webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(3217);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(3124)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fluentui_react_component_ref__ = __webpack_require__(91);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ref", function() { return __WEBPACK_IMPORTED_MODULE_0__fluentui_react_component_ref__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__addons_Confirm__ = __webpack_require__(3233);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Confirm", function() { return __WEBPACK_IMPORTED_MODULE_1__addons_Confirm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__addons_Pagination__ = __webpack_require__(3235);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Pagination", function() { return __WEBPACK_IMPORTED_MODULE_2__addons_Pagination__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__addons_Pagination_PaginationItem__ = __webpack_require__(1433);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PaginationItem", function() { return __WEBPACK_IMPORTED_MODULE_3__addons_Pagination_PaginationItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addons_Portal__ = __webpack_require__(353);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Portal", function() { return __WEBPACK_IMPORTED_MODULE_4__addons_Portal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__addons_Portal_PortalInner__ = __webpack_require__(1434);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PortalInner", function() { return __WEBPACK_IMPORTED_MODULE_5__addons_Portal_PortalInner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__addons_Radio__ = __webpack_require__(700);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Radio", function() { return __WEBPACK_IMPORTED_MODULE_6__addons_Radio__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__addons_Select__ = __webpack_require__(1435);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Select", function() { return __WEBPACK_IMPORTED_MODULE_7__addons_Select__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__addons_TextArea__ = __webpack_require__(1436);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TextArea", function() { return __WEBPACK_IMPORTED_MODULE_8__addons_TextArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__addons_TransitionablePortal__ = __webpack_require__(3242);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TransitionablePortal", function() { return __WEBPACK_IMPORTED_MODULE_9__addons_TransitionablePortal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__behaviors_Visibility__ = __webpack_require__(3244);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Visibility", function() { return __WEBPACK_IMPORTED_MODULE_10__behaviors_Visibility__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__collections_Breadcrumb__ = __webpack_require__(3246);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Breadcrumb", function() { return __WEBPACK_IMPORTED_MODULE_11__collections_Breadcrumb__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__collections_Breadcrumb_BreadcrumbDivider__ = __webpack_require__(1437);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BreadcrumbDivider", function() { return __WEBPACK_IMPORTED_MODULE_12__collections_Breadcrumb_BreadcrumbDivider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__collections_Breadcrumb_BreadcrumbSection__ = __webpack_require__(1438);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BreadcrumbSection", function() { return __WEBPACK_IMPORTED_MODULE_13__collections_Breadcrumb_BreadcrumbSection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__collections_Form__ = __webpack_require__(3248);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Form", function() { return __WEBPACK_IMPORTED_MODULE_14__collections_Form__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__collections_Form_FormButton__ = __webpack_require__(1439);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormButton", function() { return __WEBPACK_IMPORTED_MODULE_15__collections_Form_FormButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__collections_Form_FormCheckbox__ = __webpack_require__(1440);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormCheckbox", function() { return __WEBPACK_IMPORTED_MODULE_16__collections_Form_FormCheckbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__collections_Form_FormDropdown__ = __webpack_require__(1441);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormDropdown", function() { return __WEBPACK_IMPORTED_MODULE_17__collections_Form_FormDropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__collections_Form_FormField__ = __webpack_require__(187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormField", function() { return __WEBPACK_IMPORTED_MODULE_18__collections_Form_FormField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__collections_Form_FormGroup__ = __webpack_require__(1442);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormGroup", function() { return __WEBPACK_IMPORTED_MODULE_19__collections_Form_FormGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__collections_Form_FormInput__ = __webpack_require__(1443);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormInput", function() { return __WEBPACK_IMPORTED_MODULE_20__collections_Form_FormInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__collections_Form_FormRadio__ = __webpack_require__(1444);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormRadio", function() { return __WEBPACK_IMPORTED_MODULE_21__collections_Form_FormRadio__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__collections_Form_FormSelect__ = __webpack_require__(1445);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormSelect", function() { return __WEBPACK_IMPORTED_MODULE_22__collections_Form_FormSelect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__collections_Form_FormTextArea__ = __webpack_require__(1446);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FormTextArea", function() { return __WEBPACK_IMPORTED_MODULE_23__collections_Form_FormTextArea__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__collections_Grid__ = __webpack_require__(3249);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return __WEBPACK_IMPORTED_MODULE_24__collections_Grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__collections_Grid_GridColumn__ = __webpack_require__(701);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GridColumn", function() { return __WEBPACK_IMPORTED_MODULE_25__collections_Grid_GridColumn__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__collections_Grid_GridRow__ = __webpack_require__(1448);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GridRow", function() { return __WEBPACK_IMPORTED_MODULE_26__collections_Grid_GridRow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__collections_Menu__ = __webpack_require__(1452);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Menu", function() { return __WEBPACK_IMPORTED_MODULE_27__collections_Menu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__collections_Menu_MenuHeader__ = __webpack_require__(1450);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuHeader", function() { return __WEBPACK_IMPORTED_MODULE_28__collections_Menu_MenuHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__collections_Menu_MenuItem__ = __webpack_require__(702);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuItem", function() { return __WEBPACK_IMPORTED_MODULE_29__collections_Menu_MenuItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__collections_Menu_MenuMenu__ = __webpack_require__(1451);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MenuMenu", function() { return __WEBPACK_IMPORTED_MODULE_30__collections_Menu_MenuMenu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__collections_Message__ = __webpack_require__(3251);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Message", function() { return __WEBPACK_IMPORTED_MODULE_31__collections_Message__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__collections_Message_MessageContent__ = __webpack_require__(1453);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MessageContent", function() { return __WEBPACK_IMPORTED_MODULE_32__collections_Message_MessageContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__collections_Message_MessageHeader__ = __webpack_require__(1454);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MessageHeader", function() { return __WEBPACK_IMPORTED_MODULE_33__collections_Message_MessageHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__collections_Message_MessageItem__ = __webpack_require__(703);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MessageItem", function() { return __WEBPACK_IMPORTED_MODULE_34__collections_Message_MessageItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__collections_Message_MessageList__ = __webpack_require__(1455);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MessageList", function() { return __WEBPACK_IMPORTED_MODULE_35__collections_Message_MessageList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__collections_Table__ = __webpack_require__(3253);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return __WEBPACK_IMPORTED_MODULE_36__collections_Table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__collections_Table_TableBody__ = __webpack_require__(1456);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TableBody", function() { return __WEBPACK_IMPORTED_MODULE_37__collections_Table_TableBody__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__collections_Table_TableCell__ = __webpack_require__(468);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TableCell", function() { return __WEBPACK_IMPORTED_MODULE_38__collections_Table_TableCell__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__collections_Table_TableFooter__ = __webpack_require__(1457);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TableFooter", function() { return __WEBPACK_IMPORTED_MODULE_39__collections_Table_TableFooter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__collections_Table_TableHeader__ = __webpack_require__(704);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TableHeader", function() { return __WEBPACK_IMPORTED_MODULE_40__collections_Table_TableHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__collections_Table_TableHeaderCell__ = __webpack_require__(1458);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TableHeaderCell", function() { return __WEBPACK_IMPORTED_MODULE_41__collections_Table_TableHeaderCell__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__collections_Table_TableRow__ = __webpack_require__(1459);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TableRow", function() { return __WEBPACK_IMPORTED_MODULE_42__collections_Table_TableRow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__elements_Button_Button__ = __webpack_require__(705);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return __WEBPACK_IMPORTED_MODULE_43__elements_Button_Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__elements_Button_ButtonContent__ = __webpack_require__(1460);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonContent", function() { return __WEBPACK_IMPORTED_MODULE_44__elements_Button_ButtonContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__elements_Button_ButtonGroup__ = __webpack_require__(1461);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonGroup", function() { return __WEBPACK_IMPORTED_MODULE_45__elements_Button_ButtonGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__elements_Button_ButtonOr__ = __webpack_require__(1462);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonOr", function() { return __WEBPACK_IMPORTED_MODULE_46__elements_Button_ButtonOr__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__elements_Container__ = __webpack_require__(3255);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Container", function() { return __WEBPACK_IMPORTED_MODULE_47__elements_Container__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__elements_Divider__ = __webpack_require__(3257);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Divider", function() { return __WEBPACK_IMPORTED_MODULE_48__elements_Divider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__elements_Flag__ = __webpack_require__(706);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Flag", function() { return __WEBPACK_IMPORTED_MODULE_49__elements_Flag__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__elements_Header__ = __webpack_require__(3260);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Header", function() { return __WEBPACK_IMPORTED_MODULE_50__elements_Header__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__elements_Header_HeaderContent__ = __webpack_require__(1463);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderContent", function() { return __WEBPACK_IMPORTED_MODULE_51__elements_Header_HeaderContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__elements_Header_HeaderSubheader__ = __webpack_require__(1464);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderSubheader", function() { return __WEBPACK_IMPORTED_MODULE_52__elements_Header_HeaderSubheader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__elements_Icon__ = __webpack_require__(95);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return __WEBPACK_IMPORTED_MODULE_53__elements_Icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__elements_Icon_IconGroup__ = __webpack_require__(1465);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IconGroup", function() { return __WEBPACK_IMPORTED_MODULE_54__elements_Icon_IconGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__elements_Image__ = __webpack_require__(249);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Image", function() { return __WEBPACK_IMPORTED_MODULE_55__elements_Image__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__elements_Image_ImageGroup__ = __webpack_require__(1467);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ImageGroup", function() { return __WEBPACK_IMPORTED_MODULE_56__elements_Image_ImageGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__elements_Input__ = __webpack_require__(707);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return __WEBPACK_IMPORTED_MODULE_57__elements_Input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__elements_Label__ = __webpack_require__(354);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Label", function() { return __WEBPACK_IMPORTED_MODULE_58__elements_Label__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__elements_Label_LabelDetail__ = __webpack_require__(1468);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LabelDetail", function() { return __WEBPACK_IMPORTED_MODULE_59__elements_Label_LabelDetail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__elements_Label_LabelGroup__ = __webpack_require__(1469);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "LabelGroup", function() { return __WEBPACK_IMPORTED_MODULE_60__elements_Label_LabelGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__elements_List__ = __webpack_require__(3263);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "List", function() { return __WEBPACK_IMPORTED_MODULE_61__elements_List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__elements_List_ListContent__ = __webpack_require__(709);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListContent", function() { return __WEBPACK_IMPORTED_MODULE_62__elements_List_ListContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__elements_List_ListDescription__ = __webpack_require__(471);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListDescription", function() { return __WEBPACK_IMPORTED_MODULE_63__elements_List_ListDescription__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__elements_List_ListHeader__ = __webpack_require__(472);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListHeader", function() { return __WEBPACK_IMPORTED_MODULE_64__elements_List_ListHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__elements_List_ListIcon__ = __webpack_require__(710);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListIcon", function() { return __WEBPACK_IMPORTED_MODULE_65__elements_List_ListIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__elements_List_ListItem__ = __webpack_require__(1470);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListItem", function() { return __WEBPACK_IMPORTED_MODULE_66__elements_List_ListItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__elements_List_ListList__ = __webpack_require__(1471);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ListList", function() { return __WEBPACK_IMPORTED_MODULE_67__elements_List_ListList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__elements_Loader__ = __webpack_require__(3265);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Loader", function() { return __WEBPACK_IMPORTED_MODULE_68__elements_Loader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__elements_Placeholder__ = __webpack_require__(3267);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Placeholder", function() { return __WEBPACK_IMPORTED_MODULE_69__elements_Placeholder__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__elements_Placeholder_PlaceholderHeader__ = __webpack_require__(1472);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PlaceholderHeader", function() { return __WEBPACK_IMPORTED_MODULE_70__elements_Placeholder_PlaceholderHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__elements_Placeholder_PlaceholderImage__ = __webpack_require__(1473);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PlaceholderImage", function() { return __WEBPACK_IMPORTED_MODULE_71__elements_Placeholder_PlaceholderImage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__elements_Placeholder_PlaceholderLine__ = __webpack_require__(1474);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PlaceholderLine", function() { return __WEBPACK_IMPORTED_MODULE_72__elements_Placeholder_PlaceholderLine__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__elements_Placeholder_PlaceholderParagraph__ = __webpack_require__(1475);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PlaceholderParagraph", function() { return __WEBPACK_IMPORTED_MODULE_73__elements_Placeholder_PlaceholderParagraph__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__elements_Rail__ = __webpack_require__(3269);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Rail", function() { return __WEBPACK_IMPORTED_MODULE_74__elements_Rail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__elements_Reveal__ = __webpack_require__(3271);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Reveal", function() { return __WEBPACK_IMPORTED_MODULE_75__elements_Reveal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__elements_Reveal_RevealContent__ = __webpack_require__(1476);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RevealContent", function() { return __WEBPACK_IMPORTED_MODULE_76__elements_Reveal_RevealContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__elements_Segment__ = __webpack_require__(3272);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Segment", function() { return __WEBPACK_IMPORTED_MODULE_77__elements_Segment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__elements_Segment_SegmentGroup__ = __webpack_require__(1478);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SegmentGroup", function() { return __WEBPACK_IMPORTED_MODULE_78__elements_Segment_SegmentGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__elements_Segment_SegmentInline__ = __webpack_require__(1479);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SegmentInline", function() { return __WEBPACK_IMPORTED_MODULE_79__elements_Segment_SegmentInline__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__elements_Step__ = __webpack_require__(3273);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Step", function() { return __WEBPACK_IMPORTED_MODULE_80__elements_Step__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__elements_Step_StepContent__ = __webpack_require__(1481);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StepContent", function() { return __WEBPACK_IMPORTED_MODULE_81__elements_Step_StepContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__elements_Step_StepDescription__ = __webpack_require__(711);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StepDescription", function() { return __WEBPACK_IMPORTED_MODULE_82__elements_Step_StepDescription__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__elements_Step_StepGroup__ = __webpack_require__(1482);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StepGroup", function() { return __WEBPACK_IMPORTED_MODULE_83__elements_Step_StepGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__elements_Step_StepTitle__ = __webpack_require__(712);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StepTitle", function() { return __WEBPACK_IMPORTED_MODULE_84__elements_Step_StepTitle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__modules_Accordion_Accordion__ = __webpack_require__(3295);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Accordion", function() { return __WEBPACK_IMPORTED_MODULE_85__modules_Accordion_Accordion__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__modules_Accordion_AccordionAccordion__ = __webpack_require__(1486);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccordionAccordion", function() { return __WEBPACK_IMPORTED_MODULE_86__modules_Accordion_AccordionAccordion__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__modules_Accordion_AccordionContent__ = __webpack_require__(714);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccordionContent", function() { return __WEBPACK_IMPORTED_MODULE_87__modules_Accordion_AccordionContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__modules_Accordion_AccordionPanel__ = __webpack_require__(715);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccordionPanel", function() { return __WEBPACK_IMPORTED_MODULE_88__modules_Accordion_AccordionPanel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__modules_Accordion_AccordionTitle__ = __webpack_require__(716);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AccordionTitle", function() { return __WEBPACK_IMPORTED_MODULE_89__modules_Accordion_AccordionTitle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__modules_Checkbox__ = __webpack_require__(473);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return __WEBPACK_IMPORTED_MODULE_90__modules_Checkbox__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__modules_Dimmer__ = __webpack_require__(1489);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Dimmer", function() { return __WEBPACK_IMPORTED_MODULE_91__modules_Dimmer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__modules_Dimmer_DimmerDimmable__ = __webpack_require__(1487);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DimmerDimmable", function() { return __WEBPACK_IMPORTED_MODULE_92__modules_Dimmer_DimmerDimmable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__modules_Dimmer_DimmerInner__ = __webpack_require__(1488);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DimmerInner", function() { return __WEBPACK_IMPORTED_MODULE_93__modules_Dimmer_DimmerInner__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__modules_Dropdown__ = __webpack_require__(474);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Dropdown", function() { return __WEBPACK_IMPORTED_MODULE_94__modules_Dropdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__modules_Dropdown_DropdownDivider__ = __webpack_require__(1490);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownDivider", function() { return __WEBPACK_IMPORTED_MODULE_95__modules_Dropdown_DropdownDivider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__modules_Dropdown_DropdownHeader__ = __webpack_require__(1491);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownHeader", function() { return __WEBPACK_IMPORTED_MODULE_96__modules_Dropdown_DropdownHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__modules_Dropdown_DropdownItem__ = __webpack_require__(1492);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownItem", function() { return __WEBPACK_IMPORTED_MODULE_97__modules_Dropdown_DropdownItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__modules_Dropdown_DropdownMenu__ = __webpack_require__(1493);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownMenu", function() { return __WEBPACK_IMPORTED_MODULE_98__modules_Dropdown_DropdownMenu__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__modules_Dropdown_DropdownSearchInput__ = __webpack_require__(1494);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownSearchInput", function() { return __WEBPACK_IMPORTED_MODULE_99__modules_Dropdown_DropdownSearchInput__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__modules_Dropdown_DropdownText__ = __webpack_require__(1495);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownText", function() { return __WEBPACK_IMPORTED_MODULE_100__modules_Dropdown_DropdownText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__modules_Embed__ = __webpack_require__(3301);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Embed", function() { return __WEBPACK_IMPORTED_MODULE_101__modules_Embed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__modules_Modal__ = __webpack_require__(1502);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Modal", function() { return __WEBPACK_IMPORTED_MODULE_102__modules_Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__modules_Modal_ModalActions__ = __webpack_require__(1497);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalActions", function() { return __WEBPACK_IMPORTED_MODULE_103__modules_Modal_ModalActions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__modules_Modal_ModalContent__ = __webpack_require__(1498);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalContent", function() { return __WEBPACK_IMPORTED_MODULE_104__modules_Modal_ModalContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__modules_Modal_ModalDescription__ = __webpack_require__(1499);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalDescription", function() { return __WEBPACK_IMPORTED_MODULE_105__modules_Modal_ModalDescription__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__modules_Modal_ModalDimmer__ = __webpack_require__(1500);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalDimmer", function() { return __WEBPACK_IMPORTED_MODULE_106__modules_Modal_ModalDimmer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__modules_Modal_ModalHeader__ = __webpack_require__(1501);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ModalHeader", function() { return __WEBPACK_IMPORTED_MODULE_107__modules_Modal_ModalHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__modules_Popup__ = __webpack_require__(3305);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Popup", function() { return __WEBPACK_IMPORTED_MODULE_108__modules_Popup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__modules_Popup_PopupContent__ = __webpack_require__(1503);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PopupContent", function() { return __WEBPACK_IMPORTED_MODULE_109__modules_Popup_PopupContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__modules_Popup_PopupHeader__ = __webpack_require__(1504);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PopupHeader", function() { return __WEBPACK_IMPORTED_MODULE_110__modules_Popup_PopupHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__modules_Progress__ = __webpack_require__(3309);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Progress", function() { return __WEBPACK_IMPORTED_MODULE_111__modules_Progress__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__modules_Rating__ = __webpack_require__(3311);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Rating", function() { return __WEBPACK_IMPORTED_MODULE_112__modules_Rating__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__modules_Rating_RatingIcon__ = __webpack_require__(1505);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RatingIcon", function() { return __WEBPACK_IMPORTED_MODULE_113__modules_Rating_RatingIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__modules_Search__ = __webpack_require__(3314);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Search", function() { return __WEBPACK_IMPORTED_MODULE_114__modules_Search__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__modules_Search_SearchCategory__ = __webpack_require__(1506);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SearchCategory", function() { return __WEBPACK_IMPORTED_MODULE_115__modules_Search_SearchCategory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__modules_Search_SearchResult__ = __webpack_require__(1507);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SearchResult", function() { return __WEBPACK_IMPORTED_MODULE_116__modules_Search_SearchResult__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__modules_Search_SearchResults__ = __webpack_require__(1508);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SearchResults", function() { return __WEBPACK_IMPORTED_MODULE_117__modules_Search_SearchResults__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__modules_Sidebar__ = __webpack_require__(3316);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Sidebar", function() { return __WEBPACK_IMPORTED_MODULE_118__modules_Sidebar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__modules_Sidebar_SidebarPushable__ = __webpack_require__(1509);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SidebarPushable", function() { return __WEBPACK_IMPORTED_MODULE_119__modules_Sidebar_SidebarPushable__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__modules_Sidebar_SidebarPusher__ = __webpack_require__(1510);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SidebarPusher", function() { return __WEBPACK_IMPORTED_MODULE_120__modules_Sidebar_SidebarPusher__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__modules_Sticky__ = __webpack_require__(3318);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Sticky", function() { return __WEBPACK_IMPORTED_MODULE_121__modules_Sticky__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__modules_Tab__ = __webpack_require__(3320);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tab", function() { return __WEBPACK_IMPORTED_MODULE_122__modules_Tab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__modules_Tab_TabPane__ = __webpack_require__(1511);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TabPane", function() { return __WEBPACK_IMPORTED_MODULE_123__modules_Tab_TabPane__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__modules_Transition__ = __webpack_require__(1514);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Transition", function() { return __WEBPACK_IMPORTED_MODULE_124__modules_Transition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__modules_Transition_TransitionGroup__ = __webpack_require__(1513);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TransitionGroup", function() { return __WEBPACK_IMPORTED_MODULE_125__modules_Transition_TransitionGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__views_Advertisement__ = __webpack_require__(3324);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Advertisement", function() { return __WEBPACK_IMPORTED_MODULE_126__views_Advertisement__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__views_Card_Card__ = __webpack_require__(1516);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return __WEBPACK_IMPORTED_MODULE_127__views_Card_Card__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__views_Card_CardContent__ = __webpack_require__(1517);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardContent", function() { return __WEBPACK_IMPORTED_MODULE_128__views_Card_CardContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__views_Card_CardDescription__ = __webpack_require__(717);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardDescription", function() { return __WEBPACK_IMPORTED_MODULE_129__views_Card_CardDescription__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__views_Card_CardGroup__ = __webpack_require__(1518);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardGroup", function() { return __WEBPACK_IMPORTED_MODULE_130__views_Card_CardGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__views_Card_CardHeader__ = __webpack_require__(718);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardHeader", function() { return __WEBPACK_IMPORTED_MODULE_131__views_Card_CardHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__views_Card_CardMeta__ = __webpack_require__(719);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CardMeta", function() { return __WEBPACK_IMPORTED_MODULE_132__views_Card_CardMeta__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__views_Comment__ = __webpack_require__(3326);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Comment", function() { return __WEBPACK_IMPORTED_MODULE_133__views_Comment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__views_Comment_CommentAction__ = __webpack_require__(1519);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CommentAction", function() { return __WEBPACK_IMPORTED_MODULE_134__views_Comment_CommentAction__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_135__views_Comment_CommentActions__ = __webpack_require__(1520);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CommentActions", function() { return __WEBPACK_IMPORTED_MODULE_135__views_Comment_CommentActions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_136__views_Comment_CommentAuthor__ = __webpack_require__(1521);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CommentAuthor", function() { return __WEBPACK_IMPORTED_MODULE_136__views_Comment_CommentAuthor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_137__views_Comment_CommentAvatar__ = __webpack_require__(1522);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CommentAvatar", function() { return __WEBPACK_IMPORTED_MODULE_137__views_Comment_CommentAvatar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_138__views_Comment_CommentContent__ = __webpack_require__(1523);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CommentContent", function() { return __WEBPACK_IMPORTED_MODULE_138__views_Comment_CommentContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_139__views_Comment_CommentGroup__ = __webpack_require__(1524);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CommentGroup", function() { return __WEBPACK_IMPORTED_MODULE_139__views_Comment_CommentGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_140__views_Comment_CommentMetadata__ = __webpack_require__(1525);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CommentMetadata", function() { return __WEBPACK_IMPORTED_MODULE_140__views_Comment_CommentMetadata__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_141__views_Comment_CommentText__ = __webpack_require__(1526);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CommentText", function() { return __WEBPACK_IMPORTED_MODULE_141__views_Comment_CommentText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_142__views_Feed__ = __webpack_require__(3328);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Feed", function() { return __WEBPACK_IMPORTED_MODULE_142__views_Feed__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_143__views_Feed_FeedContent__ = __webpack_require__(720);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FeedContent", function() { return __WEBPACK_IMPORTED_MODULE_143__views_Feed_FeedContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_144__views_Feed_FeedDate__ = __webpack_require__(475);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FeedDate", function() { return __WEBPACK_IMPORTED_MODULE_144__views_Feed_FeedDate__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_145__views_Feed_FeedEvent__ = __webpack_require__(1527);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FeedEvent", function() { return __WEBPACK_IMPORTED_MODULE_145__views_Feed_FeedEvent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_146__views_Feed_FeedExtra__ = __webpack_require__(721);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FeedExtra", function() { return __WEBPACK_IMPORTED_MODULE_146__views_Feed_FeedExtra__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_147__views_Feed_FeedLabel__ = __webpack_require__(722);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FeedLabel", function() { return __WEBPACK_IMPORTED_MODULE_147__views_Feed_FeedLabel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_148__views_Feed_FeedLike__ = __webpack_require__(723);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FeedLike", function() { return __WEBPACK_IMPORTED_MODULE_148__views_Feed_FeedLike__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_149__views_Feed_FeedMeta__ = __webpack_require__(724);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FeedMeta", function() { return __WEBPACK_IMPORTED_MODULE_149__views_Feed_FeedMeta__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_150__views_Feed_FeedSummary__ = __webpack_require__(725);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FeedSummary", function() { return __WEBPACK_IMPORTED_MODULE_150__views_Feed_FeedSummary__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_151__views_Feed_FeedUser__ = __webpack_require__(726);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FeedUser", function() { return __WEBPACK_IMPORTED_MODULE_151__views_Feed_FeedUser__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_152__views_Item__ = __webpack_require__(3329);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Item", function() { return __WEBPACK_IMPORTED_MODULE_152__views_Item__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_153__views_Item_ItemContent__ = __webpack_require__(1529);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemContent", function() { return __WEBPACK_IMPORTED_MODULE_153__views_Item_ItemContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_154__views_Item_ItemDescription__ = __webpack_require__(727);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemDescription", function() { return __WEBPACK_IMPORTED_MODULE_154__views_Item_ItemDescription__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_155__views_Item_ItemExtra__ = __webpack_require__(728);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemExtra", function() { return __WEBPACK_IMPORTED_MODULE_155__views_Item_ItemExtra__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_156__views_Item_ItemGroup__ = __webpack_require__(1530);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemGroup", function() { return __WEBPACK_IMPORTED_MODULE_156__views_Item_ItemGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_157__views_Item_ItemHeader__ = __webpack_require__(729);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemHeader", function() { return __WEBPACK_IMPORTED_MODULE_157__views_Item_ItemHeader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_158__views_Item_ItemImage__ = __webpack_require__(1531);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemImage", function() { return __WEBPACK_IMPORTED_MODULE_158__views_Item_ItemImage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_159__views_Item_ItemMeta__ = __webpack_require__(730);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ItemMeta", function() { return __WEBPACK_IMPORTED_MODULE_159__views_Item_ItemMeta__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_160__views_Statistic__ = __webpack_require__(3330);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Statistic", function() { return __WEBPACK_IMPORTED_MODULE_160__views_Statistic__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_161__views_Statistic_StatisticGroup__ = __webpack_require__(1533);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StatisticGroup", function() { return __WEBPACK_IMPORTED_MODULE_161__views_Statistic_StatisticGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_162__views_Statistic_StatisticLabel__ = __webpack_require__(1534);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StatisticLabel", function() { return __WEBPACK_IMPORTED_MODULE_162__views_Statistic_StatisticLabel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_163__views_Statistic_StatisticValue__ = __webpack_require__(1535);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StatisticValue", function() { return __WEBPACK_IMPORTED_MODULE_163__views_Statistic_StatisticValue__["a"]; });
// Third party
 // Addons


















 // Behaviors


 // Collections
































































 // Elements




















































































 // Modules


















































































 // Views














































































/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "date", function() { return date; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "time", function() { return time; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "number", function() { return number; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "select", function() { return select; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "plural", function() { return plural; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectOrdinal", function() { return selectOrdinal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Trans_js__ = __webpack_require__(3183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Trans", function() { return __WEBPACK_IMPORTED_MODULE_0__Trans_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TransWithoutContext_js__ = __webpack_require__(1409);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TransWithoutContext", function() { return __WEBPACK_IMPORTED_MODULE_1__TransWithoutContext_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useTranslation_js__ = __webpack_require__(689);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useTranslation", function() { return __WEBPACK_IMPORTED_MODULE_2__useTranslation_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withTranslation_js__ = __webpack_require__(3187);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withTranslation", function() { return __WEBPACK_IMPORTED_MODULE_3__withTranslation_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Translation_js__ = __webpack_require__(3184);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Translation", function() { return __WEBPACK_IMPORTED_MODULE_4__Translation_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__I18nextProvider_js__ = __webpack_require__(3182);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I18nextProvider", function() { return __WEBPACK_IMPORTED_MODULE_5__I18nextProvider_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__withSSR_js__ = __webpack_require__(3186);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withSSR", function() { return __WEBPACK_IMPORTED_MODULE_6__withSSR_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__useSSR_js__ = __webpack_require__(1411);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useSSR", function() { return __WEBPACK_IMPORTED_MODULE_7__useSSR_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__initReactI18next_js__ = __webpack_require__(1410);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "initReactI18next", function() { return __WEBPACK_IMPORTED_MODULE_8__initReactI18next_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__defaults_js__ = __webpack_require__(463);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setDefaults", function() { return __WEBPACK_IMPORTED_MODULE_9__defaults_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getDefaults", function() { return __WEBPACK_IMPORTED_MODULE_9__defaults_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18nInstance_js__ = __webpack_require__(464);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setI18n", function() { return __WEBPACK_IMPORTED_MODULE_10__i18nInstance_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getI18n", function() { return __WEBPACK_IMPORTED_MODULE_10__i18nInstance_js__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__context_js__ = __webpack_require__(289);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I18nContext", function() { return __WEBPACK_IMPORTED_MODULE_11__context_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "composeInitialProps", function() { return __WEBPACK_IMPORTED_MODULE_11__context_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getInitialProps", function() { return __WEBPACK_IMPORTED_MODULE_11__context_js__["c"]; });












var date = function date() {
  return '';
};
var time = function time() {
  return '';
};
var number = function number() {
  return '';
};
var select = function select() {
  return '';
};
var plural = function plural() {
  return '';
};
var selectOrdinal = function selectOrdinal() {
  return '';
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MODELS = {
  booking: 'models/booking',
  bookingPackagePricing: 'models/bookingPackagePricing',
  customer: 'models/customer',
  mpUserDetails: 'models/mpUserDetails',
  project: 'models/project',
  projectUnit: 'models/projectUnit',
  projectUnitLayout: 'models/projectUnitLayout',
  user: 'models/user',
  businessUnit: 'models/businessUnit',
  tokenSetting: 'models/tokenSetting'
};

var TRANSLATION_FILES = exports.TRANSLATION_FILES = {
  screens: 'screens',
  constants: 'constants',
  translation: 'translation',
  models: MODELS
};

var namespaces = exports.namespaces = [TRANSLATION_FILES.screens, TRANSLATION_FILES.constants, TRANSLATION_FILES.translation];

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.flashMessage = flashMessage;
exports.flashSuccessMessage = flashSuccessMessage;
exports.flashErrorMessage = flashErrorMessage;
exports.resetFlashMessage = resetFlashMessage;

var _actions = __webpack_require__(25);

var _session = __webpack_require__(404);

function flashMessage(_ref) {
  var header = _ref.header,
      message = _ref.message,
      list = _ref.list,
      icon = _ref.icon,
      color = _ref.color,
      type = _ref.type,
      autoHideDuration = _ref.autoHideDuration;

  return {
    type: _actions.FLASH_MESSAGE,
    payload: {
      header: header,
      message: message,
      list: list,
      color: color,
      icon: icon,
      show: true,
      type: type,
      autoHideDuration: autoHideDuration || 3500
    }
  };
}

function flashSuccessMessage(_ref2) {
  var header = _ref2.header,
      message = _ref2.message,
      autoHideDuration = _ref2.autoHideDuration,
      icon = _ref2.icon;

  return function (dispatch) {
    dispatch(flashMessage({ header: header || 'Success', message: message, icon: icon || 'checkmark', type: 'success', autoHideDuration: autoHideDuration || 3500 }));
  };
}

function flashErrorMessage(_ref3) {
  var header = _ref3.header,
      message = _ref3.message,
      list = _ref3.list,
      autoHideDuration = _ref3.autoHideDuration,
      icon = _ref3.icon;

  return function (dispatch) {
    // During a session-takeover hand-off the page is navigating to /logout and every in-flight
    // request is failing at once; a generic error flash on top of that is noise the user cannot
    // act on. Stay silent — the redirect is the response.
    if ((0, _session.isSessionHandoffInProgress)()) {
      return;
    }
    dispatch(flashMessage({ header: header || 'Error', message: message, list: list, icon: icon || 'warning sign', type: 'error', autoHideDuration: autoHideDuration || 3500 }));
  };
}

function resetFlashMessage() {
  return {
    type: _actions.FLASH_MESSAGE_RESET
  };
}

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.serverRequestGetBlob = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var getJSONfromResponse = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
    var data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return res.json();

          case 3:
            data = _context.sent;
            return _context.abrupt('return', data);

          case 7:
            _context.prev = 7;
            _context.t0 = _context['catch'](0);
            return _context.abrupt('return', null);

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[0, 7]]);
  }));

  return function getJSONfromResponse(_x) {
    return _ref.apply(this, arguments);
  };
}();

// scheme://host[:port] of a URL, lower-cased, with userinfo forms rejected (returns ''). Kept as
// a regex rather than `new URL` — this bundle still targets browsers without a URL polyfill.


// TODO: refactor to options params instead of multiple params
// Send request to server accoring to options provided.
// Handle response from server accordingly and return response data
var execServerRequest = function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(apiUrl, store) {
    var httpOpts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var res, message, token, count, limit, offset, data;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            res = void 0;
            _context3.prev = 1;
            _context3.next = 4;
            return serverRequest(apiUrl, store, httpOpts);

          case 4:
            res = _context3.sent;

            if (res.ok) {
              _context3.next = 10;
              break;
            }

            _context3.next = 8;
            return res.text();

          case 8:
            message = _context3.sent;
            return _context3.abrupt('return', {
              error: message
            });

          case 10:
            token = res.headers.get('X-Csrf-Token');
            count = parseInt(res.headers.get('M-Data-count'), 10);
            limit = parseInt(res.headers.get('M-Data-limit'), 10);
            offset = parseInt(res.headers.get('M-Data-offset'), 10);
            _context3.next = 16;
            return getJSONfromResponse(res);

          case 16:
            data = _context3.sent;
            return _context3.abrupt('return', {
              count: count,
              data: data,
              error: false,
              limit: limit,
              offset: offset,
              token: token
            });

          case 20:
            _context3.prev = 20;
            _context3.t0 = _context3['catch'](1);
            throw _context3.t0;

          case 23:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this, [[1, 20]]);
  }));

  return function execServerRequest(_x9, _x10) {
    return _ref3.apply(this, arguments);
  };
}();

var serverRequestGetBlob = exports.serverRequestGetBlob = function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(apiUrl, store) {
    var httpOpts, res;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(!store || !apiUrl)) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt('return', Promise.reject('Required parameters missing.'));

          case 2:
            httpOpts = {
              credentials: 'include',
              method: 'GET',
              ignoreNotFound: true,
              headers: {}
            };
            _context4.prev = 3;
            _context4.next = 6;
            return store.dispatch(fetchM(apiUrl, httpOpts));

          case 6:
            res = _context4.sent;

            if (!(!res || !res.ok)) {
              _context4.next = 9;
              break;
            }

            return _context4.abrupt('return', null);

          case 9:
            _context4.next = 11;
            return res.blob();

          case 11:
            return _context4.abrupt('return', _context4.sent);

          case 14:
            _context4.prev = 14;
            _context4.t0 = _context4['catch'](3);
            return _context4.abrupt('return', null);

          case 17:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, this, [[3, 14]]);
  }));

  return function serverRequestGetBlob(_x14, _x15) {
    return _ref4.apply(this, arguments);
  };
}();

exports.fetchM = fetchM;
exports.fetchAPI = fetchAPI;
exports.serverRequestGet = serverRequestGet;
exports.serverRequestPost = serverRequestPost;
exports.serverRequestPut = serverRequestPut;
exports.serverRequestDelete = serverRequestDelete;

__webpack_require__(3555);

var _reactRouterRedux = __webpack_require__(13);

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

var _api = __webpack_require__(1605);

var _api2 = _interopRequireDefault(_api);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _jsCookie = __webpack_require__(247);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _selectors = __webpack_require__(1082);

var _error = __webpack_require__(2578);

var _session = __webpack_require__(404);

var _networkDiagnostics = __webpack_require__(2582);

var _flash = __webpack_require__(5);

var _auth3 = __webpack_require__(552);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint no-param-reassign: 0 */

function fetchRequest() {
  return {
    type: _actions.FETCH_REQUEST
  };
}

function fetchError(message) {
  return {
    type: _actions.FETCH_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchSuccess() {
  return {
    type: _actions.FETCH_SUCCESS
  };
}

function networkOK() {
  return {
    type: _actions.NETWORK_OK
  };
}

function networkError() {
  return {
    type: _actions.NETWORK_FAILURE
  };
}

function urlOrigin(u) {
  var m = /^(https?):\/\/([^/?#]*)/i.exec(u || '');
  if (!m || m[2].indexOf('@') !== -1 || m[2] === '') return '';
  return m[1].toLowerCase() + '://' + m[2].toLowerCase();
}

function fetchM(u) {
  var _this = this;

  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var retry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var currentVersion = _config2.default.get('version') || '';
  var user = void 0;
  var adfsProvider = '';
  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
      var attributes, identities, stateAdfsProvider, url, headers, origin, session, idToken, res, startedAt, message, bodyText, versionCheck, xShowroomMinVersion, cookie, reloadCountExceeded, minVersion, version;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return dispatch(fetchRequest());

            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return _auth2.default.currentAuthenticatedUser();

            case 5:
              user = _context2.sent;
              _context2.next = 15;
              break;

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2['catch'](2);

              if (!(retry && (typeof _context2.t0 === 'string' && !_context2.t0.match(/not authenticate/i) || (typeof _context2.t0 === 'undefined' ? 'undefined' : _typeof(_context2.t0)) === 'object' && _context2.t0.code !== 'PasswordResetRequiredException' && (_context2.t0.message.match(/not authenticate/i) || _context2.t0.message.match(/token/i))))) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt('return', dispatch(fetchM(u, opts, false)));

            case 12:
              _context2.next = 14;
              return dispatch((0, _auth3.redirectToLogin)(window.location.pathname));

            case 14:
              return _context2.abrupt('return', Promise.reject(_context2.t0));

            case 15:

              if (user) {
                attributes = user.getSignInUserSession().getIdToken().decodePayload();

                if (attributes) {
                  identities = attributes.identities;

                  if (identities) {
                    if (typeof identities === 'string') {
                      identities = JSON.parse(identities);
                    }
                    if (Array.isArray(identities)) {
                      adfsProvider = identities.reduce(function (result, identity) {
                        if (result === '' && identity.providerName) {
                          return identity.providerName;
                        }
                        return result;
                      }, adfsProvider);
                    }
                  }
                }
              }

              stateAdfsProvider = (0, _selectors.getStateAdfsProvider)();

              if (adfsProvider && adfsProvider !== stateAdfsProvider) {
                dispatch((0, _auth3.giveLoginFromADFS)(adfsProvider));
              }

              url = u;

              if (!/^(f|ht)tps?:\/\//i.test(url)) {
                url = '' + _config2.default.get('bookApiURL') + url;
              }
              headers = opts.headers ? (0, _clone2.default)(opts.headers) : {};
              origin = window.location.origin;

              if (!origin) {
                origin = window.location.protocol + '//' + window.location.hostname;
                origin += '' + (window.location.port ? ':' + window.location.port : '');
              }
              headers['X-Origin'] = origin;
              headers['X-Showroom-Version'] = currentVersion || '';

              // Send the CURRENT session's id token explicitly on book-api calls. Without it, book-api's
              // cookie fallback GUESSES the caller: it scans its configured Cognito app-client ids and takes
              // the first LastAuthUser cookie it finds — and on the shared .mhub.my cookie domain a browser
              // that has used other MHub apps carries several apps' cookie sets, so book-api can end up
              // validating a STALE token this app doesn't own and answer 428 token_expired (the retry below
              // has been papering over exactly that). book-api's middleware prefers x-aws-id-token over any
              // cookie, and the header is already in its CORS allowlist. currentSession() refreshes an
              // expired token, so the header always carries live material; when it can't (signed out,
              // devstack persona mode), the header is absent and the cookie/persona path applies as before.
              //
              // The gate is an ORIGIN comparison, never a string prefix: a prefix check accepts lookalike
              // hosts ("https://book-api.x.evil.example", "https://book-api.x@evil.example") and would hand
              // the token to a foreign origin. Userinfo forms are rejected outright — no book-api URL ever
              // carries one. The header is REWRITTEN on every attempt: fetchM's 428 retry re-enters with the
              // same opts object, so a token attached on the first attempt must not be replayed stale on the
              // second (a leftover from a now-dead session is deleted rather than sent).

              if (!(urlOrigin(url) && urlOrigin(url) === urlOrigin(_config2.default.get('bookApiURL') || ''))) {
                _context2.next = 37;
                break;
              }

              _context2.prev = 26;
              _context2.next = 29;
              return _auth2.default.currentSession();

            case 29:
              session = _context2.sent;
              idToken = session.getIdToken().getJwtToken();

              if (idToken) {
                headers['x-aws-id-token'] = idToken;
              } else {
                delete headers['x-aws-id-token'];
              }
              _context2.next = 37;
              break;

            case 34:
              _context2.prev = 34;
              _context2.t1 = _context2['catch'](26);

              delete headers['x-aws-id-token'];

            case 37:
              opts.headers = headers;

              res = void 0;
              // Read before the request goes out: it is what tells this attempt's Resource Timing entry
              // apart from an earlier request to the same URL (networkDiagnostics.attemptWasSent).

              startedAt = typeof performance !== 'undefined' && typeof performance.now === 'function' ? performance.now() : null;
              _context2.prev = 40;
              _context2.next = 43;
              return fetch(url, opts);

            case 43:
              res = _context2.sent;
              _context2.next = 59;
              break;

            case 46:
              _context2.prev = 46;
              _context2.t2 = _context2['catch'](40);

              // MS-6583: a network-level rejection names neither its request nor its cause. Ride the
              // facts on the error for the one event bugsnagNetworkNoise lets through — sizes only,
              // never the token itself. The original message is recorded here because a caller's
              // catch (actions/error.js handleError) may rename it before Bugsnag ever sees it.
              (0, _networkDiagnostics.attachNetworkDiagnostics)(_context2.t2, {
                url: url,
                method: opts.method,
                retry: !retry,
                message: _context2.t2 && _context2.t2.message,
                startedAt: startedAt,
                tokenHeaderBytes: headers['x-aws-id-token'] ? headers['x-aws-id-token'].length : 0
              });

              if (!_context2.t2.message.match(/failed to fetch/i)) {
                _context2.next = 54;
                break;
              }

              _context2.next = 52;
              return dispatch(networkError());

            case 52:
              _context2.next = 56;
              break;

            case 54:
              if (!retry) {
                _context2.next = 56;
                break;
              }

              return _context2.abrupt('return', dispatch(fetchM(u, opts, false)));

            case 56:
              _context2.next = 58;
              return dispatch(fetchError(_context2.t2.message));

            case 58:
              return _context2.abrupt('return', Promise.reject(_context2.t2));

            case 59:
              _context2.next = 61;
              return dispatch(networkOK());

            case 61:
              if (res.ok) {
                _context2.next = 101;
                break;
              }

              message = 'An error occurred';

              if (!(res.status === 401)) {
                _context2.next = 80;
                break;
              }

              // MS-6466: a superseded session answers 401 with the contract body. It must not fall
              // into redirectToLogin — the id token is still valid, so the login app would bounce
              // straight back here in a loop. handleSessionLost hands off to /logout with the
              // reason (one navigation, however many fetches fail together).
              bodyText = '';
              _context2.prev = 65;
              _context2.next = 68;
              return res.clone().text();

            case 68:
              bodyText = _context2.sent;
              _context2.next = 73;
              break;

            case 71:
              _context2.prev = 71;
              _context2.t3 = _context2['catch'](65);

            case 73:
              if (!(0, _session.isSessionSuperseded)(res.status, bodyText)) {
                _context2.next = 78;
                break;
              }

              (0, _session.handleSessionLost)();
              _context2.next = 77;
              return dispatch(fetchError('Session taken over'));

            case 77:
              return _context2.abrupt('return', Promise.reject(new _error.FetchError('Session taken over', res)));

            case 78:
              _context2.next = 80;
              return dispatch((0, _auth3.redirectToLogin)(window.location.pathname));

            case 80:
              if (!(res.status === 403 && !opts.ignoreForbidden)) {
                _context2.next = 86;
                break;
              }

              _context2.next = 83;
              return dispatch((0, _reactRouterRedux.replace)('/forbidden/'));

            case 83:
              message = 'Access denied';
              _context2.next = 86;
              return dispatch((0, _flash.flashErrorMessage)({ message: message }));

            case 86:
              if (!(res.status === 404)) {
                _context2.next = 96;
                break;
              }

              if (!opts.ignoreNotFound) {
                _context2.next = 91;
                break;
              }

              _context2.next = 90;
              return dispatch(fetchSuccess());

            case 90:
              return _context2.abrupt('return', res);

            case 91:
              _context2.next = 93;
              return dispatch((0, _reactRouterRedux.replace)('/not_found/'));

            case 93:
              message = 'Not found';
              _context2.next = 96;
              return dispatch((0, _flash.flashErrorMessage)({ message: message }));

            case 96:
              if (!(res.status === 428 && retry)) {
                _context2.next = 98;
                break;
              }

              return _context2.abrupt('return', dispatch(fetchM(u, opts, false)));

            case 98:
              _context2.next = 100;
              return dispatch(fetchError(message));

            case 100:
              return _context2.abrupt('return', Promise.reject(new _error.FetchError(message, res)));

            case 101:
              _context2.next = 103;
              return dispatch(fetchSuccess());

            case 103:

              // app version checking, auto reload if there is a newer version
              versionCheck = _config2.default.get('versionCheck');
              xShowroomMinVersion = res.headers.get('x-showroom-min-version');
              // eslint-disable-next-line max-len

              if (res.ok && xShowroomMinVersion && currentVersion && navigator.cookieEnabled && versionCheck) {
                cookie = _jsCookie2.default.getJSON('mhub-book-web-version-checker');
                // setup cookie if it does not exists

                if (!cookie) {
                  _jsCookie2.default.set('mhub-book-web-version-checker', { minVersion: 0, reloadCount: 0 });
                  cookie = { minVersion: 0, reloadCount: 0 };
                }
                reloadCountExceeded = false;
                minVersion = xShowroomMinVersion.replace(/\D/g, '') + '0000000000';
                version = currentVersion.replace(/\D/g, '') + '0000000000';

                minVersion = parseInt(minVersion.substring(0, 10), 10);
                version = parseInt(version.substring(0, 10), 10);
                // check if reload count exceeded
                if (cookie && cookie.reloadCount > 2) {
                  reloadCountExceeded = true;
                }
                // reload if min version is more than currenct version and not exceeded the reload count
                if (minVersion > version && !reloadCountExceeded) {
                  location.reload(true);
                  _jsCookie2.default.set('mhub-book-web-version-checker', { minVersion: minVersion, reloadCount: cookie.reloadCount + 1 });
                } else if (cookie && cookie.minVersion === version) {
                  _jsCookie2.default.set('mhub-book-web-version-checker', { minVersion: minVersion, reloadCount: 0 });
                }
              }

              return _context2.abrupt('return', res);

            case 107:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[2, 8], [26, 34], [40, 46], [65, 71]]);
    }));

    return function (_x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function fetchAPI(api) {
  var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '/';
  var body = arguments[2];
  var method = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'get';
  var opts = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var options = {
    headers: opts,
    body: body
  };
  return function (dispatch) {
    dispatch(fetchRequest());
    return _api2.default[method](api, path, options).then(function (res) {
      dispatch(networkOK());
      dispatch(fetchSuccess());
      return Promise.resolve(res);
    }).catch(function (err) {
      var errorMessage = err.response && err.response.data && err.response.data.error_message;
      if (errorMessage && errorMessage.match(/failed to fetch/i)) {
        dispatch(networkError());
      }
      dispatch(fetchError(errorMessage || 'An error occurred'));
      return Promise.reject(err);
    });
  };
}

// Send a network request to server, default method is GET
function serverRequest(apiUrl, store) {
  var httpOpts = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!store || !apiUrl) return Promise.reject('Required parameters missing.');
  if (!httpOpts.method) {
    // Set default
    httpOpts = {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    };
  }

  return store.dispatch(fetchM(apiUrl, httpOpts));
}function serverRequestGet(apiUrl, store) {
  return execServerRequest(apiUrl, store);
}

function serverRequestPost(apiUrl, store, token, body) {
  var overrideHttpOpts = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

  var httpOpts = {
    credentials: 'include',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Csrf-Token': token
    },
    body: JSON.stringify(body)
  };
  if (overrideHttpOpts) httpOpts = overrideHttpOpts;
  return execServerRequest(apiUrl, store, httpOpts);
}

function serverRequestPut(apiUrl, store, token, body) {
  var httpOpts = {
    credentials: 'include',
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-Csrf-Token': token
    },
    body: JSON.stringify(body)
  };
  return execServerRequest(apiUrl, store, httpOpts);
}

function serverRequestDelete(apiUrl, store, token) {
  var body = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var httpOpts = {
    credentials: 'include',
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'X-Csrf-Token': token
    },
    body: JSON.stringify(body)
  };
  return execServerRequest(apiUrl, store, httpOpts);
}

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ModernAutoControlledComponent__ = __webpack_require__(3274);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_0__ModernAutoControlledComponent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__childrenUtils__ = __webpack_require__(3276);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__childrenUtils__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__classNameBuilders__ = __webpack_require__(3277);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__classNameBuilders__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_2__classNameBuilders__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_2__classNameBuilders__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_2__classNameBuilders__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_2__classNameBuilders__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_2__classNameBuilders__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__classNameBuilders__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__customPropTypes__ = __webpack_require__(3283);
/* unused harmony reexport customPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventStack__ = __webpack_require__(3285);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_4__eventStack__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__factories__ = __webpack_require__(3286);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__factories__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_5__factories__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__factories__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_5__factories__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_5__factories__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_5__factories__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_5__factories__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_5__factories__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getUnhandledProps__ = __webpack_require__(3288);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__getUnhandledProps__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getElementType__ = __webpack_require__(3287);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_7__getElementType__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__htmlPropsUtils__ = __webpack_require__(3291);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_8__htmlPropsUtils__["c"]; });
/* unused harmony reexport htmlInputEvents */
/* unused harmony reexport htmlInputProps */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_8__htmlPropsUtils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_8__htmlPropsUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isBrowser__ = __webpack_require__(1484);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_9__isBrowser__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__doesNodeContainClick__ = __webpack_require__(3284);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_10__doesNodeContainClick__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__leven__ = __webpack_require__(1485);
/* unused harmony reexport leven */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__createPaginationItems__ = __webpack_require__(3279);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_12__createPaginationItems__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SUI__ = __webpack_require__(3275);
/* harmony reexport (module object) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_13__SUI__; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__numberToWord__ = __webpack_require__(713);
/* unused harmony reexport numberToWordMap */
/* unused harmony reexport numberToWord */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__normalizeOffset__ = __webpack_require__(3292);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_15__normalizeOffset__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__normalizeTransitionDuration__ = __webpack_require__(3293);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_16__normalizeTransitionDuration__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__objectDiff__ = __webpack_require__(3294);
/* unused harmony reexport objectDiff */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__hooks_useClassNamesOnNode__ = __webpack_require__(3289);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_18__hooks_useClassNamesOnNode__["a"]; });































 // Heads up! We import/export for this module to safely remove it with "babel-plugin-filter-imports"

//
// Hooks
//



/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.connect = exports.Provider = undefined;

var _Provider = __webpack_require__(3193);

var _Provider2 = _interopRequireDefault(_Provider);

var _connect = __webpack_require__(3194);

var _connect2 = _interopRequireDefault(_connect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports.Provider = _Provider2["default"];
exports.connect = _connect2["default"];

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname, process) {

var path = __webpack_require__(682);

var config = new Map();

try {
  // eslint-disable-next-line global-require
  var gitInfo = __webpack_require__(!(function webpackMissingModule() { var e = new Error("Cannot find module \"../src/gitInfo.json\""); e.code = 'MODULE_NOT_FOUND'; throw e; }()));
  config.set('gitBranch', gitInfo.gitBranch);
  config.set('gitHash', gitInfo.gitCommitHash);
} catch (error) {
  config.set('gitBranch', '');
  config.set('gitHash', '');
}

var server = "production";
if (!server) {
  server = 'development';
}
var env = "production";
if (!env) {
  env = 'development';
}

config.set('server', server);
config.set('env', env);
config.set('dirSrc', path.resolve(__dirname, '../src'));
config.set('dirBuild', path.resolve(__dirname, '../build'));
config.set('gaID', process.env.GA_ID || 'G-TKZYFP747F');

config.set('startURL', 'https://secure.mhub.my');
config.set('apiURL', 'https://api.mhub.my');
config.set('bookApiURL', '');
config.set('loanTrackerURL', 'http://loantracker.mhub.my');
config.set('salesChartURL', 'http://siteplan.mhub.my');
config.set('mpBucket', 'mhub-box-assets-prod');
config.set('mpURL', 'https://marketplace.mhub.my');
config.set('remarksURL', 'https://remarks.mhub.my');
config.set('versionCheck', true);
config.set('clooneURL', 'https://lawyer-api.mhub.my');
config.set('subscriptionApiEndpoint', 'https://fohmcmwftfeg7acwtqd7m72mwu.appsync-api.ap-southeast-1.amazonaws.com/graphql');
config.set('developerURL', 'https://developer.mhub.my');
config.set('analyticsURL', 'https://developer.mhub.my/analytics/sales/overview');
config.set('buyerURL', 'https://buyer.mhub.my');
config.set('logApiURL', 'https://log.mhub.my');
config.set('tzName', "Asia/Kuala_Lumpur" || 'Asia/Kuala_Lumpur');

// Q Help, the in-app support widget (src/utils/qHelpWidget.js): one prebuilt script per environment,
// built in mhub-web-turborepo apps/mhub-q-help-widget. Each build reads one Cognito pool's cookies
// and talks to one Q, so an environment only points at the build for its own pool. Empty = no tag
// (and no help launcher at all). Q_HELP_WIDGET_URL, below, overrides it.
config.set('qHelpWidgetURL', 'https://help-widget.mhub.my/v1/widget.js');

if (config.get('server') === 'staging') {
  config.set('apiURL', 'https://api-dev.mhub.my');
  config.set('startURL', 'https://stage.mhub.my');
  config.set('loanTrackerURL', 'http://loantracker-dev.mhub.my');
  config.set('salesChartURL', 'http://siteplan-staging.mhub.my');
  config.set('mpBucket', 'mhub-box-assets-stage');
  config.set('mpURL', 'https://marketplace.stage.mhub.my');
  config.set('remarksURL', 'https://remarks.stage.mhub.my');
  config.set('clooneURL', 'https://lawyer-stage-api.mhub.my');
  config.set('subscriptionApiEndpoint', 'https://25zoqekpmjeonp7aqfkvhd4fu4.appsync-api.ap-southeast-1.amazonaws.com/graphql');
  config.set('developerURL', 'https://developer.stage.mhub.my');
  config.set('analyticsURL', 'https://developer.stage.mhub.my/analytics/sales/overview');
  config.set('logApiURL', 'https://log.stage.mhub.my');
  config.set('buyerURL', 'https://enterprise-buyer.mhub.ninja');
  config.set('qHelpWidgetURL', 'https://help-widget-staging.mhub.my/v1/widget.js');
}

if (config.get('server') === 'demo') {
  config.set('apiURL', 'https://api-demo.mhub.my');
  config.set('startURL', 'https://demo.mhub.my');
  config.set('loanTrackerURL', 'http://loantracker-demo.mhub.my');
  config.set('salesChartURL', 'https://siteplan-demo.mhub.my');
  config.set('mpBucket', 'mhub-box-assets-demo');
  config.set('mpURL', 'https://marketplace.demo.mhub.my');
  config.set('remarksURL', 'https://remarks.demo.mhub.my');
  config.set('clooneURL', 'https://lawyer-demo-api.mhub.my');
  config.set('subscriptionApiEndpoint', 'https://bld5c3zytba7jc4ncumkibyjaq.appsync-api.ap-southeast-1.amazonaws.com/graphql');
  config.set('developerURL', 'https://developer.demo.mhub.my');
  config.set('analyticsURL', 'https://developer.demo.mhub.my/analytics/sales/overview');
  config.set('logApiURL', 'https://log.demo.mhub.my');
  config.set('buyerURL', 'https://buyer-demo.mhub.my');
  config.set('qHelpWidgetURL', '');
}

if (config.get('server') === 'development') {
  // Defaults preserve the EXISTING local-dev setup (mhub.local domains) — unchanged when no env is
  // set. mhub-devstack overrides them via env (MHUB_API_URL / BOOK_API_URL / MHUB_START_URL) to point
  // at local backends behind Caddy. bookApiURL is only set when provided, so non-devstack behaviour
  // is byte-identical to before.
  config.set('apiURL', process.env.MHUB_API_URL || 'http://api.mhub.local:8010');
  config.set('startURL', process.env.MHUB_START_URL || 'http://web.mhub.local:3009');
  if (process.env.BOOK_API_URL) {
    config.set('bookApiURL', process.env.BOOK_API_URL);
  }
  config.set('loanTrackerURL', 'http://web.mhub.local:3012');
  config.set('salesChartURL', 'http://dev.mhub.local:3001');
  config.set('mpBucket', 'mhub-box-assets-dev');
  config.set('mpURL', 'http://dev.mhub.local:3000');
  config.set('remarksURL', 'http://dev.mhub.my:3000');
  config.set('clooneURL', 'https://lawyer-dev-api.mhub.my');
  config.set('subscriptionApiEndpoint', 'https://idneybrr3zfxnipzv2toptjjx4.appsync-api.ap-southeast-1.amazonaws.com/graphql');
  config.set('subsAuth', '');
  config.set('developerURL', 'http://dev.mhub.local:3000');
  config.set('logApiURL', 'https://log.uat.mhub.my');
  config.set('buyerURL', 'http://localhost:5173');
  // Off unless Q_HELP_WIDGET_URL is set (mhub-devstack sets it to its local widget).
  config.set('qHelpWidgetURL', '');
}

if (config.get('server') === 'development-remote') {
  config.set('apiURL', 'https://api-dev.mhub.my');
  config.set('startURL', 'https://stage.mhub.my');
  config.set('loanTrackerURL', 'http://loantracker-dev.mhub.my');
  config.set('salesChartURL', 'http://siteplan-staging.mhub.my');
  config.set('mpBucket', 'mhub-box-assets-stage');
  config.set('mpURL', 'https://marketplace.stage.mhub.my');
  config.set('remarksURL', 'https://remarks.stage.mhub.my');
  config.set('clooneURL', 'https://lawyer-stage-api.mhub.my');
  config.set('logApiURL', 'https://log.stage.mhub.my');
  config.set('subscriptionApiEndpoint', 'https://25zoqekpmjeonp7aqfkvhd4fu4.appsync-api.ap-southeast-1.amazonaws.com/graphql');
  config.set('qHelpWidgetURL', 'https://help-widget-staging.mhub.my/v1/widget.js');
}

if (config.get('server') === 'uat') {
  config.set('apiURL', 'https://api.uat.mhub.my');
  config.set('startURL', 'https://secure.uat.mhub.my');
  config.set('loanTrackerURL', 'http://loantracker.uat.mhub.my');
  config.set('salesChartURL', 'https://siteplan.uat.mhub.my');
  config.set('mpBucket', 'mhub-box-assets-uat');
  config.set('mpURL', 'https://marketplace.uat.mhub.my');
  config.set('remarksURL', 'https://remarks.uat.mhub.my');
  config.set('clooneURL', 'https://lawyer-api.uat.mhub.my');
  config.set('subscriptionApiEndpoint', 'https://b73loqbjdfhj7bu4r32fn6f7te.appsync-api.ap-southeast-1.amazonaws.com/graphql');
  config.set('developerURL', 'https://developer.uat.mhub.my');
  config.set('logApiURL', 'https://log.uat.mhub.my');
  config.set('analyticsURL', 'https://developer.uat.mhub.my/analytics/sales/overview');
  config.set('buyerURL', 'https://buyer.uat.mhub.my');
  // UAT's own Cognito pool has its own widget build, talking to Q UAT.
  config.set('qHelpWidgetURL', 'https://help-widget-uat.mhub.my/v1/widget.js');
}

config.set('s3Region', 'ap-southeast-1');
config.set('s3SiteplanRegion', 'ap-southeast-1');

var faviconPath = process.env.FAVICON_PATH;
if (!faviconPath || faviconPath === '') {
  faviconPath = '/assets/images';
}
config.set('faviconPath', faviconPath);

var mhubLoader = "";
if (!mhubLoader || mhubLoader === '1') {
  mhubLoader = true;
} else {
  mhubLoader = false;
}
config.set('mhubLoader', mhubLoader);

var prs = "false";
if (prs === 'true') {
  prs = true;
} else {
  prs = false;
}
config.set('prs', prs);

var isPackagePricingRequired = process.env.REQUIRED_BOOKING_PRICING_PACKAGE;
if (isPackagePricingRequired === 'true') {
  isPackagePricingRequired = true;
} else {
  isPackagePricingRequired = false;
}
config.set('isPackagePricingRequired', isPackagePricingRequired);

var versionCheck = "true";
if (versionCheck === 'false') {
  versionCheck = false;
} else {
  versionCheck = true;
}
config.set('versionCheck', versionCheck);

var appTitle = process.env.APP_TITLE;
if (!appTitle || appTitle === '') {
  appTitle = 'MHub';
}
config.set('appTitle', appTitle);

// Bugsnag's release stage. The vendored notifier defaults this to "production" whenever the
// script tag omits data-releasestage (`x("releaseStage", "production")` in snagerror.js), so
// until this was wired EVERY build — uat, staging, demo and a developer's local devstack —
// reported its errors as production: billed to the production 5k/day quota and mixed into
// production error analysis (MS-6583).
//
// RELEASE_STAGE is the right source and already exists: a per-environment CI variable
// (prod/fab/ijm/pr1ma/spsetia => production, uat => uat, staging => staging, demo => demo)
// that build-deploy.yml exports before `make build`. NOT config.get('env') — that is NODE_ENV,
// which is "production" for every deployed build, uat included. `server` is the local
// fallback ('development' when nothing sets it) so a devstack build stops claiming to be
// production. Sanitised: the value is interpolated into an HTML attribute in book.html.
var releaseStage = String(process.env.RELEASE_STAGE || config.get('server') || 'development').toLowerCase().replace(/[^a-z0-9._-]/g, '').slice(0, 32) || 'development';
config.set('releaseStage', releaseStage);

config.set('appName', 'mhub-book-web-' + config.get('env'));

config.set('secureDocumentsSharingWidgetURL', "https://securedocuments-web.mhub.my/static/js/main.337d199c.js");
config.set('secureDocumentsApiURL', "https://09a0tb8nd2.execute-api.ap-southeast-1.amazonaws.com/prod");
config.set('secureDocumentsBoxURL', "https://securedocuments-box.mhub.my");

// overwite environment configs
if (process.env.MHUB_API_URL) {
  config.set('apiURL', process.env.MHUB_API_URL);
}
if (process.env.MHUB_LOG_API_URL) {
  config.set('logApiURL', process.env.MHUB_LOG_API_URL);
}
if (process.env.MHUB_START_URL) {
  config.set('startURL', process.env.MHUB_START_URL);
}
if (false) {
  config.set('qHelpWidgetURL', process.env.Q_HELP_WIDGET_URL);
}
config.set('version', "2.12.12");

config.set('crmKey', "");

// OpenTelemetry (OTEL-6). Injected at build time by config/webpack/*.js DefinePlugin, the same
// way every other value above arrives — there is no runtime env in a browser bundle.
//
// Tracing FAILS OPEN: with otelEndpoint empty the app runs exactly as before and src/lib/telemetry.js
// returns before touching the SDK. Endpoint and headers travel together on purpose — SigNoz's OTLP
// receivers are bearer-gated, so an endpoint configured without its token is answered 401.
config.set('otelEndpoint', "https://otlp.mhub.my" || '');
config.set('otelHeaders', "Authorization=Bearer%20c080ee6ec656b4de3c40ca02816dd2da0a99f3d7fe45762c0eb219b67b84c98f" || '');
// The account-scoped AWS `environment` tag value (e.g. "staging2") => deployment.environment, so
// browser spans land in the same environment bucket as the Go services. NOT releaseStage: that is
// the application environment and names resources. telemetrySdk.js falls back to releaseStage only
// while RESOURCE_ENVIRONMENT is not yet set in CI.
config.set('otelResourceEnvironment', "production" || '');
// Head-sampling ratio, 0 to 1, for the traces this browser starts (parentbased_traceidratio).
// Empty means 1 — every trace. src/lib/telemetry.js parseSamplerRatio() validates it.
config.set('otelSamplerRatio', "" || '');

module.exports = config;
/* WEBPACK VAR INJECTION */}.call(exports, "/", __webpack_require__(90)))

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export clsx */
function r(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r(e))&&(n&&(n+=" "),n+=t);return n}/* harmony default export */ __webpack_exports__["a"] = (clsx);

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                __webpack_require__(3116)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(299)(module)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;

var _reducer = __webpack_require__(1417);

Object.defineProperty(exports, 'LOCATION_CHANGE', {
  enumerable: true,
  get: function get() {
    return _reducer.LOCATION_CHANGE;
  }
});
Object.defineProperty(exports, 'routerReducer', {
  enumerable: true,
  get: function get() {
    return _reducer.routerReducer;
  }
});

var _actions = __webpack_require__(1416);

Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
  enumerable: true,
  get: function get() {
    return _actions.CALL_HISTORY_METHOD;
  }
});
Object.defineProperty(exports, 'push', {
  enumerable: true,
  get: function get() {
    return _actions.push;
  }
});
Object.defineProperty(exports, 'replace', {
  enumerable: true,
  get: function get() {
    return _actions.replace;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _actions.go;
  }
});
Object.defineProperty(exports, 'goBack', {
  enumerable: true,
  get: function get() {
    return _actions.goBack;
  }
});
Object.defineProperty(exports, 'goForward', {
  enumerable: true,
  get: function get() {
    return _actions.goForward;
  }
});
Object.defineProperty(exports, 'routerActions', {
  enumerable: true,
  get: function get() {
    return _actions.routerActions;
  }
});

var _sync = __webpack_require__(3198);

var _sync2 = _interopRequireDefault(_sync);

var _middleware = __webpack_require__(3197);

var _middleware2 = _interopRequireDefault(_middleware);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports.syncHistoryWithStore = _sync2['default'];
exports.routerMiddleware = _middleware2['default'];

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(3131);
var parse = __webpack_require__(3130);
var formats = __webpack_require__(683);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavBar = function (_Component) {
  _inherits(NavBar, _Component);

  function NavBar(props) {
    _classCallCheck(this, NavBar);

    var _this = _possibleConstructorReturn(this, (NavBar.__proto__ || Object.getPrototypeOf(NavBar)).call(this, props));

    _this.onScroll = function () {
      var offsetY = window.pageYOffset;
      var isOver = offsetY > 200;
      if (isOver !== _this.state.isOver) {
        _this.setState({ isOver: isOver });
      }
    };

    _this.handleGoBack = function (e) {
      e.preventDefault();
      var store = _this.context.store;

      if (_this.props.backURL && window.history.length <= 1) {
        store.dispatch((0, _reactRouterRedux.replace)(_this.props.backURL));
        return;
      }
      store.dispatch((0, _reactRouterRedux.goBack)());
    };

    _this.state = {
      isOver: false
    };
    return _this;
  }

  _createClass(NavBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('scroll', this.onScroll, false);
      window.scrollTo(0, 0);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.onScroll, false);
      window.scrollTo(0, 0);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'app-nav ' + (this.state.isOver ? 'fixed' : '') },
        _react2.default.createElement(
          _semanticUiReact.Segment,
          {
            basic: true, vertical: true,
            inverted: this.state.isOver
          },
          _react2.default.createElement(
            _semanticUiReact.Container,
            null,
            _react2.default.createElement(
              _semanticUiReact.Menu,
              {
                fluid: true, secondary: true,
                size: this.props.size,
                inverted: this.state.isOver
              },
              this.props.leftNav || !this.props.noBack && _react2.default.createElement(_semanticUiReact.Menu.Item, {
                link: true,
                href: '/',
                icon: 'left chevron',
                onClick: this.handleGoBack
              }),
              this.props.header ? _react2.default.createElement(_semanticUiReact.Menu.Item, { header: true, content: this.props.header }) : null,
              this.props.children || this.props.links,
              this.props.rightNav ? _react2.default.createElement(
                _semanticUiReact.Menu.Menu,
                { position: 'right' },
                this.props.rightNav
              ) : null
            ),
            this.props.bottomNode && this.state.isOver && this.props.bottomNode
          )
        )
      );
    }
  }]);

  return NavBar;
}(_react.Component);

NavBar.propTypes = {
  links: _propTypes2.default.node,
  children: _propTypes2.default.node,
  size: _propTypes2.default.string,
  header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  noBack: _propTypes2.default.bool,
  backURL: _propTypes2.default.string,
  leftNav: _propTypes2.default.node,
  rightNav: _propTypes2.default.node,
  bottomNode: _propTypes2.default.node
};
NavBar.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = NavBar;

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var moment = module.exports = __webpack_require__(3115);
moment.tz.load(__webpack_require__(3114));


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(52);
var core = __webpack_require__(78);
var hide = __webpack_require__(131);
var redefine = __webpack_require__(119);
var ctx = __webpack_require__(160);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Router__ = __webpack_require__(3203);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Router", function() { return __WEBPACK_IMPORTED_MODULE_0__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Link__ = __webpack_require__(1418);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Link", function() { return __WEBPACK_IMPORTED_MODULE_1__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__IndexLink__ = __webpack_require__(3199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexLink", function() { return __WEBPACK_IMPORTED_MODULE_2__IndexLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withRouter__ = __webpack_require__(3214);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "withRouter", function() { return __WEBPACK_IMPORTED_MODULE_3__withRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__ = __webpack_require__(3200);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRedirect", function() { return __WEBPACK_IMPORTED_MODULE_4__IndexRedirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__IndexRoute__ = __webpack_require__(3201);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "IndexRoute", function() { return __WEBPACK_IMPORTED_MODULE_5__IndexRoute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(1420);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Redirect", function() { return __WEBPACK_IMPORTED_MODULE_6__Redirect__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(3202);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Route", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouteUtils__ = __webpack_require__(207);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createRoutes", function() { return __WEBPACK_IMPORTED_MODULE_8__RouteUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RouterContext__ = __webpack_require__(695);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RouterContext", function() { return __WEBPACK_IMPORTED_MODULE_9__RouterContext__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PropTypes__ = __webpack_require__(694);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "locationShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "routerShape", function() { return __WEBPACK_IMPORTED_MODULE_10__PropTypes__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__match__ = __webpack_require__(3212);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "match", function() { return __WEBPACK_IMPORTED_MODULE_11__match__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__ = __webpack_require__(1425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "useRouterHistory", function() { return __WEBPACK_IMPORTED_MODULE_12__useRouterHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PatternUtils__ = __webpack_require__(290);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "formatPattern", function() { return __WEBPACK_IMPORTED_MODULE_13__PatternUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__ = __webpack_require__(3205);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyRouterMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_14__applyRouterMiddleware__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__browserHistory__ = __webpack_require__(3206);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "browserHistory", function() { return __WEBPACK_IMPORTED_MODULE_15__browserHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__hashHistory__ = __webpack_require__(3210);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hashHistory", function() { return __WEBPACK_IMPORTED_MODULE_16__hashHistory__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__ = __webpack_require__(1422);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createMemoryHistory", function() { return __WEBPACK_IMPORTED_MODULE_17__createMemoryHistory__["a"]; });
/* components */









/* components (configuration) */










/* utils */















/* histories */








/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitizeUrl = exports.SEARCH_ARRAY_LIMIT = undefined;
exports.getLocation = getLocation;
exports.getQuery = getQuery;
exports.decodeSearch = decodeSearch;
exports.encodeSearch = encodeSearch;
exports.siteplanUrl = siteplanUrl;
exports.AWSUrl = AWSUrl;
exports.parseParams = parseParams;
exports.cleanURL = cleanURL;

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// getLocation patch cause IE doesn't support `new URL`
// https://caniuse.com/#search=URL
function getLocation(href) {
  var match = href.match(/^(https?:)\/\/(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/);
  return match && {
    href: href,
    protocol: match[1],
    host: match[2],
    hostname: match[3],
    port: match[4],
    pathname: match[5],
    search: match[6],
    hash: match[7]
  };
}

function getQuery() {
  function get(a) {
    if (a === '') return {};
    var b = {};
    a.forEach(function (ai) {
      var p = ai.split('=', 2);
      if (p.length === 1) {
        b[p[0]] = '';
      } else {
        b[p[0]] = decodeURIComponent(p[1].replace(/\+/g, ' '));
      }
    });
    return b;
  }
  var query = get(window.location.search.substr(1).split('&'));
  return query;
}

// qs only reads an indexed list (`a[0]=x&a[1]=y`) back as an array up to `arrayLimit` entries
// (default 20). Above that it returns an object keyed "0", "1", ..., which broke every filter that
// expects an array: ticking a 22nd agency on Edit Units blanked the page (CPI-1444). Filters stored
// in the URL can legitimately hold many values, so read them back as arrays at any realistic size.
var SEARCH_ARRAY_LIMIT = exports.SEARCH_ARRAY_LIMIT = 1000;
var SEARCH_PARSE_OPTIONS = { arrayLimit: SEARCH_ARRAY_LIMIT };

function decodeSearch(search) {
  if (search.startsWith('?_q=')) {
    return _qs2.default.parse(atob(search.substring(4)), SEARCH_PARSE_OPTIONS);
  }
  return _qs2.default.parse(search.substring(1), SEARCH_PARSE_OPTIONS);
}

function encodeSearch(query) {
  var hide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (hide) {
    return '_q=' + btoa(_qs2.default.stringify(query));
  }
  return _qs2.default.stringify(query);
}

// Local dev: when AWS_S3_ENDPOINT is set (e.g. https://s3-local.mhub.my -> Caddy -> MinIO), object URLs
// are built path-style against it instead of the AWS S3 host. Returns null in real envs (var unset),
// so the AWS URL paths below stay byte-identical in production.
function localS3Base() {
  var ep = process.env.AWS_S3_ENDPOINT;
  if (!ep || ep === 'undefined') return null;
  // Normalize: trim whitespace + strip trailing slash(es) so the `${base}/${bucket}/...` joins below
  // never produce double slashes from a sloppily-set env var. Prod leaves the var unset -> null.
  var base = ep.trim().replace(/\/+$/, '');
  return base !== '' ? base : null;
}

function siteplanUrl(appConfig, fileUrl) {
  var staticRegion = _config2.default.get('s3SiteplanRegion');
  var envRegion = "undefined";
  var envBucket = "mhub-siteplan-box";
  var region = staticRegion;
  var bucket = '';
  if (envRegion !== 'undefined') {
    region = envRegion;
  } else if (appConfig && appConfig.data && appConfig.data.webAwsSiteplanRegion) {
    region = appConfig.data.webAwsSiteplanRegion;
  }
  if (envBucket !== 'undefined') {
    bucket = envBucket;
  } else if (appConfig && appConfig.data && appConfig.data.webAwsSiteplanBucket) {
    bucket = appConfig.data.webAwsSiteplanBucket;
  }
  var lb = localS3Base();
  if (lb && bucket) return lb + '/' + bucket + '/' + fileUrl;
  if (region && bucket) return 'https://s3-' + region + '.amazonaws.com/' + bucket + '/' + fileUrl;
  return '';
}

function AWSUrl(appConfig, fileUrl) {
  var bucketName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var staticRegion = _config2.default.get('s3Region');
  var envRegion = "ap-southeast-1";
  var envBucket = bucketName || "";
  var lb = localS3Base();
  if (lb) {
    var b = envBucket || appConfig && appConfig.data && appConfig.data.webAwsBucket;
    if (b) return lb + '/' + b + '/' + fileUrl;
  }
  if (bucketName) {
    return 'https://' + envBucket + '.s3-' + envRegion + '.amazonaws.com/' + fileUrl;
  }
  if (envRegion && envBucket) {
    return 'https://s3-' + envRegion + '.amazonaws.com/' + envBucket + '/' + fileUrl;
  } else if (appConfig && appConfig.data && appConfig.data.webAwsRegion && appConfig.data.webAwsBucket) {
    return 'https://s3-' + appConfig.data.webAwsRegion + '.amazonaws.com/' + appConfig.data.webAwsBucket + '/' + fileUrl;
  }
  if (envBucket) {
    return 'https://s3-' + staticRegion + '.amazonaws.com/' + envBucket + '/' + fileUrl;
  } else if (appConfig && appConfig.data && appConfig.data.webAwsBucket) {
    return 'https://s3-' + staticRegion + '.amazonaws.com/' + appConfig.data.webAwsBucket + '/' + fileUrl;
  }
  return '';
}

function parseParams(url) {
  var query = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var hash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var parsedURL = url;
  if (query && Object.keys(query).length > 0) {
    parsedURL += '?' + _qs2.default.stringify(query);
  }
  if (hash && Object.keys(hash).length > 0) {
    parsedURL += '#' + _qs2.default.stringify(hash);
  }
  return parsedURL;
}

function cleanURL(paramToRemove) {
  // Use IE-compatible getLocation instead of `new URL`
  var location = getLocation(window.location.href);
  if (!location) {
    // Fallback for environments where getLocation might fail
    var url = new URL(window.location.href);
    try {
      url.searchParams.delete(paramToRemove);
    } catch (e) {
      // If both getLocation and URL fail, do nothing
    }
    return '' + url.pathname + url.search + url.hash;
  }
  var search = location.search || '';
  if (search.startsWith('?')) {
    search = search.substring(1);
  }
  var params = _qs2.default.parse(search);
  if (Object.prototype.hasOwnProperty.call(params, paramToRemove)) {
    delete params[paramToRemove];
  }
  var newSearch = _qs2.default.stringify(params);
  var searchPart = newSearch ? '?' + newSearch : '';
  var pathname = location.pathname || '';
  var hash = location.hash || '';
  return '' + pathname + searchPart + hash;
}

var sanitizeUrl = exports.sanitizeUrl = function sanitizeUrl(input) {
  if (!input) return null;

  var trimmed = String(input).trim();
  var location = getLocation(trimmed);
  if (!location) return null;

  if (!['http:', 'https:'].includes(location.protocol)) {
    return null;
  }
  return trimmed;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _AppForm = __webpack_require__(2086);

var _AppForm2 = _interopRequireDefault(_AppForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AppForm2.default;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var clone = (function() {
'use strict';

function _instanceof(obj, type) {
  return type != null && obj instanceof type;
}

var nativeMap;
try {
  nativeMap = Map;
} catch(_) {
  // maybe a reference error because no `Map`. Give it a dummy value that no
  // value will ever be an instanceof.
  nativeMap = function() {};
}

var nativeSet;
try {
  nativeSet = Set;
} catch(_) {
  nativeSet = function() {};
}

var nativePromise;
try {
  nativePromise = Promise;
} catch(_) {
  nativePromise = function() {};
}

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/
function clone(parent, circular, depth, prototype, includeNonEnumerable) {
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    includeNonEnumerable = circular.includeNonEnumerable;
    circular = circular.circular;
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth === 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (_instanceof(parent, nativeMap)) {
      child = new nativeMap();
    } else if (_instanceof(parent, nativeSet)) {
      child = new nativeSet();
    } else if (_instanceof(parent, nativePromise)) {
      child = new nativePromise(function (resolve, reject) {
        parent.then(function(value) {
          resolve(_clone(value, depth - 1));
        }, function(err) {
          reject(_clone(err, depth - 1));
        });
      });
    } else if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      if (Buffer.allocUnsafe) {
        // Node.js >= 4.5.0
        child = Buffer.allocUnsafe(parent.length);
      } else {
        // Older Node.js versions
        child = new Buffer(parent.length);
      }
      parent.copy(child);
      return child;
    } else if (_instanceof(parent, Error)) {
      child = Object.create(parent);
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    if (_instanceof(parent, nativeMap)) {
      parent.forEach(function(value, key) {
        var keyChild = _clone(key, depth - 1);
        var valueChild = _clone(value, depth - 1);
        child.set(keyChild, valueChild);
      });
    }
    if (_instanceof(parent, nativeSet)) {
      parent.forEach(function(value) {
        var entryChild = _clone(value, depth - 1);
        child.add(entryChild);
      });
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(parent);
      for (var i = 0; i < symbols.length; i++) {
        // Don't need to worry about cloning a symbol because it is a primitive,
        // like a number or string.
        var symbol = symbols[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
          continue;
        }
        child[symbol] = _clone(parent[symbol], depth - 1);
        if (!descriptor.enumerable) {
          Object.defineProperty(child, symbol, {
            enumerable: false
          });
        }
      }
    }

    if (includeNonEnumerable) {
      var allPropertyNames = Object.getOwnPropertyNames(parent);
      for (var i = 0; i < allPropertyNames.length; i++) {
        var propertyName = allPropertyNames[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
        if (descriptor && descriptor.enumerable) {
          continue;
        }
        child[propertyName] = _clone(parent[propertyName], depth - 1);
        Object.defineProperty(child, propertyName, {
          enumerable: false
        });
      }
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
}
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
}
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
}
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
}
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
}
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if (typeof module === 'object' && module.exports) {
  module.exports = clone;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75).Buffer))

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(1739);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Client", function() { return __WEBPACK_IMPORTED_MODULE_0__client__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__command__ = __webpack_require__(1740);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "Command", function() { return __WEBPACK_IMPORTED_MODULE_1__command__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__document_type__ = __webpack_require__(1743);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__exception__ = __webpack_require__(1744);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__extended_encode_uri_component__ = __webpack_require__(1745);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__get_array_if_single_item__ = __webpack_require__(1746);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__get_value_from_text_node__ = __webpack_require__(1747);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lazy_json__ = __webpack_require__(1748);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__date_utils__ = __webpack_require__(1742);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__split_every__ = __webpack_require__(1751);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__constants__ = __webpack_require__(1741);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__retryable_trait__ = __webpack_require__(1749);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__sdk_error__ = __webpack_require__(1750);
/* unused harmony namespace reexport */













//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyxVQUFVLENBQUM7QUFDekIsY0FBYyxXQUFXLENBQUM7QUFDMUIsY0FBYyxpQkFBaUIsQ0FBQztBQUNoQyxjQUFjLGFBQWEsQ0FBQztBQUM1QixjQUFjLGlDQUFpQyxDQUFDO0FBQ2hELGNBQWMsNEJBQTRCLENBQUM7QUFDM0MsY0FBYyw0QkFBNEIsQ0FBQztBQUMzQyxjQUFjLGFBQWEsQ0FBQztBQUM1QixjQUFjLGNBQWMsQ0FBQztBQUM3QixjQUFjLGVBQWUsQ0FBQztBQUM5QixjQUFjLGFBQWEsQ0FBQztBQUM1QixjQUFjLG1CQUFtQixDQUFDO0FBQ2xDLGNBQWMsYUFBYSxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0ICogZnJvbSBcIi4vY2xpZW50XCI7XG5leHBvcnQgKiBmcm9tIFwiLi9jb21tYW5kXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9kb2N1bWVudC10eXBlXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9leGNlcHRpb25cIjtcbmV4cG9ydCAqIGZyb20gXCIuL2V4dGVuZGVkLWVuY29kZS11cmktY29tcG9uZW50XCI7XG5leHBvcnQgKiBmcm9tIFwiLi9nZXQtYXJyYXktaWYtc2luZ2xlLWl0ZW1cIjtcbmV4cG9ydCAqIGZyb20gXCIuL2dldC12YWx1ZS1mcm9tLXRleHQtbm9kZVwiO1xuZXhwb3J0ICogZnJvbSBcIi4vbGF6eS1qc29uXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9kYXRlLXV0aWxzXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9zcGxpdC1ldmVyeVwiO1xuZXhwb3J0ICogZnJvbSBcIi4vY29uc3RhbnRzXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9yZXRyeWFibGUtdHJhaXRcIjtcbmV4cG9ydCAqIGZyb20gXCIuL3Nkay1lcnJvclwiO1xuIl19

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  validate: true
};
Object.defineProperty(exports, "validate", {
  enumerable: true,
  get: function get() {
    return _validate["default"];
  }
});
var _validate = _interopRequireDefault(__webpack_require__(1866));
var _constants = __webpack_require__(172);
Object.keys(_constants).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _constants[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _constants[key];
    }
  });
});
var _utils = __webpack_require__(97);
Object.keys(_utils).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _utils[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _utils[key];
    }
  });
});
var _validations = __webpack_require__(897);
Object.keys(_validations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _validations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _validations[key];
    }
  });
});
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deserializerMiddleware__ = __webpack_require__(860);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__serializerMiddleware__ = __webpack_require__(861);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__serdePlugin__ = __webpack_require__(1713);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__serdePlugin__["a"]; });



//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYywwQkFBMEIsQ0FBQztBQUN6QyxjQUFjLHdCQUF3QixDQUFDO0FBQ3ZDLGNBQWMsZUFBZSxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0ICogZnJvbSBcIi4vZGVzZXJpYWxpemVyTWlkZGxld2FyZVwiO1xuZXhwb3J0ICogZnJvbSBcIi4vc2VyaWFsaXplck1pZGRsZXdhcmVcIjtcbmV4cG9ydCAqIGZyb20gXCIuL3NlcmRlUGx1Z2luXCI7XG4iXX0=

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var AFFILIATE_MAPPINGS_REQUEST = exports.AFFILIATE_MAPPINGS_REQUEST = 'AFFILIATE_MAPPINGS_REQUEST';
var AFFILIATE_MAPPINGS_SUCCESS = exports.AFFILIATE_MAPPINGS_SUCCESS = 'AFFILIATE_MAPPINGS_SUCCESS';
var AFFILIATE_MAPPINGS_FAILURE = exports.AFFILIATE_MAPPINGS_FAILURE = 'AFFILIATE_MAPPINGS_FAILURE';

var ADDRESS_SETTINGS_REQUEST = exports.ADDRESS_SETTINGS_REQUEST = 'ADDRESS_SETTINGS_REQUEST';
var ADDRESS_SETTINGS_FAILURE = exports.ADDRESS_SETTINGS_FAILURE = 'ADDRESS_SETTINGS_FAILURE';
var ADDRESS_SETTINGS_SUCCESS = exports.ADDRESS_SETTINGS_SUCCESS = 'ADDRESS_SETTINGS_SUCCESS';

var APP_GIVE_CREDIT_CHECK_ACCESS = exports.APP_GIVE_CREDIT_CHECK_ACCESS = 'APP_GIVE_CREDIT_CHECK_ACCESS';

var APP_CONFIG_REQUEST = exports.APP_CONFIG_REQUEST = 'APP_CONFIG_REQUEST';
var APP_CONFIG_SUCCESS = exports.APP_CONFIG_SUCCESS = 'APP_CONFIG_SUCCESS';
var APP_CONFIG_FAILURE = exports.APP_CONFIG_FAILURE = 'APP_CONFIG_FAILURE';

var BANKS_REQUEST = exports.BANKS_REQUEST = 'BANKS_REQUEST';
var BANKS_FAILURE = exports.BANKS_FAILURE = 'BANKS_FAILURE';
var BANKS_SUCCESS = exports.BANKS_SUCCESS = 'BANKS_SUCCESS';

var BANK_CASE_STATES_REQUEST = exports.BANK_CASE_STATES_REQUEST = 'BANK_CASE_STATES_REQUEST';
var BANK_CASE_STATES_FAILURE = exports.BANK_CASE_STATES_FAILURE = 'BANK_CASE_STATES_FAILURE';
var BANK_CASE_STATES_SUCCESS = exports.BANK_CASE_STATES_SUCCESS = 'BANK_CASE_STATES_SUCCESS';

var BOB_FORMS_REQUEST = exports.BOB_FORMS_REQUEST = 'BOB_FORMS_REQUEST';
var BOB_FORMS_FAILURE = exports.BOB_FORMS_FAILURE = 'BOB_FORMS_FAILURE';
var BOB_FORMS_SUCCESS = exports.BOB_FORMS_SUCCESS = 'BOB_FORMS_SUCCESS';

var BOOK_QUERY_SUCCESS = exports.BOOK_QUERY_SUCCESS = 'BOOK_QUERY_SUCCESS';

var CANCELLATION_REASONS_REQUEST = exports.CANCELLATION_REASONS_REQUEST = 'CANCELLATION_REASONS_REQUEST';
var CANCELLATION_REASONS_SUCCESS = exports.CANCELLATION_REASONS_SUCCESS = 'CANCELLATION_REASONS_SUCCESS';
var CANCELLATION_REASONS_FAILURE = exports.CANCELLATION_REASONS_FAILURE = 'CANCELLATION_REASONS_FAILURE';

var CURRENCY_SETTINGS_REQUEST = exports.CURRENCY_SETTINGS_REQUEST = 'CURRENCY_SETTINGS_REQUEST';
var CURRENCY_SETTINGS_SUCCESS = exports.CURRENCY_SETTINGS_SUCCESS = 'CURRENCY_SETTINGS_SUCCESS';
var CURRENCY_SETTINGS_FAILURE = exports.CURRENCY_SETTINGS_FAILURE = 'CURRENCY_SETTINGS_FAILURE';

var CUSTOM_OPTIONS_REQUEST = exports.CUSTOM_OPTIONS_REQUEST = 'CUSTOM_OPTIONS_REQUEST';
var CUSTOM_OPTIONS_SUCCESS = exports.CUSTOM_OPTIONS_SUCCESS = 'CUSTOM_OPTIONS_SUCCESS';
var CUSTOM_OPTIONS_FAILURE = exports.CUSTOM_OPTIONS_FAILURE = 'CUSTOM_OPTIONS_FAILURE';

var FETCH_REQUEST = exports.FETCH_REQUEST = 'FETCH_REQUEST';
var FETCH_FAILURE = exports.FETCH_FAILURE = 'FETCH_FAILURE';
var FETCH_SUCCESS = exports.FETCH_SUCCESS = 'FETCH_SUCCESS';

var FINANCE_SOURCES_REQUEST = exports.FINANCE_SOURCES_REQUEST = 'FINANCE_SOURCES_REQUEST';
var FINANCE_SOURCES_SUCCESS = exports.FINANCE_SOURCES_SUCCESS = 'FINANCE_SOURCES_SUCCESS';
var FINANCE_SOURCES_FAILURE = exports.FINANCE_SOURCES_FAILURE = 'FINANCE_SOURCES_FAILURE';

var FLASH_MESSAGE = exports.FLASH_MESSAGE = 'FLASH_MESSAGE';
var FLASH_MESSAGE_RESET = exports.FLASH_MESSAGE_RESET = 'FLASH_MESSAGE_RESET';

var GLOBAL_SETTINGS_REQUEST = exports.GLOBAL_SETTINGS_REQUEST = 'GLOBAL_SETTINGS_REQUEST';
var GLOBAL_SETTINGS_SUCCESS = exports.GLOBAL_SETTINGS_SUCCESS = 'GLOBAL_SETTINGS_SUCCESS';
var GLOBAL_SETTINGS_FAILURE = exports.GLOBAL_SETTINGS_FAILURE = 'GLOBAL_SETTINGS_FAILURE';

var IDENTITY_PRESETS_REQUEST = exports.IDENTITY_PRESETS_REQUEST = 'IDENTITY_PRESETS_REQUEST';
var IDENTITY_PRESETS_SUCCESS = exports.IDENTITY_PRESETS_SUCCESS = 'IDENTITY_PRESETS_SUCCESS';
var IDENTITY_PRESETS_FAILURE = exports.IDENTITY_PRESETS_FAILURE = 'IDENTITY_PRESETS_FAILURE';

var PHONE_VALIDATION_PRESETS_REQUEST = exports.PHONE_VALIDATION_PRESETS_REQUEST = 'PHONE_VALIDATION_PRESETS_REQUEST';
var PHONE_VALIDATION_PRESETS_SUCCESS = exports.PHONE_VALIDATION_PRESETS_SUCCESS = 'PHONE_VALIDATION_PRESETS_SUCCESS';
var PHONE_VALIDATION_PRESETS_FAILURE = exports.PHONE_VALIDATION_PRESETS_FAILURE = 'PHONE_VALIDATION_PRESETS_FAILURE';

var LOGIN_GIVE_HEADQUARTERS_ACCESS = exports.LOGIN_GIVE_HEADQUARTERS_ACCESS = 'LOGIN_GIVE_HEADQUARTERS_ACCESS';
var LOGIN_GIVE_BRANCH_LEADER_SUPERVISOR_II_ACCESS = exports.LOGIN_GIVE_BRANCH_LEADER_SUPERVISOR_II_ACCESS = 'LOGIN_GIVE_BRANCH_LEADER_SUPERVISOR_II_ACCESS';
var LOGIN_GIVE_BRANCH_LEADER_SUPERVISOR_ACCESS = exports.LOGIN_GIVE_BRANCH_LEADER_SUPERVISOR_ACCESS = 'LOGIN_GIVE_BRANCH_LEADER_SUPERVISOR_ACCESS';
var LOGIN_GIVE_BRANCH_LEADER_ACCESS = exports.LOGIN_GIVE_BRANCH_LEADER_ACCESS = 'LOGIN_GIVE_BRANCH_LEADER_ACCESS';
var LOGIN_GIVE_DEVELOPER_ACCESS = exports.LOGIN_GIVE_DEVELOPER_ACCESS = 'LOGIN_GIVE_DEVELOPER_ACCESS';
var LOGIN_GIVE_DEVELOPER_SUPERVISOR = exports.LOGIN_GIVE_DEVELOPER_SUPERVISOR = 'LOGIN_GIVE_DEVELOPER_SUPERVISOR';
var LOGIN_GIVE_DEVELOPER_SALES_MANAGER = exports.LOGIN_GIVE_DEVELOPER_SALES_MANAGER = 'LOGIN_GIVE_DEVELOPER_SALES_MANAGER';
var LOGIN_GIVE_DEVELOPER_SALES_ADMIN = exports.LOGIN_GIVE_DEVELOPER_SALES_ADMIN = 'LOGIN_GIVE_DEVELOPER_SALES_ADMIN';
var LOGIN_GIVE_DEVELOPER_STAFF = exports.LOGIN_GIVE_DEVELOPER_STAFF = 'LOGIN_GIVE_DEVELOPER_STAFF';
var LOGIN_GIVE_EXTERNAL_AGENT_LEADER = exports.LOGIN_GIVE_EXTERNAL_AGENT_LEADER = 'LOGIN_GIVE_EXTERNAL_AGENT_LEADER';
var LOGIN_GIVE_EXTERNAL_AGENT = exports.LOGIN_GIVE_EXTERNAL_AGENT = 'LOGIN_GIVE_EXTERNAL_AGENT';
var LOGIN_GIVE_EXTERNAL_AGENCY_ADMIN = exports.LOGIN_GIVE_EXTERNAL_AGENCY_ADMIN = 'LOGIN_GIVE_EXTERNAL_AGENCY_ADMIN';
var LOGIN_GIVE_DEVELOPER_SITEPLAN_ACCESS = exports.LOGIN_GIVE_DEVELOPER_SITEPLAN_ACCESS = 'LOGIN_GIVE_DEVELOPER_SITEPLAN_ACCESS';
var LOGIN_GIVE_SUPER_ADMIN_ACCESS = exports.LOGIN_GIVE_SUPER_ADMIN_ACCESS = 'LOGIN_GIVE_SUPER_ADMIN_ACCESS';
var LOGIN_GIVE_ADMIN_BASIC_ACCESS = exports.LOGIN_GIVE_ADMIN_BASIC_ACCESS = 'LOGIN_GIVE_ADMIN_BASIC_ACCESS';
var LOGIN_GIVE_ADMIN_COMMUNITY_ACCESS = exports.LOGIN_GIVE_ADMIN_COMMUNITY_ACCESS = 'LOGIN_GIVE_ADMIN_COMMUNITY_ACCESS';
var LOGIN_GIVE_ADMIN_ACCESS = exports.LOGIN_GIVE_ADMIN_ACCESS = 'LOGIN_GIVE_ADMIN_ACCESS';
var LOGIN_GIVE_MAIN_HEADQUARTERS_ACCESS = exports.LOGIN_GIVE_MAIN_HEADQUARTERS_ACCESS = 'LOGIN_GIVE_MAIN_HEADQUARTERS_ACCESS';
var LOGIN_GIVE_EDIT_UNIT_PRICE_ACCESS = exports.LOGIN_GIVE_EDIT_UNIT_PRICE_ACCESS = 'LOGIN_GIVE_EDIT_UNIT_PRICE_ACCESS';
var LOGIN_GIVE_EDIT_UNIT_DETAIL_ACCESS = exports.LOGIN_GIVE_EDIT_UNIT_DETAIL_ACCESS = 'LOGIN_GIVE_EDIT_UNIT_DETAIL_ACCESS';
var LOGIN_USER_REQUEST = exports.LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
var LOGIN_USER_SUCCESS = exports.LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
var LOGIN_USER_FAILURE = exports.LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
var LOGIN_USER_UPDATE_SUCCESS = exports.LOGIN_USER_UPDATE_SUCCESS = 'LOGIN_USER_UPDATE_SUCCESS';

var LOGIN_FROM_ADFS = exports.LOGIN_FROM_ADFS = 'LOGIN_FROM_ADFS';

var LOGOUT_USER_REQUEST = exports.LOGOUT_USER_REQUEST = 'LOGOUT_USER_REQUEST';
var LOGOUT_USER_FAILURE = exports.LOGOUT_USER_FAILURE = 'LOGOUT_USER_FAILURE';
var LOGOUT_USER_SUCCESS = exports.LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';

var NETWORK_FAILURE = exports.NETWORK_FAILURE = 'NETWORK_FAILURE';
var NETWORK_OK = exports.NETWORK_OK = 'NETWORK_OK';

var PROJECT_BUSINESS_UNITS_REQUEST = exports.PROJECT_BUSINESS_UNITS_REQUEST = 'PROJECT_BUSINESS_UNITS_REQUEST';
var PROJECT_BUSINESS_UNIT_SUCCESS = exports.PROJECT_BUSINESS_UNIT_SUCCESS = 'PROJECT_BUSINESS_UNITS_SUCCESS';
var PROJECT_BUSINESS_UNIT_FAILURE = exports.PROJECT_BUSINESS_UNIT_FAILURE = 'PROJECT_BUSINESS_UNITS_FAILURE';

var PROJECT_MAPPINGS_REQUEST = exports.PROJECT_MAPPINGS_REQUEST = 'PROJECT_MAPPINGS_REQUEST';
var PROJECT_MAPPINGS_SUCCESS = exports.PROJECT_MAPPINGS_SUCCESS = 'PROJECT_MAPPINGS_SUCCESS';
var PROJECT_MAPPINGS_FAILURE = exports.PROJECT_MAPPINGS_FAILURE = 'PROJECT_MAPPINGS_FAILURE';

var PROJECT_OPTIONS_REQUEST = exports.PROJECT_OPTIONS_REQUEST = 'PROJECT_OPTIONS_REQUEST';
var PROJECT_OPTIONS_SUCCESS = exports.PROJECT_OPTIONS_SUCCESS = 'PROJECT_OPTIONS_SUCCESS';
var PROJECT_OPTIONS_FAILURE = exports.PROJECT_OPTIONS_FAILURE = 'PROJECT_OPTIONS_FAILURE';

var PROJECT_SPECIFICATIONS_REQUEST = exports.PROJECT_SPECIFICATIONS_REQUEST = 'PROJECT_SPECIFICATIONS_REQUEST';
var PROJECT_SPECIFICATIONS_SUCCESS = exports.PROJECT_SPECIFICATIONS_SUCCESS = 'PROJECT_SPECIFICATIONS_SUCCESS';
var PROJECT_SPECIFICATIONS_FAILURE = exports.PROJECT_SPECIFICATIONS_FAILURE = 'PROJECT_SPECIFICATIONS_FAILURE';

var PROJECT_UNIT_LAYOUT_SPECIFICATIONS_REQUEST = exports.PROJECT_UNIT_LAYOUT_SPECIFICATIONS_REQUEST = 'PROJECT_UNIT_LAYOUT_SPECIFICATIONS_REQUEST';
var PROJECT_UNIT_LAYOUT_SPECIFICATIONS_SUCCESS = exports.PROJECT_UNIT_LAYOUT_SPECIFICATIONS_SUCCESS = 'PROJECT_UNIT_LAYOUT_SPECIFICATIONS_SUCCESS';
var PROJECT_UNIT_LAYOUT_SPECIFICATIONS_FAILURE = exports.PROJECT_UNIT_LAYOUT_SPECIFICATIONS_FAILURE = 'PROJECT_UNIT_LAYOUT_SPECIFICATIONS_FAILURE';

var PROJECT_UNIT_SPECIFICATIONS_REQUEST = exports.PROJECT_UNIT_SPECIFICATIONS_REQUEST = 'PROJECT_UNIT_SPECIFICATIONS_REQUEST';
var PROJECT_UNIT_SPECIFICATIONS_SUCCESS = exports.PROJECT_UNIT_SPECIFICATIONS_SUCCESS = 'PROJECT_UNIT_SPECIFICATIONS_SUCCESS';
var PROJECT_UNIT_SPECIFICATIONS_FAILURE = exports.PROJECT_UNIT_SPECIFICATIONS_FAILURE = 'PROJECT_UNIT_SPECIFICATIONS_FAILURE';

var PROMPT_MESSAGE = exports.PROMPT_MESSAGE = 'PROMPT_MESSAGE';
var PROMPT_MESSAGE_RESET = exports.PROMPT_MESSAGE_RESET = 'PROMPT_MESSAGE_RESET';

var SALES_CHART_TYPES_REQUEST = exports.SALES_CHART_TYPES_REQUEST = 'SALES_CHART_TYPES_REQUEST';
var SALES_CHART_TYPES_SUCCESS = exports.SALES_CHART_TYPES_SUCCESS = 'SALES_CHART_TYPES_SUCCESS';
var SALES_CHART_TYPES_FAILURE = exports.SALES_CHART_TYPES_FAILURE = 'SALES_CHART_TYPES_FAILURE';

var TAGS_REQUEST = exports.TAGS_REQUEST = 'TAGS_REQUEST';
var TAGS_SUCCESS = exports.TAGS_SUCCESS = 'TAGS_SUCCESS';
var TAGS_FAILURE = exports.TAGS_FAILURE = 'TAGS_FAILURE';

var TEMPLATES_REQUEST = exports.TEMPLATES_REQUEST = 'TEMPLATES_REQUEST';
var TEMPLATES_SUCCESS = exports.TEMPLATES_SUCCESS = 'TEMPLATES_SUCCESS';
var TEMPLATES_FAILURE = exports.TEMPLATES_FAILURE = 'TEMPLATES_FAILURE';

var HIMS_DISTRICTS_REQUEST = exports.HIMS_DISTRICTS_REQUEST = 'HIMS_DISTRICTS_REQUEST';
var HIMS_DISTRICTS_SUCCESS = exports.HIMS_DISTRICTS_SUCCESS = 'HIMS_DISTRICTS_SUCCESS';
var HIMS_DISTRICTS_FAILURE = exports.HIMS_DISTRICTS_FAILURE = 'HIMS_DISTRICTS_FAILURE';

var HIMS_POSTCODES_REQUEST = exports.HIMS_POSTCODES_REQUEST = 'HIMS_POSTCODES_REQUEST';
var HIMS_POSTCODES_SUCCESS = exports.HIMS_POSTCODES_SUCCESS = 'HIMS_POSTCODES_SUCCESS';
var HIMS_POSTCODES_FAILURE = exports.HIMS_POSTCODES_FAILURE = 'HIMS_POSTCODES_FAILURE';

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-nested-ternary */


var PageNav = function (_Component) {
  _inherits(PageNav, _Component);

  function PageNav(props) {
    _classCallCheck(this, PageNav);

    var _this = _possibleConstructorReturn(this, (PageNav.__proto__ || Object.getPrototypeOf(PageNav)).call(this, props));

    _initialiseProps.call(_this);

    var currentPage = props.currentPage || 1;
    _this.state = {
      currentPage: currentPage
    };
    return _this;
  }

  _createClass(PageNav, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var currentPage = nextProps.currentPage || this.state.currentPage;
      this.setState({
        currentPage: currentPage
      });
    }
  }, {
    key: 'handleOnChange',
    value: function handleOnChange(currentPage) {
      var _this2 = this;

      if (this.props.onChange) {
        this.props.onChange(currentPage);
      }
      this.setState({ currentPage: currentPage }, function () {
        if (!_this2.props.noScrollTop) {
          window.scrollTo(0, 0);
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          size = _props.size,
          loading = _props.loading;

      var options = this.getPageCount();
      var hasMore = this.getHasMore();
      var hasLess = this.getHasLess();
      return _react2.default.createElement(
        _semanticUiReact.Menu,
        {
          pagination: true,
          size: size,
          floated: this.props.floated,
          attached: this.props.attached,
          style: this.props.color ? { background: this.props.color } : null
        },
        _react2.default.createElement(_semanticUiReact.Menu.Item, {
          as: _semanticUiReact.Button,
          size: size,
          onClick: function onClick() {
            return _this3.handleChangePage(_this3.props.isCursorPagination ? 'prev' : -1);
          },
          disabled: !hasLess || loading,
          icon: 'left chevron'
        }),
        this.props.hideDropdown ? null : this.props.isCursorPagination ? _react2.default.createElement(
          _semanticUiReact.Menu.Item,
          { disabled: true, style: { minWidth: '3rem', justifyContent: 'center' } },
          this.state.currentPage
        ) : _react2.default.createElement(_semanticUiReact.Dropdown, {
          upward: this.props.upward,
          item: true,
          scrolling: true,
          search: true,
          selectOnBlur: false,
          options: options,
          onChange: this.handleInputPage,
          value: this.state.currentPage,
          disabled: options.length === 1 || loading
        }),
        _react2.default.createElement(_semanticUiReact.Menu.Item, {
          as: _semanticUiReact.Button,
          size: size,
          onClick: function onClick() {
            return _this3.handleChangePage(_this3.props.isCursorPagination ? 'next' : 1);
          },
          disabled: !hasMore || loading,
          icon: 'right chevron'
        })
      );
    }
  }]);

  return PageNav;
}(_react.Component);

PageNav.propTypes = {
  upward: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  currentPage: _propTypes2.default.number,
  loading: _propTypes2.default.bool,
  hasLess: _propTypes2.default.bool,
  hasMore: _propTypes2.default.bool,
  hideDropdown: _propTypes2.default.bool,
  count: _propTypes2.default.number,
  limit: _propTypes2.default.number,
  offset: _propTypes2.default.number,
  dataSize: _propTypes2.default.number,
  onChange: _propTypes2.default.func,
  size: _propTypes2.default.string,
  floated: _propTypes2.default.string,
  attached: _propTypes2.default.string,
  noScrollTop: _propTypes2.default.bool,
  // Cursor pagination toggle
  isCursorPagination: _propTypes2.default.bool,
  // Current "next" cursor (from latest API response)
  nextCursor: _propTypes2.default.shape({
    pit_id: _propTypes2.default.string,
    search_after: _propTypes2.default.string
  }),
  // Stack of previous cursors (for "Prev" button)
  cursorStack: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    pit_id: _propTypes2.default.string,
    search_after: _propTypes2.default.string
  }))
};
PageNav.defaultProps = {
  currentPage: 1,
  loading: false,
  hideDropdown: false,
  count: 0,
  limit: 0,
  offset: 0,
  dataSize: 0,
  size: 'tiny',
  noScrollTop: false,
  isCursorPagination: false,
  nextCursor: null,
  cursorStack: [] // previous cursors
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.getHasMore = function () {
    var _props2 = _this4.props,
        count = _props2.count,
        limit = _props2.limit,
        offset = _props2.offset,
        dataSize = _props2.dataSize,
        hasMore = _props2.hasMore,
        isCursorPagination = _props2.isCursorPagination,
        nextCursor = _props2.nextCursor;


    if (isCursorPagination) {
      return !!(nextCursor && nextCursor.search_after);
    }
    if (hasMore !== undefined) {
      return hasMore;
    }
    if (dataSize === limit) {
      return dataSize + offset !== count;
    }
    return false;
  };

  this.getHasLess = function () {
    var _props3 = _this4.props,
        offset = _props3.offset,
        hasLess = _props3.hasLess,
        isCursorPagination = _props3.isCursorPagination,
        cursorStack = _props3.cursorStack;


    if (isCursorPagination) {
      return (cursorStack || []).length > 0;
    }
    if (hasLess !== undefined) {
      return hasLess;
    }
    return offset !== 0;
  };

  this.getPageCount = function () {
    var _props4 = _this4.props,
        count = _props4.count,
        limit = _props4.limit;

    var totalPage = 1;
    if (count > 0 && limit > 0) {
      totalPage = Math.ceil(count / limit);
    }
    var pageOptions = [];
    for (var i = 1; i <= totalPage; i += 1) {
      pageOptions.push({
        text: i,
        value: i
      });
    }
    return pageOptions;
  };

  this.handleChangePage = function (direction) {
    var _props5 = _this4.props,
        isCursorPagination = _props5.isCursorPagination,
        onChange = _props5.onChange,
        cursorStack = _props5.cursorStack,
        nextCursor = _props5.nextCursor;


    if (isCursorPagination) {
      if (!onChange) return;

      if (direction === 'next') {
        onChange({
          type: 'next',
          cursor: nextCursor
        });
      }

      if (direction === 'prev') {
        var stack = cursorStack || [];
        var prevCursor = stack[stack.length - 1];

        onChange({
          type: 'prev',
          cursor: prevCursor || null
        });
      }

      return;
    }

    // Offset pagination mode (original logic)
    var currentPage = _this4.state.currentPage + direction;
    _this4.handleOnChange(currentPage);
  };

  this.handleInputPage = function (e, _ref) {
    var value = _ref.value;

    var currentPage = value;
    _this4.handleOnChange(currentPage);
  };
};

exports.default = PageNav;

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["c"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["d"] = __generator;
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* harmony export (immutable) */ __webpack_exports__["e"] = __read;
/* harmony export (immutable) */ __webpack_exports__["f"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __spreadArray */
/* harmony export (immutable) */ __webpack_exports__["h"] = __await;
/* harmony export (immutable) */ __webpack_exports__["g"] = __asyncGenerator;
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _displayTime = __webpack_require__(156);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Timestamp = function Timestamp(_ref) {
  var timestamp = _ref.timestamp,
      precise = _ref.precise,
      format = _ref.format,
      countryCode = _ref.countryCode;

  var time = void 0;
  // Convert display values only; date inputs and API serialization keep their default zone.
  var t = (0, _displayTime.displayMoment)(timestamp, countryCode);
  var now = (0, _displayTime.displayNow)(countryCode);
  var startYear = now.clone().startOf('year');
  var accurateTime = function accurateTime(tMoment, tStart) {
    var days = now.diff(tMoment, 'days');
    if (days < 2) {
      return tMoment.calendar(now, {
        sameDay: '[Today] hh:mm a',
        lastDay: '[Yesterday] hh:mm a',
        lastWeek: 'DD MMM hh:mm a',
        sameElse: 'DD MMM hh:mm a'
      });
    }
    if (tMoment.isAfter(tStart)) {
      return tMoment.format('DD MMM hh:mm a');
    }
    return tMoment.format('DD/MM/YY hh:mm a');
  };
  var simpleTime = function simpleTime(tMoment, tStart) {
    if (tMoment.isAfter(tStart)) {
      return tMoment.format('DD MMM');
    }
    return tMoment.format('DD MMM YYYY');
  };
  if (precise) {
    time = accurateTime(t, startYear);
  } else {
    time = simpleTime(t, startYear);
  }
  if (format) {
    time = t.format(format);
  }
  return _react2.default.createElement(
    'span',
    { className: 'timestamp' },
    time
  );
};

Timestamp.propTypes = {
  timestamp: _propTypes2.default.oneOfType([_propTypes2.default.string]),
  precise: _propTypes2.default.bool,
  format: _propTypes2.default.string,
  countryCode: _propTypes2.default.string
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    countryCode: state.auth && state.auth.company && state.auth.company.countryCode
  };
})(Timestamp);

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(877);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isNumber;
exports.isNumeric = isNumeric;
function isNumber(input) {
  if (+input === parseInt(input, 10)) {
    return true;
  }
  return false;
}
function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__createBinding"] = __createBinding;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__spreadArrays"] = __spreadArrays;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/* harmony export (immutable) */ __webpack_exports__["__classPrivateFieldGet"] = __classPrivateFieldGet;
/* harmony export (immutable) */ __webpack_exports__["__classPrivateFieldSet"] = __classPrivateFieldSet;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baggage_utils__ = __webpack_require__(901);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "baggageEntryMetadataFromString", function() { return __WEBPACK_IMPORTED_MODULE_0__baggage_utils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_context__ = __webpack_require__(372);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createContextKey", function() { return __WEBPACK_IMPORTED_MODULE_1__context_context__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ROOT_CONTEXT", function() { return __WEBPACK_IMPORTED_MODULE_1__context_context__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__diag_consoleLogger__ = __webpack_require__(1894);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DiagConsoleLogger", function() { return __WEBPACK_IMPORTED_MODULE_2__diag_consoleLogger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__diag_types__ = __webpack_require__(533);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DiagLogLevel", function() { return __WEBPACK_IMPORTED_MODULE_3__diag_types__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__metrics_NoopMeter__ = __webpack_require__(902);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createNoopMeter", function() { return __WEBPACK_IMPORTED_MODULE_4__metrics_NoopMeter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__metrics_Metric__ = __webpack_require__(1898);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ValueType", function() { return __WEBPACK_IMPORTED_MODULE_5__metrics_Metric__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__propagation_TextMapPropagator__ = __webpack_require__(903);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTextMapGetter", function() { return __WEBPACK_IMPORTED_MODULE_6__propagation_TextMapPropagator__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTextMapSetter", function() { return __WEBPACK_IMPORTED_MODULE_6__propagation_TextMapPropagator__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__trace_ProxyTracer__ = __webpack_require__(905);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ProxyTracer", function() { return __WEBPACK_IMPORTED_MODULE_7__trace_ProxyTracer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__trace_ProxyTracerProvider__ = __webpack_require__(906);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ProxyTracerProvider", function() { return __WEBPACK_IMPORTED_MODULE_8__trace_ProxyTracerProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__trace_SamplingResult__ = __webpack_require__(1906);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SamplingDecision", function() { return __WEBPACK_IMPORTED_MODULE_9__trace_SamplingResult__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__trace_span_kind__ = __webpack_require__(1910);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SpanKind", function() { return __WEBPACK_IMPORTED_MODULE_10__trace_span_kind__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__trace_status__ = __webpack_require__(1911);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SpanStatusCode", function() { return __WEBPACK_IMPORTED_MODULE_11__trace_status__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__trace_trace_flags__ = __webpack_require__(908);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TraceFlags", function() { return __WEBPACK_IMPORTED_MODULE_12__trace_trace_flags__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__trace_internal_utils__ = __webpack_require__(1909);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createTraceState", function() { return __WEBPACK_IMPORTED_MODULE_13__trace_internal_utils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__trace_spancontext_utils__ = __webpack_require__(536);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isSpanContextValid", function() { return __WEBPACK_IMPORTED_MODULE_14__trace_spancontext_utils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isValidTraceId", function() { return __WEBPACK_IMPORTED_MODULE_14__trace_spancontext_utils__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isValidSpanId", function() { return __WEBPACK_IMPORTED_MODULE_14__trace_spancontext_utils__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__trace_invalid_span_constants__ = __webpack_require__(535);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "INVALID_SPANID", function() { return __WEBPACK_IMPORTED_MODULE_15__trace_invalid_span_constants__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "INVALID_TRACEID", function() { return __WEBPACK_IMPORTED_MODULE_15__trace_invalid_span_constants__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "INVALID_SPAN_CONTEXT", function() { return __WEBPACK_IMPORTED_MODULE_15__trace_invalid_span_constants__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__context_api__ = __webpack_require__(1890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__diag_api__ = __webpack_require__(1892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__metrics_api__ = __webpack_require__(1897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__propagation_api__ = __webpack_require__(1902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__trace_api__ = __webpack_require__(1904);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "context", function() { return __WEBPACK_IMPORTED_MODULE_16__context_api__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "diag", function() { return __WEBPACK_IMPORTED_MODULE_17__diag_api__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "metrics", function() { return __WEBPACK_IMPORTED_MODULE_18__metrics_api__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "propagation", function() { return __WEBPACK_IMPORTED_MODULE_19__propagation_api__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "trace", function() { return __WEBPACK_IMPORTED_MODULE_20__trace_api__["a"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// Context APIs

// Diag APIs


// Metrics APIs


// Propagation APIs










// Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.





// Named export.

// Default export.
/* harmony default export */ __webpack_exports__["default"] = ({
    context: __WEBPACK_IMPORTED_MODULE_16__context_api__["a" /* context */],
    diag: __WEBPACK_IMPORTED_MODULE_17__diag_api__["a" /* diag */],
    metrics: __WEBPACK_IMPORTED_MODULE_18__metrics_api__["a" /* metrics */],
    propagation: __WEBPACK_IMPORTED_MODULE_19__propagation_api__["a" /* propagation */],
    trace: __WEBPACK_IMPORTED_MODULE_20__trace_api__["a" /* trace */],
});
//# sourceMappingURL=index.js.map

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return AssociateKmsKeyRequest; });
/* unused harmony export InvalidParameterException */
/* unused harmony export OperationAbortedException */
/* unused harmony export ResourceNotFoundException */
/* unused harmony export ServiceUnavailableException */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return CancelExportTaskRequest; });
/* unused harmony export InvalidOperationException */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return CreateExportTaskRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return CreateExportTaskResponse; });
/* unused harmony export LimitExceededException */
/* unused harmony export ResourceAlreadyExistsException */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return CreateLogGroupRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return CreateLogStreamRequest; });
/* unused harmony export DataAlreadyAcceptedException */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return DeleteDestinationRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return DeleteLogGroupRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return DeleteLogStreamRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return DeleteMetricFilterRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return DeleteQueryDefinitionRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return DeleteQueryDefinitionResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return DeleteResourcePolicyRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return DeleteRetentionPolicyRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return DeleteSubscriptionFilterRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return DescribeDestinationsRequest; });
/* unused harmony export Destination */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return DescribeDestinationsResponse; });
/* unused harmony export ExportTaskStatusCode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return DescribeExportTasksRequest; });
/* unused harmony export ExportTaskExecutionInfo */
/* unused harmony export ExportTaskStatus */
/* unused harmony export ExportTask */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return DescribeExportTasksResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return DescribeLogGroupsRequest; });
/* unused harmony export LogGroup */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return DescribeLogGroupsResponse; });
/* unused harmony export OrderBy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return DescribeLogStreamsRequest; });
/* unused harmony export LogStream */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return DescribeLogStreamsResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return DescribeMetricFiltersRequest; });
/* unused harmony export MetricTransformation */
/* unused harmony export MetricFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return DescribeMetricFiltersResponse; });
/* unused harmony export QueryStatus */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return DescribeQueriesRequest; });
/* unused harmony export QueryInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return DescribeQueriesResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return DescribeQueryDefinitionsRequest; });
/* unused harmony export QueryDefinition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return DescribeQueryDefinitionsResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return DescribeResourcePoliciesRequest; });
/* unused harmony export ResourcePolicy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return DescribeResourcePoliciesResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return DescribeSubscriptionFiltersRequest; });
/* unused harmony export Distribution */
/* unused harmony export SubscriptionFilter */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return DescribeSubscriptionFiltersResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return DisassociateKmsKeyRequest; });
/* unused harmony export FilteredLogEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return FilterLogEventsRequest; });
/* unused harmony export SearchedLogStream */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return FilterLogEventsResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return GetLogEventsRequest; });
/* unused harmony export OutputLogEvent */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return GetLogEventsResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return GetLogGroupFieldsRequest; });
/* unused harmony export LogGroupField */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return GetLogGroupFieldsResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return GetLogRecordRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return GetLogRecordResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return GetQueryResultsRequest; });
/* unused harmony export ResultField */
/* unused harmony export QueryStatistics */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return GetQueryResultsResponse; });
/* unused harmony export InputLogEvent */
/* unused harmony export InvalidSequenceTokenException */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ListTagsLogGroupRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ListTagsLogGroupResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PutDestinationRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PutDestinationResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PutDestinationPolicyRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return PutLogEventsRequest; });
/* unused harmony export RejectedLogEventsInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PutLogEventsResponse; });
/* unused harmony export UnrecognizedClientException */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return PutMetricFilterRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PutQueryDefinitionRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return PutQueryDefinitionResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return PutResourcePolicyRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return PutResourcePolicyResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return PutRetentionPolicyRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return PutSubscriptionFilterRequest; });
/* unused harmony export QueryCompileErrorLocation */
/* unused harmony export QueryCompileError */
/* unused harmony export MalformedQueryException */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return StartQueryRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return StartQueryResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return StopQueryRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return StopQueryResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TagLogGroupRequest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TestMetricFilterRequest; });
/* unused harmony export MetricFilterMatchRecord */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TestMetricFilterResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UntagLogGroupRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);

var AssociateKmsKeyRequest;
(function (AssociateKmsKeyRequest) {
    AssociateKmsKeyRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(AssociateKmsKeyRequest || (AssociateKmsKeyRequest = {}));
var InvalidParameterException;
(function (InvalidParameterException) {
    InvalidParameterException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(InvalidParameterException || (InvalidParameterException = {}));
var OperationAbortedException;
(function (OperationAbortedException) {
    OperationAbortedException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(OperationAbortedException || (OperationAbortedException = {}));
var ResourceNotFoundException;
(function (ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
var ServiceUnavailableException;
(function (ServiceUnavailableException) {
    ServiceUnavailableException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ServiceUnavailableException || (ServiceUnavailableException = {}));
var CancelExportTaskRequest;
(function (CancelExportTaskRequest) {
    CancelExportTaskRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(CancelExportTaskRequest || (CancelExportTaskRequest = {}));
var InvalidOperationException;
(function (InvalidOperationException) {
    InvalidOperationException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(InvalidOperationException || (InvalidOperationException = {}));
var CreateExportTaskRequest;
(function (CreateExportTaskRequest) {
    CreateExportTaskRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(CreateExportTaskRequest || (CreateExportTaskRequest = {}));
var CreateExportTaskResponse;
(function (CreateExportTaskResponse) {
    CreateExportTaskResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(CreateExportTaskResponse || (CreateExportTaskResponse = {}));
var LimitExceededException;
(function (LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(LimitExceededException || (LimitExceededException = {}));
var ResourceAlreadyExistsException;
(function (ResourceAlreadyExistsException) {
    ResourceAlreadyExistsException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ResourceAlreadyExistsException || (ResourceAlreadyExistsException = {}));
var CreateLogGroupRequest;
(function (CreateLogGroupRequest) {
    CreateLogGroupRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(CreateLogGroupRequest || (CreateLogGroupRequest = {}));
var CreateLogStreamRequest;
(function (CreateLogStreamRequest) {
    CreateLogStreamRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(CreateLogStreamRequest || (CreateLogStreamRequest = {}));
var DataAlreadyAcceptedException;
(function (DataAlreadyAcceptedException) {
    DataAlreadyAcceptedException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DataAlreadyAcceptedException || (DataAlreadyAcceptedException = {}));
var DeleteDestinationRequest;
(function (DeleteDestinationRequest) {
    DeleteDestinationRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DeleteDestinationRequest || (DeleteDestinationRequest = {}));
var DeleteLogGroupRequest;
(function (DeleteLogGroupRequest) {
    DeleteLogGroupRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DeleteLogGroupRequest || (DeleteLogGroupRequest = {}));
var DeleteLogStreamRequest;
(function (DeleteLogStreamRequest) {
    DeleteLogStreamRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DeleteLogStreamRequest || (DeleteLogStreamRequest = {}));
var DeleteMetricFilterRequest;
(function (DeleteMetricFilterRequest) {
    DeleteMetricFilterRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DeleteMetricFilterRequest || (DeleteMetricFilterRequest = {}));
var DeleteQueryDefinitionRequest;
(function (DeleteQueryDefinitionRequest) {
    DeleteQueryDefinitionRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DeleteQueryDefinitionRequest || (DeleteQueryDefinitionRequest = {}));
var DeleteQueryDefinitionResponse;
(function (DeleteQueryDefinitionResponse) {
    DeleteQueryDefinitionResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DeleteQueryDefinitionResponse || (DeleteQueryDefinitionResponse = {}));
var DeleteResourcePolicyRequest;
(function (DeleteResourcePolicyRequest) {
    DeleteResourcePolicyRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DeleteResourcePolicyRequest || (DeleteResourcePolicyRequest = {}));
var DeleteRetentionPolicyRequest;
(function (DeleteRetentionPolicyRequest) {
    DeleteRetentionPolicyRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DeleteRetentionPolicyRequest || (DeleteRetentionPolicyRequest = {}));
var DeleteSubscriptionFilterRequest;
(function (DeleteSubscriptionFilterRequest) {
    DeleteSubscriptionFilterRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DeleteSubscriptionFilterRequest || (DeleteSubscriptionFilterRequest = {}));
var DescribeDestinationsRequest;
(function (DescribeDestinationsRequest) {
    DescribeDestinationsRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeDestinationsRequest || (DescribeDestinationsRequest = {}));
var Destination;
(function (Destination) {
    Destination.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(Destination || (Destination = {}));
var DescribeDestinationsResponse;
(function (DescribeDestinationsResponse) {
    DescribeDestinationsResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeDestinationsResponse || (DescribeDestinationsResponse = {}));
var ExportTaskStatusCode;
(function (ExportTaskStatusCode) {
    ExportTaskStatusCode["CANCELLED"] = "CANCELLED";
    ExportTaskStatusCode["COMPLETED"] = "COMPLETED";
    ExportTaskStatusCode["FAILED"] = "FAILED";
    ExportTaskStatusCode["PENDING"] = "PENDING";
    ExportTaskStatusCode["PENDING_CANCEL"] = "PENDING_CANCEL";
    ExportTaskStatusCode["RUNNING"] = "RUNNING";
})(ExportTaskStatusCode || (ExportTaskStatusCode = {}));
var DescribeExportTasksRequest;
(function (DescribeExportTasksRequest) {
    DescribeExportTasksRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeExportTasksRequest || (DescribeExportTasksRequest = {}));
var ExportTaskExecutionInfo;
(function (ExportTaskExecutionInfo) {
    ExportTaskExecutionInfo.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ExportTaskExecutionInfo || (ExportTaskExecutionInfo = {}));
var ExportTaskStatus;
(function (ExportTaskStatus) {
    ExportTaskStatus.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ExportTaskStatus || (ExportTaskStatus = {}));
var ExportTask;
(function (ExportTask) {
    ExportTask.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ExportTask || (ExportTask = {}));
var DescribeExportTasksResponse;
(function (DescribeExportTasksResponse) {
    DescribeExportTasksResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeExportTasksResponse || (DescribeExportTasksResponse = {}));
var DescribeLogGroupsRequest;
(function (DescribeLogGroupsRequest) {
    DescribeLogGroupsRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeLogGroupsRequest || (DescribeLogGroupsRequest = {}));
var LogGroup;
(function (LogGroup) {
    LogGroup.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(LogGroup || (LogGroup = {}));
var DescribeLogGroupsResponse;
(function (DescribeLogGroupsResponse) {
    DescribeLogGroupsResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeLogGroupsResponse || (DescribeLogGroupsResponse = {}));
var OrderBy;
(function (OrderBy) {
    OrderBy["LastEventTime"] = "LastEventTime";
    OrderBy["LogStreamName"] = "LogStreamName";
})(OrderBy || (OrderBy = {}));
var DescribeLogStreamsRequest;
(function (DescribeLogStreamsRequest) {
    DescribeLogStreamsRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeLogStreamsRequest || (DescribeLogStreamsRequest = {}));
var LogStream;
(function (LogStream) {
    LogStream.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(LogStream || (LogStream = {}));
var DescribeLogStreamsResponse;
(function (DescribeLogStreamsResponse) {
    DescribeLogStreamsResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeLogStreamsResponse || (DescribeLogStreamsResponse = {}));
var DescribeMetricFiltersRequest;
(function (DescribeMetricFiltersRequest) {
    DescribeMetricFiltersRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeMetricFiltersRequest || (DescribeMetricFiltersRequest = {}));
var MetricTransformation;
(function (MetricTransformation) {
    MetricTransformation.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(MetricTransformation || (MetricTransformation = {}));
var MetricFilter;
(function (MetricFilter) {
    MetricFilter.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(MetricFilter || (MetricFilter = {}));
var DescribeMetricFiltersResponse;
(function (DescribeMetricFiltersResponse) {
    DescribeMetricFiltersResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeMetricFiltersResponse || (DescribeMetricFiltersResponse = {}));
var QueryStatus;
(function (QueryStatus) {
    QueryStatus["Cancelled"] = "Cancelled";
    QueryStatus["Complete"] = "Complete";
    QueryStatus["Failed"] = "Failed";
    QueryStatus["Running"] = "Running";
    QueryStatus["Scheduled"] = "Scheduled";
})(QueryStatus || (QueryStatus = {}));
var DescribeQueriesRequest;
(function (DescribeQueriesRequest) {
    DescribeQueriesRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeQueriesRequest || (DescribeQueriesRequest = {}));
var QueryInfo;
(function (QueryInfo) {
    QueryInfo.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(QueryInfo || (QueryInfo = {}));
var DescribeQueriesResponse;
(function (DescribeQueriesResponse) {
    DescribeQueriesResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeQueriesResponse || (DescribeQueriesResponse = {}));
var DescribeQueryDefinitionsRequest;
(function (DescribeQueryDefinitionsRequest) {
    DescribeQueryDefinitionsRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeQueryDefinitionsRequest || (DescribeQueryDefinitionsRequest = {}));
var QueryDefinition;
(function (QueryDefinition) {
    QueryDefinition.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(QueryDefinition || (QueryDefinition = {}));
var DescribeQueryDefinitionsResponse;
(function (DescribeQueryDefinitionsResponse) {
    DescribeQueryDefinitionsResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeQueryDefinitionsResponse || (DescribeQueryDefinitionsResponse = {}));
var DescribeResourcePoliciesRequest;
(function (DescribeResourcePoliciesRequest) {
    DescribeResourcePoliciesRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeResourcePoliciesRequest || (DescribeResourcePoliciesRequest = {}));
var ResourcePolicy;
(function (ResourcePolicy) {
    ResourcePolicy.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ResourcePolicy || (ResourcePolicy = {}));
var DescribeResourcePoliciesResponse;
(function (DescribeResourcePoliciesResponse) {
    DescribeResourcePoliciesResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeResourcePoliciesResponse || (DescribeResourcePoliciesResponse = {}));
var DescribeSubscriptionFiltersRequest;
(function (DescribeSubscriptionFiltersRequest) {
    DescribeSubscriptionFiltersRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeSubscriptionFiltersRequest || (DescribeSubscriptionFiltersRequest = {}));
var Distribution;
(function (Distribution) {
    Distribution["ByLogStream"] = "ByLogStream";
    Distribution["Random"] = "Random";
})(Distribution || (Distribution = {}));
var SubscriptionFilter;
(function (SubscriptionFilter) {
    SubscriptionFilter.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(SubscriptionFilter || (SubscriptionFilter = {}));
var DescribeSubscriptionFiltersResponse;
(function (DescribeSubscriptionFiltersResponse) {
    DescribeSubscriptionFiltersResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeSubscriptionFiltersResponse || (DescribeSubscriptionFiltersResponse = {}));
var DisassociateKmsKeyRequest;
(function (DisassociateKmsKeyRequest) {
    DisassociateKmsKeyRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DisassociateKmsKeyRequest || (DisassociateKmsKeyRequest = {}));
var FilteredLogEvent;
(function (FilteredLogEvent) {
    FilteredLogEvent.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(FilteredLogEvent || (FilteredLogEvent = {}));
var FilterLogEventsRequest;
(function (FilterLogEventsRequest) {
    FilterLogEventsRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(FilterLogEventsRequest || (FilterLogEventsRequest = {}));
var SearchedLogStream;
(function (SearchedLogStream) {
    SearchedLogStream.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(SearchedLogStream || (SearchedLogStream = {}));
var FilterLogEventsResponse;
(function (FilterLogEventsResponse) {
    FilterLogEventsResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(FilterLogEventsResponse || (FilterLogEventsResponse = {}));
var GetLogEventsRequest;
(function (GetLogEventsRequest) {
    GetLogEventsRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(GetLogEventsRequest || (GetLogEventsRequest = {}));
var OutputLogEvent;
(function (OutputLogEvent) {
    OutputLogEvent.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(OutputLogEvent || (OutputLogEvent = {}));
var GetLogEventsResponse;
(function (GetLogEventsResponse) {
    GetLogEventsResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(GetLogEventsResponse || (GetLogEventsResponse = {}));
var GetLogGroupFieldsRequest;
(function (GetLogGroupFieldsRequest) {
    GetLogGroupFieldsRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(GetLogGroupFieldsRequest || (GetLogGroupFieldsRequest = {}));
var LogGroupField;
(function (LogGroupField) {
    LogGroupField.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(LogGroupField || (LogGroupField = {}));
var GetLogGroupFieldsResponse;
(function (GetLogGroupFieldsResponse) {
    GetLogGroupFieldsResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(GetLogGroupFieldsResponse || (GetLogGroupFieldsResponse = {}));
var GetLogRecordRequest;
(function (GetLogRecordRequest) {
    GetLogRecordRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(GetLogRecordRequest || (GetLogRecordRequest = {}));
var GetLogRecordResponse;
(function (GetLogRecordResponse) {
    GetLogRecordResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(GetLogRecordResponse || (GetLogRecordResponse = {}));
var GetQueryResultsRequest;
(function (GetQueryResultsRequest) {
    GetQueryResultsRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(GetQueryResultsRequest || (GetQueryResultsRequest = {}));
var ResultField;
(function (ResultField) {
    ResultField.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ResultField || (ResultField = {}));
var QueryStatistics;
(function (QueryStatistics) {
    QueryStatistics.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(QueryStatistics || (QueryStatistics = {}));
var GetQueryResultsResponse;
(function (GetQueryResultsResponse) {
    GetQueryResultsResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(GetQueryResultsResponse || (GetQueryResultsResponse = {}));
var InputLogEvent;
(function (InputLogEvent) {
    InputLogEvent.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(InputLogEvent || (InputLogEvent = {}));
var InvalidSequenceTokenException;
(function (InvalidSequenceTokenException) {
    InvalidSequenceTokenException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(InvalidSequenceTokenException || (InvalidSequenceTokenException = {}));
var ListTagsLogGroupRequest;
(function (ListTagsLogGroupRequest) {
    ListTagsLogGroupRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ListTagsLogGroupRequest || (ListTagsLogGroupRequest = {}));
var ListTagsLogGroupResponse;
(function (ListTagsLogGroupResponse) {
    ListTagsLogGroupResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ListTagsLogGroupResponse || (ListTagsLogGroupResponse = {}));
var PutDestinationRequest;
(function (PutDestinationRequest) {
    PutDestinationRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(PutDestinationRequest || (PutDestinationRequest = {}));
var PutDestinationResponse;
(function (PutDestinationResponse) {
    PutDestinationResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(PutDestinationResponse || (PutDestinationResponse = {}));
var PutDestinationPolicyRequest;
(function (PutDestinationPolicyRequest) {
    PutDestinationPolicyRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(PutDestinationPolicyRequest || (PutDestinationPolicyRequest = {}));
var PutLogEventsRequest;
(function (PutLogEventsRequest) {
    PutLogEventsRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(PutLogEventsRequest || (PutLogEventsRequest = {}));
var RejectedLogEventsInfo;
(function (RejectedLogEventsInfo) {
    RejectedLogEventsInfo.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(RejectedLogEventsInfo || (RejectedLogEventsInfo = {}));
var PutLogEventsResponse;
(function (PutLogEventsResponse) {
    PutLogEventsResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(PutLogEventsResponse || (PutLogEventsResponse = {}));
var UnrecognizedClientException;
(function (UnrecognizedClientException) {
    UnrecognizedClientException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(UnrecognizedClientException || (UnrecognizedClientException = {}));
var PutMetricFilterRequest;
(function (PutMetricFilterRequest) {
    PutMetricFilterRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(PutMetricFilterRequest || (PutMetricFilterRequest = {}));
var PutQueryDefinitionRequest;
(function (PutQueryDefinitionRequest) {
    PutQueryDefinitionRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(PutQueryDefinitionRequest || (PutQueryDefinitionRequest = {}));
var PutQueryDefinitionResponse;
(function (PutQueryDefinitionResponse) {
    PutQueryDefinitionResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(PutQueryDefinitionResponse || (PutQueryDefinitionResponse = {}));
var PutResourcePolicyRequest;
(function (PutResourcePolicyRequest) {
    PutResourcePolicyRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(PutResourcePolicyRequest || (PutResourcePolicyRequest = {}));
var PutResourcePolicyResponse;
(function (PutResourcePolicyResponse) {
    PutResourcePolicyResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(PutResourcePolicyResponse || (PutResourcePolicyResponse = {}));
var PutRetentionPolicyRequest;
(function (PutRetentionPolicyRequest) {
    PutRetentionPolicyRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(PutRetentionPolicyRequest || (PutRetentionPolicyRequest = {}));
var PutSubscriptionFilterRequest;
(function (PutSubscriptionFilterRequest) {
    PutSubscriptionFilterRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(PutSubscriptionFilterRequest || (PutSubscriptionFilterRequest = {}));
var QueryCompileErrorLocation;
(function (QueryCompileErrorLocation) {
    QueryCompileErrorLocation.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(QueryCompileErrorLocation || (QueryCompileErrorLocation = {}));
var QueryCompileError;
(function (QueryCompileError) {
    QueryCompileError.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(QueryCompileError || (QueryCompileError = {}));
var MalformedQueryException;
(function (MalformedQueryException) {
    MalformedQueryException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(MalformedQueryException || (MalformedQueryException = {}));
var StartQueryRequest;
(function (StartQueryRequest) {
    StartQueryRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(StartQueryRequest || (StartQueryRequest = {}));
var StartQueryResponse;
(function (StartQueryResponse) {
    StartQueryResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(StartQueryResponse || (StartQueryResponse = {}));
var StopQueryRequest;
(function (StopQueryRequest) {
    StopQueryRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(StopQueryRequest || (StopQueryRequest = {}));
var StopQueryResponse;
(function (StopQueryResponse) {
    StopQueryResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(StopQueryResponse || (StopQueryResponse = {}));
var TagLogGroupRequest;
(function (TagLogGroupRequest) {
    TagLogGroupRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(TagLogGroupRequest || (TagLogGroupRequest = {}));
var TestMetricFilterRequest;
(function (TestMetricFilterRequest) {
    TestMetricFilterRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(TestMetricFilterRequest || (TestMetricFilterRequest = {}));
var MetricFilterMatchRecord;
(function (MetricFilterMatchRecord) {
    MetricFilterMatchRecord.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(MetricFilterMatchRecord || (MetricFilterMatchRecord = {}));
var TestMetricFilterResponse;
(function (TestMetricFilterResponse) {
    TestMetricFilterResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(TestMetricFilterResponse || (TestMetricFilterResponse = {}));
var UntagLogGroupRequest;
(function (UntagLogGroupRequest) {
    UntagLogGroupRequest.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(UntagLogGroupRequest || (UntagLogGroupRequest = {}));
//# sourceMappingURL=models_0.js.map

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return serializeAws_json1_1AssociateKmsKeyCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return serializeAws_json1_1CancelExportTaskCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return serializeAws_json1_1CreateExportTaskCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return serializeAws_json1_1CreateLogGroupCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return serializeAws_json1_1CreateLogStreamCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return serializeAws_json1_1DeleteDestinationCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return serializeAws_json1_1DeleteLogGroupCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return serializeAws_json1_1DeleteLogStreamCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return serializeAws_json1_1DeleteMetricFilterCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return serializeAws_json1_1DeleteQueryDefinitionCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return serializeAws_json1_1DeleteResourcePolicyCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return serializeAws_json1_1DeleteRetentionPolicyCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return serializeAws_json1_1DeleteSubscriptionFilterCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return serializeAws_json1_1DescribeDestinationsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return serializeAws_json1_1DescribeExportTasksCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return serializeAws_json1_1DescribeLogGroupsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return serializeAws_json1_1DescribeLogStreamsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return serializeAws_json1_1DescribeMetricFiltersCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return serializeAws_json1_1DescribeQueriesCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return serializeAws_json1_1DescribeQueryDefinitionsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return serializeAws_json1_1DescribeResourcePoliciesCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return serializeAws_json1_1DescribeSubscriptionFiltersCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return serializeAws_json1_1DisassociateKmsKeyCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return serializeAws_json1_1FilterLogEventsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return serializeAws_json1_1GetLogEventsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return serializeAws_json1_1GetLogGroupFieldsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return serializeAws_json1_1GetLogRecordCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return serializeAws_json1_1GetQueryResultsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return serializeAws_json1_1ListTagsLogGroupCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return serializeAws_json1_1PutDestinationCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return serializeAws_json1_1PutDestinationPolicyCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return serializeAws_json1_1PutLogEventsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return serializeAws_json1_1PutMetricFilterCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return serializeAws_json1_1PutQueryDefinitionCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return serializeAws_json1_1PutResourcePolicyCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return serializeAws_json1_1PutRetentionPolicyCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return serializeAws_json1_1PutSubscriptionFilterCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return serializeAws_json1_1StartQueryCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return serializeAws_json1_1StopQueryCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return serializeAws_json1_1TagLogGroupCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return serializeAws_json1_1TestMetricFilterCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serializeAws_json1_1UntagLogGroupCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return deserializeAws_json1_1AssociateKmsKeyCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return deserializeAws_json1_1CancelExportTaskCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return deserializeAws_json1_1CreateExportTaskCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return deserializeAws_json1_1CreateLogGroupCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return deserializeAws_json1_1CreateLogStreamCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return deserializeAws_json1_1DeleteDestinationCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return deserializeAws_json1_1DeleteLogGroupCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return deserializeAws_json1_1DeleteLogStreamCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return deserializeAws_json1_1DeleteMetricFilterCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return deserializeAws_json1_1DeleteQueryDefinitionCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return deserializeAws_json1_1DeleteResourcePolicyCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return deserializeAws_json1_1DeleteRetentionPolicyCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return deserializeAws_json1_1DeleteSubscriptionFilterCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return deserializeAws_json1_1DescribeDestinationsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return deserializeAws_json1_1DescribeExportTasksCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return deserializeAws_json1_1DescribeLogGroupsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return deserializeAws_json1_1DescribeLogStreamsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return deserializeAws_json1_1DescribeMetricFiltersCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return deserializeAws_json1_1DescribeQueriesCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return deserializeAws_json1_1DescribeQueryDefinitionsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return deserializeAws_json1_1DescribeResourcePoliciesCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return deserializeAws_json1_1DescribeSubscriptionFiltersCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return deserializeAws_json1_1DisassociateKmsKeyCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return deserializeAws_json1_1FilterLogEventsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return deserializeAws_json1_1GetLogEventsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return deserializeAws_json1_1GetLogGroupFieldsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return deserializeAws_json1_1GetLogRecordCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return deserializeAws_json1_1GetQueryResultsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return deserializeAws_json1_1ListTagsLogGroupCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return deserializeAws_json1_1PutDestinationCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return deserializeAws_json1_1PutDestinationPolicyCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return deserializeAws_json1_1PutLogEventsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return deserializeAws_json1_1PutMetricFilterCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return deserializeAws_json1_1PutQueryDefinitionCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return deserializeAws_json1_1PutResourcePolicyCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return deserializeAws_json1_1PutRetentionPolicyCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return deserializeAws_json1_1PutSubscriptionFilterCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deserializeAws_json1_1StartQueryCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deserializeAws_json1_1StopQueryCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return deserializeAws_json1_1TagLogGroupCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deserializeAws_json1_1TestMetricFilterCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deserializeAws_json1_1UntagLogGroupCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__ = __webpack_require__(171);


var serializeAws_json1_1AssociateKmsKeyCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.AssociateKmsKey",
        };
        body = JSON.stringify(serializeAws_json1_1AssociateKmsKeyRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1CancelExportTaskCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.CancelExportTask",
        };
        body = JSON.stringify(serializeAws_json1_1CancelExportTaskRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1CreateExportTaskCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.CreateExportTask",
        };
        body = JSON.stringify(serializeAws_json1_1CreateExportTaskRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1CreateLogGroupCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.CreateLogGroup",
        };
        body = JSON.stringify(serializeAws_json1_1CreateLogGroupRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1CreateLogStreamCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.CreateLogStream",
        };
        body = JSON.stringify(serializeAws_json1_1CreateLogStreamRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DeleteDestinationCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.DeleteDestination",
        };
        body = JSON.stringify(serializeAws_json1_1DeleteDestinationRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DeleteLogGroupCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.DeleteLogGroup",
        };
        body = JSON.stringify(serializeAws_json1_1DeleteLogGroupRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DeleteLogStreamCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.DeleteLogStream",
        };
        body = JSON.stringify(serializeAws_json1_1DeleteLogStreamRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DeleteMetricFilterCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.DeleteMetricFilter",
        };
        body = JSON.stringify(serializeAws_json1_1DeleteMetricFilterRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DeleteQueryDefinitionCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.DeleteQueryDefinition",
        };
        body = JSON.stringify(serializeAws_json1_1DeleteQueryDefinitionRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DeleteResourcePolicyCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.DeleteResourcePolicy",
        };
        body = JSON.stringify(serializeAws_json1_1DeleteResourcePolicyRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DeleteRetentionPolicyCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.DeleteRetentionPolicy",
        };
        body = JSON.stringify(serializeAws_json1_1DeleteRetentionPolicyRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DeleteSubscriptionFilterCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.DeleteSubscriptionFilter",
        };
        body = JSON.stringify(serializeAws_json1_1DeleteSubscriptionFilterRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DescribeDestinationsCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.DescribeDestinations",
        };
        body = JSON.stringify(serializeAws_json1_1DescribeDestinationsRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DescribeExportTasksCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.DescribeExportTasks",
        };
        body = JSON.stringify(serializeAws_json1_1DescribeExportTasksRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DescribeLogGroupsCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.DescribeLogGroups",
        };
        body = JSON.stringify(serializeAws_json1_1DescribeLogGroupsRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DescribeLogStreamsCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.DescribeLogStreams",
        };
        body = JSON.stringify(serializeAws_json1_1DescribeLogStreamsRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DescribeMetricFiltersCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.DescribeMetricFilters",
        };
        body = JSON.stringify(serializeAws_json1_1DescribeMetricFiltersRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DescribeQueriesCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.DescribeQueries",
        };
        body = JSON.stringify(serializeAws_json1_1DescribeQueriesRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DescribeQueryDefinitionsCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.DescribeQueryDefinitions",
        };
        body = JSON.stringify(serializeAws_json1_1DescribeQueryDefinitionsRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DescribeResourcePoliciesCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.DescribeResourcePolicies",
        };
        body = JSON.stringify(serializeAws_json1_1DescribeResourcePoliciesRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DescribeSubscriptionFiltersCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.DescribeSubscriptionFilters",
        };
        body = JSON.stringify(serializeAws_json1_1DescribeSubscriptionFiltersRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DisassociateKmsKeyCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.DisassociateKmsKey",
        };
        body = JSON.stringify(serializeAws_json1_1DisassociateKmsKeyRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1FilterLogEventsCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.FilterLogEvents",
        };
        body = JSON.stringify(serializeAws_json1_1FilterLogEventsRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1GetLogEventsCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.GetLogEvents",
        };
        body = JSON.stringify(serializeAws_json1_1GetLogEventsRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1GetLogGroupFieldsCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.GetLogGroupFields",
        };
        body = JSON.stringify(serializeAws_json1_1GetLogGroupFieldsRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1GetLogRecordCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.GetLogRecord",
        };
        body = JSON.stringify(serializeAws_json1_1GetLogRecordRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1GetQueryResultsCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.GetQueryResults",
        };
        body = JSON.stringify(serializeAws_json1_1GetQueryResultsRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1ListTagsLogGroupCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.ListTagsLogGroup",
        };
        body = JSON.stringify(serializeAws_json1_1ListTagsLogGroupRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1PutDestinationCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.PutDestination",
        };
        body = JSON.stringify(serializeAws_json1_1PutDestinationRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1PutDestinationPolicyCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.PutDestinationPolicy",
        };
        body = JSON.stringify(serializeAws_json1_1PutDestinationPolicyRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1PutLogEventsCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.PutLogEvents",
        };
        body = JSON.stringify(serializeAws_json1_1PutLogEventsRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1PutMetricFilterCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.PutMetricFilter",
        };
        body = JSON.stringify(serializeAws_json1_1PutMetricFilterRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1PutQueryDefinitionCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.PutQueryDefinition",
        };
        body = JSON.stringify(serializeAws_json1_1PutQueryDefinitionRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1PutResourcePolicyCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.PutResourcePolicy",
        };
        body = JSON.stringify(serializeAws_json1_1PutResourcePolicyRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1PutRetentionPolicyCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.PutRetentionPolicy",
        };
        body = JSON.stringify(serializeAws_json1_1PutRetentionPolicyRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1PutSubscriptionFilterCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.PutSubscriptionFilter",
        };
        body = JSON.stringify(serializeAws_json1_1PutSubscriptionFilterRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1StartQueryCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.StartQuery",
        };
        body = JSON.stringify(serializeAws_json1_1StartQueryRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1StopQueryCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.StopQuery",
        };
        body = JSON.stringify(serializeAws_json1_1StopQueryRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1TagLogGroupCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.TagLogGroup",
        };
        body = JSON.stringify(serializeAws_json1_1TagLogGroupRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1TestMetricFilterCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.TestMetricFilter",
        };
        body = JSON.stringify(serializeAws_json1_1TestMetricFilterRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1UntagLogGroupCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "Logs_20140328.UntagLogGroup",
        };
        body = JSON.stringify(serializeAws_json1_1UntagLogGroupRequest(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var deserializeAws_json1_1AssociateKmsKeyCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1AssociateKmsKeyCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1AssociateKmsKeyCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
    var _g;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_h) {
        switch (_h.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _g = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_g.body = _h.sent(), _g)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "OperationAbortedException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#OperationAbortedException": return [3 /*break*/, 4];
                    case "ResourceNotFoundException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 6];
                    case "ServiceUnavailableException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 8];
                }
                return [3 /*break*/, 10];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 10:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _h.label = 11;
            case 11:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1CancelExportTaskCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1CancelExportTaskCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1CancelExportTaskCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
    var _g;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_h) {
        switch (_h.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _g = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_g.body = _h.sent(), _g)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidOperationException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidOperationException": return [3 /*break*/, 2];
                    case "InvalidParameterException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 4];
                    case "ResourceNotFoundException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 6];
                    case "ServiceUnavailableException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 8];
                }
                return [3 /*break*/, 10];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidOperationExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 10:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _h.label = 11;
            case 11:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1CreateExportTaskCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1CreateExportTaskCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1CreateExportTaskResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1CreateExportTaskCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
    var _j;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _j = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_j.body = _k.sent(), _j)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "LimitExceededException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#LimitExceededException": return [3 /*break*/, 4];
                    case "OperationAbortedException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#OperationAbortedException": return [3 /*break*/, 6];
                    case "ResourceAlreadyExistsException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ResourceAlreadyExistsException": return [3 /*break*/, 8];
                    case "ResourceNotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 10];
                    case "ServiceUnavailableException": return [3 /*break*/, 12];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 13:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1CreateLogGroupCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1CreateLogGroupCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1CreateLogGroupCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
    var _h;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_j) {
        switch (_j.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _h = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_h.body = _j.sent(), _h)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "LimitExceededException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#LimitExceededException": return [3 /*break*/, 4];
                    case "OperationAbortedException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#OperationAbortedException": return [3 /*break*/, 6];
                    case "ResourceAlreadyExistsException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ResourceAlreadyExistsException": return [3 /*break*/, 8];
                    case "ServiceUnavailableException": return [3 /*break*/, 10];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 10];
                }
                return [3 /*break*/, 12];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 12:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _j.label = 13;
            case 13:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1CreateLogStreamCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1CreateLogStreamCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1CreateLogStreamCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
    var _g;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_h) {
        switch (_h.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _g = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_g.body = _h.sent(), _g)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ResourceAlreadyExistsException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ResourceAlreadyExistsException": return [3 /*break*/, 4];
                    case "ResourceNotFoundException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 6];
                    case "ServiceUnavailableException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 8];
                }
                return [3 /*break*/, 10];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 10:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _h.label = 11;
            case 11:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DeleteDestinationCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DeleteDestinationCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DeleteDestinationCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
    var _g;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_h) {
        switch (_h.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _g = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_g.body = _h.sent(), _g)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "OperationAbortedException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#OperationAbortedException": return [3 /*break*/, 4];
                    case "ResourceNotFoundException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 6];
                    case "ServiceUnavailableException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 8];
                }
                return [3 /*break*/, 10];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 10:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _h.label = 11;
            case 11:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DeleteLogGroupCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DeleteLogGroupCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DeleteLogGroupCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
    var _g;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_h) {
        switch (_h.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _g = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_g.body = _h.sent(), _g)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "OperationAbortedException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#OperationAbortedException": return [3 /*break*/, 4];
                    case "ResourceNotFoundException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 6];
                    case "ServiceUnavailableException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 8];
                }
                return [3 /*break*/, 10];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 10:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _h.label = 11;
            case 11:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DeleteLogStreamCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DeleteLogStreamCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DeleteLogStreamCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
    var _g;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_h) {
        switch (_h.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _g = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_g.body = _h.sent(), _g)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "OperationAbortedException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#OperationAbortedException": return [3 /*break*/, 4];
                    case "ResourceNotFoundException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 6];
                    case "ServiceUnavailableException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 8];
                }
                return [3 /*break*/, 10];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 10:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _h.label = 11;
            case 11:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DeleteMetricFilterCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DeleteMetricFilterCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DeleteMetricFilterCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
    var _g;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_h) {
        switch (_h.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _g = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_g.body = _h.sent(), _g)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "OperationAbortedException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#OperationAbortedException": return [3 /*break*/, 4];
                    case "ResourceNotFoundException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 6];
                    case "ServiceUnavailableException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 8];
                }
                return [3 /*break*/, 10];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 10:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _h.label = 11;
            case 11:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DeleteQueryDefinitionCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DeleteQueryDefinitionCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1DeleteQueryDefinitionResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DeleteQueryDefinitionCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
    var _f;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_g) {
        switch (_g.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _f = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_f.body = _g.sent(), _f)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ResourceNotFoundException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 4];
                    case "ServiceUnavailableException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 6];
                }
                return [3 /*break*/, 8];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 8:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _g.label = 9;
            case 9:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DeleteResourcePolicyCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DeleteResourcePolicyCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DeleteResourcePolicyCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
    var _f;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_g) {
        switch (_g.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _f = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_f.body = _g.sent(), _f)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ResourceNotFoundException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 4];
                    case "ServiceUnavailableException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 6];
                }
                return [3 /*break*/, 8];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 8:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _g.label = 9;
            case 9:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DeleteRetentionPolicyCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DeleteRetentionPolicyCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DeleteRetentionPolicyCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
    var _g;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_h) {
        switch (_h.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _g = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_g.body = _h.sent(), _g)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "OperationAbortedException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#OperationAbortedException": return [3 /*break*/, 4];
                    case "ResourceNotFoundException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 6];
                    case "ServiceUnavailableException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 8];
                }
                return [3 /*break*/, 10];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 10:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _h.label = 11;
            case 11:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DeleteSubscriptionFilterCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DeleteSubscriptionFilterCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DeleteSubscriptionFilterCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
    var _g;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_h) {
        switch (_h.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _g = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_g.body = _h.sent(), _g)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "OperationAbortedException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#OperationAbortedException": return [3 /*break*/, 4];
                    case "ResourceNotFoundException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 6];
                    case "ServiceUnavailableException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 8];
                }
                return [3 /*break*/, 10];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 10:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _h.label = 11;
            case 11:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DescribeDestinationsCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DescribeDestinationsCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1DescribeDestinationsResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DescribeDestinationsCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
    var _e;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_f) {
        switch (_f.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _e = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_e.body = _f.sent(), _e)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ServiceUnavailableException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 4];
                }
                return [3 /*break*/, 6];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_f.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 7];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_f.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 7];
            case 6:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _f.label = 7;
            case 7:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DescribeExportTasksCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DescribeExportTasksCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1DescribeExportTasksResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DescribeExportTasksCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
    var _e;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_f) {
        switch (_f.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _e = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_e.body = _f.sent(), _e)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ServiceUnavailableException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 4];
                }
                return [3 /*break*/, 6];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_f.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 7];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_f.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 7];
            case 6:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _f.label = 7;
            case 7:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DescribeLogGroupsCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DescribeLogGroupsCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1DescribeLogGroupsResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DescribeLogGroupsCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
    var _e;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_f) {
        switch (_f.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _e = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_e.body = _f.sent(), _e)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ServiceUnavailableException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 4];
                }
                return [3 /*break*/, 6];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_f.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 7];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_f.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 7];
            case 6:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _f.label = 7;
            case 7:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DescribeLogStreamsCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DescribeLogStreamsCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1DescribeLogStreamsResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DescribeLogStreamsCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
    var _f;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_g) {
        switch (_g.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _f = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_f.body = _g.sent(), _f)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ResourceNotFoundException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 4];
                    case "ServiceUnavailableException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 6];
                }
                return [3 /*break*/, 8];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 8:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _g.label = 9;
            case 9:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DescribeMetricFiltersCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DescribeMetricFiltersCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1DescribeMetricFiltersResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DescribeMetricFiltersCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
    var _f;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_g) {
        switch (_g.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _f = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_f.body = _g.sent(), _f)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ResourceNotFoundException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 4];
                    case "ServiceUnavailableException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 6];
                }
                return [3 /*break*/, 8];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 8:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _g.label = 9;
            case 9:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DescribeQueriesCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DescribeQueriesCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1DescribeQueriesResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DescribeQueriesCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
    var _f;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_g) {
        switch (_g.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _f = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_f.body = _g.sent(), _f)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ResourceNotFoundException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 4];
                    case "ServiceUnavailableException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 6];
                }
                return [3 /*break*/, 8];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 8:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _g.label = 9;
            case 9:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DescribeQueryDefinitionsCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DescribeQueryDefinitionsCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1DescribeQueryDefinitionsResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DescribeQueryDefinitionsCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
    var _e;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_f) {
        switch (_f.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _e = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_e.body = _f.sent(), _e)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ServiceUnavailableException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 4];
                }
                return [3 /*break*/, 6];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_f.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 7];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_f.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 7];
            case 6:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _f.label = 7;
            case 7:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DescribeResourcePoliciesCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DescribeResourcePoliciesCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1DescribeResourcePoliciesResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DescribeResourcePoliciesCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
    var _e;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_f) {
        switch (_f.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _e = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_e.body = _f.sent(), _e)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ServiceUnavailableException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 4];
                }
                return [3 /*break*/, 6];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_f.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 7];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_f.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 7];
            case 6:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _f.label = 7;
            case 7:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DescribeSubscriptionFiltersCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DescribeSubscriptionFiltersCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1DescribeSubscriptionFiltersResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DescribeSubscriptionFiltersCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
    var _f;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_g) {
        switch (_g.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _f = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_f.body = _g.sent(), _f)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ResourceNotFoundException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 4];
                    case "ServiceUnavailableException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 6];
                }
                return [3 /*break*/, 8];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 8:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _g.label = 9;
            case 9:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DisassociateKmsKeyCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DisassociateKmsKeyCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DisassociateKmsKeyCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
    var _g;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_h) {
        switch (_h.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _g = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_g.body = _h.sent(), _g)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "OperationAbortedException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#OperationAbortedException": return [3 /*break*/, 4];
                    case "ResourceNotFoundException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 6];
                    case "ServiceUnavailableException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 8];
                }
                return [3 /*break*/, 10];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 10:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _h.label = 11;
            case 11:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1FilterLogEventsCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1FilterLogEventsCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1FilterLogEventsResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1FilterLogEventsCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
    var _f;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_g) {
        switch (_g.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _f = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_f.body = _g.sent(), _f)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ResourceNotFoundException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 4];
                    case "ServiceUnavailableException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 6];
                }
                return [3 /*break*/, 8];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 8:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _g.label = 9;
            case 9:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1GetLogEventsCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1GetLogEventsCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1GetLogEventsResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1GetLogEventsCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
    var _f;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_g) {
        switch (_g.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _f = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_f.body = _g.sent(), _f)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ResourceNotFoundException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 4];
                    case "ServiceUnavailableException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 6];
                }
                return [3 /*break*/, 8];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 8:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _g.label = 9;
            case 9:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1GetLogGroupFieldsCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1GetLogGroupFieldsCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1GetLogGroupFieldsResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1GetLogGroupFieldsCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
    var _g;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_h) {
        switch (_h.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _g = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_g.body = _h.sent(), _g)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "LimitExceededException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#LimitExceededException": return [3 /*break*/, 4];
                    case "ResourceNotFoundException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 6];
                    case "ServiceUnavailableException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 8];
                }
                return [3 /*break*/, 10];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 10:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _h.label = 11;
            case 11:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1GetLogRecordCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1GetLogRecordCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1GetLogRecordResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1GetLogRecordCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
    var _g;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_h) {
        switch (_h.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _g = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_g.body = _h.sent(), _g)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "LimitExceededException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#LimitExceededException": return [3 /*break*/, 4];
                    case "ResourceNotFoundException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 6];
                    case "ServiceUnavailableException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 8];
                }
                return [3 /*break*/, 10];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 10:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _h.label = 11;
            case 11:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1GetQueryResultsCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1GetQueryResultsCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1GetQueryResultsResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1GetQueryResultsCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
    var _f;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_g) {
        switch (_g.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _f = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_f.body = _g.sent(), _f)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ResourceNotFoundException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 4];
                    case "ServiceUnavailableException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 6];
                }
                return [3 /*break*/, 8];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 8:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _g.label = 9;
            case 9:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1ListTagsLogGroupCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1ListTagsLogGroupCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1ListTagsLogGroupResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1ListTagsLogGroupCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
    var _e;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_f) {
        switch (_f.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _e = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_e.body = _f.sent(), _e)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ResourceNotFoundException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 2];
                    case "ServiceUnavailableException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 4];
                }
                return [3 /*break*/, 6];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_f.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 7];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_f.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 7];
            case 6:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _f.label = 7;
            case 7:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1PutDestinationCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1PutDestinationCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1PutDestinationResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1PutDestinationCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
    var _f;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_g) {
        switch (_g.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _f = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_f.body = _g.sent(), _f)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "OperationAbortedException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#OperationAbortedException": return [3 /*break*/, 4];
                    case "ServiceUnavailableException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 6];
                }
                return [3 /*break*/, 8];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 8:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _g.label = 9;
            case 9:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1PutDestinationPolicyCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1PutDestinationPolicyCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1PutDestinationPolicyCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
    var _f;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_g) {
        switch (_g.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _f = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_f.body = _g.sent(), _f)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "OperationAbortedException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#OperationAbortedException": return [3 /*break*/, 4];
                    case "ServiceUnavailableException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 6];
                }
                return [3 /*break*/, 8];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 8:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _g.label = 9;
            case 9:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1PutLogEventsCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1PutLogEventsCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1PutLogEventsResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1PutLogEventsCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
    var _j;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _j = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_j.body = _k.sent(), _j)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "DataAlreadyAcceptedException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#DataAlreadyAcceptedException": return [3 /*break*/, 2];
                    case "InvalidParameterException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 4];
                    case "InvalidSequenceTokenException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#InvalidSequenceTokenException": return [3 /*break*/, 6];
                    case "ResourceNotFoundException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 8];
                    case "ServiceUnavailableException": return [3 /*break*/, 10];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 10];
                    case "UnrecognizedClientException": return [3 /*break*/, 12];
                    case "com.amazonaws.cloudwatchlogs#UnrecognizedClientException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1DataAlreadyAcceptedExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidSequenceTokenExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_json1_1UnrecognizedClientExceptionResponse(parsedOutput, context)];
            case 13:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1PutMetricFilterCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1PutMetricFilterCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1PutMetricFilterCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
    var _h;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_j) {
        switch (_j.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _h = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_h.body = _j.sent(), _h)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "LimitExceededException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#LimitExceededException": return [3 /*break*/, 4];
                    case "OperationAbortedException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#OperationAbortedException": return [3 /*break*/, 6];
                    case "ResourceNotFoundException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 8];
                    case "ServiceUnavailableException": return [3 /*break*/, 10];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 10];
                }
                return [3 /*break*/, 12];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 12:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _j.label = 13;
            case 13:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1PutQueryDefinitionCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1PutQueryDefinitionCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1PutQueryDefinitionResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1PutQueryDefinitionCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
    var _f;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_g) {
        switch (_g.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _f = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_f.body = _g.sent(), _f)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ResourceNotFoundException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 4];
                    case "ServiceUnavailableException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 6];
                }
                return [3 /*break*/, 8];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 8:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _g.label = 9;
            case 9:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1PutResourcePolicyCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1PutResourcePolicyCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1PutResourcePolicyResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1PutResourcePolicyCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
    var _f;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_g) {
        switch (_g.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _f = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_f.body = _g.sent(), _f)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "LimitExceededException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#LimitExceededException": return [3 /*break*/, 4];
                    case "ServiceUnavailableException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 6];
                }
                return [3 /*break*/, 8];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 8:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _g.label = 9;
            case 9:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1PutRetentionPolicyCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1PutRetentionPolicyCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1PutRetentionPolicyCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, parsedBody, message;
    var _g;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_h) {
        switch (_h.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _g = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_g.body = _h.sent(), _g)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "OperationAbortedException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#OperationAbortedException": return [3 /*break*/, 4];
                    case "ResourceNotFoundException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 6];
                    case "ServiceUnavailableException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 8];
                }
                return [3 /*break*/, 10];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_h.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 11];
            case 10:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _h.label = 11;
            case 11:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1PutSubscriptionFilterCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1PutSubscriptionFilterCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1PutSubscriptionFilterCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
    var _h;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_j) {
        switch (_j.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _h = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_h.body = _j.sent(), _h)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "LimitExceededException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#LimitExceededException": return [3 /*break*/, 4];
                    case "OperationAbortedException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#OperationAbortedException": return [3 /*break*/, 6];
                    case "ResourceNotFoundException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 8];
                    case "ServiceUnavailableException": return [3 /*break*/, 10];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 10];
                }
                return [3 /*break*/, 12];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1OperationAbortedExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 12:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _j.label = 13;
            case 13:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1StartQueryCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1StartQueryCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1StartQueryResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1StartQueryCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
    var _h;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_j) {
        switch (_j.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _h = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_h.body = _j.sent(), _h)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "LimitExceededException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#LimitExceededException": return [3 /*break*/, 4];
                    case "MalformedQueryException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#MalformedQueryException": return [3 /*break*/, 6];
                    case "ResourceNotFoundException": return [3 /*break*/, 8];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 8];
                    case "ServiceUnavailableException": return [3 /*break*/, 10];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 10];
                }
                return [3 /*break*/, 12];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1MalformedQueryExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 12:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _j.label = 13;
            case 13:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1StopQueryCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1StopQueryCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1StopQueryResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1StopQueryCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
    var _f;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_g) {
        switch (_g.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _f = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_f.body = _g.sent(), _f)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ResourceNotFoundException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 4];
                    case "ServiceUnavailableException": return [3 /*break*/, 6];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 6];
                }
                return [3 /*break*/, 8];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 8:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _g.label = 9;
            case 9:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1TagLogGroupCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1TagLogGroupCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1TagLogGroupCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
    var _e;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_f) {
        switch (_f.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _e = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_e.body = _f.sent(), _e)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ResourceNotFoundException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 4];
                }
                return [3 /*break*/, 6];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_f.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 7];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_f.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 7];
            case 6:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _f.label = 7;
            case 7:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1TestMetricFilterCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1TestMetricFilterCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1TestMetricFilterResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1TestMetricFilterCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, parsedBody, message;
    var _e;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_f) {
        switch (_f.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _e = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_e.body = _f.sent(), _e)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InvalidParameterException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#InvalidParameterException": return [3 /*break*/, 2];
                    case "ServiceUnavailableException": return [3 /*break*/, 4];
                    case "com.amazonaws.cloudwatchlogs#ServiceUnavailableException": return [3 /*break*/, 4];
                }
                return [3 /*break*/, 6];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_f.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 7];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ServiceUnavailableExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_f.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 7];
            case 6:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _f.label = 7;
            case 7:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1UntagLogGroupCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1UntagLogGroupCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1UntagLogGroupCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, parsedBody, message;
    var _d;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_e) {
        switch (_e.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _d = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_d.body = _e.sent(), _d)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ResourceNotFoundException": return [3 /*break*/, 2];
                    case "com.amazonaws.cloudwatchlogs#ResourceNotFoundException": return [3 /*break*/, 2];
                }
                return [3 /*break*/, 4];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_e.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 5];
            case 4:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _e.label = 5;
            case 5:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DataAlreadyAcceptedExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1DataAlreadyAcceptedException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "DataAlreadyAcceptedException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1InvalidOperationExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1InvalidOperationException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "InvalidOperationException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1InvalidParameterExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1InvalidParameterException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "InvalidParameterException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1InvalidSequenceTokenExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1InvalidSequenceTokenException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "InvalidSequenceTokenException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1LimitExceededExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1LimitExceededException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "LimitExceededException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1MalformedQueryExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1MalformedQueryException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "MalformedQueryException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1OperationAbortedExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1OperationAbortedException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "OperationAbortedException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1ResourceAlreadyExistsExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1ResourceAlreadyExistsException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "ResourceAlreadyExistsException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1ResourceNotFoundExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1ResourceNotFoundException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "ResourceNotFoundException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1ServiceUnavailableExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1ServiceUnavailableException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "ServiceUnavailableException", $fault: "server", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1UnrecognizedClientExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1UnrecognizedClientException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "UnrecognizedClientException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var serializeAws_json1_1AssociateKmsKeyRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.kmsKeyId !== undefined && input.kmsKeyId !== null && { kmsKeyId: input.kmsKeyId })), (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName }));
};
var serializeAws_json1_1CancelExportTaskRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.taskId !== undefined && input.taskId !== null && { taskId: input.taskId }));
};
var serializeAws_json1_1CreateExportTaskRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.destination !== undefined && input.destination !== null && { destination: input.destination })), (input.destinationPrefix !== undefined &&
        input.destinationPrefix !== null && { destinationPrefix: input.destinationPrefix })), (input.from !== undefined && input.from !== null && { from: input.from })), (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.logStreamNamePrefix !== undefined &&
        input.logStreamNamePrefix !== null && { logStreamNamePrefix: input.logStreamNamePrefix })), (input.taskName !== undefined && input.taskName !== null && { taskName: input.taskName })), (input.to !== undefined && input.to !== null && { to: input.to }));
};
var serializeAws_json1_1CreateLogGroupRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.kmsKeyId !== undefined && input.kmsKeyId !== null && { kmsKeyId: input.kmsKeyId })), (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.tags !== undefined && input.tags !== null && { tags: serializeAws_json1_1Tags(input.tags, context) }));
};
var serializeAws_json1_1CreateLogStreamRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.logStreamName !== undefined && input.logStreamName !== null && { logStreamName: input.logStreamName }));
};
var serializeAws_json1_1DeleteDestinationRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.destinationName !== undefined &&
        input.destinationName !== null && { destinationName: input.destinationName }));
};
var serializeAws_json1_1DeleteLogGroupRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName }));
};
var serializeAws_json1_1DeleteLogStreamRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.logStreamName !== undefined && input.logStreamName !== null && { logStreamName: input.logStreamName }));
};
var serializeAws_json1_1DeleteMetricFilterRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.filterName !== undefined && input.filterName !== null && { filterName: input.filterName })), (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName }));
};
var serializeAws_json1_1DeleteQueryDefinitionRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.queryDefinitionId !== undefined &&
        input.queryDefinitionId !== null && { queryDefinitionId: input.queryDefinitionId }));
};
var serializeAws_json1_1DeleteResourcePolicyRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.policyName !== undefined && input.policyName !== null && { policyName: input.policyName }));
};
var serializeAws_json1_1DeleteRetentionPolicyRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName }));
};
var serializeAws_json1_1DeleteSubscriptionFilterRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.filterName !== undefined && input.filterName !== null && { filterName: input.filterName })), (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName }));
};
var serializeAws_json1_1DescribeDestinationsRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.DestinationNamePrefix !== undefined &&
        input.DestinationNamePrefix !== null && { DestinationNamePrefix: input.DestinationNamePrefix })), (input.limit !== undefined && input.limit !== null && { limit: input.limit })), (input.nextToken !== undefined && input.nextToken !== null && { nextToken: input.nextToken }));
};
var serializeAws_json1_1DescribeExportTasksRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.limit !== undefined && input.limit !== null && { limit: input.limit })), (input.nextToken !== undefined && input.nextToken !== null && { nextToken: input.nextToken })), (input.statusCode !== undefined && input.statusCode !== null && { statusCode: input.statusCode })), (input.taskId !== undefined && input.taskId !== null && { taskId: input.taskId }));
};
var serializeAws_json1_1DescribeLogGroupsRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.limit !== undefined && input.limit !== null && { limit: input.limit })), (input.logGroupNamePrefix !== undefined &&
        input.logGroupNamePrefix !== null && { logGroupNamePrefix: input.logGroupNamePrefix })), (input.nextToken !== undefined && input.nextToken !== null && { nextToken: input.nextToken }));
};
var serializeAws_json1_1DescribeLogStreamsRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.descending !== undefined && input.descending !== null && { descending: input.descending })), (input.limit !== undefined && input.limit !== null && { limit: input.limit })), (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.logStreamNamePrefix !== undefined &&
        input.logStreamNamePrefix !== null && { logStreamNamePrefix: input.logStreamNamePrefix })), (input.nextToken !== undefined && input.nextToken !== null && { nextToken: input.nextToken })), (input.orderBy !== undefined && input.orderBy !== null && { orderBy: input.orderBy }));
};
var serializeAws_json1_1DescribeMetricFiltersRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.filterNamePrefix !== undefined &&
        input.filterNamePrefix !== null && { filterNamePrefix: input.filterNamePrefix })), (input.limit !== undefined && input.limit !== null && { limit: input.limit })), (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.metricName !== undefined && input.metricName !== null && { metricName: input.metricName })), (input.metricNamespace !== undefined &&
        input.metricNamespace !== null && { metricNamespace: input.metricNamespace })), (input.nextToken !== undefined && input.nextToken !== null && { nextToken: input.nextToken }));
};
var serializeAws_json1_1DescribeQueriesRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.maxResults !== undefined && input.maxResults !== null && { maxResults: input.maxResults })), (input.nextToken !== undefined && input.nextToken !== null && { nextToken: input.nextToken })), (input.status !== undefined && input.status !== null && { status: input.status }));
};
var serializeAws_json1_1DescribeQueryDefinitionsRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.maxResults !== undefined && input.maxResults !== null && { maxResults: input.maxResults })), (input.nextToken !== undefined && input.nextToken !== null && { nextToken: input.nextToken })), (input.queryDefinitionNamePrefix !== undefined &&
        input.queryDefinitionNamePrefix !== null && { queryDefinitionNamePrefix: input.queryDefinitionNamePrefix }));
};
var serializeAws_json1_1DescribeResourcePoliciesRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.limit !== undefined && input.limit !== null && { limit: input.limit })), (input.nextToken !== undefined && input.nextToken !== null && { nextToken: input.nextToken }));
};
var serializeAws_json1_1DescribeSubscriptionFiltersRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.filterNamePrefix !== undefined &&
        input.filterNamePrefix !== null && { filterNamePrefix: input.filterNamePrefix })), (input.limit !== undefined && input.limit !== null && { limit: input.limit })), (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.nextToken !== undefined && input.nextToken !== null && { nextToken: input.nextToken }));
};
var serializeAws_json1_1DisassociateKmsKeyRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName }));
};
var serializeAws_json1_1FilterLogEventsRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.endTime !== undefined && input.endTime !== null && { endTime: input.endTime })), (input.filterPattern !== undefined && input.filterPattern !== null && { filterPattern: input.filterPattern })), (input.interleaved !== undefined && input.interleaved !== null && { interleaved: input.interleaved })), (input.limit !== undefined && input.limit !== null && { limit: input.limit })), (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.logStreamNamePrefix !== undefined &&
        input.logStreamNamePrefix !== null && { logStreamNamePrefix: input.logStreamNamePrefix })), (input.logStreamNames !== undefined &&
        input.logStreamNames !== null && {
        logStreamNames: serializeAws_json1_1InputLogStreamNames(input.logStreamNames, context),
    })), (input.nextToken !== undefined && input.nextToken !== null && { nextToken: input.nextToken })), (input.startTime !== undefined && input.startTime !== null && { startTime: input.startTime }));
};
var serializeAws_json1_1GetLogEventsRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.endTime !== undefined && input.endTime !== null && { endTime: input.endTime })), (input.limit !== undefined && input.limit !== null && { limit: input.limit })), (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.logStreamName !== undefined && input.logStreamName !== null && { logStreamName: input.logStreamName })), (input.nextToken !== undefined && input.nextToken !== null && { nextToken: input.nextToken })), (input.startFromHead !== undefined && input.startFromHead !== null && { startFromHead: input.startFromHead })), (input.startTime !== undefined && input.startTime !== null && { startTime: input.startTime }));
};
var serializeAws_json1_1GetLogGroupFieldsRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.time !== undefined && input.time !== null && { time: input.time }));
};
var serializeAws_json1_1GetLogRecordRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.logRecordPointer !== undefined &&
        input.logRecordPointer !== null && { logRecordPointer: input.logRecordPointer }));
};
var serializeAws_json1_1GetQueryResultsRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.queryId !== undefined && input.queryId !== null && { queryId: input.queryId }));
};
var serializeAws_json1_1InputLogEvent = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.message !== undefined && input.message !== null && { message: input.message })), (input.timestamp !== undefined && input.timestamp !== null && { timestamp: input.timestamp }));
};
var serializeAws_json1_1InputLogEvents = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_json1_1InputLogEvent(entry, context);
    });
};
var serializeAws_json1_1InputLogStreamNames = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_json1_1ListTagsLogGroupRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName }));
};
var serializeAws_json1_1LogGroupNames = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_json1_1MetricTransformation = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.defaultValue !== undefined && input.defaultValue !== null && { defaultValue: input.defaultValue })), (input.metricName !== undefined && input.metricName !== null && { metricName: input.metricName })), (input.metricNamespace !== undefined &&
        input.metricNamespace !== null && { metricNamespace: input.metricNamespace })), (input.metricValue !== undefined && input.metricValue !== null && { metricValue: input.metricValue }));
};
var serializeAws_json1_1MetricTransformations = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_json1_1MetricTransformation(entry, context);
    });
};
var serializeAws_json1_1PutDestinationPolicyRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.accessPolicy !== undefined && input.accessPolicy !== null && { accessPolicy: input.accessPolicy })), (input.destinationName !== undefined &&
        input.destinationName !== null && { destinationName: input.destinationName }));
};
var serializeAws_json1_1PutDestinationRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.destinationName !== undefined &&
        input.destinationName !== null && { destinationName: input.destinationName })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn })), (input.targetArn !== undefined && input.targetArn !== null && { targetArn: input.targetArn }));
};
var serializeAws_json1_1PutLogEventsRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.logEvents !== undefined &&
        input.logEvents !== null && { logEvents: serializeAws_json1_1InputLogEvents(input.logEvents, context) })), (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.logStreamName !== undefined && input.logStreamName !== null && { logStreamName: input.logStreamName })), (input.sequenceToken !== undefined && input.sequenceToken !== null && { sequenceToken: input.sequenceToken }));
};
var serializeAws_json1_1PutMetricFilterRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.filterName !== undefined && input.filterName !== null && { filterName: input.filterName })), (input.filterPattern !== undefined && input.filterPattern !== null && { filterPattern: input.filterPattern })), (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.metricTransformations !== undefined &&
        input.metricTransformations !== null && {
        metricTransformations: serializeAws_json1_1MetricTransformations(input.metricTransformations, context),
    }));
};
var serializeAws_json1_1PutQueryDefinitionRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.logGroupNames !== undefined &&
        input.logGroupNames !== null && {
        logGroupNames: serializeAws_json1_1LogGroupNames(input.logGroupNames, context),
    })), (input.name !== undefined && input.name !== null && { name: input.name })), (input.queryDefinitionId !== undefined &&
        input.queryDefinitionId !== null && { queryDefinitionId: input.queryDefinitionId })), (input.queryString !== undefined && input.queryString !== null && { queryString: input.queryString }));
};
var serializeAws_json1_1PutResourcePolicyRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.policyDocument !== undefined &&
        input.policyDocument !== null && { policyDocument: input.policyDocument })), (input.policyName !== undefined && input.policyName !== null && { policyName: input.policyName }));
};
var serializeAws_json1_1PutRetentionPolicyRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.retentionInDays !== undefined &&
        input.retentionInDays !== null && { retentionInDays: input.retentionInDays }));
};
var serializeAws_json1_1PutSubscriptionFilterRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.destinationArn !== undefined &&
        input.destinationArn !== null && { destinationArn: input.destinationArn })), (input.distribution !== undefined && input.distribution !== null && { distribution: input.distribution })), (input.filterName !== undefined && input.filterName !== null && { filterName: input.filterName })), (input.filterPattern !== undefined && input.filterPattern !== null && { filterPattern: input.filterPattern })), (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.roleArn !== undefined && input.roleArn !== null && { roleArn: input.roleArn }));
};
var serializeAws_json1_1StartQueryRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.endTime !== undefined && input.endTime !== null && { endTime: input.endTime })), (input.limit !== undefined && input.limit !== null && { limit: input.limit })), (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.logGroupNames !== undefined &&
        input.logGroupNames !== null && {
        logGroupNames: serializeAws_json1_1LogGroupNames(input.logGroupNames, context),
    })), (input.queryString !== undefined && input.queryString !== null && { queryString: input.queryString })), (input.startTime !== undefined && input.startTime !== null && { startTime: input.startTime }));
};
var serializeAws_json1_1StopQueryRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.queryId !== undefined && input.queryId !== null && { queryId: input.queryId }));
};
var serializeAws_json1_1TagList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_json1_1TagLogGroupRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.tags !== undefined && input.tags !== null && { tags: serializeAws_json1_1Tags(input.tags, context) }));
};
var serializeAws_json1_1Tags = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __read */])(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_json1_1TestEventMessages = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_json1_1TestMetricFilterRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.filterPattern !== undefined && input.filterPattern !== null && { filterPattern: input.filterPattern })), (input.logEventMessages !== undefined &&
        input.logEventMessages !== null && {
        logEventMessages: serializeAws_json1_1TestEventMessages(input.logEventMessages, context),
    }));
};
var serializeAws_json1_1UntagLogGroupRequest = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.logGroupName !== undefined && input.logGroupName !== null && { logGroupName: input.logGroupName })), (input.tags !== undefined && input.tags !== null && { tags: serializeAws_json1_1TagList(input.tags, context) }));
};
var deserializeAws_json1_1CreateExportTaskResponse = function (output, context) {
    return {
        taskId: output.taskId !== undefined && output.taskId !== null ? output.taskId : undefined,
    };
};
var deserializeAws_json1_1DataAlreadyAcceptedException = function (output, context) {
    return {
        expectedSequenceToken: output.expectedSequenceToken !== undefined && output.expectedSequenceToken !== null
            ? output.expectedSequenceToken
            : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1DeleteQueryDefinitionResponse = function (output, context) {
    return {
        success: output.success !== undefined && output.success !== null ? output.success : undefined,
    };
};
var deserializeAws_json1_1DescribeDestinationsResponse = function (output, context) {
    return {
        destinations: output.destinations !== undefined && output.destinations !== null
            ? deserializeAws_json1_1Destinations(output.destinations, context)
            : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
    };
};
var deserializeAws_json1_1DescribeExportTasksResponse = function (output, context) {
    return {
        exportTasks: output.exportTasks !== undefined && output.exportTasks !== null
            ? deserializeAws_json1_1ExportTasks(output.exportTasks, context)
            : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
    };
};
var deserializeAws_json1_1DescribeLogGroupsResponse = function (output, context) {
    return {
        logGroups: output.logGroups !== undefined && output.logGroups !== null
            ? deserializeAws_json1_1LogGroups(output.logGroups, context)
            : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
    };
};
var deserializeAws_json1_1DescribeLogStreamsResponse = function (output, context) {
    return {
        logStreams: output.logStreams !== undefined && output.logStreams !== null
            ? deserializeAws_json1_1LogStreams(output.logStreams, context)
            : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
    };
};
var deserializeAws_json1_1DescribeMetricFiltersResponse = function (output, context) {
    return {
        metricFilters: output.metricFilters !== undefined && output.metricFilters !== null
            ? deserializeAws_json1_1MetricFilters(output.metricFilters, context)
            : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
    };
};
var deserializeAws_json1_1DescribeQueriesResponse = function (output, context) {
    return {
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        queries: output.queries !== undefined && output.queries !== null
            ? deserializeAws_json1_1QueryInfoList(output.queries, context)
            : undefined,
    };
};
var deserializeAws_json1_1DescribeQueryDefinitionsResponse = function (output, context) {
    return {
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        queryDefinitions: output.queryDefinitions !== undefined && output.queryDefinitions !== null
            ? deserializeAws_json1_1QueryDefinitionList(output.queryDefinitions, context)
            : undefined,
    };
};
var deserializeAws_json1_1DescribeResourcePoliciesResponse = function (output, context) {
    return {
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        resourcePolicies: output.resourcePolicies !== undefined && output.resourcePolicies !== null
            ? deserializeAws_json1_1ResourcePolicies(output.resourcePolicies, context)
            : undefined,
    };
};
var deserializeAws_json1_1DescribeSubscriptionFiltersResponse = function (output, context) {
    return {
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        subscriptionFilters: output.subscriptionFilters !== undefined && output.subscriptionFilters !== null
            ? deserializeAws_json1_1SubscriptionFilters(output.subscriptionFilters, context)
            : undefined,
    };
};
var deserializeAws_json1_1Destination = function (output, context) {
    return {
        accessPolicy: output.accessPolicy !== undefined && output.accessPolicy !== null ? output.accessPolicy : undefined,
        arn: output.arn !== undefined && output.arn !== null ? output.arn : undefined,
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        destinationName: output.destinationName !== undefined && output.destinationName !== null ? output.destinationName : undefined,
        roleArn: output.roleArn !== undefined && output.roleArn !== null ? output.roleArn : undefined,
        targetArn: output.targetArn !== undefined && output.targetArn !== null ? output.targetArn : undefined,
    };
};
var deserializeAws_json1_1Destinations = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1Destination(entry, context);
    });
};
var deserializeAws_json1_1ExportTask = function (output, context) {
    return {
        destination: output.destination !== undefined && output.destination !== null ? output.destination : undefined,
        destinationPrefix: output.destinationPrefix !== undefined && output.destinationPrefix !== null
            ? output.destinationPrefix
            : undefined,
        executionInfo: output.executionInfo !== undefined && output.executionInfo !== null
            ? deserializeAws_json1_1ExportTaskExecutionInfo(output.executionInfo, context)
            : undefined,
        from: output.from !== undefined && output.from !== null ? output.from : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        status: output.status !== undefined && output.status !== null
            ? deserializeAws_json1_1ExportTaskStatus(output.status, context)
            : undefined,
        taskId: output.taskId !== undefined && output.taskId !== null ? output.taskId : undefined,
        taskName: output.taskName !== undefined && output.taskName !== null ? output.taskName : undefined,
        to: output.to !== undefined && output.to !== null ? output.to : undefined,
    };
};
var deserializeAws_json1_1ExportTaskExecutionInfo = function (output, context) {
    return {
        completionTime: output.completionTime !== undefined && output.completionTime !== null ? output.completionTime : undefined,
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
    };
};
var deserializeAws_json1_1ExportTasks = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1ExportTask(entry, context);
    });
};
var deserializeAws_json1_1ExportTaskStatus = function (output, context) {
    return {
        code: output.code !== undefined && output.code !== null ? output.code : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1ExtractedValues = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __read */])(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_json1_1FilteredLogEvent = function (output, context) {
    return {
        eventId: output.eventId !== undefined && output.eventId !== null ? output.eventId : undefined,
        ingestionTime: output.ingestionTime !== undefined && output.ingestionTime !== null ? output.ingestionTime : undefined,
        logStreamName: output.logStreamName !== undefined && output.logStreamName !== null ? output.logStreamName : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
        timestamp: output.timestamp !== undefined && output.timestamp !== null ? output.timestamp : undefined,
    };
};
var deserializeAws_json1_1FilteredLogEvents = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1FilteredLogEvent(entry, context);
    });
};
var deserializeAws_json1_1FilterLogEventsResponse = function (output, context) {
    return {
        events: output.events !== undefined && output.events !== null
            ? deserializeAws_json1_1FilteredLogEvents(output.events, context)
            : undefined,
        nextToken: output.nextToken !== undefined && output.nextToken !== null ? output.nextToken : undefined,
        searchedLogStreams: output.searchedLogStreams !== undefined && output.searchedLogStreams !== null
            ? deserializeAws_json1_1SearchedLogStreams(output.searchedLogStreams, context)
            : undefined,
    };
};
var deserializeAws_json1_1GetLogEventsResponse = function (output, context) {
    return {
        events: output.events !== undefined && output.events !== null
            ? deserializeAws_json1_1OutputLogEvents(output.events, context)
            : undefined,
        nextBackwardToken: output.nextBackwardToken !== undefined && output.nextBackwardToken !== null
            ? output.nextBackwardToken
            : undefined,
        nextForwardToken: output.nextForwardToken !== undefined && output.nextForwardToken !== null ? output.nextForwardToken : undefined,
    };
};
var deserializeAws_json1_1GetLogGroupFieldsResponse = function (output, context) {
    return {
        logGroupFields: output.logGroupFields !== undefined && output.logGroupFields !== null
            ? deserializeAws_json1_1LogGroupFieldList(output.logGroupFields, context)
            : undefined,
    };
};
var deserializeAws_json1_1GetLogRecordResponse = function (output, context) {
    return {
        logRecord: output.logRecord !== undefined && output.logRecord !== null
            ? deserializeAws_json1_1LogRecord(output.logRecord, context)
            : undefined,
    };
};
var deserializeAws_json1_1GetQueryResultsResponse = function (output, context) {
    return {
        results: output.results !== undefined && output.results !== null
            ? deserializeAws_json1_1QueryResults(output.results, context)
            : undefined,
        statistics: output.statistics !== undefined && output.statistics !== null
            ? deserializeAws_json1_1QueryStatistics(output.statistics, context)
            : undefined,
        status: output.status !== undefined && output.status !== null ? output.status : undefined,
    };
};
var deserializeAws_json1_1InvalidOperationException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1InvalidParameterException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1InvalidSequenceTokenException = function (output, context) {
    return {
        expectedSequenceToken: output.expectedSequenceToken !== undefined && output.expectedSequenceToken !== null
            ? output.expectedSequenceToken
            : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1LimitExceededException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1ListTagsLogGroupResponse = function (output, context) {
    return {
        tags: output.tags !== undefined && output.tags !== null ? deserializeAws_json1_1Tags(output.tags, context) : undefined,
    };
};
var deserializeAws_json1_1LogGroup = function (output, context) {
    return {
        arn: output.arn !== undefined && output.arn !== null ? output.arn : undefined,
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        kmsKeyId: output.kmsKeyId !== undefined && output.kmsKeyId !== null ? output.kmsKeyId : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        metricFilterCount: output.metricFilterCount !== undefined && output.metricFilterCount !== null
            ? output.metricFilterCount
            : undefined,
        retentionInDays: output.retentionInDays !== undefined && output.retentionInDays !== null ? output.retentionInDays : undefined,
        storedBytes: output.storedBytes !== undefined && output.storedBytes !== null ? output.storedBytes : undefined,
    };
};
var deserializeAws_json1_1LogGroupField = function (output, context) {
    return {
        name: output.name !== undefined && output.name !== null ? output.name : undefined,
        percent: output.percent !== undefined && output.percent !== null ? output.percent : undefined,
    };
};
var deserializeAws_json1_1LogGroupFieldList = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1LogGroupField(entry, context);
    });
};
var deserializeAws_json1_1LogGroupNames = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var deserializeAws_json1_1LogGroups = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1LogGroup(entry, context);
    });
};
var deserializeAws_json1_1LogRecord = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __read */])(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_json1_1LogStream = function (output, context) {
    return {
        arn: output.arn !== undefined && output.arn !== null ? output.arn : undefined,
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        firstEventTimestamp: output.firstEventTimestamp !== undefined && output.firstEventTimestamp !== null
            ? output.firstEventTimestamp
            : undefined,
        lastEventTimestamp: output.lastEventTimestamp !== undefined && output.lastEventTimestamp !== null
            ? output.lastEventTimestamp
            : undefined,
        lastIngestionTime: output.lastIngestionTime !== undefined && output.lastIngestionTime !== null
            ? output.lastIngestionTime
            : undefined,
        logStreamName: output.logStreamName !== undefined && output.logStreamName !== null ? output.logStreamName : undefined,
        storedBytes: output.storedBytes !== undefined && output.storedBytes !== null ? output.storedBytes : undefined,
        uploadSequenceToken: output.uploadSequenceToken !== undefined && output.uploadSequenceToken !== null
            ? output.uploadSequenceToken
            : undefined,
    };
};
var deserializeAws_json1_1LogStreams = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1LogStream(entry, context);
    });
};
var deserializeAws_json1_1MalformedQueryException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
        queryCompileError: output.queryCompileError !== undefined && output.queryCompileError !== null
            ? deserializeAws_json1_1QueryCompileError(output.queryCompileError, context)
            : undefined,
    };
};
var deserializeAws_json1_1MetricFilter = function (output, context) {
    return {
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        filterName: output.filterName !== undefined && output.filterName !== null ? output.filterName : undefined,
        filterPattern: output.filterPattern !== undefined && output.filterPattern !== null ? output.filterPattern : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        metricTransformations: output.metricTransformations !== undefined && output.metricTransformations !== null
            ? deserializeAws_json1_1MetricTransformations(output.metricTransformations, context)
            : undefined,
    };
};
var deserializeAws_json1_1MetricFilterMatches = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1MetricFilterMatchRecord(entry, context);
    });
};
var deserializeAws_json1_1MetricFilterMatchRecord = function (output, context) {
    return {
        eventMessage: output.eventMessage !== undefined && output.eventMessage !== null ? output.eventMessage : undefined,
        eventNumber: output.eventNumber !== undefined && output.eventNumber !== null ? output.eventNumber : undefined,
        extractedValues: output.extractedValues !== undefined && output.extractedValues !== null
            ? deserializeAws_json1_1ExtractedValues(output.extractedValues, context)
            : undefined,
    };
};
var deserializeAws_json1_1MetricFilters = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1MetricFilter(entry, context);
    });
};
var deserializeAws_json1_1MetricTransformation = function (output, context) {
    return {
        defaultValue: output.defaultValue !== undefined && output.defaultValue !== null ? output.defaultValue : undefined,
        metricName: output.metricName !== undefined && output.metricName !== null ? output.metricName : undefined,
        metricNamespace: output.metricNamespace !== undefined && output.metricNamespace !== null ? output.metricNamespace : undefined,
        metricValue: output.metricValue !== undefined && output.metricValue !== null ? output.metricValue : undefined,
    };
};
var deserializeAws_json1_1MetricTransformations = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1MetricTransformation(entry, context);
    });
};
var deserializeAws_json1_1OperationAbortedException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1OutputLogEvent = function (output, context) {
    return {
        ingestionTime: output.ingestionTime !== undefined && output.ingestionTime !== null ? output.ingestionTime : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
        timestamp: output.timestamp !== undefined && output.timestamp !== null ? output.timestamp : undefined,
    };
};
var deserializeAws_json1_1OutputLogEvents = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1OutputLogEvent(entry, context);
    });
};
var deserializeAws_json1_1PutDestinationResponse = function (output, context) {
    return {
        destination: output.destination !== undefined && output.destination !== null
            ? deserializeAws_json1_1Destination(output.destination, context)
            : undefined,
    };
};
var deserializeAws_json1_1PutLogEventsResponse = function (output, context) {
    return {
        nextSequenceToken: output.nextSequenceToken !== undefined && output.nextSequenceToken !== null
            ? output.nextSequenceToken
            : undefined,
        rejectedLogEventsInfo: output.rejectedLogEventsInfo !== undefined && output.rejectedLogEventsInfo !== null
            ? deserializeAws_json1_1RejectedLogEventsInfo(output.rejectedLogEventsInfo, context)
            : undefined,
    };
};
var deserializeAws_json1_1PutQueryDefinitionResponse = function (output, context) {
    return {
        queryDefinitionId: output.queryDefinitionId !== undefined && output.queryDefinitionId !== null
            ? output.queryDefinitionId
            : undefined,
    };
};
var deserializeAws_json1_1PutResourcePolicyResponse = function (output, context) {
    return {
        resourcePolicy: output.resourcePolicy !== undefined && output.resourcePolicy !== null
            ? deserializeAws_json1_1ResourcePolicy(output.resourcePolicy, context)
            : undefined,
    };
};
var deserializeAws_json1_1QueryCompileError = function (output, context) {
    return {
        location: output.location !== undefined && output.location !== null
            ? deserializeAws_json1_1QueryCompileErrorLocation(output.location, context)
            : undefined,
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1QueryCompileErrorLocation = function (output, context) {
    return {
        endCharOffset: output.endCharOffset !== undefined && output.endCharOffset !== null ? output.endCharOffset : undefined,
        startCharOffset: output.startCharOffset !== undefined && output.startCharOffset !== null ? output.startCharOffset : undefined,
    };
};
var deserializeAws_json1_1QueryDefinition = function (output, context) {
    return {
        lastModified: output.lastModified !== undefined && output.lastModified !== null ? output.lastModified : undefined,
        logGroupNames: output.logGroupNames !== undefined && output.logGroupNames !== null
            ? deserializeAws_json1_1LogGroupNames(output.logGroupNames, context)
            : undefined,
        name: output.name !== undefined && output.name !== null ? output.name : undefined,
        queryDefinitionId: output.queryDefinitionId !== undefined && output.queryDefinitionId !== null
            ? output.queryDefinitionId
            : undefined,
        queryString: output.queryString !== undefined && output.queryString !== null ? output.queryString : undefined,
    };
};
var deserializeAws_json1_1QueryDefinitionList = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1QueryDefinition(entry, context);
    });
};
var deserializeAws_json1_1QueryInfo = function (output, context) {
    return {
        createTime: output.createTime !== undefined && output.createTime !== null ? output.createTime : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        queryId: output.queryId !== undefined && output.queryId !== null ? output.queryId : undefined,
        queryString: output.queryString !== undefined && output.queryString !== null ? output.queryString : undefined,
        status: output.status !== undefined && output.status !== null ? output.status : undefined,
    };
};
var deserializeAws_json1_1QueryInfoList = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1QueryInfo(entry, context);
    });
};
var deserializeAws_json1_1QueryResults = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1ResultRows(entry, context);
    });
};
var deserializeAws_json1_1QueryStatistics = function (output, context) {
    return {
        bytesScanned: output.bytesScanned !== undefined && output.bytesScanned !== null ? output.bytesScanned : undefined,
        recordsMatched: output.recordsMatched !== undefined && output.recordsMatched !== null ? output.recordsMatched : undefined,
        recordsScanned: output.recordsScanned !== undefined && output.recordsScanned !== null ? output.recordsScanned : undefined,
    };
};
var deserializeAws_json1_1RejectedLogEventsInfo = function (output, context) {
    return {
        expiredLogEventEndIndex: output.expiredLogEventEndIndex !== undefined && output.expiredLogEventEndIndex !== null
            ? output.expiredLogEventEndIndex
            : undefined,
        tooNewLogEventStartIndex: output.tooNewLogEventStartIndex !== undefined && output.tooNewLogEventStartIndex !== null
            ? output.tooNewLogEventStartIndex
            : undefined,
        tooOldLogEventEndIndex: output.tooOldLogEventEndIndex !== undefined && output.tooOldLogEventEndIndex !== null
            ? output.tooOldLogEventEndIndex
            : undefined,
    };
};
var deserializeAws_json1_1ResourceAlreadyExistsException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1ResourceNotFoundException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1ResourcePolicies = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1ResourcePolicy(entry, context);
    });
};
var deserializeAws_json1_1ResourcePolicy = function (output, context) {
    return {
        lastUpdatedTime: output.lastUpdatedTime !== undefined && output.lastUpdatedTime !== null ? output.lastUpdatedTime : undefined,
        policyDocument: output.policyDocument !== undefined && output.policyDocument !== null ? output.policyDocument : undefined,
        policyName: output.policyName !== undefined && output.policyName !== null ? output.policyName : undefined,
    };
};
var deserializeAws_json1_1ResultField = function (output, context) {
    return {
        field: output.field !== undefined && output.field !== null ? output.field : undefined,
        value: output.value !== undefined && output.value !== null ? output.value : undefined,
    };
};
var deserializeAws_json1_1ResultRows = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1ResultField(entry, context);
    });
};
var deserializeAws_json1_1SearchedLogStream = function (output, context) {
    return {
        logStreamName: output.logStreamName !== undefined && output.logStreamName !== null ? output.logStreamName : undefined,
        searchedCompletely: output.searchedCompletely !== undefined && output.searchedCompletely !== null
            ? output.searchedCompletely
            : undefined,
    };
};
var deserializeAws_json1_1SearchedLogStreams = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1SearchedLogStream(entry, context);
    });
};
var deserializeAws_json1_1ServiceUnavailableException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1StartQueryResponse = function (output, context) {
    return {
        queryId: output.queryId !== undefined && output.queryId !== null ? output.queryId : undefined,
    };
};
var deserializeAws_json1_1StopQueryResponse = function (output, context) {
    return {
        success: output.success !== undefined && output.success !== null ? output.success : undefined,
    };
};
var deserializeAws_json1_1SubscriptionFilter = function (output, context) {
    return {
        creationTime: output.creationTime !== undefined && output.creationTime !== null ? output.creationTime : undefined,
        destinationArn: output.destinationArn !== undefined && output.destinationArn !== null ? output.destinationArn : undefined,
        distribution: output.distribution !== undefined && output.distribution !== null ? output.distribution : undefined,
        filterName: output.filterName !== undefined && output.filterName !== null ? output.filterName : undefined,
        filterPattern: output.filterPattern !== undefined && output.filterPattern !== null ? output.filterPattern : undefined,
        logGroupName: output.logGroupName !== undefined && output.logGroupName !== null ? output.logGroupName : undefined,
        roleArn: output.roleArn !== undefined && output.roleArn !== null ? output.roleArn : undefined,
    };
};
var deserializeAws_json1_1SubscriptionFilters = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1SubscriptionFilter(entry, context);
    });
};
var deserializeAws_json1_1Tags = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __read */])(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_json1_1TestMetricFilterResponse = function (output, context) {
    return {
        matches: output.matches !== undefined && output.matches !== null
            ? deserializeAws_json1_1MetricFilterMatches(output.matches, context)
            : undefined,
    };
};
var deserializeAws_json1_1UnrecognizedClientException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeMetadata = function (output) {
    var _a;
    return ({
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"],
    });
};
// Collect low-level response body stream to Uint8Array.
var collectBody = function (streamBody, context) {
    if (streamBody === void 0) { streamBody = new Uint8Array(); }
    if (streamBody instanceof Uint8Array) {
        return Promise.resolve(streamBody);
    }
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var collectBodyString = function (streamBody, context) {
    return collectBody(streamBody, context).then(function (body) { return context.utf8Encoder(body); });
};
var buildHttpRpcRequest = function (context, headers, path, resolvedHostname, body) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                contents = {
                    protocol: protocol,
                    hostname: hostname,
                    port: port,
                    method: "POST",
                    path: path,
                    headers: headers,
                };
                if (resolvedHostname !== undefined) {
                    contents.hostname = resolvedHostname;
                }
                if (body !== undefined) {
                    contents.body = body;
                }
                return [2 /*return*/, new __WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__["HttpRequest"](contents)];
        }
    });
}); };
var parseBody = function (streamBody, context) {
    return collectBodyString(streamBody, context).then(function (encoded) {
        if (encoded.length) {
            return JSON.parse(encoded);
        }
        return {};
    });
};
/**
 * Load an error code for the aws.rest-json-1.1 protocol.
 */
var loadRestJsonErrorCode = function (output, data) {
    var findKey = function (object, key) { return Object.keys(object).find(function (k) { return k.toLowerCase() === key.toLowerCase(); }); };
    var sanitizeErrorCode = function (rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) {
            cleanValue = cleanValue.split(":")[0];
        }
        if (cleanValue.indexOf("#") >= 0) {
            cleanValue = cleanValue.split("#")[1];
        }
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) {
        return sanitizeErrorCode(output.headers[headerKey]);
    }
    if (data.code !== undefined) {
        return sanitizeErrorCode(data.code);
    }
    if (data["__type"] !== undefined) {
        return sanitizeErrorCode(data["__type"]);
    }
    return "";
};
//# sourceMappingURL=Aws_json1_1.js.map

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _numeral = __webpack_require__(681);

var _numeral2 = _interopRequireDefault(_numeral);

var _reactRedux = __webpack_require__(9);

var _flash = __webpack_require__(5);

var _currencies = __webpack_require__(592);

var _companies = __webpack_require__(88);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoanAmount = function (_Component) {
  _inherits(LoanAmount, _Component);

  function LoanAmount(props) {
    _classCallCheck(this, LoanAmount);

    var _this = _possibleConstructorReturn(this, (LoanAmount.__proto__ || Object.getPrototypeOf(LoanAmount)).call(this, props));

    _initialiseProps.call(_this);

    var state = LoanAmount.getPropsToState(props);

    _this.state = state;
    return _this;
  }

  _createClass(LoanAmount, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = LoanAmount.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          currencySetting = _props.currencySetting,
          percentage = _props.percentage;
      var _state = this.state,
          amount = _state.amount,
          format = _state.format;

      var isAbbreviationEnabled = currencySetting && currencySetting.data && currencySetting.data.isAbbreviationEnabled;

      return _react2.default.createElement(
        'span',
        { className: 'loan-amount', title: isAbbreviationEnabled ? '' + this.getCurrencySymbol() + this.formatAmount(amount, format, true) : null },
        this.getCurrencySymbol() && _react2.default.createElement(
          'span',
          { className: 'prefix' },
          this.getCurrencySymbol(),
          ' '
        ),
        this.getConversionAmount(),
        percentage ? _react2.default.createElement(
          'span',
          { className: 'prefix' },
          percentage,
          ' '
        ) : null
      );
    }
  }]);

  return LoanAmount;
}(_react.Component);

LoanAmount.propTypes = {
  amount: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string,
      currencySymbol: _propTypes2.default.string
    })
  }),
  format: _propTypes2.default.string,
  precise: _propTypes2.default.bool,
  prefix: _propTypes2.default.node,
  percentage: _propTypes2.default.string,
  projectCurrencies: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  currencySetting: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      isAbbreviationEnabled: _propTypes2.default.bool,
      displayDecimal: _propTypes2.default.bool,
      abbreviationDecimalPoints: _propTypes2.default.number,
      decimalSeparator: _propTypes2.default.string,
      thousandsSeparator: _propTypes2.default.string,
      millionsSeparator: _propTypes2.default.string,
      billionsSeparator: _propTypes2.default.string
    })
  })
};
LoanAmount.defaultProps = {
  precise: true
};

LoanAmount.getPropsToState = function (props) {
  var newFormat = props.format;
  if (props.precise && props.amount) {
    var formatSplit = newFormat.split('.');
    var amountSplit = props.amount.toString().split('.');
    if (amountSplit.length > 1) {
      newFormat = formatSplit[0] + '.' + '0'.repeat(amountSplit[1].toString().length);
    }
  }
  return {
    amount: props.amount,
    format: newFormat,
    prefix: props.prefix,
    projectCurrencies: props.projectCurrencies || []
  };
};

LoanAmount.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    currencySetting: state.currencySetting
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getConversionAmount = function () {
    var _state2 = _this2.state,
        amount = _state2.amount,
        format = _state2.format,
        _state2$projectCurren = _state2.projectCurrencies,
        projectCurrencies = _state2$projectCurren === undefined ? [] : _state2$projectCurren;
    var auth = _this2.props.auth;

    var totalAmount = amount;

    if (auth && auth.company && auth.company.countryCode && auth.company.countryCode.toLowerCase() === 'vn') {
      return _this2.formatAmount(amount, format);
    }

    var convertedAmount = totalAmount;
    if (auth && !(0, _companies.isForeignCompany)(auth.company)) {
      var coBaseCurrency = _this2.getCompanyBaseCurrency();
      var displayCurrencyCode = (0, _currencies.getDisplayCurrency)();
      var companyCurrencyInProject = projectCurrencies.find(function (e) {
        return e.code === coBaseCurrency.code;
      });
      var displayCurrencyInProject = projectCurrencies.find(function (e) {
        return e.code === displayCurrencyCode;
      });
      var projectBaseCurrency = projectCurrencies.find(function (c) {
        return c.isDefault;
      }) || null;
      convertedAmount = (0, _currencies.calcConversionAmount)(companyCurrencyInProject, displayCurrencyInProject, projectBaseCurrency, amount);
    }
    return _this2.formatAmount(convertedAmount, format);
  };

  this.getCompanyBaseCurrency = function () {
    var store = _this2.context.store;
    var _props$auth$company$c = _this2.props.auth.company.companyCurrency,
        companyCurrency = _props$auth$company$c === undefined ? [] : _props$auth$company$c;

    var coDefaultCurrency = companyCurrency.find(function (e) {
      return e.isDefault;
    }) || {};
    if (!coDefaultCurrency) {
      store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));
      return null;
    }
    return coDefaultCurrency;
  };

  this.getCurrencySymbol = function () {
    var _props2 = _this2.props,
        auth = _props2.auth,
        prefix = _props2.prefix;

    return auth && auth.company && (0, _companies.isForeignCompany)(auth.company) ? auth.company.currencySymbol : prefix;
  };

  this.formatAmount = function () {
    var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '-';
    var format = arguments[1];
    var isTooltip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var _props3 = _this2.props,
        auth = _props3.auth,
        currencySetting = _props3.currencySetting;

    var loan = void 0;
    if (amount === '-') {
      return 'N/A';
    }
    var countryCode = auth && auth.company && typeof auth.company.countryCode === 'string' ? auth.company.countryCode.toLowerCase() : '';
    var isVietnam = countryCode === 'vn';
    if (isVietnam) {
      var cleanNumber = Math.round(Number(amount));

      return new Intl.NumberFormat('en-US').format(cleanNumber);
    }
    if (!isTooltip && auth && (0, _companies.isForeignCompany)(auth.company) && currencySetting.data) {
      return (0, _currencies.getCurrencySettingFormat)(amount, currencySetting.data, auth.company && auth.company.countryCode);
    }
    if (format) {
      loan = (0, _numeral2.default)(amount).format(format);
    } else {
      loan = amount * 1 >= 1000000 && amount * 1 < 100000000 ? (0, _numeral2.default)(amount).format('0.0a') : (0, _numeral2.default)(amount).format('0a');
    }
    return loan;
  };
};

exports.default = (0, _reactRedux.connect)(LoanAmount.mapStateToProps)(LoanAmount);

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56), __webpack_require__(299)(module)))

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GraphQLError = GraphQLError;

var _printError = __webpack_require__(1204);

var _location = __webpack_require__(664);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function GraphQLError( // eslint-disable-line no-redeclare
message, nodes, source, positions, path, originalError, extensions) {
  // Compute list of blame nodes.
  var _nodes = Array.isArray(nodes) ? nodes.length !== 0 ? nodes : undefined : nodes ? [nodes] : undefined; // Compute locations in the source for the given nodes/positions.


  var _source = source;

  if (!_source && _nodes) {
    var node = _nodes[0];
    _source = node && node.loc && node.loc.source;
  }

  var _positions = positions;

  if (!_positions && _nodes) {
    _positions = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push(node.loc.start);
      }

      return list;
    }, []);
  }

  if (_positions && _positions.length === 0) {
    _positions = undefined;
  }

  var _locations;

  if (positions && source) {
    _locations = positions.map(function (pos) {
      return (0, _location.getLocation)(source, pos);
    });
  } else if (_nodes) {
    _locations = _nodes.reduce(function (list, node) {
      if (node.loc) {
        list.push((0, _location.getLocation)(node.loc.source, node.loc.start));
      }

      return list;
    }, []);
  }

  var _extensions = extensions || originalError && originalError.extensions;

  Object.defineProperties(this, {
    message: {
      value: message,
      // By being enumerable, JSON.stringify will include `message` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: true,
      writable: true
    },
    locations: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: _locations || undefined,
      // By being enumerable, JSON.stringify will include `locations` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(_locations)
    },
    path: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: path || undefined,
      // By being enumerable, JSON.stringify will include `path` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(path)
    },
    nodes: {
      value: _nodes || undefined
    },
    source: {
      value: _source || undefined
    },
    positions: {
      value: _positions || undefined
    },
    originalError: {
      value: originalError
    },
    extensions: {
      // Coercing falsey values to undefined ensures they will not be included
      // in JSON.stringify() when not provided.
      value: _extensions || undefined,
      // By being enumerable, JSON.stringify will include `path` in the
      // resulting output. This ensures that the simplest possible GraphQL
      // service adheres to the spec.
      enumerable: Boolean(_extensions)
    }
  }); // Include (non-enumerable) stack trace.

  if (originalError && originalError.stack) {
    Object.defineProperty(this, 'stack', {
      value: originalError.stack,
      writable: true,
      configurable: true
    });
  } else if (Error.captureStackTrace) {
    Error.captureStackTrace(this, GraphQLError);
  } else {
    Object.defineProperty(this, 'stack', {
      value: Error().stack,
      writable: true,
      configurable: true
    });
  }
}

GraphQLError.prototype = Object.create(Error.prototype, {
  constructor: {
    value: GraphQLError
  },
  name: {
    value: 'GraphQLError'
  },
  toString: {
    value: function toString() {
      return (0, _printError.printError)(this);
    }
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseInvoke_js__ = __webpack_require__(3351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseRest_js__ = __webpack_require__(251);



/**
 * Invokes the method at `path` of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {...*} [args] The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
 *
 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
 * // => [2, 3]
 */
var invoke = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseRest_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseInvoke_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (invoke);


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _jsCookie = __webpack_require__(247);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getDefaultCurrency = function getDefaultCurrency(appConfig) {
  var cookieCurrency = _jsCookie2.default.get('currency');
  if (!cookieCurrency) {
    // fallback if currency is not in cookies (most likely due to company did not setup currency)
    return appConfig && appConfig.data && appConfig.data.currency && appConfig.data.currency.symbol;
  }
  return cookieCurrency;
};

var CurrencySymbol = function CurrencySymbol(_ref) {
  var appConfig = _ref.appConfig;
  return _react2.default.createElement(
    'span',
    null,
    getDefaultCurrency(appConfig)
  );
};

CurrencySymbol.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      currency: _propTypes2.default.shape({
        code: _propTypes2.default.string,
        symbol: _propTypes2.default.string
      })
    })
  })
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    appConfig: state.appConfig
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(CurrencySymbol);

/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.vnCRMSearchField = exports.idDocumentUploads = exports.idDocumentComplete = exports.idDocumentSides = exports.blocksVietnamLocalUnit = exports.isVietnamLocalUnit = exports.hasForeignPurchaser = exports.isForeignPurchaser = exports.crmContactCitizenship = exports.normalizeCitizenship = exports.VN_FOREIGN_THRESHOLD_MESSAGE = exports.VN_LOCAL_UNIT_FOREIGNER_MESSAGE = exports.CITIZENSHIP_FOREIGNER = exports.CITIZENSHIP_LOCAL = exports.crmContactMobile = exports.CRM_MOBILE_MIN_NATIONAL_LENGTH = exports.crmMonthlyIncome = exports.vnPreferredNameValidations = exports.vnFullNameValidations = exports.vnNameValidations = exports.vnNameFormatMessage = exports.IDENTITY_TYPE_VN_ENTERPRISE = exports.VN_NAME_FORMAT_MESSAGE = exports.VN_NAME_NO_DIGITS_REGEX = exports.vnIdentityValidation = exports.VN_CCCD_MESSAGE = exports.VN_CCCD_REGEX = exports.showsProjectStoreyPlan = exports.hidesPricesFromAgency = exports.showsLayoutUnitAvailability = exports.showsLayoutReserveButton = exports.showsProjectUnitsTab = exports.vnPreloadsPendingCancellationCount = exports.showsBulkEditCustomFields = exports.showsPaymentExcelExport = exports.bookingIDCellValue = exports.isCompleteSaleAgent = exports.crmAgentLookupQuery = exports.agentAssignedLocked = exports.staffSearchQuery = exports.showBookingIDColumn = exports.showsUnitQuotaFilter = exports.unitQuotaFilterOptions = exports.unitQuotaFilterPlaceholder = exports.unitQuotaChipLabel = exports.createdByLabel = exports.canEditVietnamUnitPricing = exports.vnUnitTextValues = exports.VN_UNIT_TEXT_FIELDS = exports.isAllowedUnitPageLimit = exports.unitPageLimitOpts = exports.isVietnamExternalAgent = exports.canEditSourceOfFinance = exports.vnDepositStatusLabel = exports.depositLabel = exports.paymentMethodOpts = exports.hasVietnamElevatedAccess = exports.vnChangeUnitBlocked = exports.isVietnamCompany = undefined;

var _webValidations = __webpack_require__(23);

var _countries = __webpack_require__(60);

var _isNumber = __webpack_require__(30);

var _paymentMethods = __webpack_require__(1045);

var _paymentMethods2 = _interopRequireDefault(_paymentMethods);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// CPI-974: single place for the Vietnam gate so every VN-only hunk reads the same way.
// Everything below returns the neutral value for MY/ID, so callers stay byte-identical there.
var isVietnamCompany = exports.isVietnamCompany = function isVietnamCompany(auth) {
  return (0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode);
};

// CPI-1347: book-api refuses change-unit (403 change_unit_not_allowed_vn) for a Vietnam
// booking whose code is not a legacy "BK-" code (CPI-974 D12: cancel and reserve again).
// Mirror that rule so the action is not offered. MY/ID always return false (unchanged).
var vnChangeUnitBlocked = exports.vnChangeUnitBlocked = function vnChangeUnitBlocked(auth, booking) {
  return isVietnamCompany(auth) && !!booking && String(booking.code || '').indexOf('BK-') !== 0;
};

// CPI-974 (D5/S1): "HQ or Sales Admin", the only two roles the Vietnam flows are restricted to -
// the same family book-api tests. Do not widen to auth.isBranchLeader, which admits four roles.
var hasVietnamElevatedAccess = exports.hasVietnamElevatedAccess = function hasVietnamElevatedAccess(auth) {
  return !!auth && !!(auth.isHeadquarters || auth.isDeveloperSalesAdmin);
};

// CPI-974 (D2/S1): the source-of-finance options. Vietnam additionally gets Bank Loan;
// PAYMENT_METHODS is returned by reference off Vietnam and is never mutated.
var paymentMethodOpts = exports.paymentMethodOpts = function paymentMethodOpts(auth) {
  return isVietnamCompany(auth) ? [].concat(_toConsumableArray(_paymentMethods2.default), [_paymentMethods.PAYMENT_METHOD_BANK_LOAN_OPTION]) : _paymentMethods2.default;
};

// CPI-974 (D): Vietnam calls the booking-fee rail a "Deposit"; unlisted keys fall through.
var VN_DEPOSIT_LABEL_KEYS = {
  'Booking Fee': 'Deposit',
  'Booking Fee Amount': 'Deposit Amount',
  'New Payment': 'New Deposit',
  'Add Payment': 'Add Deposit',
  'Payment Receipt': 'Deposit Receipt'
};

var depositLabel = exports.depositLabel = function depositLabel(auth, t, key, options) {
  if (isVietnamCompany(auth) && VN_DEPOSIT_LABEL_KEYS[key]) {
    return t(VN_DEPOSIT_LABEL_KEYS[key], options);
  }
  return t(key, options);
};

// CPI-974 (D3): Vietnam is approval-only, so the shared booking-fee statuses are relabelled.
var VN_DEPOSIT_STATUS_KEYS = {
  pending_verification: 'Pending Approval',
  paid: 'Approved'
};

// null for MY/ID and for statuses without an override, so call sites keep the old expression.
var vnDepositStatusLabel = exports.vnDepositStatusLabel = function vnDepositStatusLabel(auth, t, status) {
  if (isVietnamCompany(auth) && VN_DEPOSIT_STATUS_KEYS[status]) {
    return t(VN_DEPOSIT_STATUS_KEYS[status], { ns: _translation.TRANSLATION_FILES.constants });
  }
  return null;
};

// CPI-1212: may this user EDIT a booking's Source of Finance? Vietnam only - outside it the first
// line returns true. Inside, a BASE external agent needs the project's own
// allowAgentEditSourceOfFinance (not the older allowAgentChangeBookingPaymentMethod, which is on).
var canEditSourceOfFinance = exports.canEditSourceOfFinance = function canEditSourceOfFinance(auth, project) {
  if (!isVietnamCompany(auth)) return true;
  if (!auth || !auth.companyBranch || !auth.companyBranch.isExternal) return true;
  if (auth.isExternalAgentLeader || auth.isExternalAgencyAdmin) return true;
  return !!(project && project.allowAgentEditSourceOfFinance);
};

// CPI-1230 (D2/D3, A106): "agents see less" - an external company branch is the whole agent
// family, the same predicate the server uses. Deliberately not hasVietnamElevatedAccess inverted.
var isVietnamExternalAgent = exports.isVietnamExternalAgent = function isVietnamExternalAgent(auth) {
  return isVietnamCompany(auth) && !!(auth.companyBranch && auth.companyBranch.isExternal);
};

// CPI-1230 (Q1): the bulk-edit "records per page" dropdown gains 300 for Vietnam only.
var UNIT_PAGE_LIMITS_VN_EXTRA = { text: '300', value: '300' };
var UNIT_PAGE_LIMIT_VALUES = ['25', '50', '100', '150'];

var unitPageLimitOpts = exports.unitPageLimitOpts = function unitPageLimitOpts(auth, limits) {
  return isVietnamCompany(auth) ? [].concat(_toConsumableArray(limits), [UNIT_PAGE_LIMITS_VN_EXTRA]) : limits;
};

// The query guards reset an unrecognised ?limit= back to 50, so 300 has to be recognised there.
var isAllowedUnitPageLimit = exports.isAllowedUnitPageLimit = function isAllowedUnitPageLimit(auth, limit) {
  return UNIT_PAGE_LIMIT_VALUES.indexOf(limit) !== -1 || isVietnamCompany(auth) && limit === UNIT_PAGE_LIMITS_VN_EXTRA.value;
};

// CPI-1219: the two free-text fields a Vietnamese unit carries in its own right - the layout
// description the sales team writes on it ("2PN-2WC") and its view ("SE"). Both have a namesake on
// the unit LAYOUT, which is the product owner's "2 fields both sides"; these two are the unit's.
// Every role sees them, so there is no role gate here - only the country one.
var VN_UNIT_TEXT_FIELDS = exports.VN_UNIT_TEXT_FIELDS = ['unitLayoutNew', 'view'];

// The keys the unit form sends. Outside Vietnam it is an empty object, so no key is added and
// saving the rest of the form cannot blank a stored value. Inside it, an empty box is '', never
// undefined, which the API would drop rather than clear.
var vnUnitTextValues = exports.vnUnitTextValues = function vnUnitTextValues(unit, isVietnam) {
  return isVietnam ? VN_UNIT_TEXT_FIELDS.reduce(function (acc, key) {
    return Object.assign(acc, _defineProperty({}, key, unit && unit[key] || ''));
  }, {}) : {};
};

// CPI-1230 (D-D6): may this session type VAT % and Land Value on a unit? The same test the unit
// screen applies to those two rows. False outside Vietnam, where neither field exists.
var canEditVietnamUnitPricing = exports.canEditVietnamUnitPricing = function canEditVietnamUnitPricing(auth) {
  return isVietnamCompany(auth) && !isVietnamExternalAgent(auth) && hasVietnamElevatedAccess(auth) && !!(auth && auth.allowEditUnitPrice);
};

// CPI-1435 (PO): on a Vietnamese sale Created By is the agent - the same person as the CRM
// booking's agent - so it reads "Agent Assigned". `fallback` is the call site's own (already
// translated) label, returned unchanged for MY/ID.
var createdByLabel = exports.createdByLabel = function createdByLabel(auth, t, fallback) {
  return isVietnamCompany(auth) ? t('Agent Assigned', { ns: _translation.TRANSLATION_FILES.screens }) : fallback;
};

// CPI-1230 (D-D5): "Bumi" / "Bumiputera" in Malaysia is "Foreign restricted" in Vietnam. These
// four helpers return the Malaysian key, placeholder and option array unchanged elsewhere.
var unitQuotaChipLabel = exports.unitQuotaChipLabel = function unitQuotaChipLabel(auth, t) {
  return isVietnamCompany(auth) ? t('Foreign restricted', { ns: _translation.TRANSLATION_FILES.screens }) : t('Bumi');
};

var unitQuotaFilterPlaceholder = exports.unitQuotaFilterPlaceholder = function unitQuotaFilterPlaceholder(auth, t) {
  return isVietnamCompany(auth) ? t('Foreign restricted', { ns: _translation.TRANSLATION_FILES.screens }) : t('Select Bumiputera');
};

// Vietnam's values are a plain Yes / No pair over the same ?isBumi=true|false query parameter.
var unitQuotaFilterOptions = exports.unitQuotaFilterOptions = function unitQuotaFilterOptions(auth, t, defaultOptions) {
  return isVietnamCompany(auth) ? [{ text: t('Yes', { ns: _translation.TRANSLATION_FILES.constants }), value: 'true' }, { text: t('No', { ns: _translation.TRANSLATION_FILES.constants }), value: 'false' }] : defaultOptions;
};

// MS-5972 hid the quota filter outside Malaysia; Vietnam gets it back under its own words.
var showsUnitQuotaFilter = exports.showsUnitQuotaFilter = function showsUnitQuotaFilter(auth) {
  var countryCode = auth && auth.company && auth.company.countryCode;
  if (typeof countryCode !== 'string') {
    return false;
  }
  return countryCode.toUpperCase() === 'MY' || isVietnamCompany(auth);
};

// CPI-1209 (PO, 5 Sep, follow-up to CPI-974 D9): the Booking ID column, defined here once because
// both copies of the sales table call it. bookings.code is the reservation's sr_code for Vietnam.
var showBookingIDColumn = exports.showBookingIDColumn = function showBookingIDColumn(auth) {
  return isVietnamCompany(auth);
};

// CPI-1429: query for the staff picker (/search/staffs/). For a Vietnamese company a caller may
// also send a sale's id; book-api then lists only staff from the branch of that sale's Assigned
// Staff. Since CPI-1435 no picker sends it (Assigned Staff is the internal reviewer again, and the
// Agent Assigned picker lists anyone). Every MY/ID call builds the exact query it built before.
var staffSearchQuery = exports.staffSearchQuery = function staffSearchQuery() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      auth = _ref.auth,
      searchAll = _ref.searchAll,
      search = _ref.search,
      bookingID = _ref.bookingID;

  var query = 'limit=3' + (searchAll ? '' : '&isExternal=false') + '&search=' + search;
  if (bookingID && isVietnamCompany(auth)) {
    query += '&bookingID=' + encodeURIComponent(bookingID);
  }
  return query;
};

// CPI-1435: on a Vietnamese booking form Agent Assigned (Created By) is the CRM booking's agent, so
// it is filled from the CRM and never picked by hand. MY/ID keep their editable Created By picker.
var agentAssignedLocked = exports.agentAssignedLocked = function agentAssignedLocked(auth) {
  return isVietnamCompany(auth);
};

// CPI-1435: /search/staffs/ query that resolves the CRM booking's agent (its Cognito username,
// the opportunity's assigned_to) to the Showroom user and agency. Empty when there is no agent.
var crmAgentLookupQuery = exports.crmAgentLookupQuery = function crmAgentLookupQuery(assignedTo) {
  return assignedTo ? 'limit=1&awsUsernames=' + encodeURIComponent(assignedTo) : '';
};

// CPI-1435: whether a /search/staffs/ row can be a sale's agent - the same fields the Created By
// picker requires (handleUserSelect), including the agency. Anything less is "Invalid assigned
// agent", which book-api also refuses on Create.
var isCompleteSaleAgent = exports.isCompleteSaleAgent = function isCompleteSaleAgent(staff) {
  return !!staff && staff.id > 0 && staff.affiliateID > 0 && staff.companyID > 0 && staff.companyBranchID > 0 && !!staff.companyBranchShortName && !!staff.name && !!staff.preferredName;
};

// A booking with no code reads as a dash, the same placeholder the Sales screen already shows.
var bookingIDCellValue = exports.bookingIDCellValue = function bookingIDCellValue(booking) {
  return booking && booking.code || '-';
};

// CPI-1209 (PO, 11 Sep): "for payment excel to hide that option as deposit payment collection
// not required for skyworld." The Sales list's "Payment Excel" export (booking fee payments) is
// not offered to a Vietnamese company; Malaysia/Indonesia keep it.
var showsPaymentExcelExport = exports.showsPaymentExcelExport = function showsPaymentExcelExport(auth) {
  return !isVietnamCompany(auth);
};

// (Loo, 24 Sep): Sales > Manage > "Bulk Edit Custom Fields" is not offered to a Vietnamese
// company. The Sales list's role check (HQ, Admin, Supervisor, Sales Manager, Sales Admin) still
// applies everywhere else; this only takes the item away in Vietnam. Malaysia/Indonesia unchanged.
var showsBulkEditCustomFields = exports.showsBulkEditCustomFields = function showsBulkEditCustomFields(auth) {
  return !isVietnamCompany(auth);
};

// CPI-1226 (Loo, 7 Sep): should Sales > Manage fetch the Pending Cancellation list once as the
// page loads, purely so the header badge and the "PENDING CANCELLATION" tab badge are right on
// first paint? Until now that count arrived only when the tab was clicked, so a Vietnamese HQ user
// with an outstanding cancellation request saw 0 until they went looking. Vietnam only - Malaysia
// and Indonesia keep the single tab-1 request they make today.
var vnPreloadsPendingCancellationCount = exports.vnPreloadsPendingCancellationCount = function vnPreloadsPendingCancellationCount(auth) {
  return isVietnamCompany(auth);
};

// CPI-1272 (PO, 9 Sep): "to hide this menu items from all AGENCY role such as AL, Agent,
// Agent Admin". companyBranch.isExternal is exactly that family and nothing wider -
// src/actions/auth.js derives isExternalAgentLeader, isExternalAgent AND isExternalAgencyAdmin
// from that one flag - so isVietnamExternalAgent covers all three roles in a single predicate.
// Every developer-side role (HQ, Sales Admin, Sales Manager, Supervisor, Staff, Siteplan) keeps
// the tab, and so does every agency outside Vietnam.
var showsProjectUnitsTab = exports.showsProjectUnitsTab = function showsProjectUnitsTab(auth) {
  return !isVietnamExternalAgent(auth);
};

// CPI-1292 (PO, 14 Sep): "disable this button for Agency user role, vietnam only" - the Reserve
// button on each Project Overview > Layouts row. It only opens the layout's unit-list modal, which
// knows nothing about agency allocation, so a VN agent could pick a unit their branch is not
// allocated and dead-end on book-api's 403. Hidden for the same agency family as the Units tab
// above; the unit page's own Reserve (allocation-checked server-side, CPI-975) stays their path.
var showsLayoutReserveButton = exports.showsLayoutReserveButton = function showsLayoutReserveButton(auth) {
  return !isVietnamExternalAgent(auth);
};

// the "Unit Availability" block at the bottom of a Layout's Overview page is the
// same unit list the Units tab (CPI-1272) already keeps from Vietnamese agency roles, just filtered
// to one layout. Hidden for the same family so an agent cannot read the list through the layout
// page instead; the segment is not drawn at all, so the units request is never made either.
var showsLayoutUnitAvailability = exports.showsLayoutUnitAvailability = function showsLayoutUnitAvailability(auth) {
  return !isVietnamExternalAgent(auth);
};

// CPI-1372 (PO, 29 Sep): "hide selling prices from Agency users via project setting". The
// project's existing "Disable Base Selling Price in pricing package selection" box takes on a
// second meaning in Vietnam: ticked, an agency user (AL, Agent, Agent Admin - the same family as
// above) is shown no price at all on Unit Information - list price, before/after-tax selling
// price, and the pricing-package / fee / mortgage segments, which already key off spaValue.
// book-api zeroes the same fields in the payload (handlers/vn_gates.go vnStripUnitPricesForAgency),
// so this only decides what the screen draws; the rows are removed, never shown as "-".
// Developer-side roles, every company outside Vietnam, and a project with the box clear all
// return false and keep the screen exactly as it is.
var hidesPricesFromAgency = exports.hidesPricesFromAgency = function hidesPricesFromAgency(auth, project) {
  return isVietnamExternalAgent(auth) && !!(project && project.disableBaseSellingPriceSelection);
};

// CPI-1274 (PO, 9 Sep): "to hide storey plan from Agent if project is not published. the project
// not published setting is in project > edit > info screen." That screen's first field is the
// Status select over PROJECT_STATUSES (src/constants/projectStatuses.js), so "published" here is
// projects.status_id - NOT the Marketplace tab's marketplaceIsPublish / marketplaceBuyerIsPublish
// toggles, which live on a different tab and gate a different product.
//
// The project's own salesChartEnabled switch still decides whether a Storey Plan link exists at
// all; this only takes it away again from a Vietnamese agency while the project is draft, ready,
// archived or deleted. Developer-side roles, and everyone outside Vietnam, are unaffected.
var showsProjectStoreyPlan = exports.showsProjectStoreyPlan = function showsProjectStoreyPlan(auth, project) {
  return !isVietnamExternalAgent(auth) || !!(project && project.statusID === 'published');
};

// CPI-974: a Vietnamese CCCD is 12 digits, not a Malaysian IC. Reported twice - by Sales on
// Skyworld staging (8 Sep, 912345678123 on a new booking) and by the PO on CPI-977 comment
// 161432 item 3 (001198012345). @mhub/web-validations only knows the MY and ID formats, so
// identity type 1 has to carry its own regex here. The Purchaser tab, the Customer screen and
// the Sales booking form all read it from this one place.
//
// The rule is the CRM's Vietnam config rule, aligned to the CRM's VN config, Max 8 Sep:
// mhub-leads-v2-web src/localization/features/constants.js, COUNTRIES.vn.ic_validation_regex =
// /^[0-9]{12}$/ - exactly 12 digits and nothing else. This replaces the structured pattern
// CPI-149 wrote in March (/^(?:0\d{2}|[1-9]\d{2})[0-3]\d{8}$/, which also constrained the 4th
// digit to 0-3) on all three screens. The SRB buyer app checks 12 digits too, so the CRM, SRB
// and the Showroom now agree on what a CCCD is.
var VN_CCCD_REGEX = exports.VN_CCCD_REGEX = /^[0-9]{12}$/;

// The CRM's own wording for a malformed CCCD (validation.cccd_format in its en / vi-VN key
// files), carried into the Showroom so a Vietnamese user reads the same sentence in both
// products instead of the library's "<label> has an invalid identity type".
var VN_CCCD_MESSAGE = exports.VN_CCCD_MESSAGE = 'CCCD must be exactly 12 digits, containing only numbers without spaces or punctuation.';

// null everywhere else - outside Vietnam, and for every identity type but CCCD - so a caller
// keeps falling through to the countryCode/identityType option it passes today, message and all.
// @mhub/web-validations returns options.message verbatim when it is set (dist/lib/getMessage.js).
var vnIdentityValidation = exports.vnIdentityValidation = function vnIdentityValidation(auth, identityTypeID, t) {
  if (!isVietnamCompany(auth) || identityTypeID !== 1) {
    return null;
  }
  return {
    validRegex: VN_CCCD_REGEX,
    message: typeof t === 'function' ? t(VN_CCCD_MESSAGE, { ns: _translation.TRANSLATION_FILES.translation }) : VN_CCCD_MESSAGE
  };
};

// CPI-1319: a Vietnamese purchaser's Full Name and Preferred Name (and a company's Contact
// Person) must not contain digits. Only digits are refused, so Vietnamese letters with diacritics
// pass untouched. The Company Name of an Enterprise Registration Certificate purchaser (identity
// type 4) may carry numbers, so the name field skips the rule there. Outside Vietnam this returns
// [] and the callers' validation arrays stay byte-identical.
var VN_NAME_NO_DIGITS_REGEX = exports.VN_NAME_NO_DIGITS_REGEX = /^[^0-9]*$/;
var VN_NAME_FORMAT_MESSAGE = exports.VN_NAME_FORMAT_MESSAGE = 'cannot contain digits';
var IDENTITY_TYPE_VN_ENTERPRISE = exports.IDENTITY_TYPE_VN_ENTERPRISE = 4;

// "Preferred Name cannot contain digits" - the label leads, like "<Field> is required", so the
// "Please fix form errors" popup, which lists messages only, says which field failed.
var vnNameFormatMessage = exports.vnNameFormatMessage = function vnNameFormatMessage(t, label) {
  var text = typeof t === 'function' ? t(VN_NAME_FORMAT_MESSAGE, { ns: _translation.TRANSLATION_FILES.translation }) : VN_NAME_FORMAT_MESSAGE;
  return label ? label + ' ' + text : text;
};

var vnNameValidations = exports.vnNameValidations = function vnNameValidations(auth, t) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!isVietnamCompany(auth)) return [];
  if (options.isCompanyName) return [];
  return [{
    validate: _webValidations.matchRegex,
    option: {
      validRegex: VN_NAME_NO_DIGITS_REGEX,
      // matchRegex calls a function message with { key, label, validRegex }; label is the
      // input's validateLabel, already translated by the screen.
      message: function message(_ref2) {
        var label = _ref2.label;
        return vnNameFormatMessage(t, label);
      }
    }
  }];
};

// Sugar for the two name inputs: the Full Name / Company Name box and the Preferred Name /
// Contact Person box. identityTypeID is the purchaser's selected identity type.
var vnFullNameValidations = exports.vnFullNameValidations = function vnFullNameValidations(auth, identityTypeID, t) {
  return vnNameValidations(auth, t, {
    isCompanyName: Number(identityTypeID) === IDENTITY_TYPE_VN_ENTERPRISE
  });
};
var vnPreferredNameValidations = exports.vnPreferredNameValidations = function vnPreferredNameValidations(auth, t) {
  return vnNameValidations(auth, t);
};

// CPI-1291: the CRM sends monthly_income as a string and BookingCustomer.monthlyIncome is a
// float64. Only a whole plain number is taken (parseFloat half-reads "1.200.000" as 1.2 and
// "1,200" as 1); blank and unreadable alike become null, which Go leaves at the zero value.
var crmMonthlyIncome = exports.crmMonthlyIncome = function crmMonthlyIncome(value) {
  return (typeof value === 'string' || typeof value === 'number') && (0, _isNumber.isNumeric)(value) ? Number(value) : null;
};

// CPI-977: the CRM keeps contact.mobile as the national number ("889321232") and the full number
// in msisdn ("84889321232"), but some contacts carry the full number in mobile as well. Posted
// untouched, book-api's phone preset regex for the prefix rejects it ("Invalid Mobile Number").
// The primary purchaser at least sees it in the Mobile input; a related purchaser is posted
// straight from the CRM payload and fails the reservation with nothing to correct on screen.
// Drop "+", spaces and separators, then the dialling code when the number leads with it and is
// too long to be national. A national number can start with the code's own digits (VN 084 is
// "84xxxxxxx" without the trunk zero), so the code only goes when at least
// CRM_MOBILE_MIN_NATIONAL_LENGTH digits remain - the shortest mobile numbering plans are 8.
var CRM_MOBILE_MIN_NATIONAL_LENGTH = exports.CRM_MOBILE_MIN_NATIONAL_LENGTH = 8;
var crmContactMobile = exports.crmContactMobile = function crmContactMobile(mobile, mobilePrefix) {
  var digits = String(mobile || '').replace(/\D/g, '');
  var prefix = String(mobilePrefix || '').replace(/\D/g, '');
  if (!prefix || !digits.startsWith(prefix)) return digits;
  var national = digits.slice(prefix.length);
  return national.length >= CRM_MOBILE_MIN_NATIONAL_LENGTH ? national : digits;
};

// CPI-1248 (part 1): a Vietnamese unit flagged `isBumi` is the "Local unit" - the same column the
// unit screens label "Foreign restricted" (`unitQuotaChipLabel` above) - and no foreign purchaser
// may reserve one. Everything below is Vietnam-only at the call site; MY/ID never reach it.
//
// Citizenship is a declared 'local' | 'foreigner' and nothing else. It is NEVER inferred from a
// passport, a nationality, an address country or the buyer's identity type: a Vietnamese citizen
// living abroad and a foreigner holding a CCCD both exist, so only the declaration is evidence.
// Blank means "not declared", which does not block - the API applies the same rule on the write.
var CITIZENSHIP_LOCAL = exports.CITIZENSHIP_LOCAL = 'local';
var CITIZENSHIP_FOREIGNER = exports.CITIZENSHIP_FOREIGNER = 'foreigner';

// The sentence the user reads, kept verbatim here so the screen, the flash on the API's own 412
// and the tests cannot drift apart. English is the VN UI convention; a missing key falls back to
// exactly this text.
var VN_LOCAL_UNIT_FOREIGNER_MESSAGE = exports.VN_LOCAL_UNIT_FOREIGNER_MESSAGE = 'Foreigners are not allowed to reserve Local unit';

// CPI-1248 (part 2): the project's Foreign Purchase Control threshold (CPI-1220). book-api counts
// the units already held by a foreigner at reservation time and answers 412 /
// `M-Type: error_vn_foreign_threshold_exceeded`; the frontend counts nothing and only renders the
// refusal, so this sentence exists here purely as the fallback when the API sends no body.
var VN_FOREIGN_THRESHOLD_MESSAGE = exports.VN_FOREIGN_THRESHOLD_MESSAGE = 'Exceed foreign control threshold, please contact your agent for assistance.';

// '' for anything that is not one of the two declared values, including null/undefined, a number,
// an object, or free text that merely contains the word ("Local ward 3" is an address, not a
// citizenship).
var normalizeCitizenship = exports.normalizeCitizenship = function normalizeCitizenship(value) {
  if (typeof value !== 'string') return '';
  var normalized = value.trim().toLowerCase();
  return normalized === CITIZENSHIP_LOCAL || normalized === CITIZENSHIP_FOREIGNER ? normalized : '';
};

// The CRM holds citizenship in two places. The newer customer API has its own `citizenship`;
// before it, the CRM's Register Customer screen wrote the same two values into `address_4`
// (mhub-leads-v2-web RegisterCustomer.jsx `handleChangeCitizenship`). The explicit field wins,
// and the legacy one is read ONLY when it holds one of the two values - on a customer registered
// before that screen existed, `address_4` is an ordinary address line (a ward, a street) and
// says nothing about citizenship.
var crmContactCitizenship = exports.crmContactCitizenship = function crmContactCitizenship(contact) {
  if (!contact) return '';
  return normalizeCitizenship(contact.citizenship) || normalizeCitizenship(contact.address_4);
};

// A purchaser the booking form holds: its citizenship has already been resolved by the mapping
// above, so only the explicit field is read here.
var isForeignPurchaser = exports.isForeignPurchaser = function isForeignPurchaser(purchaser) {
  return !!purchaser && normalizeCitizenship(purchaser.citizenship) === CITIZENSHIP_FOREIGNER;
};

// Primary OR any joint purchaser. The rule is binary: a mixed set (a local primary with a foreign
// joint purchaser, or the reverse) counts as foreign, because the foreigner is still on the unit.
var hasForeignPurchaser = exports.hasForeignPurchaser = function hasForeignPurchaser(purchasers) {
  return Array.isArray(purchasers) && purchasers.some(isForeignPurchaser);
};

// `unit` is the selected unit's own details (`projectUnitDetails` on the booking form). False for
// every non-Vietnamese session, so MY/ID keep reserving exactly what they reserved before.
var isVietnamLocalUnit = exports.isVietnamLocalUnit = function isVietnamLocalUnit(auth, unit) {
  return isVietnamCompany(auth) && !!(unit && unit.isBumi);
};

// The one predicate the booking form asks before it writes: may this set of purchasers reserve
// this unit? True means block.
var blocksVietnamLocalUnit = exports.blocksVietnamLocalUnit = function blocksVietnamLocalUnit(auth, unit, purchasers) {
  return isVietnamLocalUnit(auth, unit) && hasForeignPurchaser(purchasers);
};

// CPI-1332 item 1 — a purchaser's identity document, by country and type.
// Vietnam: a CCCD has a front and a back; a passport or an Enterprise Registration Certificate is
// one image (kept in the front slot). Everywhere else the card is what it always was: two sides.
var idDocumentSides = exports.idDocumentSides = function idDocumentSides(identityTypeID, isVietnam) {
  return isVietnam && identityTypeID !== 1 ? 1 : 2;
};

// Whether the document on file is complete for its type. Keeps the screen's existing `!== ''`
// reading of the ids, so MY/ID stay byte-identical; only a one-image Vietnamese document stops
// waiting for a back it does not have.
var idDocumentComplete = exports.idDocumentComplete = function idDocumentComplete(customer, isVietnam) {
  return !!customer && customer.icFrontDocumentID !== '' && (idDocumentSides(customer.identityTypeID, isVietnam) === 1 || customer.icBackDocumentID !== '');
};

// The upload entries to send for a document: the back is dropped for a one-image type, so a file
// picked while CCCD was selected cannot ride along after the agent switches to a passport.
var idDocumentUploads = exports.idDocumentUploads = function idDocumentUploads(front, back, sides) {
  var uploads = [];
  if (front && front.file) uploads.push({ index: 0, upload: front });
  if (back && back.file && sides === 2) uploads.push({ index: 1, upload: back });
  return uploads;
};

// The CRM stores a Vietnamese identity in cccd / passport / other_identity, never in nric, so a
// search by the Malaysian field name finds nobody. Same mapping book-api uses when it writes the
// contact (FromShowroomCustomer). Non-Vietnam searches are passed through unchanged.
var vnCRMSearchField = exports.vnCRMSearchField = function vnCRMSearchField(searchType, isVietnam) {
  if (!isVietnam) return searchType;
  if (searchType === 'nric') return 'cccd';
  if (searchType === 'company') return 'other_identity';
  return searchType;
};

/***/ }),
/* 41 */
/***/ (function(module, exports) {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(75)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PREFERRED_BANKERS_PROMPT = exports.UPLOAD_LOGO_PROMPT = exports.UPLOAD_PICTURE_PROMPT = exports.UPLOAD_DOCUMENT_PROMPT = exports.NEW_STAFF_PROMPT = exports.NEW_CUSTOMER_PROMPT = exports.NEW_SPECIFICATION_PROMPT = exports.NEW_MAPPING_PROMPT = exports.NEW_PROJECT_UNIT_LAYOUT_PROMPT = exports.NEW_PROJECT_UNIT_PROMPT = exports.NEW_PROJECT_PROMPT = exports.NEW_BOOKING_PROMPT = exports.NEW_IMPORT_PROMPT = exports.CANCEL_PROMPT = exports.DEFAULT_PROMPT = undefined;

var _translation = __webpack_require__(4);

var DEFAULT_PROMPT = exports.DEFAULT_PROMPT = 'You have unsaved changes. Do you still want to **leave**?';

var CANCEL_PROMPT = exports.CANCEL_PROMPT = 'You have unsaved changes. Do you still want to **cancel**?';

var NEW_IMPORT_PROMPT = exports.NEW_IMPORT_PROMPT = 'Your import is not saved yet. Do you still want to **leave**?';

var NEW_BOOKING_PROMPT = exports.NEW_BOOKING_PROMPT = 'Your booking is not saved yet. Do you still want to **leave**?';

var NEW_PROJECT_PROMPT = exports.NEW_PROJECT_PROMPT = 'Your project is not saved yet. Do you still want to **leave**?';
var NEW_PROJECT_UNIT_PROMPT = exports.NEW_PROJECT_UNIT_PROMPT = 'Your unit is not saved yet. Do you still want to **leave**?';
var NEW_PROJECT_UNIT_LAYOUT_PROMPT = exports.NEW_PROJECT_UNIT_LAYOUT_PROMPT = 'Your unit layout is not saved yet. Do you still want to **leave**?';

var NEW_MAPPING_PROMPT = exports.NEW_MAPPING_PROMPT = 'Your preset is not saved yet. Do you still want to **leave**?';

var NEW_SPECIFICATION_PROMPT = exports.NEW_SPECIFICATION_PROMPT = 'Your preset is not saved yet. Do you still want to **leave**?';

var NEW_CUSTOMER_PROMPT = exports.NEW_CUSTOMER_PROMPT = 'Your customer details is not saved yet. Do you still want to **leave**?';
var NEW_STAFF_PROMPT = exports.NEW_STAFF_PROMPT = 'Your staff details is not saved yet. Do you still want to **leave**?';

var UPLOAD_DOCUMENT_PROMPT = exports.UPLOAD_DOCUMENT_PROMPT = 'Your document(s) is not uploaded yet. Do you still want to **leave**?';
var UPLOAD_PICTURE_PROMPT = exports.UPLOAD_PICTURE_PROMPT = 'Your picture(s) is not uploaded yet. Do you still want to **leave**?';
var UPLOAD_LOGO_PROMPT = exports.UPLOAD_LOGO_PROMPT = 'Your logo(s) is not uploaded yet. Do you still want to **leave**?';

var PREFERRED_BANKERS_PROMPT = exports.PREFERRED_BANKERS_PROMPT = 'Preferred banker(s) is not saved yet. Do you still want to **leave**?';

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setItem = setItem;
exports.getItem = getItem;
var storage = {};
var hasLocalStorage = false;

if (localStorage) {
  try {
    var x = 'testStorage';
    localStorage.setItem(x, x);
    localStorage.removeItem(x);
    hasLocalStorage = true;
  } catch (e) {
    if (e.name !== 'QuotaExceededError') {
      Bugsnag.notifyException(e);
    }
    hasLocalStorage = false;
  }
}

function setItem(key, data) {
  if (hasLocalStorage) {
    localStorage.setItem(key, data);
    return true;
  }
  storage[key] = data;
  return false;
}

function getItem(key) {
  if (hasLocalStorage) {
    return localStorage.getItem(key);
  }
  return storage[key] || null;
}

/***/ }),
/* 45 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

/**
 *  Copyright (c) 2014-2015, Facebook, Inc.
 *  All rights reserved.
 *
 *  This source code is licensed under the BSD-style license found in the
 *  LICENSE file in the root directory of this source tree. An additional grant
 *  of patent rights can be found in the PATENTS file in the same directory.
 */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  global.Immutable = factory();
}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;

  function createClass(ctor, superClass) {
    if (superClass) {
      ctor.prototype = Object.create(superClass.prototype);
    }
    ctor.prototype.constructor = ctor;
  }

  function Iterable(value) {
      return isIterable(value) ? value : Seq(value);
    }


  createClass(KeyedIterable, Iterable);
    function KeyedIterable(value) {
      return isKeyed(value) ? value : KeyedSeq(value);
    }


  createClass(IndexedIterable, Iterable);
    function IndexedIterable(value) {
      return isIndexed(value) ? value : IndexedSeq(value);
    }


  createClass(SetIterable, Iterable);
    function SetIterable(value) {
      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
    }



  function isIterable(maybeIterable) {
    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
  }

  function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
  }

  function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
  }

  function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
  }

  function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
  }

  Iterable.isIterable = isIterable;
  Iterable.isKeyed = isKeyed;
  Iterable.isIndexed = isIndexed;
  Iterable.isAssociative = isAssociative;
  Iterable.isOrdered = isOrdered;

  Iterable.Keyed = KeyedIterable;
  Iterable.Indexed = IndexedIterable;
  Iterable.Set = SetIterable;


  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  // Used for setting prototype methods that IE8 chokes on.
  var DELETE = 'delete';

  // Constants describing the size of trie nodes.
  var SHIFT = 5; // Resulted in best performance after ______?
  var SIZE = 1 << SHIFT;
  var MASK = SIZE - 1;

  // A consistent shared value representing "not set" which equals nothing other
  // than itself, and nothing that could be provided externally.
  var NOT_SET = {};

  // Boolean references, Rough equivalent of `bool &`.
  var CHANGE_LENGTH = { value: false };
  var DID_ALTER = { value: false };

  function MakeRef(ref) {
    ref.value = false;
    return ref;
  }

  function SetRef(ref) {
    ref && (ref.value = true);
  }

  // A function which returns a value representing an "owner" for transient writes
  // to tries. The return value will only ever equal itself, and will not equal
  // the return of any subsequent call of this function.
  function OwnerID() {}

  // http://jsperf.com/copy-array-inline
  function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for (var ii = 0; ii < len; ii++) {
      newArr[ii] = arr[ii + offset];
    }
    return newArr;
  }

  function ensureSize(iter) {
    if (iter.size === undefined) {
      iter.size = iter.__iterate(returnTrue);
    }
    return iter.size;
  }

  function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
      if ('' + uint32Index !== index || uint32Index === 4294967295) {
        return NaN;
      }
      index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
  }

  function returnTrue() {
    return true;
  }

  function wholeSlice(begin, end, size) {
    return (begin === 0 || (size !== undefined && begin <= -size)) &&
      (end === undefined || (size !== undefined && end >= size));
  }

  function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
  }

  function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
  }

  function resolveIndex(index, size, defaultIndex) {
    return index === undefined ?
      defaultIndex :
      index < 0 ?
        Math.max(0, size + index) :
        size === undefined ?
          index :
          Math.min(size, index);
  }

  /* global Symbol */

  var ITERATE_KEYS = 0;
  var ITERATE_VALUES = 1;
  var ITERATE_ENTRIES = 2;

  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator';

  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;


  function Iterator(next) {
      this.next = next;
    }

    Iterator.prototype.toString = function() {
      return '[Iterator]';
    };


  Iterator.KEYS = ITERATE_KEYS;
  Iterator.VALUES = ITERATE_VALUES;
  Iterator.ENTRIES = ITERATE_ENTRIES;

  Iterator.prototype.inspect =
  Iterator.prototype.toSource = function () { return this.toString(); }
  Iterator.prototype[ITERATOR_SYMBOL] = function () {
    return this;
  };


  function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [k, v];
    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
      value: value, done: false
    });
    return iteratorResult;
  }

  function iteratorDone() {
    return { value: undefined, done: true };
  }

  function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
  }

  function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
  }

  function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
  }

  function getIteratorFn(iterable) {
    var iteratorFn = iterable && (
      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
      iterable[FAUX_ITERATOR_SYMBOL]
    );
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  function isArrayLike(value) {
    return value && typeof value.length === 'number';
  }

  createClass(Seq, Iterable);
    function Seq(value) {
      return value === null || value === undefined ? emptySequence() :
        isIterable(value) ? value.toSeq() : seqFromValue(value);
    }

    Seq.of = function(/*...values*/) {
      return Seq(arguments);
    };

    Seq.prototype.toSeq = function() {
      return this;
    };

    Seq.prototype.toString = function() {
      return this.__toString('Seq {', '}');
    };

    Seq.prototype.cacheResult = function() {
      if (!this._cache && this.__iterateUncached) {
        this._cache = this.entrySeq().toArray();
        this.size = this._cache.length;
      }
      return this;
    };

    // abstract __iterateUncached(fn, reverse)

    Seq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, true);
    };

    // abstract __iteratorUncached(type, reverse)

    Seq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, true);
    };



  createClass(KeyedSeq, Seq);
    function KeyedSeq(value) {
      return value === null || value === undefined ?
        emptySequence().toKeyedSeq() :
        isIterable(value) ?
          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
          keyedSeqFromValue(value);
    }

    KeyedSeq.prototype.toKeyedSeq = function() {
      return this;
    };



  createClass(IndexedSeq, Seq);
    function IndexedSeq(value) {
      return value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
    }

    IndexedSeq.of = function(/*...values*/) {
      return IndexedSeq(arguments);
    };

    IndexedSeq.prototype.toIndexedSeq = function() {
      return this;
    };

    IndexedSeq.prototype.toString = function() {
      return this.__toString('Seq [', ']');
    };

    IndexedSeq.prototype.__iterate = function(fn, reverse) {
      return seqIterate(this, fn, reverse, false);
    };

    IndexedSeq.prototype.__iterator = function(type, reverse) {
      return seqIterator(this, type, reverse, false);
    };



  createClass(SetSeq, Seq);
    function SetSeq(value) {
      return (
        value === null || value === undefined ? emptySequence() :
        !isIterable(value) ? indexedSeqFromValue(value) :
        isKeyed(value) ? value.entrySeq() : value
      ).toSetSeq();
    }

    SetSeq.of = function(/*...values*/) {
      return SetSeq(arguments);
    };

    SetSeq.prototype.toSetSeq = function() {
      return this;
    };



  Seq.isSeq = isSeq;
  Seq.Keyed = KeyedSeq;
  Seq.Set = SetSeq;
  Seq.Indexed = IndexedSeq;

  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';

  Seq.prototype[IS_SEQ_SENTINEL] = true;



  createClass(ArraySeq, IndexedSeq);
    function ArraySeq(array) {
      this._array = array;
      this.size = array.length;
    }

    ArraySeq.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };

    ArraySeq.prototype.__iterate = function(fn, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ArraySeq.prototype.__iterator = function(type, reverse) {
      var array = this._array;
      var maxIndex = array.length - 1;
      var ii = 0;
      return new Iterator(function() 
        {return ii > maxIndex ?
          iteratorDone() :
          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
      );
    };



  createClass(ObjectSeq, KeyedSeq);
    function ObjectSeq(object) {
      var keys = Object.keys(object);
      this._object = object;
      this._keys = keys;
      this.size = keys.length;
    }

    ObjectSeq.prototype.get = function(key, notSetValue) {
      if (notSetValue !== undefined && !this.has(key)) {
        return notSetValue;
      }
      return this._object[key];
    };

    ObjectSeq.prototype.has = function(key) {
      return this._object.hasOwnProperty(key);
    };

    ObjectSeq.prototype.__iterate = function(fn, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var key = keys[reverse ? maxIndex - ii : ii];
        if (fn(object[key], key, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    ObjectSeq.prototype.__iterator = function(type, reverse) {
      var object = this._object;
      var keys = this._keys;
      var maxIndex = keys.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var key = keys[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, key, object[key]);
      });
    };

  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(IterableSeq, IndexedSeq);
    function IterableSeq(iterable) {
      this._iterable = iterable;
      this.size = iterable.length || iterable.size;
    }

    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      var iterations = 0;
      if (isIterator(iterator)) {
        var step;
        while (!(step = iterator.next()).done) {
          if (fn(step.value, iterations++, this) === false) {
            break;
          }
        }
      }
      return iterations;
    };

    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterable = this._iterable;
      var iterator = getIterator(iterable);
      if (!isIterator(iterator)) {
        return new Iterator(iteratorDone);
      }
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step : iteratorValue(type, iterations++, step.value);
      });
    };



  createClass(IteratorSeq, IndexedSeq);
    function IteratorSeq(iterator) {
      this._iterator = iterator;
      this._iteratorCache = [];
    }

    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      while (iterations < cache.length) {
        if (fn(cache[iterations], iterations++, this) === false) {
          return iterations;
        }
      }
      var step;
      while (!(step = iterator.next()).done) {
        var val = step.value;
        cache[iterations] = val;
        if (fn(val, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };

    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = this._iterator;
      var cache = this._iteratorCache;
      var iterations = 0;
      return new Iterator(function()  {
        if (iterations >= cache.length) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          cache[iterations] = step.value;
        }
        return iteratorValue(type, iterations, cache[iterations++]);
      });
    };




  // # pragma Helper functions

  function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
  }

  var EMPTY_SEQ;

  function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
  }

  function keyedSeqFromValue(value) {
    var seq =
      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
      typeof value === 'object' ? new ObjectSeq(value) :
      undefined;
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of [k, v] entries, '+
        'or keyed object: ' + value
      );
    }
    return seq;
  }

  function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values: ' + value
      );
    }
    return seq;
  }

  function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value) ||
      (typeof value === 'object' && new ObjectSeq(value));
    if (!seq) {
      throw new TypeError(
        'Expected Array or iterable object of values, or keyed object: ' + value
      );
    }
    return seq;
  }

  function maybeIndexedSeqFromValue(value) {
    return (
      isArrayLike(value) ? new ArraySeq(value) :
      isIterator(value) ? new IteratorSeq(value) :
      hasIterator(value) ? new IterableSeq(value) :
      undefined
    );
  }

  function seqIterate(seq, fn, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      for (var ii = 0; ii <= maxIndex; ii++) {
        var entry = cache[reverse ? maxIndex - ii : ii];
        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
          return ii + 1;
        }
      }
      return ii;
    }
    return seq.__iterateUncached(fn, reverse);
  }

  function seqIterator(seq, type, reverse, useKeys) {
    var cache = seq._cache;
    if (cache) {
      var maxIndex = cache.length - 1;
      var ii = 0;
      return new Iterator(function()  {
        var entry = cache[reverse ? maxIndex - ii : ii];
        return ii++ > maxIndex ?
          iteratorDone() :
          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
      });
    }
    return seq.__iteratorUncached(type, reverse);
  }

  function fromJS(json, converter) {
    return converter ?
      fromJSWith(converter, json, '', {'': json}) :
      fromJSDefault(json);
  }

  function fromJSWith(converter, json, key, parentJSON) {
    if (Array.isArray(json)) {
      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    if (isPlainObj(json)) {
      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
    }
    return json;
  }

  function fromJSDefault(json) {
    if (Array.isArray(json)) {
      return IndexedSeq(json).map(fromJSDefault).toList();
    }
    if (isPlainObj(json)) {
      return KeyedSeq(json).map(fromJSDefault).toMap();
    }
    return json;
  }

  function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
  }

  /**
   * An extension of the "same-value" algorithm as [described for use by ES6 Map
   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
   *
   * NaN is considered the same as NaN, however -0 and 0 are considered the same
   * value, which is different from the algorithm described by
   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
   *
   * This is extended further to allow Objects to describe the values they
   * represent, by way of `valueOf` or `equals` (and `hashCode`).
   *
   * Note: because of this extension, the key equality of Immutable.Map and the
   * value equality of Immutable.Set will differ from ES6 Map and Set.
   *
   * ### Defining custom values
   *
   * The easiest way to describe the value an object represents is by implementing
   * `valueOf`. For example, `Date` represents a value by returning a unix
   * timestamp for `valueOf`:
   *
   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
   *     var date2 = new Date(1234567890000);
   *     date1.valueOf(); // 1234567890000
   *     assert( date1 !== date2 );
   *     assert( Immutable.is( date1, date2 ) );
   *
   * Note: overriding `valueOf` may have other implications if you use this object
   * where JavaScript expects a primitive, such as implicit string coercion.
   *
   * For more complex types, especially collections, implementing `valueOf` may
   * not be performant. An alternative is to implement `equals` and `hashCode`.
   *
   * `equals` takes another object, presumably of similar type, and returns true
   * if the it is equal. Equality is symmetrical, so the same result should be
   * returned if this and the argument are flipped.
   *
   *     assert( a.equals(b) === b.equals(a) );
   *
   * `hashCode` returns a 32bit integer number representing the object which will
   * be used to determine how to store the value object in a Map or Set. You must
   * provide both or neither methods, one must not exist without the other.
   *
   * Also, an important relationship between these methods must be upheld: if two
   * values are equal, they *must* return the same hashCode. If the values are not
   * equal, they might have the same hashCode; this is called a hash collision,
   * and while undesirable for performance reasons, it is acceptable.
   *
   *     if (a.equals(b)) {
   *       assert( a.hashCode() === b.hashCode() );
   *     }
   *
   * All Immutable collections implement `equals` and `hashCode`.
   *
   */
  function is(valueA, valueB) {
    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
      return true;
    }
    if (!valueA || !valueB) {
      return false;
    }
    if (typeof valueA.valueOf === 'function' &&
        typeof valueB.valueOf === 'function') {
      valueA = valueA.valueOf();
      valueB = valueB.valueOf();
      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
        return true;
      }
      if (!valueA || !valueB) {
        return false;
      }
    }
    if (typeof valueA.equals === 'function' &&
        typeof valueB.equals === 'function' &&
        valueA.equals(valueB)) {
      return true;
    }
    return false;
  }

  function deepEqual(a, b) {
    if (a === b) {
      return true;
    }

    if (
      !isIterable(b) ||
      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
      isKeyed(a) !== isKeyed(b) ||
      isIndexed(a) !== isIndexed(b) ||
      isOrdered(a) !== isOrdered(b)
    ) {
      return false;
    }

    if (a.size === 0 && b.size === 0) {
      return true;
    }

    var notAssociative = !isAssociative(a);

    if (isOrdered(a)) {
      var entries = a.entries();
      return b.every(function(v, k)  {
        var entry = entries.next().value;
        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
      }) && entries.next().done;
    }

    var flipped = false;

    if (a.size === undefined) {
      if (b.size === undefined) {
        if (typeof a.cacheResult === 'function') {
          a.cacheResult();
        }
      } else {
        flipped = true;
        var _ = a;
        a = b;
        b = _;
      }
    }

    var allEqual = true;
    var bSize = b.__iterate(function(v, k)  {
      if (notAssociative ? !a.has(v) :
          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
        allEqual = false;
        return false;
      }
    });

    return allEqual && a.size === bSize;
  }

  createClass(Repeat, IndexedSeq);

    function Repeat(value, times) {
      if (!(this instanceof Repeat)) {
        return new Repeat(value, times);
      }
      this._value = value;
      this.size = times === undefined ? Infinity : Math.max(0, times);
      if (this.size === 0) {
        if (EMPTY_REPEAT) {
          return EMPTY_REPEAT;
        }
        EMPTY_REPEAT = this;
      }
    }

    Repeat.prototype.toString = function() {
      if (this.size === 0) {
        return 'Repeat []';
      }
      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };

    Repeat.prototype.get = function(index, notSetValue) {
      return this.has(index) ? this._value : notSetValue;
    };

    Repeat.prototype.includes = function(searchValue) {
      return is(this._value, searchValue);
    };

    Repeat.prototype.slice = function(begin, end) {
      var size = this.size;
      return wholeSlice(begin, end, size) ? this :
        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };

    Repeat.prototype.reverse = function() {
      return this;
    };

    Repeat.prototype.indexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return 0;
      }
      return -1;
    };

    Repeat.prototype.lastIndexOf = function(searchValue) {
      if (is(this._value, searchValue)) {
        return this.size;
      }
      return -1;
    };

    Repeat.prototype.__iterate = function(fn, reverse) {
      for (var ii = 0; ii < this.size; ii++) {
        if (fn(this._value, ii, this) === false) {
          return ii + 1;
        }
      }
      return ii;
    };

    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
      var ii = 0;
      return new Iterator(function() 
        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
      );
    };

    Repeat.prototype.equals = function(other) {
      return other instanceof Repeat ?
        is(this._value, other._value) :
        deepEqual(other);
    };


  var EMPTY_REPEAT;

  function invariant(condition, error) {
    if (!condition) throw new Error(error);
  }

  createClass(Range, IndexedSeq);

    function Range(start, end, step) {
      if (!(this instanceof Range)) {
        return new Range(start, end, step);
      }
      invariant(step !== 0, 'Cannot step a Range by 0');
      start = start || 0;
      if (end === undefined) {
        end = Infinity;
      }
      step = step === undefined ? 1 : Math.abs(step);
      if (end < start) {
        step = -step;
      }
      this._start = start;
      this._end = end;
      this._step = step;
      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
      if (this.size === 0) {
        if (EMPTY_RANGE) {
          return EMPTY_RANGE;
        }
        EMPTY_RANGE = this;
      }
    }

    Range.prototype.toString = function() {
      if (this.size === 0) {
        return 'Range []';
      }
      return 'Range [ ' +
        this._start + '...' + this._end +
        (this._step > 1 ? ' by ' + this._step : '') +
      ' ]';
    };

    Range.prototype.get = function(index, notSetValue) {
      return this.has(index) ?
        this._start + wrapIndex(this, index) * this._step :
        notSetValue;
    };

    Range.prototype.includes = function(searchValue) {
      var possibleIndex = (searchValue - this._start) / this._step;
      return possibleIndex >= 0 &&
        possibleIndex < this.size &&
        possibleIndex === Math.floor(possibleIndex);
    };

    Range.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      begin = resolveBegin(begin, this.size);
      end = resolveEnd(end, this.size);
      if (end <= begin) {
        return new Range(0, 0);
      }
      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };

    Range.prototype.indexOf = function(searchValue) {
      var offsetValue = searchValue - this._start;
      if (offsetValue % this._step === 0) {
        var index = offsetValue / this._step;
        if (index >= 0 && index < this.size) {
          return index
        }
      }
      return -1;
    };

    Range.prototype.lastIndexOf = function(searchValue) {
      return this.indexOf(searchValue);
    };

    Range.prototype.__iterate = function(fn, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      for (var ii = 0; ii <= maxIndex; ii++) {
        if (fn(value, ii, this) === false) {
          return ii + 1;
        }
        value += reverse ? -step : step;
      }
      return ii;
    };

    Range.prototype.__iterator = function(type, reverse) {
      var maxIndex = this.size - 1;
      var step = this._step;
      var value = reverse ? this._start + maxIndex * step : this._start;
      var ii = 0;
      return new Iterator(function()  {
        var v = value;
        value += reverse ? -step : step;
        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
      });
    };

    Range.prototype.equals = function(other) {
      return other instanceof Range ?
        this._start === other._start &&
        this._end === other._end &&
        this._step === other._step :
        deepEqual(this, other);
    };


  var EMPTY_RANGE;

  createClass(Collection, Iterable);
    function Collection() {
      throw TypeError('Abstract');
    }


  createClass(KeyedCollection, Collection);function KeyedCollection() {}

  createClass(IndexedCollection, Collection);function IndexedCollection() {}

  createClass(SetCollection, Collection);function SetCollection() {}


  Collection.Keyed = KeyedCollection;
  Collection.Indexed = IndexedCollection;
  Collection.Set = SetCollection;

  var imul =
    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
    Math.imul :
    function imul(a, b) {
      a = a | 0; // int
      b = b | 0; // int
      var c = a & 0xffff;
      var d = b & 0xffff;
      // Shift by 0 fixes the sign on the high part.
      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
    };

  // v8 has an optimization for storing 31-bit signed numbers.
  // Values which have either 00 or 11 as the high order bits qualify.
  // This function drops the highest order bit in a signed number, maintaining
  // the sign bit.
  function smi(i32) {
    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
  }

  function hash(o) {
    if (o === false || o === null || o === undefined) {
      return 0;
    }
    if (typeof o.valueOf === 'function') {
      o = o.valueOf();
      if (o === false || o === null || o === undefined) {
        return 0;
      }
    }
    if (o === true) {
      return 1;
    }
    var type = typeof o;
    if (type === 'number') {
      var h = o | 0;
      if (h !== o) {
        h ^= o * 0xFFFFFFFF;
      }
      while (o > 0xFFFFFFFF) {
        o /= 0xFFFFFFFF;
        h ^= o;
      }
      return smi(h);
    }
    if (type === 'string') {
      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    }
    if (typeof o.hashCode === 'function') {
      return o.hashCode();
    }
    if (type === 'object') {
      return hashJSObj(o);
    }
    if (typeof o.toString === 'function') {
      return hashString(o.toString());
    }
    throw new Error('Value type ' + type + ' cannot be hashed.');
  }

  function cachedHashString(string) {
    var hash = stringHashCache[string];
    if (hash === undefined) {
      hash = hashString(string);
      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
        STRING_HASH_CACHE_SIZE = 0;
        stringHashCache = {};
      }
      STRING_HASH_CACHE_SIZE++;
      stringHashCache[string] = hash;
    }
    return hash;
  }

  // http://jsperf.com/hashing-strings
  function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hash = 0;
    for (var ii = 0; ii < string.length; ii++) {
      hash = 31 * hash + string.charCodeAt(ii) | 0;
    }
    return smi(hash);
  }

  function hashJSObj(obj) {
    var hash;
    if (usingWeakMap) {
      hash = weakMap.get(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = obj[UID_HASH_KEY];
    if (hash !== undefined) {
      return hash;
    }

    if (!canDefineProperty) {
      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
      if (hash !== undefined) {
        return hash;
      }

      hash = getIENodeHash(obj);
      if (hash !== undefined) {
        return hash;
      }
    }

    hash = ++objHashUID;
    if (objHashUID & 0x40000000) {
      objHashUID = 0;
    }

    if (usingWeakMap) {
      weakMap.set(obj, hash);
    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
      throw new Error('Non-extensible objects are not allowed as keys.');
    } else if (canDefineProperty) {
      Object.defineProperty(obj, UID_HASH_KEY, {
        'enumerable': false,
        'configurable': false,
        'writable': false,
        'value': hash
      });
    } else if (obj.propertyIsEnumerable !== undefined &&
               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
      // Since we can't define a non-enumerable property on the object
      // we'll hijack one of the less-used non-enumerable properties to
      // save our hash on it. Since this is a function it will not show up in
      // `JSON.stringify` which is what we want.
      obj.propertyIsEnumerable = function() {
        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
      };
      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
    } else if (obj.nodeType !== undefined) {
      // At this point we couldn't get the IE `uniqueID` to use as a hash
      // and we couldn't use a non-enumerable property to exploit the
      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
      // itself.
      obj[UID_HASH_KEY] = hash;
    } else {
      throw new Error('Unable to set a non-enumerable property on object.');
    }

    return hash;
  }

  // Get references to ES5 object methods.
  var isExtensible = Object.isExtensible;

  // True if Object.defineProperty works as expected. IE8 fails this test.
  var canDefineProperty = (function() {
    try {
      Object.defineProperty({}, '@', {});
      return true;
    } catch (e) {
      return false;
    }
  }());

  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
  // and avoid memory leaks from the IE cloneNode bug.
  function getIENodeHash(node) {
    if (node && node.nodeType > 0) {
      switch (node.nodeType) {
        case 1: // Element
          return node.uniqueID;
        case 9: // Document
          return node.documentElement && node.documentElement.uniqueID;
      }
    }
  }

  // If possible, use a WeakMap.
  var usingWeakMap = typeof WeakMap === 'function';
  var weakMap;
  if (usingWeakMap) {
    weakMap = new WeakMap();
  }

  var objHashUID = 0;

  var UID_HASH_KEY = '__immutablehash__';
  if (typeof Symbol === 'function') {
    UID_HASH_KEY = Symbol(UID_HASH_KEY);
  }

  var STRING_HASH_CACHE_MIN_STRLEN = 16;
  var STRING_HASH_CACHE_MAX_SIZE = 255;
  var STRING_HASH_CACHE_SIZE = 0;
  var stringHashCache = {};

  function assertNotInfinite(size) {
    invariant(
      size !== Infinity,
      'Cannot perform this action with an infinite size.'
    );
  }

  createClass(Map, KeyedCollection);

    // @pragma Construction

    function Map(value) {
      return value === null || value === undefined ? emptyMap() :
        isMap(value) && !isOrdered(value) ? value :
        emptyMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    Map.prototype.toString = function() {
      return this.__toString('Map {', '}');
    };

    // @pragma Access

    Map.prototype.get = function(k, notSetValue) {
      return this._root ?
        this._root.get(0, undefined, k, notSetValue) :
        notSetValue;
    };

    // @pragma Modification

    Map.prototype.set = function(k, v) {
      return updateMap(this, k, v);
    };

    Map.prototype.setIn = function(keyPath, v) {
      return this.updateIn(keyPath, NOT_SET, function()  {return v});
    };

    Map.prototype.remove = function(k) {
      return updateMap(this, k, NOT_SET);
    };

    Map.prototype.deleteIn = function(keyPath) {
      return this.updateIn(keyPath, function()  {return NOT_SET});
    };

    Map.prototype.update = function(k, notSetValue, updater) {
      return arguments.length === 1 ?
        k(this) :
        this.updateIn([k], notSetValue, updater);
    };

    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
      if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
      }
      var updatedValue = updateInDeepMap(
        this,
        forceIterator(keyPath),
        notSetValue,
        updater
      );
      return updatedValue === NOT_SET ? undefined : updatedValue;
    };

    Map.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._root = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyMap();
    };

    // @pragma Composition

    Map.prototype.merge = function(/*...iters*/) {
      return mergeIntoMapWith(this, undefined, arguments);
    };

    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, merger, iters);
    };

    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.merge === 'function' ?
          m.merge.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoMapWith(this, deepMerger, arguments);
    };

    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
    };

    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
      return this.updateIn(
        keyPath,
        emptyMap(),
        function(m ) {return typeof m.mergeDeep === 'function' ?
          m.mergeDeep.apply(m, iters) :
          iters[iters.length - 1]}
      );
    };

    Map.prototype.sort = function(comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator));
    };

    Map.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedMap(sortFactory(this, comparator, mapper));
    };

    // @pragma Mutability

    Map.prototype.withMutations = function(fn) {
      var mutable = this.asMutable();
      fn(mutable);
      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
    };

    Map.prototype.asMutable = function() {
      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
    };

    Map.prototype.asImmutable = function() {
      return this.__ensureOwner();
    };

    Map.prototype.wasAltered = function() {
      return this.__altered;
    };

    Map.prototype.__iterator = function(type, reverse) {
      return new MapIterator(this, type, reverse);
    };

    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      this._root && this._root.iterate(function(entry ) {
        iterations++;
        return fn(entry[1], entry[0], this$0);
      }, reverse);
      return iterations;
    };

    Map.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeMap(this.size, this._root, ownerID, this.__hash);
    };


  function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
  }

  Map.isMap = isMap;

  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';

  var MapPrototype = Map.prototype;
  MapPrototype[IS_MAP_SENTINEL] = true;
  MapPrototype[DELETE] = MapPrototype.remove;
  MapPrototype.removeIn = MapPrototype.deleteIn;


  // #pragma Trie Nodes



    function ArrayMapNode(ownerID, entries) {
      this.ownerID = ownerID;
      this.entries = entries;
    }

    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && entries.length === 1) {
        return; // undefined
      }

      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
        return createNodes(ownerID, entries, key, value);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new ArrayMapNode(ownerID, newEntries);
    };




    function BitmapIndexedNode(ownerID, bitmap, nodes) {
      this.ownerID = ownerID;
      this.bitmap = bitmap;
      this.nodes = nodes;
    }

    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
      var bitmap = this.bitmap;
      return (bitmap & bit) === 0 ? notSetValue :
        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
    };

    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var bit = 1 << keyHashFrag;
      var bitmap = this.bitmap;
      var exists = (bitmap & bit) !== 0;

      if (!exists && value === NOT_SET) {
        return this;
      }

      var idx = popCount(bitmap & (bit - 1));
      var nodes = this.nodes;
      var node = exists ? nodes[idx] : undefined;
      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);

      if (newNode === node) {
        return this;
      }

      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
      }

      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
        return nodes[idx ^ 1];
      }

      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
        return newNode;
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
      var newNodes = exists ? newNode ?
        setIn(nodes, idx, newNode, isEditable) :
        spliceOut(nodes, idx, isEditable) :
        spliceIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
      }

      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
    };




    function HashArrayMapNode(ownerID, count, nodes) {
      this.ownerID = ownerID;
      this.count = count;
      this.nodes = nodes;
    }

    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var node = this.nodes[idx];
      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
    };

    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }
      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
      var removed = value === NOT_SET;
      var nodes = this.nodes;
      var node = nodes[idx];

      if (removed && !node) {
        return this;
      }

      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
      if (newNode === node) {
        return this;
      }

      var newCount = this.count;
      if (!node) {
        newCount++;
      } else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
          return packNodes(ownerID, nodes, newCount, idx);
        }
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newNodes = setIn(nodes, idx, newNode, isEditable);

      if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
      }

      return new HashArrayMapNode(ownerID, newCount, newNodes);
    };




    function HashCollisionNode(ownerID, keyHash, entries) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entries = entries;
    }

    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      var entries = this.entries;
      for (var ii = 0, len = entries.length; ii < len; ii++) {
        if (is(key, entries[ii][0])) {
          return entries[ii][1];
        }
      }
      return notSetValue;
    };

    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      if (keyHash === undefined) {
        keyHash = hash(key);
      }

      var removed = value === NOT_SET;

      if (keyHash !== this.keyHash) {
        if (removed) {
          return this;
        }
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
      }

      var entries = this.entries;
      var idx = 0;
      for (var len = entries.length; idx < len; idx++) {
        if (is(key, entries[idx][0])) {
          break;
        }
      }
      var exists = idx < len;

      if (exists ? entries[idx][1] === value : removed) {
        return this;
      }

      SetRef(didAlter);
      (removed || !exists) && SetRef(didChangeSize);

      if (removed && len === 2) {
        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
      }

      var isEditable = ownerID && ownerID === this.ownerID;
      var newEntries = isEditable ? entries : arrCopy(entries);

      if (exists) {
        if (removed) {
          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
        } else {
          newEntries[idx] = [key, value];
        }
      } else {
        newEntries.push([key, value]);
      }

      if (isEditable) {
        this.entries = newEntries;
        return this;
      }

      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
    };




    function ValueNode(ownerID, keyHash, entry) {
      this.ownerID = ownerID;
      this.keyHash = keyHash;
      this.entry = entry;
    }

    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
    };

    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
      var removed = value === NOT_SET;
      var keyMatch = is(key, this.entry[0]);
      if (keyMatch ? value === this.entry[1] : removed) {
        return this;
      }

      SetRef(didAlter);

      if (removed) {
        SetRef(didChangeSize);
        return; // undefined
      }

      if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
          this.entry[1] = value;
          return this;
        }
        return new ValueNode(ownerID, this.keyHash, [key, value]);
      }

      SetRef(didChangeSize);
      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
    };



  // #pragma Iterators

  ArrayMapNode.prototype.iterate =
  HashCollisionNode.prototype.iterate = function (fn, reverse) {
    var entries = this.entries;
    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
        return false;
      }
    }
  }

  BitmapIndexedNode.prototype.iterate =
  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
    var nodes = this.nodes;
    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
      var node = nodes[reverse ? maxIndex - ii : ii];
      if (node && node.iterate(fn, reverse) === false) {
        return false;
      }
    }
  }

  ValueNode.prototype.iterate = function (fn, reverse) {
    return fn(this.entry);
  }

  createClass(MapIterator, Iterator);

    function MapIterator(map, type, reverse) {
      this._type = type;
      this._reverse = reverse;
      this._stack = map._root && mapIteratorFrame(map._root);
    }

    MapIterator.prototype.next = function() {
      var type = this._type;
      var stack = this._stack;
      while (stack) {
        var node = stack.node;
        var index = stack.index++;
        var maxIndex;
        if (node.entry) {
          if (index === 0) {
            return mapIteratorValue(type, node.entry);
          }
        } else if (node.entries) {
          maxIndex = node.entries.length - 1;
          if (index <= maxIndex) {
            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
          }
        } else {
          maxIndex = node.nodes.length - 1;
          if (index <= maxIndex) {
            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
            if (subNode) {
              if (subNode.entry) {
                return mapIteratorValue(type, subNode.entry);
              }
              stack = this._stack = mapIteratorFrame(subNode, stack);
            }
            continue;
          }
        }
        stack = this._stack = this._stack.__prev;
      }
      return iteratorDone();
    };


  function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
  }

  function mapIteratorFrame(node, prev) {
    return {
      node: node,
      index: 0,
      __prev: prev
    };
  }

  function makeMap(size, root, ownerID, hash) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_MAP;
  function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
  }

  function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
      if (v === NOT_SET) {
        return map;
      }
      newSize = 1;
      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
    } else {
      var didChangeSize = MakeRef(CHANGE_LENGTH);
      var didAlter = MakeRef(DID_ALTER);
      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
      if (!didAlter.value) {
        return map;
      }
      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
      map.size = newSize;
      map._root = newRoot;
      map.__hash = undefined;
      map.__altered = true;
      return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
  }

  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
      if (value === NOT_SET) {
        return node;
      }
      SetRef(didAlter);
      SetRef(didChangeSize);
      return new ValueNode(ownerID, keyHash, [key, value]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
  }

  function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
  }

  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) {
      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
    }

    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;

    var newNode;
    var nodes = idx1 === idx2 ?
      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);

    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
  }

  function createNodes(ownerID, entries, key, value) {
    if (!ownerID) {
      ownerID = new OwnerID();
    }
    var node = new ValueNode(ownerID, hash(key), [key, value]);
    for (var ii = 0; ii < entries.length; ii++) {
      var entry = entries[ii];
      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
  }

  function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
      var node = nodes[ii];
      if (node !== undefined && ii !== excluding) {
        bitmap |= bit;
        packedNodes[packedII++] = node;
      }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
  }

  function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    }
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
  }

  function mergeIntoMapWith(map, merger, iterables) {
    var iters = [];
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = KeyedIterable(value);
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    return mergeIntoCollectionWith(map, merger, iters);
  }

  function deepMerger(existing, value, key) {
    return existing && existing.mergeDeep && isIterable(value) ?
      existing.mergeDeep(value) :
      is(existing, value) ? existing : value;
  }

  function deepMergerWith(merger) {
    return function(existing, value, key)  {
      if (existing && existing.mergeDeepWith && isIterable(value)) {
        return existing.mergeDeepWith(merger, value);
      }
      var nextValue = merger(existing, value, key);
      return is(existing, nextValue) ? existing : nextValue;
    };
  }

  function mergeIntoCollectionWith(collection, merger, iters) {
    iters = iters.filter(function(x ) {return x.size !== 0});
    if (iters.length === 0) {
      return collection;
    }
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
      return collection.constructor(iters[0]);
    }
    return collection.withMutations(function(collection ) {
      var mergeIntoMap = merger ?
        function(value, key)  {
          collection.update(key, NOT_SET, function(existing )
            {return existing === NOT_SET ? value : merger(existing, value, key)}
          );
        } :
        function(value, key)  {
          collection.set(key, value);
        }
      for (var ii = 0; ii < iters.length; ii++) {
        iters[ii].forEach(mergeIntoMap);
      }
    });
  }

  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
    var isNotSet = existing === NOT_SET;
    var step = keyPathIter.next();
    if (step.done) {
      var existingValue = isNotSet ? notSetValue : existing;
      var newValue = updater(existingValue);
      return newValue === existingValue ? existing : newValue;
    }
    invariant(
      isNotSet || (existing && existing.set),
      'invalid keyPath'
    );
    var key = step.value;
    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
    var nextUpdated = updateInDeepMap(
      nextExisting,
      keyPathIter,
      notSetValue,
      updater
    );
    return nextUpdated === nextExisting ? existing :
      nextUpdated === NOT_SET ? existing.remove(key) :
      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
  }

  function popCount(x) {
    x = x - ((x >> 1) & 0x55555555);
    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
    x = (x + (x >> 4)) & 0x0f0f0f0f;
    x = x + (x >> 8);
    x = x + (x >> 16);
    return x & 0x7f;
  }

  function setIn(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
  }

  function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
      array[idx] = val;
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        newArray[ii] = val;
        after = -1;
      } else {
        newArray[ii] = array[ii + after];
      }
    }
    return newArray;
  }

  function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
      array.pop();
      return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for (var ii = 0; ii < newLen; ii++) {
      if (ii === idx) {
        after = 1;
      }
      newArray[ii] = array[ii + after];
    }
    return newArray;
  }

  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;

  createClass(List, IndexedCollection);

    // @pragma Construction

    function List(value) {
      var empty = emptyList();
      if (value === null || value === undefined) {
        return empty;
      }
      if (isList(value)) {
        return value;
      }
      var iter = IndexedIterable(value);
      var size = iter.size;
      if (size === 0) {
        return empty;
      }
      assertNotInfinite(size);
      if (size > 0 && size < SIZE) {
        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
      }
      return empty.withMutations(function(list ) {
        list.setSize(size);
        iter.forEach(function(v, i)  {return list.set(i, v)});
      });
    }

    List.of = function(/*...values*/) {
      return this(arguments);
    };

    List.prototype.toString = function() {
      return this.__toString('List [', ']');
    };

    // @pragma Access

    List.prototype.get = function(index, notSetValue) {
      index = wrapIndex(this, index);
      if (index >= 0 && index < this.size) {
        index += this._origin;
        var node = listNodeFor(this, index);
        return node && node.array[index & MASK];
      }
      return notSetValue;
    };

    // @pragma Modification

    List.prototype.set = function(index, value) {
      return updateList(this, index, value);
    };

    List.prototype.remove = function(index) {
      return !this.has(index) ? this :
        index === 0 ? this.shift() :
        index === this.size - 1 ? this.pop() :
        this.splice(index, 1);
    };

    List.prototype.insert = function(index, value) {
      return this.splice(index, 0, value);
    };

    List.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = this._origin = this._capacity = 0;
        this._level = SHIFT;
        this._root = this._tail = null;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyList();
    };

    List.prototype.push = function(/*...values*/) {
      var values = arguments;
      var oldSize = this.size;
      return this.withMutations(function(list ) {
        setListBounds(list, 0, oldSize + values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(oldSize + ii, values[ii]);
        }
      });
    };

    List.prototype.pop = function() {
      return setListBounds(this, 0, -1);
    };

    List.prototype.unshift = function(/*...values*/) {
      var values = arguments;
      return this.withMutations(function(list ) {
        setListBounds(list, -values.length);
        for (var ii = 0; ii < values.length; ii++) {
          list.set(ii, values[ii]);
        }
      });
    };

    List.prototype.shift = function() {
      return setListBounds(this, 1);
    };

    // @pragma Composition

    List.prototype.merge = function(/*...iters*/) {
      return mergeIntoListWith(this, undefined, arguments);
    };

    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, merger, iters);
    };

    List.prototype.mergeDeep = function(/*...iters*/) {
      return mergeIntoListWith(this, deepMerger, arguments);
    };

    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return mergeIntoListWith(this, deepMergerWith(merger), iters);
    };

    List.prototype.setSize = function(size) {
      return setListBounds(this, 0, size);
    };

    // @pragma Iteration

    List.prototype.slice = function(begin, end) {
      var size = this.size;
      if (wholeSlice(begin, end, size)) {
        return this;
      }
      return setListBounds(
        this,
        resolveBegin(begin, size),
        resolveEnd(end, size)
      );
    };

    List.prototype.__iterator = function(type, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      return new Iterator(function()  {
        var value = values();
        return value === DONE ?
          iteratorDone() :
          iteratorValue(type, index++, value);
      });
    };

    List.prototype.__iterate = function(fn, reverse) {
      var index = 0;
      var values = iterateList(this, reverse);
      var value;
      while ((value = values()) !== DONE) {
        if (fn(value, index++, this) === false) {
          break;
        }
      }
      return index;
    };

    List.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        return this;
      }
      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };


  function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
  }

  List.isList = isList;

  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';

  var ListPrototype = List.prototype;
  ListPrototype[IS_LIST_SENTINEL] = true;
  ListPrototype[DELETE] = ListPrototype.remove;
  ListPrototype.setIn = MapPrototype.setIn;
  ListPrototype.deleteIn =
  ListPrototype.removeIn = MapPrototype.removeIn;
  ListPrototype.update = MapPrototype.update;
  ListPrototype.updateIn = MapPrototype.updateIn;
  ListPrototype.mergeIn = MapPrototype.mergeIn;
  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  ListPrototype.withMutations = MapPrototype.withMutations;
  ListPrototype.asMutable = MapPrototype.asMutable;
  ListPrototype.asImmutable = MapPrototype.asImmutable;
  ListPrototype.wasAltered = MapPrototype.wasAltered;



    function VNode(array, ownerID) {
      this.array = array;
      this.ownerID = ownerID;
    }

    // TODO: seems like these methods are very similar

    VNode.prototype.removeBefore = function(ownerID, level, index) {
      if (index === level ? 1 << level : 0 || this.array.length === 0) {
        return this;
      }
      var originIndex = (index >>> level) & MASK;
      if (originIndex >= this.array.length) {
        return new VNode([], ownerID);
      }
      var removingFirst = originIndex === 0;
      var newChild;
      if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) {
          return this;
        }
      }
      if (removingFirst && !newChild) {
        return this;
      }
      var editable = editableVNode(this, ownerID);
      if (!removingFirst) {
        for (var ii = 0; ii < originIndex; ii++) {
          editable.array[ii] = undefined;
        }
      }
      if (newChild) {
        editable.array[originIndex] = newChild;
      }
      return editable;
    };

    VNode.prototype.removeAfter = function(ownerID, level, index) {
      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
        return this;
      }
      var sizeIndex = ((index - 1) >>> level) & MASK;
      if (sizeIndex >= this.array.length) {
        return this;
      }

      var newChild;
      if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
          return this;
        }
      }

      var editable = editableVNode(this, ownerID);
      editable.array.splice(sizeIndex + 1);
      if (newChild) {
        editable.array[sizeIndex] = newChild;
      }
      return editable;
    };



  var DONE = {};

  function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;

    return iterateNodeOrLeaf(list._root, list._level, 0);

    function iterateNodeOrLeaf(node, level, offset) {
      return level === 0 ?
        iterateLeaf(node, offset) :
        iterateNode(node, level, offset);
    }

    function iterateLeaf(node, offset) {
      var array = offset === tailPos ? tail && tail.array : node && node.array;
      var from = offset > left ? 0 : left - offset;
      var to = right - offset;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        if (from === to) {
          return DONE;
        }
        var idx = reverse ? --to : from++;
        return array && array[idx];
      };
    }

    function iterateNode(node, level, offset) {
      var values;
      var array = node && node.array;
      var from = offset > left ? 0 : (left - offset) >> level;
      var to = ((right - offset) >> level) + 1;
      if (to > SIZE) {
        to = SIZE;
      }
      return function()  {
        do {
          if (values) {
            var value = values();
            if (value !== DONE) {
              return value;
            }
            values = null;
          }
          if (from === to) {
            return DONE;
          }
          var idx = reverse ? --to : from++;
          values = iterateNodeOrLeaf(
            array && array[idx], level - SHIFT, offset + (idx << level)
          );
        } while (true);
      };
    }
  }

  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
  }

  var EMPTY_LIST;
  function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
  }

  function updateList(list, index, value) {
    index = wrapIndex(list, index);

    if (index !== index) {
      return list;
    }

    if (index >= list.size || index < 0) {
      return list.withMutations(function(list ) {
        index < 0 ?
          setListBounds(list, index).set(0, value) :
          setListBounds(list, 0, index + 1).set(index, value)
      });
    }

    index += list._origin;

    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) {
      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    } else {
      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    }

    if (!didAlter.value) {
      return list;
    }

    if (list.__ownerID) {
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
  }

  function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = (index >>> level) & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) {
      return node;
    }

    var newNode;

    if (level > 0) {
      var lowerNode = node && node.array[idx];
      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
      if (newLowerNode === lowerNode) {
        return node;
      }
      newNode = editableVNode(node, ownerID);
      newNode.array[idx] = newLowerNode;
      return newNode;
    }

    if (nodeHas && node.array[idx] === value) {
      return node;
    }

    SetRef(didAlter);

    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) {
      newNode.array.pop();
    } else {
      newNode.array[idx] = value;
    }
    return newNode;
  }

  function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) {
      return node;
    }
    return new VNode(node ? node.array.slice() : [], ownerID);
  }

  function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) {
      return list._tail;
    }
    if (rawIndex < 1 << (list._level + SHIFT)) {
      var node = list._root;
      var level = list._level;
      while (node && level > 0) {
        node = node.array[(rawIndex >>> level) & MASK];
        level -= SHIFT;
      }
      return node;
    }
  }

  function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
      return list;
    }

    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) {
      return list.clear();
    }

    var newLevel = list._level;
    var newRoot = list._root;

    // New origin might need creating a higher root.
    var offsetShift = 0;
    while (newOrigin + offsetShift < 0) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
      newLevel += SHIFT;
      offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
      newOrigin += offsetShift;
      oldOrigin += offsetShift;
      newCapacity += offsetShift;
      oldCapacity += offsetShift;
    }

    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);

    // New size might need creating a higher root.
    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
      newLevel += SHIFT;
    }

    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ?
      listNodeFor(list, newCapacity - 1) :
      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;

    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
      newRoot = editableVNode(newRoot, owner);
      var node = newRoot;
      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
        var idx = (oldTailOffset >>> level) & MASK;
        node = node.array[idx] = editableVNode(node.array[idx], owner);
      }
      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
    }

    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) {
      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    }

    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
      newOrigin -= newTailOffset;
      newCapacity -= newTailOffset;
      newLevel = SHIFT;
      newRoot = null;
      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);

    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
      offsetShift = 0;

      // Identify the new top root node of the subtree of the old root.
      while (newRoot) {
        var beginIndex = (newOrigin >>> newLevel) & MASK;
        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
          break;
        }
        if (beginIndex) {
          offsetShift += (1 << newLevel) * beginIndex;
        }
        newLevel -= SHIFT;
        newRoot = newRoot.array[beginIndex];
      }

      // Trim the new sides of the new root.
      if (newRoot && newOrigin > oldOrigin) {
        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
      }
      if (newRoot && newTailOffset < oldTailOffset) {
        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
      }
      if (offsetShift) {
        newOrigin -= offsetShift;
        newCapacity -= offsetShift;
      }
    }

    if (list.__ownerID) {
      list.size = newCapacity - newOrigin;
      list._origin = newOrigin;
      list._capacity = newCapacity;
      list._level = newLevel;
      list._root = newRoot;
      list._tail = newTail;
      list.__hash = undefined;
      list.__altered = true;
      return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
  }

  function mergeIntoListWith(list, merger, iterables) {
    var iters = [];
    var maxSize = 0;
    for (var ii = 0; ii < iterables.length; ii++) {
      var value = iterables[ii];
      var iter = IndexedIterable(value);
      if (iter.size > maxSize) {
        maxSize = iter.size;
      }
      if (!isIterable(value)) {
        iter = iter.map(function(v ) {return fromJS(v)});
      }
      iters.push(iter);
    }
    if (maxSize > list.size) {
      list = list.setSize(maxSize);
    }
    return mergeIntoCollectionWith(list, merger, iters);
  }

  function getTailOffset(size) {
    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
  }

  createClass(OrderedMap, Map);

    // @pragma Construction

    function OrderedMap(value) {
      return value === null || value === undefined ? emptyOrderedMap() :
        isOrderedMap(value) ? value :
        emptyOrderedMap().withMutations(function(map ) {
          var iter = KeyedIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v, k)  {return map.set(k, v)});
        });
    }

    OrderedMap.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedMap.prototype.toString = function() {
      return this.__toString('OrderedMap {', '}');
    };

    // @pragma Access

    OrderedMap.prototype.get = function(k, notSetValue) {
      var index = this._map.get(k);
      return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };

    // @pragma Modification

    OrderedMap.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._map.clear();
        this._list.clear();
        return this;
      }
      return emptyOrderedMap();
    };

    OrderedMap.prototype.set = function(k, v) {
      return updateOrderedMap(this, k, v);
    };

    OrderedMap.prototype.remove = function(k) {
      return updateOrderedMap(this, k, NOT_SET);
    };

    OrderedMap.prototype.wasAltered = function() {
      return this._map.wasAltered() || this._list.wasAltered();
    };

    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._list.__iterate(
        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
        reverse
      );
    };

    OrderedMap.prototype.__iterator = function(type, reverse) {
      return this._list.fromEntrySeq().__iterator(type, reverse);
    };

    OrderedMap.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      var newList = this._list.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        this._list = newList;
        return this;
      }
      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };


  function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
  }

  OrderedMap.isOrderedMap = isOrderedMap;

  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;



  function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
  }

  var EMPTY_ORDERED_MAP;
  function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
  }

  function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) { // removed
      if (!has) {
        return omap;
      }
      if (list.size >= SIZE && list.size >= map.size * 2) {
        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
        if (omap.__ownerID) {
          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        }
      } else {
        newMap = map.remove(k);
        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
      }
    } else {
      if (has) {
        if (v === list.get(i)[1]) {
          return omap;
        }
        newMap = map;
        newList = list.set(i, [k, v]);
      } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [k, v]);
      }
    }
    if (omap.__ownerID) {
      omap.size = newMap.size;
      omap._map = newMap;
      omap._list = newList;
      omap.__hash = undefined;
      return omap;
    }
    return makeOrderedMap(newMap, newList);
  }

  createClass(ToKeyedSequence, KeyedSeq);
    function ToKeyedSequence(indexed, useKeys) {
      this._iter = indexed;
      this._useKeys = useKeys;
      this.size = indexed.size;
    }

    ToKeyedSequence.prototype.get = function(key, notSetValue) {
      return this._iter.get(key, notSetValue);
    };

    ToKeyedSequence.prototype.has = function(key) {
      return this._iter.has(key);
    };

    ToKeyedSequence.prototype.valueSeq = function() {
      return this._iter.valueSeq();
    };

    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
      var reversedSequence = reverseFactory(this, true);
      if (!this._useKeys) {
        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
      }
      return reversedSequence;
    };

    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
      var mappedSequence = mapFactory(this, mapper, context);
      if (!this._useKeys) {
        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
      }
      return mappedSequence;
    };

    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var ii;
      return this._iter.__iterate(
        this._useKeys ?
          function(v, k)  {return fn(v, k, this$0)} :
          ((ii = reverse ? resolveSize(this) : 0),
            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
        reverse
      );
    };

    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
      if (this._useKeys) {
        return this._iter.__iterator(type, reverse);
      }
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var ii = reverse ? resolveSize(this) : 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
      });
    };

  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;


  createClass(ToIndexedSequence, IndexedSeq);
    function ToIndexedSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToIndexedSequence.prototype.includes = function(value) {
      return this._iter.includes(value);
    };

    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
    };

    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, iterations++, step.value, step)
      });
    };



  createClass(ToSetSequence, SetSeq);
    function ToSetSequence(iter) {
      this._iter = iter;
      this.size = iter.size;
    }

    ToSetSequence.prototype.has = function(key) {
      return this._iter.includes(key);
    };

    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
    };

    ToSetSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        return step.done ? step :
          iteratorValue(type, step.value, step.value, step);
      });
    };



  createClass(FromEntriesSequence, KeyedSeq);
    function FromEntriesSequence(entries) {
      this._iter = entries;
      this.size = entries.size;
    }

    FromEntriesSequence.prototype.entrySeq = function() {
      return this._iter.toSeq();
    };

    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._iter.__iterate(function(entry ) {
        // Check if entry exists first so array access doesn't throw for holes
        // in the parent iteration.
        if (entry) {
          validateEntry(entry);
          var indexedIterable = isIterable(entry);
          return fn(
            indexedIterable ? entry.get(1) : entry[1],
            indexedIterable ? entry.get(0) : entry[0],
            this$0
          );
        }
      }, reverse);
    };

    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          // Check if entry exists first so array access doesn't throw for holes
          // in the parent iteration.
          if (entry) {
            validateEntry(entry);
            var indexedIterable = isIterable(entry);
            return iteratorValue(
              type,
              indexedIterable ? entry.get(0) : entry[0],
              indexedIterable ? entry.get(1) : entry[1],
              step
            );
          }
        }
      });
    };


  ToIndexedSequence.prototype.cacheResult =
  ToKeyedSequence.prototype.cacheResult =
  ToSetSequence.prototype.cacheResult =
  FromEntriesSequence.prototype.cacheResult =
    cacheResultThrough;


  function flipFactory(iterable) {
    var flipSequence = makeSequence(iterable);
    flipSequence._iter = iterable;
    flipSequence.size = iterable.size;
    flipSequence.flip = function()  {return iterable};
    flipSequence.reverse = function () {
      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
      reversedSequence.flip = function()  {return iterable.reverse()};
      return reversedSequence;
    };
    flipSequence.has = function(key ) {return iterable.includes(key)};
    flipSequence.includes = function(key ) {return iterable.has(key)};
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
    }
    flipSequence.__iteratorUncached = function(type, reverse) {
      if (type === ITERATE_ENTRIES) {
        var iterator = iterable.__iterator(type, reverse);
        return new Iterator(function()  {
          var step = iterator.next();
          if (!step.done) {
            var k = step.value[0];
            step.value[0] = step.value[1];
            step.value[1] = k;
          }
          return step;
        });
      }
      return iterable.__iterator(
        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
        reverse
      );
    }
    return flipSequence;
  }


  function mapFactory(iterable, mapper, context) {
    var mappedSequence = makeSequence(iterable);
    mappedSequence.size = iterable.size;
    mappedSequence.has = function(key ) {return iterable.has(key)};
    mappedSequence.get = function(key, notSetValue)  {
      var v = iterable.get(key, NOT_SET);
      return v === NOT_SET ?
        notSetValue :
        mapper.call(context, v, key, iterable);
    };
    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(
        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
        reverse
      );
    }
    mappedSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      return new Iterator(function()  {
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var key = entry[0];
        return iteratorValue(
          type,
          key,
          mapper.call(context, entry[1], key, iterable),
          step
        );
      });
    }
    return mappedSequence;
  }


  function reverseFactory(iterable, useKeys) {
    var reversedSequence = makeSequence(iterable);
    reversedSequence._iter = iterable;
    reversedSequence.size = iterable.size;
    reversedSequence.reverse = function()  {return iterable};
    if (iterable.flip) {
      reversedSequence.flip = function () {
        var flipSequence = flipFactory(iterable);
        flipSequence.reverse = function()  {return iterable.flip()};
        return flipSequence;
      };
    }
    reversedSequence.get = function(key, notSetValue) 
      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
    reversedSequence.has = function(key )
      {return iterable.has(useKeys ? key : -1 - key)};
    reversedSequence.includes = function(value ) {return iterable.includes(value)};
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
    };
    reversedSequence.__iterator =
      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
    return reversedSequence;
  }


  function filterFactory(iterable, predicate, context, useKeys) {
    var filterSequence = makeSequence(iterable);
    if (useKeys) {
      filterSequence.has = function(key ) {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
      };
      filterSequence.get = function(key, notSetValue)  {
        var v = iterable.get(key, NOT_SET);
        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
          v : notSetValue;
      };
    }
    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      }, reverse);
      return iterations;
    };
    filterSequence.__iteratorUncached = function (type, reverse) {
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterations = 0;
      return new Iterator(function()  {
        while (true) {
          var step = iterator.next();
          if (step.done) {
            return step;
          }
          var entry = step.value;
          var key = entry[0];
          var value = entry[1];
          if (predicate.call(context, value, key, iterable)) {
            return iteratorValue(type, useKeys ? key : iterations++, value, step);
          }
        }
      });
    }
    return filterSequence;
  }


  function countByFactory(iterable, grouper, context) {
    var groups = Map().asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        0,
        function(a ) {return a + 1}
      );
    });
    return groups.asImmutable();
  }


  function groupByFactory(iterable, grouper, context) {
    var isKeyedIter = isKeyed(iterable);
    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
    iterable.__iterate(function(v, k)  {
      groups.update(
        grouper.call(context, v, k, iterable),
        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
      );
    });
    var coerce = iterableClass(iterable);
    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
  }


  function sliceFactory(iterable, begin, end, useKeys) {
    var originalSize = iterable.size;

    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) {
      begin = begin | 0;
    }
    if (end !== undefined) {
      end = end | 0;
    }

    if (wholeSlice(begin, end, originalSize)) {
      return iterable;
    }

    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);

    // begin or end will be NaN if they were provided as negative numbers and
    // this iterable's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
    }

    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) {
      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    }

    var sliceSeq = makeSequence(iterable);

    // If iterable.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;

    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
      sliceSeq.get = function (index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ?
          iterable.get(index + resolvedBegin, notSetValue) :
          notSetValue;
      }
    }

    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (sliceSize === 0) {
        return 0;
      }
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var skipped = 0;
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k)  {
        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
                 iterations !== sliceSize;
        }
      });
      return iterations;
    };

    sliceSeq.__iteratorUncached = function(type, reverse) {
      if (sliceSize !== 0 && reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      // Don't bother instantiating parent iterator if taking 0.
      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
      var skipped = 0;
      var iterations = 0;
      return new Iterator(function()  {
        while (skipped++ < resolvedBegin) {
          iterator.next();
        }
        if (++iterations > sliceSize) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (useKeys || type === ITERATE_VALUES) {
          return step;
        } else if (type === ITERATE_KEYS) {
          return iteratorValue(type, iterations - 1, undefined, step);
        } else {
          return iteratorValue(type, iterations - 1, step.value[1], step);
        }
      });
    }

    return sliceSeq;
  }


  function takeWhileFactory(iterable, predicate, context) {
    var takeSequence = makeSequence(iterable);
    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var iterations = 0;
      iterable.__iterate(function(v, k, c) 
        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
      );
      return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var iterating = true;
      return new Iterator(function()  {
        if (!iterating) {
          return iteratorDone();
        }
        var step = iterator.next();
        if (step.done) {
          return step;
        }
        var entry = step.value;
        var k = entry[0];
        var v = entry[1];
        if (!predicate.call(context, v, k, this$0)) {
          iterating = false;
          return iteratorDone();
        }
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return takeSequence;
  }


  function skipWhileFactory(iterable, predicate, context, useKeys) {
    var skipSequence = makeSequence(iterable);
    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterate(fn, reverse);
      }
      var isSkipping = true;
      var iterations = 0;
      iterable.__iterate(function(v, k, c)  {
        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
          iterations++;
          return fn(v, useKeys ? k : iterations - 1, this$0);
        }
      });
      return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
      if (reverse) {
        return this.cacheResult().__iterator(type, reverse);
      }
      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
      var skipping = true;
      var iterations = 0;
      return new Iterator(function()  {
        var step, k, v;
        do {
          step = iterator.next();
          if (step.done) {
            if (useKeys || type === ITERATE_VALUES) {
              return step;
            } else if (type === ITERATE_KEYS) {
              return iteratorValue(type, iterations++, undefined, step);
            } else {
              return iteratorValue(type, iterations++, step.value[1], step);
            }
          }
          var entry = step.value;
          k = entry[0];
          v = entry[1];
          skipping && (skipping = predicate.call(context, v, k, this$0));
        } while (skipping);
        return type === ITERATE_ENTRIES ? step :
          iteratorValue(type, k, v, step);
      });
    };
    return skipSequence;
  }


  function concatFactory(iterable, values) {
    var isKeyedIterable = isKeyed(iterable);
    var iters = [iterable].concat(values).map(function(v ) {
      if (!isIterable(v)) {
        v = isKeyedIterable ?
          keyedSeqFromValue(v) :
          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
      } else if (isKeyedIterable) {
        v = KeyedIterable(v);
      }
      return v;
    }).filter(function(v ) {return v.size !== 0});

    if (iters.length === 0) {
      return iterable;
    }

    if (iters.length === 1) {
      var singleton = iters[0];
      if (singleton === iterable ||
          isKeyedIterable && isKeyed(singleton) ||
          isIndexed(iterable) && isIndexed(singleton)) {
        return singleton;
      }
    }

    var concatSeq = new ArraySeq(iters);
    if (isKeyedIterable) {
      concatSeq = concatSeq.toKeyedSeq();
    } else if (!isIndexed(iterable)) {
      concatSeq = concatSeq.toSetSeq();
    }
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(
      function(sum, seq)  {
        if (sum !== undefined) {
          var size = seq.size;
          if (size !== undefined) {
            return sum + size;
          }
        }
      },
      0
    );
    return concatSeq;
  }


  function flattenFactory(iterable, depth, useKeys) {
    var flatSequence = makeSequence(iterable);
    flatSequence.__iterateUncached = function(fn, reverse) {
      var iterations = 0;
      var stopped = false;
      function flatDeep(iter, currentDepth) {var this$0 = this;
        iter.__iterate(function(v, k)  {
          if ((!depth || currentDepth < depth) && isIterable(v)) {
            flatDeep(v, currentDepth + 1);
          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
            stopped = true;
          }
          return !stopped;
        }, reverse);
      }
      flatDeep(iterable, 0);
      return iterations;
    }
    flatSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(type, reverse);
      var stack = [];
      var iterations = 0;
      return new Iterator(function()  {
        while (iterator) {
          var step = iterator.next();
          if (step.done !== false) {
            iterator = stack.pop();
            continue;
          }
          var v = step.value;
          if (type === ITERATE_ENTRIES) {
            v = v[1];
          }
          if ((!depth || stack.length < depth) && isIterable(v)) {
            stack.push(iterator);
            iterator = v.__iterator(type, reverse);
          } else {
            return useKeys ? step : iteratorValue(type, iterations++, v, step);
          }
        }
        return iteratorDone();
      });
    }
    return flatSequence;
  }


  function flatMapFactory(iterable, mapper, context) {
    var coerce = iterableClass(iterable);
    return iterable.toSeq().map(
      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
    ).flatten(true);
  }


  function interposeFactory(iterable, separator) {
    var interposedSequence = makeSequence(iterable);
    interposedSequence.size = iterable.size && iterable.size * 2 -1;
    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
      var iterations = 0;
      iterable.__iterate(function(v, k) 
        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
        fn(v, iterations++, this$0) !== false},
        reverse
      );
      return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
      var iterations = 0;
      var step;
      return new Iterator(function()  {
        if (!step || iterations % 2) {
          step = iterator.next();
          if (step.done) {
            return step;
          }
        }
        return iterations % 2 ?
          iteratorValue(type, iterations++, separator) :
          iteratorValue(type, iterations++, step.value, step);
      });
    };
    return interposedSequence;
  }


  function sortFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    var isKeyedIterable = isKeyed(iterable);
    var index = 0;
    var entries = iterable.toSeq().map(
      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
    ).toArray();
    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
      isKeyedIterable ?
      function(v, i)  { entries[i].length = 2; } :
      function(v, i)  { entries[i] = v[1]; }
    );
    return isKeyedIterable ? KeyedSeq(entries) :
      isIndexed(iterable) ? IndexedSeq(entries) :
      SetSeq(entries);
  }


  function maxFactory(iterable, comparator, mapper) {
    if (!comparator) {
      comparator = defaultComparator;
    }
    if (mapper) {
      var entry = iterable.toSeq()
        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
      return entry && entry[0];
    } else {
      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
    }
  }

  function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
  }


  function zipWithFactory(keyIter, zipper, iters) {
    var zipSequence = makeSequence(keyIter);
    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
      /* generic:
      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        iterations++;
        if (fn(step.value[1], step.value[0], this) === false) {
          break;
        }
      }
      return iterations;
      */
      // indexed:
      var iterator = this.__iterator(ITERATE_VALUES, reverse);
      var step;
      var iterations = 0;
      while (!(step = iterator.next()).done) {
        if (fn(step.value, iterations++, this) === false) {
          break;
        }
      }
      return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
      var iterators = iters.map(function(i )
        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
      );
      var iterations = 0;
      var isDone = false;
      return new Iterator(function()  {
        var steps;
        if (!isDone) {
          steps = iterators.map(function(i ) {return i.next()});
          isDone = steps.some(function(s ) {return s.done});
        }
        if (isDone) {
          return iteratorDone();
        }
        return iteratorValue(
          type,
          iterations++,
          zipper.apply(null, steps.map(function(s ) {return s.value}))
        );
      });
    };
    return zipSequence
  }


  // #pragma Helper Functions

  function reify(iter, seq) {
    return isSeq(iter) ? seq : iter.constructor(seq);
  }

  function validateEntry(entry) {
    if (entry !== Object(entry)) {
      throw new TypeError('Expected [K, V] tuple: ' + entry);
    }
  }

  function resolveSize(iter) {
    assertNotInfinite(iter.size);
    return ensureSize(iter);
  }

  function iterableClass(iterable) {
    return isKeyed(iterable) ? KeyedIterable :
      isIndexed(iterable) ? IndexedIterable :
      SetIterable;
  }

  function makeSequence(iterable) {
    return Object.create(
      (
        isKeyed(iterable) ? KeyedSeq :
        isIndexed(iterable) ? IndexedSeq :
        SetSeq
      ).prototype
    );
  }

  function cacheResultThrough() {
    if (this._iter.cacheResult) {
      this._iter.cacheResult();
      this.size = this._iter.size;
      return this;
    } else {
      return Seq.prototype.cacheResult.call(this);
    }
  }

  function defaultComparator(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  function forceIterator(keyPath) {
    var iter = getIterator(keyPath);
    if (!iter) {
      // Array might not be iterable in this environment, so we need a fallback
      // to our wrapped type.
      if (!isArrayLike(keyPath)) {
        throw new TypeError('Expected iterable or array-like: ' + keyPath);
      }
      iter = getIterator(Iterable(keyPath));
    }
    return iter;
  }

  createClass(Record, KeyedCollection);

    function Record(defaultValues, name) {
      var hasInitialized;

      var RecordType = function Record(values) {
        if (values instanceof RecordType) {
          return values;
        }
        if (!(this instanceof RecordType)) {
          return new RecordType(values);
        }
        if (!hasInitialized) {
          hasInitialized = true;
          var keys = Object.keys(defaultValues);
          setProps(RecordTypePrototype, keys);
          RecordTypePrototype.size = keys.length;
          RecordTypePrototype._name = name;
          RecordTypePrototype._keys = keys;
          RecordTypePrototype._defaultValues = defaultValues;
        }
        this._map = Map(values);
      };

      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
      RecordTypePrototype.constructor = RecordType;

      return RecordType;
    }

    Record.prototype.toString = function() {
      return this.__toString(recordName(this) + ' {', '}');
    };

    // @pragma Access

    Record.prototype.has = function(k) {
      return this._defaultValues.hasOwnProperty(k);
    };

    Record.prototype.get = function(k, notSetValue) {
      if (!this.has(k)) {
        return notSetValue;
      }
      var defaultVal = this._defaultValues[k];
      return this._map ? this._map.get(k, defaultVal) : defaultVal;
    };

    // @pragma Modification

    Record.prototype.clear = function() {
      if (this.__ownerID) {
        this._map && this._map.clear();
        return this;
      }
      var RecordType = this.constructor;
      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
    };

    Record.prototype.set = function(k, v) {
      if (!this.has(k)) {
        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
      }
      var newMap = this._map && this._map.set(k, v);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.remove = function(k) {
      if (!this.has(k)) {
        return this;
      }
      var newMap = this._map && this._map.remove(k);
      if (this.__ownerID || newMap === this._map) {
        return this;
      }
      return makeRecord(this, newMap);
    };

    Record.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
    };

    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
    };

    Record.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map && this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return makeRecord(this, newMap, ownerID);
    };


  var RecordPrototype = Record.prototype;
  RecordPrototype[DELETE] = RecordPrototype.remove;
  RecordPrototype.deleteIn =
  RecordPrototype.removeIn = MapPrototype.removeIn;
  RecordPrototype.merge = MapPrototype.merge;
  RecordPrototype.mergeWith = MapPrototype.mergeWith;
  RecordPrototype.mergeIn = MapPrototype.mergeIn;
  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
  RecordPrototype.setIn = MapPrototype.setIn;
  RecordPrototype.update = MapPrototype.update;
  RecordPrototype.updateIn = MapPrototype.updateIn;
  RecordPrototype.withMutations = MapPrototype.withMutations;
  RecordPrototype.asMutable = MapPrototype.asMutable;
  RecordPrototype.asImmutable = MapPrototype.asImmutable;


  function makeRecord(likeRecord, map, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._map = map;
    record.__ownerID = ownerID;
    return record;
  }

  function recordName(record) {
    return record._name || record.constructor.name || 'Record';
  }

  function setProps(prototype, names) {
    try {
      names.forEach(setProp.bind(undefined, prototype));
    } catch (error) {
      // Object.defineProperty failed. Probably IE8.
    }
  }

  function setProp(prototype, name) {
    Object.defineProperty(prototype, name, {
      get: function() {
        return this.get(name);
      },
      set: function(value) {
        invariant(this.__ownerID, 'Cannot set on an immutable record.');
        this.set(name, value);
      }
    });
  }

  createClass(Set, SetCollection);

    // @pragma Construction

    function Set(value) {
      return value === null || value === undefined ? emptySet() :
        isSet(value) && !isOrdered(value) ? value :
        emptySet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    Set.of = function(/*...values*/) {
      return this(arguments);
    };

    Set.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    Set.prototype.toString = function() {
      return this.__toString('Set {', '}');
    };

    // @pragma Access

    Set.prototype.has = function(value) {
      return this._map.has(value);
    };

    // @pragma Modification

    Set.prototype.add = function(value) {
      return updateSet(this, this._map.set(value, true));
    };

    Set.prototype.remove = function(value) {
      return updateSet(this, this._map.remove(value));
    };

    Set.prototype.clear = function() {
      return updateSet(this, this._map.clear());
    };

    // @pragma Composition

    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
      iters = iters.filter(function(x ) {return x.size !== 0});
      if (iters.length === 0) {
        return this;
      }
      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
        return this.constructor(iters[0]);
      }
      return this.withMutations(function(set ) {
        for (var ii = 0; ii < iters.length; ii++) {
          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
        }
      });
    };

    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (!iters.every(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
      if (iters.length === 0) {
        return this;
      }
      iters = iters.map(function(iter ) {return SetIterable(iter)});
      var originalSet = this;
      return this.withMutations(function(set ) {
        originalSet.forEach(function(value ) {
          if (iters.some(function(iter ) {return iter.includes(value)})) {
            set.remove(value);
          }
        });
      });
    };

    Set.prototype.merge = function() {
      return this.union.apply(this, arguments);
    };

    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
      return this.union.apply(this, iters);
    };

    Set.prototype.sort = function(comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator));
    };

    Set.prototype.sortBy = function(mapper, comparator) {
      // Late binding
      return OrderedSet(sortFactory(this, comparator, mapper));
    };

    Set.prototype.wasAltered = function() {
      return this._map.wasAltered();
    };

    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
    };

    Set.prototype.__iterator = function(type, reverse) {
      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
    };

    Set.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      var newMap = this._map.__ensureOwner(ownerID);
      if (!ownerID) {
        this.__ownerID = ownerID;
        this._map = newMap;
        return this;
      }
      return this.__make(newMap, ownerID);
    };


  function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
  }

  Set.isSet = isSet;

  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';

  var SetPrototype = Set.prototype;
  SetPrototype[IS_SET_SENTINEL] = true;
  SetPrototype[DELETE] = SetPrototype.remove;
  SetPrototype.mergeDeep = SetPrototype.merge;
  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
  SetPrototype.withMutations = MapPrototype.withMutations;
  SetPrototype.asMutable = MapPrototype.asMutable;
  SetPrototype.asImmutable = MapPrototype.asImmutable;

  SetPrototype.__empty = emptySet;
  SetPrototype.__make = makeSet;

  function updateSet(set, newMap) {
    if (set.__ownerID) {
      set.size = newMap.size;
      set._map = newMap;
      return set;
    }
    return newMap === set._map ? set :
      newMap.size === 0 ? set.__empty() :
      set.__make(newMap);
  }

  function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_SET;
  function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
  }

  createClass(OrderedSet, Set);

    // @pragma Construction

    function OrderedSet(value) {
      return value === null || value === undefined ? emptyOrderedSet() :
        isOrderedSet(value) ? value :
        emptyOrderedSet().withMutations(function(set ) {
          var iter = SetIterable(value);
          assertNotInfinite(iter.size);
          iter.forEach(function(v ) {return set.add(v)});
        });
    }

    OrderedSet.of = function(/*...values*/) {
      return this(arguments);
    };

    OrderedSet.fromKeys = function(value) {
      return this(KeyedIterable(value).keySeq());
    };

    OrderedSet.prototype.toString = function() {
      return this.__toString('OrderedSet {', '}');
    };


  function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
  }

  OrderedSet.isOrderedSet = isOrderedSet;

  var OrderedSetPrototype = OrderedSet.prototype;
  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;

  OrderedSetPrototype.__empty = emptyOrderedSet;
  OrderedSetPrototype.__make = makeOrderedSet;

  function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
  }

  var EMPTY_ORDERED_SET;
  function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
  }

  createClass(Stack, IndexedCollection);

    // @pragma Construction

    function Stack(value) {
      return value === null || value === undefined ? emptyStack() :
        isStack(value) ? value :
        emptyStack().unshiftAll(value);
    }

    Stack.of = function(/*...values*/) {
      return this(arguments);
    };

    Stack.prototype.toString = function() {
      return this.__toString('Stack [', ']');
    };

    // @pragma Access

    Stack.prototype.get = function(index, notSetValue) {
      var head = this._head;
      index = wrapIndex(this, index);
      while (head && index--) {
        head = head.next;
      }
      return head ? head.value : notSetValue;
    };

    Stack.prototype.peek = function() {
      return this._head && this._head.value;
    };

    // @pragma Modification

    Stack.prototype.push = function(/*...values*/) {
      if (arguments.length === 0) {
        return this;
      }
      var newSize = this.size + arguments.length;
      var head = this._head;
      for (var ii = arguments.length - 1; ii >= 0; ii--) {
        head = {
          value: arguments[ii],
          next: head
        };
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pushAll = function(iter) {
      iter = IndexedIterable(iter);
      if (iter.size === 0) {
        return this;
      }
      assertNotInfinite(iter.size);
      var newSize = this.size;
      var head = this._head;
      iter.reverse().forEach(function(value ) {
        newSize++;
        head = {
          value: value,
          next: head
        };
      });
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    Stack.prototype.pop = function() {
      return this.slice(1);
    };

    Stack.prototype.unshift = function(/*...values*/) {
      return this.push.apply(this, arguments);
    };

    Stack.prototype.unshiftAll = function(iter) {
      return this.pushAll(iter);
    };

    Stack.prototype.shift = function() {
      return this.pop.apply(this, arguments);
    };

    Stack.prototype.clear = function() {
      if (this.size === 0) {
        return this;
      }
      if (this.__ownerID) {
        this.size = 0;
        this._head = undefined;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return emptyStack();
    };

    Stack.prototype.slice = function(begin, end) {
      if (wholeSlice(begin, end, this.size)) {
        return this;
      }
      var resolvedBegin = resolveBegin(begin, this.size);
      var resolvedEnd = resolveEnd(end, this.size);
      if (resolvedEnd !== this.size) {
        // super.slice(begin, end);
        return IndexedCollection.prototype.slice.call(this, begin, end);
      }
      var newSize = this.size - resolvedBegin;
      var head = this._head;
      while (resolvedBegin--) {
        head = head.next;
      }
      if (this.__ownerID) {
        this.size = newSize;
        this._head = head;
        this.__hash = undefined;
        this.__altered = true;
        return this;
      }
      return makeStack(newSize, head);
    };

    // @pragma Mutability

    Stack.prototype.__ensureOwner = function(ownerID) {
      if (ownerID === this.__ownerID) {
        return this;
      }
      if (!ownerID) {
        this.__ownerID = ownerID;
        this.__altered = false;
        return this;
      }
      return makeStack(this.size, this._head, ownerID, this.__hash);
    };

    // @pragma Iteration

    Stack.prototype.__iterate = function(fn, reverse) {
      if (reverse) {
        return this.reverse().__iterate(fn);
      }
      var iterations = 0;
      var node = this._head;
      while (node) {
        if (fn(node.value, iterations++, this) === false) {
          break;
        }
        node = node.next;
      }
      return iterations;
    };

    Stack.prototype.__iterator = function(type, reverse) {
      if (reverse) {
        return this.reverse().__iterator(type);
      }
      var iterations = 0;
      var node = this._head;
      return new Iterator(function()  {
        if (node) {
          var value = node.value;
          node = node.next;
          return iteratorValue(type, iterations++, value);
        }
        return iteratorDone();
      });
    };


  function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
  }

  Stack.isStack = isStack;

  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';

  var StackPrototype = Stack.prototype;
  StackPrototype[IS_STACK_SENTINEL] = true;
  StackPrototype.withMutations = MapPrototype.withMutations;
  StackPrototype.asMutable = MapPrototype.asMutable;
  StackPrototype.asImmutable = MapPrototype.asImmutable;
  StackPrototype.wasAltered = MapPrototype.wasAltered;


  function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
  }

  var EMPTY_STACK;
  function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
  }

  /**
   * Contributes additional methods to a constructor
   */
  function mixin(ctor, methods) {
    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols &&
      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
  }

  Iterable.Iterator = Iterator;

  mixin(Iterable, {

    // ### Conversion to other types

    toArray: function() {
      assertNotInfinite(this.size);
      var array = new Array(this.size || 0);
      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
      return array;
    },

    toIndexedSeq: function() {
      return new ToIndexedSequence(this);
    },

    toJS: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
      ).__toJS();
    },

    toJSON: function() {
      return this.toSeq().map(
        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
      ).__toJS();
    },

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, true);
    },

    toMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return Map(this.toKeyedSeq());
    },

    toObject: function() {
      assertNotInfinite(this.size);
      var object = {};
      this.__iterate(function(v, k)  { object[k] = v; });
      return object;
    },

    toOrderedMap: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedMap(this.toKeyedSeq());
    },

    toOrderedSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },

    toSet: function() {
      // Use Late Binding here to solve the circular dependency.
      return Set(isKeyed(this) ? this.valueSeq() : this);
    },

    toSetSeq: function() {
      return new ToSetSequence(this);
    },

    toSeq: function() {
      return isIndexed(this) ? this.toIndexedSeq() :
        isKeyed(this) ? this.toKeyedSeq() :
        this.toSetSeq();
    },

    toStack: function() {
      // Use Late Binding here to solve the circular dependency.
      return Stack(isKeyed(this) ? this.valueSeq() : this);
    },

    toList: function() {
      // Use Late Binding here to solve the circular dependency.
      return List(isKeyed(this) ? this.valueSeq() : this);
    },


    // ### Common JavaScript methods and properties

    toString: function() {
      return '[Iterable]';
    },

    __toString: function(head, tail) {
      if (this.size === 0) {
        return head + tail;
      }
      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    concat: function() {var values = SLICE$0.call(arguments, 0);
      return reify(this, concatFactory(this, values));
    },

    includes: function(searchValue) {
      return this.some(function(value ) {return is(value, searchValue)});
    },

    entries: function() {
      return this.__iterator(ITERATE_ENTRIES);
    },

    every: function(predicate, context) {
      assertNotInfinite(this.size);
      var returnValue = true;
      this.__iterate(function(v, k, c)  {
        if (!predicate.call(context, v, k, c)) {
          returnValue = false;
          return false;
        }
      });
      return returnValue;
    },

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, true));
    },

    find: function(predicate, context, notSetValue) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[1] : notSetValue;
    },

    findEntry: function(predicate, context) {
      var found;
      this.__iterate(function(v, k, c)  {
        if (predicate.call(context, v, k, c)) {
          found = [k, v];
          return false;
        }
      });
      return found;
    },

    findLastEntry: function(predicate, context) {
      return this.toSeq().reverse().findEntry(predicate, context);
    },

    forEach: function(sideEffect, context) {
      assertNotInfinite(this.size);
      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },

    join: function(separator) {
      assertNotInfinite(this.size);
      separator = separator !== undefined ? '' + separator : ',';
      var joined = '';
      var isFirst = true;
      this.__iterate(function(v ) {
        isFirst ? (isFirst = false) : (joined += separator);
        joined += v !== null && v !== undefined ? v.toString() : '';
      });
      return joined;
    },

    keys: function() {
      return this.__iterator(ITERATE_KEYS);
    },

    map: function(mapper, context) {
      return reify(this, mapFactory(this, mapper, context));
    },

    reduce: function(reducer, initialReduction, context) {
      assertNotInfinite(this.size);
      var reduction;
      var useFirst;
      if (arguments.length < 2) {
        useFirst = true;
      } else {
        reduction = initialReduction;
      }
      this.__iterate(function(v, k, c)  {
        if (useFirst) {
          useFirst = false;
          reduction = v;
        } else {
          reduction = reducer.call(context, reduction, v, k, c);
        }
      });
      return reduction;
    },

    reduceRight: function(reducer, initialReduction, context) {
      var reversed = this.toKeyedSeq().reverse();
      return reversed.reduce.apply(reversed, arguments);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, true));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, true));
    },

    some: function(predicate, context) {
      return !this.every(not(predicate), context);
    },

    sort: function(comparator) {
      return reify(this, sortFactory(this, comparator));
    },

    values: function() {
      return this.__iterator(ITERATE_VALUES);
    },


    // ### More sequential methods

    butLast: function() {
      return this.slice(0, -1);
    },

    isEmpty: function() {
      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
    },

    count: function(predicate, context) {
      return ensureSize(
        predicate ? this.toSeq().filter(predicate, context) : this
      );
    },

    countBy: function(grouper, context) {
      return countByFactory(this, grouper, context);
    },

    equals: function(other) {
      return deepEqual(this, other);
    },

    entrySeq: function() {
      var iterable = this;
      if (iterable._cache) {
        // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(iterable._cache);
      }
      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
      return entriesSequence;
    },

    filterNot: function(predicate, context) {
      return this.filter(not(predicate), context);
    },

    findLast: function(predicate, context, notSetValue) {
      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },

    first: function() {
      return this.find(returnTrue);
    },

    flatMap: function(mapper, context) {
      return reify(this, flatMapFactory(this, mapper, context));
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, true));
    },

    fromEntrySeq: function() {
      return new FromEntriesSequence(this);
    },

    get: function(searchKey, notSetValue) {
      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
    },

    getIn: function(searchKeyPath, notSetValue) {
      var nested = this;
      // Note: in an ES6 environment, we would prefer:
      // for (var key of searchKeyPath) {
      var iter = forceIterator(searchKeyPath);
      var step;
      while (!(step = iter.next()).done) {
        var key = step.value;
        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
        if (nested === NOT_SET) {
          return notSetValue;
        }
      }
      return nested;
    },

    groupBy: function(grouper, context) {
      return groupByFactory(this, grouper, context);
    },

    has: function(searchKey) {
      return this.get(searchKey, NOT_SET) !== NOT_SET;
    },

    hasIn: function(searchKeyPath) {
      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
    },

    isSubset: function(iter) {
      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
      return this.every(function(value ) {return iter.includes(value)});
    },

    isSuperset: function(iter) {
      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
      return iter.isSubset(this);
    },

    keySeq: function() {
      return this.toSeq().map(keyMapper).toIndexedSeq();
    },

    last: function() {
      return this.toSeq().reverse().first();
    },

    max: function(comparator) {
      return maxFactory(this, comparator);
    },

    maxBy: function(mapper, comparator) {
      return maxFactory(this, comparator, mapper);
    },

    min: function(comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },

    minBy: function(mapper, comparator) {
      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },

    rest: function() {
      return this.slice(1);
    },

    skip: function(amount) {
      return this.slice(Math.max(0, amount));
    },

    skipLast: function(amount) {
      return reify(this, this.toSeq().reverse().skip(amount).reverse());
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, true));
    },

    skipUntil: function(predicate, context) {
      return this.skipWhile(not(predicate), context);
    },

    sortBy: function(mapper, comparator) {
      return reify(this, sortFactory(this, comparator, mapper));
    },

    take: function(amount) {
      return this.slice(0, Math.max(0, amount));
    },

    takeLast: function(amount) {
      return reify(this, this.toSeq().reverse().take(amount).reverse());
    },

    takeWhile: function(predicate, context) {
      return reify(this, takeWhileFactory(this, predicate, context));
    },

    takeUntil: function(predicate, context) {
      return this.takeWhile(not(predicate), context);
    },

    valueSeq: function() {
      return this.toIndexedSeq();
    },


    // ### Hashable Object

    hashCode: function() {
      return this.__hash || (this.__hash = hashIterable(this));
    }


    // ### Internal

    // abstract __iterate(fn, reverse)

    // abstract __iterator(type, reverse)
  });

  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';

  var IterablePrototype = Iterable.prototype;
  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
  IterablePrototype.__toJS = IterablePrototype.toArray;
  IterablePrototype.__toStringMapper = quoteString;
  IterablePrototype.inspect =
  IterablePrototype.toSource = function() { return this.toString(); };
  IterablePrototype.chain = IterablePrototype.flatMap;
  IterablePrototype.contains = IterablePrototype.includes;

  // Temporary warning about using length
  (function () {
    try {
      Object.defineProperty(IterablePrototype, 'length', {
        get: function () {
          if (!Iterable.noLengthWarning) {
            var stack;
            try {
              throw new Error();
            } catch (error) {
              stack = error.stack;
            }
            if (stack.indexOf('_wrapObject') === -1) {
              console && console.warn && console.warn(
                'iterable.length has been deprecated, '+
                'use iterable.size or iterable.count(). '+
                'This warning will become a silent error in a future version. ' +
                stack
              );
              return this.size;
            }
          }
        }
      });
    } catch (e) {}
  })();



  mixin(KeyedIterable, {

    // ### More sequential methods

    flip: function() {
      return reify(this, flipFactory(this));
    },

    findKey: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry && entry[0];
    },

    findLastKey: function(predicate, context) {
      return this.toSeq().reverse().findKey(predicate, context);
    },

    keyOf: function(searchValue) {
      return this.findKey(function(value ) {return is(value, searchValue)});
    },

    lastKeyOf: function(searchValue) {
      return this.findLastKey(function(value ) {return is(value, searchValue)});
    },

    mapEntries: function(mapper, context) {var this$0 = this;
      var iterations = 0;
      return reify(this,
        this.toSeq().map(
          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
        ).fromEntrySeq()
      );
    },

    mapKeys: function(mapper, context) {var this$0 = this;
      return reify(this,
        this.toSeq().flip().map(
          function(k, v)  {return mapper.call(context, k, v, this$0)}
        ).flip()
      );
    }

  });

  var KeyedIterablePrototype = KeyedIterable.prototype;
  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};



  mixin(IndexedIterable, {

    // ### Conversion to other types

    toKeyedSeq: function() {
      return new ToKeyedSequence(this, false);
    },


    // ### ES6 Collection methods (ES6 Array and Map)

    filter: function(predicate, context) {
      return reify(this, filterFactory(this, predicate, context, false));
    },

    findIndex: function(predicate, context) {
      var entry = this.findEntry(predicate, context);
      return entry ? entry[0] : -1;
    },

    indexOf: function(searchValue) {
      var key = this.toKeyedSeq().keyOf(searchValue);
      return key === undefined ? -1 : key;
    },

    lastIndexOf: function(searchValue) {
      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
      return key === undefined ? -1 : key;

      // var index =
      // return this.toSeq().reverse().indexOf(searchValue);
    },

    reverse: function() {
      return reify(this, reverseFactory(this, false));
    },

    slice: function(begin, end) {
      return reify(this, sliceFactory(this, begin, end, false));
    },

    splice: function(index, removeNum /*, ...values*/) {
      var numArgs = arguments.length;
      removeNum = Math.max(removeNum | 0, 0);
      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
        return this;
      }
      // If index is negative, it should resolve relative to the size of the
      // collection. However size may be expensive to compute if not cached, so
      // only call count() if the number is in fact negative.
      index = resolveBegin(index, index < 0 ? this.count() : this.size);
      var spliced = this.slice(0, index);
      return reify(
        this,
        numArgs === 1 ?
          spliced :
          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
      );
    },


    // ### More collection methods

    findLastIndex: function(predicate, context) {
      var key = this.toKeyedSeq().findLastKey(predicate, context);
      return key === undefined ? -1 : key;
    },

    first: function() {
      return this.get(0);
    },

    flatten: function(depth) {
      return reify(this, flattenFactory(this, depth, false));
    },

    get: function(index, notSetValue) {
      index = wrapIndex(this, index);
      return (index < 0 || (this.size === Infinity ||
          (this.size !== undefined && index > this.size))) ?
        notSetValue :
        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
    },

    has: function(index) {
      index = wrapIndex(this, index);
      return index >= 0 && (this.size !== undefined ?
        this.size === Infinity || index < this.size :
        this.indexOf(index) !== -1
      );
    },

    interpose: function(separator) {
      return reify(this, interposeFactory(this, separator));
    },

    interleave: function(/*...iterables*/) {
      var iterables = [this].concat(arrCopy(arguments));
      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
      var interleaved = zipped.flatten(true);
      if (zipped.size) {
        interleaved.size = zipped.size * iterables.length;
      }
      return reify(this, interleaved);
    },

    last: function() {
      return this.get(-1);
    },

    skipWhile: function(predicate, context) {
      return reify(this, skipWhileFactory(this, predicate, context, false));
    },

    zip: function(/*, ...iterables */) {
      var iterables = [this].concat(arrCopy(arguments));
      return reify(this, zipWithFactory(this, defaultZipper, iterables));
    },

    zipWith: function(zipper/*, ...iterables */) {
      var iterables = arrCopy(arguments);
      iterables[0] = this;
      return reify(this, zipWithFactory(this, zipper, iterables));
    }

  });

  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;



  mixin(SetIterable, {

    // ### ES6 Collection methods (ES6 Array and Map)

    get: function(value, notSetValue) {
      return this.has(value) ? value : notSetValue;
    },

    includes: function(value) {
      return this.has(value);
    },


    // ### More sequential methods

    keySeq: function() {
      return this.valueSeq();
    }

  });

  SetIterable.prototype.has = IterablePrototype.includes;


  // Mixin subclasses

  mixin(KeyedSeq, KeyedIterable.prototype);
  mixin(IndexedSeq, IndexedIterable.prototype);
  mixin(SetSeq, SetIterable.prototype);

  mixin(KeyedCollection, KeyedIterable.prototype);
  mixin(IndexedCollection, IndexedIterable.prototype);
  mixin(SetCollection, SetIterable.prototype);


  // #pragma Helper functions

  function keyMapper(v, k) {
    return k;
  }

  function entryMapper(v, k) {
    return [k, v];
  }

  function not(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    }
  }

  function neg(predicate) {
    return function() {
      return -predicate.apply(this, arguments);
    }
  }

  function quoteString(value) {
    return typeof value === 'string' ? JSON.stringify(value) : value;
  }

  function defaultZipper() {
    return arrCopy(arguments);
  }

  function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
  }

  function hashIterable(iterable) {
    if (iterable.size === Infinity) {
      return 0;
    }
    var ordered = isOrdered(iterable);
    var keyed = isKeyed(iterable);
    var h = ordered ? 1 : 0;
    var size = iterable.__iterate(
      keyed ?
        ordered ?
          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
        ordered ?
          function(v ) { h = 31 * h + hash(v) | 0; } :
          function(v ) { h = h + hash(v) | 0; }
    );
    return murmurHashOfSize(size, h);
  }

  function murmurHashOfSize(size, h) {
    h = imul(h, 0xCC9E2D51);
    h = imul(h << 15 | h >>> -15, 0x1B873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xE6546B64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85EBCA6B);
    h = imul(h ^ h >>> 13, 0xC2B2AE35);
    h = smi(h ^ h >>> 16);
    return h;
  }

  function hashMerge(a, b) {
    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
  }

  var Immutable = {

    Iterable: Iterable,

    Seq: Seq,
    Collection: Collection,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,

    Record: Record,
    Range: Range,
    Repeat: Repeat,

    is: is,
    fromJS: fromJS

  };

  return Immutable;

}));

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchFilter = function (_Component) {
  _inherits(SearchFilter, _Component);

  function SearchFilter(props) {
    _classCallCheck(this, SearchFilter);

    var _this = _possibleConstructorReturn(this, (SearchFilter.__proto__ || Object.getPrototypeOf(SearchFilter)).call(this, props));

    _initialiseProps.call(_this);

    var state = SearchFilter.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(SearchFilter, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = SearchFilter.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'getChildName',
    value: function getChildName() {
      var filterNames = [];
      if (this.props.children) {
        _react.Children.forEach(this.props.children, function (child) {
          if (child && child.props && child.props.filterName) {
            filterNames.push(child.props.filterName);
            if (child.type && child.type.name === 'DatePicker') {
              filterNames.push(child.props.filterNameTo);
              filterNames.push(child.props.filterNameFrom);
            }
          }
        });
      }
      return filterNames;
    }
  }, {
    key: 'handleWidth',
    value: function handleWidth() {
      if (this.props.leftNav && this.props.rightNav) {
        if (this.props.searchWidth) {
          return this.props.searchWidth;
        }
        return 10;
      }
      if (this.props.leftNav || this.props.rightNav) {
        return 13;
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { style: this.props.style },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          {
            className: 'app--searchcontrols ' + (this.state.advanceFilter ? 'advance' : '') + ' ' + (this.props.inTable ? 'hide-side' : ''),
            id: 'searchcontrols',
            verticalAlign: 'top'
          },
          this.props.leftNav && _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            {
              computer: this.props.leftNavWidth ? this.props.leftNavWidth : this.props.hasCompareBtn ? 2 : 3,
              tablet: this.props.leftNavWidth ? this.props.leftNavWidth : this.props.hasCompareBtn ? 1 : 3,
              className: 'tablet computer only'
            },
            this.props.leftNav
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            {
              tablet: this.handleWidth(),
              computer: this.handleWidth()
            },
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { centered: true, className: 'searchinput' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  mobile: this.props.children ? 13 : null,
                  tablet: this.props.children ? 10 : null,
                  computer: this.props.children ? 10 : null,
                  className: this.props.children ? 'leftjoin' : null
                },
                _react2.default.createElement(
                  'form',
                  { onSubmit: this.handleSearch },
                  _react2.default.createElement(_semanticUiReact.Input, {
                    fluid: true,
                    icon: this.state.search ? _react2.default.createElement(_semanticUiReact.Icon, {
                      color: 'teal',
                      link: true,
                      name: 'x',
                      onClick: function onClick() {
                        _this2.props.onClose(_this2.props.filterName);
                      },
                      title: t('Clear input')
                    }) : null,
                    label: _react2.default.createElement(
                      _semanticUiReact.Button,
                      {
                        className: this.props.children ? 'search-button' : 'search-button-only',
                        icon: true,
                        disabled: this.props.disabled || this.props.isLoading,
                        title: t('Search')
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'search' })
                    ),
                    labelPosition: 'right',
                    loading: this.props.isLoading,
                    disabled: this.props.disabled || this.props.isLoading,
                    name: 'search',
                    onChange: this.handleOnChange,
                    placeholder: this.props.placeholder || t('Search') + '...',
                    value: this.state.search
                  })
                )
              ),
              this.props.children && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  textAlign: 'left',
                  className: 'rightjoin',
                  mobile: 2,
                  tablet: 1,
                  computer: 1
                },
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    active: this.state.advanceFilter,
                    color: this.state.advanceFilter ? 'green' : null,
                    as: 'a',
                    className: 'advance-button',
                    icon: true,
                    onClick: function onClick() {
                      _this2.handleAdvanceButtonClick();
                    },
                    title: t('Advance Filters'),
                    disabled: this.props.disabled || this.props.isLoading
                  },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'options' })
                )
              )
            ),
            this.props.children && _react2.default.createElement(
              _semanticUiReact.Grid,
              { centered: true, className: 'filtercontrols' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { mobile: 16, tablet: 11, computer: 11 },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true, className: 'filtertitle' },
                      t('Filters')
                    )
                  )
                ),
                this.props.children
              )
            )
          ),
          this.props.rightNav && _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            {
              tablet: this.props.rightNavWidth ? this.props.rightNavWidth : 3,
              computer: this.props.rightNavWidth ? this.props.rightNavWidth : this.props.hasCompareBtn ? 4 : 3,
              className: 'tablet computer only',
              textAlign: 'right'
            },
            this.props.rightNav
          )
        ),
        (this.props.leftNav || this.props.rightNav) && _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          {
            className: 'app--listcontrols ' + (this.props.inTable ? '' : 'remove-pad-btm'),
            columns: 'equal',
            verticalAlign: 'middle',
            only: 'mobile'
          },
          this.props.leftNav && _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            {
              width: this.props.leftNavWidth ? this.props.leftNavWidth : 3,
              className: 'left',
              textAlign: 'left'
            },
            this.props.leftNav
          ),
          this.props.rightNav && _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            {
              width: this.props.rightNavWidth ? this.props.rightNavWidth : 13,
              className: 'right',
              textAlign: 'right'
            },
            this.props.rightNav
          )
        )
      );
    }
  }]);

  return SearchFilter;
}(_react.Component);

SearchFilter.propTypes = {
  children: _propTypes2.default.node,
  filterName: _propTypes2.default.string.isRequired,
  isLoading: _propTypes2.default.bool,
  onChange: _propTypes2.default.func.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  search: _propTypes2.default.string,
  setAdvanceFilter: _propTypes2.default.func,
  leftNav: _propTypes2.default.node,
  rightNav: _propTypes2.default.node,
  inTable: _propTypes2.default.bool,
  placeholder: _propTypes2.default.string,
  style: _propTypes2.default.shape({
    margin: _propTypes2.default.any
  }),
  searchAtKeyEnd: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  hasCompareBtn: _propTypes2.default.bool,
  leftNavWidth: _propTypes2.default.number,
  rightNavWidth: _propTypes2.default.number,
  searchWidth: _propTypes2.default.number
};
SearchFilter.defaultProps = {
  filterName: 'search',
  isLoading: false,
  searchAtKeyEnd: false
};

SearchFilter.getPropsToState = function (props) {
  var search = props.search || '';
  var advanceFilter = props.advanceFilter || false;
  return {
    search: search,
    advanceFilter: advanceFilter
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleSearch = function (e) {
    if (e) {
      e.preventDefault();
    }
    if (_this3.props.disabled) {
      return;
    }
    if (_this3.state.search === '' && _this3.props.search !== '') {
      _this3.props.onClose(_this3.props.filterName);
    } else if (_this3.state.search) {
      _this3.props.onChange(_this3.state.search.trim(), _this3.props.filterName);
    }
  };

  this.handleOnChange = function (e) {
    if (_this3.props.disabled) {
      return;
    }
    _this3.setState({ search: e.target.value }, function () {
      var searchAtKeyEnd = _this3.props.searchAtKeyEnd;

      if (searchAtKeyEnd) {
        _this3.handleSearch();
      }
    });
  };

  this.handleAdvanceButtonClick = function () {
    _this3.setState({ advanceFilter: !_this3.state.advanceFilter }, function () {
      _this3.props.setAdvanceFilter(_this3.state.advanceFilter);
      if (!_this3.state.advanceFilter) {
        var _props;

        var filterNames = _this3.getChildName();
        (_props = _this3.props).onClose.apply(_props, _toConsumableArray(filterNames));
      }
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(SearchFilter);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var validateFormat =  false ? function (format) {
  if (format === undefined) {
    throw new Error('invariant(...): Second argument must be a string.');
  }
} : function (format) {};
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments to provide
 * information about what broke and what you were expecting.
 *
 * The invariant message will be stripped in production, but the invariant will
 * remain to ensure logic does not differ in production.
 */

function invariant(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  validateFormat(format);

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return String(args[argIndex++]);
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // Skip invariant's own stack frame.

    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createReducer;
function createReducer(initialState, reducerMap) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var reducer = reducerMap[action.type];

    return reducer ? reducer(state, action.payload) : state;
  };
}

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(53);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isType = isType;
exports.assertType = assertType;
exports.isScalarType = isScalarType;
exports.assertScalarType = assertScalarType;
exports.isObjectType = isObjectType;
exports.assertObjectType = assertObjectType;
exports.isInterfaceType = isInterfaceType;
exports.assertInterfaceType = assertInterfaceType;
exports.isUnionType = isUnionType;
exports.assertUnionType = assertUnionType;
exports.isEnumType = isEnumType;
exports.assertEnumType = assertEnumType;
exports.isInputObjectType = isInputObjectType;
exports.assertInputObjectType = assertInputObjectType;
exports.isListType = isListType;
exports.assertListType = assertListType;
exports.isNonNullType = isNonNullType;
exports.assertNonNullType = assertNonNullType;
exports.isInputType = isInputType;
exports.assertInputType = assertInputType;
exports.isOutputType = isOutputType;
exports.assertOutputType = assertOutputType;
exports.isLeafType = isLeafType;
exports.assertLeafType = assertLeafType;
exports.isCompositeType = isCompositeType;
exports.assertCompositeType = assertCompositeType;
exports.isAbstractType = isAbstractType;
exports.assertAbstractType = assertAbstractType;
exports.GraphQLList = GraphQLList;
exports.GraphQLNonNull = GraphQLNonNull;
exports.isWrappingType = isWrappingType;
exports.assertWrappingType = assertWrappingType;
exports.isNullableType = isNullableType;
exports.assertNullableType = assertNullableType;
exports.getNullableType = getNullableType;
exports.isNamedType = isNamedType;
exports.assertNamedType = assertNamedType;
exports.getNamedType = getNamedType;
exports.isRequiredArgument = isRequiredArgument;
exports.isRequiredInputField = isRequiredInputField;
exports.GraphQLInputObjectType = exports.GraphQLEnumType = exports.GraphQLUnionType = exports.GraphQLInterfaceType = exports.GraphQLObjectType = exports.GraphQLScalarType = void 0;

var _defineToJSON = _interopRequireDefault(__webpack_require__(1205));

var _defineToStringTag = _interopRequireDefault(__webpack_require__(438));

var _instanceOf = _interopRequireDefault(__webpack_require__(659));

var _inspect = _interopRequireDefault(__webpack_require__(93));

var _invariant = _interopRequireDefault(__webpack_require__(108));

var _keyMap = _interopRequireDefault(__webpack_require__(183));

var _kinds = __webpack_require__(68);

var _valueFromASTUntyped = __webpack_require__(1212);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function isType(type) {
  return isScalarType(type) || isObjectType(type) || isInterfaceType(type) || isUnionType(type) || isEnumType(type) || isInputObjectType(type) || isListType(type) || isNonNullType(type);
}

function assertType(type) {
  !isType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL type.")) : void 0;
  return type;
}
/**
 * There are predicates for each kind of GraphQL type.
 */


// eslint-disable-next-line no-redeclare
function isScalarType(type) {
  return (0, _instanceOf.default)(type, GraphQLScalarType);
}

function assertScalarType(type) {
  !isScalarType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL Scalar type.")) : void 0;
  return type;
}

// eslint-disable-next-line no-redeclare
function isObjectType(type) {
  return (0, _instanceOf.default)(type, GraphQLObjectType);
}

function assertObjectType(type) {
  !isObjectType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL Object type.")) : void 0;
  return type;
}

// eslint-disable-next-line no-redeclare
function isInterfaceType(type) {
  return (0, _instanceOf.default)(type, GraphQLInterfaceType);
}

function assertInterfaceType(type) {
  !isInterfaceType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL Interface type.")) : void 0;
  return type;
}

// eslint-disable-next-line no-redeclare
function isUnionType(type) {
  return (0, _instanceOf.default)(type, GraphQLUnionType);
}

function assertUnionType(type) {
  !isUnionType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL Union type.")) : void 0;
  return type;
}

// eslint-disable-next-line no-redeclare
function isEnumType(type) {
  return (0, _instanceOf.default)(type, GraphQLEnumType);
}

function assertEnumType(type) {
  !isEnumType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL Enum type.")) : void 0;
  return type;
}

// eslint-disable-next-line no-redeclare
function isInputObjectType(type) {
  return (0, _instanceOf.default)(type, GraphQLInputObjectType);
}

function assertInputObjectType(type) {
  !isInputObjectType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL Input Object type.")) : void 0;
  return type;
}

// eslint-disable-next-line no-redeclare
function isListType(type) {
  return (0, _instanceOf.default)(type, GraphQLList);
}

function assertListType(type) {
  !isListType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL List type.")) : void 0;
  return type;
}

// eslint-disable-next-line no-redeclare
function isNonNullType(type) {
  return (0, _instanceOf.default)(type, GraphQLNonNull);
}

function assertNonNullType(type) {
  !isNonNullType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL Non-Null type.")) : void 0;
  return type;
}
/**
 * These types may be used as input types for arguments and directives.
 */


function isInputType(type) {
  return isScalarType(type) || isEnumType(type) || isInputObjectType(type) || isWrappingType(type) && isInputType(type.ofType);
}

function assertInputType(type) {
  !isInputType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL input type.")) : void 0;
  return type;
}
/**
 * These types may be used as output types as the result of fields.
 */


function isOutputType(type) {
  return isScalarType(type) || isObjectType(type) || isInterfaceType(type) || isUnionType(type) || isEnumType(type) || isWrappingType(type) && isOutputType(type.ofType);
}

function assertOutputType(type) {
  !isOutputType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL output type.")) : void 0;
  return type;
}
/**
 * These types may describe types which may be leaf values.
 */


function isLeafType(type) {
  return isScalarType(type) || isEnumType(type);
}

function assertLeafType(type) {
  !isLeafType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL leaf type.")) : void 0;
  return type;
}
/**
 * These types may describe the parent context of a selection set.
 */


function isCompositeType(type) {
  return isObjectType(type) || isInterfaceType(type) || isUnionType(type);
}

function assertCompositeType(type) {
  !isCompositeType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL composite type.")) : void 0;
  return type;
}
/**
 * These types may describe the parent context of a selection set.
 */


function isAbstractType(type) {
  return isInterfaceType(type) || isUnionType(type);
}

function assertAbstractType(type) {
  !isAbstractType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL abstract type.")) : void 0;
  return type;
}
/**
 * List Type Wrapper
 *
 * A list is a wrapping type which points to another type.
 * Lists are often created within the context of defining the fields of
 * an object type.
 *
 * Example:
 *
 *     const PersonType = new GraphQLObjectType({
 *       name: 'Person',
 *       fields: () => ({
 *         parents: { type: GraphQLList(PersonType) },
 *         children: { type: GraphQLList(PersonType) },
 *       })
 *     })
 *
 */


// eslint-disable-next-line no-redeclare
function GraphQLList(ofType) {
  if (this instanceof GraphQLList) {
    this.ofType = assertType(ofType);
  } else {
    return new GraphQLList(ofType);
  }
} // Need to cast through any to alter the prototype.


GraphQLList.prototype.toString = function toString() {
  return '[' + String(this.ofType) + ']';
};

(0, _defineToJSON.default)(GraphQLList);
/**
 * Non-Null Type Wrapper
 *
 * A non-null is a wrapping type which points to another type.
 * Non-null types enforce that their values are never null and can ensure
 * an error is raised if this ever occurs during a request. It is useful for
 * fields which you can make a strong guarantee on non-nullability, for example
 * usually the id field of a database row will never be null.
 *
 * Example:
 *
 *     const RowType = new GraphQLObjectType({
 *       name: 'Row',
 *       fields: () => ({
 *         id: { type: GraphQLNonNull(GraphQLString) },
 *       })
 *     })
 *
 * Note: the enforcement of non-nullability occurs within the executor.
 */

// eslint-disable-next-line no-redeclare
function GraphQLNonNull(ofType) {
  if (this instanceof GraphQLNonNull) {
    this.ofType = assertNullableType(ofType);
  } else {
    return new GraphQLNonNull(ofType);
  }
} // Need to cast through any to alter the prototype.


GraphQLNonNull.prototype.toString = function toString() {
  return String(this.ofType) + '!';
};

(0, _defineToJSON.default)(GraphQLNonNull);
/**
 * These types wrap and modify other types
 */

function isWrappingType(type) {
  return isListType(type) || isNonNullType(type);
}

function assertWrappingType(type) {
  !isWrappingType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL wrapping type.")) : void 0;
  return type;
}
/**
 * These types can all accept null as a value.
 */


function isNullableType(type) {
  return isType(type) && !isNonNullType(type);
}

function assertNullableType(type) {
  !isNullableType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL nullable type.")) : void 0;
  return type;
}
/* eslint-disable no-redeclare */


function getNullableType(type) {
  /* eslint-enable no-redeclare */
  if (type) {
    return isNonNullType(type) ? type.ofType : type;
  }
}
/**
 * These named types do not include modifiers like List or NonNull.
 */


function isNamedType(type) {
  return isScalarType(type) || isObjectType(type) || isInterfaceType(type) || isUnionType(type) || isEnumType(type) || isInputObjectType(type);
}

function assertNamedType(type) {
  !isNamedType(type) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(type), " to be a GraphQL named type.")) : void 0;
  return type;
}
/* eslint-disable no-redeclare */


function getNamedType(type) {
  /* eslint-enable no-redeclare */
  if (type) {
    var unwrappedType = type;

    while (isWrappingType(unwrappedType)) {
      unwrappedType = unwrappedType.ofType;
    }

    return unwrappedType;
  }
}
/**
 * Used while defining GraphQL types to allow for circular references in
 * otherwise immutable type definitions.
 */


function resolveThunk(thunk) {
  return typeof thunk === 'function' ? thunk() : thunk;
}
/**
 * Scalar Type Definition
 *
 * The leaf values of any request and input values to arguments are
 * Scalars (or Enums) and are defined with a name and a series of functions
 * used to parse input from ast or variables and to ensure validity.
 *
 * If a type's serialize function does not return a value (i.e. it returns
 * `undefined`) then an error will be raised and a `null` value will be returned
 * in the response. If the serialize function returns `null`, then no error will
 * be included in the response.
 *
 * Example:
 *
 *     const OddType = new GraphQLScalarType({
 *       name: 'Odd',
 *       serialize(value) {
 *         if (value % 2 === 1) {
 *           return value;
 *         }
 *       }
 *     });
 *
 */


var GraphQLScalarType =
/*#__PURE__*/
function () {
  function GraphQLScalarType(config) {
    _defineProperty(this, "name", void 0);

    _defineProperty(this, "description", void 0);

    _defineProperty(this, "serialize", void 0);

    _defineProperty(this, "parseValue", void 0);

    _defineProperty(this, "parseLiteral", void 0);

    _defineProperty(this, "astNode", void 0);

    _defineProperty(this, "extensionASTNodes", void 0);

    this.name = config.name;
    this.description = config.description;
    this.serialize = config.serialize;

    this.parseValue = config.parseValue || function (value) {
      return value;
    };

    this.parseLiteral = config.parseLiteral || _valueFromASTUntyped.valueFromASTUntyped;
    this.astNode = config.astNode;
    this.extensionASTNodes = config.extensionASTNodes;
    !(typeof config.name === 'string') ? (0, _invariant.default)(0, 'Must provide name.') : void 0;
    !(typeof config.serialize === 'function') ? (0, _invariant.default)(0, "".concat(this.name, " must provide \"serialize\" function. If this custom Scalar ") + 'is also used as an input type, ensure "parseValue" and "parseLiteral" ' + 'functions are also provided.') : void 0;

    if (config.parseValue || config.parseLiteral) {
      !(typeof config.parseValue === 'function' && typeof config.parseLiteral === 'function') ? (0, _invariant.default)(0, "".concat(this.name, " must provide both \"parseValue\" and \"parseLiteral\" ") + 'functions.') : void 0;
    }
  }

  var _proto = GraphQLScalarType.prototype;

  _proto.toString = function toString() {
    return this.name;
  };

  return GraphQLScalarType;
}(); // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported


exports.GraphQLScalarType = GraphQLScalarType;
(0, _defineToStringTag.default)(GraphQLScalarType);
(0, _defineToJSON.default)(GraphQLScalarType);

/**
 * Object Type Definition
 *
 * Almost all of the GraphQL types you define will be object types. Object types
 * have a name, but most importantly describe their fields.
 *
 * Example:
 *
 *     const AddressType = new GraphQLObjectType({
 *       name: 'Address',
 *       fields: {
 *         street: { type: GraphQLString },
 *         number: { type: GraphQLInt },
 *         formatted: {
 *           type: GraphQLString,
 *           resolve(obj) {
 *             return obj.number + ' ' + obj.street
 *           }
 *         }
 *       }
 *     });
 *
 * When two types need to refer to each other, or a type needs to refer to
 * itself in a field, you can use a function expression (aka a closure or a
 * thunk) to supply the fields lazily.
 *
 * Example:
 *
 *     const PersonType = new GraphQLObjectType({
 *       name: 'Person',
 *       fields: () => ({
 *         name: { type: GraphQLString },
 *         bestFriend: { type: PersonType },
 *       })
 *     });
 *
 */
var GraphQLObjectType =
/*#__PURE__*/
function () {
  function GraphQLObjectType(config) {
    _defineProperty(this, "name", void 0);

    _defineProperty(this, "description", void 0);

    _defineProperty(this, "astNode", void 0);

    _defineProperty(this, "extensionASTNodes", void 0);

    _defineProperty(this, "isTypeOf", void 0);

    _defineProperty(this, "_fields", void 0);

    _defineProperty(this, "_interfaces", void 0);

    this.name = config.name;
    this.description = config.description;
    this.astNode = config.astNode;
    this.extensionASTNodes = config.extensionASTNodes;
    this.isTypeOf = config.isTypeOf;
    this._fields = defineFieldMap.bind(undefined, config);
    this._interfaces = defineInterfaces.bind(undefined, config);
    !(typeof config.name === 'string') ? (0, _invariant.default)(0, 'Must provide name.') : void 0;
    !(config.isTypeOf == null || typeof config.isTypeOf === 'function') ? (0, _invariant.default)(0, "".concat(this.name, " must provide \"isTypeOf\" as a function, ") + "but got: ".concat((0, _inspect.default)(config.isTypeOf), ".")) : void 0;
  }

  var _proto2 = GraphQLObjectType.prototype;

  _proto2.getFields = function getFields() {
    if (typeof this._fields === 'function') {
      this._fields = this._fields();
    }

    return this._fields;
  };

  _proto2.getInterfaces = function getInterfaces() {
    if (typeof this._interfaces === 'function') {
      this._interfaces = this._interfaces();
    }

    return this._interfaces;
  };

  _proto2.toString = function toString() {
    return this.name;
  };

  return GraphQLObjectType;
}(); // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported


exports.GraphQLObjectType = GraphQLObjectType;
(0, _defineToStringTag.default)(GraphQLObjectType);
(0, _defineToJSON.default)(GraphQLObjectType);

function defineInterfaces(config) {
  var interfaces = resolveThunk(config.interfaces) || [];
  !Array.isArray(interfaces) ? (0, _invariant.default)(0, "".concat(config.name, " interfaces must be an Array or a function which returns ") + 'an Array.') : void 0;
  return interfaces;
}

function defineFieldMap(config) {
  var fieldMap = resolveThunk(config.fields) || {};
  !isPlainObj(fieldMap) ? (0, _invariant.default)(0, "".concat(config.name, " fields must be an object with field names as keys or a ") + 'function which returns such an object.') : void 0;
  var resultFieldMap = Object.create(null);

  var _arr = Object.keys(fieldMap);

  var _loop = function _loop() {
    var fieldName = _arr[_i];
    var fieldConfig = fieldMap[fieldName];
    !isPlainObj(fieldConfig) ? (0, _invariant.default)(0, "".concat(config.name, ".").concat(fieldName, " field config must be an object")) : void 0;
    !!fieldConfig.hasOwnProperty('isDeprecated') ? (0, _invariant.default)(0, "".concat(config.name, ".").concat(fieldName, " should provide \"deprecationReason\" ") + 'instead of "isDeprecated".') : void 0;

    var field = _objectSpread({}, fieldConfig, {
      isDeprecated: Boolean(fieldConfig.deprecationReason),
      name: fieldName
    });

    !(field.resolve == null || typeof field.resolve === 'function') ? (0, _invariant.default)(0, "".concat(config.name, ".").concat(fieldName, " field resolver must be a function if ") + "provided, but got: ".concat((0, _inspect.default)(field.resolve), ".")) : void 0;
    var argsConfig = fieldConfig.args;

    if (!argsConfig) {
      field.args = [];
    } else {
      !isPlainObj(argsConfig) ? (0, _invariant.default)(0, "".concat(config.name, ".").concat(fieldName, " args must be an object with argument ") + 'names as keys.') : void 0;
      field.args = Object.keys(argsConfig).map(function (argName) {
        var arg = argsConfig[argName];
        return {
          name: argName,
          description: arg.description === undefined ? null : arg.description,
          type: arg.type,
          defaultValue: arg.defaultValue,
          astNode: arg.astNode
        };
      });
    }

    resultFieldMap[fieldName] = field;
  };

  for (var _i = 0; _i < _arr.length; _i++) {
    _loop();
  }

  return resultFieldMap;
}

function isPlainObj(obj) {
  return obj && _typeof(obj) === 'object' && !Array.isArray(obj);
}

function isRequiredArgument(arg) {
  return isNonNullType(arg.type) && arg.defaultValue === undefined;
}

/**
 * Interface Type Definition
 *
 * When a field can return one of a heterogeneous set of types, a Interface type
 * is used to describe what types are possible, what fields are in common across
 * all types, as well as a function to determine which type is actually used
 * when the field is resolved.
 *
 * Example:
 *
 *     const EntityType = new GraphQLInterfaceType({
 *       name: 'Entity',
 *       fields: {
 *         name: { type: GraphQLString }
 *       }
 *     });
 *
 */
var GraphQLInterfaceType =
/*#__PURE__*/
function () {
  function GraphQLInterfaceType(config) {
    _defineProperty(this, "name", void 0);

    _defineProperty(this, "description", void 0);

    _defineProperty(this, "astNode", void 0);

    _defineProperty(this, "extensionASTNodes", void 0);

    _defineProperty(this, "resolveType", void 0);

    _defineProperty(this, "_fields", void 0);

    this.name = config.name;
    this.description = config.description;
    this.astNode = config.astNode;
    this.extensionASTNodes = config.extensionASTNodes;
    this.resolveType = config.resolveType;
    this._fields = defineFieldMap.bind(undefined, config);
    !(typeof config.name === 'string') ? (0, _invariant.default)(0, 'Must provide name.') : void 0;
    !(config.resolveType == null || typeof config.resolveType === 'function') ? (0, _invariant.default)(0, "".concat(this.name, " must provide \"resolveType\" as a function, ") + "but got: ".concat((0, _inspect.default)(config.resolveType), ".")) : void 0;
  }

  var _proto3 = GraphQLInterfaceType.prototype;

  _proto3.getFields = function getFields() {
    if (typeof this._fields === 'function') {
      this._fields = this._fields();
    }

    return this._fields;
  };

  _proto3.toString = function toString() {
    return this.name;
  };

  return GraphQLInterfaceType;
}(); // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported


exports.GraphQLInterfaceType = GraphQLInterfaceType;
(0, _defineToStringTag.default)(GraphQLInterfaceType);
(0, _defineToJSON.default)(GraphQLInterfaceType);

/**
 * Union Type Definition
 *
 * When a field can return one of a heterogeneous set of types, a Union type
 * is used to describe what types are possible as well as providing a function
 * to determine which type is actually used when the field is resolved.
 *
 * Example:
 *
 *     const PetType = new GraphQLUnionType({
 *       name: 'Pet',
 *       types: [ DogType, CatType ],
 *       resolveType(value) {
 *         if (value instanceof Dog) {
 *           return DogType;
 *         }
 *         if (value instanceof Cat) {
 *           return CatType;
 *         }
 *       }
 *     });
 *
 */
var GraphQLUnionType =
/*#__PURE__*/
function () {
  function GraphQLUnionType(config) {
    _defineProperty(this, "name", void 0);

    _defineProperty(this, "description", void 0);

    _defineProperty(this, "astNode", void 0);

    _defineProperty(this, "extensionASTNodes", void 0);

    _defineProperty(this, "resolveType", void 0);

    _defineProperty(this, "_types", void 0);

    this.name = config.name;
    this.description = config.description;
    this.astNode = config.astNode;
    this.extensionASTNodes = config.extensionASTNodes;
    this.resolveType = config.resolveType;
    this._types = defineTypes.bind(undefined, config);
    !(typeof config.name === 'string') ? (0, _invariant.default)(0, 'Must provide name.') : void 0;
    !(config.resolveType == null || typeof config.resolveType === 'function') ? (0, _invariant.default)(0, "".concat(this.name, " must provide \"resolveType\" as a function, ") + "but got: ".concat((0, _inspect.default)(config.resolveType), ".")) : void 0;
  }

  var _proto4 = GraphQLUnionType.prototype;

  _proto4.getTypes = function getTypes() {
    if (typeof this._types === 'function') {
      this._types = this._types();
    }

    return this._types;
  };

  _proto4.toString = function toString() {
    return this.name;
  };

  return GraphQLUnionType;
}(); // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported


exports.GraphQLUnionType = GraphQLUnionType;
(0, _defineToStringTag.default)(GraphQLUnionType);
(0, _defineToJSON.default)(GraphQLUnionType);

function defineTypes(config) {
  var types = resolveThunk(config.types) || [];
  !Array.isArray(types) ? (0, _invariant.default)(0, 'Must provide Array of types or a function which returns ' + "such an array for Union ".concat(config.name, ".")) : void 0;
  return types;
}

/**
 * Enum Type Definition
 *
 * Some leaf values of requests and input values are Enums. GraphQL serializes
 * Enum values as strings, however internally Enums can be represented by any
 * kind of type, often integers.
 *
 * Example:
 *
 *     const RGBType = new GraphQLEnumType({
 *       name: 'RGB',
 *       values: {
 *         RED: { value: 0 },
 *         GREEN: { value: 1 },
 *         BLUE: { value: 2 }
 *       }
 *     });
 *
 * Note: If a value is not provided in a definition, the name of the enum value
 * will be used as its internal value.
 */
var GraphQLEnumType
/* <T> */
=
/*#__PURE__*/
function () {
  function GraphQLEnumType(config
  /* <T> */
  ) {
    _defineProperty(this, "name", void 0);

    _defineProperty(this, "description", void 0);

    _defineProperty(this, "astNode", void 0);

    _defineProperty(this, "extensionASTNodes", void 0);

    _defineProperty(this, "_values", void 0);

    _defineProperty(this, "_valueLookup", void 0);

    _defineProperty(this, "_nameLookup", void 0);

    this.name = config.name;
    this.description = config.description;
    this.astNode = config.astNode;
    this.extensionASTNodes = config.extensionASTNodes;
    this._values = defineEnumValues(this, config.values);
    this._valueLookup = new Map(this._values.map(function (enumValue) {
      return [enumValue.value, enumValue];
    }));
    this._nameLookup = (0, _keyMap.default)(this._values, function (value) {
      return value.name;
    });
    !(typeof config.name === 'string') ? (0, _invariant.default)(0, 'Must provide name.') : void 0;
  }

  var _proto5 = GraphQLEnumType.prototype;

  _proto5.getValues = function getValues() {
    return this._values;
  };

  _proto5.getValue = function getValue(name) {
    return this._nameLookup[name];
  };

  _proto5.serialize = function serialize(value
  /* T */
  ) {
    var enumValue = this._valueLookup.get(value);

    if (enumValue) {
      return enumValue.name;
    }
  };

  _proto5.parseValue = function parseValue(value)
  /* T */
  {
    if (typeof value === 'string') {
      var enumValue = this.getValue(value);

      if (enumValue) {
        return enumValue.value;
      }
    }
  };

  _proto5.parseLiteral = function parseLiteral(valueNode, _variables)
  /* T */
  {
    // Note: variables will be resolved to a value before calling this function.
    if (valueNode.kind === _kinds.Kind.ENUM) {
      var enumValue = this.getValue(valueNode.value);

      if (enumValue) {
        return enumValue.value;
      }
    }
  };

  _proto5.toString = function toString() {
    return this.name;
  };

  return GraphQLEnumType;
}(); // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported


exports.GraphQLEnumType = GraphQLEnumType;
(0, _defineToStringTag.default)(GraphQLEnumType);
(0, _defineToJSON.default)(GraphQLEnumType);

function defineEnumValues(type, valueMap
/* <T> */
) {
  !isPlainObj(valueMap) ? (0, _invariant.default)(0, "".concat(type.name, " values must be an object with value names as keys.")) : void 0;
  return Object.keys(valueMap).map(function (valueName) {
    var value = valueMap[valueName];
    !isPlainObj(value) ? (0, _invariant.default)(0, "".concat(type.name, ".").concat(valueName, " must refer to an object with a \"value\" key ") + "representing an internal value but got: ".concat((0, _inspect.default)(value), ".")) : void 0;
    !!value.hasOwnProperty('isDeprecated') ? (0, _invariant.default)(0, "".concat(type.name, ".").concat(valueName, " should provide \"deprecationReason\" instead ") + 'of "isDeprecated".') : void 0;
    return {
      name: valueName,
      description: value.description,
      isDeprecated: Boolean(value.deprecationReason),
      deprecationReason: value.deprecationReason,
      astNode: value.astNode,
      value: value.hasOwnProperty('value') ? value.value : valueName
    };
  });
}

/**
 * Input Object Type Definition
 *
 * An input object defines a structured collection of fields which may be
 * supplied to a field argument.
 *
 * Using `NonNull` will ensure that a value must be provided by the query
 *
 * Example:
 *
 *     const GeoPoint = new GraphQLInputObjectType({
 *       name: 'GeoPoint',
 *       fields: {
 *         lat: { type: GraphQLNonNull(GraphQLFloat) },
 *         lon: { type: GraphQLNonNull(GraphQLFloat) },
 *         alt: { type: GraphQLFloat, defaultValue: 0 },
 *       }
 *     });
 *
 */
var GraphQLInputObjectType =
/*#__PURE__*/
function () {
  function GraphQLInputObjectType(config) {
    _defineProperty(this, "name", void 0);

    _defineProperty(this, "description", void 0);

    _defineProperty(this, "astNode", void 0);

    _defineProperty(this, "extensionASTNodes", void 0);

    _defineProperty(this, "_fields", void 0);

    this.name = config.name;
    this.description = config.description;
    this.astNode = config.astNode;
    this.extensionASTNodes = config.extensionASTNodes;
    this._fields = defineInputFieldMap.bind(undefined, config);
    !(typeof config.name === 'string') ? (0, _invariant.default)(0, 'Must provide name.') : void 0;
  }

  var _proto6 = GraphQLInputObjectType.prototype;

  _proto6.getFields = function getFields() {
    if (typeof this._fields === 'function') {
      this._fields = this._fields();
    }

    return this._fields;
  };

  _proto6.toString = function toString() {
    return this.name;
  };

  return GraphQLInputObjectType;
}(); // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported


exports.GraphQLInputObjectType = GraphQLInputObjectType;
(0, _defineToStringTag.default)(GraphQLInputObjectType);
(0, _defineToJSON.default)(GraphQLInputObjectType);

function defineInputFieldMap(config) {
  var fieldMap = resolveThunk(config.fields) || {};
  !isPlainObj(fieldMap) ? (0, _invariant.default)(0, "".concat(config.name, " fields must be an object with field names as keys or a ") + 'function which returns such an object.') : void 0;
  var resultFieldMap = Object.create(null);

  var _arr2 = Object.keys(fieldMap);

  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var fieldName = _arr2[_i2];

    var field = _objectSpread({}, fieldMap[fieldName], {
      name: fieldName
    });

    !!field.hasOwnProperty('resolve') ? (0, _invariant.default)(0, "".concat(config.name, ".").concat(fieldName, " field has a resolve property, but ") + 'Input Types cannot define resolvers.') : void 0;
    resultFieldMap[fieldName] = field;
  }

  return resultFieldMap;
}

function isRequiredInputField(field) {
  return isNonNullType(field.type) && field.defaultValue === undefined;
}

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseDifference_js__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseRest_js__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLikeObject_js__ = __webpack_require__(495);




/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */
var without = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseRest_js__["a" /* default */])(function(array, values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArrayLikeObject_js__["a" /* default */])(array)
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseDifference_js__["a" /* default */])(array, values)
    : [];
});

/* harmony default export */ __webpack_exports__["a"] = (without);


/***/ }),
/* 56 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __assign; });
/* unused harmony export __rest */
/* unused harmony export __decorate */
/* unused harmony export __param */
/* unused harmony export __metadata */
/* harmony export (immutable) */ __webpack_exports__["c"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["d"] = __generator;
/* unused harmony export __createBinding */
/* unused harmony export __exportStar */
/* unused harmony export __values */
/* harmony export (immutable) */ __webpack_exports__["e"] = __read;
/* harmony export (immutable) */ __webpack_exports__["f"] = __spread;
/* unused harmony export __spreadArrays */
/* unused harmony export __spreadArray */
/* harmony export (immutable) */ __webpack_exports__["h"] = __await;
/* harmony export (immutable) */ __webpack_exports__["g"] = __asyncGenerator;
/* unused harmony export __asyncDelegator */
/* unused harmony export __asyncValues */
/* unused harmony export __makeTemplateObject */
/* unused harmony export __importStar */
/* unused harmony export __importDefault */
/* unused harmony export __classPrivateFieldGet */
/* unused harmony export __classPrivateFieldSet */
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _url = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/sort-comp */
/* eslint-disable max-len */


var LoadImage = function (_Component) {
  _inherits(LoadImage, _Component);

  function LoadImage(props) {
    var _this2 = this;

    _classCallCheck(this, LoadImage);

    var _this = _possibleConstructorReturn(this, (LoadImage.__proto__ || Object.getPrototypeOf(LoadImage)).call(this, props));

    _this.getPictureSize = function () {
      var pictureSize = _this.props.pictureSize;

      var size = '010';
      if (pictureSize) {
        size = parseInt(pictureSize, 10);
        if (pictureSize < 100) {
          size = '0'.concat(size);
        } else {
          size = '100';
        }
      }
      return size;
    };

    _this.getSize = function () {
      var size = _this.getPictureSize();
      switch (size) {
        case '010':
          return 'small';
        case '030':
        default:
          return 'medium';
        case '070':
          return 'large';
        case '100':
          return 'huge';
      }
    };

    _this.loadImage = function () {
      var _this$state = _this.state,
          loaded = _this$state.loaded,
          loading = _this$state.loading;

      if (!_this.state.eventAdded) {
        if (_this.props.picture && _this.props.picture.key && _this.props.picture.key.substr(_this.props.picture.key.length - 4).includes('.pdf')) {
          loaded = true;
          loading = !loaded;
        }
        _this.setState({ eventAdded: true, loaded: loaded, loading: loading }, function () {
          _this.addEvents();
          requestAnimationFrame(function () {
            _this.checkViewPort();
          });
        });
      }
    };

    _this.checkViewPort = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var wrapper, seeTop, seeBottom, isFullyVisible, firstLoadError;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(_this.wrapper && _this.wrapper.current && _this.wrapper.current.parentNode)) {
                _context.next = 16;
                break;
              }

              wrapper = _this.wrapper.current.parentNode.getBoundingClientRect();
              seeTop = wrapper.top <= window.innerHeight && wrapper.top > 0;
              seeBottom = wrapper.bottom <= window.innerHeight && wrapper.bottom > 0;
              isFullyVisible = wrapper.top >= 0 && wrapper.bottom <= window.innerHeight;

              if (!(seeTop || seeBottom || isFullyVisible)) {
                _context.next = 16;
                break;
              }

              if (!(!_this.state.loaded && !_this.state.loadFail && (_this.props.picture && _this.props.picture.key || _this.props.src))) {
                _context.next = 16;
                break;
              }

              firstLoadError = false;
              // load from base bucket first

              _context.next = 10;
              return _this.setNewImage();

            case 10:
              firstLoadError = _context.sent;

              if (!firstLoadError) {
                _context.next = 15;
                break;
              }

              _context.next = 14;
              return _this.setNewImage(_this.props.bucketName);

            case 14:
              firstLoadError = _context.sent;

            case 15:
              _this.removeEvents();

            case 16:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.setNewImage = function (bucketName) {
      return new Promise(function (resolve) {
        _this.image = new Image();
        var url = _this.renderImage(bucketName);
        _this.image.src = url;
        _this.image.onload = function () {
          _this.setState({ imgSrc: url });
          _this.setOnLoad();
          resolve(false);
        };
        _this.image.onerror = function () {
          // for pdf payment picture without '.pdf'
          if (url.endsWith('_100.jpg')) {
            url = url.replace('_100.jpg', '.pdf');
            _this.image.src = url;
            _this.setState({ imgSrc: url });
            _this.setOnLoad();
            resolve(false);
          }
          _this.handleOnError();
          resolve(true);
        };
      });
    };

    _this.setOnLoad = function () {
      var backgroundSize = 'cover';
      if (_this.props.asBackground && _this.wrapper && _this.wrapper.current) {
        if (_this.image.height < _this.wrapper.current.clientHeight || _this.image.width < _this.wrapper.current.clientWidth) {
          backgroundSize = 'contain';
        }
      }
      _this.handleOnLoad(backgroundSize);
    };

    _this.handleOnLoad = function () {
      var backgroundSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cover';

      _this.setState({
        loaded: true,
        loading: false,
        backgroundSize: backgroundSize
      }, function () {
        _this.endLoad();
      });
    };

    _this.handleOnError = function () {
      _this.setState({
        loading: false,
        loadFail: true
      }, function () {
        _this.endLoad();
      });
    };

    _this.handleOnClick = function (e) {
      if (_this.props.onClick && _this.state.loaded) {
        _this.props.onClick(e);
      }
    };

    _this.handleNewTab = function (e) {
      if (_this.props.openNewTab) {
        e.preventDefault();
        var winObj = window.open(_this.renderImage(), '_blank');
        winObj.opener = null;
      }
    };

    _this.renderComponentPdf = function () {
      return _react2.default.createElement(
        'div',
        { className: 'icon-wrap' },
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: 'round icon' },
            _react2.default.createElement('img', { alt: 'e-signing', src: '/assets/images/icons/tick-white.svg' })
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          'Document uploaded'
        )
      );
    };

    _this.renderStyle = function (backgroundSize) {
      var url = _this.renderImage();
      var style = {
        backgroundImage: 'url(' + url + ')',
        backgroundSize: backgroundSize,
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      };
      return style;
    };

    _this.state = {
      eventAdded: false,
      loading: props.loading || true,
      loaded: false,
      loadFail: false,
      backgroundSize: 'cover',
      imgSrc: ''
    };
    _this.image = null;
    _this.wrapper = _react2.default.createRef();
    _this.observer = null;
    return _this;
  }

  _createClass(LoadImage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      if (!this.image && this.state.loading) {
        if (this.props.picture || this.props.src) {
          this.loadImage();
        }
      } else if (this.image && this.image.complete) {
        this.handleOnLoad();
      }
      // Use IntersectionObserver for viewport detection
      this.observer = new window.IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            _this3.checkViewPort();
          }
        });
      }, { threshold: 0.1 });
      if (this.wrapper.current) {
        this.observer.observe(this.wrapper.current);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this4 = this;

      var loaded = false;
      var loading = false;
      if (!this.state.loadFail) {
        if (nextProps.loading !== undefined) {
          loading = nextProps.loading;
        }
        if (nextProps.picture && this.props.picture || nextProps.src && this.props.src) {
          if (nextProps.picture && this.props.picture && nextProps.picture.key === this.props.picture.key || nextProps.src === this.props.src) {
            loaded = this.state.loaded;
            loading = !loaded;
          }
          if (nextProps.picture && this.props.picture && nextProps.picture.key !== this.props.picture.key || nextProps.src !== this.props.src) {
            this.removeEvents();
            this.image = null;
            loading = true;
            loaded = false;
          }
          if (this.props.picture && this.props.picture.key && this.props.picture.key.substr(this.props.picture.key.length - 4).includes('.pdf') || nextProps.picture && nextProps.picture.key && nextProps.picture.key.substr(nextProps.picture.key.length - 4).includes('.pdf')) {
            loaded = true;
            loading = !loaded;
          }
        }
      }
      this.setState({ loaded: loaded, loading: loading }, function () {
        if (!loaded && !_this4.state.loadFail && (nextProps.picture && nextProps.picture.key || nextProps.src)) {
          if (!_this4.image) {
            _this4.loadImage();
          }
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.endLoad();
      this.removeEvents();
      if (this.observer && this.wrapper.current) {
        this.observer.unobserve(this.wrapper.current);
        this.observer.disconnect();
      }
    }
  }, {
    key: 'endLoad',
    value: function endLoad() {
      if (this.image) {
        this.image.onload = null;
        this.image.onerror = null;
        this.image = null;
        this.removeEvents();
      }
    }
  }, {
    key: 'addEvents',
    value: function addEvents() {
      var _this5 = this;

      requestAnimationFrame(function () {
        _this5.checkViewPort();
      });
      var modals = document.getElementsByClassName('ui page modals dimmer transition visible active');
      if (this.wrapper && this.wrapper.current && modals.length > 0 && modals[0].contains(this.wrapper.current)) {
        modals[0].addEventListener('load', this.checkViewPort, false);
        modals[0].addEventListener('resize', this.checkViewPort, false);
        modals[0].addEventListener('scroll', this.checkViewPort, false);
      }
      document.addEventListener('DOMContentLoaded', this.checkViewPort, false);
      window.addEventListener('load', this.checkViewPort, false);
      window.addEventListener('resize', this.checkViewPort, false);
      window.addEventListener('scroll', this.checkViewPort, false);
    }
  }, {
    key: 'removeEvents',
    value: function removeEvents() {
      var _this6 = this;

      if (this.state.eventAdded) {
        this.setState({ eventAdded: false }, function () {
          var modals = document.getElementsByClassName('ui page modals dimmer transition visible active');
          if (_this6.wrapper && _this6.wrapper.current && modals.length > 0 && modals[0].contains(_this6.wrapper.current)) {
            modals[0].removeEventListener('load', _this6.checkViewPort, false);
            modals[0].removeEventListener('resize', _this6.checkViewPort, false);
            modals[0].removeEventListener('scroll', _this6.checkViewPort, false);
          }
          document.removeEventListener('DOMContentLoaded', _this6.checkViewPort, false);
          window.removeEventListener('load', _this6.checkViewPort, false);
          window.removeEventListener('resize', _this6.checkViewPort, false);
          window.removeEventListener('scroll', _this6.checkViewPort, false);
        });
      }
    }
  }, {
    key: 'renderImage',
    value: function renderImage() {
      var bucketName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var _props = this.props,
          picture = _props.picture,
          extension = _props.extension;

      if (picture && picture.key) {
        var pictureSize = this.getPictureSize() + '.' + extension;
        if (picture.key.substr(picture.key.length - 4).includes('.pdf')) {
          pictureSize = '';
        }
        var fileUrl = '' + picture.key + pictureSize;
        if (bucketName) fileUrl = '' + picture.key;
        return (0, _url.AWSUrl)(this.props.appConfig, fileUrl, bucketName);
      }
      return this.props.src || '#';
    }
  }, {
    key: 'renderClassNames',
    value: function renderClassNames() {
      var _props2 = this.props,
          cover = _props2.cover,
          autoWidth = _props2.autoWidth,
          constrain = _props2.constrain,
          isVideo = _props2.isVideo;

      var classNames = ['load-image'];
      if (this.state.loaded) {
        classNames.push('loaded');
      }
      if (constrain) {
        classNames.push('constrain');
      }
      if (autoWidth) {
        classNames.push('auto-width');
      }
      if (cover) {
        var ratio = 'ratio';
        switch (cover) {
          case 'long':
            ratio += '2_1';
            break;
          case 'long vertical':
          case 'vertical long':
            ratio += '1_2';
            break;
          default:
            ratio += '16_9';
        }
        classNames.push(ratio);
      }
      if (isVideo) {
        classNames.push('video');
      }
      return classNames.join(' ');
    }
  }, {
    key: 'renderComponentType',
    value: function renderComponentType() {
      var _state = this.state,
          backgroundSize = _state.backgroundSize,
          imgSrc = _state.imgSrc;

      var src = imgSrc || this.renderImage();
      var picture = this.props.picture;

      if (picture && picture.key && picture.key.substr(picture.key.length - 4).includes('.pdf') || src.substr(src.length - 4).includes('.pdf')) {
        return this.renderComponentPdf();
      }
      if (this.props.asBackground) {
        if (this.props.isVideo) {
          return _react2.default.createElement(
            'div',
            {
              style: this.renderStyle(backgroundSize)
            },
            _react2.default.createElement(_semanticUiReact.Icon, {
              size: 'big',
              name: 'video play'
            })
          );
        }
        return _react2.default.createElement('div', {
          style: this.renderStyle(backgroundSize)
        });
      }
      if (this.props.isVideo) {
        return _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(_semanticUiReact.Image, {
            centered: true,
            fluid: this.props.fluid,
            shape: this.props.shape,
            label: this.props.labelNode,
            src: src,
            onClick: this.handleNewTab
          }),
          _react2.default.createElement(_semanticUiReact.Icon, {
            size: 'big',
            name: 'video play'
          })
        );
      }
      return _react2.default.createElement(_semanticUiReact.Image, {
        centered: true,
        fluid: this.props.fluid,
        shape: this.props.shape,
        label: this.props.labelNode,
        src: src,
        onClick: this.handleNewTab
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;
      var loaded = this.state.loaded;

      return _react2.default.createElement(
        _semanticUiReact.Image,
        {
          className: this.renderClassNames(),
          as: this.props.as,
          fluid: this.props.fluid,
          size: !this.props.fluid ? this.props.size || this.getSize() : null,
          centered: this.props.centered,
          inline: this.props.inline,
          onClick: this.handleOnClick
        },
        _react2.default.createElement(
          'div',
          {
            ref: this.wrapper
          },
          loaded ? this.renderComponentType() : _react2.default.createElement(
            _semanticUiReact.Image,
            {
              className: 'load-image-placeholder',
              centered: true,
              shape: this.props.shape
            },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { active: this.state.loading },
              this.props.placeholder || t('Loading')
            ),
            !this.props.picture && !this.props.src && !this.state.loading && !this.state.loadFail ? this.props.notFoundNode || t('Not Found') : null,
            this.state.loadFail ? _react2.default.createElement(_semanticUiReact.Icon, {
              size: 'large',
              name: 'exclamation triangle',
              style: { marginRight: 0 }
            }) : null
          )
        )
      );
    }
  }]);

  return LoadImage;
}(_react.Component);

LoadImage.propTypes = {
  appConfig: _propTypes2.default.shape({}),
  autoWidth: _propTypes2.default.bool,
  placeholder: _propTypes2.default.node,
  picture: _propTypes2.default.shape({
    key: _propTypes2.default.string
  }),
  pictureSize: _propTypes2.default.number,
  src: _propTypes2.default.string,
  centered: _propTypes2.default.bool,
  inline: _propTypes2.default.bool,
  size: _propTypes2.default.string,
  shape: _propTypes2.default.string,
  fluid: _propTypes2.default.bool,
  as: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  onClick: _propTypes2.default.func,
  openNewTab: _propTypes2.default.bool,
  labelNode: _propTypes2.default.node,
  cover: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
  notFoundNode: _propTypes2.default.node,
  loading: _propTypes2.default.bool,
  extension: _propTypes2.default.oneOf(['jpg', 'jpeg', 'png', 'gif', 'pdf']),
  constrain: _propTypes2.default.bool,
  asBackground: _propTypes2.default.bool,
  bucketName: _propTypes2.default.string,
  isVideo: _propTypes2.default.bool
};
LoadImage.defaultProps = {
  extension: 'jpg',
  constrain: null,
  isVideo: false
};

LoadImage.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig
  };
};

exports.default = (0, _reactI18next.withTranslation)()((0, _reactRedux.connect)(LoadImage.mapStateToProps)(LoadImage));

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SortButton = function (_Component) {
  _inherits(SortButton, _Component);

  function SortButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SortButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SortButton.__proto__ || Object.getPrototypeOf(SortButton)).call.apply(_ref, [this].concat(args))), _this), _this.getDataAttributes = function (datarget) {
      if (datarget !== '') {
        return {
          'data-bot-target': datarget
        };
      }
      return '';
    }, _this.handleOnSort = function (column, direction) {
      if (_this.props.onSort) {
        _this.props.onSort(column, direction);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SortButton, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.items !== nextProps.items || this.props.icon !== nextProps.icon || this.props.color !== nextProps.color || this.props.loading !== nextProps.loading) {
        return true;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Button.Group,
        { color: this.props.color || 'teal', floated: this.props.floated, className: this.props.className },
        _react2.default.createElement(
          _semanticUiReact.Dropdown,
          {
            className: 'sort-button icon',
            icon: this.props.icon || _react2.default.createElement(_semanticUiReact.Icon, {
              name: 'exchange',
              rotated: 'clockwise'
            }),
            floating: true,
            scrolling: true,
            button: true,
            disabled: this.props.loading || this.props.disabled
          },
          _react2.default.createElement(
            _semanticUiReact.Dropdown.Menu,
            null,
            this.props.header ? _react2.default.createElement(_semanticUiReact.Dropdown.Header, { content: this.props.header }) : null,
            this.props.items && this.props.items.length > 0 ? this.props.items.map(function (item, idx) {
              if (item.isDivider) {
                return _react2.default.createElement(_semanticUiReact.Dropdown.Divider, { key: idx });
              }
              return _react2.default.createElement(_semanticUiReact.Dropdown.Item, _extends({}, _this2.getDataAttributes(item.dataTarget), {
                key: idx,
                as: item.href ? 'a' : null,
                text: t(item.text),
                icon: item.icon,
                href: item.href || null,
                target: item.href && item.target ? item.target : null,
                rel: item.href && item.rel ? item.rel : null,
                onClick: function onClick() {
                  if (!item.href) {
                    if (item.onClick) {
                      return item.onClick();
                    }
                    return _this2.handleOnSort(item.sortColumn, item.sortDirection);
                  }
                }
              }));
            }) : null
          )
        )
      );
    }
  }]);

  return SortButton;
}(_react.Component);

SortButton.propTypes = {
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string,
    icon: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
    sortColumn: _propTypes2.default.string,
    sortDirection: _propTypes2.default.string,
    href: _propTypes2.default.string,
    target: _propTypes2.default.string,
    rel: _propTypes2.default.string,
    isDivider: _propTypes2.default.bool,
    onClick: _propTypes2.default.func,
    dataTarget: _propTypes2.default.string
  })).isRequired,
  icon: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.node, _propTypes2.default.string]),
  loading: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  onSort: _propTypes2.default.func,
  floated: _propTypes2.default.string,
  className: _propTypes2.default.string,
  header: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.translation)(SortButton);

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// Imported and modified from https://restcountries.eu/rest/v2/all?fields=name;alpha2Code;
var COUNTRIES = [{ name: 'Afghanistan', countryCode: 'af' }, { name: 'Aland Islands', countryCode: 'ax' }, { name: 'Albania', countryCode: 'al' }, { name: 'Algeria', countryCode: 'dz' }, { name: 'American Samoa', countryCode: 'as' }, { name: 'Andorra', countryCode: 'ad' }, { name: 'Angola', countryCode: 'ao' }, { name: 'Anguilla', countryCode: 'ai' }, { name: 'Antigua', countryCode: 'ag' }, { name: 'Argentina', countryCode: 'ar' }, { name: 'Armenia', countryCode: 'am' }, { name: 'Aruba', countryCode: 'aw' }, { name: 'Australia', countryCode: 'au' }, { name: 'Austria', countryCode: 'at' }, { name: 'Azerbaijan', countryCode: 'az' }, { name: 'Bahamas', countryCode: 'bs' }, { name: 'Bahrain', countryCode: 'bh' }, { name: 'Bangladesh', countryCode: 'bd' }, { name: 'Barbados', countryCode: 'bb' }, { name: 'Belarus', countryCode: 'by' }, { name: 'Belgium', countryCode: 'be' }, { name: 'Belize', countryCode: 'bz' }, { name: 'Benin', countryCode: 'bj' }, { name: 'Bermuda', countryCode: 'bm' }, { name: 'Bhutan', countryCode: 'bt' }, { name: 'Bolivia', countryCode: 'bo' }, { name: 'Bosnia', countryCode: 'ba' }, { name: 'Botswana', countryCode: 'bw' }, { name: 'Bouvet Island', countryCode: 'bv' }, { name: 'Brazil', countryCode: 'br' }, { name: 'British Virgin Islands', countryCode: 'vg' }, { name: 'Brunei', countryCode: 'bn' }, { name: 'Bulgaria', countryCode: 'bg' }, { name: 'Burkina Faso', countryCode: 'bf' }, { name: 'Myanmar', countryCode: 'mm', alias: 'Burma' }, { name: 'Burundi', countryCode: 'bi' }, { name: 'Caicos Islands', countryCode: 'tc' }, { name: 'Cambodia', countryCode: 'kh' }, { name: 'Cameroon', countryCode: 'cm' }, { name: 'Canada', countryCode: 'ca' }, { name: 'Cape Verde', countryCode: 'cv' }, { name: 'Cayman Islands', countryCode: 'ky' }, { name: 'Central African Republic', countryCode: 'cf' }, { name: 'Chad', countryCode: 'td' }, { name: 'Chile', countryCode: 'cl' }, { name: 'China', countryCode: 'cn' }, { name: 'Christmas Island', countryCode: 'cx' }, { name: 'Cocos Islands', countryCode: 'cc' }, { name: 'Colombia', countryCode: 'co' }, { name: 'Comoros', countryCode: 'km' }, { name: 'Congo', countryCode: 'cd' }, { name: 'Congo Brazzaville', countryCode: 'cg' }, { name: 'Cook Islands', countryCode: 'ck' }, { name: 'Costa Rica', countryCode: 'cr' }, { name: 'Cote Divoire', countryCode: 'ci' }, { name: 'Croatia', countryCode: 'hr' }, { name: 'Cuba', countryCode: 'cu' }, { name: 'Cyprus', countryCode: 'cy' }, { name: 'Czech Republic', countryCode: 'cz' }, { name: 'Denmark', countryCode: 'dk' }, { name: 'Djibouti', countryCode: 'dj' }, { name: 'Dominica', countryCode: 'dm' }, { name: 'Dominican Republic', countryCode: 'do' }, { name: 'Ecuador', countryCode: 'ec' }, { name: 'Egypt', countryCode: 'eg' }, { name: 'El Salvador', countryCode: 'sv' }, { name: 'Equatorial Guinea', countryCode: 'gq' }, { name: 'Eritrea', countryCode: 'er' }, { name: 'Estonia', countryCode: 'ee' }, { name: 'Ethiopia', countryCode: 'et' }, { name: 'Europeanunion', countryCode: 'eu' }, { name: 'Falkland Islands', countryCode: 'fk' }, { name: 'Faroe Islands', countryCode: 'fo' }, { name: 'Fiji', countryCode: 'fj' }, { name: 'Finland', countryCode: 'fi' }, { name: 'France', countryCode: 'fr' }, { name: 'French Guiana', countryCode: 'gf' }, { name: 'French Polynesia', countryCode: 'pf' }, { name: 'French Territories', countryCode: 'tf' }, { name: 'Gabon', countryCode: 'ga' }, { name: 'Gambia', countryCode: 'gm' }, { name: 'Georgia', countryCode: 'ge' }, { name: 'Germany', countryCode: 'de' }, { name: 'Ghana', countryCode: 'gh' }, { name: 'Gibraltar', countryCode: 'gi' }, { name: 'Greece', countryCode: 'gr' }, { name: 'Greenland', countryCode: 'gl' }, { name: 'Grenada', countryCode: 'gd' }, { name: 'Guadeloupe', countryCode: 'gp' }, { name: 'Guam', countryCode: 'gu' }, { name: 'Guatemala', countryCode: 'gt' }, { name: 'Guinea', countryCode: 'gn' }, { name: 'Guinea-Bissau', countryCode: 'gw' }, { name: 'Guyana', countryCode: 'gy' }, { name: 'Haiti', countryCode: 'ht' }, { name: 'Heard Island', countryCode: 'hm' }, { name: 'Honduras', countryCode: 'hn' }, { name: 'Hong Kong', countryCode: 'hk' }, { name: 'Hungary', countryCode: 'hu' }, { name: 'Iceland', countryCode: 'is' }, { name: 'India', countryCode: 'in' }, { name: 'Indian Ocean Territory', countryCode: 'io' }, { name: 'Indonesia', countryCode: 'id' }, { name: 'Iran', countryCode: 'ir' }, { name: 'Iraq', countryCode: 'iq' }, { name: 'Ireland', countryCode: 'ie' }, { name: 'Israel', countryCode: 'il' }, { name: 'Italy', countryCode: 'it' }, { name: 'Jamaica', countryCode: 'jm' }, { name: 'Jan Mayen', countryCode: 'sj', alias: 'Svalbard' }, { name: 'Japan', countryCode: 'jp' }, { name: 'Jordan', countryCode: 'jo' }, { name: 'Kazakhstan', countryCode: 'kz' }, { name: 'Kenya', countryCode: 'ke' }, { name: 'Kiribati', countryCode: 'ki' }, { name: 'Kuwait', countryCode: 'kw' }, { name: 'Kyrgyzstan', countryCode: 'kg' }, { name: 'Laos', countryCode: 'la' }, { name: 'Latvia', countryCode: 'lv' }, { name: 'Lebanon', countryCode: 'lb' }, { name: 'Lesotho', countryCode: 'ls' }, { name: 'Liberia', countryCode: 'lr' }, { name: 'Libya', countryCode: 'ly' }, { name: 'Liechtenstein', countryCode: 'li' }, { name: 'Lithuania', countryCode: 'lt' }, { name: 'Luxembourg', countryCode: 'lu' }, { name: 'Macau', countryCode: 'mo' }, { name: 'Macedonia', countryCode: 'mk' }, { name: 'Madagascar', countryCode: 'mg' }, { name: 'Malawi', countryCode: 'mw' }, { name: 'Malaysia', countryCode: 'my' }, { name: 'Maldives', countryCode: 'mv' }, { name: 'Mali', countryCode: 'ml' }, { name: 'Malta', countryCode: 'mt' }, { name: 'Marshall Islands', countryCode: 'mh' }, { name: 'Martinique', countryCode: 'mq' }, { name: 'Mauritania', countryCode: 'mr' }, { name: 'Mauritius', countryCode: 'mu' }, { name: 'Mayotte', countryCode: 'yt' }, { name: 'Mexico', countryCode: 'mx' }, { name: 'Micronesia', countryCode: 'fm' }, { name: 'Moldova', countryCode: 'md' }, { name: 'Monaco', countryCode: 'mc' }, { name: 'Mongolia', countryCode: 'mn' }, { name: 'Montenegro', countryCode: 'me' }, { name: 'Montserrat', countryCode: 'ms' }, { name: 'Morocco', countryCode: 'ma' }, { name: 'Mozambique', countryCode: 'mz' }, { name: 'Namibia', countryCode: 'na' }, { name: 'Nauru', countryCode: 'nr' }, { name: 'Nepal', countryCode: 'np' }, { name: 'Netherlands', countryCode: 'nl' }, { name: 'Netherlandsantilles', countryCode: 'an' }, { name: 'New Caledonia', countryCode: 'nc' }, { name: 'New Guinea', countryCode: 'pg' }, { name: 'New Zealand', countryCode: 'nz' }, { name: 'Nicaragua', countryCode: 'ni' }, { name: 'Niger', countryCode: 'ne' }, { name: 'Nigeria', countryCode: 'ng' }, { name: 'Niue', countryCode: 'nu' }, { name: 'Norfolk Island', countryCode: 'nf' }, { name: 'North Korea', countryCode: 'kp' }, { name: 'Northern Mariana Islands', countryCode: 'mp' }, { name: 'Norway', countryCode: 'no' }, { name: 'Oman', countryCode: 'om' }, { name: 'Pakistan', countryCode: 'pk' }, { name: 'Palau', countryCode: 'pw' }, { name: 'Palestine', countryCode: 'ps' }, { name: 'Panama', countryCode: 'pa' }, { name: 'Paraguay', countryCode: 'py' }, { name: 'Peru', countryCode: 'pe' }, { name: 'Philippines', countryCode: 'ph' }, { name: 'Pitcairn Islands', countryCode: 'pn' }, { name: 'Poland', countryCode: 'pl' }, { name: 'Portugal', countryCode: 'pt' }, { name: 'Puerto Rico', countryCode: 'pr' }, { name: 'Qatar', countryCode: 'qa' }, { name: 'Reunion', countryCode: 're' }, { name: 'Romania', countryCode: 'ro' }, { name: 'Russia', countryCode: 'ru' }, { name: 'Rwanda', countryCode: 'rw' }, { name: 'Saint Helena', countryCode: 'sh' }, { name: 'Saint Kitts and Nevis', countryCode: 'kn' }, { name: 'Saint Lucia', countryCode: 'lc' }, { name: 'Saint Pierre', countryCode: 'pm' }, { name: 'Saint Vincent', countryCode: 'vc' }, { name: 'Samoa', countryCode: 'ws' }, { name: 'San Marino', countryCode: 'sm' }, { name: 'Sandwich Islands', countryCode: 'gs' }, { name: 'Sao Tome', countryCode: 'st' }, { name: 'Saudi Arabia', countryCode: 'sa' }, { name: 'Scotland', countryCode: 'gb sct' }, { name: 'Senegal', countryCode: 'sn' }, { name: 'Serbia', countryCode: 'cs' }, { name: 'Serbia', countryCode: 'rs' }, { name: 'Seychelles', countryCode: 'sc' }, { name: 'Sierra Leone', countryCode: 'sl' }, { name: 'Singapore', countryCode: 'sg' }, { name: 'Slovakia', countryCode: 'sk' }, { name: 'Slovenia', countryCode: 'si' }, { name: 'Solomon Islands', countryCode: 'sb' }, { name: 'Somalia', countryCode: 'so' }, { name: 'South Africa', countryCode: 'za' }, { name: 'South Korea', countryCode: 'kr' }, { name: 'Spain', countryCode: 'es' }, { name: 'Sri Lanka', countryCode: 'lk' }, { name: 'Sudan', countryCode: 'sd' }, { name: 'Suriname', countryCode: 'sr' }, { name: 'Swaziland', countryCode: 'sz' }, { name: 'Sweden', countryCode: 'se' }, { name: 'Switzerland', countryCode: 'ch' }, { name: 'Syria', countryCode: 'sy' }, { name: 'Taiwan', countryCode: 'tw' }, { name: 'Tajikistan', countryCode: 'tj' }, { name: 'Tanzania', countryCode: 'tz' }, { name: 'Thailand', countryCode: 'th' }, { name: 'Timorleste', countryCode: 'tl' }, { name: 'Togo', countryCode: 'tg' }, { name: 'Tokelau', countryCode: 'tk' }, { name: 'Tonga', countryCode: 'to' }, { name: 'Trinidad', countryCode: 'tt' }, { name: 'Tunisia', countryCode: 'tn' }, { name: 'Turkey', countryCode: 'tr' }, { name: 'Turkmenistan', countryCode: 'tm' }, { name: 'Tuvalu', countryCode: 'tv' }, { name: 'United Arab Emirates', countryCode: 'ae', alias: 'United Arab Emirates' }, { name: 'Uganda', countryCode: 'ug' }, { name: 'Ukraine', countryCode: 'ua' }, { name: 'United Kingdom', countryCode: 'gb' }, { name: 'United States', countryCode: 'us', alias: 'America' }, { name: 'Uruguay', countryCode: 'uy' }, { name: 'US Minor Islands', countryCode: 'um' }, { name: 'US Virgin Islands', countryCode: 'vi' }, { name: 'Uzbekistan', countryCode: 'uz' }, { name: 'Vanuatu', countryCode: 'vu' }, { name: 'Vatican City', countryCode: 'va' }, { name: 'Venezuela', countryCode: 've' }, { name: 'Vietnam', countryCode: 'vn' }, { name: 'Wales', countryCode: 'gb wls' }, { name: 'Wallis and Futuna', countryCode: 'wf' }, { name: 'Western Sahara', countryCode: 'eh' }, { name: 'Yemen', countryCode: 'ye' }, { name: 'Zambia', countryCode: 'zm' }, { name: 'Zimbabwe', countryCode: 'zw' }];

var SELECT_COUNTRIES = exports.SELECT_COUNTRIES = COUNTRIES.map(function (obj) {
  return {
    text: obj.name,
    value: obj.countryCode,
    flag: obj.countryCode
  };
});

var SELECT_NATIONALITY = exports.SELECT_NATIONALITY = [].concat(_toConsumableArray(SELECT_COUNTRIES), [{ text: 'Not Applicable', value: 'Not Applicable' }]);

var normalizeCountryCode = function normalizeCountryCode(countryCode) {
  return String(countryCode || '').toLowerCase();
};

var isCountryMalaysia = exports.isCountryMalaysia = function isCountryMalaysia(countryCode) {
  return normalizeCountryCode(countryCode) === 'my';
};

var isCountryIndonesia = exports.isCountryIndonesia = function isCountryIndonesia(countryCode) {
  return normalizeCountryCode(countryCode) === 'id';
};

var isCountryVietnam = exports.isCountryVietnam = function isCountryVietnam(countryCode) {
  return normalizeCountryCode(countryCode) === 'vn';
};

exports.default = COUNTRIES;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.checkChanges = checkChanges;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _prompt = __webpack_require__(66);

var _promptMessages = __webpack_require__(43);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-param-reassign: 0 */

function checkChanges(Comp) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var CheckChanges = function (_Component) {
    _inherits(CheckChanges, _Component);

    function CheckChanges(props) {
      _classCallCheck(this, CheckChanges);

      var _this = _possibleConstructorReturn(this, (CheckChanges.__proto__ || Object.getPrototypeOf(CheckChanges)).call(this, props));

      _this.checkBeforeClose = function (e) {
        if (_this.state.hasChanges) {
          var msg = 'You have unsaved changes. Do you still want to leave?';
          e.returnValue = msg; // REQUIRED
          if (e.stopPropagation) {
            e.stopPropagation();
            e.preventDefault();
          }
          return msg;
        }
        return true;
      };

      _this.getTranslatedMessage = function () {
        var t = _this.props.t;

        var message = _promptMessages.DEFAULT_PROMPT;
        if (options.message) {
          message = options.message;
        }
        // Translate the message if t function is available
        if (t) {
          return t(message, { ns: _translation.TRANSLATION_FILES.translation });
        }
        return message;
      };

      _this.handleOnCheck = function () {
        var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var callback = arguments[1];

        if (hasChanges !== _this.state.hasChanges) {
          _this.setState({ hasChanges: hasChanges }, function () {
            if (callback) {
              callback(!_this.state.hasChanges);
            }
          });
        } else if (callback) {
          callback(!_this.state.hasChanges);
        }
      };

      _this.handleHasChanges = function () {
        return _this.state.hasChanges;
      };

      _this.handleRegisterLeaveGuard = function (guard) {
        _this.leaveGuard = guard;
      };

      _this.state = {
        hasChanges: false
      };
      return _this;
    }

    _createClass(CheckChanges, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.checkBeforeLeave();
        window.addEventListener('beforeunload', this.checkBeforeClose, false);
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        window.removeEventListener('beforeunload', this.checkBeforeClose, false);
      }
    }, {
      key: 'checkBeforeLeave',
      value: function checkBeforeLeave() {
        var _this2 = this;

        this.context.router.setRouteLeaveHook(this.props.route, function (nextLocation) {
          // A leave guard registered by the wrapped component (the Reserve screen's unit hold) asks
          // first and runs its own step before the navigation. It only covers navigation inside the
          // app: a refresh or tab close calls this hook without a location and is left alone.
          var guard = _this2.leaveGuard;
          if (nextLocation && guard && guard.shouldBlock()) {
            var store = _this2.context.store;

            var callback = function callback() {
              _this2.setState({ hasChanges: false }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.prev = 0;
                        _context.next = 3;
                        return guard.onConfirm();

                      case 3:
                        _context.next = 7;
                        break;

                      case 5:
                        _context.prev = 5;
                        _context.t0 = _context['catch'](0);

                      case 7:
                        store.dispatch((0, _prompt.promptChangesLeave)(nextLocation));

                      case 8:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this2, [[0, 5]]);
              })));
            };
            store.dispatch((0, _prompt.promptChangesMessage)({
              header: guard.header(),
              message: guard.message(),
              callback: callback
            }));
            return false;
          }
          if (_this2.state.hasChanges) {
            var _store = _this2.context.store;

            var _callback = function _callback() {
              _this2.setState({ hasChanges: false }, function () {
                if (options.callback) {
                  options.callback();
                } else {
                  _store.dispatch((0, _prompt.promptChangesLeave)(nextLocation));
                }
              });
            };
            var message = _this2.getTranslatedMessage();
            _store.dispatch((0, _prompt.promptChangesMessage)({ callback: _callback, message: message }));
            return false;
          }
          return true;
        });
      }
      // handleRegisterLeaveGuard takes { shouldBlock(), header(), message(), onConfirm() } or null.
      // react-router v3 keeps one leave hook per route, so the wrapped component cannot add its own.

    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Comp, _extends({
          onCheck: this.handleOnCheck,
          checkHasChanges: this.handleHasChanges,
          registerLeaveGuard: this.handleRegisterLeaveGuard
        }, this.props));
      }
    }]);

    return CheckChanges;
  }(_react.Component);

  CheckChanges.propTypes = {
    route: _propTypes2.default.shape({}),
    t: _propTypes2.default.func
  };
  CheckChanges.contextTypes = {
    store: _propTypes2.default.object,
    router: _propTypes2.default.object
  };


  return (0, _reactI18next.withTranslation)([_translation.TRANSLATION_FILES.translation])(CheckChanges);
}

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BlockTree = __webpack_require__(2851);

var ContentState = __webpack_require__(644);

var EditorBidiService = __webpack_require__(2872);

var SelectionState = __webpack_require__(425);

var Immutable = __webpack_require__(46);

var OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Stack = Immutable.Stack,
    OrderedMap = Immutable.OrderedMap,
    List = Immutable.List; // When configuring an editor, the user can chose to provide or not provide
// basically all keys. `currentContent` varies, so this type doesn't include it.
// (See the types defined below.)

var defaultRecord = {
  allowUndo: true,
  currentContent: null,
  decorator: null,
  directionMap: null,
  forceSelection: false,
  inCompositionMode: false,
  inlineStyleOverride: null,
  lastChangeType: null,
  nativelyRenderedContent: null,
  redoStack: Stack(),
  selection: null,
  treeMap: null,
  undoStack: Stack()
};
var EditorStateRecord = Record(defaultRecord);

var EditorState = /*#__PURE__*/function () {
  EditorState.createEmpty = function createEmpty(decorator) {
    return this.createWithText('', decorator);
  };

  EditorState.createWithText = function createWithText(text, decorator) {
    return EditorState.createWithContent(ContentState.createFromText(text), decorator);
  };

  EditorState.createWithContent = function createWithContent(contentState, decorator) {
    if (contentState.getBlockMap().count() === 0) {
      return EditorState.createEmpty(decorator);
    }

    var firstKey = contentState.getBlockMap().first().getKey();
    return EditorState.create({
      currentContent: contentState,
      undoStack: Stack(),
      redoStack: Stack(),
      decorator: decorator || null,
      selection: SelectionState.createEmpty(firstKey)
    });
  };

  EditorState.create = function create(config) {
    var currentContent = config.currentContent,
        decorator = config.decorator;

    var recordConfig = _objectSpread({}, config, {
      treeMap: generateNewTreeMap(currentContent, decorator),
      directionMap: EditorBidiService.getDirectionMap(currentContent)
    });

    return new EditorState(new EditorStateRecord(recordConfig));
  };

  EditorState.fromJS = function fromJS(config) {
    return new EditorState(new EditorStateRecord(_objectSpread({}, config, {
      directionMap: config.directionMap != null ? OrderedMap(config.directionMap) : config.directionMap,
      inlineStyleOverride: config.inlineStyleOverride != null ? OrderedSet(config.inlineStyleOverride) : config.inlineStyleOverride,
      nativelyRenderedContent: config.nativelyRenderedContent != null ? ContentState.fromJS(config.nativelyRenderedContent) : config.nativelyRenderedContent,
      redoStack: config.redoStack != null ? Stack(config.redoStack.map(function (v) {
        return ContentState.fromJS(v);
      })) : config.redoStack,
      selection: config.selection != null ? new SelectionState(config.selection) : config.selection,
      treeMap: config.treeMap != null ? OrderedMap(config.treeMap).map(function (v) {
        return List(v).map(function (v) {
          return BlockTree.fromJS(v);
        });
      }) : config.treeMap,
      undoStack: config.undoStack != null ? Stack(config.undoStack.map(function (v) {
        return ContentState.fromJS(v);
      })) : config.undoStack,
      currentContent: ContentState.fromJS(config.currentContent)
    })));
  };

  EditorState.set = function set(editorState, put) {
    var map = editorState.getImmutable().withMutations(function (state) {
      var existingDecorator = state.get('decorator');
      var decorator = existingDecorator;

      if (put.decorator === null) {
        decorator = null;
      } else if (put.decorator) {
        decorator = put.decorator;
      }

      var newContent = put.currentContent || editorState.getCurrentContent();

      if (decorator !== existingDecorator) {
        var treeMap = state.get('treeMap');
        var newTreeMap;

        if (decorator && existingDecorator) {
          newTreeMap = regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator);
        } else {
          newTreeMap = generateNewTreeMap(newContent, decorator);
        }

        state.merge({
          decorator: decorator,
          treeMap: newTreeMap,
          nativelyRenderedContent: null
        });
        return;
      }

      var existingContent = editorState.getCurrentContent();

      if (newContent !== existingContent) {
        state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator));
      }

      state.merge(put);
    });
    return new EditorState(map);
  };

  var _proto = EditorState.prototype;

  _proto.toJS = function toJS() {
    return this.getImmutable().toJS();
  };

  _proto.getAllowUndo = function getAllowUndo() {
    return this.getImmutable().get('allowUndo');
  };

  _proto.getCurrentContent = function getCurrentContent() {
    return this.getImmutable().get('currentContent');
  };

  _proto.getUndoStack = function getUndoStack() {
    return this.getImmutable().get('undoStack');
  };

  _proto.getRedoStack = function getRedoStack() {
    return this.getImmutable().get('redoStack');
  };

  _proto.getSelection = function getSelection() {
    return this.getImmutable().get('selection');
  };

  _proto.getDecorator = function getDecorator() {
    return this.getImmutable().get('decorator');
  };

  _proto.isInCompositionMode = function isInCompositionMode() {
    return this.getImmutable().get('inCompositionMode');
  };

  _proto.mustForceSelection = function mustForceSelection() {
    return this.getImmutable().get('forceSelection');
  };

  _proto.getNativelyRenderedContent = function getNativelyRenderedContent() {
    return this.getImmutable().get('nativelyRenderedContent');
  };

  _proto.getLastChangeType = function getLastChangeType() {
    return this.getImmutable().get('lastChangeType');
  }
  /**
   * While editing, the user may apply inline style commands with a collapsed
   * cursor, intending to type text that adopts the specified style. In this
   * case, we track the specified style as an "override" that takes precedence
   * over the inline style of the text adjacent to the cursor.
   *
   * If null, there is no override in place.
   */
  ;

  _proto.getInlineStyleOverride = function getInlineStyleOverride() {
    return this.getImmutable().get('inlineStyleOverride');
  };

  EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
    return EditorState.set(editorState, {
      inlineStyleOverride: inlineStyleOverride
    });
  }
  /**
   * Get the appropriate inline style for the editor state. If an
   * override is in place, use it. Otherwise, the current style is
   * based on the location of the selection state.
   */
  ;

  _proto.getCurrentInlineStyle = function getCurrentInlineStyle() {
    var override = this.getInlineStyleOverride();

    if (override != null) {
      return override;
    }

    var content = this.getCurrentContent();
    var selection = this.getSelection();

    if (selection.isCollapsed()) {
      return getInlineStyleForCollapsedSelection(content, selection);
    }

    return getInlineStyleForNonCollapsedSelection(content, selection);
  };

  _proto.getBlockTree = function getBlockTree(blockKey) {
    return this.getImmutable().getIn(['treeMap', blockKey]);
  };

  _proto.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
  };

  _proto.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
    var content = this.getCurrentContent();
    var blockMap = content.getBlockMap();
    var last = blockMap.last();
    var end = last.getLength();
    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
  };

  _proto.getDirectionMap = function getDirectionMap() {
    return this.getImmutable().get('directionMap');
  }
  /**
   * Incorporate native DOM selection changes into the EditorState. This
   * method can be used when we simply want to accept whatever the DOM
   * has given us to represent selection, and we do not need to re-render
   * the editor.
   *
   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
   */
  ;

  EditorState.acceptSelection = function acceptSelection(editorState, selection) {
    return updateSelection(editorState, selection, false);
  }
  /**
   * At times, we need to force the DOM selection to be where we
   * need it to be. This can occur when the anchor or focus nodes
   * are non-text nodes, for instance. In this case, we want to trigger
   * a re-render of the editor, which in turn forces selection into
   * the correct place in the DOM. The `forceSelection` method
   * accomplishes this.
   *
   * This method should be used in cases where you need to explicitly
   * move the DOM selection from one place to another without a change
   * in ContentState.
   */
  ;

  EditorState.forceSelection = function forceSelection(editorState, selection) {
    if (!selection.getHasFocus()) {
      selection = selection.set('hasFocus', true);
    }

    return updateSelection(editorState, selection, true);
  }
  /**
   * Move selection to the end of the editor without forcing focus.
   */
  ;

  EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
    var content = editorState.getCurrentContent();
    var lastBlock = content.getLastBlock();
    var lastKey = lastBlock.getKey();
    var length = lastBlock.getLength();
    return EditorState.acceptSelection(editorState, new SelectionState({
      anchorKey: lastKey,
      anchorOffset: length,
      focusKey: lastKey,
      focusOffset: length,
      isBackward: false
    }));
  }
  /**
   * Force focus to the end of the editor. This is useful in scenarios
   * where we want to programmatically focus the input and it makes sense
   * to allow the user to continue working seamlessly.
   */
  ;

  EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
    var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
    return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
  }
  /**
   * Push the current ContentState onto the undo stack if it should be
   * considered a boundary state, and set the provided ContentState as the
   * new current content.
   */
  ;

  EditorState.push = function push(editorState, contentState, changeType) {
    var forceSelection = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    if (editorState.getCurrentContent() === contentState) {
      return editorState;
    }

    var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());

    if (!editorState.getAllowUndo()) {
      return EditorState.set(editorState, {
        currentContent: contentState,
        directionMap: directionMap,
        lastChangeType: changeType,
        selection: contentState.getSelectionAfter(),
        forceSelection: forceSelection,
        inlineStyleOverride: null
      });
    }

    var selection = editorState.getSelection();
    var currentContent = editorState.getCurrentContent();
    var undoStack = editorState.getUndoStack();
    var newContent = contentState;

    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
      undoStack = undoStack.push(currentContent);
      newContent = newContent.set('selectionBefore', selection);
    } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
      // Preserve the previous selection.
      newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
    }

    var inlineStyleOverride = editorState.getInlineStyleOverride(); // Don't discard inline style overrides for the following change types:

    var overrideChangeTypes = ['adjust-depth', 'change-block-type', 'split-block'];

    if (overrideChangeTypes.indexOf(changeType) === -1) {
      inlineStyleOverride = null;
    }

    var editorStateChanges = {
      currentContent: newContent,
      directionMap: directionMap,
      undoStack: undoStack,
      redoStack: Stack(),
      lastChangeType: changeType,
      selection: contentState.getSelectionAfter(),
      forceSelection: forceSelection,
      inlineStyleOverride: inlineStyleOverride
    };
    return EditorState.set(editorState, editorStateChanges);
  }
  /**
   * Make the top ContentState in the undo stack the new current content and
   * push the current content onto the redo stack.
   */
  ;

  EditorState.undo = function undo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var undoStack = editorState.getUndoStack();
    var newCurrentContent = undoStack.peek();

    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: undoStack.shift(),
      redoStack: editorState.getRedoStack().push(currentContent),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'undo',
      nativelyRenderedContent: null,
      selection: currentContent.getSelectionBefore()
    });
  }
  /**
   * Make the top ContentState in the redo stack the new current content and
   * push the current content onto the undo stack.
   */
  ;

  EditorState.redo = function redo(editorState) {
    if (!editorState.getAllowUndo()) {
      return editorState;
    }

    var redoStack = editorState.getRedoStack();
    var newCurrentContent = redoStack.peek();

    if (!newCurrentContent) {
      return editorState;
    }

    var currentContent = editorState.getCurrentContent();
    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
    return EditorState.set(editorState, {
      currentContent: newCurrentContent,
      directionMap: directionMap,
      undoStack: editorState.getUndoStack().push(currentContent),
      redoStack: redoStack.shift(),
      forceSelection: true,
      inlineStyleOverride: null,
      lastChangeType: 'redo',
      nativelyRenderedContent: null,
      selection: newCurrentContent.getSelectionAfter()
    });
  }
  /**
   * Not for public consumption.
   */
  ;

  function EditorState(immutable) {
    _defineProperty(this, "_immutable", void 0);

    this._immutable = immutable;
  }
  /**
   * Not for public consumption.
   */


  _proto.getImmutable = function getImmutable() {
    return this._immutable;
  };

  return EditorState;
}();
/**
 * Set the supplied SelectionState as the new current selection, and set
 * the `force` flag to trigger manual selection placement by the view.
 */


function updateSelection(editorState, selection, forceSelection) {
  return EditorState.set(editorState, {
    selection: selection,
    forceSelection: forceSelection,
    nativelyRenderedContent: null,
    inlineStyleOverride: null
  });
}
/**
 * Regenerate the entire tree map for a given ContentState and decorator.
 * Returns an OrderedMap that maps all available ContentBlock objects.
 */


function generateNewTreeMap(contentState, decorator) {
  return contentState.getBlockMap().map(function (block) {
    return BlockTree.generate(contentState, block, decorator);
  }).toOrderedMap();
}
/**
 * Regenerate tree map objects for all ContentBlocks that have changed
 * between the current editorState and newContent. Returns an OrderedMap
 * with only changed regenerated tree map objects.
 */


function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
  var contentState = editorState.getCurrentContent().set('entityMap', newEntityMap);
  var prevBlockMap = contentState.getBlockMap();
  var prevTreeMap = editorState.getImmutable().get('treeMap');
  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
    return block !== prevBlockMap.get(key);
  }).map(function (block) {
    return BlockTree.generate(contentState, block, decorator);
  }));
}
/**
 * Generate tree map objects for a new decorator object, preserving any
 * decorations that are unchanged from the previous decorator.
 *
 * Note that in order for this to perform optimally, decoration Lists for
 * decorators should be preserved when possible to allow for direct immutable
 * List comparison.
 */


function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
    return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
  }).map(function (block) {
    return BlockTree.generate(content, block, decorator);
  }));
}
/**
 * Return whether a change should be considered a boundary state, given
 * the previous change type. Allows us to discard potential boundary states
 * during standard typing or deletion behavior.
 */


function mustBecomeBoundary(editorState, changeType) {
  var lastChangeType = editorState.getLastChangeType();
  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
}

function getInlineStyleForCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey); // If the cursor is not at the start of the block, look backward to
  // preserve the style of the preceding character.

  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  } // The caret is at position zero in this block. If the block has any
  // text at all, use the style of the first character.


  if (startBlock.getLength()) {
    return startBlock.getInlineStyleAt(0);
  } // Otherwise, look upward in the document to find the closest character.


  return lookUpwardForInlineStyle(content, startKey);
}

function getInlineStyleForNonCollapsedSelection(content, selection) {
  var startKey = selection.getStartKey();
  var startOffset = selection.getStartOffset();
  var startBlock = content.getBlockForKey(startKey); // If there is a character just inside the selection, use its style.

  if (startOffset < startBlock.getLength()) {
    return startBlock.getInlineStyleAt(startOffset);
  } // Check if the selection at the end of a non-empty block. Use the last
  // style in the block.


  if (startOffset > 0) {
    return startBlock.getInlineStyleAt(startOffset - 1);
  } // Otherwise, look upward in the document to find the closest character.


  return lookUpwardForInlineStyle(content, startKey);
}

function lookUpwardForInlineStyle(content, fromKey) {
  var lastNonEmpty = content.getBlockMap().reverse().skipUntil(function (_, k) {
    return k === fromKey;
  }).skip(1).skipUntil(function (block, _) {
    return block.getLength();
  }).first();

  if (lastNonEmpty) {
    return lastNonEmpty.getInlineStyleAt(lastNonEmpty.getLength() - 1);
  }

  return OrderedSet();
}

module.exports = EditorState;

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleError = handleError;
exports.userErrorIdentity = userErrorIdentity;

var _flash = __webpack_require__(5);

function handleError(err, nextAction) {
  return function (dispatch) {
    var message = 'An error occurred';
    if (err.res && !err.res.ok) {
      var contentType = err.res.headers.get('Content-Type');
      if (contentType.includes('text/plain')) {
        return err.res.text().then(function (text) {
          var notify = true;
          if (err.res.status === 400 || err.res.status === 401 || err.res.status === 403 || err.res.status === 412) {
            notify = false;
            message = text;
          }
          dispatch(nextAction());
          err.message = message.trim();
          if (notify) {
            Bugsnag.notifyException(err);
          }
          return Promise.reject(err);
        });
      }
      dispatch(nextAction());
      err.message = message;
      Bugsnag.notifyException(err);
      return Promise.reject(err);
    }
    var isAwsErr = err.message.match(/No current user/i);
    if (!isAwsErr) {
      dispatch((0, _flash.flashErrorMessage)({ message: message }));
    }
    dispatch(nextAction());
    err.message = message;
    if (!isAwsErr) {
      Bugsnag.notifyException(err);
    }
    return Promise.reject(err);
  };
} /* eslint no-param-reassign: 0 */

function userErrorIdentity(payload) {
  Bugsnag.user = {
    id: payload.id,
    email: payload.email,
    name: payload.name
  };
}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getConstantsLabel = undefined;
exports.translateModels = translateModels;

var _translation = __webpack_require__(4);

var _valueToText = __webpack_require__(98);

var _valueToText2 = _interopRequireDefault(_valueToText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */
function translateModels(t, key, modelName, defaultValue) {
  var option = {
    ns: _translation.TRANSLATION_FILES.models[modelName]
  };
  if (defaultValue) {
    option.defaultValue = defaultValue;
  }
  return t(key, option);
}

var getConstantsLabel = exports.getConstantsLabel = function getConstantsLabel(t, options, value) {
  if (Array.isArray(value)) {
    var newValue = [];
    value.forEach(function (v) {
      return newValue.push(t((0, _valueToText2.default)(options, v), { ns: _translation.TRANSLATION_FILES.constants }));
    });
    return newValue.join(', ');
  }
  if (value) {
    return t((0, _valueToText2.default)(options, value), { ns: _translation.TRANSLATION_FILES.constants });
  }
  return value;
};

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "baggageUtils", function() { return baggageUtils; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "internal", function() { return internal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baggage_propagation_W3CBaggagePropagator__ = __webpack_require__(1919);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W3CBaggagePropagator", function() { return __WEBPACK_IMPORTED_MODULE_0__baggage_propagation_W3CBaggagePropagator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_anchored_clock__ = __webpack_require__(1920);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AnchoredClock", function() { return __WEBPACK_IMPORTED_MODULE_1__common_anchored_clock__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_attributes__ = __webpack_require__(1921);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isAttributeKey", function() { return __WEBPACK_IMPORTED_MODULE_2__common_attributes__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isAttributeValue", function() { return __WEBPACK_IMPORTED_MODULE_2__common_attributes__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sanitizeAttributes", function() { return __WEBPACK_IMPORTED_MODULE_2__common_attributes__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_global_error_handler__ = __webpack_require__(912);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "globalErrorHandler", function() { return __WEBPACK_IMPORTED_MODULE_3__common_global_error_handler__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setGlobalErrorHandler", function() { return __WEBPACK_IMPORTED_MODULE_3__common_global_error_handler__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_logging_error_handler__ = __webpack_require__(914);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "loggingErrorHandler", function() { return __WEBPACK_IMPORTED_MODULE_4__common_logging_error_handler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_time__ = __webpack_require__(1922);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addHrTimes", function() { return __WEBPACK_IMPORTED_MODULE_5__common_time__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getTimeOrigin", function() { return __WEBPACK_IMPORTED_MODULE_5__common_time__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hrTime", function() { return __WEBPACK_IMPORTED_MODULE_5__common_time__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hrTimeDuration", function() { return __WEBPACK_IMPORTED_MODULE_5__common_time__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hrTimeToMicroseconds", function() { return __WEBPACK_IMPORTED_MODULE_5__common_time__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hrTimeToMilliseconds", function() { return __WEBPACK_IMPORTED_MODULE_5__common_time__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hrTimeToNanoseconds", function() { return __WEBPACK_IMPORTED_MODULE_5__common_time__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hrTimeToTimeStamp", function() { return __WEBPACK_IMPORTED_MODULE_5__common_time__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isTimeInput", function() { return __WEBPACK_IMPORTED_MODULE_5__common_time__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isTimeInputHrTime", function() { return __WEBPACK_IMPORTED_MODULE_5__common_time__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "millisToHrTime", function() { return __WEBPACK_IMPORTED_MODULE_5__common_time__["k"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "timeInputToHrTime", function() { return __WEBPACK_IMPORTED_MODULE_5__common_time__["l"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_hex_to_binary__ = __webpack_require__(913);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hexToBinary", function() { return __WEBPACK_IMPORTED_MODULE_6__common_hex_to_binary__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ExportResult__ = __webpack_require__(1918);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ExportResultCode", function() { return __WEBPACK_IMPORTED_MODULE_7__ExportResult__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__baggage_utils__ = __webpack_require__(911);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__platform__ = __webpack_require__(916);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RandomIdGenerator", function() { return __WEBPACK_IMPORTED_MODULE_9__platform__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SDK_INFO", function() { return __WEBPACK_IMPORTED_MODULE_9__platform__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "_globalThis", function() { return __WEBPACK_IMPORTED_MODULE_9__platform__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getEnv", function() { return __WEBPACK_IMPORTED_MODULE_9__platform__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getEnvWithoutDefaults", function() { return __WEBPACK_IMPORTED_MODULE_9__platform__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hexToBase64", function() { return __WEBPACK_IMPORTED_MODULE_9__platform__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "otperformance", function() { return __WEBPACK_IMPORTED_MODULE_9__platform__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unrefTimer", function() { return __WEBPACK_IMPORTED_MODULE_9__platform__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__propagation_composite__ = __webpack_require__(1931);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CompositePropagator", function() { return __WEBPACK_IMPORTED_MODULE_10__propagation_composite__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__trace_W3CTraceContextPropagator__ = __webpack_require__(1932);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TRACE_PARENT_HEADER", function() { return __WEBPACK_IMPORTED_MODULE_11__trace_W3CTraceContextPropagator__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TRACE_STATE_HEADER", function() { return __WEBPACK_IMPORTED_MODULE_11__trace_W3CTraceContextPropagator__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W3CTraceContextPropagator", function() { return __WEBPACK_IMPORTED_MODULE_11__trace_W3CTraceContextPropagator__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parseTraceParent", function() { return __WEBPACK_IMPORTED_MODULE_11__trace_W3CTraceContextPropagator__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__trace_rpc_metadata__ = __webpack_require__(1933);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RPCType", function() { return __WEBPACK_IMPORTED_MODULE_12__trace_rpc_metadata__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "deleteRPCMetadata", function() { return __WEBPACK_IMPORTED_MODULE_12__trace_rpc_metadata__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getRPCMetadata", function() { return __WEBPACK_IMPORTED_MODULE_12__trace_rpc_metadata__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "setRPCMetadata", function() { return __WEBPACK_IMPORTED_MODULE_12__trace_rpc_metadata__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__trace_sampler_AlwaysOffSampler__ = __webpack_require__(918);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AlwaysOffSampler", function() { return __WEBPACK_IMPORTED_MODULE_13__trace_sampler_AlwaysOffSampler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__trace_sampler_AlwaysOnSampler__ = __webpack_require__(919);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AlwaysOnSampler", function() { return __WEBPACK_IMPORTED_MODULE_14__trace_sampler_AlwaysOnSampler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__trace_sampler_ParentBasedSampler__ = __webpack_require__(1934);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ParentBasedSampler", function() { return __WEBPACK_IMPORTED_MODULE_15__trace_sampler_ParentBasedSampler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__trace_sampler_TraceIdRatioBasedSampler__ = __webpack_require__(1935);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TraceIdRatioBasedSampler", function() { return __WEBPACK_IMPORTED_MODULE_16__trace_sampler_TraceIdRatioBasedSampler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__trace_suppress_tracing__ = __webpack_require__(373);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isTracingSuppressed", function() { return __WEBPACK_IMPORTED_MODULE_17__trace_suppress_tracing__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "suppressTracing", function() { return __WEBPACK_IMPORTED_MODULE_17__trace_suppress_tracing__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "unsuppressTracing", function() { return __WEBPACK_IMPORTED_MODULE_17__trace_suppress_tracing__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__trace_TraceState__ = __webpack_require__(917);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TraceState", function() { return __WEBPACK_IMPORTED_MODULE_18__trace_TraceState__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_environment__ = __webpack_require__(920);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_ATTRIBUTE_COUNT_LIMIT", function() { return __WEBPACK_IMPORTED_MODULE_19__utils_environment__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT", function() { return __WEBPACK_IMPORTED_MODULE_19__utils_environment__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_ENVIRONMENT", function() { return __WEBPACK_IMPORTED_MODULE_19__utils_environment__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT", function() { return __WEBPACK_IMPORTED_MODULE_19__utils_environment__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "DEFAULT_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT", function() { return __WEBPACK_IMPORTED_MODULE_19__utils_environment__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parseEnvironment", function() { return __WEBPACK_IMPORTED_MODULE_19__utils_environment__["f"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_merge__ = __webpack_require__(1938);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "merge", function() { return __WEBPACK_IMPORTED_MODULE_20__utils_merge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_sampling__ = __webpack_require__(921);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TracesSamplerValues", function() { return __WEBPACK_IMPORTED_MODULE_21__utils_sampling__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_timeout__ = __webpack_require__(1940);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TimeoutError", function() { return __WEBPACK_IMPORTED_MODULE_22__utils_timeout__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "callWithTimeout", function() { return __WEBPACK_IMPORTED_MODULE_22__utils_timeout__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_url__ = __webpack_require__(1941);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isUrlIgnored", function() { return __WEBPACK_IMPORTED_MODULE_23__utils_url__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "urlMatches", function() { return __WEBPACK_IMPORTED_MODULE_23__utils_url__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_wrap__ = __webpack_require__(1942);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isWrapped", function() { return __WEBPACK_IMPORTED_MODULE_24__utils_wrap__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__utils_callback__ = __webpack_require__(1936);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BindOnceFuture", function() { return __WEBPACK_IMPORTED_MODULE_25__utils_callback__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__version__ = __webpack_require__(922);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "VERSION", function() { return __WEBPACK_IMPORTED_MODULE_26__version__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__internal_exporter__ = __webpack_require__(1923);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */









var baggageUtils = {
    getKeyPairs: __WEBPACK_IMPORTED_MODULE_8__baggage_utils__["a" /* getKeyPairs */],
    serializeKeyPairs: __WEBPACK_IMPORTED_MODULE_8__baggage_utils__["b" /* serializeKeyPairs */],
    parseKeyPairsIntoRecord: __WEBPACK_IMPORTED_MODULE_8__baggage_utils__["c" /* parseKeyPairsIntoRecord */],
    parsePairKeyValue: __WEBPACK_IMPORTED_MODULE_8__baggage_utils__["d" /* parsePairKeyValue */],
};



















var internal = {
    _export: __WEBPACK_IMPORTED_MODULE_27__internal_exporter__["a" /* _export */],
};
//# sourceMappingURL=index.js.map

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.promptMessage = promptMessage;
exports.promptChangesMessage = promptChangesMessage;
exports.promptChangesLeave = promptChangesLeave;
exports.resetPromptMessage = resetPromptMessage;

var _reactRouterRedux = __webpack_require__(13);

var _actions = __webpack_require__(25);

function promptMessage(_ref) {
  var header = _ref.header,
      message = _ref.message,
      callback = _ref.callback,
      icon = _ref.icon,
      samePage = _ref.samePage;

  return {
    type: _actions.PROMPT_MESSAGE,
    payload: {
      header: header,
      message: message,
      callback: callback,
      icon: icon,
      samePage: samePage,
      show: true
    }
  };
}

function promptChangesMessage(_ref2) {
  var header = _ref2.header,
      message = _ref2.message,
      samePage = _ref2.samePage,
      callback = _ref2.callback;

  return function (dispatch) {
    dispatch(promptMessage({ header: header || 'Unsaved changes', message: message, callback: callback, icon: 'warning sign', samePage: samePage }));
  };
}

function promptChangesLeave(nextLocation) {
  return function (dispatch) {
    switch (nextLocation.action) {
      case 'POP':
        dispatch((0, _reactRouterRedux.goBack)());
        break;
      case 'REPLACE':
        dispatch((0, _reactRouterRedux.replace)(nextLocation));
        break;
      default:
        dispatch((0, _reactRouterRedux.push)(nextLocation));
    }
  };
}

function resetPromptMessage() {
  return {
    type: _actions.PROMPT_MESSAGE_RESET
  };
}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(421)('wks');
var uid = __webpack_require__(238);
var Symbol = __webpack_require__(52).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Kind = void 0;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',
  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',
  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',
  // Values
  VARIABLE: 'Variable',
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',
  // Directives
  DIRECTIVE: 'Directive',
  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',
  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
  // Type System Extensions
  SCHEMA_EXTENSION: 'SchemaExtension',
  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */

exports.Kind = Kind;

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Auth__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types_Auth__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_AuthErrorStrings__ = __webpack_require__(773);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Auth", function() { return __WEBPACK_IMPORTED_MODULE_0__Auth__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CognitoUser", function() { return __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CookieStorage", function() { return __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CognitoHostedUIIdentityProvider", function() { return __WEBPACK_IMPORTED_MODULE_1__types_Auth__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "appendToCognitoUserAgent", function() { return __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AuthErrorStrings", function() { return __WEBPACK_IMPORTED_MODULE_3__common_AuthErrorStrings__["a"]; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */




/**
 * @deprecated use named import
 */
/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Auth__["a" /* Auth */]);

//# sourceMappingURL=index.js.map

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Constants", function() { return Constants; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Amplify__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Platform__ = __webpack_require__(365);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AmplifyClass", function() { return __WEBPACK_IMPORTED_MODULE_0__Amplify__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientDevice__ = __webpack_require__(1618);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClientDevice", function() { return __WEBPACK_IMPORTED_MODULE_2__ClientDevice__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Logger__ = __webpack_require__(111);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ConsoleLogger", function() { return __WEBPACK_IMPORTED_MODULE_3__Logger__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() { return __WEBPACK_IMPORTED_MODULE_3__Logger__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Errors__ = __webpack_require__(1620);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "missingConfig", function() { return __WEBPACK_IMPORTED_MODULE_4__Errors__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "invalidParameter", function() { return __WEBPACK_IMPORTED_MODULE_4__Errors__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Hub__ = __webpack_require__(1621);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Hub", function() { return __WEBPACK_IMPORTED_MODULE_5__Hub__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__I18n__ = __webpack_require__(1623);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I18n", function() { return __WEBPACK_IMPORTED_MODULE_6__I18n__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__JS__ = __webpack_require__(213);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return __WEBPACK_IMPORTED_MODULE_7__JS__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "sortByField", function() { return __WEBPACK_IMPORTED_MODULE_7__JS__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "objectLessAttributes", function() { return __WEBPACK_IMPORTED_MODULE_7__JS__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "filenameToContentType", function() { return __WEBPACK_IMPORTED_MODULE_7__JS__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isTextFile", function() { return __WEBPACK_IMPORTED_MODULE_7__JS__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "generateRandomString", function() { return __WEBPACK_IMPORTED_MODULE_7__JS__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "makeQuerablePromise", function() { return __WEBPACK_IMPORTED_MODULE_7__JS__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isWebWorker", function() { return __WEBPACK_IMPORTED_MODULE_7__JS__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "browserOrNode", function() { return __WEBPACK_IMPORTED_MODULE_7__JS__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "transferKeyToLowerCase", function() { return __WEBPACK_IMPORTED_MODULE_7__JS__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "transferKeyToUpperCase", function() { return __WEBPACK_IMPORTED_MODULE_7__JS__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isStrictObject", function() { return __WEBPACK_IMPORTED_MODULE_7__JS__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "JS", function() { return __WEBPACK_IMPORTED_MODULE_7__JS__["m"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Signer__ = __webpack_require__(1632);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Signer", function() { return __WEBPACK_IMPORTED_MODULE_8__Signer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Parser__ = __webpack_require__(777);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "parseMobileHubConfig", function() { return __WEBPACK_IMPORTED_MODULE_9__Parser__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Parser", function() { return __WEBPACK_IMPORTED_MODULE_9__Parser__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Providers__ = __webpack_require__(1628);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AWSCloudWatchProvider", function() { return __WEBPACK_IMPORTED_MODULE_10__Providers__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__OAuthHelper__ = __webpack_require__(776);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "FacebookOAuth", function() { return __WEBPACK_IMPORTED_MODULE_11__OAuthHelper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GoogleOAuth", function() { return __WEBPACK_IMPORTED_MODULE_11__OAuthHelper__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RNComponents__ = __webpack_require__(1629);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Linking", function() { return __WEBPACK_IMPORTED_MODULE_12__RNComponents__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AppState", function() { return __WEBPACK_IMPORTED_MODULE_12__RNComponents__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AsyncStorage", function() { return __WEBPACK_IMPORTED_MODULE_12__RNComponents__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Credentials__ = __webpack_require__(1619);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Credentials", function() { return __WEBPACK_IMPORTED_MODULE_13__Credentials__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CredentialsClass", function() { return __WEBPACK_IMPORTED_MODULE_13__Credentials__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ServiceWorker__ = __webpack_require__(1631);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ServiceWorker", function() { return __WEBPACK_IMPORTED_MODULE_14__ServiceWorker__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__StorageHelper__ = __webpack_require__(510);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StorageHelper", function() { return __WEBPACK_IMPORTED_MODULE_15__StorageHelper__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MemoryStorage", function() { return __WEBPACK_IMPORTED_MODULE_15__StorageHelper__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__UniversalStorage__ = __webpack_require__(1633);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "UniversalStorage", function() { return __WEBPACK_IMPORTED_MODULE_16__UniversalStorage__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Platform", function() { return __WEBPACK_IMPORTED_MODULE_1__Platform__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getAmplifyUserAgent", function() { return __WEBPACK_IMPORTED_MODULE_1__Platform__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__constants__ = __webpack_require__(778);
/* inactive harmony reexport namespace */
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Util__ = __webpack_require__(301);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Mutex", function() { return __WEBPACK_IMPORTED_MODULE_18__Util__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "Reachability", function() { return __WEBPACK_IMPORTED_MODULE_18__Util__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "NonRetryableError", function() { return __WEBPACK_IMPORTED_MODULE_18__Util__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "retry", function() { return __WEBPACK_IMPORTED_MODULE_18__Util__["d"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "jitteredExponentialRetry", function() { return __WEBPACK_IMPORTED_MODULE_18__Util__["e"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "DateUtils", function() { return __WEBPACK_IMPORTED_MODULE_18__Util__["f"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "urlSafeEncode", function() { return __WEBPACK_IMPORTED_MODULE_18__Util__["g"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "urlSafeDecode", function() { return __WEBPACK_IMPORTED_MODULE_18__Util__["h"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AWS_CLOUDWATCH_BASE_BUFFER_SIZE", function() { return __WEBPACK_IMPORTED_MODULE_18__Util__["i"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AWS_CLOUDWATCH_CATEGORY", function() { return __WEBPACK_IMPORTED_MODULE_18__Util__["j"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE", function() { return __WEBPACK_IMPORTED_MODULE_18__Util__["k"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AWS_CLOUDWATCH_MAX_EVENT_SIZE", function() { return __WEBPACK_IMPORTED_MODULE_18__Util__["l"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "AWS_CLOUDWATCH_PROVIDER_NAME", function() { return __WEBPACK_IMPORTED_MODULE_18__Util__["m"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "NO_CREDS_ERROR_STRING", function() { return __WEBPACK_IMPORTED_MODULE_18__Util__["n"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "RETRY_ERROR_CODES", function() { return __WEBPACK_IMPORTED_MODULE_18__Util__["o"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Amplify", function() { return __WEBPACK_IMPORTED_MODULE_0__Amplify__["b"]; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */




















var Constants = {
    userAgent: __WEBPACK_IMPORTED_MODULE_1__Platform__["a" /* Platform */].userAgent,
};



/**
 * @deprecated use named import
 */
/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__Amplify__["b" /* Amplify */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AmbiguousRoleResolutionType */
/* unused harmony export CognitoIdentityProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return CreateIdentityPoolInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IdentityPool; });
/* unused harmony export InternalErrorException */
/* unused harmony export InvalidParameterException */
/* unused harmony export LimitExceededException */
/* unused harmony export NotAuthorizedException */
/* unused harmony export ResourceConflictException */
/* unused harmony export TooManyRequestsException */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return DeleteIdentitiesInput; });
/* unused harmony export ErrorCode */
/* unused harmony export UnprocessedIdentityId */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return DeleteIdentitiesResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return DeleteIdentityPoolInput; });
/* unused harmony export ResourceNotFoundException */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return DescribeIdentityInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return IdentityDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return DescribeIdentityPoolInput; });
/* unused harmony export ExternalServiceException */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return GetCredentialsForIdentityInput; });
/* unused harmony export Credentials */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return GetCredentialsForIdentityResponse; });
/* unused harmony export InvalidIdentityPoolConfigurationException */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return GetIdInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return GetIdResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return GetIdentityPoolRolesInput; });
/* unused harmony export MappingRuleMatchType */
/* unused harmony export MappingRule */
/* unused harmony export RulesConfigurationType */
/* unused harmony export RoleMappingType */
/* unused harmony export RoleMapping */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return GetIdentityPoolRolesResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return GetOpenIdTokenInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return GetOpenIdTokenResponse; });
/* unused harmony export DeveloperUserAlreadyRegisteredException */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return GetOpenIdTokenForDeveloperIdentityInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return GetOpenIdTokenForDeveloperIdentityResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return ListIdentitiesInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return ListIdentitiesResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return ListIdentityPoolsInput; });
/* unused harmony export IdentityPoolShortDescription */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return ListIdentityPoolsResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return ListTagsForResourceInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ListTagsForResourceResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return LookupDeveloperIdentityInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return LookupDeveloperIdentityResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return MergeDeveloperIdentitiesInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return MergeDeveloperIdentitiesResponse; });
/* unused harmony export ConcurrentModificationException */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SetIdentityPoolRolesInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return TagResourceInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TagResourceResponse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return UnlinkDeveloperIdentityInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UnlinkIdentityInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return UntagResourceInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return UntagResourceResponse; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);

var AmbiguousRoleResolutionType;
(function (AmbiguousRoleResolutionType) {
    AmbiguousRoleResolutionType["AUTHENTICATED_ROLE"] = "AuthenticatedRole";
    AmbiguousRoleResolutionType["DENY"] = "Deny";
})(AmbiguousRoleResolutionType || (AmbiguousRoleResolutionType = {}));
var CognitoIdentityProvider;
(function (CognitoIdentityProvider) {
    CognitoIdentityProvider.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(CognitoIdentityProvider || (CognitoIdentityProvider = {}));
var CreateIdentityPoolInput;
(function (CreateIdentityPoolInput) {
    CreateIdentityPoolInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(CreateIdentityPoolInput || (CreateIdentityPoolInput = {}));
var IdentityPool;
(function (IdentityPool) {
    IdentityPool.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(IdentityPool || (IdentityPool = {}));
var InternalErrorException;
(function (InternalErrorException) {
    InternalErrorException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(InternalErrorException || (InternalErrorException = {}));
var InvalidParameterException;
(function (InvalidParameterException) {
    InvalidParameterException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(InvalidParameterException || (InvalidParameterException = {}));
var LimitExceededException;
(function (LimitExceededException) {
    LimitExceededException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(LimitExceededException || (LimitExceededException = {}));
var NotAuthorizedException;
(function (NotAuthorizedException) {
    NotAuthorizedException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(NotAuthorizedException || (NotAuthorizedException = {}));
var ResourceConflictException;
(function (ResourceConflictException) {
    ResourceConflictException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ResourceConflictException || (ResourceConflictException = {}));
var TooManyRequestsException;
(function (TooManyRequestsException) {
    TooManyRequestsException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(TooManyRequestsException || (TooManyRequestsException = {}));
var DeleteIdentitiesInput;
(function (DeleteIdentitiesInput) {
    DeleteIdentitiesInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DeleteIdentitiesInput || (DeleteIdentitiesInput = {}));
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["ACCESS_DENIED"] = "AccessDenied";
    ErrorCode["INTERNAL_SERVER_ERROR"] = "InternalServerError";
})(ErrorCode || (ErrorCode = {}));
var UnprocessedIdentityId;
(function (UnprocessedIdentityId) {
    UnprocessedIdentityId.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(UnprocessedIdentityId || (UnprocessedIdentityId = {}));
var DeleteIdentitiesResponse;
(function (DeleteIdentitiesResponse) {
    DeleteIdentitiesResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DeleteIdentitiesResponse || (DeleteIdentitiesResponse = {}));
var DeleteIdentityPoolInput;
(function (DeleteIdentityPoolInput) {
    DeleteIdentityPoolInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DeleteIdentityPoolInput || (DeleteIdentityPoolInput = {}));
var ResourceNotFoundException;
(function (ResourceNotFoundException) {
    ResourceNotFoundException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ResourceNotFoundException || (ResourceNotFoundException = {}));
var DescribeIdentityInput;
(function (DescribeIdentityInput) {
    DescribeIdentityInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeIdentityInput || (DescribeIdentityInput = {}));
var IdentityDescription;
(function (IdentityDescription) {
    IdentityDescription.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(IdentityDescription || (IdentityDescription = {}));
var DescribeIdentityPoolInput;
(function (DescribeIdentityPoolInput) {
    DescribeIdentityPoolInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DescribeIdentityPoolInput || (DescribeIdentityPoolInput = {}));
var ExternalServiceException;
(function (ExternalServiceException) {
    ExternalServiceException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ExternalServiceException || (ExternalServiceException = {}));
var GetCredentialsForIdentityInput;
(function (GetCredentialsForIdentityInput) {
    GetCredentialsForIdentityInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(GetCredentialsForIdentityInput || (GetCredentialsForIdentityInput = {}));
var Credentials;
(function (Credentials) {
    Credentials.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(Credentials || (Credentials = {}));
var GetCredentialsForIdentityResponse;
(function (GetCredentialsForIdentityResponse) {
    GetCredentialsForIdentityResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(GetCredentialsForIdentityResponse || (GetCredentialsForIdentityResponse = {}));
var InvalidIdentityPoolConfigurationException;
(function (InvalidIdentityPoolConfigurationException) {
    InvalidIdentityPoolConfigurationException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(InvalidIdentityPoolConfigurationException || (InvalidIdentityPoolConfigurationException = {}));
var GetIdInput;
(function (GetIdInput) {
    GetIdInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(GetIdInput || (GetIdInput = {}));
var GetIdResponse;
(function (GetIdResponse) {
    GetIdResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(GetIdResponse || (GetIdResponse = {}));
var GetIdentityPoolRolesInput;
(function (GetIdentityPoolRolesInput) {
    GetIdentityPoolRolesInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(GetIdentityPoolRolesInput || (GetIdentityPoolRolesInput = {}));
var MappingRuleMatchType;
(function (MappingRuleMatchType) {
    MappingRuleMatchType["CONTAINS"] = "Contains";
    MappingRuleMatchType["EQUALS"] = "Equals";
    MappingRuleMatchType["NOT_EQUAL"] = "NotEqual";
    MappingRuleMatchType["STARTS_WITH"] = "StartsWith";
})(MappingRuleMatchType || (MappingRuleMatchType = {}));
var MappingRule;
(function (MappingRule) {
    MappingRule.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(MappingRule || (MappingRule = {}));
var RulesConfigurationType;
(function (RulesConfigurationType) {
    RulesConfigurationType.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(RulesConfigurationType || (RulesConfigurationType = {}));
var RoleMappingType;
(function (RoleMappingType) {
    RoleMappingType["RULES"] = "Rules";
    RoleMappingType["TOKEN"] = "Token";
})(RoleMappingType || (RoleMappingType = {}));
var RoleMapping;
(function (RoleMapping) {
    RoleMapping.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(RoleMapping || (RoleMapping = {}));
var GetIdentityPoolRolesResponse;
(function (GetIdentityPoolRolesResponse) {
    GetIdentityPoolRolesResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(GetIdentityPoolRolesResponse || (GetIdentityPoolRolesResponse = {}));
var GetOpenIdTokenInput;
(function (GetOpenIdTokenInput) {
    GetOpenIdTokenInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(GetOpenIdTokenInput || (GetOpenIdTokenInput = {}));
var GetOpenIdTokenResponse;
(function (GetOpenIdTokenResponse) {
    GetOpenIdTokenResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(GetOpenIdTokenResponse || (GetOpenIdTokenResponse = {}));
var DeveloperUserAlreadyRegisteredException;
(function (DeveloperUserAlreadyRegisteredException) {
    DeveloperUserAlreadyRegisteredException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(DeveloperUserAlreadyRegisteredException || (DeveloperUserAlreadyRegisteredException = {}));
var GetOpenIdTokenForDeveloperIdentityInput;
(function (GetOpenIdTokenForDeveloperIdentityInput) {
    GetOpenIdTokenForDeveloperIdentityInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(GetOpenIdTokenForDeveloperIdentityInput || (GetOpenIdTokenForDeveloperIdentityInput = {}));
var GetOpenIdTokenForDeveloperIdentityResponse;
(function (GetOpenIdTokenForDeveloperIdentityResponse) {
    GetOpenIdTokenForDeveloperIdentityResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(GetOpenIdTokenForDeveloperIdentityResponse || (GetOpenIdTokenForDeveloperIdentityResponse = {}));
var ListIdentitiesInput;
(function (ListIdentitiesInput) {
    ListIdentitiesInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ListIdentitiesInput || (ListIdentitiesInput = {}));
var ListIdentitiesResponse;
(function (ListIdentitiesResponse) {
    ListIdentitiesResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ListIdentitiesResponse || (ListIdentitiesResponse = {}));
var ListIdentityPoolsInput;
(function (ListIdentityPoolsInput) {
    ListIdentityPoolsInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ListIdentityPoolsInput || (ListIdentityPoolsInput = {}));
var IdentityPoolShortDescription;
(function (IdentityPoolShortDescription) {
    IdentityPoolShortDescription.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(IdentityPoolShortDescription || (IdentityPoolShortDescription = {}));
var ListIdentityPoolsResponse;
(function (ListIdentityPoolsResponse) {
    ListIdentityPoolsResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ListIdentityPoolsResponse || (ListIdentityPoolsResponse = {}));
var ListTagsForResourceInput;
(function (ListTagsForResourceInput) {
    ListTagsForResourceInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ListTagsForResourceInput || (ListTagsForResourceInput = {}));
var ListTagsForResourceResponse;
(function (ListTagsForResourceResponse) {
    ListTagsForResourceResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ListTagsForResourceResponse || (ListTagsForResourceResponse = {}));
var LookupDeveloperIdentityInput;
(function (LookupDeveloperIdentityInput) {
    LookupDeveloperIdentityInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(LookupDeveloperIdentityInput || (LookupDeveloperIdentityInput = {}));
var LookupDeveloperIdentityResponse;
(function (LookupDeveloperIdentityResponse) {
    LookupDeveloperIdentityResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(LookupDeveloperIdentityResponse || (LookupDeveloperIdentityResponse = {}));
var MergeDeveloperIdentitiesInput;
(function (MergeDeveloperIdentitiesInput) {
    MergeDeveloperIdentitiesInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(MergeDeveloperIdentitiesInput || (MergeDeveloperIdentitiesInput = {}));
var MergeDeveloperIdentitiesResponse;
(function (MergeDeveloperIdentitiesResponse) {
    MergeDeveloperIdentitiesResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(MergeDeveloperIdentitiesResponse || (MergeDeveloperIdentitiesResponse = {}));
var ConcurrentModificationException;
(function (ConcurrentModificationException) {
    ConcurrentModificationException.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(ConcurrentModificationException || (ConcurrentModificationException = {}));
var SetIdentityPoolRolesInput;
(function (SetIdentityPoolRolesInput) {
    SetIdentityPoolRolesInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(SetIdentityPoolRolesInput || (SetIdentityPoolRolesInput = {}));
var TagResourceInput;
(function (TagResourceInput) {
    TagResourceInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(TagResourceInput || (TagResourceInput = {}));
var TagResourceResponse;
(function (TagResourceResponse) {
    TagResourceResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(TagResourceResponse || (TagResourceResponse = {}));
var UnlinkDeveloperIdentityInput;
(function (UnlinkDeveloperIdentityInput) {
    UnlinkDeveloperIdentityInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(UnlinkDeveloperIdentityInput || (UnlinkDeveloperIdentityInput = {}));
var UnlinkIdentityInput;
(function (UnlinkIdentityInput) {
    UnlinkIdentityInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(UnlinkIdentityInput || (UnlinkIdentityInput = {}));
var UntagResourceInput;
(function (UntagResourceInput) {
    UntagResourceInput.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(UntagResourceInput || (UntagResourceInput = {}));
var UntagResourceResponse;
(function (UntagResourceResponse) {
    UntagResourceResponse.filterSensitiveLog = function (obj) { return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, obj)); };
})(UntagResourceResponse || (UntagResourceResponse = {}));
//# sourceMappingURL=models_0.js.map

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(163);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return serializeAws_json1_1CreateIdentityPoolCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return serializeAws_json1_1DeleteIdentitiesCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return serializeAws_json1_1DeleteIdentityPoolCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return serializeAws_json1_1DescribeIdentityCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return serializeAws_json1_1DescribeIdentityPoolCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return serializeAws_json1_1GetCredentialsForIdentityCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return serializeAws_json1_1GetIdCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return serializeAws_json1_1GetIdentityPoolRolesCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return serializeAws_json1_1GetOpenIdTokenCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return serializeAws_json1_1ListIdentitiesCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return serializeAws_json1_1ListIdentityPoolsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return serializeAws_json1_1ListTagsForResourceCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return serializeAws_json1_1LookupDeveloperIdentityCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return serializeAws_json1_1MergeDeveloperIdentitiesCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return serializeAws_json1_1SetIdentityPoolRolesCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return serializeAws_json1_1TagResourceCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return serializeAws_json1_1UnlinkDeveloperIdentityCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return serializeAws_json1_1UnlinkIdentityCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return serializeAws_json1_1UntagResourceCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serializeAws_json1_1UpdateIdentityPoolCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return deserializeAws_json1_1CreateIdentityPoolCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return deserializeAws_json1_1DeleteIdentitiesCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return deserializeAws_json1_1DeleteIdentityPoolCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return deserializeAws_json1_1DescribeIdentityCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return deserializeAws_json1_1DescribeIdentityPoolCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return deserializeAws_json1_1GetCredentialsForIdentityCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return deserializeAws_json1_1GetIdCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return deserializeAws_json1_1GetIdentityPoolRolesCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return deserializeAws_json1_1GetOpenIdTokenCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return deserializeAws_json1_1ListIdentitiesCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return deserializeAws_json1_1ListIdentityPoolsCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return deserializeAws_json1_1ListTagsForResourceCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return deserializeAws_json1_1LookupDeveloperIdentityCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return deserializeAws_json1_1MergeDeveloperIdentitiesCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return deserializeAws_json1_1SetIdentityPoolRolesCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return deserializeAws_json1_1TagResourceCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return deserializeAws_json1_1UnlinkDeveloperIdentityCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return deserializeAws_json1_1UnlinkIdentityCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return deserializeAws_json1_1UntagResourceCommand; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return deserializeAws_json1_1UpdateIdentityPoolCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__ = __webpack_require__(171);


var serializeAws_json1_1CreateIdentityPoolCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.CreateIdentityPool",
        };
        body = JSON.stringify(serializeAws_json1_1CreateIdentityPoolInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DeleteIdentitiesCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.DeleteIdentities",
        };
        body = JSON.stringify(serializeAws_json1_1DeleteIdentitiesInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DeleteIdentityPoolCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.DeleteIdentityPool",
        };
        body = JSON.stringify(serializeAws_json1_1DeleteIdentityPoolInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DescribeIdentityCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.DescribeIdentity",
        };
        body = JSON.stringify(serializeAws_json1_1DescribeIdentityInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1DescribeIdentityPoolCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.DescribeIdentityPool",
        };
        body = JSON.stringify(serializeAws_json1_1DescribeIdentityPoolInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1GetCredentialsForIdentityCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.GetCredentialsForIdentity",
        };
        body = JSON.stringify(serializeAws_json1_1GetCredentialsForIdentityInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1GetIdCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.GetId",
        };
        body = JSON.stringify(serializeAws_json1_1GetIdInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1GetIdentityPoolRolesCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.GetIdentityPoolRoles",
        };
        body = JSON.stringify(serializeAws_json1_1GetIdentityPoolRolesInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1GetOpenIdTokenCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.GetOpenIdToken",
        };
        body = JSON.stringify(serializeAws_json1_1GetOpenIdTokenInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.GetOpenIdTokenForDeveloperIdentity",
        };
        body = JSON.stringify(serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1ListIdentitiesCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.ListIdentities",
        };
        body = JSON.stringify(serializeAws_json1_1ListIdentitiesInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1ListIdentityPoolsCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.ListIdentityPools",
        };
        body = JSON.stringify(serializeAws_json1_1ListIdentityPoolsInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1ListTagsForResourceCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.ListTagsForResource",
        };
        body = JSON.stringify(serializeAws_json1_1ListTagsForResourceInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1LookupDeveloperIdentityCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.LookupDeveloperIdentity",
        };
        body = JSON.stringify(serializeAws_json1_1LookupDeveloperIdentityInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1MergeDeveloperIdentitiesCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.MergeDeveloperIdentities",
        };
        body = JSON.stringify(serializeAws_json1_1MergeDeveloperIdentitiesInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1SetIdentityPoolRolesCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.SetIdentityPoolRoles",
        };
        body = JSON.stringify(serializeAws_json1_1SetIdentityPoolRolesInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1TagResourceCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.TagResource",
        };
        body = JSON.stringify(serializeAws_json1_1TagResourceInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1UnlinkDeveloperIdentityCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.UnlinkDeveloperIdentity",
        };
        body = JSON.stringify(serializeAws_json1_1UnlinkDeveloperIdentityInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1UnlinkIdentityCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.UnlinkIdentity",
        };
        body = JSON.stringify(serializeAws_json1_1UnlinkIdentityInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1UntagResourceCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.UntagResource",
        };
        body = JSON.stringify(serializeAws_json1_1UntagResourceInput(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var serializeAws_json1_1UpdateIdentityPoolCommand = function (input, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var headers, body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        headers = {
            "content-type": "application/x-amz-json-1.1",
            "x-amz-target": "AWSCognitoIdentityService.UpdateIdentityPool",
        };
        body = JSON.stringify(serializeAws_json1_1IdentityPool(input, context));
        return [2 /*return*/, buildHttpRpcRequest(context, headers, "/", undefined, body)];
    });
}); };
var deserializeAws_json1_1CreateIdentityPoolCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1CreateIdentityPoolCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1IdentityPool(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1CreateIdentityPoolCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
    var _j;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _j = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_j.body = _k.sent(), _j)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalErrorException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 2];
                    case "InvalidParameterException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 4];
                    case "LimitExceededException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#LimitExceededException": return [3 /*break*/, 6];
                    case "NotAuthorizedException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 8];
                    case "ResourceConflictException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#ResourceConflictException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DeleteIdentitiesCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DeleteIdentitiesCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1DeleteIdentitiesResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DeleteIdentitiesCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, parsedBody, message;
    var _f;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_g) {
        switch (_g.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _f = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_f.body = _g.sent(), _f)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalErrorException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 2];
                    case "InvalidParameterException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 4];
                    case "TooManyRequestsException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 6];
                }
                return [3 /*break*/, 8];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_g.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 9];
            case 8:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _g.label = 9;
            case 9:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DeleteIdentityPoolCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DeleteIdentityPoolCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DeleteIdentityPoolCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
    var _h;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_j) {
        switch (_j.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _h = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_h.body = _j.sent(), _h)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalErrorException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 2];
                    case "InvalidParameterException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 4];
                    case "NotAuthorizedException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 6];
                    case "ResourceNotFoundException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 8];
                    case "TooManyRequestsException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 10];
                }
                return [3 /*break*/, 12];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 12:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _j.label = 13;
            case 13:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DescribeIdentityCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DescribeIdentityCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1IdentityDescription(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DescribeIdentityCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
    var _h;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_j) {
        switch (_j.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _h = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_h.body = _j.sent(), _h)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalErrorException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 2];
                    case "InvalidParameterException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 4];
                    case "NotAuthorizedException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 6];
                    case "ResourceNotFoundException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 8];
                    case "TooManyRequestsException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 10];
                }
                return [3 /*break*/, 12];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 12:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _j.label = 13;
            case 13:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1DescribeIdentityPoolCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1DescribeIdentityPoolCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1IdentityPool(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1DescribeIdentityPoolCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
    var _h;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_j) {
        switch (_j.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _h = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_h.body = _j.sent(), _h)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalErrorException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 2];
                    case "InvalidParameterException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 4];
                    case "NotAuthorizedException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 6];
                    case "ResourceNotFoundException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 8];
                    case "TooManyRequestsException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 10];
                }
                return [3 /*break*/, 12];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 12:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _j.label = 13;
            case 13:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1GetCredentialsForIdentityCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1GetCredentialsForIdentityCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1GetCredentialsForIdentityResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1GetCredentialsForIdentityCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, parsedBody, message;
    var _l;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_m) {
        switch (_m.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _l = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_l.body = _m.sent(), _l)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ExternalServiceException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#ExternalServiceException": return [3 /*break*/, 2];
                    case "InternalErrorException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 4];
                    case "InvalidIdentityPoolConfigurationException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#InvalidIdentityPoolConfigurationException": return [3 /*break*/, 6];
                    case "InvalidParameterException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 8];
                    case "NotAuthorizedException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 10];
                    case "ResourceConflictException": return [3 /*break*/, 12];
                    case "com.amazonaws.cognitoidentity#ResourceConflictException": return [3 /*break*/, 12];
                    case "ResourceNotFoundException": return [3 /*break*/, 14];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 14];
                    case "TooManyRequestsException": return [3 /*break*/, 16];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 16];
                }
                return [3 /*break*/, 18];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidIdentityPoolConfigurationExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 12:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)];
            case 13:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _h.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 14:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 15:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _j.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 16:
                _k = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 17:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _k.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 18:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _m.label = 19;
            case 19:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1GetIdCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1GetIdCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1GetIdResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1GetIdCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, parsedBody, message;
    var _l;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_m) {
        switch (_m.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _l = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_l.body = _m.sent(), _l)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ExternalServiceException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#ExternalServiceException": return [3 /*break*/, 2];
                    case "InternalErrorException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 4];
                    case "InvalidParameterException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 6];
                    case "LimitExceededException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#LimitExceededException": return [3 /*break*/, 8];
                    case "NotAuthorizedException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 10];
                    case "ResourceConflictException": return [3 /*break*/, 12];
                    case "com.amazonaws.cognitoidentity#ResourceConflictException": return [3 /*break*/, 12];
                    case "ResourceNotFoundException": return [3 /*break*/, 14];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 14];
                    case "TooManyRequestsException": return [3 /*break*/, 16];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 16];
                }
                return [3 /*break*/, 18];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 12:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)];
            case 13:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _h.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 14:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 15:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _j.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 16:
                _k = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 17:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _k.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 18:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _m.label = 19;
            case 19:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1GetIdentityPoolRolesCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1GetIdentityPoolRolesCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1GetIdentityPoolRolesResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1GetIdentityPoolRolesCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
    var _j;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _j = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_j.body = _k.sent(), _j)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalErrorException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 2];
                    case "InvalidParameterException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 4];
                    case "NotAuthorizedException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 6];
                    case "ResourceConflictException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#ResourceConflictException": return [3 /*break*/, 8];
                    case "ResourceNotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1GetOpenIdTokenCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1GetOpenIdTokenCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1GetOpenIdTokenResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1GetOpenIdTokenCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    var _k;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_l) {
        switch (_l.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _k = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_k.body = _l.sent(), _k)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ExternalServiceException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#ExternalServiceException": return [3 /*break*/, 2];
                    case "InternalErrorException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 4];
                    case "InvalidParameterException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 6];
                    case "NotAuthorizedException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 8];
                    case "ResourceConflictException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#ResourceConflictException": return [3 /*break*/, 10];
                    case "ResourceNotFoundException": return [3 /*break*/, 12];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 12];
                    case "TooManyRequestsException": return [3 /*break*/, 14];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 14];
                }
                return [3 /*break*/, 16];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 12:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 13:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _h.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 14:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 15:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _j.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 16:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _l.label = 17;
            case 17:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    var _k;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_l) {
        switch (_l.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _k = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_k.body = _l.sent(), _k)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "DeveloperUserAlreadyRegisteredException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#DeveloperUserAlreadyRegisteredException": return [3 /*break*/, 2];
                    case "InternalErrorException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 4];
                    case "InvalidParameterException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 6];
                    case "NotAuthorizedException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 8];
                    case "ResourceConflictException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#ResourceConflictException": return [3 /*break*/, 10];
                    case "ResourceNotFoundException": return [3 /*break*/, 12];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 12];
                    case "TooManyRequestsException": return [3 /*break*/, 14];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 14];
                }
                return [3 /*break*/, 16];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1DeveloperUserAlreadyRegisteredExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 12:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 13:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _h.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 14:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 15:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _j.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 16:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _l.label = 17;
            case 17:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1ListIdentitiesCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1ListIdentitiesCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1ListIdentitiesResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1ListIdentitiesCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
    var _h;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_j) {
        switch (_j.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _h = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_h.body = _j.sent(), _h)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalErrorException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 2];
                    case "InvalidParameterException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 4];
                    case "NotAuthorizedException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 6];
                    case "ResourceNotFoundException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 8];
                    case "TooManyRequestsException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 10];
                }
                return [3 /*break*/, 12];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 12:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _j.label = 13;
            case 13:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1ListIdentityPoolsCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1ListIdentityPoolsCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1ListIdentityPoolsResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1ListIdentityPoolsCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
    var _h;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_j) {
        switch (_j.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _h = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_h.body = _j.sent(), _h)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalErrorException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 2];
                    case "InvalidParameterException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 4];
                    case "NotAuthorizedException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 6];
                    case "ResourceNotFoundException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 8];
                    case "TooManyRequestsException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 10];
                }
                return [3 /*break*/, 12];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 12:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _j.label = 13;
            case 13:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1ListTagsForResourceCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1ListTagsForResourceCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1ListTagsForResourceResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1ListTagsForResourceCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
    var _h;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_j) {
        switch (_j.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _h = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_h.body = _j.sent(), _h)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalErrorException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 2];
                    case "InvalidParameterException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 4];
                    case "NotAuthorizedException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 6];
                    case "ResourceNotFoundException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 8];
                    case "TooManyRequestsException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 10];
                }
                return [3 /*break*/, 12];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 12:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _j.label = 13;
            case 13:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1LookupDeveloperIdentityCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1LookupDeveloperIdentityCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1LookupDeveloperIdentityResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1LookupDeveloperIdentityCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
    var _j;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _j = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_j.body = _k.sent(), _j)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalErrorException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 2];
                    case "InvalidParameterException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 4];
                    case "NotAuthorizedException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 6];
                    case "ResourceConflictException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#ResourceConflictException": return [3 /*break*/, 8];
                    case "ResourceNotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1MergeDeveloperIdentitiesCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1MergeDeveloperIdentitiesCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1MergeDeveloperIdentitiesResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1MergeDeveloperIdentitiesCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
    var _j;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _j = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_j.body = _k.sent(), _j)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalErrorException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 2];
                    case "InvalidParameterException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 4];
                    case "NotAuthorizedException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 6];
                    case "ResourceConflictException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#ResourceConflictException": return [3 /*break*/, 8];
                    case "ResourceNotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1SetIdentityPoolRolesCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1SetIdentityPoolRolesCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1SetIdentityPoolRolesCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    var _k;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_l) {
        switch (_l.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _k = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_k.body = _l.sent(), _k)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ConcurrentModificationException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#ConcurrentModificationException": return [3 /*break*/, 2];
                    case "InternalErrorException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 4];
                    case "InvalidParameterException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 6];
                    case "NotAuthorizedException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 8];
                    case "ResourceConflictException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#ResourceConflictException": return [3 /*break*/, 10];
                    case "ResourceNotFoundException": return [3 /*break*/, 12];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 12];
                    case "TooManyRequestsException": return [3 /*break*/, 14];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 14];
                }
                return [3 /*break*/, 16];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ConcurrentModificationExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 12:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 13:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _h.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 14:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 15:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _j.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 16:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _l.label = 17;
            case 17:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1TagResourceCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1TagResourceCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1TagResourceResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1TagResourceCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
    var _h;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_j) {
        switch (_j.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _h = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_h.body = _j.sent(), _h)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalErrorException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 2];
                    case "InvalidParameterException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 4];
                    case "NotAuthorizedException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 6];
                    case "ResourceNotFoundException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 8];
                    case "TooManyRequestsException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 10];
                }
                return [3 /*break*/, 12];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 12:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _j.label = 13;
            case 13:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1UnlinkDeveloperIdentityCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1UnlinkDeveloperIdentityCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1UnlinkDeveloperIdentityCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, parsedBody, message;
    var _j;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_k) {
        switch (_k.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _j = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_j.body = _k.sent(), _j)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalErrorException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 2];
                    case "InvalidParameterException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 4];
                    case "NotAuthorizedException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 6];
                    case "ResourceConflictException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#ResourceConflictException": return [3 /*break*/, 8];
                    case "ResourceNotFoundException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 10];
                    case "TooManyRequestsException": return [3 /*break*/, 12];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 12];
                }
                return [3 /*break*/, 14];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 12:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 13:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _h.concat([(_k.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 15];
            case 14:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _k.label = 15;
            case 15:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1UnlinkIdentityCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1UnlinkIdentityCommandError(output, context)];
                }
                return [4 /*yield*/, collectBody(output.body, context)];
            case 1:
                _a.sent();
                response = {
                    $metadata: deserializeMetadata(output),
                };
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1UnlinkIdentityCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, parsedBody, message;
    var _k;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_l) {
        switch (_l.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _k = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_k.body = _l.sent(), _k)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ExternalServiceException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#ExternalServiceException": return [3 /*break*/, 2];
                    case "InternalErrorException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 4];
                    case "InvalidParameterException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 6];
                    case "NotAuthorizedException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 8];
                    case "ResourceConflictException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#ResourceConflictException": return [3 /*break*/, 10];
                    case "ResourceNotFoundException": return [3 /*break*/, 12];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 12];
                    case "TooManyRequestsException": return [3 /*break*/, 14];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 14];
                }
                return [3 /*break*/, 16];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ExternalServiceExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 12:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 13:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _h.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 14:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 15:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _j.concat([(_l.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 17];
            case 16:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _l.label = 17;
            case 17:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1UntagResourceCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1UntagResourceCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1UntagResourceResponse(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1UntagResourceCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, parsedBody, message;
    var _h;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_j) {
        switch (_j.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _h = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_h.body = _j.sent(), _h)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "InternalErrorException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 2];
                    case "InvalidParameterException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 4];
                    case "NotAuthorizedException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 6];
                    case "ResourceNotFoundException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 8];
                    case "TooManyRequestsException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 10];
                }
                return [3 /*break*/, 12];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_j.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 13];
            case 12:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _j.label = 13;
            case 13:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1UpdateIdentityPoolCommand = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var data, contents, response;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (output.statusCode >= 300) {
                    return [2 /*return*/, deserializeAws_json1_1UpdateIdentityPoolCommandError(output, context)];
                }
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                data = _a.sent();
                contents = {};
                contents = deserializeAws_json1_1IdentityPool(data, context);
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ $metadata: deserializeMetadata(output) }, contents);
                return [2 /*return*/, Promise.resolve(response)];
        }
    });
}); };
var deserializeAws_json1_1UpdateIdentityPoolCommandError = function (output, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var parsedOutput, _a, response, errorCode, _b, _c, _d, _e, _f, _g, _h, _j, _k, parsedBody, message;
    var _l;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_m) {
        switch (_m.label) {
            case 0:
                _a = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, output)];
                _l = {};
                return [4 /*yield*/, parseBody(output.body, context)];
            case 1:
                parsedOutput = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _a.concat([(_l.body = _m.sent(), _l)]));
                errorCode = "UnknownError";
                errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
                _b = errorCode;
                switch (_b) {
                    case "ConcurrentModificationException": return [3 /*break*/, 2];
                    case "com.amazonaws.cognitoidentity#ConcurrentModificationException": return [3 /*break*/, 2];
                    case "InternalErrorException": return [3 /*break*/, 4];
                    case "com.amazonaws.cognitoidentity#InternalErrorException": return [3 /*break*/, 4];
                    case "InvalidParameterException": return [3 /*break*/, 6];
                    case "com.amazonaws.cognitoidentity#InvalidParameterException": return [3 /*break*/, 6];
                    case "LimitExceededException": return [3 /*break*/, 8];
                    case "com.amazonaws.cognitoidentity#LimitExceededException": return [3 /*break*/, 8];
                    case "NotAuthorizedException": return [3 /*break*/, 10];
                    case "com.amazonaws.cognitoidentity#NotAuthorizedException": return [3 /*break*/, 10];
                    case "ResourceConflictException": return [3 /*break*/, 12];
                    case "com.amazonaws.cognitoidentity#ResourceConflictException": return [3 /*break*/, 12];
                    case "ResourceNotFoundException": return [3 /*break*/, 14];
                    case "com.amazonaws.cognitoidentity#ResourceNotFoundException": return [3 /*break*/, 14];
                    case "TooManyRequestsException": return [3 /*break*/, 16];
                    case "com.amazonaws.cognitoidentity#TooManyRequestsException": return [3 /*break*/, 16];
                }
                return [3 /*break*/, 18];
            case 2:
                _c = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ConcurrentModificationExceptionResponse(parsedOutput, context)];
            case 3:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _c.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 4:
                _d = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InternalErrorExceptionResponse(parsedOutput, context)];
            case 5:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _d.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 6:
                _e = [{}];
                return [4 /*yield*/, deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context)];
            case 7:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _e.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 8:
                _f = [{}];
                return [4 /*yield*/, deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context)];
            case 9:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _f.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 10:
                _g = [{}];
                return [4 /*yield*/, deserializeAws_json1_1NotAuthorizedExceptionResponse(parsedOutput, context)];
            case 11:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _g.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 12:
                _h = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceConflictExceptionResponse(parsedOutput, context)];
            case 13:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _h.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 14:
                _j = [{}];
                return [4 /*yield*/, deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context)];
            case 15:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _j.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 16:
                _k = [{}];
                return [4 /*yield*/, deserializeAws_json1_1TooManyRequestsExceptionResponse(parsedOutput, context)];
            case 17:
                response = __WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */].apply(void 0, _k.concat([(_m.sent())])), { name: errorCode, $metadata: deserializeMetadata(output) }]);
                return [3 /*break*/, 19];
            case 18:
                parsedBody = parsedOutput.body;
                errorCode = parsedBody.code || parsedBody.Code || errorCode;
                response = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, parsedBody), { name: "" + errorCode, message: parsedBody.message || parsedBody.Message || errorCode, $fault: "client", $metadata: deserializeMetadata(output) });
                _m.label = 19;
            case 19:
                message = response.message || response.Message || errorCode;
                response.message = message;
                delete response.Message;
                return [2 /*return*/, Promise.reject(Object.assign(new Error(message), response))];
        }
    });
}); };
var deserializeAws_json1_1ConcurrentModificationExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1ConcurrentModificationException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "ConcurrentModificationException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1DeveloperUserAlreadyRegisteredExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1DeveloperUserAlreadyRegisteredException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "DeveloperUserAlreadyRegisteredException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1ExternalServiceExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1ExternalServiceException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "ExternalServiceException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1InternalErrorExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1InternalErrorException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "InternalErrorException", $fault: "server", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1InvalidIdentityPoolConfigurationExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1InvalidIdentityPoolConfigurationException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "InvalidIdentityPoolConfigurationException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1InvalidParameterExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1InvalidParameterException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "InvalidParameterException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1LimitExceededExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1LimitExceededException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "LimitExceededException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1NotAuthorizedExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1NotAuthorizedException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "NotAuthorizedException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1ResourceConflictExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1ResourceConflictException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "ResourceConflictException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1ResourceNotFoundExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1ResourceNotFoundException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "ResourceNotFoundException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var deserializeAws_json1_1TooManyRequestsExceptionResponse = function (parsedOutput, context) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var body, deserialized, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
        body = parsedOutput.body;
        deserialized = deserializeAws_json1_1TooManyRequestsException(body, context);
        contents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ name: "TooManyRequestsException", $fault: "client", $metadata: deserializeMetadata(parsedOutput) }, deserialized);
        return [2 /*return*/, contents];
    });
}); };
var serializeAws_json1_1CognitoIdentityProvider = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.ClientId !== undefined && input.ClientId !== null && { ClientId: input.ClientId })), (input.ProviderName !== undefined && input.ProviderName !== null && { ProviderName: input.ProviderName })), (input.ServerSideTokenCheck !== undefined &&
        input.ServerSideTokenCheck !== null && { ServerSideTokenCheck: input.ServerSideTokenCheck }));
};
var serializeAws_json1_1CognitoIdentityProviderList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_json1_1CognitoIdentityProvider(entry, context);
    });
};
var serializeAws_json1_1CreateIdentityPoolInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.AllowClassicFlow !== undefined &&
        input.AllowClassicFlow !== null && { AllowClassicFlow: input.AllowClassicFlow })), (input.AllowUnauthenticatedIdentities !== undefined &&
        input.AllowUnauthenticatedIdentities !== null && {
        AllowUnauthenticatedIdentities: input.AllowUnauthenticatedIdentities,
    })), (input.CognitoIdentityProviders !== undefined &&
        input.CognitoIdentityProviders !== null && {
        CognitoIdentityProviders: serializeAws_json1_1CognitoIdentityProviderList(input.CognitoIdentityProviders, context),
    })), (input.DeveloperProviderName !== undefined &&
        input.DeveloperProviderName !== null && { DeveloperProviderName: input.DeveloperProviderName })), (input.IdentityPoolName !== undefined &&
        input.IdentityPoolName !== null && { IdentityPoolName: input.IdentityPoolName })), (input.IdentityPoolTags !== undefined &&
        input.IdentityPoolTags !== null && {
        IdentityPoolTags: serializeAws_json1_1IdentityPoolTagsType(input.IdentityPoolTags, context),
    })), (input.OpenIdConnectProviderARNs !== undefined &&
        input.OpenIdConnectProviderARNs !== null && {
        OpenIdConnectProviderARNs: serializeAws_json1_1OIDCProviderList(input.OpenIdConnectProviderARNs, context),
    })), (input.SamlProviderARNs !== undefined &&
        input.SamlProviderARNs !== null && {
        SamlProviderARNs: serializeAws_json1_1SAMLProviderList(input.SamlProviderARNs, context),
    })), (input.SupportedLoginProviders !== undefined &&
        input.SupportedLoginProviders !== null && {
        SupportedLoginProviders: serializeAws_json1_1IdentityProviders(input.SupportedLoginProviders, context),
    }));
};
var serializeAws_json1_1DeleteIdentitiesInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.IdentityIdsToDelete !== undefined &&
        input.IdentityIdsToDelete !== null && {
        IdentityIdsToDelete: serializeAws_json1_1IdentityIdList(input.IdentityIdsToDelete, context),
    }));
};
var serializeAws_json1_1DeleteIdentityPoolInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.IdentityPoolId !== undefined &&
        input.IdentityPoolId !== null && { IdentityPoolId: input.IdentityPoolId }));
};
var serializeAws_json1_1DescribeIdentityInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.IdentityId !== undefined && input.IdentityId !== null && { IdentityId: input.IdentityId }));
};
var serializeAws_json1_1DescribeIdentityPoolInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.IdentityPoolId !== undefined &&
        input.IdentityPoolId !== null && { IdentityPoolId: input.IdentityPoolId }));
};
var serializeAws_json1_1GetCredentialsForIdentityInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.CustomRoleArn !== undefined && input.CustomRoleArn !== null && { CustomRoleArn: input.CustomRoleArn })), (input.IdentityId !== undefined && input.IdentityId !== null && { IdentityId: input.IdentityId })), (input.Logins !== undefined &&
        input.Logins !== null && { Logins: serializeAws_json1_1LoginsMap(input.Logins, context) }));
};
var serializeAws_json1_1GetIdentityPoolRolesInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.IdentityPoolId !== undefined &&
        input.IdentityPoolId !== null && { IdentityPoolId: input.IdentityPoolId }));
};
var serializeAws_json1_1GetIdInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.AccountId !== undefined && input.AccountId !== null && { AccountId: input.AccountId })), (input.IdentityPoolId !== undefined &&
        input.IdentityPoolId !== null && { IdentityPoolId: input.IdentityPoolId })), (input.Logins !== undefined &&
        input.Logins !== null && { Logins: serializeAws_json1_1LoginsMap(input.Logins, context) }));
};
var serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.IdentityId !== undefined && input.IdentityId !== null && { IdentityId: input.IdentityId })), (input.IdentityPoolId !== undefined &&
        input.IdentityPoolId !== null && { IdentityPoolId: input.IdentityPoolId })), (input.Logins !== undefined &&
        input.Logins !== null && { Logins: serializeAws_json1_1LoginsMap(input.Logins, context) })), (input.TokenDuration !== undefined && input.TokenDuration !== null && { TokenDuration: input.TokenDuration }));
};
var serializeAws_json1_1GetOpenIdTokenInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.IdentityId !== undefined && input.IdentityId !== null && { IdentityId: input.IdentityId })), (input.Logins !== undefined &&
        input.Logins !== null && { Logins: serializeAws_json1_1LoginsMap(input.Logins, context) }));
};
var serializeAws_json1_1IdentityIdList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_json1_1IdentityPool = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.AllowClassicFlow !== undefined &&
        input.AllowClassicFlow !== null && { AllowClassicFlow: input.AllowClassicFlow })), (input.AllowUnauthenticatedIdentities !== undefined &&
        input.AllowUnauthenticatedIdentities !== null && {
        AllowUnauthenticatedIdentities: input.AllowUnauthenticatedIdentities,
    })), (input.CognitoIdentityProviders !== undefined &&
        input.CognitoIdentityProviders !== null && {
        CognitoIdentityProviders: serializeAws_json1_1CognitoIdentityProviderList(input.CognitoIdentityProviders, context),
    })), (input.DeveloperProviderName !== undefined &&
        input.DeveloperProviderName !== null && { DeveloperProviderName: input.DeveloperProviderName })), (input.IdentityPoolId !== undefined &&
        input.IdentityPoolId !== null && { IdentityPoolId: input.IdentityPoolId })), (input.IdentityPoolName !== undefined &&
        input.IdentityPoolName !== null && { IdentityPoolName: input.IdentityPoolName })), (input.IdentityPoolTags !== undefined &&
        input.IdentityPoolTags !== null && {
        IdentityPoolTags: serializeAws_json1_1IdentityPoolTagsType(input.IdentityPoolTags, context),
    })), (input.OpenIdConnectProviderARNs !== undefined &&
        input.OpenIdConnectProviderARNs !== null && {
        OpenIdConnectProviderARNs: serializeAws_json1_1OIDCProviderList(input.OpenIdConnectProviderARNs, context),
    })), (input.SamlProviderARNs !== undefined &&
        input.SamlProviderARNs !== null && {
        SamlProviderARNs: serializeAws_json1_1SAMLProviderList(input.SamlProviderARNs, context),
    })), (input.SupportedLoginProviders !== undefined &&
        input.SupportedLoginProviders !== null && {
        SupportedLoginProviders: serializeAws_json1_1IdentityProviders(input.SupportedLoginProviders, context),
    }));
};
var serializeAws_json1_1IdentityPoolTagsListType = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_json1_1IdentityPoolTagsType = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __read */])(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_json1_1IdentityProviders = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __read */])(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_json1_1ListIdentitiesInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.HideDisabled !== undefined && input.HideDisabled !== null && { HideDisabled: input.HideDisabled })), (input.IdentityPoolId !== undefined &&
        input.IdentityPoolId !== null && { IdentityPoolId: input.IdentityPoolId })), (input.MaxResults !== undefined && input.MaxResults !== null && { MaxResults: input.MaxResults })), (input.NextToken !== undefined && input.NextToken !== null && { NextToken: input.NextToken }));
};
var serializeAws_json1_1ListIdentityPoolsInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.MaxResults !== undefined && input.MaxResults !== null && { MaxResults: input.MaxResults })), (input.NextToken !== undefined && input.NextToken !== null && { NextToken: input.NextToken }));
};
var serializeAws_json1_1ListTagsForResourceInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.ResourceArn !== undefined && input.ResourceArn !== null && { ResourceArn: input.ResourceArn }));
};
var serializeAws_json1_1LoginsList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_json1_1LoginsMap = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __read */])(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_json1_1LookupDeveloperIdentityInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.DeveloperUserIdentifier !== undefined &&
        input.DeveloperUserIdentifier !== null && { DeveloperUserIdentifier: input.DeveloperUserIdentifier })), (input.IdentityId !== undefined && input.IdentityId !== null && { IdentityId: input.IdentityId })), (input.IdentityPoolId !== undefined &&
        input.IdentityPoolId !== null && { IdentityPoolId: input.IdentityPoolId })), (input.MaxResults !== undefined && input.MaxResults !== null && { MaxResults: input.MaxResults })), (input.NextToken !== undefined && input.NextToken !== null && { NextToken: input.NextToken }));
};
var serializeAws_json1_1MappingRule = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.Claim !== undefined && input.Claim !== null && { Claim: input.Claim })), (input.MatchType !== undefined && input.MatchType !== null && { MatchType: input.MatchType })), (input.RoleARN !== undefined && input.RoleARN !== null && { RoleARN: input.RoleARN })), (input.Value !== undefined && input.Value !== null && { Value: input.Value }));
};
var serializeAws_json1_1MappingRulesList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return serializeAws_json1_1MappingRule(entry, context);
    });
};
var serializeAws_json1_1MergeDeveloperIdentitiesInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.DestinationUserIdentifier !== undefined &&
        input.DestinationUserIdentifier !== null && { DestinationUserIdentifier: input.DestinationUserIdentifier })), (input.DeveloperProviderName !== undefined &&
        input.DeveloperProviderName !== null && { DeveloperProviderName: input.DeveloperProviderName })), (input.IdentityPoolId !== undefined &&
        input.IdentityPoolId !== null && { IdentityPoolId: input.IdentityPoolId })), (input.SourceUserIdentifier !== undefined &&
        input.SourceUserIdentifier !== null && { SourceUserIdentifier: input.SourceUserIdentifier }));
};
var serializeAws_json1_1OIDCProviderList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_json1_1RoleMapping = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.AmbiguousRoleResolution !== undefined &&
        input.AmbiguousRoleResolution !== null && { AmbiguousRoleResolution: input.AmbiguousRoleResolution })), (input.RulesConfiguration !== undefined &&
        input.RulesConfiguration !== null && {
        RulesConfiguration: serializeAws_json1_1RulesConfigurationType(input.RulesConfiguration, context),
    })), (input.Type !== undefined && input.Type !== null && { Type: input.Type }));
};
var serializeAws_json1_1RoleMappingMap = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __read */])(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, acc), (_b = {}, _b[key] = serializeAws_json1_1RoleMapping(value, context), _b));
    }, {});
};
var serializeAws_json1_1RolesMap = function (input, context) {
    return Object.entries(input).reduce(function (acc, _a) {
        var _b;
        var _c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __read */])(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var serializeAws_json1_1RulesConfigurationType = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.Rules !== undefined &&
        input.Rules !== null && { Rules: serializeAws_json1_1MappingRulesList(input.Rules, context) }));
};
var serializeAws_json1_1SAMLProviderList = function (input, context) {
    return input
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var serializeAws_json1_1SetIdentityPoolRolesInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.IdentityPoolId !== undefined &&
        input.IdentityPoolId !== null && { IdentityPoolId: input.IdentityPoolId })), (input.RoleMappings !== undefined &&
        input.RoleMappings !== null && { RoleMappings: serializeAws_json1_1RoleMappingMap(input.RoleMappings, context) })), (input.Roles !== undefined &&
        input.Roles !== null && { Roles: serializeAws_json1_1RolesMap(input.Roles, context) }));
};
var serializeAws_json1_1TagResourceInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.ResourceArn !== undefined && input.ResourceArn !== null && { ResourceArn: input.ResourceArn })), (input.Tags !== undefined &&
        input.Tags !== null && { Tags: serializeAws_json1_1IdentityPoolTagsType(input.Tags, context) }));
};
var serializeAws_json1_1UnlinkDeveloperIdentityInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.DeveloperProviderName !== undefined &&
        input.DeveloperProviderName !== null && { DeveloperProviderName: input.DeveloperProviderName })), (input.DeveloperUserIdentifier !== undefined &&
        input.DeveloperUserIdentifier !== null && { DeveloperUserIdentifier: input.DeveloperUserIdentifier })), (input.IdentityId !== undefined && input.IdentityId !== null && { IdentityId: input.IdentityId })), (input.IdentityPoolId !== undefined &&
        input.IdentityPoolId !== null && { IdentityPoolId: input.IdentityPoolId }));
};
var serializeAws_json1_1UnlinkIdentityInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.IdentityId !== undefined && input.IdentityId !== null && { IdentityId: input.IdentityId })), (input.Logins !== undefined &&
        input.Logins !== null && { Logins: serializeAws_json1_1LoginsMap(input.Logins, context) })), (input.LoginsToRemove !== undefined &&
        input.LoginsToRemove !== null && {
        LoginsToRemove: serializeAws_json1_1LoginsList(input.LoginsToRemove, context),
    }));
};
var serializeAws_json1_1UntagResourceInput = function (input, context) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, (input.ResourceArn !== undefined && input.ResourceArn !== null && { ResourceArn: input.ResourceArn })), (input.TagKeys !== undefined &&
        input.TagKeys !== null && { TagKeys: serializeAws_json1_1IdentityPoolTagsListType(input.TagKeys, context) }));
};
var deserializeAws_json1_1CognitoIdentityProvider = function (output, context) {
    return {
        ClientId: output.ClientId !== undefined && output.ClientId !== null ? output.ClientId : undefined,
        ProviderName: output.ProviderName !== undefined && output.ProviderName !== null ? output.ProviderName : undefined,
        ServerSideTokenCheck: output.ServerSideTokenCheck !== undefined && output.ServerSideTokenCheck !== null
            ? output.ServerSideTokenCheck
            : undefined,
    };
};
var deserializeAws_json1_1CognitoIdentityProviderList = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1CognitoIdentityProvider(entry, context);
    });
};
var deserializeAws_json1_1ConcurrentModificationException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1Credentials = function (output, context) {
    return {
        AccessKeyId: output.AccessKeyId !== undefined && output.AccessKeyId !== null ? output.AccessKeyId : undefined,
        Expiration: output.Expiration !== undefined && output.Expiration !== null
            ? new Date(Math.round(output.Expiration * 1000))
            : undefined,
        SecretKey: output.SecretKey !== undefined && output.SecretKey !== null ? output.SecretKey : undefined,
        SessionToken: output.SessionToken !== undefined && output.SessionToken !== null ? output.SessionToken : undefined,
    };
};
var deserializeAws_json1_1DeleteIdentitiesResponse = function (output, context) {
    return {
        UnprocessedIdentityIds: output.UnprocessedIdentityIds !== undefined && output.UnprocessedIdentityIds !== null
            ? deserializeAws_json1_1UnprocessedIdentityIdList(output.UnprocessedIdentityIds, context)
            : undefined,
    };
};
var deserializeAws_json1_1DeveloperUserAlreadyRegisteredException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1DeveloperUserIdentifierList = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var deserializeAws_json1_1ExternalServiceException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1GetCredentialsForIdentityResponse = function (output, context) {
    return {
        Credentials: output.Credentials !== undefined && output.Credentials !== null
            ? deserializeAws_json1_1Credentials(output.Credentials, context)
            : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
    };
};
var deserializeAws_json1_1GetIdentityPoolRolesResponse = function (output, context) {
    return {
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        RoleMappings: output.RoleMappings !== undefined && output.RoleMappings !== null
            ? deserializeAws_json1_1RoleMappingMap(output.RoleMappings, context)
            : undefined,
        Roles: output.Roles !== undefined && output.Roles !== null
            ? deserializeAws_json1_1RolesMap(output.Roles, context)
            : undefined,
    };
};
var deserializeAws_json1_1GetIdResponse = function (output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
    };
};
var deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityResponse = function (output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        Token: output.Token !== undefined && output.Token !== null ? output.Token : undefined,
    };
};
var deserializeAws_json1_1GetOpenIdTokenResponse = function (output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        Token: output.Token !== undefined && output.Token !== null ? output.Token : undefined,
    };
};
var deserializeAws_json1_1IdentitiesList = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1IdentityDescription(entry, context);
    });
};
var deserializeAws_json1_1IdentityDescription = function (output, context) {
    return {
        CreationDate: output.CreationDate !== undefined && output.CreationDate !== null
            ? new Date(Math.round(output.CreationDate * 1000))
            : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        LastModifiedDate: output.LastModifiedDate !== undefined && output.LastModifiedDate !== null
            ? new Date(Math.round(output.LastModifiedDate * 1000))
            : undefined,
        Logins: output.Logins !== undefined && output.Logins !== null
            ? deserializeAws_json1_1LoginsList(output.Logins, context)
            : undefined,
    };
};
var deserializeAws_json1_1IdentityPool = function (output, context) {
    return {
        AllowClassicFlow: output.AllowClassicFlow !== undefined && output.AllowClassicFlow !== null ? output.AllowClassicFlow : undefined,
        AllowUnauthenticatedIdentities: output.AllowUnauthenticatedIdentities !== undefined && output.AllowUnauthenticatedIdentities !== null
            ? output.AllowUnauthenticatedIdentities
            : undefined,
        CognitoIdentityProviders: output.CognitoIdentityProviders !== undefined && output.CognitoIdentityProviders !== null
            ? deserializeAws_json1_1CognitoIdentityProviderList(output.CognitoIdentityProviders, context)
            : undefined,
        DeveloperProviderName: output.DeveloperProviderName !== undefined && output.DeveloperProviderName !== null
            ? output.DeveloperProviderName
            : undefined,
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        IdentityPoolName: output.IdentityPoolName !== undefined && output.IdentityPoolName !== null ? output.IdentityPoolName : undefined,
        IdentityPoolTags: output.IdentityPoolTags !== undefined && output.IdentityPoolTags !== null
            ? deserializeAws_json1_1IdentityPoolTagsType(output.IdentityPoolTags, context)
            : undefined,
        OpenIdConnectProviderARNs: output.OpenIdConnectProviderARNs !== undefined && output.OpenIdConnectProviderARNs !== null
            ? deserializeAws_json1_1OIDCProviderList(output.OpenIdConnectProviderARNs, context)
            : undefined,
        SamlProviderARNs: output.SamlProviderARNs !== undefined && output.SamlProviderARNs !== null
            ? deserializeAws_json1_1SAMLProviderList(output.SamlProviderARNs, context)
            : undefined,
        SupportedLoginProviders: output.SupportedLoginProviders !== undefined && output.SupportedLoginProviders !== null
            ? deserializeAws_json1_1IdentityProviders(output.SupportedLoginProviders, context)
            : undefined,
    };
};
var deserializeAws_json1_1IdentityPoolShortDescription = function (output, context) {
    return {
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        IdentityPoolName: output.IdentityPoolName !== undefined && output.IdentityPoolName !== null ? output.IdentityPoolName : undefined,
    };
};
var deserializeAws_json1_1IdentityPoolsList = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1IdentityPoolShortDescription(entry, context);
    });
};
var deserializeAws_json1_1IdentityPoolTagsType = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __read */])(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_json1_1IdentityProviders = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __read */])(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_json1_1InternalErrorException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1InvalidIdentityPoolConfigurationException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1InvalidParameterException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1LimitExceededException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1ListIdentitiesResponse = function (output, context) {
    return {
        Identities: output.Identities !== undefined && output.Identities !== null
            ? deserializeAws_json1_1IdentitiesList(output.Identities, context)
            : undefined,
        IdentityPoolId: output.IdentityPoolId !== undefined && output.IdentityPoolId !== null ? output.IdentityPoolId : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined,
    };
};
var deserializeAws_json1_1ListIdentityPoolsResponse = function (output, context) {
    return {
        IdentityPools: output.IdentityPools !== undefined && output.IdentityPools !== null
            ? deserializeAws_json1_1IdentityPoolsList(output.IdentityPools, context)
            : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined,
    };
};
var deserializeAws_json1_1ListTagsForResourceResponse = function (output, context) {
    return {
        Tags: output.Tags !== undefined && output.Tags !== null
            ? deserializeAws_json1_1IdentityPoolTagsType(output.Tags, context)
            : undefined,
    };
};
var deserializeAws_json1_1LoginsList = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var deserializeAws_json1_1LookupDeveloperIdentityResponse = function (output, context) {
    return {
        DeveloperUserIdentifierList: output.DeveloperUserIdentifierList !== undefined && output.DeveloperUserIdentifierList !== null
            ? deserializeAws_json1_1DeveloperUserIdentifierList(output.DeveloperUserIdentifierList, context)
            : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
        NextToken: output.NextToken !== undefined && output.NextToken !== null ? output.NextToken : undefined,
    };
};
var deserializeAws_json1_1MappingRule = function (output, context) {
    return {
        Claim: output.Claim !== undefined && output.Claim !== null ? output.Claim : undefined,
        MatchType: output.MatchType !== undefined && output.MatchType !== null ? output.MatchType : undefined,
        RoleARN: output.RoleARN !== undefined && output.RoleARN !== null ? output.RoleARN : undefined,
        Value: output.Value !== undefined && output.Value !== null ? output.Value : undefined,
    };
};
var deserializeAws_json1_1MappingRulesList = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1MappingRule(entry, context);
    });
};
var deserializeAws_json1_1MergeDeveloperIdentitiesResponse = function (output, context) {
    return {
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
    };
};
var deserializeAws_json1_1NotAuthorizedException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1OIDCProviderList = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var deserializeAws_json1_1ResourceConflictException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1ResourceNotFoundException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1RoleMapping = function (output, context) {
    return {
        AmbiguousRoleResolution: output.AmbiguousRoleResolution !== undefined && output.AmbiguousRoleResolution !== null
            ? output.AmbiguousRoleResolution
            : undefined,
        RulesConfiguration: output.RulesConfiguration !== undefined && output.RulesConfiguration !== null
            ? deserializeAws_json1_1RulesConfigurationType(output.RulesConfiguration, context)
            : undefined,
        Type: output.Type !== undefined && output.Type !== null ? output.Type : undefined,
    };
};
var deserializeAws_json1_1RoleMappingMap = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __read */])(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, acc), (_b = {}, _b[key] = deserializeAws_json1_1RoleMapping(value, context), _b));
    }, {});
};
var deserializeAws_json1_1RolesMap = function (output, context) {
    return Object.entries(output).reduce(function (acc, _a) {
        var _b;
        var _c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["e" /* __read */])(_a, 2), key = _c[0], value = _c[1];
        if (value === null) {
            return acc;
        }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, acc), (_b = {}, _b[key] = value, _b));
    }, {});
};
var deserializeAws_json1_1RulesConfigurationType = function (output, context) {
    return {
        Rules: output.Rules !== undefined && output.Rules !== null
            ? deserializeAws_json1_1MappingRulesList(output.Rules, context)
            : undefined,
    };
};
var deserializeAws_json1_1SAMLProviderList = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return entry;
    });
};
var deserializeAws_json1_1TagResourceResponse = function (output, context) {
    return {};
};
var deserializeAws_json1_1TooManyRequestsException = function (output, context) {
    return {
        message: output.message !== undefined && output.message !== null ? output.message : undefined,
    };
};
var deserializeAws_json1_1UnprocessedIdentityId = function (output, context) {
    return {
        ErrorCode: output.ErrorCode !== undefined && output.ErrorCode !== null ? output.ErrorCode : undefined,
        IdentityId: output.IdentityId !== undefined && output.IdentityId !== null ? output.IdentityId : undefined,
    };
};
var deserializeAws_json1_1UnprocessedIdentityIdList = function (output, context) {
    return (output || [])
        .filter(function (e) { return e != null; })
        .map(function (entry) {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1UnprocessedIdentityId(entry, context);
    });
};
var deserializeAws_json1_1UntagResourceResponse = function (output, context) {
    return {};
};
var deserializeMetadata = function (output) {
    var _a;
    return ({
        httpStatusCode: output.statusCode,
        requestId: (_a = output.headers["x-amzn-requestid"]) !== null && _a !== void 0 ? _a : output.headers["x-amzn-request-id"],
        extendedRequestId: output.headers["x-amz-id-2"],
        cfId: output.headers["x-amz-cf-id"],
    });
};
// Collect low-level response body stream to Uint8Array.
var collectBody = function (streamBody, context) {
    if (streamBody === void 0) { streamBody = new Uint8Array(); }
    if (streamBody instanceof Uint8Array) {
        return Promise.resolve(streamBody);
    }
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
// Encode Uint8Array data into string with utf-8.
var collectBodyString = function (streamBody, context) {
    return collectBody(streamBody, context).then(function (body) { return context.utf8Encoder(body); });
};
var buildHttpRpcRequest = function (context, headers, path, resolvedHostname, body) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
    var _a, hostname, _b, protocol, port, contents;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, context.endpoint()];
            case 1:
                _a = _c.sent(), hostname = _a.hostname, _b = _a.protocol, protocol = _b === void 0 ? "https" : _b, port = _a.port;
                contents = {
                    protocol: protocol,
                    hostname: hostname,
                    port: port,
                    method: "POST",
                    path: path,
                    headers: headers,
                };
                if (resolvedHostname !== undefined) {
                    contents.hostname = resolvedHostname;
                }
                if (body !== undefined) {
                    contents.body = body;
                }
                return [2 /*return*/, new __WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__["HttpRequest"](contents)];
        }
    });
}); };
var parseBody = function (streamBody, context) {
    return collectBodyString(streamBody, context).then(function (encoded) {
        if (encoded.length) {
            return JSON.parse(encoded);
        }
        return {};
    });
};
/**
 * Load an error code for the aws.rest-json-1.1 protocol.
 */
var loadRestJsonErrorCode = function (output, data) {
    var findKey = function (object, key) { return Object.keys(object).find(function (k) { return k.toLowerCase() === key.toLowerCase(); }); };
    var sanitizeErrorCode = function (rawValue) {
        var cleanValue = rawValue;
        if (cleanValue.indexOf(":") >= 0) {
            cleanValue = cleanValue.split(":")[0];
        }
        if (cleanValue.indexOf("#") >= 0) {
            cleanValue = cleanValue.split("#")[1];
        }
        return cleanValue;
    };
    var headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) {
        return sanitizeErrorCode(output.headers[headerKey]);
    }
    if (data.code !== undefined) {
        return sanitizeErrorCode(data.code);
    }
    if (data["__type"] !== undefined) {
        return sanitizeErrorCode(data["__type"]);
    }
    return "";
};
//# sourceMappingURL=Aws_json1_1.js.map

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(2598)
var ieee754 = __webpack_require__(3021)
var isArray = __webpack_require__(1246)

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Use Object implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * Due to various browser bugs, sometimes the Object implementation will be used even
 * when the browser supports typed arrays.
 *
 * Note:
 *
 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
 *
 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
 *
 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
 *     incorrect length in some situations.

 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
 * get the Object implementation, which is slower but behaves correctly.
 */
Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
  ? global.TYPED_ARRAY_SUPPORT
  : typedArraySupport()

/*
 * Export kMaxLength after typed array support is determined.
 */
exports.kMaxLength = kMaxLength()

function typedArraySupport () {
  try {
    var arr = new Uint8Array(1)
    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
    return arr.foo() === 42 && // typed array instances can be augmented
        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
  } catch (e) {
    return false
  }
}

function kMaxLength () {
  return Buffer.TYPED_ARRAY_SUPPORT
    ? 0x7fffffff
    : 0x3fffffff
}

function createBuffer (that, length) {
  if (kMaxLength() < length) {
    throw new RangeError('Invalid typed array length')
  }
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = new Uint8Array(length)
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    if (that === null) {
      that = new Buffer(length)
    }
    that.length = length
  }

  return that
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
    return new Buffer(arg, encodingOrOffset, length)
  }

  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new Error(
        'If encoding is specified then the first argument must be a string'
      )
    }
    return allocUnsafe(this, arg)
  }
  return from(this, arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

// TODO: Legacy, not needed anymore. Remove in next major version.
Buffer._augment = function (arr) {
  arr.__proto__ = Buffer.prototype
  return arr
}

function from (that, value, encodingOrOffset, length) {
  if (typeof value === 'number') {
    throw new TypeError('"value" argument must not be a number')
  }

  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
    return fromArrayBuffer(that, value, encodingOrOffset, length)
  }

  if (typeof value === 'string') {
    return fromString(that, value, encodingOrOffset)
  }

  return fromObject(that, value)
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(null, value, encodingOrOffset, length)
}

if (Buffer.TYPED_ARRAY_SUPPORT) {
  Buffer.prototype.__proto__ = Uint8Array.prototype
  Buffer.__proto__ = Uint8Array
  if (typeof Symbol !== 'undefined' && Symbol.species &&
      Buffer[Symbol.species] === Buffer) {
    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
    Object.defineProperty(Buffer, Symbol.species, {
      value: null,
      configurable: true
    })
  }
}

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be a number')
  } else if (size < 0) {
    throw new RangeError('"size" argument must not be negative')
  }
}

function alloc (that, size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(that, size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpretted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(that, size).fill(fill, encoding)
      : createBuffer(that, size).fill(fill)
  }
  return createBuffer(that, size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(null, size, fill, encoding)
}

function allocUnsafe (that, size) {
  assertSize(size)
  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) {
    for (var i = 0; i < size; ++i) {
      that[i] = 0
    }
  }
  return that
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(null, size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(null, size)
}

function fromString (that, string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('"encoding" must be a valid string encoding')
  }

  var length = byteLength(string, encoding) | 0
  that = createBuffer(that, length)

  var actual = that.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    that = that.slice(0, actual)
  }

  return that
}

function fromArrayLike (that, array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  that = createBuffer(that, length)
  for (var i = 0; i < length; i += 1) {
    that[i] = array[i] & 255
  }
  return that
}

function fromArrayBuffer (that, array, byteOffset, length) {
  array.byteLength // this throws if `array` is not a valid ArrayBuffer

  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('\'offset\' is out of bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('\'length\' is out of bounds')
  }

  if (byteOffset === undefined && length === undefined) {
    array = new Uint8Array(array)
  } else if (length === undefined) {
    array = new Uint8Array(array, byteOffset)
  } else {
    array = new Uint8Array(array, byteOffset, length)
  }

  if (Buffer.TYPED_ARRAY_SUPPORT) {
    // Return an augmented `Uint8Array` instance, for best performance
    that = array
    that.__proto__ = Buffer.prototype
  } else {
    // Fallback: Return an object instance of the Buffer class
    that = fromArrayLike(that, array)
  }
  return that
}

function fromObject (that, obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    that = createBuffer(that, len)

    if (that.length === 0) {
      return that
    }

    obj.copy(that, 0, 0, len)
    return that
  }

  if (obj) {
    if ((typeof ArrayBuffer !== 'undefined' &&
        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
      if (typeof obj.length !== 'number' || isnan(obj.length)) {
        return createBuffer(that, 0)
      }
      return fromArrayLike(that, obj)
    }

    if (obj.type === 'Buffer' && isArray(obj.data)) {
      return fromArrayLike(that, obj.data)
    }
  }

  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
}

function checked (length) {
  // Note: cannot use `length < kMaxLength()` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= kMaxLength()) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return !!(b != null && b._isBuffer)
}

Buffer.compare = function compare (a, b) {
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError('Arguments must be Buffers')
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    }
    buf.copy(buffer, pos)
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    string = '' + string
  }

  var len = string.length
  if (len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
      case undefined:
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) return utf8ToBytes(string).length // assume utf8
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
// Buffer instances.
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length | 0
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  if (this.length > 0) {
    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
    if (this.length > max) str += ' ... '
  }
  return '<Buffer ' + str + '>'
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (!Buffer.isBuffer(target)) {
    throw new TypeError('Argument must be a Buffer')
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset  // Coerce to Number.
  if (isNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (Buffer.TYPED_ARRAY_SUPPORT &&
        typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  // must be an even number of digits
  var strLen = string.length
  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (isNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function latin1Write (buf, string, offset, length) {
  return asciiWrite(buf, string, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset | 0
    if (isFinite(length)) {
      length = length | 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  // legacy write(string, encoding, offset, length) - remove in v0.13
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
        return asciiWrite(this, string, offset, length)

      case 'latin1':
      case 'binary':
        return latin1Write(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF) ? 4
      : (firstByte > 0xDF) ? 3
      : (firstByte > 0xBF) ? 2
      : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += toHex(buf[i])
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  for (var i = 0; i < bytes.length; i += 2) {
    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    newBuf = this.subarray(start, end)
    newBuf.__proto__ = Buffer.prototype
  } else {
    var sliceLen = end - start
    newBuf = new Buffer(sliceLen, undefined)
    for (var i = 0; i < sliceLen; ++i) {
      newBuf[i] = this[i + start]
    }
  }

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  byteLength = byteLength | 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  this[offset] = (value & 0xff)
  return offset + 1
}

function objectWriteUInt16 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
      (littleEndian ? i : 1 - i) * 8
  }
}

Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

function objectWriteUInt32 (buf, value, offset, littleEndian) {
  if (value < 0) value = 0xffffffff + value + 1
  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
  }
}

Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset + 3] = (value >>> 24)
    this[offset + 2] = (value >>> 16)
    this[offset + 1] = (value >>> 8)
    this[offset] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) {
    var limit = Math.pow(2, 8 * byteLength - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
  } else {
    objectWriteUInt16(this, value, offset, true)
  }
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 8)
    this[offset + 1] = (value & 0xff)
  } else {
    objectWriteUInt16(this, value, offset, false)
  }
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value & 0xff)
    this[offset + 1] = (value >>> 8)
    this[offset + 2] = (value >>> 16)
    this[offset + 3] = (value >>> 24)
  } else {
    objectWriteUInt32(this, value, offset, true)
  }
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset | 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  if (Buffer.TYPED_ARRAY_SUPPORT) {
    this[offset] = (value >>> 24)
    this[offset + 1] = (value >>> 16)
    this[offset + 2] = (value >>> 8)
    this[offset + 3] = (value & 0xff)
  } else {
    objectWriteUInt32(this, value, offset, false)
  }
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start
  var i

  if (this === target && start < targetStart && targetStart < end) {
    // descending copy from end
    for (i = len - 1; i >= 0; --i) {
      target[i + targetStart] = this[i + start]
    }
  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
    // ascending copy from start
    for (i = 0; i < len; ++i) {
      target[i + targetStart] = this[i + start]
    }
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, start + len),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if (code < 256) {
        val = code
      }
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
  } else if (typeof val === 'number') {
    val = val & 255
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : utf8ToBytes(new Buffer(val, encoding).toString())
    var len = bytes.length
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function stringtrim (str) {
  if (str.trim) return str.trim()
  return str.replace(/^\s+|\s+$/g, '')
}

function toHex (n) {
  if (n < 16) return '0' + n.toString(16)
  return n.toString(16)
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

function isnan (val) {
  return val !== val // eslint-disable-line no-self-compare
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseMap_js__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(69);





/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_2__baseMap_js__["a" /* default */];
  return func(collection, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(iteratee, 3));
}

/* harmony default export */ __webpack_exports__["a"] = (map);


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {(function (module, exports) {
  'use strict';

  // Utils
  function assert (val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
  }

  // Could use `inherits` module, but don't want to move from single file
  // architecture yet.
  function inherits (ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function () {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
  }

  // BN

  function BN (number, base, endian) {
    if (BN.isBN(number)) {
      return number;
    }

    this.negative = 0;
    this.words = null;
    this.length = 0;

    // Reduction context
    this.red = null;

    if (number !== null) {
      if (base === 'le' || base === 'be') {
        endian = base;
        base = 10;
      }

      this._init(number || 0, base || 10, endian || 'be');
    }
  }
  if (typeof module === 'object') {
    module.exports = BN;
  } else {
    exports.BN = BN;
  }

  BN.BN = BN;
  BN.wordSize = 26;

  var Buffer;
  try {
    if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') {
      Buffer = window.Buffer;
    } else {
      Buffer = __webpack_require__(3560).Buffer;
    }
  } catch (e) {
  }

  BN.isBN = function isBN (num) {
    if (num instanceof BN) {
      return true;
    }

    return num !== null && typeof num === 'object' &&
      num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
  };

  BN.max = function max (left, right) {
    if (left.cmp(right) > 0) return left;
    return right;
  };

  BN.min = function min (left, right) {
    if (left.cmp(right) < 0) return left;
    return right;
  };

  BN.prototype._init = function init (number, base, endian) {
    if (typeof number === 'number') {
      return this._initNumber(number, base, endian);
    }

    if (typeof number === 'object') {
      return this._initArray(number, base, endian);
    }

    if (base === 'hex') {
      base = 16;
    }
    assert(base === (base | 0) && base >= 2 && base <= 36);

    number = number.toString().replace(/\s+/g, '');
    var start = 0;
    if (number[0] === '-') {
      start++;
      this.negative = 1;
    }

    if (start < number.length) {
      if (base === 16) {
        this._parseHex(number, start, endian);
      } else {
        this._parseBase(number, base, start);
        if (endian === 'le') {
          this._initArray(this.toArray(), base, endian);
        }
      }
    }
  };

  BN.prototype._initNumber = function _initNumber (number, base, endian) {
    if (number < 0) {
      this.negative = 1;
      number = -number;
    }
    if (number < 0x4000000) {
      this.words = [ number & 0x3ffffff ];
      this.length = 1;
    } else if (number < 0x10000000000000) {
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff
      ];
      this.length = 2;
    } else {
      assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
      this.words = [
        number & 0x3ffffff,
        (number / 0x4000000) & 0x3ffffff,
        1
      ];
      this.length = 3;
    }

    if (endian !== 'le') return;

    // Reverse the bytes
    this._initArray(this.toArray(), base, endian);
  };

  BN.prototype._initArray = function _initArray (number, base, endian) {
    // Perhaps a Uint8Array
    assert(typeof number.length === 'number');
    if (number.length <= 0) {
      this.words = [ 0 ];
      this.length = 1;
      return this;
    }

    this.length = Math.ceil(number.length / 3);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    var j, w;
    var off = 0;
    if (endian === 'be') {
      for (i = number.length - 1, j = 0; i >= 0; i -= 3) {
        w = number[i] | (number[i - 1] << 8) | (number[i - 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    } else if (endian === 'le') {
      for (i = 0, j = 0; i < number.length; i += 3) {
        w = number[i] | (number[i + 1] << 8) | (number[i + 2] << 16);
        this.words[j] |= (w << off) & 0x3ffffff;
        this.words[j + 1] = (w >>> (26 - off)) & 0x3ffffff;
        off += 24;
        if (off >= 26) {
          off -= 26;
          j++;
        }
      }
    }
    return this.strip();
  };

  function parseHex4Bits (string, index) {
    var c = string.charCodeAt(index);
    // 'A' - 'F'
    if (c >= 65 && c <= 70) {
      return c - 55;
    // 'a' - 'f'
    } else if (c >= 97 && c <= 102) {
      return c - 87;
    // '0' - '9'
    } else {
      return (c - 48) & 0xf;
    }
  }

  function parseHexByte (string, lowerBound, index) {
    var r = parseHex4Bits(string, index);
    if (index - 1 >= lowerBound) {
      r |= parseHex4Bits(string, index - 1) << 4;
    }
    return r;
  }

  BN.prototype._parseHex = function _parseHex (number, start, endian) {
    // Create possibly bigger array to ensure that it fits the number
    this.length = Math.ceil((number.length - start) / 6);
    this.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      this.words[i] = 0;
    }

    // 24-bits chunks
    var off = 0;
    var j = 0;

    var w;
    if (endian === 'be') {
      for (i = number.length - 1; i >= start; i -= 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    } else {
      var parseLength = number.length - start;
      for (i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2) {
        w = parseHexByte(number, start, i) << off;
        this.words[j] |= w & 0x3ffffff;
        if (off >= 18) {
          off -= 18;
          j += 1;
          this.words[j] |= w >>> 26;
        } else {
          off += 8;
        }
      }
    }

    this.strip();
  };

  function parseBase (str, start, end, mul) {
    var r = 0;
    var len = Math.min(str.length, end);
    for (var i = start; i < len; i++) {
      var c = str.charCodeAt(i) - 48;

      r *= mul;

      // 'a'
      if (c >= 49) {
        r += c - 49 + 0xa;

      // 'A'
      } else if (c >= 17) {
        r += c - 17 + 0xa;

      // '0' - '9'
      } else {
        r += c;
      }
    }
    return r;
  }

  BN.prototype._parseBase = function _parseBase (number, base, start) {
    // Initialize as zero
    this.words = [ 0 ];
    this.length = 1;

    // Find length of limb in base
    for (var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base) {
      limbLen++;
    }
    limbLen--;
    limbPow = (limbPow / base) | 0;

    var total = number.length - start;
    var mod = total % limbLen;
    var end = Math.min(total, total - mod) + start;

    var word = 0;
    for (var i = start; i < end; i += limbLen) {
      word = parseBase(number, i, i + limbLen, base);

      this.imuln(limbPow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    if (mod !== 0) {
      var pow = 1;
      word = parseBase(number, i, number.length, base);

      for (i = 0; i < mod; i++) {
        pow *= base;
      }

      this.imuln(pow);
      if (this.words[0] + word < 0x4000000) {
        this.words[0] += word;
      } else {
        this._iaddn(word);
      }
    }

    this.strip();
  };

  BN.prototype.copy = function copy (dest) {
    dest.words = new Array(this.length);
    for (var i = 0; i < this.length; i++) {
      dest.words[i] = this.words[i];
    }
    dest.length = this.length;
    dest.negative = this.negative;
    dest.red = this.red;
  };

  BN.prototype.clone = function clone () {
    var r = new BN(null);
    this.copy(r);
    return r;
  };

  BN.prototype._expand = function _expand (size) {
    while (this.length < size) {
      this.words[this.length++] = 0;
    }
    return this;
  };

  // Remove leading `0` from `this`
  BN.prototype.strip = function strip () {
    while (this.length > 1 && this.words[this.length - 1] === 0) {
      this.length--;
    }
    return this._normSign();
  };

  BN.prototype._normSign = function _normSign () {
    // -0 = 0
    if (this.length === 1 && this.words[0] === 0) {
      this.negative = 0;
    }
    return this;
  };

  BN.prototype.inspect = function inspect () {
    return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
  };

  /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */

  var zeros = [
    '',
    '0',
    '00',
    '000',
    '0000',
    '00000',
    '000000',
    '0000000',
    '00000000',
    '000000000',
    '0000000000',
    '00000000000',
    '000000000000',
    '0000000000000',
    '00000000000000',
    '000000000000000',
    '0000000000000000',
    '00000000000000000',
    '000000000000000000',
    '0000000000000000000',
    '00000000000000000000',
    '000000000000000000000',
    '0000000000000000000000',
    '00000000000000000000000',
    '000000000000000000000000',
    '0000000000000000000000000'
  ];

  var groupSizes = [
    0, 0,
    25, 16, 12, 11, 10, 9, 8,
    8, 7, 7, 7, 7, 6, 6,
    6, 6, 6, 6, 6, 5, 5,
    5, 5, 5, 5, 5, 5, 5,
    5, 5, 5, 5, 5, 5, 5
  ];

  var groupBases = [
    0, 0,
    33554432, 43046721, 16777216, 48828125, 60466176, 40353607, 16777216,
    43046721, 10000000, 19487171, 35831808, 62748517, 7529536, 11390625,
    16777216, 24137569, 34012224, 47045881, 64000000, 4084101, 5153632,
    6436343, 7962624, 9765625, 11881376, 14348907, 17210368, 20511149,
    24300000, 28629151, 33554432, 39135393, 45435424, 52521875, 60466176
  ];

  BN.prototype.toString = function toString (base, padding) {
    base = base || 10;
    padding = padding | 0 || 1;

    var out;
    if (base === 16 || base === 'hex') {
      out = '';
      var off = 0;
      var carry = 0;
      for (var i = 0; i < this.length; i++) {
        var w = this.words[i];
        var word = (((w << off) | carry) & 0xffffff).toString(16);
        carry = (w >>> (24 - off)) & 0xffffff;
        off += 2;
        if (off >= 26) {
          off -= 26;
          i--;
        }
        if (carry !== 0 || i !== this.length - 1) {
          out = zeros[6 - word.length] + word + out;
        } else {
          out = word + out;
        }
      }
      if (carry !== 0) {
        out = carry.toString(16) + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    if (base === (base | 0) && base >= 2 && base <= 36) {
      // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
      var groupSize = groupSizes[base];
      // var groupBase = Math.pow(base, groupSize);
      var groupBase = groupBases[base];
      out = '';
      var c = this.clone();
      c.negative = 0;
      while (!c.isZero()) {
        var r = c.modn(groupBase).toString(base);
        c = c.idivn(groupBase);

        if (!c.isZero()) {
          out = zeros[groupSize - r.length] + r + out;
        } else {
          out = r + out;
        }
      }
      if (this.isZero()) {
        out = '0' + out;
      }
      while (out.length % padding !== 0) {
        out = '0' + out;
      }
      if (this.negative !== 0) {
        out = '-' + out;
      }
      return out;
    }

    assert(false, 'Base should be between 2 and 36');
  };

  BN.prototype.toNumber = function toNumber () {
    var ret = this.words[0];
    if (this.length === 2) {
      ret += this.words[1] * 0x4000000;
    } else if (this.length === 3 && this.words[2] === 0x01) {
      // NOTE: at this stage it is known that the top bit is set
      ret += 0x10000000000000 + (this.words[1] * 0x4000000);
    } else if (this.length > 2) {
      assert(false, 'Number can only safely store up to 53 bits');
    }
    return (this.negative !== 0) ? -ret : ret;
  };

  BN.prototype.toJSON = function toJSON () {
    return this.toString(16);
  };

  BN.prototype.toBuffer = function toBuffer (endian, length) {
    assert(typeof Buffer !== 'undefined');
    return this.toArrayLike(Buffer, endian, length);
  };

  BN.prototype.toArray = function toArray (endian, length) {
    return this.toArrayLike(Array, endian, length);
  };

  BN.prototype.toArrayLike = function toArrayLike (ArrayType, endian, length) {
    var byteLength = this.byteLength();
    var reqLength = length || Math.max(1, byteLength);
    assert(byteLength <= reqLength, 'byte array longer than desired length');
    assert(reqLength > 0, 'Requested array length <= 0');

    this.strip();
    var littleEndian = endian === 'le';
    var res = new ArrayType(reqLength);

    var b, i;
    var q = this.clone();
    if (!littleEndian) {
      // Assume big-endian
      for (i = 0; i < reqLength - byteLength; i++) {
        res[i] = 0;
      }

      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[reqLength - i - 1] = b;
      }
    } else {
      for (i = 0; !q.isZero(); i++) {
        b = q.andln(0xff);
        q.iushrn(8);

        res[i] = b;
      }

      for (; i < reqLength; i++) {
        res[i] = 0;
      }
    }

    return res;
  };

  if (Math.clz32) {
    BN.prototype._countBits = function _countBits (w) {
      return 32 - Math.clz32(w);
    };
  } else {
    BN.prototype._countBits = function _countBits (w) {
      var t = w;
      var r = 0;
      if (t >= 0x1000) {
        r += 13;
        t >>>= 13;
      }
      if (t >= 0x40) {
        r += 7;
        t >>>= 7;
      }
      if (t >= 0x8) {
        r += 4;
        t >>>= 4;
      }
      if (t >= 0x02) {
        r += 2;
        t >>>= 2;
      }
      return r + t;
    };
  }

  BN.prototype._zeroBits = function _zeroBits (w) {
    // Short-cut
    if (w === 0) return 26;

    var t = w;
    var r = 0;
    if ((t & 0x1fff) === 0) {
      r += 13;
      t >>>= 13;
    }
    if ((t & 0x7f) === 0) {
      r += 7;
      t >>>= 7;
    }
    if ((t & 0xf) === 0) {
      r += 4;
      t >>>= 4;
    }
    if ((t & 0x3) === 0) {
      r += 2;
      t >>>= 2;
    }
    if ((t & 0x1) === 0) {
      r++;
    }
    return r;
  };

  // Return number of used bits in a BN
  BN.prototype.bitLength = function bitLength () {
    var w = this.words[this.length - 1];
    var hi = this._countBits(w);
    return (this.length - 1) * 26 + hi;
  };

  function toBitArray (num) {
    var w = new Array(num.bitLength());

    for (var bit = 0; bit < w.length; bit++) {
      var off = (bit / 26) | 0;
      var wbit = bit % 26;

      w[bit] = (num.words[off] & (1 << wbit)) >>> wbit;
    }

    return w;
  }

  // Number of trailing zero bits
  BN.prototype.zeroBits = function zeroBits () {
    if (this.isZero()) return 0;

    var r = 0;
    for (var i = 0; i < this.length; i++) {
      var b = this._zeroBits(this.words[i]);
      r += b;
      if (b !== 26) break;
    }
    return r;
  };

  BN.prototype.byteLength = function byteLength () {
    return Math.ceil(this.bitLength() / 8);
  };

  BN.prototype.toTwos = function toTwos (width) {
    if (this.negative !== 0) {
      return this.abs().inotn(width).iaddn(1);
    }
    return this.clone();
  };

  BN.prototype.fromTwos = function fromTwos (width) {
    if (this.testn(width - 1)) {
      return this.notn(width).iaddn(1).ineg();
    }
    return this.clone();
  };

  BN.prototype.isNeg = function isNeg () {
    return this.negative !== 0;
  };

  // Return negative clone of `this`
  BN.prototype.neg = function neg () {
    return this.clone().ineg();
  };

  BN.prototype.ineg = function ineg () {
    if (!this.isZero()) {
      this.negative ^= 1;
    }

    return this;
  };

  // Or `num` with `this` in-place
  BN.prototype.iuor = function iuor (num) {
    while (this.length < num.length) {
      this.words[this.length++] = 0;
    }

    for (var i = 0; i < num.length; i++) {
      this.words[i] = this.words[i] | num.words[i];
    }

    return this.strip();
  };

  BN.prototype.ior = function ior (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuor(num);
  };

  // Or `num` with `this`
  BN.prototype.or = function or (num) {
    if (this.length > num.length) return this.clone().ior(num);
    return num.clone().ior(this);
  };

  BN.prototype.uor = function uor (num) {
    if (this.length > num.length) return this.clone().iuor(num);
    return num.clone().iuor(this);
  };

  // And `num` with `this` in-place
  BN.prototype.iuand = function iuand (num) {
    // b = min-length(num, this)
    var b;
    if (this.length > num.length) {
      b = num;
    } else {
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = this.words[i] & num.words[i];
    }

    this.length = b.length;

    return this.strip();
  };

  BN.prototype.iand = function iand (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuand(num);
  };

  // And `num` with `this`
  BN.prototype.and = function and (num) {
    if (this.length > num.length) return this.clone().iand(num);
    return num.clone().iand(this);
  };

  BN.prototype.uand = function uand (num) {
    if (this.length > num.length) return this.clone().iuand(num);
    return num.clone().iuand(this);
  };

  // Xor `num` with `this` in-place
  BN.prototype.iuxor = function iuxor (num) {
    // a.length > b.length
    var a;
    var b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    for (var i = 0; i < b.length; i++) {
      this.words[i] = a.words[i] ^ b.words[i];
    }

    if (this !== a) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = a.length;

    return this.strip();
  };

  BN.prototype.ixor = function ixor (num) {
    assert((this.negative | num.negative) === 0);
    return this.iuxor(num);
  };

  // Xor `num` with `this`
  BN.prototype.xor = function xor (num) {
    if (this.length > num.length) return this.clone().ixor(num);
    return num.clone().ixor(this);
  };

  BN.prototype.uxor = function uxor (num) {
    if (this.length > num.length) return this.clone().iuxor(num);
    return num.clone().iuxor(this);
  };

  // Not ``this`` with ``width`` bitwidth
  BN.prototype.inotn = function inotn (width) {
    assert(typeof width === 'number' && width >= 0);

    var bytesNeeded = Math.ceil(width / 26) | 0;
    var bitsLeft = width % 26;

    // Extend the buffer with leading zeroes
    this._expand(bytesNeeded);

    if (bitsLeft > 0) {
      bytesNeeded--;
    }

    // Handle complete words
    for (var i = 0; i < bytesNeeded; i++) {
      this.words[i] = ~this.words[i] & 0x3ffffff;
    }

    // Handle the residue
    if (bitsLeft > 0) {
      this.words[i] = ~this.words[i] & (0x3ffffff >> (26 - bitsLeft));
    }

    // And remove leading zeroes
    return this.strip();
  };

  BN.prototype.notn = function notn (width) {
    return this.clone().inotn(width);
  };

  // Set `bit` of `this`
  BN.prototype.setn = function setn (bit, val) {
    assert(typeof bit === 'number' && bit >= 0);

    var off = (bit / 26) | 0;
    var wbit = bit % 26;

    this._expand(off + 1);

    if (val) {
      this.words[off] = this.words[off] | (1 << wbit);
    } else {
      this.words[off] = this.words[off] & ~(1 << wbit);
    }

    return this.strip();
  };

  // Add `num` to `this` in-place
  BN.prototype.iadd = function iadd (num) {
    var r;

    // negative + positive
    if (this.negative !== 0 && num.negative === 0) {
      this.negative = 0;
      r = this.isub(num);
      this.negative ^= 1;
      return this._normSign();

    // positive + negative
    } else if (this.negative === 0 && num.negative !== 0) {
      num.negative = 0;
      r = this.isub(num);
      num.negative = 1;
      return r._normSign();
    }

    // a.length > b.length
    var a, b;
    if (this.length > num.length) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      this.words[i] = r & 0x3ffffff;
      carry = r >>> 26;
    }

    this.length = a.length;
    if (carry !== 0) {
      this.words[this.length] = carry;
      this.length++;
    // Copy the rest of the words
    } else if (a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    return this;
  };

  // Add `num` to `this`
  BN.prototype.add = function add (num) {
    var res;
    if (num.negative !== 0 && this.negative === 0) {
      num.negative = 0;
      res = this.sub(num);
      num.negative ^= 1;
      return res;
    } else if (num.negative === 0 && this.negative !== 0) {
      this.negative = 0;
      res = num.sub(this);
      this.negative = 1;
      return res;
    }

    if (this.length > num.length) return this.clone().iadd(num);

    return num.clone().iadd(this);
  };

  // Subtract `num` from `this` in-place
  BN.prototype.isub = function isub (num) {
    // this - (-num) = this + num
    if (num.negative !== 0) {
      num.negative = 0;
      var r = this.iadd(num);
      num.negative = 1;
      return r._normSign();

    // -this - num = -(this + num)
    } else if (this.negative !== 0) {
      this.negative = 0;
      this.iadd(num);
      this.negative = 1;
      return this._normSign();
    }

    // At this point both numbers are positive
    var cmp = this.cmp(num);

    // Optimization - zeroify
    if (cmp === 0) {
      this.negative = 0;
      this.length = 1;
      this.words[0] = 0;
      return this;
    }

    // a > b
    var a, b;
    if (cmp > 0) {
      a = this;
      b = num;
    } else {
      a = num;
      b = this;
    }

    var carry = 0;
    for (var i = 0; i < b.length; i++) {
      r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }
    for (; carry !== 0 && i < a.length; i++) {
      r = (a.words[i] | 0) + carry;
      carry = r >> 26;
      this.words[i] = r & 0x3ffffff;
    }

    // Copy rest of the words
    if (carry === 0 && i < a.length && a !== this) {
      for (; i < a.length; i++) {
        this.words[i] = a.words[i];
      }
    }

    this.length = Math.max(this.length, i);

    if (a !== this) {
      this.negative = 1;
    }

    return this.strip();
  };

  // Subtract `num` from `this`
  BN.prototype.sub = function sub (num) {
    return this.clone().isub(num);
  };

  function smallMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    var len = (self.length + num.length) | 0;
    out.length = len;
    len = (len - 1) | 0;

    // Peel one iteration (compiler can't do it, because of code complexity)
    var a = self.words[0] | 0;
    var b = num.words[0] | 0;
    var r = a * b;

    var lo = r & 0x3ffffff;
    var carry = (r / 0x4000000) | 0;
    out.words[0] = lo;

    for (var k = 1; k < len; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = carry >>> 26;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = (k - j) | 0;
        a = self.words[i] | 0;
        b = num.words[j] | 0;
        r = a * b + rword;
        ncarry += (r / 0x4000000) | 0;
        rword = r & 0x3ffffff;
      }
      out.words[k] = rword | 0;
      carry = ncarry | 0;
    }
    if (carry !== 0) {
      out.words[k] = carry | 0;
    } else {
      out.length--;
    }

    return out.strip();
  }

  // TODO(indutny): it may be reasonable to omit it for users who don't need
  // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
  // multiplication (like elliptic secp256k1).
  var comb10MulTo = function comb10MulTo (self, num, out) {
    var a = self.words;
    var b = num.words;
    var o = out.words;
    var c = 0;
    var lo;
    var mid;
    var hi;
    var a0 = a[0] | 0;
    var al0 = a0 & 0x1fff;
    var ah0 = a0 >>> 13;
    var a1 = a[1] | 0;
    var al1 = a1 & 0x1fff;
    var ah1 = a1 >>> 13;
    var a2 = a[2] | 0;
    var al2 = a2 & 0x1fff;
    var ah2 = a2 >>> 13;
    var a3 = a[3] | 0;
    var al3 = a3 & 0x1fff;
    var ah3 = a3 >>> 13;
    var a4 = a[4] | 0;
    var al4 = a4 & 0x1fff;
    var ah4 = a4 >>> 13;
    var a5 = a[5] | 0;
    var al5 = a5 & 0x1fff;
    var ah5 = a5 >>> 13;
    var a6 = a[6] | 0;
    var al6 = a6 & 0x1fff;
    var ah6 = a6 >>> 13;
    var a7 = a[7] | 0;
    var al7 = a7 & 0x1fff;
    var ah7 = a7 >>> 13;
    var a8 = a[8] | 0;
    var al8 = a8 & 0x1fff;
    var ah8 = a8 >>> 13;
    var a9 = a[9] | 0;
    var al9 = a9 & 0x1fff;
    var ah9 = a9 >>> 13;
    var b0 = b[0] | 0;
    var bl0 = b0 & 0x1fff;
    var bh0 = b0 >>> 13;
    var b1 = b[1] | 0;
    var bl1 = b1 & 0x1fff;
    var bh1 = b1 >>> 13;
    var b2 = b[2] | 0;
    var bl2 = b2 & 0x1fff;
    var bh2 = b2 >>> 13;
    var b3 = b[3] | 0;
    var bl3 = b3 & 0x1fff;
    var bh3 = b3 >>> 13;
    var b4 = b[4] | 0;
    var bl4 = b4 & 0x1fff;
    var bh4 = b4 >>> 13;
    var b5 = b[5] | 0;
    var bl5 = b5 & 0x1fff;
    var bh5 = b5 >>> 13;
    var b6 = b[6] | 0;
    var bl6 = b6 & 0x1fff;
    var bh6 = b6 >>> 13;
    var b7 = b[7] | 0;
    var bl7 = b7 & 0x1fff;
    var bh7 = b7 >>> 13;
    var b8 = b[8] | 0;
    var bl8 = b8 & 0x1fff;
    var bh8 = b8 >>> 13;
    var b9 = b[9] | 0;
    var bl9 = b9 & 0x1fff;
    var bh9 = b9 >>> 13;

    out.negative = self.negative ^ num.negative;
    out.length = 19;
    /* k = 0 */
    lo = Math.imul(al0, bl0);
    mid = Math.imul(al0, bh0);
    mid = (mid + Math.imul(ah0, bl0)) | 0;
    hi = Math.imul(ah0, bh0);
    var w0 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w0 >>> 26)) | 0;
    w0 &= 0x3ffffff;
    /* k = 1 */
    lo = Math.imul(al1, bl0);
    mid = Math.imul(al1, bh0);
    mid = (mid + Math.imul(ah1, bl0)) | 0;
    hi = Math.imul(ah1, bh0);
    lo = (lo + Math.imul(al0, bl1)) | 0;
    mid = (mid + Math.imul(al0, bh1)) | 0;
    mid = (mid + Math.imul(ah0, bl1)) | 0;
    hi = (hi + Math.imul(ah0, bh1)) | 0;
    var w1 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w1 >>> 26)) | 0;
    w1 &= 0x3ffffff;
    /* k = 2 */
    lo = Math.imul(al2, bl0);
    mid = Math.imul(al2, bh0);
    mid = (mid + Math.imul(ah2, bl0)) | 0;
    hi = Math.imul(ah2, bh0);
    lo = (lo + Math.imul(al1, bl1)) | 0;
    mid = (mid + Math.imul(al1, bh1)) | 0;
    mid = (mid + Math.imul(ah1, bl1)) | 0;
    hi = (hi + Math.imul(ah1, bh1)) | 0;
    lo = (lo + Math.imul(al0, bl2)) | 0;
    mid = (mid + Math.imul(al0, bh2)) | 0;
    mid = (mid + Math.imul(ah0, bl2)) | 0;
    hi = (hi + Math.imul(ah0, bh2)) | 0;
    var w2 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w2 >>> 26)) | 0;
    w2 &= 0x3ffffff;
    /* k = 3 */
    lo = Math.imul(al3, bl0);
    mid = Math.imul(al3, bh0);
    mid = (mid + Math.imul(ah3, bl0)) | 0;
    hi = Math.imul(ah3, bh0);
    lo = (lo + Math.imul(al2, bl1)) | 0;
    mid = (mid + Math.imul(al2, bh1)) | 0;
    mid = (mid + Math.imul(ah2, bl1)) | 0;
    hi = (hi + Math.imul(ah2, bh1)) | 0;
    lo = (lo + Math.imul(al1, bl2)) | 0;
    mid = (mid + Math.imul(al1, bh2)) | 0;
    mid = (mid + Math.imul(ah1, bl2)) | 0;
    hi = (hi + Math.imul(ah1, bh2)) | 0;
    lo = (lo + Math.imul(al0, bl3)) | 0;
    mid = (mid + Math.imul(al0, bh3)) | 0;
    mid = (mid + Math.imul(ah0, bl3)) | 0;
    hi = (hi + Math.imul(ah0, bh3)) | 0;
    var w3 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w3 >>> 26)) | 0;
    w3 &= 0x3ffffff;
    /* k = 4 */
    lo = Math.imul(al4, bl0);
    mid = Math.imul(al4, bh0);
    mid = (mid + Math.imul(ah4, bl0)) | 0;
    hi = Math.imul(ah4, bh0);
    lo = (lo + Math.imul(al3, bl1)) | 0;
    mid = (mid + Math.imul(al3, bh1)) | 0;
    mid = (mid + Math.imul(ah3, bl1)) | 0;
    hi = (hi + Math.imul(ah3, bh1)) | 0;
    lo = (lo + Math.imul(al2, bl2)) | 0;
    mid = (mid + Math.imul(al2, bh2)) | 0;
    mid = (mid + Math.imul(ah2, bl2)) | 0;
    hi = (hi + Math.imul(ah2, bh2)) | 0;
    lo = (lo + Math.imul(al1, bl3)) | 0;
    mid = (mid + Math.imul(al1, bh3)) | 0;
    mid = (mid + Math.imul(ah1, bl3)) | 0;
    hi = (hi + Math.imul(ah1, bh3)) | 0;
    lo = (lo + Math.imul(al0, bl4)) | 0;
    mid = (mid + Math.imul(al0, bh4)) | 0;
    mid = (mid + Math.imul(ah0, bl4)) | 0;
    hi = (hi + Math.imul(ah0, bh4)) | 0;
    var w4 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w4 >>> 26)) | 0;
    w4 &= 0x3ffffff;
    /* k = 5 */
    lo = Math.imul(al5, bl0);
    mid = Math.imul(al5, bh0);
    mid = (mid + Math.imul(ah5, bl0)) | 0;
    hi = Math.imul(ah5, bh0);
    lo = (lo + Math.imul(al4, bl1)) | 0;
    mid = (mid + Math.imul(al4, bh1)) | 0;
    mid = (mid + Math.imul(ah4, bl1)) | 0;
    hi = (hi + Math.imul(ah4, bh1)) | 0;
    lo = (lo + Math.imul(al3, bl2)) | 0;
    mid = (mid + Math.imul(al3, bh2)) | 0;
    mid = (mid + Math.imul(ah3, bl2)) | 0;
    hi = (hi + Math.imul(ah3, bh2)) | 0;
    lo = (lo + Math.imul(al2, bl3)) | 0;
    mid = (mid + Math.imul(al2, bh3)) | 0;
    mid = (mid + Math.imul(ah2, bl3)) | 0;
    hi = (hi + Math.imul(ah2, bh3)) | 0;
    lo = (lo + Math.imul(al1, bl4)) | 0;
    mid = (mid + Math.imul(al1, bh4)) | 0;
    mid = (mid + Math.imul(ah1, bl4)) | 0;
    hi = (hi + Math.imul(ah1, bh4)) | 0;
    lo = (lo + Math.imul(al0, bl5)) | 0;
    mid = (mid + Math.imul(al0, bh5)) | 0;
    mid = (mid + Math.imul(ah0, bl5)) | 0;
    hi = (hi + Math.imul(ah0, bh5)) | 0;
    var w5 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w5 >>> 26)) | 0;
    w5 &= 0x3ffffff;
    /* k = 6 */
    lo = Math.imul(al6, bl0);
    mid = Math.imul(al6, bh0);
    mid = (mid + Math.imul(ah6, bl0)) | 0;
    hi = Math.imul(ah6, bh0);
    lo = (lo + Math.imul(al5, bl1)) | 0;
    mid = (mid + Math.imul(al5, bh1)) | 0;
    mid = (mid + Math.imul(ah5, bl1)) | 0;
    hi = (hi + Math.imul(ah5, bh1)) | 0;
    lo = (lo + Math.imul(al4, bl2)) | 0;
    mid = (mid + Math.imul(al4, bh2)) | 0;
    mid = (mid + Math.imul(ah4, bl2)) | 0;
    hi = (hi + Math.imul(ah4, bh2)) | 0;
    lo = (lo + Math.imul(al3, bl3)) | 0;
    mid = (mid + Math.imul(al3, bh3)) | 0;
    mid = (mid + Math.imul(ah3, bl3)) | 0;
    hi = (hi + Math.imul(ah3, bh3)) | 0;
    lo = (lo + Math.imul(al2, bl4)) | 0;
    mid = (mid + Math.imul(al2, bh4)) | 0;
    mid = (mid + Math.imul(ah2, bl4)) | 0;
    hi = (hi + Math.imul(ah2, bh4)) | 0;
    lo = (lo + Math.imul(al1, bl5)) | 0;
    mid = (mid + Math.imul(al1, bh5)) | 0;
    mid = (mid + Math.imul(ah1, bl5)) | 0;
    hi = (hi + Math.imul(ah1, bh5)) | 0;
    lo = (lo + Math.imul(al0, bl6)) | 0;
    mid = (mid + Math.imul(al0, bh6)) | 0;
    mid = (mid + Math.imul(ah0, bl6)) | 0;
    hi = (hi + Math.imul(ah0, bh6)) | 0;
    var w6 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w6 >>> 26)) | 0;
    w6 &= 0x3ffffff;
    /* k = 7 */
    lo = Math.imul(al7, bl0);
    mid = Math.imul(al7, bh0);
    mid = (mid + Math.imul(ah7, bl0)) | 0;
    hi = Math.imul(ah7, bh0);
    lo = (lo + Math.imul(al6, bl1)) | 0;
    mid = (mid + Math.imul(al6, bh1)) | 0;
    mid = (mid + Math.imul(ah6, bl1)) | 0;
    hi = (hi + Math.imul(ah6, bh1)) | 0;
    lo = (lo + Math.imul(al5, bl2)) | 0;
    mid = (mid + Math.imul(al5, bh2)) | 0;
    mid = (mid + Math.imul(ah5, bl2)) | 0;
    hi = (hi + Math.imul(ah5, bh2)) | 0;
    lo = (lo + Math.imul(al4, bl3)) | 0;
    mid = (mid + Math.imul(al4, bh3)) | 0;
    mid = (mid + Math.imul(ah4, bl3)) | 0;
    hi = (hi + Math.imul(ah4, bh3)) | 0;
    lo = (lo + Math.imul(al3, bl4)) | 0;
    mid = (mid + Math.imul(al3, bh4)) | 0;
    mid = (mid + Math.imul(ah3, bl4)) | 0;
    hi = (hi + Math.imul(ah3, bh4)) | 0;
    lo = (lo + Math.imul(al2, bl5)) | 0;
    mid = (mid + Math.imul(al2, bh5)) | 0;
    mid = (mid + Math.imul(ah2, bl5)) | 0;
    hi = (hi + Math.imul(ah2, bh5)) | 0;
    lo = (lo + Math.imul(al1, bl6)) | 0;
    mid = (mid + Math.imul(al1, bh6)) | 0;
    mid = (mid + Math.imul(ah1, bl6)) | 0;
    hi = (hi + Math.imul(ah1, bh6)) | 0;
    lo = (lo + Math.imul(al0, bl7)) | 0;
    mid = (mid + Math.imul(al0, bh7)) | 0;
    mid = (mid + Math.imul(ah0, bl7)) | 0;
    hi = (hi + Math.imul(ah0, bh7)) | 0;
    var w7 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w7 >>> 26)) | 0;
    w7 &= 0x3ffffff;
    /* k = 8 */
    lo = Math.imul(al8, bl0);
    mid = Math.imul(al8, bh0);
    mid = (mid + Math.imul(ah8, bl0)) | 0;
    hi = Math.imul(ah8, bh0);
    lo = (lo + Math.imul(al7, bl1)) | 0;
    mid = (mid + Math.imul(al7, bh1)) | 0;
    mid = (mid + Math.imul(ah7, bl1)) | 0;
    hi = (hi + Math.imul(ah7, bh1)) | 0;
    lo = (lo + Math.imul(al6, bl2)) | 0;
    mid = (mid + Math.imul(al6, bh2)) | 0;
    mid = (mid + Math.imul(ah6, bl2)) | 0;
    hi = (hi + Math.imul(ah6, bh2)) | 0;
    lo = (lo + Math.imul(al5, bl3)) | 0;
    mid = (mid + Math.imul(al5, bh3)) | 0;
    mid = (mid + Math.imul(ah5, bl3)) | 0;
    hi = (hi + Math.imul(ah5, bh3)) | 0;
    lo = (lo + Math.imul(al4, bl4)) | 0;
    mid = (mid + Math.imul(al4, bh4)) | 0;
    mid = (mid + Math.imul(ah4, bl4)) | 0;
    hi = (hi + Math.imul(ah4, bh4)) | 0;
    lo = (lo + Math.imul(al3, bl5)) | 0;
    mid = (mid + Math.imul(al3, bh5)) | 0;
    mid = (mid + Math.imul(ah3, bl5)) | 0;
    hi = (hi + Math.imul(ah3, bh5)) | 0;
    lo = (lo + Math.imul(al2, bl6)) | 0;
    mid = (mid + Math.imul(al2, bh6)) | 0;
    mid = (mid + Math.imul(ah2, bl6)) | 0;
    hi = (hi + Math.imul(ah2, bh6)) | 0;
    lo = (lo + Math.imul(al1, bl7)) | 0;
    mid = (mid + Math.imul(al1, bh7)) | 0;
    mid = (mid + Math.imul(ah1, bl7)) | 0;
    hi = (hi + Math.imul(ah1, bh7)) | 0;
    lo = (lo + Math.imul(al0, bl8)) | 0;
    mid = (mid + Math.imul(al0, bh8)) | 0;
    mid = (mid + Math.imul(ah0, bl8)) | 0;
    hi = (hi + Math.imul(ah0, bh8)) | 0;
    var w8 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w8 >>> 26)) | 0;
    w8 &= 0x3ffffff;
    /* k = 9 */
    lo = Math.imul(al9, bl0);
    mid = Math.imul(al9, bh0);
    mid = (mid + Math.imul(ah9, bl0)) | 0;
    hi = Math.imul(ah9, bh0);
    lo = (lo + Math.imul(al8, bl1)) | 0;
    mid = (mid + Math.imul(al8, bh1)) | 0;
    mid = (mid + Math.imul(ah8, bl1)) | 0;
    hi = (hi + Math.imul(ah8, bh1)) | 0;
    lo = (lo + Math.imul(al7, bl2)) | 0;
    mid = (mid + Math.imul(al7, bh2)) | 0;
    mid = (mid + Math.imul(ah7, bl2)) | 0;
    hi = (hi + Math.imul(ah7, bh2)) | 0;
    lo = (lo + Math.imul(al6, bl3)) | 0;
    mid = (mid + Math.imul(al6, bh3)) | 0;
    mid = (mid + Math.imul(ah6, bl3)) | 0;
    hi = (hi + Math.imul(ah6, bh3)) | 0;
    lo = (lo + Math.imul(al5, bl4)) | 0;
    mid = (mid + Math.imul(al5, bh4)) | 0;
    mid = (mid + Math.imul(ah5, bl4)) | 0;
    hi = (hi + Math.imul(ah5, bh4)) | 0;
    lo = (lo + Math.imul(al4, bl5)) | 0;
    mid = (mid + Math.imul(al4, bh5)) | 0;
    mid = (mid + Math.imul(ah4, bl5)) | 0;
    hi = (hi + Math.imul(ah4, bh5)) | 0;
    lo = (lo + Math.imul(al3, bl6)) | 0;
    mid = (mid + Math.imul(al3, bh6)) | 0;
    mid = (mid + Math.imul(ah3, bl6)) | 0;
    hi = (hi + Math.imul(ah3, bh6)) | 0;
    lo = (lo + Math.imul(al2, bl7)) | 0;
    mid = (mid + Math.imul(al2, bh7)) | 0;
    mid = (mid + Math.imul(ah2, bl7)) | 0;
    hi = (hi + Math.imul(ah2, bh7)) | 0;
    lo = (lo + Math.imul(al1, bl8)) | 0;
    mid = (mid + Math.imul(al1, bh8)) | 0;
    mid = (mid + Math.imul(ah1, bl8)) | 0;
    hi = (hi + Math.imul(ah1, bh8)) | 0;
    lo = (lo + Math.imul(al0, bl9)) | 0;
    mid = (mid + Math.imul(al0, bh9)) | 0;
    mid = (mid + Math.imul(ah0, bl9)) | 0;
    hi = (hi + Math.imul(ah0, bh9)) | 0;
    var w9 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w9 >>> 26)) | 0;
    w9 &= 0x3ffffff;
    /* k = 10 */
    lo = Math.imul(al9, bl1);
    mid = Math.imul(al9, bh1);
    mid = (mid + Math.imul(ah9, bl1)) | 0;
    hi = Math.imul(ah9, bh1);
    lo = (lo + Math.imul(al8, bl2)) | 0;
    mid = (mid + Math.imul(al8, bh2)) | 0;
    mid = (mid + Math.imul(ah8, bl2)) | 0;
    hi = (hi + Math.imul(ah8, bh2)) | 0;
    lo = (lo + Math.imul(al7, bl3)) | 0;
    mid = (mid + Math.imul(al7, bh3)) | 0;
    mid = (mid + Math.imul(ah7, bl3)) | 0;
    hi = (hi + Math.imul(ah7, bh3)) | 0;
    lo = (lo + Math.imul(al6, bl4)) | 0;
    mid = (mid + Math.imul(al6, bh4)) | 0;
    mid = (mid + Math.imul(ah6, bl4)) | 0;
    hi = (hi + Math.imul(ah6, bh4)) | 0;
    lo = (lo + Math.imul(al5, bl5)) | 0;
    mid = (mid + Math.imul(al5, bh5)) | 0;
    mid = (mid + Math.imul(ah5, bl5)) | 0;
    hi = (hi + Math.imul(ah5, bh5)) | 0;
    lo = (lo + Math.imul(al4, bl6)) | 0;
    mid = (mid + Math.imul(al4, bh6)) | 0;
    mid = (mid + Math.imul(ah4, bl6)) | 0;
    hi = (hi + Math.imul(ah4, bh6)) | 0;
    lo = (lo + Math.imul(al3, bl7)) | 0;
    mid = (mid + Math.imul(al3, bh7)) | 0;
    mid = (mid + Math.imul(ah3, bl7)) | 0;
    hi = (hi + Math.imul(ah3, bh7)) | 0;
    lo = (lo + Math.imul(al2, bl8)) | 0;
    mid = (mid + Math.imul(al2, bh8)) | 0;
    mid = (mid + Math.imul(ah2, bl8)) | 0;
    hi = (hi + Math.imul(ah2, bh8)) | 0;
    lo = (lo + Math.imul(al1, bl9)) | 0;
    mid = (mid + Math.imul(al1, bh9)) | 0;
    mid = (mid + Math.imul(ah1, bl9)) | 0;
    hi = (hi + Math.imul(ah1, bh9)) | 0;
    var w10 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w10 >>> 26)) | 0;
    w10 &= 0x3ffffff;
    /* k = 11 */
    lo = Math.imul(al9, bl2);
    mid = Math.imul(al9, bh2);
    mid = (mid + Math.imul(ah9, bl2)) | 0;
    hi = Math.imul(ah9, bh2);
    lo = (lo + Math.imul(al8, bl3)) | 0;
    mid = (mid + Math.imul(al8, bh3)) | 0;
    mid = (mid + Math.imul(ah8, bl3)) | 0;
    hi = (hi + Math.imul(ah8, bh3)) | 0;
    lo = (lo + Math.imul(al7, bl4)) | 0;
    mid = (mid + Math.imul(al7, bh4)) | 0;
    mid = (mid + Math.imul(ah7, bl4)) | 0;
    hi = (hi + Math.imul(ah7, bh4)) | 0;
    lo = (lo + Math.imul(al6, bl5)) | 0;
    mid = (mid + Math.imul(al6, bh5)) | 0;
    mid = (mid + Math.imul(ah6, bl5)) | 0;
    hi = (hi + Math.imul(ah6, bh5)) | 0;
    lo = (lo + Math.imul(al5, bl6)) | 0;
    mid = (mid + Math.imul(al5, bh6)) | 0;
    mid = (mid + Math.imul(ah5, bl6)) | 0;
    hi = (hi + Math.imul(ah5, bh6)) | 0;
    lo = (lo + Math.imul(al4, bl7)) | 0;
    mid = (mid + Math.imul(al4, bh7)) | 0;
    mid = (mid + Math.imul(ah4, bl7)) | 0;
    hi = (hi + Math.imul(ah4, bh7)) | 0;
    lo = (lo + Math.imul(al3, bl8)) | 0;
    mid = (mid + Math.imul(al3, bh8)) | 0;
    mid = (mid + Math.imul(ah3, bl8)) | 0;
    hi = (hi + Math.imul(ah3, bh8)) | 0;
    lo = (lo + Math.imul(al2, bl9)) | 0;
    mid = (mid + Math.imul(al2, bh9)) | 0;
    mid = (mid + Math.imul(ah2, bl9)) | 0;
    hi = (hi + Math.imul(ah2, bh9)) | 0;
    var w11 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w11 >>> 26)) | 0;
    w11 &= 0x3ffffff;
    /* k = 12 */
    lo = Math.imul(al9, bl3);
    mid = Math.imul(al9, bh3);
    mid = (mid + Math.imul(ah9, bl3)) | 0;
    hi = Math.imul(ah9, bh3);
    lo = (lo + Math.imul(al8, bl4)) | 0;
    mid = (mid + Math.imul(al8, bh4)) | 0;
    mid = (mid + Math.imul(ah8, bl4)) | 0;
    hi = (hi + Math.imul(ah8, bh4)) | 0;
    lo = (lo + Math.imul(al7, bl5)) | 0;
    mid = (mid + Math.imul(al7, bh5)) | 0;
    mid = (mid + Math.imul(ah7, bl5)) | 0;
    hi = (hi + Math.imul(ah7, bh5)) | 0;
    lo = (lo + Math.imul(al6, bl6)) | 0;
    mid = (mid + Math.imul(al6, bh6)) | 0;
    mid = (mid + Math.imul(ah6, bl6)) | 0;
    hi = (hi + Math.imul(ah6, bh6)) | 0;
    lo = (lo + Math.imul(al5, bl7)) | 0;
    mid = (mid + Math.imul(al5, bh7)) | 0;
    mid = (mid + Math.imul(ah5, bl7)) | 0;
    hi = (hi + Math.imul(ah5, bh7)) | 0;
    lo = (lo + Math.imul(al4, bl8)) | 0;
    mid = (mid + Math.imul(al4, bh8)) | 0;
    mid = (mid + Math.imul(ah4, bl8)) | 0;
    hi = (hi + Math.imul(ah4, bh8)) | 0;
    lo = (lo + Math.imul(al3, bl9)) | 0;
    mid = (mid + Math.imul(al3, bh9)) | 0;
    mid = (mid + Math.imul(ah3, bl9)) | 0;
    hi = (hi + Math.imul(ah3, bh9)) | 0;
    var w12 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w12 >>> 26)) | 0;
    w12 &= 0x3ffffff;
    /* k = 13 */
    lo = Math.imul(al9, bl4);
    mid = Math.imul(al9, bh4);
    mid = (mid + Math.imul(ah9, bl4)) | 0;
    hi = Math.imul(ah9, bh4);
    lo = (lo + Math.imul(al8, bl5)) | 0;
    mid = (mid + Math.imul(al8, bh5)) | 0;
    mid = (mid + Math.imul(ah8, bl5)) | 0;
    hi = (hi + Math.imul(ah8, bh5)) | 0;
    lo = (lo + Math.imul(al7, bl6)) | 0;
    mid = (mid + Math.imul(al7, bh6)) | 0;
    mid = (mid + Math.imul(ah7, bl6)) | 0;
    hi = (hi + Math.imul(ah7, bh6)) | 0;
    lo = (lo + Math.imul(al6, bl7)) | 0;
    mid = (mid + Math.imul(al6, bh7)) | 0;
    mid = (mid + Math.imul(ah6, bl7)) | 0;
    hi = (hi + Math.imul(ah6, bh7)) | 0;
    lo = (lo + Math.imul(al5, bl8)) | 0;
    mid = (mid + Math.imul(al5, bh8)) | 0;
    mid = (mid + Math.imul(ah5, bl8)) | 0;
    hi = (hi + Math.imul(ah5, bh8)) | 0;
    lo = (lo + Math.imul(al4, bl9)) | 0;
    mid = (mid + Math.imul(al4, bh9)) | 0;
    mid = (mid + Math.imul(ah4, bl9)) | 0;
    hi = (hi + Math.imul(ah4, bh9)) | 0;
    var w13 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w13 >>> 26)) | 0;
    w13 &= 0x3ffffff;
    /* k = 14 */
    lo = Math.imul(al9, bl5);
    mid = Math.imul(al9, bh5);
    mid = (mid + Math.imul(ah9, bl5)) | 0;
    hi = Math.imul(ah9, bh5);
    lo = (lo + Math.imul(al8, bl6)) | 0;
    mid = (mid + Math.imul(al8, bh6)) | 0;
    mid = (mid + Math.imul(ah8, bl6)) | 0;
    hi = (hi + Math.imul(ah8, bh6)) | 0;
    lo = (lo + Math.imul(al7, bl7)) | 0;
    mid = (mid + Math.imul(al7, bh7)) | 0;
    mid = (mid + Math.imul(ah7, bl7)) | 0;
    hi = (hi + Math.imul(ah7, bh7)) | 0;
    lo = (lo + Math.imul(al6, bl8)) | 0;
    mid = (mid + Math.imul(al6, bh8)) | 0;
    mid = (mid + Math.imul(ah6, bl8)) | 0;
    hi = (hi + Math.imul(ah6, bh8)) | 0;
    lo = (lo + Math.imul(al5, bl9)) | 0;
    mid = (mid + Math.imul(al5, bh9)) | 0;
    mid = (mid + Math.imul(ah5, bl9)) | 0;
    hi = (hi + Math.imul(ah5, bh9)) | 0;
    var w14 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w14 >>> 26)) | 0;
    w14 &= 0x3ffffff;
    /* k = 15 */
    lo = Math.imul(al9, bl6);
    mid = Math.imul(al9, bh6);
    mid = (mid + Math.imul(ah9, bl6)) | 0;
    hi = Math.imul(ah9, bh6);
    lo = (lo + Math.imul(al8, bl7)) | 0;
    mid = (mid + Math.imul(al8, bh7)) | 0;
    mid = (mid + Math.imul(ah8, bl7)) | 0;
    hi = (hi + Math.imul(ah8, bh7)) | 0;
    lo = (lo + Math.imul(al7, bl8)) | 0;
    mid = (mid + Math.imul(al7, bh8)) | 0;
    mid = (mid + Math.imul(ah7, bl8)) | 0;
    hi = (hi + Math.imul(ah7, bh8)) | 0;
    lo = (lo + Math.imul(al6, bl9)) | 0;
    mid = (mid + Math.imul(al6, bh9)) | 0;
    mid = (mid + Math.imul(ah6, bl9)) | 0;
    hi = (hi + Math.imul(ah6, bh9)) | 0;
    var w15 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w15 >>> 26)) | 0;
    w15 &= 0x3ffffff;
    /* k = 16 */
    lo = Math.imul(al9, bl7);
    mid = Math.imul(al9, bh7);
    mid = (mid + Math.imul(ah9, bl7)) | 0;
    hi = Math.imul(ah9, bh7);
    lo = (lo + Math.imul(al8, bl8)) | 0;
    mid = (mid + Math.imul(al8, bh8)) | 0;
    mid = (mid + Math.imul(ah8, bl8)) | 0;
    hi = (hi + Math.imul(ah8, bh8)) | 0;
    lo = (lo + Math.imul(al7, bl9)) | 0;
    mid = (mid + Math.imul(al7, bh9)) | 0;
    mid = (mid + Math.imul(ah7, bl9)) | 0;
    hi = (hi + Math.imul(ah7, bh9)) | 0;
    var w16 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w16 >>> 26)) | 0;
    w16 &= 0x3ffffff;
    /* k = 17 */
    lo = Math.imul(al9, bl8);
    mid = Math.imul(al9, bh8);
    mid = (mid + Math.imul(ah9, bl8)) | 0;
    hi = Math.imul(ah9, bh8);
    lo = (lo + Math.imul(al8, bl9)) | 0;
    mid = (mid + Math.imul(al8, bh9)) | 0;
    mid = (mid + Math.imul(ah8, bl9)) | 0;
    hi = (hi + Math.imul(ah8, bh9)) | 0;
    var w17 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w17 >>> 26)) | 0;
    w17 &= 0x3ffffff;
    /* k = 18 */
    lo = Math.imul(al9, bl9);
    mid = Math.imul(al9, bh9);
    mid = (mid + Math.imul(ah9, bl9)) | 0;
    hi = Math.imul(ah9, bh9);
    var w18 = (((c + lo) | 0) + ((mid & 0x1fff) << 13)) | 0;
    c = (((hi + (mid >>> 13)) | 0) + (w18 >>> 26)) | 0;
    w18 &= 0x3ffffff;
    o[0] = w0;
    o[1] = w1;
    o[2] = w2;
    o[3] = w3;
    o[4] = w4;
    o[5] = w5;
    o[6] = w6;
    o[7] = w7;
    o[8] = w8;
    o[9] = w9;
    o[10] = w10;
    o[11] = w11;
    o[12] = w12;
    o[13] = w13;
    o[14] = w14;
    o[15] = w15;
    o[16] = w16;
    o[17] = w17;
    o[18] = w18;
    if (c !== 0) {
      o[19] = c;
      out.length++;
    }
    return out;
  };

  // Polyfill comb
  if (!Math.imul) {
    comb10MulTo = smallMulTo;
  }

  function bigMulTo (self, num, out) {
    out.negative = num.negative ^ self.negative;
    out.length = self.length + num.length;

    var carry = 0;
    var hncarry = 0;
    for (var k = 0; k < out.length - 1; k++) {
      // Sum all words with the same `i + j = k` and accumulate `ncarry`,
      // note that ncarry could be >= 0x3ffffff
      var ncarry = hncarry;
      hncarry = 0;
      var rword = carry & 0x3ffffff;
      var maxJ = Math.min(k, num.length - 1);
      for (var j = Math.max(0, k - self.length + 1); j <= maxJ; j++) {
        var i = k - j;
        var a = self.words[i] | 0;
        var b = num.words[j] | 0;
        var r = a * b;

        var lo = r & 0x3ffffff;
        ncarry = (ncarry + ((r / 0x4000000) | 0)) | 0;
        lo = (lo + rword) | 0;
        rword = lo & 0x3ffffff;
        ncarry = (ncarry + (lo >>> 26)) | 0;

        hncarry += ncarry >>> 26;
        ncarry &= 0x3ffffff;
      }
      out.words[k] = rword;
      carry = ncarry;
      ncarry = hncarry;
    }
    if (carry !== 0) {
      out.words[k] = carry;
    } else {
      out.length--;
    }

    return out.strip();
  }

  function jumboMulTo (self, num, out) {
    var fftm = new FFTM();
    return fftm.mulp(self, num, out);
  }

  BN.prototype.mulTo = function mulTo (num, out) {
    var res;
    var len = this.length + num.length;
    if (this.length === 10 && num.length === 10) {
      res = comb10MulTo(this, num, out);
    } else if (len < 63) {
      res = smallMulTo(this, num, out);
    } else if (len < 1024) {
      res = bigMulTo(this, num, out);
    } else {
      res = jumboMulTo(this, num, out);
    }

    return res;
  };

  // Cooley-Tukey algorithm for FFT
  // slightly revisited to rely on looping instead of recursion

  function FFTM (x, y) {
    this.x = x;
    this.y = y;
  }

  FFTM.prototype.makeRBT = function makeRBT (N) {
    var t = new Array(N);
    var l = BN.prototype._countBits(N) - 1;
    for (var i = 0; i < N; i++) {
      t[i] = this.revBin(i, l, N);
    }

    return t;
  };

  // Returns binary-reversed representation of `x`
  FFTM.prototype.revBin = function revBin (x, l, N) {
    if (x === 0 || x === N - 1) return x;

    var rb = 0;
    for (var i = 0; i < l; i++) {
      rb |= (x & 1) << (l - i - 1);
      x >>= 1;
    }

    return rb;
  };

  // Performs "tweedling" phase, therefore 'emulating'
  // behaviour of the recursive algorithm
  FFTM.prototype.permute = function permute (rbt, rws, iws, rtws, itws, N) {
    for (var i = 0; i < N; i++) {
      rtws[i] = rws[rbt[i]];
      itws[i] = iws[rbt[i]];
    }
  };

  FFTM.prototype.transform = function transform (rws, iws, rtws, itws, N, rbt) {
    this.permute(rbt, rws, iws, rtws, itws, N);

    for (var s = 1; s < N; s <<= 1) {
      var l = s << 1;

      var rtwdf = Math.cos(2 * Math.PI / l);
      var itwdf = Math.sin(2 * Math.PI / l);

      for (var p = 0; p < N; p += l) {
        var rtwdf_ = rtwdf;
        var itwdf_ = itwdf;

        for (var j = 0; j < s; j++) {
          var re = rtws[p + j];
          var ie = itws[p + j];

          var ro = rtws[p + j + s];
          var io = itws[p + j + s];

          var rx = rtwdf_ * ro - itwdf_ * io;

          io = rtwdf_ * io + itwdf_ * ro;
          ro = rx;

          rtws[p + j] = re + ro;
          itws[p + j] = ie + io;

          rtws[p + j + s] = re - ro;
          itws[p + j + s] = ie - io;

          /* jshint maxdepth : false */
          if (j !== l) {
            rx = rtwdf * rtwdf_ - itwdf * itwdf_;

            itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
            rtwdf_ = rx;
          }
        }
      }
    }
  };

  FFTM.prototype.guessLen13b = function guessLen13b (n, m) {
    var N = Math.max(m, n) | 1;
    var odd = N & 1;
    var i = 0;
    for (N = N / 2 | 0; N; N = N >>> 1) {
      i++;
    }

    return 1 << i + 1 + odd;
  };

  FFTM.prototype.conjugate = function conjugate (rws, iws, N) {
    if (N <= 1) return;

    for (var i = 0; i < N / 2; i++) {
      var t = rws[i];

      rws[i] = rws[N - i - 1];
      rws[N - i - 1] = t;

      t = iws[i];

      iws[i] = -iws[N - i - 1];
      iws[N - i - 1] = -t;
    }
  };

  FFTM.prototype.normalize13b = function normalize13b (ws, N) {
    var carry = 0;
    for (var i = 0; i < N / 2; i++) {
      var w = Math.round(ws[2 * i + 1] / N) * 0x2000 +
        Math.round(ws[2 * i] / N) +
        carry;

      ws[i] = w & 0x3ffffff;

      if (w < 0x4000000) {
        carry = 0;
      } else {
        carry = w / 0x4000000 | 0;
      }
    }

    return ws;
  };

  FFTM.prototype.convert13b = function convert13b (ws, len, rws, N) {
    var carry = 0;
    for (var i = 0; i < len; i++) {
      carry = carry + (ws[i] | 0);

      rws[2 * i] = carry & 0x1fff; carry = carry >>> 13;
      rws[2 * i + 1] = carry & 0x1fff; carry = carry >>> 13;
    }

    // Pad with zeroes
    for (i = 2 * len; i < N; ++i) {
      rws[i] = 0;
    }

    assert(carry === 0);
    assert((carry & ~0x1fff) === 0);
  };

  FFTM.prototype.stub = function stub (N) {
    var ph = new Array(N);
    for (var i = 0; i < N; i++) {
      ph[i] = 0;
    }

    return ph;
  };

  FFTM.prototype.mulp = function mulp (x, y, out) {
    var N = 2 * this.guessLen13b(x.length, y.length);

    var rbt = this.makeRBT(N);

    var _ = this.stub(N);

    var rws = new Array(N);
    var rwst = new Array(N);
    var iwst = new Array(N);

    var nrws = new Array(N);
    var nrwst = new Array(N);
    var niwst = new Array(N);

    var rmws = out.words;
    rmws.length = N;

    this.convert13b(x.words, x.length, rws, N);
    this.convert13b(y.words, y.length, nrws, N);

    this.transform(rws, _, rwst, iwst, N, rbt);
    this.transform(nrws, _, nrwst, niwst, N, rbt);

    for (var i = 0; i < N; i++) {
      var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
      iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
      rwst[i] = rx;
    }

    this.conjugate(rwst, iwst, N);
    this.transform(rwst, iwst, rmws, _, N, rbt);
    this.conjugate(rmws, _, N);
    this.normalize13b(rmws, N);

    out.negative = x.negative ^ y.negative;
    out.length = x.length + y.length;
    return out.strip();
  };

  // Multiply `this` by `num`
  BN.prototype.mul = function mul (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return this.mulTo(num, out);
  };

  // Multiply employing FFT
  BN.prototype.mulf = function mulf (num) {
    var out = new BN(null);
    out.words = new Array(this.length + num.length);
    return jumboMulTo(this, num, out);
  };

  // In-place Multiplication
  BN.prototype.imul = function imul (num) {
    return this.clone().mulTo(num, this);
  };

  BN.prototype.imuln = function imuln (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);

    // Carry
    var carry = 0;
    for (var i = 0; i < this.length; i++) {
      var w = (this.words[i] | 0) * num;
      var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
      carry >>= 26;
      carry += (w / 0x4000000) | 0;
      // NOTE: lo is 27bit maximum
      carry += lo >>> 26;
      this.words[i] = lo & 0x3ffffff;
    }

    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    this.length = num === 0 ? 1 : this.length;

    return this;
  };

  BN.prototype.muln = function muln (num) {
    return this.clone().imuln(num);
  };

  // `this` * `this`
  BN.prototype.sqr = function sqr () {
    return this.mul(this);
  };

  // `this` * `this` in-place
  BN.prototype.isqr = function isqr () {
    return this.imul(this.clone());
  };

  // Math.pow(`this`, `num`)
  BN.prototype.pow = function pow (num) {
    var w = toBitArray(num);
    if (w.length === 0) return new BN(1);

    // Skip leading zeroes
    var res = this;
    for (var i = 0; i < w.length; i++, res = res.sqr()) {
      if (w[i] !== 0) break;
    }

    if (++i < w.length) {
      for (var q = res.sqr(); i < w.length; i++, q = q.sqr()) {
        if (w[i] === 0) continue;

        res = res.mul(q);
      }
    }

    return res;
  };

  // Shift-left in-place
  BN.prototype.iushln = function iushln (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;
    var carryMask = (0x3ffffff >>> (26 - r)) << (26 - r);
    var i;

    if (r !== 0) {
      var carry = 0;

      for (i = 0; i < this.length; i++) {
        var newCarry = this.words[i] & carryMask;
        var c = ((this.words[i] | 0) - newCarry) << r;
        this.words[i] = c | carry;
        carry = newCarry >>> (26 - r);
      }

      if (carry) {
        this.words[i] = carry;
        this.length++;
      }
    }

    if (s !== 0) {
      for (i = this.length - 1; i >= 0; i--) {
        this.words[i + s] = this.words[i];
      }

      for (i = 0; i < s; i++) {
        this.words[i] = 0;
      }

      this.length += s;
    }

    return this.strip();
  };

  BN.prototype.ishln = function ishln (bits) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushln(bits);
  };

  // Shift-right in-place
  // NOTE: `hint` is a lowest bit before trailing zeroes
  // NOTE: if `extended` is present - it will be filled with destroyed bits
  BN.prototype.iushrn = function iushrn (bits, hint, extended) {
    assert(typeof bits === 'number' && bits >= 0);
    var h;
    if (hint) {
      h = (hint - (hint % 26)) / 26;
    } else {
      h = 0;
    }

    var r = bits % 26;
    var s = Math.min((bits - r) / 26, this.length);
    var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
    var maskedWords = extended;

    h -= s;
    h = Math.max(0, h);

    // Extended mode, copy masked part
    if (maskedWords) {
      for (var i = 0; i < s; i++) {
        maskedWords.words[i] = this.words[i];
      }
      maskedWords.length = s;
    }

    if (s === 0) {
      // No-op, we should not move anything at all
    } else if (this.length > s) {
      this.length -= s;
      for (i = 0; i < this.length; i++) {
        this.words[i] = this.words[i + s];
      }
    } else {
      this.words[0] = 0;
      this.length = 1;
    }

    var carry = 0;
    for (i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--) {
      var word = this.words[i] | 0;
      this.words[i] = (carry << (26 - r)) | (word >>> r);
      carry = word & mask;
    }

    // Push carried bits as a mask
    if (maskedWords && carry !== 0) {
      maskedWords.words[maskedWords.length++] = carry;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  BN.prototype.ishrn = function ishrn (bits, hint, extended) {
    // TODO(indutny): implement me
    assert(this.negative === 0);
    return this.iushrn(bits, hint, extended);
  };

  // Shift-left
  BN.prototype.shln = function shln (bits) {
    return this.clone().ishln(bits);
  };

  BN.prototype.ushln = function ushln (bits) {
    return this.clone().iushln(bits);
  };

  // Shift-right
  BN.prototype.shrn = function shrn (bits) {
    return this.clone().ishrn(bits);
  };

  BN.prototype.ushrn = function ushrn (bits) {
    return this.clone().iushrn(bits);
  };

  // Test if n bit is set
  BN.prototype.testn = function testn (bit) {
    assert(typeof bit === 'number' && bit >= 0);
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) return false;

    // Check bit and return
    var w = this.words[s];

    return !!(w & q);
  };

  // Return only lowers bits of number (in-place)
  BN.prototype.imaskn = function imaskn (bits) {
    assert(typeof bits === 'number' && bits >= 0);
    var r = bits % 26;
    var s = (bits - r) / 26;

    assert(this.negative === 0, 'imaskn works only with positive numbers');

    if (this.length <= s) {
      return this;
    }

    if (r !== 0) {
      s++;
    }
    this.length = Math.min(s, this.length);

    if (r !== 0) {
      var mask = 0x3ffffff ^ ((0x3ffffff >>> r) << r);
      this.words[this.length - 1] &= mask;
    }

    if (this.length === 0) {
      this.words[0] = 0;
      this.length = 1;
    }

    return this.strip();
  };

  // Return only lowers bits of number
  BN.prototype.maskn = function maskn (bits) {
    return this.clone().imaskn(bits);
  };

  // Add plain number `num` to `this`
  BN.prototype.iaddn = function iaddn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.isubn(-num);

    // Possible sign change
    if (this.negative !== 0) {
      if (this.length === 1 && (this.words[0] | 0) < num) {
        this.words[0] = num - (this.words[0] | 0);
        this.negative = 0;
        return this;
      }

      this.negative = 0;
      this.isubn(num);
      this.negative = 1;
      return this;
    }

    // Add without checks
    return this._iaddn(num);
  };

  BN.prototype._iaddn = function _iaddn (num) {
    this.words[0] += num;

    // Carry
    for (var i = 0; i < this.length && this.words[i] >= 0x4000000; i++) {
      this.words[i] -= 0x4000000;
      if (i === this.length - 1) {
        this.words[i + 1] = 1;
      } else {
        this.words[i + 1]++;
      }
    }
    this.length = Math.max(this.length, i + 1);

    return this;
  };

  // Subtract plain number `num` from `this`
  BN.prototype.isubn = function isubn (num) {
    assert(typeof num === 'number');
    assert(num < 0x4000000);
    if (num < 0) return this.iaddn(-num);

    if (this.negative !== 0) {
      this.negative = 0;
      this.iaddn(num);
      this.negative = 1;
      return this;
    }

    this.words[0] -= num;

    if (this.length === 1 && this.words[0] < 0) {
      this.words[0] = -this.words[0];
      this.negative = 1;
    } else {
      // Carry
      for (var i = 0; i < this.length && this.words[i] < 0; i++) {
        this.words[i] += 0x4000000;
        this.words[i + 1] -= 1;
      }
    }

    return this.strip();
  };

  BN.prototype.addn = function addn (num) {
    return this.clone().iaddn(num);
  };

  BN.prototype.subn = function subn (num) {
    return this.clone().isubn(num);
  };

  BN.prototype.iabs = function iabs () {
    this.negative = 0;

    return this;
  };

  BN.prototype.abs = function abs () {
    return this.clone().iabs();
  };

  BN.prototype._ishlnsubmul = function _ishlnsubmul (num, mul, shift) {
    var len = num.length + shift;
    var i;

    this._expand(len);

    var w;
    var carry = 0;
    for (i = 0; i < num.length; i++) {
      w = (this.words[i + shift] | 0) + carry;
      var right = (num.words[i] | 0) * mul;
      w -= right & 0x3ffffff;
      carry = (w >> 26) - ((right / 0x4000000) | 0);
      this.words[i + shift] = w & 0x3ffffff;
    }
    for (; i < this.length - shift; i++) {
      w = (this.words[i + shift] | 0) + carry;
      carry = w >> 26;
      this.words[i + shift] = w & 0x3ffffff;
    }

    if (carry === 0) return this.strip();

    // Subtraction overflow
    assert(carry === -1);
    carry = 0;
    for (i = 0; i < this.length; i++) {
      w = -(this.words[i] | 0) + carry;
      carry = w >> 26;
      this.words[i] = w & 0x3ffffff;
    }
    this.negative = 1;

    return this.strip();
  };

  BN.prototype._wordDiv = function _wordDiv (num, mode) {
    var shift = this.length - num.length;

    var a = this.clone();
    var b = num;

    // Normalize
    var bhi = b.words[b.length - 1] | 0;
    var bhiBits = this._countBits(bhi);
    shift = 26 - bhiBits;
    if (shift !== 0) {
      b = b.ushln(shift);
      a.iushln(shift);
      bhi = b.words[b.length - 1] | 0;
    }

    // Initialize quotient
    var m = a.length - b.length;
    var q;

    if (mode !== 'mod') {
      q = new BN(null);
      q.length = m + 1;
      q.words = new Array(q.length);
      for (var i = 0; i < q.length; i++) {
        q.words[i] = 0;
      }
    }

    var diff = a.clone()._ishlnsubmul(b, 1, m);
    if (diff.negative === 0) {
      a = diff;
      if (q) {
        q.words[m] = 1;
      }
    }

    for (var j = m - 1; j >= 0; j--) {
      var qj = (a.words[b.length + j] | 0) * 0x4000000 +
        (a.words[b.length + j - 1] | 0);

      // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
      // (0x7ffffff)
      qj = Math.min((qj / bhi) | 0, 0x3ffffff);

      a._ishlnsubmul(b, qj, j);
      while (a.negative !== 0) {
        qj--;
        a.negative = 0;
        a._ishlnsubmul(b, 1, j);
        if (!a.isZero()) {
          a.negative ^= 1;
        }
      }
      if (q) {
        q.words[j] = qj;
      }
    }
    if (q) {
      q.strip();
    }
    a.strip();

    // Denormalize
    if (mode !== 'div' && shift !== 0) {
      a.iushrn(shift);
    }

    return {
      div: q || null,
      mod: a
    };
  };

  // NOTE: 1) `mode` can be set to `mod` to request mod only,
  //       to `div` to request div only, or be absent to
  //       request both div & mod
  //       2) `positive` is true if unsigned mod is requested
  BN.prototype.divmod = function divmod (num, mode, positive) {
    assert(!num.isZero());

    if (this.isZero()) {
      return {
        div: new BN(0),
        mod: new BN(0)
      };
    }

    var div, mod, res;
    if (this.negative !== 0 && num.negative === 0) {
      res = this.neg().divmod(num, mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.iadd(num);
        }
      }

      return {
        div: div,
        mod: mod
      };
    }

    if (this.negative === 0 && num.negative !== 0) {
      res = this.divmod(num.neg(), mode);

      if (mode !== 'mod') {
        div = res.div.neg();
      }

      return {
        div: div,
        mod: res.mod
      };
    }

    if ((this.negative & num.negative) !== 0) {
      res = this.neg().divmod(num.neg(), mode);

      if (mode !== 'div') {
        mod = res.mod.neg();
        if (positive && mod.negative !== 0) {
          mod.isub(num);
        }
      }

      return {
        div: res.div,
        mod: mod
      };
    }

    // Both numbers are positive at this point

    // Strip both numbers to approximate shift value
    if (num.length > this.length || this.cmp(num) < 0) {
      return {
        div: new BN(0),
        mod: this
      };
    }

    // Very short reduction
    if (num.length === 1) {
      if (mode === 'div') {
        return {
          div: this.divn(num.words[0]),
          mod: null
        };
      }

      if (mode === 'mod') {
        return {
          div: null,
          mod: new BN(this.modn(num.words[0]))
        };
      }

      return {
        div: this.divn(num.words[0]),
        mod: new BN(this.modn(num.words[0]))
      };
    }

    return this._wordDiv(num, mode);
  };

  // Find `this` / `num`
  BN.prototype.div = function div (num) {
    return this.divmod(num, 'div', false).div;
  };

  // Find `this` % `num`
  BN.prototype.mod = function mod (num) {
    return this.divmod(num, 'mod', false).mod;
  };

  BN.prototype.umod = function umod (num) {
    return this.divmod(num, 'mod', true).mod;
  };

  // Find Round(`this` / `num`)
  BN.prototype.divRound = function divRound (num) {
    var dm = this.divmod(num);

    // Fast case - exact division
    if (dm.mod.isZero()) return dm.div;

    var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;

    var half = num.ushrn(1);
    var r2 = num.andln(1);
    var cmp = mod.cmp(half);

    // Round down
    if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;

    // Round up
    return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
  };

  BN.prototype.modn = function modn (num) {
    assert(num <= 0x3ffffff);
    var p = (1 << 26) % num;

    var acc = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      acc = (p * acc + (this.words[i] | 0)) % num;
    }

    return acc;
  };

  // In-place division by number
  BN.prototype.idivn = function idivn (num) {
    assert(num <= 0x3ffffff);

    var carry = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var w = (this.words[i] | 0) + carry * 0x4000000;
      this.words[i] = (w / num) | 0;
      carry = w % num;
    }

    return this.strip();
  };

  BN.prototype.divn = function divn (num) {
    return this.clone().idivn(num);
  };

  BN.prototype.egcd = function egcd (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var x = this;
    var y = p.clone();

    if (x.negative !== 0) {
      x = x.umod(p);
    } else {
      x = x.clone();
    }

    // A * x + B * y = x
    var A = new BN(1);
    var B = new BN(0);

    // C * x + D * y = y
    var C = new BN(0);
    var D = new BN(1);

    var g = 0;

    while (x.isEven() && y.isEven()) {
      x.iushrn(1);
      y.iushrn(1);
      ++g;
    }

    var yp = y.clone();
    var xp = x.clone();

    while (!x.isZero()) {
      for (var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        x.iushrn(i);
        while (i-- > 0) {
          if (A.isOdd() || B.isOdd()) {
            A.iadd(yp);
            B.isub(xp);
          }

          A.iushrn(1);
          B.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        y.iushrn(j);
        while (j-- > 0) {
          if (C.isOdd() || D.isOdd()) {
            C.iadd(yp);
            D.isub(xp);
          }

          C.iushrn(1);
          D.iushrn(1);
        }
      }

      if (x.cmp(y) >= 0) {
        x.isub(y);
        A.isub(C);
        B.isub(D);
      } else {
        y.isub(x);
        C.isub(A);
        D.isub(B);
      }
    }

    return {
      a: C,
      b: D,
      gcd: y.iushln(g)
    };
  };

  // This is reduced incarnation of the binary EEA
  // above, designated to invert members of the
  // _prime_ fields F(p) at a maximal speed
  BN.prototype._invmp = function _invmp (p) {
    assert(p.negative === 0);
    assert(!p.isZero());

    var a = this;
    var b = p.clone();

    if (a.negative !== 0) {
      a = a.umod(p);
    } else {
      a = a.clone();
    }

    var x1 = new BN(1);
    var x2 = new BN(0);

    var delta = b.clone();

    while (a.cmpn(1) > 0 && b.cmpn(1) > 0) {
      for (var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
      if (i > 0) {
        a.iushrn(i);
        while (i-- > 0) {
          if (x1.isOdd()) {
            x1.iadd(delta);
          }

          x1.iushrn(1);
        }
      }

      for (var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
      if (j > 0) {
        b.iushrn(j);
        while (j-- > 0) {
          if (x2.isOdd()) {
            x2.iadd(delta);
          }

          x2.iushrn(1);
        }
      }

      if (a.cmp(b) >= 0) {
        a.isub(b);
        x1.isub(x2);
      } else {
        b.isub(a);
        x2.isub(x1);
      }
    }

    var res;
    if (a.cmpn(1) === 0) {
      res = x1;
    } else {
      res = x2;
    }

    if (res.cmpn(0) < 0) {
      res.iadd(p);
    }

    return res;
  };

  BN.prototype.gcd = function gcd (num) {
    if (this.isZero()) return num.abs();
    if (num.isZero()) return this.abs();

    var a = this.clone();
    var b = num.clone();
    a.negative = 0;
    b.negative = 0;

    // Remove common factor of two
    for (var shift = 0; a.isEven() && b.isEven(); shift++) {
      a.iushrn(1);
      b.iushrn(1);
    }

    do {
      while (a.isEven()) {
        a.iushrn(1);
      }
      while (b.isEven()) {
        b.iushrn(1);
      }

      var r = a.cmp(b);
      if (r < 0) {
        // Swap `a` and `b` to make `a` always bigger than `b`
        var t = a;
        a = b;
        b = t;
      } else if (r === 0 || b.cmpn(1) === 0) {
        break;
      }

      a.isub(b);
    } while (true);

    return b.iushln(shift);
  };

  // Invert number in the field F(num)
  BN.prototype.invm = function invm (num) {
    return this.egcd(num).a.umod(num);
  };

  BN.prototype.isEven = function isEven () {
    return (this.words[0] & 1) === 0;
  };

  BN.prototype.isOdd = function isOdd () {
    return (this.words[0] & 1) === 1;
  };

  // And first word and num
  BN.prototype.andln = function andln (num) {
    return this.words[0] & num;
  };

  // Increment at the bit position in-line
  BN.prototype.bincn = function bincn (bit) {
    assert(typeof bit === 'number');
    var r = bit % 26;
    var s = (bit - r) / 26;
    var q = 1 << r;

    // Fast case: bit is much higher than all existing words
    if (this.length <= s) {
      this._expand(s + 1);
      this.words[s] |= q;
      return this;
    }

    // Add bit and propagate, if needed
    var carry = q;
    for (var i = s; carry !== 0 && i < this.length; i++) {
      var w = this.words[i] | 0;
      w += carry;
      carry = w >>> 26;
      w &= 0x3ffffff;
      this.words[i] = w;
    }
    if (carry !== 0) {
      this.words[i] = carry;
      this.length++;
    }
    return this;
  };

  BN.prototype.isZero = function isZero () {
    return this.length === 1 && this.words[0] === 0;
  };

  BN.prototype.cmpn = function cmpn (num) {
    var negative = num < 0;

    if (this.negative !== 0 && !negative) return -1;
    if (this.negative === 0 && negative) return 1;

    this.strip();

    var res;
    if (this.length > 1) {
      res = 1;
    } else {
      if (negative) {
        num = -num;
      }

      assert(num <= 0x3ffffff, 'Number is too big');

      var w = this.words[0] | 0;
      res = w === num ? 0 : w < num ? -1 : 1;
    }
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Compare two numbers and return:
  // 1 - if `this` > `num`
  // 0 - if `this` == `num`
  // -1 - if `this` < `num`
  BN.prototype.cmp = function cmp (num) {
    if (this.negative !== 0 && num.negative === 0) return -1;
    if (this.negative === 0 && num.negative !== 0) return 1;

    var res = this.ucmp(num);
    if (this.negative !== 0) return -res | 0;
    return res;
  };

  // Unsigned comparison
  BN.prototype.ucmp = function ucmp (num) {
    // At this point both numbers have the same sign
    if (this.length > num.length) return 1;
    if (this.length < num.length) return -1;

    var res = 0;
    for (var i = this.length - 1; i >= 0; i--) {
      var a = this.words[i] | 0;
      var b = num.words[i] | 0;

      if (a === b) continue;
      if (a < b) {
        res = -1;
      } else if (a > b) {
        res = 1;
      }
      break;
    }
    return res;
  };

  BN.prototype.gtn = function gtn (num) {
    return this.cmpn(num) === 1;
  };

  BN.prototype.gt = function gt (num) {
    return this.cmp(num) === 1;
  };

  BN.prototype.gten = function gten (num) {
    return this.cmpn(num) >= 0;
  };

  BN.prototype.gte = function gte (num) {
    return this.cmp(num) >= 0;
  };

  BN.prototype.ltn = function ltn (num) {
    return this.cmpn(num) === -1;
  };

  BN.prototype.lt = function lt (num) {
    return this.cmp(num) === -1;
  };

  BN.prototype.lten = function lten (num) {
    return this.cmpn(num) <= 0;
  };

  BN.prototype.lte = function lte (num) {
    return this.cmp(num) <= 0;
  };

  BN.prototype.eqn = function eqn (num) {
    return this.cmpn(num) === 0;
  };

  BN.prototype.eq = function eq (num) {
    return this.cmp(num) === 0;
  };

  //
  // A reduce context, could be using montgomery or something better, depending
  // on the `m` itself.
  //
  BN.red = function red (num) {
    return new Red(num);
  };

  BN.prototype.toRed = function toRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    assert(this.negative === 0, 'red works only with positives');
    return ctx.convertTo(this)._forceRed(ctx);
  };

  BN.prototype.fromRed = function fromRed () {
    assert(this.red, 'fromRed works only with numbers in reduction context');
    return this.red.convertFrom(this);
  };

  BN.prototype._forceRed = function _forceRed (ctx) {
    this.red = ctx;
    return this;
  };

  BN.prototype.forceRed = function forceRed (ctx) {
    assert(!this.red, 'Already a number in reduction context');
    return this._forceRed(ctx);
  };

  BN.prototype.redAdd = function redAdd (num) {
    assert(this.red, 'redAdd works only with red numbers');
    return this.red.add(this, num);
  };

  BN.prototype.redIAdd = function redIAdd (num) {
    assert(this.red, 'redIAdd works only with red numbers');
    return this.red.iadd(this, num);
  };

  BN.prototype.redSub = function redSub (num) {
    assert(this.red, 'redSub works only with red numbers');
    return this.red.sub(this, num);
  };

  BN.prototype.redISub = function redISub (num) {
    assert(this.red, 'redISub works only with red numbers');
    return this.red.isub(this, num);
  };

  BN.prototype.redShl = function redShl (num) {
    assert(this.red, 'redShl works only with red numbers');
    return this.red.shl(this, num);
  };

  BN.prototype.redMul = function redMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.mul(this, num);
  };

  BN.prototype.redIMul = function redIMul (num) {
    assert(this.red, 'redMul works only with red numbers');
    this.red._verify2(this, num);
    return this.red.imul(this, num);
  };

  BN.prototype.redSqr = function redSqr () {
    assert(this.red, 'redSqr works only with red numbers');
    this.red._verify1(this);
    return this.red.sqr(this);
  };

  BN.prototype.redISqr = function redISqr () {
    assert(this.red, 'redISqr works only with red numbers');
    this.red._verify1(this);
    return this.red.isqr(this);
  };

  // Square root over p
  BN.prototype.redSqrt = function redSqrt () {
    assert(this.red, 'redSqrt works only with red numbers');
    this.red._verify1(this);
    return this.red.sqrt(this);
  };

  BN.prototype.redInvm = function redInvm () {
    assert(this.red, 'redInvm works only with red numbers');
    this.red._verify1(this);
    return this.red.invm(this);
  };

  // Return negative clone of `this` % `red modulo`
  BN.prototype.redNeg = function redNeg () {
    assert(this.red, 'redNeg works only with red numbers');
    this.red._verify1(this);
    return this.red.neg(this);
  };

  BN.prototype.redPow = function redPow (num) {
    assert(this.red && !num.red, 'redPow(normalNum)');
    this.red._verify1(this);
    return this.red.pow(this, num);
  };

  // Prime numbers with efficient reduction
  var primes = {
    k256: null,
    p224: null,
    p192: null,
    p25519: null
  };

  // Pseudo-Mersenne prime
  function MPrime (name, p) {
    // P = 2 ^ N - K
    this.name = name;
    this.p = new BN(p, 16);
    this.n = this.p.bitLength();
    this.k = new BN(1).iushln(this.n).isub(this.p);

    this.tmp = this._tmp();
  }

  MPrime.prototype._tmp = function _tmp () {
    var tmp = new BN(null);
    tmp.words = new Array(Math.ceil(this.n / 13));
    return tmp;
  };

  MPrime.prototype.ireduce = function ireduce (num) {
    // Assumes that `num` is less than `P^2`
    // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
    var r = num;
    var rlen;

    do {
      this.split(r, this.tmp);
      r = this.imulK(r);
      r = r.iadd(this.tmp);
      rlen = r.bitLength();
    } while (rlen > this.n);

    var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
    if (cmp === 0) {
      r.words[0] = 0;
      r.length = 1;
    } else if (cmp > 0) {
      r.isub(this.p);
    } else {
      if (r.strip !== undefined) {
        // r is BN v4 instance
        r.strip();
      } else {
        // r is BN v5 instance
        r._strip();
      }
    }

    return r;
  };

  MPrime.prototype.split = function split (input, out) {
    input.iushrn(this.n, 0, out);
  };

  MPrime.prototype.imulK = function imulK (num) {
    return num.imul(this.k);
  };

  function K256 () {
    MPrime.call(
      this,
      'k256',
      'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
  }
  inherits(K256, MPrime);

  K256.prototype.split = function split (input, output) {
    // 256 = 9 * 26 + 22
    var mask = 0x3fffff;

    var outLen = Math.min(input.length, 9);
    for (var i = 0; i < outLen; i++) {
      output.words[i] = input.words[i];
    }
    output.length = outLen;

    if (input.length <= 9) {
      input.words[0] = 0;
      input.length = 1;
      return;
    }

    // Shift by 9 limbs
    var prev = input.words[9];
    output.words[output.length++] = prev & mask;

    for (i = 10; i < input.length; i++) {
      var next = input.words[i] | 0;
      input.words[i - 10] = ((next & mask) << 4) | (prev >>> 22);
      prev = next;
    }
    prev >>>= 22;
    input.words[i - 10] = prev;
    if (prev === 0 && input.length > 10) {
      input.length -= 10;
    } else {
      input.length -= 9;
    }
  };

  K256.prototype.imulK = function imulK (num) {
    // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
    num.words[num.length] = 0;
    num.words[num.length + 1] = 0;
    num.length += 2;

    // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
    var lo = 0;
    for (var i = 0; i < num.length; i++) {
      var w = num.words[i] | 0;
      lo += w * 0x3d1;
      num.words[i] = lo & 0x3ffffff;
      lo = w * 0x40 + ((lo / 0x4000000) | 0);
    }

    // Fast length reduction
    if (num.words[num.length - 1] === 0) {
      num.length--;
      if (num.words[num.length - 1] === 0) {
        num.length--;
      }
    }
    return num;
  };

  function P224 () {
    MPrime.call(
      this,
      'p224',
      'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
  }
  inherits(P224, MPrime);

  function P192 () {
    MPrime.call(
      this,
      'p192',
      'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
  }
  inherits(P192, MPrime);

  function P25519 () {
    // 2 ^ 255 - 19
    MPrime.call(
      this,
      '25519',
      '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
  }
  inherits(P25519, MPrime);

  P25519.prototype.imulK = function imulK (num) {
    // K = 0x13
    var carry = 0;
    for (var i = 0; i < num.length; i++) {
      var hi = (num.words[i] | 0) * 0x13 + carry;
      var lo = hi & 0x3ffffff;
      hi >>>= 26;

      num.words[i] = lo;
      carry = hi;
    }
    if (carry !== 0) {
      num.words[num.length++] = carry;
    }
    return num;
  };

  // Exported mostly for testing purposes, use plain name instead
  BN._prime = function prime (name) {
    // Cached version of prime
    if (primes[name]) return primes[name];

    var prime;
    if (name === 'k256') {
      prime = new K256();
    } else if (name === 'p224') {
      prime = new P224();
    } else if (name === 'p192') {
      prime = new P192();
    } else if (name === 'p25519') {
      prime = new P25519();
    } else {
      throw new Error('Unknown prime ' + name);
    }
    primes[name] = prime;

    return prime;
  };

  //
  // Base reduction engine
  //
  function Red (m) {
    if (typeof m === 'string') {
      var prime = BN._prime(m);
      this.m = prime.p;
      this.prime = prime;
    } else {
      assert(m.gtn(1), 'modulus must be greater than 1');
      this.m = m;
      this.prime = null;
    }
  }

  Red.prototype._verify1 = function _verify1 (a) {
    assert(a.negative === 0, 'red works only with positives');
    assert(a.red, 'red works only with red numbers');
  };

  Red.prototype._verify2 = function _verify2 (a, b) {
    assert((a.negative | b.negative) === 0, 'red works only with positives');
    assert(a.red && a.red === b.red,
      'red works only with red numbers');
  };

  Red.prototype.imod = function imod (a) {
    if (this.prime) return this.prime.ireduce(a)._forceRed(this);
    return a.umod(this.m)._forceRed(this);
  };

  Red.prototype.neg = function neg (a) {
    if (a.isZero()) {
      return a.clone();
    }

    return this.m.sub(a)._forceRed(this);
  };

  Red.prototype.add = function add (a, b) {
    this._verify2(a, b);

    var res = a.add(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.iadd = function iadd (a, b) {
    this._verify2(a, b);

    var res = a.iadd(b);
    if (res.cmp(this.m) >= 0) {
      res.isub(this.m);
    }
    return res;
  };

  Red.prototype.sub = function sub (a, b) {
    this._verify2(a, b);

    var res = a.sub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res._forceRed(this);
  };

  Red.prototype.isub = function isub (a, b) {
    this._verify2(a, b);

    var res = a.isub(b);
    if (res.cmpn(0) < 0) {
      res.iadd(this.m);
    }
    return res;
  };

  Red.prototype.shl = function shl (a, num) {
    this._verify1(a);
    return this.imod(a.ushln(num));
  };

  Red.prototype.imul = function imul (a, b) {
    this._verify2(a, b);
    return this.imod(a.imul(b));
  };

  Red.prototype.mul = function mul (a, b) {
    this._verify2(a, b);
    return this.imod(a.mul(b));
  };

  Red.prototype.isqr = function isqr (a) {
    return this.imul(a, a.clone());
  };

  Red.prototype.sqr = function sqr (a) {
    return this.mul(a, a);
  };

  Red.prototype.sqrt = function sqrt (a) {
    if (a.isZero()) return a.clone();

    var mod3 = this.m.andln(3);
    assert(mod3 % 2 === 1);

    // Fast case
    if (mod3 === 3) {
      var pow = this.m.add(new BN(1)).iushrn(2);
      return this.pow(a, pow);
    }

    // Tonelli-Shanks algorithm (Totally unoptimized and slow)
    //
    // Find Q and S, that Q * 2 ^ S = (P - 1)
    var q = this.m.subn(1);
    var s = 0;
    while (!q.isZero() && q.andln(1) === 0) {
      s++;
      q.iushrn(1);
    }
    assert(!q.isZero());

    var one = new BN(1).toRed(this);
    var nOne = one.redNeg();

    // Find quadratic non-residue
    // NOTE: Max is such because of generalized Riemann hypothesis.
    var lpow = this.m.subn(1).iushrn(1);
    var z = this.m.bitLength();
    z = new BN(2 * z * z).toRed(this);

    while (this.pow(z, lpow).cmp(nOne) !== 0) {
      z.redIAdd(nOne);
    }

    var c = this.pow(z, q);
    var r = this.pow(a, q.addn(1).iushrn(1));
    var t = this.pow(a, q);
    var m = s;
    while (t.cmp(one) !== 0) {
      var tmp = t;
      for (var i = 0; tmp.cmp(one) !== 0; i++) {
        tmp = tmp.redSqr();
      }
      assert(i < m);
      var b = this.pow(c, new BN(1).iushln(m - i - 1));

      r = r.redMul(b);
      c = b.redSqr();
      t = t.redMul(c);
      m = i;
    }

    return r;
  };

  Red.prototype.invm = function invm (a) {
    var inv = a._invmp(this.m);
    if (inv.negative !== 0) {
      inv.negative = 0;
      return this.imod(inv).redNeg();
    } else {
      return this.imod(inv);
    }
  };

  Red.prototype.pow = function pow (a, num) {
    if (num.isZero()) return new BN(1).toRed(this);
    if (num.cmpn(1) === 0) return a.clone();

    var windowSize = 4;
    var wnd = new Array(1 << windowSize);
    wnd[0] = new BN(1).toRed(this);
    wnd[1] = a;
    for (var i = 2; i < wnd.length; i++) {
      wnd[i] = this.mul(wnd[i - 1], a);
    }

    var res = wnd[0];
    var current = 0;
    var currentLen = 0;
    var start = num.bitLength() % 26;
    if (start === 0) {
      start = 26;
    }

    for (i = num.length - 1; i >= 0; i--) {
      var word = num.words[i];
      for (var j = start - 1; j >= 0; j--) {
        var bit = (word >> j) & 1;
        if (res !== wnd[0]) {
          res = this.sqr(res);
        }

        if (bit === 0 && current === 0) {
          currentLen = 0;
          continue;
        }

        current <<= 1;
        current |= bit;
        currentLen++;
        if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;

        res = this.mul(res, wnd[current]);
        currentLen = 0;
        current = 0;
      }
      start = 26;
    }

    return res;
  };

  Red.prototype.convertTo = function convertTo (num) {
    var r = num.umod(this.m);

    return r === num ? r.clone() : r;
  };

  Red.prototype.convertFrom = function convertFrom (num) {
    var res = num.clone();
    res.red = null;
    return res;
  };

  //
  // Montgomery method engine
  //

  BN.mont = function mont (num) {
    return new Mont(num);
  };

  function Mont (m) {
    Red.call(this, m);

    this.shift = this.m.bitLength();
    if (this.shift % 26 !== 0) {
      this.shift += 26 - (this.shift % 26);
    }

    this.r = new BN(1).iushln(this.shift);
    this.r2 = this.imod(this.r.sqr());
    this.rinv = this.r._invmp(this.m);

    this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
    this.minv = this.minv.umod(this.r);
    this.minv = this.r.sub(this.minv);
  }
  inherits(Mont, Red);

  Mont.prototype.convertTo = function convertTo (num) {
    return this.imod(num.ushln(this.shift));
  };

  Mont.prototype.convertFrom = function convertFrom (num) {
    var r = this.imod(num.mul(this.rinv));
    r.red = null;
    return r;
  };

  Mont.prototype.imul = function imul (a, b) {
    if (a.isZero() || b.isZero()) {
      a.words[0] = 0;
      a.length = 1;
      return a;
    }

    var t = a.imul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;

    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.mul = function mul (a, b) {
    if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);

    var t = a.mul(b);
    var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
    var u = t.isub(c).iushrn(this.shift);
    var res = u;
    if (u.cmp(this.m) >= 0) {
      res = u.isub(this.m);
    } else if (u.cmpn(0) < 0) {
      res = u.iadd(this.m);
    }

    return res._forceRed(this);
  };

  Mont.prototype.invm = function invm (a) {
    // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
    var res = this.imod(a._invmp(this.m).mul(this.r2));
    return res._forceRed(this);
  };
})(typeof module === 'undefined' || module, this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(299)(module)))

/***/ }),
/* 78 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configurations__ = __webpack_require__(1714);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__configurations__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__middleware__ = __webpack_require__(1715);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__middleware__["a"]; });


//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyxrQkFBa0IsQ0FBQztBQUNqQyxjQUFjLGNBQWMsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gXCIuL2NvbmZpZ3VyYXRpb25zXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9taWRkbGV3YXJlXCI7XG4iXX0=

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DeleteConfirm = function (_Component) {
  _inherits(DeleteConfirm, _Component);

  function DeleteConfirm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DeleteConfirm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DeleteConfirm.__proto__ || Object.getPrototypeOf(DeleteConfirm)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    }, _this.handleOnComfirm = function (e) {
      e.preventDefault();
      if (_this.props.onConfirm) {
        _this.props.onConfirm(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DeleteConfirm, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.name !== nextProps.name || this.props.open !== nextProps.open) {
        return true;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          basic: true,
          open: this.props.open === true,
          onClose: this.handleOnClose,
          size: 'small'
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: this.props.headerNode || t('WARNING: Delete Confirmation', { ns: _translation.TRANSLATION_FILES.translation }) }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            this.props.content || _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                _reactI18next.Trans,
                {
                  ns: _translation.TRANSLATION_FILES.translation,
                  i18nKey: 'Are you sure you want to permanently delete <strong>{{name}}</strong>?',
                  values: { name: this.props.name || this.props.t('this', { ns: _translation.TRANSLATION_FILES.translation }) }
                },
                'Are you sure you want to permanently delete ',
                _react2.default.createElement(
                  'strong',
                  null,
                  "'{name}'"
                ),
                '?'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'small',
                null,
                t('This cannot be undone.', { ns: _translation.TRANSLATION_FILES.translation })
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleOnClose, content: t('Cancel', { ns: _translation.TRANSLATION_FILES.screens }) }),
          _react2.default.createElement(_semanticUiReact.Button, { negative: true, onClick: this.handleOnComfirm, icon: 'trash', content: t('Delete', { ns: _translation.TRANSLATION_FILES.translation }) })
        )
      );
    }
  }]);

  return DeleteConfirm;
}(_react.Component);

DeleteConfirm.contextTypes = {
  store: _propTypes2.default.object
};
DeleteConfirm.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  name: _propTypes2.default.string,
  headerNode: _propTypes2.default.node,
  content: _propTypes2.default.node,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(DeleteConfirm);

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ViewLarge = function (_Component) {
  _inherits(ViewLarge, _Component);

  function ViewLarge() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ViewLarge);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ViewLarge.__proto__ || Object.getPrototypeOf(ViewLarge)).call.apply(_ref, [this].concat(args))), _this), _this.hasTouch = function () {
      return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }, _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    }, _this.handleOnSlide = function (e, direction) {
      e.preventDefault();
      e.stopPropagation();
      if (_this.props.onSlide) {
        _this.props.onSlide(e, direction);
      }
    }, _this.renderLabel = function () {
      var picture = _this.props.picture;

      if (picture && picture.label) {
        return _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(
            'p',
            null,
            picture.label
          )
        );
      }
      return null;
    }, _this.renderContent = function () {
      var _this$props = _this.props,
          picture = _this$props.picture,
          type = _this$props.type;

      if (type === 'video' && picture && picture.data) {
        return _react2.default.createElement('div', {
          style: {
            width: '100%',
            display: 'flex',
            justifyContent: 'center'
          },
          dangerouslySetInnerHTML: {
            __html: picture.data.html
          }
        });
      }
      return _react2.default.createElement(_LoadImage2.default, {
        centered: true,
        picture: picture,
        pictureSize: _this.props.pictureSize,
        src: _this.props.src,
        openNewTab: true,
        showLabel: true,
        extension: _this.props.extension,
        bucketName: _config2.default.get('mpBucket'),
        labelNode: _this.props.slideshow && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_semanticUiReact.Button, {
            className: 'slide-show-button ' + (_this.hasTouch() ? '' : 'no-touch'),
            inverted: true,
            floated: 'left',
            size: 'massive',
            onClick: function onClick(e) {
              return _this.handleOnSlide(e, 'left');
            },
            icon: 'chevron left',
            disabled: _this.props.disabledLeft
          }),
          _react2.default.createElement(_semanticUiReact.Button, {
            className: 'slide-show-button ' + (_this.hasTouch() ? '' : 'no-touch'),
            inverted: true,
            floated: 'right',
            size: 'massive',
            onClick: function onClick(e) {
              return _this.handleOnSlide(e, 'right');
            },
            icon: 'chevron right',
            disabled: _this.props.disabledRight
          })
        )
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ViewLarge, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (JSON.stringify(this.props.picture) !== JSON.stringify(nextProps.picture) || this.props.type !== nextProps.type || this.props.src !== nextProps.src || this.props.open !== nextProps.open) {
        return true;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          basic: true,
          open: this.props.open === true,
          onClose: this.handleOnClose,
          closeIcon: 'close',
          className: 'view-large'
        },
        _react2.default.createElement(_semanticUiReact.Header, { content: t('Preview') }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { image: true, className: 'slideshow' },
          this.renderContent()
        ),
        this.renderLabel()
      );
    }
  }]);

  return ViewLarge;
}(_react.Component);

ViewLarge.contextTypes = {
  store: _propTypes2.default.object
};
ViewLarge.propTypes = {
  t: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  picture: _propTypes2.default.shape({
    label: _propTypes2.default.string,
    url: _propTypes2.default.string,
    data: _propTypes2.default.shape({
      html: _propTypes2.default.node
    })
  }),
  type: _propTypes2.default.oneOf(['picture', 'video']),
  src: _propTypes2.default.string,
  onSlide: _propTypes2.default.func,
  disabledLeft: _propTypes2.default.bool,
  disabledRight: _propTypes2.default.bool,
  slideshow: _propTypes2.default.bool,
  pictureSize: _propTypes2.default.number,
  extension: _propTypes2.default.string
};
ViewLarge.defaultProps = {
  pictureSize: 100,
  type: 'picture'
};
exports.default = (0, _reactI18next.withTranslation)()(ViewLarge);

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(51)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(50);
var IE8_DOM_DEFINE = __webpack_require__(1127);
var toPrimitive = __webpack_require__(201);
var dP = Object.defineProperty;

exports.f = __webpack_require__(82) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

/* harmony default export */ __webpack_exports__["a"] = (isNil);


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fileSize;
function fileSize(size) {
  var i = Math.floor(Math.log(size) / Math.log(1024));
  return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i];
}

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BookingSelectListMultiple = exports.BookingSearchList = exports.SearchList = exports.BookingSelectList = exports.SelectList = exports.SelectListMultiple = exports.BookingDatePicker = exports.DatePicker = undefined;

var _DatePicker2 = __webpack_require__(2142);

var _DatePicker3 = _interopRequireDefault(_DatePicker2);

var _BookingDatePicker2 = __webpack_require__(2137);

var _BookingDatePicker3 = _interopRequireDefault(_BookingDatePicker2);

var _SelectListMultiple2 = __webpack_require__(2145);

var _SelectListMultiple3 = _interopRequireDefault(_SelectListMultiple2);

var _SelectList2 = __webpack_require__(2144);

var _SelectList3 = _interopRequireDefault(_SelectList2);

var _BookingSelectList2 = __webpack_require__(1017);

var _BookingSelectList3 = _interopRequireDefault(_BookingSelectList2);

var _SearchList2 = __webpack_require__(2143);

var _SearchList3 = _interopRequireDefault(_SearchList2);

var _BookingSearchList2 = __webpack_require__(2138);

var _BookingSearchList3 = _interopRequireDefault(_BookingSearchList2);

var _BookingSelectListMultiple2 = __webpack_require__(2139);

var _BookingSelectListMultiple3 = _interopRequireDefault(_BookingSelectListMultiple2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.DatePicker = _DatePicker3.default;
exports.BookingDatePicker = _BookingDatePicker3.default;
exports.SelectListMultiple = _SelectListMultiple3.default;
exports.SelectList = _SelectList3.default;
exports.BookingSelectList = _BookingSelectList3.default;
exports.SearchList = _SearchList3.default;
exports.BookingSearchList = _BookingSearchList3.default;
exports.BookingSelectListMultiple = _BookingSelectListMultiple3.default;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatAmountIntl = undefined;
exports.default = amountToString;
exports.spaFullString = spaFullString;
exports.spaFullNumber = spaFullNumber;
exports.fullToAmount = fullToAmount;
exports.amountToFixed = amountToFixed;

var _numeral = __webpack_require__(681);

var _numeral2 = _interopRequireDefault(_numeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function replaceAll(string, search, replacement) {
  return string.split(search).join(replacement);
}

function amountIsValid(amountFull, iAmount) {
  if (amountFull !== iAmount) {
    return false;
  }
  return true;
}

function amountToString(amountDecimal, amountFlat, amountFull, amountTimes) {
  // save as string
  var amount = '';
  var sDecimal = '00';
  var sflat = '0';
  var sTimes = '';
  if (amountDecimal) sDecimal = amountDecimal.toString();
  if (amountFlat) sflat = amountFlat.toString();
  if (amountTimes) sTimes = amountTimes.toString();
  // correct decimal
  var fsDecimal = sDecimal;
  if (sTimes.substr(1).length > sDecimal.length) {
    fsDecimal = '0'.repeat(sTimes.substr(1).length - sDecimal.length) + sDecimal;
  }
  // join flat plus corrected decimal
  amount = sflat + '.' + fsDecimal;
  // convert float64 to int
  var iAmount = parseInt(replaceAll(amount, '.', ''), 10);
  // check if amountfull matches corrected decimal amount
  if (!amountIsValid(amountFull, iAmount)) {
    return '0';
  }
  return amount;
}

function formatAmount() {
  var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '-';
  var format = arguments[1];

  var fAmount = void 0;
  if (format) {
    fAmount = (0, _numeral2.default)(amount).format(format);
  } else {
    fAmount = amount * 1 >= 1000000 && amount * 1 < 100000000 ? (0, _numeral2.default)(amount).format('0.0a') : (0, _numeral2.default)(amount).format('0a');
  }
  return fAmount;
}

function spaFullString(item, format) {
  var amountDecimal = item.spaDecimal || 0;
  var amountFlat = item.spaValue || 0;
  var amountTimes = item.spaTimes || 100;
  var amountFull = item.spaFull || item.spaValue * amountTimes;
  if (format) {
    return formatAmount(amountToString(amountDecimal, amountFlat, amountFull, amountTimes), format);
  }
  return amountToString(amountDecimal, amountFlat, amountFull, amountTimes);
}

function spaFullNumber(item) {
  var times = item.spaTimes || 100;
  return parseFloat(spaFullString(item)).toFixed(times.toString().length - 1);
}

function fullToAmount(item, fullAmount) {
  var i = item;
  var amount = fullAmount.toString();
  if (amount.includes('.')) {
    var decimal = '0';
    var amountSplit = amount.split('.');
    if (amountSplit.length > 1) {
      decimal = amountSplit[1];
    }
    var intDecimal = parseInt(decimal, 10);
    if (intDecimal < 10) {
      if (decimal.length === 1) {
        decimal = intDecimal + '0';
      } else {
        decimal = '0' + intDecimal;
      }
    }
    i.spaDecimal = decimal;
    i.spaValue = amount.split('.')[0];
    i.spaTimes = '1' + '0'.repeat(decimal.length);
    i.spaFull = parseInt(i.spaValue, 10) * parseInt(i.spaTimes, 10) + parseInt(i.spaDecimal, 10);
  } else {
    i.spaDecimal = 0;
    i.spaValue = amount;
    i.spaTimes = 100;
    i.spaFull = amount * i.spaTimes;
  }
  i.spaDecimal = parseInt(i.spaDecimal, 10);
  i.spaValue = parseInt(i.spaValue, 10);
  i.spaTimes = parseInt(i.spaTimes, 10);
  i.spaFull = parseInt(i.spaFull, 10);
  return i;
}

function amountToFixed(amount, times) {
  var t = times || 100;
  return parseFloat(amount).toFixed(t.toString().length - 1);
}

var formatAmountIntl = exports.formatAmountIntl = function formatAmountIntl(value) {
  var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'en-US';

  var num = Number(value) || 0;
  return new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(num);
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isForeignCompany = isForeignCompany;
function isForeignCompany(company) {
  return company && company.countryCode !== 'my';
}

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 90 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Ref__ = __webpack_require__(1788);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Ref__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RefFindNode__ = __webpack_require__(882);
/* unused harmony reexport RefFindNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RefForward__ = __webpack_require__(883);
/* unused harmony reexport RefForward */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(530);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__utils__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__utils__["b"]; });




//# sourceMappingURL=index.js.map


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UploadModal = function (_Component) {
  _inherits(UploadModal, _Component);

  function UploadModal(props) {
    _classCallCheck(this, UploadModal);

    var _this = _possibleConstructorReturn(this, (UploadModal.__proto__ || Object.getPrototypeOf(UploadModal)).call(this, props));

    _initialiseProps.call(_this);

    var state = UploadModal.getPropsToState(props);
    _this.state = _extends({
      open: false
    }, state);
    return _this;
  }

  _createClass(UploadModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = UploadModal.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      this.fixBody();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.fixBody();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          className: 'upload-modal',
          open: this.state.open,
          onOpen: function onOpen() {
            return _this2.handleOnOpen();
          },
          onClose: function onClose() {
            return _this2.handleOnClose();
          },
          trigger: this.props.trigger || _react2.default.createElement(_semanticUiReact.Button, {
            type: 'button',
            floated: this.props.floated,
            disabled: this.props.loading || this.props.disabled,
            primary: this.props.primary,
            fluid: this.props.fluid,
            icon: this.props.icon,
            labelPosition: this.props.icon ? 'left' : null,
            content: t(this.props.btnText, { ns: _translation.TRANSLATION_FILES.translation })
          }),
          closeIcon: 'close',
          size: 'large'
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: this.props.icon, content: ' ' + t(this.props.btnText, { ns: _translation.TRANSLATION_FILES.translation }) + ' ' + t(this.props.header.toLowerCase(), { ns: _translation.TRANSLATION_FILES.translation }) }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          this.props.content ? this.props.content({
            open: this.state.open,
            onClose: this.handleOnClose,
            onConfirm: this.handleOnConfirm
          }) : null
        )
      );
    }
  }]);

  return UploadModal;
}(_react.Component);

UploadModal.contextTypes = {
  store: _propTypes2.default.object
};
UploadModal.propTypes = {
  header: _propTypes2.default.string,
  onConfirm: _propTypes2.default.func,
  onModalStateChange: _propTypes2.default.func,
  onClose: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  content: _propTypes2.default.func,
  trigger: _propTypes2.default.node,
  primary: _propTypes2.default.bool,
  floated: _propTypes2.default.string,
  btnText: _propTypes2.default.string,
  icon: _propTypes2.default.string,
  fluid: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  modalState: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
UploadModal.defaultProps = {
  header: 'file',
  icon: 'cloud upload',
  btnText: 'Upload',
  primary: true,
  disabled: false
};

UploadModal.getPropsToState = function (props) {
  var state = {};
  // control modal state externally instead of based on trigger if modalState provided
  if (props.modalState !== null && props.modalState !== undefined) state.open = props.modalState;
  return _extends({}, state);
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.fixBody = function () {
    var anotherModal = document.getElementsByClassName('ui page modals');
    if (anotherModal && anotherModal.length > 0) {
      document.body.classList.add('dimmable', 'dimmed');
    }
  };

  this.handleOnOpen = function () {
    _this3.setState({ open: true }, function () {
      var onModalStateChange = _this3.props.onModalStateChange;

      if (onModalStateChange) {
        onModalStateChange(true);
      }
    });
  };

  this.close = function () {
    _this3.handleOnClose(true);
  };

  this.handleOnClose = function () {
    var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var open = false;
    if (!force && _this3.props.onClose) {
      open = _this3.props.onClose();
    }
    _this3.setState({ open: open }, function () {
      var onModalStateChange = _this3.props.onModalStateChange;

      if (onModalStateChange) {
        onModalStateChange(open);
      }
    });
  };

  this.handleOnConfirm = function (e, data) {
    e.preventDefault();
    if (_this3.props.onConfirm) {
      _this3.props.onConfirm(e, data);
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(UploadModal);

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = inspect;

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Used to print values in error messages.
 */
function inspect(value) {
  return value && _typeof(value) === 'object' ? typeof value.inspect === 'function' ? value.inspect() : Array.isArray(value) ? '[' + value.map(inspect).join(', ') + ']' : '{' + Object.keys(value).map(function (k) {
    return "".concat(k, ": ").concat(inspect(value[k]));
  }).join(', ') + '}' : typeof value === 'string' ? '"' + value + '"' : typeof value === 'function' ? "[function ".concat(value.name, "]") : String(value);
}

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "changeLanguage", function() { return changeLanguage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createInstance", function() { return createInstance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return instance; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dir", function() { return dir; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "exists", function() { return exists; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFixedT", function() { return getFixedT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasLoadedNamespace", function() { return hasLoadedNamespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "init", function() { return init; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadLanguages", function() { return loadLanguages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadNamespaces", function() { return loadNamespaces; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadResources", function() { return loadResources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "reloadResources", function() { return reloadResources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDefaultNamespace", function() { return setDefaultNamespace; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return t; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "use", function() { return use; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(1766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(1769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(1765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(1764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_toArray__ = __webpack_require__(1770);










function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};
var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Logger);
    this.init(concreteLogger, options);
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, _objectSpread$6(_objectSpread$6({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }), this.options));
    }
  }, {
    key: "clone",
    value: function clone(options) {
      options = options || this.options;
      options.prefix = options.prefix || this.prefix;
      return new Logger(this.logger, options);
    }
  }]);
  return Logger;
}();
var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, EventEmitter);
    this.observers = {};
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;
      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];
        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;
      if (!listener) {
        delete this.observers[event];
        return;
      }
      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }
      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);
        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);
  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}
function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }
  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }
  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();
    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }
  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}
function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
    obj = _getLastOfPath.obj,
    k = _getLastOfPath.k;
  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
    obj = _getLastOfPath2.obj,
    k = _getLastOfPath2.k;
  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
    obj = _getLastOfPath3.obj,
    k = _getLastOfPath3.k;
  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);
  if (value !== undefined) {
    return value;
  }
  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }
  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }
  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [' ', ',', '?', '!', ';'];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
  nsSeparator = nsSeparator || '';
  keySeparator = keySeparator || '';
  var possibleChars = chars.filter(function (c) {
    return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
  });
  if (possibleChars.length === 0) return true;
  var r = new RegExp("(".concat(possibleChars.map(function (c) {
    return c === '?' ? '\\?' : c;
  }).join('|'), ")"));
  var matched = !r.test(key);
  if (!matched) {
    var ki = key.indexOf(keySeparator);
    if (ki > 0 && !r.test(key.substring(0, ki))) {
      matched = true;
    }
  }
  return matched;
}
function deepFind(obj, path) {
  var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
  if (!obj) return undefined;
  if (obj[path]) return obj[path];
  var paths = path.split(keySeparator);
  var current = obj;
  for (var i = 0; i < paths.length; ++i) {
    if (!current) return undefined;
    if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) {
      return undefined;
    }
    if (current[paths[i]] === undefined) {
      var j = 2;
      var p = paths.slice(i, i + j).join(keySeparator);
      var mix = current[p];
      while (mix === undefined && paths.length > i + j) {
        j++;
        p = paths.slice(i, i + j).join(keySeparator);
        mix = current[p];
      }
      if (mix === undefined) return undefined;
      if (mix === null) return null;
      if (path.endsWith(p)) {
        if (typeof mix === 'string') return mix;
        if (p && typeof mix[p] === 'string') return mix[p];
      }
      var joinedPath = paths.slice(i + j).join(keySeparator);
      if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
      return undefined;
    }
    current = current[paths[i]];
  }
  return current;
}

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$3(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$3(); return function _createSuperInternal() { var Super = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }
function _isNativeReflectConstruct$3() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ResourceStore = function (_EventEmitter) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(ResourceStore, _EventEmitter);
  var _super = _createSuper$3(ResourceStore);
  function ResourceStore(data) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ResourceStore);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    }
    _this.data = data || {};
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    if (_this.options.ignoreJSONStructure === undefined) {
      _this.options.ignoreJSONStructure = true;
    }
    return _this;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);
      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }
      var result = getPath(this.data, path);
      if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
      return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };
      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];
      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }
      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};
      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$5(_objectSpread$5({}, pack), resources);
      }
      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }
      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$5(_objectSpread$5({}, {}), this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "hasLanguageSomeTranslations",
    value: function hasLanguageSomeTranslations(lng) {
      var data = this.getDataByLanguage(lng);
      var n = data && Object.keys(data) || [];
      return !!n.find(function (v) {
        return data[v] && Object.keys(data[v]).length > 0;
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);
  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;
    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$2(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$2(); return function _createSuperInternal() { var Super = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }
function _isNativeReflectConstruct$2() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var checkedLoadedFor = {};
var Translator = function (_EventEmitter) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Translator, _EventEmitter);
  var _super = _createSuper$2(Translator);
  function Translator(services) {
    var _this;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Translator);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    }
    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    _this.options = options;
    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }
    _this.logger = baseLogger.create('translator');
    return _this;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      if (key === undefined || key === null) {
        return false;
      }
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS || [];
      var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
      var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
      if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
        var m = key.match(this.interpolator.nestingRegexp);
        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }
        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }
      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(options) === 'object') options = _objectSpread$4({}, options);
      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
        key = _this$extractFromKey.key,
        namespaces = _this$extractFromKey.namespaces;
      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          if (returnDetails) {
            return {
              res: "".concat(namespace).concat(nsSeparator).concat(key),
              usedKey: key,
              exactUsedKey: key,
              usedLng: lng,
              usedNS: namespace
            };
          }
          return "".concat(namespace).concat(nsSeparator).concat(key);
        }
        if (returnDetails) {
          return {
            res: key,
            usedKey: key,
            exactUsedKey: key,
            usedLng: lng,
            usedNS: namespace
          };
        }
        return key;
      }
      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          if (!this.options.returnedObjectHandler) {
            this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          }
          var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$4(_objectSpread$4({}, options), {}, {
            ns: namespaces
          })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
          if (returnDetails) {
            resolved.res = r;
            return resolved;
          }
          return r;
        }
        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$4(_objectSpread$4({}, options), {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }
          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }
        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }
        var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
        var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$4(_objectSpread$4({}, options), {}, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }
          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }
          var send = function send(l, k, specificDefaultValue) {
            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
            }
            _this2.emit('missingKey', l, namespace, k, res);
          };
          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language, options).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }
        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
        if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
          if (this.options.compatibilityAPI !== 'v1') {
            res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
          } else {
            res = this.options.parseMissingKeyHandler(res);
          }
        }
      }
      if (returnDetails) {
        resolved.res = res;
        return resolved;
      }
      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;
      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$4(_objectSpread$4({}, options), {
          interpolation: _objectSpread$4(_objectSpread$4({}, this.options.interpolation), options.interpolation)
        }));
        var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
        var nestBef;
        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }
        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }
        if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = resolved.usedLng;
        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
            return null;
          }
          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }
      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;
      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$4({
          i18nResolved: resolved
        }, options) : options, this);
      }
      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;
        var extracted = _this4.extractFromKey(k, options);
        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
        var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;
          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }
          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKeys = [key];
            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
              var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
              if (needsPluralHandling) {
                finalKeys.push(key + pluralSuffix);
                if (needsZeroSuffixLookup) {
                  finalKeys.push(key + zeroSuffix);
                }
              }
              if (needsContextHandling) {
                var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                finalKeys.push(contextKey);
                if (needsPluralHandling) {
                  finalKeys.push(contextKey + pluralSuffix);
                  if (needsZeroSuffixLookup) {
                    finalKeys.push(contextKey + zeroSuffix);
                  }
                }
              }
            }
            var possibleKey;
            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';
      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }
      return false;
    }
  }]);
  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}
var LanguageUtil = function () {
  function LanguageUtil(options) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, LanguageUtil);
    this.options = options;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');
        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }
        return p.join('-');
      }
      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }
      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;
      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;
        var cleanedLng = _this.formatLanguageCode(code);
        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });
      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;
          var lngOnly = _this.getLanguagePartFromCode(code);
          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng === lngOnly) return supportedLng;
            if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }
      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;
      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];
      var addCode = function addCode(c) {
        if (!c) return;
        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }
      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);
  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kk', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};
var deprecatedJsonVersions = ['v1', 'v2', 'v3'];
var suffixesOrder = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
};
function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}
var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, PluralResolver);
    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
      this.options.compatibilityJSON = 'v3';
      this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
    }
    this.rules = createRules();
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (this.shouldUseIntlApi()) {
        try {
          return new Intl.PluralRules(code, {
            type: options.ordinal ? 'ordinal' : 'cardinal'
          });
        } catch (_unused) {
          return;
        }
      }
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);
      if (this.shouldUseIntlApi()) {
        return rule && rule.resolvedOptions().pluralCategories.length > 1;
      }
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      return this.getSuffixes(code, options).map(function (suffix) {
        return "".concat(key).concat(suffix);
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var rule = this.getRule(code, options);
      if (!rule) {
        return [];
      }
      if (this.shouldUseIntlApi()) {
        return rule.resolvedOptions().pluralCategories.sort(function (pluralCategory1, pluralCategory2) {
          return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
        }).map(function (pluralCategory) {
          return "".concat(_this.options.prepend).concat(pluralCategory);
        });
      }
      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number, options);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var rule = this.getRule(code, options);
      if (rule) {
        if (this.shouldUseIntlApi()) {
          return "".concat(this.options.prepend).concat(rule.select(count));
        }
        return this.getSuffixRetroCompatible(rule, count);
      }
      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }, {
    key: "getSuffixRetroCompatible",
    value: function getSuffixRetroCompatible(rule, count) {
      var _this2 = this;
      var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
      var suffix = rule.numbers[idx];
      if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        if (suffix === 2) {
          suffix = 'plural';
        } else if (suffix === 1) {
          suffix = '';
        }
      }
      var returnSuffix = function returnSuffix() {
        return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
      };
      if (this.options.compatibilityJSON === 'v1') {
        if (suffix === 1) return '';
        if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
        return returnSuffix();
      } else if (this.options.compatibilityJSON === 'v2') {
        return returnSuffix();
      } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
        return returnSuffix();
      }
      return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
    }
  }, {
    key: "shouldUseIntlApi",
    value: function shouldUseIntlApi() {
      return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
    }
  }]);
  return PluralResolver;
}();

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function deepFindWithDefaults(data, defaultData, key) {
  var keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
  var ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  var path = getPathWithDefaults(data, defaultData, key);
  if (!path && ignoreJSONStructure && typeof key === 'string') {
    path = deepFind(data, key, keySeparator);
    if (path === undefined) path = deepFind(defaultData, key, keySeparator);
  }
  return path;
}
var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Interpolator);
    this.logger = baseLogger.create('interpolator');
    this.options = options;
    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };
    this.init(options);
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;
      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }
      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = deepFindWithDefaults(data, defaultData, key, _this.options.keySeparator, _this.options.ignoreJSONStructure);
          return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
            interpolationkey: key
          })) : path;
        }
        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(deepFindWithDefaults(data, defaultData, k, _this.options.keySeparator, _this.options.ignoreJSONStructure), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
          interpolationkey: k
        }));
      };
      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;
        while (match = todo.regex.exec(str)) {
          var matchedVar = match[1].trim();
          value = handleFormat(matchedVar);
          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) {
              value = '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }
          var safeValue = todo.safeValue(value);
          str = str.replace(match[0], safeValue);
          if (skipOnVariables) {
            todo.regex.lastIndex += value.length;
            todo.regex.lastIndex -= match[0].length;
          } else {
            todo.regex.lastIndex = 0;
          }
          replaces++;
          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;
      var clonedOptions;
      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        var matchedSingleQuotes = optionsString.match(/'/g);
        var matchedDoubleQuotes = optionsString.match(/"/g);
        if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) {
          optionsString = optionsString.replace(/'/g, '"');
        }
        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }
        delete clonedOptions.defaultValue;
        return key;
      }
      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        clonedOptions = _objectSpread$3({}, options);
        clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== 'string' ? clonedOptions.replace : clonedOptions;
        clonedOptions.applyPostProcessor = false;
        delete clonedOptions.defaultValue;
        var doReduce = false;
        if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }
        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);
        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }
        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
              interpolationkey: match[1].trim()
            }));
          }, value.trim());
        }
        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }
      return str;
    }
  }]);
  return Interpolator;
}();

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function parseFormatStr(formatStr) {
  var formatName = formatStr.toLowerCase().trim();
  var formatOptions = {};
  if (formatStr.indexOf('(') > -1) {
    var p = formatStr.split('(');
    formatName = p[0].toLowerCase().trim();
    var optStr = p[1].substring(0, p[1].length - 1);
    if (formatName === 'currency' && optStr.indexOf(':') < 0) {
      if (!formatOptions.currency) formatOptions.currency = optStr.trim();
    } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
      if (!formatOptions.range) formatOptions.range = optStr.trim();
    } else {
      var opts = optStr.split(';');
      opts.forEach(function (opt) {
        if (!opt) return;
        var _opt$split = opt.split(':'),
          _opt$split2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__babel_runtime_helpers_esm_toArray__["a" /* default */])(_opt$split),
          key = _opt$split2[0],
          rest = _opt$split2.slice(1);
        var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
        if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
        if (val === 'false') formatOptions[key.trim()] = false;
        if (val === 'true') formatOptions[key.trim()] = true;
        if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
      });
    }
  }
  return {
    formatName: formatName,
    formatOptions: formatOptions
  };
}
function createCachedFormatter(fn) {
  var cache = {};
  return function invokeFormatter(val, lng, options) {
    var key = lng + JSON.stringify(options);
    var formatter = cache[key];
    if (!formatter) {
      formatter = fn(lng, options);
      cache[key] = formatter;
    }
    return formatter(val);
  };
}
var Formatter = function () {
  function Formatter() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Formatter);
    this.logger = baseLogger.create('formatter');
    this.options = options;
    this.formats = {
      number: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val);
        };
      }),
      currency: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.NumberFormat(lng, _objectSpread$2(_objectSpread$2({}, opt), {}, {
          style: 'currency'
        }));
        return function (val) {
          return formatter.format(val);
        };
      }),
      datetime: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.DateTimeFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val);
        };
      }),
      relativetime: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val, opt.range || 'day');
        };
      }),
      list: createCachedFormatter(function (lng, opt) {
        var formatter = new Intl.ListFormat(lng, _objectSpread$2({}, opt));
        return function (val) {
          return formatter.format(val);
        };
      })
    };
    this.init(options);
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Formatter, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var iOpts = options.interpolation;
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
    }
  }, {
    key: "add",
    value: function add(name, fc) {
      this.formats[name.toLowerCase().trim()] = fc;
    }
  }, {
    key: "addCached",
    value: function addCached(name, fc) {
      this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
    }
  }, {
    key: "format",
    value: function format(value, _format, lng) {
      var _this = this;
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var formats = _format.split(this.formatSeparator);
      var result = formats.reduce(function (mem, f) {
        var _parseFormatStr = parseFormatStr(f),
          formatName = _parseFormatStr.formatName,
          formatOptions = _parseFormatStr.formatOptions;
        if (_this.formats[formatName]) {
          var formatted = mem;
          try {
            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
            formatted = _this.formats[formatName](mem, l, _objectSpread$2(_objectSpread$2(_objectSpread$2({}, formatOptions), options), valOptions));
          } catch (error) {
            _this.logger.warn(error);
          }
          return formatted;
        } else {
          _this.logger.warn("there was no format function for ".concat(formatName));
        }
        return mem;
      }, value);
      return result;
    }
  }]);
  return Formatter;
}();

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper$1(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct$1(); return function _createSuperInternal() { var Super = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }
function _isNativeReflectConstruct$1() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function removePending(q, name) {
  if (q.pending[name] !== undefined) {
    delete q.pending[name];
    q.pendingCount--;
  }
}
var Connector = function (_EventEmitter) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(Connector, _EventEmitter);
  var _super = _createSuper$1(Connector);
  function Connector(backend, store, services) {
    var _this;
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Connector);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    }
    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.waitingReads = [];
    _this.maxParallelReads = options.maxParallelReads || 10;
    _this.readingCalls = 0;
    _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
    _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
    _this.state = {};
    _this.queue = [];
    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }
    return _this;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;
      var toLoad = {};
      var pending = {};
      var toLoadLanguages = {};
      var toLoadNamespaces = {};
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);
          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending[name] === undefined) pending[name] = true;
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending[name] === undefined) pending[name] = true;
            if (toLoad[name] === undefined) toLoad[name] = true;
            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
          }
        });
        if (!hasAllNamespaces) toLoadLanguages[lng] = true;
      });
      if (Object.keys(toLoad).length || Object.keys(pending).length) {
        this.queue.push({
          pending: pending,
          pendingCount: Object.keys(pending).length,
          loaded: {},
          errors: [],
          callback: callback
        });
      }
      return {
        toLoad: Object.keys(toLoad),
        pending: Object.keys(pending),
        toLoadLanguages: Object.keys(toLoadLanguages),
        toLoadNamespaces: Object.keys(toLoadNamespaces)
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);
      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }
      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        removePending(q, name);
        if (err) q.errors.push(err);
        if (q.pendingCount === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = {};
            var loadedKeys = q.loaded[l];
            if (loadedKeys.length) {
              loadedKeys.forEach(function (n) {
                if (loaded[l][n] === undefined) loaded[l][n] = true;
              });
            }
          });
          q.done = true;
          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;
      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      if (this.readingCalls >= this.maxParallelReads) {
        this.waitingReads.push({
          lng: lng,
          ns: ns,
          fcName: fcName,
          tried: tried,
          wait: wait,
          callback: callback
        });
        return;
      }
      this.readingCalls++;
      var resolver = function resolver(err, data) {
        _this3.readingCalls--;
        if (_this3.waitingReads.length > 0) {
          var next = _this3.waitingReads.shift();
          _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
        }
        if (err && data && tried < _this3.maxRetries) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }
        callback(err, data);
      };
      var fc = this.backend[fcName].bind(this.backend);
      if (fc.length === 2) {
        try {
          var r = fc(lng, ns);
          if (r && typeof r.then === 'function') {
            r.then(function (data) {
              return resolver(null, data);
            })["catch"](resolver);
          } else {
            resolver(null, r);
          }
        } catch (err) {
          resolver(err);
        }
        return;
      }
      return fc(lng, ns, resolver);
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;
      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }
      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);
      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }
      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;
      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
      var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function () {};
      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }
      if (key === undefined || key === null || key === '') return;
      if (this.backend && this.backend.create) {
        var opts = _objectSpread$1(_objectSpread$1({}, options), {}, {
          isUpdate: isUpdate
        });
        var fc = this.backend.create.bind(this.backend);
        if (fc.length < 6) {
          try {
            var r;
            if (fc.length === 5) {
              r = fc(languages, namespace, key, fallbackValue, opts);
            } else {
              r = fc(languages, namespace, key, fallbackValue);
            }
            if (r && typeof r.then === 'function') {
              r.then(function (data) {
                return clb(null, data);
              })["catch"](clb);
            } else {
              clb(null, r);
            }
          } catch (err) {
            clb(err);
          }
        } else {
          fc(languages, namespace, key, fallbackValue, clb, opts);
        }
      }
      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);
  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(args[2]) === 'object' || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }
      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: true
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];
  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }
  return options;
}

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function noop() {}
function bindMemberFunctions(inst) {
  var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
  mems.forEach(function (mem) {
    if (typeof inst[mem] === 'function') {
      inst[mem] = inst[mem].bind(inst);
    }
  });
}
var I18n = function (_EventEmitter) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(I18n, _EventEmitter);
  var _super = _createSuper(I18n);
  function I18n() {
    var _this;
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, I18n);
    _this = _super.call(this);
    if (isIE10) {
      EventEmitter.call(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    }
    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };
    bindMemberFunctions(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(_this, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this));
      }
      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }
    return _this;
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      if (typeof options === 'function') {
        callback = options;
        options = {};
      }
      if (!options.defaultNS && options.defaultNS !== false && options.ns) {
        if (typeof options.ns === 'string') {
          options.defaultNS = options.ns;
        } else if (options.ns.indexOf('translation') < 0) {
          options.defaultNS = options.ns[0];
        }
      }
      var defOpts = get();
      this.options = _objectSpread(_objectSpread(_objectSpread({}, defOpts), this.options), transformOptions(options));
      if (this.options.compatibilityAPI !== 'v1') {
        this.options.interpolation = _objectSpread(_objectSpread({}, defOpts.interpolation), this.options.interpolation);
      }
      if (options.keySeparator !== undefined) {
        this.options.userDefinedKeySeparator = options.keySeparator;
      }
      if (options.nsSeparator !== undefined) {
        this.options.userDefinedNsSeparator = options.nsSeparator;
      }
      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }
      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }
        var formatter;
        if (this.modules.formatter) {
          formatter = this.modules.formatter;
        } else if (typeof Intl !== 'undefined') {
          formatter = Formatter;
        }
        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
          s.formatter = createClassOnDemand(formatter);
          s.formatter.init(s, this.options);
          this.options.interpolation.format = s.formatter.format.bind(s.formatter);
        }
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
        }
        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }
        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }
          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop;
      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }
      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }
      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;
          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;
          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
          return _this2;
        };
      });
      var deferred = defer();
      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);
          _this2.emit('initialized', _this2.options);
          deferred.resolve(t);
          callback(err, t);
        };
        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
        _this2.changeLanguage(_this2.options.lng, finish);
      };
      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }
      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;
      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];
        var append = function append(lng) {
          if (!lng) return;
          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };
        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }
        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }
        this.services.backendConnector.load(toLoad, this.options.ns, function (e) {
          if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
          usedCallback(e);
        });
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
      if (module.type === 'backend') {
        this.modules.backend = module;
      }
      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }
      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }
      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }
      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }
      if (module.type === 'formatter') {
        this.modules.formatter = module;
      }
      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }
      return this;
    }
  }, {
    key: "setResolvedLanguage",
    value: function setResolvedLanguage(l) {
      if (!l || !this.languages) return;
      if (['cimode', 'dev'].indexOf(l) > -1) return;
      for (var li = 0; li < this.languages.length; li++) {
        var lngInLngs = this.languages[li];
        if (['cimode', 'dev'].indexOf(lngInLngs) > -1) continue;
        if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
          this.resolvedLanguage = lngInLngs;
          break;
        }
      }
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;
      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);
      var setLngProps = function setLngProps(l) {
        _this4.language = l;
        _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
        _this4.resolvedLanguage = undefined;
        _this4.setResolvedLanguage(l);
      };
      var done = function done(err, l) {
        if (l) {
          setLngProps(l);
          _this4.translator.changeLanguage(l);
          _this4.isLanguageChangingTo = undefined;
          _this4.emit('languageChanged', l);
          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }
        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };
      var setLng = function setLng(lngs) {
        if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
        if (l) {
          if (!_this4.language) {
            setLngProps(l);
          }
          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage) _this4.services.languageDetector.cacheUserLanguage(l);
        }
        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };
      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        if (this.services.languageDetector.detect.length === 0) {
          this.services.languageDetector.detect().then(setLng);
        } else {
          this.services.languageDetector.detect(setLng);
        }
      } else {
        setLng(lng);
      }
      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns, keyPrefix) {
      var _this5 = this;
      var fixedT = function fixedT(key, opts) {
        var options;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }
          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread({}, opts);
        }
        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
        var keySeparator = _this5.options.keySeparator || '.';
        var resultKey;
        if (options.keyPrefix && Array.isArray(key)) {
          resultKey = key.map(function (k) {
            return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
          });
        } else {
          resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
        }
        return _this5.t(resultKey, options);
      };
      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }
      fixedT.ns = ns;
      fixedT.keyPrefix = keyPrefix;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;
      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;
      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }
      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }
      var lng = options.lng || this.resolvedLanguage || this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;
      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
      };
      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }
      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;
      var deferred = defer();
      if (!this.options.ns) {
        if (callback) callback();
        return Promise.resolve();
      }
      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });
      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }
      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam', 'ckb'];
      var languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
      return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
      var mergedOptions = _objectSpread(_objectSpread(_objectSpread({}, this.options), options), {
        isClone: true
      });
      var clone = new I18n(mergedOptions);
      if (options.debug !== undefined || options.prefix !== undefined) {
        clone.logger = clone.logger.clone(options);
      }
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }
        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        options: this.options,
        store: this.store,
        language: this.language,
        languages: this.languages,
        resolvedLanguage: this.resolvedLanguage
      };
    }
  }]);
  return I18n;
}(EventEmitter);
__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(I18n, "createInstance", function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var callback = arguments.length > 1 ? arguments[1] : undefined;
  return new I18n(options, callback);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;

var createInstance = instance.createInstance;
var dir = instance.dir;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var hasLoadedNamespace = instance.hasLoadedNamespace;
var loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;




/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(470);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Icon__["a"]; });



/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithHoles = __webpack_require__(1760);
var iterableToArrayLimit = __webpack_require__(1776);
var unsupportedIterableToArray = __webpack_require__(880);
var nonIterableRest = __webpack_require__(1777);
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}
module.exports = _slicedToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "assertArray", {
  enumerable: true,
  get: function get() {
    return _assertArray["default"];
  }
});
Object.defineProperty(exports, "assertNumber", {
  enumerable: true,
  get: function get() {
    return _assertNumber["default"];
  }
});
Object.defineProperty(exports, "assertObject", {
  enumerable: true,
  get: function get() {
    return _assertObject["default"];
  }
});
Object.defineProperty(exports, "assertShape", {
  enumerable: true,
  get: function get() {
    return _assertShape["default"];
  }
});
Object.defineProperty(exports, "assertString", {
  enumerable: true,
  get: function get() {
    return _assertString["default"];
  }
});
Object.defineProperty(exports, "assertStringOrNumber", {
  enumerable: true,
  get: function get() {
    return _assertStringOrNumber["default"];
  }
});
exports.checkValueExist = checkValueExist;
Object.defineProperty(exports, "createValidity", {
  enumerable: true,
  get: function get() {
    return _createValidity["default"];
  }
});
var _createValidity = _interopRequireDefault(__webpack_require__(1865));
var _assertArray = _interopRequireDefault(__webpack_require__(1860));
var _assertNumber = _interopRequireDefault(__webpack_require__(1861));
var _assertObject = _interopRequireDefault(__webpack_require__(896));
var _assertShape = _interopRequireDefault(__webpack_require__(1862));
var _assertString = _interopRequireDefault(__webpack_require__(1863));
var _assertStringOrNumber = _interopRequireDefault(__webpack_require__(1864));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function checkValueExist(value) {
  return value !== null && value !== undefined;
}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = valueToText;
function valueToText(array, value) {
  var arrayItem = array.find(function (x) {
    return x.value === value;
  });
  if (arrayItem && arrayItem.text) {
    return arrayItem.text;
  }
  return '';
}

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(179);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tileProps = exports.tileGroupProps = exports.isView = exports.isClassName = exports.isViews = exports.isValue = exports.isMaxDate = exports.isMinDate = exports.isCalendarType = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var calendarTypes = ['ISO 8601', 'US', 'Arabic', 'Hebrew'];
var allViews = ['century', 'decade', 'year', 'month'];

var isCalendarType = _propTypes["default"].oneOf(calendarTypes);

exports.isCalendarType = isCalendarType;

var isMinDate = function isMinDate(props, propName, componentName) {
  var minDate = props[propName];

  if (minDate) {
    if (!(minDate instanceof Date)) {
      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
    }

    var maxDate = props.maxDate;

    if (maxDate && minDate > maxDate) {
      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(minDate), "` supplied to `").concat(componentName, "`, minDate cannot be larger than maxDate."));
    }
  } // Everything is fine


  return null;
};

exports.isMinDate = isMinDate;

var isMaxDate = function isMaxDate(props, propName, componentName) {
  var maxDate = props[propName];

  if (maxDate) {
    if (!(maxDate instanceof Date)) {
      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, expected instance of `Date`."));
    }

    var minDate = props.minDate;

    if (minDate && maxDate < minDate) {
      return new Error("Invalid prop `".concat(propName, "` of type `").concat(_typeof(maxDate), "` supplied to `").concat(componentName, "`, maxDate cannot be smaller than minDate."));
    }
  } // Everything is fine


  return null;
};

exports.isMaxDate = isMaxDate;

var isValue = _propTypes["default"].oneOfType([_propTypes["default"].instanceOf(Date), _propTypes["default"].arrayOf(_propTypes["default"].instanceOf(Date))]);

exports.isValue = isValue;

var isViews = _propTypes["default"].arrayOf(_propTypes["default"].oneOf(allViews));

exports.isViews = isViews;

var isClassName = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].string)]);

exports.isClassName = isClassName;

var isView = function isView(props, propName, componentName) {
  var view = props[propName];
  var views = props.views;
  var allowedViews = views || allViews;

  if (view !== undefined && allowedViews.indexOf(view) === -1) {
    return new Error("Invalid prop `".concat(propName, "` of value `").concat(view, "` supplied to `").concat(componentName, "`, expected one of [").concat(allowedViews.map(function (a) {
      return "\"".concat(a, "\"");
    }).join(', '), "]."));
  } // Everything is fine


  return null;
};

exports.isView = isView;

isView.isRequired = function (props, propName, componentName) {
  var view = props[propName];

  if (!view) {
    return new Error("The prop `".concat(propName, "` is marked as required in `").concat(componentName, "`, but its value is `").concat(view, "`."));
  }

  return isView(props, propName, componentName);
};

var tileGroupProps = {
  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
  hover: _propTypes["default"].instanceOf(Date),
  locale: _propTypes["default"].string,
  maxDate: isMaxDate,
  minDate: isMinDate,
  onClick: _propTypes["default"].func,
  onMouseOver: _propTypes["default"].func,
  tileClassName: _propTypes["default"].oneOfType([_propTypes["default"].func, isClassName]),
  tileContent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
  value: isValue,
  valueType: _propTypes["default"].string
};
exports.tileGroupProps = tileGroupProps;
var tileProps = {
  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
  classes: _propTypes["default"].arrayOf(_propTypes["default"].string).isRequired,
  date: _propTypes["default"].instanceOf(Date).isRequired,
  locale: _propTypes["default"].string,
  maxDate: isMaxDate,
  minDate: isMinDate,
  onClick: _propTypes["default"].func,
  onMouseOver: _propTypes["default"].func,
  style: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
  tileClassName: _propTypes["default"].oneOfType([_propTypes["default"].func, isClassName]),
  tileContent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
  tileDisabled: _propTypes["default"].func
};
exports.tileProps = tileProps;

/***/ }),
/* 101 */
/***/ (function(module, exports) {

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
module.exports = _asyncToGenerator, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(879);
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

// TODO(Babel 8): Remove this file.

var runtime = __webpack_require__(1781)();
module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  if (typeof globalThis === "object") {
    globalThis.regeneratorRuntime = runtime;
  } else {
    Function("r", "regeneratorRuntime = r")(runtime);
  }
}


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _Validate = __webpack_require__(219);

var _Validate2 = _interopRequireDefault(_Validate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PhoneInput = function (_Component) {
  _inherits(PhoneInput, _Component);

  function PhoneInput() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PhoneInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PhoneInput.__proto__ || Object.getPrototypeOf(PhoneInput)).call.apply(_ref, [this].concat(args))), _this), _this.getClassName = function () {
      var _this$props = _this.props,
          className = _this$props.className,
          prefix = _this$props.prefix;

      if (className && className !== '') return className;
      if (prefix && prefix !== '') return prefix;
      return null;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PhoneInput, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'field' },
        this.props.label !== '' ? _react2.default.createElement(
          'label',
          { htmlFor: this.props.name, style: this.props.disabled ? { opacity: 0.22 } : {} },
          this.props.label
        ) : null,
        _react2.default.createElement(
          _Validate2.default,
          {
            validation: this.props.validation,
            label: this.props.validateLabel || this.props.label,
            name: this.props.name,
            ref: this.props.validateRef,
            onChange: function onChange(e, data) {
              // bubble up onChange
              if (_this2.props.onChange) {
                _this2.props.onChange(e, data);
              }
            }
          },
          _react2.default.createElement(_semanticUiReact.Input, {
            className: this.getClassName(),
            autoComplete: this.props.autoComplete,
            disabled: this.props.disabled,
            fluid: true,
            icon: this.props.icon ? this.props.icon : null,
            iconPosition: this.props.iconPosition && this.props.iconPosition !== '' ? this.props.iconPosition : null,
            label: this.props.prefix && this.props.prefix !== '' ? this.props.prefix : null,
            loading: this.props.loading,
            name: this.props.name,
            pattern: this.props.pattern,
            placeholder: this.props.placeholder,
            readOnly: this.props.readOnly,
            type: this.props.type,
            value: this.props.value
          })
        )
      );
    }
  }]);

  return PhoneInput;
}(_react.Component);

PhoneInput.propTypes = {
  autoComplete: _propTypes2.default.string,
  className: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  icon: _propTypes2.default.node,
  iconPosition: _propTypes2.default.string,
  label: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  name: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func,
  pattern: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  prefix: _propTypes2.default.string,
  readOnly: _propTypes2.default.bool,
  type: _propTypes2.default.string,
  validation: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({
    validate: _propTypes2.default.func,
    option: _propTypes2.default.object
  })]).isRequired),
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  validateLabel: _propTypes2.default.string,
  validateRef: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({})])
};
exports.default = (0, _react.forwardRef)(function (props, ref) {
  return _react2.default.createElement(PhoneInput, _extends({}, props, { validateRef: ref }));
});

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var CharacterMetadata = __webpack_require__(133);

var ContentStateInlineStyle = __webpack_require__(2853);

var applyEntityToContentState = __webpack_require__(2877);

var getCharacterRemovalRange = __webpack_require__(2897);

var getContentStateFragment = __webpack_require__(427);

var Immutable = __webpack_require__(46);

var insertFragmentIntoContentState = __webpack_require__(2901);

var insertTextIntoContentState = __webpack_require__(2902);

var invariant = __webpack_require__(48);

var modifyBlockForContentState = __webpack_require__(1189);

var removeEntitiesAtEdges = __webpack_require__(1192);

var removeRangeFromContentState = __webpack_require__(2918);

var splitBlockInContentState = __webpack_require__(2920);

var OrderedSet = Immutable.OrderedSet;
/**
 * `DraftModifier` provides a set of convenience methods that apply
 * modifications to a `ContentState` object based on a target `SelectionState`.
 *
 * Any change to a `ContentState` should be decomposable into a series of
 * transaction functions that apply the required changes and return output
 * `ContentState` objects.
 *
 * These functions encapsulate some of the most common transaction sequences.
 */

var DraftModifier = {
  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
    var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);
    var character = CharacterMetadata.create({
      style: inlineStyle || OrderedSet(),
      entity: entityKey || null
    });
    return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
  },
  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
    !targetRange.isCollapsed() ?  false ? invariant(false, 'Target range must be collapsed for `insertText`.') : invariant(false) : void 0;
    return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
  },
  moveText: function moveText(contentState, removalRange, targetRange) {
    var movedFragment = getContentStateFragment(contentState, removalRange);
    var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');
    return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
  },
  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
    var mergeBlockData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'REPLACE_WITH_NEW_DATA';
    var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
    var withoutText = removeRangeFromContentState(withoutEntities, targetRange);
    return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment, mergeBlockData);
  },
  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
    var startKey, endKey, startBlock, endBlock;

    if (rangeToRemove.getIsBackward()) {
      rangeToRemove = rangeToRemove.merge({
        anchorKey: rangeToRemove.getFocusKey(),
        anchorOffset: rangeToRemove.getFocusOffset(),
        focusKey: rangeToRemove.getAnchorKey(),
        focusOffset: rangeToRemove.getAnchorOffset(),
        isBackward: false
      });
    }

    startKey = rangeToRemove.getAnchorKey();
    endKey = rangeToRemove.getFocusKey();
    startBlock = contentState.getBlockForKey(startKey);
    endBlock = contentState.getBlockForKey(endKey);
    var startOffset = rangeToRemove.getStartOffset();
    var endOffset = rangeToRemove.getEndOffset();
    var startEntityKey = startBlock.getEntityAt(startOffset);
    var endEntityKey = endBlock.getEntityAt(endOffset - 1); // Check whether the selection state overlaps with a single entity.
    // If so, try to remove the appropriate substring of the entity text.

    if (startKey === endKey) {
      if (startEntityKey && startEntityKey === endEntityKey) {
        var adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
        return removeRangeFromContentState(contentState, adjustedRemovalRange);
      }
    }

    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToRemove);
    return removeRangeFromContentState(withoutEntities, rangeToRemove);
  },
  splitBlock: function splitBlock(contentState, selectionState) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    var withoutText = removeRangeFromContentState(withoutEntities, selectionState);
    return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
  },
  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
  },
  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
    return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
  },
  setBlockType: function setBlockType(contentState, selectionState, blockType) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({
        type: blockType,
        depth: 0
      });
    });
  },
  setBlockData: function setBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({
        data: blockData
      });
    });
  },
  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
    return modifyBlockForContentState(contentState, selectionState, function (block) {
      return block.merge({
        data: block.getData().merge(blockData)
      });
    });
  },
  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
    return applyEntityToContentState(withoutEntities, selectionState, entityKey);
  }
};
module.exports = DraftModifier;

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var UserAgentData = __webpack_require__(2927);

var VersionRange = __webpack_require__(2928);

var mapObject = __webpack_require__(2939);

var memoizeStringOnly = __webpack_require__(2940);
/**
 * Checks to see whether `name` and `version` satisfy `query`.
 *
 * @param {string} name Name of the browser, device, engine or platform
 * @param {?string} version Version of the browser, engine or platform
 * @param {string} query Query of form "Name [range expression]"
 * @param {?function} normalizer Optional pre-processor for range expression
 * @return {boolean}
 */


function compare(name, version, query, normalizer) {
  // check for exact match with no version
  if (name === query) {
    return true;
  } // check for non-matching names


  if (!query.startsWith(name)) {
    return false;
  } // full comparison with version


  var range = query.slice(name.length);

  if (version) {
    range = normalizer ? normalizer(range) : range;
    return VersionRange.contains(range, version);
  }

  return false;
}
/**
 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
 * platform.
 *
 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
 *
 * @param {string} version
 * @return {string}
 */


function normalizePlatformVersion(version) {
  if (UserAgentData.platformName === 'Windows') {
    return version.replace(/^\s*NT/, '');
  }

  return version;
}
/**
 * Provides client-side access to the authoritative PHP-generated User Agent
 * information supplied by the server.
 */


var UserAgent = {
  /**
   * Check if the User Agent browser matches `query`.
   *
   * `query` should be a string like "Chrome" or "Chrome > 33".
   *
   * Valid browser names include:
   *
   * - ACCESS NetFront
   * - AOL
   * - Amazon Silk
   * - Android
   * - BlackBerry
   * - BlackBerry PlayBook
   * - Chrome
   * - Chrome for iOS
   * - Chrome frame
   * - Facebook PHP SDK
   * - Facebook for iOS
   * - Firefox
   * - IE
   * - IE Mobile
   * - Mobile Safari
   * - Motorola Internet Browser
   * - Nokia
   * - Openwave Mobile Browser
   * - Opera
   * - Opera Mini
   * - Opera Mobile
   * - Safari
   * - UIWebView
   * - Unknown
   * - webOS
   * - etc...
   *
   * An authoritative list can be found in the PHP `BrowserDetector` class and
   * related classes in the same file (see calls to `new UserAgentBrowser` here:
   * https://fburl.com/50728104).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isBrowser: function isBrowser(query) {
    return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
  },

  /**
   * Check if the User Agent browser uses a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isBrowserArchitecture: function isBrowserArchitecture(query) {
    return compare(UserAgentData.browserArchitecture, null, query);
  },

  /**
   * Check if the User Agent device matches `query`.
   *
   * `query` should be a string like "iPhone" or "iPad".
   *
   * Valid device names include:
   *
   * - Kindle
   * - Kindle Fire
   * - Unknown
   * - iPad
   * - iPhone
   * - iPod
   * - etc...
   *
   * An authoritative list can be found in the PHP `DeviceDetector` class and
   * related classes in the same file (see calls to `new UserAgentDevice` here:
   * https://fburl.com/50728332).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name"
   * @return {boolean}
   */
  isDevice: function isDevice(query) {
    return compare(UserAgentData.deviceName, null, query);
  },

  /**
   * Check if the User Agent rendering engine matches `query`.
   *
   * `query` should be a string like "WebKit" or "WebKit >= 537".
   *
   * Valid engine names include:
   *
   * - Gecko
   * - Presto
   * - Trident
   * - WebKit
   * - etc...
   *
   * An authoritative list can be found in the PHP `RenderingEngineDetector`
   * class related classes in the same file (see calls to `new
   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isEngine: function isEngine(query) {
    return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
  },

  /**
   * Check if the User Agent platform matches `query`.
   *
   * `query` should be a string like "Windows" or "iOS 5 - 6".
   *
   * Valid platform names include:
   *
   * - Android
   * - BlackBerry OS
   * - Java ME
   * - Linux
   * - Mac OS X
   * - Mac OS X Calendar
   * - Mac OS X Internet Account
   * - Symbian
   * - SymbianOS
   * - Windows
   * - Windows Mobile
   * - Windows Phone
   * - iOS
   * - iOS Facebook Integration Account
   * - iOS Facebook Social Sharing UI
   * - webOS
   * - Chrome OS
   * - etc...
   *
   * An authoritative list can be found in the PHP `PlatformDetector` class and
   * related classes in the same file (see calls to `new UserAgentPlatform`
   * here: https://fburl.com/50729226).
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "Name [range expression]"
   * @return {boolean}
   */
  isPlatform: function isPlatform(query) {
    return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
  },

  /**
   * Check if the User Agent platform is a 32 or 64 bit architecture.
   *
   * @note Function results are memoized
   *
   * @param {string} query Query of the form "32" or "64".
   * @return {boolean}
   */
  isPlatformArchitecture: function isPlatformArchitecture(query) {
    return compare(UserAgentData.platformArchitecture, null, query);
  }
};
module.exports = mapObject(UserAgent, memoizeStringOnly);

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var nullthrows = function nullthrows(x) {
  if (x != null) {
    return x;
  }

  throw new Error("Got unexpected null or undefined");
};

module.exports = nullthrows;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = invariant;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function invariant(condition, message) {
  /* istanbul ignore else */
  if (!condition) {
    throw new Error(message);
  }
}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(3175);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(1565);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ConsoleLogger__ = __webpack_require__(775);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ConsoleLogger__["a"]; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(255);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  SecureDocumentsProvider: true
};
Object.defineProperty(exports, "SecureDocumentsProvider", {
  enumerable: true,
  get: function get() {
    return _SecureDocumentsProvider.default;
  }
});

var _SecureDocumentsProvider = _interopRequireWildcard(__webpack_require__(1794));

Object.keys(_SecureDocumentsProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SecureDocumentsProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SecureDocumentsProvider[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9yZWFjdC9jb250ZXh0L2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0E7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IGRlZmF1bHQgYXMgU2VjdXJlRG9jdW1lbnRzUHJvdmlkZXIgfSBmcm9tICcuL1NlY3VyZURvY3VtZW50c1Byb3ZpZGVyJztcbmV4cG9ydCAqIGZyb20gJy4vU2VjdXJlRG9jdW1lbnRzUHJvdmlkZXInO1xuIl19

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(894);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return top; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return bottom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return right; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return left; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return auto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return basePlacements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return start; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return end; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clippingParents; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return viewport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return popper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return reference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return variationPlacements; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return placements; });
/* unused harmony export beforeRead */
/* unused harmony export read */
/* unused harmony export afterRead */
/* unused harmony export beforeMain */
/* unused harmony export main */
/* unused harmony export afterMain */
/* unused harmony export beforeWrite */
/* unused harmony export write */
/* unused harmony export afterWrite */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return modifierPhases; });
var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(985);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var INTL_CALL_CODES = [{ value: '213', text: 'Algeria (213)' }, { value: '1684', text: 'American Samoa (1684)' }, { value: '376', text: 'Andorra (376)' }, { value: '244', text: 'Angola (244)' }, { value: '1264', text: 'Anguilla (1264)' }, { value: '672', text: 'Antarctica/Norfolk Island (672)' }, { value: '1268', text: 'Antigua And Barbuda (1268)' }, { value: '54', text: 'Argentina (54)' }, { value: '355', text: 'Armenia (355)' }, { value: '297', text: 'Aruba (297)' }, { value: '61', text: 'Australia/Cocos/Christmas Islands (61)' }, { value: '43', text: 'Austria (43)' }, { value: '994', text: 'Azerbaijan (994)' }, { value: '973', text: 'Bahrain (973)' }, { value: '880', text: 'Bangladesh (880)' }, { value: '1246', text: 'Barbados (1246)' }, { value: '375', text: 'Belarus (375)' }, { value: '32', text: 'Belgium (32)' }, { value: '501', text: 'Belize (501)' }, { value: '229', text: 'Benin (229)' }, { value: '1441', text: 'Bermuda (1441)' }, { value: '975', text: 'Bhutan (975)' }, { value: '591', text: 'Bolivia (591)' }, { value: '387', text: 'Bosnia And Herzegowina (387)' }, { value: '267', text: 'Botswana (267)' }, { value: '55', text: 'Brazil (55)' }, { value: '673', text: 'Brunei Darussalam (673)' }, { value: '359', text: 'Bulgaria (359)' }, { value: '226', text: 'Burkina Faso (226)' }, { value: '257', text: 'Burundi (257)' }, { value: '855', text: 'Cambodia (855)' }, { value: '237', text: 'Cameroon (237)' }, { value: '1345', text: 'Cayman Islands (1345)' }, { value: '236', text: 'Central African Republic (236)' }, { value: '235', text: 'Chad (235)' }, { value: '56', text: 'Chile (56)' }, { value: '86', text: 'China (86)' }, { value: '57', text: 'Colombia (57)' }, { value: '269', text: 'Comoros (269)' }, { value: '243', text: 'Congo, Democratic Republic Of (243)' }, { value: '242', text: 'Congo, Peoples Republic Of (242)' }, { value: '682', text: 'Cook Islands (682)' }, { value: '506', text: 'Costa Rica (506)' }, { value: '225', text: 'Cote DIvoire (225)' }, { value: '385', text: 'Croatia (385)' }, { value: '53', text: 'Cuba (53)' }, { value: '357', text: 'Cyprus (357)' }, { value: '420', text: 'Czech Republic (420)' }, { value: '45', text: 'Denmark (45)' }, { value: '253', text: 'Djibouti (253)' }, { value: '1767', text: 'Dominica (1767)' }, { value: '1809', text: 'Dominican Republic (1809)' }, { value: '670', text: 'East Timor/Timor-Leste (670)' }, { value: '593', text: 'Ecuador (593)' }, { value: '20', text: 'Egypt (20)' }, { value: '503', text: 'El Salvador (503)' }, { value: '240', text: 'Equatorial Guinea (240)' }, { value: '372', text: 'Estonia (372)' }, { value: '251', text: 'Ethiopia (251)' }, { value: '500', text: 'Falkland Islands (Malvinas) (500)' }, { value: '298', text: 'Faroe Islands (298)' }, { value: '679', text: 'Fiji (679)' }, { value: '358', text: 'Finland (358)' }, { value: '33', text: 'France (33)' }, { value: '594', text: 'French Guiana (594)' }, { value: '689', text: 'French Polynesia (689)' }, { value: '241', text: 'Gabon (241)' }, { value: '220', text: 'Gambia (220)' }, { value: '995', text: 'Georgia (995)' }, { value: '49', text: 'Germany (49)' }, { value: '233', text: 'Ghana (233)' }, { value: '350', text: 'Gibraltar (350)' }, { value: '30', text: 'Greece (30)' }, { value: '299', text: 'Greenland (299)' }, { value: '1473', text: 'Grenada (1473)' }, { value: '590', text: 'Guadeloupe/Saint Barthelemy (590)' }, { value: '1671', text: 'Guam (1671)' }, { value: '502', text: 'Guatemala (502)' }, { value: '224', text: 'Guinea (224)' }, { value: '245', text: 'Guinea-Bissau (245)' }, { value: '592', text: 'Guyana (592)' }, { value: '509', text: 'Haiti (509)' }, { value: '504', text: 'Honduras (504)' }, { value: '852', text: 'Hong Kong (852)' }, { value: '36', text: 'Hungary (36)' }, { value: '354', text: 'Iceland (354)' }, { value: '91', text: 'India (91)' }, { value: '62', text: 'Indonesia (62)' }, { value: '98', text: 'Iran (98)' }, { value: '964', text: 'Iraq (964)' }, { value: '353', text: 'Ireland (353)' }, { value: '972', text: 'Israel (972)' }, { value: '39', text: 'Italy (39)' }, { value: '1876', text: 'Jamaica (1876)' }, { value: '81', text: 'Japan (81)' }, { value: '962', text: 'Jordan (962)' }, { value: '254', text: 'Kenya (254)' }, { value: '686', text: 'Kiribati (686)' }, { value: '850', text: 'Korea, North (850)' }, { value: '82', text: 'South Korea (82)' }, { value: '965', text: 'Kuwait (965)' }, { value: '996', text: 'Kyrgyzstan (996)' }, { value: '856', text: 'Laos (856)' }, { value: '371', text: 'Latvia (371)' }, { value: '961', text: 'Lebanon (961)' }, { value: '266', text: 'Lesotho (266)' }, { value: '231', text: 'Liberia (231)' }, { value: '218', text: 'Libyan Arab Jamahiriya (218)' }, { value: '423', text: 'Liechtenstein (423)' }, { value: '370', text: 'Lithuania (370)' }, { value: '352', text: 'Luxembourg (352)' }, { value: '853', text: 'Macao (853)' }, { value: '389', text: 'Macedonia (389)' }, { value: '261', text: 'Madagascar (261)' }, { value: '265', text: 'Malawi (265)' }, { value: '60', text: 'Malaysia (60)' }, { value: '960', text: 'Maldives (960)' }, { value: '223', text: 'Mali (223)' }, { value: '356', text: 'Malta (356)' }, { value: '692', text: 'Marshall Islands (692)' }, { value: '596', text: 'Martinique (596)' }, { value: '222', text: 'Mauritania (222)' }, { value: '230', text: 'Mauritius (230)' }, { value: '262', text: 'Mayotte Islands (262)' }, { value: '52', text: 'Mexico (52)' }, { value: '691', text: 'Micronesia (691)' }, { value: '373', text: 'Moldova (373)' }, { value: '377', text: 'Monaco (377)' }, { value: '976', text: 'Mongolia (976)' }, { value: '382', text: 'Montenegro (382)' }, { value: '664', text: 'Montserrat (664)' }, { value: '212', text: 'Morocco (212)' }, { value: '258', text: 'Mozambique (258)' }, { value: '95', text: 'Myanmar (95)' }, { value: '264', text: 'Namibia (264)' }, { value: '674', text: 'Nauru (674)' }, { value: '977', text: 'Nepal (977)' }, { value: '31', text: 'Netherlands (31)' }, { value: '687', text: 'New Caledonia (687)' }, { value: '64', text: 'New Zealand (64)' }, { value: '505', text: 'Nicaragua (505)' }, { value: '227', text: 'Niger (227)' }, { value: '234', text: 'Nigeria (234)' }, { value: '683', text: 'Niue (683)' }, { value: '47', text: 'Norway (47)' }, { value: '968', text: 'Oman (968)' }, { value: '92', text: 'Pakistan (92)' }, { value: '680', text: 'Palau (680)' }, { value: '507', text: 'Panama (507)' }, { value: '675', text: 'Papua New Guinea (675)' }, { value: '595', text: 'Paraguay (595)' }, { value: '51', text: 'Peru (51)' }, { value: '63', text: 'Philippines (63)' }, { value: '48', text: 'Poland (48)' }, { value: '351', text: 'Portugal (351)' }, { value: '974', text: 'Qatar (974)' }, { value: '40', text: 'Romania (40)' }, { value: '7', text: 'Russia/Kazakhstan (7)' }, { value: '250', text: 'Rwanda (250)' }, { value: '1869', text: 'Saint Kitts And Nevis (1869)' }, { value: '1758', text: 'Saint Lucia (1758)' }, { value: '1599', text: 'Saint Martin (1599)' }, { value: '1784', text: 'Saint Vincent And The Grenadines (1784)' }, { value: '685', text: 'Samoa (685)' }, { value: '378', text: 'San Marino (378)' }, { value: '239', text: 'Sao Tome And Principe (239)' }, { value: '966', text: 'Saudi Arabia (966)' }, { value: '221', text: 'Senegal (221)' }, { value: '381', text: 'Serbia/Yugoslavia (381)' }, { value: '232', text: 'Sierra Leone (232)' }, { value: '65', text: 'Singapore (65)' }, { value: '421', text: 'Slovakia (Slovak Republic) (421)' }, { value: '386', text: 'Slovenia (386)' }, { value: '677', text: 'Solomon Islands (677)' }, { value: '252', text: 'Somalia (252)' }, { value: '27', text: 'South Africa (27)' }, { value: '34', text: 'Spain (34)' }, { value: '94', text: 'Sri Lanka (94)' }, { value: '290', text: 'St. Helena (290)' }, { value: '508', text: 'St. Pierre And Miquelon (508)' }, { value: '249', text: 'Sudan (249)' }, { value: '597', text: 'Suriname (597)' }, { value: '268', text: 'Swaziland (268)' }, { value: '46', text: 'Sweden (46)' }, { value: '41', text: 'Switzerland (41)' }, { value: '963', text: 'Syrian Arab Republic (963)' }, { value: '886', text: 'Taiwan (886)' }, { value: '992', text: 'Tajikistan (992)' }, { value: '255', text: 'Tanzania, United Republic Of (255)' }, { value: '66', text: 'Thailand (66)' }, { value: '228', text: 'Togo (228)' }, { value: '676', text: 'Tonga (676)' }, { value: '1868', text: 'Trinidad And Tobago (1868)' }, { value: '216', text: 'Tunisia (216)' }, { value: '90', text: 'Turkey (90)' }, { value: '993', text: 'Turkmenistan (993)' }, { value: '1649', text: 'Turks And Caicos Islands (1649)' }, { value: '688', text: 'Tuvalu (688)' }, { value: '256', text: 'Uganda (256)' }, { value: '380', text: 'Ukraine (380)' }, { value: '971', text: 'United Arab Emirates (971)' }, { value: '44', text: 'United Kingdom (44)' }, { value: '1', text: 'United States/Canada (1)' }, { value: '598', text: 'Uruguay (598)' }, { value: '998', text: 'Uzbekistan (998)' }, { value: '678', text: 'Vanuatu (678)' }, { value: '58', text: 'Venezuela (58)' }, { value: '84', text: 'Vietnam (84)' }, { value: '1284', text: 'Virgin Islands (British) (1284)' }, { value: '1340', text: 'Virgin Islands (U.S) (1340)' }, { value: '681', text: 'Wallis And Futuna Islands  (681)' }, { value: '967', text: 'Yemen (967)' }, { value: '260', text: 'Zambia (260)' }, { value: '263', text: 'Zimbabwe (263)' }, { value: 'other', text: 'Other' }];

exports.default = INTL_CALL_CODES;

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = exports.editRoutes = undefined;

var _languagePreference = __webpack_require__(325);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _vietnam = __webpack_require__(40);

var _preSalesLaunch = __webpack_require__(269);

var _i18next = __webpack_require__(94);

var _i18next2 = _interopRequireDefault(_i18next);

var _chartLanguage = __webpack_require__(2575);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var editRoutes = exports.editRoutes = function editRoutes(id, lawyerIsEnabled, panelBankersIsEnabled, serviceCompanyID) {
  var links = [{ text: 'Edit', value: '/projects/' + id + '/edit/' }, { text: 'Unit Layouts', value: '/projects/' + id + '/layouts/' }, { text: 'Pricing Package', value: _config2.default.get('developerURL') && serviceCompanyID ? _config2.default.get('developerURL') + '/c/' + serviceCompanyID + '/projects/' + id + '/edit?tab=package_pricings' : '/projects/' + id + '/package_pricings/' }, { text: 'Documents', value: '/projects/' + id + '/documents/' }, { text: 'Logo', value: '/projects/' + id + '/logo/' }, { text: 'Pictures', value: '/projects/' + id + '/pictures/' }, { text: 'Videos', value: '/projects/' + id + '/videos/' }];
  if (lawyerIsEnabled) {
    links.push({ text: 'Panel Lawyers', value: '/projects/' + id + '/lawyers/' });
  }
  if (panelBankersIsEnabled) {
    links.push({ text: 'Panel Bankers', value: '/projects/' + id + '/bankers/' });
  }
  return links;
};

// `auth` is the last argument and defaults to null so an unmigrated caller keeps the full menu:
// both Vietnam gates below read it, and both answer "show" when it is absent.
var routes = exports.routes = function routes(id, data) {
  var showReport = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isSiteplan = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var auth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

  var _ref = data || {},
      siteplan = _ref.siteplan,
      salesChartEnabled = _ref.salesChartEnabled,
      siteplanAppEnabled = _ref.siteplanAppEnabled,
      isLaunchMode = _ref.isLaunchMode,
      salesChartRefreshSeconds = _ref.salesChartRefreshSeconds;

  var hasSiteplan = siteplan && siteplan.id && siteplan.key;
  var links = [{ text: 'Overview', value: '/projects/' + id + '/' }];
  if ((0, _vietnam.showsProjectUnitsTab)(auth)) {
    // CPI-1272
    links.push({ text: 'Units', value: '/projects/' + id + '/units/' });
  }
  // CPI-1274; Pre-Sales Launch: no link for a role HQ has blocked from the sales chart
  if (salesChartEnabled && (0, _vietnam.showsProjectStoreyPlan)(auth, data) && !(0, _preSalesLaunch.salesChartBlocked)(auth, data)) {
    // CPI-1284: the chart opens in the Showroom's current language. The header switcher
    // (components/LanguageSwitcher.jsx) saves the pick to the profile and moves i18next at once,
    // but leaves the redux profile (auth.language) as it was at login, so the live i18next value
    // is read first and auth.language is only the fallback. Launch mode keeps its auto-refresh
    // in front.
    var storeyPlanQuery = ['language=' + (0, _chartLanguage.chartLanguage)((0, _languagePreference.normalizeLanguage)(_i18next2.default.language) || (0, _languagePreference.normalizeLanguage)(auth && auth.language) || 'en')];
    if (isLaunchMode) storeyPlanQuery.unshift('refresh=' + salesChartRefreshSeconds);
    links.push({ text: 'Storey Plan', value: _config2.default.get('bookApiURL') + '/reports/storey_plan/' + id + '/?' + storeyPlanQuery.join('&') });
  }
  if (siteplanAppEnabled && hasSiteplan) {
    links.push({ text: 'Site Plan', value: _config2.default.get('salesChartURL') + '/?projectID=' + id + '&lang=' + encodeURIComponent((0, _languagePreference.normalizeLanguage)(_i18next2.default.language) || (0, _languagePreference.normalizeLanguage)(auth && auth.language) || 'en') });
  }
  if (showReport && !isSiteplan) {
    links.push({ text: 'Reports', value: '/projects/' + id + '/reports/' });
  }
  if (!isSiteplan) {
    links.push({ text: 'Activities', value: '/projects/' + id + '/activities/' });
  }
  return links;
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.titleCase = titleCase;
exports.symbolToSpace = symbolToSpace;
exports.camelToTitle = camelToTitle;
exports.toSentenceFromList = toSentenceFromList;
function titleCase(str) {
  return str.toLowerCase().split(' ').map(function (word) {
    if (typeof word[0] === 'string') {
      return word.replace(word[0], word[0].toUpperCase());
    }
    return word;
  }).join(' ');
}

function symbolToSpace(str) {
  return str.trim().replace(/([_]|[^\w\d\s])/igm, ' ');
}

function camelToTitle(str) {
  return str
  // Insert space before uppercase letters that are followed by a lowercase
  .replace(/([A-Z])(?=[a-z])/g, ' $1')
  // Capitalize the very first character
  .replace(/^./, function (match) {
    return match.toUpperCase();
  })
  // Collapse acronyms: turn "S S T" back into "SST"
  .replace(/\b(?:[A-Z] ){2,}[A-Z]\b/g, function (match) {
    return match.replace(/ /g, '');
  });
}

function toSentenceFromList(items) {
  if (items.length === 0) return '';
  if (items.length === 1) return items[0];
  if (items.length === 2) return items.join(' and ');
  return items.slice(0, -1).join(', ') + ' and ' + items[items.length - 1];
}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(52);
var hide = __webpack_require__(131);
var has = __webpack_require__(130);
var SRC = __webpack_require__(238)('src');
var $toString = __webpack_require__(2672);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(78).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(17);
var fails = __webpack_require__(51);
var defined = __webpack_require__(179);
var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
var createHTML = function (string, tag, attribute, value) {
  var S = String(defined(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};
module.exports = function (NAME, exec) {
  var O = {};
  O[NAME] = exec(createHTML);
  $export($export.P + $export.F * fails(function () {
    var test = ''[NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  }), 'String', O);
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getYear = getYear;
exports.getMonth = getMonth;
exports.getMonthIndex = getMonthIndex;
exports.getDay = getDay;
exports.getDayOfWeek = getDayOfWeek;
exports.getBeginOfCenturyYear = getBeginOfCenturyYear;
exports.getBeginOfCentury = getBeginOfCentury;
exports.getEndOfCentury = getEndOfCentury;
exports.getCenturyRange = getCenturyRange;
exports.getBeginOfPreviousCentury = getBeginOfPreviousCentury;
exports.getEndOfPreviousCentury = getEndOfPreviousCentury;
exports.getBeginOfNextCentury = getBeginOfNextCentury;
exports.getBeginOfDecadeYear = getBeginOfDecadeYear;
exports.getBeginOfDecade = getBeginOfDecade;
exports.getEndOfDecade = getEndOfDecade;
exports.getDecadeRange = getDecadeRange;
exports.getBeginOfPreviousDecade = getBeginOfPreviousDecade;
exports.getEndOfPreviousDecade = getEndOfPreviousDecade;
exports.getBeginOfNextDecade = getBeginOfNextDecade;
exports.getBeginOfYear = getBeginOfYear;
exports.getEndOfYear = getEndOfYear;
exports.getYearRange = getYearRange;
exports.getBeginOfPreviousYear = getBeginOfPreviousYear;
exports.getEndOfPreviousYear = getEndOfPreviousYear;
exports.getBeginOfNextYear = getBeginOfNextYear;
exports.getBeginOfMonth = getBeginOfMonth;
exports.getEndOfMonth = getEndOfMonth;
exports.getBeginOfWeek = getBeginOfWeek;
exports.getMonthRange = getMonthRange;
exports.getBeginOfPreviousMonth = getBeginOfPreviousMonth;
exports.getEndOfPreviousMonth = getEndOfPreviousMonth;
exports.getBeginOfNextMonth = getBeginOfNextMonth;
exports.getBeginOfDay = getBeginOfDay;
exports.getEndOfDay = getEndOfDay;
exports.getDayRange = getDayRange;
exports.getWeekNumber = getWeekNumber;
exports.getBegin = getBegin;
exports.getBeginPrevious = getBeginPrevious;
exports.getBeginNext = getBeginNext;
exports.getEnd = getEnd;
exports.getEndPrevious = getEndPrevious;
exports.getRange = getRange;
exports.getValueRange = getValueRange;
exports.getDaysInMonth = getDaysInMonth;
exports.getCenturyLabel = getCenturyLabel;
exports.getDecadeLabel = getDecadeLabel;
exports.isWeekend = isWeekend;
exports.getISOLocalMonth = getISOLocalMonth;
exports.getISOLocalDate = getISOLocalDate;
exports.getEndPrevious2 = exports.getBeginNext2 = exports.getBeginPrevious2 = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _map = _toConsumableArray(Array(7)).map(function (el, index) {
  return index;
}),
    _map2 = _slicedToArray(_map, 7),
    // eslint-disable-next-line no-unused-vars
SUNDAY = _map2[0],
    MONDAY = _map2[1],
    TUESDAY = _map2[2],
    WEDNESDAY = _map2[3],
    THURSDAY = _map2[4],
    FRIDAY = _map2[5],
    SATURDAY = _map2[6];
/* Simple getters - getting a property of a given point in time */


function getYear(date) {
  if (date instanceof Date) {
    return date.getFullYear();
  }

  if (typeof date === 'number') {
    return date;
  }

  var year = parseInt(date, 10);

  if (typeof date === 'string' && !isNaN(year)) {
    return year;
  }

  throw new Error("Failed to get year from date: ".concat(date, "."));
}

function getMonth(date) {
  return date.getMonth() + 1;
}

function getMonthIndex(date) {
  return date.getMonth();
}

function getDay(date) {
  return date.getDate();
}

function getDayOfWeek(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
  var weekday = date.getDay();

  switch (calendarType) {
    case 'ISO 8601':
      // Shifts days of the week so that Monday is 0, Sunday is 6
      return (weekday + 6) % 7;

    case 'Arabic':
      return (weekday + 1) % 7;

    case 'Hebrew':
    case 'US':
      return weekday;

    default:
      throw new Error('Unsupported calendar type.');
  }
}
/* Complex getters - getting a property somehow related to a given point in time */


function getBeginOfCenturyYear(date) {
  var year = getYear(date) - 1;
  return year + -year % 100 + 1;
}

function getBeginOfCentury(date) {
  var beginOfCenturyYear = getBeginOfCenturyYear(date);
  return new Date(beginOfCenturyYear, 0, 1);
}

function getEndOfCentury(date) {
  var beginOfCenturyYear = getBeginOfCenturyYear(date);
  return new Date(beginOfCenturyYear + 100, 0, 1, 0, 0, 0, -1);
}

function getCenturyRange(date) {
  return [getBeginOfCentury(date), getEndOfCentury(date)];
}

function getBeginOfPreviousCentury(date) {
  var previousCenturyYear = getYear(date) - 100;
  return getBeginOfCentury(previousCenturyYear);
}

function getEndOfPreviousCentury(date) {
  var previousCenturyYear = getYear(date) - 100;
  return getEndOfCentury(previousCenturyYear);
}

function getBeginOfNextCentury(date) {
  var nextCenturyYear = getYear(date) + 100;
  return getBeginOfCentury(nextCenturyYear);
}

function getBeginOfDecadeYear(date) {
  var year = getYear(date) - 1;
  return year + -year % 10 + 1;
}

function getBeginOfDecade(date) {
  var beginOfDecadeYear = getBeginOfDecadeYear(date);
  return new Date(beginOfDecadeYear, 0, 1);
}

function getEndOfDecade(date) {
  var beginOfDecadeYear = getBeginOfDecadeYear(date);
  return new Date(beginOfDecadeYear + 10, 0, 1, 0, 0, 0, -1);
}

function getDecadeRange(date) {
  return [getBeginOfDecade(date), getEndOfDecade(date)];
}

function getBeginOfPreviousDecade(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var previousDecadeYear = getBeginOfDecadeYear(date) - offset;
  return getBeginOfDecade(previousDecadeYear);
}

function getEndOfPreviousDecade(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var previousDecadeYear = getBeginOfDecadeYear(date) - offset;
  return getEndOfDecade(previousDecadeYear);
}

function getBeginOfNextDecade(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var nextDecadeYear = getBeginOfDecadeYear(date) + offset;
  return getBeginOfDecade(nextDecadeYear);
}
/**
 * Returns the beginning of a given year.
 *
 * @param {Date} date Date.
 */


function getBeginOfYear(date) {
  var year = getYear(date);
  return new Date(year, 0, 1);
}
/**
 * Returns the end of a given year.
 *
 * @param {Date} date Date.
 */


function getEndOfYear(date) {
  var year = getYear(date);
  return new Date(year + 1, 0, 1, 0, 0, 0, -1);
}
/**
 * Returns an array with the beginning and the end of a given year.
 *
 * @param {Date} date Date.
 */


function getYearRange(date) {
  return [getBeginOfYear(date), getEndOfYear(date)];
}

function getBeginOfPreviousYear(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var previousYear = getYear(date) - offset;
  return getBeginOfYear(previousYear);
}

function getEndOfPreviousYear(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var previousYear = getYear(date) - offset;
  return getEndOfYear(previousYear);
}

function getBeginOfNextYear(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var nextYear = getYear(date) + offset;
  return getBeginOfYear(nextYear);
}
/**
 * Returns the beginning of a given month.
 *
 * @param {Date} date Date.
 */


function getBeginOfMonth(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  return new Date(year, monthIndex, 1);
}
/**
 * Returns the end of a given month.
 *
 * @param {Date} date Date.
 */


function getEndOfMonth(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  return new Date(year, monthIndex + 1, 1, 0, 0, 0, -1);
}
/**
 * Returns the beginning of a given week.
 *
 * @param {Date} date Date.
 * @param {String} calendarType Calendar type. Can be ISO 8601 or US.
 */


function getBeginOfWeek(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  var day = date.getDate() - getDayOfWeek(date, calendarType);
  return new Date(year, monthIndex, day);
}
/**
 * Returns an array with the beginning and the end of a given month.
 *
 * @param {Date} date Date.
 */


function getMonthRange(date) {
  return [getBeginOfMonth(date), getEndOfMonth(date)];
}

function getDifferentMonth(date, offset) {
  var year = getYear(date);
  var previousMonthIndex = getMonthIndex(date) + offset;
  return new Date(year, previousMonthIndex, 1);
}

function getBeginOfPreviousMonth(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var previousMonth = getDifferentMonth(date, -offset);
  return getBeginOfMonth(previousMonth);
}

function getEndOfPreviousMonth(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var previousMonth = getDifferentMonth(date, -offset);
  return getEndOfMonth(previousMonth);
}

function getBeginOfNextMonth(date) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var nextMonth = getDifferentMonth(date, offset);
  return getBeginOfMonth(nextMonth);
}

function getBeginOfDay(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  var day = getDay(date);
  return new Date(year, monthIndex, day);
}

function getEndOfDay(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  var day = getDay(date);
  return new Date(year, monthIndex, day + 1, 0, 0, 0, -1);
}
/**
 * Returns an array with the beginning and the end of a given day.
 *
 * @param {Date} date Date.
 */


function getDayRange(date) {
  return [getBeginOfDay(date), getEndOfDay(date)];
}
/**
 * Gets week number according to ISO 8601 or US standard.
 * In ISO 8601, Arabic and Hebrew week 1 is the one with January 4.
 * In US calendar week 1 is the one with January 1.
 *
 * @param {Date} date Date.
 * @param {String} calendarType Calendar type. Can be ISO 8601 or US.
 */


function getWeekNumber(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
  var calendarTypeForWeekNumber = calendarType === 'US' ? 'US' : 'ISO 8601';
  var beginOfWeek = getBeginOfWeek(date, calendarTypeForWeekNumber);
  var year = getYear(date) + 1;
  var dayInWeekOne;
  var beginOfFirstWeek; // Look for the first week one that does not come after a given date

  do {
    dayInWeekOne = new Date(year, 0, calendarTypeForWeekNumber === 'ISO 8601' ? 4 : 1);
    beginOfFirstWeek = getBeginOfWeek(dayInWeekOne, calendarTypeForWeekNumber);
    year -= 1;
  } while (date - beginOfFirstWeek < 0);

  return Math.round((beginOfWeek - beginOfFirstWeek) / (8.64e7 * 7)) + 1;
}
/**
 * Returns the beginning of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */


function getBegin(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getBeginOfCentury(date);

    case 'decade':
      return getBeginOfDecade(date);

    case 'year':
      return getBeginOfYear(date);

    case 'month':
      return getBeginOfMonth(date);

    case 'day':
      return getBeginOfDay(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}

function getBeginPrevious(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getBeginOfPreviousCentury(date);

    case 'decade':
      return getBeginOfPreviousDecade(date);

    case 'year':
      return getBeginOfPreviousYear(date);

    case 'month':
      return getBeginOfPreviousMonth(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}

function getBeginNext(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getBeginOfNextCentury(date);

    case 'decade':
      return getBeginOfNextDecade(date);

    case 'year':
      return getBeginOfNextYear(date);

    case 'month':
      return getBeginOfNextMonth(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}

var getBeginPrevious2 = function getBeginPrevious2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getBeginOfPreviousDecade(date, 100);

    case 'year':
      return getBeginOfPreviousYear(date, 10);

    case 'month':
      return getBeginOfPreviousMonth(date, 12);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};

exports.getBeginPrevious2 = getBeginPrevious2;

var getBeginNext2 = function getBeginNext2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getBeginOfNextDecade(date, 100);

    case 'year':
      return getBeginOfNextYear(date, 10);

    case 'month':
      return getBeginOfNextMonth(date, 12);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
/**
 * Returns the end of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */


exports.getBeginNext2 = getBeginNext2;

function getEnd(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getEndOfCentury(date);

    case 'decade':
      return getEndOfDecade(date);

    case 'year':
      return getEndOfYear(date);

    case 'month':
      return getEndOfMonth(date);

    case 'day':
      return getEndOfDay(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}

function getEndPrevious(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getEndOfPreviousCentury(date);

    case 'decade':
      return getEndOfPreviousDecade(date);

    case 'year':
      return getEndOfPreviousYear(date);

    case 'month':
      return getEndOfPreviousMonth(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}

var getEndPrevious2 = function getEndPrevious2(rangeType, date) {
  switch (rangeType) {
    case 'decade':
      return getEndOfPreviousDecade(date, 100);

    case 'year':
      return getEndOfPreviousYear(date, 10);

    case 'month':
      return getEndOfPreviousMonth(date, 12);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
};
/**
 * Returns an array with the beginning and the end of a given range.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date Date.
 */


exports.getEndPrevious2 = getEndPrevious2;

function getRange(rangeType, date) {
  switch (rangeType) {
    case 'century':
      return getCenturyRange(date);

    case 'decade':
      return getDecadeRange(date);

    case 'year':
      return getYearRange(date);

    case 'month':
      return getMonthRange(date);

    case 'day':
      return getDayRange(date);

    default:
      throw new Error("Invalid rangeType: ".concat(rangeType));
  }
}
/**
 * Creates a range out of two values, ensuring they are in order and covering entire period ranges.
 *
 * @param {String} rangeType Range type (e.g. 'day')
 * @param {Date} date1 First date.
 * @param {Date} date2 Second date.
 */


function getValueRange(rangeType, date1, date2) {
  var rawNextValue = [date1, date2].sort(function (a, b) {
    return a - b;
  });
  return [getBegin(rangeType, rawNextValue[0]), getEnd(rangeType, rawNextValue[1])];
}
/**
 * Returns a number of days in a month of a given date.
 *
 * @param {Date} date Date.
 */


function getDaysInMonth(date) {
  var year = getYear(date);
  var monthIndex = getMonthIndex(date);
  return new Date(year, monthIndex + 1, 0).getDate();
}

function toYearLabel(_ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      start = _ref2[0],
      end = _ref2[1];

  return "".concat(getYear(start), " \u2013 ").concat(getYear(end));
}
/**
 * Returns a string labelling a century of a given date.
 * For example, for 2017 it will return 2001-2100.
 *
 * @param {Date|String|Number} date Date or a year as a string or as a number.
 */


function getCenturyLabel(date) {
  return toYearLabel(getCenturyRange(date));
}
/**
 * Returns a string labelling a century of a given date.
 * For example, for 2017 it will return 2011-2020.
 *
 * @param {Date|String|Number} date Date or a year as a string or as a number.
 */


function getDecadeLabel(date) {
  return toYearLabel(getDecadeRange(date));
}
/**
 * Returns a boolean determining whether a given date is on Saturday or Sunday.
 *
 * @param {Date} date Date.
 */


function isWeekend(date) {
  var calendarType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ISO 8601';
  var weekday = date.getDay();

  switch (calendarType) {
    case 'Arabic':
    case 'Hebrew':
      return weekday === FRIDAY || weekday === SATURDAY;

    case 'ISO 8601':
    case 'US':
      return weekday === SATURDAY || weekday === SUNDAY;

    default:
      throw new Error('Unsupported calendar type.');
  }
}
/**
 * Returns local month in ISO-like format (YYYY-MM).
 */


function getISOLocalMonth(value) {
  if (!value) {
    return value;
  }

  var date = new Date(value);

  if (isNaN(date.getTime())) {
    throw new Error("Invalid date: ".concat(value));
  }

  var year = getYear(date);
  var month = "0".concat(getMonth(date)).slice(-2);
  return "".concat(year, "-").concat(month);
}
/**
 * Returns local date in ISO-like format (YYYY-MM-DD).
 */


function getISOLocalDate(value) {
  if (!value) {
    return value;
  }

  var date = new Date(value);

  if (isNaN(date.getTime())) {
    throw new Error("Invalid date: ".concat(value));
  }

  var year = getYear(date);
  var month = "0".concat(getMonth(date)).slice(-2);
  var day = "0".concat(getDay(date)).slice(-2);
  return "".concat(year, "-").concat(month, "-").concat(day);
}

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SortableContainer", function() { return sortableContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SortableElement", function() { return sortableElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SortableHandle", function() { return sortableHandle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortableContainer", function() { return sortableContainer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortableElement", function() { return sortableElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sortableHandle", function() { return sortableHandle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "arrayMove", function() { return arrayMove; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);





// A type of promise-like that resolves synchronously and supports only one observer
const _Pact = (function() {
	function _Pact() {}
	_Pact.prototype.then = function(onFulfilled, onRejected) {
		const result = new _Pact();
		const state = this.s;
		if (state) {
			const callback = state & 1 ? onFulfilled : onRejected;
			if (callback) {
				try {
					_settle(result, 1, callback(this.v));
				} catch (e) {
					_settle(result, 2, e);
				}
				return result;
			} else {
				return this;
			}
		}
		this.o = function(_this) {
			try {
				const value = _this.v;
				if (_this.s & 1) {
					_settle(result, 1, onFulfilled ? onFulfilled(value) : value);
				} else if (onRejected) {
					_settle(result, 1, onRejected(value));
				} else {
					_settle(result, 2, value);
				}
			} catch (e) {
				_settle(result, 2, e);
			}
		};
		return result;
	};
	return _Pact;
})();

// Settles a pact synchronously
function _settle(pact, state, value) {
	if (!pact.s) {
		if (value instanceof _Pact) {
			if (value.s) {
				if (state & 1) {
					state = value.s;
				}
				value = value.v;
			} else {
				value.o = _settle.bind(null, pact, state);
				return;
			}
		}
		if (value && value.then) {
			value.then(_settle.bind(null, pact, state), _settle.bind(null, pact, 2));
			return;
		}
		pact.s = state;
		pact.v = value;
		const observer = pact.o;
		if (observer) {
			observer(pact);
		}
	}
}

// Asynchronously await a promise and pass the result to a finally continuation
function _finallyRethrows(body, finalizer) {
	try {
		var result = body();
	} catch (e) {
		return finalizer(true, e);
	}
	if (result && result.then) {
		return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
	}
	return finalizer(false, value);
}

// Sentinel value for early returns in generators 
const _earlyReturn = {};

// Asynchronous generator class; accepts the entrypoint of the generator, to which it passes itself when the generator should start
const _AsyncGenerator = (function() {
	function _AsyncGenerator(entry) {
		this._entry = entry;
		this._pact = null;
		this._resolve = null;
		this._return = null;
		this._promise = null;
	}

	function _wrapReturnedValue(value) {
		return { value: value, done: true };
	}
	function _wrapYieldedValue(value) {
		return { value: value, done: false };
	}

	_AsyncGenerator.prototype[Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))] = function() {
		return this;
	};
	_AsyncGenerator.prototype._yield = function(value) {
		// Yield the value to the pending next call
		this._resolve(value && value.then ? value.then(_wrapYieldedValue) : _wrapYieldedValue(value));
		// Return a pact for an upcoming next/return/throw call
		return this._pact = new _Pact();
	};
	_AsyncGenerator.prototype.next = function(value) {
		// Advance the generator, starting it if it has yet to be started
		const _this = this;
		return _this._promise = new Promise(function (resolve) {
			const _pact = _this._pact;
			if (_pact === null) {
				const _entry = _this._entry;
				if (_entry === null) {
					// Generator is started, but not awaiting a yield expression
					// Abandon the next call!
					return resolve(_this._promise);
				}
				// Start the generator
				_this._entry = null;
				_this._resolve = resolve;
				function returnValue(value) {
					_this._resolve(value && value.then ? value.then(_wrapReturnedValue) : _wrapReturnedValue(value));
					_this._pact = null;
					_this._resolve = null;
				}
				_entry(_this).then(returnValue, function(error) {
					if (error === _earlyReturn) {
						returnValue(_this._return);
					} else {
						const pact = new _Pact();
						_this._resolve(pact);
						_this._pact = null;
						_this._resolve = null;
						_resolve(pact, 2, error);
					}
				});
			} else {
				// Generator is started and a yield expression is pending, settle it
				_this._pact = null;
				_this._resolve = resolve;
				_settle(_pact, 1, value);
			}
		});
	};
	_AsyncGenerator.prototype.return = function(value) {
		// Early return from the generator if started, otherwise abandons the generator
		const _this = this;
		return _this._promise = new Promise(function (resolve) {
			const _pact = _this._pact;
			if (_pact === null) {
				if (_this._entry === null) {
					// Generator is started, but not awaiting a yield expression
					// Abandon the return call!
					return resolve(_this._promise);
				}
				// Generator is not started, abandon it and return the specified value
				_this._entry = null;
				return resolve(value && value.then ? value.then(_wrapReturnedValue) : _wrapReturnedValue(value));
			}
			// Settle the yield expression with a rejected "early return" value
			_this._return = value;
			_this._resolve = resolve;
			_this._pact = null;
			_settle(_pact, 2, _earlyReturn);
		});
	};
	_AsyncGenerator.prototype.throw = function(error) {
		// Inject an exception into the pending yield expression
		const _this = this;
		return _this._promise = new Promise(function (resolve, reject) {
			const _pact = _this._pact;
			if (_pact === null) {
				if (_this._entry === null) {
					// Generator is started, but not awaiting a yield expression
					// Abandon the throw call!
					return resolve(_this._promise);
				}
				// Generator is not started, abandon it and return a rejected Promise containing the error
				_this._entry = null;
				return reject(error);
			}
			// Settle the yield expression with the value as a rejection
			_this._resolve = resolve;
			_this._pact = null;
			_settle(_pact, 2, error);
		});
	};
	
	return _AsyncGenerator;
})();

var Manager = function Manager() {
  this.refs = {};
};

Manager.prototype.add = function add (collection, ref) {
  if (!this.refs[collection]) {
    this.refs[collection] = [];
  }

  this.refs[collection].push(ref);
};

Manager.prototype.remove = function remove (collection, ref) {
  var index = this.getIndex(collection, ref);

  if (index !== -1) {
    this.refs[collection].splice(index, 1);
  }
};

Manager.prototype.isActive = function isActive () {
  return this.active;
};

Manager.prototype.getActive = function getActive () {
    var this$1 = this;

  return this.refs[this.active.collection].find( // eslint-disable-next-line eqeqeq
  function (ref) {
      var node = ref.node;

      return node.sortableInfo.index == this$1.active.index;
    });
};

Manager.prototype.getIndex = function getIndex (collection, ref) {
  return this.refs[collection].indexOf(ref);
};

Manager.prototype.getOrderedRefs = function getOrderedRefs (collection) {
    if ( collection === void 0 ) collection = this.active.collection;

  return this.refs[collection].sort(sortByIndex);
};

function sortByIndex(ref, ref$1) {
  var index1 = ref.node.sortableInfo.index;
  var index2 = ref$1.node.sortableInfo.index;

  return index1 - index2;
}

function arrayMove(array, from, to) {
  // Will be deprecated soon. Consumers should install 'array-move' instead
  // https://www.npmjs.com/package/array-move
  array = array.slice();
  array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0]);
  return array;
}
function omit(obj) {
  var keysToOmit = [], len = arguments.length - 1;
  while ( len-- > 0 ) keysToOmit[ len ] = arguments[ len + 1 ];

  return Object.keys(obj).reduce(function (acc, key) {
    if (keysToOmit.indexOf(key) === -1) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}
var events = {
  start: ['touchstart', 'mousedown'],
  move: ['touchmove', 'mousemove'],
  end: ['touchend', 'touchcancel', 'mouseup']
};
var vendorPrefix = function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    // Server environment
    return '';
  } // fix for: https://bugzilla.mozilla.org/show_bug.cgi?id=548397
  // window.getComputedStyle() returns null inside an iframe with display: none
  // in this case return an array with a fake mozilla style in it.


  var styles = window.getComputedStyle(document.documentElement, '') || ['-moz-hidden-iframe'];
  var pre = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];

  switch (pre) {
    case 'ms':
      return 'ms';

    default:
      return pre && pre.length ? pre[0].toUpperCase() + pre.substr(1) : '';
  }
}();
function closest(el, fn) {
  while (el) {
    if (fn(el)) {
      return el;
    }

    el = el.parentNode;
  }

  return null;
}
function limit(min, max, value) {
  return Math.max(min, Math.min(value, max));
}

function getPixelValue(stringValue) {
  if (stringValue.substr(-2) === 'px') {
    return parseFloat(stringValue);
  }

  return 0;
}

function getElementMargin(element) {
  var style = window.getComputedStyle(element);
  return {
    top: getPixelValue(style.marginTop),
    right: getPixelValue(style.marginRight),
    bottom: getPixelValue(style.marginBottom),
    left: getPixelValue(style.marginLeft)
  };
}
function provideDisplayName(prefix, Component$$1) {
  var componentName = Component$$1.displayName || Component$$1.name;
  return componentName ? (prefix + "(" + componentName + ")") : prefix;
}
function getPosition(event) {
  if (event.touches && event.touches.length) {
    return {
      x: event.touches[0].pageX,
      y: event.touches[0].pageY
    };
  } else if (event.changedTouches && event.changedTouches.length) {
    return {
      x: event.changedTouches[0].pageX,
      y: event.changedTouches[0].pageY
    };
  } else {
    return {
      x: event.pageX,
      y: event.pageY
    };
  }
}
function isTouchEvent(event) {
  return event.touches && event.touches.length || event.changedTouches && event.changedTouches.length;
}
function getEdgeOffset(node, parent, offset) {
  if ( offset === void 0 ) offset = {
  top: 0,
  left: 0
};

  if (!node) {
    return undefined;
  } // Get the actual offsetTop / offsetLeft value, no matter how deep the node is nested


  var nodeOffset = {
    top: offset.top + node.offsetTop,
    left: offset.left + node.offsetLeft
  };

  if (node.parentNode === parent) {
    return nodeOffset;
  }

  return getEdgeOffset(node.parentNode, parent, nodeOffset);
}
function getLockPixelOffset(ref) {
  var lockOffset = ref.lockOffset;
  var width = ref.width;
  var height = ref.height;

  var offsetX = lockOffset;
  var offsetY = lockOffset;
  var unit = 'px';

  if (typeof lockOffset === 'string') {
    var match = /^[+-]?\d*(?:\.\d*)?(px|%)$/.exec(lockOffset);
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(match !== null, 'lockOffset value should be a number or a string of a ' + 'number followed by "px" or "%". Given %s', lockOffset);
    offsetX = parseFloat(lockOffset);
    offsetY = parseFloat(lockOffset);
    unit = match[1];
  }

  __WEBPACK_IMPORTED_MODULE_3_invariant___default()(isFinite(offsetX) && isFinite(offsetY), 'lockOffset value should be a finite. Given %s', lockOffset);

  if (unit === '%') {
    offsetX = offsetX * width / 100;
    offsetY = offsetY * height / 100;
  }

  return {
    x: offsetX,
    y: offsetY
  };
}

function sortableContainer(WrappedComponent, config) {
  if ( config === void 0 ) config = {
  withRef: false
};

  var _class, _temp;

  return _temp = _class = /*@__PURE__*/(function (superclass) {
    function WithSortableContainer(props) {
      var this$1 = this;

      var _this = this;

      superclass.call(this, props);

      this.handleStart = function (event) {
        var ref = this$1.props;
        var distance = ref.distance;
        var shouldCancelStart = ref.shouldCancelStart;

        if (event.button === 2 || shouldCancelStart(event)) {
          return;
        }

        this$1._touched = true;
        this$1._pos = getPosition(event);
        var node = closest(event.target, function (el) { return el.sortableInfo != null; });

        if (node && node.sortableInfo && this$1.nodeIsChild(node) && !this$1.state.sorting) {
          var ref$1 = this$1.props;
          var useDragHandle = ref$1.useDragHandle;
          var ref$2 = node.sortableInfo;
          var index = ref$2.index;
          var collection = ref$2.collection;

          if (useDragHandle && !closest(event.target, function (el) { return el.sortableHandle != null; })) {
            return;
          }

          this$1.manager.active = {
            index: index,
            collection: collection
          };
          /*
           * Fixes a bug in Firefox where the :active state of anchor tags
           * prevent subsequent 'mousemove' events from being fired
           * (see https://github.com/clauderic/react-sortable-hoc/issues/118)
           */

          if (!isTouchEvent(event) && event.target.tagName.toLowerCase() === 'a') {
            event.preventDefault();
          }

          if (!distance) {
            if (this$1.props.pressDelay === 0) {
              this$1.handlePress(event);
            } else {
              this$1.pressTimer = setTimeout(function () { return this$1.handlePress(event); }, this$1.props.pressDelay);
            }
          }
        }
      };

      this.nodeIsChild = function (node) {
        return node.sortableInfo.manager === this$1.manager;
      };

      this.handleMove = function (event) {
        var ref = this$1.props;
        var distance = ref.distance;
        var pressThreshold = ref.pressThreshold;

        if (!this$1.state.sorting && this$1._touched && !this$1._awaitingUpdateBeforeSortStart) {
          var position = getPosition(event);
          var delta = {
            x: this$1._pos.x - position.x,
            y: this$1._pos.y - position.y
          };
          var combinedDelta = Math.abs(delta.x) + Math.abs(delta.y);
          this$1.delta = delta;

          if (!distance && (!pressThreshold || pressThreshold && combinedDelta >= pressThreshold)) {
            clearTimeout(this$1.cancelTimer);
            this$1.cancelTimer = setTimeout(this$1.cancel, 0);
          } else if (distance && combinedDelta >= distance && this$1.manager.isActive()) {
            this$1.handlePress(event);
          }
        }
      };

      this.handleEnd = function () {
        this$1._touched = false;
        this$1.cancel();
      };

      this.cancel = function () {
        var ref = this$1.props;
        var distance = ref.distance;
        var ref$1 = this$1.state;
        var sorting = ref$1.sorting;

        if (!sorting) {
          if (!distance) {
            clearTimeout(this$1.pressTimer);
          }

          this$1.manager.active = null;
        }
      };

      this.handlePress = function (event) {
        try {
          var active = _this.manager.getActive();

          var _temp5 = function () {
            if (active) {
              function _temp4() {
                var ref;

                var margin = getElementMargin(node);

                var containerBoundingRect = _this.container.getBoundingClientRect();

                var dimensions = getHelperDimensions({
                  index: index,
                  node: node,
                  collection: collection
                });
                _this.node = node;
                _this.margin = margin;
                _this.width = dimensions.width;
                _this.height = dimensions.height;
                _this.marginOffset = {
                  x: _this.margin.left + _this.margin.right,
                  y: Math.max(_this.margin.top, _this.margin.bottom)
                };
                _this.boundingClientRect = node.getBoundingClientRect();
                _this.containerBoundingRect = containerBoundingRect;
                _this.index = index;
                _this.newIndex = index;
                _this.axis = {
                  x: axis.indexOf('x') >= 0,
                  y: axis.indexOf('y') >= 0
                };
                _this.offsetEdge = getEdgeOffset(node, _this.container);
                _this.initialOffset = getPosition(event);
                _this.initialScroll = {
                  top: _this.container.scrollTop,
                  left: _this.container.scrollLeft
                };
                _this.initialWindowScroll = {
                  top: window.pageYOffset,
                  left: window.pageXOffset
                };
                var fields = node.querySelectorAll('input, textarea, select');
                var clonedNode = node.cloneNode(true);
                var clonedFields = [].concat( clonedNode.querySelectorAll('input, textarea, select') );
                clonedFields.forEach(function (field, i) {
                  if (field.type !== 'file' && fields[index]) {
                    field.value = fields[i].value;
                  }
                });
                _this.helper = _this.document.body.appendChild(clonedNode);
                _this.helper.style.position = 'fixed';
                _this.helper.style.top = (_this.boundingClientRect.top - margin.top) + "px";
                _this.helper.style.left = (_this.boundingClientRect.left - margin.left) + "px";
                _this.helper.style.width = (_this.width) + "px";
                _this.helper.style.height = (_this.height) + "px";
                _this.helper.style.boxSizing = 'border-box';
                _this.helper.style.pointerEvents = 'none';

                if (hideSortableGhost) {
                  _this.sortableGhost = node;
                  node.style.visibility = 'hidden';
                  node.style.opacity = 0;
                }

                _this.minTranslate = {};
                _this.maxTranslate = {};

                if (_this.axis.x) {
                  _this.minTranslate.x = (useWindowAsScrollContainer ? 0 : containerBoundingRect.left) - _this.boundingClientRect.left - _this.width / 2;
                  _this.maxTranslate.x = (useWindowAsScrollContainer ? _this.contentWindow.innerWidth : containerBoundingRect.left + containerBoundingRect.width) - _this.boundingClientRect.left - _this.width / 2;
                }

                if (_this.axis.y) {
                  _this.minTranslate.y = (useWindowAsScrollContainer ? 0 : containerBoundingRect.top) - _this.boundingClientRect.top - _this.height / 2;
                  _this.maxTranslate.y = (useWindowAsScrollContainer ? _this.contentWindow.innerHeight : containerBoundingRect.top + containerBoundingRect.height) - _this.boundingClientRect.top - _this.height / 2;
                }

                if (helperClass) {
                  (ref = _this.helper.classList).add.apply(ref, helperClass.split(' '));
                }

                _this.listenerNode = event.touches ? node : _this.contentWindow;
                events.move.forEach(function (eventName) { return _this.listenerNode.addEventListener(eventName, _this.handleSortMove, false); });
                events.end.forEach(function (eventName) { return _this.listenerNode.addEventListener(eventName, _this.handleSortEnd, false); });

                _this.setState({
                  sorting: true,
                  sortingIndex: index
                });

                if (onSortStart) {
                  onSortStart({
                    node: node,
                    index: index,
                    collection: collection
                  }, event);
                }
              }

              var ref = _this.props;
              var axis = ref.axis;
              var getHelperDimensions = ref.getHelperDimensions;
              var helperClass = ref.helperClass;
              var hideSortableGhost = ref.hideSortableGhost;
              var updateBeforeSortStart = ref.updateBeforeSortStart;
              var onSortStart = ref.onSortStart;
              var useWindowAsScrollContainer = ref.useWindowAsScrollContainer;
              var node = active.node;
              var collection = active.collection;
              var ref$1 = node.sortableInfo;
              var index = ref$1.index;

              var _temp3 = function () {
                if (typeof updateBeforeSortStart === 'function') {
                  _this._awaitingUpdateBeforeSortStart = true;

                  var _temp2 = _finallyRethrows(function () {
                    return Promise.resolve(updateBeforeSortStart({
                      node: node,
                      index: index,
                      collection: collection
                    }, event)).then(function () {});
                  }, function (_wasThrown, _result) {
                    _this._awaitingUpdateBeforeSortStart = false;
                    if (_wasThrown) { throw _result; }
                    return _result;
                  });

                  if (_temp2 && _temp2.then) { return _temp2.then(function () {}); }
                }
              }();

              return _temp3 && _temp3.then ? _temp3.then(_temp4) : _temp4(_temp3);
            }
          }();

          return Promise.resolve(_temp5 && _temp5.then ? _temp5.then(function () {}) : void 0);
        } catch (e) {
          return Promise.reject(e);
        }
      };

      this.handleSortMove = function (event) {
        var ref = this$1.props;
        var onSortMove = ref.onSortMove; // Prevent scrolling on mobile

        event.preventDefault();
        this$1.updatePosition(event);
        this$1.animateNodes();
        this$1.autoscroll();

        if (onSortMove) {
          onSortMove(event);
        }
      };

      this.handleSortEnd = function (event) {
        var ref = this$1.props;
        var hideSortableGhost = ref.hideSortableGhost;
        var onSortEnd = ref.onSortEnd;
        var ref$1 = this$1.manager.active;
        var collection = ref$1.collection; // Remove the event listeners if the node is still in the DOM

        if (this$1.listenerNode) {
          events.move.forEach(function (eventName) { return this$1.listenerNode.removeEventListener(eventName, this$1.handleSortMove); });
          events.end.forEach(function (eventName) { return this$1.listenerNode.removeEventListener(eventName, this$1.handleSortEnd); });
        } // Remove the helper from the DOM


        this$1.helper.parentNode.removeChild(this$1.helper);

        if (hideSortableGhost && this$1.sortableGhost) {
          this$1.sortableGhost.style.visibility = '';
          this$1.sortableGhost.style.opacity = '';
        }

        var nodes = this$1.manager.refs[collection];

        for (var i = 0, len = nodes.length; i < len; i++) {
          var node = nodes[i];
          var el = node.node; // Clear the cached offsetTop / offsetLeft value

          node.edgeOffset = null; // Remove the transforms / transitions

          el.style[(vendorPrefix + "Transform")] = '';
          el.style[(vendorPrefix + "TransitionDuration")] = '';
        } // Stop autoscroll


        clearInterval(this$1.autoscrollInterval);
        this$1.autoscrollInterval = null; // Update state

        this$1.manager.active = null;
        this$1.setState({
          sorting: false,
          sortingIndex: null
        });

        if (typeof onSortEnd === 'function') {
          onSortEnd({
            oldIndex: this$1.index,
            newIndex: this$1.newIndex,
            collection: collection
          }, event);
        }

        this$1._touched = false;
      };

      this.autoscroll = function () {
        var translate = this$1.translate;
        var direction = {
          x: 0,
          y: 0
        };
        var speed = {
          x: 1,
          y: 1
        };
        var acceleration = {
          x: 10,
          y: 10
        };

        if (translate.y >= this$1.maxTranslate.y - this$1.height / 2) {
          // Scroll Down
          direction.y = 1;
          speed.y = acceleration.y * Math.abs((this$1.maxTranslate.y - this$1.height / 2 - translate.y) / this$1.height);
        } else if (translate.x >= this$1.maxTranslate.x - this$1.width / 2) {
          // Scroll Right
          direction.x = 1;
          speed.x = acceleration.x * Math.abs((this$1.maxTranslate.x - this$1.width / 2 - translate.x) / this$1.width);
        } else if (translate.y <= this$1.minTranslate.y + this$1.height / 2) {
          // Scroll Up
          direction.y = -1;
          speed.y = acceleration.y * Math.abs((translate.y - this$1.height / 2 - this$1.minTranslate.y) / this$1.height);
        } else if (translate.x <= this$1.minTranslate.x + this$1.width / 2) {
          // Scroll Left
          direction.x = -1;
          speed.x = acceleration.x * Math.abs((translate.x - this$1.width / 2 - this$1.minTranslate.x) / this$1.width);
        }

        if (this$1.autoscrollInterval) {
          clearInterval(this$1.autoscrollInterval);
          this$1.autoscrollInterval = null;
          this$1.isAutoScrolling = false;
        }

        if (direction.x !== 0 || direction.y !== 0) {
          this$1.autoscrollInterval = setInterval(function () {
            this$1.isAutoScrolling = true;
            var offset = {
              left: speed.x * direction.x,
              top: speed.y * direction.y
            };
            this$1.scrollContainer.scrollTop += offset.top;
            this$1.scrollContainer.scrollLeft += offset.left;
            this$1.translate.x += offset.left;
            this$1.translate.y += offset.top;
            this$1.animateNodes();
          }, 5);
        }
      };

      this.manager = new Manager();
      this.events = {
        start: this.handleStart,
        move: this.handleMove,
        end: this.handleEnd
      };
      __WEBPACK_IMPORTED_MODULE_3_invariant___default()(!(props.distance && props.pressDelay), 'Attempted to set both `pressDelay` and `distance` on SortableContainer, you may only use one or the other, not both at the same time.');
      this.state = {};
    }

    if ( superclass ) WithSortableContainer.__proto__ = superclass;
    WithSortableContainer.prototype = Object.create( superclass && superclass.prototype );
    WithSortableContainer.prototype.constructor = WithSortableContainer;

    WithSortableContainer.prototype.getChildContext = function getChildContext () {
      return {
        manager: this.manager
      };
    };

    WithSortableContainer.prototype.componentDidMount = function componentDidMount () {
      var this$1 = this;

      var ref = this.props;
      var useWindowAsScrollContainer = ref.useWindowAsScrollContainer;
      /*
       *  Set our own default rather than using defaultProps because Jest
       *  snapshots will serialize window, causing a RangeError
       *  https://github.com/clauderic/react-sortable-hoc/issues/249
       */

      var container = this.getContainer();
      Promise.resolve(container).then(function (containerNode) {
        this$1.container = containerNode;
        this$1.document = this$1.container.ownerDocument || document;
        var contentWindow = this$1.props.contentWindow || this$1.document.defaultView || window;
        this$1.contentWindow = typeof contentWindow === 'function' ? contentWindow() : contentWindow;
        this$1.scrollContainer = useWindowAsScrollContainer ? this$1.document.scrollingElement || this$1.document.documentElement : this$1.container;

        var loop = function ( key ) {
          if (this$1.events.hasOwnProperty(key)) {
            events[key].forEach(function (eventName) { return this$1.container.addEventListener(eventName, this$1.events[key], false); });
          }
        };

        for (var key in this$1.events) loop( key );
      });
    };

    WithSortableContainer.prototype.componentWillUnmount = function componentWillUnmount () {
      var this$1 = this;

      if (this.container) {
        var loop = function ( key ) {
          if (this$1.events.hasOwnProperty(key)) {
            events[key].forEach(function (eventName) { return this$1.container.removeEventListener(eventName, this$1.events[key]); });
          }
        };

        for (var key in this$1.events) loop( key );
      }
    };

    WithSortableContainer.prototype.getLockPixelOffsets = function getLockPixelOffsets () {
      var ref = this;
      var width = ref.width;
      var height = ref.height;
      var ref$1 = this.props;
      var lockOffset = ref$1.lockOffset;
      var offsets = Array.isArray(lockOffset) ? lockOffset : [lockOffset, lockOffset];
      __WEBPACK_IMPORTED_MODULE_3_invariant___default()(offsets.length === 2, 'lockOffset prop of SortableContainer should be a single ' + 'value or an array of exactly two values. Given %s', lockOffset);
      var minLockOffset = offsets[0];
      var maxLockOffset = offsets[1];
      return [getLockPixelOffset({
        lockOffset: minLockOffset,
        width: width,
        height: height
      }), getLockPixelOffset({
        lockOffset: maxLockOffset,
        width: width,
        height: height
      })];
    };

    WithSortableContainer.prototype.updatePosition = function updatePosition (event) {
      var ref = this.props;
      var lockAxis = ref.lockAxis;
      var lockToContainerEdges = ref.lockToContainerEdges;
      var offset = getPosition(event);
      var translate = {
        x: offset.x - this.initialOffset.x,
        y: offset.y - this.initialOffset.y
      }; // Adjust for window scroll

      translate.y -= window.pageYOffset - this.initialWindowScroll.top;
      translate.x -= window.pageXOffset - this.initialWindowScroll.left;
      this.translate = translate;

      if (lockToContainerEdges) {
        var ref$1 = this.getLockPixelOffsets();
        var minLockOffset = ref$1[0];
        var maxLockOffset = ref$1[1];
        var minOffset = {
          x: this.width / 2 - minLockOffset.x,
          y: this.height / 2 - minLockOffset.y
        };
        var maxOffset = {
          x: this.width / 2 - maxLockOffset.x,
          y: this.height / 2 - maxLockOffset.y
        };
        translate.x = limit(this.minTranslate.x + minOffset.x, this.maxTranslate.x - maxOffset.x, translate.x);
        translate.y = limit(this.minTranslate.y + minOffset.y, this.maxTranslate.y - maxOffset.y, translate.y);
      }

      if (lockAxis === 'x') {
        translate.y = 0;
      } else if (lockAxis === 'y') {
        translate.x = 0;
      }

      this.helper.style[(vendorPrefix + "Transform")] = "translate3d(" + (translate.x) + "px," + (translate.y) + "px, 0)";
    };

    WithSortableContainer.prototype.animateNodes = function animateNodes () {
      var ref = this.props;
      var transitionDuration = ref.transitionDuration;
      var hideSortableGhost = ref.hideSortableGhost;
      var onSortOver = ref.onSortOver;
      var nodes = this.manager.getOrderedRefs();
      var containerScrollDelta = {
        left: this.container.scrollLeft - this.initialScroll.left,
        top: this.container.scrollTop - this.initialScroll.top
      };
      var sortingOffset = {
        left: this.offsetEdge.left + this.translate.x + containerScrollDelta.left,
        top: this.offsetEdge.top + this.translate.y + containerScrollDelta.top
      };
      var windowScrollDelta = {
        top: window.pageYOffset - this.initialWindowScroll.top,
        left: window.pageXOffset - this.initialWindowScroll.left
      };
      var prevIndex = this.newIndex;
      this.newIndex = null;

      for (var i = 0, len = nodes.length; i < len; i++) {
        var ref$1 = nodes[i];
        var node = ref$1.node;
        var index = node.sortableInfo.index;
        var width = node.offsetWidth;
        var height = node.offsetHeight;
        var offset = {
          width: this.width > width ? width / 2 : this.width / 2,
          height: this.height > height ? height / 2 : this.height / 2
        };
        var translate = {
          x: 0,
          y: 0
        };
        var ref$2 = nodes[i];
        var edgeOffset = ref$2.edgeOffset; // If we haven't cached the node's offsetTop / offsetLeft value

        if (!edgeOffset) {
          edgeOffset = getEdgeOffset(node, this.container);
          nodes[i].edgeOffset = edgeOffset;
        } // Get a reference to the next and previous node


        var nextNode = i < nodes.length - 1 && nodes[i + 1];
        var prevNode = i > 0 && nodes[i - 1]; // Also cache the next node's edge offset if needed.
        // We need this for calculating the animation in a grid setup

        if (nextNode && !nextNode.edgeOffset) {
          nextNode.edgeOffset = getEdgeOffset(nextNode.node, this.container);
        } // If the node is the one we're currently animating, skip it


        if (index === this.index) {
          if (hideSortableGhost) {
            /*
             * With windowing libraries such as `react-virtualized`, the sortableGhost
             * node may change while scrolling down and then back up (or vice-versa),
             * so we need to update the reference to the new node just to be safe.
             */
            this.sortableGhost = node;
            node.style.visibility = 'hidden';
            node.style.opacity = 0;
          }

          continue;
        }

        if (transitionDuration) {
          node.style[(vendorPrefix + "TransitionDuration")] = transitionDuration + "ms";
        }

        if (this.axis.x) {
          if (this.axis.y) {
            // Calculations for a grid setup
            if (index < this.index && (sortingOffset.left + windowScrollDelta.left - offset.width <= edgeOffset.left && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height || sortingOffset.top + windowScrollDelta.top + offset.height <= edgeOffset.top)) {
              // If the current node is to the left on the same row, or above the node that's being dragged
              // then move it to the right
              translate.x = this.width + this.marginOffset.x;

              if (edgeOffset.left + translate.x > this.containerBoundingRect.width - offset.width) {
                // If it moves passed the right bounds, then animate it to the first position of the next row.
                // We just use the offset of the next node to calculate where to move, because that node's original position
                // is exactly where we want to go
                translate.x = nextNode.edgeOffset.left - edgeOffset.left;
                translate.y = nextNode.edgeOffset.top - edgeOffset.top;
              }

              if (this.newIndex === null) {
                this.newIndex = index;
              }
            } else if (index > this.index && (sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top || sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top + height)) {
              // If the current node is to the right on the same row, or below the node that's being dragged
              // then move it to the left
              translate.x = -(this.width + this.marginOffset.x);

              if (edgeOffset.left + translate.x < this.containerBoundingRect.left + offset.width) {
                // If it moves passed the left bounds, then animate it to the last position of the previous row.
                // We just use the offset of the previous node to calculate where to move, because that node's original position
                // is exactly where we want to go
                translate.x = prevNode.edgeOffset.left - edgeOffset.left;
                translate.y = prevNode.edgeOffset.top - edgeOffset.top;
              }

              this.newIndex = index;
            }
          } else {
            if (index > this.index && sortingOffset.left + windowScrollDelta.left + offset.width >= edgeOffset.left) {
              translate.x = -(this.width + this.marginOffset.x);
              this.newIndex = index;
            } else if (index < this.index && sortingOffset.left + windowScrollDelta.left <= edgeOffset.left + offset.width) {
              translate.x = this.width + this.marginOffset.x;

              if (this.newIndex == null) {
                this.newIndex = index;
              }
            }
          }
        } else if (this.axis.y) {
          if (index > this.index && sortingOffset.top + windowScrollDelta.top + offset.height >= edgeOffset.top) {
            translate.y = -(this.height + this.marginOffset.y);
            this.newIndex = index;
          } else if (index < this.index && sortingOffset.top + windowScrollDelta.top <= edgeOffset.top + offset.height) {
            translate.y = this.height + this.marginOffset.y;

            if (this.newIndex == null) {
              this.newIndex = index;
            }
          }
        }

        node.style[(vendorPrefix + "Transform")] = "translate3d(" + (translate.x) + "px," + (translate.y) + "px,0)";
      }

      if (this.newIndex == null) {
        this.newIndex = this.index;
      }

      if (onSortOver && this.newIndex !== prevIndex) {
        onSortOver({
          newIndex: this.newIndex,
          oldIndex: prevIndex,
          index: this.index,
          collection: this.manager.active.collection
        });
      }
    };

    WithSortableContainer.prototype.getWrappedInstance = function getWrappedInstance () {
      __WEBPACK_IMPORTED_MODULE_3_invariant___default()(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableContainer() call');
      return this.refs.wrappedInstance;
    };

    WithSortableContainer.prototype.getContainer = function getContainer () {
      var ref = this.props;
      var getContainer = ref.getContainer;

      if (typeof getContainer !== 'function') {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this);
      }

      return getContainer(config.withRef ? this.getWrappedInstance() : undefined);
    };

    WithSortableContainer.prototype.render = function render () {
      var ref = config.withRef ? 'wrappedInstance' : null;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])( WrappedComponent, Object.assign({}, { ref: ref }, omit(this.props, 'contentWindow', 'useWindowAsScrollContainer', 'distance', 'helperClass', 'hideSortableGhost', 'transitionDuration', 'useDragHandle', 'pressDelay', 'pressThreshold', 'shouldCancelStart', 'updateBeforeSortStart', 'onSortStart', 'onSortMove', 'onSortEnd', 'axis', 'lockAxis', 'lockOffset', 'lockToContainerEdges', 'getContainer', 'getHelperDimensions')));
    };

    return WithSortableContainer;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"])), _class.displayName = provideDisplayName('sortableList', WrappedComponent), _class.defaultProps = {
    axis: 'y',
    transitionDuration: 300,
    pressDelay: 0,
    pressThreshold: 5,
    distance: 0,
    useWindowAsScrollContainer: false,
    hideSortableGhost: true,

    shouldCancelStart: function shouldCancelStart(event) {
      // Cancel sorting if the event target is an `input`, `textarea`, `select` or `option`
      var disabledElements = ['input', 'textarea', 'select', 'option', 'button'];

      if (disabledElements.indexOf(event.target.tagName.toLowerCase()) !== -1) {
        // Return true to cancel sorting
        return true;
      }

      return false;
    },

    lockToContainerEdges: false,
    lockOffset: '50%',
    getHelperDimensions: function (ref) {
      var node = ref.node;

      return ({
      width: node.offsetWidth,
      height: node.offsetHeight
    });
  }
  }, _class.propTypes = {
    axis: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['x', 'y', 'xy']),
    distance: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    lockAxis: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    helperClass: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    transitionDuration: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    contentWindow: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
    updateBeforeSortStart: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    onSortStart: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    onSortMove: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    onSortOver: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    onSortEnd: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    shouldCancelStart: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    pressDelay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    pressThreshold: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number,
    useDragHandle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    useWindowAsScrollContainer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    hideSortableGhost: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    lockToContainerEdges: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    lockOffset: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]))]),
    getContainer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    getHelperDimensions: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
  }, _class.childContextTypes = {
    manager: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
  }, _temp;
}

function sortableElement(WrappedComponent, config) {
  if ( config === void 0 ) config = {
  withRef: false
};

  var _class, _temp;

  return _temp = _class = /*@__PURE__*/(function (superclass) {
    function WithSortableElement () {
      superclass.apply(this, arguments);
    }

    if ( superclass ) WithSortableElement.__proto__ = superclass;
    WithSortableElement.prototype = Object.create( superclass && superclass.prototype );
    WithSortableElement.prototype.constructor = WithSortableElement;

    WithSortableElement.prototype.componentDidMount = function componentDidMount () {
      var ref = this.props;
      var collection = ref.collection;
      var disabled = ref.disabled;
      var index = ref.index;

      if (!disabled) {
        this.setDraggable(collection, index);
      }
    };

    WithSortableElement.prototype.componentWillReceiveProps = function componentWillReceiveProps (nextProps) {
      if (this.props.index !== nextProps.index && this.node) {
        this.node.sortableInfo.index = nextProps.index;
      }

      if (this.props.disabled !== nextProps.disabled) {
        var collection = nextProps.collection;
        var disabled = nextProps.disabled;
        var index = nextProps.index;

        if (disabled) {
          this.removeDraggable(collection);
        } else {
          this.setDraggable(collection, index);
        }
      } else if (this.props.collection !== nextProps.collection) {
        this.removeDraggable(this.props.collection);
        this.setDraggable(nextProps.collection, nextProps.index);
      }
    };

    WithSortableElement.prototype.componentWillUnmount = function componentWillUnmount () {
      var ref = this.props;
      var collection = ref.collection;
      var disabled = ref.disabled;

      if (!disabled) {
        this.removeDraggable(collection);
      }
    };

    WithSortableElement.prototype.setDraggable = function setDraggable (collection, index) {
      var node = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this);
      node.sortableInfo = {
        index: index,
        collection: collection,
        manager: this.context.manager
      };
      this.node = node;
      this.ref = {
        node: node
      };
      this.context.manager.add(collection, this.ref);
    };

    WithSortableElement.prototype.removeDraggable = function removeDraggable (collection) {
      this.context.manager.remove(collection, this.ref);
    };

    WithSortableElement.prototype.getWrappedInstance = function getWrappedInstance () {
      __WEBPACK_IMPORTED_MODULE_3_invariant___default()(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableElement() call');
      return this.refs.wrappedInstance;
    };

    WithSortableElement.prototype.render = function render () {
      var ref = config.withRef ? 'wrappedInstance' : null;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])( WrappedComponent, Object.assign({}, { ref: ref }, omit(this.props, 'collection', 'disabled', 'index')));
    };

    return WithSortableElement;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"])), _class.displayName = provideDisplayName('sortableElement', WrappedComponent), _class.contextTypes = {
    manager: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object.isRequired
  }, _class.propTypes = {
    index: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number.isRequired,
    collection: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string]),
    disabled: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
  }, _class.defaultProps = {
    collection: 0
  }, _temp;
}

function sortableHandle(WrappedComponent, config) {
  if ( config === void 0 ) config = {
  withRef: false
};

  var _class, _temp;

  return _temp = _class = /*@__PURE__*/(function (superclass) {
    function WithSortableHandle () {
      superclass.apply(this, arguments);
    }

    if ( superclass ) WithSortableHandle.__proto__ = superclass;
    WithSortableHandle.prototype = Object.create( superclass && superclass.prototype );
    WithSortableHandle.prototype.constructor = WithSortableHandle;

    WithSortableHandle.prototype.componentDidMount = function componentDidMount () {
      var node = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"])(this);
      node.sortableHandle = true;
    };

    WithSortableHandle.prototype.getWrappedInstance = function getWrappedInstance () {
      __WEBPACK_IMPORTED_MODULE_3_invariant___default()(config.withRef, 'To access the wrapped instance, you need to pass in {withRef: true} as the second argument of the SortableHandle() call');
      return this.refs.wrappedInstance;
    };

    WithSortableHandle.prototype.render = function render () {
      var ref = config.withRef ? 'wrappedInstance' : null;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])( WrappedComponent, Object.assign({}, { ref: ref }, this.props));
    };

    return WithSortableHandle;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"])), _class.displayName = provideDisplayName('sortableHandle', WrappedComponent), _temp;
}


//# sourceMappingURL=index.es.js.map


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getMessage", {
  enumerable: true,
  get: function get() {
    return _getMessage["default"];
  }
});
var _getMessage = _interopRequireDefault(__webpack_require__(1859));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isHTMLElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isShadowRoot; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(151);


function isElement(node) {
  var OwnElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}



/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  mobilePrefix: _propTypes2.default.string,
  mobile: _propTypes2.default.string,
  className: _propTypes2.default.string
};

var Phone = function Phone(_ref) {
  var mobilePrefix = _ref.mobilePrefix,
      mobile = _ref.mobile,
      className = _ref.className;

  var prefix = mobilePrefix === 'other' ? '' : mobilePrefix;
  return mobile ? _react2.default.createElement(
    'a',
    { className: className, href: 'tel:+' + prefix + mobile },
    '+',
    prefix,
    mobile
  ) : null;
};

Phone.propTypes = propTypes;

exports.default = Phone;

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _affiliateMappings = __webpack_require__(987);

var _projectMappings = __webpack_require__(997);

var _projectOptions = __webpack_require__(998);

var _projectSpecifications = __webpack_require__(999);

var _projectUnitLayoutSpecifications = __webpack_require__(1000);

var _projectUnitSpecifications = __webpack_require__(554);

var _translation = __webpack_require__(4);

var _unitLayout = __webpack_require__(270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


var isPRS = _config2.default.get('prs');

var SpecificationTable = function (_Component) {
  _inherits(SpecificationTable, _Component);

  function SpecificationTable(props) {
    _classCallCheck(this, SpecificationTable);

    var _this = _possibleConstructorReturn(this, (SpecificationTable.__proto__ || Object.getPrototypeOf(SpecificationTable)).call(this, props));

    _initialiseProps.call(_this);

    var affiliateMappings = props.affiliateMappings ? [].concat(props.affiliateMappings.data) : [];
    var projectMappings = props.projectMappings ? [].concat(props.projectMappings.data) : [];
    var projectOptions = props.projectOptions ? [].concat(props.projectOptions.data) : [];
    var projectSpecifications = props.projectSpecifications ? [].concat(props.projectSpecifications.data) : [];
    var projectUnitLayoutSpecifications = props.projectUnitLayoutSpecifications ? [].concat(props.projectUnitLayoutSpecifications.data) : [];
    var projectUnitSpecifications = props.projectUnitSpecifications ? [].concat(props.projectUnitSpecifications.data) : [];
    var options = [];
    if (props.type) {
      switch (props.type) {
        case 'affiliateMappings':
          options = affiliateMappings.map(function (d) {
            return _this.setPreset(d.name, 'blue');
          });
          break;
        case 'projectMappings':
          options = projectMappings.map(function (d) {
            return _this.setPreset(d.name, 'blue');
          });
          break;
        case 'projectOptions':
          options = projectOptions.map(function (d) {
            return _this.setPreset(d.name, 'blue');
          });
          break;
        case 'projects':
          options = projectSpecifications.map(function (d) {
            return _this.setPreset(d.name, 'blue');
          });
          break;
        // CPI-1208 (Q4): the five Vietnam presets are seeded rows on a table with no company
        // column, so they are filtered out for every company that is not Vietnamese.
        case 'unit_layouts':
          options = (0, _unitLayout.visibleLayoutSpecifications)(props.auth, projectUnitLayoutSpecifications).map(function (d) {
            return _this.setPreset(d.name, 'blue');
          });
          break;
        case 'units':
          options = projectUnitSpecifications.map(function (d) {
            return _this.setPreset(d.name, 'blue');
          });
          break;
        default:
          options = [];
      }
    }
    var data = props.data ? [].concat(props.data) : [];
    if (data.length > 0) {
      var _options;

      options = (_options = options).concat.apply(_options, _toConsumableArray(data.map(function (d) {
        return _this.setPreset(d.name);
      }))).filter(function (d, idx, arr) {
        return idx === arr.findIndex(function (f) {
          return f.text === d.text;
        }) && d.text.length > 0;
      });
    }
    var isEditing = false || props.isEditing;
    _this.state = {
      options: options,
      data: data,
      hideTab: false,
      isEditing: isEditing,
      affiliateMappings: affiliateMappings,
      projectMappings: projectMappings,
      projectOptions: projectOptions,
      projectSpecifications: projectSpecifications,
      projectUnitLayoutSpecifications: projectUnitLayoutSpecifications,
      projectUnitSpecifications: projectUnitSpecifications
    };
    return _this;
  }

  _createClass(SpecificationTable, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;

      if (isPRS) store.dispatch((0, _projectOptions.fetchProjectOptions)(false));
      store.dispatch((0, _projectSpecifications.fetchProjectSpecifications)(false));
      store.dispatch((0, _projectUnitLayoutSpecifications.fetchProjectUnitLayoutSpecifications)(false));
      store.dispatch((0, _projectUnitSpecifications.fetchProjectUnitSpecifications)(false));
      store.dispatch((0, _affiliateMappings.fetchAffiliateMappings)(false));
      store.dispatch((0, _projectMappings.fetchProjectMappings)(false));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var affiliateMappings = nextProps.affiliateMappings ? [].concat(nextProps.affiliateMappings.data) : this.state.affiliateMappings;
      var projectMappings = nextProps.projectMappings ? [].concat(nextProps.projectMappings.data) : this.state.projectMappings;
      var projectOptions = nextProps.projectOptions ? [].concat(nextProps.projectOptions.data) : this.state.projectOptions;
      var projectSpecifications = nextProps.projectSpecifications ? [].concat(nextProps.projectSpecifications.data) : this.state.projectSpecifications;
      var projectUnitLayoutSpecifications = nextProps.projectUnitLayoutSpecifications ? [].concat(nextProps.projectUnitLayoutSpecifications.data) : this.state.projectUnitLayoutSpecifications;
      var projectUnitSpecifications = nextProps.projectUnitSpecifications ? [].concat(nextProps.projectUnitSpecifications.data) : this.state.projectUnitSpecifications;
      var options = [];
      if (nextProps.type) {
        switch (nextProps.type) {
          case 'affiliateMappings':
            options = affiliateMappings.map(function (d) {
              return _this2.setPreset(d.name, 'blue');
            });
            break;
          case 'projectMappings':
            options = projectMappings.map(function (d) {
              return _this2.setPreset(d.name, 'blue');
            });
            break;
          case 'projectOptions':
            options = projectOptions.map(function (d) {
              return _this2.setPreset(d.name, 'blue');
            });
            break;
          case 'projects':
            options = projectSpecifications.map(function (d) {
              return _this2.setPreset(d.name, 'blue');
            });
            break;
          case 'unit_layouts':
            options = (0, _unitLayout.visibleLayoutSpecifications)(nextProps.auth, projectUnitLayoutSpecifications).map(function (d) {
              return _this2.setPreset(d.name, 'blue');
            });
            break;
          case 'units':
            options = projectUnitSpecifications.map(function (d) {
              return _this2.setPreset(d.name, 'blue');
            });
            break;
          default:
            options = [];
        }
      }
      var data = nextProps.data ? [].concat(nextProps.data) : [];
      if (data.length > 0) {
        var _options2;

        options = (_options2 = options).concat.apply(_options2, _toConsumableArray(data.map(function (d) {
          return _this2.setPreset(d.name);
        }))).filter(function (d, idx, arr) {
          return idx === arr.findIndex(function (f) {
            return f.text === d.text;
          }) && d.text.length > 0;
        });
      }
      if (nextProps.editable) {
        var isEditing = nextProps.isEditing;
        if (isEditing !== undefined) {
          this.setState({ isEditing: isEditing });
        }
      }
      this.setState({
        data: data,
        options: options,
        affiliateMappings: affiliateMappings,
        projectMappings: projectMappings,
        projectOptions: projectOptions,
        projectSpecifications: projectSpecifications,
        projectUnitLayoutSpecifications: projectUnitLayoutSpecifications,
        projectUnitSpecifications: projectUnitSpecifications
      });
    }
  }, {
    key: 'handleOnChange',
    value: function handleOnChange(data) {
      this.setState({ data: data });
      if (this.props.onChange) {
        this.props.onChange(data);
      }
    }
  }, {
    key: 'checkIsEditing',
    value: function checkIsEditing() {
      return this.props.editable && this.state.isEditing;
    }
  }, {
    key: 'renderRow',
    value: function renderRow() {
      var _this3 = this;

      var data = this.state.data;
      var t = this.props.t;

      if (this.checkIsEditing()) {
        if (data.length > 0) {
          return data.map(function (row, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Table.Row,
              { key: idx },
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { collapsing: true },
                _react2.default.createElement(
                  _semanticUiReact.Button.Group,
                  { vertical: true, size: 'mini', compact: true },
                  _react2.default.createElement(_semanticUiReact.Button, {
                    type: 'button',
                    icon: 'chevron up',
                    disabled: idx === 0,
                    onClick: function onClick() {
                      return _this3.handleMoveRow(idx, row, -1);
                    }
                  }),
                  _react2.default.createElement(_semanticUiReact.Button, {
                    type: 'button',
                    icon: 'chevron down',
                    disabled: idx + 1 === data.length,
                    onClick: function onClick() {
                      return _this3.handleMoveRow(idx, row, 1);
                    }
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { width: 16 },
                _react2.default.createElement(_semanticUiReact.Dropdown, {
                  options: _this3.state.options,
                  placeholder: _this3.props.placeholderName || t('Enter / select specification'),
                  search: true,
                  selection: true,
                  fluid: true,
                  allowAdditions: true,
                  additionLabel: t('Add') + ' ',
                  value: row.name,
                  onAddItem: _this3.handleAddition,
                  onChange: function onChange(e, d) {
                    return _this3.handleInputSpecifications(d, idx, 'name');
                  },
                  selectOnBlur: false,
                  noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                }),
                _react2.default.createElement(_semanticUiReact.Input, {
                  placeholder: _this3.props.placeholderDescription || t('Enter description'),
                  fluid: true,
                  value: row.value,
                  onChange: function onChange(e, d) {
                    return _this3.handleInputSpecifications(d, idx, 'value');
                  }
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { collapsing: true },
                _react2.default.createElement(_semanticUiReact.Button, {
                  floated: 'right',
                  negative: true,
                  type: 'button',
                  size: 'small',
                  icon: 'trash',
                  onClick: function onClick() {
                    return _this3.handleRemoveRow(idx);
                  }
                })
              )
            );
          });
        }
        return _react2.default.createElement(
          _semanticUiReact.Table.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { colSpan: '3', textAlign: 'center' },
            this.props.notFoundNode || _react2.default.createElement(
              'p',
              null,
              t('No specifications set'),
              '.'
            )
          )
        );
      }
      if (data.length > 0) {
        return data.map(function (row, idx, rows) {
          return _react2.default.createElement(
            _semanticUiReact.Table.Row,
            { key: idx, title: row.description || null },
            idx > 0 && rows[idx - 1].name === row.name ? null : _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              {
                width: 5,
                rowSpan: _this3.getColSpan(row, idx, rows)
              },
              row.name
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              row.value
            )
          );
        });
      }
      return _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { colSpan: '2', textAlign: 'center' },
          _react2.default.createElement(
            _semanticUiReact.Segment,
            { textAlign: 'center', vertical: true },
            this.props.notFoundNode || _react2.default.createElement(
              'p',
              null,
              t('No specifications set'),
              '.'
            ),
            !this.checkIsEditing() && this.props.onAdd ? _react2.default.createElement(
              _semanticUiReact.Button,
              {
                as: 'a',
                primary: true, compact: true,
                disabled: this.props.loading,
                onClick: this.handleOnClick
              },
              t('Click here to add')
            ) : null
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          newHeader = _props.newHeader,
          isCollapsible = _props.isCollapsible,
          t = _props.t;
      var hideTab = this.state.hideTab;

      return _react2.default.createElement(
        'div',
        null,
        newHeader ? _react2.default.createElement(
          _semanticUiReact.Header,
          { className: 'new_title', as: 'h5', attached: 'top', textAlign: 'center' },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 16, textAlign: 'center' },
                newHeader
              ),
              isCollapsible ? _react2.default.createElement(_semanticUiReact.Label, {
                as: 'button',
                attached: 'top right',
                icon: hideTab ? 'angle up' : 'angle down',
                className: 'collapse-button',
                style: {
                  position: 'absolute',
                  right: '0',
                  top: '3px',
                  marginRight: '0',
                  marginTop: '0.5em'
                },
                onClick: this.handleOnCollapseSegment,
                disabled: this.props.loading
              }) : null
            )
          )
        ) : null,
        newHeader && !hideTab ? _react2.default.createElement(
          _semanticUiReact.Segment,
          { attached: true },
          _react2.default.createElement(
            _semanticUiReact.Table,
            {
              style: this.props.tableStyle || {},
              celled: true, striped: true, unstackable: true,
              structured: !this.checkIsEditing(),
              selectable: this.checkIsEditing(),
              compact: this.checkIsEditing()
            },
            this.props.editable ? _react2.default.createElement(
              _semanticUiReact.Table.Header,
              { fullWidth: true },
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                this.props.hideButton ? _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  { colSpan: 2 },
                  this.props.headerNode || t('Specifications')
                ) : _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  { colSpan: 2 },
                  this.props.headerButtonNode && !this.state.isEditing && this.props.headerButtonNode,
                  this.props.cancelNode && this.checkIsEditing() ? this.props.cancelNode({
                    isEditing: this.state.isEditing,
                    onClick: this.handleOnCancel
                  }) : null,
                  !this.props.cancelNode && this.checkIsEditing() ? _react2.default.createElement(_semanticUiReact.Button, {
                    as: 'a',
                    size: 'small',
                    floated: 'left',
                    compact: true,
                    icon: 'remove',
                    content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }),
                    onClick: this.handleOnCancel,
                    disabled: this.props.loading
                  }) : null,
                  this.props.buttonNode && this.props.editable ? this.props.buttonNode({
                    isEditing: this.state.isEditing,
                    onClick: this.handleOnConfirm
                  }) : null,
                  !this.props.buttonNode && this.props.editable ? _react2.default.createElement(_semanticUiReact.Button, {
                    as: 'a',
                    size: 'small',
                    floated: 'right',
                    compact: true,
                    onClick: this.handleOnConfirm,
                    icon: this.checkIsEditing() ? 'save' : 'pencil',
                    color: this.checkIsEditing() ? 'blue' : null,
                    content: t(this.checkIsEditing() ? 'Update' : 'Edit', { ns: _translation.TRANSLATION_FILES.translation }),
                    disabled: this.props.loading
                  }) : null
                ),
                this.checkIsEditing() ? _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  { collapsing: true },
                  _react2.default.createElement(_semanticUiReact.Button, {
                    floated: 'right',
                    primary: true,
                    type: 'button',
                    size: 'small',
                    icon: 'add',
                    onClick: this.handleAddRow
                  })
                ) : null
              )
            ) : this.props.headerButtonNode && !this.state.isEditing ? _react2.default.createElement(
              _semanticUiReact.Table.Header,
              { fullWidth: true },
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  { colSpan: 2 },
                  this.props.headerButtonNode
                )
              )
            ) : null,
            _react2.default.createElement(
              _semanticUiReact.Table.Body,
              null,
              this.renderRow()
            ),
            this.checkIsEditing() ? _react2.default.createElement(
              _semanticUiReact.Table.Footer,
              { fullWidth: true },
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(_semanticUiReact.Table.HeaderCell, { colSpan: 2 }),
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  { collapsing: true },
                  _react2.default.createElement(_semanticUiReact.Button, {
                    floated: 'right',
                    primary: true,
                    type: 'button',
                    size: 'small',
                    icon: 'add',
                    onClick: this.handleAddRow
                  })
                )
              )
            ) : null
          )
        ) : null,
        !newHeader ? _react2.default.createElement(
          _semanticUiReact.Table,
          {
            style: this.props.tableStyle || {},
            celled: true, striped: true, unstackable: true,
            structured: !this.checkIsEditing(),
            selectable: this.checkIsEditing(),
            compact: this.checkIsEditing()
          },
          this.props.editable ? _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              this.props.hideButton ? _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 2 },
                this.props.headerNode || t('Specifications')
              ) : _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 2 },
                this.props.headerButtonNode && !this.state.isEditing && this.props.headerButtonNode,
                this.props.cancelNode && this.checkIsEditing() ? this.props.cancelNode({
                  isEditing: this.state.isEditing,
                  onClick: this.handleOnCancel
                }) : null,
                !this.props.cancelNode && this.checkIsEditing() ? _react2.default.createElement(_semanticUiReact.Button, {
                  as: 'a',
                  size: 'small',
                  floated: 'left',
                  compact: true,
                  icon: 'remove',
                  content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }),
                  onClick: this.handleOnCancel,
                  disabled: this.props.loading
                }) : null,
                this.props.buttonNode && this.props.editable ? this.props.buttonNode({
                  isEditing: this.state.isEditing,
                  onClick: this.handleOnConfirm
                }) : null,
                !this.props.buttonNode && this.props.editable ? _react2.default.createElement(_semanticUiReact.Button, {
                  as: 'a',
                  size: 'small',
                  floated: 'right',
                  compact: true,
                  onClick: this.handleOnConfirm,
                  icon: this.checkIsEditing() ? 'save' : 'pencil',
                  color: this.checkIsEditing() ? 'blue' : null,
                  content: t(this.checkIsEditing() ? 'Update' : 'Edit', { ns: _translation.TRANSLATION_FILES.translation }),
                  disabled: this.props.loading
                }) : null
              ),
              this.checkIsEditing() ? _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { collapsing: true },
                _react2.default.createElement(_semanticUiReact.Button, {
                  floated: 'right',
                  primary: true,
                  type: 'button',
                  size: 'small',
                  icon: 'add',
                  onClick: this.handleAddRow
                })
              ) : null
            )
          ) : this.props.headerButtonNode && !this.state.isEditing ? _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 2 },
                this.props.headerButtonNode
              )
            )
          ) : null,
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            this.renderRow()
          ),
          this.checkIsEditing() ? _react2.default.createElement(
            _semanticUiReact.Table.Footer,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(_semanticUiReact.Table.HeaderCell, { colSpan: 2 }),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { collapsing: true },
                _react2.default.createElement(_semanticUiReact.Button, {
                  floated: 'right',
                  primary: true,
                  type: 'button',
                  size: 'small',
                  icon: 'add',
                  onClick: this.handleAddRow
                })
              )
            )
          ) : null
        ) : null
      );
    }
  }]);

  return SpecificationTable;
}(_react.Component);

SpecificationTable.contextTypes = {
  store: _propTypes2.default.object
};
SpecificationTable.propTypes = {
  type: _propTypes2.default.oneOf(['projects', 'unit_layouts', 'units', 'bookings', 'projectOptions', 'customOptions', 'projectMappings', 'affiliateMappings']).isRequired,
  data: _propTypes2.default.arrayOf(_propTypes2.default.object),
  onAdd: _propTypes2.default.func,
  notFoundNode: _propTypes2.default.node,
  headerNode: _propTypes2.default.string,
  headerButtonNode: _propTypes2.default.string,
  isEditing: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  buttonNode: _propTypes2.default.func,
  cancelNode: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onCancel: _propTypes2.default.func,
  editable: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  hideButton: _propTypes2.default.bool,
  placeholderName: _propTypes2.default.string,
  placeholderDescription: _propTypes2.default.string,
  affiliateMappings: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  projectMappings: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  projectOptions: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  projectSpecifications: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  projectUnitLayoutSpecifications: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  projectUnitSpecifications: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  // CPI-1208 (Q4): only used to decide whether the five Vietnam layout presets are offered.
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  tableStyle: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  newHeader: _propTypes2.default.string,
  isCollapsible: _propTypes2.default.bool
};

SpecificationTable.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    affiliateMappings: state.affiliateMappings,
    projectMappings: state.projectMappings,
    projectOptions: state.projectOptions,
    projectSpecifications: state.projectSpecifications,
    projectUnitLayoutSpecifications: state.projectUnitLayoutSpecifications,
    projectUnitSpecifications: state.projectUnitSpecifications
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.setPreset = function (value) {
    var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    return {
      text: value,
      value: value,
      label: { color: color, empty: true, circular: true }
    };
  };

  this.getColSpan = function (row, idx, rows) {
    var colSpan = 0;
    for (var i = idx; i < rows.length; i += 1) {
      if (rows[i].name !== row.name) {
        break;
      }
      colSpan += 1;
    }
    if (colSpan > 0) {
      return colSpan;
    }
    return null;
  };

  this.handleOnClick = function (e) {
    if (_this4.props.onAdd) {
      _this4.props.onAdd(e);
    }
  };

  this.handleInputSpecifications = function (d, idx, key) {
    var _state = _this4.state,
        data = _state.data,
        affiliateMappings = _state.affiliateMappings,
        projectMappings = _state.projectMappings,
        projectOptions = _state.projectOptions,
        projectSpecifications = _state.projectSpecifications,
        projectUnitLayoutSpecifications = _state.projectUnitLayoutSpecifications,
        projectUnitSpecifications = _state.projectUnitSpecifications;

    data[idx][key] = d.value;
    if (key === 'name') {
      if (_this4.props.type) {
        var ps = void 0;
        switch (_this4.props.type) {
          case 'affiliateMappings':
            ps = affiliateMappings.find(function (p) {
              return p.name === d.value;
            });
            break;
          case 'projectMappings':
            ps = projectMappings.find(function (p) {
              return p.name === d.value;
            });
            break;
          case 'projectOptions':
            ps = projectOptions.find(function (p) {
              return p.name === d.value;
            });
            break;
          case 'unit_layouts':
            ps = projectUnitLayoutSpecifications.find(function (p) {
              return p.name === d.value;
            });
            break;
          case 'units':
            ps = projectUnitSpecifications.find(function (p) {
              return p.name === d.value;
            });
            break;
          case 'projects':
          default:
            ps = projectSpecifications.find(function (p) {
              return p.name === d.value;
            });
        }
        data[idx].shortName = ps ? ps.shortName : '';
        data[idx].description = ps ? ps.description : '';
      }
    }
    _this4.handleOnChange(data);
  };

  this.handleAddRow = function () {
    var data = _this4.state.data;

    data.push({
      name: '',
      shortName: '',
      description: '',
      value: '',
      position: data.length + 1 || 1
    });
    _this4.handleOnChange(data);
  };

  this.handleRemoveRow = function (idx) {
    var data = _this4.state.data;

    data.splice(idx, 1);
    _this4.handleOnChange(data);
  };

  this.handleMoveRow = function (idx, row, incre) {
    var data = _this4.state.data;

    if (idx + incre >= 0 && idx + incre < data.length) {
      data.splice(idx, 1);
      data.splice(idx + incre, 0, row);
    }
    data.forEach(function (d, index) {
      data[index].position = index + 1;
    });
    _this4.handleOnChange(data);
  };

  this.handleOnConfirm = function (e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (_this4.props.editable) {
      var isEditing = !_this4.state.isEditing;
      _this4.setState({ isEditing: isEditing }, function () {
        if (!isEditing) {
          if (_this4.props.onClick) {
            _this4.props.onClick(e);
          }
        }
      });
    } else if (_this4.props.onClick) {
      _this4.props.onClick(e);
    }
  };

  this.handleOnCancel = function (e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (_this4.props.editable) {
      var isEditing = false;
      _this4.setState({ isEditing: isEditing }, function () {
        if (_this4.props.onCancel) {
          _this4.props.onCancel(e);
        }
      });
    }
  };

  this.handleOnCollapseSegment = function (e) {
    e.preventDefault();
    _this4.setState({ hideTab: !_this4.state.hideTab });
  };

  this.handleAddition = function (e, _ref) {
    var value = _ref.value;

    if (value) {
      _this4.setState({
        options: [_this4.setPreset(value)].concat(_toConsumableArray(_this4.state.options))
      });
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(SpecificationTable.mapStateToProps)(SpecificationTable));

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var BOOKING_STATUSES = [{ text: 'Reserved', value: 'reserved', name: 'reserved' }, { text: 'Booked', value: 'booked', name: 'booked' }, { text: 'Cancelled by Developer', value: 'cancelled_developer', name: 'cancelled_developer' }, { text: 'Sold', value: 'sold_spa_signed', name: 'sold_spa_signed' }, { text: 'Waiting List', value: 'cancelled_availability', name: 'cancelled_availability', disabled: true }, { text: 'Expired', value: 'expired', name: 'expired' }];

var BOOKING_STATUSES_ALL = exports.BOOKING_STATUSES_ALL = [{ text: 'Reserved', value: 'reserved', name: 'reserved' }, { text: 'Booked', value: 'booked', name: 'booked' }, { text: 'Cancelled by Developer', value: 'cancelled_developer', name: 'cancelled_developer' }, { text: 'Waiting List', value: 'cancelled_availability', name: 'cancelled_availability' }, { text: 'Sold', value: 'sold_spa_signed', name: 'sold_spa_signed' }, { text: 'Expired', value: 'expired', name: 'expired' }];

var BOOKING_STATUSES_TABS = exports.BOOKING_STATUSES_TABS = [{ text: 'Total', value: 'total', name: 'total', className: 'uc-total' }, { text: 'Reserved', value: 'reserved', name: 'reserved', className: 'uc-reserved' }, { text: 'Booked', value: 'booked', name: 'booked', className: 'uc-booked' }, { text: 'Sold', value: 'sold_spa_signed', name: 'sold_spa_signed', className: 'uc-sold_spa_signed' }, { text: 'Waiting List', value: 'cancelled_availability', name: 'cancelled_availability', className: 'uc-cancelled_availability' }, { text: 'Cancelled', value: 'cancelled_developer', name: 'cancelled_developer', className: 'uc-cancelled_developer' }, { text: 'Expired', value: 'expired', name: 'expired', className: 'uc-expired' }];

var CANCELLED_BOOKING_STATUSES = exports.CANCELLED_BOOKING_STATUSES = [{ text: 'Cancelled by Developer', value: 'cancelled_developer', name: 'cancelled_developer' }, { text: 'Waiting List', value: 'cancelled_availability', name: 'cancelled_availability' }, { text: 'Expired', value: 'expired', name: 'expired' }];

exports.default = BOOKING_STATUSES;

// CPI-1209 (A33/A34): Vietnam shows "Pending Cancellation" on the sales list - as a tile, as a
// filter option and as the row's status. It is a VIEW, not a seventh booking status: bookings.
// status_id stays FK-constrained to the six rows above, and a sale awaiting approval keeps the
// status it already had, so nothing that counts Reserved/Booked/Sold/Cancelled changes meaning.
// The signal is the pair of columns book-api already writes when a cancellation is requested.

var BOOKING_STATUS_PENDING_CANCELLATION = exports.BOOKING_STATUS_PENDING_CANCELLATION = 'pending_cancellation';

// The tile and the row flag borrow the CRM's existing pending-cancellation colour
// (src/styles/components/updatedBasicComponents.less), so no new style is introduced.
var PENDING_CANCELLATION_STATUS = exports.PENDING_CANCELLATION_STATUS = {
  text: 'Pending Cancellation',
  value: BOOKING_STATUS_PENDING_CANCELLATION,
  name: BOOKING_STATUS_PENDING_CANCELLATION
};

var PENDING_CANCELLATION_TAB = exports.PENDING_CANCELLATION_TAB = _extends({}, PENDING_CANCELLATION_STATUS, {
  className: 'uc-opportunity-pending_cancellation'
});

// "immediately before Cancelled" per the ticket. Falls back to appending if the Cancelled entry
// is ever renamed, so a rename cannot silently drop the option.
var insertBeforeCancelled = function insertBeforeCancelled(list, item) {
  var idx = list.findIndex(function (s) {
    return s.value === 'cancelled_developer';
  });
  if (idx < 0) return [].concat(_toConsumableArray(list), [item]);
  return [].concat(_toConsumableArray(list.slice(0, idx)), [item], _toConsumableArray(list.slice(idx)));
};

// Both helpers return the ORIGINAL array by reference when the flag is off, so Malaysia and
// Indonesia render from the identical object they render from today.
var bookingStatusesAll = exports.bookingStatusesAll = function bookingStatusesAll() {
  var withPendingCancellation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return withPendingCancellation ? insertBeforeCancelled(BOOKING_STATUSES_ALL, PENDING_CANCELLATION_STATUS) : BOOKING_STATUSES_ALL;
};

var bookingStatusesTabs = exports.bookingStatusesTabs = function bookingStatusesTabs() {
  var withPendingCancellation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return withPendingCancellation ? insertBeforeCancelled(BOOKING_STATUSES_TABS, PENDING_CANCELLATION_TAB) : BOOKING_STATUSES_TABS;
};

// The same predicate book-api's manage view uses (handlers/manage.go): a cancellation has been
// requested, it has not been declined, and the sale is not already cancelled. Kept here so the
// list and the tests read one definition. Both fields arrive on the row for free through
// ListBookings' Column("booking.*").
var isBookingPendingCancellation = exports.isBookingPendingCancellation = function isBookingPendingCancellation(booking) {
  return !!(booking && booking.pendingCancellation && !booking.declinedPendingCancellationAt && booking.statusID !== 'cancelled_developer' && booking.statusID !== 'cancelled_availability');
};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BOOKING_DEFAULT = {
  id: '',
  code: '',
  projectID: '',
  project: {
    printType: 'none',
    maOwnerCompanyBranchID: 0
  },
  projectUnitID: '',
  customerID: '',
  customerDetailID: '',
  customerDetail: {
    address2: ''
  },
  statusID: '',
  bookingStatus: {
    name: ''
  },
  paymentMethodID: '',
  paymentMethod: {
    name: ''
  },
  paymentTypeID: '',
  paymentType: {
    name: ''
  },
  paymentStatusID: '',
  paymentStatus: {
    name: ''
  },
  paymentAmount: '',
  paymentPictures: [],
  paymentAt: '',
  spaValue: '',
  spaDecimal: '',
  spaFull: '',
  spaTimes: '',
  sellingPrice: '',
  nettSellingPrice: '',
  createdAt: '',
  leadCreatedAt: '',
  leadStatus: '',
  bankCases: [],
  assignedMaName: '',
  assignedMaPreferredName: '',
  assignedMaUserID: 0,
  remarkInternal: '',
  newBookingNoteEncoded: '',
  isCancelPending: true,
  bookingCustomFields: [],
  noeticStatusID: 'none',
  noeticSalesID: '',
  bookingFeePayments: [],
  bookingPaymentPaidCents: 0,
  specifications: [],
  salesPersonSignAt: '',
  bookingAttachments: [],
  linkBuyerApp: false,
  buyerProfileID: '',
  srpLoan: '',
  firstTimeBuyer: '',
  externalID: '',
  externalLeadID: ''
};
exports.default = BOOKING_DEFAULT;

/***/ }),
/* 130 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(83);
var createDesc = __webpack_require__(236);
module.exports = __webpack_require__(82) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(332);
var defined = __webpack_require__(179);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var _require = __webpack_require__(46),
    Map = _require.Map,
    OrderedSet = _require.OrderedSet,
    Record = _require.Record; // Immutable.map is typed such that the value for every key in the map
// must be the same type


var EMPTY_SET = OrderedSet();
var defaultRecord = {
  style: EMPTY_SET,
  entity: null
};
var CharacterMetadataRecord = Record(defaultRecord);

var CharacterMetadata = /*#__PURE__*/function (_CharacterMetadataRec) {
  _inheritsLoose(CharacterMetadata, _CharacterMetadataRec);

  function CharacterMetadata() {
    return _CharacterMetadataRec.apply(this, arguments) || this;
  }

  var _proto = CharacterMetadata.prototype;

  _proto.getStyle = function getStyle() {
    return this.get('style');
  };

  _proto.getEntity = function getEntity() {
    return this.get('entity');
  };

  _proto.hasStyle = function hasStyle(style) {
    return this.getStyle().includes(style);
  };

  CharacterMetadata.applyStyle = function applyStyle(record, style) {
    var withStyle = record.set('style', record.getStyle().add(style));
    return CharacterMetadata.create(withStyle);
  };

  CharacterMetadata.removeStyle = function removeStyle(record, style) {
    var withoutStyle = record.set('style', record.getStyle().remove(style));
    return CharacterMetadata.create(withoutStyle);
  };

  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
    return CharacterMetadata.create(withEntity);
  }
  /**
   * Use this function instead of the `CharacterMetadata` constructor.
   * Since most content generally uses only a very small number of
   * style/entity permutations, we can reuse these objects as often as
   * possible.
   */
  ;

  CharacterMetadata.create = function create(config) {
    if (!config) {
      return EMPTY;
    }

    var defaultConfig = {
      style: EMPTY_SET,
      entity: null
    }; // Fill in unspecified properties, if necessary.

    var configMap = Map(defaultConfig).merge(config);
    var existing = pool.get(configMap);

    if (existing) {
      return existing;
    }

    var newCharacter = new CharacterMetadata(configMap);
    pool = pool.set(configMap, newCharacter);
    return newCharacter;
  };

  CharacterMetadata.fromJS = function fromJS(_ref) {
    var style = _ref.style,
        entity = _ref.entity;
    return new CharacterMetadata({
      style: Array.isArray(style) ? OrderedSet(style) : style,
      entity: Array.isArray(entity) ? OrderedSet(entity) : entity
    });
  };

  return CharacterMetadata;
}(CharacterMetadataRecord);

var EMPTY = new CharacterMetadata();
var pool = Map([[Map(defaultRecord), EMPTY]]);
CharacterMetadata.EMPTY = EMPTY;
module.exports = CharacterMetadata;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This file is a fork of ContentBlock adding support for nesting references by
 * providing links to children, parent, prevSibling, and nextSibling.
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var CharacterMetadata = __webpack_require__(133);

var findRangesImmutable = __webpack_require__(339);

var Immutable = __webpack_require__(46);

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;
var EMPTY_SET = OrderedSet();
var defaultRecord = {
  parent: null,
  characterList: List(),
  data: Map(),
  depth: 0,
  key: '',
  text: '',
  type: 'unstyled',
  children: List(),
  prevSibling: null,
  nextSibling: null
};

var haveEqualStyle = function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
};

var haveEqualEntity = function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
};

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;

  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
  }

  return config;
};

var ContentBlockNode = /*#__PURE__*/function (_ref) {
  _inheritsLoose(ContentBlockNode, _ref);

  function ContentBlockNode() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecord;

    /* eslint-disable-next-line constructor-super */
    return _ref.call(this, decorateCharacterList(props)) || this;
  }

  var _proto = ContentBlockNode.prototype;

  _proto.getKey = function getKey() {
    return this.get('key');
  };

  _proto.getType = function getType() {
    return this.get('type');
  };

  _proto.getText = function getText() {
    return this.get('text');
  };

  _proto.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  _proto.getLength = function getLength() {
    return this.getText().length;
  };

  _proto.getDepth = function getDepth() {
    return this.get('depth');
  };

  _proto.getData = function getData() {
    return this.get('data');
  };

  _proto.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET;
  };

  _proto.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  };

  _proto.getChildKeys = function getChildKeys() {
    return this.get('children');
  };

  _proto.getParentKey = function getParentKey() {
    return this.get('parent');
  };

  _proto.getPrevSiblingKey = function getPrevSiblingKey() {
    return this.get('prevSibling');
  };

  _proto.getNextSiblingKey = function getNextSiblingKey() {
    return this.get('nextSibling');
  };

  _proto.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  };

  _proto.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlockNode;
}(Record(defaultRecord));

module.exports = ContentBlockNode;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;
var BN = __webpack_require__(77);
var minAssert = __webpack_require__(137);
var minUtils = __webpack_require__(1262);

utils.assert = minAssert;
utils.toArray = minUtils.toArray;
utils.zero2 = minUtils.zero2;
utils.toHex = minUtils.toHex;
utils.encode = minUtils.encode;

// Represent num in a w-NAF form
function getNAF(num, w, bits) {
  var naf = new Array(Math.max(num.bitLength(), bits) + 1);
  var i;
  for (i = 0; i < naf.length; i += 1) {
    naf[i] = 0;
  }

  var ws = 1 << (w + 1);
  var k = num.clone();

  for (i = 0; i < naf.length; i++) {
    var z;
    var mod = k.andln(ws - 1);
    if (k.isOdd()) {
      if (mod > (ws >> 1) - 1)
        z = (ws >> 1) - mod;
      else
        z = mod;
      k.isubn(z);
    } else {
      z = 0;
    }

    naf[i] = z;
    k.iushrn(1);
  }

  return naf;
}
utils.getNAF = getNAF;

// Represent k1, k2 in a Joint Sparse Form
function getJSF(k1, k2) {
  var jsf = [
    [],
    [],
  ];

  k1 = k1.clone();
  k2 = k2.clone();
  var d1 = 0;
  var d2 = 0;
  var m8;
  while (k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0) {
    // First phase
    var m14 = (k1.andln(3) + d1) & 3;
    var m24 = (k2.andln(3) + d2) & 3;
    if (m14 === 3)
      m14 = -1;
    if (m24 === 3)
      m24 = -1;
    var u1;
    if ((m14 & 1) === 0) {
      u1 = 0;
    } else {
      m8 = (k1.andln(7) + d1) & 7;
      if ((m8 === 3 || m8 === 5) && m24 === 2)
        u1 = -m14;
      else
        u1 = m14;
    }
    jsf[0].push(u1);

    var u2;
    if ((m24 & 1) === 0) {
      u2 = 0;
    } else {
      m8 = (k2.andln(7) + d2) & 7;
      if ((m8 === 3 || m8 === 5) && m14 === 2)
        u2 = -m24;
      else
        u2 = m24;
    }
    jsf[1].push(u2);

    // Second phase
    if (2 * d1 === u1 + 1)
      d1 = 1 - d1;
    if (2 * d2 === u2 + 1)
      d2 = 1 - d2;
    k1.iushrn(1);
    k2.iushrn(1);
  }

  return jsf;
}
utils.getJSF = getJSF;

function cachedProperty(obj, name, computer) {
  var key = '_' + name;
  obj.prototype[name] = function cachedProperty() {
    return this[key] !== undefined ? this[key] :
      this[key] = computer.call(this);
  };
}
utils.cachedProperty = cachedProperty;

function parseBytes(bytes) {
  return typeof bytes === 'string' ? utils.toArray(bytes, 'hex') :
    bytes;
}
utils.parseBytes = parseBytes;

function intFromLE(bytes) {
  return new BN(bytes, 'hex', 'le');
}
utils.intFromLE = intFromLE;



/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDirective = isDirective;
exports.isSpecifiedDirective = isSpecifiedDirective;
exports.specifiedDirectives = exports.GraphQLDeprecatedDirective = exports.DEFAULT_DEPRECATION_REASON = exports.GraphQLSkipDirective = exports.GraphQLIncludeDirective = exports.GraphQLDirective = void 0;

var _definition = __webpack_require__(54);

var _scalars = __webpack_require__(184);

var _defineToStringTag = _interopRequireDefault(__webpack_require__(438));

var _defineToJSON = _interopRequireDefault(__webpack_require__(1205));

var _instanceOf = _interopRequireDefault(__webpack_require__(659));

var _invariant = _interopRequireDefault(__webpack_require__(108));

var _directiveLocation = __webpack_require__(345);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-next-line no-redeclare
function isDirective(directive) {
  return (0, _instanceOf.default)(directive, GraphQLDirective);
}
/**
 * Directives are used by the GraphQL runtime as a way of modifying execution
 * behavior. Type system creators will usually not create these directly.
 */


var GraphQLDirective =
/*#__PURE__*/
function () {
  function GraphQLDirective(config) {
    _defineProperty(this, "name", void 0);

    _defineProperty(this, "description", void 0);

    _defineProperty(this, "locations", void 0);

    _defineProperty(this, "args", void 0);

    _defineProperty(this, "astNode", void 0);

    this.name = config.name;
    this.description = config.description;
    this.locations = config.locations;
    this.astNode = config.astNode;
    !config.name ? (0, _invariant.default)(0, 'Directive must be named.') : void 0;
    !Array.isArray(config.locations) ? (0, _invariant.default)(0, 'Must provide locations for directive.') : void 0;
    var args = config.args;

    if (!args) {
      this.args = [];
    } else {
      !!Array.isArray(args) ? (0, _invariant.default)(0, "@".concat(config.name, " args must be an object with argument names as keys.")) : void 0;
      this.args = Object.keys(args).map(function (argName) {
        var arg = args[argName];
        return {
          name: argName,
          description: arg.description === undefined ? null : arg.description,
          type: arg.type,
          defaultValue: arg.defaultValue,
          astNode: arg.astNode
        };
      });
    }
  }

  var _proto = GraphQLDirective.prototype;

  _proto.toString = function toString() {
    return '@' + this.name;
  };

  return GraphQLDirective;
}(); // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported


exports.GraphQLDirective = GraphQLDirective;
(0, _defineToStringTag.default)(GraphQLDirective);
(0, _defineToJSON.default)(GraphQLDirective);

/**
 * Used to conditionally include fields or fragments.
 */
var GraphQLIncludeDirective = new GraphQLDirective({
  name: 'include',
  description: 'Directs the executor to include this field or fragment only when ' + 'the `if` argument is true.',
  locations: [_directiveLocation.DirectiveLocation.FIELD, _directiveLocation.DirectiveLocation.FRAGMENT_SPREAD, _directiveLocation.DirectiveLocation.INLINE_FRAGMENT],
  args: {
    if: {
      type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLBoolean),
      description: 'Included when true.'
    }
  }
});
/**
 * Used to conditionally skip (exclude) fields or fragments.
 */

exports.GraphQLIncludeDirective = GraphQLIncludeDirective;
var GraphQLSkipDirective = new GraphQLDirective({
  name: 'skip',
  description: 'Directs the executor to skip this field or fragment when the `if` ' + 'argument is true.',
  locations: [_directiveLocation.DirectiveLocation.FIELD, _directiveLocation.DirectiveLocation.FRAGMENT_SPREAD, _directiveLocation.DirectiveLocation.INLINE_FRAGMENT],
  args: {
    if: {
      type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLBoolean),
      description: 'Skipped when true.'
    }
  }
});
/**
 * Constant string used for default reason for a deprecation.
 */

exports.GraphQLSkipDirective = GraphQLSkipDirective;
var DEFAULT_DEPRECATION_REASON = 'No longer supported';
/**
 * Used to declare element of a GraphQL schema as deprecated.
 */

exports.DEFAULT_DEPRECATION_REASON = DEFAULT_DEPRECATION_REASON;
var GraphQLDeprecatedDirective = new GraphQLDirective({
  name: 'deprecated',
  description: 'Marks an element of a GraphQL schema as no longer supported.',
  locations: [_directiveLocation.DirectiveLocation.FIELD_DEFINITION, _directiveLocation.DirectiveLocation.ENUM_VALUE],
  args: {
    reason: {
      type: _scalars.GraphQLString,
      description: 'Explains why this element was deprecated, usually also including a ' + 'suggestion for how to access supported similar data. Formatted using ' + 'the Markdown syntax (as specified by [CommonMark](https://commonmark.org/).',
      defaultValue: DEFAULT_DEPRECATION_REASON
    }
  }
});
/**
 * The full list of specified directives.
 */

exports.GraphQLDeprecatedDirective = GraphQLDeprecatedDirective;
var specifiedDirectives = [GraphQLIncludeDirective, GraphQLSkipDirective, GraphQLDeprecatedDirective];
exports.specifiedDirectives = specifiedDirectives;

function isSpecifiedDirective(directive) {
  return specifiedDirectives.some(function (specifiedDirective) {
    return specifiedDirective.name === directive.name;
  });
}

/***/ }),
/* 137 */
/***/ (function(module, exports) {

module.exports = assert;

function assert(val, msg) {
  if (!val)
    throw new Error(msg || 'Assertion failed');
}

assert.equal = function assertEqual(l, r, msg) {
  if (l != r)
    throw new Error(msg || ('Assertion failed: ' + l + ' != ' + r));
};


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMatches_js__ = __webpack_require__(3360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__ = __webpack_require__(3361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__property_js__ = __webpack_require__(3473);






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */];
  }
  if (typeof value == 'object') {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value)
      ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__["a" /* default */])(value[0], value[1])
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseMatches_js__["a" /* default */])(value);
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__property_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIteratee);


/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LAWYERS = exports.LAWYERS = '/lawyers';
var LAWYER = exports.LAWYER = function LAWYER(id) {
  return LAWYERS + '/' + id;
};

var PROJECT = exports.PROJECT = function PROJECT(id) {
  return '/projects/' + id;
};

var PANEL_LAWYERS = exports.PANEL_LAWYERS = function PANEL_LAWYERS(projectID) {
  return '' + LAWYERS + PROJECT(projectID);
};
var PANEL_LAWYER = exports.PANEL_LAWYER = function PANEL_LAWYER(projectID, id) {
  return '' + LAWYER(id) + PROJECT(projectID);
};

var BOOKING_CASES = exports.BOOKING_CASES = function BOOKING_CASES(bookingID) {
  return LAWYERS + '/cases/' + bookingID;
};
var BOOKING_AGING_CASES = exports.BOOKING_AGING_CASES = LAWYERS + '/cases/aging';
var LAWYER_CASES = exports.LAWYER_CASES = function LAWYER_CASES(id) {
  return LAWYER(id) + '/cases';
};
var LAWYER_CASE = exports.LAWYER_CASE = function LAWYER_CASE(id, caseID) {
  return LAWYER_CASES(id) + '/' + caseID;
};
var LAWYER_CASE_DETAILS = exports.LAWYER_CASE_DETAILS = function LAWYER_CASE_DETAILS(id, caseID) {
  return LAWYER_CASE(id, caseID) + '/details';
};

var LAWYER_INVITES = exports.LAWYER_INVITES = LAWYERS + '/invites';
var INVITE_LAWYER = exports.INVITE_LAWYER = function INVITE_LAWYER(projectID) {
  return LAWYERS + '/invite/' + projectID;
};
var LAWYER_RESEND_INVITE = exports.LAWYER_RESEND_INVITE = function LAWYER_RESEND_INVITE(inviteID) {
  return LAWYERS + '/invitation/' + inviteID + '/resend';
};

var LAWYER_REPORT_CASES_SUMMARY_COUNT = exports.LAWYER_REPORT_CASES_SUMMARY_COUNT = function LAWYER_REPORT_CASES_SUMMARY_COUNT(companyID) {
  return LAWYERS + '/report/' + companyID + '/cases_summary_count';
};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var INTL_FLAG_CODES = [{ value: '213', text: 'Algeria (213)', countryCode: 'dz' }, { value: '1684', text: 'American Samoa (1684)', countryCode: 'as' }, { value: '376', text: 'Andorra (376)', countryCode: 'ad' }, { value: '244', text: 'Angola (244)', countryCode: 'ao' }, { value: '1264', text: 'Anguilla (1264)', countryCode: 'ai' }, { value: '672', text: 'Antarctica/Norfolk Island (672)', countryCode: 'nf' }, { value: '1268', text: 'Antigua And Barbuda (1268)', countryCode: 'ag' }, { value: '54', text: 'Argentina (54)', countryCode: 'ar' }, { value: '355', text: 'Armenia (355)', countryCode: 'am' }, { value: '297', text: 'Aruba (297)', countryCode: 'aw' }, { value: '61', text: 'Australia/Cocos/Christmas Islands (61)', countryCode: 'au' }, { value: '43', text: 'Austria (43)', countryCode: 'at' }, { value: '994', text: 'Azerbaijan (994)', countryCode: 'az' }, { value: '973', text: 'Bahrain (973)', countryCode: 'bh' }, { value: '880', text: 'Bangladesh (880)', countryCode: 'bd' }, { value: '1246', text: 'Barbados (1246)', countryCode: 'bb' }, { value: '375', text: 'Belarus (375)', countryCode: 'by' }, { value: '32', text: 'Belgium (32)', countryCode: 'be' }, { value: '501', text: 'Belize (501)', countryCode: 'bz' }, { value: '229', text: 'Benin (229)', countryCode: 'bj' }, { value: '1441', text: 'Bermuda (1441)', countryCode: 'bm' }, { value: '975', text: 'Bhutan (975)', countryCode: 'bt' }, { value: '591', text: 'Bolivia (591)', countryCode: 'bo' }, { value: '387', text: 'Bosnia And Herzegowina (387)', countryCode: 'ba' }, { value: '267', text: 'Botswana (267)', countryCode: 'bw' }, { value: '55', text: 'Brazil (55)', countryCode: 'br' }, { value: '673', text: 'Brunei Darussalam (673)', countryCode: 'bn' }, { value: '359', text: 'Bulgaria (359)', countryCode: 'bg' }, { value: '226', text: 'Burkina Faso (226)', countryCode: 'bf' }, { value: '257', text: 'Burundi (257)', countryCode: 'bi' }, { value: '855', text: 'Cambodia (855)', countryCode: 'kh' }, { value: '237', text: 'Cameroon (237)', countryCode: 'cm' }, { value: '1', text: 'Canada (1)', countryCode: 'ca' }, { value: '1345', text: 'Cayman Islands (1345)', countryCode: 'ky' }, { value: '236', text: 'Central African Republic (236)', countryCode: 'cf' }, { value: '235', text: 'Chad (235)', countryCode: 'td' }, { value: '56', text: 'Chile (56)', countryCode: 'cl' }, { value: '86', text: 'China (86)', countryCode: 'cn' }, { value: '61', text: 'Christmas Islands (61)', countryCode: 'cx' }, { value: '61', text: 'Cocos (61)', countryCode: 'cc' }, { value: '57', text: 'Colombia (57)', countryCode: 'co' }, { value: '269', text: 'Comoros (269)', countryCode: 'km' }, { value: '243', text: 'Congo, Democratic Republic Of (243)', countryCode: 'cd' }, { value: '242', text: 'Congo, Peoples Republic Of (242)', countryCode: 'cg' }, { value: '682', text: 'Cook Islands (682)', countryCode: 'ck' }, { value: '506', text: 'Costa Rica (506)', countryCode: 'cr' }, { value: '225', text: 'Cote DIvoire (225)', countryCode: 'ci' }, { value: '385', text: 'Croatia (385)', countryCode: 'hr' }, { value: '53', text: 'Cuba (53)', countryCode: 'cu' }, { value: '357', text: 'Cyprus (357)', countryCode: 'cy' }, { value: '420', text: 'Czech Republic (420)', countryCode: 'cz' }, { value: '45', text: 'Denmark (45)', countryCode: 'dk' }, { value: '253', text: 'Djibouti (253)', countryCode: 'dj' }, { value: '1767', text: 'Dominica (1767)', countryCode: 'dm' }, { value: '1809', text: 'Dominican Republic (1809)', countryCode: 'do' }, { value: '670', text: 'East Timor/Timor-Leste (670)', countryCode: 'tl' }, { value: '593', text: 'Ecuador (593)', countryCode: 'ec' }, { value: '20', text: 'Egypt (20)', countryCode: 'eg' }, { value: '503', text: 'El Salvador (503)', countryCode: 'sv' }, { value: '240', text: 'Equatorial Guinea (240)', countryCode: 'gq' }, { value: '372', text: 'Estonia (372)', countryCode: 'ee' }, { value: '251', text: 'Ethiopia (251)', countryCode: 'et' }, { value: '500', text: 'Falkland Islands (Malvinas) (500)', countryCode: 'fk' }, { value: '298', text: 'Faroe Islands (298)', countryCode: 'fo' }, { value: '679', text: 'Fiji (679)', countryCode: 'fj' }, { value: '358', text: 'Finland (358)', countryCode: 'fi' }, { value: '33', text: 'France (33)', countryCode: 'fr' }, { value: '594', text: 'French Guiana (594)', countryCode: 'gf' }, { value: '689', text: 'French Polynesia (689)', countryCode: 'pf' }, { value: '241', text: 'Gabon (241)', countryCode: 'ga' }, { value: '220', text: 'Gambia (220)', countryCode: 'gm' }, { value: '995', text: 'Georgia (995)', countryCode: 'ge' }, { value: '49', text: 'Germany (49)', countryCode: 'de' }, { value: '233', text: 'Ghana (233)', countryCode: 'gh' }, { value: '350', text: 'Gibraltar (350)', countryCode: 'gi' }, { value: '30', text: 'Greece (30)', countryCode: 'gr' }, { value: '299', text: 'Greenland (299)', countryCode: 'gl' }, { value: '1473', text: 'Grenada (1473)', countryCode: 'gd' }, { value: '590', text: 'Guadeloupe/Saint Barthelemy (590)', countryCode: 'gp' }, { value: '1671', text: 'Guam (1671)', countryCode: 'gu' }, { value: '502', text: 'Guatemala (502)', countryCode: 'gt' }, { value: '224', text: 'Guinea (224)', countryCode: 'gn' }, { value: '245', text: 'Guinea-Bissau (245)', countryCode: 'gw' }, { value: '592', text: 'Guyana (592)', countryCode: 'gy' }, { value: '509', text: 'Haiti (509)', countryCode: 'ht' }, { value: '504', text: 'Honduras (504)', countryCode: 'hn' }, { value: '852', text: 'Hong Kong (852)', countryCode: 'hk' }, { value: '36', text: 'Hungary (36)', countryCode: 'hu' }, { value: '354', text: 'Iceland (354)', countryCode: 'is' }, { value: '91', text: 'India (91)', countryCode: 'in' }, { value: '62', text: 'Indonesia (62)', countryCode: 'id' }, { value: '98', text: 'Iran (98)', countryCode: 'ir' }, { value: '964', text: 'Iraq (964)', countryCode: 'iq' }, { value: '353', text: 'Ireland (353)', countryCode: 'ie' }, { value: '972', text: 'Israel (972)', countryCode: 'il' }, { value: '39', text: 'Italy (39)', countryCode: 'it' }, { value: '1876', text: 'Jamaica (1876)', countryCode: 'jm' }, { value: '81', text: 'Japan (81)', countryCode: 'jp' }, { value: '962', text: 'Jordan (962)', countryCode: 'jo' }, { value: '7', text: 'Kazakhstan (7)', countryCode: 'kz' }, { value: '254', text: 'Kenya (254)', countryCode: 'ke' }, { value: '686', text: 'Kiribati (686)', countryCode: 'ki' }, { value: '850', text: 'Korea, North (850)', countryCode: 'kp' }, { value: '82', text: 'South Korea (82)', countryCode: 'kr' }, { value: '965', text: 'Kuwait (965)', countryCode: 'kw' }, { value: '996', text: 'Kyrgyzstan (996)', countryCode: 'kg' }, { value: '856', text: 'Laos (856)', countryCode: 'la' }, { value: '371', text: 'Latvia (371)', countryCode: 'lv' }, { value: '961', text: 'Lebanon (961)', countryCode: 'lb' }, { value: '266', text: 'Lesotho (266)', countryCode: 'ls' }, { value: '231', text: 'Liberia (231)', countryCode: 'lr' }, { value: '218', text: 'Libyan Arab Jamahiriya (218)', countryCode: 'ly' }, { value: '423', text: 'Liechtenstein (423)', countryCode: 'li' }, { value: '370', text: 'Lithuania (370)', countryCode: 'lt' }, { value: '352', text: 'Luxembourg (352)', countryCode: 'lu' }, { value: '853', text: 'Macao (853)', countryCode: 'mo' }, { value: '389', text: 'Macedonia (389)', countryCode: 'mk' }, { value: '261', text: 'Madagascar (261)', countryCode: 'mg' }, { value: '265', text: 'Malawi (265)', countryCode: 'mw' }, { value: '60', text: 'Malaysia (60)', countryCode: 'my' }, { value: '960', text: 'Maldives (960)', countryCode: 'mv' }, { value: '223', text: 'Mali (223)', countryCode: 'ml' }, { value: '356', text: 'Malta (356)', countryCode: 'mt' }, { value: '692', text: 'Marshall Islands (692)', countryCode: 'mh' }, { value: '596', text: 'Martinique (596)', countryCode: 'mq' }, { value: '222', text: 'Mauritania (222)', countryCode: 'mr' }, { value: '230', text: 'Mauritius (230)', countryCode: 'mu' }, { value: '262', text: 'Mayotte Islands (262)', countryCode: 'yt' }, { value: '52', text: 'Mexico (52)', countryCode: 'mx' }, { value: '691', text: 'Micronesia (691)', countryCode: 'fm' }, { value: '373', text: 'Moldova (373)', countryCode: 'md' }, { value: '377', text: 'Monaco (377)', countryCode: 'mc' }, { value: '976', text: 'Mongolia (976)', countryCode: 'mn' }, { value: '382', text: 'Montenegro (382)', countryCode: 'me' }, { value: '664', text: 'Montserrat (664)', countryCode: 'ms' }, { value: '212', text: 'Morocco (212)', countryCode: 'ma' }, { value: '258', text: 'Mozambique (258)', countryCode: 'mz' }, { value: '95', text: 'Myanmar (95)', countryCode: 'mm' }, { value: '264', text: 'Namibia (264)', countryCode: 'na' }, { value: '674', text: 'Nauru (674)', countryCode: 'nr' }, { value: '977', text: 'Nepal (977)', countryCode: 'np' }, { value: '31', text: 'Netherlands (31)', countryCode: 'nl' }, { value: '687', text: 'New Caledonia (687)', countryCode: 'nc' }, { value: '64', text: 'New Zealand (64)', countryCode: 'nz' }, { value: '505', text: 'Nicaragua (505)', countryCode: 'ni' }, { value: '227', text: 'Niger (227)', countryCode: 'ne' }, { value: '234', text: 'Nigeria (234)', countryCode: 'ng' }, { value: '683', text: 'Niue (683)', countryCode: 'nu' }, { value: '47', text: 'Norway (47)', countryCode: 'no' }, { value: '968', text: 'Oman (968)', countryCode: 'om' }, { value: '92', text: 'Pakistan (92)', countryCode: 'pk' }, { value: '680', text: 'Palau (680)', countryCode: 'pw' }, { value: '507', text: 'Panama (507)', countryCode: 'pa' }, { value: '675', text: 'Papua New Guinea (675)', countryCode: 'pg' }, { value: '595', text: 'Paraguay (595)', countryCode: 'py' }, { value: '51', text: 'Peru (51)', countryCode: 'pe' }, { value: '63', text: 'Philippines (63)', countryCode: 'ph' }, { value: '48', text: 'Poland (48)', countryCode: 'pl' }, { value: '351', text: 'Portugal (351)', countryCode: 'pt' }, { value: '974', text: 'Qatar (974)', countryCode: 'qa' }, { value: '40', text: 'Romania (40)', countryCode: 'ro' }, { value: '7', text: 'Russia (7)', countryCode: 'ru' }, { value: '250', text: 'Rwanda (250)', countryCode: 'rw' }, { value: '1869', text: 'Saint Kitts And Nevis (1869)', countryCode: 'kn' }, { value: '1758', text: 'Saint Lucia (1758)', countryCode: 'lc' }, { value: '1784', text: 'Saint Vincent And The Grenadines (1784)', countryCode: 'vc' }, { value: '685', text: 'Samoa (685)', countryCode: 'ws' }, { value: '378', text: 'San Marino (378)', countryCode: 'sm' }, { value: '239', text: 'Sao Tome And Principe (239)', countryCode: 'st' }, { value: '966', text: 'Saudi Arabia (966)', countryCode: 'sa' }, { value: '221', text: 'Senegal (221)', countryCode: 'sn' }, { value: '381', text: 'Serbia/Yugoslavia (381)', countryCode: 'cs' }, { value: '232', text: 'Sierra Leone (232)', countryCode: 'sl' }, { value: '65', text: 'Singapore (65)', countryCode: 'sg' }, { value: '421', text: 'Slovakia (Slovak Republic) (421)', countryCode: 'sk' }, { value: '386', text: 'Slovenia (386)', countryCode: 'si' }, { value: '677', text: 'Solomon Islands (677)', countryCode: 'sb' }, { value: '252', text: 'Somalia (252)', countryCode: 'so' }, { value: '27', text: 'South Africa (27)', countryCode: 'za' }, { value: '34', text: 'Spain (34)', countryCode: 'es' }, { value: '94', text: 'Sri Lanka (94)', countryCode: 'lk' }, { value: '290', text: 'St. Helena (290)', countryCode: 'sh' }, { value: '508', text: 'St. Pierre And Miquelon (508)', countryCode: 'pm' }, { value: '249', text: 'Sudan (249)', countryCode: 'sd' }, { value: '597', text: 'Suritext (597)', countryCode: 'sr' }, { value: '268', text: 'Swaziland (268)', countryCode: 'sz' }, { value: '46', text: 'Sweden (46)', countryCode: 'se' }, { value: '41', text: 'Switzerland (41)', countryCode: 'ch' }, { value: '963', text: 'Syrian Arab Republic (963)', countryCode: 'sy' }, { value: '886', text: 'Taiwan (886)', countryCode: 'tw' }, { value: '992', text: 'Tajikistan (992)', countryCode: 'tj' }, { value: '255', text: 'Tanzania, United Republic Of (255)', countryCode: 'tz' }, { value: '66', text: 'Thailand (66)', countryCode: 'th' }, { value: '228', text: 'Togo (228)', countryCode: 'tg' }, { value: '676', text: 'Tonga (676)', countryCode: 'to' }, { value: '1868', text: 'Trinidad And Tobago (1868)', countryCode: 'tt' }, { value: '216', text: 'Tunisia (216)', countryCode: 'tn' }, { value: '90', text: 'Turkey (90)', countryCode: 'tr' }, { value: '993', text: 'Turkmenistan (993)', countryCode: 'tm' }, { value: '1649', text: 'Turks And Caicos Islands (1649)', countryCode: 'tc' }, { value: '688', text: 'Tuvalu (688)', countryCode: 'tv' }, { value: '256', text: 'Uganda (256)', countryCode: 'ug' }, { value: '380', text: 'Ukraine (380)', countryCode: 'ua' }, { value: '971', text: 'United Arab Emirates (971)', countryCode: 'ae' }, { value: '44', text: 'United Kingdom (44)', countryCode: 'gb' }, { value: '1', text: 'United States (1)', countryCode: 'us' }, { value: '598', text: 'Uruguay (598)', countryCode: 'uy' }, { value: '998', text: 'Uzbekistan (998)', countryCode: 'uz' }, { value: '678', text: 'Vanuatu (678)', countryCode: 'vu' }, { value: '58', text: 'Venezuela (58)', countryCode: 've' }, { value: '84', text: 'Vietnam (84)', countryCode: 'vn' }, { value: '1284', text: 'Virgin Islands (British) (1284)', countryCode: 'vg' }, { value: '1340', text: 'Virgin Islands (U.S) (1340)', countryCode: 'vi' }, { value: '681', text: 'Wallis And Futuna Islands  (681)', countryCode: 'wf' }, { value: '967', text: 'Yemen (967)', countryCode: 'ye' }, { value: '260', text: 'Zambia (260)', countryCode: 'zm' }, { value: '263', text: 'Zimbabwe (263)', countryCode: 'zw' }, { value: 'other', text: 'Other' }];

exports.default = INTL_FLAG_CODES;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var TYPE_CASE_SPA = exports.TYPE_CASE_SPA = 'SPA';
var TYPE_CASE_LA = exports.TYPE_CASE_LA = 'LA';

var LAWYER_CASE_TYPES = exports.LAWYER_CASE_TYPES = [{ text: TYPE_CASE_SPA, value: TYPE_CASE_SPA, name: TYPE_CASE_SPA }, { text: TYPE_CASE_LA, value: TYPE_CASE_LA, name: TYPE_CASE_LA }];

var DEVELOPER_CANCELLED = exports.DEVELOPER_CANCELLED = 'DEVELOPER_CANCELLED';
var DEVELOPER_CANCELLED_OPTION = exports.DEVELOPER_CANCELLED_OPTION = { text: 'Developer Cancelled', value: DEVELOPER_CANCELLED, name: DEVELOPER_CANCELLED, color: 'status-danger' };

// SPA Tracker status
var PENDING_APPOINTMENT = exports.PENDING_APPOINTMENT = 'PENDING_APPOINTMENT';
var SPA_SIGNED_PENDING = exports.SPA_SIGNED_PENDING = 'SPA_SIGNED_PENDING';
var SPA_SIGNED = exports.SPA_SIGNED = 'SPA_SIGNED';
var SPA_RECEIVED = exports.SPA_RECEIVED = 'SPA_RECEIVED';
var DEVELOPER_SIGNED = exports.DEVELOPER_SIGNED = 'DEVELOPER_SIGNED';
var LAWYER_COLLECTED = exports.LAWYER_COLLECTED = 'LAWYER_COLLECTED';
var SOLD = exports.SOLD = 'SOLD';
var DEVELOPER_RECEIVED = exports.DEVELOPER_RECEIVED = 'DEVELOPER_RECEIVED';

var PENDING_APPOINTMENT_OPTION = exports.PENDING_APPOINTMENT_OPTION = { text: 'Pending Appointment', value: PENDING_APPOINTMENT, name: PENDING_APPOINTMENT, color: 'status-warning' };
var SPA_SIGNED_PENDING_OPTION = exports.SPA_SIGNED_PENDING_OPTION = { text: 'SPA Signed Pending', value: SPA_SIGNED_PENDING, name: SPA_SIGNED_PENDING, color: 'status-warning' };
var SPA_SIGNED_OPTION = exports.SPA_SIGNED_OPTION = { text: 'SPA Signed', value: SPA_SIGNED, name: SPA_SIGNED, color: 'status-good' };
var SPA_RECEIVED_OPTION = exports.SPA_RECEIVED_OPTION = { text: 'SPA Received', value: SPA_RECEIVED, name: SPA_RECEIVED, color: 'status-good' };
var DEVELOPER_SIGNED_OPTION = exports.DEVELOPER_SIGNED_OPTION = { text: 'Developer Signed', value: DEVELOPER_SIGNED, name: DEVELOPER_SIGNED, color: 'status-good' };
var LAWYER_COLLECTED_OPTION = exports.LAWYER_COLLECTED_OPTION = { text: 'Lawyer Collected', value: LAWYER_COLLECTED, name: LAWYER_COLLECTED, color: 'status-good' };
var SOLD_OPTION = exports.SOLD_OPTION = { text: 'SPA Stamped', value: SOLD, name: SOLD, color: 'status-good' };
var DEVELOPER_RECEIVED_OPTION = exports.DEVELOPER_RECEIVED_OPTION = { text: 'Developer Received', value: DEVELOPER_RECEIVED, name: DEVELOPER_RECEIVED, color: 'status-good' };

var LAWYER_SPA_STATUSES = exports.LAWYER_SPA_STATUSES = [PENDING_APPOINTMENT_OPTION, SPA_SIGNED_PENDING_OPTION, SPA_SIGNED_OPTION, SPA_RECEIVED_OPTION, DEVELOPER_SIGNED_OPTION, LAWYER_COLLECTED_OPTION, SOLD_OPTION, DEVELOPER_RECEIVED_OPTION, DEVELOPER_CANCELLED_OPTION];

var LAWYER_SPA_STATUS_MILESTONES = exports.LAWYER_SPA_STATUS_MILESTONES = [PENDING_APPOINTMENT_OPTION, SPA_SIGNED_OPTION, SPA_RECEIVED_OPTION, DEVELOPER_SIGNED_OPTION, LAWYER_COLLECTED_OPTION, SOLD_OPTION, DEVELOPER_RECEIVED_OPTION];

var getLawyerSPACaseStatuses = exports.getLawyerSPACaseStatuses = function getLawyerSPACaseStatuses() {
  var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : PENDING_APPOINTMENT;
  var company = arguments[1];
  var hasUpdateAccess = arguments[2];

  var statuses = [];
  var currentStatus = LAWYER_SPA_STATUSES.find(function (s) {
    return s.value === status;
  });
  if (currentStatus) {
    statuses.push(_extends({}, currentStatus, { disabled: true }));
  }
  var hasAccess = company && company.lawyerAllowBuLeadersUpdate && hasUpdateAccess;
  switch (status) {
    case PENDING_APPOINTMENT:
      if (hasAccess) statuses.push(SPA_SIGNED_OPTION);
      break;
    case SPA_SIGNED:
      if (hasAccess) statuses.push(PENDING_APPOINTMENT_OPTION);
      statuses.push(SPA_RECEIVED_OPTION);
      break;
    case SPA_RECEIVED:
      if (hasAccess) statuses.push(SPA_SIGNED_OPTION);
      statuses.push(DEVELOPER_SIGNED_OPTION);
      break;
    case DEVELOPER_SIGNED:
      if (hasAccess) statuses.push(SPA_RECEIVED_OPTION);
      statuses.push(LAWYER_COLLECTED_OPTION);
      break;
    case LAWYER_COLLECTED:
      if (hasAccess) statuses.push(DEVELOPER_SIGNED_OPTION);
      statuses.push(SOLD_OPTION);
      break;
    case SOLD:
      if (hasAccess) statuses.push(LAWYER_COLLECTED_OPTION);
      statuses.push(DEVELOPER_RECEIVED_OPTION);
      break;
    default:
      break;
  }

  if (status !== SOLD) {
    statuses.push(DEVELOPER_CANCELLED_OPTION);
  }

  return statuses;
};

// LA Tracker status
var NEW = exports.NEW = 'NEW';
var LA_SIGNED_BY_BORROWER = exports.LA_SIGNED_BY_BORROWER = 'LA_SIGNED_BY_BORROWER';
var LA_SIGNED_BY_BANK = exports.LA_SIGNED_BY_BANK = 'LA_SIGNED_BY_BANK';
var LOU_SIGNED_ISSUED = exports.LOU_SIGNED_ISSUED = 'LOU_SIGNED_ISSUED';
var LA_STAMPED = exports.LA_STAMPED = 'LA_STAMPED';
var ADVICE_BANK = exports.ADVICE_BANK = 'ADVICE_BANK';
var FIRST_DISBURSEMENT = exports.FIRST_DISBURSEMENT = 'FIRST_DISBURSEMENT';

var NEW_OPTION = exports.NEW_OPTION = { text: 'New', value: NEW, name: NEW, color: 'status-info' };
var LA_SIGNED_BY_BORROWER_OPTION = exports.LA_SIGNED_BY_BORROWER_OPTION = { text: 'LA Signed by Borrower', value: LA_SIGNED_BY_BORROWER, name: LA_SIGNED_BY_BORROWER, color: 'status-good' };
var LA_SIGNED_BY_BANK_OPTION = exports.LA_SIGNED_BY_BANK_OPTION = { text: 'LA Signed by Bank', value: LA_SIGNED_BY_BANK, name: LA_SIGNED_BY_BANK, color: 'status-good' };
var LOU_SIGNED_ISSUED_OPTION = exports.LOU_SIGNED_ISSUED_OPTION = { text: 'LOU Signed & Issued', value: LOU_SIGNED_ISSUED, name: LOU_SIGNED_ISSUED, color: 'status-good' };
var LA_STAMPED_OPTION = exports.LA_STAMPED_OPTION = { text: 'LA Stamped', value: LA_STAMPED, name: LA_STAMPED, color: 'status-good' };
var ADVICE_BANK_OPTION = exports.ADVICE_BANK_OPTION = { text: 'Advice Bank for 1st Draw Down', value: ADVICE_BANK, name: ADVICE_BANK, color: 'status-danger' };
var FIRST_DISBURSEMENT_OPTION = exports.FIRST_DISBURSEMENT_OPTION = { text: '1st Disbursement', value: FIRST_DISBURSEMENT, name: FIRST_DISBURSEMENT, color: 'status-danger' };

var LAWYER_LA_STATUSES = exports.LAWYER_LA_STATUSES = [NEW_OPTION, LA_SIGNED_BY_BORROWER_OPTION, LA_SIGNED_BY_BANK_OPTION, LOU_SIGNED_ISSUED_OPTION, LA_STAMPED_OPTION, ADVICE_BANK_OPTION, FIRST_DISBURSEMENT_OPTION, DEVELOPER_CANCELLED_OPTION];

var LAWYER_LA_STATUS_MILESTONES = exports.LAWYER_LA_STATUS_MILESTONES = [NEW_OPTION, LA_SIGNED_BY_BORROWER_OPTION, LA_SIGNED_BY_BANK_OPTION, LOU_SIGNED_ISSUED_OPTION, LA_STAMPED_OPTION, ADVICE_BANK_OPTION, FIRST_DISBURSEMENT_OPTION];

var getLawyerLACaseStatuses = exports.getLawyerLACaseStatuses = function getLawyerLACaseStatuses() {
  var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NEW;
  var company = arguments[1];
  var hasUpdateAccess = arguments[2];

  var statuses = [];
  var currentStatus = LAWYER_LA_STATUSES.find(function (s) {
    return s.value === status;
  });
  if (currentStatus) {
    statuses.push(_extends({}, currentStatus, { disabled: true }));
  }
  var hasAccess = company && company.lawyerAllowBuLeadersUpdate && hasUpdateAccess;
  if (hasAccess) {
    switch (status) {
      case NEW:
        statuses.push(LA_SIGNED_BY_BORROWER_OPTION);
        break;
      case LA_SIGNED_BY_BORROWER:
        statuses.push(NEW_OPTION);
        statuses.push(LA_SIGNED_BY_BANK_OPTION);
        break;
      case LA_SIGNED_BY_BANK:
        statuses.push(LA_SIGNED_BY_BORROWER_OPTION);
        statuses.push(LOU_SIGNED_ISSUED_OPTION);
        break;
      case LOU_SIGNED_ISSUED:
        statuses.push(LA_SIGNED_BY_BANK_OPTION);
        statuses.push(LA_STAMPED_OPTION);
        break;
      case LA_STAMPED:
        statuses.push(LOU_SIGNED_ISSUED_OPTION);
        statuses.push(ADVICE_BANK_OPTION);
        break;
      case ADVICE_BANK:
        statuses.push(LA_STAMPED_OPTION);
        statuses.push(FIRST_DISBURSEMENT_OPTION);
        break;
      default:
        break;
    }
  }
  if (status !== FIRST_DISBURSEMENT_OPTION) {
    statuses.push(DEVELOPER_CANCELLED_OPTION);
  }
  return statuses;
};

var LAWYER_ALL_STATUSES = exports.LAWYER_ALL_STATUSES = [PENDING_APPOINTMENT_OPTION, SPA_SIGNED_PENDING_OPTION, SPA_SIGNED_OPTION, SPA_RECEIVED_OPTION, DEVELOPER_SIGNED_OPTION, LAWYER_COLLECTED_OPTION, SOLD_OPTION, DEVELOPER_RECEIVED_OPTION].concat(LAWYER_LA_STATUSES);

var getLawyerCaseStatuses = exports.getLawyerCaseStatuses = function getLawyerCaseStatuses(caseType) {
  switch (caseType) {
    case TYPE_CASE_SPA:
      return LAWYER_SPA_STATUSES;
    case TYPE_CASE_LA:
      return LAWYER_LA_STATUSES;
    default:
      return LAWYER_ALL_STATUSES;
  }
};

// Secondary SPA Lawyer
var LAWYER_STATUS_ACTIVE = exports.LAWYER_STATUS_ACTIVE = 'active';
var LAWYER_STATUS_CANCELLED = exports.LAWYER_STATUS_CANCELLED = 'cancelled';
var REP_TYPE_DEVELOPER = exports.REP_TYPE_DEVELOPER = 'developer';
var REP_TYPE_PURCHASER = exports.REP_TYPE_PURCHASER = 'purchaser';

var SPA_LAWYER_REP_OPTIONS = exports.SPA_LAWYER_REP_OPTIONS = [{ text: 'Developer', value: REP_TYPE_DEVELOPER }, { text: 'Purchaser', value: REP_TYPE_PURCHASER }];

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var REG_URL = exports.REG_URL = '^(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})([/\\w .-]*)*/?(\\?[\\w\\d._%+-=&amp;]*)?$';

var REGEX_TIN_VALID = exports.REGEX_TIN_VALID = /^[A-Za-z]{1,2}\d{9,14}$/;

var REGEX_POSTCODE_MY = exports.REGEX_POSTCODE_MY = /^\d{5}$/;

// Indonesia NPWP (Nomor Pokok Wajib Pajak) regex (new & old regex)
// Matches a 16-digit NPWP (new format) or a 15-digit NPWP with formatting (old format)
var REGEX_NPWP_ID = exports.REGEX_NPWP_ID = /^(\d{16}|\d{2}\.\d{3}\.\d{3}\.\d-\d{3}\.\d{3})$/;

var REGEX_BANK_ACCOUNT_NUMBER = exports.REGEX_BANK_ACCOUNT_NUMBER = /^\d{10,16}$/;

var REGEX_FULL_NAME = exports.REGEX_FULL_NAME = /^[A-Za-z\s''-]{3,100}$/;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var STATES = [{ kod_negeri_id: '01', value: 'Johor', text: 'Johor' }, { kod_negeri_id: '02', value: 'Kedah', text: 'Kedah' }, { kod_negeri_id: '03', value: 'Kelantan', text: 'Kelantan' }, { kod_negeri_id: '14', value: 'Kuala Lumpur', text: 'Wilayah Persekutuan Kuala Lumpur' }, { kod_negeri_id: '15', value: 'Labuan', text: 'Wilayah Persekutuan Labuan' }, { kod_negeri_id: '04', value: 'Malacca', text: 'Melaka' }, { kod_negeri_id: '05', value: 'Negeri Sembilan', text: 'Negeri Sembilan' }, { kod_negeri_id: '06', value: 'Pahang', text: 'Pahang' }, { kod_negeri_id: '07', value: 'Penang', text: 'Pulau Pinang' }, { kod_negeri_id: '08', value: 'Perak', text: 'Perak' }, { kod_negeri_id: '09', value: 'Perlis', text: 'Perlis' }, { kod_negeri_id: '16', value: 'Putrajaya', text: 'Wilayah Persekutuan Putrajaya' }, { kod_negeri_id: '12', value: 'Sabah', text: 'Sabah' }, { kod_negeri_id: '13', value: 'Sarawak', text: 'Sarawak' }, { kod_negeri_id: '10', value: 'Selangor', text: 'Selangor' }, { kod_negeri_id: '11', value: 'Terengganu', text: 'Terengganu' }];

exports.default = STATES;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StateAuth = exports.BookingNoteDefault = exports.BookingNotePropTypes = undefined;

var _BookingNote = __webpack_require__(2568);

var _BookingNote2 = _interopRequireDefault(_BookingNote);

var _StateAuth = __webpack_require__(2569);

var _StateAuth2 = _interopRequireDefault(_StateAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BookingNotePropTypes = _BookingNote2.default;
exports.BookingNoteDefault = _BookingNote.BookingNoteDefault;
exports.StateAuth = _StateAuth2.default;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = required;
exports.getPhoneValidRegex = getPhoneValidRegex;

var _webValidations = __webpack_require__(23);

function required(value, opts) {
  (0, _webValidations.assertString)(value);
  var options = Object.assign({}, opts);
  var key = options.key,
      label = options.label,
      message = options.message,
      validRegex = options.validRegex;

  if (key === undefined) {
    key = 'key';
  }
  if (label === undefined) {
    label = 'Field';
  }
  if (message === undefined) {
    message = label + ' is not a valid phone number';
  }
  if (validRegex === undefined) {
    validRegex = '^\\d+$';
  }
  var e = new RegExp(validRegex, 'i');
  var validity = (0, _webValidations.createValidity)(key);
  if (value !== '' && !e.test(value)) {
    validity.isValid = false;
    validity.message = message;
  }
  return validity;
}

function getPhoneValidRegex(presets, prefix, type) {
  var regex = '^[0-9]*$';
  if (prefix && presets) {
    var preset = presets.find(function (pvp) {
      return pvp.type === type && pvp.prefix === prefix;
    });
    if (preset) {
      regex = preset.regex;
    }
  }
  return regex;
}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(51);

module.exports = function (method, arg) {
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call
    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
  });
};


/***/ }),
/* 148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(356);


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ __webpack_exports__["a"] = (get);


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(169);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWindow;
function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAddressSettings = fetchAddressSettings;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function addressSettingsRequest() {
  return {
    type: _actions.ADDRESS_SETTINGS_REQUEST
  };
}

function addressSettingsSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.ADDRESS_SETTINGS_SUCCESS,
    payload: {
      data: data,
      token: token
    }
  };
}

function addressSettingsError(message) {
  return {
    type: _actions.ADDRESS_SETTINGS_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchAddressSettings() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(addressSettingsRequest());
    if (!fresh) {
      var addressSettingsData = {};
      try {
        addressSettingsData = JSON.parse(localStorage.getItem(_config2.default.get('appName') + '.addressSettings')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!addressSettingsData.data || _config2.default.get('version') !== addressSettingsData.version) {
        reload = true;
      } else {
        dispatch((0, _fetchM.fetchM)('/address_settings/last_updated/', {
          credentials: 'include'
        })).then(function (data) {
          reload = (0, _momentTimezone2.default)(data.lastUpdatedAt).isAfter((0, _momentTimezone2.default)(addressSettingsData.createdAt));
        }).catch(function (err) {
          return dispatch((0, _error.handleError)(err, addressSettingsError));
        });
      }
      if (!reload) {
        dispatch(addressSettingsSuccess(addressSettingsData.data));
        return Promise.resolve();
      }
    }
    return dispatch((0, _fetchM.fetchM)('/address_settings/', {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        localStorage.setItem(_config2.default.get('appName') + '.addressSettings', JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(addressSettingsSuccess(data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, addressSettingsError));
    });
  };
}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditableBox = function (_Component) {
  _inherits(EditableBox, _Component);

  function EditableBox(props) {
    _classCallCheck(this, EditableBox);

    var _this = _possibleConstructorReturn(this, (EditableBox.__proto__ || Object.getPrototypeOf(EditableBox)).call(this, props));

    _initialiseProps.call(_this);

    var isEditing = false || props.isEditing;
    var showPreview = false || props.showPreview;
    _this.state = {
      isEditing: isEditing,
      showPreview: showPreview,
      hideTab: false
    };
    return _this;
  }

  _createClass(EditableBox, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.editable) {
        var isEditing = nextProps.isEditing;
        if (isEditing !== undefined) {
          this.setState({ isEditing: isEditing });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          buttonNode = _props.buttonNode,
          editable = _props.editable,
          newHeader = _props.newHeader,
          isCollapsible = _props.isCollapsible,
          showPreview = _props.showPreview,
          t = _props.t;
      var _state = this.state,
          isEditing = _state.isEditing,
          hideTab = _state.hideTab;

      var showButtons = editable && (!newHeader || newHeader && isCollapsible) && (isEditing || buttonNode || !showPreview);
      return _react2.default.createElement(
        'div',
        null,
        newHeader && _react2.default.createElement(
          _semanticUiReact.Header,
          { className: 'new_title', as: 'h5', attached: 'top', textAlign: 'center' },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            this.props.editable ? _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 16, textAlign: 'center' },
                this.props.newHeader
              ),
              !isCollapsible ? _react2.default.createElement(
                'div',
                null,
                this.state.isEditing && (this.props.cancelNode ? this.props.cancelNode({
                  isEditing: this.state.isEditing,
                  onClick: this.handleOnCancel
                }) : _react2.default.createElement(_semanticUiReact.Label, {
                  as: 'button',
                  attached: 'top left',
                  style: {
                    position: 'absolute',
                    left: '0',
                    top: '3px',
                    marginLeft: '0'
                  },
                  color: 'grey',
                  content: t('Cancel'),
                  icon: 'remove',
                  onClick: this.handleOnCancel,
                  disabled: this.props.loading
                })),
                this.props.buttonNode ? this.props.buttonNode({
                  isEditing: this.state.isEditing,
                  onClick: this.handleOnConfirm
                }) : _react2.default.createElement(_semanticUiReact.Label, {
                  as: 'button',
                  attached: 'top right',
                  style: {
                    right: '0',
                    top: this.state.isEditing ? '3px' : '0.4em'
                  },
                  color: this.state.isEditing ? 'blue' : null,
                  content: t(this.state.isEditing ? 'Update' : 'Edit'),
                  icon: this.state.isEditing ? 'save' : 'edit',
                  onClick: this.handleOnConfirm,
                  disabled: this.props.loading,
                  className: this.state.isEditing ? '' : 'editable-button-new'
                })
              ) : _react2.default.createElement(_semanticUiReact.Label, {
                as: 'button',
                attached: 'top right',
                icon: hideTab ? 'angle up' : 'angle down',
                className: 'collapse-button',
                style: {
                  position: 'absolute',
                  right: '0',
                  top: '3px',
                  marginRight: '0',
                  marginTop: '0.5em'
                },
                onClick: this.handleOnCollapseSegment,
                disabled: this.props.loading
              })
            ) : _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 16, textAlign: 'center' },
                this.props.newHeader
              )
            )
          )
        ),
        !hideTab ? _react2.default.createElement(
          _semanticUiReact.Segment,
          {
            attached: newHeader !== '',
            basic: this.props.hideBorder && !this.state.isEditing,
            style: newHeader && isCollapsible ? { padding: '1em' } : {}
          },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            this.props.gridProps,
            showButtons && _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              this.state.isEditing && (this.props.cancelNode ? this.props.cancelNode({
                isEditing: this.state.isEditing,
                onClick: this.handleOnCancel
              }) : _react2.default.createElement(_semanticUiReact.Label, {
                as: 'button',
                attached: 'top left',
                size: 'small',
                content: t('Cancel'),
                icon: 'remove',
                onClick: this.handleOnCancel,
                disabled: this.props.loading
              })),
              this.props.buttonNode && this.props.buttonNode({
                isEditing: this.state.isEditing,
                onClick: this.handleOnConfirm
              }),
              !this.props.buttonNode && !showPreview && _react2.default.createElement(_semanticUiReact.Label, {
                as: 'button',
                attached: 'top right',
                size: 'small',
                color: this.state.isEditing ? 'blue' : null,
                content: t(this.state.isEditing ? 'Update' : 'Edit'),
                icon: this.state.isEditing ? 'save' : 'edit',
                onClick: this.handleOnConfirm,
                disabled: this.props.loading,
                className: this.state.isEditing ? '' : 'editable-button'
              })
            ),
            this.props.content ? _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 16 },
                this.props.content({
                  isEditing: this.state.isEditing,
                  onConfirm: this.handleOnConfirm,
                  onCancel: this.handleOnCancel
                })
              )
            ) : null
          )
        ) : null
      );
    }
  }]);

  return EditableBox;
}(_react.Component);

EditableBox.propTypes = {
  gridProps: _propTypes2.default.shape({
    stackable: _propTypes2.default.bool
  }),
  buttonNode: _propTypes2.default.func,
  cancelNode: _propTypes2.default.func,
  color: _propTypes2.default.string,
  isEditing: _propTypes2.default.bool,
  editable: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  onCancel: _propTypes2.default.func,
  onEdit: _propTypes2.default.func,
  content: _propTypes2.default.func,
  hideBorder: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  newHeader: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  isCollapsible: _propTypes2.default.bool,
  showPreview: _propTypes2.default.bool,
  t: _propTypes2.default.func
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleOnConfirm = function (e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (_this2.props.editable && _this2.props.onCancel) {
      var isEditing = !_this2.state.isEditing;
      if (_this2.props.isEditing !== undefined) {
        isEditing = _this2.props.isEditing;
      }
      _this2.setState({ isEditing: isEditing }, function () {
        if (_this2.props.isEditing !== undefined) {
          if (isEditing) {
            if (_this2.props.onClick) {
              _this2.props.onClick(e);
            }
          } else if (_this2.props.onEdit) {
            _this2.props.onEdit(e);
          }
        } else if (!isEditing) {
          if (_this2.props.onClick) {
            _this2.props.onClick(e);
          }
        } else if (_this2.props.onEdit) {
          _this2.props.onEdit(e);
        }
      });
    } else if (_this2.props.onClick) {
      _this2.props.onClick(e);
    }
  };

  this.handleOnCancel = function (e) {
    if (e && e.preventDefault) {
      e.preventDefault();
    }
    if (_this2.props.editable) {
      var isEditing = false;
      _this2.setState({ isEditing: isEditing }, function () {
        if (_this2.props.onCancel) {
          _this2.props.onCancel(e);
        }
      });
    }
  };

  this.handleOnCollapseSegment = function (e) {
    e.preventDefault();
    _this2.setState({ hideTab: !_this2.state.hideTab });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.translation)(EditableBox);

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var IDENTITY_TYPE_OPTS = [{ text: 'MyKad (NRIC)', value: 1, tin_code: 'NRIC' }, { text: 'Passport', value: 2, tin_code: 'PASSPORT' }, { text: 'Military / Police', value: 3, tin_code: 'ARMY' }, { text: 'Company Registration Number', value: 4, tin_code: 'BRN' }];
exports.default = IDENTITY_TYPE_OPTS;
var IDENTITY_TYPE_NRIC = exports.IDENTITY_TYPE_NRIC = 1;
var IDENTITY_TYPE_PASSPORT = exports.IDENTITY_TYPE_PASSPORT = 2;
var IDENTITY_TYPE_MILITARY = exports.IDENTITY_TYPE_MILITARY = 3;
var IDENTITY_TYPE_BRN = exports.IDENTITY_TYPE_BRN = 4;

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GENERIC_TIN_UNMATCHED_ERROR_MSG = exports.isGenericTinFound = exports.getGenericTinByIdTypeAndTinNo = exports.getAutoFillTin = exports.isForeignIdType = exports.FOREIGN_GENERIC_TIN_LIST = exports.LOCAL_GENERIC_TIN_LIST = exports.GENERIC_TIN_VALUES = exports.GENERIC_TIN_MAP = exports.GOVERNMENT_GENERIC_TIN = exports.FOREIGN_SUPPLIER_GENERIC_TIN = exports.FOREIGN_BUYER_GENERIC_TIN = exports.PUBLIC_GENERIC_TIN = undefined;

var _defaultIdentityTypeOpts = __webpack_require__(154);

var BOOKING_STATUSES_TIN_VALIDATION = [{ text: 'Booked and Sold', value: 'booked_and_sold', name: 'booked_and_sold' }, { text: 'Sold', value: 'sold', name: 'sold' }]; /* eslint-disable max-len */
exports.default = BOOKING_STATUSES_TIN_VALIDATION;
var PUBLIC_GENERIC_TIN = exports.PUBLIC_GENERIC_TIN = 'EI00000000010';
var FOREIGN_BUYER_GENERIC_TIN = exports.FOREIGN_BUYER_GENERIC_TIN = 'EI00000000020';
var FOREIGN_SUPPLIER_GENERIC_TIN = exports.FOREIGN_SUPPLIER_GENERIC_TIN = 'EI00000000030';
var GOVERNMENT_GENERIC_TIN = exports.GOVERNMENT_GENERIC_TIN = 'EI00000000040';

var GENERIC_TIN_MAP = exports.GENERIC_TIN_MAP = [{ idType: _defaultIdentityTypeOpts.IDENTITY_TYPE_NRIC, genericTin: PUBLIC_GENERIC_TIN, isForeignEntity: false, autofill: false }, { idType: _defaultIdentityTypeOpts.IDENTITY_TYPE_PASSPORT, genericTin: FOREIGN_BUYER_GENERIC_TIN, isForeignEntity: true, autofill: true }, { idType: _defaultIdentityTypeOpts.IDENTITY_TYPE_PASSPORT, genericTin: FOREIGN_SUPPLIER_GENERIC_TIN, isForeignEntity: true, autofill: false }, { idType: _defaultIdentityTypeOpts.IDENTITY_TYPE_MILITARY, genericTin: PUBLIC_GENERIC_TIN, isForeignEntity: false, autofill: false }, { idType: _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN, genericTin: '', isForeignEntity: false, autofill: true }, { idType: _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN, genericTin: FOREIGN_BUYER_GENERIC_TIN, isForeignEntity: true, autofill: true }, { idType: _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN, genericTin: FOREIGN_SUPPLIER_GENERIC_TIN, isForeignEntity: true, autofill: false }];

var GENERIC_TIN_VALUES = exports.GENERIC_TIN_VALUES = GENERIC_TIN_MAP.map(function (e) {
  return e.genericTin;
});
var LOCAL_GENERIC_TIN_LIST = exports.LOCAL_GENERIC_TIN_LIST = [PUBLIC_GENERIC_TIN, GOVERNMENT_GENERIC_TIN];
var FOREIGN_GENERIC_TIN_LIST = exports.FOREIGN_GENERIC_TIN_LIST = [FOREIGN_BUYER_GENERIC_TIN, FOREIGN_SUPPLIER_GENERIC_TIN];

// isForeignCompany param currently only valid for checking idType BRN
// since BRN can be either foreign/local
// for other idTypes can omit this param
var isForeignIdType = exports.isForeignIdType = function isForeignIdType(idType, isForeignCompany) {
  if (idType === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN) {
    return isForeignCompany;
  }
  return GENERIC_TIN_MAP.some(function (e) {
    return e.isForeignEntity && e.idType === idType;
  });
};

// isForeignCompany param currently only valid for checking idType BRN
// since BRN can be either foreign/local
// for other idTypes can omit this param
var getAutoFillTin = exports.getAutoFillTin = function getAutoFillTin(idType, isForeignCompany) {
  if (idType === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN) {
    var _tin = GENERIC_TIN_MAP.find(function (e) {
      return e.idType === idType && e.isForeignEntity === isForeignCompany;
    });
    return _tin && _tin.autofill ? _tin.genericTin : '';
  }
  var tin = GENERIC_TIN_MAP.find(function (e) {
    return e.idType === idType && e.autofill;
  });
  return tin ? tin.genericTin : '';
};

// isForeignCompany param currently only valid for checking idType BRN
// since BRN can be either foreign/local
// for other idTypes can omit this param
var getGenericTinByIdTypeAndTinNo = exports.getGenericTinByIdTypeAndTinNo = function getGenericTinByIdTypeAndTinNo(idType, tin, isForeignCompany) {
  if (idType === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN) {
    return GENERIC_TIN_MAP.filter(function (tinType) {
      return tinType.idType === idType && tinType.genericTin === tin && tinType.isForeignEntity === isForeignCompany;
    });
  }
  return GENERIC_TIN_MAP.filter(function (tinType) {
    return tinType.idType === idType && tinType.genericTin === tin;
  });
};

var isGenericTinFound = exports.isGenericTinFound = function isGenericTinFound() {
  var genericTinList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return genericTinList.length > 0;
};

var GENERIC_TIN_UNMATCHED_ERROR_MSG = exports.GENERIC_TIN_UNMATCHED_ERROR_MSG = 'The Generic TIN you entered doesn’t match the selected ID type';

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.displayMoment = displayMoment;
exports.displayNow = displayNow;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _countries = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Every display in the app runs in the zone baked into the build —
 * `moment.tz.setDefault(config.get('tzName'))` in `containers/Root.jsx`. CPI-1109 established that
 * Vietnam companies must instead read timestamps in the viewer's own browser zone, so one instant
 * shows 11:03 in Ho Chi Minh, 12:03 in Kuala Lumpur and 04:03 in UTC.
 *
 * That rule used to live inside the connected `components/Timestamp`, which left every caller that
 * formats a Moment directly — tooltips, `title` attributes, activity before/after values, grouping
 * keys — rendering in the build zone. These two helpers are the single source of truth for the
 * rule so those callers stop re-implementing it.
 *
 * Scope is display only. Date-only calendar fields, picker inputs, query ranges, operational
 * schedules, countdown maths and API serialization keep the configured zone and must not use this.
 */

/**
 * A fresh Moment for display: browser-local for Vietnam companies, configured zone otherwise.
 * `value` is anything Moment accepts, and `undefined` means now exactly as it does in Moment. The
 * argument is never mutated — `moment(value)` clones a Moment input — and neither is the global
 * default, the locale or any store state.
 */
function displayMoment(value, countryCode) {
  var m = (0, _momentTimezone2.default)(value);
  return (0, _countries.isCountryVietnam)(countryCode) ? m.local() : m;
}

/**
 * The matching reference clock. Calendar-relative formats (Today/Yesterday, "still this year")
 * compare the value against now, so both sides have to be read in the same zone or the chosen
 * branch is itself wrong near midnight and at the year boundary.
 */
function displayNow(countryCode) {
  return displayMoment(undefined, countryCode);
}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isbase64;
function isbase64(str) {
  try {
    return btoa(atob(str)) === str;
  } catch (err) {
    return false;
  }
}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__(160);
var IObject = __webpack_require__(332);
var toObject = __webpack_require__(99);
var toLength = __webpack_require__(73);
var asc = __webpack_require__(1123);
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(158);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(333);
var createDesc = __webpack_require__(236);
var toIObject = __webpack_require__(132);
var toPrimitive = __webpack_require__(201);
var has = __webpack_require__(130);
var IE8_DOM_DEFINE = __webpack_require__(1127);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(82) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(17);
var core = __webpack_require__(78);
var fails = __webpack_require__(51);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 163 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var seenKeys = {};
var MULTIPLIER = Math.pow(2, 24);

function generateRandomKey() {
  var key;

  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
  }

  seenKeys[key] = true;
  return key;
}

module.exports = generateRandomKey;

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.print = print;

var _visitor = __webpack_require__(245);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */
function print(ast) {
  return (0, _visitor.visit)(ast, {
    leave: printDocASTReducer
  });
}

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },
  // Document
  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },
  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
    // the query short form.

    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },
  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue,
        directives = _ref.directives;
    return variable + ': ' + type + wrap(' = ', defaultValue) + wrap(' ', join(directives, ' '));
  },
  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },
  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    return join([wrap('', alias, ': ') + name + wrap('(', join(args, ', '), ')'), join(directives, ' '), selectionSet], ' ');
  },
  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },
  // Fragments
  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap(' ', join(directives, ' '));
  },
  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },
  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (// Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(name).concat(wrap('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },
  // Value
  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? printBlockString(value, key === 'description') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },
  // Directive
  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap('(', join(args, ', '), ')');
  },
  // Type
  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },
  // Type System Definitions
  SchemaDefinition: function SchemaDefinition(_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },
  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),
  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + (args.every(function (arg) {
      return arg.indexOf('\n') === -1;
    }) ? wrap('(', join(args, ', '), ')') : wrap('(\n', indent(join(args, '\n')), '\n)')) + ': ' + type + wrap(' ', join(directives, ' '));
  }),
  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),
  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, join(directives, ' '), block(fields)], ' ');
  }),
  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),
  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),
  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),
  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),
  DirectiveDefinition: addDescription(function (_ref31) {
    var name = _ref31.name,
        args = _ref31.arguments,
        locations = _ref31.locations;
    return 'directive @' + name + (args.every(function (arg) {
      return arg.indexOf('\n') === -1;
    }) ? wrap('(', join(args, ', '), ')') : wrap('(\n', indent(join(args, '\n')), '\n)')) + ' on ' + join(locations, ' | ');
  }),
  SchemaExtension: function SchemaExtension(_ref32) {
    var directives = _ref32.directives,
        operationTypes = _ref32.operationTypes;
    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },
  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
    var name = _ref34.name,
        interfaces = _ref34.interfaces,
        directives = _ref34.directives,
        fields = _ref34.fields;
    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
    var name = _ref35.name,
        directives = _ref35.directives,
        fields = _ref35.fields;
    return join(['extend interface', name, join(directives, ' '), block(fields)], ' ');
  },
  UnionTypeExtension: function UnionTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        types = _ref36.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },
  EnumTypeExtension: function EnumTypeExtension(_ref37) {
    var name = _ref37.name,
        directives = _ref37.directives,
        values = _ref37.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },
  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
    var name = _ref38.name,
        directives = _ref38.directives,
        fields = _ref38.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  }
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */


function join(maybeArray, separator) {
  return maybeArray ? maybeArray.filter(function (x) {
    return x;
  }).join(separator || '') : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */


function block(array) {
  return array && array.length !== 0 ? '{\n' + indent(join(array, '\n')) + '\n}' : '';
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise
 * print an empty string.
 */


function wrap(start, maybeString, end) {
  return maybeString ? start + maybeString + (end || '') : '';
}

function indent(maybeString) {
  return maybeString && '  ' + maybeString.replace(/\n/g, '\n  ');
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 */


function printBlockString(value, isDescription) {
  var escaped = value.replace(/"""/g, '\\"""');
  return (value[0] === ' ' || value[0] === '\t') && value.indexOf('\n') === -1 ? "\"\"\"".concat(escaped.replace(/"$/, '"\n'), "\"\"\"") : "\"\"\"\n".concat(isDescription ? escaped : indent(escaped), "\n\"\"\"");
}

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isIntrospectionType = isIntrospectionType;
exports.introspectionTypes = exports.TypeNameMetaFieldDef = exports.TypeMetaFieldDef = exports.SchemaMetaFieldDef = exports.__TypeKind = exports.TypeKind = exports.__EnumValue = exports.__InputValue = exports.__Field = exports.__Type = exports.__DirectiveLocation = exports.__Directive = exports.__Schema = void 0;

var _isInvalid = _interopRequireDefault(__webpack_require__(204));

var _objectValues = _interopRequireDefault(__webpack_require__(205));

var _astFromValue = __webpack_require__(665);

var _printer = __webpack_require__(165);

var _definition = __webpack_require__(54);

var _scalars = __webpack_require__(184);

var _directiveLocation = __webpack_require__(345);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
var __Schema = new _definition.GraphQLObjectType({
  name: '__Schema',
  description: 'A GraphQL Schema defines the capabilities of a GraphQL server. It ' + 'exposes all available types and directives on the server, as well as ' + 'the entry points for query, mutation, and subscription operations.',
  fields: function fields() {
    return {
      types: {
        description: 'A list of all types supported by this server.',
        type: (0, _definition.GraphQLNonNull)((0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__Type))),
        resolve: function resolve(schema) {
          return (0, _objectValues.default)(schema.getTypeMap());
        }
      },
      queryType: {
        description: 'The type that query operations will be rooted at.',
        type: (0, _definition.GraphQLNonNull)(__Type),
        resolve: function resolve(schema) {
          return schema.getQueryType();
        }
      },
      mutationType: {
        description: 'If this server supports mutation, the type that ' + 'mutation operations will be rooted at.',
        type: __Type,
        resolve: function resolve(schema) {
          return schema.getMutationType();
        }
      },
      subscriptionType: {
        description: 'If this server support subscription, the type that ' + 'subscription operations will be rooted at.',
        type: __Type,
        resolve: function resolve(schema) {
          return schema.getSubscriptionType();
        }
      },
      directives: {
        description: 'A list of all directives supported by this server.',
        type: (0, _definition.GraphQLNonNull)((0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__Directive))),
        resolve: function resolve(schema) {
          return schema.getDirectives();
        }
      }
    };
  }
});

exports.__Schema = __Schema;

var __Directive = new _definition.GraphQLObjectType({
  name: '__Directive',
  description: 'A Directive provides a way to describe alternate runtime execution and ' + 'type validation behavior in a GraphQL document.' + "\n\nIn some cases, you need to provide options to alter GraphQL's " + 'execution behavior in ways field arguments will not suffice, such as ' + 'conditionally including or skipping a field. Directives provide this by ' + 'describing additional information to the executor.',
  fields: function fields() {
    return {
      name: {
        type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLString),
        resolve: function resolve(obj) {
          return obj.name;
        }
      },
      description: {
        type: _scalars.GraphQLString,
        resolve: function resolve(obj) {
          return obj.description;
        }
      },
      locations: {
        type: (0, _definition.GraphQLNonNull)((0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__DirectiveLocation))),
        resolve: function resolve(obj) {
          return obj.locations;
        }
      },
      args: {
        type: (0, _definition.GraphQLNonNull)((0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__InputValue))),
        resolve: function resolve(directive) {
          return directive.args || [];
        }
      }
    };
  }
});

exports.__Directive = __Directive;

var __DirectiveLocation = new _definition.GraphQLEnumType({
  name: '__DirectiveLocation',
  description: 'A Directive can be adjacent to many parts of the GraphQL language, a ' + '__DirectiveLocation describes one such possible adjacencies.',
  values: {
    QUERY: {
      value: _directiveLocation.DirectiveLocation.QUERY,
      description: 'Location adjacent to a query operation.'
    },
    MUTATION: {
      value: _directiveLocation.DirectiveLocation.MUTATION,
      description: 'Location adjacent to a mutation operation.'
    },
    SUBSCRIPTION: {
      value: _directiveLocation.DirectiveLocation.SUBSCRIPTION,
      description: 'Location adjacent to a subscription operation.'
    },
    FIELD: {
      value: _directiveLocation.DirectiveLocation.FIELD,
      description: 'Location adjacent to a field.'
    },
    FRAGMENT_DEFINITION: {
      value: _directiveLocation.DirectiveLocation.FRAGMENT_DEFINITION,
      description: 'Location adjacent to a fragment definition.'
    },
    FRAGMENT_SPREAD: {
      value: _directiveLocation.DirectiveLocation.FRAGMENT_SPREAD,
      description: 'Location adjacent to a fragment spread.'
    },
    INLINE_FRAGMENT: {
      value: _directiveLocation.DirectiveLocation.INLINE_FRAGMENT,
      description: 'Location adjacent to an inline fragment.'
    },
    VARIABLE_DEFINITION: {
      value: _directiveLocation.DirectiveLocation.VARIABLE_DEFINITION,
      description: 'Location adjacent to a variable definition.'
    },
    SCHEMA: {
      value: _directiveLocation.DirectiveLocation.SCHEMA,
      description: 'Location adjacent to a schema definition.'
    },
    SCALAR: {
      value: _directiveLocation.DirectiveLocation.SCALAR,
      description: 'Location adjacent to a scalar definition.'
    },
    OBJECT: {
      value: _directiveLocation.DirectiveLocation.OBJECT,
      description: 'Location adjacent to an object type definition.'
    },
    FIELD_DEFINITION: {
      value: _directiveLocation.DirectiveLocation.FIELD_DEFINITION,
      description: 'Location adjacent to a field definition.'
    },
    ARGUMENT_DEFINITION: {
      value: _directiveLocation.DirectiveLocation.ARGUMENT_DEFINITION,
      description: 'Location adjacent to an argument definition.'
    },
    INTERFACE: {
      value: _directiveLocation.DirectiveLocation.INTERFACE,
      description: 'Location adjacent to an interface definition.'
    },
    UNION: {
      value: _directiveLocation.DirectiveLocation.UNION,
      description: 'Location adjacent to a union definition.'
    },
    ENUM: {
      value: _directiveLocation.DirectiveLocation.ENUM,
      description: 'Location adjacent to an enum definition.'
    },
    ENUM_VALUE: {
      value: _directiveLocation.DirectiveLocation.ENUM_VALUE,
      description: 'Location adjacent to an enum value definition.'
    },
    INPUT_OBJECT: {
      value: _directiveLocation.DirectiveLocation.INPUT_OBJECT,
      description: 'Location adjacent to an input object type definition.'
    },
    INPUT_FIELD_DEFINITION: {
      value: _directiveLocation.DirectiveLocation.INPUT_FIELD_DEFINITION,
      description: 'Location adjacent to an input object field definition.'
    }
  }
});

exports.__DirectiveLocation = __DirectiveLocation;

var __Type = new _definition.GraphQLObjectType({
  name: '__Type',
  description: 'The fundamental unit of any GraphQL Schema is the type. There are ' + 'many kinds of types in GraphQL as represented by the `__TypeKind` enum.' + '\n\nDepending on the kind of a type, certain fields describe ' + 'information about that type. Scalar types provide no information ' + 'beyond a name and description, while Enum types provide their values. ' + 'Object and Interface types provide the fields they describe. Abstract ' + 'types, Union and Interface, provide the Object types possible ' + 'at runtime. List and NonNull types compose other types.',
  fields: function fields() {
    return {
      kind: {
        type: (0, _definition.GraphQLNonNull)(__TypeKind),
        resolve: function resolve(type) {
          if ((0, _definition.isScalarType)(type)) {
            return TypeKind.SCALAR;
          } else if ((0, _definition.isObjectType)(type)) {
            return TypeKind.OBJECT;
          } else if ((0, _definition.isInterfaceType)(type)) {
            return TypeKind.INTERFACE;
          } else if ((0, _definition.isUnionType)(type)) {
            return TypeKind.UNION;
          } else if ((0, _definition.isEnumType)(type)) {
            return TypeKind.ENUM;
          } else if ((0, _definition.isInputObjectType)(type)) {
            return TypeKind.INPUT_OBJECT;
          } else if ((0, _definition.isListType)(type)) {
            return TypeKind.LIST;
          } else if ((0, _definition.isNonNullType)(type)) {
            return TypeKind.NON_NULL;
          }

          throw new Error('Unknown kind of type: ' + type);
        }
      },
      name: {
        type: _scalars.GraphQLString,
        resolve: function resolve(obj) {
          return obj.name;
        }
      },
      description: {
        type: _scalars.GraphQLString,
        resolve: function resolve(obj) {
          return obj.description;
        }
      },
      fields: {
        type: (0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__Field)),
        args: {
          includeDeprecated: {
            type: _scalars.GraphQLBoolean,
            defaultValue: false
          }
        },
        resolve: function resolve(type, _ref) {
          var includeDeprecated = _ref.includeDeprecated;

          if ((0, _definition.isObjectType)(type) || (0, _definition.isInterfaceType)(type)) {
            var fields = (0, _objectValues.default)(type.getFields());

            if (!includeDeprecated) {
              fields = fields.filter(function (field) {
                return !field.deprecationReason;
              });
            }

            return fields;
          }

          return null;
        }
      },
      interfaces: {
        type: (0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__Type)),
        resolve: function resolve(type) {
          if ((0, _definition.isObjectType)(type)) {
            return type.getInterfaces();
          }
        }
      },
      possibleTypes: {
        type: (0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__Type)),
        resolve: function resolve(type, args, context, _ref2) {
          var schema = _ref2.schema;

          if ((0, _definition.isAbstractType)(type)) {
            return schema.getPossibleTypes(type);
          }
        }
      },
      enumValues: {
        type: (0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__EnumValue)),
        args: {
          includeDeprecated: {
            type: _scalars.GraphQLBoolean,
            defaultValue: false
          }
        },
        resolve: function resolve(type, _ref3) {
          var includeDeprecated = _ref3.includeDeprecated;

          if ((0, _definition.isEnumType)(type)) {
            var values = type.getValues();

            if (!includeDeprecated) {
              values = values.filter(function (value) {
                return !value.deprecationReason;
              });
            }

            return values;
          }
        }
      },
      inputFields: {
        type: (0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__InputValue)),
        resolve: function resolve(type) {
          if ((0, _definition.isInputObjectType)(type)) {
            return (0, _objectValues.default)(type.getFields());
          }
        }
      },
      ofType: {
        type: __Type,
        resolve: function resolve(obj) {
          return obj.ofType;
        }
      }
    };
  }
});

exports.__Type = __Type;

var __Field = new _definition.GraphQLObjectType({
  name: '__Field',
  description: 'Object and Interface types are described by a list of Fields, each of ' + 'which has a name, potentially a list of arguments, and a return type.',
  fields: function fields() {
    return {
      name: {
        type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLString),
        resolve: function resolve(obj) {
          return obj.name;
        }
      },
      description: {
        type: _scalars.GraphQLString,
        resolve: function resolve(obj) {
          return obj.description;
        }
      },
      args: {
        type: (0, _definition.GraphQLNonNull)((0, _definition.GraphQLList)((0, _definition.GraphQLNonNull)(__InputValue))),
        resolve: function resolve(field) {
          return field.args || [];
        }
      },
      type: {
        type: (0, _definition.GraphQLNonNull)(__Type),
        resolve: function resolve(obj) {
          return obj.type;
        }
      },
      isDeprecated: {
        type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLBoolean),
        resolve: function resolve(obj) {
          return obj.isDeprecated;
        }
      },
      deprecationReason: {
        type: _scalars.GraphQLString,
        resolve: function resolve(obj) {
          return obj.deprecationReason;
        }
      }
    };
  }
});

exports.__Field = __Field;

var __InputValue = new _definition.GraphQLObjectType({
  name: '__InputValue',
  description: 'Arguments provided to Fields or Directives and the input fields of an ' + 'InputObject are represented as Input Values which describe their type ' + 'and optionally a default value.',
  fields: function fields() {
    return {
      name: {
        type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLString),
        resolve: function resolve(obj) {
          return obj.name;
        }
      },
      description: {
        type: _scalars.GraphQLString,
        resolve: function resolve(obj) {
          return obj.description;
        }
      },
      type: {
        type: (0, _definition.GraphQLNonNull)(__Type),
        resolve: function resolve(obj) {
          return obj.type;
        }
      },
      defaultValue: {
        type: _scalars.GraphQLString,
        description: 'A GraphQL-formatted string representing the default value for this ' + 'input value.',
        resolve: function resolve(inputVal) {
          return (0, _isInvalid.default)(inputVal.defaultValue) ? null : (0, _printer.print)((0, _astFromValue.astFromValue)(inputVal.defaultValue, inputVal.type));
        }
      }
    };
  }
});

exports.__InputValue = __InputValue;

var __EnumValue = new _definition.GraphQLObjectType({
  name: '__EnumValue',
  description: 'One possible value for a given Enum. Enum values are unique values, not ' + 'a placeholder for a string or numeric value. However an Enum value is ' + 'returned in a JSON response as a string.',
  fields: function fields() {
    return {
      name: {
        type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLString),
        resolve: function resolve(obj) {
          return obj.name;
        }
      },
      description: {
        type: _scalars.GraphQLString,
        resolve: function resolve(obj) {
          return obj.description;
        }
      },
      isDeprecated: {
        type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLBoolean),
        resolve: function resolve(obj) {
          return obj.isDeprecated;
        }
      },
      deprecationReason: {
        type: _scalars.GraphQLString,
        resolve: function resolve(obj) {
          return obj.deprecationReason;
        }
      }
    };
  }
});

exports.__EnumValue = __EnumValue;
var TypeKind = {
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  INPUT_OBJECT: 'INPUT_OBJECT',
  LIST: 'LIST',
  NON_NULL: 'NON_NULL'
};
exports.TypeKind = TypeKind;

var __TypeKind = new _definition.GraphQLEnumType({
  name: '__TypeKind',
  description: 'An enum describing what kind of type a given `__Type` is.',
  values: {
    SCALAR: {
      value: TypeKind.SCALAR,
      description: 'Indicates this type is a scalar.'
    },
    OBJECT: {
      value: TypeKind.OBJECT,
      description: 'Indicates this type is an object. ' + '`fields` and `interfaces` are valid fields.'
    },
    INTERFACE: {
      value: TypeKind.INTERFACE,
      description: 'Indicates this type is an interface. ' + '`fields` and `possibleTypes` are valid fields.'
    },
    UNION: {
      value: TypeKind.UNION,
      description: 'Indicates this type is a union. `possibleTypes` is a valid field.'
    },
    ENUM: {
      value: TypeKind.ENUM,
      description: 'Indicates this type is an enum. `enumValues` is a valid field.'
    },
    INPUT_OBJECT: {
      value: TypeKind.INPUT_OBJECT,
      description: 'Indicates this type is an input object. ' + '`inputFields` is a valid field.'
    },
    LIST: {
      value: TypeKind.LIST,
      description: 'Indicates this type is a list. `ofType` is a valid field.'
    },
    NON_NULL: {
      value: TypeKind.NON_NULL,
      description: 'Indicates this type is a non-null. `ofType` is a valid field.'
    }
  }
});
/**
 * Note that these are GraphQLField and not GraphQLFieldConfig,
 * so the format for args is different.
 */


exports.__TypeKind = __TypeKind;
var SchemaMetaFieldDef = {
  name: '__schema',
  type: (0, _definition.GraphQLNonNull)(__Schema),
  description: 'Access the current type schema of this server.',
  args: [],
  resolve: function resolve(source, args, context, _ref4) {
    var schema = _ref4.schema;
    return schema;
  }
};
exports.SchemaMetaFieldDef = SchemaMetaFieldDef;
var TypeMetaFieldDef = {
  name: '__type',
  type: __Type,
  description: 'Request the type information of a single type.',
  args: [{
    name: 'name',
    type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLString)
  }],
  resolve: function resolve(source, _ref5, context, _ref6) {
    var name = _ref5.name;
    var schema = _ref6.schema;
    return schema.getType(name);
  }
};
exports.TypeMetaFieldDef = TypeMetaFieldDef;
var TypeNameMetaFieldDef = {
  name: '__typename',
  type: (0, _definition.GraphQLNonNull)(_scalars.GraphQLString),
  description: 'The name of the current Object type at runtime.',
  args: [],
  resolve: function resolve(source, args, context, _ref7) {
    var parentType = _ref7.parentType;
    return parentType.name;
  }
};
exports.TypeNameMetaFieldDef = TypeNameMetaFieldDef;
var introspectionTypes = [__Schema, __Directive, __DirectiveLocation, __Type, __Field, __InputValue, __EnumValue, __TypeKind];
exports.introspectionTypes = introspectionTypes;

function isIntrospectionType(type) {
  return (0, _definition.isNamedType)(type) && ( // Would prefer to use introspectionTypes.some(), however %checks needs
  // a simple expression.
  type.name === __Schema.name || type.name === __Directive.name || type.name === __DirectiveLocation.name || type.name === __Type.name || type.name === __Field.name || type.name === __InputValue.name || type.name === __EnumValue.name || type.name === __TypeKind.name);
}

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(137);
var inherits = __webpack_require__(41);

exports.inherits = inherits;

function isSurrogatePair(msg, i) {
  if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) {
    return false;
  }
  if (i < 0 || i + 1 >= msg.length) {
    return false;
  }
  return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg === 'string') {
    if (!enc) {
      // Inspired by stringToUtf8ByteArray() in closure-library by Google
      // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
      // Apache License 2.0
      // https://github.com/google/closure-library/blob/master/LICENSE
      var p = 0;
      for (var i = 0; i < msg.length; i++) {
        var c = msg.charCodeAt(i);
        if (c < 128) {
          res[p++] = c;
        } else if (c < 2048) {
          res[p++] = (c >> 6) | 192;
          res[p++] = (c & 63) | 128;
        } else if (isSurrogatePair(msg, i)) {
          c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
          res[p++] = (c >> 18) | 240;
          res[p++] = ((c >> 12) & 63) | 128;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        } else {
          res[p++] = (c >> 12) | 224;
          res[p++] = ((c >> 6) & 63) | 128;
          res[p++] = (c & 63) | 128;
        }
      }
    } else if (enc === 'hex') {
      msg = msg.replace(/[^a-z0-9]+/ig, '');
      if (msg.length % 2 !== 0)
        msg = '0' + msg;
      for (i = 0; i < msg.length; i += 2)
        res.push(parseInt(msg[i] + msg[i + 1], 16));
    }
  } else {
    for (i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
  }
  return res;
}
exports.toArray = toArray;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
exports.toHex = toHex;

function htonl(w) {
  var res = (w >>> 24) |
            ((w >>> 8) & 0xff00) |
            ((w << 8) & 0xff0000) |
            ((w & 0xff) << 24);
  return res >>> 0;
}
exports.htonl = htonl;

function toHex32(msg, endian) {
  var res = '';
  for (var i = 0; i < msg.length; i++) {
    var w = msg[i];
    if (endian === 'little')
      w = htonl(w);
    res += zero8(w.toString(16));
  }
  return res;
}
exports.toHex32 = toHex32;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
exports.zero2 = zero2;

function zero8(word) {
  if (word.length === 7)
    return '0' + word;
  else if (word.length === 6)
    return '00' + word;
  else if (word.length === 5)
    return '000' + word;
  else if (word.length === 4)
    return '0000' + word;
  else if (word.length === 3)
    return '00000' + word;
  else if (word.length === 2)
    return '000000' + word;
  else if (word.length === 1)
    return '0000000' + word;
  else
    return word;
}
exports.zero8 = zero8;

function join32(msg, start, end, endian) {
  var len = end - start;
  assert(len % 4 === 0);
  var res = new Array(len / 4);
  for (var i = 0, k = start; i < res.length; i++, k += 4) {
    var w;
    if (endian === 'big')
      w = (msg[k] << 24) | (msg[k + 1] << 16) | (msg[k + 2] << 8) | msg[k + 3];
    else
      w = (msg[k + 3] << 24) | (msg[k + 2] << 16) | (msg[k + 1] << 8) | msg[k];
    res[i] = w >>> 0;
  }
  return res;
}
exports.join32 = join32;

function split32(msg, endian) {
  var res = new Array(msg.length * 4);
  for (var i = 0, k = 0; i < msg.length; i++, k += 4) {
    var m = msg[i];
    if (endian === 'big') {
      res[k] = m >>> 24;
      res[k + 1] = (m >>> 16) & 0xff;
      res[k + 2] = (m >>> 8) & 0xff;
      res[k + 3] = m & 0xff;
    } else {
      res[k + 3] = m >>> 24;
      res[k + 2] = (m >>> 16) & 0xff;
      res[k + 1] = (m >>> 8) & 0xff;
      res[k] = m & 0xff;
    }
  }
  return res;
}
exports.split32 = split32;

function rotr32(w, b) {
  return (w >>> b) | (w << (32 - b));
}
exports.rotr32 = rotr32;

function rotl32(w, b) {
  return (w << b) | (w >>> (32 - b));
}
exports.rotl32 = rotl32;

function sum32(a, b) {
  return (a + b) >>> 0;
}
exports.sum32 = sum32;

function sum32_3(a, b, c) {
  return (a + b + c) >>> 0;
}
exports.sum32_3 = sum32_3;

function sum32_4(a, b, c, d) {
  return (a + b + c + d) >>> 0;
}
exports.sum32_4 = sum32_4;

function sum32_5(a, b, c, d, e) {
  return (a + b + c + d + e) >>> 0;
}
exports.sum32_5 = sum32_5;

function sum64(buf, pos, ah, al) {
  var bh = buf[pos];
  var bl = buf[pos + 1];

  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  buf[pos] = hi >>> 0;
  buf[pos + 1] = lo;
}
exports.sum64 = sum64;

function sum64_hi(ah, al, bh, bl) {
  var lo = (al + bl) >>> 0;
  var hi = (lo < al ? 1 : 0) + ah + bh;
  return hi >>> 0;
}
exports.sum64_hi = sum64_hi;

function sum64_lo(ah, al, bh, bl) {
  var lo = al + bl;
  return lo >>> 0;
}
exports.sum64_lo = sum64_lo;

function sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;

  var hi = ah + bh + ch + dh + carry;
  return hi >>> 0;
}
exports.sum64_4_hi = sum64_4_hi;

function sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
  var lo = al + bl + cl + dl;
  return lo >>> 0;
}
exports.sum64_4_lo = sum64_4_lo;

function sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var carry = 0;
  var lo = al;
  lo = (lo + bl) >>> 0;
  carry += lo < al ? 1 : 0;
  lo = (lo + cl) >>> 0;
  carry += lo < cl ? 1 : 0;
  lo = (lo + dl) >>> 0;
  carry += lo < dl ? 1 : 0;
  lo = (lo + el) >>> 0;
  carry += lo < el ? 1 : 0;

  var hi = ah + bh + ch + dh + eh + carry;
  return hi >>> 0;
}
exports.sum64_5_hi = sum64_5_hi;

function sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
  var lo = al + bl + cl + dl + el;

  return lo >>> 0;
}
exports.sum64_5_lo = sum64_5_lo;

function rotr64_hi(ah, al, num) {
  var r = (al << (32 - num)) | (ah >>> num);
  return r >>> 0;
}
exports.rotr64_hi = rotr64_hi;

function rotr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.rotr64_lo = rotr64_lo;

function shr64_hi(ah, al, num) {
  return ah >>> num;
}
exports.shr64_hi = shr64_hi;

function shr64_lo(ah, al, num) {
  var r = (ah << (32 - num)) | (al >>> num);
  return r >>> 0;
}
exports.shr64_lo = shr64_lo;


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isString_js__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toInteger_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__values_js__ = __webpack_require__(502);






/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(collection) ? collection : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__values_js__["a" /* default */])(collection);
  fromIndex = (fromIndex && !guard) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__toInteger_js__["a" /* default */])(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isString_js__["a" /* default */])(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__["a" /* default */])(collection, value, fromIndex) > -1);
}

/* harmony default export */ __webpack_exports__["a"] = (includes);


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(752);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CloudWatchLogsClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__runtimeConfig__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_sdk_config_resolver__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_content_length__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_host_header__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_middleware_logger__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__aws_sdk_middleware_retry__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__aws_sdk_middleware_user_agent__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__aws_sdk_smithy_client__ = __webpack_require__(22);










/**
 * <p>You can use Amazon CloudWatch Logs to monitor, store, and access your log files from
 *       EC2 instances, AWS CloudTrail, or other sources. You can then retrieve the associated
 *       log data from CloudWatch Logs using the CloudWatch console, CloudWatch Logs commands in the
 *       AWS CLI, CloudWatch Logs API, or CloudWatch Logs SDK.</p>
 *          <p>You can use CloudWatch Logs to:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <b>Monitor logs from EC2 instances in real-time</b>: You
 *           can use CloudWatch Logs to monitor applications and systems using log data. For example,
 *           CloudWatch Logs can track the number of errors that occur in your application logs and
 *           send you a notification whenever the rate of errors exceeds a threshold that you specify.
 *           CloudWatch Logs uses your log data for monitoring so no code changes are required. For
 *           example, you can monitor application logs for specific literal terms (such as
 *           "NullReferenceException") or count the number of occurrences of a literal term at a
 *           particular position in log data (such as "404" status codes in an Apache access log). When
 *           the term you are searching for is found, CloudWatch Logs reports the data to a CloudWatch
 *           metric that you specify.</p>
 *             </li>
 *             <li>
 *                <p>
 *                   <b>Monitor AWS CloudTrail logged events</b>: You can
 *           create alarms in CloudWatch and receive notifications of particular API activity as
 *           captured by CloudTrail. You can use the notification to perform troubleshooting.</p>
 *             </li>
 *             <li>
 *                <p>
 *                   <b>Archive log data</b>: You can use CloudWatch Logs to
 *           store your log data in highly durable storage. You can change the log retention setting so
 *           that any log events older than this setting are automatically deleted. The CloudWatch Logs
 *           agent makes it easy to quickly send both rotated and non-rotated log data off of a host
 *           and into the log service. You can then access the raw log data when you need it.</p>
 *             </li>
 *          </ul>
 */
var CloudWatchLogsClient = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CloudWatchLogsClient, _super);
    function CloudWatchLogsClient(configuration) {
        var _this = this;
        var _config_0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, __WEBPACK_IMPORTED_MODULE_1__runtimeConfig__["a" /* ClientDefaultValues */]), configuration);
        var _config_1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__aws_sdk_config_resolver__["a" /* resolveRegionConfig */])(_config_0);
        var _config_2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__aws_sdk_config_resolver__["b" /* resolveEndpointsConfig */])(_config_1);
        var _config_3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__aws_sdk_middleware_signing__["b" /* resolveAwsAuthConfig */])(_config_2);
        var _config_4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__aws_sdk_middleware_retry__["a" /* resolveRetryConfig */])(_config_3);
        var _config_5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_host_header__["a" /* resolveHostHeaderConfig */])(_config_4);
        var _config_6 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__aws_sdk_middleware_user_agent__["a" /* resolveUserAgentConfig */])(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__aws_sdk_middleware_signing__["a" /* getAwsAuthPlugin */])(_this.config));
        _this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__aws_sdk_middleware_retry__["b" /* getRetryPlugin */])(_this.config));
        _this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_content_length__["a" /* getContentLengthPlugin */])(_this.config));
        _this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_host_header__["b" /* getHostHeaderPlugin */])(_this.config));
        _this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_middleware_logger__["a" /* getLoggerPlugin */])(_this.config));
        _this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__aws_sdk_middleware_user_agent__["b" /* getUserAgentPlugin */])(_this.config));
        return _this;
    }
    CloudWatchLogsClient.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    return CloudWatchLogsClient;
}(__WEBPACK_IMPORTED_MODULE_9__aws_sdk_smithy_client__["Client"]));

//# sourceMappingURL=CloudWatchLogsClient.js.map

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__httpResponse__ = __webpack_require__(1725);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "HttpResponse", function() { return __WEBPACK_IMPORTED_MODULE_0__httpResponse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__httpRequest__ = __webpack_require__(1724);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "HttpRequest", function() { return __WEBPACK_IMPORTED_MODULE_1__httpRequest__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__httpHandler__ = __webpack_require__(1723);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isValidHostname__ = __webpack_require__(1726);
/* unused harmony namespace reexport */




//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyxnQkFBZ0IsQ0FBQztBQUMvQixjQUFjLGVBQWUsQ0FBQztBQUM5QixjQUFjLGVBQWUsQ0FBQztBQUM5QixjQUFjLG1CQUFtQixDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0ICogZnJvbSBcIi4vaHR0cFJlc3BvbnNlXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9odHRwUmVxdWVzdFwiO1xuZXhwb3J0ICogZnJvbSBcIi4vaHR0cEhhbmRsZXJcIjtcbmV4cG9ydCAqIGZyb20gXCIuL2lzVmFsaWRIb3N0bmFtZVwiO1xuIl19

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RX_PHONE_PREFIXES = exports.RX_PHONES = exports.RX_PASSWORD = exports.RX_IDENTITY = exports.RX_EMAIL = exports.RX_ALPHA = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// RegExp
var RX_ALPHA = exports.RX_ALPHA = '^[a-zA-Z]+$';
var RX_EMAIL = exports.RX_EMAIL = /^[a-zA-Z0-9][a-zA-Z0-9._%+-]*@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
var RX_PASSWORD = exports.RX_PASSWORD = ['^', '(?=.*\\d)',
// one number
'(?=.*[a-zA-Z])',
// one alphabet
'[A-Za-z\\d\\:\\;\\"\\\'\\+\\=\\-\\_\\\\\\|\\{\\[\\}\\]\\<\\>\\.\\,\\/\\?\\|', '\\~\\`\\!\\@\\#\\$\\%\\^\\&\\*\\(\\)]', '{6,}',
// 6 characters
'$'].join('');
var RX_PHONE_PREFIXES = exports.RX_PHONE_PREFIXES = {
  IN: '^62$',
  MY: '^60$',
  SG: '^65$'
};

// Complicated RegExp
// use String(62) to avoid `Non-string literal property keys not supported` warning
var RX_PHONES = exports.RX_PHONES = _defineProperty(_defineProperty(_defineProperty({}, String(62), {
  // indonesia
  "false": '^[2-9]\\d{10,}$',
  "true": '^08\\d{9,10}$'
}), String(60), {
  // malaysia
  "false": '^[2-9]\\d{7,8}$',
  "true": '^1\\d{8,9}$'
}), String(65), {
  // singapore
  "false": '^[6]\\d{7}$',
  "true": '^[89]\\d{7}$'
});
var RX_IDENTITY = exports.RX_IDENTITY = {
  MY: {
    ic_number: '^([0-9][0-9])((0[1-9])|(1[0-2]))((0[1-9]|[1-2][0-9]|3[0-1]))([0-9][0-9])([0-9][0-9][0-9][0-9])$',
    passport: '^\\w*$',
    military_police: '^\\w*$',
    other: '^[a-zA-Z0-9 ()-]{0,30}$'
  },
  ID: {
    ic_number: '^(1[1-9]|21|3[1-6]|5[1-3]|6[1-5]|7[1-6]|8[1-2]|9[1-2])([0-2][0-9]|7[0-9])([0-9][0-9])(0[1-9]|1[1-9]|2[1-9]|3[0-1]|4[1-9]|5[1-9]|6[1-9]|7[0-1])(0[1-9]|1[1-2])([0-9][0-9])([0-9][0-9][0-9][0-9])$',
    passport: '^\\w*$',
    military_police: '^\\w*$',
    other: '^\\w*$'
  }
};

/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trace__ = __webpack_require__(2024);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__trace__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__trace__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__trace__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__trace__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__trace__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__trace__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__trace__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__trace__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__trace__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__trace__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__trace__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__trace__["l"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__resource__ = __webpack_require__(2020);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_1__resource__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_1__resource__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_1__resource__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_1__resource__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_1__resource__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_1__resource__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_1__resource__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_1__resource__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stable_attributes__ = __webpack_require__(2021);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stable_metrics__ = __webpack_require__(2022);
/* unused harmony namespace reexport */
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable no-restricted-syntax --
 * These re-exports are only of constants, only two-levels deep, and
 * should not cause problems for tree-shakers.
 */
// Deprecated. These are kept around for compatibility purposes


// Use these instead


//# sourceMappingURL=index.js.map

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIdentityTypeOpts = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _defaultIdentityTypeOpts = __webpack_require__(154);

var _defaultIdentityTypeOpts2 = _interopRequireDefault(_defaultIdentityTypeOpts);

var _countries = __webpack_require__(60);

var _companies = __webpack_require__(88);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getIdentityTypeOpts = exports.getIdentityTypeOpts = function getIdentityTypeOpts(auth, identityPresets) {
  var isVietnam = (0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode);
  var identityTypeOpts = _defaultIdentityTypeOpts2.default;
  if (isVietnam) {
    var cccdTypeOpt = identityTypeOpts.find(function (o) {
      return o.value === 1;
    });
    if (cccdTypeOpt) {
      cccdTypeOpt.text = 'CCCD';
    }
    // CPI-976: Vietnam's identity types are CCCD, Passport and Enterprise Registration Certificate
    // (value 4, relabelled). Mapped into a new object - the constant is shared.
    identityTypeOpts = identityTypeOpts.filter(function (o) {
      return o.value !== 3;
    }).map(function (o) {
      return o.value === 4 ? _extends({}, o, { text: 'Enterprise Registration Certificate' }) : o;
    });
  } else if (auth && (0, _companies.isForeignCompany)(auth.company)) {
    // remove NRIC & Military/Police identities
    identityTypeOpts = identityTypeOpts.filter(function (o) {
      return o.value !== 1 && o.value !== 3;
    });
    // check for new identity presets
    if (identityPresets && identityPresets.length > 0) {
      identityTypeOpts = [].concat(_toConsumableArray(identityTypeOpts), _toConsumableArray(identityPresets.map(function (i) {
        return { text: i.label, value: i.id, 'data-regex': i.regex };
      })));
    }
  }

  return identityTypeOpts;
};

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.centsToFloat = centsToFloat;
exports.floatToCents = floatToCents;
function isInt(n) {
  return Number(n) === n && n % 1 === 0;
}
function centsToFloat(value) {
  if (isInt(value)) {
    return value / 100;
  }
  return value;
}
function floatToCents(value) {
  if (value.includes('.')) {
    return parseInt(value.replace('.', ''), 10);
  }
  return value * 100;
}

/***/ }),
/* 176 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.11' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 177 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 178 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 179 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

if (__webpack_require__(82)) {
  var LIBRARY = __webpack_require__(231);
  var global = __webpack_require__(52);
  var fails = __webpack_require__(51);
  var $export = __webpack_require__(17);
  var $typed = __webpack_require__(422);
  var $buffer = __webpack_require__(638);
  var ctx = __webpack_require__(160);
  var anInstance = __webpack_require__(276);
  var propertyDesc = __webpack_require__(236);
  var hide = __webpack_require__(131);
  var redefineAll = __webpack_require__(278);
  var toInteger = __webpack_require__(163);
  var toLength = __webpack_require__(73);
  var toIndex = __webpack_require__(1146);
  var toAbsoluteIndex = __webpack_require__(237);
  var toPrimitive = __webpack_require__(201);
  var has = __webpack_require__(130);
  var classof = __webpack_require__(331);
  var isObject = __webpack_require__(53);
  var toObject = __webpack_require__(99);
  var isArrayIter = __webpack_require__(625);
  var create = __webpack_require__(232);
  var getPrototypeOf = __webpack_require__(234);
  var gOPN = __webpack_require__(233).f;
  var getIterFn = __webpack_require__(640);
  var uid = __webpack_require__(238);
  var wks = __webpack_require__(67);
  var createArrayMethod = __webpack_require__(159);
  var createArrayIncludes = __webpack_require__(412);
  var speciesConstructor = __webpack_require__(334);
  var ArrayIterators = __webpack_require__(641);
  var Iterators = __webpack_require__(277);
  var $iterDetect = __webpack_require__(418);
  var setSpecies = __webpack_require__(279);
  var arrayFill = __webpack_require__(618);
  var arrayCopyWithin = __webpack_require__(1121);
  var $DP = __webpack_require__(83);
  var $GOPD = __webpack_require__(161);
  var dP = $DP.f;
  var gOPD = $GOPD.f;
  var RangeError = global.RangeError;
  var TypeError = global.TypeError;
  var Uint8Array = global.Uint8Array;
  var ARRAY_BUFFER = 'ArrayBuffer';
  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
  var PROTOTYPE = 'prototype';
  var ArrayProto = Array[PROTOTYPE];
  var $ArrayBuffer = $buffer.ArrayBuffer;
  var $DataView = $buffer.DataView;
  var arrayForEach = createArrayMethod(0);
  var arrayFilter = createArrayMethod(2);
  var arraySome = createArrayMethod(3);
  var arrayEvery = createArrayMethod(4);
  var arrayFind = createArrayMethod(5);
  var arrayFindIndex = createArrayMethod(6);
  var arrayIncludes = createArrayIncludes(true);
  var arrayIndexOf = createArrayIncludes(false);
  var arrayValues = ArrayIterators.values;
  var arrayKeys = ArrayIterators.keys;
  var arrayEntries = ArrayIterators.entries;
  var arrayLastIndexOf = ArrayProto.lastIndexOf;
  var arrayReduce = ArrayProto.reduce;
  var arrayReduceRight = ArrayProto.reduceRight;
  var arrayJoin = ArrayProto.join;
  var arraySort = ArrayProto.sort;
  var arraySlice = ArrayProto.slice;
  var arrayToString = ArrayProto.toString;
  var arrayToLocaleString = ArrayProto.toLocaleString;
  var ITERATOR = wks('iterator');
  var TAG = wks('toStringTag');
  var TYPED_CONSTRUCTOR = uid('typed_constructor');
  var DEF_CONSTRUCTOR = uid('def_constructor');
  var ALL_CONSTRUCTORS = $typed.CONSTR;
  var TYPED_ARRAY = $typed.TYPED;
  var VIEW = $typed.VIEW;
  var WRONG_LENGTH = 'Wrong length!';

  var $map = createArrayMethod(1, function (O, length) {
    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
  });

  var LITTLE_ENDIAN = fails(function () {
    // eslint-disable-next-line no-undef
    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
  });

  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
    new Uint8Array(1).set({});
  });

  var toOffset = function (it, BYTES) {
    var offset = toInteger(it);
    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
    return offset;
  };

  var validate = function (it) {
    if (isObject(it) && TYPED_ARRAY in it) return it;
    throw TypeError(it + ' is not a typed array!');
  };

  var allocate = function (C, length) {
    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
      throw TypeError('It is not a typed array constructor!');
    } return new C(length);
  };

  var speciesFromList = function (O, list) {
    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
  };

  var fromList = function (C, list) {
    var index = 0;
    var length = list.length;
    var result = allocate(C, length);
    while (length > index) result[index] = list[index++];
    return result;
  };

  var addGetter = function (it, key, internal) {
    dP(it, key, { get: function () { return this._d[internal]; } });
  };

  var $from = function from(source /* , mapfn, thisArg */) {
    var O = toObject(source);
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var iterFn = getIterFn(O);
    var i, length, values, result, step, iterator;
    if (iterFn != undefined && !isArrayIter(iterFn)) {
      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
        values.push(step.value);
      } O = values;
    }
    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
      result[i] = mapping ? mapfn(O[i], i) : O[i];
    }
    return result;
  };

  var $of = function of(/* ...items */) {
    var index = 0;
    var length = arguments.length;
    var result = allocate(this, length);
    while (length > index) result[index] = arguments[index++];
    return result;
  };

  // iOS Safari 6.x fails here
  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

  var $toLocaleString = function toLocaleString() {
    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
  };

  var proto = {
    copyWithin: function copyWithin(target, start /* , end */) {
      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
    },
    every: function every(callbackfn /* , thisArg */) {
      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
      return arrayFill.apply(validate(this), arguments);
    },
    filter: function filter(callbackfn /* , thisArg */) {
      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
        arguments.length > 1 ? arguments[1] : undefined));
    },
    find: function find(predicate /* , thisArg */) {
      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    findIndex: function findIndex(predicate /* , thisArg */) {
      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
    },
    forEach: function forEach(callbackfn /* , thisArg */) {
      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    indexOf: function indexOf(searchElement /* , fromIndex */) {
      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    includes: function includes(searchElement /* , fromIndex */) {
      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
    },
    join: function join(separator) { // eslint-disable-line no-unused-vars
      return arrayJoin.apply(validate(this), arguments);
    },
    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
      return arrayLastIndexOf.apply(validate(this), arguments);
    },
    map: function map(mapfn /* , thisArg */) {
      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduce.apply(validate(this), arguments);
    },
    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
      return arrayReduceRight.apply(validate(this), arguments);
    },
    reverse: function reverse() {
      var that = this;
      var length = validate(that).length;
      var middle = Math.floor(length / 2);
      var index = 0;
      var value;
      while (index < middle) {
        value = that[index];
        that[index++] = that[--length];
        that[length] = value;
      } return that;
    },
    some: function some(callbackfn /* , thisArg */) {
      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
    },
    sort: function sort(comparefn) {
      return arraySort.call(validate(this), comparefn);
    },
    subarray: function subarray(begin, end) {
      var O = validate(this);
      var length = O.length;
      var $begin = toAbsoluteIndex(begin, length);
      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
        O.buffer,
        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
      );
    }
  };

  var $slice = function slice(start, end) {
    return speciesFromList(this, arraySlice.call(validate(this), start, end));
  };

  var $set = function set(arrayLike /* , offset */) {
    validate(this);
    var offset = toOffset(arguments[1], 1);
    var length = this.length;
    var src = toObject(arrayLike);
    var len = toLength(src.length);
    var index = 0;
    if (len + offset > length) throw RangeError(WRONG_LENGTH);
    while (index < len) this[offset + index] = src[index++];
  };

  var $iterators = {
    entries: function entries() {
      return arrayEntries.call(validate(this));
    },
    keys: function keys() {
      return arrayKeys.call(validate(this));
    },
    values: function values() {
      return arrayValues.call(validate(this));
    }
  };

  var isTAIndex = function (target, key) {
    return isObject(target)
      && target[TYPED_ARRAY]
      && typeof key != 'symbol'
      && key in target
      && String(+key) == String(key);
  };
  var $getDesc = function getOwnPropertyDescriptor(target, key) {
    return isTAIndex(target, key = toPrimitive(key, true))
      ? propertyDesc(2, target[key])
      : gOPD(target, key);
  };
  var $setDesc = function defineProperty(target, key, desc) {
    if (isTAIndex(target, key = toPrimitive(key, true))
      && isObject(desc)
      && has(desc, 'value')
      && !has(desc, 'get')
      && !has(desc, 'set')
      // TODO: add validation descriptor w/o calling accessors
      && !desc.configurable
      && (!has(desc, 'writable') || desc.writable)
      && (!has(desc, 'enumerable') || desc.enumerable)
    ) {
      target[key] = desc.value;
      return target;
    } return dP(target, key, desc);
  };

  if (!ALL_CONSTRUCTORS) {
    $GOPD.f = $getDesc;
    $DP.f = $setDesc;
  }

  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
    getOwnPropertyDescriptor: $getDesc,
    defineProperty: $setDesc
  });

  if (fails(function () { arrayToString.call({}); })) {
    arrayToString = arrayToLocaleString = function toString() {
      return arrayJoin.call(this);
    };
  }

  var $TypedArrayPrototype$ = redefineAll({}, proto);
  redefineAll($TypedArrayPrototype$, $iterators);
  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
  redefineAll($TypedArrayPrototype$, {
    slice: $slice,
    set: $set,
    constructor: function () { /* noop */ },
    toString: arrayToString,
    toLocaleString: $toLocaleString
  });
  addGetter($TypedArrayPrototype$, 'buffer', 'b');
  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
  addGetter($TypedArrayPrototype$, 'length', 'e');
  dP($TypedArrayPrototype$, TAG, {
    get: function () { return this[TYPED_ARRAY]; }
  });

  // eslint-disable-next-line max-statements
  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
    CLAMPED = !!CLAMPED;
    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
    var GETTER = 'get' + KEY;
    var SETTER = 'set' + KEY;
    var TypedArray = global[NAME];
    var Base = TypedArray || {};
    var TAC = TypedArray && getPrototypeOf(TypedArray);
    var FORCED = !TypedArray || !$typed.ABV;
    var O = {};
    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
    var getter = function (that, index) {
      var data = that._d;
      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
    };
    var setter = function (that, index, value) {
      var data = that._d;
      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
    };
    var addElement = function (that, index) {
      dP(that, index, {
        get: function () {
          return getter(this, index);
        },
        set: function (value) {
          return setter(this, index, value);
        },
        enumerable: true
      });
    };
    if (FORCED) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME, '_d');
        var index = 0;
        var offset = 0;
        var buffer, byteLength, length, klass;
        if (!isObject(data)) {
          length = toIndex(data);
          byteLength = length * BYTES;
          buffer = new $ArrayBuffer(byteLength);
        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          buffer = data;
          offset = toOffset($offset, BYTES);
          var $len = data.byteLength;
          if ($length === undefined) {
            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
            byteLength = $len - offset;
            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
          } else {
            byteLength = toLength($length) * BYTES;
            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
          }
          length = byteLength / BYTES;
        } else if (TYPED_ARRAY in data) {
          return fromList(TypedArray, data);
        } else {
          return $from.call(TypedArray, data);
        }
        hide(that, '_d', {
          b: buffer,
          o: offset,
          l: byteLength,
          e: length,
          v: new $DataView(buffer)
        });
        while (index < length) addElement(that, index++);
      });
      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
      hide(TypedArrayPrototype, 'constructor', TypedArray);
    } else if (!fails(function () {
      TypedArray(1);
    }) || !fails(function () {
      new TypedArray(-1); // eslint-disable-line no-new
    }) || !$iterDetect(function (iter) {
      new TypedArray(); // eslint-disable-line no-new
      new TypedArray(null); // eslint-disable-line no-new
      new TypedArray(1.5); // eslint-disable-line no-new
      new TypedArray(iter); // eslint-disable-line no-new
    }, true)) {
      TypedArray = wrapper(function (that, data, $offset, $length) {
        anInstance(that, TypedArray, NAME);
        var klass;
        // `ws` module bug, temporarily remove validation length for Uint8Array
        // https://github.com/websockets/ws/pull/645
        if (!isObject(data)) return new Base(toIndex(data));
        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
          return $length !== undefined
            ? new Base(data, toOffset($offset, BYTES), $length)
            : $offset !== undefined
              ? new Base(data, toOffset($offset, BYTES))
              : new Base(data);
        }
        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
        return $from.call(TypedArray, data);
      });
      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
      });
      TypedArray[PROTOTYPE] = TypedArrayPrototype;
      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
    }
    var $nativeIterator = TypedArrayPrototype[ITERATOR];
    var CORRECT_ITER_NAME = !!$nativeIterator
      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
    var $iterator = $iterators.values;
    hide(TypedArray, TYPED_CONSTRUCTOR, true);
    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
    hide(TypedArrayPrototype, VIEW, true);
    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
      dP(TypedArrayPrototype, TAG, {
        get: function () { return NAME; }
      });
    }

    O[NAME] = TypedArray;

    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

    $export($export.S, NAME, {
      BYTES_PER_ELEMENT: BYTES
    });

    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
      from: $from,
      of: $of
    });

    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

    $export($export.P, NAME, proto);

    setSpecies(NAME);

    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

    $export($export.P + $export.F * fails(function () {
      new TypedArray(1).slice();
    }), NAME, { slice: $slice });

    $export($export.P + $export.F * (fails(function () {
      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
    }) || !fails(function () {
      TypedArrayPrototype.toLocaleString.call([1, 2]);
    })), NAME, { toLocaleString: $toLocaleString });

    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
  };
} else module.exports = function () { /* empty */ };


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(2828);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var KEY_DELIMITER = '-';
var DraftOffsetKey = {
  encode: function encode(blockKey, decoratorKey, leafKey) {
    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
  },
  decode: function decode(offsetKey) {
    // Extracts the last two parts of offsetKey and captures the rest in blockKeyParts
    var _offsetKey$split$reve = offsetKey.split(KEY_DELIMITER).reverse(),
        leafKey = _offsetKey$split$reve[0],
        decoratorKey = _offsetKey$split$reve[1],
        blockKeyParts = _offsetKey$split$reve.slice(2);

    return {
      // Recomposes the parts of blockKey after reversing them
      blockKey: blockKeyParts.reverse().join(KEY_DELIMITER),
      decoratorKey: parseInt(decoratorKey, 10),
      leafKey: parseInt(leafKey, 10)
    };
  }
};
module.exports = DraftOffsetKey;

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = keyMap;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * for each value in the array.
 *
 * This provides a convenient lookup for the array items if the key function
 * produces unique results.
 *
 *     const phoneBook = [
 *       { name: 'Jon', num: '555-1234' },
 *       { name: 'Jenny', num: '867-5309' }
 *     ]
 *
 *     // { Jon: { name: 'Jon', num: '555-1234' },
 *     //   Jenny: { name: 'Jenny', num: '867-5309' } }
 *     const entriesByName = keyMap(
 *       phoneBook,
 *       entry => entry.name
 *     )
 *
 *     // { name: 'Jenny', num: '857-6309' }
 *     const jennyEntry = entriesByName['Jenny']
 *
 */
function keyMap(list, keyFn) {
  return list.reduce(function (map, item) {
    return map[keyFn(item)] = item, map;
  }, Object.create(null));
}

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSpecifiedScalarType = isSpecifiedScalarType;
exports.specifiedScalarTypes = exports.GraphQLID = exports.GraphQLBoolean = exports.GraphQLString = exports.GraphQLFloat = exports.GraphQLInt = void 0;

var _inspect = _interopRequireDefault(__webpack_require__(93));

var _isFinite = _interopRequireDefault(__webpack_require__(2973));

var _isInteger = _interopRequireDefault(__webpack_require__(2974));

var _definition = __webpack_require__(54);

var _kinds = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
// As per the GraphQL Spec, Integers are only treated as valid when a valid
// 32-bit signed integer, providing the broadest support across platforms.
//
// n.b. JavaScript's integers are safe between -(2^53 - 1) and 2^53 - 1 because
// they are internally represented as IEEE 754 doubles.
var MAX_INT = 2147483647;
var MIN_INT = -2147483648;

function serializeInt(value) {
  if (typeof value === 'boolean') {
    return value ? 1 : 0;
  }

  var num = value;

  if (typeof value === 'string' && value !== '') {
    num = Number(value);
  }

  if (!(0, _isInteger.default)(num)) {
    throw new TypeError("Int cannot represent non-integer value: ".concat((0, _inspect.default)(value)));
  }

  if (num > MAX_INT || num < MIN_INT) {
    throw new TypeError("Int cannot represent non 32-bit signed integer value: ".concat((0, _inspect.default)(value)));
  }

  return num;
}

function coerceInt(value) {
  if (!(0, _isInteger.default)(value)) {
    throw new TypeError("Int cannot represent non-integer value: ".concat((0, _inspect.default)(value)));
  }

  if (value > MAX_INT || value < MIN_INT) {
    throw new TypeError("Int cannot represent non 32-bit signed integer value: ".concat((0, _inspect.default)(value)));
  }

  return value;
}

var GraphQLInt = new _definition.GraphQLScalarType({
  name: 'Int',
  description: 'The `Int` scalar type represents non-fractional signed whole numeric ' + 'values. Int can represent values between -(2^31) and 2^31 - 1. ',
  serialize: serializeInt,
  parseValue: coerceInt,
  parseLiteral: function parseLiteral(ast) {
    if (ast.kind === _kinds.Kind.INT) {
      var num = parseInt(ast.value, 10);

      if (num <= MAX_INT && num >= MIN_INT) {
        return num;
      }
    }

    return undefined;
  }
});
exports.GraphQLInt = GraphQLInt;

function serializeFloat(value) {
  if (typeof value === 'boolean') {
    return value ? 1 : 0;
  }

  var num = value;

  if (typeof value === 'string' && value !== '') {
    num = Number(value);
  }

  if (!(0, _isFinite.default)(num)) {
    throw new TypeError("Float cannot represent non numeric value: ".concat((0, _inspect.default)(value)));
  }

  return num;
}

function coerceFloat(value) {
  if (!(0, _isFinite.default)(value)) {
    throw new TypeError("Float cannot represent non numeric value: ".concat((0, _inspect.default)(value)));
  }

  return value;
}

var GraphQLFloat = new _definition.GraphQLScalarType({
  name: 'Float',
  description: 'The `Float` scalar type represents signed double-precision fractional ' + 'values as specified by ' + '[IEEE 754](http://en.wikipedia.org/wiki/IEEE_floating_point). ',
  serialize: serializeFloat,
  parseValue: coerceFloat,
  parseLiteral: function parseLiteral(ast) {
    return ast.kind === _kinds.Kind.FLOAT || ast.kind === _kinds.Kind.INT ? parseFloat(ast.value) : undefined;
  }
});
exports.GraphQLFloat = GraphQLFloat;

function serializeString(value) {
  // Support serializing objects with custom valueOf() functions - a common way
  // to represent an complex value which can be represented as a string
  // (ex: MongoDB id objects).
  var result = value && typeof value.valueOf === 'function' ? value.valueOf() : value; // Serialize string, boolean and number values to a string, but do not
  // attempt to coerce object, function, symbol, or other types as strings.

  if (typeof result === 'string') {
    return result;
  }

  if (typeof result === 'boolean') {
    return result ? 'true' : 'false';
  }

  if ((0, _isFinite.default)(result)) {
    return result.toString();
  }

  throw new TypeError("String cannot represent value: ".concat((0, _inspect.default)(value)));
}

function coerceString(value) {
  if (typeof value !== 'string') {
    throw new TypeError("String cannot represent a non string value: ".concat((0, _inspect.default)(value)));
  }

  return value;
}

var GraphQLString = new _definition.GraphQLScalarType({
  name: 'String',
  description: 'The `String` scalar type represents textual data, represented as UTF-8 ' + 'character sequences. The String type is most often used by GraphQL to ' + 'represent free-form human-readable text.',
  serialize: serializeString,
  parseValue: coerceString,
  parseLiteral: function parseLiteral(ast) {
    return ast.kind === _kinds.Kind.STRING ? ast.value : undefined;
  }
});
exports.GraphQLString = GraphQLString;

function serializeBoolean(value) {
  if (typeof value === 'boolean') {
    return value;
  }

  if ((0, _isFinite.default)(value)) {
    return value !== 0;
  }

  throw new TypeError("Boolean cannot represent a non boolean value: ".concat((0, _inspect.default)(value)));
}

function coerceBoolean(value) {
  if (typeof value !== 'boolean') {
    throw new TypeError("Boolean cannot represent a non boolean value: ".concat((0, _inspect.default)(value)));
  }

  return value;
}

var GraphQLBoolean = new _definition.GraphQLScalarType({
  name: 'Boolean',
  description: 'The `Boolean` scalar type represents `true` or `false`.',
  serialize: serializeBoolean,
  parseValue: coerceBoolean,
  parseLiteral: function parseLiteral(ast) {
    return ast.kind === _kinds.Kind.BOOLEAN ? ast.value : undefined;
  }
});
exports.GraphQLBoolean = GraphQLBoolean;

function serializeID(value) {
  // Support serializing objects with custom valueOf() functions - a common way
  // to represent an object identifier (ex. MongoDB).
  var result = value && typeof value.valueOf === 'function' ? value.valueOf() : value;

  if (typeof result === 'string') {
    return result;
  }

  if ((0, _isInteger.default)(result)) {
    return String(result);
  }

  throw new TypeError("ID cannot represent value: ".concat((0, _inspect.default)(value)));
}

function coerceID(value) {
  if (typeof value === 'string') {
    return value;
  }

  if ((0, _isInteger.default)(value)) {
    return value.toString();
  }

  throw new TypeError("ID cannot represent value: ".concat((0, _inspect.default)(value)));
}

var GraphQLID = new _definition.GraphQLScalarType({
  name: 'ID',
  description: 'The `ID` scalar type represents a unique identifier, often used to ' + 'refetch an object or as key for a cache. The ID type appears in a JSON ' + 'response as a String; however, it is not intended to be human-readable. ' + 'When expected as an input type, any string (such as `"4"`) or integer ' + '(such as `4`) input value will be accepted as an ID.',
  serialize: serializeID,
  parseValue: coerceID,
  parseLiteral: function parseLiteral(ast) {
    return ast.kind === _kinds.Kind.STRING || ast.kind === _kinds.Kind.INT ? ast.value : undefined;
  }
});
exports.GraphQLID = GraphQLID;
var specifiedScalarTypes = [GraphQLString, GraphQLInt, GraphQLFloat, GraphQLBoolean, GraphQLID];
exports.specifiedScalarTypes = specifiedScalarTypes;

function isSpecifiedScalarType(type) {
  return (0, _definition.isNamedType)(type) && ( // Would prefer to use specifiedScalarTypes.some(), however %checks needs
  // a simple expression.
  type.name === GraphQLString.name || type.name === GraphQLInt.name || type.name === GraphQLFloat.name || type.name === GraphQLBoolean.name || type.name === GraphQLID.name);
}

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeFromAST = typeFromAST;

var _kinds = __webpack_require__(68);

var _definition = __webpack_require__(54);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function typeFromAST(schema, typeNode) {
  /* eslint-enable no-redeclare */
  var innerType;

  if (typeNode.kind === _kinds.Kind.LIST_TYPE) {
    innerType = typeFromAST(schema, typeNode.type);
    return innerType && (0, _definition.GraphQLList)(innerType);
  }

  if (typeNode.kind === _kinds.Kind.NON_NULL_TYPE) {
    innerType = typeFromAST(schema, typeNode.type);
    return innerType && (0, _definition.GraphQLNonNull)(innerType);
  }

  if (typeNode.kind === _kinds.Kind.NAMED_TYPE) {
    return schema.getType(typeNode.name.value);
  }
  /* istanbul ignore next */


  throw new Error("Unexpected type kind: ".concat(typeNode.kind, "."));
}

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(1251);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isNil__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_get__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_Label__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_Checkbox__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__addons_Radio__ = __webpack_require__(700);










/**
 * A field is a form element containing a label and an input.
 * @see Form
 * @see Button
 * @see Checkbox
 * @see Dropdown
 * @see Input
 * @see Radio
 * @see Select
 * @see Visibility
 */

function FormField(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      control = props.control,
      disabled = props.disabled,
      error = props.error,
      inline = props.inline,
      label = props.label,
      required = props.required,
      type = props.type,
      width = props.width,
      id = props.id;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(error, 'error'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(inline, 'inline'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(required, 'required'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["f" /* useWidthProp */])(width, 'wide'), 'field', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(FormField, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(FormField, props);

  var errorPointing = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_get__["a" /* default */])(error, 'pointing', 'above');

  var errorLabel = __WEBPACK_IMPORTED_MODULE_7__elements_Label__["a" /* default */].create(error, {
    autoGenerateKey: false,
    defaultProps: {
      prompt: true,
      pointing: errorPointing,
      id: id ? id + "-error-message" : undefined,
      role: 'alert',
      'aria-atomic': true
    }
  });
  var errorLabelBefore = (errorPointing === 'below' || errorPointing === 'right') && errorLabel;
  var errorLabelAfter = (errorPointing === 'above' || errorPointing === 'left') && errorLabel; // ----------------------------------------
  // No Control
  // ----------------------------------------

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isNil__["a" /* default */])(control)) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isNil__["a" /* default */])(label)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        className: classes,
        id: id
      }), __WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes,
      id: id
    }), errorLabelBefore, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["z" /* createHTMLLabel */])(label, {
      autoGenerateKey: false
    }), errorLabelAfter);
  } // ----------------------------------------
  // Checkbox/Radio Control
  // ----------------------------------------


  var ariaDescribedBy = id && error ? id + "-error-message" : null;
  var ariaAttrs = {
    'aria-describedby': ariaDescribedBy,
    'aria-invalid': error ? true : undefined
  };

  var controlProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    content: content,
    children: children,
    disabled: disabled,
    required: required,
    type: type,
    id: id
  }); // wrap HTML checkboxes/radios in the label


  if (control === 'input' && (type === 'checkbox' || type === 'radio')) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, {
      className: classes
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("label", null, errorLabelBefore, /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["createElement"])(control, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ariaAttrs, controlProps)), " ", label, errorLabelAfter));
  } // pass label prop to controls that support it


  if (control === __WEBPACK_IMPORTED_MODULE_8__modules_Checkbox__["a" /* default */] || control === __WEBPACK_IMPORTED_MODULE_9__addons_Radio__["a" /* default */]) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, {
      className: classes
    }, errorLabelBefore, /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["createElement"])(control, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ariaAttrs, controlProps, {
      label: label
    })), errorLabelAfter);
  } // ----------------------------------------
  // Other Control
  // ----------------------------------------


  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, {
    className: classes
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["z" /* createHTMLLabel */])(label, {
    defaultProps: {
      htmlFor: id
    },
    autoGenerateKey: false
  }), errorLabelBefore, /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react__["createElement"])(control, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ariaAttrs, controlProps)), errorLabelAfter);
}

FormField.handledProps = ["as", "children", "className", "content", "control", "disabled", "error", "id", "inline", "label", "required", "type", "width"];
FormField.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /**
   * A form control component (i.e. Dropdown) or HTML tagName (i.e. 'input').
   * Extra FormField props are passed to the control component.
   * Mutually exclusive with children.
   */
  control: PropTypes.oneOfType([PropTypes.elementType, PropTypes.oneOf(['button', 'input', 'select', 'textarea'])]),

  /** Individual fields may be disabled. */
  disabled: PropTypes.bool,

  /** Individual fields may display an error state along with a message. */
  error: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),

  /** The id of the control */
  id: PropTypes.string,

  /** A field can have its label next to instead of above it. */
  inline: PropTypes.bool,
  // Heads Up!
  // Do not disallow children with `label` shorthand
  // The `control` might accept a `label` prop and `children`

  /** Mutually exclusive with children. */
  label: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),

  /** A field can show that input is mandatory. */
  required: PropTypes.bool,

  /** Passed to the control component (i.e. <input type='password' />) */
  type: customPropTypes.every([customPropTypes.demand(['control']) // don't strictly validate HTML types
  // a control might be passed that uses a `type` prop with unknown values
  // let the control validate if for us
  ]),

  /** A field can specify its width in grid columns */
  width: PropTypes.oneOf(SUI.WIDTHS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FormField);

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(3402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(3433);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),
/* 190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CloudWatchLogs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CloudWatchLogsClient__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commands_AssociateKmsKeyCommand__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_CancelExportTaskCommand__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commands_CreateExportTaskCommand__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commands_CreateLogGroupCommand__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commands_CreateLogStreamCommand__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commands_DeleteDestinationCommand__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commands_DeleteLogGroupCommand__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commands_DeleteLogStreamCommand__ = __webpack_require__(798);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commands_DeleteMetricFilterCommand__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commands_DeleteQueryDefinitionCommand__ = __webpack_require__(800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commands_DeleteResourcePolicyCommand__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commands_DeleteRetentionPolicyCommand__ = __webpack_require__(802);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commands_DeleteSubscriptionFilterCommand__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commands_DescribeDestinationsCommand__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commands_DescribeExportTasksCommand__ = __webpack_require__(804);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__commands_DescribeLogGroupsCommand__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__commands_DescribeLogStreamsCommand__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__commands_DescribeMetricFiltersCommand__ = __webpack_require__(518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__commands_DescribeQueriesCommand__ = __webpack_require__(805);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__commands_DescribeQueryDefinitionsCommand__ = __webpack_require__(806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__commands_DescribeResourcePoliciesCommand__ = __webpack_require__(807);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__commands_DescribeSubscriptionFiltersCommand__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__commands_DisassociateKmsKeyCommand__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__commands_FilterLogEventsCommand__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__commands_GetLogEventsCommand__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__commands_GetLogGroupFieldsCommand__ = __webpack_require__(809);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__commands_GetLogRecordCommand__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__commands_GetQueryResultsCommand__ = __webpack_require__(811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__commands_ListTagsLogGroupCommand__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__commands_PutDestinationCommand__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__commands_PutDestinationPolicyCommand__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__commands_PutLogEventsCommand__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__commands_PutMetricFilterCommand__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__commands_PutQueryDefinitionCommand__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__commands_PutResourcePolicyCommand__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__commands_PutRetentionPolicyCommand__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__commands_PutSubscriptionFilterCommand__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__commands_StartQueryCommand__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__commands_StopQueryCommand__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__commands_TagLogGroupCommand__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__commands_TestMetricFilterCommand__ = __webpack_require__(824);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__commands_UntagLogGroupCommand__ = __webpack_require__(825);












































/**
 * <p>You can use Amazon CloudWatch Logs to monitor, store, and access your log files from
 *       EC2 instances, AWS CloudTrail, or other sources. You can then retrieve the associated
 *       log data from CloudWatch Logs using the CloudWatch console, CloudWatch Logs commands in the
 *       AWS CLI, CloudWatch Logs API, or CloudWatch Logs SDK.</p>
 *          <p>You can use CloudWatch Logs to:</p>
 *          <ul>
 *             <li>
 *                <p>
 *                   <b>Monitor logs from EC2 instances in real-time</b>: You
 *           can use CloudWatch Logs to monitor applications and systems using log data. For example,
 *           CloudWatch Logs can track the number of errors that occur in your application logs and
 *           send you a notification whenever the rate of errors exceeds a threshold that you specify.
 *           CloudWatch Logs uses your log data for monitoring so no code changes are required. For
 *           example, you can monitor application logs for specific literal terms (such as
 *           "NullReferenceException") or count the number of occurrences of a literal term at a
 *           particular position in log data (such as "404" status codes in an Apache access log). When
 *           the term you are searching for is found, CloudWatch Logs reports the data to a CloudWatch
 *           metric that you specify.</p>
 *             </li>
 *             <li>
 *                <p>
 *                   <b>Monitor AWS CloudTrail logged events</b>: You can
 *           create alarms in CloudWatch and receive notifications of particular API activity as
 *           captured by CloudTrail. You can use the notification to perform troubleshooting.</p>
 *             </li>
 *             <li>
 *                <p>
 *                   <b>Archive log data</b>: You can use CloudWatch Logs to
 *           store your log data in highly durable storage. You can change the log retention setting so
 *           that any log events older than this setting are automatically deleted. The CloudWatch Logs
 *           agent makes it easy to quickly send both rotated and non-rotated log data off of a host
 *           and into the log service. You can then access the raw log data when you need it.</p>
 *             </li>
 *          </ul>
 */
var CloudWatchLogs = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CloudWatchLogs, _super);
    function CloudWatchLogs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CloudWatchLogs.prototype.associateKmsKey = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_2__commands_AssociateKmsKeyCommand__["a" /* AssociateKmsKeyCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.cancelExportTask = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_3__commands_CancelExportTaskCommand__["a" /* CancelExportTaskCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.createExportTask = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_4__commands_CreateExportTaskCommand__["a" /* CreateExportTaskCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.createLogGroup = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_5__commands_CreateLogGroupCommand__["a" /* CreateLogGroupCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.createLogStream = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_6__commands_CreateLogStreamCommand__["a" /* CreateLogStreamCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.deleteDestination = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_7__commands_DeleteDestinationCommand__["a" /* DeleteDestinationCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.deleteLogGroup = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_8__commands_DeleteLogGroupCommand__["a" /* DeleteLogGroupCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.deleteLogStream = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_9__commands_DeleteLogStreamCommand__["a" /* DeleteLogStreamCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.deleteMetricFilter = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_10__commands_DeleteMetricFilterCommand__["a" /* DeleteMetricFilterCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.deleteQueryDefinition = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_11__commands_DeleteQueryDefinitionCommand__["a" /* DeleteQueryDefinitionCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.deleteResourcePolicy = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_12__commands_DeleteResourcePolicyCommand__["a" /* DeleteResourcePolicyCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.deleteRetentionPolicy = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_13__commands_DeleteRetentionPolicyCommand__["a" /* DeleteRetentionPolicyCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.deleteSubscriptionFilter = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_14__commands_DeleteSubscriptionFilterCommand__["a" /* DeleteSubscriptionFilterCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.describeDestinations = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_15__commands_DescribeDestinationsCommand__["a" /* DescribeDestinationsCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.describeExportTasks = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_16__commands_DescribeExportTasksCommand__["a" /* DescribeExportTasksCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.describeLogGroups = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_17__commands_DescribeLogGroupsCommand__["a" /* DescribeLogGroupsCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.describeLogStreams = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_18__commands_DescribeLogStreamsCommand__["a" /* DescribeLogStreamsCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.describeMetricFilters = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_19__commands_DescribeMetricFiltersCommand__["a" /* DescribeMetricFiltersCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.describeQueries = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_20__commands_DescribeQueriesCommand__["a" /* DescribeQueriesCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.describeQueryDefinitions = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_21__commands_DescribeQueryDefinitionsCommand__["a" /* DescribeQueryDefinitionsCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.describeResourcePolicies = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_22__commands_DescribeResourcePoliciesCommand__["a" /* DescribeResourcePoliciesCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.describeSubscriptionFilters = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_23__commands_DescribeSubscriptionFiltersCommand__["a" /* DescribeSubscriptionFiltersCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.disassociateKmsKey = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_24__commands_DisassociateKmsKeyCommand__["a" /* DisassociateKmsKeyCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.filterLogEvents = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_25__commands_FilterLogEventsCommand__["a" /* FilterLogEventsCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.getLogEvents = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_26__commands_GetLogEventsCommand__["a" /* GetLogEventsCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.getLogGroupFields = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_27__commands_GetLogGroupFieldsCommand__["a" /* GetLogGroupFieldsCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.getLogRecord = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_28__commands_GetLogRecordCommand__["a" /* GetLogRecordCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.getQueryResults = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_29__commands_GetQueryResultsCommand__["a" /* GetQueryResultsCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.listTagsLogGroup = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_30__commands_ListTagsLogGroupCommand__["a" /* ListTagsLogGroupCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.putDestination = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_31__commands_PutDestinationCommand__["a" /* PutDestinationCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.putDestinationPolicy = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_32__commands_PutDestinationPolicyCommand__["a" /* PutDestinationPolicyCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.putLogEvents = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_33__commands_PutLogEventsCommand__["a" /* PutLogEventsCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.putMetricFilter = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_34__commands_PutMetricFilterCommand__["a" /* PutMetricFilterCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.putQueryDefinition = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_35__commands_PutQueryDefinitionCommand__["a" /* PutQueryDefinitionCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.putResourcePolicy = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_36__commands_PutResourcePolicyCommand__["a" /* PutResourcePolicyCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.putRetentionPolicy = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_37__commands_PutRetentionPolicyCommand__["a" /* PutRetentionPolicyCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.putSubscriptionFilter = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_38__commands_PutSubscriptionFilterCommand__["a" /* PutSubscriptionFilterCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.startQuery = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_39__commands_StartQueryCommand__["a" /* StartQueryCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.stopQuery = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_40__commands_StopQueryCommand__["a" /* StopQueryCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.tagLogGroup = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_41__commands_TagLogGroupCommand__["a" /* TagLogGroupCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.testMetricFilter = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_42__commands_TestMetricFilterCommand__["a" /* TestMetricFilterCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CloudWatchLogs.prototype.untagLogGroup = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_43__commands_UntagLogGroupCommand__["a" /* UntagLogGroupCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    return CloudWatchLogs;
}(__WEBPACK_IMPORTED_MODULE_1__CloudWatchLogsClient__["a" /* CloudWatchLogsClient */]));

//# sourceMappingURL=CloudWatchLogs.js.map

/***/ }),
/* 191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDocumentElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instanceOf_js__ = __webpack_require__(125);

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__instanceOf_js__["a" /* isElement */])(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _Validate = __webpack_require__(219);

var _Validate2 = _interopRequireDefault(_Validate);

var _Helper = __webpack_require__(381);

var _Helper2 = _interopRequireDefault(_Helper);

var _identityTypes = __webpack_require__(174);

var _fetchM = __webpack_require__(6);

var _tin = __webpack_require__(155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TinFieldInput = function (_Component) {
  _inherits(TinFieldInput, _Component);

  function TinFieldInput(props) {
    var _this2 = this;

    _classCallCheck(this, TinFieldInput);

    var _this = _possibleConstructorReturn(this, (TinFieldInput.__proto__ || Object.getPrototypeOf(TinFieldInput)).call(this, props));

    _this.handleOnChange = function (e, data) {
      _this.setState({
        hasValueChanged: true,
        localErrMessage: null
      });

      if (_this.props.onChange) {
        _this.props.onChange(e, data);
      }
    };

    _this.resetHasValueChanged = function () {
      _this.setState({ hasValueChanged: false });
    };

    _this.identityValueHasChanged = function () {
      _this.setState({ searchedTinValue: null, searchTinFound: false });
    };

    _this.handleSearchTin = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var BUFFER_MILLISEC, _this$props, identityType, identityValue, now, diffTime, roundedSeconds;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              BUFFER_MILLISEC = 5000;
              _this$props = _this.props, identityType = _this$props.identityType, identityValue = _this$props.identityValue;


              _this.handleOnChange({ target: { value: '', tinFound: false } });

              if (!(!identityType || !identityValue)) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt('return');

            case 5:
              if (!_this.state.searchTimestamp) {
                _context2.next = 14;
                break;
              }

              now = Date.now();
              diffTime = now - _this.state.searchTimestamp;

              if (!(diffTime <= BUFFER_MILLISEC)) {
                _context2.next = 12;
                break;
              }

              roundedSeconds = Math.ceil((BUFFER_MILLISEC - diffTime) / 1000);

              _this.setState({
                hasValueChanged: true,
                localErrMessage: 'Cooldown ' + roundedSeconds + ' second' + (roundedSeconds > 1 ? 's' : '')
              });
              return _context2.abrupt('return');

            case 12:
              clearInterval(_this.searchTimestamp);
              _this.setState({
                hasValueChanged: false,
                localErrMessage: null
              });

            case 14:
              _this.setState({ searchedTinValue: null, searchLoading: true, searchTimestamp: Date.now() });

              // simulate a processing time during search tin
              _this.searchTimeout = setTimeout(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var idType, query, store, res, data, errMessage, _errMessage;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        idType = (0, _identityTypes.getIdentityTypeOpts)().find(function (i) {
                          return i.value === identityType;
                        }).tin_code;
                        query = Object.assign({
                          idType: idType,
                          idValue: identityValue,
                          unitID: _this.props.unitID || null,
                          bookingID: _this.props.bookingID || null
                        });
                        store = _this.context.store;
                        _context.prev = 3;
                        _context.next = 6;
                        return store.dispatch((0, _fetchM.fetchM)('/tin/search/?' + _qs2.default.stringify(query), {
                          credentials: 'include',
                          method: 'GET',
                          headers: {
                            'Content-Type': 'application/json',
                            'X-Origin': _this.state.origin
                          }
                        }));

                      case 6:
                        res = _context.sent;

                        if (!(res && res.ok)) {
                          _context.next = 14;
                          break;
                        }

                        _context.next = 10;
                        return res.json();

                      case 10:
                        data = _context.sent;

                        _this.setState({ searchedTinValue: data.tin, searchLoading: false, searchTinFound: true, hasValueChanged: false, localErrMessage: null });
                        _this.handleOnChange({ target: { value: data.tin, tinFound: true } });
                        return _context.abrupt('return');

                      case 14:
                        _context.next = 16;
                        return res.text();

                      case 16:
                        errMessage = _context.sent;
                        throw Error(errMessage);

                      case 20:
                        _context.prev = 20;
                        _context.t0 = _context['catch'](3);

                        if (!_context.t0.res) {
                          _context.next = 28;
                          break;
                        }

                        _context.next = 25;
                        return _context.t0.res.text();

                      case 25:
                        _context.t1 = _context.sent;
                        _context.next = 29;
                        break;

                      case 28:
                        _context.t1 = _context.t0.message;

                      case 29:
                        _errMessage = _context.t1;

                        _this.setState({ searchedTinValue: null, searchLoading: false, searchTinFound: false, hasValueChanged: true, localErrMessage: _errMessage });

                      case 31:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, _this2, [[3, 20]]);
              })), 1500);

            case 16:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.state = {
      localErrMessage: props.errMessage || null,
      hasValueChanged: false,
      searchLoading: false,
      searchTinFound: false,
      searchTimestamp: null,
      searchedTinValue: null,
      origin: window.location.origin
    };
    return _this;
  }

  _createClass(TinFieldInput, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props = this.props,
          value = _props.value,
          identityValue = _props.identityValue;
      var _state = this.state,
          searchTinFound = _state.searchTinFound,
          searchedTinValue = _state.searchedTinValue,
          searchLoading = _state.searchLoading;


      if (identityValue && prevProps.identityValue !== identityValue && !_tin.GENERIC_TIN_VALUES.includes(value)) {
        this.handleOnChange({ target: { value: '', tinFound: false } });
        this.identityValueHasChanged();
      }

      if (value && prevProps.value !== value && !searchTinFound) {
        this.handleOnChange({ target: { value: value, tinFound: false } });
      } else if (prevState.searchLoading !== searchLoading && !searchLoading && searchTinFound) {
        this.handleOnChange({ target: { value: searchedTinValue, tinFound: searchTinFound } });
      }

      if (value && prevProps.isLoading && !this.props.isLoading) {
        this.resetHasValueChanged();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
    }
  }, {
    key: 'getIconName',
    value: function getIconName() {
      var _props2 = this.props,
          isLoading = _props2.isLoading,
          tinError = _props2.tinError;
      var _state2 = this.state,
          searchLoading = _state2.searchLoading,
          searchTinFound = _state2.searchTinFound;

      if (searchLoading || isLoading) {
        return 'circle notch';
      }
      if (tinError) {
        return 'remove circle';
      }
      if (searchTinFound || tinError === false) {
        return 'check circle';
      }
      return '';
    }
  }, {
    key: 'getIconColor',
    value: function getIconColor() {
      var _props3 = this.props,
          isLoading = _props3.isLoading,
          tinError = _props3.tinError;
      var _state3 = this.state,
          searchLoading = _state3.searchLoading,
          searchTinFound = _state3.searchTinFound;

      if (searchLoading || isLoading) {
        return 'grey';
      }
      if (tinError) {
        return 'red';
      }
      if (searchTinFound || tinError === false) {
        return 'green';
      }
      return null;
    }
    // Generate CSS classes for input styling consistency

  }, {
    key: 'getInputClassName',
    value: function getInputClassName() {
      var _props4 = this.props,
          value = _props4.value,
          isLoading = _props4.isLoading,
          tinError = _props4.tinError;
      var _state4 = this.state,
          searchLoading = _state4.searchLoading,
          searchTinFound = _state4.searchTinFound;

      var className = '';
      if (searchLoading || value && isLoading) {
        className += 'loading circle notched icon ';
      }
      if (value && (!searchLoading || !isLoading) && !searchTinFound && tinError) {
        className += 'error';
      }
      return className.trim();
    }
  }, {
    key: 'renderErrorMessage',
    value: function renderErrorMessage() {
      var _props5 = this.props,
          hideMessage = _props5.hideMessage,
          errMessage = _props5.errMessage;
      var _state5 = this.state,
          hasValueChanged = _state5.hasValueChanged,
          localErrMessage = _state5.localErrMessage;


      var displayMessage = hasValueChanged ? localErrMessage : errMessage;

      if (displayMessage && !hideMessage) {
        return _react2.default.createElement(
          'div',
          { className: 'validate field', style: this.props.style },
          _react2.default.createElement(
            _Helper2.default,
            { type: 'error' },
            displayMessage
          )
        );
      }
      return null;
    }

    // Unified label rendering for consistent styling

  }, {
    key: 'renderLabel',
    value: function renderLabel(labelText) {
      var showInfoIcon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _props6 = this.props,
          hideLabel = _props6.hideLabel,
          required = _props6.required;

      if (hideLabel) return null;

      var labelContent = '' + labelText + (required ? ' *' : '');

      if (!showInfoIcon) {
        // Simple label for Indonesia
        return _react2.default.createElement(
          _semanticUiReact.Form.Group,
          { style: { display: 'flex', alignItems: 'center', marginBottom: '0px' } },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { columns: 1 },
            _react2.default.createElement(_semanticUiReact.Form.Field, {
              className: 'form-label',
              label: labelContent,
              style: { textAlign: 'left', flex: '1', paddingLeft: '0.5em' }
            })
          )
        );
      }

      // Label with info icon for Malaysia
      return _react2.default.createElement(
        _semanticUiReact.Form.Group,
        { style: { display: 'flex', alignItems: 'center', marginBottom: '0px' } },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { columns: 1 },
          _react2.default.createElement(_semanticUiReact.Form.Field, {
            className: 'form-label',
            label: labelContent,
            style: { textAlign: 'left', flex: '1', paddingLeft: '0.5em' }
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { columns: 1 },
          _react2.default.createElement(_semanticUiReact.Popup, {
            className: 'srb',
            content: _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Why It\'s Important:'
                ),
                ' Adding a Tax Identification Number (TIN) ensures compliance with Malaysian regulations and enables the issuance of e-invoices.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'For Individuals:'
                ),
                ' All local individuals above 18 y/o have a TIN. It starts with "IG" followed by 9 to 11 digits.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'For Companies:'
                ),
                ' Filling in the TIN during booking creation is compulsory. ',
                _react2.default.createElement('br', null),
                ' Example formats: C20880050010, D4800990020.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'For Foreigners:'
                ),
                ' Providing a TIN is optional. If you are unable to obtain one, you may leave it blank.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'strong',
                  null,
                  'Auto-Validate:'
                ),
                ' The results are based on a validation check with LHDN. Ensure the details are accurate to avoid validation errors.'
              ),
              _react2.default.createElement(
                'a',
                { href: 'https://support.mhub.my/hc/en-us/articles/35235273120537-Tax-Identification-Number-TIN-Field', target: '_blank', rel: 'noopener noreferrer' },
                '[Having trouble obtaining a correct TIN? Click here to learn more.]'
              )
            ),
            on: 'click',
            wide: true,
            positionFixed: true,
            style: { background: 'white', color: 'black', border: '3.5px solid #22242626', padding: '1.5em 2em' },
            position: 'bottom center',
            trigger: _react2.default.createElement(_semanticUiReact.Button, {
              icon: 'question circle outline',
              size: 'small',
              style: { padding: '0.2em 0.3em', background: 'none', marginBottom: '7px', color: 'rgb(0, 151, 161)' }
            }),
            pinned: true,
            inverted: true,
            onOpen: function onOpen(e) {
              e.preventDefault();
            },
            onClose: function onClose(e) {
              e.preventDefault();
            }
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props7 = this.props,
          isIndonesia = _props7.isIndonesia,
          validation = _props7.validation,
          validateRef = _props7.validateRef,
          onChange = _props7.onChange,
          value = _props7.value,
          required = _props7.required,
          readOnly = _props7.readOnly,
          disabled = _props7.disabled,
          style = _props7.style;


      if (isIndonesia) {
        // Indonesia (NPWP) - Now with consistent styling
        var _labelText = 'NPWP';
        var _placeholderText = '12.345.678.9-012.000 or 1234567890123456';

        return _react2.default.createElement(
          _Validate2.default,
          {
            validation: validation,
            label: 'NPWP',
            name: 'taxIdentificationNo',
            ref: validateRef,
            onChange: onChange
          },
          _react2.default.createElement(_semanticUiReact.Form.Input, {
            className: this.getInputClassName(),
            fluid: true,
            readOnly: readOnly,
            disabled: disabled,
            autoComplete: 'off',
            name: 'taxIdentificationNo',
            placeholder: _placeholderText,
            onChange: onChange,
            value: value,
            style: style,
            label: this.renderLabel(_labelText, false)
          })
        );
      }
      // Malaysia - Existing functionality with consistent structure
      var labelText = 'Tax Identification Number';
      var placeholderText = 'e.g. IG00000012345' + (required ? ' *' : '');

      return _react2.default.createElement(
        _Validate2.default,
        {
          validation: validation,
          label: 'Tax Identification Number',
          name: 'taxIdentificationNo',
          ref: validateRef,
          onChange: this.handleOnChange,
          hideMessage: this.props.tinError === false
        },
        _react2.default.createElement(_semanticUiReact.Form.Input, {
          className: this.getInputClassName(),
          fluid: true,
          readOnly: readOnly,
          disabled: disabled,
          autoComplete: 'off',
          name: 'taxIdentificationNo',
          placeholder: placeholderText,
          onChange: this.handleOnChange,
          value: value,
          style: style,
          actionPosition: 'left',
          label: this.renderLabel(labelText, true),
          icon: this.state.searchLoading || value ? _react2.default.createElement(_semanticUiReact.Icon, {
            loading: this.state.searchLoading || this.props.isLoading,
            name: this.getIconName(),
            color: this.getIconColor()
          }) : null,
          action: _react2.default.createElement(_semanticUiReact.Popup, {
            content: 'Search TIN from LHDN',
            mouseEnterDelay: 500,
            size: 'tiny',
            trigger: _react2.default.createElement(_semanticUiReact.Button, {
              style: { backgroundColor: '#f9fafb', border: '1px solid #ccc' },
              icon: 'search',
              type: 'button',
              disabled: readOnly || this.state.searchTinFound || this.state.searchLoading,
              onClick: this.handleSearchTin
            })
          })
        }),
        this.renderErrorMessage()
      );
    }
  }]);

  return TinFieldInput;
}(_react.Component);

TinFieldInput.propTypes = {
  identityType: _propTypes2.default.number,
  identityValue: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  value: _propTypes2.default.string,
  isLoading: _propTypes2.default.bool,
  tinError: _propTypes2.default.bool,
  errMessage: _propTypes2.default.string,
  hideMessage: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  readOnly: _propTypes2.default.bool,
  required: _propTypes2.default.bool,
  hideLabel: _propTypes2.default.bool,
  validation: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({
    validate: _propTypes2.default.func,
    option: _propTypes2.default.object
  })]).isRequired),
  validateRef: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({})]),
  style: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  bookingID: _propTypes2.default.string,
  unitID: _propTypes2.default.string,
  isIndonesia: _propTypes2.default.bool
};
TinFieldInput.contextTypes = {
  store: _propTypes2.default.object
};
TinFieldInput.defaultProps = {
  isLoading: false,
  tinError: null,
  disabled: false,
  isIndonesia: false
};
exports.default = (0, _react.forwardRef)(function (props, ref) {
  return _react2.default.createElement(TinFieldInput, _extends({}, props, { validateRef: ref }));
});

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _marked = __webpack_require__(678);

var _marked2 = _interopRequireDefault(_marked);

var _dompurify = __webpack_require__(2849);

var _dompurify2 = _interopRequireDefault(_dompurify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable import/extensions */
/* eslint react/no-danger: 0 */
var MarkdownText = function MarkdownText(_ref) {
  var content = _ref.content,
      children = _ref.children;

  _marked2.default.setOptions({
    breaks: true,
    headerPrefix: 'mhub-content-'
  });

  var sanitizedHTML = _dompurify2.default.sanitize(_marked2.default.parse(children || content));

  return _react2.default.createElement('div', {
    className: 'markdown-text',
    dangerouslySetInnerHTML: { __html: sanitizedHTML }
  });
};

MarkdownText.propTypes = {
  content: _propTypes2.default.string,
  children: _propTypes2.default.string
};

exports.default = MarkdownText;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SUPER_ADMIN = exports.SUPER_ADMIN = 'SUPER_ADMIN';
var ADMIN_COMMUNITY = exports.ADMIN_COMMUNITY = 'ADMIN_COMMUNITY';
var ADMIN_BASIC = exports.ADMIN_BASIC = 'ADMIN_BASIC';
var ADMIN = exports.ADMIN = 'ADMIN';
var ANALYTICS = exports.ANALYTICS = 'ANALYTICS';
var DEVELOPER_BRANCH_LEADER_SUPERVISOR_II = exports.DEVELOPER_BRANCH_LEADER_SUPERVISOR_II = 'DEVELOPER_BRANCH_LEADER_SUPERVISOR_II';
var DEVELOPER_BRANCH_LEADER_SUPERVISOR = exports.DEVELOPER_BRANCH_LEADER_SUPERVISOR = 'DEVELOPER_BRANCH_LEADER_SUPERVISOR';
var DEVELOPER_BRANCH_LEADER = exports.DEVELOPER_BRANCH_LEADER = 'DEVELOPER_BRANCH_LEADER';
var DEVELOPER_SITEPLAN = exports.DEVELOPER_SITEPLAN = 'DEVELOPER_SITEPLAN';
var DEVELOPER_AGENT_LEADER = exports.DEVELOPER_AGENT_LEADER = 'DEVELOPER_AGENT_LEADER';
var DEVELOPER_AGENCY_ADMIN = exports.DEVELOPER_AGENCY_ADMIN = 'DEVELOPER_AGENCY_ADMIN';
var DEVELOPER_EXECUTIVE = exports.DEVELOPER_EXECUTIVE = 'DEVELOPER_EXECUTIVE';
var DEVELOPER_HEADQUARTERS = exports.DEVELOPER_HEADQUARTERS = 'DEVELOPER_HEADQUARTERS';
var DEVELOPER_TEAM_LEADER = exports.DEVELOPER_TEAM_LEADER = 'DEVELOPER_TEAM_LEADER';
var CREDIT_CONTROL = exports.CREDIT_CONTROL = 'CREDIT_CONTROL';
var CREDIT_ADMIN = exports.CREDIT_ADMIN = 'CREDIT_ADMIN';
var FINANCE_EXECUTIVE = exports.FINANCE_EXECUTIVE = 'FINANCE_EXECUTIVE';
var CREDIT_CONTROL_SALES_STAFF = exports.CREDIT_CONTROL_SALES_STAFF = 'CREDIT_CONTROL_SALES_STAFF';
var CREDIT_CONTROL_SALES_ADMIN = exports.CREDIT_CONTROL_SALES_ADMIN = 'CREDIT_CONTROL_SALES_ADMIN';
var COMMISSION_TRACKER_HEADQUARTERS = exports.COMMISSION_TRACKER_HEADQUARTERS = 'COMMISSION_TRACKER_HEADQUARTERS';
var COMMISSION_TRACKER_SUPERVISOR = exports.COMMISSION_TRACKER_SUPERVISOR = 'COMMISSION_TRACKER_SUPERVISOR';
var COMMISSION_TRACKER_SALES_MANAGER = exports.COMMISSION_TRACKER_SALES_MANAGER = 'COMMISSION_TRACKER_SALES_MANAGER';
var COMMISSION_TRACKER_SALES_ADMIN = exports.COMMISSION_TRACKER_SALES_ADMIN = 'COMMISSION_TRACKER_SALES_ADMIN';
var COMMISSION_TRACKER_STAFF = exports.COMMISSION_TRACKER_STAFF = 'COMMISSION_TRACKER_STAFF';
var COMMISSION_TRACKER_TEAM_LEADER = exports.COMMISSION_TRACKER_TEAM_LEADER = 'COMMISSION_TRACKER_TEAM_LEADER';
var COMMISSION_TRACKER_AGENCY_ADMIN = exports.COMMISSION_TRACKER_AGENCY_ADMIN = 'COMMISSION_TRACKER_AGENCY_ADMIN';
var COMMISSION_TRACKER_AGENT = exports.COMMISSION_TRACKER_AGENT = 'COMMISSION_TRACKER_AGENT';

// group ids
var GROUP_ID_SUPER_ADMIN = exports.GROUP_ID_SUPER_ADMIN = '1';
var GROUP_ID_ADMIN_COMMUNITY = exports.GROUP_ID_ADMIN_COMMUNITY = '15';
var GROUP_ID_ADMIN_BASIC = exports.GROUP_ID_ADMIN_BASIC = '14';
var GROUP_ID_ADMIN = exports.GROUP_ID_ADMIN = '2';

var GROUP_ID_DEVELOPER_HEADQUARTERS = exports.GROUP_ID_DEVELOPER_HEADQUARTERS = '6';
var GROUP_ID_DEVELOPER_TEAM_LEADER = exports.GROUP_ID_DEVELOPER_TEAM_LEADER = '9';
var GROUP_ID_DEVELOPER_BRANCH_LEADER = exports.GROUP_ID_DEVELOPER_BRANCH_LEADER = '11';
var GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR = exports.GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR = '12';
var GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II = exports.GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II = '13';
var GROUP_ID_DEVELOPER_EXECUTIVE = exports.GROUP_ID_DEVELOPER_EXECUTIVE = '10';
var GROUP_ID_DEVELOPER_SITEPLAN = exports.GROUP_ID_DEVELOPER_SITEPLAN = '16';
var GROUP_ID_DEVELOPER_AGENT_LEADER = exports.GROUP_ID_DEVELOPER_AGENT_LEADER = '17';
var GROUP_ID_DEVELOPER_AGENCY_ADMIN = exports.GROUP_ID_DEVELOPER_AGENCY_ADMIN = '21';

var GROUP_ID_CREDIT_CONTROL = exports.GROUP_ID_CREDIT_CONTROL = '18';
var GROUP_ID_CREDIT_ADMIN = exports.GROUP_ID_CREDIT_ADMIN = '19';
var GROUP_ID_CREDIT_CONTROL_SALES_STAFF = exports.GROUP_ID_CREDIT_CONTROL_SALES_STAFF = '31';
var GROUP_ID_CREDIT_CONTROL_SALES_ADMIN = exports.GROUP_ID_CREDIT_CONTROL_SALES_ADMIN = '32';

var GROUP_ID_COMMISSION_TRACKER_HEADQUARTERS = exports.GROUP_ID_COMMISSION_TRACKER_HEADQUARTERS = '22';
var GROUP_ID_COMMISSION_TRACKER_SUPERVISOR = exports.GROUP_ID_COMMISSION_TRACKER_SUPERVISOR = '23';
var GROUP_ID_COMMISSION_TRACKER_SALES_MANAGER = exports.GROUP_ID_COMMISSION_TRACKER_SALES_MANAGER = '24';
var GROUP_ID_COMMISSION_TRACKER_SALES_ADMIN = exports.GROUP_ID_COMMISSION_TRACKER_SALES_ADMIN = '25';
var GROUP_ID_COMMISSION_TRACKER_STAFF = exports.GROUP_ID_COMMISSION_TRACKER_STAFF = '26';
var GROUP_ID_COMMISSION_TRACKER_TEAM_LEADER = exports.GROUP_ID_COMMISSION_TRACKER_TEAM_LEADER = '27';
var GROUP_ID_COMMISSION_TRACKER_AGENCY_ADMIN = exports.GROUP_ID_COMMISSION_TRACKER_AGENCY_ADMIN = '28';
var GROUP_ID_COMMISSION_TRACKER_AGENT = exports.GROUP_ID_COMMISSION_TRACKER_AGENT = '29';

var GROUP_ID_FINANCE_EXECUTIVE = exports.GROUP_ID_FINANCE_EXECUTIVE = '20';
var GROUP_ID_ANALYTICS = exports.GROUP_ID_ANALYTICS = '30';

var devGroups = exports.devGroups = [{
  id: GROUP_ID_DEVELOPER_HEADQUARTERS,
  code: DEVELOPER_HEADQUARTERS,
  name: 'Headquarters'
}, {
  id: GROUP_ID_DEVELOPER_BRANCH_LEADER,
  code: DEVELOPER_BRANCH_LEADER,
  name: 'Business Unit Leader'
}, {
  id: GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR,
  code: DEVELOPER_BRANCH_LEADER_SUPERVISOR,
  name: 'Business Unit Leader Supervisor'
}, {
  id: GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
  code: DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
  name: 'Business Unit Leader Supervisor II'
}, {
  id: GROUP_ID_DEVELOPER_EXECUTIVE,
  code: DEVELOPER_EXECUTIVE,
  name: 'Agent/Internal Staff'
}, {
  id: GROUP_ID_DEVELOPER_SITEPLAN,
  code: DEVELOPER_SITEPLAN,
  name: 'Basic Siteplan'
}, {
  id: GROUP_ID_DEVELOPER_AGENT_LEADER,
  code: DEVELOPER_AGENT_LEADER,
  name: 'Agent Leader'
}, {
  id: GROUP_ID_DEVELOPER_AGENCY_ADMIN,
  code: DEVELOPER_AGENCY_ADMIN,
  name: 'Agency Admin'
}];

var ignoreGroupIDs = exports.ignoreGroupIDs = [GROUP_ID_CREDIT_CONTROL, GROUP_ID_CREDIT_ADMIN, GROUP_ID_CREDIT_CONTROL_SALES_STAFF, GROUP_ID_CREDIT_CONTROL_SALES_ADMIN, GROUP_ID_FINANCE_EXECUTIVE, GROUP_ID_COMMISSION_TRACKER_HEADQUARTERS, GROUP_ID_COMMISSION_TRACKER_SUPERVISOR, GROUP_ID_COMMISSION_TRACKER_SALES_MANAGER, GROUP_ID_COMMISSION_TRACKER_SALES_ADMIN, GROUP_ID_COMMISSION_TRACKER_STAFF, GROUP_ID_COMMISSION_TRACKER_TEAM_LEADER, GROUP_ID_COMMISSION_TRACKER_AGENCY_ADMIN, GROUP_ID_COMMISSION_TRACKER_AGENT, GROUP_ID_ANALYTICS];

var creditControlGroups = exports.creditControlGroups = [{
  id: GROUP_ID_CREDIT_CONTROL,
  code: CREDIT_CONTROL,
  name: 'Credit Control'
}, {
  id: GROUP_ID_CREDIT_ADMIN,
  code: CREDIT_ADMIN,
  name: 'Credit Admin'
}, {
  id: GROUP_ID_CREDIT_CONTROL_SALES_STAFF,
  code: CREDIT_CONTROL_SALES_STAFF,
  name: 'Sales Staff'
}, {
  id: GROUP_ID_CREDIT_CONTROL_SALES_ADMIN,
  code: CREDIT_CONTROL_SALES_ADMIN,
  name: 'Sales Admin'
}];

var commissionTrackerGroups = exports.commissionTrackerGroups = [{
  id: GROUP_ID_COMMISSION_TRACKER_HEADQUARTERS,
  code: COMMISSION_TRACKER_HEADQUARTERS,
  name: 'Headquarters'
}, {
  id: GROUP_ID_COMMISSION_TRACKER_SUPERVISOR,
  code: COMMISSION_TRACKER_SUPERVISOR,
  name: 'Supervisor'
}, {
  id: GROUP_ID_COMMISSION_TRACKER_SALES_MANAGER,
  code: COMMISSION_TRACKER_SALES_MANAGER,
  name: 'Sales Manager'
}, {
  id: GROUP_ID_COMMISSION_TRACKER_SALES_ADMIN,
  code: COMMISSION_TRACKER_SALES_ADMIN,
  name: 'Sales Admin'
}, {
  id: GROUP_ID_COMMISSION_TRACKER_STAFF,
  code: COMMISSION_TRACKER_STAFF,
  name: 'Staff'
}, {
  id: GROUP_ID_COMMISSION_TRACKER_TEAM_LEADER,
  code: COMMISSION_TRACKER_TEAM_LEADER,
  name: 'Agency Leader'
}, {
  id: GROUP_ID_COMMISSION_TRACKER_AGENT,
  code: COMMISSION_TRACKER_AGENT,
  name: 'Agent'
}];

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OPPORTUNITY_STATUS = exports.OPPORTUNITY_STATUS = {
  TOTAL: 'total',
  PENDING_PAYMENT: 'pending_payment',
  PAYMENT_MADE: 'payment_made',
  PARTIALLY_PAID_UNVERIFIED: 'partially_paid_unverified',
  PAID_UNVERIFIED: 'paid_unverified',
  PAID_VERIFIED: 'paid_verified',
  APPROVED: 'approved',
  VERIFICATION_REJECTED: 'verification_rejected',
  PENDING_CANCELLATION: 'pending_cancellation',
  CANCELLED: 'cancelled',
  // CPI-1226 (Vietnam only): the terminal status of a cancellation whose recorded scenario was
  // "due to error". `cancelled` now means "due to buyer, or no scenario recorded".
  CANCELLED_ERROR: 'cancelled_error',
  PENDING_REFUND: 'pending_refund',
  REFUNDED: 'refunded',
  REFUND_DECLINED: 'refund_declined',
  EXPIRED: 'expired'
};

var OPPORTUNITY_STATUS_GROUP = exports.OPPORTUNITY_STATUS_GROUP = {
  TOTAL: 'total',
  PENDING_APPROVAL: 'pending_approval',
  APPROVED: 'approved',
  PENDING_CLOSURE: 'pending_closure',
  PENDING_REFUND: 'pending_refund',
  CLOSED: 'closed',
  // CPI-1226: mhub-opportunity-api's SRGroupStatuses gained an `error` group holding
  // cancelled_error, and showroom/summary emits a matching `error` key. Vietnam only -- a
  // Malaysian summary never carries it, and this whole screen is Vietnam-only anyway.
  ERROR: 'error'
};

var SINGLE_STATUS_FILTER_OPTIONS = exports.SINGLE_STATUS_FILTER_OPTIONS = [{ value: 'pending_payment', text: 'Pending Payment' }, { value: 'payment_made', text: 'Payment Made' }, { value: 'partially_paid_unverified', text: 'Partial Paid' }, { value: 'paid_unverified', text: 'Paid Unverified' }, { value: 'paid_verified', text: 'Paid Verified' }, { value: 'approved', text: 'Approved' }, { value: 'verification_rejected', text: 'Verification Rejected' }, { value: 'pending_cancellation', text: 'Pending Cancellation' }, { value: 'cancelled', text: 'Cancelled' },
// Required, not cosmetic: renderBookingStatus falls back to SINGLE_STATUS_MAP[PENDING_PAYMENT]
// for an unmapped sr_status, so without this row every error-cancelled booking would render
// its status chip as "Pending Payment".
{ value: 'cancelled_error', text: 'Cancelled (Error)' }, { value: 'pending_refund', text: 'Pending Refund' }, { value: 'refunded', text: 'Refunded' }, { value: 'refund_declined', text: 'Refund Declined' }, { value: 'expired', text: 'Expired' }];

var OPPORTUNITY_STATUSES_TABS = exports.OPPORTUNITY_STATUSES_TABS = [{ text: 'All Bookings', header: 'All bookings', value: OPPORTUNITY_STATUS_GROUP.TOTAL, name: OPPORTUNITY_STATUS_GROUP.TOTAL, className: 'uc-opportunity-total' }, { text: 'Pending Approval', header: 'Pending approval bookings', value: OPPORTUNITY_STATUS_GROUP.PENDING_APPROVAL, name: OPPORTUNITY_STATUS_GROUP.PENDING_APPROVAL, className: 'uc-opportunity-pending_approval' }, { text: 'Approved', header: 'Approved bookings', value: OPPORTUNITY_STATUS_GROUP.APPROVED, name: OPPORTUNITY_STATUS_GROUP.APPROVED, className: 'uc-opportunity-approved' }, { text: 'Pending Closure', header: 'Pending closure bookings', value: OPPORTUNITY_STATUS_GROUP.PENDING_CLOSURE, name: OPPORTUNITY_STATUS_GROUP.PENDING_CLOSURE, className: 'uc-opportunity-pending_closure' }, { text: 'Pending Refund', header: 'Pending refund bookings', value: OPPORTUNITY_STATUS_GROUP.PENDING_REFUND, name: OPPORTUNITY_STATUS_GROUP.PENDING_REFUND, className: 'uc-opportunity-pending_refund' }, { text: 'Closed', header: 'Closed bookings', value: OPPORTUNITY_STATUS_GROUP.CLOSED, name: OPPORTUNITY_STATUS_GROUP.CLOSED, className: 'uc-opportunity-closed' },
// CPI-1226: a plain group tab. It used to be a client-side carve-out of `cancelled` out of
// Closed, because mhub-opportunity-api's SRGroupStatuses had no group for it and
// showroom/summary had no counterpart key. Both now exist (`error` -> {cancelled_error}), so
// this drives `group_status` exactly like the six tabs above it and the carve-out machinery in
// OpportunityList.jsx is gone.
//
// The tab no longer holds every cancellation: buyer cancellations stay `cancelled` and are
// counted under Closed, which is the point of the split. Existing rows have no recorded
// scenario, so they read as buyer cancellations and move to Closed on the day this ships.
//
// No country check: this whole screen is Vietnam-only already. Both entry points route to
// /opportunities/ only for VN and to /bookings/ otherwise (containers/BookApp.jsx and
// containers/BookDash.jsx), and nothing outside components/Opportunities/ reads these tabs.
// `className` stays `uc-opportunity-cancelled` so the existing styling still applies. The
// 'Cancelled' translation key is deliberately NOT reused -- it is shared across booking lists,
// token payments, the loan tracker and more, so editing it would rename all of those.
{ text: 'Error', header: 'Error bookings', value: OPPORTUNITY_STATUS_GROUP.ERROR, name: OPPORTUNITY_STATUS_GROUP.ERROR, className: 'uc-opportunity-cancelled' }];

// Values of the tabs that filter by sr_status rather than group_status. Empty since CPI-1226
// re-pointed the Error tab at a real group; kept because the derivation is what makes it empty,
// and a future sr_status tab only has to set `singleStatus: true` again.
var SINGLE_STATUS_TAB_VALUES = exports.SINGLE_STATUS_TAB_VALUES = OPPORTUNITY_STATUSES_TABS.filter(function (tab) {
  return tab.singleStatus;
}).map(function (tab) {
  return tab.value;
});

var OPPORTUNITY_STATUS_MAP = exports.OPPORTUNITY_STATUS_MAP = OPPORTUNITY_STATUSES_TABS.reduce(function (acc, tab) {
  return _extends({}, acc, _defineProperty({}, tab.value, tab));
}, {});

var SINGLE_STATUS_MAP = exports.SINGLE_STATUS_MAP = SINGLE_STATUS_FILTER_OPTIONS.reduce(function (acc, option) {
  return _extends({}, acc, _defineProperty({}, option.value, option));
}, {});

var DEFAULT_OPPORTUNITY_STATUS = exports.DEFAULT_OPPORTUNITY_STATUS = OPPORTUNITY_STATUS_GROUP.TOTAL;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preSalesLaunchRoleOptions = exports.preSalesLaunchRoleIDs = exports.paymentReceiptAccessesOptions = exports.defaultPaymentReceiptAccesses = exports.rduAccessesOptions = exports.defaultRduAccesses = exports.bookingNoteAccessesOptions = exports.defaultBookingNoteAccesses = exports.SR_ROLE_ID_DEVELOPER_SITEPLAN = exports.SR_ROLE_ID_AGENT = exports.SR_ROLE_ID_STAFF = exports.SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN = exports.SR_ROLE_ID_DEVELOPER_AGENT_LEADER = exports.SR_ROLE_ID_DEVELOPER_BRANCH_LEADER = exports.SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II = exports.SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR = exports.SR_ROLE_ID_DEVELOPER_HEADQUARTERS = undefined;
exports.matchGroupIDToSrRoleID = matchGroupIDToSrRoleID;
exports.hasAnyRequiredRoleIDs = hasAnyRequiredRoleIDs;
exports.srRoleIDOfUser = srRoleIDOfUser;

var _groups = __webpack_require__(194);

var _array = __webpack_require__(2570);

/* eslint-disable max-len */
var SR_ROLE_ID_DEVELOPER_HEADQUARTERS = exports.SR_ROLE_ID_DEVELOPER_HEADQUARTERS = 1;
var SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR = exports.SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR = 2;
var SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II = exports.SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II = 3;
var SR_ROLE_ID_DEVELOPER_BRANCH_LEADER = exports.SR_ROLE_ID_DEVELOPER_BRANCH_LEADER = 4;
var SR_ROLE_ID_DEVELOPER_AGENT_LEADER = exports.SR_ROLE_ID_DEVELOPER_AGENT_LEADER = 5;
var SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN = exports.SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN = 6;
var SR_ROLE_ID_STAFF = exports.SR_ROLE_ID_STAFF = 7;
var SR_ROLE_ID_AGENT = exports.SR_ROLE_ID_AGENT = 8;
var SR_ROLE_ID_DEVELOPER_SITEPLAN = exports.SR_ROLE_ID_DEVELOPER_SITEPLAN = 9;

var srRolesMapping = [{ roleID: SR_ROLE_ID_DEVELOPER_HEADQUARTERS, groupIDs: [_groups.GROUP_ID_DEVELOPER_EXECUTIVE, _groups.GROUP_ID_DEVELOPER_HEADQUARTERS] }, { roleID: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR, groupIDs: [_groups.GROUP_ID_DEVELOPER_EXECUTIVE, _groups.GROUP_ID_DEVELOPER_BRANCH_LEADER, _groups.GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR, _groups.GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II] }, { roleID: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II, groupIDs: [_groups.GROUP_ID_DEVELOPER_EXECUTIVE, _groups.GROUP_ID_DEVELOPER_BRANCH_LEADER, _groups.GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II] }, { roleID: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER, groupIDs: [_groups.GROUP_ID_DEVELOPER_EXECUTIVE, _groups.GROUP_ID_DEVELOPER_BRANCH_LEADER] }, { roleID: SR_ROLE_ID_DEVELOPER_AGENT_LEADER, groupIDs: [_groups.GROUP_ID_DEVELOPER_EXECUTIVE, _groups.GROUP_ID_DEVELOPER_AGENT_LEADER] }, { roleID: SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN, groupIDs: [_groups.GROUP_ID_DEVELOPER_EXECUTIVE, _groups.GROUP_ID_DEVELOPER_AGENCY_ADMIN] }, { roleID: SR_ROLE_ID_STAFF, groupIDs: [_groups.GROUP_ID_DEVELOPER_EXECUTIVE] }, { roleID: SR_ROLE_ID_AGENT, groupIDs: [_groups.GROUP_ID_DEVELOPER_EXECUTIVE] }, { roleID: SR_ROLE_ID_DEVELOPER_SITEPLAN, groupIDs: [_groups.GROUP_ID_DEVELOPER_SITEPLAN] }];

// matchGroupIDToSrRoleID helper function to match group IDs to SR role IDs
function matchGroupIDToSrRoleID(groupIDs, isAgent) {
  var matchRoles = [];
  srRolesMapping.forEach(function (srRole) {
    var hasDERole = (0, _array.arrayContainsRequired)([SR_ROLE_ID_STAFF], matchRoles) || (0, _array.arrayContainsRequired)([SR_ROLE_ID_AGENT], matchRoles);
    if (!hasDERole && (0, _array.arrayContainsRequired)(srRole.groupIDs, groupIDs)) {
      if (isAgent && srRole.roleID === SR_ROLE_ID_STAFF) {
        matchRoles.push(SR_ROLE_ID_AGENT); // if agent, return agent role ID
      } else {
        matchRoles.push(srRole.roleID);
      }
    }
  });
  return matchRoles;
}

// check if has any required SR role IDs to input SR role IDs
function hasAnyRequiredRoleIDs(requiredRoleIDs, inputRoleIDs) {
  return (0, _array.arrayHasMatchingValues)(requiredRoleIDs, inputRoleIDs);
}

// booking notes
var defaultBookingNoteAccesses = exports.defaultBookingNoteAccesses = [SR_ROLE_ID_DEVELOPER_HEADQUARTERS, SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR, SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II, SR_ROLE_ID_DEVELOPER_BRANCH_LEADER, SR_ROLE_ID_DEVELOPER_AGENT_LEADER, SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN, SR_ROLE_ID_STAFF, SR_ROLE_ID_AGENT, SR_ROLE_ID_DEVELOPER_SITEPLAN];
var bookingNoteAccessesOptions = exports.bookingNoteAccessesOptions = [{
  text: 'Headquarters',
  value: SR_ROLE_ID_DEVELOPER_HEADQUARTERS,
  description: 'Admin',
  disabled: true
}, {
  text: 'Supervisor',
  value: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR,
  description: 'BU Leader'
}, {
  text: 'Sales Manager',
  value: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
  description: 'BU Leader'
}, {
  text: 'Sales Admin',
  value: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER,
  description: 'BU Leader'
}, {
  text: 'Agent Leader',
  value: SR_ROLE_ID_DEVELOPER_AGENT_LEADER
}, {
  text: 'Agency Admin',
  value: SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN,
  description: 'Claim C.'
}, {
  text: 'Staff',
  value: SR_ROLE_ID_STAFF
}, {
  text: 'Agent',
  value: SR_ROLE_ID_AGENT
}, {
  text: 'Basic Siteplan',
  value: SR_ROLE_ID_DEVELOPER_SITEPLAN
}];

// reserve delisted units
var defaultRduAccesses = exports.defaultRduAccesses = [SR_ROLE_ID_DEVELOPER_HEADQUARTERS];
var rduAccessesOptions = exports.rduAccessesOptions = [{
  text: 'Headquarters',
  value: SR_ROLE_ID_DEVELOPER_HEADQUARTERS,
  description: 'Admin',
  disabled: true
}, {
  text: 'Supervisor',
  value: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR,
  description: 'BU Leader'
}, {
  text: 'Sales Manager',
  value: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
  description: 'BU Leader'
}, {
  text: 'Sales Admin',
  value: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER,
  description: 'BU Leader'
}, {
  text: 'Agent Leader',
  value: SR_ROLE_ID_DEVELOPER_AGENT_LEADER
}, {
  text: 'Agency Admin',
  value: SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN,
  description: 'Claim C.'
}, {
  text: 'Staff',
  value: SR_ROLE_ID_STAFF
}, {
  text: 'Agent',
  value: SR_ROLE_ID_AGENT
}, {
  text: 'Basic Siteplan',
  value: SR_ROLE_ID_DEVELOPER_SITEPLAN
}];

// payment receipt
var defaultPaymentReceiptAccesses = exports.defaultPaymentReceiptAccesses = [SR_ROLE_ID_DEVELOPER_HEADQUARTERS, SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR, SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II, SR_ROLE_ID_DEVELOPER_BRANCH_LEADER, SR_ROLE_ID_DEVELOPER_AGENT_LEADER, SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN, SR_ROLE_ID_STAFF, SR_ROLE_ID_AGENT, SR_ROLE_ID_DEVELOPER_SITEPLAN];
var paymentReceiptAccessesOptions = exports.paymentReceiptAccessesOptions = [{
  text: 'Headquarters',
  value: SR_ROLE_ID_DEVELOPER_HEADQUARTERS,
  description: 'Admin',
  disabled: true
}, {
  text: 'Supervisor',
  value: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR,
  description: 'BU Leader'
}, {
  text: 'Sales Manager',
  value: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II,
  description: 'BU Leader'
}, {
  text: 'Sales Admin',
  value: SR_ROLE_ID_DEVELOPER_BRANCH_LEADER,
  description: 'BU Leader'
}, {
  text: 'Agent Leader',
  value: SR_ROLE_ID_DEVELOPER_AGENT_LEADER
}, {
  text: 'Agency Admin',
  value: SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN,
  description: 'Claim C.'
}, {
  text: 'Staff',
  value: SR_ROLE_ID_STAFF
}, {
  text: 'Agent',
  value: SR_ROLE_ID_AGENT
}, {
  text: 'Basic Siteplan',
  value: SR_ROLE_ID_DEVELOPER_SITEPLAN
}];

// pre-sales launch: the roles HQ may block from reserving or from the Storey Plan. HQ and Basic
// Siteplan cannot be blocked, matching models.PreSalesLaunchRoleIDs in book-api.
var preSalesLaunchRoleIDs = exports.preSalesLaunchRoleIDs = [SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR, SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II, SR_ROLE_ID_DEVELOPER_BRANCH_LEADER, SR_ROLE_ID_DEVELOPER_AGENT_LEADER, SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN, SR_ROLE_ID_STAFF, SR_ROLE_ID_AGENT];
var preSalesLaunchRoleOptions = exports.preSalesLaunchRoleOptions = bookingNoteAccessesOptions.filter(function (opt) {
  return preSalesLaunchRoleIDs.includes(opt.value);
});

// srRoleIDOfUser returns the user's one exact SR role ID, or 0 for admins and users without one.
// Unlike matchGroupIDToSrRoleID, which returns every role whose groups the user holds (a
// Supervisor also matches Sales Manager and Sales Admin), a Supervisor here is only 2. Mirrors
// utils.SrRoleIDOf in book-api, using the exclusive role flags on the auth state.
function srRoleIDOfUser(auth) {
  if (!auth || !auth.companyBranch || auth.isSuperAdmin || auth.isAdmin || auth.isAdminBasic) return 0;
  if (auth.isHeadquarters) return SR_ROLE_ID_DEVELOPER_HEADQUARTERS;
  if (auth.companyBranch.isExternal) {
    if (auth.isExternalAgencyAdmin) return SR_ROLE_ID_DEVELOPER_AGENCY_ADMIN;
    if (auth.isExternalAgentLeader) return SR_ROLE_ID_DEVELOPER_AGENT_LEADER;
    if (auth.isExternalAgent) return SR_ROLE_ID_AGENT;
    return 0;
  }
  if (auth.isDeveloperSupervisor) return SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR;
  if (auth.isDeveloperSalesManager) return SR_ROLE_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II;
  if (auth.isDeveloperSalesAdmin) return SR_ROLE_ID_DEVELOPER_BRANCH_LEADER;
  if (auth.isDeveloperStaff) return SR_ROLE_ID_STAFF;
  return 0;
}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.depositToCollect = exports.previewDepositAmount = exports.isDepositRatePercentValid = exports.depositPercentToRate = exports.depositRateToPercent = exports.DEPOSIT_RATE_PERCENT_MAX = exports.vnPricePanelFigure = exports.VN_STORED_TOTAL_NOTICE = exports.liveTotalFor = exports.livePackageTotal = exports.approvedBookingFeePaid = exports.hasBankGuaranteeWaiverLine = exports.isPricingPackageMissing = exports.isPricingPackageLocked = exports.vnPackageLockMessage = exports.VN_PACKAGE_LOCK_MESSAGES = exports.isBookedOrBeyond = exports.BOOKED_OR_BEYOND_STATUS_IDS = undefined;

var _vietnam = __webpack_require__(40);

// CPI-977: the Vietnam pricing-package decisions in one place, as plain functions - each one is a
// rule book-api enforces as well. Every export returns the neutral answer off Vietnam.

// "Booked or beyond", where the pricing package freezes. Mirrors book-api's IsBookedOrBeyond.
var BOOKED_OR_BEYOND_STATUS_IDS = exports.BOOKED_OR_BEYOND_STATUS_IDS = ['booked', 'sold_spa_signed'];

var isBookedOrBeyond = exports.isBookedOrBeyond = function isBookedOrBeyond(statusID) {
  return BOOKED_OR_BEYOND_STATUS_IDS.includes(statusID);
};

// CPI-977 requirements 7 and 11: one lock rule for the pricing package and the additional fee
// package, mirroring book-api's vnPackageLockKey. Reserved locks everyone but HQ
// (auth.isHeadquarters, the DEVELOPER_HEADQUARTERS group); Booked and Sold lock everyone, and the
// unit has to be cancelled to change the scheme. Malaysia keeps its own rule
// (BookingPricingPackage.jsx disablePricingEditAfterSold).
var VN_PACKAGE_LOCK_MESSAGES = exports.VN_PACKAGE_LOCK_MESSAGES = {
  pricing: {
    booked: 'Pricing package is locked once the unit is booked',
    reserved: 'Only a Headquarters user can change the pricing package while the unit is reserved'
  },
  fee: {
    booked: 'Additional fee package is locked once the unit is booked',
    reserved: 'Only a Headquarters user can change the additional fee package while the unit is reserved'
  }
};

// The screens.json key explaining why the package is locked, or null when it is not locked.
var vnPackageLockMessage = exports.vnPackageLockMessage = function vnPackageLockMessage(auth, statusID) {
  var kind = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'pricing';

  if (!(0, _vietnam.isVietnamCompany)(auth)) {
    return null;
  }
  var messages = VN_PACKAGE_LOCK_MESSAGES[kind] || VN_PACKAGE_LOCK_MESSAGES.pricing;
  if (isBookedOrBeyond(statusID)) {
    return messages.booked;
  }
  if (statusID === 'reserved' && !(auth && auth.isHeadquarters)) {
    return messages.reserved;
  }
  return null;
};

var isPricingPackageLocked = exports.isPricingPackageLocked = function isPricingPackageLocked(auth, statusID) {
  var kind = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'pricing';
  return vnPackageLockMessage(auth, statusID, kind) !== null;
};

// CPI-977 requirement 1: Save stays disabled until a package is chosen. In Vietnam that is always
// required (Bookings/Form.jsx passes isVietnamCompany || the project's own
// require_pricing_select_during_reserve). The third argument is the "Base Selling Price" sentinel,
// which counts as nothing selected because the form clears it before POSTing.
var isPricingPackageMissing = exports.isPricingPackageMissing = function isPricingPackageMissing(isRequired, unitPackagePricingID, baseSellingPriceID) {
  if (!isRequired) {
    return false;
  }
  if (!unitPackagePricingID) {
    return true;
  }
  return !!baseSellingPriceID && String(unitPackagePricingID) === String(baseSellingPriceID);
};

// CPI-977 S3: the waiver is a discount line matched by code, so renaming it cannot switch it off.
var BANK_GUARANTEE_WAIVER_CODE = 'BGW';

var hasBankGuaranteeWaiverLine = exports.hasBankGuaranteeWaiverLine = function hasBankGuaranteeWaiverLine(packagePricing) {
  var calculations = packagePricing && packagePricing.calculations || [];
  return calculations.some(function (c) {
    return c && c.code === BANK_GUARANTEE_WAIVER_CODE;
  });
};

// CPI-977 AC8: the approved CRM booking fee book-api attaches to the booking, or null when there
// is none. Minor units whose exponent depends on the currency - never divide by 100 here.
var approvedBookingFeePaid = exports.approvedBookingFeePaid = function approvedBookingFeePaid(booking) {
  if (!booking) {
    return null;
  }
  var amountMinor = Number(booking.srBookingFeePaidMinor);
  if (!amountMinor || !(amountMinor > 0)) {
    return null;
  }
  return {
    amountMinor: amountMinor,
    currencyCode: booking.srBookingFeeCurrency || 'VND'
  };
};

// The live total the preview response carries, or null when it is not a priced package.
var livePackageTotal = exports.livePackageTotal = function livePackageTotal(preview) {
  var packagePricing = preview && preview.packagePricing || null;
  if (!packagePricing) {
    return null;
  }
  var total = Number(packagePricing.totalPrice);
  if (!Number.isFinite(total)) {
    return null;
  }
  return total;
};

// The live total recorded for one package id, or null - the map is keyed by the dropdown's value.
var liveTotalFor = exports.liveTotalFor = function liveTotalFor(liveTotals, packagePricingID) {
  if (!liveTotals || !packagePricingID) {
    return null;
  }
  var total = Number(liveTotals[packagePricingID]);
  if (!Number.isFinite(total)) {
    return null;
  }
  return total;
};

// D-C5: the label the panel shows instead of passing a stored figure off as a live one.
var VN_STORED_TOTAL_NOTICE = exports.VN_STORED_TOTAL_NOTICE = 'Stored package total — live price unavailable for your role';

// What the Vietnam price panel shows: the amount, whether it came from the server's own preview,
// and whether to print the D-C5 notice - the live total, else the stored total, with the notice
// only when a preview was actually refused.
var vnPricePanelFigure = exports.vnPricePanelFigure = function vnPricePanelFigure() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      preview = _ref.preview,
      previewFailed = _ref.previewFailed,
      storedTotal = _ref.storedTotal;

  var live = livePackageTotal(preview);
  if (live !== null) {
    return { amount: live, isLive: true, showStoredNotice: false };
  }
  var stored = Number(storedTotal);
  return {
    amount: Number.isFinite(stored) ? stored : 0,
    isLive: false,
    showStoredNotice: !!previewFailed
  };
};

// CPI-977 (PO, 5 Sep): the deposit is a percentage of the nett price, not the project's flat sum.
// The rate lives on the pricing package (package_pricings.deposit_rate, sent as depositRate) and
// book-api does the arithmetic; the two functions below are a unit conversion and a fallback.

// The column is a fraction (0.1000 = 10%) and the form talks percent; these conversions are the
// only place the two units meet. numeric(6,4) holds four decimals, so the box is worth two.
var DEPOSIT_RATE_PERCENT_MAX = exports.DEPOSIT_RATE_PERCENT_MAX = 100;
var DEPOSIT_RATE_PERCENT_DECIMALS = 2;

// '' for a package with no rate - the empty box IS the "no rate" state and must round-trip.
var depositRateToPercent = exports.depositRateToPercent = function depositRateToPercent(rate) {
  if (rate === null || rate === undefined || rate === '') {
    return '';
  }
  var fraction = Number(rate);
  if (!Number.isFinite(fraction)) {
    return '';
  }
  // parseFloat drops the trailing zeros toFixed leaves behind, so 0.1 reads "10" and not "10.00".
  return String(parseFloat((fraction * 100).toFixed(DEPOSIT_RATE_PERCENT_DECIMALS)));
};

// null (not 0) for an empty or unusable box: book-api reads NULL as "no rate on this package"
// and 0 as "collect nothing".
var depositPercentToRate = exports.depositPercentToRate = function depositPercentToRate(percent) {
  if (percent === null || percent === undefined || String(percent).trim() === '') {
    return null;
  }
  var value = Number(percent);
  if (!Number.isFinite(value) || value < 0 || value > DEPOSIT_RATE_PERCENT_MAX) {
    return null;
  }
  return Number((value / 100).toFixed(DEPOSIT_RATE_PERCENT_DECIMALS + 2));
};

// What the form's own validation asks. An empty box is valid.
var isDepositRatePercentValid = exports.isDepositRatePercentValid = function isDepositRatePercentValid(percent) {
  if (percent === null || percent === undefined || String(percent).trim() === '') {
    return true;
  }
  var value = Number(percent);
  return Number.isFinite(value) && value >= 0 && value <= DEPOSIT_RATE_PERCENT_MAX;
};

// The server's computed deposit for a previewed scheme, or null. Two shapes are accepted, the
// package's own depositAmount first. Zero is a real answer and is kept.
var previewDepositAmount = exports.previewDepositAmount = function previewDepositAmount(preview) {
  if (!preview) {
    return null;
  }
  var packagePricing = preview.packagePricing || null;
  var candidates = [packagePricing ? packagePricing.depositAmount : undefined, preview.depositAmount];
  for (var i = 0; i < candidates.length; i += 1) {
    var candidate = candidates[i];
    if (candidate !== null && candidate !== undefined && candidate !== '') {
      var amount = Number(candidate);
      if (Number.isFinite(amount)) {
        return amount;
      }
    }
  }
  return null;
};

// The one deposit rule every CPI-977 screen asks: the computed amount when the server sent one,
// otherwise the flat figure that screen has always shown. isComputed says which it is.
var depositToCollect = exports.depositToCollect = function depositToCollect() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      preview = _ref2.preview,
      depositAmount = _ref2.depositAmount,
      flatAmount = _ref2.flatAmount;

  var computed = previewDepositAmount(preview);
  if (computed !== null) {
    return { amount: computed, isComputed: true };
  }
  // A saved booking has no preview: book-api stored the computed figure on the reservation. Zero
  // is NOT kept here - on a reservation it means the deposit has not been set yet.
  var stored = Number(depositAmount);
  if (Number.isFinite(stored) && stored > 0) {
    return { amount: stored, isComputed: true };
  }
  var flat = Number(flatAmount);
  return { amount: Number.isFinite(flat) ? flat : 0, isComputed: false };
};

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(42).Buffer
var Transform = __webpack_require__(759).Transform
var StringDecoder = __webpack_require__(760).StringDecoder
var inherits = __webpack_require__(41)

function CipherBase (hashMode) {
  Transform.call(this)
  this.hashMode = typeof hashMode === 'string'
  if (this.hashMode) {
    this[hashMode] = this._finalOrDigest
  } else {
    this.final = this._finalOrDigest
  }
  if (this._final) {
    this.__final = this._final
    this._final = null
  }
  this._decoder = null
  this._encoding = null
}
inherits(CipherBase, Transform)

CipherBase.prototype.update = function (data, inputEnc, outputEnc) {
  if (typeof data === 'string') {
    data = Buffer.from(data, inputEnc)
  }

  var outData = this._update(data)
  if (this.hashMode) return this

  if (outputEnc) {
    outData = this._toString(outData, outputEnc)
  }

  return outData
}

CipherBase.prototype.setAutoPadding = function () {}
CipherBase.prototype.getAuthTag = function () {
  throw new Error('trying to get auth tag in unsupported state')
}

CipherBase.prototype.setAuthTag = function () {
  throw new Error('trying to set auth tag in unsupported state')
}

CipherBase.prototype.setAAD = function () {
  throw new Error('trying to set aad in unsupported state')
}

CipherBase.prototype._transform = function (data, _, next) {
  var err
  try {
    if (this.hashMode) {
      this._update(data)
    } else {
      this.push(this._update(data))
    }
  } catch (e) {
    err = e
  } finally {
    next(err)
  }
}
CipherBase.prototype._flush = function (done) {
  var err
  try {
    this.push(this.__final())
  } catch (e) {
    err = e
  }

  done(err)
}
CipherBase.prototype._finalOrDigest = function (outputEnc) {
  var outData = this.__final() || Buffer.alloc(0)
  if (outputEnc) {
    outData = this._toString(outData, outputEnc, true)
  }
  return outData
}

CipherBase.prototype._toString = function (value, enc, fin) {
  if (!this._decoder) {
    this._decoder = new StringDecoder(enc)
    this._encoding = enc
  }

  if (this._encoding !== enc) throw new Error('can\'t switch encodings')

  var out = this._decoder.write(value)
  if (fin) {
    out += this._decoder.end()
  }

  return out
}

module.exports = CipherBase


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(330)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(238)('meta');
var isObject = __webpack_require__(53);
var has = __webpack_require__(130);
var setDesc = __webpack_require__(83).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(51)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(53);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 202 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */


module.exports = function (name) {
  if (typeof window !== 'undefined' && window.__DRAFT_GKX) {
    return !!window.__DRAFT_GKX[name];
  }

  return false;
};

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isInvalid;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Returns true if a value is undefined, or NaN.
 */
function isInvalid(value) {
  return value === undefined || value !== value;
}

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/* eslint-disable no-redeclare */
// $FlowFixMe workaround for: https://github.com/facebook/flow/issues/2221
var objectValues = Object.values || function (obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
};

var _default = objectValues;
exports.default = _default;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;

var _warning = __webpack_require__(212);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
  var _parsePath = parsePath(path),
      pathname = _parsePath.pathname,
      search = _parsePath.search,
      hash = _parsePath.hash;

  return createPath({
    pathname: pathname,
    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
    hash: hash
  });
};

var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
  var _parsePath2 = parsePath(path),
      pathname = _parsePath2.pathname,
      search = _parsePath2.search,
      hash = _parsePath2.hash;

  return createPath({
    pathname: pathname,
    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
      return prefix === '?' ? prefix : suffix;
    }),
    hash: hash
  });
};

var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
  var _parsePath3 = parsePath(path),
      search = _parsePath3.search;

  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
  return match && match[1];
};

var extractPath = function extractPath(string) {
  var match = string.match(/^(https?:)?\/\/[^\/]*/);
  return match == null ? string : string.substring(match[0].length);
};

var parsePath = exports.parsePath = function parsePath(path) {
  var pathname = extractPath(path);
  var search = '';
  var hash = '';

   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;

  var hashIndex = pathname.indexOf('#');
  if (hashIndex !== -1) {
    hash = pathname.substring(hashIndex);
    pathname = pathname.substring(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');
  if (searchIndex !== -1) {
    search = pathname.substring(searchIndex);
    pathname = pathname.substring(0, searchIndex);
  }

  if (pathname === '') pathname = '/';

  return {
    pathname: pathname,
    search: search,
    hash: hash
  };
};

var createPath = exports.createPath = function createPath(location) {
  if (location == null || typeof location === 'string') return location;

  var basename = location.basename,
      pathname = location.pathname,
      search = location.search,
      hash = location.hash;

  var path = (basename || '') + pathname;

  if (search && search !== '?') path += search;

  if (hash) path += hash;

  return path;
};

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isReactChildren;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRouteFromReactElement;
/* unused harmony export createRoutesFromReactChildren */
/* harmony export (immutable) */ __webpack_exports__["a"] = createRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



function isValidChild(object) {
  return object == null || __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(object);
}

function isReactChildren(object) {
  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
}

function createRoute(defaultProps, props) {
  return _extends({}, defaultProps, props);
}

function createRouteFromReactElement(element) {
  var type = element.type;
  var route = createRoute(type.defaultProps, element.props);

  if (route.children) {
    var childRoutes = createRoutesFromReactChildren(route.children, route);

    if (childRoutes.length) route.childRoutes = childRoutes;

    delete route.children;
  }

  return route;
}

/**
 * Creates and returns a routes object from the given ReactChildren. JSX
 * provides a convenient way to visualize how routes in the hierarchy are
 * nested.
 *
 *   import { Route, createRoutesFromReactChildren } from 'react-router'
 *
 *   const routes = createRoutesFromReactChildren(
 *     <Route component={App}>
 *       <Route path="home" component={Dashboard}/>
 *       <Route path="news" component={NewsFeed}/>
 *     </Route>
 *   )
 *
 * Note: This method is automatically used when you provide <Route> children
 * to a <Router> component.
 */
function createRoutesFromReactChildren(children, parentRoute) {
  var routes = [];

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
    if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
      // Component classes may have a static create* method.
      if (element.type.createRouteFromReactElement) {
        var route = element.type.createRouteFromReactElement(element, parentRoute);

        if (route) routes.push(route);
      } else {
        routes.push(createRouteFromReactElement(element));
      }
    }
  });

  return routes;
}

/**
 * Creates and returns an array of routes from the given object which
 * may be a JSX route, a plain object route, or an array of either.
 */
function createRoutes(routes) {
  if (isReactChildren(routes)) {
    routes = createRoutesFromReactChildren(routes);
  } else if (routes && !Array.isArray(routes)) {
    routes = [routes];
  }

  return routes;
}

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toFinite_js__ = __webpack_require__(757);


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toFinite_js__["a" /* default */])(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (toInteger);


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(741);


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),
/* 211 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
var stylesInDom = {},
	memoize = function(fn) {
		var memo;
		return function () {
			if (typeof memo === "undefined") memo = fn.apply(this, arguments);
			return memo;
		};
	},
	isOldIE = memoize(function() {
		return /msie [6-9]\b/.test(self.navigator.userAgent.toLowerCase());
	}),
	getHeadElement = memoize(function () {
		return document.head || document.getElementsByTagName("head")[0];
	}),
	singletonElement = null,
	singletonCounter = 0,
	styleElementsInsertedAtTop = [];

module.exports = function(list, options) {
	if(typeof DEBUG !== "undefined" && DEBUG) {
		if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};
	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (typeof options.singleton === "undefined") options.singleton = isOldIE();

	// By default, add <style> tags to the bottom of <head>.
	if (typeof options.insertAt === "undefined") options.insertAt = "bottom";

	var styles = listToStyles(list);
	addStylesToDom(styles, options);

	return function update(newList) {
		var mayRemove = [];
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			domStyle.refs--;
			mayRemove.push(domStyle);
		}
		if(newList) {
			var newStyles = listToStyles(newList);
			addStylesToDom(newStyles, options);
		}
		for(var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];
			if(domStyle.refs === 0) {
				for(var j = 0; j < domStyle.parts.length; j++)
					domStyle.parts[j]();
				delete stylesInDom[domStyle.id];
			}
		}
	};
}

function addStylesToDom(styles, options) {
	for(var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];
		if(domStyle) {
			domStyle.refs++;
			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}
			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];
			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}
			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles(list) {
	var styles = [];
	var newStyles = {};
	for(var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};
		if(!newStyles[id])
			styles.push(newStyles[id] = {id: id, parts: [part]});
		else
			newStyles[id].parts.push(part);
	}
	return styles;
}

function insertStyleElement(options, styleElement) {
	var head = getHeadElement();
	var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	if (options.insertAt === "top") {
		if(!lastStyleElementInsertedAtTop) {
			head.insertBefore(styleElement, head.firstChild);
		} else if(lastStyleElementInsertedAtTop.nextSibling) {
			head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			head.appendChild(styleElement);
		}
		styleElementsInsertedAtTop.push(styleElement);
	} else if (options.insertAt === "bottom") {
		head.appendChild(styleElement);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement(styleElement) {
	styleElement.parentNode.removeChild(styleElement);
	var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	if(idx >= 0) {
		styleElementsInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement(options) {
	var styleElement = document.createElement("style");
	styleElement.type = "text/css";
	insertStyleElement(options, styleElement);
	return styleElement;
}

function createLinkElement(options) {
	var linkElement = document.createElement("link");
	linkElement.rel = "stylesheet";
	insertStyleElement(options, linkElement);
	return linkElement;
}

function addStyle(obj, options) {
	var styleElement, update, remove;

	if (options.singleton) {
		var styleIndex = singletonCounter++;
		styleElement = singletonElement || (singletonElement = createStyleElement(options));
		update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
		remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
	} else if(obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function") {
		styleElement = createLinkElement(options);
		update = updateLink.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
			if(styleElement.href)
				URL.revokeObjectURL(styleElement.href);
		};
	} else {
		styleElement = createStyleElement(options);
		update = applyToTag.bind(null, styleElement);
		remove = function() {
			removeStyleElement(styleElement);
		};
	}

	update(obj);

	return function updateStyle(newObj) {
		if(newObj) {
			if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
				return;
			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;
		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag(styleElement, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (styleElement.styleSheet) {
		styleElement.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = styleElement.childNodes;
		if (childNodes[index]) styleElement.removeChild(childNodes[index]);
		if (childNodes.length) {
			styleElement.insertBefore(cssNode, childNodes[index]);
		} else {
			styleElement.appendChild(cssNode);
		}
	}
}

function applyToTag(styleElement, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		styleElement.setAttribute("media", media)
	}

	if(styleElement.styleSheet) {
		styleElement.styleSheet.cssText = css;
	} else {
		while(styleElement.firstChild) {
			styleElement.removeChild(styleElement.firstChild);
		}
		styleElement.appendChild(document.createTextNode(css));
	}
}

function updateLink(linkElement, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	if(sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = linkElement.href;

	linkElement.href = URL.createObjectURL(blob);

	if(oldSrc)
		URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return sortByField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return objectLessAttributes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return filenameToContentType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isTextFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return generateRandomString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return makeQuerablePromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isWebWorker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return browserOrNode; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return transferKeyToLowerCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return transferKeyToUpperCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isStrictObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return JS; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var MIME_MAP = [
    { type: 'text/plain', ext: 'txt' },
    { type: 'text/html', ext: 'html' },
    { type: 'text/javascript', ext: 'js' },
    { type: 'text/css', ext: 'css' },
    { type: 'text/csv', ext: 'csv' },
    { type: 'text/yaml', ext: 'yml' },
    { type: 'text/yaml', ext: 'yaml' },
    { type: 'text/calendar', ext: 'ics' },
    { type: 'text/calendar', ext: 'ical' },
    { type: 'image/apng', ext: 'apng' },
    { type: 'image/bmp', ext: 'bmp' },
    { type: 'image/gif', ext: 'gif' },
    { type: 'image/x-icon', ext: 'ico' },
    { type: 'image/x-icon', ext: 'cur' },
    { type: 'image/jpeg', ext: 'jpg' },
    { type: 'image/jpeg', ext: 'jpeg' },
    { type: 'image/jpeg', ext: 'jfif' },
    { type: 'image/jpeg', ext: 'pjp' },
    { type: 'image/jpeg', ext: 'pjpeg' },
    { type: 'image/png', ext: 'png' },
    { type: 'image/svg+xml', ext: 'svg' },
    { type: 'image/tiff', ext: 'tif' },
    { type: 'image/tiff', ext: 'tiff' },
    { type: 'image/webp', ext: 'webp' },
    { type: 'application/json', ext: 'json' },
    { type: 'application/xml', ext: 'xml' },
    { type: 'application/x-sh', ext: 'sh' },
    { type: 'application/zip', ext: 'zip' },
    { type: 'application/x-rar-compressed', ext: 'rar' },
    { type: 'application/x-tar', ext: 'tar' },
    { type: 'application/x-bzip', ext: 'bz' },
    { type: 'application/x-bzip2', ext: 'bz2' },
    { type: 'application/pdf', ext: 'pdf' },
    { type: 'application/java-archive', ext: 'jar' },
    { type: 'application/msword', ext: 'doc' },
    { type: 'application/vnd.ms-excel', ext: 'xls' },
    { type: 'application/vnd.ms-excel', ext: 'xlsx' },
    { type: 'message/rfc822', ext: 'eml' },
];
var isEmpty = function (obj) {
    if (obj === void 0) { obj = {}; }
    return Object.keys(obj).length === 0;
};
var sortByField = function (list, field, dir) {
    if (!list || !list.sort) {
        return false;
    }
    var dirX = dir && dir === 'desc' ? -1 : 1;
    list.sort(function (a, b) {
        var a_val = a[field];
        var b_val = b[field];
        if (typeof b_val === 'undefined') {
            return typeof a_val === 'undefined' ? 0 : 1 * dirX;
        }
        if (typeof a_val === 'undefined') {
            return -1 * dirX;
        }
        if (a_val < b_val) {
            return -1 * dirX;
        }
        if (a_val > b_val) {
            return 1 * dirX;
        }
        return 0;
    });
    return true;
};
var objectLessAttributes = function (obj, less) {
    var ret = Object.assign({}, obj);
    if (less) {
        if (typeof less === 'string') {
            delete ret[less];
        }
        else {
            less.forEach(function (attr) {
                delete ret[attr];
            });
        }
    }
    return ret;
};
var filenameToContentType = function (filename, defVal) {
    if (defVal === void 0) { defVal = 'application/octet-stream'; }
    var name = filename.toLowerCase();
    var filtered = MIME_MAP.filter(function (mime) { return name.endsWith('.' + mime.ext); });
    return filtered.length > 0 ? filtered[0].type : defVal;
};
var isTextFile = function (contentType) {
    var type = contentType.toLowerCase();
    if (type.startsWith('text/')) {
        return true;
    }
    return ('application/json' === type ||
        'application/xml' === type ||
        'application/sh' === type);
};
var generateRandomString = function () {
    var result = '';
    var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for (var i = 32; i > 0; i -= 1) {
        result += chars[Math.floor(Math.random() * chars.length)];
    }
    return result;
};
var makeQuerablePromise = function (promise) {
    if (promise.isResolved)
        return promise;
    var isPending = true;
    var isRejected = false;
    var isFullfilled = false;
    var result = promise.then(function (data) {
        isFullfilled = true;
        isPending = false;
        return data;
    }, function (e) {
        isRejected = true;
        isPending = false;
        throw e;
    });
    result.isFullfilled = function () { return isFullfilled; };
    result.isPending = function () { return isPending; };
    result.isRejected = function () { return isRejected; };
    return result;
};
var isWebWorker = function () {
    if (typeof self === 'undefined') {
        return false;
    }
    var selfContext = self;
    return typeof selfContext.WorkerGlobalScope !== 'undefined' &&
        self instanceof selfContext.WorkerGlobalScope;
};
var browserOrNode = function () {
    var isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
    var isNode = typeof process !== 'undefined' &&
        process.versions != null &&
        process.versions.node != null;
    return {
        isBrowser: isBrowser,
        isNode: isNode,
    };
};
/**
 * transfer the first letter of the keys to lowercase
 * @param {Object} obj - the object need to be transferred
 * @param {Array} whiteListForItself - whitelist itself from being transferred
 * @param {Array} whiteListForChildren - whitelist its children keys from being transferred
 */
var transferKeyToLowerCase = function (obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) { whiteListForItself = []; }
    if (whiteListForChildren === void 0) { whiteListForChildren = []; }
    if (!isStrictObject(obj))
        return obj;
    var ret = {};
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            var transferedKey = whiteListForItself.includes(key)
                ? key
                : key[0].toLowerCase() + key.slice(1);
            ret[transferedKey] = whiteListForChildren.includes(key)
                ? obj[key]
                : transferKeyToLowerCase(obj[key], whiteListForItself, whiteListForChildren);
        }
    }
    return ret;
};
/**
 * transfer the first letter of the keys to lowercase
 * @param {Object} obj - the object need to be transferred
 * @param {Array} whiteListForItself - whitelist itself from being transferred
 * @param {Array} whiteListForChildren - whitelist its children keys from being transferred
 */
var transferKeyToUpperCase = function (obj, whiteListForItself, whiteListForChildren) {
    if (whiteListForItself === void 0) { whiteListForItself = []; }
    if (whiteListForChildren === void 0) { whiteListForChildren = []; }
    if (!isStrictObject(obj))
        return obj;
    var ret = {};
    for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
            var transferredKey = whiteListForItself.includes(key)
                ? key
                : key[0].toUpperCase() + key.slice(1);
            ret[transferredKey] = whiteListForChildren.includes(key)
                ? obj[key]
                : transferKeyToUpperCase(obj[key], whiteListForItself, whiteListForChildren);
        }
    }
    return ret;
};
/**
 * Return true if the object is a strict object
 * which means it's not Array, Function, Number, String, Boolean or Null
 * @param obj the Object
 */
var isStrictObject = function (obj) {
    return (obj instanceof Object &&
        !(obj instanceof Array) &&
        !(obj instanceof Function) &&
        !(obj instanceof Number) &&
        !(obj instanceof String) &&
        !(obj instanceof Boolean));
};
/**
 * @deprecated use per-function imports
 */
var JS = /** @class */ (function () {
    function JS() {
    }
    JS.isEmpty = isEmpty;
    JS.sortByField = sortByField;
    JS.objectLessAttributes = objectLessAttributes;
    JS.filenameToContentType = filenameToContentType;
    JS.isTextFile = isTextFile;
    JS.generateRandomString = generateRandomString;
    JS.makeQuerablePromise = makeQuerablePromise;
    JS.isWebWorker = isWebWorker;
    JS.browserOrNode = browserOrNode;
    JS.transferKeyToLowerCase = transferKeyToLowerCase;
    JS.transferKeyToUpperCase = transferKeyToUpperCase;
    JS.isStrictObject = isStrictObject;
    return JS;
}());

/**
 * @deprecated use per-function imports
 */
/* unused harmony default export */ var _unused_webpack_default_export = (JS);
//# sourceMappingURL=JS.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(90)))

/***/ }),
/* 214 */
/***/ (function(module, exports) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNodeName;
function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBasePlacement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(114);

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return max; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return min; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return round; });
var max = Math.max;
var min = Math.min;
var round = Math.round;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _banks = __webpack_require__(581);

var _banks2 = _interopRequireDefault(_banks);

var _translation = __webpack_require__(4);

var _Validate = __webpack_require__(219);

var _Validate2 = _interopRequireDefault(_Validate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectBank = function (_Component) {
  _inherits(SelectBank, _Component);

  function SelectBank(props) {
    _classCallCheck(this, SelectBank);

    var _this = _possibleConstructorReturn(this, (SelectBank.__proto__ || Object.getPrototypeOf(SelectBank)).call(this, props));

    _this.findBankCountry = function (val) {
      return _banks2.default.find(function (bbc) {
        return bbc.value.some(function (bank) {
          return bank.value === val;
        });
      });
    };

    _this.handleSelectCountry = function (e, data) {
      _this.setState({ country: data.value });
      // reset bank value
      _this.handleSelectBank(e, { value: '', name: _this.props.name });
    };

    _this.handleSelectBank = function (e, data) {
      if (_this.props.onChange) {
        _this.props.onChange(e, data);
      }
    };

    var country = props.country || 'my';
    if (props.value) {
      var countryObj = _this.findBankCountry(props.value);
      if (countryObj) {
        country = countryObj.country;
      }
    }
    _this.state = {
      country: country
    };
    return _this;
  }

  _createClass(SelectBank, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var value = nextProps.value;

      if (value !== this.props.value) {
        var countryObj = this.findBankCountry(value);
        if (countryObj) {
          var country = countryObj.country;
          this.setState({ country: country });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var country = this.state.country;
      var t = this.props.t;

      var countries = [{ text: 'ID', value: 'id' }, { text: 'MY', value: 'my' }, { text: 'SG', value: 'sg' }, { text: 'VN', value: 'vn' }];
      var bankOptions = [];
      var banksByCountry = _banks2.default.find(function (b) {
        return b.country === country;
      });
      if (banksByCountry) {
        bankOptions = banksByCountry.value;
      }
      return _react2.default.createElement(
        'div',
        { className: 'field' },
        this.props.label !== '' ? _react2.default.createElement(
          'label',
          { htmlFor: this.props.name },
          this.props.label
        ) : null,
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', style: this.props.style && this.props.style },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            {
              textAlign: 'left',
              width: this.props.fullWidth ? 16 : 4,
              style: this.props.fullWidth ? { paddingBottom: '0' } : { paddingRight: '0' }
            },
            _react2.default.createElement(_semanticUiReact.Form.Select, {
              name: 'bankCountry',
              onChange: this.handleSelectCountry,
              options: countries,
              search: true,
              selectOnBlur: false,
              value: country,
              style: { minWidth: 'auto' },
              disabled: this.props.disabled,
              noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right', width: this.props.fullWidth ? 16 : 12 },
            _react2.default.createElement(
              _Validate2.default,
              {
                hideMessage: true,
                validation: this.props.validation,
                label: this.props.validateLabel || this.props.label,
                name: this.props.name,
                ref: this.props.validateRef,
                onChange: this.handleSelectBank
              },
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                fluid: true,
                search: true,
                autoComplete: this.props.autoComplete,
                loading: this.props.loading,
                name: this.props.name,
                options: bankOptions,
                placeholder: this.props.placeholder,
                text: this.props.text,
                selectOnBlur: false,
                value: this.props.value,
                disabled: this.props.disabled,
                noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
              })
            )
          )
        )
      );
    }
  }]);

  return SelectBank;
}(_react.Component);

SelectBank.propTypes = {
  autoComplete: _propTypes2.default.string,
  label: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  country: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  text: _propTypes2.default.string,
  fullWidth: _propTypes2.default.bool,
  validation: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({
    validate: _propTypes2.default.func,
    option: _propTypes2.default.object
  })]).isRequired),
  value: _propTypes2.default.string,
  validateLabel: _propTypes2.default.string,
  validateRef: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({})]),
  disabled: _propTypes2.default.bool,
  style: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  t: _propTypes2.default.func
};


var SelectBankWithTranslation = (0, _reactI18next.withTranslation)([_translation.TRANSLATION_FILES.translation])(SelectBank);
exports.default = (0, _react.forwardRef)(function (props, ref) {
  return _react2.default.createElement(SelectBankWithTranslation, _extends({}, props, { validateRef: ref }));
});

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _webValidations = __webpack_require__(23);

var _Helper = __webpack_require__(381);

var _Helper2 = _interopRequireDefault(_Helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-param-reassign */


var Validate = function (_Component) {
  _inherits(Validate, _Component);

  function Validate(props) {
    _classCallCheck(this, Validate);

    var _this = _possibleConstructorReturn(this, (Validate.__proto__ || Object.getPrototypeOf(Validate)).call(this, props));

    _this.translateValidationMessage = function (message) {
      var t = _this.props.t;

      if (!t || !message) return message;

      if (message.includes('is required')) {
        var fieldName = message.replace(' is required', '').trim();
        var translatedRequired = t('is required', { defaultValue: 'is required' });
        return fieldName + ' ' + translatedRequired;
      } else if (message.includes('is not a valid mobile number')) {
        var _fieldName = message.replace('is not a valid mobile number', '').trim();
        var translatedInvalidPhone = t('is not a valid mobile number', { defaultValue: 'is not a valid mobile number' });
        return _fieldName + ' ' + translatedInvalidPhone;
      } else if (message.includes('does not match the format')) {
        var _fieldName2 = message.replace(' does not match the format', '').trim();
        var translatedDoesNotMatch = t('does not match the format', { defaultValue: 'does not match the format' });
        return _fieldName2 + ' ' + translatedDoesNotMatch;
      } else if (message.match(/needs to be at least \d+/)) {
        var match = message.match(/needs to be at least (\d+)/);
        var minValue = match ? match[1] : '0';
        var _fieldName3 = message.replace(/needs to be at least \d+/, '').trim();
        var translatedNeedsToBeAtLeast = t('needs to be at least {{number}}', { number: minValue, defaultValue: 'needs to be at least ' + minValue });
        return _fieldName3 + ' ' + translatedNeedsToBeAtLeast;
      } else if (message.includes('is not a valid email address')) {
        var _fieldName4 = message.replace('is not a valid email address', '').trim();
        var translatedInvalidEmail = t('is not a valid email address', { defaultValue: 'is not a valid email address' });
        return _fieldName4 + ' ' + translatedInvalidEmail;
      }
      return message;
    };

    _this.handleOnChange = function (e, data) {
      // bubble up onChange
      if (_this.props.onChange) {
        _this.props.onChange(e, data);
      }
      if (data && data.value) {
        _this.validate(data.value);
      } else {
        _this.validate(e.target.value);
      }
    };

    _this.validate = function (value) {
      var label = _this.props.validateLabel || _this.props.label || _this.getLabels();
      var name = _this.props.name || _this.getNames();
      var type = _this.getTypes();
      var message = _this.props.message;
      return new Promise(function (res) {
        if (_this.props.validation && _this.props.validation.length > 0) {
          if (type === 'number') {
            // If value is empty string, will become NaN
            value = parseFloat(value);
            if (isNaN(value)) {
              value = 0;
            }
          }
          var validate = void 0;
          _this.props.validation.every(function (v) {
            if (v && v.toString() && v.toString().includes('is required')) {
              // array & undefined required fix
              if (type !== 'number' && (value === undefined || !value)) value = '';
              if (Array.isArray(value)) value = value.join();
            }
            if ((typeof v === 'undefined' ? 'undefined' : _typeof(v)) === 'object') {
              validate = v.validate(value, Object.assign({ key: name, label: label, message: message }, v.option));
            } else {
              validate = v(value, { key: name, label: label, message: message });
            }
            return validate.isValid;
          });
          var translatedMessage = _this.translateValidationMessage(validate.message);
          _this.setState({
            isValid: validate.isValid,
            message: translatedMessage
          }, function () {
            if (_this.props.onError) {
              _this.props.onError(!validate.isValid, translatedMessage);
            }
            // Return validation object with translated message
            res(_extends({}, validate, { message: translatedMessage }));
          });
        } else {
          res((0, _webValidations.createValidity)(name));
        }
      });
    };

    _this.state = {
      isValid: true,
      message: null
    };
    return _this;
  }

  _createClass(Validate, [{
    key: 'getLabels',
    value: function getLabels() {
      var labels = _react.Children.map(this.props.children, function (child) {
        if (!child) return null;
        return child.props.label;
      }).filter(Boolean);
      return labels.join(', ');
    }
  }, {
    key: 'getNames',
    value: function getNames() {
      var names = _react.Children.map(this.props.children, function (child) {
        if (!child) return null;
        return child.props.name;
      }).filter(Boolean);
      return names.join(', ');
    }
  }, {
    key: 'getTypes',
    value: function getTypes() {
      var _this2 = this;

      var types = _react.Children.map(this.props.children, function (child) {
        if (!child) return null;
        return _this2.props.showThousandSeparator ? 'number' : child.props.type;
      }).filter(Boolean);
      return types.join(', ');
    }
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this3 = this;

      return _react.Children.map(this.props.children, function (child) {
        // Skip null/undefined children
        if (!child) return null;

        if (_this3.props.hideMessage || _this3.props.onError) {
          return _react2.default.cloneElement(child, {
            onChange: _this3.handleOnChange
          });
        }
        return _react2.default.cloneElement(child, {
          onChange: _this3.handleOnChange,
          error: !_this3.state.isValid
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'validate field', style: this.props.style && this.props.style },
        this.renderChild(),
        this.state.message && !this.props.hideMessage ? _react2.default.createElement(
          _Helper2.default,
          { type: 'error' },
          this.state.message
        ) : null
      );
    }
  }]);

  return Validate;
}(_react.Component);

// withRef forwards `ref` natively to the Validate class instance, so refs
// re-attach on every render exactly like the pre-HOC `export default class`.


Validate.propTypes = {
  name: _propTypes2.default.string,
  label: _propTypes2.default.string,
  message: _propTypes2.default.string,
  children: _propTypes2.default.node,
  validation: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({
    validate: _propTypes2.default.func,
    option: _propTypes2.default.object
  })]).isRequired),
  onChange: _propTypes2.default.func,
  validateLabel: _propTypes2.default.string,
  onError: _propTypes2.default.func,
  hideMessage: _propTypes2.default.bool,
  showThousandSeparator: _propTypes2.default.bool,
  style: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(undefined, { withRef: true })(Validate);

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDayPicker = __webpack_require__(687);

var _reactDayPicker2 = _interopRequireDefault(_reactDayPicker);

__webpack_require__(360);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _i18next = __webpack_require__(94);

var _i18next2 = _interopRequireDefault(_i18next);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_momentTimezone2.default.locale('en-gb');

var getCurrentLocale = function getCurrentLocale() {
  var lang = _i18next2.default.language || 'en-gb';
  if (lang.startsWith('vi')) return 'vi';
  return 'en-gb';
};

// Year & Month Dropdown

var YearMonthForm = function (_Component) {
  _inherits(YearMonthForm, _Component);

  function YearMonthForm(props) {
    _classCallCheck(this, YearMonthForm);

    var _this = _possibleConstructorReturn(this, (YearMonthForm.__proto__ || Object.getPrototypeOf(YearMonthForm)).call(this, props));

    _this.handleOnChange = function (e) {
      var _e$target = e.target,
          name = _e$target.name,
          value = _e$target.value;

      _this.setState(_defineProperty({}, name, value), function () {
        _this.handleChange();
      });
    };

    _this.handleChange = function () {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          monthLogic = _this$props.monthLogic;
      var _this$state = _this.state,
          year = _this$state.year,
          month = _this$state.month,
          currentMonth = _this$state.currentMonth,
          currentYear = _this$state.currentYear;

      if (onChange) {
        if (monthLogic && monthLogic({ year: year, month: month, currentMonth: currentMonth, currentYear: currentYear })) {
          onChange(new Date(year, currentMonth));
          return;
        }
        onChange(new Date(year, month));
      }
    };

    var date = props.date;

    _this.state = {
      currentMonth: new Date().getMonth(),
      currentYear: new Date().getFullYear(),
      year: date.getFullYear(),
      month: date.getMonth()
    };
    return _this;
  }

  _createClass(YearMonthForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var date = nextProps.date;

      this.setState({
        year: date.getFullYear(),
        month: date.getMonth()
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          reff = _props.reff,
          fromMonth = _props.fromMonth,
          toMonth = _props.toMonth,
          monthLogic = _props.monthLogic;
      var _state = this.state,
          currentMonth = _state.currentMonth,
          currentYear = _state.currentYear;

      // 2. Automatically grab the active dropdown language context

      var currentLocale = getCurrentLocale();

      var months = [];
      for (var i = 0; i < 12; i += 1) {
        months.push((0, _momentTimezone2.default)().locale(currentLocale).month(i).format('MMMM'));
      }

      var years = [];
      for (var _i = fromMonth.getFullYear(); _i <= toMonth.getFullYear(); _i += 1) {
        years.push(_i);
      }
      return _react2.default.createElement(
        'div',
        { className: 'DayPicker-Caption' },
        _react2.default.createElement(
          'select',
          {
            ref: reff,
            name: 'month',
            onChange: this.handleOnChange,
            value: this.state.month,
            style: {
              width: '47%',
              display: 'inline-block',
              padding: '0.15em',
              marginRight: '0.25em'
            }
          },
          months.map(function (month, i) {
            if (monthLogic && monthLogic({ year: _this2.state.year, currentMonth: currentMonth, currentYear: currentYear, month: i })) {
              return '';
            }
            return _react2.default.createElement(
              'option',
              { key: month, value: i },
              month
            );
          })
        ),
        _react2.default.createElement(
          'select',
          {
            name: 'year',
            onChange: this.handleOnChange,
            value: this.state.year,
            style: {
              width: '30%',
              display: 'inline-block',
              padding: '0.15em'
            },
            disabled: years.length < 2
          },
          years.map(function (year) {
            return _react2.default.createElement(
              'option',
              { key: year, value: year },
              year
            );
          })
        )
      );
    }
  }]);

  return YearMonthForm;
}(_react.Component);

YearMonthForm.propTypes = {
  date: _propTypes2.default.object.isRequired,
  onChange: _propTypes2.default.func,
  fromMonth: _propTypes2.default.object,
  toMonth: _propTypes2.default.object,
  monthLogic: _propTypes2.default.func
};
YearMonthForm.defaultProps = {
  monthLogic: function monthLogic(_ref2) {
    var year = _ref2.year,
        month = _ref2.month,
        currentYear = _ref2.currentYear,
        currentMonth = _ref2.currentMonth;
    return year === currentYear && month > currentMonth;
  }
};

var InputBirthdate = function (_Component2) {
  _inherits(InputBirthdate, _Component2);

  function InputBirthdate(props) {
    _classCallCheck(this, InputBirthdate);

    var _this3 = _possibleConstructorReturn(this, (InputBirthdate.__proto__ || Object.getPrototypeOf(InputBirthdate)).call(this, props));

    _initialiseProps.call(_this3);

    var state = InputBirthdate.getPropsToState(props);
    _this3.state = _extends({}, state, {
      showOverlay: false
    });
    return _this3;
  }

  _createClass(InputBirthdate, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = InputBirthdate.getPropsToState(nextProps);
      if (!nextProps.disabled) {
        state.showOverlay = false;
      }
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.clickTimeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          fromMonth = _props2.fromMonth,
          toMonth = _props2.toMonth,
          monthLogic = _props2.monthLogic,
          disabledDays = _props2.disabledDays;
      var _state2 = this.state,
          from = _state2.from,
          showOverlay = _state2.showOverlay;

      // 3. Extract the active i18n language string right here

      var currentLocale = getCurrentLocale();
      var localizedWeekdays = _momentTimezone2.default.localeData(currentLocale).weekdaysMin();

      return _react2.default.createElement(
        'div',
        { className: this.props.disabled ? 'disabled field' : 'field', onMouseDown: this.handleContainerMouseDown },
        this.props.label ? _react2.default.createElement(
          'label',
          { htmlFor: 'birthdate' },
          this.props.label
        ) : '',
        _react2.default.createElement(
          'div',
          { className: 'ui fluid icon input' },
          _react2.default.createElement('input', {
            name: 'birthdate',
            type: 'text',
            ref: function ref(el) {
              _this4.inputDate = el;
            },
            pattern: '(?:19|20)[0-9]{2}-(?:(?:0[1-9]|1[0-2])-(?:0[1-9]|1[0-9]|2[0-9])|(?:(?!02)(?:0[1-9]|1[0-2])-(?:30))|(?:(?:0[13578]|1[02])-31))',
            placeholder: 'YYYY-MM-DD',
            value: from ? (0, _momentTimezone2.default)(from).locale(currentLocale).format('YYYY-MM-DD') : '',
            readOnly: true,
            onClick: !this.props.disabled ? this.handleInputClick : undefined,
            disabled: this.props.disabled
          }),
          _react2.default.createElement('i', {
            'aria-hidden': 'true',
            onClick: showOverlay ? this.handleClose : undefined,
            className: showOverlay ? 'x icon' : 'calendar icon',
            style: showOverlay ? { cursor: 'pointer', pointerEvents: 'all' } : {}
          })
        ),
        showOverlay && !this.props.disabled && _react2.default.createElement(
          'div',
          { style: { position: 'relative' } },
          _react2.default.createElement(
            'div',
            {
              style: {
                position: 'absolute',
                background: 'white',
                boxShadow: '0 2px 5px rgba(0, 0, 0, .15)',
                zIndex: '100'
              }
            },
            _react2.default.createElement(
              'div',
              { className: 'YearNavigation' },
              _react2.default.createElement(_reactDayPicker2.default, {
                showOutsideDays: true,
                month: this.state.month,
                fromMonth: fromMonth,
                toMonth: toMonth,
                selectedDays: from,
                disabledDays: disabledDays,
                onDayClick: this.handleDayClick,
                weekdaysShort: localizedWeekdays,
                captionElement: function captionElement(_ref) {
                  var date = _ref.date,
                      localeUtils = _ref.localeUtils;
                  return _react2.default.createElement(YearMonthForm, {
                    date: date,
                    localeUtils: localeUtils,
                    onChange: _this4.handleYearMonthChange,
                    fromMonth: fromMonth,
                    toMonth: toMonth,
                    monthLogic: monthLogic
                  });
                }
              })
            )
          )
        )
      );
    }
  }]);

  return InputBirthdate;
}(_react.Component);

InputBirthdate.propTypes = {
  date: _propTypes2.default.string,
  onSelectDay: _propTypes2.default.func.isRequired,
  label: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  format: _propTypes2.default.string,
  fromMonth: _propTypes2.default.object,
  toMonth: _propTypes2.default.object,
  showMonth: _propTypes2.default.object,
  monthLogic: _propTypes2.default.func,
  disabledDays: _propTypes2.default.shape({
    before: _propTypes2.default.object,
    after: _propTypes2.default.object
  })
};
InputBirthdate.defaultProps = {
  format: 'YYYY-MM-DD',
  fromMonth: new Date(0, new Date().getMonth()),
  toMonth: new Date(),
  disabledDays: {
    after: new Date()
  }
};

InputBirthdate.getPropsToState = function (props) {
  var from = props.date ? new Date(props.date) : null;
  var month = props.date ? new Date(props.date) : props.fromMonth;
  if (props.showMonth) {
    month = props.showMonth;
  }
  return {
    from: from,
    month: month
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.inputDate = null;

  this.handleInputClick = function () {
    _this5.setState({
      showOverlay: !_this5.state.showOverlay
    }, function () {
      if (!_this5.state.showOverlay) {
        _this5.inputDate.blur();
      }
    });
  };

  this.handleDayClick = function (day) {
    var modifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    if (modifiers.disabled) {
      return;
    }
    _this5.setState({ from: day, showOverlay: false }, function () {
      _this5.inputDate.blur();
    });
    var _props3 = _this5.props,
        onSelectDay = _props3.onSelectDay,
        format = _props3.format;

    var currentLocale = getCurrentLocale();
    var date = format ? (0, _momentTimezone2.default)(day).locale(currentLocale).format(format) : (0, _momentTimezone2.default)(day).locale(currentLocale);
    if (onSelectDay) {
      onSelectDay(date);
    }
  };

  this.handleClose = function () {
    _this5.setState({ showOverlay: false }, function () {
      _this5.inputDate.blur();
    });
  };

  this.handleYearMonthChange = function (month) {
    _this5.setState({ month: month });
  };
};

exports.default = InputBirthdate;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var HIMS_DEVELOPER_CODE = exports.HIMS_DEVELOPER_CODE = 'hims_developer_code';
var HIMS_PROJECT_DEVELOPMENT_ID = exports.HIMS_PROJECT_DEVELOPMENT_ID = 'hims_project_development_id';
var HIMS_UNIT_NUMBER = exports.HIMS_UNIT_NUMBER = 'hims_unit_number';
var HIMS_COMPONENT_ID = exports.HIMS_COMPONENT_ID = 'hims_component_id';
var HIMS_LOT_PT = exports.HIMS_LOT_PT = 'hims_lot_pt';
var HIMS_LOT_POSITION = exports.HIMS_LOT_POSITION = 'hims_lot_position';
var HIMS_STRATA_PETAK_TANAH = exports.HIMS_STRATA_PETAK_TANAH = 'hims_strata_petak_tanah';
var HIMS_STRATA_MENARA = exports.HIMS_STRATA_MENARA = 'hims_strata_menara';
var HIMS_STRATA_TINGKAT = exports.HIMS_STRATA_TINGKAT = 'hims_strata_tingkat';
var HIMS_STRATA_JP = exports.HIMS_STRATA_JP = 'hims_strata_jp';
var HIMS_STRATA_PETAK_AKSESORI = exports.HIMS_STRATA_PETAK_AKSESORI = 'hims_strata_petak_aksesori';
var HIMS_STRATA_JADUAL_AKSESORI = exports.HIMS_STRATA_JADUAL_AKSESORI = 'hims_strata_jadual_aksesori';

var HIMS_STRATA_UNIT_FIELDS = exports.HIMS_STRATA_UNIT_FIELDS = [HIMS_STRATA_PETAK_TANAH, HIMS_STRATA_MENARA, HIMS_STRATA_TINGKAT, HIMS_STRATA_JP, HIMS_STRATA_PETAK_AKSESORI, HIMS_STRATA_JADUAL_AKSESORI];

var HIMS_UNIT_MAIN_FIELDS = exports.HIMS_UNIT_MAIN_FIELDS = [HIMS_DEVELOPER_CODE, HIMS_PROJECT_DEVELOPMENT_ID, HIMS_UNIT_NUMBER, HIMS_COMPONENT_ID];

var HIMS_UNIT_FIELDS = exports.HIMS_UNIT_FIELDS = [].concat(HIMS_UNIT_MAIN_FIELDS, [HIMS_LOT_PT, HIMS_LOT_POSITION], HIMS_STRATA_UNIT_FIELDS);

var HIMS_LOT_POSITION_OPTIONS = exports.HIMS_LOT_POSITION_OPTIONS = [{ text: 'Intermediate', value: 'I', description: 'Unit Tengah' }, { text: 'End Lot', value: 'E', description: 'Unit Hujung' }, { text: 'Corner Lot', value: 'C', description: 'Unit Sudut' }, { text: 'Highrise', value: 'T', description: 'Bertingkat' }, { text: 'Show Unit', value: 'S', description: 'Unit Pameran' }];

var HIMS_BOOKING_SYNC_STATUSES = exports.HIMS_BOOKING_SYNC_STATUSES = [{ text: 'Success', value: 'hims-success', name: 'success' }, { text: 'Pending Sync', value: 'hims-pending', name: 'pending' }, { text: 'Failed', value: 'hims-failed', name: 'failed' }];

var HIMS_STRATA_OPTIONS = exports.HIMS_STRATA_OPTIONS = [{ text: 'Yes', value: 'yes' }, { text: 'No', value: 'no' }];

var HIMS_SPA_LAWYER_REP_OPTIONS = exports.HIMS_SPA_LAWYER_REP_OPTIONS = [{ text: 'Developer', value: 'developer' }, { text: 'Purchaser', value: 'purchaser' }];

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PROJECT_PACKAGE_PRICING_DEFAULT = {
  id: '',
  projectID: '',
  name: '',
  description: '',
  orderPriority: 0,
  bumiPurchaserOnly: false,
  isEnabled: true,
  // CPI-977: the Vietnam deposit rate, a FRACTION of the nett price (0.1000 = 10%). null means the
  // package has no rate, and the project's flat reservation sum still applies -- which is every
  // Malaysian and Indonesian package, and the state a new package starts in.
  depositRate: null,
  scheduleStartAt: null,
  scheduleEndAt: null,
  // TODO: change to packagePricingCalculations
  packagePricingItems: [],
  businessUnitAccesses: [],
  createdAt: null,
  updatedAt: null
};

var PROJECT_PACKAGE_PRICING_ITEM_DEFAULT = {
  id: '',
  projectPackagePricingID: '',
  name: '',
  description: '',
  orderPriority: 0,
  isEnabled: true,
  formulaType: 'discount_percent_original_price',
  formulaValue: '',
  newValue: 0,
  valueChange: 0,
  createdAt: null,
  updatedAt: null
};

var PROJECT_UNIT_PACKAGE_PRICING_DEFAULT = {
  id: '',
  projectID: '',
  projectUnitID: '',
  projectPackagePricingID: '',
  orderPriority: 0,
  totalPrice: '',
  isCustomPrice: false,
  customName: '',
  customDescription: '',
  createdAt: null,
  updatedAt: null,
  accessibleIn: []
};

exports.PROJECT_PACKAGE_PRICING_DEFAULT = PROJECT_PACKAGE_PRICING_DEFAULT;
exports.PROJECT_PACKAGE_PRICING_ITEM_DEFAULT = PROJECT_PACKAGE_PRICING_ITEM_DEFAULT;
exports.PROJECT_UNIT_PACKAGE_PRICING_DEFAULT = PROJECT_UNIT_PACKAGE_PRICING_DEFAULT;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUnitFormAreaLabel = exports.getAreaSortLabels = exports.getLandAreaModelLabel = exports.getAreaModelLabel = exports.getMissingAreaLabel = exports.getAreaLabel = exports.isVietnamCountryCode = undefined;

var _translation = __webpack_require__(4);

var isVietnamCountryCode = exports.isVietnamCountryCode = function isVietnamCountryCode(countryCode) {
  if (typeof countryCode !== 'string') {
    return false;
  }
  return countryCode.toLowerCase() === 'vn';
};

// CPI-1230 (D1): the unit's `size` is Vietnam's NSA (Net Saleable Area) and its `landArea` is
// Vietnam's NFA (Net Floor Area). Every arm that is not Vietnam is byte-identical to before.
var getAreaLabel = exports.getAreaLabel = function getAreaLabel(t, countryCode) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var isVietnam = isVietnamCountryCode(countryCode);
  var _options$short = options.short,
      short = _options$short === undefined ? false : _options$short,
      _options$lower = options.lower,
      lower = _options$lower === undefined ? false : _options$lower;


  if (short) {
    return t(isVietnam ? 'Net Saleable' : 'Build Up', { ns: _translation.TRANSLATION_FILES.screens });
  }

  if (lower) {
    return t(isVietnam ? 'unit net saleable area' : 'unit build up area', { ns: _translation.TRANSLATION_FILES.screens });
  }

  return t(isVietnam ? 'Net saleable area' : 'Build Up Area', { ns: _translation.TRANSLATION_FILES.translation });
};

var getMissingAreaLabel = exports.getMissingAreaLabel = function getMissingAreaLabel(t, countryCode) {
  return t(isVietnamCountryCode(countryCode) ? 'No net saleable area available' : 'No build up area available', { ns: _translation.TRANSLATION_FILES.translation });
};

var getAreaModelLabel = exports.getAreaModelLabel = function getAreaModelLabel(t, countryCode) {
  return t(isVietnamCountryCode(countryCode) ? 'NSA · Net Saleable Area' : 'Build Up Area', { ns: _translation.TRANSLATION_FILES.screens });
};

// The companion of getAreaModelLabel for the unit's `landArea` row.
var getLandAreaModelLabel = exports.getLandAreaModelLabel = function getLandAreaModelLabel(t, countryCode) {
  return t(isVietnamCountryCode(countryCode) ? 'NFA · Net Floor Area' : 'Land Area', { ns: _translation.TRANSLATION_FILES.screens });
};

// The unit list's sort menu names the same `size` column, so its wording follows the reversal.
var getAreaSortLabels = exports.getAreaSortLabels = function getAreaSortLabels(countryCode) {
  return isVietnamCountryCode(countryCode) ? { ascending: 'Net Saleable Ascending', descending: 'Net Saleable Descending' } : { ascending: 'Build Up Ascending', descending: 'Build Up Descending' };
};

// CPI-1230 (D-D6): the standalone unit create / edit form labels the same column "Size", so it
// cannot reuse getAreaModelLabel without moving a Malaysian label.
var getUnitFormAreaLabel = exports.getUnitFormAreaLabel = function getUnitFormAreaLabel(t, countryCode) {
  return isVietnamCountryCode(countryCode) ? getAreaModelLabel(t, countryCode) : t('Size', { ns: _translation.TRANSLATION_FILES.screens });
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(2593);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(2592);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(598);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(598);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(177);
var core = __webpack_require__(176);
var ctx = __webpack_require__(1111);
var hide = __webpack_require__(272);
var has = __webpack_require__(228);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 228 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(329);
var IE8_DOM_DEFINE = __webpack_require__(1113);
var toPrimitive = __webpack_require__(614);
var dP = Object.defineProperty;

exports.f = __webpack_require__(199) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(67)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(131)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 231 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(50);
var dPs = __webpack_require__(1136);
var enumBugKeys = __webpack_require__(621);
var IE_PROTO = __webpack_require__(632)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(620)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(623).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(1138);
var hiddenKeys = __webpack_require__(621).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(130);
var toObject = __webpack_require__(99);
var IE_PROTO = __webpack_require__(632)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(1138);
var enumBugKeys = __webpack_require__(621);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 236 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(163);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 238 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(53);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory();
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define([], factory);
	}
	else {
		// Global (browser)
		root.CryptoJS = factory();
	}
}(this, function () {

	/*globals window, global, require*/

	/**
	 * CryptoJS core components.
	 */
	var CryptoJS = CryptoJS || (function (Math, undefined) {

	    var crypto;

	    // Native crypto from window (Browser)
	    if (typeof window !== 'undefined' && window.crypto) {
	        crypto = window.crypto;
	    }

	    // Native (experimental IE 11) crypto from window (Browser)
	    if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
	        crypto = window.msCrypto;
	    }

	    // Native crypto from global (NodeJS)
	    if (!crypto && typeof global !== 'undefined' && global.crypto) {
	        crypto = global.crypto;
	    }

	    // Native crypto import via require (NodeJS)
	    if (!crypto && "function" === 'function') {
	        try {
	            crypto = __webpack_require__(2830);
	        } catch (err) {}
	    }

	    /*
	     * Cryptographically secure pseudorandom number generator
	     *
	     * As Math.random() is cryptographically not safe to use
	     */
	    var cryptoSecureRandomInt = function () {
	        if (crypto) {
	            // Use getRandomValues method (Browser)
	            if (typeof crypto.getRandomValues === 'function') {
	                try {
	                    return crypto.getRandomValues(new Uint32Array(1))[0];
	                } catch (err) {}
	            }

	            // Use randomBytes method (NodeJS)
	            if (typeof crypto.randomBytes === 'function') {
	                try {
	                    return crypto.randomBytes(4).readInt32LE();
	                } catch (err) {}
	            }
	        }

	        throw new Error('Native crypto module could not be used to get secure random number.');
	    };

	    /*
	     * Local polyfill of Object.create

	     */
	    var create = Object.create || (function () {
	        function F() {}

	        return function (obj) {
	            var subtype;

	            F.prototype = obj;

	            subtype = new F();

	            F.prototype = null;

	            return subtype;
	        };
	    }())

	    /**
	     * CryptoJS namespace.
	     */
	    var C = {};

	    /**
	     * Library namespace.
	     */
	    var C_lib = C.lib = {};

	    /**
	     * Base object for prototypal inheritance.
	     */
	    var Base = C_lib.Base = (function () {


	        return {
	            /**
	             * Creates a new object that inherits from this object.
	             *
	             * @param {Object} overrides Properties to copy into the new object.
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         field: 'value',
	             *
	             *         method: function () {
	             *         }
	             *     });
	             */
	            extend: function (overrides) {
	                // Spawn
	                var subtype = create(this);

	                // Augment
	                if (overrides) {
	                    subtype.mixIn(overrides);
	                }

	                // Create default initializer
	                if (!subtype.hasOwnProperty('init') || this.init === subtype.init) {
	                    subtype.init = function () {
	                        subtype.$super.init.apply(this, arguments);
	                    };
	                }

	                // Initializer's prototype is the subtype object
	                subtype.init.prototype = subtype;

	                // Reference supertype
	                subtype.$super = this;

	                return subtype;
	            },

	            /**
	             * Extends this object and runs the init method.
	             * Arguments to create() will be passed to init().
	             *
	             * @return {Object} The new object.
	             *
	             * @static
	             *
	             * @example
	             *
	             *     var instance = MyType.create();
	             */
	            create: function () {
	                var instance = this.extend();
	                instance.init.apply(instance, arguments);

	                return instance;
	            },

	            /**
	             * Initializes a newly created object.
	             * Override this method to add some logic when your objects are created.
	             *
	             * @example
	             *
	             *     var MyType = CryptoJS.lib.Base.extend({
	             *         init: function () {
	             *             // ...
	             *         }
	             *     });
	             */
	            init: function () {
	            },

	            /**
	             * Copies properties into this object.
	             *
	             * @param {Object} properties The properties to mix in.
	             *
	             * @example
	             *
	             *     MyType.mixIn({
	             *         field: 'value'
	             *     });
	             */
	            mixIn: function (properties) {
	                for (var propertyName in properties) {
	                    if (properties.hasOwnProperty(propertyName)) {
	                        this[propertyName] = properties[propertyName];
	                    }
	                }

	                // IE won't copy toString using the loop above
	                if (properties.hasOwnProperty('toString')) {
	                    this.toString = properties.toString;
	                }
	            },

	            /**
	             * Creates a copy of this object.
	             *
	             * @return {Object} The clone.
	             *
	             * @example
	             *
	             *     var clone = instance.clone();
	             */
	            clone: function () {
	                return this.init.prototype.extend(this);
	            }
	        };
	    }());

	    /**
	     * An array of 32-bit words.
	     *
	     * @property {Array} words The array of 32-bit words.
	     * @property {number} sigBytes The number of significant bytes in this word array.
	     */
	    var WordArray = C_lib.WordArray = Base.extend({
	        /**
	         * Initializes a newly created word array.
	         *
	         * @param {Array} words (Optional) An array of 32-bit words.
	         * @param {number} sigBytes (Optional) The number of significant bytes in the words.
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.create();
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607]);
	         *     var wordArray = CryptoJS.lib.WordArray.create([0x00010203, 0x04050607], 6);
	         */
	        init: function (words, sigBytes) {
	            words = this.words = words || [];

	            if (sigBytes != undefined) {
	                this.sigBytes = sigBytes;
	            } else {
	                this.sigBytes = words.length * 4;
	            }
	        },

	        /**
	         * Converts this word array to a string.
	         *
	         * @param {Encoder} encoder (Optional) The encoding strategy to use. Default: CryptoJS.enc.Hex
	         *
	         * @return {string} The stringified word array.
	         *
	         * @example
	         *
	         *     var string = wordArray + '';
	         *     var string = wordArray.toString();
	         *     var string = wordArray.toString(CryptoJS.enc.Utf8);
	         */
	        toString: function (encoder) {
	            return (encoder || Hex).stringify(this);
	        },

	        /**
	         * Concatenates a word array to this word array.
	         *
	         * @param {WordArray} wordArray The word array to append.
	         *
	         * @return {WordArray} This word array.
	         *
	         * @example
	         *
	         *     wordArray1.concat(wordArray2);
	         */
	        concat: function (wordArray) {
	            // Shortcuts
	            var thisWords = this.words;
	            var thatWords = wordArray.words;
	            var thisSigBytes = this.sigBytes;
	            var thatSigBytes = wordArray.sigBytes;

	            // Clamp excess bits
	            this.clamp();

	            // Concat
	            if (thisSigBytes % 4) {
	                // Copy one byte at a time
	                for (var i = 0; i < thatSigBytes; i++) {
	                    var thatByte = (thatWords[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                    thisWords[(thisSigBytes + i) >>> 2] |= thatByte << (24 - ((thisSigBytes + i) % 4) * 8);
	                }
	            } else {
	                // Copy one word at a time
	                for (var i = 0; i < thatSigBytes; i += 4) {
	                    thisWords[(thisSigBytes + i) >>> 2] = thatWords[i >>> 2];
	                }
	            }
	            this.sigBytes += thatSigBytes;

	            // Chainable
	            return this;
	        },

	        /**
	         * Removes insignificant bits.
	         *
	         * @example
	         *
	         *     wordArray.clamp();
	         */
	        clamp: function () {
	            // Shortcuts
	            var words = this.words;
	            var sigBytes = this.sigBytes;

	            // Clamp
	            words[sigBytes >>> 2] &= 0xffffffff << (32 - (sigBytes % 4) * 8);
	            words.length = Math.ceil(sigBytes / 4);
	        },

	        /**
	         * Creates a copy of this word array.
	         *
	         * @return {WordArray} The clone.
	         *
	         * @example
	         *
	         *     var clone = wordArray.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone.words = this.words.slice(0);

	            return clone;
	        },

	        /**
	         * Creates a word array filled with random bytes.
	         *
	         * @param {number} nBytes The number of random bytes to generate.
	         *
	         * @return {WordArray} The random word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.lib.WordArray.random(16);
	         */
	        random: function (nBytes) {
	            var words = [];

	            for (var i = 0; i < nBytes; i += 4) {
	                words.push(cryptoSecureRandomInt());
	            }

	            return new WordArray.init(words, nBytes);
	        }
	    });

	    /**
	     * Encoder namespace.
	     */
	    var C_enc = C.enc = {};

	    /**
	     * Hex encoding strategy.
	     */
	    var Hex = C_enc.Hex = {
	        /**
	         * Converts a word array to a hex string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The hex string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var hexString = CryptoJS.enc.Hex.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var hexChars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                hexChars.push((bite >>> 4).toString(16));
	                hexChars.push((bite & 0x0f).toString(16));
	            }

	            return hexChars.join('');
	        },

	        /**
	         * Converts a hex string to a word array.
	         *
	         * @param {string} hexStr The hex string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Hex.parse(hexString);
	         */
	        parse: function (hexStr) {
	            // Shortcut
	            var hexStrLength = hexStr.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < hexStrLength; i += 2) {
	                words[i >>> 3] |= parseInt(hexStr.substr(i, 2), 16) << (24 - (i % 8) * 4);
	            }

	            return new WordArray.init(words, hexStrLength / 2);
	        }
	    };

	    /**
	     * Latin1 encoding strategy.
	     */
	    var Latin1 = C_enc.Latin1 = {
	        /**
	         * Converts a word array to a Latin1 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Latin1 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var latin1String = CryptoJS.enc.Latin1.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;

	            // Convert
	            var latin1Chars = [];
	            for (var i = 0; i < sigBytes; i++) {
	                var bite = (words[i >>> 2] >>> (24 - (i % 4) * 8)) & 0xff;
	                latin1Chars.push(String.fromCharCode(bite));
	            }

	            return latin1Chars.join('');
	        },

	        /**
	         * Converts a Latin1 string to a word array.
	         *
	         * @param {string} latin1Str The Latin1 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Latin1.parse(latin1String);
	         */
	        parse: function (latin1Str) {
	            // Shortcut
	            var latin1StrLength = latin1Str.length;

	            // Convert
	            var words = [];
	            for (var i = 0; i < latin1StrLength; i++) {
	                words[i >>> 2] |= (latin1Str.charCodeAt(i) & 0xff) << (24 - (i % 4) * 8);
	            }

	            return new WordArray.init(words, latin1StrLength);
	        }
	    };

	    /**
	     * UTF-8 encoding strategy.
	     */
	    var Utf8 = C_enc.Utf8 = {
	        /**
	         * Converts a word array to a UTF-8 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The UTF-8 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var utf8String = CryptoJS.enc.Utf8.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            try {
	                return decodeURIComponent(escape(Latin1.stringify(wordArray)));
	            } catch (e) {
	                throw new Error('Malformed UTF-8 data');
	            }
	        },

	        /**
	         * Converts a UTF-8 string to a word array.
	         *
	         * @param {string} utf8Str The UTF-8 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Utf8.parse(utf8String);
	         */
	        parse: function (utf8Str) {
	            return Latin1.parse(unescape(encodeURIComponent(utf8Str)));
	        }
	    };

	    /**
	     * Abstract buffered block algorithm template.
	     *
	     * The property blockSize must be implemented in a concrete subtype.
	     *
	     * @property {number} _minBufferSize The number of blocks that should be kept unprocessed in the buffer. Default: 0
	     */
	    var BufferedBlockAlgorithm = C_lib.BufferedBlockAlgorithm = Base.extend({
	        /**
	         * Resets this block algorithm's data buffer to its initial state.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm.reset();
	         */
	        reset: function () {
	            // Initial values
	            this._data = new WordArray.init();
	            this._nDataBytes = 0;
	        },

	        /**
	         * Adds new data to this block algorithm's buffer.
	         *
	         * @param {WordArray|string} data The data to append. Strings are converted to a WordArray using UTF-8.
	         *
	         * @example
	         *
	         *     bufferedBlockAlgorithm._append('data');
	         *     bufferedBlockAlgorithm._append(wordArray);
	         */
	        _append: function (data) {
	            // Convert string to WordArray, else assume WordArray already
	            if (typeof data == 'string') {
	                data = Utf8.parse(data);
	            }

	            // Append
	            this._data.concat(data);
	            this._nDataBytes += data.sigBytes;
	        },

	        /**
	         * Processes available data blocks.
	         *
	         * This method invokes _doProcessBlock(offset), which must be implemented by a concrete subtype.
	         *
	         * @param {boolean} doFlush Whether all blocks and partial blocks should be processed.
	         *
	         * @return {WordArray} The processed data.
	         *
	         * @example
	         *
	         *     var processedData = bufferedBlockAlgorithm._process();
	         *     var processedData = bufferedBlockAlgorithm._process(!!'flush');
	         */
	        _process: function (doFlush) {
	            var processedWords;

	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;
	            var dataSigBytes = data.sigBytes;
	            var blockSize = this.blockSize;
	            var blockSizeBytes = blockSize * 4;

	            // Count blocks ready
	            var nBlocksReady = dataSigBytes / blockSizeBytes;
	            if (doFlush) {
	                // Round up to include partial blocks
	                nBlocksReady = Math.ceil(nBlocksReady);
	            } else {
	                // Round down to include only full blocks,
	                // less the number of blocks that must remain in the buffer
	                nBlocksReady = Math.max((nBlocksReady | 0) - this._minBufferSize, 0);
	            }

	            // Count words ready
	            var nWordsReady = nBlocksReady * blockSize;

	            // Count bytes ready
	            var nBytesReady = Math.min(nWordsReady * 4, dataSigBytes);

	            // Process blocks
	            if (nWordsReady) {
	                for (var offset = 0; offset < nWordsReady; offset += blockSize) {
	                    // Perform concrete-algorithm logic
	                    this._doProcessBlock(dataWords, offset);
	                }

	                // Remove processed words
	                processedWords = dataWords.splice(0, nWordsReady);
	                data.sigBytes -= nBytesReady;
	            }

	            // Return processed words
	            return new WordArray.init(processedWords, nBytesReady);
	        },

	        /**
	         * Creates a copy of this object.
	         *
	         * @return {Object} The clone.
	         *
	         * @example
	         *
	         *     var clone = bufferedBlockAlgorithm.clone();
	         */
	        clone: function () {
	            var clone = Base.clone.call(this);
	            clone._data = this._data.clone();

	            return clone;
	        },

	        _minBufferSize: 0
	    });

	    /**
	     * Abstract hasher template.
	     *
	     * @property {number} blockSize The number of 32-bit words this hasher operates on. Default: 16 (512 bits)
	     */
	    var Hasher = C_lib.Hasher = BufferedBlockAlgorithm.extend({
	        /**
	         * Configuration options.
	         */
	        cfg: Base.extend(),

	        /**
	         * Initializes a newly created hasher.
	         *
	         * @param {Object} cfg (Optional) The configuration options to use for this hash computation.
	         *
	         * @example
	         *
	         *     var hasher = CryptoJS.algo.SHA256.create();
	         */
	        init: function (cfg) {
	            // Apply config defaults
	            this.cfg = this.cfg.extend(cfg);

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this hasher to its initial state.
	         *
	         * @example
	         *
	         *     hasher.reset();
	         */
	        reset: function () {
	            // Reset data buffer
	            BufferedBlockAlgorithm.reset.call(this);

	            // Perform concrete-hasher logic
	            this._doReset();
	        },

	        /**
	         * Updates this hasher with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {Hasher} This hasher.
	         *
	         * @example
	         *
	         *     hasher.update('message');
	         *     hasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            // Append
	            this._append(messageUpdate);

	            // Update the hash
	            this._process();

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the hash computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The hash.
	         *
	         * @example
	         *
	         *     var hash = hasher.finalize();
	         *     var hash = hasher.finalize('message');
	         *     var hash = hasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Final message update
	            if (messageUpdate) {
	                this._append(messageUpdate);
	            }

	            // Perform concrete-hasher logic
	            var hash = this._doFinalize();

	            return hash;
	        },

	        blockSize: 512/32,

	        /**
	         * Creates a shortcut function to a hasher's object interface.
	         *
	         * @param {Hasher} hasher The hasher to create a helper for.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var SHA256 = CryptoJS.lib.Hasher._createHelper(CryptoJS.algo.SHA256);
	         */
	        _createHelper: function (hasher) {
	            return function (message, cfg) {
	                return new hasher.init(cfg).finalize(message);
	            };
	        },

	        /**
	         * Creates a shortcut function to the HMAC's object interface.
	         *
	         * @param {Hasher} hasher The hasher to use in this HMAC helper.
	         *
	         * @return {Function} The shortcut function.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var HmacSHA256 = CryptoJS.lib.Hasher._createHmacHelper(CryptoJS.algo.SHA256);
	         */
	        _createHmacHelper: function (hasher) {
	            return function (message, key) {
	                return new C_algo.HMAC.init(hasher, key).finalize(message);
	            };
	        }
	    });

	    /**
	     * Algorithm namespace.
	     */
	    var C_algo = C.algo = {};

	    return C;
	}(Math));


	return CryptoJS;

}));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var CharacterMetadata = __webpack_require__(133);

var findRangesImmutable = __webpack_require__(339);

var Immutable = __webpack_require__(46);

var List = Immutable.List,
    Map = Immutable.Map,
    OrderedSet = Immutable.OrderedSet,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat;
var EMPTY_SET = OrderedSet();
var defaultRecord = {
  key: '',
  type: 'unstyled',
  text: '',
  characterList: List(),
  depth: 0,
  data: Map()
};
var ContentBlockRecord = Record(defaultRecord);

var decorateCharacterList = function decorateCharacterList(config) {
  if (!config) {
    return config;
  }

  var characterList = config.characterList,
      text = config.text;

  if (text && !characterList) {
    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
  }

  return config;
};

var ContentBlock = /*#__PURE__*/function (_ContentBlockRecord) {
  _inheritsLoose(ContentBlock, _ContentBlockRecord);

  function ContentBlock(config) {
    return _ContentBlockRecord.call(this, decorateCharacterList(config)) || this;
  }

  var _proto = ContentBlock.prototype;

  _proto.getKey = function getKey() {
    return this.get('key');
  };

  _proto.getType = function getType() {
    return this.get('type');
  };

  _proto.getText = function getText() {
    return this.get('text');
  };

  _proto.getCharacterList = function getCharacterList() {
    return this.get('characterList');
  };

  _proto.getLength = function getLength() {
    return this.getText().length;
  };

  _proto.getDepth = function getDepth() {
    return this.get('depth');
  };

  _proto.getData = function getData() {
    return this.get('data');
  };

  _proto.getInlineStyleAt = function getInlineStyleAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getStyle() : EMPTY_SET;
  };

  _proto.getEntityAt = function getEntityAt(offset) {
    var character = this.getCharacterList().get(offset);
    return character ? character.getEntity() : null;
  }
  /**
   * Execute a callback for every contiguous range of styles within the block.
   */
  ;

  _proto.findStyleRanges = function findStyleRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
  }
  /**
   * Execute a callback for every contiguous range of entities within the block.
   */
  ;

  _proto.findEntityRanges = function findEntityRanges(filterFn, callback) {
    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
  };

  return ContentBlock;
}(ContentBlockRecord);

function haveEqualStyle(charA, charB) {
  return charA.getStyle() === charB.getStyle();
}

function haveEqualEntity(charA, charB) {
  return charA.getEntity() === charB.getEntity();
}

module.exports = ContentBlock;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function isElement(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  return node.nodeType === Node.ELEMENT_NODE;
}

module.exports = isElement;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * Unicode-enabled replacesments for basic String functions.
 *
 * All the functions in this module assume that the input string is a valid
 * UTF-16 encoding of a Unicode sequence. If it's not the case, the behavior
 * will be undefined.
 *
 * WARNING: Since this module is typechecks-enforced, you may find new bugs
 * when replacing normal String functions with ones provided here.
 */


var invariant = __webpack_require__(48); // These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
// surrogate code unit.


var SURROGATE_HIGH_START = 0xD800;
var SURROGATE_HIGH_END = 0xDBFF;
var SURROGATE_LOW_START = 0xDC00;
var SURROGATE_LOW_END = 0xDFFF;
var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;
/**
 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
 */

function isCodeUnitInSurrogateRange(codeUnit) {
  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
}
/**
 * Returns whether the two characters starting at `index` form a surrogate pair.
 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
 * (s, 1) returns false.
 *
 * @param {string} str
 * @param {number} index
 * @return {boolean}
 */


function isSurrogatePair(str, index) {
  !(0 <= index && index < str.length) ?  false ? invariant(false, 'isSurrogatePair: Invalid index %s for string length %s.', index, str.length) : invariant(false) : void 0;

  if (index + 1 === str.length) {
    return false;
  }

  var first = str.charCodeAt(index);
  var second = str.charCodeAt(index + 1);
  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
}
/**
 * @param {string} str  Non-empty string
 * @return {boolean}    True if the input includes any surrogate code units
 */


function hasSurrogateUnit(str) {
  return SURROGATE_UNITS_REGEX.test(str);
}
/**
 * Return the length of the original Unicode character at given position in the
 * String by looking into the UTF-16 code unit; that is equal to 1 for any
 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
 * representing non-BMP characters ([U+10000..U+10FFFF]).
 *
 * Examples:
 * - '\u0020' => 1
 * - '\u3020' => 1
 * - '\uD835' => 2
 * - '\uD835\uDDEF' => 2
 * - '\uDDEF' => 2
 *
 * @param {string} str  Non-empty string
 * @param {number} pos  Position in the string to look for one code unit
 * @return {number}      Number 1 or 2
 */


function getUTF16Length(str, pos) {
  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
}
/**
 * Fully Unicode-enabled replacement for String#length
 *
 * @param {string} str  Valid Unicode string
 * @return {number}     The number of Unicode characters in the string
 */


function strlen(str) {
  // Call the native functions if there's no surrogate char
  if (!hasSurrogateUnit(str)) {
    return str.length;
  }

  var len = 0;

  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    len++;
  }

  return len;
}
/**
 * Fully Unicode-enabled replacement for String#substr()
 *
 * @param {string} str      Valid Unicode string
 * @param {number} start    Location in Unicode sequence to begin extracting
 * @param {?number} length  The number of Unicode characters to extract
 *                          (default: to the end of the string)
 * @return {string}         Extracted sub-string
 */


function substr(str, start, length) {
  start = start || 0;
  length = length === undefined ? Infinity : length || 0; // Call the native functions if there's no surrogate char

  if (!hasSurrogateUnit(str)) {
    return str.substr(start, length);
  } // Obvious cases


  var size = str.length;

  if (size <= 0 || start > size || length <= 0) {
    return '';
  } // Find the actual starting position


  var posA = 0;

  if (start > 0) {
    for (; start > 0 && posA < size; start--) {
      posA += getUTF16Length(str, posA);
    }

    if (posA >= size) {
      return '';
    }
  } else if (start < 0) {
    for (posA = size; start < 0 && 0 < posA; start++) {
      posA -= getUTF16Length(str, posA - 1);
    }

    if (posA < 0) {
      posA = 0;
    }
  } // Find the actual ending position


  var posB = size;

  if (length < size) {
    for (posB = posA; length > 0 && posB < size; length--) {
      posB += getUTF16Length(str, posB);
    }
  }

  return str.substring(posA, posB);
}
/**
 * Fully Unicode-enabled replacement for String#substring()
 *
 * @param {string} str    Valid Unicode string
 * @param {number} start  Location in Unicode sequence to begin extracting
 * @param {?number} end   Location in Unicode sequence to end extracting
 *                        (default: end of the string)
 * @return {string}       Extracted sub-string
 */


function substring(str, start, end) {
  start = start || 0;
  end = end === undefined ? Infinity : end || 0;

  if (start < 0) {
    start = 0;
  }

  if (end < 0) {
    end = 0;
  }

  var length = Math.abs(end - start);
  start = start < end ? start : end;
  return substr(str, start, length);
}
/**
 * Get a list of Unicode code-points from a String
 *
 * @param {string} str        Valid Unicode string
 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
 */


function getCodePoints(str) {
  var codePoints = [];

  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
    codePoints.push(str.codePointAt(pos));
  }

  return codePoints;
}

var UnicodeUtils = {
  getCodePoints: getCodePoints,
  getUTF16Length: getUTF16Length,
  hasSurrogateUnit: hasSurrogateUnit,
  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
  isSurrogatePair: isSurrogatePair,
  strlen: strlen,
  substring: substring,
  substr: substr
};
module.exports = UnicodeUtils;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * This function is used to mark string literals representing CSS class names
 * so that they can be transformed statically. This allows for modularization
 * and minification of CSS class names.
 *
 * In static_upstream, this function is actually implemented, but it should
 * eventually be replaced with something more descriptive, and the transform
 * that is used in the main stack should be ported for use elsewhere.
 *
 * @param string|object className to modularize, or an object of key/values.
 *                      In the object case, the values are conditions that
 *                      determine if the className keys should be included.
 * @param [string ...]  Variable list of classNames in the string case.
 * @return string       Renderable space-separated CSS className.
 */
function cx(classNames) {
  if (typeof classNames == 'object') {
    return Object.keys(classNames).filter(function (className) {
      return classNames[className];
    }).map(replace).join(' ');
  }

  return Array.prototype.map.call(arguments, replace).join(' ');
}

function replace(str) {
  return str.replace(/\//g, '-');
}

module.exports = cx;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visit = visit;
exports.visitInParallel = visitInParallel;
exports.visitWithTypeInfo = visitWithTypeInfo;
exports.getVisitFn = getVisitFn;
exports.BREAK = exports.QueryDocumentKeys = void 0;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

/**
 * A visitor is comprised of visit functions, which are called on each node
 * during the visitor's traversal.
 */

/**
 * A KeyMap describes each the traversable properties of each kind of node.
 */
var QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields']
};
exports.QueryDocumentKeys = QueryDocumentKeys;
var BREAK = {};
/**
 * visit() will walk through an AST using a depth first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */

exports.BREAK = BREAK;

function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};

          for (var k in node) {
            if (node.hasOwnProperty(k)) {
              clone[k] = node[k];
            }
          }

          node = clone;
        }

        var editOffset = 0;

        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];

          if (inArray) {
            editKey -= editOffset;
          }

          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;

      if (node === null || node === undefined) {
        continue;
      }

      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;

    if (!Array.isArray(node)) {
      if (!isNode(node)) {
        throw new Error('Invalid AST Node: ' + JSON.stringify(node));
      }

      var visitFn = getVisitFn(visitor, node.kind, isLeaving);

      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);

          if (!isLeaving) {
            if (isNode(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      stack = {
        inArray: inArray,
        index: index,
        keys: keys,
        edits: edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : visitorKeys[node.kind] || [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}

function isNode(maybeNode) {
  return Boolean(maybeNode && typeof maybeNode.kind === 'string');
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */


function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);
  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          false);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (!skipping[i]) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          true);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}
/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */


function visitWithTypeInfo(typeInfo, visitor) {
  return {
    enter: function enter(node) {
      typeInfo.enter(node);
      var fn = getVisitFn(visitor, node.kind,
      /* isLeaving */
      false);

      if (fn) {
        var result = fn.apply(visitor, arguments);

        if (result !== undefined) {
          typeInfo.leave(node);

          if (isNode(result)) {
            typeInfo.enter(result);
          }
        }

        return result;
      }
    },
    leave: function leave(node) {
      var fn = getVisitFn(visitor, node.kind,
      /* isLeaving */
      true);
      var result;

      if (fn) {
        result = fn.apply(visitor, arguments);
      }

      typeInfo.leave(node);
      return result;
    }
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */


function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];

  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }

    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }

      var specificKindVisitor = specificVisitor[kind];

      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSchema = isSchema;
exports.GraphQLSchema = void 0;

var _definition = __webpack_require__(54);

var _directives = __webpack_require__(136);

var _inspect = _interopRequireDefault(__webpack_require__(93));

var _introspection = __webpack_require__(166);

var _defineToStringTag = _interopRequireDefault(__webpack_require__(438));

var _find = _interopRequireDefault(__webpack_require__(342));

var _instanceOf = _interopRequireDefault(__webpack_require__(659));

var _invariant = _interopRequireDefault(__webpack_require__(108));

var _objectValues = _interopRequireDefault(__webpack_require__(205));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// eslint-disable-next-line no-redeclare
function isSchema(schema) {
  return (0, _instanceOf.default)(schema, GraphQLSchema);
}
/**
 * Schema Definition
 *
 * A Schema is created by supplying the root types of each type of operation,
 * query and mutation (optional). A schema definition is then supplied to the
 * validator and executor.
 *
 * Example:
 *
 *     const MyAppSchema = new GraphQLSchema({
 *       query: MyAppQueryRootType,
 *       mutation: MyAppMutationRootType,
 *     })
 *
 * Note: If an array of `directives` are provided to GraphQLSchema, that will be
 * the exact list of directives represented and allowed. If `directives` is not
 * provided then a default set of the specified directives (e.g. @include and
 * @skip) will be used. If you wish to provide *additional* directives to these
 * specified directives, you must explicitly declare them. Example:
 *
 *     const MyAppSchema = new GraphQLSchema({
 *       ...
 *       directives: specifiedDirectives.concat([ myCustomDirective ]),
 *     })
 *
 */


var GraphQLSchema =
/*#__PURE__*/
function () {
  // Used as a cache for validateSchema().
  // Referenced by validateSchema().
  function GraphQLSchema(config) {
    _defineProperty(this, "astNode", void 0);

    _defineProperty(this, "extensionASTNodes", void 0);

    _defineProperty(this, "_queryType", void 0);

    _defineProperty(this, "_mutationType", void 0);

    _defineProperty(this, "_subscriptionType", void 0);

    _defineProperty(this, "_directives", void 0);

    _defineProperty(this, "_typeMap", void 0);

    _defineProperty(this, "_implementations", void 0);

    _defineProperty(this, "_possibleTypeMap", void 0);

    _defineProperty(this, "__validationErrors", void 0);

    _defineProperty(this, "__allowedLegacyNames", void 0);

    // If this schema was built from a source known to be valid, then it may be
    // marked with assumeValid to avoid an additional type system validation.
    if (config && config.assumeValid) {
      this.__validationErrors = [];
    } else {
      // Otherwise check for common mistakes during construction to produce
      // clear and early error messages.
      !(_typeof(config) === 'object') ? (0, _invariant.default)(0, 'Must provide configuration object.') : void 0;
      !(!config.types || Array.isArray(config.types)) ? (0, _invariant.default)(0, "\"types\" must be Array if provided but got: ".concat((0, _inspect.default)(config.types), ".")) : void 0;
      !(!config.directives || Array.isArray(config.directives)) ? (0, _invariant.default)(0, '"directives" must be Array if provided but got: ' + "".concat((0, _inspect.default)(config.directives), ".")) : void 0;
      !(!config.allowedLegacyNames || Array.isArray(config.allowedLegacyNames)) ? (0, _invariant.default)(0, '"allowedLegacyNames" must be Array if provided but got: ' + "".concat((0, _inspect.default)(config.allowedLegacyNames), ".")) : void 0;
    }

    this.__allowedLegacyNames = config.allowedLegacyNames || [];
    this._queryType = config.query;
    this._mutationType = config.mutation;
    this._subscriptionType = config.subscription; // Provide specified directives (e.g. @include and @skip) by default.

    this._directives = config.directives || _directives.specifiedDirectives;
    this.astNode = config.astNode;
    this.extensionASTNodes = config.extensionASTNodes; // Build type map now to detect any errors within this schema.

    var initialTypes = [this.getQueryType(), this.getMutationType(), this.getSubscriptionType(), _introspection.__Schema];
    var types = config.types;

    if (types) {
      initialTypes = initialTypes.concat(types);
    } // Keep track of all types referenced within the schema.


    var typeMap = Object.create(null); // First by deeply visiting all initial types.

    typeMap = initialTypes.reduce(typeMapReducer, typeMap); // Then by deeply visiting all directive types.

    typeMap = this._directives.reduce(typeMapDirectiveReducer, typeMap); // Storing the resulting map for reference by the schema.

    this._typeMap = typeMap; // Keep track of all implementations by interface name.

    this._implementations = Object.create(null);

    var _arr = Object.keys(this._typeMap);

    for (var _i = 0; _i < _arr.length; _i++) {
      var typeName = _arr[_i];
      var type = this._typeMap[typeName];

      if ((0, _definition.isObjectType)(type)) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = type.getInterfaces()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var iface = _step.value;

            if ((0, _definition.isInterfaceType)(iface)) {
              var impls = this._implementations[iface.name];

              if (impls) {
                impls.push(type);
              } else {
                this._implementations[iface.name] = [type];
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      } else if ((0, _definition.isAbstractType)(type) && !this._implementations[type.name]) {
        this._implementations[type.name] = [];
      }
    }
  }

  var _proto = GraphQLSchema.prototype;

  _proto.getQueryType = function getQueryType() {
    return this._queryType;
  };

  _proto.getMutationType = function getMutationType() {
    return this._mutationType;
  };

  _proto.getSubscriptionType = function getSubscriptionType() {
    return this._subscriptionType;
  };

  _proto.getTypeMap = function getTypeMap() {
    return this._typeMap;
  };

  _proto.getType = function getType(name) {
    return this.getTypeMap()[name];
  };

  _proto.getPossibleTypes = function getPossibleTypes(abstractType) {
    if ((0, _definition.isUnionType)(abstractType)) {
      return abstractType.getTypes();
    }

    return this._implementations[abstractType.name];
  };

  _proto.isPossibleType = function isPossibleType(abstractType, possibleType) {
    var possibleTypeMap = this._possibleTypeMap;

    if (!possibleTypeMap) {
      this._possibleTypeMap = possibleTypeMap = Object.create(null);
    }

    if (!possibleTypeMap[abstractType.name]) {
      var possibleTypes = this.getPossibleTypes(abstractType);
      possibleTypeMap[abstractType.name] = possibleTypes.reduce(function (map, type) {
        return map[type.name] = true, map;
      }, Object.create(null));
    }

    return Boolean(possibleTypeMap[abstractType.name][possibleType.name]);
  };

  _proto.getDirectives = function getDirectives() {
    return this._directives;
  };

  _proto.getDirective = function getDirective(name) {
    return (0, _find.default)(this.getDirectives(), function (directive) {
      return directive.name === name;
    });
  };

  return GraphQLSchema;
}(); // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported


exports.GraphQLSchema = GraphQLSchema;
(0, _defineToStringTag.default)(GraphQLSchema);

function typeMapReducer(map, type) {
  if (!type) {
    return map;
  }

  if ((0, _definition.isWrappingType)(type)) {
    return typeMapReducer(map, type.ofType);
  }

  if (map[type.name]) {
    !(map[type.name] === type) ? (0, _invariant.default)(0, 'Schema must contain unique named types but contains multiple ' + "types named \"".concat(type.name, "\".")) : void 0;
    return map;
  }

  map[type.name] = type;
  var reducedMap = map;

  if ((0, _definition.isUnionType)(type)) {
    reducedMap = type.getTypes().reduce(typeMapReducer, reducedMap);
  }

  if ((0, _definition.isObjectType)(type)) {
    reducedMap = type.getInterfaces().reduce(typeMapReducer, reducedMap);
  }

  if ((0, _definition.isObjectType)(type) || (0, _definition.isInterfaceType)(type)) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = (0, _objectValues.default)(type.getFields())[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var field = _step2.value;

        if (field.args) {
          var fieldArgTypes = field.args.map(function (arg) {
            return arg.type;
          });
          reducedMap = fieldArgTypes.reduce(typeMapReducer, reducedMap);
        }

        reducedMap = typeMapReducer(reducedMap, field.type);
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

  if ((0, _definition.isInputObjectType)(type)) {
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = (0, _objectValues.default)(type.getFields())[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var _field = _step3.value;
        reducedMap = typeMapReducer(reducedMap, _field.type);
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }
  }

  return reducedMap;
}

function typeMapDirectiveReducer(map, directive) {
  // Directives are not validated until validateSchema() is called.
  if (!(0, _directives.isDirective)(directive)) {
    return map;
  }

  return directive.args.reduce(function (_map, arg) {
    return typeMapReducer(_map, arg.type);
  }, map);
}

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.



/*<replacement>*/

var pna = __webpack_require__(455);
/*</replacement>*/

/*<replacement>*/
var objectKeys = Object.keys || function (obj) {
  var keys = [];
  for (var key in obj) {
    keys.push(key);
  }return keys;
};
/*</replacement>*/

module.exports = Duplex;

/*<replacement>*/
var util = __webpack_require__(335);
util.inherits = __webpack_require__(41);
/*</replacement>*/

var Readable = __webpack_require__(1426);
var Writable = __webpack_require__(696);

util.inherits(Duplex, Readable);

{
  // avoid scope creep, the keys array can then be collected
  var keys = objectKeys(Writable.prototype);
  for (var v = 0; v < keys.length; v++) {
    var method = keys[v];
    if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
  }
}

function Duplex(options) {
  if (!(this instanceof Duplex)) return new Duplex(options);

  Readable.call(this, options);
  Writable.call(this, options);

  if (options && options.readable === false) this.readable = false;

  if (options && options.writable === false) this.writable = false;

  this.allowHalfOpen = true;
  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;

  this.once('end', onend);
}

Object.defineProperty(Duplex.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// the no-half-open enforcer
function onend() {
  // if we allow half-open state, or if the writable side ended,
  // then we're ok.
  if (this.allowHalfOpen || this._writableState.ended) return;

  // no more data can be written.
  // But allow more writes to happen in this tick.
  pna.nextTick(onEndNT, this);
}

function onEndNT(self) {
  self.end();
}

Object.defineProperty(Duplex.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined || this._writableState === undefined) {
      return false;
    }
    return this._readableState.destroyed && this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (this._readableState === undefined || this._writableState === undefined) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
    this._writableState.destroyed = value;
  }
});

Duplex.prototype._destroy = function (err, cb) {
  this.push(null);
  this.end();

  pna.nextTick(cb, err);
};

/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Image__ = __webpack_require__(1466);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Image__["a"]; });



/***/ }),
/* 250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseForOwn_js__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createBaseEach_js__ = __webpack_require__(3381);



/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createBaseEach_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseForOwn_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (baseEach);


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overRest_js__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(749);




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__overRest_js__["a" /* default */])(func, start, __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */]), func + '');
}

/* harmony default export */ __webpack_exports__["a"] = (baseRest);


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(3356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__(3404);



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */
function isUndefined(value) {
  return value === undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (isUndefined);


/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ALGORITHM_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CREDENTIAL_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AMZ_DATE_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SIGNED_HEADERS_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EXPIRES_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SIGNATURE_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TOKEN_QUERY_PARAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return AUTH_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return AMZ_DATE_HEADER; });
/* unused harmony export DATE_HEADER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return GENERATED_HEADERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return SIGNATURE_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SHA256_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return TOKEN_HEADER; });
/* unused harmony export HOST_HEADER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return ALWAYS_UNSIGNABLE_HEADERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return PROXY_HEADER_PATTERN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return SEC_HEADER_PATTERN; });
/* unused harmony export UNSIGNABLE_PATTERNS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ALGORITHM_IDENTIFIER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return EVENT_ALGORITHM_IDENTIFIER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return UNSIGNED_PAYLOAD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return MAX_CACHE_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return KEY_TYPE_IDENTIFIER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAX_PRESIGNED_TTL; });
var ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
var CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
var AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
var SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
var EXPIRES_QUERY_PARAM = "X-Amz-Expires";
var SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
var TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
var AUTH_HEADER = "authorization";
var AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
var DATE_HEADER = "date";
var GENERATED_HEADERS = [AUTH_HEADER, AMZ_DATE_HEADER, DATE_HEADER];
var SIGNATURE_HEADER = SIGNATURE_QUERY_PARAM.toLowerCase();
var SHA256_HEADER = "x-amz-content-sha256";
var TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
var HOST_HEADER = "host";
var ALWAYS_UNSIGNABLE_HEADERS = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true,
};
var PROXY_HEADER_PATTERN = /^proxy-/;
var SEC_HEADER_PATTERN = /^sec-/;
var UNSIGNABLE_PATTERNS = [/^proxy-/i, /^sec-/i];
var ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
var EVENT_ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256-PAYLOAD";
var UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";
var MAX_CACHE_SIZE = 50;
var KEY_TYPE_IDENTIFIER = "aws4_request";
var MAX_PRESIGNED_TTL = 60 * 60 * 24 * 7;
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(214)["default"];
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(1779);
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiagAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__diag_ComponentLogger__ = __webpack_require__(1893);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__diag_internal_logLevelLogger__ = __webpack_require__(1895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__diag_types__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_global_utils__ = __webpack_require__(258);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};




var API_NAME = 'diag';
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */
var DiagAPI = /** @class */ (function () {
    /**
     * Private internal constructor
     * @private
     */
    function DiagAPI() {
        function _logProxy(funcName) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var logger = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__internal_global_utils__["b" /* getGlobal */])('diag');
                // shortcut if logger not set
                if (!logger)
                    return;
                return logger[funcName].apply(logger, __spreadArray([], __read(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function (logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) { optionsOrLogLevel = { logLevel: __WEBPACK_IMPORTED_MODULE_2__diag_types__["a" /* DiagLogLevel */].INFO }; }
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') {
                optionsOrLogLevel = {
                    logLevel: optionsOrLogLevel,
                };
            }
            var oldLogger = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__internal_global_utils__["b" /* getGlobal */])('diag');
            var newLogger = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__diag_internal_logLevelLogger__["a" /* createLogLevelDiagLogger */])((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : __WEBPACK_IMPORTED_MODULE_2__diag_types__["a" /* DiagLogLevel */].INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__internal_global_utils__["a" /* registerGlobal */])('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function () {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__internal_global_utils__["c" /* unregisterGlobal */])(API_NAME, self);
        };
        self.createComponentLogger = function (options) {
            return new __WEBPACK_IMPORTED_MODULE_0__diag_ComponentLogger__["a" /* DiagComponentLogger */](options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
    /** Get the singleton instance of the DiagAPI API */
    DiagAPI.instance = function () {
        if (!this._instance) {
            this._instance = new DiagAPI();
        }
        return this._instance;
    };
    return DiagAPI;
}());

//# sourceMappingURL=diag.js.map

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerGlobal;
/* harmony export (immutable) */ __webpack_exports__["b"] = getGlobal;
/* harmony export (immutable) */ __webpack_exports__["c"] = unregisterGlobal;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform__ = __webpack_require__(1901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__version__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__semver__ = __webpack_require__(1896);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



var major = __WEBPACK_IMPORTED_MODULE_1__version__["a" /* VERSION */].split('.')[0];
var GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + major);
var _global = __WEBPACK_IMPORTED_MODULE_0__platform__["a" /* _globalThis */];
function registerGlobal(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) { allowOverride = false; }
    var api = (_global[GLOBAL_OPENTELEMETRY_API_KEY] = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: __WEBPACK_IMPORTED_MODULE_1__version__["a" /* VERSION */],
    });
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== __WEBPACK_IMPORTED_MODULE_1__version__["a" /* VERSION */]) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + __WEBPACK_IMPORTED_MODULE_1__version__["a" /* VERSION */]);
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + __WEBPACK_IMPORTED_MODULE_1__version__["a" /* VERSION */] + ".");
    return true;
}
function getGlobal(type) {
    var _a, _b;
    var globalVersion = (_a = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__semver__["a" /* isCompatible */])(globalVersion)) {
        return;
    }
    return (_b = _global[GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function unregisterGlobal(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + __WEBPACK_IMPORTED_MODULE_1__version__["a" /* VERSION */] + ".");
    var api = _global[GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) {
        delete api[type];
    }
}
//# sourceMappingURL=global-utils.js.map

/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WebTracerProvider__ = __webpack_require__(2017);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "WebTracerProvider", function() { return __WEBPACK_IMPORTED_MODULE_0__WebTracerProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StackContextManager__ = __webpack_require__(941);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "StackContextManager", function() { return __WEBPACK_IMPORTED_MODULE_1__StackContextManager__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums_PerformanceTimingNames__ = __webpack_require__(942);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "PerformanceTimingNames", function() { return __WEBPACK_IMPORTED_MODULE_2__enums_PerformanceTimingNames__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(2018);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addSpanNetworkEvent", function() { return __WEBPACK_IMPORTED_MODULE_3__utils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "addSpanNetworkEvents", function() { return __WEBPACK_IMPORTED_MODULE_3__utils__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getElementXPath", function() { return __WEBPACK_IMPORTED_MODULE_3__utils__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getResource", function() { return __WEBPACK_IMPORTED_MODULE_3__utils__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hasKey", function() { return __WEBPACK_IMPORTED_MODULE_3__utils__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "normalizeUrl", function() { return __WEBPACK_IMPORTED_MODULE_3__utils__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parseUrl", function() { return __WEBPACK_IMPORTED_MODULE_3__utils__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "shouldPropagateTraceHeaders", function() { return __WEBPACK_IMPORTED_MODULE_3__utils__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "sortResources", function() { return __WEBPACK_IMPORTED_MODULE_3__utils__["i"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_base__ = __webpack_require__(538);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AlwaysOffSampler", function() { return __WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_base__["AlwaysOffSampler"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AlwaysOnSampler", function() { return __WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_base__["AlwaysOnSampler"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BasicTracerProvider", function() { return __WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_base__["BasicTracerProvider"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BatchSpanProcessor", function() { return __WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_base__["BatchSpanProcessor"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ConsoleSpanExporter", function() { return __WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_base__["ConsoleSpanExporter"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ForceFlushState", function() { return __WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_base__["ForceFlushState"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InMemorySpanExporter", function() { return __WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_base__["InMemorySpanExporter"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NoopSpanProcessor", function() { return __WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_base__["NoopSpanProcessor"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ParentBasedSampler", function() { return __WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_base__["ParentBasedSampler"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RandomIdGenerator", function() { return __WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_base__["RandomIdGenerator"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SamplingDecision", function() { return __WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_base__["SamplingDecision"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SimpleSpanProcessor", function() { return __WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_base__["SimpleSpanProcessor"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Span", function() { return __WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_base__["Span"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TraceIdRatioBasedSampler", function() { return __WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_base__["TraceIdRatioBasedSampler"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tracer", function() { return __WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_base__["Tracer"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





//# sourceMappingURL=index.js.map

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */


var BookingTitle = function (_Component) {
  _inherits(BookingTitle, _Component);

  function BookingTitle(props) {
    _classCallCheck(this, BookingTitle);

    var _this = _possibleConstructorReturn(this, (BookingTitle.__proto__ || Object.getPrototypeOf(BookingTitle)).call(this, props));

    var state = BookingTitle.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(BookingTitle, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = BookingTitle.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var isMobile = this.props.isMobile;
      var data = this.state.data;

      var columnStyle = { paddingBottom: '0' };
      if (isMobile) columnStyle.padding = '0';
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { style: { paddingBottom: '0' } },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'center', style: columnStyle },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _semanticUiReact.Header,
                { as: 'h3', style: { marginBottom: '0' } },
                data && data.projectUnit && data.projectUnit.reference ? data.projectUnit.reference : ''
              ),
              _react2.default.createElement(
                'b',
                null,
                data && data.project && data.project.name ? data.project.name : ''
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'span',
                null,
                data && data.code ? data.code : ''
              )
            )
          )
        )
      );
    }
  }]);

  return BookingTitle;
}(_react.Component);

BookingTitle.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]).isRequired,
  isMobile: _propTypes2.default.bool
};
BookingTitle.defaultProps = {
  isMobile: false
};

BookingTitle.getPropsToState = function (props) {
  var data = props.data;
  return {
    data: data
  };
};

exports.default = BookingTitle;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18next = __webpack_require__(94);

var _i18next2 = _interopRequireDefault(_i18next);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = {
  colRight: { textAlign: 'right', margin: 'auto' },
  textInline: { display: 'inline-block' }
};

var ListItem = function ListItem(_ref) {
  var className = _ref.className,
      _onClick = _ref.onClick,
      onPoint = _ref.onPoint,
      item = _ref.item,
      header = _ref.header,
      subheader = _ref.subheader,
      selected = _ref.selected,
      disabled = _ref.disabled,
      checkable = _ref.checkable,
      leftComponent = _ref.leftComponent,
      rightComponent = _ref.rightComponent,
      leftComponentTextAlign = _ref.leftComponentTextAlign,
      rightComponentTextAlign = _ref.rightComponentTextAlign,
      totalCountUnitAllocated = _ref.totalCountUnitAllocated;
  return _react2.default.createElement(
    _semanticUiReact.Grid,
    {
      columns: 'equal',
      verticalAlign: 'middle',
      className: className,
      onClick: function onClick(event) {
        if (!disabled && _onClick) {
          _onClick(event, item);
        }
      }
    },
    checkable ? _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { textAlign: 'center', mobile: 3, tablet: 2, computer: 2 },
      _react2.default.createElement(_semanticUiReact.Checkbox, {
        checked: selected,
        disabled: disabled,
        readOnly: true
      })
    ) : null,
    leftComponent ? _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { textAlign: leftComponentTextAlign || 'center', mobile: 3, tablet: 2, computer: 2 },
      leftComponent
    ) : null,
    _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid,
        { columns: 1 },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { columns: 'equal' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  {
                    as: 'h4',
                    className: 'clickable',
                    onClick: onPoint
                  },
                  header ? header(item) : item.preferredName,
                  subheader ? _react2.default.createElement(
                    _semanticUiReact.Header.Subheader,
                    null,
                    subheader(item)
                  ) : null
                )
              ),
              totalCountUnitAllocated ? _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { style: styles.colRight },
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  {
                    as: 'h4'
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Header.Subheader,
                    { style: styles.textInline },
                    _i18next2.default.t('Total Unit Allocated', { ns: 'translation' }),
                    ' : \xA0'
                  ),
                  totalCountUnitAllocated ? totalCountUnitAllocated.totalUnitAllocated !== 0 ? totalCountUnitAllocated.totalUnitAllocated : _i18next2.default.t('All Units', { ns: 'translation' }) : 'NaN'
                )
              ) : ''
            )
          )
        )
      )
    ),
    rightComponent ? _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { textAlign: rightComponentTextAlign || 'center', mobile: 3, tablet: 2, computer: rightComponent ? 2 : 1 },
      rightComponent
    ) : null
  );
};

ListItem.propTypes = {
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  onPoint: _propTypes2.default.func,
  selected: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  checkable: _propTypes2.default.bool,
  item: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  header: _propTypes2.default.func,
  subheader: _propTypes2.default.func,
  leftComponent: _propTypes2.default.node,
  rightComponent: _propTypes2.default.node,
  leftComponentTextAlign: _propTypes2.default.string,
  rightComponentTextAlign: _propTypes2.default.string,
  totalCountUnitAllocated: _propTypes2.default.shape({
    projectID: _propTypes2.default.string,
    projectName: _propTypes2.default.string,
    totalUnitAllocated: _propTypes2.default.number
  })
};

exports.default = ListItem;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cancellationCategoryLabel = exports.CANCELLATION_CATEGORIES = exports.CANCELLATION_REASON_MAX_LENGTH = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _translation = __webpack_require__(4);

var _opportunityStatuses = __webpack_require__(195);

var _cancellationReasonCategory = __webpack_require__(2574);

var _vietnam = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/label-has-for */
// The <label>s are lifted verbatim from the CRM's own cancel modal, which has the same exemption.


var CANCELLATION_REASON_MAX_LENGTH = exports.CANCELLATION_REASON_MAX_LENGTH = 500;

// CPI-1226: the two fixed cancellation scenarios. `value` is the wire value sent as
// sr_cancellation_type (from utils/cancellationReasonCategory); `label` doubles as the i18n key.
var CANCELLATION_CATEGORIES = exports.CANCELLATION_CATEGORIES = [{ value: _cancellationReasonCategory.CANCELLATION_CATEGORY_BUYER, label: 'Cancellation due to Buyer' }, { value: _cancellationReasonCategory.CANCELLATION_CATEGORY_ERROR, label: 'Cancellation due to Error' }];

// Look-up for a stored cancellation; '' for an absent or unrecognised value.
var cancellationCategoryLabel = exports.cancellationCategoryLabel = function cancellationCategoryLabel(value) {
  return (CANCELLATION_CATEGORIES.find(function (category) {
    return category.value === value;
  }) || {}).label || '';
};

// Lifted out of OpportunityOverviewDetail.jsx so the CRM screen and Sales Overview share one modal.

var OpportunityCancelModal = function (_Component) {
  _inherits(OpportunityCancelModal, _Component);

  function OpportunityCancelModal(props) {
    _classCallCheck(this, OpportunityCancelModal);

    var _this = _possibleConstructorReturn(this, (OpportunityCancelModal.__proto__ || Object.getPrototypeOf(OpportunityCancelModal)).call(this, props));

    _this.reasonList = function () {
      var _this$props = _this.props,
          auth = _this$props.auth,
          cancellationReasons = _this$props.cancellationReasons;

      return (0, _cancellationReasonCategory.visibleCancellationReasons)(auth, cancellationReasons && cancellationReasons.data || []);
    };

    _this.handleExistingReasonChange = function (e, _ref) {
      var value = _ref.value;

      var reasons = _this.reasonList();
      // Sliced like handleReasonChange caps typing, or the box arrives already invalid.
      var reasonText = function reasonText(id) {
        return String((reasons.find(function (reason) {
          return reason && reason.id === id;
        }) || {}).name || '').slice(0, CANCELLATION_REASON_MAX_LENGTH);
      };
      var pickedName = reasonText(value);
      var category = (0, _cancellationReasonCategory.cancellationCategoryForReasonID)(reasons, value);
      _this.setState(function (state) {
        // The free text is filled in for them only while it is untouched.
        var textIsUntouched = !state.cancellationReason.trim() || !!state.cancellationReasonID && state.cancellationReason === reasonText(state.cancellationReasonID);
        return {
          cancellationReasonID: value,
          cancellationCategory: category || state.cancellationCategory,
          cancellationReason: textIsUntouched ? pickedName : state.cancellationReason
        };
      });
    };

    _this.handleChoiceChange = function (e, _ref2) {
      var value = _ref2.value;

      var reasons = _this.reasonList();
      var reasonText = function reasonText(id) {
        return String((reasons.find(function (reason) {
          return reason && reason.id === id;
        }) || {}).name || '').slice(0, CANCELLATION_REASON_MAX_LENGTH);
      };
      var reasonID = (0, _cancellationReasonCategory.cancellationReasonIDForChoice)(value);
      var category = (0, _cancellationReasonCategory.cancellationCategoryForChoice)(reasons, value);
      var pickedName = reasonText(reasonID);
      _this.setState(function (state) {
        var textIsUntouched = !state.cancellationReason.trim() || !!state.cancellationReasonID && state.cancellationReason === reasonText(state.cancellationReasonID);
        return {
          cancellationChoice: value,
          cancellationReasonID: reasonID,
          cancellationCategory: category || state.cancellationCategory,
          cancellationReason: textIsUntouched ? pickedName : state.cancellationReason
        };
      });
    };

    _this.handleCategoryChange = function (e, _ref3) {
      var value = _ref3.value;

      _this.setState({ cancellationCategory: value });
    };

    _this.handleReasonChange = function (e) {
      var inputValue = e.target.value;
      if (inputValue.length <= CANCELLATION_REASON_MAX_LENGTH) {
        _this.setState({ cancellationReason: inputValue });
      }
    };

    _this.handleClose = function () {
      _this.setState({
        cancellationChoice: '',
        cancellationReasonID: '',
        cancellationCategory: '',
        cancellationReason: ''
      });
      if (_this.props.onClose) _this.props.onClose();
    };

    _this.handleSubmit = function () {
      var onSubmit = _this.props.onSubmit;
      var _this$state = _this.state,
          cancellationCategory = _this$state.cancellationCategory,
          cancellationReason = _this$state.cancellationReason;

      if (onSubmit && cancellationCategory && cancellationReason.trim()) {
        onSubmit(_opportunityStatuses.OPPORTUNITY_STATUS.PENDING_CANCELLATION, cancellationReason.trim(), cancellationCategory);
      }
      _this.handleClose();
    };

    _this.state = {
      // CPI-1226 post-fix: what the Vietnamese dropdown holds - either a synthesized category
      // option or a master-list row id. Malaysia does not use it; it keeps the two selects.
      cancellationChoice: '',
      cancellationReasonID: '',
      cancellationCategory: '',
      cancellationReason: ''
    };
    return _this;
  }
  // CPI-1226 post-fix: filtered to the rows this country may offer - one in Vietnam, the whole
  // list everywhere else - so the dropdown, the free text it fills in and the category it sets all
  // read the same rows.

  // CPI-1226 (PO, 5 Sep): picking a tenant reason pre-selects the category; the rule lives in
  // utils/cancellationReasonCategory. It never clears a chosen category nor overwrites typed text.

  // CPI-1226 post-fix: Vietnam's single dropdown. A synthesized category option carries the
  // category in its own value, so picking one sets sr_cancellation_type directly and refers to no
  // master-list row; picking the developer row sets the category the way it always did and fills
  // the free text with the row's name. Switching from the row to a category clears that prefill
  // (a category has no name to copy), which puts Submit back to dead until the reason is written.


  _createClass(OpportunityCancelModal, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          auth = _props.auth,
          open = _props.open,
          srCode = _props.srCode,
          t = _props.t;
      var _state = this.state,
          cancellationChoice = _state.cancellationChoice,
          cancellationReasonID = _state.cancellationReasonID,
          cancellationCategory = _state.cancellationCategory,
          cancellationReason = _state.cancellationReason;

      var isVietnam = (0, _vietnam.isVietnamCompany)(auth);
      var characterCount = cancellationReason.length;
      var isInvalid = !cancellationCategory || characterCount === 0 || characterCount > CANCELLATION_REASON_MAX_LENGTH;
      var categoryOptions = CANCELLATION_CATEGORIES.map(function (_ref4) {
        var value = _ref4.value,
            label = _ref4.label;
        return {
          key: value,
          value: value,
          text: t(label, { ns: _translation.TRANSLATION_FILES.translation })
        };
      });
      // Admin-editable rows: name is the label, id is the value; hidden when the company has none.
      var existingReasonOptions = this.reasonList().map(function (reason) {
        return { key: reason.id, value: reason.id, text: reason.name };
      });
      // CPI-1226 post-fix: Vietnam gets ONE dropdown of exactly three entries - the two categories
      // above, then the tenant's existing "Cancelled by Developer" row. Malaysia keeps the two
      // selects it has, with the same options in the same order.
      var vnChoiceOptions = categoryOptions.map(function (option) {
        return _extends({}, option, {
          key: 'category-' + option.value,
          value: (0, _cancellationReasonCategory.cancellationCategoryOptionValue)(option.value)
        });
      }).concat(existingReasonOptions);
      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          open: open,
          onClose: this.handleClose,
          size: 'small',
          className: 'cancellation-reason-modal',
          closeIcon: true
        },
        _react2.default.createElement(
          _semanticUiReact.Modal.Header,
          { className: 'modal-title' },
          t('Request cancellation', { ns: _translation.TRANSLATION_FILES.translation })
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { className: 'modal-body-content' },
          _react2.default.createElement(
            _semanticUiReact.Form,
            null,
            _react2.default.createElement(
              _semanticUiReact.Form.Field,
              { className: 'field-booking-id' },
              _react2.default.createElement(
                'label',
                null,
                t('Booking ID', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(
                'div',
                { className: 'read-only-box' },
                srCode || '-'
              )
            ),
            !isVietnam && existingReasonOptions.length > 0 && _react2.default.createElement(_semanticUiReact.Form.Select, {
              label: _react2.default.createElement(
                'label',
                null,
                t('Existing cancellation reason', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              options: existingReasonOptions,
              value: cancellationReasonID,
              onChange: this.handleExistingReasonChange,
              placeholder: t('Select an existing reason (optional)', { ns: _translation.TRANSLATION_FILES.translation }),
              selectOnBlur: false
            }),
            _react2.default.createElement(_semanticUiReact.Form.Select, {
              label: _react2.default.createElement(
                'label',
                null,
                t('Cancellation category', { ns: _translation.TRANSLATION_FILES.translation }),
                ' ',
                _react2.default.createElement(
                  'span',
                  { className: 'required-star' },
                  '*'
                )
              ),
              options: isVietnam ? vnChoiceOptions : categoryOptions,
              value: isVietnam ? cancellationChoice : cancellationCategory,
              onChange: isVietnam ? this.handleChoiceChange : this.handleCategoryChange,
              placeholder: t('Select a cancellation category', { ns: _translation.TRANSLATION_FILES.translation }),
              selectOnBlur: false
            }),
            _react2.default.createElement(
              _semanticUiReact.Form.Field,
              null,
              _react2.default.createElement(
                'label',
                null,
                t('Cancellation reason', { ns: _translation.TRANSLATION_FILES.translation }),
                ' ',
                _react2.default.createElement(
                  'span',
                  { className: 'required-star' },
                  '*'
                )
              ),
              _react2.default.createElement(_semanticUiReact.TextArea, {
                rows: 4,
                value: cancellationReason,
                onChange: this.handleReasonChange,
                placeholder: t('Enter the reason for cancelling this booking...', { ns: _translation.TRANSLATION_FILES.translation })
              }),
              _react2.default.createElement(
                'div',
                { className: 'char-counter ' + (characterCount > CANCELLATION_REASON_MAX_LENGTH ? 'error-limit' : '') },
                characterCount + ' / ' + CANCELLATION_REASON_MAX_LENGTH
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          { className: 'modal-actions-footer' },
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              className: 'btn-dismiss',
              onClick: this.handleClose
            },
            t('Cancel', { ns: _translation.TRANSLATION_FILES.translation })
          ),
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              className: 'btn-submit',
              onClick: this.handleSubmit,
              disabled: isInvalid
            },
            t('Submit request', { ns: _translation.TRANSLATION_FILES.translation })
          )
        )
      );
    }
  }]);

  return OpportunityCancelModal;
}(_react.Component);

OpportunityCancelModal.propTypes = {
  open: _propTypes2.default.bool,
  srCode: _propTypes2.default.string,
  onClose: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  // The company's cancellation reason master list, already in the store (BookApp.jsx fetches it).
  cancellationReasons: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  // CPI-1226 post-fix: only to decide which entries the dropdown offers.
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  t: _propTypes2.default.func
};

OpportunityCancelModal.mapStateToProps = function (state) {
  return {
    cancellationReasons: state.cancellationReasons,
    auth: state.auth
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(OpportunityCancelModal.mapStateToProps)(OpportunityCancelModal));

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ANALYTICS = exports.ANALYTICS = 'analytics';
var BUYER_MARKETPLACE = exports.BUYER_MARKETPLACE = 'buyer_marketplace';
var CREDIT_CONTROL = exports.CREDIT_CONTROL = 'credit_control';
var LEAD = exports.LEAD = 'lead_management';
var LEADV2 = exports.LEADV2 = 'lead_management_v2';
var LOAN_TRACKER = exports.LOAN_TRACKER = 'loan_tracker';
var MARKETPLACE = exports.MARKETPLACE = 'markertplace';
var SHOWROOM = exports.SHOWROOM = 'showroom';
var COMMISSION_TRACKER = exports.COMMISSION_TRACKER = 'commission_tracker';
var EINVOICE = exports.EINVOICE = 'einvoice';

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BANK_CASE_STATUSES = [{ text: 'New', value: 'new', name: 'new', color: 'status-info' }, { text: 'Pending Docs', value: 'pending_docs', name: 'pending_docs', color: 'status-warning' }, { text: 'Docs Submitted', value: 'pending_docs_submitted', name: 'pending_docs_submitted', color: 'status-warning' }, { text: 'LO Issued', value: 'approved_lo_issued', name: 'approved_lo_issued', color: 'status-good' }, { text: 'Unreachable', value: 'pending_unreachable', name: 'pending_unreachable' }, { text: 'Loan Re-appealed', value: 'pending_reappealed', name: 'pending_reappealed' }, { text: 'Wrong Info', value: 'reject_wrong_info', name: 'reject_wrong_info' }, { text: 'Customer Cancelled', value: 'reject_cancelled', name: 'reject_cancelled', color: 'status-danger' }, { text: 'LO Signed', value: 'success_li_issued', name: 'success_li_issued', color: 'status-good' }, { text: 'Unqualified', value: 'reject_unqualified', name: 'reject_unqualified', color: 'status-danger' }, { text: 'Loan Rejected', value: 'reject_bank', name: 'reject_bank', color: 'status-danger' }, { text: 'Customer Rejected', value: 'reject_customer', name: 'reject_customer', color: 'status-danger' }, { text: 'LO Signed With Another Bank', value: 'reject_lo_signed_other_bank', name: 'reject_lo_signed_other_bank', color: 'status-danger' }, { text: 'Developer Cancelled', value: 'reject_developer', name: 'reject_developer', color: 'status-danger' }];
var BANK_CASE_STATUS_GROUPS = exports.BANK_CASE_STATUS_GROUPS = [{ text: 'All', value: 'all', name: 'all' }, { text: 'Current', value: 'current', name: 'current' }, { text: 'Closed', value: 'closed', name: 'closed' }, { text: 'Custom', value: 'custom', name: 'custom' }];
var CURRENT_STATUSES = exports.CURRENT_STATUSES = ['new', 'pending_docs', 'pending_docs_submitted', 'approved_lo_issued', 'pending_unreachable', 'pending_reappealed', 'reject_wrong_info', 'reject_cancelled'];
var CLOSED_STATUSES = exports.CLOSED_STATUSES = ['success_li_issued', 'reject_unqualified', 'reject_bank', 'reject_customer', 'reject_lo_signed_other_bank', 'reject_developer'];
var REJECTED_STATUSES = exports.REJECTED_STATUSES = ['reject_cancelled', 'reject_unqualified', 'reject_bank', 'reject_customer', 'reject_lo_signed_other_bank', 'reject_developer'];
exports.default = BANK_CASE_STATUSES;

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DATE_RANGES = [{ text: 'Custom Date Range', value: 'custom' }, { text: 'Today', value: 'today' }, { text: 'Yesterday', value: 'yesterday' }, { text: 'Last 7 Days', value: 'last7days' }, { text: 'Last 30 Days', value: 'last30days' }];

var REPORT_DATE_RANGES = exports.REPORT_DATE_RANGES = [{ text: 'Custom Date Range', value: 'custom' }, { text: 'Today', value: 'today' }, { text: 'Weekly', value: 'weekly' }, { text: 'Monthly', value: 'monthly' }, { text: 'Yearly', value: 'yearly' }];

var AGING_DATE_RANGE = exports.AGING_DATE_RANGE = [{ text: 'Until today', value: 'until_today' }, { text: 'More than 3 days', value: 'more_than_3_days' }, { text: 'More than 7 days', value: 'more_than_7_days' }, { text: 'More than 14 days', value: 'more_than_14_days' }, { text: 'More than 30 days', value: 'more_than_30_days' }];

exports.default = DATE_RANGES;

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var UNIT_STATUSES_DE_BASIC = exports.UNIT_STATUSES_DE_BASIC = [{ text: 'Available', value: 'new', name: 'new' }, { text: 'Reserved', value: 'reserved', name: 'reserved' }, { text: 'Booked', value: 'booked', name: 'booked' }];
var UNIT_STATUSES_DE_EXTRA = exports.UNIT_STATUSES_DE_EXTRA = [{ text: 'Delisted', value: 'delist', name: 'delist' }, { text: 'Booked', value: 'sold_spa_signed', name: 'sold_spa_signed' }, { text: 'Reserved', value: 'developer_reserved', name: 'developer_reserved' }, { text: 'Booked', value: 'developer_booked', name: 'developer_booked' }, { text: 'Booked', value: 'developer_sold', name: 'developer_sold' }];
var UNIT_STATUSES_DE_ALL = exports.UNIT_STATUSES_DE_ALL = [].concat(UNIT_STATUSES_DE_BASIC, UNIT_STATUSES_DE_EXTRA);
var UNIT_STATUSES_HQ_DEVELOPER = exports.UNIT_STATUSES_HQ_DEVELOPER = [{ text: 'Reserved', value: 'developer_reserved', name: 'developer_reserved' }, { text: 'Booked', value: 'developer_booked', name: 'developer_booked' }, { text: 'Sold', value: 'developer_sold', name: 'developer_sold' }];
var UNIT_STATUSES_HQ_BASIC = exports.UNIT_STATUSES_HQ_BASIC = [{ text: 'Available', value: 'new', name: 'new' }, { text: 'Reserved', value: 'reserved', name: 'reserved' }, { text: 'Booked', value: 'booked', name: 'booked' }, { text: 'Sold', value: 'sold_spa_signed', name: 'sold_spa_signed' }, { text: 'Delisted', value: 'delist', name: 'delist' }];
var UNIT_STATUSES_SIMPLE_MODE = exports.UNIT_STATUSES_SIMPLE_MODE = [{ text: 'Available', value: 'new', name: 'new' }, { text: 'Unavailable', value: 'unavailable', name: 'unavailable' }];
var UNIT_STATUSES_SIMPLE_ALL = exports.UNIT_STATUSES_SIMPLE_ALL = [].concat(UNIT_STATUSES_HQ_BASIC, UNIT_STATUSES_SIMPLE_MODE);
var UNIT_STATUSES_HQ_ALL = exports.UNIT_STATUSES_HQ_ALL = [].concat(UNIT_STATUSES_HQ_BASIC, UNIT_STATUSES_HQ_DEVELOPER);

var UNIT_STATUSES_HQ_REAL = exports.UNIT_STATUSES_HQ_REAL = [{ text: 'Available', value: 'new', name: 'new' }, { text: 'Reserved', value: 'reserved', name: 'reserved' }, { text: 'Booked', value: 'booked', name: 'booked' }, { text: 'Sold', value: 'sold_spa_signed', name: 'sold_spa_signed' }, { text: 'Delisted', value: 'delist', name: 'delist' }, { text: 'Reserved outside MHub', value: 'developer_reserved', name: 'developer_reserved' }, { text: 'Booked outside MHub', value: 'developer_booked', name: 'developer_booked' }, { text: 'Sold outside MHub', value: 'developer_sold', name: 'developer_sold' }];

var UNIT_STATUSES_EXTERNAL_ALL = exports.UNIT_STATUSES_EXTERNAL_ALL = [{ text: 'Available', value: 'new', name: 'new' }].concat(UNIT_STATUSES_HQ_DEVELOPER, [{ text: 'Delisted', value: 'delist', name: 'delist' }]);

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18next = __webpack_require__(94);

var _i18next2 = _interopRequireDefault(_i18next);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _EditImage = __webpack_require__(560);

var _EditImage2 = _interopRequireDefault(_EditImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UploadBookingPaymentPictureForm = function (_Component) {
  _inherits(UploadBookingPaymentPictureForm, _Component);

  function UploadBookingPaymentPictureForm(props) {
    _classCallCheck(this, UploadBookingPaymentPictureForm);

    var _this = _possibleConstructorReturn(this, (UploadBookingPaymentPictureForm.__proto__ || Object.getPrototypeOf(UploadBookingPaymentPictureForm)).call(this, props));

    _this.handleSubmit = function (event) {
      event.preventDefault();
      if (_this.state.uploads.length > 0) {
        var formData = new FormData(_this.bppForm);
        _this.state.uploads.forEach(function (upload, idx) {
          formData.append('files_' + idx, upload.file);
          formData.append('tags_' + idx, _this.state.tags[idx]);
          formData.append('degrees_' + idx, _this.state.degrees[idx] || 0);
          formData.append('names_' + idx, _this.state.names[idx]);
        });
        formData.append('total_attached', _this.state.uploads.length || 0);
        if (_this.props.onSubmit) {
          _this.props.onSubmit(event, formData);
        }
      }
    };

    _this.handleOnChange = function () {
      var store = _this.context.store;
      var fileType = _this.props.fileType;

      var fileExtLength = fileType === 'docx' ? 5 : 4;
      var files = Array.prototype.slice.call(_this.uploadFiles.files);
      _this.uploadFiles.value = null;
      if (window.FileReader) {
        files.forEach(function (file) {
          if (!fileType && file.type.match('image.*') || fileType && fileType === 'attachment' && (file.type.match('image.*') || file.type.match('application/pdf')) && file.size < 10485760 || fileType === 'docx' && file.type.match(_this.allowedFileTypes()) && file.size < 10485760) {
            var reader = new FileReader();
            reader.onloadend = function () {
              var _this$state = _this.state,
                  uploads = _this$state.uploads,
                  tags = _this$state.tags,
                  names = _this$state.names;

              var upload = {
                file: file,
                name: file.name.substring(0, file.name.length - fileExtLength),
                src: reader.result
              };
              uploads.push(upload);
              tags.push([]);
              names.push(upload.name);
              _this.setState({
                uploads: uploads,
                tags: tags,
                names: names
              }, function () {
                _this.handleCheckChanges();
              });
            };
            reader.readAsDataURL(file);
          } else if (fileType && fileType === 'attachment' && (file.type.match('image.*') || file.type.match('application/pdf')) && file.size > 10485760 || fileType && fileType === 'docx' && file.size > 10485760) {
            store.dispatch((0, _flash.flashMessage)({
              header: 'Maximum file size exceeded',
              message: 'Please ensure file is less than 10MB.',
              icon: 'warning sign',
              type: 'error',
              autoHideDuration: 5000
            }));
          } else if (fileType && fileType === 'attachment' && !(file.type.match('image.*') && !file.type.match('application/pdf'))) {
            store.dispatch((0, _flash.flashMessage)({
              header: 'Wrong file format',
              message: 'Only JPG, JPEG, PNG and PDF files are allowed.',
              icon: 'warning sign',
              type: 'error',
              autoHideDuration: 5000
            }));
          } else {
            store.dispatch((0, _flash.flashMessage)({
              header: 'Wrong file format',
              message: 'Only JPG, JPEG and PNG files are allowed.',
              icon: 'warning sign',
              type: 'error',
              autoHideDuration: 5000
            }));
          }
        });
      }
    };

    _this.handleRemove = function (event, idx) {
      event.preventDefault();
      var _this$state2 = _this.state,
          uploads = _this$state2.uploads,
          tags = _this$state2.tags,
          degrees = _this$state2.degrees,
          names = _this$state2.names;

      uploads.splice(idx, 1);
      degrees.splice(idx, 1);
      tags.splice(idx, 1);
      names.splice(idx, 1);
      _this.setState({ uploads: uploads, degrees: degrees, tags: tags, names: names });
    };

    _this.handleAddFile = function (event) {
      event.preventDefault();
      _this.uploadFiles.click();
    };

    _this.handleTagsChange = function (e, value, idx) {
      var tags = _this.state.tags;

      tags[idx] = value;
      _this.setState({ tags: tags });
    };

    _this.handleInputChange = function (e, value, idx) {
      var names = _this.state.names;

      names[idx] = value;
      _this.setState({ names: names });
    };

    _this.handleAddition = function (e, _ref) {
      var value = _ref.value;

      _this.setState({
        options: [{ text: value, value: value }].concat(_toConsumableArray(_this.state.options))
      });
    };

    _this.handleRotate = function (direction, idx) {
      var degrees = _this.state.degrees;

      if (!degrees[idx]) {
        degrees[idx] = 0;
      }
      var increment = direction === 'right' ? 1 : -1;
      degrees[idx] += 90 * increment;
      if (degrees[idx] >= 360) {
        degrees[idx] = 0;
      }
      if (degrees[idx] < 0) {
        degrees[idx] = 270;
      }
      _this.setState({ degrees: degrees });
    };

    _this.allowedFileTypes = function () {
      var fileType = _this.props.fileType;

      if (fileType === 'attachment') {
        return 'image/gif, image/jpeg, image/png, application/pdf';
      }
      if (fileType === 'docx') {
        return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
      }
      return 'image/gif, image/jpeg, image/png';
    };

    _this.state = {
      loading: props.loading || false,
      uploads: [],
      tags: [],
      degrees: [],
      names: [],
      options: [],
      hasChanges: false
    };
    return _this;
  }

  _createClass(UploadBookingPaymentPictureForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.setState({ loading: nextProps.loading || false });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'submit',
    value: function submit(url) {
      var _this3 = this;

      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var store = this.context.store;

      return this.setLoading(true).then(function () {
        return store.dispatch((0, _fetchM.fetchM)(url, opts));
      }).then(function (res) {
        return res.json();
      }).then(function (result) {
        return _this3.setLoading(false).then(function () {
          return result;
        });
      }).catch(function (err) {
        return _this3.setLoading(false).then(function () {
          return Promise.reject(err);
        });
      });
    }
  }, {
    key: 'resetFiles',
    value: function resetFiles() {
      // temporary fix for upload modal not closing
      this.setState({
        uploads: [],
        tags: [],
        names: [],
        degrees: []
      });
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      var _this4 = this;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true }, function () {
          if (_this4.props.onChange) {
            _this4.props.onChange(true);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var fileType = this.props.fileType;

      return _react2.default.createElement(
        'form',
        {
          encType: 'multipart/form-data',
          onSubmit: this.handleSubmit,
          name: 'uploadBookingPaymentPictures',
          ref: function ref(_ref5) {
            _this5.bppForm = _ref5;
          }
        },
        _react2.default.createElement('input', {
          ref: function ref(_ref2) {
            _this5.uploadFiles = _ref2;
          },
          type: 'file',
          onChange: this.handleOnChange,
          accept: this.allowedFileTypes(),
          multiple: true,
          style: { display: 'none' }
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 'equal' },
            _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'computer' }),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { verticalAlign: 'middle', columns: 'equal' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Button, {
                    fluid: true,
                    compact: true,
                    primary: true,
                    icon: 'add',
                    content: this.props.btnText,
                    onClick: this.handleAddFile,
                    disabled: this.state.loading
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Button, {
                    fluid: true,
                    compact: true,
                    onClick: this.handleSubmit,
                    positive: true,
                    content: _i18next2.default.t('Upload', { ns: 'screens' }), icon: 'cloud upload',
                    loading: this.state.loading,
                    disabled: this.state.uploads.length < 1 || this.state.loading
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { stackable: true, doubling: true, columns: 1 },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { indeterminate: true, inline: 'centered' },
              _i18next2.default.t('Uploading', { ns: 'translation' })
            )
          ),
          this.state.uploads.length > 0 ? this.state.uploads.map(function (upload, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { key: idx },
              _react2.default.createElement(
                _semanticUiReact.Segment.Group,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { secondary: true },
                  _react2.default.createElement(_EditImage2.default, {
                    src: upload.src,
                    degree: _this5.state.degrees[idx] || 0
                  }),
                  _react2.default.createElement(_semanticUiReact.Label, {
                    as: 'a',
                    corner: true,
                    color: 'red',
                    icon: 'delete',
                    disabled: _this5.state.loading,
                    onClick: function onClick(e) {
                      return _this5.handleRemove(e, idx);
                    }
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { padded: true },
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { columns: 1 },
                    fileType && (fileType === 'attachment' && upload.file.type === 'application/pdf' || fileType === 'docx') ? null : _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      null,
                      _react2.default.createElement(_semanticUiReact.Label, {
                        as: 'a',
                        attached: 'top left',
                        icon: { name: 'repeat', flipped: 'horizontally' },
                        disabled: _this5.state.loading,
                        onClick: function onClick() {
                          return _this5.handleRotate('left', idx);
                        }
                      }),
                      _react2.default.createElement(_semanticUiReact.Label, {
                        as: 'a',
                        attached: 'top right',
                        icon: 'repeat',
                        disabled: _this5.state.loading,
                        onClick: function onClick() {
                          return _this5.handleRotate('right', idx);
                        }
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      null,
                      _react2.default.createElement(_semanticUiReact.Input, {
                        placeholder: 'Name',
                        fluid: true,
                        value: _this5.state.names[idx],
                        disabled: _this5.state.loading,
                        onChange: function onChange(e, _ref3) {
                          var value = _ref3.value;
                          return _this5.handleInputChange(e, value, idx);
                        },
                        readOnly: fileType === 'docx'
                      }),
                      fileType !== 'docx' && _react2.default.createElement(_semanticUiReact.Dropdown, {
                        options: _this5.state.options,
                        placeholder: _i18next2.default.t('Add tags', { ns: 'translation' }),
                        search: true,
                        selection: true,
                        fluid: true,
                        multiple: true,
                        allowAdditions: true,
                        noResultsMessage: _i18next2.default.t('Add tags', { ns: 'translation' }),
                        value: _this5.state.tags[idx],
                        onAddItem: _this5.handleAddition,
                        disabled: _this5.state.loading,
                        onChange: function onChange(e, _ref4) {
                          var value = _ref4.value;
                          return _this5.handleTagsChange(e, value, idx);
                        }
                      })
                    )
                  )
                )
              )
            );
          }) : null
        )
      );
    }
  }]);

  return UploadBookingPaymentPictureForm;
}(_react.Component);

UploadBookingPaymentPictureForm.contextTypes = {
  store: _propTypes2.default.object
};
UploadBookingPaymentPictureForm.propTypes = {
  onSubmit: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  fileType: _propTypes2.default.string,
  btnText: _propTypes2.default.string
};
UploadBookingPaymentPictureForm.contextTypes = {
  store: _propTypes2.default.object
};
UploadBookingPaymentPictureForm.defaultProps = {
  btnText: 'Images'
};
exports.default = UploadBookingPaymentPictureForm;

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseJSON = parseJSON;
function parseJSON(data) {
  try {
    return JSON.parse(data);
  } catch (e) {
    Bugsnag.notifyException(e);
    return null;
  }
}

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.salesChartBlocked = exports.reservationBlocked = exports.canManagePreSalesLaunch = undefined;

var _srRoleAccess = __webpack_require__(196);

// Pre-Sales Launch role lists on Booking Setup. Each blocks only the exact roles HQ picked, so an
// empty or missing list blocks nobody, and HQ and admins are never blocked. Mirrors
// reservationBlocked / salesChartBlocked in book-api, which also refuse on the server.
var roleIsListed = function roleIsListed(auth, roleIDs) {
  var roleID = (0, _srRoleAccess.srRoleIDOfUser)(auth);
  return _srRoleAccess.preSalesLaunchRoleIDs.includes(roleID) && Array.isArray(roleIDs) && roleIDs.includes(roleID);
};

// canManagePreSalesLaunch: only HQ and admins may change the lists. Sales Managers and
// Supervisors can save a project too, so the lists are read-only for them, and book-api keeps
// the saved lists whatever they send.
var canManagePreSalesLaunch = exports.canManagePreSalesLaunch = function canManagePreSalesLaunch(auth) {
  return !!auth && !!(auth.isSuperAdmin || auth.isAdmin || auth.isAdminBasic || auth.isHeadquarters);
};

// reservationBlocked: the user may not open the new booking form, reserve or change unit.
var reservationBlocked = exports.reservationBlocked = function reservationBlocked(auth, project) {
  return !!project && roleIsListed(auth, project.reserveDisabledRoleIDs);
};

// salesChartBlocked: the user does not get the Storey Plan.
var salesChartBlocked = exports.salesChartBlocked = function salesChartBlocked(auth, project) {
  return !!project && roleIsListed(auth, project.salesChartDisabledRoleIDs);
};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.layoutLandAreaValue = exports.layoutAreaValue = exports.visibleLayoutSpecifications = exports.layoutFieldDisplay = exports.parseLayoutFormValues = exports.VN_LAYOUT_DEFAULT_VALUES = exports.VN_LAYOUT_FIELDS = undefined;

var _vietnam = __webpack_require__(40);

// CPI-1208: a Vietnamese unit layout records six things a Malaysian one does not - Block,
// Direction, View, Floor and the two areas NFA and NSA. Everything here is unchanged elsewhere.
var VN_LAYOUT_FIELDS = exports.VN_LAYOUT_FIELDS = ['block', 'direction', 'view', 'floor', 'nfa', 'nsa'];

var VN_LAYOUT_DEFAULT_VALUES = exports.VN_LAYOUT_DEFAULT_VALUES = {
  block: '',
  direction: '',
  view: '',
  floor: '',
  nfa: 0,
  nsa: 0
};

// The numeric fields have to leave the form as numbers; nfa and nsa are added for Vietnam only.
// An empty box is 0, never NaN - NaN serialises to null and the API would refuse the write.
var parseLayoutFormValues = exports.parseLayoutFormValues = function parseLayoutFormValues(unitLayout, isVietnam) {
  return Object.assign(unitLayout, {
    size: parseFloat(unitLayout.size),
    landArea: parseFloat(unitLayout.landArea)
  }, isVietnam ? {
    nfa: parseFloat(unitLayout.nfa) || 0,
    nsa: parseFloat(unitLayout.nsa) || 0
  } : {});
};

// CPI-1244 item 11's empty-state rule: a layout field with no value shows a dash, not a stray 0.
var layoutFieldDisplay = exports.layoutFieldDisplay = function layoutFieldDisplay(value) {
  if (value === null || value === undefined || value === '' || value === 0) {
    return '-';
  }
  return value;
};

// CPI-1208 item 6 / Q4: the five specification presets are seeded rows with no company column,
// so they are offered for a Vietnamese company only.
var VN_LAYOUT_SPECIFICATION_PRESETS = ['structure', 'ceiling', 'windows', 'ironmongery', 'carpark'];

var visibleLayoutSpecifications = exports.visibleLayoutSpecifications = function visibleLayoutSpecifications(auth, specifications) {
  var list = specifications || [];
  if ((0, _vietnam.isVietnamCompany)(auth)) {
    return list;
  }
  return list.filter(function (s) {
    return !s || VN_LAYOUT_SPECIFICATION_PRESETS.indexOf(s.id) === -1;
  });
};

// CPI-1208 post-fix (PO, 6 Sep): "ensure to hide the old one from the UI." A Vietnamese layout
// keeps `size` and `landArea` in the database - nothing stops writing them - but no Vietnamese
// screen shows them: the pair a VN screen reads is NSA and NFA. These two are the single place
// that decides which pair a screen reads, so the form, the list row, the detail header and the
// Compare screen cannot drift. Outside Vietnam each returns exactly the field the screen read
// before.
var layoutAreaValue = exports.layoutAreaValue = function layoutAreaValue(isVietnam, unitLayout) {
  return isVietnam ? (unitLayout || {}).nsa : (unitLayout || {}).size;
};

var layoutLandAreaValue = exports.layoutLandAreaValue = function layoutLandAreaValue(isVietnam, unitLayout) {
  return isVietnam ? (unitLayout || {}).nfa : (unitLayout || {}).landArea;
};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateForm = undefined;

var _flash = __webpack_require__(5);

var validateForm = exports.validateForm = function validateForm(store, validations) {
  var errors = validations.filter(function (v) {
    return !v.isValid;
  });
  var isError = errors.length > 0;
  if (isError) {
    store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errors.map(function (l) {
        return l.message;
      }) }));
  }
  return isError;
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(229);
var createDesc = __webpack_require__(410);
module.exports = __webpack_require__(199) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 273 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(1114);
var defined = __webpack_require__(604);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(611)('wks');
var uid = __webpack_require__(411);
var Symbol = __webpack_require__(177).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(119);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(52);
var dP = __webpack_require__(83);
var DESCRIPTORS = __webpack_require__(82);
var SPECIES = __webpack_require__(67)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(83).f;
var has = __webpack_require__(130);
var TAG = __webpack_require__(67)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(17);
var defined = __webpack_require__(179);
var fails = __webpack_require__(51);
var spaces = __webpack_require__(636);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parse = parse;
exports.parseValue = parseValue;
exports.parseType = parseType;
exports.parseConstValue = parseConstValue;
exports.parseTypeReference = parseTypeReference;
exports.parseNamedType = parseNamedType;

var _inspect = _interopRequireDefault(__webpack_require__(93));

var _source = __webpack_require__(1208);

var _error = __webpack_require__(656);

var _lexer = __webpack_require__(663);

var _kinds = __webpack_require__(68);

var _directiveLocation = __webpack_require__(345);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;

  if (!(sourceObj instanceof _source.Source)) {
    throw new TypeError("Must provide Source. Received: ".concat((0, _inspect.default)(sourceObj)));
  }

  var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
  return parseDocument(lexer);
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */


function parseValue(source, options) {
  var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
  var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
  expect(lexer, _lexer.TokenKind.SOF);
  var value = parseValueLiteral(lexer, false);
  expect(lexer, _lexer.TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */


function parseType(source, options) {
  var sourceObj = typeof source === 'string' ? new _source.Source(source) : source;
  var lexer = (0, _lexer.createLexer)(sourceObj, options || {});
  expect(lexer, _lexer.TokenKind.SOF);
  var type = parseTypeReference(lexer);
  expect(lexer, _lexer.TokenKind.EOF);
  return type;
}
/**
 * Converts a name lex token into a name parse node.
 */


function parseName(lexer) {
  var token = expect(lexer, _lexer.TokenKind.NAME);
  return {
    kind: _kinds.Kind.NAME,
    value: token.value,
    loc: loc(lexer, token)
  };
} // Implements the parsing rules in the Document section.

/**
 * Document : Definition+
 */


function parseDocument(lexer) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.DOCUMENT,
    definitions: many(lexer, _lexer.TokenKind.SOF, parseDefinition, _lexer.TokenKind.EOF),
    loc: loc(lexer, start)
  };
}
/**
 * Definition :
 *   - ExecutableDefinition
 *   - TypeSystemDefinition
 *   - TypeSystemExtension
 */


function parseDefinition(lexer) {
  if (peek(lexer, _lexer.TokenKind.NAME)) {
    switch (lexer.token.value) {
      case 'query':
      case 'mutation':
      case 'subscription':
      case 'fragment':
        return parseExecutableDefinition(lexer);

      case 'schema':
      case 'scalar':
      case 'type':
      case 'interface':
      case 'union':
      case 'enum':
      case 'input':
      case 'directive':
        return parseTypeSystemDefinition(lexer);

      case 'extend':
        return parseTypeSystemExtension(lexer);
    }
  } else if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
    return parseExecutableDefinition(lexer);
  } else if (peekDescription(lexer)) {
    return parseTypeSystemDefinition(lexer);
  }

  throw unexpected(lexer);
}
/**
 * ExecutableDefinition :
 *   - OperationDefinition
 *   - FragmentDefinition
 */


function parseExecutableDefinition(lexer) {
  if (peek(lexer, _lexer.TokenKind.NAME)) {
    switch (lexer.token.value) {
      case 'query':
      case 'mutation':
      case 'subscription':
        return parseOperationDefinition(lexer);

      case 'fragment':
        return parseFragmentDefinition(lexer);
    }
  } else if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
    return parseOperationDefinition(lexer);
  }

  throw unexpected(lexer);
} // Implements the parsing rules in the Operations section.

/**
 * OperationDefinition :
 *  - SelectionSet
 *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
 */


function parseOperationDefinition(lexer) {
  var start = lexer.token;

  if (peek(lexer, _lexer.TokenKind.BRACE_L)) {
    return {
      kind: _kinds.Kind.OPERATION_DEFINITION,
      operation: 'query',
      name: undefined,
      variableDefinitions: [],
      directives: [],
      selectionSet: parseSelectionSet(lexer),
      loc: loc(lexer, start)
    };
  }

  var operation = parseOperationType(lexer);
  var name;

  if (peek(lexer, _lexer.TokenKind.NAME)) {
    name = parseName(lexer);
  }

  return {
    kind: _kinds.Kind.OPERATION_DEFINITION,
    operation: operation,
    name: name,
    variableDefinitions: parseVariableDefinitions(lexer),
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}
/**
 * OperationType : one of query mutation subscription
 */


function parseOperationType(lexer) {
  var operationToken = expect(lexer, _lexer.TokenKind.NAME);

  switch (operationToken.value) {
    case 'query':
      return 'query';

    case 'mutation':
      return 'mutation';

    case 'subscription':
      return 'subscription';
  }

  throw unexpected(lexer, operationToken);
}
/**
 * VariableDefinitions : ( VariableDefinition+ )
 */


function parseVariableDefinitions(lexer) {
  return peek(lexer, _lexer.TokenKind.PAREN_L) ? many(lexer, _lexer.TokenKind.PAREN_L, parseVariableDefinition, _lexer.TokenKind.PAREN_R) : [];
}
/**
 * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
 */


function parseVariableDefinition(lexer) {
  var start = lexer.token;

  if (lexer.options.experimentalVariableDefinitionDirectives) {
    return {
      kind: _kinds.Kind.VARIABLE_DEFINITION,
      variable: parseVariable(lexer),
      type: (expect(lexer, _lexer.TokenKind.COLON), parseTypeReference(lexer)),
      defaultValue: skip(lexer, _lexer.TokenKind.EQUALS) ? parseValueLiteral(lexer, true) : undefined,
      directives: parseDirectives(lexer, true),
      loc: loc(lexer, start)
    };
  }

  return {
    kind: _kinds.Kind.VARIABLE_DEFINITION,
    variable: parseVariable(lexer),
    type: (expect(lexer, _lexer.TokenKind.COLON), parseTypeReference(lexer)),
    defaultValue: skip(lexer, _lexer.TokenKind.EQUALS) ? parseValueLiteral(lexer, true) : undefined,
    loc: loc(lexer, start)
  };
}
/**
 * Variable : $ Name
 */


function parseVariable(lexer) {
  var start = lexer.token;
  expect(lexer, _lexer.TokenKind.DOLLAR);
  return {
    kind: _kinds.Kind.VARIABLE,
    name: parseName(lexer),
    loc: loc(lexer, start)
  };
}
/**
 * SelectionSet : { Selection+ }
 */


function parseSelectionSet(lexer) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.SELECTION_SET,
    selections: many(lexer, _lexer.TokenKind.BRACE_L, parseSelection, _lexer.TokenKind.BRACE_R),
    loc: loc(lexer, start)
  };
}
/**
 * Selection :
 *   - Field
 *   - FragmentSpread
 *   - InlineFragment
 */


function parseSelection(lexer) {
  return peek(lexer, _lexer.TokenKind.SPREAD) ? parseFragment(lexer) : parseField(lexer);
}
/**
 * Field : Alias? Name Arguments? Directives? SelectionSet?
 *
 * Alias : Name :
 */


function parseField(lexer) {
  var start = lexer.token;
  var nameOrAlias = parseName(lexer);
  var alias;
  var name;

  if (skip(lexer, _lexer.TokenKind.COLON)) {
    alias = nameOrAlias;
    name = parseName(lexer);
  } else {
    name = nameOrAlias;
  }

  return {
    kind: _kinds.Kind.FIELD,
    alias: alias,
    name: name,
    arguments: parseArguments(lexer, false),
    directives: parseDirectives(lexer, false),
    selectionSet: peek(lexer, _lexer.TokenKind.BRACE_L) ? parseSelectionSet(lexer) : undefined,
    loc: loc(lexer, start)
  };
}
/**
 * Arguments[Const] : ( Argument[?Const]+ )
 */


function parseArguments(lexer, isConst) {
  var item = isConst ? parseConstArgument : parseArgument;
  return peek(lexer, _lexer.TokenKind.PAREN_L) ? many(lexer, _lexer.TokenKind.PAREN_L, item, _lexer.TokenKind.PAREN_R) : [];
}
/**
 * Argument[Const] : Name : Value[?Const]
 */


function parseArgument(lexer) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.ARGUMENT,
    name: parseName(lexer),
    value: (expect(lexer, _lexer.TokenKind.COLON), parseValueLiteral(lexer, false)),
    loc: loc(lexer, start)
  };
}

function parseConstArgument(lexer) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.ARGUMENT,
    name: parseName(lexer),
    value: (expect(lexer, _lexer.TokenKind.COLON), parseConstValue(lexer)),
    loc: loc(lexer, start)
  };
} // Implements the parsing rules in the Fragments section.

/**
 * Corresponds to both FragmentSpread and InlineFragment in the spec.
 *
 * FragmentSpread : ... FragmentName Directives?
 *
 * InlineFragment : ... TypeCondition? Directives? SelectionSet
 */


function parseFragment(lexer) {
  var start = lexer.token;
  expect(lexer, _lexer.TokenKind.SPREAD);

  if (peek(lexer, _lexer.TokenKind.NAME) && lexer.token.value !== 'on') {
    return {
      kind: _kinds.Kind.FRAGMENT_SPREAD,
      name: parseFragmentName(lexer),
      directives: parseDirectives(lexer, false),
      loc: loc(lexer, start)
    };
  }

  var typeCondition;

  if (lexer.token.value === 'on') {
    lexer.advance();
    typeCondition = parseNamedType(lexer);
  }

  return {
    kind: _kinds.Kind.INLINE_FRAGMENT,
    typeCondition: typeCondition,
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}
/**
 * FragmentDefinition :
 *   - fragment FragmentName on TypeCondition Directives? SelectionSet
 *
 * TypeCondition : NamedType
 */


function parseFragmentDefinition(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'fragment'); // Experimental support for defining variables within fragments changes
  // the grammar of FragmentDefinition:
  //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

  if (lexer.options.experimentalFragmentVariables) {
    return {
      kind: _kinds.Kind.FRAGMENT_DEFINITION,
      name: parseFragmentName(lexer),
      variableDefinitions: parseVariableDefinitions(lexer),
      typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
      directives: parseDirectives(lexer, false),
      selectionSet: parseSelectionSet(lexer),
      loc: loc(lexer, start)
    };
  }

  return {
    kind: _kinds.Kind.FRAGMENT_DEFINITION,
    name: parseFragmentName(lexer),
    typeCondition: (expectKeyword(lexer, 'on'), parseNamedType(lexer)),
    directives: parseDirectives(lexer, false),
    selectionSet: parseSelectionSet(lexer),
    loc: loc(lexer, start)
  };
}
/**
 * FragmentName : Name but not `on`
 */


function parseFragmentName(lexer) {
  if (lexer.token.value === 'on') {
    throw unexpected(lexer);
  }

  return parseName(lexer);
} // Implements the parsing rules in the Values section.

/**
 * Value[Const] :
 *   - [~Const] Variable
 *   - IntValue
 *   - FloatValue
 *   - StringValue
 *   - BooleanValue
 *   - NullValue
 *   - EnumValue
 *   - ListValue[?Const]
 *   - ObjectValue[?Const]
 *
 * BooleanValue : one of `true` `false`
 *
 * NullValue : `null`
 *
 * EnumValue : Name but not `true`, `false` or `null`
 */


function parseValueLiteral(lexer, isConst) {
  var token = lexer.token;

  switch (token.kind) {
    case _lexer.TokenKind.BRACKET_L:
      return parseList(lexer, isConst);

    case _lexer.TokenKind.BRACE_L:
      return parseObject(lexer, isConst);

    case _lexer.TokenKind.INT:
      lexer.advance();
      return {
        kind: _kinds.Kind.INT,
        value: token.value,
        loc: loc(lexer, token)
      };

    case _lexer.TokenKind.FLOAT:
      lexer.advance();
      return {
        kind: _kinds.Kind.FLOAT,
        value: token.value,
        loc: loc(lexer, token)
      };

    case _lexer.TokenKind.STRING:
    case _lexer.TokenKind.BLOCK_STRING:
      return parseStringLiteral(lexer);

    case _lexer.TokenKind.NAME:
      if (token.value === 'true' || token.value === 'false') {
        lexer.advance();
        return {
          kind: _kinds.Kind.BOOLEAN,
          value: token.value === 'true',
          loc: loc(lexer, token)
        };
      } else if (token.value === 'null') {
        lexer.advance();
        return {
          kind: _kinds.Kind.NULL,
          loc: loc(lexer, token)
        };
      }

      lexer.advance();
      return {
        kind: _kinds.Kind.ENUM,
        value: token.value,
        loc: loc(lexer, token)
      };

    case _lexer.TokenKind.DOLLAR:
      if (!isConst) {
        return parseVariable(lexer);
      }

      break;
  }

  throw unexpected(lexer);
}

function parseStringLiteral(lexer) {
  var token = lexer.token;
  lexer.advance();
  return {
    kind: _kinds.Kind.STRING,
    value: token.value,
    block: token.kind === _lexer.TokenKind.BLOCK_STRING,
    loc: loc(lexer, token)
  };
}

function parseConstValue(lexer) {
  return parseValueLiteral(lexer, true);
}

function parseValueValue(lexer) {
  return parseValueLiteral(lexer, false);
}
/**
 * ListValue[Const] :
 *   - [ ]
 *   - [ Value[?Const]+ ]
 */


function parseList(lexer, isConst) {
  var start = lexer.token;
  var item = isConst ? parseConstValue : parseValueValue;
  return {
    kind: _kinds.Kind.LIST,
    values: any(lexer, _lexer.TokenKind.BRACKET_L, item, _lexer.TokenKind.BRACKET_R),
    loc: loc(lexer, start)
  };
}
/**
 * ObjectValue[Const] :
 *   - { }
 *   - { ObjectField[?Const]+ }
 */


function parseObject(lexer, isConst) {
  var start = lexer.token;
  expect(lexer, _lexer.TokenKind.BRACE_L);
  var fields = [];

  while (!skip(lexer, _lexer.TokenKind.BRACE_R)) {
    fields.push(parseObjectField(lexer, isConst));
  }

  return {
    kind: _kinds.Kind.OBJECT,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * ObjectField[Const] : Name : Value[?Const]
 */


function parseObjectField(lexer, isConst) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.OBJECT_FIELD,
    name: parseName(lexer),
    value: (expect(lexer, _lexer.TokenKind.COLON), parseValueLiteral(lexer, isConst)),
    loc: loc(lexer, start)
  };
} // Implements the parsing rules in the Directives section.

/**
 * Directives[Const] : Directive[?Const]+
 */


function parseDirectives(lexer, isConst) {
  var directives = [];

  while (peek(lexer, _lexer.TokenKind.AT)) {
    directives.push(parseDirective(lexer, isConst));
  }

  return directives;
}
/**
 * Directive[Const] : @ Name Arguments[?Const]?
 */


function parseDirective(lexer, isConst) {
  var start = lexer.token;
  expect(lexer, _lexer.TokenKind.AT);
  return {
    kind: _kinds.Kind.DIRECTIVE,
    name: parseName(lexer),
    arguments: parseArguments(lexer, isConst),
    loc: loc(lexer, start)
  };
} // Implements the parsing rules in the Types section.

/**
 * Type :
 *   - NamedType
 *   - ListType
 *   - NonNullType
 */


function parseTypeReference(lexer) {
  var start = lexer.token;
  var type;

  if (skip(lexer, _lexer.TokenKind.BRACKET_L)) {
    type = parseTypeReference(lexer);
    expect(lexer, _lexer.TokenKind.BRACKET_R);
    type = {
      kind: _kinds.Kind.LIST_TYPE,
      type: type,
      loc: loc(lexer, start)
    };
  } else {
    type = parseNamedType(lexer);
  }

  if (skip(lexer, _lexer.TokenKind.BANG)) {
    return {
      kind: _kinds.Kind.NON_NULL_TYPE,
      type: type,
      loc: loc(lexer, start)
    };
  }

  return type;
}
/**
 * NamedType : Name
 */


function parseNamedType(lexer) {
  var start = lexer.token;
  return {
    kind: _kinds.Kind.NAMED_TYPE,
    name: parseName(lexer),
    loc: loc(lexer, start)
  };
} // Implements the parsing rules in the Type Definition section.

/**
 * TypeSystemDefinition :
 *   - SchemaDefinition
 *   - TypeDefinition
 *   - DirectiveDefinition
 *
 * TypeDefinition :
 *   - ScalarTypeDefinition
 *   - ObjectTypeDefinition
 *   - InterfaceTypeDefinition
 *   - UnionTypeDefinition
 *   - EnumTypeDefinition
 *   - InputObjectTypeDefinition
 */


function parseTypeSystemDefinition(lexer) {
  // Many definitions begin with a description and require a lookahead.
  var keywordToken = peekDescription(lexer) ? lexer.lookahead() : lexer.token;

  if (keywordToken.kind === _lexer.TokenKind.NAME) {
    switch (keywordToken.value) {
      case 'schema':
        return parseSchemaDefinition(lexer);

      case 'scalar':
        return parseScalarTypeDefinition(lexer);

      case 'type':
        return parseObjectTypeDefinition(lexer);

      case 'interface':
        return parseInterfaceTypeDefinition(lexer);

      case 'union':
        return parseUnionTypeDefinition(lexer);

      case 'enum':
        return parseEnumTypeDefinition(lexer);

      case 'input':
        return parseInputObjectTypeDefinition(lexer);

      case 'directive':
        return parseDirectiveDefinition(lexer);
    }
  }

  throw unexpected(lexer, keywordToken);
}

function peekDescription(lexer) {
  return peek(lexer, _lexer.TokenKind.STRING) || peek(lexer, _lexer.TokenKind.BLOCK_STRING);
}
/**
 * Description : StringValue
 */


function parseDescription(lexer) {
  if (peekDescription(lexer)) {
    return parseStringLiteral(lexer);
  }
}
/**
 * SchemaDefinition : schema Directives[Const]? { OperationTypeDefinition+ }
 */


function parseSchemaDefinition(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'schema');
  var directives = parseDirectives(lexer, true);
  var operationTypes = many(lexer, _lexer.TokenKind.BRACE_L, parseOperationTypeDefinition, _lexer.TokenKind.BRACE_R);
  return {
    kind: _kinds.Kind.SCHEMA_DEFINITION,
    directives: directives,
    operationTypes: operationTypes,
    loc: loc(lexer, start)
  };
}
/**
 * OperationTypeDefinition : OperationType : NamedType
 */


function parseOperationTypeDefinition(lexer) {
  var start = lexer.token;
  var operation = parseOperationType(lexer);
  expect(lexer, _lexer.TokenKind.COLON);
  var type = parseNamedType(lexer);
  return {
    kind: _kinds.Kind.OPERATION_TYPE_DEFINITION,
    operation: operation,
    type: type,
    loc: loc(lexer, start)
  };
}
/**
 * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
 */


function parseScalarTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'scalar');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: _kinds.Kind.SCALAR_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}
/**
 * ObjectTypeDefinition :
 *   Description?
 *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
 */


function parseObjectTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'type');
  var name = parseName(lexer);
  var interfaces = parseImplementsInterfaces(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  return {
    kind: _kinds.Kind.OBJECT_TYPE_DEFINITION,
    description: description,
    name: name,
    interfaces: interfaces,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * ImplementsInterfaces :
 *   - implements `&`? NamedType
 *   - ImplementsInterfaces & NamedType
 */


function parseImplementsInterfaces(lexer) {
  var types = [];

  if (lexer.token.value === 'implements') {
    lexer.advance(); // Optional leading ampersand

    skip(lexer, _lexer.TokenKind.AMP);

    do {
      types.push(parseNamedType(lexer));
    } while (skip(lexer, _lexer.TokenKind.AMP) || // Legacy support for the SDL?
    lexer.options.allowLegacySDLImplementsInterfaces && peek(lexer, _lexer.TokenKind.NAME));
  }

  return types;
}
/**
 * FieldsDefinition : { FieldDefinition+ }
 */


function parseFieldsDefinition(lexer) {
  // Legacy support for the SDL?
  if (lexer.options.allowLegacySDLEmptyFields && peek(lexer, _lexer.TokenKind.BRACE_L) && lexer.lookahead().kind === _lexer.TokenKind.BRACE_R) {
    lexer.advance();
    lexer.advance();
    return [];
  }

  return peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseFieldDefinition, _lexer.TokenKind.BRACE_R) : [];
}
/**
 * FieldDefinition :
 *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
 */


function parseFieldDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  var args = parseArgumentDefs(lexer);
  expect(lexer, _lexer.TokenKind.COLON);
  var type = parseTypeReference(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: _kinds.Kind.FIELD_DEFINITION,
    description: description,
    name: name,
    arguments: args,
    type: type,
    directives: directives,
    loc: loc(lexer, start)
  };
}
/**
 * ArgumentsDefinition : ( InputValueDefinition+ )
 */


function parseArgumentDefs(lexer) {
  if (!peek(lexer, _lexer.TokenKind.PAREN_L)) {
    return [];
  }

  return many(lexer, _lexer.TokenKind.PAREN_L, parseInputValueDef, _lexer.TokenKind.PAREN_R);
}
/**
 * InputValueDefinition :
 *   - Description? Name : Type DefaultValue? Directives[Const]?
 */


function parseInputValueDef(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  expect(lexer, _lexer.TokenKind.COLON);
  var type = parseTypeReference(lexer);
  var defaultValue;

  if (skip(lexer, _lexer.TokenKind.EQUALS)) {
    defaultValue = parseConstValue(lexer);
  }

  var directives = parseDirectives(lexer, true);
  return {
    kind: _kinds.Kind.INPUT_VALUE_DEFINITION,
    description: description,
    name: name,
    type: type,
    defaultValue: defaultValue,
    directives: directives,
    loc: loc(lexer, start)
  };
}
/**
 * InterfaceTypeDefinition :
 *   - Description? interface Name Directives[Const]? FieldsDefinition?
 */


function parseInterfaceTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'interface');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);
  return {
    kind: _kinds.Kind.INTERFACE_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * UnionTypeDefinition :
 *   - Description? union Name Directives[Const]? UnionMemberTypes?
 */


function parseUnionTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'union');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var types = parseUnionMemberTypes(lexer);
  return {
    kind: _kinds.Kind.UNION_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    types: types,
    loc: loc(lexer, start)
  };
}
/**
 * UnionMemberTypes :
 *   - = `|`? NamedType
 *   - UnionMemberTypes | NamedType
 */


function parseUnionMemberTypes(lexer) {
  var types = [];

  if (skip(lexer, _lexer.TokenKind.EQUALS)) {
    // Optional leading pipe
    skip(lexer, _lexer.TokenKind.PIPE);

    do {
      types.push(parseNamedType(lexer));
    } while (skip(lexer, _lexer.TokenKind.PIPE));
  }

  return types;
}
/**
 * EnumTypeDefinition :
 *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
 */


function parseEnumTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'enum');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var values = parseEnumValuesDefinition(lexer);
  return {
    kind: _kinds.Kind.ENUM_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    values: values,
    loc: loc(lexer, start)
  };
}
/**
 * EnumValuesDefinition : { EnumValueDefinition+ }
 */


function parseEnumValuesDefinition(lexer) {
  return peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseEnumValueDefinition, _lexer.TokenKind.BRACE_R) : [];
}
/**
 * EnumValueDefinition : Description? EnumValue Directives[Const]?
 *
 * EnumValue : Name
 */


function parseEnumValueDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  return {
    kind: _kinds.Kind.ENUM_VALUE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}
/**
 * InputObjectTypeDefinition :
 *   - Description? input Name Directives[Const]? InputFieldsDefinition?
 */


function parseInputObjectTypeDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'input');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseInputFieldsDefinition(lexer);
  return {
    kind: _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION,
    description: description,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * InputFieldsDefinition : { InputValueDefinition+ }
 */


function parseInputFieldsDefinition(lexer) {
  return peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseInputValueDef, _lexer.TokenKind.BRACE_R) : [];
}
/**
 * TypeSystemExtension :
 *   - SchemaExtension
 *   - TypeExtension
 *
 * TypeExtension :
 *   - ScalarTypeExtension
 *   - ObjectTypeExtension
 *   - InterfaceTypeExtension
 *   - UnionTypeExtension
 *   - EnumTypeExtension
 *   - InputObjectTypeDefinition
 */


function parseTypeSystemExtension(lexer) {
  var keywordToken = lexer.lookahead();

  if (keywordToken.kind === _lexer.TokenKind.NAME) {
    switch (keywordToken.value) {
      case 'schema':
        return parseSchemaExtension(lexer);

      case 'scalar':
        return parseScalarTypeExtension(lexer);

      case 'type':
        return parseObjectTypeExtension(lexer);

      case 'interface':
        return parseInterfaceTypeExtension(lexer);

      case 'union':
        return parseUnionTypeExtension(lexer);

      case 'enum':
        return parseEnumTypeExtension(lexer);

      case 'input':
        return parseInputObjectTypeExtension(lexer);
    }
  }

  throw unexpected(lexer, keywordToken);
}
/**
 * SchemaExtension :
 *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
 *  - extend schema Directives[Const]
 */


function parseSchemaExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'schema');
  var directives = parseDirectives(lexer, true);
  var operationTypes = peek(lexer, _lexer.TokenKind.BRACE_L) ? many(lexer, _lexer.TokenKind.BRACE_L, parseOperationTypeDefinition, _lexer.TokenKind.BRACE_R) : [];

  if (directives.length === 0 && operationTypes.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.SCHEMA_EXTENSION,
    directives: directives,
    operationTypes: operationTypes,
    loc: loc(lexer, start)
  };
}
/**
 * ScalarTypeExtension :
 *   - extend scalar Name Directives[Const]
 */


function parseScalarTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'scalar');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);

  if (directives.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.SCALAR_TYPE_EXTENSION,
    name: name,
    directives: directives,
    loc: loc(lexer, start)
  };
}
/**
 * ObjectTypeExtension :
 *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
 *  - extend type Name ImplementsInterfaces? Directives[Const]
 *  - extend type Name ImplementsInterfaces
 */


function parseObjectTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'type');
  var name = parseName(lexer);
  var interfaces = parseImplementsInterfaces(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);

  if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.OBJECT_TYPE_EXTENSION,
    name: name,
    interfaces: interfaces,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * InterfaceTypeExtension :
 *   - extend interface Name Directives[Const]? FieldsDefinition
 *   - extend interface Name Directives[Const]
 */


function parseInterfaceTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'interface');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseFieldsDefinition(lexer);

  if (directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.INTERFACE_TYPE_EXTENSION,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * UnionTypeExtension :
 *   - extend union Name Directives[Const]? UnionMemberTypes
 *   - extend union Name Directives[Const]
 */


function parseUnionTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'union');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var types = parseUnionMemberTypes(lexer);

  if (directives.length === 0 && types.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.UNION_TYPE_EXTENSION,
    name: name,
    directives: directives,
    types: types,
    loc: loc(lexer, start)
  };
}
/**
 * EnumTypeExtension :
 *   - extend enum Name Directives[Const]? EnumValuesDefinition
 *   - extend enum Name Directives[Const]
 */


function parseEnumTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'enum');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var values = parseEnumValuesDefinition(lexer);

  if (directives.length === 0 && values.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.ENUM_TYPE_EXTENSION,
    name: name,
    directives: directives,
    values: values,
    loc: loc(lexer, start)
  };
}
/**
 * InputObjectTypeExtension :
 *   - extend input Name Directives[Const]? InputFieldsDefinition
 *   - extend input Name Directives[Const]
 */


function parseInputObjectTypeExtension(lexer) {
  var start = lexer.token;
  expectKeyword(lexer, 'extend');
  expectKeyword(lexer, 'input');
  var name = parseName(lexer);
  var directives = parseDirectives(lexer, true);
  var fields = parseInputFieldsDefinition(lexer);

  if (directives.length === 0 && fields.length === 0) {
    throw unexpected(lexer);
  }

  return {
    kind: _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION,
    name: name,
    directives: directives,
    fields: fields,
    loc: loc(lexer, start)
  };
}
/**
 * DirectiveDefinition :
 *   - Description? directive @ Name ArgumentsDefinition? on DirectiveLocations
 */


function parseDirectiveDefinition(lexer) {
  var start = lexer.token;
  var description = parseDescription(lexer);
  expectKeyword(lexer, 'directive');
  expect(lexer, _lexer.TokenKind.AT);
  var name = parseName(lexer);
  var args = parseArgumentDefs(lexer);
  expectKeyword(lexer, 'on');
  var locations = parseDirectiveLocations(lexer);
  return {
    kind: _kinds.Kind.DIRECTIVE_DEFINITION,
    description: description,
    name: name,
    arguments: args,
    locations: locations,
    loc: loc(lexer, start)
  };
}
/**
 * DirectiveLocations :
 *   - `|`? DirectiveLocation
 *   - DirectiveLocations | DirectiveLocation
 */


function parseDirectiveLocations(lexer) {
  // Optional leading pipe
  skip(lexer, _lexer.TokenKind.PIPE);
  var locations = [];

  do {
    locations.push(parseDirectiveLocation(lexer));
  } while (skip(lexer, _lexer.TokenKind.PIPE));

  return locations;
}
/*
 * DirectiveLocation :
 *   - ExecutableDirectiveLocation
 *   - TypeSystemDirectiveLocation
 *
 * ExecutableDirectiveLocation : one of
 *   `QUERY`
 *   `MUTATION`
 *   `SUBSCRIPTION`
 *   `FIELD`
 *   `FRAGMENT_DEFINITION`
 *   `FRAGMENT_SPREAD`
 *   `INLINE_FRAGMENT`
 *
 * TypeSystemDirectiveLocation : one of
 *   `SCHEMA`
 *   `SCALAR`
 *   `OBJECT`
 *   `FIELD_DEFINITION`
 *   `ARGUMENT_DEFINITION`
 *   `INTERFACE`
 *   `UNION`
 *   `ENUM`
 *   `ENUM_VALUE`
 *   `INPUT_OBJECT`
 *   `INPUT_FIELD_DEFINITION`
 */


function parseDirectiveLocation(lexer) {
  var start = lexer.token;
  var name = parseName(lexer);

  if (_directiveLocation.DirectiveLocation.hasOwnProperty(name.value)) {
    return name;
  }

  throw unexpected(lexer, start);
} // Core parsing utility functions

/**
 * Returns a location object, used to identify the place in
 * the source that created a given parsed object.
 */


function loc(lexer, startToken) {
  if (!lexer.options.noLocation) {
    return new Loc(startToken, lexer.lastToken, lexer.source);
  }
}

function Loc(startToken, endToken, source) {
  this.start = startToken.start;
  this.end = endToken.end;
  this.startToken = startToken;
  this.endToken = endToken;
  this.source = source;
} // Print a simplified form when appearing in JSON/util.inspect.


Loc.prototype.toJSON = Loc.prototype.inspect = function toJSON() {
  return {
    start: this.start,
    end: this.end
  };
};
/**
 * Determines if the next token is of a given kind
 */


function peek(lexer, kind) {
  return lexer.token.kind === kind;
}
/**
 * If the next token is of the given kind, return true after advancing
 * the lexer. Otherwise, do not change the parser state and return false.
 */


function skip(lexer, kind) {
  var match = lexer.token.kind === kind;

  if (match) {
    lexer.advance();
  }

  return match;
}
/**
 * If the next token is of the given kind, return that token after advancing
 * the lexer. Otherwise, do not change the parser state and throw an error.
 */


function expect(lexer, kind) {
  var token = lexer.token;

  if (token.kind === kind) {
    lexer.advance();
    return token;
  }

  throw (0, _error.syntaxError)(lexer.source, token.start, "Expected ".concat(kind, ", found ").concat((0, _lexer.getTokenDesc)(token)));
}
/**
 * If the next token is a keyword with the given value, return that token after
 * advancing the lexer. Otherwise, do not change the parser state and return
 * false.
 */


function expectKeyword(lexer, value) {
  var token = lexer.token;

  if (token.kind === _lexer.TokenKind.NAME && token.value === value) {
    lexer.advance();
    return token;
  }

  throw (0, _error.syntaxError)(lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat((0, _lexer.getTokenDesc)(token)));
}
/**
 * Helper function for creating an error when an unexpected lexed token
 * is encountered.
 */


function unexpected(lexer, atToken) {
  var token = atToken || lexer.token;
  return (0, _error.syntaxError)(lexer.source, token.start, "Unexpected ".concat((0, _lexer.getTokenDesc)(token)));
}
/**
 * Returns a possibly empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */


function any(lexer, openKind, parseFn, closeKind) {
  expect(lexer, openKind);
  var nodes = [];

  while (!skip(lexer, closeKind)) {
    nodes.push(parseFn(lexer));
  }

  return nodes;
}
/**
 * Returns a non-empty list of parse nodes, determined by
 * the parseFn. This list begins with a lex token of openKind
 * and ends with a lex token of closeKind. Advances the parser
 * to the next lex token after the closing token.
 */


function many(lexer, openKind, parseFn, closeKind) {
  expect(lexer, openKind);
  var nodes = [parseFn(lexer)];

  while (!skip(lexer, closeKind)) {
    nodes.push(parseFn(lexer));
  }

  return nodes;
}

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(89);

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = __webpack_require__(212);

var _warning2 = _interopRequireDefault(_warning);

var _PathUtils = __webpack_require__(206);

var _Actions = __webpack_require__(444);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createQuery = exports.createQuery = function createQuery(props) {
  return _extends(Object.create(null), props);
};

var createLocation = exports.createLocation = function createLocation() {
  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;

   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;

  var pathname = object.pathname || '/';
  var search = object.search || '';
  var hash = object.hash || '';
  var state = object.state;

  return {
    pathname: pathname,
    search: search,
    hash: hash,
    state: state,
    action: action,
    key: key
  };
};

var isDate = function isDate(object) {
  return Object.prototype.toString.call(object) === '[object Date]';
};

var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
  if (a === b) return true;

  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);

  if (typeofA !== typeofB) return false;

  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;

  // Not the same object, but same type.
  if (typeofA === 'object') {
    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;

    if (!Array.isArray(a)) {
      var keysofA = Object.keys(a);
      var keysofB = Object.keys(b);
      return keysofA.length === keysofB.length && keysofA.every(function (key) {
        return statesAreEqual(a[key], b[key]);
      });
    }

    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return statesAreEqual(item, b[index]);
    });
  }

  // All other serializable types (string, number, boolean)
  // should be strict equal.
  return false;
};

var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
  return a.key === b.key &&
  // a.action === b.action && // Different action !== location change.
  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(3048),
    getValue = __webpack_require__(3062);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var MAX_BYTES = 65536

// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var MAX_UINT32 = 4294967295

function oldBrowser () {
  throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11')
}

var Buffer = __webpack_require__(42).Buffer
var crypto = global.crypto || global.msCrypto

if (crypto && crypto.getRandomValues) {
  module.exports = randomBytes
} else {
  module.exports = oldBrowser
}

function randomBytes (size, cb) {
  // phantomjs needs to throw
  if (size > MAX_UINT32) throw new RangeError('requested too many random bytes')

  var bytes = Buffer.allocUnsafe(size)

  if (size > 0) {  // getRandomValues fails on IE if size == 0
    if (size > MAX_BYTES) { // this is the max bytes crypto.getRandomValues
      // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
      for (var generated = 0; generated < size; generated += MAX_BYTES) {
        // buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        crypto.getRandomValues(bytes.slice(generated, generated + MAX_BYTES))
      }
    } else {
      crypto.getRandomValues(bytes)
    }
  }

  if (typeof cb === 'function') {
    return process.nextTick(function () {
      cb(null, bytes)
    })
  }

  return bytes
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56), __webpack_require__(90)))

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clone = clone;
exports.isDate = isDate;
exports.addMonths = addMonths;
exports.isSameDay = isSameDay;
exports.isSameMonth = isSameMonth;
exports.isDayBefore = isDayBefore;
exports.isDayAfter = isDayAfter;
exports.isPastDay = isPastDay;
exports.isFutureDay = isFutureDay;
exports.isDayBetween = isDayBetween;
exports.addDayToRange = addDayToRange;
exports.isDayInRange = isDayInRange;
exports.getWeekNumber = getWeekNumber;
/**
 * Clone a date object.
 *
 * @export
 * @param  {Date} d The date to clone
 * @return {Date} The cloned date
 */
function clone(d) {
  return new Date(d.getTime());
}

/**
 * Return `true` if the passed value is a valid JavaScript Date object.
 *
 * @export
 * @param {any} value
 * @returns {Boolean}
 */
function isDate(value) {
  return value instanceof Date && !isNaN(value.valueOf());
}

/**
 * Return `d` as a new date with `n` months added.
 *
 * @export
 * @param {Date} d
 * @param {number} n
 */
function addMonths(d, n) {
  var newDate = clone(d);
  newDate.setMonth(d.getMonth() + n);
  return newDate;
}

/**
 * Return `true` if two dates are the same day, ignoring the time.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameDay(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getDate() === d2.getDate() && d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Return `true` if two dates fall in the same month.
 *
 * @export
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isSameMonth(d1, d2) {
  if (!d1 || !d2) {
    return false;
  }
  return d1.getMonth() === d2.getMonth() && d1.getFullYear() === d2.getFullYear();
}

/**
 * Returns `true` if the first day is before the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */
function isDayBefore(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 < day2;
}

/**
 * Returns `true` if the first day is after the second day.
 *
 * @export
 * @param {Date} d1
 * @param {Date} d2
 * @returns {Boolean}
 */
function isDayAfter(d1, d2) {
  var day1 = clone(d1).setHours(0, 0, 0, 0);
  var day2 = clone(d2).setHours(0, 0, 0, 0);
  return day1 > day2;
}

/**
 * Return `true` if a day is in the past, e.g. yesterday or any day
 * before yesterday.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isPastDay(d) {
  var today = new Date();
  today.setHours(0, 0, 0, 0);
  return isDayBefore(d, today);
}

/**
 * Return `true` if a day is in the future, e.g. tomorrow or any day
 * after tomorrow.
 *
 * @export
 * @param  {Date}  d
 * @return {Boolean}
 */
function isFutureDay(d) {
  var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
  tomorrow.setHours(0, 0, 0, 0);
  return d >= tomorrow;
}

/**
 * Return `true` if day `d` is between days `d1` and `d2`,
 * without including them.
 *
 * @export
 * @param  {Date}  d
 * @param  {Date}  d1
 * @param  {Date}  d2
 * @return {Boolean}
 */
function isDayBetween(d, d1, d2) {
  var date = clone(d);
  date.setHours(0, 0, 0, 0);
  return isDayAfter(date, d1) && isDayBefore(date, d2) || isDayAfter(date, d2) && isDayBefore(date, d1);
}

/**
 * Add a day to a range and return a new range. A range is an object with
 * `from` and `to` days.
 *
 * @export
 * @param {Date} day
 * @param {Object} range
 * @return {Object} Returns a new range object
 */
function addDayToRange(day) {
  var range = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { from: null, to: null };
  var from = range.from,
      to = range.to;

  if (!from) {
    from = day;
  } else if (from && to && isSameDay(from, to) && isSameDay(day, from)) {
    from = null;
    to = null;
  } else if (to && isDayBefore(day, from)) {
    from = day;
  } else if (to && isSameDay(day, to)) {
    from = day;
    to = day;
  } else {
    to = day;
    if (isDayBefore(to, from)) {
      to = from;
      from = day;
    }
  }

  return { from: from, to: to };
}

/**
 * Return `true` if a day is included in a range of days.
 *
 * @export
 * @param  {Date}  day
 * @param  {Object}  range
 * @return {Boolean}
 */
function isDayInRange(day, range) {
  var from = range.from,
      to = range.to;

  return from && isSameDay(day, from) || to && isSameDay(day, to) || from && to && isDayBetween(day, from, to);
}

/**
 * Return the year's week number (as per ISO, i.e. with the week starting from monday)
 * for the given day.
 *
 * @export
 * @param {Date} day
 * @returns {Number}
 */
function getWeekNumber(day) {
  var date = clone(day);
  date.setHours(0, 0, 0);
  date.setDate(date.getDate() + 4 - (date.getDay() || 7));
  return Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 8.64e7 + 1) / 7);
}

exports.default = {
  addDayToRange: addDayToRange,
  addMonths: addMonths,
  clone: clone,
  getWeekNumber: getWeekNumber,
  isDate: isDate,
  isDayAfter: isDayAfter,
  isDayBefore: isDayBefore,
  isDayBetween: isDayBetween,
  isDayInRange: isDayInRange,
  isFutureDay: isFutureDay,
  isPastDay: isPastDay,
  isSameDay: isSameDay,
  isSameMonth: isSameMonth
};
//# sourceMappingURL=DateUtils.js.map

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ReactGAImplementation = void 0;
var _ga = _interopRequireWildcard(__webpack_require__(3180));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ReactGAImplementation = _ga.GA4;
exports.ReactGAImplementation = ReactGAImplementation;
var _default = _ga["default"];
exports["default"] = _default;

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return I18nContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ReportNamespaces; });
/* harmony export (immutable) */ __webpack_exports__["b"] = composeInitialProps;
/* harmony export (immutable) */ __webpack_exports__["c"] = getInitialProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__ = __webpack_require__(527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaults_js__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__i18nInstance_js__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__initReactI18next_js__ = __webpack_require__(1410);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__defaults_js__["b"]; });
/* unused harmony reexport setDefaults */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__i18nInstance_js__["b"]; });
/* unused harmony reexport setI18n */
/* unused harmony reexport initReactI18next */




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }






var I18nContext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["createContext"])();
var ReportNamespaces = function () {
  function ReportNamespaces() {
    __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_classCallCheck___default()(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_createClass___default()(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function composeInitialProps(ForComponent) {
  return function (ctx) {
    return new Promise(function (resolve) {
      var i18nInitialProps = getInitialProps();

      if (ForComponent.getInitialProps) {
        ForComponent.getInitialProps(ctx).then(function (componentsInitialProps) {
          resolve(_objectSpread(_objectSpread({}, componentsInitialProps), i18nInitialProps));
        });
      } else {
        resolve(i18nInitialProps);
      }
    });
  };
}
function getInitialProps() {
  var i18n = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__i18nInstance_js__["b" /* getI18n */])();
  var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
  var ret = {};
  var initialI18nStore = {};
  i18n.languages.forEach(function (l) {
    initialI18nStore[l] = {};
    namespaces.forEach(function (ns) {
      initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
    });
  });
  ret.initialI18nStore = initialI18nStore;
  ret.initialLanguage = i18n.language;
  return ret;
}

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export compilePattern */
/* harmony export (immutable) */ __webpack_exports__["c"] = matchPattern;
/* harmony export (immutable) */ __webpack_exports__["b"] = getParamNames;
/* unused harmony export getParams */
/* harmony export (immutable) */ __webpack_exports__["a"] = formatPattern;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);


function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? invariant(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? invariant(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? invariant(false, 'Path "%s" is missing end paren', pattern) : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);


var warned = {};

function routerWarning(falseToWarn, message) {
  // Only issue deprecation warnings once.
  if (message.indexOf('deprecated') !== -1) {
    if (warned[message]) {
      return;
    }

    warned[message] = true;
  }

  message = '[react-router] ' + message;

  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  __WEBPACK_IMPORTED_MODULE_0_warning___default.a.apply(undefined, [falseToWarn, message].concat(args));
}

function _resetWarned() {
  warned = {};
}

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(296);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (toKey);


/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHas_js__ = __webpack_require__(3346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__(1568);



/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHas_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (has);


/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(149);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(139);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(139);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(42).Buffer

// prototype class for hash functions
function Hash (blockSize, finalSize) {
  this._block = Buffer.alloc(blockSize)
  this._finalSize = finalSize
  this._blockSize = blockSize
  this._len = 0
}

Hash.prototype.update = function (data, enc) {
  if (typeof data === 'string') {
    enc = enc || 'utf8'
    data = Buffer.from(data, enc)
  }

  var block = this._block
  var blockSize = this._blockSize
  var length = data.length
  var accum = this._len

  for (var offset = 0; offset < length;) {
    var assigned = accum % blockSize
    var remainder = Math.min(length - offset, blockSize - assigned)

    for (var i = 0; i < remainder; i++) {
      block[assigned + i] = data[offset + i]
    }

    accum += remainder
    offset += remainder

    if ((accum % blockSize) === 0) {
      this._update(block)
    }
  }

  this._len += length
  return this
}

Hash.prototype.digest = function (enc) {
  var rem = this._len % this._blockSize

  this._block[rem] = 0x80

  // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
  // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
  this._block.fill(0, rem + 1)

  if (rem >= this._finalSize) {
    this._update(this._block)
    this._block.fill(0)
  }

  var bits = this._len * 8

  // uint32
  if (bits <= 0xffffffff) {
    this._block.writeUInt32BE(bits, this._blockSize - 4)

  // uint64
  } else {
    var lowBits = (bits & 0xffffffff) >>> 0
    var highBits = (bits - lowBits) / 0x100000000

    this._block.writeUInt32BE(highBits, this._blockSize - 8)
    this._block.writeUInt32BE(lowBits, this._blockSize - 4)
  }

  this._update(this._block)
  var hash = this._hash()

  return enc ? hash.toString(enc) : hash
}

Hash.prototype._update = function () {
  throw new Error('_update must be implemented by subclass')
}

module.exports = Hash


/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTEiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxMSAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNzY5MTIgMC4yNDY3MDRDOS42OTA5MyAwLjE2ODQ4MiA5LjU5ODEgMC4xMDY0MjIgOS40OTU5MiAwLjA2NDA4NjlDOS4zOTM3NSAwLjAyMTc1MTkgOS4yODQyMyAwIDkuMTczNjMgMEM5LjA2MzAzIDAgOC45NTM1MSAwLjAyMTc1MTkgOC44NTEzMyAwLjA2NDA4NjlDOC43NDkxNSAwLjEwNjQyMiA4LjY1NjMzIDAuMTY4NDgyIDguNTc4MTQgMC4yNDY3MDRMNS4wMTcxMyAzLjgwOTY5TDEuNDUwMTIgMC4yNDY3MDRDMS4yOTIxOCAwLjA4ODc2NzcgMS4wNzc5OCAwLjAwMDEyMjA1MyAwLjg1NDYyNyAwLjAwMDEyMjA3QzAuNjMxMjcyIDAuMDAwMTIyMDg4IDAuNDE3MDc0IDAuMDg4NzY3NyAwLjI1OTEzOCAwLjI0NjcwNEMwLjEwMTIwMSAwLjQwNDY0IDAuMDEyNDY0MyAwLjYxODkyOSAwLjAxMjQ2NDMgMC44NDIyODVDMC4wMTI0NjQzIDEuMDY1NjQgMC4xMDEyMDEgMS4yNzk4MSAwLjI1OTEzOCAxLjQzNzc0TDMuODIzMTMgNC45OTk3NkwwLjI1OTEzOCA4LjU2MzcyQzAuMTc4MjU4IDguNjQxMzEgMC4xMTM2NTMgOC43MzQyOSAwLjA2OTE2NTkgOC44MzcxNkMwLjAyNDY3ODQgOC45NDAwMyAwLjAwMTE4NDg0IDkuMDUwNzcgNC4zNjI5ZS0wNSA5LjE2Mjg0Qy0wLjAwMTA5NzU4IDkuMjc0OTEgMC4wMjAxNjAxIDkuMzg1OTkgMC4wNjI1NDM2IDkuNDg5NzVDMC4xMDQ5MjcgOS41OTM1IDAuMTY3NTg3IDkuNjg3NzUgMC4yNDY4NyA5Ljc2Njk3QzAuMzI2MTUyIDkuODQ2MTggMC40MjA0NTYgOS45MDg3NSAwLjUyNDI0NCA5Ljk1MTA1QzAuNjI4MDMyIDkuOTkzMzUgMC43MzkyMDIgMTAuMDE0NSAwLjg1MTI3IDEwLjAxMzNDMC45NjMzMzkgMTAuMDEyMSAxLjA3NDA2IDkuOTg4NDIgMS4xNzY4OSA5Ljk0Mzg1QzEuMjc5NzIgOS44OTkyNyAxLjM3MjYgOS44MzQ3MyAxLjQ1MDEyIDkuNzUzNzhMNS4wMTMxNCA2LjE5MTc3TDguNTc0MTEgOS43NTA3M0M4LjczMzAzIDkuOTAzMTggOC45NDUzNiA5Ljk4NzM1IDkuMTY1NTcgOS45ODUxMUM5LjM4NTc4IDkuOTgyODcgOS41OTYzNiA5Ljg5NDQyIDkuNzUyMTUgOS43Mzg3N0M5LjkwNzkzIDkuNTgzMTIgOS45OTY1MiA5LjM3MjU1IDkuOTk4OTUgOS4xNTIzNEMxMC4wMDE0IDguOTMyMTQgOS45MTc0NCA4LjcxOTcyIDkuNzY1MTIgOC41NjA2N0w2LjIwNDExIDUuMDAwNzNMOS43NjUxMiAxLjQzODcyQzkuODQzNzUgMS4zNjA3NyA5LjkwNjI1IDEuMjY4MTQgOS45NDkwMiAxLjE2NjAyQzkuOTkxNzkgMS4wNjM4OSAxMC4wMTQgMC45NTQyMjYgMTAuMDE0NCAwLjg0MzUwNkMxMC4wMTQ3IDAuNzMyNzg2IDkuOTkzMjcgMC42MjMxNjQgOS45NTExOSAwLjUyMDc1MkM5LjkwOTEgMC40MTgzNCA5Ljg0NzIzIDAuMzI1MTc2IDkuNzY5MTIgMC4yNDY3MDRaIiBmaWxsPSIjMDAyMzNCIi8+Cjwvc3ZnPgo="

/***/ }),
/* 299 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AmplifyClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Amplify; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(111);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('Amplify');
var AmplifyClass = /** @class */ (function () {
    function AmplifyClass() {
        // Everything that is `register`ed is tracked here
        this._components = [];
        this._config = {};
        // All modules (with `getModuleName()`) are stored here for dependency injection
        this._modules = {};
        // for backward compatibility to avoid breaking change
        // if someone is using like Amplify.Auth
        this.Auth = null;
        this.Analytics = null;
        this.API = null;
        this.Credentials = null;
        this.Storage = null;
        this.I18n = null;
        this.Cache = null;
        this.PubSub = null;
        this.Interactions = null;
        this.Pushnotification = null;
        this.UI = null;
        this.XR = null;
        this.Predictions = null;
        this.DataStore = null;
        this.Logger = __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */];
        this.ServiceWorker = null;
    }
    AmplifyClass.prototype.register = function (comp) {
        logger.debug('component registered in amplify', comp);
        this._components.push(comp);
        if (typeof comp.getModuleName === 'function') {
            this._modules[comp.getModuleName()] = comp;
            this[comp.getModuleName()] = comp;
        }
        else {
            logger.debug('no getModuleName method for component', comp);
        }
        // Finally configure this new component(category) loaded
        // With the new modularization changes in Amplify V3, all the Amplify
        // component are not loaded/registered right away but when they are
        // imported (and hence instantiated) in the client's app. This ensures
        // that all new components imported get correctly configured with the
        // configuration that Amplify.configure() was called with.
        comp.configure(this._config);
    };
    AmplifyClass.prototype.configure = function (config) {
        var _this = this;
        if (!config)
            return this._config;
        this._config = Object.assign(this._config, config);
        logger.debug('amplify config', this._config);
        // Dependency Injection via property-setting.
        // This avoids introducing a public method/interface/setter that's difficult to remove later.
        // Plus, it reduces `if` statements within the `constructor` and `configure` of each module
        Object.entries(this._modules).forEach(function (_a) {
            var _b = __read(_a, 2), Name = _b[0], comp = _b[1];
            // e.g. Auth.*
            Object.keys(comp).forEach(function (property) {
                // e.g. Auth["Credentials"] = this._modules["Credentials"] when set
                if (_this._modules[property]) {
                    comp[property] = _this._modules[property];
                }
            });
        });
        this._components.map(function (comp) {
            comp.configure(_this._config);
        });
        return this._config;
    };
    AmplifyClass.prototype.addPluggable = function (pluggable) {
        if (pluggable &&
            pluggable['getCategory'] &&
            typeof pluggable['getCategory'] === 'function') {
            this._components.map(function (comp) {
                if (comp['addPluggable'] &&
                    typeof comp['addPluggable'] === 'function') {
                    comp.addPluggable(pluggable);
                }
            });
        }
    };
    return AmplifyClass;
}());

var Amplify = new AmplifyClass();
/**
 * @deprecated use named import
 */
/* unused harmony default export */ var _unused_webpack_default_export = (Amplify);
//# sourceMappingURL=Amplify.js.map

/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Retry__ = __webpack_require__(1637);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Retry__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__Retry__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__Retry__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Mutex__ = __webpack_require__(1635);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Mutex__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reachability__ = __webpack_require__(1636);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Reachability__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DateUtils__ = __webpack_require__(1634);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_3__DateUtils__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StringUtils__ = __webpack_require__(1638);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__StringUtils__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_4__StringUtils__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Constants__ = __webpack_require__(511);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_5__Constants__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_5__Constants__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__Constants__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_5__Constants__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_5__Constants__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_5__Constants__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_5__Constants__["g"]; });






//# sourceMappingURL=index.js.map

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__autoLoader__ = __webpack_require__(1967);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "registerInstrumentations", function() { return __WEBPACK_IMPORTED_MODULE_0__autoLoader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform_index__ = __webpack_require__(925);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InstrumentationBase", function() { return __WEBPACK_IMPORTED_MODULE_1__platform_index__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instrumentationNodeModuleDefinition__ = __webpack_require__(1970);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InstrumentationNodeModuleDefinition", function() { return __WEBPACK_IMPORTED_MODULE_2__instrumentationNodeModuleDefinition__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instrumentationNodeModuleFile__ = __webpack_require__(1971);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InstrumentationNodeModuleFile", function() { return __WEBPACK_IMPORTED_MODULE_3__instrumentationNodeModuleFile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(1974);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "isWrapped", function() { return __WEBPACK_IMPORTED_MODULE_4__utils__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "safeExecuteInTheMiddle", function() { return __WEBPACK_IMPORTED_MODULE_4__utils__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "safeExecuteInTheMiddleAsync", function() { return __WEBPACK_IMPORTED_MODULE_4__utils__["c"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





//# sourceMappingURL=index.js.map

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Resource; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_semantic_conventions__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__platform__ = __webpack_require__(933);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};




/**
 * A Resource describes the entity for which a signals (metrics or trace) are
 * collected.
 */
var Resource = /** @class */ (function () {
    function Resource(
    /**
     * A dictionary of attributes with string keys and values that provide
     * information about the entity as numbers, strings or booleans
     * TODO: Consider to add check/validation on attributes.
     */
    attributes, asyncAttributesPromise) {
        var _this = this;
        var _a;
        this._attributes = attributes;
        this.asyncAttributesPending = asyncAttributesPromise != null;
        this._syncAttributes = (_a = this._attributes) !== null && _a !== void 0 ? _a : {};
        this._asyncAttributesPromise = asyncAttributesPromise === null || asyncAttributesPromise === void 0 ? void 0 : asyncAttributesPromise.then(function (asyncAttributes) {
            _this._attributes = Object.assign({}, _this._attributes, asyncAttributes);
            _this.asyncAttributesPending = false;
            return asyncAttributes;
        }, function (err) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].debug("a resource's async attributes promise rejected: %s", err);
            _this.asyncAttributesPending = false;
            return {};
        });
    }
    /**
     * Returns an empty Resource
     */
    Resource.empty = function () {
        return Resource.EMPTY;
    };
    /**
     * Returns a Resource that identifies the SDK in use.
     */
    Resource.default = function () {
        var _a;
        return new Resource((_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_1__opentelemetry_semantic_conventions__["m" /* SEMRESATTRS_SERVICE_NAME */]] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__platform__["a" /* defaultServiceName */])(),
            _a[__WEBPACK_IMPORTED_MODULE_1__opentelemetry_semantic_conventions__["q" /* SEMRESATTRS_TELEMETRY_SDK_LANGUAGE */]] = __WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__["SDK_INFO"][__WEBPACK_IMPORTED_MODULE_1__opentelemetry_semantic_conventions__["q" /* SEMRESATTRS_TELEMETRY_SDK_LANGUAGE */]],
            _a[__WEBPACK_IMPORTED_MODULE_1__opentelemetry_semantic_conventions__["r" /* SEMRESATTRS_TELEMETRY_SDK_NAME */]] = __WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__["SDK_INFO"][__WEBPACK_IMPORTED_MODULE_1__opentelemetry_semantic_conventions__["r" /* SEMRESATTRS_TELEMETRY_SDK_NAME */]],
            _a[__WEBPACK_IMPORTED_MODULE_1__opentelemetry_semantic_conventions__["s" /* SEMRESATTRS_TELEMETRY_SDK_VERSION */]] = __WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__["SDK_INFO"][__WEBPACK_IMPORTED_MODULE_1__opentelemetry_semantic_conventions__["s" /* SEMRESATTRS_TELEMETRY_SDK_VERSION */]],
            _a));
    };
    Object.defineProperty(Resource.prototype, "attributes", {
        get: function () {
            var _a;
            if (this.asyncAttributesPending) {
                __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].error('Accessing resource attributes before async attributes settled');
            }
            return (_a = this._attributes) !== null && _a !== void 0 ? _a : {};
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Returns a promise that will never be rejected. Resolves when all async attributes have finished being added to
     * this Resource's attributes. This is useful in exporters to block until resource detection
     * has finished.
     */
    Resource.prototype.waitForAsyncAttributes = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.asyncAttributesPending) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._asyncAttributesPromise];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns a new, merged {@link Resource} by merging the current Resource
     * with the other Resource. In case of a collision, other Resource takes
     * precedence.
     *
     * @param other the Resource that will be merged with this.
     * @returns the newly merged Resource.
     */
    Resource.prototype.merge = function (other) {
        var _this = this;
        var _a;
        if (!other)
            return this;
        // SpanAttributes from other resource overwrite attributes from this resource.
        var mergedSyncAttributes = __assign(__assign({}, this._syncAttributes), ((_a = other._syncAttributes) !== null && _a !== void 0 ? _a : other.attributes));
        if (!this._asyncAttributesPromise &&
            !other._asyncAttributesPromise) {
            return new Resource(mergedSyncAttributes);
        }
        var mergedAttributesPromise = Promise.all([
            this._asyncAttributesPromise,
            other._asyncAttributesPromise,
        ]).then(function (_a) {
            var _b;
            var _c = __read(_a, 2), thisAsyncAttributes = _c[0], otherAsyncAttributes = _c[1];
            return __assign(__assign(__assign(__assign({}, _this._syncAttributes), thisAsyncAttributes), ((_b = other._syncAttributes) !== null && _b !== void 0 ? _b : other.attributes)), otherAsyncAttributes);
        });
        return new Resource(mergedSyncAttributes, mergedAttributesPromise);
    };
    Resource.EMPTY = new Resource({});
    return Resource;
}());

//# sourceMappingURL=Resource.js.map

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBoundingClientRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instanceOf_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_math_js__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getWindow_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isLayoutViewport_js__ = __webpack_require__(945);




function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__instanceOf_js__["b" /* isHTMLElement */])(element)) {
    scaleX = element.offsetWidth > 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_math_js__["a" /* round */])(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_math_js__["a" /* round */])(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__instanceOf_js__["a" /* isElement */])(element) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getWindow_js__["a" /* default */])(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isLayoutViewport_js__["a" /* default */])() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getComputedStyle;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(151);

function getComputedStyle(element) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(element).getComputedStyle(element);
}

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOffsetParent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getNodeName_js__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instanceOf_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isTableElement_js__ = __webpack_require__(2032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getParentNode_js__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_userAgent_js__ = __webpack_require__(959);








function getTrueOffsetParent(element) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(element) || // https://github.com/popperjs/popper-core/issues/837
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_userAgent_js__["a" /* default */])());
  var isIE = /Trident/i.test(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_userAgent_js__["a" /* default */])());

  if (isIE && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getParentNode_js__["a" /* default */])(element);

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["c" /* isShadowRoot */])(currentNode)) {
    currentNode = currentNode.host;
  }

  while (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(currentNode) && ['html', 'body'].indexOf(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getNodeName_js__["a" /* default */])(currentNode)) < 0) {
    var css = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__isTableElement_js__["a" /* default */])(offsetParent) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getNodeName_js__["a" /* default */])(offsetParent) === 'html' || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getNodeName_js__["a" /* default */])(offsetParent) === 'body' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getComputedStyle_js__["a" /* default */])(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = detectOverflow;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_utils_getClippingRect_js__ = __webpack_require__(2025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_getDocumentElement_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_utils_getBoundingClientRect_js__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__computeOffsets_js__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rectToClientRect_js__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dom_utils_instanceOf_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mergePaddingObject_js__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__expandToHashMap_js__ = __webpack_require__(955);








 // eslint-disable-next-line import/no-unused-modules

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["b" /* clippingParents */] : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["c" /* viewport */] : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["d" /* popper */] : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__mergePaddingObject_js__["a" /* default */])(typeof padding !== 'number' ? padding : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__expandToHashMap_js__["a" /* default */])(padding, __WEBPACK_IMPORTED_MODULE_5__enums_js__["e" /* basePlacements */]));
  var altContext = elementContext === __WEBPACK_IMPORTED_MODULE_5__enums_js__["d" /* popper */] ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["f" /* reference */] : __WEBPACK_IMPORTED_MODULE_5__enums_js__["d" /* popper */];
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getClippingRect_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__dom_utils_instanceOf_js__["a" /* isElement */])(element) ? element : element.contextElement || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_utils_getDocumentElement_js__["a" /* default */])(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_utils_getBoundingClientRect_js__["a" /* default */])(state.elements.reference);
  var popperOffsets = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__computeOffsets_js__["a" /* default */])({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__rectToClientRect_js__["a" /* default */])(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === __WEBPACK_IMPORTED_MODULE_5__enums_js__["d" /* popper */] ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === __WEBPACK_IMPORTED_MODULE_5__enums_js__["d" /* popper */] && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [__WEBPACK_IMPORTED_MODULE_5__enums_js__["g" /* right */], __WEBPACK_IMPORTED_MODULE_5__enums_js__["h" /* bottom */]].indexOf(key) >= 0 ? 1 : -1;
      var axis = [__WEBPACK_IMPORTED_MODULE_5__enums_js__["i" /* top */], __WEBPACK_IMPORTED_MODULE_5__enums_js__["h" /* bottom */]].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getVariation;
function getVariation(placement) {
  return placement.split('-')[1];
}

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = exports;

asn1.bignum = __webpack_require__(77);

asn1.define = __webpack_require__(2051).define;
asn1.base = __webpack_require__(311);
asn1.constants = __webpack_require__(976);
asn1.decoders = __webpack_require__(2055);
asn1.encoders = __webpack_require__(2057);


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

var base = exports;

base.Reporter = __webpack_require__(2053).Reporter;
base.DecoderBuffer = __webpack_require__(975).DecoderBuffer;
base.EncoderBuffer = __webpack_require__(975).EncoderBuffer;
base.Node = __webpack_require__(2052);


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCustomOptions = fetchCustomOptions;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function customOptionsRequest() {
  return {
    type: _actions.CUSTOM_OPTIONS_REQUEST
  };
}

function customOptionsSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.CUSTOM_OPTIONS_SUCCESS,
    payload: {
      data: data,
      token: token
    }
  };
}

function customOptionsError(message) {
  return {
    type: _actions.CUSTOM_OPTIONS_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchCustomOptions() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(customOptionsRequest());
    if (!fresh) {
      var customOptionsData = {};
      try {
        customOptionsData = JSON.parse((0, _storage.getItem)(_config2.default.get('appName') + '.customOptions')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!customOptionsData.data || _config2.default.get('version') !== customOptionsData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(customOptionsData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(customOptionsSuccess(customOptionsData.data));
        return Promise.resolve();
      }
    }
    return dispatch((0, _fetchM.fetchM)('/custom_options/', {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        (0, _storage.setItem)(_config2.default.get('appName') + '.customOptions', JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(customOptionsSuccess(data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, customOptionsError));
    });
  };
}

/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NoteEditor = exports.List = exports.BookingNote = undefined;

var _BookingNote = __webpack_require__(2094);

var _BookingNote2 = _interopRequireDefault(_BookingNote);

var _List = __webpack_require__(2095);

var _List2 = _interopRequireDefault(_List);

var _NoteEditor = __webpack_require__(2100);

var _NoteEditor2 = _interopRequireDefault(_NoteEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BookingNote = _BookingNote2.default;
exports.List = _List2.default;
exports.NoteEditor = _NoteEditor2.default;
exports.default = _BookingNote2.default;

/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCalendar = __webpack_require__(1405);

var _reactCalendar2 = _interopRequireDefault(_reactCalendar);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

var _calendarDate = __webpack_require__(1087);

var _TimePicker = __webpack_require__(2209);

var _TimePicker2 = _interopRequireDefault(_TimePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


_momentTimezone2.default.locale('en-gb');

var DateTimePicker = function (_Component) {
  _inherits(DateTimePicker, _Component);

  function DateTimePicker(props) {
    _classCallCheck(this, DateTimePicker);

    var _this = _possibleConstructorReturn(this, (DateTimePicker.__proto__ || Object.getPrototypeOf(DateTimePicker)).call(this, props));

    _initialiseProps.call(_this);

    var date = props.value;
    _this.state = {
      date: date,
      loading: false,
      tabIndex: 1,
      transition: {
        calendar: true,
        time: false
      },
      visible: props.visible
    };
    return _this;
  }

  _createClass(DateTimePicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var date = nextProps.value;
      this.setState({
        date: date,
        visible: nextProps.visible
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          loading = _state.loading,
          date = _state.date,
          tabIndex = _state.tabIndex,
          transition = _state.transition,
          visible = _state.visible;
      var _props = this.props,
          basic = _props.basic,
          closeable = _props.closeable,
          closeableCompact = _props.closeableCompact,
          maxDate = _props.maxDate,
          minDate = _props.minDate,
          noPadding = _props.noPadding,
          t = _props.t,
          useBrowserTimezone = _props.useBrowserTimezone;

      var currentLang = this.props.i18n && this.props.i18n.language || 'en-GB';
      return _react2.default.createElement(
        _semanticUiReact.Transition,
        {
          animation: 'vertical flip',
          duration: 250,
          transitionOnMount: true,
          unmountOnHide: true,
          visible: visible
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { centered: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: noPadding && { paddingTop: '0' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { basic: basic, className: 'dtp visible' },
                _react2.default.createElement(
                  _semanticUiReact.Button.Group,
                  { fluid: true },
                  _react2.default.createElement(
                    _semanticUiReact.Button,
                    {
                      disabled: loading,
                      onClick: function onClick(e) {
                        return tabIndex === 2 && _this2.handleTabChange(e, 1);
                      },
                      active: tabIndex === 1,
                      color: tabIndex === 1 ? 'teal' : null
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'calendar' }),
                    t('Date')
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Button,
                    {
                      disabled: loading,
                      onClick: function onClick(e) {
                        return tabIndex === 1 && _this2.handleTabChange(e, 2);
                      },
                      active: tabIndex === 2,
                      color: tabIndex === 2 ? 'teal' : null
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'clock' }),
                    t('Time')
                  )
                ),
                tabIndex === 1 && _react2.default.createElement(
                  _semanticUiReact.Transition,
                  {
                    animation: 'scale',
                    duration: 250,
                    unmountOnHide: true,
                    visible: transition.calendar,
                    onComplete: this.setLoading,
                    onHide: this.setLoading
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Segment,
                    { basic: true, className: 'dtp_tab_content' },
                    _react2.default.createElement(_reactCalendar2.default, {
                      locale: currentLang,
                      maxDate: maxDate && (0, _calendarDate.toCalendarTile)(maxDate, useBrowserTimezone),
                      minDate: minDate && (0, _calendarDate.toCalendarTile)(minDate, useBrowserTimezone),
                      onChange: this.handleOnChangeCalendar,
                      value: (0, _calendarDate.toCalendarTile)(date || (0, _momentTimezone2.default)(), useBrowserTimezone)
                    })
                  )
                ),
                tabIndex === 2 && _react2.default.createElement(
                  _semanticUiReact.Transition,
                  {
                    animation: 'scale',
                    duration: 250,
                    unmountOnHide: true,
                    visible: transition.time,
                    onComplete: this.setLoading,
                    onHide: this.setLoading
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Segment,
                    { basic: true, className: 'dtp_tab_content' },
                    _react2.default.createElement(_TimePicker2.default, {
                      value: date ? (0, _momentTimezone2.default)(date) : (0, _momentTimezone2.default)(),
                      onChange: this.handleOnChangeTime,
                      useBrowserTimezone: useBrowserTimezone
                    })
                  )
                ),
                closeable && _react2.default.createElement(
                  _semanticUiReact.Button,
                  { size: 'small', primary: true, fluid: true, compact: closeableCompact, onClick: this.handleOnClose },
                  t('Close', { ns: _translation.TRANSLATION_FILES.translation })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DateTimePicker;
}(_react.Component);

DateTimePicker.propTypes = {
  basic: _propTypes2.default.bool,
  closeable: _propTypes2.default.bool,
  closeableCompact: _propTypes2.default.bool,
  maxDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.instanceOf(Date)]),
  minDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.instanceOf(Date)]),
  noPadding: _propTypes2.default.bool,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.instanceOf(Date)]),
  visible: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  useBrowserTimezone: _propTypes2.default.bool
};
DateTimePicker.defaultProps = {
  visible: true,
  closeable: true,
  closeableCompact: true
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    _this3.setState({
      loading: loading
    });
  };

  this.handleTabChange = function (e, tabIndex) {
    e.preventDefault();
    var transition = {
      calendar: tabIndex === 1,
      time: tabIndex === 2
    };
    _this3.setState({
      tabIndex: tabIndex,
      loading: true
    }, function () {
      _this3.setState({
        transition: transition
      });
    });
  };

  this.handleOnChangeTime = function (date) {
    var visible = _this3.state.visible;

    _this3.setState({ date: date }, function () {
      if (_this3.props.onChange) _this3.props.onChange(date, visible);
    });
  };

  this.handleOnChangeCalendar = function (value) {
    var _state2 = _this3.state,
        visible = _state2.visible,
        date = _state2.date;
    var useBrowserTimezone = _this3.props.useBrowserTimezone;

    var newDate = (0, _calendarDate.fromCalendarTile)(value, date, useBrowserTimezone).toDate();
    _this3.setState({ date: newDate }, function () {
      if (_this3.props.onChange) _this3.props.onChange(newDate, visible);
    });
  };

  this.handleOnClose = function (e) {
    e.preventDefault();
    var date = _this3.state.date;

    _this3.setState({ visible: false }, function () {
      if (_this3.props.onChange) _this3.props.onChange(date, _this3.state.visible);
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(DateTimePicker);

/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Identity = function Identity(_ref) {
  var identity = _ref.identity,
      type = _ref.type;

  var text = identity;
  if (type === 1 && identity.length === 12) {
    text = identity.substring(0, 6) + '-' + identity.substring(6, 8) + '-' + identity.substring(8, 13);
  }
  return _react2.default.createElement(
    'span',
    null,
    text
  );
};

Identity.propTypes = {
  identity: _propTypes2.default.string,
  type: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired
};

exports.default = Identity;

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SizeSuffix = function (_Component) {
  _inherits(SizeSuffix, _Component);

  function SizeSuffix() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SizeSuffix);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SizeSuffix.__proto__ || Object.getPrototypeOf(SizeSuffix)).call.apply(_ref, [this].concat(args))), _this), _this.checkSizeSuffix = function (suffix) {
      var _this$props = _this.props,
          t = _this$props.t,
          isVietnam = _this$props.isVietnam;

      switch (suffix) {
        case 'square_metres':
          return isVietnam ? ' m²' : ' ' + t('sqm', { ns: _translation.TRANSLATION_FILES.screens });
        case 'square_feet':
          return ' ' + t('sqft', { ns: _translation.TRANSLATION_FILES.screens });
        default:
          return '';
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SizeSuffix, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.className !== nextProps.className || parseFloat(this.props.size) !== parseFloat(nextProps.size) || this.props.suffix !== nextProps.suffix || this.props.isVietnam !== nextProps.isVietnam) {
        return true;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        { className: this.props.className },
        this.props.size ? '' + parseFloat(this.props.size) + this.checkSizeSuffix(this.props.suffix) : '-'
      );
    }
  }]);

  return SizeSuffix;
}(_react.Component);

SizeSuffix.propTypes = {
  className: _propTypes2.default.string,
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  suffix: _propTypes2.default.string,
  isVietnam: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(SizeSuffix);

/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortableDragHandle = exports.SortableContainer = undefined;

var _SortableContainer = __webpack_require__(2195);

var _SortableContainer2 = _interopRequireDefault(_SortableContainer);

var _SortableDragHandle = __webpack_require__(2196);

var _SortableDragHandle2 = _interopRequireDefault(_SortableDragHandle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SortableContainer = _SortableContainer2.default;
exports.SortableDragHandle = _SortableDragHandle2.default;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BUMI = exports.BUMI = [{ text: 'Bumiputera', value: 'Bumiputera' }, { text: 'Non-Bumiputera', value: 'Non-Bumiputera' }, { text: 'Not Applicable', value: 'Not Applicable' }];
exports.default = BUMI;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var GENDER = exports.GENDER = [{ text: 'Male', value: 'Male' }, { text: 'Female', value: 'Female' }, { text: 'Not Applicable', value: 'Not Applicable' }];
exports.default = GENDER;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MARITAL_STATUS = exports.MARITAL_STATUS = [{ text: 'Single', value: 'Single' }, { text: 'Married', value: 'Married' }, { text: 'Divorced', value: 'Divorced' }, { text: 'Widowed', value: 'Widowed' }, { text: 'Separated', value: 'Separated' }, { text: 'Not Applicable', value: 'Not Applicable' }];
exports.default = MARITAL_STATUS;

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var PAYMENT_STATUSES = [{ text: 'Unpaid', value: 'unpaid' }, { text: 'Partially Paid', value: 'partial_paid' }, { text: 'Paid', value: 'paid' }, { text: 'Refunded', value: 'refunded' }];

var PAYMENT_STATUS_MAP = exports.PAYMENT_STATUS_MAP = PAYMENT_STATUSES.reduce(function (acc, val) {
  return _extends({}, acc, _defineProperty({}, val.value, val));
}, {});

exports.default = PAYMENT_STATUSES;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PAYMENT_TYPES = [{ text: 'Virtual Account', value: 'virtual_account' }, { text: 'Bank Transfer', value: 'bank_transfer' }, { text: 'Cheque', value: 'cheque' }, { text: 'Cash', value: 'cash' }, { text: 'Credit Card', value: 'credit_card' }, { text: 'MHub Pay', value: 'online_payment' }, { text: 'Others', value: 'others' }];

exports.default = PAYMENT_TYPES;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PROPERTY_CATEGORY_LANDED = exports.PROPERTY_CATEGORY_LANDED = 'landed';
var PROPERTY_CATEGORY_HIGH_RISE = exports.PROPERTY_CATEGORY_HIGH_RISE = 'high_rise';

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RACE = exports.RACE = [{ text: 'Malay', value: 'Malay' }, { text: 'Chinese', value: 'Chinese' }, { text: 'Indian', value: 'Indian' }, { text: 'Kadazan Dusun', value: 'Kadazan Dusun' }, { text: 'Bajau', value: 'Bajau' }, { text: 'Murut', value: 'Murut' }, { text: 'Iban', value: 'Iban' }, { text: 'Bidayuh', value: 'Bidayuh' }, { text: 'Melanau', value: 'Melanau' }, { text: 'Orang Ulu', value: 'Orang Ulu' }, { text: 'Others (Please Fill In)', value: 'Others' }, { text: 'Not Applicable', value: 'Not Applicable' }];
exports.default = RACE;

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.readLanguagePreference = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var request = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(method, language, selectedToken) {
    var token, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.t0 = selectedToken;

            if (_context.t0) {
              _context.next = 5;
              break;
            }

            _context.next = 4;
            return _auth2.default.currentSession();

          case 4:
            _context.t0 = _context.sent.getIdToken().getJwtToken();

          case 5:
            token = _context.t0;
            _context.next = 8;
            return fetch(_config2.default.get('apiURL') + '/authenticated/language/', _extends({
              method: method,
              credentials: 'include',
              cache: 'no-store',
              headers: {
                'Content-Type': 'application/json',
                'X-Aws-Id-Token': token
              }
            }, method === 'PUT' ? { body: JSON.stringify({ currentLanguageCode: language }) } : {}));

          case 8:
            response = _context.sent;

            if (response.ok) {
              _context.next = 11;
              break;
            }

            throw new Error('Language preference ' + method + ' failed (' + response.status + ')');

          case 11:
            return _context.abrupt('return', response.json());

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function request(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

var readLanguagePreference = exports.readLanguagePreference = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var started, result;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            started = revision;
            _context2.next = 3;
            return writes;

          case 3:
            if (!unresolvedWrite) {
              _context2.next = 5;
              break;
            }

            throw Object.assign(new Error('Previous language save is still awaiting a response'), { code: 'LANGUAGE_SAVE_UNCONFIRMED', blocked: true });

          case 5:
            if (!(started !== revision)) {
              _context2.next = 7;
              break;
            }

            return _context2.abrupt('return', null);

          case 7:
            _context2.next = 9;
            return request('GET');

          case 9:
            result = _context2.sent;
            return _context2.abrupt('return', started === revision ? normalizeLanguage(result.currentLanguageCode) : null);

          case 11:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  }));

  return function readLanguagePreference() {
    return _ref2.apply(this, arguments);
  };
}();

exports.subscribeLanguageSaveStatus = subscribeLanguageSaveStatus;
exports.normalizeLanguage = normalizeLanguage;
exports.saveLanguagePreference = saveLanguagePreference;

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// CPI-1310: shared durable preference, read on load only. Never subscribe to
// focus/storage events: already-open presentation tabs keep their language.
var languages = ['en', 'vi', 'id'];
var revision = 0;
var writes = Promise.resolve();
var unresolvedWrite = null;
var saveStatusListeners = new Set();
function subscribeLanguageSaveStatus(listener) {
  saveStatusListeners.add(listener);
  listener(!!unresolvedWrite);
  return function () {
    return saveStatusListeners.delete(listener);
  };
}
function notifySaveStatus() {
  saveStatusListeners.forEach(function (listener) {
    return listener(!!unresolvedWrite);
  });
}

function normalizeLanguage(value) {
  if (typeof value !== 'string') return null;
  var code = value.toLowerCase().split(/[-_]/)[0];
  return languages.indexOf(code) >= 0 ? code : null;
}

function saveLanguagePreference(value) {
  var _this = this;

  var language = normalizeLanguage(value);
  if (!language) return Promise.reject(new Error('Unsupported language'));
  revision += 1;
  // Keep rapid selections in order, including after an earlier failed save.
  // Capture the caller at selection time. A queued old selection must not use
  // another account's token after logout/login in this browser.
  var identity = _auth2.default.currentSession().then(function (session) {
    return { token: session.getIdToken().getJwtToken() };
  }, function (error) {
    return { error: error };
  });
  var pending = writes.then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var expired, requestStarted, timer, timeoutError, operation, settled;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (!unresolvedWrite) {
              _context3.next = 2;
              break;
            }

            throw Object.assign(new Error('Previous language save is still awaiting a response'), { code: 'LANGUAGE_SAVE_UNCONFIRMED', blocked: true });

          case 2:
            expired = false;
            requestStarted = false;
            timer = void 0;
            timeoutError = new Error('Language preference save timed out');
            operation = identity.then(function (caller) {
              if (expired) throw timeoutError; // Never send a timed-out identity lookup's late result.
              if (caller.error) throw caller.error;
              requestStarted = true;
              return request('PUT', language, caller.token);
            });

            settled = function settled() {
              if (unresolvedWrite === operation) {
                unresolvedWrite = null;
                notifySaveStatus();
              }
            };

            operation.then(settled, settled);
            _context3.prev = 9;
            _context3.next = 12;
            return Promise.race([operation, new Promise(function (resolve, reject) {
              timer = setTimeout(function () {
                expired = true;
                // Aborting fetch cannot cancel server-side processing. Report failure,
                // but refuse overlapping writes until this actual operation settles.
                if (requestStarted) {
                  unresolvedWrite = operation;
                  timeoutError.code = 'LANGUAGE_SAVE_UNCONFIRMED';
                  notifySaveStatus();
                }
                reject(timeoutError);
              }, 5000);
            })]);

          case 12:
            return _context3.abrupt('return', _context3.sent);

          case 13:
            _context3.prev = 13;

            clearTimeout(timer);
            return _context3.finish(13);

          case 16:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this, [[9,, 13, 16]]);
  })));
  writes = pending.catch(function () {});
  return pending;
}

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCurrencyExponent = getCurrencyExponent;
exports.majorToMinor = majorToMinor;
exports.minorToMajor = minorToMajor;
exports.formatMajorNumber = formatMajorNumber;
exports.formatMinorNumber = formatMinorNumber;
exports.formatMajorAmount = formatMajorAmount;
exports.formatMinorAmount = formatMinorAmount;
// ISO 4217 exponents: amountMinor = amount * 10^exponent
var CURRENCY_EXPONENTS = {
  MYR: 2, // Malaysian Ringgit (sen)
  VND: 0, // Vietnamese Dong (no subdivision)
  IDR: 2 // Indonesian Rupiah (sen)
};

var DEFAULT_EXPONENT = 2;

function getCurrencyExponent(currencyCode) {
  if (!currencyCode) return DEFAULT_EXPONENT;
  var exp = CURRENCY_EXPONENTS[currencyCode.toUpperCase()];
  return exp !== undefined ? exp : DEFAULT_EXPONENT;
}

function majorToMinor(amount, currencyCode) {
  var exp = getCurrencyExponent(currencyCode);
  return Math.round(amount * Math.pow(10, exp));
}

function minorToMajor(amountMinor, currencyCode) {
  var exp = getCurrencyExponent(currencyCode);
  if (exp === 0) return amountMinor;
  return amountMinor / Math.pow(10, exp);
}

// CPI-977 (S4/S6): one money formatter for every Vietnam amount on screen. It was a local method
// on containers/Opportunities/Overview/Payment.jsx and open-coded twice more; the PO's requirement
// is byte-identity with the CRM. Behaviour is the promoted method's, unchanged.
function formatMajorNumber(amount, currencyCode) {
  var exp = getCurrencyExponent(currencyCode);
  return new Intl.NumberFormat('en-MY', {
    minimumFractionDigits: exp,
    maximumFractionDigits: exp
  }).format(amount || 0);
}

function formatMinorNumber(amountMinor, currencyCode) {
  return formatMajorNumber(minorToMajor(amountMinor || 0, currencyCode), currencyCode);
}

// `VND 50,000,000`. The default code matches the promoted method's, so no call site changes.
function formatMajorAmount(amount) {
  var currencyCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'VND';

  return currencyCode + ' ' + formatMajorNumber(amount, currencyCode);
}

function formatMinorAmount(amountMinor) {
  var currencyCode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'VND';

  return currencyCode + ' ' + formatMinorNumber(amountMinor, currencyCode);
}

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {module.exports = function xor (a, b) {
  var length = Math.min(a.length, b.length)
  var buffer = new Buffer(length)

  for (var i = 0; i < length; ++i) {
    buffer[i] = a[i] ^ b[i]
  }

  return buffer
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75).Buffer))

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(273);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 330 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(178);
var TAG = __webpack_require__(67)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(178);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 333 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(50);
var aFunction = __webpack_require__(158);
var SPECIES = __webpack_require__(67)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.

function isArray(arg) {
  if (Array.isArray) {
    return Array.isArray(arg);
  }
  return objectToString(arg) === '[object Array]';
}
exports.isArray = isArray;

function isBoolean(arg) {
  return typeof arg === 'boolean';
}
exports.isBoolean = isBoolean;

function isNull(arg) {
  return arg === null;
}
exports.isNull = isNull;

function isNullOrUndefined(arg) {
  return arg == null;
}
exports.isNullOrUndefined = isNullOrUndefined;

function isNumber(arg) {
  return typeof arg === 'number';
}
exports.isNumber = isNumber;

function isString(arg) {
  return typeof arg === 'string';
}
exports.isString = isString;

function isSymbol(arg) {
  return typeof arg === 'symbol';
}
exports.isSymbol = isSymbol;

function isUndefined(arg) {
  return arg === void 0;
}
exports.isUndefined = isUndefined;

function isRegExp(re) {
  return objectToString(re) === '[object RegExp]';
}
exports.isRegExp = isRegExp;

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}
exports.isObject = isObject;

function isDate(d) {
  return objectToString(d) === '[object Date]';
}
exports.isDate = isDate;

function isError(e) {
  return (objectToString(e) === '[object Error]' || e instanceof Error);
}
exports.isError = isError;

function isFunction(arg) {
  return typeof arg === 'function';
}
exports.isFunction = isFunction;

function isPrimitive(arg) {
  return arg === null ||
         typeof arg === 'boolean' ||
         typeof arg === 'number' ||
         typeof arg === 'string' ||
         typeof arg === 'symbol' ||  // ES6 symbol
         typeof arg === 'undefined';
}
exports.isPrimitive = isPrimitive;

exports.isBuffer = Buffer.isBuffer;

function objectToString(o) {
  return Object.prototype.toString.call(o);
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75).Buffer))

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(41)
var MD5 = __webpack_require__(679)
var RIPEMD160 = __webpack_require__(699)
var sha = __webpack_require__(758)
var Base = __webpack_require__(198)

function Hash (hash) {
  Base.call(this, 'digest')

  this._hash = hash
}

inherits(Hash, Base)

Hash.prototype._update = function (data) {
  this._hash.update(data)
}

Hash.prototype._final = function () {
  return this._hash.digest()
}

module.exports = function createHash (alg) {
  alg = alg.toLowerCase()
  if (alg === 'md5') return new MD5()
  if (alg === 'rmd160' || alg === 'ripemd160') return new RIPEMD160()

  return new Hash(sha(alg))
}


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var Immutable = __webpack_require__(46);

var OrderedMap = Immutable.OrderedMap;
var BlockMapBuilder = {
  createFromArray: function createFromArray(blocks) {
    return OrderedMap(blocks.map(function (block) {
      return [block.getKey(), block];
    }));
  }
};
module.exports = BlockMapBuilder;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */


var AtomicBlockUtils = __webpack_require__(2850);

var BlockMapBuilder = __webpack_require__(337);

var CharacterMetadata = __webpack_require__(133);

var CompositeDraftDecorator = __webpack_require__(2852);

var ContentBlock = __webpack_require__(241);

var ContentState = __webpack_require__(644);

var DefaultDraftBlockRenderMap = __webpack_require__(645);

var DefaultDraftInlineStyle = __webpack_require__(1161);

var DraftEditor = __webpack_require__(2855);

var DraftEditorBlock = __webpack_require__(1162);

var DraftEntity = __webpack_require__(424);

var DraftModifier = __webpack_require__(105);

var DraftEntityInstance = __webpack_require__(1165);

var EditorState = __webpack_require__(62);

var KeyBindingUtil = __webpack_require__(646);

var RawDraftContentState = __webpack_require__(2873);

var RichTextEditorUtil = __webpack_require__(1169);

var SelectionState = __webpack_require__(425);

var convertFromDraftStateToRaw = __webpack_require__(2878);

var convertFromRawToDraftState = __webpack_require__(2879);

var generateRandomKey = __webpack_require__(164);

var getDefaultKeyBinding = __webpack_require__(1174);

var getVisibleSelectionRect = __webpack_require__(2900);

var convertFromHTML = __webpack_require__(1170);

var DraftPublic = {
  Editor: DraftEditor,
  EditorBlock: DraftEditorBlock,
  EditorState: EditorState,
  CompositeDecorator: CompositeDraftDecorator,
  Entity: DraftEntity,
  EntityInstance: DraftEntityInstance,
  BlockMapBuilder: BlockMapBuilder,
  CharacterMetadata: CharacterMetadata,
  ContentBlock: ContentBlock,
  ContentState: ContentState,
  RawDraftContentState: RawDraftContentState,
  SelectionState: SelectionState,
  AtomicBlockUtils: AtomicBlockUtils,
  KeyBindingUtil: KeyBindingUtil,
  Modifier: DraftModifier,
  RichUtils: RichTextEditorUtil,
  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
  DefaultDraftInlineStyle: DefaultDraftInlineStyle,
  convertFromHTML: convertFromHTML,
  convertFromRaw: convertFromRawToDraftState,
  convertToRaw: convertFromDraftStateToRaw,
  genKey: generateRandomKey,
  getDefaultKeyBinding: getDefaultKeyBinding,
  getVisibleSelectionRect: getVisibleSelectionRect
};
module.exports = DraftPublic;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/**
 * Search through an array to find contiguous stretches of elements that
 * match a specified filter function.
 *
 * When ranges are found, execute a specified `found` function to supply
 * the values to the caller.
 */
function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
  if (!haystack.size) {
    return;
  }

  var cursor = 0;
  haystack.reduce(function (value, nextValue, nextIndex) {
    if (!areEqualFn(value, nextValue)) {
      if (filterFn(value)) {
        foundFn(cursor, nextIndex);
      }

      cursor = nextIndex;
    }

    return nextValue;
  });
  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
}

module.exports = findRangesImmutable;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function isHTMLElement(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  if (!node.ownerDocument.defaultView) {
    return node instanceof HTMLElement;
  }

  if (node instanceof node.ownerDocument.defaultView.HTMLElement) {
    return true;
  }

  return false;
}

module.exports = isHTMLElement;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(105);

var gkx = __webpack_require__(203);

var experimentalTreeDataSupport = gkx('draft_tree_data_support');
/**
 * For a collapsed selection state, remove text based on the specified strategy.
 * If the selection state is not collapsed, remove the entire selected range.
 */

function removeTextWithStrategy(editorState, strategy, direction) {
  var selection = editorState.getSelection();
  var content = editorState.getCurrentContent();
  var target = selection;
  var anchorKey = selection.getAnchorKey();
  var focusKey = selection.getFocusKey();
  var anchorBlock = content.getBlockForKey(anchorKey);

  if (experimentalTreeDataSupport) {
    if (direction === 'forward') {
      if (anchorKey !== focusKey) {
        // For now we ignore forward delete across blocks,
        // if there is demand for this we will implement it.
        return content;
      }
    }
  }

  if (selection.isCollapsed()) {
    if (direction === 'forward') {
      if (editorState.isSelectionAtEndOfContent()) {
        return content;
      }

      if (experimentalTreeDataSupport) {
        var isAtEndOfBlock = selection.getAnchorOffset() === content.getBlockForKey(anchorKey).getLength();

        if (isAtEndOfBlock) {
          var anchorBlockSibling = content.getBlockForKey(anchorBlock.nextSibling);

          if (!anchorBlockSibling || anchorBlockSibling.getLength() === 0) {
            // For now we ignore forward delete at the end of a block,
            // if there is demand for this we will implement it.
            return content;
          }
        }
      }
    } else if (editorState.isSelectionAtStartOfContent()) {
      return content;
    }

    target = strategy(editorState);

    if (target === selection) {
      return content;
    }
  }

  return DraftModifier.removeRange(content, target, direction);
}

module.exports = removeTextWithStrategy;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = find;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function find(list, predicate) {
  for (var i = 0; i < list.length; i++) {
    if (predicate(list[i])) {
      return list[i];
    }
  }
}

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = keyValMap;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * and a function to produce the values from each item in the array.
 *
 *     const phoneBook = [
 *       { name: 'Jon', num: '555-1234' },
 *       { name: 'Jenny', num: '867-5309' }
 *     ]
 *
 *     // { Jon: '555-1234', Jenny: '867-5309' }
 *     const phonesByName = keyValMap(
 *       phoneBook,
 *       entry => entry.name,
 *       entry => entry.num
 *     )
 *
 */
function keyValMap(list, keyFn, valFn) {
  return list.reduce(function (map, item) {
    return map[keyFn(item)] = valFn(item), map;
  }, Object.create(null));
}

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = suggestionList;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Given an invalid input string and a list of valid options, returns a filtered
 * list of valid options sorted based on their similarity with the input.
 */
function suggestionList(input, options) {
  var optionsByDistance = Object.create(null);
  var oLength = options.length;
  var inputThreshold = input.length / 2;

  for (var i = 0; i < oLength; i++) {
    var distance = lexicalDistance(input, options[i]);
    var threshold = Math.max(inputThreshold, options[i].length / 2, 1);

    if (distance <= threshold) {
      optionsByDistance[options[i]] = distance;
    }
  }

  return Object.keys(optionsByDistance).sort(function (a, b) {
    return optionsByDistance[a] - optionsByDistance[b];
  });
}
/**
 * Computes the lexical distance between strings A and B.
 *
 * The "distance" between two strings is given by counting the minimum number
 * of edits needed to transform string A into string B. An edit can be an
 * insertion, deletion, or substitution of a single character, or a swap of two
 * adjacent characters.
 *
 * Includes a custom alteration from Damerau-Levenshtein to treat case changes
 * as a single edit which helps identify mis-cased values with an edit distance
 * of 1.
 *
 * This distance can be useful for detecting typos in input or sorting
 *
 * @param {string} a
 * @param {string} b
 * @return {int} distance in number of edits
 */


function lexicalDistance(aStr, bStr) {
  if (aStr === bStr) {
    return 0;
  }

  var i;
  var j;
  var d = [];
  var a = aStr.toLowerCase();
  var b = bStr.toLowerCase();
  var aLength = a.length;
  var bLength = b.length; // Any case change counts as a single edit

  if (a === b) {
    return 1;
  }

  for (i = 0; i <= aLength; i++) {
    d[i] = [i];
  }

  for (j = 1; j <= bLength; j++) {
    d[0][j] = j;
  }

  for (i = 1; i <= aLength; i++) {
    for (j = 1; j <= bLength; j++) {
      var cost = a[i - 1] === b[j - 1] ? 0 : 1;
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);

      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
        d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + cost);
      }
    }
  }

  return d[aLength][bLength];
}

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DirectiveLocation = void 0;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */

exports.DirectiveLocation = DirectiveLocation;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeInfo = void 0;

var _kinds = __webpack_require__(68);

var _definition = __webpack_require__(54);

var _introspection = __webpack_require__(166);

var _typeFromAST = __webpack_require__(185);

var _find = _interopRequireDefault(__webpack_require__(342));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * TypeInfo is a utility class which, given a GraphQL schema, can keep track
 * of the current field and type definitions at any point in a GraphQL document
 * AST during a recursive descent by calling `enter(node)` and `leave(node)`.
 */
var TypeInfo =
/*#__PURE__*/
function () {
  function TypeInfo(schema, // NOTE: this experimental optional second parameter is only needed in order
  // to support non-spec-compliant codebases. You should never need to use it.
  getFieldDefFn, // Initial type may be provided in rare cases to facilitate traversals
  initialType) {
    _defineProperty(this, "_schema", void 0);

    _defineProperty(this, "_typeStack", void 0);

    _defineProperty(this, "_parentTypeStack", void 0);

    _defineProperty(this, "_inputTypeStack", void 0);

    _defineProperty(this, "_fieldDefStack", void 0);

    _defineProperty(this, "_defaultValueStack", void 0);

    _defineProperty(this, "_directive", void 0);

    _defineProperty(this, "_argument", void 0);

    _defineProperty(this, "_enumValue", void 0);

    _defineProperty(this, "_getFieldDef", void 0);

    this._schema = schema;
    this._typeStack = [];
    this._parentTypeStack = [];
    this._inputTypeStack = [];
    this._fieldDefStack = [];
    this._defaultValueStack = [];
    this._directive = null;
    this._argument = null;
    this._enumValue = null;
    this._getFieldDef = getFieldDefFn || getFieldDef;

    if (initialType) {
      if ((0, _definition.isInputType)(initialType)) {
        this._inputTypeStack.push(initialType);
      }

      if ((0, _definition.isCompositeType)(initialType)) {
        this._parentTypeStack.push(initialType);
      }

      if ((0, _definition.isOutputType)(initialType)) {
        this._typeStack.push(initialType);
      }
    }
  }

  var _proto = TypeInfo.prototype;

  _proto.getType = function getType() {
    if (this._typeStack.length > 0) {
      return this._typeStack[this._typeStack.length - 1];
    }
  };

  _proto.getParentType = function getParentType() {
    if (this._parentTypeStack.length > 0) {
      return this._parentTypeStack[this._parentTypeStack.length - 1];
    }
  };

  _proto.getInputType = function getInputType() {
    if (this._inputTypeStack.length > 0) {
      return this._inputTypeStack[this._inputTypeStack.length - 1];
    }
  };

  _proto.getParentInputType = function getParentInputType() {
    if (this._inputTypeStack.length > 1) {
      return this._inputTypeStack[this._inputTypeStack.length - 2];
    }
  };

  _proto.getFieldDef = function getFieldDef() {
    if (this._fieldDefStack.length > 0) {
      return this._fieldDefStack[this._fieldDefStack.length - 1];
    }
  };

  _proto.getDefaultValue = function getDefaultValue() {
    if (this._defaultValueStack.length > 0) {
      return this._defaultValueStack[this._defaultValueStack.length - 1];
    }
  };

  _proto.getDirective = function getDirective() {
    return this._directive;
  };

  _proto.getArgument = function getArgument() {
    return this._argument;
  };

  _proto.getEnumValue = function getEnumValue() {
    return this._enumValue;
  };

  _proto.enter = function enter(node) {
    var schema = this._schema; // Note: many of the types below are explicitly typed as "mixed" to drop
    // any assumptions of a valid schema to ensure runtime types are properly
    // checked before continuing since TypeInfo is used as part of validation
    // which occurs before guarantees of schema and document validity.

    switch (node.kind) {
      case _kinds.Kind.SELECTION_SET:
        var namedType = (0, _definition.getNamedType)(this.getType());

        this._parentTypeStack.push((0, _definition.isCompositeType)(namedType) ? namedType : undefined);

        break;

      case _kinds.Kind.FIELD:
        var parentType = this.getParentType();
        var fieldDef;
        var fieldType;

        if (parentType) {
          fieldDef = this._getFieldDef(schema, parentType, node);

          if (fieldDef) {
            fieldType = fieldDef.type;
          }
        }

        this._fieldDefStack.push(fieldDef);

        this._typeStack.push((0, _definition.isOutputType)(fieldType) ? fieldType : undefined);

        break;

      case _kinds.Kind.DIRECTIVE:
        this._directive = schema.getDirective(node.name.value);
        break;

      case _kinds.Kind.OPERATION_DEFINITION:
        var type;

        if (node.operation === 'query') {
          type = schema.getQueryType();
        } else if (node.operation === 'mutation') {
          type = schema.getMutationType();
        } else if (node.operation === 'subscription') {
          type = schema.getSubscriptionType();
        }

        this._typeStack.push((0, _definition.isObjectType)(type) ? type : undefined);

        break;

      case _kinds.Kind.INLINE_FRAGMENT:
      case _kinds.Kind.FRAGMENT_DEFINITION:
        var typeConditionAST = node.typeCondition;
        var outputType = typeConditionAST ? (0, _typeFromAST.typeFromAST)(schema, typeConditionAST) : (0, _definition.getNamedType)(this.getType());

        this._typeStack.push((0, _definition.isOutputType)(outputType) ? outputType : undefined);

        break;

      case _kinds.Kind.VARIABLE_DEFINITION:
        var inputType = (0, _typeFromAST.typeFromAST)(schema, node.type);

        this._inputTypeStack.push((0, _definition.isInputType)(inputType) ? inputType : undefined);

        break;

      case _kinds.Kind.ARGUMENT:
        var argDef;
        var argType;
        var fieldOrDirective = this.getDirective() || this.getFieldDef();

        if (fieldOrDirective) {
          argDef = (0, _find.default)(fieldOrDirective.args, function (arg) {
            return arg.name === node.name.value;
          });

          if (argDef) {
            argType = argDef.type;
          }
        }

        this._argument = argDef;

        this._defaultValueStack.push(argDef ? argDef.defaultValue : undefined);

        this._inputTypeStack.push((0, _definition.isInputType)(argType) ? argType : undefined);

        break;

      case _kinds.Kind.LIST:
        var listType = (0, _definition.getNullableType)(this.getInputType());
        var itemType = (0, _definition.isListType)(listType) ? listType.ofType : listType; // List positions never have a default value.

        this._defaultValueStack.push(undefined);

        this._inputTypeStack.push((0, _definition.isInputType)(itemType) ? itemType : undefined);

        break;

      case _kinds.Kind.OBJECT_FIELD:
        var objectType = (0, _definition.getNamedType)(this.getInputType());
        var inputFieldType;
        var inputField;

        if ((0, _definition.isInputObjectType)(objectType)) {
          inputField = objectType.getFields()[node.name.value];

          if (inputField) {
            inputFieldType = inputField.type;
          }
        }

        this._defaultValueStack.push(inputField ? inputField.defaultValue : undefined);

        this._inputTypeStack.push((0, _definition.isInputType)(inputFieldType) ? inputFieldType : undefined);

        break;

      case _kinds.Kind.ENUM:
        var enumType = (0, _definition.getNamedType)(this.getInputType());
        var enumValue;

        if ((0, _definition.isEnumType)(enumType)) {
          enumValue = enumType.getValue(node.value);
        }

        this._enumValue = enumValue;
        break;
    }
  };

  _proto.leave = function leave(node) {
    switch (node.kind) {
      case _kinds.Kind.SELECTION_SET:
        this._parentTypeStack.pop();

        break;

      case _kinds.Kind.FIELD:
        this._fieldDefStack.pop();

        this._typeStack.pop();

        break;

      case _kinds.Kind.DIRECTIVE:
        this._directive = null;
        break;

      case _kinds.Kind.OPERATION_DEFINITION:
      case _kinds.Kind.INLINE_FRAGMENT:
      case _kinds.Kind.FRAGMENT_DEFINITION:
        this._typeStack.pop();

        break;

      case _kinds.Kind.VARIABLE_DEFINITION:
        this._inputTypeStack.pop();

        break;

      case _kinds.Kind.ARGUMENT:
        this._argument = null;

        this._defaultValueStack.pop();

        this._inputTypeStack.pop();

        break;

      case _kinds.Kind.LIST:
      case _kinds.Kind.OBJECT_FIELD:
        this._defaultValueStack.pop();

        this._inputTypeStack.pop();

        break;

      case _kinds.Kind.ENUM:
        this._enumValue = null;
        break;
    }
  };

  return TypeInfo;
}();
/**
 * Not exactly the same as the executor's definition of getFieldDef, in this
 * statically evaluated environment we do not always have an Object type,
 * and need to handle Interface and Union types.
 */


exports.TypeInfo = TypeInfo;

function getFieldDef(schema, parentType, fieldNode) {
  var name = fieldNode.name.value;

  if (name === _introspection.SchemaMetaFieldDef.name && schema.getQueryType() === parentType) {
    return _introspection.SchemaMetaFieldDef;
  }

  if (name === _introspection.TypeMetaFieldDef.name && schema.getQueryType() === parentType) {
    return _introspection.TypeMetaFieldDef;
  }

  if (name === _introspection.TypeNameMetaFieldDef.name && (0, _definition.isCompositeType)(parentType)) {
    return _introspection.TypeNameMetaFieldDef;
  }

  if ((0, _definition.isObjectType)(parentType) || (0, _definition.isInterfaceType)(parentType)) {
    return parentType.getFields()[name];
  }
}

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(167);
var assert = __webpack_require__(137);

function BlockHash() {
  this.pending = null;
  this.pendingTotal = 0;
  this.blockSize = this.constructor.blockSize;
  this.outSize = this.constructor.outSize;
  this.hmacStrength = this.constructor.hmacStrength;
  this.padLength = this.constructor.padLength / 8;
  this.endian = 'big';

  this._delta8 = this.blockSize / 8;
  this._delta32 = this.blockSize / 32;
}
exports.BlockHash = BlockHash;

BlockHash.prototype.update = function update(msg, enc) {
  // Convert message to array, pad it, and join into 32bit blocks
  msg = utils.toArray(msg, enc);
  if (!this.pending)
    this.pending = msg;
  else
    this.pending = this.pending.concat(msg);
  this.pendingTotal += msg.length;

  // Enough data, try updating
  if (this.pending.length >= this._delta8) {
    msg = this.pending;

    // Process pending data in blocks
    var r = msg.length % this._delta8;
    this.pending = msg.slice(msg.length - r, msg.length);
    if (this.pending.length === 0)
      this.pending = null;

    msg = utils.join32(msg, 0, msg.length - r, this.endian);
    for (var i = 0; i < msg.length; i += this._delta32)
      this._update(msg, i, i + this._delta32);
  }

  return this;
};

BlockHash.prototype.digest = function digest(enc) {
  this.update(this._pad());
  assert(this.pending === null);

  return this._digest(enc);
};

BlockHash.prototype._pad = function pad() {
  var len = this.pendingTotal;
  var bytes = this._delta8;
  var k = bytes - ((len + this.padLength) % bytes);
  var res = new Array(k + this.padLength);
  res[0] = 0x80;
  for (var i = 1; i < k; i++)
    res[i] = 0;

  // Append length
  len <<= 3;
  if (this.endian === 'big') {
    for (var t = 8; t < this.padLength; t++)
      res[i++] = 0;

    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = len & 0xff;
  } else {
    res[i++] = len & 0xff;
    res[i++] = (len >>> 8) & 0xff;
    res[i++] = (len >>> 16) & 0xff;
    res[i++] = (len >>> 24) & 0xff;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;
    res[i++] = 0;

    for (t = 8; t < this.padLength; t++)
      res[i++] = 0;
  }

  return res;
};


/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$$iterator", function() { return $$iterator; });
/* harmony export (immutable) */ __webpack_exports__["isIterable"] = isIterable;
/* harmony export (immutable) */ __webpack_exports__["isArrayLike"] = isArrayLike;
/* harmony export (immutable) */ __webpack_exports__["isCollection"] = isCollection;
/* harmony export (immutable) */ __webpack_exports__["getIterator"] = getIterator;
/* harmony export (immutable) */ __webpack_exports__["getIteratorMethod"] = getIteratorMethod;
/* harmony export (immutable) */ __webpack_exports__["createIterator"] = createIterator;
/* harmony export (immutable) */ __webpack_exports__["forEach"] = forEach;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "$$asyncIterator", function() { return $$asyncIterator; });
/* harmony export (immutable) */ __webpack_exports__["isAsyncIterable"] = isAsyncIterable;
/* harmony export (immutable) */ __webpack_exports__["getAsyncIterator"] = getAsyncIterator;
/* harmony export (immutable) */ __webpack_exports__["getAsyncIteratorMethod"] = getAsyncIteratorMethod;
/* harmony export (immutable) */ __webpack_exports__["createAsyncIterator"] = createAsyncIterator;
/* harmony export (immutable) */ __webpack_exports__["forAwaitEach"] = forAwaitEach;
/**
 * Copyright (c) 2016, Lee Byron
 * All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 * @ignore
 */

/**
 * [Iterator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator)
 * is a *protocol* which describes a standard way to produce a sequence of
 * values, typically the values of the Iterable represented by this Iterator.
 *
 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterator-interface)
 * it can be utilized by any version of JavaScript.
 *
 * @external Iterator
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterator|MDN Iteration protocols}
 */

/**
 * [Iterable](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable)
 * is a *protocol* which when implemented allows a JavaScript object to define
 * their iteration behavior, such as what values are looped over in a
 * [`for...of`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Statements/for...of)
 * loop or `iterall`'s `forEach` function. Many [built-in types](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#Builtin_iterables)
 * implement the Iterable protocol, including `Array` and `Map`.
 *
 * While described by the [ES2015 version of JavaScript](http://www.ecma-international.org/ecma-262/6.0/#sec-iterable-interface)
 * it can be utilized by any version of JavaScript.
 *
 * @external Iterable
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Iteration_protocols#iterable|MDN Iteration protocols}
 */

// In ES2015 environments, Symbol exists
var SYMBOL /*: any */ = typeof Symbol === 'function' ? Symbol : void 0

// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
var SYMBOL_ITERATOR = SYMBOL && SYMBOL.iterator

/**
 * A property name to be used as the name of an Iterable's method responsible
 * for producing an Iterator, referred to as `@@iterator`. Typically represents
 * the value `Symbol.iterator` but falls back to the string `"@@iterator"` when
 * `Symbol.iterator` is not defined.
 *
 * Use `$$iterator` for defining new Iterables instead of `Symbol.iterator`,
 * but do not use it for accessing existing Iterables, instead use
 * {@link getIterator} or {@link isIterable}.
 *
 * @example
 *
 * var $$iterator = require('iterall').$$iterator
 *
 * function Counter (to) {
 *   this.to = to
 * }
 *
 * Counter.prototype[$$iterator] = function () {
 *   return {
 *     to: this.to,
 *     num: 0,
 *     next () {
 *       if (this.num >= this.to) {
 *         return { value: undefined, done: true }
 *       }
 *       return { value: this.num++, done: false }
 *     }
 *   }
 * }
 *
 * var counter = new Counter(3)
 * for (var number of counter) {
 *   console.log(number) // 0 ... 1 ... 2
 * }
 *
 * @type {Symbol|string}
 */
/*:: declare export var $$iterator: '@@iterator'; */
var $$iterator = SYMBOL_ITERATOR || '@@iterator'

/**
 * Returns true if the provided object implements the Iterator protocol via
 * either implementing a `Symbol.iterator` or `"@@iterator"` method.
 *
 * @example
 *
 * var isIterable = require('iterall').isIterable
 * isIterable([ 1, 2, 3 ]) // true
 * isIterable('ABC') // true
 * isIterable({ length: 1, 0: 'Alpha' }) // false
 * isIterable({ key: 'value' }) // false
 * isIterable(new Map()) // true
 *
 * @param obj
 *   A value which might implement the Iterable protocol.
 * @return {boolean} true if Iterable.
 */
/*:: declare export function isIterable(obj: any): boolean; */
function isIterable(obj) {
  return !!getIteratorMethod(obj)
}

/**
 * Returns true if the provided object implements the Array-like protocol via
 * defining a positive-integer `length` property.
 *
 * @example
 *
 * var isArrayLike = require('iterall').isArrayLike
 * isArrayLike([ 1, 2, 3 ]) // true
 * isArrayLike('ABC') // true
 * isArrayLike({ length: 1, 0: 'Alpha' }) // true
 * isArrayLike({ key: 'value' }) // false
 * isArrayLike(new Map()) // false
 *
 * @param obj
 *   A value which might implement the Array-like protocol.
 * @return {boolean} true if Array-like.
 */
/*:: declare export function isArrayLike(obj: any): boolean; */
function isArrayLike(obj) {
  var length = obj != null && obj.length
  return typeof length === 'number' && length >= 0 && length % 1 === 0
}

/**
 * Returns true if the provided object is an Object (i.e. not a string literal)
 * and is either Iterable or Array-like.
 *
 * This may be used in place of [Array.isArray()][isArray] to determine if an
 * object should be iterated-over. It always excludes string literals and
 * includes Arrays (regardless of if it is Iterable). It also includes other
 * Array-like objects such as NodeList, TypedArray, and Buffer.
 *
 * @example
 *
 * var isCollection = require('iterall').isCollection
 * isCollection([ 1, 2, 3 ]) // true
 * isCollection('ABC') // false
 * isCollection({ length: 1, 0: 'Alpha' }) // true
 * isCollection({ key: 'value' }) // false
 * isCollection(new Map()) // true
 *
 * @example
 *
 * var forEach = require('iterall').forEach
 * if (isCollection(obj)) {
 *   forEach(obj, function (value) {
 *     console.log(value)
 *   })
 * }
 *
 * @param obj
 *   An Object value which might implement the Iterable or Array-like protocols.
 * @return {boolean} true if Iterable or Array-like Object.
 */
/*:: declare export function isCollection(obj: any): boolean; */
function isCollection(obj) {
  return Object(obj) === obj && (isArrayLike(obj) || isIterable(obj))
}

/**
 * If the provided object implements the Iterator protocol, its Iterator object
 * is returned. Otherwise returns undefined.
 *
 * @example
 *
 * var getIterator = require('iterall').getIterator
 * var iterator = getIterator([ 1, 2, 3 ])
 * iterator.next() // { value: 1, done: false }
 * iterator.next() // { value: 2, done: false }
 * iterator.next() // { value: 3, done: false }
 * iterator.next() // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>} iterable
 *   An Iterable object which is the source of an Iterator.
 * @return {Iterator<T>} new Iterator instance.
 */
/*:: declare export var getIterator:
  & (<+TValue>(iterable: Iterable<TValue>) => Iterator<TValue>)
  & ((iterable: mixed) => void | Iterator<mixed>); */
function getIterator(iterable) {
  var method = getIteratorMethod(iterable)
  if (method) {
    return method.call(iterable)
  }
}

/**
 * If the provided object implements the Iterator protocol, the method
 * responsible for producing its Iterator object is returned.
 *
 * This is used in rare cases for performance tuning. This method must be called
 * with obj as the contextual this-argument.
 *
 * @example
 *
 * var getIteratorMethod = require('iterall').getIteratorMethod
 * var myArray = [ 1, 2, 3 ]
 * var method = getIteratorMethod(myArray)
 * if (method) {
 *   var iterator = method.call(myArray)
 * }
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>} iterable
 *   An Iterable object which defines an `@@iterator` method.
 * @return {function(): Iterator<T>} `@@iterator` method.
 */
/*:: declare export var getIteratorMethod:
  & (<+TValue>(iterable: Iterable<TValue>) => (() => Iterator<TValue>))
  & ((iterable: mixed) => (void | (() => Iterator<mixed>))); */
function getIteratorMethod(iterable) {
  if (iterable != null) {
    var method =
      (SYMBOL_ITERATOR && iterable[SYMBOL_ITERATOR]) || iterable['@@iterator']
    if (typeof method === 'function') {
      return method
    }
  }
}

/**
 * Similar to {@link getIterator}, this method returns a new Iterator given an
 * Iterable. However it will also create an Iterator for a non-Iterable
 * Array-like collection, such as Array in a non-ES2015 environment.
 *
 * `createIterator` is complimentary to `forEach`, but allows a "pull"-based
 * iteration as opposed to `forEach`'s "push"-based iteration.
 *
 * `createIterator` produces an Iterator for Array-likes with the same behavior
 * as ArrayIteratorPrototype described in the ECMAScript specification, and
 * does *not* skip over "holes".
 *
 * @example
 *
 * var createIterator = require('iterall').createIterator
 *
 * var myArraylike = { length: 3, 0: 'Alpha', 1: 'Bravo', 2: 'Charlie' }
 * var iterator = createIterator(myArraylike)
 * iterator.next() // { value: 'Alpha', done: false }
 * iterator.next() // { value: 'Bravo', done: false }
 * iterator.next() // { value: 'Charlie', done: false }
 * iterator.next() // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>|{ length: number }} collection
 *   An Iterable or Array-like object to produce an Iterator.
 * @return {Iterator<T>} new Iterator instance.
 */
/*:: declare export var createIterator:
  & (<+TValue>(collection: Iterable<TValue>) => Iterator<TValue>)
  & ((collection: {length: number}) => Iterator<mixed>)
  & ((collection: mixed) => (void | Iterator<mixed>)); */
function createIterator(collection) {
  if (collection != null) {
    var iterator = getIterator(collection)
    if (iterator) {
      return iterator
    }
    if (isArrayLike(collection)) {
      return new ArrayLikeIterator(collection)
    }
  }
}

// When the object provided to `createIterator` is not Iterable but is
// Array-like, this simple Iterator is created.
function ArrayLikeIterator(obj) {
  this._o = obj
  this._i = 0
}

// Note: all Iterators are themselves Iterable.
ArrayLikeIterator.prototype[$$iterator] = function() {
  return this
}

// A simple state-machine determines the IteratorResult returned, yielding
// each value in the Array-like object in order of their indicies.
ArrayLikeIterator.prototype.next = function() {
  if (this._o === void 0 || this._i >= this._o.length) {
    this._o = void 0
    return { value: void 0, done: true }
  }
  return { value: this._o[this._i++], done: false }
}

/**
 * Given an object which either implements the Iterable protocol or is
 * Array-like, iterate over it, calling the `callback` at each iteration.
 *
 * Use `forEach` where you would expect to use a `for ... of` loop in ES6.
 * However `forEach` adheres to the behavior of [Array#forEach][] described in
 * the ECMAScript specification, skipping over "holes" in Array-likes. It will
 * also delegate to a `forEach` method on `collection` if one is defined,
 * ensuring native performance for `Arrays`.
 *
 * Similar to [Array#forEach][], the `callback` function accepts three
 * arguments, and is provided with `thisArg` as the calling context.
 *
 * Note: providing an infinite Iterator to forEach will produce an error.
 *
 * [Array#forEach]: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
 *
 * @example
 *
 * var forEach = require('iterall').forEach
 *
 * forEach(myIterable, function (value, index, iterable) {
 *   console.log(value, index, iterable === myIterable)
 * })
 *
 * @example
 *
 * // ES6:
 * for (let value of myIterable) {
 *   console.log(value)
 * }
 *
 * // Any JavaScript environment:
 * forEach(myIterable, function (value) {
 *   console.log(value)
 * })
 *
 * @template T the type of each iterated value
 * @param {Iterable<T>|{ length: number }} collection
 *   The Iterable or array to iterate over.
 * @param {function(T, number, object)} callback
 *   Function to execute for each iteration, taking up to three arguments
 * @param [thisArg]
 *   Optional. Value to use as `this` when executing `callback`.
 */
/*:: declare export var forEach:
  & (<+TValue, TCollection: Iterable<TValue>>(
      collection: TCollection,
      callbackFn: (value: TValue, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => void)
  & (<TCollection: {length: number}>(
      collection: TCollection,
      callbackFn: (value: mixed, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => void); */
function forEach(collection, callback, thisArg) {
  if (collection != null) {
    if (typeof collection.forEach === 'function') {
      return collection.forEach(callback, thisArg)
    }
    var i = 0
    var iterator = getIterator(collection)
    if (iterator) {
      var step
      while (!(step = iterator.next()).done) {
        callback.call(thisArg, step.value, i++, collection)
        // Infinite Iterators could cause forEach to run forever.
        // After a very large number of iterations, produce an error.
        /* istanbul ignore if */
        if (i > 9999999) {
          throw new TypeError('Near-infinite iteration.')
        }
      }
    } else if (isArrayLike(collection)) {
      for (; i < collection.length; i++) {
        if (collection.hasOwnProperty(i)) {
          callback.call(thisArg, collection[i], i, collection)
        }
      }
    }
  }
}

/////////////////////////////////////////////////////
//                                                 //
//                 ASYNC ITERATORS                 //
//                                                 //
/////////////////////////////////////////////////////

/**
 * [AsyncIterable](https://tc39.github.io/proposal-async-iteration/#sec-asynciterable-interface)
 * is a *protocol* which when implemented allows a JavaScript object to define
 * an asynchronous iteration behavior, such as what values are looped over in
 * a [`for-await-of`](https://tc39.github.io/proposal-async-iteration/#sec-for-in-and-for-of-statements)
 * loop or `iterall`'s {@link forAwaitEach} function.
 *
 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
 * it can be utilized by any version of JavaScript.
 *
 * @external AsyncIterable
 * @see {@link https://tc39.github.io/proposal-async-iteration/#sec-asynciterable-interface|Async Iteration Proposal}
 * @template T The type of each iterated value
 * @property {function (): AsyncIterator<T>} Symbol.asyncIterator
 *   A method which produces an AsyncIterator for this AsyncIterable.
 */

/**
 * [AsyncIterator](https://tc39.github.io/proposal-async-iteration/#sec-asynciterator-interface)
 * is a *protocol* which describes a standard way to produce and consume an
 * asynchronous sequence of values, typically the values of the
 * {@link AsyncIterable} represented by this {@link AsyncIterator}.
 *
 * AsyncIterator is similar to Observable or Stream. Like an {@link Iterator} it
 * also as a `next()` method, however instead of an IteratorResult,
 * calling this method returns a {@link Promise} for a IteratorResult.
 *
 * While described as a proposed addition to the [ES2017 version of JavaScript](https://tc39.github.io/proposal-async-iteration/)
 * it can be utilized by any version of JavaScript.
 *
 * @external AsyncIterator
 * @see {@link https://tc39.github.io/proposal-async-iteration/#sec-asynciterator-interface|Async Iteration Proposal}
 */

// In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
var SYMBOL_ASYNC_ITERATOR = SYMBOL && SYMBOL.asyncIterator

/**
 * A property name to be used as the name of an AsyncIterable's method
 * responsible for producing an Iterator, referred to as `@@asyncIterator`.
 * Typically represents the value `Symbol.asyncIterator` but falls back to the
 * string `"@@asyncIterator"` when `Symbol.asyncIterator` is not defined.
 *
 * Use `$$asyncIterator` for defining new AsyncIterables instead of
 * `Symbol.asyncIterator`, but do not use it for accessing existing Iterables,
 * instead use {@link getAsyncIterator} or {@link isAsyncIterable}.
 *
 * @example
 *
 * var $$asyncIterator = require('iterall').$$asyncIterator
 *
 * function Chirper (to) {
 *   this.to = to
 * }
 *
 * Chirper.prototype[$$asyncIterator] = function () {
 *   return {
 *     to: this.to,
 *     num: 0,
 *     next () {
 *       return new Promise(resolve => {
 *         if (this.num >= this.to) {
 *           resolve({ value: undefined, done: true })
 *         } else {
 *           setTimeout(() => {
 *             resolve({ value: this.num++, done: false })
 *           }, 1000)
 *         }
 *       })
 *     }
 *   }
 * }
 *
 * var chirper = new Chirper(3)
 * for await (var number of chirper) {
 *   console.log(number) // 0 ...wait... 1 ...wait... 2
 * }
 *
 * @type {Symbol|string}
 */
/*:: declare export var $$asyncIterator: '@@asyncIterator'; */
var $$asyncIterator = SYMBOL_ASYNC_ITERATOR || '@@asyncIterator'

/**
 * Returns true if the provided object implements the AsyncIterator protocol via
 * either implementing a `Symbol.asyncIterator` or `"@@asyncIterator"` method.
 *
 * @example
 *
 * var isAsyncIterable = require('iterall').isAsyncIterable
 * isAsyncIterable(myStream) // true
 * isAsyncIterable('ABC') // false
 *
 * @param obj
 *   A value which might implement the AsyncIterable protocol.
 * @return {boolean} true if AsyncIterable.
 */
/*:: declare export function isAsyncIterable(obj: any): boolean; */
function isAsyncIterable(obj) {
  return !!getAsyncIteratorMethod(obj)
}

/**
 * If the provided object implements the AsyncIterator protocol, its
 * AsyncIterator object is returned. Otherwise returns undefined.
 *
 * @example
 *
 * var getAsyncIterator = require('iterall').getAsyncIterator
 * var asyncIterator = getAsyncIterator(myStream)
 * asyncIterator.next().then(console.log) // { value: 1, done: false }
 * asyncIterator.next().then(console.log) // { value: 2, done: false }
 * asyncIterator.next().then(console.log) // { value: 3, done: false }
 * asyncIterator.next().then(console.log) // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>} asyncIterable
 *   An AsyncIterable object which is the source of an AsyncIterator.
 * @return {AsyncIterator<T>} new AsyncIterator instance.
 */
/*:: declare export var getAsyncIterator:
  & (<+TValue>(asyncIterable: AsyncIterable<TValue>) => AsyncIterator<TValue>)
  & ((asyncIterable: mixed) => (void | AsyncIterator<mixed>)); */
function getAsyncIterator(asyncIterable) {
  var method = getAsyncIteratorMethod(asyncIterable)
  if (method) {
    return method.call(asyncIterable)
  }
}

/**
 * If the provided object implements the AsyncIterator protocol, the method
 * responsible for producing its AsyncIterator object is returned.
 *
 * This is used in rare cases for performance tuning. This method must be called
 * with obj as the contextual this-argument.
 *
 * @example
 *
 * var getAsyncIteratorMethod = require('iterall').getAsyncIteratorMethod
 * var method = getAsyncIteratorMethod(myStream)
 * if (method) {
 *   var asyncIterator = method.call(myStream)
 * }
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>} asyncIterable
 *   An AsyncIterable object which defines an `@@asyncIterator` method.
 * @return {function(): AsyncIterator<T>} `@@asyncIterator` method.
 */
/*:: declare export var getAsyncIteratorMethod:
  & (<+TValue>(asyncIterable: AsyncIterable<TValue>) => (() => AsyncIterator<TValue>))
  & ((asyncIterable: mixed) => (void | (() => AsyncIterator<mixed>))); */
function getAsyncIteratorMethod(asyncIterable) {
  if (asyncIterable != null) {
    var method =
      (SYMBOL_ASYNC_ITERATOR && asyncIterable[SYMBOL_ASYNC_ITERATOR]) ||
      asyncIterable['@@asyncIterator']
    if (typeof method === 'function') {
      return method
    }
  }
}

/**
 * Similar to {@link getAsyncIterator}, this method returns a new AsyncIterator
 * given an AsyncIterable. However it will also create an AsyncIterator for a
 * non-async Iterable as well as non-Iterable Array-like collection, such as
 * Array in a pre-ES2015 environment.
 *
 * `createAsyncIterator` is complimentary to `forAwaitEach`, but allows a
 * buffering "pull"-based iteration as opposed to `forAwaitEach`'s
 * "push"-based iteration.
 *
 * `createAsyncIterator` produces an AsyncIterator for non-async Iterables as
 * described in the ECMAScript proposal [Async-from-Sync Iterator Objects](https://tc39.github.io/proposal-async-iteration/#sec-async-from-sync-iterator-objects).
 *
 * > Note: Creating `AsyncIterator`s requires the existence of `Promise`.
 * > While `Promise` has been available in modern browsers for a number of
 * > years, legacy browsers (like IE 11) may require a polyfill.
 *
 * @example
 *
 * var createAsyncIterator = require('iterall').createAsyncIterator
 *
 * var myArraylike = { length: 3, 0: 'Alpha', 1: 'Bravo', 2: 'Charlie' }
 * var iterator = createAsyncIterator(myArraylike)
 * iterator.next().then(console.log) // { value: 'Alpha', done: false }
 * iterator.next().then(console.log) // { value: 'Bravo', done: false }
 * iterator.next().then(console.log) // { value: 'Charlie', done: false }
 * iterator.next().then(console.log) // { value: undefined, done: true }
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>|Iterable<T>|{ length: number }} source
 *   An AsyncIterable, Iterable, or Array-like object to produce an Iterator.
 * @return {AsyncIterator<T>} new AsyncIterator instance.
 */
/*:: declare export var createAsyncIterator:
  & (<+TValue>(
      collection: Iterable<Promise<TValue> | TValue> | AsyncIterable<TValue>
    ) => AsyncIterator<TValue>)
  & ((collection: {length: number}) => AsyncIterator<mixed>)
  & ((collection: mixed) => (void | AsyncIterator<mixed>)); */
function createAsyncIterator(source) {
  if (source != null) {
    var asyncIterator = getAsyncIterator(source)
    if (asyncIterator) {
      return asyncIterator
    }
    var iterator = createIterator(source)
    if (iterator) {
      return new AsyncFromSyncIterator(iterator)
    }
  }
}

// When the object provided to `createAsyncIterator` is not AsyncIterable but is
// sync Iterable, this simple wrapper is created.
function AsyncFromSyncIterator(iterator) {
  this._i = iterator
}

// Note: all AsyncIterators are themselves AsyncIterable.
AsyncFromSyncIterator.prototype[$$asyncIterator] = function() {
  return this
}

// A simple state-machine determines the IteratorResult returned, yielding
// each value in the Array-like object in order of their indicies.
AsyncFromSyncIterator.prototype.next = function(value) {
  return unwrapAsyncFromSync(this._i, 'next', value)
}

AsyncFromSyncIterator.prototype.return = function(value) {
  return this._i.return
    ? unwrapAsyncFromSync(this._i, 'return', value)
    : Promise.resolve({ value: value, done: true })
}

AsyncFromSyncIterator.prototype.throw = function(value) {
  return this._i.throw
    ? unwrapAsyncFromSync(this._i, 'throw', value)
    : Promise.reject(value)
}

function unwrapAsyncFromSync(iterator, fn, value) {
  var step
  return new Promise(function(resolve) {
    step = iterator[fn](value)
    resolve(step.value)
  }).then(function(value) {
    return { value: value, done: step.done }
  })
}

/**
 * Given an object which either implements the AsyncIterable protocol or is
 * Array-like, iterate over it, calling the `callback` at each iteration.
 *
 * Use `forAwaitEach` where you would expect to use a [for-await-of](https://tc39.github.io/proposal-async-iteration/#sec-for-in-and-for-of-statements) loop.
 *
 * Similar to [Array#forEach][], the `callback` function accepts three
 * arguments, and is provided with `thisArg` as the calling context.
 *
 * > Note: Using `forAwaitEach` requires the existence of `Promise`.
 * > While `Promise` has been available in modern browsers for a number of
 * > years, legacy browsers (like IE 11) may require a polyfill.
 *
 * @example
 *
 * var forAwaitEach = require('iterall').forAwaitEach
 *
 * forAwaitEach(myIterable, function (value, index, iterable) {
 *   console.log(value, index, iterable === myIterable)
 * })
 *
 * @example
 *
 * // ES2017:
 * for await (let value of myAsyncIterable) {
 *   console.log(await doSomethingAsync(value))
 * }
 * console.log('done')
 *
 * // Any JavaScript environment:
 * forAwaitEach(myAsyncIterable, function (value) {
 *   return doSomethingAsync(value).then(console.log)
 * }).then(function () {
 *   console.log('done')
 * })
 *
 * @template T the type of each iterated value
 * @param {AsyncIterable<T>|Iterable<Promise<T> | T>|{ length: number }} source
 *   The AsyncIterable or array to iterate over.
 * @param {function(T, number, object)} callback
 *   Function to execute for each iteration, taking up to three arguments
 * @param [thisArg]
 *   Optional. Value to use as `this` when executing `callback`.
 */
/*:: declare export var forAwaitEach:
  & (<+TValue, TCollection: Iterable<Promise<TValue> | TValue> | AsyncIterable<TValue>>(
      collection: TCollection,
      callbackFn: (value: TValue, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => Promise<void>)
  & (<TCollection: { length: number }>(
      collection: TCollection,
      callbackFn: (value: mixed, index: number, collection: TCollection) => any,
      thisArg?: any
    ) => Promise<void>); */
function forAwaitEach(source, callback, thisArg) {
  var asyncIterator = createAsyncIterator(source)
  if (asyncIterator) {
    var i = 0
    return new Promise(function(resolve, reject) {
      function next() {
        asyncIterator
          .next()
          .then(function(step) {
            if (!step.done) {
              Promise.resolve(callback.call(thisArg, step.value, i++, source))
                .then(next)
                .catch(reject)
            } else {
              resolve()
            }
            // Explicitly return null, silencing bluebird-style warnings.
            return null
          })
          .catch(reject)
        // Explicitly return null, silencing bluebird-style warnings.
        return null
      }
      next()
    })
  }
}


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isObject = function isObject(val) {
  return val !== null && !Array.isArray(val) && typeof val === 'object'
}

var codes = {
  // ----------------------------------------
  // By Code
  // ----------------------------------------
  3: 'Cancel',
  6: 'Help',
  8: 'Backspace',
  9: 'Tab',
  12: 'Clear',
  13: 'Enter',
  16: 'Shift',
  17: 'Control',
  18: 'Alt',
  19: 'Pause',
  20: 'CapsLock',
  27: 'Escape',
  28: 'Convert',
  29: 'NonConvert',
  30: 'Accept',
  31: 'ModeChange',
  32: ' ',
  33: 'PageUp',
  34: 'PageDown',
  35: 'End',
  36: 'Home',
  37: 'ArrowLeft',
  38: 'ArrowUp',
  39: 'ArrowRight',
  40: 'ArrowDown',
  41: 'Select',
  42: 'Print',
  43: 'Execute',
  44: 'PrintScreen',
  45: 'Insert',
  46: 'Delete',
  48: ['0', ')'],
  49: ['1', '!'],
  50: ['2', '@'],
  51: ['3', '#'],
  52: ['4', '$'],
  53: ['5', '%'],
  54: ['6', '^'],
  55: ['7', '&'],
  56: ['8', '*'],
  57: ['9', '('],
  91: 'OS',
  93: 'ContextMenu',
  144: 'NumLock',
  145: 'ScrollLock',
  181: 'VolumeMute',
  182: 'VolumeDown',
  183: 'VolumeUp',
  186: [';', ':'],
  187: ['=', '+'],
  188: [',', '<'],
  189: ['-', '_'],
  190: ['.', '>'],
  191: ['/', '?'],
  192: ['`', '~'],
  219: ['[', '{'],
  220: ['\\', '|'],
  221: [']', '}'],
  222: ["'", '"'],
  224: 'Meta',
  225: 'AltGraph',
  246: 'Attn',
  247: 'CrSel',
  248: 'ExSel',
  249: 'EraseEof',
  250: 'Play',
  251: 'ZoomOut',
}

// Function Keys (F1-24)
for (var i = 0; i < 24; i += 1) {
  codes[112 + i] = 'F' + (i + 1)
}

// Alphabet (a-Z)
for (var j = 0; j < 26; j += 1) {
  var n = j + 65
  codes[n] = [String.fromCharCode(n + 32), String.fromCharCode(n)]
}

var keyboardKey = {
  codes: codes,

  /**
   * Get the `keyCode` or `which` value from a keyboard event or `key` name.
   * @param {string|object} eventOrKey A keyboard event-like object or `key` name.
   * @param {string} [eventOrKey.key] If object, it must have one of these keys.
   * @param {number} [eventOrKey.keyCode] If object, it must have one of these keys.
   * @param {number} [eventOrKey.which] If object, it must have one of these keys.
   * @returns {number|undefined}
   */
  getCode: function getCode(eventOrKey) {
    if (isObject(eventOrKey)) {
      return eventOrKey.keyCode || eventOrKey.which || this[eventOrKey.key]
    }
    return this[eventOrKey]
  },

  /**
   * Get the key name from a keyboard event, `keyCode`, or `which` value.
   * @param {number|object} eventOrCode A keyboard event-like object or key code.
   * @param {string} [eventOrCode.key] If object with a `key` name, it will be returned.
   * @param {number} [eventOrCode.keyCode] If object, it must have one of these keys.
   * @param {number} [eventOrCode.which] If object, it must have one of these keys.
   * @param {boolean} [eventOrCode.shiftKey] If object, it must have one of these keys.
   * @returns {string|undefined}
   */
  getKey: function getKey(eventOrCode) {
    var isEvent = isObject(eventOrCode)

    // handle events with a `key` already defined
    if (isEvent && eventOrCode.key) {
      return eventOrCode.key
    }

    var name = codes[isEvent ? eventOrCode.keyCode || eventOrCode.which : eventOrCode]

    if (Array.isArray(name)) {
      if (isEvent) {
        name = name[eventOrCode.shiftKey ? 1 : 0]
      } else {
        name = name[0]
      }
    }

    return name
  },

  // ----------------------------------------
  // By Name
  // ----------------------------------------
  // declare these manually for static analysis
  Cancel: 3,
  Help: 6,
  Backspace: 8,
  Tab: 9,
  Clear: 12,
  Enter: 13,
  Shift: 16,
  Control: 17,
  Alt: 18,
  Pause: 19,
  CapsLock: 20,
  Escape: 27,
  Convert: 28,
  NonConvert: 29,
  Accept: 30,
  ModeChange: 31,
  ' ': 32,
  PageUp: 33,
  PageDown: 34,
  End: 35,
  Home: 36,
  ArrowLeft: 37,
  ArrowUp: 38,
  ArrowRight: 39,
  ArrowDown: 40,
  Select: 41,
  Print: 42,
  Execute: 43,
  PrintScreen: 44,
  Insert: 45,
  Delete: 46,
  0: 48,
  ')': 48,
  1: 49,
  '!': 49,
  2: 50,
  '@': 50,
  3: 51,
  '#': 51,
  4: 52,
  $: 52,
  5: 53,
  '%': 53,
  6: 54,
  '^': 54,
  7: 55,
  '&': 55,
  8: 56,
  '*': 56,
  9: 57,
  '(': 57,
  a: 65,
  A: 65,
  b: 66,
  B: 66,
  c: 67,
  C: 67,
  d: 68,
  D: 68,
  e: 69,
  E: 69,
  f: 70,
  F: 70,
  g: 71,
  G: 71,
  h: 72,
  H: 72,
  i: 73,
  I: 73,
  j: 74,
  J: 74,
  k: 75,
  K: 75,
  l: 76,
  L: 76,
  m: 77,
  M: 77,
  n: 78,
  N: 78,
  o: 79,
  O: 79,
  p: 80,
  P: 80,
  q: 81,
  Q: 81,
  r: 82,
  R: 82,
  s: 83,
  S: 83,
  t: 84,
  T: 84,
  u: 85,
  U: 85,
  v: 86,
  V: 86,
  w: 87,
  W: 87,
  x: 88,
  X: 88,
  y: 89,
  Y: 89,
  z: 90,
  Z: 90,
  OS: 91,
  ContextMenu: 93,
  F1: 112,
  F2: 113,
  F3: 114,
  F4: 115,
  F5: 116,
  F6: 117,
  F7: 118,
  F8: 119,
  F9: 120,
  F10: 121,
  F11: 122,
  F12: 123,
  F13: 124,
  F14: 125,
  F15: 126,
  F16: 127,
  F17: 128,
  F18: 129,
  F19: 130,
  F20: 131,
  F21: 132,
  F22: 133,
  F23: 134,
  F24: 135,
  NumLock: 144,
  ScrollLock: 145,
  VolumeMute: 181,
  VolumeDown: 182,
  VolumeUp: 183,
  ';': 186,
  ':': 186,
  '=': 187,
  '+': 187,
  ',': 188,
  '<': 188,
  '-': 189,
  _: 189,
  '.': 190,
  '>': 190,
  '/': 191,
  '?': 191,
  '`': 192,
  '~': 192,
  '[': 219,
  '{': 219,
  '\\': 220,
  '|': 220,
  ']': 221,
  '}': 221,
  "'": 222,
  '"': 222,
  Meta: 224,
  AltGraph: 225,
  Attn: 246,
  CrSel: 247,
  ExSel: 248,
  EraseEof: 249,
  Play: 250,
  ZoomOut: 251,
}

// ----------------------------------------
// By Alias
// ----------------------------------------
// provide dot-notation accessible keys for all key names
keyboardKey.Spacebar = keyboardKey[' ']
keyboardKey.Digit0 = keyboardKey['0']
keyboardKey.Digit1 = keyboardKey['1']
keyboardKey.Digit2 = keyboardKey['2']
keyboardKey.Digit3 = keyboardKey['3']
keyboardKey.Digit4 = keyboardKey['4']
keyboardKey.Digit5 = keyboardKey['5']
keyboardKey.Digit6 = keyboardKey['6']
keyboardKey.Digit7 = keyboardKey['7']
keyboardKey.Digit8 = keyboardKey['8']
keyboardKey.Digit9 = keyboardKey['9']
keyboardKey.Tilde = keyboardKey['~']
keyboardKey.GraveAccent = keyboardKey['`']
keyboardKey.ExclamationPoint = keyboardKey['!']
keyboardKey.AtSign = keyboardKey['@']
keyboardKey.PoundSign = keyboardKey['#']
keyboardKey.PercentSign = keyboardKey['%']
keyboardKey.Caret = keyboardKey['^']
keyboardKey.Ampersand = keyboardKey['&']
keyboardKey.PlusSign = keyboardKey['+']
keyboardKey.MinusSign = keyboardKey['-']
keyboardKey.EqualsSign = keyboardKey['=']
keyboardKey.DivisionSign = keyboardKey['/']
keyboardKey.MultiplicationSign = keyboardKey['*']
keyboardKey.Comma = keyboardKey[',']
keyboardKey.Decimal = keyboardKey['.']
keyboardKey.Colon = keyboardKey[':']
keyboardKey.Semicolon = keyboardKey[';']
keyboardKey.Pipe = keyboardKey['|']
keyboardKey.BackSlash = keyboardKey['\\']
keyboardKey.QuestionMark = keyboardKey['?']
keyboardKey.SingleQuote = keyboardKey["'"]
keyboardKey.DoubleQuote = keyboardKey['"']
keyboardKey.LeftCurlyBrace = keyboardKey['{']
keyboardKey.RightCurlyBrace = keyboardKey['}']
keyboardKey.LeftParenthesis = keyboardKey['(']
keyboardKey.RightParenthesis = keyboardKey[')']
keyboardKey.LeftAngleBracket = keyboardKey['<']
keyboardKey.RightAngleBracket = keyboardKey['>']
keyboardKey.LeftSquareBracket = keyboardKey['[']
keyboardKey.RightSquareBracket = keyboardKey[']']

module.exports = keyboardKey


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(676),
    getRawTag = __webpack_require__(3059),
    objectToString = __webpack_require__(3085);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 351 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = falsy;
/* unused harmony export history */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return component; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return components; });
/* unused harmony export route */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


function falsy(props, propName, componentName) {
  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
}

var history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  listen: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var component = __WEBPACK_IMPORTED_MODULE_0_prop_types__["elementType"];
var components = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([component, __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"]]);
var route = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_0_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_0_prop_types__["element"]]);
var routes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["oneOfType"])([route, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["arrayOf"])(route)]);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Portal__ = __webpack_require__(3236);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Portal__["a"]; });



/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Label__ = __webpack_require__(708);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Label__["a"]; });



/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(110);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toKey_js__ = __webpack_require__(292);



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toKey_js__["a" /* default */])(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (baseGet);


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isKey_js__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToPath_js__ = __webpack_require__(3446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(210);





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return value;
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isKey_js__["a" /* default */])(value, object) ? [value] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__stringToPath_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (castPath);


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayEach_js__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseEach_js__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__castFunction_js__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(69);





/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arrayEach_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__baseEach_js__["a" /* default */];
  return func(collection, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__castFunction_js__["a" /* default */])(iteratee));
}

/* harmony default export */ __webpack_exports__["a"] = (forEach);


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2840);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(211)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js?-autoprefixer!../../postcss-loader/index.js!./style.css", function() {
			var newContent = require("!!../../css-loader/index.js?-autoprefixer!../../postcss-loader/index.js!./style.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 361 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5IDEzVjE3QzE5IDE3LjUzMDQgMTguNzg5MyAxOC4wMzkxIDE4LjQxNDIgMTguNDE0MkMxOC4wMzkxIDE4Ljc4OTMgMTcuNTMwNCAxOSAxNyAxOUgzQzIuNDY5NTcgMTkgMS45NjA4NiAxOC43ODkzIDEuNTg1NzkgMTguNDE0MkMxLjIxMDcxIDE4LjAzOTEgMSAxNy41MzA0IDEgMTdWMTNNNSA4TDEwIDEzTTEwIDEzTDE1IDhNMTAgMTNWMSIgc3Ryb2tlPSIjNTk2OTc1IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var punycode = __webpack_require__(3129);
var util = __webpack_require__(3541);

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = __webpack_require__(3134);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Observable */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable__ = __webpack_require__(3556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_zen_observable__);


var Observable = __WEBPACK_IMPORTED_MODULE_0_zen_observable___default.a;

/* harmony default export */ __webpack_exports__["a"] = (Observable);

//# sourceMappingURL=bundle.esm.js.map


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CognitoHostedUIIdentityProvider; });
/* harmony export (immutable) */ __webpack_exports__["e"] = isFederatedSignInOptions;
/* harmony export (immutable) */ __webpack_exports__["f"] = isFederatedSignInOptionsCustom;
/* harmony export (immutable) */ __webpack_exports__["g"] = hasCustomState;
/* harmony export (immutable) */ __webpack_exports__["c"] = isCognitoHostedOpts;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AuthErrorTypes; });
/* harmony export (immutable) */ __webpack_exports__["d"] = isUsernamePasswordOpts;
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var CognitoHostedUIIdentityProvider;
(function (CognitoHostedUIIdentityProvider) {
    CognitoHostedUIIdentityProvider["Cognito"] = "COGNITO";
    CognitoHostedUIIdentityProvider["Google"] = "Google";
    CognitoHostedUIIdentityProvider["Facebook"] = "Facebook";
    CognitoHostedUIIdentityProvider["Amazon"] = "LoginWithAmazon";
    CognitoHostedUIIdentityProvider["Apple"] = "SignInWithApple";
})(CognitoHostedUIIdentityProvider || (CognitoHostedUIIdentityProvider = {}));
function isFederatedSignInOptions(obj) {
    var keys = ['provider'];
    return obj && !!keys.find(function (k) { return obj.hasOwnProperty(k); });
}
function isFederatedSignInOptionsCustom(obj) {
    var keys = ['customProvider'];
    return obj && !!keys.find(function (k) { return obj.hasOwnProperty(k); });
}
function hasCustomState(obj) {
    var keys = ['customState'];
    return obj && !!keys.find(function (k) { return obj.hasOwnProperty(k); });
}
function isCognitoHostedOpts(oauth) {
    return oauth.redirectSignIn !== undefined;
}
var AuthErrorTypes;
(function (AuthErrorTypes) {
    AuthErrorTypes["NoConfig"] = "noConfig";
    AuthErrorTypes["MissingAuthConfig"] = "missingAuthConfig";
    AuthErrorTypes["EmptyUsername"] = "emptyUsername";
    AuthErrorTypes["InvalidUsername"] = "invalidUsername";
    AuthErrorTypes["EmptyPassword"] = "emptyPassword";
    AuthErrorTypes["EmptyCode"] = "emptyCode";
    AuthErrorTypes["SignUpError"] = "signUpError";
    AuthErrorTypes["NoMFA"] = "noMFA";
    AuthErrorTypes["InvalidMFA"] = "invalidMFA";
    AuthErrorTypes["EmptyChallengeResponse"] = "emptyChallengeResponse";
    AuthErrorTypes["NoUserSession"] = "noUserSession";
    AuthErrorTypes["Default"] = "default";
    AuthErrorTypes["DeviceConfig"] = "deviceConfig";
    AuthErrorTypes["NetworkError"] = "networkError";
})(AuthErrorTypes || (AuthErrorTypes = {}));
function isUsernamePasswordOpts(obj) {
    return !!obj.username;
}
//# sourceMappingURL=Auth.js.map

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Platform; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getAmplifyUserAgent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__version__ = __webpack_require__(1626);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

var BASE_USER_AGENT = "aws-amplify/" + __WEBPACK_IMPORTED_MODULE_0__version__["a" /* version */];
var Platform = {
    userAgent: BASE_USER_AGENT + " js",
    product: '',
    navigator: null,
    isReactNative: false,
};
if (typeof navigator !== 'undefined' && navigator.product) {
    Platform.product = navigator.product || '';
    Platform.navigator = navigator || null;
    switch (navigator.product) {
        case 'ReactNative':
            Platform.userAgent = BASE_USER_AGENT + " react-native";
            Platform.isReactNative = true;
            break;
        default:
            Platform.userAgent = BASE_USER_AGENT + " js";
            Platform.isReactNative = false;
            break;
    }
}
var getAmplifyUserAgent = function () {
    return Platform.userAgent;
};
/**
 * @deprecated use named import
 */
/* unused harmony default export */ var _unused_webpack_default_export = (Platform);
//# sourceMappingURL=index.js.map

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DEFAULT_RETRY_DELAY_BASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MAXIMUM_RETRY_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return THROTTLING_RETRY_DELAY_BASE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INITIAL_RETRY_TOKENS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RETRY_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TIMEOUT_RETRY_COST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return NO_RETRY_INCREMENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INVOCATION_ID_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REQUEST_HEADER; });
/**
 * The base number of milliseconds to use in calculating a suitable cool-down
 * time when a retryable error is encountered.
 */
var DEFAULT_RETRY_DELAY_BASE = 100;
/**
 * The maximum amount of time (in milliseconds) that will be used as a delay
 * between retry attempts.
 */
var MAXIMUM_RETRY_DELAY = 20 * 1000;
/**
 * The retry delay base (in milliseconds) to use when a throttling error is
 * encountered.
 */
var THROTTLING_RETRY_DELAY_BASE = 500;
/**
 * Initial number of retry tokens in Retry Quota
 */
var INITIAL_RETRY_TOKENS = 500;
/**
 * The total amount of retry tokens to be decremented from retry token balance.
 */
var RETRY_COST = 5;
/**
 * The total amount of retry tokens to be decremented from retry token balance
 * when a throttling error is encountered.
 */
var TIMEOUT_RETRY_COST = 10;
/**
 * The total amount of retry token to be incremented from retry token balance
 * if an SDK operation invocation succeeds without requiring a retry request.
 */
var NO_RETRY_INCREMENT = 1;
/**
 * Header name for SDK invocation ID
 */
var INVOCATION_ID_HEADER = "amz-sdk-invocation-id";
/**
 * Header name for request retry information.
 */
var REQUEST_HEADER = "amz-sdk-request";
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__retryMiddleware__ = __webpack_require__(1709);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__retryMiddleware__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__omitRetryHeadersMiddleware__ = __webpack_require__(1708);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultStrategy__ = __webpack_require__(855);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__defaultStrategy__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configurations__ = __webpack_require__(1706);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__configurations__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__delayDecider__ = __webpack_require__(856);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__retryDecider__ = __webpack_require__(857);
/* unused harmony namespace reexport */






//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyxtQkFBbUIsQ0FBQztBQUNsQyxjQUFjLDhCQUE4QixDQUFDO0FBQzdDLGNBQWMsbUJBQW1CLENBQUM7QUFDbEMsY0FBYyxrQkFBa0IsQ0FBQztBQUNqQyxjQUFjLGdCQUFnQixDQUFDO0FBQy9CLGNBQWMsZ0JBQWdCLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgKiBmcm9tIFwiLi9yZXRyeU1pZGRsZXdhcmVcIjtcbmV4cG9ydCAqIGZyb20gXCIuL29taXRSZXRyeUhlYWRlcnNNaWRkbGV3YXJlXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9kZWZhdWx0U3RyYXRlZ3lcIjtcbmV4cG9ydCAqIGZyb20gXCIuL2NvbmZpZ3VyYXRpb25zXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9kZWxheURlY2lkZXJcIjtcbmV4cG9ydCAqIGZyb20gXCIuL3JldHJ5RGVjaWRlclwiO1xuIl19

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fromHex */
/* harmony export (immutable) */ __webpack_exports__["a"] = toHex;
var SHORT_TO_HEX = {};
var HEX_TO_SHORT = {};
for (var i = 0; i < 256; i++) {
    var encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) {
        encodedByte = "0" + encodedByte;
    }
    SHORT_TO_HEX[i] = encodedByte;
    HEX_TO_SHORT[encodedByte] = i;
}
/**
 * Converts a hexadecimal encoded string to a Uint8Array of bytes.
 *
 * @param encoded The hexadecimal encoded string
 */
function fromHex(encoded) {
    if (encoded.length % 2 !== 0) {
        throw new Error("Hex encoded strings must have an even number length");
    }
    var out = new Uint8Array(encoded.length / 2);
    for (var i = 0; i < encoded.length; i += 2) {
        var encodedByte = encoded.substr(i, 2).toLowerCase();
        if (encodedByte in HEX_TO_SHORT) {
            out[i / 2] = HEX_TO_SHORT[encodedByte];
        }
        else {
            throw new Error("Cannot decode unrecognized sequence " + encodedByte + " as hexadecimal");
        }
    }
    return out;
}
/**
 * Converts a Uint8Array of binary data to a hexadecimal encoded string.
 *
 * @param bytes The binary data to encode
 */
function toHex(bytes) {
    var out = "";
    for (var i = 0; i < bytes.byteLength; i++) {
        out += SHORT_TO_HEX[bytes[i]];
    }
    return out;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBTSxZQUFZLEdBQThCLEVBQUUsQ0FBQztBQUNuRCxJQUFNLFlBQVksR0FBOEIsRUFBRSxDQUFDO0FBRW5ELEtBQUssSUFBSSxDQUFDLEdBQUcsQ0FBQyxFQUFFLENBQUMsR0FBRyxHQUFHLEVBQUUsQ0FBQyxFQUFFLEVBQUU7SUFDNUIsSUFBSSxXQUFXLEdBQUcsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxFQUFFLENBQUMsQ0FBQyxXQUFXLEVBQUUsQ0FBQztJQUMvQyxJQUFJLFdBQVcsQ0FBQyxNQUFNLEtBQUssQ0FBQyxFQUFFO1FBQzVCLFdBQVcsR0FBRyxNQUFJLFdBQWEsQ0FBQztLQUNqQztJQUVELFlBQVksQ0FBQyxDQUFDLENBQUMsR0FBRyxXQUFXLENBQUM7SUFDOUIsWUFBWSxDQUFDLFdBQVcsQ0FBQyxHQUFHLENBQUMsQ0FBQztDQUMvQjtBQUVEOzs7O0dBSUc7QUFDSCxNQUFNLFVBQVUsT0FBTyxDQUFDLE9BQWU7SUFDckMsSUFBSSxPQUFPLENBQUMsTUFBTSxHQUFHLENBQUMsS0FBSyxDQUFDLEVBQUU7UUFDNUIsTUFBTSxJQUFJLEtBQUssQ0FBQyxxREFBcUQsQ0FBQyxDQUFDO0tBQ3hFO0lBRUQsSUFBTSxHQUFHLEdBQUcsSUFBSSxVQUFVLENBQUMsT0FBTyxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUMsQ0FBQztJQUMvQyxLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsT0FBTyxDQUFDLE1BQU0sRUFBRSxDQUFDLElBQUksQ0FBQyxFQUFFO1FBQzFDLElBQU0sV0FBVyxHQUFHLE9BQU8sQ0FBQyxNQUFNLENBQUMsQ0FBQyxFQUFFLENBQUMsQ0FBQyxDQUFDLFdBQVcsRUFBRSxDQUFDO1FBQ3ZELElBQUksV0FBVyxJQUFJLFlBQVksRUFBRTtZQUMvQixHQUFHLENBQUMsQ0FBQyxHQUFHLENBQUMsQ0FBQyxHQUFHLFlBQVksQ0FBQyxXQUFXLENBQUMsQ0FBQztTQUN4QzthQUFNO1lBQ0wsTUFBTSxJQUFJLEtBQUssQ0FBQyx5Q0FBdUMsV0FBVyxvQkFBaUIsQ0FBQyxDQUFDO1NBQ3RGO0tBQ0Y7SUFFRCxPQUFPLEdBQUcsQ0FBQztBQUNiLENBQUM7QUFFRDs7OztHQUlHO0FBQ0gsTUFBTSxVQUFVLEtBQUssQ0FBQyxLQUFpQjtJQUNyQyxJQUFJLEdBQUcsR0FBRyxFQUFFLENBQUM7SUFDYixLQUFLLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBRSxDQUFDLEdBQUcsS0FBSyxDQUFDLFVBQVUsRUFBRSxDQUFDLEVBQUUsRUFBRTtRQUN6QyxHQUFHLElBQUksWUFBWSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDO0tBQy9CO0lBRUQsT0FBTyxHQUFHLENBQUM7QUFDYixDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU0hPUlRfVE9fSEVYOiB7IFtrZXk6IG51bWJlcl06IHN0cmluZyB9ID0ge307XG5jb25zdCBIRVhfVE9fU0hPUlQ6IHsgW2tleTogc3RyaW5nXTogbnVtYmVyIH0gPSB7fTtcblxuZm9yIChsZXQgaSA9IDA7IGkgPCAyNTY7IGkrKykge1xuICBsZXQgZW5jb2RlZEJ5dGUgPSBpLnRvU3RyaW5nKDE2KS50b0xvd2VyQ2FzZSgpO1xuICBpZiAoZW5jb2RlZEJ5dGUubGVuZ3RoID09PSAxKSB7XG4gICAgZW5jb2RlZEJ5dGUgPSBgMCR7ZW5jb2RlZEJ5dGV9YDtcbiAgfVxuXG4gIFNIT1JUX1RPX0hFWFtpXSA9IGVuY29kZWRCeXRlO1xuICBIRVhfVE9fU0hPUlRbZW5jb2RlZEJ5dGVdID0gaTtcbn1cblxuLyoqXG4gKiBDb252ZXJ0cyBhIGhleGFkZWNpbWFsIGVuY29kZWQgc3RyaW5nIHRvIGEgVWludDhBcnJheSBvZiBieXRlcy5cbiAqXG4gKiBAcGFyYW0gZW5jb2RlZCBUaGUgaGV4YWRlY2ltYWwgZW5jb2RlZCBzdHJpbmdcbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIGZyb21IZXgoZW5jb2RlZDogc3RyaW5nKTogVWludDhBcnJheSB7XG4gIGlmIChlbmNvZGVkLmxlbmd0aCAlIDIgIT09IDApIHtcbiAgICB0aHJvdyBuZXcgRXJyb3IoXCJIZXggZW5jb2RlZCBzdHJpbmdzIG11c3QgaGF2ZSBhbiBldmVuIG51bWJlciBsZW5ndGhcIik7XG4gIH1cblxuICBjb25zdCBvdXQgPSBuZXcgVWludDhBcnJheShlbmNvZGVkLmxlbmd0aCAvIDIpO1xuICBmb3IgKGxldCBpID0gMDsgaSA8IGVuY29kZWQubGVuZ3RoOyBpICs9IDIpIHtcbiAgICBjb25zdCBlbmNvZGVkQnl0ZSA9IGVuY29kZWQuc3Vic3RyKGksIDIpLnRvTG93ZXJDYXNlKCk7XG4gICAgaWYgKGVuY29kZWRCeXRlIGluIEhFWF9UT19TSE9SVCkge1xuICAgICAgb3V0W2kgLyAyXSA9IEhFWF9UT19TSE9SVFtlbmNvZGVkQnl0ZV07XG4gICAgfSBlbHNlIHtcbiAgICAgIHRocm93IG5ldyBFcnJvcihgQ2Fubm90IGRlY29kZSB1bnJlY29nbml6ZWQgc2VxdWVuY2UgJHtlbmNvZGVkQnl0ZX0gYXMgaGV4YWRlY2ltYWxgKTtcbiAgICB9XG4gIH1cblxuICByZXR1cm4gb3V0O1xufVxuXG4vKipcbiAqIENvbnZlcnRzIGEgVWludDhBcnJheSBvZiBiaW5hcnkgZGF0YSB0byBhIGhleGFkZWNpbWFsIGVuY29kZWQgc3RyaW5nLlxuICpcbiAqIEBwYXJhbSBieXRlcyBUaGUgYmluYXJ5IGRhdGEgdG8gZW5jb2RlXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiB0b0hleChieXRlczogVWludDhBcnJheSk6IHN0cmluZyB7XG4gIGxldCBvdXQgPSBcIlwiO1xuICBmb3IgKGxldCBpID0gMDsgaSA8IGJ5dGVzLmJ5dGVMZW5ndGg7IGkrKykge1xuICAgIG91dCArPSBTSE9SVF9UT19IRVhbYnl0ZXNbaV1dO1xuICB9XG5cbiAgcmV0dXJuIG91dDtcbn1cbiJdfQ==

/***/ }),
/* 369 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContextAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__context_NoopContextManager__ = __webpack_require__(1891);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_global_utils__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__diag__ = __webpack_require__(257);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};



var API_NAME = 'context';
var NOOP_CONTEXT_MANAGER = new __WEBPACK_IMPORTED_MODULE_0__context_NoopContextManager__["a" /* NoopContextManager */]();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */
var ContextAPI = /** @class */ (function () {
    /** Empty private constructor prevents end users from constructing a new instance of the API */
    function ContextAPI() {
    }
    /** Get the singleton instance of the Context API */
    ContextAPI.getInstance = function () {
        if (!this._instance) {
            this._instance = new ContextAPI();
        }
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */
    ContextAPI.prototype.setGlobalContextManager = function (contextManager) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__internal_global_utils__["a" /* registerGlobal */])(API_NAME, contextManager, __WEBPACK_IMPORTED_MODULE_2__diag__["a" /* DiagAPI */].instance());
    };
    /**
     * Get the currently active context
     */
    ContextAPI.prototype.active = function () {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */
    ContextAPI.prototype.with = function (context, fn, thisArg) {
        var _a;
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        return (_a = this._getContextManager()).with.apply(_a, __spreadArray([context, fn, thisArg], __read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */
    ContextAPI.prototype.bind = function (context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__internal_global_utils__["b" /* getGlobal */])(API_NAME) || NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */
    ContextAPI.prototype.disable = function () {
        this._getContextManager().disable();
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__internal_global_utils__["c" /* unregisterGlobal */])(API_NAME, __WEBPACK_IMPORTED_MODULE_2__diag__["a" /* DiagAPI */].instance());
    };
    return ContextAPI;
}());

//# sourceMappingURL=context.js.map

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createContextKey;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ROOT_CONTEXT; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** Get a key to uniquely identify a context value */
function createContextKey(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var BaseContext = /** @class */ (function () {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */
    function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function (key) { return self._currentContext.get(key); };
        self.setValue = function (key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function (key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}());
/** The root context is used as the default parent context when there is no active context */
var ROOT_CONTEXT = new BaseContext();
//# sourceMappingURL=context.js.map

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = suppressTracing;
/* harmony export (immutable) */ __webpack_exports__["c"] = unsuppressTracing;
/* harmony export (immutable) */ __webpack_exports__["a"] = isTracingSuppressed;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var SUPPRESS_TRACING_KEY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["createContextKey"])('OpenTelemetry SDK Context Key SUPPRESS_TRACING');
function suppressTracing(context) {
    return context.setValue(SUPPRESS_TRACING_KEY, true);
}
function unsuppressTracing(context) {
    return context.deleteValue(SUPPRESS_TRACING_KEY);
}
function isTracingSuppressed(context) {
    return context.getValue(SUPPRESS_TRACING_KEY) === true;
}
//# sourceMappingURL=suppress-tracing.js.map

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NoopDetector */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return noopDetector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NoopDetectorSync__ = __webpack_require__(375);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var NoopDetector = /** @class */ (function () {
    function NoopDetector() {
    }
    NoopDetector.prototype.detect = function () {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0__NoopDetectorSync__["a" /* noopDetectorSync */].detect());
    };
    return NoopDetector;
}());

var noopDetector = new NoopDetector();
//# sourceMappingURL=NoopDetector.js.map

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NoopDetectorSync */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return noopDetectorSync; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resource__ = __webpack_require__(304);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var NoopDetectorSync = /** @class */ (function () {
    function NoopDetectorSync() {
    }
    NoopDetectorSync.prototype.detect = function () {
        return new __WEBPACK_IMPORTED_MODULE_0__Resource__["a" /* Resource */]({});
    };
    return NoopDetectorSync;
}());

var noopDetectorSync = new NoopDetectorSync();
//# sourceMappingURL=NoopDetectorSync.js.map

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SamplingDecision; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A sampling decision that determines how a {@link Span} will be recorded
 * and collected.
 */
var SamplingDecision;
(function (SamplingDecision) {
    /**
     * `Span.isRecording() === false`, span will not be recorded and all events
     * and attributes will be dropped.
     */
    SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    /**
     * `Span.isRecording() === true`, but `Sampled` flag in {@link TraceFlags}
     * MUST NOT be set.
     */
    SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    /**
     * `Span.isRecording() === true` AND `Sampled` flag in {@link TraceFlags}
     * MUST be set.
     */
    SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})(SamplingDecision || (SamplingDecision = {}));
//# sourceMappingURL=Sampler.js.map

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getParentNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNodeName_js__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instanceOf_js__ = __webpack_require__(125);



function getParentNode(element) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNodeName_js__["a" /* default */])(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__instanceOf_js__["c" /* isShadowRoot */])(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__["a" /* default */])(element) // fallback

  );
}

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var stack;

if (true) {
  stack = __webpack_require__(2042);
} else {
  stack = require('./cjs/event-stack.development.js');
}

module.exports = stack.default;
module.exports.instance = stack.instance;


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAppConfig = fetchAppConfig;

var _actions = __webpack_require__(25);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function appConfigRequest() {
  return {
    type: _actions.APP_CONFIG_REQUEST
  };
}

function appConfigSuccess(data) {
  return {
    type: _actions.APP_CONFIG_SUCCESS,
    payload: {
      data: data
    }
  };
}

function appConfigError(message) {
  return {
    type: _actions.APP_CONFIG_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchAppConfig() {
  return function (dispatch) {
    dispatch(appConfigRequest());
    return dispatch((0, _fetchM.fetchM)('/app/', {
      credentials: 'include'
    })).then(function (res) {
      return res.json();
    }).then(function (data) {
      dispatch(appConfigSuccess(data));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, appConfigError));
    });
  };
}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchTemplates = fetchTemplates;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function templatesRequest() {
  return {
    type: _actions.TEMPLATES_REQUEST
  };
}

function templatesSuccess(type, data) {
  var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return {
    type: _actions.TEMPLATES_SUCCESS,
    payload: {
      type: type,
      data: data,
      token: token
    }
  };
}

function templatesError(message) {
  return {
    type: _actions.TEMPLATES_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchTemplates(templateType) {
  var fresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(templatesRequest());
    if (!fresh) {
      var templatesData = {};
      try {
        templatesData = JSON.parse((0, _storage.getItem)(_config2.default.get('appName') + '.templates.' + templateType)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!templatesData.data || _config2.default.get('version') !== templatesData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(templatesData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(templatesSuccess(templateType, templatesData.data));
        return Promise.resolve();
      }
    }
    var q = Object.assign({
      limit: 0,
      templateType: templateType
    });
    return dispatch((0, _fetchM.fetchM)('/templates/?' + _qs2.default.stringify(q), {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        (0, _storage.setItem)(_config2.default.get('appName') + '.templates.' + templateType, JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(templatesSuccess(templateType, data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, templatesError));
    });
  };
}

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Helper = function Helper(_ref) {
  var children = _ref.children,
      type = _ref.type;
  return _react2.default.createElement(
    'span',
    { className: type || 'info' },
    children
  );
};

Helper.propTypes = {
  children: _propTypes2.default.node.isRequired,
  type: _propTypes2.default.string
};

exports.default = Helper;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _translation = __webpack_require__(4);

var _Validate = __webpack_require__(219);

var _Validate2 = _interopRequireDefault(_Validate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Select = function (_Component) {
  _inherits(Select, _Component);

  function Select() {
    _classCallCheck(this, Select);

    return _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).apply(this, arguments));
  }

  _createClass(Select, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _Validate2.default,
        {
          hideMessage: this.props.hideMessage,
          validation: this.props.validation,
          label: this.props.validateLabel || this.props.label,
          name: this.props.validateName || this.props.name,
          ref: this.props.validateRef,
          onChange: function onChange(e, data) {
            // bubble up onChange
            if (_this2.props.onChange) {
              _this2.props.onChange(e, data);
            }
          },
          style: this.props.style && this.props.style
        },
        _react2.default.createElement(_semanticUiReact.Form.Select, {
          disabled: this.props.disabled,
          search: true,
          fluid: true,
          multiple: this.props.multiple,
          label: this.props.label,
          loading: this.props.loading,
          name: this.props.name,
          placeholder: this.props.placeholder,
          value: this.props.value,
          options: this.props.options,
          selectOnBlur: this.props.selectOnBlur,
          noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
        })
      );
    }
  }]);

  return Select;
}(_react.Component);

Select.propTypes = {
  disabled: _propTypes2.default.bool,
  hideMessage: _propTypes2.default.bool,
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  loading: _propTypes2.default.bool,
  name: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  style: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  validation: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({
    validate: _propTypes2.default.func,
    option: _propTypes2.default.object
  })]).isRequired),
  value: _propTypes2.default.oneOfType([_propTypes2.default.string]),
  validateName: _propTypes2.default.string,
  validateLabel: _propTypes2.default.string,
  validateRef: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({})]),
  options: _propTypes2.default.arrayOf(_propTypes2.default.object),
  selectOnBlur: _propTypes2.default.bool,
  multiple: _propTypes2.default.bool,
  t: _propTypes2.default.func
};


var SelectWithTranslation = (0, _reactI18next.withTranslation)([_translation.TRANSLATION_FILES.translation])(Select);

exports.default = (0, _react.forwardRef)(function (props, ref) {
  return _react2.default.createElement(SelectWithTranslation, _extends({}, props, { validateRef: ref }));
});

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _Validate = __webpack_require__(219);

var _Validate2 = _interopRequireDefault(_Validate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextArea = function (_Component) {
  _inherits(TextArea, _Component);

  function TextArea() {
    _classCallCheck(this, TextArea);

    return _possibleConstructorReturn(this, (TextArea.__proto__ || Object.getPrototypeOf(TextArea)).apply(this, arguments));
  }

  _createClass(TextArea, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _Validate2.default,
        {
          hideMessage: this.props.hideMessage,
          validation: this.props.validation,
          label: this.props.validateLabel || this.props.label,
          name: this.props.name,
          ref: this.props.validateRef,
          onChange: function onChange(e, data) {
            // bubble up onChange
            if (_this2.props.onChange) {
              _this2.props.onChange(e, data);
            }
          }
        },
        _react2.default.createElement(_semanticUiReact.Form.TextArea, {
          autoComplete: this.props.autoComplete,
          placeholder: this.props.placeholder,
          disabled: this.props.disabled,
          label: this.props.label,
          loading: this.props.loading,
          name: this.props.name,
          rows: this.props.rows,
          value: this.props.value,
          style: this.props.style && this.props.style
        })
      );
    }
  }]);

  return TextArea;
}(_react.Component);

TextArea.propTypes = {
  placeholder: _propTypes2.default.string,
  autoComplete: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  hideMessage: _propTypes2.default.bool,
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  loading: _propTypes2.default.bool,
  rows: _propTypes2.default.number,
  name: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func,
  style: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  validation: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({
    validate: _propTypes2.default.func,
    option: _propTypes2.default.object
  })]).isRequired),
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  validateLabel: _propTypes2.default.string,
  validateRef: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({})])
};
exports.default = (0, _react.forwardRef)(function (props, ref) {
  return _react2.default.createElement(TextArea, _extends({}, props, { validateRef: ref }));
});

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _ListItem = __webpack_require__(261);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _ic_preferred_green = __webpack_require__(504);

var _ic_preferred_green2 = _interopRequireDefault(_ic_preferred_green);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var LawyerItem = function LawyerItem(_ref) {
  var checkVerified = _ref.checkVerified,
      headerNode = _ref.headerNode,
      rest = _objectWithoutProperties(_ref, ['checkVerified', 'headerNode']);

  var check = function check(item) {
    if (checkVerified) {
      return checkVerified(item);
    }
    return false;
  };
  return _react2.default.createElement(_ListItem2.default, _extends({
    header: function header(item) {
      return _react2.default.createElement(
        'div',
        { style: { display: 'inline-flex', alignItems: 'center' } },
        item.lawyer_name || item.name,
        check(item) || item.is_sub || item.verified ? _react2.default.createElement(_semanticUiReact.Image, { src: _ic_preferred_green2.default, height: '15', style: { marginLeft: '0.5em' } }) : null,
        headerNode
      );
    },
    subheader: function subheader(item) {
      return item.firm;
    }
  }, rest));
};

LawyerItem.propTypes = {
  item: _propTypes2.default.shape({
    name: _propTypes2.default.string,
    firm: _propTypes2.default.string,
    verified: _propTypes2.default.number
  }).isRequired,
  checkVerified: _propTypes2.default.func,
  headerNode: _propTypes2.default.node
};

exports.default = LawyerItem;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _MediaItem = __webpack_require__(2156);

var _MediaItem2 = _interopRequireDefault(_MediaItem);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _url = __webpack_require__(19);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable camelcase */

// import { SelectListMultiple } from './Filters';


var MediaList = function (_Component) {
  _inherits(MediaList, _Component);

  function MediaList(props) {
    _classCallCheck(this, MediaList);

    var _this = _possibleConstructorReturn(this, (MediaList.__proto__ || Object.getPrototypeOf(MediaList)).call(this, props));

    _initialiseProps.call(_this);

    var state = MediaList.getPropsToState(props);
    var view = props.view || 'list';
    _this.state = _extends({
      count: 0,
      limit: 0,
      offset: 0,
      data: [],
      view: view
    }, state);
    return _this;
  }

  _createClass(MediaList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
        delete query.page;
      }
      this.replaceQuery(query);
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = MediaList.getPropsToState(nextProps);
      if (nextProps.view) {
        if (this.state.view !== nextProps.view) {
          state.view = nextProps.view;
        }
      }
      this.setState(state);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;
      var pathname = this.props.location.pathname;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      this.fetchMedias(queryNew);
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));
    }
  }, {
    key: 'handleRefetch',
    value: function handleRefetch() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      this.replaceQuery(query);
    }
  }, {
    key: 'renderType',
    value: function renderType(media) {
      var _this2 = this;

      var pictureType = media.type;
      if (this.props.unitLayoutID && media.unitLayouts && media.unitLayouts.length > 0) {
        pictureType = media.unitLayouts.find(function (ul) {
          return ul.projectUnitLayoutID === _this2.props.unitLayoutID;
        }).type;
      } else if (this.props.projectID && media.projects && media.projects.length > 0) {
        pictureType = media.projects.find(function (p) {
          return p.projectID === _this2.props.projectID;
        }).type;
      }
      return pictureType.replace('_', ' ');
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this3 = this;

      var t = this.props.t;

      if (this.state.view === 'list') {
        return this.state.data.length > 0 ? this.state.data.map(function (media, key) {
          var thumbnailUrl = _this3.getThumbnailUrl(media);
          return _react2.default.createElement(
            _semanticUiReact.Table.Row,
            {
              key: key,
              disabled: _this3.handleOnCheck(media),
              onClick: function onClick(e) {
                return _this3.handleOnClick(e, media);
              }
            },
            !_this3.state.isMobile && _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              { width: 3 },
              _react2.default.createElement(_LoadImage2.default, {
                as: 'a',
                centered: true,
                size: 'small',
                src: thumbnailUrl,
                onClick: function onClick(e) {
                  return _this3.handleViewLarge(e, media);
                },
                isVideo: true
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              {
                width: _this3.state.isMobile ? 16 : 6
              },
              _this3.state.isMobile ? _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 'equal' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 6 },
                  _react2.default.createElement(_LoadImage2.default, {
                    as: 'a',
                    centered: true,
                    size: 'tiny',
                    src: thumbnailUrl,
                    onClick: function onClick(e) {
                      return _this3.handleViewLarge(e, media);
                    },
                    isVideo: true
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { columns: 'equal' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 16 },
                        _this3.renderLabel(media),
                        _react2.default.createElement(
                          'p',
                          null,
                          _react2.default.createElement(
                            'small',
                            null,
                            _react2.default.createElement(
                              _reactRouter.Link,
                              {
                                as: 'a',
                                to: media.url,
                                target: '_blank'
                              },
                              _react2.default.createElement(_semanticUiReact.Icon, {
                                style: { marginRight: '0.5em' },
                                size: 'small',
                                name: 'external'
                              }),
                              media.url
                            )
                          )
                        )
                      )
                    ),
                    _this3.props.buttonNode ? _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 16, textAlign: 'right' },
                        _this3.props.buttonNode({
                          loading: _this3.state.loading,
                          item: media,
                          view: _this3.state.view,
                          isMobile: _this3.state.isMobile
                        })
                      )
                    ) : null
                  )
                )
              ) : _react2.default.createElement(
                'div',
                null,
                _this3.renderLabel(media),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'small',
                    null,
                    _react2.default.createElement(
                      _reactRouter.Link,
                      {
                        as: 'a',
                        to: media.url,
                        target: '_blank'
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, {
                        style: { marginRight: '0.5em' },
                        size: 'small',
                        name: 'external'
                      }),
                      media.url
                    )
                  )
                )
              )
            ),
            !_this3.state.isMobile && _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              _this3.props.buttonNode ? _react2.default.createElement(
                'div',
                { className: 'picture-list-buttons' },
                _this3.props.buttonNode({
                  loading: _this3.state.loading,
                  item: media,
                  view: _this3.state.view,
                  isMobile: _this3.state.isMobile
                })
              ) : null
            )
          );
        }) : _react2.default.createElement(
          _semanticUiReact.Table.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { colSpan: '100%', textAlign: 'center' },
            this.state.loading ? _react2.default.createElement(
              _semanticUiReact.Loader,
              { active: true, inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            ) : this.props.notFoundNode ? t(this.props.notFoundNode, { ns: _translation.TRANSLATION_FILES.translation }) : null
          )
        );
      }
      return _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(
            _semanticUiReact.Card.Group,
            { itemsPerRow: this.state.data.length > 0 ? 4 : 1, doubling: true, stackable: true },
            this.state.data.length > 0 ? this.state.data.map(function (media, key) {
              return _react2.default.createElement(_MediaItem2.default, {
                key: key,
                media: media,
                size: 'medium',
                onViewLarge: function onViewLarge(e) {
                  return _this3.handleViewLarge(e, media);
                },
                onRemove: function onRemove(e) {
                  return _this3.handleOnRemove(e, media);
                },
                buttonNode: _this3.props.buttonNode ? _this3.props.buttonNode({
                  loading: _this3.state.loading,
                  item: media,
                  view: _this3.state.view,
                  isMobile: _this3.state.isMobile
                }) : null
                // labelNode={
                //   <Label
                //     className="capitalize"
                //     attached="top left"
                //     content={this.renderType(media)}
                //   />
                // }
              });
            }) : _react2.default.createElement(
              _semanticUiReact.Card,
              null,
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { textAlign: 'center', vertical: true },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                ) : this.props.notFoundNode ? t(this.props.notFoundNode, { ns: _translation.TRANSLATION_FILES.translation }) : null
              )
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;
      var _state = this.state,
          count = _state.count,
          limit = _state.limit,
          offset = _state.offset,
          data = _state.data,
          loading = _state.loading,
          currentPage = _state.currentPage,
          view = _state.view;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 20 },
            active: this.state.loading && this.state.data.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            fixed: view === 'card',
            striped: true, unstackable: true
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: '100%' },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { columns: 1, verticalAlign: 'middle' },
                  this.props.toggleable && _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_semanticUiReact.Label, {
                      as: 'button',
                      attached: 'top left',
                      size: 'small',
                      icon: (view === 'list' ? 'block' : 'list') + ' layout',
                      content: t(view === 'list' ? 'Card' : 'List', { ns: _translation.TRANSLATION_FILES.screens }),
                      onClick: this.handleToggleView,
                      disabled: this.state.loading
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    this.props.headerNode ? this.props.headerNode({
                      count: count,
                      limit: limit,
                      offset: offset,
                      dataSize: data.length,
                      loading: loading,
                      currentPage: currentPage,
                      onChange: this.handleChangePage
                    }) : _react2.default.createElement(_SearchFilter2.default, {
                      inTable: true,
                      advanceFilter: this.state.advanceFilter,
                      isLoading: loading,
                      onChange: this.handleFilterOnChange,
                      onClose: this.handleClearFilter,
                      search: this.state.search,
                      setAdvanceFilter: this.handleSetAdvanceFilter,
                      leftNav: _react2.default.createElement(_PageNav2.default, {
                        currentPage: currentPage,
                        count: count,
                        limit: limit,
                        offset: offset,
                        dataSize: data.length,
                        loading: loading,
                        onChange: this.handleChangePage
                      }),
                      rightNav: this.props.searchRightNav
                    })
                  )
                )
              )
            ),
            view === 'list' && !this.state.isMobile && _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Preview', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Label | URL', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null)
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            this.renderBody()
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Footer,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: '100%' },
                this.props.footerNode ? this.props.footerNode({
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: data.length,
                  loading: loading,
                  currentPage: currentPage,
                  onChange: this.handleChangePage
                }) : _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { columns: 'equal', verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_PageNav2.default, {
                      upward: true,
                      currentPage: currentPage,
                      count: count,
                      limit: limit,
                      offset: offset,
                      dataSize: data.length,
                      loading: loading,
                      onChange: this.handleChangePage
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return MediaList;
}(_react.Component);

MediaList.propTypes = {
  notFoundNode: _propTypes2.default.node,
  onClick: _propTypes2.default.func,
  onCheck: _propTypes2.default.func,
  onViewLarge: _propTypes2.default.func,
  onRemove: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  headerNode: _propTypes2.default.func,
  footerNode: _propTypes2.default.func,
  buttonNode: _propTypes2.default.func,
  projectID: _propTypes2.default.string,
  unitLayoutID: _propTypes2.default.string,
  where: _propTypes2.default.shape({}),
  toggleable: _propTypes2.default.bool,
  t: _propTypes2.default.func,
  view: _propTypes2.default.oneOf(['list', 'card']),
  searchRightNav: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  })
};
MediaList.defaultProps = {
  notFoundNode: 'No videos found'
};
MediaList.contextTypes = {
  store: _propTypes2.default.object
};

MediaList.getPropsToState = function (props) {
  // let advanceFilter = false;
  var isMobile = window.innerWidth < 768;
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  // const types = query.types || [];
  // if (
  //     (types && types.length > 0)
  //   ) {
  //   advanceFilter = true;
  // }
  return {
    // advanceFilter,
    isMobile: isMobile,
    currentPage: currentPage,
    search: search
    // types,
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.getThumbnailUrl = function (media) {
    if (media && media.data && media.data.thumbnail_url) {
      return media.data.thumbnail_url;
    }
    return '';
  };

  this.setData = function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return new Promise(function (res) {
      _this4.setState({
        data: data || []
      }, function () {
        res(data);
        if (_this4.props.onChange) {
          _this4.props.onChange(_this4.state.data);
        }
      });
    });
  };

  this.setComponentState = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new Promise(function (res) {
      _this4.setState(state, function () {
        res(state);
      });
    });
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this4.setState({ loading: loading }, function () {
        res(loading);
      });
    });
  };

  this.fetchMedias = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var t, store, query, projectURL, layoutURL, url, res, message, count, limit, offset, data, que;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              t = _this4.props.t;
              _context.next = 3;
              return _this4.setLoading(true);

            case 3:
              store = _this4.context.store;
              query = Object.assign(q, _this4.props.where || {});

              // TODO: hardcode query, to be change

              query.type = 'video';
              query.oembed = true;

              projectURL = _this4.props.projectID ? '/projects/' + _this4.props.projectID : '';
              layoutURL = _this4.props.unitLayoutID ? '/unit_layouts/' + _this4.props.unitLayoutID : '';
              url = projectURL.concat(layoutURL, '/medias/?' + _qs2.default.stringify(query));
              res = void 0;
              _context.prev = 11;
              _context.next = 14;
              return store.dispatch((0, _fetchM.fetchM)(url, {
                credentials: 'include',
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }));

            case 14:
              res = _context.sent;
              _context.next = 25;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context['catch'](11);

              Bugsnag.notifyException(_context.t0);
              _context.next = 22;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

            case 22:
              _context.next = 24;
              return _this4.setLoading(false);

            case 24:
              return _context.abrupt('return');

            case 25:
              if (res.ok) {
                _context.next = 33;
                break;
              }

              _context.next = 28;
              return res.text();

            case 28:
              message = _context.sent;
              _context.next = 31;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

            case 31:
              _context.next = 49;
              break;

            case 33:
              count = parseInt(res.headers.get('M-Data-count'), 10);
              limit = parseInt(res.headers.get('M-Data-limit'), 10);
              offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
              _context.next = 38;
              return res.json();

            case 38:
              data = _context.sent;
              _context.next = 41;
              return _this4.setData(data);

            case 41:
              if (!(_this4.state.data.length < 1 && query.page > 1)) {
                _context.next = 47;
                break;
              }

              que = (0, _url.decodeSearch)(_this4.props.location.search);

              que.page = 1;
              _this4.replaceQuery(que);
              _context.next = 49;
              break;

            case 47:
              _context.next = 49;
              return _this4.setComponentState({
                count: count,
                limit: limit,
                offset: offset
              });

            case 49:
              _context.next = 51;
              return _this4.setLoading(false);

            case 51:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this4, [[11, 17]]);
    }));

    return function () {
      return _ref.apply(this, arguments);
    };
  }();

  this.handleResize = function () {
    var isMobile = window.innerWidth < 768;
    if (isMobile !== _this4.state.isMobile) {
      _this4.setState({ isMobile: isMobile });
    }
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    query.page = currentPage;
    _this4.setState({
      currentPage: currentPage
    });
    _this4.replaceQuery(query);
  };

  this.handleOnClick = function (e, media) {
    if (_this4.props.onClick) {
      _this4.props.onClick(e, media);
    }
  };

  this.handleToggleView = function (e) {
    e.preventDefault();
    var view = _this4.state.view === 'list' ? 'card' : 'list';
    _this4.setState({ view: view });
  };

  this.handleOnCheck = function (media) {
    if (_this4.props.onCheck) {
      return _this4.props.onCheck({ media: media });
    }
    return false;
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    _this4.setState({
      search: ''
    }, function () {
      if (hasQuery) {
        _this4.replaceQuery(query, true);
      }
    });
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    query[queryName] = value;
    _this4.replaceQuery(query, true);
  };

  this.handleSetAdvanceFilter = function (advanceFilter) {
    _this4.setState({
      advanceFilter: advanceFilter
    });
  };

  this.handleViewLarge = function (e, media) {
    if (_this4.props.onViewLarge) {
      _this4.props.onViewLarge(e, media);
    }
  };

  this.handleOnRemove = function (e, media) {
    if (_this4.props.onRemove) {
      _this4.props.onRemove(e, media);
    }
  };

  this.renderLabel = function (media) {
    if (media.label && media.label.trim().length > 0) {
      return media.label;
    }
    if (_this4.state.isMobile) {
      return _react2.default.createElement(
        'span',
        { className: 'grey-text' },
        'No label set'
      );
    }
    return '-';
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })((0, _reactRouter.withRouter)(MediaList, { withRef: true }));

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _Filters = __webpack_require__(86);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _PictureItem = __webpack_require__(564);

var _PictureItem2 = _interopRequireDefault(_PictureItem);

var _pictureTypes = __webpack_require__(392);

var _pictureTypes2 = _interopRequireDefault(_pictureTypes);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _url = __webpack_require__(19);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PictureList = function (_Component) {
  _inherits(PictureList, _Component);

  function PictureList(props) {
    _classCallCheck(this, PictureList);

    var _this = _possibleConstructorReturn(this, (PictureList.__proto__ || Object.getPrototypeOf(PictureList)).call(this, props));

    _initialiseProps.call(_this);

    var state = PictureList.getPropsToState(props);
    var view = props.view || 'list';
    _this.state = _extends({
      count: 0,
      limit: 0,
      offset: 0,
      data: [],
      view: view
    }, state);
    return _this;
  }

  _createClass(PictureList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
        delete query.page;
      }
      this.replaceQuery(query);
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = PictureList.getPropsToState(nextProps);
      if (nextProps.view) {
        if (this.state.view !== nextProps.view) {
          state.view = nextProps.view;
        }
      }
      this.setState(state);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setPictures',
    value: function setPictures() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this2.setState({
          data: data || []
        }, function () {
          res(data);
          if (_this2.props.onChange) {
            _this2.props.onChange(_this2.state.data);
          }
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchPictures',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var store, query, projectURL, layoutURL, url, res, message, count, limit, offset, data, que;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = Object.assign(q, this.props.where || {});
                projectURL = this.props.projectID ? '/projects/' + this.props.projectID : '';
                layoutURL = this.props.unitLayoutID ? '/unit_layouts/' + this.props.unitLayoutID : '';
                url = projectURL.concat(layoutURL, '/pictures/?' + _qs2.default.stringify(query));
                res = void 0;
                _context.prev = 8;
                _context.next = 11;
                return store.dispatch((0, _fetchM.fetchM)(url, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 11:
                res = _context.sent;
                _context.next = 22;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](8);

                Bugsnag.notifyException(_context.t0);
                _context.next = 19;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 19:
                _context.next = 21;
                return this.setLoading(false);

              case 21:
                return _context.abrupt('return');

              case 22:
                if (res.ok) {
                  _context.next = 30;
                  break;
                }

                _context.next = 25;
                return res.text();

              case 25:
                message = _context.sent;
                _context.next = 28;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 28:
                _context.next = 46;
                break;

              case 30:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context.next = 35;
                return res.json();

              case 35:
                data = _context.sent;
                _context.next = 38;
                return this.setPictures(data);

              case 38:
                if (!(this.state.data.length < 1 && query.page > 1)) {
                  _context.next = 44;
                  break;
                }

                que = (0, _url.decodeSearch)(this.props.location.search);

                que.page = 1;
                this.replaceQuery(que);
                _context.next = 46;
                break;

              case 44:
                _context.next = 46;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 46:
                _context.next = 48;
                return this.setLoading(false);

              case 48:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 14]]);
      }));

      function fetchPictures() {
        return _ref.apply(this, arguments);
      }

      return fetchPictures;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;
      var pathname = this.props.location.pathname;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      this.fetchPictures(queryNew);
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));
    }
  }, {
    key: 'handleRefetch',
    value: function handleRefetch() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      this.replaceQuery(query);
    }
  }, {
    key: 'renderType',
    value: function renderType(picture) {
      var _this5 = this;

      var t = this.props.t;

      var pictureType = picture.type;
      if (this.props.unitLayoutID && picture.unitLayouts && picture.unitLayouts.length > 0) {
        pictureType = picture.unitLayouts.find(function (ul) {
          return ul.projectUnitLayoutID === _this5.props.unitLayoutID;
        }).type;
      } else if (this.props.projectID && picture.projects && picture.projects.length > 0) {
        pictureType = picture.projects.find(function (p) {
          return p.projectID === _this5.props.projectID;
        }).type;
      }
      var typeOption = _pictureTypes2.default.find(function (pt) {
        return pt.value === pictureType;
      });
      return typeOption ? t(typeOption.text, { ns: _translation.TRANSLATION_FILES.screens }) : pictureType.replace('_', ' ');
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this6 = this;

      var t = this.props.t;

      if (this.state.view === 'list') {
        return this.state.data.length > 0 ? this.state.data.map(function (picture, key) {
          return _react2.default.createElement(
            _semanticUiReact.Table.Row,
            {
              key: key,
              disabled: _this6.handleOnCheck(picture),
              onClick: function onClick(e) {
                return _this6.handleOnClick(e, picture);
              }
            },
            !_this6.state.isMobile && _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              { width: 3 },
              _react2.default.createElement(_LoadImage2.default, {
                as: 'a',
                centered: true,
                size: 'tiny',
                picture: picture,
                pictureSize: 10,
                onClick: function onClick(e) {
                  return _this6.handleViewLarge(e, picture);
                }
              })
            ),
            !_this6.state.isMobile && _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              { width: 3 },
              _this6.renderLabel(picture)
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              {
                width: _this6.state.isMobile ? 16 : 3,
                className: _this6.state.isMobile ? null : 'capitalize'
              },
              _this6.state.isMobile ? _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 'equal' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 16 },
                  _react2.default.createElement(_semanticUiReact.Label, {
                    className: 'capitalize',
                    attached: 'top left',
                    content: _this6.renderType(picture)
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 6 },
                  _react2.default.createElement(_LoadImage2.default, {
                    as: 'a',
                    centered: true,
                    size: 'tiny',
                    picture: picture,
                    pictureSize: 10,
                    onClick: function onClick(e) {
                      return _this6.handleViewLarge(e, picture);
                    }
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { columns: 'equal' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 16 },
                        _this6.renderLabel(picture)
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 16 },
                        _this6.renderTags(picture)
                      )
                    ),
                    _this6.props.buttonNode ? _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 16, textAlign: 'right' },
                        _this6.props.buttonNode({
                          loading: _this6.state.loading,
                          picture: picture,
                          view: _this6.state.view,
                          isMobile: _this6.state.isMobile
                        })
                      )
                    ) : null
                  )
                )
              ) : _this6.renderType(picture)
            ),
            !_this6.state.isMobile && _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              _this6.renderTags(picture),
              _this6.props.buttonNode ? _react2.default.createElement(
                'div',
                { className: 'picture-list-buttons' },
                _this6.props.buttonNode({
                  loading: _this6.state.loading,
                  picture: picture,
                  view: _this6.state.view,
                  isMobile: _this6.state.isMobile
                })
              ) : null
            )
          );
        }) : _react2.default.createElement(
          _semanticUiReact.Table.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { colSpan: this.state.isMobile ? null : 4, textAlign: 'center' },
            this.state.loading ? _react2.default.createElement(
              _semanticUiReact.Loader,
              { active: true, inline: 'centered' },
              'Loading'
            ) : this.props.notFoundNode || _react2.default.createElement(
              'p',
              null,
              t('No pictures found'),
              '.'
            )
          )
        );
      }
      return _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(
            _semanticUiReact.Card.Group,
            { itemsPerRow: this.state.data.length > 0 ? 4 : 1, doubling: true, stackable: true },
            this.state.data.length > 0 ? this.state.data.map(function (picture, key) {
              return _react2.default.createElement(_PictureItem2.default, {
                key: key,
                picture: picture,
                pictureSize: 30,
                onViewLarge: function onViewLarge(e) {
                  return _this6.handleViewLarge(e, picture);
                },
                onRemove: function onRemove(e) {
                  return _this6.handleOnRemove(e, picture);
                },
                onTagClick: _this6.handleOnTagClick,
                buttonNode: _this6.props.buttonNode ? _this6.props.buttonNode({
                  loading: _this6.state.loading,
                  picture: picture,
                  view: _this6.state.view,
                  isMobile: _this6.state.isMobile
                }) : null,
                labelNode: _react2.default.createElement(_semanticUiReact.Label, {
                  className: 'capitalize',
                  attached: 'top left',
                  content: _this6.renderType(picture)
                })
              });
            }) : _react2.default.createElement(
              _semanticUiReact.Card,
              null,
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { textAlign: 'center', vertical: true },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  t('Loading')
                ) : this.props.notFoundNode || _react2.default.createElement(
                  'p',
                  null,
                  t('No pictures found'),
                  '.'
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          count = _state.count,
          limit = _state.limit,
          offset = _state.offset,
          data = _state.data,
          loading = _state.loading,
          currentPage = _state.currentPage,
          view = _state.view;
      var t = this.props.t;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 20 },
            active: this.state.loading && this.state.data.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading')
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            fixed: view === 'card',
            striped: true, unstackable: true
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: this.state.isMobile ? null : 4 },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { columns: 1, verticalAlign: 'middle' },
                  this.props.toggleable && _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_semanticUiReact.Label, {
                      as: 'button',
                      attached: 'top left',
                      size: 'small',
                      icon: (view === 'list' ? 'block' : 'list') + ' layout',
                      content: t(view === 'list' ? 'Card' : 'List'),
                      onClick: this.handleToggleView,
                      disabled: this.state.loading
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    this.props.headerNode ? this.props.headerNode({
                      count: count,
                      limit: limit,
                      offset: offset,
                      dataSize: data.length,
                      loading: loading,
                      currentPage: currentPage,
                      onChange: this.handleChangePage
                    }) : _react2.default.createElement(
                      _SearchFilter2.default,
                      {
                        inTable: true,
                        advanceFilter: this.state.advanceFilter,
                        isLoading: loading,
                        onChange: this.handleFilterOnChange,
                        onClose: this.handleClearFilter,
                        search: this.state.search,
                        setAdvanceFilter: this.handleSetAdvanceFilter,
                        leftNav: _react2.default.createElement(_PageNav2.default, {
                          currentPage: currentPage,
                          count: count,
                          limit: limit,
                          offset: offset,
                          dataSize: data.length,
                          loading: loading,
                          onChange: this.handleChangePage
                        }),
                        rightNav: this.props.searchRightNav
                      },
                      _react2.default.createElement(_Filters.SelectListMultiple, {
                        filterName: 'types',
                        hasSearch: true,
                        headerText: t('Select Types'),
                        onChange: this.handleFilterOnChange,
                        onClose: this.handleClearFilter,
                        options: _pictureTypes2.default.map(function (status) {
                          return _extends({}, status, {
                            text: t(status.text, { ns: _translation.TRANSLATION_FILES.screens })
                          });
                        }),
                        placeholder: t('Select Types'),
                        value: this.state.types
                      })
                    )
                  )
                )
              )
            ),
            view === 'list' && !this.state.isMobile && _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Picture')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Label')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Type')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Tags')
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            this.renderBody()
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Footer,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: this.state.isMobile ? null : 4 },
                this.props.footerNode ? this.props.footerNode({
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: data.length,
                  loading: loading,
                  currentPage: currentPage,
                  onChange: this.handleChangePage
                }) : _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { columns: 'equal', verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_PageNav2.default, {
                      upward: true,
                      currentPage: currentPage,
                      count: count,
                      limit: limit,
                      offset: offset,
                      dataSize: data.length,
                      loading: loading,
                      onChange: this.handleChangePage
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return PictureList;
}(_react.Component);

PictureList.propTypes = {
  notFoundNode: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onCheck: _propTypes2.default.func,
  onViewLarge: _propTypes2.default.func,
  onRemove: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  headerNode: _propTypes2.default.func,
  footerNode: _propTypes2.default.func,
  buttonNode: _propTypes2.default.func,
  projectID: _propTypes2.default.string,
  unitLayoutID: _propTypes2.default.string,
  where: _propTypes2.default.shape({}),
  toggleable: _propTypes2.default.bool,
  view: _propTypes2.default.oneOf(['list', 'card']),
  searchRightNav: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
PictureList.contextTypes = {
  store: _propTypes2.default.object
};

PictureList.getPropsToState = function (props) {
  var advanceFilter = false;
  var isMobile = window.innerWidth < 768;
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var types = query.types || [];
  if (types && types.length > 0) {
    advanceFilter = true;
  }
  return {
    advanceFilter: advanceFilter,
    isMobile: isMobile,
    currentPage: currentPage,
    search: search,
    types: types
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.handleResize = function () {
    var isMobile = window.innerWidth < 768;
    if (isMobile !== _this7.state.isMobile) {
      _this7.setState({ isMobile: isMobile });
    }
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this7.props.location.search);
    query.page = currentPage;
    _this7.setState({
      currentPage: currentPage
    });
    _this7.replaceQuery(query);
  };

  this.handleOnClick = function (e, picture) {
    if (_this7.props.onClick) {
      _this7.props.onClick(e, picture);
    }
  };

  this.handleToggleView = function (e) {
    e.preventDefault();
    var view = _this7.state.view === 'list' ? 'card' : 'list';
    _this7.setState({ view: view });
  };

  this.handleOnCheck = function (picture) {
    if (_this7.props.onCheck) {
      return _this7.props.onCheck({ picture: picture });
    }
    return false;
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this7.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    _this7.setState({
      search: ''
    }, function () {
      if (hasQuery) {
        _this7.replaceQuery(query, true);
      }
    });
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this7.props.location.search);
    query[queryName] = value;
    _this7.replaceQuery(query, true);
  };

  this.handleSetAdvanceFilter = function (advanceFilter) {
    _this7.setState({
      advanceFilter: advanceFilter
    });
  };

  this.handleViewLarge = function (e, picture) {
    if (_this7.props.onViewLarge) {
      _this7.props.onViewLarge(e, picture);
    }
  };

  this.handleOnRemove = function (e, picture) {
    if (_this7.props.onRemove) {
      _this7.props.onRemove(e, picture);
    }
  };

  this.handleOnTagClick = function (tag) {
    var query = (0, _url.decodeSearch)(_this7.props.location.search);
    query.search = tag;
    _this7.replaceQuery(query, true);
  };

  this.renderLabel = function (picture) {
    if (picture.label && picture.label.trim().length > 0) {
      return picture.label;
    }
    if (_this7.state.isMobile) {
      return _react2.default.createElement(
        'span',
        { className: 'grey-text' },
        'No label set'
      );
    }
    return '-';
  };

  this.renderTags = function (picture) {
    if (picture.tags && picture.tags.length > 0) {
      return _react2.default.createElement(
        _semanticUiReact.Label.Group,
        { size: 'tiny' },
        picture.tags.map(function (t, idx) {
          return _react2.default.createElement(
            _semanticUiReact.Label,
            { key: idx, as: 'a', onClick: function onClick() {
                return _this7.handleOnTagClick(t);
              } },
            t
          );
        })
      );
    }
    if (!_this7.state.isMobile) {
      return '-';
    }
    return null;
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })((0, _reactRouter.withRouter)(PictureList, { withRef: true }));

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkRegex = exports.VALIDATION_TYPE_DICT = exports.VALIDATION_TYPE_MAP = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable max-len */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var VALIDATION_TYPE_MAP = exports.VALIDATION_TYPE_MAP = [{ key: 'none', value: 'none', text: 'None', regex: '', example: '' }, { key: 'email', value: 'email', text: 'Email', regex: '^[\\w._%+-]+@[\\w.-]+\\.[A-Za-z]{2,}$', example: '' }, { key: 'phone_digits_only', value: 'phone_digits_only', text: 'Phone (Digits Only)', regex: '^\\d{7,15}$', example: '' }, { key: 'phone_intl', value: 'phone_intl', text: 'Phone (Intl Format)', regex: '^\\+?[1-9]\\d{6,14}$', example: '' }, { key: 'number_integer', value: 'number_integer', text: 'Number (Integer)', regex: '^-?\\d+$', example: '' }, { key: 'number_decimal', value: 'number_decimal', text: 'Number (Decimal)', regex: '^-?\\d*(\\.\\d+)?$', example: '' }, { key: 'number_positive', value: 'number_positive', text: 'Positive Number', regex: '^\\d+(\\.\\d+)?$', example: '' }, { key: 'currency_two_decimals', value: 'currency_two_decimals', text: 'Currency (2 decimals)', regex: '^\\d+(\\.\\d{1,2})?$', example: '' }, { key: 'percentage', value: 'percentage', text: 'Percentage (0 - 100)', regex: '^(100(?:\\.0{1,2})?|(?:\\d{1,2}(?:\\.\\d{1,2})?))$', example: '' }, { key: 'date_ymd_dash', value: 'date_ymd_dash', text: 'Date (YYYY-MM-DD)', regex: '^\\d{4}-\\d{2}-\\d{2}$', example: '' }, { key: 'date_dmy_slash', value: 'date_dmy_slash', text: 'Date (DD/MM/YYYY)', regex: '^\\d{2}\\/\\d{2}\\/\\d{4}$', example: '' }, { key: 'date_mdy_slash', value: 'date_mdy_slash', text: 'Date (MM/DD/YYYY)', regex: '^\\d{2}\\/\\d{2}\\/\\d{4}$', example: '' }, { key: 'date_ymd_slash', value: 'date_ymd_slash', text: 'Date (YYYY/MM/DD)', regex: '^\\d{4}\\/\\d{2}\\/\\d{2}$', example: '' }, { key: 'date_dmy_dash', value: 'date_dmy_dash', text: 'Date (DD-MM-YYYY)', regex: '^\\d{2}-\\d{2}-\\d{4}$', example: '' }, { key: 'date_dmy_dot', value: 'date_dmy_dot', text: 'Date (DD.MM.YYYY)', regex: '^\\d{2}\\.\\d{2}\\.\\d{4}$', example: '' }, { key: 'date_Mdy_space', value: 'date_Mdy_space', text: 'Date (Month name DD, YYYY)', regex: '^(January|February|March|April|May|June|July|August|September|October|November|December)\\s(0[1-9]|[12][0-9]|3[01]),\\s\\d{4}$', example: 'August 03, 2025' }, { key: 'date_my_dash', value: 'date_my_dash', text: 'Month-Year (MM-YYYY)', regex: '^(0[1-9]|1[0-2])-\\d{4}$', example: '10-2025' }, { key: 'date_ym_dash', value: 'date_ym_dash', text: 'Month-Year (YYYY-MM)', regex: '^\\d{4}-(0[1-9]|1[0-2])$', example: '2025-10' }, { key: 'date_y_only', value: 'date_y_only', text: 'Year Only (YYYY)', regex: '^\\d{4}$', example: '2025' }, { key: 'time_Hm_doubledot', value: 'time_Hm_doubledot', text: 'Time (HH:MM, 24h)', regex: '^(?:[01]\\d|2[0-3]):[0-5]\\d$', example: '14:35' }, { key: 'time_Hms_doubledot', value: 'time_Hms_doubledot', text: 'Time (HH:MM:SS, 24h)', regex: '^(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d$', example: '14:35:41' }, { key: 'time_hma_doubledot', value: 'time_hma_doubledot', text: 'Time (HH:MM AM/PM)', regex: '^(0?[1-9]|1[0-2]):[0-5]\\d\\s?(AM|PM)$', example: '11:30 PM' }, { key: 'datetime_ymd_dash_Hm_doubledot', value: 'datetime_ymd_dash_Hm_doubledot', text: 'DateTime (YYYY-MM-DD HH:MM)', regex: '^\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\\d|3[01])\\s(0\\d|1\\d|2[0-3]):[0-5]\\d$', example: '2025-08-20 14:30' }, { key: 'datetime_ymd_dash_Hms_doubledot', value: 'datetime_ymd_dash_Hms_doubledot', text: 'DateTime (YYYY-MM-DD HH:MM:SS)', regex: '^\\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\\d|3[01])\\s([01]\\d|2[0-3]):([0-5]\\d):([0-5]\\d)$', example: '2025-08-20 14:30:45' }, { key: 'datime_iso_full', value: 'datime_iso_full', text: 'DateTime ISO 8601', regex: '^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(?:\\.\\d+)?(Z|[+-]\\d{2}:\\d{2})$', example: '2025-08-20T14:30:00Z' }, { key: 'week_no_in_year', value: 'week_no_in_year', text: 'Week Number (YYYY-Www)', regex: '^\\d{4}-W(0[1-9]|[1-4]\\d|5[0-3])$', example: '2025-W34' }, { key: 'quarter_no_in_year', value: 'quarter_no_in_year', text: 'Quarter (YYYY-Qn)', regex: '^\\d{4}-Q[1-4]$', example: '2025-Q3' }, { key: 'alphanumeric_no_space', value: 'alphanumeric_no_space', text: 'Alphanumeric Only', regex: '^[A-Za-z0-9]+$', example: 'Test123' }, { key: 'letters_only', value: 'letters_only', text: 'Letters Only', regex: '^[A-Za-z]+$', example: 'Hello' }, { key: 'uppercase_only', value: 'uppercase_only', text: 'Uppercase Only', regex: '^[A-Z]+$', example: 'ABCDEF' }, { key: 'lowercase_only', value: 'lowercase_only', text: 'Lowercase Only', regex: '^[a-z]+$', example: 'abcdef' }, { key: 'alphanumeric_with_space', value: 'alphanumeric_with_space', text: 'Alphanumeric + Space', regex: '^[A-Za-z0-9 ]+$', example: 'Test 123' }, { key: 'nric_my', value: 'nric_my', text: 'MyKad (NRIC, Malaysia)', regex: '^\\d{6}-\\d{2}-\\d{4}$', example: '900101-14-5678' }, { key: 'passport_generic', value: 'passport_generic', text: 'Passport No. (Generic)', regex: '^[A-Za-z0-9]{5,20}$', example: 'A1234567' }, { key: 'brn_my', value: 'brn_my', text: 'Company Reg No. (MY)', regex: '^\\d{6,10}$', example: '1234567' }, { key: 'tin_generic', value: 'tin_generic', text: 'TIN (Generic)', regex: '^[A-Za-z0-9-]{5,20}$', example: 'TIN-12345' }, { key: 'zip_code_my', value: 'zip_code_my', text: 'Zip/Postal Code (MY)', regex: '^\\d{5}$', example: '88200' }, { key: 'zip_code_intl', value: 'zip_code_intl', text: 'Zip/Postal Code (Intl)', regex: '^[A-Za-z0-9\\- ]{3,10}$', example: 'SW1A 1AA' }, { key: 'url', value: 'url', text: 'URL', regex: '^(https?:\\/\\/)?([\\w.-]+)\\.([a-z]{2,})([/\\w .-]*)*\\/?$', example: 'https://example.com' }, { key: 'ipv4', value: 'ipv4', text: 'IPv4', regex: '^((25[0-5]|2[0-4]\\d|1\\d{2}|[1-9]?\\d)(\\.|$)){4}$', example: '192.168.0.1' }, { key: 'ipv6', value: 'ipv6', text: 'IPv6', regex: '^([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}$', example: '2001:0db8:85a3:0000:0000:8a2e:0370:7334' }, { key: 'credit_card_no', value: 'credit_card_no', text: 'Credit Card No.', regex: '^(?:\\d[ -]?){13,19}$', example: '4111111111111111' }, { key: 'drive_license_my', value: 'drive_license_my', text: 'Malaysian Driving License', regex: '^[A-Z]{1,2}\\d{6,8}$', example: 'B1234567' }, { key: 'vehicle_plate_my', value: 'vehicle_plate_my', text: 'Vehicle Plate (MY)', regex: '^[A-Z]{1,3}\\d{1,4}[A-Z]?$', example: 'WXY1234A' }, { key: 'invoice_no_generic', value: 'invoice_no_generic', text: 'Invoice No.', regex: '^[A-Za-z0-9\\-/]{3,20}$', example: 'INV-2025/001' }, { key: 'booking_ref_code', value: 'booking_ref_code', text: 'Booking Ref Code', regex: '^[A-Z]{3}-\\d{6}$', example: 'ABC-123456' }, { key: 'hex_color_code', value: 'hex_color_code', text: 'Hex Color Code', regex: '^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$', example: '#FF5733' }, { key: 'otp_six_digits', value: 'otp_six_digits', text: 'OTP (6 digits)', regex: '^\\d{6}$', example: '123456' }, { key: 'uuid_v4', value: 'uuid_v4', text: 'UUID (v4)', regex: '^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$', example: '550e8400-e29b-41d4-a716-446655440000' }, { key: 'mac_address', value: 'mac_address', text: 'MAC Address', regex: '^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$', example: '00:1A:2B:3C:4D:5E' }, { key: 'hostname', value: 'hostname', text: 'Hostname', regex: '^([a-zA-Z0-9-]{1,63}\\.)+[a-zA-Z]{2,}$', example: 'myhost.local' }, { key: 'subnet_cidr', value: 'subnet_cidr', text: 'Subnet (CIDR)', regex: '^((25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]?\\d)(\\.(?!$)|$)){4}\\/(3[0-2]|[12]?\\d)$', example: '192.168.1.0/24' }, { key: 'custom', value: 'custom', text: 'Custom (Regex)', regex: '', example: '' }];

var VALIDATION_TYPE_DICT = exports.VALIDATION_TYPE_DICT = VALIDATION_TYPE_MAP.reduce(function (acc, item) {
  return _extends({}, acc, _defineProperty({}, item.value, item));
}, {});

/** Extracts [day, month, year] from a date string based on the format key.*/
var extractDateParts = function extractDateParts(value, formatKey) {
  var parts = value.split(/[/\-.\sTZ]/).map(Number);

  // Map each format key to [day, month, year] using the correct positions
  var formatToDateParts = {
    // DD/MM/YYYY, DD-MM-YYYY, DD.MM.YYYY -> parts[0]=day, parts[1]=month, parts[2]=year
    date_dmy_slash: [parts[0], parts[1], parts[2]],
    date_dmy_dash: [parts[0], parts[1], parts[2]],
    date_dmy_dot: [parts[0], parts[1], parts[2]],

    // MM/DD/YYYY -> parts[0]=month, parts[1]=day, parts[2]=year
    date_mdy_slash: [parts[1], parts[0], parts[2]],

    // YYYY/MM/DD, YYYY-MM-DD -> parts[0]=year, parts[1]=month, parts[2]=day
    date_ymd_slash: [parts[2], parts[1], parts[0]],
    date_ymd_dash: [parts[2], parts[1], parts[0]],

    // MM-YYYY -> parts[0]=month, parts[1]=year (no day, use 1)
    date_my_dash: [1, parts[0], parts[1]],

    // YYYY-MM -> parts[0]=year, parts[1]=month (no day, use 1)
    date_ym_dash: [1, parts[1], parts[0]],

    // YYYY-MM-DD HH:MM / YYYY-MM-DD HH:MM:SS / ISO 8601
    datetime_ymd_dash_Hm_doubledot: [parts[2], parts[1], parts[0]],
    datetime_ymd_dash_Hms_doubledot: [parts[2], parts[1], parts[0]],
    datetime_iso_full: [parts[2], parts[1], parts[0]]
  };

  // Special handling for "Month DD, YYYY" (e.g. "August 03, 2025")
  if (formatKey === 'date_Mdy_space') {
    var match = value.match(/^(\w+)\s(\d{2}),\s(\d{4})$/);
    if (!match) return null;

    var monthNames = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];
    var monthIndex = monthNames.indexOf(match[1].toLowerCase()) + 1;
    if (monthIndex === 0) return null;

    return [Number(match[2]), monthIndex, Number(match[3])];
  }

  return formatToDateParts[formatKey] || null;
};

/** Validates whether day/month/year is a real calendar date.*/
var isValidCalendarDate = function isValidCalendarDate(day, month, year) {
  var date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
};

var checkRegex = exports.checkRegex = function checkRegex(value, data) {
  if (!value || !data || !data.regex) {
    return { isValid: true, message: null };
  }

  var formatEntry = VALIDATION_TYPE_DICT[data.formatName];

  // Step 1: Check if value matches the expected format pattern (e.g. DD/MM/YYYY)
  var regexValid = new RegExp(data.regex).test(value);
  if (!regexValid) {
    return {
      isValid: false,
      message: data.label + ' must be a valid ' + formatEntry.text + (formatEntry.value === 'custom' ? ': ' + data.regex : '')
    };
  }

  // Step 2: For date formats, also validate the actual calendar date.
  var dateParts = extractDateParts(value, data.formatName);
  if (dateParts) {
    var _dateParts = _slicedToArray(dateParts, 3),
        day = _dateParts[0],
        month = _dateParts[1],
        year = _dateParts[2];

    if (!isValidCalendarDate(day, month, year)) {
      return {
        isValid: false,
        message: data.label + ' must be a valid ' + formatEntry.text
      };
    }
  }

  return { isValid: true, message: null };
};

var RegexDropdownPicker = function (_Component) {
  _inherits(RegexDropdownPicker, _Component);

  function RegexDropdownPicker() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RegexDropdownPicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RegexDropdownPicker.__proto__ || Object.getPrototypeOf(RegexDropdownPicker)).call.apply(_ref, [this].concat(args))), _this), _this.typingTimeout = null, _this.handleOnFormatChange = function (e, _ref2) {
      var value = _ref2.value;

      var selected = VALIDATION_TYPE_DICT[value];

      _this.props.onChange(e, { validationFormat: selected });
    }, _this.handleOnRegexChange = function (e, _ref3) {
      var value = _ref3.value;

      if (_this.props.formatValue === VALIDATION_TYPE_DICT.custom.value) {
        _this.props.onChange(e, {
          validationFormat: _extends({}, VALIDATION_TYPE_DICT.custom, {
            regex: value
          })
        });
      }

      // Optional debounced side-effect (e.g. validation, API)
      clearTimeout(_this.typingTimeout);
      _this.typingTimeout = setTimeout(function () {
        console.log('Debounced side effect with regex:', value);
        // you can trigger validation/API here instead
      }, 300);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RegexDropdownPicker, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // clean up timeout when unmount
      clearTimeout(this.typingTimeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          formatValue = _props.formatValue,
          regexValue = _props.regexValue;


      return _react2.default.createElement(
        _semanticUiReact.Form.Group,
        null,
        _react2.default.createElement(
          _semanticUiReact.Form.Field,
          { width: 8 },
          _react2.default.createElement(_semanticUiReact.Form.Select, {
            fluid: true,
            search: true,
            name: 'formatPicker',
            label: t('Validation Type', { ns: _translation.TRANSLATION_FILES.screens }),
            options: VALIDATION_TYPE_MAP,
            value: formatValue || VALIDATION_TYPE_MAP[0].value,
            onChange: this.handleOnFormatChange
          })
        ),
        formatValue === 'custom' && _react2.default.createElement(
          _semanticUiReact.Form.Field,
          { width: 8 },
          _react2.default.createElement(_semanticUiReact.Form.Input, {
            fluid: true,
            name: 'regexInput',
            label: t('Custom Regex', { ns: _translation.TRANSLATION_FILES.screens }),
            value: regexValue,
            onChange: this.handleOnRegexChange
          })
        )
      );
    }
  }]);

  return RegexDropdownPicker;
}(_react.Component);

RegexDropdownPicker.propTypes = {
  t: _propTypes2.default.func.isRequired,
  formatValue: _propTypes2.default.string,
  regexValue: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired
};

RegexDropdownPicker.defaultProps = {
  formatValue: '',
  regexValue: ''
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(RegexDropdownPicker);

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _translation = __webpack_require__(4);

var _fetchM = __webpack_require__(6);

var _vietnam = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchStaff = function (_Component) {
  _inherits(SearchStaff, _Component);

  function SearchStaff(props) {
    _classCallCheck(this, SearchStaff);

    var _this = _possibleConstructorReturn(this, (SearchStaff.__proto__ || Object.getPrototypeOf(SearchStaff)).call(this, props));

    _initialiseProps.call(_this);

    var state = SearchStaff.getPropsToState(props);
    _this.state = _extends({}, state, {
      findStaffsResults: [],
      loading: false,
      showNoResults: true,
      selection: null
    });
    return _this;
  }

  _createClass(SearchStaff, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = SearchStaff.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.setTimer) {
        clearTimeout(this.setTimer);
      }
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this3.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'searchStaffs',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
        var _this4 = this;

        var t, store, res, query, message, _message, json, findStaffsResults, noResultsMessage;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                res = null;
                _context.prev = 5;
                query = (0, _vietnam.staffSearchQuery)({
                  auth: this.props.auth,
                  searchAll: this.props.searchAll,
                  search: value,
                  bookingID: this.props.bookingID
                });
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/search/staffs/?' + query, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context.sent;
                _context.next = 23;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](5);
                _context.next = 16;
                return this.setLoading(false);

              case 16:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 19;
                return _context.t0.res.text();

              case 19:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 21:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 23:
                if (res.ok) {
                  _context.next = 31;
                  break;
                }

                _context.next = 26;
                return res.text();

              case 26:
                _message = _context.sent;
                _context.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 29:
                _context.next = 43;
                break;

              case 31:
                _context.next = 33;
                return res.json();

              case 33:
                json = _context.sent;

                if (!json) {
                  _context.next = 40;
                  break;
                }

                findStaffsResults = json.map(function (obj) {
                  var newResults = {};
                  newResults.key = obj.id;
                  newResults.title = obj.name;
                  newResults.price = obj.preferredName;
                  newResults.description = obj.email;
                  return newResults;
                });
                _context.next = 38;
                return this.setComponentState({ findStaffsResults: findStaffsResults }, function () {
                  if (_this4.props.onFetch) {
                    _this4.props.onFetch(json, _this4.state.value);
                  }
                });

              case 38:
                _context.next = 43;
                break;

              case 40:
                noResultsMessage = t('No results found', { ns: _translation.TRANSLATION_FILES.translation });
                _context.next = 43;
                return this.setComponentState({ noResultsMessage: noResultsMessage });

              case 43:
                _context.next = 45;
                return this.setLoading(false);

              case 45:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 12]]);
      }));

      function searchStaffs(_x3) {
        return _ref.apply(this, arguments);
      }

      return searchStaffs;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            this.props.selectedValue.key > 0 || this.state.selection ? _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 16 },
                  _react2.default.createElement(_semanticUiReact.Input, {
                    readOnly: true,
                    fluid: true,
                    disabled: this.props.disabled,
                    value: this.props.selectedValue.key > 0 ? this.props.selectedValue.title + ' ' + (this.props.selectedValue.price && '(' + this.props.selectedValue.price + ')') : this.state.selection.title + ' ' + (this.state.selection.price && '(' + this.state.selection.price + ')'),
                    icon: _react2.default.createElement(_semanticUiReact.Icon, {
                      title: 'Clear Selection',
                      name: 'x',
                      onClick: this.handleClearSelection,
                      link: true
                    })
                  })
                )
              )
            ) : _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 16 },
                  _react2.default.createElement(_semanticUiReact.Search, {
                    className: 'searchlist',
                    disabled: this.props.disabled,
                    fluid: true,
                    icon: _react2.default.createElement(_semanticUiReact.Icon, {
                      title: 'Clear Selection',
                      name: this.state.value ? 'x' : 'search',
                      onClick: this.state.value && this.handlerClearValue,
                      link: !!this.state.value
                    }),
                    loading: this.state.loading,
                    onResultSelect: this.handleResultSelect,
                    onSearchChange: this.handleSearchChange,
                    results: this.state.findStaffsResults,
                    value: this.state.value,
                    placeholder: this.props.placeholder || t('Find Staff...', { ns: _translation.TRANSLATION_FILES.translation }),
                    noResultsMessage: this.state.noResultsMessage,
                    onFocus: function onFocus() {
                      var showNoResults = false;
                      _this5.setState({ showNoResults: showNoResults });
                    },
                    showNoResults: this.state.showNoResults
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return SearchStaff;
}(_react.Component);

SearchStaff.contextTypes = {
  store: _propTypes2.default.object
};
SearchStaff.propTypes = {
  onSelect: _propTypes2.default.func.isRequired,
  onClear: _propTypes2.default.func.isRequired,
  selectedValue: _propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired,
    price: _propTypes2.default.string.isRequired
  }).isRequired,
  value: _propTypes2.default.string,
  searchAll: _propTypes2.default.bool,
  // CPI-1429: Vietnamese sale whose assigned agent's branch limits the results; needs auth.
  bookingID: _propTypes2.default.string,
  auth: _propTypes2.default.shape({ company: _propTypes2.default.shape({ countryCode: _propTypes2.default.string }) }),
  disabled: _propTypes2.default.bool,
  onFetch: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  t: _propTypes2.default.func
};
SearchStaff.defaultProps = {
  selectedValue: {
    key: 0,
    title: '',
    price: ''
  },
  disabled: false
};

SearchStaff.getPropsToState = function (props) {
  var value = props.value || '';
  var noResultsMessage = 'Loading...';
  return {
    value: value,
    noResultsMessage: noResultsMessage
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.handleSearchChange = function (e, _ref2) {
    var value = _ref2.value;
    var t = _this6.props.t;

    clearTimeout(_this6.setTimer);
    var findStaffsResults = [];
    var showNoResults = true;
    var noResultsMessage = t('Loading...', { ns: _translation.TRANSLATION_FILES.translation });
    _this6.setState({ findStaffsResults: findStaffsResults, noResultsMessage: noResultsMessage, showNoResults: showNoResults, value: value }, function () {
      if (value !== '') {
        _this6.setTimer = setTimeout(function () {
          _this6.searchStaffs(value);
        }, 500);
      }
    });
  };

  this.handleResultSelect = function (e, _ref3) {
    var result = _ref3.result;

    _this6.setState({
      selection: result,
      value: ''
    }, function () {
      _this6.props.onSelect(result);
    });
  };

  this.handleClearSelection = function () {
    _this6.setState({
      selection: null
    }, function () {
      _this6.props.onClear();
    });
  };

  this.handlerClearValue = function () {
    _this6.setState({
      value: ''
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(SearchStaff);

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StatusFlag = function (_Component) {
  _inherits(StatusFlag, _Component);

  function StatusFlag(props) {
    _classCallCheck(this, StatusFlag);

    var _this = _possibleConstructorReturn(this, (StatusFlag.__proto__ || Object.getPrototypeOf(StatusFlag)).call(this, props));

    _this.state = {
      // example future state
      isOpen: false
    };
    return _this;
  }

  _createClass(StatusFlag, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          text = _props.text,
          value = _props.value;


      return _react2.default.createElement(
        'div',
        { className: 'uc-status-flag uc-' + value, style: { display: 'inline-flex', alignItems: 'center', gap: '8px' } },
        _react2.default.createElement(
          'span',
          { style: { margin: 0 } },
          text
        )
      );
    }
  }]);

  return StatusFlag;
}(_react.Component);

// Optional: define default props


StatusFlag.defaultProps = {
  position: 'bottom center'
};

StatusFlag.propTypes = {
  text: _propTypes2.default.string,
  value: _propTypes2.default.string
};

exports.default = StatusFlag;

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CUSTOMER_TITLES = [{ text: 'Mr.', value: 'Mr.' }, { text: 'Ms.', value: 'Ms.' }, { text: 'Mrs.', value: 'Mrs.' },
// { text: 'Dr.', value: 'Dr.' },
// { text: 'JP', value: 'JP' },
// { text: 'Pehin', value: 'Pehin' },
// { text: 'Datin', value: 'Datin' },
// { text: 'Datuk', value: 'Datuk' },
// { text: 'Dato\'', value: 'Dato\'' },
// { text: 'Dato', value: 'Dato' },
// { text: 'Datuk Seri', value: 'Datuk Seri' },
// { text: 'Datin Seri', value: 'Datin Seri' },
// { text: 'Dato\' Sri', value: 'Dato\' Sri' },
// { text: 'Tan Sri', value: 'Tan Sri' },
// { text: 'Puan Sri', value: 'Puan Sri' },
// { text: 'Tun', value: 'Tun' },
{ text: 'Not Applicable', value: 'Not Applicable' }];
exports.default = CUSTOMER_TITLES;

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_BOOKING_FIELD_LIST = exports.PURCHASER_CUSTOM_FIELDS = exports.EXTRA_PURCHASER_CUSTOM_FIELDS = exports.getDefaultFieldsData = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _race = __webpack_require__(324);

var _bumi = __webpack_require__(318);

var _gender = __webpack_require__(319);

var _maritalStatus = __webpack_require__(320);

var getBDFOptions = function getBDFOptions(data) {
  if (data.length > 0) {
    return data.map(function (v, idx) {
      return {
        id: '',
        projectBookingCustomFieldID: '',
        title: v.text,
        value: v.value,
        isDeleted: false,
        isEditing: false,
        dataValue: '',
        position: idx + 1
      };
    });
  }
  return null;
};
var extraPurchaserCustomFieldList = [{
  id: '',
  type: 'input',
  name: 'jobTitle',
  label: 'Occupation'
}, {
  id: '',
  type: 'input',
  name: 'monthlyIncome',
  label: 'Monthly Income'
}, {
  id: '',
  type: 'dropdown',
  name: 'nationality',
  label: 'Nationality'
}, {
  id: '',
  type: 'input',
  name: 'birthdate',
  label: 'Date of Birth'
}, {
  id: '',
  type: 'dropdown',
  name: 'gender',
  label: 'Gender',
  projectBookingCustomFieldOptions: getBDFOptions(_gender.GENDER)
}, {
  id: '',
  type: 'dropdown',
  name: 'race',
  label: 'Race',
  projectBookingCustomFieldOptions: getBDFOptions(_race.RACE)
}, {
  id: '',
  type: 'dropdown',
  name: 'bumi',
  label: 'Bumi Status',
  projectBookingCustomFieldOptions: getBDFOptions(_bumi.BUMI)
}, {
  id: '',
  type: 'dropdown',
  name: 'maritalStatus',
  label: 'Marital Status',
  projectBookingCustomFieldOptions: getBDFOptions(_maritalStatus.MARITAL_STATUS)
}, {
  id: '',
  type: 'input',
  name: 'emergencyContactName',
  label: 'Name of Emergency Contact'
}, {
  id: '',
  type: 'input',
  name: 'emergencyContactRelation',
  label: 'Emergency Contact Relation'
}, {
  id: '',
  type: 'input',
  name: 'emergencyContactMobile',
  label: 'Emergency Contact Number'
}, {
  id: '',
  type: 'input',
  name: 'emergencyContactEmail',
  label: 'Emergency Contact Email'
}, {
  id: '',
  type: 'input',
  name: 'emergencyContactIdentity',
  label: 'Emergency Identity Number'
}, {
  id: '',
  type: 'input',
  name: 'sstRegistrationNo',
  label: 'SST Registration No.'
}];
var getDefaultFieldsData = exports.getDefaultFieldsData = function getDefaultFieldsData() {
  var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return fields.map(function (v, idx) {
    return _extends({}, v, {
      placeholder: v.label,
      defaultValue: '',
      className: '',
      style: '',
      isEditing: false,
      isRequired: false,
      isDisabled: false,
      isDeleted: false,
      isDefault: true,
      isHidden: false,
      position: (v.name === 'email' ? extraPurchaserCustomFieldList.length : idx) + 1,
      showName: false,
      errorMessage: '' // not saved inside db only for FE usage
    });
  });
};
var EXTRA_PURCHASER_CUSTOM_FIELDS = exports.EXTRA_PURCHASER_CUSTOM_FIELDS = getDefaultFieldsData(extraPurchaserCustomFieldList);
var purchaserCustomFieldList = [{
  id: '',
  type: 'input',
  name: 'email',
  label: 'Email'
}];
var PURCHASER_CUSTOM_FIELDS = exports.PURCHASER_CUSTOM_FIELDS = getDefaultFieldsData(purchaserCustomFieldList);
var DEFAULT_BOOKING_FIELD_LIST = exports.DEFAULT_BOOKING_FIELD_LIST = EXTRA_PURCHASER_CUSTOM_FIELDS.concat(PURCHASER_CUSTOM_FIELDS);

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PICTURE_TYPES = [{ key: 'general', text: 'General', value: 'general' }, { key: 'site_plan', text: 'Site Plan', value: 'site_plan' }, { key: 'unit_layout', text: 'Unit Layout', value: 'unit_layout' }, { key: 'map', text: 'Map', value: 'map' }];
exports.default = PICTURE_TYPES;

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var VA_BANK_NAME = exports.VA_BANK_NAME = 'va_bank_name';
var VA_ACCOUNT_NUMBER = exports.VA_ACCOUNT_NUMBER = 'va_account_number';

var VA_UNIT_FIELDS = exports.VA_UNIT_FIELDS = [VA_BANK_NAME, VA_ACCOUNT_NUMBER];

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDropzone = __webpack_require__(3177);

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _reactI18next = __webpack_require__(3);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _compress = __webpack_require__(2576);

var _EditImage = __webpack_require__(560);

var _EditImage2 = _interopRequireDefault(_EditImage);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _ESigningModal = __webpack_require__(571);

var _ESigningModal2 = _interopRequireDefault(_ESigningModal);

var _CreditCheckConsentTemplate = __webpack_require__(2117);

var _CreditCheckConsentTemplate2 = _interopRequireDefault(_CreditCheckConsentTemplate);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DEFAULT_ACCEPT = 'image/jpeg, image/png, application/pdf';

// Whether a file is one of the types in an accept list such as 'image/jpeg, image/png', which may
// also hold wildcards ('image/*') and extensions ('.pdf').
var fileAccepted = function fileAccepted(accept, file) {
  return (accept || '').split(',').map(function (type) {
    return type.trim().toLowerCase();
  }).filter(Boolean).some(function (type) {
    if (type.startsWith('.')) return (file.name || '').toLowerCase().endsWith(type);
    if (type.endsWith('/*')) return (file.type || '').toLowerCase().startsWith(type.slice(0, -1));
    return (file.type || '').toLowerCase() === type;
  });
};

var UploadForm = function (_Component) {
  _inherits(UploadForm, _Component);

  function UploadForm(props) {
    _classCallCheck(this, UploadForm);

    var _this = _possibleConstructorReturn(this, (UploadForm.__proto__ || Object.getPrototypeOf(UploadForm)).call(this, props));

    _initialiseProps.call(_this);

    var upload = Object.assign({}, UploadForm.defaultValues);
    var state = UploadForm.getPropsToState(props);
    _this.state = _extends({
      upload: upload
    }, state, {
      accepted: [],
      rejected: [],
      isSignature: true,
      loading: false,
      isSigned: false,
      files: ''
    });
    return _this;
  }

  _createClass(UploadForm, [{
    key: 'getFormData',
    value: function getFormData() {
      return new FormData(this.form);
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'setSigned',
    value: function setSigned() {
      var _this3 = this;

      var isSigned = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ isSigned: isSigned }, function () {
          res(isSigned);
        });
      });
    }
  }, {
    key: 'getDocumentToken',
    value: function getDocumentToken(callback) {
      var _this4 = this;

      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.customerID + '/documents/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      }).then(function (res) {
        var documentToken = res.headers.get('X-Csrf-Token');
        _this4.setState({
          documentToken: documentToken
        }, function () {
          if (callback) {
            callback();
          }
        });
      });
    }
  }, {
    key: 'resetFiles',
    value: function resetFiles() {
      var _this5 = this;

      // temporary fix for upload modal not closing
      this.setState({
        upload: Object.assign({}, UploadForm.defaultValues)
      }, function () {
        _this5.handleOnChange();
      });
    }
  }, {
    key: 'handleOnChange',
    value: function handleOnChange() {
      if (this.props.onChange) {
        var upload = this.state.upload;

        this.props.onChange(upload, upload.src.length > 0);
      }
    }
  }, {
    key: 'rejectedMessage',
    value: function rejectedMessage() {
      var accept = this.props.accept;

      return accept === DEFAULT_ACCEPT ? 'Only image/jpeg, image/png, and application/pdf accepted' : 'Only ' + accept + ' accepted';
    }
  }, {
    key: 'generateSignature',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(body) {
        var picture, store, res, message, response, newPicture;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                picture = this.state.picture;
                store = this.context.store;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.customerID + '/documents/signatures/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    // Let browser decide Content-Type
                    'X-Csrf-Token': this.state.documentToken
                  },
                  body: body
                }));

              case 8:
                res = _context.sent;
                _context.next = 24;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);
                _context.next = 15;
                return this.setLoading(false);

              case 15:
                Bugsnag.notifyException(_context.t0);

                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 22;
                  break;
                }

                _context.next = 19;
                return _context.t0.res.text();

              case 19:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 22:
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context.abrupt('return');

              case 24:
                if (!res.ok) {
                  _context.next = 32;
                  break;
                }

                _context.next = 27;
                return res.json();

              case 27:
                response = _context.sent;
                newPicture = Object.assign({}, picture);

                newPicture.key = response.key;
                newPicture.name = response.name;
                this.setState({ picture: newPicture });

              case 32:
                _context.next = 34;
                return this.setLoading(false);

              case 34:
                _context.next = 36;
                return this.signatureModal.handleOnCancel();

              case 36:
                _context.next = 38;
                return this.setSigned(true);

              case 38:
                this.props.onSigned();
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Consent signed', message: 'Consent signed and generated' }));

              case 40:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function generateSignature(_x3) {
        return _ref.apply(this, arguments);
      }

      return generateSignature;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var t = this.props.t;
      var _props = this.props,
          as = _props.as,
          title = _props.title,
          labelContent = _props.labelContent;
      var _state = this.state,
          isSignature = _state.isSignature,
          isSigned = _state.isSigned,
          picture = _state.picture,
          upload = _state.upload;

      var Wrapper = as;
      return _react2.default.createElement(
        Wrapper,
        {
          encType: 'multipart/form-data',
          name: 'uploadForm',
          ref: function ref(_ref5) {
            _this6.form = _ref5;
          }
        },
        _react2.default.createElement('input', {
          ref: function ref(_ref2) {
            _this6.uploadFiles = _ref2;
          },
          type: 'file',
          onChange: this.handleChangeFile,
          accept: this.props.accept,
          style: { display: 'none' }
        }),
        this.props.signature && _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { centered: true },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                computer: title === 'NewCreditForm' ? 8 : null,
                tablet: title === 'NewCreditForm' ? 10 : null,
                mobile: title === 'NewCreditForm' ? 16 : null
              },
              _react2.default.createElement(
                'h3',
                {
                  style: {
                    textAlign: 'left'
                  }
                },
                'Choose One'
              ),
              _react2.default.createElement(
                'div',
                { className: 'menuTab' },
                _react2.default.createElement(
                  _semanticUiReact.Menu,
                  { fluid: true, widths: 2 },
                  this.tabs.map(function (tab, idx) {
                    return _react2.default.createElement(
                      _semanticUiReact.Menu.Item,
                      {
                        key: idx,
                        name: tab.name,
                        onClick: function onClick() {
                          return _this6.handleChangeTab(tab.isSignature);
                        },
                        active: isSignature === tab.isSignature
                      },
                      _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          { style: { marginBottom: 0 } },
                          tab.text
                        ),
                        _react2.default.createElement(
                          'p',
                          { style: { fontSize: '10px' } },
                          tab.description
                        )
                      )
                    );
                  })
                )
              )
            )
          )
        ),
        !isSignature || !this.props.signature ? _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', textAlign: 'center' },
          this.state.picture.name && (title === 'NewCreditForm' || title === 'Front' || title === 'Back') ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { paddingBottom: 0 } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                computer: title === 'NewCreditForm' ? 5 : null,
                tablet: title === 'NewCreditForm' ? 6 : null,
                mobile: title === 'NewCreditForm' ? 8 : null,
                style: { textAlign: 'left', width: title !== 'NewCreditForm' ? '60%' : null, overflow: 'hidden' }
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle outline', style: { color: 'rgba(0, 151, 161, 1)' } }),
              this.state.picture.name
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                computer: title === 'NewCreditForm' ? 3 : null,
                tablet: title === 'NewCreditForm' ? 4 : null,
                mobile: title === 'NewCreditForm' ? 8 : null,
                style: { textAlign: 'right', width: title !== 'NewCreditForm' ? '40%' : null }
              },
              _react2.default.createElement(
                'div',
                { className: 'replaceButton' },
                _react2.default.createElement(_semanticUiReact.Button, {
                  floated: 'right',
                  onClick: this.handleAddFile,
                  content: t('Replace file', { ns: _translation.TRANSLATION_FILES.translation })
                })
              )
            )
          ) : null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { padding: title === 'FinancialForm' ? 0 : null } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              upload.file && upload.type !== 'application/pdf' && this.state.picture.name !== 'consent.png' && title !== 'FinancialForm' ? _react2.default.createElement(_semanticUiReact.Label, {
                style: { opacity: 0.75 },
                as: 'a',
                attached: 'top left',
                icon: { name: 'repeat', flipped: 'horizontally' },
                disabled: this.props.loading,
                onClick: function onClick() {
                  return _this6.handleRotate('left');
                }
              }) : null,
              upload.file && upload.type !== 'application/pdf' && this.state.picture.name !== 'consent.png' && title !== 'FinancialForm' ? _react2.default.createElement(_semanticUiReact.Label, {
                style: { opacity: 0.75 },
                as: 'a',
                attached: 'top right',
                icon: 'repeat',
                disabled: this.props.loading,
                onClick: function onClick() {
                  return _this6.handleRotate('right');
                }
              }) : null,
              upload.file && upload.type !== 'application/pdf' && this.state.picture.name !== 'consent.png' && title !== 'FinancialForm' ? _react2.default.createElement(_EditImage2.default, {
                src: picture.key,
                degree: upload.degree || 0,
                onClick: this.handleAddFile
              }) : null,
              !upload.file && upload.type === 'application/pdf' && title !== 'FinancialForm' && title !== 'NewCreditForm' && title !== 'Front' && title !== 'Back' ? _react2.default.createElement(_LoadImage2.default, {
                centered: true,
                onClick: this.handleAddFile,
                picture: this.props.picture,
                pictureSize: this.props.picture ? 70 : null,
                src: this.props.sampleURL || '',
                size: this.props.picture ? null : this.props.sampleSize || 'medium',
                bucketName: this.props.bucketName
              }) : null,
              upload.file && upload.type !== 'application/pdf' && this.state.picture.name === 'consent.png' && title !== 'FinancialForm' ? _react2.default.createElement(_LoadImage2.default, {
                centered: true,
                onClick: this.handleAddFile,
                picture: this.state.picture,
                pictureSize: this.state.picture ? 70 : null,
                src: this.props.sampleURL || '',
                size: this.state.picture ? null : this.props.sampleSize || 'medium',
                bucketName: this.props.bucketName
              }) : null,
              !upload.file && this.props.pictureSrc && title !== 'FinancialForm' ? _react2.default.createElement(_LoadImage2.default, {
                centered: true,
                onClick: this.handleAddFile,
                picture: null,
                src: this.props.pictureSrc
              }) : null,
              !upload.file && !this.props.pictureSrc && this.state.picture.key && title !== 'FinancialForm' ? _react2.default.createElement(_LoadImage2.default, {
                centered: true,
                onClick: this.handleAddFile,
                picture: this.state.picture,
                pictureSize: this.state.picture ? 70 : null,
                src: this.props.sampleURL || '',
                size: this.state.picture ? null : this.props.sampleSize || 'medium',
                bucketName: this.props.bucketName
              }) : null,
              (upload.file || this.state.picture.key) && title === 'FinancialForm' ? _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { style: { marginTop: '1rem', paddingBottom: 0 } },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_semanticUiReact.Header, {
                      as: 'h5',
                      style: { marginBottom: '0.5em', width: '60%', float: 'left', marginTop: '0.5rem' },
                      textAlign: 'left',
                      content: labelContent
                    }),
                    _react2.default.createElement(
                      'div',
                      { className: 'replaceButton', style: { width: '40%', float: 'right' } },
                      _react2.default.createElement(_semanticUiReact.Button, {
                        floated: 'right',
                        onClick: this.handleAddFile,
                        content: t('Replace file', { ns: _translation.TRANSLATION_FILES.translation })
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { style: { paddingTop: 0 } },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Container,
                      { style: { border: '1px solid rgb(217, 218, 220)', padding: '1rem', borderRadius: '0.25rem', background: this.state.picture.name ? 'rgba(231, 236, 241)' : 'transparent', height: '50px', overflow: 'hidden' } },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'file outline', style: { float: 'left' } }),
                      _react2.default.createElement(
                        'p',
                        { style: { float: 'left', width: '70%' } },
                        this.state.picture.name
                      )
                    )
                  )
                )
              ) : null
            )
          ),
          this.props.downloadURL ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { padding: '1rem 0' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_semanticUiReact.Button, {
                className: 'consentLink',
                content: 'Download Consent Authorization Form',
                onClick: function onClick(e) {
                  return _this6.handleOpenConsentForm(e);
                }
              })
            )
          ) : null,
          title === 'NewCreditForm' || title === 'FinancialForm' || title === 'Front' || title === 'Back' ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { centered: true },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { computer: title === 'NewCreditForm' ? 8 : null, tablet: title === 'NewCreditForm' ? 10 : null, mobile: title === 'NewCreditForm' ? 16 : null },
              !upload.file && this.state.picture.key === '' && title === 'FinancialForm' ? _react2.default.createElement(_semanticUiReact.Header, {
                as: 'h5',
                style: { marginBottom: '0.5em', width: '60%', float: 'left', marginTop: '0.5rem' },
                textAlign: 'left',
                content: labelContent
              }) : null,
              !upload.file && this.state.picture.key === '' && !this.props.pictureSrc ? _react2.default.createElement(
                _reactDropzone2.default,
                {
                  accept: this.props.accept,
                  onDrop: function onDrop(accepted, rejected) {
                    _this6.handleChangeDropFile({ accepted: accepted, rejected: rejected });
                  },
                  style: title === 'FinancialForm' ? {
                    width: '100%',
                    height: '40px',
                    borderColor: 'rgba(164, 179, 193, 1)',
                    borderRadius: '0.3rem',
                    borderStyle: 'dashed',
                    borderWidth: '1px',
                    display: 'flex',
                    alignItems: 'center'
                  } : {
                    width: '100%',
                    height: '200px',
                    background: 'rgba(229, 244, 245, 1)',
                    borderColor: 'rgba(0, 151, 161, 1)',
                    borderRadius: '0.3rem',
                    borderStyle: 'dashed',
                    borderWidth: '1px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                  },
                  activeStyle: { background: 'rgba(0, 151, 161, 1)' }
                },
                function (_ref3) {
                  var isDragActive = _ref3.isDragActive;
                  return _react2.default.createElement(
                    _semanticUiReact.Header,
                    {
                      as: 'a',
                      style: title === 'FinancialForm' ? {
                        textAlign: 'center',
                        width: '100%',
                        height: '100%',
                        marginTop: '2rem'
                      } : null
                    },
                    (title === 'NewCreditForm' || title === 'Front' || title === 'Back') && !isDragActive ? _react2.default.createElement(
                      'div',
                      { style: { color: 'rgba(0, 151, 161, 1)' } },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus circle' }),
                      _react2.default.createElement(
                        _semanticUiReact.Header.Content,
                        null,
                        title === 'NewCreditForm' ? 'Upload signed form' : null,
                        title === 'Front' ? t('Upload Front') : null,
                        title === 'Back' ? t('Upload Back') : null
                      )
                    ) : null,
                    (title === 'NewCreditForm' || title === 'Front' || title === 'Back') && isDragActive ? _react2.default.createElement(
                      'div',
                      { style: { color: 'white' } },
                      _react2.default.createElement(
                        _semanticUiReact.Header.Content,
                        null,
                        'Drop file here',
                        _react2.default.createElement(
                          _semanticUiReact.Header.Subheader,
                          { style: { color: 'white' } },
                          'Add file by dropping them in this window'
                        )
                      )
                    ) : null,
                    title === 'FinancialForm' && !isDragActive ? _react2.default.createElement(
                      'div',
                      { style: { color: 'rgba(89, 105, 117, 1)' } },
                      _react2.default.createElement(
                        _semanticUiReact.Header.Content,
                        { style: { fontWeight: 'normal' } },
                        '+ Upload file'
                      )
                    ) : null,
                    title === 'FinancialForm' && isDragActive ? _react2.default.createElement(
                      'div',
                      { style: { color: 'white' } },
                      _react2.default.createElement(
                        _semanticUiReact.Header.Content,
                        null,
                        'Drop file here'
                      )
                    ) : null
                  );
                }
              ) : null
            )
          ) : _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              !upload.file ? _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  fluid: true,
                  primary: true,
                  disabled: this.props.loading,
                  onClick: this.handleAddFile
                },
                _react2.default.createElement(
                  'i',
                  { className: 'icon' },
                  _react2.default.createElement('img', { src: '/assets/images/icons/upload.svg', alt: '' })
                ),
                'Upload File'
              ) : null
            )
          )
        ) : _react2.default.createElement(
          _semanticUiReact.Segment,
          { style: { boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.25)' } },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { className: 'signature-upload', columns: 'equal' },
            isSigned && picture.name === 'consent.png' ? _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { textAlign: 'center' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(_LoadImage2.default, {
                  centered: true,
                  picture: picture,
                  pictureSize: this.state.picture ? 70 : null,
                  src: this.props.sampleURL || '',
                  size: this.state.picture ? null : this.props.sampleSize || 'medium',
                  bucketName: this.props.bucketName
                })
              )
            ) : _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(_CreditCheckConsentTemplate2.default, {
                  company: this.props.auth && this.props.auth.company,
                  customerName: this.props.customerName,
                  jobTitle: this.props.jobTitle,
                  identityTypeID: this.props.identityTypeID,
                  identity: this.props.identity,
                  customerID: this.props.customerID
                })
              )
            ),
            (this.props.signedAt && this.props.signedAt !== null && (0, _momentTimezone2.default)().isBefore((0, _momentTimezone2.default)(this.props.signedAt).add(1, 'day')) || this.state.isSigned) && _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'sign' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'round icon' },
                  _react2.default.createElement('img', { alt: 'e-signing', src: '/assets/images/icons/tick-white.svg' })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'E-signing'
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { centered: true, style: { background: 'rgba(229, 244, 245, 1)', padding: '2rem' } },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { className: 'res-width' },
                _react2.default.createElement(_ESigningModal2.default, {
                  ref: function ref(_ref4) {
                    _this6.signatureModal = _ref4;
                  },
                  loading: this.state.loading,
                  saveButton: _react2.default.createElement(_semanticUiReact.Button, { onClick: this.saveSignature, disabled: this.state.loading, positive: true, color: 'green', content: 'Save' }),
                  trigger: this.state.isSigned ? _react2.default.createElement(
                    'div',
                    { className: 'clickable link' },
                    'Sign again'
                  ) : _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'div',
                      { className: 'eSignButton' },
                      _react2.default.createElement(
                        _semanticUiReact.Button,
                        {
                          disabled: this.state.loading
                        },
                        'E-sign here'
                      )
                    )
                  )
                })
              )
            )
          )
        )
      );
    }
  }]);

  return UploadForm;
}(_react.Component);

UploadForm.propTypes = {
  as: _propTypes2.default.string,
  customerID: _propTypes2.default.string,
  jobTitle: _propTypes2.default.string,
  customerName: _propTypes2.default.string,
  identity: _propTypes2.default.string,
  identityTypeID: _propTypes2.default.number,
  isCompress: _propTypes2.default.bool,
  title: _propTypes2.default.string,
  picture: _propTypes2.default.shape({
    key: _propTypes2.default.string,
    tags: _propTypes2.default.arrayOf(_propTypes2.default.string)
  }),
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.object
  }),
  onChange: _propTypes2.default.func,
  signature: _propTypes2.default.bool,
  sampleURL: _propTypes2.default.string,
  sampleSize: _propTypes2.default.string,
  tags: _propTypes2.default.arrayOf(_propTypes2.default.string),
  labelContent: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  downloadURL: _propTypes2.default.string,
  signedAt: _propTypes2.default.string,
  onSigned: _propTypes2.default.func,
  bucketName: _propTypes2.default.string,
  // A ready URL for the current picture, used instead of building one from picture.key
  // (CPI-1332: a linked purchaser's CRM Customer identity picture, loaded from book-api).
  pictureSrc: _propTypes2.default.string,
  // The file types offered (CPI-1332: a linked purchaser's CRM Customer picture must be an
  // image).
  accept: _propTypes2.default.string,
  t: _propTypes2.default.func
};
UploadForm.defaultProps = {
  as: 'form',
  accept: DEFAULT_ACCEPT
};
UploadForm.contextTypes = {
  store: _propTypes2.default.object
};
UploadForm.defaultValues = {
  file: null,
  name: '',
  src: '',
  type: '',
  tags: [],
  degree: 0
};
UploadForm.defaultPicture = {
  createdAt: '',
  customerID: '',
  id: '',
  key: '',
  name: '',
  size: 0,
  tags: [],
  updatedAt: '',
  userID: 0
};

UploadForm.getPropsToState = function (props) {
  var picture = Object.assign({}, UploadForm.defaultPicture, props.picture || {});
  return {
    picture: picture
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.handleChangeFile = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var picture, files, file, accept, reader;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _this7.setLoading(true);

          case 2:
            picture = _this7.state.picture;
            files = Array.prototype.slice.call(_this7.uploadFiles.files);

            _this7.uploadFiles.value = null;

            if (!(window.FileReader && files && files.length > 0)) {
              _context2.next = 24;
              break;
            }

            file = files[0];
            // CPI-1426: the picker's accept is only a hint ("All files" bypasses it), so a picked file
            // is checked when the caller narrowed the types. The default is left to book-api as before,
            // which also takes types the default does not list (GIF).

            accept = _this7.props.accept;

            if (!(file && accept !== DEFAULT_ACCEPT && !fileAccepted(accept, file))) {
              _context2.next = 13;
              break;
            }

            _this7.context.store.dispatch((0, _flash.flashErrorMessage)({ message: _this7.rejectedMessage() }));
            _context2.next = 12;
            return _this7.setLoading(false);

          case 12:
            return _context2.abrupt('return');

          case 13:
            if (!file) {
              _context2.next = 22;
              break;
            }

            reader = new FileReader();

            if (!(file.type.match('image.*') && _this7.props.isCompress && file.size > 1048576)) {
              _context2.next = 20;
              break;
            }

            _context2.next = 18;
            return (0, _compress.compress)(file).then(function (b) {
              reader.onloadend = function () {
                var upload = Object.assign(_this7.state.upload, {
                  file: b,
                  name: file.name,
                  src: reader.result,
                  type: file.type,
                  tags: [].concat(_this7.props.tags) || [],
                  degree: 0
                });
                _this7.setState({ upload: upload }, function () {
                  _this7.handleOnChange();
                });
                var newPicture = Object.assign({}, picture);
                newPicture.key = reader.result;
                newPicture.name = file.name;
                _this7.setState({ picture: newPicture });
              };
              reader.readAsDataURL(b);
            });

          case 18:
            _context2.next = 22;
            break;

          case 20:
            reader.onloadend = function () {
              var upload = Object.assign(_this7.state.upload, {
                file: file,
                name: file.name,
                src: reader.result,
                type: file.type,
                tags: [].concat(_this7.props.tags) || [],
                degree: 0
              });
              _this7.setState({ upload: upload }, function () {
                _this7.handleOnChange();
              });
              var newPicture = Object.assign({}, picture);
              newPicture.key = reader.result;
              newPicture.name = file.name;
              _this7.setState({ picture: newPicture });
            };
            reader.readAsDataURL(file);

          case 22:
            _context2.next = 24;
            return _this7.setLoading(false);

          case 24:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this7);
  }));

  this.handleChangeDropFile = function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref8) {
      var accepted = _ref8.accepted,
          rejected = _ref8.rejected;
      var store, picture, file, reader;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this7.setLoading(true);

            case 2:
              _this7.uploadFiles.value = null;
              store = _this7.context.store;
              picture = _this7.state.picture;

              if (rejected.length > 0) {
                store.dispatch((0, _flash.flashErrorMessage)({ message: _this7.rejectedMessage() }));
              }

              if (!(window.FileReader && accepted && accepted.length > 0)) {
                _context3.next = 19;
                break;
              }

              file = accepted[0];

              if (!file) {
                _context3.next = 17;
                break;
              }

              reader = new FileReader();

              if (!(file.type.match('image.*') && _this7.props.isCompress && file.size > 1048576)) {
                _context3.next = 15;
                break;
              }

              _context3.next = 13;
              return (0, _compress.compress)(file).then(function (b) {
                reader.onloadend = function () {
                  var upload = Object.assign(_this7.state.upload, {
                    file: b,
                    name: file.name,
                    src: reader.result,
                    type: file.type,
                    tags: [].concat(_this7.props.tags) || [],
                    degree: 0
                  });
                  _this7.setState({ upload: upload }, function () {
                    _this7.handleOnChange();
                  });
                  var newPicture = Object.assign({}, picture);
                  newPicture.key = reader.result;
                  newPicture.name = file.name;
                  _this7.setState({ picture: newPicture });
                };
                reader.readAsDataURL(b);
              });

            case 13:
              _context3.next = 17;
              break;

            case 15:
              reader.onloadend = function () {
                var upload = Object.assign(_this7.state.upload, {
                  file: file,
                  name: file.name,
                  src: reader.result,
                  type: file.type,
                  tags: [].concat(_this7.props.tags) || [],
                  degree: 0
                });
                _this7.setState({ upload: upload }, function () {
                  _this7.handleOnChange();
                });
                var newPicture = Object.assign({}, picture);
                newPicture.key = reader.result;
                newPicture.name = file.name;
                _this7.setState({ picture: newPicture });
              };
              reader.readAsDataURL(file);

            case 17:
              _context3.next = 19;
              return _this7.setLoading(false);

            case 19:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this7);
    }));

    return function (_x4) {
      return _ref7.apply(this, arguments);
    };
  }();

  this.handleRemove = function (event) {
    event.preventDefault();
    var upload = Object.assign({}, UploadForm.defaultValues);
    var newPicture = Object.assign({}, _this7.state.picture);
    newPicture.key = '';
    newPicture.name = '';
    _this7.setState({ picture: newPicture });
    _this7.setState({ upload: upload }, function () {
      _this7.handleOnChange();
    });
  };

  this.handleAddFile = function (event) {
    event.preventDefault();
    _this7.uploadFiles.click();
  };

  this.saveSignature = function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(event) {
      var store, formData;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              event.preventDefault();
              store = _this7.context.store;

              if (!_this7.signatureModal.isEmpty()) {
                _context4.next = 5;
                break;
              }

              store.dispatch((0, _flash.flashErrorMessage)({ message: 'Please sign the consent' }));
              return _context4.abrupt('return');

            case 5:
              formData = new FormData();


              formData.append('signature', (0, _compress.dataURLToBlob)(_this7.signatureModal.signData()));

              if (!(formData !== null)) {
                _context4.next = 10;
                break;
              }

              _context4.next = 10;
              return _this7.getDocumentToken(function () {
                _this7.generateSignature(formData);
              });

            case 10:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this7);
    }));

    return function (_x5) {
      return _ref9.apply(this, arguments);
    };
  }();

  this.handleRotate = function (direction) {
    var upload = _this7.state.upload;

    if (!upload.degree) {
      upload.degree = 0;
    }
    var increment = direction === 'right' ? 1 : -1;
    upload.degree += 90 * increment;
    if (upload.degree >= 360) {
      upload.degree = 0;
    }
    if (upload.degree < 0) {
      upload.degree = 270;
    }
    _this7.setState({ upload: upload }, function () {
      _this7.handleOnChange();
    });
  };

  this.tabs = [{ name: 'isSignature', text: 'E-signing', description: '(Required touch screen)', isSignature: true }, { name: 'isUpload', text: 'Upload Form', description: '(10mb max)', isSignature: false }];

  this.handleChangeTab = function () {
    var signature = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    var isSignature = _this7.state.isSignature;

    isSignature = signature;
    _this7.setState({ isSignature: isSignature });
  };

  this.handleOpenConsentForm = function (e) {
    e.preventDefault();
    window.open(_this7.props.downloadURL);
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(UploadForm);

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _reactRedux = __webpack_require__(9);

var _SizeSuffix = __webpack_require__(316);

var _SizeSuffix2 = _interopRequireDefault(_SizeSuffix);

var _translation = __webpack_require__(4);

var _translation2 = __webpack_require__(64);

var _unitLayout = __webpack_require__(270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */


var LayoutTitle = function (_Component) {
  _inherits(LayoutTitle, _Component);

  function LayoutTitle(props) {
    _classCallCheck(this, LayoutTitle);

    var _this = _possibleConstructorReturn(this, (LayoutTitle.__proto__ || Object.getPrototypeOf(LayoutTitle)).call(this, props));

    var state = LayoutTitle.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(LayoutTitle, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = LayoutTitle.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;
      var data = this.state.data;

      var isVietnam = this.props.auth.company && this.props.auth.company.countryCode.toUpperCase() === 'VN';
      var columnStyle = { paddingBottom: '0' };
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { style: { paddingBottom: '0' } },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'center', style: columnStyle },
            data ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _semanticUiReact.Header,
                { as: 'h3', style: { marginBottom: '0' } },
                data ? data.name : ''
              ),
              (0, _unitLayout.layoutAreaValue)(isVietnam, data) ? _react2.default.createElement(
                'p',
                { style: { margin: 0 } },
                _react2.default.createElement(
                  'span',
                  null,
                  isVietnam ? (0, _translation2.translateModels)(t, 'nsa', 'projectUnitLayout') : (0, _translation2.translateModels)(t, 'size', 'projectUnitLayout'),
                  ' '
                ),
                _react2.default.createElement(_SizeSuffix2.default, {
                  size: (0, _unitLayout.layoutAreaValue)(isVietnam, data),
                  suffix: data.project ? data.project.sizeSuffix : null,
                  isVietnam: isVietnam
                })
              ) : null,
              (0, _unitLayout.layoutLandAreaValue)(isVietnam, data) ? _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  isVietnam ? (0, _translation2.translateModels)(t, 'nfa', 'projectUnitLayout') : (0, _translation2.translateModels)(t, 'landArea', 'projectUnitLayout'),
                  ' '
                ),
                _react2.default.createElement(_SizeSuffix2.default, {
                  size: (0, _unitLayout.layoutLandAreaValue)(isVietnam, data),
                  suffix: data.project ? data.project.sizeSuffix : null,
                  isVietnam: isVietnam
                })
              ) : null
            ) : ''
          )
        )
      );
    }
  }]);

  return LayoutTitle;
}(_react.Component);

LayoutTitle.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]).isRequired,
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  t: _propTypes2.default.func
};

LayoutTitle.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

LayoutTitle.getPropsToState = function (props) {
  var data = props.data;
  return {
    data: data
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.projectUnitLayout]))((0, _reactRedux.connect)(LayoutTitle.mapStateToProps)(LayoutTitle));

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var routes = exports.routes = function routes(id, unitLayoutID) {
  var hasAccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var links = [{ text: 'Overview', value: '/projects/' + id + '/layouts/' + unitLayoutID + '/' }];
  if (hasAccess) {
    links.push({ text: 'Pictures', value: '/projects/' + id + '/layouts/' + unitLayoutID + '/pictures/' }, { text: 'Documents', value: '/projects/' + id + '/layouts/' + unitLayoutID + '/documents/' }, { text: 'Videos', value: '/projects/' + id + '/layouts/' + unitLayoutID + '/videos/' });
  }
  return links;
};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _BankerItem = __webpack_require__(556);

var _BankerItem2 = _interopRequireDefault(_BankerItem);

var _LimitCounter = __webpack_require__(1023);

var _LimitCounter2 = _interopRequireDefault(_LimitCounter);

var _HLBEligibleBanner = __webpack_require__(2152);

var _HLBEligibleBanner2 = _interopRequireDefault(_HLBEligibleBanner);

var _HLBCampaignJoinModal = __webpack_require__(1019);

var _HLBCampaignJoinModal2 = _interopRequireDefault(_HLBCampaignJoinModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BankersList = function (_Component) {
  _inherits(BankersList, _Component);

  function BankersList(props) {
    _classCallCheck(this, BankersList);

    var _this = _possibleConstructorReturn(this, (BankersList.__proto__ || Object.getPrototypeOf(BankersList)).call(this, props));

    _initialiseProps.call(_this);

    var state = BankersList.getPropsToState(props);
    var currentTab = props.only || _this.tabs[0].name;
    if (props.only) {
      currentTab = 'banker';
    }
    _this.state = _extends({}, state, {
      data: [],
      loading: true,
      count: 0,
      limit: 0,
      offset: 0,
      currentTab: currentTab,
      currentPage: 1,
      query: {},
      search: '',
      customTabs: [],
      showHLBJoinModal: false
    });
    return _this;
  }

  _createClass(BankersList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = BankersList.getPropsToState(nextProps);
      if (nextProps.open === true && this.props.open !== nextProps.open) {
        this.handleOnOpen();
        this.fetchBankers();
        if (this.props.bankerSelectionTabs) {
          this.getCustomTabs();
        }
      }
      this.setState(state);
    }
  }, {
    key: 'setBankers',
    value: function setBankers() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this2.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchBankers',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this5 = this;

        var store, query, url, res, message, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                _context.next = 4;
                return this.setBankers([]);

              case 4:
                store = this.context.store;
                query = Object.assign({
                  limit: 50,
                  page: this.state.currentPage || 1,
                  hideSummary: true,
                  search: this.state.search || ''
                });

                if (this.state.search) {
                  delete query.page;
                }
                if (this.props.bankID) {
                  query.bankID = this.props.bankID;
                }
                url = '/bankers/all/';
                _context.t0 = this.state.currentTab;
                _context.next = _context.t0 === 'panel_banker' ? 12 : _context.t0 === 'preferred_banker' ? 14 : 16;
                break;

              case 12:
                if (this.props.projectID) {
                  url = '/projects/' + this.props.projectID + '/bankers/?' + _qs2.default.stringify(query);
                }
                return _context.abrupt('break', 17);

              case 14:
                url = '/bankers/preferred/?' + _qs2.default.stringify(query);
                return _context.abrupt('break', 17);

              case 16:
                url = '/bankers/all/?' + _qs2.default.stringify(query);

              case 17:
                res = void 0;
                _context.prev = 18;
                _context.next = 21;
                return store.dispatch((0, _fetchM.fetchM)(url, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 21:
                res = _context.sent;
                _context.next = 32;
                break;

              case 24:
                _context.prev = 24;
                _context.t1 = _context['catch'](18);

                Bugsnag.notifyException(_context.t1);
                _context.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 29:
                _context.next = 31;
                return this.setLoading(false);

              case 31:
                return _context.abrupt('return');

              case 32:
                if (res.ok) {
                  _context.next = 40;
                  break;
                }

                _context.next = 35;
                return res.text();

              case 35:
                message = _context.sent;
                _context.next = 38;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 38:
                _context.next = 54;
                break;

              case 40:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10) || 0;
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context.next = 45;
                return res.json();

              case 45:
                data = _context.sent;
                _context.next = 48;
                return this.setBankers(data);

              case 48:
                if (!(this.state.data.length < 1 && query.page > 1)) {
                  _context.next = 52;
                  break;
                }

                this.setState({ currentPage: 1 }, function () {
                  _this5.fetchBankers();
                });
                _context.next = 54;
                break;

              case 52:
                _context.next = 54;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 54:
                _context.next = 56;
                return this.setLoading(false);

              case 56:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[18, 24]]);
      }));

      function fetchBankers() {
        return _ref.apply(this, arguments);
      }

      return fetchBankers;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var t = this.props.t;

      var hlbBankCodes = ['HLB', 'HLI'];
      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          open: this.props.open === true,
          onClose: this.handleOnClose,
          closeIcon: 'close',
          size: 'large',
          className: 'items-list-modal'
        },
        _react2.default.createElement(_semanticUiReact.Header, {
          icon: 'add',
          content: t('Add bankers', { ns: 'translation' })
        }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          !this.props.only && (!this.state.customTabs || this.state.customTabs && this.state.customTabs.length < 1) ? _react2.default.createElement(
            _semanticUiReact.Menu,
            { widths: 3, secondary: true, pointing: true },
            this.tabs.map(function (tab, key) {
              return _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                {
                  key: key,
                  name: tab.name,
                  onClick: _this6.handleChangeTab,
                  active: _this6.state.currentTab === tab.name
                },
                tab.text
              );
            })
          ) : null,
          !this.props.only && this.state.customTabs && this.state.customTabs.length > 0 ? _react2.default.createElement(
            _semanticUiReact.Menu,
            { widths: this.state.customTabs.length, secondary: true, pointing: true },
            this.state.customTabs.map(function (tab, key) {
              return _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                {
                  key: key,
                  name: tab.name,
                  onClick: _this6.handleChangeTab,
                  active: _this6.state.currentTab === tab.name
                },
                tab.text
              );
            })
          ) : null,
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle', columns: 1 },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_SearchFilter2.default, {
                isLoading: this.state.loading,
                onChange: this.handleOnChange,
                onClose: this.handleClearFilter,
                search: this.state.search
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'list' },
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                {
                  inverted: true, style: { zIndex: 20 },
                  active: this.state.loading && this.state.data.length > 0
                },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: 'translation' })
                )
              ),
              this.state.data.length > 0 ? _react2.default.createElement(
                _semanticUiReact.Table,
                { className: 'hlb-table-banker-listing', unstackable: true },
                _react2.default.createElement(
                  _semanticUiReact.Table.Body,
                  null,
                  this.state.data.map(function (d, idx) {
                    var banker = d;
                    if (d && d.banker && d.statusID && d.statusID === '200') {
                      banker = d.banker;
                      banker.pendingOnboarding = true;
                    }
                    var isSelected = _this6.state.selected.some(function (s) {
                      return s.id === banker.id;
                    });
                    var isHLBBankCampaign = banker.bank && hlbBankCodes.includes(banker.bank.code) && _this6.showHLBCampaign();
                    var disabled = _this6.handleOnCheck(banker);
                    return _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      {
                        key: idx,
                        active: disabled,
                        className: isHLBBankCampaign ? 'hlb-bank-row' : ''
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(_BankerItem2.default, {
                          banker: banker,
                          onClick: _this6.handleOnSelect,
                          selected: isSelected || _this6.handleOnCheckSelected(banker),
                          disabled: disabled,
                          checkable: true,
                          isHLBCampaign: _this6.showHLBCampaign(),
                          isHLBCampaignBank: isHLBBankCampaign
                        })
                      )
                    );
                  })
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Segment,
                { textAlign: 'center' },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  t('Loading', { ns: 'translation' })
                ) : t('No ' + this.state.currentTab.replace('_', ' ') + ' found.', { ns: 'translation' })
              )
            ),
            this.state.selected.some(function (s) {
              return hlbBankCodes.includes(s.bank.code);
            }) && this.showHLBCampaign() ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_HLBEligibleBanner2.default, { onJoinCampaign: this.handleOpenHLBModal })
            ) : null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              this.props.extraNode,
              this.props.limit && this.props.limit > 0 ? _react2.default.createElement(_LimitCounter2.default, {
                current: this.state.selected.length,
                limit: this.props.limit,
                primaryText: t('bankers', { ns: 'translation' }),
                t: t
              }) : null
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_PageNav2.default, {
            currentPage: this.state.currentPage,
            count: this.state.count,
            limit: this.state.limit,
            offset: this.state.offset,
            dataSize: this.state.data.length,
            loading: this.state.loading,
            onChange: this.handleChangePage,
            hideDropdown: true
          }),
          _react2.default.createElement(_semanticUiReact.Button, {
            primary: true,
            onClick: this.handleOnComfirm,
            icon: 'checkmark',
            content: t('Add', { ns: 'screens' }),
            disabled: this.state.selected.length < 1
          })
        ),
        _react2.default.createElement(_HLBCampaignJoinModal2.default, {
          show: this.state.showHLBJoinModal,
          onClose: this.handleCloseHLBModal
        })
      );
    }
  }, {
    key: 'tabs',
    get: function get() {
      var t = this.props.t;

      return [{ text: t('Panel', { ns: 'translation' }), name: 'panel_banker', value: 'panel_banker' }, { text: t('Preferred', { ns: 'translation' }), name: 'preferred_banker', value: 'preferred_banker' }, { text: t('All', { ns: 'translation' }), name: 'banker', value: 'banker' }];
    }
  }]);

  return BankersList;
}(_react.Component);

BankersList.contextTypes = {
  store: _propTypes2.default.object
};
BankersList.propTypes = {
  auth: _propTypes2.default.shape({
    companyBranch: _propTypes2.default.object
  }),
  bankerSelectionTabs: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  bankerOnSelect: _propTypes2.default.func,
  bankerOnCheck: _propTypes2.default.func,
  projectID: _propTypes2.default.string,
  bankID: _propTypes2.default.number,
  limit: _propTypes2.default.number,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  selected: _propTypes2.default.arrayOf(_propTypes2.default.object),
  only: _propTypes2.default.oneOf(['banker', 'preferred_banker', 'panel_banker']),
  extraNode: _propTypes2.default.node,
  bankerOnCheckSelected: _propTypes2.default.func,
  project: _propTypes2.default.shape({
    hlbCampaignIsEnabled: _propTypes2.default.bool
  }),
  t: _propTypes2.default.func.isRequired
};

BankersList.getPropsToState = function (props) {
  var bankerSelectionTabs = props.bankerSelectionTabs;
  var selected = props.selected ? [].concat(props.selected) : [];
  return {
    bankerSelectionTabs: bankerSelectionTabs,
    selected: selected
  };
};

BankersList.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.getCustomTabs = function () {
    var t = _this7.props.t;

    var tabs = [];
    if (_this7.props.bankerSelectionTabs.length > 0) {
      _this7.props.bankerSelectionTabs.map(function (tab) {
        switch (tab) {
          case 'panel_banker':
            return tabs.push({ text: t('Panel', { ns: 'translation' }), name: 'panel_banker', value: 'panel_banker' });
          case 'preferred_banker':
            return tabs.push({ text: t('Preferred', { ns: 'translation' }), name: 'preferred_banker', value: 'preferred_banker' });
          case 'all':
            return tabs.push({ text: t('All', { ns: 'translation' }), name: 'banker', value: 'banker' });
          default:
            break;
        }
        return null;
      });
    }
    _this7.setState({ customTabs: tabs });
  };

  this.checkBankerUserIsActive = function (banker) {
    return banker.user.statusID === '100';
  };

  this.showHLBCampaign = function () {
    var _props = _this7.props,
        project = _props.project,
        auth = _props.auth;

    var isHLBCampaignEnabled = !!(project && project.hlbCampaignIsEnabled);
    var isAgent = auth && auth.companyBranch && auth.companyBranch.isExternal;

    return isHLBCampaignEnabled && isAgent;
  };

  this.handleOnComfirm = function (e) {
    e.preventDefault();
    var selected = _this7.state.selected;
    var onConfirm = _this7.props.onConfirm;


    if (onConfirm) {
      onConfirm(e, selected);
    }
  };

  this.handleOnOpen = function () {
    var store = _this7.context.store;

    store.dispatch((0, _flash.resetFlashMessage)());
  };

  this.handleOnClose = function (e) {
    if (_this7.props.onClose) {
      _this7.props.onClose(e);
    }
  };

  this.handleChangeTab = function (e, _ref2) {
    var name = _ref2.name,
        value = _ref2.value;

    var currentTab = name || value;
    _this7.setState({ currentTab: currentTab, currentPage: 1 }, function () {
      _this7.fetchBankers();
    });
  };

  this.handleOnSelect = function (e, banker) {
    var selected = _this7.state.selected;

    var index = selected.findIndex(function (b) {
      return b.id === banker.id;
    });
    if (index < 0) {
      if (_this7.handleOnCheck(banker)) {
        return;
      }
      selected.push(banker);
    } else {
      selected.splice(index, 1);
    }
    _this7.setState({ selected: selected }, function () {
      if (_this7.props.bankerOnSelect) {
        _this7.props.bankerOnSelect(banker);
      }
    });
  };

  this.handleOnCheck = function (banker) {
    if (_this7.props.bankerOnCheck) {
      var selected = _this7.state.selected;

      return _this7.props.bankerOnCheck(banker, selected);
    }
    return false;
  };

  this.handleOnCheckSelected = function (banker) {
    if (_this7.props.bankerOnCheckSelected) {
      return _this7.props.bankerOnCheckSelected(banker);
    }
    return false;
  };

  this.handleClearFilter = function () {
    _this7.setState({ search: '' }, function () {
      _this7.fetchBankers();
    });
  };

  this.handleOnChange = function (search) {
    _this7.setState({ search: search }, function () {
      _this7.fetchBankers();
    });
  };

  this.handleChangePage = function (currentPage) {
    _this7.setState({ currentPage: currentPage }, function () {
      _this7.fetchBankers();
    });
  };

  this.handleOpenHLBModal = function () {
    _this7.setState({ showHLBJoinModal: true });
  };

  this.handleCloseHLBModal = function () {
    _this7.setState({ showHLBJoinModal: false });
  };
};

exports.default = (0, _reactRouter.withRouter)((0, _reactRedux.connect)(BankersList.mapStateToProps)((0, _reactI18next.withTranslation)()(BankersList)));

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _reactRedux = __webpack_require__(9);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _webValidations = __webpack_require__(23);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _flash = __webpack_require__(5);

var _BookingNote = __webpack_require__(313);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _translation = __webpack_require__(4);

var _bookingStatuses = __webpack_require__(128);

var _bookingStatuses2 = _interopRequireDefault(_bookingStatuses);

var _index = __webpack_require__(145);

var _financeSource = __webpack_require__(402);

var _translation2 = __webpack_require__(64);

var _CalendarDatePicker = __webpack_require__(1010);

var _CalendarDatePicker2 = _interopRequireDefault(_CalendarDatePicker);

var _strings = __webpack_require__(118);

var _amount = __webpack_require__(87);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-prototype-builtins */
/* eslint-disable react/prop-types */
/* eslint-disable max-len */

// actions

// components

// constants

// types

// utils


var inputDateFormat = 'DD/MM/YYYY';

var BookingStatusNotes = function (_Component) {
  _inherits(BookingStatusNotes, _Component);

  function BookingStatusNotes(props) {
    _classCallCheck(this, BookingStatusNotes);

    var _this = _possibleConstructorReturn(this, (BookingStatusNotes.__proto__ || Object.getPrototypeOf(BookingStatusNotes)).call(this, props));

    _initialiseProps.call(_this);

    var state = BookingStatusNotes.getPropsToState(props);
    var cancellationReasons = props.cancellationReasons ? [].concat(props.cancellationReasons.data) : [];
    _this.state = _extends({}, state, {
      cancellationReasons: cancellationReasons
    });
    return _this;
  }

  _createClass(BookingStatusNotes, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = BookingStatusNotes.getPropsToState(nextProps);
      var cancellationReasons = nextProps.cancellationReasons ? [].concat(nextProps.cancellationReasons.data) : this.state.cancellationReasons;
      if (this.checkStringify(state.oriData, this.state.oriData)) {
        state.data = this.state.data;
      }

      if (state && state.data && state.data.newBookingNoteEncoded && this.state && this.state.oriData && this.state.oriData.newBookingNoteEncoded && state.data.newBookingNoteEncoded !== this.state.oriData.newBookingNoteEncoded) {
        state.selectedBankID = this.state.selectedBankID;
      }

      var financeSources = nextProps.financeSources;
      if (state.data && state.data.project && state.data.project.sourceOfFinanceOptions && financeSources.data && financeSources.data.length > 0) {
        var paymentOptions = [];
        state.data.project.sourceOfFinanceOptions.forEach(function (f) {
          paymentOptions.push({ text: (0, _financeSource.getFinanceSourceLabel)(f, financeSources.data), value: f });
        });
        state.paymentMethods = paymentOptions;
      }
      this.setState(_extends({}, state, {
        cancellationReasons: cancellationReasons
      }));
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (!prevProps.open && this.props.open) {
        this.bookingDatesSetValues();
      }
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var admin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var dhq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var dbl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var internal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      var auth = this.props.auth;
      if (dbl && this.props.auth.isBranchLeader) {
        return true;
      }
      if (dhq && this.props.auth.isHeadquarters) {
        return true;
      }
      if (admin && this.props.auth.isSuperAdmin) {
        return true;
      }
      if (internal && auth && auth.companyBranch && !auth.companyBranch.isExternal) {
        return true;
      }
      return check;
    }
  }, {
    key: 'showCooldown',
    value: function showCooldown() {
      var appConfig = this.props.appConfig.data;
      var auth = this.props.auth;

      var hasAccess = auth.isHeadquarters || auth.isAdminBasic || auth.isSuperAdmin;
      return hasAccess && appConfig && appConfig.settings && appConfig.settings.unitCooldownIsEnabled;
    }
  }, {
    key: 'checkCuByAgent',
    value: function checkCuByAgent() {
      var _props = this.props,
          auth = _props.auth,
          isUnitChange = _props.isUnitChange;

      if (auth && auth.companyBranch && auth.companyBranch.isExternal && auth.isDeveloper && !auth.isSuperAdmin && !auth.isHeadquarters && !auth.isBranchLeader) {
        return isUnitChange;
      }
      return false;
    }
  }, {
    key: 'hideCancelCriteria',
    value: function hideCancelCriteria() {
      var data = this.state.data;

      if (this.checkCuByAgent() && data.project && data.project.cuDisableExtEditCancelCriteria) {
        return true;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          data = _state.data,
          loanMargin = _state.loanMargin,
          selectedBankID = _state.selectedBankID,
          cancellationReasons = _state.cancellationReasons,
          cancelReason = _state.cancelReason;
      var t = this.props.t;

      var isBooked = this.props.statusID === 'booked';
      var isSold = this.props.statusID === 'sold_spa_signed';
      var isCancelled = this.props.statusID === 'cancelled_developer';
      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          className: 'booking-status-note',
          open: this.props.open === true,
          onClose: this.handleOnClose,
          closeOnDimmerClick: false,
          size: 'small'
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'file text outline', content: this.renderHeader() }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: isSold || isBooked ? { paddingBottom: '1em' } : null },
            this.renderStatusModal(data, loanMargin, selectedBankID, cancellationReasons, cancelReason)
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          isCancelled && this.renderCancelActions(),
          !isCancelled && isSold && _react2.default.createElement(
            _semanticUiReact.Label,
            { className: 'booking-sold-status-label' },
            t('All fields marked with an * are required')
          ),
          !isCancelled && this.renderActionButtons()
        )
      );
    }
  }]);

  return BookingStatusNotes;
}(_react.Component);

BookingStatusNotes.contextTypes = {
  store: _propTypes2.default.object
};
BookingStatusNotes.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func.isRequired,
  onConfirm: _propTypes2.default.func.isRequired,
  isCancelPending: _propTypes2.default.bool,
  isUserCooldown: _propTypes2.default.bool,
  isUnitChange: _propTypes2.default.bool,
  isDelistOnHold: _propTypes2.default.bool,
  statusID: _propTypes2.default.string.isRequired,
  headerNode: _propTypes2.default.node,
  onNotesChange: _propTypes2.default.func.isRequired,
  onCheckboxChange: _propTypes2.default.func.isRequired,
  data: _propTypes2.default.shape({
    paymentMethodID: _propTypes2.default.string
  }),
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      settings: _propTypes2.default.shape({
        unitCooldownIsEnabled: _propTypes2.default.bool,
        disableSoldDateSelection: _propTypes2.default.bool,
        notesExternalPlaceholder: _propTypes2.default.string
      })
    })
  }),
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isDeveloper: _propTypes2.default.bool,
    companyBranch: _propTypes2.default.shape({
      isExternal: _propTypes2.default.bool
    })
  }),
  cancellationReasons: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  financeSources: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  t: _propTypes2.default.func
};

BookingStatusNotes.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig,
    auth: state.auth,
    cancellationReasons: state.cancellationReasons,
    financeSources: state.financeSources
  };
};

BookingStatusNotes.contextTypes = {
  store: _propTypes2.default.object
};

BookingStatusNotes.getPropsToState = function (props) {
  var data = props.data;
  var paymentMethods = [];

  var loanMargin = 0;
  var selectedBankID = null;
  var cancelReason = '';

  if (data) {
    if (data.loanAmount > 0) {
      loanMargin = Math.ceil(data.loanAmount / parseFloat((0, _amount.spaFullNumber)(data)) * 100);
    }
    if (data.selectedBankCaseID) {
      selectedBankID = data.selectedBankCaseID === 0 && !data.loanAmount ? null : data.selectedBankCaseID;
    }
    // set cancellation reason
    var defaultReasonID = 'cancelled_by_developer';
    var defaultCUReasonOrder = {
      transfer_of_parcel: 1,
      change_of_unit_default: 2
    };
    var orderedCUReasons = props.cancellationReasons.data.filter(function (item) {
      return defaultCUReasonOrder.hasOwnProperty(item.id);
    }).sort(function (a, b) {
      return defaultCUReasonOrder[a.id] - defaultCUReasonOrder[b.id];
    });
    var defaultCUReasonID = orderedCUReasons.length > 0 ? orderedCUReasons[0].id : '';
    if (props.isUnitChange && defaultCUReasonID) {
      defaultReasonID = defaultCUReasonID;
    }
    cancelReason = data.cancellationReasonID || defaultReasonID;
  }
  return {
    data: data,
    oriData: (0, _clone2.default)(data),
    soldDatePickVisible: false,
    spaSigningDatePickVisible: false,
    spaStampingDatePickVisible: false,
    minSoldDate: null,
    paymentMethods: paymentMethods,
    loanMargin: loanMargin,
    selectedBankID: selectedBankID,
    cancelReason: cancelReason,
    bookedDatePickVisible: false,
    minBookedDate: null
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getPercentageOptions = function () {
    var options = [];
    for (var i = 100; i >= 0; i -= 1) {
      options = [].concat(_toConsumableArray(options), [{
        key: i,
        value: i,
        text: i + '%'
      }]);
    }
    return options;
  };

  this.getValueText = function (value) {
    var t = _this2.props.t;

    var valueName = _bookingStatuses2.default.find(function (vn) {
      return vn.value === value;
    });
    if (valueName && valueName.text) {
      return t(valueName.text, { ns: _translation.TRANSLATION_FILES.constants });
    }
    return '';
  };

  this.checkStringify = function (source, target) {
    return JSON.stringify(source) === JSON.stringify(target);
  };

  this.bankCasesList = function () {
    var data = _this2.state.data;
    var t = _this2.props.t;

    var bankCases = [];

    if (data.bankCases.length > 0) {
      bankCases = data.bankCases.reduce(function (r, bc) {
        if (bc.status && !bc.status.startsWith('reject')) {
          r.push({
            key: bc.id,
            value: bc.id,
            text: bc.bank.name
          });
        }
        return r;
      }, []);

      return [].concat(_toConsumableArray(bankCases), [{
        key: 'others',
        value: 0,
        text: t('Others', { ns: _translation.TRANSLATION_FILES.constants })
      }]);
    }

    return [].concat(_toConsumableArray(bankCases), [{
      key: 'others',
      value: 0,
      text: t('Others', { ns: _translation.TRANSLATION_FILES.constants })
    }]);
  };

  this.bookingDatesSetValues = function () {
    var data = _this2.state.data;

    var isBooked = _this2.props.statusID === 'booked';
    var isSold = _this2.props.statusID === 'sold_spa_signed';

    // Set date for date pickers
    if (isBooked) {
      data.approvedAt = data.approvedAt ? data.approvedAt : (0, _momentTimezone2.default)().toDate();
    } else if (isSold) {
      data.lastSoldAt = data.lastSoldAt ? data.lastSoldAt : (0, _momentTimezone2.default)().toDate();
    }
    _this2.setState({ data: data });
  };

  this.handleOnVisible = function (name) {
    var data = _this2.state.data;

    var updatedState = _extends({}, _this2.state);
    var minDate = data.createdAt ? (0, _momentTimezone2.default)(data.createdAt).startOf('day').toDate() : null;

    // set minDate for date pickers
    if (name === 'approvedAt') {
      updatedState.minBookedDate = minDate;
    } else {
      updatedState.minSoldDate = minDate;
    }

    // Set visibility for date pickers
    if (name === 'lastSoldAt') {
      updatedState.soldDatePickVisible = true;
    } else if (name === 'spaSigningDate') {
      updatedState.spaSigningDatePickVisible = true;
    } else if (name === 'spaStampingDate') {
      updatedState.spaStampingDatePickVisible = true;
    } else if (name === 'approvedAt') {
      updatedState.bookedDatePickVisible = true;
    }

    _this2.setState(updatedState);
  };

  this.handleOnClear = function (field) {
    var data = _this2.state.data;

    data[field] = null;
    _this2.setState({ data: data });
  };

  this.handleDateChanges = function (value, visible, name, pickerField) {
    var data = _this2.state.data;
    // Set the respective booking date based on input.

    data[name] = value;
    _this2.setState(_defineProperty({ data: data }, pickerField, visible));
  };

  this.handleOnClose = function (e) {
    if (_this2.props.onClose) {
      _this2.props.onClose(e);
    }
  };

  this.handleOnConfirm = function (e, data, bankCaseID) {
    e.preventDefault();
    var t = _this2.props.t;

    var bookingData = data;
    var isBooked = _this2.props.statusID === 'booked';
    var isSold = _this2.props.statusID === 'sold_spa_signed';
    var isCancelled = _this2.props.statusID === 'cancelled_developer';
    var unitData = bookingData ? bookingData.projectUnit : null;
    var unitBookingSummary = unitData ? unitData.projectUnitBookingSummary : null;
    var holdUnitFailed = unitData && unitData.delistOnHold && unitBookingSummary && unitBookingSummary.bookedCount + unitBookingSummary.reservedCount + unitBookingSummary.soldCount > 1;

    if (bookingData.newBookingNoteEncoded === '' || isSold && bookingData.paymentMethodID !== 'cash' && !bankCaseID && bankCaseID !== 0 || isBooked && !bookingData.approvedAt || isSold && !bookingData.lastSoldAt || bookingData.paymentMethodID !== 'cash' && bookingData.selectedBankCaseID !== 0 && (bookingData.loanAmount <= 0 || bookingData.loanAmount > parseFloat((0, _amount.spaFullNumber)(bookingData))) || holdUnitFailed) {
      var store = _this2.context.store;

      var message = '';
      var missingFields = [];
      if (isBooked) {
        if (!bookingData.approvedAt) {
          missingFields.push((0, _translation2.translateModels)(t, 'approvedAt', 'booking'));
        }
        if (bookingData.newBookingNoteEncoded === '') {
          missingFields.push(t('Notes'));
        }
        message = (0, _strings.toSentenceFromList)(missingFields) + ' required';
      } else if (isSold) {
        if (!bookingData.lastSoldAt) {
          missingFields.push((0, _translation2.translateModels)(t, 'lastSoldAt', 'booking'));
        }
        if (!bankCaseID) {
          missingFields.push(t('Bank'));
        }
        if (bookingData.paymentMethodID !== 'cash' && bookingData.selectedBankCaseID !== 0 && bookingData.loanAmount <= 0) {
          missingFields.push(t('Loan Amount'));
        }
        if (bookingData.newBookingNoteEncoded === '') {
          missingFields.push(t('Notes'));
        }
        if (bookingData.loanAmount > parseFloat((0, _amount.spaFullNumber)(bookingData))) {
          message = 'Loan Amount must be less than Selling Price';
        }
      } else if (bookingData.newBookingNoteEncoded === '') {
        missingFields.push(t('Notes'));
      } else if (holdUnitFailed) {
        message = 'There is another active reservation for this unit. Cannot change status to On Hold.';
      } else {
        message = 'Loan Amount must be more than 0';
      }
      if (missingFields.length > 0) {
        message = (0, _strings.toSentenceFromList)(missingFields) + ' required';
      }
      store.dispatch((0, _flash.flashErrorMessage)({
        header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }),
        message: t(message, { ns: _translation.TRANSLATION_FILES.translation })
      }));
    } else if (_this2.props.onConfirm) {
      if (_this2.props.statusID === 'sold_spa_signed') {
        bookingData.isCancelPending = false;
        bookingData.isUserCooldown = false;
        bookingData.projectUnit.delistOnHold = false;
      }
      if ((!bankCaseID || bankCaseID === 0) && !data.loanAmount) {
        bookingData.selectedBankCaseID = 0;
      }
      if (isCancelled) {
        bookingData.cancellationReasonID = _this2.state.cancelReason;
      }
      if (data.lastSoldAt) {
        bookingData.lastSoldAt = data.lastSoldAt;
      }
      _this2.props.onConfirm(e, bookingData);
    }
  };

  this.handleAmountChange = function (e, d) {
    var _state2 = _this2.state,
        data = _state2.data,
        loanMargin = _state2.loanMargin;

    var loanPercent = loanMargin;
    if (d.name === 'loanAmount') {
      var amount = 0;
      if (d.value !== '') {
        amount = parseFloat(d.value);
      }
      loanPercent = Math.ceil(amount / parseFloat((0, _amount.spaFullNumber)(data)) * 100);
      data.loanAmount = amount;
    }
    _this2.setState({ data: data, loanMargin: loanPercent });
  };

  this.handleNotesChange = function (bnEncoded) {
    if (_this2.props.onNotesChange) {
      _this2.props.onNotesChange(bnEncoded);
    }
  };

  this.handleCheckboxChange = function (e, value) {
    if (_this2.props.onCheckboxChange) {
      _this2.props.onCheckboxChange(e, value);
    }
  };

  this.handleChange = function (e, d) {
    var data = _this2.state.data;

    if (d.name === 'bankName' && d.value !== '') {
      data.selectedBankCaseID = 0;
    }
    data[d.name] = d.value;

    _this2.setState({ data: data });
  };

  this.handleSelectChange = function (e, d) {
    var data = _this2.state.data;
    var _state3 = _this2.state,
        loanMargin = _state3.loanMargin,
        selectedBankID = _state3.selectedBankID,
        cancelReason = _state3.cancelReason;

    if (d.name === 'selectedBankCaseID') {
      if (data.selectedBankCaseID !== d.value) {
        data.bankerName = '';
        data.bankName = '';
      }
      if (data.bankCases.length > 0 && d.value !== 0) {
        var selectedBankCase = data.bankCases.find(function (bc) {
          return bc.id === d.value;
        });
        data.bankerName = selectedBankCase.banker.name;
        data.loanAmount = parseFloat(selectedBankCase.loanAmount);
        loanMargin = Math.ceil(selectedBankCase.loanAmount / parseFloat((0, _amount.spaFullNumber)(data)) * 100);
      }
      selectedBankID = d.value;
    } else if (d.name === 'loanMargin') {
      loanMargin = _lodash2.default.toNumber(d.value);
      data.loanAmount = parseFloat((loanMargin / 100 * parseFloat((0, _amount.spaFullNumber)(data))).toFixed(2));
    } else if (d.name === 'cancellationReasonID') {
      cancelReason = d.value;
    }
    data[d.name] = d.value;
    _this2.setState({
      data: data,
      loanMargin: loanMargin,
      selectedBankID: selectedBankID,
      cancelReason: cancelReason
    });
  };

  this.renderHeader = function () {
    var _props2 = _this2.props,
        headerNode = _props2.headerNode,
        t = _props2.t;

    if (headerNode) return headerNode;
    if (_this2.checkCuByAgent()) return t('Change Unit');
    return t('Change status to {{status}}', { status: _this2.getValueText(_this2.props.statusID) }) + '?';
  };

  this.renderCancelContent = function () {
    var t = _this2.props.t;

    return _react2.default.createElement(
      _semanticUiReact.Form,
      { className: 'cancel_options' },
      _react2.default.createElement(
        _semanticUiReact.FormField,
        null,
        _react2.default.createElement(
          'b',
          null,
          'Cancellation Criteria'
        )
      ),
      _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
        name: 'isCancelPending',
        label: (0, _translation2.translateModels)(t, 'isCancelPending', 'booking'),
        checked: _this2.props.isCancelPending,
        onChange: _this2.handleCheckboxChange
      }),
      _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
        name: 'delistOnHold',
        label: (0, _translation2.translateModels)(t, 'delistOnHold', 'booking'),
        checked: _this2.props.isDelistOnHold,
        onChange: _this2.handleCheckboxChange
      }),
      _this2.showCooldown() && _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
        name: 'isUserCooldown',
        label: (0, _translation2.translateModels)(t, 'isUserCooldown', 'booking'),
        checked: _this2.props.isUserCooldown,
        onChange: _this2.handleCheckboxChange
      })
    );
  };

  this.renderCancelActions = function () {
    return _react2.default.createElement(
      _semanticUiReact.Grid,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { mobile: 16, computer: 16 },
          _this2.renderActionButtons()
        )
      )
    );
  };

  this.renderActionButtons = function () {
    var _props3 = _this2.props,
        t = _props3.t,
        auth = _props3.auth,
        isUnitChange = _props3.isUnitChange;
    var _state4 = _this2.state,
        data = _state4.data,
        selectedBankID = _state4.selectedBankID;
    // Hide Cancel button for Agent/Staff during unit change (only show for HQ)

    var showCancelButton = !isUnitChange || auth && auth.isHeadquarters;
    return _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      null,
      showCancelButton && _react2.default.createElement(_semanticUiReact.Button, { negative: true, onClick: _this2.handleOnClose, icon: 'cancel', content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }) }),
      _react2.default.createElement(_semanticUiReact.Button, {
        positive: true,
        onClick: function onClick(e) {
          return _this2.handleOnConfirm(e, data, selectedBankID);
        },
        icon: 'checkmark',
        content: t('Confirm', { ns: _translation.TRANSLATION_FILES.translation }),
        'data-bot-target': 'confirm'
      })
    );
  };

  this.renderStatusModal = function (data, loanMargin, selectedBankID, cancellationReasons, cancelReason) {
    var _props4 = _this2.props,
        t = _props4.t,
        appConfig = _props4.appConfig;

    var isBooked = _this2.props.statusID === 'booked';
    var isSold = _this2.props.statusID === 'sold_spa_signed';
    var isCancelled = _this2.props.statusID === 'cancelled_developer';
    var allowSelectingSoldDate = appConfig && appConfig.data && appConfig.data.settings && !appConfig.data.settings.disableSoldDateSelection;

    if (data && isBooked) {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          null,
          t('Please fill in details')
        ),
        _react2.default.createElement(
          _semanticUiReact.Form,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { marginTop: '1.2em' } },
            _react2.default.createElement(
              'b',
              null,
              (0, _translation2.translateModels)(t, 'approvedAt', 'booking') + '*'
            ),
            _react2.default.createElement(_semanticUiReact.Form.Input, {
              fluid: true,
              placeholder: t('Click to set booking date'),
              value: data.approvedAt ? (0, _momentTimezone2.default)(data.approvedAt).format(inputDateFormat) : '',
              readOnly: true,
              onFocus: function onFocus() {
                return _this2.handleOnVisible('approvedAt');
              },
              icon: data.approvedAt ? _react2.default.createElement(_semanticUiReact.Icon, {
                color: 'red',
                link: true,
                name: 'x',
                onClick: function onClick() {
                  return _this2.handleOnClear('approvedAt');
                },
                title: t('Clear')
              }) : 'calendar',
              style: { marginTop: '0.2em', marginBottom: '0.9em' },
              width: 8
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8 },
              _react2.default.createElement(_CalendarDatePicker2.default, {
                closeableCompact: false,
                minDate: _this2.state.minBookedDate,
                maxDate: (0, _momentTimezone2.default)().toDate(),
                noPadding: true,
                name: 'approvedAt',
                value: data.approvedAt ? (0, _momentTimezone2.default)(data.approvedAt).toDate() : null,
                onChange: function onChange(value, visible) {
                  return _this2.handleDateChanges(value, visible, 'approvedAt', 'bookedDatePickVisible');
                },
                visible: _this2.state.bookedDatePickVisible
              })
            )
          ),
          _react2.default.createElement(
            'b',
            null,
            t('Notes'),
            '* (',
            t('Required').toLowerCase(),
            ')'
          ),
          _react2.default.createElement(_BookingNote.NoteEditor, {
            bookingNote: _extends({}, _index.BookingNoteDefault),
            hideCustomOptions: true,
            onUpdate: _this2.handleNotesChange,
            auth: _this2.props.auth,
            settings: _this2.props.appConfig && _this2.props.appConfig.data && _this2.props.appConfig.data.settings
          })
        )
      );
    } else if (data && isSold) {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          null,
          t('Please fill in details')
        ),
        _react2.default.createElement(
          _semanticUiReact.Form,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8 },
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { style: { marginTop: '1.2em' } },
                _react2.default.createElement(
                  'b',
                  null,
                  (0, _translation2.translateModels)(t, 'lastSoldAt', 'booking') + '*'
                ),
                _react2.default.createElement(_semanticUiReact.Form.Input, {
                  fluid: true,
                  placeholder: t('Click to set sold at date'),
                  value: data.lastSoldAt ? (0, _momentTimezone2.default)(data.lastSoldAt).format(inputDateFormat) : '',
                  disabled: !allowSelectingSoldDate,
                  readOnly: true,
                  onFocus: function onFocus() {
                    return _this2.handleOnVisible('lastSoldAt');
                  },
                  icon: data.lastSoldAt ? _react2.default.createElement(_semanticUiReact.Icon, {
                    color: 'red',
                    link: true,
                    name: 'x',
                    onClick: function onClick() {
                      return _this2.handleOnClear('lastSoldAt');
                    },
                    title: t('Clear')
                  }) : 'calendar'
                })
              )
            )
          ),
          allowSelectingSoldDate ? _react2.default.createElement(
            _semanticUiReact.Grid,
            { style: { marginTop: '-1rem' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8 },
              _react2.default.createElement(_CalendarDatePicker2.default, {
                closeableCompact: false,
                minDate: _this2.state.minSoldDate,
                maxDate: (0, _momentTimezone2.default)().toDate(),
                noPadding: true,
                name: 'lastSoldAt',
                value: data.lastSoldAt ? (0, _momentTimezone2.default)(data.lastSoldAt).toDate() : null,
                onChange: function onChange(value, visible) {
                  return _this2.handleDateChanges(value, visible, 'lastSoldAt', 'soldDatePickVisible');
                },
                visible: _this2.state.soldDatePickVisible
              })
            )
          ) : null,
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { style: { marginTop: '-1.5rem' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8 },
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  (0, _translation2.translateModels)(t, 'spaSigningDate', 'booking')
                ),
                _react2.default.createElement(_semanticUiReact.Form.Input, {
                  fluid: true,
                  placeholder: t('Click to set SPA signing date'),
                  value: data.spaSigningDate ? (0, _momentTimezone2.default)(data.spaSigningDate).format(inputDateFormat) : '',
                  disabled: !allowSelectingSoldDate,
                  readOnly: true,
                  onFocus: function onFocus() {
                    return _this2.handleOnVisible('spaSigningDate');
                  },
                  icon: data.spaSigningDate ? _react2.default.createElement(_semanticUiReact.Icon, {
                    color: 'red',
                    link: true,
                    name: 'x',
                    onClick: function onClick() {
                      return _this2.handleOnClear('spaSigningDate');
                    },
                    title: t('Clear')
                  }) : 'calendar'
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8 },
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  (0, _translation2.translateModels)(t, 'spaStampingDate', 'booking')
                ),
                _react2.default.createElement(_semanticUiReact.Form.Input, {
                  fluid: true,
                  placeholder: t('Click to set SPA stamping date'),
                  value: data.spaStampingDate ? (0, _momentTimezone2.default)(data.spaStampingDate).format(inputDateFormat) : '',
                  disabled: !allowSelectingSoldDate,
                  readOnly: true,
                  onFocus: function onFocus() {
                    return _this2.handleOnVisible('spaStampingDate');
                  },
                  icon: data.spaStampingDate ? _react2.default.createElement(_semanticUiReact.Icon, {
                    color: 'red',
                    link: true,
                    name: 'x',
                    onClick: function onClick() {
                      return _this2.handleOnClear('spaStampingDate');
                    },
                    title: t('Clear')
                  }) : 'calendar'
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { style: { marginTop: '-1rem' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8 },
              _react2.default.createElement(_CalendarDatePicker2.default, {
                closeableCompact: false,
                minDate: _this2.state.minSoldDate,
                maxDate: (0, _momentTimezone2.default)().toDate(),
                noPadding: true,
                name: 'spaSigningDate',
                value: data.spaSigningDate ? (0, _momentTimezone2.default)(data.spaSigningDate).toDate() : null,
                onChange: function onChange(value, visible) {
                  return _this2.handleDateChanges(value, visible, 'spaSigningDate', 'spaSigningDatePickVisible');
                },
                visible: _this2.state.spaSigningDatePickVisible
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8 },
              _react2.default.createElement(_CalendarDatePicker2.default, {
                closeableCompact: false,
                minDate: _this2.state.minSoldDate,
                maxDate: (0, _momentTimezone2.default)().toDate(),
                noPadding: true,
                name: 'spaStampingDate',
                value: data.spaStampingDate ? (0, _momentTimezone2.default)(data.spaStampingDate).toDate() : null,
                onChange: function onChange(value, visible) {
                  return _this2.handleDateChanges(value, visible, 'spaStampingDate', 'spaStampingDatePickVisible');
                },
                visible: _this2.state.spaStampingDatePickVisible
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'booking-sold-status-info', columns: 2 },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    (0, _translation2.translateModels)(t, 'paymentMethodID', 'booking')
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  data && data.paymentMethod ? t(data.paymentMethod.name, { ns: _translation.TRANSLATION_FILES.constants, defaultValue: data.paymentMethod.name }) : '-'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    (0, _translation2.translateModels)(t, 'spaValue', 'booking')
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(_LoanAmount2.default, {
                    projectCurrencies: data && data.project && data.project.projectCurrency ? data.project.projectCurrency : [],
                    format: '0,000,000.00',
                    amount: (0, _amount.spaFullNumber)(data),
                    prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                  })
                )
              )
            )
          ),
          data.paymentMethodID !== 'cash' ? _react2.default.createElement(
            'div',
            null,
            data.bankCases.length < 1 || data.selectedBankCaseID === 0 ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                fluid: true,
                label: t('Bank') + '*',
                name: 'selectedBankCaseID',
                options: _this2.bankCasesList(),
                placeholder: t('Please select'),
                selectOnBlur: false,
                value: selectedBankID,
                onChange: _this2.handleSelectChange
              }),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_semanticUiReact.Form.Input, {
                  name: 'bankName',
                  label: (0, _translation2.translateModels)(t, 'bankName', 'booking'),
                  value: data.bankName,
                  onChange: _this2.handleChange
                }),
                _react2.default.createElement(_semanticUiReact.Form.Input, {
                  className: 'booking-sold-status-banker-name',
                  name: 'bankerName',
                  label: (0, _translation2.translateModels)(t, 'bankerName', 'booking'),
                  value: data.bankerName,
                  onChange: _this2.handleChange,
                  disabled: data.bankCases.length > 0 && data.selectedBankCaseID !== 0
                })
              )
            ) : _react2.default.createElement(
              _semanticUiReact.Form.Group,
              { widths: 'equal' },
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                fluid: true,
                label: t('Bank') + '*',
                name: 'selectedBankCaseID',
                options: _this2.bankCasesList(),
                placeholder: t('Please select'),
                selectOnBlur: false,
                value: selectedBankID,
                onChange: _this2.handleSelectChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Input, {
                className: 'booking-sold-status-banker-name',
                name: 'bankerName',
                label: (0, _translation2.translateModels)(t, 'bankerName', 'booking'),
                value: data.bankerName,
                onChange: _this2.handleChange,
                disabled: data.bankCases.length > 0 && data.selectedBankCaseID !== 0
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Form.Group,
              { widths: 'equal' },
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                fluid: true,
                search: true,
                label: t('Loan Margin'),
                name: 'loanMargin',
                options: _this2.getPercentageOptions(),
                placeholder: '0%',
                selectOnBlur: false,
                value: loanMargin,
                onChange: _this2.handleSelectChange,
                openOnFocus: false,
                onOpen: function onOpen() {
                  // this function is to make dropdown scroll to top when open (only when value is 0)
                  if (loanMargin === 0) {
                    setTimeout(function () {
                      var menu = document.querySelector('.ui.dropdown .menu.visible, .menu.transition.visible');
                      if (!menu) menu = document.querySelector('.menu.visible');
                      if (menu) {
                        // scroll to top
                        menu.scrollTop = 0;
                      }
                    }, 0);
                  }
                }
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                name: 'loanAmount',
                label: t('Loan Amount') + ' ' + (data.selectedBankCaseID !== 0 ? '*' : ''),
                type: 'number',
                min: '0',
                value: data.loanAmount,
                onChange: _this2.handleAmountChange,
                step: '0.01',
                validation: [function (v, o) {
                  return (0, _webValidations.numericRange)(v, _extends({}, o, {
                    min: 0,
                    max: parseFloat((0, _amount.spaFullNumber)(data))
                  }));
                }]
              })
            )
          ) : null,
          _react2.default.createElement(
            'b',
            null,
            t('Notes'),
            '* (',
            t('Required').toLowerCase(),
            ')'
          ),
          _react2.default.createElement(_BookingNote.NoteEditor, {
            bookingNote: _extends({}, _index.BookingNoteDefault),
            hideCustomOptions: true,
            onUpdate: _this2.handleNotesChange,
            auth: _this2.props.auth,
            settings: _this2.props.appConfig && _this2.props.appConfig.data && _this2.props.appConfig.data.settings
          })
        ),
        data.project && !data.project.allowPurchaserEditAfterSold && _react2.default.createElement(
          _semanticUiReact.Segment,
          { className: 'booking-sold-notice' },
          _react2.default.createElement(
            'div',
            { className: 'title' },
            _react2.default.createElement(
              _semanticUiReact.Icon,
              null,
              _react2.default.createElement('img', {
                alt: 'info', src: '/assets/icons/info_blue.svg', style: { width: '16px', height: '16px' }
              })
            ),
            _react2.default.createElement(
              'strong',
              null,
              'Important: Please ensure all information is accurate before proceeding'
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'content' },
            'Once a booking is sold, purchaser details, pricing, and discounts can no longer be edited.'
          )
        )
      );
    }
    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'p',
        null,
        t('Please fill in details')
      ),
      _react2.default.createElement(
        _semanticUiReact.Form,
        null,
        _this2.props.statusID === 'cancelled_developer' && _react2.default.createElement(
          'div',
          { style: { marginBottom: '1.5em' } },
          _react2.default.createElement(
            'b',
            null,
            _this2.checkCuByAgent() ? t('Reason') : (0, _translation2.translateModels)(t, 'cancellationReasonID', 'booking'),
            '* (',
            t('Required').toLowerCase(),
            ')'
          ),
          _react2.default.createElement(_semanticUiReact.Form.Select, {
            style: { marginTop: '1em' },
            fluid: true,
            name: 'cancellationReasonID',
            options: cancellationReasons && cancellationReasons.map(function (d) {
              return {
                text: d.name,
                value: d.id
              };
            }),
            selectOnBlur: false,
            value: cancelReason,
            onChange: _this2.handleSelectChange,
            disabled: _this2.checkCuByAgent()
          })
        ),
        _react2.default.createElement(
          'b',
          null,
          t('Notes'),
          '* (',
          t('Required').toLowerCase(),
          ')'
        ),
        _react2.default.createElement(_BookingNote.NoteEditor, {
          bookingNote: _extends({}, _index.BookingNoteDefault),
          hideCustomOptions: true,
          onUpdate: _this2.handleNotesChange,
          auth: _this2.props.auth,
          settings: _this2.props.appConfig && _this2.props.appConfig.data && _this2.props.appConfig.data.settings
        })
      ),
      isCancelled && !_this2.hideCancelCriteria() && _this2.renderCancelContent()
    );
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.booking]))((0, _reactRedux.connect)(BookingStatusNotes.mapStateToProps)(BookingStatusNotes));

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalConfirm = function (_Component) {
  _inherits(ModalConfirm, _Component);

  function ModalConfirm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ModalConfirm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalConfirm.__proto__ || Object.getPrototypeOf(ModalConfirm)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    }, _this.handleOnComfirm = function (e) {
      e.preventDefault();
      if (_this.props.onConfirm) {
        _this.props.onConfirm(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ModalConfirm, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.open !== nextProps.open) {
        return true;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          size: 'small',
          open: this.props.open === true,
          onClose: this.handleOnClose
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: this.props.headerNode || t('Confirm', { ns: _translation.TRANSLATION_FILES.translation }) + '?' }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            this.props.content || _react2.default.createElement(
              'p',
              null,
              t('Are you sure to continue'),
              '?'
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, negative: true, onClick: this.handleOnClose, icon: 'cancel', content: t('No', { ns: _translation.TRANSLATION_FILES.constants }), inverted: true }),
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, positive: true, onClick: this.handleOnComfirm, icon: 'checkmark', content: t('Yes', { ns: _translation.TRANSLATION_FILES.constants }), inverted: true })
        )
      );
    }
  }]);

  return ModalConfirm;
}(_react.Component);

ModalConfirm.contextTypes = {
  store: _propTypes2.default.object
};
ModalConfirm.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  headerNode: _propTypes2.default.node,
  content: _propTypes2.default.node
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(ModalConfirm);

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _ListItem = __webpack_require__(261);

var _ListItem2 = _interopRequireDefault(_ListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectsList = function (_Component) {
  _inherits(ProjectsList, _Component);

  function ProjectsList(props) {
    _classCallCheck(this, ProjectsList);

    var _this = _possibleConstructorReturn(this, (ProjectsList.__proto__ || Object.getPrototypeOf(ProjectsList)).call(this, props));

    _initialiseProps.call(_this);

    var state = ProjectsList.getPropsToState(props);
    _this.state = _extends({}, state, {
      data: [],
      loading: true,
      count: 0,
      limit: 0,
      offset: 0,
      currentPage: 1,
      query: {},
      search: ''
    });
    return _this;
  }

  _createClass(ProjectsList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = ProjectsList.getPropsToState(nextProps);
      if (nextProps.open === true && this.props.open !== nextProps.open) {
        this.fetchProjects();
      }
      this.setState(state);
    }
  }, {
    key: 'setProjects',
    value: function setProjects() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this2.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchProjects',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this5 = this;

        var store, query, res, message, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                _context.next = 4;
                return this.setProjects([]);

              case 4:
                store = this.context.store;
                query = Object.assign({
                  viewAll: true,
                  page: this.state.currentPage || 1,
                  search: this.state.search || ''
                });
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/projects/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 10:
                res = _context.sent;
                _context.next = 21;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                Bugsnag.notifyException(_context.t0);
                _context.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 18:
                _context.next = 20;
                return this.setLoading(false);

              case 20:
                return _context.abrupt('return');

              case 21:
                if (res.ok) {
                  _context.next = 29;
                  break;
                }

                _context.next = 24;
                return res.text();

              case 24:
                message = _context.sent;
                _context.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 27:
                _context.next = 43;
                break;

              case 29:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10) || 0;
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context.next = 34;
                return res.json();

              case 34:
                data = _context.sent;
                _context.next = 37;
                return this.setProjects(data);

              case 37:
                if (!(this.state.data.length < 1 && query.page > 1)) {
                  _context.next = 41;
                  break;
                }

                this.setState({ currentPage: 1 }, function () {
                  _this5.fetchProjects();
                });
                _context.next = 43;
                break;

              case 41:
                _context.next = 43;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 43:
                _context.next = 45;
                return this.setLoading(false);

              case 45:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function fetchProjects() {
        return _ref.apply(this, arguments);
      }

      return fetchProjects;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          open: this.props.open === true,
          onClose: this.handleOnClose,
          closeIcon: 'close',
          size: 'large',
          className: 'items-list-modal'
        },
        _react2.default.createElement(_semanticUiReact.Header, {
          icon: 'add',
          content: 'Add projects'
        }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle', columns: 1 },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_SearchFilter2.default, {
                isLoading: this.state.loading,
                onChange: this.handleOnChange,
                onClose: this.handleClearFilter,
                search: this.state.search
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'list' },
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                {
                  inverted: true, style: { zIndex: 20 },
                  active: this.state.loading && this.state.data.length > 0
                },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  'Loading'
                )
              ),
              this.state.data.length > 0 ? _react2.default.createElement(
                _semanticUiReact.Table,
                { unstackable: true },
                _react2.default.createElement(
                  _semanticUiReact.Table.Body,
                  null,
                  this.state.data.map(function (project, idx) {
                    return _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      {
                        key: idx,
                        positive: _this6.state.selected.some(function (s) {
                          return s.id === project.id;
                        }) || _this6.checkUserBranchProject(project),
                        active: _this6.handleOnCheck(project)
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(_ListItem2.default, {
                          item: project,
                          onClick: _this6.handleOnSelect,
                          selected: _this6.state.selected.some(function (s) {
                            return s.id === project.id;
                          }),
                          disabled: _this6.handleOnCheck(project) || _this6.checkProjectOwner(project) || _this6.checkUserBranchProject(project),
                          header: function header(item) {
                            if (_this6.checkProjectOwner(project)) {
                              return _react2.default.createElement(
                                'span',
                                null,
                                item.name,
                                ' ',
                                _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', fitted: true }),
                                _react2.default.createElement(
                                  'i',
                                  null,
                                  ' ',
                                  _react2.default.createElement(
                                    'small',
                                    null,
                                    'Owner'
                                  )
                                )
                              );
                            }
                            if (_this6.checkUserBranchProject(project)) {
                              return _react2.default.createElement(
                                'span',
                                null,
                                item.name,
                                ' ',
                                _react2.default.createElement(_semanticUiReact.Icon, { name: 'eye', fitted: true }),
                                _react2.default.createElement(
                                  'i',
                                  null,
                                  ' ',
                                  _react2.default.createElement(
                                    'small',
                                    null,
                                    'Business Unit Access'
                                  )
                                )
                              );
                            }
                            return item.name;
                          },
                          subheader: function subheader(item) {
                            return item.status.name;
                          },
                          checkable: true
                        })
                      )
                    );
                  })
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Segment,
                { textAlign: 'center' },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  'Loading'
                ) : 'No project found.'
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_PageNav2.default, {
            currentPage: this.state.currentPage,
            count: this.state.count,
            limit: this.state.limit,
            offset: this.state.offset,
            dataSize: this.state.data.length,
            loading: this.state.loading,
            onChange: this.handleChangePage,
            hideDropdown: true
          }),
          _react2.default.createElement(_semanticUiReact.Button, {
            primary: true,
            onClick: this.handleOnComfirm,
            icon: 'checkmark',
            content: 'Add'
          })
        )
      );
    }
  }]);

  return ProjectsList;
}(_react.Component);

ProjectsList.contextTypes = {
  store: _propTypes2.default.object
};
ProjectsList.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  onCheck: _propTypes2.default.func,
  selected: _propTypes2.default.arrayOf(_propTypes2.default.object),
  companyBranchID: _propTypes2.default.number,
  userBranchProjects: _propTypes2.default.arrayOf(_propTypes2.default.object)
};
ProjectsList.defaultProps = {
  companyBranchID: 0
};

ProjectsList.getPropsToState = function (props) {
  var selected = [].concat(props.selected);
  return {
    selected: selected
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.getCoverPicture = function (pictures) {
    if (pictures && pictures.length > 0 && pictures.some(function (pp) {
      return pp.isCover === true;
    })) {
      return pictures.find(function (pp) {
        return pp.isCover === true;
      }).picture;
    }
    return null;
  };

  this.handleOnComfirm = function (e) {
    e.preventDefault();
    if (_this7.props.onConfirm) {
      _this7.props.onConfirm(e, _this7.state.selected);
    }
  };

  this.handleOnClose = function (e) {
    if (_this7.props.onClose) {
      _this7.props.onClose(e);
    }
  };

  this.handleChangeTab = function (e, _ref2) {
    var name = _ref2.name,
        value = _ref2.value;

    var currentTab = name || value;
    _this7.setState({ currentTab: currentTab }, function () {
      _this7.fetchProjects();
    });
  };

  this.handleOnSelect = function (e, project) {
    var selected = _this7.state.selected;

    var index = selected.findIndex(function (b) {
      return b.id === project.id;
    });
    if (index < 0) {
      if (_this7.handleOnCheck(project)) {
        return;
      }
      selected.push(project);
    } else {
      selected.splice(index, 1);
    }
    _this7.setState({ selected: selected }, function () {
      if (_this7.props.onSelect) {
        _this7.props.onSelect(project);
      }
    });
  };

  this.handleOnCheck = function (project) {
    if (_this7.props.onCheck) {
      var selected = _this7.state.selected;

      return _this7.props.onCheck(project, selected);
    }
    return false;
  };

  this.handleClearFilter = function () {
    _this7.setState({ search: '' }, function () {
      _this7.fetchProjects();
    });
  };

  this.handleOnChange = function (search) {
    _this7.setState({ search: search }, function () {
      _this7.fetchProjects();
    });
  };

  this.handleChangePage = function (currentPage) {
    _this7.setState({ currentPage: currentPage }, function () {
      _this7.fetchProjects();
    });
  };

  this.checkProjectOwner = function (project) {
    if (_this7.props.companyBranchID && project.maOwnerCompanyBranchID === _this7.props.companyBranchID) {
      return true;
    }
    return false;
  };

  this.checkUserBranchProject = function (project) {
    if (_this7.props.userBranchProjects) {
      var match = _this7.props.userBranchProjects.find(function (d) {
        return d.id === project.id;
      });
      if (match) {
        return true;
      }
    }
    return false;
  };
};

exports.default = ProjectsList;

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _i18next = __webpack_require__(94);

var _i18next2 = _interopRequireDefault(_i18next);

var _i18nextHttpBackend = __webpack_require__(3019);

var _i18nextHttpBackend2 = _interopRequireDefault(_i18nextHttpBackend);

var _i18nextBrowserLanguagedetector = __webpack_require__(3017);

var _i18nextBrowserLanguagedetector2 = _interopRequireDefault(_i18nextBrowserLanguagedetector);

var _reactI18next = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_i18next2.default.use(_i18nextHttpBackend2.default).use(_i18nextBrowserLanguagedetector2.default).use(_reactI18next.initReactI18next).init({
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false
  },
  backend: {
    // Locale JSON is unhashed, so browsers that cached it under the old one-year
    // Cache-Control keep serving stale keys (CPI-977: raw "waiveBankGuarantee" on
    // Sales Info). The build version changes the URL so every deploy is a fresh fetch.
    loadPath: '/locales/{{lng}}/{{ns}}.json?v=' + encodeURIComponent("2.12.12" || '')
  }
});

exports.default = _i18next2.default;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultProjectSourceOfFinanceOptions = exports.getSourceOfFinanceValue = exports.getFinanceSourceLabel = undefined;

var _paymentMethods = __webpack_require__(1045);

var _valueToText = __webpack_require__(98);

var _valueToText2 = _interopRequireDefault(_valueToText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFinanceSourceLabel = exports.getFinanceSourceLabel = function getFinanceSourceLabel(type, financeSources) {
  var idx = financeSources.findIndex(function (s) {
    return s.id === type;
  });
  if (idx > -1) {
    return financeSources[idx].label;
  }
  // CPI-974 (D2/S1): label-only lookup, so it uses the label table rather than the option list -
  // Vietnam's 'bank_loan' renders as "Bank Loan" even when the tenant's rows are unseeded.
  return (0, _valueToText2.default)(_paymentMethods.PAYMENT_METHOD_LABELS, type);
};

var getSourceOfFinanceValue = exports.getSourceOfFinanceValue = function getSourceOfFinanceValue(value) {
  if (value.includes(_paymentMethods.PAYMENT_METHOD_PANEL_BANKER)) return _paymentMethods.PAYMENT_METHOD_PANEL_BANKER;
  if (value.includes(_paymentMethods.PAYMENT_METHOD_PREFERRED_BANKER)) return _paymentMethods.PAYMENT_METHOD_PREFERRED_BANKER;
  if (value.includes(_paymentMethods.PAYMENT_METHOD_CASH_BUYER)) return _paymentMethods.PAYMENT_METHOD_CASH_BUYER;
  if (value.includes(_paymentMethods.PAYMENT_METHOD_GOVERNMENT_LOAN)) return _paymentMethods.PAYMENT_METHOD_GOVERNMENT_LOAN;
  if (value.includes(_paymentMethods.PAYMENT_METHOD_STAFF_LOAN)) return _paymentMethods.PAYMENT_METHOD_STAFF_LOAN;
  if (value.includes(_paymentMethods.PAYMENT_METHOD_RENT_TO_OWN)) return _paymentMethods.PAYMENT_METHOD_RENT_TO_OWN;
  return value;
};

var getDefaultProjectSourceOfFinanceOptions = exports.getDefaultProjectSourceOfFinanceOptions = function getDefaultProjectSourceOfFinanceOptions() {
  return [_paymentMethods.PAYMENT_METHOD_PANEL_BANKER, _paymentMethods.PAYMENT_METHOD_PREFERRED_BANKER, _paymentMethods.PAYMENT_METHOD_CASH_BUYER, _paymentMethods.PAYMENT_METHOD_GOVERNMENT_LOAN, _paymentMethods.PAYMENT_METHOD_STAFF_LOAN, _paymentMethods.PAYMENT_METHOD_RENT_TO_OWN];
};

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bookingFlow = bookingFlow;
function bookingFlow(booking, currentPage) {
  // currentPage
  // 0. Booking Form
  // 1. Customer Assessment
  // 2. Payment
  // 3. Loan Tracker
  var hasCustomerAssessment = false;
  var hasPayment = false;
  var hasLoanTracker = false;
  var sofGroup = 0;
  if (booking && booking.project) {
    var project = booking.project;
    var sof = booking.paymentMethodID;
    if (project.customerAssessmentFlow) hasCustomerAssessment = true;
    if (project.paymentFlow) hasPayment = true;
    if (project.loanTrackerDirectShow) hasLoanTracker = true;
    if (sof === 'referred_banker' || sof === 'own_banker') sofGroup = 1;
    if (sof === 'government_loan') sofGroup = 2;
    if (sof === 'cash' || sof === 'staff_loan') sofGroup = 3;
    if (sof !== 'cash') sofGroup = 4;
  }

  function switchURL(page) {
    var nextURL = '/bookings/' + booking.id + '/';
    if (page === 0) {
      if (hasCustomerAssessment && sofGroup === 1) return nextURL + 'credit_check/';
      if (hasCustomerAssessment && sofGroup === 2) return nextURL + 'lppsa/';
      return switchURL(1);
    } else if (page === 1) {
      if (hasPayment) return nextURL + 'payment/';
      return switchURL(2);
    } else if (page === 2) {
      if (hasLoanTracker && sofGroup === 4 && !booking.buyerProfileID) return nextURL + 'loan/';
    }
    return nextURL;
  }
  return switchURL(currentPage);
}

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSessionSuperseded = isSessionSuperseded;
exports.handleSessionLost = handleSessionLost;
exports.isSessionHandoffInProgress = isSessionHandoffInProgress;
exports.resetSessionLostLatchForTests = resetSessionLostLatchForTests;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// book-api's system/session_floor.go WriteSessionSuperseded — the contract string shared with
// the 15 CRM readers.
var SUPERSEDED_BODY = 'invalid user session';

// The message decides, not the status alone: CRM learned that a bare status check misclassifies
// gateway/WAF auth failures as takeover and fabricates a "someone signed in on another device"
// explanation the user then acts on (mhub-leads-v2-web src/utils/session.js). And it is an
// EQUALITY check, not a substring one: book-web's only legitimate emitter is book-api's REST
// response — there is no AppSync runtime here to wrap the message, so anything else containing
// the phrase is not the contract and must keep the ordinary 401 handling. Trailing whitespace
// and case are tolerated (an http.Error-style regression appends a newline).
// MS-6466: Showroom's half of the single-session hand-off. book-api refuses a superseded
// caller with 401 and the programme's contract body; this module decides when that happened
// and performs the one-shot hand-off to the login app's /logout with the reason it localises.
function isSessionSuperseded(status, body) {
  return Number(status) === 401 && String(body || '').trim().toLowerCase() === SUPERSEDED_BODY;
}

// One-shot latch: when a session dies, every in-flight fetch fails together and exactly one may
// navigate. The latch flips AFTER the navigation call returns — a throwing navigation leaves it
// open, so the next failing fetch retries the hand-off instead of stranding the user on a dead
// screen (same semantics as CRM's sessionLostHandled).
var sessionLostHandled = false;
// When the hand-off navigation was triggered. The flash suppression below is time-boxed to this,
// NOT to the permanent latch: a full-page /logout navigation unloads well within the window, but
// if it is BLOCKED (a beforeunload unsaved-changes prompt the user cancels), the page survives —
// and error flashes must resume after the window rather than stay silenced for the page's life.
var handoffAt = 0;
var HANDOFF_FLASH_WINDOW_MS = 5000;
var nowMs = function nowMs() {
  return Date.now();
};

function handleSessionLost(go) {
  if (sessionLostHandled) {
    return;
  }
  var navigate = go || function (url) {
    window.location.assign(url);
  };
  // /logout, deliberately not /login: the id token is still VALID — only the session floor
  // refuses it — so /login would bounce straight back into the app and loop. The login app
  // localises the reason (logout.reason.sessionTakenOver, all four locales).
  navigate(_config2.default.get('startURL') + '/logout?reason=session-taken-over');
  sessionLostHandled = true;
  handoffAt = nowMs();
}

// True while a takeover hand-off is navigating away (bounded window). A superseded session 401s
// every in-flight request at once, and each caller's own catch would flash "An error occurred,
// please refresh page" — noise on top of a page already leaving for /logout. Error flashes check
// this and stay silent during that window; if the navigation was cancelled they resume after it.
function isSessionHandoffInProgress() {
  return sessionLostHandled && nowMs() - handoffAt < HANDOFF_FLASH_WINDOW_MS;
}

function resetSessionLostLatchForTests() {
  sessionLostHandled = false;
  handoffAt = 0;
}

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(2591);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/

var Buffer = __webpack_require__(42).Buffer

function asUInt32Array (buf) {
  if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf)

  var len = (buf.length / 4) | 0
  var out = new Array(len)

  for (var i = 0; i < len; i++) {
    out[i] = buf.readUInt32BE(i * 4)
  }

  return out
}

function scrubVec (v) {
  for (var i = 0; i < v.length; v++) {
    v[i] = 0
  }
}

function cryptBlock (M, keySchedule, SUB_MIX, SBOX, nRounds) {
  var SUB_MIX0 = SUB_MIX[0]
  var SUB_MIX1 = SUB_MIX[1]
  var SUB_MIX2 = SUB_MIX[2]
  var SUB_MIX3 = SUB_MIX[3]

  var s0 = M[0] ^ keySchedule[0]
  var s1 = M[1] ^ keySchedule[1]
  var s2 = M[2] ^ keySchedule[2]
  var s3 = M[3] ^ keySchedule[3]
  var t0, t1, t2, t3
  var ksRow = 4

  for (var round = 1; round < nRounds; round++) {
    t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[(s1 >>> 16) & 0xff] ^ SUB_MIX2[(s2 >>> 8) & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++]
    t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[(s2 >>> 16) & 0xff] ^ SUB_MIX2[(s3 >>> 8) & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++]
    t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[(s3 >>> 16) & 0xff] ^ SUB_MIX2[(s0 >>> 8) & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++]
    t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[(s0 >>> 16) & 0xff] ^ SUB_MIX2[(s1 >>> 8) & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++]
    s0 = t0
    s1 = t1
    s2 = t2
    s3 = t3
  }

  t0 = ((SBOX[s0 >>> 24] << 24) | (SBOX[(s1 >>> 16) & 0xff] << 16) | (SBOX[(s2 >>> 8) & 0xff] << 8) | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++]
  t1 = ((SBOX[s1 >>> 24] << 24) | (SBOX[(s2 >>> 16) & 0xff] << 16) | (SBOX[(s3 >>> 8) & 0xff] << 8) | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++]
  t2 = ((SBOX[s2 >>> 24] << 24) | (SBOX[(s3 >>> 16) & 0xff] << 16) | (SBOX[(s0 >>> 8) & 0xff] << 8) | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++]
  t3 = ((SBOX[s3 >>> 24] << 24) | (SBOX[(s0 >>> 16) & 0xff] << 16) | (SBOX[(s1 >>> 8) & 0xff] << 8) | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++]
  t0 = t0 >>> 0
  t1 = t1 >>> 0
  t2 = t2 >>> 0
  t3 = t3 >>> 0

  return [t0, t1, t2, t3]
}

// AES constants
var RCON = [0x00, 0x01, 0x02, 0x04, 0x08, 0x10, 0x20, 0x40, 0x80, 0x1b, 0x36]
var G = (function () {
  // Compute double table
  var d = new Array(256)
  for (var j = 0; j < 256; j++) {
    if (j < 128) {
      d[j] = j << 1
    } else {
      d[j] = (j << 1) ^ 0x11b
    }
  }

  var SBOX = []
  var INV_SBOX = []
  var SUB_MIX = [[], [], [], []]
  var INV_SUB_MIX = [[], [], [], []]

  // Walk GF(2^8)
  var x = 0
  var xi = 0
  for (var i = 0; i < 256; ++i) {
    // Compute sbox
    var sx = xi ^ (xi << 1) ^ (xi << 2) ^ (xi << 3) ^ (xi << 4)
    sx = (sx >>> 8) ^ (sx & 0xff) ^ 0x63
    SBOX[x] = sx
    INV_SBOX[sx] = x

    // Compute multiplication
    var x2 = d[x]
    var x4 = d[x2]
    var x8 = d[x4]

    // Compute sub bytes, mix columns tables
    var t = (d[sx] * 0x101) ^ (sx * 0x1010100)
    SUB_MIX[0][x] = (t << 24) | (t >>> 8)
    SUB_MIX[1][x] = (t << 16) | (t >>> 16)
    SUB_MIX[2][x] = (t << 8) | (t >>> 24)
    SUB_MIX[3][x] = t

    // Compute inv sub bytes, inv mix columns tables
    t = (x8 * 0x1010101) ^ (x4 * 0x10001) ^ (x2 * 0x101) ^ (x * 0x1010100)
    INV_SUB_MIX[0][sx] = (t << 24) | (t >>> 8)
    INV_SUB_MIX[1][sx] = (t << 16) | (t >>> 16)
    INV_SUB_MIX[2][sx] = (t << 8) | (t >>> 24)
    INV_SUB_MIX[3][sx] = t

    if (x === 0) {
      x = xi = 1
    } else {
      x = x2 ^ d[d[d[x8 ^ x2]]]
      xi ^= d[d[xi]]
    }
  }

  return {
    SBOX: SBOX,
    INV_SBOX: INV_SBOX,
    SUB_MIX: SUB_MIX,
    INV_SUB_MIX: INV_SUB_MIX
  }
})()

function AES (key) {
  this._key = asUInt32Array(key)
  this._reset()
}

AES.blockSize = 4 * 4
AES.keySize = 256 / 8
AES.prototype.blockSize = AES.blockSize
AES.prototype.keySize = AES.keySize
AES.prototype._reset = function () {
  var keyWords = this._key
  var keySize = keyWords.length
  var nRounds = keySize + 6
  var ksRows = (nRounds + 1) * 4

  var keySchedule = []
  for (var k = 0; k < keySize; k++) {
    keySchedule[k] = keyWords[k]
  }

  for (k = keySize; k < ksRows; k++) {
    var t = keySchedule[k - 1]

    if (k % keySize === 0) {
      t = (t << 8) | (t >>> 24)
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])

      t ^= RCON[(k / keySize) | 0] << 24
    } else if (keySize > 6 && k % keySize === 4) {
      t =
        (G.SBOX[t >>> 24] << 24) |
        (G.SBOX[(t >>> 16) & 0xff] << 16) |
        (G.SBOX[(t >>> 8) & 0xff] << 8) |
        (G.SBOX[t & 0xff])
    }

    keySchedule[k] = keySchedule[k - keySize] ^ t
  }

  var invKeySchedule = []
  for (var ik = 0; ik < ksRows; ik++) {
    var ksR = ksRows - ik
    var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)]

    if (ik < 4 || ksR <= 4) {
      invKeySchedule[ik] = tt
    } else {
      invKeySchedule[ik] =
        G.INV_SUB_MIX[0][G.SBOX[tt >>> 24]] ^
        G.INV_SUB_MIX[1][G.SBOX[(tt >>> 16) & 0xff]] ^
        G.INV_SUB_MIX[2][G.SBOX[(tt >>> 8) & 0xff]] ^
        G.INV_SUB_MIX[3][G.SBOX[tt & 0xff]]
    }
  }

  this._nRounds = nRounds
  this._keySchedule = keySchedule
  this._invKeySchedule = invKeySchedule
}

AES.prototype.encryptBlockRaw = function (M) {
  M = asUInt32Array(M)
  return cryptBlock(M, this._keySchedule, G.SUB_MIX, G.SBOX, this._nRounds)
}

AES.prototype.encryptBlock = function (M) {
  var out = this.encryptBlockRaw(M)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[1], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[3], 12)
  return buf
}

AES.prototype.decryptBlock = function (M) {
  M = asUInt32Array(M)

  // swap
  var m1 = M[1]
  M[1] = M[3]
  M[3] = m1

  var out = cryptBlock(M, this._invKeySchedule, G.INV_SUB_MIX, G.INV_SBOX, this._nRounds)
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0], 0)
  buf.writeUInt32BE(out[3], 4)
  buf.writeUInt32BE(out[2], 8)
  buf.writeUInt32BE(out[1], 12)
  return buf
}

AES.prototype.scrub = function () {
  scrubVec(this._keySchedule)
  scrubVec(this._invKeySchedule)
  scrubVec(this._key)
}

module.exports.AES = AES


/***/ }),
/* 407 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(1118);
var enumBugKeys = __webpack_require__(605);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 409 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 410 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 411 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(132);
var toLength = __webpack_require__(73);
var toAbsoluteIndex = __webpack_require__(237);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(52);
var $export = __webpack_require__(17);
var redefine = __webpack_require__(119);
var redefineAll = __webpack_require__(278);
var meta = __webpack_require__(200);
var forOf = __webpack_require__(416);
var anInstance = __webpack_require__(276);
var isObject = __webpack_require__(53);
var fails = __webpack_require__(51);
var $iterDetect = __webpack_require__(418);
var setToStringTag = __webpack_require__(280);
var inheritIfRequired = __webpack_require__(624);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(1149);
var redefine = __webpack_require__(119);
var hide = __webpack_require__(131);
var fails = __webpack_require__(51);
var defined = __webpack_require__(179);
var wks = __webpack_require__(67);
var regexpExec = __webpack_require__(630);

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__(50);
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(160);
var call = __webpack_require__(1130);
var isArrayIter = __webpack_require__(625);
var anObject = __webpack_require__(50);
var toLength = __webpack_require__(73);
var getIterFn = __webpack_require__(640);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(178);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(67)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 419 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__(331);
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(78);
var global = __webpack_require__(52);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(231) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(52);
var hide = __webpack_require__(131);
var uid = __webpack_require__(238);
var TYPED = uid('typed_array');
var VIEW = uid('view');
var ABV = !!(global.ArrayBuffer && global.DataView);
var CONSTR = ABV;
var i = 0;
var l = 9;
var Typed;

var TypedArrayConstructors = (
  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
).split(',');

while (i < l) {
  if (Typed = global[TypedArrayConstructors[i++]]) {
    hide(Typed.prototype, TYPED, true);
    hide(Typed.prototype, VIEW, true);
  } else CONSTR = false;
}

module.exports = {
  ABV: ABV,
  CONSTR: CONSTR,
  TYPED: TYPED,
  VIEW: VIEW
};


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(52);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var DraftEntityInstance = __webpack_require__(1165);

var Immutable = __webpack_require__(46);

var invariant = __webpack_require__(48);

var uuid = __webpack_require__(2922);

var Map = Immutable.Map;
var instances = Map();
var instanceKey = uuid();
/**
 * Temporary utility for generating the warnings
 */

function logWarning(oldMethodCall, newMethodCall) {
  console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
}

/**
 * A "document entity" is an object containing metadata associated with a
 * piece of text in a ContentBlock.
 *
 * For example, a `link` entity might include a `uri` property. When a
 * ContentBlock is rendered in the browser, text that refers to that link
 * entity may be rendered as an anchor, with the `uri` as the href value.
 *
 * In a ContentBlock, every position in the text may correspond to zero
 * or one entities. This correspondence is tracked using a key string,
 * generated via DraftEntity.create() and used to obtain entity metadata
 * via DraftEntity.get().
 */
var DraftEntity = {
  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getLastCreatedEntityKey' instead.
   * ---
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  getLastCreatedEntityKey: function getLastCreatedEntityKey() {
    logWarning('DraftEntity.getLastCreatedEntityKey', 'contentState.getLastCreatedEntityKey');
    return DraftEntity.__getLastCreatedEntityKey();
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.createEntity' instead.
   * ---
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  create: function create(type, mutability, data) {
    logWarning('DraftEntity.create', 'contentState.createEntity');
    return DraftEntity.__create(type, mutability, data);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.addEntity' instead.
   * ---
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  add: function add(instance) {
    logWarning('DraftEntity.add', 'contentState.addEntity');
    return DraftEntity.__add(instance);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.getEntity' instead.
   * ---
   * Retrieve the entity corresponding to the supplied key string.
   */
  get: function get(key) {
    logWarning('DraftEntity.get', 'contentState.getEntity');
    return DraftEntity.__get(key);
  },

  /**
   * Get all the entities in the content state.
   */
  __getAll: function __getAll() {
    return instances;
  },

  /**
   * Load the entity map with the given set of entities.
   */
  __loadWithEntities: function __loadWithEntities(entities) {
    instances = entities;
    instanceKey = uuid();
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.mergeEntityData' instead.
   * ---
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  mergeData: function mergeData(key, toMerge) {
    logWarning('DraftEntity.mergeData', 'contentState.mergeEntityData');
    return DraftEntity.__mergeData(key, toMerge);
  },

  /**
   * WARNING: This method will be deprecated soon!
   * Please use 'contentState.replaceEntityData' instead.
   * ---
   * Completely replace the data for a given instance.
   */
  replaceData: function replaceData(key, newData) {
    logWarning('DraftEntity.replaceData', 'contentState.replaceEntityData');
    return DraftEntity.__replaceData(key, newData);
  },
  // ***********************************WARNING******************************
  // --- the above public API will be deprecated in the next version of Draft!
  // The methods below this line are private - don't call them directly.

  /**
   * Get the random key string from whatever entity was last created.
   * We need this to support the new API, as part of transitioning to put Entity
   * storage in contentState.
   */
  __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
    return instanceKey;
  },

  /**
   * Create a DraftEntityInstance and store it for later retrieval.
   *
   * A random key string will be generated and returned. This key may
   * be used to track the entity's usage in a ContentBlock, and for
   * retrieving data about the entity at render time.
   */
  __create: function __create(type, mutability, data) {
    return DraftEntity.__add(new DraftEntityInstance({
      type: type,
      mutability: mutability,
      data: data || {}
    }));
  },

  /**
   * Add an existing DraftEntityInstance to the DraftEntity map. This is
   * useful when restoring instances from the server.
   */
  __add: function __add(instance) {
    instanceKey = uuid();
    instances = instances.set(instanceKey, instance);
    return instanceKey;
  },

  /**
   * Retrieve the entity corresponding to the supplied key string.
   */
  __get: function __get(key) {
    var instance = instances.get(key);
    !!!instance ?  false ? invariant(false, 'Unknown DraftEntity key: %s.', key) : invariant(false) : void 0;
    return instance;
  },

  /**
   * Entity instances are immutable. If you need to update the data for an
   * instance, this method will merge your data updates and return a new
   * instance.
   */
  __mergeData: function __mergeData(key, toMerge) {
    var instance = DraftEntity.__get(key);

    var newData = _objectSpread({}, instance.getData(), toMerge);

    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  },

  /**
   * Completely replace the data for a given instance.
   */
  __replaceData: function __replaceData(key, newData) {
    var instance = DraftEntity.__get(key);

    var newInstance = instance.set('data', newData);
    instances = instances.set(key, newInstance);
    return newInstance;
  }
};
module.exports = DraftEntity;

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Immutable = __webpack_require__(46);

var Record = Immutable.Record;
var defaultRecord = {
  anchorKey: '',
  anchorOffset: 0,
  focusKey: '',
  focusOffset: 0,
  isBackward: false,
  hasFocus: false
};
/* $FlowFixMe[unclear-type] This comment suppresses an error found when
 * automatically adding a type annotation with the codemod Komodo/Annotate_
 * exports. To see the error delete this comment and run Flow. */

var SelectionStateRecord = Record(defaultRecord);

var SelectionState = /*#__PURE__*/function (_SelectionStateRecord) {
  _inheritsLoose(SelectionState, _SelectionStateRecord);

  function SelectionState() {
    return _SelectionStateRecord.apply(this, arguments) || this;
  }

  var _proto = SelectionState.prototype;

  _proto.serialize = function serialize() {
    return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
  };

  _proto.getAnchorKey = function getAnchorKey() {
    return this.get('anchorKey');
  };

  _proto.getAnchorOffset = function getAnchorOffset() {
    return this.get('anchorOffset');
  };

  _proto.getFocusKey = function getFocusKey() {
    return this.get('focusKey');
  };

  _proto.getFocusOffset = function getFocusOffset() {
    return this.get('focusOffset');
  };

  _proto.getIsBackward = function getIsBackward() {
    return this.get('isBackward');
  };

  _proto.getHasFocus = function getHasFocus() {
    return this.get('hasFocus');
  }
  /**
   * Return whether the specified range overlaps with an edge of the
   * SelectionState.
   */
  ;

  _proto.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
    var anchorKey = this.getAnchorKey();
    var focusKey = this.getFocusKey();

    if (anchorKey === focusKey && anchorKey === blockKey) {
      var selectionStart = this.getStartOffset();
      var selectionEnd = this.getEndOffset();
      return start <= selectionStart && selectionStart <= end || // selectionStart is between start and end, or
      start <= selectionEnd && selectionEnd <= end // selectionEnd is between start and end
      ;
    }

    if (blockKey !== anchorKey && blockKey !== focusKey) {
      return false;
    }

    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();
    return start <= offsetToCheck && end >= offsetToCheck;
  };

  _proto.isCollapsed = function isCollapsed() {
    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
  };

  _proto.getStartKey = function getStartKey() {
    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
  };

  _proto.getStartOffset = function getStartOffset() {
    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
  };

  _proto.getEndKey = function getEndKey() {
    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
  };

  _proto.getEndOffset = function getEndOffset() {
    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
  };

  SelectionState.createEmpty = function createEmpty(key) {
    return new SelectionState({
      anchorKey: key,
      anchorOffset: 0,
      focusKey: key,
      focusOffset: 0,
      isBackward: false,
      hasFocus: false
    });
  };

  return SelectionState;
}(SelectionStateRecord);

module.exports = SelectionState;

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var getCorrectDocumentFromNode = __webpack_require__(428);

var getSelectionOffsetKeyForNode = __webpack_require__(1182);
/**
 * Get the key from the node's nearest offset-aware ancestor.
 */


function findAncestorOffsetKey(node) {
  var searchNode = node;

  while (searchNode && searchNode !== getCorrectDocumentFromNode(node).documentElement) {
    var key = getSelectionOffsetKeyForNode(searchNode);

    if (key != null) {
      return key;
    }

    searchNode = searchNode.parentNode;
  }

  return null;
}

module.exports = findAncestorOffsetKey;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var randomizeBlockMapKeys = __webpack_require__(1191);

var removeEntitiesAtEdges = __webpack_require__(1192);

var getContentStateFragment = function getContentStateFragment(contentState, selectionState) {
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset(); // Edge entities should be stripped to ensure that we don't preserve
  // invalid partial entities when the fragment is reused. We do, however,
  // preserve entities that are entirely within the selection range.

  var contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState);
  var blockMap = contentWithoutEdgeEntities.getBlockMap();
  var blockKeys = blockMap.keySeq();
  var startIndex = blockKeys.indexOf(startKey);
  var endIndex = blockKeys.indexOf(endKey) + 1;
  return randomizeBlockMapKeys(blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
    var text = block.getText();
    var chars = block.getCharacterList();

    if (startKey === endKey) {
      return block.merge({
        text: text.slice(startOffset, endOffset),
        characterList: chars.slice(startOffset, endOffset)
      });
    }

    if (blockKey === startKey) {
      return block.merge({
        text: text.slice(startOffset),
        characterList: chars.slice(startOffset)
      });
    }

    if (blockKey === endKey) {
      return block.merge({
        text: text.slice(0, endOffset),
        characterList: chars.slice(0, endOffset)
      });
    }

    return block;
  }));
};

module.exports = getContentStateFragment;

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function getCorrectDocumentFromNode(node) {
  if (!node || !node.ownerDocument) {
    return document;
  }

  return node.ownerDocument;
}

module.exports = getCorrectDocumentFromNode;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/**
 * Utility method for determining whether or not the value returned
 * from a handler indicates that it was handled.
 */
function isEventHandled(value) {
  return value === 'handled' || value === true;
}

module.exports = isEventHandled;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
module.exports = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ALT: 18,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
  COMMA: 188,
  PERIOD: 190,
  A: 65,
  Z: 90,
  ZERO: 48,
  NUMPAD_0: 96,
  NUMPAD_9: 105
};

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var getStyleProperty = __webpack_require__(2933);
/**
 * @param {DOMNode} element [description]
 * @param {string} name Overflow style property name.
 * @return {boolean} True if the supplied ndoe is scrollable.
 */


function _isNodeScrollable(element, name) {
  var overflow = Style.get(element, name);
  return overflow === 'auto' || overflow === 'scroll';
}
/**
 * Utilities for querying and mutating style properties.
 */


var Style = {
  /**
   * Gets the style property for the supplied node. This will return either the
   * computed style, if available, or the declared style.
   *
   * @param {DOMNode} node
   * @param {string} name Style property name.
   * @return {?string} Style property value.
   */
  get: getStyleProperty,

  /**
   * Determines the nearest ancestor of a node that is scrollable.
   *
   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
   *
   * @param {?DOMNode} node Node from which to start searching.
   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
   */
  getScrollParent: function getScrollParent(node) {
    if (!node) {
      return null;
    }

    var ownerDocument = node.ownerDocument;

    while (node && node !== ownerDocument.body) {
      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
        return node;
      }

      node = node.parentNode;
    }

    return ownerDocument.defaultView || ownerDocument.parentWindow;
  }
};
module.exports = Style;

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Constants to represent text directionality
 *
 * Also defines a *global* direciton, to be used in bidi algorithms as a
 * default fallback direciton, when no better direction is found or provided.
 *
 * NOTE: Use `setGlobalDir()`, or update `initGlobalDir()`, to set the initial
 *       global direction value based on the application.
 *
 * Part of the implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */


var invariant = __webpack_require__(48);

var NEUTRAL = 'NEUTRAL'; // No strong direction

var LTR = 'LTR'; // Left-to-Right direction

var RTL = 'RTL'; // Right-to-Left direction

var globalDir = null; // == Helpers ==

/**
 * Check if a directionality value is a Strong one
 */

function isStrong(dir) {
  return dir === LTR || dir === RTL;
}
/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property.
 */


function getHTMLDir(dir) {
  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  return dir === LTR ? 'ltr' : 'rtl';
}
/**
 * Get string value to be used for `dir` HTML attribute or `direction` CSS
 * property, but returns null if `dir` has same value as `otherDir`.
 * `null`.
 */


function getHTMLDirIfDifferent(dir, otherDir) {
  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  !isStrong(otherDir) ?  false ? invariant(false, '`otherDir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
  return dir === otherDir ? null : getHTMLDir(dir);
} // == Global Direction ==

/**
 * Set the global direction.
 */


function setGlobalDir(dir) {
  globalDir = dir;
}
/**
 * Initialize the global direction
 */


function initGlobalDir() {
  setGlobalDir(LTR);
}
/**
 * Get the global direction
 */


function getGlobalDir() {
  if (!globalDir) {
    this.initGlobalDir();
  }

  !globalDir ?  false ? invariant(false, 'Global direction not set.') : invariant(false) : void 0;
  return globalDir;
}

var UnicodeBidiDirection = {
  // Values
  NEUTRAL: NEUTRAL,
  LTR: LTR,
  RTL: RTL,
  // Helpers
  isStrong: isStrong,
  getHTMLDir: getHTMLDir,
  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
  // Global Direction
  setGlobalDir: setGlobalDir,
  initGlobalDir: initGlobalDir,
  getGlobalDir: getGlobalDir
};
module.exports = UnicodeBidiDirection;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */


var getDocumentScrollElement = __webpack_require__(2931);

var getUnboundedScrollPosition = __webpack_require__(2934);
/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are bounded. This means that if the scroll position is
 * negative or exceeds the element boundaries (which is possible using inertial
 * scrolling), you will get zero or the maximum scroll position, respectively.
 *
 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */


function getScrollPosition(scrollable) {
  var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);

  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    scrollable = documentScrollElement;
  }

  var scrollPosition = getUnboundedScrollPosition(scrollable);
  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;
  var xMax = scrollable.scrollWidth - viewport.clientWidth;
  var yMax = scrollable.scrollHeight - viewport.clientHeight;
  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));
  return scrollPosition;
}

module.exports = getScrollPosition;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(77);
var utils = __webpack_require__(135);
var getNAF = utils.getNAF;
var getJSF = utils.getJSF;
var assert = utils.assert;

function BaseCurve(type, conf) {
  this.type = type;
  this.p = new BN(conf.p, 16);

  // Use Montgomery, when there is no fast reduction for the prime
  this.red = conf.prime ? BN.red(conf.prime) : BN.mont(this.p);

  // Useful for many curves
  this.zero = new BN(0).toRed(this.red);
  this.one = new BN(1).toRed(this.red);
  this.two = new BN(2).toRed(this.red);

  // Curve configuration, optional
  this.n = conf.n && new BN(conf.n, 16);
  this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);

  // Temporary arrays
  this._wnafT1 = new Array(4);
  this._wnafT2 = new Array(4);
  this._wnafT3 = new Array(4);
  this._wnafT4 = new Array(4);

  this._bitLength = this.n ? this.n.bitLength() : 0;

  // Generalized Greg Maxwell's trick
  var adjustCount = this.n && this.p.div(this.n);
  if (!adjustCount || adjustCount.cmpn(100) > 0) {
    this.redN = null;
  } else {
    this._maxwellTrick = true;
    this.redN = this.n.toRed(this.red);
  }
}
module.exports = BaseCurve;

BaseCurve.prototype.point = function point() {
  throw new Error('Not implemented');
};

BaseCurve.prototype.validate = function validate() {
  throw new Error('Not implemented');
};

BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
  assert(p.precomputed);
  var doubles = p._getDoubles();

  var naf = getNAF(k, 1, this._bitLength);
  var I = (1 << (doubles.step + 1)) - (doubles.step % 2 === 0 ? 2 : 1);
  I /= 3;

  // Translate into more windowed form
  var repr = [];
  var j;
  var nafW;
  for (j = 0; j < naf.length; j += doubles.step) {
    nafW = 0;
    for (var l = j + doubles.step - 1; l >= j; l--)
      nafW = (nafW << 1) + naf[l];
    repr.push(nafW);
  }

  var a = this.jpoint(null, null, null);
  var b = this.jpoint(null, null, null);
  for (var i = I; i > 0; i--) {
    for (j = 0; j < repr.length; j++) {
      nafW = repr[j];
      if (nafW === i)
        b = b.mixedAdd(doubles.points[j]);
      else if (nafW === -i)
        b = b.mixedAdd(doubles.points[j].neg());
    }
    a = a.add(b);
  }
  return a.toP();
};

BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
  var w = 4;

  // Precompute window
  var nafPoints = p._getNAFPoints(w);
  w = nafPoints.wnd;
  var wnd = nafPoints.points;

  // Get NAF form
  var naf = getNAF(k, w, this._bitLength);

  // Add `this`*(N+1) for every w-NAF index
  var acc = this.jpoint(null, null, null);
  for (var i = naf.length - 1; i >= 0; i--) {
    // Count zeroes
    for (var l = 0; i >= 0 && naf[i] === 0; i--)
      l++;
    if (i >= 0)
      l++;
    acc = acc.dblp(l);

    if (i < 0)
      break;
    var z = naf[i];
    assert(z !== 0);
    if (p.type === 'affine') {
      // J +- P
      if (z > 0)
        acc = acc.mixedAdd(wnd[(z - 1) >> 1]);
      else
        acc = acc.mixedAdd(wnd[(-z - 1) >> 1].neg());
    } else {
      // J +- J
      if (z > 0)
        acc = acc.add(wnd[(z - 1) >> 1]);
      else
        acc = acc.add(wnd[(-z - 1) >> 1].neg());
    }
  }
  return p.type === 'affine' ? acc.toP() : acc;
};

BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW,
  points,
  coeffs,
  len,
  jacobianResult) {
  var wndWidth = this._wnafT1;
  var wnd = this._wnafT2;
  var naf = this._wnafT3;

  // Fill all arrays
  var max = 0;
  var i;
  var j;
  var p;
  for (i = 0; i < len; i++) {
    p = points[i];
    var nafPoints = p._getNAFPoints(defW);
    wndWidth[i] = nafPoints.wnd;
    wnd[i] = nafPoints.points;
  }

  // Comb small window NAFs
  for (i = len - 1; i >= 1; i -= 2) {
    var a = i - 1;
    var b = i;
    if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
      naf[a] = getNAF(coeffs[a], wndWidth[a], this._bitLength);
      naf[b] = getNAF(coeffs[b], wndWidth[b], this._bitLength);
      max = Math.max(naf[a].length, max);
      max = Math.max(naf[b].length, max);
      continue;
    }

    var comb = [
      points[a], /* 1 */
      null, /* 3 */
      null, /* 5 */
      points[b], /* 7 */
    ];

    // Try to avoid Projective points, if possible
    if (points[a].y.cmp(points[b].y) === 0) {
      comb[1] = points[a].add(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].add(points[b].neg());
    } else {
      comb[1] = points[a].toJ().mixedAdd(points[b]);
      comb[2] = points[a].toJ().mixedAdd(points[b].neg());
    }

    var index = [
      -3, /* -1 -1 */
      -1, /* -1 0 */
      -5, /* -1 1 */
      -7, /* 0 -1 */
      0, /* 0 0 */
      7, /* 0 1 */
      5, /* 1 -1 */
      1, /* 1 0 */
      3,  /* 1 1 */
    ];

    var jsf = getJSF(coeffs[a], coeffs[b]);
    max = Math.max(jsf[0].length, max);
    naf[a] = new Array(max);
    naf[b] = new Array(max);
    for (j = 0; j < max; j++) {
      var ja = jsf[0][j] | 0;
      var jb = jsf[1][j] | 0;

      naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
      naf[b][j] = 0;
      wnd[a] = comb;
    }
  }

  var acc = this.jpoint(null, null, null);
  var tmp = this._wnafT4;
  for (i = max; i >= 0; i--) {
    var k = 0;

    while (i >= 0) {
      var zero = true;
      for (j = 0; j < len; j++) {
        tmp[j] = naf[j][i] | 0;
        if (tmp[j] !== 0)
          zero = false;
      }
      if (!zero)
        break;
      k++;
      i--;
    }
    if (i >= 0)
      k++;
    acc = acc.dblp(k);
    if (i < 0)
      break;

    for (j = 0; j < len; j++) {
      var z = tmp[j];
      p;
      if (z === 0)
        continue;
      else if (z > 0)
        p = wnd[j][(z - 1) >> 1];
      else if (z < 0)
        p = wnd[j][(-z - 1) >> 1].neg();

      if (p.type === 'affine')
        acc = acc.mixedAdd(p);
      else
        acc = acc.add(p);
    }
  }
  // Zeroify references
  for (i = 0; i < len; i++)
    wnd[i] = null;

  if (jacobianResult)
    return acc;
  else
    return acc.toP();
};

function BasePoint(curve, type) {
  this.curve = curve;
  this.type = type;
  this.precomputed = null;
}
BaseCurve.BasePoint = BasePoint;

BasePoint.prototype.eq = function eq(/*other*/) {
  throw new Error('Not implemented');
};

BasePoint.prototype.validate = function validate() {
  return this.curve.validate(this);
};

BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  bytes = utils.toArray(bytes, enc);

  var len = this.p.byteLength();

  // uncompressed, hybrid-odd, hybrid-even
  if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) &&
      bytes.length - 1 === 2 * len) {
    if (bytes[0] === 0x06)
      assert(bytes[bytes.length - 1] % 2 === 0);
    else if (bytes[0] === 0x07)
      assert(bytes[bytes.length - 1] % 2 === 1);

    var res =  this.point(bytes.slice(1, 1 + len),
      bytes.slice(1 + len, 1 + 2 * len));

    return res;
  } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) &&
              bytes.length - 1 === len) {
    return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
  }
  throw new Error('Unknown point format');
};

BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
  return this.encode(enc, true);
};

BasePoint.prototype._encode = function _encode(compact) {
  var len = this.curve.p.byteLength();
  var x = this.getX().toArray('be', len);

  if (compact)
    return [ this.getY().isEven() ? 0x02 : 0x03 ].concat(x);

  return [ 0x04 ].concat(x, this.getY().toArray('be', len));
};

BasePoint.prototype.encode = function encode(enc, compact) {
  return utils.encode(this._encode(compact), enc);
};

BasePoint.prototype.precompute = function precompute(power) {
  if (this.precomputed)
    return this;

  var precomputed = {
    doubles: null,
    naf: null,
    beta: null,
  };
  precomputed.naf = this._getNAFPoints(8);
  precomputed.doubles = this._getDoubles(4, power);
  precomputed.beta = this._getBeta();
  this.precomputed = precomputed;

  return this;
};

BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
  if (!this.precomputed)
    return false;

  var doubles = this.precomputed.doubles;
  if (!doubles)
    return false;

  return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};

BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
  if (this.precomputed && this.precomputed.doubles)
    return this.precomputed.doubles;

  var doubles = [ this ];
  var acc = this;
  for (var i = 0; i < power; i += step) {
    for (var j = 0; j < step; j++)
      acc = acc.dbl();
    doubles.push(acc);
  }
  return {
    step: step,
    points: doubles,
  };
};

BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
  if (this.precomputed && this.precomputed.naf)
    return this.precomputed.naf;

  var res = [ this ];
  var max = (1 << wnd) - 1;
  var dbl = max === 1 ? null : this.dbl();
  for (var i = 1; i < max; i++)
    res[i] = res[i - 1].add(dbl);
  return {
    wnd: wnd,
    points: res,
  };
};

BasePoint.prototype._getBeta = function _getBeta() {
  return null;
};

BasePoint.prototype.dblp = function dblp(k) {
  var r = this;
  for (var i = 0; i < k; i++)
    r = r.dbl();
  return r;
};


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(42).Buffer
var MD5 = __webpack_require__(679)

/* eslint-disable camelcase */
function EVP_BytesToKey (password, salt, keyBits, ivLen) {
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, 'binary')
  if (salt) {
    if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, 'binary')
    if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length')
  }

  var keyLen = keyBits / 8
  var key = Buffer.alloc(keyLen)
  var iv = Buffer.alloc(ivLen || 0)
  var tmp = Buffer.alloc(0)

  while (keyLen > 0 || ivLen > 0) {
    var hash = new MD5()
    hash.update(tmp)
    hash.update(password)
    if (salt) hash.update(salt)
    tmp = hash.digest()

    var used = 0

    if (keyLen > 0) {
      var keyStart = key.length - keyLen
      used = Math.min(keyLen, tmp.length)
      tmp.copy(key, keyStart, 0, used)
      keyLen -= used
    }

    if (used < tmp.length && ivLen > 0) {
      var ivStart = iv.length - ivLen
      var length = Math.min(ivLen, tmp.length - used)
      tmp.copy(iv, ivStart, used, used + length)
      ivLen -= length
    }
  }

  tmp.fill(0)
  return { key: key, iv: iv }
}

module.exports = EVP_BytesToKey


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(2964);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.execute = execute;
exports.responsePathAsArray = responsePathAsArray;
exports.addPath = addPath;
exports.assertValidExecutionArguments = assertValidExecutionArguments;
exports.buildExecutionContext = buildExecutionContext;
exports.collectFields = collectFields;
exports.buildResolveInfo = buildResolveInfo;
exports.resolveFieldValueOrError = resolveFieldValueOrError;
exports.getFieldDef = getFieldDef;
exports.defaultFieldResolver = void 0;

var _iterall = __webpack_require__(348);

var _GraphQLError = __webpack_require__(37);

var _locatedError = __webpack_require__(657);

var _inspect = _interopRequireDefault(__webpack_require__(93));

var _invariant = _interopRequireDefault(__webpack_require__(108));

var _isInvalid = _interopRequireDefault(__webpack_require__(204));

var _isNullish = _interopRequireDefault(__webpack_require__(660));

var _isPromise = _interopRequireDefault(__webpack_require__(1206));

var _memoize = _interopRequireDefault(__webpack_require__(2975));

var _promiseForObject = _interopRequireDefault(__webpack_require__(2976));

var _promiseReduce = _interopRequireDefault(__webpack_require__(2977));

var _getOperationRootType = __webpack_require__(667);

var _typeFromAST = __webpack_require__(185);

var _kinds = __webpack_require__(68);

var _values = __webpack_require__(658);

var _definition = __webpack_require__(54);

var _introspection = __webpack_require__(166);

var _directives = __webpack_require__(136);

var _validate = __webpack_require__(440);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function execute(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
  /* eslint-enable no-redeclare */
  // Extract arguments from object args if provided.
  return arguments.length === 1 ? executeImpl(argsOrSchema.schema, argsOrSchema.document, argsOrSchema.rootValue, argsOrSchema.contextValue, argsOrSchema.variableValues, argsOrSchema.operationName, argsOrSchema.fieldResolver) : executeImpl(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver);
}

function executeImpl(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
  // If arguments are missing or incorrect, throw an error.
  assertValidExecutionArguments(schema, document, variableValues); // If a valid execution context cannot be created due to incorrect arguments,
  // a "Response" with only errors is returned.

  var exeContext = buildExecutionContext(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver); // Return early errors if execution context failed.

  if (Array.isArray(exeContext)) {
    return {
      errors: exeContext
    };
  } // Return a Promise that will eventually resolve to the data described by
  // The "Response" section of the GraphQL specification.
  //
  // If errors are encountered while executing a GraphQL field, only that
  // field and its descendants will be omitted, and sibling fields will still
  // be executed. An execution which encounters errors will still result in a
  // resolved Promise.


  var data = executeOperation(exeContext, exeContext.operation, rootValue);
  return buildResponse(exeContext, data);
}
/**
 * Given a completed execution context and data, build the { errors, data }
 * response defined by the "Response" section of the GraphQL specification.
 */


function buildResponse(exeContext, data) {
  if ((0, _isPromise.default)(data)) {
    return data.then(function (resolved) {
      return buildResponse(exeContext, resolved);
    });
  }

  return exeContext.errors.length === 0 ? {
    data: data
  } : {
    errors: exeContext.errors,
    data: data
  };
}
/**
 * Given a ResponsePath (found in the `path` entry in the information provided
 * as the last argument to a field resolver), return an Array of the path keys.
 */


function responsePathAsArray(path) {
  var flattened = [];
  var curr = path;

  while (curr) {
    flattened.push(curr.key);
    curr = curr.prev;
  }

  return flattened.reverse();
}
/**
 * Given a ResponsePath and a key, return a new ResponsePath containing the
 * new key.
 */


function addPath(prev, key) {
  return {
    prev: prev,
    key: key
  };
}
/**
 * Essential assertions before executing to provide developer feedback for
 * improper use of the GraphQL library.
 */


function assertValidExecutionArguments(schema, document, rawVariableValues) {
  !document ? (0, _invariant.default)(0, 'Must provide document') : void 0; // If the schema used for execution is invalid, throw an error.

  (0, _validate.assertValidSchema)(schema); // Variables, if provided, must be an object.

  !(!rawVariableValues || _typeof(rawVariableValues) === 'object') ? (0, _invariant.default)(0, 'Variables must be provided as an Object where each property is a ' + 'variable value. Perhaps look to see if an unparsed JSON string ' + 'was provided.') : void 0;
}
/**
 * Constructs a ExecutionContext object from the arguments passed to
 * execute, which we will pass throughout the other execution methods.
 *
 * Throws a GraphQLError if a valid execution context cannot be created.
 */


function buildExecutionContext(schema, document, rootValue, contextValue, rawVariableValues, operationName, fieldResolver) {
  var errors = [];
  var operation;
  var hasMultipleAssumedOperations = false;
  var fragments = Object.create(null);

  for (var i = 0; i < document.definitions.length; i++) {
    var definition = document.definitions[i];

    switch (definition.kind) {
      case _kinds.Kind.OPERATION_DEFINITION:
        if (!operationName && operation) {
          hasMultipleAssumedOperations = true;
        } else if (!operationName || definition.name && definition.name.value === operationName) {
          operation = definition;
        }

        break;

      case _kinds.Kind.FRAGMENT_DEFINITION:
        fragments[definition.name.value] = definition;
        break;
    }
  }

  if (!operation) {
    if (operationName) {
      errors.push(new _GraphQLError.GraphQLError("Unknown operation named \"".concat(operationName, "\".")));
    } else {
      errors.push(new _GraphQLError.GraphQLError('Must provide an operation.'));
    }
  } else if (hasMultipleAssumedOperations) {
    errors.push(new _GraphQLError.GraphQLError('Must provide operation name if query contains ' + 'multiple operations.'));
  }

  var variableValues;

  if (operation) {
    var coercedVariableValues = (0, _values.getVariableValues)(schema, operation.variableDefinitions || [], rawVariableValues || {});

    if (coercedVariableValues.errors) {
      errors.push.apply(errors, coercedVariableValues.errors);
    } else {
      variableValues = coercedVariableValues.coerced;
    }
  }

  if (errors.length !== 0) {
    return errors;
  }

  !operation ? (0, _invariant.default)(0, 'Has operation if no errors.') : void 0;
  !variableValues ? (0, _invariant.default)(0, 'Has variables if no errors.') : void 0;
  return {
    schema: schema,
    fragments: fragments,
    rootValue: rootValue,
    contextValue: contextValue,
    operation: operation,
    variableValues: variableValues,
    fieldResolver: fieldResolver || defaultFieldResolver,
    errors: errors
  };
}
/**
 * Implements the "Evaluating operations" section of the spec.
 */


function executeOperation(exeContext, operation, rootValue) {
  var type = (0, _getOperationRootType.getOperationRootType)(exeContext.schema, operation);
  var fields = collectFields(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));
  var path = undefined; // Errors from sub-fields of a NonNull type may propagate to the top level,
  // at which point we still log the error and null the parent field, which
  // in this case is the entire response.
  //
  // Similar to completeValueCatchingError.

  try {
    var result = operation.operation === 'mutation' ? executeFieldsSerially(exeContext, type, rootValue, path, fields) : executeFields(exeContext, type, rootValue, path, fields);

    if ((0, _isPromise.default)(result)) {
      return result.then(undefined, function (error) {
        exeContext.errors.push(error);
        return Promise.resolve(null);
      });
    }

    return result;
  } catch (error) {
    exeContext.errors.push(error);
    return null;
  }
}
/**
 * Implements the "Evaluating selection sets" section of the spec
 * for "write" mode.
 */


function executeFieldsSerially(exeContext, parentType, sourceValue, path, fields) {
  return (0, _promiseReduce.default)(Object.keys(fields), function (results, responseName) {
    var fieldNodes = fields[responseName];
    var fieldPath = addPath(path, responseName);
    var result = resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);

    if (result === undefined) {
      return results;
    }

    if ((0, _isPromise.default)(result)) {
      return result.then(function (resolvedResult) {
        results[responseName] = resolvedResult;
        return results;
      });
    }

    results[responseName] = result;
    return results;
  }, Object.create(null));
}
/**
 * Implements the "Evaluating selection sets" section of the spec
 * for "read" mode.
 */


function executeFields(exeContext, parentType, sourceValue, path, fields) {
  var results = Object.create(null);
  var containsPromise = false;

  for (var i = 0, keys = Object.keys(fields); i < keys.length; ++i) {
    var responseName = keys[i];
    var fieldNodes = fields[responseName];
    var fieldPath = addPath(path, responseName);
    var result = resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);

    if (result !== undefined) {
      results[responseName] = result;

      if (!containsPromise && (0, _isPromise.default)(result)) {
        containsPromise = true;
      }
    }
  } // If there are no promises, we can just return the object


  if (!containsPromise) {
    return results;
  } // Otherwise, results is a map from field name to the result of resolving that
  // field, which is possibly a promise. Return a promise that will return this
  // same map, but with any promises replaced with the values they resolved to.


  return (0, _promiseForObject.default)(results);
}
/**
 * Given a selectionSet, adds all of the fields in that selection to
 * the passed in map of fields, and returns it at the end.
 *
 * CollectFields requires the "runtime type" of an object. For a field which
 * returns an Interface or Union type, the "runtime type" will be the actual
 * Object type returned by that field.
 */


function collectFields(exeContext, runtimeType, selectionSet, fields, visitedFragmentNames) {
  for (var i = 0; i < selectionSet.selections.length; i++) {
    var selection = selectionSet.selections[i];

    switch (selection.kind) {
      case _kinds.Kind.FIELD:
        if (!shouldIncludeNode(exeContext, selection)) {
          continue;
        }

        var name = getFieldEntryKey(selection);

        if (!fields[name]) {
          fields[name] = [];
        }

        fields[name].push(selection);
        break;

      case _kinds.Kind.INLINE_FRAGMENT:
        if (!shouldIncludeNode(exeContext, selection) || !doesFragmentConditionMatch(exeContext, selection, runtimeType)) {
          continue;
        }

        collectFields(exeContext, runtimeType, selection.selectionSet, fields, visitedFragmentNames);
        break;

      case _kinds.Kind.FRAGMENT_SPREAD:
        var fragName = selection.name.value;

        if (visitedFragmentNames[fragName] || !shouldIncludeNode(exeContext, selection)) {
          continue;
        }

        visitedFragmentNames[fragName] = true;
        var fragment = exeContext.fragments[fragName];

        if (!fragment || !doesFragmentConditionMatch(exeContext, fragment, runtimeType)) {
          continue;
        }

        collectFields(exeContext, runtimeType, fragment.selectionSet, fields, visitedFragmentNames);
        break;
    }
  }

  return fields;
}
/**
 * Determines if a field should be included based on the @include and @skip
 * directives, where @skip has higher precidence than @include.
 */


function shouldIncludeNode(exeContext, node) {
  var skip = (0, _values.getDirectiveValues)(_directives.GraphQLSkipDirective, node, exeContext.variableValues);

  if (skip && skip.if === true) {
    return false;
  }

  var include = (0, _values.getDirectiveValues)(_directives.GraphQLIncludeDirective, node, exeContext.variableValues);

  if (include && include.if === false) {
    return false;
  }

  return true;
}
/**
 * Determines if a fragment is applicable to the given type.
 */


function doesFragmentConditionMatch(exeContext, fragment, type) {
  var typeConditionNode = fragment.typeCondition;

  if (!typeConditionNode) {
    return true;
  }

  var conditionalType = (0, _typeFromAST.typeFromAST)(exeContext.schema, typeConditionNode);

  if (conditionalType === type) {
    return true;
  }

  if ((0, _definition.isAbstractType)(conditionalType)) {
    return exeContext.schema.isPossibleType(conditionalType, type);
  }

  return false;
}
/**
 * Implements the logic to compute the key of a given field's entry
 */


function getFieldEntryKey(node) {
  return node.alias ? node.alias.value : node.name.value;
}
/**
 * Resolves the field on the given source object. In particular, this
 * figures out the value that the field returns by calling its resolve function,
 * then calls completeValue to complete promises, serialize scalars, or execute
 * the sub-selection-set for objects.
 */


function resolveField(exeContext, parentType, source, fieldNodes, path) {
  var fieldNode = fieldNodes[0];
  var fieldName = fieldNode.name.value;
  var fieldDef = getFieldDef(exeContext.schema, parentType, fieldName);

  if (!fieldDef) {
    return;
  }

  var resolveFn = fieldDef.resolve || exeContext.fieldResolver;
  var info = buildResolveInfo(exeContext, fieldDef, fieldNodes, parentType, path); // Get the resolve function, regardless of if its result is normal
  // or abrupt (error).

  var result = resolveFieldValueOrError(exeContext, fieldDef, fieldNodes, resolveFn, source, info);
  return completeValueCatchingError(exeContext, fieldDef.type, fieldNodes, info, path, result);
}

function buildResolveInfo(exeContext, fieldDef, fieldNodes, parentType, path) {
  // The resolve function's optional fourth argument is a collection of
  // information about the current execution state.
  return {
    fieldName: fieldDef.name,
    fieldNodes: fieldNodes,
    returnType: fieldDef.type,
    parentType: parentType,
    path: path,
    schema: exeContext.schema,
    fragments: exeContext.fragments,
    rootValue: exeContext.rootValue,
    operation: exeContext.operation,
    variableValues: exeContext.variableValues
  };
} // Isolates the "ReturnOrAbrupt" behavior to not de-opt the `resolveField`
// function. Returns the result of resolveFn or the abrupt-return Error object.


function resolveFieldValueOrError(exeContext, fieldDef, fieldNodes, resolveFn, source, info) {
  try {
    // Build a JS object of arguments from the field.arguments AST, using the
    // variables scope to fulfill any variable references.
    // TODO: find a way to memoize, in case this field is within a List type.
    var args = (0, _values.getArgumentValues)(fieldDef, fieldNodes[0], exeContext.variableValues); // The resolve function's optional third argument is a context value that
    // is provided to every resolve function within an execution. It is commonly
    // used to represent an authenticated user, or request-specific caches.

    var _contextValue = exeContext.contextValue;
    var result = resolveFn(source, args, _contextValue, info);
    return (0, _isPromise.default)(result) ? result.then(undefined, asErrorInstance) : result;
  } catch (error) {
    return asErrorInstance(error);
  }
} // Sometimes a non-error is thrown, wrap it as an Error instance to ensure a
// consistent Error interface.


function asErrorInstance(error) {
  return error instanceof Error ? error : new Error(error || undefined);
} // This is a small wrapper around completeValue which detects and logs errors
// in the execution context.


function completeValueCatchingError(exeContext, returnType, fieldNodes, info, path, result) {
  try {
    var completed;

    if ((0, _isPromise.default)(result)) {
      completed = result.then(function (resolved) {
        return completeValue(exeContext, returnType, fieldNodes, info, path, resolved);
      });
    } else {
      completed = completeValue(exeContext, returnType, fieldNodes, info, path, result);
    }

    if ((0, _isPromise.default)(completed)) {
      // Note: we don't rely on a `catch` method, but we do expect "thenable"
      // to take a second callback for the error case.
      return completed.then(undefined, function (error) {
        return handleFieldError(error, fieldNodes, path, returnType, exeContext);
      });
    }

    return completed;
  } catch (error) {
    return handleFieldError(error, fieldNodes, path, returnType, exeContext);
  }
}

function handleFieldError(rawError, fieldNodes, path, returnType, exeContext) {
  var error = (0, _locatedError.locatedError)(asErrorInstance(rawError), fieldNodes, responsePathAsArray(path)); // If the field type is non-nullable, then it is resolved without any
  // protection from errors, however it still properly locates the error.

  if ((0, _definition.isNonNullType)(returnType)) {
    throw error;
  } // Otherwise, error protection is applied, logging the error and resolving
  // a null value for this field if one is encountered.


  exeContext.errors.push(error);
  return null;
}
/**
 * Implements the instructions for completeValue as defined in the
 * "Field entries" section of the spec.
 *
 * If the field type is Non-Null, then this recursively completes the value
 * for the inner type. It throws a field error if that completion returns null,
 * as per the "Nullability" section of the spec.
 *
 * If the field type is a List, then this recursively completes the value
 * for the inner type on each item in the list.
 *
 * If the field type is a Scalar or Enum, ensures the completed value is a legal
 * value of the type by calling the `serialize` method of GraphQL type
 * definition.
 *
 * If the field is an abstract type, determine the runtime type of the value
 * and then complete based on that type
 *
 * Otherwise, the field type expects a sub-selection set, and will complete the
 * value by evaluating all sub-selections.
 */


function completeValue(exeContext, returnType, fieldNodes, info, path, result) {
  // If result is an Error, throw a located error.
  if (result instanceof Error) {
    throw result;
  } // If field type is NonNull, complete for inner type, and throw field error
  // if result is null.


  if ((0, _definition.isNonNullType)(returnType)) {
    var completed = completeValue(exeContext, returnType.ofType, fieldNodes, info, path, result);

    if (completed === null) {
      throw new Error("Cannot return null for non-nullable field ".concat(info.parentType.name, ".").concat(info.fieldName, "."));
    }

    return completed;
  } // If result value is null-ish (null, undefined, or NaN) then return null.


  if ((0, _isNullish.default)(result)) {
    return null;
  } // If field type is List, complete each item in the list with the inner type


  if ((0, _definition.isListType)(returnType)) {
    return completeListValue(exeContext, returnType, fieldNodes, info, path, result);
  } // If field type is a leaf type, Scalar or Enum, serialize to a valid value,
  // returning null if serialization is not possible.


  if ((0, _definition.isLeafType)(returnType)) {
    return completeLeafValue(returnType, result);
  } // If field type is an abstract type, Interface or Union, determine the
  // runtime Object type and complete for that type.


  if ((0, _definition.isAbstractType)(returnType)) {
    return completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result);
  } // If field type is Object, execute and complete all sub-selections.


  if ((0, _definition.isObjectType)(returnType)) {
    return completeObjectValue(exeContext, returnType, fieldNodes, info, path, result);
  } // Not reachable. All possible output types have been considered.

  /* istanbul ignore next */


  throw new Error("Cannot complete value of unexpected type \"".concat((0, _inspect.default)(returnType), "\"."));
}
/**
 * Complete a list value by completing each item in the list with the
 * inner type
 */


function completeListValue(exeContext, returnType, fieldNodes, info, path, result) {
  !(0, _iterall.isCollection)(result) ? (0, _invariant.default)(0, "Expected Iterable, but did not find one for field ".concat(info.parentType.name, ".").concat(info.fieldName, ".")) : void 0; // This is specified as a simple map, however we're optimizing the path
  // where the list contains no Promises by avoiding creating another Promise.

  var itemType = returnType.ofType;
  var containsPromise = false;
  var completedResults = [];
  (0, _iterall.forEach)(result, function (item, index) {
    // No need to modify the info object containing the path,
    // since from here on it is not ever accessed by resolver functions.
    var fieldPath = addPath(path, index);
    var completedItem = completeValueCatchingError(exeContext, itemType, fieldNodes, info, fieldPath, item);

    if (!containsPromise && (0, _isPromise.default)(completedItem)) {
      containsPromise = true;
    }

    completedResults.push(completedItem);
  });
  return containsPromise ? Promise.all(completedResults) : completedResults;
}
/**
 * Complete a Scalar or Enum by serializing to a valid value, returning
 * null if serialization is not possible.
 */


function completeLeafValue(returnType, result) {
  !returnType.serialize ? (0, _invariant.default)(0, 'Missing serialize method on type') : void 0;
  var serializedResult = returnType.serialize(result);

  if ((0, _isInvalid.default)(serializedResult)) {
    throw new Error("Expected a value of type \"".concat((0, _inspect.default)(returnType), "\" but ") + "received: ".concat((0, _inspect.default)(result)));
  }

  return serializedResult;
}
/**
 * Complete a value of an abstract type by determining the runtime object type
 * of that value, then complete the value for that type.
 */


function completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result) {
  var runtimeType = returnType.resolveType ? returnType.resolveType(result, exeContext.contextValue, info) : defaultResolveTypeFn(result, exeContext.contextValue, info, returnType);

  if ((0, _isPromise.default)(runtimeType)) {
    return runtimeType.then(function (resolvedRuntimeType) {
      return completeObjectValue(exeContext, ensureValidRuntimeType(resolvedRuntimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
    });
  }

  return completeObjectValue(exeContext, ensureValidRuntimeType(runtimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
}

function ensureValidRuntimeType(runtimeTypeOrName, exeContext, returnType, fieldNodes, info, result) {
  var runtimeType = typeof runtimeTypeOrName === 'string' ? exeContext.schema.getType(runtimeTypeOrName) : runtimeTypeOrName;

  if (!(0, _definition.isObjectType)(runtimeType)) {
    throw new _GraphQLError.GraphQLError("Abstract type ".concat(returnType.name, " must resolve to an Object type at ") + "runtime for field ".concat(info.parentType.name, ".").concat(info.fieldName, " with ") + "value ".concat((0, _inspect.default)(result), ", received \"").concat((0, _inspect.default)(runtimeType), "\". ") + "Either the ".concat(returnType.name, " type should provide a \"resolveType\" ") + 'function or each possible type should provide an ' + '"isTypeOf" function.', fieldNodes);
  }

  if (!exeContext.schema.isPossibleType(returnType, runtimeType)) {
    throw new _GraphQLError.GraphQLError("Runtime Object type \"".concat(runtimeType.name, "\" is not a possible type ") + "for \"".concat(returnType.name, "\"."), fieldNodes);
  }

  return runtimeType;
}
/**
 * Complete an Object value by executing all sub-selections.
 */


function completeObjectValue(exeContext, returnType, fieldNodes, info, path, result) {
  // If there is an isTypeOf predicate function, call it with the
  // current result. If isTypeOf returns false, then raise an error rather
  // than continuing execution.
  if (returnType.isTypeOf) {
    var isTypeOf = returnType.isTypeOf(result, exeContext.contextValue, info);

    if ((0, _isPromise.default)(isTypeOf)) {
      return isTypeOf.then(function (resolvedIsTypeOf) {
        if (!resolvedIsTypeOf) {
          throw invalidReturnTypeError(returnType, result, fieldNodes);
        }

        return collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result);
      });
    }

    if (!isTypeOf) {
      throw invalidReturnTypeError(returnType, result, fieldNodes);
    }
  }

  return collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result);
}

function invalidReturnTypeError(returnType, result, fieldNodes) {
  return new _GraphQLError.GraphQLError("Expected value of type \"".concat(returnType.name, "\" but got: ").concat((0, _inspect.default)(result), "."), fieldNodes);
}

function collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result) {
  // Collect sub-fields to execute to complete this value.
  var subFieldNodes = collectSubfields(exeContext, returnType, fieldNodes);
  return executeFields(exeContext, returnType, result, path, subFieldNodes);
}
/**
 * A memoized collection of relevant subfields with regard to the return
 * type. Memoizing ensures the subfields are not repeatedly calculated, which
 * saves overhead when resolving lists of values.
 */


var collectSubfields = (0, _memoize.default)(_collectSubfields);

function _collectSubfields(exeContext, returnType, fieldNodes) {
  var subFieldNodes = Object.create(null);
  var visitedFragmentNames = Object.create(null);

  for (var i = 0; i < fieldNodes.length; i++) {
    var selectionSet = fieldNodes[i].selectionSet;

    if (selectionSet) {
      subFieldNodes = collectFields(exeContext, returnType, selectionSet, subFieldNodes, visitedFragmentNames);
    }
  }

  return subFieldNodes;
}
/**
 * If a resolveType function is not given, then a default resolve behavior is
 * used which attempts two strategies:
 *
 * First, See if the provided value has a `__typename` field defined, if so, use
 * that value as name of the resolved type.
 *
 * Otherwise, test each possible type for the abstract type by calling
 * isTypeOf for the object being coerced, returning the first type that matches.
 */


function defaultResolveTypeFn(value, contextValue, info, abstractType) {
  // First, look for `__typename`.
  if (value !== null && _typeof(value) === 'object' && typeof value.__typename === 'string') {
    return value.__typename;
  } // Otherwise, test each possible type.


  var possibleTypes = info.schema.getPossibleTypes(abstractType);
  var promisedIsTypeOfResults = [];

  for (var i = 0; i < possibleTypes.length; i++) {
    var type = possibleTypes[i];

    if (type.isTypeOf) {
      var isTypeOfResult = type.isTypeOf(value, contextValue, info);

      if ((0, _isPromise.default)(isTypeOfResult)) {
        promisedIsTypeOfResults[i] = isTypeOfResult;
      } else if (isTypeOfResult) {
        return type;
      }
    }
  }

  if (promisedIsTypeOfResults.length) {
    return Promise.all(promisedIsTypeOfResults).then(function (isTypeOfResults) {
      for (var _i = 0; _i < isTypeOfResults.length; _i++) {
        if (isTypeOfResults[_i]) {
          return possibleTypes[_i];
        }
      }
    });
  }
}
/**
 * If a resolve function is not given, then a default resolve behavior is used
 * which takes the property of the source object of the same name as the field
 * and returns it as the result, or if it's a function, returns the result
 * of calling that function while passing along args and context value.
 */


var defaultFieldResolver = function defaultFieldResolver(source, args, contextValue, info) {
  // ensure source is a value for which property access is acceptable.
  if (_typeof(source) === 'object' || typeof source === 'function') {
    var property = source[info.fieldName];

    if (typeof property === 'function') {
      return source[info.fieldName](args, contextValue, info);
    }

    return property;
  }
};
/**
 * This method looks up the field on the given type defintion.
 * It has special casing for the two introspection fields, __schema
 * and __typename. __typename is special because it can always be
 * queried as a field, even in situations where no other fields
 * are allowed, like on a Union. __schema could get automatically
 * added to the query type, but that would require mutating type
 * definitions, which would cause issues.
 */


exports.defaultFieldResolver = defaultFieldResolver;

function getFieldDef(schema, parentType, fieldName) {
  if (fieldName === _introspection.SchemaMetaFieldDef.name && schema.getQueryType() === parentType) {
    return _introspection.SchemaMetaFieldDef;
  } else if (fieldName === _introspection.TypeMetaFieldDef.name && schema.getQueryType() === parentType) {
    return _introspection.TypeMetaFieldDef;
  } else if (fieldName === _introspection.TypeNameMetaFieldDef.name) {
    return _introspection.TypeNameMetaFieldDef;
  }

  return parentType.getFields()[fieldName];
}

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyToStringTag;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * The `applyToStringTag()` function checks first to see if the runtime
 * supports the `Symbol` class and then if the `Symbol.toStringTag` constant
 * is defined as a `Symbol` instance. If both conditions are met, the
 * Symbol.toStringTag property is defined as a getter that returns the
 * supplied class constructor's name.
 *
 * @method applyToStringTag
 *
 * @param {Class<any>} classObject a class such as Object, String, Number but
 * typically one of your own creation through the class keyword; `class A {}`,
 * for example.
 */
function applyToStringTag(classObject) {
  if (typeof Symbol === 'function' && Symbol.toStringTag) {
    Object.defineProperty(classObject.prototype, Symbol.toStringTag, {
      get: function get() {
        return this.constructor.name;
      }
    });
  }
}

/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isDefinitionNode = isDefinitionNode;
exports.isExecutableDefinitionNode = isExecutableDefinitionNode;
exports.isSelectionNode = isSelectionNode;
exports.isValueNode = isValueNode;
exports.isTypeNode = isTypeNode;
exports.isTypeSystemDefinitionNode = isTypeSystemDefinitionNode;
exports.isTypeDefinitionNode = isTypeDefinitionNode;
exports.isTypeSystemExtensionNode = isTypeSystemExtensionNode;
exports.isTypeExtensionNode = isTypeExtensionNode;

var _kinds = __webpack_require__(68);

/**
 * Copyright (c) 2018-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function isDefinitionNode(node) {
  return isExecutableDefinitionNode(node) || isTypeSystemDefinitionNode(node) || isTypeSystemExtensionNode(node);
}

function isExecutableDefinitionNode(node) {
  return node.kind === _kinds.Kind.OPERATION_DEFINITION || node.kind === _kinds.Kind.FRAGMENT_DEFINITION;
}

function isSelectionNode(node) {
  return node.kind === _kinds.Kind.FIELD || node.kind === _kinds.Kind.FRAGMENT_SPREAD || node.kind === _kinds.Kind.INLINE_FRAGMENT;
}

function isValueNode(node) {
  return node.kind === _kinds.Kind.VARIABLE || node.kind === _kinds.Kind.INT || node.kind === _kinds.Kind.FLOAT || node.kind === _kinds.Kind.STRING || node.kind === _kinds.Kind.BOOLEAN || node.kind === _kinds.Kind.NULL || node.kind === _kinds.Kind.ENUM || node.kind === _kinds.Kind.LIST || node.kind === _kinds.Kind.OBJECT;
}

function isTypeNode(node) {
  return node.kind === _kinds.Kind.NAMED_TYPE || node.kind === _kinds.Kind.LIST_TYPE || node.kind === _kinds.Kind.NON_NULL_TYPE;
}

function isTypeSystemDefinitionNode(node) {
  return node.kind === _kinds.Kind.SCHEMA_DEFINITION || isTypeDefinitionNode(node) || node.kind === _kinds.Kind.DIRECTIVE_DEFINITION;
}

function isTypeDefinitionNode(node) {
  return node.kind === _kinds.Kind.SCALAR_TYPE_DEFINITION || node.kind === _kinds.Kind.OBJECT_TYPE_DEFINITION || node.kind === _kinds.Kind.INTERFACE_TYPE_DEFINITION || node.kind === _kinds.Kind.UNION_TYPE_DEFINITION || node.kind === _kinds.Kind.ENUM_TYPE_DEFINITION || node.kind === _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION;
}

function isTypeSystemExtensionNode(node) {
  return node.kind === _kinds.Kind.SCHEMA_EXTENSION || isTypeExtensionNode(node);
}

function isTypeExtensionNode(node) {
  return node.kind === _kinds.Kind.SCALAR_TYPE_EXTENSION || node.kind === _kinds.Kind.OBJECT_TYPE_EXTENSION || node.kind === _kinds.Kind.INTERFACE_TYPE_EXTENSION || node.kind === _kinds.Kind.UNION_TYPE_EXTENSION || node.kind === _kinds.Kind.ENUM_TYPE_EXTENSION || node.kind === _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION;
}

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateSchema = validateSchema;
exports.assertValidSchema = assertValidSchema;

var _definition = __webpack_require__(54);

var _directives = __webpack_require__(136);

var _introspection = __webpack_require__(166);

var _schema = __webpack_require__(246);

var _inspect = _interopRequireDefault(__webpack_require__(93));

var _find = _interopRequireDefault(__webpack_require__(342));

var _invariant = _interopRequireDefault(__webpack_require__(108));

var _objectValues = _interopRequireDefault(__webpack_require__(205));

var _GraphQLError = __webpack_require__(37);

var _assertValidName = __webpack_require__(1209);

var _typeComparators = __webpack_require__(441);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Implements the "Type Validation" sub-sections of the specification's
 * "Type System" section.
 *
 * Validation runs synchronously, returning an array of encountered errors, or
 * an empty array if no errors were encountered and the Schema is valid.
 */
function validateSchema(schema) {
  // First check to ensure the provided value is in fact a GraphQLSchema.
  !(0, _schema.isSchema)(schema) ? (0, _invariant.default)(0, "Expected ".concat((0, _inspect.default)(schema), " to be a GraphQL schema.")) : void 0; // If this Schema has already been validated, return the previous results.

  if (schema.__validationErrors) {
    return schema.__validationErrors;
  } // Validate the schema, producing a list of errors.


  var context = new SchemaValidationContext(schema);
  validateRootTypes(context);
  validateDirectives(context);
  validateTypes(context); // Persist the results of validation before returning to ensure validation
  // does not run multiple times for this schema.

  var errors = context.getErrors();
  schema.__validationErrors = errors;
  return errors;
}
/**
 * Utility function which asserts a schema is valid by throwing an error if
 * it is invalid.
 */


function assertValidSchema(schema) {
  var errors = validateSchema(schema);

  if (errors.length !== 0) {
    throw new Error(errors.map(function (error) {
      return error.message;
    }).join('\n\n'));
  }
}

var SchemaValidationContext =
/*#__PURE__*/
function () {
  function SchemaValidationContext(schema) {
    _defineProperty(this, "_errors", void 0);

    _defineProperty(this, "schema", void 0);

    this._errors = [];
    this.schema = schema;
  }

  var _proto = SchemaValidationContext.prototype;

  _proto.reportError = function reportError(message, nodes) {
    var _nodes = (Array.isArray(nodes) ? nodes : [nodes]).filter(Boolean);

    this.addError(new _GraphQLError.GraphQLError(message, _nodes));
  };

  _proto.addError = function addError(error) {
    this._errors.push(error);
  };

  _proto.getErrors = function getErrors() {
    return this._errors;
  };

  return SchemaValidationContext;
}();

function validateRootTypes(context) {
  var schema = context.schema;
  var queryType = schema.getQueryType();

  if (!queryType) {
    context.reportError("Query root type must be provided.", schema.astNode);
  } else if (!(0, _definition.isObjectType)(queryType)) {
    context.reportError("Query root type must be Object type, it cannot be ".concat((0, _inspect.default)(queryType), "."), getOperationTypeNode(schema, queryType, 'query'));
  }

  var mutationType = schema.getMutationType();

  if (mutationType && !(0, _definition.isObjectType)(mutationType)) {
    context.reportError('Mutation root type must be Object type if provided, it cannot be ' + "".concat((0, _inspect.default)(mutationType), "."), getOperationTypeNode(schema, mutationType, 'mutation'));
  }

  var subscriptionType = schema.getSubscriptionType();

  if (subscriptionType && !(0, _definition.isObjectType)(subscriptionType)) {
    context.reportError('Subscription root type must be Object type if provided, it cannot be ' + "".concat((0, _inspect.default)(subscriptionType), "."), getOperationTypeNode(schema, subscriptionType, 'subscription'));
  }
}

function getOperationTypeNode(schema, type, operation) {
  var operationNodes = getAllSubNodes(schema, function (node) {
    return node.operationTypes;
  });
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = operationNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var node = _step.value;

      if (node.operation === operation) {
        return node.type;
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return type.astNode;
}

function validateDirectives(context) {
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = context.schema.getDirectives()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var directive = _step2.value;

      // Ensure all directives are in fact GraphQL directives.
      if (!(0, _directives.isDirective)(directive)) {
        context.reportError("Expected directive but got: ".concat((0, _inspect.default)(directive), "."), directive && directive.astNode);
        continue;
      } // Ensure they are named correctly.


      validateName(context, directive); // TODO: Ensure proper locations.
      // Ensure the arguments are valid.

      var argNames = Object.create(null);
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = directive.args[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var arg = _step3.value;
          var argName = arg.name; // Ensure they are named correctly.

          validateName(context, arg); // Ensure they are unique per directive.

          if (argNames[argName]) {
            context.reportError("Argument @".concat(directive.name, "(").concat(argName, ":) can only be defined once."), getAllDirectiveArgNodes(directive, argName));
            continue;
          }

          argNames[argName] = true; // Ensure the type is an input type.

          if (!(0, _definition.isInputType)(arg.type)) {
            context.reportError("The type of @".concat(directive.name, "(").concat(argName, ":) must be Input Type ") + "but got: ".concat((0, _inspect.default)(arg.type), "."), getDirectiveArgTypeNode(directive, argName));
          }
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }
}

function validateName(context, node) {
  // If a schema explicitly allows some legacy name which is no longer valid,
  // allow it to be assumed valid.
  if (context.schema.__allowedLegacyNames.indexOf(node.name) !== -1) {
    return;
  } // Ensure names are valid, however introspection types opt out.


  var error = (0, _assertValidName.isValidNameError)(node.name, node.astNode || undefined);

  if (error) {
    context.addError(error);
  }
}

function validateTypes(context) {
  var typeMap = context.schema.getTypeMap();
  var _iteratorNormalCompletion4 = true;
  var _didIteratorError4 = false;
  var _iteratorError4 = undefined;

  try {
    for (var _iterator4 = (0, _objectValues.default)(typeMap)[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
      var type = _step4.value;

      // Ensure all provided types are in fact GraphQL type.
      if (!(0, _definition.isNamedType)(type)) {
        context.reportError("Expected GraphQL named type but got: ".concat((0, _inspect.default)(type), "."), type && type.astNode);
        continue;
      } // Ensure it is named correctly (excluding introspection types).


      if (!(0, _introspection.isIntrospectionType)(type)) {
        validateName(context, type);
      }

      if ((0, _definition.isObjectType)(type)) {
        // Ensure fields are valid
        validateFields(context, type); // Ensure objects implement the interfaces they claim to.

        validateObjectInterfaces(context, type);
      } else if ((0, _definition.isInterfaceType)(type)) {
        // Ensure fields are valid.
        validateFields(context, type);
      } else if ((0, _definition.isUnionType)(type)) {
        // Ensure Unions include valid member types.
        validateUnionMembers(context, type);
      } else if ((0, _definition.isEnumType)(type)) {
        // Ensure Enums have valid values.
        validateEnumValues(context, type);
      } else if ((0, _definition.isInputObjectType)(type)) {
        // Ensure Input Object fields are valid.
        validateInputFields(context, type);
      }
    }
  } catch (err) {
    _didIteratorError4 = true;
    _iteratorError4 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
        _iterator4.return();
      }
    } finally {
      if (_didIteratorError4) {
        throw _iteratorError4;
      }
    }
  }
}

function validateFields(context, type) {
  var fields = (0, _objectValues.default)(type.getFields()); // Objects and Interfaces both must define one or more fields.

  if (fields.length === 0) {
    context.reportError("Type ".concat(type.name, " must define one or more fields."), getAllNodes(type));
  }

  var _iteratorNormalCompletion5 = true;
  var _didIteratorError5 = false;
  var _iteratorError5 = undefined;

  try {
    for (var _iterator5 = fields[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
      var field = _step5.value;
      // Ensure they are named correctly.
      validateName(context, field); // Ensure they were defined at most once.

      var fieldNodes = getAllFieldNodes(type, field.name);

      if (fieldNodes.length > 1) {
        context.reportError("Field ".concat(type.name, ".").concat(field.name, " can only be defined once."), fieldNodes);
        continue;
      } // Ensure the type is an output type


      if (!(0, _definition.isOutputType)(field.type)) {
        context.reportError("The type of ".concat(type.name, ".").concat(field.name, " must be Output Type ") + "but got: ".concat((0, _inspect.default)(field.type), "."), getFieldTypeNode(type, field.name));
      } // Ensure the arguments are valid


      var argNames = Object.create(null);
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = field.args[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var arg = _step6.value;
          var argName = arg.name; // Ensure they are named correctly.

          validateName(context, arg); // Ensure they are unique per field.

          if (argNames[argName]) {
            context.reportError("Field argument ".concat(type.name, ".").concat(field.name, "(").concat(argName, ":) can only ") + 'be defined once.', getAllFieldArgNodes(type, field.name, argName));
          }

          argNames[argName] = true; // Ensure the type is an input type

          if (!(0, _definition.isInputType)(arg.type)) {
            context.reportError("The type of ".concat(type.name, ".").concat(field.name, "(").concat(argName, ":) must be Input ") + "Type but got: ".concat((0, _inspect.default)(arg.type), "."), getFieldArgTypeNode(type, field.name, argName));
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError5 = true;
    _iteratorError5 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
        _iterator5.return();
      }
    } finally {
      if (_didIteratorError5) {
        throw _iteratorError5;
      }
    }
  }
}

function validateObjectInterfaces(context, object) {
  var implementedTypeNames = Object.create(null);
  var _iteratorNormalCompletion7 = true;
  var _didIteratorError7 = false;
  var _iteratorError7 = undefined;

  try {
    for (var _iterator7 = object.getInterfaces()[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
      var iface = _step7.value;

      if (!(0, _definition.isInterfaceType)(iface)) {
        context.reportError("Type ".concat((0, _inspect.default)(object), " must only implement Interface types, ") + "it cannot implement ".concat((0, _inspect.default)(iface), "."), getImplementsInterfaceNode(object, iface));
        continue;
      }

      if (implementedTypeNames[iface.name]) {
        context.reportError("Type ".concat(object.name, " can only implement ").concat(iface.name, " once."), getAllImplementsInterfaceNodes(object, iface));
        continue;
      }

      implementedTypeNames[iface.name] = true;
      validateObjectImplementsInterface(context, object, iface);
    }
  } catch (err) {
    _didIteratorError7 = true;
    _iteratorError7 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
        _iterator7.return();
      }
    } finally {
      if (_didIteratorError7) {
        throw _iteratorError7;
      }
    }
  }
}

function validateObjectImplementsInterface(context, object, iface) {
  var objectFieldMap = object.getFields();
  var ifaceFieldMap = iface.getFields(); // Assert each interface field is implemented.

  var _arr = Object.keys(ifaceFieldMap);

  for (var _i = 0; _i < _arr.length; _i++) {
    var fieldName = _arr[_i];
    var objectField = objectFieldMap[fieldName];
    var ifaceField = ifaceFieldMap[fieldName]; // Assert interface field exists on object.

    if (!objectField) {
      context.reportError("Interface field ".concat(iface.name, ".").concat(fieldName, " expected but ") + "".concat(object.name, " does not provide it."), [getFieldNode(iface, fieldName)].concat(getAllNodes(object)));
      continue;
    } // Assert interface field type is satisfied by object field type, by being
    // a valid subtype. (covariant)


    if (!(0, _typeComparators.isTypeSubTypeOf)(context.schema, objectField.type, ifaceField.type)) {
      context.reportError("Interface field ".concat(iface.name, ".").concat(fieldName, " expects type ") + "".concat((0, _inspect.default)(ifaceField.type), " but ").concat(object.name, ".").concat(fieldName, " ") + "is type ".concat((0, _inspect.default)(objectField.type), "."), [getFieldTypeNode(iface, fieldName), getFieldTypeNode(object, fieldName)]);
    } // Assert each interface field arg is implemented.


    var _iteratorNormalCompletion8 = true;
    var _didIteratorError8 = false;
    var _iteratorError8 = undefined;

    try {
      var _loop = function _loop() {
        var ifaceArg = _step8.value;
        var argName = ifaceArg.name;
        var objectArg = (0, _find.default)(objectField.args, function (arg) {
          return arg.name === argName;
        }); // Assert interface field arg exists on object field.

        if (!objectArg) {
          context.reportError("Interface field argument ".concat(iface.name, ".").concat(fieldName, "(").concat(argName, ":) ") + "expected but ".concat(object.name, ".").concat(fieldName, " does not provide it."), [getFieldArgNode(iface, fieldName, argName), getFieldNode(object, fieldName)]);
          return "continue";
        } // Assert interface field arg type matches object field arg type.
        // (invariant)
        // TODO: change to contravariant?


        if (!(0, _typeComparators.isEqualType)(ifaceArg.type, objectArg.type)) {
          context.reportError("Interface field argument ".concat(iface.name, ".").concat(fieldName, "(").concat(argName, ":) ") + "expects type ".concat((0, _inspect.default)(ifaceArg.type), " but ") + "".concat(object.name, ".").concat(fieldName, "(").concat(argName, ":) is type ") + "".concat((0, _inspect.default)(objectArg.type), "."), [getFieldArgTypeNode(iface, fieldName, argName), getFieldArgTypeNode(object, fieldName, argName)]);
        } // TODO: validate default values?

      };

      for (var _iterator8 = ifaceField.args[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
        var _ret = _loop();

        if (_ret === "continue") continue;
      } // Assert additional arguments must not be required.

    } catch (err) {
      _didIteratorError8 = true;
      _iteratorError8 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
          _iterator8.return();
        }
      } finally {
        if (_didIteratorError8) {
          throw _iteratorError8;
        }
      }
    }

    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
      var _loop2 = function _loop2() {
        var objectArg = _step9.value;
        var argName = objectArg.name;
        var ifaceArg = (0, _find.default)(ifaceField.args, function (arg) {
          return arg.name === argName;
        });

        if (!ifaceArg && (0, _definition.isRequiredArgument)(objectArg)) {
          context.reportError("Object field ".concat(object.name, ".").concat(fieldName, " includes required ") + "argument ".concat(argName, " that is missing from the Interface field ") + "".concat(iface.name, ".").concat(fieldName, "."), [getFieldArgNode(object, fieldName, argName), getFieldNode(iface, fieldName)]);
        }
      };

      for (var _iterator9 = objectField.args[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
        _loop2();
      }
    } catch (err) {
      _didIteratorError9 = true;
      _iteratorError9 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
          _iterator9.return();
        }
      } finally {
        if (_didIteratorError9) {
          throw _iteratorError9;
        }
      }
    }
  }
}

function validateUnionMembers(context, union) {
  var memberTypes = union.getTypes();

  if (memberTypes.length === 0) {
    context.reportError("Union type ".concat(union.name, " must define one or more member types."), getAllNodes(union));
  }

  var includedTypeNames = Object.create(null);
  var _iteratorNormalCompletion10 = true;
  var _didIteratorError10 = false;
  var _iteratorError10 = undefined;

  try {
    for (var _iterator10 = memberTypes[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
      var memberType = _step10.value;

      if (includedTypeNames[memberType.name]) {
        context.reportError("Union type ".concat(union.name, " can only include type ") + "".concat(memberType.name, " once."), getUnionMemberTypeNodes(union, memberType.name));
        continue;
      }

      includedTypeNames[memberType.name] = true;

      if (!(0, _definition.isObjectType)(memberType)) {
        context.reportError("Union type ".concat(union.name, " can only include Object types, ") + "it cannot include ".concat((0, _inspect.default)(memberType), "."), getUnionMemberTypeNodes(union, String(memberType)));
      }
    }
  } catch (err) {
    _didIteratorError10 = true;
    _iteratorError10 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
        _iterator10.return();
      }
    } finally {
      if (_didIteratorError10) {
        throw _iteratorError10;
      }
    }
  }
}

function validateEnumValues(context, enumType) {
  var enumValues = enumType.getValues();

  if (enumValues.length === 0) {
    context.reportError("Enum type ".concat(enumType.name, " must define one or more values."), getAllNodes(enumType));
  }

  var _iteratorNormalCompletion11 = true;
  var _didIteratorError11 = false;
  var _iteratorError11 = undefined;

  try {
    for (var _iterator11 = enumValues[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
      var enumValue = _step11.value;
      var valueName = enumValue.name; // Ensure no duplicates.

      var allNodes = getEnumValueNodes(enumType, valueName);

      if (allNodes && allNodes.length > 1) {
        context.reportError("Enum type ".concat(enumType.name, " can include value ").concat(valueName, " only once."), allNodes);
      } // Ensure valid name.


      validateName(context, enumValue);

      if (valueName === 'true' || valueName === 'false' || valueName === 'null') {
        context.reportError("Enum type ".concat(enumType.name, " cannot include value: ").concat(valueName, "."), enumValue.astNode);
      }
    }
  } catch (err) {
    _didIteratorError11 = true;
    _iteratorError11 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
        _iterator11.return();
      }
    } finally {
      if (_didIteratorError11) {
        throw _iteratorError11;
      }
    }
  }
}

function validateInputFields(context, inputObj) {
  var fields = (0, _objectValues.default)(inputObj.getFields());

  if (fields.length === 0) {
    context.reportError("Input Object type ".concat(inputObj.name, " must define one or more fields."), getAllNodes(inputObj));
  } // Ensure the arguments are valid


  var _iteratorNormalCompletion12 = true;
  var _didIteratorError12 = false;
  var _iteratorError12 = undefined;

  try {
    for (var _iterator12 = fields[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
      var field = _step12.value;
      // Ensure they are named correctly.
      validateName(context, field); // TODO: Ensure they are unique per field.
      // Ensure the type is an input type

      if (!(0, _definition.isInputType)(field.type)) {
        context.reportError("The type of ".concat(inputObj.name, ".").concat(field.name, " must be Input Type ") + "but got: ".concat((0, _inspect.default)(field.type), "."), field.astNode && field.astNode.type);
      }
    }
  } catch (err) {
    _didIteratorError12 = true;
    _iteratorError12 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
        _iterator12.return();
      }
    } finally {
      if (_didIteratorError12) {
        throw _iteratorError12;
      }
    }
  }
}

function getAllNodes(object) {
  var astNode = object.astNode,
      extensionASTNodes = object.extensionASTNodes;
  return astNode ? extensionASTNodes ? [astNode].concat(extensionASTNodes) : [astNode] : extensionASTNodes || [];
}

function getAllSubNodes(object, getter) {
  var result = [];
  var _iteratorNormalCompletion13 = true;
  var _didIteratorError13 = false;
  var _iteratorError13 = undefined;

  try {
    for (var _iterator13 = getAllNodes(object)[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
      var astNode = _step13.value;

      if (astNode) {
        var subNodes = getter(astNode);

        if (subNodes) {
          result = result.concat(subNodes);
        }
      }
    }
  } catch (err) {
    _didIteratorError13 = true;
    _iteratorError13 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
        _iterator13.return();
      }
    } finally {
      if (_didIteratorError13) {
        throw _iteratorError13;
      }
    }
  }

  return result;
}

function getImplementsInterfaceNode(type, iface) {
  return getAllImplementsInterfaceNodes(type, iface)[0];
}

function getAllImplementsInterfaceNodes(type, iface) {
  return getAllSubNodes(type, function (typeNode) {
    return typeNode.interfaces;
  }).filter(function (ifaceNode) {
    return ifaceNode.name.value === iface.name;
  });
}

function getFieldNode(type, fieldName) {
  return getAllFieldNodes(type, fieldName)[0];
}

function getAllFieldNodes(type, fieldName) {
  return getAllSubNodes(type, function (typeNode) {
    return typeNode.fields;
  }).filter(function (fieldNode) {
    return fieldNode.name.value === fieldName;
  });
}

function getFieldTypeNode(type, fieldName) {
  var fieldNode = getFieldNode(type, fieldName);
  return fieldNode && fieldNode.type;
}

function getFieldArgNode(type, fieldName, argName) {
  return getAllFieldArgNodes(type, fieldName, argName)[0];
}

function getAllFieldArgNodes(type, fieldName, argName) {
  var argNodes = [];
  var fieldNode = getFieldNode(type, fieldName);

  if (fieldNode && fieldNode.arguments) {
    var _iteratorNormalCompletion14 = true;
    var _didIteratorError14 = false;
    var _iteratorError14 = undefined;

    try {
      for (var _iterator14 = fieldNode.arguments[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
        var node = _step14.value;

        if (node.name.value === argName) {
          argNodes.push(node);
        }
      }
    } catch (err) {
      _didIteratorError14 = true;
      _iteratorError14 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
          _iterator14.return();
        }
      } finally {
        if (_didIteratorError14) {
          throw _iteratorError14;
        }
      }
    }
  }

  return argNodes;
}

function getFieldArgTypeNode(type, fieldName, argName) {
  var fieldArgNode = getFieldArgNode(type, fieldName, argName);
  return fieldArgNode && fieldArgNode.type;
}

function getAllDirectiveArgNodes(directive, argName) {
  return getAllSubNodes(directive, function (directiveNode) {
    return directiveNode.arguments;
  }).filter(function (argNode) {
    return argNode.name.value === argName;
  });
}

function getDirectiveArgTypeNode(directive, argName) {
  var argNode = getAllDirectiveArgNodes(directive, argName)[0];
  return argNode && argNode.type;
}

function getUnionMemberTypeNodes(union, typeName) {
  return getAllSubNodes(union, function (unionNode) {
    return unionNode.types;
  }).filter(function (typeNode) {
    return typeNode.name.value === typeName;
  });
}

function getEnumValueNodes(enumType, valueName) {
  return getAllSubNodes(enumType, function (enumNode) {
    return enumNode.values;
  }).filter(function (valueNode) {
    return valueNode.name.value === valueName;
  });
}

/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEqualType = isEqualType;
exports.isTypeSubTypeOf = isTypeSubTypeOf;
exports.doTypesOverlap = doTypesOverlap;

var _definition = __webpack_require__(54);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Provided two types, return true if the types are equal (invariant).
 */
function isEqualType(typeA, typeB) {
  // Equivalent types are equal.
  if (typeA === typeB) {
    return true;
  } // If either type is non-null, the other must also be non-null.


  if ((0, _definition.isNonNullType)(typeA) && (0, _definition.isNonNullType)(typeB)) {
    return isEqualType(typeA.ofType, typeB.ofType);
  } // If either type is a list, the other must also be a list.


  if ((0, _definition.isListType)(typeA) && (0, _definition.isListType)(typeB)) {
    return isEqualType(typeA.ofType, typeB.ofType);
  } // Otherwise the types are not equal.


  return false;
}
/**
 * Provided a type and a super type, return true if the first type is either
 * equal or a subset of the second super type (covariant).
 */


function isTypeSubTypeOf(schema, maybeSubType, superType) {
  // Equivalent type is a valid subtype
  if (maybeSubType === superType) {
    return true;
  } // If superType is non-null, maybeSubType must also be non-null.


  if ((0, _definition.isNonNullType)(superType)) {
    if ((0, _definition.isNonNullType)(maybeSubType)) {
      return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
    }

    return false;
  }

  if ((0, _definition.isNonNullType)(maybeSubType)) {
    // If superType is nullable, maybeSubType may be non-null or nullable.
    return isTypeSubTypeOf(schema, maybeSubType.ofType, superType);
  } // If superType type is a list, maybeSubType type must also be a list.


  if ((0, _definition.isListType)(superType)) {
    if ((0, _definition.isListType)(maybeSubType)) {
      return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
    }

    return false;
  }

  if ((0, _definition.isListType)(maybeSubType)) {
    // If superType is not a list, maybeSubType must also be not a list.
    return false;
  } // If superType type is an abstract type, maybeSubType type may be a currently
  // possible object type.


  if ((0, _definition.isAbstractType)(superType) && (0, _definition.isObjectType)(maybeSubType) && schema.isPossibleType(superType, maybeSubType)) {
    return true;
  } // Otherwise, the child type is not a valid subtype of the parent type.


  return false;
}
/**
 * Provided two composite types, determine if they "overlap". Two composite
 * types overlap when the Sets of possible concrete types for each intersect.
 *
 * This is often used to determine if a fragment of a given type could possibly
 * be visited in a context of another type.
 *
 * This function is commutative.
 */


function doTypesOverlap(schema, typeA, typeB) {
  // Equivalent types overlap
  if (typeA === typeB) {
    return true;
  }

  if ((0, _definition.isAbstractType)(typeA)) {
    if ((0, _definition.isAbstractType)(typeB)) {
      // If both types are abstract, then determine if there is any intersection
      // between possible concrete types of each.
      return schema.getPossibleTypes(typeA).some(function (type) {
        return schema.isPossibleType(typeB, type);
      });
    } // Determine if the latter type is a possible concrete type of the former.


    return schema.isPossibleType(typeA, typeB);
  }

  if ((0, _definition.isAbstractType)(typeB)) {
    // Determine if the former type is a possible concrete type of the latter.
    return schema.isPossibleType(typeB, typeA);
  } // Otherwise the types do not overlap.


  return false;
}

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.valueFromAST = valueFromAST;

var _keyMap = _interopRequireDefault(__webpack_require__(183));

var _isInvalid = _interopRequireDefault(__webpack_require__(204));

var _objectValues = _interopRequireDefault(__webpack_require__(205));

var _kinds = __webpack_require__(68);

var _definition = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Produces a JavaScript value given a GraphQL Value AST.
 *
 * A GraphQL type must be provided, which will be used to interpret different
 * GraphQL Value literals.
 *
 * Returns `undefined` when the value could not be validly coerced according to
 * the provided type.
 *
 * | GraphQL Value        | JSON Value    |
 * | -------------------- | ------------- |
 * | Input Object         | Object        |
 * | List                 | Array         |
 * | Boolean              | Boolean       |
 * | String               | String        |
 * | Int / Float          | Number        |
 * | Enum Value           | Mixed         |
 * | NullValue            | null          |
 *
 */
function valueFromAST(valueNode, type, variables) {
  if (!valueNode) {
    // When there is no node, then there is also no value.
    // Importantly, this is different from returning the value null.
    return;
  }

  if ((0, _definition.isNonNullType)(type)) {
    if (valueNode.kind === _kinds.Kind.NULL) {
      return; // Invalid: intentionally return no value.
    }

    return valueFromAST(valueNode, type.ofType, variables);
  }

  if (valueNode.kind === _kinds.Kind.NULL) {
    // This is explicitly returning the value null.
    return null;
  }

  if (valueNode.kind === _kinds.Kind.VARIABLE) {
    var variableName = valueNode.name.value;

    if (!variables || (0, _isInvalid.default)(variables[variableName])) {
      // No valid return value.
      return;
    }

    var variableValue = variables[variableName];

    if (variableValue === null && (0, _definition.isNonNullType)(type)) {
      return; // Invalid: intentionally return no value.
    } // Note: This does no further checking that this variable is correct.
    // This assumes that this query has been validated and the variable
    // usage here is of the correct type.


    return variableValue;
  }

  if ((0, _definition.isListType)(type)) {
    var itemType = type.ofType;

    if (valueNode.kind === _kinds.Kind.LIST) {
      var coercedValues = [];
      var itemNodes = valueNode.values;

      for (var i = 0; i < itemNodes.length; i++) {
        if (isMissingVariable(itemNodes[i], variables)) {
          // If an array contains a missing variable, it is either coerced to
          // null or if the item type is non-null, it considered invalid.
          if ((0, _definition.isNonNullType)(itemType)) {
            return; // Invalid: intentionally return no value.
          }

          coercedValues.push(null);
        } else {
          var itemValue = valueFromAST(itemNodes[i], itemType, variables);

          if ((0, _isInvalid.default)(itemValue)) {
            return; // Invalid: intentionally return no value.
          }

          coercedValues.push(itemValue);
        }
      }

      return coercedValues;
    }

    var coercedValue = valueFromAST(valueNode, itemType, variables);

    if ((0, _isInvalid.default)(coercedValue)) {
      return; // Invalid: intentionally return no value.
    }

    return [coercedValue];
  }

  if ((0, _definition.isInputObjectType)(type)) {
    if (valueNode.kind !== _kinds.Kind.OBJECT) {
      return; // Invalid: intentionally return no value.
    }

    var coercedObj = Object.create(null);
    var fieldNodes = (0, _keyMap.default)(valueNode.fields, function (field) {
      return field.name.value;
    });
    var fields = (0, _objectValues.default)(type.getFields());

    for (var _i = 0; _i < fields.length; _i++) {
      var field = fields[_i];
      var fieldNode = fieldNodes[field.name];

      if (!fieldNode || isMissingVariable(fieldNode.value, variables)) {
        if (field.defaultValue !== undefined) {
          coercedObj[field.name] = field.defaultValue;
        } else if ((0, _definition.isNonNullType)(field.type)) {
          return; // Invalid: intentionally return no value.
        }

        continue;
      }

      var fieldValue = valueFromAST(fieldNode.value, field.type, variables);

      if ((0, _isInvalid.default)(fieldValue)) {
        return; // Invalid: intentionally return no value.
      }

      coercedObj[field.name] = fieldValue;
    }

    return coercedObj;
  }

  if ((0, _definition.isEnumType)(type)) {
    if (valueNode.kind !== _kinds.Kind.ENUM) {
      return; // Invalid: intentionally return no value.
    }

    var enumValue = type.getValue(valueNode.value);

    if (!enumValue) {
      return; // Invalid: intentionally return no value.
    }

    return enumValue.value;
  }

  if ((0, _definition.isScalarType)(type)) {
    // Scalars fulfill parsing a literal value via parseLiteral().
    // Invalid values represent a failure to parse correctly, in which case
    // no value is returned.
    var result;

    try {
      result = type.parseLiteral(valueNode, variables);
    } catch (_error) {
      return; // Invalid: intentionally return no value.
    }

    if ((0, _isInvalid.default)(result)) {
      return; // Invalid: intentionally return no value.
    }

    return result;
  }
  /* istanbul ignore next */


  throw new Error("Unknown type: ".concat(type, "."));
} // Returns true if the provided valueNode is a variable which is not defined
// in the set of variables.


function isMissingVariable(valueNode, variables) {
  return valueNode.kind === _kinds.Kind.VARIABLE && (!variables || (0, _isInvalid.default)(variables[valueNode.name.value]));
}

/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = validate;
exports.validateSDL = validateSDL;
exports.assertValidSDL = assertValidSDL;
exports.assertValidSDLExtension = assertValidSDLExtension;

var _invariant = _interopRequireDefault(__webpack_require__(108));

var _visitor = __webpack_require__(245);

var _validate = __webpack_require__(440);

var _TypeInfo = __webpack_require__(346);

var _specifiedRules = __webpack_require__(1237);

var _ValidationContext = __webpack_require__(668);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Implements the "Validation" section of the spec.
 *
 * Validation runs synchronously, returning an array of encountered errors, or
 * an empty array if no errors were encountered and the document is valid.
 *
 * A list of specific validation rules may be provided. If not provided, the
 * default list of rules defined by the GraphQL specification will be used.
 *
 * Each validation rules is a function which returns a visitor
 * (see the language/visitor API). Visitor methods are expected to return
 * GraphQLErrors, or Arrays of GraphQLErrors when invalid.
 *
 * Optionally a custom TypeInfo instance may be provided. If not provided, one
 * will be created from the provided schema.
 */
function validate(schema, documentAST) {
  var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _specifiedRules.specifiedRules;
  var typeInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new _TypeInfo.TypeInfo(schema);
  !documentAST ? (0, _invariant.default)(0, 'Must provide document') : void 0; // If the schema used for validation is invalid, throw an error.

  (0, _validate.assertValidSchema)(schema);
  var context = new _ValidationContext.ValidationContext(schema, documentAST, typeInfo); // This uses a specialized visitor which runs multiple visitors in parallel,
  // while maintaining the visitor skip and break API.

  var visitor = (0, _visitor.visitInParallel)(rules.map(function (rule) {
    return rule(context);
  })); // Visit the whole document with each instance of all provided rules.

  (0, _visitor.visit)(documentAST, (0, _visitor.visitWithTypeInfo)(typeInfo, visitor));
  return context.getErrors();
} // @internal


function validateSDL(documentAST, schemaToExtend) {
  var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _specifiedRules.specifiedSDLRules;
  var context = new _ValidationContext.SDLValidationContext(documentAST, schemaToExtend);
  var visitors = rules.map(function (rule) {
    return rule(context);
  });
  (0, _visitor.visit)(documentAST, (0, _visitor.visitInParallel)(visitors));
  return context.getErrors();
}
/**
 * Utility function which asserts a SDL document is valid by throwing an error
 * if it is invalid.
 *
 * @internal
 */


function assertValidSDL(documentAST) {
  var errors = validateSDL(documentAST);

  if (errors.length !== 0) {
    throw new Error(errors.map(function (error) {
      return error.message;
    }).join('\n\n'));
  }
}
/**
 * Utility function which asserts a SDL document is valid by throwing an error
 * if it is invalid.
 *
 * @internal
 */


function assertValidSDLExtension(documentAST, schema) {
  var errors = validateSDL(documentAST, schema);

  if (errors.length !== 0) {
    throw new Error(errors.map(function (error) {
      return error.message;
    }).join('\n\n'));
  }
}

/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
/**
 * Indicates that navigation was caused by a call to history.push.
 */
var PUSH = exports.PUSH = 'PUSH';

/**
 * Indicates that navigation was caused by a call to history.replace.
 */
var REPLACE = exports.REPLACE = 'REPLACE';

/**
 * Indicates that navigation was caused by some other action such
 * as using a browser's back/forward buttons and/or manually manipulating
 * the URL in a browser's location bar. This is the default.
 *
 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
 * for more information.
 */
var POP = exports.POP = 'POP';

/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
};

var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
};

/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */
var supportsHistory = exports.supportsHistory = function supportsHistory() {
  var ua = window.navigator.userAgent;

  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;

  return window.history && 'pushState' in window.history;
};

/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */
var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
};

/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */
var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
};

/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */
var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
};

/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(3072),
    listCacheDelete = __webpack_require__(3073),
    listCacheGet = __webpack_require__(3074),
    listCacheHas = __webpack_require__(3075),
    listCacheSet = __webpack_require__(3076);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(1254);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(3069);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(285);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__draft_to_markdown__ = __webpack_require__(3101);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "draftToMarkdown", function() { return __WEBPACK_IMPORTED_MODULE_0__draft_to_markdown__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__markdown_to_draft__ = __webpack_require__(3102);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "markdownToDraft", function() { return __WEBPACK_IMPORTED_MODULE_1__markdown_to_draft__["a"]; });



/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var id = moment.defineLocale('id', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Besok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kemarin pukul] LT',
            lastWeek : 'dddd [lalu pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lalu',
            s : 'beberapa detik',
            ss : '%d detik',
            m : 'semenit',
            mm : '%d menit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return id;

})));


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var vi = moment.defineLocale('vi', {
        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
        monthsParseExact : true,
        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /sa|ch/i,
        isPM : function (input) {
            return /^ch$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [năm] YYYY',
            LLL : 'D MMMM [năm] YYYY HH:mm',
            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
            l : 'DD/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần rồi lúc] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s tới',
            past : '%s trước',
            s : 'vài giây',
            ss : '%d giây' ,
            m : 'một phút',
            mm : '%d phút',
            h : 'một giờ',
            hh : '%d giờ',
            d : 'một ngày',
            dd : '%d ngày',
            M : 'một tháng',
            MM : '%d tháng',
            y : 'một năm',
            yy : '%d năm'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return vi;

})));


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(3562);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof global !== 'undefined' && obj === global)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
}
function isArray(obj) { return toStr(obj) === '[object Array]' && canTrustToString(obj); }
function isDate(obj) { return toStr(obj) === '[object Date]' && canTrustToString(obj); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && canTrustToString(obj); }
function isError(obj) { return toStr(obj) === '[object Error]' && canTrustToString(obj); }
function isString(obj) { return toStr(obj) === '[object String]' && canTrustToString(obj); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && canTrustToString(obj); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && canTrustToString(obj); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(3119)
var aesid = __webpack_require__(3118)
var fixProc = __webpack_require__(3121)
var ciphers = __webpack_require__(600)
var compat = __webpack_require__(1388)
var Buffer = __webpack_require__(42).Buffer
module.exports = parseKeys

function parseKeys (buffer) {
  var password
  if (typeof buffer === 'object' && !Buffer.isBuffer(buffer)) {
    password = buffer.passphrase
    buffer = buffer.key
  }
  if (typeof buffer === 'string') {
    buffer = Buffer.from(buffer)
  }

  var stripped = fixProc(buffer, password)

  var type = stripped.tag
  var data = stripped.data
  var subtype, ndata
  switch (type) {
    case 'CERTIFICATE':
      ndata = asn1.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo
      // falls through
    case 'PUBLIC KEY':
      if (!ndata) {
        ndata = asn1.PublicKey.decode(data, 'der')
      }
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der')
        case '1.2.840.10045.2.1':
          ndata.subjectPrivateKey = ndata.subjectPublicKey
          return {
            type: 'ec',
            data: ndata
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.pub_key = asn1.DSAparam.decode(ndata.subjectPublicKey.data, 'der')
          return {
            type: 'dsa',
            data: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'ENCRYPTED PRIVATE KEY':
      data = asn1.EncryptedPrivateKey.decode(data, 'der')
      data = decrypt(data, password)
      // falls through
    case 'PRIVATE KEY':
      ndata = asn1.PrivateKey.decode(data, 'der')
      subtype = ndata.algorithm.algorithm.join('.')
      switch (subtype) {
        case '1.2.840.113549.1.1.1':
          return asn1.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der')
        case '1.2.840.10045.2.1':
          return {
            curve: ndata.algorithm.curve,
            privateKey: asn1.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
          }
        case '1.2.840.10040.4.1':
          ndata.algorithm.params.priv_key = asn1.DSAparam.decode(ndata.subjectPrivateKey, 'der')
          return {
            type: 'dsa',
            params: ndata.algorithm.params
          }
        default: throw new Error('unknown key id ' + subtype)
      }
      throw new Error('unknown key type ' + type)
    case 'RSA PUBLIC KEY':
      return asn1.RSAPublicKey.decode(data, 'der')
    case 'RSA PRIVATE KEY':
      return asn1.RSAPrivateKey.decode(data, 'der')
    case 'DSA PRIVATE KEY':
      return {
        type: 'dsa',
        params: asn1.DSAPrivateKey.decode(data, 'der')
      }
    case 'EC PRIVATE KEY':
      data = asn1.ECPrivateKey.decode(data, 'der')
      return {
        curve: data.parameters.value,
        privateKey: data.privateKey
      }
    default: throw new Error('unknown key type ' + type)
  }
}
parseKeys.signature = asn1.signature
function decrypt (data, password) {
  var salt = data.algorithm.decrypt.kde.kdeparams.salt
  var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10)
  var algo = aesid[data.algorithm.decrypt.cipher.algo.join('.')]
  var iv = data.algorithm.decrypt.cipher.iv
  var cipherText = data.subjectPrivateKey
  var keylen = parseInt(algo.split('-')[1], 10) / 8
  var key = compat.pbkdf2Sync(password, salt, iters, keylen, 'sha1')
  var cipher = ciphers.createDecipheriv(algo, key, iv)
  var out = []
  out.push(cipher.update(cipherText))
  out.push(cipher.final())
  return Buffer.concat(out)
}


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

if (typeof process === 'undefined' ||
    !process.version ||
    process.version.indexOf('v0.') === 0 ||
    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
  module.exports = { nextTick: nextTick };
} else {
  module.exports = process
}

function nextTick(fn, arg1, arg2, arg3) {
  if (typeof fn !== 'function') {
    throw new TypeError('"callback" argument must be a function');
  }
  var len = arguments.length;
  var args, i;
  switch (len) {
  case 0:
  case 1:
    return process.nextTick(fn);
  case 2:
    return process.nextTick(function afterTickOne() {
      fn.call(null, arg1);
    });
  case 3:
    return process.nextTick(function afterTickTwo() {
      fn.call(null, arg1, arg2);
    });
  case 4:
    return process.nextTick(function afterTickThree() {
      fn.call(null, arg1, arg2, arg3);
    });
  default:
    args = new Array(len - 1);
    i = 0;
    while (i < args.length) {
      args[i++] = arguments[i];
    }
    return process.nextTick(function afterTick() {
      fn.apply(null, args);
    });
  }
}


/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _mergeClassNames = _interopRequireDefault(__webpack_require__(1260));

var _propTypes2 = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Tile =
/*#__PURE__*/
function (_Component) {
  _inherits(Tile, _Component);

  function Tile() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tile);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tile)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    return _this;
  }

  _createClass(Tile, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          activeStartDate = _this$props.activeStartDate,
          children = _this$props.children,
          classes = _this$props.classes,
          date = _this$props.date,
          formatAbbr = _this$props.formatAbbr,
          locale = _this$props.locale,
          maxDate = _this$props.maxDate,
          maxDateTransform = _this$props.maxDateTransform,
          minDate = _this$props.minDate,
          minDateTransform = _this$props.minDateTransform,
          onClick = _this$props.onClick,
          onMouseOver = _this$props.onMouseOver,
          style = _this$props.style,
          tileDisabled = _this$props.tileDisabled,
          view = _this$props.view;
      var _this$state = this.state,
          tileClassName = _this$state.tileClassName,
          tileContent = _this$state.tileContent;
      return _react["default"].createElement("button", {
        className: (0, _mergeClassNames["default"])(classes, tileClassName),
        disabled: minDate && minDateTransform(minDate) > date || maxDate && maxDateTransform(maxDate) < date || tileDisabled && tileDisabled({
          activeStartDate: activeStartDate,
          date: date,
          view: view
        }),
        onClick: onClick && function () {
          return onClick(date);
        },
        onFocus: onMouseOver && function () {
          return onMouseOver(date);
        },
        onMouseOver: onMouseOver && function () {
          return onMouseOver(date);
        },
        style: style,
        type: "button"
      }, formatAbbr ? _react["default"].createElement("abbr", {
        "aria-label": formatAbbr(locale, date)
      }, children) : children, tileContent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var date = nextProps.date,
          tileClassName = nextProps.tileClassName,
          tileContent = nextProps.tileContent,
          view = nextProps.view;
      var nextState = {};

      if (tileClassName !== prevState.tileClassNameProps) {
        nextState.tileClassName = typeof tileClassName === 'function' ? tileClassName({
          date: date,
          view: view
        }) : tileClassName;
        nextState.tileClassNameProps = tileClassName;
      }

      if (tileContent !== prevState.tileContentProps) {
        nextState.tileContent = typeof tileContent === 'function' ? tileContent({
          date: date,
          view: view
        }) : tileContent;
        nextState.tileContentProps = tileContent;
      }

      return nextState;
    }
  }]);

  return Tile;
}(_react.Component);

exports["default"] = Tile;
Tile.propTypes = _objectSpread({}, _propTypes2.tileProps, {
  children: _propTypes["default"].node.isRequired,
  formatAbbr: _propTypes["default"].func,
  maxDateTransform: _propTypes["default"].func.isRequired,
  minDateTransform: _propTypes["default"].func.isRequired
});

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TileGroup;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _Flex = _interopRequireDefault(__webpack_require__(685));

var _utils = __webpack_require__(1406);

var _propTypes2 = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function TileGroup(_ref) {
  var className = _ref.className,
      count = _ref.count,
      dateTransform = _ref.dateTransform,
      dateType = _ref.dateType,
      end = _ref.end,
      hover = _ref.hover,
      offset = _ref.offset,
      start = _ref.start,
      step = _ref.step,
      Tile = _ref.tile,
      value = _ref.value,
      valueType = _ref.valueType,
      tileProps = _objectWithoutProperties(_ref, ["className", "count", "dateTransform", "dateType", "end", "hover", "offset", "start", "step", "tile", "value", "valueType"]);

  var tiles = [];

  for (var point = start; point <= end; point += step) {
    var date = dateTransform(point);
    tiles.push(_react["default"].createElement(Tile, _extends({
      key: date.getTime(),
      classes: (0, _utils.getTileClasses)({
        value: value,
        valueType: valueType,
        date: date,
        dateType: dateType,
        hover: hover
      }),
      date: date,
      point: point
    }, tileProps)));
  }

  return _react["default"].createElement(_Flex["default"], {
    className: className,
    count: count,
    offset: offset,
    wrap: true
  }, tiles);
}

TileGroup.propTypes = _objectSpread({}, _propTypes2.tileGroupProps, {
  activeStartDate: _propTypes["default"].instanceOf(Date),
  count: _propTypes["default"].number,
  dateTransform: _propTypes["default"].func.isRequired,
  offset: _propTypes["default"].number,
  step: _propTypes["default"].number,
  tile: _propTypes["default"].func.isRequired
});
TileGroup.defaultProps = {
  count: 3,
  step: 1
};

/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatShortWeekday = exports.formatWeekday = exports.formatMonth = exports.formatMonthYear = exports.formatLongDate = exports.formatDate = void 0;

var _getUserLocale = _interopRequireDefault(__webpack_require__(2966));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function getFormatter(options) {
  return function (locale, date) {
    return date.toLocaleString(locale || (0, _getUserLocale["default"])(), options);
  };
}
/**
 * Changes the hour in a Date to ensure right date formatting even if DST is messed up.
 * Workaround for bug in WebKit and Firefox with historical dates.
 * For more details, see:
 * https://bugs.chromium.org/p/chromium/issues/detail?id=750465
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1385643
 *
 * @param {Date} date Date.
 */


function toSafeHour(date) {
  var safeDate = new Date(date);
  return new Date(safeDate.setHours(12));
}

function getSafeFormatter(options) {
  return function (locale, date) {
    return getFormatter(options)(locale, toSafeHour(date));
  };
}

var formatDateOptions = {
  day: 'numeric',
  month: 'numeric',
  year: 'numeric'
};
var formatLongDateOptions = {
  day: 'numeric',
  month: 'long',
  year: 'numeric'
};
var formatMonthYearOptions = {
  month: 'long',
  year: 'numeric'
};
var formatMonthOptions = {
  month: 'long'
};
var formatWeekdayOptions = {
  weekday: 'long'
};
var formatShortWeekdayOptions = {
  weekday: 'short'
};
var formatDate = getSafeFormatter(formatDateOptions);
exports.formatDate = formatDate;
var formatLongDate = getSafeFormatter(formatLongDateOptions);
exports.formatLongDate = formatLongDate;
var formatMonthYear = getSafeFormatter(formatMonthYearOptions);
exports.formatMonthYear = formatMonthYear;
var formatMonth = getSafeFormatter(formatMonthOptions);
exports.formatMonth = formatMonth;
var formatWeekday = getSafeFormatter(formatWeekdayOptions);
exports.formatWeekday = formatWeekday;
var formatShortWeekday = getSafeFormatter(formatShortWeekdayOptions);
exports.formatShortWeekday = formatShortWeekday;

/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.cancelEvent = cancelEvent;
exports.getFirstDayOfMonth = getFirstDayOfMonth;
exports.getDaysInMonth = getDaysInMonth;
exports.getModifiersFromProps = getModifiersFromProps;
exports.getFirstDayOfWeekFromProps = getFirstDayOfWeekFromProps;
exports.isRangeOfDates = isRangeOfDates;
exports.getMonthsDiff = getMonthsDiff;
exports.getWeekArray = getWeekArray;
exports.startOfMonth = startOfMonth;
exports.getDayNodes = getDayNodes;
exports.nodeListToArray = nodeListToArray;
exports.hasOwnProp = hasOwnProp;

var _DateUtils = __webpack_require__(287);

var _LocaleUtils = __webpack_require__(460);

var _classNames = __webpack_require__(461);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cancelEvent(e) {
  e.preventDefault();
  e.stopPropagation();
}

function getFirstDayOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1, 12);
}

function getDaysInMonth(d) {
  var resultDate = getFirstDayOfMonth(d);

  resultDate.setMonth(resultDate.getMonth() + 1);
  resultDate.setDate(resultDate.getDate() - 1);

  return resultDate.getDate();
}

function getModifiersFromProps(props) {
  var modifiers = _extends({}, props.modifiers);
  if (props.selectedDays) {
    modifiers[props.classNames.selected] = props.selectedDays;
  }
  if (props.disabledDays) {
    modifiers[props.classNames.disabled] = props.disabledDays;
  }
  return modifiers;
}

function getFirstDayOfWeekFromProps(props) {
  var firstDayOfWeek = props.firstDayOfWeek,
      _props$locale = props.locale,
      locale = _props$locale === undefined ? 'en' : _props$locale,
      _props$localeUtils = props.localeUtils,
      localeUtils = _props$localeUtils === undefined ? {} : _props$localeUtils;

  if (!isNaN(firstDayOfWeek)) {
    return firstDayOfWeek;
  }
  if (localeUtils.getFirstDayOfWeek) {
    return localeUtils.getFirstDayOfWeek(locale);
  }
  return 0;
}

function isRangeOfDates(value) {
  return !!(value && value.from && value.to);
}

function getMonthsDiff(d1, d2) {
  return d2.getMonth() - d1.getMonth() + 12 * (d2.getFullYear() - d1.getFullYear());
}

function getWeekArray(d) {
  var firstDayOfWeek = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _LocaleUtils.getFirstDayOfWeek)();
  var fixedWeeks = arguments[2];

  var daysInMonth = getDaysInMonth(d);
  var dayArray = [];

  var week = [];
  var weekArray = [];

  for (var i = 1; i <= daysInMonth; i += 1) {
    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i, 12));
  }

  dayArray.forEach(function (day) {
    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
      weekArray.push(week);
      week = [];
    }
    week.push(day);
    if (dayArray.indexOf(day) === dayArray.length - 1) {
      weekArray.push(week);
    }
  });

  // unshift days to start the first week
  var firstWeek = weekArray[0];
  for (var _i = 7 - firstWeek.length; _i > 0; _i -= 1) {
    var outsideDate = (0, _DateUtils.clone)(firstWeek[0]);
    outsideDate.setDate(firstWeek[0].getDate() - 1);
    firstWeek.unshift(outsideDate);
  }

  // push days until the end of the last week
  var lastWeek = weekArray[weekArray.length - 1];
  for (var _i2 = lastWeek.length; _i2 < 7; _i2 += 1) {
    var _outsideDate = (0, _DateUtils.clone)(lastWeek[lastWeek.length - 1]);
    _outsideDate.setDate(lastWeek[lastWeek.length - 1].getDate() + 1);
    lastWeek.push(_outsideDate);
  }

  // add extra weeks to reach 6 weeks
  if (fixedWeeks && weekArray.length < 6) {
    var lastExtraWeek = void 0;

    for (var _i3 = weekArray.length; _i3 < 6; _i3 += 1) {
      lastExtraWeek = weekArray[weekArray.length - 1];
      var lastDay = lastExtraWeek[lastExtraWeek.length - 1];
      var extraWeek = [];

      for (var j = 0; j < 7; j += 1) {
        var _outsideDate2 = (0, _DateUtils.clone)(lastDay);
        _outsideDate2.setDate(lastDay.getDate() + j + 1);
        extraWeek.push(_outsideDate2);
      }

      weekArray.push(extraWeek);
    }
  }

  return weekArray;
}

function startOfMonth(d) {
  var newDate = (0, _DateUtils.clone)(d);
  newDate.setDate(1);
  newDate.setHours(12, 0, 0, 0); // always set noon to avoid time zone issues
  return newDate;
}

function getDayNodes(node, classNames) {
  var outsideClassName = void 0;
  if (classNames === _classNames2.default) {
    // When using CSS modules prefix the modifier as required by the BEM syntax
    outsideClassName = classNames.day + '--' + classNames.outside;
  } else {
    outsideClassName = '' + classNames.outside;
  }
  var dayQuery = classNames.day.replace(/ /g, '.');
  var outsideDayQuery = outsideClassName.replace(/ /g, '.');
  var selector = '.' + dayQuery + ':not(.' + outsideDayQuery + ')';
  return node.querySelectorAll(selector);
}

function nodeListToArray(nodeList) {
  return Array.prototype.slice.call(nodeList, 0);
}

function hasOwnProp(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}
//# sourceMappingURL=Helpers.js.map

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatDay = formatDay;
exports.formatMonthTitle = formatMonthTitle;
exports.formatWeekdayShort = formatWeekdayShort;
exports.formatWeekdayLong = formatWeekdayLong;
exports.getFirstDayOfWeek = getFirstDayOfWeek;
exports.getMonths = getMonths;
var WEEKDAYS_LONG = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

var WEEKDAYS_SHORT = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

function formatDay(day) {
  return day.toDateString();
}

function formatMonthTitle(d) {
  return MONTHS[d.getMonth()] + ' ' + d.getFullYear();
}

function formatWeekdayShort(i) {
  return WEEKDAYS_SHORT[i];
}

function formatWeekdayLong(i) {
  return WEEKDAYS_LONG[i];
}

function getFirstDayOfWeek() {
  return 0;
}

function getMonths() {
  return MONTHS;
}

exports.default = {
  formatDay: formatDay,
  formatMonthTitle: formatMonthTitle,
  formatWeekdayShort: formatWeekdayShort,
  formatWeekdayLong: formatWeekdayLong,
  getFirstDayOfWeek: getFirstDayOfWeek,
  getMonths: getMonths
};
//# sourceMappingURL=LocaleUtils.js.map

/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Proxy object to map classnames when css modules are not used

exports.default = {
  container: 'DayPicker',
  wrapper: 'DayPicker-wrapper',
  interactionDisabled: 'DayPicker--interactionDisabled',
  months: 'DayPicker-Months',
  month: 'DayPicker-Month',

  navBar: 'DayPicker-NavBar',
  navButtonPrev: 'DayPicker-NavButton DayPicker-NavButton--prev',
  navButtonNext: 'DayPicker-NavButton DayPicker-NavButton--next',
  navButtonInteractionDisabled: 'DayPicker-NavButton--interactionDisabled',

  caption: 'DayPicker-Caption',
  weekdays: 'DayPicker-Weekdays',
  weekdaysRow: 'DayPicker-WeekdaysRow',
  weekday: 'DayPicker-Weekday',
  body: 'DayPicker-Body',
  week: 'DayPicker-Week',
  weekNumber: 'DayPicker-WeekNumber',
  day: 'DayPicker-Day',
  footer: 'DayPicker-Footer',
  todayButton: 'DayPicker-TodayButton',

  // default modifiers
  today: 'today',
  selected: 'selected',
  disabled: 'disabled',
  outside: 'outside'
};
//# sourceMappingURL=classNames.js.map

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LEFT = exports.LEFT = 37;
var UP = exports.UP = 38;
var RIGHT = exports.RIGHT = 39;
var DOWN = exports.DOWN = 40;
var ENTER = exports.ENTER = 13;
var SPACE = exports.SPACE = 32;
var ESC = exports.ESC = 27;
var TAB = exports.TAB = 9;
//# sourceMappingURL=keys.js.map

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setDefaults;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDefaults;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__unescape_js__ = __webpack_require__(3185);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }


var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true,
  unescape: __WEBPACK_IMPORTED_MODULE_1__unescape_js__["a" /* unescape */]
};
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread(_objectSpread({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setI18n;
/* harmony export (immutable) */ __webpack_exports__["b"] = getI18n;
var i18nInstance;
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = warn;
/* harmony export (immutable) */ __webpack_exports__["b"] = warnOnce;
/* harmony export (immutable) */ __webpack_exports__["e"] = loadNamespaces;
/* harmony export (immutable) */ __webpack_exports__["d"] = loadLanguages;
/* harmony export (immutable) */ __webpack_exports__["c"] = hasLoadedNamespace;
/* harmony export (immutable) */ __webpack_exports__["a"] = getDisplayName;
function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}

var loadedClb = function loadedClb(i18n, cb) {
  return function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  };
};

function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, loadedClb(i18n, cb));
}
function loadLanguages(i18n, lng, ns, cb) {
  if (typeof ns === 'string') ns = [ns];
  ns.forEach(function (n) {
    if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
  });
  i18n.loadLanguages(lng, loadedClb(i18n, cb));
}

function oldI18nextHasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;

  if (!isNewerI18next) {
    return oldI18nextHasLoadedNamespace(ns, i18n, options);
  }

  return i18n.hasLoadedNamespace(ns, {
    lng: options.lng,
    precheck: function precheck(i18nInstance, loadNotPending) {
      if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
    }
  });
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}

/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(3188);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_Icon__ = __webpack_require__(95);







/**
 * A table row can have cells.
 */

function TableCell(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      collapsing = props.collapsing,
      content = props.content,
      disabled = props.disabled,
      error = props.error,
      icon = props.icon,
      negative = props.negative,
      positive = props.positive,
      selectable = props.selectable,
      singleLine = props.singleLine,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign,
      warning = props.warning,
      width = props.width;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(collapsing, 'collapsing'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(error, 'error'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(negative, 'negative'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(positive, 'positive'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(selectable, 'selectable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(singleLine, 'single line'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(warning, 'warning'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["n" /* useTextAlignProp */])(textAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["i" /* useVerticalAlignProp */])(verticalAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["f" /* useWidthProp */])(width, 'wide'), className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(TableCell, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(TableCell, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_6__elements_Icon__["a" /* default */].create(icon), content);
}

TableCell.handledProps = ["active", "as", "children", "className", "collapsing", "content", "disabled", "error", "icon", "negative", "positive", "selectable", "singleLine", "textAlign", "verticalAlign", "warning", "width"];
TableCell.defaultProps = {
  as: 'td'
};
TableCell.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A cell can be active or selected by a user. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A cell can be collapsing so that it only uses as much space as required. */
  collapsing: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A cell can be disabled. */
  disabled: PropTypes.bool,

  /** A cell may call attention to an error or a negative value. */
  error: PropTypes.bool,

  /** Add an Icon by name, props object, or pass an <Icon /> */
  icon: customPropTypes.itemShorthand,

  /** A cell may let a user know whether a value is bad. */
  negative: PropTypes.bool,

  /** A cell may let a user know whether a value is good. */
  positive: PropTypes.bool,

  /** A cell can be selectable. */
  selectable: PropTypes.bool,

  /** A cell can specify that its contents should remain on a single line and not wrap. */
  singleLine: PropTypes.bool,

  /** A table cell can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified')),

  /** A table cell can adjust its text alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS),

  /** A cell may warn a user. */
  warning: PropTypes.bool,

  /** A table can specify the width of individual columns independently. */
  width: PropTypes.oneOf(SUI.WIDTHS)
} : {};
TableCell.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["e" /* createShorthandFactory */])(TableCell, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (TableCell);

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(705);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["a"]; });



/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_isNil__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__IconGroup__ = __webpack_require__(1465);










/**
 * An icon is a glyph used to represent something else.
 * @see Image
 */

var Icon = /*#__PURE__*/function (_PureComponent) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Icon, _PureComponent);

  function Icon() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;

    _this.handleClick = function (e) {
      var disabled = _this.props.disabled;

      if (disabled) {
        e.preventDefault();
        return;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(_this.props, 'onClick', e, _this.props);
    };

    return _this;
  }

  var _proto = Icon.prototype;

  _proto.getIconAriaOptions = function getIconAriaOptions() {
    var ariaOptions = {};
    var _this$props = this.props,
        ariaLabel = _this$props['aria-label'],
        ariaHidden = _this$props['aria-hidden'];

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_isNil__["a" /* default */])(ariaLabel)) {
      ariaOptions['aria-hidden'] = 'true';
    } else {
      ariaOptions['aria-label'] = ariaLabel;
    }

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_isNil__["a" /* default */])(ariaHidden)) {
      ariaOptions['aria-hidden'] = ariaHidden;
    }

    return ariaOptions;
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        bordered = _this$props2.bordered,
        circular = _this$props2.circular,
        className = _this$props2.className,
        color = _this$props2.color,
        corner = _this$props2.corner,
        disabled = _this$props2.disabled,
        fitted = _this$props2.fitted,
        flipped = _this$props2.flipped,
        inverted = _this$props2.inverted,
        link = _this$props2.link,
        loading = _this$props2.loading,
        name = _this$props2.name,
        rotated = _this$props2.rotated,
        size = _this$props2.size;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(color, name, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(bordered, 'bordered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(circular, 'circular'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(fitted, 'fitted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(link, 'link'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(loading, 'loading'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["h" /* useKeyOrValueAndKey */])(corner, 'corner'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["g" /* useValueAndKey */])(flipped, 'flipped'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["g" /* useValueAndKey */])(rotated, 'rotated'), 'icon', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["b" /* getUnhandledProps */])(Icon, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["c" /* getElementType */])(Icon, this.props);
    var ariaOptions = this.getIconAriaOptions();
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, ariaOptions, {
      className: classes,
      onClick: this.handleClick
    }));
  };

  return Icon;
}(__WEBPACK_IMPORTED_MODULE_7_react__["PureComponent"]);

Icon.handledProps = ["aria-hidden", "aria-label", "as", "bordered", "circular", "className", "color", "corner", "disabled", "fitted", "flipped", "inverted", "link", "loading", "name", "rotated", "size"];
Icon.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Formatted to appear bordered. */
  bordered: PropTypes.bool,

  /** Icon can formatted to appear circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Color of the icon. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Icons can display a smaller corner icon. */
  corner: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top left', 'top right', 'bottom left', 'bottom right'])]),

  /** Show that the icon is inactive. */
  disabled: PropTypes.bool,

  /** Fitted, without space to left or right of Icon. */
  fitted: PropTypes.bool,

  /** Icon can be flipped. */
  flipped: PropTypes.oneOf(['horizontally', 'vertically']),

  /** Formatted to have its colors inverted for contrast. */
  inverted: PropTypes.bool,

  /** Icon can be formatted as a link. */
  link: PropTypes.bool,

  /** Icon can be used as a simple loader. */
  loading: PropTypes.bool,

  /** Name of the icon. */
  name: customPropTypes.suggest(SUI.ALL_ICONS_IN_ALL_CONTEXTS),

  /** Icon can rotated. */
  rotated: PropTypes.oneOf(['clockwise', 'counterclockwise']),

  /** Size of the icon. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** Icon can have an aria label. */
  'aria-hidden': PropTypes.string,

  /** Icon can have an aria label. */
  'aria-label': PropTypes.string
} : {};
Icon.defaultProps = {
  as: 'i'
};
Icon.Group = __WEBPACK_IMPORTED_MODULE_9__IconGroup__["a" /* default */];
Icon.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["e" /* createShorthandFactory */])(Icon, function (value) {
  return {
    name: value
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A list item can contain a description.
 */

function ListDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(className, 'description');
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ListDescription, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ListDescription, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ListDescription.handledProps = ["as", "children", "className", "content"];
ListDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ListDescription.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ListDescription, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ListDescription);

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A list item can contain a header.
 */

function ListHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ListHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ListHeader, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ListHeader.handledProps = ["as", "children", "className", "content"];
ListHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ListHeader.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ListHeader, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ListHeader);

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Checkbox__ = __webpack_require__(3296);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Checkbox__["a"]; });



/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dropdown__ = __webpack_require__(3298);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dropdown__["a"]; });



/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * An event or an event summary can contain a date.
 */

function FeedDate(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('date', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(FeedDate, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(FeedDate, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

FeedDate.handledProps = ["as", "children", "className", "content"];
FeedDate.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedDate);

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__ = __webpack_require__(3417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__ = __webpack_require__(3418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__ = __webpack_require__(3419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__ = __webpack_require__(3420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__ = __webpack_require__(3421);






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__["a" /* default */];
ListCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__["a" /* default */];
ListCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__["a" /* default */];
ListCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__["a" /* default */];
ListCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (ListCache);


/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__ = __webpack_require__(3437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__ = __webpack_require__(3438);




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__["a" /* default */];
SetCache.prototype.has = __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (SetCache);


/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ __webpack_exports__["a"] = (apply);


/***/ }),
/* 479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__ = __webpack_require__(484);


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__["a" /* default */])(array, value, 0) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayIncludes);


/***/ }),
/* 480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(493);


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (assocIndexOf);


/***/ }),
/* 481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(149);


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (baseCreate);


/***/ }),
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isFlattenable_js__ = __webpack_require__(3413);



/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = __WEBPACK_IMPORTED_MODULE_1__isFlattenable_js__["a" /* default */]);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseFlatten);


/***/ }),
/* 483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFor_js__ = __webpack_require__(3345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(150);



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseFor_js__["a" /* default */])(object, iteratee, __WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseForOwn);


/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsNaN_js__ = __webpack_require__(3355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__strictIndexOf_js__ = __webpack_require__(3444);




/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__strictIndexOf_js__["a" /* default */])(array, value, fromIndex)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__["a" /* default */])(array, __WEBPACK_IMPORTED_MODULE_1__baseIsNaN_js__["a" /* default */], fromIndex);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIndexOf);


/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseSlice);


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (cacheHas);


/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(149);



/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(result) ? result : thisBinding;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createCtor);


/***/ }),
/* 489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isKeyable_js__ = __webpack_require__(3414);


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isKeyable_js__["a" /* default */])(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ __webpack_exports__["a"] = (getMapData);


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIndex_js__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(149);





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(object) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isIndex_js__["a" /* default */])(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(object[index], value);
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (isIterateeCall);


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(252);


/* Built-in method references that are verified to be native. */
var nativeCreate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'create');

/* harmony default export */ __webpack_exports__["a"] = (nativeCreate);


/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (replaceHolders);


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["a"] = (eq);


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__(3352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(139);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(139);



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLikeObject);


/***/ }),
/* 496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(3481);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(766)(module)))

/***/ }),
/* 497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseKeys_js__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTag_js__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArguments_js__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBuffer_js__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isPrototype_js__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(498);









/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__["a" /* default */])(value) &&
      (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__isBuffer_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArguments_js__["a" /* default */])(value))) {
    return !value.length;
  }
  var tag = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getTag_js__["a" /* default */])(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__isPrototype_js__["a" /* default */])(value)) {
    return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseKeys_js__["a" /* default */])(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (isEmpty);


/***/ }),
/* 498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__(3357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(3432);




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePick_js__ = __webpack_require__(3363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flatRest_js__ = __webpack_require__(3397);



/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__flatRest_js__["a" /* default */])(function(object, paths) {
  return object == null ? {} : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basePick_js__["a" /* default */])(object, paths);
});

/* harmony default export */ __webpack_exports__["a"] = (pick);


/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayReduce_js__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseEach_js__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseReduce_js__ = __webpack_require__(3367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArray_js__ = __webpack_require__(69);






/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arrayReduce_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_3__baseReduce_js__["a" /* default */],
      initAccum = arguments.length < 3;

  return func(collection, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 4), accumulator, initAccum, __WEBPACK_IMPORTED_MODULE_1__baseEach_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (reduce);


/***/ }),
/* 501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTrim_js__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isSymbol_js__ = __webpack_require__(296);




/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isSymbol_js__["a" /* default */])(value)) {
    return NAN;
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseTrim_js__["a" /* default */])(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/* harmony default export */ __webpack_exports__["a"] = (toNumber);


/***/ }),
/* 502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseValues_js__ = __webpack_require__(3372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(150);



/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseValues_js__["a" /* default */])(object, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (values);


/***/ }),
/* 503 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 504 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOS45OCAxNi42MTUiPgogIDxkZWZzPgogICAgPHN0eWxlPgogICAgICAuY2xzLTEgewogICAgICAgIGZpbGw6IG5vbmU7CiAgICAgICAgc3Ryb2tlOiAjMjFiYTQ1OwogICAgICAgIHN0cm9rZS1taXRlcmxpbWl0OiAxMDsKICAgICAgICBzdHJva2Utd2lkdGg6IDEuNXB4OwogICAgICB9CiAgICA8L3N0eWxlPgogIDwvZGVmcz4KICA8ZyBpZD0iR3JvdXBfMzIzMiIgZGF0YS1uYW1lPSJHcm91cCAzMjMyIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMi41NSAtNC40MzUpIj4KICAgIDxwYXRoIGlkPSJQYXRoXzI2NTMiIGRhdGEtbmFtZT0iUGF0aCAyNjUzIiBjbGFzcz0iY2xzLTEiIGQ9Ik0xNy42MzksMjEuNDdhNy4xNyw3LjE3LDAsMSwxLTcuMTctNy4xNyw3LjA0Nyw3LjA0NywwLDAsMSw1LjA2NCwyLjEwNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAtOC4zMzkpIi8+CiAgICA8cGF0aCBpZD0iUGF0aF8yNjU0IiBkYXRhLW5hbWU9IlBhdGggMjY1NCIgY2xhc3M9ImNscy0xIiBkPSJNMTUuOSwxMS42MDVsNC4xOCw0LjExOUwzMC43NTQsNC45NjMiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC04Ljc1NiAwKSIvPgogIDwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate_js__ = __webpack_require__(506);

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__validate_js__["a" /* default */])(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ __webpack_exports__["a"] = (stringify);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__regex_js__ = __webpack_require__(3545);


function validate(uuid) {
  return typeof uuid === 'string' && __WEBPACK_IMPORTED_MODULE_0__regex_js__["a" /* default */].test(uuid);
}

/* harmony default export */ __webpack_exports__["a"] = (validate);

/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GRAPHQL_AUTH_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GraphQLAuthError; });
var GRAPHQL_AUTH_MODE;
(function (GRAPHQL_AUTH_MODE) {
    GRAPHQL_AUTH_MODE["API_KEY"] = "API_KEY";
    GRAPHQL_AUTH_MODE["AWS_IAM"] = "AWS_IAM";
    GRAPHQL_AUTH_MODE["OPENID_CONNECT"] = "OPENID_CONNECT";
    GRAPHQL_AUTH_MODE["AMAZON_COGNITO_USER_POOLS"] = "AMAZON_COGNITO_USER_POOLS";
})(GRAPHQL_AUTH_MODE || (GRAPHQL_AUTH_MODE = {}));
var GraphQLAuthError;
(function (GraphQLAuthError) {
    GraphQLAuthError["NO_API_KEY"] = "No api-key configured";
    GraphQLAuthError["NO_CURRENT_USER"] = "No current user";
    GraphQLAuthError["NO_CREDENTIALS"] = "No credentials";
    GraphQLAuthError["NO_FEDERATED_JWT"] = "No federated jwt";
})(GraphQLAuthError || (GraphQLAuthError = {}));
//# sourceMappingURL=index.js.map

/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CacheUtils__ = __webpack_require__(1616);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CacheUtils__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__CacheUtils__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__CacheUtils__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__CacheUtils__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__CacheUtils__["e"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CacheList__ = __webpack_require__(1615);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_1__CacheList__["a"]; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */


//# sourceMappingURL=index.js.map

/***/ }),
/* 509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BrowserStorageCache__ = __webpack_require__(1613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__InMemoryCache__ = __webpack_require__(1614);
/* unused harmony reexport BrowserStorageCache */
/* unused harmony reexport InMemoryCache */
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */




/**
 * @deprecated use named import
 */
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__BrowserStorageCache__["a" /* BrowserStorageCache */]);
__WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["Amplify"].register(__WEBPACK_IMPORTED_MODULE_1__BrowserStorageCache__["a" /* BrowserStorageCache */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MemoryStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StorageHelper; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var dataMemory = {};
/** @class */
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
    }
    /**
     * This is used to set a specific item in storage
     * @param {string} key - the key for the item
     * @param {object} value - the value
     * @returns {string} value that was set
     */
    MemoryStorage.setItem = function (key, value) {
        dataMemory[key] = value;
        return dataMemory[key];
    };
    /**
     * This is used to get a specific key from storage
     * @param {string} key - the key for the item
     * This is used to clear the storage
     * @returns {string} the data item
     */
    MemoryStorage.getItem = function (key) {
        return Object.prototype.hasOwnProperty.call(dataMemory, key)
            ? dataMemory[key]
            : undefined;
    };
    /**
     * This is used to remove an item from storage
     * @param {string} key - the key being set
     * @returns {string} value - value that was deleted
     */
    MemoryStorage.removeItem = function (key) {
        return delete dataMemory[key];
    };
    /**
     * This is used to clear the storage
     * @returns {string} nothing
     */
    MemoryStorage.clear = function () {
        dataMemory = {};
        return dataMemory;
    };
    return MemoryStorage;
}());

var StorageHelper = /** @class */ (function () {
    /**
     * This is used to get a storage object
     * @returns {object} the storage
     */
    function StorageHelper() {
        try {
            this.storageWindow = window.localStorage;
            this.storageWindow.setItem('aws.amplify.test-ls', 1);
            this.storageWindow.removeItem('aws.amplify.test-ls');
        }
        catch (exception) {
            this.storageWindow = MemoryStorage;
        }
    }
    /**
     * This is used to return the storage
     * @returns {object} the storage
     */
    StorageHelper.prototype.getStorage = function () {
        return this.storageWindow;
    };
    return StorageHelper;
}());

/**
 * @deprecated use named import
 */
/* unused harmony default export */ var _unused_webpack_default_export = (StorageHelper);
//# sourceMappingURL=index.js.map

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AWS_CLOUDWATCH_BASE_BUFFER_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AWS_CLOUDWATCH_CATEGORY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AWS_CLOUDWATCH_MAX_EVENT_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AWS_CLOUDWATCH_PROVIDER_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return NO_CREDS_ERROR_STRING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RETRY_ERROR_CODES; });
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
// Logging constants
var AWS_CLOUDWATCH_BASE_BUFFER_SIZE = 26;
var AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE = 1048576;
var AWS_CLOUDWATCH_MAX_EVENT_SIZE = 256000;
var AWS_CLOUDWATCH_CATEGORY = 'Logging';
var AWS_CLOUDWATCH_PROVIDER_NAME = 'AWSCloudWatch';
var NO_CREDS_ERROR_STRING = 'No credentials';
var RETRY_ERROR_CODES = [
    'ResourceNotFoundException',
    'InvalidSequenceTokenException',
];

//# sourceMappingURL=Constants.js.map

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mqttTopicMatch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MqttOverWSProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_paho_mqtt__ = __webpack_require__(3117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_paho_mqtt___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_paho_mqtt__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_zen_observable_ts__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PubSubProvider__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_amplify_core__ = __webpack_require__(71);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */





var logger = new __WEBPACK_IMPORTED_MODULE_4__aws_amplify_core__["ConsoleLogger"]('MqttOverWSProvider');
function mqttTopicMatch(filter, topic) {
    var filterArray = filter.split('/');
    var length = filterArray.length;
    var topicArray = topic.split('/');
    for (var i = 0; i < length; ++i) {
        var left = filterArray[i];
        var right = topicArray[i];
        if (left === '#')
            return topicArray.length >= length;
        if (left !== '+' && left !== right)
            return false;
    }
    return length === topicArray.length;
}
var ClientsQueue = /** @class */ (function () {
    function ClientsQueue() {
        this.promises = new Map();
    }
    ClientsQueue.prototype.get = function (clientId, clientFactory) {
        return __awaiter(this, void 0, void 0, function () {
            var promise;
            return __generator(this, function (_a) {
                promise = this.promises.get(clientId);
                if (promise) {
                    return [2 /*return*/, promise];
                }
                promise = clientFactory(clientId);
                this.promises.set(clientId, promise);
                return [2 /*return*/, promise];
            });
        });
    };
    Object.defineProperty(ClientsQueue.prototype, "allClients", {
        get: function () {
            return Array.from(this.promises.keys());
        },
        enumerable: true,
        configurable: true
    });
    ClientsQueue.prototype.remove = function (clientId) {
        this.promises.delete(clientId);
    };
    return ClientsQueue;
}());
var topicSymbol = typeof Symbol !== 'undefined' ? Symbol('topic') : '@@topic';
var MqttOverWSProvider = /** @class */ (function (_super) {
    __extends(MqttOverWSProvider, _super);
    function MqttOverWSProvider(options) {
        if (options === void 0) { options = {}; }
        var _this = _super.call(this, __assign(__assign({}, options), { clientId: options.clientId || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_uuid__["v4"])() })) || this;
        _this._clientsQueue = new ClientsQueue();
        _this._topicObservers = new Map();
        _this._clientIdObservers = new Map();
        return _this;
    }
    Object.defineProperty(MqttOverWSProvider.prototype, "clientId", {
        get: function () {
            return this.options.clientId;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MqttOverWSProvider.prototype, "endpoint", {
        get: function () {
            return this.options.aws_pubsub_endpoint;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MqttOverWSProvider.prototype, "clientsQueue", {
        get: function () {
            return this._clientsQueue;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MqttOverWSProvider.prototype, "isSSLEnabled", {
        get: function () {
            return !this.options
                .aws_appsync_dangerously_connect_to_http_endpoint_for_testing;
        },
        enumerable: true,
        configurable: true
    });
    MqttOverWSProvider.prototype.getTopicForValue = function (value) {
        return typeof value === 'object' && value[topicSymbol];
    };
    MqttOverWSProvider.prototype.getProviderName = function () {
        return 'MqttOverWSProvider';
    };
    MqttOverWSProvider.prototype.onDisconnect = function (_a) {
        var _this = this;
        var clientId = _a.clientId, errorCode = _a.errorCode, args = __rest(_a, ["clientId", "errorCode"]);
        if (errorCode !== 0) {
            logger.warn(clientId, JSON.stringify(__assign({ errorCode: errorCode }, args), null, 2));
            var topicsToDelete_1 = [];
            var clientIdObservers = this._clientIdObservers.get(clientId);
            if (!clientIdObservers) {
                return;
            }
            clientIdObservers.forEach(function (observer) {
                observer.error('Disconnected, error code: ' + errorCode);
                // removing observers for disconnected clientId
                _this._topicObservers.forEach(function (observerForTopic, observerTopic) {
                    observerForTopic.delete(observer);
                    if (observerForTopic.size === 0) {
                        topicsToDelete_1.push(observerTopic);
                    }
                });
            });
            // forgiving any trace of clientId
            this._clientIdObservers.delete(clientId);
            // Removing topics that are not listen by an observer
            topicsToDelete_1.forEach(function (topic) {
                _this._topicObservers.delete(topic);
            });
        }
    };
    MqttOverWSProvider.prototype.newClient = function (_a) {
        var url = _a.url, clientId = _a.clientId;
        return __awaiter(this, void 0, void 0, function () {
            var client;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        logger.debug('Creating new MQTT client', clientId);
                        client = new __WEBPACK_IMPORTED_MODULE_0_paho_mqtt__["Client"](url, clientId);
                        // client.trace = (args) => logger.debug(clientId, JSON.stringify(args, null, 2));
                        client.onMessageArrived = function (_a) {
                            var topic = _a.destinationName, msg = _a.payloadString;
                            _this._onMessage(topic, msg);
                        };
                        client.onConnectionLost = function (_a) {
                            var errorCode = _a.errorCode, args = __rest(_a, ["errorCode"]);
                            _this.onDisconnect(__assign({ clientId: clientId, errorCode: errorCode }, args));
                        };
                        return [4 /*yield*/, new Promise(function (resolve, reject) {
                                client.connect({
                                    useSSL: _this.isSSLEnabled,
                                    mqttVersion: 3,
                                    onSuccess: function () { return resolve(client); },
                                    onFailure: reject,
                                });
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/, client];
                }
            });
        });
    };
    MqttOverWSProvider.prototype.connect = function (clientId, options) {
        if (options === void 0) { options = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.clientsQueue.get(clientId, function (clientId) {
                            return _this.newClient(__assign(__assign({}, options), { clientId: clientId }));
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    MqttOverWSProvider.prototype.disconnect = function (clientId) {
        return __awaiter(this, void 0, void 0, function () {
            var client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.clientsQueue.get(clientId, function () { return null; })];
                    case 1:
                        client = _a.sent();
                        if (client && client.isConnected()) {
                            client.disconnect();
                        }
                        this.clientsQueue.remove(clientId);
                        return [2 /*return*/];
                }
            });
        });
    };
    MqttOverWSProvider.prototype.publish = function (topics, msg) {
        return __awaiter(this, void 0, void 0, function () {
            var targetTopics, message, url, client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        targetTopics = [].concat(topics);
                        message = JSON.stringify(msg);
                        return [4 /*yield*/, this.endpoint];
                    case 1:
                        url = _a.sent();
                        return [4 /*yield*/, this.connect(this.clientId, { url: url })];
                    case 2:
                        client = _a.sent();
                        logger.debug('Publishing to topic(s)', targetTopics.join(','), message);
                        targetTopics.forEach(function (topic) { return client.send(topic, message); });
                        return [2 /*return*/];
                }
            });
        });
    };
    MqttOverWSProvider.prototype._onMessage = function (topic, msg) {
        try {
            var matchedTopicObservers_1 = [];
            this._topicObservers.forEach(function (observerForTopic, observerTopic) {
                if (mqttTopicMatch(observerTopic, topic)) {
                    matchedTopicObservers_1.push(observerForTopic);
                }
            });
            var parsedMessage_1 = JSON.parse(msg);
            if (typeof parsedMessage_1 === 'object') {
                parsedMessage_1[topicSymbol] = topic;
            }
            matchedTopicObservers_1.forEach(function (observersForTopic) {
                observersForTopic.forEach(function (observer) { return observer.next(parsedMessage_1); });
            });
        }
        catch (error) {
            logger.warn('Error handling message', error, msg);
        }
    };
    MqttOverWSProvider.prototype.subscribe = function (topics, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var targetTopics = [].concat(topics);
        logger.debug('Subscribing to topic(s)', targetTopics.join(','));
        return new __WEBPACK_IMPORTED_MODULE_2_zen_observable_ts__["a" /* default */](function (observer) {
            targetTopics.forEach(function (topic) {
                // this._topicObservers is used to notify the observers according to the topic received on the message
                var observersForTopic = _this._topicObservers.get(topic);
                if (!observersForTopic) {
                    observersForTopic = new Set();
                    _this._topicObservers.set(topic, observersForTopic);
                }
                observersForTopic.add(observer);
            });
            // @ts-ignore
            var client;
            var _a = options.clientId, clientId = _a === void 0 ? _this.clientId : _a;
            // this._clientIdObservers is used to close observers when client gets disconnected
            var observersForClientId = _this._clientIdObservers.get(clientId);
            if (!observersForClientId) {
                observersForClientId = new Set();
            }
            observersForClientId.add(observer);
            _this._clientIdObservers.set(clientId, observersForClientId);
            (function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, url, _b, e_1;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            _a = options.url;
                            if (!(_a === void 0)) return [3 /*break*/, 2];
                            return [4 /*yield*/, this.endpoint];
                        case 1:
                            _b = _c.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            _b = _a;
                            _c.label = 3;
                        case 3:
                            url = _b;
                            _c.label = 4;
                        case 4:
                            _c.trys.push([4, 6, , 7]);
                            return [4 /*yield*/, this.connect(clientId, { url: url })];
                        case 5:
                            client = _c.sent();
                            targetTopics.forEach(function (topic) {
                                client.subscribe(topic);
                            });
                            return [3 /*break*/, 7];
                        case 6:
                            e_1 = _c.sent();
                            observer.error(e_1);
                            return [3 /*break*/, 7];
                        case 7: return [2 /*return*/];
                    }
                });
            }); })();
            return function () {
                logger.debug('Unsubscribing from topic(s)', targetTopics.join(','));
                if (client) {
                    _this._clientIdObservers.get(clientId).delete(observer);
                    // No more observers per client => client not needed anymore
                    if (_this._clientIdObservers.get(clientId).size === 0) {
                        _this.disconnect(clientId);
                        _this._clientIdObservers.delete(clientId);
                    }
                    targetTopics.forEach(function (topic) {
                        var observersForTopic = _this._topicObservers.get(topic) ||
                            new Set();
                        observersForTopic.delete(observer);
                        // if no observers exists for the topic, topic should be removed
                        if (observersForTopic.size === 0) {
                            _this._topicObservers.delete(topic);
                            if (client.isConnected()) {
                                client.unsubscribe(topic);
                            }
                        }
                    });
                }
                return null;
            };
        });
    };
    return MqttOverWSProvider;
}(__WEBPACK_IMPORTED_MODULE_3__PubSubProvider__["a" /* AbstractPubSubProvider */]));

//# sourceMappingURL=MqttOverWSProvider.js.map

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AbstractPubSubProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__ = __webpack_require__(71);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var logger = new __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["ConsoleLogger"]('AbstractPubSubProvider');
var AbstractPubSubProvider = /** @class */ (function () {
    function AbstractPubSubProvider(options) {
        if (options === void 0) { options = {}; }
        this._config = options;
    }
    AbstractPubSubProvider.prototype.configure = function (config) {
        if (config === void 0) { config = {}; }
        this._config = __assign(__assign({}, config), this._config);
        logger.debug("configure " + this.getProviderName(), this._config);
        return this.options;
    };
    AbstractPubSubProvider.prototype.getCategory = function () {
        return 'PubSub';
    };
    Object.defineProperty(AbstractPubSubProvider.prototype, "options", {
        get: function () {
            return __assign({}, this._config);
        },
        enumerable: true,
        configurable: true
    });
    return AbstractPubSubProvider;
}());

//# sourceMappingURL=PubSubProvider.js.map

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromUtf8", function() { return fromUtf8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toUtf8", function() { return toUtf8; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pureJs__ = __webpack_require__(1655);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__whatwgEncodingApi__ = __webpack_require__(1656);


var fromUtf8 = function (input) {
    return typeof TextEncoder === "function" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__whatwgEncodingApi__["a" /* fromUtf8 */])(input) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__pureJs__["a" /* fromUtf8 */])(input);
};
var toUtf8 = function (input) {
    return typeof TextDecoder === "function" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__whatwgEncodingApi__["b" /* toUtf8 */])(input) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__pureJs__["b" /* toUtf8 */])(input);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFFBQVEsSUFBSSxVQUFVLEVBQUUsTUFBTSxJQUFJLFFBQVEsRUFBRSxNQUFNLFVBQVUsQ0FBQztBQUN0RSxPQUFPLEVBQUUsUUFBUSxJQUFJLG1CQUFtQixFQUFFLE1BQU0sSUFBSSxpQkFBaUIsRUFBRSxNQUFNLHFCQUFxQixDQUFDO0FBS25HLE1BQU0sQ0FBQyxJQUFNLFFBQVEsR0FBRyxVQUFDLEtBQWE7SUFDcEMsT0FBQSxPQUFPLFdBQVcsS0FBSyxVQUFVLENBQUMsQ0FBQyxDQUFDLG1CQUFtQixDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxVQUFVLENBQUMsS0FBSyxDQUFDO0FBQWxGLENBQWtGLENBQUM7QUFFckYsTUFBTSxDQUFDLElBQU0sTUFBTSxHQUFHLFVBQUMsS0FBaUI7SUFDdEMsT0FBQSxPQUFPLFdBQVcsS0FBSyxVQUFVLENBQUMsQ0FBQyxDQUFDLGlCQUFpQixDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDO0FBQTlFLENBQThFLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBmcm9tVXRmOCBhcyBqc0Zyb21VdGY4LCB0b1V0ZjggYXMganNUb1V0ZjggfSBmcm9tIFwiLi9wdXJlSnNcIjtcbmltcG9ydCB7IGZyb21VdGY4IGFzIHRleHRFbmNvZGVyRnJvbVV0ZjgsIHRvVXRmOCBhcyB0ZXh0RW5jb2RlclRvVXRmOCB9IGZyb20gXCIuL3doYXR3Z0VuY29kaW5nQXBpXCI7XG5cbmRlY2xhcmUgY29uc3QgVGV4dERlY29kZXI6IEZ1bmN0aW9uIHwgdW5kZWZpbmVkO1xuZGVjbGFyZSBjb25zdCBUZXh0RW5jb2RlcjogRnVuY3Rpb24gfCB1bmRlZmluZWQ7XG5cbmV4cG9ydCBjb25zdCBmcm9tVXRmOCA9IChpbnB1dDogc3RyaW5nKTogVWludDhBcnJheSA9PlxuICB0eXBlb2YgVGV4dEVuY29kZXIgPT09IFwiZnVuY3Rpb25cIiA/IHRleHRFbmNvZGVyRnJvbVV0ZjgoaW5wdXQpIDoganNGcm9tVXRmOChpbnB1dCk7XG5cbmV4cG9ydCBjb25zdCB0b1V0ZjggPSAoaW5wdXQ6IFVpbnQ4QXJyYXkpOiBzdHJpbmcgPT5cbiAgdHlwZW9mIFRleHREZWNvZGVyID09PSBcImZ1bmN0aW9uXCIgPyB0ZXh0RW5jb2RlclRvVXRmOChpbnB1dCkgOiBqc1RvVXRmOChpbnB1dCk7XG4iXX0=

/***/ }),
/* 515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DescribeDestinationsCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Lists all your destinations. The results are ASCII-sorted by destination name.</p>
 */
var DescribeDestinationsCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DescribeDestinationsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeDestinationsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DescribeDestinationsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DescribeDestinationsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["R" /* DescribeDestinationsRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["S" /* DescribeDestinationsResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeDestinationsCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["Y" /* serializeAws_json1_1DescribeDestinationsCommand */])(input, context);
    };
    DescribeDestinationsCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["Z" /* deserializeAws_json1_1DescribeDestinationsCommand */])(output, context);
    };
    return DescribeDestinationsCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DescribeDestinationsCommand.js.map

/***/ }),
/* 516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DescribeLogGroupsCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Lists the specified log groups. You can list all your log groups or filter the results by prefix.
 *       The results are ASCII-sorted by log group name.</p>
 */
var DescribeLogGroupsCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DescribeLogGroupsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeLogGroupsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DescribeLogGroupsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DescribeLogGroupsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["_10" /* DescribeLogGroupsRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["_11" /* DescribeLogGroupsResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeLogGroupsCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_26" /* serializeAws_json1_1DescribeLogGroupsCommand */])(input, context);
    };
    DescribeLogGroupsCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_27" /* deserializeAws_json1_1DescribeLogGroupsCommand */])(output, context);
    };
    return DescribeLogGroupsCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DescribeLogGroupsCommand.js.map

/***/ }),
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DescribeLogStreamsCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Lists the log streams for the specified log group.
 *       You can list all the log streams or filter the results by prefix.
 *       You can also control how the results are ordered.</p>
 *          <p>This operation has a limit of five transactions per second, after which transactions are throttled.</p>
 */
var DescribeLogStreamsCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DescribeLogStreamsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeLogStreamsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DescribeLogStreamsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DescribeLogStreamsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["_8" /* DescribeLogStreamsRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["_9" /* DescribeLogStreamsResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeLogStreamsCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_24" /* serializeAws_json1_1DescribeLogStreamsCommand */])(input, context);
    };
    DescribeLogStreamsCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_25" /* deserializeAws_json1_1DescribeLogStreamsCommand */])(output, context);
    };
    return DescribeLogStreamsCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DescribeLogStreamsCommand.js.map

/***/ }),
/* 518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DescribeMetricFiltersCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Lists the specified metric filters. You can list all of the metric filters or filter
 *       the results by log name, prefix, metric name, or metric namespace. The results are
 *       ASCII-sorted by filter name.</p>
 */
var DescribeMetricFiltersCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DescribeMetricFiltersCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeMetricFiltersCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DescribeMetricFiltersCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DescribeMetricFiltersCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["N" /* DescribeMetricFiltersRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["O" /* DescribeMetricFiltersResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeMetricFiltersCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["U" /* serializeAws_json1_1DescribeMetricFiltersCommand */])(input, context);
    };
    DescribeMetricFiltersCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["V" /* deserializeAws_json1_1DescribeMetricFiltersCommand */])(output, context);
    };
    return DescribeMetricFiltersCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DescribeMetricFiltersCommand.js.map

/***/ }),
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DescribeSubscriptionFiltersCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Lists the subscription filters for the specified log group. You can list all the subscription filters or filter the results by prefix.
 *       The results are ASCII-sorted by filter name.</p>
 */
var DescribeSubscriptionFiltersCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DescribeSubscriptionFiltersCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeSubscriptionFiltersCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DescribeSubscriptionFiltersCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DescribeSubscriptionFiltersCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["F" /* DescribeSubscriptionFiltersRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["G" /* DescribeSubscriptionFiltersResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeSubscriptionFiltersCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["M" /* serializeAws_json1_1DescribeSubscriptionFiltersCommand */])(input, context);
    };
    DescribeSubscriptionFiltersCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["N" /* deserializeAws_json1_1DescribeSubscriptionFiltersCommand */])(output, context);
    };
    return DescribeSubscriptionFiltersCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DescribeSubscriptionFiltersCommand.js.map

/***/ }),
/* 520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FilterLogEventsCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Lists log events from the specified log group. You can list all the log events or filter the results
 *       using a filter pattern, a time range, and the name of the log stream.</p>
 *          <p>By default, this operation returns as many log events as can fit in 1 MB (up to 10,000
 *       log events) or all the events found within the time range that you specify. If the results
 *       include a token, then there are more log events available, and you can get additional results
 *       by specifying the token in a subsequent call. This operation can return empty results
 *     while there are more log events available through the token.</p>
 *          <p>The returned log events are sorted by event timestamp, the timestamp when the event was ingested
 *     by CloudWatch Logs, and the ID of the <code>PutLogEvents</code> request.</p>
 */
var FilterLogEventsCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(FilterLogEventsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function FilterLogEventsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    FilterLogEventsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "FilterLogEventsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["C" /* FilterLogEventsRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["D" /* FilterLogEventsResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    FilterLogEventsCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["I" /* serializeAws_json1_1FilterLogEventsCommand */])(input, context);
    };
    FilterLogEventsCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["J" /* deserializeAws_json1_1FilterLogEventsCommand */])(output, context);
    };
    return FilterLogEventsCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=FilterLogEventsCommand.js.map

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetLogEventsCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Lists log events from the specified log stream. You can list all of the log events or
 *       filter using a time range.</p>
 *
 *          <p>By default, this operation returns as many log events as can fit in a response size of 1MB (up to 10,000 log events).
 *       You can get additional log events by specifying one of the tokens in a subsequent call.
 *       This operation can return empty results while there are more log events available through the token.</p>
 */
var GetLogEventsCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(GetLogEventsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetLogEventsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    GetLogEventsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "GetLogEventsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["_6" /* GetLogEventsRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["_7" /* GetLogEventsResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetLogEventsCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_22" /* serializeAws_json1_1GetLogEventsCommand */])(input, context);
    };
    GetLogEventsCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_23" /* deserializeAws_json1_1GetLogEventsCommand */])(output, context);
    };
    return GetLogEventsCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=GetLogEventsCommand.js.map

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CognitoIdentityClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__runtimeConfig__ = __webpack_require__(1684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_sdk_config_resolver__ = __webpack_require__(847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_content_length__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_host_header__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_middleware_logger__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__aws_sdk_middleware_retry__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__aws_sdk_middleware_user_agent__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__aws_sdk_smithy_client__ = __webpack_require__(22);










/**
 * <fullname>Amazon Cognito Federated Identities</fullname>
 *          <p>Amazon Cognito Federated Identities is a web service that delivers scoped temporary
 *          credentials to mobile devices and other untrusted environments. It uniquely identifies a
 *          device and supplies the user with a consistent identity over the lifetime of an
 *          application.</p>
 *          <p>Using Amazon Cognito Federated Identities, you can enable authentication with one or
 *          more third-party identity providers (Facebook, Google, or Login with Amazon) or an Amazon
 *          Cognito user pool, and you can also choose to support unauthenticated access from your app.
 *          Cognito delivers a unique identifier for each user and acts as an OpenID token provider
 *          trusted by AWS Security Token Service (STS) to access temporary, limited-privilege AWS
 *          credentials.</p>
 *          <p>For a description of the authentication flow from the Amazon Cognito Developer Guide
 *          see <a href="https://docs.aws.amazon.com/cognito/latest/developerguide/authentication-flow.html">Authentication Flow</a>.</p>
 *          <p>For more information see <a href="https://docs.aws.amazon.com/cognito/latest/developerguide/cognito-identity.html">Amazon Cognito Federated Identities</a>.</p>
 */
var CognitoIdentityClient = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CognitoIdentityClient, _super);
    function CognitoIdentityClient(configuration) {
        var _this = this;
        var _config_0 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, __WEBPACK_IMPORTED_MODULE_1__runtimeConfig__["a" /* ClientDefaultValues */]), configuration);
        var _config_1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__aws_sdk_config_resolver__["a" /* resolveRegionConfig */])(_config_0);
        var _config_2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__aws_sdk_config_resolver__["b" /* resolveEndpointsConfig */])(_config_1);
        var _config_3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__aws_sdk_middleware_signing__["b" /* resolveAwsAuthConfig */])(_config_2);
        var _config_4 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__aws_sdk_middleware_retry__["a" /* resolveRetryConfig */])(_config_3);
        var _config_5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_host_header__["a" /* resolveHostHeaderConfig */])(_config_4);
        var _config_6 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__aws_sdk_middleware_user_agent__["a" /* resolveUserAgentConfig */])(_config_5);
        _this = _super.call(this, _config_6) || this;
        _this.config = _config_6;
        _this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__aws_sdk_middleware_retry__["b" /* getRetryPlugin */])(_this.config));
        _this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_content_length__["a" /* getContentLengthPlugin */])(_this.config));
        _this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_host_header__["b" /* getHostHeaderPlugin */])(_this.config));
        _this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_middleware_logger__["a" /* getLoggerPlugin */])(_this.config));
        _this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__aws_sdk_middleware_user_agent__["b" /* getUserAgentPlugin */])(_this.config));
        return _this;
    }
    CognitoIdentityClient.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
    };
    return CognitoIdentityClient;
}(__WEBPACK_IMPORTED_MODULE_9__aws_sdk_smithy_client__["Client"]));

//# sourceMappingURL=CognitoIdentityClient.js.map

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListIdentityPoolsCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__ = __webpack_require__(22);






/**
 * <p>Lists all of the Cognito identity pools registered for your account.</p>
 *          <p>You must use AWS Developer credentials to call this API.</p>
 */
var ListIdentityPoolsCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ListIdentityPoolsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListIdentityPoolsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    ListIdentityPoolsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__["a" /* getAwsAuthPlugin */])(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "ListIdentityPoolsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["D" /* ListIdentityPoolsInput */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["E" /* ListIdentityPoolsResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListIdentityPoolsCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["K" /* serializeAws_json1_1ListIdentityPoolsCommand */])(input, context);
    };
    ListIdentityPoolsCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["L" /* deserializeAws_json1_1ListIdentityPoolsCommand */])(output, context);
    };
    return ListIdentityPoolsCommand;
}(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=ListIdentityPoolsCommand.js.map

/***/ }),
/* 524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CognitoIdentityClient__ = __webpack_require__(522);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "CognitoIdentityClient", function() { return __WEBPACK_IMPORTED_MODULE_0__CognitoIdentityClient__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CognitoIdentity__ = __webpack_require__(826);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commands_CreateIdentityPoolCommand__ = __webpack_require__(827);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_DeleteIdentitiesCommand__ = __webpack_require__(828);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commands_DeleteIdentityPoolCommand__ = __webpack_require__(829);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commands_DescribeIdentityCommand__ = __webpack_require__(830);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commands_DescribeIdentityPoolCommand__ = __webpack_require__(831);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commands_GetCredentialsForIdentityCommand__ = __webpack_require__(832);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "GetCredentialsForIdentityCommand", function() { return __WEBPACK_IMPORTED_MODULE_7__commands_GetCredentialsForIdentityCommand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commands_GetIdCommand__ = __webpack_require__(833);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "GetIdCommand", function() { return __WEBPACK_IMPORTED_MODULE_8__commands_GetIdCommand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commands_GetIdentityPoolRolesCommand__ = __webpack_require__(834);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commands_GetOpenIdTokenCommand__ = __webpack_require__(835);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commands_GetOpenIdTokenForDeveloperIdentityCommand__ = __webpack_require__(836);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commands_ListIdentitiesCommand__ = __webpack_require__(837);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commands_ListIdentityPoolsCommand__ = __webpack_require__(523);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__pagination_ListIdentityPoolsPaginator__ = __webpack_require__(1683);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commands_ListTagsForResourceCommand__ = __webpack_require__(838);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commands_LookupDeveloperIdentityCommand__ = __webpack_require__(839);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__commands_MergeDeveloperIdentitiesCommand__ = __webpack_require__(840);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__commands_SetIdentityPoolRolesCommand__ = __webpack_require__(841);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__commands_TagResourceCommand__ = __webpack_require__(842);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__commands_UnlinkDeveloperIdentityCommand__ = __webpack_require__(843);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__commands_UnlinkIdentityCommand__ = __webpack_require__(844);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__commands_UntagResourceCommand__ = __webpack_require__(845);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__commands_UpdateIdentityPoolCommand__ = __webpack_require__(846);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__pagination_Interfaces__ = __webpack_require__(1682);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__models_index__ = __webpack_require__(1680);
/* unused harmony namespace reexport */


























//# sourceMappingURL=index.js.map

/***/ }),
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromBase64;
/* harmony export (immutable) */ __webpack_exports__["b"] = toBase64;
var alphabetByEncoding = {};
var alphabetByValue = new Array(64);
for (var i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++) {
    var char = String.fromCharCode(i + start);
    alphabetByEncoding[char] = i;
    alphabetByValue[i] = char;
}
for (var i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++) {
    var char = String.fromCharCode(i + start);
    var index = i + 26;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
for (var i = 0; i < 10; i++) {
    alphabetByEncoding[i.toString(10)] = i + 52;
    var char = i.toString(10);
    var index = i + 52;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
alphabetByEncoding["+"] = 62;
alphabetByValue[62] = "+";
alphabetByEncoding["/"] = 63;
alphabetByValue[63] = "/";
var bitsPerLetter = 6;
var bitsPerByte = 8;
var maxLetterValue = 63;
/**
 * Converts a base-64 encoded string to a Uint8Array of bytes.
 *
 * @param input The base-64 encoded string
 *
 * @see https://tools.ietf.org/html/rfc4648#section-4
 */
function fromBase64(input) {
    var totalByteLength = (input.length / 4) * 3;
    if (input.substr(-2) === "==") {
        totalByteLength -= 2;
    }
    else if (input.substr(-1) === "=") {
        totalByteLength--;
    }
    var out = new ArrayBuffer(totalByteLength);
    var dataView = new DataView(out);
    for (var i = 0; i < input.length; i += 4) {
        var bits = 0;
        var bitLength = 0;
        for (var j = i, limit = i + 3; j <= limit; j++) {
            if (input[j] !== "=") {
                bits |= alphabetByEncoding[input[j]] << ((limit - j) * bitsPerLetter);
                bitLength += bitsPerLetter;
            }
            else {
                bits >>= bitsPerLetter;
            }
        }
        var chunkOffset = (i / 4) * 3;
        bits >>= bitLength % bitsPerByte;
        var byteLength = Math.floor(bitLength / bitsPerByte);
        for (var k = 0; k < byteLength; k++) {
            var offset = (byteLength - k - 1) * bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & (255 << offset)) >> offset);
        }
    }
    return new Uint8Array(out);
}
/**
 * Converts a Uint8Array of binary data to a base-64 encoded string.
 *
 * @param input The binary data to encode
 *
 * @see https://tools.ietf.org/html/rfc4648#section-4
 */
function toBase64(input) {
    var str = "";
    for (var i = 0; i < input.length; i += 3) {
        var bits = 0;
        var bitLength = 0;
        for (var j = i, limit = Math.min(i + 3, input.length); j < limit; j++) {
            bits |= input[j] << ((limit - j - 1) * bitsPerByte);
            bitLength += bitsPerByte;
        }
        var bitClusterCount = Math.ceil(bitLength / bitsPerLetter);
        bits <<= bitClusterCount * bitsPerLetter - bitLength;
        for (var k = 1; k <= bitClusterCount; k++) {
            var offset = (bitClusterCount - k) * bitsPerLetter;
            str += alphabetByValue[(bits & (maxLetterValue << offset)) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["locateWindow"] = locateWindow;
var fallbackWindow = {};
/**
 * Locates the global scope for a browser or browser-like environment. If
 * neither `window` nor `self` is defined by the environment, the same object
 * will be returned on each invocation.
 */
function locateWindow() {
    if (typeof window !== "undefined") {
        return window;
    }
    else if (typeof self !== "undefined") {
        return self;
    }
    return fallbackWindow;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsSUFBTSxjQUFjLEdBQUcsRUFBWSxDQUFDO0FBRXBDOzs7O0dBSUc7QUFDSCxNQUFNLFVBQVUsWUFBWTtJQUMxQixJQUFJLE9BQU8sTUFBTSxLQUFLLFdBQVcsRUFBRTtRQUNqQyxPQUFPLE1BQU0sQ0FBQztLQUNmO1NBQU0sSUFBSSxPQUFPLElBQUksS0FBSyxXQUFXLEVBQUU7UUFDdEMsT0FBTyxJQUFJLENBQUM7S0FDYjtJQUVELE9BQU8sY0FBYyxDQUFDO0FBQ3hCLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJjb25zdCBmYWxsYmFja1dpbmRvdyA9IHt9IGFzIFdpbmRvdztcblxuLyoqXG4gKiBMb2NhdGVzIHRoZSBnbG9iYWwgc2NvcGUgZm9yIGEgYnJvd3NlciBvciBicm93c2VyLWxpa2UgZW52aXJvbm1lbnQuIElmXG4gKiBuZWl0aGVyIGB3aW5kb3dgIG5vciBgc2VsZmAgaXMgZGVmaW5lZCBieSB0aGUgZW52aXJvbm1lbnQsIHRoZSBzYW1lIG9iamVjdFxuICogd2lsbCBiZSByZXR1cm5lZCBvbiBlYWNoIGludm9jYXRpb24uXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBsb2NhdGVXaW5kb3coKTogV2luZG93IHtcbiAgaWYgKHR5cGVvZiB3aW5kb3cgIT09IFwidW5kZWZpbmVkXCIpIHtcbiAgICByZXR1cm4gd2luZG93O1xuICB9IGVsc2UgaWYgKHR5cGVvZiBzZWxmICE9PSBcInVuZGVmaW5lZFwiKSB7XG4gICAgcmV0dXJuIHNlbGY7XG4gIH1cblxuICByZXR1cm4gZmFsbGJhY2tXaW5kb3c7XG59XG4iXX0=

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(879);
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(878);

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return handleRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isRefObject; });
/**
 * The function that correctly handles passing refs.
 *
 * @param ref - An ref object or function
 * @param node - A node that should be passed by ref
 */
var handleRef = function handleRef(ref, node) {
  if (false) {
    if (typeof ref === 'string') {
      throw new Error('We do not support refs as string, this is a legacy API and will be likely to be removed in one of the future releases of React.');
    }
  }

  if (typeof ref === 'function') {
    ref(node);
    return;
  }

  if (ref !== null && typeof ref === 'object') {
    // The `current` property is defined as readonly, however it's a valid way because
    // `ref` is a mutable object
    ref.current = node;
  }
};
/** Checks that the passed object is a valid React ref object. */

var isRefObject = function isRefObject(ref) {
  return (// https://github.com/facebook/react/blob/v16.8.2/packages/react-reconciler/src/ReactFiberCommitWork.js#L665
    ref !== null && typeof ref === 'object' && ref.hasOwnProperty('current')
  );
};
//# sourceMappingURL=utils.js.map


/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoopLogger; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NOOP_LOGGER; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var NoopLogger = /** @class */ (function () {
    function NoopLogger() {
    }
    NoopLogger.prototype.emit = function (_logRecord) { };
    return NoopLogger;
}());

var NOOP_LOGGER = new NoopLogger();
//# sourceMappingURL=NoopLogger.js.map

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NoopLoggerProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NOOP_LOGGER_PROVIDER; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NoopLogger__ = __webpack_require__(531);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var NoopLoggerProvider = /** @class */ (function () {
    function NoopLoggerProvider() {
    }
    NoopLoggerProvider.prototype.getLogger = function (_name, _version, _options) {
        return new __WEBPACK_IMPORTED_MODULE_0__NoopLogger__["a" /* NoopLogger */]();
    };
    return NoopLoggerProvider;
}());

var NOOP_LOGGER_PROVIDER = new NoopLoggerProvider();
//# sourceMappingURL=NoopLoggerProvider.js.map

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiagLogLevel; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */
var DiagLogLevel;
(function (DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */
    DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */
    DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */
    DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */
    DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */
    DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */
    DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */
    DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})(DiagLogLevel || (DiagLogLevel = {}));
//# sourceMappingURL=types.js.map

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NonRecordingSpan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__invalid_span_constants__ = __webpack_require__(535);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */
var NonRecordingSpan = /** @class */ (function () {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) { _spanContext = __WEBPACK_IMPORTED_MODULE_0__invalid_span_constants__["c" /* INVALID_SPAN_CONTEXT */]; }
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function () {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function (_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function (_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function (_name, _attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addLink = function (_link) {
        return this;
    };
    NonRecordingSpan.prototype.addLinks = function (_links) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function (_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function (_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function (_endTime) { };
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function () {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function (_exception, _time) { };
    return NonRecordingSpan;
}());

//# sourceMappingURL=NonRecordingSpan.js.map

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INVALID_SPANID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INVALID_TRACEID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return INVALID_SPAN_CONTEXT; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trace_flags__ = __webpack_require__(908);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var INVALID_SPANID = '0000000000000000';
var INVALID_TRACEID = '00000000000000000000000000000000';
var INVALID_SPAN_CONTEXT = {
    traceId: INVALID_TRACEID,
    spanId: INVALID_SPANID,
    traceFlags: __WEBPACK_IMPORTED_MODULE_0__trace_flags__["a" /* TraceFlags */].NONE,
};
//# sourceMappingURL=invalid-span-constants.js.map

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isValidTraceId;
/* harmony export (immutable) */ __webpack_exports__["c"] = isValidSpanId;
/* harmony export (immutable) */ __webpack_exports__["a"] = isSpanContextValid;
/* harmony export (immutable) */ __webpack_exports__["d"] = wrapSpanContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__invalid_span_constants__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NonRecordingSpan__ = __webpack_require__(534);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function isValidTraceId(traceId) {
    return VALID_TRACEID_REGEX.test(traceId) && traceId !== __WEBPACK_IMPORTED_MODULE_0__invalid_span_constants__["b" /* INVALID_TRACEID */];
}
function isValidSpanId(spanId) {
    return VALID_SPANID_REGEX.test(spanId) && spanId !== __WEBPACK_IMPORTED_MODULE_0__invalid_span_constants__["a" /* INVALID_SPANID */];
}
/**
 * Returns true if this {@link SpanContext} is valid.
 * @return true if this {@link SpanContext} is valid.
 */
function isSpanContextValid(spanContext) {
    return (isValidTraceId(spanContext.traceId) && isValidSpanId(spanContext.spanId));
}
/**
 * Wrap the given {@link SpanContext} in a new non-recording {@link Span}
 *
 * @param spanContext span context to be wrapped
 * @returns a new non-recording {@link Span} with the provided context
 */
function wrapSpanContext(spanContext) {
    return new __WEBPACK_IMPORTED_MODULE_1__NonRecordingSpan__["a" /* NonRecordingSpan */](spanContext);
}
//# sourceMappingURL=spancontext-utils.js.map

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validateTimeoutMillis */
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapStaticHeadersInFunction;
/* harmony export (immutable) */ __webpack_exports__["b"] = mergeOtlpSharedConfigurationWithDefaults;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSharedConfigurationDefaults;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function validateTimeoutMillis(timeoutMillis) {
    if (!Number.isNaN(timeoutMillis) &&
        Number.isFinite(timeoutMillis) &&
        timeoutMillis > 0) {
        return timeoutMillis;
    }
    throw new Error("Configuration: timeoutMillis is invalid, expected number greater than 0 (actual: '" + timeoutMillis + "')");
}
function wrapStaticHeadersInFunction(headers) {
    if (headers == null) {
        return undefined;
    }
    return function () { return headers; };
}
/**
 * @param userProvidedConfiguration  Configuration options provided by the user in code.
 * @param fallbackConfiguration Fallback to use when the {@link userProvidedConfiguration} does not specify an option.
 * @param defaultConfiguration The defaults as defined by the exporter specification
 */
function mergeOtlpSharedConfigurationWithDefaults(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration) {
    var _a, _b, _c, _d, _e, _f;
    return {
        timeoutMillis: validateTimeoutMillis((_b = (_a = userProvidedConfiguration.timeoutMillis) !== null && _a !== void 0 ? _a : fallbackConfiguration.timeoutMillis) !== null && _b !== void 0 ? _b : defaultConfiguration.timeoutMillis),
        concurrencyLimit: (_d = (_c = userProvidedConfiguration.concurrencyLimit) !== null && _c !== void 0 ? _c : fallbackConfiguration.concurrencyLimit) !== null && _d !== void 0 ? _d : defaultConfiguration.concurrencyLimit,
        compression: (_f = (_e = userProvidedConfiguration.compression) !== null && _e !== void 0 ? _e : fallbackConfiguration.compression) !== null && _f !== void 0 ? _f : defaultConfiguration.compression,
    };
}
function getSharedConfigurationDefaults() {
    return {
        timeoutMillis: 10000,
        concurrencyLimit: 30,
        compression: 'none',
    };
}
//# sourceMappingURL=shared-configuration.js.map

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tracer__ = __webpack_require__(935);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tracer", function() { return __WEBPACK_IMPORTED_MODULE_0__Tracer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BasicTracerProvider__ = __webpack_require__(2008);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BasicTracerProvider", function() { return __WEBPACK_IMPORTED_MODULE_1__BasicTracerProvider__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ForceFlushState", function() { return __WEBPACK_IMPORTED_MODULE_1__BasicTracerProvider__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__platform__ = __webpack_require__(539);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "BatchSpanProcessor", function() { return __WEBPACK_IMPORTED_MODULE_2__platform__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "RandomIdGenerator", function() { return __WEBPACK_IMPORTED_MODULE_2__platform__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__export_ConsoleSpanExporter__ = __webpack_require__(2012);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ConsoleSpanExporter", function() { return __WEBPACK_IMPORTED_MODULE_3__export_ConsoleSpanExporter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__export_InMemorySpanExporter__ = __webpack_require__(2013);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InMemorySpanExporter", function() { return __WEBPACK_IMPORTED_MODULE_4__export_InMemorySpanExporter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__export_SimpleSpanProcessor__ = __webpack_require__(2014);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SimpleSpanProcessor", function() { return __WEBPACK_IMPORTED_MODULE_5__export_SimpleSpanProcessor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__export_NoopSpanProcessor__ = __webpack_require__(937);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NoopSpanProcessor", function() { return __WEBPACK_IMPORTED_MODULE_6__export_NoopSpanProcessor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sampler_AlwaysOffSampler__ = __webpack_require__(540);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AlwaysOffSampler", function() { return __WEBPACK_IMPORTED_MODULE_7__sampler_AlwaysOffSampler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__sampler_AlwaysOnSampler__ = __webpack_require__(541);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AlwaysOnSampler", function() { return __WEBPACK_IMPORTED_MODULE_8__sampler_AlwaysOnSampler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sampler_ParentBasedSampler__ = __webpack_require__(938);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ParentBasedSampler", function() { return __WEBPACK_IMPORTED_MODULE_9__sampler_ParentBasedSampler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__sampler_TraceIdRatioBasedSampler__ = __webpack_require__(939);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "TraceIdRatioBasedSampler", function() { return __WEBPACK_IMPORTED_MODULE_10__sampler_TraceIdRatioBasedSampler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Sampler__ = __webpack_require__(376);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SamplingDecision", function() { return __WEBPACK_IMPORTED_MODULE_11__Sampler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Span__ = __webpack_require__(934);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Span", function() { return __WEBPACK_IMPORTED_MODULE_12__Span__["a"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */













//# sourceMappingURL=index.js.map

/***/ }),
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__export_BatchSpanProcessor__ = __webpack_require__(2016);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__export_BatchSpanProcessor__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RandomIdGenerator__ = __webpack_require__(2015);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__RandomIdGenerator__["a"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


//# sourceMappingURL=index.js.map

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlwaysOffSampler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sampler__ = __webpack_require__(376);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Sampler that samples no traces. */
var AlwaysOffSampler = /** @class */ (function () {
    function AlwaysOffSampler() {
    }
    AlwaysOffSampler.prototype.shouldSample = function () {
        return {
            decision: __WEBPACK_IMPORTED_MODULE_0__Sampler__["a" /* SamplingDecision */].NOT_RECORD,
        };
    };
    AlwaysOffSampler.prototype.toString = function () {
        return 'AlwaysOffSampler';
    };
    return AlwaysOffSampler;
}());

//# sourceMappingURL=AlwaysOffSampler.js.map

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlwaysOnSampler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sampler__ = __webpack_require__(376);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** Sampler that samples all traces. */
var AlwaysOnSampler = /** @class */ (function () {
    function AlwaysOnSampler() {
    }
    AlwaysOnSampler.prototype.shouldSample = function () {
        return {
            decision: __WEBPACK_IMPORTED_MODULE_0__Sampler__["a" /* SamplingDecision */].RECORD_AND_SAMPLED,
        };
    };
    AlwaysOnSampler.prototype.toString = function () {
        return 'AlwaysOnSampler';
    };
    return AlwaysOnSampler;
}());

//# sourceMappingURL=AlwaysOnSampler.js.map

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = popperGenerator;
/* unused harmony export createPopper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_utils_getCompositeRect_js__ = __webpack_require__(2026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_getLayoutRect_js__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_utils_listScrollParents_js__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_utils_getOffsetParent_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_orderModifiers_js__ = __webpack_require__(2041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_debounce_js__ = __webpack_require__(2036);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_mergeByName_js__ = __webpack_require__(2040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_detectOverflow_js__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dom_utils_instanceOf_js__ = __webpack_require__(125);
/* unused harmony reexport detectOverflow */









var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__dom_utils_instanceOf_js__["a" /* isElement */])(reference) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_utils_listScrollParents_js__["a" /* default */])(reference) : reference.contextElement ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_utils_listScrollParents_js__["a" /* default */])(reference.contextElement) : [],
          popper: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_utils_listScrollParents_js__["a" /* default */])(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_orderModifiers_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_mergeByName_js__["a" /* default */])([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getCompositeRect_js__["a" /* default */])(reference, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_utils_getOffsetParent_js__["a" /* default */])(popper), state.options.strategy === 'fixed'),
          popper: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_utils_getLayoutRect_js__["a" /* default */])(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_debounce_js__["a" /* default */])(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}
var createPopper = /*#__PURE__*/popperGenerator(); // eslint-disable-next-line import/no-unused-modules



/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLayoutRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__ = __webpack_require__(305);
 // Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__["a" /* default */])(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWindowScroll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(151);

function getWindowScroll(node) {
  var win = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWindowScrollBarX;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getWindowScroll_js__ = __webpack_require__(544);



function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__["a" /* default */])(element)).left + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getWindowScroll_js__["a" /* default */])(element).scrollLeft;
}

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isScrollParent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getComputedStyle_js__ = __webpack_require__(306);

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getComputedStyle_js__["a" /* default */])(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_utils_getNodeName_js__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_instanceOf_js__ = __webpack_require__(125);

 // This modifier takes the styles prepared by the `computeStyles` modifier
// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_utils_instanceOf_js__["b" /* isHTMLElement */])(element) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getNodeName_js__["a" /* default */])(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_utils_instanceOf_js__["b" /* isHTMLElement */])(element) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getNodeName_js__["a" /* default */])(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect,
  requires: ['computeStyles']
});

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export mapToStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_getOffsetParent_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_utils_getWindow_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_utils_getDocumentElement_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__dom_utils_getComputedStyle_js__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_getBasePlacement_js__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_getVariation_js__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_math_js__ = __webpack_require__(217);







 // eslint-disable-next-line import/no-unused-modules

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_math_js__["a" /* round */])(x * dpr) / dpr || 0,
    y: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_math_js__["a" /* round */])(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = __WEBPACK_IMPORTED_MODULE_0__enums_js__["j" /* left */];
  var sideY = __WEBPACK_IMPORTED_MODULE_0__enums_js__["i" /* top */];
  var win = window;

  if (adaptive) {
    var offsetParent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_utils_getOffsetParent_js__["a" /* default */])(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_utils_getWindow_js__["a" /* default */])(popper)) {
      offsetParent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_utils_getDocumentElement_js__["a" /* default */])(popper);

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__dom_utils_getComputedStyle_js__["a" /* default */])(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["i" /* top */] || (placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["j" /* left */] || placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["g" /* right */]) && variation === __WEBPACK_IMPORTED_MODULE_0__enums_js__["l" /* end */]) {
      sideY = __WEBPACK_IMPORTED_MODULE_0__enums_js__["h" /* bottom */];
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["j" /* left */] || (placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["i" /* top */] || placement === __WEBPACK_IMPORTED_MODULE_0__enums_js__["h" /* bottom */]) && variation === __WEBPACK_IMPORTED_MODULE_0__enums_js__["l" /* end */]) {
      sideX = __WEBPACK_IMPORTED_MODULE_0__enums_js__["g" /* right */];
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_utils_getWindow_js__["a" /* default */])(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_getBasePlacement_js__["a" /* default */])(state.placement),
    variation: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_getVariation_js__["a" /* default */])(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
});

/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dom_utils_getWindow_js__ = __webpack_require__(151);
 // eslint-disable-next-line import/no-unused-modules

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__dom_utils_getWindow_js__["a" /* default */])(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
});

/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_computeOffsets_js__ = __webpack_require__(954);


function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_computeOffsets_js__["a" /* default */])({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
});

/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMainAxisFromPlacement;
function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCompanyCurrencies = fetchCompanyCurrencies;
exports.giveLoginFromADFS = giveLoginFromADFS;
exports.redirectToLogin = redirectToLogin;
exports.checkAuthenticated = checkAuthenticated;
exports.logoutAndRedirect = logoutAndRedirect;

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

var _reactRouterRedux = __webpack_require__(13);

var _url = __webpack_require__(19);

var _selectors = __webpack_require__(1082);

var _actions = __webpack_require__(25);

var _apps = __webpack_require__(263);

var _groups = __webpack_require__(194);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _telemetry = __webpack_require__(1081);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint no-alert: 0 */


// The decoded Cognito ID token of the current session — the token fetchM sends to the APIs, whose
// `sub` the Go tiers stamp as user.id. Only telemetry calls it, and only while tracing runs.
var readIdTokenClaims = function readIdTokenClaims() {
  return _auth2.default.currentSession().then(function (session) {
    return session.getIdToken().decodePayload();
  });
};

var signInOauth = function signInOauth(provider, nextBase64) {
  return new Promise(function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
      var authConfig, oauth, clientId, domain, redirectSignIn, scope, responseType, query, url;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              authConfig = _auth2.default.configure();
              oauth = authConfig.oauth, clientId = authConfig.userPoolWebClientId;

              if (oauth) {
                _context.next = 4;
                break;
              }

              return _context.abrupt('return', reject());

            case 4:
              domain = oauth.domain, redirectSignIn = oauth.redirectSignIn, scope = oauth.scope, responseType = oauth.responseType;
              query = {
                client_id: clientId,
                response_type: responseType,
                scope: scope.join(' '),
                redirect_uri: redirectSignIn
              };


              if (provider) {
                query.identity_provider = provider.toUpperCase();
              }

              if (nextBase64) {
                query.state = nextBase64;
              }

              // The url of the Cognito Hosted UI
              url = (0, _url.parseParams)('https://' + domain + '/oauth2/authorize', query);

              // Launch hosted UI

              window.location.assign(url);
              return _context.abrupt('return', resolve());

            case 11:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }());
};

function requestLogin() {
  return {
    type: _actions.LOGIN_USER_REQUEST
  };
}

function loginError(message) {
  return {
    type: _actions.LOGIN_USER_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function giveHeadquartersAccess() {
  return {
    type: _actions.LOGIN_GIVE_HEADQUARTERS_ACCESS
  };
}

function giveMainHeadquartersAccess() {
  return {
    type: _actions.LOGIN_GIVE_MAIN_HEADQUARTERS_ACCESS
  };
}

function giveBranchLeaderSupervisorIIAccess() {
  return {
    type: _actions.LOGIN_GIVE_BRANCH_LEADER_SUPERVISOR_II_ACCESS
  };
}

function giveBranchLeaderSupervisorAccess() {
  return {
    type: _actions.LOGIN_GIVE_BRANCH_LEADER_SUPERVISOR_ACCESS
  };
}

function giveBranchLeaderAccess() {
  return {
    type: _actions.LOGIN_GIVE_BRANCH_LEADER_ACCESS
  };
}

function giveSuperAdminAccess() {
  return {
    type: _actions.LOGIN_GIVE_SUPER_ADMIN_ACCESS
  };
}

function giveAdminBasicAccess() {
  return {
    type: _actions.LOGIN_GIVE_ADMIN_BASIC_ACCESS
  };
}

function giveAdminCommunityAccess() {
  return {
    type: _actions.LOGIN_GIVE_ADMIN_COMMUNITY_ACCESS
  };
}

function giveAdminAccess() {
  return {
    type: _actions.LOGIN_GIVE_ADMIN_ACCESS
  };
}

function giveDeveloperAccess() {
  return {
    type: _actions.LOGIN_GIVE_DEVELOPER_ACCESS
  };
}

function giveDeveloperSupervisorAccess() {
  return {
    type: _actions.LOGIN_GIVE_DEVELOPER_SUPERVISOR
  };
}

function giveDeveloperSalesManagerAccess() {
  return {
    type: _actions.LOGIN_GIVE_DEVELOPER_SALES_MANAGER
  };
}

function giveDeveloperSalesAdminAccess() {
  return {
    type: _actions.LOGIN_GIVE_DEVELOPER_SALES_ADMIN
  };
}

function giveDeveloperStaffAccess() {
  return {
    type: _actions.LOGIN_GIVE_DEVELOPER_STAFF
  };
}

function giveExternalAgencyAdmin() {
  return {
    type: _actions.LOGIN_GIVE_EXTERNAL_AGENCY_ADMIN
  };
}

function giveExternalAgentAccess() {
  return {
    type: _actions.LOGIN_GIVE_EXTERNAL_AGENT
  };
}

function giveExternalAgentLeaderAccess() {
  return {
    type: _actions.LOGIN_GIVE_EXTERNAL_AGENT_LEADER
  };
}

function giveDeveloperSiteplanAccess() {
  return {
    type: _actions.LOGIN_GIVE_DEVELOPER_SITEPLAN_ACCESS
  };
}

function giveEditUnitPriceAccess() {
  return {
    type: _actions.LOGIN_GIVE_EDIT_UNIT_PRICE_ACCESS
  };
}

function giveEditUnitDetailsAccess() {
  return {
    type: _actions.LOGIN_GIVE_EDIT_UNIT_DETAIL_ACCESS
  };
}

function giveCreditCheckAccess() {
  return {
    type: _actions.APP_GIVE_CREDIT_CHECK_ACCESS
  };
}

function receiveLogin(payload) {
  (0, _error.userErrorIdentity)(payload);
  // OTEL-6: same hook Bugsnag uses to identify the user, for the same reason — a trace with no
  // caller cannot be tied back to whoever reported the problem. OTEL-95: user.id is the `sub` of
  // the session's ID token (never the username, which embeds an SSO user's email), read only
  // while tracing runs. No-op when tracing is disabled.
  (0, _telemetry.identifyEndUser)(payload, readIdTokenClaims);
  return {
    type: _actions.LOGIN_USER_SUCCESS,
    payload: payload
  };
}

function requestLogout() {
  return {
    type: _actions.LOGOUT_USER_REQUEST
  };
}

function completeLogout() {
  // Drop the caller, so the next session's spans cannot inherit the last user.
  (0, _telemetry.clearEndUser)();
  return {
    type: _actions.LOGOUT_USER_SUCCESS
  };
}

function fetchCompanyCurrencies() {
  var _this = this;

  return function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var _getState, auth, response;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _getState = getState(), auth = _getState.auth;
              _context2.prev = 1;
              _context2.next = 4;
              return (0, _fetchM.serverRequestGet)('/company/' + auth.company.id + '/currency/', { dispatch: dispatch });

            case 4:
              response = _context2.sent;

              if (!response.error) {
                _context2.next = 7;
                break;
              }

              return _context2.abrupt('return', null);

            case 7:
              return _context2.abrupt('return', dispatch({
                type: 'companyCurrency',
                payload: {
                  data: response.data || []
                }
              }));

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](1);

              Bugsnag.notifyException(_context2.t0);
              return _context2.abrupt('return', null);

            case 14:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this, [[1, 10]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
}

function giveLoginFromADFS(provider) {
  return {
    type: _actions.LOGIN_FROM_ADFS,
    payload: {
      provider: provider
    }
  };
}

function redirectToLogin() {
  var next = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';

  return function () {
    var nextBase64 = '';
    if (next) {
      try {
        nextBase64 = btoa('' + window.location.origin + next + (window.location.search || ''));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }
    var provider = (0, _selectors.getStateAdfsProvider)();
    if (provider) {
      signInOauth(provider, nextBase64);
    } else {
      window.location.href = _config2.default.get('startURL') + '/login?redirect=' + nextBase64;
    }
  };
}

function isBranchLeader(groups) {
  return groups.some(function (group) {
    return group.code === _groups.DEVELOPER_BRANCH_LEADER;
  });
}

function isBranchLeaderSupervisorII(groups) {
  return groups.some(function (group) {
    return group.code === _groups.DEVELOPER_BRANCH_LEADER_SUPERVISOR_II;
  });
}

function isBranchLeaderSupervisor(groups) {
  return groups.some(function (group) {
    return group.code === _groups.DEVELOPER_BRANCH_LEADER_SUPERVISOR;
  });
}

function isHeadquarters(groups) {
  return groups.some(function (group) {
    return group.code === _groups.DEVELOPER_HEADQUARTERS;
  });
}

function isDeveloper(groups) {
  return groups.some(function (group) {
    return group.code === _groups.DEVELOPER_EXECUTIVE;
  });
}

function isDeveloperAgentLeader(groups) {
  return groups.some(function (group) {
    return group.code === _groups.DEVELOPER_AGENT_LEADER;
  });
}

function isDeveloperAgencyAdmin(groups) {
  return groups.some(function (group) {
    return group.code === _groups.DEVELOPER_AGENCY_ADMIN;
  });
}

function isDeveloperSupervisor(groups) {
  return isDeveloper(groups) && isBranchLeader(groups) && isBranchLeaderSupervisorII(groups) && isBranchLeaderSupervisor(groups);
}

function isDeveloperSalesManager(groups) {
  return isDeveloper(groups) && isBranchLeader(groups) && isBranchLeaderSupervisorII(groups) && !isBranchLeaderSupervisor(groups);
}

function isDeveloperSalesAdmin(groups) {
  return isDeveloper(groups) && isBranchLeader(groups) && !isBranchLeaderSupervisorII(groups) && !isBranchLeaderSupervisor(groups);
}

function isDeveloperStaff(groups, affiliate) {
  return isDeveloper(groups) && !isBranchLeader(groups) && !isBranchLeaderSupervisorII(groups) && !isBranchLeaderSupervisor(groups) && !isHeadquarters(groups) && affiliate && affiliate.companyBranch && !affiliate.companyBranch.isExternal;
}

function isExternalAgentLeader(groups, affiliate) {
  return isDeveloper(groups) && isDeveloperAgentLeader(groups) && affiliate && affiliate.companyBranch && affiliate.companyBranch.isExternal;
}

function isExternalAgent(groups, affiliate) {
  return isDeveloper(groups) && !isDeveloperAgentLeader(groups) && affiliate && affiliate.companyBranch && affiliate.companyBranch.isExternal;
}

function isExternalAgencyAdmin(groups, affiliate) {
  return isDeveloper(groups) && isDeveloperAgencyAdmin(groups) && affiliate && affiliate.companyBranch && affiliate.companyBranch.isExternal;
}

function isDeveloperSiteplan(groups) {
  return groups.some(function (group) {
    return group.code === _groups.DEVELOPER_SITEPLAN;
  });
}

function isMainHeadquarters(affiliate) {
  return affiliate.companyBranchID === affiliate.company.headquartersBranchID;
}

function isSuperAdmin(groups) {
  return groups.some(function (group) {
    return group.code === _groups.SUPER_ADMIN;
  });
}

function isAdminBasic(groups) {
  return groups.some(function (group) {
    return group.code === _groups.ADMIN_BASIC;
  });
}

function isAdminCommunity(groups) {
  return groups.some(function (group) {
    return group.code === _groups.ADMIN_COMMUNITY;
  });
}

function isAdmin(groups) {
  return groups.some(function (group) {
    return group.code === _groups.ADMIN;
  });
}

function checkGroupAccess(groups, affiliate) {
  return function (dispatch) {
    if (groups) {
      if (isHeadquarters(groups)) {
        dispatch(giveHeadquartersAccess());
        if (isMainHeadquarters(affiliate)) {
          dispatch(giveMainHeadquartersAccess());
        }
        if (affiliate && affiliate.access) {
          var _affiliate$access = affiliate.access,
              allowEditUnitPrice = _affiliate$access.allowEditUnitPrice,
              allowEditUnitDetails = _affiliate$access.allowEditUnitDetails;

          if (allowEditUnitPrice) {
            dispatch(giveEditUnitPriceAccess());
          }
          if (allowEditUnitDetails) {
            dispatch(giveEditUnitDetailsAccess());
          }
        }
      }
      if (isBranchLeader(groups)) {
        dispatch(giveBranchLeaderAccess());
        if (affiliate && affiliate.access) {
          var _affiliate$access2 = affiliate.access,
              _allowEditUnitPrice = _affiliate$access2.allowEditUnitPrice,
              _allowEditUnitDetails = _affiliate$access2.allowEditUnitDetails;

          if (_allowEditUnitPrice) {
            dispatch(giveEditUnitPriceAccess());
          }
          if (_allowEditUnitDetails) {
            dispatch(giveEditUnitDetailsAccess());
          }
        }
      }
      if (isBranchLeaderSupervisor(groups)) {
        dispatch(giveBranchLeaderSupervisorAccess());
      }
      if (isBranchLeaderSupervisorII(groups)) {
        dispatch(giveBranchLeaderSupervisorIIAccess());
      }
      if (isSuperAdmin(groups)) {
        dispatch(giveSuperAdminAccess());
        dispatch(giveEditUnitPriceAccess());
        dispatch(giveEditUnitDetailsAccess());
      }
      if (isDeveloper(groups)) {
        dispatch(giveDeveloperAccess());
      }
      if (isDeveloperSupervisor(groups)) {
        dispatch(giveDeveloperSupervisorAccess());
      }
      if (isDeveloperSalesManager(groups)) {
        dispatch(giveDeveloperSalesManagerAccess());
      }
      if (isDeveloperSalesAdmin(groups)) {
        dispatch(giveDeveloperSalesAdminAccess());
      }
      if (isDeveloperStaff(groups, affiliate)) {
        dispatch(giveDeveloperStaffAccess());
      }
      if (isExternalAgentLeader(groups, affiliate)) {
        dispatch(giveExternalAgentLeaderAccess());
      }
      if (isExternalAgent(groups, affiliate)) {
        dispatch(giveExternalAgentAccess());
      }
      if (isExternalAgencyAdmin(groups, affiliate)) {
        dispatch(giveExternalAgencyAdmin());
      }
      if (isDeveloperSiteplan(groups)) {
        dispatch(giveDeveloperSiteplanAccess());
      }
      if (isAdminBasic(groups)) {
        dispatch(giveAdminBasicAccess());
      }
      if (isAdminCommunity(groups)) {
        dispatch(giveAdminCommunityAccess());
      }
      if (isAdmin(groups)) {
        dispatch(giveAdminAccess());
      }
    }
  };
}

function checkCreditCheckAccess() {
  var companyApps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  return function (dispatch) {
    var ccApp = companyApps.find(function (a) {
      return a.appID === 'credit_check';
    });
    if (ccApp && ccApp.hasAccess) {
      dispatch(giveCreditCheckAccess());
    }
  };
}

function checkAuthenticated(nextBase64) {
  var opts = {
    credentials: 'include',
    headers: {
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    }
  };
  return function (dispatch) {
    dispatch(requestLogin());
    return dispatch((0, _fetchM.fetchM)(_config2.default.get('apiURL') + '/authenticated/', opts)).then(function (res) {
      return res.json();
    }).then(function (payload) {
      var bookApiURL = void 0;
      var loanTrackerURL = void 0;
      var apps = payload.affiliate && payload.affiliate.company && payload.affiliate.company.apps ? payload.affiliate.company.apps : [];
      var groups = payload.groups || [];
      if (isSuperAdmin(groups)) {
        bookApiURL = prompt('Enter 3 Character Code or SR API URL: ', _config2.default.get('env') === 'development' ? 'http://api.mhub.local:9000' : 'hub');
      } else if (apps.length > 0) {
        var app = payload.affiliate.company.apps.find(function (a) {
          return a.appID === _apps.SHOWROOM;
        });
        var loanApp = payload.affiliate.company.apps.find(function (a) {
          return a.appID === _apps.LOAN_TRACKER;
        });
        if (app) {
          bookApiURL = app.apiURL;
          if (app.webURL) {
            // check if current URL matches app web URL config
            var currentURL = (0, _url.getLocation)(window.location.href);
            var bookURL = (0, _url.getLocation)(app.webURL);
            if (bookURL.host !== currentURL.host) {
              var startURL = _config2.default.get('startURL');
              window.location.href = startURL;
            }
          }
        }
        if (loanApp) {
          loanTrackerURL = loanApp.webURL;
        }
      }
      if (loanTrackerURL) {
        _config2.default.set('loanTrackerURL', loanTrackerURL);
      }
      if (bookApiURL) {
        var bApiURL = bookApiURL;
        if (bookApiURL.length === 3 && _config2.default.get('server') === 'uat') {
          bApiURL = 'https://book-api-' + bookApiURL.toLowerCase() + '.uat.mhub.my';
        } else if (bookApiURL.length === 3 && _config2.default.get('env') !== 'development') {
          bApiURL = 'https://book-api-' + bookApiURL.toLowerCase() + '.mhub.my';
        }
        _config2.default.set('bookApiURL', bApiURL);
        // OTEL-6: the Showroom API host is per-tenant and only known here, so the traceparent
        // allowlist cannot be built at init from config alone. Both web instrumentations re-read
        // propagateTraceHeaderCorsUrls per request, so registering now covers every later call.
        // No-op when tracing is disabled.
        (0, _telemetry.registerTracePropagationOrigin)(bApiURL);
      } else {
        var err = new Error('Showroom API not defined');
        var metadata = { payload: { data: JSON.stringify(payload) } };
        Bugsnag.notifyException(err, 'Auth error', metadata);
        dispatch((0, _reactRouterRedux.push)('/forbidden/'));
        return;
      }
      dispatch(receiveLogin(payload));
      dispatch(checkGroupAccess(groups, payload.affiliate));
      dispatch(checkCreditCheckAccess(apps));
      var redirect = '/';
      if (nextBase64) {
        try {
          redirect = atob(nextBase64);
        } catch (e) {
          Bugsnag.notifyException(e);
        }
      }
      dispatch((0, _reactRouterRedux.replace)(redirect));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, loginError));
    });
  };
}

function logoutAndRedirect() {
  var _this2 = this;

  return function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return dispatch(requestLogout());

            case 2:
              _context3.next = 4;
              return dispatch(completeLogout());

            case 4:
              window.location.href = _config2.default.get('startURL') + '/logout';
              return _context3.abrupt('return', Promise.resolve());

            case 6:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));

    return function (_x7) {
      return _ref3.apply(this, arguments);
    };
  }();
}

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCurrencySetting = fetchCurrencySetting;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function currencySettingsRequest() {
  return {
    type: _actions.CURRENCY_SETTINGS_REQUEST
  };
}

function currencySettingsSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.CURRENCY_SETTINGS_SUCCESS,
    payload: {
      data: data,
      token: token
    }
  };
}

function currencySettingsError(message) {
  return {
    type: _actions.CURRENCY_SETTINGS_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchCurrencySetting() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch, getState) {
    var _getState = getState(),
        auth = _getState.auth;

    var token = null;
    var reload = false;
    var companyID = '';
    if (auth && auth.company && auth.company.id) {
      companyID = auth.company.id;
    }
    dispatch(currencySettingsRequest());
    if (!fresh) {
      var currencySettingData = {};
      try {
        currencySettingData = JSON.parse((0, _storage.getItem)(_config2.default.get('appName') + '.currencySetting')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!currencySettingData.data || _config2.default.get('version') !== currencySettingData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(currencySettingData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(currencySettingsSuccess(currencySettingData.data));
        return Promise.resolve();
      }
    }
    return dispatch((0, _fetchM.fetchM)('/company/' + companyID + '/currency_setting/', {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        (0, _storage.setItem)(_config2.default.get('appName') + '.currencySetting', JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(currencySettingsSuccess(data, token));
    }).catch(function (err) {
      dispatch((0, _error.handleError)(err, currencySettingsError));
    });
  };
}

/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchProjectUnitSpecifications = fetchProjectUnitSpecifications;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function projectUnitSpecificationsRequest() {
  return {
    type: _actions.PROJECT_UNIT_SPECIFICATIONS_REQUEST
  };
}

function projectUnitSpecificationsSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.PROJECT_UNIT_SPECIFICATIONS_SUCCESS,
    payload: {
      data: data,
      token: token
    }
  };
}

function projectUnitSpecificationsError(message) {
  return {
    type: _actions.PROJECT_UNIT_SPECIFICATIONS_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchProjectUnitSpecifications() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(projectUnitSpecificationsRequest());
    if (!fresh) {
      var projectUnitSpecificationsData = {};
      try {
        projectUnitSpecificationsData = JSON.parse((0, _storage.getItem)(_config2.default.get('appName') + '.projectUnitSpecifications')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!projectUnitSpecificationsData.data || _config2.default.get('version') !== projectUnitSpecificationsData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(projectUnitSpecificationsData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(projectUnitSpecificationsSuccess(projectUnitSpecificationsData.data));
        return Promise.resolve();
      }
    }
    var q = Object.assign({
      limit: 0
    });
    return dispatch((0, _fetchM.fetchM)('/specifications/units/?' + _qs2.default.stringify(q), {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        (0, _storage.setItem)(_config2.default.get('appName') + '.projectUnitSpecifications', JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(projectUnitSpecificationsSuccess(data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, projectUnitSpecificationsError));
    });
  };
}

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchTags = fetchTags;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function tagsRequest() {
  return {
    type: _actions.TAGS_REQUEST
  };
}

function tagsSuccess(type, data) {
  var token = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  return {
    type: _actions.TAGS_SUCCESS,
    payload: {
      type: type,
      data: data,
      token: token
    }
  };
}

function tagsError(message) {
  return {
    type: _actions.TAGS_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchTags(tagType) {
  var fresh = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(tagsRequest());
    if (!fresh) {
      var tagsData = {};
      try {
        tagsData = JSON.parse((0, _storage.getItem)(_config2.default.get('appName') + '.tags.' + tagType)) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!tagsData.data || _config2.default.get('version') !== tagsData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(tagsData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(tagsSuccess(tagType, tagsData.data));
        return Promise.resolve();
      }
    }
    var q = Object.assign({
      limit: 0
    });
    return dispatch((0, _fetchM.fetchM)('/tags/' + tagType + '/?' + _qs2.default.stringify(q), {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        (0, _storage.setItem)(_config2.default.get('appName') + '.tags.' + tagType, JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(tagsSuccess(tagType, data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, tagsError));
    });
  };
}

/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _BankIcon = __webpack_require__(2089);

var _BankIcon2 = _interopRequireDefault(_BankIcon);

var _ic_preferred_green = __webpack_require__(504);

var _ic_preferred_green2 = _interopRequireDefault(_ic_preferred_green);

var _HLBRewardsTag = __webpack_require__(2153);

var _HLBRewardsTag2 = _interopRequireDefault(_HLBRewardsTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SummaryTable = function SummaryTable(_ref) {
  var custom = _ref.custom,
      summary = _ref.summary;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return _react2.default.createElement(
    'small',
    null,
    _react2.default.createElement(
      _semanticUiReact.Table,
      { className: custom ? 'custom' : null, unstackable: true, fixed: true, basic: 'very', columns: 5, textAlign: 'center', size: 'small', compact: true },
      _react2.default.createElement(
        _semanticUiReact.Table.Header,
        { fullWidth: true },
        _react2.default.createElement(
          _semanticUiReact.Table.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.HeaderCell,
            null,
            t('Total', { ns: 'constants' })
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.HeaderCell,
            null,
            t('Pending', { ns: 'constants' })
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.HeaderCell,
            null,
            t('Approved', { ns: 'constants' })
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.HeaderCell,
            null,
            t('Success', { ns: 'constants' })
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.HeaderCell,
            null,
            t('Rejected', { ns: 'constants' })
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Body,
        null,
        summary && summary.length > 0 ? _react2.default.createElement(
          _semanticUiReact.Table.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            summary[0].count
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            summary[0].pendingCount
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            summary[0].approvedCount
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            summary[0].successCount
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            summary[0].rejectCount
          )
        ) : _react2.default.createElement(
          _semanticUiReact.Table.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            '0'
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            '0'
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            '0'
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            '0'
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            '0'
          )
        )
      )
    )
  );
};

SummaryTable.propTypes = {
  custom: _propTypes2.default.bool,
  summary: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    count: _propTypes2.default.number
  }))
};

var checkBankerUserIsOnboarding = function checkBankerUserIsOnboarding(banker) {
  return banker.user && banker.user.statusID === '200';
};

var BankerItem = function BankerItem(_ref2) {
  var custom = _ref2.custom,
      className = _ref2.className,
      _onClick = _ref2.onClick,
      onPoint = _ref2.onPoint,
      banker = _ref2.banker,
      selected = _ref2.selected,
      disabled = _ref2.disabled,
      checkable = _ref2.checkable,
      leftComponent = _ref2.leftComponent,
      rightComponent = _ref2.rightComponent,
      showSummary = _ref2.showSummary,
      isHLBCampaign = _ref2.isHLBCampaign,
      isHLBCampaignBank = _ref2.isHLBCampaignBank;

  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  var mobile = 15;
  if (!checkable && rightComponent) {
    mobile = 9;
    if (banker.directToBank && banker.bank.logoSrc) {
      mobile = 12;
    }
  }
  return _react2.default.createElement(
    _semanticUiReact.Grid,
    {
      columns: 'equal',
      verticalAlign: 'middle',
      className: 'banker-item ' + (className || '') + ' ' + (!isHLBCampaign && checkBankerUserIsOnboarding(banker) && 'inactive-case dark'),
      onClick: function onClick(event) {
        if (!disabled && _onClick) {
          _onClick(event, banker);
        }
      }
    },
    leftComponent || checkable ? _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { textAlign: 'center', mobile: 2, tablet: 2, computer: 1 },
      checkable ? _react2.default.createElement(_semanticUiReact.Checkbox, {
        checked: selected,
        disabled: disabled,
        readOnly: true
      }) : leftComponent
    ) : null,
    isHLBCampaign && _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { textAlign: 'center', mobile: 3, tablet: 2, computer: 2 },
      _react2.default.createElement(_BankIcon2.default, { bankID: banker.bankID, type: 'round' })
    ),
    isHLBCampaign || checkable || rightComponent ? null : _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { textAlign: 'center', mobile: 3, tablet: 2, computer: leftComponent ? 1 : 2 },
      _react2.default.createElement(_BankIcon2.default, { bankID: banker.bankID, type: 'round' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid,
        { columns: 1 },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { columns: 'equal' },
              checkable && !rightComponent || banker.directToBank && banker.bank.logoSrc ? null : _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { mobile: 3, tablet: 4, computer: 3 },
                _react2.default.createElement(_BankIcon2.default, { bankID: banker.bankID, type: 'round' })
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  mobile: mobile,
                  tablet: 12,
                  computer: 11
                },
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  {
                    as: 'h4',
                    className: 'clickable',
                    onClick: onPoint
                  },
                  banker.directToBank && banker.bank.logoSrc ? _react2.default.createElement(
                    _semanticUiReact.Header.Content,
                    { style: { display: 'inline-flex', alignItems: 'center' } },
                    _react2.default.createElement(_semanticUiReact.Image, { src: banker.bank.logoSrc, style: { maxHeight: '35px' } }),
                    banker.bank.isExclusive ? _react2.default.createElement(
                      _semanticUiReact.Header.Subheader,
                      { style: { display: 'flex', color: '#21BA45', alignItems: 'center', fontWeight: '100', marginLeft: '0.5em' } },
                      _react2.default.createElement(_semanticUiReact.Image, { src: _ic_preferred_green2.default, height: '15', style: { marginRight: '0.25em' } }),
                      showSummary ? '' : 'Preferred'
                    ) : null
                  ) : _react2.default.createElement(
                    _semanticUiReact.Header.Content,
                    null,
                    _react2.default.createElement(
                      'span',
                      { style: { marginRight: '.3em' } },
                      banker.name
                    ),
                    banker.isFeatured && _react2.default.createElement(
                      'span',
                      { style: { color: 'orange', marginLeft: '0.25em' } },
                      '\u2605'
                    ),
                    banker.bankTeamBanker && banker.bankTeamBanker.isTeamLeader && _react2.default.createElement(_semanticUiReact.Popup, {
                      trigger: _react2.default.createElement(
                        _semanticUiReact.Icon.Group,
                        { className: 'team-leader', size: 'small' },
                        _react2.default.createElement(_semanticUiReact.Icon, { size: 'big', color: 'blue', name: 'certificate' }),
                        _react2.default.createElement(_semanticUiReact.Icon, { size: 'small', name: 'user', inverted: true })
                      ),
                      content: t('Team Leader', { ns: 'translation' }),
                      inverted: true,
                      position: 'top center'
                    }),
                    (checkBankerUserIsOnboarding(banker) || banker.pendingOnboarding) && _react2.default.createElement(_semanticUiReact.Label, { style: { marginLeft: 0 }, size: 'tiny', color: 'orange', content: t('Pending Registration', { ns: 'translation' }) }),
                    _react2.default.createElement(
                      _semanticUiReact.Header.Subheader,
                      null,
                      _react2.default.createElement(
                        'p',
                        null,
                        banker.mobilePrefix,
                        banker.mobile
                      ),
                      banker.bank ? banker.bank.name : null,
                      ' ',
                      banker.bankBranch ? banker.bankBranch.name : null
                    )
                  )
                )
              ),
              custom && rightComponent ? _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { className: custom ? 'computer-hide' : null, textAlign: 'right', mobile: 4, tablet: 2, computer: rightComponent ? 2 : 1 },
                rightComponent
              ) : null
            )
          ),
          showSummary ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { only: checkable ? null : 'mobile' },
            _react2.default.createElement(SummaryTable, { custom: custom, summary: banker.summary })
          ) : null
        )
      )
    ),
    !checkable && showSummary ? _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { textAlign: 'right', tablet: 7, computer: 6, className: 'mobile-hide' },
      _react2.default.createElement(SummaryTable, { custom: custom, summary: banker.summary })
    ) : null,
    isHLBCampaignBank && _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { textAlign: 'center', mobile: 3, tablet: 2, computer: 5, style: { display: 'flex', alignItems: 'end' } },
      _react2.default.createElement(_HLBRewardsTag2.default, null)
    ),
    !isHLBCampaign && (checkable || rightComponent) ? _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { className: custom ? 'mobile-hide' : null, textAlign: 'center', mobile: 4, tablet: 2, computer: rightComponent ? 3 : 2 },
      rightComponent || (banker.directToBank && banker.bank.logoSrc ? null : _react2.default.createElement(_BankIcon2.default, { bankID: banker.bankID, type: 'round' }))
    ) : null
  );
};

BankerItem.propTypes = {
  custom: _propTypes2.default.bool,
  className: _propTypes2.default.string,
  onClick: _propTypes2.default.func,
  onPoint: _propTypes2.default.func,
  selected: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  checkable: _propTypes2.default.bool,
  banker: _propTypes2.default.shape({
    preferredName: _propTypes2.default.string
  }),
  leftComponent: _propTypes2.default.node,
  rightComponent: _propTypes2.default.node,
  showSummary: _propTypes2.default.bool,
  isHLBCampaign: _propTypes2.default.bool,
  isHLBCampaignBank: _propTypes2.default.bool
};

exports.default = BankerItem;

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BookingSteppers = function (_Component) {
  _inherits(BookingSteppers, _Component);

  function BookingSteppers() {
    _classCallCheck(this, BookingSteppers);

    return _possibleConstructorReturn(this, (BookingSteppers.__proto__ || Object.getPrototypeOf(BookingSteppers)).apply(this, arguments));
  }

  _createClass(BookingSteppers, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          step = _props.step,
          totalSteps = _props.totalSteps,
          lastStepLabel = _props.lastStepLabel,
          t = _props.t;


      return _react2.default.createElement(
        'div',
        null,
        totalSteps === 3 ? _react2.default.createElement(
          _semanticUiReact.Grid,
          { className: 'booking-steppers', centered: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 5 },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'booking-steppers-left' },
              step === 1 ? _react2.default.createElement(
                _semanticUiReact.Label,
                { className: 'active', circular: true },
                '1'
              ) : _react2.default.createElement(
                _semanticUiReact.Label,
                { color: 'blue', className: 'checkmark', circular: true },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'booking-steppers-divider-col ' + (step > 1 ? 'active' : '') },
              _react2.default.createElement(_semanticUiReact.Divider, { className: '' + (step >= 2 ? 'complete' : '') })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'booking-steppers-middle' },
              step <= 2 ? _react2.default.createElement(
                _semanticUiReact.Label,
                { className: '' + (step === 2 ? 'active' : ''), circular: true },
                '2'
              ) : _react2.default.createElement(
                _semanticUiReact.Label,
                { color: 'blue', className: 'checkmark', circular: true },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'booking-steppers-divider-col ' + (step > 2 ? 'active' : '') },
              _react2.default.createElement(_semanticUiReact.Divider, { className: '' + (step >= 3 ? 'complete' : '') })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'booking-steppers-right' },
              _react2.default.createElement(
                _semanticUiReact.Label,
                { className: '' + (step === 3 ? 'active' : ''), circular: true },
                '3'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'label-row', textAlign: 'center' },
            _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'tablet computer', tablet: 2, computer: 2 }),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 6, tablet: 5, computer: 5 },
              _react2.default.createElement(_semanticUiReact.Header, { as: 'h4', content: t('Basic details') })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 4, tablet: 2, computer: 2 },
              _react2.default.createElement(_semanticUiReact.Header, { as: 'h4', content: t('Payment') })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 6, tablet: 5, computer: 5 },
              _react2.default.createElement(_semanticUiReact.Header, { as: 'h4', content: t('Mortgage') })
            ),
            _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'tablet computer', tablet: 2, computer: 2 })
          )
        ) : '',
        totalSteps === 2 ? _react2.default.createElement(
          _semanticUiReact.Grid,
          { className: 'booking-steppers', centered: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 5 },
            _react2.default.createElement(_semanticUiReact.Grid.Column, null),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'booking-steppers-left' },
              step === 1 ? _react2.default.createElement(
                _semanticUiReact.Label,
                { className: 'active', circular: true },
                '1'
              ) : _react2.default.createElement(
                _semanticUiReact.Label,
                { color: 'blue', className: 'checkmark', circular: true },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'booking-steppers-divider-col ' + (step > 1 ? 'active' : '') },
              _react2.default.createElement(_semanticUiReact.Divider, { className: '' + (step >= 2 ? 'complete' : '') })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'booking-steppers-right' },
              _react2.default.createElement(
                _semanticUiReact.Label,
                { className: '' + (step === 2 ? 'active' : ''), circular: true },
                '2'
              )
            ),
            _react2.default.createElement(_semanticUiReact.Grid.Column, null)
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'label-row' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 7, textAlign: 'right' },
              _react2.default.createElement(_semanticUiReact.Header, { as: 'h4', content: t('Basic details') })
            ),
            _react2.default.createElement(_semanticUiReact.Grid.Column, { width: 2 }),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 7, textAlign: 'left' },
              _react2.default.createElement(_semanticUiReact.Header, { as: 'h4', content: '' + (lastStepLabel && lastStepLabel !== '' ? lastStepLabel : t('Mortgage')) })
            )
          )
        ) : ''
      );
    }
  }]);

  return BookingSteppers;
}(_react.Component);

BookingSteppers.propTypes = {
  step: _propTypes2.default.number,
  totalSteps: _propTypes2.default.number,
  lastStepLabel: _propTypes2.default.string
};
BookingSteppers.defaultProps = {
  step: 1,
  totalSteps: 3
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(BookingSteppers);

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */


var BookingSectionTab = function (_Component) {
  _inherits(BookingSectionTab, _Component);

  function BookingSectionTab(props) {
    _classCallCheck(this, BookingSectionTab);

    var _this = _possibleConstructorReturn(this, (BookingSectionTab.__proto__ || Object.getPrototypeOf(BookingSectionTab)).call(this, props));

    _initialiseProps.call(_this);

    var state = BookingSectionTab.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(BookingSectionTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = BookingSectionTab.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isMobile = _props.isMobile,
          t = _props.t;
      var _state = this.state,
          isSticky = _state.isSticky,
          loading = _state.loading,
          tabs = _state.tabs,
          tabID = _state.tabID;

      var filteredTabs = tabs.filter(function (tab) {
        return !tab.disabled;
      });
      return _react2.default.createElement(
        'div',
        null,
        isSticky ? _react2.default.createElement(
          _semanticUiReact.Button.Group,
          { className: 'booking_section_tabs sticky', compact: true, fluid: true, size: isMobile ? 'mini' : 'tiny', disabled: loading },
          filteredTabs.map(function (tab, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Button,
              { key: idx, active: tabID === tab.id, onClick: function onClick(e) {
                  return _this2.handleTabClick(e, tab);
                }, style: isMobile ? { fontSize: '0.65rem' } : {} },
              t(tab.title).toUpperCase()
            );
          })
        ) : isMobile ? _react2.default.createElement(
          _semanticUiReact.Button.Group,
          { className: 'booking_section_tabs', compact: true, fluid: true, size: 'mini', disabled: loading },
          filteredTabs.map(function (tab, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Button,
              { key: idx, active: tabID === tab.id, onClick: function onClick(e) {
                  return _this2.handleTabClick(e, tab);
                } },
              t(tab.title).toUpperCase()
            );
          })
        ) : _react2.default.createElement(
          _semanticUiReact.Button.Group,
          { className: 'booking_section_tabs', fluid: true, disabled: loading },
          filteredTabs.map(function (tab, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Button,
              { key: idx, active: tabID === tab.id, onClick: function onClick(e) {
                  return _this2.handleTabClick(e, tab);
                } },
              _react2.default.createElement(
                _semanticUiReact.Header,
                { as: 'h4', inverted: tabID === tab.id },
                t(tab.title).toUpperCase(),
                _react2.default.createElement(
                  _semanticUiReact.Header.Subheader,
                  null,
                  t(tab.description)
                )
              )
            );
          })
        )
      );
    }
  }]);

  return BookingSectionTab;
}(_react.Component);

BookingSectionTab.propTypes = {
  isMobile: _propTypes2.default.bool,
  isSticky: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  onTabChange: _propTypes2.default.func,
  tabs: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  tabID: _propTypes2.default.number
};
BookingSectionTab.defaultProps = {
  isMobile: false,
  tabID: 1
};

BookingSectionTab.getPropsToState = function (props) {
  var bookingID = props.bookingID || '';
  var isSticky = props.isSticky;
  var loading = props.loading;
  var tabs = props.tabs || [];
  var tabID = props.tabID;
  return {
    bookingID: bookingID,
    isSticky: isSticky,
    loading: loading,
    tabs: tabs,
    tabID: tabID
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleTabClick = function (e, tab) {
    var isSticky = _this3.state.isSticky;

    e.preventDefault();
    _this3.setState({ tabID: tab.id }, function () {
      if (_this3.props.onTabChange) {
        _this3.props.onTabChange(_extends({}, tab, {
          isSticky: isSticky
        }));
      }
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(BookingSectionTab);

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/forbid-prop-types */


var COUNTDOWN_NOT_STARTED = 1;
var COUNTDOWN_STARTED = 2;
var COUNTDOWN_FINISHED = 3;

var Countdown = function (_Component) {
  _inherits(Countdown, _Component);

  function Countdown(props) {
    _classCallCheck(this, Countdown);

    var _this = _possibleConstructorReturn(this, (Countdown.__proto__ || Object.getPrototypeOf(Countdown)).call(this, props));

    _this.componentDidMount = function () {
      _this.startTimeout = setTimeout(_this.start, _this.props.startDelay);
    };

    _this.componentDidUpdate = function (prevProps) {
      // A finished countdown has cleared its interval; a new target must start it again.
      // Skip invalid targets: NaN never equals NaN, so they would restart on every update.
      var next = (0, _momentTimezone2.default)(_this.props.targetDate);
      if (next.isValid() && (0, _momentTimezone2.default)(prevProps.targetDate).valueOf() !== next.valueOf()) {
        clearTimeout(_this.startTimeout);
        clearInterval(_this.state.intervalId);
        _this.start();
      }
    };

    _this.componentWillUnmount = function () {
      clearTimeout(_this.startTimeout);
      clearInterval(_this.state.intervalId);
    };

    _this.start = function () {
      var timer = setInterval(function () {
        _this.tick();
      }, _this.props.interval);

      _this.setState({
        status: COUNTDOWN_STARTED,
        intervalId: timer
      });

      _this.tick();
    };

    _this.calculateRemainingTime = function () {
      return Math.max(0, (0, _momentTimezone2.default)(_this.props.targetDate).diff((0, _momentTimezone2.default)()));
    };

    _this.addLeadingZero = function (value) {
      if (value < 10) {
        return '0' + value.toString();
      }
      return value;
    };

    _this.tick = function () {
      // Branch on the freshly computed value, not this.state: inside a React batch (e.g. a
      // restart from componentDidUpdate) setState is deferred and the state read would be stale.
      var remainingTime = _this.calculateRemainingTime();
      _this.setState({ remainingTime: remainingTime }, function () {
        if (_this.props.onChange) _this.props.onChange(remainingTime);
      });

      if (remainingTime <= 0) {
        _this.setState({
          status: COUNTDOWN_FINISHED
        });

        if (_this.props.onFinished) {
          _this.props.onFinished();
        }
        clearInterval(_this.state.intervalId);
      }
    };

    _this.renderRemainingTime = function () {
      var html = [];
      var _this$props = _this.props,
          format = _this$props.format,
          leadingZero = _this$props.leadingZero,
          timeSeparator = _this$props.timeSeparator,
          showLegend = _this$props.showLegend,
          showUnit = _this$props.showUnit,
          t = _this$props.t;
      var remainingTime = _this.state.remainingTime;

      if (format.day) {
        var daysLeft = _momentTimezone2.default.duration(remainingTime).asDays();
        if (leadingZero) {
          daysLeft = _this.addLeadingZero(daysLeft);
        }
        var dayText = Math.trunc(daysLeft);
        if (showLegend || showUnit) {
          dayText = t('{{count}}' + (showLegend ? ' days' : '') + (showUnit ? ' d' : ''), { count: Math.trunc(daysLeft) });
        }
        html.push(_react2.default.createElement(
          'span',
          { className: 'react-cntdwn-day', key: 'day' },
          dayText,
          timeSeparator
        ));
      }

      if (format.hour) {
        var hours = _momentTimezone2.default.duration(remainingTime).get('hours');
        if (leadingZero) {
          hours = _this.addLeadingZero(hours);
        }
        var hourText = hours;
        if (showLegend || showUnit) {
          hourText = t('{{count}}' + (showLegend ? ' hours' : '') + (showUnit ? ' h' : ''), { count: hours });
        }
        html.push(_react2.default.createElement(
          'span',
          { className: 'react-cntdwn-hour', key: 'hour' },
          hourText,
          timeSeparator
        ));
      }

      if (format.minute) {
        var minutes = _momentTimezone2.default.duration(remainingTime).get('minutes');
        if (leadingZero) {
          minutes = _this.addLeadingZero(minutes);
        }
        var minuteText = minutes;
        if (showLegend || showUnit) {
          minuteText = t('{{count}}' + (showLegend ? ' minutes' : '') + (showUnit ? ' m' : ''), { count: minutes });
        }
        html.push(_react2.default.createElement(
          'span',
          { className: 'react-cntdwn-minute', key: 'minute' },
          minuteText,
          timeSeparator
        ));
      }

      if (format.second) {
        var seconds = _momentTimezone2.default.duration(remainingTime).get('seconds');
        if (leadingZero) {
          seconds = _this.addLeadingZero(seconds);
        }
        var secondText = seconds;
        if (showLegend || showUnit) {
          secondText = t('{{count}}' + (showLegend ? ' seconds' : '') + (showUnit ? ' s' : ''), { count: seconds });
        }
        html.push(_react2.default.createElement(
          'span',
          { className: 'react-cntdwn-second', key: 'second' },
          secondText
        ));
      }

      return html;
    };

    _this.render = function () {
      if (_this.state.status === COUNTDOWN_NOT_STARTED) {
        return _react2.default.createElement('span', null);
      }
      return _react2.default.createElement(
        'div',
        { className: 'react-cntdwn-timer' },
        _this.renderRemainingTime()
      );
    };

    _this.state = {
      remainingTime: 0,
      status: COUNTDOWN_NOT_STARTED,
      intervalId: null
    };
    return _this;
  }

  // Never negative: an expired target renders zeros, not "0-9 m" or "NaN d".


  return Countdown;
}(_react.Component);

Countdown.propTypes = {
  targetDate: _propTypes2.default.instanceOf(Date).isRequired,
  interval: _propTypes2.default.number,
  startDelay: _propTypes2.default.number,
  onFinished: _propTypes2.default.func,
  format: _propTypes2.default.object,
  timeSeparator: _propTypes2.default.string,
  leadingZero: _propTypes2.default.bool,
  showLegend: _propTypes2.default.bool,
  showUnit: _propTypes2.default.bool,
  onChange: _propTypes2.default.func
};

Countdown.defaultProps = {
  interval: 1000,
  startDelay: 0,
  format: {
    hour: 'HH',
    minute: 'mm',
    second: 'ss'
  },
  timeSeparator: ' ',
  leadingZero: false,
  showLegend: false,
  showUnit: false
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(Countdown);

/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditImage = function (_Component) {
  _inherits(EditImage, _Component);

  function EditImage(props) {
    _classCallCheck(this, EditImage);

    var _this = _possibleConstructorReturn(this, (EditImage.__proto__ || Object.getPrototypeOf(EditImage)).call(this, props));

    _initialiseProps.call(_this);

    var degree = props.degree || 0;
    _this.state = {
      degree: degree,
      image: null
    };
    _this.canvas = null;
    _this.hasClick = false;
    return _this;
  }

  _createClass(EditImage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getOnClick();
      this.updateCanvas();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var degree = nextProps.degree;
      if (this.props.src !== nextProps.src) {
        this.setState({
          image: null
        }, function () {
          _this2.updateCanvas();
        });
      }
      this.setState({ degree: degree });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateCanvas();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.removeOnClick();
    }
  }, {
    key: 'getOnClick',
    value: function getOnClick() {
      if (this.props.onClick) {
        var canvas = this.canvas;
        canvas.addEventListener('click', this.handleOnClick, false);
        this.hasClick = true;
      }
    }
  }, {
    key: 'removeOnClick',
    value: function removeOnClick() {
      if (this.hasClick) {
        var canvas = this.canvas;
        canvas.removeEventListener('click', this.handleOnClick, false);
      }
    }
  }, {
    key: 'updateCanvas',
    value: function updateCanvas() {
      var canvas = this.canvas;
      var ctx = canvas.getContext('2d');
      var max = canvas.width > canvas.height ? canvas.width : canvas.height;
      ctx.clearRect(0, 0, max, max);
      // draw image
      if (!this.state.image) {
        var image = new Image();
        image.src = this.props.src;
        image.onload = function () {
          image.height = 450 * image.height / image.width;
          image.width = 450;
          canvas.width = image.width;
          canvas.height = image.height;
          ctx.drawImage(image, 0, 0, image.width, image.height);
        };
        this.setState({ image: image });
      } else {
        this.rotate(this.state.degree);
      }
    }
  }, {
    key: 'changeCanvasSize',
    value: function changeCanvasSize(degree) {
      var image = this.state.image;

      if (degree === 0 || degree === 180) {
        this.canvas.width = image.width;
        this.canvas.height = image.height;
      } else {
        this.canvas.width = image.height;
        this.canvas.height = image.width;
      }
    }
  }, {
    key: 'drawImage',
    value: function drawImage(degree) {
      var canvas = this.canvas;
      var ctx = canvas.getContext('2d');
      var image = this.state.image;

      ctx.save();
      ctx.translate(canvas.width / 2, canvas.height / 2);
      ctx.rotate(degree * Math.PI / 180);
      ctx.drawImage(image, -image.width * 0.5, -image.height * 0.5, image.width, image.height);
      ctx.restore();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement('canvas', {
        className: 'center',
        ref: function ref(_ref) {
          _this3.canvas = _ref;
        }
      });
    }
  }]);

  return EditImage;
}(_react.Component);

EditImage.propTypes = {
  src: _propTypes2.default.string.isRequired,
  degree: _propTypes2.default.number,
  onClick: _propTypes2.default.func
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleOnClick = function (e) {
    if (_this4.props.onClick) {
      _this4.props.onClick(e);
    }
  };

  this.rotate = function (degree) {
    _this4.changeCanvasSize(degree);
    _this4.drawImage(degree);
  };
};

exports.default = EditImage;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _tags = __webpack_require__(555);

var _valueToText = __webpack_require__(98);

var _valueToText2 = _interopRequireDefault(_valueToText);

var _translation = __webpack_require__(4);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable camelcase */


var GalleryList = function (_Component) {
  _inherits(GalleryList, _Component);

  function GalleryList(props) {
    _classCallCheck(this, GalleryList);

    var _this = _possibleConstructorReturn(this, (GalleryList.__proto__ || Object.getPrototypeOf(GalleryList)).call(this, props));

    _initialiseProps.call(_this);

    var tabs = [{ text: props.t('General'), name: 'general', value: 'general' }, { text: props.t('Site Plan'), name: 'site_plan', value: 'site_plan' }, { text: props.t('Unit Layout'), name: 'unit_layout', value: 'unit_layout' }, { text: props.t('Map'), name: 'map', value: 'map' }, { text: props.t('Video'), name: 'video', value: 'video' }];
    if (props.excludeType && props.excludeType.length > 0) {
      tabs = tabs.filter(function (tab) {
        return !props.excludeType.some(function (ex) {
          return ex === tab.name;
        });
      });
    }
    if (!props.editable && props.pictures && props.pictures.length > 0) {
      tabs = tabs.filter(function (tab) {
        return props.pictures.some(function (p) {
          return p.type === tab.name;
        });
      });
    }
    var currentTab = tabs && tabs[0] ? tabs[0].name : '';
    _this.state = {
      count: 0,
      limit: 0,
      offset: 0,
      loading: props.loading || true,
      data: [],
      currentPage: 1,
      searchTag: '',
      tabs: tabs,
      currentTab: currentTab
    };
    return _this;
  }

  _createClass(GalleryList, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;

      store.dispatch((0, _tags.fetchTags)('picture', true));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.currentTab === 'video') {
        this.fetchMedias();
      } else {
        this.fetchPictures();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var loading = nextProps.loading;
      if (loading !== undefined) {
        this.setState({ loading: loading });
      }
      // Update tabs when language changes (t function changes)
      if (nextProps.t !== this.props.t) {
        this.updateTabs(nextProps.t);
      }
    }
  }, {
    key: 'updateTabs',
    value: function updateTabs(t) {
      var _this2 = this;

      var tabs = [{ text: t('General'), name: 'general', value: 'general' }, { text: t('Site Plan'), name: 'site_plan', value: 'site_plan' }, { text: t('Unit Layout'), name: 'unit_layout', value: 'unit_layout' }, { text: t('Map'), name: 'map', value: 'map' }, { text: t('Video'), name: 'video', value: 'video' }];
      if (this.props.excludeType && this.props.excludeType.length > 0) {
        tabs = tabs.filter(function (tab) {
          return !_this2.props.excludeType.some(function (ex) {
            return ex === tab.name;
          });
        });
      }
      if (!this.props.editable && this.props.pictures && this.props.pictures.length > 0) {
        tabs = tabs.filter(function (tab) {
          return _this2.props.pictures.some(function (p) {
            return p.type === tab.name;
          });
        });
      }
      this.setState({ tabs: tabs });
    }
  }, {
    key: 'setData',
    value: function setData() {
      var _this3 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this3.setState({
          data: data || []
        }, function () {
          res(data);
          if (_this3.props.onChange) {
            _this3.props.onChange(data);
          }
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this4 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this4.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this5 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this5.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchMedias',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this6 = this;

        var store, t, query, projectURL, layoutURL, url, res, message, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = {
                  page: this.state.currentPage || 1,
                  type: 'video',
                  oembed: true
                };
                projectURL = this.props.projectID ? '/projects/' + this.props.projectID : '';
                layoutURL = this.props.unitLayoutID ? '/unit_layouts/' + this.props.unitLayoutID : '';
                url = projectURL.concat(layoutURL, '/medias/?' + _qs2.default.stringify(query));
                res = void 0;
                _context.prev = 9;
                _context.next = 12;
                return store.dispatch((0, _fetchM.fetchM)(url, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context.sent;
                _context.next = 23;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](9);

                Bugsnag.notifyException(_context.t0);
                _context.next = 20;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 20:
                _context.next = 22;
                return this.setLoading(false);

              case 22:
                return _context.abrupt('return');

              case 23:
                if (res.ok) {
                  _context.next = 31;
                  break;
                }

                _context.next = 26;
                return res.text();

              case 26:
                message = _context.sent;
                _context.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 29:
                _context.next = 45;
                break;

              case 31:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context.next = 36;
                return res.json();

              case 36:
                data = _context.sent;
                _context.next = 39;
                return this.setData(data);

              case 39:
                if (!(this.state.data.length < 1 && query.page > 1)) {
                  _context.next = 43;
                  break;
                }

                this.setState({ currentPage: 1 }, function () {
                  _this6.fetchMedias();
                });
                _context.next = 45;
                break;

              case 43:
                _context.next = 45;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 45:
                _context.next = 47;
                return this.setLoading(false);

              case 47:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 15]]);
      }));

      function fetchMedias() {
        return _ref.apply(this, arguments);
      }

      return fetchMedias;
    }()
  }, {
    key: 'fetchPictures',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this7 = this;

        var store, t, query, projectURL, layoutURL, url, res, message, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({
                  page: this.state.currentPage || 1,
                  tab: this.state.currentTab || (this.props.tabs && this.props.tabs.length > 0 ? this.props.tabs[0].name : 'general'),
                  search: this.state.currentTab === 'general' ? this.state.searchTag : ''
                });
                projectURL = this.props.projectID ? '/projects/' + this.props.projectID : '';
                layoutURL = this.props.unitLayoutID ? '/unit_layouts/' + this.props.unitLayoutID : '';
                url = projectURL.concat(layoutURL, '/pictures/?' + _qs2.default.stringify(query));
                res = void 0;
                _context2.prev = 9;
                _context2.next = 12;
                return store.dispatch((0, _fetchM.fetchM)(url, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context2.sent;
                _context2.next = 23;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](9);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 20;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 20:
                _context2.next = 22;
                return this.setLoading(false);

              case 22:
                return _context2.abrupt('return');

              case 23:
                if (res.ok) {
                  _context2.next = 31;
                  break;
                }

                _context2.next = 26;
                return res.text();

              case 26:
                message = _context2.sent;
                _context2.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 29:
                _context2.next = 45;
                break;

              case 31:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context2.next = 36;
                return res.json();

              case 36:
                data = _context2.sent;
                _context2.next = 39;
                return this.setData(data);

              case 39:
                if (!(this.state.data.length < 1 && query.page > 1)) {
                  _context2.next = 43;
                  break;
                }

                this.setState({ currentPage: 1 }, function () {
                  _this7.fetchPictures();
                });
                _context2.next = 45;
                break;

              case 43:
                _context2.next = 45;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 45:
                _context2.next = 47;
                return this.setLoading(false);

              case 47:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[9, 15]]);
      }));

      function fetchPictures() {
        return _ref2.apply(this, arguments);
      }

      return fetchPictures;
    }()
  }, {
    key: 'checkTabular',
    value: function checkTabular() {
      if (this.props.editable) {
        return this.state.data.length > 0 ? 5 : 1;
      }
      return 5;
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var _this8 = this;

      var t = this.props.t;
      var _state = this.state,
          data = _state.data,
          tabs = _state.tabs,
          currentTab = _state.currentTab,
          loading = _state.loading;

      var pictureNode = data.map(function (item, key) {
        if (currentTab === 'video') {
          return _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'center', key: key },
            _react2.default.createElement(_LoadImage2.default, {
              as: 'a',
              size: 'small',
              shape: 'rounded',
              onClick: function onClick(e) {
                return _this8.handleViewLarge(e, item, 'video');
              },
              src: _this8.getThumbnailUrl(item),
              isVideo: true
            }),
            _react2.default.createElement(
              'p',
              {
                style: {
                  margin: '0.5em 1em 0',
                  textAlign: 'center',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  fontSize: '0.9em'
                },
                onClick: function onClick(e) {
                  return _this8.handleViewLarge(e, item, 'video');
                }
              },
              item.label
            )
          );
        }
        return _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { textAlign: 'center', key: key },
          _react2.default.createElement(_LoadImage2.default, {
            as: 'a',
            size: 'small',
            shape: 'rounded',
            onClick: function onClick(e) {
              return _this8.handleViewLarge(e, item, 'picture');
            },
            picture: item,
            pictureSize: 30
          })
        );
      });
      var tab = (0, _valueToText2.default)(tabs, currentTab).toLowerCase();
      return data.length > 0 ? pictureNode : _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: '16' },
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { textAlign: 'center', vertical: true },
          _react2.default.createElement(
            _reactI18next.Trans,
            { ns: _translation.TRANSLATION_FILES.screens },
            currentTab === 'video' ? _react2.default.createElement(
              'p',
              null,
              'No videos found.'
            ) : _react2.default.createElement(
              'p',
              null,
              'No ',
              { tab: tab },
              ' pictures found.'
            )
          ),
          this.props.editable && (this.props.onAdd || this.props.addPath || this.props.addVideoPath) ? _react2.default.createElement(
            _semanticUiReact.Button,
            {
              as: this.props.addPath || this.props.addVideoPath ? _reactRouter.Link : 'a',
              primary: true, compact: true,
              disabled: loading,
              onClick: this.handleOnAdd,
              to: currentTab === 'video' && this.props.addVideoPath ? this.props.addVideoPath : this.props.addPath
            },
            t('Click here to add')
          ) : null
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Menu,
          {
            fluid: true,
            attached: 'top',
            tabular: this.props.tabular
          },
          this.props.tabular ? this.state.tabs.map(function (tab, key) {
            return _react2.default.createElement(
              _semanticUiReact.Menu.Item,
              {
                key: key,
                name: tab.name,
                onClick: _this9.handleChangeTab,
                active: _this9.state.currentTab === tab.name
              },
              tab.text
            );
          }) : _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: this.state.tabs,
            onChange: this.handleChangeTab,
            value: this.state.currentTab,
            disabled: this.state.loading,
            noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
          }),
          _react2.default.createElement(
            _semanticUiReact.Menu.Menu,
            { position: 'right' },
            _react2.default.createElement(_PageNav2.default, {
              attached: 'top',
              size: 'small',
              currentPage: this.state.currentPage,
              count: this.state.count,
              limit: this.state.limit,
              offset: this.state.offset,
              dataSize: this.state.data.length,
              loading: this.state.loading,
              onChange: this.handleChangePage,
              noScrollTop: true
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { attached: 'bottom' },
          this.renderTags(),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            {
              doubling: this.state.data.length > 0,
              columns: this.checkTabular(),
              verticalAlign: 'middle'
            },
            _react2.default.createElement(
              _semanticUiReact.Dimmer,
              { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
              _react2.default.createElement(
                _semanticUiReact.Loader,
                { inline: 'centered' },
                t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
              )
            ),
            this.renderContent()
          )
        )
      );
    }
  }]);

  return GalleryList;
}(_react.Component);

GalleryList.propTypes = {
  pictures: _propTypes2.default.arrayOf(_propTypes2.default.object),
  tabular: _propTypes2.default.bool,
  projectID: _propTypes2.default.string,
  unitLayoutID: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  onViewLarge: _propTypes2.default.func,
  onAdd: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  addPath: _propTypes2.default.string,
  addVideoPath: _propTypes2.default.string,
  editable: _propTypes2.default.bool,
  excludeType: _propTypes2.default.arrayOf(_propTypes2.default.string),
  tags: _propTypes2.default.arrayOf(_propTypes2.default.object),
  t: _propTypes2.default.func
};
GalleryList.contextTypes = {
  store: _propTypes2.default.object
};

GalleryList.mapStateToProps = function (state) {
  return {
    tags: state.tags.data && state.tags.data.picture ? state.tags.data.picture : []
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this10 = this;

  this.getThumbnailUrl = function (media) {
    if (media && media.data && media.data.thumbnail_url) {
      return media.data.thumbnail_url;
    }
    return '';
  };

  this.handleChangePage = function (currentPage) {
    _this10.setState({ currentPage: currentPage }, function () {
      _this10.fetchPictures();
    });
  };

  this.handleChangeTab = function (e, _ref3) {
    var name = _ref3.name,
        value = _ref3.value;

    var currentTab = name || value;
    _this10.setState({ currentTab: currentTab }, function () {
      if (currentTab === 'video') {
        _this10.fetchMedias();
      } else {
        _this10.fetchPictures();
      }
    });
  };

  this.handleViewLarge = function (e, data, type) {
    if (_this10.props.onViewLarge) {
      _this10.props.onViewLarge(e, data, type);
    }
  };

  this.handleOnAdd = function (e) {
    if (_this10.props.onAdd) {
      _this10.props.onAdd(e);
    }
  };

  this.handleOnTagClick = function () {
    var searchTag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _this10.setState({ searchTag: searchTag }, function () {
      _this10.fetchPictures();
    });
  };

  this.checkTagSelected = function (value) {
    var searchTag = _this10.state.searchTag;

    if (value === 'All') {
      return searchTag === '';
    }
    return searchTag === value;
  };

  this.renderTags = function () {
    var _props = _this10.props,
        tags = _props.tags,
        t = _props.t;
    var currentTab = _this10.state.currentTab;

    if (tags.length > 0 && currentTab === 'general') {
      var newTags = [{ name: 'All' }].concat(tags);
      return _react2.default.createElement(
        _semanticUiReact.Label.Group,
        { style: { marginBottom: '1em' } },
        newTags.map(function (nt, idx) {
          return _react2.default.createElement(
            _semanticUiReact.Label,
            {
              key: idx,
              as: 'a',
              onClick: function onClick() {
                return _this10.handleOnTagClick(nt.name === 'All' ? '' : nt.name);
              },
              color: _this10.checkTagSelected(nt.name) ? 'blue' : null
            },
            nt.name === 'All' ? t('All', { ns: _translation.TRANSLATION_FILES.translation }) : nt.name
          );
        })
      );
    }
    return null;
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(GalleryList.mapStateToProps, null, null, { withRef: true })(GalleryList));

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRouter = __webpack_require__(18);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LPPSAChecker = function (_Component) {
  _inherits(LPPSAChecker, _Component);

  function LPPSAChecker(props) {
    _classCallCheck(this, LPPSAChecker);

    var _this = _possibleConstructorReturn(this, (LPPSAChecker.__proto__ || Object.getPrototypeOf(LPPSAChecker)).call(this, props));

    _initialiseProps.call(_this);

    var state = LPPSAChecker.getPropsToState(props);
    _this.state = _extends({}, state, {
      token: props.token,
      file: null
    });
    return _this;
  }

  _createClass(LPPSAChecker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = LPPSAChecker.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'submitFile',
    value: function submitFile(body) {
      var _this4 = this;

      this.setLoading(true);
      var store = this.context.store;
      var data = this.state.data;

      var url = void 0;
      switch (this.props.type) {
        case 'booking':
          url = '/bookings/' + this.props.bookingID + '/customer/' + data.id + '/lppsa/';
          break;
        case 'customer':
          url = '/customers/' + data.id + '/lppsa/';
          break;
        default:
          break;
      }
      store.dispatch((0, _fetchM.fetchM)(url, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'X-Csrf-Token': this.props.token
        },
        body: body
      })).then(function (res) {
        _this4.setLoading(false);
        res.text().then(function (message) {
          var json = JSON.parse(message);
          if (json) {
            data.lppsaResultID = json.id;
            data.lppsaResult.name = json.name;
            data.lppsaResult.key = json.key;
            _this4.setState({ data: data }, function () {
              if (_this4.props.onChange) _this4.props.onChange(data);
              store.dispatch((0, _flash.flashMessage)({ header: 'Upload Success', message: 'File Successfully Uploaded', icon: 'checkmark', type: 'success', autoHideDuration: 10000 }));
            });
          }
        });
      }).catch(function (err) {
        _this4.setLoading(false);
        if (err.res && err.res.status >= 400 && err.res.status < 500) {
          err.res.text().then(function (message) {
            store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
          });
          _this4.setState({ file: null });
          return;
        }
        store.dispatch((0, _flash.flashErrorMessage)(err));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var newHeader = this.props.newHeader;
      var _state = this.state,
          file = _state.file,
          data = _state.data;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            'Loading'
          )
        ),
        _react2.default.createElement(
          'form',
          {
            encType: 'multipart/form-data',
            onSubmit: this.handleSubmit,
            ref: function ref(_ref2) {
              _this5.form = _ref2;
            },
            style: { display: 'none' }
          },
          'Select file to upload:',
          _react2.default.createElement('input', {
            id: 'lppsa_upload',
            name: 'lppsa_upload',
            onChange: this.handleOnChange,
            ref: function ref(_ref) {
              _this5.lppsa_upload = _ref;
            },
            type: 'file'
          })
        ),
        newHeader && _react2.default.createElement(
          _semanticUiReact.Header,
          { className: 'new_title', as: 'h5', attached: 'top' },
          newHeader
        ),
        _react2.default.createElement(
          _semanticUiReact.Segment,
          {
            attached: newHeader ? true : false,
            textAlign: 'center'
          },
          _react2.default.createElement(
            'p',
            null,
            'Please ensure popups are not blocked, ',
            _react2.default.createElement('br', null),
            'Clicking this will bring you to a new tab, ',
            _react2.default.createElement('br', null),
            'Download the attachment and upload below, ',
            _react2.default.createElement('br', null)
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            {
              as: 'a',
              className: 'ui medium primary button',
              to: 'http://www.lppsa.gov.my/v2/kalkulator-pembiayaan/',
              target: '_blank'
            },
            'Check eligibility in LPPSA'
          ),
          _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { centered: true, padded: true },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { style: { padding: '0 0 0.5em' } },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { mobile: 16, tablet: 10, computer: 7, textAlign: 'left' },
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    'LPPSA Result Page Screenshot'
                  )
                ),
                file && file.name || data.lppsaResult && data.lppsaResult.name ? _react2.default.createElement(
                  _semanticUiReact.Message,
                  {
                    className: 'import_file_selcted',
                    info: true,
                    onDismiss: this.handleDismiss,
                    size: 'tiny'
                  },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    {
                      as: 'a',
                      to: data.lppsaResult ? _config2.default.get('bookApiURL') + '/customers/' + data.id + '/lppsa/' + data.lppsaResultID + '/' + data.lppsaResult.name : '#',
                      target: '_blank'
                    },
                    _react2.default.createElement(
                      'b',
                      null,
                      file && file.name || data.lppsaResult && data.lppsaResult.name
                    )
                  )
                ) : _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    basic: true,
                    fluid: true,
                    onClick: this.handleAddFile,
                    style: { marginBottom: '0.5em' }
                  },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus' }),
                  ' Upload file'
                ),
                _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    'Select Result Status'
                  )
                ),
                _react2.default.createElement(_semanticUiReact.Dropdown, {
                  disabled: this.state.loading,
                  fluid: true,
                  onChange: this.handleOnDDChange,
                  options: this.LPPSA_STATUS,
                  placeholder: 'Select Status',
                  selection: true,
                  selectOnBlur: false,
                  value: data.lppsaResultStatusID
                })
              )
            )
          )
        )
      );
    }
  }]);

  return LPPSAChecker;
}(_react.Component);

LPPSAChecker.contextTypes = {
  store: _propTypes2.default.object
};
LPPSAChecker.propTypes = {
  loading: _propTypes2.default.bool,
  token: _propTypes2.default.string,
  type: _propTypes2.default.oneOf(['booking', 'customer']).isRequired,
  bookingID: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  newHeader: _propTypes2.default.string
};
LPPSAChecker.defaultData = {
  lppsaResultStatusID: '',
  lppsaResultID: '',
  lppsaResult: {
    name: '',
    key: ''
  }
};

LPPSAChecker.getPropsToState = function (props) {
  var token = props.token;
  var loading = props.loadng;
  var data = Object.assign({}, LPPSAChecker.defaultData, props.data);
  return {
    data: data,
    token: token,
    loading: loading
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.handleAddFile = function (e) {
    e.preventDefault();
    _this6.lppsa_upload.click();
  };

  this.handleOnChange = function () {
    var files = Array.prototype.slice.call(_this6.lppsa_upload.files);
    _this6.lppsa_upload.value = null;
    if (window.FileReader) {
      files.forEach(function (file) {
        var reader = new FileReader();
        reader.onloadend = function () {
          _this6.setState({ file: file }, function () {
            _this6.handleSubmit();
          });
        };
        reader.readAsDataURL(file);
      });
    }
  };

  this.handleSubmit = function () {
    var formData = new FormData();
    formData.append('lppsa_upload', _this6.state.file);
    _this6.submitFile(formData);
  };

  this.handleDismiss = function () {
    var data = _this6.state.data;

    data.lppsaResult.name = '';
    data.lppsaResult.key = '';
    data.lppsaResultID = '';
    _this6.setState({ file: null, data: data }, function () {
      if (_this6.props.onChange) _this6.props.onChange(data);
    });
  };

  this.handleOnDDChange = function (e, _ref3) {
    var value = _ref3.value;

    e.preventDefault();
    var data = _this6.state.data;

    data.lppsaResultStatusID = value;
    _this6.setState({ data: data }, function () {
      if (_this6.props.onChange) _this6.props.onChange(data);
    });
  };

  this.LPPSA_STATUS = [{ text: 'Passed', value: 'Passed' }, { text: 'Failed', value: 'Failed' }];
};

exports.default = LPPSAChecker;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MappingPresetList = function (_Component) {
  _inherits(MappingPresetList, _Component);

  function MappingPresetList(props) {
    _classCallCheck(this, MappingPresetList);

    var _this = _possibleConstructorReturn(this, (MappingPresetList.__proto__ || Object.getPrototypeOf(MappingPresetList)).call(this, props));

    _this.handleCheckIsDefaultPreset = function (preset) {
      var type = _this.props.type;

      var defaultPresets = [];
      if (type === 'projects') {
        defaultPresets = ['financing_accounting_tool_name', 'registered_financial_accounting_code', 'registered_project_name', 'registered_company_name', 'registered_admin_full_name', 'registered_admin_id'];
      }
      if (type === 'affiliates') {
        defaultPresets = ['registered_sales_agency_name', 'registered_salesperson_name'];
      }
      if (type === 'cancellation_reasons') {
        defaultPresets = ['cancelled_by_developer', 'change_of_unit_default'];
      }
      return defaultPresets.includes(preset);
    };

    _this.handleChangePage = function (currentPage) {
      _this.setState({ currentPage: currentPage }, function () {
        _this.fetchMappings(_this.props.where);
      });
    };

    _this.handleCancelDelete = function (e) {
      e.preventDefault();
      _this.setState({
        showConfirm: false,
        selectedPreset: null
      });
    };

    _this.handleDelete = function (e, selectedPreset) {
      e.preventDefault();
      _this.setState({
        selectedPreset: selectedPreset
      }, function () {
        _this.setState({
          showConfirm: true
        });
      });
    };

    _this.handleConfirmDelete = function (e) {
      e.preventDefault();
      _this.setState({
        showConfirm: false
      }, function () {
        _this.deletePreset(_this.state.selectedPreset.id);
      });
    };

    _this.state = {
      count: 0,
      limit: 0,
      offset: 0,
      loading: props.loading || true,
      data: [],
      currentPage: 1,
      showConfirm: false,
      selectedPreset: null
    };
    return _this;
  }

  _createClass(MappingPresetList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchMappings(this.props.where);
    }
  }, {
    key: 'setMappings',
    value: function setMappings() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this2.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchMapping',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var store, t, res, token, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                token = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/' + this.renderPath() + '/' + id + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 15:
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                return _context.abrupt('return', null);

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 27;
                break;

              case 26:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

              case 27:
                return _context.abrupt('return', token);

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchMapping(_x4) {
        return _ref.apply(this, arguments);
      }

      return fetchMapping;
    }()
  }, {
    key: 'fetchMappings',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var where = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var store, t, query, res, message, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, where);

                query.page = this.state.currentPage || 1;
                res = void 0;
                _context2.prev = 7;
                _context2.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/' + this.renderPath() + '/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 10:
                res = _context2.sent;
                _context2.next = 21;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](7);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 18:
                _context2.next = 20;
                return this.setLoading(false);

              case 20:
                return _context2.abrupt('return');

              case 21:
                if (res.ok) {
                  _context2.next = 29;
                  break;
                }

                _context2.next = 24;
                return res.text();

              case 24:
                message = _context2.sent;
                _context2.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 27:
                _context2.next = 39;
                break;

              case 29:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context2.next = 34;
                return res.json();

              case 34:
                data = _context2.sent;
                _context2.next = 37;
                return this.setMappings(data);

              case 37:
                _context2.next = 39;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 39:
                _context2.next = 41;
                return this.setLoading(false);

              case 41:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 13]]);
      }));

      function fetchMappings() {
        return _ref2.apply(this, arguments);
      }

      return fetchMappings;
    }()
  }, {
    key: 'deletePreset',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id) {
        var t, store, token, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                _context3.next = 4;
                return this.fetchMapping(id);

              case 4:
                token = _context3.sent;
                _context3.next = 7;
                return this.setState({ loading: true });

              case 7:
                _context3.prev = 7;
                _context3.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/' + this.renderPath() + '/' + id + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': token
                  }
                }));

              case 10:
                _context3.next = 24;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](7);

                Bugsnag.notifyException(_context3.t0);

                if (!(_context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 23;
                  break;
                }

                _context3.next = 18;
                return _context3.t0.res.text();

              case 18:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                _context3.next = 22;
                return this.setState({ loading: false });

              case 22:
                return _context3.abrupt('return');

              case 23:
                store.dispatch((0, _flash.flashErrorMessage)(_context3.t0));

              case 24:
                _context3.next = 26;
                return this.setState({ loading: false });

              case 26:
                this.handleChangePage(1);
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Preset successfully deleted', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 28:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[7, 12]]);
      }));

      function deletePreset(_x6) {
        return _ref3.apply(this, arguments);
      }

      return deletePreset;
    }()
  }, {
    key: 'renderPath',
    value: function renderPath() {
      var type = this.props.type;

      if (type !== 'cancellation_reasons') {
        return 'mappings/' + type;
      }
      return type;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state = this.state,
          count = _state.count,
          limit = _state.limit,
          offset = _state.offset,
          loading = _state.loading,
          currentPage = _state.currentPage;
      var t = this.props.t;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_DeleteConfirm2.default, {
          open: this.state.showConfirm,
          onClose: this.handleCancelDelete,
          onConfirm: this.handleConfirmDelete,
          name: this.state.selectedPreset ? this.state.selectedPreset.name : ''
        }),
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 20 },
            active: this.state.loading && this.state.data.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            striped: true, unstackable: true,
            selectable: true
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 4 },
                _react2.default.createElement(_semanticUiReact.Button, {
                  as: _reactRouter.Link,
                  primary: true,
                  size: 'small',
                  icon: 'add',
                  content: t('Preset'),
                  to: '/settings/' + this.renderPath() + '/new/'
                }),
                this.props.headerNode ? this.props.headerNode({
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: this.state.data.length,
                  loading: loading,
                  currentPage: currentPage,
                  onChange: this.handleChangePage
                }) : _react2.default.createElement(_PageNav2.default, {
                  floated: 'right',
                  currentPage: currentPage,
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: this.state.data.length,
                  loading: loading,
                  onChange: this.handleChangePage
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 4 },
                t('Name')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 4 },
                t('Short Name')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 2 },
                t('Description')
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            this.state.data.length > 0 ? this.state.data.map(function (field, key) {
              return _react2.default.createElement(
                _semanticUiReact.Table.Row,
                { key: key },
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { width: 4 },
                  _this5.handleCheckIsDefaultPreset(field.id) ? _react2.default.createElement(
                    'span',
                    { style: { color: '#4183c4' } },
                    field.name
                  ) : _react2.default.createElement(
                    _reactRouter.Link,
                    {
                      to: '/settings/' + _this5.renderPath() + '/' + field.id + '/'
                    },
                    field.name
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { width: 4 },
                  field.shortName
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  field.description || '-'
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { collapsing: true, textAlign: 'right' },
                  !_this5.handleCheckIsDefaultPreset(field.id) && _react2.default.createElement(_semanticUiReact.Button, {
                    compact: true,
                    negative: true,
                    type: 'button',
                    size: 'tiny',
                    icon: 'cancel',
                    onClick: function onClick(e) {
                      return _this5.handleDelete(e, field);
                    }
                  })
                )
              );
            }) : _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 4, textAlign: 'center' },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                ) : _react2.default.createElement(
                  'p',
                  null,
                  t('No presets found'),
                  '.'
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Footer,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 4, textAlign: 'right' },
                this.props.footerNode ? this.props.footerNode({
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: this.state.data.length,
                  loading: loading,
                  currentPage: currentPage,
                  onChange: this.handleChangePage
                }) : _react2.default.createElement(_PageNav2.default, {
                  upward: true,
                  currentPage: currentPage,
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: this.state.data.length,
                  loading: loading,
                  onChange: this.handleChangePage
                })
              )
            )
          )
        )
      );
    }
  }]);

  return MappingPresetList;
}(_react.Component);

MappingPresetList.contextTypes = {
  store: _propTypes2.default.object
};
MappingPresetList.propTypes = {
  headerNode: _propTypes2.default.func,
  footerNode: _propTypes2.default.func,
  where: _propTypes2.default.shape({
    limit: _propTypes2.default.number
  }),
  loading: _propTypes2.default.bool,
  type: _propTypes2.default.oneOf(['affiliates', 'projects', 'cancellation_reasons']).isRequired,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(MappingPresetList);

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _translation = __webpack_require__(4);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PictureItem = function (_Component) {
  _inherits(PictureItem, _Component);

  function PictureItem(props) {
    _classCallCheck(this, PictureItem);

    var _this = _possibleConstructorReturn(this, (PictureItem.__proto__ || Object.getPrototypeOf(PictureItem)).call(this, props));

    _this.handleShowDimmed = function () {
      _this.setState({ active: true });
    };

    _this.handleHideDimmed = function () {
      _this.setState({ active: false });
    };

    _this.handleTagClick = function (tag) {
      if (_this.props.onTagClick) {
        _this.props.onTagClick(tag);
      }
    };

    _this.state = {
      active: false
    };
    return _this;
  }

  _createClass(PictureItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;
      var active = this.state.active;

      return _react2.default.createElement(
        _semanticUiReact.Card,
        { className: this.props.fixedSize ? 'picture-item-fixed-size' : 'picture-item' },
        _react2.default.createElement(
          _semanticUiReact.Dimmer.Dimmable,
          {
            dimmed: active,
            className: 'center',
            onMouseEnter: function onMouseEnter() {
              return _this2.handleShowDimmed();
            },
            onMouseLeave: this.handleHideDimmed
          },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: active },
            this.props.onViewLarge ? _react2.default.createElement(_semanticUiReact.Button, {
              primary: true,
              icon: 'zoom',
              content: t('View', { ns: _translation.TRANSLATION_FILES.translation }),
              onClick: function onClick(e) {
                return _this2.props.onViewLarge(e);
              }
            }) : null,
            this.props.onRemove ? _react2.default.createElement(_semanticUiReact.Label, {
              as: 'a',
              corner: true,
              color: 'red',
              icon: 'close',
              onClick: function onClick(e) {
                return _this2.props.onRemove(e);
              }
            }) : null
          ),
          _react2.default.createElement(_LoadImage2.default, {
            centered: true,
            asBackground: this.props.fixedSize,
            size: this.props.size,
            picture: this.props.picture,
            pictureSize: this.props.pictureSize,
            labelNode: this.props.labelNode,
            extension: this.props.extension
          })
        ),
        this.props.hideTags ? null : _react2.default.createElement(
          _semanticUiReact.Card.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Label.Group,
            { size: 'tiny' },
            this.props.picture.tags && this.props.picture.tags.length > 0 ? this.props.picture.tags.map(function (tag, idx) {
              return _react2.default.createElement(
                _semanticUiReact.Label,
                { key: idx, as: 'a', onClick: function onClick() {
                    return _this2.handleTagClick(tag);
                  } },
                tag
              );
            }) : _react2.default.createElement(
              _semanticUiReact.Card.Meta,
              null,
              t('No tags set', { ns: _translation.TRANSLATION_FILES.translation })
            )
          )
        ),
        this.props.buttonNode
      );
    }
  }]);

  return PictureItem;
}(_react.Component);

PictureItem.propTypes = {
  t: _propTypes2.default.func,
  picture: _propTypes2.default.shape({
    key: _propTypes2.default.string,
    tags: _propTypes2.default.arrayOf(_propTypes2.default.string)
  }),
  labelNode: _propTypes2.default.node,
  buttonNode: _propTypes2.default.node,
  hideTags: _propTypes2.default.bool,
  onViewLarge: _propTypes2.default.func,
  onRemove: _propTypes2.default.func,
  size: _propTypes2.default.string,
  pictureSize: _propTypes2.default.number,
  onTagClick: _propTypes2.default.func,
  extension: _propTypes2.default.oneOf(['jpg', 'jpeg', 'png', 'gif', 'pdf']),
  fixedSize: _propTypes2.default.bool
};
PictureItem.defaultProps = {
  fixedSize: null
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(PictureItem);

/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _unitStatuses = __webpack_require__(266);

var _translation = __webpack_require__(4);

var _strings = __webpack_require__(118);

var _json = __webpack_require__(268);

var _translation2 = __webpack_require__(64);

var _displayTime = __webpack_require__(156);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


// Still needed for the module-level locale; timestamps render in the viewer's display zone.
_momentTimezone2.default.locale('en-gb');

var ProjectUnitActivities = function (_Component) {
  _inherits(ProjectUnitActivities, _Component);

  function ProjectUnitActivities() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProjectUnitActivities);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProjectUnitActivities.__proto__ || Object.getPrototypeOf(ProjectUnitActivities)).call.apply(_ref, [this].concat(args))), _this), _this.renderActivityMessage = function (activity) {
      var _this$props = _this.props,
          countryCode = _this$props.countryCode,
          t = _this$props.t;
      var _activity$projectUnit = activity.projectUnit,
          projectUnit = _activity$projectUnit === undefined ? {} : _activity$projectUnit; // set projectUnit as empty object if not exist

      if (!projectUnit) {
        // projectUnit value can be null, which means projectUnit: null
        // need to explicitly set it to empty object
        projectUnit = {};
      }

      var _ref2 = projectUnit.project || {},
          _ref2$projectCurrency = _ref2.projectCurrency,
          projectCurrency = _ref2$projectCurrency === undefined ? [] : _ref2$projectCurrency;

      var activityBefore = (0, _json.parseJSON)(activity.before);
      var activityAfter = (0, _json.parseJSON)(activity.after);
      var afterKeys = Object.keys(activityAfter);
      var changes = [];
      var mpPublishState = 'removed from';
      afterKeys.forEach(function (element) {
        var message = void 0;
        var after = '';
        var before = activityBefore[element];
        if (activity.before) {
          if (!_lodash2.default.isEmpty(activityAfter[element]) || _lodash2.default.isNumber(activityAfter[element])) {
            after = activityAfter[element];
          }
        }
        switch (element) {
          case 'isPublishedToMP':
            if (before === false && after) {
              mpPublishState = 'launched to';
            }
            message = _react2.default.createElement(
              'span',
              null,
              t('Unit is ' + mpPublishState),
              ' ',
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                ' ',
                (0, _translation2.translateModels)(t, element, 'projectUnit')
              )
            );
            break;
          case 'statusID':
            before = (0, _translation2.getConstantsLabel)(t, _unitStatuses.UNIT_STATUSES_HQ_REAL, before);
            after = (0, _translation2.getConstantsLabel)(t, _unitStatuses.UNIT_STATUSES_HQ_REAL, after);
            break;
          case 'spaValue':
            before = _react2.default.createElement(_LoanAmount2.default, { projectCurrencies: projectCurrency, format: '0,000,000', amount: before, prefix: _react2.default.createElement(_CurrencySymbol2.default, null) });
            after = _react2.default.createElement(_LoanAmount2.default, { projectCurrencies: projectCurrency, format: '0,000,000', amount: after, prefix: _react2.default.createElement(_CurrencySymbol2.default, null) });
            break;
          case 'address':
            if (!before) message = _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                (0, _translation2.translateModels)(t, element, 'projectUnit')
              ),
              ': ',
              _react2.default.createElement(
                'u',
                null,
                after
              )
            );
            break;
          case 'projectUnitLayoutID':
          case 'availableUnits':
          case 'reservedByAWSUser':
            message = _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                (0, _translation2.translateModels)(t, element, 'projectUnit')
              ),
              ' ',
              t('changed')
            );
            break;
          case 'reservedByUserPreferredName':
          case 'reservedByPreviousAWSUser':
          case 'reservedByUser':
          case 'pricePerSize':
          case 'lastAvailableAt':
          case 'lastBookedAt':
          case 'lastDelistAt':
          case 'lastSoldAt':
          case 'lastDeveloperReservedAt':
          case 'lastDeveloperBookedAt':
          case 'lastDeveloperSoldAt':
          case 'lawyerID':
          case 'companyBranchAllocationIDs':
          case 'companyBranchAllocationAwsIDs':
            before = null;
            after = null;
            break;
          case 'createdAt':
          case 'updatedAt':
          case 'latestCreatedAt':
          case 'reservedTimeoutExpireAt':
          case 'latestReservedAt':
            before = before !== null ? (0, _displayTime.displayMoment)(before, countryCode).format('MMMM Do YYYY, h:mm:ss a') : null;
            after = after !== null ? (0, _displayTime.displayMoment)(after, countryCode).format('MMMM Do YYYY, h:mm:ss a') : null;
            break;
          case 'lawyerName':
            message = _react2.default.createElement(
              'span',
              null,
              t('Lawyer {{name}}', { name: after }) + ' ',
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                t('pre-assigned to unit')
              )
            );
            break;
          case 'delistReasonID':
            before = null;
            after = null;
            break;
          case 'delistReasonLabel':
            message = _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                t('Delist Reason')
              ),
              ': ',
              _react2.default.createElement(
                'u',
                null,
                after
              )
            );
            break;
          default:
            break;
        }
        if (message) {
          changes.push(message);
        } else if (before || after) {
          var keyName = (0, _translation2.translateModels)(t, element, 'projectUnit', (0, _strings.camelToTitle)(element));
          if (before === false && after) {
            message = _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation.TRANSLATION_FILES.screens },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  { style: { color: '#666' } },
                  { keyName: keyName }
                ),
                ' has been added'
              )
            );
          } else if (!before) {
            message = _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                keyName
              ),
              ': ',
              _react2.default.createElement(
                'u',
                null,
                after
              )
            );
          } else if (before && !after) {
            message = _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation.TRANSLATION_FILES.screens },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  { style: { color: '#666' } },
                  { keyName: keyName }
                ),
                ' has been removed'
              )
            );
          } else if (element === 'spaValue') {
            message = _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                keyName
              ),
              ' ',
              t('changed from', { ns: _translation.TRANSLATION_FILES.screens }),
              ' ',
              _react2.default.createElement(
                'u',
                null,
                before
              ),
              ' ',
              t('to', { ns: _translation.TRANSLATION_FILES.screens }),
              ' ',
              _react2.default.createElement(
                'u',
                null,
                after
              )
            );
          } else {
            message = _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation.TRANSLATION_FILES.screens },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  { style: { color: '#666' } },
                  { keyName: keyName }
                ),
                ' changed from ',
                _react2.default.createElement(
                  'u',
                  null,
                  { before: before }
                ),
                ' to ',
                _react2.default.createElement(
                  'u',
                  null,
                  { after: after }
                )
              )
            );
          }
          changes.push(message);
        }
      });
      return _react2.default.createElement(
        _semanticUiReact.List,
        { bulleted: true },
        changes.map(function (element, id) {
          return _react2.default.createElement(
            _semanticUiReact.List.Item,
            { key: id },
            element
          );
        })
      );
    }, _this.renderActivityTitle = function (title) {
      var t = _this.props.t;

      var loweredTitle = title.toLowerCase();

      var packageKeyword = 'package (';
      if (loweredTitle.includes(packageKeyword)) {
        var packageName = title.slice(loweredTitle.indexOf(packageKeyword) + packageKeyword.length);
        packageName = '(' + packageName;
        title = title.replace(packageName, '{{package}}');
        return t(title, { package: packageName });
      }
      return t(title);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProjectUnitActivities, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          data = _props.data,
          t = _props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(
              _semanticUiReact.Feed,
              null,
              data && data.length > 0 ? data.map(function (activity, idx) {
                return _react2.default.createElement(
                  _semanticUiReact.Feed.Event,
                  { key: idx, className: 'activity-logs' },
                  _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: 'user' }),
                  _react2.default.createElement(
                    _semanticUiReact.Feed.Content,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Date,
                      null,
                      _react2.default.createElement(_Timestamp2.default, { timestamp: activity.createdAt, format: 'MMMM Do YYYY, h:mm:ss a' })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Summary,
                      null,
                      _this2.props.hasAccess ? activity.maUserAffiliateID > 0 ? _react2.default.createElement(
                        _reactRouter.Link,
                        { to: '/users/' + activity.maUserAffiliateID + '/' },
                        activity.maCreatedByPreferredName || t('Unknown')
                      ) : '' : activity.maCreatedByPreferredName,
                      ' ' + _this2.renderActivityTitle(activity.message),
                      _this2.props.showAll ? _react2.default.createElement(
                        'span',
                        null,
                        '\xA0',
                        t('for'),
                        '\xA0',
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { to: '/projects/' + activity.projectID + '/units/' + activity.projectUnitID + '/' },
                          activity.projectUnitReference,
                          ',\xA0',
                          activity.projectName
                        )
                      ) : ''
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Extra,
                      { text: true },
                      activity.after && _this2.renderActivityMessage(activity)
                    )
                  )
                );
              }) : this.props.loading ? _react2.default.createElement('br', null) : _react2.default.createElement(
                'center',
                null,
                t('No activity found'),
                '.'
              )
            )
          )
        )
      );
    }
  }]);

  return ProjectUnitActivities;
}(_react.Component);
// Same reactive company selector as components/Timestamp, so the before/after strings follow
// login, company switching and logout without a reload.


ProjectUnitActivities.propTypes = {
  data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  hasAccess: _propTypes2.default.bool.isRequired,
  loading: _propTypes2.default.bool.isRequired,
  showAll: _propTypes2.default.bool,
  t: _propTypes2.default.func,
  countryCode: _propTypes2.default.string
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    countryCode: state.auth && state.auth.company && state.auth.company.countryCode
  };
};
exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.projectUnit]))((0, _reactRedux.connect)(mapStateToProps)(ProjectUnitActivities));

/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnitPackagePricingEdit = exports.ProjectUnitPackagePricing = undefined;

var _ProjectUnitPackagePricing = __webpack_require__(2174);

var _ProjectUnitPackagePricing2 = _interopRequireDefault(_ProjectUnitPackagePricing);

var _UnitPackagePricingEdit = __webpack_require__(2175);

var _UnitPackagePricingEdit2 = _interopRequireDefault(_UnitPackagePricingEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ProjectUnitPackagePricing = _ProjectUnitPackagePricing2.default;
exports.UnitPackagePricingEdit = _UnitPackagePricingEdit2.default;

/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _Filters = __webpack_require__(86);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _SizeSuffix = __webpack_require__(316);

var _SizeSuffix2 = _interopRequireDefault(_SizeSuffix);

var _FixedBarStatus = __webpack_require__(1018);

var _FixedBarStatus2 = _interopRequireDefault(_FixedBarStatus);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _unitStatuses = __webpack_require__(266);

var _bumiFilter = __webpack_require__(2216);

var _bumiFilter2 = _interopRequireDefault(_bumiFilter);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _projectUnitSpecifications = __webpack_require__(554);

var _amount = __webpack_require__(87);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _strings = __webpack_require__(118);

var _url = __webpack_require__(19);

var _storage = __webpack_require__(44);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

var _translation = __webpack_require__(4);

var _areaLabel = __webpack_require__(223);

var _vietnam = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */
/* eslint-disable max-len */
/* eslint jsx-a11y/no-static-element-interactions: 0 */


var ProjectUnitsList = function (_Component) {
  _inherits(ProjectUnitsList, _Component);

  function ProjectUnitsList(props) {
    _classCallCheck(this, ProjectUnitsList);

    var _this = _possibleConstructorReturn(this, (ProjectUnitsList.__proto__ || Object.getPrototypeOf(ProjectUnitsList)).call(this, props));

    _initialiseProps.call(_this);

    var state = ProjectUnitsList.getPropsToState(props);
    var summary = Object.assign({}, ProjectUnitsList.summaryDefault);
    _this.state = _extends({
      hasMore: false,
      token: '',
      count: 0,
      limit: 0,
      offset: 0,
      data: [],
      summary: summary,
      advanceFilter: false,
      showDeleteConfirm: false,
      deleteUnitData: null,
      mpToggleLoading: false,
      oriData: []
    }, state);
    _this.debouncedMPToggle = _lodash2.default.debounce(_this.setUnitPublishToMP, 700);
    return _this;
  }

  _createClass(ProjectUnitsList, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;

      store.dispatch((0, _projectUnitSpecifications.fetchProjectUnitSpecifications)());
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
        delete query.page;
      }
      this.replaceQuery(query);
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = ProjectUnitsList.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setUnits',
    value: function setUnits() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this2.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchProjectUnits',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var store, t, query, res, message, token, count, limit, offset, data, hasMore, que;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign(q, this.props.where || {}, {
                  projectUnitLayoutID: this.props.unitLayoutID || null
                });
                res = void 0;
                _context.prev = 6;
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.projectID + '/units/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context.sent;
                _context.next = 20;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                Bugsnag.notifyException(_context.t0);
                _context.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context.next = 19;
                return this.setLoading(false);

              case 19:
                return _context.abrupt('return');

              case 20:
                if (res.ok) {
                  _context.next = 28;
                  break;
                }

                _context.next = 23;
                return res.text();

              case 23:
                message = _context.sent;
                _context.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context.next = 47;
                break;

              case 28:
                token = res.headers.get('X-Csrf-Token');
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context.next = 34;
                return res.json();

              case 34:
                data = _context.sent;
                _context.next = 37;
                return this.setUnits(data);

              case 37:
                this.setState({
                  oriData: _lodash2.default.cloneDeep(data)
                });

                hasMore = this.state.data.length === limit ? this.state.data.length + offset !== count : false;

                if (!(this.state.data.length < 1 && query.page > 1)) {
                  _context.next = 45;
                  break;
                }

                que = (0, _url.decodeSearch)(this.props.location.search);

                que.page = 1;
                this.replaceQuery(que);
                _context.next = 47;
                break;

              case 45:
                _context.next = 47;
                return this.setComponentState({
                  token: token,
                  count: count,
                  limit: limit,
                  offset: offset,
                  hasMore: hasMore
                });

              case 47:
                _context.next = 49;
                return this.setLoading(false);

              case 49:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));

      function fetchProjectUnits() {
        return _ref.apply(this, arguments);
      }

      return fetchProjectUnits;
    }()
  }, {
    key: 'fetchProjectUnitSummaries',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var store, t, query, res, message, summary;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign(q, this.props.where || {}, {
                  projectUnitLayoutID: this.props.unitLayoutID || null
                });
                res = void 0;
                _context2.prev = 6;
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.projectID + '/units/summary/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context2.sent;
                _context2.next = 20;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context2.next = 19;
                return this.setLoading(false);

              case 19:
                return _context2.abrupt('return');

              case 20:
                if (res.ok) {
                  _context2.next = 28;
                  break;
                }

                _context2.next = 23;
                return res.text();

              case 23:
                message = _context2.sent;
                _context2.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context2.next = 33;
                break;

              case 28:
                _context2.next = 30;
                return res.json();

              case 30:
                summary = _context2.sent;
                _context2.next = 33;
                return this.setComponentState({ summary: summary });

              case 33:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 12]]);
      }));

      function fetchProjectUnitSummaries() {
        return _ref2.apply(this, arguments);
      }

      return fetchProjectUnitSummaries;
    }()
  }, {
    key: 'deleteUnit',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(unitData) {
        var t, store, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                _context3.next = 4;
                return this.setState({ loading: true });

              case 4:
                _context3.prev = 4;
                _context3.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.projectID + '/units/' + unitData.id + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  }
                }));

              case 7:
                _context3.next = 21;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](4);
                _context3.next = 13;
                return this.setState({ loading: false });

              case 13:
                Bugsnag.notifyException(_context3.t0);

                if (!(_context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 20;
                  break;
                }

                _context3.next = 17;
                return _context3.t0.res.text();

              case 17:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 20:
                store.dispatch((0, _flash.flashErrorMessage)(_context3.t0));

              case 21:
                _context3.next = 23;
                return this.setState({ loading: false });

              case 23:
                store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.projectID + '/'));
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Unit {{reference}} was successfully deleted', { reference: unitData.reference, ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 25:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 9]]);
      }));

      function deleteUnit(_x6) {
        return _ref3.apply(this, arguments);
      }

      return deleteUnit;
    }()
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var user = this.props.auth;
      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      if (this.props.auth.isBranchLeader && this.state.data && this.state.data.length > 0 && this.state.data[0].project.maOwnerCompanyBranchID === user.companyBranch.id) {
        return true;
      }
      return check;
    }
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;
      var pathname = this.props.location.pathname;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      this.fetchProjectUnits(queryNew);
      this.fetchProjectUnitSummaries(queryNew);
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));
    }
  }, {
    key: 'cellCheckSorted',
    value: function cellCheckSorted(column) {
      var _decodeSearch = (0, _url.decodeSearch)(this.props.location.search),
          sortColumn = _decodeSearch.sortColumn,
          sortDirection = _decodeSearch.sortDirection;

      if (column === sortColumn) {
        return sortDirection === 'asc' ? 'ascending' : 'descending';
      }
      return null;
    }
  }, {
    key: 'renderLegend',
    value: function renderLegend() {
      var _this5 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        {
          columns: 'equal',
          textAlign: 'left',
          verticalAlign: 'middle',
          style: { margin: '0 0 -1em 0' }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { style: { padding: 0, marginBottom: '0.25em' } },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            {
              style: { padding: '0.5em 0', fontSize: '14px' }
            },
            _react2.default.createElement(
              'a',
              {
                onClick: function onClick(event) {
                  event.preventDefault();
                  _this5.handleReplaceStatus();
                }
              },
              _react2.default.createElement(
                'span',
                { style: { fontWeight: 'bold' } },
                t('Total units') + ':'
              ),
              ' ',
              this.getStatusCount('total')
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { style: { padding: 0 } },
          this.getUnitStatuses().map(function (status, key) {
            return _react2.default.createElement(_FixedBarStatus2.default, {
              key: key,
              status: status.value,
              name: status.text,
              count: _this5.getStatusCount(status.value),
              onClick: _this5.handleReplaceStatus
            });
          })
        )
      );
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this6 = this;

      var _state = this.state,
          data = _state.data,
          facilities = _state.facilities,
          isMobile = _state.isMobile,
          loading = _state.loading,
          mpToggleLoading = _state.mpToggleLoading,
          projectUnitSpecifications = _state.projectUnitSpecifications;
      var _props = this.props,
          project = _props.project,
          t = _props.t;

      var isVietnam = (0, _vietnam.isVietnamCompany)(this.props.auth);
      var queryParams = new URLSearchParams(window.location.search);
      var source = queryParams.get('source');
      return data.length > 0 ? data.map(function (unit, idx) {
        return _react2.default.createElement(
          _semanticUiReact.Table.Row,
          {
            key: idx,
            disabled: _this6.handleOnCheck(unit),
            className: _this6.getRowClassName(unit.statusID)
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { collapsing: true },
            _react2.default.createElement(_semanticUiReact.Label, {
              empty: true, circular: true,
              className: _this6.getLabelClassName(unit.statusID)
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            _react2.default.createElement(
              'span',
              { style: { display: 'inline-flex' } },
              _react2.default.createElement(
                _semanticUiReact.Item.Header,
                { as: !_this6.handleOnCheck(unit) && _this6.hasClickAccess(unit.statusID) ? _reactRouter.Link : 'span', to: '/projects/' + unit.projectID + '/units/' + unit.id + '/' + (source ? '?source=' + source : '') },
                unit.reference,
                '\xA0'
              ),
              unit.isBumi && _react2.default.createElement(
                _semanticUiReact.Label,
                { size: 'mini' },
                (0, _vietnam.unitQuotaChipLabel)(_this6.props.auth, t)
              ),
              unit.statusID === 'delist' && unit.delistOnHold && _react2.default.createElement(_semanticUiReact.Icon, { className: 'unit-list_on-hold-icon', name: 'pause circle outline', size: 'large' })
            ),
            _react2.default.createElement('br', null),
            isMobile && _react2.default.createElement(_SizeSuffix2.default, {
              size: unit.size,
              suffix: unit.project.sizeSuffix,
              isVietnam: isVietnam
            }),
            isMobile && _react2.default.createElement('br', null),
            isMobile && ((0, _amount.spaFullNumber)(unit) > 1 ? _react2.default.createElement(_LoanAmount2.default, {
              projectCurrencies: unit.project.projectCurrency,
              format: '0,000,000.00',
              amount: (0, _amount.spaFullNumber)(unit),
              prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
            }) : '-'),
            project && project.activeBookingsInUnits && isMobile && _react2.default.createElement(
              'p',
              null,
              t('Active Bookings'),
              ': ',
              _this6.countActiveBooking(unit)
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'mobile-hide' },
            unit.projectUnitLayout.name
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'mobile-hide' },
            (0, _amount.spaFullNumber)(unit) > 1 ? _react2.default.createElement(_LoanAmount2.default, {
              projectCurrencies: unit.project.projectCurrency,
              format: '0,000,000.00',
              amount: (0, _amount.spaFullNumber)(unit),
              prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
            }) : '-'
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'mobile-hide' },
            _react2.default.createElement(_SizeSuffix2.default, {
              size: unit.size,
              suffix: unit.project.sizeSuffix,
              isVietnam: isVietnam
            })
          ),
          facilities && facilities.length > 0 ? projectUnitSpecifications.filter(function (opt) {
            return facilities.some(function (qf) {
              return qf === opt.id;
            });
          }).map(function (f) {
            return _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              {
                key: f.id,
                title: f.description,
                collapsing: f.id === 'view'
              },
              unit && unit.specifications && unit.specifications.some(function (s) {
                return s.name === f.name;
              }) ? unit.specifications.find(function (s) {
                return s.name === f.name;
              }).value : '-'
            );
          }) : null,
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'mobile-hide' },
            _react2.default.createElement(_SizeSuffix2.default, {
              size: unit.landArea,
              suffix: unit.project ? unit.project.sizeSuffix : null,
              isVietnam: isVietnam
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { width: 2, className: 'mobile-hide capitalize' },
            _this6.checkStatusID(unit)
          ),
          _this6.isHQorSuperAdmin() && _this6.isUnitAvailable() && _this6.isProjectPublishToMP() && _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { collapsing: true, textAlign: 'center' },
            unit.statusID === 'new' && _react2.default.createElement(_semanticUiReact.Checkbox, {
              toggle: true,
              disabled: mpToggleLoading,
              onChange: function onChange(e, d) {
                e.preventDefault();
                _this6.handleMPToggle(d, unit.id);
                _this6.debouncedMPToggle(unit);
              },
              checked: unit.isPublishedToMP
            })
          ),
          _this6.hasVirtualTour() ? _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { collapsing: true, textAlign: 'center' },
            unit.virtualTourURL !== '' || unit.projectUnitLayout && unit.projectUnitLayout.virtualTourURL !== '' ? _react2.default.createElement(_semanticUiReact.Button, {
              as: 'a',
              href: unit.virtualTourURL || (unit.projectUnitLayout ? unit.projectUnitLayout.virtualTourURL : ''),
              compact: true,
              color: 'teal',
              icon: 'street view',
              disabled: _this6.handleOnCheck(unit),
              target: '_blank',
              rel: 'noopener noreferrer'
            }) : null
          ) : null,
          project && project.activeBookingsInUnits && !isMobile && _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { collapsing: true, textAlign: 'center' },
            _this6.countActiveBooking(unit)
          ),
          _this6.hasAccess() ? _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { collapsing: true, textAlign: 'center' },
            !isMobile && _this6.canDelete(unit) && (_this6.props.auth.allowEditUnitDetails || _this6.props.auth.allowEditUnitPrice) && _react2.default.createElement(
              _semanticUiReact.Button,
              {
                color: 'red',
                disabled: loading,
                compact: true,
                icon: true,
                title: t('Delete', { ns: _translation.TRANSLATION_FILES.translation }),
                onClick: function onClick(e) {
                  return _this6.handleDelete(e, unit);
                }
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'trash' })
            )
          ) : null
        );
      }) : _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { colSpan: '100%', textAlign: 'center' },
          loading && _react2.default.createElement(
            _semanticUiReact.Loader,
            { active: true, inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          ),
          !loading && (this.props.notFoundNode || _react2.default.createElement(
            'p',
            null,
            t('No units found') + '.'
          ))
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var _state2 = this.state,
          count = _state2.count,
          limit = _state2.limit,
          offset = _state2.offset,
          loading = _state2.loading,
          currentPage = _state2.currentPage,
          globalSettings = _state2.globalSettings;

      var query = (0, _url.decodeSearch)(this.props.location.search);
      var t = this.props.t;

      var countryCode = this.props.auth && this.props.auth.company && this.props.auth.company.countryCode;

      var _getAreaSortLabels = (0, _areaLabel.getAreaSortLabels)(countryCode),
          areaSortAscending = _getAreaSortLabels.ascending,
          areaSortDescending = _getAreaSortLabels.descending;

      var sortItems = [{
        text: 'Unit No. Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'project_unit.reference',
        sortDirection: 'asc'
      }, {
        text: 'Unit No. Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'project_unit.reference',
        sortDirection: 'desc'
      }, {
        text: 'Unit Layout Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'project_unit_layout__name',
        sortDirection: 'asc'
      }, {
        text: 'Unit Layout Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'project_unit_layout__name',
        sortDirection: 'desc'
      }, {
        text: 'Selling Price Ascending',
        icon: 'sort numeric ascending',
        sortColumn: 'project_unit.spa_value',
        sortDirection: 'asc'
      }, {
        text: 'Selling Price Descending',
        icon: 'sort numeric descending',
        sortColumn: 'project_unit.spa_value',
        sortDirection: 'desc'
      }, {
        text: areaSortAscending,
        icon: 'sort numeric ascending',
        sortColumn: 'project_unit.size',
        sortDirection: 'asc'
      }, {
        text: areaSortDescending,
        icon: 'sort numeric descending',
        sortColumn: 'project_unit.size',
        sortDirection: 'desc'
      }, {
        text: 'Land Ascending',
        icon: 'sort numeric ascending',
        sortColumn: 'project_unit.land_area',
        sortDirection: 'asc'
      }, {
        text: 'Land Descending',
        icon: 'sort numeric descending',
        sortColumn: 'project_unit.land_area',
        sortDirection: 'desc'
      }, {
        text: 'Status Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'project_unit.status_id',
        sortDirection: 'asc'
      }, {
        text: 'Status Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'project_unit.status_id',
        sortDirection: 'desc'
      }];
      var exportItems = [{
        text: 'Units Excel',
        href: _config2.default.get('bookApiURL') + '/projects/' + this.props.projectID + '/units/export/?' + _qs2.default.stringify(Object.assign(query, {}))
      }, {
        text: 'Pricing Packages Excel',
        href: _config2.default.get('bookApiURL') + '/projects/' + this.props.projectID + '/units/export/package_pricings/?' + _qs2.default.stringify(Object.assign(query, {}))
      }, {
        text: 'Agency Unit Allocation',
        href: _config2.default.get('bookApiURL') + '/projects/' + this.props.projectID + '/units/export/unit_allocation/?' + _qs2.default.stringify(Object.assign(query, {}))
      }];
      var bookingsByTypes = [{ text: t('Bookings via MHub'), value: 'mhub' }, { text: t('Bookings outside MHub'), value: 'outside' }];
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_DeleteConfirm2.default, {
          open: this.state.showDeleteConfirm,
          onClose: this.handleCancelDelete,
          onConfirm: this.handleConfirmDelete,
          name: this.state.deleteUnitData && this.state.deleteUnitData.reference || t('Unit')
        }),
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 20 },
            active: loading && this.state.data.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        this.renderLegend(),
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            celled: true,
            unstackable: true,
            sortable: true,
            structured: true,
            className: 'units'
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: '100%' },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { columns: 1, verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    this.props.headerNode ? this.props.headerNode({
                      count: count,
                      limit: limit,
                      offset: offset,
                      dataSize: this.state.data.length,
                      loading: loading,
                      currentPage: currentPage,
                      onChange: this.handleChangePage
                    }) : _react2.default.createElement(
                      _SearchFilter2.default,
                      {
                        inTable: true,
                        hasCompareBtn: this.state.summary.newCount > 0,
                        advanceFilter: this.state.advanceFilter,
                        isLoading: loading,
                        onChange: this.handleFilterOnChange,
                        onClose: this.handleClearFilter,
                        search: this.state.search,
                        setAdvanceFilter: this.handleSetAdvanceFilter,
                        leftNav: _react2.default.createElement(
                          _semanticUiReact.Header,
                          { style: { marginLeft: '0.5em', marginTop: '0.25em' } },
                          this.state.unitStatus.length > 0 ? t(_unitStatuses.UNIT_STATUSES_SIMPLE_ALL.find(function (status) {
                            return status.value === _this7.state.unitStatus[0];
                          }).text, { ns: _translation.TRANSLATION_FILES.constants }) : t('All', { ns: _translation.TRANSLATION_FILES.translation })
                        ),
                        rightNav: _react2.default.createElement(
                          'div',
                          null,
                          this.state.summary && this.state.summary.newCount > 0 ? _react2.default.createElement(
                            _semanticUiReact.Button,
                            {
                              disabled: loading,
                              as: _reactRouter.Link,
                              to: '/projects/' + this.props.projectID + '/units/compare/',
                              style: {
                                backgroundColor: '#00b5ad',
                                color: '#fff',
                                textShadow: 'none',
                                backgroundImage: 'none'
                              }
                            },
                            _react2.default.createElement(_semanticUiReact.Icon, { name: 'clone' }),
                            _react2.default.createElement(
                              'small',
                              null,
                              t('Compare', { ns: _translation.TRANSLATION_FILES.translation })
                            )
                          ) : null,
                          this.hasAccess(this.props.auth.isBranchLeader) ? _react2.default.createElement(_SortButton2.default, {
                            loading: loading,
                            icon: 'download',
                            items: exportItems
                          }) : '',
                          _react2.default.createElement(_SortButton2.default, {
                            loading: loading,
                            items: sortItems,
                            onSort: this.handleSortData
                          })
                        )
                      },
                      _react2.default.createElement(_Filters.SelectListMultiple, {
                        filterName: 'facilities',
                        hasSearch: true,
                        headerText: null,
                        onChange: this.handleFilterOnChange,
                        onClose: this.handleClearFilter,
                        options: this.state.options,
                        placeholder: t('Select Unit Specifications'),
                        value: this.state.facilities,
                        renderLabel: this.renderLabel,
                        limit: 3
                      }),
                      (0, _vietnam.showsUnitQuotaFilter)(this.props.auth) && _react2.default.createElement(_Filters.SelectList, {
                        filterName: 'isBumi',
                        headerText: null,
                        onChange: this.handleFilterOnChange,
                        onClose: this.handleClearFilter,
                        options: (0, _vietnam.unitQuotaFilterOptions)(this.props.auth, t, _bumiFilter2.default),
                        placeholder: (0, _vietnam.unitQuotaFilterPlaceholder)(this.props.auth, t),
                        value: this.state.isBumi
                      }),
                      this.hasAccess() && _react2.default.createElement(_Filters.SelectList, {
                        filterName: 'bookingsBy',
                        hasSearch: true,
                        headerText: null,
                        onChange: this.handleFilterOnChange,
                        onClose: this.handleClearFilter,
                        options: bookingsByTypes,
                        placeholder: t('Bookings Type'),
                        value: this.state.bookingsBy
                      })
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(_semanticUiReact.Table.HeaderCell, { collapsing: true }),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                {
                  sorted: this.cellCheckSorted(sortItems[0].sortColumn),
                  onClick: function onClick() {
                    return _this7.handleCellSort(sortItems[0].sortColumn);
                  }
                },
                t('Unit'),
                this.cellCheckSorted(sortItems[0].sortColumn) ? null : _react2.default.createElement(_semanticUiReact.Icon, {
                  inverted: true, color: 'grey',
                  name: 'sort'
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                {
                  sorted: this.cellCheckSorted(sortItems[2].sortColumn),
                  onClick: function onClick() {
                    return _this7.handleCellSort(sortItems[2].sortColumn);
                  },
                  className: 'mobile-hide'
                },
                t('Layout'),
                this.cellCheckSorted(sortItems[2].sortColumn) ? null : _react2.default.createElement(_semanticUiReact.Icon, {
                  inverted: true, color: 'grey',
                  name: 'sort'
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                {
                  sorted: this.cellCheckSorted(sortItems[4].sortColumn),
                  onClick: function onClick() {
                    return _this7.handleCellSort(sortItems[4].sortColumn);
                  },
                  className: 'mobile-hide'
                },
                globalSettings && globalSettings.sellingPrice ? globalSettings.sellingPrice : t('Selling Price'),
                this.cellCheckSorted(sortItems[4].sortColumn) ? null : _react2.default.createElement(_semanticUiReact.Icon, {
                  inverted: true, color: 'grey',
                  name: 'sort'
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                {
                  sorted: this.cellCheckSorted(sortItems[6].sortColumn),
                  onClick: function onClick() {
                    return _this7.handleCellSort(sortItems[6].sortColumn);
                  },
                  className: 'mobile-hide'
                },
                (0, _areaLabel.getAreaLabel)(t, countryCode, { short: true }),
                this.cellCheckSorted(sortItems[6].sortColumn) ? null : _react2.default.createElement(_semanticUiReact.Icon, {
                  inverted: true, color: 'grey',
                  name: 'sort'
                })
              ),
              this.state.facilities && this.state.facilities.length > 0 ? this.state.projectUnitSpecifications.filter(function (opt) {
                return _this7.state.facilities.some(function (qf) {
                  return qf === opt.id;
                });
              }).map(function (f) {
                return _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  {
                    key: f.id,
                    title: f.description,
                    collapsing: f.id === 'view'
                  },
                  f.shortName
                );
              }) : null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                {
                  sorted: this.cellCheckSorted(sortItems[8].sortColumn),
                  onClick: function onClick() {
                    return _this7.handleCellSort(sortItems[8].sortColumn);
                  },
                  className: 'mobile-hide'
                },
                t('Land'),
                this.cellCheckSorted(sortItems[8].sortColumn) ? null : _react2.default.createElement(_semanticUiReact.Icon, {
                  inverted: true, color: 'grey',
                  name: 'sort'
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                {
                  width: 2, className: 'mobile-hide',
                  sorted: this.cellCheckSorted(sortItems[10].sortColumn),
                  onClick: function onClick() {
                    return _this7.handleCellSort(sortItems[10].sortColumn);
                  }
                },
                t('Status'),
                this.cellCheckSorted(sortItems[10].sortColumn) ? null : _react2.default.createElement(_semanticUiReact.Icon, {
                  inverted: true, color: 'grey',
                  name: 'sort'
                })
              ),
              this.isHQorSuperAdmin() && this.isProjectPublishToMP() && this.isUnitAvailable() && _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { collapsing: true },
                t('List on Marketplace')
              ),
              this.hasVirtualTour() ? _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { collapsing: true },
                t('Virtual Tour')
              ) : null,
              this.props.project && this.props.project.activeBookingsInUnits && !this.state.isMobile && _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { collapsing: true },
                t('Active Bookings')
              ),
              this.hasAccess() ? _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { collapsing: true },
                this.props.hideNew ? null : _react2.default.createElement(_semanticUiReact.Button, {
                  as: _reactRouter.Link,
                  fluid: !this.state.isMobile,
                  compact: true,
                  primary: true,
                  icon: this.state.isMobile && 'add',
                  content: !this.state.isMobile && t('New', { ns: _translation.TRANSLATION_FILES.constants }),
                  to: this.props.addPath,
                  onClick: this.handleOnAdd
                })
              ) : null
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            this.renderBody()
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Footer,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: '100%' },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { columns: 1, verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'center' },
                    this.props.footerNode ? this.props.footerNode({
                      count: count,
                      limit: limit,
                      offset: offset,
                      dataSize: this.state.data.length,
                      loading: loading,
                      currentPage: currentPage,
                      onChange: this.handleChangePage
                    }) : _react2.default.createElement(_PageNav2.default, {
                      currentPage: currentPage,
                      count: count,
                      limit: limit,
                      offset: offset,
                      dataSize: this.state.data.length,
                      loading: loading,
                      onChange: this.handleChangePage
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ProjectUnitsList;
}(_react.Component);

ProjectUnitsList.propTypes = {
  notFoundNode: _propTypes2.default.node,
  unitOnClick: _propTypes2.default.func,
  unitOnCheck: _propTypes2.default.func,
  headerNode: _propTypes2.default.func,
  footerNode: _propTypes2.default.func,
  selected: _propTypes2.default.string,
  projectID: _propTypes2.default.string.isRequired,
  unitLayoutID: _propTypes2.default.string,
  where: _propTypes2.default.shape({
    limit: _propTypes2.default.number
  }),
  toggleable: _propTypes2.default.bool,
  addPath: _propTypes2.default.string,
  onAdd: _propTypes2.default.func,
  projectUnitSpecifications: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    allowEditUnitPrice: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  hideNew: _propTypes2.default.bool,
  t: _propTypes2.default.func,
  project: _propTypes2.default.shape({
    siteplanSettings: _propTypes2.default.shape({
      salesChartSimpleMode: _propTypes2.default.bool,
      siteplanSimpleMode: _propTypes2.default.bool,
      unitListDisableClickUnavailable: _propTypes2.default.bool
    }),
    activeBookingsInUnits: _propTypes2.default.bool
  })
};
ProjectUnitsList.contextTypes = {
  store: _propTypes2.default.object
};

ProjectUnitsList.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    projectUnitSpecifications: state.projectUnitSpecifications
  };
};

ProjectUnitsList.getPropsToState = function (props) {
  var projectUnitSpecifications = props.projectUnitSpecifications ? [].concat(props.projectUnitSpecifications.data) : [];
  var options = projectUnitSpecifications.map(function (d) {
    return {
      text: (0, _strings.titleCase)(d.name),
      value: d.id,
      description: d.shortName
    };
  }) || [];
  var windowWidth = window.innerWidth;
  var isMobile = windowWidth < 768;
  var row = 9;
  switch (true) {
    case windowWidth < 442:
      row = 2;break;
    case windowWidth < 553:
      row = 3;break;
    case windowWidth < 665:
      row = 4;break;
    case windowWidth < 768:
      row = 5;break;
    case windowWidth < 992:
      row = 6;break;
    case windowWidth < 1200:
      row = 8;break;
    default:
      row = 9;
  }
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var unitStatus = query.unitStatus || [];
  var isBumi = query.isBumi || '';
  var bookingsBy = query.bookingsBy || '';
  var facilities = [];
  var globalSettings = {};

  var storedFacilities = (0, _storage.getItem)(_config2.default.get('appName') + '.project_' + props.projectID + '.facilities');
  if (storedFacilities) {
    try {
      facilities = JSON.parse(storedFacilities).data || [];
    } catch (e) {
      Bugsnag.notifyException(e);
    }
  }

  var storeGlobalSettings = (0, _storage.getItem)(_config2.default.get('appName') + '.globalSettings');
  if (storeGlobalSettings) {
    try {
      globalSettings = JSON.parse(storeGlobalSettings).data || [];
    } catch (e) {
      Bugsnag.notifyException(e);
    }
  }
  var returnStates = {
    options: options,
    projectUnitSpecifications: projectUnitSpecifications,
    isMobile: isMobile,
    row: row,
    currentPage: currentPage,
    search: search,
    unitStatus: unitStatus,
    facilities: facilities,
    isBumi: isBumi,
    bookingsBy: bookingsBy,
    globalSettings: globalSettings
  };
  if (facilities && facilities.length > 0 || isBumi !== '' || bookingsBy !== '') {
    returnStates.advanceFilter = true;
  }
  return returnStates;
};

ProjectUnitsList.summaryDefault = {
  count: 0,
  newCount: 0,
  reservedCount: 0,
  bookedCount: 0,
  developerBookedCount: 0,
  delistCount: 0,
  soldCount: 0,
  developerReservedCount: 0,
  developerSoldCount: 0
};

var _initialiseProps = function _initialiseProps() {
  var _this8 = this;

  this.setUnitPublishToMP = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var projectUnit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var store, t, id, projectID;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              store = _this8.context.store;
              t = _this8.props.t;
              id = projectUnit.id, projectID = projectUnit.projectID;

              if (!(!id && !projectID)) {
                _context4.next = 7;
                break;
              }

              _context4.next = 6;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

            case 6:
              return _context4.abrupt('return');

            case 7:
              _context4.prev = 7;
              _context4.next = 10;
              return (0, _fetchM.serverRequestPut)('/projects/' + projectID + '/units/' + id + '/', store, _this8.state.token, { isPublishedToMP: projectUnit.isPublishedToMP });

            case 10:
              store.dispatch((0, _flash.flashSuccessMessage)({
                header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                message: t('Unit {{reference}} was successfully ' + (projectUnit.isPublishedToMP ? 'listed' : 'unlisted') + ' in Marketplace', { reference: projectUnit.reference, ns: _translation.TRANSLATION_FILES.translation })
              }));
              _context4.next = 20;
              break;

            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4['catch'](7);

              Bugsnag.notifyException(_context4.t0);
              _context4.next = 18;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

            case 18:
              _context4.next = 20;
              return _this8.setState({
                data: _lodash2.default.cloneDeep(_this8.state.oriData)
              });

            case 20:
              _this8.setState({
                mpToggleLoading: false
              });

            case 21:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this8, [[7, 13]]);
    }));

    return function () {
      return _ref4.apply(this, arguments);
    };
  }();

  this.getStatusCount = function (status) {
    var summary = _this8.state.summary;

    if (_this8.state.loading) {
      return '...';
    }
    switch (status) {
      case 'total':
        return summary.count;
      case 'new':
        return summary.newCount;
      case 'reserved':
        return summary.reservedCount + summary.developerReservedCount;
      case 'booked':
        if (_this8.hasAccess()) {
          return summary.bookedCount + summary.developerBookedCount;
        }
        return summary.bookedCount + summary.developerBookedCount + summary.soldCount + summary.developerSoldCount;
      case 'delist':
        return summary.delistCount;
      case 'sold_spa_signed':
        return summary.soldCount + summary.developerSoldCount;
      case 'unavailable':
        return summary.unavailableCount;
      default:
        return 0;
    }
  };

  this.getRowClassName = function (statusID) {
    if (statusID) {
      if (!_this8.hasAccess()) {
        if (statusID === 'sold_spa_signed' || statusID === 'developer_sold') {
          return 'row-colors unit_row_booked';
        }
      }
      return 'row-colors unit_row_' + statusID;
    }
    return 'row-colors';
  };

  this.getLabelClassName = function (statusID) {
    if (!_this8.hasAccess()) {
      if (statusID === 'sold_spa_signed' || statusID === 'developer_sold') {
        return 'booked';
      }
    }
    return statusID;
  };

  this.getUnitStatuses = function () {
    if (_this8.hasAccess()) {
      return _this8.translateStatuses(_unitStatuses.UNIT_STATUSES_HQ_BASIC);
    }
    if (_this8.hasSimpleViewMode()) {
      return _this8.translateStatuses(_unitStatuses.UNIT_STATUSES_SIMPLE_MODE);
    }
    return _this8.translateStatuses(_unitStatuses.UNIT_STATUSES_DE_BASIC);
  };

  this.hasSimpleViewMode = function () {
    var project = _this8.props.project;

    var user = _this8.props.auth;
    if (!user.isHeadquarters && !user.isSuperAdmin && !user.isBranchLeader) {
      return project && project.siteplanSettings && (project.siteplanSettings.salesChartSimpleMode || project.siteplanSettings.siteplanSimpleMode);
    }
    return false;
  };

  this.translateStatuses = function (statuses) {
    var t = _this8.props.t;

    return statuses.map(function (s) {
      return _extends({}, s, {
        text: t(s.text, { ns: _translation.TRANSLATION_FILES.constants })
      });
    });
  };

  this.adjustRow = function (windowWidth) {
    switch (true) {
      case windowWidth < 442:
        return 2;
      case windowWidth < 553:
        return 3;
      case windowWidth < 665:
        return 4;
      case windowWidth < 768:
        return 5;
      case windowWidth < 992:
        return 6;
      case windowWidth < 1200:
        return 8;
      default:
        return 9;
    }
  };

  this.isHQorSuperAdmin = function () {
    return _this8.props.auth.isHeadquarters || _this8.props.auth.isSuperAdmin;
  };

  this.handleResize = function () {
    var state = {};
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    if (isMobile !== _this8.state.isMobile) {
      state.isMobile = isMobile;
    }
    var row = _this8.adjustRow(windowWidth);
    if (row !== _this8.state.row) {
      state.row = row;
    }
    _this8.setState(_extends({}, state));
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    query.page = currentPage;
    _this8.setState({
      currentPage: currentPage
    });
    _this8.replaceQuery(query);
  };

  this.changeColor = function (unit) {
    if (_this8.handleOnCheck(unit)) {
      if (unit.statusID === 'reserved' && unit.projectUnitBookingSummary.reservedCount >= unit.project.bookingUnitLimit) {
        return 'yellow';
      }
      return _this8.statusColor(unit.statusID);
    } else if (_this8.props.selected && _this8.props.selected === unit.id) {
      return 'green';
    }
    return null;
  };

  this.handleOnClick = function (e, unit) {
    if (_this8.props.unitOnClick) {
      _this8.props.unitOnClick(e, { unit: unit });
    }
  };

  this.handleOnCheck = function (unit) {
    if (_this8.props.unitOnCheck) {
      return _this8.props.unitOnCheck({ unit: unit });
    }
    return false;
  };

  this.hasClickAccess = function (statusID) {
    var project = _this8.props.project;

    if (_this8.hasSimpleViewMode() && project && project.siteplanSettings && project.siteplanSettings.unitListDisableClickUnavailable && statusID === 'unavailable') {
      return false;
    }
    return true;
  };

  this.handleOnAdd = function (e) {
    if (_this8.props.onAdd) {
      _this8.props.onAdd(e);
    }
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this8.replaceQuery(query, true);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
      if (filter === 'facilities') {
        (0, _storage.setItem)(_config2.default.get('appName') + '.project_' + _this8.props.projectID + '.facilities', JSON.stringify({
          data: [],
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
        hasQuery = true;
      }
      if (queryArray.length < 2) {
        _this8.setState({ advanceFilter: false });
      }
    });
    if (hasQuery) {
      _this8.replaceQuery(query, true);
    }
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    if (queryName === 'facilities') {
      (0, _storage.setItem)(_config2.default.get('appName') + '.project_' + _this8.props.projectID + '.facilities', JSON.stringify({
        data: value,
        createdAt: (0, _momentTimezone2.default)().toDate(),
        version: _config2.default.get('version')
      }));
    } else {
      query[queryName] = value;
    }
    _this8.replaceQuery(query, true);
  };

  this.handleReplaceStatus = function () {
    var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    query.unitStatus = [];
    if (status !== '') {
      query.unitStatus.push(status);
    }
    _this8.replaceQuery(query);
  };

  this.handleSetAdvanceFilter = function (advanceFilter) {
    _this8.setState({
      advanceFilter: advanceFilter
    });
  };

  this.handleCellSort = function (column) {
    var _decodeSearch2 = (0, _url.decodeSearch)(_this8.props.location.search),
        sortColumn = _decodeSearch2.sortColumn,
        sortDirection = _decodeSearch2.sortDirection;

    var direction = 'asc';
    if (column === sortColumn) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc';
    }
    _this8.handleSortData(column, direction);
  };

  this.checkStatusID = function (unit) {
    var t = _this8.props.t;

    switch (unit.statusID) {
      case 'developer_reserved':
        return t('Reserved', { ns: _translation.TRANSLATION_FILES.constants });
      case 'developer_booked':
        return t('Booked', { ns: _translation.TRANSLATION_FILES.constants });
      case 'developer_sold':
      case 'sold_spa_signed':
        return t(_this8.hasAccess() ? 'Sold' : 'Booked', { ns: _translation.TRANSLATION_FILES.constants });
      case 'new':
        return t('Available', { ns: _translation.TRANSLATION_FILES.constants });
      case 'unavailable':
        return t('Unavailable', { ns: _translation.TRANSLATION_FILES.constants });
      default:
        return t(unit.status.name, { ns: _translation.TRANSLATION_FILES.constants });
    }
  };

  this.handleCancelDelete = function (e) {
    e.preventDefault();
    _this8.setState({
      showDeleteConfirm: false
    });
  };

  this.handleConfirmDelete = function (e) {
    e.preventDefault();
    _this8.setState({
      showDeleteConfirm: false
    }, function () {
      _this8.deleteUnit(_this8.state.deleteUnitData);
    });
  };

  this.handleDelete = function (e, data) {
    e.preventDefault();
    _this8.setState({
      showDeleteConfirm: true,
      deleteUnitData: data
    });
  };

  this.handleMPToggle = function (toggleData, unitID) {
    var data = _this8.state.data;

    var index = data.findIndex(function (unit) {
      return unit.id === unitID;
    });
    if (index !== -1) {
      data[index].isPublishedToMP = toggleData.checked;
      _this8.setState({
        data: data,
        mpToggleLoading: true
      });
    }
  };

  this.canDelete = function (data) {
    if (data.projectUnitBookingSummary) {
      if (data.projectUnitBookingSummary.totalCount < 1) return true;
    }
    return false;
  };

  this.isUnitAvailable = function () {
    var data = _this8.state.data;

    return data.some(function (unit) {
      return unit.statusID === 'new';
    });
  };

  this.isProjectPublishToMP = function () {
    var data = _this8.state.data;

    return data.some(function (unit) {
      return unit.project.marketplaceIsPublish || unit.project.marketplaceBuyerIsPublish;
    });
  };

  this.hasVirtualTour = function () {
    var data = _this8.state.data;

    return data.some(function (unit) {
      return unit.virtualTourURL !== '' || unit.projectUnitLayout && unit.projectUnitLayout.virtualTourURL !== '';
    });
  };

  this.countActiveBooking = function (unit) {
    var activeBookingCount = 0;
    var bookingSummary = unit.projectUnitBookingSummary;
    if (bookingSummary) {
      activeBookingCount = bookingSummary.reservedCount + bookingSummary.bookedCount + bookingSummary.soldCount;
    }
    if (unit.project && unit.project.activeBookingsIncludeWaitlist) {
      activeBookingCount += bookingSummary.cancelledAvailabilityCount;
    }
    return activeBookingCount;
  };

  this.renderLabel = function (label, idx, props) {
    var content = _this8.state.projectUnitSpecifications.find(function (s) {
      return s.id === label.value;
    }).shortName;
    return _extends({
      content: content
    }, props);
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRouter.withRouter)((0, _reactRedux.connect)(ProjectUnitsList.mapStateToProps)(ProjectUnitsList)));

/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _flash = __webpack_require__(5);

var _himsDistricts = __webpack_require__(2078);

var _states = __webpack_require__(144);

var _states2 = _interopRequireDefault(_states);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchHimsDistricts = function (_Component) {
  _inherits(SearchHimsDistricts, _Component);

  function SearchHimsDistricts(props) {
    _classCallCheck(this, SearchHimsDistricts);

    var _this = _possibleConstructorReturn(this, (SearchHimsDistricts.__proto__ || Object.getPrototypeOf(SearchHimsDistricts)).call(this, props));

    _initialiseProps.call(_this);

    var state = SearchHimsDistricts.getPropsToState(props);
    _this.state = _extends({}, state);
    return _this;
  }

  _createClass(SearchHimsDistricts, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var store = this.context.store;

      store.dispatch((0, _himsDistricts.fetchHimsDistricts)(false)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = SearchHimsDistricts.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var name = this.props.name;
      var _state = this.state,
          districts = _state.districts,
          value = _state.value,
          error = _state.error;

      return _react2.default.createElement(
        _semanticUiReact.Segment,
        { className: 'hims-address ' + (error ? 'error' : '') },
        _react2.default.createElement(
          _AppForm2.default.Validate,
          {
            ref: this.props.validateRef,
            validation: [_webValidations.required],
            onChange: this.handleOnChange,
            validateLabel: 'HIMS City',
            onError: this.handleOnError
          },
          _react2.default.createElement(_semanticUiReact.Form.Select, {
            name: name,
            fluid: true,
            options: districts,
            placeholder: 'City*',
            label: _react2.default.createElement(
              _react.Fragment,
              null,
              _react2.default.createElement(
                'label',
                { htmlFor: name },
                'City*'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Required by HIMS'
              )
            ),
            search: true,
            selectOnBlur: false,
            value: value
          })
        )
      );
    }
  }]);

  return SearchHimsDistricts;
}(_react.Component);

SearchHimsDistricts.contextTypes = {
  store: _propTypes2.default.object
};
SearchHimsDistricts.propTypes = {
  state: _propTypes2.default.string.isRequired,
  onSelect: _propTypes2.default.func.isRequired,
  name: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string.isRequired,
  himsDistricts: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  validateRef: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({})])
};

SearchHimsDistricts.mapStateToProps = function (state) {
  return {
    himsDistricts: state.himsDistricts
  };
};

SearchHimsDistricts.getPropsToState = function (props) {
  var value = props.value || '';
  var noResultsMessage = 'Loading...';

  var himsDistricts = props.himsDistricts,
      state = props.state;

  var districts = [];
  if (himsDistricts && himsDistricts.data && himsDistricts.data.length > 0) {
    var srState = _states2.default.find(function (s) {
      return s.value === state;
    });
    if (srState) {
      var himsState = himsDistricts.data.find(function (hs) {
        return hs.id === srState.kod_negeri_id;
      });
      if (himsState && himsState.districts) {
        districts = himsState.districts.map(function (c) {
          return {
            key: c.id,
            value: c.id,
            kod_negeri_id: c.kod_negeri_id,
            kod_daerah_id: c.kod_daerah_id,
            text: c.keterangan
          };
        });
      }
    }
  }

  if (districts.length > 0 && value) {
    var himsDistrict = districts.find(function (c) {
      return c.value === value;
    });
    if (!himsDistrict) {
      value = '';
    }
  }

  return {
    value: value,
    noResultsMessage: noResultsMessage,
    districts: districts
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleOnChange = function (e, data) {
    var value = data.value;

    var district = _this2.state.districts.find(function (c) {
      return c.value === value;
    });
    if (!district) {
      value = '';
    }
    _this2.setState({ value: value }, function () {
      if (district && _this2.props.onSelect) {
        _this2.props.onSelect(district);
      }
    });
  };

  this.handleOnError = function (isError) {
    _this2.setState({ error: isError });
  };
};

exports.default = (0, _reactRedux.connect)(SearchHimsDistricts.mapStateToProps)(SearchHimsDistricts);

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _flash = __webpack_require__(5);

var _himsPostcodes = __webpack_require__(994);

var _states = __webpack_require__(144);

var _states2 = _interopRequireDefault(_states);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchHimsPostcodes = function (_Component) {
  _inherits(SearchHimsPostcodes, _Component);

  function SearchHimsPostcodes(props) {
    _classCallCheck(this, SearchHimsPostcodes);

    var _this = _possibleConstructorReturn(this, (SearchHimsPostcodes.__proto__ || Object.getPrototypeOf(SearchHimsPostcodes)).call(this, props));

    _initialiseProps.call(_this);

    var state = SearchHimsPostcodes.getPropsToState(props);
    _this.state = _extends({}, state);
    return _this;
  }

  _createClass(SearchHimsPostcodes, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var store = this.context.store;

      store.dispatch((0, _himsPostcodes.fetchHimsPostcodes)(false)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = SearchHimsPostcodes.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var name = this.props.name;
      var _state = this.state,
          postcodes = _state.postcodes,
          value = _state.value;

      return _react2.default.createElement(
        _AppForm2.default.Validate,
        {
          ref: this.props.validateRef,
          validation: [_webValidations.required],
          onChange: this.handleOnChange,
          validateLabel: 'Postcode'
        },
        _react2.default.createElement(_semanticUiReact.Form.Select, {
          name: name,
          fluid: true,
          options: postcodes,
          placeholder: 'Postcode*',
          label: 'Postcode*',
          search: true,
          selectOnBlur: false,
          value: value
        })
      );
    }
  }]);

  return SearchHimsPostcodes;
}(_react.Component);

SearchHimsPostcodes.contextTypes = {
  store: _propTypes2.default.object
};
SearchHimsPostcodes.propTypes = {
  state: _propTypes2.default.string.isRequired,
  onSelect: _propTypes2.default.func.isRequired,
  name: _propTypes2.default.string.isRequired,
  himsPostcodes: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  validateRef: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({})])
};

SearchHimsPostcodes.mapStateToProps = function (state) {
  return {
    himsPostcodes: state.himsPostcodes
  };
};

SearchHimsPostcodes.getPropsToState = function (props) {
  var value = props.value || '';
  var noResultsMessage = 'Loading...';

  var himsPostcodes = props.himsPostcodes,
      state = props.state;


  var postcodes = [];
  if (himsPostcodes && himsPostcodes.data && himsPostcodes.data.length > 0) {
    var srState = _states2.default.find(function (s) {
      return s.value === state;
    });
    if (srState) {
      var himsState = himsPostcodes.data.find(function (hp) {
        return hp.id === srState.kod_negeri_id;
      });
      if (himsState && himsState.postcodes) {
        postcodes = himsState.postcodes.map(function (p) {
          return {
            key: p.poskod,
            value: p.poskod,
            kod_negeri_id: himsState.id,
            kod_bandar_id: p.kod_bandar_id,
            bandar: p.bandar,
            text: p.poskod
          };
        });
      }
    } else {
      postcodes = himsPostcodes.data.flatMap(function (d) {
        return (d.postcodes || []).map(function (postcode) {
          return {
            key: postcode.poskod,
            value: postcode.poskod,
            kod_negeri_id: d.id,
            kod_bandar_id: postcode.kod_bandar_id,
            bandar: postcode.bandar,
            text: postcode.poskod
          };
        });
      });
    }
  }

  // // add 'TIADA MAKLUMAT POSKOD' option if there isn't any
  // if (postcodes.length === 0) {
  //   postcodes.unshift({
  //     key: '0000000',
  //     value: '0000000',
  //     kod_negeri_id: null,
  //     kod_bandar_id: '0000',
  //     text: 'TIADA MAKLUMAT POSKOD',
  //   });
  // }

  if (postcodes.length > 0 && value) {
    var himsPostcode = postcodes.find(function (c) {
      return c.value === value;
    });
    if (!himsPostcode) {
      value = '';
    }
  }

  return {
    value: value,
    noResultsMessage: noResultsMessage,
    postcodes: postcodes
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleOnChange = function (e, data) {
    var value = data.value;

    var postcode = _this2.state.postcodes.find(function (c) {
      return c.value === value;
    });
    if (!postcode) {
      value = '';
    }
    _this2.setState({ value: value }, function () {
      if (postcode && _this2.props.onSelect) {
        _this2.props.onSelect(postcode);
      }
    });
  };
};

exports.default = (0, _reactRedux.connect)(SearchHimsPostcodes.mapStateToProps)(SearchHimsPostcodes);

/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchFilter = function (_Component) {
  _inherits(SearchFilter, _Component);

  function SearchFilter(props) {
    _classCallCheck(this, SearchFilter);

    var _this = _possibleConstructorReturn(this, (SearchFilter.__proto__ || Object.getPrototypeOf(SearchFilter)).call(this, props));

    _initialiseProps.call(_this);

    var state = SearchFilter.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(SearchFilter, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = SearchFilter.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        'form',
        { onSubmit: this.handleSearch, className: 'search-in' },
        _react2.default.createElement(_semanticUiReact.Input, {
          fluid: true,
          icon: this.state.search ? _react2.default.createElement(_semanticUiReact.Icon, {
            className: 'clear-button',
            color: 'teal',
            link: true,
            name: 'x',
            onClick: this.handleClear,
            title: t('Clear input')
          }) : null,
          loading: this.props.isLoading,
          disabled: this.props.isLoading,
          name: 'search',
          onChange: this.handleOnChange,
          placeholder: t(this.props.placeholder),
          value: this.state.search
        }),
        this.props.options && this.props.options.length > 0 && _react2.default.createElement(_semanticUiReact.Dropdown, {
          className: this.props.isFullSize ? 'small' : null,
          fluid: true,
          selection: true,
          onChange: this.handleOnDropdownChange,
          options: this.props.options,
          disabled: this.props.isLoading,
          value: this.state.searchIn
        }),
        _react2.default.createElement(
          'button',
          {
            type: 'submit',
            className: 'ui icon right attached button search',
            disabled: this.props.isLoading,
            title: t('Search')
          },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'search' })
        )
      );
    }
  }]);

  return SearchFilter;
}(_react.Component);

SearchFilter.propTypes = {
  filterName: _propTypes2.default.string.isRequired,
  filterInName: _propTypes2.default.string.isRequired,
  isLoading: _propTypes2.default.bool,
  onChange: _propTypes2.default.func.isRequired,
  onSearchInChange: _propTypes2.default.func,
  onClear: _propTypes2.default.func.isRequired,
  search: _propTypes2.default.string,
  searchIn: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  options: _propTypes2.default.arrayOf(_propTypes2.default.object),
  isFullSize: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
SearchFilter.defaultProps = {
  filterName: 'search',
  filterInName: 'searchIn',
  isLoading: false,
  placeholder: 'Search'
};

SearchFilter.getPropsToState = function (props) {
  var search = props.search || '';
  var searchIn = props.searchIn || '';
  if (props.options && props.options.length > 0 && (!searchIn || searchIn === '')) {
    searchIn = props.options[0].value;
  }
  return {
    search: search,
    searchIn: searchIn
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleClear = function () {
    _this2.setState({ search: '' }, function () {
      var _props = _this2.props,
          onClear = _props.onClear,
          filterName = _props.filterName;

      if (onClear) {
        onClear(filterName);
      }
    });
  };

  this.handleSearch = function (e) {
    if (e) {
      e.preventDefault();
    }
    if (_this2.state.search === '' && _this2.props.search !== '') {
      _this2.handleClear();
    } else if (_this2.state.search) {
      _this2.props.onChange(_this2.state.search, _this2.props.filterName);
    }
  };

  this.handleOnChange = function (e) {
    var search = e.target.value;
    _this2.setState({ search: search }, function () {
      if (search === '') {
        _this2.handleClear();
      }
    });
  };

  this.handleOnDropdownChange = function (e, _ref) {
    var value = _ref.value;

    _this2.setState({ searchIn: value }, function () {
      _this2.props.onSearchInChange(value, _this2.props.filterInName);
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(SearchFilter);

/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _SignaturePad = __webpack_require__(2192);

var _SignaturePad2 = _interopRequireDefault(_SignaturePad);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ESigningModal = function (_Component) {
  _inherits(ESigningModal, _Component);

  function ESigningModal(props) {
    _classCallCheck(this, ESigningModal);

    var _this = _possibleConstructorReturn(this, (ESigningModal.__proto__ || Object.getPrototypeOf(ESigningModal)).call(this, props));

    _this.handleOnOpen = function (e) {
      e.preventDefault();
      _this.setState({ open: true });
    };

    _this.handleOnClose = function () {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var open = false;
      if (!force && _this.props.onClose) {
        open = _this.props.onClose();
      }
      _this.setState({ open: open });
    };

    _this.handleOnCancel = function () {
      _this.signaturePad.clear();
      _this.close();
    };

    _this.clear = function (e) {
      e.preventDefault();
      _this.signaturePad.clear();
    };

    _this.state = {
      open: false,
      modalOpen: false
    };
    return _this;
  }

  _createClass(ESigningModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var open = nextProps.open;

      if (open) {
        this.setState({
          open: open
        });
      }
    }
  }, {
    key: 'close',
    value: function close() {
      this.handleOnClose(true);
    }
  }, {
    key: 'signData',
    value: function signData() {
      return this.signaturePad.getTrimmedCanvas().toDataURL();
    }
  }, {
    key: 'isEmpty',
    value: function isEmpty() {
      if (this.signaturePad.isEmpty()) {
        return true;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          trigger = _props.trigger,
          saveButton = _props.saveButton,
          cancelButton = _props.cancelButton,
          t = _props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          className: 'signature',
          closeOnDimmerClick: false,
          size: window.innerWidth < 1200 ? 'fullscreen' : 'large',
          trigger: trigger,
          open: this.state.open,
          onClose: this.handleOnCancel,
          onOpen: this.handleOnOpen
        },
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            'div',
            { className: 'wrapper' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_SignaturePad2.default, {
                loading: this.props.loading,
                ref: function ref(_ref) {
                  _this2.signaturePad = _ref;
                },
                backgroundColor: 'transparent',
                canvasProps: { width: window.innerWidth, height: window.innerHeight - 100, className: 'signaturePad' }
              })
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            t('Sign above')
          ),
          _react2.default.createElement(
            'p',
            { style: { fontWeight: '200' } },
            _react2.default.createElement(
              'em',
              null,
              t('Sign note')
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          { className: 'text-center' },
          _react2.default.createElement(_semanticUiReact.Button, { onClick: this.clear, disabled: this.props.loading, basic: true, color: 'grey', content: t('Clear') }),
          cancelButton || _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleOnCancel, disabled: this.props.loading, basic: true, color: 'grey', content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }) }),
          saveButton
        )
      );
    }
  }]);

  return ESigningModal;
}(_react.Component);

ESigningModal.propTypes = {
  trigger: _propTypes2.default.node,
  onClose: _propTypes2.default.func,
  cancelButton: _propTypes2.default.node,
  saveButton: _propTypes2.default.node,
  loading: _propTypes2.default.bool,
  open: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
ESigningModal.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(ESigningModal);

/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SpecificationPresetList = function (_Component) {
  _inherits(SpecificationPresetList, _Component);

  function SpecificationPresetList(props) {
    _classCallCheck(this, SpecificationPresetList);

    var _this = _possibleConstructorReturn(this, (SpecificationPresetList.__proto__ || Object.getPrototypeOf(SpecificationPresetList)).call(this, props));

    _this.handleChangePage = function (currentPage) {
      _this.setState({ currentPage: currentPage }, function () {
        _this.fetchSpecifications(_this.props.where);
      });
    };

    _this.handleCancelDelete = function (e) {
      e.preventDefault();
      _this.setState({
        showConfirm: false,
        selectedPreset: null
      });
    };

    _this.handleDelete = function (e, selectedPreset) {
      e.preventDefault();
      _this.setState({
        selectedPreset: selectedPreset
      }, function () {
        _this.setState({
          showConfirm: true
        });
      });
    };

    _this.handleConfirmDelete = function (e) {
      e.preventDefault();
      _this.setState({
        showConfirm: false
      }, function () {
        _this.deletePreset(_this.state.selectedPreset.id);
      });
    };

    _this.state = {
      count: 0,
      limit: 0,
      offset: 0,
      loading: props.loading || true,
      data: [],
      currentPage: 1,
      showConfirm: false,
      selectedPreset: null
    };
    return _this;
  }

  _createClass(SpecificationPresetList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchSpecifications(this.props.where);
    }
  }, {
    key: 'setSpecifications',
    value: function setSpecifications() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this2.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchSpecification',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var store, t, res, token, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                token = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/specifications/' + this.props.type + '/' + id + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 15:
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                return _context.abrupt('return', null);

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 27;
                break;

              case 26:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

              case 27:
                return _context.abrupt('return', token);

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchSpecification(_x4) {
        return _ref.apply(this, arguments);
      }

      return fetchSpecification;
    }()
  }, {
    key: 'fetchSpecifications',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var where = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var store, t, query, res, message, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, where);

                query.page = this.state.currentPage || 1;
                res = void 0;
                _context2.prev = 7;
                _context2.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/specifications/' + this.props.type + '/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 10:
                res = _context2.sent;
                _context2.next = 21;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](7);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 18:
                _context2.next = 20;
                return this.setLoading(false);

              case 20:
                return _context2.abrupt('return');

              case 21:
                if (res.ok) {
                  _context2.next = 29;
                  break;
                }

                _context2.next = 24;
                return res.text();

              case 24:
                message = _context2.sent;
                _context2.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 27:
                _context2.next = 39;
                break;

              case 29:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context2.next = 34;
                return res.json();

              case 34:
                data = _context2.sent;
                _context2.next = 37;
                return this.setSpecifications(data);

              case 37:
                _context2.next = 39;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 39:
                _context2.next = 41;
                return this.setLoading(false);

              case 41:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 13]]);
      }));

      function fetchSpecifications() {
        return _ref2.apply(this, arguments);
      }

      return fetchSpecifications;
    }()
  }, {
    key: 'deletePreset',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id) {
        var store, t, token, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                _context3.next = 4;
                return this.fetchSpecification(id);

              case 4:
                token = _context3.sent;
                _context3.next = 7;
                return this.setState({ loading: true });

              case 7:
                _context3.prev = 7;
                _context3.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/specifications/' + this.props.type + '/' + id + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': token
                  }
                }));

              case 10:
                _context3.next = 22;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](7);

                Bugsnag.notifyException(_context3.t0);

                if (!(_context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 21;
                  break;
                }

                _context3.next = 18;
                return _context3.t0.res.text();

              case 18:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context3.t0));

              case 22:
                _context3.next = 24;
                return this.setState({ loading: false });

              case 24:
                this.handleChangePage(1);
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Preset successfully deleted', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 26:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[7, 12]]);
      }));

      function deletePreset(_x6) {
        return _ref3.apply(this, arguments);
      }

      return deletePreset;
    }()
  }, {
    key: 'renderPath',
    value: function renderPath() {
      if (this.props.type === 'unit_layouts') {
        return 'layouts';
      }
      return this.props.type;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state = this.state,
          count = _state.count,
          limit = _state.limit,
          offset = _state.offset,
          loading = _state.loading,
          currentPage = _state.currentPage;
      var t = this.props.t;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_DeleteConfirm2.default, {
          open: this.state.showConfirm,
          onClose: this.handleCancelDelete,
          onConfirm: this.handleConfirmDelete,
          name: this.state.selectedPreset ? this.state.selectedPreset.name : ''
        }),
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 20 },
            active: this.state.loading && this.state.data.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            striped: true, unstackable: true,
            selectable: true
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 4 },
                _react2.default.createElement(_semanticUiReact.Button, {
                  as: _reactRouter.Link,
                  primary: true,
                  size: 'small',
                  icon: 'add',
                  content: t('Preset'),
                  to: '/settings/' + this.renderPath() + '/new/'
                }),
                this.props.headerNode ? this.props.headerNode({
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: this.state.data.length,
                  loading: loading,
                  currentPage: currentPage,
                  onChange: this.handleChangePage
                }) : _react2.default.createElement(_PageNav2.default, {
                  floated: 'right',
                  currentPage: currentPage,
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: this.state.data.length,
                  loading: loading,
                  onChange: this.handleChangePage
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 4 },
                t('Name')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 4 },
                t('Short Name')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 2 },
                t('Description')
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            this.state.data.length > 0 ? this.state.data.map(function (field, key) {
              return _react2.default.createElement(
                _semanticUiReact.Table.Row,
                { key: key },
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { width: 4 },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    {
                      to: '/settings/' + _this5.renderPath() + '/' + field.id + '/'
                    },
                    field.name
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { width: 4 },
                  field.shortName
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  field.description || '-'
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { collapsing: true, textAlign: 'right' },
                  _react2.default.createElement(_semanticUiReact.Button, {
                    compact: true,
                    negative: true,
                    type: 'button',
                    size: 'tiny',
                    icon: 'cancel',
                    onClick: function onClick(e) {
                      return _this5.handleDelete(e, field);
                    }
                  })
                )
              );
            }) : _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 4, textAlign: 'center' },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                ) : _react2.default.createElement(
                  'p',
                  null,
                  t('No presets found'),
                  '.'
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Footer,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 4, textAlign: 'right' },
                this.props.footerNode ? this.props.footerNode({
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: this.state.data.length,
                  loading: loading,
                  currentPage: currentPage,
                  onChange: this.handleChangePage
                }) : _react2.default.createElement(_PageNav2.default, {
                  upward: true,
                  currentPage: currentPage,
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: this.state.data.length,
                  loading: loading,
                  onChange: this.handleChangePage
                })
              )
            )
          )
        )
      );
    }
  }]);

  return SpecificationPresetList;
}(_react.Component);

SpecificationPresetList.contextTypes = {
  store: _propTypes2.default.object
};
SpecificationPresetList.propTypes = {
  headerNode: _propTypes2.default.func,
  footerNode: _propTypes2.default.func,
  where: _propTypes2.default.shape({
    limit: _propTypes2.default.number
  }),
  loading: _propTypes2.default.bool,
  type: _propTypes2.default.oneOf(['projects', 'unit_layouts', 'units']).isRequired
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(SpecificationPresetList);

/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint max-len: 0*/
var icon = function icon(type, backfill, iconfill) {
  switch (type) {
    case 'projects':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('circle', { id: 'book_dash_icon_back', style: { fill: backfill }, cx: '63', cy: '63', r: '63' }),
        _react2.default.createElement('path', { d: 'M88,46.2c-0.4-2-2.4-5.8-7-5.8c-0.6,0-1,0.4-1,1v3.4h-36v-3.4c0-0.6-0.4-1-1-1c-4.6,0-6.6,3.8-7,5.8c0,0.1,0,0.1,0,0.2v31.9c-0.1,0.5-0.3,3.2,1.3,5.2c1.1,1.2,2.6,1.9,4.7,1.9h39c2.4,0,7-1.5,7-7v-32C88,46.3,88,46.2,88,46.2zM82,42.5c3,0.5,3.9,3.5,4,4v27.9c-1.2-1.2-2.8-1.8-4-2V42.5z M38.1,46.5c0.1-0.6,1-3.5,4-4v30c-1.2,0.2-2.8,0.8-4,2V46.5zM81,83.3h-39c-1.4,0-2.5-0.4-3.2-1.2c-1.2-1.3-0.9-3.5-0.8-3.6c0.8-4.1,4.8-4.2,5-4.2c0.6,0,1-0.4,1-1V46.8h36v26.6c0,0.5,0.4,1,1,1c0.2,0,4.1,0.1,5,4.1C85.9,83.1,81.5,83.3,81,83.3z' }),
        _react2.default.createElement('path', { d: 'M78,52.4h-25c-0.6,0-1,0.4-1,1v5h-6c-0.6,0-1,0.4-1,1v17c0,0.6,0.4,1,1,1h20c0.6,0,1-0.4,1-1v-10h6c0.6,0,1-0.4,1-1s-0.4-1-1-1H58c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1c-0.5,0-1,0.4-1,1v3h-10v-6.1h6c0.6,0,1-0.4,1-1s-0.4-1-1-1h-6v-6.9h6c0.6,0,1-0.4,1-1v-5h10.8v6c0,0.6,0.4,1,1,1s1-0.4,1-1v-6h3.8c0.6,1.6,2.5,5.4,6.4,6.3v14.6h-7c-0.6,0-1,0.4-1,1s0.4,1,1,1h8c0.6,0,1-0.4,1-1v-23C79,52.8,78.6,52.4,78,52.4z M58.1,71.3c0.5,0,1-0.4,1-1v-4h6v9h-6v-3C59,71.8,58.6,71.3,58.1,71.3zM72.8,54.4H77v4.3C74.8,57.9,73.4,55.8,72.8,54.4z' })
      );
    case 'bookings':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('circle', { id: 'book_dash_icon_back', style: { fill: backfill }, cx: '63', cy: '63', r: '63' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M87,49.4c-0.6,0-1,0.4-1,1v33c0,2.8-2.5,3-3,3H41c-2.8,0-3-2.5-3-3v-33c0-0.6-0.4-1-1-1s-1,0.4-1,1v33c0,1.7,1,5,5,5h42c1.7,0,5-1,5-5v-33C88,49.8,87.6,49.4,87,49.4z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M40.5,85.2c0.2,0.1,0.4,0.2,0.6,0.2c0.1,0,0.3,0,0.4-0.1c11.4-4.8,20.1-1,20.2-1c0.3,0.1,0.6,0.1,0.9,0c7.5-3.8,20.1,0,20.3,0.1c0.3,0.1,0.6,0,0.9-0.2c0.3-0.2,0.4-0.5,0.4-0.8v-36c0-0.4-0.3-0.8-0.7-0.9l-3-1c-0.5-0.2-1.1,0.1-1.3,0.6c0,0.1,0,0.2-0.1,0.3v-8c0-0.3-0.2-0.6-0.4-0.8c-0.3-0.2-0.6-0.2-0.9-0.1c-0.4,0.1-9.2,3.1-14.3,7.2C63.1,44.8,63,45,63,45.3c0-0.4-0.3-0.8-0.8-0.9c-12.2-3-21.3,0.9-21.6,1.1C40.2,45.6,40,46,40,46.4v38C40,84.7,40.2,85,40.5,85.2z M63,45.4c0,0.2,0.1,0.4,0.2,0.6c0.3,0.4,1,0.5,1.4,0.2c3.7-2.9,9.7-5.4,12.4-6.4v32.9l-14,6.1V45.4z M42,47c2.1-0.8,9.6-3,19-0.9v34.2c0,0.3,0.2,0.7,0.5,0.8c0.3,0.2,0.6,0.2,0.9,0.1l16-7c0.4-0.2,0.6-0.5,0.6-0.9v-27c0,0.4,0.3,0.8,0.7,0.9l2.3,0.8v34c-3.5-0.9-13.2-2.9-20,0.2c-1.9-0.7-9.7-3.2-20,0.6V47z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M46.4,55.3c0,0,4.8-1.8,10.3,0c0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.8-0.3,0.9-0.7c0.2-0.5-0.1-1.1-0.6-1.3c-6.3-2.1-11.5-0.1-11.7,0c-0.5,0.2-0.8,0.8-0.6,1.3C45.3,55.2,45.9,55.5,46.4,55.3z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M46.4,60.3c0,0,4.8-1.8,10.3,0c0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.8-0.3,0.9-0.7c0.2-0.5-0.1-1.1-0.6-1.3c-6.3-2.1-11.5-0.1-11.7,0c-0.5,0.2-0.8,0.8-0.6,1.3C45.3,60.2,45.9,60.5,46.4,60.3z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M46.4,65.3c0,0,4.8-1.8,10.3,0c0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.8-0.3,0.9-0.7c0.2-0.5-0.1-1.1-0.6-1.3c-6.3-2.1-11.5-0.1-11.7,0c-0.5,0.2-0.8,0.8-0.6,1.3C45.3,65.2,45.9,65.5,46.4,65.3z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M46.4,70.3c0,0,4.8-1.8,10.3,0c0.1,0,0.2,0.1,0.3,0.1c0.4,0,0.8-0.3,0.9-0.7c0.2-0.5-0.1-1.1-0.6-1.3c-6.3-2.1-11.5-0.1-11.7,0c-0.5,0.2-0.8,0.8-0.6,1.3C45.3,70.2,45.9,70.5,46.4,70.3z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M57,75.4c0.4,0,0.8-0.3,0.9-0.7c0.2-0.5-0.1-1.1-0.6-1.3c-6.3-2.1-11.5-0.1-11.7,0c-0.5,0.2-0.8,0.8-0.6,1.3c0.2,0.5,0.8,0.8,1.3,0.6c0,0,4.8-1.8,10.3,0C56.8,75.3,56.9,75.4,57,75.4z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M73.8,46.4c-4.1,1-8.2,4-8.4,4.2c-0.4,0.3-0.5,1-0.2,1.4c0.2,0.3,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2c0,0,3.9-2.9,7.6-3.8c0.5-0.1,0.9-0.7,0.7-1.2C74.8,46.6,74.3,46.2,73.8,46.4z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M73.8,51.4c-4.1,1-8.2,4-8.4,4.2c-0.4,0.3-0.5,1-0.2,1.4c0.2,0.3,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2c0,0,3.9-2.9,7.6-3.8c0.5-0.1,0.9-0.7,0.7-1.2C74.8,51.6,74.3,51.2,73.8,51.4z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M73.8,56.4c-4.1,1-8.2,4-8.4,4.2c-0.4,0.3-0.5,1-0.2,1.4c0.2,0.3,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2c0,0,3.9-2.9,7.6-3.8c0.5-0.1,0.9-0.7,0.7-1.2C74.8,56.6,74.3,56.2,73.8,56.4z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M73.8,61.4c-4.1,1-8.2,4-8.4,4.2c-0.4,0.3-0.5,1-0.2,1.4c0.2,0.3,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2c0,0,3.9-2.9,7.6-3.8c0.5-0.1,0.9-0.7,0.7-1.2C74.8,61.6,74.3,61.2,73.8,61.4z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M73.8,66.4c-4.1,1-8.2,4-8.4,4.2c-0.4,0.3-0.5,1-0.2,1.4c0.2,0.3,0.5,0.4,0.8,0.4c0.2,0,0.4-0.1,0.6-0.2c0,0,3.9-2.9,7.6-3.8c0.5-0.1,0.9-0.7,0.7-1.2C74.8,66.6,74.3,66.2,73.8,66.4z' })
      );
    case 'marketplace':
      return _react2.default.createElement(
        'g',
        { id: 'Layer_1', 'data-name': 'Layer 1' },
        _react2.default.createElement('ellipse', { id: 'book_dash_icon_back', 'data-name': 'Ellipse_18', cx: '67.5', cy: '68', rx: '67.5', ry: '68', style: { fill: backfill } }),
        _react2.default.createElement(
          'g',
          null,
          _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'M85.2,38v19.6c0,4.2,3.7,7.6,8.3,7.6h1.2c4.6,0,8.3-3.4,8.3-7.6l-4.7-17.3C97.9,39,96.5,38,94.9,38H85.2z', style: { fill: 'none', stroke: '#AABAC9', strokeWidth: '3.9979', strokeMiterlimit: '3.9979' } }),
            _react2.default.createElement(
              'g',
              null,
              _react2.default.createElement('path', { d: 'M67.5,57.7C67.5,57.7,67.5,57.7,67.5,57.7c0,4.2,3.7,7.6,8.3,7.6h1.2c4.6,0,8.3-3.4,8.3-7.6V38H67.5V57.7z', style: { fill: 'none', stroke: '#AABAC9', strokeWidth: '3.9979', strokeMiterlimit: '3.9979' } }),
              _react2.default.createElement('path', { d: 'M67.5,38H49.7v19.6c0,0,0,0,0,0c0,4.2,3.7,7.6,8.3,7.6h1.2c4.6,0,8.3-3.4,8.3-7.6c0,0,0,0,0,0V38z', style: { fill: 'none', stroke: '#AABAC9', strokeWidth: '3.9979', strokeMiterlimit: '3.9979' } }),
              _react2.default.createElement('path', { d: 'M49.7,38h-9.8c-1.6,0-2.9,1-3.3,2.3L32,57.7c0,4.2,3.7,7.6,8.3,7.6h1.2c4.6,0,8.3-3.4,8.3-7.6c0,0,0,0,0,0V38z', style: { fill: 'none', stroke: '#AABAC9', strokeWidth: '3.9979', strokeMiterlimit: '3.9979' } })
            )
          ),
          _react2.default.createElement('line', { x1: '105.6', y1: '98', x2: '29.3', y2: '98', style: { fill: 'none', stroke: '#AABAC9', strokeWidth: '3.9979', strokeMiterlimit: '3.9979' } }),
          _react2.default.createElement('polyline', { points: '97.4,64.8 97.4,97.7 37.5,97.7 37.5,64.8', style: { fill: 'none', stroke: '#AABAC9', strokeWidth: '3.9979', strokeMiterlimit: '3.9979' } }),
          _react2.default.createElement('path', { d: 'M75.1,98H59.8c-0.3,0-0.5-0.2-0.5-0.5V76.6c0-0.3,0.2-0.5,0.5-0.5h15.3c0.3,0,0.5,0.2,0.5,0.5v20.9C75.6,97.8,75.4,98,75.1,98z', style: { fill: 'none', stroke: '#AABAC9', strokeWidth: '3.9979', strokeMiterlimit: '3.9979' } })
        )
      );
    case 'customers':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('circle', { id: 'book_dash_icon_back', style: { fill: backfill }, cx: '63', cy: '63', r: '63' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M75.1,49.9c0-7.2-5.8-13-13-13c-7.2,0-13,5.8-13,13s5.8,13,13,13C69.2,62.9,75.1,57,75.1,49.9z M62.1,60.9c-6.1,0-11-4.9-11-11s4.9-11,11-11s11,4.9,11,11S68.1,60.9,62.1,60.9z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M53.8,62.9c-0.2,0-4.3,1.1-8.4,4.7c-3.8,3.3-8.3,9.5-8.3,20.3c0,0.6,0.4,1,1,1s1-0.4,1-1c0-18.9,14.6-22.9,15.2-23c0.5-0.1,0.9-0.7,0.7-1.2C54.9,63.1,54.3,62.7,53.8,62.9z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M70.2,62.9c-0.5-0.1-1.1,0.2-1.2,0.7c-0.1,0.5,0.2,1.1,0.7,1.2c0.2,0,15.2,4,15.2,23c0,0.6,0.4,1,1,1s1-0.4,1-1C87,67.3,70.4,62.9,70.2,62.9z' })
      );
    case 'staff':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('circle', { id: 'book_dash_icon_back', style: { fill: backfill }, cx: '63', cy: '63', r: '63' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M49,55.4c3.9,0,7-3.1,7-7s-3.1-7-7-7s-7,3.1-7,7S45.1,55.4,49,55.4z M49,43.4c2.8,0,5,2.2,5,5s-2.2,5-5,5s-5-2.2-5-5S46.3,43.4,49,43.4z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M82,48.4c0-3.9-3.1-7-7-7s-7,3.1-7,7s3.1,7,7,7S82,52.2,82,48.4z M75,53.4c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S77.8,53.4,75,53.4z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M44.8,55.4c-0.1,0-8.8,2.3-8.8,13c0,0.6,0.4,1,1,1s1-0.4,1-1c0-9.1,6.9-11,7.2-11c0.5-0.1,0.9-0.7,0.7-1.2S45.3,55.2,44.8,55.4z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M79.2,55.4c-0.5-0.1-1.1,0.2-1.2,0.7c-0.1,0.5,0.2,1.1,0.7,1.2c0.1,0,7.2,1.9,7.2,11c0,0.6,0.4,1,1,1s1-0.4,1-1C88,57.7,79.3,55.4,79.2,55.4z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M61.8,64.4c3.9,0,7-3.1,7-7s-3.1-7-7-7s-7,3.1-7,7S57.9,64.4,61.8,64.4z M61.8,52.4c2.7,0,5,2.2,5,5s-2.2,5-5,5c-2.7,0-5-2.2-5-5S59,52.4,61.8,52.4z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M65.9,65c-0.5-0.1-1.1,0.3-1.1,0.8c-0.1,0.5,0.3,1.1,0.8,1.1c4.9,0.7,6.8,6.4,7.1,7.3v7.2c0,0.7-0.6,0.8-1,0.8h-19c-1.4,0-2-0.5-2-0.8l0.2-7.2c1.1-4.8,7.1-7.4,7.2-7.4c0.5-0.2,0.8-0.8,0.5-1.3c-0.2-0.5-0.8-0.7-1.3-0.5c-0.3,0.1-7.1,3-8.4,8.9c0,0.1,0,0.1,0,0.2l-0.2,7.3c0,1,0.8,2.8,4,2.8h19c1.2,0,3-0.8,3-2.8v-7.4c0-0.1,0-0.2,0-0.3C74.6,73.6,72.5,66,65.9,65z' })
      );
    case 'pictures':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('circle', { id: 'book_dash_icon_back', style: { fill: backfill }, cx: '63', cy: '63', r: '63' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M57.3,58.3c0,2.3,1.9,4.1,4.1,4.1s4.1-1.9,4.1-4.1s-1.9-4.1-4.1-4.1S57.3,56,57.3,58.3z M61.4,56.2c1.2,0,2.1,1,2.1,2.1s-1,2.1-2.1,2.1c-1.2,0-2.1-1-2.1-2.1S60.2,56.2,61.4,56.2z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M82.4,46.5c-0.1-0.1-0.1-0.2-0.2-0.3l-9-9c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.3-0.1-0.4-0.1h-27c-2.9,0-4,2.4-4,4v44c0,2.6,3.3,3.8,3.7,3.9c0.1,0,0.2,0.1,0.3,0.1h34c0.2,0,0.3,0,0.4-0.1c2.5-1.3,2.6-3.8,2.6-3.9v-38C82.5,46.7,82.5,46.6,82.4,46.5z M73.5,40.3l5.6,5.6h-4.6c-0.8,0-1-0.6-1-1V40.3z M79.3,86.9H45.7c-0.6-0.2-2.2-1-2.2-2v-44c0-0.5,0.2-2,2-2h26v6c0,1.2,0.8,3,3,3h6v37C80.5,84.9,80.5,86.1,79.3,86.9z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M73.5,56.9h-5c-0.6,0-1,0.4-1,1s0.4,1,1,1h5c0.8,0,1,0.6,1,1v11.6l-6.3-6.3c-0.4-0.4-1-0.4-1.4,0l-2,2c-0.4,0.4-0.4,1,0,1.4s1,0.4,1.4,0l1.3-1.3l7,7v1.6c0,1.8-1.5,2-2,2h-20c-1.3,0-1.9-0.8-2.1-1.4l8.1-8.1l6.3,6.3c0.4,0.4,1,0.4,1.4,0s0.4-1,0-1.4l-7-7c-0.4-0.4-1-0.4-1.4,0l-7.6,7.6V60.6c0-1.2,1.1-1.6,1.4-1.7h1.9c0.6,0,1-0.4,1-1s-0.4-1-1-1h-2c-0.1,0-0.1,0-0.2,0c-1.1,0.2-3.1,1.3-3.1,3.7v15.3c0,0,0,0.1,0,0.1c0.1,1.3,1.2,3.9,4.3,3.9h20c1.6,0,4-1.1,4-4v-16C76.5,58.6,75.7,56.9,73.5,56.9z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M57.5,45.9c0.6,0,1-0.4,1-1s-0.4-1-1-1h-9c-0.6,0-1,0.4-1,1s0.4,1,1,1H57.5z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M49.5,47.9c-0.6,0-1,0.4-1,1s0.5,1,1,1s1-0.4,1-1S50.2,47.9,49.5,47.9L49.5,47.9z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M54.5,47.9c-0.6,0-1,0.4-1,1s0.5,1,1,1s1-0.4,1-1S55.2,47.9,54.5,47.9L54.5,47.9z' })
      );
    case 'documents':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('circle', { id: 'book_dash_icon_back', style: { fill: backfill }, cx: '63', cy: '63', r: '63' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M57.3,58.3c0,2.3,1.9,4.1,4.1,4.1s4.1-1.9,4.1-4.1s-1.9-4.1-4.1-4.1S57.3,56,57.3,58.3z M61.4,56.2c1.2,0,2.1,1,2.1,2.1s-1,2.1-2.1,2.1c-1.2,0-2.1-1-2.1-2.1S60.2,56.2,61.4,56.2z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M82.4,46.5c-0.1-0.1-0.1-0.2-0.2-0.3l-9-9c-0.1-0.1-0.2-0.2-0.3-0.2c-0.1-0.1-0.3-0.1-0.4-0.1h-27c-2.9,0-4,2.4-4,4v44c0,2.6,3.3,3.8,3.7,3.9c0.1,0,0.2,0.1,0.3,0.1h34c0.2,0,0.3,0,0.4-0.1c2.5-1.3,2.6-3.8,2.6-3.9v-38C82.5,46.7,82.5,46.6,82.4,46.5z M73.5,40.3l5.6,5.6h-4.6c-0.8,0-1-0.6-1-1V40.3z M79.3,86.9H45.7c-0.6-0.2-2.2-1-2.2-2v-44c0-0.5,0.2-2,2-2h26v6c0,1.2,0.8,3,3,3h6v37C80.5,84.9,80.5,86.1,79.3,86.9z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M73.5,56.9h-5c-0.6,0-1,0.4-1,1s0.4,1,1,1h5c0.8,0,1,0.6,1,1v11.6l-6.3-6.3c-0.4-0.4-1-0.4-1.4,0l-2,2c-0.4,0.4-0.4,1,0,1.4s1,0.4,1.4,0l1.3-1.3l7,7v1.6c0,1.8-1.5,2-2,2h-20c-1.3,0-1.9-0.8-2.1-1.4l8.1-8.1l6.3,6.3c0.4,0.4,1,0.4,1.4,0s0.4-1,0-1.4l-7-7c-0.4-0.4-1-0.4-1.4,0l-7.6,7.6V60.6c0-1.2,1.1-1.6,1.4-1.7h1.9c0.6,0,1-0.4,1-1s-0.4-1-1-1h-2c-0.1,0-0.1,0-0.2,0c-1.1,0.2-3.1,1.3-3.1,3.7v15.3c0,0,0,0.1,0,0.1c0.1,1.3,1.2,3.9,4.3,3.9h20c1.6,0,4-1.1,4-4v-16C76.5,58.6,75.7,56.9,73.5,56.9z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M57.5,45.9c0.6,0,1-0.4,1-1s-0.4-1-1-1h-9c-0.6,0-1,0.4-1,1s0.4,1,1,1H57.5z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M49.5,47.9c-0.6,0-1,0.4-1,1s0.5,1,1,1s1-0.4,1-1S50.2,47.9,49.5,47.9L49.5,47.9z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M54.5,47.9c-0.6,0-1,0.4-1,1s0.5,1,1,1s1-0.4,1-1S55.2,47.9,54.5,47.9L54.5,47.9z' })
      );
    case 'reports':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('circle', { id: 'book_dash_icon_back', style: { fill: backfill }, cx: '63', cy: '63', r: '63' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M80.9,37.9H43.1c-3.1,0-5.6,2.5-5.6,5.6v38.9c0,3.1,2.5,5.6,5.6,5.6h37.9c3.1,0,5.6-2.5,5.6-5.6V43.4C86.5,40.4,84,37.9,80.9,37.9z M43.1,39.9h37.9c2,0,3.6,1.6,3.6,3.6v19.4l-6,0c-2.3,0-3.6,1.2-3.7,1.3c-0.1,0.1-0.2,0.2-0.2,0.3l-6,12.9c-0.2,0.3-0.6,0.8-1,0.8c0,0,0,0,0,0c-0.4,0-0.9-0.5-1.2-0.8l-8-28.8c0-0.1-0.1-0.2-0.1-0.3c-0.8-1.2-1.7-1.8-2.8-1.8c-1.7,0-2.8,1.6-2.9,1.8c0,0.1-0.1,0.2-0.1,0.2l-4,12c-0.7,2-1.6,2.7-1.9,2.9h-7.2V43.4C39.5,41.5,41.1,39.9,43.1,39.9z M80.9,85.9H43.1c-2,0-3.6-1.6-3.6-3.6V65.5h7.4c0.1,0,0.2,0,0.4-0.1c0.2-0.1,2.1-0.9,3.2-4.2l4-11.9c0.2-0.3,0.7-0.8,1.2-0.8c0,0,0,0,0,0c0.4,0,0.8,0.4,1,0.8l8,28.8c0,0.1,0.1,0.2,0.1,0.3c0.1,0.2,1.2,1.8,2.9,1.8c1,0,2-0.6,2.8-1.8c0,0,0.1-0.1,0.1-0.1l5.9-12.8c0.3-0.2,1-0.6,2.2-0.6l6,0v17.5C84.5,84.3,82.9,85.9,80.9,85.9z' })
      );
    case 'settings':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('circle', { id: 'book_dash_icon_back', style: { fill: backfill }, cx: '63', cy: '63', r: '63' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M62,54.3c-4.7,0-8.6,3.9-8.6,8.6c0,4.7,3.9,8.6,8.6,8.6s8.6-3.9,8.6-8.6C70.6,58.1,66.7,54.3,62,54.3zM62,69.5c-3.6,0-6.6-3-6.6-6.6s3-6.6,6.6-6.6c3.6,0,6.6,3,6.6,6.6S65.6,69.5,62,69.5z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M87,58.8l-8.3-2.7l-0.2-0.4l4-7.8c0.2-0.4,0.1-0.9-0.2-1.2L78,42.5c-0.3-0.3-0.8-0.4-1.2-0.2l-7.8,4l-0.4-0.2L66,37.9c-0.1-0.4-0.5-0.7-0.9-0.7l-6.1,0c0,0,0,0,0,0c-0.4,0-0.8,0.3-1,0.7l-2.7,8.3l-0.4,0.2l-7.8-4c-0.4-0.2-0.9-0.1-1.2,0.2l-4.3,4.3c-0.3,0.3-0.4,0.8-0.2,1.2l4,7.8l-0.2,0.4L37,58.8c-0.4,0.1-0.7,0.5-0.7,1l0,6.1c0,0.4,0.3,0.8,0.7,1l8.3,2.7l0.2,0.4l-4,7.8c-0.2,0.4-0.1,0.9,0.2,1.2l4.3,4.3c0.3,0.3,0.8,0.4,1.2,0.2l7.8-4l0.4,0.2l2.7,8.3c0.1,0.4,0.5,0.7,1,0.7l6.1,0h0c0.4,0,0.8-0.3,1-0.7l2.7-8.3l0.4-0.2l7.8,4c0.4,0.2,0.9,0.1,1.2-0.2l4.3-4.3c0.3-0.3,0.4-0.8,0.2-1.2l-4-7.8l0.2-0.4l8.3-2.7c0.4-0.1,0.7-0.5,0.7-0.9l0-6.1C87.7,59.4,87.4,59,87,58.8z M85.7,65.2l-8.1,2.6c-0.3,0.1-0.5,0.3-0.6,0.6l-0.5,1.2c-0.1,0.3-0.1,0.6,0,0.8l3.9,7.5l-3.3,3.3l-7.5-3.9c-0.3-0.1-0.6-0.1-0.8,0l-1.2,0.5c-0.3,0.1-0.5,0.3-0.6,0.6l-2.6,8l-4.6,0l-2.6-8.1c-0.1-0.3-0.3-0.5-0.6-0.6l-1.2-0.5c-0.3-0.1-0.6-0.1-0.8,0l-7.5,3.9L43.6,78l3.9-7.5c0.1-0.3,0.1-0.6,0-0.8L47,68.3c-0.1-0.3-0.3-0.5-0.6-0.6l-8-2.6l0-4.6l8.1-2.6c0.3-0.1,0.5-0.3,0.6-0.6l0.5-1.2c0.1-0.3,0.1-0.6,0-0.8l-3.9-7.5l3.3-3.3l7.5,3.9c0.3,0.1,0.6,0.1,0.8,0l1.2-0.5c0.3-0.1,0.5-0.3,0.6-0.6l2.6-8l4.6,0l2.6,8.1c0.1,0.3,0.3,0.5,0.6,0.6l1.2,0.5c0.3,0.1,0.6,0.1,0.8,0l7.5-3.9l3.3,3.3l-3.9,7.5c-0.1,0.3-0.1,0.6,0,0.8l0.5,1.2c0.1,0.3,0.3,0.5,0.6,0.6l8,2.6L85.7,65.2z' })
      );
    case 'creditcheck':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('circle', { id: 'book_dash_icon_back', style: { fill: backfill }, cx: '63', cy: '63', r: '63' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M62,36.9c-14.3,0-26,11.7-26,26c0,14.3,11.7,26,26,26s26-11.7,26-26C88,48.5,76.3,36.9,62,36.9z M62,86.9c-11.3,0-20.8-7.9-23.3-18.5h15.9c0.8,1.5,3.2,5.1,7.9,5.1c0.2,0,5.5-0.1,7.9-5.2h15.1C82.9,78.9,73.4,86.9,62,86.9z M69.7,66.3c-0.4,0-0.8,0.2-0.9,0.6c-1.8,4.5-6.1,4.6-6.3,4.6c-4.4,0-6.3-4.3-6.3-4.5c-0.2-0.4-0.5-0.6-0.9-0.6H38.3c-0.2-1.2-0.3-2.3-0.3-3.5c0-13.2,10.8-24,24-24c13.2,0,24,10.8,24,24c0,1.2-0.1,2.3-0.3,3.4H69.7z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M69.7,52.9l-6.4,6.4c-0.4-0.1-0.8-0.2-1.2-0.2c-2.1,0-3.7,1.7-3.7,3.7c0,2.1,1.7,3.7,3.7,3.7s3.7-1.7,3.7-3.7c0-0.9-0.3-1.7-0.8-2.3l6.2-6.2c0.4-0.4,0.4-1,0-1.4S70,52.5,69.7,52.9z M62,64.6c-0.9,0-1.7-0.8-1.7-1.7s0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7S63,64.6,62,64.6z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M44.8,62.2h-5.2c-0.6,0-1,0.4-1,1s0.4,1,1,1h5.2c0.6,0,1-0.4,1-1S45.3,62.2,44.8,62.2z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M61.4,47.6c0.6,0,1-0.4,1-1v-5.2c0-0.6-0.4-1-1-1s-1,0.4-1,1v5.2C60.4,47.1,60.8,47.6,61.4,47.6z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M47.5,53.6L43,51.2c-0.5-0.3-1.1-0.1-1.4,0.4c-0.3,0.5-0.1,1.1,0.4,1.4l4.6,2.4c0.1,0.1,0.3,0.1,0.5,0.1c0.4,0,0.7-0.2,0.9-0.5C48.2,54.5,48,53.9,47.5,53.6z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M82.2,51.6c-0.3-0.5-0.9-0.7-1.4-0.4l-4.6,2.4c-0.5,0.3-0.7,0.9-0.4,1.4c0.2,0.3,0.5,0.5,0.9,0.5c0.2,0,0.3,0,0.5-0.1l4.6-2.4C82.2,52.7,82.4,52.1,82.2,51.6z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M73.4,42.9c-0.5-0.3-1.1-0.1-1.4,0.4l-2.4,4.6c-0.3,0.5-0.1,1.1,0.4,1.4c0.1,0.1,0.3,0.1,0.5,0.1c0.4,0,0.7-0.2,0.9-0.5l2.4-4.6C74.1,43.8,73.9,43.1,73.4,42.9z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M51.7,43.3c-0.3-0.5-0.9-0.7-1.4-0.4c-0.5,0.3-0.7,0.9-0.4,1.4l2.4,4.6c0.2,0.3,0.5,0.5,0.9,0.5c0.2,0,0.3,0,0.5-0.1c0.5-0.3,0.7-0.9,0.4-1.4L51.7,43.3z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M84.2,62.2H79c-0.6,0-1,0.4-1,1s0.4,1,1,1h5.2c0.6,0,1-0.4,1-1S84.7,62.2,84.2,62.2z' })
      );
    case 'spec_layout':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('circle', { id: 'book_dash_icon_back', style: { fill: backfill }, cx: '63', cy: '63', r: '63' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M88,46.2c-0.4-2-2.4-5.8-7-5.8c-0.6,0-1,0.4-1,1v3.4h-36v-3.4c0-0.6-0.4-1-1-1c-4.6,0-6.6,3.8-7,5.8c0,0.1,0,0.1,0,0.2v31.9c-0.1,0.5-0.3,3.2,1.3,5.2c1.1,1.2,2.6,1.9,4.7,1.9h39c2.4,0,7-1.5,7-7v-32C88,46.3,88,46.2,88,46.2z M82,42.5c3,0.5,3.9,3.5,4,4v27.9c-1.2-1.2-2.8-1.8-4-2V42.5z M38.1,46.5c0.1-0.6,1-3.5,4-4v30c-1.2,0.2-2.8,0.8-4,2V46.5z M81,83.3h-39c-1.4,0-2.5-0.4-3.2-1.2c-1.2-1.3-0.9-3.5-0.8-3.6c0.8-4.1,4.8-4.2,5-4.2c0.6,0,1-0.4,1-1V46.8h36v26.6c0,0.5,0.4,1,1,1c0.2,0,4.1,0.1,5,4.1C85.9,83.1,81.5,83.3,81,83.3z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M78,52.4h-25c-0.6,0-1,0.4-1,1v5h-6c-0.6,0-1,0.4-1,1v17c0,0.6,0.4,1,1,1h20c0.6,0,1-0.4,1-1v-10h6c0.6,0,1-0.4,1-1s-0.4-1-1-1H58c-0.6,0-1,0.4-1,1v5c0,0.6,0.4,1,1,1c-0.5,0-1,0.4-1,1v3h-10v-6.1h6c0.6,0,1-0.4,1-1s-0.4-1-1-1h-6v-6.9h6c0.6,0,1-0.4,1-1v-5h10.8v6c0,0.6,0.4,1,1,1s1-0.4,1-1v-6h3.8c0.6,1.6,2.5,5.4,6.4,6.3v14.6h-7c-0.6,0-1,0.4-1,1s0.4,1,1,1h8c0.6,0,1-0.4,1-1v-23C79,52.8,78.6,52.4,78,52.4z M58.1,71.3c0.5,0,1-0.4,1-1v-4h6v9h-6v-3C59,71.8,58.6,71.3,58.1,71.3z M72.8,54.4H77v4.3C74.8,57.9,73.4,55.8,72.8,54.4z' })
      );
    case 'spec_unit':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('ellipse', { id: 'book_dash_icon_back', 'data-name': 'Ellipse 17', cx: '67.5', cy: '68', rx: '67.5', ry: '68', style: { fill: backfill } }),
        _react2.default.createElement('path', { d: 'M102.08,70.25,91.42,59.59l0,0,0,0L89.85,58a1.74,1.74,0,0,0,.05-.41V48.55a1.75,1.75,0,0,0-3.5,0v6L68.59,36.76a1.8,1.8,0,0,0-2.48,0L32.76,70.11a1.75,1.75,0,0,0,2.47,2.47L67.35,40.47,88.89,62l0,0,0,0L99.6,72.73a1.75,1.75,0,0,0,2.47-2.47Z', style: { fill: iconfill } }),
        _react2.default.createElement('path', { d: 'M91.72,69.88A1.75,1.75,0,0,0,90,71.63V96.25H45V71.63a1.75,1.75,0,0,0-3.5,0V98a1.75,1.75,0,0,0,1.75,1.75H91.72A1.75,1.75,0,0,0,93.47,98V71.63A1.75,1.75,0,0,0,91.72,69.88Z', style: { fill: iconfill } })
      );
    case 'business_unit':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('circle', { id: 'book_dash_icon_back', style: { fill: backfill }, cx: '63', cy: '63', r: '63' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M49,55.4c3.9,0,7-3.1,7-7s-3.1-7-7-7s-7,3.1-7,7S45.1,55.4,49,55.4z M49,43.4c2.8,0,5,2.2,5,5s-2.2,5-5,5s-5-2.2-5-5S46.3,43.4,49,43.4z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M82,48.4c0-3.9-3.1-7-7-7s-7,3.1-7,7s3.1,7,7,7S82,52.2,82,48.4z M75,53.4c-2.8,0-5-2.2-5-5s2.2-5,5-5s5,2.2,5,5S77.8,53.4,75,53.4z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M44.8,55.4c-0.1,0-8.8,2.3-8.8,13c0,0.6,0.4,1,1,1s1-0.4,1-1c0-9.1,6.9-11,7.2-11c0.5-0.1,0.9-0.7,0.7-1.2S45.3,55.2,44.8,55.4z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M79.2,55.4c-0.5-0.1-1.1,0.2-1.2,0.7c-0.1,0.5,0.2,1.1,0.7,1.2c0.1,0,7.2,1.9,7.2,11c0,0.6,0.4,1,1,1s1-0.4,1-1C88,57.7,79.3,55.4,79.2,55.4z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M61.8,64.4c3.9,0,7-3.1,7-7s-3.1-7-7-7s-7,3.1-7,7S57.9,64.4,61.8,64.4z M61.8,52.4c2.7,0,5,2.2,5,5s-2.2,5-5,5c-2.7,0-5-2.2-5-5S59,52.4,61.8,52.4z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M65.9,65c-0.5-0.1-1.1,0.3-1.1,0.8c-0.1,0.5,0.3,1.1,0.8,1.1c4.9,0.7,6.8,6.4,7.1,7.3v7.2c0,0.7-0.6,0.8-1,0.8h-19c-1.4,0-2-0.5-2-0.8l0.2-7.2c1.1-4.8,7.1-7.4,7.2-7.4c0.5-0.2,0.8-0.8,0.5-1.3c-0.2-0.5-0.8-0.7-1.3-0.5c-0.3,0.1-7.1,3-8.4,8.9c0,0.1,0,0.1,0,0.2l-0.2,7.3c0,1,0.8,2.8,4,2.8h19c1.2,0,3-0.8,3-2.8v-7.4c0-0.1,0-0.2,0-0.3C74.6,73.6,72.5,66,65.9,65z' })
      );
    case 'preferred_bankers':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('circle', { id: 'book_dash_icon_back', style: { fill: backfill }, cx: '63', cy: '63', r: '63' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M87,50L62,37c-0.3-0.2-0.6-0.1-0.9,0L37,50c-0.4,0.2-0.6,0.7-0.5,1.1c0.1,0.4,0.5,0.8,1,0.8h0.3v2.9c0,0.3,0,0.8,0.4,1.2c0.2,0.3,0.5,0.5,0.9,0.6v2.3c0,0.1,0,1.5,2,1.9v17.2c-1.1,0.2-2,0.8-2,1.9v2.3c-0.3,0.1-0.6,0.3-0.8,0.6c-0.2,0.3-0.5,0.8-0.4,1.5v3.6c0,0.6,0.4,1,1,1h46.5c0.6,0,1-0.4,1-1v-3.9c0-0.3,0-0.8-0.4-1.2c-0.2-0.3-0.5-0.5-0.9-0.6v-2.3c0-0.1,0-1.5-2-1.9V60.8c1.1-0.2,2-0.8,2-1.9v-2.3c0.3-0.1,0.6-0.3,0.8-0.6c0.2-0.3,0.5-0.8,0.4-1.5v-2.6h0.3c0.5,0,0.9-0.3,1-0.8C87.6,50.6,87.4,50.2,87,50z M61.5,39l20.9,10.9h-41L61.5,39z M56,56.9v2c0,0.1,0,1.5,2,1.9v17.2c-1.1,0.2-2,0.8-2,1.9v2h-5v-2c0-0.1,0-1.5-2-1.9V60.8c1.1-0.2,2-0.8,2-1.9v-2H56z M66,56.9v1.8c-0.2,0.1-0.6,0.2-1,0.2h-6c-0.6,0-0.9-0.1-1-0.2v-1.8H66z M73,56.9v2c0,0.1,0,1.5,2,1.9v17.2c-1.1,0.2-2,0.8-2,1.9v2h-5v-2c0-0.1,0-1.5-2-1.9V60.8c1.1-0.2,2-0.8,2-1.9v-2H73z M83,80v1.8h-8V80c0.2-0.1,0.6-0.2,1-0.2h6C82.6,79.9,82.9,80,83,80z M81,77.9h-4v-17h4V77.9z M58,81.9V80c0.2-0.1,0.6-0.2,1-0.2h6c0.6,0,0.9,0.1,1,0.2v1.8H58z M64,77.9h-4v-17h4V77.9z M43,60.9h4v17h-4V60.9z M49,58.7c-0.2,0.1-0.6,0.2-1,0.2h-6c-0.6,0-0.9-0.1-1-0.2v-1.8h8V58.7z M42,79.9h6c0.6,0,0.9,0.1,1,0.2v1.8h-8V80C41.2,79.9,41.7,79.9,42,79.9z M84.2,86.9H39.8v-2.7c0-0.1,0-0.1-0.1-0.1c0.1-0.1,0.5-0.2,0.7-0.2h43c0.4,0,0.7,0.1,0.8,0.1V86.9z M82,58.9h-6c-0.6,0-0.9-0.1-1-0.2v-1.8h8v1.8C82.8,58.8,82.4,58.9,82,58.9z M84.3,54.7c-0.1,0.1-0.5,0.2-0.7,0.2h-43c-0.4,0-0.7-0.1-0.8-0.1v-2.9h44.5v2.7C84.2,54.6,84.3,54.6,84.3,54.7z' })
      );
    case 'activities':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('circle', { id: 'book_dash_icon_back', style: { fill: backfill }, cx: '63', cy: '63', r: '63' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M62,44.1h0.1c0.6,0,1-0.4,1-1s-0.4-1-1-1H62c-0.6,0-1,0.4-1,1S61.5,44.1,62,44.1z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M51.1,59.1H51c-0.6,0-1,0.4-1,1s0.4,1,1,1h0.1c0.6,0,1-0.4,1-1S51.7,59.1,51.1,59.1z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M73,59.1H56c-0.6,0-1,0.4-1,1s0.4,1,1,1h17c0.6,0,1-0.4,1-1S73.6,59.1,73,59.1z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M51.1,65.1H51c-0.6,0-1,0.4-1,1s0.4,1,1,1h0.1c0.6,0,1-0.4,1-1S51.7,65.1,51.1,65.1z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M73,65.1H56c-0.6,0-1,0.4-1,1s0.4,1,1,1h17c0.6,0,1-0.4,1-1S73.6,65.1,73,65.1z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M51.1,71.1H51c-0.6,0-1,0.4-1,1s0.4,1,1,1h0.1c0.6,0,1-0.4,1-1S51.7,71.1,51.1,71.1z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M73,71.1H56c-0.6,0-1,0.4-1,1s0.4,1,1,1h17c0.6,0,1-0.4,1-1S73.6,71.1,73,71.1z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M51.1,77.1H51c-0.6,0-1,0.4-1,1s0.4,1,1,1h0.1c0.6,0,1-0.4,1-1S51.7,77.1,51.1,77.1z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M73,77.1H56c-0.6,0-1,0.4-1,1s0.4,1,1,1h17c0.6,0,1-0.4,1-1S73.6,77.1,73,77.1z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M74.7,45.9H72c-0.8-0.6-1.6-0.9-1.7-0.9c-0.1,0-0.2-0.1-0.3-0.1c-0.9,0-2.3-1.9-3.1-3.4c-1-2.9-3.6-3.6-4.9-3.6c-3.7,0-4.9,3.5-4.9,3.7c0,0.1-0.1,0.2-0.1,0.3c0,1-1.6,2.5-2.4,3.1c-0.9,0.2-1.6,0.6-2.1,0.9h-3.1c-4,0-7.3,3.3-7.3,7.3v27.4c0,4,3.3,7.3,7.3,7.3h25.4c4,0,7.3-3.3,7.3-7.3V53.2C82,49.1,78.7,45.9,74.7,45.9z M55.3,46.8c0.1,0,0.2-0.1,0.3-0.1c0.3-0.2,3.3-2.3,3.4-4.6c0.2-0.5,1.1-2.2,3-2.2c0.1,0,2.3,0.1,3.1,2.3c0,0,0,0.1,0.1,0.1c0.4,0.7,2.3,4.3,4.7,4.5c0.2,0.1,0.7,0.3,1.2,0.8c0.2,0.2,0.3,0.3,0.4,0.5c0,0,0,0,0,0c0.1,0.2,0.2,0.3,0.3,0.5c0.1,0.2,0.1,0.3,0.2,0.5c0,0,0,0.1,0,0.1c0,0.2,0.1,0.4,0.1,0.7v2H52v-2c0-0.1,0.1-1.3,1.3-2.2c0,0,0,0,0,0C53.8,47.3,54.4,47,55.3,46.8z M80,80.5c0,2.9-2.4,5.3-5.3,5.3H49.3c-2.9,0-5.3-2.4-5.3-5.3V53.2c0-2.9,2.4-5.3,5.3-5.3h1.2c-0.5,1-0.6,1.9-0.6,2v3c0,0.6,0.4,1,1,1h22c0.6,0,1-0.4,1-1v-3c0-0.3,0-0.7-0.1-1c0,0,0-0.1,0-0.1c-0.1-0.3-0.2-0.6-0.3-0.9h1.1c2.9,0,5.3,2.4,5.3,5.3V80.5z' })
      );
    case 'accounting':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('circle', { id: 'book_dash_icon_back', style: { fill: backfill }, cx: '63', cy: '63', r: '63' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M56.8,54.5h8.3c0.6,0,1-0.4,1-1s-0.4-1-1-1h-8.3c-0.6,0-1,0.4-1,1S56.2,54.5,56.8,54.5z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M56.8,61.8h16.7c0.6,0,1-0.4,1-1s-0.4-1-1-1H56.8c-0.6,0-1,0.4-1,1S56.2,61.8,56.8,61.8z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M56.8,68h16.7c0.6,0,1-0.4,1-1s-0.4-1-1-1H56.8c-0.6,0-1,0.4-1,1S56.2,68,56.8,68z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M45.9,68.6c0,0,0.1,0,0.1,0.1c0.5,0.2,1,0.3,1.4,0.3v1.1c0,0.6,0.4,1,1,1s1-0.4,1-1v-1.3c1.1-0.4,1.7-1.2,2-1.7c0,0,0-0.1,0-0.1c0.4-1.3,0.3-2.5-0.2-3.4c-0.9-1.4-2.5-1.7-2.7-1.7c-1.2-0.1-2-1.1-2.2-1.4c-0.3-1.7-0.1-3,0.5-3.6c0.6-0.5,1.4-0.3,1.4-0.3c0.1,0,0.2,0,0.2,0c2,0,2.1,1.9,2.1,2.3c0,0.5,0.4,1,1,1c0.6,0,1-0.4,1-1c0-1.5-0.9-3.7-3.1-4.2v-1.2c0-0.6-0.4-1-1-1s-1,0.4-1,1v1c-0.7,0.1-1.4,0.3-2,0.9c-1.2,1.1-1.5,2.9-1.1,5.6c0,0.1,0.1,0.2,0.1,0.3c0.1,0.1,1.4,2.4,3.8,2.6c0,0,0.9,0.2,1.3,0.8c0.2,0.4,0.3,0.9,0.1,1.6c-0.2,0.3-0.9,1.2-2.8,0.6c-0.3-0.2-1.5-1-1.5-2.4c0-0.6-0.4-1-1-1s-1,0.4-1,1C43.3,67.2,45.8,68.6,45.9,68.6z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M83.6,48.3h-1.9v-2c0-2.3-1.9-4.2-4.2-4.2H40.2c-2.3,0-4.2,1.9-4.2,4.2v26.9c0,2.3,1.9,4.2,4.2,4.2h2v1.9c0,2.4,2,4.4,4.4,4.4h37c2.4,0,4.4-2,4.4-4.4V52.7C88,50.3,86,48.3,83.6,48.3z M38,73.2V46.3c0-1.2,1-2.2,2.2-2.2h37.3c1.2,0,2.2,1,2.2,2.2v3V73c0,1.3-1.1,2.4-2.4,2.4H43.3h-3C39,75.4,38,74.4,38,73.2z M86,79.3c0,1.3-1.1,2.4-2.4,2.4h-37c-1.3,0-2.4-1.1-2.4-2.4v-1.9h33.1h0.1c2.3,0,4.2-1.9,4.2-4.2V73V50.3h1.9c1.3,0,2.4,1.1,2.4,2.4V79.3z' })
      );
    case 'payments':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('circle', { id: 'book_dash_icon_back', style: { fill: backfill }, cx: '63', cy: '63', r: '63' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M87,64.5h-2.2v-5.4c0-2.1-2.1-3.3-3.2-3.9v-5.7c0-2.7-2.6-4-2.7-4.1c-0.1-0.1-0.3-0.1-0.4-0.1h-6.4v-7.5c0-0.6-0.4-1-1-1H46.6c-0.3,0-0.5,0.1-0.7,0.3s-0.3,0.4-0.3,0.7l0,7.5l-4.3,0c-0.1,0-0.2,0-0.2,0c-5,1.2-5,5.1-5,5.2v30.9c0,0.1,0,0.1,0,0.2c1.2,5.9,5.9,7.1,6.1,7.2c0.1,0,0.2,0,0.2,0h37.2c4.2,0,5.3-2.7,5.3-4.2v-5.4H87c0.6,0,1-0.4,1-1V65.5C88,65,87.6,64.5,87,64.5z M78.2,47.4c0.4,0.3,1.4,1,1.4,2.2v5.4l-7.4,0v-7.6H78.2z M53.5,54.4V38.9h4.8v15.5H53.5z M70.1,54.4h-9.7V38.9h9.7V54.4z M51.5,38.9v15.5h-3.9l0-15.5H51.5z M41.4,47.4l4.1,0v7.6l-5.3,0c-0.1,0-2.2-0.1-2.2-4.3C38,50.5,38.1,48.2,41.4,47.4z M82.8,84.6c0,0.4-0.2,2.2-3.3,2.2H42.5c-0.6-0.2-3.6-1.4-4.5-5.5V56.1c1.1,0.9,2.2,0.9,2.2,0.9h6.4h24.4h9.4c0.7,0.3,2.4,1.1,2.4,2.2v5.4h-6.4c-0.1,0-0.1,0-0.2,0c-4.8,1-6.1,5.2-6.1,7.4c0,4.9,4,6.9,6.1,7.4c0.1,0,0.1,0,0.2,0h6.4V84.6z M86,77.3h-2.2h-7.3c-0.6-0.2-4.4-1.3-4.4-5.4c0-0.2,0.1-4.5,4.4-5.4h7.3H86V77.3z' })
      );
    case 'lead':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('circle', { id: 'book_dash_icon_back', style: { fill: backfill }, cx: '63', cy: '63', r: '63' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M48.5,60.9c0-0.6-0.4-1-1-1h-8c-0.6,0-1,0.4-1,1s0.4,1,1,1h8C48.1,61.9,48.5,61.4,48.5,60.9z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M84.5,59.9h-8c-0.6,0-1,0.4-1,1s0.4,1,1,1h8c0.6,0,1-0.4,1-1S85.1,59.9,84.5,59.9z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M62.5,46.9c0.6,0,1-0.4,1-1v-8c0-0.6-0.4-1-1-1s-1,0.4-1,1v8C61.5,46.4,62,46.9,62.5,46.9z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M50.6,50.4c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3c0.4-0.4,0.4-1,0-1.4l-5.7-5.7c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4L50.6,50.4z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M72.7,50.7c0.3,0,0.5-0.1,0.7-0.3l5.7-5.7c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0L72,49c-0.4,0.4-0.4,1,0,1.4C72.2,50.6,72.4,50.7,72.7,50.7z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M62.3,66.5c4.3,0,7.7-3.5,7.7-7.7s-3.5-7.7-7.7-7.7c-4.3,0-7.7,3.5-7.7,7.7S58,66.5,62.3,66.5z M62.3,53.1c3.1,0,5.7,2.6,5.7,5.7s-2.6,5.7-5.7,5.7c-3.1,0-5.7-2.6-5.7-5.7S59.2,53.1,62.3,53.1z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M66.9,67.4c-0.5-0.1-1.1,0.3-1.1,0.8c-0.1,0.5,0.3,1.1,0.8,1.1c5.6,0.8,7.8,7.3,8.1,8.3v8.1c0,0.9-0.9,1-1.2,1H52.2c-2.2,0-2.3-1-2.4-1l0.2-8.1c1.3-5.5,8-8.4,8.1-8.4c0.5-0.2,0.8-0.8,0.5-1.3c-0.2-0.5-0.8-0.7-1.3-0.5c-0.3,0.1-7.9,3.3-9.3,9.9c0,0.1,0,0.1,0,0.2l-0.2,8.2c0,1.1,0.9,3,4.4,3h21.3c1.3,0,3.2-0.8,3.2-3v-8.3c0-0.1,0-0.2,0-0.3C76.6,76.9,74.2,68.5,66.9,67.4z' })
      );
    case 'currencies':
      return _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('circle', { id: 'book_dash_icon_back', cx: '63', cy: '63', r: '63', style: { fill: backfill } }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M79.087,38.989h-1.33l.967-.968a1,1,0,0,0-1.414-1.414l-2.674,2.675a1,1,0,0,0,0,1.414l2.674,2.675a1,1,0,0,0,1.414-1.414l-.967-.968h1.33a6.763,6.763,0,0,1,6.756,6.756v2.941a1,1,0,0,0,2,0V47.745A8.766,8.766,0,0,0,79.087,38.989Z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M49.875,82.63a1,1,0,1,0-1.414,1.414l.968.968H48.1a6.763,6.763,0,0,1-6.756-6.756V75.314a1,1,0,0,0-2,0v2.942A8.766,8.766,0,0,0,48.1,87.012h1.329l-.967.967a1,1,0,1,0,1.414,1.414l2.675-2.674a1,1,0,0,0,0-1.414Z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M71.8,54.2A16.832,16.832,0,1,0,54.2,71.8,16.832,16.832,0,1,0,71.8,54.2ZM40.157,55A14.832,14.832,0,0,1,69.8,54.218,16.81,16.81,0,0,0,57.782,60.6H54.365a4.33,4.33,0,0,0,.806-1.477,4.536,4.536,0,0,0,.087-2.129h2.284a1,1,0,0,0,0-2H54.473a7.786,7.786,0,0,1-.995-2.718A2.578,2.578,0,0,1,55.843,49.5c2.7,0,2.9,1.415,2.911,1.706a1,1,0,0,0,1,.985h0a1,1,0,0,0,1-1,3.539,3.539,0,0,0-1.049-2.369A5.251,5.251,0,0,0,55.843,47.5a4.533,4.533,0,0,0-4.365,4.771,7.277,7.277,0,0,0,.766,2.718H50.051a1,1,0,0,0,0,2h3.158a2.739,2.739,0,0,1,.04,1.577,3.249,3.249,0,0,1-1.79,1.837l-.538.192h-.245a1,1,0,0,0,0,2h5.75a16.711,16.711,0,0,0-2.208,7.21A14.849,14.849,0,0,1,40.157,55ZM71,85.844A14.843,14.843,0,1,1,85.843,71,14.859,14.859,0,0,1,71,85.844Z' }),
        _react2.default.createElement('path', { style: { fill: iconfill }, d: 'M76.636,64.435H71.9V60.617a1,1,0,1,0-2,0v3.818h-.61a4,4,0,0,0,0,7.994H73.4a1.57,1.57,0,1,1,0,3.139H65.363a1,1,0,0,0,0,2H69.9v4.3a1,1,0,0,0,2,0v-4.3h1.5a3.57,3.57,0,1,0,0-7.139H69.289a2,2,0,0,1,0-3.994H70.7a.513.513,0,0,0,.4,0h5.539a1,1,0,0,0,0-2Z' })
      );
    default:
      return _react2.default.createElement('g', null);
  }
};

var BookDashIcons = function BookDashIcons(_ref) {
  var type = _ref.type,
      width = _ref.width,
      height = _ref.height,
      backfill = _ref.backfill,
      iconfill = _ref.iconfill;
  return _react2.default.createElement(
    'svg',
    { id: 'Dash_Grid_SVG', 'data-name': 'Layer 1', xmlns: 'http://www.w3.org/2000/svg', width: width, height: height, viewBox: '0 0 135 136' },
    icon(type, backfill, iconfill)
  );
};

BookDashIcons.propTypes = {
  type: _propTypes2.default.oneOf(['projects', 'bookings', 'marketplace', 'customers', 'staff', 'pictures', 'documents', 'reports', 'settings', 'creditcheck', 'spec_layout', 'spec_unit', 'business_unit', 'preferred_bankers', 'activities', 'accounting', 'payments', 'lead', 'currencies']).isRequired,
  width: _propTypes2.default.string.isRequired,
  height: _propTypes2.default.string.isRequired,
  backfill: _propTypes2.default.string.isRequired,
  iconfill: _propTypes2.default.string.isRequired
};

BookDashIcons.defaultProps = {
  width: '6em',
  height: '6em',
  backfill: '#000000',
  iconfill: '#00233B'
};

exports.default = BookDashIcons;

/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GridDivider = function GridDivider(_ref) {
  var _ref$columnWidth = _ref.columnWidth,
      columnWidth = _ref$columnWidth === undefined ? 16 : _ref$columnWidth;
  return _react2.default.createElement(
    _semanticUiReact.Grid.Row,
    { style: { paddingBottom: 0 } },
    _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { width: columnWidth },
      _react2.default.createElement(_semanticUiReact.Divider, null)
    )
  );
};

GridDivider.propTypes = {
  columnWidth: _propTypes2.default.number
};

exports.default = GridDivider;

/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InfoPopup = function (_Component) {
  _inherits(InfoPopup, _Component);

  function InfoPopup(props) {
    _classCallCheck(this, InfoPopup);

    var _this = _possibleConstructorReturn(this, (InfoPopup.__proto__ || Object.getPrototypeOf(InfoPopup)).call(this, props));

    _this.state = {
      // example future state
      isOpen: false
    };
    return _this;
  }

  _createClass(InfoPopup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          content = _props.content,
          trigger = _props.trigger,
          position = _props.position,
          disabled = _props.disabled,
          touchAsClicked = _props.touchAsClicked;

      // Wrap trigger with stopPropagation

      var wrappedTrigger = _react2.default.cloneElement(trigger, {
        onClick: function onClick(e) {
          e.stopPropagation();
          if (trigger.props.onClick) {
            trigger.props.onClick(e);
          }
        }
      });

      // Wrap content with stopPropagation
      var wrappedContent = _react2.default.createElement(
        'div',
        { onClick: function onClick(e) {
            return e.stopPropagation();
          } },
        content
      );

      return _react2.default.createElement(_semanticUiReact.Popup, {
        size: 'mini',
        inverted: true,
        basic: true,
        content: wrappedContent,
        position: position,
        trigger: wrappedTrigger,
        disabled: disabled,
        on: touchAsClicked ? 'click' : ['hover', 'click'],
        offset: [0, 0]
      });
    }
  }]);

  return InfoPopup;
}(_react.Component);

// Optional: define default props


InfoPopup.defaultProps = {
  position: 'bottom center',
  touchAsClicked: false
};

InfoPopup.propTypes = {
  content: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
  position: _propTypes2.default.string,
  trigger: _propTypes2.default.node.isRequired,
  disabled: _propTypes2.default.bool,
  // attempt workaround fix where some touch device
  // incorrectly registered the touch event as click event
  touchAsClicked: _propTypes2.default.bool
};

exports.default = InfoPopup;

/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _InputCalendarRange = __webpack_require__(1016);

var _InputCalendarRange2 = _interopRequireDefault(_InputCalendarRange);

var _dateRanges = __webpack_require__(265);

var _dateRanges2 = _interopRequireDefault(_dateRanges);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BookingDatePicker = function (_Component) {
  _inherits(BookingDatePicker, _Component);

  function BookingDatePicker(props) {
    _classCallCheck(this, BookingDatePicker);

    var _this = _possibleConstructorReturn(this, (BookingDatePicker.__proto__ || Object.getPrototypeOf(BookingDatePicker)).call(this, props));

    _initialiseProps.call(_this);

    var state = BookingDatePicker.getPropsToState(props);
    _this.state = _extends({}, state, {
      open: false
    });
    return _this;
  }

  _createClass(BookingDatePicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var value = this.state.value;

      var state = BookingDatePicker.getPropsToState(nextProps);
      this.setState(_extends({}, state), function () {
        if (value === 'custom' && value !== state.value) {
          _this2.date.handleReset();
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      var classNames = ['uc-dropdown uc-dropdown-custom-selection uc-dropdown-datepicker booking'];
      if (this.state.value.length > 0) {
        classNames.push('selected');
      }
      return _react2.default.createElement(
        'div',
        { className: 'field' },
        _react2.default.createElement(
          'label',
          { className: 'ui', htmlFor: this.props.filterName, style: { fontWeight: 'bold', margin: '0 0 0.28571429rem 0', fontSize: '.92857143em', display: 'block' } },
          this.props.label
        ),
        _react2.default.createElement(
          _semanticUiReact.Dropdown,
          {
            fluid: true,
            selection: true,
            floating: true,
            className: classNames.join(' '),
            open: this.state.open,
            header: this.props.headerText,
            text: this.state.value && this.props.options && this.props.options.length > 0 ? this.props.options.find(function (o) {
              return o.value === _this3.state.value;
            }).text : null,
            placeholder: this.props.placeholder,
            selectOnBlur: false,
            value: this.state.value,
            onClick: this.handleOpen,
            onBlur: this.handleBlur,
            disabled: this.props.disabled,
            name: this.props.filterName
          },
          _react2.default.createElement(
            _semanticUiReact.Dropdown.Menu,
            null,
            this.props.headerText && _react2.default.createElement(_semanticUiReact.Dropdown.Header, { content: this.props.headerText }),
            this.props.options && this.props.options.length > 0 && this.props.options.some(function (v) {
              return v.value === 'custom';
            }) && _react2.default.createElement(
              _semanticUiReact.Dropdown.Item,
              { onClick: this.handleOnCustomChange, value: 'custom' },
              _react2.default.createElement(_semanticUiReact.Dropdown.Header, { style: { marginBottom: '0.5em' }, content: t('Custom Date Range', { ns: _translation.TRANSLATION_FILES.constants }) }),
              _react2.default.createElement(_InputCalendarRange2.default, {
                ref: function ref(_ref) {
                  _this3.date = _ref;
                },
                filterNameFrom: this.props.filterNameFrom,
                filterNameTo: this.props.filterNameTo,
                dateFrom: this.props.dateFrom,
                dateTo: this.props.dateTo,
                onReset: this.props.onResetRange,
                onSetRange: this.handleSetRange
              })
            ),
            this.props.options && this.props.options.length > 0 ? this.props.options.filter(function (v) {
              return v.value !== 'custom';
            }).map(function (opt, idx) {
              return _react2.default.createElement(_semanticUiReact.Dropdown.Item, {
                key: idx,
                value: opt.value,
                text: t(opt.text, { ns: _translation.TRANSLATION_FILES.constants }),
                onClick: _this3.handleOnChange
              });
            }) : null
          )
        )
      );
    }
  }]);

  return BookingDatePicker;
}(_react.Component);

BookingDatePicker.propTypes = {
  dateFrom: _propTypes2.default.string,
  dateTo: _propTypes2.default.string,
  filterName: _propTypes2.default.string.isRequired,
  filterNameFrom: _propTypes2.default.string.isRequired,
  filterNameTo: _propTypes2.default.string.isRequired,
  headerText: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  onResetRange: _propTypes2.default.func.isRequired,
  onSetRange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired
  })).isRequired,
  placeholder: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  label: _propTypes2.default.string,
  t: _propTypes2.default.func
};
BookingDatePicker.defaultProps = {
  hasSearch: false,
  headerText: 'Date Range',
  options: _dateRanges2.default,
  placeholder: 'Select Date Range',
  value: '',
  disabled: false
};

BookingDatePicker.getPropsToState = function (props) {
  var value = props.value || '';
  return {
    value: value
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleOnChange = function (e, _ref2) {
    var value = _ref2.value;

    _this4.setState({ value: value }, function () {
      if (_this4.props.dateFrom || _this4.props.dateTo) {
        _this4.date.handleReset();
      }
      _this4.props.onChange(value, _this4.props.filterName);
    });
  };

  this.handleOnCustomChange = function (e, _ref3) {
    var value = _ref3.value;

    var hasChange = _this4.state.value !== value;
    _this4.setState({ value: value, open: false }, function () {
      if (hasChange) {
        _this4.props.onChange(value, _this4.props.filterName);
      }
    });
  };

  this.handleClose = function () {
    _this4.setState({ value: '' }, function () {
      _this4.props.onClose(_this4.props.filterName);
    });
  };

  this.handleSetRange = function (from, to) {
    var onSetRange = _this4.props.onSetRange;

    var value = 'custom';
    _this4.setState({ value: value, open: from && !to }, function () {
      _this4.props.onChange(value, _this4.props.filterName);
      if (onSetRange) {
        if (from && to) {
          onSetRange(from, to);
        }
      }
    });
  };

  this.handleOpen = function () {
    _this4.setState(function (prevState) {
      return {
        open: !prevState.open
      };
    });
  };

  this.handleBlur = function () {
    _this4.setState({ open: false });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(BookingDatePicker);

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BookingSelectList = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _i18next = __webpack_require__(94);

var _i18next2 = _interopRequireDefault(_i18next);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BookingSelectList = exports.BookingSelectList = function (_Component) {
  _inherits(BookingSelectList, _Component);

  function BookingSelectList(props) {
    _classCallCheck(this, BookingSelectList);

    var _this = _possibleConstructorReturn(this, (BookingSelectList.__proto__ || Object.getPrototypeOf(BookingSelectList)).call(this, props));

    _initialiseProps.call(_this);

    var state = BookingSelectList.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(BookingSelectList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = BookingSelectList.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classNames = ['uc-dropdown booking'];
      if (this.state.value.length > 0) {
        classNames.push('selected');
      }
      var options = this.props.options;
      var truncateStyle = {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        display: 'inline-block',
        maxWidth: '100%'
      };
      var hasHeader = options && options.some(function (opt) {
        return opt.header;
      });
      if (hasHeader) {
        options.forEach(function (opt, idx, arr) {
          if (opt.header) {
            if (idx > 0 && !arr[idx - 1].divider) {
              options.splice(idx, 0, { divider: true });
            }
          }
        });
        return _react2.default.createElement(
          'div',
          { className: 'field' },
          _react2.default.createElement(
            'label',
            { className: 'ui', htmlFor: this.props.name, style: { fontWeight: 'bold', marginBottom: '0.5em', display: 'block' } },
            this.props.label
          ),
          _react2.default.createElement(
            _semanticUiReact.Dropdown,
            {
              fluid: true,
              selection: true,
              scrolling: true,
              floating: true,
              className: classNames.join(' '),
              disabled: this.props.disabled,
              header: this.props.headerText,
              onChange: this.handleOnChange,
              selectOnBlur: false,
              text: this.state.value && options && options.length > 0 ? options.find(function (o) {
                return o.value === _this2.state.value;
              }).text : null,
              placeholder: this.props.placeholder,
              value: this.state.value,
              style: this.props.style,
              name: this.props.name
            },
            _react2.default.createElement(
              _semanticUiReact.Dropdown.Menu,
              null,
              this.props.headerText && _react2.default.createElement(_semanticUiReact.Dropdown.Header, { content: this.props.headerText }),
              options && options.length > 0 ? options.map(function (opt, idx) {
                if (opt.divider) {
                  return _react2.default.createElement(_semanticUiReact.Dropdown.Divider, { key: idx });
                }
                if (opt.header) {
                  return _react2.default.createElement(_semanticUiReact.Dropdown.Header, { key: idx, content: opt.text });
                }
                return _react2.default.createElement(_semanticUiReact.Dropdown.Item, {
                  key: idx,
                  value: opt.value,
                  text: opt.text,
                  selected: _this2.state.value === opt.value,
                  onClick: _this2.handleOnChange
                });
              }) : null
            )
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { className: 'field' },
        _react2.default.createElement(
          'label',
          { className: 'ui', htmlFor: this.props.name, style: { fontWeight: 'bold', margin: '0 0 0.28571429rem 0', fontSize: '.92857143em', display: 'block' } },
          this.props.label
        ),
        _react2.default.createElement(_semanticUiReact.Dropdown, {
          className: classNames.join(' '),
          disabled: this.props.disabled,
          fluid: true,
          selection: true,
          header: this.props.headerText,
          onChange: this.handleOnChange,
          options: options,
          selectOnBlur: false,
          placeholder: this.props.placeholder,
          value: this.state.value,
          scrolling: true,
          style: this.props.style,
          search: true,
          text: this.state.value && options && options.length > 0 ? _react2.default.createElement(
            'span',
            { style: truncateStyle },
            (options.find(function (o) {
              return o.value === _this2.state.value;
            }) || {}).text || this.props.placeholder
          ) : this.props.placeholder,
          name: this.props.name,
          noResultsMessage: _i18next2.default.t('No results found', { ns: 'translation' })
        })
      );
    }
  }]);

  return BookingSelectList;
}(_react.Component);

BookingSelectList.propTypes = {
  disabled: _propTypes2.default.bool,
  filterName: _propTypes2.default.string.isRequired,
  headerText: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired
  })).isRequired,
  placeholder: _propTypes2.default.string,
  value: _propTypes2.default.string,
  search: _propTypes2.default.string,
  style: _propTypes2.default.shape({}),
  label: _propTypes2.default.string,
  name: _propTypes2.default.string
};
BookingSelectList.defaultProps = {
  hasSearch: false,
  options: [],
  placeholder: 'Select an Option',
  value: ''
};

BookingSelectList.getPropsToState = function (props) {
  var value = props.value || '';
  var search = props.search || '';
  return {
    value: value,
    search: search
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleOnChange = function (e, _ref) {
    var value = _ref.value;

    _this3.setState({ value: value }, function () {
      _this3.props.onChange(value, _this3.props.filterName);
    });
  };
};

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BookingSelectListMultiple = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _i18next = __webpack_require__(94);

var _i18next2 = _interopRequireDefault(_i18next);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BookingSelectListMultiple = exports.BookingSelectListMultiple = function (_Component) {
  _inherits(BookingSelectListMultiple, _Component);

  function BookingSelectListMultiple(props) {
    _classCallCheck(this, BookingSelectListMultiple);

    var _this = _possibleConstructorReturn(this, (BookingSelectListMultiple.__proto__ || Object.getPrototypeOf(BookingSelectListMultiple)).call(this, props));

    _initialiseProps.call(_this);

    var state = BookingSelectListMultiple.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(BookingSelectListMultiple, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = BookingSelectListMultiple.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classNames = ['uc-dropdown uc-dropdown-select-list-multiple booking'];
      if (this.state.value.length > 0) {
        classNames.push('selected');
      }
      return _react2.default.createElement(
        'div',
        { className: 'field' },
        _react2.default.createElement(
          'label',
          { className: 'ui', htmlFor: this.props.filterName, style: { fontWeight: 'bold', margin: '0 0 0.28571429rem 0', fontSize: '.92857143em', display: 'block' } },
          this.props.label
        ),
        _react2.default.createElement(_semanticUiReact.Dropdown, {
          selection: true,
          fluid: true,
          scrolling: true,
          search: true,
          floating: true,
          className: classNames.join(' '),
          closeOnChange: false,
          header: this.props.headerText,
          onChange: this.handleOnChange,
          options: this.state.options.map(function (op) {
            return _extends({}, op, {
              content: _react2.default.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'center' } },
                _react2.default.createElement(_semanticUiReact.Icon, {
                  style: {
                    color: _this2.state.value.some(function (v) {
                      return v === op.value;
                    }) ? '#50b793' : '#969CA4',
                    flex: '0 0 auto', // prevents icon from stretching
                    marginRight: '8px'
                  },
                  size: 'large',
                  inverted: true,
                  name: 'square ' + (_this2.state.value.some(function (v) {
                    return v === op.value;
                  }) ? 'check' : 'outline')
                }),
                _react2.default.createElement(
                  'span',
                  { style: { flex: 1 } },
                  op.text
                )
              )
            });
          }),
          renderLabel: this.props.renderLabel,
          selectOnBlur: false,
          text: this.state.value.length > 0 ? this.state.value.length + ' ' + (this.props.selectedText || 'selected') || null : this.props.placeholder,
          placeholder: this.state.value.length > 0 ? null : this.props.placeholder,
          disabled: this.props.disabled,
          value: '',
          name: this.props.filterName,
          noResultsMessage: _i18next2.default.t('No results found', { ns: 'translation' })
        })
      );
    }
  }]);

  return BookingSelectListMultiple;
}(_react.Component);

BookingSelectListMultiple.propTypes = {
  disabled: _propTypes2.default.bool,
  filterName: _propTypes2.default.string.isRequired,
  headerText: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired
  })).isRequired,
  placeholder: _propTypes2.default.string,
  value: _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired),
  search: _propTypes2.default.string,
  renderLabel: _propTypes2.default.func,
  selectedText: _propTypes2.default.string,
  label: _propTypes2.default.string
};
BookingSelectListMultiple.defaultProps = {
  hasSearch: false,
  options: [],
  placeholder: 'Select an Option',
  value: []
};

BookingSelectListMultiple.getPropsToState = function (props) {
  var value = props.value || [];
  var options = props.options || [];
  var search = props.search || '';
  var limit = props.limit || 0;
  if (limit > 0) {
    options = options.map(function (d) {
      return _extends({
        disabled: limit > 0 && value.length >= limit
      }, d);
    });
  }
  return {
    value: value,
    options: options,
    search: search
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleOnChange = function (e, _ref) {
    var value = _ref.value;

    if (_this3.state.value.some(function (v) {
      return v === value;
    })) {
      var index = _this3.state.value.findIndex(function (v) {
        return v === value;
      });
      _this3.state.value.splice(index, 1);
    } else {
      _this3.state.value.push(value);
    }
    var newValue = [].concat(_this3.state.value);
    _this3.setState({ value: newValue }, function () {
      _this3.props.onChange(newValue, _this3.props.filterName);
    });
  };
};

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchFilter = function (_Component) {
  _inherits(SearchFilter, _Component);

  function SearchFilter(props) {
    _classCallCheck(this, SearchFilter);

    var _this = _possibleConstructorReturn(this, (SearchFilter.__proto__ || Object.getPrototypeOf(SearchFilter)).call(this, props));

    _initialiseProps.call(_this);

    var state = SearchFilter.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(SearchFilter, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.waitForDropdownMenu();
      window.addEventListener('resize', this.syncDropdownMenuWidth);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = SearchFilter.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.syncDropdownMenuWidth);
      clearInterval(this.dropdownPollInterval);
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      var isRenderInputAction = this.props.options && this.props.options.length > 0 && this.state.searchIn;
      return _react2.default.createElement(
        _semanticUiReact.Form,
        { onSubmit: this.handleSearch },
        _react2.default.createElement(
          'div',
          { className: 'field' },
          _react2.default.createElement(
            'label',
            { htmlFor: 'search' },
            this.props.label
          ),
          _react2.default.createElement(
            _semanticUiReact.Input,
            _extends({
              className: 'uc-search-wrapper ' + (isRenderInputAction ? 'uc-with-dropdown' : 'uc-no-dropdown'),
              loading: this.props.isLoading,
              disabled: this.props.isLoading,
              name: 'search',
              onChange: this.handleOnChange,
              placeholder: t(this.props.placeholder),
              value: this.state.search
            }, isRenderInputAction && { action: true }),
            _react2.default.createElement('input', { onBlur: this.handleBlur }),
            this.props.options && this.props.options.length > 0 && _react2.default.createElement(_semanticUiReact.Dropdown, {
              selection: true,
              floating: true,
              className: 'uc-search-dropdown',
              style: { textAlign: 'right' },
              onChange: this.handleOnDropdownChange,
              options: this.props.options,
              disabled: this.props.isLoading,
              value: this.state.searchIn,
              name: 'searchIn'
            })
          )
        )
      );
    }
  }]);

  return SearchFilter;
}(_react.Component);

SearchFilter.propTypes = {
  filterName: _propTypes2.default.string.isRequired,
  filterInName: _propTypes2.default.string.isRequired,
  isLoading: _propTypes2.default.bool,
  onChange: _propTypes2.default.func.isRequired,
  onSearchInChange: _propTypes2.default.func,
  onClear: _propTypes2.default.func.isRequired,
  search: _propTypes2.default.string,
  searchIn: _propTypes2.default.string,
  placeholder: _propTypes2.default.string,
  options: _propTypes2.default.arrayOf(_propTypes2.default.object),
  isFullSize: _propTypes2.default.bool,
  t: _propTypes2.default.func,
  label: _propTypes2.default.string
};
SearchFilter.defaultProps = {
  filterName: 'search',
  filterInName: 'searchIn',
  isLoading: false,
  placeholder: 'Search'
};

SearchFilter.getPropsToState = function (props) {
  var search = props.search || '';
  var searchIn = props.searchIn || '';
  if (props.options && props.options.length > 0 && (!searchIn || searchIn === '')) {
    searchIn = props.options[0].value;
  }
  return {
    search: search,
    searchIn: searchIn
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.waitForDropdownMenu = function () {
    _this2.dropdownPollInterval = setInterval(function () {
      var menu = document.querySelector('.uc-search-dropdown .menu');
      if (menu && menu.offsetParent !== null) {
        // check it's visible
        clearInterval(_this2.dropdownPollInterval);
        _this2.syncDropdownMenuWidth();
      }
    }, 50);
  };

  this.syncDropdownMenuWidth = function () {
    var inputWrapper = document.querySelector('.uc-search-wrapper');
    var dropdown = document.querySelector('.uc-search-dropdown');
    var dropdownMenu = document.querySelector('.uc-search-dropdown .menu');

    if (inputWrapper && dropdown && dropdownMenu) {
      var inputRect = inputWrapper.getBoundingClientRect();
      var dropdownRect = dropdown.getBoundingClientRect();
      var leftOffset = dropdownRect.left - inputRect.left;

      dropdownMenu.style.minWidth = inputWrapper.offsetWidth + 'px';
      dropdownMenu.style.left = '-' + leftOffset + 'px';
    }
  };

  this.handleClear = function () {
    _this2.setState({ search: '' }, function () {
      var _props = _this2.props,
          onClear = _props.onClear,
          filterName = _props.filterName;

      if (onClear) {
        onClear(filterName);
      }
    });
  };

  this.handleSearch = function (e) {
    if (e) {
      e.preventDefault();
    }
    if (_this2.state.search === '' && _this2.props.search !== '') {
      _this2.handleClear();
    } else if (_this2.state.search) {
      _this2.props.onChange(_this2.state.search, _this2.props.filterName);
    }
  };

  this.handleBlur = function () {
    // Call submit manually
    _this2.handleSearch();
  };

  this.handleOnChange = function (e) {
    var search = e.target.value;
    _this2.setState({ search: search }, function () {
      if (search === '') {
        _this2.handleClear();
      }
    });
  };

  this.handleOnDropdownChange = function (e, _ref) {
    var value = _ref.value;

    _this2.setState({ searchIn: value }, function () {
      _this2.props.onSearchInChange(value, _this2.props.filterInName);
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(SearchFilter);

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SortButton = function (_Component) {
  _inherits(SortButton, _Component);

  function SortButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SortButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SortButton.__proto__ || Object.getPrototypeOf(SortButton)).call.apply(_ref, [this].concat(args))), _this), _this.getDataAttributes = function (datarget) {
      if (datarget !== '') {
        return {
          'data-bot-target': datarget
        };
      }
      return '';
    }, _this.handleOnSort = function (column, direction) {
      if (_this.props.onSort) {
        _this.props.onSort(column, direction);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SortButton, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.items !== nextProps.items || this.props.icon !== nextProps.icon || this.props.color !== nextProps.color || this.props.loading !== nextProps.loading) {
        return true;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Button.Group,
        { floated: this.props.floated, className: this.props.className },
        _react2.default.createElement(
          _semanticUiReact.Dropdown,
          {
            basic: true,
            icon: this.props.icon,
            floating: true,
            scrolling: true,
            disabled: this.props.loading || this.props.disabled
          },
          _react2.default.createElement(
            _semanticUiReact.Dropdown.Menu,
            null,
            this.props.header ? _react2.default.createElement(_semanticUiReact.Dropdown.Header, { content: this.props.header }) : null,
            this.props.items && this.props.items.length > 0 ? this.props.items.map(function (item, idx) {
              if (item.isDivider) {
                return _react2.default.createElement(_semanticUiReact.Dropdown.Divider, { key: idx });
              }
              return _react2.default.createElement(_semanticUiReact.Dropdown.Item, _extends({}, _this2.getDataAttributes(item.dataTarget), {
                key: idx,
                as: item.href ? 'a' : null,
                text: t(item.text),
                icon: item.icon,
                href: item.href || null,
                target: item.href && item.target ? item.target : null,
                rel: item.href && item.rel ? item.rel : null,
                onClick: function onClick() {
                  if (!item.href) {
                    if (item.onClick) {
                      return item.onClick();
                    }
                    return _this2.handleOnSort(item.sortColumn, item.sortDirection);
                  }
                  return null;
                }
              }));
            }) : null
          )
        )
      );
    }
  }]);

  return SortButton;
}(_react.Component);

SortButton.propTypes = {
  items: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string,
    icon: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
    sortColumn: _propTypes2.default.string,
    sortDirection: _propTypes2.default.string,
    href: _propTypes2.default.string,
    target: _propTypes2.default.string,
    rel: _propTypes2.default.string,
    isDivider: _propTypes2.default.bool,
    onClick: _propTypes2.default.func,
    dataTarget: _propTypes2.default.string
  })).isRequired,
  icon: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.node, _propTypes2.default.string]),
  loading: _propTypes2.default.bool,
  color: _propTypes2.default.string,
  onSort: _propTypes2.default.func,
  floated: _propTypes2.default.string,
  className: _propTypes2.default.string,
  header: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.translation)(SortButton);

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable max-len */
// Imported and modified from http://www.bnm.gov.my/index.php?ch=en_announcement&pg=en_announcement&ac=478
var MY_BANKS = [{ value: 'Aeon Bank', text: 'Aeon Bank' }, { value: 'Affin Bank Berhad', text: 'Affin Bank Berhad' }, { value: 'Affin Islamic Bank Berhad', text: 'Affin Islamic Bank Berhad' }, { value: 'Agro Bank Malaysia', text: 'Agro Bank Malaysia' }, { value: 'Al Rajhi Bank', text: 'Al Rajhi Bank' },
// { value: 'Alkhair International Islamic Bank Bhd', text: 'Alkhair International Islamic Bank Bhd', disabled: true },
{ value: 'Alliance Bank Malaysia Berhad', text: 'Alliance Bank Malaysia Berhad' }, { value: 'Alliance Islamic Bank Berhad', text: 'Alliance Islamic Bank Berhad' }, { value: 'AmBank (M) Berhad', text: 'AmBank (M) Berhad' }, { value: 'AmBank Islamic Berhad', text: 'AmBank Islamic Berhad' },
// { value: 'Asia Offshore Finance Agency', text: 'Asia Offshore Finance Agency', disabled: true },
{ value: 'Bangkok Bank Berhad', text: 'Bangkok Bank Berhad' }, { value: 'Bank Islam Malaysia', text: 'Bank Islam Malaysia' }, { value: 'Bank Muamalat Malaysia', text: 'Bank Muamalat Malaysia' }, { value: 'Bank of America Malaysia Berhad', text: 'Bank of America Malaysia Berhad' }, { value: 'Bank of China (Malaysia) Berhad', text: 'Bank of China (Malaysia) Berhad' }, { value: 'Bank of Tokyo-Mitsubishi UFJ (Malaysia) Berhad', text: 'Bank of Tokyo-Mitsubishi UFJ (Malaysia) Berhad' }, { value: 'Bank Perusahaan Kecil & Sederhana Berhad ((Small Medium Enterprise) SME Bank Berhad)', text: 'Bank Perusahaan Kecil & Sederhana Berhad ((Small Medium Enterprise) SME Bank Berhad)' }, { value: 'Bank Rakyat', text: 'Bank Rakyat' }, { value: 'Bank Simpanan Nasional', text: 'Bank Simpanan Nasional' }, { value: 'BNP Paribas Malaysia Berhad', text: 'BNP Paribas Malaysia Berhad' }, { value: 'Boost Bank', text: 'Boost Bank' }, { value: 'China Construction Bank (Malaysia) Berhad[2]', text: 'China Construction Bank (Malaysia) Berhad[2]' }, { value: 'CIMB Bank Berhad', text: 'CIMB Bank Berhad' }, { value: 'CIMB Islamic Bank Berhad', text: 'CIMB Islamic Bank Berhad' }, { value: 'Citibank Berhad', text: 'Citibank Berhad' }, { value: 'Deutsche Bank (Malaysia) Berhad', text: 'Deutsche Bank (Malaysia) Berhad' }, { value: 'Export-Import Bank of Malaysia Berhad (Exim Bank)', text: 'Export-Import Bank of Malaysia Berhad (Exim Bank)' }, { value: 'GX Bank', text: 'GX Bank' }, { value: 'Hong Leong Bank Berhad', text: 'Hong Leong Bank Berhad' }, { value: 'Hong Leong Islamic Bank Berhad', text: 'Hong Leong Islamic Bank Berhad' }, { value: 'HSBC Amanah Malaysia Berhad', text: 'HSBC Amanah Malaysia Berhad' }, { value: 'HSBC Bank Malaysia Berhad', text: 'HSBC Bank Malaysia Berhad' }, { value: 'India International Bank (Malaysia) Berhad', text: 'India International Bank (Malaysia) Berhad' }, { value: 'Industrial and Commercial Bank of China (Malaysia) Berhad', text: 'Industrial and Commercial Bank of China (Malaysia) Berhad' }, { value: 'J.P. Morgan Chase Bank Berhad', text: 'J.P. Morgan Chase Bank Berhad' }, { value: 'KAF Digital Bank', text: 'KAF Digital Bank' }, { value: 'Kuwait Finance House (Malaysia) Berhad', text: 'Kuwait Finance House (Malaysia) Berhad' }, { value: 'Malayan Banking Berhad', text: 'Malayan Banking Berhad' }, { value: 'Maybank Islamic Berhad', text: 'Maybank Islamic Berhad' }, { value: 'MBSB Bank Berhad', text: 'MBSB Bank Berhad' }, { value: 'Mizuho Bank (Malaysia) Berhad', text: 'Mizuho Bank (Malaysia) Berhad' }, { value: 'OCBC Al-Amin Bank Berhad', text: 'OCBC Al-Amin Bank Berhad' }, { value: 'OCBC Bank (Malaysia) Berhad', text: 'OCBC Bank (Malaysia) Berhad' }, { value: 'Public Bank Berhad', text: 'Public Bank Berhad' }, { value: 'Public Islamic Bank Berhad', text: 'Public Islamic Bank Berhad' }, { value: 'RHB Bank Berhad', text: 'RHB Bank Berhad' }, { value: 'RHB Islamic Bank Berhad', text: 'RHB Islamic Bank Berhad' }, { value: 'Ryt Bank', text: 'Ryt Bank' }, { value: 'Sabah Development Bank Berhad (SDB)', text: 'Sabah Development Bank Berhad (SDB)' }, { value: 'Standard Chartered Bank Malaysia Berhad', text: 'Standard Chartered Bank Malaysia Berhad' }, { value: 'Standard Chartered Saadiq Berhad ', text: 'Standard Chartered Saadiq Berhad ' }, { value: 'Sumitomo Mitsui Banking Corporation Malaysia Berhad', text: 'Sumitomo Mitsui Banking Corporation Malaysia Berhad' }, { value: 'The Bank of Nova Scotia Berhad', text: 'The Bank of Nova Scotia Berhad' }, { value: 'Touch \'n Go', text: 'Touch \'n Go' }, { value: 'United Overseas Bank (Malaysia) Bhd.', text: 'United Overseas Bank (Malaysia) Bhd.' }];

var SG_BANKS = [{ value: 'Australia and New Zealand Banking Group Ltd', text: 'Australia & New Zealand Banking Group Ltd' }, { value: 'Bangkok Bank Public Company Limited', text: 'Bangkok Bank Public Company Limited' }, { value: 'Bank of America', text: 'Bank of America' }, { value: 'Bank of China Limited', text: 'Bank of China Limited' }, { value: 'Bank of East Asia Ltd', text: 'Bank of East Asia Ltd' }, { value: 'Bank of India', text: 'Bank of India' }, { value: 'Bank of Singapore Limited', text: 'Bank of Singapore Limited' }, { value: 'Bank of Tokyo-Mitsubishi UFJ Ltd', text: 'Bank of Tokyo-Mitsubishi UFJ Ltd' }, { value: 'BNP Paribas', text: 'BNP Paribas' }, { value: 'CIMB Bank Berhad', text: 'CIMB Bank Berhad' }, { value: 'Citibank Singapore Ltd', text: 'Citibank Singapore Ltd' }, { value: 'Credit Agricole Corporate & Investment Bank', text: 'Credit Agricole Corporate & Investment Bank' }, { value: 'DBS Bank Ltd', text: 'DBS Bank LTD' }, { value: 'Far Eastern Bank Ltd', text: 'Far Eastern Bank LTD' }, { value: 'HL Bank', text: 'HL Bank' }, { value: 'Hongkong and Shanghai Banking Corporation Ltd', text: 'Hongkong & Shanghai Banking Corporation Ltd' }, { value: 'Icici Bank Ltd', text: 'Icici Bank Ltd' }, { value: 'Indian Bank', text: 'Indian Bank' }, { value: 'Indian Overseas Bank', text: 'Indian Overseas Bank' }, { value: 'Industrial and Commercial Bank of China Ltd', text: 'Industrial & Commercial Bank of China Ltd' }, { value: 'JP Morgan Chase Bank', text: 'JP Morgan Chase Bank' }, { value: 'Malayan Banking Berhad', text: 'Malayan Banking Berhad' }, { value: 'Mizuho Bank Ltd', text: 'Mizuho Bank Ltd' }, { value: 'Oversa-Chinese Banking Corporation Limited', text: 'Oversa-Chinese Banking Corporation Limited' }, { value: 'PT Bank negara Indonesia (Persero) Tbk', text: 'PT Bank negara Indonesia (Persero) Tbk' }, { value: 'RHB Bank Berhad', text: 'RHB Bank Berhad' }, { value: 'Standard Chartered Bank (Singapore) Ltd', text: 'Standard Chartered Bank (Singapore) Ltd' }, { value: 'State Bank of India', text: 'State Bank of India' }, { value: 'Sumitomo Mitsui Banking Corporation', text: 'Sumitomo Mitsui Banking Corporation' }, { value: 'UCO Bank', text: 'UCO Bank' }, { value: 'United Overseas Bank Limited', text: 'United Overseas Bank Limited' }];

var ID_BANKS = exports.ID_BANKS = [{ value: 'PT Bank Anz Indonesia', text: 'PT Bank Anz Indonesia' }, { value: 'PT Bank Artha Graha Internasional Tbk', text: 'PT Bank Artha Graha Internasional Tbk' }, { value: 'PT Bank Bnp Paribas Indonesia', text: 'PT Bank Bnp Paribas Indonesia' }, { value: 'PT Bank Btpn Tbk', text: 'PT Bank Btpn Tbk' }, { value: 'PT Bank Bumi Arta Tbk', text: 'PT Bank Bumi Arta Tbk' }, { value: 'PT Bank Capital Indonesia Tbk', text: 'PT Bank Capital Indonesia Tbk' }, { value: 'PT Bank Central Asia Tbk', text: 'PT Bank Central Asia Tbk' }, { value: 'PT Bank Cimb Niaga Tbk', text: 'PT Bank Cimb Niaga Tbk' }, { value: 'PT Bank Commonwealth', text: 'PT Bank Commonwealth' }, { value: 'PT Bank Ctbc Indonesia', text: 'PT Bank Ctbc Indonesia' }, { value: 'PT Bank Danamon Indonesia Tbk', text: 'PT Bank Danamon Indonesia Tbk' }, { value: 'PT Bank Dbs Indonesia', text: 'PT Bank Dbs Indonesia' }, { value: 'PT Bank Hsbc Indonesia', text: 'PT Bank Hsbc Indonesia' }, { value: 'PT Bank Icbc Indonesia', text: 'PT Bank Icbc Indonesia' }, { value: 'PT Bank Jtrust Indonesia Tbk', text: 'PT Bank Jtrust Indonesia Tbk' }, { value: 'PT Bank Kb Bukopin Tbk', text: 'PT Bank Kb Bukopin Tbk' }, { value: 'PT Bank Keb Hana Indonesia', text: 'PT Bank Keb Hana Indonesia' }, { value: 'PT Bank Mandiri (Persero) Tbk', text: 'PT Bank Mandiri (Persero) Tbk' }, { value: 'PT Bank Mayapada International Tbk', text: 'PT Bank Mayapada International Tbk' }, { value: 'PT Bank Maybank Indonesia Tbk', text: 'PT Bank Maybank Indonesia Tbk' }, { value: 'PT Bank Mega Syariah', text: 'PT Bank Mega Syariah' }, { value: 'PT Bank Mega Tbk', text: 'PT Bank Mega Tbk' }, { value: 'PT Bank Muamalat Indonesia Tbk', text: 'PT Bank Muamalat Indonesia Tbk' }, { value: 'PT Bank Negara Indonesia (Persero) Tbk', text: 'PT Bank Negara Indonesia (Persero) Tbk' }, { value: 'PT Bank Ocbc Nisp Tbk', text: 'PT Bank Ocbc Nisp Tbk' }, { value: 'PT Bank Permata Tbk', text: 'PT Bank Permata Tbk' }, { value: 'PT Bank Rakyat Indonesia (Persero) Tbk', text: 'PT Bank Rakyat Indonesia (Persero) Tbk' }, { value: 'PT Bank Sbi Indonesia', text: 'PT Bank Sbi Indonesia' }, { value: 'PT Bank Sinarmas Tbk', text: 'PT Bank Sinarmas Tbk' }, { value: 'PT Bank Syariah Indonesia Tbk', text: 'PT Bank Syariah Indonesia Tbk' }, { value: 'PT Bank Tabungan Negara (Persero) Tbk', text: 'PT Bank Tabungan Negara (Persero) Tbk' }, { value: 'PT Bank Uob Indonesia', text: 'PT Bank Uob Indonesia' }, { value: 'PT Bank Victoria Syariah', text: 'PT Bank Victoria Syariah' }, { value: 'VA - PT Bank Central Asia Tbk', text: 'VA - PT Bank Central Asia Tbk' }, { value: 'VA - PT Bank Mandiri (Persero) Tbk', text: 'VA - PT Bank Mandiri (Persero) Tbk' }, { value: 'VA - PT Bank Negara Indonesia (Persero) Tbk', text: 'VA - PT Bank Negara Indonesia (Persero) Tbk' }, { value: 'VA - PT Bank Permata Tbk', text: 'VA - PT Bank Permata Tbk' }, { value: 'VA - PT Bank Rakyat Indonesia (Persero) Tbk', text: 'VA - PT Bank Rakyat Indonesia (Persero) Tbk' }, { value: 'VA - PT Bank Syariah Indonesia Tbk', text: 'VA - PT Bank Syariah Indonesia Tbk' }];

var VN_BANKS = exports.VN_BANKS = [{ value: 'Vietcombank', text: 'Joint Stock Commercial Bank for Foreign Trade of Vietnam' }, { value: 'Agribank', text: 'Vietnam Bank for Agriculture and Rural Development' }, { value: 'BIDV', text: 'Joint Stock Commercial Bank for Investment and Development of Vietnam' }, { value: 'VietinBank', text: 'Vietnam Joint Stock Commercial Bank for Industry and Trade' }, { value: 'Techcombank', text: 'Vietnam Technological and Commercial Joint-stock Bank' }, { value: 'MB Bank', text: 'Military Commercial Joint Stock Bank' }, { value: 'VPBank', text: 'Vietnam Prosperity Joint Stock Commercial Bank' }, { value: 'ACB', text: 'Asia Commercial Joint Stock Bank' }, { value: 'Sacombank', text: 'Saigon Thuong Tin Commercial Joint Stock Bank' }, { value: 'VIB', text: 'Vietnam International Commercial Joint Stock Bank' }, { value: 'HDBank', text: 'Ho Chi Minh City Development Joint Stock Commercial Bank' }, { value: 'TPBank', text: 'Tien Phong Commercial Joint Stock Bank' }, { value: 'SHB', text: 'Saigon - Hanoi Commercial Joint Stock Bank' }, { value: 'Shinhan Bank Vietnam', text: 'Shinhan Bank Vietnam' }, { value: 'HSBC Vietnam', text: 'HSBC Vietnam' }, { value: 'Standard Chartered Vietnam', text: 'Standard Chartered Vietnam' }, { value: 'Public Bank Vietnam', text: 'Public Bank Vietnam' }, { value: 'UOB Vietnam', text: 'UOB Vietnam' }, { value: 'Woori Bank', text: 'Woori Bank' }];

var BANKS = exports.BANKS = [].concat(MY_BANKS, ID_BANKS, SG_BANKS);

var BANKS_BY_COUNTRY = [{ country: 'id', value: ID_BANKS }, { country: 'my', value: MY_BANKS }, { country: 'sg', value: SG_BANKS }, { country: 'vn', value: VN_BANKS }];

exports.default = BANKS_BY_COUNTRY;

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BU_STATUS_FILTER = [{ text: 'Archived', value: 'archived' }, { text: 'Active', value: 'active' }];
exports.default = BU_STATUS_FILTER;

/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PROJECT_STATUSES = [{ text: 'Draft', value: 'draft' }, { text: 'Ready', value: 'ready' }, { text: 'Published', value: 'published' }, { text: 'Archived', value: 'archived' }, { text: 'Deleted', value: 'deleted' }];
exports.default = PROJECT_STATUSES;

/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SOURCE_OF_FINANCE_STATUS = exports.SOURCE_OF_FINANCE_STATUS = {
  CASH: 'cash',
  LOAN: 'bank_loan'
};

var SOURCE_OF_FINANCE_STATUSES = exports.SOURCE_OF_FINANCE_STATUSES = [{ text: 'Cash', value: SOURCE_OF_FINANCE_STATUS.CASH }, { text: 'Loan', value: SOURCE_OF_FINANCE_STATUS.LOAN }];

var SOURCE_OF_FINANCE_STATUS_MAP = exports.SOURCE_OF_FINANCE_STATUS_MAP = SOURCE_OF_FINANCE_STATUSES.reduce(function (acc, tab) {
  return _extends({}, acc, _defineProperty({}, tab.value, tab));
}, {});

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _fileSize = __webpack_require__(85);

var _fileSize2 = _interopRequireDefault(_fileSize);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AttachmentModal = function (_Component) {
  _inherits(AttachmentModal, _Component);

  function AttachmentModal(props) {
    _classCallCheck(this, AttachmentModal);

    var _this = _possibleConstructorReturn(this, (AttachmentModal.__proto__ || Object.getPrototypeOf(AttachmentModal)).call(this, props));

    _initialiseProps.call(_this);

    var state = AttachmentModal.getPropsToState(props);

    _this.state = _extends({
      loading: false,
      pictureListModalOpen: false,
      pictureListModalID: '',
      showLarge: false,
      selectedPicture: null,
      slideshow: false,
      showDeletePictureConfirm: false,
      deleteFile: null
    }, state);
    return _this;
  }

  _createClass(AttachmentModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = AttachmentModal.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'checkDisabled',
    value: function checkDisabled() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';
      var selectedPicture = this.state.selectedPicture;

      if (this.getPaymentPictures() && this.getPaymentPictures().length > 0 && selectedPicture) {
        var index = this.getPaymentPictures().indexOf(selectedPicture);
        if (direction === 'left') {
          return index - 1 >= 0;
        }
        return index + 1 < this.getPaymentPictures().length;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;
      var _state = this.state,
          modalState = _state.modalState,
          deleteFile = _state.deleteFile;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_DeleteConfirm2.default, {
          open: this.state.showDeletePictureConfirm,
          onClose: this.handleCancelDeletePicture,
          onConfirm: this.handleConfirmDeletePicture,
          name: deleteFile ? deleteFile.name : ''
        }),
        _react2.default.createElement(_ViewLarge2.default, {
          open: this.state.showLarge,
          onClose: this.handleCloseLarge,
          picture: this.state.selectedPicture,
          onSlide: this.handleSlidePicture,
          disabledLeft: !this.checkDisabled('left'),
          disabledRight: !this.checkDisabled('right'),
          slideshow: this.state.slideshow
        }),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            open: modalState,
            onClose: this.handleClosePictureListModal
          },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Header,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { verticalAlign: 'middle' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 8, tablet: 8, computer: 8 },
                  _react2.default.createElement(
                    'h3',
                    null,
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'attach', size: 'large' }),
                    ' ',
                    t('Payment Attachments')
                  )
                ),
                _react2.default.createElement(_semanticUiReact.Grid.Column, { mobile: 8, tablet: 8, computer: 8, textAlign: 'right' })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            { scrolling: true },
            _react2.default.createElement(
              _semanticUiReact.Modal.Description,
              null,
              _react2.default.createElement(
                _semanticUiReact.Segment.Group,
                null,
                this.getPaymentPictures().length > 0 ? this.getPaymentPictures().map(function (file, id) {
                  return _react2.default.createElement(
                    _semanticUiReact.Segment,
                    { key: id },
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      {
                        columns: 'equal',
                        verticalAlign: 'middle',
                        as: 'a'
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 5, computer: 6, textAlign: 'left', onClick: function onClick(e) {
                            return _this3.handleViewLargeSlide(e, file);
                          }, style: { overflowX: 'hidden' } },
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'file image outline' }),
                        file.name,
                        _react2.default.createElement(
                          'span',
                          { className: 'mobile-hide' },
                          ' (',
                          (0, _fileSize2.default)(file.size),
                          ')'
                        ),
                        _react2.default.createElement(
                          'small',
                          { className: 'large-hide small-hide tablet-hide' },
                          _react2.default.createElement('br', null),
                          (0, _fileSize2.default)(file.size)
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 5, computer: 5, style: { paddingLeft: 0 } },
                        _react2.default.createElement(
                          'p',
                          { className: 'attachment-button' },
                          _react2.default.createElement(_semanticUiReact.Button, {
                            basic: true,
                            content: t('Print Attachment'),
                            onClick: function onClick(e) {
                              return _this3.handleOpenAttachment(e, file);
                            }
                          })
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 6, computer: 5, textAlign: 'right' },
                        _react2.default.createElement(
                          'small',
                          { onClick: function onClick(e) {
                              return _this3.handleViewLargeSlide(e, file);
                            }, style: { paddingRight: '1em' } },
                          _react2.default.createElement(_Timestamp2.default, { format: 'DD/MM/YY hh:mm a', timestamp: file.createdAt })
                        ),
                        _this3.props.onDelete ? _react2.default.createElement(_semanticUiReact.Button, {
                          compact: true,
                          negative: true,
                          type: 'button',
                          size: 'tiny',
                          icon: 'trash',
                          onClick: function onClick(e) {
                            return _this3.handleDeletePicture(e, file);
                          }
                        }) : ''
                      )
                    )
                  );
                }) : _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { textAlign: 'center' },
                  'No pictures found'
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleClosePictureListModal, content: t('Close', { ns: _translation.TRANSLATION_FILES.translation }) })
          )
        )
      );
    }
  }]);

  return AttachmentModal;
}(_react.Component);

AttachmentModal.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  modalState: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onDelete: _propTypes2.default.func
};

AttachmentModal.getPropsToState = function (props) {
  var modalState = props.modalState;
  var data = Object.assign({}, props.data);
  return {
    data: data,
    modalState: modalState
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.getPaymentPictures = function () {
    var data = _this4.state.data;

    if (data && data.paymentPictures && data.paymentPictures.length > 0) {
      return data.paymentPictures;
    }
    return [];
  };

  this.handleClosePictureListModal = function () {
    if (_this4.props.onClose) _this4.props.onClose();
  };

  this.handleCloseLarge = function (e) {
    e.preventDefault();
    _this4.setState({
      showLarge: false,
      selectedPicture: null,
      slideshow: false
    });
  };

  this.handleCancelDeletePicture = function (e) {
    e.preventDefault();
    _this4.setState({
      showDeletePictureConfirm: false,
      deleteFile: null
    });
  };

  this.handleConfirmDeletePicture = function (e) {
    e.preventDefault();
    var fileID = _this4.state.deleteFile.id;
    _this4.setState({
      showDeletePictureConfirm: false,
      deleteFile: null
    }, function () {
      _this4.props.onDelete(fileID, _this4.removeDeletedPictures);
    });
  };

  this.handleDeletePicture = function (e, file) {
    e.preventDefault();
    _this4.setState({
      showDeletePictureConfirm: true,
      deleteFile: file
    });
  };

  this.handleOpenAttachment = function (e, file) {
    e.preventDefault();
    var url = _config2.default.get('bookApiURL') + '/bookings/' + _this4.state.data.bookingID + '/pictures/' + file.id + '/print/';
    window.open(url);
  };

  this.handleSlidePicture = function (e) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
    var selectedPicture = _this4.state.selectedPicture;

    var index = _this4.getPaymentPictures().indexOf(selectedPicture);
    var nextIndex = direction === 'left' ? index - 1 : index + 1;
    _this4.setState({
      selectedPicture: _this4.getPaymentPictures()[nextIndex]
    });
  };

  this.handleViewLargeSlide = function (e, data) {
    e.preventDefault();
    _this4.setState({
      selectedPicture: data,
      showLarge: true,
      slideshow: true
    });
  };

  this.removeDeletedPictures = function (picId) {
    var data = _this4.state.data;

    var picIndex = data.paymentPictures.findIndex(function (e) {
      return e.id === picId;
    });
    if (picIndex !== -1) {
      data.paymentPictures.splice(picIndex, 1);
      _this4.setState({ data: data });
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(AttachmentModal);

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _strings = __webpack_require__(118);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var validFileTypes = ['image/gif', 'image/jpeg', 'image/png'];

var UploadLogoForm = function (_Component) {
  _inherits(UploadLogoForm, _Component);

  function UploadLogoForm(props) {
    _classCallCheck(this, UploadLogoForm);

    var _this = _possibleConstructorReturn(this, (UploadLogoForm.__proto__ || Object.getPrototypeOf(UploadLogoForm)).call(this, props));

    _this.handleSubmit = function (event) {
      event.preventDefault();
      var formData = new FormData(_this.form);
      _this.state.uploads.forEach(function (upload, idx) {
        formData.append('files_' + idx, upload.file);
        formData.append('labels_' + idx, _this.state.logoLabels[idx]);
      });
      if (_this.props.onSubmit) {
        _this.props.onSubmit(event, formData);
      }
    };

    _this.handleRemove = function (event, idx) {
      event.preventDefault();
      var _this$state = _this.state,
          uploads = _this$state.uploads,
          logoLabels = _this$state.logoLabels;

      uploads.splice(idx, 1);
      logoLabels.splice(idx, 1);
      _this.setState({ uploads: uploads, logoLabels: logoLabels });
    };

    _this.handleAddFile = function (event) {
      event.preventDefault();
      _this.uploadFiles.click();
    };

    _this.handleOnChange = function () {
      var files = Array.prototype.slice.call(_this.uploadFiles.files);
      _this.uploadFiles.value = null;
      if (window.FileReader) {
        files.forEach(function (file) {
          var reader = new FileReader();
          if (!validFileTypes.some(function (fileType) {
            return file.type === fileType;
          })) {
            var store = _this.context.store;

            store.dispatch((0, _flash.flashErrorMessage)({ message: 'Invalid image file(s) submitted.' }));
            return;
          }
          reader.onloadend = function () {
            var _this$state2 = _this.state,
                uploads = _this$state2.uploads,
                logoLabels = _this$state2.logoLabels;

            var name = file.name.substring(0, file.name.length - 4);
            uploads.push({
              file: file,
              name: name,
              src: reader.result
            });
            var label = (0, _strings.titleCase)((0, _strings.symbolToSpace)(name));
            logoLabels.push(label);
            _this.setState({
              uploads: uploads,
              logoLabels: logoLabels
            }, function () {
              _this.handleCheckChanges();
            });
          };
          reader.readAsDataURL(file);
        });
      }
    };

    _this.handleLabelChange = function (e, value, idx) {
      var logoLabels = _this.state.logoLabels;

      var newValue = value.replace(/[\\~#%&*{}/:<>?|"]/, '');
      logoLabels[idx] = newValue;
      _this.setState({ logoLabels: logoLabels });
    };

    _this.state = {
      loading: false,
      uploads: [],
      logoLabels: []
    };
    _this.uploadFiles = null;
    return _this;
  }

  _createClass(UploadLogoForm, [{
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'submit',
    value: function submit(url) {
      var _this3 = this;

      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var store = this.context.store;

      return this.setLoading(true).then(function () {
        return store.dispatch((0, _fetchM.fetchM)(url, opts));
      }).then(function (res) {
        return res.json();
      }).then(function (result) {
        return _this3.setLoading(false).then(function () {
          return _this3.resetFiles();
        }).then(function () {
          return result;
        });
      }).catch(function (err) {
        return _this3.setLoading(false).then(function () {
          return _this3.resetFiles();
        }).then(function () {
          return Promise.reject(err);
        });
      });
    }
  }, {
    key: 'resetFiles',
    value: function resetFiles() {
      // temporary fix for upload modal not closing
      this.setState({
        uploads: [],
        logoLabels: []
      });
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      var _this4 = this;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true }, function () {
          if (_this4.props.onChange) {
            _this4.props.onChange(true);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        'form',
        {
          encType: 'multipart/form-data',
          onSubmit: this.handleSubmit,
          name: 'uploadLogo',
          ref: function ref(_ref3) {
            _this5.form = _ref3;
          }
        },
        _react2.default.createElement('input', {
          ref: function ref(_ref) {
            _this5.uploadFiles = _ref;
          },
          type: 'file',
          onChange: function onChange() {
            return _this5.handleOnChange();
          },
          accept: 'image/gif, image/jpeg, image/png',
          multiple: true,
          style: { display: 'none' }
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 'equal' },
            _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'computer' }),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { verticalAlign: 'middle', columns: 'equal' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Button, {
                    fluid: true,
                    compact: true,
                    primary: true,
                    icon: 'add',
                    content: t('Logos'),
                    onClick: this.handleAddFile,
                    disabled: this.state.loading
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Button, {
                    fluid: true,
                    compact: true,
                    type: 'submit',
                    positive: true,
                    content: t('Upload', { ns: _translation.TRANSLATION_FILES.translation }),
                    icon: 'cloud upload',
                    loading: this.state.loading,
                    disabled: this.state.uploads.length < 1 || this.state.loading
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { stackable: true, doubling: true, columns: 2 },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { indeterminate: true, inline: 'centered' },
              t('Uploading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          this.state.uploads.length > 0 ? this.state.uploads.map(function (upload, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { key: idx },
              _react2.default.createElement(
                _semanticUiReact.Segment.Group,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { secondary: true },
                  _react2.default.createElement(_LoadImage2.default, {
                    fluid: true,
                    src: upload.src
                  }),
                  _react2.default.createElement(_semanticUiReact.Label, {
                    as: 'a',
                    corner: true,
                    color: 'red',
                    icon: 'delete',
                    disabled: _this5.state.loading,
                    onClick: function onClick(e) {
                      return _this5.handleRemove(e, idx);
                    }
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { padded: true },
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { columns: 1 },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      null,
                      _react2.default.createElement(_semanticUiReact.Input, {
                        label: t('Label'),
                        fluid: true,
                        placeholder: t('Label'),
                        type: 'text',
                        value: _this5.state.logoLabels[idx],
                        disabled: _this5.state.loading,
                        onChange: function onChange(e, _ref2) {
                          var value = _ref2.value;
                          return _this5.handleLabelChange(e, value, idx);
                        }
                      })
                    )
                  )
                )
              )
            );
          }) : null
        )
      );
    }
  }]);

  return UploadLogoForm;
}(_react.Component);

UploadLogoForm.propTypes = {
  onSubmit: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  t: _propTypes2.default.func
};
UploadLogoForm.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })((0, _reactRedux.connect)(UploadLogoForm.mapStateToProps, null, null, { withRef: true })(UploadLogoForm));

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _PhoneInput = __webpack_require__(104);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

var _intlCallCodes = __webpack_require__(116);

var _intlCallCodes2 = _interopRequireDefault(_intlCallCodes);

var _phone = __webpack_require__(146);

var _companies = __webpack_require__(88);

var _storage = __webpack_require__(44);

var _intlFlagCodes = __webpack_require__(141);

var _intlFlagCodes2 = _interopRequireDefault(_intlFlagCodes);

var _translation = __webpack_require__(4);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InviteBankerForm = function (_Component) {
  _inherits(InviteBankerForm, _Component);

  function InviteBankerForm(props) {
    _classCallCheck(this, InviteBankerForm);

    var _this = _possibleConstructorReturn(this, (InviteBankerForm.__proto__ || Object.getPrototypeOf(InviteBankerForm)).call(this, props));

    _initialiseProps.call(_this);

    var auth = props.auth;
    var defaultCountryPhoneCode = '60';
    if (auth && (0, _companies.isForeignCompany)(auth.company)) {
      var idx = _intlFlagCodes2.default.findIndex(function (f) {
        return f.countryCode === auth.company.countryCode;
      });
      if (idx !== -1) {
        defaultCountryPhoneCode = _intlFlagCodes2.default[idx].value;
      }
    }

    var phoneValidationPresets = {};
    var storePhoneValidationPresets = (0, _storage.getItem)(_config2.default.get('appName') + '.phoneValidationPresets');
    if (storePhoneValidationPresets) {
      try {
        phoneValidationPresets = JSON.parse(storePhoneValidationPresets).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }

    _this.state = {
      mobilePrefix: defaultCountryPhoneCode,
      mobile: '',
      name: '',
      bankID: 0,
      errMessages: [],
      banksOptions: [],
      defaultCountryPhoneCode: defaultCountryPhoneCode,
      phoneValidationPresets: phoneValidationPresets
    };
    _this.validation = {
      name: (0, _react.createRef)(),
      bankID: (0, _react.createRef)(),
      mobilePrefix: (0, _react.createRef)(),
      mobile: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(InviteBankerForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.open && !this.props.open) {
        this.resetData(function () {
          _this2.getBanksOptions(nextProps);
        });
      }
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          open: this.props.open === true,
          onClose: this.handleOnClose,
          closeIcon: 'close'
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'add', content: t('Invite banker') }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            _react2.default.createElement(
              'p',
              null,
              t('Please fill in banker detail'),
              '.'
            ),
            _react2.default.createElement(
              _AppForm2.default,
              {
                onSubmit: this.handleSubmit,
                error: this.state.errMessages.length > 0,
                ref: function ref(_ref2) {
                  _this3.form = _ref2;
                }
              },
              _react2.default.createElement(_AppForm2.default.Input, {
                autoComplete: 'off',
                name: 'name',
                onChange: this.handleOnChange,
                label: t('Name'),
                ref: this.validation.name,
                validation: [_webValidations.required],
                value: this.state.name
              }),
              _react2.default.createElement(
                _AppForm2.default.Validate,
                {
                  validation: [_webValidations.required],
                  ref: this.validation.bankID,
                  onChange: this.handleOnChange,
                  validateLabel: t('Bank')
                },
                _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  { name: 'bankID' },
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'bankID' },
                    t('Bank')
                  ),
                  _react2.default.createElement(_semanticUiReact.Dropdown, {
                    name: 'bankID',
                    selectOnBlur: false,
                    fluid: true, selection: true, search: true,
                    floating: true, scrolling: true, className: 'icon',
                    onChange: function onChange(e, _ref) {
                      var value = _ref.value;
                      return _this3.handleOnChange(e, { value: value, name: 'bankID' });
                    },
                    options: this.state.banksOptions,
                    value: this.state.bankID
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    validation: [_webValidations.required],
                    ref: this.validation.mobilePrefix,
                    onChange: this.handleOnChange,
                    validateLabel: t('{{label}} Prefix', { label: t('Mobile') })
                  },
                  _react2.default.createElement(_semanticUiReact.Form.Select, {
                    name: 'mobilePrefix',
                    onChange: this.handleOnChange,
                    options: _intlCallCodes2.default,
                    label: t('{{label}} Prefix', { label: t('Mobile') }),
                    search: true,
                    selectOnBlur: false,
                    value: this.state.mobilePrefix
                  })
                ),
                _react2.default.createElement(_PhoneInput2.default, {
                  autoComplete: 'off',
                  name: 'mobile',
                  onChange: this.handleOnChange,
                  placeholder: this.state.mobilePrefix === '60' ? t('Mobile') + '* (e.g. 196756118)' : t('Mobile') + '*',
                  label: this.state.mobilePrefix === '60' ? t('Mobile') + '* (e.g. 196756118)' : t('Mobile') + '*',
                  prefix: this.state.mobilePrefix,
                  ref: this.validation.mobile,
                  type: 'tel',
                  validation: [_webValidations.required, {
                    validate: _webValidations.phoneNumber,
                    option: this.state.mobilePrefix === 'other' ? {} : {
                      isMobile: true,
                      phonePrefix: this.state.mobilePrefix,
                      validRegex: (0, _phone.getPhoneValidRegex)(this.state.phoneValidationPresets, this.state.mobilePrefix, 'mobile')
                    }
                  }],
                  value: this.state.mobile,
                  validateLabel: t('Mobile')
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, negative: true, onClick: this.handleOnClose, icon: 'cancel', content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }), inverted: true }),
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, positive: true, onClick: this.handleOnComfirm, icon: 'checkmark', content: t('Invite'), inverted: true })
        )
      );
    }
  }]);

  return InviteBankerForm;
}(_react.Component);

InviteBankerForm.contextTypes = {
  store: _propTypes2.default.object
};
InviteBankerForm.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  bankOnCheck: _propTypes2.default.func,
  banks: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  })
};

InviteBankerForm.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    banks: state.banks
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.getBanksOptions = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this4.props;
    var banks = props.banks,
        bankOnCheck = props.bankOnCheck;

    var banksOptions = banks.data.map(function (bank) {
      return {
        value: bank.id,
        text: bank.name,
        disabled: bankOnCheck ? bankOnCheck(bank) : false
      };
    });
    var available = banksOptions.filter(function (b) {
      return !b.disabled;
    });
    var bankID = available.length > 0 ? available[0].value : 0;
    _this4.setState({ banksOptions: banksOptions, bankID: bankID });
  };

  this.resetData = function () {
    var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
    var defaultCountryPhoneCode = _this4.state.defaultCountryPhoneCode;

    _this4.setState({
      mobilePrefix: defaultCountryPhoneCode,
      mobile: '',
      name: '',
      bankID: 0
    }, cb);
  };

  this.handleSubmit = function (event) {
    event.preventDefault();
    var _state = _this4.state,
        name = _state.name,
        bankID = _state.bankID,
        mobile = _state.mobile,
        mobilePrefix = _state.mobilePrefix;

    var banker = {
      name: name,
      bankID: bankID.toString(),
      mobilePrefix: mobilePrefix,
      mobile: mobile
    };
    return _AppForm2.default.validate(_this4.validation, banker).then(function (validations) {
      _this4.setState({
        errMessages: validations.filter(function (v) {
          return !v.isValid;
        })
      });
      if (_this4.props.onConfirm) {
        _this4.props.onConfirm(event, validations, banker);
      }
    });
  };

  this.handleOnClose = function (e) {
    if (_this4.props.onClose) {
      _this4.props.onClose(e);
    }
  };

  this.handleOnComfirm = function (e) {
    e.preventDefault();
    _this4.form.handleSubmit(event);
  };

  this.handleOnChange = function (e, _ref3) {
    var name = _ref3.name,
        value = _ref3.value;

    _this4.setState(_defineProperty({}, name, value));
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })((0, _reactRedux.connect)(InviteBankerForm.mapStateToProps)(InviteBankerForm));

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ModalNotice = function (_Component) {
  _inherits(ModalNotice, _Component);

  function ModalNotice() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ModalNotice);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalNotice.__proto__ || Object.getPrototypeOf(ModalNotice)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ModalNotice, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.open !== nextProps.open) {
        return true;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          size: 'small',
          open: this.props.open === true,
          onClose: this.handleOnClose
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: this.props.icon || undefined, content: this.props.headerNode || 'Notice' }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            this.props.content
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleOnClose, content: 'Close' })
        )
      );
    }
  }]);

  return ModalNotice;
}(_react.Component);

ModalNotice.contextTypes = {
  store: _propTypes2.default.object
};
ModalNotice.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  headerNode: _propTypes2.default.node,
  content: _propTypes2.default.node,
  icon: _propTypes2.default.string
};
exports.default = ModalNotice;

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable camelcase */


var RemoveMedia = function (_Component) {
  _inherits(RemoveMedia, _Component);

  function RemoveMedia() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RemoveMedia);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RemoveMedia.__proto__ || Object.getPrototypeOf(RemoveMedia)).call.apply(_ref, [this].concat(args))), _this), _this.getThumbnailUrl = function () {
      var media = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

      if (media && media.data && media.data.thumbnail_url) {
        return media.data.thumbnail_url;
      }
      return '';
    }, _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    }, _this.handleOnConfirm = function (e) {
      e.preventDefault();
      if (_this.props.onConfirm) {
        _this.props.onConfirm(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RemoveMedia, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (JSON.stringify(this.props.media) !== JSON.stringify(nextProps.media) || JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data) || this.props.open !== nextProps.open) {
        return true;
      }
      return false;
    }
  }, {
    key: 'renderWarning',
    value: function renderWarning() {
      var _props = this.props,
          media = _props.media,
          t = _props.t;

      if (this.props.type === 'delete' && media) {
        if (media.projects || media.unitLayouts) {
          var projectLength = media.projects ? media.projects.length : 0;
          var layoutLength = media.unitLayouts ? media.unitLayouts.length : 0;
          return _react2.default.createElement(
            'h3',
            null,
            t('This video is used in {{count}} place(s).', { ns: _translation.TRANSLATION_FILES.translation, count: projectLength + layoutLength })
          );
        }
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      var thumbnailUrl = this.getThumbnailUrl();
      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          basic: true,
          open: this.props.open === true,
          onClose: this.handleOnClose
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: this.props.headerNode || t('Confirm ' + (this.props.type || 'remove') + '?', { ns: _translation.TRANSLATION_FILES.translation }) }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { image: true },
          _react2.default.createElement(_LoadImage2.default, {
            wrapped: true,
            src: thumbnailUrl
          }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            this.renderWarning(),
            _react2.default.createElement(
              'h3',
              null,
              t('Are you sure to ' + (this.props.type || 'remove') + ' this video', { ns: _translation.TRANSLATION_FILES.translation }),
              this.props.type !== 'delete' && this.props.data ? ' ' + t('from', { ns: _translation.TRANSLATION_FILES.screens }) + ' ' + this.props.data.name : '',
              '?'
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, negative: true, onClick: this.handleOnClose, icon: 'cancel', content: t('No', { ns: _translation.TRANSLATION_FILES.constants }), inverted: true }),
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, positive: true, onClick: this.handleOnConfirm, icon: this.props.type === 'delete' ? 'trash' : 'checkmark', content: t('Yes', { ns: _translation.TRANSLATION_FILES.constants }), inverted: true })
        )
      );
    }
  }]);

  return RemoveMedia;
}(_react.Component);

RemoveMedia.contextTypes = {
  store: _propTypes2.default.object
};
RemoveMedia.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  t: _propTypes2.default.func,
  media: _propTypes2.default.shape({
    url: _propTypes2.default.string,
    projects: _propTypes2.default.array,
    unitLayouts: _propTypes2.default.array,
    data: _propTypes2.default.shape({
      thumbnail_url: _propTypes2.default.string,
      thumbnail_url_with_play_button: _propTypes2.default.string
    })
  }),
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  headerNode: _propTypes2.default.node,
  type: _propTypes2.default.oneOf(['delete', 'remove'])
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(RemoveMedia);

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RemovePicture = function (_Component) {
  _inherits(RemovePicture, _Component);

  function RemovePicture() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RemovePicture);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RemovePicture.__proto__ || Object.getPrototypeOf(RemovePicture)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    }, _this.handleOnComfirm = function (e) {
      e.preventDefault();
      if (_this.props.onConfirm) {
        _this.props.onConfirm(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RemovePicture, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (JSON.stringify(this.props.picture) !== JSON.stringify(nextProps.picture) || JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data) || this.props.open !== nextProps.open) {
        return true;
      }
      return false;
    }
  }, {
    key: 'renderWarning',
    value: function renderWarning() {
      var _props = this.props,
          picture = _props.picture,
          t = _props.t;

      if (this.props.type === 'delete' && picture) {
        if (picture.projects || picture.unitLayouts) {
          var projectLength = picture.projects ? picture.projects.length : 0;
          var layoutLength = picture.unitLayouts ? picture.unitLayouts.length : 0;
          return _react2.default.createElement(
            'h3',
            null,
            t('This {{section}} is used in {{count}} place(s).', { section: t('Picture'), count: projectLength + layoutLength })
          );
        }
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          basic: true,
          open: this.props.open === true,
          onClose: this.handleOnClose
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: this.props.headerNode || t('Confirm ' + (this.props.type || 'remove')) + '?' }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { image: true },
          _react2.default.createElement(_LoadImage2.default, {
            wrapped: true,
            picture: this.props.picture,
            pictureSize: this.props.pictureSize,
            extension: this.props.extension
          }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            this.renderWarning(),
            _react2.default.createElement(
              'h3',
              null,
              t('Are you sure to delete this picture') + ' ' + (this.props.type !== 'delete' && this.props.data ? ' ' + t('from') + ' ' + this.props.data.name : '') + '?'
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, negative: true, onClick: this.handleOnClose, icon: 'cancel', content: t('No'), inverted: true }),
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, positive: true, onClick: this.handleOnComfirm, icon: this.props.type === 'delete' ? 'trash' : 'checkmark', content: t('Yes'), inverted: true })
        )
      );
    }
  }]);

  return RemovePicture;
}(_react.Component);

RemovePicture.contextTypes = {
  store: _propTypes2.default.object
};
RemovePicture.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  picture: _propTypes2.default.shape({
    key: _propTypes2.default.string,
    projects: _propTypes2.default.array,
    unitLayouts: _propTypes2.default.array
  }),
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  headerNode: _propTypes2.default.node,
  type: _propTypes2.default.oneOf(['delete', 'remove']),
  pictureSize: _propTypes2.default.number,
  extension: _propTypes2.default.string,
  t: _propTypes2.default.func
};
RemovePicture.defaultProps = {
  pictureSize: 30
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(RemovePicture);

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCountryName = getCountryName;

var _countries = __webpack_require__(60);

var _countries2 = _interopRequireDefault(_countries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCountryName(countryCode) {
  var country = _countries2.default.find(function (c) {
    return c.countryCode === countryCode;
  });
  if (country && country.name) {
    return country.name;
  }
  return '';
}

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDisplayCurrencySymbol = exports.calcConversionAmount = exports.getDisplayCurrency = exports.getCompanyBaseCurrency = undefined;
exports.getCurrencySettingFormat = getCurrencySettingFormat;

var _jsCookie = __webpack_require__(247);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getCompanyBaseCurrency = exports.getCompanyBaseCurrency = function getCompanyBaseCurrency() {
  var companyObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _companyObj$companyCu = companyObj.companyCurrency,
      companyCurrency = _companyObj$companyCu === undefined ? [] : _companyObj$companyCu;

  return companyCurrency.find(function (e) {
    return e.isDefault;
  }) || { err: true };
};

var getDisplayCurrency = exports.getDisplayCurrency = function getDisplayCurrency() {
  return _jsCookie2.default.get('currency');
};

var calcConversionAmount = exports.calcConversionAmount = function calcConversionAmount() {
  var companyCurrencyInProject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var displayCurrencyInProject = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var projectBaseCurrency = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var amount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var totalAmount = amount;

  var convertedAmount = totalAmount;

  // fallback if no currency set
  if (!companyCurrencyInProject || !projectBaseCurrency) return totalAmount;

  if (companyCurrencyInProject.code !== projectBaseCurrency.code) {
    // If company base currency dont match project base currency
    convertedAmount /= companyCurrencyInProject.conversionRatePoint / 1000;
  }
  if (projectBaseCurrency.code !== displayCurrencyInProject.code) {
    // If project base currency dont match display currency
    if (displayCurrencyInProject.conversionRatePoint) {
      convertedAmount *= displayCurrencyInProject.conversionRatePoint / 1000;
    } else {
      // Currency for display is not set in project level
      convertedAmount = '-';
    }
  }
  return convertedAmount;
};

var getDisplayCurrencySymbol = exports.getDisplayCurrencySymbol = function getDisplayCurrencySymbol() {
  var appConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  var cookieCurrency = _jsCookie2.default.get('currency');
  if (!cookieCurrency) {
    // fallback if currency is not in cookies (most likely due to company did not setup currency)
    return (appConfig && appConfig.data && appConfig.data.currency && appConfig.data.currency.symbol) + ' ';
  }
  return cookieCurrency + ' ';
};

var defaultCurrencySetting = {
  displayDecimal: true,
  isAbbreviationEnabled: false,
  abbreviationDecimalPoints: 2,
  decimalSeparator: '.',
  thousandsSeparator: ',',
  millionsSeparator: ',',
  billionsSeparator: ','
};

var translateAbbreviation = function translateAbbreviation(abb, countryCode) {
  // for country Indonesia only
  if (countryCode === 'id') {
    switch (abb) {
      case 'M':
        return 'Juta';
      case 'B':
        return 'Miliar';
      default:
        return abb;
    }
  }
  return abb;
};

var getAbbreviationFormat = function getAbbreviationFormat(amountWOCArr, dp, countryCode) {
  var abbSplice = -3;
  var abbreviation = 'K';

  if (amountWOCArr.length > 6 && amountWOCArr.length <= 9) {
    abbSplice = -6;
    abbreviation = 'M';
  } else if (amountWOCArr.length > 9) {
    abbSplice = -9;
    abbreviation = 'B';
  }

  amountWOCArr.splice(abbSplice, 0, '.');
  var a = amountWOCArr.join('');
  var splits = a.split('.');

  if (dp <= 0) {
    return '' + splits[0] + abbreviation;
  }

  var sb = splits[1].split('');
  if (sb.length > dp) {
    sb = sb.splice(0, dp);
  } else if (sb.length < dp) {
    var maxLength = 3;
    if (abbreviation === 'M') maxLength = 6;
    if (abbreviation === 'B') maxLength = 9;
    var fillLength = dp <= maxLength ? dp - sb.length : maxLength - sb.length;
    sb = [].concat(_toConsumableArray(sb), _toConsumableArray(Array(fillLength).fill('0')));
  }
  var translatedAbb = translateAbbreviation(abbreviation, countryCode);
  return splits[0] + '.' + sb.join('') + translatedAbb;
};

// getCurrencySettingFormat returns amount in currency setting format
function getCurrencySettingFormat() {
  var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var currencySetting = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultCurrencySetting;
  var countryCode = arguments[2];

  var cs = currencySetting && currencySetting.id ? currencySetting : defaultCurrencySetting;
  var displayDecimal = cs.displayDecimal,
      isAbbreviationEnabled = cs.isAbbreviationEnabled,
      abbreviationDecimalPoints = cs.abbreviationDecimalPoints,
      ds = cs.decimalSeparator,
      ts = cs.thousandsSeparator,
      ms = cs.millionsSeparator,
      bs = cs.billionsSeparator;

  var fullAmount = amount.toString();

  var amountSplits = fullAmount.split('.');
  var amountWOcents = amountSplits[0].toString();
  var cents = amountSplits.length > 1 ? amountSplits[1].toString() : '00';
  var lenAmountWOcents = amountWOcents.length;

  var a = amountWOcents.split('');
  if (isAbbreviationEnabled && lenAmountWOcents > 3) {
    return getAbbreviationFormat(a, abbreviationDecimalPoints, countryCode);
  } else if (lenAmountWOcents > 3 && lenAmountWOcents <= 6) {
    a.splice(-3, 0, ts);
  } else if (lenAmountWOcents > 6 && lenAmountWOcents <= 9) {
    a.splice(-6, 0, ms);
    a.splice(-3, 0, ts);
  } else if (lenAmountWOcents > 9) {
    a.splice(-9, 0, bs);
    a.splice(-6, 0, ms);
    a.splice(-3, 0, ts);
  }
  fullAmount = a.join('');

  if (displayDecimal) {
    fullAmount = '' + fullAmount + ds + cents;
  }

  return fullAmount;
}

/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = dateFromIC;
function dateFromIC(icDate) {
  var yymmdd = "" + icDate;
  if (yymmdd.length !== 6) {
    return false;
  }
  var year = yymmdd.substring(0, 2) - 0;
  var month = yymmdd.substring(2, 4);
  var day = yymmdd.substring(4, 6);
  if (year <= ("" + new Date().getFullYear()).substring(2, 4)) {
    year += 2000;
  } else {
    year += 1900;
  }
  return year + "-" + month + "-" + day;
}

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var initializeDisplayLanguage = exports.initializeDisplayLanguage = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(i18n, fallback, readPreference, isActive) {
    var started, language;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            started = revision;
            language = fallback;
            _context.prev = 2;
            _context.next = 5;
            return readPreference();

          case 5:
            _context.t0 = _context.sent;

            if (_context.t0) {
              _context.next = 8;
              break;
            }

            _context.t0 = fallback;

          case 8:
            language = _context.t0;
            _context.next = 14;
            break;

          case 11:
            _context.prev = 11;
            _context.t1 = _context["catch"](2);

            Bugsnag.notifyException(_context.t1);

          case 14:
            if (!(started === revision && isActive())) {
              _context.next = 17;
              break;
            }

            _context.next = 17;
            return changeDisplayLanguage(i18n, language);

          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this, [[2, 11]]);
  }));

  return function initializeDisplayLanguage(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

exports.changeDisplayLanguage = changeDisplayLanguage;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// Serialize resource loads within this tab; an older load must never finish last.
var revision = 0;
var changes = Promise.resolve();
function changeDisplayLanguage(i18n, language) {
  revision += 1;
  var selected = revision;
  var pending = changes.then(function () {
    if (selected === revision) return i18n.changeLanguage(language);
    return undefined;
  });
  changes = pending.catch(function (error) {
    Bugsnag.notifyException(error);
  });
  return changes;
}

/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canAccessRestrictedModule = canAccessRestrictedModule;
exports.restrictedModuleAccess = restrictedModuleAccess;

var _vietnam = __webpack_require__(40);

// Role flags applied on top of a module definition so that the module matches
// only the roles allowed above. The keys mirror the flags used by the module
// filters in BookDash and AppFooter.
var VIETNAM_RESTRICTED_MODULE_ACCESS = {
  isBranchLeader: false,
  isBranchLeaderSupervisorII: false,
  isDeveloper: false,
  isSiteplan: false,
  isDeveloperSupervisor: false,
  isHeadquarters: true,
  isSuperAdmin: true,
  isAdminBasic: true,
  isAdminCommunity: true,
  isDeveloperSalesManager: false,
  isDeveloperSalesAdmin: false
};

function hasVietnamRestrictedModuleAccess() {
  var auth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return Boolean(auth.isSuperAdmin || auth.isAdminBasic || auth.isAdminCommunity || auth.isHeadquarters);
}

// canAccessRestrictedModule tells whether Payments, Bankers and Reports may be
// reached by the signed in user.
function canAccessRestrictedModule() {
  var auth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!(0, _vietnam.isVietnamCompany)(auth)) {
    return true;
  }
  return hasVietnamRestrictedModuleAccess(auth);
}

// restrictedModuleAccess returns the role flag overrides to merge into a module
// definition, or null when the company is not affected.
function restrictedModuleAccess() {
  var auth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return (0, _vietnam.isVietnamCompany)(auth) ? VIETNAM_RESTRICTED_MODULE_ACCESS : null;
}

/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSvgDocument = getSvgDocument;
exports.checkIsMHubUnit = checkIsMHubUnit;
exports.checkSvgFormatValid = checkSvgFormatValid;
exports.displaySVG = displaySVG;
var SVGNS = 'http://www.w3.org/2000/svg';
var XLINKNS = 'http://www.w3.org/1999/xlink';

function getSvgDocument(data) {
  var doc = new DOMParser();
  return doc.parseFromString(data, 'image/svg+xml');
}

function checkIsMHubUnit(id) {
  if (id) {
    if (id.startsWith('mhub-ref:') || id.startsWith('mhub-id:')) {
      return true;
    }
  }
  return false;
}

function checkSvgFormatValid(data) {
  var xml = getSvgDocument(data);
  var svg = xml.getElementById('mhub-svg');
  if (svg) {
    var mainGroup = xml.getElementById('mhub-site-plan');
    if (mainGroup) {
      if (mainGroup.parentNode === svg) {
        var unitGroup = xml.getElementById('mhub-units');
        if (unitGroup) {
          if (unitGroup.parentNode === mainGroup) {
            return true;
          }
        }
      }
    }
  }
  return false;
}

function displaySVG(data, imgURL) {
  var dataIsString = typeof data === 'string';
  var xml = dataIsString ? getSvgDocument(data) : data;
  var svgElements = xml.getElementsByTagName('svg');
  if (svgElements.length > 0) {
    var svg = svgElements[0];
    if (imgURL) {
      // get svg width height
      var svgWidth = svg.getAttribute('width');
      var svgHeight = svg.getAttribute('height');
      var svgViewBox = svg.getAttribute('viewBox');
      if (svgViewBox) {
        var viewBox = svgViewBox.split(' ');
        svgWidth = viewBox[2];
        svgHeight = viewBox[3];
      }
      // set img
      var svgImg = xml.getElementById('mhub-svg-img');
      if (!svgImg) {
        // use createElementNS to create svg element
        svgImg = xml.createElementNS(SVGNS, 'image');
        svgImg.setAttribute('id', 'mhub-svg-img');

        var siteplan = xml.getElementById('mhub-site-plan');
        if (siteplan) {
          siteplan.insertBefore(svgImg, siteplan.firstChild);
        }
      }
      if (svgImg) {
        svgImg.setAttribute('href', imgURL);
        svgImg.setAttributeNS(XLINKNS, 'xlink:href', imgURL);
        svgImg.setAttribute('xmlns:xlink', XLINKNS);
        svgImg.setAttribute('x', 0);
        svgImg.setAttribute('y', 0);
        svgImg.setAttribute('width', svgWidth);
        svgImg.setAttribute('height', svgHeight);
        svgImg.setAttribute('style', 'opacity:0.75;');
      }
    }
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', '100%');
  }
  var result = xml.documentElement.outerHTML;
  if (dataIsString) {
    result = data.slice(0, data.indexOf('<svg'));
    result += xml.documentElement.outerHTML;
  }
  return result;
}

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1097);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(2595);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(2594);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

var r;

module.exports = function rand(len) {
  if (!r)
    r = new Rand(null);

  return r.generate(len);
};

function Rand(rand) {
  this.rand = rand;
}
module.exports.Rand = Rand;

Rand.prototype.generate = function generate(len) {
  return this._rand(len);
};

// Emulate crypto API using randy
Rand.prototype._rand = function _rand(n) {
  if (this.rand.getBytes)
    return this.rand.getBytes(n);

  var res = new Uint8Array(n);
  for (var i = 0; i < res.length; i++)
    res[i] = this.rand.getByte();
  return res;
};

if (typeof self === 'object') {
  if (self.crypto && self.crypto.getRandomValues) {
    // Modern browsers
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.crypto.getRandomValues(arr);
      return arr;
    };
  } else if (self.msCrypto && self.msCrypto.getRandomValues) {
    // IE
    Rand.prototype._rand = function _rand(n) {
      var arr = new Uint8Array(n);
      self.msCrypto.getRandomValues(arr);
      return arr;
    };

  // Safari's WebWorkers do not have `crypto`
  } else if (typeof window === 'object') {
    // Old junk
    Rand.prototype._rand = function() {
      throw new Error('Not implemented yet');
    };
  }
} else {
  // Node.js or Web worker with no crypto support
  try {
    var crypto = __webpack_require__(3561);
    if (typeof crypto.randomBytes !== 'function')
      throw new Error('Not supported');

    Rand.prototype._rand = function _rand(n) {
      return crypto.randomBytes(n);
    };
  } catch (e) {
  }
}


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

var ciphers = __webpack_require__(2601)
var deciphers = __webpack_require__(2600)
var modes = __webpack_require__(1101)

function getCiphers () {
  return Object.keys(modes)
}

exports.createCipher = exports.Cipher = ciphers.createCipher
exports.createCipheriv = exports.Cipheriv = ciphers.createCipheriv
exports.createDecipher = exports.Decipher = deciphers.createDecipher
exports.createDecipheriv = exports.Decipheriv = deciphers.createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var modeModules = {
  ECB: __webpack_require__(2607),
  CBC: __webpack_require__(2603),
  CFB: __webpack_require__(2604),
  CFB8: __webpack_require__(2606),
  CFB1: __webpack_require__(2605),
  OFB: __webpack_require__(2608),
  CTR: __webpack_require__(1100),
  GCM: __webpack_require__(1100)
}

var modes = __webpack_require__(1101)

for (var key in modes) {
  modes[key].module = modeModules[modes[key].mode]
}

module.exports = modes


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var bn = __webpack_require__(77);
var randomBytes = __webpack_require__(286);
module.exports = crt;
function blind(priv) {
  var r = getr(priv);
  var blinder = r.toRed(bn.mont(priv.modulus))
  .redPow(new bn(priv.publicExponent)).fromRed();
  return {
    blinder: blinder,
    unblinder:r.invm(priv.modulus)
  };
}
function crt(msg, priv) {
  var blinds = blind(priv);
  var len = priv.modulus.byteLength();
  var mod = bn.mont(priv.modulus);
  var blinded = new bn(msg).mul(blinds.blinder).umod(priv.modulus);
  var c1 = blinded.toRed(bn.mont(priv.prime1));
  var c2 = blinded.toRed(bn.mont(priv.prime2));
  var qinv = priv.coefficient;
  var p = priv.prime1;
  var q = priv.prime2;
  var m1 = c1.redPow(priv.exponent1);
  var m2 = c2.redPow(priv.exponent2);
  m1 = m1.fromRed();
  m2 = m2.fromRed();
  var h = m1.isub(m2).imul(qinv).umod(p);
  h.imul(q);
  m2.iadd(h);
  return new Buffer(m2.imul(blinds.unblinder).umod(priv.modulus).toArray(false, len));
}
crt.getr = getr;
function getr(priv) {
  var len = priv.modulus.byteLength();
  var r = new bn(randomBytes(len));
  while (r.cmp(priv.modulus) >=  0 || !r.umod(priv.prime1) || !r.umod(priv.prime2)) {
    r = new bn(randomBytes(len));
  }
  return r;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75).Buffer))

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;


/***/ }),
/* 604 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 605 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 606 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(329);
var dPs = __webpack_require__(2648);
var enumBugKeys = __webpack_require__(605);
var IE_PROTO = __webpack_require__(610)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(1112)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(2642).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 608 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(229).f;
var has = __webpack_require__(228);
var TAG = __webpack_require__(275)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(611)('keys');
var uid = __webpack_require__(411);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(176);
var global = __webpack_require__(177);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(407) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 612 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(604);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(273);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(177);
var core = __webpack_require__(176);
var LIBRARY = __webpack_require__(407);
var wksExt = __webpack_require__(616);
var defineProperty = __webpack_require__(229).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(275);


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__(633)(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

var toObject = __webpack_require__(99);
var toAbsoluteIndex = __webpack_require__(237);
var toLength = __webpack_require__(73);
module.exports = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var aLen = arguments.length;
  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
  var end = aLen > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(83);
var createDesc = __webpack_require__(236);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(53);
var document = __webpack_require__(52).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 621 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__(67)('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(52).document;
module.exports = document && document.documentElement;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(53);
var setPrototypeOf = __webpack_require__(631).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(277);
var ITERATOR = __webpack_require__(67)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__(53);
var cof = __webpack_require__(178);
var MATCH = __webpack_require__(67)('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(231);
var $export = __webpack_require__(17);
var redefine = __webpack_require__(119);
var hide = __webpack_require__(131);
var Iterators = __webpack_require__(277);
var $iterCreate = __webpack_require__(1131);
var setToStringTag = __webpack_require__(280);
var getPrototypeOf = __webpack_require__(234);
var ITERATOR = __webpack_require__(67)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 628 */
/***/ (function(module, exports) {

// 20.2.2.14 Math.expm1(x)
var $expm1 = Math.expm1;
module.exports = (!$expm1
  // Old FF bug
  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
  // Tor Browser bug
  || $expm1(-2e-17) != -2e-17
) ? function expm1(x) {
  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
} : $expm1;


/***/ }),
/* 629 */
/***/ (function(module, exports) {

// 20.2.2.28 Math.sign(x)
module.exports = Math.sign || function sign(x) {
  // eslint-disable-next-line no-self-compare
  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
};


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__(415);

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(53);
var anObject = __webpack_require__(50);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(160)(Function.call, __webpack_require__(161).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(421)('keys');
var uid = __webpack_require__(238);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(163);
var defined = __webpack_require__(179);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__(626);
var defined = __webpack_require__(179);

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toInteger = __webpack_require__(163);
var defined = __webpack_require__(179);

module.exports = function repeat(count) {
  var str = String(defined(this));
  var res = '';
  var n = toInteger(count);
  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
  return res;
};


/***/ }),
/* 636 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(160);
var invoke = __webpack_require__(1128);
var html = __webpack_require__(623);
var cel = __webpack_require__(620);
var global = __webpack_require__(52);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(178)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(52);
var DESCRIPTORS = __webpack_require__(82);
var LIBRARY = __webpack_require__(231);
var $typed = __webpack_require__(422);
var hide = __webpack_require__(131);
var redefineAll = __webpack_require__(278);
var fails = __webpack_require__(51);
var anInstance = __webpack_require__(276);
var toInteger = __webpack_require__(163);
var toLength = __webpack_require__(73);
var toIndex = __webpack_require__(1146);
var gOPN = __webpack_require__(233).f;
var dP = __webpack_require__(83).f;
var arrayFill = __webpack_require__(618);
var setToStringTag = __webpack_require__(280);
var ARRAY_BUFFER = 'ArrayBuffer';
var DATA_VIEW = 'DataView';
var PROTOTYPE = 'prototype';
var WRONG_LENGTH = 'Wrong length!';
var WRONG_INDEX = 'Wrong index!';
var $ArrayBuffer = global[ARRAY_BUFFER];
var $DataView = global[DATA_VIEW];
var Math = global.Math;
var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
var Infinity = global.Infinity;
var BaseBuffer = $ArrayBuffer;
var abs = Math.abs;
var pow = Math.pow;
var floor = Math.floor;
var log = Math.log;
var LN2 = Math.LN2;
var BUFFER = 'buffer';
var BYTE_LENGTH = 'byteLength';
var BYTE_OFFSET = 'byteOffset';
var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
function packIEEE754(value, mLen, nBytes) {
  var buffer = new Array(nBytes);
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
  var i = 0;
  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
  var e, m, c;
  value = abs(value);
  // eslint-disable-next-line no-self-compare
  if (value != value || value === Infinity) {
    // eslint-disable-next-line no-self-compare
    m = value != value ? 1 : 0;
    e = eMax;
  } else {
    e = floor(log(value) / LN2);
    if (value * (c = pow(2, -e)) < 1) {
      e--;
      c *= 2;
    }
    if (e + eBias >= 1) {
      value += rt / c;
    } else {
      value += rt * pow(2, 1 - eBias);
    }
    if (value * c >= 2) {
      e++;
      c /= 2;
    }
    if (e + eBias >= eMax) {
      m = 0;
      e = eMax;
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * pow(2, mLen);
      e = e + eBias;
    } else {
      m = value * pow(2, eBias - 1) * pow(2, mLen);
      e = 0;
    }
  }
  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
  e = e << mLen | m;
  eLen += mLen;
  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
  buffer[--i] |= s * 128;
  return buffer;
}
function unpackIEEE754(buffer, mLen, nBytes) {
  var eLen = nBytes * 8 - mLen - 1;
  var eMax = (1 << eLen) - 1;
  var eBias = eMax >> 1;
  var nBits = eLen - 7;
  var i = nBytes - 1;
  var s = buffer[i--];
  var e = s & 127;
  var m;
  s >>= 7;
  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
  m = e & (1 << -nBits) - 1;
  e >>= -nBits;
  nBits += mLen;
  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
  if (e === 0) {
    e = 1 - eBias;
  } else if (e === eMax) {
    return m ? NaN : s ? -Infinity : Infinity;
  } else {
    m = m + pow(2, mLen);
    e = e - eBias;
  } return (s ? -1 : 1) * m * pow(2, e - mLen);
}

function unpackI32(bytes) {
  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
}
function packI8(it) {
  return [it & 0xff];
}
function packI16(it) {
  return [it & 0xff, it >> 8 & 0xff];
}
function packI32(it) {
  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
}
function packF64(it) {
  return packIEEE754(it, 52, 8);
}
function packF32(it) {
  return packIEEE754(it, 23, 4);
}

function addGetter(C, key, internal) {
  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
}

function get(view, bytes, index, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = store.slice(start, start + bytes);
  return isLittleEndian ? pack : pack.reverse();
}
function set(view, bytes, index, conversion, value, isLittleEndian) {
  var numIndex = +index;
  var intIndex = toIndex(numIndex);
  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
  var store = view[$BUFFER]._b;
  var start = intIndex + view[$OFFSET];
  var pack = conversion(+value);
  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
}

if (!$typed.ABV) {
  $ArrayBuffer = function ArrayBuffer(length) {
    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
    var byteLength = toIndex(length);
    this._b = arrayFill.call(new Array(byteLength), 0);
    this[$LENGTH] = byteLength;
  };

  $DataView = function DataView(buffer, byteOffset, byteLength) {
    anInstance(this, $DataView, DATA_VIEW);
    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
    var bufferLength = buffer[$LENGTH];
    var offset = toInteger(byteOffset);
    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
    this[$BUFFER] = buffer;
    this[$OFFSET] = offset;
    this[$LENGTH] = byteLength;
  };

  if (DESCRIPTORS) {
    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
    addGetter($DataView, BUFFER, '_b');
    addGetter($DataView, BYTE_LENGTH, '_l');
    addGetter($DataView, BYTE_OFFSET, '_o');
  }

  redefineAll($DataView[PROTOTYPE], {
    getInt8: function getInt8(byteOffset) {
      return get(this, 1, byteOffset)[0] << 24 >> 24;
    },
    getUint8: function getUint8(byteOffset) {
      return get(this, 1, byteOffset)[0];
    },
    getInt16: function getInt16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
    },
    getUint16: function getUint16(byteOffset /* , littleEndian */) {
      var bytes = get(this, 2, byteOffset, arguments[1]);
      return bytes[1] << 8 | bytes[0];
    },
    getInt32: function getInt32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1]));
    },
    getUint32: function getUint32(byteOffset /* , littleEndian */) {
      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
    },
    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
    },
    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
    },
    setInt8: function setInt8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setUint8: function setUint8(byteOffset, value) {
      set(this, 1, byteOffset, packI8, value);
    },
    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
      set(this, 2, byteOffset, packI16, value, arguments[2]);
    },
    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packI32, value, arguments[2]);
    },
    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
      set(this, 4, byteOffset, packF32, value, arguments[2]);
    },
    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
      set(this, 8, byteOffset, packF64, value, arguments[2]);
    }
  });
} else {
  if (!fails(function () {
    $ArrayBuffer(1);
  }) || !fails(function () {
    new $ArrayBuffer(-1); // eslint-disable-line no-new
  }) || fails(function () {
    new $ArrayBuffer(); // eslint-disable-line no-new
    new $ArrayBuffer(1.5); // eslint-disable-line no-new
    new $ArrayBuffer(NaN); // eslint-disable-line no-new
    return $ArrayBuffer.name != ARRAY_BUFFER;
  })) {
    $ArrayBuffer = function ArrayBuffer(length) {
      anInstance(this, $ArrayBuffer);
      return new BaseBuffer(toIndex(length));
    };
    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
    }
    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
  }
  // iOS Safari 7.x bug
  var view = new $DataView(new $ArrayBuffer(2));
  var $setInt8 = $DataView[PROTOTYPE].setInt8;
  view.setInt8(0, 2147483648);
  view.setInt8(1, 2147483649);
  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
    setInt8: function setInt8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    },
    setUint8: function setUint8(byteOffset, value) {
      $setInt8.call(this, byteOffset, value << 24 >> 24);
    }
  }, true);
}
setToStringTag($ArrayBuffer, ARRAY_BUFFER);
setToStringTag($DataView, DATA_VIEW);
hide($DataView[PROTOTYPE], $typed.VIEW, true);
exports[ARRAY_BUFFER] = $ArrayBuffer;
exports[DATA_VIEW] = $DataView;


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(67);


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(331);
var ITERATOR = __webpack_require__(67)('iterator');
var Iterators = __webpack_require__(277);
module.exports = __webpack_require__(78).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(230);
var step = __webpack_require__(1132);
var Iterators = __webpack_require__(277);
var toIObject = __webpack_require__(132);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(627)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(240));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function (Math) {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var Hasher = C_lib.Hasher;
	    var C_algo = C.algo;

	    // Initialization and round constants tables
	    var H = [];
	    var K = [];

	    // Compute constants
	    (function () {
	        function isPrime(n) {
	            var sqrtN = Math.sqrt(n);
	            for (var factor = 2; factor <= sqrtN; factor++) {
	                if (!(n % factor)) {
	                    return false;
	                }
	            }

	            return true;
	        }

	        function getFractionalBits(n) {
	            return ((n - (n | 0)) * 0x100000000) | 0;
	        }

	        var n = 2;
	        var nPrime = 0;
	        while (nPrime < 64) {
	            if (isPrime(n)) {
	                if (nPrime < 8) {
	                    H[nPrime] = getFractionalBits(Math.pow(n, 1 / 2));
	                }
	                K[nPrime] = getFractionalBits(Math.pow(n, 1 / 3));

	                nPrime++;
	            }

	            n++;
	        }
	    }());

	    // Reusable object
	    var W = [];

	    /**
	     * SHA-256 hash algorithm.
	     */
	    var SHA256 = C_algo.SHA256 = Hasher.extend({
	        _doReset: function () {
	            this._hash = new WordArray.init(H.slice(0));
	        },

	        _doProcessBlock: function (M, offset) {
	            // Shortcut
	            var H = this._hash.words;

	            // Working variables
	            var a = H[0];
	            var b = H[1];
	            var c = H[2];
	            var d = H[3];
	            var e = H[4];
	            var f = H[5];
	            var g = H[6];
	            var h = H[7];

	            // Computation
	            for (var i = 0; i < 64; i++) {
	                if (i < 16) {
	                    W[i] = M[offset + i] | 0;
	                } else {
	                    var gamma0x = W[i - 15];
	                    var gamma0  = ((gamma0x << 25) | (gamma0x >>> 7))  ^
	                                  ((gamma0x << 14) | (gamma0x >>> 18)) ^
	                                   (gamma0x >>> 3);

	                    var gamma1x = W[i - 2];
	                    var gamma1  = ((gamma1x << 15) | (gamma1x >>> 17)) ^
	                                  ((gamma1x << 13) | (gamma1x >>> 19)) ^
	                                   (gamma1x >>> 10);

	                    W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16];
	                }

	                var ch  = (e & f) ^ (~e & g);
	                var maj = (a & b) ^ (a & c) ^ (b & c);

	                var sigma0 = ((a << 30) | (a >>> 2)) ^ ((a << 19) | (a >>> 13)) ^ ((a << 10) | (a >>> 22));
	                var sigma1 = ((e << 26) | (e >>> 6)) ^ ((e << 21) | (e >>> 11)) ^ ((e << 7)  | (e >>> 25));

	                var t1 = h + sigma1 + ch + K[i] + W[i];
	                var t2 = sigma0 + maj;

	                h = g;
	                g = f;
	                f = e;
	                e = (d + t1) | 0;
	                d = c;
	                c = b;
	                b = a;
	                a = (t1 + t2) | 0;
	            }

	            // Intermediate hash value
	            H[0] = (H[0] + a) | 0;
	            H[1] = (H[1] + b) | 0;
	            H[2] = (H[2] + c) | 0;
	            H[3] = (H[3] + d) | 0;
	            H[4] = (H[4] + e) | 0;
	            H[5] = (H[5] + f) | 0;
	            H[6] = (H[6] + g) | 0;
	            H[7] = (H[7] + h) | 0;
	        },

	        _doFinalize: function () {
	            // Shortcuts
	            var data = this._data;
	            var dataWords = data.words;

	            var nBitsTotal = this._nDataBytes * 8;
	            var nBitsLeft = data.sigBytes * 8;

	            // Add padding
	            dataWords[nBitsLeft >>> 5] |= 0x80 << (24 - nBitsLeft % 32);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 14] = Math.floor(nBitsTotal / 0x100000000);
	            dataWords[(((nBitsLeft + 64) >>> 9) << 4) + 15] = nBitsTotal;
	            data.sigBytes = dataWords.length * 4;

	            // Hash final blocks
	            this._process();

	            // Return final computed hash
	            return this._hash;
	        },

	        clone: function () {
	            var clone = Hasher.clone.call(this);
	            clone._hash = this._hash.clone();

	            return clone;
	        }
	    });

	    /**
	     * Shortcut function to the hasher's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     *
	     * @return {WordArray} The hash.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hash = CryptoJS.SHA256('message');
	     *     var hash = CryptoJS.SHA256(wordArray);
	     */
	    C.SHA256 = Hasher._createHelper(SHA256);

	    /**
	     * Shortcut function to the HMAC's object interface.
	     *
	     * @param {WordArray|string} message The message to hash.
	     * @param {WordArray|string} key The secret key.
	     *
	     * @return {WordArray} The HMAC.
	     *
	     * @static
	     *
	     * @example
	     *
	     *     var hmac = CryptoJS.HmacSHA256(message, key);
	     */
	    C.HmacSHA256 = Hasher._createHmacHelper(SHA256);
	}(Math));


	return CryptoJS.SHA256;

}));

/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(137);

function Cipher(options) {
  this.options = options;

  this.type = this.options.type;
  this.blockSize = 8;
  this._init();

  this.buffer = new Array(this.blockSize);
  this.bufferOff = 0;
}
module.exports = Cipher;

Cipher.prototype._init = function _init() {
  // Might be overrided
};

Cipher.prototype.update = function update(data) {
  if (data.length === 0)
    return [];

  if (this.type === 'decrypt')
    return this._updateDecrypt(data);
  else
    return this._updateEncrypt(data);
};

Cipher.prototype._buffer = function _buffer(data, off) {
  // Append data to buffer
  var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
  for (var i = 0; i < min; i++)
    this.buffer[this.bufferOff + i] = data[off + i];
  this.bufferOff += min;

  // Shift next
  return min;
};

Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
  this._update(this.buffer, 0, out, off);
  this.bufferOff = 0;
  return this.blockSize;
};

Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = ((this.bufferOff + data.length) / this.blockSize) | 0;
  var out = new Array(count * this.blockSize);

  if (this.bufferOff !== 0) {
    inputOff += this._buffer(data, inputOff);

    if (this.bufferOff === this.buffer.length)
      outputOff += this._flushBuffer(out, outputOff);
  }

  // Write blocks
  var max = data.length - ((data.length - inputOff) % this.blockSize);
  for (; inputOff < max; inputOff += this.blockSize) {
    this._update(data, inputOff, out, outputOff);
    outputOff += this.blockSize;
  }

  // Queue rest
  for (; inputOff < data.length; inputOff++, this.bufferOff++)
    this.buffer[this.bufferOff] = data[inputOff];

  return out;
};

Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
  var inputOff = 0;
  var outputOff = 0;

  var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
  var out = new Array(count * this.blockSize);

  // TODO(indutny): optimize it, this is far from optimal
  for (; count > 0; count--) {
    inputOff += this._buffer(data, inputOff);
    outputOff += this._flushBuffer(out, outputOff);
  }

  // Buffer rest of the input
  inputOff += this._buffer(data, inputOff);

  return out;
};

Cipher.prototype.final = function final(buffer) {
  var first;
  if (buffer)
    first = this.update(buffer);

  var last;
  if (this.type === 'encrypt')
    last = this._finalEncrypt();
  else
    last = this._finalDecrypt();

  if (first)
    return first.concat(last);
  else
    return last;
};

Cipher.prototype._pad = function _pad(buffer, off) {
  if (off === 0)
    return false;

  while (off < buffer.length)
    buffer[off++] = 0;

  return true;
};

Cipher.prototype._finalEncrypt = function _finalEncrypt() {
  if (!this._pad(this.buffer, this.bufferOff))
    return [];

  var out = new Array(this.blockSize);
  this._update(this.buffer, 0, out, 0);
  return out;
};

Cipher.prototype._unpad = function _unpad(buffer) {
  return buffer;
};

Cipher.prototype._finalDecrypt = function _finalDecrypt() {
  assert.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
  var out = new Array(this.blockSize);
  this._flushBuffer(out, 0);

  return this._unpad(out);
};


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var BlockMapBuilder = __webpack_require__(337);

var CharacterMetadata = __webpack_require__(133);

var ContentBlock = __webpack_require__(241);

var ContentBlockNode = __webpack_require__(134);

var DraftEntity = __webpack_require__(424);

var SelectionState = __webpack_require__(425);

var generateRandomKey = __webpack_require__(164);

var getOwnObjectValues = __webpack_require__(1179);

var gkx = __webpack_require__(203);

var Immutable = __webpack_require__(46);

var sanitizeDraftText = __webpack_require__(1193);

var List = Immutable.List,
    Record = Immutable.Record,
    Repeat = Immutable.Repeat,
    ImmutableMap = Immutable.Map,
    OrderedMap = Immutable.OrderedMap;
var defaultRecord = {
  entityMap: null,
  blockMap: null,
  selectionBefore: null,
  selectionAfter: null
};
var ContentStateRecord = Record(defaultRecord);
/* $FlowFixMe[signature-verification-failure] Supressing a `signature-
 * verification-failure` error here. TODO: T65949050 Clean up the branch for
 * this GK */

var ContentBlockNodeRecord = gkx('draft_tree_data_support') ? ContentBlockNode : ContentBlock;

var ContentState = /*#__PURE__*/function (_ContentStateRecord) {
  _inheritsLoose(ContentState, _ContentStateRecord);

  function ContentState() {
    return _ContentStateRecord.apply(this, arguments) || this;
  }

  var _proto = ContentState.prototype;

  _proto.getEntityMap = function getEntityMap() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity;
  };

  _proto.getBlockMap = function getBlockMap() {
    return this.get('blockMap');
  };

  _proto.getSelectionBefore = function getSelectionBefore() {
    return this.get('selectionBefore');
  };

  _proto.getSelectionAfter = function getSelectionAfter() {
    return this.get('selectionAfter');
  };

  _proto.getBlockForKey = function getBlockForKey(key) {
    var block = this.getBlockMap().get(key);
    return block;
  };

  _proto.getKeyBefore = function getKeyBefore(key) {
    return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  _proto.getKeyAfter = function getKeyAfter(key) {
    return this.getBlockMap().keySeq().skipUntil(function (v) {
      return v === key;
    }).skip(1).first();
  };

  _proto.getBlockAfter = function getBlockAfter(key) {
    return this.getBlockMap().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  _proto.getBlockBefore = function getBlockBefore(key) {
    return this.getBlockMap().reverse().skipUntil(function (_, k) {
      return k === key;
    }).skip(1).first();
  };

  _proto.getBlocksAsArray = function getBlocksAsArray() {
    return this.getBlockMap().toArray();
  };

  _proto.getFirstBlock = function getFirstBlock() {
    return this.getBlockMap().first();
  };

  _proto.getLastBlock = function getLastBlock() {
    return this.getBlockMap().last();
  };

  _proto.getPlainText = function getPlainText(delimiter) {
    return this.getBlockMap().map(function (block) {
      return block ? block.getText() : '';
    }).join(delimiter || '\n');
  };

  _proto.getLastCreatedEntityKey = function getLastCreatedEntityKey() {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity.__getLastCreatedEntityKey();
  };

  _proto.hasText = function hasText() {
    var blockMap = this.getBlockMap();
    return blockMap.size > 1 || // make sure that there are no zero width space chars
    escape(blockMap.first().getText()).replace(/%u200B/g, '').length > 0;
  };

  _proto.createEntity = function createEntity(type, mutability, data) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__create(type, mutability, data);

    return this;
  };

  _proto.mergeEntityData = function mergeEntityData(key, toMerge) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__mergeData(key, toMerge);

    return this;
  };

  _proto.replaceEntityData = function replaceEntityData(key, newData) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__replaceData(key, newData);

    return this;
  };

  _proto.addEntity = function addEntity(instance) {
    // TODO: update this when we fully remove DraftEntity
    DraftEntity.__add(instance);

    return this;
  };

  _proto.getEntity = function getEntity(key) {
    // TODO: update this when we fully remove DraftEntity
    return DraftEntity.__get(key);
  };

  _proto.getAllEntities = function getAllEntities() {
    return DraftEntity.__getAll();
  };

  _proto.loadWithEntities = function loadWithEntities(entities) {
    return DraftEntity.__loadWithEntities(entities);
  };

  ContentState.createFromBlockArray = function createFromBlockArray( // TODO: update flow type when we completely deprecate the old entity API
  blocks, entityMap) {
    // TODO: remove this when we completely deprecate the old entity API
    var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks;
    var blockMap = BlockMapBuilder.createFromArray(theBlocks);
    var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
    return new ContentState({
      blockMap: blockMap,
      entityMap: entityMap || DraftEntity,
      selectionBefore: selectionState,
      selectionAfter: selectionState
    });
  };

  ContentState.createFromText = function createFromText(text) {
    var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\r\n?|\n/g;
    var strings = text.split(delimiter);
    var blocks = strings.map(function (block) {
      block = sanitizeDraftText(block);
      return new ContentBlockNodeRecord({
        key: generateRandomKey(),
        text: block,
        type: 'unstyled',
        characterList: List(Repeat(CharacterMetadata.EMPTY, block.length))
      });
    });
    return ContentState.createFromBlockArray(blocks);
  };

  ContentState.fromJS = function fromJS(state) {
    return new ContentState(_objectSpread({}, state, {
      blockMap: OrderedMap(state.blockMap).map(ContentState.createContentBlockFromJS),
      selectionBefore: new SelectionState(state.selectionBefore),
      selectionAfter: new SelectionState(state.selectionAfter)
    }));
  };

  ContentState.createContentBlockFromJS = function createContentBlockFromJS(block) {
    var characterList = block.characterList;
    return new ContentBlockNodeRecord(_objectSpread({}, block, {
      data: ImmutableMap(block.data),
      characterList: characterList != null ? List((Array.isArray(characterList) ? characterList : getOwnObjectValues(characterList)).map(function (c) {
        return CharacterMetadata.fromJS(c);
      })) : undefined
    }));
  };

  return ContentState;
}(ContentStateRecord);

module.exports = ContentState;

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var React = __webpack_require__(0);

var cx = __webpack_require__(244);

var _require = __webpack_require__(46),
    Map = _require.Map;

var UL_WRAP = React.createElement("ul", {
  className: cx('public/DraftStyleDefault/ul')
});
var OL_WRAP = React.createElement("ol", {
  className: cx('public/DraftStyleDefault/ol')
});
var PRE_WRAP = React.createElement("pre", {
  className: cx('public/DraftStyleDefault/pre')
});
var DefaultDraftBlockRenderMap = Map({
  'header-one': {
    element: 'h1'
  },
  'header-two': {
    element: 'h2'
  },
  'header-three': {
    element: 'h3'
  },
  'header-four': {
    element: 'h4'
  },
  'header-five': {
    element: 'h5'
  },
  'header-six': {
    element: 'h6'
  },
  section: {
    element: 'section'
  },
  article: {
    element: 'article'
  },
  'unordered-list-item': {
    element: 'li',
    wrapper: UL_WRAP
  },
  'ordered-list-item': {
    element: 'li',
    wrapper: OL_WRAP
  },
  blockquote: {
    element: 'blockquote'
  },
  atomic: {
    element: 'figure'
  },
  'code-block': {
    element: 'pre',
    wrapper: PRE_WRAP
  },
  unstyled: {
    element: 'div',
    aliasedElements: ['p']
  }
});
module.exports = DefaultDraftBlockRenderMap;

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UserAgent = __webpack_require__(106);

var isSoftNewlineEvent = __webpack_require__(2907);

var isOSX = UserAgent.isPlatform('Mac OS X');
var KeyBindingUtil = {
  /**
   * Check whether the ctrlKey modifier is *not* being used in conjunction with
   * the altKey modifier. If they are combined, the result is an `altGraph`
   * key modifier, which should not be handled by this set of key bindings.
   */
  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
    return !!e.ctrlKey && !e.altKey;
  },
  isOptionKeyCommand: function isOptionKeyCommand(e) {
    return isOSX && e.altKey;
  },
  usesMacOSHeuristics: function usesMacOSHeuristics() {
    return isOSX;
  },
  hasCommandModifier: function hasCommandModifier(e) {
    return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
  },
  isSoftNewlineEvent: isSoftNewlineEvent
};
module.exports = KeyBindingUtil;

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var _require = __webpack_require__(1171),
    notEmptyKey = _require.notEmptyKey;
/**
 * Return the entity key that should be used when inserting text for the
 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
 * and `SEGMENTED` entities should not be used for insertion behavior.
 */


function getEntityKeyForSelection(contentState, targetSelection) {
  var entityKey;

  if (targetSelection.isCollapsed()) {
    var key = targetSelection.getAnchorKey();
    var offset = targetSelection.getAnchorOffset();

    if (offset > 0) {
      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);

      if (entityKey !== contentState.getBlockForKey(key).getEntityAt(offset)) {
        return null;
      }

      return filterKey(contentState.getEntityMap(), entityKey);
    }

    return null;
  }

  var startKey = targetSelection.getStartKey();
  var startOffset = targetSelection.getStartOffset();
  var startBlock = contentState.getBlockForKey(startKey);
  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);
  return filterKey(contentState.getEntityMap(), entityKey);
}
/**
 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
 * return it. If not, return null.
 */


function filterKey(entityMap, entityKey) {
  if (notEmptyKey(entityKey)) {
    var entity = entityMap.__get(entityKey);

    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
  }

  return null;
}

module.exports = getEntityKeyForSelection;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var warning = __webpack_require__(652);
/**
 * Given a collapsed selection, move the focus `maxDistance` backward within
 * the selected block. If the selection will go beyond the start of the block,
 * move focus to the end of the previous block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */


function moveSelectionBackward(editorState, maxDistance) {
  var selection = editorState.getSelection(); // Should eventually make this an invariant

   false ? warning(selection.isCollapsed(), 'moveSelectionBackward should only be called with a collapsed SelectionState') : void 0;
  var content = editorState.getCurrentContent();
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();
  var focusKey = key;
  var focusOffset = 0;

  if (maxDistance > offset) {
    var keyBefore = content.getKeyBefore(key);

    if (keyBefore == null) {
      focusKey = key;
    } else {
      focusKey = keyBefore;
      var blockBefore = content.getBlockForKey(keyBefore);
      focusOffset = blockBefore.getText().length;
    }
  } else {
    focusOffset = offset - maxDistance;
  }

  return selection.merge({
    focusKey: focusKey,
    focusOffset: focusOffset,
    isBackward: true
  });
}

module.exports = moveSelectionBackward;

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * @param {DOMElement} element
 * @param {DOMDocument} doc
 * @return {boolean}
 */
function _isViewportScrollElement(element, doc) {
  return !!doc && (element === doc.documentElement || element === doc.body);
}
/**
 * Scroll Module. This class contains 4 simple static functions
 * to be used to access Element.scrollTop/scrollLeft properties.
 * To solve the inconsistencies between browsers when either
 * document.body or document.documentElement is supplied,
 * below logic will be used to alleviate the issue:
 *
 * 1. If 'element' is either 'document.body' or 'document.documentElement,
 *    get whichever element's 'scroll{Top,Left}' is larger.
 * 2. If 'element' is either 'document.body' or 'document.documentElement',
 *    set the 'scroll{Top,Left}' on both elements.
 */


var Scroll = {
  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getTop: function getTop(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ? // In practice, they will either both have the same value,
    // or one will be zero and the other will be the scroll position
    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newTop
   */
  setTop: function setTop(element, newTop) {
    var doc = element.ownerDocument;

    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
    } else {
      element.scrollTop = newTop;
    }
  },

  /**
   * @param {DOMElement} element
   * @return {number}
   */
  getLeft: function getLeft(element) {
    var doc = element.ownerDocument;
    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
  },

  /**
   * @param {DOMElement} element
   * @param {number} newLeft
   */
  setLeft: function setLeft(element, newLeft) {
    var doc = element.ownerDocument;

    if (_isViewportScrollElement(element, doc)) {
      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
    } else {
      element.scrollLeft = newLeft;
    }
  }
};
module.exports = Scroll;

/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Basic (stateless) API for text direction detection
 *
 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */


var UnicodeBidiDirection = __webpack_require__(432);

var invariant = __webpack_require__(48);

/**
 * RegExp ranges of characters with a *Strong* Bidi_Class value.
 *
 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
 *
 * NOTE: For performance reasons, we only support Unicode's
 *       Basic Multilingual Plane (BMP) for now.
 */
var RANGE_BY_BIDI_TYPE = {
  L: "A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB" + "\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8" + "\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377" + "\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1" + "\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559" + "\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D" + "\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965" + "\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C" + "\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD" + "\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD" + "\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03" + "\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33" + "\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F" + "\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0" + "\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0" + "\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10" + "\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40" + "\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F" + "\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95" + "\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9" + "\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7" + "\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10" + "\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61" + "\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8" + "\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6" + "\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF" + "\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D" + "\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61" + "\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96" + "\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF" + "\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45" + "\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88" + "\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7" + "\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6" + "\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14" + "\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38" + "\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C" + "\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8" + "\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F" + "\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061" + "\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081" + "\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C" + "\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC" + "\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288" + "\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5" + "\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368" + "\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E" + "\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0" + "\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736" + "\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5" + "\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9" + "\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA" + "\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931" + "\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB" + "\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16" + "\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64" + "\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD" + "\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B" + "\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0" + "\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7" + "\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B" + "\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59" + "\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1" + "\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B" + "\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15" + "\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D" + "\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC" + "\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E" + "\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D" + "\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139" + "\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184" + "\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF" + "\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4" + "\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F" + "\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE" + "\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007" + "\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C" + "\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF" + "\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F" + "\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247" + "\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB" + "\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5" + "\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD" + "\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B" + "\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF" + "\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E" + "\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801" + "\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835" + "\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3" + "\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909" + "\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C" + "\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD" + "\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF" + "\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34" + "\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F" + "\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1" + "\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF" + "\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5" + "\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E" + "\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4" + "\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3" + "\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9" + "\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70" + "\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF" + "\uFFD2-\uFFD7\uFFDA-\uFFDC",
  R: "\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF" + "\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA" + "\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828" + "\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E" + "\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C" + "\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F",
  AL: "\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640" + "\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6" + "\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F" + "\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF" + "\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2" + "\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7" + "\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75" + "\uFE76-\uFEFC\uFEFD-\uFEFE"
};
var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
/**
 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     A character with strong bidi direction, or null if not found
 */

function firstStrongChar(str) {
  var match = REGEX_STRONG.exec(str);
  return match == null ? null : match[0];
}
/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL).
 *
 * @param str  A text block; e.g. paragraph, table cell, tag
 * @return     The resolved direction
 */


function firstStrongCharDir(str) {
  var strongChar = firstStrongChar(str);

  if (strongChar == null) {
    return UnicodeBidiDirection.NEUTRAL;
  }

  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection.RTL : UnicodeBidiDirection.LTR;
}
/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str       A text block; e.g. paragraph, table cell, tag
 * @param fallback  Fallback direction, used if no strong direction detected
 *                  for the block (default = NEUTRAL)
 * @return          The resolved direction
 */


function resolveBlockDir(str, fallback) {
  fallback = fallback || UnicodeBidiDirection.NEUTRAL;

  if (!str.length) {
    return fallback;
  }

  var blockDir = firstStrongCharDir(str);
  return blockDir === UnicodeBidiDirection.NEUTRAL ? fallback : blockDir;
}
/**
 * Returns the direction of a block of text, based on the direction of its
 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
 * direction, if no strong character is found.
 *
 * NOTE: This function is similar to resolveBlockDir(), but uses the global
 * direction as the fallback, so it *always* returns a Strong direction,
 * making it useful for integration in places that you need to make the final
 * decision, like setting some CSS class.
 *
 * This function is supposed to be used in respect to Higher-Level Protocol
 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                The resolved Strong direction
 */


function getDirection(str, strongFallback) {
  if (!strongFallback) {
    strongFallback = UnicodeBidiDirection.getGlobalDir();
  }

  !UnicodeBidiDirection.isStrong(strongFallback) ?  false ? invariant(false, 'Fallback direction must be a strong direction') : invariant(false) : void 0;
  return resolveBlockDir(str, strongFallback);
}
/**
 * Returns true if getDirection(arguments...) returns LTR.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is LTR
 */


function isDirectionLTR(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection.LTR;
}
/**
 * Returns true if getDirection(arguments...) returns RTL.
 *
 * @param str             A text block; e.g. paragraph, table cell
 * @param strongFallback  Fallback direction, used if no strong direction
 *                        detected for the block (default = global direction)
 * @return                True if the resolved direction is RTL
 */


function isDirectionRTL(str, strongFallback) {
  return getDirection(str, strongFallback) === UnicodeBidiDirection.RTL;
}

var UnicodeBidi = {
  firstStrongChar: firstStrongChar,
  firstStrongCharDir: firstStrongCharDir,
  resolveBlockDir: resolveBlockDir,
  getDirection: getDirection,
  isDirectionLTR: isDirectionLTR,
  isDirectionRTL: isDirectionRTL
};
module.exports = UnicodeBidi;

/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var isTextNode = __webpack_require__(2937);
/*eslint-disable no-bitwise */

/**
 * Checks if a given DOM node contains or is another DOM node.
 */


function containsNode(outerNode, innerNode) {
  if (!outerNode || !innerNode) {
    return false;
  } else if (outerNode === innerNode) {
    return true;
  } else if (isTextNode(outerNode)) {
    return false;
  } else if (isTextNode(innerNode)) {
    return containsNode(outerNode, innerNode.parentNode);
  } else if ('contains' in outerNode) {
    return outerNode.contains(innerNode);
  } else if (outerNode.compareDocumentPosition) {
    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
  } else {
    return false;
  }
}

module.exports = containsNode;

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var emptyFunction = __webpack_require__(1195);
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */


function printWarning(format) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var argIndex = 0;
  var message = 'Warning: ' + format.replace(/%s/g, function () {
    return args[argIndex++];
  });

  if (typeof console !== 'undefined') {
    console.error(message);
  }

  try {
    // --- Welcome to debugging React ---
    // This error was thrown as a convenience so that you can use this stack
    // to find the callsite that caused this warning to fire.
    throw new Error(message);
  } catch (x) {}
}

var warning =  false ? function (condition, format) {
  if (format === undefined) {
    throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
  }

  if (!condition) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
      args[_key2 - 2] = arguments[_key2];
    }

    printWarning.apply(void 0, [format].concat(args));
  }
} : emptyFunction;
module.exports = warning;

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elliptic = exports;

elliptic.version = __webpack_require__(2953).version;
elliptic.utils = __webpack_require__(135);
elliptic.rand = __webpack_require__(599);
elliptic.curve = __webpack_require__(1199);
elliptic.curves = __webpack_require__(654);

// Protocols
elliptic.ec = __webpack_require__(2946);
elliptic.eddsa = __webpack_require__(2949);


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curves = exports;

var hash = __webpack_require__(670);
var curve = __webpack_require__(1199);
var utils = __webpack_require__(135);

var assert = utils.assert;

function PresetCurve(options) {
  if (options.type === 'short')
    this.curve = new curve.short(options);
  else if (options.type === 'edwards')
    this.curve = new curve.edwards(options);
  else
    this.curve = new curve.mont(options);
  this.g = this.curve.g;
  this.n = this.curve.n;
  this.hash = options.hash;

  assert(this.g.validate(), 'Invalid curve');
  assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
curves.PresetCurve = PresetCurve;

function defineCurve(name, options) {
  Object.defineProperty(curves, name, {
    configurable: true,
    enumerable: true,
    get: function() {
      var curve = new PresetCurve(options);
      Object.defineProperty(curves, name, {
        configurable: true,
        enumerable: true,
        value: curve,
      });
      return curve;
    },
  });
}

defineCurve('p192', {
  type: 'short',
  prime: 'p192',
  p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
  b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
  n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
  hash: hash.sha256,
  gRed: false,
  g: [
    '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
    '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811',
  ],
});

defineCurve('p224', {
  type: 'short',
  prime: 'p224',
  p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
  a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
  b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
  n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
  hash: hash.sha256,
  gRed: false,
  g: [
    'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
    'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34',
  ],
});

defineCurve('p256', {
  type: 'short',
  prime: null,
  p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
  a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
  b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
  n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
  hash: hash.sha256,
  gRed: false,
  g: [
    '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
    '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5',
  ],
});

defineCurve('p384', {
  type: 'short',
  prime: null,
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 ffffffff',
  a: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'fffffffe ffffffff 00000000 00000000 fffffffc',
  b: 'b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f ' +
     '5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef',
  n: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 ' +
     'f4372ddf 581a0db2 48b0a77a ecec196a ccc52973',
  hash: hash.sha384,
  gRed: false,
  g: [
    'aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 ' +
    '5502f25d bf55296c 3a545e38 72760ab7',
    '3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 ' +
    '0a60b1ce 1d7e819d 7a431d7c 90ea0e5f',
  ],
});

defineCurve('p521', {
  type: 'short',
  prime: null,
  p: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff',
  a: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff ffffffff ffffffff fffffffc',
  b: '00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b ' +
     '99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd ' +
     '3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00',
  n: '000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ' +
     'ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 ' +
     'f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409',
  hash: hash.sha512,
  gRed: false,
  g: [
    '000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 ' +
    '053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 ' +
    'a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66',
    '00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 ' +
    '579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 ' +
    '3fad0761 353c7086 a272c240 88be9476 9fd16650',
  ],
});

defineCurve('curve25519', {
  type: 'mont',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '76d06',
  b: '1',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '9',
  ],
});

defineCurve('ed25519', {
  type: 'edwards',
  prime: 'p25519',
  p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
  a: '-1',
  c: '1',
  // -121665 * (121666^(-1)) (mod P)
  d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
  n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
  hash: hash.sha256,
  gRed: false,
  g: [
    '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',

    // 4/5
    '6666666666666666666666666666666666666666666666666666666666666658',
  ],
});

var pre;
try {
  pre = __webpack_require__(2952);
} catch (e) {
  pre = undefined;
}

defineCurve('secp256k1', {
  type: 'short',
  prime: 'k256',
  p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
  a: '0',
  b: '7',
  n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
  h: '1',
  hash: hash.sha256,

  // Precomputed endomorphism
  beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
  lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
  basis: [
    {
      a: '3086d221a7d46bcde86c90e49284eb15',
      b: '-e4437ed6010e88286f547fa90abfe4c3',
    },
    {
      a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
      b: '3086d221a7d46bcde86c90e49284eb15',
    },
  ],

  gRed: false,
  g: [
    '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
    '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
    pre,
  ],
});


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $Object = __webpack_require__(1200);

var $Error = __webpack_require__(2956);
var $EvalError = __webpack_require__(2955);
var $RangeError = __webpack_require__(2957);
var $ReferenceError = __webpack_require__(2958);
var $SyntaxError = __webpack_require__(2959);
var $TypeError = __webpack_require__(282);
var $URIError = __webpack_require__(2960);

var abs = __webpack_require__(3103);
var floor = __webpack_require__(3104);
var max = __webpack_require__(3106);
var min = __webpack_require__(3107);
var pow = __webpack_require__(3108);
var round = __webpack_require__(3109);
var sign = __webpack_require__(3110);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(1203);
var $defineProperty = __webpack_require__(2954);

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(2999)();

var getProto = __webpack_require__(2965);
var $ObjectGPO = __webpack_require__(1201);
var $ReflectGPO = __webpack_require__(1202);

var $apply = __webpack_require__(1105);
var $call = __webpack_require__(603);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(436);
var hasOwn = __webpack_require__(3007);
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GraphQLError", {
  enumerable: true,
  get: function get() {
    return _GraphQLError.GraphQLError;
  }
});
Object.defineProperty(exports, "syntaxError", {
  enumerable: true,
  get: function get() {
    return _syntaxError.syntaxError;
  }
});
Object.defineProperty(exports, "locatedError", {
  enumerable: true,
  get: function get() {
    return _locatedError.locatedError;
  }
});
Object.defineProperty(exports, "printError", {
  enumerable: true,
  get: function get() {
    return _printError.printError;
  }
});
Object.defineProperty(exports, "formatError", {
  enumerable: true,
  get: function get() {
    return _formatError.formatError;
  }
});

var _GraphQLError = __webpack_require__(37);

var _syntaxError = __webpack_require__(2969);

var _locatedError = __webpack_require__(657);

var _printError = __webpack_require__(1204);

var _formatError = __webpack_require__(2968);

/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.locatedError = locatedError;

var _GraphQLError = __webpack_require__(37);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Given an arbitrary Error, presumably thrown while attempting to execute a
 * GraphQL operation, produce a new GraphQLError aware of the location in the
 * document responsible for the original Error.
 */
function locatedError(originalError, nodes, path) {
  // Note: this uses a brand-check to support GraphQL errors originating from
  // other contexts.
  if (originalError && Array.isArray(originalError.path)) {
    return originalError;
  }

  return new _GraphQLError.GraphQLError(originalError && originalError.message, originalError && originalError.nodes || nodes, originalError && originalError.source, originalError && originalError.positions, path, originalError);
}

/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVariableValues = getVariableValues;
exports.getArgumentValues = getArgumentValues;
exports.getDirectiveValues = getDirectiveValues;

var _GraphQLError = __webpack_require__(37);

var _find = _interopRequireDefault(__webpack_require__(342));

var _inspect = _interopRequireDefault(__webpack_require__(93));

var _invariant = _interopRequireDefault(__webpack_require__(108));

var _keyMap = _interopRequireDefault(__webpack_require__(183));

var _coerceValue = __webpack_require__(666);

var _typeFromAST = __webpack_require__(185);

var _valueFromAST = __webpack_require__(442);

var _kinds = __webpack_require__(68);

var _printer = __webpack_require__(165);

var _definition = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Prepares an object map of variableValues of the correct type based on the
 * provided variable definitions and arbitrary input. If the input cannot be
 * parsed to match the variable definitions, a GraphQLError will be thrown.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 */
function getVariableValues(schema, varDefNodes, inputs) {
  var errors = [];
  var coercedValues = {};

  for (var i = 0; i < varDefNodes.length; i++) {
    var varDefNode = varDefNodes[i];
    var varName = varDefNode.variable.name.value;
    var varType = (0, _typeFromAST.typeFromAST)(schema, varDefNode.type);

    if (!(0, _definition.isInputType)(varType)) {
      // Must use input types for variables. This should be caught during
      // validation, however is checked again here for safety.
      errors.push(new _GraphQLError.GraphQLError("Variable \"$".concat(varName, "\" expected value of type ") + "\"".concat((0, _printer.print)(varDefNode.type), "\" which cannot be used as an input type."), [varDefNode.type]));
    } else {
      var hasValue = hasOwnProperty(inputs, varName);
      var value = hasValue ? inputs[varName] : undefined;

      if (!hasValue && varDefNode.defaultValue) {
        // If no value was provided to a variable with a default value,
        // use the default value.
        coercedValues[varName] = (0, _valueFromAST.valueFromAST)(varDefNode.defaultValue, varType);
      } else if ((!hasValue || value === null) && (0, _definition.isNonNullType)(varType)) {
        // If no value or a nullish value was provided to a variable with a
        // non-null type (required), produce an error.
        errors.push(new _GraphQLError.GraphQLError(hasValue ? "Variable \"$".concat(varName, "\" of non-null type ") + "\"".concat((0, _inspect.default)(varType), "\" must not be null.") : "Variable \"$".concat(varName, "\" of required type ") + "\"".concat((0, _inspect.default)(varType), "\" was not provided."), [varDefNode]));
      } else if (hasValue) {
        if (value === null) {
          // If the explicit value `null` was provided, an entry in the coerced
          // values must exist as the value `null`.
          coercedValues[varName] = null;
        } else {
          // Otherwise, a non-null value was provided, coerce it to the expected
          // type or report an error if coercion fails.
          var coerced = (0, _coerceValue.coerceValue)(value, varType, varDefNode);
          var coercionErrors = coerced.errors;

          if (coercionErrors) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = coercionErrors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var error = _step.value;
                error.message = "Variable \"$".concat(varName, "\" got invalid ") + "value ".concat((0, _inspect.default)(value), "; ").concat(error.message);
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }

            errors.push.apply(errors, coercionErrors);
          } else {
            coercedValues[varName] = coerced.value;
          }
        }
      }
    }
  }

  return errors.length === 0 ? {
    errors: undefined,
    coerced: coercedValues
  } : {
    errors: errors,
    coerced: undefined
  };
}
/**
 * Prepares an object map of argument values given a list of argument
 * definitions and list of argument AST nodes.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 */


function getArgumentValues(def, node, variableValues) {
  var coercedValues = {};
  var argDefs = def.args;
  var argNodes = node.arguments;

  if (!argDefs || !argNodes) {
    return coercedValues;
  }

  var argNodeMap = (0, _keyMap.default)(argNodes, function (arg) {
    return arg.name.value;
  });

  for (var i = 0; i < argDefs.length; i++) {
    var argDef = argDefs[i];
    var name = argDef.name;
    var argType = argDef.type;
    var argumentNode = argNodeMap[name];
    var hasValue = void 0;
    var isNull = void 0;

    if (argumentNode && argumentNode.value.kind === _kinds.Kind.VARIABLE) {
      var variableName = argumentNode.value.name.value;
      hasValue = variableValues && hasOwnProperty(variableValues, variableName);
      isNull = variableValues && variableValues[variableName] === null;
    } else {
      hasValue = argumentNode != null;
      isNull = argumentNode && argumentNode.value.kind === _kinds.Kind.NULL;
    }

    if (!hasValue && argDef.defaultValue !== undefined) {
      // If no argument was provided where the definition has a default value,
      // use the default value.
      coercedValues[name] = argDef.defaultValue;
    } else if ((!hasValue || isNull) && (0, _definition.isNonNullType)(argType)) {
      // If no argument or a null value was provided to an argument with a
      // non-null type (required), produce a field error.
      if (isNull) {
        throw new _GraphQLError.GraphQLError("Argument \"".concat(name, "\" of non-null type \"").concat((0, _inspect.default)(argType), "\" ") + 'must not be null.', [argumentNode.value]);
      } else if (argumentNode && argumentNode.value.kind === _kinds.Kind.VARIABLE) {
        var _variableName = argumentNode.value.name.value;
        throw new _GraphQLError.GraphQLError("Argument \"".concat(name, "\" of required type \"").concat((0, _inspect.default)(argType), "\" ") + "was provided the variable \"$".concat(_variableName, "\" ") + 'which was not provided a runtime value.', [argumentNode.value]);
      } else {
        throw new _GraphQLError.GraphQLError("Argument \"".concat(name, "\" of required type \"").concat((0, _inspect.default)(argType), "\" ") + 'was not provided.', [node]);
      }
    } else if (hasValue) {
      if (argumentNode.value.kind === _kinds.Kind.NULL) {
        // If the explicit value `null` was provided, an entry in the coerced
        // values must exist as the value `null`.
        coercedValues[name] = null;
      } else if (argumentNode.value.kind === _kinds.Kind.VARIABLE) {
        var _variableName2 = argumentNode.value.name.value;
        !variableValues ? (0, _invariant.default)(0, 'Must exist for hasValue to be true.') : void 0; // Note: This does no further checking that this variable is correct.
        // This assumes that this query has been validated and the variable
        // usage here is of the correct type.

        coercedValues[name] = variableValues[_variableName2];
      } else {
        var valueNode = argumentNode.value;
        var coercedValue = (0, _valueFromAST.valueFromAST)(valueNode, argType, variableValues);

        if (coercedValue === undefined) {
          // Note: ValuesOfCorrectType validation should catch this before
          // execution. This is a runtime check to ensure execution does not
          // continue with an invalid argument value.
          throw new _GraphQLError.GraphQLError("Argument \"".concat(name, "\" has invalid value ").concat((0, _printer.print)(valueNode), "."), [argumentNode.value]);
        }

        coercedValues[name] = coercedValue;
      }
    }
  }

  return coercedValues;
}
/**
 * Prepares an object map of argument values given a directive definition
 * and a AST node which may contain directives. Optionally also accepts a map
 * of variable values.
 *
 * If the directive does not exist on the node, returns undefined.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 */


function getDirectiveValues(directiveDef, node, variableValues) {
  var directiveNode = node.directives && (0, _find.default)(node.directives, function (directive) {
    return directive.name.value === directiveDef.name;
  });

  if (directiveNode) {
    return getArgumentValues(directiveDef, directiveNode, variableValues);
  }
}

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */
// See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
var _default =  true ? // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
  return value instanceof constructor;
} : // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
  if (value instanceof constructor) {
    return true;
  }

  if (value) {
    var valueClass = value.constructor;
    var className = constructor.name;

    if (className && valueClass && valueClass.name === className) {
      throw new Error("Cannot use ".concat(className, " \"").concat(value, "\" from another module or realm.\n\nEnsure that there is only one instance of \"graphql\" in the node_modules\ndirectory. If different versions of \"graphql\" are the dependencies of other\nrelied on modules, use \"resolutions\" to ensure only one version is installed.\n\nhttps://yarnpkg.com/en/docs/selective-version-resolutions\n\nDuplicate \"graphql\" modules cannot be used at the same time since different\nversions may have different capabilities and behavior. The data from one\nversion used in the function from another could produce confusing and\nspurious results."));
    }
  }

  return false;
};

exports.default = _default;

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isNullish;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Returns true if a value is null, undefined, or NaN.
 */
function isNullish(value) {
  return value === null || value === undefined || value !== value;
}

/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = orList;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
var MAX_LENGTH = 5;
/**
 * Given [ A, B, C ] return 'A, B, or C'.
 */

function orList(items) {
  var selected = items.slice(0, MAX_LENGTH);
  return selected.reduce(function (list, quoted, index) {
    return list + (selected.length > 2 ? ', ' : ' ') + (index === selected.length - 1 ? 'or ' : '') + quoted;
  });
}

/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = quotedOrList;

var _orList = _interopRequireDefault(__webpack_require__(661));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Given [ A, B, C ] return '"A", "B", or "C"'.
 */
function quotedOrList(items) {
  return (0, _orList.default)(items.map(function (item) {
    return "\"".concat(item, "\"");
  }));
}

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createLexer = createLexer;
exports.getTokenDesc = getTokenDesc;
exports.TokenKind = void 0;

var _error = __webpack_require__(656);

var _blockStringValue = _interopRequireDefault(__webpack_require__(1207));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Given a Source object, this returns a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */
function createLexer(source, options) {
  var startOfFileToken = new Tok(TokenKind.SOF, 0, 0, 0, 0, null);
  var lexer = {
    source: source,
    options: options,
    lastToken: startOfFileToken,
    token: startOfFileToken,
    line: 1,
    lineStart: 0,
    advance: advanceLexer,
    lookahead: lookahead
  };
  return lexer;
}

function advanceLexer() {
  this.lastToken = this.token;
  var token = this.token = this.lookahead();
  return token;
}

function lookahead() {
  var token = this.token;

  if (token.kind !== TokenKind.EOF) {
    do {
      // Note: next is only mutable during parsing, so we cast to allow this.
      token = token.next || (token.next = readToken(this, token));
    } while (token.kind === TokenKind.COMMENT);
  }

  return token;
}
/**
 * The return type of createLexer.
 */


/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */

exports.TokenKind = TokenKind;

/**
 * A helper function to describe a token as a string for debugging
 */
function getTokenDesc(token) {
  var value = token.value;
  return value ? "".concat(token.kind, " \"").concat(value, "\"") : token.kind;
}

var charCodeAt = String.prototype.charCodeAt;
var slice = String.prototype.slice;
/**
 * Helper function for constructing the Token object.
 */

function Tok(kind, start, end, line, column, prev, value) {
  this.kind = kind;
  this.start = start;
  this.end = end;
  this.line = line;
  this.column = column;
  this.value = value;
  this.prev = prev;
  this.next = null;
} // Print a simplified form when appearing in JSON/util.inspect.


Tok.prototype.toJSON = Tok.prototype.inspect = function toJSON() {
  return {
    kind: this.kind,
    value: this.value,
    line: this.line,
    column: this.column
  };
};

function printCharCode(code) {
  return (// NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? TokenKind.EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
  );
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace and comments until it finds the next lexable
 * token, then lexes punctuators immediately or calls the appropriate helper
 * function for more complicated tokens.
 */


function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;
  var pos = positionAfterWhitespace(body, prev.end, lexer);
  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;

  if (pos >= bodyLength) {
    return new Tok(TokenKind.EOF, bodyLength, bodyLength, line, col, prev);
  }

  var code = charCodeAt.call(body, pos); // SourceCharacter

  switch (code) {
    // !
    case 33:
      return new Tok(TokenKind.BANG, pos, pos + 1, line, col, prev);
    // #

    case 35:
      return readComment(source, pos, line, col, prev);
    // $

    case 36:
      return new Tok(TokenKind.DOLLAR, pos, pos + 1, line, col, prev);
    // &

    case 38:
      return new Tok(TokenKind.AMP, pos, pos + 1, line, col, prev);
    // (

    case 40:
      return new Tok(TokenKind.PAREN_L, pos, pos + 1, line, col, prev);
    // )

    case 41:
      return new Tok(TokenKind.PAREN_R, pos, pos + 1, line, col, prev);
    // .

    case 46:
      if (charCodeAt.call(body, pos + 1) === 46 && charCodeAt.call(body, pos + 2) === 46) {
        return new Tok(TokenKind.SPREAD, pos, pos + 3, line, col, prev);
      }

      break;
    // :

    case 58:
      return new Tok(TokenKind.COLON, pos, pos + 1, line, col, prev);
    // =

    case 61:
      return new Tok(TokenKind.EQUALS, pos, pos + 1, line, col, prev);
    // @

    case 64:
      return new Tok(TokenKind.AT, pos, pos + 1, line, col, prev);
    // [

    case 91:
      return new Tok(TokenKind.BRACKET_L, pos, pos + 1, line, col, prev);
    // ]

    case 93:
      return new Tok(TokenKind.BRACKET_R, pos, pos + 1, line, col, prev);
    // {

    case 123:
      return new Tok(TokenKind.BRACE_L, pos, pos + 1, line, col, prev);
    // |

    case 124:
      return new Tok(TokenKind.PIPE, pos, pos + 1, line, col, prev);
    // }

    case 125:
      return new Tok(TokenKind.BRACE_R, pos, pos + 1, line, col, prev);
    // A-Z _ a-z

    case 65:
    case 66:
    case 67:
    case 68:
    case 69:
    case 70:
    case 71:
    case 72:
    case 73:
    case 74:
    case 75:
    case 76:
    case 77:
    case 78:
    case 79:
    case 80:
    case 81:
    case 82:
    case 83:
    case 84:
    case 85:
    case 86:
    case 87:
    case 88:
    case 89:
    case 90:
    case 95:
    case 97:
    case 98:
    case 99:
    case 100:
    case 101:
    case 102:
    case 103:
    case 104:
    case 105:
    case 106:
    case 107:
    case 108:
    case 109:
    case 110:
    case 111:
    case 112:
    case 113:
    case 114:
    case 115:
    case 116:
    case 117:
    case 118:
    case 119:
    case 120:
    case 121:
    case 122:
      return readName(source, pos, line, col, prev);
    // - 0-9

    case 45:
    case 48:
    case 49:
    case 50:
    case 51:
    case 52:
    case 53:
    case 54:
    case 55:
    case 56:
    case 57:
      return readNumber(source, pos, code, line, col, prev);
    // "

    case 34:
      if (charCodeAt.call(body, pos + 1) === 34 && charCodeAt.call(body, pos + 2) === 34) {
        return readBlockString(source, pos, line, col, prev);
      }

      return readString(source, pos, line, col, prev);
  }

  throw (0, _error.syntaxError)(source, pos, unexpectedCharacterMessage(code));
}
/**
 * Report a message that an unexpected character was encountered.
 */


function unexpectedCharacterMessage(code) {
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
  }

  if (code === 39) {
    // '
    return "Unexpected single quote character ('), did you mean to use " + 'a double quote (")?';
  }

  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads from body starting at startPosition until it finds a non-whitespace
 * or commented character, then returns the position of that character for
 * lexing.
 */


function positionAfterWhitespace(body, startPosition, lexer) {
  var bodyLength = body.length;
  var position = startPosition;

  while (position < bodyLength) {
    var code = charCodeAt.call(body, position); // tab | space | comma | BOM

    if (code === 9 || code === 32 || code === 44 || code === 0xfeff) {
      ++position;
    } else if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (charCodeAt.call(body, position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else {
      break;
    }
  }

  return position;
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */


function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code;
  var position = start;

  do {
    code = charCodeAt.call(body, ++position);
  } while (code !== null && ( // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new Tok(TokenKind.COMMENT, start, position, line, col, prev, slice.call(body, start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */


function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = charCodeAt.call(body, ++position);
  }

  if (code === 48) {
    // 0
    code = charCodeAt.call(body, ++position);

    if (code >= 48 && code <= 57) {
      throw (0, _error.syntaxError)(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    }
  } else {
    position = readDigits(source, position, code);
    code = charCodeAt.call(body, position);
  }

  if (code === 46) {
    // .
    isFloat = true;
    code = charCodeAt.call(body, ++position);
    position = readDigits(source, position, code);
    code = charCodeAt.call(body, position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;
    code = charCodeAt.call(body, ++position);

    if (code === 43 || code === 45) {
      // + -
      code = charCodeAt.call(body, ++position);
    }

    position = readDigits(source, position, code);
  }

  return new Tok(isFloat ? TokenKind.FLOAT : TokenKind.INT, start, position, line, col, prev, slice.call(body, start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */


function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;

  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = charCodeAt.call(body, ++position);
    } while (code >= 48 && code <= 57); // 0 - 9


    return position;
  }

  throw (0, _error.syntaxError)(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */


function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && (code = charCodeAt.call(body, position)) !== null && // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += slice.call(body, chunkStart, position);
      return new Tok(TokenKind.STRING, start, position + 1, line, col, prev, value);
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009) {
      throw (0, _error.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    ++position;

    if (code === 92) {
      // \
      value += slice.call(body, chunkStart, position - 1);
      code = charCodeAt.call(body, position);

      switch (code) {
        case 34:
          value += '"';
          break;

        case 47:
          value += '/';
          break;

        case 92:
          value += '\\';
          break;

        case 98:
          value += '\b';
          break;

        case 102:
          value += '\f';
          break;

        case 110:
          value += '\n';
          break;

        case 114:
          value += '\r';
          break;

        case 116:
          value += '\t';
          break;

        case 117:
          // u
          var charCode = uniCharCode(charCodeAt.call(body, position + 1), charCodeAt.call(body, position + 2), charCodeAt.call(body, position + 3), charCodeAt.call(body, position + 4));

          if (charCode < 0) {
            throw (0, _error.syntaxError)(source, position, 'Invalid character escape sequence: ' + "\\u".concat(body.slice(position + 1, position + 5), "."));
          }

          value += String.fromCharCode(charCode);
          position += 4;
          break;

        default:
          throw (0, _error.syntaxError)(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
      }

      ++position;
      chunkStart = position;
    }
  }

  throw (0, _error.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */


function readBlockString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && (code = charCodeAt.call(body, position)) !== null) {
    // Closing Triple-Quote (""")
    if (code === 34 && charCodeAt.call(body, position + 1) === 34 && charCodeAt.call(body, position + 2) === 34) {
      rawValue += slice.call(body, chunkStart, position);
      return new Tok(TokenKind.BLOCK_STRING, start, position + 3, line, col, prev, (0, _blockStringValue.default)(rawValue));
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw (0, _error.syntaxError)(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    } // Escape Triple-Quote (\""")


    if (code === 92 && charCodeAt.call(body, position + 1) === 34 && charCodeAt.call(body, position + 2) === 34 && charCodeAt.call(body, position + 3) === 34) {
      rawValue += slice.call(body, chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw (0, _error.syntaxError)(source, position, 'Unterminated string.');
}
/**
 * Converts four hexidecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */


function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */


function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */


function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;

  while (position !== bodyLength && (code = charCodeAt.call(body, position)) !== null && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }

  return new Tok(TokenKind.NAME, start, position, line, col, prev, slice.call(body, start, position));
}

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLocation = getLocation;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match;

  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }

  return {
    line: line,
    column: column
  };
}

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.astFromValue = astFromValue;

var _iterall = __webpack_require__(348);

var _inspect = _interopRequireDefault(__webpack_require__(93));

var _isNullish = _interopRequireDefault(__webpack_require__(660));

var _isInvalid = _interopRequireDefault(__webpack_require__(204));

var _objectValues = _interopRequireDefault(__webpack_require__(205));

var _kinds = __webpack_require__(68);

var _definition = __webpack_require__(54);

var _scalars = __webpack_require__(184);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Produces a GraphQL Value AST given a JavaScript value.
 *
 * A GraphQL type must be provided, which will be used to interpret different
 * JavaScript values.
 *
 * | JSON Value    | GraphQL Value        |
 * | ------------- | -------------------- |
 * | Object        | Input Object         |
 * | Array         | List                 |
 * | Boolean       | Boolean              |
 * | String        | String / Enum Value  |
 * | Number        | Int / Float          |
 * | Mixed         | Enum Value           |
 * | null          | NullValue            |
 *
 */
function astFromValue(value, type) {
  if ((0, _definition.isNonNullType)(type)) {
    var astValue = astFromValue(value, type.ofType);

    if (astValue && astValue.kind === _kinds.Kind.NULL) {
      return null;
    }

    return astValue;
  } // only explicit null, not undefined, NaN


  if (value === null) {
    return {
      kind: _kinds.Kind.NULL
    };
  } // undefined, NaN


  if ((0, _isInvalid.default)(value)) {
    return null;
  } // Convert JavaScript array to GraphQL list. If the GraphQLType is a list, but
  // the value is not an array, convert the value using the list's item type.


  if ((0, _definition.isListType)(type)) {
    var itemType = type.ofType;

    if ((0, _iterall.isCollection)(value)) {
      var valuesNodes = [];
      (0, _iterall.forEach)(value, function (item) {
        var itemNode = astFromValue(item, itemType);

        if (itemNode) {
          valuesNodes.push(itemNode);
        }
      });
      return {
        kind: _kinds.Kind.LIST,
        values: valuesNodes
      };
    }

    return astFromValue(value, itemType);
  } // Populate the fields of the input object by creating ASTs from each value
  // in the JavaScript object according to the fields in the input type.


  if ((0, _definition.isInputObjectType)(type)) {
    if (value === null || _typeof(value) !== 'object') {
      return null;
    }

    var fields = (0, _objectValues.default)(type.getFields());
    var fieldNodes = [];
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = fields[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var field = _step.value;
        var fieldValue = astFromValue(value[field.name], field.type);

        if (fieldValue) {
          fieldNodes.push({
            kind: _kinds.Kind.OBJECT_FIELD,
            name: {
              kind: _kinds.Kind.NAME,
              value: field.name
            },
            value: fieldValue
          });
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return {
      kind: _kinds.Kind.OBJECT,
      fields: fieldNodes
    };
  }

  if ((0, _definition.isScalarType)(type) || (0, _definition.isEnumType)(type)) {
    // Since value is an internally represented value, it must be serialized
    // to an externally represented value before converting into an AST.
    var serialized = type.serialize(value);

    if ((0, _isNullish.default)(serialized)) {
      return null;
    } // Others serialize based on their corresponding JavaScript scalar types.


    if (typeof serialized === 'boolean') {
      return {
        kind: _kinds.Kind.BOOLEAN,
        value: serialized
      };
    } // JavaScript numbers can be Int or Float values.


    if (typeof serialized === 'number') {
      var stringNum = String(serialized);
      return integerStringRegExp.test(stringNum) ? {
        kind: _kinds.Kind.INT,
        value: stringNum
      } : {
        kind: _kinds.Kind.FLOAT,
        value: stringNum
      };
    }

    if (typeof serialized === 'string') {
      // Enum types use Enum literals.
      if ((0, _definition.isEnumType)(type)) {
        return {
          kind: _kinds.Kind.ENUM,
          value: serialized
        };
      } // ID types can use Int literals.


      if (type === _scalars.GraphQLID && integerStringRegExp.test(serialized)) {
        return {
          kind: _kinds.Kind.INT,
          value: serialized
        };
      }

      return {
        kind: _kinds.Kind.STRING,
        value: serialized
      };
    }

    throw new TypeError("Cannot convert value to AST: ".concat((0, _inspect.default)(serialized)));
  }
  /* istanbul ignore next */


  throw new Error("Unknown type: ".concat(type, "."));
}
/**
 * IntValue:
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit ( Digit+ )?
 */


var integerStringRegExp = /^-?(0|[1-9][0-9]*)$/;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coerceValue = coerceValue;

var _iterall = __webpack_require__(348);

var _inspect = _interopRequireDefault(__webpack_require__(93));

var _isInvalid = _interopRequireDefault(__webpack_require__(204));

var _orList = _interopRequireDefault(__webpack_require__(661));

var _suggestionList = _interopRequireDefault(__webpack_require__(344));

var _GraphQLError = __webpack_require__(37);

var _definition = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Coerces a JavaScript value given a GraphQL Type.
 *
 * Returns either a value which is valid for the provided type or a list of
 * encountered coercion errors.
 *
 */
function coerceValue(value, type, blameNode, path) {
  // A value must be provided if the type is non-null.
  if ((0, _definition.isNonNullType)(type)) {
    if (value == null) {
      return ofErrors([coercionError("Expected non-nullable type ".concat((0, _inspect.default)(type), " not to be null"), blameNode, path)]);
    }

    return coerceValue(value, type.ofType, blameNode, path);
  }

  if (value == null) {
    // Explicitly return the value null.
    return ofValue(null);
  }

  if ((0, _definition.isScalarType)(type)) {
    // Scalars determine if a value is valid via parseValue(), which can
    // throw to indicate failure. If it throws, maintain a reference to
    // the original error.
    try {
      var parseResult = type.parseValue(value);

      if ((0, _isInvalid.default)(parseResult)) {
        return ofErrors([coercionError("Expected type ".concat(type.name), blameNode, path)]);
      }

      return ofValue(parseResult);
    } catch (error) {
      return ofErrors([coercionError("Expected type ".concat(type.name), blameNode, path, error.message, error)]);
    }
  }

  if ((0, _definition.isEnumType)(type)) {
    if (typeof value === 'string') {
      var enumValue = type.getValue(value);

      if (enumValue) {
        return ofValue(enumValue.value);
      }
    }

    var suggestions = (0, _suggestionList.default)(String(value), type.getValues().map(function (enumValue) {
      return enumValue.name;
    }));
    var didYouMean = suggestions.length !== 0 ? "did you mean ".concat((0, _orList.default)(suggestions), "?") : undefined;
    return ofErrors([coercionError("Expected type ".concat(type.name), blameNode, path, didYouMean)]);
  }

  if ((0, _definition.isListType)(type)) {
    var itemType = type.ofType;

    if ((0, _iterall.isCollection)(value)) {
      var errors;
      var coercedValue = [];
      (0, _iterall.forEach)(value, function (itemValue, index) {
        var coercedItem = coerceValue(itemValue, itemType, blameNode, atPath(path, index));

        if (coercedItem.errors) {
          errors = add(errors, coercedItem.errors);
        } else if (!errors) {
          coercedValue.push(coercedItem.value);
        }
      });
      return errors ? ofErrors(errors) : ofValue(coercedValue);
    } // Lists accept a non-list value as a list of one.


    var coercedItem = coerceValue(value, itemType, blameNode);
    return coercedItem.errors ? coercedItem : ofValue([coercedItem.value]);
  }

  if ((0, _definition.isInputObjectType)(type)) {
    if (_typeof(value) !== 'object') {
      return ofErrors([coercionError("Expected type ".concat(type.name, " to be an object"), blameNode, path)]);
    }

    var _errors;

    var _coercedValue = {};
    var fields = type.getFields(); // Ensure every defined field is valid.

    for (var fieldName in fields) {
      if (hasOwnProperty.call(fields, fieldName)) {
        var field = fields[fieldName];
        var fieldValue = value[fieldName];

        if ((0, _isInvalid.default)(fieldValue)) {
          if (!(0, _isInvalid.default)(field.defaultValue)) {
            _coercedValue[fieldName] = field.defaultValue;
          } else if ((0, _definition.isNonNullType)(field.type)) {
            _errors = add(_errors, coercionError("Field ".concat(printPath(atPath(path, fieldName)), " of required ") + "type ".concat((0, _inspect.default)(field.type), " was not provided"), blameNode));
          }
        } else {
          var coercedField = coerceValue(fieldValue, field.type, blameNode, atPath(path, fieldName));

          if (coercedField.errors) {
            _errors = add(_errors, coercedField.errors);
          } else if (!_errors) {
            _coercedValue[fieldName] = coercedField.value;
          }
        }
      }
    } // Ensure every provided field is defined.


    for (var _fieldName in value) {
      if (hasOwnProperty.call(value, _fieldName)) {
        if (!fields[_fieldName]) {
          var _suggestions = (0, _suggestionList.default)(_fieldName, Object.keys(fields));

          var _didYouMean = _suggestions.length !== 0 ? "did you mean ".concat((0, _orList.default)(_suggestions), "?") : undefined;

          _errors = add(_errors, coercionError("Field \"".concat(_fieldName, "\" is not defined by type ").concat(type.name), blameNode, path, _didYouMean));
        }
      }
    }

    return _errors ? ofErrors(_errors) : ofValue(_coercedValue);
  }
  /* istanbul ignore next */


  throw new Error("Unexpected type: ".concat(type, "."));
}

function ofValue(value) {
  return {
    errors: undefined,
    value: value
  };
}

function ofErrors(errors) {
  return {
    errors: errors,
    value: undefined
  };
}

function add(errors, moreErrors) {
  return (errors || []).concat(moreErrors);
}

function atPath(prev, key) {
  return {
    prev: prev,
    key: key
  };
}

function coercionError(message, blameNode, path, subMessage, originalError) {
  var pathStr = printPath(path); // Return a GraphQLError instance

  return new _GraphQLError.GraphQLError(message + (pathStr ? ' at ' + pathStr : '') + (subMessage ? '; ' + subMessage : '.'), blameNode, undefined, undefined, undefined, originalError);
} // Build a string describing the path into the value where the error was found


function printPath(path) {
  var pathStr = '';
  var currentPath = path;

  while (currentPath) {
    pathStr = (typeof currentPath.key === 'string' ? '.' + currentPath.key : '[' + String(currentPath.key) + ']') + pathStr;
    currentPath = currentPath.prev;
  }

  return pathStr ? 'value' + pathStr : '';
}

var hasOwnProperty = Object.prototype.hasOwnProperty;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOperationRootType = getOperationRootType;

var _GraphQLError = __webpack_require__(37);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Extracts the root type of the operation from the schema.
 */
function getOperationRootType(schema, operation) {
  switch (operation.operation) {
    case 'query':
      var queryType = schema.getQueryType();

      if (!queryType) {
        throw new _GraphQLError.GraphQLError('Schema does not define the required query root type.', [operation]);
      }

      return queryType;

    case 'mutation':
      var mutationType = schema.getMutationType();

      if (!mutationType) {
        throw new _GraphQLError.GraphQLError('Schema is not configured for mutations.', [operation]);
      }

      return mutationType;

    case 'subscription':
      var subscriptionType = schema.getSubscriptionType();

      if (!subscriptionType) {
        throw new _GraphQLError.GraphQLError('Schema is not configured for subscriptions.', [operation]);
      }

      return subscriptionType;

    default:
      throw new _GraphQLError.GraphQLError('Can only have query, mutation and subscription operations.', [operation]);
  }
}

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ValidationContext = exports.SDLValidationContext = exports.ASTValidationContext = void 0;

var _visitor = __webpack_require__(245);

var _kinds = __webpack_require__(68);

var _TypeInfo = __webpack_require__(346);

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * An instance of this class is passed as the "this" context to all validators,
 * allowing access to commonly useful contextual information from within a
 * validation rule.
 */
var ASTValidationContext =
/*#__PURE__*/
function () {
  function ASTValidationContext(ast) {
    _defineProperty(this, "_ast", void 0);

    _defineProperty(this, "_errors", void 0);

    this._ast = ast;
    this._errors = [];
  }

  var _proto = ASTValidationContext.prototype;

  _proto.reportError = function reportError(error) {
    this._errors.push(error);
  };

  _proto.getErrors = function getErrors() {
    return this._errors;
  };

  _proto.getDocument = function getDocument() {
    return this._ast;
  };

  return ASTValidationContext;
}();

exports.ASTValidationContext = ASTValidationContext;

var SDLValidationContext =
/*#__PURE__*/
function (_ASTValidationContext) {
  _inheritsLoose(SDLValidationContext, _ASTValidationContext);

  function SDLValidationContext(ast, schema) {
    var _this;

    _this = _ASTValidationContext.call(this, ast) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "_schema", void 0);

    _this._schema = schema;
    return _this;
  }

  var _proto2 = SDLValidationContext.prototype;

  _proto2.getSchema = function getSchema() {
    return this._schema;
  };

  return SDLValidationContext;
}(ASTValidationContext);

exports.SDLValidationContext = SDLValidationContext;

var ValidationContext =
/*#__PURE__*/
function (_ASTValidationContext2) {
  _inheritsLoose(ValidationContext, _ASTValidationContext2);

  function ValidationContext(schema, ast, typeInfo) {
    var _this2;

    _this2 = _ASTValidationContext2.call(this, ast) || this;

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "_schema", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "_typeInfo", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "_fragments", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "_fragmentSpreads", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "_recursivelyReferencedFragments", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "_variableUsages", void 0);

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this2)), "_recursiveVariableUsages", void 0);

    _this2._schema = schema;
    _this2._typeInfo = typeInfo;
    _this2._fragmentSpreads = new Map();
    _this2._recursivelyReferencedFragments = new Map();
    _this2._variableUsages = new Map();
    _this2._recursiveVariableUsages = new Map();
    return _this2;
  }

  var _proto3 = ValidationContext.prototype;

  _proto3.getSchema = function getSchema() {
    return this._schema;
  };

  _proto3.getFragment = function getFragment(name) {
    var fragments = this._fragments;

    if (!fragments) {
      this._fragments = fragments = this.getDocument().definitions.reduce(function (frags, statement) {
        if (statement.kind === _kinds.Kind.FRAGMENT_DEFINITION) {
          frags[statement.name.value] = statement;
        }

        return frags;
      }, Object.create(null));
    }

    return fragments[name];
  };

  _proto3.getFragmentSpreads = function getFragmentSpreads(node) {
    var spreads = this._fragmentSpreads.get(node);

    if (!spreads) {
      spreads = [];
      var setsToVisit = [node];

      while (setsToVisit.length !== 0) {
        var set = setsToVisit.pop();

        for (var i = 0; i < set.selections.length; i++) {
          var selection = set.selections[i];

          if (selection.kind === _kinds.Kind.FRAGMENT_SPREAD) {
            spreads.push(selection);
          } else if (selection.selectionSet) {
            setsToVisit.push(selection.selectionSet);
          }
        }
      }

      this._fragmentSpreads.set(node, spreads);
    }

    return spreads;
  };

  _proto3.getRecursivelyReferencedFragments = function getRecursivelyReferencedFragments(operation) {
    var fragments = this._recursivelyReferencedFragments.get(operation);

    if (!fragments) {
      fragments = [];
      var collectedNames = Object.create(null);
      var nodesToVisit = [operation.selectionSet];

      while (nodesToVisit.length !== 0) {
        var node = nodesToVisit.pop();
        var spreads = this.getFragmentSpreads(node);

        for (var i = 0; i < spreads.length; i++) {
          var fragName = spreads[i].name.value;

          if (collectedNames[fragName] !== true) {
            collectedNames[fragName] = true;
            var fragment = this.getFragment(fragName);

            if (fragment) {
              fragments.push(fragment);
              nodesToVisit.push(fragment.selectionSet);
            }
          }
        }
      }

      this._recursivelyReferencedFragments.set(operation, fragments);
    }

    return fragments;
  };

  _proto3.getVariableUsages = function getVariableUsages(node) {
    var usages = this._variableUsages.get(node);

    if (!usages) {
      var newUsages = [];
      var typeInfo = new _TypeInfo.TypeInfo(this._schema);
      (0, _visitor.visit)(node, (0, _visitor.visitWithTypeInfo)(typeInfo, {
        VariableDefinition: function VariableDefinition() {
          return false;
        },
        Variable: function Variable(variable) {
          newUsages.push({
            node: variable,
            type: typeInfo.getInputType(),
            defaultValue: typeInfo.getDefaultValue()
          });
        }
      }));
      usages = newUsages;

      this._variableUsages.set(node, usages);
    }

    return usages;
  };

  _proto3.getRecursiveVariableUsages = function getRecursiveVariableUsages(operation) {
    var usages = this._recursiveVariableUsages.get(operation);

    if (!usages) {
      usages = this.getVariableUsages(operation);
      var fragments = this.getRecursivelyReferencedFragments(operation);

      for (var i = 0; i < fragments.length; i++) {
        Array.prototype.push.apply(usages, this.getVariableUsages(fragments[i]));
      }

      this._recursiveVariableUsages.set(operation, usages);
    }

    return usages;
  };

  _proto3.getType = function getType() {
    return this._typeInfo.getType();
  };

  _proto3.getParentType = function getParentType() {
    return this._typeInfo.getParentType();
  };

  _proto3.getInputType = function getInputType() {
    return this._typeInfo.getInputType();
  };

  _proto3.getParentInputType = function getParentInputType() {
    return this._typeInfo.getParentInputType();
  };

  _proto3.getFieldDef = function getFieldDef() {
    return this._typeInfo.getFieldDef();
  };

  _proto3.getDirective = function getDirective() {
    return this._typeInfo.getDirective();
  };

  _proto3.getArgument = function getArgument() {
    return this._typeInfo.getArgument();
  };

  return ValidationContext;
}(ASTValidationContext);

exports.ValidationContext = ValidationContext;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.badValueMessage = badValueMessage;
exports.requiredFieldMessage = requiredFieldMessage;
exports.unknownFieldMessage = unknownFieldMessage;
exports.ValuesOfCorrectType = ValuesOfCorrectType;

var _GraphQLError = __webpack_require__(37);

var _printer = __webpack_require__(165);

var _definition = __webpack_require__(54);

var _inspect = _interopRequireDefault(__webpack_require__(93));

var _isInvalid = _interopRequireDefault(__webpack_require__(204));

var _keyMap = _interopRequireDefault(__webpack_require__(183));

var _orList = _interopRequireDefault(__webpack_require__(661));

var _suggestionList = _interopRequireDefault(__webpack_require__(344));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function badValueMessage(typeName, valueName, message) {
  return "Expected type ".concat(typeName, ", found ").concat(valueName) + (message ? "; ".concat(message) : '.');
}

function requiredFieldMessage(typeName, fieldName, fieldTypeName) {
  return "Field ".concat(typeName, ".").concat(fieldName, " of required type ") + "".concat(fieldTypeName, " was not provided.");
}

function unknownFieldMessage(typeName, fieldName, message) {
  return "Field \"".concat(fieldName, "\" is not defined by type ").concat(typeName) + (message ? "; ".concat(message) : '.');
}
/**
 * Value literals of correct type
 *
 * A GraphQL document is only valid if all value literals are of the type
 * expected at their position.
 */


function ValuesOfCorrectType(context) {
  return {
    NullValue: function NullValue(node) {
      var type = context.getInputType();

      if ((0, _definition.isNonNullType)(type)) {
        context.reportError(new _GraphQLError.GraphQLError(badValueMessage((0, _inspect.default)(type), (0, _printer.print)(node)), node));
      }
    },
    ListValue: function ListValue(node) {
      // Note: TypeInfo will traverse into a list's item type, so look to the
      // parent input type to check if it is a list.
      var type = (0, _definition.getNullableType)(context.getParentInputType());

      if (!(0, _definition.isListType)(type)) {
        isValidScalar(context, node);
        return false; // Don't traverse further.
      }
    },
    ObjectValue: function ObjectValue(node) {
      var type = (0, _definition.getNamedType)(context.getInputType());

      if (!(0, _definition.isInputObjectType)(type)) {
        isValidScalar(context, node);
        return false; // Don't traverse further.
      } // Ensure every required field exists.


      var inputFields = type.getFields();
      var fieldNodeMap = (0, _keyMap.default)(node.fields, function (field) {
        return field.name.value;
      });

      var _arr = Object.keys(inputFields);

      for (var _i = 0; _i < _arr.length; _i++) {
        var fieldName = _arr[_i];
        var fieldDef = inputFields[fieldName];
        var fieldNode = fieldNodeMap[fieldName];

        if (!fieldNode && (0, _definition.isRequiredInputField)(fieldDef)) {
          var typeStr = (0, _inspect.default)(fieldDef.type);
          context.reportError(new _GraphQLError.GraphQLError(requiredFieldMessage(type.name, fieldName, typeStr), node));
        }
      }
    },
    ObjectField: function ObjectField(node) {
      var parentType = (0, _definition.getNamedType)(context.getParentInputType());
      var fieldType = context.getInputType();

      if (!fieldType && (0, _definition.isInputObjectType)(parentType)) {
        var suggestions = (0, _suggestionList.default)(node.name.value, Object.keys(parentType.getFields()));
        var didYouMean = suggestions.length !== 0 ? "Did you mean ".concat((0, _orList.default)(suggestions), "?") : undefined;
        context.reportError(new _GraphQLError.GraphQLError(unknownFieldMessage(parentType.name, node.name.value, didYouMean), node));
      }
    },
    EnumValue: function EnumValue(node) {
      var type = (0, _definition.getNamedType)(context.getInputType());

      if (!(0, _definition.isEnumType)(type)) {
        isValidScalar(context, node);
      } else if (!type.getValue(node.value)) {
        context.reportError(new _GraphQLError.GraphQLError(badValueMessage(type.name, (0, _printer.print)(node), enumTypeSuggestion(type, node)), node));
      }
    },
    IntValue: function IntValue(node) {
      return isValidScalar(context, node);
    },
    FloatValue: function FloatValue(node) {
      return isValidScalar(context, node);
    },
    StringValue: function StringValue(node) {
      return isValidScalar(context, node);
    },
    BooleanValue: function BooleanValue(node) {
      return isValidScalar(context, node);
    }
  };
}
/**
 * Any value literal may be a valid representation of a Scalar, depending on
 * that scalar type.
 */


function isValidScalar(context, node) {
  // Report any error at the full type expected by the location.
  var locationType = context.getInputType();

  if (!locationType) {
    return;
  }

  var type = (0, _definition.getNamedType)(locationType);

  if (!(0, _definition.isScalarType)(type)) {
    context.reportError(new _GraphQLError.GraphQLError(badValueMessage((0, _inspect.default)(locationType), (0, _printer.print)(node), enumTypeSuggestion(type, node)), node));
    return;
  } // Scalars determine if a literal value is valid via parseLiteral() which
  // may throw or return an invalid value to indicate failure.


  try {
    var parseResult = type.parseLiteral(node, undefined
    /* variables */
    );

    if ((0, _isInvalid.default)(parseResult)) {
      context.reportError(new _GraphQLError.GraphQLError(badValueMessage((0, _inspect.default)(locationType), (0, _printer.print)(node)), node));
    }
  } catch (error) {
    // Ensure a reference to the original error is maintained.
    context.reportError(new _GraphQLError.GraphQLError(badValueMessage((0, _inspect.default)(locationType), (0, _printer.print)(node), error.message), node, undefined, undefined, undefined, error));
  }
}

function enumTypeSuggestion(type, node) {
  if ((0, _definition.isEnumType)(type)) {
    var suggestions = (0, _suggestionList.default)((0, _printer.print)(node), type.getValues().map(function (value) {
      return value.name;
    }));

    if (suggestions.length !== 0) {
      return "Did you mean the enum value ".concat((0, _orList.default)(suggestions), "?");
    }
  }
}

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

var hash = exports;

hash.utils = __webpack_require__(167);
hash.common = __webpack_require__(347);
hash.sha = __webpack_require__(3003);
hash.ripemd = __webpack_require__(3002);
hash.hmac = __webpack_require__(3001);

// Proxy hash functions to the main object
hash.sha1 = hash.sha.sha1;
hash.sha256 = hash.sha.sha256;
hash.sha224 = hash.sha.sha224;
hash.sha384 = hash.sha.sha384;
hash.sha512 = hash.sha.sha512;
hash.ripemd160 = hash.ripemd.ripemd160;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;

var _LocationUtils = __webpack_require__(284);

var _DOMUtils = __webpack_require__(445);

var _DOMStateStorage = __webpack_require__(1242);

var _PathUtils = __webpack_require__(206);

var _ExecutionEnvironment = __webpack_require__(672);

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();

var _createLocation = function _createLocation(historyState) {
  var key = historyState && historyState.key;

  return (0, _LocationUtils.createLocation)({
    pathname: window.location.pathname,
    search: window.location.search,
    hash: window.location.hash,
    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
  }, undefined, key);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  var historyState = void 0;
  try {
    historyState = window.history.state || {};
  } catch (error) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    historyState = {};
  }

  return _createLocation(historyState);
};

var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
  return callback(window.confirm(message));
}; // eslint-disable-line no-alert

var startListener = exports.startListener = function startListener(listener) {
  var handlePopState = function handlePopState(event) {
    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
      return;
    listener(_createLocation(event.state));
  };

  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);

  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
    return listener(getCurrentLocation());
  };

  if (needsHashchangeListener) {
    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
  }

  return function () {
    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);

    if (needsHashchangeListener) {
      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
    }
  };
};

var updateLocation = function updateLocation(location, updateState) {
  var state = location.state,
      key = location.key;


  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);

  updateState({ key: key }, (0, _PathUtils.createPath)(location));
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.pushState(state, null, path);
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  return updateLocation(location, function (state, path) {
    return window.history.replaceState(state, null, path);
  });
};

var go = exports.go = function go(n) {
  if (n) window.history.go(n);
};

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _AsyncUtils = __webpack_require__(3008);

var _PathUtils = __webpack_require__(206);

var _runTransitionHook = __webpack_require__(674);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _Actions = __webpack_require__(444);

var _LocationUtils = __webpack_require__(284);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createHistory = function createHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var getCurrentLocation = options.getCurrentLocation,
      getUserConfirmation = options.getUserConfirmation,
      pushLocation = options.pushLocation,
      replaceLocation = options.replaceLocation,
      go = options.go,
      keyLength = options.keyLength;


  var currentLocation = void 0;
  var pendingLocation = void 0;
  var beforeListeners = [];
  var listeners = [];
  var allKeys = [];

  var getCurrentIndex = function getCurrentIndex() {
    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);

    if (currentLocation) return allKeys.indexOf(currentLocation.key);

    return -1;
  };

  var updateLocation = function updateLocation(nextLocation) {
    var currentIndex = getCurrentIndex();

    currentLocation = nextLocation;

    if (currentLocation.action === _Actions.PUSH) {
      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
    } else if (currentLocation.action === _Actions.REPLACE) {
      allKeys[currentIndex] = currentLocation.key;
    }

    listeners.forEach(function (listener) {
      return listener(currentLocation);
    });
  };

  var listenBefore = function listenBefore(listener) {
    beforeListeners.push(listener);

    return function () {
      return beforeListeners = beforeListeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var listen = function listen(listener) {
    listeners.push(listener);

    return function () {
      return listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  };

  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
        return result != null ? done(result) : next();
      });
    }, function (message) {
      if (getUserConfirmation && typeof message === 'string') {
        getUserConfirmation(message, function (ok) {
          return callback(ok !== false);
        });
      } else {
        callback(message !== false);
      }
    });
  };

  var transitionTo = function transitionTo(nextLocation) {
    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do

    pendingLocation = nextLocation;

    confirmTransitionTo(nextLocation, function (ok) {
      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation

      pendingLocation = null;

      if (ok) {
        // Treat PUSH to same path like REPLACE to be consistent with browsers
        if (nextLocation.action === _Actions.PUSH) {
          var prevPath = (0, _PathUtils.createPath)(currentLocation);
          var nextPath = (0, _PathUtils.createPath)(nextLocation);

          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
        }

        if (nextLocation.action === _Actions.POP) {
          updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.PUSH) {
          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
        } else if (nextLocation.action === _Actions.REPLACE) {
          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
        }
      } else if (currentLocation && nextLocation.action === _Actions.POP) {
        var prevIndex = allKeys.indexOf(currentLocation.key);
        var nextIndex = allKeys.indexOf(nextLocation.key);

        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
      }
    });
  };

  var push = function push(input) {
    return transitionTo(createLocation(input, _Actions.PUSH));
  };

  var replace = function replace(input) {
    return transitionTo(createLocation(input, _Actions.REPLACE));
  };

  var goBack = function goBack() {
    return go(-1);
  };

  var goForward = function goForward() {
    return go(1);
  };

  var createKey = function createKey() {
    return Math.random().toString(36).substr(2, keyLength || 6);
  };

  var createHref = function createHref(location) {
    return (0, _PathUtils.createPath)(location);
  };

  var createLocation = function createLocation(location, action) {
    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
    return (0, _LocationUtils.createLocation)(location, action, key);
  };

  return {
    getCurrentLocation: getCurrentLocation,
    listenBefore: listenBefore,
    listen: listen,
    transitionTo: transitionTo,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    createKey: createKey,
    createPath: _PathUtils.createPath,
    createHref: createHref,
    createLocation: createLocation
  };
};

exports.default = createHistory;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _warning = __webpack_require__(212);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var runTransitionHook = function runTransitionHook(hook, location, callback) {
  var result = hook(location, callback);

  if (hook.length < 2) {
    // Assume the hook runs synchronously and automatically
    // call the callback with the return value.
    callback(result);
  } else {
     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
  }
};

exports.default = runTransitionHook;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(285),
    root = __webpack_require__(186);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(186);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 677 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * marked v5.1.2 - a markdown parser
 * Copyright (c) 2011-2023, Christopher Jeffrey. (MIT Licensed)
 * https://github.com/markedjs/marked
 */

/**
 * DO NOT EDIT THIS FILE
 * The code in this file is generated from files in ./src/
 */

(function (global, factory) {
   true ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.marked = {}));
})(this, (function (exports) { 'use strict';

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];
        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }
      return target;
    };
    return _extends.apply(this, arguments);
  }
  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }
  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
    return arr2;
  }
  function _createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  function _toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
      var res = prim.call(input, hint || "default");
      if (typeof res !== "object") return res;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
  }
  function _toPropertyKey(arg) {
    var key = _toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
  }
  var id = 0;
  function _classPrivateFieldLooseKey(name) {
    return "__private_" + id++ + "_" + name;
  }
  function _classPrivateFieldLooseBase(receiver, privateKey) {
    if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
      throw new TypeError("attempted to use private field on non-instance");
    }
    return receiver;
  }

  function getDefaults() {
    return {
      async: false,
      baseUrl: null,
      breaks: false,
      extensions: null,
      gfm: true,
      headerIds: true,
      headerPrefix: '',
      highlight: null,
      hooks: null,
      langPrefix: 'language-',
      mangle: true,
      pedantic: false,
      renderer: null,
      sanitize: false,
      sanitizer: null,
      silent: false,
      smartypants: false,
      tokenizer: null,
      walkTokens: null,
      xhtml: false
    };
  }
  exports.defaults = getDefaults();
  function changeDefaults(newDefaults) {
    exports.defaults = newDefaults;
  }

  /**
   * Helpers
   */
  var escapeTest = /[&<>"']/;
  var escapeReplace = new RegExp(escapeTest.source, 'g');
  var escapeTestNoEncode = /[<>"']|&(?!(#\d{1,7}|#[Xx][a-fA-F0-9]{1,6}|\w+);)/;
  var escapeReplaceNoEncode = new RegExp(escapeTestNoEncode.source, 'g');
  var escapeReplacements = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };
  var getEscapeReplacement = function getEscapeReplacement(ch) {
    return escapeReplacements[ch];
  };
  function escape(html, encode) {
    if (encode) {
      if (escapeTest.test(html)) {
        return html.replace(escapeReplace, getEscapeReplacement);
      }
    } else {
      if (escapeTestNoEncode.test(html)) {
        return html.replace(escapeReplaceNoEncode, getEscapeReplacement);
      }
    }
    return html;
  }
  var unescapeTest = /&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/ig;

  /**
   * @param {string} html
   */
  function unescape(html) {
    // explicitly match decimal, hex, and named HTML entities
    return html.replace(unescapeTest, function (_, n) {
      n = n.toLowerCase();
      if (n === 'colon') return ':';
      if (n.charAt(0) === '#') {
        return n.charAt(1) === 'x' ? String.fromCharCode(parseInt(n.substring(2), 16)) : String.fromCharCode(+n.substring(1));
      }
      return '';
    });
  }
  var caret = /(^|[^\[])\^/g;

  /**
   * @param {string | RegExp} regex
   * @param {string} opt
   */
  function edit(regex, opt) {
    regex = typeof regex === 'string' ? regex : regex.source;
    opt = opt || '';
    var obj = {
      replace: function replace(name, val) {
        val = val.source || val;
        val = val.replace(caret, '$1');
        regex = regex.replace(name, val);
        return obj;
      },
      getRegex: function getRegex() {
        return new RegExp(regex, opt);
      }
    };
    return obj;
  }
  var nonWordAndColonTest = /[^\w:]/g;
  var originIndependentUrl = /^$|^[a-z][a-z0-9+.-]*:|^[?#]/i;

  /**
   * @param {boolean} sanitize
   * @param {string} base
   * @param {string} href
   */
  function cleanUrl(sanitize, base, href) {
    if (sanitize) {
      var prot;
      try {
        prot = decodeURIComponent(unescape(href)).replace(nonWordAndColonTest, '').toLowerCase();
      } catch (e) {
        return null;
      }
      if (prot.indexOf('javascript:') === 0 || prot.indexOf('vbscript:') === 0 || prot.indexOf('data:') === 0) {
        return null;
      }
    }
    if (base && !originIndependentUrl.test(href)) {
      href = resolveUrl(base, href);
    }
    try {
      href = encodeURI(href).replace(/%25/g, '%');
    } catch (e) {
      return null;
    }
    return href;
  }
  var baseUrls = {};
  var justDomain = /^[^:]+:\/*[^/]*$/;
  var protocol = /^([^:]+:)[\s\S]*$/;
  var domain = /^([^:]+:\/*[^/]*)[\s\S]*$/;

  /**
   * @param {string} base
   * @param {string} href
   */
  function resolveUrl(base, href) {
    if (!baseUrls[' ' + base]) {
      // we can ignore everything in base after the last slash of its path component,
      // but we might need to add _that_
      // https://tools.ietf.org/html/rfc3986#section-3
      if (justDomain.test(base)) {
        baseUrls[' ' + base] = base + '/';
      } else {
        baseUrls[' ' + base] = rtrim(base, '/', true);
      }
    }
    base = baseUrls[' ' + base];
    var relativeBase = base.indexOf(':') === -1;
    if (href.substring(0, 2) === '//') {
      if (relativeBase) {
        return href;
      }
      return base.replace(protocol, '$1') + href;
    } else if (href.charAt(0) === '/') {
      if (relativeBase) {
        return href;
      }
      return base.replace(domain, '$1') + href;
    } else {
      return base + href;
    }
  }
  var noopTest = {
    exec: function noopTest() {}
  };
  function splitCells(tableRow, count) {
    // ensure that every cell-delimiting pipe has a space
    // before it to distinguish it from an escaped pipe
    var row = tableRow.replace(/\|/g, function (match, offset, str) {
        var escaped = false,
          curr = offset;
        while (--curr >= 0 && str[curr] === '\\') escaped = !escaped;
        if (escaped) {
          // odd number of slashes means | is escaped
          // so we leave it alone
          return '|';
        } else {
          // add space before unescaped |
          return ' |';
        }
      }),
      cells = row.split(/ \|/);
    var i = 0;

    // First/last cell in a row cannot be empty if it has no leading/trailing pipe
    if (!cells[0].trim()) {
      cells.shift();
    }
    if (cells.length > 0 && !cells[cells.length - 1].trim()) {
      cells.pop();
    }
    if (cells.length > count) {
      cells.splice(count);
    } else {
      while (cells.length < count) cells.push('');
    }
    for (; i < cells.length; i++) {
      // leading or trailing whitespace is ignored per the gfm spec
      cells[i] = cells[i].trim().replace(/\\\|/g, '|');
    }
    return cells;
  }

  /**
   * Remove trailing 'c's. Equivalent to str.replace(/c*$/, '').
   * /c*$/ is vulnerable to REDOS.
   *
   * @param {string} str
   * @param {string} c
   * @param {boolean} invert Remove suffix of non-c chars instead. Default falsey.
   */
  function rtrim(str, c, invert) {
    var l = str.length;
    if (l === 0) {
      return '';
    }

    // Length of suffix matching the invert condition.
    var suffLen = 0;

    // Step left until we fail to match the invert condition.
    while (suffLen < l) {
      var currChar = str.charAt(l - suffLen - 1);
      if (currChar === c && !invert) {
        suffLen++;
      } else if (currChar !== c && invert) {
        suffLen++;
      } else {
        break;
      }
    }
    return str.slice(0, l - suffLen);
  }
  function findClosingBracket(str, b) {
    if (str.indexOf(b[1]) === -1) {
      return -1;
    }
    var l = str.length;
    var level = 0,
      i = 0;
    for (; i < l; i++) {
      if (str[i] === '\\') {
        i++;
      } else if (str[i] === b[0]) {
        level++;
      } else if (str[i] === b[1]) {
        level--;
        if (level < 0) {
          return i;
        }
      }
    }
    return -1;
  }
  function checkDeprecations(opt, callback) {
    if (!opt || opt.silent) {
      return;
    }
    if (callback) {
      console.warn('marked(): callback is deprecated since version 5.0.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/using_pro#async');
    }
    if (opt.sanitize || opt.sanitizer) {
      console.warn('marked(): sanitize and sanitizer parameters are deprecated since version 0.7.0, should not be used and will be removed in the future. Read more here: https://marked.js.org/#/USING_ADVANCED.md#options');
    }
    if (opt.highlight || opt.langPrefix !== 'language-') {
      console.warn('marked(): highlight and langPrefix parameters are deprecated since version 5.0.0, should not be used and will be removed in the future. Instead use https://www.npmjs.com/package/marked-highlight.');
    }
    if (opt.mangle) {
      console.warn('marked(): mangle parameter is enabled by default, but is deprecated since version 5.0.0, and will be removed in the future. To clear this warning, install https://www.npmjs.com/package/marked-mangle, or disable by setting `{mangle: false}`.');
    }
    if (opt.baseUrl) {
      console.warn('marked(): baseUrl parameter is deprecated since version 5.0.0, should not be used and will be removed in the future. Instead use https://www.npmjs.com/package/marked-base-url.');
    }
    if (opt.smartypants) {
      console.warn('marked(): smartypants parameter is deprecated since version 5.0.0, should not be used and will be removed in the future. Instead use https://www.npmjs.com/package/marked-smartypants.');
    }
    if (opt.xhtml) {
      console.warn('marked(): xhtml parameter is deprecated since version 5.0.0, should not be used and will be removed in the future. Instead use https://www.npmjs.com/package/marked-xhtml.');
    }
    if (opt.headerIds || opt.headerPrefix) {
      console.warn('marked(): headerIds and headerPrefix parameters enabled by default, but are deprecated since version 5.0.0, and will be removed in the future. To clear this warning, install  https://www.npmjs.com/package/marked-gfm-heading-id, or disable by setting `{headerIds: false}`.');
    }
  }

  function outputLink(cap, link, raw, lexer) {
    var href = link.href;
    var title = link.title ? escape(link.title) : null;
    var text = cap[1].replace(/\\([\[\]])/g, '$1');
    if (cap[0].charAt(0) !== '!') {
      lexer.state.inLink = true;
      var token = {
        type: 'link',
        raw: raw,
        href: href,
        title: title,
        text: text,
        tokens: lexer.inlineTokens(text)
      };
      lexer.state.inLink = false;
      return token;
    }
    return {
      type: 'image',
      raw: raw,
      href: href,
      title: title,
      text: escape(text)
    };
  }
  function indentCodeCompensation(raw, text) {
    var matchIndentToCode = raw.match(/^(\s+)(?:```)/);
    if (matchIndentToCode === null) {
      return text;
    }
    var indentToCode = matchIndentToCode[1];
    return text.split('\n').map(function (node) {
      var matchIndentInNode = node.match(/^\s+/);
      if (matchIndentInNode === null) {
        return node;
      }
      var indentInNode = matchIndentInNode[0];
      if (indentInNode.length >= indentToCode.length) {
        return node.slice(indentToCode.length);
      }
      return node;
    }).join('\n');
  }

  /**
   * Tokenizer
   */
  var Tokenizer = /*#__PURE__*/function () {
    function Tokenizer(options) {
      this.options = options || exports.defaults;
    }
    var _proto = Tokenizer.prototype;
    _proto.space = function space(src) {
      var cap = this.rules.block.newline.exec(src);
      if (cap && cap[0].length > 0) {
        return {
          type: 'space',
          raw: cap[0]
        };
      }
    };
    _proto.code = function code(src) {
      var cap = this.rules.block.code.exec(src);
      if (cap) {
        var text = cap[0].replace(/^ {1,4}/gm, '');
        return {
          type: 'code',
          raw: cap[0],
          codeBlockStyle: 'indented',
          text: !this.options.pedantic ? rtrim(text, '\n') : text
        };
      }
    };
    _proto.fences = function fences(src) {
      var cap = this.rules.block.fences.exec(src);
      if (cap) {
        var raw = cap[0];
        var text = indentCodeCompensation(raw, cap[3] || '');
        return {
          type: 'code',
          raw: raw,
          lang: cap[2] ? cap[2].trim().replace(this.rules.inline._escapes, '$1') : cap[2],
          text: text
        };
      }
    };
    _proto.heading = function heading(src) {
      var cap = this.rules.block.heading.exec(src);
      if (cap) {
        var text = cap[2].trim();

        // remove trailing #s
        if (/#$/.test(text)) {
          var trimmed = rtrim(text, '#');
          if (this.options.pedantic) {
            text = trimmed.trim();
          } else if (!trimmed || / $/.test(trimmed)) {
            // CommonMark requires space before trailing #s
            text = trimmed.trim();
          }
        }
        return {
          type: 'heading',
          raw: cap[0],
          depth: cap[1].length,
          text: text,
          tokens: this.lexer.inline(text)
        };
      }
    };
    _proto.hr = function hr(src) {
      var cap = this.rules.block.hr.exec(src);
      if (cap) {
        return {
          type: 'hr',
          raw: cap[0]
        };
      }
    };
    _proto.blockquote = function blockquote(src) {
      var cap = this.rules.block.blockquote.exec(src);
      if (cap) {
        var text = cap[0].replace(/^ *>[ \t]?/gm, '');
        var top = this.lexer.state.top;
        this.lexer.state.top = true;
        var tokens = this.lexer.blockTokens(text);
        this.lexer.state.top = top;
        return {
          type: 'blockquote',
          raw: cap[0],
          tokens: tokens,
          text: text
        };
      }
    };
    _proto.list = function list(src) {
      var cap = this.rules.block.list.exec(src);
      if (cap) {
        var raw, istask, ischecked, indent, i, blankLine, endsWithBlankLine, line, nextLine, rawLine, itemContents, endEarly;
        var bull = cap[1].trim();
        var isordered = bull.length > 1;
        var list = {
          type: 'list',
          raw: '',
          ordered: isordered,
          start: isordered ? +bull.slice(0, -1) : '',
          loose: false,
          items: []
        };
        bull = isordered ? "\\d{1,9}\\" + bull.slice(-1) : "\\" + bull;
        if (this.options.pedantic) {
          bull = isordered ? bull : '[*+-]';
        }

        // Get next list item
        var itemRegex = new RegExp("^( {0,3}" + bull + ")((?:[\t ][^\\n]*)?(?:\\n|$))");

        // Check if current bullet point can start a new List Item
        while (src) {
          endEarly = false;
          if (!(cap = itemRegex.exec(src))) {
            break;
          }
          if (this.rules.block.hr.test(src)) {
            // End list if bullet was actually HR (possibly move into itemRegex?)
            break;
          }
          raw = cap[0];
          src = src.substring(raw.length);
          line = cap[2].split('\n', 1)[0].replace(/^\t+/, function (t) {
            return ' '.repeat(3 * t.length);
          });
          nextLine = src.split('\n', 1)[0];
          if (this.options.pedantic) {
            indent = 2;
            itemContents = line.trimLeft();
          } else {
            indent = cap[2].search(/[^ ]/); // Find first non-space char
            indent = indent > 4 ? 1 : indent; // Treat indented code blocks (> 4 spaces) as having only 1 indent
            itemContents = line.slice(indent);
            indent += cap[1].length;
          }
          blankLine = false;
          if (!line && /^ *$/.test(nextLine)) {
            // Items begin with at most one blank line
            raw += nextLine + '\n';
            src = src.substring(nextLine.length + 1);
            endEarly = true;
          }
          if (!endEarly) {
            var nextBulletRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:[*+-]|\\d{1,9}[.)])((?:[ \t][^\\n]*)?(?:\\n|$))");
            var hrRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}((?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$)");
            var fencesBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}(?:```|~~~)");
            var headingBeginRegex = new RegExp("^ {0," + Math.min(3, indent - 1) + "}#");

            // Check if following lines should be included in List Item
            while (src) {
              rawLine = src.split('\n', 1)[0];
              nextLine = rawLine;

              // Re-align to follow commonmark nesting rules
              if (this.options.pedantic) {
                nextLine = nextLine.replace(/^ {1,4}(?=( {4})*[^ ])/g, '  ');
              }

              // End list item if found code fences
              if (fencesBeginRegex.test(nextLine)) {
                break;
              }

              // End list item if found start of new heading
              if (headingBeginRegex.test(nextLine)) {
                break;
              }

              // End list item if found start of new bullet
              if (nextBulletRegex.test(nextLine)) {
                break;
              }

              // Horizontal rule found
              if (hrRegex.test(src)) {
                break;
              }
              if (nextLine.search(/[^ ]/) >= indent || !nextLine.trim()) {
                // Dedent if possible
                itemContents += '\n' + nextLine.slice(indent);
              } else {
                // not enough indentation
                if (blankLine) {
                  break;
                }

                // paragraph continuation unless last line was a different block level element
                if (line.search(/[^ ]/) >= 4) {
                  // indented code block
                  break;
                }
                if (fencesBeginRegex.test(line)) {
                  break;
                }
                if (headingBeginRegex.test(line)) {
                  break;
                }
                if (hrRegex.test(line)) {
                  break;
                }
                itemContents += '\n' + nextLine;
              }
              if (!blankLine && !nextLine.trim()) {
                // Check if current line is blank
                blankLine = true;
              }
              raw += rawLine + '\n';
              src = src.substring(rawLine.length + 1);
              line = nextLine.slice(indent);
            }
          }
          if (!list.loose) {
            // If the previous item ended with a blank line, the list is loose
            if (endsWithBlankLine) {
              list.loose = true;
            } else if (/\n *\n *$/.test(raw)) {
              endsWithBlankLine = true;
            }
          }

          // Check for task list items
          if (this.options.gfm) {
            istask = /^\[[ xX]\] /.exec(itemContents);
            if (istask) {
              ischecked = istask[0] !== '[ ] ';
              itemContents = itemContents.replace(/^\[[ xX]\] +/, '');
            }
          }
          list.items.push({
            type: 'list_item',
            raw: raw,
            task: !!istask,
            checked: ischecked,
            loose: false,
            text: itemContents
          });
          list.raw += raw;
        }

        // Do not consume newlines at end of final item. Alternatively, make itemRegex *start* with any newlines to simplify/speed up endsWithBlankLine logic
        list.items[list.items.length - 1].raw = raw.trimRight();
        list.items[list.items.length - 1].text = itemContents.trimRight();
        list.raw = list.raw.trimRight();
        var l = list.items.length;

        // Item child tokens handled here at end because we needed to have the final item to trim it first
        for (i = 0; i < l; i++) {
          this.lexer.state.top = false;
          list.items[i].tokens = this.lexer.blockTokens(list.items[i].text, []);
          if (!list.loose) {
            // Check if list should be loose
            var spacers = list.items[i].tokens.filter(function (t) {
              return t.type === 'space';
            });
            var hasMultipleLineBreaks = spacers.length > 0 && spacers.some(function (t) {
              return /\n.*\n/.test(t.raw);
            });
            list.loose = hasMultipleLineBreaks;
          }
        }

        // Set all items to loose if list is loose
        if (list.loose) {
          for (i = 0; i < l; i++) {
            list.items[i].loose = true;
          }
        }
        return list;
      }
    };
    _proto.html = function html(src) {
      var cap = this.rules.block.html.exec(src);
      if (cap) {
        var token = {
          type: 'html',
          block: true,
          raw: cap[0],
          pre: !this.options.sanitizer && (cap[1] === 'pre' || cap[1] === 'script' || cap[1] === 'style'),
          text: cap[0]
        };
        if (this.options.sanitize) {
          var text = this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]);
          token.type = 'paragraph';
          token.text = text;
          token.tokens = this.lexer.inline(text);
        }
        return token;
      }
    };
    _proto.def = function def(src) {
      var cap = this.rules.block.def.exec(src);
      if (cap) {
        var tag = cap[1].toLowerCase().replace(/\s+/g, ' ');
        var href = cap[2] ? cap[2].replace(/^<(.*)>$/, '$1').replace(this.rules.inline._escapes, '$1') : '';
        var title = cap[3] ? cap[3].substring(1, cap[3].length - 1).replace(this.rules.inline._escapes, '$1') : cap[3];
        return {
          type: 'def',
          tag: tag,
          raw: cap[0],
          href: href,
          title: title
        };
      }
    };
    _proto.table = function table(src) {
      var cap = this.rules.block.table.exec(src);
      if (cap) {
        var item = {
          type: 'table',
          header: splitCells(cap[1]).map(function (c) {
            return {
              text: c
            };
          }),
          align: cap[2].replace(/^ *|\| *$/g, '').split(/ *\| */),
          rows: cap[3] && cap[3].trim() ? cap[3].replace(/\n[ \t]*$/, '').split('\n') : []
        };
        if (item.header.length === item.align.length) {
          item.raw = cap[0];
          var l = item.align.length;
          var i, j, k, row;
          for (i = 0; i < l; i++) {
            if (/^ *-+: *$/.test(item.align[i])) {
              item.align[i] = 'right';
            } else if (/^ *:-+: *$/.test(item.align[i])) {
              item.align[i] = 'center';
            } else if (/^ *:-+ *$/.test(item.align[i])) {
              item.align[i] = 'left';
            } else {
              item.align[i] = null;
            }
          }
          l = item.rows.length;
          for (i = 0; i < l; i++) {
            item.rows[i] = splitCells(item.rows[i], item.header.length).map(function (c) {
              return {
                text: c
              };
            });
          }

          // parse child tokens inside headers and cells

          // header child tokens
          l = item.header.length;
          for (j = 0; j < l; j++) {
            item.header[j].tokens = this.lexer.inline(item.header[j].text);
          }

          // cell child tokens
          l = item.rows.length;
          for (j = 0; j < l; j++) {
            row = item.rows[j];
            for (k = 0; k < row.length; k++) {
              row[k].tokens = this.lexer.inline(row[k].text);
            }
          }
          return item;
        }
      }
    };
    _proto.lheading = function lheading(src) {
      var cap = this.rules.block.lheading.exec(src);
      if (cap) {
        return {
          type: 'heading',
          raw: cap[0],
          depth: cap[2].charAt(0) === '=' ? 1 : 2,
          text: cap[1],
          tokens: this.lexer.inline(cap[1])
        };
      }
    };
    _proto.paragraph = function paragraph(src) {
      var cap = this.rules.block.paragraph.exec(src);
      if (cap) {
        var text = cap[1].charAt(cap[1].length - 1) === '\n' ? cap[1].slice(0, -1) : cap[1];
        return {
          type: 'paragraph',
          raw: cap[0],
          text: text,
          tokens: this.lexer.inline(text)
        };
      }
    };
    _proto.text = function text(src) {
      var cap = this.rules.block.text.exec(src);
      if (cap) {
        return {
          type: 'text',
          raw: cap[0],
          text: cap[0],
          tokens: this.lexer.inline(cap[0])
        };
      }
    };
    _proto.escape = function escape$1(src) {
      var cap = this.rules.inline.escape.exec(src);
      if (cap) {
        return {
          type: 'escape',
          raw: cap[0],
          text: escape(cap[1])
        };
      }
    };
    _proto.tag = function tag(src) {
      var cap = this.rules.inline.tag.exec(src);
      if (cap) {
        if (!this.lexer.state.inLink && /^<a /i.test(cap[0])) {
          this.lexer.state.inLink = true;
        } else if (this.lexer.state.inLink && /^<\/a>/i.test(cap[0])) {
          this.lexer.state.inLink = false;
        }
        if (!this.lexer.state.inRawBlock && /^<(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
          this.lexer.state.inRawBlock = true;
        } else if (this.lexer.state.inRawBlock && /^<\/(pre|code|kbd|script)(\s|>)/i.test(cap[0])) {
          this.lexer.state.inRawBlock = false;
        }
        return {
          type: this.options.sanitize ? 'text' : 'html',
          raw: cap[0],
          inLink: this.lexer.state.inLink,
          inRawBlock: this.lexer.state.inRawBlock,
          block: false,
          text: this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0]
        };
      }
    };
    _proto.link = function link(src) {
      var cap = this.rules.inline.link.exec(src);
      if (cap) {
        var trimmedUrl = cap[2].trim();
        if (!this.options.pedantic && /^</.test(trimmedUrl)) {
          // commonmark requires matching angle brackets
          if (!/>$/.test(trimmedUrl)) {
            return;
          }

          // ending angle bracket cannot be escaped
          var rtrimSlash = rtrim(trimmedUrl.slice(0, -1), '\\');
          if ((trimmedUrl.length - rtrimSlash.length) % 2 === 0) {
            return;
          }
        } else {
          // find closing parenthesis
          var lastParenIndex = findClosingBracket(cap[2], '()');
          if (lastParenIndex > -1) {
            var start = cap[0].indexOf('!') === 0 ? 5 : 4;
            var linkLen = start + cap[1].length + lastParenIndex;
            cap[2] = cap[2].substring(0, lastParenIndex);
            cap[0] = cap[0].substring(0, linkLen).trim();
            cap[3] = '';
          }
        }
        var href = cap[2];
        var title = '';
        if (this.options.pedantic) {
          // split pedantic href and title
          var link = /^([^'"]*[^\s])\s+(['"])(.*)\2/.exec(href);
          if (link) {
            href = link[1];
            title = link[3];
          }
        } else {
          title = cap[3] ? cap[3].slice(1, -1) : '';
        }
        href = href.trim();
        if (/^</.test(href)) {
          if (this.options.pedantic && !/>$/.test(trimmedUrl)) {
            // pedantic allows starting angle bracket without ending angle bracket
            href = href.slice(1);
          } else {
            href = href.slice(1, -1);
          }
        }
        return outputLink(cap, {
          href: href ? href.replace(this.rules.inline._escapes, '$1') : href,
          title: title ? title.replace(this.rules.inline._escapes, '$1') : title
        }, cap[0], this.lexer);
      }
    };
    _proto.reflink = function reflink(src, links) {
      var cap;
      if ((cap = this.rules.inline.reflink.exec(src)) || (cap = this.rules.inline.nolink.exec(src))) {
        var link = (cap[2] || cap[1]).replace(/\s+/g, ' ');
        link = links[link.toLowerCase()];
        if (!link) {
          var text = cap[0].charAt(0);
          return {
            type: 'text',
            raw: text,
            text: text
          };
        }
        return outputLink(cap, link, cap[0], this.lexer);
      }
    };
    _proto.emStrong = function emStrong(src, maskedSrc, prevChar) {
      if (prevChar === void 0) {
        prevChar = '';
      }
      var match = this.rules.inline.emStrong.lDelim.exec(src);
      if (!match) return;

      // _ can't be between two alphanumerics. \p{L}\p{N} includes non-english alphabet/numbers as well
      if (match[3] && prevChar.match(/(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CA\uA7D0\uA7D1\uA7D3\uA7D5-\uA7D9\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDF50-\uDF59\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDD00-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD834[\uDEC0-\uDED3\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDCD0-\uDCEB\uDCF0-\uDCF9\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])/)) return;
      var nextChar = match[1] || match[2] || '';
      if (!nextChar || !prevChar || this.rules.inline.punctuation.exec(prevChar)) {
        var lLength = match[0].length - 1;
        var rDelim,
          rLength,
          delimTotal = lLength,
          midDelimTotal = 0;
        var endReg = match[0][0] === '*' ? this.rules.inline.emStrong.rDelimAst : this.rules.inline.emStrong.rDelimUnd;
        endReg.lastIndex = 0;

        // Clip maskedSrc to same section of string as src (move to lexer?)
        maskedSrc = maskedSrc.slice(-1 * src.length + lLength);
        while ((match = endReg.exec(maskedSrc)) != null) {
          rDelim = match[1] || match[2] || match[3] || match[4] || match[5] || match[6];
          if (!rDelim) continue; // skip single * in __abc*abc__

          rLength = rDelim.length;
          if (match[3] || match[4]) {
            // found another Left Delim
            delimTotal += rLength;
            continue;
          } else if (match[5] || match[6]) {
            // either Left or Right Delim
            if (lLength % 3 && !((lLength + rLength) % 3)) {
              midDelimTotal += rLength;
              continue; // CommonMark Emphasis Rules 9-10
            }
          }

          delimTotal -= rLength;
          if (delimTotal > 0) continue; // Haven't found enough closing delimiters

          // Remove extra characters. *a*** -> *a*
          rLength = Math.min(rLength, rLength + delimTotal + midDelimTotal);
          var raw = src.slice(0, lLength + match.index + rLength + 1);

          // Create `em` if smallest delimiter has odd char count. *a***
          if (Math.min(lLength, rLength) % 2) {
            var _text = raw.slice(1, -1);
            return {
              type: 'em',
              raw: raw,
              text: _text,
              tokens: this.lexer.inlineTokens(_text)
            };
          }

          // Create 'strong' if smallest delimiter has even char count. **a***
          var text = raw.slice(2, -2);
          return {
            type: 'strong',
            raw: raw,
            text: text,
            tokens: this.lexer.inlineTokens(text)
          };
        }
      }
    };
    _proto.codespan = function codespan(src) {
      var cap = this.rules.inline.code.exec(src);
      if (cap) {
        var text = cap[2].replace(/\n/g, ' ');
        var hasNonSpaceChars = /[^ ]/.test(text);
        var hasSpaceCharsOnBothEnds = /^ /.test(text) && / $/.test(text);
        if (hasNonSpaceChars && hasSpaceCharsOnBothEnds) {
          text = text.substring(1, text.length - 1);
        }
        text = escape(text, true);
        return {
          type: 'codespan',
          raw: cap[0],
          text: text
        };
      }
    };
    _proto.br = function br(src) {
      var cap = this.rules.inline.br.exec(src);
      if (cap) {
        return {
          type: 'br',
          raw: cap[0]
        };
      }
    };
    _proto.del = function del(src) {
      var cap = this.rules.inline.del.exec(src);
      if (cap) {
        return {
          type: 'del',
          raw: cap[0],
          text: cap[2],
          tokens: this.lexer.inlineTokens(cap[2])
        };
      }
    };
    _proto.autolink = function autolink(src, mangle) {
      var cap = this.rules.inline.autolink.exec(src);
      if (cap) {
        var text, href;
        if (cap[2] === '@') {
          text = escape(this.options.mangle ? mangle(cap[1]) : cap[1]);
          href = 'mailto:' + text;
        } else {
          text = escape(cap[1]);
          href = text;
        }
        return {
          type: 'link',
          raw: cap[0],
          text: text,
          href: href,
          tokens: [{
            type: 'text',
            raw: text,
            text: text
          }]
        };
      }
    };
    _proto.url = function url(src, mangle) {
      var cap;
      if (cap = this.rules.inline.url.exec(src)) {
        var text, href;
        if (cap[2] === '@') {
          text = escape(this.options.mangle ? mangle(cap[0]) : cap[0]);
          href = 'mailto:' + text;
        } else {
          // do extended autolink path validation
          var prevCapZero;
          do {
            prevCapZero = cap[0];
            cap[0] = this.rules.inline._backpedal.exec(cap[0])[0];
          } while (prevCapZero !== cap[0]);
          text = escape(cap[0]);
          if (cap[1] === 'www.') {
            href = 'http://' + cap[0];
          } else {
            href = cap[0];
          }
        }
        return {
          type: 'link',
          raw: cap[0],
          text: text,
          href: href,
          tokens: [{
            type: 'text',
            raw: text,
            text: text
          }]
        };
      }
    };
    _proto.inlineText = function inlineText(src, smartypants) {
      var cap = this.rules.inline.text.exec(src);
      if (cap) {
        var text;
        if (this.lexer.state.inRawBlock) {
          text = this.options.sanitize ? this.options.sanitizer ? this.options.sanitizer(cap[0]) : escape(cap[0]) : cap[0];
        } else {
          text = escape(this.options.smartypants ? smartypants(cap[0]) : cap[0]);
        }
        return {
          type: 'text',
          raw: cap[0],
          text: text
        };
      }
    };
    return Tokenizer;
  }();

  /**
   * Block-Level Grammar
   */
  var block = {
    newline: /^(?: *(?:\n|$))+/,
    code: /^( {4}[^\n]+(?:\n(?: *(?:\n|$))*)?)+/,
    fences: /^ {0,3}(`{3,}(?=[^`\n]*(?:\n|$))|~{3,})([^\n]*)(?:\n|$)(?:|([\s\S]*?)(?:\n|$))(?: {0,3}\1[~`]* *(?=\n|$)|$)/,
    hr: /^ {0,3}((?:-[\t ]*){3,}|(?:_[ \t]*){3,}|(?:\*[ \t]*){3,})(?:\n+|$)/,
    heading: /^ {0,3}(#{1,6})(?=\s|$)(.*)(?:\n+|$)/,
    blockquote: /^( {0,3}> ?(paragraph|[^\n]*)(?:\n|$))+/,
    list: /^( {0,3}bull)([ \t][^\n]+?)?(?:\n|$)/,
    html: '^ {0,3}(?:' // optional indentation
    + '<(script|pre|style|textarea)[\\s>][\\s\\S]*?(?:</\\1>[^\\n]*\\n+|$)' // (1)
    + '|comment[^\\n]*(\\n+|$)' // (2)
    + '|<\\?[\\s\\S]*?(?:\\?>\\n*|$)' // (3)
    + '|<![A-Z][\\s\\S]*?(?:>\\n*|$)' // (4)
    + '|<!\\[CDATA\\[[\\s\\S]*?(?:\\]\\]>\\n*|$)' // (5)
    + '|</?(tag)(?: +|\\n|/?>)[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (6)
    + '|<(?!script|pre|style|textarea)([a-z][\\w-]*)(?:attribute)*? */?>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) open tag
    + '|</(?!script|pre|style|textarea)[a-z][\\w-]*\\s*>(?=[ \\t]*(?:\\n|$))[\\s\\S]*?(?:(?:\\n *)+\\n|$)' // (7) closing tag
    + ')',
    def: /^ {0,3}\[(label)\]: *(?:\n *)?([^<\s][^\s]*|<.*?>)(?:(?: +(?:\n *)?| *\n *)(title))? *(?:\n+|$)/,
    table: noopTest,
    lheading: /^((?:(?!^bull ).|\n(?!\n|bull ))+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    // regex template, placeholders will be replaced according to different paragraph
    // interruption rules of commonmark and the original markdown spec:
    _paragraph: /^([^\n]+(?:\n(?!hr|heading|lheading|blockquote|fences|list|html|table| +\n)[^\n]+)*)/,
    text: /^[^\n]+/
  };
  block._label = /(?!\s*\])(?:\\.|[^\[\]\\])+/;
  block._title = /(?:"(?:\\"?|[^"\\])*"|'[^'\n]*(?:\n[^'\n]+)*\n?'|\([^()]*\))/;
  block.def = edit(block.def).replace('label', block._label).replace('title', block._title).getRegex();
  block.bullet = /(?:[*+-]|\d{1,9}[.)])/;
  block.listItemStart = edit(/^( *)(bull) */).replace('bull', block.bullet).getRegex();
  block.list = edit(block.list).replace(/bull/g, block.bullet).replace('hr', '\\n+(?=\\1?(?:(?:- *){3,}|(?:_ *){3,}|(?:\\* *){3,})(?:\\n+|$))').replace('def', '\\n+(?=' + block.def.source + ')').getRegex();
  block._tag = 'address|article|aside|base|basefont|blockquote|body|caption' + '|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption' + '|figure|footer|form|frame|frameset|h[1-6]|head|header|hr|html|iframe' + '|legend|li|link|main|menu|menuitem|meta|nav|noframes|ol|optgroup|option' + '|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr' + '|track|ul';
  block._comment = /<!--(?!-?>)[\s\S]*?(?:-->|$)/;
  block.html = edit(block.html, 'i').replace('comment', block._comment).replace('tag', block._tag).replace('attribute', / +[a-zA-Z:_][\w.:-]*(?: *= *"[^"\n]*"| *= *'[^'\n]*'| *= *[^\s"'=<>`]+)?/).getRegex();
  block.lheading = edit(block.lheading).replace(/bull/g, block.bullet) // lists can interrupt
  .getRegex();
  block.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('|table', '').replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();
  block.blockquote = edit(block.blockquote).replace('paragraph', block.paragraph).getRegex();

  /**
   * Normal Block Grammar
   */

  block.normal = _extends({}, block);

  /**
   * GFM Block Grammar
   */

  block.gfm = _extends({}, block.normal, {
    table: '^ *([^\\n ].*\\|.*)\\n' // Header
    + ' {0,3}(?:\\| *)?(:?-+:? *(?:\\| *:?-+:? *)*)(?:\\| *)?' // Align
    + '(?:\\n((?:(?! *\\n|hr|heading|blockquote|code|fences|list|html).*(?:\\n|$))*)\\n*|$)' // Cells
  });

  block.gfm.table = edit(block.gfm.table).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('blockquote', ' {0,3}>').replace('code', ' {4}[^\\n]').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // tables can be interrupted by type (6) html blocks
  .getRegex();
  block.gfm.paragraph = edit(block._paragraph).replace('hr', block.hr).replace('heading', ' {0,3}#{1,6} ').replace('|lheading', '') // setex headings don't interrupt commonmark paragraphs
  .replace('table', block.gfm.table) // interrupt paragraphs with table
  .replace('blockquote', ' {0,3}>').replace('fences', ' {0,3}(?:`{3,}(?=[^`\\n]*\\n)|~{3,})[^\\n]*\\n').replace('list', ' {0,3}(?:[*+-]|1[.)]) ') // only lists starting from 1 can interrupt
  .replace('html', '</?(?:tag)(?: +|\\n|/?>)|<(?:script|pre|style|textarea|!--)').replace('tag', block._tag) // pars can be interrupted by type (6) html blocks
  .getRegex();
  /**
   * Pedantic grammar (original John Gruber's loose markdown specification)
   */

  block.pedantic = _extends({}, block.normal, {
    html: edit('^ *(?:comment *(?:\\n|\\s*$)' + '|<(tag)[\\s\\S]+?</\\1> *(?:\\n{2,}|\\s*$)' // closed tag
    + '|<tag(?:"[^"]*"|\'[^\']*\'|\\s[^\'"/>\\s]*)*?/?> *(?:\\n{2,}|\\s*$))').replace('comment', block._comment).replace(/tag/g, '(?!(?:' + 'a|em|strong|small|s|cite|q|dfn|abbr|data|time|code|var|samp|kbd|sub' + '|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo|span|br|wbr|ins|del|img)' + '\\b)\\w+(?!:|[^\\w\\s@]*@)\\b').getRegex(),
    def: /^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +(["(][^\n]+[")]))? *(?:\n+|$)/,
    heading: /^(#{1,6})(.*)(?:\n+|$)/,
    fences: noopTest,
    // fences not supported
    lheading: /^(.+?)\n {0,3}(=+|-+) *(?:\n+|$)/,
    paragraph: edit(block.normal._paragraph).replace('hr', block.hr).replace('heading', ' *#{1,6} *[^\n]').replace('lheading', block.lheading).replace('blockquote', ' {0,3}>').replace('|fences', '').replace('|list', '').replace('|html', '').getRegex()
  });

  /**
   * Inline-Level Grammar
   */
  var inline = {
    escape: /^\\([!"#$%&'()*+,\-./:;<=>?@\[\]\\^_`{|}~])/,
    autolink: /^<(scheme:[^\s\x00-\x1f<>]*|email)>/,
    url: noopTest,
    tag: '^comment' + '|^</[a-zA-Z][\\w:-]*\\s*>' // self-closing tag
    + '|^<[a-zA-Z][\\w-]*(?:attribute)*?\\s*/?>' // open tag
    + '|^<\\?[\\s\\S]*?\\?>' // processing instruction, e.g. <?php ?>
    + '|^<![a-zA-Z]+\\s[\\s\\S]*?>' // declaration, e.g. <!DOCTYPE html>
    + '|^<!\\[CDATA\\[[\\s\\S]*?\\]\\]>',
    // CDATA section
    link: /^!?\[(label)\]\(\s*(href)(?:\s+(title))?\s*\)/,
    reflink: /^!?\[(label)\]\[(ref)\]/,
    nolink: /^!?\[(ref)\](?:\[\])?/,
    reflinkSearch: 'reflink|nolink(?!\\()',
    emStrong: {
      lDelim: /^(?:\*+(?:((?!\*)[punct])|[^\s*]))|^_+(?:((?!_)[punct])|([^\s_]))/,
      //         (1) and (2) can only be a Right Delimiter. (3) and (4) can only be Left.  (5) and (6) can be either Left or Right.
      //         | Skip orphan inside strong      | Consume to delim | (1) #***              | (2) a***#, a***                    | (3) #***a, ***a                  | (4) ***#                 | (5) #***#                         | (6) a***a
      rDelimAst: /^[^_*]*?__[^_*]*?\*[^_*]*?(?=__)|[^*]+(?=[^*])|(?!\*)[punct](\*+)(?=[\s]|$)|[^punct\s](\*+)(?!\*)(?=[punct\s]|$)|(?!\*)[punct\s](\*+)(?=[^punct\s])|[\s](\*+)(?!\*)(?=[punct])|(?!\*)[punct](\*+)(?!\*)(?=[punct])|[^punct\s](\*+)(?=[^punct\s])/,
      rDelimUnd: /^[^_*]*?\*\*[^_*]*?_[^_*]*?(?=\*\*)|[^_]+(?=[^_])|(?!_)[punct](_+)(?=[\s]|$)|[^punct\s](_+)(?!_)(?=[punct\s]|$)|(?!_)[punct\s](_+)(?=[^punct\s])|[\s](_+)(?!_)(?=[punct])|(?!_)[punct](_+)(?!_)(?=[punct])/ // ^- Not allowed for _
    },

    code: /^(`+)([^`]|[^`][\s\S]*?[^`])\1(?!`)/,
    br: /^( {2,}|\\)\n(?!\s*$)/,
    del: noopTest,
    text: /^(`+|[^`])(?:(?= {2,}\n)|[\s\S]*?(?:(?=[\\<!\[`*_]|\b_|$)|[^ ](?= {2,}\n)))/,
    punctuation: /^((?![*_])[\spunctuation])/
  };

  // list of unicode punctuation marks, plus any missing characters from CommonMark spec
  inline._punctuation = '\\p{P}$+<=>`^|~';
  inline.punctuation = edit(inline.punctuation, 'u').replace(/punctuation/g, inline._punctuation).getRegex();

  // sequences em should skip over [title](link), `code`, <html>
  inline.blockSkip = /\[[^[\]]*?\]\([^\(\)]*?\)|`[^`]*?`|<[^<>]*?>/g;
  inline.anyPunctuation = /\\[punct]/g;
  inline._escapes = /\\([punct])/g;
  inline._comment = edit(block._comment).replace('(?:-->|$)', '-->').getRegex();
  inline.emStrong.lDelim = edit(inline.emStrong.lDelim, 'u').replace(/punct/g, inline._punctuation).getRegex();
  inline.emStrong.rDelimAst = edit(inline.emStrong.rDelimAst, 'gu').replace(/punct/g, inline._punctuation).getRegex();
  inline.emStrong.rDelimUnd = edit(inline.emStrong.rDelimUnd, 'gu').replace(/punct/g, inline._punctuation).getRegex();
  inline.anyPunctuation = edit(inline.anyPunctuation, 'gu').replace(/punct/g, inline._punctuation).getRegex();
  inline._escapes = edit(inline._escapes, 'gu').replace(/punct/g, inline._punctuation).getRegex();
  inline._scheme = /[a-zA-Z][a-zA-Z0-9+.-]{1,31}/;
  inline._email = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+(@)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+(?![-_])/;
  inline.autolink = edit(inline.autolink).replace('scheme', inline._scheme).replace('email', inline._email).getRegex();
  inline._attribute = /\s+[a-zA-Z:_][\w.:-]*(?:\s*=\s*"[^"]*"|\s*=\s*'[^']*'|\s*=\s*[^\s"'=<>`]+)?/;
  inline.tag = edit(inline.tag).replace('comment', inline._comment).replace('attribute', inline._attribute).getRegex();
  inline._label = /(?:\[(?:\\.|[^\[\]\\])*\]|\\.|`[^`]*`|[^\[\]\\`])*?/;
  inline._href = /<(?:\\.|[^\n<>\\])+>|[^\s\x00-\x1f]*/;
  inline._title = /"(?:\\"?|[^"\\])*"|'(?:\\'?|[^'\\])*'|\((?:\\\)?|[^)\\])*\)/;
  inline.link = edit(inline.link).replace('label', inline._label).replace('href', inline._href).replace('title', inline._title).getRegex();
  inline.reflink = edit(inline.reflink).replace('label', inline._label).replace('ref', block._label).getRegex();
  inline.nolink = edit(inline.nolink).replace('ref', block._label).getRegex();
  inline.reflinkSearch = edit(inline.reflinkSearch, 'g').replace('reflink', inline.reflink).replace('nolink', inline.nolink).getRegex();

  /**
   * Normal Inline Grammar
   */

  inline.normal = _extends({}, inline);

  /**
   * Pedantic Inline Grammar
   */

  inline.pedantic = _extends({}, inline.normal, {
    strong: {
      start: /^__|\*\*/,
      middle: /^__(?=\S)([\s\S]*?\S)__(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,
      endAst: /\*\*(?!\*)/g,
      endUnd: /__(?!_)/g
    },
    em: {
      start: /^_|\*/,
      middle: /^()\*(?=\S)([\s\S]*?\S)\*(?!\*)|^_(?=\S)([\s\S]*?\S)_(?!_)/,
      endAst: /\*(?!\*)/g,
      endUnd: /_(?!_)/g
    },
    link: edit(/^!?\[(label)\]\((.*?)\)/).replace('label', inline._label).getRegex(),
    reflink: edit(/^!?\[(label)\]\s*\[([^\]]*)\]/).replace('label', inline._label).getRegex()
  });

  /**
   * GFM Inline Grammar
   */

  inline.gfm = _extends({}, inline.normal, {
    escape: edit(inline.escape).replace('])', '~|])').getRegex(),
    _extended_email: /[A-Za-z0-9._+-]+(@)[a-zA-Z0-9-_]+(?:\.[a-zA-Z0-9-_]*[a-zA-Z0-9])+(?![-_])/,
    url: /^((?:ftp|https?):\/\/|www\.)(?:[a-zA-Z0-9\-]+\.?)+[^\s<]*|^email/,
    _backpedal: /(?:[^?!.,:;*_'"~()&]+|\([^)]*\)|&(?![a-zA-Z0-9]+;$)|[?!.,:;*_'"~)]+(?!$))+/,
    del: /^(~~?)(?=[^\s~])([\s\S]*?[^\s~])\1(?=[^~]|$)/,
    text: /^([`~]+|[^`~])(?:(?= {2,}\n)|(?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)|[\s\S]*?(?:(?=[\\<!\[`*~_]|\b_|https?:\/\/|ftp:\/\/|www\.|$)|[^ ](?= {2,}\n)|[^a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-](?=[a-zA-Z0-9.!#$%&'*+\/=?_`{\|}~-]+@)))/
  });
  inline.gfm.url = edit(inline.gfm.url, 'i').replace('email', inline.gfm._extended_email).getRegex();
  /**
   * GFM + Line Breaks Inline Grammar
   */

  inline.breaks = _extends({}, inline.gfm, {
    br: edit(inline.br).replace('{2,}', '*').getRegex(),
    text: edit(inline.gfm.text).replace('\\b_', '\\b_| {2,}\\n').replace(/\{2,\}/g, '*').getRegex()
  });

  /**
   * smartypants text replacement
   * @param {string} text
   */
  function smartypants(text) {
    return text
    // em-dashes
    .replace(/---/g, "\u2014")
    // en-dashes
    .replace(/--/g, "\u2013")
    // opening singles
    .replace(/(^|[-\u2014/(\[{"\s])'/g, "$1\u2018")
    // closing singles & apostrophes
    .replace(/'/g, "\u2019")
    // opening doubles
    .replace(/(^|[-\u2014/(\[{\u2018\s])"/g, "$1\u201C")
    // closing doubles
    .replace(/"/g, "\u201D")
    // ellipses
    .replace(/\.{3}/g, "\u2026");
  }

  /**
   * mangle email addresses
   * @param {string} text
   */
  function mangle(text) {
    var out = '',
      i,
      ch;
    var l = text.length;
    for (i = 0; i < l; i++) {
      ch = text.charCodeAt(i);
      if (Math.random() > 0.5) {
        ch = 'x' + ch.toString(16);
      }
      out += '&#' + ch + ';';
    }
    return out;
  }

  /**
   * Block Lexer
   */
  var Lexer = /*#__PURE__*/function () {
    function Lexer(options) {
      this.tokens = [];
      this.tokens.links = Object.create(null);
      this.options = options || exports.defaults;
      this.options.tokenizer = this.options.tokenizer || new Tokenizer();
      this.tokenizer = this.options.tokenizer;
      this.tokenizer.options = this.options;
      this.tokenizer.lexer = this;
      this.inlineQueue = [];
      this.state = {
        inLink: false,
        inRawBlock: false,
        top: true
      };
      var rules = {
        block: block.normal,
        inline: inline.normal
      };
      if (this.options.pedantic) {
        rules.block = block.pedantic;
        rules.inline = inline.pedantic;
      } else if (this.options.gfm) {
        rules.block = block.gfm;
        if (this.options.breaks) {
          rules.inline = inline.breaks;
        } else {
          rules.inline = inline.gfm;
        }
      }
      this.tokenizer.rules = rules;
    }

    /**
     * Expose Rules
     */
    /**
     * Static Lex Method
     */
    Lexer.lex = function lex(src, options) {
      var lexer = new Lexer(options);
      return lexer.lex(src);
    }

    /**
     * Static Lex Inline Method
     */;
    Lexer.lexInline = function lexInline(src, options) {
      var lexer = new Lexer(options);
      return lexer.inlineTokens(src);
    }

    /**
     * Preprocessing
     */;
    var _proto = Lexer.prototype;
    _proto.lex = function lex(src) {
      src = src.replace(/\r\n|\r/g, '\n');
      this.blockTokens(src, this.tokens);
      var next;
      while (next = this.inlineQueue.shift()) {
        this.inlineTokens(next.src, next.tokens);
      }
      return this.tokens;
    }

    /**
     * Lexing
     */;
    _proto.blockTokens = function blockTokens(src, tokens) {
      var _this = this;
      if (tokens === void 0) {
        tokens = [];
      }
      if (this.options.pedantic) {
        src = src.replace(/\t/g, '    ').replace(/^ +$/gm, '');
      } else {
        src = src.replace(/^( *)(\t+)/gm, function (_, leading, tabs) {
          return leading + '    '.repeat(tabs.length);
        });
      }
      var token, lastToken, cutSrc, lastParagraphClipped;
      var _loop = function _loop() {
        if (_this.options.extensions && _this.options.extensions.block && _this.options.extensions.block.some(function (extTokenizer) {
          if (token = extTokenizer.call({
            lexer: _this
          }, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }
          return false;
        })) {
          return "continue";
        }

        // newline
        if (token = _this.tokenizer.space(src)) {
          src = src.substring(token.raw.length);
          if (token.raw.length === 1 && tokens.length > 0) {
            // if there's a single \n as a spacer, it's terminating the last line,
            // so move it there so that we don't get unecessary paragraph tags
            tokens[tokens.length - 1].raw += '\n';
          } else {
            tokens.push(token);
          }
          return "continue";
        }

        // code
        if (token = _this.tokenizer.code(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          // An indented code block cannot interrupt a paragraph.
          if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
            _this.inlineQueue[_this.inlineQueue.length - 1].src = lastToken.text;
          } else {
            tokens.push(token);
          }
          return "continue";
        }

        // fences
        if (token = _this.tokenizer.fences(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // heading
        if (token = _this.tokenizer.heading(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // hr
        if (token = _this.tokenizer.hr(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // blockquote
        if (token = _this.tokenizer.blockquote(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // list
        if (token = _this.tokenizer.list(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // html
        if (token = _this.tokenizer.html(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // def
        if (token = _this.tokenizer.def(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && (lastToken.type === 'paragraph' || lastToken.type === 'text')) {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.raw;
            _this.inlineQueue[_this.inlineQueue.length - 1].src = lastToken.text;
          } else if (!_this.tokens.links[token.tag]) {
            _this.tokens.links[token.tag] = {
              href: token.href,
              title: token.title
            };
          }
          return "continue";
        }

        // table (gfm)
        if (token = _this.tokenizer.table(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // lheading
        if (token = _this.tokenizer.lheading(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // top-level paragraph
        // prevent paragraph consuming extensions by clipping 'src' to extension start
        cutSrc = src;
        if (_this.options.extensions && _this.options.extensions.startBlock) {
          var startIndex = Infinity;
          var tempSrc = src.slice(1);
          var tempStart;
          _this.options.extensions.startBlock.forEach(function (getStartIndex) {
            tempStart = getStartIndex.call({
              lexer: this
            }, tempSrc);
            if (typeof tempStart === 'number' && tempStart >= 0) {
              startIndex = Math.min(startIndex, tempStart);
            }
          });
          if (startIndex < Infinity && startIndex >= 0) {
            cutSrc = src.substring(0, startIndex + 1);
          }
        }
        if (_this.state.top && (token = _this.tokenizer.paragraph(cutSrc))) {
          lastToken = tokens[tokens.length - 1];
          if (lastParagraphClipped && lastToken.type === 'paragraph') {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
            _this.inlineQueue.pop();
            _this.inlineQueue[_this.inlineQueue.length - 1].src = lastToken.text;
          } else {
            tokens.push(token);
          }
          lastParagraphClipped = cutSrc.length !== src.length;
          src = src.substring(token.raw.length);
          return "continue";
        }

        // text
        if (token = _this.tokenizer.text(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && lastToken.type === 'text') {
            lastToken.raw += '\n' + token.raw;
            lastToken.text += '\n' + token.text;
            _this.inlineQueue.pop();
            _this.inlineQueue[_this.inlineQueue.length - 1].src = lastToken.text;
          } else {
            tokens.push(token);
          }
          return "continue";
        }
        if (src) {
          var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
          if (_this.options.silent) {
            console.error(errMsg);
            return "break";
          } else {
            throw new Error(errMsg);
          }
        }
      };
      while (src) {
        var _ret = _loop();
        if (_ret === "continue") continue;
        if (_ret === "break") break;
      }
      this.state.top = true;
      return tokens;
    };
    _proto.inline = function inline(src, tokens) {
      if (tokens === void 0) {
        tokens = [];
      }
      this.inlineQueue.push({
        src: src,
        tokens: tokens
      });
      return tokens;
    }

    /**
     * Lexing/Compiling
     */;
    _proto.inlineTokens = function inlineTokens(src, tokens) {
      var _this2 = this;
      if (tokens === void 0) {
        tokens = [];
      }
      var token, lastToken, cutSrc;

      // String with links masked to avoid interference with em and strong
      var maskedSrc = src;
      var match;
      var keepPrevChar, prevChar;

      // Mask out reflinks
      if (this.tokens.links) {
        var links = Object.keys(this.tokens.links);
        if (links.length > 0) {
          while ((match = this.tokenizer.rules.inline.reflinkSearch.exec(maskedSrc)) != null) {
            if (links.includes(match[0].slice(match[0].lastIndexOf('[') + 1, -1))) {
              maskedSrc = maskedSrc.slice(0, match.index) + '[' + 'a'.repeat(match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.reflinkSearch.lastIndex);
            }
          }
        }
      }
      // Mask out other blocks
      while ((match = this.tokenizer.rules.inline.blockSkip.exec(maskedSrc)) != null) {
        maskedSrc = maskedSrc.slice(0, match.index) + '[' + 'a'.repeat(match[0].length - 2) + ']' + maskedSrc.slice(this.tokenizer.rules.inline.blockSkip.lastIndex);
      }

      // Mask out escaped characters
      while ((match = this.tokenizer.rules.inline.anyPunctuation.exec(maskedSrc)) != null) {
        maskedSrc = maskedSrc.slice(0, match.index) + '++' + maskedSrc.slice(this.tokenizer.rules.inline.anyPunctuation.lastIndex);
      }
      var _loop2 = function _loop2() {
        if (!keepPrevChar) {
          prevChar = '';
        }
        keepPrevChar = false;

        // extensions
        if (_this2.options.extensions && _this2.options.extensions.inline && _this2.options.extensions.inline.some(function (extTokenizer) {
          if (token = extTokenizer.call({
            lexer: _this2
          }, src, tokens)) {
            src = src.substring(token.raw.length);
            tokens.push(token);
            return true;
          }
          return false;
        })) {
          return "continue";
        }

        // escape
        if (token = _this2.tokenizer.escape(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // tag
        if (token = _this2.tokenizer.tag(src)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && token.type === 'text' && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }
          return "continue";
        }

        // link
        if (token = _this2.tokenizer.link(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // reflink, nolink
        if (token = _this2.tokenizer.reflink(src, _this2.tokens.links)) {
          src = src.substring(token.raw.length);
          lastToken = tokens[tokens.length - 1];
          if (lastToken && token.type === 'text' && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }
          return "continue";
        }

        // em & strong
        if (token = _this2.tokenizer.emStrong(src, maskedSrc, prevChar)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // code
        if (token = _this2.tokenizer.codespan(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // br
        if (token = _this2.tokenizer.br(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // del (gfm)
        if (token = _this2.tokenizer.del(src)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // autolink
        if (token = _this2.tokenizer.autolink(src, mangle)) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // url (gfm)
        if (!_this2.state.inLink && (token = _this2.tokenizer.url(src, mangle))) {
          src = src.substring(token.raw.length);
          tokens.push(token);
          return "continue";
        }

        // text
        // prevent inlineText consuming extensions by clipping 'src' to extension start
        cutSrc = src;
        if (_this2.options.extensions && _this2.options.extensions.startInline) {
          var startIndex = Infinity;
          var tempSrc = src.slice(1);
          var tempStart;
          _this2.options.extensions.startInline.forEach(function (getStartIndex) {
            tempStart = getStartIndex.call({
              lexer: this
            }, tempSrc);
            if (typeof tempStart === 'number' && tempStart >= 0) {
              startIndex = Math.min(startIndex, tempStart);
            }
          });
          if (startIndex < Infinity && startIndex >= 0) {
            cutSrc = src.substring(0, startIndex + 1);
          }
        }
        if (token = _this2.tokenizer.inlineText(cutSrc, smartypants)) {
          src = src.substring(token.raw.length);
          if (token.raw.slice(-1) !== '_') {
            // Track prevChar before string of ____ started
            prevChar = token.raw.slice(-1);
          }
          keepPrevChar = true;
          lastToken = tokens[tokens.length - 1];
          if (lastToken && lastToken.type === 'text') {
            lastToken.raw += token.raw;
            lastToken.text += token.text;
          } else {
            tokens.push(token);
          }
          return "continue";
        }
        if (src) {
          var errMsg = 'Infinite loop on byte: ' + src.charCodeAt(0);
          if (_this2.options.silent) {
            console.error(errMsg);
            return "break";
          } else {
            throw new Error(errMsg);
          }
        }
      };
      while (src) {
        var _ret2 = _loop2();
        if (_ret2 === "continue") continue;
        if (_ret2 === "break") break;
      }
      return tokens;
    };
    _createClass(Lexer, null, [{
      key: "rules",
      get: function get() {
        return {
          block: block,
          inline: inline
        };
      }
    }]);
    return Lexer;
  }();

  /**
   * Renderer
   */
  var Renderer = /*#__PURE__*/function () {
    function Renderer(options) {
      this.options = options || exports.defaults;
    }
    var _proto = Renderer.prototype;
    _proto.code = function code(_code, infostring, escaped) {
      var lang = (infostring || '').match(/\S*/)[0];
      if (this.options.highlight) {
        var out = this.options.highlight(_code, lang);
        if (out != null && out !== _code) {
          escaped = true;
          _code = out;
        }
      }
      _code = _code.replace(/\n$/, '') + '\n';
      if (!lang) {
        return '<pre><code>' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
      }
      return '<pre><code class="' + this.options.langPrefix + escape(lang) + '">' + (escaped ? _code : escape(_code, true)) + '</code></pre>\n';
    }

    /**
     * @param {string} quote
     */;
    _proto.blockquote = function blockquote(quote) {
      return "<blockquote>\n" + quote + "</blockquote>\n";
    };
    _proto.html = function html(_html, block) {
      return _html;
    }

    /**
     * @param {string} text
     * @param {string} level
     * @param {string} raw
     * @param {any} slugger
     */;
    _proto.heading = function heading(text, level, raw, slugger) {
      if (this.options.headerIds) {
        var id = this.options.headerPrefix + slugger.slug(raw);
        return "<h" + level + " id=\"" + id + "\">" + text + "</h" + level + ">\n";
      }

      // ignore IDs
      return "<h" + level + ">" + text + "</h" + level + ">\n";
    };
    _proto.hr = function hr() {
      return this.options.xhtml ? '<hr/>\n' : '<hr>\n';
    };
    _proto.list = function list(body, ordered, start) {
      var type = ordered ? 'ol' : 'ul',
        startatt = ordered && start !== 1 ? ' start="' + start + '"' : '';
      return '<' + type + startatt + '>\n' + body + '</' + type + '>\n';
    }

    /**
     * @param {string} text
     */;
    _proto.listitem = function listitem(text) {
      return "<li>" + text + "</li>\n";
    };
    _proto.checkbox = function checkbox(checked) {
      return '<input ' + (checked ? 'checked="" ' : '') + 'disabled="" type="checkbox"' + (this.options.xhtml ? ' /' : '') + '> ';
    }

    /**
     * @param {string} text
     */;
    _proto.paragraph = function paragraph(text) {
      return "<p>" + text + "</p>\n";
    }

    /**
     * @param {string} header
     * @param {string} body
     */;
    _proto.table = function table(header, body) {
      if (body) body = "<tbody>" + body + "</tbody>";
      return '<table>\n' + '<thead>\n' + header + '</thead>\n' + body + '</table>\n';
    }

    /**
     * @param {string} content
     */;
    _proto.tablerow = function tablerow(content) {
      return "<tr>\n" + content + "</tr>\n";
    };
    _proto.tablecell = function tablecell(content, flags) {
      var type = flags.header ? 'th' : 'td';
      var tag = flags.align ? "<" + type + " align=\"" + flags.align + "\">" : "<" + type + ">";
      return tag + content + ("</" + type + ">\n");
    }

    /**
     * span level renderer
     * @param {string} text
     */;
    _proto.strong = function strong(text) {
      return "<strong>" + text + "</strong>";
    }

    /**
     * @param {string} text
     */;
    _proto.em = function em(text) {
      return "<em>" + text + "</em>";
    }

    /**
     * @param {string} text
     */;
    _proto.codespan = function codespan(text) {
      return "<code>" + text + "</code>";
    };
    _proto.br = function br() {
      return this.options.xhtml ? '<br/>' : '<br>';
    }

    /**
     * @param {string} text
     */;
    _proto.del = function del(text) {
      return "<del>" + text + "</del>";
    }

    /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */;
    _proto.link = function link(href, title, text) {
      href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
      if (href === null) {
        return text;
      }
      var out = '<a href="' + href + '"';
      if (title) {
        out += ' title="' + title + '"';
      }
      out += '>' + text + '</a>';
      return out;
    }

    /**
     * @param {string} href
     * @param {string} title
     * @param {string} text
     */;
    _proto.image = function image(href, title, text) {
      href = cleanUrl(this.options.sanitize, this.options.baseUrl, href);
      if (href === null) {
        return text;
      }
      var out = "<img src=\"" + href + "\" alt=\"" + text + "\"";
      if (title) {
        out += " title=\"" + title + "\"";
      }
      out += this.options.xhtml ? '/>' : '>';
      return out;
    };
    _proto.text = function text(_text) {
      return _text;
    };
    return Renderer;
  }();

  /**
   * TextRenderer
   * returns only the textual part of the token
   */
  var TextRenderer = /*#__PURE__*/function () {
    function TextRenderer() {}
    var _proto = TextRenderer.prototype;
    // no need for block level renderers
    _proto.strong = function strong(text) {
      return text;
    };
    _proto.em = function em(text) {
      return text;
    };
    _proto.codespan = function codespan(text) {
      return text;
    };
    _proto.del = function del(text) {
      return text;
    };
    _proto.html = function html(text) {
      return text;
    };
    _proto.text = function text(_text) {
      return _text;
    };
    _proto.link = function link(href, title, text) {
      return '' + text;
    };
    _proto.image = function image(href, title, text) {
      return '' + text;
    };
    _proto.br = function br() {
      return '';
    };
    return TextRenderer;
  }();

  /**
   * Slugger generates header id
   */
  var Slugger = /*#__PURE__*/function () {
    function Slugger() {
      this.seen = {};
    }

    /**
     * @param {string} value
     */
    var _proto = Slugger.prototype;
    _proto.serialize = function serialize(value) {
      return value.toLowerCase().trim()
      // remove html tags
      .replace(/<[!\/a-z].*?>/ig, '')
      // remove unwanted chars
      .replace(/[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~]/g, '').replace(/\s/g, '-');
    }

    /**
     * Finds the next safe (unique) slug to use
     * @param {string} originalSlug
     * @param {boolean} isDryRun
     */;
    _proto.getNextSafeSlug = function getNextSafeSlug(originalSlug, isDryRun) {
      var slug = originalSlug;
      var occurenceAccumulator = 0;
      if (this.seen.hasOwnProperty(slug)) {
        occurenceAccumulator = this.seen[originalSlug];
        do {
          occurenceAccumulator++;
          slug = originalSlug + '-' + occurenceAccumulator;
        } while (this.seen.hasOwnProperty(slug));
      }
      if (!isDryRun) {
        this.seen[originalSlug] = occurenceAccumulator;
        this.seen[slug] = 0;
      }
      return slug;
    }

    /**
     * Convert string to unique id
     * @param {object} [options]
     * @param {boolean} [options.dryrun] Generates the next unique slug without
     * updating the internal accumulator.
     */;
    _proto.slug = function slug(value, options) {
      if (options === void 0) {
        options = {};
      }
      var slug = this.serialize(value);
      return this.getNextSafeSlug(slug, options.dryrun);
    };
    return Slugger;
  }();

  /**
   * Parsing & Compiling
   */
  var Parser = /*#__PURE__*/function () {
    function Parser(options) {
      this.options = options || exports.defaults;
      this.options.renderer = this.options.renderer || new Renderer();
      this.renderer = this.options.renderer;
      this.renderer.options = this.options;
      this.textRenderer = new TextRenderer();
      this.slugger = new Slugger();
    }

    /**
     * Static Parse Method
     */
    Parser.parse = function parse(tokens, options) {
      var parser = new Parser(options);
      return parser.parse(tokens);
    }

    /**
     * Static Parse Inline Method
     */;
    Parser.parseInline = function parseInline(tokens, options) {
      var parser = new Parser(options);
      return parser.parseInline(tokens);
    }

    /**
     * Parse Loop
     */;
    var _proto = Parser.prototype;
    _proto.parse = function parse(tokens, top) {
      if (top === void 0) {
        top = true;
      }
      var out = '',
        i,
        j,
        k,
        l2,
        l3,
        row,
        cell,
        header,
        body,
        token,
        ordered,
        start,
        loose,
        itemBody,
        item,
        checked,
        task,
        checkbox,
        ret;
      var l = tokens.length;
      for (i = 0; i < l; i++) {
        token = tokens[i];

        // Run any renderer extensions
        if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
          ret = this.options.extensions.renderers[token.type].call({
            parser: this
          }, token);
          if (ret !== false || !['space', 'hr', 'heading', 'code', 'table', 'blockquote', 'list', 'html', 'paragraph', 'text'].includes(token.type)) {
            out += ret || '';
            continue;
          }
        }
        switch (token.type) {
          case 'space':
            {
              continue;
            }
          case 'hr':
            {
              out += this.renderer.hr();
              continue;
            }
          case 'heading':
            {
              out += this.renderer.heading(this.parseInline(token.tokens), token.depth, unescape(this.parseInline(token.tokens, this.textRenderer)), this.slugger);
              continue;
            }
          case 'code':
            {
              out += this.renderer.code(token.text, token.lang, token.escaped);
              continue;
            }
          case 'table':
            {
              header = '';

              // header
              cell = '';
              l2 = token.header.length;
              for (j = 0; j < l2; j++) {
                cell += this.renderer.tablecell(this.parseInline(token.header[j].tokens), {
                  header: true,
                  align: token.align[j]
                });
              }
              header += this.renderer.tablerow(cell);
              body = '';
              l2 = token.rows.length;
              for (j = 0; j < l2; j++) {
                row = token.rows[j];
                cell = '';
                l3 = row.length;
                for (k = 0; k < l3; k++) {
                  cell += this.renderer.tablecell(this.parseInline(row[k].tokens), {
                    header: false,
                    align: token.align[k]
                  });
                }
                body += this.renderer.tablerow(cell);
              }
              out += this.renderer.table(header, body);
              continue;
            }
          case 'blockquote':
            {
              body = this.parse(token.tokens);
              out += this.renderer.blockquote(body);
              continue;
            }
          case 'list':
            {
              ordered = token.ordered;
              start = token.start;
              loose = token.loose;
              l2 = token.items.length;
              body = '';
              for (j = 0; j < l2; j++) {
                item = token.items[j];
                checked = item.checked;
                task = item.task;
                itemBody = '';
                if (item.task) {
                  checkbox = this.renderer.checkbox(checked);
                  if (loose) {
                    if (item.tokens.length > 0 && item.tokens[0].type === 'paragraph') {
                      item.tokens[0].text = checkbox + ' ' + item.tokens[0].text;
                      if (item.tokens[0].tokens && item.tokens[0].tokens.length > 0 && item.tokens[0].tokens[0].type === 'text') {
                        item.tokens[0].tokens[0].text = checkbox + ' ' + item.tokens[0].tokens[0].text;
                      }
                    } else {
                      item.tokens.unshift({
                        type: 'text',
                        text: checkbox
                      });
                    }
                  } else {
                    itemBody += checkbox;
                  }
                }
                itemBody += this.parse(item.tokens, loose);
                body += this.renderer.listitem(itemBody, task, checked);
              }
              out += this.renderer.list(body, ordered, start);
              continue;
            }
          case 'html':
            {
              out += this.renderer.html(token.text, token.block);
              continue;
            }
          case 'paragraph':
            {
              out += this.renderer.paragraph(this.parseInline(token.tokens));
              continue;
            }
          case 'text':
            {
              body = token.tokens ? this.parseInline(token.tokens) : token.text;
              while (i + 1 < l && tokens[i + 1].type === 'text') {
                token = tokens[++i];
                body += '\n' + (token.tokens ? this.parseInline(token.tokens) : token.text);
              }
              out += top ? this.renderer.paragraph(body) : body;
              continue;
            }
          default:
            {
              var errMsg = 'Token with "' + token.type + '" type was not found.';
              if (this.options.silent) {
                console.error(errMsg);
                return;
              } else {
                throw new Error(errMsg);
              }
            }
        }
      }
      return out;
    }

    /**
     * Parse Inline Tokens
     */;
    _proto.parseInline = function parseInline(tokens, renderer) {
      renderer = renderer || this.renderer;
      var out = '',
        i,
        token,
        ret;
      var l = tokens.length;
      for (i = 0; i < l; i++) {
        token = tokens[i];

        // Run any renderer extensions
        if (this.options.extensions && this.options.extensions.renderers && this.options.extensions.renderers[token.type]) {
          ret = this.options.extensions.renderers[token.type].call({
            parser: this
          }, token);
          if (ret !== false || !['escape', 'html', 'link', 'image', 'strong', 'em', 'codespan', 'br', 'del', 'text'].includes(token.type)) {
            out += ret || '';
            continue;
          }
        }
        switch (token.type) {
          case 'escape':
            {
              out += renderer.text(token.text);
              break;
            }
          case 'html':
            {
              out += renderer.html(token.text);
              break;
            }
          case 'link':
            {
              out += renderer.link(token.href, token.title, this.parseInline(token.tokens, renderer));
              break;
            }
          case 'image':
            {
              out += renderer.image(token.href, token.title, token.text);
              break;
            }
          case 'strong':
            {
              out += renderer.strong(this.parseInline(token.tokens, renderer));
              break;
            }
          case 'em':
            {
              out += renderer.em(this.parseInline(token.tokens, renderer));
              break;
            }
          case 'codespan':
            {
              out += renderer.codespan(token.text);
              break;
            }
          case 'br':
            {
              out += renderer.br();
              break;
            }
          case 'del':
            {
              out += renderer.del(this.parseInline(token.tokens, renderer));
              break;
            }
          case 'text':
            {
              out += renderer.text(token.text);
              break;
            }
          default:
            {
              var errMsg = 'Token with "' + token.type + '" type was not found.';
              if (this.options.silent) {
                console.error(errMsg);
                return;
              } else {
                throw new Error(errMsg);
              }
            }
        }
      }
      return out;
    };
    return Parser;
  }();

  var Hooks = /*#__PURE__*/function () {
    function Hooks(options) {
      this.options = options || exports.defaults;
    }
    var _proto = Hooks.prototype;
    /**
     * Process markdown before marked
     */
    _proto.preprocess = function preprocess(markdown) {
      return markdown;
    }

    /**
     * Process HTML after marked is finished
     */;
    _proto.postprocess = function postprocess(html) {
      return html;
    };
    return Hooks;
  }();
  Hooks.passThroughHooks = new Set(['preprocess', 'postprocess']);

  var _parseMarkdown = /*#__PURE__*/_classPrivateFieldLooseKey("parseMarkdown");
  var _onError = /*#__PURE__*/_classPrivateFieldLooseKey("onError");
  var Marked = /*#__PURE__*/function () {
    function Marked() {
      Object.defineProperty(this, _onError, {
        value: _onError2
      });
      Object.defineProperty(this, _parseMarkdown, {
        value: _parseMarkdown2
      });
      this.defaults = getDefaults();
      this.options = this.setOptions;
      this.parse = _classPrivateFieldLooseBase(this, _parseMarkdown)[_parseMarkdown](Lexer.lex, Parser.parse);
      this.parseInline = _classPrivateFieldLooseBase(this, _parseMarkdown)[_parseMarkdown](Lexer.lexInline, Parser.parseInline);
      this.Parser = Parser;
      this.parser = Parser.parse;
      this.Renderer = Renderer;
      this.TextRenderer = TextRenderer;
      this.Lexer = Lexer;
      this.lexer = Lexer.lex;
      this.Tokenizer = Tokenizer;
      this.Slugger = Slugger;
      this.Hooks = Hooks;
      this.use.apply(this, arguments);
    }
    var _proto = Marked.prototype;
    _proto.walkTokens = function walkTokens(tokens, callback) {
      var _this = this;
      var values = [];
      var _loop = function _loop() {
        var token = _step.value;
        values = values.concat(callback.call(_this, token));
        switch (token.type) {
          case 'table':
            {
              for (var _iterator2 = _createForOfIteratorHelperLoose(token.header), _step2; !(_step2 = _iterator2()).done;) {
                var cell = _step2.value;
                values = values.concat(_this.walkTokens(cell.tokens, callback));
              }
              for (var _iterator3 = _createForOfIteratorHelperLoose(token.rows), _step3; !(_step3 = _iterator3()).done;) {
                var row = _step3.value;
                for (var _iterator4 = _createForOfIteratorHelperLoose(row), _step4; !(_step4 = _iterator4()).done;) {
                  var _cell = _step4.value;
                  values = values.concat(_this.walkTokens(_cell.tokens, callback));
                }
              }
              break;
            }
          case 'list':
            {
              values = values.concat(_this.walkTokens(token.items, callback));
              break;
            }
          default:
            {
              if (_this.defaults.extensions && _this.defaults.extensions.childTokens && _this.defaults.extensions.childTokens[token.type]) {
                // Walk any extensions
                _this.defaults.extensions.childTokens[token.type].forEach(function (childTokens) {
                  values = values.concat(_this.walkTokens(token[childTokens], callback));
                });
              } else if (token.tokens) {
                values = values.concat(_this.walkTokens(token.tokens, callback));
              }
            }
        }
      };
      for (var _iterator = _createForOfIteratorHelperLoose(tokens), _step; !(_step = _iterator()).done;) {
        _loop();
      }
      return values;
    };
    _proto.use = function use() {
      var _this2 = this;
      var extensions = this.defaults.extensions || {
        renderers: {},
        childTokens: {}
      };
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      args.forEach(function (pack) {
        // copy options to new object
        var opts = _extends({}, pack);

        // set async to true if it was set to true before
        opts.async = _this2.defaults.async || opts.async || false;

        // ==-- Parse "addon" extensions --== //
        if (pack.extensions) {
          pack.extensions.forEach(function (ext) {
            if (!ext.name) {
              throw new Error('extension name required');
            }
            if (ext.renderer) {
              // Renderer extensions
              var prevRenderer = extensions.renderers[ext.name];
              if (prevRenderer) {
                // Replace extension with func to run new extension but fall back if false
                extensions.renderers[ext.name] = function () {
                  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                  }
                  var ret = ext.renderer.apply(this, args);
                  if (ret === false) {
                    ret = prevRenderer.apply(this, args);
                  }
                  return ret;
                };
              } else {
                extensions.renderers[ext.name] = ext.renderer;
              }
            }
            if (ext.tokenizer) {
              // Tokenizer Extensions
              if (!ext.level || ext.level !== 'block' && ext.level !== 'inline') {
                throw new Error("extension level must be 'block' or 'inline'");
              }
              if (extensions[ext.level]) {
                extensions[ext.level].unshift(ext.tokenizer);
              } else {
                extensions[ext.level] = [ext.tokenizer];
              }
              if (ext.start) {
                // Function to check for start of token
                if (ext.level === 'block') {
                  if (extensions.startBlock) {
                    extensions.startBlock.push(ext.start);
                  } else {
                    extensions.startBlock = [ext.start];
                  }
                } else if (ext.level === 'inline') {
                  if (extensions.startInline) {
                    extensions.startInline.push(ext.start);
                  } else {
                    extensions.startInline = [ext.start];
                  }
                }
              }
            }
            if (ext.childTokens) {
              // Child tokens to be visited by walkTokens
              extensions.childTokens[ext.name] = ext.childTokens;
            }
          });
          opts.extensions = extensions;
        }

        // ==-- Parse "overwrite" extensions --== //
        if (pack.renderer) {
          var renderer = _this2.defaults.renderer || new Renderer(_this2.defaults);
          var _loop2 = function _loop2(prop) {
            var prevRenderer = renderer[prop];
            // Replace renderer with func to run extension, but fall back if false
            renderer[prop] = function () {
              for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
              }
              var ret = pack.renderer[prop].apply(renderer, args);
              if (ret === false) {
                ret = prevRenderer.apply(renderer, args);
              }
              return ret;
            };
          };
          for (var prop in pack.renderer) {
            _loop2(prop);
          }
          opts.renderer = renderer;
        }
        if (pack.tokenizer) {
          var tokenizer = _this2.defaults.tokenizer || new Tokenizer(_this2.defaults);
          var _loop3 = function _loop3(_prop) {
            var prevTokenizer = tokenizer[_prop];
            // Replace tokenizer with func to run extension, but fall back if false
            tokenizer[_prop] = function () {
              for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                args[_key4] = arguments[_key4];
              }
              var ret = pack.tokenizer[_prop].apply(tokenizer, args);
              if (ret === false) {
                ret = prevTokenizer.apply(tokenizer, args);
              }
              return ret;
            };
          };
          for (var _prop in pack.tokenizer) {
            _loop3(_prop);
          }
          opts.tokenizer = tokenizer;
        }

        // ==-- Parse Hooks extensions --== //
        if (pack.hooks) {
          var hooks = _this2.defaults.hooks || new Hooks();
          var _loop4 = function _loop4(_prop2) {
            var prevHook = hooks[_prop2];
            if (Hooks.passThroughHooks.has(_prop2)) {
              hooks[_prop2] = function (arg) {
                if (_this2.defaults.async) {
                  return Promise.resolve(pack.hooks[_prop2].call(hooks, arg)).then(function (ret) {
                    return prevHook.call(hooks, ret);
                  });
                }
                var ret = pack.hooks[_prop2].call(hooks, arg);
                return prevHook.call(hooks, ret);
              };
            } else {
              hooks[_prop2] = function () {
                for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                  args[_key5] = arguments[_key5];
                }
                var ret = pack.hooks[_prop2].apply(hooks, args);
                if (ret === false) {
                  ret = prevHook.apply(hooks, args);
                }
                return ret;
              };
            }
          };
          for (var _prop2 in pack.hooks) {
            _loop4(_prop2);
          }
          opts.hooks = hooks;
        }

        // ==-- Parse WalkTokens extensions --== //
        if (pack.walkTokens) {
          var walkTokens = _this2.defaults.walkTokens;
          opts.walkTokens = function (token) {
            var values = [];
            values.push(pack.walkTokens.call(this, token));
            if (walkTokens) {
              values = values.concat(walkTokens.call(this, token));
            }
            return values;
          };
        }
        _this2.defaults = _extends({}, _this2.defaults, opts);
      });
      return this;
    };
    _proto.setOptions = function setOptions(opt) {
      this.defaults = _extends({}, this.defaults, opt);
      return this;
    };
    return Marked;
  }();
  function _parseMarkdown2(lexer, parser) {
    var _this3 = this;
    return function (src, opt, callback) {
      if (typeof opt === 'function') {
        callback = opt;
        opt = null;
      }
      var origOpt = _extends({}, opt);
      opt = _extends({}, _this3.defaults, origOpt);
      var throwError = _classPrivateFieldLooseBase(_this3, _onError)[_onError](opt.silent, opt.async, callback);

      // throw error in case of non string input
      if (typeof src === 'undefined' || src === null) {
        return throwError(new Error('marked(): input parameter is undefined or null'));
      }
      if (typeof src !== 'string') {
        return throwError(new Error('marked(): input parameter is of type ' + Object.prototype.toString.call(src) + ', string expected'));
      }
      checkDeprecations(opt, callback);
      if (opt.hooks) {
        opt.hooks.options = opt;
      }
      if (callback) {
        var highlight = opt.highlight;
        var tokens;
        try {
          if (opt.hooks) {
            src = opt.hooks.preprocess(src);
          }
          tokens = lexer(src, opt);
        } catch (e) {
          return throwError(e);
        }
        var done = function done(err) {
          var out;
          if (!err) {
            try {
              if (opt.walkTokens) {
                _this3.walkTokens(tokens, opt.walkTokens);
              }
              out = parser(tokens, opt);
              if (opt.hooks) {
                out = opt.hooks.postprocess(out);
              }
            } catch (e) {
              err = e;
            }
          }
          opt.highlight = highlight;
          return err ? throwError(err) : callback(null, out);
        };
        if (!highlight || highlight.length < 3) {
          return done();
        }
        delete opt.highlight;
        if (!tokens.length) return done();
        var pending = 0;
        _this3.walkTokens(tokens, function (token) {
          if (token.type === 'code') {
            pending++;
            setTimeout(function () {
              highlight(token.text, token.lang, function (err, code) {
                if (err) {
                  return done(err);
                }
                if (code != null && code !== token.text) {
                  token.text = code;
                  token.escaped = true;
                }
                pending--;
                if (pending === 0) {
                  done();
                }
              });
            }, 0);
          }
        });
        if (pending === 0) {
          done();
        }
        return;
      }
      if (opt.async) {
        return Promise.resolve(opt.hooks ? opt.hooks.preprocess(src) : src).then(function (src) {
          return lexer(src, opt);
        }).then(function (tokens) {
          return opt.walkTokens ? Promise.all(_this3.walkTokens(tokens, opt.walkTokens)).then(function () {
            return tokens;
          }) : tokens;
        }).then(function (tokens) {
          return parser(tokens, opt);
        }).then(function (html) {
          return opt.hooks ? opt.hooks.postprocess(html) : html;
        })["catch"](throwError);
      }
      try {
        if (opt.hooks) {
          src = opt.hooks.preprocess(src);
        }
        var _tokens = lexer(src, opt);
        if (opt.walkTokens) {
          _this3.walkTokens(_tokens, opt.walkTokens);
        }
        var html = parser(_tokens, opt);
        if (opt.hooks) {
          html = opt.hooks.postprocess(html);
        }
        return html;
      } catch (e) {
        return throwError(e);
      }
    };
  }
  function _onError2(silent, async, callback) {
    return function (e) {
      e.message += '\nPlease report this to https://github.com/markedjs/marked.';
      if (silent) {
        var msg = '<p>An error occurred:</p><pre>' + escape(e.message + '', true) + '</pre>';
        if (async) {
          return Promise.resolve(msg);
        }
        if (callback) {
          callback(null, msg);
          return;
        }
        return msg;
      }
      if (async) {
        return Promise.reject(e);
      }
      if (callback) {
        callback(e);
        return;
      }
      throw e;
    };
  }

  var markedInstance = new Marked(exports.defaults);

  /**
   * Marked
   */
  function marked(src, opt, callback) {
    return markedInstance.parse(src, opt, callback);
  }

  /**
   * Options
   */

  marked.options = marked.setOptions = function (opt) {
    markedInstance.setOptions(opt);
    marked.defaults = markedInstance.defaults;
    changeDefaults(marked.defaults);
    return marked;
  };
  marked.getDefaults = getDefaults;
  marked.defaults = exports.defaults;

  /**
   * Use Extension
   */

  marked.use = function () {
    markedInstance.use.apply(markedInstance, arguments);
    marked.defaults = markedInstance.defaults;
    changeDefaults(marked.defaults);
    return marked;
  };

  /**
   * Run callback for every token
   */

  marked.walkTokens = function (tokens, callback) {
    return markedInstance.walkTokens(tokens, callback);
  };

  /**
   * Parse Inline
   * @param {string} src
   */
  marked.parseInline = markedInstance.parseInline;

  /**
   * Expose
   */
  marked.Parser = Parser;
  marked.parser = Parser.parse;
  marked.Renderer = Renderer;
  marked.TextRenderer = TextRenderer;
  marked.Lexer = Lexer;
  marked.lexer = Lexer.lex;
  marked.Tokenizer = Tokenizer;
  marked.Slugger = Slugger;
  marked.Hooks = Hooks;
  marked.parse = marked;
  var options = marked.options;
  var setOptions = marked.setOptions;
  var use = marked.use;
  var walkTokens = marked.walkTokens;
  var parseInline = marked.parseInline;
  var parse = marked;
  var parser = Parser.parse;
  var lexer = Lexer.lex;

  exports.Hooks = Hooks;
  exports.Lexer = Lexer;
  exports.Marked = Marked;
  exports.Parser = Parser;
  exports.Renderer = Renderer;
  exports.Slugger = Slugger;
  exports.TextRenderer = TextRenderer;
  exports.Tokenizer = Tokenizer;
  exports.getDefaults = getDefaults;
  exports.lexer = lexer;
  exports.marked = marked;
  exports.options = options;
  exports.parse = parse;
  exports.parseInline = parseInline;
  exports.parser = parser;
  exports.setOptions = setOptions;
  exports.use = use;
  exports.walkTokens = walkTokens;

}));


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(41)
var HashBase = __webpack_require__(1238)
var Buffer = __webpack_require__(42).Buffer

var ARRAY16 = new Array(16)

function MD5 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
}

inherits(MD5, HashBase)

MD5.prototype._update = function () {
  var M = ARRAY16
  for (var i = 0; i < 16; ++i) M[i] = this._block.readInt32LE(i * 4)

  var a = this._a
  var b = this._b
  var c = this._c
  var d = this._d

  a = fnF(a, b, c, d, M[0], 0xd76aa478, 7)
  d = fnF(d, a, b, c, M[1], 0xe8c7b756, 12)
  c = fnF(c, d, a, b, M[2], 0x242070db, 17)
  b = fnF(b, c, d, a, M[3], 0xc1bdceee, 22)
  a = fnF(a, b, c, d, M[4], 0xf57c0faf, 7)
  d = fnF(d, a, b, c, M[5], 0x4787c62a, 12)
  c = fnF(c, d, a, b, M[6], 0xa8304613, 17)
  b = fnF(b, c, d, a, M[7], 0xfd469501, 22)
  a = fnF(a, b, c, d, M[8], 0x698098d8, 7)
  d = fnF(d, a, b, c, M[9], 0x8b44f7af, 12)
  c = fnF(c, d, a, b, M[10], 0xffff5bb1, 17)
  b = fnF(b, c, d, a, M[11], 0x895cd7be, 22)
  a = fnF(a, b, c, d, M[12], 0x6b901122, 7)
  d = fnF(d, a, b, c, M[13], 0xfd987193, 12)
  c = fnF(c, d, a, b, M[14], 0xa679438e, 17)
  b = fnF(b, c, d, a, M[15], 0x49b40821, 22)

  a = fnG(a, b, c, d, M[1], 0xf61e2562, 5)
  d = fnG(d, a, b, c, M[6], 0xc040b340, 9)
  c = fnG(c, d, a, b, M[11], 0x265e5a51, 14)
  b = fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20)
  a = fnG(a, b, c, d, M[5], 0xd62f105d, 5)
  d = fnG(d, a, b, c, M[10], 0x02441453, 9)
  c = fnG(c, d, a, b, M[15], 0xd8a1e681, 14)
  b = fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20)
  a = fnG(a, b, c, d, M[9], 0x21e1cde6, 5)
  d = fnG(d, a, b, c, M[14], 0xc33707d6, 9)
  c = fnG(c, d, a, b, M[3], 0xf4d50d87, 14)
  b = fnG(b, c, d, a, M[8], 0x455a14ed, 20)
  a = fnG(a, b, c, d, M[13], 0xa9e3e905, 5)
  d = fnG(d, a, b, c, M[2], 0xfcefa3f8, 9)
  c = fnG(c, d, a, b, M[7], 0x676f02d9, 14)
  b = fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20)

  a = fnH(a, b, c, d, M[5], 0xfffa3942, 4)
  d = fnH(d, a, b, c, M[8], 0x8771f681, 11)
  c = fnH(c, d, a, b, M[11], 0x6d9d6122, 16)
  b = fnH(b, c, d, a, M[14], 0xfde5380c, 23)
  a = fnH(a, b, c, d, M[1], 0xa4beea44, 4)
  d = fnH(d, a, b, c, M[4], 0x4bdecfa9, 11)
  c = fnH(c, d, a, b, M[7], 0xf6bb4b60, 16)
  b = fnH(b, c, d, a, M[10], 0xbebfbc70, 23)
  a = fnH(a, b, c, d, M[13], 0x289b7ec6, 4)
  d = fnH(d, a, b, c, M[0], 0xeaa127fa, 11)
  c = fnH(c, d, a, b, M[3], 0xd4ef3085, 16)
  b = fnH(b, c, d, a, M[6], 0x04881d05, 23)
  a = fnH(a, b, c, d, M[9], 0xd9d4d039, 4)
  d = fnH(d, a, b, c, M[12], 0xe6db99e5, 11)
  c = fnH(c, d, a, b, M[15], 0x1fa27cf8, 16)
  b = fnH(b, c, d, a, M[2], 0xc4ac5665, 23)

  a = fnI(a, b, c, d, M[0], 0xf4292244, 6)
  d = fnI(d, a, b, c, M[7], 0x432aff97, 10)
  c = fnI(c, d, a, b, M[14], 0xab9423a7, 15)
  b = fnI(b, c, d, a, M[5], 0xfc93a039, 21)
  a = fnI(a, b, c, d, M[12], 0x655b59c3, 6)
  d = fnI(d, a, b, c, M[3], 0x8f0ccc92, 10)
  c = fnI(c, d, a, b, M[10], 0xffeff47d, 15)
  b = fnI(b, c, d, a, M[1], 0x85845dd1, 21)
  a = fnI(a, b, c, d, M[8], 0x6fa87e4f, 6)
  d = fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10)
  c = fnI(c, d, a, b, M[6], 0xa3014314, 15)
  b = fnI(b, c, d, a, M[13], 0x4e0811a1, 21)
  a = fnI(a, b, c, d, M[4], 0xf7537e82, 6)
  d = fnI(d, a, b, c, M[11], 0xbd3af235, 10)
  c = fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15)
  b = fnI(b, c, d, a, M[9], 0xeb86d391, 21)

  this._a = (this._a + a) | 0
  this._b = (this._b + b) | 0
  this._c = (this._c + c) | 0
  this._d = (this._d + d) | 0
}

MD5.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.allocUnsafe(16)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fnF (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + b) | 0
}

function fnG (a, b, c, d, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + b) | 0
}

function fnH (a, b, c, d, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + b) | 0
}

function fnI (a, b, c, d, m, k, s) {
  return (rotl((a + ((c ^ (b | (~d)))) + m + k) | 0, s) + b) | 0
}

module.exports = MD5


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = $getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  var args = [];
  for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    ReflectApply(this.listener, this.target, args);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function') {
        throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
      }

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strictUriEncode = __webpack_require__(3499);
var objectAssign = __webpack_require__(121);

function encoderForArrayFormat(opts) {
	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, index) {
				return value === null ? [
					encode(key, opts),
					'[',
					index,
					']'
				].join('') : [
					encode(key, opts),
					'[',
					encode(index, opts),
					']=',
					encode(value, opts)
				].join('');
			};

		case 'bracket':
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'[]=',
					encode(value, opts)
				].join('');
			};

		default:
			return function (key, value) {
				return value === null ? encode(key, opts) : [
					encode(key, opts),
					'=',
					encode(value, opts)
				].join('');
			};
	}
}

function parserForArrayFormat(opts) {
	var result;

	switch (opts.arrayFormat) {
		case 'index':
			return function (key, value, accumulator) {
				result = /\[(\d*)\]$/.exec(key);

				key = key.replace(/\[\d*\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				}

				if (accumulator[key] === undefined) {
					accumulator[key] = {};
				}

				accumulator[key][result[1]] = value;
			};

		case 'bracket':
			return function (key, value, accumulator) {
				result = /(\[\])$/.exec(key);
				key = key.replace(/\[\]$/, '');

				if (!result) {
					accumulator[key] = value;
					return;
				} else if (accumulator[key] === undefined) {
					accumulator[key] = [value];
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};

		default:
			return function (key, value, accumulator) {
				if (accumulator[key] === undefined) {
					accumulator[key] = value;
					return;
				}

				accumulator[key] = [].concat(accumulator[key], value);
			};
	}
}

function encode(value, opts) {
	if (opts.encode) {
		return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
	}

	return value;
}

function keysSorter(input) {
	if (Array.isArray(input)) {
		return input.sort();
	} else if (typeof input === 'object') {
		return keysSorter(Object.keys(input)).sort(function (a, b) {
			return Number(a) - Number(b);
		}).map(function (key) {
			return input[key];
		});
	}

	return input;
}

exports.extract = function (str) {
	return str.split('?')[1] || '';
};

exports.parse = function (str, opts) {
	opts = objectAssign({arrayFormat: 'none'}, opts);

	var formatter = parserForArrayFormat(opts);

	// Create an object with no prototype
	// https://github.com/sindresorhus/query-string/issues/47
	var ret = Object.create(null);

	if (typeof str !== 'string') {
		return ret;
	}

	str = str.trim().replace(/^(\?|#|&)/, '');

	if (!str) {
		return ret;
	}

	str.split('&').forEach(function (param) {
		var parts = param.replace(/\+/g, ' ').split('=');
		// Firefox (pre 40) decodes `%3D` to `=`
		// https://github.com/sindresorhus/query-string/pull/37
		var key = parts.shift();
		var val = parts.length > 0 ? parts.join('=') : undefined;

		// missing `=` should be `null`:
		// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
		val = val === undefined ? null : decodeURIComponent(val);

		formatter(decodeURIComponent(key), val, ret);
	});

	return Object.keys(ret).sort().reduce(function (result, key) {
		var val = ret[key];
		if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
			// Sort object keys, not values
			result[key] = keysSorter(val);
		} else {
			result[key] = val;
		}

		return result;
	}, Object.create(null));
};

exports.stringify = function (obj, opts) {
	var defaults = {
		encode: true,
		strict: true,
		arrayFormat: 'none'
	};

	opts = objectAssign(defaults, opts);

	var formatter = encoderForArrayFormat(opts);

	return obj ? Object.keys(obj).sort().map(function (key) {
		var val = obj[key];

		if (val === undefined) {
			return '';
		}

		if (val === null) {
			return encode(key, opts);
		}

		if (Array.isArray(val)) {
			var result = [];

			val.slice().forEach(function (val2) {
				if (val2 === undefined) {
					return;
				}

				result.push(formatter(key, val2, result.length));
			});

			return result.join('&');
		}

		return encode(key, opts) + '=' + encode(val, opts);
	}).filter(function (x) {
		return x.length > 0;
	}).join('&') : '';
};


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Flex;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function toPercent(num) {
  return "".concat(num, "%");
}

function Flex(_ref) {
  var children = _ref.children,
      className = _ref.className,
      direction = _ref.direction,
      count = _ref.count,
      offset = _ref.offset,
      style = _ref.style,
      wrap = _ref.wrap,
      otherProps = _objectWithoutProperties(_ref, ["children", "className", "direction", "count", "offset", "style", "wrap"]);

  return _react["default"].createElement("div", _extends({
    className: className,
    style: _objectSpread({
      display: 'flex',
      flexDirection: direction,
      flexWrap: wrap ? 'wrap' : 'no-wrap'
    }, style)
  }, otherProps), _react["default"].Children.map(children, function (child, index) {
    return _react["default"].cloneElement(child, _objectSpread({}, child.props, {
      style: {
        flexBasis: toPercent(100 / count),
        maxWidth: toPercent(100 / count),
        overflow: 'hidden',
        marginLeft: offset && index === 0 ? toPercent(100 * offset / count) : null
      }
    }));
  }));
}

Flex.propTypes = {
  children: _propTypes["default"].node,
  className: _propTypes["default"].string,
  count: _propTypes["default"].number.isRequired,
  direction: _propTypes["default"].string,
  offset: _propTypes["default"].number,
  style: _propTypes["default"].objectOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])),
  wrap: _propTypes["default"].bool
};

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startAnimation = exports.formatNumber = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _countup = __webpack_require__(2825);

var _countup2 = _interopRequireDefault(_countup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Adapted from the countup.js format number function
// https://github.com/inorganik/countUp.js/blob/master/countUp.js#L46-L60
var formatNumber = exports.formatNumber = function formatNumber(start, options) {
  var neg = start < 0;
  var num = '' + Math.abs(start).toFixed(options.decimals);
  var x = num.split('.');
  var x1 = x[0];
  var x2 = x.length > 1 ? '' + options.decimal + x[1] : '';
  var rgx = /(\d+)(\d{3})/;

  if (options.separator) {
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, '$1' + options.separator + '$2');
    }
  }

  return '' + (neg ? '-' : '') + (options.prefix || '') + x1 + x2 + (options.suffix || '');
};

var startAnimation = exports.startAnimation = function startAnimation(component) {
  if (!(component && component.spanElement)) {
    throw new Error('You need to pass the CountUp component as an argument!\neg. this.myCountUp.startAnimation(this.myCountUp);');
  }

  var _component$props = component.props,
      decimal = _component$props.decimal,
      decimals = _component$props.decimals,
      duration = _component$props.duration,
      easingFn = _component$props.easingFn,
      end = _component$props.end,
      formattingFn = _component$props.formattingFn,
      onComplete = _component$props.onComplete,
      onStart = _component$props.onStart,
      prefix = _component$props.prefix,
      separator = _component$props.separator,
      start = _component$props.start,
      suffix = _component$props.suffix,
      useEasing = _component$props.useEasing;


  var countupInstance = new _countup2.default(component.spanElement, start, end, decimals, duration, {
    decimal: decimal,
    easingFn: easingFn,
    formattingFn: formattingFn,
    separator: separator,
    prefix: prefix,
    suffix: suffix,
    useEasing: useEasing,
    useGrouping: !!separator
  });

  if (typeof onStart === 'function') {
    onStart();
  }

  countupInstance.start(onComplete);
};

var CountUp = function (_React$Component) {
  _inherits(CountUp, _React$Component);

  function CountUp() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CountUp);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CountUp.__proto__ || Object.getPrototypeOf(CountUp)).call.apply(_ref, [this].concat(args))), _this), _this.spanElement = null, _this.refSpan = function (span) {
      _this.spanElement = span;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CountUp, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      startAnimation(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var hasCertainPropsChanged = this.props.duration !== nextProps.duration || this.props.end !== nextProps.end || this.props.start !== nextProps.start;

      return nextProps.redraw || hasCertainPropsChanged;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      startAnimation(this);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          start = _props.start,
          decimal = _props.decimal,
          decimals = _props.decimals,
          separator = _props.separator,
          prefix = _props.prefix,
          suffix = _props.suffix,
          style = _props.style,
          formattingFn = _props.formattingFn;


      return _react2.default.createElement(
        'span',
        { className: className, ref: this.refSpan, style: style },
        typeof formattingFn === 'function' ? formattingFn(start) : formatNumber(start, {
          decimal: decimal,
          decimals: decimals,
          separator: separator,
          prefix: prefix,
          suffix: suffix
        })
      );
    }
  }]);

  return CountUp;
}(_react2.default.Component);

CountUp.defaultProps = {
  className: undefined,
  decimal: '.',
  decimals: 0,
  duration: 3,
  easingFn: null,
  end: 100,
  formattingFn: null,
  onComplete: undefined,
  onStart: undefined,
  prefix: '',
  separator: '',
  start: 0,
  suffix: '',
  redraw: false,
  style: undefined,
  useEasing: true
};
exports.default = CountUp;

/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

/*
  Used as main file in package.json
*/

/* eslint-disable no-var */
/* eslint-env node */

var DayPicker = __webpack_require__(3171);
var DateUtils = __webpack_require__(287);
var LocaleUtils = __webpack_require__(460);
var ModifiersUtils = __webpack_require__(688);
var Weekday = __webpack_require__(1408);
var Navbar = __webpack_require__(1407);
var PropTypes = __webpack_require__(3173);

module.exports = DayPicker;
module.exports.DateUtils = DateUtils;
module.exports.LocaleUtils = LocaleUtils;
module.exports.ModifiersUtils = ModifiersUtils;
module.exports.WeekdayPropTypes = Weekday.propTypes;
module.exports.NavbarPropTypes = Navbar.propTypes;
module.exports.PropTypes = PropTypes;


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dayMatchesModifier = dayMatchesModifier;
exports.getModifiersForDay = getModifiersForDay;

var _DateUtils = __webpack_require__(287);

var _Helpers = __webpack_require__(459);

/**
 * Return `true` if a date matches the specified modifier.
 *
 * @export
 * @param {Date} day
 * @param {Any} modifier
 * @return {Boolean}
 */
function dayMatchesModifier(day, modifier) {
  if (!modifier) {
    return false;
  }
  var arr = Array.isArray(modifier) ? modifier : [modifier];
  return arr.some(function (mod) {
    if (!mod) {
      return false;
    }
    if (mod instanceof Date) {
      return (0, _DateUtils.isSameDay)(day, mod);
    }
    if ((0, _Helpers.isRangeOfDates)(mod)) {
      return (0, _DateUtils.isDayInRange)(day, mod);
    }
    if (mod.after && mod.before && (0, _DateUtils.isDayAfter)(mod.before, mod.after)) {
      return (0, _DateUtils.isDayAfter)(day, mod.after) && (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after && mod.before && ((0, _DateUtils.isDayAfter)(mod.after, mod.before) || (0, _DateUtils.isSameDay)(mod.after, mod.before))) {
      return (0, _DateUtils.isDayAfter)(day, mod.after) || (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.after) {
      return (0, _DateUtils.isDayAfter)(day, mod.after);
    }
    if (mod.before) {
      return (0, _DateUtils.isDayBefore)(day, mod.before);
    }
    if (mod.daysOfWeek) {
      return mod.daysOfWeek.some(function (dayOfWeek) {
        return day.getDay() === dayOfWeek;
      });
    }
    if (typeof mod === 'function') {
      return mod(day);
    }
    return false;
  });
}

/**
 * Return the modifiers matching the given day for the given
 * object of modifiers.
 *
 * @export
 * @param {Date} day
 * @param {Object} [modifiersObj={}]
 * @return {Array}
 */
function getModifiersForDay(day) {
  var modifiersObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.keys(modifiersObj).reduce(function (modifiers, modifierName) {
    var value = modifiersObj[modifierName];
    if (dayMatchesModifier(day, value)) {
      modifiers.push(modifierName);
    }
    return modifiers;
  }, []);
}

exports.default = { dayMatchesModifier: dayMatchesModifier, getModifiersForDay: getModifiersForDay };
//# sourceMappingURL=ModifiersUtils.js.map

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useTranslation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_js__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_js__ = __webpack_require__(465);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var usePrevious = function usePrevious(value, ignore) {
  var ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    ref.current = ignore ? ref.current : value;
  }, [value, ignore]);
  return ref.current;
};

function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__context_js__["a" /* I18nContext */]) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__context_js__["d" /* getI18n */])();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new __WEBPACK_IMPORTED_MODULE_4__context_js__["e" /* ReportNamespaces */]();

  if (!i18n) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_js__["b" /* warnOnce */])('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k, optsOrDefaultValue) {
      if (typeof optsOrDefaultValue === 'string') return optsOrDefaultValue;
      if (optsOrDefaultValue && __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_typeof___default()(optsOrDefaultValue) === 'object' && typeof optsOrDefaultValue.defaultValue === 'string') return optsOrDefaultValue.defaultValue;
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_js__["b" /* warnOnce */])('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = _objectSpread(_objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__context_js__["f" /* getDefaults */])()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense,
      keyPrefix = i18nOptions.keyPrefix;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_js__["c" /* hasLoadedNamespace */])(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
  }

  var _useState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useState"])(getT),
      _useState2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var joinedNS = namespaces.join();
  if (props.lng) joinedNS = "".concat(props.lng).concat(joinedNS);
  var previousJoinedNS = usePrevious(joinedNS);
  var isMounted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(true);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      if (props.lng) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_js__["d" /* loadLanguages */])(i18n, props.lng, namespaces, function () {
          if (isMounted.current) setT(getT);
        });
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_js__["e" /* loadNamespaces */])(i18n, namespaces, function () {
          if (isMounted.current) setT(getT);
        });
      }
    }

    if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) {
      setT(getT);
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, joinedNS]);
  var isInitial = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useRef"])(true);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["useEffect"])(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n, keyPrefix]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    if (props.lng) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_js__["d" /* loadLanguages */])(i18n, props.lng, namespaces, function () {
        return resolve();
      });
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_js__["e" /* loadNamespaces */])(i18n, namespaces, function () {
        return resolve();
      });
    }
  });
}

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ManagerReferenceNodeContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ManagerReferenceNodeSetterContext; });
/* unused harmony export Manager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ManagerReferenceNodeContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();
var ManagerReferenceNodeSetterContext = __WEBPACK_IMPORTED_MODULE_0_react__["createContext"]();
function Manager(_ref) {
  var children = _ref.children;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](null),
      referenceNode = _React$useState[0],
      setReferenceNode = _React$useState[1];

  var hasUnmounted = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](false);
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    return function () {
      hasUnmounted.current = true;
    };
  }, []);
  var handleSetReferenceNode = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (node) {
    if (!hasUnmounted.current) {
      setReferenceNode(node);
    }
  }, []);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react__["createElement"](ManagerReferenceNodeSetterContext.Provider, {
    value: handleSetReferenceNode
  }, children));
}

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return unwrapArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return safeInvoke; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fromEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return useIsomorphicLayoutEffect; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? __WEBPACK_IMPORTED_MODULE_0_react__["useLayoutEffect"] : __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"];

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = loopAsync;
/* harmony export (immutable) */ __webpack_exports__["a"] = mapAsync;
function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var sync = false,
      hasNext = false,
      doneArgs = void 0;

  function done() {
    isDone = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      doneArgs = [].concat(Array.prototype.slice.call(arguments));
      return;
    }

    callback.apply(this, arguments);
  }

  function next() {
    if (isDone) {
      return;
    }

    hasNext = true;
    if (sync) {
      // Iterate instead of recursing if possible.
      return;
    }

    sync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work.call(this, currentTurn++, next, done);
    }

    sync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(this, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  }

  next();
}

function mapAsync(array, work, callback) {
  var length = array.length;
  var values = [];

  if (length === 0) return callback(null, values);

  var isDone = false,
      doneCount = 0;

  function done(index, error, value) {
    if (isDone) return;

    if (error) {
      isDone = true;
      callback(error);
    } else {
      values[index] = value;

      isDone = ++doneCount === length;

      if (isDone) callback(null, values);
    }
  }

  array.forEach(function (item, index) {
    work(item, index, function (error, value) {
      done(index, error, value);
    });
  });
}

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ContextProvider;
/* harmony export (immutable) */ __webpack_exports__["b"] = ContextSubscriber;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



// Works around issues with context updates failing to propagate.
// Caveat: the context value is expected to never change its identity.
// https://github.com/facebook/react/issues/2517
// https://github.com/reactjs/react-router/issues/470

var contextProviderShape = __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
  eventIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number.isRequired
});

function makeContextName(name) {
  return '@@contextSubscriber/' + name;
}

var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef !== 'undefined';

function ContextProvider(name) {
  var _childContextTypes, _config;

  var contextName = makeContextName(name);
  var listenersKey = contextName + '/listeners';
  var eventIndexKey = contextName + '/eventIndex';
  var subscribeKey = contextName + '/subscribe';

  var config = (_config = {
    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),

    getChildContext: function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextName] = {
        eventIndex: this[eventIndexKey],
        subscribe: this[subscribeKey]
      }, _ref;
    },


    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
    componentWillMount: function componentWillMount() {
      this[listenersKey] = [];
      this[eventIndexKey] = 0;
    },


    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
    componentWillReceiveProps: function componentWillReceiveProps() {
      this[eventIndexKey]++;
    },
    componentDidUpdate: function componentDidUpdate() {
      var _this = this;

      this[listenersKey].forEach(function (listener) {
        return listener(_this[eventIndexKey]);
      });
    }
  }, _config[subscribeKey] = function (listener) {
    var _this2 = this;

    // No need to immediately call listener here.
    this[listenersKey].push(listener);

    return function () {
      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
        return item !== listener;
      });
    };
  }, _config);

  if (prefixUnsafeLifecycleMethods) {
    config.UNSAFE_componentWillMount = config.componentWillMount;
    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
    delete config.componentWillMount;
    delete config.componentWillReceiveProps;
  }
  return config;
}

function ContextSubscriber(name) {
  var _contextTypes, _config2;

  var contextName = makeContextName(name);
  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
  var handleContextUpdateKey = contextName + '/handleContextUpdate';
  var unsubscribeKey = contextName + '/unsubscribe';

  var config = (_config2 = {
    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),

    getInitialState: function getInitialState() {
      var _ref2;

      if (!this.context[contextName]) {
        return {};
      }

      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
    },
    componentDidMount: function componentDidMount() {
      if (!this.context[contextName]) {
        return;
      }

      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
    },


    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
    componentWillReceiveProps: function componentWillReceiveProps() {
      var _setState;

      if (!this.context[contextName]) {
        return;
      }

      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
    },
    componentWillUnmount: function componentWillUnmount() {
      if (!this[unsubscribeKey]) {
        return;
      }

      this[unsubscribeKey]();
      this[unsubscribeKey] = null;
    }
  }, _config2[handleContextUpdateKey] = function (eventIndex) {
    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
      var _setState2;

      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
    }
  }, _config2);

  if (prefixUnsafeLifecycleMethods) {
    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
    delete config.componentWillReceiveProps;
  }
  return config;
}

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return routerShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return locationShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var routerShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  push: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  replace: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  go: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goBack: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  goForward: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  setRouteLeaveHook: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired,
  isActive: __WEBPACK_IMPORTED_MODULE_0_prop_types__["func"].isRequired
});

var locationShape = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_prop_types__["shape"])({
  pathname: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  search: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  state: __WEBPACK_IMPORTED_MODULE_0_prop_types__["object"],
  action: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"].isRequired,
  key: __WEBPACK_IMPORTED_MODULE_0_prop_types__["string"]
});

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getRouteParams__ = __webpack_require__(3209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ContextUtils__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(207);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };











/**
 * A <RouterContext> renders the component tree for a given router state
 * and sets the history object and the current location in context.
 */
var RouterContext = __WEBPACK_IMPORTED_MODULE_3_create_react_class___default()({
  displayName: 'RouterContext',

  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__ContextUtils__["a" /* ContextProvider */])('router')],

  propTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired,
    location: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired,
    routes: __WEBPACK_IMPORTED_MODULE_4_prop_types__["array"].isRequired,
    params: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired,
    components: __WEBPACK_IMPORTED_MODULE_4_prop_types__["array"].isRequired,
    createElement: __WEBPACK_IMPORTED_MODULE_4_prop_types__["func"].isRequired
  },

  getDefaultProps: function getDefaultProps() {
    return {
      createElement: __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement
    };
  },


  childContextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4_prop_types__["object"].isRequired
  },

  getChildContext: function getChildContext() {
    return {
      router: this.props.router
    };
  },
  createElement: function createElement(component, props) {
    return component == null ? null : this.props.createElement(component, props);
  },
  render: function render() {
    var _this = this;

    var _props = this.props,
        location = _props.location,
        routes = _props.routes,
        params = _props.params,
        components = _props.components,
        router = _props.router;

    var element = null;

    if (components) {
      element = components.reduceRight(function (element, components, index) {
        if (components == null) return element; // Don't create new children; use the grandchildren.

        var route = routes[index];
        var routeParams = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getRouteParams__["a" /* default */])(route, params);
        var props = {
          location: location,
          params: params,
          route: route,
          router: router,
          routeParams: routeParams,
          routes: routes
        };

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["b" /* isReactChildren */])(element)) {
          props.children = element;
        } else if (element) {
          for (var prop in element) {
            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
          }
        }

        // Handle components is object for { [name]: component } but not valid element
        // type of react, such as React.memo, React.lazy and so on.
        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react_is__["isValidElementType"])(components)) {
          var elements = {};

          for (var key in components) {
            if (Object.prototype.hasOwnProperty.call(components, key)) {
              // Pass through the key as a prop to createElement to allow
              // custom createElement functions to know which named component
              // they're rendering, for e.g. matching up to fetched data.
              elements[key] = _this.createElement(components[key], _extends({
                key: key }, props));
            }
          }

          return elements;
        }

        return _this.createElement(components, props);
      }, element);
    }

    !(element === null || element === false || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(element)) ?  false ? invariant(false, 'The root route must render a single element') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return element;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (RouterContext);

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.



/*<replacement>*/

var pna = __webpack_require__(455);
/*</replacement>*/

module.exports = Writable;

/* <replacement> */
function WriteReq(chunk, encoding, cb) {
  this.chunk = chunk;
  this.encoding = encoding;
  this.callback = cb;
  this.next = null;
}

// It seems a linked list but it is not
// there will be only 2 of these for each stream
function CorkedRequest(state) {
  var _this = this;

  this.next = null;
  this.entry = null;
  this.finish = function () {
    onCorkedFinish(_this, state);
  };
}
/* </replacement> */

/*<replacement>*/
var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : pna.nextTick;
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Writable.WritableState = WritableState;

/*<replacement>*/
var util = __webpack_require__(335);
util.inherits = __webpack_require__(41);
/*</replacement>*/

/*<replacement>*/
var internalUtil = {
  deprecate: __webpack_require__(3542)
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(1429);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(42).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

var destroyImpl = __webpack_require__(1428);

util.inherits(Writable, Stream);

function nop() {}

function WritableState(options, stream) {
  Duplex = Duplex || __webpack_require__(248);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag to indicate whether or not this stream
  // contains buffers or objects.
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;

  // the point at which write() starts returning false
  // Note: 0 is a valid value, means that we always return false if
  // the entire buffer is not flushed immediately on write()
  var hwm = options.highWaterMark;
  var writableHwm = options.writableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // if _final has been called
  this.finalCalled = false;

  // drain event flag.
  this.needDrain = false;
  // at the start of calling end()
  this.ending = false;
  // when end() has been called, and returned
  this.ended = false;
  // when 'finish' is emitted
  this.finished = false;

  // has it been destroyed
  this.destroyed = false;

  // should we decode strings into buffers before passing to _write?
  // this is here so that some node-core streams can optimize string
  // handling at a lower level.
  var noDecode = options.decodeStrings === false;
  this.decodeStrings = !noDecode;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // not an actual buffer we keep track of, but a measurement
  // of how much we're waiting to get pushed to some underlying
  // socket or file.
  this.length = 0;

  // a flag to see when we're in the middle of a write.
  this.writing = false;

  // when true all writes will be buffered until .uncork() call
  this.corked = 0;

  // a flag to be able to tell if the onwrite cb is called immediately,
  // or on a later tick.  We set this to true at first, because any
  // actions that shouldn't happen until "later" should generally also
  // not happen before the first write call.
  this.sync = true;

  // a flag to know if we're processing previously buffered items, which
  // may call the _write() callback in the same tick, so that we don't
  // end up in an overlapped onwrite situation.
  this.bufferProcessing = false;

  // the callback that's passed to _write(chunk,cb)
  this.onwrite = function (er) {
    onwrite(stream, er);
  };

  // the callback that the user supplies to write(chunk,encoding,cb)
  this.writecb = null;

  // the amount that is being written when _write is called.
  this.writelen = 0;

  this.bufferedRequest = null;
  this.lastBufferedRequest = null;

  // number of pending user-supplied write callbacks
  // this must be 0 before 'finish' can be emitted
  this.pendingcb = 0;

  // emit prefinish if the only thing we're waiting for is _write cbs
  // This is relevant for synchronous Transform streams
  this.prefinished = false;

  // True if the error was already emitted and should not be thrown again
  this.errorEmitted = false;

  // count buffered requests
  this.bufferedRequestCount = 0;

  // allocate the first CorkedRequest, there is always
  // one allocated and free to use, and we maintain at most two
  this.corkedRequestsFree = new CorkedRequest(this);
}

WritableState.prototype.getBuffer = function getBuffer() {
  var current = this.bufferedRequest;
  var out = [];
  while (current) {
    out.push(current);
    current = current.next;
  }
  return out;
};

(function () {
  try {
    Object.defineProperty(WritableState.prototype, 'buffer', {
      get: internalUtil.deprecate(function () {
        return this.getBuffer();
      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
    });
  } catch (_) {}
})();

// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
  realHasInstance = Function.prototype[Symbol.hasInstance];
  Object.defineProperty(Writable, Symbol.hasInstance, {
    value: function (object) {
      if (realHasInstance.call(this, object)) return true;
      if (this !== Writable) return false;

      return object && object._writableState instanceof WritableState;
    }
  });
} else {
  realHasInstance = function (object) {
    return object instanceof this;
  };
}

function Writable(options) {
  Duplex = Duplex || __webpack_require__(248);

  // Writable ctor is applied to Duplexes, too.
  // `realHasInstance` is necessary because using plain `instanceof`
  // would return false, as no `_writableState` property is attached.

  // Trying to use the custom `instanceof` for Writable here will also break the
  // Node.js LazyTransform implementation, which has a non-trivial getter for
  // `_writableState` that would lead to infinite recursion.
  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
    return new Writable(options);
  }

  this._writableState = new WritableState(options, this);

  // legacy.
  this.writable = true;

  if (options) {
    if (typeof options.write === 'function') this._write = options.write;

    if (typeof options.writev === 'function') this._writev = options.writev;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;

    if (typeof options.final === 'function') this._final = options.final;
  }

  Stream.call(this);
}

// Otherwise people can pipe Writable streams, which is just wrong.
Writable.prototype.pipe = function () {
  this.emit('error', new Error('Cannot pipe, not readable'));
};

function writeAfterEnd(stream, cb) {
  var er = new Error('write after end');
  // TODO: defer error events consistently everywhere, not just the cb
  stream.emit('error', er);
  pna.nextTick(cb, er);
}

// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function validChunk(stream, state, chunk, cb) {
  var valid = true;
  var er = false;

  if (chunk === null) {
    er = new TypeError('May not write null values to stream');
  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  if (er) {
    stream.emit('error', er);
    pna.nextTick(cb, er);
    valid = false;
  }
  return valid;
}

Writable.prototype.write = function (chunk, encoding, cb) {
  var state = this._writableState;
  var ret = false;
  var isBuf = !state.objectMode && _isUint8Array(chunk);

  if (isBuf && !Buffer.isBuffer(chunk)) {
    chunk = _uint8ArrayToBuffer(chunk);
  }

  if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;

  if (typeof cb !== 'function') cb = nop;

  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
    state.pendingcb++;
    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
  }

  return ret;
};

Writable.prototype.cork = function () {
  var state = this._writableState;

  state.corked++;
};

Writable.prototype.uncork = function () {
  var state = this._writableState;

  if (state.corked) {
    state.corked--;

    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
  }
};

Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
  // node::ParseEncoding() requires lower case.
  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
  this._writableState.defaultEncoding = encoding;
  return this;
};

function decodeChunk(state, chunk, encoding) {
  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
    chunk = Buffer.from(chunk, encoding);
  }
  return chunk;
}

Object.defineProperty(Writable.prototype, 'writableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._writableState.highWaterMark;
  }
});

// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
  if (!isBuf) {
    var newChunk = decodeChunk(state, chunk, encoding);
    if (chunk !== newChunk) {
      isBuf = true;
      encoding = 'buffer';
      chunk = newChunk;
    }
  }
  var len = state.objectMode ? 1 : chunk.length;

  state.length += len;

  var ret = state.length < state.highWaterMark;
  // we must ensure that previous needDrain will not be reset to false.
  if (!ret) state.needDrain = true;

  if (state.writing || state.corked) {
    var last = state.lastBufferedRequest;
    state.lastBufferedRequest = {
      chunk: chunk,
      encoding: encoding,
      isBuf: isBuf,
      callback: cb,
      next: null
    };
    if (last) {
      last.next = state.lastBufferedRequest;
    } else {
      state.bufferedRequest = state.lastBufferedRequest;
    }
    state.bufferedRequestCount += 1;
  } else {
    doWrite(stream, state, false, len, chunk, encoding, cb);
  }

  return ret;
}

function doWrite(stream, state, writev, len, chunk, encoding, cb) {
  state.writelen = len;
  state.writecb = cb;
  state.writing = true;
  state.sync = true;
  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
  state.sync = false;
}

function onwriteError(stream, state, sync, er, cb) {
  --state.pendingcb;

  if (sync) {
    // defer the callback if we are being called synchronously
    // to avoid piling up things on the stack
    pna.nextTick(cb, er);
    // this can emit finish, and it will always happen
    // after error
    pna.nextTick(finishMaybe, stream, state);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
  } else {
    // the caller expect this to happen before if
    // it is async
    cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
    // this can emit finish, but finish must
    // always follow error
    finishMaybe(stream, state);
  }
}

function onwriteStateUpdate(state) {
  state.writing = false;
  state.writecb = null;
  state.length -= state.writelen;
  state.writelen = 0;
}

function onwrite(stream, er) {
  var state = stream._writableState;
  var sync = state.sync;
  var cb = state.writecb;

  onwriteStateUpdate(state);

  if (er) onwriteError(stream, state, sync, er, cb);else {
    // Check if we're actually ready to finish, but don't emit yet
    var finished = needFinish(state);

    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
      clearBuffer(stream, state);
    }

    if (sync) {
      /*<replacement>*/
      asyncWrite(afterWrite, stream, state, finished, cb);
      /*</replacement>*/
    } else {
      afterWrite(stream, state, finished, cb);
    }
  }
}

function afterWrite(stream, state, finished, cb) {
  if (!finished) onwriteDrain(stream, state);
  state.pendingcb--;
  cb();
  finishMaybe(stream, state);
}

// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function onwriteDrain(stream, state) {
  if (state.length === 0 && state.needDrain) {
    state.needDrain = false;
    stream.emit('drain');
  }
}

// if there's something in the buffer waiting, then process it
function clearBuffer(stream, state) {
  state.bufferProcessing = true;
  var entry = state.bufferedRequest;

  if (stream._writev && entry && entry.next) {
    // Fast case, write everything using _writev()
    var l = state.bufferedRequestCount;
    var buffer = new Array(l);
    var holder = state.corkedRequestsFree;
    holder.entry = entry;

    var count = 0;
    var allBuffers = true;
    while (entry) {
      buffer[count] = entry;
      if (!entry.isBuf) allBuffers = false;
      entry = entry.next;
      count += 1;
    }
    buffer.allBuffers = allBuffers;

    doWrite(stream, state, true, state.length, buffer, '', holder.finish);

    // doWrite is almost always async, defer these to save a bit of time
    // as the hot path ends with doWrite
    state.pendingcb++;
    state.lastBufferedRequest = null;
    if (holder.next) {
      state.corkedRequestsFree = holder.next;
      holder.next = null;
    } else {
      state.corkedRequestsFree = new CorkedRequest(state);
    }
    state.bufferedRequestCount = 0;
  } else {
    // Slow case, write chunks one-by-one
    while (entry) {
      var chunk = entry.chunk;
      var encoding = entry.encoding;
      var cb = entry.callback;
      var len = state.objectMode ? 1 : chunk.length;

      doWrite(stream, state, false, len, chunk, encoding, cb);
      entry = entry.next;
      state.bufferedRequestCount--;
      // if we didn't call the onwrite immediately, then
      // it means that we need to wait until it does.
      // also, that means that the chunk and cb are currently
      // being processed, so move the buffer counter past them.
      if (state.writing) {
        break;
      }
    }

    if (entry === null) state.lastBufferedRequest = null;
  }

  state.bufferedRequest = entry;
  state.bufferProcessing = false;
}

Writable.prototype._write = function (chunk, encoding, cb) {
  cb(new Error('_write() is not implemented'));
};

Writable.prototype._writev = null;

Writable.prototype.end = function (chunk, encoding, cb) {
  var state = this._writableState;

  if (typeof chunk === 'function') {
    cb = chunk;
    chunk = null;
    encoding = null;
  } else if (typeof encoding === 'function') {
    cb = encoding;
    encoding = null;
  }

  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);

  // .end() fully uncorks
  if (state.corked) {
    state.corked = 1;
    this.uncork();
  }

  // ignore unnecessary end() calls.
  if (!state.ending && !state.finished) endWritable(this, state, cb);
};

function needFinish(state) {
  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function callFinal(stream, state) {
  stream._final(function (err) {
    state.pendingcb--;
    if (err) {
      stream.emit('error', err);
    }
    state.prefinished = true;
    stream.emit('prefinish');
    finishMaybe(stream, state);
  });
}
function prefinish(stream, state) {
  if (!state.prefinished && !state.finalCalled) {
    if (typeof stream._final === 'function') {
      state.pendingcb++;
      state.finalCalled = true;
      pna.nextTick(callFinal, stream, state);
    } else {
      state.prefinished = true;
      stream.emit('prefinish');
    }
  }
}

function finishMaybe(stream, state) {
  var need = needFinish(state);
  if (need) {
    prefinish(stream, state);
    if (state.pendingcb === 0) {
      state.finished = true;
      stream.emit('finish');
    }
  }
  return need;
}

function endWritable(stream, state, cb) {
  state.ending = true;
  finishMaybe(stream, state);
  if (cb) {
    if (state.finished) pna.nextTick(cb);else stream.once('finish', cb);
  }
  state.ended = true;
  stream.writable = false;
}

function onCorkedFinish(corkReq, state, err) {
  var entry = corkReq.entry;
  corkReq.entry = null;
  while (entry) {
    var cb = entry.callback;
    state.pendingcb--;
    cb(err);
    entry = entry.next;
  }
  if (state.corkedRequestsFree) {
    state.corkedRequestsFree.next = corkReq;
  } else {
    state.corkedRequestsFree = corkReq;
  }
}

Object.defineProperty(Writable.prototype, 'destroyed', {
  get: function () {
    if (this._writableState === undefined) {
      return false;
    }
    return this._writableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._writableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._writableState.destroyed = value;
  }
});

Writable.prototype.destroy = destroyImpl.destroy;
Writable.prototype._undestroy = destroyImpl.undestroy;
Writable.prototype._destroy = function (err, cb) {
  this.end();
  cb(err);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90), __webpack_require__(3509).setImmediate, __webpack_require__(56)))

/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(1426);
exports.Stream = exports;
exports.Readable = exports;
exports.Writable = __webpack_require__(696);
exports.Duplex = __webpack_require__(248);
exports.Transform = __webpack_require__(1427);
exports.PassThrough = __webpack_require__(3219);


/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(3227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(3226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(3225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(1430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(1432);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return __WEBPACK_IMPORTED_MODULE_4__compose__["a"]; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(75).Buffer
var inherits = __webpack_require__(41)
var HashBase = __webpack_require__(1238)

var ARRAY16 = new Array(16)

var zl = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
]

var zr = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
]

var sl = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
]

var sr = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
]

var hl = [0x00000000, 0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xa953fd4e]
var hr = [0x50a28be6, 0x5c4dd124, 0x6d703ef3, 0x7a6d76e9, 0x00000000]

function RIPEMD160 () {
  HashBase.call(this, 64)

  // state
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0
}

inherits(RIPEMD160, HashBase)

RIPEMD160.prototype._update = function () {
  var words = ARRAY16
  for (var j = 0; j < 16; ++j) words[j] = this._block.readInt32LE(j * 4)

  var al = this._a | 0
  var bl = this._b | 0
  var cl = this._c | 0
  var dl = this._d | 0
  var el = this._e | 0

  var ar = this._a | 0
  var br = this._b | 0
  var cr = this._c | 0
  var dr = this._d | 0
  var er = this._e | 0

  // computation
  for (var i = 0; i < 80; i += 1) {
    var tl
    var tr
    if (i < 16) {
      tl = fn1(al, bl, cl, dl, el, words[zl[i]], hl[0], sl[i])
      tr = fn5(ar, br, cr, dr, er, words[zr[i]], hr[0], sr[i])
    } else if (i < 32) {
      tl = fn2(al, bl, cl, dl, el, words[zl[i]], hl[1], sl[i])
      tr = fn4(ar, br, cr, dr, er, words[zr[i]], hr[1], sr[i])
    } else if (i < 48) {
      tl = fn3(al, bl, cl, dl, el, words[zl[i]], hl[2], sl[i])
      tr = fn3(ar, br, cr, dr, er, words[zr[i]], hr[2], sr[i])
    } else if (i < 64) {
      tl = fn4(al, bl, cl, dl, el, words[zl[i]], hl[3], sl[i])
      tr = fn2(ar, br, cr, dr, er, words[zr[i]], hr[3], sr[i])
    } else { // if (i<80) {
      tl = fn5(al, bl, cl, dl, el, words[zl[i]], hl[4], sl[i])
      tr = fn1(ar, br, cr, dr, er, words[zr[i]], hr[4], sr[i])
    }

    al = el
    el = dl
    dl = rotl(cl, 10)
    cl = bl
    bl = tl

    ar = er
    er = dr
    dr = rotl(cr, 10)
    cr = br
    br = tr
  }

  // update state
  var t = (this._b + cl + dr) | 0
  this._b = (this._c + dl + er) | 0
  this._c = (this._d + el + ar) | 0
  this._d = (this._e + al + br) | 0
  this._e = (this._a + bl + cr) | 0
  this._a = t
}

RIPEMD160.prototype._digest = function () {
  // create padding and handle blocks
  this._block[this._blockOffset++] = 0x80
  if (this._blockOffset > 56) {
    this._block.fill(0, this._blockOffset, 64)
    this._update()
    this._blockOffset = 0
  }

  this._block.fill(0, this._blockOffset, 56)
  this._block.writeUInt32LE(this._length[0], 56)
  this._block.writeUInt32LE(this._length[1], 60)
  this._update()

  // produce result
  var buffer = Buffer.alloc ? Buffer.alloc(20) : new Buffer(20)
  buffer.writeInt32LE(this._a, 0)
  buffer.writeInt32LE(this._b, 4)
  buffer.writeInt32LE(this._c, 8)
  buffer.writeInt32LE(this._d, 12)
  buffer.writeInt32LE(this._e, 16)
  return buffer
}

function rotl (x, n) {
  return (x << n) | (x >>> (32 - n))
}

function fn1 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ c ^ d) + m + k) | 0, s) + e) | 0
}

function fn2 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & c) | ((~b) & d)) + m + k) | 0, s) + e) | 0
}

function fn3 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b | (~c)) ^ d) + m + k) | 0, s) + e) | 0
}

function fn4 (a, b, c, d, e, m, k, s) {
  return (rotl((a + ((b & d) | (c & (~d))) + m + k) | 0, s) + e) | 0
}

function fn5 (a, b, c, d, e, m, k, s) {
  return (rotl((a + (b ^ (c | (~d))) + m + k) | 0, s) + e) | 0
}

module.exports = RIPEMD160


/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Radio__ = __webpack_require__(3238);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Radio__["a"]; });



/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A column sub-component for Grid.
 */

function GridColumn(props) {
  var children = props.children,
      className = props.className,
      computer = props.computer,
      color = props.color,
      floated = props.floated,
      largeScreen = props.largeScreen,
      mobile = props.mobile,
      only = props.only,
      stretched = props.stretched,
      tablet = props.tablet,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign,
      widescreen = props.widescreen,
      width = props.width;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(color, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(stretched, 'stretched'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* useMultipleProp */])(only, 'only'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["n" /* useTextAlignProp */])(textAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["g" /* useValueAndKey */])(floated, 'floated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["i" /* useVerticalAlignProp */])(verticalAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["f" /* useWidthProp */])(computer, 'wide computer'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["f" /* useWidthProp */])(largeScreen, 'wide large screen'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["f" /* useWidthProp */])(mobile, 'wide mobile'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["f" /* useWidthProp */])(tablet, 'wide tablet'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["f" /* useWidthProp */])(widescreen, 'wide widescreen'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["f" /* useWidthProp */])(width, 'wide'), 'column', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(GridColumn, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(GridColumn, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), children);
}

GridColumn.handledProps = ["as", "children", "className", "color", "computer", "floated", "largeScreen", "mobile", "only", "stretched", "tablet", "textAlign", "verticalAlign", "widescreen", "width"];
GridColumn.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A grid column can be colored. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A column can specify a width for a computer. */
  computer: customPropTypes.every([customPropTypes.disallow(['width']), PropTypes.oneOf(SUI.WIDTHS)]),

  /** A column can sit flush against the left or right edge of a row. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A column can specify a width for a large screen device. */
  largeScreen: customPropTypes.every([customPropTypes.disallow(['width']), PropTypes.oneOf(SUI.WIDTHS)]),

  /** A column can specify a width for a mobile device. */
  mobile: customPropTypes.every([customPropTypes.disallow(['width']), PropTypes.oneOf(SUI.WIDTHS)]),

  /** A column can appear only for a specific device, or screen sizes. */
  only: customPropTypes.multipleProp(SUI.VISIBILITY),

  /** A column can stretch its contents to take up the entire grid or row height. */
  stretched: PropTypes.bool,

  /** A column can specify a width for a tablet device. */
  tablet: customPropTypes.every([customPropTypes.disallow(['width']), PropTypes.oneOf(SUI.WIDTHS)]),

  /** A column can specify its text alignment. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS),

  /** A column can specify its vertical alignment to have all its columns vertically centered. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS),

  /** A column can specify a width for a wide screen device. */
  widescreen: customPropTypes.every([customPropTypes.disallow(['width']), PropTypes.oneOf(SUI.WIDTHS)]),

  /** Represents width of column. */
  width: customPropTypes.every([customPropTypes.disallow(['computer', 'largeScreen', 'mobile', 'tablet', 'widescreen']), PropTypes.oneOf(SUI.WIDTHS)])
} : {};
GridColumn.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(GridColumn, function (children) {
  return {
    children: children
  };
});
/* harmony default export */ __webpack_exports__["a"] = (GridColumn);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MenuItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_startCase__ = __webpack_require__(3479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_Icon__ = __webpack_require__(95);









/**
 * A menu can contain an item.
 */

var MenuItem = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(MenuItem, _Component);

  function MenuItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleClick = function (e) {
      var disabled = _this.props.disabled;
      if (!disabled) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(_this.props, 'onClick', e, _this.props);
    };

    return _this;
  }

  var _proto = MenuItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        children = _this$props.children,
        className = _this$props.className,
        color = _this$props.color,
        content = _this$props.content,
        disabled = _this$props.disabled,
        fitted = _this$props.fitted,
        header = _this$props.header,
        icon = _this$props.icon,
        link = _this$props.link,
        name = _this$props.name,
        onClick = _this$props.onClick,
        position = _this$props.position;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(color, position, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(icon === true || icon && !(name || content), 'icon'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(header, 'header'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(link, 'link'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["h" /* useKeyOrValueAndKey */])(fitted, 'fitted'), 'item', className);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["c" /* getElementType */])(MenuItem, this.props, function () {
      if (onClick) return 'a';
    });
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["b" /* getUnhandledProps */])(MenuItem, this.props);

    if (!__WEBPACK_IMPORTED_MODULE_7__lib__["d" /* childrenUtils */].isNil(children)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        className: classes,
        onClick: this.handleClick
      }), children);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes,
      onClick: this.handleClick
    }), __WEBPACK_IMPORTED_MODULE_8__elements_Icon__["a" /* default */].create(icon, {
      autoGenerateKey: false
    }), __WEBPACK_IMPORTED_MODULE_7__lib__["d" /* childrenUtils */].isNil(content) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_startCase__["a" /* default */])(name) : content);
  };

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

MenuItem.handledProps = ["active", "as", "children", "className", "color", "content", "disabled", "fitted", "header", "icon", "index", "link", "name", "onClick", "position"];

MenuItem.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A menu item can be active. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Additional colors can be specified. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A menu item can be disabled. */
  disabled: PropTypes.bool,

  /** A menu item or menu can remove element padding, vertically or horizontally. */
  fitted: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['horizontally', 'vertically'])]),

  /** A menu item may include a header or may itself be a header. */
  header: PropTypes.bool,

  /** MenuItem can be only icon. */
  icon: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),

  /** MenuItem index inside Menu. */
  index: PropTypes.number,

  /** A menu item can be link. */
  link: PropTypes.bool,

  /** Internal name of the MenuItem. */
  name: PropTypes.string,

  /**
   * Called on click. When passed, the component will render as an `a`
   * tag by default instead of a `div`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** A menu item can take left or right position. */
  position: PropTypes.oneOf(['left', 'right'])
} : {};
MenuItem.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["e" /* createShorthandFactory */])(MenuItem, function (val) {
  return {
    content: val,
    name: val
  };
});

/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A message list can contain an item.
 */

function MessageItem(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(MessageItem, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(MessageItem, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

MessageItem.handledProps = ["as", "children", "className", "content"];
MessageItem.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
MessageItem.defaultProps = {
  as: 'li'
};
MessageItem.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(MessageItem, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (MessageItem);

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A table can have a header.
 */

function TableHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      fullWidth = props.fullWidth;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(fullWidth, 'full-width'), className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(TableHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(TableHeader, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

TableHeader.handledProps = ["as", "children", "className", "content", "fullWidth"];
TableHeader.defaultProps = {
  as: 'thead'
};
TableHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A definition table can have a full width header or footer, filling in the gap left by the first column. */
  fullWidth: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (TableHeader);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fluentui_react_component_ref__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Icon_Icon__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Label_Label__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ButtonContent__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ButtonGroup__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ButtonOr__ = __webpack_require__(1462);














/**
 * A Button indicates a possible user action.
 * @see Form
 * @see Icon
 * @see Label
 */

var Button = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Button, _Component);

  function Button() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.ref = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["createRef"])();

    _this.computeElementType = function () {
      var _this$props = _this.props,
          attached = _this$props.attached,
          label = _this$props.label;
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])(attached) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])(label)) return 'div';
    };

    _this.computeTabIndex = function (ElementType) {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          tabIndex = _this$props2.tabIndex;
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])(tabIndex)) return tabIndex;
      if (disabled) return -1;
      if (ElementType === 'div') return 0;
    };

    _this.focus = function (options) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.ref.current, 'focus', options);
    };

    _this.handleClick = function (e) {
      var disabled = _this.props.disabled;

      if (disabled) {
        e.preventDefault();
        return;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onClick', e, _this.props);
    };

    _this.hasIconClass = function () {
      var _this$props3 = _this.props,
          labelPosition = _this$props3.labelPosition,
          children = _this$props3.children,
          content = _this$props3.content,
          icon = _this$props3.icon;
      if (icon === true) return true;
      return icon && (labelPosition || __WEBPACK_IMPORTED_MODULE_8__lib__["d" /* childrenUtils */].isNil(children) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])(content));
    };

    return _this;
  }

  var _proto = Button.prototype;

  _proto.computeButtonAriaRole = function computeButtonAriaRole(ElementType) {
    var role = this.props.role;
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])(role)) return role;
    if (ElementType !== 'button') return 'button';
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        active = _this$props4.active,
        animated = _this$props4.animated,
        attached = _this$props4.attached,
        basic = _this$props4.basic,
        children = _this$props4.children,
        circular = _this$props4.circular,
        className = _this$props4.className,
        color = _this$props4.color,
        compact = _this$props4.compact,
        content = _this$props4.content,
        disabled = _this$props4.disabled,
        floated = _this$props4.floated,
        fluid = _this$props4.fluid,
        icon = _this$props4.icon,
        inverted = _this$props4.inverted,
        label = _this$props4.label,
        labelPosition = _this$props4.labelPosition,
        loading = _this$props4.loading,
        negative = _this$props4.negative,
        positive = _this$props4.positive,
        primary = _this$props4.primary,
        secondary = _this$props4.secondary,
        size = _this$props4.size,
        toggle = _this$props4.toggle,
        type = _this$props4.type;
    var baseClasses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(basic, 'basic'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(circular, 'circular'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(compact, 'compact'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(this.hasIconClass(), 'icon'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(loading, 'loading'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(negative, 'negative'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(positive, 'positive'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(primary, 'primary'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(secondary, 'secondary'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(toggle, 'toggle'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["h" /* useKeyOrValueAndKey */])(animated, 'animated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["h" /* useKeyOrValueAndKey */])(attached, 'attached'));
    var labeledClasses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["h" /* useKeyOrValueAndKey */])(labelPosition || !!label, 'labeled'));
    var wrapperClasses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["g" /* useValueAndKey */])(floated, 'floated'));
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["b" /* getUnhandledProps */])(Button, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["c" /* getElementType */])(Button, this.props, this.computeElementType);
    var tabIndex = this.computeTabIndex(ElementType);

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])(label)) {
      var buttonClasses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])('ui', baseClasses, 'button', className);
      var containerClasses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])('ui', labeledClasses, 'button', className, wrapperClasses);
      var labelElement = __WEBPACK_IMPORTED_MODULE_10__Label_Label__["a" /* default */].create(label, {
        defaultProps: {
          basic: true,
          pointing: labelPosition === 'left' ? 'right' : 'left'
        },
        autoGenerateKey: false
      });
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        className: containerClasses,
        onClick: this.handleClick
      }), labelPosition === 'left' && labelElement, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__fluentui_react_component_ref__["a" /* Ref */], {
        innerRef: this.ref
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("button", {
        className: buttonClasses,
        "aria-pressed": toggle ? !!active : undefined,
        disabled: disabled,
        type: type,
        tabIndex: tabIndex
      }, __WEBPACK_IMPORTED_MODULE_9__Icon_Icon__["a" /* default */].create(icon, {
        autoGenerateKey: false
      }), " ", content)), (labelPosition === 'right' || !labelPosition) && labelElement);
    }

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])('ui', baseClasses, wrapperClasses, labeledClasses, 'button', className);
    var hasChildren = !__WEBPACK_IMPORTED_MODULE_8__lib__["d" /* childrenUtils */].isNil(children);
    var role = this.computeButtonAriaRole(ElementType);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__fluentui_react_component_ref__["a" /* Ref */], {
      innerRef: this.ref
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes,
      "aria-pressed": toggle ? !!active : undefined,
      disabled: disabled && ElementType === 'button' || undefined,
      onClick: this.handleClick,
      role: role,
      type: type,
      tabIndex: tabIndex
    }), hasChildren && children, !hasChildren && __WEBPACK_IMPORTED_MODULE_9__Icon_Icon__["a" /* default */].create(icon, {
      autoGenerateKey: false
    }), !hasChildren && content));
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Button.handledProps = ["active", "animated", "as", "attached", "basic", "children", "circular", "className", "color", "compact", "content", "disabled", "floated", "fluid", "icon", "inverted", "label", "labelPosition", "loading", "negative", "onClick", "positive", "primary", "role", "secondary", "size", "tabIndex", "toggle", "type"];
Button.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A button can show it is currently the active user selection. */
  active: PropTypes.bool,

  /** A button can animate to show hidden content. */
  animated: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['fade', 'vertical'])]),

  /** A button can be attached to other content. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right', 'top', 'bottom'])]),

  /** A basic button is less pronounced. */
  basic: PropTypes.bool,

  /** Primary content. */
  children: customPropTypes.every([PropTypes.node, customPropTypes.disallow(['label']), customPropTypes.givenProps({
    icon: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.object.isRequired, PropTypes.element.isRequired])
  }, customPropTypes.disallow(['icon']))]),

  /** A button can be circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** A button can have different colors */
  color: PropTypes.oneOf([].concat(SUI.COLORS, ['facebook', 'google plus', 'instagram', 'linkedin', 'twitter', 'vk', 'youtube'])),

  /** A button can reduce its padding to fit into tighter spaces. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A button can show it is currently unable to be interacted with. */
  disabled: PropTypes.bool,

  /** A button can be aligned to the left or right of its container. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A button can take the width of its container. */
  fluid: PropTypes.bool,

  /** Add an Icon by name, props object, or pass an <Icon />. */
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.object, PropTypes.element]),

  /** A button can be formatted to appear on dark backgrounds. */
  inverted: PropTypes.bool,

  /** Add a Label by text, props object, or pass a <Label />. */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.element]),

  /** A labeled button can format a Label or Icon to appear on the left or right. */
  labelPosition: PropTypes.oneOf(['right', 'left']),

  /** A button can show a loading indicator. */
  loading: PropTypes.bool,

  /** A button can hint towards a negative consequence. */
  negative: PropTypes.bool,

  /**
   * Called after user's click.
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** A button can hint towards a positive consequence. */
  positive: PropTypes.bool,

  /** A button can be formatted to show different levels of emphasis. */
  primary: PropTypes.bool,

  /** The role of the HTML element. */
  role: PropTypes.string,

  /** A button can be formatted to show different levels of emphasis. */
  secondary: PropTypes.bool,

  /** A button can have different sizes. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** A button can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A button can be formatted to toggle on and off. */
  toggle: PropTypes.bool,

  /** The type of the HTML element. */
  type: PropTypes.oneOf(['button', 'submit', 'reset'])
} : {};
Button.defaultProps = {
  as: 'button'
};
Button.Content = __WEBPACK_IMPORTED_MODULE_11__ButtonContent__["a" /* default */];
Button.Group = __WEBPACK_IMPORTED_MODULE_12__ButtonGroup__["a" /* default */];
Button.Or = __WEBPACK_IMPORTED_MODULE_13__ButtonOr__["a" /* default */];
Button.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["e" /* createShorthandFactory */])(Button, function (value) {
  return {
    content: value
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Flag__ = __webpack_require__(3258);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Flag__["a"]; });



/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input__ = __webpack_require__(3261);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Input__["a"]; });



/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Label; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isUndefined__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Icon_Icon__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Image_Image__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LabelDetail__ = __webpack_require__(1468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LabelGroup__ = __webpack_require__(1469);












/**
 * A label displays content classification.
 */

var Label = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Label, _Component);

  function Label() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleClick = function (e) {
      var onClick = _this.props.onClick;
      if (onClick) onClick(e, _this.props);
    };

    _this.handleIconOverrides = function (predefinedProps) {
      return {
        onClick: function onClick(e) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(predefinedProps, 'onClick', e);

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(_this.props, 'onRemove', e, _this.props);
        }
      };
    };

    return _this;
  }

  var _proto = Label.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        attached = _this$props.attached,
        basic = _this$props.basic,
        children = _this$props.children,
        circular = _this$props.circular,
        className = _this$props.className,
        color = _this$props.color,
        content = _this$props.content,
        corner = _this$props.corner,
        detail = _this$props.detail,
        empty = _this$props.empty,
        floating = _this$props.floating,
        horizontal = _this$props.horizontal,
        icon = _this$props.icon,
        image = _this$props.image,
        onRemove = _this$props.onRemove,
        pointing = _this$props.pointing,
        prompt = _this$props.prompt,
        removeIcon = _this$props.removeIcon,
        ribbon = _this$props.ribbon,
        size = _this$props.size,
        tag = _this$props.tag;
    var pointingClass = pointing === true && 'pointing' || (pointing === 'left' || pointing === 'right') && pointing + " pointing" || (pointing === 'above' || pointing === 'below') && "pointing " + pointing;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])('ui', color, pointingClass, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(basic, 'basic'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(circular, 'circular'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(empty, 'empty'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(floating, 'floating'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(horizontal, 'horizontal'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(image === true, 'image'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(prompt, 'prompt'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(tag, 'tag'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["h" /* useKeyOrValueAndKey */])(corner, 'corner'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["h" /* useKeyOrValueAndKey */])(ribbon, 'ribbon'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["g" /* useValueAndKey */])(attached, 'attached'), 'label', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["b" /* getUnhandledProps */])(Label, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["c" /* getElementType */])(Label, this.props);

    if (!__WEBPACK_IMPORTED_MODULE_7__lib__["d" /* childrenUtils */].isNil(children)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        className: classes,
        onClick: this.handleClick
      }), children);
    }

    var removeIconShorthand = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isUndefined__["a" /* default */])(removeIcon) ? 'delete' : removeIcon;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      className: classes,
      onClick: this.handleClick
    }, rest), __WEBPACK_IMPORTED_MODULE_8__Icon_Icon__["a" /* default */].create(icon, {
      autoGenerateKey: false
    }), typeof image !== 'boolean' && __WEBPACK_IMPORTED_MODULE_9__Image_Image__["a" /* default */].create(image, {
      autoGenerateKey: false
    }), content, __WEBPACK_IMPORTED_MODULE_10__LabelDetail__["a" /* default */].create(detail, {
      autoGenerateKey: false
    }), onRemove && __WEBPACK_IMPORTED_MODULE_8__Icon_Icon__["a" /* default */].create(removeIconShorthand, {
      autoGenerateKey: false,
      overrideProps: this.handleIconOverrides
    }));
  };

  return Label;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

Label.handledProps = ["active", "as", "attached", "basic", "children", "circular", "className", "color", "content", "corner", "detail", "empty", "floating", "horizontal", "icon", "image", "onClick", "onRemove", "pointing", "prompt", "removeIcon", "ribbon", "size", "tag"];

Label.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A label can be active. */
  active: PropTypes.bool,

  /** A label can attach to a content segment. */
  attached: PropTypes.oneOf(['top', 'bottom', 'top right', 'top left', 'bottom left', 'bottom right']),

  /** A label can reduce its complexity. */
  basic: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** A label can be circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Color of the label. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A label can position itself in the corner of an element. */
  corner: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right'])]),

  /** Shorthand for LabelDetail. */
  detail: customPropTypes.itemShorthand,

  /** Formats the label as a dot. */
  empty: customPropTypes.every([PropTypes.bool, customPropTypes.demand(['circular'])]),

  /** Float above another element in the upper right corner. */
  floating: PropTypes.bool,

  /** A horizontal label is formatted to label content along-side it horizontally. */
  horizontal: PropTypes.bool,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand,

  /** A label can be formatted to emphasize an image or prop can be used as shorthand for Image. */
  image: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Adds an "x" icon, called when "x" is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onRemove: PropTypes.func,

  /** A label can point to content next to it. */
  pointing: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['above', 'below', 'left', 'right'])]),

  /** A label can prompt for an error in your forms. */
  prompt: PropTypes.bool,

  /** Shorthand for Icon to appear as the last child and trigger onRemove. */
  removeIcon: customPropTypes.itemShorthand,

  /** A label can appear as a ribbon attaching itself to an element. */
  ribbon: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['right'])]),

  /** A label can have different sizes. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** A label can appear as a tag. */
  tag: PropTypes.bool
} : {};
Label.Detail = __WEBPACK_IMPORTED_MODULE_10__LabelDetail__["a" /* default */];
Label.Group = __WEBPACK_IMPORTED_MODULE_11__LabelGroup__["a" /* default */];
Label.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["e" /* createShorthandFactory */])(Label, function (value) {
  return {
    content: value
  };
});

/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ListDescription__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListHeader__ = __webpack_require__(472);







/**
 * A list item can contain a content.
 */

function ListContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      floated = props.floated,
      header = props.header,
      verticalAlign = props.verticalAlign;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["g" /* useValueAndKey */])(floated, 'floated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["i" /* useVerticalAlignProp */])(verticalAlign), 'content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ListContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ListContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_6__ListHeader__["a" /* default */].create(header), __WEBPACK_IMPORTED_MODULE_5__ListDescription__["a" /* default */].create(description), content);
}

ListContent.handledProps = ["as", "children", "className", "content", "description", "floated", "header", "verticalAlign"];
ListContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for ListDescription. */
  description: customPropTypes.itemShorthand,

  /** An list content can be floated left or right. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** Shorthand for ListHeader. */
  header: customPropTypes.itemShorthand,

  /** An element inside a list can be vertically aligned. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
ListContent.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ListContent, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ListContent);

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Icon_Icon__ = __webpack_require__(470);






/**
 * A list item can contain an icon.
 */

function ListIcon(props) {
  var className = props.className,
      verticalAlign = props.verticalAlign;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["i" /* useVerticalAlignProp */])(verticalAlign), className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ListIcon, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Icon_Icon__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }));
}

ListIcon.handledProps = ["className", "verticalAlign"];
ListIcon.propTypes =  false ? {
  /** Additional classes. */
  className: PropTypes.string,

  /** An element inside a list can be vertically aligned. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
ListIcon.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ListIcon, function (name) {
  return {
    name: name
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ListIcon);

/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);






function StepDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('description', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(StepDescription, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(StepDescription, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

StepDescription.handledProps = ["as", "children", "className", "content"];
StepDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
StepDescription.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(StepDescription, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (StepDescription);

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A step can contain a title.
 */

function StepTitle(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('title', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(StepTitle, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(StepTitle, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

StepTitle.handledProps = ["as", "children", "className", "content"];
StepTitle.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
StepTitle.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(StepTitle, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (StepTitle);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return numberToWordMap; });
/* harmony export (immutable) */ __webpack_exports__["b"] = numberToWord;
var numberToWordMap = {
  1: 'one',
  2: 'two',
  3: 'three',
  4: 'four',
  5: 'five',
  6: 'six',
  7: 'seven',
  8: 'eight',
  9: 'nine',
  10: 'ten',
  11: 'eleven',
  12: 'twelve',
  13: 'thirteen',
  14: 'fourteen',
  15: 'fifteen',
  16: 'sixteen'
};
/**
 * Return the number word for numbers 1-16.
 * Returns strings or numbers as is if there is no corresponding word.
 * Returns an empty string if value is not a string or number.
 * @param {string|number} value The value to convert to a word.
 * @returns {string}
 */

function numberToWord(value) {
  var type = typeof value;

  if (type === 'string' || type === 'number') {
    return numberToWordMap[value] || value;
  }

  return '';
}

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A content sub-component for Accordion component.
 */

function AccordionContent(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('content', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(active, 'active'), className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(AccordionContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(AccordionContent, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

AccordionContent.handledProps = ["active", "as", "children", "className", "content"];
AccordionContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Whether or not the content is visible. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
AccordionContent.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(AccordionContent, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (AccordionContent);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AccordionTitle__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccordionContent__ = __webpack_require__(714);







/**
 * A panel sub-component for Accordion component.
 */

var AccordionPanel = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(AccordionPanel, _Component);

  function AccordionPanel() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleTitleOverrides = function (predefinedProps) {
      return {
        onClick: function onClick(e, titleProps) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_invoke__["a" /* default */])(predefinedProps, 'onClick', e, titleProps);

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_invoke__["a" /* default */])(_this.props, 'onTitleClick', e, titleProps);
        }
      };
    };

    return _this;
  }

  var _proto = AccordionPanel.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        content = _this$props.content,
        index = _this$props.index,
        title = _this$props.title;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_5__AccordionTitle__["a" /* default */].create(title, {
      autoGenerateKey: false,
      defaultProps: {
        active: active,
        index: index
      },
      overrideProps: this.handleTitleOverrides
    }), __WEBPACK_IMPORTED_MODULE_6__AccordionContent__["a" /* default */].create(content, {
      autoGenerateKey: false,
      defaultProps: {
        active: active
      }
    }));
  };

  return AccordionPanel;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

AccordionPanel.handledProps = ["active", "content", "index", "onTitleClick", "title"];
AccordionPanel.propTypes =  false ? {
  /** Whether or not the title is in the open state. */
  active: PropTypes.bool,

  /** A shorthand for Accordion.Content. */
  content: customPropTypes.itemShorthand,

  /** A panel index. */
  index: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Called when a panel title is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All item props.
   */
  onTitleClick: PropTypes.func,

  /** A shorthand for Accordion.Title. */
  title: customPropTypes.itemShorthand
} : {};
AccordionPanel.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(AccordionPanel, null);
/* harmony default export */ __webpack_exports__["a"] = (AccordionPanel);

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionTitle; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isNil__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_Icon__ = __webpack_require__(95);









/**
 * A title sub-component for Accordion component.
 */

var AccordionTitle = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(AccordionTitle, _Component);

  function AccordionTitle() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleClick = function (e) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(_this.props, 'onClick', e, _this.props);
    };

    return _this;
  }

  var _proto = AccordionTitle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        children = _this$props.children,
        className = _this$props.className,
        content = _this$props.content,
        icon = _this$props.icon;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(active, 'active'), 'title', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["b" /* getUnhandledProps */])(AccordionTitle, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["c" /* getElementType */])(AccordionTitle, this.props);
    var iconValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isNil__["a" /* default */])(icon) ? 'dropdown' : icon;

    if (!__WEBPACK_IMPORTED_MODULE_7__lib__["d" /* childrenUtils */].isNil(children)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        className: classes,
        onClick: this.handleClick
      }), children);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes,
      onClick: this.handleClick
    }), __WEBPACK_IMPORTED_MODULE_8__elements_Icon__["a" /* default */].create(iconValue, {
      autoGenerateKey: false
    }), content);
  };

  return AccordionTitle;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

AccordionTitle.handledProps = ["active", "as", "children", "className", "content", "icon", "index", "onClick"];

AccordionTitle.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Whether or not the title is in the open state. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand,

  /** AccordionTitle index inside Accordion. */
  index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func
} : {};
AccordionTitle.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["e" /* createShorthandFactory */])(AccordionTitle, function (content) {
  return {
    content: content
  };
});

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);






/**
 * A card can contain a description with one or more paragraphs.
 */

function CardDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      textAlign = props.textAlign;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["n" /* useTextAlignProp */])(textAlign), 'description', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(CardDescription, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(CardDescription, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CardDescription.handledProps = ["as", "children", "className", "content", "textAlign"];
CardDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A card content can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CardDescription);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);






/**
 * A card can contain a header.
 */

function CardHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      textAlign = props.textAlign;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["n" /* useTextAlignProp */])(textAlign), 'header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(CardHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(CardHeader, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CardHeader.handledProps = ["as", "children", "className", "content", "textAlign"];
CardHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A card header can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CardHeader);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);






/**
 * A card can contain content metadata.
 */

function CardMeta(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      textAlign = props.textAlign;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["n" /* useTextAlignProp */])(textAlign), 'meta', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(CardMeta, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(CardMeta, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CardMeta.handledProps = ["as", "children", "className", "content", "textAlign"];
CardMeta.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A card meta can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CardMeta);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeedDate__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FeedExtra__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FeedMeta__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FeedSummary__ = __webpack_require__(725);










function FeedContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      extraImages = props.extraImages,
      extraText = props.extraText,
      date = props.date,
      meta = props.meta,
      summary = props.summary;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(FeedContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(FeedContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_5__FeedDate__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, date, {
    autoGenerateKey: false
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_8__FeedSummary__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, summary, {
    autoGenerateKey: false
  }), content, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedExtra__["a" /* default */], function (val) {
    return {
      text: true,
      content: val
    };
  }, extraText, {
    autoGenerateKey: false
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedExtra__["a" /* default */], function (val) {
    return {
      images: val
    };
  }, extraImages, {
    autoGenerateKey: false
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_7__FeedMeta__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, meta, {
    autoGenerateKey: false
  }));
}

FeedContent.handledProps = ["as", "children", "className", "content", "date", "extraImages", "extraText", "meta", "summary"];
FeedContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** An event can contain a date. */
  date: customPropTypes.itemShorthand,

  /** Shorthand for FeedExtra with images. */
  extraImages: FeedExtra.propTypes.images,

  /** Shorthand for FeedExtra with text. */
  extraText: customPropTypes.itemShorthand,

  /** Shorthand for FeedMeta. */
  meta: customPropTypes.itemShorthand,

  /** Shorthand for FeedSummary. */
  summary: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedContent);

/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);






/**
 * A feed can contain an extra content.
 */

function FeedExtra(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      images = props.images,
      text = props.text;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(images, 'images'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(content || text, 'text'), 'extra', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(FeedExtra, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(FeedExtra, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  } // TODO need a "collection factory" to handle creating multiple image elements and their keys


  var imageElements = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_map__["a" /* default */])(images, function (image, index) {
    var key = [index, image].join('-');
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["k" /* createHTMLImage */])(image, {
      key: key
    });
  });

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), content, imageElements);
}

FeedExtra.handledProps = ["as", "children", "className", "content", "images", "text"];
FeedExtra.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** An event can contain additional information like a set of images. */
  images: customPropTypes.every([customPropTypes.disallow(['text']), PropTypes.oneOfType([PropTypes.bool, customPropTypes.collectionShorthand])]),

  /** An event can contain additional text information. */
  text: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedExtra);

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_Icon__ = __webpack_require__(95);






/**
 * An event can contain an image or icon label.
 */

function FeedLabel(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      icon = props.icon,
      image = props.image;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('label', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(FeedLabel, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(FeedLabel, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), content, __WEBPACK_IMPORTED_MODULE_5__elements_Icon__["a" /* default */].create(icon, {
    autoGenerateKey: false
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["k" /* createHTMLImage */])(image));
}

FeedLabel.handledProps = ["as", "children", "className", "content", "icon", "image"];
FeedLabel.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** An event can contain icon label. */
  icon: customPropTypes.itemShorthand,

  /** An event can contain image label. */
  image: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedLabel);

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_Icon__ = __webpack_require__(95);






/**
 * A feed can contain a like element.
 */

function FeedLike(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      icon = props.icon;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('like', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(FeedLike, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(FeedLike, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__elements_Icon__["a" /* default */].create(icon, {
    autoGenerateKey: false
  }), content);
}

FeedLike.handledProps = ["as", "children", "className", "content", "icon"];
FeedLike.defaultProps = {
  as: 'a'
};
FeedLike.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for icon. Mutually exclusive with children. */
  icon: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedLike);

/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeedLike__ = __webpack_require__(723);






/**
 * A feed can contain a meta.
 */

function FeedMeta(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      like = props.like;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('meta', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(FeedMeta, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(FeedMeta, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_5__FeedLike__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, like, {
    autoGenerateKey: false
  }), content);
}

FeedMeta.handledProps = ["as", "children", "className", "content", "like"];
FeedMeta.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for FeedLike. */
  like: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedMeta);

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeedDate__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FeedUser__ = __webpack_require__(726);







/**
 * A feed can contain a summary.
 */

function FeedSummary(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      date = props.date,
      user = props.user;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('summary', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(FeedSummary, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(FeedSummary, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedUser__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, user, {
    autoGenerateKey: false
  }), content && ' ', content, content && ' ', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_5__FeedDate__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, date, {
    autoGenerateKey: false
  }));
}

FeedSummary.handledProps = ["as", "children", "className", "content", "date", "user"];
FeedSummary.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for FeedDate. */
  date: customPropTypes.itemShorthand,

  /** Shorthand for FeedUser. */
  user: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedSummary);

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A feed can contain a user element.
 */

function FeedUser(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('user', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(FeedUser, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(FeedUser, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

FeedUser.handledProps = ["as", "children", "className", "content"];
FeedUser.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
FeedUser.defaultProps = {
  as: 'a'
};
/* harmony default export */ __webpack_exports__["a"] = (FeedUser);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * An item can contain a description with a single or multiple paragraphs.
 */

function ItemDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('description', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ItemDescription, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ItemDescription, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ItemDescription.handledProps = ["as", "children", "className", "content"];
ItemDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ItemDescription.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ItemDescription, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ItemDescription);

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * An item can contain extra content meant to be formatted separately from the main content.
 */

function ItemExtra(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('extra', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ItemExtra, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ItemExtra, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ItemExtra.handledProps = ["as", "children", "className", "content"];
ItemExtra.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ItemExtra.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ItemExtra, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ItemExtra);

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * An item can contain a header.
 */

function ItemHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ItemHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ItemHeader, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ItemHeader.handledProps = ["as", "children", "className", "content"];
ItemHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ItemHeader.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ItemHeader, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ItemHeader);

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * An item can contain content metadata.
 */

function ItemMeta(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('meta', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ItemMeta, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ItemMeta, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ItemMeta.handledProps = ["as", "children", "className", "content"];
ItemMeta.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ItemMeta.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ItemMeta, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ItemMeta);

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseLodash_js__ = __webpack_require__(740);



/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__baseLodash_js__["a" /* default */].prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

/* harmony default export */ __webpack_exports__["a"] = (LazyWrapper);


/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(110);



/* Built-in method references that are verified to be native. */
var Map = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__ = __webpack_require__(3422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__ = __webpack_require__(3423);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__ = __webpack_require__(3424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__ = __webpack_require__(3425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__ = __webpack_require__(3426);






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__["a" /* default */];
MapCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__["a" /* default */];
MapCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__["a" /* default */];
MapCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__["a" /* default */];
MapCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (MapCache);


/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayEach);


/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayIncludesWith);


/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayPush);


/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(1563);


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */]) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignValue);


/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__ = __webpack_require__(3353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(139);



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(other))) {
    return value !== value && other !== other;
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__["a" /* default */])(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqual);


/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__(3430);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

/* harmony default export */ __webpack_exports__["a"] = (baseLodash);


/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(296);





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

/* harmony default export */ __webpack_exports__["a"] = (getHolder);


/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(1572);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__(3331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__(3333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__(1578);








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

/* harmony default export */ __webpack_exports__["a"] = (hasUnicode);


/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(296);



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ __webpack_exports__["a"] = (isKey);


/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (setToArray);


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__ = __webpack_require__(3368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortOut_js__ = __webpack_require__(1576);



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shortOut_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (setToString);


/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseFilter_js__ = __webpack_require__(3344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(69);





/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__baseFilter_js__["a" /* default */];
  return func(collection, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(predicate, 3));
}

/* harmony default export */ __webpack_exports__["a"] = (filter);


/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFind_js__ = __webpack_require__(3387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__findIndex_js__ = __webpack_require__(1583);



/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createFind_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__findIndex_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (find);


/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(139);




/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == stringTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isString);


/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(733);


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */]);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

/* harmony default export */ __webpack_exports__["a"] = (noop);


/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arraySome_js__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseSome_js__ = __webpack_require__(3369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIterateeCall_js__ = __webpack_require__(490);






/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */
function some(collection, predicate, guard) {
  var func = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arraySome_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_2__baseSome_js__["a" /* default */];
  if (guard && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__isIterateeCall_js__["a" /* default */])(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(predicate, 3));
}

/* harmony default export */ __webpack_exports__["a"] = (some);


/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toNumber_js__ = __webpack_require__(501);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toNumber_js__["a" /* default */])(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (toFinite);


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var exports = module.exports = function SHA (algorithm) {
  algorithm = algorithm.toLowerCase()

  var Algorithm = exports[algorithm]
  if (!Algorithm) throw new Error(algorithm + ' is not supported (we accept pull requests)')

  return new Algorithm()
}

exports.sha = __webpack_require__(3491)
exports.sha1 = __webpack_require__(3492)
exports.sha224 = __webpack_require__(3493)
exports.sha256 = __webpack_require__(1590)
exports.sha384 = __webpack_require__(3494)
exports.sha512 = __webpack_require__(1591)


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

module.exports = Stream;

var EE = __webpack_require__(680).EventEmitter;
var inherits = __webpack_require__(41);

inherits(Stream, EE);
Stream.Readable = __webpack_require__(697);
Stream.Writable = __webpack_require__(3223);
Stream.Duplex = __webpack_require__(3218);
Stream.Transform = __webpack_require__(3222);
Stream.PassThrough = __webpack_require__(3221);

// Backwards-compat with node 0.4.x
Stream.Stream = Stream;



// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.

function Stream() {
  EE.call(this);
}

Stream.prototype.pipe = function(dest, options) {
  var source = this;

  function ondata(chunk) {
    if (dest.writable) {
      if (false === dest.write(chunk) && source.pause) {
        source.pause();
      }
    }
  }

  source.on('data', ondata);

  function ondrain() {
    if (source.readable && source.resume) {
      source.resume();
    }
  }

  dest.on('drain', ondrain);

  // If the 'end' option is not supplied, dest.end() will be called when
  // source gets the 'end' or 'close' events.  Only dest.end() once.
  if (!dest._isStdio && (!options || options.end !== false)) {
    source.on('end', onend);
    source.on('close', onclose);
  }

  var didOnEnd = false;
  function onend() {
    if (didOnEnd) return;
    didOnEnd = true;

    dest.end();
  }


  function onclose() {
    if (didOnEnd) return;
    didOnEnd = true;

    if (typeof dest.destroy === 'function') dest.destroy();
  }

  // don't leave dangling pipes when there are errors.
  function onerror(er) {
    cleanup();
    if (EE.listenerCount(this, 'error') === 0) {
      throw er; // Unhandled stream error in pipe.
    }
  }

  source.on('error', onerror);
  dest.on('error', onerror);

  // remove all the event listeners that were added.
  function cleanup() {
    source.removeListener('data', ondata);
    dest.removeListener('drain', ondrain);

    source.removeListener('end', onend);
    source.removeListener('close', onclose);

    source.removeListener('error', onerror);
    dest.removeListener('error', onerror);

    source.removeListener('end', cleanup);
    source.removeListener('close', cleanup);

    dest.removeListener('close', cleanup);
  }

  source.on('end', cleanup);
  source.on('close', cleanup);

  dest.on('close', cleanup);

  dest.emit('pipe', source);

  // Allow for unix-like usage: A.pipe(B).pipe(C)
  return dest;
};


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = __webpack_require__(42).Buffer;
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),
/* 761 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEwMDBfMTIyMDgpIj4KPHBhdGggZD0iTTIuMjUgNkMyLjI1IDUuNDAzMjYgMi40ODcwNSA0LjgzMDk3IDIuOTA5MDEgNC40MDkwMUMzLjMzMDk3IDMuOTg3MDUgMy45MDMyNiAzLjc1IDQuNSAzLjc1SDEzLjVDMTQuMDk2NyAzLjc1IDE0LjY2OSAzLjk4NzA1IDE1LjA5MSA0LjQwOTAxQzE1LjUxMjkgNC44MzA5NyAxNS43NSA1LjQwMzI2IDE1Ljc1IDZWMTJDMTUuNzUgMTIuNTk2NyAxNS41MTI5IDEzLjE2OSAxNS4wOTEgMTMuNTkxQzE0LjY2OSAxNC4wMTI5IDE0LjA5NjcgMTQuMjUgMTMuNSAxNC4yNUg0LjVDMy45MDMyNiAxNC4yNSAzLjMzMDk3IDE0LjAxMjkgMi45MDkwMSAxMy41OTFDMi40ODcwNSAxMy4xNjkgMi4yNSAxMi41OTY3IDIuMjUgMTJWNloiIHN0cm9rZT0iI0RCRERERSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMi4yNSA3LjVIMTUuNzUiIHN0cm9rZT0iI0RCRERERSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNS4yNSAxMS4yNUg1LjI1NzUiIHN0cm9rZT0iI0RCRERERSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOC4yNSAxMS4yNUg5Ljc1IiBzdHJva2U9IiNEQkREREUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xMDAwXzEyMjA4Ij4KPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),
/* 762 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEwMDBfMTIxOTYpIj4KPHBhdGggZD0iTTIuMjUgNkMyLjI1IDUuNDAzMjYgMi40ODcwNSA0LjgzMDk3IDIuOTA5MDEgNC40MDkwMUMzLjMzMDk3IDMuOTg3MDUgMy45MDMyNiAzLjc1IDQuNSAzLjc1SDEzLjVDMTQuMDk2NyAzLjc1IDE0LjY2OSAzLjk4NzA1IDE1LjA5MSA0LjQwOTAxQzE1LjUxMjkgNC44MzA5NyAxNS43NSA1LjQwMzI2IDE1Ljc1IDZWMTJDMTUuNzUgMTIuNTk2NyAxNS41MTI5IDEzLjE2OSAxNS4wOTEgMTMuNTkxQzE0LjY2OSAxNC4wMTI5IDE0LjA5NjcgMTQuMjUgMTMuNSAxNC4yNUg0LjVDMy45MDMyNiAxNC4yNSAzLjMzMDk3IDE0LjAxMjkgMi45MDkwMSAxMy41OTFDMi40ODcwNSAxMy4xNjkgMi4yNSAxMi41OTY3IDIuMjUgMTJWNloiIHN0cm9rZT0iIzI0QTQ3NiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMi4yNSA3LjVIMTUuNzUiIHN0cm9rZT0iIzI0QTQ3NiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNS4yNSAxMS4yNUg1LjI1NzUiIHN0cm9rZT0iIzI0QTQ3NiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOC4yNSAxMS4yNUg5Ljc1IiBzdHJva2U9IiMyNEE0NzYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xMDAwXzEyMTk2Ij4KPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),
/* 763 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEwMDBfMTIyMDQpIj4KPHBhdGggZD0iTTIuMjUgNkMyLjI1IDUuNDAzMjYgMi40ODcwNSA0LjgzMDk3IDIuOTA5MDEgNC40MDkwMUMzLjMzMDk3IDMuOTg3MDUgMy45MDMyNiAzLjc1IDQuNSAzLjc1SDEzLjVDMTQuMDk2NyAzLjc1IDE0LjY2OSAzLjk4NzA1IDE1LjA5MSA0LjQwOTAxQzE1LjUxMjkgNC44MzA5NyAxNS43NSA1LjQwMzI2IDE1Ljc1IDZWMTJDMTUuNzUgMTIuNTk2NyAxNS41MTI5IDEzLjE2OSAxNS4wOTEgMTMuNTkxQzE0LjY2OSAxNC4wMTI5IDE0LjA5NjcgMTQuMjUgMTMuNSAxNC4yNUg0LjVDMy45MDMyNiAxNC4yNSAzLjMzMDk3IDE0LjAxMjkgMi45MDkwMSAxMy41OTFDMi40ODcwNSAxMy4xNjkgMi4yNSAxMi41OTY3IDIuMjUgMTJWNloiIHN0cm9rZT0iI0YyQjQyQSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMi4yNSA3LjVIMTUuNzUiIHN0cm9rZT0iI0YyQjQyQSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNS4yNSAxMS4yNUg1LjI1NzUiIHN0cm9rZT0iI0YyQjQyQSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOC4yNSAxMS4yNUg5Ljc1IiBzdHJva2U9IiNGMkI0MkEiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xMDAwXzEyMjA0Ij4KPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),
/* 764 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEwOTVfMzQ2NikiPgo8cGF0aCBkPSJNMi4yNSAxNS43NUgxNS43NSIgc3Ryb2tlPSIjREJERERFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yLjI1IDcuNUgxNS43NSIgc3Ryb2tlPSIjREJERERFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0zLjc1IDQuNUw5IDIuMjVMMTQuMjUgNC41IiBzdHJva2U9IiNEQkREREUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMgNy41VjE1Ljc1IiBzdHJva2U9IiNEQkREREUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE1IDcuNVYxNS43NSIgc3Ryb2tlPSIjREJERERFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik02IDEwLjVWMTIuNzUiIHN0cm9rZT0iI0RCRERERSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOSAxMC41VjEyLjc1IiBzdHJva2U9IiNEQkREREUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyIDEwLjVWMTIuNzUiIHN0cm9rZT0iI0RCRERERSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzEwOTVfMzQ2NiI+CjxyZWN0IHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K"

/***/ }),
/* 765 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE0OTZfMTg1NjUpIj4KPHBhdGggZD0iTTMgOS41TDcgNS41TTcgNS41TDExIDkuNU03IDUuNVYxOS41IiBzdHJva2U9IiM1OTY5NzUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMSAxNS41TDE3IDE5LjVNMTcgMTkuNUwxMyAxNS41TTE3IDE5LjVWNS41IiBzdHJva2U9IiM1OTY5NzUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTQ5Nl8xODU2NSI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0id2hpdGUiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMC41KSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),
/* 766 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return graphqlOperation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GraphQLAPIClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GraphQLAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_error_GraphQLError__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_graphql_error_GraphQLError___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_graphql_error_GraphQLError__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql_language_printer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_language_parser__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_graphql_language_parser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_graphql_language_parser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_amplify_core__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_amplify_pubsub__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_amplify_auth__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__aws_amplify_cache__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types__ = __webpack_require__(507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__aws_amplify_api_rest__ = __webpack_require__(771);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */









var USER_AGENT_HEADER = 'x-amz-user-agent';
var logger = new __WEBPACK_IMPORTED_MODULE_3__aws_amplify_core__["ConsoleLogger"]('GraphQLAPI');
var graphqlOperation = function (query, variables) {
    if (variables === void 0) { variables = {}; }
    return ({
        query: query,
        variables: variables,
    });
};
/**
 * Export Cloud Logic APIs
 */
var GraphQLAPIClass = /** @class */ (function () {
    /**
     * Initialize GraphQL API with AWS configuration
     * @param {Object} options - Configuration object for API
     */
    function GraphQLAPIClass(options) {
        this._api = null;
        this.Auth = __WEBPACK_IMPORTED_MODULE_5__aws_amplify_auth__["default"];
        this.Cache = __WEBPACK_IMPORTED_MODULE_6__aws_amplify_cache__["a" /* default */];
        this.Credentials = __WEBPACK_IMPORTED_MODULE_3__aws_amplify_core__["Credentials"];
        this._options = options;
        logger.debug('API Options', this._options);
    }
    GraphQLAPIClass.prototype.getModuleName = function () {
        return 'GraphQLAPI';
    };
    /**
     * Configure API
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */
    GraphQLAPIClass.prototype.configure = function (options) {
        var _a = options || {}, _b = _a.API, API = _b === void 0 ? {} : _b, otherOptions = __rest(_a, ["API"]);
        var opt = __assign(__assign({}, otherOptions), API);
        logger.debug('configure GraphQL API', { opt: opt });
        if (opt['aws_project_region']) {
            opt = Object.assign({}, opt, {
                region: opt['aws_project_region'],
                header: {},
            });
        }
        if (typeof opt.graphql_headers !== 'undefined' &&
            typeof opt.graphql_headers !== 'function') {
            logger.warn('graphql_headers should be a function');
            opt.graphql_headers = undefined;
        }
        this._options = Object.assign({}, this._options, opt);
        this.createInstance();
        return this._options;
    };
    /**
     * Create an instance of API for the library
     * @return - A promise of true if Success
     */
    GraphQLAPIClass.prototype.createInstance = function () {
        logger.debug('create Rest instance');
        if (this._options) {
            this._api = new __WEBPACK_IMPORTED_MODULE_8__aws_amplify_api_rest__["a" /* RestClient */](this._options);
            // Share instance Credentials with client for SSR
            this._api.Credentials = this.Credentials;
            return true;
        }
        else {
            return Promise.reject('API not configured');
        }
    };
    GraphQLAPIClass.prototype._headerBasedAuth = function (defaultAuthenticationType) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, aws_appsync_authenticationType, apiKey, authenticationType, headers, _b, credentialsOK, token, federatedInfo, currentUser, e_1, session, e_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this._options, aws_appsync_authenticationType = _a.aws_appsync_authenticationType, apiKey = _a.aws_appsync_apiKey;
                        authenticationType = defaultAuthenticationType || aws_appsync_authenticationType || 'AWS_IAM';
                        headers = {};
                        _b = authenticationType;
                        switch (_b) {
                            case 'API_KEY': return [3 /*break*/, 1];
                            case 'AWS_IAM': return [3 /*break*/, 2];
                            case 'OPENID_CONNECT': return [3 /*break*/, 4];
                            case 'AMAZON_COGNITO_USER_POOLS': return [3 /*break*/, 11];
                        }
                        return [3 /*break*/, 15];
                    case 1:
                        if (!apiKey) {
                            throw new Error(__WEBPACK_IMPORTED_MODULE_7__types__["a" /* GraphQLAuthError */].NO_API_KEY);
                        }
                        headers = {
                            Authorization: null,
                            'X-Api-Key': apiKey,
                        };
                        return [3 /*break*/, 16];
                    case 2: return [4 /*yield*/, this._ensureCredentials()];
                    case 3:
                        credentialsOK = _c.sent();
                        if (!credentialsOK) {
                            throw new Error(__WEBPACK_IMPORTED_MODULE_7__types__["a" /* GraphQLAuthError */].NO_CREDENTIALS);
                        }
                        return [3 /*break*/, 16];
                    case 4:
                        _c.trys.push([4, 9, , 10]);
                        token = void 0;
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_6__aws_amplify_cache__["a" /* default */].getItem('federatedInfo')];
                    case 5:
                        federatedInfo = _c.sent();
                        if (!federatedInfo) return [3 /*break*/, 6];
                        token = federatedInfo.token;
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__aws_amplify_auth__["default"].currentAuthenticatedUser()];
                    case 7:
                        currentUser = _c.sent();
                        if (currentUser) {
                            token = currentUser.token;
                        }
                        _c.label = 8;
                    case 8:
                        if (!token) {
                            throw new Error(__WEBPACK_IMPORTED_MODULE_7__types__["a" /* GraphQLAuthError */].NO_FEDERATED_JWT);
                        }
                        headers = {
                            Authorization: token,
                        };
                        return [3 /*break*/, 10];
                    case 9:
                        e_1 = _c.sent();
                        throw new Error(__WEBPACK_IMPORTED_MODULE_7__types__["a" /* GraphQLAuthError */].NO_CURRENT_USER);
                    case 10: return [3 /*break*/, 16];
                    case 11:
                        _c.trys.push([11, 13, , 14]);
                        return [4 /*yield*/, this.Auth.currentSession()];
                    case 12:
                        session = _c.sent();
                        headers = {
                            Authorization: session.getAccessToken().getJwtToken(),
                        };
                        return [3 /*break*/, 14];
                    case 13:
                        e_2 = _c.sent();
                        throw new Error(__WEBPACK_IMPORTED_MODULE_7__types__["a" /* GraphQLAuthError */].NO_CURRENT_USER);
                    case 14: return [3 /*break*/, 16];
                    case 15:
                        headers = {
                            Authorization: null,
                        };
                        return [3 /*break*/, 16];
                    case 16: return [2 /*return*/, headers];
                }
            });
        });
    };
    /**
     * to get the operation type
     * @param operation
     */
    GraphQLAPIClass.prototype.getGraphqlOperationType = function (operation) {
        var doc = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_graphql_language_parser__["parse"])(operation);
        var _a = __read(doc.definitions, 1), operationType = _a[0].operation;
        return operationType;
    };
    /**
     * Executes a GraphQL operation
     *
     * @param {GraphQLOptions} GraphQL Options
     * @param {object} additionalHeaders headers to merge in after any `graphql_headers` set in the config
     * @returns {Promise<GraphQLResult> | Observable<object>}
     */
    GraphQLAPIClass.prototype.graphql = function (_a, additionalHeaders) {
        var paramQuery = _a.query, _b = _a.variables, variables = _b === void 0 ? {} : _b, authMode = _a.authMode;
        var query = typeof paramQuery === 'string'
            ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_graphql_language_parser__["parse"])(paramQuery)
            : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_graphql_language_parser__["parse"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__["print"])(paramQuery));
        var _c = __read(query.definitions.filter(function (def) { return def.kind === 'OperationDefinition'; }), 1), _d = _c[0], operationDef = _d === void 0 ? {} : _d;
        var operationType = operationDef.operation;
        switch (operationType) {
            case 'query':
            case 'mutation':
                var cancellableToken = this._api.getCancellableToken();
                var initParams = { cancellableToken: cancellableToken };
                var responsePromise = this._graphql({ query: query, variables: variables, authMode: authMode }, additionalHeaders, initParams);
                this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
                return responsePromise;
            case 'subscription':
                return this._graphqlSubscribe({ query: query, variables: variables, authMode: authMode }, additionalHeaders);
        }
        throw new Error("invalid operation type: " + operationType);
    };
    GraphQLAPIClass.prototype._graphql = function (_a, additionalHeaders, initParams) {
        var query = _a.query, variables = _a.variables, authMode = _a.authMode;
        if (additionalHeaders === void 0) { additionalHeaders = {}; }
        if (initParams === void 0) { initParams = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var _b, region, appSyncGraphqlEndpoint, _c, graphql_headers, customGraphqlEndpoint, customEndpointRegion, headers, _d, _e, _f, _g, _h, _j, body, init, endpoint, error, response, err_1, errors;
            var _k;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        if (!!this._api) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.createInstance()];
                    case 1:
                        _l.sent();
                        _l.label = 2;
                    case 2:
                        _b = this._options, region = _b.aws_appsync_region, appSyncGraphqlEndpoint = _b.aws_appsync_graphqlEndpoint, _c = _b.graphql_headers, graphql_headers = _c === void 0 ? function () { return ({}); } : _c, customGraphqlEndpoint = _b.graphql_endpoint, customEndpointRegion = _b.graphql_endpoint_iam_region;
                        _d = [{}];
                        _e = !customGraphqlEndpoint;
                        if (!_e) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._headerBasedAuth(authMode)];
                    case 3:
                        _e = (_l.sent());
                        _l.label = 4;
                    case 4:
                        _f = [__assign.apply(void 0, _d.concat([(_e)]))];
                        _g = customGraphqlEndpoint;
                        if (!_g) return [3 /*break*/, 8];
                        if (!customEndpointRegion) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._headerBasedAuth(authMode)];
                    case 5:
                        _h = _l.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        _h = { Authorization: null };
                        _l.label = 7;
                    case 7:
                        _g = (_h);
                        _l.label = 8;
                    case 8:
                        _j = [__assign.apply(void 0, _f.concat([(_g)]))];
                        return [4 /*yield*/, graphql_headers({ query: query, variables: variables })];
                    case 9:
                        headers = __assign.apply(void 0, [__assign.apply(void 0, [__assign.apply(void 0, _j.concat([(_l.sent())])), additionalHeaders]), (!customGraphqlEndpoint && (_k = {},
                                _k[USER_AGENT_HEADER] = __WEBPACK_IMPORTED_MODULE_3__aws_amplify_core__["Constants"].userAgent,
                                _k))]);
                        body = {
                            query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__["print"])(query),
                            variables: variables,
                        };
                        init = Object.assign({
                            headers: headers,
                            body: body,
                            signerServiceInfo: {
                                service: !customGraphqlEndpoint ? 'appsync' : 'execute-api',
                                region: !customGraphqlEndpoint ? region : customEndpointRegion,
                            },
                        }, initParams);
                        endpoint = customGraphqlEndpoint || appSyncGraphqlEndpoint;
                        if (!endpoint) {
                            error = new __WEBPACK_IMPORTED_MODULE_0_graphql_error_GraphQLError__["GraphQLError"]('No graphql endpoint provided.');
                            throw {
                                data: {},
                                errors: [error],
                            };
                        }
                        _l.label = 10;
                    case 10:
                        _l.trys.push([10, 12, , 13]);
                        return [4 /*yield*/, this._api.post(endpoint, init)];
                    case 11:
                        response = _l.sent();
                        return [3 /*break*/, 13];
                    case 12:
                        err_1 = _l.sent();
                        // If the exception is because user intentionally
                        // cancelled the request, do not modify the exception
                        // so that clients can identify the exception correctly.
                        if (this._api.isCancel(err_1)) {
                            throw err_1;
                        }
                        response = {
                            data: {},
                            errors: [new __WEBPACK_IMPORTED_MODULE_0_graphql_error_GraphQLError__["GraphQLError"](err_1.message, null, null, null, null, err_1)],
                        };
                        return [3 /*break*/, 13];
                    case 13:
                        errors = response.errors;
                        if (errors && errors.length) {
                            throw response;
                        }
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */
    GraphQLAPIClass.prototype.isCancel = function (error) {
        return this._api.isCancel(error);
    };
    /**
     * Cancels an inflight request. Only applicable for graphql queries and mutations
     * @param {any} request - request to cancel
     * @return {boolean} - A boolean indicating if the request was cancelled
     */
    GraphQLAPIClass.prototype.cancel = function (request, message) {
        return this._api.cancel(request, message);
    };
    GraphQLAPIClass.prototype._graphqlSubscribe = function (_a, additionalHeaders) {
        var query = _a.query, variables = _a.variables, defaultAuthenticationType = _a.authMode;
        if (additionalHeaders === void 0) { additionalHeaders = {}; }
        var _b = this._options, region = _b.aws_appsync_region, appSyncGraphqlEndpoint = _b.aws_appsync_graphqlEndpoint, aws_appsync_authenticationType = _b.aws_appsync_authenticationType, apiKey = _b.aws_appsync_apiKey, _c = _b.graphql_headers, graphql_headers = _c === void 0 ? function () { return ({}); } : _c;
        var authenticationType = defaultAuthenticationType || aws_appsync_authenticationType || 'AWS_IAM';
        if (__WEBPACK_IMPORTED_MODULE_4__aws_amplify_pubsub__["a" /* default */] && typeof __WEBPACK_IMPORTED_MODULE_4__aws_amplify_pubsub__["a" /* default */].subscribe === 'function') {
            return __WEBPACK_IMPORTED_MODULE_4__aws_amplify_pubsub__["a" /* default */].subscribe('', {
                provider: __WEBPACK_IMPORTED_MODULE_3__aws_amplify_core__["INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER"],
                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                authenticationType: authenticationType,
                apiKey: apiKey,
                query: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_graphql_language_printer__["print"])(query),
                region: region,
                variables: variables,
                graphql_headers: graphql_headers,
                additionalHeaders: additionalHeaders,
            });
        }
        else {
            logger.debug('No pubsub module applied for subscription');
            throw new Error('No pubsub module applied for subscription');
        }
    };
    /**
     * @private
     */
    GraphQLAPIClass.prototype._ensureCredentials = function () {
        var _this = this;
        return this.Credentials.get()
            .then(function (credentials) {
            if (!credentials)
                return false;
            var cred = _this.Credentials.shear(credentials);
            logger.debug('set credentials for api', cred);
            return true;
        })
            .catch(function (err) {
            logger.warn('ensure credentials error', err);
            return false;
        });
    };
    return GraphQLAPIClass;
}());

var GraphQLAPI = new GraphQLAPIClass(null);
__WEBPACK_IMPORTED_MODULE_3__aws_amplify_core__["Amplify"].register(GraphQLAPI);
//# sourceMappingURL=GraphQLAPI.js.map

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GraphQLAPI__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(507);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__types__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__types__["b"]; });
/* unused harmony reexport GraphQLAPI */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__GraphQLAPI__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__GraphQLAPI__["a"]; });
/* unused harmony namespace reexport */
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */




/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__GraphQLAPI__["b" /* GraphQLAPI */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RestAPIClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RestAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RestClient__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__ = __webpack_require__(71);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */


var logger = new __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["ConsoleLogger"]('RestAPI');
/**
 * Export Cloud Logic APIs
 */
var RestAPIClass = /** @class */ (function () {
    /**
     * Initialize Rest API with AWS configuration
     * @param {Object} options - Configuration object for API
     */
    function RestAPIClass(options) {
        this._api = null;
        this.Credentials = __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["Credentials"];
        this._options = options;
        logger.debug('API Options', this._options);
    }
    RestAPIClass.prototype.getModuleName = function () {
        return 'RestAPI';
    };
    /**
     * Configure API part with aws configurations
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */
    RestAPIClass.prototype.configure = function (options) {
        var _a = options || {}, _b = _a.API, API = _b === void 0 ? {} : _b, otherOptions = __rest(_a, ["API"]);
        var opt = __assign(__assign({}, otherOptions), API);
        logger.debug('configure Rest API', { opt: opt });
        if (opt['aws_project_region']) {
            if (opt['aws_cloud_logic_custom']) {
                var custom = opt['aws_cloud_logic_custom'];
                opt.endpoints =
                    typeof custom === 'string' ? JSON.parse(custom) : custom;
            }
            opt = Object.assign({}, opt, {
                region: opt['aws_project_region'],
                header: {},
            });
        }
        if (Array.isArray(opt.endpoints)) {
            // Check if endpoints has custom_headers and validate if is a function
            opt.endpoints.forEach(function (endpoint) {
                if (typeof endpoint.custom_header !== 'undefined' &&
                    typeof endpoint.custom_header !== 'function') {
                    logger.warn('Rest API ' + endpoint.name + ', custom_header should be a function');
                    endpoint.custom_header = undefined;
                }
            });
        }
        else if (this._options && Array.isArray(this._options.endpoints)) {
            opt.endpoints = this._options.endpoints;
        }
        else {
            opt.endpoints = [];
        }
        this._options = Object.assign({}, this._options, opt);
        this.createInstance();
        return this._options;
    };
    /**
     * Create an instance of API for the library
     * @return - A promise of true if Success
     */
    RestAPIClass.prototype.createInstance = function () {
        logger.debug('create Rest API instance');
        this._api = new __WEBPACK_IMPORTED_MODULE_0__RestClient__["a" /* RestClient */](this._options);
        // Share Amplify instance with client for SSR
        this._api.Credentials = this.Credentials;
        return true;
    };
    /**
     * Make a GET request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    RestAPIClass.prototype.get = function (apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.get(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        }
        catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a POST request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    RestAPIClass.prototype.post = function (apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.post(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        }
        catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a PUT request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    RestAPIClass.prototype.put = function (apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.put(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        }
        catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a PATCH request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    RestAPIClass.prototype.patch = function (apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.patch(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        }
        catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a DEL request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    RestAPIClass.prototype.del = function (apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.del(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        }
        catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Make a HEAD request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    RestAPIClass.prototype.head = function (apiName, path, init) {
        try {
            var apiInfo = this.getEndpointInfo(apiName, path);
            var cancellableToken = this._api.getCancellableToken();
            var initParams = Object.assign({}, init);
            initParams.cancellableToken = cancellableToken;
            var responsePromise = this._api.head(apiInfo, initParams);
            this._api.updateRequestToBeCancellable(responsePromise, cancellableToken);
            return responsePromise;
        }
        catch (err) {
            return Promise.reject(err.message);
        }
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */
    RestAPIClass.prototype.isCancel = function (error) {
        return this._api.isCancel(error);
    };
    /**
     * Cancels an inflight request
     * @param {any} request - request to cancel
     * @return {boolean} - A boolean indicating if the request was cancelled
     */
    RestAPIClass.prototype.cancel = function (request, message) {
        return this._api.cancel(request, message);
    };
    /**
     * Getting endpoint for API
     * @param {string} apiName - The name of the api
     * @return {string} - The endpoint of the api
     */
    RestAPIClass.prototype.endpoint = function (apiName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._api.endpoint(apiName)];
            });
        });
    };
    /**
     * Getting endpoint info for API
     * @param {string} apiName - The name of the api
     * @param {string} path - The path of the api that is going to accessed
     * @return {ApiInfo} - The endpoint information for that api-name
     */
    RestAPIClass.prototype.getEndpointInfo = function (apiName, path) {
        var cloud_logic_array = this._options.endpoints;
        if (!Array.isArray(cloud_logic_array)) {
            throw new Error("API category not configured");
        }
        var apiConfig = cloud_logic_array.find(function (api) { return api.name === apiName; });
        if (!apiConfig) {
            throw new Error("API " + apiName + " does not exist");
        }
        var response = {
            endpoint: apiConfig.endpoint + path,
        };
        if (typeof apiConfig.region === 'string') {
            response.region = apiConfig.region;
        }
        else if (typeof this._options.region === 'string') {
            response.region = this._options.region;
        }
        if (typeof apiConfig.service === 'string') {
            response.service = apiConfig.service || 'execute-api';
        }
        else {
            response.service = 'execute-api';
        }
        if (typeof apiConfig.custom_header === 'function') {
            response.custom_header = apiConfig.custom_header;
        }
        else {
            response.custom_header = undefined;
        }
        return response;
    };
    return RestAPIClass;
}());

var RestAPI = new RestAPIClass(null);
__WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["Amplify"].register(RestAPI);
//# sourceMappingURL=RestAPI.js.map

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RestClient; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(2059);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_url__);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};



var logger = new __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["ConsoleLogger"]('RestClient');
/**
* HTTP Client for REST requests. Send and receive JSON data.
* Sign request with AWS credentials if available
* Usage:
<pre>
const restClient = new RestClient();
restClient.get('...')
    .then(function(data) {
        console.log(data);
    })
    .catch(err => console.log(err));
</pre>
*/
var RestClient = /** @class */ (function () {
    /**
     * @param {RestClientOptions} [options] - Instance options
     */
    function RestClient(options) {
        this._region = 'us-east-1'; // this will be updated by endpoint function
        this._service = 'execute-api'; // this can be updated by endpoint function
        this._custom_header = undefined; // this can be updated by endpoint function
        /**
         * This weak map provides functionality to let clients cancel
         * in-flight axios requests. https://github.com/axios/axios#cancellation
         *
         * 1. For every axios request, a unique cancel token is generated and added in the request.
         * 2. Promise for fulfilling the request is then mapped to that unique cancel token.
         * 3. The promise is returned to the client.
         * 4. Clients can either wait for the promise to fulfill or call `API.cancel(promise)` to cancel the request.
         * 5. If `API.cancel(promise)` is called, then the corresponding cancel token is retrieved from the map below.
         * 6. Promise returned to the client will be in rejected state with the error provided during cancel.
         * 7. Clients can check if the error is because of cancelling by calling `API.isCancel(error)`.
         *
         * For more details, see https://github.com/aws-amplify/amplify-js/pull/3769#issuecomment-552660025
         */
        this._cancelTokenMap = null;
        this.Credentials = __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["Credentials"];
        this._options = options;
        logger.debug('API Options', this._options);
        if (this._cancelTokenMap == null) {
            this._cancelTokenMap = new WeakMap();
        }
    }
    /**
    * Update AWS credentials
    * @param {AWSCredentials} credentials - AWS credentials
    *
    updateCredentials(credentials: AWSCredentials) {
        this.options.credentials = credentials;
    }
*/
    /**
     * Basic HTTP request. Customizable
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {string} method - Request HTTP method
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    RestClient.prototype.ajax = function (urlOrApiInfo, method, init) {
        return __awaiter(this, void 0, void 0, function () {
            var parsed_url, url, region, service, custom_header, params, libraryHeaders, userAgent, initParams, isAllResponse, custom_header_obj, _a, _b, search, parsedUrl;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        logger.debug(method, urlOrApiInfo);
                        region = 'us-east-1';
                        service = 'execute-api';
                        custom_header = undefined;
                        if (typeof urlOrApiInfo === 'string') {
                            parsed_url = this._parseUrl(urlOrApiInfo);
                            url = urlOrApiInfo;
                        }
                        else {
                            (url = urlOrApiInfo.endpoint, custom_header = urlOrApiInfo.custom_header, region = urlOrApiInfo.region, service = urlOrApiInfo.service);
                            parsed_url = this._parseUrl(urlOrApiInfo.endpoint);
                        }
                        params = {
                            method: method,
                            url: url,
                            host: parsed_url.host,
                            path: parsed_url.path,
                            headers: {},
                            data: null,
                            responseType: 'json',
                            timeout: 0,
                            cancelToken: null,
                        };
                        libraryHeaders = {};
                        if (__WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["Platform"].isReactNative) {
                            userAgent = __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["Platform"].userAgent || 'aws-amplify/0.1.x';
                            libraryHeaders = {
                                'User-Agent': userAgent,
                            };
                        }
                        initParams = Object.assign({}, init);
                        isAllResponse = initParams.response;
                        if (initParams.body) {
                            if (typeof FormData === 'function' &&
                                initParams.body instanceof FormData) {
                                libraryHeaders['Content-Type'] = 'multipart/form-data';
                                params.data = initParams.body;
                            }
                            else {
                                libraryHeaders['Content-Type'] = 'application/json; charset=UTF-8';
                                params.data = JSON.stringify(initParams.body);
                            }
                        }
                        if (initParams.responseType) {
                            params.responseType = initParams.responseType;
                        }
                        if (initParams.withCredentials) {
                            params['withCredentials'] = initParams.withCredentials;
                        }
                        if (initParams.timeout) {
                            params.timeout = initParams.timeout;
                        }
                        if (initParams.cancellableToken) {
                            params.cancelToken = initParams.cancellableToken.token;
                        }
                        params['signerServiceInfo'] = initParams.signerServiceInfo;
                        if (!(typeof custom_header === 'function')) return [3 /*break*/, 2];
                        return [4 /*yield*/, custom_header()];
                    case 1:
                        _a = _c.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a = undefined;
                        _c.label = 3;
                    case 3:
                        custom_header_obj = _a;
                        params.headers = __assign(__assign(__assign({}, libraryHeaders), custom_header_obj), initParams.headers);
                        _b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_url__["parse"])(url, true, true), search = _b.search, parsedUrl = __rest(_b, ["search"]);
                        params.url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_url__["format"])(__assign(__assign({}, parsedUrl), { query: __assign(__assign({}, parsedUrl.query), (initParams.queryStringParameters || {})) }));
                        // Do not sign the request if client has added 'Authorization' header,
                        // which means custom authorizer.
                        if (typeof params.headers['Authorization'] !== 'undefined') {
                            params.headers = Object.keys(params.headers).reduce(function (acc, k) {
                                if (params.headers[k]) {
                                    acc[k] = params.headers[k];
                                }
                                return acc;
                                // tslint:disable-next-line:align
                            }, {});
                            return [2 /*return*/, this._request(params, isAllResponse)];
                        }
                        // Signing the request in case there credentials are available
                        return [2 /*return*/, this.Credentials.get().then(function (credentials) {
                                return _this._signed(__assign({}, params), credentials, isAllResponse, {
                                    region: region,
                                    service: service,
                                }).catch(function (error) {
                                    if (__WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["DateUtils"].isClockSkewError(error)) {
                                        var headers = error.response.headers;
                                        var dateHeader = headers && (headers.date || headers.Date);
                                        var responseDate = new Date(dateHeader);
                                        var requestDate = __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["DateUtils"].getDateFromHeaderString(params.headers['x-amz-date']);
                                        // Compare local clock to the server clock
                                        if (__WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["DateUtils"].isClockSkewed(responseDate)) {
                                            __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["DateUtils"].setClockOffset(responseDate.getTime() - requestDate.getTime());
                                            return _this.ajax(urlOrApiInfo, method, init);
                                        }
                                    }
                                    throw error;
                                });
                            }, function (err) {
                                logger.debug('No credentials available, the request will be unsigned');
                                return _this._request(params, isAllResponse);
                            })];
                }
            });
        });
    };
    /**
     * GET HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {JSON} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    RestClient.prototype.get = function (urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, 'GET', init);
    };
    /**
     * PUT HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    RestClient.prototype.put = function (urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, 'PUT', init);
    };
    /**
     * PATCH HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    RestClient.prototype.patch = function (urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, 'PATCH', init);
    };
    /**
     * POST HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    RestClient.prototype.post = function (urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, 'POST', init);
    };
    /**
     * DELETE HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    RestClient.prototype.del = function (urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, 'DELETE', init);
    };
    /**
     * HEAD HTTP request
     * @param {string | ApiInfo } urlOrApiInfo - Full request URL or Api information
     * @param {json} init - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    RestClient.prototype.head = function (urlOrApiInfo, init) {
        return this.ajax(urlOrApiInfo, 'HEAD', init);
    };
    /**
     * Cancel an inflight API request
     * @param {Promise<any>} request - The request promise to cancel
     * @param {string} [message] - A message to include in the cancelation exception
     */
    RestClient.prototype.cancel = function (request, message) {
        var source = this._cancelTokenMap.get(request);
        if (source) {
            source.cancel(message);
        }
        return true;
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */
    RestClient.prototype.isCancel = function (error) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.isCancel(error);
    };
    /**
     * Retrieves a new and unique cancel token which can be
     * provided in an axios request to be cancelled later.
     */
    RestClient.prototype.getCancellableToken = function () {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.CancelToken.source();
    };
    /**
     * Updates the weakmap with a response promise and its
     * cancel token such that the cancel token can be easily
     * retrieved (and used for cancelling the request)
     */
    RestClient.prototype.updateRequestToBeCancellable = function (promise, cancelTokenSource) {
        this._cancelTokenMap.set(promise, cancelTokenSource);
    };
    /**
     * Getting endpoint for API
     * @param {string} apiName - The name of the api
     * @return {string} - The endpoint of the api
     */
    RestClient.prototype.endpoint = function (apiName) {
        var _this = this;
        var cloud_logic_array = this._options.endpoints;
        var response = '';
        if (!Array.isArray(cloud_logic_array)) {
            return response;
        }
        cloud_logic_array.forEach(function (v) {
            if (v.name === apiName) {
                response = v.endpoint;
                if (typeof v.region === 'string') {
                    _this._region = v.region;
                }
                else if (typeof _this._options.region === 'string') {
                    _this._region = _this._options.region;
                }
                if (typeof v.service === 'string') {
                    _this._service = v.service || 'execute-api';
                }
                else {
                    _this._service = 'execute-api';
                }
                if (typeof v.custom_header === 'function') {
                    _this._custom_header = v.custom_header;
                }
                else {
                    _this._custom_header = undefined;
                }
            }
        });
        return response;
    };
    /** private methods **/
    RestClient.prototype._signed = function (params, credentials, isAllResponse, _a) {
        var service = _a.service, region = _a.region;
        var signerServiceInfoParams = params.signerServiceInfo, otherParams = __rest(params, ["signerServiceInfo"]);
        var endpoint_region = region || this._region || this._options.region;
        var endpoint_service = service || this._service || this._options.service;
        var creds = {
            secret_key: credentials.secretAccessKey,
            access_key: credentials.accessKeyId,
            session_token: credentials.sessionToken,
        };
        var endpointInfo = {
            region: endpoint_region,
            service: endpoint_service,
        };
        var signerServiceInfo = Object.assign(endpointInfo, signerServiceInfoParams);
        var signed_params = __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["Signer"].sign(otherParams, creds, signerServiceInfo);
        if (signed_params.data) {
            signed_params.body = signed_params.data;
        }
        logger.debug('Signed Request: ', signed_params);
        delete signed_params.headers['host'];
        return __WEBPACK_IMPORTED_MODULE_1_axios___default()(signed_params)
            .then(function (response) { return (isAllResponse ? response : response.data); })
            .catch(function (error) {
            logger.debug(error);
            throw error;
        });
    };
    RestClient.prototype._request = function (params, isAllResponse) {
        if (isAllResponse === void 0) { isAllResponse = false; }
        return __WEBPACK_IMPORTED_MODULE_1_axios___default()(params)
            .then(function (response) { return (isAllResponse ? response : response.data); })
            .catch(function (error) {
            logger.debug(error);
            throw error;
        });
    };
    RestClient.prototype._parseUrl = function (url) {
        var parts = url.split('/');
        return {
            host: parts[2],
            path: '/' + parts.slice(3).join('/'),
        };
    };
    return RestClient;
}());

//# sourceMappingURL=RestClient.js.map

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RestAPI__ = __webpack_require__(769);
/* unused harmony reexport RestAPI */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__RestAPI__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RestClient__ = __webpack_require__(770);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__RestClient__["a"]; });
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */



/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0__RestAPI__["a" /* RestAPI */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return APIClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return API; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aws_amplify_auth__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_amplify_cache__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_amplify_api_rest__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_amplify_api_graphql__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_amplify_core__ = __webpack_require__(71);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */





var logger = new __WEBPACK_IMPORTED_MODULE_4__aws_amplify_core__["ConsoleLogger"]('API');
/**
 * @deprecated
 * Use RestApi or GraphQLAPI to reduce your application bundle size
 * Export Cloud Logic APIs
 */
var APIClass = /** @class */ (function () {
    /**
     * Initialize API with AWS configuration
     * @param {Object} options - Configuration object for API
     */
    function APIClass(options) {
        this.Auth = __WEBPACK_IMPORTED_MODULE_0__aws_amplify_auth__["Auth"];
        this.Cache = __WEBPACK_IMPORTED_MODULE_1__aws_amplify_cache__["a" /* default */];
        this.Credentials = __WEBPACK_IMPORTED_MODULE_4__aws_amplify_core__["Credentials"];
        this._options = options;
        this._restApi = new __WEBPACK_IMPORTED_MODULE_2__aws_amplify_api_rest__["b" /* RestAPIClass */](options);
        this._graphqlApi = new __WEBPACK_IMPORTED_MODULE_3__aws_amplify_api_graphql__["d" /* GraphQLAPIClass */](options);
        logger.debug('API Options', this._options);
    }
    APIClass.prototype.getModuleName = function () {
        return 'API';
    };
    /**
     * Configure API part with aws configurations
     * @param {Object} config - Configuration of the API
     * @return {Object} - The current configuration
     */
    APIClass.prototype.configure = function (options) {
        this._options = Object.assign({}, this._options, options);
        // Share Amplify instance with client for SSR
        this._restApi.Credentials = this.Credentials;
        this._graphqlApi.Auth = this.Auth;
        this._graphqlApi.Cache = this.Cache;
        this._graphqlApi.Credentials = this.Credentials;
        var restAPIConfig = this._restApi.configure(this._options);
        var graphQLAPIConfig = this._graphqlApi.configure(this._options);
        return __assign(__assign({}, restAPIConfig), graphQLAPIConfig);
    };
    /**
     * Make a GET request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    APIClass.prototype.get = function (apiName, path, init) {
        return this._restApi.get(apiName, path, init);
    };
    /**
     * Make a POST request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    APIClass.prototype.post = function (apiName, path, init) {
        return this._restApi.post(apiName, path, init);
    };
    /**
     * Make a PUT request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    APIClass.prototype.put = function (apiName, path, init) {
        return this._restApi.put(apiName, path, init);
    };
    /**
     * Make a PATCH request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    APIClass.prototype.patch = function (apiName, path, init) {
        return this._restApi.patch(apiName, path, init);
    };
    /**
     * Make a DEL request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    APIClass.prototype.del = function (apiName, path, init) {
        return this._restApi.del(apiName, path, init);
    };
    /**
     * Make a HEAD request
     * @param {string} apiName - The api name of the request
     * @param {string} path - The path of the request
     * @param {json} [init] - Request extra params
     * @return {Promise} - A promise that resolves to an object with response status and JSON data, if successful.
     */
    APIClass.prototype.head = function (apiName, path, init) {
        return this._restApi.head(apiName, path, init);
    };
    /**
     * Checks to see if an error thrown is from an api request cancellation
     * @param {any} error - Any error
     * @return {boolean} - A boolean indicating if the error was from an api request cancellation
     */
    APIClass.prototype.isCancel = function (error) {
        return this._restApi.isCancel(error);
    };
    /**
     * Cancels an inflight request
     * @param {any} request - request to cancel
     * @return {boolean} - A boolean indicating if the request was cancelled
     */
    APIClass.prototype.cancel = function (request, message) {
        return this._restApi.cancel(request, message);
    };
    /**
     * Getting endpoint for API
     * @param {string} apiName - The name of the api
     * @return {string} - The endpoint of the api
     */
    APIClass.prototype.endpoint = function (apiName) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this._restApi.endpoint(apiName)];
            });
        });
    };
    /**
     * to get the operation type
     * @param operation
     */
    APIClass.prototype.getGraphqlOperationType = function (operation) {
        return this._graphqlApi.getGraphqlOperationType(operation);
    };
    /**
     * Executes a GraphQL operation
     *
     * @param {GraphQLOptions} GraphQL Options
     * @param {object} additionalHeaders headers to merge in after any `graphql_headers` set in the config
     * @returns {Promise<GraphQLResult> | Observable<object>}
     */
    APIClass.prototype.graphql = function (options, additionalHeaders) {
        return this._graphqlApi.graphql(options, additionalHeaders);
    };
    return APIClass;
}());

var API = new APIClass(null);
__WEBPACK_IMPORTED_MODULE_4__aws_amplify_core__["Amplify"].register(API);
//# sourceMappingURL=API.js.map

/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthErrorStrings; });
var AuthErrorStrings;
(function (AuthErrorStrings) {
    AuthErrorStrings["DEFAULT_MSG"] = "Authentication Error";
    AuthErrorStrings["EMPTY_EMAIL"] = "Email cannot be empty";
    AuthErrorStrings["EMPTY_PHONE"] = "Phone number cannot be empty";
    AuthErrorStrings["EMPTY_USERNAME"] = "Username cannot be empty";
    AuthErrorStrings["INVALID_USERNAME"] = "The username should either be a string or one of the sign in types";
    AuthErrorStrings["EMPTY_PASSWORD"] = "Password cannot be empty";
    AuthErrorStrings["EMPTY_CODE"] = "Confirmation code cannot be empty";
    AuthErrorStrings["SIGN_UP_ERROR"] = "Error creating account";
    AuthErrorStrings["NO_MFA"] = "No valid MFA method provided";
    AuthErrorStrings["INVALID_MFA"] = "Invalid MFA type";
    AuthErrorStrings["EMPTY_CHALLENGE"] = "Challenge response cannot be empty";
    AuthErrorStrings["NO_USER_SESSION"] = "Failed to get the session because the user is empty";
    AuthErrorStrings["NETWORK_ERROR"] = "Network Error";
    AuthErrorStrings["DEVICE_CONFIG"] = "Device tracking has not been configured in this User Pool";
})(AuthErrorStrings || (AuthErrorStrings = {}));
//# sourceMappingURL=AuthErrorStrings.js.map

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StorageCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__ = __webpack_require__(71);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */


var logger = new __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["ConsoleLogger"]('StorageCache');
/**
 * Initialization of the cache
 *
 */
var StorageCache = /** @class */ (function () {
    /**
     * Initialize the cache
     * @param config - the configuration of the cache
     */
    function StorageCache(config) {
        this.config = Object.assign({}, config);
        this.cacheCurSizeKey = this.config.keyPrefix + 'CurSize';
        this.checkConfig();
    }
    StorageCache.prototype.getModuleName = function () {
        return 'Cache';
    };
    StorageCache.prototype.checkConfig = function () {
        // check configuration
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* isInteger */])(this.config.capacityInBytes)) {
            logger.error('Invalid parameter: capacityInBytes. It should be an Integer. Setting back to default.');
            this.config.capacityInBytes = __WEBPACK_IMPORTED_MODULE_0__Utils__["a" /* defaultConfig */].capacityInBytes;
        }
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* isInteger */])(this.config.itemMaxSize)) {
            logger.error('Invalid parameter: itemMaxSize. It should be an Integer. Setting back to default.');
            this.config.itemMaxSize = __WEBPACK_IMPORTED_MODULE_0__Utils__["a" /* defaultConfig */].itemMaxSize;
        }
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* isInteger */])(this.config.defaultTTL)) {
            logger.error('Invalid parameter: defaultTTL. It should be an Integer. Setting back to default.');
            this.config.defaultTTL = __WEBPACK_IMPORTED_MODULE_0__Utils__["a" /* defaultConfig */].defaultTTL;
        }
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Utils__["c" /* isInteger */])(this.config.defaultPriority)) {
            logger.error('Invalid parameter: defaultPriority. It should be an Integer. Setting back to default.');
            this.config.defaultPriority = __WEBPACK_IMPORTED_MODULE_0__Utils__["a" /* defaultConfig */].defaultPriority;
        }
        if (this.config.itemMaxSize > this.config.capacityInBytes) {
            logger.error('Invalid parameter: itemMaxSize. It should be smaller than capacityInBytes. Setting back to default.');
            this.config.itemMaxSize = __WEBPACK_IMPORTED_MODULE_0__Utils__["a" /* defaultConfig */].itemMaxSize;
        }
        if (this.config.defaultPriority > 5 || this.config.defaultPriority < 1) {
            logger.error('Invalid parameter: defaultPriority. It should be between 1 and 5. Setting back to default.');
            this.config.defaultPriority = __WEBPACK_IMPORTED_MODULE_0__Utils__["a" /* defaultConfig */].defaultPriority;
        }
        if (Number(this.config.warningThreshold) > 1 ||
            Number(this.config.warningThreshold) < 0) {
            logger.error('Invalid parameter: warningThreshold. It should be between 0 and 1. Setting back to default.');
            this.config.warningThreshold = __WEBPACK_IMPORTED_MODULE_0__Utils__["a" /* defaultConfig */].warningThreshold;
        }
        // set 5MB limit
        var cacheLimit = 5 * 1024 * 1024;
        if (this.config.capacityInBytes > cacheLimit) {
            logger.error('Cache Capacity should be less than 5MB. Setting back to default. Setting back to default.');
            this.config.capacityInBytes = __WEBPACK_IMPORTED_MODULE_0__Utils__["a" /* defaultConfig */].capacityInBytes;
        }
    };
    /**
     * produce a JSON object with meta-data and data value
     * @param value - the value of the item
     * @param options - optional, the specified meta-data
     *
     * @return - the item which has the meta-data and the value
     */
    StorageCache.prototype.fillCacheItem = function (key, value, options) {
        var ret = {
            key: key,
            data: value,
            timestamp: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Utils__["b" /* getCurrTime */])(),
            visitedTime: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Utils__["b" /* getCurrTime */])(),
            priority: options.priority,
            expires: options.expires,
            type: typeof value,
            byteSize: 0,
        };
        ret.byteSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Utils__["d" /* getByteLength */])(JSON.stringify(ret));
        // for accurate size
        ret.byteSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Utils__["d" /* getByteLength */])(JSON.stringify(ret));
        return ret;
    };
    /**
     * set cache with customized configuration
     * @param config - customized configuration
     *
     * @return - the current configuration
     */
    StorageCache.prototype.configure = function (config) {
        if (!config) {
            return this.config;
        }
        if (config.keyPrefix) {
            logger.warn("Don't try to configure keyPrefix!");
        }
        this.config = Object.assign({}, this.config, config, config.Cache);
        this.checkConfig();
        return this.config;
    };
    return StorageCache;
}());

/**
 * @deprecated use named import
 */
/* unused harmony default export */ var _unused_webpack_default_export = (StorageCache);
//# sourceMappingURL=StorageCache.js.map

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LOG_TYPE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsoleLogger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Util_Constants__ = __webpack_require__(511);
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};

var LOG_LEVELS = {
    VERBOSE: 1,
    DEBUG: 2,
    INFO: 3,
    WARN: 4,
    ERROR: 5,
};
var LOG_TYPE;
(function (LOG_TYPE) {
    LOG_TYPE["DEBUG"] = "DEBUG";
    LOG_TYPE["ERROR"] = "ERROR";
    LOG_TYPE["INFO"] = "INFO";
    LOG_TYPE["WARN"] = "WARN";
    LOG_TYPE["VERBOSE"] = "VERBOSE";
})(LOG_TYPE || (LOG_TYPE = {}));
/**
 * Write logs
 * @class Logger
 */
var ConsoleLogger = /** @class */ (function () {
    /**
     * @constructor
     * @param {string} name - Name of the logger
     */
    function ConsoleLogger(name, level) {
        if (level === void 0) { level = LOG_TYPE.WARN; }
        this.name = name;
        this.level = level;
        this._pluggables = [];
    }
    ConsoleLogger.prototype._padding = function (n) {
        return n < 10 ? '0' + n : '' + n;
    };
    ConsoleLogger.prototype._ts = function () {
        var dt = new Date();
        return ([this._padding(dt.getMinutes()), this._padding(dt.getSeconds())].join(':') +
            '.' +
            dt.getMilliseconds());
    };
    ConsoleLogger.prototype.configure = function (config) {
        if (!config)
            return this._config;
        this._config = config;
        return this._config;
    };
    /**
     * Write log
     * @method
     * @memeberof Logger
     * @param {LOG_TYPE|string} type - log type, default INFO
     * @param {string|object} msg - Logging message or object
     */
    ConsoleLogger.prototype._log = function (type) {
        var e_1, _a;
        var msg = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            msg[_i - 1] = arguments[_i];
        }
        var logger_level_name = this.level;
        if (ConsoleLogger.LOG_LEVEL) {
            logger_level_name = ConsoleLogger.LOG_LEVEL;
        }
        if (typeof window !== 'undefined' && window.LOG_LEVEL) {
            logger_level_name = window.LOG_LEVEL;
        }
        var logger_level = LOG_LEVELS[logger_level_name];
        var type_level = LOG_LEVELS[type];
        if (!(type_level >= logger_level)) {
            // Do nothing if type is not greater than or equal to logger level (handle undefined)
            return;
        }
        var log = console.log.bind(console);
        if (type === LOG_TYPE.ERROR && console.error) {
            log = console.error.bind(console);
        }
        if (type === LOG_TYPE.WARN && console.warn) {
            log = console.warn.bind(console);
        }
        var prefix = "[" + type + "] " + this._ts() + " " + this.name;
        var message = '';
        if (msg.length === 1 && typeof msg[0] === 'string') {
            message = prefix + " - " + msg[0];
            log(message);
        }
        else if (msg.length === 1) {
            message = prefix + " " + msg[0];
            log(prefix, msg[0]);
        }
        else if (typeof msg[0] === 'string') {
            var obj = msg.slice(1);
            if (obj.length === 1) {
                obj = obj[0];
            }
            message = prefix + " - " + msg[0] + " " + obj;
            log(prefix + " - " + msg[0], obj);
        }
        else {
            message = prefix + " " + msg;
            log(prefix, msg);
        }
        try {
            for (var _b = __values(this._pluggables), _c = _b.next(); !_c.done; _c = _b.next()) {
                var plugin = _c.value;
                var logEvent = { message: message, timestamp: Date.now() };
                plugin.pushLogs([logEvent]);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /**
     * Write General log. Default to INFO
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */
    ConsoleLogger.prototype.log = function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        this._log.apply(this, __spread([LOG_TYPE.INFO], msg));
    };
    /**
     * Write INFO log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */
    ConsoleLogger.prototype.info = function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        this._log.apply(this, __spread([LOG_TYPE.INFO], msg));
    };
    /**
     * Write WARN log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */
    ConsoleLogger.prototype.warn = function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        this._log.apply(this, __spread([LOG_TYPE.WARN], msg));
    };
    /**
     * Write ERROR log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */
    ConsoleLogger.prototype.error = function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        this._log.apply(this, __spread([LOG_TYPE.ERROR], msg));
    };
    /**
     * Write DEBUG log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */
    ConsoleLogger.prototype.debug = function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        this._log.apply(this, __spread([LOG_TYPE.DEBUG], msg));
    };
    /**
     * Write VERBOSE log
     * @method
     * @memeberof Logger
     * @param {string|object} msg - Logging message or object
     */
    ConsoleLogger.prototype.verbose = function () {
        var msg = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            msg[_i] = arguments[_i];
        }
        this._log.apply(this, __spread([LOG_TYPE.VERBOSE], msg));
    };
    ConsoleLogger.prototype.addPluggable = function (pluggable) {
        if (pluggable && pluggable.getCategoryName() === __WEBPACK_IMPORTED_MODULE_0__Util_Constants__["b" /* AWS_CLOUDWATCH_CATEGORY */]) {
            this._pluggables.push(pluggable);
            pluggable.configure(this._config);
        }
    };
    ConsoleLogger.prototype.listPluggables = function () {
        return this._pluggables;
    };
    ConsoleLogger.LOG_LEVEL = null;
    return ConsoleLogger;
}());

//# sourceMappingURL=ConsoleLogger.js.map

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GoogleOAuth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FacebookOAuth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GoogleOAuth__ = __webpack_require__(1625);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FacebookOAuth__ = __webpack_require__(1624);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */


var GoogleOAuth = new __WEBPACK_IMPORTED_MODULE_0__GoogleOAuth__["a" /* GoogleOAuth */]();
var FacebookOAuth = new __WEBPACK_IMPORTED_MODULE_1__FacebookOAuth__["a" /* FacebookOAuth */]();
//# sourceMappingURL=index.js.map

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseMobileHubConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Parser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(111);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('Parser');
var parseMobileHubConfig = function (config) {
    var amplifyConfig = {};
    // Analytics
    if (config['aws_mobile_analytics_app_id']) {
        var Analytics = {
            AWSPinpoint: {
                appId: config['aws_mobile_analytics_app_id'],
                region: config['aws_mobile_analytics_app_region'],
            },
        };
        amplifyConfig.Analytics = Analytics;
    }
    // Auth
    if (config['aws_cognito_identity_pool_id'] || config['aws_user_pools_id']) {
        amplifyConfig.Auth = {
            userPoolId: config['aws_user_pools_id'],
            userPoolWebClientId: config['aws_user_pools_web_client_id'],
            region: config['aws_cognito_region'],
            identityPoolId: config['aws_cognito_identity_pool_id'],
            identityPoolRegion: config['aws_cognito_region'],
            mandatorySignIn: config['aws_mandatory_sign_in'] === 'enable',
        };
    }
    // Storage
    var storageConfig;
    if (config['aws_user_files_s3_bucket']) {
        storageConfig = {
            AWSS3: {
                bucket: config['aws_user_files_s3_bucket'],
                region: config['aws_user_files_s3_bucket_region'],
                dangerouslyConnectToHttpEndpointForTesting: config['aws_user_files_s3_dangerously_connect_to_http_endpoint_for_testing'],
            },
        };
    }
    else {
        storageConfig = config ? config.Storage || config : {};
    }
    // Logging
    if (config['Logging']) {
        amplifyConfig.Logging = __assign(__assign({}, config['Logging']), { region: config['aws_project_region'] });
    }
    amplifyConfig.Analytics = Object.assign({}, amplifyConfig.Analytics, config.Analytics);
    amplifyConfig.Auth = Object.assign({}, amplifyConfig.Auth, config.Auth);
    amplifyConfig.Storage = Object.assign({}, storageConfig);
    amplifyConfig.Logging = Object.assign({}, amplifyConfig.Logging, config.Logging);
    logger.debug('parse config', config, 'to amplifyconfig', amplifyConfig);
    return amplifyConfig;
};
/**
 * @deprecated use per-function export
 */
var Parser = /** @class */ (function () {
    function Parser() {
    }
    Parser.parseMobilehubConfig = parseMobileHubConfig;
    return Parser;
}());

/**
 * @deprecated use per-function export
 */
/* unused harmony default export */ var _unused_webpack_default_export = (Parser);
//# sourceMappingURL=Parser.js.map

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USER_AGENT_HEADER; });
/*
 * Copyright 2018-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
/**
 * This Symbol is used to reference an internal-only PubSub provider that
 * is used for AppSync/GraphQL subscriptions in the API category.
 */
var hasSymbol = typeof Symbol !== 'undefined' && typeof Symbol.for === 'function';
var INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER = hasSymbol
    ? Symbol.for('INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER')
    : '@@INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER';
var INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER = hasSymbol
    ? Symbol.for('INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER')
    : '@@INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER';
var USER_AGENT_HEADER = 'x-amz-user-agent';
//# sourceMappingURL=constants.js.map

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PubSubProvider__ = __webpack_require__(513);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AWSAppSyncProvider__ = __webpack_require__(1639);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__AWSAppSyncProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AWSAppSyncRealTimeProvider__ = __webpack_require__(1640);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__AWSAppSyncRealTimeProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AWSIotProvider__ = __webpack_require__(1641);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__MqttOverWSProvider__ = __webpack_require__(512);
/* unused harmony namespace reexport */
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */





//# sourceMappingURL=index.js.map

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONTROL_MSG; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PubSub__ = __webpack_require__(1642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Providers__ = __webpack_require__(779);
/* unused harmony namespace reexport */
/* unused harmony reexport PubSub */
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */


var CONTROL_MSG;
(function (CONTROL_MSG) {
    CONTROL_MSG["CONNECTION_CLOSED"] = "Connection closed";
    CONTROL_MSG["CONNECTION_FAILED"] = "Connection failed";
    CONTROL_MSG["REALTIME_SUBSCRIPTION_INIT_ERROR"] = "AppSync Realtime subscription init error";
    CONTROL_MSG["SUBSCRIPTION_ACK"] = "Subscription ack";
    CONTROL_MSG["TIMEOUT_DISCONNECT"] = "Timeout disconnect";
})(CONTROL_MSG || (CONTROL_MSG = {}));

/**
 * @deprecated use named import
 */
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__PubSub__["a" /* PubSub */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(1643);
var v4 = __webpack_require__(1644);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 782 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 783 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
exports.SHA_256_HASH = { name: "SHA-256" };
exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: exports.SHA_256_HASH
};
exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NvbnN0YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLFlBQVksR0FBd0IsRUFBRSxJQUFJLEVBQUUsU0FBUyxFQUFFLENBQUM7QUFFeEQsUUFBQSxpQkFBaUIsR0FBZ0Q7SUFDNUUsSUFBSSxFQUFFLE1BQU07SUFDWixJQUFJLEVBQUUsb0JBQVk7Q0FDbkIsQ0FBQztBQUVXLFFBQUEsa0JBQWtCLEdBQUcsSUFBSSxVQUFVLENBQUM7SUFDL0MsR0FBRztJQUNILEdBQUc7SUFDSCxHQUFHO0lBQ0gsRUFBRTtJQUNGLEdBQUc7SUFDSCxHQUFHO0lBQ0gsRUFBRTtJQUNGLEVBQUU7SUFDRixHQUFHO0lBQ0gsR0FBRztJQUNILEdBQUc7SUFDSCxHQUFHO0lBQ0gsR0FBRztJQUNILEdBQUc7SUFDSCxHQUFHO0lBQ0gsRUFBRTtJQUNGLEVBQUU7SUFDRixHQUFHO0lBQ0gsRUFBRTtJQUNGLEdBQUc7SUFDSCxHQUFHO0lBQ0gsR0FBRztJQUNILEdBQUc7SUFDSCxFQUFFO0lBQ0YsR0FBRztJQUNILEdBQUc7SUFDSCxHQUFHO0lBQ0gsRUFBRTtJQUNGLEdBQUc7SUFDSCxFQUFFO0lBQ0YsR0FBRztJQUNILEVBQUU7Q0FDSCxDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgU0hBXzI1Nl9IQVNIOiB7IG5hbWU6IFwiU0hBLTI1NlwiIH0gPSB7IG5hbWU6IFwiU0hBLTI1NlwiIH07XG5cbmV4cG9ydCBjb25zdCBTSEFfMjU2X0hNQUNfQUxHTzogeyBuYW1lOiBcIkhNQUNcIjsgaGFzaDogeyBuYW1lOiBcIlNIQS0yNTZcIiB9IH0gPSB7XG4gIG5hbWU6IFwiSE1BQ1wiLFxuICBoYXNoOiBTSEFfMjU2X0hBU0hcbn07XG5cbmV4cG9ydCBjb25zdCBFTVBUWV9EQVRBX1NIQV8yNTYgPSBuZXcgVWludDhBcnJheShbXG4gIDIyNyxcbiAgMTc2LFxuICAxOTYsXG4gIDY2LFxuICAxNTIsXG4gIDI1MixcbiAgMjgsXG4gIDIwLFxuICAxNTQsXG4gIDI1MSxcbiAgMjQ0LFxuICAyMDAsXG4gIDE1MyxcbiAgMTExLFxuICAxODUsXG4gIDM2LFxuICAzOSxcbiAgMTc0LFxuICA2NSxcbiAgMjI4LFxuICAxMDAsXG4gIDE1NSxcbiAgMTQ3LFxuICA3NixcbiAgMTY0LFxuICAxNDksXG4gIDE1MyxcbiAgMjcsXG4gIDEyMCxcbiAgODIsXG4gIDE4NCxcbiAgODVcbl0pO1xuIl19

/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Sha256 = void 0;
var isEmptyData_1 = __webpack_require__(787);
var constants_1 = __webpack_require__(784);
var util_utf8_browser_1 = __webpack_require__(514);
var util_locate_window_1 = __webpack_require__(526);
var Sha256 = /** @class */ (function () {
    function Sha256(secret) {
        if (secret) {
            this.operation = getKeyPromise(secret).then(function (keyData) {
                return util_locate_window_1.locateWindow().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function () { });
        }
        else {
            this.operation = Promise.resolve(util_locate_window_1.locateWindow().msCrypto.subtle.digest("SHA-256"));
        }
    }
    Sha256.prototype.update = function (toHash) {
        var _this = this;
        if (isEmptyData_1.isEmptyData(toHash)) {
            return;
        }
        this.operation = this.operation.then(function (operation) {
            operation.onerror = function () {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function () { });
    };
    Sha256.prototype.digest = function () {
        return this.operation.then(function (operation) {
            return new Promise(function (resolve, reject) {
                operation.onerror = function () {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function () {
                    if (operation.result) {
                        resolve(new Uint8Array(operation.result));
                    }
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}());
exports.Sha256 = Sha256;
function getKeyPromise(secret) {
    return new Promise(function (resolve, reject) {
        var keyOperation = util_locate_window_1.locateWindow().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"]);
        keyOperation.oncomplete = function () {
            if (keyOperation.result) {
                resolve(keyOperation.result);
            }
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function () {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function toArrayBufferView(data) {
    if (typeof data === "string") {
        return util_utf8_browser_1.fromUtf8(data);
    }
    if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    }
    return new Uint8Array(data);
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
var tslib_1 = __webpack_require__(31);
tslib_1.__exportStar(__webpack_require__(1651), exports);
var ie11Sha256_1 = __webpack_require__(785);
Object.defineProperty(exports, "Ie11Sha256", { enumerable: true, get: function () { return ie11Sha256_1.Sha256; } });
var webCryptoSha256_1 = __webpack_require__(788);
Object.defineProperty(exports, "WebCryptoSha256", { enumerable: true, get: function () { return webCryptoSha256_1.Sha256; } });
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUFBLGdFQUFzQztBQUN0QywyQ0FBb0Q7QUFBM0Msd0dBQUEsTUFBTSxPQUFjO0FBQzdCLHFEQUE4RDtBQUFyRCxrSEFBQSxNQUFNLE9BQW1CIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0ICogZnJvbSBcIi4vY3Jvc3NQbGF0Zm9ybVNoYTI1NlwiO1xuZXhwb3J0IHsgU2hhMjU2IGFzIEllMTFTaGEyNTYgfSBmcm9tIFwiLi9pZTExU2hhMjU2XCI7XG5leHBvcnQgeyBTaGEyNTYgYXMgV2ViQ3J5cHRvU2hhMjU2IH0gZnJvbSBcIi4vd2ViQ3J5cHRvU2hhMjU2XCI7XG4iXX0=

/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") {
        return data.length === 0;
    }
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXNFbXB0eURhdGEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaXNFbXB0eURhdGEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsU0FBZ0IsV0FBVyxDQUFDLElBQWdCO0lBQzFDLElBQUksT0FBTyxJQUFJLEtBQUssUUFBUSxFQUFFO1FBQzVCLE9BQU8sSUFBSSxDQUFDLE1BQU0sS0FBSyxDQUFDLENBQUM7S0FDMUI7SUFFRCxPQUFPLElBQUksQ0FBQyxVQUFVLEtBQUssQ0FBQyxDQUFDO0FBQy9CLENBQUM7QUFORCxrQ0FNQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFNvdXJjZURhdGEgfSBmcm9tIFwiQGF3cy1zZGsvdHlwZXNcIjtcblxuZXhwb3J0IGZ1bmN0aW9uIGlzRW1wdHlEYXRhKGRhdGE6IFNvdXJjZURhdGEpOiBib29sZWFuIHtcbiAgaWYgKHR5cGVvZiBkYXRhID09PSBcInN0cmluZ1wiKSB7XG4gICAgcmV0dXJuIGRhdGEubGVuZ3RoID09PSAwO1xuICB9XG5cbiAgcmV0dXJuIGRhdGEuYnl0ZUxlbmd0aCA9PT0gMDtcbn1cbiJdfQ==

/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Sha256 = void 0;
var util_utf8_browser_1 = __webpack_require__(514);
var isEmptyData_1 = __webpack_require__(787);
var constants_1 = __webpack_require__(784);
var util_locate_window_1 = __webpack_require__(526);
var Sha256 = /** @class */ (function () {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function (resolve, reject) {
                util_locate_window_1.locateWindow()
                    .crypto.subtle.importKey("raw", convertToBuffer(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"])
                    .then(resolve, reject);
            });
            this.key.catch(function () { });
        }
    }
    Sha256.prototype.update = function (data) {
        if (isEmptyData_1.isEmptyData(data)) {
            return;
        }
        var update = convertToBuffer(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function () {
        var _this = this;
        if (this.key) {
            return this.key.then(function (key) {
                return util_locate_window_1.locateWindow()
                    .crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash)
                    .then(function (data) { return new Uint8Array(data); });
            });
        }
        if (isEmptyData_1.isEmptyData(this.toHash)) {
            return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
        }
        return Promise.resolve()
            .then(function () {
            return util_locate_window_1.locateWindow().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
        })
            .then(function (data) { return Promise.resolve(new Uint8Array(data)); });
    };
    return Sha256;
}());
exports.Sha256 = Sha256;
function convertToBuffer(data) {
    if (typeof data === "string") {
        return util_utf8_browser_1.fromUtf8(data);
    }
    if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    }
    return new Uint8Array(data);
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */
exports.BLOCK_SIZE = 64;
/**
 * @internal
 */
exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */
exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */
exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */
exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
//# sourceMappingURL=constants.js.map

/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @internal
 */
exports.BLOCK_SIZE = 64;
/**
 * @internal
 */
exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */
exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */
exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */
exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
//# sourceMappingURL=constants.js.map

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AssociateKmsKeyCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Associates the specified AWS Key Management Service (AWS KMS) customer master key (CMK) with the specified log group.</p>
 *          <p>Associating an AWS KMS CMK with a log group overrides any existing associations between the log group and a CMK.
 *       After a CMK is associated with a log group, all newly ingested data for the log group is encrypted using the CMK.
 *       This association is stored as long as the data encrypted with the CMK is still within Amazon CloudWatch Logs.
 *       This enables Amazon CloudWatch Logs to decrypt this data whenever it is requested.</p>
 *          <important>
 *             <p>CloudWatch Logs supports only symmetric CMKs. Do not use an associate an asymmetric CMK
 *         with your log group. For more information, see <a href="https://docs.aws.amazon.com/kms/latest/developerguide/symmetric-asymmetric.html">Using Symmetric and Asymmetric
 *           Keys</a>.</p>
 *          </important>
 *          <p>It can take up to 5 minutes for this operation to take effect.</p>
 *          <p>If you attempt to associate a CMK with a log group but the CMK does not exist or the
 *       CMK is disabled, you receive an <code>InvalidParameterException</code> error. </p>
 */
var AssociateKmsKeyCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(AssociateKmsKeyCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function AssociateKmsKeyCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    AssociateKmsKeyCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "AssociateKmsKeyCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["_5" /* AssociateKmsKeyRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    AssociateKmsKeyCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_20" /* serializeAws_json1_1AssociateKmsKeyCommand */])(input, context);
    };
    AssociateKmsKeyCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_21" /* deserializeAws_json1_1AssociateKmsKeyCommand */])(output, context);
    };
    return AssociateKmsKeyCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=AssociateKmsKeyCommand.js.map

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CancelExportTaskCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Cancels the specified export task.</p>
 *          <p>The task must be in the <code>PENDING</code> or <code>RUNNING</code> state.</p>
 */
var CancelExportTaskCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CancelExportTaskCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CancelExportTaskCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    CancelExportTaskCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "CancelExportTaskCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["_4" /* CancelExportTaskRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CancelExportTaskCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_18" /* serializeAws_json1_1CancelExportTaskCommand */])(input, context);
    };
    CancelExportTaskCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_19" /* deserializeAws_json1_1CancelExportTaskCommand */])(output, context);
    };
    return CancelExportTaskCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=CancelExportTaskCommand.js.map

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateExportTaskCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Creates an export task, which allows you to efficiently export data from a
 *       log group to an Amazon S3 bucket. When you perform a <code>CreateExportTask</code>
 *       operation, you must use credentials that have permission to write to the S3 bucket
 *       that you specify as the destination.</p>
 *          <p>This is an asynchronous call. If all the required information is provided, this
 *       operation initiates an export task and responds with the ID of the task. After the task has started,
 *       you can use <a href="https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_DescribeExportTasks.html">DescribeExportTasks</a> to get the status of the export task. Each account can
 *       only have one active (<code>RUNNING</code> or <code>PENDING</code>) export task at a time.
 *       To cancel an export task, use <a href="https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_CancelExportTask.html">CancelExportTask</a>.</p>
 *          <p>You can export logs from multiple log groups or multiple time ranges to the same S3
 *       bucket. To separate out log data for each export task, you can specify a prefix to be used as
 *       the Amazon S3 key prefix for all exported objects.</p>
 *          <p>Exporting to S3 buckets that are encrypted with AES-256 is supported. Exporting to S3 buckets
 *       encrypted with SSE-KMS is not supported. </p>
 */
var CreateExportTaskCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CreateExportTaskCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateExportTaskCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    CreateExportTaskCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "CreateExportTaskCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["_2" /* CreateExportTaskRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["_3" /* CreateExportTaskResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateExportTaskCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_16" /* serializeAws_json1_1CreateExportTaskCommand */])(input, context);
    };
    CreateExportTaskCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_17" /* deserializeAws_json1_1CreateExportTaskCommand */])(output, context);
    };
    return CreateExportTaskCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=CreateExportTaskCommand.js.map

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateLogGroupCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Creates a log group with the specified name. You can create up to 20,000 log groups per account.</p>
 *          <p>You must use the following guidelines when naming a log group:</p>
 *          <ul>
 *             <li>
 *                <p>Log group names must be unique within a region for an AWS account.</p>
 *             </li>
 *             <li>
 *                <p>Log group names can be between 1 and 512 characters long.</p>
 *             </li>
 *             <li>
 *                <p>Log group names consist of the following characters: a-z, A-Z, 0-9, '_' (underscore), '-' (hyphen),
 *           '/' (forward slash), '.' (period), and '#' (number sign)</p>
 *             </li>
 *          </ul>
 *          <p>When you create a log group, by default the log events in the log group never expire. To set
 *     a retention policy so that events expire and are deleted after a specified time, use
 *       <a href="https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_PutRetentionPolicy.html">PutRetentionPolicy</a>.</p>
 *          <p>If you associate a AWS Key Management Service (AWS KMS) customer master key (CMK) with the log group, ingested data is encrypted using the CMK.
 *       This association is stored as long as the data encrypted with the CMK is still within Amazon CloudWatch Logs.
 *       This enables Amazon CloudWatch Logs to decrypt this data whenever it is requested.</p>
 *          <p>If you attempt to associate a CMK with the log group but the CMK does not exist or the
 *       CMK is disabled, you receive an <code>InvalidParameterException</code> error. </p>
 *          <important>
 *             <p> CloudWatch Logs supports only symmetric CMKs. Do not associate an asymmetric CMK with
 *         your log group. For more information, see <a href="https://docs.aws.amazon.com/kms/latest/developerguide/symmetric-asymmetric.html">Using Symmetric and Asymmetric
 *           Keys</a>.</p>
 *          </important>
 */
var CreateLogGroupCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CreateLogGroupCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateLogGroupCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    CreateLogGroupCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "CreateLogGroupCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["_13" /* CreateLogGroupRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateLogGroupCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_30" /* serializeAws_json1_1CreateLogGroupCommand */])(input, context);
    };
    CreateLogGroupCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_31" /* deserializeAws_json1_1CreateLogGroupCommand */])(output, context);
    };
    return CreateLogGroupCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=CreateLogGroupCommand.js.map

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateLogStreamCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Creates a log stream for the specified log group. A log stream is a sequence of log events
 *       that originate from a single source, such as an application instance or a resource that is
 *       being monitored.</p>
 *          <p>There is no limit on the number of log streams that you can create for a log group. There is a limit
 *     of 50 TPS on <code>CreateLogStream</code> operations, after which transactions are throttled.</p>
 *          <p>You must use the following guidelines when naming a log stream:</p>
 *          <ul>
 *             <li>
 *                <p>Log stream names must be unique within the log group.</p>
 *             </li>
 *             <li>
 *                <p>Log stream names can be between 1 and 512 characters long.</p>
 *             </li>
 *             <li>
 *                <p>The ':' (colon) and '*' (asterisk) characters are not allowed.</p>
 *             </li>
 *          </ul>
 */
var CreateLogStreamCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CreateLogStreamCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateLogStreamCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    CreateLogStreamCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "CreateLogStreamCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["_12" /* CreateLogStreamRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateLogStreamCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_28" /* serializeAws_json1_1CreateLogStreamCommand */])(input, context);
    };
    CreateLogStreamCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_29" /* deserializeAws_json1_1CreateLogStreamCommand */])(output, context);
    };
    return CreateLogStreamCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=CreateLogStreamCommand.js.map

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteDestinationCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Deletes the specified destination, and eventually disables all the
 *       subscription filters that publish to it. This operation does not delete the
 *       physical resource encapsulated by the destination.</p>
 */
var DeleteDestinationCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DeleteDestinationCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteDestinationCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DeleteDestinationCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DeleteDestinationCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["_1" /* DeleteDestinationRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteDestinationCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_14" /* serializeAws_json1_1DeleteDestinationCommand */])(input, context);
    };
    DeleteDestinationCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_15" /* deserializeAws_json1_1DeleteDestinationCommand */])(output, context);
    };
    return DeleteDestinationCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DeleteDestinationCommand.js.map

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteLogGroupCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Deletes the specified log group and permanently deletes all the archived
 *       log events associated with the log group.</p>
 */
var DeleteLogGroupCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DeleteLogGroupCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteLogGroupCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DeleteLogGroupCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DeleteLogGroupCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["_0" /* DeleteLogGroupRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteLogGroupCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_12" /* serializeAws_json1_1DeleteLogGroupCommand */])(input, context);
    };
    DeleteLogGroupCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_13" /* deserializeAws_json1_1DeleteLogGroupCommand */])(output, context);
    };
    return DeleteLogGroupCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DeleteLogGroupCommand.js.map

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteLogStreamCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Deletes the specified log stream and permanently deletes all the archived log events associated
 *       with the log stream.</p>
 */
var DeleteLogStreamCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DeleteLogStreamCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteLogStreamCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DeleteLogStreamCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DeleteLogStreamCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["Z" /* DeleteLogStreamRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteLogStreamCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_10" /* serializeAws_json1_1DeleteLogStreamCommand */])(input, context);
    };
    DeleteLogStreamCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_11" /* deserializeAws_json1_1DeleteLogStreamCommand */])(output, context);
    };
    return DeleteLogStreamCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DeleteLogStreamCommand.js.map

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteMetricFilterCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Deletes the specified metric filter.</p>
 */
var DeleteMetricFilterCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DeleteMetricFilterCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteMetricFilterCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DeleteMetricFilterCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DeleteMetricFilterCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["Y" /* DeleteMetricFilterRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteMetricFilterCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_8" /* serializeAws_json1_1DeleteMetricFilterCommand */])(input, context);
    };
    DeleteMetricFilterCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_9" /* deserializeAws_json1_1DeleteMetricFilterCommand */])(output, context);
    };
    return DeleteMetricFilterCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DeleteMetricFilterCommand.js.map

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteQueryDefinitionCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Deletes a saved CloudWatch Logs Insights query definition.
 *       A query definition contains details about a saved CloudWatch Logs Insights query.</p>
 *          <p>Each <code>DeleteQueryDefinition</code> operation can delete one query definition.</p>
 *          <p>You must have the <code>logs:DeleteQueryDefinition</code> permission to be able to perform
 *       this operation.</p>
 */
var DeleteQueryDefinitionCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DeleteQueryDefinitionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteQueryDefinitionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DeleteQueryDefinitionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DeleteQueryDefinitionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["W" /* DeleteQueryDefinitionRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["X" /* DeleteQueryDefinitionResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteQueryDefinitionCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_6" /* serializeAws_json1_1DeleteQueryDefinitionCommand */])(input, context);
    };
    DeleteQueryDefinitionCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_7" /* deserializeAws_json1_1DeleteQueryDefinitionCommand */])(output, context);
    };
    return DeleteQueryDefinitionCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DeleteQueryDefinitionCommand.js.map

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteResourcePolicyCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Deletes a resource policy from this account. This revokes
 *     the access of the identities in that policy to put log events to this account.</p>
 */
var DeleteResourcePolicyCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DeleteResourcePolicyCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteResourcePolicyCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DeleteResourcePolicyCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DeleteResourcePolicyCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["V" /* DeleteResourcePolicyRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteResourcePolicyCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_4" /* serializeAws_json1_1DeleteResourcePolicyCommand */])(input, context);
    };
    DeleteResourcePolicyCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_5" /* deserializeAws_json1_1DeleteResourcePolicyCommand */])(output, context);
    };
    return DeleteResourcePolicyCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DeleteResourcePolicyCommand.js.map

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteRetentionPolicyCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Deletes the specified retention policy.</p>
 *          <p>Log events do not expire if they belong to log groups without a retention policy.</p>
 */
var DeleteRetentionPolicyCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DeleteRetentionPolicyCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteRetentionPolicyCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DeleteRetentionPolicyCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DeleteRetentionPolicyCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["U" /* DeleteRetentionPolicyRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteRetentionPolicyCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_2" /* serializeAws_json1_1DeleteRetentionPolicyCommand */])(input, context);
    };
    DeleteRetentionPolicyCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_3" /* deserializeAws_json1_1DeleteRetentionPolicyCommand */])(output, context);
    };
    return DeleteRetentionPolicyCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DeleteRetentionPolicyCommand.js.map

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteSubscriptionFilterCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Deletes the specified subscription filter.</p>
 */
var DeleteSubscriptionFilterCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DeleteSubscriptionFilterCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteSubscriptionFilterCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DeleteSubscriptionFilterCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DeleteSubscriptionFilterCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["T" /* DeleteSubscriptionFilterRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteSubscriptionFilterCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_0" /* serializeAws_json1_1DeleteSubscriptionFilterCommand */])(input, context);
    };
    DeleteSubscriptionFilterCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["_1" /* deserializeAws_json1_1DeleteSubscriptionFilterCommand */])(output, context);
    };
    return DeleteSubscriptionFilterCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DeleteSubscriptionFilterCommand.js.map

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DescribeExportTasksCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Lists the specified export tasks. You can list all your export tasks or filter
 *       the results based on task ID or task status.</p>
 */
var DescribeExportTasksCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DescribeExportTasksCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeExportTasksCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DescribeExportTasksCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DescribeExportTasksCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["P" /* DescribeExportTasksRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["Q" /* DescribeExportTasksResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeExportTasksCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["W" /* serializeAws_json1_1DescribeExportTasksCommand */])(input, context);
    };
    DescribeExportTasksCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["X" /* deserializeAws_json1_1DescribeExportTasksCommand */])(output, context);
    };
    return DescribeExportTasksCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DescribeExportTasksCommand.js.map

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DescribeQueriesCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Returns a list of CloudWatch Logs Insights queries that are scheduled, executing, or have
 *       been executed recently in this account. You can request all queries or limit it to queries of
 *       a specific log group or queries with a certain status.</p>
 */
var DescribeQueriesCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DescribeQueriesCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeQueriesCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DescribeQueriesCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DescribeQueriesCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["L" /* DescribeQueriesRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["M" /* DescribeQueriesResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeQueriesCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["S" /* serializeAws_json1_1DescribeQueriesCommand */])(input, context);
    };
    DescribeQueriesCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["T" /* deserializeAws_json1_1DescribeQueriesCommand */])(output, context);
    };
    return DescribeQueriesCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DescribeQueriesCommand.js.map

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DescribeQueryDefinitionsCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>This operation returns a paginated list of your saved CloudWatch Logs Insights query definitions.</p>
 *          <p>You can use the <code>queryDefinitionNamePrefix</code> parameter to limit the results to only the
 *       query definitions that have names that start with a certain string.</p>
 */
var DescribeQueryDefinitionsCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DescribeQueryDefinitionsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeQueryDefinitionsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DescribeQueryDefinitionsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DescribeQueryDefinitionsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["J" /* DescribeQueryDefinitionsRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["K" /* DescribeQueryDefinitionsResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeQueryDefinitionsCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["Q" /* serializeAws_json1_1DescribeQueryDefinitionsCommand */])(input, context);
    };
    DescribeQueryDefinitionsCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["R" /* deserializeAws_json1_1DescribeQueryDefinitionsCommand */])(output, context);
    };
    return DescribeQueryDefinitionsCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DescribeQueryDefinitionsCommand.js.map

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DescribeResourcePoliciesCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Lists the resource policies in this account.</p>
 */
var DescribeResourcePoliciesCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DescribeResourcePoliciesCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeResourcePoliciesCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DescribeResourcePoliciesCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DescribeResourcePoliciesCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["H" /* DescribeResourcePoliciesRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["I" /* DescribeResourcePoliciesResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeResourcePoliciesCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["O" /* serializeAws_json1_1DescribeResourcePoliciesCommand */])(input, context);
    };
    DescribeResourcePoliciesCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["P" /* deserializeAws_json1_1DescribeResourcePoliciesCommand */])(output, context);
    };
    return DescribeResourcePoliciesCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DescribeResourcePoliciesCommand.js.map

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DisassociateKmsKeyCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Disassociates the associated AWS Key Management Service (AWS KMS) customer master key (CMK) from the specified log group.</p>
 *          <p>After the AWS KMS CMK is disassociated from the log group, AWS CloudWatch Logs stops encrypting newly ingested data for the log group.
 *       All previously ingested data remains encrypted, and AWS CloudWatch Logs requires permissions for the CMK whenever the encrypted data is requested.</p>
 *          <p>Note that it can take up to 5 minutes for this operation to take effect.</p>
 */
var DisassociateKmsKeyCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DisassociateKmsKeyCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DisassociateKmsKeyCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DisassociateKmsKeyCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "DisassociateKmsKeyCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["E" /* DisassociateKmsKeyRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DisassociateKmsKeyCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["K" /* serializeAws_json1_1DisassociateKmsKeyCommand */])(input, context);
    };
    DisassociateKmsKeyCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["L" /* deserializeAws_json1_1DisassociateKmsKeyCommand */])(output, context);
    };
    return DisassociateKmsKeyCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DisassociateKmsKeyCommand.js.map

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetLogGroupFieldsCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Returns a list of the fields that are included in log events in the specified log group, along with the percentage of log events
 *     that contain each field. The search is limited to a time period that you specify.</p>
 *          <p>In the results, fields that start with @ are fields generated by CloudWatch Logs. For
 *       example, <code>@timestamp</code> is the timestamp of each log event. For more information about the fields that are
 *       generated by CloudWatch logs, see
 *       <a href="https://docs.aws.amazon.com/AmazonCloudWatch/latest/logs/CWL_AnalyzeLogData-discoverable-fields.html">Supported Logs and Discovered Fields</a>.</p>
 *          <p>The response results are sorted by the frequency percentage, starting
 *     with the highest percentage.</p>
 */
var GetLogGroupFieldsCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(GetLogGroupFieldsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetLogGroupFieldsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    GetLogGroupFieldsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "GetLogGroupFieldsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["A" /* GetLogGroupFieldsRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["B" /* GetLogGroupFieldsResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetLogGroupFieldsCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["G" /* serializeAws_json1_1GetLogGroupFieldsCommand */])(input, context);
    };
    GetLogGroupFieldsCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["H" /* deserializeAws_json1_1GetLogGroupFieldsCommand */])(output, context);
    };
    return GetLogGroupFieldsCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=GetLogGroupFieldsCommand.js.map

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetLogRecordCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Retrieves all of the fields and values of a single log event. All fields are retrieved,
 *       even if the original query that produced the <code>logRecordPointer</code> retrieved only a
 *       subset of fields. Fields are returned as field name/field value pairs.</p>
 *          <p>The full unparsed log event is returned within <code>@message</code>.</p>
 */
var GetLogRecordCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(GetLogRecordCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetLogRecordCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    GetLogRecordCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "GetLogRecordCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["y" /* GetLogRecordRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["z" /* GetLogRecordResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetLogRecordCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["E" /* serializeAws_json1_1GetLogRecordCommand */])(input, context);
    };
    GetLogRecordCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["F" /* deserializeAws_json1_1GetLogRecordCommand */])(output, context);
    };
    return GetLogRecordCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=GetLogRecordCommand.js.map

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetQueryResultsCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Returns the results from the specified query.</p>
 *          <p>Only the fields requested in the query are returned, along with a <code>@ptr</code>
 *       field, which is the identifier for the log record. You can use the value of <code>@ptr</code>
 *       in a <a href="https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_GetLogRecord.html">GetLogRecord</a>
 *       operation to get the full log record.</p>
 *          <p>
 *             <code>GetQueryResults</code>
 *       does not start a query execution. To run a query, use <a href="https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_StartQuery.html">StartQuery</a>.</p>
 *          <p>If the value of the <code>Status</code> field in the output is <code>Running</code>, this operation
 *       returns only partial results. If you see a value of <code>Scheduled</code> or <code>Running</code> for the status,
 *       you can retry the operation later to see the final results. </p>
 */
var GetQueryResultsCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(GetQueryResultsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetQueryResultsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    GetQueryResultsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "GetQueryResultsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["w" /* GetQueryResultsRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["x" /* GetQueryResultsResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetQueryResultsCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["C" /* serializeAws_json1_1GetQueryResultsCommand */])(input, context);
    };
    GetQueryResultsCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["D" /* deserializeAws_json1_1GetQueryResultsCommand */])(output, context);
    };
    return GetQueryResultsCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=GetQueryResultsCommand.js.map

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListTagsLogGroupCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Lists the tags for the specified log group.</p>
 */
var ListTagsLogGroupCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ListTagsLogGroupCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListTagsLogGroupCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    ListTagsLogGroupCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "ListTagsLogGroupCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["u" /* ListTagsLogGroupRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["v" /* ListTagsLogGroupResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListTagsLogGroupCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["A" /* serializeAws_json1_1ListTagsLogGroupCommand */])(input, context);
    };
    ListTagsLogGroupCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["B" /* deserializeAws_json1_1ListTagsLogGroupCommand */])(output, context);
    };
    return ListTagsLogGroupCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=ListTagsLogGroupCommand.js.map

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PutDestinationCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Creates or updates a destination. This operation is used only to create destinations for cross-account subscriptions.</p>
 *          <p>A destination encapsulates a physical resource (such
 *       as an Amazon Kinesis stream) and enables you to subscribe to a real-time stream of log events
 *       for a different account, ingested using <a href="https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_PutLogEvents.html">PutLogEvents</a>.</p>
 *          <p>Through an access policy, a destination controls what is written to it.
 *       By default, <code>PutDestination</code> does not set any access policy with the destination,
 *       which means a cross-account user cannot call <a href="https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_PutSubscriptionFilter.html">PutSubscriptionFilter</a> against
 *       this destination. To enable this, the destination owner must call <a href="https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_PutDestinationPolicy.html">PutDestinationPolicy</a> after <code>PutDestination</code>.</p>
 *          <p>To perform a <code>PutDestination</code> operation, you must also have the
 *     <code>iam:PassRole</code> permission.</p>
 */
var PutDestinationCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(PutDestinationCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutDestinationCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    PutDestinationCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "PutDestinationCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["s" /* PutDestinationRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["t" /* PutDestinationResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutDestinationCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["y" /* serializeAws_json1_1PutDestinationCommand */])(input, context);
    };
    PutDestinationCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["z" /* deserializeAws_json1_1PutDestinationCommand */])(output, context);
    };
    return PutDestinationCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=PutDestinationCommand.js.map

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PutDestinationPolicyCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Creates or updates an access policy associated with an existing
 *       destination. An access policy is an <a href="https://docs.aws.amazon.com/IAM/latest/UserGuide/policies_overview.html">IAM policy document</a> that is used
 *       to authorize claims to register a subscription filter against a given destination.</p>
 */
var PutDestinationPolicyCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(PutDestinationPolicyCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutDestinationPolicyCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    PutDestinationPolicyCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "PutDestinationPolicyCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["r" /* PutDestinationPolicyRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutDestinationPolicyCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["w" /* serializeAws_json1_1PutDestinationPolicyCommand */])(input, context);
    };
    PutDestinationPolicyCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["x" /* deserializeAws_json1_1PutDestinationPolicyCommand */])(output, context);
    };
    return PutDestinationPolicyCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=PutDestinationPolicyCommand.js.map

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PutLogEventsCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Uploads a batch of log events to the specified log stream.</p>
 *          <p>You must include the sequence token obtained from the response of the previous call. An
 *       upload in a newly created log stream does not require a sequence token. You can also get the
 *       sequence token in the <code>expectedSequenceToken</code> field from
 *         <code>InvalidSequenceTokenException</code>. If you call <code>PutLogEvents</code> twice
 *       within a narrow time period using the same value for <code>sequenceToken</code>, both calls
 *       might be successful or one might be rejected.</p>
 *          <p>The batch of events must satisfy the following constraints:</p>
 *          <ul>
 *             <li>
 *                <p>The maximum batch size is 1,048,576 bytes. This size is calculated as the sum of
 *           all event messages in UTF-8, plus 26 bytes for each log event.</p>
 *             </li>
 *             <li>
 *                <p>None of the log events in the batch can be more than 2 hours in the future.</p>
 *             </li>
 *             <li>
 *                <p>None of the log events in the batch can be older than 14 days or older than the retention
 *           period of the log group.</p>
 *             </li>
 *             <li>
 *                <p>The log events in the batch must be in chronological order by their timestamp. The
 *           timestamp is the time the event occurred, expressed as the number of milliseconds after
 *           Jan 1, 1970 00:00:00 UTC. (In AWS Tools for PowerShell and the AWS SDK for .NET, the
 *           timestamp is specified in .NET format: yyyy-mm-ddThh:mm:ss. For example,
 *           2017-09-15T13:45:30.) </p>
 *             </li>
 *             <li>
 *                <p>A batch of log events in a single request cannot span more than 24 hours. Otherwise, the operation fails.</p>
 *             </li>
 *             <li>
 *                <p>The maximum number of log events in a batch is 10,000.</p>
 *             </li>
 *             <li>
 *                <p>There is a quota of 5 requests per second per log stream. Additional requests are throttled. This quota can't be changed.</p>
 *             </li>
 *          </ul>
 *          <p>If a call to <code>PutLogEvents</code> returns "UnrecognizedClientException" the most likely cause is an invalid AWS access key ID or secret key. </p>
 */
var PutLogEventsCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(PutLogEventsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutLogEventsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    PutLogEventsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "PutLogEventsCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["p" /* PutLogEventsRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["q" /* PutLogEventsResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutLogEventsCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["u" /* serializeAws_json1_1PutLogEventsCommand */])(input, context);
    };
    PutLogEventsCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["v" /* deserializeAws_json1_1PutLogEventsCommand */])(output, context);
    };
    return PutLogEventsCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=PutLogEventsCommand.js.map

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PutMetricFilterCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Creates or updates a metric filter and associates it with the specified log group.
 *       Metric filters allow you to configure rules to extract metric data from log events ingested
 *       through <a href="https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_PutLogEvents.html">PutLogEvents</a>.</p>
 *          <p>The maximum number of metric filters that can be associated with a log group is
 *       100.</p>
 */
var PutMetricFilterCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(PutMetricFilterCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutMetricFilterCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    PutMetricFilterCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "PutMetricFilterCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["o" /* PutMetricFilterRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutMetricFilterCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["s" /* serializeAws_json1_1PutMetricFilterCommand */])(input, context);
    };
    PutMetricFilterCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["t" /* deserializeAws_json1_1PutMetricFilterCommand */])(output, context);
    };
    return PutMetricFilterCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=PutMetricFilterCommand.js.map

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PutQueryDefinitionCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Creates or updates a query definition for CloudWatch Logs Insights. For
 *       more information, see <a href="https://docs.aws.amazon.com/AmazonCloudWatch/latest/logs/AnalyzingLogData.html">Analyzing Log Data with CloudWatch Logs Insights</a>.</p>
 *
 *          <p>To update a query definition, specify its
 *         <code>queryDefinitionId</code> in your request. The values of <code>name</code>, <code>queryString</code>,
 *       and <code>logGroupNames</code> are changed to the values that you specify in your update
 *       operation. No current values are retained from the current query definition. For example, if
 *       you update a current query definition that includes log groups, and you don't specify the
 *         <code>logGroupNames</code> parameter in your update operation, the query definition changes
 *       to contain no log groups.</p>
 *          <p>You must have the <code>logs:PutQueryDefinition</code> permission to be able to perform
 *     this operation.</p>
 */
var PutQueryDefinitionCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(PutQueryDefinitionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutQueryDefinitionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    PutQueryDefinitionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "PutQueryDefinitionCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["m" /* PutQueryDefinitionRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["n" /* PutQueryDefinitionResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutQueryDefinitionCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["q" /* serializeAws_json1_1PutQueryDefinitionCommand */])(input, context);
    };
    PutQueryDefinitionCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["r" /* deserializeAws_json1_1PutQueryDefinitionCommand */])(output, context);
    };
    return PutQueryDefinitionCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=PutQueryDefinitionCommand.js.map

/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PutResourcePolicyCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Creates or updates a resource policy allowing other AWS services to put log events to
 *       this account, such as Amazon Route 53. An account can have up to 10 resource policies per AWS
 *       Region.</p>
 */
var PutResourcePolicyCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(PutResourcePolicyCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutResourcePolicyCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    PutResourcePolicyCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "PutResourcePolicyCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["k" /* PutResourcePolicyRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["l" /* PutResourcePolicyResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutResourcePolicyCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["o" /* serializeAws_json1_1PutResourcePolicyCommand */])(input, context);
    };
    PutResourcePolicyCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["p" /* deserializeAws_json1_1PutResourcePolicyCommand */])(output, context);
    };
    return PutResourcePolicyCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=PutResourcePolicyCommand.js.map

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PutRetentionPolicyCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Sets the retention of the specified log group. A retention policy allows you to
 *       configure the number of days for which to retain log events in the specified log
 *       group.</p>
 */
var PutRetentionPolicyCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(PutRetentionPolicyCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutRetentionPolicyCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    PutRetentionPolicyCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "PutRetentionPolicyCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["j" /* PutRetentionPolicyRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutRetentionPolicyCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["m" /* serializeAws_json1_1PutRetentionPolicyCommand */])(input, context);
    };
    PutRetentionPolicyCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["n" /* deserializeAws_json1_1PutRetentionPolicyCommand */])(output, context);
    };
    return PutRetentionPolicyCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=PutRetentionPolicyCommand.js.map

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PutSubscriptionFilterCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Creates or updates a subscription filter and associates it with the specified log
 *       group. Subscription filters allow you to subscribe to a real-time stream of log events
 *       ingested through <a href="https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_PutLogEvents.html">PutLogEvents</a> and have them delivered to a specific
 *       destination. When log events are sent to the
 *       receiving service, they are Base64 encoded
 *       and compressed with the gzip format.</p>
 *          <p>The following destinations are supported for subscription filters:</p>
 *          <ul>
 *             <li>
 *                <p>An Amazon Kinesis stream belonging to the same account as the subscription filter,
 *           for same-account delivery.</p>
 *             </li>
 *             <li>
 *                <p>A logical destination that belongs to a different account, for cross-account delivery.</p>
 *             </li>
 *             <li>
 *                <p>An Amazon Kinesis Firehose delivery stream that belongs to the same account as the
 *           subscription filter, for same-account delivery.</p>
 *             </li>
 *             <li>
 *                <p>An AWS Lambda function that belongs to the same account as the subscription filter,
 *           for same-account delivery.</p>
 *             </li>
 *          </ul>
 *          <p>There can only be one subscription filter associated with a log group. If you are
 *       updating an existing filter, you must specify the correct name in <code>filterName</code>.
 *       Otherwise, the call fails because you cannot associate a second filter with a log
 *       group.</p>
 *          <p>To perform a <code>PutSubscriptionFilter</code> operation, you must also have the
 *       <code>iam:PassRole</code> permission.</p>
 */
var PutSubscriptionFilterCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(PutSubscriptionFilterCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutSubscriptionFilterCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    PutSubscriptionFilterCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "PutSubscriptionFilterCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["i" /* PutSubscriptionFilterRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutSubscriptionFilterCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["k" /* serializeAws_json1_1PutSubscriptionFilterCommand */])(input, context);
    };
    PutSubscriptionFilterCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["l" /* deserializeAws_json1_1PutSubscriptionFilterCommand */])(output, context);
    };
    return PutSubscriptionFilterCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=PutSubscriptionFilterCommand.js.map

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StartQueryCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Schedules a query of a log group using CloudWatch Logs Insights. You specify the log group
 *       and time range to query and the query string to use.</p>
 *          <p>For more information, see <a href="https://docs.aws.amazon.com/AmazonCloudWatch/latest/logs/CWL_QuerySyntax.html">CloudWatch Logs Insights Query Syntax</a>.</p>
 *
 *          <p>Queries time out after 15 minutes of execution. If your queries are timing out, reduce the
 *       time range being searched or partition your query into a number of queries.</p>
 */
var StartQueryCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(StartQueryCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StartQueryCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    StartQueryCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "StartQueryCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["g" /* StartQueryRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["h" /* StartQueryResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StartQueryCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["i" /* serializeAws_json1_1StartQueryCommand */])(input, context);
    };
    StartQueryCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["j" /* deserializeAws_json1_1StartQueryCommand */])(output, context);
    };
    return StartQueryCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=StartQueryCommand.js.map

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StopQueryCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Stops a CloudWatch Logs Insights query that is in progress. If the query has already ended, the operation
 *     returns an error indicating that the specified query is not running.</p>
 */
var StopQueryCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(StopQueryCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function StopQueryCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    StopQueryCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "StopQueryCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["e" /* StopQueryRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["f" /* StopQueryResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    StopQueryCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["g" /* serializeAws_json1_1StopQueryCommand */])(input, context);
    };
    StopQueryCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["h" /* deserializeAws_json1_1StopQueryCommand */])(output, context);
    };
    return StopQueryCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=StopQueryCommand.js.map

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TagLogGroupCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Adds or updates the specified tags for the specified log group.</p>
 *          <p>To list the tags for a log group, use <a href="https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_ListTagsLogGroup.html">ListTagsLogGroup</a>.
 *       To remove tags, use <a href="https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_UntagLogGroup.html">UntagLogGroup</a>.</p>
 *          <p>For more information about tags, see <a href="https://docs.aws.amazon.com/AmazonCloudWatch/latest/logs/Working-with-log-groups-and-streams.html#log-group-tagging">Tag Log Groups in Amazon CloudWatch Logs</a>
 *       in the <i>Amazon CloudWatch Logs User Guide</i>.</p>
 */
var TagLogGroupCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(TagLogGroupCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function TagLogGroupCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    TagLogGroupCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "TagLogGroupCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["d" /* TagLogGroupRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    TagLogGroupCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["e" /* serializeAws_json1_1TagLogGroupCommand */])(input, context);
    };
    TagLogGroupCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["f" /* deserializeAws_json1_1TagLogGroupCommand */])(output, context);
    };
    return TagLogGroupCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=TagLogGroupCommand.js.map

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TestMetricFilterCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Tests the filter pattern of a metric filter against a sample of log event messages. You
 *       can use this operation to validate the correctness of a metric filter pattern.</p>
 */
var TestMetricFilterCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(TestMetricFilterCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function TestMetricFilterCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    TestMetricFilterCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "TestMetricFilterCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["b" /* TestMetricFilterRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["c" /* TestMetricFilterResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    TestMetricFilterCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["c" /* serializeAws_json1_1TestMetricFilterCommand */])(input, context);
    };
    TestMetricFilterCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["d" /* deserializeAws_json1_1TestMetricFilterCommand */])(output, context);
    };
    return TestMetricFilterCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=TestMetricFilterCommand.js.map

/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UntagLogGroupCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Removes the specified tags from the specified log group.</p>
 *          <p>To list the tags for a log group, use <a href="https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_ListTagsLogGroup.html">ListTagsLogGroup</a>.
 *       To add tags, use <a href="https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_TagLogGroup.html">TagLogGroup</a>.</p>
 */
var UntagLogGroupCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(UntagLogGroupCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UntagLogGroupCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    UntagLogGroupCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CloudWatchLogsClient";
        var commandName = "UntagLogGroupCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["a" /* UntagLogGroupRequest */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UntagLogGroupCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["a" /* serializeAws_json1_1UntagLogGroupCommand */])(input, context);
    };
    UntagLogGroupCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["b" /* deserializeAws_json1_1UntagLogGroupCommand */])(output, context);
    };
    return UntagLogGroupCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=UntagLogGroupCommand.js.map

/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CognitoIdentity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CognitoIdentityClient__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commands_CreateIdentityPoolCommand__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_DeleteIdentitiesCommand__ = __webpack_require__(828);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commands_DeleteIdentityPoolCommand__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commands_DescribeIdentityCommand__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commands_DescribeIdentityPoolCommand__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commands_GetCredentialsForIdentityCommand__ = __webpack_require__(832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commands_GetIdCommand__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commands_GetIdentityPoolRolesCommand__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commands_GetOpenIdTokenCommand__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commands_GetOpenIdTokenForDeveloperIdentityCommand__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commands_ListIdentitiesCommand__ = __webpack_require__(837);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commands_ListIdentityPoolsCommand__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commands_ListTagsForResourceCommand__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commands_LookupDeveloperIdentityCommand__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__commands_MergeDeveloperIdentitiesCommand__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__commands_SetIdentityPoolRolesCommand__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__commands_TagResourceCommand__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__commands_UnlinkDeveloperIdentityCommand__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__commands_UnlinkIdentityCommand__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__commands_UntagResourceCommand__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__commands_UpdateIdentityPoolCommand__ = __webpack_require__(846);























/**
 * <fullname>Amazon Cognito Federated Identities</fullname>
 *          <p>Amazon Cognito Federated Identities is a web service that delivers scoped temporary
 *          credentials to mobile devices and other untrusted environments. It uniquely identifies a
 *          device and supplies the user with a consistent identity over the lifetime of an
 *          application.</p>
 *          <p>Using Amazon Cognito Federated Identities, you can enable authentication with one or
 *          more third-party identity providers (Facebook, Google, or Login with Amazon) or an Amazon
 *          Cognito user pool, and you can also choose to support unauthenticated access from your app.
 *          Cognito delivers a unique identifier for each user and acts as an OpenID token provider
 *          trusted by AWS Security Token Service (STS) to access temporary, limited-privilege AWS
 *          credentials.</p>
 *          <p>For a description of the authentication flow from the Amazon Cognito Developer Guide
 *          see <a href="https://docs.aws.amazon.com/cognito/latest/developerguide/authentication-flow.html">Authentication Flow</a>.</p>
 *          <p>For more information see <a href="https://docs.aws.amazon.com/cognito/latest/developerguide/cognito-identity.html">Amazon Cognito Federated Identities</a>.</p>
 */
var CognitoIdentity = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CognitoIdentity, _super);
    function CognitoIdentity() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CognitoIdentity.prototype.createIdentityPool = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_2__commands_CreateIdentityPoolCommand__["a" /* CreateIdentityPoolCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.deleteIdentities = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_3__commands_DeleteIdentitiesCommand__["a" /* DeleteIdentitiesCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.deleteIdentityPool = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_4__commands_DeleteIdentityPoolCommand__["a" /* DeleteIdentityPoolCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.describeIdentity = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_5__commands_DescribeIdentityCommand__["a" /* DescribeIdentityCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.describeIdentityPool = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_6__commands_DescribeIdentityPoolCommand__["a" /* DescribeIdentityPoolCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.getCredentialsForIdentity = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_7__commands_GetCredentialsForIdentityCommand__["a" /* GetCredentialsForIdentityCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.getId = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_8__commands_GetIdCommand__["a" /* GetIdCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.getIdentityPoolRoles = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_9__commands_GetIdentityPoolRolesCommand__["a" /* GetIdentityPoolRolesCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.getOpenIdToken = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_10__commands_GetOpenIdTokenCommand__["a" /* GetOpenIdTokenCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.getOpenIdTokenForDeveloperIdentity = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_11__commands_GetOpenIdTokenForDeveloperIdentityCommand__["a" /* GetOpenIdTokenForDeveloperIdentityCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.listIdentities = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_12__commands_ListIdentitiesCommand__["a" /* ListIdentitiesCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.listIdentityPools = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_13__commands_ListIdentityPoolsCommand__["a" /* ListIdentityPoolsCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.listTagsForResource = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_14__commands_ListTagsForResourceCommand__["a" /* ListTagsForResourceCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.lookupDeveloperIdentity = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_15__commands_LookupDeveloperIdentityCommand__["a" /* LookupDeveloperIdentityCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.mergeDeveloperIdentities = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_16__commands_MergeDeveloperIdentitiesCommand__["a" /* MergeDeveloperIdentitiesCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.setIdentityPoolRoles = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_17__commands_SetIdentityPoolRolesCommand__["a" /* SetIdentityPoolRolesCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.tagResource = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_18__commands_TagResourceCommand__["a" /* TagResourceCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.unlinkDeveloperIdentity = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_19__commands_UnlinkDeveloperIdentityCommand__["a" /* UnlinkDeveloperIdentityCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.unlinkIdentity = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_20__commands_UnlinkIdentityCommand__["a" /* UnlinkIdentityCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.untagResource = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_21__commands_UntagResourceCommand__["a" /* UntagResourceCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    CognitoIdentity.prototype.updateIdentityPool = function (args, optionsOrCb, cb) {
        var command = new __WEBPACK_IMPORTED_MODULE_22__commands_UpdateIdentityPoolCommand__["a" /* UpdateIdentityPoolCommand */](args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error("Expect http options but get " + typeof optionsOrCb);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    };
    return CognitoIdentity;
}(__WEBPACK_IMPORTED_MODULE_1__CognitoIdentityClient__["a" /* CognitoIdentityClient */]));

//# sourceMappingURL=CognitoIdentity.js.map

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CreateIdentityPoolCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__ = __webpack_require__(22);






/**
 * <p>Creates a new identity pool. The identity pool is a store of user identity
 *          information that is specific to your AWS account. The keys for <code>SupportedLoginProviders</code> are as follows:</p>
 *
 *          <ul>
 *             <li>
 *                <p>Facebook: <code>graph.facebook.com</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>Google: <code>accounts.google.com</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>Amazon: <code>www.amazon.com</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>Twitter: <code>api.twitter.com</code>
 *                </p>
 *             </li>
 *             <li>
 *                <p>Digits: <code>www.digits.com</code>
 *                </p>
 *             </li>
 *          </ul>
 *
 *          <p>You must use AWS Developer credentials to call this API.</p>
 */
var CreateIdentityPoolCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(CreateIdentityPoolCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function CreateIdentityPoolCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    CreateIdentityPoolCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__["a" /* getAwsAuthPlugin */])(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "CreateIdentityPoolCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["C" /* CreateIdentityPoolInput */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["a" /* IdentityPool */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    CreateIdentityPoolCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["I" /* serializeAws_json1_1CreateIdentityPoolCommand */])(input, context);
    };
    CreateIdentityPoolCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["J" /* deserializeAws_json1_1CreateIdentityPoolCommand */])(output, context);
    };
    return CreateIdentityPoolCommand;
}(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=CreateIdentityPoolCommand.js.map

/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteIdentitiesCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__ = __webpack_require__(22);






/**
 * <p>Deletes identities from an identity pool. You can specify a list of 1-60 identities
 *          that you want to delete.</p>
 *          <p>You must use AWS Developer credentials to call this API.</p>
 */
var DeleteIdentitiesCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DeleteIdentitiesCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteIdentitiesCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DeleteIdentitiesCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__["a" /* getAwsAuthPlugin */])(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "DeleteIdentitiesCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["A" /* DeleteIdentitiesInput */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["B" /* DeleteIdentitiesResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteIdentitiesCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["G" /* serializeAws_json1_1DeleteIdentitiesCommand */])(input, context);
    };
    DeleteIdentitiesCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["H" /* deserializeAws_json1_1DeleteIdentitiesCommand */])(output, context);
    };
    return DeleteIdentitiesCommand;
}(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DeleteIdentitiesCommand.js.map

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DeleteIdentityPoolCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__ = __webpack_require__(22);






/**
 * <p>Deletes an identity pool. Once a pool is deleted, users will not be able to
 *          authenticate with the pool.</p>
 *          <p>You must use AWS Developer credentials to call this API.</p>
 */
var DeleteIdentityPoolCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DeleteIdentityPoolCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DeleteIdentityPoolCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DeleteIdentityPoolCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__["a" /* getAwsAuthPlugin */])(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "DeleteIdentityPoolCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["z" /* DeleteIdentityPoolInput */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DeleteIdentityPoolCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["E" /* serializeAws_json1_1DeleteIdentityPoolCommand */])(input, context);
    };
    DeleteIdentityPoolCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["F" /* deserializeAws_json1_1DeleteIdentityPoolCommand */])(output, context);
    };
    return DeleteIdentityPoolCommand;
}(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DeleteIdentityPoolCommand.js.map

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DescribeIdentityCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__ = __webpack_require__(22);






/**
 * <p>Returns metadata related to the given identity, including when the identity was
 *          created and any associated linked logins.</p>
 *          <p>You must use AWS Developer credentials to call this API.</p>
 */
var DescribeIdentityCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DescribeIdentityCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeIdentityCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DescribeIdentityCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__["a" /* getAwsAuthPlugin */])(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "DescribeIdentityCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["x" /* DescribeIdentityInput */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["y" /* IdentityDescription */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeIdentityCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["C" /* serializeAws_json1_1DescribeIdentityCommand */])(input, context);
    };
    DescribeIdentityCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["D" /* deserializeAws_json1_1DescribeIdentityCommand */])(output, context);
    };
    return DescribeIdentityCommand;
}(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DescribeIdentityCommand.js.map

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DescribeIdentityPoolCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__ = __webpack_require__(22);






/**
 * <p>Gets details about a particular identity pool, including the pool name, ID
 *          description, creation date, and current number of users.</p>
 *          <p>You must use AWS Developer credentials to call this API.</p>
 */
var DescribeIdentityPoolCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(DescribeIdentityPoolCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function DescribeIdentityPoolCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    DescribeIdentityPoolCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__["a" /* getAwsAuthPlugin */])(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "DescribeIdentityPoolCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["w" /* DescribeIdentityPoolInput */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["a" /* IdentityPool */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    DescribeIdentityPoolCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["A" /* serializeAws_json1_1DescribeIdentityPoolCommand */])(input, context);
    };
    DescribeIdentityPoolCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["B" /* deserializeAws_json1_1DescribeIdentityPoolCommand */])(output, context);
    };
    return DescribeIdentityPoolCommand;
}(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=DescribeIdentityPoolCommand.js.map

/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetCredentialsForIdentityCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Returns credentials for the provided identity ID. Any provided logins will be
 *          validated against supported login providers. If the token is for
 *          cognito-identity.amazonaws.com, it will be passed through to AWS Security Token Service
 *          with the appropriate role for the token.</p>
 *          <p>This is a public API. You do not need any credentials to call this API.</p>
 */
var GetCredentialsForIdentityCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(GetCredentialsForIdentityCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetCredentialsForIdentityCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    GetCredentialsForIdentityCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "GetCredentialsForIdentityCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["H" /* GetCredentialsForIdentityInput */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["I" /* GetCredentialsForIdentityResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetCredentialsForIdentityCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["O" /* serializeAws_json1_1GetCredentialsForIdentityCommand */])(input, context);
    };
    GetCredentialsForIdentityCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["P" /* deserializeAws_json1_1GetCredentialsForIdentityCommand */])(output, context);
    };
    return GetCredentialsForIdentityCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=GetCredentialsForIdentityCommand.js.map

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetIdCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Generates (or retrieves) a Cognito ID. Supplying multiple logins will create an
 *          implicit linked account.</p>
 *          <p>This is a public API. You do not need any credentials to call this API.</p>
 */
var GetIdCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(GetIdCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetIdCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    GetIdCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "GetIdCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["F" /* GetIdInput */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["G" /* GetIdResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetIdCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["M" /* serializeAws_json1_1GetIdCommand */])(input, context);
    };
    GetIdCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["N" /* deserializeAws_json1_1GetIdCommand */])(output, context);
    };
    return GetIdCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=GetIdCommand.js.map

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetIdentityPoolRolesCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__ = __webpack_require__(22);






/**
 * <p>Gets the roles for an identity pool.</p>
 *          <p>You must use AWS Developer credentials to call this API.</p>
 */
var GetIdentityPoolRolesCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(GetIdentityPoolRolesCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetIdentityPoolRolesCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    GetIdentityPoolRolesCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__["a" /* getAwsAuthPlugin */])(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "GetIdentityPoolRolesCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["u" /* GetIdentityPoolRolesInput */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["v" /* GetIdentityPoolRolesResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetIdentityPoolRolesCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["y" /* serializeAws_json1_1GetIdentityPoolRolesCommand */])(input, context);
    };
    GetIdentityPoolRolesCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["z" /* deserializeAws_json1_1GetIdentityPoolRolesCommand */])(output, context);
    };
    return GetIdentityPoolRolesCommand;
}(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=GetIdentityPoolRolesCommand.js.map

/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetOpenIdTokenCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Gets an OpenID token, using a known Cognito ID. This known Cognito ID is returned by
 *             <a>GetId</a>. You can optionally add additional logins for the identity.
 *          Supplying multiple logins creates an implicit link.</p>
 *          <p>The OpenId token is valid for 10 minutes.</p>
 *          <p>This is a public API. You do not need any credentials to call this API.</p>
 */
var GetOpenIdTokenCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(GetOpenIdTokenCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetOpenIdTokenCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    GetOpenIdTokenCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "GetOpenIdTokenCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["s" /* GetOpenIdTokenInput */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["t" /* GetOpenIdTokenResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetOpenIdTokenCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["w" /* serializeAws_json1_1GetOpenIdTokenCommand */])(input, context);
    };
    GetOpenIdTokenCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["x" /* deserializeAws_json1_1GetOpenIdTokenCommand */])(output, context);
    };
    return GetOpenIdTokenCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=GetOpenIdTokenCommand.js.map

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetOpenIdTokenForDeveloperIdentityCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__ = __webpack_require__(22);






/**
 * <p>Registers (or retrieves) a Cognito <code>IdentityId</code> and an OpenID Connect
 *          token for a user authenticated by your backend authentication process. Supplying multiple
 *          logins will create an implicit linked account. You can only specify one developer provider
 *          as part of the <code>Logins</code> map, which is linked to the identity pool. The developer
 *          provider is the "domain" by which Cognito will refer to your users.</p>
 *          <p>You can use <code>GetOpenIdTokenForDeveloperIdentity</code> to create a new identity
 *          and to link new logins (that is, user credentials issued by a public provider or developer
 *          provider) to an existing identity. When you want to create a new identity, the
 *             <code>IdentityId</code> should be null. When you want to associate a new login with an
 *          existing authenticated/unauthenticated identity, you can do so by providing the existing
 *             <code>IdentityId</code>. This API will create the identity in the specified
 *             <code>IdentityPoolId</code>.</p>
 *          <p>You must use AWS Developer credentials to call this API.</p>
 */
var GetOpenIdTokenForDeveloperIdentityCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(GetOpenIdTokenForDeveloperIdentityCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetOpenIdTokenForDeveloperIdentityCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    GetOpenIdTokenForDeveloperIdentityCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__["a" /* getAwsAuthPlugin */])(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "GetOpenIdTokenForDeveloperIdentityCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["q" /* GetOpenIdTokenForDeveloperIdentityInput */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["r" /* GetOpenIdTokenForDeveloperIdentityResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetOpenIdTokenForDeveloperIdentityCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["u" /* serializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommand */])(input, context);
    };
    GetOpenIdTokenForDeveloperIdentityCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["v" /* deserializeAws_json1_1GetOpenIdTokenForDeveloperIdentityCommand */])(output, context);
    };
    return GetOpenIdTokenForDeveloperIdentityCommand;
}(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=GetOpenIdTokenForDeveloperIdentityCommand.js.map

/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListIdentitiesCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__ = __webpack_require__(22);






/**
 * <p>Lists the identities in an identity pool.</p>
 *          <p>You must use AWS Developer credentials to call this API.</p>
 */
var ListIdentitiesCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ListIdentitiesCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListIdentitiesCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    ListIdentitiesCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__["a" /* getAwsAuthPlugin */])(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "ListIdentitiesCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["o" /* ListIdentitiesInput */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["p" /* ListIdentitiesResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListIdentitiesCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["s" /* serializeAws_json1_1ListIdentitiesCommand */])(input, context);
    };
    ListIdentitiesCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["t" /* deserializeAws_json1_1ListIdentitiesCommand */])(output, context);
    };
    return ListIdentitiesCommand;
}(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=ListIdentitiesCommand.js.map

/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ListTagsForResourceCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__ = __webpack_require__(22);






/**
 * <p>Lists the tags that are assigned to an Amazon Cognito identity pool.</p>
 *          <p>A tag is a label that you can apply to identity pools to categorize and manage them in
 *          different ways, such as by purpose, owner, environment, or other criteria.</p>
 *          <p>You can use this action up to 10 times per second, per account.</p>
 */
var ListTagsForResourceCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(ListTagsForResourceCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function ListTagsForResourceCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    ListTagsForResourceCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__["a" /* getAwsAuthPlugin */])(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "ListTagsForResourceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["m" /* ListTagsForResourceInput */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["n" /* ListTagsForResourceResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    ListTagsForResourceCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["q" /* serializeAws_json1_1ListTagsForResourceCommand */])(input, context);
    };
    ListTagsForResourceCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["r" /* deserializeAws_json1_1ListTagsForResourceCommand */])(output, context);
    };
    return ListTagsForResourceCommand;
}(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=ListTagsForResourceCommand.js.map

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LookupDeveloperIdentityCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__ = __webpack_require__(22);






/**
 * <p>Retrieves the <code>IdentityID</code> associated with a
 *             <code>DeveloperUserIdentifier</code> or the list of <code>DeveloperUserIdentifier</code>
 *          values associated with an <code>IdentityId</code> for an existing identity. Either
 *             <code>IdentityID</code> or <code>DeveloperUserIdentifier</code> must not be null. If you
 *          supply only one of these values, the other value will be searched in the database and
 *          returned as a part of the response. If you supply both,
 *             <code>DeveloperUserIdentifier</code> will be matched against <code>IdentityID</code>. If
 *          the values are verified against the database, the response returns both values and is the
 *          same as the request. Otherwise a <code>ResourceConflictException</code> is
 *          thrown.</p>
 *          <p>
 *             <code>LookupDeveloperIdentity</code> is intended for low-throughput control plane
 *          operations: for example, to enable customer service to locate an identity ID by username.
 *          If you are using it for higher-volume operations such as user authentication, your requests
 *          are likely to be throttled. <a>GetOpenIdTokenForDeveloperIdentity</a> is a
 *          better option for higher-volume operations for user authentication.</p>
 *          <p>You must use AWS Developer credentials to call this API.</p>
 */
var LookupDeveloperIdentityCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(LookupDeveloperIdentityCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function LookupDeveloperIdentityCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    LookupDeveloperIdentityCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__["a" /* getAwsAuthPlugin */])(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "LookupDeveloperIdentityCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["k" /* LookupDeveloperIdentityInput */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["l" /* LookupDeveloperIdentityResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    LookupDeveloperIdentityCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["o" /* serializeAws_json1_1LookupDeveloperIdentityCommand */])(input, context);
    };
    LookupDeveloperIdentityCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["p" /* deserializeAws_json1_1LookupDeveloperIdentityCommand */])(output, context);
    };
    return LookupDeveloperIdentityCommand;
}(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=LookupDeveloperIdentityCommand.js.map

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MergeDeveloperIdentitiesCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__ = __webpack_require__(22);






/**
 * <p>Merges two users having different <code>IdentityId</code>s, existing in the same
 *          identity pool, and identified by the same developer provider. You can use this action to
 *          request that discrete users be merged and identified as a single user in the Cognito
 *          environment. Cognito associates the given source user (<code>SourceUserIdentifier</code>)
 *          with the <code>IdentityId</code> of the <code>DestinationUserIdentifier</code>. Only
 *          developer-authenticated users can be merged. If the users to be merged are associated with
 *          the same public provider, but as two different users, an exception will be
 *          thrown.</p>
 *          <p>The number of linked logins is limited to 20. So, the number of linked logins for the
 *          source user, <code>SourceUserIdentifier</code>, and the destination user,
 *          <code>DestinationUserIdentifier</code>, together should not be larger than 20.
 *          Otherwise, an exception will be thrown.</p>
 *          <p>You must use AWS Developer credentials to call this API.</p>
 */
var MergeDeveloperIdentitiesCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(MergeDeveloperIdentitiesCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function MergeDeveloperIdentitiesCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    MergeDeveloperIdentitiesCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__["a" /* getAwsAuthPlugin */])(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "MergeDeveloperIdentitiesCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["i" /* MergeDeveloperIdentitiesInput */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["j" /* MergeDeveloperIdentitiesResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    MergeDeveloperIdentitiesCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["m" /* serializeAws_json1_1MergeDeveloperIdentitiesCommand */])(input, context);
    };
    MergeDeveloperIdentitiesCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["n" /* deserializeAws_json1_1MergeDeveloperIdentitiesCommand */])(output, context);
    };
    return MergeDeveloperIdentitiesCommand;
}(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=MergeDeveloperIdentitiesCommand.js.map

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SetIdentityPoolRolesCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__ = __webpack_require__(22);






/**
 * <p>Sets the roles for an identity pool. These roles are used when making calls to <a>GetCredentialsForIdentity</a> action.</p>
 *          <p>You must use AWS Developer credentials to call this API.</p>
 */
var SetIdentityPoolRolesCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(SetIdentityPoolRolesCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function SetIdentityPoolRolesCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    SetIdentityPoolRolesCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__["a" /* getAwsAuthPlugin */])(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "SetIdentityPoolRolesCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["h" /* SetIdentityPoolRolesInput */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    SetIdentityPoolRolesCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["k" /* serializeAws_json1_1SetIdentityPoolRolesCommand */])(input, context);
    };
    SetIdentityPoolRolesCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["l" /* deserializeAws_json1_1SetIdentityPoolRolesCommand */])(output, context);
    };
    return SetIdentityPoolRolesCommand;
}(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=SetIdentityPoolRolesCommand.js.map

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TagResourceCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__ = __webpack_require__(22);






/**
 * <p>Assigns a set of tags to an Amazon Cognito identity pool. A tag is a label that you can
 *          use to categorize and manage identity pools in different ways, such as by purpose, owner,
 *          environment, or other criteria.</p>
 *          <p>Each tag consists of a key and value, both of which you define. A key is a general
 *          category for more specific values. For example, if you have two versions of an identity
 *          pool, one for testing and another for production, you might assign an
 *             <code>Environment</code> tag key to both identity pools. The value of this key might be
 *             <code>Test</code> for one identity pool and <code>Production</code> for the
 *          other.</p>
 *          <p>Tags are useful for cost tracking and access control. You can activate your tags so that
 *          they appear on the Billing and Cost Management console, where you can track the costs
 *          associated with your identity pools. In an IAM policy, you can constrain permissions for
 *          identity pools based on specific tags or tag values.</p>
 *          <p>You can use this action up to 5 times per second, per account. An identity pool can have
 *          as many as 50 tags.</p>
 */
var TagResourceCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(TagResourceCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function TagResourceCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    TagResourceCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__["a" /* getAwsAuthPlugin */])(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "TagResourceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["f" /* TagResourceInput */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["g" /* TagResourceResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    TagResourceCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["i" /* serializeAws_json1_1TagResourceCommand */])(input, context);
    };
    TagResourceCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["j" /* deserializeAws_json1_1TagResourceCommand */])(output, context);
    };
    return TagResourceCommand;
}(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=TagResourceCommand.js.map

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UnlinkDeveloperIdentityCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__ = __webpack_require__(22);






/**
 * <p>Unlinks a <code>DeveloperUserIdentifier</code> from an existing identity. Unlinked
 *          developer users will be considered new identities next time they are seen. If, for a given
 *          Cognito identity, you remove all federated identities as well as the developer user
 *          identifier, the Cognito identity becomes inaccessible.</p>
 *          <p>You must use AWS Developer credentials to call this API.</p>
 */
var UnlinkDeveloperIdentityCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(UnlinkDeveloperIdentityCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UnlinkDeveloperIdentityCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    UnlinkDeveloperIdentityCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__["a" /* getAwsAuthPlugin */])(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "UnlinkDeveloperIdentityCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["e" /* UnlinkDeveloperIdentityInput */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UnlinkDeveloperIdentityCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["g" /* serializeAws_json1_1UnlinkDeveloperIdentityCommand */])(input, context);
    };
    UnlinkDeveloperIdentityCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["h" /* deserializeAws_json1_1UnlinkDeveloperIdentityCommand */])(output, context);
    };
    return UnlinkDeveloperIdentityCommand;
}(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=UnlinkDeveloperIdentityCommand.js.map

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UnlinkIdentityCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__ = __webpack_require__(22);





/**
 * <p>Unlinks a federated identity from an existing account. Unlinked logins will be
 *          considered new identities next time they are seen. Removing the last linked login will make
 *          this identity inaccessible.</p>
 *          <p>This is a public API. You do not need any credentials to call this API.</p>
 */
var UnlinkIdentityCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(UnlinkIdentityCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UnlinkIdentityCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    UnlinkIdentityCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "UnlinkIdentityCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["d" /* UnlinkIdentityInput */].filterSensitiveLog,
            outputFilterSensitiveLog: function (output) { return output; },
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UnlinkIdentityCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["e" /* serializeAws_json1_1UnlinkIdentityCommand */])(input, context);
    };
    UnlinkIdentityCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["f" /* deserializeAws_json1_1UnlinkIdentityCommand */])(output, context);
    };
    return UnlinkIdentityCommand;
}(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=UnlinkIdentityCommand.js.map

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UntagResourceCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__ = __webpack_require__(22);






/**
 * <p>Removes the specified tags from an Amazon Cognito identity pool. You can use this action
 *          up to 5 times per second, per account</p>
 */
var UntagResourceCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(UntagResourceCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UntagResourceCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    UntagResourceCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__["a" /* getAwsAuthPlugin */])(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "UntagResourceCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["b" /* UntagResourceInput */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["c" /* UntagResourceResponse */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UntagResourceCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["c" /* serializeAws_json1_1UntagResourceCommand */])(input, context);
    };
    UntagResourceCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["d" /* deserializeAws_json1_1UntagResourceCommand */])(output, context);
    };
    return UntagResourceCommand;
}(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=UntagResourceCommand.js.map

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UpdateIdentityPoolCommand; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_models_0__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__ = __webpack_require__(22);






/**
 * <p>Updates an identity pool.</p>
 *          <p>You must use AWS Developer credentials to call this API.</p>
 */
var UpdateIdentityPoolCommand = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["b" /* __extends */])(UpdateIdentityPoolCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdateIdentityPoolCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    /**
     * @internal
     */
    UpdateIdentityPoolCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__aws_sdk_middleware_serde__["a" /* getSerdePlugin */])(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_middleware_signing__["a" /* getAwsAuthPlugin */])(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var clientName = "CognitoIdentityClient";
        var commandName = "UpdateIdentityPoolCommand";
        var handlerExecutionContext = {
            logger: logger,
            clientName: clientName,
            commandName: commandName,
            inputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["a" /* IdentityPool */].filterSensitiveLog,
            outputFilterSensitiveLog: __WEBPACK_IMPORTED_MODULE_1__models_models_0__["a" /* IdentityPool */].filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateIdentityPoolCommand.prototype.serialize = function (input, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["a" /* serializeAws_json1_1UpdateIdentityPoolCommand */])(input, context);
    };
    UpdateIdentityPoolCommand.prototype.deserialize = function (output, context) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__protocols_Aws_json1_1__["b" /* deserializeAws_json1_1UpdateIdentityPoolCommand */])(output, context);
    };
    return UpdateIdentityPoolCommand;
}(__WEBPACK_IMPORTED_MODULE_5__aws_sdk_smithy_client__["Command"]));

//# sourceMappingURL=UpdateIdentityPoolCommand.js.map

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EndpointsConfig__ = __webpack_require__(1689);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__EndpointsConfig__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RegionConfig__ = __webpack_require__(1690);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__RegionConfig__["a"]; });


//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyxtQkFBbUIsQ0FBQztBQUNsQyxjQUFjLGdCQUFnQixDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0ICogZnJvbSBcIi4vRW5kcG9pbnRzQ29uZmlnXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9SZWdpb25Db25maWdcIjtcbiJdfQ==

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromCognitoIdentity;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_client_cognito_identity__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_sdk_property_provider__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__resolveLogins__ = __webpack_require__(849);




/**
 * Retrieves temporary AWS credentials using Amazon Cognito's
 * `GetCredentialsForIdentity` operation.
 *
 * Results from this function call are not cached internally.
 */
function fromCognitoIdentity(parameters) {
    var _this = this;
    return function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(_this, void 0, void 0, function () {
        var _a, _b, _c, AccessKeyId, Expiration, _d, SecretKey, SessionToken, _e, _f, _g, _h;
        var _j;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_k) {
            switch (_k.label) {
                case 0:
                    _f = (_e = parameters.client).send;
                    _g = __WEBPACK_IMPORTED_MODULE_1__aws_sdk_client_cognito_identity__["GetCredentialsForIdentityCommand"].bind;
                    _j = {
                        CustomRoleArn: parameters.customRoleArn,
                        IdentityId: parameters.identityId
                    };
                    if (!parameters.logins) return [3 /*break*/, 2];
                    return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__resolveLogins__["a" /* resolveLogins */])(parameters.logins)];
                case 1:
                    _h = _k.sent();
                    return [3 /*break*/, 3];
                case 2:
                    _h = undefined;
                    _k.label = 3;
                case 3: return [4 /*yield*/, _f.apply(_e, [new (_g.apply(__WEBPACK_IMPORTED_MODULE_1__aws_sdk_client_cognito_identity__["GetCredentialsForIdentityCommand"], [void 0, (_j.Logins = _h,
                                _j)]))()])];
                case 4:
                    _a = (_k.sent()).Credentials, _b = _a === void 0 ? throwOnMissingCredentials() : _a, _c = _b.AccessKeyId, AccessKeyId = _c === void 0 ? throwOnMissingAccessKeyId() : _c, Expiration = _b.Expiration, _d = _b.SecretKey, SecretKey = _d === void 0 ? throwOnMissingSecretKey() : _d, SessionToken = _b.SessionToken;
                    return [2 /*return*/, {
                            identityId: parameters.identityId,
                            accessKeyId: AccessKeyId,
                            secretAccessKey: SecretKey,
                            sessionToken: SessionToken,
                            expiration: Expiration,
                        }];
            }
        });
    }); };
}
function throwOnMissingAccessKeyId() {
    throw new __WEBPACK_IMPORTED_MODULE_2__aws_sdk_property_provider__["a" /* ProviderError */]("Response from Amazon Cognito contained no access key ID");
}
function throwOnMissingCredentials() {
    throw new __WEBPACK_IMPORTED_MODULE_2__aws_sdk_property_provider__["a" /* ProviderError */]("Response from Amazon Cognito contained no credentials");
}
function throwOnMissingSecretKey() {
    throw new __WEBPACK_IMPORTED_MODULE_2__aws_sdk_property_provider__["a" /* ProviderError */]("Response from Amazon Cognito contained no secret key");
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = resolveLogins;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);

/**
 * @internal
 */
function resolveLogins(logins) {
    return Promise.all(Object.keys(logins).reduce(function (arr, name) {
        var tokenOrProvider = logins[name];
        if (typeof tokenOrProvider === "string") {
            arr.push([name, tokenOrProvider]);
        }
        else {
            arr.push(tokenOrProvider().then(function (token) { return [name, token]; }));
        }
        return arr;
    }, [])).then(function (resolvedPairs) {
        return resolvedPairs.reduce(function (logins, _a) {
            var _b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(_a, 2), key = _b[0], value = _b[1];
            logins[key] = value;
            return logins;
        }, {});
    });
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetch_http_handler__ = __webpack_require__(1699);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__fetch_http_handler__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stream_collector__ = __webpack_require__(1701);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__stream_collector__["a"]; });


//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyxzQkFBc0IsQ0FBQztBQUNyQyxjQUFjLG9CQUFvQixDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0ICogZnJvbSBcIi4vZmV0Y2gtaHR0cC1oYW5kbGVyXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9zdHJlYW0tY29sbGVjdG9yXCI7XG4iXX0=

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__invalidFunction__ = __webpack_require__(1702);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__invalidProvider__ = __webpack_require__(1703);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__invalidProvider__["a"]; });


//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyxtQkFBbUIsQ0FBQztBQUNsQyxjQUFjLG1CQUFtQixDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0ICogZnJvbSBcIi4vaW52YWxpZEZ1bmN0aW9uXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9pbnZhbGlkUHJvdmlkZXJcIjtcbiJdfQ==

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export contentLengthMiddleware */
/* unused harmony export contentLengthMiddlewareOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getContentLengthPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__ = __webpack_require__(171);


var CONTENT_LENGTH_HEADER = "content-length";
function contentLengthMiddleware(bodyLengthChecker) {
    var _this = this;
    return function (next) { return function (args) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(_this, void 0, void 0, function () {
        var request, body, headers, length;
        var _a;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_b) {
            request = args.request;
            if (__WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__["HttpRequest"].isInstance(request)) {
                body = request.body, headers = request.headers;
                if (body &&
                    Object.keys(headers)
                        .map(function (str) { return str.toLowerCase(); })
                        .indexOf(CONTENT_LENGTH_HEADER) === -1) {
                    length = bodyLengthChecker(body);
                    if (length !== undefined) {
                        request.headers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, request.headers), (_a = {}, _a[CONTENT_LENGTH_HEADER] = String(length), _a));
                    }
                }
            }
            return [2 /*return*/, next(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, args), { request: request }))];
        });
    }); }; };
}
var contentLengthMiddlewareOptions = {
    step: "build",
    tags: ["SET_CONTENT_LENGTH", "CONTENT_LENGTH"],
    name: "contentLengthMiddleware",
    override: true,
};
var getContentLengthPlugin = function (options) { return ({
    applyToStack: function (clientStack) {
        clientStack.add(contentLengthMiddleware(options.bodyLengthChecker), contentLengthMiddlewareOptions);
    },
}); };
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = resolveHostHeaderConfig;
/* unused harmony export hostHeaderMiddleware */
/* unused harmony export hostHeaderMiddlewareOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getHostHeaderPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__ = __webpack_require__(171);


function resolveHostHeaderConfig(input) {
    return input;
}
var hostHeaderMiddleware = function (options) { return function (next) { return function (args) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(void 0, void 0, void 0, function () {
    var request, _a, handlerProtocol;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_b) {
        if (!__WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__["HttpRequest"].isInstance(args.request))
            return [2 /*return*/, next(args)];
        request = args.request;
        _a = (options.requestHandler.metadata || {}).handlerProtocol, handlerProtocol = _a === void 0 ? "" : _a;
        //For H2 request, remove 'host' header and use ':authority' header instead
        //reference: https://nodejs.org/dist/latest-v13.x/docs/api/errors.html#ERR_HTTP2_INVALID_CONNECTION_HEADERS
        if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
            delete request.headers["host"];
            request.headers[":authority"] = "";
            //non-H2 request and 'host' header is not set, set the 'host' header to request's hostname.
        }
        else if (!request.headers["host"]) {
            request.headers["host"] = request.hostname;
        }
        return [2 /*return*/, next(args)];
    });
}); }; }; };
var hostHeaderMiddlewareOptions = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: ["HOST"],
    override: true,
};
var getHostHeaderPlugin = function (options) { return ({
    applyToStack: function (clientStack) {
        clientStack.add(hostHeaderMiddleware(options), hostHeaderMiddlewareOptions);
    },
}); };
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__loggerMiddleware__ = __webpack_require__(1705);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__loggerMiddleware__["a"]; });

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyxvQkFBb0IsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gXCIuL2xvZ2dlck1pZGRsZXdhcmVcIjtcbiJdfQ==

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_MAX_ATTEMPTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_RETRY_MODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return StandardRetryStrategy; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_sdk_service_error_classification__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid__ = __webpack_require__(1710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__constants__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultRetryQuota__ = __webpack_require__(1707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__delayDecider__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__retryDecider__ = __webpack_require__(857);








/**
 * The default value for how many HTTP requests an SDK should make for a
 * single SDK operation invocation before giving up
 */
var DEFAULT_MAX_ATTEMPTS = 3;
/**
 * The default retry algorithm to use.
 */
var DEFAULT_RETRY_MODE = "standard";
var StandardRetryStrategy = /** @class */ (function () {
    function StandardRetryStrategy(maxAttemptsProvider, options) {
        var _a, _b, _c;
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = DEFAULT_RETRY_MODE;
        this.retryDecider = (_a = options === null || options === void 0 ? void 0 : options.retryDecider) !== null && _a !== void 0 ? _a : __WEBPACK_IMPORTED_MODULE_7__retryDecider__["a" /* defaultRetryDecider */];
        this.delayDecider = (_b = options === null || options === void 0 ? void 0 : options.delayDecider) !== null && _b !== void 0 ? _b : __WEBPACK_IMPORTED_MODULE_6__delayDecider__["a" /* defaultDelayDecider */];
        this.retryQuota = (_c = options === null || options === void 0 ? void 0 : options.retryQuota) !== null && _c !== void 0 ? _c : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__defaultRetryQuota__["a" /* getDefaultRetryQuota */])(__WEBPACK_IMPORTED_MODULE_4__constants__["b" /* INITIAL_RETRY_TOKENS */]);
    }
    StandardRetryStrategy.prototype.shouldRetry = function (error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    };
    StandardRetryStrategy.prototype.getMaxAttempts = function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var maxAttempts, error_1;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.maxAttemptsProvider()];
                    case 1:
                        maxAttempts = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        maxAttempts = DEFAULT_MAX_ATTEMPTS;
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, maxAttempts];
                }
            });
        });
    };
    StandardRetryStrategy.prototype.retry = function (next, args) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var retryTokenAmount, attempts, totalDelay, maxAttempts, request, _loop_1, this_1, state_1;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        attempts = 0;
                        totalDelay = 0;
                        return [4 /*yield*/, this.getMaxAttempts()];
                    case 1:
                        maxAttempts = _a.sent();
                        request = args.request;
                        if (__WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__["HttpRequest"].isInstance(request)) {
                            request.headers[__WEBPACK_IMPORTED_MODULE_4__constants__["c" /* INVOCATION_ID_HEADER */]] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_uuid__["v4"])();
                        }
                        _loop_1 = function () {
                            var _a, response, output, err_1, delay_1;
                            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _b.trys.push([0, 2, , 5]);
                                        if (__WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__["HttpRequest"].isInstance(request)) {
                                            request.headers[__WEBPACK_IMPORTED_MODULE_4__constants__["d" /* REQUEST_HEADER */]] = "attempt=" + (attempts + 1) + "; max=" + maxAttempts;
                                        }
                                        return [4 /*yield*/, next(args)];
                                    case 1:
                                        _a = _b.sent(), response = _a.response, output = _a.output;
                                        this_1.retryQuota.releaseRetryTokens(retryTokenAmount);
                                        output.$metadata.attempts = attempts + 1;
                                        output.$metadata.totalRetryDelay = totalDelay;
                                        return [2 /*return*/, { value: { response: response, output: output } }];
                                    case 2:
                                        err_1 = _b.sent();
                                        attempts++;
                                        if (!this_1.shouldRetry(err_1, attempts, maxAttempts)) return [3 /*break*/, 4];
                                        retryTokenAmount = this_1.retryQuota.retrieveRetryTokens(err_1);
                                        delay_1 = this_1.delayDecider(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__aws_sdk_service_error_classification__["c" /* isThrottlingError */])(err_1) ? __WEBPACK_IMPORTED_MODULE_4__constants__["e" /* THROTTLING_RETRY_DELAY_BASE */] : __WEBPACK_IMPORTED_MODULE_4__constants__["f" /* DEFAULT_RETRY_DELAY_BASE */], attempts);
                                        totalDelay += delay_1;
                                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, delay_1); })];
                                    case 3:
                                        _b.sent();
                                        return [2 /*return*/, "continue"];
                                    case 4:
                                        if (!err_1.$metadata) {
                                            err_1.$metadata = {};
                                        }
                                        err_1.$metadata.attempts = attempts;
                                        err_1.$metadata.totalRetryDelay = totalDelay;
                                        throw err_1;
                                    case 5: return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        _a.label = 2;
                    case 2:
                        if (false) return [3 /*break*/, 4];
                        return [5 /*yield**/, _loop_1()];
                    case 3:
                        state_1 = _a.sent();
                        if (typeof state_1 === "object")
                            return [2 /*return*/, state_1.value];
                        return [3 /*break*/, 2];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return StandardRetryStrategy;
}());

//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultDelayDecider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(366);

/**
 * Calculate a capped, fully-jittered exponential backoff time.
 */
var defaultDelayDecider = function (delayBase, attempts) {
    return Math.floor(Math.min(__WEBPACK_IMPORTED_MODULE_0__constants__["a" /* MAXIMUM_RETRY_DELAY */], Math.random() * Math.pow(2, attempts) * delayBase));
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVsYXlEZWNpZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2RlbGF5RGVjaWRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsbUJBQW1CLEVBQUUsTUFBTSxhQUFhLENBQUM7QUFFbEQ7O0dBRUc7QUFDSCxNQUFNLENBQUMsSUFBTSxtQkFBbUIsR0FBRyxVQUFDLFNBQWlCLEVBQUUsUUFBZ0I7SUFDckUsT0FBQSxJQUFJLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsbUJBQW1CLEVBQUUsSUFBSSxDQUFDLE1BQU0sRUFBRSxHQUFHLFNBQUEsQ0FBQyxFQUFJLFFBQVEsQ0FBQSxHQUFHLFNBQVMsQ0FBQyxDQUFDO0FBQXBGLENBQW9GLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBNQVhJTVVNX1JFVFJZX0RFTEFZIH0gZnJvbSBcIi4vY29uc3RhbnRzXCI7XG5cbi8qKlxuICogQ2FsY3VsYXRlIGEgY2FwcGVkLCBmdWxseS1qaXR0ZXJlZCBleHBvbmVudGlhbCBiYWNrb2ZmIHRpbWUuXG4gKi9cbmV4cG9ydCBjb25zdCBkZWZhdWx0RGVsYXlEZWNpZGVyID0gKGRlbGF5QmFzZTogbnVtYmVyLCBhdHRlbXB0czogbnVtYmVyKSA9PlxuICBNYXRoLmZsb29yKE1hdGgubWluKE1BWElNVU1fUkVUUllfREVMQVksIE1hdGgucmFuZG9tKCkgKiAyICoqIGF0dGVtcHRzICogZGVsYXlCYXNlKSk7XG4iXX0=

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultRetryDecider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aws_sdk_service_error_classification__ = __webpack_require__(866);

var defaultRetryDecider = function (error) {
    if (!error) {
        return false;
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__aws_sdk_service_error_classification__["a" /* isRetryableByTrait */])(error) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__aws_sdk_service_error_classification__["b" /* isClockSkewError */])(error) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__aws_sdk_service_error_classification__["c" /* isThrottlingError */])(error) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__aws_sdk_service_error_classification__["d" /* isTransientError */])(error);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmV0cnlEZWNpZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3JldHJ5RGVjaWRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQ0wsZ0JBQWdCLEVBQ2hCLGtCQUFrQixFQUNsQixpQkFBaUIsRUFDakIsZ0JBQWdCLEdBQ2pCLE1BQU0sdUNBQXVDLENBQUM7QUFHL0MsTUFBTSxDQUFDLElBQU0sbUJBQW1CLEdBQUcsVUFBQyxLQUFlO0lBQ2pELElBQUksQ0FBQyxLQUFLLEVBQUU7UUFDVixPQUFPLEtBQUssQ0FBQztLQUNkO0lBRUQsT0FBTyxrQkFBa0IsQ0FBQyxLQUFLLENBQUMsSUFBSSxnQkFBZ0IsQ0FBQyxLQUFLLENBQUMsSUFBSSxpQkFBaUIsQ0FBQyxLQUFLLENBQUMsSUFBSSxnQkFBZ0IsQ0FBQyxLQUFLLENBQUMsQ0FBQztBQUNySCxDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQge1xuICBpc0Nsb2NrU2tld0Vycm9yLFxuICBpc1JldHJ5YWJsZUJ5VHJhaXQsXG4gIGlzVGhyb3R0bGluZ0Vycm9yLFxuICBpc1RyYW5zaWVudEVycm9yLFxufSBmcm9tIFwiQGF3cy1zZGsvc2VydmljZS1lcnJvci1jbGFzc2lmaWNhdGlvblwiO1xuaW1wb3J0IHsgU2RrRXJyb3IgfSBmcm9tIFwiQGF3cy1zZGsvc21pdGh5LWNsaWVudFwiO1xuXG5leHBvcnQgY29uc3QgZGVmYXVsdFJldHJ5RGVjaWRlciA9IChlcnJvcjogU2RrRXJyb3IpID0+IHtcbiAgaWYgKCFlcnJvcikge1xuICAgIHJldHVybiBmYWxzZTtcbiAgfVxuXG4gIHJldHVybiBpc1JldHJ5YWJsZUJ5VHJhaXQoZXJyb3IpIHx8IGlzQ2xvY2tTa2V3RXJyb3IoZXJyb3IpIHx8IGlzVGhyb3R0bGluZ0Vycm9yKGVycm9yKSB8fCBpc1RyYW5zaWVudEVycm9yKGVycm9yKTtcbn07XG4iXX0=

/***/ }),
/* 858 */
/***/ (function(module, exports) {

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
  return ([
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]], '-',
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]],
    bth[buf[i++]], bth[buf[i++]]
  ]).join('');
}

module.exports = bytesToUuid;


/***/ }),
/* 859 */
/***/ (function(module, exports) {

// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto));

if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}


/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return deserializerMiddleware; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);

var deserializerMiddleware = function (options, deserializer) { return function (next, context) { return function (args) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(void 0, void 0, void 0, function () {
    var response, parsed;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, next(args)];
            case 1:
                response = (_a.sent()).response;
                return [4 /*yield*/, deserializer(response, options)];
            case 2:
                parsed = _a.sent();
                return [2 /*return*/, {
                        response: response,
                        output: parsed,
                    }];
        }
    });
}); }; }; };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVzZXJpYWxpemVyTWlkZGxld2FyZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kZXNlcmlhbGl6ZXJNaWRkbGV3YXJlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFTQSxNQUFNLENBQUMsSUFBTSxzQkFBc0IsR0FBRyxVQUNwQyxPQUFxQixFQUNyQixZQUEwRCxJQUNqQixPQUFBLFVBQ3pDLElBQXVDLEVBQ3ZDLE9BQWdDLElBQ00sT0FBQSxVQUN0QyxJQUF3Qzs7OztvQkFFbkIscUJBQU0sSUFBSSxDQUFDLElBQUksQ0FBQyxFQUFBOztnQkFBN0IsUUFBUSxHQUFLLENBQUEsU0FBZ0IsQ0FBQSxTQUFyQjtnQkFDRCxxQkFBTSxZQUFZLENBQUMsUUFBUSxFQUFFLE9BQU8sQ0FBQyxFQUFBOztnQkFBOUMsTUFBTSxHQUFHLFNBQXFDO2dCQUNwRCxzQkFBTzt3QkFDTCxRQUFRLFVBQUE7d0JBQ1IsTUFBTSxFQUFFLE1BQWdCO3FCQUN6QixFQUFDOzs7S0FDSCxFQVR1QyxDQVN2QyxFQVowQyxDQVkxQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtcbiAgRGVzZXJpYWxpemVIYW5kbGVyLFxuICBEZXNlcmlhbGl6ZUhhbmRsZXJBcmd1bWVudHMsXG4gIERlc2VyaWFsaXplSGFuZGxlck91dHB1dCxcbiAgRGVzZXJpYWxpemVNaWRkbGV3YXJlLFxuICBIYW5kbGVyRXhlY3V0aW9uQ29udGV4dCxcbiAgUmVzcG9uc2VEZXNlcmlhbGl6ZXIsXG59IGZyb20gXCJAYXdzLXNkay90eXBlc1wiO1xuXG5leHBvcnQgY29uc3QgZGVzZXJpYWxpemVyTWlkZGxld2FyZSA9IDxJbnB1dCBleHRlbmRzIG9iamVjdCwgT3V0cHV0IGV4dGVuZHMgb2JqZWN0LCBSdW50aW1lVXRpbHMgPSBhbnk+KFxuICBvcHRpb25zOiBSdW50aW1lVXRpbHMsXG4gIGRlc2VyaWFsaXplcjogUmVzcG9uc2VEZXNlcmlhbGl6ZXI8YW55LCBhbnksIFJ1bnRpbWVVdGlscz5cbik6IERlc2VyaWFsaXplTWlkZGxld2FyZTxJbnB1dCwgT3V0cHV0PiA9PiAoXG4gIG5leHQ6IERlc2VyaWFsaXplSGFuZGxlcjxJbnB1dCwgT3V0cHV0PixcbiAgY29udGV4dDogSGFuZGxlckV4ZWN1dGlvbkNvbnRleHRcbik6IERlc2VyaWFsaXplSGFuZGxlcjxJbnB1dCwgT3V0cHV0PiA9PiBhc3luYyAoXG4gIGFyZ3M6IERlc2VyaWFsaXplSGFuZGxlckFyZ3VtZW50czxJbnB1dD5cbik6IFByb21pc2U8RGVzZXJpYWxpemVIYW5kbGVyT3V0cHV0PE91dHB1dD4+ID0+IHtcbiAgY29uc3QgeyByZXNwb25zZSB9ID0gYXdhaXQgbmV4dChhcmdzKTtcbiAgY29uc3QgcGFyc2VkID0gYXdhaXQgZGVzZXJpYWxpemVyKHJlc3BvbnNlLCBvcHRpb25zKTtcbiAgcmV0dXJuIHtcbiAgICByZXNwb25zZSxcbiAgICBvdXRwdXQ6IHBhcnNlZCBhcyBPdXRwdXQsXG4gIH07XG59O1xuIl19

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serializerMiddleware; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);

var serializerMiddleware = function (options, serializer) { return function (next, context) { return function (args) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(void 0, void 0, void 0, function () {
    var request;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, serializer(args.input, options)];
            case 1:
                request = _a.sent();
                return [2 /*return*/, next(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, args), { request: request }))];
        }
    });
}); }; }; };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VyaWFsaXplck1pZGRsZXdhcmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvc2VyaWFsaXplck1pZGRsZXdhcmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQVVBLE1BQU0sQ0FBQyxJQUFNLG9CQUFvQixHQUFHLFVBQ2xDLE9BQXFCLEVBQ3JCLFVBQWdELElBQ1QsT0FBQSxVQUN2QyxJQUFxQyxFQUNyQyxPQUFnQyxJQUNJLE9BQUEsVUFDcEMsSUFBc0M7Ozs7b0JBRXRCLHFCQUFNLFVBQVUsQ0FBQyxJQUFJLENBQUMsS0FBSyxFQUFFLE9BQU8sQ0FBQyxFQUFBOztnQkFBL0MsT0FBTyxHQUFHLFNBQXFDO2dCQUNyRCxzQkFBTyxJQUFJLHVCQUNOLElBQUksS0FDUCxPQUFPLFNBQUEsSUFDUCxFQUFDOzs7S0FDSixFQVJxQyxDQVFyQyxFQVh3QyxDQVd4QyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtcbiAgRW5kcG9pbnRCZWFyZXIsXG4gIEhhbmRsZXJFeGVjdXRpb25Db250ZXh0LFxuICBSZXF1ZXN0U2VyaWFsaXplcixcbiAgU2VyaWFsaXplSGFuZGxlcixcbiAgU2VyaWFsaXplSGFuZGxlckFyZ3VtZW50cyxcbiAgU2VyaWFsaXplSGFuZGxlck91dHB1dCxcbiAgU2VyaWFsaXplTWlkZGxld2FyZSxcbn0gZnJvbSBcIkBhd3Mtc2RrL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCBzZXJpYWxpemVyTWlkZGxld2FyZSA9IDxJbnB1dCBleHRlbmRzIG9iamVjdCwgT3V0cHV0IGV4dGVuZHMgb2JqZWN0LCBSdW50aW1lVXRpbHMgZXh0ZW5kcyBFbmRwb2ludEJlYXJlcj4oXG4gIG9wdGlvbnM6IFJ1bnRpbWVVdGlscyxcbiAgc2VyaWFsaXplcjogUmVxdWVzdFNlcmlhbGl6ZXI8YW55LCBSdW50aW1lVXRpbHM+XG4pOiBTZXJpYWxpemVNaWRkbGV3YXJlPElucHV0LCBPdXRwdXQ+ID0+IChcbiAgbmV4dDogU2VyaWFsaXplSGFuZGxlcjxJbnB1dCwgT3V0cHV0PixcbiAgY29udGV4dDogSGFuZGxlckV4ZWN1dGlvbkNvbnRleHRcbik6IFNlcmlhbGl6ZUhhbmRsZXI8SW5wdXQsIE91dHB1dD4gPT4gYXN5bmMgKFxuICBhcmdzOiBTZXJpYWxpemVIYW5kbGVyQXJndW1lbnRzPElucHV0PlxuKTogUHJvbWlzZTxTZXJpYWxpemVIYW5kbGVyT3V0cHV0PE91dHB1dD4+ID0+IHtcbiAgY29uc3QgcmVxdWVzdCA9IGF3YWl0IHNlcmlhbGl6ZXIoYXJncy5pbnB1dCwgb3B0aW9ucyk7XG4gIHJldHVybiBuZXh0KHtcbiAgICAuLi5hcmdzLFxuICAgIHJlcXVlc3QsXG4gIH0pO1xufTtcbiJdfQ==

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MiddlewareStack__ = __webpack_require__(1716);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MiddlewareStack__["a"]; });

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyxtQkFBbUIsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gXCIuL01pZGRsZXdhcmVTdGFja1wiO1xuIl19

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__configurations__ = __webpack_require__(1717);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__configurations__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__user_agent_middleware__ = __webpack_require__(1719);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__user_agent_middleware__["a"]; });


//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyxrQkFBa0IsQ0FBQztBQUNqQyxjQUFjLHlCQUF5QixDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0ICogZnJvbSBcIi4vY29uZmlndXJhdGlvbnNcIjtcbmV4cG9ydCAqIGZyb20gXCIuL3VzZXItYWdlbnQtbWlkZGxld2FyZVwiO1xuIl19

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProviderError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);

/**
 * An error representing a failure of an individual credential provider.
 *
 * This error class has special meaning to the {@link chain} method. If a
 * provider in the chain is rejected with an error, the chain will only proceed
 * to the next provider if the value of the `tryNextLink` property on the error
 * is truthy. This allows individual providers to halt the chain and also
 * ensures the chain will stop if an entirely unexpected error is encountered.
 */
var ProviderError = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(ProviderError, _super);
    function ProviderError(message, tryNextLink) {
        if (tryNextLink === void 0) { tryNextLink = true; }
        var _this = _super.call(this, message) || this;
        _this.tryNextLink = tryNextLink;
        return _this;
    }
    return ProviderError;
}(Error));

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUHJvdmlkZXJFcnJvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Qcm92aWRlckVycm9yLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7Ozs7R0FRRztBQUNIO0lBQW1DLGlDQUFLO0lBQ3RDLHVCQUFZLE9BQWUsRUFBa0IsV0FBMkI7UUFBM0IsNEJBQUEsRUFBQSxrQkFBMkI7UUFBeEUsWUFDRSxrQkFBTSxPQUFPLENBQUMsU0FDZjtRQUY0QyxpQkFBVyxHQUFYLFdBQVcsQ0FBZ0I7O0lBRXhFLENBQUM7SUFDSCxvQkFBQztBQUFELENBQUMsQUFKRCxDQUFtQyxLQUFLLEdBSXZDIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBBbiBlcnJvciByZXByZXNlbnRpbmcgYSBmYWlsdXJlIG9mIGFuIGluZGl2aWR1YWwgY3JlZGVudGlhbCBwcm92aWRlci5cbiAqXG4gKiBUaGlzIGVycm9yIGNsYXNzIGhhcyBzcGVjaWFsIG1lYW5pbmcgdG8gdGhlIHtAbGluayBjaGFpbn0gbWV0aG9kLiBJZiBhXG4gKiBwcm92aWRlciBpbiB0aGUgY2hhaW4gaXMgcmVqZWN0ZWQgd2l0aCBhbiBlcnJvciwgdGhlIGNoYWluIHdpbGwgb25seSBwcm9jZWVkXG4gKiB0byB0aGUgbmV4dCBwcm92aWRlciBpZiB0aGUgdmFsdWUgb2YgdGhlIGB0cnlOZXh0TGlua2AgcHJvcGVydHkgb24gdGhlIGVycm9yXG4gKiBpcyB0cnV0aHkuIFRoaXMgYWxsb3dzIGluZGl2aWR1YWwgcHJvdmlkZXJzIHRvIGhhbHQgdGhlIGNoYWluIGFuZCBhbHNvXG4gKiBlbnN1cmVzIHRoZSBjaGFpbiB3aWxsIHN0b3AgaWYgYW4gZW50aXJlbHkgdW5leHBlY3RlZCBlcnJvciBpcyBlbmNvdW50ZXJlZC5cbiAqL1xuZXhwb3J0IGNsYXNzIFByb3ZpZGVyRXJyb3IgZXh0ZW5kcyBFcnJvciB7XG4gIGNvbnN0cnVjdG9yKG1lc3NhZ2U6IHN0cmluZywgcHVibGljIHJlYWRvbmx5IHRyeU5leHRMaW5rOiBib29sZWFuID0gdHJ1ZSkge1xuICAgIHN1cGVyKG1lc3NhZ2UpO1xuICB9XG59XG4iXX0=

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chain__ = __webpack_require__(1720);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fromStatic__ = __webpack_require__(1721);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__memoize__ = __webpack_require__(1722);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProviderError__ = __webpack_require__(864);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__ProviderError__["a"]; });




//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyxTQUFTLENBQUM7QUFDeEIsY0FBYyxjQUFjLENBQUM7QUFDN0IsY0FBYyxXQUFXLENBQUM7QUFDMUIsY0FBYyxpQkFBaUIsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gXCIuL2NoYWluXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9mcm9tU3RhdGljXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9tZW1vaXplXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9Qcm92aWRlckVycm9yXCI7XG4iXX0=

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isRetryableByTrait; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isClockSkewError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isThrottlingError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isTransientError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(1729);

var isRetryableByTrait = function (error) { return error.$retryable !== undefined; };
var isClockSkewError = function (error) { return __WEBPACK_IMPORTED_MODULE_0__constants__["a" /* CLOCK_SKEW_ERROR_CODES */].includes(error.name); };
var isThrottlingError = function (error) {
    var _a, _b;
    return ((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) === 429 ||
        __WEBPACK_IMPORTED_MODULE_0__constants__["b" /* THROTTLING_ERROR_CODES */].includes(error.name) ||
        ((_b = error.$retryable) === null || _b === void 0 ? void 0 : _b.throttling) == true;
};
var isTransientError = function (error) {
    var _a;
    return __WEBPACK_IMPORTED_MODULE_0__constants__["c" /* TRANSIENT_ERROR_CODES */].includes(error.name) ||
        __WEBPACK_IMPORTED_MODULE_0__constants__["d" /* TRANSIENT_ERROR_STATUS_CODES */].includes(((_a = error.$metadata) === null || _a === void 0 ? void 0 : _a.httpStatusCode) || 0);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRUEsT0FBTyxFQUNMLHNCQUFzQixFQUN0QixzQkFBc0IsRUFDdEIscUJBQXFCLEVBQ3JCLDRCQUE0QixHQUM3QixNQUFNLGFBQWEsQ0FBQztBQUVyQixNQUFNLENBQUMsSUFBTSxrQkFBa0IsR0FBRyxVQUFDLEtBQWUsSUFBSyxPQUFBLEtBQUssQ0FBQyxVQUFVLEtBQUssU0FBUyxFQUE5QixDQUE4QixDQUFDO0FBRXRGLE1BQU0sQ0FBQyxJQUFNLGdCQUFnQixHQUFHLFVBQUMsS0FBZSxJQUFLLE9BQUEsc0JBQXNCLENBQUMsUUFBUSxDQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsRUFBM0MsQ0FBMkMsQ0FBQztBQUVqRyxNQUFNLENBQUMsSUFBTSxpQkFBaUIsR0FBRyxVQUFDLEtBQWU7O0lBQy9DLE9BQUEsT0FBQSxLQUFLLENBQUMsU0FBUywwQ0FBRSxjQUFjLE1BQUssR0FBRztRQUN2QyxzQkFBc0IsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQztRQUMzQyxPQUFBLEtBQUssQ0FBQyxVQUFVLDBDQUFFLFVBQVUsS0FBSSxJQUFJLENBQUE7Q0FBQSxDQUFDO0FBRXZDLE1BQU0sQ0FBQyxJQUFNLGdCQUFnQixHQUFHLFVBQUMsS0FBZTs7SUFDOUMsT0FBQSxxQkFBcUIsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDLElBQUksQ0FBQztRQUMxQyw0QkFBNEIsQ0FBQyxRQUFRLENBQUMsT0FBQSxLQUFLLENBQUMsU0FBUywwQ0FBRSxjQUFjLEtBQUksQ0FBQyxDQUFDLENBQUE7Q0FBQSxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgU2RrRXJyb3IgfSBmcm9tIFwiQGF3cy1zZGsvc21pdGh5LWNsaWVudFwiO1xuXG5pbXBvcnQge1xuICBDTE9DS19TS0VXX0VSUk9SX0NPREVTLFxuICBUSFJPVFRMSU5HX0VSUk9SX0NPREVTLFxuICBUUkFOU0lFTlRfRVJST1JfQ09ERVMsXG4gIFRSQU5TSUVOVF9FUlJPUl9TVEFUVVNfQ09ERVMsXG59IGZyb20gXCIuL2NvbnN0YW50c1wiO1xuXG5leHBvcnQgY29uc3QgaXNSZXRyeWFibGVCeVRyYWl0ID0gKGVycm9yOiBTZGtFcnJvcikgPT4gZXJyb3IuJHJldHJ5YWJsZSAhPT0gdW5kZWZpbmVkO1xuXG5leHBvcnQgY29uc3QgaXNDbG9ja1NrZXdFcnJvciA9IChlcnJvcjogU2RrRXJyb3IpID0+IENMT0NLX1NLRVdfRVJST1JfQ09ERVMuaW5jbHVkZXMoZXJyb3IubmFtZSk7XG5cbmV4cG9ydCBjb25zdCBpc1Rocm90dGxpbmdFcnJvciA9IChlcnJvcjogU2RrRXJyb3IpID0+XG4gIGVycm9yLiRtZXRhZGF0YT8uaHR0cFN0YXR1c0NvZGUgPT09IDQyOSB8fFxuICBUSFJPVFRMSU5HX0VSUk9SX0NPREVTLmluY2x1ZGVzKGVycm9yLm5hbWUpIHx8XG4gIGVycm9yLiRyZXRyeWFibGU/LnRocm90dGxpbmcgPT0gdHJ1ZTtcblxuZXhwb3J0IGNvbnN0IGlzVHJhbnNpZW50RXJyb3IgPSAoZXJyb3I6IFNka0Vycm9yKSA9PlxuICBUUkFOU0lFTlRfRVJST1JfQ09ERVMuaW5jbHVkZXMoZXJyb3IubmFtZSkgfHxcbiAgVFJBTlNJRU5UX0VSUk9SX1NUQVRVU19DT0RFUy5pbmNsdWRlcyhlcnJvci4kbWV0YWRhdGE/Lmh0dHBTdGF0dXNDb2RlIHx8IDApO1xuIl19

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = cloneRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);

/**
 * @internal
 */
function cloneRequest(_a) {
    var headers = _a.headers, query = _a.query, rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"])(_a, ["headers", "query"]);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, rest), { headers: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, headers), query: query ? cloneQuery(query) : undefined });
}
function cloneQuery(query) {
    return Object.keys(query).reduce(function (carry, paramName) {
        var _a;
        var param = query[paramName];
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(param) : param, _a));
    }, {});
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY2xvbmVSZXF1ZXN0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2Nsb25lUmVxdWVzdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBRUE7O0dBRUc7QUFDSCxNQUFNLFVBQVUsWUFBWSxDQUFDLEVBQXdDO0lBQXRDLElBQUEsT0FBTyxhQUFBLEVBQUUsS0FBSyxXQUFBLEVBQUssSUFBSSxjQUF6QixvQkFBMkIsQ0FBRjtJQUNwRCw2QkFDSyxJQUFJLEtBQ1AsT0FBTyxlQUFPLE9BQU8sR0FDckIsS0FBSyxFQUFFLEtBQUssQ0FBQyxDQUFDLENBQUMsVUFBVSxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxTQUFTLElBQzVDO0FBQ0osQ0FBQztBQUVELFNBQVMsVUFBVSxDQUFDLEtBQXdCO0lBQzFDLE9BQU8sTUFBTSxDQUFDLElBQUksQ0FBQyxLQUFLLENBQUMsQ0FBQyxNQUFNLENBQUMsVUFBQyxLQUF3QixFQUFFLFNBQWlCOztRQUMzRSxJQUFNLEtBQUssR0FBRyxLQUFLLENBQUMsU0FBUyxDQUFDLENBQUM7UUFDL0IsNkJBQ0ssS0FBSyxnQkFDUCxTQUFTLElBQUcsS0FBSyxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLFVBQUssS0FBSyxFQUFFLENBQUMsQ0FBQyxLQUFLLE9BQ3REO0lBQ0osQ0FBQyxFQUFFLEVBQUUsQ0FBQyxDQUFDO0FBQ1QsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEh0dHBSZXF1ZXN0LCBRdWVyeVBhcmFtZXRlckJhZyB9IGZyb20gXCJAYXdzLXNkay90eXBlc1wiO1xuXG4vKipcbiAqIEBpbnRlcm5hbFxuICovXG5leHBvcnQgZnVuY3Rpb24gY2xvbmVSZXF1ZXN0KHsgaGVhZGVycywgcXVlcnksIC4uLnJlc3QgfTogSHR0cFJlcXVlc3QpOiBIdHRwUmVxdWVzdCB7XG4gIHJldHVybiB7XG4gICAgLi4ucmVzdCxcbiAgICBoZWFkZXJzOiB7IC4uLmhlYWRlcnMgfSxcbiAgICBxdWVyeTogcXVlcnkgPyBjbG9uZVF1ZXJ5KHF1ZXJ5KSA6IHVuZGVmaW5lZCxcbiAgfTtcbn1cblxuZnVuY3Rpb24gY2xvbmVRdWVyeShxdWVyeTogUXVlcnlQYXJhbWV0ZXJCYWcpOiBRdWVyeVBhcmFtZXRlckJhZyB7XG4gIHJldHVybiBPYmplY3Qua2V5cyhxdWVyeSkucmVkdWNlKChjYXJyeTogUXVlcnlQYXJhbWV0ZXJCYWcsIHBhcmFtTmFtZTogc3RyaW5nKSA9PiB7XG4gICAgY29uc3QgcGFyYW0gPSBxdWVyeVtwYXJhbU5hbWVdO1xuICAgIHJldHVybiB7XG4gICAgICAuLi5jYXJyeSxcbiAgICAgIFtwYXJhbU5hbWVdOiBBcnJheS5pc0FycmF5KHBhcmFtKSA/IFsuLi5wYXJhbV0gOiBwYXJhbSxcbiAgICB9O1xuICB9LCB7fSk7XG59XG4iXX0=

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createScope;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSigningKey; });
/* unused harmony export clearCredentialCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_util_hex_encoding__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(254);



var signingKeyCache = {};
var cacheQueue = [];
/**
 * Create a string describing the scope of credentials used to sign a request.
 *
 * @param shortDate The current calendar date in the form YYYYMMDD.
 * @param region    The AWS region in which the service resides.
 * @param service   The service to which the signed request is being sent.
 */
function createScope(shortDate, region, service) {
    return shortDate + "/" + region + "/" + service + "/" + __WEBPACK_IMPORTED_MODULE_2__constants__["o" /* KEY_TYPE_IDENTIFIER */];
}
/**
 * Derive a signing key from its composite parts
 *
 * @param sha256Constructor A constructor function that can instantiate SHA-256
 *                          hash objects.
 * @param credentials       The credentials with which the request will be
 *                          signed.
 * @param shortDate         The current calendar date in the form YYYYMMDD.
 * @param region            The AWS region in which the service resides.
 * @param service           The service to which the signed request is being
 *                          sent.
 */
var getSigningKey = function (sha256Constructor, credentials, shortDate, region, service) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(void 0, void 0, void 0, function () {
    var credsHash, cacheKey, key, _a, _b, signable, e_1_1;
    var e_1, _c;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_d) {
        switch (_d.label) {
            case 0: return [4 /*yield*/, hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId)];
            case 1:
                credsHash = _d.sent();
                cacheKey = shortDate + ":" + region + ":" + service + ":" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__aws_sdk_util_hex_encoding__["a" /* toHex */])(credsHash) + ":" + credentials.sessionToken;
                if (cacheKey in signingKeyCache) {
                    return [2 /*return*/, signingKeyCache[cacheKey]];
                }
                cacheQueue.push(cacheKey);
                while (cacheQueue.length > __WEBPACK_IMPORTED_MODULE_2__constants__["p" /* MAX_CACHE_SIZE */]) {
                    delete signingKeyCache[cacheQueue.shift()];
                }
                key = "AWS4" + credentials.secretAccessKey;
                _d.label = 2;
            case 2:
                _d.trys.push([2, 7, 8, 9]);
                _a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])([shortDate, region, service, __WEBPACK_IMPORTED_MODULE_2__constants__["o" /* KEY_TYPE_IDENTIFIER */]]), _b = _a.next();
                _d.label = 3;
            case 3:
                if (!!_b.done) return [3 /*break*/, 6];
                signable = _b.value;
                return [4 /*yield*/, hmac(sha256Constructor, key, signable)];
            case 4:
                key = _d.sent();
                _d.label = 5;
            case 5:
                _b = _a.next();
                return [3 /*break*/, 3];
            case 6: return [3 /*break*/, 9];
            case 7:
                e_1_1 = _d.sent();
                e_1 = { error: e_1_1 };
                return [3 /*break*/, 9];
            case 8:
                try {
                    if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                }
                finally { if (e_1) throw e_1.error; }
                return [7 /*endfinally*/];
            case 9: return [2 /*return*/, (signingKeyCache[cacheKey] = key)];
        }
    });
}); };
/**
 * @internal
 */
function clearCredentialCache() {
    cacheQueue.length = 0;
    Object.keys(signingKeyCache).forEach(function (cacheKey) {
        delete signingKeyCache[cacheKey];
    });
}
function hmac(ctor, secret, data) {
    var hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3JlZGVudGlhbERlcml2YXRpb24uanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY3JlZGVudGlhbERlcml2YXRpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUNBLE9BQU8sRUFBRSxLQUFLLEVBQUUsTUFBTSw0QkFBNEIsQ0FBQztBQUVuRCxPQUFPLEVBQUUsbUJBQW1CLEVBQUUsY0FBYyxFQUFFLE1BQU0sYUFBYSxDQUFDO0FBRWxFLElBQU0sZUFBZSxHQUFrQyxFQUFFLENBQUM7QUFDMUQsSUFBTSxVQUFVLEdBQWtCLEVBQUUsQ0FBQztBQUVyQzs7Ozs7O0dBTUc7QUFDSCxNQUFNLFVBQVUsV0FBVyxDQUFDLFNBQWlCLEVBQUUsTUFBYyxFQUFFLE9BQWU7SUFDNUUsT0FBVSxTQUFTLFNBQUksTUFBTSxTQUFJLE9BQU8sU0FBSSxtQkFBcUIsQ0FBQztBQUNwRSxDQUFDO0FBRUQ7Ozs7Ozs7Ozs7O0dBV0c7QUFDSCxNQUFNLENBQUMsSUFBTSxhQUFhLEdBQUcsVUFDM0IsaUJBQWtDLEVBQ2xDLFdBQXdCLEVBQ3hCLFNBQWlCLEVBQ2pCLE1BQWMsRUFDZCxPQUFlOzs7OztvQkFFRyxxQkFBTSxJQUFJLENBQUMsaUJBQWlCLEVBQUUsV0FBVyxDQUFDLGVBQWUsRUFBRSxXQUFXLENBQUMsV0FBVyxDQUFDLEVBQUE7O2dCQUEvRixTQUFTLEdBQUcsU0FBbUY7Z0JBQy9GLFFBQVEsR0FBTSxTQUFTLFNBQUksTUFBTSxTQUFJLE9BQU8sU0FBSSxLQUFLLENBQUMsU0FBUyxDQUFDLFNBQUksV0FBVyxDQUFDLFlBQWMsQ0FBQztnQkFDckcsSUFBSSxRQUFRLElBQUksZUFBZSxFQUFFO29CQUMvQixzQkFBTyxlQUFlLENBQUMsUUFBUSxDQUFDLEVBQUM7aUJBQ2xDO2dCQUVELFVBQVUsQ0FBQyxJQUFJLENBQUMsUUFBUSxDQUFDLENBQUM7Z0JBQzFCLE9BQU8sVUFBVSxDQUFDLE1BQU0sR0FBRyxjQUFjLEVBQUU7b0JBQ3pDLE9BQU8sZUFBZSxDQUFDLFVBQVUsQ0FBQyxLQUFLLEVBQVksQ0FBQyxDQUFDO2lCQUN0RDtnQkFFRyxHQUFHLEdBQWUsU0FBTyxXQUFXLENBQUMsZUFBaUIsQ0FBQzs7OztnQkFDcEMsS0FBQSxTQUFBLENBQUMsU0FBUyxFQUFFLE1BQU0sRUFBRSxPQUFPLEVBQUUsbUJBQW1CLENBQUMsQ0FBQTs7OztnQkFBN0QsUUFBUTtnQkFDWCxxQkFBTSxJQUFJLENBQUMsaUJBQWlCLEVBQUUsR0FBRyxFQUFFLFFBQVEsQ0FBQyxFQUFBOztnQkFBbEQsR0FBRyxHQUFHLFNBQTRDLENBQUM7Ozs7Ozs7Ozs7Ozs7Ozs7b0JBRXJELHNCQUFPLENBQUMsZUFBZSxDQUFDLFFBQVEsQ0FBQyxHQUFHLEdBQWlCLENBQUMsRUFBQzs7O0tBQ3hELENBQUM7QUFFRjs7R0FFRztBQUNILE1BQU0sVUFBVSxvQkFBb0I7SUFDbEMsVUFBVSxDQUFDLE1BQU0sR0FBRyxDQUFDLENBQUM7SUFDdEIsTUFBTSxDQUFDLElBQUksQ0FBQyxlQUFlLENBQUMsQ0FBQyxPQUFPLENBQUMsVUFBQyxRQUFRO1FBQzVDLE9BQU8sZUFBZSxDQUFDLFFBQVEsQ0FBQyxDQUFDO0lBQ25DLENBQUMsQ0FBQyxDQUFDO0FBQ0wsQ0FBQztBQUVELFNBQVMsSUFBSSxDQUFDLElBQXFCLEVBQUUsTUFBa0IsRUFBRSxJQUFnQjtJQUN2RSxJQUFNLElBQUksR0FBRyxJQUFJLElBQUksQ0FBQyxNQUFNLENBQUMsQ0FBQztJQUM5QixJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDO0lBQ2xCLE9BQU8sSUFBSSxDQUFDLE1BQU0sRUFBRSxDQUFDO0FBQ3ZCLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBDcmVkZW50aWFscywgSGFzaENvbnN0cnVjdG9yLCBTb3VyY2VEYXRhIH0gZnJvbSBcIkBhd3Mtc2RrL3R5cGVzXCI7XG5pbXBvcnQgeyB0b0hleCB9IGZyb20gXCJAYXdzLXNkay91dGlsLWhleC1lbmNvZGluZ1wiO1xuXG5pbXBvcnQgeyBLRVlfVFlQRV9JREVOVElGSUVSLCBNQVhfQ0FDSEVfU0laRSB9IGZyb20gXCIuL2NvbnN0YW50c1wiO1xuXG5jb25zdCBzaWduaW5nS2V5Q2FjaGU6IHsgW2tleTogc3RyaW5nXTogVWludDhBcnJheSB9ID0ge307XG5jb25zdCBjYWNoZVF1ZXVlOiBBcnJheTxzdHJpbmc+ID0gW107XG5cbi8qKlxuICogQ3JlYXRlIGEgc3RyaW5nIGRlc2NyaWJpbmcgdGhlIHNjb3BlIG9mIGNyZWRlbnRpYWxzIHVzZWQgdG8gc2lnbiBhIHJlcXVlc3QuXG4gKlxuICogQHBhcmFtIHNob3J0RGF0ZSBUaGUgY3VycmVudCBjYWxlbmRhciBkYXRlIGluIHRoZSBmb3JtIFlZWVlNTURELlxuICogQHBhcmFtIHJlZ2lvbiAgICBUaGUgQVdTIHJlZ2lvbiBpbiB3aGljaCB0aGUgc2VydmljZSByZXNpZGVzLlxuICogQHBhcmFtIHNlcnZpY2UgICBUaGUgc2VydmljZSB0byB3aGljaCB0aGUgc2lnbmVkIHJlcXVlc3QgaXMgYmVpbmcgc2VudC5cbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIGNyZWF0ZVNjb3BlKHNob3J0RGF0ZTogc3RyaW5nLCByZWdpb246IHN0cmluZywgc2VydmljZTogc3RyaW5nKTogc3RyaW5nIHtcbiAgcmV0dXJuIGAke3Nob3J0RGF0ZX0vJHtyZWdpb259LyR7c2VydmljZX0vJHtLRVlfVFlQRV9JREVOVElGSUVSfWA7XG59XG5cbi8qKlxuICogRGVyaXZlIGEgc2lnbmluZyBrZXkgZnJvbSBpdHMgY29tcG9zaXRlIHBhcnRzXG4gKlxuICogQHBhcmFtIHNoYTI1NkNvbnN0cnVjdG9yIEEgY29uc3RydWN0b3IgZnVuY3Rpb24gdGhhdCBjYW4gaW5zdGFudGlhdGUgU0hBLTI1NlxuICogICAgICAgICAgICAgICAgICAgICAgICAgIGhhc2ggb2JqZWN0cy5cbiAqIEBwYXJhbSBjcmVkZW50aWFscyAgICAgICBUaGUgY3JlZGVudGlhbHMgd2l0aCB3aGljaCB0aGUgcmVxdWVzdCB3aWxsIGJlXG4gKiAgICAgICAgICAgICAgICAgICAgICAgICAgc2lnbmVkLlxuICogQHBhcmFtIHNob3J0RGF0ZSAgICAgICAgIFRoZSBjdXJyZW50IGNhbGVuZGFyIGRhdGUgaW4gdGhlIGZvcm0gWVlZWU1NREQuXG4gKiBAcGFyYW0gcmVnaW9uICAgICAgICAgICAgVGhlIEFXUyByZWdpb24gaW4gd2hpY2ggdGhlIHNlcnZpY2UgcmVzaWRlcy5cbiAqIEBwYXJhbSBzZXJ2aWNlICAgICAgICAgICBUaGUgc2VydmljZSB0byB3aGljaCB0aGUgc2lnbmVkIHJlcXVlc3QgaXMgYmVpbmdcbiAqICAgICAgICAgICAgICAgICAgICAgICAgICBzZW50LlxuICovXG5leHBvcnQgY29uc3QgZ2V0U2lnbmluZ0tleSA9IGFzeW5jIChcbiAgc2hhMjU2Q29uc3RydWN0b3I6IEhhc2hDb25zdHJ1Y3RvcixcbiAgY3JlZGVudGlhbHM6IENyZWRlbnRpYWxzLFxuICBzaG9ydERhdGU6IHN0cmluZyxcbiAgcmVnaW9uOiBzdHJpbmcsXG4gIHNlcnZpY2U6IHN0cmluZ1xuKTogUHJvbWlzZTxVaW50OEFycmF5PiA9PiB7XG4gIGNvbnN0IGNyZWRzSGFzaCA9IGF3YWl0IGhtYWMoc2hhMjU2Q29uc3RydWN0b3IsIGNyZWRlbnRpYWxzLnNlY3JldEFjY2Vzc0tleSwgY3JlZGVudGlhbHMuYWNjZXNzS2V5SWQpO1xuICBjb25zdCBjYWNoZUtleSA9IGAke3Nob3J0RGF0ZX06JHtyZWdpb259OiR7c2VydmljZX06JHt0b0hleChjcmVkc0hhc2gpfToke2NyZWRlbnRpYWxzLnNlc3Npb25Ub2tlbn1gO1xuICBpZiAoY2FjaGVLZXkgaW4gc2lnbmluZ0tleUNhY2hlKSB7XG4gICAgcmV0dXJuIHNpZ25pbmdLZXlDYWNoZVtjYWNoZUtleV07XG4gIH1cblxuICBjYWNoZVF1ZXVlLnB1c2goY2FjaGVLZXkpO1xuICB3aGlsZSAoY2FjaGVRdWV1ZS5sZW5ndGggPiBNQVhfQ0FDSEVfU0laRSkge1xuICAgIGRlbGV0ZSBzaWduaW5nS2V5Q2FjaGVbY2FjaGVRdWV1ZS5zaGlmdCgpIGFzIHN0cmluZ107XG4gIH1cblxuICBsZXQga2V5OiBTb3VyY2VEYXRhID0gYEFXUzQke2NyZWRlbnRpYWxzLnNlY3JldEFjY2Vzc0tleX1gO1xuICBmb3IgKGNvbnN0IHNpZ25hYmxlIG9mIFtzaG9ydERhdGUsIHJlZ2lvbiwgc2VydmljZSwgS0VZX1RZUEVfSURFTlRJRklFUl0pIHtcbiAgICBrZXkgPSBhd2FpdCBobWFjKHNoYTI1NkNvbnN0cnVjdG9yLCBrZXksIHNpZ25hYmxlKTtcbiAgfVxuICByZXR1cm4gKHNpZ25pbmdLZXlDYWNoZVtjYWNoZUtleV0gPSBrZXkgYXMgVWludDhBcnJheSk7XG59O1xuXG4vKipcbiAqIEBpbnRlcm5hbFxuICovXG5leHBvcnQgZnVuY3Rpb24gY2xlYXJDcmVkZW50aWFsQ2FjaGUoKTogdm9pZCB7XG4gIGNhY2hlUXVldWUubGVuZ3RoID0gMDtcbiAgT2JqZWN0LmtleXMoc2lnbmluZ0tleUNhY2hlKS5mb3JFYWNoKChjYWNoZUtleSkgPT4ge1xuICAgIGRlbGV0ZSBzaWduaW5nS2V5Q2FjaGVbY2FjaGVLZXldO1xuICB9KTtcbn1cblxuZnVuY3Rpb24gaG1hYyhjdG9yOiBIYXNoQ29uc3RydWN0b3IsIHNlY3JldDogU291cmNlRGF0YSwgZGF0YTogU291cmNlRGF0YSk6IFByb21pc2U8VWludDhBcnJheT4ge1xuICBjb25zdCBoYXNoID0gbmV3IGN0b3Ioc2VjcmV0KTtcbiAgaGFzaC51cGRhdGUoZGF0YSk7XG4gIHJldHVybiBoYXNoLmRpZ2VzdCgpO1xufVxuIl19

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parseUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aws_sdk_querystring_parser__ = __webpack_require__(1728);

var parseUrl = function (url) {
    var _a = new URL(url), hostname = _a.hostname, pathname = _a.pathname, port = _a.port, protocol = _a.protocol, search = _a.search;
    var query;
    if (search) {
        query = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__aws_sdk_querystring_parser__["a" /* parseQueryString */])(search);
    }
    return {
        hostname: hostname,
        port: port ? parseInt(port) : undefined,
        protocol: protocol,
        path: pathname,
        query: query,
    };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLGdCQUFnQixFQUFFLE1BQU0sNkJBQTZCLENBQUM7QUFHL0QsTUFBTSxDQUFDLElBQU0sUUFBUSxHQUFjLFVBQUMsR0FBVztJQUN2QyxJQUFBLEtBQWlELElBQUksR0FBRyxDQUFDLEdBQUcsQ0FBQyxFQUEzRCxRQUFRLGNBQUEsRUFBRSxRQUFRLGNBQUEsRUFBRSxJQUFJLFVBQUEsRUFBRSxRQUFRLGNBQUEsRUFBRSxNQUFNLFlBQWlCLENBQUM7SUFFcEUsSUFBSSxLQUFvQyxDQUFDO0lBQ3pDLElBQUksTUFBTSxFQUFFO1FBQ1YsS0FBSyxHQUFHLGdCQUFnQixDQUFDLE1BQU0sQ0FBQyxDQUFDO0tBQ2xDO0lBRUQsT0FBTztRQUNMLFFBQVEsVUFBQTtRQUNSLElBQUksRUFBRSxJQUFJLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLENBQUMsU0FBUztRQUN2QyxRQUFRLFVBQUE7UUFDUixJQUFJLEVBQUUsUUFBUTtRQUNkLEtBQUssT0FBQTtLQUNOLENBQUM7QUFDSixDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBwYXJzZVF1ZXJ5U3RyaW5nIH0gZnJvbSBcIkBhd3Mtc2RrL3F1ZXJ5c3RyaW5nLXBhcnNlclwiO1xuaW1wb3J0IHsgRW5kcG9pbnQsIFF1ZXJ5UGFyYW1ldGVyQmFnLCBVcmxQYXJzZXIgfSBmcm9tIFwiQGF3cy1zZGsvdHlwZXNcIjtcblxuZXhwb3J0IGNvbnN0IHBhcnNlVXJsOiBVcmxQYXJzZXIgPSAodXJsOiBzdHJpbmcpOiBFbmRwb2ludCA9PiB7XG4gIGNvbnN0IHsgaG9zdG5hbWUsIHBhdGhuYW1lLCBwb3J0LCBwcm90b2NvbCwgc2VhcmNoIH0gPSBuZXcgVVJMKHVybCk7XG5cbiAgbGV0IHF1ZXJ5OiBRdWVyeVBhcmFtZXRlckJhZyB8IHVuZGVmaW5lZDtcbiAgaWYgKHNlYXJjaCkge1xuICAgIHF1ZXJ5ID0gcGFyc2VRdWVyeVN0cmluZyhzZWFyY2gpO1xuICB9XG5cbiAgcmV0dXJuIHtcbiAgICBob3N0bmFtZSxcbiAgICBwb3J0OiBwb3J0ID8gcGFyc2VJbnQocG9ydCkgOiB1bmRlZmluZWQsXG4gICAgcHJvdG9jb2wsXG4gICAgcGF0aDogcGF0aG5hbWUsXG4gICAgcXVlcnksXG4gIH07XG59O1xuIl19

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateBodyLength;
function calculateBodyLength(body) {
    if (typeof body === "string") {
        var len = body.length;
        for (var i = len - 1; i >= 0; i--) {
            var code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff)
                len++;
            else if (code > 0x7ff && code <= 0xffff)
                len += 2;
        }
        return len;
    }
    else if (typeof body.byteLength === "number") {
        // handles Uint8Array, ArrayBuffer, Buffer, and ArrayBufferView
        return body.byteLength;
    }
    else if (typeof body.size === "number") {
        // handles browser File object
        return body.size;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxVQUFVLG1CQUFtQixDQUFDLElBQVM7SUFDM0MsSUFBSSxPQUFPLElBQUksS0FBSyxRQUFRLEVBQUU7UUFDNUIsSUFBSSxHQUFHLEdBQUcsSUFBSSxDQUFDLE1BQU0sQ0FBQztRQUV0QixLQUFLLElBQUksQ0FBQyxHQUFHLEdBQUcsR0FBRyxDQUFDLEVBQUUsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLEVBQUUsRUFBRTtZQUNqQyxJQUFNLElBQUksR0FBRyxJQUFJLENBQUMsVUFBVSxDQUFDLENBQUMsQ0FBQyxDQUFDO1lBQ2hDLElBQUksSUFBSSxHQUFHLElBQUksSUFBSSxJQUFJLElBQUksS0FBSztnQkFBRSxHQUFHLEVBQUUsQ0FBQztpQkFDbkMsSUFBSSxJQUFJLEdBQUcsS0FBSyxJQUFJLElBQUksSUFBSSxNQUFNO2dCQUFFLEdBQUcsSUFBSSxDQUFDLENBQUM7U0FDbkQ7UUFFRCxPQUFPLEdBQUcsQ0FBQztLQUNaO1NBQU0sSUFBSSxPQUFPLElBQUksQ0FBQyxVQUFVLEtBQUssUUFBUSxFQUFFO1FBQzlDLCtEQUErRDtRQUMvRCxPQUFPLElBQUksQ0FBQyxVQUFVLENBQUM7S0FDeEI7U0FBTSxJQUFJLE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxRQUFRLEVBQUU7UUFDeEMsOEJBQThCO1FBQzlCLE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQztLQUNsQjtBQUNILENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZnVuY3Rpb24gY2FsY3VsYXRlQm9keUxlbmd0aChib2R5OiBhbnkpOiBudW1iZXIgfCB1bmRlZmluZWQge1xuICBpZiAodHlwZW9mIGJvZHkgPT09IFwic3RyaW5nXCIpIHtcbiAgICBsZXQgbGVuID0gYm9keS5sZW5ndGg7XG5cbiAgICBmb3IgKGxldCBpID0gbGVuIC0gMTsgaSA+PSAwOyBpLS0pIHtcbiAgICAgIGNvbnN0IGNvZGUgPSBib2R5LmNoYXJDb2RlQXQoaSk7XG4gICAgICBpZiAoY29kZSA+IDB4N2YgJiYgY29kZSA8PSAweDdmZikgbGVuKys7XG4gICAgICBlbHNlIGlmIChjb2RlID4gMHg3ZmYgJiYgY29kZSA8PSAweGZmZmYpIGxlbiArPSAyO1xuICAgIH1cblxuICAgIHJldHVybiBsZW47XG4gIH0gZWxzZSBpZiAodHlwZW9mIGJvZHkuYnl0ZUxlbmd0aCA9PT0gXCJudW1iZXJcIikge1xuICAgIC8vIGhhbmRsZXMgVWludDhBcnJheSwgQXJyYXlCdWZmZXIsIEJ1ZmZlciwgYW5kIEFycmF5QnVmZmVyVmlld1xuICAgIHJldHVybiBib2R5LmJ5dGVMZW5ndGg7XG4gIH0gZWxzZSBpZiAodHlwZW9mIGJvZHkuc2l6ZSA9PT0gXCJudW1iZXJcIikge1xuICAgIC8vIGhhbmRsZXMgYnJvd3NlciBGaWxlIG9iamVjdFxuICAgIHJldHVybiBib2R5LnNpemU7XG4gIH1cbn1cbiJdfQ==

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return escapeUri; });
var escapeUri = function (uri) {
    // AWS percent-encodes some extra non-standard characters in a URI
    return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
};
var hexEncode = function (c) { return "%" + c.charCodeAt(0).toString(16).toUpperCase(); };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXNjYXBlLXVyaS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9lc2NhcGUtdXJpLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBQyxJQUFNLFNBQVMsR0FBRyxVQUFDLEdBQVc7SUFDbkMsa0VBQWtFO0lBQ2xFLE9BQUEsa0JBQWtCLENBQUMsR0FBRyxDQUFDLENBQUMsT0FBTyxDQUFDLFVBQVUsRUFBRSxTQUFTLENBQUM7QUFBdEQsQ0FBc0QsQ0FBQztBQUV6RCxJQUFNLFNBQVMsR0FBRyxVQUFDLENBQVMsSUFBSyxPQUFBLE1BQUksQ0FBQyxDQUFDLFVBQVUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsRUFBRSxDQUFDLENBQUMsV0FBVyxFQUFJLEVBQWhELENBQWdELENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgZXNjYXBlVXJpID0gKHVyaTogc3RyaW5nKTogc3RyaW5nID0+XG4gIC8vIEFXUyBwZXJjZW50LWVuY29kZXMgc29tZSBleHRyYSBub24tc3RhbmRhcmQgY2hhcmFjdGVycyBpbiBhIFVSSVxuICBlbmNvZGVVUklDb21wb25lbnQodXJpKS5yZXBsYWNlKC9bIScoKSpdL2csIGhleEVuY29kZSk7XG5cbmNvbnN0IGhleEVuY29kZSA9IChjOiBzdHJpbmcpID0+IGAlJHtjLmNoYXJDb2RlQXQoMCkudG9TdHJpbmcoMTYpLnRvVXBwZXJDYXNlKCl9YDtcbiJdfQ==

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__escape_uri__ = __webpack_require__(871);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__escape_uri__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__escape_uri_path__ = __webpack_require__(1752);
/* unused harmony namespace reexport */


//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyxjQUFjLENBQUM7QUFDN0IsY0FBYyxtQkFBbUIsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gXCIuL2VzY2FwZS11cmlcIjtcbmV4cG9ydCAqIGZyb20gXCIuL2VzY2FwZS11cmktcGF0aFwiO1xuIl19

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultUserAgent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bowser__ = __webpack_require__(1753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_bowser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_bowser__);


/**
 * Default provider to the user agent in browsers. It's a best effort to infer
 * the device information. It uses bowser library to detect the browser and virsion
 */
var defaultUserAgent = function (_a) {
    var serviceId = _a.serviceId, clientVersion = _a.clientVersion;
    return function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(void 0, void 0, void 0, function () {
        var parsedUA, sections;
        var _a, _b, _c, _d, _e, _f, _g;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_h) {
            parsedUA = ((_a = window === null || window === void 0 ? void 0 : window.navigator) === null || _a === void 0 ? void 0 : _a.userAgent) ? __WEBPACK_IMPORTED_MODULE_1_bowser___default.a.parse(window.navigator.userAgent) : undefined;
            sections = [
                // sdk-metadata
                ["aws-sdk-js", clientVersion],
                // os-metadata
                ["os/" + (((_b = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _b === void 0 ? void 0 : _b.name) || "other"), (_c = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.os) === null || _c === void 0 ? void 0 : _c.version],
                // language-metadata
                // ECMAScript edition doesn't matter in JS.
                ["lang/js"],
                // browser vendor and version.
                ["md/browser", ((_e = (_d = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _d === void 0 ? void 0 : _d.name) !== null && _e !== void 0 ? _e : "unknown") + "_" + ((_g = (_f = parsedUA === null || parsedUA === void 0 ? void 0 : parsedUA.browser) === null || _f === void 0 ? void 0 : _f.version) !== null && _g !== void 0 ? _g : "unknown")],
            ];
            if (serviceId) {
                // api-metadata
                // service Id may not appear in non-AWS clients
                sections.push(["api/" + serviceId, clientVersion]);
            }
            return [2 /*return*/, sections];
        });
    }); };
};
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 874 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 875 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(1771);


function _toPropertyKey(arg) {
  var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(arg, "string");
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(key) === "symbol" ? key : String(key);
}

/***/ }),
/* 879 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(214)["default"];
var toPrimitive = __webpack_require__(1784);
function _toPropertyKey(arg) {
  var key = toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
module.exports = _toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 880 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(874);
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useEventListener; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var getWindowEvent = function getWindowEvent(target) {
  if (target) {
    var _ownerDocument$defaul, _ownerDocument, _ownerDocument$defaul2;

    if (typeof target.window === 'object' && target.window === target) {
      return target.event;
    }

    return (_ownerDocument$defaul = (_ownerDocument = target.ownerDocument) == null ? void 0 : (_ownerDocument$defaul2 = _ownerDocument.defaultView) == null ? void 0 : _ownerDocument$defaul2.event) != null ? _ownerDocument$defaul : undefined;
  }

  return undefined;
};

var isActionSupported = function isActionSupported(element, method) {
  return element ? !!element[method] : false;
};

var useEventListener = function useEventListener(options) {
  var capture = options.capture,
      listener = options.listener,
      type = options.type,
      target = options.target,
      targetRef = options.targetRef;
  var latestListener = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](listener);
  latestListener.current = listener;
  var eventHandler = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (event) {
    return latestListener.current(event);
  }, []);
  var timeoutId = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](undefined);

  if (false) {
    // This is fine to violate there conditional rule as environment variables will never change during component
    // lifecycle
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (typeof target !== 'undefined' && typeof targetRef !== 'undefined') {
        throw new Error('`target` and `targetRef` props are mutually exclusive, please use one of them.');
      }

      if (typeof target === 'undefined' && typeof targetRef === 'undefined') {
        throw new Error("`target` and `targetRef` props are `undefined`, it' required to use one of them.");
      }
    }, [target, targetRef]);
  }

  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    var element = typeof targetRef === 'undefined' ? target : targetRef.current; // Store the current event to avoid triggering handlers immediately
    // Note this depends on a deprecated but extremely well supported quirk of the web platform
    // https://github.com/facebook/react/issues/20074

    var currentEvent = getWindowEvent(window);

    var conditionalHandler = function conditionalHandler(event) {
      // Skip if this event is the same as the one running when we added the handlers
      if (event === currentEvent) {
        currentEvent = undefined;
        return;
      }

      eventHandler(event);
    };

    if (isActionSupported(element, 'addEventListener')) {
      element.addEventListener(type, conditionalHandler, capture);
    } else if (false) {
      throw new Error('@fluentui/react-component-event-listener: Passed `element` is not valid or does not support `addEventListener()` method.');
    } // @ts-ignore We have a collision between types from DOM and @types/node


    timeoutId.current = setTimeout(function () {
      currentEvent = undefined;
    }, 1);
    return function () {
      clearTimeout(timeoutId.current);
      currentEvent = undefined;

      if (isActionSupported(element, 'removeEventListener')) {
        element.removeEventListener(type, conditionalHandler, capture);
      } else if (false) {
        throw new Error('@fluentui/react-component-event-listener: Passed `element` is not valid or does not support `removeEventListener()` method.');
      }
    };
  }, [capture, eventHandler, target, targetRef, type]);
};
//# sourceMappingURL=useEventListener.js.map


/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RefFindNode; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(530);



 // ========================================================
// react/packages/react-reconciler/src/ReactFiber.js
// ========================================================

/**
 * Detects if a passed element is a Fiber object instead of an element. Is needed as `ReactDOM.findDOMNode()` returns
 * a Fiber in `react-test-renderer` that can cause issues with tests. Is used only in non-production env.
 *
 * @see https://github.com/facebook/react/issues/7371#issuecomment-317396864
 * @see https://github.com/Semantic-Org/Semantic-UI-React/issues/4061#issuecomment-694895617
 */
function isFiberRef(node) {
  if (node === null) {
    return false;
  }

  if (node instanceof Element || node instanceof Text) {
    return false;
  }

  return !!(node.type && node.tag);
}

var RefFindNode = /*#__PURE__*/function (_React$Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(RefFindNode, _React$Component);

  function RefFindNode() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.prevNode = void 0;
    return _this;
  }

  var _proto = RefFindNode.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var currentNode = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](this);

    if (false) {
      if (isFiberRef(currentNode)) {
        currentNode = null;
      }
    }

    this.prevNode = currentNode;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* handleRef */])(this.props.innerRef, currentNode);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var currentNode = __WEBPACK_IMPORTED_MODULE_2_react_dom__["findDOMNode"](this);

    if (false) {
      if (isFiberRef(currentNode)) {
        currentNode = null;
      }
    }

    if (this.prevNode !== currentNode) {
      this.prevNode = currentNode;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* handleRef */])(this.props.innerRef, currentNode);
    }

    if (prevProps.innerRef !== this.props.innerRef) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* handleRef */])(this.props.innerRef, currentNode);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* handleRef */])(this.props.innerRef, null);
    delete this.prevNode;
  };

  _proto.render = function render() {
    var children = this.props.children;
    return children;
  };

  return RefFindNode;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
//# sourceMappingURL=RefFindNode.js.map


/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RefForward; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(530);



var RefForward = /*#__PURE__*/function (_React$Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(RefForward, _React$Component);

  function RefForward() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.currentNode = void 0;

    _this.handleRefOverride = function (node) {
      var _this$props = _this.props,
          children = _this$props.children,
          innerRef = _this$props.innerRef;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* handleRef */])(children.ref, node);
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* handleRef */])(innerRef, node);
      _this.currentNode = node;
    };

    return _this;
  }

  var _proto = RefForward.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.innerRef !== this.props.innerRef) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* handleRef */])(this.props.innerRef, this.currentNode);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    delete this.currentNode;
  };

  _proto.render = function render() {
    var children = this.props.children;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](children, {
      ref: this.handleRefOverride
    });
  };

  return RefForward;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);
//# sourceMappingURL=RefForward.js.map


/***/ }),
/* 884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SECURE_DOCUMENTS_ERROR_CODE = exports.isSecureDocumentsErrorInstance = exports.isSecureDocumentsError = exports.SecureDocumentsIncompleteError = exports.SecureDocumentsError = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(369));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(875));

var _inherits2 = _interopRequireDefault(__webpack_require__(1774));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(1780));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(1773));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(102));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    var instance = Reflect.construct(cls, Array.from(arguments));
    Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    return instance;
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var SecureDocumentsError = /*#__PURE__*/function (_extendableBuiltin2) {
  (0, _inherits2.default)(SecureDocumentsError, _extendableBuiltin2);

  var _super = _createSuper(SecureDocumentsError);

  function SecureDocumentsError(message, code) {
    var _this;

    var statusCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 500;
    (0, _classCallCheck2.default)(this, SecureDocumentsError);
    _this = _super.call(this, message);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "code", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "statusCode", void 0);
    _this.statusCode = statusCode;
    _this.name = 'SecureDocumentsError';
    _this.code = code;
    Object.setPrototypeOf((0, _assertThisInitialized2.default)(_this), SecureDocumentsError.prototype);
    return _this;
  }

  return SecureDocumentsError;
}(_extendableBuiltin(Error));
/*
  The file was stored in (or removed from) S3, but recording that failed. Retry with
  `client.completeSync(err.receipt)`; repeating the upload would store the file again.
*/


exports.SecureDocumentsError = SecureDocumentsError;

var SecureDocumentsIncompleteError = /*#__PURE__*/function (_SecureDocumentsError) {
  (0, _inherits2.default)(SecureDocumentsIncompleteError, _SecureDocumentsError);

  var _super2 = _createSuper(SecureDocumentsIncompleteError);

  function SecureDocumentsIncompleteError(cause, receipt) {
    var _this2;

    (0, _classCallCheck2.default)(this, SecureDocumentsIncompleteError);
    _this2 = _super2.call(this, cause.message, SECURE_DOCUMENTS_ERROR_CODE.IncompleteOperationException, cause.statusCode);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this2), "receipt", void 0);
    _this2.name = 'SecureDocumentsIncompleteError';
    _this2.receipt = receipt;
    Object.setPrototypeOf((0, _assertThisInitialized2.default)(_this2), SecureDocumentsIncompleteError.prototype);
    return _this2;
  }

  return SecureDocumentsIncompleteError;
}(SecureDocumentsError); // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types


exports.SecureDocumentsIncompleteError = SecureDocumentsIncompleteError;

var isSecureDocumentsError = function isSecureDocumentsError(err) {
  return err && err.code && err.message && err.statusCode;
};

exports.isSecureDocumentsError = isSecureDocumentsError;

var isSecureDocumentsErrorInstance = function isSecureDocumentsErrorInstance(err) {
  return err instanceof SecureDocumentsError;
};

exports.isSecureDocumentsErrorInstance = isSecureDocumentsErrorInstance;
var SECURE_DOCUMENTS_ERROR_CODE;
exports.SECURE_DOCUMENTS_ERROR_CODE = SECURE_DOCUMENTS_ERROR_CODE;

(function (SECURE_DOCUMENTS_ERROR_CODE) {
  SECURE_DOCUMENTS_ERROR_CODE["AccessDeniedException"] = "AccessDeniedException";
  SECURE_DOCUMENTS_ERROR_CODE["FolderAlreadyExistsException"] = "FolderAlreadyExistsException";
  SECURE_DOCUMENTS_ERROR_CODE["DocumentAlreadyExistsException"] = "DocumentAlreadyExistsException";
  SECURE_DOCUMENTS_ERROR_CODE["FolderNotEmptyException"] = "FolderNotEmptyException";
  SECURE_DOCUMENTS_ERROR_CODE["InternalServerError"] = "InternalServerError";
  SECURE_DOCUMENTS_ERROR_CODE["NoSuchDocumentException"] = "NoSuchDocumentException";
  SECURE_DOCUMENTS_ERROR_CODE["NoSuchFolderException"] = "NoSuchFolderException";
  SECURE_DOCUMENTS_ERROR_CODE["BadRequestException"] = "BadRequestException";
  SECURE_DOCUMENTS_ERROR_CODE["IncompleteOperationException"] = "IncompleteOperationException";
})(SECURE_DOCUMENTS_ERROR_CODE || (exports.SECURE_DOCUMENTS_ERROR_CODE = SECURE_DOCUMENTS_ERROR_CODE = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(255);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  utilities: true
};
exports.utilities = void 0;

var _core = __webpack_require__(1791);

Object.keys(_core).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _core[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _core[key];
    }
  });
});

var _react = __webpack_require__(1833);

Object.keys(_react).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _react[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _react[key];
    }
  });
});

var _shared = __webpack_require__(1834);

Object.keys(_shared).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _shared[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _shared[key];
    }
  });
});

var utilities = _interopRequireWildcard(__webpack_require__(1840));

exports.utilities = utilities;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7QUFBQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUNBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBQ0E7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFDQSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gJy4vY29yZSc7XG5leHBvcnQgKiBmcm9tICcuL3JlYWN0JztcbmV4cG9ydCAqIGZyb20gJy4vc2hhcmVkJztcbmltcG9ydCAqIGFzIHV0aWxpdGllcyBmcm9tICcuL3V0aWxpdGllcyc7XG5leHBvcnQgeyB1dGlsaXRpZXMgfTtcbiJdfQ==

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useReadDocument.default;
  }
});

var _useReadDocument = _interopRequireDefault(__webpack_require__(1817));

var _useReadDocument2 = __webpack_require__(1818);

Object.keys(_useReadDocument2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useReadDocument2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useReadDocument2[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VSZWFkRG9jdW1lbnQvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IGRlZmF1bHQgfSBmcm9tICcuL3VzZVJlYWREb2N1bWVudCc7XG5leHBvcnQgKiBmcm9tICcuL3VzZVJlYWREb2N1bWVudC50eXBlcyc7XG4iXX0=

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SYNC_RECEIPT_VERSION = exports.SYNC_RECEIPT_QUERY_PARAM = exports.MHUB_COGNITO_GROUPS = void 0;
var MHUB_COGNITO_GROUPS;
exports.MHUB_COGNITO_GROUPS = MHUB_COGNITO_GROUPS;

(function (MHUB_COGNITO_GROUPS) {
  MHUB_COGNITO_GROUPS["admin"] = "ADMIN";
  MHUB_COGNITO_GROUPS["adminBasic"] = "ADMIN_BASIC";
  MHUB_COGNITO_GROUPS["adminCommunity"] = "ADMIN_COMMUNITY";
  MHUB_COGNITO_GROUPS["agent"] = "AGENT";
  MHUB_COGNITO_GROUPS["developerBranchLeader"] = "DEVELOPER_BRANCH_LEADER";
  MHUB_COGNITO_GROUPS["developerBranchLeaderSupervisor"] = "DEVELOPER_BRANCH_LEADER_SUPERVISOR";
  MHUB_COGNITO_GROUPS["developerBranchLeaderSupervisorIi"] = "DEVELOPER_BRANCH_LEADER_SUPERVISOR_II";
  MHUB_COGNITO_GROUPS["developerExecutive"] = "DEVELOPER_EXECUTIVE";
  MHUB_COGNITO_GROUPS["developerHeadquarters"] = "DEVELOPER_HEADQUARTERS";
  MHUB_COGNITO_GROUPS["developerSiteplan"] = "DEVELOPER_SITEPLAN";
  MHUB_COGNITO_GROUPS["developerTeamLeader"] = "DEVELOPER_TEAM_LEADER";
  MHUB_COGNITO_GROUPS["headquarters"] = "HEADQUARTERS";
  MHUB_COGNITO_GROUPS["lawyer"] = "LAWYER";
  MHUB_COGNITO_GROUPS["lawyerHeadquarters"] = "LAWYER_HEADQUARTERS";
  MHUB_COGNITO_GROUPS["marketplaceAgent"] = "MARKETPLACE_AGENT";
  MHUB_COGNITO_GROUPS["mortgageBanker"] = "MORTGAGE_BANKER";
  MHUB_COGNITO_GROUPS["superAdmin"] = "SUPER_ADMIN";
  MHUB_COGNITO_GROUPS["teamLeader"] = "TEAM_LEADER";
})(MHUB_COGNITO_GROUPS || (exports.MHUB_COGNITO_GROUPS = MHUB_COGNITO_GROUPS = {}));

/*
  Receipt contract with the upload edge (mhub-securedocuments-auth-api).

  The edge cannot reliably see the caller's token after the S3 write, so a client that sends
  `?sdsReceipt=1` gets a receipt back instead of the edge recording the operation, and records it
  itself with its own token (see `SecureDocumentsClient.completeSync`). The parameter name and
  version must match the edge.
*/
var SYNC_RECEIPT_QUERY_PARAM = 'sdsReceipt';
exports.SYNC_RECEIPT_QUERY_PARAM = SYNC_RECEIPT_QUERY_PARAM;
var SYNC_RECEIPT_VERSION = 1;
exports.SYNC_RECEIPT_VERSION = SYNC_RECEIPT_VERSION;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(113);
var settle = __webpack_require__(1850);
var buildURL = __webpack_require__(895);
var buildFullPath = __webpack_require__(1847);
var parseHeaders = __webpack_require__(1857);
var isURLSameOrigin = __webpack_require__(1855);
var createError = __webpack_require__(891);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(1853);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(1849);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(113);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(113);
var normalizeHeaderName = __webpack_require__(1856);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(888);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(888);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(113);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = assertObject;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function assertObject(value) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  if (_typeof(value) !== 'object' || Array.isArray(value)) {
    throw new TypeError("".concat(label, " needs to be a plain object"));
  }
}

/***/ }),
/* 897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "arrayLength", {
  enumerable: true,
  get: function get() {
    return _arrayLength["default"];
  }
});
Object.defineProperty(exports, "capitalize", {
  enumerable: true,
  get: function get() {
    return _capitalize["default"];
  }
});
Object.defineProperty(exports, "email", {
  enumerable: true,
  get: function get() {
    return _email["default"];
  }
});
Object.defineProperty(exports, "equalTo", {
  enumerable: true,
  get: function get() {
    return _equalTo["default"];
  }
});
Object.defineProperty(exports, "identity", {
  enumerable: true,
  get: function get() {
    return _identity["default"];
  }
});
Object.defineProperty(exports, "isAlpha", {
  enumerable: true,
  get: function get() {
    return _isAlpha["default"];
  }
});
Object.defineProperty(exports, "matchRegex", {
  enumerable: true,
  get: function get() {
    return _matchRegex["default"];
  }
});
Object.defineProperty(exports, "numericRange", {
  enumerable: true,
  get: function get() {
    return _numericRange["default"];
  }
});
Object.defineProperty(exports, "phoneNumber", {
  enumerable: true,
  get: function get() {
    return _phoneNumber["default"];
  }
});
Object.defineProperty(exports, "phonePrefix", {
  enumerable: true,
  get: function get() {
    return _phonePrefix["default"];
  }
});
Object.defineProperty(exports, "required", {
  enumerable: true,
  get: function get() {
    return _required["default"];
  }
});
Object.defineProperty(exports, "stringLength", {
  enumerable: true,
  get: function get() {
    return _stringLength["default"];
  }
});
var _arrayLength = _interopRequireDefault(__webpack_require__(1867));
var _capitalize = _interopRequireDefault(__webpack_require__(1868));
var _email = _interopRequireDefault(__webpack_require__(1869));
var _equalTo = _interopRequireDefault(__webpack_require__(1870));
var _identity = _interopRequireDefault(__webpack_require__(1871));
var _isAlpha = _interopRequireDefault(__webpack_require__(1872));
var _matchRegex = _interopRequireDefault(__webpack_require__(1873));
var _numericRange = _interopRequireDefault(__webpack_require__(1874));
var _phoneNumber = _interopRequireDefault(__webpack_require__(1875));
var _phonePrefix = _interopRequireDefault(__webpack_require__(1876));
var _required = _interopRequireDefault(__webpack_require__(1877));
var _stringLength = _interopRequireDefault(__webpack_require__(1878));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProxyLogger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NoopLogger__ = __webpack_require__(531);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var ProxyLogger = /** @class */ (function () {
    function ProxyLogger(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    /**
     * Emit a log record. This method should only be used by log appenders.
     *
     * @param logRecord
     */
    ProxyLogger.prototype.emit = function (logRecord) {
        this._getLogger().emit(logRecord);
    };
    /**
     * Try to get a logger from the proxy logger provider.
     * If the proxy logger provider has no delegate, return a noop logger.
     */
    ProxyLogger.prototype._getLogger = function () {
        if (this._delegate) {
            return this._delegate;
        }
        var logger = this._provider.getDelegateLogger(this.name, this.version, this.options);
        if (!logger) {
            return __WEBPACK_IMPORTED_MODULE_0__NoopLogger__["b" /* NOOP_LOGGER */];
        }
        this._delegate = logger;
        return this._delegate;
    };
    return ProxyLogger;
}());

//# sourceMappingURL=ProxyLogger.js.map

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProxyLoggerProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NoopLoggerProvider__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProxyLogger__ = __webpack_require__(898);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var ProxyLoggerProvider = /** @class */ (function () {
    function ProxyLoggerProvider() {
    }
    ProxyLoggerProvider.prototype.getLogger = function (name, version, options) {
        var _a;
        return ((_a = this.getDelegateLogger(name, version, options)) !== null && _a !== void 0 ? _a : new __WEBPACK_IMPORTED_MODULE_1__ProxyLogger__["a" /* ProxyLogger */](this, name, version, options));
    };
    ProxyLoggerProvider.prototype.getDelegate = function () {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : __WEBPACK_IMPORTED_MODULE_0__NoopLoggerProvider__["a" /* NOOP_LOGGER_PROVIDER */];
    };
    /**
     * Set the delegate logger provider
     */
    ProxyLoggerProvider.prototype.setDelegate = function (delegate) {
        this._delegate = delegate;
    };
    ProxyLoggerProvider.prototype.getDelegateLogger = function (name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getLogger(name, version, options);
    };
    return ProxyLoggerProvider;
}());

//# sourceMappingURL=ProxyLoggerProvider.js.map

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return logs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types_LogRecord__ = __webpack_require__(1883);
/* unused harmony reexport SeverityNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NoopLogger__ = __webpack_require__(531);
/* unused harmony reexport NOOP_LOGGER */
/* unused harmony reexport NoopLogger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NoopLoggerProvider__ = __webpack_require__(532);
/* unused harmony reexport NOOP_LOGGER_PROVIDER */
/* unused harmony reexport NoopLoggerProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ProxyLogger__ = __webpack_require__(898);
/* unused harmony reexport ProxyLogger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProxyLoggerProvider__ = __webpack_require__(899);
/* unused harmony reexport ProxyLoggerProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_logs__ = __webpack_require__(1879);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var logs = __WEBPACK_IMPORTED_MODULE_5__api_logs__["a" /* LogsAPI */].getInstance();
//# sourceMappingURL=index.js.map

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createBaggage;
/* harmony export (immutable) */ __webpack_exports__["a"] = baggageEntryMetadataFromString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_diag__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_baggage_impl__ = __webpack_require__(1888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__internal_symbol__ = __webpack_require__(1889);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



var diag = __WEBPACK_IMPORTED_MODULE_0__api_diag__["a" /* DiagAPI */].instance();
/**
 * Create a new Baggage with optional entries
 *
 * @param entries An array of baggage entries the new baggage should contain
 */
function createBaggage(entries) {
    if (entries === void 0) { entries = {}; }
    return new __WEBPACK_IMPORTED_MODULE_1__internal_baggage_impl__["a" /* BaggageImpl */](new Map(Object.entries(entries)));
}
/**
 * Create a serializable BaggageEntryMetadata object from a string.
 *
 * @param str string metadata. Format is currently not defined by the spec and has no special meaning.
 *
 */
function baggageEntryMetadataFromString(str) {
    if (typeof str !== 'string') {
        diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = '';
    }
    return {
        __TYPE__: __WEBPACK_IMPORTED_MODULE_2__internal_symbol__["a" /* baggageEntryMetadataSymbol */],
        toString: function () {
            return str;
        },
    };
}
//# sourceMappingURL=utils.js.map

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NoopMeter */
/* unused harmony export NoopMetric */
/* unused harmony export NoopCounterMetric */
/* unused harmony export NoopUpDownCounterMetric */
/* unused harmony export NoopGaugeMetric */
/* unused harmony export NoopHistogramMetric */
/* unused harmony export NoopObservableMetric */
/* unused harmony export NoopObservableCounterMetric */
/* unused harmony export NoopObservableGaugeMetric */
/* unused harmony export NoopObservableUpDownCounterMetric */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NOOP_METER; });
/* unused harmony export NOOP_COUNTER_METRIC */
/* unused harmony export NOOP_GAUGE_METRIC */
/* unused harmony export NOOP_HISTOGRAM_METRIC */
/* unused harmony export NOOP_UP_DOWN_COUNTER_METRIC */
/* unused harmony export NOOP_OBSERVABLE_COUNTER_METRIC */
/* unused harmony export NOOP_OBSERVABLE_GAUGE_METRIC */
/* unused harmony export NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC */
/* harmony export (immutable) */ __webpack_exports__["a"] = createNoopMeter;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */
var NoopMeter = /** @class */ (function () {
    function NoopMeter() {
    }
    /**
     * @see {@link Meter.createGauge}
     */
    NoopMeter.prototype.createGauge = function (_name, _options) {
        return NOOP_GAUGE_METRIC;
    };
    /**
     * @see {@link Meter.createHistogram}
     */
    NoopMeter.prototype.createHistogram = function (_name, _options) {
        return NOOP_HISTOGRAM_METRIC;
    };
    /**
     * @see {@link Meter.createCounter}
     */
    NoopMeter.prototype.createCounter = function (_name, _options) {
        return NOOP_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */
    NoopMeter.prototype.createUpDownCounter = function (_name, _options) {
        return NOOP_UP_DOWN_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */
    NoopMeter.prototype.createObservableGauge = function (_name, _options) {
        return NOOP_OBSERVABLE_GAUGE_METRIC;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */
    NoopMeter.prototype.createObservableCounter = function (_name, _options) {
        return NOOP_OBSERVABLE_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */
    NoopMeter.prototype.createObservableUpDownCounter = function (_name, _options) {
        return NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */
    NoopMeter.prototype.addBatchObservableCallback = function (_callback, _observables) { };
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */
    NoopMeter.prototype.removeBatchObservableCallback = function (_callback) { };
    return NoopMeter;
}());

var NoopMetric = /** @class */ (function () {
    function NoopMetric() {
    }
    return NoopMetric;
}());

var NoopCounterMetric = /** @class */ (function (_super) {
    __extends(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function (_value, _attributes) { };
    return NoopCounterMetric;
}(NoopMetric));

var NoopUpDownCounterMetric = /** @class */ (function (_super) {
    __extends(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function (_value, _attributes) { };
    return NoopUpDownCounterMetric;
}(NoopMetric));

var NoopGaugeMetric = /** @class */ (function (_super) {
    __extends(NoopGaugeMetric, _super);
    function NoopGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopGaugeMetric.prototype.record = function (_value, _attributes) { };
    return NoopGaugeMetric;
}(NoopMetric));

var NoopHistogramMetric = /** @class */ (function (_super) {
    __extends(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function (_value, _attributes) { };
    return NoopHistogramMetric;
}(NoopMetric));

var NoopObservableMetric = /** @class */ (function () {
    function NoopObservableMetric() {
    }
    NoopObservableMetric.prototype.addCallback = function (_callback) { };
    NoopObservableMetric.prototype.removeCallback = function (_callback) { };
    return NoopObservableMetric;
}());

var NoopObservableCounterMetric = /** @class */ (function (_super) {
    __extends(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}(NoopObservableMetric));

var NoopObservableGaugeMetric = /** @class */ (function (_super) {
    __extends(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}(NoopObservableMetric));

var NoopObservableUpDownCounterMetric = /** @class */ (function (_super) {
    __extends(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}(NoopObservableMetric));

var NOOP_METER = new NoopMeter();
// Synchronous instruments
var NOOP_COUNTER_METRIC = new NoopCounterMetric();
var NOOP_GAUGE_METRIC = new NoopGaugeMetric();
var NOOP_HISTOGRAM_METRIC = new NoopHistogramMetric();
var NOOP_UP_DOWN_COUNTER_METRIC = new NoopUpDownCounterMetric();
// Asynchronous instruments
var NOOP_OBSERVABLE_COUNTER_METRIC = new NoopObservableCounterMetric();
var NOOP_OBSERVABLE_GAUGE_METRIC = new NoopObservableGaugeMetric();
var NOOP_OBSERVABLE_UP_DOWN_COUNTER_METRIC = new NoopObservableUpDownCounterMetric();
/**
 * Create a no-op Meter
 */
function createNoopMeter() {
    return NOOP_METER;
}
//# sourceMappingURL=NoopMeter.js.map

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultTextMapGetter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return defaultTextMapSetter; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var defaultTextMapGetter = {
    get: function (carrier, key) {
        if (carrier == null) {
            return undefined;
        }
        return carrier[key];
    },
    keys: function (carrier) {
        if (carrier == null) {
            return [];
        }
        return Object.keys(carrier);
    },
};
var defaultTextMapSetter = {
    set: function (carrier, key, value) {
        if (carrier == null) {
            return;
        }
        carrier[key] = value;
    },
};
//# sourceMappingURL=TextMapPropagator.js.map

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoopTracer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_context__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trace_context_utils__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__NonRecordingSpan__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__spancontext_utils__ = __webpack_require__(536);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




var contextApi = __WEBPACK_IMPORTED_MODULE_0__api_context__["a" /* ContextAPI */].getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */
var NoopTracer = /** @class */ (function () {
    function NoopTracer() {
    }
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function (name, options, context) {
        if (context === void 0) { context = contextApi.active(); }
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) {
            return new __WEBPACK_IMPORTED_MODULE_2__NonRecordingSpan__["a" /* NonRecordingSpan */]();
        }
        var parentFromContext = context && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__trace_context_utils__["d" /* getSpanContext */])(context);
        if (isSpanContext(parentFromContext) &&
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__spancontext_utils__["a" /* isSpanContextValid */])(parentFromContext)) {
            return new __WEBPACK_IMPORTED_MODULE_2__NonRecordingSpan__["a" /* NonRecordingSpan */](parentFromContext);
        }
        else {
            return new __WEBPACK_IMPORTED_MODULE_2__NonRecordingSpan__["a" /* NonRecordingSpan */]();
        }
    };
    NoopTracer.prototype.startActiveSpan = function (name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) {
            return;
        }
        else if (arguments.length === 2) {
            fn = arg2;
        }
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        }
        else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__trace_context_utils__["e" /* setSpan */])(parentContext, span);
        return contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}());

function isSpanContext(spanContext) {
    return (typeof spanContext === 'object' &&
        typeof spanContext['spanId'] === 'string' &&
        typeof spanContext['traceId'] === 'string' &&
        typeof spanContext['traceFlags'] === 'number');
}
//# sourceMappingURL=NoopTracer.js.map

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProxyTracer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NoopTracer__ = __webpack_require__(904);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var NOOP_TRACER = new __WEBPACK_IMPORTED_MODULE_0__NoopTracer__["a" /* NoopTracer */]();
/**
 * Proxy tracer provided by the proxy tracer provider
 */
var ProxyTracer = /** @class */ (function () {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function (name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function (_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */
    ProxyTracer.prototype._getTracer = function () {
        if (this._delegate) {
            return this._delegate;
        }
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) {
            return NOOP_TRACER;
        }
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}());

//# sourceMappingURL=ProxyTracer.js.map

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ProxyTracerProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProxyTracer__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NoopTracerProvider__ = __webpack_require__(1905);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var NOOP_TRACER_PROVIDER = new __WEBPACK_IMPORTED_MODULE_1__NoopTracerProvider__["a" /* NoopTracerProvider */]();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */
var ProxyTracerProvider = /** @class */ (function () {
    function ProxyTracerProvider() {
    }
    /**
     * Get a {@link ProxyTracer}
     */
    ProxyTracerProvider.prototype.getTracer = function (name, version, options) {
        var _a;
        return ((_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new __WEBPACK_IMPORTED_MODULE_0__ProxyTracer__["a" /* ProxyTracer */](this, name, version, options));
    };
    ProxyTracerProvider.prototype.getDelegate = function () {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */
    ProxyTracerProvider.prototype.setDelegate = function (delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function (name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}());

//# sourceMappingURL=ProxyTracerProvider.js.map

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getSpan;
/* harmony export (immutable) */ __webpack_exports__["c"] = getActiveSpan;
/* harmony export (immutable) */ __webpack_exports__["e"] = setSpan;
/* harmony export (immutable) */ __webpack_exports__["a"] = deleteSpan;
/* harmony export (immutable) */ __webpack_exports__["f"] = setSpanContext;
/* harmony export (immutable) */ __webpack_exports__["d"] = getSpanContext;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__context_context__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NonRecordingSpan__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_context__ = __webpack_require__(371);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/**
 * span key
 */
var SPAN_KEY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__context_context__["a" /* createContextKey */])('OpenTelemetry Context Key SPAN');
/**
 * Return the span if one exists
 *
 * @param context context to get span from
 */
function getSpan(context) {
    return context.getValue(SPAN_KEY) || undefined;
}
/**
 * Gets the span from the current context, if one exists.
 */
function getActiveSpan() {
    return getSpan(__WEBPACK_IMPORTED_MODULE_2__api_context__["a" /* ContextAPI */].getInstance().active());
}
/**
 * Set the span on a context
 *
 * @param context context to use as parent
 * @param span span to set active
 */
function setSpan(context, span) {
    return context.setValue(SPAN_KEY, span);
}
/**
 * Remove current span stored in the context
 *
 * @param context context to delete span from
 */
function deleteSpan(context) {
    return context.deleteValue(SPAN_KEY);
}
/**
 * Wrap span context in a NoopSpan and set as span in a new
 * context
 *
 * @param context context to set active span on
 * @param spanContext span context to be wrapped
 */
function setSpanContext(context, spanContext) {
    return setSpan(context, new __WEBPACK_IMPORTED_MODULE_1__NonRecordingSpan__["a" /* NonRecordingSpan */](spanContext));
}
/**
 * Get the span context of the span if it exists.
 *
 * @param context context to get values from
 */
function getSpanContext(context) {
    var _a;
    return (_a = getSpan(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}
//# sourceMappingURL=context-utils.js.map

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TraceFlags; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TraceFlags;
(function (TraceFlags) {
    /** Represents no flag set. */
    TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */
    TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})(TraceFlags || (TraceFlags = {}));
//# sourceMappingURL=trace_flags.js.map

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VERSION; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// this is autogenerated file, see scripts/version-update.js
var VERSION = '1.9.0';
//# sourceMappingURL=version.js.map

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return BAGGAGE_KEY_PAIR_SEPARATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return BAGGAGE_PROPERTIES_SEPARATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BAGGAGE_ITEMS_SEPARATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return BAGGAGE_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return BAGGAGE_MAX_NAME_VALUE_PAIRS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BAGGAGE_MAX_PER_NAME_VALUE_PAIRS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return BAGGAGE_MAX_TOTAL_LENGTH; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var BAGGAGE_KEY_PAIR_SEPARATOR = '=';
var BAGGAGE_PROPERTIES_SEPARATOR = ';';
var BAGGAGE_ITEMS_SEPARATOR = ',';
// Name of the http header used to propagate the baggage
var BAGGAGE_HEADER = 'baggage';
// Maximum number of name-value pairs allowed by w3c spec
var BAGGAGE_MAX_NAME_VALUE_PAIRS = 180;
// Maximum number of bytes per a single name-value pair allowed by w3c spec
var BAGGAGE_MAX_PER_NAME_VALUE_PAIRS = 4096;
// Maximum total length of all name-value pairs allowed by w3c spec
var BAGGAGE_MAX_TOTAL_LENGTH = 8192;
//# sourceMappingURL=constants.js.map

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = serializeKeyPairs;
/* harmony export (immutable) */ __webpack_exports__["a"] = getKeyPairs;
/* harmony export (immutable) */ __webpack_exports__["d"] = parsePairKeyValue;
/* harmony export (immutable) */ __webpack_exports__["c"] = parseKeyPairsIntoRecord;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(910);
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function serializeKeyPairs(keyPairs) {
    return keyPairs.reduce(function (hValue, current) {
        var value = "" + hValue + (hValue !== '' ? __WEBPACK_IMPORTED_MODULE_1__constants__["a" /* BAGGAGE_ITEMS_SEPARATOR */] : '') + current;
        return value.length > __WEBPACK_IMPORTED_MODULE_1__constants__["b" /* BAGGAGE_MAX_TOTAL_LENGTH */] ? hValue : value;
    }, '');
}
function getKeyPairs(baggage) {
    return baggage.getAllEntries().map(function (_a) {
        var _b = __read(_a, 2), key = _b[0], value = _b[1];
        var entry = encodeURIComponent(key) + "=" + encodeURIComponent(value.value);
        // include opaque metadata if provided
        // NOTE: we intentionally don't URI-encode the metadata - that responsibility falls on the metadata implementation
        if (value.metadata !== undefined) {
            entry += __WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BAGGAGE_PROPERTIES_SEPARATOR */] + value.metadata.toString();
        }
        return entry;
    });
}
function parsePairKeyValue(entry) {
    var valueProps = entry.split(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BAGGAGE_PROPERTIES_SEPARATOR */]);
    if (valueProps.length <= 0)
        return;
    var keyPairPart = valueProps.shift();
    if (!keyPairPart)
        return;
    var separatorIndex = keyPairPart.indexOf(__WEBPACK_IMPORTED_MODULE_1__constants__["d" /* BAGGAGE_KEY_PAIR_SEPARATOR */]);
    if (separatorIndex <= 0)
        return;
    var key = decodeURIComponent(keyPairPart.substring(0, separatorIndex).trim());
    var value = decodeURIComponent(keyPairPart.substring(separatorIndex + 1).trim());
    var metadata;
    if (valueProps.length > 0) {
        metadata = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["baggageEntryMetadataFromString"])(valueProps.join(__WEBPACK_IMPORTED_MODULE_1__constants__["c" /* BAGGAGE_PROPERTIES_SEPARATOR */]));
    }
    return { key: key, value: value, metadata: metadata };
}
/**
 * Parse a string serialized in the baggage HTTP Format (without metadata):
 * https://github.com/w3c/baggage/blob/master/baggage/HTTP_HEADER_FORMAT.md
 */
function parseKeyPairsIntoRecord(value) {
    if (typeof value !== 'string' || value.length === 0)
        return {};
    return value
        .split(__WEBPACK_IMPORTED_MODULE_1__constants__["a" /* BAGGAGE_ITEMS_SEPARATOR */])
        .map(function (entry) {
        return parsePairKeyValue(entry);
    })
        .filter(function (keyPair) { return keyPair !== undefined && keyPair.value.length > 0; })
        .reduce(function (headers, keyPair) {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        headers[keyPair.key] = keyPair.value;
        return headers;
    }, {});
}
//# sourceMappingURL=utils.js.map

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = setGlobalErrorHandler;
/* harmony export (immutable) */ __webpack_exports__["a"] = globalErrorHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__logging_error_handler__ = __webpack_require__(914);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/** The global error handler delegate */
var delegateHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__logging_error_handler__["a" /* loggingErrorHandler */])();
/**
 * Set the global error handler
 * @param {ErrorHandler} handler
 */
function setGlobalErrorHandler(handler) {
    delegateHandler = handler;
}
/**
 * Return the global error handler
 * @param {Exception} ex
 */
function globalErrorHandler(ex) {
    try {
        delegateHandler(ex);
    }
    catch (_a) { } // eslint-disable-line no-empty
}
//# sourceMappingURL=global-error-handler.js.map

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hexToBinary;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function intValue(charCode) {
    // 0-9
    if (charCode >= 48 && charCode <= 57) {
        return charCode - 48;
    }
    // a-f
    if (charCode >= 97 && charCode <= 102) {
        return charCode - 87;
    }
    // A-F
    return charCode - 55;
}
function hexToBinary(hexStr) {
    var buf = new Uint8Array(hexStr.length / 2);
    var offset = 0;
    for (var i = 0; i < hexStr.length; i += 2) {
        var hi = intValue(hexStr.charCodeAt(i));
        var lo = intValue(hexStr.charCodeAt(i + 1));
        buf[offset++] = (hi << 4) | lo;
    }
    return buf;
}
//# sourceMappingURL=hex-to-binary.js.map

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loggingErrorHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns a function that logs an error using the provided logger, or a
 * console logger if one was not provided.
 */
function loggingErrorHandler() {
    return function (ex) {
        __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].error(stringifyException(ex));
    };
}
/**
 * Converts an exception into a string representation
 * @param {Exception} ex
 */
function stringifyException(ex) {
    if (typeof ex === 'string') {
        return ex;
    }
    else {
        return JSON.stringify(flattenException(ex));
    }
}
/**
 * Flattens an exception into key-value pairs by traversing the prototype chain
 * and coercing values to strings. Duplicate properties will not be overwritten;
 * the first insert wins.
 */
function flattenException(ex) {
    var result = {};
    var current = ex;
    while (current !== null) {
        Object.getOwnPropertyNames(current).forEach(function (propertyName) {
            if (result[propertyName])
                return;
            var value = current[propertyName];
            if (value) {
                result[propertyName] = String(value);
            }
        });
        current = Object.getPrototypeOf(current);
    }
    return result;
}
//# sourceMappingURL=logging-error-handler.js.map

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _globalThis; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Updates to this file should also be replicated to @opentelemetry/api too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */
/** only globals that common to node and browsers are allowed */
// eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var _globalThis = typeof globalThis === 'object'
    ? globalThis
    : typeof self === 'object'
        ? self
        : typeof window === 'object'
            ? window
            : typeof global === 'object'
                ? global
                : {};
//# sourceMappingURL=globalThis.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(56)))

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__environment__ = __webpack_require__(1926);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__environment__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__environment__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globalThis__ = __webpack_require__(915);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__globalThis__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hex_to_base64__ = __webpack_require__(1927);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__hex_to_base64__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RandomIdGenerator__ = __webpack_require__(1925);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__RandomIdGenerator__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__performance__ = __webpack_require__(1928);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_4__performance__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sdk_info__ = __webpack_require__(1929);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_5__sdk_info__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__timer_util__ = __webpack_require__(1930);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_6__timer_util__["a"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







//# sourceMappingURL=index.js.map

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TraceState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_validators__ = __webpack_require__(1924);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var MAX_TRACE_STATE_ITEMS = 32;
var MAX_TRACE_STATE_LEN = 512;
var LIST_MEMBERS_SEPARATOR = ',';
var LIST_MEMBER_KEY_VALUE_SPLITTER = '=';
/**
 * TraceState must be a class and not a simple object type because of the spec
 * requirement (https://www.w3.org/TR/trace-context/#tracestate-field).
 *
 * Here is the list of allowed mutations:
 * - New key-value pair should be added into the beginning of the list
 * - The value of any key can be updated. Modified keys MUST be moved to the
 * beginning of the list.
 */
var TraceState = /** @class */ (function () {
    function TraceState(rawTraceState) {
        this._internalState = new Map();
        if (rawTraceState)
            this._parse(rawTraceState);
    }
    TraceState.prototype.set = function (key, value) {
        // TODO: Benchmark the different approaches(map vs list) and
        // use the faster one.
        var traceState = this._clone();
        if (traceState._internalState.has(key)) {
            traceState._internalState.delete(key);
        }
        traceState._internalState.set(key, value);
        return traceState;
    };
    TraceState.prototype.unset = function (key) {
        var traceState = this._clone();
        traceState._internalState.delete(key);
        return traceState;
    };
    TraceState.prototype.get = function (key) {
        return this._internalState.get(key);
    };
    TraceState.prototype.serialize = function () {
        var _this = this;
        return this._keys()
            .reduce(function (agg, key) {
            agg.push(key + LIST_MEMBER_KEY_VALUE_SPLITTER + _this.get(key));
            return agg;
        }, [])
            .join(LIST_MEMBERS_SEPARATOR);
    };
    TraceState.prototype._parse = function (rawTraceState) {
        if (rawTraceState.length > MAX_TRACE_STATE_LEN)
            return;
        this._internalState = rawTraceState
            .split(LIST_MEMBERS_SEPARATOR)
            .reverse() // Store in reverse so new keys (.set(...)) will be placed at the beginning
            .reduce(function (agg, part) {
            var listMember = part.trim(); // Optional Whitespace (OWS) handling
            var i = listMember.indexOf(LIST_MEMBER_KEY_VALUE_SPLITTER);
            if (i !== -1) {
                var key = listMember.slice(0, i);
                var value = listMember.slice(i + 1, part.length);
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_validators__["a" /* validateKey */])(key) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_validators__["b" /* validateValue */])(value)) {
                    agg.set(key, value);
                }
                else {
                    // TODO: Consider to add warning log
                }
            }
            return agg;
        }, new Map());
        // Because of the reverse() requirement, trunc must be done after map is created
        if (this._internalState.size > MAX_TRACE_STATE_ITEMS) {
            this._internalState = new Map(Array.from(this._internalState.entries())
                .reverse() // Use reverse same as original tracestate parse chain
                .slice(0, MAX_TRACE_STATE_ITEMS));
        }
    };
    TraceState.prototype._keys = function () {
        return Array.from(this._internalState.keys()).reverse();
    };
    TraceState.prototype._clone = function () {
        var traceState = new TraceState();
        traceState._internalState = new Map(this._internalState);
        return traceState;
    };
    return TraceState;
}());

//# sourceMappingURL=TraceState.js.map

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlwaysOffSampler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @deprecated Use the one defined in @opentelemetry/sdk-trace-base instead.
 * Sampler that samples no traces.
 */
var AlwaysOffSampler = /** @class */ (function () {
    function AlwaysOffSampler() {
    }
    AlwaysOffSampler.prototype.shouldSample = function () {
        return {
            decision: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["SamplingDecision"].NOT_RECORD,
        };
    };
    AlwaysOffSampler.prototype.toString = function () {
        return 'AlwaysOffSampler';
    };
    return AlwaysOffSampler;
}());

//# sourceMappingURL=AlwaysOffSampler.js.map

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AlwaysOnSampler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @deprecated Use the one defined in @opentelemetry/sdk-trace-base instead.
 * Sampler that samples all traces.
 */
var AlwaysOnSampler = /** @class */ (function () {
    function AlwaysOnSampler() {
    }
    AlwaysOnSampler.prototype.shouldSample = function () {
        return {
            decision: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["SamplingDecision"].RECORD_AND_SAMPLED,
        };
    };
    AlwaysOnSampler.prototype.toString = function () {
        return 'AlwaysOnSampler';
    };
    return AlwaysOnSampler;
}());

//# sourceMappingURL=AlwaysOnSampler.js.map

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_ATTRIBUTE_COUNT_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return DEFAULT_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return DEFAULT_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DEFAULT_ENVIRONMENT; });
/* harmony export (immutable) */ __webpack_exports__["f"] = parseEnvironment;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sampling__ = __webpack_require__(921);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var DEFAULT_LIST_SEPARATOR = ',';
/**
 * Environment interface to define all names
 */
var ENVIRONMENT_BOOLEAN_KEYS = ['OTEL_SDK_DISABLED'];
function isEnvVarABoolean(key) {
    return (ENVIRONMENT_BOOLEAN_KEYS.indexOf(key) > -1);
}
var ENVIRONMENT_NUMBERS_KEYS = [
    'OTEL_BSP_EXPORT_TIMEOUT',
    'OTEL_BSP_MAX_EXPORT_BATCH_SIZE',
    'OTEL_BSP_MAX_QUEUE_SIZE',
    'OTEL_BSP_SCHEDULE_DELAY',
    'OTEL_BLRP_EXPORT_TIMEOUT',
    'OTEL_BLRP_MAX_EXPORT_BATCH_SIZE',
    'OTEL_BLRP_MAX_QUEUE_SIZE',
    'OTEL_BLRP_SCHEDULE_DELAY',
    'OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT',
    'OTEL_ATTRIBUTE_COUNT_LIMIT',
    'OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT',
    'OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT',
    'OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT',
    'OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT',
    'OTEL_SPAN_EVENT_COUNT_LIMIT',
    'OTEL_SPAN_LINK_COUNT_LIMIT',
    'OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT',
    'OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT',
    'OTEL_EXPORTER_OTLP_TIMEOUT',
    'OTEL_EXPORTER_OTLP_TRACES_TIMEOUT',
    'OTEL_EXPORTER_OTLP_METRICS_TIMEOUT',
    'OTEL_EXPORTER_OTLP_LOGS_TIMEOUT',
    'OTEL_EXPORTER_JAEGER_AGENT_PORT',
];
function isEnvVarANumber(key) {
    return (ENVIRONMENT_NUMBERS_KEYS.indexOf(key) > -1);
}
var ENVIRONMENT_LISTS_KEYS = [
    'OTEL_NO_PATCH_MODULES',
    'OTEL_PROPAGATORS',
    'OTEL_SEMCONV_STABILITY_OPT_IN',
];
function isEnvVarAList(key) {
    return ENVIRONMENT_LISTS_KEYS.indexOf(key) > -1;
}
var DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT = Infinity;
var DEFAULT_ATTRIBUTE_COUNT_LIMIT = 128;
var DEFAULT_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT = 128;
var DEFAULT_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT = 128;
/**
 * Default environment variables
 */
var DEFAULT_ENVIRONMENT = {
    OTEL_SDK_DISABLED: false,
    CONTAINER_NAME: '',
    ECS_CONTAINER_METADATA_URI_V4: '',
    ECS_CONTAINER_METADATA_URI: '',
    HOSTNAME: '',
    KUBERNETES_SERVICE_HOST: '',
    NAMESPACE: '',
    OTEL_BSP_EXPORT_TIMEOUT: 30000,
    OTEL_BSP_MAX_EXPORT_BATCH_SIZE: 512,
    OTEL_BSP_MAX_QUEUE_SIZE: 2048,
    OTEL_BSP_SCHEDULE_DELAY: 5000,
    OTEL_BLRP_EXPORT_TIMEOUT: 30000,
    OTEL_BLRP_MAX_EXPORT_BATCH_SIZE: 512,
    OTEL_BLRP_MAX_QUEUE_SIZE: 2048,
    OTEL_BLRP_SCHEDULE_DELAY: 5000,
    OTEL_EXPORTER_JAEGER_AGENT_HOST: '',
    OTEL_EXPORTER_JAEGER_AGENT_PORT: 6832,
    OTEL_EXPORTER_JAEGER_ENDPOINT: '',
    OTEL_EXPORTER_JAEGER_PASSWORD: '',
    OTEL_EXPORTER_JAEGER_USER: '',
    OTEL_EXPORTER_OTLP_ENDPOINT: '',
    OTEL_EXPORTER_OTLP_TRACES_ENDPOINT: '',
    OTEL_EXPORTER_OTLP_METRICS_ENDPOINT: '',
    OTEL_EXPORTER_OTLP_LOGS_ENDPOINT: '',
    OTEL_EXPORTER_OTLP_HEADERS: '',
    OTEL_EXPORTER_OTLP_TRACES_HEADERS: '',
    OTEL_EXPORTER_OTLP_METRICS_HEADERS: '',
    OTEL_EXPORTER_OTLP_LOGS_HEADERS: '',
    OTEL_EXPORTER_OTLP_TIMEOUT: 10000,
    OTEL_EXPORTER_OTLP_TRACES_TIMEOUT: 10000,
    OTEL_EXPORTER_OTLP_METRICS_TIMEOUT: 10000,
    OTEL_EXPORTER_OTLP_LOGS_TIMEOUT: 10000,
    OTEL_EXPORTER_ZIPKIN_ENDPOINT: 'http://localhost:9411/api/v2/spans',
    OTEL_LOG_LEVEL: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["DiagLogLevel"].INFO,
    OTEL_NO_PATCH_MODULES: [],
    OTEL_PROPAGATORS: ['tracecontext', 'baggage'],
    OTEL_RESOURCE_ATTRIBUTES: '',
    OTEL_SERVICE_NAME: '',
    OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT: DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT,
    OTEL_ATTRIBUTE_COUNT_LIMIT: DEFAULT_ATTRIBUTE_COUNT_LIMIT,
    OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT: DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT,
    OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT: DEFAULT_ATTRIBUTE_COUNT_LIMIT,
    OTEL_LOGRECORD_ATTRIBUTE_VALUE_LENGTH_LIMIT: DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT,
    OTEL_LOGRECORD_ATTRIBUTE_COUNT_LIMIT: DEFAULT_ATTRIBUTE_COUNT_LIMIT,
    OTEL_SPAN_EVENT_COUNT_LIMIT: 128,
    OTEL_SPAN_LINK_COUNT_LIMIT: 128,
    OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT: DEFAULT_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
    OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT: DEFAULT_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT,
    OTEL_TRACES_EXPORTER: '',
    OTEL_TRACES_SAMPLER: __WEBPACK_IMPORTED_MODULE_1__sampling__["a" /* TracesSamplerValues */].ParentBasedAlwaysOn,
    OTEL_TRACES_SAMPLER_ARG: '',
    OTEL_LOGS_EXPORTER: '',
    OTEL_EXPORTER_OTLP_INSECURE: '',
    OTEL_EXPORTER_OTLP_TRACES_INSECURE: '',
    OTEL_EXPORTER_OTLP_METRICS_INSECURE: '',
    OTEL_EXPORTER_OTLP_LOGS_INSECURE: '',
    OTEL_EXPORTER_OTLP_CERTIFICATE: '',
    OTEL_EXPORTER_OTLP_TRACES_CERTIFICATE: '',
    OTEL_EXPORTER_OTLP_METRICS_CERTIFICATE: '',
    OTEL_EXPORTER_OTLP_LOGS_CERTIFICATE: '',
    OTEL_EXPORTER_OTLP_COMPRESSION: '',
    OTEL_EXPORTER_OTLP_TRACES_COMPRESSION: '',
    OTEL_EXPORTER_OTLP_METRICS_COMPRESSION: '',
    OTEL_EXPORTER_OTLP_LOGS_COMPRESSION: '',
    OTEL_EXPORTER_OTLP_CLIENT_KEY: '',
    OTEL_EXPORTER_OTLP_TRACES_CLIENT_KEY: '',
    OTEL_EXPORTER_OTLP_METRICS_CLIENT_KEY: '',
    OTEL_EXPORTER_OTLP_LOGS_CLIENT_KEY: '',
    OTEL_EXPORTER_OTLP_CLIENT_CERTIFICATE: '',
    OTEL_EXPORTER_OTLP_TRACES_CLIENT_CERTIFICATE: '',
    OTEL_EXPORTER_OTLP_METRICS_CLIENT_CERTIFICATE: '',
    OTEL_EXPORTER_OTLP_LOGS_CLIENT_CERTIFICATE: '',
    OTEL_EXPORTER_OTLP_PROTOCOL: 'http/protobuf',
    OTEL_EXPORTER_OTLP_TRACES_PROTOCOL: 'http/protobuf',
    OTEL_EXPORTER_OTLP_METRICS_PROTOCOL: 'http/protobuf',
    OTEL_EXPORTER_OTLP_LOGS_PROTOCOL: 'http/protobuf',
    OTEL_EXPORTER_OTLP_METRICS_TEMPORALITY_PREFERENCE: 'cumulative',
    OTEL_SEMCONV_STABILITY_OPT_IN: [],
};
/**
 * @param key
 * @param environment
 * @param values
 */
function parseBoolean(key, environment, values) {
    if (typeof values[key] === 'undefined') {
        return;
    }
    var value = String(values[key]);
    // support case-insensitive "true"
    environment[key] = value.toLowerCase() === 'true';
}
/**
 * Parses a variable as number with number validation
 * @param name
 * @param environment
 * @param values
 * @param min
 * @param max
 */
function parseNumber(name, environment, values, min, max) {
    if (min === void 0) { min = -Infinity; }
    if (max === void 0) { max = Infinity; }
    if (typeof values[name] !== 'undefined') {
        var value = Number(values[name]);
        if (!isNaN(value)) {
            if (value < min) {
                environment[name] = min;
            }
            else if (value > max) {
                environment[name] = max;
            }
            else {
                environment[name] = value;
            }
        }
    }
}
/**
 * Parses list-like strings from input into output.
 * @param name
 * @param environment
 * @param values
 * @param separator
 */
function parseStringList(name, output, input, separator) {
    if (separator === void 0) { separator = DEFAULT_LIST_SEPARATOR; }
    var givenValue = input[name];
    if (typeof givenValue === 'string') {
        output[name] = givenValue.split(separator).map(function (v) { return v.trim(); });
    }
}
// The support string -> DiagLogLevel mappings
var logLevelMap = {
    ALL: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["DiagLogLevel"].ALL,
    VERBOSE: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["DiagLogLevel"].VERBOSE,
    DEBUG: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["DiagLogLevel"].DEBUG,
    INFO: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["DiagLogLevel"].INFO,
    WARN: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["DiagLogLevel"].WARN,
    ERROR: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["DiagLogLevel"].ERROR,
    NONE: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["DiagLogLevel"].NONE,
};
/**
 * Environmentally sets log level if valid log level string is provided
 * @param key
 * @param environment
 * @param values
 */
function setLogLevelFromEnv(key, environment, values) {
    var value = values[key];
    if (typeof value === 'string') {
        var theLevel = logLevelMap[value.toUpperCase()];
        if (theLevel != null) {
            environment[key] = theLevel;
        }
    }
}
/**
 * Parses environment values
 * @param values
 */
function parseEnvironment(values) {
    var environment = {};
    for (var env in DEFAULT_ENVIRONMENT) {
        var key = env;
        switch (key) {
            case 'OTEL_LOG_LEVEL':
                setLogLevelFromEnv(key, environment, values);
                break;
            default:
                if (isEnvVarABoolean(key)) {
                    parseBoolean(key, environment, values);
                }
                else if (isEnvVarANumber(key)) {
                    parseNumber(key, environment, values);
                }
                else if (isEnvVarAList(key)) {
                    parseStringList(key, environment, values);
                }
                else {
                    var value = values[key];
                    if (typeof value !== 'undefined' && value !== null) {
                        environment[key] = String(value);
                    }
                }
        }
    }
    return environment;
}
//# sourceMappingURL=environment.js.map

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TracesSamplerValues; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TracesSamplerValues;
(function (TracesSamplerValues) {
    TracesSamplerValues["AlwaysOff"] = "always_off";
    TracesSamplerValues["AlwaysOn"] = "always_on";
    TracesSamplerValues["ParentBasedAlwaysOff"] = "parentbased_always_off";
    TracesSamplerValues["ParentBasedAlwaysOn"] = "parentbased_always_on";
    TracesSamplerValues["ParentBasedTraceIdRatio"] = "parentbased_traceidratio";
    TracesSamplerValues["TraceIdRatio"] = "traceidratio";
})(TracesSamplerValues || (TracesSamplerValues = {}));
//# sourceMappingURL=sampling.js.map

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VERSION; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// this is autogenerated file, see scripts/version-update.js
var VERSION = '1.30.1';
//# sourceMappingURL=version.js.map

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttributeNames; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var AttributeNames;
(function (AttributeNames) {
    AttributeNames["DOCUMENT_LOAD"] = "documentLoad";
    AttributeNames["DOCUMENT_FETCH"] = "documentFetch";
    AttributeNames["RESOURCE_FETCH"] = "resourceFetch";
})(AttributeNames || (AttributeNames = {}));
//# sourceMappingURL=AttributeNames.js.map

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttributeNames; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var AttributeNames;
(function (AttributeNames) {
    AttributeNames["EVENT_TYPE"] = "event_type";
    AttributeNames["TARGET_ELEMENT"] = "target_element";
    AttributeNames["TARGET_XPATH"] = "target_xpath";
    AttributeNames["HTTP_URL"] = "http.url";
})(AttributeNames || (AttributeNames = {}));
//# sourceMappingURL=AttributeNames.js.map

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instrumentation__ = __webpack_require__(1972);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__instrumentation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop_normalize__ = __webpack_require__(1973);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__noop_normalize__["a"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


//# sourceMappingURL=index.js.map

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = convertLegacyBrowserHttpOptions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__otlp_http_configuration__ = __webpack_require__(1979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_configuration__ = __webpack_require__(537);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * @deprecated this will be removed in 2.0
 *
 * @param config
 * @param signalResourcePath
 * @param requiredHeaders
 */
function convertLegacyBrowserHttpOptions(config, signalResourcePath, requiredHeaders) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__otlp_http_configuration__["a" /* mergeOtlpHttpConfigurationWithDefaults */])({
        url: config.url,
        timeoutMillis: config.timeoutMillis,
        headers: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_configuration__["a" /* wrapStaticHeadersInFunction */])(config.headers),
        concurrencyLimit: config.concurrencyLimit,
    }, {}, // no fallback for browser case
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__otlp_http_configuration__["b" /* getHttpConfigurationDefaults */])(requiredHeaders, signalResourcePath));
}
//# sourceMappingURL=convert-legacy-browser-http-options.js.map

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createOtlpXhrExportDelegate;
/* harmony export (immutable) */ __webpack_exports__["b"] = createOtlpSendBeaconExportDelegate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__retrying_transport__ = __webpack_require__(1985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__transport_xhr_transport__ = __webpack_require__(1987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__transport_send_beacon_transport__ = __webpack_require__(1986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__otlp_network_export_delegate__ = __webpack_require__(928);




function createOtlpXhrExportDelegate(options, serializer) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__otlp_network_export_delegate__["a" /* createOtlpNetworkExportDelegate */])(options, serializer, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__retrying_transport__["a" /* createRetryingTransport */])({
        transport: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__transport_xhr_transport__["a" /* createXhrTransport */])(options),
    }));
}
function createOtlpSendBeaconExportDelegate(options, serializer) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__otlp_network_export_delegate__["a" /* createOtlpNetworkExportDelegate */])(options, serializer, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__retrying_transport__["a" /* createRetryingTransport */])({
        transport: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__transport_send_beacon_transport__["a" /* createSendBeaconTransport */])({
            url: options.url,
            blobType: options.headers()['Content-Type'],
        }),
    }));
}
//# sourceMappingURL=otlp-browser-http-export-delegate.js.map

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createOtlpNetworkExportDelegate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bounded_queue_export_promise_handler__ = __webpack_require__(1976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__otlp_export_delegate__ = __webpack_require__(1984);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


function createOtlpNetworkExportDelegate(options, serializer, transport) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__otlp_export_delegate__["a" /* createOtlpExportDelegate */])({
        transport: transport,
        serializer: serializer,
        promiseHandler: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__bounded_queue_export_promise_handler__["a" /* createBoundedQueueExportPromiseHandler */])(options),
    }, { timeout: options.timeoutMillis });
}
//# sourceMappingURL=otlp-network-export-delegate.js.map

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OTLPExporterError; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Interface for handling error
 */
var OTLPExporterError = /** @class */ (function (_super) {
    __extends(OTLPExporterError, _super);
    function OTLPExporterError(message, code, data) {
        var _this = _super.call(this, message) || this;
        _this.name = 'OTLPExporterError';
        _this.data = data;
        _this.code = code;
        return _this;
    }
    return OTLPExporterError;
}(Error));

//# sourceMappingURL=types.js.map

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return browserDetectorSync; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_semantic_conventions__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Resource__ = __webpack_require__(304);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



/**
 * BrowserDetectorSync will be used to detect the resources related to browser.
 */
var BrowserDetectorSync = /** @class */ (function () {
    function BrowserDetectorSync() {
    }
    BrowserDetectorSync.prototype.detect = function (config) {
        var _a;
        var _b, _c, _d;
        var isBrowser = typeof navigator !== 'undefined' &&
            ((_c = (_b = global.process) === null || _b === void 0 ? void 0 : _b.versions) === null || _c === void 0 ? void 0 : _c.node) === undefined && // Node.js v21 adds `navigator`
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore don't have Bun types
            ((_d = global.Bun) === null || _d === void 0 ? void 0 : _d.version) === undefined; // Bun (bun.sh) defines `navigator`
        if (!isBrowser) {
            return __WEBPACK_IMPORTED_MODULE_2__Resource__["a" /* Resource */].empty();
        }
        var browserResource = (_a = {},
            _a[__WEBPACK_IMPORTED_MODULE_0__opentelemetry_semantic_conventions__["n" /* SEMRESATTRS_PROCESS_RUNTIME_NAME */]] = 'browser',
            _a[__WEBPACK_IMPORTED_MODULE_0__opentelemetry_semantic_conventions__["o" /* SEMRESATTRS_PROCESS_RUNTIME_DESCRIPTION */]] = 'Web Browser',
            _a[__WEBPACK_IMPORTED_MODULE_0__opentelemetry_semantic_conventions__["p" /* SEMRESATTRS_PROCESS_RUNTIME_VERSION */]] = navigator.userAgent,
            _a);
        return this._getResourceAttributes(browserResource, config);
    };
    /**
     * Validates process resource attribute map from process variables
     *
     * @param browserResource The un-sanitized resource attributes from process as key/value pairs.
     * @param config: Config
     * @returns The sanitized resource attributes.
     */
    BrowserDetectorSync.prototype._getResourceAttributes = function (browserResource, _config) {
        if (browserResource[__WEBPACK_IMPORTED_MODULE_0__opentelemetry_semantic_conventions__["p" /* SEMRESATTRS_PROCESS_RUNTIME_VERSION */]] === '') {
            __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__["diag"].debug('BrowserDetector failed: Unable to find required browser resources. ');
            return __WEBPACK_IMPORTED_MODULE_2__Resource__["a" /* Resource */].empty();
        }
        else {
            return new __WEBPACK_IMPORTED_MODULE_2__Resource__["a" /* Resource */](__assign({}, browserResource));
        }
    };
    return BrowserDetectorSync;
}());
var browserDetectorSync = new BrowserDetectorSync();
//# sourceMappingURL=BrowserDetectorSync.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(56)))

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return envDetectorSync; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__opentelemetry_semantic_conventions__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Resource__ = __webpack_require__(304);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};




/**
 * EnvDetectorSync can be used to detect the presence of and create a Resource
 * from the OTEL_RESOURCE_ATTRIBUTES environment variable.
 */
var EnvDetectorSync = /** @class */ (function () {
    function EnvDetectorSync() {
        // Type, attribute keys, and attribute values should not exceed 256 characters.
        this._MAX_LENGTH = 255;
        // OTEL_RESOURCE_ATTRIBUTES is a comma-separated list of attributes.
        this._COMMA_SEPARATOR = ',';
        // OTEL_RESOURCE_ATTRIBUTES contains key value pair separated by '='.
        this._LABEL_KEY_VALUE_SPLITTER = '=';
        this._ERROR_MESSAGE_INVALID_CHARS = 'should be a ASCII string with a length greater than 0 and not exceed ' +
            this._MAX_LENGTH +
            ' characters.';
        this._ERROR_MESSAGE_INVALID_VALUE = 'should be a ASCII string with a length not exceed ' +
            this._MAX_LENGTH +
            ' characters.';
    }
    /**
     * Returns a {@link Resource} populated with attributes from the
     * OTEL_RESOURCE_ATTRIBUTES environment variable. Note this is an async
     * function to conform to the Detector interface.
     *
     * @param config The resource detection config
     */
    EnvDetectorSync.prototype.detect = function (_config) {
        var attributes = {};
        var env = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["getEnv"])();
        var rawAttributes = env.OTEL_RESOURCE_ATTRIBUTES;
        var serviceName = env.OTEL_SERVICE_NAME;
        if (rawAttributes) {
            try {
                var parsedAttributes = this._parseResourceAttributes(rawAttributes);
                Object.assign(attributes, parsedAttributes);
            }
            catch (e) {
                __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].debug("EnvDetector failed: " + e.message);
            }
        }
        if (serviceName) {
            attributes[__WEBPACK_IMPORTED_MODULE_2__opentelemetry_semantic_conventions__["m" /* SEMRESATTRS_SERVICE_NAME */]] = serviceName;
        }
        return new __WEBPACK_IMPORTED_MODULE_3__Resource__["a" /* Resource */](attributes);
    };
    /**
     * Creates an attribute map from the OTEL_RESOURCE_ATTRIBUTES environment
     * variable.
     *
     * OTEL_RESOURCE_ATTRIBUTES: A comma-separated list of attributes describing
     * the source in more detail, e.g. “key1=val1,key2=val2”. Domain names and
     * paths are accepted as attribute keys. Values may be quoted or unquoted in
     * general. If a value contains whitespace, =, or " characters, it must
     * always be quoted.
     *
     * @param rawEnvAttributes The resource attributes as a comma-separated list
     * of key/value pairs.
     * @returns The sanitized resource attributes.
     */
    EnvDetectorSync.prototype._parseResourceAttributes = function (rawEnvAttributes) {
        var e_1, _a;
        if (!rawEnvAttributes)
            return {};
        var attributes = {};
        var rawAttributes = rawEnvAttributes.split(this._COMMA_SEPARATOR, -1);
        try {
            for (var rawAttributes_1 = __values(rawAttributes), rawAttributes_1_1 = rawAttributes_1.next(); !rawAttributes_1_1.done; rawAttributes_1_1 = rawAttributes_1.next()) {
                var rawAttribute = rawAttributes_1_1.value;
                var keyValuePair = rawAttribute.split(this._LABEL_KEY_VALUE_SPLITTER, -1);
                if (keyValuePair.length !== 2) {
                    continue;
                }
                var _b = __read(keyValuePair, 2), key = _b[0], value = _b[1];
                // Leading and trailing whitespaces are trimmed.
                key = key.trim();
                value = value.trim().split(/^"|"$/).join('');
                if (!this._isValidAndNotEmpty(key)) {
                    throw new Error("Attribute key " + this._ERROR_MESSAGE_INVALID_CHARS);
                }
                if (!this._isValid(value)) {
                    throw new Error("Attribute value " + this._ERROR_MESSAGE_INVALID_VALUE);
                }
                attributes[key] = decodeURIComponent(value);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (rawAttributes_1_1 && !rawAttributes_1_1.done && (_a = rawAttributes_1.return)) _a.call(rawAttributes_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return attributes;
    };
    /**
     * Determines whether the given String is a valid printable ASCII string with
     * a length not exceed _MAX_LENGTH characters.
     *
     * @param str The String to be validated.
     * @returns Whether the String is valid.
     */
    EnvDetectorSync.prototype._isValid = function (name) {
        return name.length <= this._MAX_LENGTH && this._isBaggageOctetString(name);
    };
    // https://www.w3.org/TR/baggage/#definition
    EnvDetectorSync.prototype._isBaggageOctetString = function (str) {
        for (var i = 0; i < str.length; i++) {
            var ch = str.charCodeAt(i);
            if (ch < 0x21 || ch === 0x2c || ch === 0x3b || ch === 0x5c || ch > 0x7e) {
                return false;
            }
        }
        return true;
    };
    /**
     * Determines whether the given String is a valid printable ASCII string with
     * a length greater than 0 and not exceed _MAX_LENGTH characters.
     *
     * @param str The String to be validated.
     * @returns Whether the String is valid and not empty.
     */
    EnvDetectorSync.prototype._isValidAndNotEmpty = function (str) {
        return str.length > 0 && this._isValid(str);
    };
    return EnvDetectorSync;
}());
var envDetectorSync = new EnvDetectorSync();
//# sourceMappingURL=EnvDetectorSync.js.map

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resource__ = __webpack_require__(304);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resource", function() { return __WEBPACK_IMPORTED_MODULE_0__Resource__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__platform__ = __webpack_require__(933);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultServiceName", function() { return __WEBPACK_IMPORTED_MODULE_1__platform__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__detectors__ = __webpack_require__(1997);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "browserDetector", function() { return __WEBPACK_IMPORTED_MODULE_2__detectors__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "browserDetectorSync", function() { return __WEBPACK_IMPORTED_MODULE_2__detectors__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "envDetector", function() { return __WEBPACK_IMPORTED_MODULE_2__detectors__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "envDetectorSync", function() { return __WEBPACK_IMPORTED_MODULE_2__detectors__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hostDetector", function() { return __WEBPACK_IMPORTED_MODULE_2__detectors__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "hostDetectorSync", function() { return __WEBPACK_IMPORTED_MODULE_2__detectors__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "osDetector", function() { return __WEBPACK_IMPORTED_MODULE_2__detectors__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "osDetectorSync", function() { return __WEBPACK_IMPORTED_MODULE_2__detectors__["h"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "processDetector", function() { return __WEBPACK_IMPORTED_MODULE_2__detectors__["i"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "processDetectorSync", function() { return __WEBPACK_IMPORTED_MODULE_2__detectors__["j"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "serviceInstanceIdDetectorSync", function() { return __WEBPACK_IMPORTED_MODULE_2__detectors__["k"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__detect_resources__ = __webpack_require__(1994);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "detectResourcesSync", function() { return __WEBPACK_IMPORTED_MODULE_3__detect_resources__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "detectResources", function() { return __WEBPACK_IMPORTED_MODULE_3__detect_resources__["b"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




//# sourceMappingURL=index.js.map

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__default_service_name__ = __webpack_require__(2006);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__default_service_name__["a"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Span; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__opentelemetry_semantic_conventions__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums__ = __webpack_require__(2010);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};




/**
 * This class represents a span.
 */
var Span = /** @class */ (function () {
    /**
     * Constructs a new Span instance.
     *
     * @deprecated calling Span constructor directly is not supported. Please use tracer.startSpan.
     * */
    function Span(parentTracer, context, spanName, spanContext, kind, parentSpanId, links, startTime, _deprecatedClock, // keeping this argument even though it is unused to ensure backwards compatibility
    attributes) {
        if (links === void 0) { links = []; }
        this.attributes = {};
        this.links = [];
        this.events = [];
        this._droppedAttributesCount = 0;
        this._droppedEventsCount = 0;
        this._droppedLinksCount = 0;
        this.status = {
            code: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["SpanStatusCode"].UNSET,
        };
        this.endTime = [0, 0];
        this._ended = false;
        this._duration = [-1, -1];
        this.name = spanName;
        this._spanContext = spanContext;
        this.parentSpanId = parentSpanId;
        this.kind = kind;
        this.links = links;
        var now = Date.now();
        this._performanceStartTime = __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["otperformance"].now();
        this._performanceOffset =
            now - (this._performanceStartTime + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["getTimeOrigin"])());
        this._startTimeProvided = startTime != null;
        this.startTime = this._getTime(startTime !== null && startTime !== void 0 ? startTime : now);
        this.resource = parentTracer.resource;
        this.instrumentationLibrary = parentTracer.instrumentationLibrary;
        this._spanLimits = parentTracer.getSpanLimits();
        this._attributeValueLengthLimit =
            this._spanLimits.attributeValueLengthLimit || 0;
        if (attributes != null) {
            this.setAttributes(attributes);
        }
        this._spanProcessor = parentTracer.getActiveSpanProcessor();
        this._spanProcessor.onStart(this, context);
    }
    Span.prototype.spanContext = function () {
        return this._spanContext;
    };
    Span.prototype.setAttribute = function (key, value) {
        if (value == null || this._isSpanEnded())
            return this;
        if (key.length === 0) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn("Invalid attribute key: " + key);
            return this;
        }
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["isAttributeValue"])(value)) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn("Invalid attribute value set for key: " + key);
            return this;
        }
        if (Object.keys(this.attributes).length >=
            this._spanLimits.attributeCountLimit &&
            !Object.prototype.hasOwnProperty.call(this.attributes, key)) {
            this._droppedAttributesCount++;
            return this;
        }
        this.attributes[key] = this._truncateToSize(value);
        return this;
    };
    Span.prototype.setAttributes = function (attributes) {
        var e_1, _a;
        try {
            for (var _b = __values(Object.entries(attributes)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var _d = __read(_c.value, 2), k = _d[0], v = _d[1];
                this.setAttribute(k, v);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return this;
    };
    /**
     *
     * @param name Span Name
     * @param [attributesOrStartTime] Span attributes or start time
     *     if type is {@type TimeInput} and 3rd param is undefined
     * @param [timeStamp] Specified time stamp for the event
     */
    Span.prototype.addEvent = function (name, attributesOrStartTime, timeStamp) {
        if (this._isSpanEnded())
            return this;
        if (this._spanLimits.eventCountLimit === 0) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn('No events allowed.');
            this._droppedEventsCount++;
            return this;
        }
        if (this.events.length >= this._spanLimits.eventCountLimit) {
            if (this._droppedEventsCount === 0) {
                __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].debug('Dropping extra events.');
            }
            this.events.shift();
            this._droppedEventsCount++;
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["isTimeInput"])(attributesOrStartTime)) {
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["isTimeInput"])(timeStamp)) {
                timeStamp = attributesOrStartTime;
            }
            attributesOrStartTime = undefined;
        }
        var attributes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["sanitizeAttributes"])(attributesOrStartTime);
        this.events.push({
            name: name,
            attributes: attributes,
            time: this._getTime(timeStamp),
            droppedAttributesCount: 0,
        });
        return this;
    };
    Span.prototype.addLink = function (link) {
        this.links.push(link);
        return this;
    };
    Span.prototype.addLinks = function (links) {
        var _a;
        (_a = this.links).push.apply(_a, __spreadArray([], __read(links), false));
        return this;
    };
    Span.prototype.setStatus = function (status) {
        if (this._isSpanEnded())
            return this;
        this.status = __assign({}, status);
        // When using try-catch, the caught "error" is of type `any`. When then assigning `any` to `status.message`,
        // TypeScript will not error. While this can happen during use of any API, it is more common on Span#setStatus()
        // as it's likely used in a catch-block. Therefore, we validate if `status.message` is actually a string, null, or
        // undefined to avoid an incorrect type causing issues downstream.
        if (this.status.message != null && typeof status.message !== 'string') {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn("Dropping invalid status.message of type '" + typeof status.message + "', expected 'string'");
            delete this.status.message;
        }
        return this;
    };
    Span.prototype.updateName = function (name) {
        if (this._isSpanEnded())
            return this;
        this.name = name;
        return this;
    };
    Span.prototype.end = function (endTime) {
        if (this._isSpanEnded()) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].error(this.name + " " + this._spanContext.traceId + "-" + this._spanContext.spanId + " - You can only call end() on a span once.");
            return;
        }
        this._ended = true;
        this.endTime = this._getTime(endTime);
        this._duration = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["hrTimeDuration"])(this.startTime, this.endTime);
        if (this._duration[0] < 0) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn('Inconsistent start and end time, startTime > endTime. Setting span duration to 0ms.', this.startTime, this.endTime);
            this.endTime = this.startTime.slice();
            this._duration = [0, 0];
        }
        if (this._droppedEventsCount > 0) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn("Dropped " + this._droppedEventsCount + " events because eventCountLimit reached");
        }
        this._spanProcessor.onEnd(this);
    };
    Span.prototype._getTime = function (inp) {
        if (typeof inp === 'number' && inp <= __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["otperformance"].now()) {
            // must be a performance timestamp
            // apply correction and convert to hrtime
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["hrTime"])(inp + this._performanceOffset);
        }
        if (typeof inp === 'number') {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["millisToHrTime"])(inp);
        }
        if (inp instanceof Date) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["millisToHrTime"])(inp.getTime());
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["isTimeInputHrTime"])(inp)) {
            return inp;
        }
        if (this._startTimeProvided) {
            // if user provided a time for the start manually
            // we can't use duration to calculate event/end times
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["millisToHrTime"])(Date.now());
        }
        var msDuration = __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["otperformance"].now() - this._performanceStartTime;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["addHrTimes"])(this.startTime, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["millisToHrTime"])(msDuration));
    };
    Span.prototype.isRecording = function () {
        return this._ended === false;
    };
    Span.prototype.recordException = function (exception, time) {
        var attributes = {};
        if (typeof exception === 'string') {
            attributes[__WEBPACK_IMPORTED_MODULE_2__opentelemetry_semantic_conventions__["j" /* SEMATTRS_EXCEPTION_MESSAGE */]] = exception;
        }
        else if (exception) {
            if (exception.code) {
                attributes[__WEBPACK_IMPORTED_MODULE_2__opentelemetry_semantic_conventions__["k" /* SEMATTRS_EXCEPTION_TYPE */]] = exception.code.toString();
            }
            else if (exception.name) {
                attributes[__WEBPACK_IMPORTED_MODULE_2__opentelemetry_semantic_conventions__["k" /* SEMATTRS_EXCEPTION_TYPE */]] = exception.name;
            }
            if (exception.message) {
                attributes[__WEBPACK_IMPORTED_MODULE_2__opentelemetry_semantic_conventions__["j" /* SEMATTRS_EXCEPTION_MESSAGE */]] = exception.message;
            }
            if (exception.stack) {
                attributes[__WEBPACK_IMPORTED_MODULE_2__opentelemetry_semantic_conventions__["l" /* SEMATTRS_EXCEPTION_STACKTRACE */]] = exception.stack;
            }
        }
        // these are minimum requirements from spec
        if (attributes[__WEBPACK_IMPORTED_MODULE_2__opentelemetry_semantic_conventions__["k" /* SEMATTRS_EXCEPTION_TYPE */]] ||
            attributes[__WEBPACK_IMPORTED_MODULE_2__opentelemetry_semantic_conventions__["j" /* SEMATTRS_EXCEPTION_MESSAGE */]]) {
            this.addEvent(__WEBPACK_IMPORTED_MODULE_3__enums__["a" /* ExceptionEventName */], attributes, time);
        }
        else {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn("Failed to record an exception " + exception);
        }
    };
    Object.defineProperty(Span.prototype, "duration", {
        get: function () {
            return this._duration;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "ended", {
        get: function () {
            return this._ended;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "droppedAttributesCount", {
        get: function () {
            return this._droppedAttributesCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "droppedEventsCount", {
        get: function () {
            return this._droppedEventsCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Span.prototype, "droppedLinksCount", {
        get: function () {
            return this._droppedLinksCount;
        },
        enumerable: false,
        configurable: true
    });
    Span.prototype._isSpanEnded = function () {
        if (this._ended) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn("Can not execute the operation on ended Span {traceId: " + this._spanContext.traceId + ", spanId: " + this._spanContext.spanId + "}");
        }
        return this._ended;
    };
    // Utility function to truncate given value within size
    // for value type of string, will truncate to given limit
    // for type of non-string, will return same value
    Span.prototype._truncateToLimitUtil = function (value, limit) {
        if (value.length <= limit) {
            return value;
        }
        return value.substring(0, limit);
    };
    /**
     * If the given attribute value is of type string and has more characters than given {@code attributeValueLengthLimit} then
     * return string with truncated to {@code attributeValueLengthLimit} characters
     *
     * If the given attribute value is array of strings then
     * return new array of strings with each element truncated to {@code attributeValueLengthLimit} characters
     *
     * Otherwise return same Attribute {@code value}
     *
     * @param value Attribute value
     * @returns truncated attribute value if required, otherwise same value
     */
    Span.prototype._truncateToSize = function (value) {
        var _this = this;
        var limit = this._attributeValueLengthLimit;
        // Check limit
        if (limit <= 0) {
            // Negative values are invalid, so do not truncate
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn("Attribute value limit must be positive, got " + limit);
            return value;
        }
        // String
        if (typeof value === 'string') {
            return this._truncateToLimitUtil(value, limit);
        }
        // Array of strings
        if (Array.isArray(value)) {
            return value.map(function (val) {
                return typeof val === 'string' ? _this._truncateToLimitUtil(val, limit) : val;
            });
        }
        // Other types, no need to apply value length limit
        return value;
    };
    return Span;
}());

//# sourceMappingURL=Span.js.map

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Tracer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Span__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utility__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__platform__ = __webpack_require__(539);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





/**
 * This class represents a basic tracer.
 */
var Tracer = /** @class */ (function () {
    /**
     * Constructs a new Tracer instance.
     */
    function Tracer(instrumentationLibrary, config, _tracerProvider) {
        this._tracerProvider = _tracerProvider;
        var localConfig = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utility__["b" /* mergeConfig */])(config);
        this._sampler = localConfig.sampler;
        this._generalLimits = localConfig.generalLimits;
        this._spanLimits = localConfig.spanLimits;
        this._idGenerator = config.idGenerator || new __WEBPACK_IMPORTED_MODULE_4__platform__["b" /* RandomIdGenerator */]();
        this.resource = _tracerProvider.resource;
        this.instrumentationLibrary = instrumentationLibrary;
    }
    /**
     * Starts a new Span or returns the default NoopSpan based on the sampling
     * decision.
     */
    Tracer.prototype.startSpan = function (name, options, context) {
        var _a, _b, _c;
        if (options === void 0) { options = {}; }
        if (context === void 0) { context = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].active(); }
        // remove span from context in case a root span is requested via options
        if (options.root) {
            context = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].deleteSpan(context);
        }
        var parentSpan = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].getSpan(context);
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["isTracingSuppressed"])(context)) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].debug('Instrumentation suppressed, returning Noop Span');
            var nonRecordingSpan = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].wrapSpanContext(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["INVALID_SPAN_CONTEXT"]);
            return nonRecordingSpan;
        }
        var parentSpanContext = parentSpan === null || parentSpan === void 0 ? void 0 : parentSpan.spanContext();
        var spanId = this._idGenerator.generateSpanId();
        var traceId;
        var traceState;
        var parentSpanId;
        if (!parentSpanContext ||
            !__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].isSpanContextValid(parentSpanContext)) {
            // New root span.
            traceId = this._idGenerator.generateTraceId();
        }
        else {
            // New child span.
            traceId = parentSpanContext.traceId;
            traceState = parentSpanContext.traceState;
            parentSpanId = parentSpanContext.spanId;
        }
        var spanKind = (_a = options.kind) !== null && _a !== void 0 ? _a : __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["SpanKind"].INTERNAL;
        var links = ((_b = options.links) !== null && _b !== void 0 ? _b : []).map(function (link) {
            return {
                context: link.context,
                attributes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["sanitizeAttributes"])(link.attributes),
            };
        });
        var attributes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["sanitizeAttributes"])(options.attributes);
        // make sampling decision
        var samplingResult = this._sampler.shouldSample(context, traceId, name, spanKind, attributes, links);
        traceState = (_c = samplingResult.traceState) !== null && _c !== void 0 ? _c : traceState;
        var traceFlags = samplingResult.decision === __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["SamplingDecision"].RECORD_AND_SAMPLED
            ? __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["TraceFlags"].SAMPLED
            : __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["TraceFlags"].NONE;
        var spanContext = { traceId: traceId, spanId: spanId, traceFlags: traceFlags, traceState: traceState };
        if (samplingResult.decision === __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["SamplingDecision"].NOT_RECORD) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].debug('Recording is off, propagating context in a non-recording span');
            var nonRecordingSpan = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].wrapSpanContext(spanContext);
            return nonRecordingSpan;
        }
        // Set initial span attributes. The attributes object may have been mutated
        // by the sampler, so we sanitize the merged attributes before setting them.
        var initAttributes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["sanitizeAttributes"])(Object.assign(attributes, samplingResult.attributes));
        var span = new __WEBPACK_IMPORTED_MODULE_2__Span__["a" /* Span */](this, context, name, spanContext, spanKind, parentSpanId, links, options.startTime, undefined, initAttributes);
        return span;
    };
    Tracer.prototype.startActiveSpan = function (name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) {
            return;
        }
        else if (arguments.length === 2) {
            fn = arg2;
        }
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        }
        else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].setSpan(parentContext, span);
        return __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].with(contextWithSpanSet, fn, undefined, span);
    };
    /** Returns the active {@link GeneralLimits}. */
    Tracer.prototype.getGeneralLimits = function () {
        return this._generalLimits;
    };
    /** Returns the active {@link SpanLimits}. */
    Tracer.prototype.getSpanLimits = function () {
        return this._spanLimits;
    };
    Tracer.prototype.getActiveSpanProcessor = function () {
        return this._tracerProvider.getActiveSpanProcessor();
    };
    return Tracer;
}());

//# sourceMappingURL=Tracer.js.map

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loadDefaultConfig;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildSamplerFromEnv;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sampler_AlwaysOffSampler__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sampler_AlwaysOnSampler__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sampler_ParentBasedSampler__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__sampler_TraceIdRatioBasedSampler__ = __webpack_require__(939);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var FALLBACK_OTEL_TRACES_SAMPLER = __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["TracesSamplerValues"].AlwaysOn;
var DEFAULT_RATIO = 1;
/**
 * Load default configuration. For fields with primitive values, any user-provided
 * value will override the corresponding default value. For fields with
 * non-primitive values (like `spanLimits`), the user-provided value will be
 * used to extend the default value.
 */
// object needs to be wrapped in this function and called when needed otherwise
// envs are parsed before tests are ran - causes tests using these envs to fail
function loadDefaultConfig() {
    var env = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["getEnv"])();
    return {
        sampler: buildSamplerFromEnv(env),
        forceFlushTimeoutMillis: 30000,
        generalLimits: {
            attributeValueLengthLimit: env.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT,
            attributeCountLimit: env.OTEL_ATTRIBUTE_COUNT_LIMIT,
        },
        spanLimits: {
            attributeValueLengthLimit: env.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT,
            attributeCountLimit: env.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT,
            linkCountLimit: env.OTEL_SPAN_LINK_COUNT_LIMIT,
            eventCountLimit: env.OTEL_SPAN_EVENT_COUNT_LIMIT,
            attributePerEventCountLimit: env.OTEL_SPAN_ATTRIBUTE_PER_EVENT_COUNT_LIMIT,
            attributePerLinkCountLimit: env.OTEL_SPAN_ATTRIBUTE_PER_LINK_COUNT_LIMIT,
        },
        mergeResourceWithDefaults: true,
    };
}
/**
 * Based on environment, builds a sampler, complies with specification.
 * @param environment optional, by default uses getEnv(), but allows passing a value to reuse parsed environment
 */
function buildSamplerFromEnv(environment) {
    if (environment === void 0) { environment = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["getEnv"])(); }
    switch (environment.OTEL_TRACES_SAMPLER) {
        case __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["TracesSamplerValues"].AlwaysOn:
            return new __WEBPACK_IMPORTED_MODULE_3__sampler_AlwaysOnSampler__["a" /* AlwaysOnSampler */]();
        case __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["TracesSamplerValues"].AlwaysOff:
            return new __WEBPACK_IMPORTED_MODULE_2__sampler_AlwaysOffSampler__["a" /* AlwaysOffSampler */]();
        case __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["TracesSamplerValues"].ParentBasedAlwaysOn:
            return new __WEBPACK_IMPORTED_MODULE_4__sampler_ParentBasedSampler__["a" /* ParentBasedSampler */]({
                root: new __WEBPACK_IMPORTED_MODULE_3__sampler_AlwaysOnSampler__["a" /* AlwaysOnSampler */](),
            });
        case __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["TracesSamplerValues"].ParentBasedAlwaysOff:
            return new __WEBPACK_IMPORTED_MODULE_4__sampler_ParentBasedSampler__["a" /* ParentBasedSampler */]({
                root: new __WEBPACK_IMPORTED_MODULE_2__sampler_AlwaysOffSampler__["a" /* AlwaysOffSampler */](),
            });
        case __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["TracesSamplerValues"].TraceIdRatio:
            return new __WEBPACK_IMPORTED_MODULE_5__sampler_TraceIdRatioBasedSampler__["a" /* TraceIdRatioBasedSampler */](getSamplerProbabilityFromEnv(environment));
        case __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["TracesSamplerValues"].ParentBasedTraceIdRatio:
            return new __WEBPACK_IMPORTED_MODULE_4__sampler_ParentBasedSampler__["a" /* ParentBasedSampler */]({
                root: new __WEBPACK_IMPORTED_MODULE_5__sampler_TraceIdRatioBasedSampler__["a" /* TraceIdRatioBasedSampler */](getSamplerProbabilityFromEnv(environment)),
            });
        default:
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].error("OTEL_TRACES_SAMPLER value \"" + environment.OTEL_TRACES_SAMPLER + " invalid, defaulting to " + FALLBACK_OTEL_TRACES_SAMPLER + "\".");
            return new __WEBPACK_IMPORTED_MODULE_3__sampler_AlwaysOnSampler__["a" /* AlwaysOnSampler */]();
    }
}
function getSamplerProbabilityFromEnv(environment) {
    if (environment.OTEL_TRACES_SAMPLER_ARG === undefined ||
        environment.OTEL_TRACES_SAMPLER_ARG === '') {
        __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].error("OTEL_TRACES_SAMPLER_ARG is blank, defaulting to " + DEFAULT_RATIO + ".");
        return DEFAULT_RATIO;
    }
    var probability = Number(environment.OTEL_TRACES_SAMPLER_ARG);
    if (isNaN(probability)) {
        __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].error("OTEL_TRACES_SAMPLER_ARG=" + environment.OTEL_TRACES_SAMPLER_ARG + " was given, but it is invalid, defaulting to " + DEFAULT_RATIO + ".");
        return DEFAULT_RATIO;
    }
    if (probability < 0 || probability > 1) {
        __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].error("OTEL_TRACES_SAMPLER_ARG=" + environment.OTEL_TRACES_SAMPLER_ARG + " was given, but it is out of range ([0..1]), defaulting to " + DEFAULT_RATIO + ".");
        return DEFAULT_RATIO;
    }
    return probability;
}
//# sourceMappingURL=config.js.map

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoopSpanProcessor; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** No-op implementation of SpanProcessor */
var NoopSpanProcessor = /** @class */ (function () {
    function NoopSpanProcessor() {
    }
    NoopSpanProcessor.prototype.onStart = function (_span, _context) { };
    NoopSpanProcessor.prototype.onEnd = function (_span) { };
    NoopSpanProcessor.prototype.shutdown = function () {
        return Promise.resolve();
    };
    NoopSpanProcessor.prototype.forceFlush = function () {
        return Promise.resolve();
    };
    return NoopSpanProcessor;
}());

//# sourceMappingURL=NoopSpanProcessor.js.map

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParentBasedSampler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AlwaysOffSampler__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AlwaysOnSampler__ = __webpack_require__(541);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




/**
 * A composite sampler that either respects the parent span's sampling decision
 * or delegates to `delegateSampler` for root spans.
 */
var ParentBasedSampler = /** @class */ (function () {
    function ParentBasedSampler(config) {
        var _a, _b, _c, _d;
        this._root = config.root;
        if (!this._root) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["globalErrorHandler"])(new Error('ParentBasedSampler must have a root sampler configured'));
            this._root = new __WEBPACK_IMPORTED_MODULE_3__AlwaysOnSampler__["a" /* AlwaysOnSampler */]();
        }
        this._remoteParentSampled =
            (_a = config.remoteParentSampled) !== null && _a !== void 0 ? _a : new __WEBPACK_IMPORTED_MODULE_3__AlwaysOnSampler__["a" /* AlwaysOnSampler */]();
        this._remoteParentNotSampled =
            (_b = config.remoteParentNotSampled) !== null && _b !== void 0 ? _b : new __WEBPACK_IMPORTED_MODULE_2__AlwaysOffSampler__["a" /* AlwaysOffSampler */]();
        this._localParentSampled =
            (_c = config.localParentSampled) !== null && _c !== void 0 ? _c : new __WEBPACK_IMPORTED_MODULE_3__AlwaysOnSampler__["a" /* AlwaysOnSampler */]();
        this._localParentNotSampled =
            (_d = config.localParentNotSampled) !== null && _d !== void 0 ? _d : new __WEBPACK_IMPORTED_MODULE_2__AlwaysOffSampler__["a" /* AlwaysOffSampler */]();
    }
    ParentBasedSampler.prototype.shouldSample = function (context, traceId, spanName, spanKind, attributes, links) {
        var parentContext = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].getSpanContext(context);
        if (!parentContext || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["isSpanContextValid"])(parentContext)) {
            return this._root.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        }
        if (parentContext.isRemote) {
            if (parentContext.traceFlags & __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["TraceFlags"].SAMPLED) {
                return this._remoteParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
            }
            return this._remoteParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        }
        if (parentContext.traceFlags & __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["TraceFlags"].SAMPLED) {
            return this._localParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        }
        return this._localParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
    };
    ParentBasedSampler.prototype.toString = function () {
        return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    };
    return ParentBasedSampler;
}());

//# sourceMappingURL=ParentBasedSampler.js.map

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TraceIdRatioBasedSampler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Sampler__ = __webpack_require__(376);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/** Sampler that samples a given fraction of traces based of trace id deterministically. */
var TraceIdRatioBasedSampler = /** @class */ (function () {
    function TraceIdRatioBasedSampler(_ratio) {
        if (_ratio === void 0) { _ratio = 0; }
        this._ratio = _ratio;
        this._ratio = this._normalize(_ratio);
        this._upperBound = Math.floor(this._ratio * 0xffffffff);
    }
    TraceIdRatioBasedSampler.prototype.shouldSample = function (context, traceId) {
        return {
            decision: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["isValidTraceId"])(traceId) && this._accumulate(traceId) < this._upperBound
                ? __WEBPACK_IMPORTED_MODULE_1__Sampler__["a" /* SamplingDecision */].RECORD_AND_SAMPLED
                : __WEBPACK_IMPORTED_MODULE_1__Sampler__["a" /* SamplingDecision */].NOT_RECORD,
        };
    };
    TraceIdRatioBasedSampler.prototype.toString = function () {
        return "TraceIdRatioBased{" + this._ratio + "}";
    };
    TraceIdRatioBasedSampler.prototype._normalize = function (ratio) {
        if (typeof ratio !== 'number' || isNaN(ratio))
            return 0;
        return ratio >= 1 ? 1 : ratio <= 0 ? 0 : ratio;
    };
    TraceIdRatioBasedSampler.prototype._accumulate = function (traceId) {
        var accumulation = 0;
        for (var i = 0; i < traceId.length / 8; i++) {
            var pos = i * 8;
            var part = parseInt(traceId.slice(pos, pos + 8), 16);
            accumulation = (accumulation ^ part) >>> 0;
        }
        return accumulation;
    };
    return TraceIdRatioBasedSampler;
}());

//# sourceMappingURL=TraceIdRatioBasedSampler.js.map

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = mergeConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = reconfigureLimits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__ = __webpack_require__(65);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * Function to merge Default configuration (as specified in './config') with
 * user provided configurations.
 */
function mergeConfig(userConfig) {
    var perInstanceDefaults = {
        sampler: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["b" /* buildSamplerFromEnv */])(),
    };
    var DEFAULT_CONFIG = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__config__["a" /* loadDefaultConfig */])();
    var target = Object.assign({}, DEFAULT_CONFIG, perInstanceDefaults, userConfig);
    target.generalLimits = Object.assign({}, DEFAULT_CONFIG.generalLimits, userConfig.generalLimits || {});
    target.spanLimits = Object.assign({}, DEFAULT_CONFIG.spanLimits, userConfig.spanLimits || {});
    return target;
}
/**
 * When general limits are provided and model specific limits are not,
 * configures the model specific limits by using the values from the general ones.
 * @param userConfig User provided tracer configuration
 */
function reconfigureLimits(userConfig) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var spanLimits = Object.assign({}, userConfig.spanLimits);
    var parsedEnvConfig = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["getEnvWithoutDefaults"])();
    /**
     * Reassign span attribute count limit to use first non null value defined by user or use default value
     */
    spanLimits.attributeCountLimit =
        (_f = (_e = (_d = (_b = (_a = userConfig.spanLimits) === null || _a === void 0 ? void 0 : _a.attributeCountLimit) !== null && _b !== void 0 ? _b : (_c = userConfig.generalLimits) === null || _c === void 0 ? void 0 : _c.attributeCountLimit) !== null && _d !== void 0 ? _d : parsedEnvConfig.OTEL_SPAN_ATTRIBUTE_COUNT_LIMIT) !== null && _e !== void 0 ? _e : parsedEnvConfig.OTEL_ATTRIBUTE_COUNT_LIMIT) !== null && _f !== void 0 ? _f : __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["DEFAULT_ATTRIBUTE_COUNT_LIMIT"];
    /**
     * Reassign span attribute value length limit to use first non null value defined by user or use default value
     */
    spanLimits.attributeValueLengthLimit =
        (_m = (_l = (_k = (_h = (_g = userConfig.spanLimits) === null || _g === void 0 ? void 0 : _g.attributeValueLengthLimit) !== null && _h !== void 0 ? _h : (_j = userConfig.generalLimits) === null || _j === void 0 ? void 0 : _j.attributeValueLengthLimit) !== null && _k !== void 0 ? _k : parsedEnvConfig.OTEL_SPAN_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && _l !== void 0 ? _l : parsedEnvConfig.OTEL_ATTRIBUTE_VALUE_LENGTH_LIMIT) !== null && _m !== void 0 ? _m : __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["DEFAULT_ATTRIBUTE_VALUE_LENGTH_LIMIT"];
    return Object.assign({}, userConfig, { spanLimits: spanLimits });
}
//# sourceMappingURL=utility.js.map

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StackContextManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

/**
 * Stack Context Manager for managing the state in web
 * it doesn't fully support the async calls though
 */
var StackContextManager = /** @class */ (function () {
    function StackContextManager() {
        /**
         * whether the context manager is enabled or not
         */
        this._enabled = false;
        /**
         * Keeps the reference to current context
         */
        this._currentContext = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["ROOT_CONTEXT"];
    }
    /**
     *
     * @param context
     * @param target Function to be executed within the context
     */
    // eslint-disable-next-line @typescript-eslint/ban-types
    StackContextManager.prototype._bindFunction = function (context, target) {
        if (context === void 0) { context = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["ROOT_CONTEXT"]; }
        var manager = this;
        var contextWrapper = function () {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return manager.with(context, function () { return target.apply(_this, args); });
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length,
        });
        return contextWrapper;
    };
    /**
     * Returns the active context
     */
    StackContextManager.prototype.active = function () {
        return this._currentContext;
    };
    /**
     * Binds a the certain context or the active one to the target function and then returns the target
     * @param context A context (span) to be bind to target
     * @param target a function or event emitter. When target or one of its callbacks is called,
     *  the provided context will be used as the active context for the duration of the call.
     */
    StackContextManager.prototype.bind = function (context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) {
            context = this.active();
        }
        if (typeof target === 'function') {
            return this._bindFunction(context, target);
        }
        return target;
    };
    /**
     * Disable the context manager (clears the current context)
     */
    StackContextManager.prototype.disable = function () {
        this._currentContext = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["ROOT_CONTEXT"];
        this._enabled = false;
        return this;
    };
    /**
     * Enables the context manager and creates a default(root) context
     */
    StackContextManager.prototype.enable = function () {
        if (this._enabled) {
            return this;
        }
        this._enabled = true;
        this._currentContext = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["ROOT_CONTEXT"];
        return this;
    };
    /**
     * Calls the callback function [fn] with the provided [context]. If [context] is undefined then it will use the window.
     * The context will be set as active
     * @param context
     * @param fn Callback function
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */
    StackContextManager.prototype.with = function (context, fn, thisArg) {
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        var previousContext = this._currentContext;
        this._currentContext = context || __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["ROOT_CONTEXT"];
        try {
            return fn.call.apply(fn, __spreadArray([thisArg], __read(args), false));
        }
        finally {
            this._currentContext = previousContext;
        }
    };
    return StackContextManager;
}());

//# sourceMappingURL=StackContextManager.js.map

/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PerformanceTimingNames; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var PerformanceTimingNames;
(function (PerformanceTimingNames) {
    PerformanceTimingNames["CONNECT_END"] = "connectEnd";
    PerformanceTimingNames["CONNECT_START"] = "connectStart";
    PerformanceTimingNames["DECODED_BODY_SIZE"] = "decodedBodySize";
    PerformanceTimingNames["DOM_COMPLETE"] = "domComplete";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_END"] = "domContentLoadedEventEnd";
    PerformanceTimingNames["DOM_CONTENT_LOADED_EVENT_START"] = "domContentLoadedEventStart";
    PerformanceTimingNames["DOM_INTERACTIVE"] = "domInteractive";
    PerformanceTimingNames["DOMAIN_LOOKUP_END"] = "domainLookupEnd";
    PerformanceTimingNames["DOMAIN_LOOKUP_START"] = "domainLookupStart";
    PerformanceTimingNames["ENCODED_BODY_SIZE"] = "encodedBodySize";
    PerformanceTimingNames["FETCH_START"] = "fetchStart";
    PerformanceTimingNames["LOAD_EVENT_END"] = "loadEventEnd";
    PerformanceTimingNames["LOAD_EVENT_START"] = "loadEventStart";
    PerformanceTimingNames["NAVIGATION_START"] = "navigationStart";
    PerformanceTimingNames["REDIRECT_END"] = "redirectEnd";
    PerformanceTimingNames["REDIRECT_START"] = "redirectStart";
    PerformanceTimingNames["REQUEST_START"] = "requestStart";
    PerformanceTimingNames["RESPONSE_END"] = "responseEnd";
    PerformanceTimingNames["RESPONSE_START"] = "responseStart";
    PerformanceTimingNames["SECURE_CONNECTION_START"] = "secureConnectionStart";
    PerformanceTimingNames["UNLOAD_EVENT_END"] = "unloadEventEnd";
    PerformanceTimingNames["UNLOAD_EVENT_START"] = "unloadEventStart";
})(PerformanceTimingNames || (PerformanceTimingNames = {}));
//# sourceMappingURL=PerformanceTimingNames.js.map

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createConstMap;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Creates a const map from the given values
 * @param values - An array of values to be used as keys and values in the map.
 * @returns A populated version of the map with the values and keys derived from the values.
 */
/*#__NO_SIDE_EFFECTS__*/
function createConstMap(values) {
    // eslint-disable-next-line prefer-const, @typescript-eslint/no-explicit-any
    var res = {};
    var len = values.length;
    for (var lp = 0; lp < len; lp++) {
        var val = values[lp];
        if (val) {
            res[String(val).toUpperCase().replace(/[-.]/g, '_')] = val;
        }
    }
    return res;
}
//# sourceMappingURL=utils.js.map

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instanceOf_js__ = __webpack_require__(125);

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__instanceOf_js__["c" /* isShadowRoot */])(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isLayoutViewport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_userAgent_js__ = __webpack_require__(959);

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_userAgent_js__["a" /* default */])());
}

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = listScrollParents;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getScrollParent_js__ = __webpack_require__(2030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getParentNode_js__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getWindow_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isScrollParent_js__ = __webpack_require__(546);




/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getScrollParent_js__["a" /* default */])(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getWindow_js__["a" /* default */])(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isScrollParent_js__["a" /* default */])(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getParentNode_js__["a" /* default */])(target)));
}

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_getBasePlacement_js__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dom_utils_getLayoutRect_js__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dom_utils_contains_js__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__dom_utils_getOffsetParent_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_getMainAxisFromPlacement_js__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_within_js__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_mergePaddingObject_js__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_expandToHashMap_js__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__enums_js__ = __webpack_require__(114);








 // eslint-disable-next-line import/no-unused-modules

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_mergePaddingObject_js__["a" /* default */])(typeof padding !== 'number' ? padding : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_expandToHashMap_js__["a" /* default */])(padding, __WEBPACK_IMPORTED_MODULE_8__enums_js__["e" /* basePlacements */]));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_getBasePlacement_js__["a" /* default */])(state.placement);
  var axis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_getMainAxisFromPlacement_js__["a" /* default */])(basePlacement);
  var isVertical = [__WEBPACK_IMPORTED_MODULE_8__enums_js__["j" /* left */], __WEBPACK_IMPORTED_MODULE_8__enums_js__["g" /* right */]].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__dom_utils_getLayoutRect_js__["a" /* default */])(arrowElement);
  var minProp = axis === 'y' ? __WEBPACK_IMPORTED_MODULE_8__enums_js__["i" /* top */] : __WEBPACK_IMPORTED_MODULE_8__enums_js__["j" /* left */];
  var maxProp = axis === 'y' ? __WEBPACK_IMPORTED_MODULE_8__enums_js__["h" /* bottom */] : __WEBPACK_IMPORTED_MODULE_8__enums_js__["g" /* right */];
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__dom_utils_getOffsetParent_js__["a" /* default */])(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_within_js__["a" /* within */])(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__dom_utils_contains_js__["a" /* default */])(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
});

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__ = __webpack_require__(2038);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_getOppositeVariationPlacement_js__ = __webpack_require__(2039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_detectOverflow_js__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_computeAutoPlacement_js__ = __webpack_require__(2035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_getVariation_js__ = __webpack_require__(309);






 // eslint-disable-next-line import/no-unused-modules

function getExpandedFallbackPlacements(placement) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(placement) === __WEBPACK_IMPORTED_MODULE_5__enums_js__["m" /* auto */]) {
    return [];
  }

  var oppositePlacement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__["a" /* default */])(placement);
  return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_getOppositeVariationPlacement_js__["a" /* default */])(placement), oppositePlacement, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_getOppositeVariationPlacement_js__["a" /* default */])(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__["a" /* default */])(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(placement) === __WEBPACK_IMPORTED_MODULE_5__enums_js__["m" /* auto */] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_computeAutoPlacement_js__["a" /* default */])(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(placement);

    var isStartVariation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils_getVariation_js__["a" /* default */])(placement) === __WEBPACK_IMPORTED_MODULE_5__enums_js__["k" /* start */];
    var isVertical = [__WEBPACK_IMPORTED_MODULE_5__enums_js__["i" /* top */], __WEBPACK_IMPORTED_MODULE_5__enums_js__["h" /* bottom */]].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_detectOverflow_js__["a" /* default */])(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["g" /* right */] : __WEBPACK_IMPORTED_MODULE_5__enums_js__["j" /* left */] : isStartVariation ? __WEBPACK_IMPORTED_MODULE_5__enums_js__["h" /* bottom */] : __WEBPACK_IMPORTED_MODULE_5__enums_js__["i" /* top */];

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__["a" /* default */])(mainVariationSide);
    }

    var altVariationSide = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_getOppositePlacement_js__["a" /* default */])(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
});

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_detectOverflow_js__ = __webpack_require__(308);



function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [__WEBPACK_IMPORTED_MODULE_0__enums_js__["i" /* top */], __WEBPACK_IMPORTED_MODULE_0__enums_js__["g" /* right */], __WEBPACK_IMPORTED_MODULE_0__enums_js__["h" /* bottom */], __WEBPACK_IMPORTED_MODULE_0__enums_js__["j" /* left */]].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_detectOverflow_js__["a" /* default */])(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_detectOverflow_js__["a" /* default */])(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
});

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__applyStyles_js__ = __webpack_require__(547);
/* unused harmony reexport applyStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrow_js__ = __webpack_require__(947);
/* unused harmony reexport arrow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__computeStyles_js__ = __webpack_require__(548);
/* unused harmony reexport computeStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__eventListeners_js__ = __webpack_require__(549);
/* unused harmony reexport eventListeners */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__flip_js__ = __webpack_require__(948);
/* unused harmony reexport flip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hide_js__ = __webpack_require__(949);
/* unused harmony reexport hide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__offset_js__ = __webpack_require__(951);
/* unused harmony reexport offset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__popperOffsets_js__ = __webpack_require__(550);
/* unused harmony reexport popperOffsets */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__preventOverflow_js__ = __webpack_require__(952);
/* unused harmony reexport preventOverflow */










/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export distanceAndSkiddingToXY */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_getBasePlacement_js__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums_js__ = __webpack_require__(114);

 // eslint-disable-next-line import/no-unused-modules

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_getBasePlacement_js__["a" /* default */])(placement);
  var invertDistance = [__WEBPACK_IMPORTED_MODULE_1__enums_js__["j" /* left */], __WEBPACK_IMPORTED_MODULE_1__enums_js__["i" /* top */]].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [__WEBPACK_IMPORTED_MODULE_1__enums_js__["j" /* left */], __WEBPACK_IMPORTED_MODULE_1__enums_js__["g" /* right */]].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = __WEBPACK_IMPORTED_MODULE_1__enums_js__["n" /* placements */].reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
});

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_getMainAxisFromPlacement_js__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_getAltAxis_js__ = __webpack_require__(2037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_within_js__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__dom_utils_getLayoutRect_js__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__dom_utils_getOffsetParent_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_detectOverflow_js__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_getVariation_js__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_getFreshSideObject_js__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_math_js__ = __webpack_require__(217);












function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_detectOverflow_js__["a" /* default */])(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils_getBasePlacement_js__["a" /* default */])(state.placement);
  var variation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_getVariation_js__["a" /* default */])(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_getMainAxisFromPlacement_js__["a" /* default */])(basePlacement);
  var altAxis = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils_getAltAxis_js__["a" /* default */])(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? __WEBPACK_IMPORTED_MODULE_0__enums_js__["i" /* top */] : __WEBPACK_IMPORTED_MODULE_0__enums_js__["j" /* left */];
    var altSide = mainAxis === 'y' ? __WEBPACK_IMPORTED_MODULE_0__enums_js__["h" /* bottom */] : __WEBPACK_IMPORTED_MODULE_0__enums_js__["g" /* right */];
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = offset + overflow[mainSide];
    var max = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === __WEBPACK_IMPORTED_MODULE_0__enums_js__["k" /* start */] ? referenceRect[len] : popperRect[len];
    var maxLen = variation === __WEBPACK_IMPORTED_MODULE_0__enums_js__["k" /* start */] ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__dom_utils_getLayoutRect_js__["a" /* default */])(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_getFreshSideObject_js__["a" /* default */])();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_within_js__["a" /* within */])(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__dom_utils_getOffsetParent_js__["a" /* default */])(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_within_js__["a" /* within */])(tether ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_math_js__["c" /* min */])(min, tetherMin) : min, offset, tether ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_math_js__["b" /* max */])(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? __WEBPACK_IMPORTED_MODULE_0__enums_js__["i" /* top */] : __WEBPACK_IMPORTED_MODULE_0__enums_js__["j" /* left */];

    var _altSide = mainAxis === 'x' ? __WEBPACK_IMPORTED_MODULE_0__enums_js__["h" /* bottom */] : __WEBPACK_IMPORTED_MODULE_0__enums_js__["g" /* right */];

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [__WEBPACK_IMPORTED_MODULE_0__enums_js__["i" /* top */], __WEBPACK_IMPORTED_MODULE_0__enums_js__["j" /* left */]].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_within_js__["b" /* withinMaxClamp */])(_tetherMin, _offset, _tetherMax) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_within_js__["a" /* within */])(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
});

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createPopper */
/* unused harmony export defaultModifiers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPopper_js__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modifiers_eventListeners_js__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modifiers_popperOffsets_js__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modifiers_computeStyles_js__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modifiers_applyStyles_js__ = __webpack_require__(547);
/* unused harmony reexport popperGenerator */
/* unused harmony reexport detectOverflow */





var defaultModifiers = [__WEBPACK_IMPORTED_MODULE_1__modifiers_eventListeners_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__modifiers_popperOffsets_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__modifiers_computeStyles_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__modifiers_applyStyles_js__["a" /* default */]];
var createPopper = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createPopper_js__["a" /* popperGenerator */])({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules



/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeOffsets;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getBasePlacement_js__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getVariation_js__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getMainAxisFromPlacement_js__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__enums_js__ = __webpack_require__(114);




function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getBasePlacement_js__["a" /* default */])(placement) : null;
  var variation = placement ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getVariation_js__["a" /* default */])(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case __WEBPACK_IMPORTED_MODULE_3__enums_js__["i" /* top */]:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case __WEBPACK_IMPORTED_MODULE_3__enums_js__["h" /* bottom */]:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case __WEBPACK_IMPORTED_MODULE_3__enums_js__["g" /* right */]:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case __WEBPACK_IMPORTED_MODULE_3__enums_js__["j" /* left */]:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getMainAxisFromPlacement_js__["a" /* default */])(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case __WEBPACK_IMPORTED_MODULE_3__enums_js__["k" /* start */]:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case __WEBPACK_IMPORTED_MODULE_3__enums_js__["l" /* end */]:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;

      default:
    }
  }

  return offsets;
}

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = expandToHashMap;
function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFreshSideObject;
function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergePaddingObject;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getFreshSideObject_js__ = __webpack_require__(956);

function mergePaddingObject(paddingObject) {
  return Object.assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getFreshSideObject_js__["a" /* default */])(), paddingObject);
}

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rectToClientRect;
function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUAString;
function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = within;
/* harmony export (immutable) */ __webpack_exports__["b"] = withinMaxClamp;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__math_js__ = __webpack_require__(217);

function within(min, value, max) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math_js__["b" /* max */])(min, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__math_js__["c" /* min */])(value, max));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthenticationHelper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js_core__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_crypto_js_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_crypto_js_lib_typedarrays__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_crypto_js_lib_typedarrays___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_crypto_js_lib_typedarrays__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crypto_js_sha256__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crypto_js_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_crypto_js_sha256__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_WordArray__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BigInteger__ = __webpack_require__(962);
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */


 // necessary for crypto js




/**
 * Returns a Buffer with a sequence of random nBytes
 *
 * @param {number} nBytes
 * @returns {Buffer} fixed-length sequence of random bytes
 */

function randomBytes(nBytes) {
  return __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(new __WEBPACK_IMPORTED_MODULE_5__utils_WordArray__["a" /* default */]().random(nBytes).toString(), 'hex');
}


/**
 * Tests if a hex string has it most significant bit set (case-insensitive regex)
 */

var HEX_MSB_REGEX = /^[89a-f]/i;
var initN = 'FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD1' + '29024E088A67CC74020BBEA63B139B22514A08798E3404DD' + 'EF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245' + 'E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7ED' + 'EE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3D' + 'C2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F' + '83655D23DCA3AD961C62F356208552BB9ED529077096966D' + '670C354E4ABC9804F1746C08CA18217C32905E462E36CE3B' + 'E39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9' + 'DE2BCBF6955817183995497CEA956AE515D2261898FA0510' + '15728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64' + 'ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7' + 'ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6B' + 'F12FFA06D98A0864D87602733EC86A64521F2B18177B200C' + 'BBE117577A615D6C770988C0BAD946E208E24FA074E5AB31' + '43DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF';
var newPasswordRequiredChallengeUserAttributePrefix = 'userAttributes.';
/** @class */

var AuthenticationHelper = /*#__PURE__*/function () {
  /**
   * Constructs a new AuthenticationHelper object
   * @param {string} PoolName Cognito user pool name.
   */
  function AuthenticationHelper(PoolName) {
    this.N = new __WEBPACK_IMPORTED_MODULE_6__BigInteger__["a" /* default */](initN, 16);
    this.g = new __WEBPACK_IMPORTED_MODULE_6__BigInteger__["a" /* default */]('2', 16);
    this.k = new __WEBPACK_IMPORTED_MODULE_6__BigInteger__["a" /* default */](this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16);
    this.smallAValue = this.generateRandomSmallA();
    this.getLargeAValue(function () {});
    this.infoBits = __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from('Caldera Derived Key', 'utf8');
    this.poolName = PoolName;
  }
  /**
   * @returns {BigInteger} small A, a random number
   */


  var _proto = AuthenticationHelper.prototype;

  _proto.getSmallAValue = function getSmallAValue() {
    return this.smallAValue;
  }
  /**
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   */
  ;

  _proto.getLargeAValue = function getLargeAValue(callback) {
    var _this = this;

    if (this.largeAValue) {
      callback(null, this.largeAValue);
    } else {
      this.calculateA(this.smallAValue, function (err, largeAValue) {
        if (err) {
          callback(err, null);
        }

        _this.largeAValue = largeAValue;
        callback(null, _this.largeAValue);
      });
    }
  }
  /**
   * helper function to generate a random big integer
   * @returns {BigInteger} a random value.
   * @private
   */
  ;

  _proto.generateRandomSmallA = function generateRandomSmallA() {
    // This will be interpreted as a postive 128-bit integer
    var hexRandom = randomBytes(128).toString('hex');
    var randomBigInt = new __WEBPACK_IMPORTED_MODULE_6__BigInteger__["a" /* default */](hexRandom, 16); // There is no need to do randomBigInt.mod(this.N - 1) as N (3072-bit) is > 128 bytes (1024-bit)

    return randomBigInt;
  }
  /**
   * helper function to generate a random string
   * @returns {string} a random value.
   * @private
   */
  ;

  _proto.generateRandomString = function generateRandomString() {
    return randomBytes(40).toString('base64');
  }
  /**
   * @returns {string} Generated random value included in password hash.
   */
  ;

  _proto.getRandomPassword = function getRandomPassword() {
    return this.randomPassword;
  }
  /**
   * @returns {string} Generated random value included in devices hash.
   */
  ;

  _proto.getSaltDevices = function getSaltDevices() {
    return this.SaltToHashDevices;
  }
  /**
   * @returns {string} Value used to verify devices.
   */
  ;

  _proto.getVerifierDevices = function getVerifierDevices() {
    return this.verifierDevices;
  }
  /**
   * Generate salts and compute verifier.
   * @param {string} deviceGroupKey Devices to generate verifier for.
   * @param {string} username User to generate verifier for.
   * @param {nodeCallback<null>} callback Called with (err, null)
   * @returns {void}
   */
  ;

  _proto.generateHashDevice = function generateHashDevice(deviceGroupKey, username, callback) {
    var _this2 = this;

    this.randomPassword = this.generateRandomString();
    var combinedString = "" + deviceGroupKey + username + ":" + this.randomPassword;
    var hashedString = this.hash(combinedString);
    var hexRandom = randomBytes(16).toString('hex'); // The random hex will be unambiguously represented as a postive integer

    this.SaltToHashDevices = this.padHex(new __WEBPACK_IMPORTED_MODULE_6__BigInteger__["a" /* default */](hexRandom, 16));
    this.g.modPow(new __WEBPACK_IMPORTED_MODULE_6__BigInteger__["a" /* default */](this.hexHash(this.SaltToHashDevices + hashedString), 16), this.N, function (err, verifierDevicesNotPadded) {
      if (err) {
        callback(err, null);
      }

      _this2.verifierDevices = _this2.padHex(verifierDevicesNotPadded);
      callback(null, null);
    });
  }
  /**
   * Calculate the client's public value A = g^a%N
   * with the generated random number a
   * @param {BigInteger} a Randomly generated small A.
   * @param {nodeCallback<BigInteger>} callback Called with (err, largeAValue)
   * @returns {void}
   * @private
   */
  ;

  _proto.calculateA = function calculateA(a, callback) {
    var _this3 = this;

    this.g.modPow(a, this.N, function (err, A) {
      if (err) {
        callback(err, null);
      }

      if (A.mod(_this3.N).equals(__WEBPACK_IMPORTED_MODULE_6__BigInteger__["a" /* default */].ZERO)) {
        callback(new Error('Illegal paramater. A mod N cannot be 0.'), null);
      }

      callback(null, A);
    });
  }
  /**
   * Calculate the client's value U which is the hash of A and B
   * @param {BigInteger} A Large A value.
   * @param {BigInteger} B Server B value.
   * @returns {BigInteger} Computed U value.
   * @private
   */
  ;

  _proto.calculateU = function calculateU(A, B) {
    this.UHexHash = this.hexHash(this.padHex(A) + this.padHex(B));
    var finalU = new __WEBPACK_IMPORTED_MODULE_6__BigInteger__["a" /* default */](this.UHexHash, 16);
    return finalU;
  }
  /**
   * Calculate a hash from a bitArray
   * @param {Buffer} buf Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */
  ;

  _proto.hash = function hash(buf) {
    var str = buf instanceof __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"] ? __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default.a.lib.WordArray.create(buf) : buf;
    var hashHex = __WEBPACK_IMPORTED_MODULE_3_crypto_js_sha256___default()(str).toString();
    return new Array(64 - hashHex.length).join('0') + hashHex;
  }
  /**
   * Calculate a hash from a hex string
   * @param {String} hexStr Value to hash.
   * @returns {String} Hex-encoded hash.
   * @private
   */
  ;

  _proto.hexHash = function hexHash(hexStr) {
    return this.hash(__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(hexStr, 'hex'));
  }
  /**
   * Standard hkdf algorithm
   * @param {Buffer} ikm Input key material.
   * @param {Buffer} salt Salt value.
   * @returns {Buffer} Strong key material.
   * @private
   */
  ;

  _proto.computehkdf = function computehkdf(ikm, salt) {
    var infoBitsWordArray = __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default.a.lib.WordArray.create(__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].concat([this.infoBits, __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(String.fromCharCode(1), 'utf8')]));
    var ikmWordArray = ikm instanceof __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"] ? __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default.a.lib.WordArray.create(ikm) : ikm;
    var saltWordArray = salt instanceof __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"] ? __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default.a.lib.WordArray.create(salt) : salt;
    var prk = __WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256___default()(ikmWordArray, saltWordArray);
    var hmac = __WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256___default()(infoBitsWordArray, prk);
    return __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(hmac.toString(), 'hex').slice(0, 16);
  }
  /**
   * Calculates the final hkdf based on computed S value, and computed U value and the key
   * @param {String} username Username.
   * @param {String} password Password.
   * @param {BigInteger} serverBValue Server B value.
   * @param {BigInteger} salt Generated salt.
   * @param {nodeCallback<Buffer>} callback Called with (err, hkdfValue)
   * @returns {void}
   */
  ;

  _proto.getPasswordAuthenticationKey = function getPasswordAuthenticationKey(username, password, serverBValue, salt, callback) {
    var _this4 = this;

    if (serverBValue.mod(this.N).equals(__WEBPACK_IMPORTED_MODULE_6__BigInteger__["a" /* default */].ZERO)) {
      throw new Error('B cannot be zero.');
    }

    this.UValue = this.calculateU(this.largeAValue, serverBValue);

    if (this.UValue.equals(__WEBPACK_IMPORTED_MODULE_6__BigInteger__["a" /* default */].ZERO)) {
      throw new Error('U cannot be zero.');
    }

    var usernamePassword = "" + this.poolName + username + ":" + password;
    var usernamePasswordHash = this.hash(usernamePassword);
    var xValue = new __WEBPACK_IMPORTED_MODULE_6__BigInteger__["a" /* default */](this.hexHash(this.padHex(salt) + usernamePasswordHash), 16);
    this.calculateS(xValue, serverBValue, function (err, sValue) {
      if (err) {
        callback(err, null);
      }

      var hkdf = _this4.computehkdf(__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(_this4.padHex(sValue), 'hex'), __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(_this4.padHex(_this4.UValue), 'hex'));

      callback(null, hkdf);
    });
  }
  /**
   * Calculates the S value used in getPasswordAuthenticationKey
   * @param {BigInteger} xValue Salted password hash value.
   * @param {BigInteger} serverBValue Server B value.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */
  ;

  _proto.calculateS = function calculateS(xValue, serverBValue, callback) {
    var _this5 = this;

    this.g.modPow(xValue, this.N, function (err, gModPowXN) {
      if (err) {
        callback(err, null);
      }

      var intValue2 = serverBValue.subtract(_this5.k.multiply(gModPowXN));
      intValue2.modPow(_this5.smallAValue.add(_this5.UValue.multiply(xValue)), _this5.N, function (err2, result) {
        if (err2) {
          callback(err2, null);
        }

        callback(null, result.mod(_this5.N));
      });
    });
  }
  /**
   * Return constant newPasswordRequiredChallengeUserAttributePrefix
   * @return {newPasswordRequiredChallengeUserAttributePrefix} constant prefix value
   */
  ;

  _proto.getNewPasswordRequiredChallengeUserAttributePrefix = function getNewPasswordRequiredChallengeUserAttributePrefix() {
    return newPasswordRequiredChallengeUserAttributePrefix;
  }
  /**
   * Returns an unambiguous, even-length hex string of the two's complement encoding of an integer.
   *
   * It is compatible with the hex encoding of Java's BigInteger's toByteArray(), wich returns a
   * byte array containing the two's-complement representation of a BigInteger. The array contains
   * the minimum number of bytes required to represent the BigInteger, including at least one sign bit.
   *
   * Examples showing how ambiguity is avoided by left padding with:
   * 	"00" (for positive values where the most-significant-bit is set)
   *  "FF" (for negative values where the most-significant-bit is set)
   *
   * padHex(bigInteger.fromInt(-236))  === "FF14"
   * padHex(bigInteger.fromInt(20))    === "14"
   *
   * padHex(bigInteger.fromInt(-200))  === "FF38"
   * padHex(bigInteger.fromInt(56))    === "38"
   *
   * padHex(bigInteger.fromInt(-20))   === "EC"
   * padHex(bigInteger.fromInt(236))   === "00EC"
   *
   * padHex(bigInteger.fromInt(-56))   === "C8"
   * padHex(bigInteger.fromInt(200))   === "00C8"
   *
   * @param {BigInteger} bigInt Number to encode.
   * @returns {String} even-length hex string of the two's complement encoding.
   */
  ;

  _proto.padHex = function padHex(bigInt) {
    if (!(bigInt instanceof __WEBPACK_IMPORTED_MODULE_6__BigInteger__["a" /* default */])) {
      throw new Error('Not a BigInteger');
    }

    var isNegative = bigInt.compareTo(__WEBPACK_IMPORTED_MODULE_6__BigInteger__["a" /* default */].ZERO) < 0;
    /* Get a hex string for abs(bigInt) */

    var hexStr = bigInt.abs().toString(16);
    /* Pad hex to even length if needed */

    hexStr = hexStr.length % 2 !== 0 ? "0" + hexStr : hexStr;
    /* Prepend "00" if the most significant bit is set */

    hexStr = HEX_MSB_REGEX.test(hexStr) ? "00" + hexStr : hexStr;

    if (isNegative) {
      /* Flip the bits of the representation */
      var invertedNibbles = hexStr.split('').map(function (x) {
        var invertedNibble = ~parseInt(x, 16) & 0xf;
        return '0123456789ABCDEF'.charAt(invertedNibble);
      }).join('');
      /* After flipping the bits, add one to get the 2's complement representation */

      var flippedBitsBI = new __WEBPACK_IMPORTED_MODULE_6__BigInteger__["a" /* default */](invertedNibbles, 16).add(__WEBPACK_IMPORTED_MODULE_6__BigInteger__["a" /* default */].ONE);
      hexStr = flippedBitsBI.toString(16);
      /*
      For hex strings starting with 'FF8', 'FF' can be dropped, e.g. 0xFFFF80=0xFF80=0x80=-128
      		Any sequence of '1' bits on the left can always be substituted with a single '1' bit
      without changing the represented value.
      		This only happens in the case when the input is 80...00
      */

      if (hexStr.toUpperCase().startsWith('FF8')) {
        hexStr = hexStr.substring(2);
      }
    }

    return hexStr;
  };

  return AuthenticationHelper;
}();



/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// A small implementation of BigInteger based on http://www-cs-students.stanford.edu/~tjw/jsbn/
//
// All public methods have been removed except the following:
//   new BigInteger(a, b) (only radix 2, 4, 8, 16 and 32 supported)
//   toString (only radix 2, 4, 8, 16 and 32 supported)
//   negate
//   abs
//   compareTo
//   bitLength
//   mod
//   equals
//   add
//   subtract
//   multiply
//   divide
//   modPow
/* harmony default export */ __webpack_exports__["a"] = (BigInteger);
/*
 * Copyright (c) 2003-2005  Tom Wu
 * All Rights Reserved.
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS-IS" AND WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS, IMPLIED OR OTHERWISE, INCLUDING WITHOUT LIMITATION, ANY
 * WARRANTY OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR PURPOSE.
 *
 * IN NO EVENT SHALL TOM WU BE LIABLE FOR ANY SPECIAL, INCIDENTAL,
 * INDIRECT OR CONSEQUENTIAL DAMAGES OF ANY KIND, OR ANY DAMAGES WHATSOEVER
 * RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER OR NOT ADVISED OF
 * THE POSSIBILITY OF DAMAGE, AND ON ANY THEORY OF LIABILITY, ARISING OUT
 * OF OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 *
 * In addition, the following condition applies:
 *
 * All redistributions must retain an intact copy of this copyright notice
 * and disclaimer.
 */
// (public) Constructor

function BigInteger(a, b) {
  if (a != null) this.fromString(a, b);
} // return new, unset BigInteger


function nbi() {
  return new BigInteger(null);
} // Bits per digit


var dbits; // JavaScript engine analysis

var canary = 0xdeadbeefcafe;
var j_lm = (canary & 0xffffff) == 0xefcafe; // am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
// am1: use a single mult and divide to get the high bits,
// max digit bits should be 26 because
// max internal value = 2*dvalue^2-2*dvalue (< 2^53)

function am1(i, x, w, j, c, n) {
  while (--n >= 0) {
    var v = x * this[i++] + w[j] + c;
    c = Math.floor(v / 0x4000000);
    w[j++] = v & 0x3ffffff;
  }

  return c;
} // am2 avoids a big mult-and-extract completely.
// Max digit bits should be <= 30 because we do bitwise ops
// on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)


function am2(i, x, w, j, c, n) {
  var xl = x & 0x7fff,
      xh = x >> 15;

  while (--n >= 0) {
    var l = this[i] & 0x7fff;
    var h = this[i++] >> 15;
    var m = xh * l + h * xl;
    l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
    c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
    w[j++] = l & 0x3fffffff;
  }

  return c;
} // Alternately, set max digit bits to 28 since some
// browsers slow down when dealing with 32-bit numbers.


function am3(i, x, w, j, c, n) {
  var xl = x & 0x3fff,
      xh = x >> 14;

  while (--n >= 0) {
    var l = this[i] & 0x3fff;
    var h = this[i++] >> 14;
    var m = xh * l + h * xl;
    l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
    c = (l >> 28) + (m >> 14) + xh * h;
    w[j++] = l & 0xfffffff;
  }

  return c;
}

var inBrowser = typeof navigator !== 'undefined';

if (inBrowser && j_lm && navigator.appName == 'Microsoft Internet Explorer') {
  BigInteger.prototype.am = am2;
  dbits = 30;
} else if (inBrowser && j_lm && navigator.appName != 'Netscape') {
  BigInteger.prototype.am = am1;
  dbits = 26;
} else {
  // Mozilla/Netscape seems to prefer am3
  BigInteger.prototype.am = am3;
  dbits = 28;
}

BigInteger.prototype.DB = dbits;
BigInteger.prototype.DM = (1 << dbits) - 1;
BigInteger.prototype.DV = 1 << dbits;
var BI_FP = 52;
BigInteger.prototype.FV = Math.pow(2, BI_FP);
BigInteger.prototype.F1 = BI_FP - dbits;
BigInteger.prototype.F2 = 2 * dbits - BI_FP; // Digit conversions

var BI_RM = '0123456789abcdefghijklmnopqrstuvwxyz';
var BI_RC = new Array();
var rr, vv;
rr = '0'.charCodeAt(0);

for (vv = 0; vv <= 9; ++vv) {
  BI_RC[rr++] = vv;
}

rr = 'a'.charCodeAt(0);

for (vv = 10; vv < 36; ++vv) {
  BI_RC[rr++] = vv;
}

rr = 'A'.charCodeAt(0);

for (vv = 10; vv < 36; ++vv) {
  BI_RC[rr++] = vv;
}

function int2char(n) {
  return BI_RM.charAt(n);
}

function intAt(s, i) {
  var c = BI_RC[s.charCodeAt(i)];
  return c == null ? -1 : c;
} // (protected) copy this to r


function bnpCopyTo(r) {
  for (var i = this.t - 1; i >= 0; --i) {
    r[i] = this[i];
  }

  r.t = this.t;
  r.s = this.s;
} // (protected) set from integer value x, -DV <= x < DV


function bnpFromInt(x) {
  this.t = 1;
  this.s = x < 0 ? -1 : 0;
  if (x > 0) this[0] = x;else if (x < -1) this[0] = x + this.DV;else this.t = 0;
} // return bigint initialized to value


function nbv(i) {
  var r = nbi();
  r.fromInt(i);
  return r;
} // (protected) set from string and radix


function bnpFromString(s, b) {
  var k;
  if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
  this.t = 0;
  this.s = 0;
  var i = s.length,
      mi = false,
      sh = 0;

  while (--i >= 0) {
    var x = intAt(s, i);

    if (x < 0) {
      if (s.charAt(i) == '-') mi = true;
      continue;
    }

    mi = false;
    if (sh == 0) this[this.t++] = x;else if (sh + k > this.DB) {
      this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
      this[this.t++] = x >> this.DB - sh;
    } else this[this.t - 1] |= x << sh;
    sh += k;
    if (sh >= this.DB) sh -= this.DB;
  }

  this.clamp();
  if (mi) BigInteger.ZERO.subTo(this, this);
} // (protected) clamp off excess high words


function bnpClamp() {
  var c = this.s & this.DM;

  while (this.t > 0 && this[this.t - 1] == c) {
    --this.t;
  }
} // (public) return string representation in given radix


function bnToString(b) {
  if (this.s < 0) return '-' + this.negate().toString(b);
  var k;
  if (b == 16) k = 4;else if (b == 8) k = 3;else if (b == 2) k = 1;else if (b == 32) k = 5;else if (b == 4) k = 2;else throw new Error('Only radix 2, 4, 8, 16, 32 are supported');
  var km = (1 << k) - 1,
      d,
      m = false,
      r = '',
      i = this.t;
  var p = this.DB - i * this.DB % k;

  if (i-- > 0) {
    if (p < this.DB && (d = this[i] >> p) > 0) {
      m = true;
      r = int2char(d);
    }

    while (i >= 0) {
      if (p < k) {
        d = (this[i] & (1 << p) - 1) << k - p;
        d |= this[--i] >> (p += this.DB - k);
      } else {
        d = this[i] >> (p -= k) & km;

        if (p <= 0) {
          p += this.DB;
          --i;
        }
      }

      if (d > 0) m = true;
      if (m) r += int2char(d);
    }
  }

  return m ? r : '0';
} // (public) -this


function bnNegate() {
  var r = nbi();
  BigInteger.ZERO.subTo(this, r);
  return r;
} // (public) |this|


function bnAbs() {
  return this.s < 0 ? this.negate() : this;
} // (public) return + if this > a, - if this < a, 0 if equal


function bnCompareTo(a) {
  var r = this.s - a.s;
  if (r != 0) return r;
  var i = this.t;
  r = i - a.t;
  if (r != 0) return this.s < 0 ? -r : r;

  while (--i >= 0) {
    if ((r = this[i] - a[i]) != 0) return r;
  }

  return 0;
} // returns bit length of the integer x


function nbits(x) {
  var r = 1,
      t;

  if ((t = x >>> 16) != 0) {
    x = t;
    r += 16;
  }

  if ((t = x >> 8) != 0) {
    x = t;
    r += 8;
  }

  if ((t = x >> 4) != 0) {
    x = t;
    r += 4;
  }

  if ((t = x >> 2) != 0) {
    x = t;
    r += 2;
  }

  if ((t = x >> 1) != 0) {
    x = t;
    r += 1;
  }

  return r;
} // (public) return the number of bits in "this"


function bnBitLength() {
  if (this.t <= 0) return 0;
  return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
} // (protected) r = this << n*DB


function bnpDLShiftTo(n, r) {
  var i;

  for (i = this.t - 1; i >= 0; --i) {
    r[i + n] = this[i];
  }

  for (i = n - 1; i >= 0; --i) {
    r[i] = 0;
  }

  r.t = this.t + n;
  r.s = this.s;
} // (protected) r = this >> n*DB


function bnpDRShiftTo(n, r) {
  for (var i = n; i < this.t; ++i) {
    r[i - n] = this[i];
  }

  r.t = Math.max(this.t - n, 0);
  r.s = this.s;
} // (protected) r = this << n


function bnpLShiftTo(n, r) {
  var bs = n % this.DB;
  var cbs = this.DB - bs;
  var bm = (1 << cbs) - 1;
  var ds = Math.floor(n / this.DB),
      c = this.s << bs & this.DM,
      i;

  for (i = this.t - 1; i >= 0; --i) {
    r[i + ds + 1] = this[i] >> cbs | c;
    c = (this[i] & bm) << bs;
  }

  for (i = ds - 1; i >= 0; --i) {
    r[i] = 0;
  }

  r[ds] = c;
  r.t = this.t + ds + 1;
  r.s = this.s;
  r.clamp();
} // (protected) r = this >> n


function bnpRShiftTo(n, r) {
  r.s = this.s;
  var ds = Math.floor(n / this.DB);

  if (ds >= this.t) {
    r.t = 0;
    return;
  }

  var bs = n % this.DB;
  var cbs = this.DB - bs;
  var bm = (1 << bs) - 1;
  r[0] = this[ds] >> bs;

  for (var i = ds + 1; i < this.t; ++i) {
    r[i - ds - 1] |= (this[i] & bm) << cbs;
    r[i - ds] = this[i] >> bs;
  }

  if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
  r.t = this.t - ds;
  r.clamp();
} // (protected) r = this - a


function bnpSubTo(a, r) {
  var i = 0,
      c = 0,
      m = Math.min(a.t, this.t);

  while (i < m) {
    c += this[i] - a[i];
    r[i++] = c & this.DM;
    c >>= this.DB;
  }

  if (a.t < this.t) {
    c -= a.s;

    while (i < this.t) {
      c += this[i];
      r[i++] = c & this.DM;
      c >>= this.DB;
    }

    c += this.s;
  } else {
    c += this.s;

    while (i < a.t) {
      c -= a[i];
      r[i++] = c & this.DM;
      c >>= this.DB;
    }

    c -= a.s;
  }

  r.s = c < 0 ? -1 : 0;
  if (c < -1) r[i++] = this.DV + c;else if (c > 0) r[i++] = c;
  r.t = i;
  r.clamp();
} // (protected) r = this * a, r != this,a (HAC 14.12)
// "this" should be the larger one if appropriate.


function bnpMultiplyTo(a, r) {
  var x = this.abs(),
      y = a.abs();
  var i = x.t;
  r.t = i + y.t;

  while (--i >= 0) {
    r[i] = 0;
  }

  for (i = 0; i < y.t; ++i) {
    r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
  }

  r.s = 0;
  r.clamp();
  if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
} // (protected) r = this^2, r != this (HAC 14.16)


function bnpSquareTo(r) {
  var x = this.abs();
  var i = r.t = 2 * x.t;

  while (--i >= 0) {
    r[i] = 0;
  }

  for (i = 0; i < x.t - 1; ++i) {
    var c = x.am(i, x[i], r, 2 * i, 0, 1);

    if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
      r[i + x.t] -= x.DV;
      r[i + x.t + 1] = 1;
    }
  }

  if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
  r.s = 0;
  r.clamp();
} // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
// r != q, this != m.  q or r may be null.


function bnpDivRemTo(m, q, r) {
  var pm = m.abs();
  if (pm.t <= 0) return;
  var pt = this.abs();

  if (pt.t < pm.t) {
    if (q != null) q.fromInt(0);
    if (r != null) this.copyTo(r);
    return;
  }

  if (r == null) r = nbi();
  var y = nbi(),
      ts = this.s,
      ms = m.s;
  var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus

  if (nsh > 0) {
    pm.lShiftTo(nsh, y);
    pt.lShiftTo(nsh, r);
  } else {
    pm.copyTo(y);
    pt.copyTo(r);
  }

  var ys = y.t;
  var y0 = y[ys - 1];
  if (y0 == 0) return;
  var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
  var d1 = this.FV / yt,
      d2 = (1 << this.F1) / yt,
      e = 1 << this.F2;
  var i = r.t,
      j = i - ys,
      t = q == null ? nbi() : q;
  y.dlShiftTo(j, t);

  if (r.compareTo(t) >= 0) {
    r[r.t++] = 1;
    r.subTo(t, r);
  }

  BigInteger.ONE.dlShiftTo(ys, t);
  t.subTo(y, y); // "negative" y so we can replace sub with am later

  while (y.t < ys) {
    y[y.t++] = 0;
  }

  while (--j >= 0) {
    // Estimate quotient digit
    var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);

    if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
      // Try it out
      y.dlShiftTo(j, t);
      r.subTo(t, r);

      while (r[i] < --qd) {
        r.subTo(t, r);
      }
    }
  }

  if (q != null) {
    r.drShiftTo(ys, q);
    if (ts != ms) BigInteger.ZERO.subTo(q, q);
  }

  r.t = ys;
  r.clamp();
  if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder

  if (ts < 0) BigInteger.ZERO.subTo(r, r);
} // (public) this mod a


function bnMod(a) {
  var r = nbi();
  this.abs().divRemTo(a, null, r);
  if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
  return r;
} // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
// justification:
//         xy == 1 (mod m)
//         xy =  1+km
//   xy(2-xy) = (1+km)(1-km)
// x[y(2-xy)] = 1-k^2m^2
// x[y(2-xy)] == 1 (mod m^2)
// if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
// should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
// JS multiply "overflows" differently from C/C++, so care is needed here.


function bnpInvDigit() {
  if (this.t < 1) return 0;
  var x = this[0];
  if ((x & 1) == 0) return 0;
  var y = x & 3; // y == 1/x mod 2^2

  y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4

  y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8

  y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
  // last step - calculate inverse mod DV directly;
  // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints

  y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
  // we really want the negative inverse, and -DV < y < DV

  return y > 0 ? this.DV - y : -y;
}

function bnEquals(a) {
  return this.compareTo(a) == 0;
} // (protected) r = this + a


function bnpAddTo(a, r) {
  var i = 0,
      c = 0,
      m = Math.min(a.t, this.t);

  while (i < m) {
    c += this[i] + a[i];
    r[i++] = c & this.DM;
    c >>= this.DB;
  }

  if (a.t < this.t) {
    c += a.s;

    while (i < this.t) {
      c += this[i];
      r[i++] = c & this.DM;
      c >>= this.DB;
    }

    c += this.s;
  } else {
    c += this.s;

    while (i < a.t) {
      c += a[i];
      r[i++] = c & this.DM;
      c >>= this.DB;
    }

    c += a.s;
  }

  r.s = c < 0 ? -1 : 0;
  if (c > 0) r[i++] = c;else if (c < -1) r[i++] = this.DV + c;
  r.t = i;
  r.clamp();
} // (public) this + a


function bnAdd(a) {
  var r = nbi();
  this.addTo(a, r);
  return r;
} // (public) this - a


function bnSubtract(a) {
  var r = nbi();
  this.subTo(a, r);
  return r;
} // (public) this * a


function bnMultiply(a) {
  var r = nbi();
  this.multiplyTo(a, r);
  return r;
} // (public) this / a


function bnDivide(a) {
  var r = nbi();
  this.divRemTo(a, r, null);
  return r;
} // Montgomery reduction


function Montgomery(m) {
  this.m = m;
  this.mp = m.invDigit();
  this.mpl = this.mp & 0x7fff;
  this.mph = this.mp >> 15;
  this.um = (1 << m.DB - 15) - 1;
  this.mt2 = 2 * m.t;
} // xR mod m


function montConvert(x) {
  var r = nbi();
  x.abs().dlShiftTo(this.m.t, r);
  r.divRemTo(this.m, null, r);
  if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
  return r;
} // x/R mod m


function montRevert(x) {
  var r = nbi();
  x.copyTo(r);
  this.reduce(r);
  return r;
} // x = x/R mod m (HAC 14.32)


function montReduce(x) {
  while (x.t <= this.mt2) {
    // pad x so am has enough room later
    x[x.t++] = 0;
  }

  for (var i = 0; i < this.m.t; ++i) {
    // faster way of calculating u0 = x[i]*mp mod DV
    var j = x[i] & 0x7fff;
    var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM; // use am to combine the multiply-shift-add into one call

    j = i + this.m.t;
    x[j] += this.m.am(0, u0, x, i, 0, this.m.t); // propagate carry

    while (x[j] >= x.DV) {
      x[j] -= x.DV;
      x[++j]++;
    }
  }

  x.clamp();
  x.drShiftTo(this.m.t, x);
  if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
} // r = "x^2/R mod m"; x != r


function montSqrTo(x, r) {
  x.squareTo(r);
  this.reduce(r);
} // r = "xy/R mod m"; x,y != r


function montMulTo(x, y, r) {
  x.multiplyTo(y, r);
  this.reduce(r);
}

Montgomery.prototype.convert = montConvert;
Montgomery.prototype.revert = montRevert;
Montgomery.prototype.reduce = montReduce;
Montgomery.prototype.mulTo = montMulTo;
Montgomery.prototype.sqrTo = montSqrTo; // (public) this^e % m (HAC 14.85)

function bnModPow(e, m, callback) {
  var i = e.bitLength(),
      k,
      r = nbv(1),
      z = new Montgomery(m);
  if (i <= 0) return r;else if (i < 18) k = 1;else if (i < 48) k = 3;else if (i < 144) k = 4;else if (i < 768) k = 5;else k = 6; // precomputation

  var g = new Array(),
      n = 3,
      k1 = k - 1,
      km = (1 << k) - 1;
  g[1] = z.convert(this);

  if (k > 1) {
    var g2 = nbi();
    z.sqrTo(g[1], g2);

    while (n <= km) {
      g[n] = nbi();
      z.mulTo(g2, g[n - 2], g[n]);
      n += 2;
    }
  }

  var j = e.t - 1,
      w,
      is1 = true,
      r2 = nbi(),
      t;
  i = nbits(e[j]) - 1;

  while (j >= 0) {
    if (i >= k1) w = e[j] >> i - k1 & km;else {
      w = (e[j] & (1 << i + 1) - 1) << k1 - i;
      if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
    }
    n = k;

    while ((w & 1) == 0) {
      w >>= 1;
      --n;
    }

    if ((i -= n) < 0) {
      i += this.DB;
      --j;
    }

    if (is1) {
      // ret == 1, don't bother squaring or multiplying it
      g[w].copyTo(r);
      is1 = false;
    } else {
      while (n > 1) {
        z.sqrTo(r, r2);
        z.sqrTo(r2, r);
        n -= 2;
      }

      if (n > 0) z.sqrTo(r, r2);else {
        t = r;
        r = r2;
        r2 = t;
      }
      z.mulTo(r2, g[w], r);
    }

    while (j >= 0 && (e[j] & 1 << i) == 0) {
      z.sqrTo(r, r2);
      t = r;
      r = r2;
      r2 = t;

      if (--i < 0) {
        i = this.DB - 1;
        --j;
      }
    }
  }

  var result = z.revert(r);
  callback(null, result);
  return result;
} // protected


BigInteger.prototype.copyTo = bnpCopyTo;
BigInteger.prototype.fromInt = bnpFromInt;
BigInteger.prototype.fromString = bnpFromString;
BigInteger.prototype.clamp = bnpClamp;
BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
BigInteger.prototype.drShiftTo = bnpDRShiftTo;
BigInteger.prototype.lShiftTo = bnpLShiftTo;
BigInteger.prototype.rShiftTo = bnpRShiftTo;
BigInteger.prototype.subTo = bnpSubTo;
BigInteger.prototype.multiplyTo = bnpMultiplyTo;
BigInteger.prototype.squareTo = bnpSquareTo;
BigInteger.prototype.divRemTo = bnpDivRemTo;
BigInteger.prototype.invDigit = bnpInvDigit;
BigInteger.prototype.addTo = bnpAddTo; // public

BigInteger.prototype.toString = bnToString;
BigInteger.prototype.negate = bnNegate;
BigInteger.prototype.abs = bnAbs;
BigInteger.prototype.compareTo = bnCompareTo;
BigInteger.prototype.bitLength = bnBitLength;
BigInteger.prototype.mod = bnMod;
BigInteger.prototype.equals = bnEquals;
BigInteger.prototype.add = bnAdd;
BigInteger.prototype.subtract = bnSubtract;
BigInteger.prototype.multiply = bnMultiply;
BigInteger.prototype.divide = bnDivide;
BigInteger.prototype.modPow = bnModPow; // "constants"

BigInteger.ZERO = nbv(0);
BigInteger.ONE = nbv(1);

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CognitoAccessToken; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CognitoJwtToken__ = __webpack_require__(965);
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/*
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */

var CognitoAccessToken = /*#__PURE__*/function (_CognitoJwtToken) {
  _inheritsLoose(CognitoAccessToken, _CognitoJwtToken);

  /**
   * Constructs a new CognitoAccessToken object
   * @param {string=} AccessToken The JWT access token.
   */
  function CognitoAccessToken(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        AccessToken = _ref.AccessToken;

    return _CognitoJwtToken.call(this, AccessToken || '') || this;
  }

  return CognitoAccessToken;
}(__WEBPACK_IMPORTED_MODULE_0__CognitoJwtToken__["a" /* default */]);



/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CognitoIdToken; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CognitoJwtToken__ = __webpack_require__(965);
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */

var CognitoIdToken = /*#__PURE__*/function (_CognitoJwtToken) {
  _inheritsLoose(CognitoIdToken, _CognitoJwtToken);

  /**
   * Constructs a new CognitoIdToken object
   * @param {string=} IdToken The JWT Id token
   */
  function CognitoIdToken(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        IdToken = _ref.IdToken;

    return _CognitoJwtToken.call(this, IdToken || '') || this;
  }

  return CognitoIdToken;
}(__WEBPACK_IMPORTED_MODULE_0__CognitoJwtToken__["a" /* default */]);



/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CognitoJwtToken; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buffer__);
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */

var CognitoJwtToken = /*#__PURE__*/function () {
  /**
   * Constructs a new CognitoJwtToken object
   * @param {string=} token The JWT token.
   */
  function CognitoJwtToken(token) {
    // Assign object
    this.jwtToken = token || '';
    this.payload = this.decodePayload();
  }
  /**
   * @returns {string} the record's token.
   */


  var _proto = CognitoJwtToken.prototype;

  _proto.getJwtToken = function getJwtToken() {
    return this.jwtToken;
  }
  /**
   * @returns {int} the token's expiration (exp member).
   */
  ;

  _proto.getExpiration = function getExpiration() {
    return this.payload.exp;
  }
  /**
   * @returns {int} the token's "issued at" (iat member).
   */
  ;

  _proto.getIssuedAt = function getIssuedAt() {
    return this.payload.iat;
  }
  /**
   * @returns {object} the token's payload.
   */
  ;

  _proto.decodePayload = function decodePayload() {
    var payload = this.jwtToken.split('.')[1];

    try {
      return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(payload, 'base64').toString('utf8'));
    } catch (err) {
      return {};
    }
  };

  return CognitoJwtToken;
}();



/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CognitoRefreshToken; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */
var CognitoRefreshToken = /*#__PURE__*/function () {
  /**
   * Constructs a new CognitoRefreshToken object
   * @param {string=} RefreshToken The JWT refresh token.
   */
  function CognitoRefreshToken(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        RefreshToken = _ref.RefreshToken;

    // Assign object
    this.token = RefreshToken || '';
  }
  /**
   * @returns {string} the record's token.
   */


  var _proto = CognitoRefreshToken.prototype;

  _proto.getToken = function getToken() {
    return this.token;
  };

  return CognitoRefreshToken;
}();



/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CognitoUser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js_core__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_crypto_js_core__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_crypto_js_lib_typedarrays__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_crypto_js_lib_typedarrays___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_crypto_js_lib_typedarrays__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crypto_js_enc_base64__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_crypto_js_enc_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_crypto_js_enc_base64__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BigInteger__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AuthenticationHelper__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CognitoAccessToken__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CognitoIdToken__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CognitoRefreshToken__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CognitoUserSession__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DateHelper__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CognitoUserAttribute__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__StorageHelper__ = __webpack_require__(971);
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */


 // necessary for crypto js












/**
 * @callback nodeCallback
 * @template T result
 * @param {*} err The operation failure reason, or null.
 * @param {T} result The operation result.
 */

/**
 * @callback onFailure
 * @param {*} err Failure reason.
 */

/**
 * @callback onSuccess
 * @template T result
 * @param {T} result The operation result.
 */

/**
 * @callback mfaRequired
 * @param {*} details MFA challenge details.
 */

/**
 * @callback customChallenge
 * @param {*} details Custom challenge details.
 */

/**
 * @callback inputVerificationCode
 * @param {*} data Server response.
 */

/**
 * @callback authSuccess
 * @param {CognitoUserSession} session The new session.
 * @param {bool=} userConfirmationNecessary User must be confirmed.
 */

var isBrowser = typeof navigator !== 'undefined';
var userAgent = isBrowser ? navigator.userAgent : 'nodejs';
/** @class */

var CognitoUser = /*#__PURE__*/function () {
  /**
   * Constructs a new CognitoUser object
   * @param {object} data Creation options
   * @param {string} data.Username The user's username.
   * @param {CognitoUserPool} data.Pool Pool containing the user.
   * @param {object} data.Storage Optional storage object.
   */
  function CognitoUser(data) {
    if (data == null || data.Username == null || data.Pool == null) {
      throw new Error('Username and Pool information are required.');
    }

    this.username = data.Username || '';
    this.pool = data.Pool;
    this.Session = null;
    this.client = data.Pool.client;
    this.signInUserSession = null;
    this.authenticationFlowType = 'USER_SRP_AUTH';
    this.storage = data.Storage || new __WEBPACK_IMPORTED_MODULE_13__StorageHelper__["a" /* default */]().getStorage();
    this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
    this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
  }
  /**
   * Sets the session for this user
   * @param {CognitoUserSession} signInUserSession the session
   * @returns {void}
   */


  var _proto = CognitoUser.prototype;

  _proto.setSignInUserSession = function setSignInUserSession(signInUserSession) {
    this.clearCachedUserData();
    this.signInUserSession = signInUserSession;
    this.cacheTokens();
  }
  /**
   * @returns {CognitoUserSession} the current session for this user
   */
  ;

  _proto.getSignInUserSession = function getSignInUserSession() {
    return this.signInUserSession;
  }
  /**
   * @returns {string} the user's username
   */
  ;

  _proto.getUsername = function getUsername() {
    return this.username;
  }
  /**
   * @returns {String} the authentication flow type
   */
  ;

  _proto.getAuthenticationFlowType = function getAuthenticationFlowType() {
    return this.authenticationFlowType;
  }
  /**
   * sets authentication flow type
   * @param {string} authenticationFlowType New value.
   * @returns {void}
   */
  ;

  _proto.setAuthenticationFlowType = function setAuthenticationFlowType(authenticationFlowType) {
    this.authenticationFlowType = authenticationFlowType;
  }
  /**
   * This is used for authenticating the user through the custom authentication flow.
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */
  ;

  _proto.initiateAuth = function initiateAuth(authDetails, callback) {
    var _this = this;

    var authParameters = authDetails.getAuthParameters();
    authParameters.USERNAME = this.username;
    var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
    var jsonReq = {
      AuthFlow: 'CUSTOM_AUTH',
      ClientId: this.pool.getClientId(),
      AuthParameters: authParameters,
      ClientMetadata: clientMetaData
    };

    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }

    this.client.request('InitiateAuth', jsonReq, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }

      var challengeName = data.ChallengeName;
      var challengeParameters = data.ChallengeParameters;

      if (challengeName === 'CUSTOM_CHALLENGE') {
        _this.Session = data.Session;
        return callback.customChallenge(challengeParameters);
      }

      _this.signInUserSession = _this.getCognitoUserSession(data.AuthenticationResult);

      _this.cacheTokens();

      return callback.onSuccess(_this.signInUserSession);
    });
  }
  /**
   * This is used for authenticating the user.
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */
  ;

  _proto.authenticateUser = function authenticateUser(authDetails, callback) {
    if (this.authenticationFlowType === 'USER_PASSWORD_AUTH') {
      return this.authenticateUserPlainUsernamePassword(authDetails, callback);
    } else if (this.authenticationFlowType === 'USER_SRP_AUTH' || this.authenticationFlowType === 'CUSTOM_AUTH') {
      return this.authenticateUserDefaultAuth(authDetails, callback);
    }

    return callback.onFailure(new Error('Authentication flow type is invalid.'));
  }
  /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * It calls the AuthenticationHelper for SRP related
   * stuff
   * @param {AuthenticationDetails} authDetails Contains the authentication data
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {newPasswordRequired} callback.newPasswordRequired new
   *        password and any required attributes are required to continue
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *        response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */
  ;

  _proto.authenticateUserDefaultAuth = function authenticateUserDefaultAuth(authDetails, callback) {
    var _this2 = this;

    var authenticationHelper = new __WEBPACK_IMPORTED_MODULE_6__AuthenticationHelper__["a" /* default */](this.pool.getUserPoolId().split('_')[1]);
    var dateHelper = new __WEBPACK_IMPORTED_MODULE_11__DateHelper__["a" /* default */]();
    var serverBValue;
    var salt;
    var authParameters = {};

    if (this.deviceKey != null) {
      authParameters.DEVICE_KEY = this.deviceKey;
    }

    authParameters.USERNAME = this.username;
    authenticationHelper.getLargeAValue(function (errOnAValue, aValue) {
      // getLargeAValue callback start
      if (errOnAValue) {
        callback.onFailure(errOnAValue);
      }

      authParameters.SRP_A = aValue.toString(16);

      if (_this2.authenticationFlowType === 'CUSTOM_AUTH') {
        authParameters.CHALLENGE_NAME = 'SRP_A';
      }

      var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
      var jsonReq = {
        AuthFlow: _this2.authenticationFlowType,
        ClientId: _this2.pool.getClientId(),
        AuthParameters: authParameters,
        ClientMetadata: clientMetaData
      };

      if (_this2.getUserContextData(_this2.username)) {
        jsonReq.UserContextData = _this2.getUserContextData(_this2.username);
      }

      _this2.client.request('InitiateAuth', jsonReq, function (err, data) {
        if (err) {
          return callback.onFailure(err);
        }

        var challengeParameters = data.ChallengeParameters;
        _this2.username = challengeParameters.USER_ID_FOR_SRP;
        _this2.userDataKey = _this2.keyPrefix + "." + _this2.username + ".userData";
        serverBValue = new __WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */](challengeParameters.SRP_B, 16);
        salt = new __WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */](challengeParameters.SALT, 16);

        _this2.getCachedDeviceKeyAndPassword();

        authenticationHelper.getPasswordAuthenticationKey(_this2.username, authDetails.getPassword(), serverBValue, salt, function (errOnHkdf, hkdf) {
          // getPasswordAuthenticationKey callback start
          if (errOnHkdf) {
            callback.onFailure(errOnHkdf);
          }

          var dateNow = dateHelper.getNowString();
          var message = __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default.a.lib.WordArray.create(__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].concat([__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(_this2.pool.getUserPoolId().split('_')[1], 'utf8'), __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(_this2.username, 'utf8'), __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(challengeParameters.SECRET_BLOCK, 'base64'), __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(dateNow, 'utf8')]));
          var key = __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default.a.lib.WordArray.create(hkdf);
          var signatureString = __WEBPACK_IMPORTED_MODULE_3_crypto_js_enc_base64___default.a.stringify(__WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256___default()(message, key));
          var challengeResponses = {};
          challengeResponses.USERNAME = _this2.username;
          challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
          challengeResponses.TIMESTAMP = dateNow;
          challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;

          if (_this2.deviceKey != null) {
            challengeResponses.DEVICE_KEY = _this2.deviceKey;
          }

          var respondToAuthChallenge = function respondToAuthChallenge(challenge, challengeCallback) {
            return _this2.client.request('RespondToAuthChallenge', challenge, function (errChallenge, dataChallenge) {
              if (errChallenge && errChallenge.code === 'ResourceNotFoundException' && errChallenge.message.toLowerCase().indexOf('device') !== -1) {
                challengeResponses.DEVICE_KEY = null;
                _this2.deviceKey = null;
                _this2.randomPassword = null;
                _this2.deviceGroupKey = null;

                _this2.clearCachedDeviceKeyAndPassword();

                return respondToAuthChallenge(challenge, challengeCallback);
              }

              return challengeCallback(errChallenge, dataChallenge);
            });
          };

          var jsonReqResp = {
            ChallengeName: 'PASSWORD_VERIFIER',
            ClientId: _this2.pool.getClientId(),
            ChallengeResponses: challengeResponses,
            Session: data.Session,
            ClientMetadata: clientMetaData
          };

          if (_this2.getUserContextData()) {
            jsonReqResp.UserContextData = _this2.getUserContextData();
          }

          respondToAuthChallenge(jsonReqResp, function (errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) {
              return callback.onFailure(errAuthenticate);
            }

            return _this2.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
          });
          return undefined; // getPasswordAuthenticationKey callback end
        });
        return undefined;
      }); // getLargeAValue callback end

    });
  }
  /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {AuthenticationDetails} authDetails Contains the authentication data.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code
   *        required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @returns {void}
   */
  ;

  _proto.authenticateUserPlainUsernamePassword = function authenticateUserPlainUsernamePassword(authDetails, callback) {
    var _this3 = this;

    var authParameters = {};
    authParameters.USERNAME = this.username;
    authParameters.PASSWORD = authDetails.getPassword();

    if (!authParameters.PASSWORD) {
      callback.onFailure(new Error('PASSWORD parameter is required'));
      return;
    }

    var authenticationHelper = new __WEBPACK_IMPORTED_MODULE_6__AuthenticationHelper__["a" /* default */](this.pool.getUserPoolId().split('_')[1]);
    this.getCachedDeviceKeyAndPassword();

    if (this.deviceKey != null) {
      authParameters.DEVICE_KEY = this.deviceKey;
    }

    var clientMetaData = Object.keys(authDetails.getValidationData()).length !== 0 ? authDetails.getValidationData() : authDetails.getClientMetadata();
    var jsonReq = {
      AuthFlow: 'USER_PASSWORD_AUTH',
      ClientId: this.pool.getClientId(),
      AuthParameters: authParameters,
      ClientMetadata: clientMetaData
    };

    if (this.getUserContextData(this.username)) {
      jsonReq.UserContextData = this.getUserContextData(this.username);
    } // USER_PASSWORD_AUTH happens in a single round-trip: client sends userName and password,
    // Cognito UserPools verifies password and returns tokens.


    this.client.request('InitiateAuth', jsonReq, function (err, authResult) {
      if (err) {
        return callback.onFailure(err);
      }

      return _this3.authenticateUserInternal(authResult, authenticationHelper, callback);
    });
  }
  /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   * @param {object} dataAuthenticate authentication data
   * @param {object} authenticationHelper helper created
   * @param {callback} callback passed on from caller
   * @returns {void}
   */
  ;

  _proto.authenticateUserInternal = function authenticateUserInternal(dataAuthenticate, authenticationHelper, callback) {
    var _this4 = this;

    var challengeName = dataAuthenticate.ChallengeName;
    var challengeParameters = dataAuthenticate.ChallengeParameters;

    if (challengeName === 'SMS_MFA') {
      this.Session = dataAuthenticate.Session;
      return callback.mfaRequired(challengeName, challengeParameters);
    }

    if (challengeName === 'SELECT_MFA_TYPE') {
      this.Session = dataAuthenticate.Session;
      return callback.selectMFAType(challengeName, challengeParameters);
    }

    if (challengeName === 'MFA_SETUP') {
      this.Session = dataAuthenticate.Session;
      return callback.mfaSetup(challengeName, challengeParameters);
    }

    if (challengeName === 'SOFTWARE_TOKEN_MFA') {
      this.Session = dataAuthenticate.Session;
      return callback.totpRequired(challengeName, challengeParameters);
    }

    if (challengeName === 'CUSTOM_CHALLENGE') {
      this.Session = dataAuthenticate.Session;
      return callback.customChallenge(challengeParameters);
    }

    if (challengeName === 'NEW_PASSWORD_REQUIRED') {
      this.Session = dataAuthenticate.Session;
      var userAttributes = null;
      var rawRequiredAttributes = null;
      var requiredAttributes = [];
      var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();

      if (challengeParameters) {
        userAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.userAttributes);
        rawRequiredAttributes = JSON.parse(dataAuthenticate.ChallengeParameters.requiredAttributes);
      }

      if (rawRequiredAttributes) {
        for (var i = 0; i < rawRequiredAttributes.length; i++) {
          requiredAttributes[i] = rawRequiredAttributes[i].substr(userAttributesPrefix.length);
        }
      }

      return callback.newPasswordRequired(userAttributes, requiredAttributes);
    }

    if (challengeName === 'DEVICE_SRP_AUTH') {
      this.getDeviceResponse(callback);
      return undefined;
    }

    this.signInUserSession = this.getCognitoUserSession(dataAuthenticate.AuthenticationResult);
    this.challengeName = challengeName;
    this.cacheTokens();
    var newDeviceMetadata = dataAuthenticate.AuthenticationResult.NewDeviceMetadata;

    if (newDeviceMetadata == null) {
      return callback.onSuccess(this.signInUserSession);
    }

    authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function (errGenHash) {
      if (errGenHash) {
        return callback.onFailure(errGenHash);
      }

      var deviceSecretVerifierConfig = {
        Salt: __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
        PasswordVerifier: __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
      };
      _this4.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
      _this4.deviceGroupKey = newDeviceMetadata.DeviceGroupKey;
      _this4.randomPassword = authenticationHelper.getRandomPassword();

      _this4.client.request('ConfirmDevice', {
        DeviceKey: newDeviceMetadata.DeviceKey,
        AccessToken: _this4.signInUserSession.getAccessToken().getJwtToken(),
        DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
        DeviceName: userAgent
      }, function (errConfirm, dataConfirm) {
        if (errConfirm) {
          return callback.onFailure(errConfirm);
        }

        _this4.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;

        _this4.cacheDeviceKeyAndPassword();

        if (dataConfirm.UserConfirmationNecessary === true) {
          return callback.onSuccess(_this4.signInUserSession, dataConfirm.UserConfirmationNecessary);
        }

        return callback.onSuccess(_this4.signInUserSession);
      });

      return undefined;
    });
    return undefined;
  }
  /**
   * This method is user to complete the NEW_PASSWORD_REQUIRED challenge.
   * Pass the new password with any new user attributes to be updated.
   * User attribute keys must be of format userAttributes.<attribute_name>.
   * @param {string} newPassword new password for this user
   * @param {object} requiredAttributeData map with values for all required attributes
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {mfaRequired} callback.mfaRequired MFA code required to continue.
   * @param {customChallenge} callback.customChallenge Custom challenge
   *         response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */
  ;

  _proto.completeNewPasswordChallenge = function completeNewPasswordChallenge(newPassword, requiredAttributeData, callback, clientMetadata) {
    var _this5 = this;

    if (!newPassword) {
      return callback.onFailure(new Error('New password is required.'));
    }

    var authenticationHelper = new __WEBPACK_IMPORTED_MODULE_6__AuthenticationHelper__["a" /* default */](this.pool.getUserPoolId().split('_')[1]);
    var userAttributesPrefix = authenticationHelper.getNewPasswordRequiredChallengeUserAttributePrefix();
    var finalUserAttributes = {};

    if (requiredAttributeData) {
      Object.keys(requiredAttributeData).forEach(function (key) {
        finalUserAttributes[userAttributesPrefix + key] = requiredAttributeData[key];
      });
    }

    finalUserAttributes.NEW_PASSWORD = newPassword;
    finalUserAttributes.USERNAME = this.username;
    var jsonReq = {
      ChallengeName: 'NEW_PASSWORD_REQUIRED',
      ClientId: this.pool.getClientId(),
      ChallengeResponses: finalUserAttributes,
      Session: this.Session,
      ClientMetadata: clientMetadata
    };

    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }

    this.client.request('RespondToAuthChallenge', jsonReq, function (errAuthenticate, dataAuthenticate) {
      if (errAuthenticate) {
        return callback.onFailure(errAuthenticate);
      }

      return _this5.authenticateUserInternal(dataAuthenticate, authenticationHelper, callback);
    });
    return undefined;
  }
  /**
   * This is used to get a session using device authentication. It is called at the end of user
   * authentication
   *
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   * @private
   */
  ;

  _proto.getDeviceResponse = function getDeviceResponse(callback, clientMetadata) {
    var _this6 = this;

    var authenticationHelper = new __WEBPACK_IMPORTED_MODULE_6__AuthenticationHelper__["a" /* default */](this.deviceGroupKey);
    var dateHelper = new __WEBPACK_IMPORTED_MODULE_11__DateHelper__["a" /* default */]();
    var authParameters = {};
    authParameters.USERNAME = this.username;
    authParameters.DEVICE_KEY = this.deviceKey;
    authenticationHelper.getLargeAValue(function (errAValue, aValue) {
      // getLargeAValue callback start
      if (errAValue) {
        callback.onFailure(errAValue);
      }

      authParameters.SRP_A = aValue.toString(16);
      var jsonReq = {
        ChallengeName: 'DEVICE_SRP_AUTH',
        ClientId: _this6.pool.getClientId(),
        ChallengeResponses: authParameters,
        ClientMetadata: clientMetadata
      };

      if (_this6.getUserContextData()) {
        jsonReq.UserContextData = _this6.getUserContextData();
      }

      _this6.client.request('RespondToAuthChallenge', jsonReq, function (err, data) {
        if (err) {
          return callback.onFailure(err);
        }

        var challengeParameters = data.ChallengeParameters;
        var serverBValue = new __WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */](challengeParameters.SRP_B, 16);
        var salt = new __WEBPACK_IMPORTED_MODULE_5__BigInteger__["a" /* default */](challengeParameters.SALT, 16);
        authenticationHelper.getPasswordAuthenticationKey(_this6.deviceKey, _this6.randomPassword, serverBValue, salt, function (errHkdf, hkdf) {
          // getPasswordAuthenticationKey callback start
          if (errHkdf) {
            return callback.onFailure(errHkdf);
          }

          var dateNow = dateHelper.getNowString();
          var message = __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default.a.lib.WordArray.create(__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].concat([__WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(_this6.deviceGroupKey, 'utf8'), __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(_this6.deviceKey, 'utf8'), __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(challengeParameters.SECRET_BLOCK, 'base64'), __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(dateNow, 'utf8')]));
          var key = __WEBPACK_IMPORTED_MODULE_1_crypto_js_core___default.a.lib.WordArray.create(hkdf);
          var signatureString = __WEBPACK_IMPORTED_MODULE_3_crypto_js_enc_base64___default.a.stringify(__WEBPACK_IMPORTED_MODULE_4_crypto_js_hmac_sha256___default()(message, key));
          var challengeResponses = {};
          challengeResponses.USERNAME = _this6.username;
          challengeResponses.PASSWORD_CLAIM_SECRET_BLOCK = challengeParameters.SECRET_BLOCK;
          challengeResponses.TIMESTAMP = dateNow;
          challengeResponses.PASSWORD_CLAIM_SIGNATURE = signatureString;
          challengeResponses.DEVICE_KEY = _this6.deviceKey;
          var jsonReqResp = {
            ChallengeName: 'DEVICE_PASSWORD_VERIFIER',
            ClientId: _this6.pool.getClientId(),
            ChallengeResponses: challengeResponses,
            Session: data.Session
          };

          if (_this6.getUserContextData()) {
            jsonReqResp.UserContextData = _this6.getUserContextData();
          }

          _this6.client.request('RespondToAuthChallenge', jsonReqResp, function (errAuthenticate, dataAuthenticate) {
            if (errAuthenticate) {
              return callback.onFailure(errAuthenticate);
            }

            _this6.signInUserSession = _this6.getCognitoUserSession(dataAuthenticate.AuthenticationResult);

            _this6.cacheTokens();

            return callback.onSuccess(_this6.signInUserSession);
          });

          return undefined; // getPasswordAuthenticationKey callback end
        });
        return undefined;
      }); // getLargeAValue callback end

    });
  }
  /**
   * This is used for a certain user to confirm the registration by using a confirmation code
   * @param {string} confirmationCode Code entered by user.
   * @param {bool} forceAliasCreation Allow migrating from an existing email / phone number.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */
  ;

  _proto.confirmRegistration = function confirmRegistration(confirmationCode, forceAliasCreation, callback, clientMetadata) {
    var jsonReq = {
      ClientId: this.pool.getClientId(),
      ConfirmationCode: confirmationCode,
      Username: this.username,
      ForceAliasCreation: forceAliasCreation,
      ClientMetadata: clientMetadata
    };

    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }

    this.client.request('ConfirmSignUp', jsonReq, function (err) {
      if (err) {
        return callback(err, null);
      }

      return callback(null, 'SUCCESS');
    });
  }
  /**
   * This is used by the user once he has the responses to a custom challenge
   * @param {string} answerChallenge The custom challenge answer.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {customChallenge} callback.customChallenge
   *    Custom challenge response required to continue.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */
  ;

  _proto.sendCustomChallengeAnswer = function sendCustomChallengeAnswer(answerChallenge, callback, clientMetadata) {
    var _this7 = this;

    var challengeResponses = {};
    challengeResponses.USERNAME = this.username;
    challengeResponses.ANSWER = answerChallenge;
    var authenticationHelper = new __WEBPACK_IMPORTED_MODULE_6__AuthenticationHelper__["a" /* default */](this.pool.getUserPoolId().split('_')[1]);
    this.getCachedDeviceKeyAndPassword();

    if (this.deviceKey != null) {
      challengeResponses.DEVICE_KEY = this.deviceKey;
    }

    var jsonReq = {
      ChallengeName: 'CUSTOM_CHALLENGE',
      ChallengeResponses: challengeResponses,
      ClientId: this.pool.getClientId(),
      Session: this.Session,
      ClientMetadata: clientMetadata
    };

    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }

    this.client.request('RespondToAuthChallenge', jsonReq, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }

      return _this7.authenticateUserInternal(data, authenticationHelper, callback);
    });
  }
  /**
   * This is used by the user once he has an MFA code
   * @param {string} confirmationCode The MFA code entered by the user.
   * @param {object} callback Result callback map.
   * @param {string} mfaType The mfa we are replying to.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {authSuccess} callback.onSuccess Called on success with the new session.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */
  ;

  _proto.sendMFACode = function sendMFACode(confirmationCode, callback, mfaType, clientMetadata) {
    var _this8 = this;

    var challengeResponses = {};
    challengeResponses.USERNAME = this.username;
    challengeResponses.SMS_MFA_CODE = confirmationCode;
    var mfaTypeSelection = mfaType || 'SMS_MFA';

    if (mfaTypeSelection === 'SOFTWARE_TOKEN_MFA') {
      challengeResponses.SOFTWARE_TOKEN_MFA_CODE = confirmationCode;
    }

    if (this.deviceKey != null) {
      challengeResponses.DEVICE_KEY = this.deviceKey;
    }

    var jsonReq = {
      ChallengeName: mfaTypeSelection,
      ChallengeResponses: challengeResponses,
      ClientId: this.pool.getClientId(),
      Session: this.Session,
      ClientMetadata: clientMetadata
    };

    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }

    this.client.request('RespondToAuthChallenge', jsonReq, function (err, dataAuthenticate) {
      if (err) {
        return callback.onFailure(err);
      }

      var challengeName = dataAuthenticate.ChallengeName;

      if (challengeName === 'DEVICE_SRP_AUTH') {
        _this8.getDeviceResponse(callback);

        return undefined;
      }

      _this8.signInUserSession = _this8.getCognitoUserSession(dataAuthenticate.AuthenticationResult);

      _this8.cacheTokens();

      if (dataAuthenticate.AuthenticationResult.NewDeviceMetadata == null) {
        return callback.onSuccess(_this8.signInUserSession);
      }

      var authenticationHelper = new __WEBPACK_IMPORTED_MODULE_6__AuthenticationHelper__["a" /* default */](_this8.pool.getUserPoolId().split('_')[1]);
      authenticationHelper.generateHashDevice(dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey, function (errGenHash) {
        if (errGenHash) {
          return callback.onFailure(errGenHash);
        }

        var deviceSecretVerifierConfig = {
          Salt: __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(authenticationHelper.getSaltDevices(), 'hex').toString('base64'),
          PasswordVerifier: __WEBPACK_IMPORTED_MODULE_0_buffer__["Buffer"].from(authenticationHelper.getVerifierDevices(), 'hex').toString('base64')
        };
        _this8.verifierDevices = deviceSecretVerifierConfig.PasswordVerifier;
        _this8.deviceGroupKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey;
        _this8.randomPassword = authenticationHelper.getRandomPassword();

        _this8.client.request('ConfirmDevice', {
          DeviceKey: dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey,
          AccessToken: _this8.signInUserSession.getAccessToken().getJwtToken(),
          DeviceSecretVerifierConfig: deviceSecretVerifierConfig,
          DeviceName: userAgent
        }, function (errConfirm, dataConfirm) {
          if (errConfirm) {
            return callback.onFailure(errConfirm);
          }

          _this8.deviceKey = dataAuthenticate.AuthenticationResult.NewDeviceMetadata.DeviceKey;

          _this8.cacheDeviceKeyAndPassword();

          if (dataConfirm.UserConfirmationNecessary === true) {
            return callback.onSuccess(_this8.signInUserSession, dataConfirm.UserConfirmationNecessary);
          }

          return callback.onSuccess(_this8.signInUserSession);
        });

        return undefined;
      });
      return undefined;
    });
  }
  /**
   * This is used by an authenticated user to change the current password
   * @param {string} oldUserPassword The current password.
   * @param {string} newUserPassword The requested new password.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */
  ;

  _proto.changePassword = function changePassword(oldUserPassword, newUserPassword, callback, clientMetadata) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.request('ChangePassword', {
      PreviousPassword: oldUserPassword,
      ProposedPassword: newUserPassword,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      ClientMetadata: clientMetadata
    }, function (err) {
      if (err) {
        return callback(err, null);
      }

      return callback(null, 'SUCCESS');
    });
    return undefined;
  }
  /**
   * This is used by an authenticated user to enable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */
  ;

  _proto.enableMFA = function enableMFA(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error('User is not authenticated'), null);
    }

    var mfaOptions = [];
    var mfaEnabled = {
      DeliveryMedium: 'SMS',
      AttributeName: 'phone_number'
    };
    mfaOptions.push(mfaEnabled);
    this.client.request('SetUserSettings', {
      MFAOptions: mfaOptions,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback(err, null);
      }

      return callback(null, 'SUCCESS');
    });
    return undefined;
  }
  /**
   * This is used by an authenticated user to enable MFA for itself
   * @param {IMfaSettings} smsMfaSettings the sms mfa settings
   * @param {IMFASettings} softwareTokenMfaSettings the software token mfa settings
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */
  ;

  _proto.setUserMfaPreference = function setUserMfaPreference(smsMfaSettings, softwareTokenMfaSettings, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.request('SetUserMFAPreference', {
      SMSMfaSettings: smsMfaSettings,
      SoftwareTokenMfaSettings: softwareTokenMfaSettings,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback(err, null);
      }

      return callback(null, 'SUCCESS');
    });
    return undefined;
  }
  /**
   * This is used by an authenticated user to disable MFA for itself
   * @deprecated
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */
  ;

  _proto.disableMFA = function disableMFA(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error('User is not authenticated'), null);
    }

    var mfaOptions = [];
    this.client.request('SetUserSettings', {
      MFAOptions: mfaOptions,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback(err, null);
      }

      return callback(null, 'SUCCESS');
    });
    return undefined;
  }
  /**
   * This is used by an authenticated user to delete itself
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */
  ;

  _proto.deleteUser = function deleteUser(callback, clientMetadata) {
    var _this9 = this;

    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.request('DeleteUser', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      ClientMetadata: clientMetadata
    }, function (err) {
      if (err) {
        return callback(err, null);
      }

      _this9.clearCachedUser();

      return callback(null, 'SUCCESS');
    });
    return undefined;
  }
  /**
   * @typedef {CognitoUserAttribute | { Name:string, Value:string }} AttributeArg
   */

  /**
   * This is used by an authenticated user to change a list of attributes
   * @param {AttributeArg[]} attributes A list of the new user attributes.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */
  ;

  _proto.updateAttributes = function updateAttributes(attributes, callback, clientMetadata) {
    var _this10 = this;

    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.request('UpdateUserAttributes', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      UserAttributes: attributes,
      ClientMetadata: clientMetadata
    }, function (err) {
      if (err) {
        return callback(err, null);
      } // update cached user


      return _this10.getUserData(function () {
        return callback(null, 'SUCCESS');
      }, {
        bypassCache: true
      });
    });
    return undefined;
  }
  /**
   * This is used by an authenticated user to get a list of attributes
   * @param {nodeCallback<CognitoUserAttribute[]>} callback Called on success or error.
   * @returns {void}
   */
  ;

  _proto.getUserAttributes = function getUserAttributes(callback) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.request('GetUser', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err, userData) {
      if (err) {
        return callback(err, null);
      }

      var attributeList = [];

      for (var i = 0; i < userData.UserAttributes.length; i++) {
        var attribute = {
          Name: userData.UserAttributes[i].Name,
          Value: userData.UserAttributes[i].Value
        };
        var userAttribute = new __WEBPACK_IMPORTED_MODULE_12__CognitoUserAttribute__["a" /* default */](attribute);
        attributeList.push(userAttribute);
      }

      return callback(null, attributeList);
    });
    return undefined;
  }
  /**
   * This was previously used by an authenticated user to get MFAOptions,
   * but no longer returns a meaningful response. Refer to the documentation for
   * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
   * @deprecated
   * @param {nodeCallback<MFAOptions>} callback Called on success or error.
   * @returns {void}
   */
  ;

  _proto.getMFAOptions = function getMFAOptions(callback) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.request('GetUser', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err, userData) {
      if (err) {
        return callback(err, null);
      }

      return callback(null, userData.MFAOptions);
    });
    return undefined;
  }
  /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */
  ;

  _proto.createGetUserRequest = function createGetUserRequest() {
    return this.client.promisifyRequest('GetUser', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    });
  }
  /**
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */
  ;

  _proto.refreshSessionIfPossible = function refreshSessionIfPossible(options) {
    var _this11 = this;

    if (options === void 0) {
      options = {};
    }

    // best effort, if not possible
    return new Promise(function (resolve) {
      var refresh = _this11.signInUserSession.getRefreshToken();

      if (refresh && refresh.getToken()) {
        _this11.refreshSession(refresh, resolve, options.clientMetadata);
      } else {
        resolve();
      }
    });
  }
  /**
   * @typedef {Object} GetUserDataOptions
   * @property {boolean} bypassCache - force getting data from Cognito service
   * @property {Record<string, string>} clientMetadata - clientMetadata for getSession
   */

  /**
   * This is used by an authenticated users to get the userData
   * @param {nodeCallback<UserData>} callback Called on success or error.
   * @param {GetUserDataOptions} params
   * @returns {void}
   */
  ;

  _proto.getUserData = function getUserData(callback, params) {
    var _this12 = this;

    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      this.clearCachedUserData();
      return callback(new Error('User is not authenticated'), null);
    }

    var userData = this.getUserDataFromCache();

    if (!userData) {
      this.fetchUserData().then(function (data) {
        callback(null, data);
      })["catch"](callback);
      return;
    }

    if (this.isFetchUserDataAndTokenRequired(params)) {
      this.fetchUserData().then(function (data) {
        return _this12.refreshSessionIfPossible(params).then(function () {
          return data;
        });
      }).then(function (data) {
        return callback(null, data);
      })["catch"](callback);
      return;
    }

    try {
      callback(null, JSON.parse(userData));
      return;
    } catch (err) {
      this.clearCachedUserData();
      callback(err, null);
      return;
    }
  }
  /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */
  ;

  _proto.getUserDataFromCache = function getUserDataFromCache() {
    var userData = this.storage.getItem(this.userDataKey);
    return userData;
  }
  /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */
  ;

  _proto.isFetchUserDataAndTokenRequired = function isFetchUserDataAndTokenRequired(params) {
    var _ref = params || {},
        _ref$bypassCache = _ref.bypassCache,
        bypassCache = _ref$bypassCache === void 0 ? false : _ref$bypassCache;

    return bypassCache;
  }
  /**
   *
   * PRIVATE ONLY: This is an internal only method and should not
   * be directly called by the consumers.
   */
  ;

  _proto.fetchUserData = function fetchUserData() {
    var _this13 = this;

    return this.createGetUserRequest().then(function (data) {
      _this13.cacheUserData(data);

      return data;
    });
  }
  /**
   * This is used by an authenticated user to delete a list of attributes
   * @param {string[]} attributeList Names of the attributes to delete.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */
  ;

  _proto.deleteAttributes = function deleteAttributes(attributeList, callback) {
    var _this14 = this;

    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      return callback(new Error('User is not authenticated'), null);
    }

    this.client.request('DeleteUserAttributes', {
      UserAttributeNames: attributeList,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback(err, null);
      } // update cached user


      return _this14.getUserData(function () {
        return callback(null, 'SUCCESS');
      }, {
        bypassCache: true
      });
    });
    return undefined;
  }
  /**
   * This is used by a user to resend a confirmation code
   * @param {nodeCallback<string>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */
  ;

  _proto.resendConfirmationCode = function resendConfirmationCode(callback, clientMetadata) {
    var jsonReq = {
      ClientId: this.pool.getClientId(),
      Username: this.username,
      ClientMetadata: clientMetadata
    };
    this.client.request('ResendConfirmationCode', jsonReq, function (err, result) {
      if (err) {
        return callback(err, null);
      }

      return callback(null, result);
    });
  }
  /**
   * @typedef {Object} GetSessionOptions
   * @property {Record<string, string>} clientMetadata - clientMetadata for getSession
   */

  /**
   * This is used to get a session, either from the session object
   * or from  the local storage, or by using a refresh token
   *
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {GetSessionOptions} options
   * @returns {void}
   */
  ;

  _proto.getSession = function getSession(callback, options) {
    if (options === void 0) {
      options = {};
    }

    if (this.username == null) {
      return callback(new Error('Username is null. Cannot retrieve a new session'), null);
    }

    if (this.signInUserSession != null && this.signInUserSession.isValid()) {
      return callback(null, this.signInUserSession);
    }

    var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
    var idTokenKey = keyPrefix + ".idToken";
    var accessTokenKey = keyPrefix + ".accessToken";
    var refreshTokenKey = keyPrefix + ".refreshToken";
    var clockDriftKey = keyPrefix + ".clockDrift";

    if (this.storage.getItem(idTokenKey)) {
      var idToken = new __WEBPACK_IMPORTED_MODULE_8__CognitoIdToken__["a" /* default */]({
        IdToken: this.storage.getItem(idTokenKey)
      });
      var accessToken = new __WEBPACK_IMPORTED_MODULE_7__CognitoAccessToken__["a" /* default */]({
        AccessToken: this.storage.getItem(accessTokenKey)
      });
      var refreshToken = new __WEBPACK_IMPORTED_MODULE_9__CognitoRefreshToken__["a" /* default */]({
        RefreshToken: this.storage.getItem(refreshTokenKey)
      });
      var clockDrift = parseInt(this.storage.getItem(clockDriftKey), 0) || 0;
      var sessionData = {
        IdToken: idToken,
        AccessToken: accessToken,
        RefreshToken: refreshToken,
        ClockDrift: clockDrift
      };
      var cachedSession = new __WEBPACK_IMPORTED_MODULE_10__CognitoUserSession__["a" /* default */](sessionData);

      if (cachedSession.isValid()) {
        this.signInUserSession = cachedSession;
        return callback(null, this.signInUserSession);
      }

      if (!refreshToken.getToken()) {
        return callback(new Error('Cannot retrieve a new session. Please authenticate.'), null);
      }

      this.refreshSession(refreshToken, callback, options.clientMetadata);
    } else {
      callback(new Error('Local storage is missing an ID Token, Please authenticate'), null);
    }

    return undefined;
  }
  /**
   * This uses the refreshToken to retrieve a new session
   * @param {CognitoRefreshToken} refreshToken A previous session's refresh token.
   * @param {nodeCallback<CognitoUserSession>} callback Called on success or error.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */
  ;

  _proto.refreshSession = function refreshSession(refreshToken, callback, clientMetadata) {
    var _this15 = this;

    var wrappedCallback = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(callback) : callback;
    var authParameters = {};
    authParameters.REFRESH_TOKEN = refreshToken.getToken();
    var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
    var lastUserKey = keyPrefix + ".LastAuthUser";

    if (this.storage.getItem(lastUserKey)) {
      this.username = this.storage.getItem(lastUserKey);
      var deviceKeyKey = keyPrefix + "." + this.username + ".deviceKey";
      this.deviceKey = this.storage.getItem(deviceKeyKey);
      authParameters.DEVICE_KEY = this.deviceKey;
    }

    var jsonReq = {
      ClientId: this.pool.getClientId(),
      AuthFlow: 'REFRESH_TOKEN_AUTH',
      AuthParameters: authParameters,
      ClientMetadata: clientMetadata
    };

    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }

    this.client.request('InitiateAuth', jsonReq, function (err, authResult) {
      if (err) {
        if (err.code === 'NotAuthorizedException') {
          _this15.clearCachedUser();
        }

        return wrappedCallback(err, null);
      }

      if (authResult) {
        var authenticationResult = authResult.AuthenticationResult;

        if (!Object.prototype.hasOwnProperty.call(authenticationResult, 'RefreshToken')) {
          authenticationResult.RefreshToken = refreshToken.getToken();
        }

        _this15.signInUserSession = _this15.getCognitoUserSession(authenticationResult);

        _this15.cacheTokens();

        return wrappedCallback(null, _this15.signInUserSession);
      }

      return undefined;
    });
  }
  /**
   * This is used to save the session tokens to local storage
   * @returns {void}
   */
  ;

  _proto.cacheTokens = function cacheTokens() {
    var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
    var idTokenKey = keyPrefix + "." + this.username + ".idToken";
    var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
    var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
    var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
    var lastUserKey = keyPrefix + ".LastAuthUser";
    this.storage.setItem(idTokenKey, this.signInUserSession.getIdToken().getJwtToken());
    this.storage.setItem(accessTokenKey, this.signInUserSession.getAccessToken().getJwtToken());
    this.storage.setItem(refreshTokenKey, this.signInUserSession.getRefreshToken().getToken());
    this.storage.setItem(clockDriftKey, "" + this.signInUserSession.getClockDrift());
    this.storage.setItem(lastUserKey, this.username);
  }
  /**
   * This is to cache user data
   */
  ;

  _proto.cacheUserData = function cacheUserData(userData) {
    this.storage.setItem(this.userDataKey, JSON.stringify(userData));
  }
  /**
   * This is to remove cached user data
   */
  ;

  _proto.clearCachedUserData = function clearCachedUserData() {
    this.storage.removeItem(this.userDataKey);
  };

  _proto.clearCachedUser = function clearCachedUser() {
    this.clearCachedTokens();
    this.clearCachedUserData();
  }
  /**
   * This is used to cache the device key and device group and device password
   * @returns {void}
   */
  ;

  _proto.cacheDeviceKeyAndPassword = function cacheDeviceKeyAndPassword() {
    var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
    var deviceKeyKey = keyPrefix + ".deviceKey";
    var randomPasswordKey = keyPrefix + ".randomPasswordKey";
    var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
    this.storage.setItem(deviceKeyKey, this.deviceKey);
    this.storage.setItem(randomPasswordKey, this.randomPassword);
    this.storage.setItem(deviceGroupKeyKey, this.deviceGroupKey);
  }
  /**
   * This is used to get current device key and device group and device password
   * @returns {void}
   */
  ;

  _proto.getCachedDeviceKeyAndPassword = function getCachedDeviceKeyAndPassword() {
    var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
    var deviceKeyKey = keyPrefix + ".deviceKey";
    var randomPasswordKey = keyPrefix + ".randomPasswordKey";
    var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";

    if (this.storage.getItem(deviceKeyKey)) {
      this.deviceKey = this.storage.getItem(deviceKeyKey);
      this.randomPassword = this.storage.getItem(randomPasswordKey);
      this.deviceGroupKey = this.storage.getItem(deviceGroupKeyKey);
    }
  }
  /**
   * This is used to clear the device key info from local storage
   * @returns {void}
   */
  ;

  _proto.clearCachedDeviceKeyAndPassword = function clearCachedDeviceKeyAndPassword() {
    var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username;
    var deviceKeyKey = keyPrefix + ".deviceKey";
    var randomPasswordKey = keyPrefix + ".randomPasswordKey";
    var deviceGroupKeyKey = keyPrefix + ".deviceGroupKey";
    this.storage.removeItem(deviceKeyKey);
    this.storage.removeItem(randomPasswordKey);
    this.storage.removeItem(deviceGroupKeyKey);
  }
  /**
   * This is used to clear the session tokens from local storage
   * @returns {void}
   */
  ;

  _proto.clearCachedTokens = function clearCachedTokens() {
    var keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId();
    var idTokenKey = keyPrefix + "." + this.username + ".idToken";
    var accessTokenKey = keyPrefix + "." + this.username + ".accessToken";
    var refreshTokenKey = keyPrefix + "." + this.username + ".refreshToken";
    var lastUserKey = keyPrefix + ".LastAuthUser";
    var clockDriftKey = keyPrefix + "." + this.username + ".clockDrift";
    this.storage.removeItem(idTokenKey);
    this.storage.removeItem(accessTokenKey);
    this.storage.removeItem(refreshTokenKey);
    this.storage.removeItem(lastUserKey);
    this.storage.removeItem(clockDriftKey);
  }
  /**
   * This is used to build a user session from tokens retrieved in the authentication result
   * @param {object} authResult Successful auth response from server.
   * @returns {CognitoUserSession} The new user session.
   * @private
   */
  ;

  _proto.getCognitoUserSession = function getCognitoUserSession(authResult) {
    var idToken = new __WEBPACK_IMPORTED_MODULE_8__CognitoIdToken__["a" /* default */](authResult);
    var accessToken = new __WEBPACK_IMPORTED_MODULE_7__CognitoAccessToken__["a" /* default */](authResult);
    var refreshToken = new __WEBPACK_IMPORTED_MODULE_9__CognitoRefreshToken__["a" /* default */](authResult);
    var sessionData = {
      IdToken: idToken,
      AccessToken: accessToken,
      RefreshToken: refreshToken
    };
    return new __WEBPACK_IMPORTED_MODULE_10__CognitoUserSession__["a" /* default */](sessionData);
  }
  /**
   * This is used to initiate a forgot password request
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode?} callback.inputVerificationCode
   *    Optional callback raised instead of onSuccess with response data.
   * @param {onSuccess} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */
  ;

  _proto.forgotPassword = function forgotPassword(callback, clientMetadata) {
    var jsonReq = {
      ClientId: this.pool.getClientId(),
      Username: this.username,
      ClientMetadata: clientMetadata
    };

    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }

    this.client.request('ForgotPassword', jsonReq, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }

      if (typeof callback.inputVerificationCode === 'function') {
        return callback.inputVerificationCode(data);
      }

      return callback.onSuccess(data);
    });
  }
  /**
   * This is used to confirm a new password using a confirmationCode
   * @param {string} confirmationCode Code entered by user.
   * @param {string} newPassword Confirm new password.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<void>} callback.onSuccess Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */
  ;

  _proto.confirmPassword = function confirmPassword(confirmationCode, newPassword, callback, clientMetadata) {
    var jsonReq = {
      ClientId: this.pool.getClientId(),
      Username: this.username,
      ConfirmationCode: confirmationCode,
      Password: newPassword,
      ClientMetadata: clientMetadata
    };

    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }

    this.client.request('ConfirmForgotPassword', jsonReq, function (err) {
      if (err) {
        return callback.onFailure(err);
      }

      return callback.onSuccess();
    });
  }
  /**
   * This is used to initiate an attribute confirmation request
   * @param {string} attributeName User attribute that needs confirmation.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {inputVerificationCode} callback.inputVerificationCode Called on success.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */
  ;

  _proto.getAttributeVerificationCode = function getAttributeVerificationCode(attributeName, callback, clientMetadata) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.request('GetUserAttributeVerificationCode', {
      AttributeName: attributeName,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      ClientMetadata: clientMetadata
    }, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }

      if (typeof callback.inputVerificationCode === 'function') {
        return callback.inputVerificationCode(data);
      }

      return callback.onSuccess();
    });
    return undefined;
  }
  /**
   * This is used to confirm an attribute using a confirmation code
   * @param {string} attributeName Attribute being confirmed.
   * @param {string} confirmationCode Code entered by user.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */
  ;

  _proto.verifyAttribute = function verifyAttribute(attributeName, confirmationCode, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.request('VerifyUserAttribute', {
      AttributeName: attributeName,
      Code: confirmationCode,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback.onFailure(err);
      }

      return callback.onSuccess('SUCCESS');
    });
    return undefined;
  }
  /**
   * This is used to get the device information using the current device key
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device data.
   * @returns {void}
   */
  ;

  _proto.getDevice = function getDevice(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.request('GetDevice', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey
    }, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }

      return callback.onSuccess(data);
    });
    return undefined;
  }
  /**
   * This is used to forget a specific device
   * @param {string} deviceKey Device key.
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */
  ;

  _proto.forgetSpecificDevice = function forgetSpecificDevice(deviceKey, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.request('ForgetDevice', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: deviceKey
    }, function (err) {
      if (err) {
        return callback.onFailure(err);
      }

      return callback.onSuccess('SUCCESS');
    });
    return undefined;
  }
  /**
   * This is used to forget the current device
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */
  ;

  _proto.forgetDevice = function forgetDevice(callback) {
    var _this16 = this;

    this.forgetSpecificDevice(this.deviceKey, {
      onFailure: callback.onFailure,
      onSuccess: function onSuccess(result) {
        _this16.deviceKey = null;
        _this16.deviceGroupKey = null;
        _this16.randomPassword = null;

        _this16.clearCachedDeviceKeyAndPassword();

        return callback.onSuccess(result);
      }
    });
  }
  /**
   * This is used to set the device status as remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */
  ;

  _proto.setDeviceStatusRemembered = function setDeviceStatusRemembered(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.request('UpdateDeviceStatus', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey,
      DeviceRememberedStatus: 'remembered'
    }, function (err) {
      if (err) {
        return callback.onFailure(err);
      }

      return callback.onSuccess('SUCCESS');
    });
    return undefined;
  }
  /**
   * This is used to set the device status as not remembered
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */
  ;

  _proto.setDeviceStatusNotRemembered = function setDeviceStatusNotRemembered(callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.request('UpdateDeviceStatus', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey,
      DeviceRememberedStatus: 'not_remembered'
    }, function (err) {
      if (err) {
        return callback.onFailure(err);
      }

      return callback.onSuccess('SUCCESS');
    });
    return undefined;
  }
  /**
   * This is used to list all devices for a user
   *
   * @param {int} limit the number of devices returned in a call
   * @param {string | null} paginationToken the pagination token in case any was returned before
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<*>} callback.onSuccess Called on success with device list.
   * @returns {void}
   */
  ;

  _proto.listDevices = function listDevices(limit, paginationToken, callback) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    var requestParams = {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      Limit: limit
    };

    if (paginationToken) {
      requestParams.PaginationToken = paginationToken;
    }

    this.client.request('ListDevices', requestParams, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }

      return callback.onSuccess(data);
    });
    return undefined;
  }
  /**
   * This is used to globally revoke all tokens issued to a user
   * @param {object} callback Result callback map.
   * @param {onFailure} callback.onFailure Called on any error.
   * @param {onSuccess<string>} callback.onSuccess Called on success.
   * @returns {void}
   */
  ;

  _proto.globalSignOut = function globalSignOut(callback) {
    var _this17 = this;

    if (this.signInUserSession == null || !this.signInUserSession.isValid()) {
      return callback.onFailure(new Error('User is not authenticated'));
    }

    this.client.request('GlobalSignOut', {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function (err) {
      if (err) {
        return callback.onFailure(err);
      }

      _this17.clearCachedUser();

      return callback.onSuccess('SUCCESS');
    });
    return undefined;
  }
  /**
   * This is used for the user to signOut of the application and clear the cached tokens.
   * @returns {void}
   */
  ;

  _proto.signOut = function signOut(revokeTokenCallback) {
    var _this18 = this;

    // If tokens won't be revoked, we just clean the client data.
    if (!revokeTokenCallback || typeof revokeTokenCallback !== "function") {
      this.cleanClientData();
      return;
    }

    this.getSession(function (error, _session) {
      if (error) {
        return revokeTokenCallback(error);
      }

      _this18.revokeTokens(function (err) {
        _this18.cleanClientData();

        revokeTokenCallback(err);
      });
    });
  };

  _proto.revokeTokens = function revokeTokens(revokeTokenCallback) {
    if (revokeTokenCallback === void 0) {
      revokeTokenCallback = function revokeTokenCallback() {};
    }

    if (typeof revokeTokenCallback !== 'function') {
      throw new Error('Invalid revokeTokenCallback. It should be a function.');
    }

    var tokensToBeRevoked = [];

    if (!this.signInUserSession) {
      var error = new Error('User is not authenticated');
      return revokeTokenCallback(error);
    }

    if (!this.signInUserSession.getAccessToken()) {
      var _error = new Error('No Access token available');

      return revokeTokenCallback(_error);
    }

    var refreshToken = this.signInUserSession.getRefreshToken().getToken();
    var accessToken = this.signInUserSession.getAccessToken();

    if (this.isSessionRevocable(accessToken)) {
      if (refreshToken) {
        return this.revokeToken({
          token: refreshToken,
          callback: revokeTokenCallback
        });
      }
    }

    revokeTokenCallback();
  };

  _proto.isSessionRevocable = function isSessionRevocable(token) {
    if (token && typeof token.decodePayload === 'function') {
      try {
        var _token$decodePayload = token.decodePayload(),
            origin_jti = _token$decodePayload.origin_jti;

        return !!origin_jti;
      } catch (err) {// Nothing to do, token doesnt have origin_jti claim
      }
    }

    return false;
  };

  _proto.cleanClientData = function cleanClientData() {
    this.signInUserSession = null;
    this.clearCachedUser();
  };

  _proto.revokeToken = function revokeToken(_ref2) {
    var token = _ref2.token,
        callback = _ref2.callback;
    this.client.requestWithRetry('RevokeToken', {
      Token: token,
      ClientId: this.pool.getClientId()
    }, function (err) {
      if (err) {
        return callback(err);
      }

      callback();
    });
  }
  /**
   * This is used by a user trying to select a given MFA
   * @param {string} answerChallenge the mfa the user wants
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */
  ;

  _proto.sendMFASelectionAnswer = function sendMFASelectionAnswer(answerChallenge, callback) {
    var _this19 = this;

    var challengeResponses = {};
    challengeResponses.USERNAME = this.username;
    challengeResponses.ANSWER = answerChallenge;
    var jsonReq = {
      ChallengeName: 'SELECT_MFA_TYPE',
      ChallengeResponses: challengeResponses,
      ClientId: this.pool.getClientId(),
      Session: this.Session
    };

    if (this.getUserContextData()) {
      jsonReq.UserContextData = this.getUserContextData();
    }

    this.client.request('RespondToAuthChallenge', jsonReq, function (err, data) {
      if (err) {
        return callback.onFailure(err);
      }

      _this19.Session = data.Session;

      if (answerChallenge === 'SMS_MFA') {
        return callback.mfaRequired(data.ChallengeName, data.ChallengeParameters);
      }

      if (answerChallenge === 'SOFTWARE_TOKEN_MFA') {
        return callback.totpRequired(data.ChallengeName, data.ChallengeParameters);
      }

      return undefined;
    });
  }
  /**
   * This returns the user context data for advanced security feature.
   * @returns {string} the user context data from CognitoUserPool
   */
  ;

  _proto.getUserContextData = function getUserContextData() {
    var pool = this.pool;
    return pool.getUserContextData(this.username);
  }
  /**
   * This is used by an authenticated or a user trying to authenticate to associate a TOTP MFA
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */
  ;

  _proto.associateSoftwareToken = function associateSoftwareToken(callback) {
    var _this20 = this;

    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      this.client.request('AssociateSoftwareToken', {
        Session: this.Session
      }, function (err, data) {
        if (err) {
          return callback.onFailure(err);
        }

        _this20.Session = data.Session;
        return callback.associateSecretCode(data.SecretCode);
      });
    } else {
      this.client.request('AssociateSoftwareToken', {
        AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
      }, function (err, data) {
        if (err) {
          return callback.onFailure(err);
        }

        return callback.associateSecretCode(data.SecretCode);
      });
    }
  }
  /**
   * This is used by an authenticated or a user trying to authenticate to verify a TOTP MFA
   * @param {string} totpCode The MFA code entered by the user.
   * @param {string} friendlyDeviceName The device name we are assigning to the device.
   * @param {nodeCallback<string>} callback Called on success or error.
   * @returns {void}
   */
  ;

  _proto.verifySoftwareToken = function verifySoftwareToken(totpCode, friendlyDeviceName, callback) {
    var _this21 = this;

    if (!(this.signInUserSession != null && this.signInUserSession.isValid())) {
      this.client.request('VerifySoftwareToken', {
        Session: this.Session,
        UserCode: totpCode,
        FriendlyDeviceName: friendlyDeviceName
      }, function (err, data) {
        if (err) {
          return callback.onFailure(err);
        }

        _this21.Session = data.Session;
        var challengeResponses = {};
        challengeResponses.USERNAME = _this21.username;
        var jsonReq = {
          ChallengeName: 'MFA_SETUP',
          ClientId: _this21.pool.getClientId(),
          ChallengeResponses: challengeResponses,
          Session: _this21.Session
        };

        if (_this21.getUserContextData()) {
          jsonReq.UserContextData = _this21.getUserContextData();
        }

        _this21.client.request('RespondToAuthChallenge', jsonReq, function (errRespond, dataRespond) {
          if (errRespond) {
            return callback.onFailure(errRespond);
          }

          _this21.signInUserSession = _this21.getCognitoUserSession(dataRespond.AuthenticationResult);

          _this21.cacheTokens();

          return callback.onSuccess(_this21.signInUserSession);
        });

        return undefined;
      });
    } else {
      this.client.request('VerifySoftwareToken', {
        AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
        UserCode: totpCode,
        FriendlyDeviceName: friendlyDeviceName
      }, function (err, data) {
        if (err) {
          return callback.onFailure(err);
        }

        return callback.onSuccess(data);
      });
    }
  };

  return CognitoUser;
}();



/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CognitoUserAttribute; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */
var CognitoUserAttribute = /*#__PURE__*/function () {
  /**
   * Constructs a new CognitoUserAttribute object
   * @param {string=} Name The record's name
   * @param {string=} Value The record's value
   */
  function CognitoUserAttribute(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        Name = _ref.Name,
        Value = _ref.Value;

    this.Name = Name || '';
    this.Value = Value || '';
  }
  /**
   * @returns {string} the record's value.
   */


  var _proto = CognitoUserAttribute.prototype;

  _proto.getValue = function getValue() {
    return this.Value;
  }
  /**
   * Sets the record's value.
   * @param {string} value The new value.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */
  ;

  _proto.setValue = function setValue(value) {
    this.Value = value;
    return this;
  }
  /**
   * @returns {string} the record's name.
   */
  ;

  _proto.getName = function getName() {
    return this.Name;
  }
  /**
   * Sets the record's name
   * @param {string} name The new name.
   * @returns {CognitoUserAttribute} The record for method chaining.
   */
  ;

  _proto.setName = function setName(name) {
    this.Name = name;
    return this;
  }
  /**
   * @returns {string} a string representation of the record.
   */
  ;

  _proto.toString = function toString() {
    return JSON.stringify(this);
  }
  /**
   * @returns {object} a flat object representing the record.
   */
  ;

  _proto.toJSON = function toJSON() {
    return {
      Name: this.Name,
      Value: this.Value
    };
  };

  return CognitoUserAttribute;
}();



/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CognitoUserSession; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */
var CognitoUserSession = /*#__PURE__*/function () {
  /**
   * Constructs a new CognitoUserSession object
   * @param {CognitoIdToken} IdToken The session's Id token.
   * @param {CognitoRefreshToken=} RefreshToken The session's refresh token.
   * @param {CognitoAccessToken} AccessToken The session's access token.
   * @param {int} ClockDrift The saved computer's clock drift or undefined to force calculation.
   */
  function CognitoUserSession(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        IdToken = _ref.IdToken,
        RefreshToken = _ref.RefreshToken,
        AccessToken = _ref.AccessToken,
        ClockDrift = _ref.ClockDrift;

    if (AccessToken == null || IdToken == null) {
      throw new Error('Id token and Access Token must be present.');
    }

    this.idToken = IdToken;
    this.refreshToken = RefreshToken;
    this.accessToken = AccessToken;
    this.clockDrift = ClockDrift === undefined ? this.calculateClockDrift() : ClockDrift;
  }
  /**
   * @returns {CognitoIdToken} the session's Id token
   */


  var _proto = CognitoUserSession.prototype;

  _proto.getIdToken = function getIdToken() {
    return this.idToken;
  }
  /**
   * @returns {CognitoRefreshToken} the session's refresh token
   */
  ;

  _proto.getRefreshToken = function getRefreshToken() {
    return this.refreshToken;
  }
  /**
   * @returns {CognitoAccessToken} the session's access token
   */
  ;

  _proto.getAccessToken = function getAccessToken() {
    return this.accessToken;
  }
  /**
   * @returns {int} the session's clock drift
   */
  ;

  _proto.getClockDrift = function getClockDrift() {
    return this.clockDrift;
  }
  /**
   * @returns {int} the computer's clock drift
   */
  ;

  _proto.calculateClockDrift = function calculateClockDrift() {
    var now = Math.floor(new Date() / 1000);
    var iat = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
    return now - iat;
  }
  /**
   * Checks to see if the session is still valid based on session expiry information found
   * in tokens and the current time (adjusted with clock drift)
   * @returns {boolean} if the session is still valid
   */
  ;

  _proto.isValid = function isValid() {
    var now = Math.floor(new Date() / 1000);
    var adjusted = now - this.clockDrift;
    return adjusted < this.accessToken.getExpiration() && adjusted < this.idToken.getExpiration();
  };

  return CognitoUserSession;
}();



/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateHelper; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */
var monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
var weekNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
/** @class */

var DateHelper = /*#__PURE__*/function () {
  function DateHelper() {}

  var _proto = DateHelper.prototype;

  /**
   * @returns {string} The current time in "ddd MMM D HH:mm:ss UTC YYYY" format.
   */
  _proto.getNowString = function getNowString() {
    var now = new Date();
    var weekDay = weekNames[now.getUTCDay()];
    var month = monthNames[now.getUTCMonth()];
    var day = now.getUTCDate();
    var hours = now.getUTCHours();

    if (hours < 10) {
      hours = "0" + hours;
    }

    var minutes = now.getUTCMinutes();

    if (minutes < 10) {
      minutes = "0" + minutes;
    }

    var seconds = now.getUTCSeconds();

    if (seconds < 10) {
      seconds = "0" + seconds;
    }

    var year = now.getUTCFullYear(); // ddd MMM D HH:mm:ss UTC YYYY

    var dateNow = weekDay + " " + month + " " + day + " " + hours + ":" + minutes + ":" + seconds + " UTC " + year;
    return dateNow;
  };

  return DateHelper;
}();



/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MemoryStorage */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StorageHelper; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */
var dataMemory = {};
/** @class */

var MemoryStorage = /*#__PURE__*/function () {
  function MemoryStorage() {}

  /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */
  MemoryStorage.setItem = function setItem(key, value) {
    dataMemory[key] = value;
    return dataMemory[key];
  }
  /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */
  ;

  MemoryStorage.getItem = function getItem(key) {
    return Object.prototype.hasOwnProperty.call(dataMemory, key) ? dataMemory[key] : undefined;
  }
  /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {boolean} return true
   */
  ;

  MemoryStorage.removeItem = function removeItem(key) {
    return delete dataMemory[key];
  }
  /**
   * This is used to clear the storage
   * @returns {string} nothing
   */
  ;

  MemoryStorage.clear = function clear() {
    dataMemory = {};
    return dataMemory;
  };

  return MemoryStorage;
}();
/** @class */

var StorageHelper = /*#__PURE__*/function () {
  /**
   * This is used to get a storage object
   * @returns {object} the storage
   */
  function StorageHelper() {
    try {
      this.storageWindow = window.localStorage;
      this.storageWindow.setItem('aws.cognito.test-ls', 1);
      this.storageWindow.removeItem('aws.cognito.test-ls');
    } catch (exception) {
      this.storageWindow = MemoryStorage;
    }
  }
  /**
   * This is used to return the storage
   * @returns {object} the storage
   */


  var _proto = StorageHelper.prototype;

  _proto.getStorage = function getStorage() {
    return this.storageWindow;
  };

  return StorageHelper;
}();



/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return appendToCognitoUserAgent; });
// constructor
function UserAgent() {} // public


UserAgent.prototype.userAgent = 'aws-amplify/0.1.x js';
var appendToCognitoUserAgent = function appendToCognitoUserAgent(content) {
  if (!content) {
    return;
  }

  if (UserAgent.prototype.userAgent && !UserAgent.prototype.userAgent.includes(content)) {
    UserAgent.prototype.userAgent = UserAgent.prototype.userAgent.concat(' ', content);
  }

  if (!UserAgent.prototype.userAgent || UserAgent.prototype.userAgent === '') {
    UserAgent.prototype.userAgent = content;
  }
}; // class for defining the amzn user-agent

/* harmony default export */ __webpack_exports__["b"] = (UserAgent);

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AuthenticationDetails__ = __webpack_require__(2046);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__AuthenticationDetails__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthenticationHelper__ = __webpack_require__(961);
/* unused harmony reexport AuthenticationHelper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CognitoAccessToken__ = __webpack_require__(963);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__CognitoAccessToken__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CognitoIdToken__ = __webpack_require__(964);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_3__CognitoIdToken__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CognitoRefreshToken__ = __webpack_require__(966);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_4__CognitoRefreshToken__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CognitoUser__ = __webpack_require__(967);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_5__CognitoUser__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CognitoUserAttribute__ = __webpack_require__(968);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__CognitoUserAttribute__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CognitoUserPool__ = __webpack_require__(2048);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__CognitoUserPool__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CognitoUserSession__ = __webpack_require__(969);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_8__CognitoUserSession__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CookieStorage__ = __webpack_require__(2049);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_9__CookieStorage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DateHelper__ = __webpack_require__(970);
/* unused harmony reexport DateHelper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__UserAgent__ = __webpack_require__(972);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_11__UserAgent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_WordArray__ = __webpack_require__(974);
/* unused harmony reexport WordArray */
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */














/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WordArray; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cryptoSecureRandomInt__ = __webpack_require__(2050);

/**
 * Hex encoding strategy.
 * Converts a word array to a hex string.
 * @param {WordArray} wordArray The word array.
 * @return {string} The hex string.
 * @static
 */

function hexStringify(wordArray) {
  // Shortcuts
  var words = wordArray.words;
  var sigBytes = wordArray.sigBytes; // Convert

  var hexChars = [];

  for (var i = 0; i < sigBytes; i++) {
    var bite = words[i >>> 2] >>> 24 - i % 4 * 8 & 0xff;
    hexChars.push((bite >>> 4).toString(16));
    hexChars.push((bite & 0x0f).toString(16));
  }

  return hexChars.join('');
}

var WordArray = /*#__PURE__*/function () {
  function WordArray(words, sigBytes) {
    words = this.words = words || [];

    if (sigBytes != undefined) {
      this.sigBytes = sigBytes;
    } else {
      this.sigBytes = words.length * 4;
    }
  }

  var _proto = WordArray.prototype;

  _proto.random = function random(nBytes) {
    var words = [];

    for (var i = 0; i < nBytes; i += 4) {
      words.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__cryptoSecureRandomInt__["a" /* default */])());
    }

    return new WordArray(words, nBytes);
  };

  _proto.toString = function toString() {
    return hexStringify(this);
  };

  return WordArray;
}();



/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(41);
var Reporter = __webpack_require__(311).Reporter;
var Buffer = __webpack_require__(75).Buffer;

function DecoderBuffer(base, options) {
  Reporter.call(this, options);
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer');
    return;
  }

  this.base = base;
  this.offset = 0;
  this.length = base.length;
}
inherits(DecoderBuffer, Reporter);
exports.DecoderBuffer = DecoderBuffer;

DecoderBuffer.prototype.save = function save() {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) };
};

DecoderBuffer.prototype.restore = function restore(save) {
  // Return skipped data
  var res = new DecoderBuffer(this.base);
  res.offset = save.offset;
  res.length = this.offset;

  this.offset = save.offset;
  Reporter.prototype.restore.call(this, save.reporter);

  return res;
};

DecoderBuffer.prototype.isEmpty = function isEmpty() {
  return this.offset === this.length;
};

DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
  if (this.offset + 1 <= this.length)
    return this.base.readUInt8(this.offset++, true);
  else
    return this.error(fail || 'DecoderBuffer overrun');
}

DecoderBuffer.prototype.skip = function skip(bytes, fail) {
  if (!(this.offset + bytes <= this.length))
    return this.error(fail || 'DecoderBuffer overrun');

  var res = new DecoderBuffer(this.base);

  // Share reporter state
  res._reporterState = this._reporterState;

  res.offset = this.offset;
  res.length = this.offset + bytes;
  this.offset += bytes;
  return res;
}

DecoderBuffer.prototype.raw = function raw(save) {
  return this.base.slice(save ? save.offset : this.offset, this.length);
}

function EncoderBuffer(value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0;
    this.value = value.map(function(item) {
      if (!(item instanceof EncoderBuffer))
        item = new EncoderBuffer(item, reporter);
      this.length += item.length;
      return item;
    }, this);
  } else if (typeof value === 'number') {
    if (!(0 <= value && value <= 0xff))
      return reporter.error('non-byte EncoderBuffer value');
    this.value = value;
    this.length = 1;
  } else if (typeof value === 'string') {
    this.value = value;
    this.length = Buffer.byteLength(value);
  } else if (Buffer.isBuffer(value)) {
    this.value = value;
    this.length = value.length;
  } else {
    return reporter.error('Unsupported type: ' + typeof value);
  }
}
exports.EncoderBuffer = EncoderBuffer;

EncoderBuffer.prototype.join = function join(out, offset) {
  if (!out)
    out = new Buffer(this.length);
  if (!offset)
    offset = 0;

  if (this.length === 0)
    return out;

  if (Array.isArray(this.value)) {
    this.value.forEach(function(item) {
      item.join(out, offset);
      offset += item.length;
    });
  } else {
    if (typeof this.value === 'number')
      out[offset] = this.value;
    else if (typeof this.value === 'string')
      out.write(this.value, offset);
    else if (Buffer.isBuffer(this.value))
      this.value.copy(out, offset);
    offset += this.length;
  }

  return out;
};


/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

var constants = exports;

// Helper
constants._reverse = function reverse(map) {
  var res = {};

  Object.keys(map).forEach(function(key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key)
      key = key | 0;

    var value = map[key];
    res[value] = key;
  });

  return res;
};

constants.der = __webpack_require__(2054);


/***/ }),
/* 977 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(41);

var asn1 = __webpack_require__(310);
var base = asn1.base;
var bignum = asn1.bignum;

// Import DER constants
var der = asn1.constants.der;

function DERDecoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DERDecoder;

DERDecoder.prototype.decode = function decode(data, options) {
  if (!(data instanceof base.DecoderBuffer))
    data = new base.DecoderBuffer(data, options);

  return this.tree._decode(data, options);
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
  if (buffer.isEmpty())
    return false;

  var state = buffer.save();
  var decodedTag = derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  buffer.restore(state);

  return decodedTag.tag === tag || decodedTag.tagStr === tag ||
    (decodedTag.tagStr + 'of') === tag || any;
};

DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
  var decodedTag = derDecodeTag(buffer,
                                'Failed to decode tag of "' + tag + '"');
  if (buffer.isError(decodedTag))
    return decodedTag;

  var len = derDecodeLen(buffer,
                         decodedTag.primitive,
                         'Failed to get length of "' + tag + '"');

  // Failure
  if (buffer.isError(len))
    return len;

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error('Failed to match tag: "' + tag + '"');
  }

  if (decodedTag.primitive || len !== null)
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');

  // Indefinite length... find END tag
  var state = buffer.save();
  var res = this._skipUntilEnd(
      buffer,
      'Failed to skip indefinite length body: "' + this.tag + '"');
  if (buffer.isError(res))
    return res;

  len = buffer.offset - state.offset;
  buffer.restore(state);
  return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};

DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
  while (true) {
    var tag = derDecodeTag(buffer, fail);
    if (buffer.isError(tag))
      return tag;
    var len = derDecodeLen(buffer, tag.primitive, fail);
    if (buffer.isError(len))
      return len;

    var res;
    if (tag.primitive || len !== null)
      res = buffer.skip(len)
    else
      res = this._skipUntilEnd(buffer, fail);

    // Failure
    if (buffer.isError(res))
      return res;

    if (tag.tagStr === 'end')
      break;
  }
};

DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder,
                                                    options) {
  var result = [];
  while (!buffer.isEmpty()) {
    var possibleEnd = this._peekTag(buffer, 'end');
    if (buffer.isError(possibleEnd))
      return possibleEnd;

    var res = decoder.decode(buffer, 'der', options);
    if (buffer.isError(res) && possibleEnd)
      break;
    result.push(res);
  }
  return result;
};

DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
  if (tag === 'bitstr') {
    var unused = buffer.readUInt8();
    if (buffer.isError(unused))
      return unused;
    return { unused: unused, data: buffer.raw() };
  } else if (tag === 'bmpstr') {
    var raw = buffer.raw();
    if (raw.length % 2 === 1)
      return buffer.error('Decoding of string type: bmpstr length mismatch');

    var str = '';
    for (var i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2));
    }
    return str;
  } else if (tag === 'numstr') {
    var numstr = buffer.raw().toString('ascii');
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: ' +
                          'numstr unsupported characters');
    }
    return numstr;
  } else if (tag === 'octstr') {
    return buffer.raw();
  } else if (tag === 'objDesc') {
    return buffer.raw();
  } else if (tag === 'printstr') {
    var printstr = buffer.raw().toString('ascii');
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: ' +
                          'printstr unsupported characters');
    }
    return printstr;
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString();
  } else {
    return buffer.error('Decoding of string type: ' + tag + ' unsupported');
  }
};

DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
  var result;
  var identifiers = [];
  var ident = 0;
  while (!buffer.isEmpty()) {
    var subident = buffer.readUInt8();
    ident <<= 7;
    ident |= subident & 0x7f;
    if ((subident & 0x80) === 0) {
      identifiers.push(ident);
      ident = 0;
    }
  }
  if (subident & 0x80)
    identifiers.push(ident);

  var first = (identifiers[0] / 40) | 0;
  var second = identifiers[0] % 40;

  if (relative)
    result = identifiers;
  else
    result = [first, second].concat(identifiers.slice(1));

  if (values) {
    var tmp = values[result.join(' ')];
    if (tmp === undefined)
      tmp = values[result.join('.')];
    if (tmp !== undefined)
      result = tmp;
  }

  return result;
};

DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
  var str = buffer.raw().toString();
  if (tag === 'gentime') {
    var year = str.slice(0, 4) | 0;
    var mon = str.slice(4, 6) | 0;
    var day = str.slice(6, 8) | 0;
    var hour = str.slice(8, 10) | 0;
    var min = str.slice(10, 12) | 0;
    var sec = str.slice(12, 14) | 0;
  } else if (tag === 'utctime') {
    var year = str.slice(0, 2) | 0;
    var mon = str.slice(2, 4) | 0;
    var day = str.slice(4, 6) | 0;
    var hour = str.slice(6, 8) | 0;
    var min = str.slice(8, 10) | 0;
    var sec = str.slice(10, 12) | 0;
    if (year < 70)
      year = 2000 + year;
    else
      year = 1900 + year;
  } else {
    return buffer.error('Decoding ' + tag + ' time is not supported yet');
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};

DERNode.prototype._decodeNull = function decodeNull(buffer) {
  return null;
};

DERNode.prototype._decodeBool = function decodeBool(buffer) {
  var res = buffer.readUInt8();
  if (buffer.isError(res))
    return res;
  else
    return res !== 0;
};

DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
  // Bigint, return as it is (assume big endian)
  var raw = buffer.raw();
  var res = new bignum(raw);

  if (values)
    res = values[res.toString(10)] || res;

  return res;
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getDecoder('der').tree;
};

// Utility methods

function derDecodeTag(buf, fail) {
  var tag = buf.readUInt8(fail);
  if (buf.isError(tag))
    return tag;

  var cls = der.tagClass[tag >> 6];
  var primitive = (tag & 0x20) === 0;

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    var oct = tag;
    tag = 0;
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail);
      if (buf.isError(oct))
        return oct;

      tag <<= 7;
      tag |= oct & 0x7f;
    }
  } else {
    tag &= 0x1f;
  }
  var tagStr = der.tag[tag];

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  };
}

function derDecodeLen(buf, primitive, fail) {
  var len = buf.readUInt8(fail);
  if (buf.isError(len))
    return len;

  // Indefinite form
  if (!primitive && len === 0x80)
    return null;

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len;
  }

  // Long form
  var num = len & 0x7f;
  if (num > 4)
    return buf.error('length octect is too long');

  len = 0;
  for (var i = 0; i < num; i++) {
    len <<= 8;
    var j = buf.readUInt8(fail);
    if (buf.isError(j))
      return j;
    len |= j;
  }

  return len;
}


/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(41);
var Buffer = __webpack_require__(75).Buffer;

var asn1 = __webpack_require__(310);
var base = asn1.base;

// Import DER constants
var der = asn1.constants.der;

function DEREncoder(entity) {
  this.enc = 'der';
  this.name = entity.name;
  this.entity = entity;

  // Construct base tree
  this.tree = new DERNode();
  this.tree._init(entity.body);
};
module.exports = DEREncoder;

DEREncoder.prototype.encode = function encode(data, reporter) {
  return this.tree._encode(data, reporter).join();
};

// Tree methods

function DERNode(parent) {
  base.Node.call(this, 'der', parent);
}
inherits(DERNode, base.Node);

DERNode.prototype._encodeComposite = function encodeComposite(tag,
                                                              primitive,
                                                              cls,
                                                              content) {
  var encodedTag = encodeTag(tag, primitive, cls, this.reporter);

  // Short form
  if (content.length < 0x80) {
    var header = new Buffer(2);
    header[0] = encodedTag;
    header[1] = content.length;
    return this._createEncoderBuffer([ header, content ]);
  }

  // Long form
  // Count octets required to store length
  var lenOctets = 1;
  for (var i = content.length; i >= 0x100; i >>= 8)
    lenOctets++;

  var header = new Buffer(1 + 1 + lenOctets);
  header[0] = encodedTag;
  header[1] = 0x80 | lenOctets;

  for (var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)
    header[i] = j & 0xff;

  return this._createEncoderBuffer([ header, content ]);
};

DERNode.prototype._encodeStr = function encodeStr(str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([ str.unused | 0, str.data ]);
  } else if (tag === 'bmpstr') {
    var buf = new Buffer(str.length * 2);
    for (var i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2);
    }
    return this._createEncoderBuffer(buf);
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports ' +
                                 'only digits and space');
    }
    return this._createEncoderBuffer(str);
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports ' +
                                 'only latin upper and lower case letters, ' +
                                 'digits, space, apostrophe, left and rigth ' +
                                 'parenthesis, plus sign, comma, hyphen, ' +
                                 'dot, slash, colon, equal sign, ' +
                                 'question mark');
    }
    return this._createEncoderBuffer(str);
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str);
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str);
  } else {
    return this.reporter.error('Encoding of string type: ' + tag +
                               ' unsupported');
  }
};

DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
  if (typeof id === 'string') {
    if (!values)
      return this.reporter.error('string objid given, but no values map found');
    if (!values.hasOwnProperty(id))
      return this.reporter.error('objid not found in values map');
    id = values[id].split(/[\s\.]+/g);
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  } else if (Array.isArray(id)) {
    id = id.slice();
    for (var i = 0; i < id.length; i++)
      id[i] |= 0;
  }

  if (!Array.isArray(id)) {
    return this.reporter.error('objid() should be either array or string, ' +
                               'got: ' + JSON.stringify(id));
  }

  if (!relative) {
    if (id[1] >= 40)
      return this.reporter.error('Second objid identifier OOB');
    id.splice(0, 2, id[0] * 40 + id[1]);
  }

  // Count number of octets
  var size = 0;
  for (var i = 0; i < id.length; i++) {
    var ident = id[i];
    for (size++; ident >= 0x80; ident >>= 7)
      size++;
  }

  var objid = new Buffer(size);
  var offset = objid.length - 1;
  for (var i = id.length - 1; i >= 0; i--) {
    var ident = id[i];
    objid[offset--] = ident & 0x7f;
    while ((ident >>= 7) > 0)
      objid[offset--] = 0x80 | (ident & 0x7f);
  }

  return this._createEncoderBuffer(objid);
};

function two(num) {
  if (num < 10)
    return '0' + num;
  else
    return num;
}

DERNode.prototype._encodeTime = function encodeTime(time, tag) {
  var str;
  var date = new Date(time);

  if (tag === 'gentime') {
    str = [
      two(date.getFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else if (tag === 'utctime') {
    str = [
      two(date.getFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('');
  } else {
    this.reporter.error('Encoding ' + tag + ' time is not supported yet');
  }

  return this._encodeStr(str, 'octstr');
};

DERNode.prototype._encodeNull = function encodeNull() {
  return this._createEncoderBuffer('');
};

DERNode.prototype._encodeInt = function encodeInt(num, values) {
  if (typeof num === 'string') {
    if (!values)
      return this.reporter.error('String int or enum given, but no values map');
    if (!values.hasOwnProperty(num)) {
      return this.reporter.error('Values map doesn\'t contain: ' +
                                 JSON.stringify(num));
    }
    num = values[num];
  }

  // Bignum, assume big endian
  if (typeof num !== 'number' && !Buffer.isBuffer(num)) {
    var numArray = num.toArray();
    if (!num.sign && numArray[0] & 0x80) {
      numArray.unshift(0);
    }
    num = new Buffer(numArray);
  }

  if (Buffer.isBuffer(num)) {
    var size = num.length;
    if (num.length === 0)
      size++;

    var out = new Buffer(size);
    num.copy(out);
    if (num.length === 0)
      out[0] = 0
    return this._createEncoderBuffer(out);
  }

  if (num < 0x80)
    return this._createEncoderBuffer(num);

  if (num < 0x100)
    return this._createEncoderBuffer([0, num]);

  var size = 1;
  for (var i = num; i >= 0x100; i >>= 8)
    size++;

  var out = new Array(size);
  for (var i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff;
    num >>= 8;
  }
  if(out[0] & 0x80) {
    out.unshift(0);
  }

  return this._createEncoderBuffer(new Buffer(out));
};

DERNode.prototype._encodeBool = function encodeBool(value) {
  return this._createEncoderBuffer(value ? 0xff : 0);
};

DERNode.prototype._use = function use(entity, obj) {
  if (typeof entity === 'function')
    entity = entity(obj);
  return entity._getEncoder('der').tree;
};

DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
  var state = this._baseState;
  var i;
  if (state['default'] === null)
    return false;

  var data = dataBuffer.join();
  if (state.defaultBuffer === undefined)
    state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();

  if (data.length !== state.defaultBuffer.length)
    return false;

  for (i=0; i < data.length; i++)
    if (data[i] !== state.defaultBuffer[i])
      return false;

  return true;
};

// Utility methods

function encodeTag(tag, primitive, cls, reporter) {
  var res;

  if (tag === 'seqof')
    tag = 'seq';
  else if (tag === 'setof')
    tag = 'set';

  if (der.tagByName.hasOwnProperty(tag))
    res = der.tagByName[tag];
  else if (typeof tag === 'number' && (tag | 0) === tag)
    res = tag;
  else
    return reporter.error('Unknown tag: ' + tag);

  if (res >= 0x1f)
    return reporter.error('Multi-octet tag encoding unsupported');

  if (!primitive)
    res |= 0x20;

  res |= (der.tagClassByName[cls || 'universal'] << 6);

  return res;
}


/***/ }),
/* 979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(115);
var settle = __webpack_require__(2067);
var cookies = __webpack_require__(2070);
var buildURL = __webpack_require__(986);
var buildFullPath = __webpack_require__(2064);
var parseHeaders = __webpack_require__(2075);
var isURLSameOrigin = __webpack_require__(2073);
var createError = __webpack_require__(982);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(2066);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(115);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy', 'params'];
  var defaultToConfig2Keys = [
    'baseURL', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'timeoutMessage', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress', 'decompress',
    'maxContentLength', 'maxBodyLength', 'maxRedirects', 'transport', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath', 'responseEncoding'
  ];
  var directMergeKeys = ['validateStatus'];

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  }

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, mergeDeepProperties);

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      config[prop] = getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  utils.forEach(directMergeKeys, function merge(prop) {
    if (prop in config2) {
      config[prop] = getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      config[prop] = getMergedValue(undefined, config1[prop]);
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys)
    .concat(directMergeKeys);

  var otherKeys = Object
    .keys(config1)
    .concat(Object.keys(config2))
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, mergeDeepProperties);

  return config;
};


/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(115);
var normalizeHeaderName = __webpack_require__(2074);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(979);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(979);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ }),
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(115);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAffiliateMappings = fetchAffiliateMappings;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function affiliateMappingsRequest() {
  return {
    type: _actions.AFFILIATE_MAPPINGS_REQUEST
  };
}

function affiliateMappingsSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.AFFILIATE_MAPPINGS_SUCCESS,
    payload: {
      data: data,
      token: token
    }
  };
}

function affiliateMappingsError(message) {
  return {
    type: _actions.AFFILIATE_MAPPINGS_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchAffiliateMappings() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(affiliateMappingsRequest());
    if (!fresh) {
      var affiliateMappingsData = {};
      try {
        affiliateMappingsData = JSON.parse((0, _storage.getItem)(_config2.default.get('appName') + '.affiliateMappings')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!affiliateMappingsData.data || _config2.default.get('version') !== affiliateMappingsData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(affiliateMappingsData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(affiliateMappingsSuccess(affiliateMappingsData.data));
        return Promise.resolve();
      }
    }
    var q = Object.assign({
      limit: 0
    });
    return dispatch((0, _fetchM.fetchM)('/mappings/affiliates/?' + _qs2.default.stringify(q), {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        (0, _storage.setItem)(_config2.default.get('appName') + '.affiliateMappings', JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(affiliateMappingsSuccess(data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, affiliateMappingsError));
    });
  };
}

/***/ }),
/* 988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchBankCaseStates = fetchBankCaseStates;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bankCaseStatesRequest() {
  return {
    type: _actions.BANK_CASE_STATES_REQUEST
  };
}

function bankCaseStatesSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.BANK_CASE_STATES_SUCCESS,
    payload: {
      data: data,
      token: token
    }
  };
}

function bankCaseStatesError(message) {
  return {
    type: _actions.BANK_CASE_STATES_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchBankCaseStates() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(bankCaseStatesRequest());
    if (!fresh) {
      var bankCaseStatesData = {};
      try {
        bankCaseStatesData = JSON.parse(localStorage.getItem(_config2.default.get('appName') + '.bankCaseStates')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!bankCaseStatesData.data || _config2.default.get('version') !== bankCaseStatesData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(bankCaseStatesData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(bankCaseStatesSuccess(bankCaseStatesData.data));
        return Promise.resolve();
      }
    }
    return dispatch((0, _fetchM.fetchM)(_config2.default.get('apiURL') + '/bank_case_states/', {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        localStorage.setItem(_config2.default.get('appName') + '.bankCaseStates', JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(bankCaseStatesSuccess(data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, bankCaseStatesError));
    });
  };
}

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchBobForms = fetchBobForms;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bobFormRequest() {
  return {
    type: _actions.BOB_FORMS_REQUEST
  };
}

function bobFormSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.BOB_FORMS_SUCCESS,
    payload: {
      data: data,
      token: token
    }
  };
}

function bobFormError(message) {
  return {
    type: _actions.BOB_FORMS_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchBobForms() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(bobFormRequest());
    if (!fresh) {
      var bobFormData = {};
      try {
        bobFormData = JSON.parse((0, _storage.getItem)(_config2.default.get('appName') + '.bobForms')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!bobFormData.data || _config2.default.get('version') !== bobFormData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(bobFormData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(bobFormSuccess(bobFormData.data));
        return Promise.resolve();
      }
    }
    return dispatch((0, _fetchM.fetchM)('/bob/forms/', {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (d) {
      var data = [];
      if (d) data = d;
      try {
        (0, _storage.setItem)(_config2.default.get('appName') + '.bobForms', JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(bobFormSuccess(data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, bobFormError));
    });
  };
}

/***/ }),
/* 990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearBookQuery = clearBookQuery;
exports.extractBookQuery = extractBookQuery;

var _jsCookie = __webpack_require__(247);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function bookQuerySuccess(data) {
  return {
    type: _actions.BOOK_QUERY_SUCCESS,
    payload: {
      data: data
    }
  };
}

function clearBookQuery() {
  var _this = this;

  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              // clear in cookie
              _jsCookie2.default.remove('mhub-book-web-book-queries');
              // clear in state
              _context.next = 3;
              return dispatch(bookQuerySuccess([]));

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}

function extractBookQuery(props) {
  return function (dispatch) {
    var queries = [];
    // extract from cookie
    var cQueries = _jsCookie2.default.getJSON('mhub-book-web-book-queries');
    if (cQueries) {
      cQueries.forEach(function (cq) {
        if (!queries.find(function (q) {
          return q.name === cq.name;
        })) {
          queries.push(cq);
        }
      });
    }
    // extract from URL query
    if (props.location && props.location.query) {
      var query = props.location.query;

      Object.keys(query).forEach(function (q) {
        if (q.startsWith('book_')) {
          var eIndex = queries.findIndex(function (dq) {
            return dq.name === q;
          });
          if (eIndex > -1) {
            // replace new query value
            queries[eIndex].value = query[q];
          } else {
            // add new query
            queries.push({
              name: q,
              value: query[q]
            });
          }
        }
      });
    }
    // save to cookie
    _jsCookie2.default.set('mhub-book-web-book-queries', queries, { expires: 1 });
    // save to state
    dispatch(bookQuerySuccess(queries));
  };
}

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchCancellationReasons = fetchCancellationReasons;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cancellationReasonsRequest() {
  return {
    type: _actions.CANCELLATION_REASONS_REQUEST
  };
}

function cancellationReasonsSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.CANCELLATION_REASONS_SUCCESS,
    payload: {
      data: data,
      token: token
    }
  };
}

function cancellationReasonsError(message) {
  return {
    type: _actions.CANCELLATION_REASONS_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchCancellationReasons() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(cancellationReasonsRequest());
    if (!fresh) {
      var cancellationReasonsData = {};
      try {
        cancellationReasonsData = JSON.parse((0, _storage.getItem)(_config2.default.get('appName') + '.cancellationReasons')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!cancellationReasonsData.data || _config2.default.get('version') !== cancellationReasonsData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(cancellationReasonsData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(cancellationReasonsSuccess(cancellationReasonsData.data));
        return Promise.resolve();
      }
    }
    var q = Object.assign({
      limit: 0
    });
    return dispatch((0, _fetchM.fetchM)('/cancellation_reasons/?' + _qs2.default.stringify(q), {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        (0, _storage.setItem)(_config2.default.get('appName') + '.cancellationReasons', JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(cancellationReasonsSuccess(data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, cancellationReasonsError));
    });
  };
}

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchFinanceSources = fetchFinanceSources;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function financeSourcesRequest() {
  return {
    type: _actions.FINANCE_SOURCES_REQUEST
  };
}

function financeSourcesSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.FINANCE_SOURCES_SUCCESS,
    payload: {
      data: data || [],
      token: token
    }
  };
}

function financeSourcesError(message) {
  return {
    type: _actions.FINANCE_SOURCES_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchFinanceSources() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(financeSourcesRequest());
    if (!fresh) {
      var financeSourcesData = {};
      try {
        financeSourcesData = JSON.parse((0, _storage.getItem)(_config2.default.get('appName') + '.financeSources')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!financeSourcesData.data || _config2.default.get('version') !== financeSourcesData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(financeSourcesData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(financeSourcesSuccess(financeSourcesData.data));
        return Promise.resolve();
      }
    }
    return dispatch((0, _fetchM.fetchM)('/finance_sources/', {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        (0, _storage.setItem)(_config2.default.get('appName') + '.financeSources', JSON.stringify({
          data: data || [],
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(financeSourcesSuccess(data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, financeSourcesError));
    });
  };
}

/***/ }),
/* 993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchGlobalSettings = fetchGlobalSettings;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function globalSettingsRequest() {
  return {
    type: _actions.GLOBAL_SETTINGS_REQUEST
  };
}

function globalSettingsSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.GLOBAL_SETTINGS_SUCCESS,
    payload: {
      data: data,
      token: token
    }
  };
}

function globalSettingsError(message) {
  return {
    type: _actions.GLOBAL_SETTINGS_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchGlobalSettings() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(globalSettingsRequest());
    if (!fresh) {
      var globalSettingsData = {};
      try {
        globalSettingsData = JSON.parse((0, _storage.getItem)(_config2.default.get('appName') + '.globalSettings')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!globalSettingsData.data || _config2.default.get('version') !== globalSettingsData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(globalSettingsData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(globalSettingsSuccess(globalSettingsData.data));
        return Promise.resolve();
      }
    }
    return dispatch((0, _fetchM.fetchM)('/settings/', {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        (0, _storage.setItem)(_config2.default.get('appName') + '.globalSettings', JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(globalSettingsSuccess(data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, globalSettingsError));
    });
  };
}

/***/ }),
/* 994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchHimsPostcodes = fetchHimsPostcodes;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function himsPostcodesRequest() {
  return {
    type: _actions.HIMS_POSTCODES_REQUEST
  };
}

function himsPostcodesSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.HIMS_POSTCODES_SUCCESS,
    payload: {
      data: data,
      token: token
    }
  };
}

function himsPostcodesError(message) {
  return {
    type: _actions.HIMS_POSTCODES_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchHimsPostcodes() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    var himsPostcodesData = {};
    dispatch(himsPostcodesRequest());
    if (!fresh) {
      try {
        himsPostcodesData = JSON.parse(localStorage.getItem(_config2.default.get('appName') + '.himsPostcodes')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!himsPostcodesData.data || _config2.default.get('version') !== himsPostcodesData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(himsPostcodesData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(himsPostcodesSuccess(himsPostcodesData.data));
        return Promise.resolve();
      }
    }
    return dispatch((0, _fetchM.fetchM)('/hims/postcodes/', {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        localStorage.setItem(_config2.default.get('appName') + '.himsPostcodes', JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(himsPostcodesSuccess(data, token));
    }).catch(function (err) {
      // reuse data from localStorage in case of error
      if (himsPostcodesData.data) {
        dispatch(himsPostcodesSuccess(himsPostcodesData.data));
        return Promise.resolve();
      }
      dispatch((0, _error.handleError)(err, himsPostcodesError));
      return Promise.reject(err);
    });
  };
}

/***/ }),
/* 995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchIdentityPresets = fetchIdentityPresets;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function identityPresetsRequest() {
  return {
    type: _actions.IDENTITY_PRESETS_REQUEST
  };
}

function identityPresetsSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.IDENTITY_PRESETS_SUCCESS,
    payload: {
      data: data || [],
      token: token
    }
  };
}

function identityPresetsError(message) {
  return {
    type: _actions.IDENTITY_PRESETS_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchIdentityPresets() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(identityPresetsRequest());
    if (!fresh) {
      var identityPresetsData = {};
      try {
        identityPresetsData = JSON.parse((0, _storage.getItem)(_config2.default.get('appName') + '.identityPresets')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!identityPresetsData.data || _config2.default.get('version') !== identityPresetsData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(identityPresetsData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(identityPresetsSuccess(identityPresetsData.data));
        return Promise.resolve();
      }
    }
    return dispatch((0, _fetchM.fetchM)('/identity_presets/', {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        (0, _storage.setItem)(_config2.default.get('appName') + '.identityPresets', JSON.stringify({
          data: data || [],
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(identityPresetsSuccess(data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, identityPresetsError));
    });
  };
}

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchPhoneValidationPresets = fetchPhoneValidationPresets;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function phoneValidationPresetsRequest() {
  return {
    type: _actions.PHONE_VALIDATION_PRESETS_REQUEST
  };
}

function phoneValidationPresetsSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.PHONE_VALIDATION_PRESETS_SUCCESS,
    payload: {
      data: data || [],
      token: token
    }
  };
}

function phoneValidationPresetsError(message) {
  return {
    type: _actions.PHONE_VALIDATION_PRESETS_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchPhoneValidationPresets() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(phoneValidationPresetsRequest());
    if (!fresh) {
      var phoneValidationPresetsData = {};
      try {
        phoneValidationPresetsData = JSON.parse((0, _storage.getItem)(_config2.default.get('appName') + '.phoneValidationPresets')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!phoneValidationPresetsData.data || _config2.default.get('version') !== phoneValidationPresetsData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(phoneValidationPresetsData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(phoneValidationPresetsSuccess(phoneValidationPresetsData.data));
        return Promise.resolve();
      }
    }
    return dispatch((0, _fetchM.fetchM)('/phone_validation_presets/', {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        (0, _storage.setItem)(_config2.default.get('appName') + '.phoneValidationPresets', JSON.stringify({
          data: data || [],
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(phoneValidationPresetsSuccess(data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, phoneValidationPresetsError));
    });
  };
}

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchProjectMappings = fetchProjectMappings;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function projectMappingsRequest() {
  return {
    type: _actions.PROJECT_MAPPINGS_REQUEST
  };
}

function projectMappingsSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.PROJECT_MAPPINGS_SUCCESS,
    payload: {
      data: data,
      token: token
    }
  };
}

function projectMappingsError(message) {
  return {
    type: _actions.PROJECT_MAPPINGS_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchProjectMappings() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(projectMappingsRequest());
    if (!fresh) {
      var projectMappingsData = {};
      try {
        projectMappingsData = JSON.parse((0, _storage.getItem)(_config2.default.get('appName') + '.projectMappings')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!projectMappingsData.data || _config2.default.get('version') !== projectMappingsData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(projectMappingsData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(projectMappingsSuccess(projectMappingsData.data));
        return Promise.resolve();
      }
    }
    var q = Object.assign({
      limit: 0
    });
    return dispatch((0, _fetchM.fetchM)('/mappings/projects/?' + _qs2.default.stringify(q), {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        (0, _storage.setItem)(_config2.default.get('appName') + '.projectMappings', JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(projectMappingsSuccess(data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, projectMappingsError));
    });
  };
}

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchProjectOptions = fetchProjectOptions;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function projectOptionsRequest() {
  return {
    type: _actions.PROJECT_OPTIONS_REQUEST
  };
}

function projectOptionsSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.PROJECT_OPTIONS_SUCCESS,
    payload: {
      data: data,
      token: token
    }
  };
}

function projectOptionsError(message) {
  return {
    type: _actions.PROJECT_OPTIONS_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchProjectOptions() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(projectOptionsRequest());
    if (!fresh) {
      var projectOptionsData = {};
      try {
        projectOptionsData = JSON.parse((0, _storage.getItem)(_config2.default.get('appName') + '.projectOptions')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!projectOptionsData.data || _config2.default.get('version') !== projectOptionsData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(projectOptionsData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(projectOptionsSuccess(projectOptionsData.data));
        return Promise.resolve();
      }
    }
    var q = Object.assign({
      limit: 0
    });
    return dispatch((0, _fetchM.fetchM)('/specifications/options/?' + _qs2.default.stringify(q), {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        (0, _storage.setItem)(_config2.default.get('appName') + '.projectOptions', JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(projectOptionsSuccess(data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, projectOptionsError));
    });
  };
}

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchProjectSpecifications = fetchProjectSpecifications;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function projectSpecificationsRequest() {
  return {
    type: _actions.PROJECT_SPECIFICATIONS_REQUEST
  };
}

function projectSpecificationsSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.PROJECT_SPECIFICATIONS_SUCCESS,
    payload: {
      data: data,
      token: token
    }
  };
}

function projectSpecificationsError(message) {
  return {
    type: _actions.PROJECT_SPECIFICATIONS_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchProjectSpecifications() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(projectSpecificationsRequest());
    if (!fresh) {
      var projectSpecificationsData = {};
      try {
        projectSpecificationsData = JSON.parse((0, _storage.getItem)(_config2.default.get('appName') + '.projectSpecifications')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!projectSpecificationsData.data || _config2.default.get('version') !== projectSpecificationsData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(projectSpecificationsData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(projectSpecificationsSuccess(projectSpecificationsData.data));
        return Promise.resolve();
      }
    }
    var q = Object.assign({
      limit: 0
    });
    return dispatch((0, _fetchM.fetchM)('/specifications/projects/?' + _qs2.default.stringify(q), {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        (0, _storage.setItem)(_config2.default.get('appName') + '.projectSpecifications', JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(projectSpecificationsSuccess(data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, projectSpecificationsError));
    });
  };
}

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchProjectUnitLayoutSpecifications = fetchProjectUnitLayoutSpecifications;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function projectUnitLayoutSpecificationsRequest() {
  return {
    type: _actions.PROJECT_UNIT_LAYOUT_SPECIFICATIONS_REQUEST
  };
}

function projectUnitLayoutSpecificationsSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.PROJECT_UNIT_LAYOUT_SPECIFICATIONS_SUCCESS,
    payload: {
      data: data,
      token: token
    }
  };
}

function projectUnitLayoutSpecificationsError(message) {
  return {
    type: _actions.PROJECT_UNIT_LAYOUT_SPECIFICATIONS_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchProjectUnitLayoutSpecifications() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(projectUnitLayoutSpecificationsRequest());
    if (!fresh) {
      var projectUnitLayoutSpecificationsData = {};
      try {
        projectUnitLayoutSpecificationsData = JSON.parse((0, _storage.getItem)(_config2.default.get('appName') + '.projectUnitLayoutSpecifications')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!projectUnitLayoutSpecificationsData.data || _config2.default.get('version') !== projectUnitLayoutSpecificationsData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(projectUnitLayoutSpecificationsData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(projectUnitLayoutSpecificationsSuccess(projectUnitLayoutSpecificationsData.data));
        return Promise.resolve();
      }
    }
    var q = Object.assign({
      limit: 0
    });
    return dispatch((0, _fetchM.fetchM)('/specifications/unit_layouts/?' + _qs2.default.stringify(q), {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        (0, _storage.setItem)(_config2.default.get('appName') + '.projectUnitLayoutSpecifications', JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(projectUnitLayoutSpecificationsSuccess(data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, projectUnitLayoutSpecificationsError));
    });
  };
}

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchSalesChartTypes = fetchSalesChartTypes;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function salesChartTypesRequest() {
  return {
    type: _actions.SALES_CHART_TYPES_REQUEST
  };
}

function salesChartTypesSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.SALES_CHART_TYPES_SUCCESS,
    payload: {
      data: data,
      token: token
    }
  };
}

function salesChartTypesError(message) {
  return {
    type: _actions.SALES_CHART_TYPES_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchSalesChartTypes() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(salesChartTypesRequest());
    if (!fresh) {
      var salesChartTypesData = {};
      try {
        salesChartTypesData = JSON.parse((0, _storage.getItem)(_config2.default.get('appName') + '.salesChartTypes')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!salesChartTypesData.data || _config2.default.get('version') !== salesChartTypesData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(salesChartTypesData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(salesChartTypesSuccess(salesChartTypesData.data));
        return Promise.resolve();
      }
    }
    var q = Object.assign({
      limit: 0
    });
    return dispatch((0, _fetchM.fetchM)('/sales_chart_types/?' + _qs2.default.stringify(q), {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        (0, _storage.setItem)(_config2.default.get('appName') + '.salesChartTypes', JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(salesChartTypesSuccess(data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, salesChartTypesError));
    });
  };
}

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _json = __webpack_require__(268);

var _translation = __webpack_require__(4);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


// Still needed for the module-level locale; the feed date renders through Timestamp.
_momentTimezone2.default.locale('en-gb');

var AddressSettingActivities = function (_Component) {
  _inherits(AddressSettingActivities, _Component);

  function AddressSettingActivities() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddressSettingActivities);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddressSettingActivities.__proto__ || Object.getPrototypeOf(AddressSettingActivities)).call.apply(_ref, [this].concat(args))), _this), _this.keyToColumnName = function (key) {
      var t = _this.props.t;

      switch (key) {
        case 'format':
          return '';
        default:
          {
            // translate address fields
            var name = _lodash2.default.startCase(key).split(' ').splice(0, 2).join(' ');
            name = name.split(' ');
            name = t(name[0]).concat(' ', name[1]);
            return name;
          }
      }
    }, _this.keyToName = function (key) {
      var t = _this.props.t;

      switch (key) {
        case 'format':
          return t('Address format template');
        default:
          return _lodash2.default.startCase(key).split(' ')[2];
      }
    }, _this.renderActivityMessage = function (activity) {
      var activityBefore = (0, _json.parseJSON)(activity.before);
      var activityAfter = (0, _json.parseJSON)(activity.after);
      var afterKeys = Object.keys(activityAfter);
      var changes = [];
      afterKeys.forEach(function (element) {
        var columnName = _this.keyToColumnName(element);
        var keyName = _this.keyToName(element);
        var message = void 0;
        var after = '';
        var before = activityBefore[element];
        if (activity.before) {
          after = activityAfter[element];
        }
        if (before === after) {
          return;
        }
        switch (keyName) {
          case 'Required':
            message = _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                columnName,
                ' '
              ),
              _react2.default.createElement(
                _reactI18next.Trans,
                { ns: _translation.TRANSLATION_FILES.screens, components: { underline: _react2.default.createElement('u', null) } },
                'is set as ',
                _react2.default.createElement(
                  'u',
                  null,
                  after ? 'required' : 'optional'
                ),
                ' field'
              )
            );
            break;
          case 'Enabled':
            message = _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                columnName,
                ' '
              ),
              _react2.default.createElement(
                _reactI18next.Trans,
                { ns: _translation.TRANSLATION_FILES.screens, components: { underline: _react2.default.createElement('u', null) } },
                'is ',
                _react2.default.createElement(
                  'u',
                  null,
                  after ? 'enabled' : 'disabled'
                )
              )
            );
            break;
          default:
            break;
        }
        switch (element) {
          case 'format':
            if (!before) message = _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                keyName
              ),
              ': ',
              _react2.default.createElement(
                'u',
                null,
                after
              )
            );
            break;
          default:
            break;
        }
        if (message) {
          changes.push(message);
        } else if (before || after) {
          if (before === false && after) {
            message = _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation.TRANSLATION_FILES.screens },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  { style: { color: '#666' } },
                  columnName && _react2.default.createElement(
                    'span',
                    null,
                    { columnName: columnName },
                    '\'s '
                  ),
                  { keyName: keyName }
                ),
                ' has been added'
              )
            );
          } else if (!before) {
            message = _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                columnName ? columnName + '\'s ' : '',
                keyName
              ),
              ': ',
              _react2.default.createElement(
                'u',
                null,
                after
              )
            );
          } else if (before && !after) {
            message = _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation.TRANSLATION_FILES.screens },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  { style: { color: '#666' } },
                  columnName && _react2.default.createElement(
                    'span',
                    null,
                    { columnName: columnName },
                    '\'s '
                  ),
                  { keyName: keyName }
                ),
                ' has been removed'
              )
            );
          } else {
            message = _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation.TRANSLATION_FILES.screens },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  { style: { color: '#666' } },
                  columnName && _react2.default.createElement(
                    'span',
                    null,
                    { columnName: columnName },
                    '\'s '
                  ),
                  { keyName: keyName }
                ),
                ' changed from ',
                _react2.default.createElement(
                  'u',
                  null,
                  { before: before }
                ),
                ' to ',
                _react2.default.createElement(
                  'u',
                  null,
                  { after: after }
                )
              )
            );
          }
          changes.push(message);
        }
      });
      return _react2.default.createElement(
        _semanticUiReact.List,
        { bulleted: true },
        changes.map(function (element, id) {
          return _react2.default.createElement(
            _semanticUiReact.List.Item,
            { key: id },
            element
          );
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddressSettingActivities, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          data = _props.data,
          t = _props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(
              _semanticUiReact.Feed,
              null,
              data && data.length > 0 ? data.map(function (activity, idx) {
                return _react2.default.createElement(
                  _semanticUiReact.Feed.Event,
                  { key: idx, className: 'activity-logs' },
                  _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: 'user' }),
                  _react2.default.createElement(
                    _semanticUiReact.Feed.Content,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Date,
                      null,
                      _react2.default.createElement(_Timestamp2.default, { timestamp: activity.createdAt, format: 'MMMM Do YYYY, h:mm:ss a' })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Summary,
                      null,
                      _this2.props.hasAccess ? activity.userAffiliateID > 0 ? _react2.default.createElement(
                        _reactRouter.Link,
                        { to: '/users/' + activity.userAffiliateID + '/' },
                        activity.userPreferredName || t('Unknown')
                      ) : '' : activity.userPreferredName,
                      ' ' + t(activity.message)
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Extra,
                      { text: true },
                      activity.after && _this2.renderActivityMessage(activity)
                    )
                  )
                );
              }) : this.props.loading ? _react2.default.createElement('br', null) : _react2.default.createElement(
                'center',
                null,
                t('No activity found'),
                '.'
              )
            )
          )
        )
      );
    }
  }]);

  return AddressSettingActivities;
}(_react.Component);

AddressSettingActivities.propTypes = {
  data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  hasAccess: _propTypes2.default.bool.isRequired,
  loading: _propTypes2.default.bool.isRequired,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(AddressSettingActivities);

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _Validate = __webpack_require__(219);

var _Validate2 = _interopRequireDefault(_Validate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Input = function (_Component) {
  _inherits(Input, _Component);

  function Input(props) {
    _classCallCheck(this, Input);

    var _this = _possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

    _this.addThousandSeparator = function (value) {
      // remove any existing commas/ alphabets from the input
      var sanitizedValue = value ? value.replace(/[^\d.]/g, '') : '';
      // split the cents
      var splitValue = sanitizedValue.split('.');
      var amount = splitValue[0];
      var cents = splitValue[1] || '';
      if (cents.length > 2) {
        cents = cents.substring(0, 2);
      }
      // format the amount with commas
      var formattedValue = amount ? parseFloat(amount).toLocaleString() : '';

      // then combine the amount with the cents
      _this.setState({
        formattedValue: value.includes('.') ? formattedValue + '.' + cents : formattedValue
      });
      // return value without commas
      return amount && value.includes('.') ? amount + '.' + cents : amount;
    };

    _this.handleOnChange = function (e, data) {
      if (_this.props.showThousandSeparator) {
        data.value = _this.addThousandSeparator(data.value);
      }
      // bubble up onChange
      if (_this.props.onChange) {
        _this.props.onChange(e, data);
      }
    };

    if (_this.props.showThousandSeparator) {
      var formattedValue = _this.addThousandSeparator(props.value);
      _this.state = {
        formattedValue: formattedValue
      };
    }
    return _this;
  }

  _createClass(Input, [{
    key: 'render',
    value: function render() {
      var type = this.props.showThousandSeparator ? 'text' : this.props.type;
      var value = this.props.showThousandSeparator ? this.state.formattedValue : this.props.value;
      return _react2.default.createElement(
        _Validate2.default,
        {
          hideMessage: this.props.hideMessage,
          message: this.props.message,
          showThousandSeparator: this.props.showThousandSeparator,
          validation: this.props.validation,
          label: this.props.validateLabel || this.props.label,
          name: this.props.validateName || this.props.name,
          ref: this.props.validateRef,
          onChange: this.handleOnChange,
          style: this.props.style && this.props.style
        },
        _react2.default.createElement(_semanticUiReact.Form.Input, {
          autoComplete: this.props.autoComplete,
          disabled: this.props.disabled,
          fluid: true,
          label: this.props.label,
          loading: this.props.loading,
          name: this.props.name,
          placeholder: this.props.placeholder,
          readOnly: this.props.readOnly,
          type: type,
          pattern: this.props.pattern,
          value: value,
          step: this.props.step,
          min: this.props.min,
          icon: this.props.icon
        })
      );
    }
  }]);

  return Input;
}(_react.Component);

Input.propTypes = {
  autoComplete: _propTypes2.default.string,
  message: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  hideMessage: _propTypes2.default.bool,
  label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
  loading: _propTypes2.default.bool,
  min: _propTypes2.default.string,
  name: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func,
  placeholder: _propTypes2.default.string,
  readOnly: _propTypes2.default.bool,
  type: _propTypes2.default.string,
  step: _propTypes2.default.string,
  icon: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string, _propTypes2.default.node]),
  pattern: _propTypes2.default.string,
  style: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  validation: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({
    validate: _propTypes2.default.func,
    option: _propTypes2.default.object
  })]).isRequired),
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  showThousandSeparator: _propTypes2.default.bool,
  validateName: _propTypes2.default.string,
  validateLabel: _propTypes2.default.string,
  validateRef: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.shape({})])
};
Input.defaultProps = {
  step: null
};
exports.default = (0, _react.forwardRef)(function (props, ref) {
  return _react2.default.createElement(Input, _extends({}, props, { validateRef: ref }));
});

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _download = __webpack_require__(361);

var _download2 = _interopRequireDefault(_download);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getFileIcon = function getFileIcon() {
  var fileName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var ext = (fileName || '').split('.').pop().toLowerCase();
  if (ext === 'pdf') return 'file pdf outline';
  if (['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp', 'tif', 'tiff'].includes(ext)) {
    return 'file image outline';
  }
  if (['doc', 'docx', 'rtf', 'odt'].includes(ext)) return 'file word outline';
  if (['xls', 'xlsx', 'csv', 'ods'].includes(ext)) return 'file excel outline';
  if (['ppt', 'pptx'].includes(ext)) return 'file powerpoint outline';
  if (ext === 'txt') return 'file text outline';
  return 'file alternate outline';
};

var getFileIconColor = function getFileIconColor() {
  var fileName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var ext = (fileName || '').split('.').pop().toLowerCase();
  if (ext === 'pdf') return 'red';
  if (['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp', 'tif', 'tiff'].includes(ext)) return 'purple';
  if (['doc', 'docx', 'rtf', 'odt'].includes(ext)) return 'blue';
  if (['xls', 'xlsx', 'csv', 'ods'].includes(ext)) return 'green';
  if (['ppt', 'pptx'].includes(ext)) return 'orange';
  return 'grey';
};

var AttachmentItem = function AttachmentItem(_ref) {
  var fileName = _ref.fileName,
      downloadUrl = _ref.downloadUrl,
      small = _ref.small;

  var baseUrl = downloadUrl || '';
  var hasDl = baseUrl.includes('dl=true');
  var separator = baseUrl.includes('?') ? '&' : '?';
  var forceDownloadUrl = !baseUrl ? null : hasDl ? baseUrl : '' + baseUrl + separator + 'dl=true';

  var viewUrl = !baseUrl ? null : baseUrl.replace('?dl=true', '').replace('&dl=true', '');

  return _react2.default.createElement(
    'div',
    { className: 'attachment-item-row' + (small ? ' attachment-item-row--small' : '') },
    _react2.default.createElement(
      'div',
      { className: 'attachment-preview-container' },
      _react2.default.createElement(_semanticUiReact.Icon, {
        name: getFileIcon(fileName),
        size: small ? 'small' : 'large',
        color: getFileIconColor(fileName),
        style: { margin: 0, flexShrink: 0 }
      }),
      _react2.default.createElement(
        'a',
        {
          className: 'attachment-item-link',
          href: viewUrl,
          title: (fileName || 'Attachment') + ' (Preview)',
          target: '_blank',
          rel: 'noopener noreferrer'
        },
        _react2.default.createElement(
          'span',
          { className: 'doc-name' },
          fileName || 'Attachment'
        )
      )
    ),
    _react2.default.createElement(
      'a',
      {
        className: 'attachment-download-link',
        href: forceDownloadUrl,
        title: 'Download ' + (fileName || 'Attachment')
      },
      _react2.default.createElement('img', {
        src: _download2.default,
        alt: 'download',
        className: 'attachment-download-icon',
        style: { marginLeft: '4px' }
      })
    )
  );
};

AttachmentItem.propTypes = {
  fileName: _propTypes2.default.string,
  downloadUrl: _propTypes2.default.string.isRequired,
  small: _propTypes2.default.bool
};

exports.default = AttachmentItem;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BookingActivities = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _i18n = __webpack_require__(401);

var _i18n2 = _interopRequireDefault(_i18n);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _bookingStatuses = __webpack_require__(128);

var _bookingStatuses2 = _interopRequireDefault(_bookingStatuses);

var _paymentTypes = __webpack_require__(322);

var _paymentTypes2 = _interopRequireDefault(_paymentTypes);

var _paymentStatuses = __webpack_require__(321);

var _paymentStatuses2 = _interopRequireDefault(_paymentStatuses);

var _translation = __webpack_require__(4);

var _strings = __webpack_require__(118);

var _translation2 = __webpack_require__(64);

var _json = __webpack_require__(268);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _financeSource = __webpack_require__(402);

var _displayTime = __webpack_require__(156);

var _activityDateValue = __webpack_require__(2214);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


// Still needed for the module-level locale; timestamps render in the viewer's display zone.
_momentTimezone2.default.locale('en-gb');

// Also exported unwrapped so tests can drive it without the translation/connect wrappers. The
// default export below is unchanged and remains what the app renders.

var BookingActivities = exports.BookingActivities = function (_Component) {
  _inherits(BookingActivities, _Component);

  function BookingActivities(props) {
    _classCallCheck(this, BookingActivities);

    var _this = _possibleConstructorReturn(this, (BookingActivities.__proto__ || Object.getPrototypeOf(BookingActivities)).call(this, props));

    _initialiseProps.call(_this);

    var cancellationReasons = props.cancellationReasons ? [].concat(props.cancellationReasons.data) : [];
    _this.state = {
      mpUserLoading: false,
      mpUserDetails: {},
      cancellationReasons: cancellationReasons,
      currentLanguage: _i18n2.default.language
    };
    _this.validation = {};
    _this.loanBox = null;
    _this.handleLanguageChange = _this.handleLanguageChange.bind(_this);
    return _this;
  }

  _createClass(BookingActivities, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Set moment locale based on current language
      var languageMap = {
        en: 'en-gb',
        vi: 'vi',
        id: 'id'
      };
      _momentTimezone2.default.locale(languageMap[_i18n2.default.language] || 'en-gb');
      // Listen for language changes
      _i18n2.default.on('languageChanged', this.handleLanguageChange);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // Sync moment locale when language changes
      if (prevState && prevState.currentLanguage !== this.state.currentLanguage) {
        var languageMap = {
          en: 'en-gb',
          vi: 'vi',
          id: 'id'
        };
        _momentTimezone2.default.locale(languageMap[this.state.currentLanguage] || 'en-gb');
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Clean up language change listener
      _i18n2.default.off('languageChanged', this.handleLanguageChange);
    }
  }, {
    key: 'setMPUserLoading',
    value: function setMPUserLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ mpUserLoading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          data = _props.data,
          t = _props.t;
      var _state = this.state,
          mpUserLoading = _state.mpUserLoading,
          mpUserDetails = _state.mpUserDetails;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(
              _semanticUiReact.Feed,
              null,
              data && data.length > 0 ? data.map(function (activity, idx) {
                return _react2.default.createElement(
                  _semanticUiReact.Feed.Event,
                  { key: idx, className: 'activity-logs' },
                  _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: 'user' }),
                  _react2.default.createElement(
                    _semanticUiReact.Feed.Content,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Date,
                      null,
                      _react2.default.createElement(_Timestamp2.default, { timestamp: activity.createdAt, format: 'MMMM Do YYYY, h:mm:ss a' })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Summary,
                      null,
                      _this3.props.hasAccess ? activity.maUserAffiliateID > 0 ? activity.booking.origin && activity.booking.origin.includes('marketplace') ? activity.booking.origin.includes('_') ? activity.maCreatedByPreferredName : _react2.default.createElement(
                        _semanticUiReact.Popup,
                        {
                          on: 'click',
                          trigger: _react2.default.createElement(
                            'a',
                            null,
                            activity.maCreatedByPreferredName || 'Unknown'
                          ),
                          onOpen: function onOpen() {
                            _this3.fetchMarketplaceUserDetails(activity.userID);
                          },
                          size: 'mini',
                          inverted: true,
                          position: 'bottom right',
                          disabled: true,
                          flowing: true
                        },
                        mpUserLoading ? _react2.default.createElement(
                          _semanticUiReact.Loader,
                          { active: true, inline: 'centered' },
                          t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                        ) : _react2.default.createElement(
                          'span',
                          { style: { fontSize: '15px' } },
                          _react2.default.createElement(
                            'div',
                            null,
                            (0, _translation2.translateModels)(t, 'fullName', 'mpUserDetails') + ': ' + mpUserDetails.fullName
                          ),
                          _react2.default.createElement(
                            'div',
                            null,
                            (0, _translation2.translateModels)(t, 'email', 'mpUserDetails') + ': ' + mpUserDetails.email
                          ),
                          _react2.default.createElement(
                            'div',
                            null,
                            (0, _translation2.translateModels)(t, 'mobile', 'mpUserDetails') + ': ' + mpUserDetails.mobilePrefix + mpUserDetails.mobile
                          ),
                          mpUserDetails.agencyName ? _react2.default.createElement(
                            'div',
                            null,
                            (0, _translation2.translateModels)(t, 'agencyName', 'mpUserDetails') + ': ' + mpUserDetails.agencyName
                          ) : null,
                          mpUserDetails.registrationNumber ? _react2.default.createElement(
                            'div',
                            null,
                            (0, _translation2.translateModels)(t, 'registrationNumber', 'mpUserDetails') + ': ' + mpUserDetails.registrationNumber
                          ) : null
                        )
                      ) : _react2.default.createElement(
                        _reactRouter.Link,
                        { to: '/users/' + activity.maUserAffiliateID + '/' },
                        activity.maCreatedByPreferredName || t('Unknown')
                      ) : '' : activity.maCreatedByPreferredName,
                      ' ' + _this3.renderActivityTitle(activity.message),
                      _this3.props.showAll ? _react2.default.createElement(
                        'span',
                        null,
                        '\xA0',
                        t('for'),
                        '\xA0',
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { to: '/bookings/' + activity.bookingID + '/' },
                          activity.bookingCode,
                          ',\xA0',
                          activity.projectUnitReference,
                          ',\xA0',
                          activity.projectName
                        )
                      ) : ''
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Extra,
                      { text: true },
                      activity.after && _this3.renderActivityMessage(activity)
                    )
                  )
                );
              }) : this.props.loading ? _react2.default.createElement('br', null) : _react2.default.createElement(
                'center',
                null,
                t('No activity found'),
                '.'
              )
            )
          )
        )
      );
    }
  }]);

  return BookingActivities;
}(_react.Component);

BookingActivities.contextTypes = {
  store: _propTypes2.default.object
};
BookingActivities.propTypes = {
  data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  hasAccess: _propTypes2.default.bool.isRequired,
  loading: _propTypes2.default.bool.isRequired,
  showAll: _propTypes2.default.bool,
  cancellationReasons: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  addressSettings: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  financeSources: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  t: _propTypes2.default.func
};

BookingActivities.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig,
    cancellationReasons: state.cancellationReasons,
    addressSettings: state.addressSettings,
    financeSources: state.financeSources
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleLanguageChange = function () {
    _this4.setState({ currentLanguage: _i18n2.default.language });
  };

  this.getAddressLabel = function (key) {
    var addressSettings = _this4.props.addressSettings;

    var as = addressSettings.data.find(function (a) {
      return _lodash2.default.camelCase(a.columnName) === key;
    });
    if (as) {
      return as.label;
    }
    return key;
  };

  this.keyToName = function (key, isPP) {
    var t = _this4.props.t;

    if (isPP) {
      switch (key) {
        case 'description':
        case 'spaPrice':
        case 'name':
        case 'totalPrice':
        case 'bumiPurchaserOnly':
        case 'unitSellingPrice':
        case 'customName':
        case 'isCustomPrice':
          return (0, _translation2.translateModels)(t, key, 'bookingPackagePricing');
        default:
          break;
      }
    }
    switch (key) {
      case 'address1':
      case 'address2':
      case 'address3':
      case 'address4':
      case 'address5':
      case 'address6':
      case 'address7':
      case 'address8':
      case 'address9':
      case 'address10':
        return _this4.getAddressLabel(key);
      default:
        return (0, _translation2.translateModels)(t, key, 'booking', (0, _strings.camelToTitle)(key));
    }
  };

  this.fetchMarketplaceUserDetails = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(userID) {
      var store, t, url, response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store = _this4.context.store;
              t = _this4.props.t;
              url = '/marketplace/staffs/' + userID + '/';
              _context.prev = 3;
              _context.next = 6;
              return _this4.setMPUserLoading(true);

            case 6:
              _context.next = 8;
              return (0, _fetchM.serverRequestGet)(url, store);

            case 8:
              response = _context.sent;

              if (!response.error) {
                _context.next = 13;
                break;
              }

              _context.next = 12;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: response.message }));

            case 12:
              return _context.abrupt('return');

            case 13:
              _context.next = 15;
              return _this4.setState({ mpUserDetails: response.data });

            case 15:
              _context.next = 17;
              return _this4.setMPUserLoading(false);

            case 17:
              _context.next = 26;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context['catch'](3);

              Bugsnag.notifyException(_context.t0);
              _context.next = 24;
              return _this4.setMPUserLoading(false);

            case 24:
              _context.next = 26;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

            case 26:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this4, [[3, 19]]);
    }));

    return function (_x2) {
      return _ref.apply(this, arguments);
    };
  }();

  this.renderCancellationReason = function (value) {
    var cancellationReasons = _this4.props.cancellationReasons;


    return cancellationReasons && cancellationReasons.data && cancellationReasons.data.some(function (x) {
      return x.id === value;
    }) ? cancellationReasons.data.find(function (x) {
      return x.id === value;
    }).name : value;
  };

  this.renderActivityMessage = function (activity) {
    var _props2 = _this4.props,
        auth = _props2.auth,
        financeSources = _props2.financeSources,
        t = _props2.t;

    var countryCode = auth && auth.company && auth.company.countryCode;
    var _activity$booking = activity.booking,
        booking = _activity$booking === undefined ? {} : _activity$booking; // set booking as empty object if not exist

    if (!booking) {
      // booking value can be null, which means booking: null
      // need to explicitly set it to empty object
      booking = {};
    }

    var _ref2 = booking.project || {},
        _ref2$projectCurrency = _ref2.projectCurrency,
        projectCurrency = _ref2$projectCurrency === undefined ? [] : _ref2$projectCurrency;

    var activityBefore = (0, _json.parseJSON)(activity.before);
    var activityAfter = (0, _json.parseJSON)(activity.after);
    var afterKeys = Object.keys(activityAfter);
    var changes = [];

    var lowerCaseMsg = activity && activity.message && activity.message.toLowerCase();
    var isPackagePricings = lowerCaseMsg && (lowerCaseMsg.includes('package pricing') || lowerCaseMsg.includes('pricing package'));
    var isUnitChange = lowerCaseMsg && lowerCaseMsg.includes('unit change');

    afterKeys.forEach(function (element) {
      var message = void 0;
      var after = '';
      var before = activityBefore[element];
      if (activity.before) {
        if (!_lodash2.default.isEmpty(activityAfter[element]) || _lodash2.default.isNumber(activityAfter[element])) {
          after = activityAfter[element];
        }
      }
      switch (element) {
        case 'id':
          if (!isPackagePricings && isUnitChange) {
            if (booking.oldID && booking.oldID === before) {
              message = _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  _reactI18next.Trans,
                  { ns: _translation.TRANSLATION_FILES.screens },
                  'This booking is created via ',
                  _react2.default.createElement(
                    'span',
                    { style: { color: '#666' } },
                    'Unit Change'
                  ),
                  ' from ',
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/bookings/' + booking.oldID + '/' },
                    'here'
                  )
                )
              );
            }
            if (booking.newID && booking.newID === after) {
              message = _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  _reactI18next.Trans,
                  { ns: _translation.TRANSLATION_FILES.screens },
                  'A new ',
                  _react2.default.createElement(
                    _reactRouter.Link,
                    { to: '/bookings/' + booking.newID + '/' },
                    'booking'
                  ),
                  ' is created via ',
                  _react2.default.createElement(
                    'span',
                    { style: { color: '#666' } },
                    'Unit Change'
                  )
                )
              );
            }
          }
          break;
        case 'statusID':
          before = (0, _translation2.getConstantsLabel)(t, _bookingStatuses2.default, before);
          after = (0, _translation2.getConstantsLabel)(t, _bookingStatuses2.default, after);
          break;
        case 'paymentMethodID':
          {
            var beforeLabel = (0, _financeSource.getFinanceSourceLabel)(before, financeSources.data);
            var afterLabel = (0, _financeSource.getFinanceSourceLabel)(after, financeSources.data);
            before = t(beforeLabel, { ns: _translation.TRANSLATION_FILES.constants, defaultValue: beforeLabel });
            after = t(afterLabel, { ns: _translation.TRANSLATION_FILES.constants, defaultValue: afterLabel });
            break;
          }
        case 'spaValue':
          before = _react2.default.createElement(_LoanAmount2.default, { projectCurrencies: projectCurrency, format: '0,000,000', amount: before, prefix: _react2.default.createElement(_CurrencySymbol2.default, null) });
          after = _react2.default.createElement(_LoanAmount2.default, { projectCurrencies: projectCurrency, format: '0,000,000', amount: after, prefix: _react2.default.createElement(_CurrencySymbol2.default, null) });
          break;
        case 'paymentTypeID':
          before = (0, _translation2.getConstantsLabel)(t, _paymentTypes2.default, before);
          after = (0, _translation2.getConstantsLabel)(t, _paymentTypes2.default, after);
          break;
        case 'paymentStatusID':
          before = (0, _translation2.getConstantsLabel)(t, _paymentStatuses2.default, before);
          after = (0, _translation2.getConstantsLabel)(t, _paymentStatuses2.default, after);
          break;
        case 'customerID':
          message = _react2.default.createElement(
            'span',
            { style: { color: '#666' } },
            _this4.keyToName(element, isPackagePricings),
            ' ',
            t('changed')
          );
          break;
        case 'isCancelPending':
          if (activity.booking.statusID === 'cancelled_developer') {
            message = _react2.default.createElement(
              'span',
              { style: { color: '#666' } },
              t('Cancelled all pending loan applications')
            );
          } else {
            before = null;
            after = null;
          }
          break;
        case 'enabledHoldDelistUnit':
          message = _react2.default.createElement(
            'span',
            { style: { color: '#666' } },
            'Unit is put on hold'
          );
          break;
        case 'nettSellingPrice':
          before = _react2.default.createElement(_LoanAmount2.default, { projectCurrencies: projectCurrency, format: '0,000,000', amount: before, prefix: _react2.default.createElement(_CurrencySymbol2.default, null) });
          after = _react2.default.createElement(_LoanAmount2.default, { projectCurrencies: projectCurrency, format: '0,000,000', amount: after, prefix: _react2.default.createElement(_CurrencySymbol2.default, null) });
          break;
        case 'amountCents':
          before = before ? _react2.default.createElement(_LoanAmount2.default, { projectCurrencies: projectCurrency, format: '0,000,000', amount: before / 100, prefix: _react2.default.createElement(_CurrencySymbol2.default, null) }) : null;
          after = _react2.default.createElement(_LoanAmount2.default, { projectCurrencies: projectCurrency, format: '0,000,000', amount: after / 100, prefix: _react2.default.createElement(_CurrencySymbol2.default, null) });
          break;
        // Legal calendar dates: the same day for every viewer, so they keep the configured zone.
        case 'spaSigningDate':
        case 'spaStampingDate':
          before = before ? (0, _activityDateValue.formatLegalDate)(before) : null;
          after = (0, _activityDateValue.formatLegalDate)(after);
          break;
        // Actual instants that are merely shown without a clock: the calendar day is the viewer's.
        case 'approvedAt':
        case 'cancelledAt':
        case 'lastSoldAt':
        case 'lastBookedAt':
          before = before ? (0, _activityDateValue.formatInstantAsDate)(before, countryCode) : null;
          after = (0, _activityDateValue.formatInstantAsDate)(after, countryCode);
          break;
        case 'cancellationReasonID':
          before = _this4.renderCancellationReason(before);
          after = _this4.renderCancellationReason(after);
          break;
        case 'pricePerSqm':
          before = before ? _react2.default.createElement(_LoanAmount2.default, { projectCurrencies: projectCurrency, format: '0,000,000', amount: before, prefix: _react2.default.createElement(_CurrencySymbol2.default, null) }) : null;
          after = _react2.default.createElement(_LoanAmount2.default, { projectCurrencies: projectCurrency, format: '0,000,000', amount: after, prefix: _react2.default.createElement(_CurrencySymbol2.default, null) });
          break;
        case 'frontIC':
        case 'backIC':
          message = _react2.default.createElement(
            'span',
            { style: { color: '#666' } },
            after
          );
          break;
        case 'createdAt':
        case 'updatedAt':
        case 'pendingDocsAt':
        case 'pendingDocsSubmittedAt':
        case 'approvedLoIssuedAt':
        case 'successLiIssuedAt':
        case 'rejectUnqualifiedAt':
        case 'rejectBankAt':
        case 'rejectCustomerAt':
        case 'rejectCancelledAt':
        case 'rejectLoSignedOtherBankAt':
        case 'rejectDeveloperAt':
        case 'closedAt':
        case 'reservedAt':
        case 'bookedAt':
        case 'soldAt':
        case 'unsuccessfulAt':
        case 'signAt':
        case 'rejectedAt':
        case 'requestedAt':
        case 'pdfLastSentAt':
        case 'paymentAt':
        case 'leadCreatedAt':
        case 'salesPersonSignAt':
        case 'declinedPendingCancellationAt':
        case 'systemCreatedAt':
        case 'statusUpdatedAt':
          before = (0, _displayTime.displayMoment)(before, countryCode).format('MMMM Do YYYY, h:mm a');
          after = (0, _displayTime.displayMoment)(after, countryCode).format('MMMM Do YYYY, h:mm a');
          break;
        case 'loanTracker':
        case 'maUser':
        case 'maCreated':
        case 'bookingCustomerID':
        case 'assignedMaUserID':
        case 'assignedMaPreferredName':
        case 'projectBookingCustomFieldOptionID':
        case 'projectBookingCustomFieldOptionIDs':
        case 'maUserID':
        case 'maUserAffiliateID':
        case 'maUserAffiliateCompanyID':
        case 'maUserAffiliateCompanyBranchID':
        case 'signature':
        case 'salesPersonSignature':
        case 'spaTimes':
        case 'lastReservedAt':
        case 'lastCancelledDeveloperAt':
        case 'lastCancelledAvailabilityAt':
        case 'lastExpiredAt':
        case 'himsHasChanges':
        case 'systemPricePerSqm':
        case 'newBookingNoteEncoded':
          before = null;
          after = null;
          break;
        default:
          break;
      }
      if (message) {
        changes.push(message);
      } else if (before || after) {
        var keyName = _this4.keyToName(element, isPackagePricings);
        if (before === false && after) {
          message = _react2.default.createElement(
            _reactI18next.Trans,
            { ns: _translation.TRANSLATION_FILES.screens },
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                { keyName: keyName }
              ),
              ' has been added'
            )
          );
        } else if (!before) {
          message = _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'span',
              { style: { color: '#666' } },
              keyName
            ),
            ': ',
            _react2.default.createElement(
              'u',
              null,
              after
            )
          );
        } else if (before && !after) {
          message = _react2.default.createElement(
            _reactI18next.Trans,
            { ns: _translation.TRANSLATION_FILES.screens },
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                { keyName: keyName }
              ),
              ' has been removed'
            )
          );
        } else if (['spaValue', 'nettSellingPrice', 'amountCents', 'pricePerSqm'].includes(element)) {
          message = _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'span',
              { style: { color: '#666' } },
              keyName
            ),
            ' ',
            t('changed from', { ns: _translation.TRANSLATION_FILES.screens }),
            ' ',
            _react2.default.createElement(
              'u',
              null,
              before
            ),
            ' ',
            t('to', { ns: _translation.TRANSLATION_FILES.screens }),
            ' ',
            _react2.default.createElement(
              'u',
              null,
              after
            )
          );
        } else {
          message = _react2.default.createElement(
            _reactI18next.Trans,
            { ns: _translation.TRANSLATION_FILES.screens },
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                { keyName: keyName }
              ),
              ' changed from ',
              _react2.default.createElement(
                'u',
                null,
                { before: before }
              ),
              ' to ',
              _react2.default.createElement(
                'u',
                null,
                { after: after }
              )
            )
          );
        }
        changes.push(message);
      }
    });
    return _react2.default.createElement(
      _semanticUiReact.List,
      { bulleted: true },
      changes.map(function (element, id) {
        return _react2.default.createElement(
          _semanticUiReact.List.Item,
          { key: id },
          element
        );
      })
    );
  };

  this.renderActivityTitle = function (message) {
    var t = _this4.props.t;

    var title = message;
    var regexp = / *\([^)]*\) */g;
    var hasBrackets = regexp.test(title);
    if (hasBrackets) {
      var data = title.match(regexp)[0];
      title = title.replace(regexp, ' {{data}} ');
      return t(title.trim(), { data: data });
    }
    return t(title);
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.booking, _translation.TRANSLATION_FILES.models.bookingPackagePricing, _translation.TRANSLATION_FILES.models.mpUserDetails]))((0, _reactRedux.connect)(BookingActivities.mapStateToProps)(BookingActivities));

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _paymentTypes = __webpack_require__(322);

var _paymentTypes2 = _interopRequireDefault(_paymentTypes);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _ContentExpand = __webpack_require__(2116);

var _ContentExpand2 = _interopRequireDefault(_ContentExpand);

var _TextExpand = __webpack_require__(2207);

var _TextExpand2 = _interopRequireDefault(_TextExpand);

var _Form = __webpack_require__(267);

var _Form2 = _interopRequireDefault(_Form);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

var _UploadModal = __webpack_require__(92);

var _UploadModal2 = _interopRequireDefault(_UploadModal);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _fileSize = __webpack_require__(85);

var _fileSize2 = _interopRequireDefault(_fileSize);

var _valueToText = __webpack_require__(98);

var _valueToText2 = _interopRequireDefault(_valueToText);

var _centsFloat = __webpack_require__(175);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BookingFeePaymentList = function (_Component) {
  _inherits(BookingFeePaymentList, _Component);

  function BookingFeePaymentList(props) {
    _classCallCheck(this, BookingFeePaymentList);

    var _this = _possibleConstructorReturn(this, (BookingFeePaymentList.__proto__ || Object.getPrototypeOf(BookingFeePaymentList)).call(this, props));

    _this.getPicturesLength = function (data) {
      if (data && data.paymentPictures && data.paymentPictures.length > 0) {
        return data.paymentPictures.length;
      }
      return 0;
    };

    _this.getPaymentPictures = function () {
      var pictureListModalID = _this.state.pictureListModalID;
      var data = _this.props.data;

      var payment = data.find(function (d) {
        return d.id === pictureListModalID;
      });
      if (payment && payment.paymentPictures && payment.paymentPictures.length > 0) {
        return payment.paymentPictures;
      }
      return [];
    };

    _this.isOfflinePayment = function (payment) {
      if (payment.paymentMethodTypeID === 'online_payment' || payment.status === 'deduction') {
        return false;
      }
      return true;
    };

    _this.isCancelled = function (payment) {
      if (payment.cancelledReason !== '' && (payment.status === 'cancelled' || payment.status === 'deduction')) {
        return true;
      }
      return false;
    };

    _this.handleCancelPayment = function (e, payment) {
      e.preventDefault();
      _this.setState({
        cancelModalOpen: true,
        cancelModalID: payment.id,
        cancelModalAmount: payment.amountCents
      });
    };

    _this.handleChangeCancelReason = function (e, data) {
      _this.setState({
        cancelModalReason: data.value
      });
    };

    _this.handleCloseCancelModal = function (e) {
      e.preventDefault();
      _this.setState({
        loading: false,
        cancelModalOpen: false,
        cancelModalID: '',
        cancelModalAmount: '',
        cancelModalReason: ''
      });
    };

    _this.handleCancelPaymentDelete = function (e) {
      e.preventDefault();
      _this.setState({
        cancelModalOpen: false
      }, function () {
        _this.cancelPayment();
      });
    };

    _this.handleCheckBeforeClose = function () {
      if (_this.form.state.uploads.length > 0) {
        _this.uploadModal.close();
        return true;
      }
      return false;
    };

    _this.handleViewPictures = function (e, payment) {
      e.preventDefault();
      _this.setState({
        pictureListModalOpen: true,
        pictureListModalID: payment.id
      });
    };

    _this.handleClosePictureListModal = function (e) {
      e.preventDefault();
      _this.setState({
        loading: false,
        pictureListModalOpen: false,
        pictureListModalID: ''
      }, function () {
        if (_this.props.isSubModal) {
          document.body.className += ' dimmable dimmed scrolling';
        }
      });
    };

    _this.handleCloseLarge = function (e) {
      e.preventDefault();
      _this.setState({
        showLarge: false,
        selectedPicture: null,
        slideshow: false
      });
    };

    _this.handleViewLargeSlide = function (e, data) {
      e.preventDefault();
      _this.setState({
        selectedPicture: data,
        showLarge: true,
        slideshow: true
      });
    };

    _this.handleSlidePicture = function (e) {
      var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
      var selectedPicture = _this.state.selectedPicture;

      var index = _this.getPaymentPictures().indexOf(selectedPicture);
      var nextIndex = direction === 'left' ? index - 1 : index + 1;
      _this.setState({
        selectedPicture: _this.getPaymentPictures()[nextIndex]
      });
    };

    _this.handleDeletePicture = function (e, file) {
      e.preventDefault();
      _this.setState({
        showDeletePictureConfirm: true,
        deleteFile: file
      });
    };

    _this.handleCancelDeletePicture = function (e) {
      e.preventDefault();
      _this.setState({
        showDeletePictureConfirm: false,
        deleteFile: null
      });
    };

    _this.handleConfirmDeletePicture = function (e) {
      e.preventDefault();
      var fileID = _this.state.deleteFile.id;
      _this.setState({
        showDeletePictureConfirm: false,
        deleteFile: null
      }, function () {
        _this.deletePicture(fileID);
      });
    };

    _this.PAYMENT_STATUS = [{ text: 'Payment Made', value: 'paid' }, { text: 'Pending', value: 'pending' }, { text: 'Cancelled', value: 'cancelled' }, { text: 'Deduction', value: 'deduction' }];
    _this.ONLINE_PAYMENT_STATUS = [{ text: 'Pending Registration', value: 'new' }, { text: 'Approved', value: 'approved' }, { text: 'Rejected', value: 'rejected' }, { text: 'Payment Requested', value: 'payment_submitted' }, { text: 'Payment Failed', value: 'payment_failed' }, { text: 'Paid', value: 'payment_completed' }];

    _this.state = {
      cancelModalOpen: false,
      cancelModalID: '',
      cancelModalAmount: '',
      loading: false,
      pictureListModalOpen: false,
      pictureListModalID: '',
      showLarge: false,
      selectedPicture: null,
      slideshow: false,
      showDeletePictureConfirm: false,
      deleteFile: null
    };
    return _this;
  }

  _createClass(BookingFeePaymentList, [{
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'getPaymentStatus',
    value: function getPaymentStatus(payment) {
      var textWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'auto';
      var t = this.props.t;

      if (payment.paymentMethodTypeID === 'online_payment' && payment.onlinePayment && payment.onlinePayment.requestStatus) {
        var onlinePaymentURL = '';
        if (payment.onlinePayment.requestStatus === 'payment_submitted' || payment.onlinePayment.requestStatus === 'payment_completed') {
          onlinePaymentURL = payment.onlinePayment.responsePaymentURL;
        }
        if (onlinePaymentURL !== '') {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'a',
              { href: payment.onlinePayment.responsePaymentURL, rel: 'noopener noreferrer', target: '_blank' },
              t((0, _valueToText2.default)(this.ONLINE_PAYMENT_STATUS, payment.onlinePayment.requestStatus), { ns: _translation.TRANSLATION_FILES.constants })
            ),
            _react2.default.createElement('br', null)
          );
        }
        return _react2.default.createElement(
          'div',
          null,
          t((0, _valueToText2.default)(this.ONLINE_PAYMENT_STATUS, payment.onlinePayment.requestStatus), { ns: _translation.TRANSLATION_FILES.constants }),
          _react2.default.createElement('br', null)
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        t((0, _valueToText2.default)(this.PAYMENT_STATUS, payment.status), { ns: _translation.TRANSLATION_FILES.constants }),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'div',
          { className: textWidth !== 'auto' ? 'text_expand_single' : '', style: { width: textWidth, fontSize: '80%' } },
          payment.cancelledReason
        )
      );
    }
  }, {
    key: 'checkDisabled',
    value: function checkDisabled() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';
      var selectedPicture = this.state.selectedPicture;

      if (this.getPaymentPictures() && this.getPaymentPictures().length > 0 && selectedPicture) {
        var index = this.getPaymentPictures().indexOf(selectedPicture);
        if (direction === 'left') {
          return index - 1 >= 0;
        }
        return index + 1 < this.getPaymentPictures().length;
      }
      return false;
    }
  }, {
    key: 'cancelPayment',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, data, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                _context.next = 3;
                return this.setLoading(true);

              case 3:
                data = {
                  cancelledReason: this.state.cancelModalReason
                };
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.props.bookingID + '/booking_fee_payments/' + this.state.cancelModalID + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(data)
                }));

              case 7:
                _context.next = 21;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](4);
                _context.next = 13;
                return this.setLoading(false);

              case 13:
                Bugsnag.notifyException(_context.t0);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 17;
                return _context.t0.res.text();

              case 17:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 20:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));

              case 21:
                _context.next = 23;
                return this.setLoading(false);

              case 23:
                _context.next = 25;
                return this.setComponentState({
                  cancelModalID: '',
                  cancelModalAmount: '',
                  cancelModalReason: ''
                });

              case 25:
                if (this.props.fetchNewBooking) {
                  this.props.fetchNewBooking();
                }

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 9]]);
      }));

      function cancelPayment() {
        return _ref.apply(this, arguments);
      }

      return cancelPayment;
    }()
  }, {
    key: 'uploadPictures',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e, body) {
        var _this4 = this;

        var t, store;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e.preventDefault();
                _context2.next = 3;
                return this.setLoading(true);

              case 3:
                t = this.props.t;
                store = this.context.store;

                store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.props.bookingID + '/pictures/?FPID=' + this.state.pictureListModalID, {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    // Let browser decide Content-Type
                    'X-Csrf-Token': this.props.token
                  },
                  body: body
                })).then(function (res) {
                  res.text().then(function () {
                    if (_this4.props.fetchNewBooking) {
                      _this4.props.fetchNewBooking(function () {
                        _this4.setLoading(false);
                      });
                    }
                  });
                  if (!_this4.props.fetchNewBooking) _this4.setLoading(false);
                  _this4.uploadModal.close();
                  store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Upload Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Picture(s) successfully uploaded', { ns: _translation.TRANSLATION_FILES.translation }) }));
                }).catch(function (err) {
                  _this4.setLoading(false);
                  if (err.res && err.res.status >= 400 && err.res.status < 500) {
                    err.res.text().then(function (message) {
                      store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                    });
                    return;
                  }
                  store.dispatch((0, _flash.flashErrorMessage)(err));
                  _this4.handleCancel();
                });

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function uploadPictures(_x6, _x7) {
        return _ref2.apply(this, arguments);
      }

      return uploadPictures;
    }()
  }, {
    key: 'deletePicture',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id) {
        var store, t, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                _context3.next = 4;
                return this.setLoading(true);

              case 4:
                _context3.prev = 4;
                _context3.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.props.bookingID + '/pictures/' + id + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 7:
                _context3.next = 19;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](4);

                Bugsnag.notifyException(_context3.t0);

                if (!(_context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 18;
                  break;
                }

                _context3.next = 15;
                return _context3.t0.res.text();

              case 15:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 18:
                store.dispatch((0, _flash.flashErrorMessage)(_context3.t0));

              case 19:
                if (!this.props.fetchNewBooking) {
                  _context3.next = 22;
                  break;
                }

                _context3.next = 22;
                return this.props.fetchNewBooking();

              case 22:
                _context3.next = 24;
                return this.setLoading(false);

              case 24:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Picture successfully deleted', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 25:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 9]]);
      }));

      function deletePicture(_x8) {
        return _ref3.apply(this, arguments);
      }

      return deletePicture;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props = this.props,
          t = _props.t,
          data = _props.data,
          _props$projectCurrenc = _props.projectCurrencies,
          projectCurrencies = _props$projectCurrenc === undefined ? [] : _props$projectCurrenc;
      var _state = this.state,
          cancelModalOpen = _state.cancelModalOpen,
          cancelModalAmount = _state.cancelModalAmount,
          cancelModalReason = _state.cancelModalReason,
          pictureListModalOpen = _state.pictureListModalOpen,
          deleteFile = _state.deleteFile;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(_DeleteConfirm2.default, {
          open: this.state.showDeletePictureConfirm,
          onClose: this.handleCancelDeletePicture,
          onConfirm: this.handleConfirmDeletePicture,
          name: deleteFile ? deleteFile.name : ''
        }),
        _react2.default.createElement(_ViewLarge2.default, {
          open: this.state.showLarge,
          onClose: this.handleCloseLarge,
          picture: this.state.selectedPicture,
          onSlide: this.handleSlidePicture,
          disabledLeft: !this.checkDisabled('left'),
          disabledRight: !this.checkDisabled('right'),
          slideshow: this.state.slideshow
        }),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            size: 'small',
            open: cancelModalOpen,
            onClose: this.handleCloseCancelModal
          },
          _react2.default.createElement(_semanticUiReact.Header, { icon: 'x', content: t('Cancel Payment', { ns: _translation.TRANSLATION_FILES.screens }) }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Modal.Description,
              null,
              t('Cancel and deduct payment of', { ns: _translation.TRANSLATION_FILES.translation }),
              '\xA0',
              _react2.default.createElement(
                'b',
                null,
                _react2.default.createElement(_LoanAmount2.default, {
                  projectCurrencies: projectCurrencies,
                  format: '0,000,000.00',
                  precise: true,
                  amount: (0, _centsFloat.centsToFloat)(cancelModalAmount),
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                })
              ),
              '?',
              _react2.default.createElement('br', null),
              _react2.default.createElement('br', null),
              _react2.default.createElement(_semanticUiReact.Input, {
                fluid: true,
                onChange: this.handleChangeCancelReason,
                type: 'text',
                placeholder: 'Cancel reason',
                value: cancelModalReason
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleCloseCancelModal, icon: 'cancel', content: 'No' }),
            _react2.default.createElement(_semanticUiReact.Button, { positive: true, onClick: this.handleCancelPaymentDelete, icon: 'checkmark', content: 'Yes' })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            open: pictureListModalOpen,
            onClose: this.handleClosePictureListModal
          },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              'Loading'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Header,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { verticalAlign: 'middle' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 8, tablet: 8, computer: 8 },
                  _react2.default.createElement(
                    'h3',
                    null,
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'picture', size: 'large' }),
                    ' ',
                    t('Picture Attachments', { ns: _translation.TRANSLATION_FILES.translation })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 8, tablet: 8, computer: 8, textAlign: 'right' },
                  !this.props.listOnly ? _react2.default.createElement(_UploadModal2.default, {
                    ref: function ref(_ref5) {
                      _this5.uploadModal = _ref5;
                    },
                    header: 'pictures',
                    loading: this.state.loading,
                    onConfirm: function onConfirm(e, file) {
                      _this5.uploadPictures(e, file);
                    },
                    onClose: this.handleCheckBeforeClose,
                    content: function content(opt) {
                      return _react2.default.createElement(_Form2.default, {
                        ref: function ref(_ref4) {
                          _this5.form = _ref4;
                        },
                        loading: _this5.state.loading,
                        onSubmit: opt.onConfirm
                      });
                    }
                  }) : ''
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            { scrolling: true },
            _react2.default.createElement(
              _semanticUiReact.Modal.Description,
              null,
              _react2.default.createElement(
                _semanticUiReact.Segment.Group,
                null,
                this.getPaymentPictures().length > 0 ? this.getPaymentPictures().map(function (file, id) {
                  return _react2.default.createElement(
                    _semanticUiReact.Segment,
                    { key: id },
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      {
                        columns: 'equal',
                        verticalAlign: 'middle',
                        as: 'a'
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 10, computer: 11, textAlign: 'left', onClick: function onClick(e) {
                            return _this5.handleViewLargeSlide(e, file);
                          } },
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'file image outline' }),
                        file.name,
                        _react2.default.createElement(
                          'span',
                          { className: 'mobile-hide' },
                          ' (',
                          (0, _fileSize2.default)(file.size),
                          ')'
                        ),
                        _react2.default.createElement(
                          'small',
                          { className: 'large-hide small-hide tablet-hide' },
                          _react2.default.createElement('br', null),
                          (0, _fileSize2.default)(file.size)
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 6, computer: 5, textAlign: 'right' },
                        _react2.default.createElement(
                          'small',
                          { onClick: function onClick(e) {
                              return _this5.handleViewLargeSlide(e, file);
                            }, style: { paddingRight: '1em' } },
                          _react2.default.createElement(_Timestamp2.default, { timestamp: file.createdAt, format: 'DD/MM/YY hh:mm a' })
                        ),
                        _react2.default.createElement(_semanticUiReact.Button, {
                          compact: true,
                          negative: true,
                          type: 'button',
                          size: 'tiny',
                          icon: 'trash',
                          onClick: function onClick(e) {
                            return _this5.handleDeletePicture(e, file);
                          }
                        })
                      )
                    )
                  );
                }) : _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { textAlign: 'center' },
                  t('No pictures found', { ns: _translation.TRANSLATION_FILES.screens })
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleClosePictureListModal, content: 'Close' })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 16, tablet: 16, computer: 16, style: { overflowX: 'auto' } },
            data && data.length > 0 ? _react2.default.createElement(
              _semanticUiReact.Table,
              {
                unstackable: true
              },
              _react2.default.createElement(
                _semanticUiReact.Table.Header,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    this.props.t('Date', { ns: _translation.TRANSLATION_FILES.translation })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    this.props.t('Amount', { ns: _translation.TRANSLATION_FILES.translation })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    this.props.t('Type', { ns: _translation.TRANSLATION_FILES.translation })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    this.props.t('Reference', { ns: _translation.TRANSLATION_FILES.translation })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    this.props.t('Attachments', { ns: _translation.TRANSLATION_FILES.translation })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    this.props.t('Status', { ns: _translation.TRANSLATION_FILES.translation })
                  ),
                  !this.props.listOnly && _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null)
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Body,
                null,
                data.map(function (payment, idx) {
                  return _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    { key: idx },
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      { width: 3 },
                      _react2.default.createElement(_Timestamp2.default, { timestamp: payment.createdAt, format: 'DD/MM/YY hh:mm a' })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      { width: 2 },
                      _react2.default.createElement(_LoanAmount2.default, {
                        projectCurrencies: projectCurrencies,
                        format: '0,000,000.00',
                        amount: (0, _centsFloat.centsToFloat)(payment.amountCents),
                        prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      { width: 2 },
                      t((0, _valueToText2.default)(_paymentTypes2.default, payment.paymentMethodTypeID), { ns: _translation.TRANSLATION_FILES.constants })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      { width: 4 },
                      _react2.default.createElement(_TextExpand2.default, {
                        width: '150px',
                        text: payment.reference
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      { width: 2 },
                      _this5.isOfflinePayment(payment) ? _react2.default.createElement(
                        'button',
                        {
                          className: 'a-button-blue',
                          onClick: function onClick(e) {
                            return _this5.handleViewPictures(e, payment);
                          },
                          title: 'View'
                        },
                        _this5.getPicturesLength(payment) > 0 ? _this5.getPicturesLength(payment) + ' ' + t('Attachment', { ns: _translation.TRANSLATION_FILES.screens }) : t('None', { ns: _translation.TRANSLATION_FILES.translation })
                      ) : 'n/a'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      { width: 2 },
                      _react2.default.createElement(_ContentExpand2.default, {
                        width: '150px',
                        shortText: _this5.getPaymentStatus(payment, '150px'),
                        fullContent: _this5.isCancelled(payment) ? _react2.default.createElement(
                          'div',
                          null,
                          _this5.getPaymentStatus(payment)
                        ) : '',
                        expandable: _this5.isCancelled(payment)
                      })
                    ),
                    !_this5.props.listOnly && _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      { width: 1 },
                      payment.status === 'paid' && payment.paymentMethodTypeID !== 'online_payment' && _react2.default.createElement(
                        _semanticUiReact.Button,
                        { onClick: function onClick(e) {
                            return _this5.handleCancelPayment(e, payment);
                          }, size: 'mini', floated: 'right', negative: true, icon: true },
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'x' })
                      )
                    )
                  );
                })
              )
            ) : _react2.default.createElement(
              _semanticUiReact.Segment,
              { textAlign: 'center' },
              t('No payments found', { ns: _translation.TRANSLATION_FILES.screens })
            )
          )
        )
      );
    }
  }]);

  return BookingFeePaymentList;
}(_react.Component);

BookingFeePaymentList.propTypes = {
  auth: _propTypes2.default.shape({
    groups: _propTypes2.default.array
  }),
  bookingID: _propTypes2.default.string.isRequired,
  data: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  fetchNewBooking: _propTypes2.default.func,
  token: _propTypes2.default.string.isRequired,
  listOnly: _propTypes2.default.bool,
  isSubModal: _propTypes2.default.bool,
  projectCurrencies: _propTypes2.default.arrayOf(_propTypes2.default.object),
  t: _propTypes2.default.func
};
BookingFeePaymentList.defaultProps = {
  data: []
};
BookingFeePaymentList.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)([_translation.TRANSLATION_FILES.screens, _translation.TRANSLATION_FILES.translation])(BookingFeePaymentList);

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ListItemEmpty = exports.ListItemPlaceholder = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _marked = __webpack_require__(2581);

var _marked2 = _interopRequireDefault(_marked);

var _types = __webpack_require__(145);

var _translation = __webpack_require__(4);

var _noteTimestamp = __webpack_require__(2101);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_momentTimezone2.default.locale('en-gb'); /* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-unused-prop-types */
var ListItemPlaceholder = exports.ListItemPlaceholder = function ListItemPlaceholder() {
  return _react2.default.createElement(
    _semanticUiReact.Feed.Event,
    { key: 0, className: 'bnl-item' },
    _react2.default.createElement(
      _semanticUiReact.Feed.Label,
      null,
      _react2.default.createElement(
        _semanticUiReact.Placeholder,
        null,
        _react2.default.createElement(_semanticUiReact.Placeholder.Image, { square: true })
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Feed.Content,
      null,
      _react2.default.createElement(
        _semanticUiReact.Feed.Extra,
        null,
        _react2.default.createElement(
          _semanticUiReact.Placeholder,
          null,
          _react2.default.createElement(
            _semanticUiReact.Placeholder.Paragraph,
            null,
            _react2.default.createElement(_semanticUiReact.Placeholder.Line, null),
            _react2.default.createElement(_semanticUiReact.Placeholder.Line, null)
          ),
          _react2.default.createElement(
            _semanticUiReact.Placeholder.Paragraph,
            null,
            _react2.default.createElement(_semanticUiReact.Placeholder.Line, null),
            _react2.default.createElement(_semanticUiReact.Placeholder.Line, null),
            _react2.default.createElement(_semanticUiReact.Placeholder.Line, null),
            _react2.default.createElement(_semanticUiReact.Placeholder.Line, null)
          )
        )
      )
    )
  );
};

var ListItemEmpty = exports.ListItemEmpty = function ListItemEmpty(_ref) {
  var t = _ref.t;
  return _react2.default.createElement(
    _semanticUiReact.Feed.Event,
    { className: 'bnl-empty-item' },
    _react2.default.createElement(
      _semanticUiReact.Feed.Content,
      null,
      _react2.default.createElement(
        'p',
        null,
        t('No notes found')
      )
    )
  );
};

ListItemEmpty.propTypes = {
  t: _propTypes2.default.func
};

var ListItem = function ListItem(_ref2) {
  var bookingNote = _ref2.bookingNote,
      canManage = _ref2.canManage,
      countryCode = _ref2.countryCode,
      hasAccess = _ref2.hasAccess,
      isLastIndex = _ref2.isLastIndex,
      listIndex = _ref2.listIndex,
      noteIsDeleting = _ref2.noteIsDeleting,
      noteIsDisabled = _ref2.noteIsDisabled,
      noteIsEditing = _ref2.noteIsEditing,
      onDelete = _ref2.onDelete,
      onEdit = _ref2.onEdit,
      i18n = _ref2.i18n,
      t = _ref2.t;

  var numberToColor = function numberToColor(number) {
    if (typeof number === 'number' && Number.isInteger(number)) {
      var colors = ['#B03060', '#FE9A76', '#FFD700', '#32CD32', '#016936', '#EE82EE', '#B413EC', '#FF1493', '#A52A2A', '#A0A0A0'];
      var colorIndex = (number - 1) % colors.length;
      return colors[colorIndex];
    }
    return '#0E6EB8';
  };
  var formatTimestamp = function formatTimestamp(timestamp) {
    return (0, _noteTimestamp.formatNoteTimestamp)(timestamp, countryCode, {
      language: i18n.language,
      atLabel: t('at'),
      yesterdayAtLabel: t('Yesterday at')
    });
  };
  var privacyIcon = function privacyIcon(privacy) {
    switch (privacy) {
      case 'public':
        return 'globe';
      case 'internal':
        return 'users';
      case 'private':
        return 'lock';
      default:
        return 'globe';
    }
  };
  var privacyTitle = function privacyTitle(privacy) {
    switch (privacy) {
      case 'public':
        return 'Public';
      case 'internal':
        return 'Internal';
      case 'private':
        return 'Only Me';
      default:
        return 'Public';
    }
  };
  var isSystemUser = function isSystemUser(name) {
    if (name.toLowerCase().includes('system')) return true;
    return false;
  };
  var getNote = function getNote(bNote) {
    try {
      var hasNoSpaces = bNote.indexOf(' ') === -1;
      if (hasNoSpaces) {
        return decodeURIComponent(bNote.replace(/\+/g, ' '));
      }
      return decodeURIComponent(bNote);
    } catch (e) {
      return bNote;
    }
  };
  return _react2.default.createElement(
    _semanticUiReact.Dimmer.Dimmable,
    {
      as: _semanticUiReact.Feed.Event,
      className: 'bnl-item ' + (noteIsEditing ? 'is-editing' : '') + ' ' + (noteIsDisabled ? 'is-disabled' : ''),
      dimmed: noteIsDeleting,
      id: 'fe_' + listIndex,
      key: listIndex
    },
    _react2.default.createElement(
      _semanticUiReact.Feed.Label,
      null,
      _react2.default.createElement(
        'span',
        { className: 'bnl-item-avatar', style: { backgroundColor: numberToColor(bookingNote.muID) } },
        bookingNote.muName ? bookingNote.muName.charAt(0).toUpperCase() : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { inverted: true, fitted: true, color: 'teal', name: 'user' })
        )
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Feed.Content,
      null,
      _react2.default.createElement(
        _semanticUiReact.Feed.Summary,
        null,
        _react2.default.createElement(
          'div',
          { className: 'bnl-item-title-info' },
          hasAccess && !isSystemUser(bookingNote.muPreferredName) ? _react2.default.createElement(
            _semanticUiReact.Feed.User,
            { as: _reactRouter.Link, to: '/users/' + bookingNote.muAffiliateID + '/' },
            bookingNote.muPreferredName,
            ' ',
            _react2.default.createElement(
              'small',
              null,
              '(',
              bookingNote.muName,
              ')'
            )
          ) : _react2.default.createElement(
            _semanticUiReact.Feed.User,
            null,
            bookingNote.muPreferredName,
            ' ',
            _react2.default.createElement(
              'small',
              null,
              '(',
              bookingNote.muName,
              ')'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Feed.Extra,
            { className: 'bnl-item-date-privacy' },
            _react2.default.createElement(
              _semanticUiReact.Feed.Date,
              null,
              _react2.default.createElement(_semanticUiReact.Popup, {
                trigger: _react2.default.createElement(
                  'span',
                  { className: 'timedate' },
                  formatTimestamp(bookingNote.createdAt)
                ),
                content: (0, _noteTimestamp.formatNoteTooltip)(bookingNote.createdAt, countryCode, t('at')),
                position: isLastIndex ? 'top left' : 'bottom left',
                flowing: true,
                inverted: true,
                size: 'mini'
              }),
              bookingNote.createdAt !== bookingNote.updatedAt ? _react2.default.createElement(_semanticUiReact.Popup, {
                trigger: _react2.default.createElement(
                  'span',
                  null,
                  ' ',
                  _react2.default.createElement(
                    'span',
                    { className: 'timedate' },
                    '(',
                    t('edited'),
                    ')'
                  )
                ),
                content: (0, _noteTimestamp.formatNoteTooltip)(bookingNote.updatedAt, countryCode, 'at'),
                position: isLastIndex ? 'top left' : 'bottom left',
                flowing: true,
                inverted: true,
                size: 'mini'
              }) : '',
              '\xA0\xB7\xA0',
              _react2.default.createElement(_semanticUiReact.Popup, {
                trigger: _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(_semanticUiReact.Icon, { name: privacyIcon(bookingNote.privacy) })
                ),
                content: t(privacyTitle(bookingNote.privacy), { ns: _translation.TRANSLATION_FILES.constants }),
                position: isLastIndex ? 'top left' : 'bottom left',
                flowing: true,
                inverted: true,
                size: 'mini'
              })
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bnl-item-edit-menu' },
          canManage ? _react2.default.createElement(
            _semanticUiReact.Dropdown,
            {
              icon: null,
              pointing: isLastIndex ? 'bottom right' : 'top right',
              selectOnBlur: false,
              trigger: _react2.default.createElement(_semanticUiReact.Icon, { color: 'grey', name: 'ellipsis vertical' })
            },
            _react2.default.createElement(
              _semanticUiReact.Dropdown.Menu,
              null,
              _react2.default.createElement(_semanticUiReact.Dropdown.Item, {
                icon: 'pencil',
                text: t('Edit', { ns: _translation.TRANSLATION_FILES.translation }),
                onClick: function onClick() {
                  return onEdit(bookingNote);
                }
              }),
              _react2.default.createElement(_semanticUiReact.Dropdown.Item, {
                icon: 'trash',
                text: t('Delete', { ns: _translation.TRANSLATION_FILES.translation }),
                onClick: function onClick() {
                  return onDelete(bookingNote.id, 'open');
                }
              })
            )
          ) : ''
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Feed.Extra,
        { className: 'bnl-item-note-content' },
        _react2.default.createElement('div', { className: 'bnl-item-markdown m-marked', dangerouslySetInnerHTML: { __html: _marked2.default.parse(getNote(bookingNote.note)) } })
      ),
      _react2.default.createElement(
        _semanticUiReact.Dimmer,
        {
          active: noteIsDeleting,
          inverted: true,
          className: 'bnl-item-delete-dialog',
          verticalAlign: 'top'
        },
        _react2.default.createElement(
          _semanticUiReact.Header,
          { size: 'tiny', color: 'red' },
          t('Confirm Delete Note'),
          '?'
        ),
        _react2.default.createElement(
          _semanticUiReact.Button,
          { size: 'mini', onClick: function onClick() {
              return onDelete(bookingNote.id, 'close');
            }, compact: true, color: 'teal' },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'x' }),
          t('Cancel', { ns: _translation.TRANSLATION_FILES.translation })
        ),
        _react2.default.createElement(
          _semanticUiReact.Button,
          { size: 'mini', onClick: function onClick() {
              return onDelete(bookingNote.id, 'delete');
            }, compact: true, color: 'red' },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'trash' }),
          t('Delete Note')
        )
      )
    )
  );
};

ListItem.propTypes = {
  bookingNote: _types.BookingNotePropTypes,
  noteIsDeleting: _propTypes2.default.bool,
  noteIsDisabled: _propTypes2.default.bool,
  noteIsEditing: _propTypes2.default.bool,
  canManage: _propTypes2.default.bool,
  listIndex: _propTypes2.default.number,
  isLastIndex: _propTypes2.default.bool,
  onDelete: _propTypes2.default.func,
  onEdit: _propTypes2.default.func,
  hasAccess: _propTypes2.default.bool,
  countryCode: _propTypes2.default.string,
  i18n: _propTypes2.default.shape({
    language: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};

// Connected here rather than at the SharedNote/BookingNote callers so every list that renders a
// note item gets the viewer's zone, using the same reactive company selector as components/Timestamp.
var mapStateToProps = function mapStateToProps(state) {
  return {
    countryCode: state.auth && state.auth.company && state.auth.company.countryCode
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(mapStateToProps)(ListItem));

/***/ }),
/* 1008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NotificationIcon = function NotificationIcon(_ref) {
  var status = _ref.status,
      type = _ref.type,
      className = _ref.className;

  var checkStatus = function checkStatus() {
    switch (status) {
      case 'new':
        return 'new';

      case 'nudge':
        return 'nudge';

      case 'alert':
      case 'system':
      case 'announcement':
        return 'alert';

      case 'update_pending':
        return 'update-pending';

      case 'update_success':
      case 'update_reject':
      case 'closed_success':
      case 'closed_reject':
        return 'update-success-reject';

      case 'reassign':
        return 'reassign';

      case 'others':
      case 'update':
      default:
        return 'update';
    }
  };
  return _react2.default.createElement(
    'div',
    { className: 'notification-icon ' + className + ' ' + status + ' ' + (type || '') },
    _react2.default.createElement('img', {
      src: '/assets/icons/notification/' + checkStatus() + '.svg',
      alt: 'Alert for ' + status.replace('_', ' ')
    })
  );
};

NotificationIcon.propTypes = {
  status: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string,
  type: _propTypes2.default.string
};

exports.default = NotificationIcon;

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _strings = __webpack_require__(118);

var _json = __webpack_require__(268);

var _translation = __webpack_require__(64);

var _translation2 = __webpack_require__(4);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


// Still needed for the module-level locale; the feed date renders through Timestamp.
_momentTimezone2.default.locale('en-gb');

var BusinessUnitActivities = function (_Component) {
  _inherits(BusinessUnitActivities, _Component);

  function BusinessUnitActivities() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BusinessUnitActivities);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BusinessUnitActivities.__proto__ || Object.getPrototypeOf(BusinessUnitActivities)).call.apply(_ref, [this].concat(args))), _this), _this.translateGroupsToName = function (groups) {
      var t = _this.props.t;

      var text = void 0;
      var accessRoles = [{ text: 'Headquarters', values: [10, 6], description: 'Admin' }, { text: 'Supervisor', values: [10, 11, 12, 13], description: 'BU Leader' }, { text: 'Sales Manager', values: [10, 11, 13], description: 'BU Leader' }, { text: 'Sales Admin', values: [10, 11], description: 'BU Leader' }, { text: 'Agency Admin', values: [10, 21], description: 'Claim C.' }, { text: 'Agent Leader', values: [10, 17] }, { text: 'Agent / Staff', values: [10] }, { text: 'Basic Siteplan', values: [16] }];
      accessRoles.forEach(function (ar) {
        var result = ar.values.every(function (word) {
          return groups.indexOf(word.toString()) > -1;
        });
        if (result && !text) text = t(ar.text, { ns: _translation2.TRANSLATION_FILES.constants }) + ' ' + (ar.description ? '(' + t(ar.description, { ns: _translation2.TRANSLATION_FILES.constants }) + ')' : '');
      });
      if (!text) text = groups;
      return text;
    }, _this.renderActivityMessage = function (activity) {
      var t = _this.props.t;

      var activityBefore = (0, _json.parseJSON)(activity.before);
      var activityAfter = (0, _json.parseJSON)(activity.after);

      var afterKeys = Object.keys(activityAfter);
      var changes = [];

      var translateValue = function translateValue(value) {
        if (typeof value === 'boolean') {
          return t(value.toString(), { ns: _translation2.TRANSLATION_FILES.constants });
        }

        return t(String(value), { ns: _translation2.TRANSLATION_FILES.constants });
      };

      var renderArrayChange = function renderArrayChange(element) {
        var before = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var after = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        var beforeMap = new Map(before.map(function (item) {
          return [item.id, item];
        }));

        var afterMap = new Map(after.map(function (item) {
          return [item.id, item];
        }));

        var added = after.filter(function (item) {
          return !beforeMap.has(item.id);
        });
        var removed = before.filter(function (item) {
          return !afterMap.has(item.id);
        });

        var keyName = (0, _translation.translateModels)(t, element, 'businessUnit', (0, _strings.camelToTitle)(element));

        added.forEach(function (item) {
          changes.push(_react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'span',
              { style: { color: '#666' } },
              keyName
            ),
            ' ',
            _react2.default.createElement(
              'u',
              null,
              item.name
            ),
            ' ',
            t('has been added', { ns: _translation2.TRANSLATION_FILES.screens })
          ));
        });

        removed.forEach(function (item) {
          changes.push(_react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'span',
              { style: { color: '#666' } },
              keyName
            ),
            ' ',
            _react2.default.createElement(
              'u',
              null,
              item.name
            ),
            ' ',
            t('has been removed', { ns: _translation2.TRANSLATION_FILES.screens })
          ));
        });
      };

      afterKeys.forEach(function (element) {
        var message = void 0;
        var after = '';
        var before = activityBefore[element];
        var keyElement = element;

        if (activity.before) {
          after = activityAfter[element];
        }

        // Handle array fields
        if (Array.isArray(before) || Array.isArray(after)) {
          renderArrayChange(element, before || [], after || []);

          return;
        }

        switch (element) {
          case 'groups':
            before = activity.before ? _this.translateGroupsToName(activity.before) : null;

            after = activity.after ? _this.translateGroupsToName(activity.after) : null;
            break;

          case 'SSTRegisterationNumber':
            // rename to SSTRegistrationNumber
            keyElement = 'SSTRegistrationNumber';
            break;

          default:
            break;
        }

        if (message) {
          changes.push(message);
        } else if (before || after) {
          var keyName = (0, _translation.translateModels)(t, element, 'businessUnit', (0, _strings.camelToTitle)(keyElement || element));

          keyElement = '';

          if (before === false && after) {
            message = _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation2.TRANSLATION_FILES.screens },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  { style: { color: '#666' } },
                  keyName
                ),
                ' has been added'
              )
            );
          } else if (!before) {
            message = _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                keyName
              ),
              ':',
              ' ',
              _react2.default.createElement(
                'u',
                null,
                translateValue(after)
              )
            );
          } else if (before && !after) {
            message = _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation2.TRANSLATION_FILES.screens },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  { style: { color: '#666' } },
                  keyName
                ),
                ' has been removed'
              )
            );
          } else {
            message = _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation2.TRANSLATION_FILES.screens },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  { style: { color: '#666' } },
                  keyName
                ),
                ' changed from',
                ' ',
                _react2.default.createElement(
                  'u',
                  null,
                  { before: translateValue(before) }
                ),
                ' to',
                ' ',
                _react2.default.createElement(
                  'u',
                  null,
                  { after: translateValue(after) }
                )
              )
            );
          }

          changes.push(message);
        }
      });

      return _react2.default.createElement(
        _semanticUiReact.List,
        { bulleted: true },
        changes.map(function (element, id) {
          return _react2.default.createElement(
            _semanticUiReact.List.Item,
            { key: id },
            element
          );
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BusinessUnitActivities, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          data = _props.data,
          t = _props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(
              _semanticUiReact.Feed,
              null,
              data && data.length > 0 ? data.map(function (activity, idx) {
                return _react2.default.createElement(
                  _semanticUiReact.Feed.Event,
                  { key: idx, className: 'activity-logs' },
                  _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: 'user' }),
                  _react2.default.createElement(
                    _semanticUiReact.Feed.Content,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Date,
                      null,
                      _react2.default.createElement(_Timestamp2.default, { timestamp: activity.createdAt, format: 'MMMM Do YYYY, h:mm:ss a' })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Summary,
                      null,
                      _this2.props.hasAccess ? activity.creatorAffiliateID > 0 ? _react2.default.createElement(
                        _reactRouter.Link,
                        { to: '/users/' + activity.creatorAffiliateID + '/' },
                        activity.creatorPreferredName || t('Unknown')
                      ) : activity.creatorPreferredName || 'U' + activity.creatorUserID : activity.creatorPreferredName || 'U' + activity.creatorUserID,
                      ' ' + t(activity.message, { ns: _translation2.TRANSLATION_FILES.translation }),
                      _this2.props.showAll && _react2.default.createElement(
                        _reactRouter.Link,
                        { to: '/business_units/' + activity.businessUnitID + '/' },
                        ' ' + (activity.businessUnitName || 'U' + activity.businessUnitID)
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Extra,
                      { text: true },
                      activity.after && _this2.renderActivityMessage(activity)
                    )
                  )
                );
              }) : this.props.loading ? _react2.default.createElement('br', null) : _react2.default.createElement(
                'center',
                null,
                t('No activity found'),
                '.'
              )
            )
          )
        )
      );
    }
  }]);

  return BusinessUnitActivities;
}(_react.Component);

BusinessUnitActivities.propTypes = {
  data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  hasAccess: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  showAll: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation2.namespaces), [_translation2.TRANSLATION_FILES.models.businessUnit]))(BusinessUnitActivities);

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactCalendar = __webpack_require__(1405);

var _reactCalendar2 = _interopRequireDefault(_reactCalendar);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _i18next = __webpack_require__(94);

var _i18next2 = _interopRequireDefault(_i18next);

var _translation = __webpack_require__(4);

var _calendarDate = __webpack_require__(1087);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


var CalendarDatePicker = function (_Component) {
  _inherits(CalendarDatePicker, _Component);

  function CalendarDatePicker(props) {
    _classCallCheck(this, CalendarDatePicker);

    var _this = _possibleConstructorReturn(this, (CalendarDatePicker.__proto__ || Object.getPrototypeOf(CalendarDatePicker)).call(this, props));

    _initialiseProps.call(_this);

    var date = props.value;
    _this.state = {
      date: date,
      loading: false,
      transition: {
        calendar: true,
        time: false
      },
      visible: props.visible
    };
    return _this;
  }

  _createClass(CalendarDatePicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var date = nextProps.value;
      this.setState({
        date: date,
        visible: nextProps.visible
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          date = _state.date,
          transition = _state.transition,
          visible = _state.visible;
      var _props = this.props,
          basic = _props.basic,
          closeable = _props.closeable,
          closeableCompact = _props.closeableCompact,
          maxDate = _props.maxDate,
          minDate = _props.minDate,
          noPadding = _props.noPadding,
          t = _props.t;


      var currentLang = _i18next2.default.language || 'en-GB';

      return _react2.default.createElement(
        _semanticUiReact.Transition,
        {
          animation: 'vertical flip',
          duration: 250,
          transitionOnMount: true,
          unmountOnHide: true,
          visible: visible
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { centered: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: noPadding && { paddingTop: '0' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { basic: basic, className: 'dtp visible' },
                _react2.default.createElement(
                  _semanticUiReact.Transition,
                  {
                    animation: 'scale',
                    duration: 250,
                    unmountOnHide: true,
                    visible: transition.calendar,
                    onComplete: this.setLoading,
                    onHide: this.setLoading
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Segment,
                    { basic: true, className: 'dtp_tab_content' },
                    _react2.default.createElement(_reactCalendar2.default, {
                      locale: currentLang,
                      maxDate: maxDate && (0, _calendarDate.toCalendarTile)(maxDate),
                      minDate: minDate && (0, _calendarDate.toCalendarTile)(minDate),
                      onChange: this.handleOnChangeCalendar,
                      value: (0, _calendarDate.toCalendarTile)(date || (0, _momentTimezone2.default)())
                    })
                  )
                ),
                closeable && _react2.default.createElement(
                  _semanticUiReact.Button,
                  { size: 'small', primary: true, fluid: true, compact: closeableCompact, onClick: this.handleOnClose },
                  t('Close', { ns: _translation.TRANSLATION_FILES.translation })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return CalendarDatePicker;
}(_react.Component);

// 6. Wrap the export declaration with withTranslation HOC hook


CalendarDatePicker.propTypes = {
  basic: _propTypes2.default.bool,
  closeable: _propTypes2.default.bool,
  closeableCompact: _propTypes2.default.bool,
  maxDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.instanceOf(Date)]),
  minDate: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.instanceOf(Date)]),
  noPadding: _propTypes2.default.bool,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.instanceOf(Date)]),
  visible: _propTypes2.default.bool,
  onChange: _propTypes2.default.func,
  t: _propTypes2.default.func.isRequired
};
CalendarDatePicker.defaultProps = {
  visible: true,
  closeable: true,
  closeableCompact: true
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    _this2.setState({
      loading: loading
    });
  };

  this.handleOnChangeCalendar = function (value) {
    var date = _this2.state.date;

    var newDate = (0, _calendarDate.fromCalendarTile)(value, date).toDate();
    // visible to false - close calendar after date selected
    _this2.setState({ date: newDate, visible: false }, function () {
      if (_this2.props.onChange) _this2.props.onChange(newDate, false);
    });
  };

  this.handleOnClose = function (e) {
    e.preventDefault();
    var date = _this2.state.date;

    _this2.setState({ visible: false }, function () {
      if (_this2.props.onChange) _this2.props.onChange(date, _this2.state.visible);
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(CalendarDatePicker);

/***/ }),
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContentPlaceholder = function (_Component) {
  _inherits(ContentPlaceholder, _Component);

  function ContentPlaceholder(props) {
    _classCallCheck(this, ContentPlaceholder);

    var _this = _possibleConstructorReturn(this, (ContentPlaceholder.__proto__ || Object.getPrototypeOf(ContentPlaceholder)).call(this, props));

    _this.handleCheckExpand = function () {
      var needExpand = _this.checkExpand();
      if (needExpand !== _this.state.needExpand) {
        _this.setState({ needExpand: needExpand });
      }
    };

    _this.documentHeight = function () {
      return Math.max(document.documentElement.clientHeight, document.body.offsetHeight, document.documentElement.offsetHeight);
    };

    _this.checkExpand = function () {
      if (_this.content) {
        var minHeight = _this.documentHeight() / 3;
        return _this.content.clientHeight > minHeight;
      }
      return _this.state.isExpanded;
    };

    _this.handleOnMore = function (e) {
      if (_this.props.expandable) {
        var isExpanded = !_this.state.isExpanded;
        if (_this.props.isExpanded !== undefined) {
          isExpanded = _this.props.isExpanded;
        }
        _this.setState({ isExpanded: isExpanded }, function () {
          if (_this.props.onMore) {
            _this.props.onMore(e, isExpanded);
          }
        });
      }
    };

    _this.checkLoading = function () {
      return _this.props.loading && (_this.props.header || _this.props.subheader || _this.props.paragraphs);
    };

    _this.renderRows = function () {
      var total = 4;
      if (_this.props.paragraphs && typeof _this.props.paragraphs === 'number') {
        total = _this.props.paragraphs;
      }
      var rows = new Array(total);
      rows.fill('paragraph', 0, total);
      return rows.map(function (r, idx) {
        return _react2.default.createElement('div', { key: idx, className: r });
      });
    };

    _this.state = {
      isExpanded: false,
      needExpand: false
    };
    _this.content = null;
    return _this;
  }

  _createClass(ContentPlaceholder, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.expandable) {
        document.addEventListener('DOMContentLoaded', this.handleCheckExpand, false);
        window.addEventListener('scroll', this.handleCheckExpand, false);
        window.addEventListener('resize', this.handleCheckExpand, false);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.expandable) {
        var isExpanded = nextProps.isExpanded;
        if (isExpanded !== undefined) {
          this.setState({ isExpanded: isExpanded });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('DOMContentLoaded', this.handleCheckExpand, false);
      window.removeEventListener('scroll', this.handleCheckExpand, false);
      window.removeEventListener('resize', this.handleCheckExpand, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classNames = [];
      if (this.checkLoading()) {
        classNames.push('content-placeholder');
        if (this.props.direction) {
          classNames.push(this.props.direction);
        }
      } else if (this.props.expandable) {
        if (this.state.needExpand && !this.state.isExpanded) {
          classNames.push('expandable');
        }
      }
      return _react2.default.createElement(
        'div',
        {
          ref: function ref(_ref) {
            _this2.content = _ref;
          },
          className: classNames.join(' ')
        },
        this.checkLoading() && this.props.header ? _react2.default.createElement('div', { className: 'header' }) : null,
        this.checkLoading() && this.props.subheader ? _react2.default.createElement('div', { className: 'header sub' }) : null,
        this.checkLoading() && this.props.paragraphs ? this.renderRows() : null,
        !this.checkLoading() ? this.props.children || this.props.content : null,
        !this.checkLoading() && this.props.expandable && this.state.needExpand && _react2.default.createElement(
          'div',
          { className: 'show-more' },
          _react2.default.createElement(
            'a',
            { onClick: this.handleOnMore },
            _react2.default.createElement(_semanticUiReact.Icon, {
              name: this.state.isExpanded ? 'chevron up' : 'chevron down'
            }),
            this.state.isExpanded ? 'Collapse' : 'Show more'
          )
        )
      );
    }
  }]);

  return ContentPlaceholder;
}(_react.Component);

ContentPlaceholder.propTypes = {
  header: _propTypes2.default.bool,
  subheader: _propTypes2.default.bool,
  paragraphs: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number]),
  loading: _propTypes2.default.bool,
  content: _propTypes2.default.node,
  children: _propTypes2.default.node,
  direction: _propTypes2.default.string,
  expandable: _propTypes2.default.bool,
  onMore: _propTypes2.default.func,
  isExpanded: _propTypes2.default.bool
};
exports.default = ContentPlaceholder;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Countdown = function (_Component) {
  _inherits(Countdown, _Component);

  function Countdown(props) {
    _classCallCheck(this, Countdown);

    var _this = _possibleConstructorReturn(this, (Countdown.__proto__ || Object.getPrototypeOf(Countdown)).call(this, props));

    _this.timerStart = function () {
      _this.timer = setInterval(function () {
        var time = _this.state.time;

        if (time <= 0) {
          _this.clearTimer();
          _this.stopTimer();
        } else {
          _this.setState({ time: time - 1 });
        }
      }, 1000);
    };

    _this.timer = null;
    _this.state = {
      startTime: props.time || 0,
      time: props.time || 0
    };
    return _this;
  }

  _createClass(Countdown, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearTimer();
    }
  }, {
    key: 'stopTimer',
    value: function stopTimer() {
      if (this.props.onComplete) {
        this.props.onComplete();
      }
    }
  }, {
    key: 'startTimer',
    value: function startTimer(newTime) {
      var _this2 = this;

      this.clearTimer(); // clear previous timer
      if (this.props.onStart) {
        this.props.onStart();
      }
      if (newTime) {
        this.setState({ startTime: newTime, time: newTime }, function () {
          _this2.timerStart();
        });
      } else {
        this.timerStart();
      }
    }
  }, {
    key: 'clearTimer',
    value: function clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'span',
        { className: 'countdown' },
        this.props.message ? this.props.message(this.state.time, this.state.startTime) : this.state.time
      );
    }
  }]);

  return Countdown;
}(_react.Component);

Countdown.propTypes = {
  time: _propTypes2.default.number,
  onStart: _propTypes2.default.func,
  onComplete: _propTypes2.default.func,
  message: _propTypes2.default.func
};

exports.default = Countdown;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _webValidations = __webpack_require__(23);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _currencies = __webpack_require__(2221);

var _currencies2 = _interopRequireDefault(_currencies);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Currencies = function (_Component) {
  _inherits(Currencies, _Component);

  function Currencies(props) {
    _classCallCheck(this, Currencies);

    var _this = _possibleConstructorReturn(this, (Currencies.__proto__ || Object.getPrototypeOf(Currencies)).call(this, props));

    _initialiseProps.call(_this);

    var state = _this.getPropsToState(props);
    _this.validationForEdit = {
      conversionRatePoint: (0, _react.createRef)()
    };
    _this.validationForCreate = {
      newCode: (0, _react.createRef)(),
      newConversionRate: (0, _react.createRef)()
    };
    _this.state = _extends({
      dataToBeDelete: {},
      isEditing: false,
      isNew: false,
      showDeleteConfirm: false
    }, state);
    return _this;
  }

  _createClass(Currencies, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = this.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'convertRateToDecimal',
    value: function convertRateToDecimal(rate) {
      return rate / 1000;
    }
  }, {
    key: 'isShowFirstCurrencyMsg',
    value: function isShowFirstCurrencyMsg() {
      return this.state.data.length === 0 && this.state.isNew;
    }
  }, {
    key: 'isDeletable',
    value: function isDeletable(value) {
      var isDefault = value.isDefault,
          code = value.code;
      var allowSwitchingDefault = this.state.allowSwitchingDefault;
      var companyDefaultCurrency = this.props.companyDefaultCurrency;

      return !isDefault && allowSwitchingDefault && code !== companyDefaultCurrency;
    }
  }, {
    key: 'renderActionsColumn',
    value: function renderActionsColumn(isEdit, isEditing, index, value) {
      var _this2 = this;

      var _props = this.props,
          isForeignCompany = _props.isForeignCompany,
          t = _props.t;
      // To render actions button according to the edit state of the rows
      // If is editing, only show button for the row that is being edited and hide buttons on other rows
      // If not editing, show button for edit and delete for all rows
      // Delete button is not available for default currency

      var toSaveAction = _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_semanticUiReact.Popup, {
          trigger: _react2.default.createElement(
            _semanticUiReact.Button,
            {
              positive: true,
              className: 'ui compact icon primary button',
              onClick: function onClick(e) {
                return _this2.onSave(index, e);
              }
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'save' })
          ), content: t('Save', { ns: _translation.TRANSLATION_FILES.translation })
        }),
        _react2.default.createElement(_semanticUiReact.Popup, {
          trigger: _react2.default.createElement(
            _semanticUiReact.Button,
            {
              negative: true,
              className: 'ui compact icon primary button',
              onClick: function onClick(e) {
                return _this2.handleEditChange(index, e, { value: false, name: 'isEdit' });
              }
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'close' })
          ), content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation })
        })
      );

      var toEditAction = _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_semanticUiReact.Popup, {
          trigger: _react2.default.createElement(
            _semanticUiReact.Button,
            {
              className: 'ui compact icon primary button',
              disabled: isForeignCompany,
              onClick: function onClick(e) {
                return _this2.handleEditChange(index, e, { value: true, name: 'isEdit' });
              }
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'edit' })
          ), content: t('Edit', { ns: _translation.TRANSLATION_FILES.translation })
        }),
        this.isDeletable(value) ? _react2.default.createElement(_semanticUiReact.Popup, {
          trigger: _react2.default.createElement(
            _semanticUiReact.Button,
            {
              negative: true,
              className: 'ui compact icon primary button',
              onClick: function onClick(e) {
                return _this2.onClickDelete(index, e, value);
              }
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'trash' })
          ), content: t('Delete', { ns: _translation.TRANSLATION_FILES.translation })
        }) : null
      );

      if (isEditing) {
        if (isEdit) {
          return toSaveAction;
        }
      } else {
        return toEditAction;
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          isForeignCompany = _props2.isForeignCompany,
          t = _props2.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_DeleteConfirm2.default, {
          open: this.state.showDeleteConfirm,
          onClose: this.handleCancelDelete,
          onConfirm: this.handleConfirmDelete,
          name: this.state.dataToBeDelete && this.state.dataToBeDelete.name || t('Currency')
        }),
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 20 },
            active: this.state.loading && this.state.data.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _AppForm2.default,
          {
            onSubmit: this.handleSubmit,
            ref: function ref(_ref) {
              _this3.form = _ref;
            },
            as: 'div'
          },
          _react2.default.createElement(
            _semanticUiReact.Table,
            {
              striped: true,
              selectable: true,
              padded: true
            },
            _react2.default.createElement(
              _semanticUiReact.Table.Header,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  { colSpan: 5, textAlign: 'left' },
                  _react2.default.createElement(_semanticUiReact.Button, {
                    disabled: isForeignCompany,
                    primary: true,
                    size: 'small',
                    icon: 'add',
                    content: t('Add', { ns: _translation.TRANSLATION_FILES.translation }),
                    onClick: this.onClickAdd
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  null,
                  t('Currency')
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  null,
                  t('Code')
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  null,
                  t('Rate')
                ),
                _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null),
                _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null)
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Body,
              null,
              this.state.data.length > 0 ? this.state.data.map(function (value, index) {
                return _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  { key: index },
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    value.name
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    value.code
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    value.isEdit ? _react2.default.createElement(_AppForm2.default.Input, {
                      hideMessage: true,
                      validateLabel: value.name + ' ' + t('Conversion rate').toLowerCase(),
                      name: 'conversionRatePoint',
                      value: value.conversionRatePoint,
                      onChange: function onChange(e, data) {
                        var d = data;
                        d.name = 'conversionRatePoint';
                        return _this3.handleEditChange(index, e, d);
                      },
                      ref: _this3.validationForEdit.conversionRatePoint,
                      validation: [_webValidations.required, {
                        validate: _webValidations.numericRange,
                        option: {
                          min: 0.1
                        }
                      }],
                      type: 'number'
                    }) : value.conversionRatePoint
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    { textAlign: 'right' },
                    value.isDefault ? _react2.default.createElement(
                      _semanticUiReact.Label,
                      { color: 'blue', basic: true, horizontal: true },
                      t('Default')
                    ) : null,
                    !value.isDefault && _this3.state.allowSwitchingDefault ? _react2.default.createElement(
                      _semanticUiReact.Button,
                      {
                        value: value,
                        primary: true,
                        compact: true,
                        size: 'tiny',
                        onClick: _this3.handleMakeDefault
                      },
                      t('Make Default')
                    ) : null
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    _this3.renderActionsColumn(value.isEdit, _this3.state.isEditing, index, value)
                  )
                );
              }) : _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { colSpan: 5, textAlign: 'center' },
                  this.state.loading ? _react2.default.createElement(
                    _semanticUiReact.Loader,
                    { active: true, inline: 'centered' },
                    t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                  ) : t('No currency found') + '.'
                )
              )
            ),
            this.state.isNew ? _react2.default.createElement(
              _semanticUiReact.Table.Body,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                { active: true },
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  _react2.default.createElement(
                    _AppForm2.default.Validate,
                    {
                      hideMessage: true,
                      validation: [_webValidations.required],
                      validateLabel: t('Currency'),
                      ref: this.validationForCreate.newCode,
                      onChange: this.handleSelectChange
                    },
                    _react2.default.createElement(_semanticUiReact.Form.Select, {
                      text: this.state.selectedCurrency ? null : t('Select Currency'),
                      autoComplete: 'off',
                      fluid: true,
                      name: 'selectedCurrency',
                      options: this.state.currencyOptions,
                      search: true,
                      selectOnBlur: false,
                      value: this.state.selectedCurrency,
                      onChange: this.handleSelectChange
                    })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  this.state.newCode
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  _react2.default.createElement(_AppForm2.default.Input, {
                    hideMessage: true,
                    validateLabel: t('Conversion rate'),
                    name: 'newConversionRate',
                    value: this.state.newConversionRate,
                    onChange: this.handleInputChange,
                    ref: this.validationForCreate.newConversionRate,
                    validation: [_webValidations.required, {
                      validate: _webValidations.numericRange,
                      option: {
                        min: 0.1
                      }
                    }],
                    type: 'number'
                  })
                ),
                _react2.default.createElement(_semanticUiReact.Table.Cell, null),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  _react2.default.createElement(_semanticUiReact.Popup, {
                    trigger: _react2.default.createElement(
                      _semanticUiReact.Button,
                      {
                        positive: true,
                        className: 'ui compact icon primary button',
                        onClick: this.onCreate
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus' })
                    ), content: t('Create', { ns: _translation.TRANSLATION_FILES.translation })
                  }),
                  _react2.default.createElement(_semanticUiReact.Popup, {
                    trigger: _react2.default.createElement(
                      _semanticUiReact.Button,
                      {
                        negative: true,
                        className: 'ui compact icon primary button',
                        onClick: this.onCancelCreate
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'close' })
                    ), content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation })
                  })
                )
              )
            ) : null,
            this.isShowFirstCurrencyMsg() ? _react2.default.createElement(
              _semanticUiReact.Table.Body,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { colSpan: 5, textAlign: 'center' },
                  t('The first currency you set will be the base currency'),
                  this.state.allowSwitchingDefault ? '.' : ' ' + t('and cannot be edited once saved') + '.'
                )
              )
            ) : null
          )
        )
      );
    }
  }]);

  return Currencies;
}(_react.Component);

Currencies.propTypes = {
  allowSwitchingDefault: _propTypes2.default.bool,
  companyDefaultCurrency: _propTypes2.default.string.isRequired,
  isForeignCompany: _propTypes2.default.bool,
  currenciesProvided: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  data: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  loading: _propTypes2.default.bool,
  onDefaultAdd: _propTypes2.default.func.isRequired,
  onDefaultDelete: _propTypes2.default.func.isRequired,
  onDefaultMakeDefault: _propTypes2.default.func,
  onDefaultSave: _propTypes2.default.func.isRequired
};
Currencies.defaultCurrency = {
  selectedCurrency: null,
  newName: null,
  newCode: '',
  newConversionRate: '',
  isEditing: false
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.filterCurrencies = function () {
    var existingCurrencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var currencies = _currencies2.default;
    if (_this4.props.currenciesProvided) currencies = _this4.props.currenciesProvided;
    // Remove currency option that is already in existingCurrencies
    var filtered = currencies.filter(function (c) {
      return existingCurrencies.every(function (e) {
        return e.code !== c.value;
      });
    });
    return filtered;
  };

  this.getPropsToState = function (props) {
    var allowSwitchingDefault = props.allowSwitchingDefault;
    var data = _this4.transformData(props.data);
    var loading = props.loading;
    var currencyOptions = _this4.filterCurrencies(data);

    return _extends({
      allowSwitchingDefault: allowSwitchingDefault,
      currencyOptions: currencyOptions,
      data: data,
      loading: loading
    }, Currencies.defaultCurrency);
  };

  this.handleCancelDelete = function (e) {
    // Handler for confirmation dialog
    e.preventDefault();
    _this4.setState({
      showDeleteConfirm: false
    });
  };

  this.handleConfirmDelete = function (e) {
    // Handler for confirmation dialog
    e.preventDefault();
    _this4.setState({
      showDeleteConfirm: false
    }, function () {
      _this4.onDelete(_this4.state.dataToBeDelete);
    });
  };

  this.handleEditChange = function (index, event, _ref2) {
    var value = _ref2.value,
        name = _ref2.name;

    event.preventDefault();
    var extraState = {};
    if (name === 'isEdit') {
      // toggle isEditing flag to allow only one edit at a time
      extraState.isEditing = !_this4.state.isEditing;
    }

    var data = _this4.state.data;

    data[index] = Object.assign({}, data[index], _defineProperty({}, name, value));
    _this4.setState(_extends({
      data: data
    }, extraState));
  };

  this.handleInputChange = function (e, d) {
    _this4.setState(_defineProperty({}, d.name, d.value));
  };

  this.handleMakeDefault = function (e, d) {
    e.preventDefault();
    _this4.props.onDefaultMakeDefault(null, { value: d.value });
  };

  this.handleSelectChange = function (e, d) {
    // value is the code of the currency
    var selected = _currencies2.default.find(function (val) {
      return val.value === d.value;
    });
    _this4.setState({
      newCode: selected.value,
      newName: selected.text,
      selectedCurrency: selected.value
    });
  };

  this.handleSubmit = function (e) {
    e.preventDefault();
  };

  this.onClickAdd = function (e) {
    e.preventDefault();
    _this4.setState({ isNew: true });
  };

  this.onClickDelete = function (index, e, data) {
    e.preventDefault();
    _this4.setState({
      dataToBeDelete: _extends({
        index: index
      }, data),
      showDeleteConfirm: true
    });
  };

  this.onCancelCreate = function (e) {
    e.preventDefault();
    _this4.setState({
      isNew: false
    });
  };

  this.onCreate = function (e) {
    e.preventDefault();
    return _AppForm2.default.validate(_this4.validationForCreate, _this4.state).then(function (validations) {
      var value = {
        name: _this4.state.newName,
        code: _this4.state.newCode,
        conversionRatePoint: _this4.state.newConversionRate * 1000,
        isDefault: _this4.state.data.length === 0
      };
      _this4.props.onDefaultAdd(validations, { value: value });
    });
  };

  this.onDelete = function () {
    var dataToBeDelete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _this4.props.onDefaultDelete(null, { value: dataToBeDelete });
  };

  this.onSave = function (index, e) {
    e.preventDefault();
    var newData = _this4.state.data[index];
    var value = {
      code: newData.code,
      conversionRatePoint: newData.conversionRatePoint * 1000,
      id: newData.id,
      isDefault: newData.isDefault,
      index: index
    };
    return _AppForm2.default.validate(_this4.validationForEdit, value).then(function (validations) {
      _this4.props.onDefaultSave(validations, { value: value });
    });
  };

  this.transformData = function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    // Transform data prior to being rendered
    // Adds decimal point to conversionRatePoint of integer type
    // Adds isEdit flag to indicate if it is being edited
    var result = data.map(function (d) {
      var dataToBeTransformed = {
        isEdit: false,
        conversionRatePoint: _this4.convertRateToDecimal(d.conversionRatePoint)
      };
      var currency = Object.assign({}, d, dataToBeTransformed);
      return currency;
    });
    return result;
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(Currencies);

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint no-prototype-builtins: 0 */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(9);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _reactSortableHoc = __webpack_require__(123);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _defaultBookingFields = __webpack_require__(391);

var _hims = __webpack_require__(221);

var _virtualAccount = __webpack_require__(393);

var _translation = __webpack_require__(4);

var _RegexDropdownPicker = __webpack_require__(387);

var _RegexDropdownPicker2 = _interopRequireDefault(_RegexDropdownPicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getFieldTypeLabels = function getFieldTypeLabels(type) {
  var isDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var defaultOpts = [{ value: 'dropdown', text: 'Dropdown Single' }, { value: 'dropdown_multi', text: 'Dropdown Multiple' }, { value: 'input', text: 'Single Line Text' }, { value: 'textarea', text: 'Multi Line Text' }];
  if (type === 'unit') {
    if (isDefault) {
      return defaultOpts.filter(function (o) {
        return !o.value.includes('dropdown_multi');
      });
    }
    return defaultOpts.filter(function (o) {
      return !o.value.includes('dropdown');
    });
  }
  return defaultOpts;
};

var sortItems = [{ name: 'alphabetically', text: 'Reorder Alphabetically' }, { name: 'newest', text: 'Reorder By Newest' }, { name: 'oldest', text: 'Reorder By Oldest' }];

var DragHandle = (0, _reactSortableHoc.SortableHandle)(function () {
  return _react2.default.createElement(_semanticUiReact.Icon, { size: 'large', disabled: true, name: 'content', className: 'DragHandleIcon' });
});

var SortableOptionItem = (0, _reactSortableHoc.SortableElement)(function (_ref) {
  var data = _ref.data,
      idx = _ref.idx,
      _onChange = _ref.onChange,
      onEdit = _ref.onEdit,
      t = _ref.t;
  return _react2.default.createElement(
    _semanticUiReact.Grid,
    { className: 'item' },
    _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { verticalAlign: 'middle', textAlign: 'center' },
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { mobile: 3, tablet: 2, computer: 2 },
        data.isEditing ? '' : _react2.default.createElement(DragHandle, null)
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { mobile: 10, tablet: 12, computer: 12 },
        _react2.default.createElement(
          'b',
          null,
          data.title
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { mobile: 3, tablet: 2, computer: 2, textAlign: 'right' },
        _react2.default.createElement(
          'button',
          {
            className: 'a-button-gray',
            onClick: function onClick(e) {
              return onEdit(e, idx);
            }
          },
          _react2.default.createElement(_semanticUiReact.Icon, {
            name: data.isEditing ? 'x' : 'edit',
            size: 'large',
            color: 'grey'
          })
        )
      )
    ),
    data.isEditing ? _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { verticalAlign: 'middle', className: 'EditArea' },
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 16 },
        _react2.default.createElement(
          _semanticUiReact.Form,
          null,
          _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal' },
            _react2.default.createElement(_semanticUiReact.Form.Input, {
              fluid: true,
              name: 'title',
              label: t('Choice Name') + ' (' + t('Required').toLowerCase() + ')',
              placeholder: t('Choice Name') + '*',
              value: data.title,
              onChange: function onChange(e, d) {
                return _onChange(e, d, idx);
              }
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal' },
            _react2.default.createElement(_semanticUiReact.Form.Input, {
              fluid: true,
              name: 'value',
              label: t('Choice Value') + ' (' + t('Required').toLowerCase() + ')',
              placeholder: t('Choice Value') + '*',
              value: data.value,
              onChange: function onChange(e, d) {
                return _onChange(e, d, idx);
              }
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal' },
            _react2.default.createElement(
              _semanticUiReact.Form.Field,
              null,
              _react2.default.createElement(
                'label',
                { htmlFor: 'dataValue' },
                t('Data (JSON Format)')
              ),
              _react2.default.createElement(
                'div',
                { className: 'ui fluid input' },
                _react2.default.createElement('textarea', {
                  classID: 'dataValue',
                  name: 'dataValue',
                  className: 'semantic-textbox',
                  style: { minHeight: '6em', maxHeight: '40vh', width: '100%' },
                  value: data.dataValue,
                  onChange: function onChange(e, d) {
                    return _onChange(e, d, idx);
                  }
                })
              )
            )
          ),
          data.id !== '' && _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal' },
            _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
              label: t('Delete', { ns: _translation.TRANSLATION_FILES.translation }) + ' (' + t('erases this {{field}}', { field: t('Option').toLowerCase() }) + ')',
              name: 'isDeleted',
              checked: data.isDeleted,
              onChange: function onChange(e, d) {
                return _onChange(e, d, idx);
              }
            })
          )
        )
      )
    ) : ''
  );
});

var SortableOptionList = (0, _reactSortableHoc.SortableContainer)(function (_ref2) {
  var addDisabled = _ref2.addDisabled,
      fieldID = _ref2.fieldID,
      items = _ref2.items,
      onAdd = _ref2.onAdd,
      onChange = _ref2.onChange,
      onEdit = _ref2.onEdit,
      t = _ref2.t;
  return _react2.default.createElement(
    'div',
    { className: 'contain' },
    items.map(function (data, index) {
      return _react2.default.createElement(SortableOptionItem, {
        data: data,
        fieldID: fieldID,
        idx: index,
        index: index,
        key: 'item-' + index,
        onChange: onChange,
        onEdit: onEdit,
        t: t
      });
    }),
    _react2.default.createElement(
      _semanticUiReact.Grid,
      { className: 'foot' },
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { verticalAlign: 'middle' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { textAlign: 'center' },
          _react2.default.createElement(AddOptionButton, {
            isDisabled: addDisabled,
            onClick: onAdd,
            t: t
          })
        )
      )
    )
  );
});

var AddOptionButton = function AddOptionButton(_ref3) {
  var isDisabled = _ref3.isDisabled,
      onClick = _ref3.onClick,
      t = _ref3.t;
  return _react2.default.createElement(
    _semanticUiReact.Button.Group,
    { fluid: true },
    _react2.default.createElement(
      _semanticUiReact.Button,
      {
        disabled: isDisabled,
        onClick: onClick,
        style: { width: '65%' }
      },
      t('Add Choice')
    )
  );
};
AddOptionButton.propTypes = {
  isDisabled: _propTypes2.default.bool,
  onClick: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func
};

var CustomFieldOptionModal = function CustomFieldOptionModal(_ref4) {
  var addDisabled = _ref4.addDisabled,
      data = _ref4.data,
      onAdd = _ref4.onAdd,
      onChange = _ref4.onChange,
      onEdit = _ref4.onEdit,
      onSave = _ref4.onSave,
      onCancel = _ref4.onCancel,
      onSortEnd = _ref4.onSortEnd,
      open = _ref4.open,
      saveDisabled = _ref4.saveDisabled,
      t = _ref4.t;
  return _react2.default.createElement(
    _semanticUiReact.Modal,
    { open: open },
    _react2.default.createElement(
      _semanticUiReact.Modal.Header,
      null,
      'Dropdown Choices',
      _react2.default.createElement(
        _semanticUiReact.Button,
        { onClick: onCancel, floated: 'right', color: 'grey' },
        'Cancel'
      ),
      _react2.default.createElement(
        _semanticUiReact.Button,
        { onClick: onSave, floated: 'right', primary: true, disabled: saveDisabled },
        'Proceed'
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Modal.Content,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid,
        { className: 'PBCFOSetup' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(SortableOptionList, {
              addDisabled: addDisabled,
              helperClass: 'PBCFOSetup isSorting',
              items: data,
              lockAxis: 'y',
              lockToContainerEdges: true,
              onAdd: onAdd,
              onChange: onChange,
              onEdit: onEdit,
              onSortEnd: onSortEnd,
              useDragHandle: true,
              t: t
            })
          )
        )
      )
    )
  );
};
CustomFieldOptionModal.propTypes = {
  addDisabled: _propTypes2.default.bool,
  data: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  onAdd: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onEdit: _propTypes2.default.func,
  onSave: _propTypes2.default.func,
  onCancel: _propTypes2.default.func,
  onSortEnd: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  saveDisabled: _propTypes2.default.bool,
  t: _propTypes2.default.func
};

var SortableFieldItem = (0, _reactSortableHoc.SortableElement)(function (_ref5) {
  var data = _ref5.data,
      idx = _ref5.idx,
      _onChange2 = _ref5.onChange,
      onClickName = _ref5.onClickName,
      onClickOptions = _ref5.onClickOptions,
      onEdit = _ref5.onEdit,
      type = _ref5.type,
      t = _ref5.t;

  var fieldLabel = getFieldTypeLabels(type, data.isDefault).find(function (d) {
    return d.value === data.type;
  });
  var fieldOptions = [{
    text: t('Disabled', { ns: _translation.TRANSLATION_FILES.constants }),
    value: ''
  }];
  if (type === 'unit' && (data.type === 'dropdown' || data.type === 'dropdown_multi') && data.projectUnitCustomFieldSettingOptions && data.projectUnitCustomFieldSettingOptions.length > 0) {
    data.projectUnitCustomFieldSettingOptions.sort(function (a, b) {
      return a.position - b.position;
    }).forEach(function (d) {
      if (d.title !== '' && d.value !== '') {
        fieldOptions.push({ text: d.title, value: d.value, id: d.id });
      }
    });
  }
  if (type === 'booking' && (data.type === 'dropdown' || data.type === 'dropdown_multi') && data.projectBookingCustomFieldOptions && data.projectBookingCustomFieldOptions.length > 0) {
    data.projectBookingCustomFieldOptions.sort(function (a, b) {
      return a.position - b.position;
    }).forEach(function (d) {
      if (d.title !== '' && d.value !== '') {
        fieldOptions.push({ text: d.title, value: d.value, id: d.id });
      }
    });
  }
  if (data.type === 'dropdown_multi') {
    fieldOptions = fieldOptions.filter(function (f) {
      return f.value !== '';
    });
  }
  var previewOptions = fieldOptions.filter(function (f) {
    return f.value !== '';
  });
  var renderLabel = function renderLabel(label) {
    return {
      content: label && label.text ? label.text : '',
      circular: true
    };
  };
  var renderErrorMessage = function renderErrorMessage() {
    return _react2.default.createElement(
      'div',
      { style: { color: 'red', fontSize: '14px', marginTop: '0.4em' } },
      data.errorMessage
    );
  };
  return _react2.default.createElement(
    _semanticUiReact.Grid,
    { className: 'item' },
    _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { verticalAlign: 'middle', textAlign: 'center' },
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { mobile: 3, tablet: 2, computer: 2 },
        data.isEditing ? '' : _react2.default.createElement(DragHandle, null)
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { mobile: 10, tablet: 12, computer: 12 },
        _react2.default.createElement(
          'span',
          { style: type === 'booking' && data.isDeleted || type === 'unit' && data.isHidden ? { textDecoration: 'line-through' } : {} },
          data.isEditing && !data.isDefault ? _react2.default.createElement(
            'button',
            { onClick: function onClick(e) {
                return onClickName(e, idx);
              }, className: 'a-button-blue' },
            data.label
          ) : data.isDefault ? t(data.label, { ns: _translation.TRANSLATION_FILES.screens }) : data.label,
          ' ',
          _react2.default.createElement(
            'small',
            null,
            '(',
            fieldLabel ? t(fieldLabel.text, { ns: _translation.TRANSLATION_FILES.constants }) : '',
            ')'
          )
        ),
        data.isEditing && data.showName ? _react2.default.createElement(_semanticUiReact.Form.Input, {
          name: 'name',
          placeholder: t('Name') + '*',
          value: data.name,
          onChange: function onChange(e, d) {
            return _onChange2(e, d, idx);
          },
          size: 'mini'
        }) : ''
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { mobile: 3, tablet: 2, computer: 2, textAlign: 'right' },
        _react2.default.createElement(
          'button',
          {
            className: 'a-button-gray',
            onClick: function onClick(e) {
              return onEdit(e, idx);
            }
          },
          _react2.default.createElement(_semanticUiReact.Icon, {
            name: data.isEditing ? 'x' : 'edit',
            size: 'large',
            color: 'grey'
          })
        )
      )
    ),
    data.isEditing ? _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { verticalAlign: 'middle', className: 'EditArea' },
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 16 },
        _react2.default.createElement(
          _semanticUiReact.Form.Group,
          { widths: 'equal' },
          _react2.default.createElement(_semanticUiReact.Form.Select, {
            fluid: true,
            name: 'type',
            label: t('Field Type') + ' (' + t('Required').toLowerCase() + ')',
            value: data.type,
            options: getFieldTypeLabels(type, data.isDefault).map(function (l) {
              return _extends({}, l, {
                text: t(l.text, { ns: _translation.TRANSLATION_FILES.constants })
              });
            }),
            onChange: function onChange(e, d) {
              return _onChange2(e, d, idx);
            },
            disabled: data.isDefault
          }),
          _react2.default.createElement(_semanticUiReact.Form.Input, {
            fluid: true,
            name: 'label',
            label: t('Field Label') + ' (' + t('Required').toLowerCase() + ')',
            placeholder: t('Field Label') + '*',
            value: data.label,
            onChange: function onChange(e, d) {
              return _onChange2(e, d, idx);
            },
            disabled: data.name === 'email' && data.isDefault
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Form.Group,
          { widths: 'equal' },
          _react2.default.createElement(_semanticUiReact.Form.Input, {
            fluid: true,
            name: 'placeholder',
            label: t('Placeholder Text'),
            placeholder: t('Placeholder Text'),
            value: data.placeholder,
            onChange: function onChange(e, d) {
              return _onChange2(e, d, idx);
            },
            disabled: data.name === 'email' && data.isDefault
          }),
          data.type === 'dropdown' || data.type === 'dropdown_multi' ? _react2.default.createElement(_semanticUiReact.Form.Select, {
            fluid: true,
            name: 'defaultValue',
            label: t('Default Value'),
            placeholder: t('Disabled', { ns: _translation.TRANSLATION_FILES.constants }),
            multiple: data.type === 'dropdown_multi',
            value: data.type === 'dropdown_multi' && !_lodash2.default.isArray(data.defaultValue) ? data.defaultValue.split(',') : data.defaultValue,
            options: fieldOptions,
            onChange: function onChange(e, d) {
              return _onChange2(e, d, idx);
            },
            renderLabel: renderLabel
          }) : _react2.default.createElement(_semanticUiReact.Form.Input, {
            fluid: true,
            name: 'defaultValue',
            label: t('Default Value'),
            placeholder: t('Default Value'),
            value: data.defaultValue,
            onChange: function onChange(e, d) {
              return _onChange2(e, d, idx);
            },
            disabled: data.name === 'email' && data.isDefault
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Form.Group,
          { widths: 'equal' },
          _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
            label: t('Required'),
            name: 'isRequired',
            checked: data.isRequired,
            onChange: function onChange(e, d) {
              return _onChange2(e, d, idx);
            },
            disabled: type === 'unit' && data.isDefault
          }),
          !data.isDefault && _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
            label: t('Lock / Disabled'),
            name: 'isDisabled',
            checked: data.isDisabled,
            onChange: function onChange(e, d) {
              return _onChange2(e, d, idx);
            }
          }),
          type === 'booking' && data.id !== '' && !data.isDefault && _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
            label: t('Delete', { ns: _translation.TRANSLATION_FILES.translation }) + ' (' + t('erases this {{field}}', { field: t('Field').toLowerCase() }) + ')',
            name: 'isDeleted',
            checked: data.isDeleted,
            onChange: function onChange(e, d) {
              return _onChange2(e, d, idx);
            }
          }),
          (type === 'booking' && data.isDefault || type === 'unit' && data.id !== '') && _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
            label: t('Hide'),
            name: 'isHidden',
            checked: data.isHidden,
            onChange: function onChange(e, d) {
              return _onChange2(e, d, idx);
            },
            disabled: data.name === 'email' || type === 'unit' && data.isDefault
          })
        ),
        type === 'booking' && data.isRequired && !data.isDefault && _react2.default.createElement(
          _semanticUiReact.Form.Group,
          null,
          _react2.default.createElement(
            _semanticUiReact.Form.Field,
            { width: 8 },
            _react2.default.createElement(
              'label',
              null,
              t('Required at status')
            ),
            _react2.default.createElement(
              'div',
              { style: { fontSize: '12px', color: '#777', marginBottom: '5px' } },
              t('Field becomes required once the unit reaches the status')
            ),
            _react2.default.createElement(_semanticUiReact.Form.Select, {
              fluid: true,
              name: 'requiredAtStatus',
              placeholder: t('Select status'),
              value: data.requiredAtStatus || 'reserved',
              options: [{ text: t('Reserved'), value: 'reserved' }, { text: t('Booked'), value: 'booked' }, { text: t('Sold'), value: 'sold_spa_signed' }],
              onChange: function onChange(e, d) {
                return _onChange2(e, d, idx);
              }
            })
          )
        )
      ),
      !data.isDefault && (data.type === 'dropdown' || data.type === 'dropdown_multi') ? _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 16, textAlign: 'center' },
        _react2.default.createElement(
          _semanticUiReact.Button,
          { onClick: function onClick(e) {
              return onClickOptions(e, idx);
            } },
          t('Dropdown Choices')
        )
      ) : '',
      type === 'booking' && data.type === 'input' && _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 16, textAlign: 'left' },
        _react2.default.createElement(_RegexDropdownPicker2.default, {
          formatValue: data.formatName,
          regexValue: data.regex,
          onChange: function onChange(e, d) {
            return _onChange2(e, d, idx);
          }
        })
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 16 },
        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { tertiary: true },
          _react2.default.createElement(
            'center',
            null,
            _react2.default.createElement(
              'h3',
              null,
              t('Live Preview')
            )
          ),
          data.type === 'textarea' && _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal' },
            _react2.default.createElement(_semanticUiReact.Form.TextArea, {
              autoComplete: 'off',
              disabled: data.isDisabled,
              label: '' + (data.isDefault ? t(data.label, { ns: _translation.TRANSLATION_FILES.screens }) : data.label) + (data.isRequired ? '*' : ''),
              name: data.name,
              placeholder: data.placeholder,
              value: data.defaultValue,
              style: { minHeight: '6em', height: '6em' }
            })
          ),
          data.type === 'input' && _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal' },
            _react2.default.createElement(_semanticUiReact.Form.Input, {
              autoComplete: 'off',
              disabled: data.isDisabled,
              label: '' + (data.isDefault ? t(data.label, { ns: _translation.TRANSLATION_FILES.screens }) : data.label) + (data.isRequired ? '*' : ''),
              name: data.name,
              placeholder: data.placeholder,
              value: data.defaultValue,
              error: !!data.errorMessage && renderErrorMessage
            })
          ),
          (data.type === 'dropdown' || data.type === 'dropdown_multi') && _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal' },
            _react2.default.createElement(_semanticUiReact.Form.Select, {
              className: 'custom_dropdown',
              disabled: data.isDisabled,
              label: '' + (data.isDefault ? t(data.label, { ns: _translation.TRANSLATION_FILES.screens }) : data.label) + (data.isRequired ? '*' : ''),
              name: data.name,
              options: previewOptions,
              placeholder: data.placeholder,
              search: true,
              selectOnBlur: false,
              value: data.type === 'dropdown_multi' && !_lodash2.default.isArray(data.defaultValue) ? data.defaultValue.split(',') : data.defaultValue,
              multiple: data.type === 'dropdown_multi',
              renderLabel: renderLabel
            })
          )
        )
      )
    ) : ''
  );
});

var SortableFieldList = (0, _reactSortableHoc.SortableContainer)(function (_ref6) {
  var addDisabled = _ref6.addDisabled,
      items = _ref6.items,
      onAdd = _ref6.onAdd,
      onAddChange = _ref6.onAddChange,
      onChange = _ref6.onChange,
      onClickOptions = _ref6.onClickOptions,
      onClickName = _ref6.onClickName,
      onEdit = _ref6.onEdit,
      _ref6$isDefault = _ref6.isDefault,
      isDefault = _ref6$isDefault === undefined ? false : _ref6$isDefault,
      type = _ref6.type,
      t = _ref6.t,
      _ref6$startIndex = _ref6.startIndex,
      startIndex = _ref6$startIndex === undefined ? 0 : _ref6$startIndex;
  return _react2.default.createElement(
    'div',
    { className: 'contain' },
    items.map(function (data, idx) {
      var index = idx + startIndex;
      return _react2.default.createElement(SortableFieldItem, {
        data: data,
        idx: index,
        index: index,
        key: 'item-' + index,
        onChange: onChange,
        onEdit: onEdit,
        onClickOptions: onClickOptions,
        onClickName: onClickName,
        type: type,
        t: t
      });
    }),
    !isDefault && _react2.default.createElement(
      _semanticUiReact.Grid,
      { className: 'foot' },
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { verticalAlign: 'middle' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { textAlign: 'center' },
          _react2.default.createElement(AddFieldButton, {
            isDisabled: addDisabled,
            onChange: onAddChange,
            onClick: onAdd,
            type: type,
            t: t
          })
        )
      )
    )
  );
});

var AddFieldButton = function AddFieldButton(_ref7) {
  var isDisabled = _ref7.isDisabled,
      onChange = _ref7.onChange,
      onClick = _ref7.onClick,
      type = _ref7.type,
      t = _ref7.t;
  return _react2.default.createElement(
    _semanticUiReact.Button.Group,
    { fluid: true },
    _react2.default.createElement(_semanticUiReact.Dropdown, {
      button: true,
      className: 'icon teal',
      defaultValue: 'input',
      disabled: isDisabled,
      onChange: onChange,
      options: getFieldTypeLabels(type).map(function (l) {
        return _extends({}, l, {
          text: t(l.text, { ns: _translation.TRANSLATION_FILES.constants })
        });
      }),
      noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
    }),
    _react2.default.createElement(
      _semanticUiReact.Button,
      {
        color: 'grey',
        disabled: isDisabled,
        onClick: onClick,
        style: { width: '65%' }
      },
      t('Add Field')
    )
  );
};
AddFieldButton.propTypes = {
  isDisabled: _propTypes2.default.bool,
  onChange: _propTypes2.default.func.isRequired,
  onClick: _propTypes2.default.func.isRequired,
  type: _propTypes2.default.string,
  t: _propTypes2.default.func
};

var CustomField = function (_Component) {
  _inherits(CustomField, _Component);

  function CustomField(props) {
    _classCallCheck(this, CustomField);

    var _this = _possibleConstructorReturn(this, (CustomField.__proto__ || Object.getPrototypeOf(CustomField)).call(this, props));

    _initialiseProps.call(_this);

    var state = CustomField.getPropsToState(props);
    _this.state = _extends({}, state, {
      optionFieldID: 0,
      optionModalIsOpen: false,
      addType: 'input',
      isDefault: false
    });
    return _this;
  }

  _createClass(CustomField, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = CustomField.getPropsToState(nextProps);
      if (JSON.stringify(this.state.data) !== JSON.stringify(state.data) || JSON.stringify(this.state.defaultData) !== JSON.stringify(state.defaultData)) {
        this.setState(_extends({}, state));
      }
    }
    // Options

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          type = _props.type,
          t = _props.t;
      var _state = this.state,
          data = _state.data,
          editingData = _state.editingData,
          optionFieldID = _state.optionFieldID,
          optionModalIsOpen = _state.optionModalIsOpen,
          defaultData = _state.defaultData;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { className: 'PBCFSetup' },
        type === 'booking' && _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(
              _semanticUiReact.Divider,
              { horizontal: true },
              t('Purchaser Default Fields (Fixed)')
            ),
            _react2.default.createElement(SortableFieldList, {
              addDisabled: this.checkAddButtonDisabled(),
              helperClass: 'PBCFSetup isSorting',
              items: this.getSortedData(defaultData).map(function (d) {
                return _extends({}, d);
              }),
              lockAxis: 'y',
              lockToContainerEdges: true,
              onChange: function onChange(e, d, i) {
                return _this2.handleOnChange(e, d, i, true);
              },
              onEdit: function onEdit(e, i) {
                return _this2.handleOnEdit(e, i, true);
              },
              onSortEnd: function onSortEnd(v) {
                return _this2.onSortEnd(v, true);
              },
              useDragHandle: true,
              isDefault: true,
              type: type,
              t: t
            })
          )
        ),
        type === 'unit' && this.renderUnitDefaultFields(),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(
              _semanticUiReact.Divider,
              { horizontal: true },
              t(type === 'booking' ? 'Custom Booking Fields' : 'Unit Custom Fields')
            ),
            _react2.default.createElement(CustomFieldOptionModal, {
              addDisabled: this.checkOptionAddButtonDisabled(),
              data: this.getSortedData(this.getOptionsData(editingData, optionFieldID)),
              onAdd: this.handleOptionsOnAdd,
              onChange: this.handleOptionsOnChange,
              onEdit: this.handleOptionsOnEdit,
              onSave: this.handleOptionsModalSave,
              onCancel: this.handleOptionsModalCancel,
              onSortEnd: this.onSortOptionsEnd,
              open: optionModalIsOpen,
              saveDisabled: this.checkOptionSaveButtonDisabled(),
              t: t
            }),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 16, textAlign: 'right' },
                  _react2.default.createElement(
                    _semanticUiReact.Menu,
                    {
                      text: true,
                      compact: true,
                      size: 'tiny',
                      secondary: true
                    },
                    sortItems.map(function (item, key) {
                      return _react2.default.createElement(
                        _semanticUiReact.Menu.Item,
                        {
                          key: key,
                          name: item.name,
                          onClick: _this2.handleOrderItems
                        },
                        t(item.text, { ns: _translation.TRANSLATION_FILES.translation })
                      );
                    })
                  )
                )
              )
            ),
            _react2.default.createElement(SortableFieldList, {
              addDisabled: this.checkAddButtonDisabled(),
              helperClass: 'PBCFSetup isSorting',
              items: this.getSortedData(data),
              lockAxis: 'y',
              lockToContainerEdges: true,
              onAdd: this.handleOnAdd,
              onAddChange: this.handleOnAddChange,
              onChange: this.handleOnChange,
              onClickOptions: this.handleOnClickOptions,
              onClickName: this.handleOnClickName,
              onEdit: this.handleOnEdit,
              onSortEnd: function onSortEnd(v) {
                return _this2.onSortEnd(v, false);
              },
              useDragHandle: true,
              type: type,
              t: t
            })
          )
        )
      );
    }
  }]);

  return CustomField;
}(_react.Component);

CustomField.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  onChangeData: _propTypes2.default.func,
  type: _propTypes2.default.string,
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      himsIsEnabled: _propTypes2.default.bool,
      settings: _propTypes2.default.shape({
        virtualAccountIsEnabled: _propTypes2.default.bool
      })
    })
  }),
  t: _propTypes2.default.func
};
CustomField.defaultBookingValues = {
  id: '',
  type: 'input',
  name: '',
  label: '',
  placeholder: '',
  defaultValue: '',
  className: '',
  style: '',
  isRequired: false,
  requiredAtStatus: 'reserved',
  isDisabled: false,
  isDeleted: false,
  isEditing: true,
  position: 1,
  projectBookingCustomFieldOptions: [],
  showName: false,
  isDefault: false,
  isHidden: false,
  formatName: 'none',
  regex: null,
  errorMessage: null
};
CustomField.defaultUnitValues = {
  id: '',
  type: 'input',
  name: '',
  label: '',
  placeholder: '',
  defaultValue: '',
  className: '',
  style: '',
  isRequired: false,
  isDisabled: false,
  isHidden: false,
  isEditing: true,
  position: 1,
  projectUnitCustomFieldSettingOptions: [],
  showName: false
};
CustomField.defaultBookingOptionValues = {
  id: '',
  projectBookingCustomFieldID: '',
  title: '',
  value: '',
  isDeleted: false,
  isEditing: true,
  dataValue: '',
  position: 1
};
CustomField.defaultUnitOptionValues = {
  id: '',
  projectUnitCustomFieldSettingID: '',
  title: '',
  value: '',
  isDeleted: false,
  isEditing: true,
  dataValue: '',
  position: 1
};

CustomField.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

CustomField.getPropsToState = function (props) {
  var data = props.data || [];
  data.forEach(function (d, idx) {
    if (!data[idx].hasOwnProperty('isEditing')) {
      data[idx].isEditing = false;
    }
    if (props.type === 'unit' && d.type === 'dropdown') {
      var newOptions = d.projectUnitCustomFieldSettingOptions;
      if (newOptions) {
        d.projectUnitCustomFieldSettingOptions.forEach(function (o, id) {
          if (!newOptions[id].hasOwnProperty('isEditing')) {
            newOptions[id].isEditing = false;
          }
        });
      }
      data[idx].projectBookingCustomFieldOptions = newOptions;
    } else if (d.type === 'dropdown') {
      var _newOptions = d.projectBookingCustomFieldOptions;
      if (_newOptions) {
        d.projectBookingCustomFieldOptions.forEach(function (o, id) {
          if (!_newOptions[id].hasOwnProperty('isEditing')) {
            _newOptions[id].isEditing = false;
          }
        });
      }
      data[idx].projectBookingCustomFieldOptions = _newOptions;
    }
  });
  var d = data.filter(function (c) {
    return !c.isDefault;
  });
  var defaultData = data.filter(function (c) {
    return c.isDefault;
  });
  if (props.type === 'booking') {
    if (defaultData.length === 0) {
      defaultData = _defaultBookingFields.DEFAULT_BOOKING_FIELD_LIST;
    }
    // check for new default booking field (email)
    var emailIdx = defaultData.findIndex(function (dd) {
      return dd.name === 'email';
    });
    if (emailIdx === -1) {
      defaultData = defaultData.concat(_defaultBookingFields.PURCHASER_CUSTOM_FIELDS);
    }
  }
  return {
    data: d,
    defaultData: defaultData,
    editingData: JSON.parse(JSON.stringify(d))
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onSortEnd = function (value) {
    var isDefault = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var _state2 = _this3.state,
        data = _state2.data,
        defaultData = _state2.defaultData;

    var newData = isDefault ? defaultData : data;
    _this3.setState({ isDefault: isDefault }, function () {
      return _this3.sortDataByIndex((0, _reactSortableHoc.arrayMove)(newData, value.oldIndex, value.newIndex));
    });
  };

  this.onSortOptionsEnd = function (_ref8) {
    var oldIndex = _ref8.oldIndex,
        newIndex = _ref8.newIndex;
    var type = _this3.props.type;
    var _state3 = _this3.state,
        editingData = _state3.editingData,
        optionFieldID = _state3.optionFieldID;

    if (type === 'unit') {
      editingData[optionFieldID].projectUnitCustomFieldSettingOptions = (0, _reactSortableHoc.arrayMove)(editingData[optionFieldID].projectUnitCustomFieldSettingOptions, oldIndex, newIndex);
    } else {
      editingData[optionFieldID].projectBookingCustomFieldOptions = (0, _reactSortableHoc.arrayMove)(editingData[optionFieldID].projectBookingCustomFieldOptions, oldIndex, newIndex);
    }
    _this3.sortDataByIndexOptions(editingData, optionFieldID);
  };

  this.getSortedData = function (data) {
    if (data) {
      return data.sort(function (a, b) {
        return a.position - b.position;
      });
    }
    return [];
  };

  this.getOptionsData = function (data, fieldID) {
    var type = _this3.props.type;

    if (data && data.length > 0 && data[fieldID]) {
      if (type === 'unit' && data[fieldID].projectUnitCustomFieldSettingOptions) return data[fieldID].projectUnitCustomFieldSettingOptions;
      if (type === 'booking' && data[fieldID].projectBookingCustomFieldOptions) return data[fieldID].projectBookingCustomFieldOptions;
      return data[fieldID].projectBookingCustomFieldOptions;
    }
    return [];
  };

  this.sortDataByIndexOptions = function (nd, fieldID) {
    var type = _this3.props.type;

    var newData = nd;
    if (type === 'unit') {
      newData[fieldID].projectUnitCustomFieldSettingOptions.forEach(function (d, index) {
        newData[fieldID].projectUnitCustomFieldSettingOptions[index].position = index + 1;
      });
    } else {
      newData[fieldID].projectBookingCustomFieldOptions.forEach(function (d, index) {
        newData[fieldID].projectBookingCustomFieldOptions[index].position = index + 1;
      });
    }
    _this3.setState({ editingData: newData });
  };

  this.sortDataByIndex = function (nd) {
    var _state4 = _this3.state,
        isDefault = _state4.isDefault,
        data = _state4.data,
        defaultData = _state4.defaultData;

    var newData = nd;
    newData.forEach(function (d, index) {
      newData[index].position = index + 1;
    });
    var allData = data.concat(defaultData);
    if (isDefault) {
      _this3.setState({ defaultData: newData }, function () {
        return _this3.props.onChangeData(allData);
      });
    } else {
      _this3.setState({ data: newData, editingData: _this3.handleOnDeepCopyData(newData) }, function () {
        return _this3.props.onChangeData(allData);
      });
    }
  };

  this.handleOnDeepCopyData = function (d) {
    return JSON.parse(JSON.stringify(d));
  };

  this.handleOnChange = function (e, d, index) {
    var isDefault = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var _state5 = _this3.state,
        data = _state5.data,
        defaultData = _state5.defaultData;

    var newData = isDefault ? defaultData : data;
    if (d && d.validationFormat && _typeof(d.validationFormat) === 'object' && !Array.isArray(d.validationFormat)) {
      newData[index].formatName = d.validationFormat.value;
      newData[index].regex = d.validationFormat.regex;
      newData[index].errorMessage = (0, _RegexDropdownPicker.checkRegex)(newData[index].defaultValue, newData[index]).message;
    }
    if (d.hasOwnProperty('checked')) {
      newData[index][d.name] = d.checked;

      // Mutual exclusion: If Required is checked, uncheck Lock/Disabled (and vice versa)
      if (d.name === 'isRequired' && d.checked) {
        newData[index].isDisabled = false;
      } else if (d.name === 'isDisabled' && d.checked) {
        newData[index].isRequired = false;
      }
    } else {
      newData[index][d.name] = d.value;
    }
    if (d.name === 'type') {
      newData[index].defaultValue = '';
    }
    if (!newData[index].isDefault && d.name === 'label' && d.value !== '') {
      newData[index].name = d.value.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '_').replace(/_+$/, '');
    }
    if (d.name === 'defaultValue') {
      if (Array.isArray(data.value)) {
        newData[index].defaultValue = d.value.filter(function (v) {
          return v !== '';
        }).join();
      } else {
        newData[index].errorMessage = (0, _RegexDropdownPicker.checkRegex)(d.value, newData[index]).message;
      }
    }
    _this3.setState({ isDefault: isDefault }, function () {
      return _this3.sortOptionsDataByIndex(newData);
    });
  };

  this.handleOnAdd = function (e) {
    e.preventDefault();
    var type = _this3.props.type;
    var _state6 = _this3.state,
        data = _state6.data,
        addType = _state6.addType;

    var lastID = data.length;
    var newItem = Object.assign({}, type === 'unit' ? CustomField.defaultUnitValues : CustomField.defaultBookingValues);
    if (type === 'unit') {
      newItem.projectUnitCustomFieldSettingOptions = [];
    } else {
      newItem.projectBookingCustomFieldOptions = [];
    }
    newItem.type = addType;
    if (lastID > 0) {
      newItem.position = data[lastID - 1].position;
    }
    data.push(newItem);
    _this3.setState({ isDefault: false }, function () {
      return _this3.sortDataByIndex(data);
    });
  };

  this.handleOnAddChange = function (e, d) {
    _this3.setState({ addType: d.value });
  };

  this.handleOnEdit = function (e, index) {
    var isDefault = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    e.preventDefault();
    var _state7 = _this3.state,
        data = _state7.data,
        defaultData = _state7.defaultData;

    var newData = isDefault ? defaultData : data;
    if (newData[index].isEditing && newData[index].id === '' && (newData[index].name === '' || newData[index].label === '')) {
      newData.splice(index, 1);
    } else {
      newData[index].isEditing = !newData[index].isEditing;
    }
    _this3.setState({ isDefault: isDefault }, function () {
      return _this3.sortDataByIndex(newData);
    });
  };

  this.sortOptionsDataByIndex = function (nd) {
    var isCustomFieldOpts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var type = _this3.props.type;
    var _state8 = _this3.state,
        isDefault = _state8.isDefault,
        data = _state8.data,
        defaultData = _state8.defaultData,
        editingData = _state8.editingData;

    var newData = nd;
    newData.forEach(function (d, index) {
      if (type === 'unit' && d.projectUnitCustomFieldSettingOptions) {
        d.projectUnitCustomFieldSettingOptions.forEach(function (o, idx) {
          newData[index].projectUnitCustomFieldSettingOptions[idx].position = idx + 1;
        });
      } else if (d.projectBookingCustomFieldOptions) {
        d.projectBookingCustomFieldOptions.forEach(function (o, idx) {
          newData[index].projectBookingCustomFieldOptions[idx].position = idx + 1;
        });
      }
    });
    var currentData = isCustomFieldOpts ? editingData : data;
    var allData = currentData.concat(defaultData);
    if (isDefault) {
      _this3.setState({ defaultData: newData }, function () {
        return _this3.props.onChangeData(allData);
      });
    } else if (isCustomFieldOpts) {
      _this3.setState({ editingData: newData });
    } else {
      _this3.setState({ data: newData, editingData: _this3.handleOnDeepCopyData(newData) }, function () {
        return _this3.props.onChangeData(allData);
      });
    }
  };

  this.handleOptionsOnChange = function (e, d, index) {
    var type = _this3.props.type;
    var _state9 = _this3.state,
        editingData = _state9.editingData,
        optionFieldID = _state9.optionFieldID;

    if (type === 'unit') {
      if (e.target.name === 'dataValue') {
        editingData[optionFieldID].projectUnitCustomFieldSettingOptions[index][e.target.name] = e.target.value;
      } else if (d.hasOwnProperty('checked')) {
        editingData[optionFieldID].projectUnitCustomFieldSettingOptions[index][d.name] = d.checked;
      } else {
        editingData[optionFieldID].projectUnitCustomFieldSettingOptions[index][d.name] = d.value;
      }
      if (e.target.name === 'title' && d.value !== '') {
        editingData[optionFieldID].projectUnitCustomFieldSettingOptions[index].value = d.value.toLowerCase().replace(/[^a-zA-Z0-9]+/g, '_').replace(/_+$/, '');
      }
    } else if (e.target.name === 'dataValue') {
      editingData[optionFieldID].projectBookingCustomFieldOptions[index][e.target.name] = e.target.value;
    } else if (d.hasOwnProperty('checked')) {
      editingData[optionFieldID].projectBookingCustomFieldOptions[index][d.name] = d.checked;
    } else {
      editingData[optionFieldID].projectBookingCustomFieldOptions[index][d.name] = d.value;
    }
    _this3.sortOptionsDataByIndex(editingData, true);
  };

  this.handleOptionsOnAdd = function (e) {
    e.preventDefault();
    var type = _this3.props.type;
    var _state10 = _this3.state,
        editingData = _state10.editingData,
        optionFieldID = _state10.optionFieldID;

    var options = [];
    if (type === 'unit') {
      if (editingData[optionFieldID].projectUnitCustomFieldSettingOptions) {
        options = editingData[optionFieldID].projectUnitCustomFieldSettingOptions;
      }
      var lastID = options.length;
      var newItem = Object.assign({}, CustomField.defaultUnitOptionValues);
      newItem.projectUnitCustomFieldSettingID = editingData[optionFieldID].id;
      if (lastID > 0) {
        newItem.position = options[lastID - 1].position;
      }
      options.push(newItem);
      editingData[optionFieldID].projectUnitCustomFieldSettingOptions = options;
    } else {
      if (editingData[optionFieldID] && editingData[optionFieldID].projectBookingCustomFieldOptions) {
        options = editingData[optionFieldID].projectBookingCustomFieldOptions;
      }
      var _lastID = options.length;
      var _newItem = Object.assign({}, CustomField.defaultBookingOptionValues);
      _newItem.projectBookingCustomFieldID = editingData[optionFieldID].id;
      if (_lastID > 0) {
        _newItem.position = options[_lastID - 1].position;
      }
      options.push(_newItem);
      editingData[optionFieldID].projectBookingCustomFieldOptions = options;
    }
    _this3.sortOptionsDataByIndex(editingData, true);
  };

  this.handleOptionsOnEdit = function (e, index) {
    var type = _this3.props.type;
    var optionFieldID = _this3.state.optionFieldID;

    e.preventDefault();
    var newData = _this3.state.editingData;
    if (type === 'unit') {
      if (newData[optionFieldID].projectUnitCustomFieldSettingOptions[index].isEditing && newData[optionFieldID].projectUnitCustomFieldSettingOptions[index].id === '' && (newData[optionFieldID].projectUnitCustomFieldSettingOptions[index].title === '' || newData[optionFieldID].projectUnitCustomFieldSettingOptions[index].value === '')) {
        newData[optionFieldID].projectUnitCustomFieldSettingOptions.splice(index, 1);
      } else {
        newData[optionFieldID].projectUnitCustomFieldSettingOptions[index].isEditing = !newData[optionFieldID].projectUnitCustomFieldSettingOptions[index].isEditing;
      }
    } else if (newData[optionFieldID].projectBookingCustomFieldOptions[index].isEditing && newData[optionFieldID].projectBookingCustomFieldOptions[index].id === '' && (newData[optionFieldID].projectBookingCustomFieldOptions[index].title === '' || newData[optionFieldID].projectBookingCustomFieldOptions[index].value === '')) {
      newData[optionFieldID].projectBookingCustomFieldOptions.splice(index, 1);
    } else {
      newData[optionFieldID].projectBookingCustomFieldOptions[index].isEditing = !newData[optionFieldID].projectBookingCustomFieldOptions[index].isEditing;
    }
    _this3.sortOptionsDataByIndex(newData, true);
  };

  this.handleOnClickOptions = function (e, optionFieldID) {
    e.preventDefault();
    _this3.setState({
      optionFieldID: optionFieldID,
      optionModalIsOpen: true
    });
  };

  this.handleOnClickName = function (e, index) {
    var data = _this3.state.data;

    e.preventDefault();
    data[index].showName = !data[index].showName;
    _this3.sortOptionsDataByIndex(data);
  };

  this.handleOptionsModalSave = function () {
    var type = _this3.props.type;
    var _state11 = _this3.state,
        editingData = _state11.editingData,
        optionFieldID = _state11.optionFieldID,
        defaultData = _state11.defaultData;

    if (type === 'unit' && editingData[optionFieldID].projectUnitCustomFieldSettingOptions && editingData[optionFieldID].projectUnitCustomFieldSettingOptions.length > 0) {
      editingData[optionFieldID].projectUnitCustomFieldSettingOptions.forEach(function (d, idx) {
        editingData[optionFieldID].projectUnitCustomFieldSettingOptions[idx].isEditing = false;
      });
    } else if (type === 'booking' && editingData[optionFieldID].projectBookingCustomFieldOptions && editingData[optionFieldID].projectBookingCustomFieldOptions.length > 0) {
      editingData[optionFieldID].projectBookingCustomFieldOptions.forEach(function (d, idx) {
        editingData[optionFieldID].projectBookingCustomFieldOptions[idx].isEditing = false;
      });
    }
    var allData = type === 'unit' ? editingData : editingData.concat(defaultData);
    _this3.setState({
      editingData: editingData,
      data: _this3.handleOnDeepCopyData(editingData),
      optionModalIsOpen: false
    }, function () {
      return _this3.props.onChangeData(allData);
    });
  };

  this.handleOptionsModalCancel = function () {
    return _this3.setState({ editingData: _this3.handleOnDeepCopyData(_this3.state.data), optionModalIsOpen: false });
  };

  this.handleOrderItems = function (e, _ref9) {
    var name = _ref9.name;

    var data = _this3.state.data;
    switch (name) {
      case 'alphabetically':
        data = data.sort(function (a, b) {
          return a.label.localeCompare(b.label);
        });
        break;
      case 'newest':
        data = data.sort(function (a, b) {
          var aTime = (0, _momentTimezone2.default)(b.createdAt).valueOf().toString();
          var bTime = (0, _momentTimezone2.default)(a.createdAt).valueOf().toString();
          return aTime.localeCompare(bTime);
        });
        break;
      case 'oldest':
        data = data.sort(function (b, a) {
          var aTime = (0, _momentTimezone2.default)(b.createdAt).valueOf().toString();
          var bTime = (0, _momentTimezone2.default)(a.createdAt).valueOf().toString();
          return aTime.localeCompare(bTime);
        });
        break;
      default:
        return;
    }
    _this3.sortDataByIndex(data);
  };

  this.checkOptionAddButtonDisabled = function () {
    var type = _this3.props.type;
    var _state12 = _this3.state,
        editingData = _state12.editingData,
        optionFieldID = _state12.optionFieldID,
        optionModalIsOpen = _state12.optionModalIsOpen;

    if (optionModalIsOpen) {
      var options = type === 'unit' ? editingData[optionFieldID].projectUnitCustomFieldSettingOptions : editingData[optionFieldID].projectBookingCustomFieldOptions;
      if (options && options.filter(function (d) {
        return d.title === '' || d.value === '';
      }).length > 0) {
        return true;
      }
    }
    return false;
  };

  this.checkOptionSaveButtonDisabled = function () {
    var type = _this3.props.type;
    var _state13 = _this3.state,
        editingData = _state13.editingData,
        optionFieldID = _state13.optionFieldID,
        optionModalIsOpen = _state13.optionModalIsOpen;

    if (optionModalIsOpen) {
      var options = type === 'unit' ? editingData[optionFieldID].projectUnitCustomFieldSettingOptions : editingData[optionFieldID].projectBookingCustomFieldOptions;
      if (!options || options.length === 0) {
        return false;
      }
      return options.filter(function (d) {
        return !d.isDeleted && (d.title === '' || d.value === '');
      }).length > 0;
    }
    return false;
  };

  this.checkAddButtonDisabled = function () {
    var data = _this3.state.data;

    if (data.filter(function (d) {
      return d.name === '' || d.label === '';
    }).length > 0) {
      return true;
    }
    return false;
  };

  this.hasCompanyHimsEnabled = function () {
    var appConfig = _this3.props.appConfig;

    return appConfig && appConfig.data && appConfig.data.himsIsEnabled;
  };

  this.hasVAEnabled = function () {
    var appConfig = _this3.props.appConfig;

    return appConfig && appConfig.data && appConfig.data.settings && appConfig.data.settings.virtualAccountIsEnabled;
  };

  this.renderUnitDefaultFields = function () {
    var _props2 = _this3.props,
        type = _props2.type,
        t = _props2.t;
    var defaultData = _this3.state.defaultData;

    var UNIT_DEFAULT_FIELDS = [{ title: 'HIMS Unit Fields', fields: _hims.HIMS_UNIT_FIELDS, enabled: _this3.hasCompanyHimsEnabled() }, { title: 'Virtual Account Fields', fields: _virtualAccount.VA_UNIT_FIELDS, enabled: _this3.hasVAEnabled() }];
    return _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { width: 16 },
      UNIT_DEFAULT_FIELDS.map(function (f, idx) {
        return f.enabled && _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { style: idx > 0 ? { paddingTop: '2em' } : null },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(
              _semanticUiReact.Divider,
              { horizontal: true },
              t(f.title)
            ),
            _react2.default.createElement(SortableFieldList, {
              addDisabled: _this3.checkAddButtonDisabled(),
              helperClass: 'PBCFSetup isSorting',
              items: _this3.getSortedData(defaultData.filter(function (d) {
                return f.fields.some(function (ff) {
                  return d.name === ff;
                });
              })),
              lockAxis: 'y',
              lockToContainerEdges: true,
              onChange: function onChange(e, d, i) {
                return _this3.handleOnChange(e, d, i, true);
              },
              onEdit: function onEdit(e, i) {
                return _this3.handleOnEdit(e, i, true);
              },
              onSortEnd: function onSortEnd(v) {
                return _this3.onSortEnd(v, true);
              },
              useDragHandle: true,
              isDefault: true,
              type: type,
              t: t,
              startIndex: idx === 0 ? 0 : UNIT_DEFAULT_FIELDS[idx - 1].fields.length
            })
          )
        );
      })
    );
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(CustomField.mapStateToProps)(CustomField));

/***/ }),
/* 1015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _hims = __webpack_require__(221);

var _banks = __webpack_require__(581);

var _virtualAccount = __webpack_require__(393);

var _SelectBank = __webpack_require__(218);

var _SelectBank2 = _interopRequireDefault(_SelectBank);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _RegexDropdownPicker = __webpack_require__(387);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var RenderDivider = function RenderDivider() {
  return _react2.default.createElement(_semanticUiReact.Divider, { className: 'compact' });
};

var CustomFieldForm = function (_Component) {
  _inherits(CustomFieldForm, _Component);

  function CustomFieldForm(props) {
    _classCallCheck(this, CustomFieldForm);

    var _this = _possibleConstructorReturn(this, (CustomFieldForm.__proto__ || Object.getPrototypeOf(CustomFieldForm)).call(this, props));

    _this.getPrefix = function (v) {
      var isBookingCustomField = _this.props.isBookingCustomField;

      if (!isBookingCustomField) {
        return 'ucf_' + v;
      }
      return 'bcf_' + v;
    };

    _this.isRequiredAtStatus = function (field) {
      var _this$props = _this.props,
          componentData = _this$props.componentData,
          isBookingCustomField = _this$props.isBookingCustomField;

      // Only applies to booking custom fields

      if (!isBookingCustomField || !field.isRequired) {
        return field.isRequired;
      }

      // For DEFAULT fields (purchaser fields), always use isRequired directly
      // Status-based logic only applies to custom booking fields
      if (field.isDefault) {
        return field.isRequired;
      }

      var currentStatus = componentData.statusID || 'reserved';
      var requiredAtStatus = field.requiredAtStatus || 'reserved';

      // Define status hierarchy: reserved < booked < sold_spa_signed
      var statusHierarchy = {
        'reserved': 1,
        'booked': 2,
        'sold_spa_signed': 3
      };

      var currentLevel = statusHierarchy[currentStatus];
      var requiredLevel = statusHierarchy[requiredAtStatus];

      if (!currentLevel || !requiredLevel) {
        return false;
      }

      return currentLevel >= requiredLevel;
    };

    _this.renderLabel = function (label) {
      return {
        content: label.text,
        circular: true
      };
    };

    _this.renderInputField = function (data, idx) {
      var _this$props2 = _this.props,
          componentData = _this$props2.componentData,
          isEditing = _this$props2.isEditing,
          onCustomInputChange = _this$props2.onCustomInputChange;

      var isHimsUnitField = _hims.HIMS_UNIT_FIELDS.includes(data.name);
      var nonEditHimsField = isHimsUnitField && !_hims.HIMS_STRATA_UNIT_FIELDS.includes(data.name);
      if (isEditing) {
        return _react2.default.createElement(
          _semanticUiReact.Form.Group,
          { widths: 'equal' },
          _react2.default.createElement(_AppForm2.default.Input, {
            key: idx,
            disabled: data.isDisabled,
            autoComplete: 'off',
            label: '' + data.label + (_this.isRequiredAtStatus(data) ? '*' : '') + ' ' + (nonEditHimsField ? '(read only)' : ''),
            name: _this.getPrefix(data.name),
            onChange: function onChange(e) {
              return onCustomInputChange(e, _this.validation);
            },
            placeholder: data.placeholder,
            ref: _this.validation[_this.getPrefix(data.name)],
            validation: _this.isRequiredAtStatus(data) && !data.isDisabled ? [_webValidations.required, {
              validate: function validate(value) {
                return (0, _RegexDropdownPicker.checkRegex)(value, data);
              }
            }] : [{
              validate: function validate(value) {
                return (0, _RegexDropdownPicker.checkRegex)(value, data);
              }
            }],
            value: componentData[_this.getPrefix(data.name)],
            validateLabel: data.label,
            readOnly: nonEditHimsField
          })
        );
      }
      return _react2.default.createElement(
        'div',
        { key: idx },
        isHimsUnitField && idx < 2 ? '' : _react2.default.createElement(RenderDivider, null),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { stretched: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 6, className: 'word_break_word' },
              _react2.default.createElement(
                'b',
                null,
                data.label
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 10, className: 'word_break_word' },
              componentData[_this.getPrefix(data.name)] || '-'
            )
          )
        )
      );
    };

    _this.renderTextareaField = function (data, idx) {
      var _this$props3 = _this.props,
          componentData = _this$props3.componentData,
          isEditing = _this$props3.isEditing,
          onCustomInputChange = _this$props3.onCustomInputChange;

      if (isEditing) {
        return _react2.default.createElement(
          _semanticUiReact.Form.Group,
          { widths: 'equal' },
          _react2.default.createElement(
            _AppForm2.default.Validate,
            {
              key: idx,
              validation: _this.isRequiredAtStatus(data) && !data.isDisabled ? [_webValidations.required] : null,
              ref: _this.validation[_this.getPrefix(data.name)],
              onChange: onCustomInputChange,
              validateLabel: data.label
            },
            _react2.default.createElement(_semanticUiReact.Form.TextArea, {
              disabled: data.isDisabled,
              autoComplete: 'off',
              label: '' + data.label + (_this.isRequiredAtStatus(data) ? '*' : ''),
              name: _this.getPrefix(data.name),
              placeholder: data.placeholder,
              ref: _this.validation[_this.getPrefix(data.name)],
              value: componentData[_this.getPrefix(data.name)],
              style: { minHeight: '6em', height: '6em' }
            })
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { key: idx },
        _react2.default.createElement(RenderDivider, null),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { stretched: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 6, className: 'word_break_word' },
              _react2.default.createElement(
                'b',
                null,
                data.label
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 10, className: 'word_break_word' },
              componentData[_this.getPrefix(data.name)] || '-'
            )
          )
        )
      );
    };

    _this.renderDropdownField = function (data, idx, oriData) {
      var _this$props4 = _this.props,
          componentData = _this$props4.componentData,
          countryCode = _this$props4.countryCode,
          isEditing = _this$props4.isEditing,
          onCustomSelectChange = _this$props4.onCustomSelectChange,
          isBookingCustomField = _this$props4.isBookingCustomField;

      var customFieldOptions = [];
      var optionText = '';
      var value = componentData[_this.getPrefix(data.name)];

      if (!isBookingCustomField && oriData && oriData.projectUnitCustomFieldSettingOptions) {
        oriData.projectUnitCustomFieldSettingOptions.forEach(function (d) {
          customFieldOptions.push({ text: d.title, value: d.value, id: d.id });
        });
      }

      if (!isBookingCustomField && data.name === _hims.HIMS_LOT_POSITION) {
        customFieldOptions = _hims.HIMS_LOT_POSITION_OPTIONS;
      }
      if (!isBookingCustomField && data.name === _virtualAccount.VA_BANK_NAME) {
        customFieldOptions = _banks.BANKS;
      }

      if (isBookingCustomField && oriData && oriData.projectBookingCustomFieldOptions) {
        // keep the Project > Booking Fields order; the API array is not guaranteed sorted
        [].concat(_toConsumableArray(oriData.projectBookingCustomFieldOptions)).sort(function (a, b) {
          return a.position - b.position;
        }).forEach(function (d) {
          customFieldOptions.push({ text: d.title, value: d.value, id: d.id });
        });
      }

      if (data.type === 'dropdown_multi') {
        if (componentData[_this.getPrefix(data.name)]) {
          var selectedOptions = customFieldOptions.filter(function (o) {
            var match = false;
            componentData[_this.getPrefix(data.name)].split(',').forEach(function (v) {
              if (v === o.value) match = true;
            });
            return match;
          });
          optionText = selectedOptions.map(function (v, key) {
            return _react2.default.createElement(
              _semanticUiReact.Label,
              { key: key, circular: true, size: 'small' },
              v.text
            );
          });
        }
        if (componentData[_this.getPrefix(data.name)] && value !== '') {
          value = value.split(',');
        } else {
          value = [];
        }
      } else if (data.type === 'dropdown') {
        var option = customFieldOptions.find(function (d) {
          return d.value === componentData[_this.getPrefix(data.name)];
        });
        if (option) {
          optionText = option.text;
        }
      }

      // return
      if (isEditing) {
        if (!isBookingCustomField && data.name === _virtualAccount.VA_BANK_NAME) {
          return _react2.default.createElement(_SelectBank2.default, {
            country: countryCode,
            validation: _this.isRequiredAtStatus(data) && !data.isDisabled ? [_webValidations.required] : null,
            validateRef: _this.validation[_this.getPrefix(data.name)],
            validateLabel: data.label,
            label: '' + data.label + (_this.isRequiredAtStatus(data) ? '*' : ''),
            onChange: function onChange(e, d) {
              return onCustomSelectChange(e, d, customFieldOptions, _this.validation);
            },
            name: _this.getPrefix(data.name),
            placeholder: data.placeholder,
            value: value
          });
        }
        return _react2.default.createElement(
          _semanticUiReact.Form.Group,
          { widths: 'equal' },
          _react2.default.createElement(
            _AppForm2.default.Validate,
            {
              key: idx,
              validation: _this.isRequiredAtStatus(data) && !data.isDisabled ? [_webValidations.required] : null,
              ref: _this.validation[_this.getPrefix(data.name)],
              onChange: function onChange(e, d) {
                return onCustomSelectChange(e, d, customFieldOptions, _this.validation);
              },
              validateLabel: data.label
            },
            _react2.default.createElement(_semanticUiReact.Form.Select, {
              disabled: data.isDisabled,
              label: '' + data.label + (_this.isRequiredAtStatus(data) ? '*' : ''),
              name: _this.getPrefix(data.name),
              options: customFieldOptions,
              placeholder: data.placeholder,
              search: true,
              selectOnBlur: false,
              value: value,
              multiple: data.type === 'dropdown_multi',
              renderLabel: _this.renderLabel,
              clearable: true
            })
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { key: idx },
        _react2.default.createElement(RenderDivider, null),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { stretched: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 6, className: 'word_break_word' },
              _react2.default.createElement(
                'b',
                null,
                data.label
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 10, className: 'word_break_word' },
              _react2.default.createElement(
                'div',
                null,
                optionText || '-'
              )
            )
          )
        )
      );
    };

    _this.renderCustomField = function (field, idx) {
      var isCustomFieldSetting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var dataCustomFields = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
      var _this$props5 = _this.props,
          isBookingCustomField = _this$props5.isBookingCustomField,
          hasProjectHimsEnabled = _this$props5.hasProjectHimsEnabled,
          hasHimsStrataEnabled = _this$props5.hasHimsStrataEnabled,
          vaIsEnabled = _this$props5.vaIsEnabled;

      var data = field;
      if (!isCustomFieldSetting) {
        data = isBookingCustomField ? field.projectBookingCustomField : field.projectUnitCustomFieldSetting;
      } else if (isCustomFieldSetting && dataCustomFields && dataCustomFields.length > 0) {
        var existingField = isBookingCustomField ? dataCustomFields.find(function (d) {
          return d.projectBookingCustomField.id === data.id;
        }) : dataCustomFields.find(function (d) {
          return d.projectUnitCustomFieldSetting.id === data.id;
        });
        if (existingField) return '';
      }

      if (!isBookingCustomField && data.isDefault) {
        // set HIMS unit fields based on project settings
        if (!hasProjectHimsEnabled && _hims.HIMS_UNIT_FIELDS.includes(data.name)) return '';
        if (!hasHimsStrataEnabled && _hims.HIMS_STRATA_UNIT_FIELDS.includes(data.name)) return '';

        // set Virtual Account fields based on global settings
        if (!vaIsEnabled && _virtualAccount.VA_UNIT_FIELDS.includes(data.name)) return '';
      }

      if (data.type === 'input') return _this.renderInputField(data, idx);
      if (data.type === 'textarea') return _this.renderTextareaField(data, idx);
      if (data.type === 'dropdown' || data.type === 'dropdown_multi') return _this.renderDropdownField(data, idx, field);

      return '';
    };

    _this.renderAllCustomFields = function () {
      var isHims = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _this$props6 = _this.props,
          componentData = _this$props6.componentData,
          customFieldSettings = _this$props6.customFieldSettings,
          isBookingCustomField = _this$props6.isBookingCustomField,
          minItems = _this$props6.minItems,
          offsetFrom = _this$props6.offsetFrom;

      var isUnitCustomField = !isBookingCustomField;
      var renderCFs = [];
      if (isBookingCustomField && componentData.bookingCustomFields && componentData.bookingCustomFields.length > 0) {
        componentData.bookingCustomFields.filter(function (bcf) {
          return !bcf.projectBookingCustomField.isDefault && !bcf.projectBookingCustomField.isHidden;
        }).sort(function (a, b) {
          return a.projectBookingCustomField.position - b.projectBookingCustomField.position;
        }).forEach(function (d, idx) {
          return renderCFs.push(_this.renderCustomField(d, idx, false));
        });
      }
      if (isUnitCustomField && componentData.projectUnitCustomFields && componentData.projectUnitCustomFields.length > 0) {
        componentData.projectUnitCustomFields.filter(function (ucf) {
          return !ucf.projectUnitCustomFieldSetting.isHidden;
        })
        // show only HIMS unit fields if isHims is true, otherwise exclude them
        .filter(function (ucf) {
          return isHims ? _hims.HIMS_UNIT_FIELDS.includes(ucf.projectUnitCustomFieldSetting.name) : !_hims.HIMS_UNIT_FIELDS.includes(ucf.projectUnitCustomFieldSetting.name);
        }).sort(function (a, b) {
          return a.projectUnitCustomFieldSetting.position - b.projectUnitCustomFieldSetting.position;
        }).forEach(function (d, idx) {
          return renderCFs.push(_this.renderCustomField(d, idx, false));
        });
      }
      if (isBookingCustomField && customFieldSettings && customFieldSettings.length > 0) {
        customFieldSettings.filter(function (cf) {
          return !cf.isDefault && !cf.isHidden;
        }).sort(function (a, b) {
          return a.position - b.position;
        }).map(function (d, idx) {
          return renderCFs.push(_this.renderCustomField(d, idx, true, isBookingCustomField ? componentData.bookingCustomFields : componentData.projectUnitCustomFields));
        });
      }
      if (isUnitCustomField && customFieldSettings && customFieldSettings.length > 0) {
        customFieldSettings.filter(function (cf) {
          return !cf.isHidden;
        })
        // show only HIMS unit fields if isHims is true, otherwise exclude them
        .filter(function (cf) {
          return isHims ? _hims.HIMS_UNIT_FIELDS.includes(cf.name) : !_hims.HIMS_UNIT_FIELDS.includes(cf.name);
        }).sort(function (a, b) {
          return a.position - b.position;
        }).map(function (d, idx) {
          return renderCFs.push(_this.renderCustomField(d, idx, true, isBookingCustomField ? componentData.bookingCustomFields : componentData.projectUnitCustomFields));
        });
      }
      if (minItems && minItems > 0) {
        return renderCFs.slice(0, minItems);
      }
      if (offsetFrom && offsetFrom > 0) {
        renderCFs.splice(0, offsetFrom);
      }
      return renderCFs;
    };

    _this.renderHimsUnitFieldsBox = function () {
      var _this$props7 = _this.props,
          mobile = _this$props7.mobile,
          tablet = _this$props7.tablet,
          computer = _this$props7.computer;

      return _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 16, style: { marginTop: '10px' } },
        _react2.default.createElement(
          _semanticUiReact.Header,
          { className: 'hims_unit_fields', as: 'h5', attached: 'top', textAlign: 'center' },
          'HIMS INFORMATION'
        ),
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { attached: true },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { style: { marginTop: '10px', marginBottom: '4px' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'no-top-padding' },
              _this.renderAllCustomFields(true).map(function (element, idx) {
                return element ? _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { key: idx, mobile: mobile, tablet: tablet, computer: computer },
                  element
                ) : '';
              })
            )
          )
        )
      );
    };

    _this.validation = {};
    // add validateRef for all custom fields
    if (props.componentData) {
      if (props.componentData.bookingCustomFields && props.componentData.bookingCustomFields.length > 0) {
        props.componentData.bookingCustomFields.forEach(function (key) {
          _this.validation[_this.getPrefix(key.projectBookingCustomField.name)] = (0, _react.createRef)();
        });
      }
      if (props.componentData.projectUnitCustomFields && props.componentData.projectUnitCustomFields.length > 0) {
        props.componentData.projectUnitCustomFields.forEach(function (key) {
          _this.validation[_this.getPrefix(key.name)] = (0, _react.createRef)();
        });
      }
    }
    if (props.customFieldSettings && props.customFieldSettings.length > 0) {
      props.customFieldSettings.filter(function (cf) {
        return !cf.isDefault && !cf.isHidden;
      }).forEach(function (key) {
        _this.validation[_this.getPrefix(key.name)] = (0, _react.createRef)();
      });
    }
    return _this;
  }

  _createClass(CustomFieldForm, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      var _props = this.props,
          isBookingCustomField = _props.isBookingCustomField,
          componentData = _props.componentData;

      if (isBookingCustomField && this.props.isEditing && !prevProps.isEditing) {
        if (isBookingCustomField && componentData.bookingCustomFields && componentData.bookingCustomFields.length > 0) {
          componentData.bookingCustomFields.filter(function (bcf) {
            return !bcf.projectBookingCustomField.isDefault && !bcf.projectBookingCustomField.isHidden;
          }).sort(function (a, b) {
            return a.projectBookingCustomField.position - b.projectBookingCustomField.position;
          }).forEach(function (d) {
            if (_this2.validation[_this2.getPrefix(d.projectBookingCustomField.name)] && _this2.validation[_this2.getPrefix(d.projectBookingCustomField.name)].current) {
              return _this2.validation[_this2.getPrefix(d.projectBookingCustomField.name)].current.validate(componentData[_this2.getPrefix(d.projectBookingCustomField.name)]);
            }
            return null;
          });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          mobile = _props2.mobile,
          tablet = _props2.tablet,
          computer = _props2.computer,
          hasProjectHimsEnabled = _props2.hasProjectHimsEnabled,
          isEditing = _props2.isEditing;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'no-top-padding' },
          this.renderAllCustomFields().map(function (element, idx) {
            return element ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { key: idx, mobile: mobile, tablet: tablet, computer: computer },
              element
            ) : '';
          })
        ),
        isEditing && hasProjectHimsEnabled && _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 16 },
          _react2.default.createElement(_semanticUiReact.Divider, null),
          _react2.default.createElement(
            _semanticUiReact.Header,
            { textAlign: 'center', size: 'small', style: { paddingBottom: '10px' } },
            'HIMS Information'
          )
        ),
        isEditing && hasProjectHimsEnabled && _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'no-top-padding' },
          this.renderAllCustomFields(true).map(function (element, idx) {
            return element ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { key: idx, mobile: mobile, tablet: tablet, computer: computer },
              element
            ) : '';
          })
        ),
        !isEditing && hasProjectHimsEnabled && this.renderHimsUnitFieldsBox()
      );
    }
  }]);

  return CustomFieldForm;
}(_react.Component);

CustomFieldForm.propTypes = {
  componentData: _propTypes2.default.oneOfType([_propTypes2.default.object]).isRequired,
  customFieldSettings: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  countryCode: _propTypes2.default.string,
  isEditing: _propTypes2.default.bool,
  isBookingCustomField: _propTypes2.default.bool,
  onCustomInputChange: _propTypes2.default.func.isRequired,
  onCustomSelectChange: _propTypes2.default.func.isRequired,
  hasProjectHimsEnabled: _propTypes2.default.bool,
  vaIsEnabled: _propTypes2.default.bool,
  hasHimsStrataEnabled: _propTypes2.default.bool,
  minItems: _propTypes2.default.number,
  offsetFrom: _propTypes2.default.number,
  mobile: _propTypes2.default.number,
  tablet: _propTypes2.default.number,
  computer: _propTypes2.default.number
};
CustomFieldForm.defaultProps = {
  mobile: 16,
  tablet: 16,
  computer: 8
};
exports.default = CustomFieldForm;

/***/ }),
/* 1016 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _reactDayPicker = __webpack_require__(687);

var _reactDayPicker2 = _interopRequireDefault(_reactDayPicker);

__webpack_require__(360);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_momentTimezone2.default.locale('en-gb');

var InputCalendarRange = function (_Component) {
  _inherits(InputCalendarRange, _Component);

  function InputCalendarRange(props) {
    _classCallCheck(this, InputCalendarRange);

    var _this = _possibleConstructorReturn(this, (InputCalendarRange.__proto__ || Object.getPrototypeOf(InputCalendarRange)).call(this, props));

    _this.inputFrom = null;
    _this.inputTo = null;
    _this.clickedInside = false;
    _this.clickTimeout = null;

    _this.handleContainerMouseDown = function () {
      _this.clickedInside = true;
      // The input's onBlur method is called from a queue right after onMouseDown event.
      // setTimeout adds another callback in the queue, but is called later than onBlur event
      _this.clickTimeout = setTimeout(function () {
        _this.clickedInside = false;
      }, 0);
    };

    _this.handleInputFromFocus = function () {
      if (_this.state.showOverlayRight) {
        _this.setState({
          showOverlayRight: false,
          showOverlay: true
        }, function () {
          _this.inputFrom.focus();
        });
      } else {
        _this.setState({
          showOverlay: true
        });
      }
    };

    _this.handleInputToFocus = function () {
      if (!_this.state.from) {
        _this.setState({
          showOverlayRight: false,
          showOverlay: true
        }, function () {
          _this.inputFrom.focus();
        });
      } else {
        _this.setState({
          showOverlayRight: true,
          showOverlay: false
        }, function () {
          _this.inputTo.focus();
        });
      }
    };

    _this.handleInputFromBlur = function () {
      var showOverlay = _this.clickedInside;
      _this.setState({
        showOverlay: showOverlay
      });
      // Force input's focus if blur event was caused by clicking on the calendar
      if (showOverlay && !_this.state.from) {
        _this.inputFrom.focus();
      }
    };

    _this.handleInputToBlur = function () {
      var showOverlayRight = _this.clickedInside;
      if (!_this.state.showOverlay) {
        _this.setState({
          showOverlayRight: showOverlayRight
        });
      }
    };

    _this.handleDayClick = function (day) {
      var range = _reactDayPicker.DateUtils.addDayToRange(day, _this.state);
      _this.setState(range, function () {
        if (_this.state.from && !_this.state.to) {
          _this.inputTo.focus();
          _this.setState({
            showOverlay: false,
            showOverlayRight: true
          }, function () {
            _this.props.onSetRange((0, _momentTimezone2.default)(_this.state.from).format('YYYY-MM-DD'), '');
          });
        } else if (_this.state.from && _this.state.to) {
          _this.setState({
            showOverlay: false,
            showOverlayRight: false
          }, function () {
            if (_this.state.showOverlayRight) {
              _this.inputTo.blur();
            }
            _this.props.onSetRange((0, _momentTimezone2.default)(_this.state.from).format('YYYY-MM-DD'), (0, _momentTimezone2.default)(_this.state.to).format('YYYY-MM-DD'));
          });
        }
      });
    };

    _this.handleReset = function () {
      _this.setState({
        from: null,
        to: null,
        showOverlay: false,
        showOverlayRight: false
      }, function () {
        _this.inputFrom.blur();
        _this.inputTo.blur();
        if (_this.props.onReset) {
          _this.props.onReset(_this.props.filterNameFrom, _this.props.filterNameTo);
        }
      });
    };

    _this.state = {
      showOverlay: false,
      showOverlayRight: false,
      value: '',
      from: _this.props.dateFrom ? new Date(_this.props.dateFrom) : null,
      to: _this.props.dateTo ? new Date(_this.props.dateTo) : null
    };
    return _this;
  }

  _createClass(InputCalendarRange, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.clickTimeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var overlayStyle = {
        position: 'absolute',
        background: 'white',
        boxShadow: '0 2px 5px rgba(0, 0, 0, .15)',
        zIndex: '9999'
      };
      var overlayStyleRight = {
        position: 'absolute',
        background: 'white',
        boxShadow: '0 2px 5px rgba(0, 0, 0, .15)',
        zIndex: '9999',
        right: '0'
      };
      var _state = this.state,
          from = _state.from,
          to = _state.to,
          showOverlay = _state.showOverlay,
          showOverlayRight = _state.showOverlayRight;
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { onMouseDown: this.handleContainerMouseDown },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 8, style: { paddingRight: '0.5rem' } },
            _react2.default.createElement(
              'div',
              { className: 'ui fluid icon input' },
              _react2.default.createElement('input', {
                type: 'text',
                ref: function ref(el) {
                  _this2.inputFrom = el;
                },
                placeholder: t('Start date'),
                value: from ? (0, _momentTimezone2.default)(from).format('L') : '',
                onFocus: this.handleInputFromFocus,
                onBlur: this.handleInputFromBlur,
                readOnly: true
              }),
              _react2.default.createElement('i', { 'aria-hidden': 'true', className: 'calendar icon' })
            ),
            showOverlay && _react2.default.createElement(
              'div',
              { style: { position: 'relative' } },
              _react2.default.createElement(
                'div',
                { style: overlayStyle },
                _react2.default.createElement(_reactDayPicker2.default, {
                  numberOfMonths: 1,
                  selectedDays: [from, { from: from, to: to }],
                  onDayClick: this.handleDayClick
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 8, style: { paddingLeft: '0.5rem' } },
            _react2.default.createElement(
              'div',
              { className: 'ui fluid icon input' },
              _react2.default.createElement('input', {
                type: 'text',
                ref: function ref(el) {
                  _this2.inputTo = el;
                },
                placeholder: t('End date'),
                value: to ? (0, _momentTimezone2.default)(to).format('L') : '',
                onFocus: this.handleInputToFocus,
                onBlur: this.handleInputToBlur,
                readOnly: true
              }),
              _react2.default.createElement('i', { 'aria-hidden': 'true', className: 'calendar icon' })
            ),
            showOverlayRight && _react2.default.createElement(
              'div',
              { style: { position: 'relative' } },
              _react2.default.createElement(
                'div',
                { style: overlayStyleRight },
                _react2.default.createElement(_reactDayPicker2.default, {
                  numberOfMonths: 1,
                  selectedDays: [from, { from: from, to: to }],
                  onDayClick: this.handleDayClick
                })
              )
            )
          )
        )
      );
    }
  }]);

  return InputCalendarRange;
}(_react.Component);

InputCalendarRange.propTypes = {
  dateFrom: _propTypes2.default.string,
  dateTo: _propTypes2.default.string,
  filterNameFrom: _propTypes2.default.string.isRequired,
  filterNameTo: _propTypes2.default.string.isRequired,
  onSetRange: _propTypes2.default.func.isRequired,
  onReset: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(InputCalendarRange);

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BookingSelectList = function (_Component) {
  _inherits(BookingSelectList, _Component);

  function BookingSelectList(props) {
    _classCallCheck(this, BookingSelectList);

    var _this = _possibleConstructorReturn(this, (BookingSelectList.__proto__ || Object.getPrototypeOf(BookingSelectList)).call(this, props));

    _initialiseProps.call(_this);

    var state = BookingSelectList.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(BookingSelectList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = BookingSelectList.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classNames = ['booking'];
      if (this.state.value.length > 0) {
        classNames.push('selected');
      }
      var options = this.props.options;
      var truncateStyle = {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        display: 'inline-block',
        maxWidth: '100%'
      };
      var hasHeader = options && options.some(function (opt) {
        return opt.header;
      });
      if (hasHeader) {
        options.forEach(function (opt, idx, arr) {
          if (opt.header) {
            if (idx > 0 && !arr[idx - 1].divider) {
              options.splice(idx, 0, { divider: true });
            }
          }
        });
        return _react2.default.createElement(
          _semanticUiReact.Dropdown,
          {
            className: classNames.join(' '),
            disabled: this.props.disabled,
            fluid: true,
            header: this.props.headerText,
            onChange: this.handleOnChange,
            selectOnBlur: false,
            text: this.state.value && options && options.length > 0 ? options.find(function (o) {
              return o.value === _this2.state.value;
            }).text : null,
            placeholder: this.props.placeholder,
            value: this.state.value,
            scrolling: true,
            style: this.props.style
          },
          _react2.default.createElement(
            _semanticUiReact.Dropdown.Menu,
            null,
            this.props.headerText && _react2.default.createElement(_semanticUiReact.Dropdown.Header, { content: this.props.headerText }),
            options && options.length > 0 ? options.map(function (opt, idx) {
              if (opt.divider) {
                return _react2.default.createElement(_semanticUiReact.Dropdown.Divider, { key: idx });
              }
              if (opt.header) {
                return _react2.default.createElement(_semanticUiReact.Dropdown.Header, { key: idx, content: opt.text });
              }
              return _react2.default.createElement(_semanticUiReact.Dropdown.Item, {
                key: idx,
                value: opt.value,
                text: opt.text,
                selected: _this2.state.value === opt.value,
                onClick: _this2.handleOnChange
              });
            }) : null
          )
        );
      }
      return _react2.default.createElement(_semanticUiReact.Dropdown, {
        className: classNames.join(' '),
        disabled: this.props.disabled,
        fluid: true,
        header: this.props.headerText,
        onChange: this.handleOnChange,
        options: options,
        selectOnBlur: false,
        placeholder: this.props.placeholder,
        value: this.state.value,
        scrolling: true,
        style: this.props.style,
        search: true,
        text: this.state.value ? _react2.default.createElement(
          'span',
          { style: truncateStyle },
          options.find(function (o) {
            return o.value === _this2.state.value;
          }).text
        ) : this.props.placeholder
      });
    }
  }]);

  return BookingSelectList;
}(_react.Component);

BookingSelectList.propTypes = {
  disabled: _propTypes2.default.bool,
  filterName: _propTypes2.default.string.isRequired,
  headerText: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired
  })).isRequired,
  placeholder: _propTypes2.default.string,
  value: _propTypes2.default.string,
  search: _propTypes2.default.string,
  style: _propTypes2.default.shape({})
};
BookingSelectList.defaultProps = {
  hasSearch: false,
  options: [],
  placeholder: 'Select an Option',
  value: ''
};

BookingSelectList.getPropsToState = function (props) {
  var value = props.value || '';
  var search = props.search || '';
  return {
    value: value,
    search: search
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleOnChange = function (e, _ref) {
    var value = _ref.value;

    _this3.setState({ value: value }, function () {
      _this3.props.onChange(value, _this3.props.filterName);
    });
  };
};

exports.default = BookingSelectList;

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FixedBarStatus = function FixedBarStatus(_ref) {
  var className = _ref.className,
      status = _ref.status,
      name = _ref.name,
      count = _ref.count,
      onClick = _ref.onClick,
      selected = _ref.selected;

  var classNames = ['tab-status'];
  if (className) {
    classNames.push(className);
  }
  if (status) {
    classNames.push(status);
  }
  if (selected) {
    classNames.push('selected');
  }
  var handleOnClick = function handleOnClick(event) {
    event.preventDefault();
    if (onClick) {
      onClick(status);
    }
  };
  return _react2.default.createElement(
    _semanticUiReact.Grid.Column,
    {
      textAlign: 'center',
      className: classNames.join(' '),
      onClick: handleOnClick
    },
    _react2.default.createElement(
      'p',
      null,
      count
    ),
    name,
    selected ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron down' }) : null
  );
};

FixedBarStatus.contextTypes = {
  store: _propTypes2.default.object
};

FixedBarStatus.propTypes = {
  className: _propTypes2.default.string,
  status: _propTypes2.default.string,
  name: _propTypes2.default.string,
  count: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  onClick: _propTypes2.default.func,
  selected: _propTypes2.default.bool
};

exports.default = FixedBarStatus;

/***/ }),
/* 1019 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _close = __webpack_require__(298);

var _close2 = _interopRequireDefault(_close);

var _HLBCampaignMainBanner = __webpack_require__(1020);

var _HLBCampaignMainBanner2 = _interopRequireDefault(_HLBCampaignMainBanner);

var _HLBCampaignTncModal = __webpack_require__(1021);

var _HLBCampaignTncModal2 = _interopRequireDefault(_HLBCampaignTncModal);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _banks = __webpack_require__(581);

var _banks2 = _interopRequireDefault(_banks);

var _regex = __webpack_require__(143);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HLBCampaignJoinModal = function (_Component) {
  _inherits(HLBCampaignJoinModal, _Component);

  function HLBCampaignJoinModal(props) {
    var _this2 = this;

    _classCallCheck(this, HLBCampaignJoinModal);

    var _this = _possibleConstructorReturn(this, (HLBCampaignJoinModal.__proto__ || Object.getPrototypeOf(HLBCampaignJoinModal)).call(this, props));

    _this.getBankOptions = function () {
      var auth = _this.props.auth;

      var countryCode = auth && auth.company && auth.company.countryCode && auth.company.countryCode.toLowerCase() || 'my';
      var banksByCountry = _banks2.default.find(function (b) {
        return b.country === countryCode;
      });

      if (banksByCountry) {
        return {
          data: banksByCountry.value.map(function (bank) {
            return {
              key: bank.value,
              value: bank.value,
              text: bank.text
            };
          })
        };
      }
      var myBanks = _banks2.default.find(function (b) {
        return b.country === 'my';
      });
      return {
        data: myBanks ? myBanks.value.map(function (bank) {
          return {
            key: bank.value,
            value: bank.value,
            text: bank.text
          };
        }) : []
      };
    };

    _this.fetchUserDetailsAndAutofill = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var auth, store, res, userData, token, fullName, identityNo, bankAccountName, bankAccountNumber, hasAllFields;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              auth = _this.props.auth;
              store = _this.context.store;
              _context.prev = 2;
              _context.next = 5;
              return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/staffs/' + auth.affiliateID + '/', {
                credentials: 'include',
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }));

            case 5:
              res = _context.sent;

              if (!res.ok) {
                _context.next = 17;
                break;
              }

              _context.next = 9;
              return res.json();

            case 9:
              userData = _context.sent;
              token = res.headers.get('X-Csrf-Token');
              fullName = userData.fullName || '';
              identityNo = userData.identityNo || '';
              bankAccountName = userData.bankAccountName || '';
              bankAccountNumber = userData.bankAccountNumber || '';
              hasAllFields = fullName && identityNo && bankAccountName && bankAccountNumber;


              _this.setState({
                fullName: fullName,
                identityNo: identityNo,
                bankAccountName: bankAccountName,
                bankAccountNumber: bankAccountNumber,
                bankList: _this.getBankOptions(),
                editMode: hasAllFields,
                token: token,
                originalValues: {
                  fullName: fullName,
                  identityNo: identityNo,
                  bankAccountName: bankAccountName,
                  bankAccountNumber: bankAccountNumber
                }
              }, function () {
                _this.setState({ hasChanges: _this.hasFormChanges() });
              });

            case 17:
              _context.next = 22;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context['catch'](2);

              _this.setState({
                fullName: '',
                bankList: _this.getBankOptions(),
                editMode: false,
                originalValues: {
                  fullName: '',
                  identityNo: '',
                  bankAccountName: '',
                  bankAccountNumber: ''
                }
              }, function () {
                _this.setState({ hasChanges: _this.hasFormChanges() });
              });

            case 22:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[2, 19]]);
    }));

    _this.hasFormChanges = function () {
      var _this$state = _this.state,
          fullName = _this$state.fullName,
          identityNo = _this$state.identityNo,
          bankAccountName = _this$state.bankAccountName,
          bankAccountNumber = _this$state.bankAccountNumber,
          originalValues = _this$state.originalValues,
          editMode = _this$state.editMode;


      var normalizeValue = function normalizeValue(value) {
        return value || '';
      };

      if (editMode) {
        var fullNameChanged = normalizeValue(fullName) !== normalizeValue(originalValues.fullName);
        var identityNoChanged = normalizeValue(identityNo) !== normalizeValue(originalValues.identityNo);
        var bankAccountNameChanged = normalizeValue(bankAccountName) !== normalizeValue(originalValues.bankAccountName);
        var bankAccountNumberChanged = normalizeValue(bankAccountNumber) !== normalizeValue(originalValues.bankAccountNumber);

        return fullNameChanged || identityNoChanged || bankAccountNameChanged || bankAccountNumberChanged;
      }

      return !!(normalizeValue(fullName).trim() || normalizeValue(identityNo).trim() || normalizeValue(bankAccountName) || normalizeValue(bankAccountNumber).trim());
    };

    _this.validate = function () {
      var errors = {};
      var _this$state2 = _this.state,
          fullName = _this$state2.fullName,
          identityNo = _this$state2.identityNo,
          bankAccountName = _this$state2.bankAccountName,
          bankAccountNumber = _this$state2.bankAccountNumber,
          agreed = _this$state2.agreed;


      var hasBankDetails = bankAccountName || bankAccountNumber && bankAccountNumber.trim();

      if (hasBankDetails) {
        if (!fullName || !fullName.trim()) {
          errors.fullName = 'Full Name is required';
        } else {
          var fullNameRegex = _regex.REGEX_FULL_NAME;
          if (!fullNameRegex.test(fullName.trim())) {
            errors.fullName = 'Full Name does not match the format';
          }
        }
      } else if (fullName && fullName.trim()) {
        var _fullNameRegex = _regex.REGEX_FULL_NAME;
        if (!_fullNameRegex.test(fullName.trim())) {
          errors.fullName = 'Full Name does not match the format';
        }
      }
      if (!identityNo || !identityNo.trim()) {
        errors.identityNo = 'NRIC is required';
      } else {
        try {
          var identityValidation = (0, _webValidations.identity)(identityNo.trim(), {
            countryCode: 'MY',
            identityType: 'ic_number'
          });
          if (!identityValidation.isValid) {
            errors.identityNo = 'Invalid NRIC format';
          }
        } catch (error) {
          errors.identityNo = 'Invalid NRIC format';
        }
      }
      if (bankAccountNumber && bankAccountNumber.trim()) {
        if (!bankAccountName) {
          errors.bankAccountName = 'Bank is required';
        }
      }
      if (bankAccountName) {
        if (!bankAccountNumber || !bankAccountNumber.trim()) {
          errors.bankAccountNumber = 'Bank account number is required';
        } else {
          var bankAccountRegex = _regex.REGEX_BANK_ACCOUNT_NUMBER;
          if (!bankAccountRegex.test(bankAccountNumber.trim())) {
            errors.bankAccountNumber = 'Bank Account Number does not match the format';
          }
        }
      }
      if (!agreed) {
        errors.agreed = 'You must agree to the terms';
      }

      return errors;
    };

    _this.handleOnClose = function () {
      _this.setState({
        show: false,
        fullName: '',
        identityNo: '',
        bankAccountName: '',
        bankAccountNumber: '',
        agreed: false,
        errors: {},
        editMode: false,
        isSubmitting: false,
        token: null,
        originalValues: {
          fullName: '',
          identityNo: '',
          bankAccountName: '',
          bankAccountNumber: ''
        },
        hasChanges: false
      });

      if (_this.props.onClose) {
        _this.props.onClose();
      }
    };

    _this.handleOnCloseTnc = function () {
      _this.setState({ openTncModal: false });
    };

    _this.handleOnOpenTnc = function () {
      _this.setState({ openTncModal: true });
    };

    _this.handleInputChange = function (e, _ref2) {
      var _this$setState;

      var name = _ref2.name,
          value = _ref2.value;

      _this.setState((_this$setState = {}, _defineProperty(_this$setState, name, value), _defineProperty(_this$setState, 'errors', _extends({}, _this.state.errors, _defineProperty({}, name, null))), _this$setState), function () {
        _this.setState({ hasChanges: _this.hasFormChanges() });
      });
    };

    _this.handleSubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _this$state3, fullName, identityNo, bankAccountName, bankAccountNumber, editMode, store, auth, errors, errorMessages, submissionData, apiEndpoint, res, errorData;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$state3 = _this.state, fullName = _this$state3.fullName, identityNo = _this$state3.identityNo, bankAccountName = _this$state3.bankAccountName, bankAccountNumber = _this$state3.bankAccountNumber, editMode = _this$state3.editMode;
              store = _this.context.store;
              auth = _this.props.auth;
              errors = _this.validate();

              if (!(Object.keys(errors).length > 0)) {
                _context2.next = 14;
                break;
              }

              _this.setState({ errors: errors });
              errorMessages = Object.keys(errors).map(function (key) {
                return errors[key];
              });

              if (!(errorMessages.length === 1)) {
                _context2.next = 11;
                break;
              }

              _context2.next = 10;
              return store.dispatch((0, _flash.flashErrorMessage)({
                message: errorMessages[0]
              }));

            case 10:
              return _context2.abrupt('return');

            case 11:
              _context2.next = 13;
              return store.dispatch((0, _flash.flashErrorMessage)({
                list: errorMessages
              }));

            case 13:
              return _context2.abrupt('return');

            case 14:
              _this.setState({ isSubmitting: true });
              _context2.prev = 15;
              submissionData = {
                fullName: fullName,
                identityNo: identityNo,
                bankAccountName: bankAccountName,
                bankAccountNumber: bankAccountNumber
              };
              apiEndpoint = _config2.default.get('bookApiURL') + '/staffs/' + auth.affiliateID + '/';
              _context2.next = 20;
              return store.dispatch((0, _fetchM.fetchM)(apiEndpoint, {
                credentials: 'include',
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Csrf-Token': _this.state.token
                },
                body: JSON.stringify(submissionData)
              }));

            case 20:
              res = _context2.sent;

              if (!res.ok) {
                _context2.next = 29;
                break;
              }

              _context2.next = 24;
              return res.json();

            case 24:
              _context2.next = 26;
              return store.dispatch((0, _flash.flashSuccessMessage)({
                message: editMode ? 'Bank details updated successfully' : 'Bank details submitted successfully'
              }));

            case 26:
              _this.handleOnClose();
              _context2.next = 33;
              break;

            case 29:
              _context2.next = 31;
              return res.json();

            case 31:
              errorData = _context2.sent;
              throw new Error(errorData.message || 'Failed to submit bank details');

            case 33:
              _context2.next = 39;
              break;

            case 35:
              _context2.prev = 35;
              _context2.t0 = _context2['catch'](15);
              _context2.next = 39;
              return store.dispatch((0, _flash.flashErrorMessage)({
                message: _context2.t0.message || 'An error occurred while submitting your bank details. Please try again.'
              }));

            case 39:
              _context2.prev = 39;

              _this.setState({ isSubmitting: false });
              return _context2.finish(39);

            case 42:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[15, 35, 39, 42]]);
    }));

    _this.state = {
      show: false,
      agreed: false,
      fullName: '',
      identityNo: '',
      bankAccountName: '',
      bankList: [],
      bankAccountNumber: '',
      editMode: false,
      errors: {},
      openTncModal: false,
      isSubmitting: false,
      token: null,
      originalValues: {
        fullName: '',
        identityNo: '',
        bankAccountName: '',
        bankAccountNumber: ''
      },
      hasChanges: false
    };
    return _this;
  }

  _createClass(HLBCampaignJoinModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var show = nextProps.show;

      var wasShown = this.props.show;

      this.setState({ show: show });
      if (show && !wasShown) {
        this.fetchUserDetailsAndAutofill();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          show = _state.show,
          agreed = _state.agreed,
          bankList = _state.bankList,
          fullName = _state.fullName,
          identityNo = _state.identityNo,
          bankAccountName = _state.bankAccountName,
          bankAccountNumber = _state.bankAccountNumber,
          editMode = _state.editMode,
          errors = _state.errors,
          isSubmitting = _state.isSubmitting,
          hasChanges = _state.hasChanges;


      return _react2.default.createElement(
        _semanticUiReact.Modal,
        { size: 'small', open: show, onClose: this.handleOnClose },
        _react2.default.createElement(
          _semanticUiReact.Modal.Header,
          null,
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', justifyContent: 'space-between' } },
            _react2.default.createElement(
              'span',
              { style: { fontSize: '18px', fontWeight: '600' } },
              'Confirm Your Participation'
            ),
            _react2.default.createElement(
              'button',
              {
                type: 'button',
                onClick: this.handleOnClose,
                style: {
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center'
                },
                'aria-label': 'Close'
              },
              _react2.default.createElement('img', {
                src: _close2.default,
                width: 20,
                alt: 'close'
              })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { className: 'hlb-campaign-welcome-modal-content' },
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            _react2.default.createElement(_HLBCampaignMainBanner2.default, null)
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: { marginTop: '2em' } },
            _react2.default.createElement(
              _semanticUiReact.Segment,
              null,
              _react2.default.createElement(
                'p',
                { style: { fontSize: '16px', fontWeight: '600' } },
                'Register bank account for rewards'
              ),
              _react2.default.createElement(
                _semanticUiReact.Form,
                { className: 'hlb-campaign-form', id: 'hlb-campaign-join-form', onSubmit: this.handleSubmit },
                _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  { error: !!errors.fullName },
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'fullName', style: { marginBottom: '0.5em', fontWeight: '600' } },
                    'Full name (as in MyKad)'
                  ),
                  _react2.default.createElement(_semanticUiReact.Form.Input, {
                    name: 'fullName',
                    placeholder: 'Full name',
                    value: fullName,
                    onChange: this.handleInputChange,
                    error: errors.fullName && _react2.default.createElement(
                      'div',
                      { className: 'hlb-form-error-message' },
                      errors.fullName
                    )
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  { error: !!errors.identityNo },
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'nric', style: { marginBottom: '0.5em', fontWeight: '600' } },
                    'MyKad (NRIC)'
                  ),
                  _react2.default.createElement(_semanticUiReact.Form.Input, {
                    name: 'identityNo',
                    placeholder: 'MyKad (NRIC)',
                    value: identityNo,
                    onChange: this.handleInputChange,
                    error: errors.identityNo && _react2.default.createElement(
                      'div',
                      { className: 'hlb-form-error-message' },
                      errors.identityNo
                    )
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  { error: !!errors.bankAccountName },
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'bank', style: { marginBottom: '0.5em', fontWeight: '600' } },
                    'Bank'
                  ),
                  _react2.default.createElement(_semanticUiReact.Form.Dropdown, {
                    placeholder: 'Bank',
                    fluid: true,
                    selection: true,
                    name: 'bankAccountName',
                    value: bankAccountName,
                    onChange: function onChange(e, _ref4) {
                      var value = _ref4.value;
                      return _this3.handleInputChange(e, { name: 'bankAccountName', value: value });
                    },
                    options: bankList.data || [],
                    error: errors.bankAccountName && _react2.default.createElement(
                      'div',
                      { className: 'hlb-form-error-message' },
                      errors.bankAccountName
                    )
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  { error: !!errors.bankAccountNumber },
                  _react2.default.createElement(
                    'label',
                    { htmlFor: 'bankAccountNumber', style: { marginBottom: '0.5em', fontWeight: '600' } },
                    'Bank account number'
                  ),
                  _react2.default.createElement(_semanticUiReact.Form.Input, {
                    name: 'bankAccountNumber',
                    placeholder: 'Bank account number',
                    value: bankAccountNumber,
                    onChange: this.handleInputChange,
                    error: errors.bankAccountNumber && _react2.default.createElement(
                      'div',
                      { className: 'hlb-form-error-message' },
                      errors.bankAccountNumber
                    )
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  { error: !!errors.agreed },
                  _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    label: _react2.default.createElement(
                      'label',
                      { htmlFor: 'agreeTerms', style: { fontSize: '12px' } },
                      'I agree to the \xA0',
                      _react2.default.createElement(
                        'button',
                        {
                          type: 'button',
                          className: 'hlb-campaign-link',
                          onClick: this.handleOnOpenTnc,
                          style: { background: 'none', border: 'none', padding: 0 },
                          'aria-label': 'Open Terms and Conditions'
                        },
                        'Terms and Conditions'
                      ),
                      ', and consent to the processing of my personal details collected as stated above'
                    ),
                    checked: agreed,
                    name: 'agreeTerms',
                    onChange: function onChange(e, data) {
                      return _this3.setState({
                        agreed: data.checked,
                        errors: _extends({}, _this3.state.errors, {
                          agreed: data.checked ? null : _this3.state.errors.agreed
                        })
                      }, function () {
                        _this3.setState({ hasChanges: _this3.hasFormChanges() });
                      });
                    },
                    error: errors.agreed && _react2.default.createElement(
                      'div',
                      { className: 'hlb-form-error-message' },
                      errors.agreed
                    )
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', justifyContent: 'end', marginTop: '2em' } },
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  type: 'submit',
                  primary: true,
                  form: 'hlb-campaign-join-form',
                  disabled: !agreed || isSubmitting || !hasChanges,
                  loading: isSubmitting
                },
                editMode ? 'Update' : 'Confirm'
              )
            )
          ),
          _react2.default.createElement(_HLBCampaignTncModal2.default, {
            open: this.state.openTncModal,
            onClose: this.handleOnCloseTnc
          })
        )
      );
    }
  }]);

  return HLBCampaignJoinModal;
}(_react.Component);

HLBCampaignJoinModal.propTypes = {
  show: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  auth: _propTypes2.default.shape({
    id: _propTypes2.default.number,
    email: _propTypes2.default.string,
    preferredName: _propTypes2.default.string,
    affiliateID: _propTypes2.default.number,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  })
};
HLBCampaignJoinModal.contextTypes = {
  store: _propTypes2.default.object
};

HLBCampaignJoinModal.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

exports.default = (0, _reactRedux.connect)(HLBCampaignJoinModal.mapStateToProps)(HLBCampaignJoinModal);

/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HLBCampaignMainBanner = function (_Component) {
  _inherits(HLBCampaignMainBanner, _Component);

  function HLBCampaignMainBanner() {
    _classCallCheck(this, HLBCampaignMainBanner);

    return _possibleConstructorReturn(this, (HLBCampaignMainBanner.__proto__ || Object.getPrototypeOf(HLBCampaignMainBanner)).apply(this, arguments));
  }

  _createClass(HLBCampaignMainBanner, [{
    key: "render",
    value: function render() {
      return _react2.default.createElement(
        "div",
        { className: "hlb-campaign-main-banner" },
        _react2.default.createElement(
          "h2",
          { className: "hlb-campaign-main-banner-title" },
          "MHub Loan Tracker Campaign"
        ),
        _react2.default.createElement(
          "span",
          { className: "hlb-campaign-main-banner-subtitle" },
          "28 Aug - 31 Dec 2025"
        ),
        _react2.default.createElement(
          "div",
          { className: "hlb-campaign-main-banner-content" },
          _react2.default.createElement(
            "div",
            { style: { display: 'flex', flexDirection: 'column', textAlign: 'center', gap: '0.5em' } },
            _react2.default.createElement(
              "span",
              { style: { fontFamily: 'Montserrat', fontSize: '11px', lineHeight: '100%', fontWeight: '600' } },
              "Get"
            ),
            _react2.default.createElement(
              "span",
              { style: { fontFamily: 'Cinzel', fontSize: '26px', lineHeight: '100%', fontWeight: '700' } },
              "RM"
            )
          ),
          _react2.default.createElement(
            "span",
            { style: { fontFamily: 'Cinzel', fontSize: '52px', lineHeight: '100%', marginTop: '5px', fontWeight: '900' } },
            "10"
          ),
          _react2.default.createElement(
            "span",
            { style: { fontSize: '12px', fontWeight: '600' } },
            "Get RM10 from MHub for every case you send to Hong Leong Bank!*"
          )
        ),
        _react2.default.createElement(
          "div",
          { style: { display: 'flex', width: '100%', justifyContent: 'end', marginTop: '1em', marginRight: '1em' } },
          _react2.default.createElement(
            "span",
            { style: { fontSize: '8px', fontWeight: '600', letterSpacing: '4%' } },
            "*Terms & conditions apply"
          )
        )
      );
    }
  }]);

  return HLBCampaignMainBanner;
}(_react.Component);

exports.default = HLBCampaignMainBanner;

/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HLBCampaignTncModal = function (_Component) {
  _inherits(HLBCampaignTncModal, _Component);

  function HLBCampaignTncModal(props) {
    _classCallCheck(this, HLBCampaignTncModal);

    var _this = _possibleConstructorReturn(this, (HLBCampaignTncModal.__proto__ || Object.getPrototypeOf(HLBCampaignTncModal)).call(this, props));

    _initialiseProps.call(_this);

    var state = HLBCampaignTncModal.getPropsToState(props);
    _this.state = _extends({}, state);
    return _this;
  }

  _createClass(HLBCampaignTncModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = HLBCampaignTncModal.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var open = this.state.open;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          size: 'large',
          open: open,
          onClose: this.handleOnClose,
          closeIcon: 'close'
        },
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { className: 'hlb-campaign-terms-modal-content' },
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            _react2.default.createElement(
              'div',
              { className: 'hlb-campaign-main-banner' },
              _react2.default.createElement(
                'h2',
                { className: 'hlb-campaign-main-banner-title' },
                'Terms & Conditions'
              ),
              _react2.default.createElement(
                'span',
                { className: 'hlb-campaign-main-banner-subtitle', style: { marginBottom: '20px' } },
                'MHub Loan Tracker Campaign'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: { marginTop: '2em' } },
            _react2.default.createElement(
              'p',
              { className: 'header' },
              'Terms and Conditions'
            ),
            _react2.default.createElement(
              'p',
              { className: 'title' },
              'Campaign period'
            ),
            _react2.default.createElement(
              _semanticUiReact.List,
              { bulleted: true },
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'The Campaign starts of the 28th of Aug and ends on 31st Dec 2025'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: { marginTop: '1em' } },
            _react2.default.createElement(
              'p',
              { className: 'title' },
              'Campaign'
            ),
            _react2.default.createElement(
              _semanticUiReact.List,
              { bulleted: true },
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Cases sent to HLB through TRB Ventures Sdn Bhd Showroom during this period will qualify for cash payout Cases sent to HLB through TRB Ventures Sdn Bhd Showroom during this period will qualify for cash payout'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: { marginTop: '1em' } },
            _react2.default.createElement(
              'p',
              { className: 'title' },
              'Eligibility'
            ),
            _react2.default.createElement(
              _semanticUiReact.List,
              { bulleted: true },
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Only agents that have access to MHub Showroom in Malaysia can participate'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Only applicable to bookings under Booked/Reserved status'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Only applicable to bookings made during the campaign period'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Bookings cannot be made under the property agent\u2019s name. Any agent wishing to book a property in his or her own name, under a genuine transaction must write to TRB Ventures Sdn Bhd to seek eligibility to add the booking. Requests can be sent to victor@mhub.my'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Participants cannot be related to TRB Ventures Sdn Bhd management staff'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Only valid for projects prequalified by the TRB Ventures Sdn Bhd'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'TRB Ventures Sdn Bhd reserve the right to deduct bank transaction fees for the cash payout'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: { marginTop: '1em' } },
            _react2.default.createElement(
              'p',
              { className: 'title' },
              'Cash payout'
            ),
            _react2.default.createElement(
              _semanticUiReact.List,
              { bulleted: true },
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'RM10 will be paid to agents who submit cases (with the consent of the purchaser) to HLB through TRB Ventures Sdn Bhd Showroom exclusively. Agents who submit it to HLB through TRB Ventures Sdn Bhd Showroom as well as directly to HLB will not be eligible for the cash payout'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'TRB Ventures Sdn Bhd will transfer the payment to eligible agents every 15th and 30th of the month'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Qualifying agents must submit their bank details to TRB Ventures Sdn Bhd to receive payout. Payment is deemed to have been made once TRB Ventures Sdn Bhd has made the transfer even if the agent does not receive the payment'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: { marginTop: '1em' } },
            _react2.default.createElement(
              'p',
              { className: 'title' },
              'Disqualification'
            ),
            _react2.default.createElement(
              _semanticUiReact.List,
              { bulleted: true },
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Without prejudice to any right which TRB Ventures Sdn Bhd may have in law, TRB Ventures Sdn Bhd reserves the right at its sole discretion to disqualify any Eligible Participant(s) and/or forfeit any reward from the Eligible Participant who:'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.List,
              { as: 'ul' },
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'i. TRB Ventures Sdn Bhd determines to be tampering with the entry process or the operation of the Campaign, or to be acting in breach or potential breach of this Terms and Conditions; or'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'ii. TRB Ventures Sdn Bhd believes has undertaken fraudulent practice and/or activities or other activities harmful to this Campaign or the Campaign submission process. Fraudulent activities are deemed to include but not be limited to any act of deceit and/or deception and/or cheating.'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: { marginTop: '1em' } },
            _react2.default.createElement(
              'p',
              { className: 'title' },
              'Variation'
            ),
            _react2.default.createElement(
              _semanticUiReact.List,
              { bulleted: true },
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'TRB Ventures Sdn Bhd reserve the right to vary the terms of the campaign including the amount of cash payout and prizes awarded'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Where the prizes announced no longer is available for TRB Ventures Sdn Bhd to purchase TRB Ventures Sdn Bhd reserves the right to choose a substitute of similar value'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: { marginTop: '1em' } },
            _react2.default.createElement(
              'p',
              { className: 'title' },
              'TRB Ventures Sdn Bhd\'s decision'
            ),
            _react2.default.createElement(
              _semanticUiReact.List,
              { bulleted: true },
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'All decisions made by TRB Ventures Sdn Bhd relating to or in connection with the Campaign including and without limitation, the process and manner the entries are judged shall be final and no appeal, query or correspondence shall be entertained.'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'TRB Ventures Sdn Bhd will transfer the payment to eligible agents every 15th and 30th of the month'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Qualifying agents must submit their bank details to TRB Ventures Sdn Bhd to receive payout. Payment is deemed to have been made once TRB Ventures Sdn Bhd has made the transfer even if the agent does not receive the payment'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: { marginTop: '1em' } },
            _react2.default.createElement(
              'p',
              { className: 'title' },
              'Usage of Participants Data and Image'
            ),
            _react2.default.createElement(
              _semanticUiReact.List,
              { bulleted: true },
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'By participating in this Campaign, Eligible Participant agrees to be bound by these terms and conditions and consent to allow his/her personal data being collected, processed and used by TRB Ventures Sdn Bhd in accordance with TRB Ventures Sdn Bhd Privacy Notice stipulated in the Appendix 1 (\u201CPrivacy Notice\u201D).'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.List,
              { as: 'ul' },
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                '* Subject to the Privacy Notice, by participating in this contest, each Eligible Participant agrees that all details submitted pursuant to this Campaign, including without limitation personal data/ information being collected, processed and used by TRB Ventures Sdn Bhd for:'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                '** The purpose of this Campaign such as marketing and promotional activities conducted in such manner as TRB Ventures Sdn Bhd sees fit nationwide or worldwide in any media including without limitation to the internet, without further express consent from, and payment or consideration to the relevant Eligible Participants.'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                '*** Marketing and promotional activities include without limitation the use and/or publication of any details provided in and/or in connection to the entries, interview material as well responses and related photographs.'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                '**** The winner expressly grant permission to TRB Ventures Sdn Bhd and its agencies or partners to use the winner\u2019s name, photograph and/or likeness for purposes of advertising, editorial, promotional, marketing, trade and/or other purposes without further compensation and notice.'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: { marginTop: '1em', marginBottom: '2em' } },
            _react2.default.createElement(
              'p',
              { className: 'title' },
              'General Terms'
            ),
            _react2.default.createElement(
              _semanticUiReact.List,
              { bulleted: true },
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'TRB Ventures Sdn Bhd reserves the right to cancel, terminate or suspend the Campaign without any prior notice and reason. For the avoidance of doubt, any cancellation, termination or suspension by TRB Ventures Sdn Bhd of this contest shall not entitle the participant to any claim or compensation against TRB Ventures Sdn Bhd for any or all losses or damages suffered or incurred as a direct or indirect result of the act of cancellation, termination or suspension.'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.List,
              { as: 'ul' },
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                '* In the event of any inconsistency between these Terms and Conditions and any advertising, promotional, publicity and other materials relating to or in connection with the Campaign, these Terms and Conditions shall prevail.'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                '** This Campaign can only be used for single transaction, normal priced items and cannot be bundled with other ongoing promotions'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                '***  This Campaign cannot be stacked with other voucher, or promotion codes.'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.List,
              { bulleted: true },
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Each buyer is eligible for only one payment. If the same customer switches units and the agent resubmits the case, or if the agent selects both Hong Leong Bank and Hong Leong Islamic Bank for the same customer, the organizer will consider it as a single referral qualifying for payment.'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'If the payment date falls on a public holiday, payment will be processed on the next working day.'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Cases submitted after 10:00 AM on the 12th or 25th of the month will be included in the next payment cycle.'
              )
            )
          )
        )
      );
    }
  }]);

  return HLBCampaignTncModal;
}(_react.Component);

HLBCampaignTncModal.propTypes = {
  onClose: _propTypes2.default.func
};

HLBCampaignTncModal.getPropsToState = function (props) {
  var open = props.open;
  return {
    open: open
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleOnClose = function () {
    _this2.props.onClose();
  };
};

exports.default = HLBCampaignTncModal;

/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var himsMsgIncomplete = 'The given data was invalid.';
var himsDefaultErrorStatus422 = 'The data provided cannot be accepted as valid. Please review and verify the information to ensure its accuracy and reliability. If the problem persists, please report your problem to support@mhub.my and mention this error message.';
var himsDefaultErrorCode9 = 'The permit for this project has been canceled. Kindly seek clarification from HIMS for further details.';

var HimsErrorLog = function (_Component) {
  _inherits(HimsErrorLog, _Component);

  function HimsErrorLog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HimsErrorLog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HimsErrorLog.__proto__ || Object.getPrototypeOf(HimsErrorLog)).call.apply(_ref, [this].concat(args))), _this), _this.getHimsNewBuyer = function (statusCode) {
      switch (statusCode) {
        case 5:
          return 'Please set the formula in Pricing Package for Bumi Discount category (Diskaun Kuota Bumi) as the value cannot be RM 0.00';
        case 6:
          return 'The SPJB Price (SPA price) surpasses the approved sales price in HIMS. Please verify both the SPA price and the approved price in HIMS to ensure it remains within the approved sales price limit.';
        case 7:
          return 'This unit has already been sold in HIMS, and your request could not be processed through MHub. Please review the unit information in HIMS for further clarification.';
        case 8:
          return 'This unit has been registered for land owner in HIMS, and your request could not be processed through MHub. Please review the unit information in HIMS for further clarification.';
        default:
          return himsDefaultErrorStatus422;
      }
    }, _this.getHimsDeleteBuyer = function (statusCode) {
      switch (statusCode) {
        case 7:
          return 'This buyer are not allowed to delete using this API. Please submit your cancellation via HIMS.';
        case 8:
          return 'This purchaser is considered as First Buyer in HIMS, and your request could not be processed through MHub. Please submit your application Pembatalan Pembeli Pertama via HIMS.';
        default:
          return himsDefaultErrorStatus422;
      }
    }, _this.getHimsSuggestion = function () {
      var _this$props = _this.props,
          httpStatus = _this$props.httpStatus,
          action = _this$props.action,
          response = _this$props.response;

      if (!response) {
        return '';
      }
      var message = response.message,
          statusCode = response.status_code;

      switch (httpStatus) {
        case 401:
          return 'The request is denied due to an authentication error. If the problem persists, please report your problem to support@mhub.my and mention this error message and the query that caused it.';
        case 404:
          return 'The server encountered an error and could not complete your request. If the problem persists, please report your problem to support@mhub.my and mention this error message and the query that caused it.';
        case 422:
          if (statusCode === 9) {
            return himsDefaultErrorCode9;
          }
          switch (action) {
            case 'new_buyer':
              return _this.getHimsNewBuyer(statusCode);
            case 'delete_buyer':
              return _this.getHimsDeleteBuyer(statusCode);
            case 'change_buyer':
              if (message.startsWith('Permission denied!')) {
                return _this.getHimsDeleteBuyer(statusCode);
              }
              return _this.getHimsNewBuyer(statusCode);
            default:
              return himsDefaultErrorStatus422;
          }
        case 500:
          return 'The server encountered an error and could not complete your request. If the problem persists, please report your problem to support@mhub.my and mention this error message and the query that caused it.';
        default:
          return '';
      }
    }, _this.getErrorItems = function () {
      var _this$props2 = _this.props,
          errors = _this$props2.errors,
          response = _this$props2.response;

      var errMessage = himsMsgIncomplete;
      if (response && response.message) {
        errMessage = response.message;
      }

      if (errMessage === himsMsgIncomplete) {
        return errors.filter(function (d) {
          return d !== himsMsgIncomplete;
        }).map(function (d, idx) {
          return _react2.default.createElement(
            _semanticUiReact.List.Item,
            { key: 'hims_error_' + idx },
            d
          );
        });
      }
      return [];
    }, _this.renderHeader = function () {
      var _this$props3 = _this.props,
          httpStatus = _this$props3.httpStatus,
          response = _this$props3.response;

      var header = 'Incomplete required information';
      if (response && response.message) {
        header = httpStatus + ' ' + response.message;
      }
      return _react2.default.createElement(
        'h3',
        null,
        'Error: ',
        header
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HimsErrorLog, [{
    key: 'render',
    value: function render() {
      var suggestion = this.getHimsSuggestion();
      var errorItems = this.getErrorItems();
      return _react2.default.createElement(
        'div',
        null,
        this.renderHeader(),
        suggestion && _react2.default.createElement(
          'p',
          null,
          suggestion
        ),
        errorItems.length > 0 && _react2.default.createElement(
          'p',
          null,
          'Please complete the information below:'
        ),
        errorItems.length > 0 && _react2.default.createElement(
          _semanticUiReact.List,
          { bulleted: true },
          errorItems
        )
      );
    }
  }]);

  return HimsErrorLog;
}(_react.Component);

HimsErrorLog.propTypes = {
  httpStatus: _propTypes2.default.number,
  action: _propTypes2.default.string,
  response: _propTypes2.default.shape({
    status_code: _propTypes2.default.number,
    message: _propTypes2.default.string
  }),
  errors: _propTypes2.default.arrayOf(_propTypes2.default.string)
};
exports.default = HimsErrorLog;

/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LimitCounter = function LimitCounter(_ref) {
  var style = _ref.style,
      current = _ref.current,
      limit = _ref.limit,
      primaryText = _ref.primaryText,
      customText = _ref.customText,
      t = _ref.t;
  return _react2.default.createElement(
    _semanticUiReact.Label,
    { className: 'limit-counter', style: style },
    customText ? customText({ current: current, limit: limit }) : current + ' ' + t('of', { ns: 'translation' }) + ' ' + limit + ' ' + (primaryText || t('items', { ns: 'translation' })) + ' ' + t('selected', { ns: 'translation' })
  );
};

LimitCounter.propTypes = {
  style: _propTypes2.default.shape({
    float: _propTypes2.default.string
  }),
  current: _propTypes2.default.number,
  limit: _propTypes2.default.number,
  primaryText: _propTypes2.default.string,
  customText: _propTypes2.default.func,
  t: _propTypes2.default.func.isRequired
};

exports.default = (0, _reactI18next.withTranslation)()(LimitCounter);

/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _PictureItem = __webpack_require__(564);

var _PictureItem2 = _interopRequireDefault(_PictureItem);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _url = __webpack_require__(19);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogoList = function (_Component) {
  _inherits(LogoList, _Component);

  function LogoList(props) {
    _classCallCheck(this, LogoList);

    var _this = _possibleConstructorReturn(this, (LogoList.__proto__ || Object.getPrototypeOf(LogoList)).call(this, props));

    _initialiseProps.call(_this);

    var state = LogoList.getPropsToState(props);
    var view = props.view || 'list';
    _this.state = _extends({
      count: 0,
      limit: 0,
      offset: 0,
      data: [],
      view: view
    }, state);
    return _this;
  }

  _createClass(LogoList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
        delete query.page;
      }
      this.replaceQuery(query);
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = LogoList.getPropsToState(nextProps);
      if (nextProps.view) {
        if (this.state.view !== nextProps.view) {
          state.view = nextProps.view;
        }
      }
      this.setState(state);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setLogos',
    value: function setLogos() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this2.setState({
          data: data || []
        }, function () {
          res(data);
          if (_this2.props.onChange) {
            _this2.props.onChange(_this2.state.data);
          }
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchLogos',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var store, query, url, res, message, count, limit, offset, data, que;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = Object.assign(q, this.props.where || {});
                url = '/logos/?' + _qs2.default.stringify(query);
                res = void 0;
                _context.prev = 6;
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchM)(url, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context.sent;
                _context.next = 20;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                Bugsnag.notifyException(_context.t0);
                _context.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 17:
                _context.next = 19;
                return this.setLoading(false);

              case 19:
                return _context.abrupt('return');

              case 20:
                if (res.ok) {
                  _context.next = 28;
                  break;
                }

                _context.next = 23;
                return res.text();

              case 23:
                message = _context.sent;
                _context.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context.next = 44;
                break;

              case 28:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context.next = 33;
                return res.json();

              case 33:
                data = _context.sent;
                _context.next = 36;
                return this.setLogos(data);

              case 36:
                if (!(this.state.data.length < 1 && query.page > 1)) {
                  _context.next = 42;
                  break;
                }

                que = (0, _url.decodeSearch)(this.props.location.search);

                que.page = 1;
                this.replaceQuery(que);
                _context.next = 44;
                break;

              case 42:
                _context.next = 44;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 44:
                _context.next = 46;
                return this.setLoading(false);

              case 46:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));

      function fetchLogos() {
        return _ref.apply(this, arguments);
      }

      return fetchLogos;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;
      var pathname = this.props.location.pathname;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      this.fetchLogos(queryNew);
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));
    }
  }, {
    key: 'handleRefetch',
    value: function handleRefetch() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      this.replaceQuery(query);
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this5 = this;

      var t = this.props.t;

      if (this.state.view === 'list') {
        return this.state.data.length > 0 ? this.state.data.map(function (logo, key) {
          return _react2.default.createElement(
            _semanticUiReact.Table.Row,
            {
              key: key,
              disabled: _this5.handleOnCheck(logo),
              onClick: function onClick(e) {
                return _this5.handleOnClick(e, logo);
              }
            },
            !_this5.state.isMobile && _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              { width: 5 },
              _react2.default.createElement(_LoadImage2.default, {
                constrain: true,
                as: 'a',
                centered: true,
                size: 'tiny',
                picture: logo,
                pictureSize: 50,
                extension: 'png',
                onClick: function onClick(e) {
                  return _this5.handleViewLarge(e, logo);
                }
              })
            ),
            !_this5.state.isMobile && _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              { width: 5 },
              _this5.renderLabel(logo)
            ),
            _this5.state.isMobile ? _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 'equal' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 6 },
                  _react2.default.createElement(_LoadImage2.default, {
                    constrain: true,
                    as: 'a',
                    centered: true,
                    size: 'tiny',
                    picture: logo,
                    pictureSize: 50,
                    extension: 'png',
                    onClick: function onClick(e) {
                      return _this5.handleViewLarge(e, logo);
                    }
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { columns: 'equal' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 16 },
                        _this5.renderLabel(logo)
                      )
                    ),
                    _this5.props.buttonNode ? _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 16, textAlign: 'right' },
                        _this5.props.buttonNode({
                          loading: _this5.state.loading,
                          logo: logo,
                          view: _this5.state.view,
                          isMobile: _this5.state.isMobile
                        })
                      )
                    ) : null
                  )
                )
              )
            ) : null,
            !_this5.state.isMobile && _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              _this5.props.buttonNode ? _react2.default.createElement(
                'div',
                { className: 'picture-list-buttons' },
                _this5.props.buttonNode({
                  loading: _this5.state.loading,
                  logo: logo,
                  view: _this5.state.view,
                  isMobile: _this5.state.isMobile
                })
              ) : null
            )
          );
        }) : _react2.default.createElement(
          _semanticUiReact.Table.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { colSpan: this.state.isMobile ? null : 3, textAlign: 'center' },
            this.state.loading ? _react2.default.createElement(
              _semanticUiReact.Loader,
              { active: true, inline: 'centered' },
              t('Loading')
            ) : this.props.notFoundNode || _react2.default.createElement(
              'p',
              null,
              t('No logos found'),
              '.'
            )
          )
        );
      }
      return _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(
            _semanticUiReact.Card.Group,
            { itemsPerRow: this.state.data.length > 0 ? 4 : 1, doubling: true, stackable: true },
            this.state.data.length > 0 ? this.state.data.map(function (logo, key) {
              return _react2.default.createElement(_PictureItem2.default, {
                key: key,
                picture: logo,
                pictureSize: 50,
                onViewLarge: function onViewLarge(e) {
                  return _this5.handleViewLarge(e, logo);
                },
                onRemove: function onRemove(e) {
                  return _this5.handleOnRemove(e, logo);
                },
                extension: 'png',
                hideTags: true,
                fixedSize: true,
                buttonNode: _this5.props.buttonNode ? _this5.props.buttonNode({
                  loading: _this5.state.loading,
                  logo: logo,
                  view: _this5.state.view
                }) : null
              });
            }) : _react2.default.createElement(
              _semanticUiReact.Card,
              null,
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { textAlign: 'center', vertical: true },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  t('Loading')
                ) : this.props.notFoundNode || _react2.default.createElement(
                  'p',
                  null,
                  t('No logos found'),
                  '.'
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          count = _state.count,
          limit = _state.limit,
          offset = _state.offset,
          data = _state.data,
          loading = _state.loading,
          currentPage = _state.currentPage,
          view = _state.view;
      var t = this.props.t;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 20 },
            active: (this.state.loading || this.props.loading) && this.state.data.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading')
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            fixed: view === 'card',
            striped: true, unstackable: true
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: this.state.isMobile ? null : 3 },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { columns: 1, verticalAlign: 'middle' },
                  this.props.toggleable && _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_semanticUiReact.Label, {
                      as: 'button',
                      attached: 'top left',
                      size: 'small',
                      icon: (view === 'list' ? 'block' : 'list') + ' layout',
                      content: t(view === 'list' ? 'Card' : 'List'),
                      onClick: this.handleToggleView,
                      disabled: this.state.loading
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    this.props.headerNode ? this.props.headerNode({
                      count: count,
                      limit: limit,
                      offset: offset,
                      dataSize: data.length,
                      loading: loading,
                      currentPage: currentPage,
                      onChange: this.handleChangePage
                    }) : _react2.default.createElement(_SearchFilter2.default, {
                      inTable: true,
                      advanceFilter: this.state.advanceFilter,
                      isLoading: loading,
                      onChange: this.handleFilterOnChange,
                      onClose: this.handleClearFilter,
                      search: this.state.search,
                      setAdvanceFilter: this.handleSetAdvanceFilter,
                      leftNav: _react2.default.createElement(_PageNav2.default, {
                        currentPage: currentPage,
                        count: count,
                        limit: limit,
                        offset: offset,
                        dataSize: data.length,
                        loading: loading,
                        onChange: this.handleChangePage
                      }),
                      rightNav: this.props.searchRightNav
                    })
                  )
                )
              )
            ),
            view === 'list' && !this.state.isMobile && _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Logo')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Label')
              ),
              _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null)
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            this.renderBody()
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Footer,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: this.state.isMobile ? null : 3 },
                this.props.footerNode ? this.props.footerNode({
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: data.length,
                  loading: loading,
                  currentPage: currentPage,
                  onChange: this.handleChangePage
                }) : _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { columns: 'equal', verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_PageNav2.default, {
                      upward: true,
                      currentPage: currentPage,
                      count: count,
                      limit: limit,
                      offset: offset,
                      dataSize: data.length,
                      loading: loading,
                      onChange: this.handleChangePage
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LogoList;
}(_react.Component);

LogoList.propTypes = {
  notFoundNode: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onCheck: _propTypes2.default.func,
  onViewLarge: _propTypes2.default.func,
  onRemove: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  headerNode: _propTypes2.default.func,
  footerNode: _propTypes2.default.func,
  buttonNode: _propTypes2.default.func,
  where: _propTypes2.default.shape({}),
  toggleable: _propTypes2.default.bool,
  view: _propTypes2.default.oneOf(['list', 'card']),
  searchRightNav: _propTypes2.default.node,
  loading: _propTypes2.default.bool,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
LogoList.contextTypes = {
  store: _propTypes2.default.object
};

LogoList.getPropsToState = function (props) {
  var advanceFilter = false;
  var isMobile = window.innerWidth < 768;
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var types = query.types || [];
  if (types && types.length > 0) {
    advanceFilter = true;
  }
  return {
    advanceFilter: advanceFilter,
    isMobile: isMobile,
    currentPage: currentPage,
    search: search,
    types: types
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.handleResize = function () {
    var isMobile = window.innerWidth < 768;
    if (isMobile !== _this6.state.isMobile) {
      _this6.setState({ isMobile: isMobile });
    }
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.page = currentPage;
    _this6.setState({
      currentPage: currentPage
    });
    _this6.replaceQuery(query);
  };

  this.handleOnClick = function (e, logo) {
    if (_this6.props.onClick) {
      _this6.props.onClick(e, logo);
    }
  };

  this.handleToggleView = function (e) {
    e.preventDefault();
    var view = _this6.state.view === 'list' ? 'card' : 'list';
    _this6.setState({ view: view });
  };

  this.handleOnCheck = function (logo) {
    if (_this6.props.onCheck) {
      return _this6.props.onCheck({ logo: logo });
    }
    return false;
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    _this6.setState({
      search: ''
    }, function () {
      if (hasQuery) {
        _this6.replaceQuery(query, true);
      }
    });
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query[queryName] = value;
    _this6.replaceQuery(query, true);
  };

  this.handleSetAdvanceFilter = function (advanceFilter) {
    _this6.setState({
      advanceFilter: advanceFilter
    });
  };

  this.handleViewLarge = function (e, logo) {
    if (_this6.props.onViewLarge) {
      _this6.props.onViewLarge(e, logo);
    }
  };

  this.handleOnRemove = function (e, logo) {
    if (_this6.props.onRemove) {
      _this6.props.onRemove(e, logo);
    }
  };

  this.renderLabel = function (logo) {
    var t = _this6.props.t;

    if (logo.label && logo.label.trim().length > 0) {
      return logo.label;
    }
    if (_this6.state.isMobile) {
      return _react2.default.createElement(
        'span',
        { className: 'grey-text' },
        t('No label set')
      );
    }
    return '-';
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })((0, _reactRouter.withRouter)(LogoList, { withRef: true }));

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// When does the refund record for an opportunity need re-reading?
//
// Both places that show it (OpportunityOverviewDetail, Payment) used to re-fetch
// `/unit_reservation_refunds/opportunity/:id/` whenever the props OBJECT changed identity. Overview
// rebuilds `data` as a fresh object on every one of its own state resets (loading flips, tab
// changes, a paymentData/documentData reload), so one tab on the SkyVN UAT tenant issued the same
// GET twenty-four times and got twenty-four 404s (CPI-1388).
//
// The rule: re-read when the fields that travel with a refund change (id, sr_status, status, the
// update stamp when the payload carries one), not when the reference does. This is NOT the only
// trigger, and it must not be: approve / decline write the refund FIRST and only then call
// onUpdateOpportunity (RefundRequestDetail.jsx), so a refund can change while the opportunity's
// fields do not. Those paths refresh explicitly -- RefundRequestDetail's onSuccess re-reads, and a
// replaced refundData list from Opportunities.jsx still re-reads in OpportunityOverviewDetail.

var stamp = function stamp(o) {
  return o && (o.updated_at || o.updatedAt) || null;
};

/** Opportunity fields whose change can mean a different refund record. */
var refundKeyOfOpportunity = exports.refundKeyOfOpportunity = function refundKeyOfOpportunity(d) {
  return d ? [d.id, d.sr_status, d.status, stamp(d)].join('|') : '';
};

/** Payment (unit reservation token) fields whose change can mean a different refund record. */
var refundKeyOfPayment = exports.refundKeyOfPayment = function refundKeyOfPayment(p) {
  return p ? [p.opportunityID, p.id, p.status, stamp(p)].join('|') : '';
};

var shouldRefetchRefund = exports.shouldRefetchRefund = function shouldRefetchRefund(prev, next, keyOf) {
  return keyOf(prev) !== keyOf(next);
};

// Book API only creates a refund record when it moves the opportunity to pending_refund, and the
// record's later states map to refunded / refund_declined. For every other sr_status the GET is a
// guaranteed 404, so the record is not read at all (the console "spam" on ordinary bookings).
var REFUND_SR_STATUSES = ['pending_refund', 'refunded', 'refund_declined'];

/** Whether this opportunity's sr_status is one that can carry a unit reservation refund record. */
var opportunityCanHaveRefund = exports.opportunityCanHaveRefund = function opportunityCanHaveRefund(o) {
  return !!(o && REFUND_SR_STATUSES.includes(o.sr_status));
};

/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _webValidations = __webpack_require__(23);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _uuid = __webpack_require__(1600);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = __webpack_require__(9);

var _decimal2 = __webpack_require__(1157);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _reactRouterRedux = __webpack_require__(13);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _expand = __webpack_require__(3530);

var _expand2 = _interopRequireDefault(_expand);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _Helper = __webpack_require__(381);

var _Helper2 = _interopRequireDefault(_Helper);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _amount = __webpack_require__(87);

var _amount2 = _interopRequireDefault(_amount);

var _decimal3 = __webpack_require__(1089);

var _DateTimePicker = __webpack_require__(314);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

var _arrowUp = __webpack_require__(1595);

var _arrowUp2 = _interopRequireDefault(_arrowUp);

var _arrowDown = __webpack_require__(1594);

var _arrowDown2 = _interopRequireDefault(_arrowDown);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/sort-comp */
/* eslint-disable max-len */
/* eslint-disable arrow-parens */


var PaymentPlanForm = function (_Component) {
  _inherits(PaymentPlanForm, _Component);

  function PaymentPlanForm(props) {
    _classCallCheck(this, PaymentPlanForm);

    var _this = _possibleConstructorReturn(this, (PaymentPlanForm.__proto__ || Object.getPrototypeOf(PaymentPlanForm)).call(this, props));

    _initialiseProps.call(_this);

    var bookingData = props.bookingData,
        bookingPaymentPlan = props.bookingPaymentPlan,
        contractPaymentSchedules = props.contractPaymentSchedules;

    var downpaymentCpss = _this.getCpsByDetailType(contractPaymentSchedules);
    var instalmentCpss = _this.getCpsByDetailType(contractPaymentSchedules, 'instalment');
    var cpss = _this.sortContractPaymentSchedule(contractPaymentSchedules || []);

    _this.validation = {
      downpaymentCount: (0, _react.createRef)(),
      instalmentCount: (0, _react.createRef)()
    };

    _this.state = {
      errMessages: [],
      showDatePicker: '', // NOTE: based on each CPS id
      isDownpaymentAccordionActive: true,
      isInstalmentAccordionActive: true,
      isCollapseInstalmentContent: true,
      formContractPaymentSchedules: cpss,
      selectedBookingPaymentPlan: (0, _clone2.default)(bookingPaymentPlan),
      downpaymentCount: _lodash2.default.size(downpaymentCpss),
      instalmentCount: _lodash2.default.size(instalmentCpss),
      depositAmount: bookingData && bookingData.paymentAmount ? parseFloat(bookingData.paymentAmount) : 0,

      // references
      oriContractPaymentSchedules: cpss,
      oriBookingPaymentPlan: (0, _clone2.default)(bookingPaymentPlan)
    };
    return _this;
  }

  _createClass(PaymentPlanForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.listProjectPaymentSchedules(this.props.bookingData);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var bookingData = nextProps.bookingData,
          bookingPaymentPlan = nextProps.bookingPaymentPlan,
          contractPaymentSchedules = nextProps.contractPaymentSchedules;
      var _state = this.state,
          formContractPaymentSchedules = _state.formContractPaymentSchedules,
          oriContractPaymentSchedules = _state.oriContractPaymentSchedules,
          selectedBookingPaymentPlan = _state.selectedBookingPaymentPlan,
          oriBookingPaymentPlan = _state.oriBookingPaymentPlan,
          depositAmount = _state.depositAmount;


      var newbpp = _extends({}, selectedBookingPaymentPlan);
      var neworibpp = _extends({}, oriBookingPaymentPlan);
      var newcpss = [].concat(_toConsumableArray(formContractPaymentSchedules));
      var oricpss = [].concat(_toConsumableArray(oriContractPaymentSchedules));

      var hasExistingData = !_lodash2.default.isEmpty(bookingPaymentPlan);
      var isNotEdited = _lodash2.default.isEmpty(newcpss);
      if (hasExistingData && isNotEdited) {
        newcpss = contractPaymentSchedules;
        oricpss = contractPaymentSchedules;
        newbpp = bookingPaymentPlan;
        neworibpp = bookingPaymentPlan;
      }
      var downpaymentCpss = this.getCpsByDetailType(newcpss);
      var instalmentCpss = this.getCpsByDetailType(newcpss, 'instalment');
      this.handleSetState({
        selectedBookingPaymentPlan: (0, _clone2.default)(newbpp),
        formContractPaymentSchedules: this.sortContractPaymentSchedule(newcpss) || [],
        downpaymentCount: _lodash2.default.size(downpaymentCpss),
        instalmentCount: _lodash2.default.size(instalmentCpss),
        oriContractPaymentSchedules: this.sortContractPaymentSchedule(oricpss) || [],
        oriBookingPaymentPlan: (0, _clone2.default)(neworibpp),
        depositAmount: bookingData && bookingData.paymentAmount ? parseFloat(bookingData.paymentAmount) : depositAmount
      });
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _props = this.props,
          auth = _props.auth,
          bookingData = _props.bookingData;

      if (auth.isSuperAdmin || auth.isHeadquarters) {
        return true;
      }
      if (auth.isBranchLeaderSupervisorII && bookingData && bookingData.project && bookingData.project.maOwnerCompanyBranchID === auth.companyBranch.id) {
        return true;
      }
      return check;
    }

    // identify mutable and non-mutable contract payment schedule for smart fill


    // categorized cps by detail type downpayment > instalment > development_stage
    // then sort by sequence no


    // smartly update and return booking payment plan detail


    // calculate each of the instalment amount after spa - deposit - downpayment - billed installment amount


    // auto recalculate all the instalment


    // 1. update transaction amount
    // 2. for instalment, balance goes into last CPS
    // 3. set customized flag in bppd smartly
    // 4. for customized downpayment bppd amount type percentage -> fixed + use trx amount


    // only check for date without time


    // increase: add CPS from FE, BE will generate a BPPD
    // decrease: remove CPS and BPPD


    // instalment doesn't need to validate as we have autofill to make it tally


    // try to find error in this.state.errorMessages and return string else return undefined

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          auth = _props2.auth,
          bookingData = _props2.bookingData,
          t = _props2.t;
      var _state2 = this.state,
          errMessages = _state2.errMessages,
          formContractPaymentSchedules = _state2.formContractPaymentSchedules,
          selectedBookingPaymentPlan = _state2.selectedBookingPaymentPlan,
          availablePaymentSchedules = _state2.availablePaymentSchedules,
          depositAmount = _state2.depositAmount;

      var accordionOptions = [];
      var currency = !_lodash2.default.isEmpty(bookingData.project.projectCurrency) && bookingData.project.projectCurrency;
      var spaValue = Number((0, _amount.spaFullNumber)(bookingData));

      // downpayment
      var cpsDownpayments = this.getCpsByDetailType(formContractPaymentSchedules);
      if (!_lodash2.default.isEmpty(cpsDownpayments)) {
        accordionOptions.push({
          id: 'addPaymentPlanDownpayment',
          name: 'isDownpaymentAccordionActive',
          title: t('Downpayment'),
          subtitle: this.renderAmountWithCurrency(this.calculateTotalContractPaymentScheduleAmount(cpsDownpayments), currency),
          content: this.renderDownpaymentContent(cpsDownpayments)
        });
      }

      // instalment
      var cpsInstalments = this.getCpsByDetailType(formContractPaymentSchedules, 'instalment');
      if (!_lodash2.default.isEmpty(cpsInstalments)) {
        accordionOptions.push({
          id: 'addPaymentPlanInstalment',
          name: 'isInstalmentAccordionActive',
          title: t('Instalment'),
          subtitle: this.renderAmountWithCurrency(this.calculateTotalInstalment(), currency),
          content: this.renderInstalmentContent(cpsInstalments)
        });
      }

      return _react2.default.createElement(
        _AppForm2.default,
        {
          as: 'div',
          className: 'paymentPlanForm',
          error: errMessages.length > 0
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'span',
                { className: 'text-subtitle' },
                t('Selling Price')
              ),
              _react2.default.createElement(
                'p',
                { className: 'text-header mt-4' },
                this.renderAmountWithCurrency(spaValue, bookingData.project.projectCurrency)
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 2 },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              this.renderDropdown({
                name: 'paymentScheduleID',
                value: selectedBookingPaymentPlan ? selectedBookingPaymentPlan.psPaymentScheduleID : '',
                label: t('Payment Plan'),
                isRequired: true,
                placeholder: t('Select', { ns: _translation.TRANSLATION_FILES.translation }),
                noResultMsg: t('No payment plan found'),
                options: this.shapeOptions(availablePaymentSchedules, t)
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              this.renderAmountInput({
                label: t('Deposit paid'),
                name: 'depositPaid',
                value: depositAmount,
                idx: 0,
                disabled: bookingData && bookingData.id
              })
            )
          )
        ),
        !_lodash2.default.isEmpty(accordionOptions) && _react2.default.createElement(
          'section',
          null,
          accordionOptions.map(function (opt) {
            return _this2.renderAccordion(opt);
          }),
          this.hasAccess() && _react2.default.createElement(
            'div',
            { className: 'createPsdSection' },
            _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation.TRANSLATION_FILES.screens },
              'Want to create a new payment schedule? Go to',
              this.renderTextButton('Master settings', function () {
                return _this2.handleRedirect(auth && auth.company && auth.company.service_company_id ? _config2.default.get('developerURL') + '/c/' + auth.company.service_company_id + '/projects/' + bookingData.project.id + '/edit?tab=payment_schedule' : undefined);
              })
            )
          )
        )
      );
    }
  }]);

  return PaymentPlanForm;
}(_react.Component);

PaymentPlanForm.contextTypes = {
  store: _propTypes2.default.object
};

PaymentPlanForm.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

PaymentPlanForm.propTypes = {
  token: _propTypes2.default.string,
  auth: _propTypes2.default.shape({
    isSuperAdmin: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool,
    company: _propTypes2.default.shape()
  }),
  onSubmit: _propTypes2.default.func,
  onPaymentPlanSelect: _propTypes2.default.func,
  onSaveDisabled: _propTypes2.default.func,
  bookingPaymentPlan: _propTypes2.default.shape(),
  contractPaymentSchedules: _propTypes2.default.arrayOf(_propTypes2.default.shape()), //  list pending / billed cps
  bookingData: _propTypes2.default.shape(),
  t: _propTypes2.default.func
};
PaymentPlanForm.defaultProps = {
  bookingData: {
    id: '',
    projectID: '',
    projectUnitID: '',
    paymentAmount: 0
  },
  bookingPaymentPlan: {},
  contractPaymentSchedules: []
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.mapCpssWithBppdName = function () {
    var cpss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var bpp = arguments[1];
    return _lodash2.default.map(cpss, function (cps) {
      return _extends({}, cps, {
        name: _this3.getDownpaymentName(bpp, cps.bookingPaymentPlanDetailID, cps.name)
      });
    }) || [];
  };

  this.listProjectPaymentSchedules = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(booking) {
      var store, res, message, _message, data, availablePaymentSchedules;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3.setLoading(true);

            case 2:
              store = _this3.context.store;
              res = void 0;
              _context.prev = 4;
              _context.next = 7;
              return store.dispatch((0, _fetchM.fetchM)('/projects/' + booking.projectID + '/payment_schedules/?isEnabled=true', {
                credentials: 'include',
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }));

            case 7:
              res = _context.sent;
              _context.next = 25;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](4);

              if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                _context.next = 19;
                break;
              }

              _context.next = 15;
              return _context.t0.res.text();

            case 15:
              message = _context.sent;
              _context.next = 18;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

            case 18:
              return _context.abrupt('return');

            case 19:
              _context.next = 21;
              return _this3.setLoading(false);

            case 21:
              Bugsnag.notifyException(_context.t0);
              _context.next = 24;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

            case 24:
              return _context.abrupt('return');

            case 25:
              if (res.ok) {
                _context.next = 33;
                break;
              }

              _context.next = 28;
              return res.text();

            case 28:
              _message = _context.sent;
              _context.next = 31;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

            case 31:
              _context.next = 38;
              break;

            case 33:
              _context.next = 35;
              return res.json();

            case 35:
              data = _context.sent;

              // filter out startAt that is before today
              availablePaymentSchedules = _lodash2.default.filter(data, function (aps) {
                return (0, _momentTimezone2.default)(aps.startAt).isBefore((0, _momentTimezone2.default)());
              });

              _this3.setState({ availablePaymentSchedules: availablePaymentSchedules });

            case 38:
              _context.next = 40;
              return _this3.setLoading(false);

            case 40:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3, [[4, 10]]);
    }));

    return function (_x3) {
      return _ref.apply(this, arguments);
    };
  }();

  this.generateBookingPaymentPlan = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(booking, paymentScheduleID) {
      var store, res, url, message, _message2, data, contractPaymentSchedules, selectedBookingPaymentPlan;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.setLoading(true);

            case 2:
              store = _this3.context.store;
              res = void 0;
              url = '/bookings/' + booking.id + '/payment_plan/generate/' + paymentScheduleID + '/';

              if (!booking.id) {
                url = '/projects/' + booking.projectID + '/units/' + booking.projectUnitID + '/payment_plan/' + paymentScheduleID + '/';
              }
              _context2.prev = 6;
              _context2.next = 9;
              return store.dispatch((0, _fetchM.fetchM)(url, {
                credentials: 'include',
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Csrf-Token': _this3.props.token
                },
                body: JSON.stringify(_extends({}, booking, {
                  paymentAmount: _this3.state.depositAmount
                }))
              }));

            case 9:
              res = _context2.sent;
              _context2.next = 27;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2['catch'](6);

              if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                _context2.next = 21;
                break;
              }

              _context2.next = 17;
              return _context2.t0.res.text();

            case 17:
              message = _context2.sent;
              _context2.next = 20;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

            case 20:
              return _context2.abrupt('return');

            case 21:
              _context2.next = 23;
              return _this3.setLoading(false);

            case 23:
              Bugsnag.notifyException(_context2.t0);
              _context2.next = 26;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

            case 26:
              return _context2.abrupt('return');

            case 27:
              if (res.ok) {
                _context2.next = 35;
                break;
              }

              _context2.next = 30;
              return res.text();

            case 30:
              _message2 = _context2.sent;
              _context2.next = 33;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: _message2 }));

            case 33:
              _context2.next = 43;
              break;

            case 35:
              _context2.next = 37;
              return res.json();

            case 37:
              data = _context2.sent;
              contractPaymentSchedules = _this3.sortContractPaymentSchedule(_this3.mapCpssWithBppdName(data.contractPaymentSchedules, data)) || [];
              selectedBookingPaymentPlan = _extends({}, (0, _clone2.default)(data), { contractPaymentSchedules: contractPaymentSchedules });


              _this3.handleSetState({
                downpaymentCount: _lodash2.default.size(_this3.getCpsByDetailType(contractPaymentSchedules)) || 0,
                instalmentCount: _lodash2.default.size(_this3.getCpsByDetailType(contractPaymentSchedules, 'instalment')) || 0,
                selectedBookingPaymentPlan: selectedBookingPaymentPlan,
                formContractPaymentSchedules: contractPaymentSchedules,
                oriContractPaymentSchedules: (0, _clone2.default)(contractPaymentSchedules),
                oriBookingPaymentPlan: (0, _clone2.default)(selectedBookingPaymentPlan)
              });
              _context2.next = 43;
              return store.dispatch((0, _flash.flashSuccessMessage)({ message: 'Booking payment plan has been generated successfully' }));

            case 43:
              _context2.next = 45;
              return _this3.setLoading(false);

            case 45:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3, [[6, 12]]);
    }));

    return function (_x4, _x5) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this3.setState({ loading: loading }, res);
    });
  };

  this.getCpsByDetailType = function () {
    var cpss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'downpayment';
    return _lodash2.default.filter(cpss, function (cps) {
      return cps.detailType === type || false;
    });
  };

  this.getMutableContractPaymentSchedules = function () {
    var cpss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var targetCpsID = arguments[1];

    var mutableCpss = [];
    var nonMutableCpss = [];

    var currIdx = _lodash2.default.findIndex(cpss, function (cps) {
      return cps.id === targetCpsID;
    });
    if (currIdx > -1) {
      nonMutableCpss = _lodash2.default.slice(cpss, 0, currIdx);
      mutableCpss = _lodash2.default.slice(cpss, currIdx);
    }
    return { nonMutableCpss: nonMutableCpss, mutableCpss: mutableCpss };
  };

  this.sortContractPaymentScheduleBySeqNo = function () {
    var cpss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return _lodash2.default.sortBy(cpss, 'sequenceNo');
  };

  this.sortContractPaymentSchedule = function () {
    var cpss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var cpssDownpayment = _this3.sortContractPaymentScheduleBySeqNo(_lodash2.default.filter(cpss, function (cps) {
      return cps.detailType === 'downpayment';
    }));
    var cpssInstalment = _this3.sortContractPaymentScheduleBySeqNo(_lodash2.default.filter(cpss, function (cps) {
      return cps.detailType === 'instalment';
    }));
    var cpssDevelopmentStage = _this3.sortContractPaymentScheduleBySeqNo(_lodash2.default.filter(cpss, function (cps) {
      return cps.detailType === 'development_stage';
    }));
    return [].concat(_toConsumableArray(cpssDownpayment), _toConsumableArray(cpssInstalment), _toConsumableArray(cpssDevelopmentStage));
  };

  this.validateAppForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var validations, errMessages;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _AppForm2.default.validate(_this3.validation, _extends({}, _this3.state.formContractPaymentSchedules.reduce(function (acc, curr) {
              var newAcc = _extends({}, acc);
              newAcc[curr.id] = curr;
              return newAcc;
            }, {}), {
              downpaymentCount: Number(_this3.state.downpaymentCount),
              instalmentCount: Number(_this3.state.instalmentCount)
            }));

          case 2:
            validations = _context3.sent;
            errMessages = validations.filter(function (v) {
              return !v.isValid;
            });

            _this3.handleSetState({ errMessages: errMessages });

          case 5:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this3);
  }));

  this.handleSetState = function (s) {
    return _this3.setState(function (prev) {
      return _extends({}, prev, s);
    }, function () {
      _this3.handleOnSaveDisabled();
    });
  };

  this.handleToggle = function (name) {
    return _this3.handleSetState(_defineProperty({}, name, !_this3.state[name]));
  };

  this.shapeOptions = function (paymentSchedules, t) {
    return _lodash2.default.map(paymentSchedules, function (ps) {
      return {
        key: ps.psPaymentScheduleID,
        text: ps.psPaymentSchedule ? ps.psPaymentSchedule.code : t('No payment schedule'), // remove checking as every Project payment schedule should've payment schedule
        value: ps.psPaymentScheduleID
      };
    });
  };

  this.checkSaveDisabled = function (props, state) {
    var contractPaymentSchedules = props.contractPaymentSchedules;
    var selectedBookingPaymentPlan = state.selectedBookingPaymentPlan,
        formContractPaymentSchedules = state.formContractPaymentSchedules;


    var hasNoChanges = _lodash2.default.every(formContractPaymentSchedules, function (fcps) {
      return _lodash2.default.some(contractPaymentSchedules, function (cps) {
        return JSON.stringify(cps) === JSON.stringify(fcps);
      });
    });

    return _lodash2.default.isEmpty(selectedBookingPaymentPlan) || _lodash2.default.isEmpty(formContractPaymentSchedules) || hasNoChanges;
  };

  this.handleOnSaveDisabled = function () {
    var onSaveDisabled = _this3.props.onSaveDisabled;

    if (onSaveDisabled) {
      onSaveDisabled(_this3.checkSaveDisabled(_this3.props, _this3.state));
    }
  };

  this.amountToNumberStr = function (_decimal, _flat, _full, _times) {
    var times = _times || 100;
    var amountStr = (0, _amount2.default)(_decimal, _flat, _full, _times);
    return parseFloat(amountStr).toFixed(times.toString().length - 1);
  };

  this.fullToAmount = function (fullAmount) {
    var amount = fullAmount.toString();
    var decimal = 0;
    var flat = 0;
    var times = 0;
    var full = 0;

    if (amount.includes('.')) {
      var newDecimal = '0';
      var amountSplit = amount.split('.');
      if (amountSplit.length > 1) {
        newDecimal = amountSplit[1];
      }
      var intDecimal = parseInt(newDecimal, 10);
      if (intDecimal < 10) {
        if (newDecimal.length === 1) {
          newDecimal = intDecimal + '0';
        } else {
          newDecimal = '0' + intDecimal;
        }
      }
      decimal = newDecimal;
      flat = amount.split('.')[0];
      times = '1' + '0'.repeat(newDecimal.length);
      full = parseInt(flat, 10) * parseInt(times, 10) + parseInt(decimal, 10);
    } else {
      decimal = 0;
      flat = amount;
      times = 100;
      full = amount * times;
    }
    decimal = parseInt(decimal.toString(), 10);
    flat = parseInt(flat.toString(), 10);
    times = parseInt(times.toString(), 10);
    full = parseInt(full.toString(), 10);
    return {
      decimal: decimal,
      flat: flat,
      times: times,
      full: full
    };
  };

  this.calculateTotalContractPaymentScheduleAmount = function () {
    var cpss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return cpss.reduce(function (acc, curr) {
      var transactionAmountDecimal = curr.transactionAmountDecimal,
          transactionAmountFlat = curr.transactionAmountFlat,
          transactionAmountFull = curr.transactionAmountFull,
          transactionAmountTimes = curr.transactionAmountTimes;

      var fixAmount = Number(_this3.amountToNumberStr(transactionAmountDecimal, transactionAmountFlat, transactionAmountFull, transactionAmountTimes));
      return (0, _decimal3.decimalSum)(acc, fixAmount);
    }, 0);
  };

  this.handleInputChange = function (e, cpsID) {
    e.preventDefault();
    var value = e.target.value;
    var name = e.target.name;

    var cpss = [].concat(_toConsumableArray(_this3.state.formContractPaymentSchedules));
    var targetCps = _lodash2.default.find(cpss, function (cps) {
      return cps.id === cpsID;
    });

    if (targetCps) {
      targetCps[name] = value;
      if (targetCps.bookingPaymentPlanDetailID !== '') {
        var _handleSetCustomized = _this3.handleSetCustomized(targetCps),
            newBpp = _handleSetCustomized.newBpp;

        _this3.handleSetState({ selectedBookingPaymentPlan: newBpp });
      }
      _this3.handleSetState({ formContractPaymentSchedules: cpss });
    }
  };

  this.handleSetCustomized = function (currentCps) {
    var bpp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _state3 = _this3.state,
        selectedBookingPaymentPlan = _state3.selectedBookingPaymentPlan,
        oriContractPaymentSchedules = _state3.oriContractPaymentSchedules,
        oriBookingPaymentPlan = _state3.oriBookingPaymentPlan,
        instalmentCount = _state3.instalmentCount;
    // current target data

    var newBpp = bpp && !_lodash2.default.isEmpty(bpp.id) ? _extends({}, bpp) : _extends({}, selectedBookingPaymentPlan);
    var currentDetail = _lodash2.default.find(newBpp.bookingPaymentPlanDetails, function (bppd) {
      return bppd.id === currentCps.bookingPaymentPlanDetailID;
    });

    // bppd not found means nothing to edit
    if (_lodash2.default.isEmpty(currentDetail)) return undefined;

    // ori data
    var oriCps = _lodash2.default.find(oriContractPaymentSchedules, function (ocps) {
      return ocps.id === currentCps.id;
    });
    var oriDetail = _lodash2.default.find(oriBookingPaymentPlan.bookingPaymentPlanDetails, function (obppd) {
      return obppd.id === currentCps.bookingPaymentPlanDetailID;
    });

    // amount
    var oriTrxAmount = oriCps ? _this3.calculateTransactionAmount(oriCps) : 0;
    var currTrxAmount = _this3.calculateTransactionAmount(currentCps);
    var isEditedTrxAmount = !new _decimal2.Decimal(oriTrxAmount).equals(new _decimal2.Decimal(currTrxAmount));

    // count
    var isInstalmentType = currentCps.detailType === 'instalment';
    var isEditedInstalmentCount = isInstalmentType && Number(instalmentCount) !== _lodash2.default.size(_this3.getCpsByDetailType(oriContractPaymentSchedules, 'instalment'));

    // date
    var isEditedBillingAt = oriCps ? (0, _momentTimezone2.default)(oriCps.transactionDate).format('DD/MM/YYYY') !== (0, _momentTimezone2.default)(currentCps.transactionDate).format('DD/MM/YYYY') : false;

    // name
    var isDownpaymentType = currentCps.detailType === 'downpayment';
    var isEditedName = isDownpaymentType && (oriCps ? oriCps.name !== currentCps.name : false);

    var hasChanges = isEditedTrxAmount || isEditedInstalmentCount || isEditedBillingAt || isEditedName;
    if (hasChanges) currentDetail.customized = true;

    if (isEditedName) currentDetail.name = currentCps.name;

    if (isEditedInstalmentCount) currentDetail.detailInstalmentCount = Number(instalmentCount);

    if (isEditedTrxAmount) {
      currentDetail.downpaymentPercentage = isEditedTrxAmount ? 0 : oriDetail.downpaymentPercentage;
      currentDetail.downpaymentAmountType = isEditedTrxAmount ? 'fixed' : oriDetail.downpaymentAmountType;
      currentDetail.downpaymentAmountDecimal = isEditedTrxAmount ? currentCps.transactionAmountDecimal : oriDetail.downpaymentAmountDecimal;
      currentDetail.downpaymentAmountFlat = isEditedTrxAmount ? currentCps.transactionAmountFlat : oriDetail.downpaymentAmountFlat;
      currentDetail.downpaymentAmountFull = isEditedTrxAmount ? currentCps.transactionAmountFull : oriDetail.downpaymentAmountFull;
      currentDetail.downpaymentAmountTimes = isEditedTrxAmount ? currentCps.transactionAmountTimes : oriDetail.downpaymentAmountTimes;
    }
    return { newBpp: newBpp, currentDetail: currentDetail };
  };

  this.calculateTransactionAmount = function (cps) {
    return _this3.amountToNumberStr(cps.transactionAmountDecimal, cps.transactionAmountFlat, cps.transactionAmountFull, cps.transactionAmountTimes);
  };

  this.handleMultipleCpsChanges = function () {
    var cpss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var bpp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var instalmentCount = _this3.state.instalmentCount;

    var allCpss = [].concat(_toConsumableArray(cpss));
    var cpssWithLastInstalmentOnly = _lodash2.default.filter(allCpss, function (cps) {
      var isInstalment = cps.detailType === 'instalment';
      var isDownpaymentButNotNewlyCreated = !isInstalment && !_lodash2.default.isEmpty(cps.bookingPaymentPlanDetailID);
      // reason of getting last record only, because last row will absorb all the balance
      // if previous instalment amount changes, almost guaranteed will affect the last row
      var isInstalmentButOnlyLastRecord = isInstalment && cps.sequenceNo === Number(instalmentCount);
      return isDownpaymentButNotNewlyCreated || isInstalmentButOnlyLastRecord;
    });

    var bookingPaymentPlanDetails = _lodash2.default.map(cpssWithLastInstalmentOnly, function (cps) {
      var _handleSetCustomized2 = _this3.handleSetCustomized(cps, bpp),
          currentDetail = _handleSetCustomized2.currentDetail;

      return currentDetail;
    });
    return bookingPaymentPlanDetails;
  };

  this.calculateEachInstalmentAmount = function (balance, instalmentCount) {
    var bookingPaymentPlan = _this3.props.bookingPaymentPlan;

    var billed = bookingPaymentPlan.billedContractPaymentSchedules || [];
    var billedWithType = _this3.getCpsByDetailType([].concat(_toConsumableArray(billed)), 'instalment') || [];

    var count = instalmentCount || _this3.state.instalmentCount;
    var nonBilledCount = Number(count) - _lodash2.default.size(billedWithType);

    var totalBilledAmount = billedWithType.reduce(function (acc, curr) {
      return (0, _decimal3.decimalSum)(acc, _this3.calculateTransactionAmount(curr));
    }, 0);
    var billableAmount = (0, _decimal3.decimalSub)(balance, totalBilledAmount);
    return {
      eachInstalmentAmount: billableAmount <= 0 ? 0 : (0, _decimal3.decimalDiv)(billableAmount, nonBilledCount),
      totalBilledInstalmentAmount: Number(totalBilledAmount),
      nonBilledCount: nonBilledCount
    };
  };

  this.recalculateInstalmentContractPaymentScheduleAmount = function () {
    var cpss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var balanceAfterDownpayment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var detailRoundingNearest = arguments[2];

    var totalCount = _lodash2.default.size(cpss);
    var instalmentCount = _lodash2.default.size(_this3.getCpsByDetailType(cpss, 'instalment'));
    var sortedCpss = _this3.sortContractPaymentSchedule(cpss);

    // calculate each instalment with rounding

    var _calculateEachInstalm = _this3.calculateEachInstalmentAmount(balanceAfterDownpayment, instalmentCount),
        eachInstalmentAmount = _calculateEachInstalm.eachInstalmentAmount,
        totalBilledInstalmentAmount = _calculateEachInstalm.totalBilledInstalmentAmount,
        nonBilledCount = _calculateEachInstalm.nonBilledCount;

    var rdplace = _this3.roundingPlace(detailRoundingNearest);
    var roundedTransactionAmountNum = _this3.handleRoundingNearest(rdplace, eachInstalmentAmount);

    var _fullToAmount = _this3.fullToAmount(roundedTransactionAmountNum),
        decimal = _fullToAmount.decimal,
        flat = _fullToAmount.flat,
        times = _fullToAmount.times,
        full = _fullToAmount.full;
    // calculate last row absorb


    var totalInstalmentAmountWithoutLastRow = (0, _decimal3.decimalSum)((0, _decimal3.decimalMul)(roundedTransactionAmountNum, nonBilledCount - 1), totalBilledInstalmentAmount);
    var remainingAmountForLastInstalment = (0, _decimal3.decimalSub)(balanceAfterDownpayment, totalInstalmentAmountWithoutLastRow);
    if (remainingAmountForLastInstalment < 0) {
      remainingAmountForLastInstalment = 0;
    }

    var _fullToAmount2 = _this3.fullToAmount(remainingAmountForLastInstalment),
        bDecimal = _fullToAmount2.decimal,
        bFlat = _fullToAmount2.flat,
        bTimes = _fullToAmount2.times,
        bFull = _fullToAmount2.full;

    return _lodash2.default.map(sortedCpss, function (cps, idx) {
      var isLastRow = idx + 1 === totalCount;
      var isBilled = _this3.checkCpsIsBilled(false, '', cps.sequenceNo);
      switch (cps.detailType) {
        case 'instalment':
          if (isBilled) return cps;
          if (isLastRow) {
            return _extends({}, cps, {
              transactionAmountDecimal: bDecimal,
              transactionAmountFlat: bFlat,
              transactionAmountTimes: bTimes,
              transactionAmountFull: bFull
            });
          }
          return _extends({}, cps, {
            transactionAmountDecimal: decimal,
            transactionAmountFlat: flat,
            transactionAmountTimes: times,
            transactionAmountFull: full
          });
        default:
          return cps;
      }
    });
  };

  this.handleAmountChange = function (e, cpsID) {
    e.preventDefault();
    var value = e.target.value;
    var name = e.target.name;
    var numberValue = Number(Number(value).toFixed(2));

    var depositAmount = _this3.state.depositAmount;
    // update deposit amount (only for project unit preview breakdown)

    if (name === 'depositPaid') {
      depositAmount = numberValue;
    }

    var _fullToAmount3 = _this3.fullToAmount(numberValue),
        decimal = _fullToAmount3.decimal,
        flat = _fullToAmount3.flat,
        times = _fullToAmount3.times,
        full = _fullToAmount3.full;

    var _state4 = _this3.state,
        formContractPaymentSchedules = _state4.formContractPaymentSchedules,
        selectedBookingPaymentPlan = _state4.selectedBookingPaymentPlan;

    var cpss = [].concat(_toConsumableArray(formContractPaymentSchedules));

    var balance = _this3.getBillableBalance(depositAmount);

    var cpssDownpayment = _lodash2.default.map(_this3.getCpsByDetailType(cpss), function (cps) {
      var ncps = _extends({}, cps);
      var isBilled = _this3.checkCpsIsBilled(true, cps.bookingPaymentPlanDetailID);
      var fullAmount = _this3.calculateTransactionAmount(cps);
      if (!isBilled && cps.id === cpsID) {
        ncps.transactionAmountDecimal = decimal;
        ncps.transactionAmountFlat = flat;
        ncps.transactionAmountFull = full;
        ncps.transactionAmountTimes = times;
        fullAmount = numberValue;
      }
      // recalculate balance for instalment
      balance = (0, _decimal3.decimalSub)(balance, fullAmount);
      return ncps;
    });

    var cpssInstalment = _this3.getCpsByDetailType(cpss, 'instalment');
    if (name === 'depositPaid' || name === 'downpaymentAmount') {
      // system recalculate if amount in downpayment changed
      if (cpssInstalment.length > 0) {
        var bppd = _lodash2.default.find(selectedBookingPaymentPlan.bookingPaymentPlanDetails, function (item) {
          return item.id === cpssInstalment[0].bookingPaymentPlanDetailID;
        });
        if (bppd) {
          cpssInstalment = _this3.recalculateInstalmentContractPaymentScheduleAmount(cpssInstalment, balance, bppd.detailRoundingNearest);
        }
      }
    } else {
      // only changed the current cps amount and last cps
      cpssInstalment = _lodash2.default.map(cpssInstalment, function (cps, idx) {
        var ncps = _extends({}, cps);
        var isLastRow = idx + 1 === _lodash2.default.size(cpssInstalment);
        if (isLastRow) {
          var _fullToAmount4 = _this3.fullToAmount(balance),
              bDecimal = _fullToAmount4.decimal,
              bFlat = _fullToAmount4.flat,
              bTimes = _fullToAmount4.times,
              bFull = _fullToAmount4.full;

          ncps.transactionAmountDecimal = bDecimal;
          ncps.transactionAmountFlat = bFlat;
          ncps.transactionAmountFull = bFull;
          ncps.transactionAmountTimes = bTimes;
        }

        if (cps.id === cpsID) {
          ncps.transactionAmountDecimal = decimal;
          ncps.transactionAmountFlat = flat;
          ncps.transactionAmountFull = full;
          ncps.transactionAmountTimes = times;
        }

        balance = (0, _decimal3.decimalSub)(balance, Number(_this3.calculateTransactionAmount(ncps)));
        return ncps;
      });
    }

    // for mutate booking payment plan
    var allCpss = [].concat(_toConsumableArray(cpssDownpayment), _toConsumableArray(cpssInstalment));
    var bookingPaymentPlanDetails = _this3.handleMultipleCpsChanges(allCpss);

    _this3.handleSetState({
      formContractPaymentSchedules: _this3.sortContractPaymentSchedule(allCpss),
      selectedBookingPaymentPlan: _extends({}, _this3.state.selectedBookingPaymentPlan, {
        bookingPaymentPlanDetails: bookingPaymentPlanDetails
      }),
      depositAmount: depositAmount
    });
  };

  this.checkDateIsNotEqual = function (currDateStr, updateDateStr) {
    return (0, _momentTimezone2.default)(currDateStr).format('DD/MM/YYYY') !== (0, _momentTimezone2.default)(updateDateStr).format('DD/MM/YYYY');
  };

  this.handleDateChange = function (cpsID, value, visible) {
    // close datePicker when `close` is clicked
    if (!visible) {
      _this3.handleSetState({ showDatePicker: '' });
      return;
    }

    var _props$bookingData = _this3.props.bookingData,
        lastReservedAt = _props$bookingData.lastReservedAt,
        lastSoldAt = _props$bookingData.lastSoldAt;
    var _state5 = _this3.state,
        formContractPaymentSchedules = _state5.formContractPaymentSchedules,
        selectedBookingPaymentPlan = _state5.selectedBookingPaymentPlan;

    var _getMutableContractPa = _this3.getMutableContractPaymentSchedules(formContractPaymentSchedules, cpsID),
        mcpss = _getMutableContractPa.mutableCpss,
        nonMutableCpss = _getMutableContractPa.nonMutableCpss;

    var mutableCpss = [].concat(_toConsumableArray(mcpss));
    var cpssDownpayment = _lodash2.default.filter(mutableCpss, function (mc) {
      return mc.detailType === 'downpayment';
    });
    var cpssInstalment = _lodash2.default.filter(mutableCpss, function (mc) {
      return mc.detailType === 'instalment';
    });

    // other than current downpayment cps, the transaction date of cps will be updated based on booking payment plan details.
    // newly created cps ( from FE ) will not have booking payment plan. So they will not be auto filled since there is nothing to refer to.
    var newCpsDownpayments = _lodash2.default.map(cpssDownpayment, function (cps) {
      var ndcps = _extends({}, cps);
      var currBppd = _lodash2.default.find(selectedBookingPaymentPlan.bookingPaymentPlanDetails, function (p) {
        return p.id === cps.bookingPaymentPlanDetailID;
      });

      if (cps.id === cpsID) {
        ndcps.transactionDate = value.toISOString(true);
      } else if (!_lodash2.default.isEmpty(currBppd)) {
        ndcps.transactionDate = _this3.calculateDownpaymentBillingAt({
          billingDays: currBppd.downpaymentBillingDays,
          billingCondition: currBppd.downpaymentBillingCondition,
          prevBillingAt: value.toISOString(true),
          lastReservedAt: lastReservedAt,
          lastSoldAt: lastSoldAt
        });
      }
      return ndcps;
    });

    // instalment 1st / start billing date is dependent on last downpayment's transaction date.
    // if last downpayment has valid date changes so shall the instalment.

    var lastNewDownpaymentTransactionDate = newCpsDownpayments[_lodash2.default.size(newCpsDownpayments) - 1] ? newCpsDownpayments[_lodash2.default.size(newCpsDownpayments) - 1].transactionDate : '';
    var lastDownpaymentTransactionDate = cpssDownpayment[_lodash2.default.size(cpssDownpayment) - 1] ? cpssDownpayment[_lodash2.default.size(cpssDownpayment) - 1].transactionDate : '';

    var lastDownpaymentHasDateChanges = false;
    if (_lodash2.default.size(newCpsDownpayments) > 0 && _lodash2.default.size(cpssDownpayment) > 0) {
      lastDownpaymentHasDateChanges = _this3.checkDateIsNotEqual(lastDownpaymentTransactionDate, lastNewDownpaymentTransactionDate);
    }
    var currType = _this3.extractDetailTypeByCpsID(cpsID);
    var instalmentHasBilled = _this3.checkInstalmentHasBilled();

    var newCpsInstalment = _lodash2.default.map(cpssInstalment, function (cps, idx) {
      var nicps = _extends({}, cps);
      var endOfMonth = (0, _momentTimezone2.default)(value).endOf('month');
      var isEndOfMonth = endOfMonth.format('DD/MM/YYYY') === (0, _momentTimezone2.default)(value).format('DD/MM/YYYY');

      var nv = currType === 'instalment' ? value.toISOString(true) : '';
      if (lastDownpaymentHasDateChanges) {
        nv = lastNewDownpaymentTransactionDate;
      }

      if (cps.id === cpsID) {
        nicps.transactionDate = nv;
      } else if (!_lodash2.default.isEmpty(nv) && !instalmentHasBilled) {
        // NOTE: calculate date based on booking payment plan detail. right now we default by one month
        // if date is end of the month, transactionDate will be updated with it.
        // 28 FEB + 1 month = 28 March ( if .endOf('month') is not used )
        var newDate = (0, _momentTimezone2.default)(nv).add(lastDownpaymentHasDateChanges ? idx + 1 : idx, 'months');
        if (isEndOfMonth) {
          newDate = newDate.endOf('month');
        }
        nicps.transactionDate = newDate.toISOString(true);
      }

      return nicps;
    });

    // mutate booking payment plan
    var allCpss = [].concat(_toConsumableArray(nonMutableCpss), _toConsumableArray(newCpsDownpayments), _toConsumableArray(newCpsInstalment));
    var bookingPaymentPlanDetails = _this3.handleMultipleCpsChanges(allCpss);

    _this3.handleSetState({
      formContractPaymentSchedules: _this3.sortContractPaymentSchedule(allCpss),
      selectedBookingPaymentPlan: _extends({}, _this3.state.selectedBookingPaymentPlan, {
        bookingPaymentPlanDetails: bookingPaymentPlanDetails
      }),
      errMessages: _this3.removeErrorMessage('billingAt_' + cpsID)
    });
  };

  this.handleAddOrRemoveRecords = function (_ref4) {
    var _ref4$shouldInsert = _ref4.shouldInsert,
        shouldInsert = _ref4$shouldInsert === undefined ? false : _ref4$shouldInsert,
        _ref4$differences = _ref4.differences,
        differences = _ref4$differences === undefined ? 0 : _ref4$differences,
        _ref4$cpss = _ref4.cpss,
        cpss = _ref4$cpss === undefined ? [] : _ref4$cpss,
        bppd = _ref4.bookingPaymentPlanDetail,
        detailType = _ref4.detailType;
    var auth = _this3.props.auth;

    var newBpp = (0, _clone2.default)(_this3.state.selectedBookingPaymentPlan);
    var newCpss = [].concat(_toConsumableArray(cpss));
    var cpsCount = _lodash2.default.size(cpss) || 0;

    if (shouldInsert) {
      var lastBillingAt = newCpss[cpsCount - 1] ? newCpss[cpsCount - 1].transactionDate : undefined;
      var cpsssToInsert = [].concat(_toConsumableArray(Array(differences).keys())).map(function (key) {
        return {
          id: (0, _uuid.v4)(),
          name: '',
          sequenceNo: cpsCount + (key + 1),
          transactionDate: detailType === 'instalment' && lastBillingAt ? (0, _momentTimezone2.default)(lastBillingAt).add(key + 1, 'months').toISOString(true) : '',
          status: 'record',
          psPaymentScheduleDetailID: bppd ? bppd.psPaymentScheduleDetailID : '',
          detailType: detailType,
          bookingPaymentPlanID: bppd ? bppd.bookingPaymentPlanID : '',
          bookingPaymentPlanDetailID: bppd && detailType === 'instalment' ? bppd.id : '',
          bookingID: _this3.props.bookingData.id,
          psPaymentScheduleID: bppd ? bppd.psPaymentScheduleID : '',
          companyID: auth && auth.company ? auth.company.service_company_id : '',
          projectID: _this3.props.bookingData.projectID,
          projectUnitID: _this3.props.bookingData.projectUnitID
        };
      });

      newCpss = [].concat(_toConsumableArray(newCpss), _toConsumableArray(cpsssToInsert));
    } else {
      var currCount = _lodash2.default.size(newCpss) - Math.abs(differences);
      // remove cps + return removed cps for deleting bppd
      var removedCpss = newCpss.splice(currCount, Math.abs(differences));

      // only delete bppd when is downpayment
      if (detailType === 'downpayment') {
        newBpp.bookingPaymentPlanDetails = _lodash2.default.filter(newBpp.bookingPaymentPlanDetails, function (d) {
          return !_lodash2.default.some(removedCpss, function (rcps) {
            return rcps.bookingPaymentPlanDetailID === d.id;
          });
        });
      }
    }

    return { newCpss: newCpss, newBpp: newBpp };
  };

  this.extractDetailTypeByCpsID = function (cpsID) {
    var formContractPaymentSchedules = _this3.state.formContractPaymentSchedules;

    var cps = _lodash2.default.find(formContractPaymentSchedules, function (c) {
      return c.id === cpsID;
    });
    return _lodash2.default.isEmpty(cps) ? undefined : cps.detailType;
  };

  this.getMutableCpsCount = function (input) {
    var isDownpayment = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var newValue = Number(input);
    var bookingPaymentPlan = _this3.props.bookingPaymentPlan;

    var billed = bookingPaymentPlan.billedContractPaymentSchedules || [];
    var billedDownpaymentCpss = _this3.getCpsByDetailType([].concat(_toConsumableArray(billed)), isDownpayment ? 'downpayment' : 'instalment');
    var lastIndex = _lodash2.default.findLastIndex(billedDownpaymentCpss);
    return newValue <= _lodash2.default.size(billedDownpaymentCpss) ? billedDownpaymentCpss[lastIndex].sequenceNo : newValue;
  };

  this.checkCpsIsBilled = function (isDownpayment, bookingPaymentPlanDetailID, sequenceNo) {
    var bookingPaymentPlan = _this3.props.bookingPaymentPlan;

    var billed = bookingPaymentPlan.billedContractPaymentSchedules || [];
    var billedWithType = _this3.getCpsByDetailType([].concat(_toConsumableArray(billed)), isDownpayment ? 'downpayment' : 'instalment');
    return _lodash2.default.some(billedWithType, function (b) {
      return isDownpayment ? b.bookingPaymentPlanDetailID === bookingPaymentPlanDetailID : b.sequenceNo === sequenceNo;
    });
  };

  this.checkInstalmentHasBilled = function () {
    var bookingPaymentPlan = _this3.props.bookingPaymentPlan;

    var billed = bookingPaymentPlan.billedContractPaymentSchedules || [];
    return _lodash2.default.size(_this3.getCpsByDetailType(billed, 'instalment')) > 0;
  };

  this.handleNumberInput = function (value, name) {
    var _state6 = _this3.state,
        formContractPaymentSchedules = _state6.formContractPaymentSchedules,
        selectedBookingPaymentPlan = _state6.selectedBookingPaymentPlan,
        instalmentCount = _state6.instalmentCount,
        downpaymentCount = _state6.downpaymentCount;

    var newfcpss = [].concat(_toConsumableArray(formContractPaymentSchedules));
    var bpp = (0, _clone2.default)(selectedBookingPaymentPlan);
    var downpaymentCpss = _this3.getCpsByDetailType(newfcpss);
    var instalmentCpss = _this3.getCpsByDetailType(newfcpss, 'instalment');

    var detailDownpayment = _lodash2.default.find(selectedBookingPaymentPlan.bookingPaymentPlanDetails, function (bppd) {
      return bppd.detailType === 'downpayment';
    });
    var detailInstalment = _lodash2.default.find(selectedBookingPaymentPlan.bookingPaymentPlanDetails, function (bppd) {
      return bppd.detailType === 'instalment';
    });

    var ndc = downpaymentCount;
    var nic = instalmentCount;

    // do not update anything if value is less than 0 OR is not from downpayment / instalment count
    if (value < 1 || name !== 'downpaymentCount' && name !== 'instalmentCount') return;

    if (name === 'downpaymentCount') {
      var _handleAddOrRemoveRec = _this3.handleAddOrRemoveRecords({
        shouldInsert: value > _lodash2.default.size(downpaymentCpss),
        differences: value - _lodash2.default.size(downpaymentCpss),
        cpss: downpaymentCpss,
        bookingPaymentPlanDetail: detailDownpayment,
        detailType: 'downpayment'
      }),
          newDownpaymentCpss = _handleAddOrRemoveRec.newCpss,
          newBpp = _handleAddOrRemoveRec.newBpp;

      bpp = newBpp;
      newfcpss = _this3.sortContractPaymentSchedule([].concat(_toConsumableArray(newDownpaymentCpss), _toConsumableArray(instalmentCpss)));

      ndc = Number(value);
    } else {
      var _handleAddOrRemoveRec2 = _this3.handleAddOrRemoveRecords({
        shouldInsert: value > _lodash2.default.size(instalmentCpss),
        differences: value - _lodash2.default.size(instalmentCpss),
        cpss: instalmentCpss,
        bookingPaymentPlanDetail: detailInstalment,
        detailType: 'instalment'
      }),
          newInstalmentCpss = _handleAddOrRemoveRec2.newCpss,
          _newBpp = _handleAddOrRemoveRec2.newBpp;

      bpp = _newBpp;
      nic = Number(value);
      newfcpss = _this3.sortContractPaymentSchedule([].concat(_toConsumableArray(downpaymentCpss), _toConsumableArray(newInstalmentCpss)));
    }

    // recalculate instalment
    var instalmentBppd = _lodash2.default.find(bpp.bookingPaymentPlanDetails, function (bppd) {
      return bppd.detailType === 'instalment';
    });
    var totalDownpayment = _this3.calculateTotalContractPaymentScheduleAmount(_this3.getCpsByDetailType(newfcpss));
    var balance = (0, _decimal3.decimalSub)(_this3.getBillableBalance(), totalDownpayment);
    newfcpss = _this3.recalculateInstalmentContractPaymentScheduleAmount(newfcpss, balance, instalmentBppd.detailRoundingNearest);

    // set customized flag or instalmentCount in bppd
    var bookingPaymentPlanDetails = _this3.handleMultipleCpsChanges(newfcpss, bpp);

    _this3.handleSetState({
      formContractPaymentSchedules: _this3.sortContractPaymentSchedule(newfcpss),
      selectedBookingPaymentPlan: _extends({}, bpp, {
        bookingPaymentPlanDetails: bookingPaymentPlanDetails
      }),
      downpaymentCount: Number(ndc),
      instalmentCount: Number(nic)
    });
  };

  this.handleRedirect = function (value) {
    var store = _this3.context.store;


    if (_lodash2.default.isEmpty(value)) return;

    if (value.includes(_config2.default.get('developerURL'))) {
      window.location.href = value;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(value));
    }
  };

  this.renderAmountWithCurrency = function (amount, currency) {
    return _react2.default.createElement(_LoanAmount2.default, {
      projectCurrencies: currency,
      format: '0,000,000.00',
      amount: amount ? Number(amount).toFixed(2) : '0.00',
      prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
    });
  };

  this.renderLabel = function (label) {
    var isRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var gutterBottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return _react2.default.createElement(
      'p',
      { className: 'text-subtitle ' + (!gutterBottom && 'noGutterBottom') },
      label,
      '\xA0',
      isRequired && _react2.default.createElement(
        'span',
        { style: { color: 'red' } },
        '*'
      )
    );
  };

  this.renderAccordionToggle = function (isActive) {
    return _react2.default.createElement('img', {
      className: 'verticalAlign-mid ml-16',
      src: isActive ? _arrowUp2.default : _arrowDown2.default,
      alt: isActive ? 'collapse' : 'expand'
    });
  };

  this.calculateTotalInstalment = function (downpayments) {
    var formContractPaymentSchedules = _this3.state.formContractPaymentSchedules;


    var balance = _this3.getBillableBalance();
    var totalDownpayment = 0;

    var cpsDownpayments = downpayments || _this3.getCpsByDetailType(formContractPaymentSchedules);
    if (!_lodash2.default.isEmpty(cpsDownpayments)) {
      totalDownpayment = _this3.calculateTotalContractPaymentScheduleAmount(cpsDownpayments);
    }
    return (0, _decimal3.decimalSub)(balance, totalDownpayment) || 0;
  };

  this.calculateDownpaymentBillingAt = function (_ref5) {
    var _ref5$billingDays = _ref5.billingDays,
        billingDays = _ref5$billingDays === undefined ? 0 : _ref5$billingDays,
        billingCondition = _ref5.billingCondition,
        prevBillingAt = _ref5.prevBillingAt,
        lastReservedAt = _ref5.lastReservedAt,
        lastSoldAt = _ref5.lastSoldAt;

    var isAfterSigningDateCondition = billingCondition === 'after_signing_date';
    var isReadyToCalculateForSoldAt = isAfterSigningDateCondition && !_lodash2.default.isEmpty(lastSoldAt);
    var isReadyToCalculateForReserveAt = !isAfterSigningDateCondition && !_lodash2.default.isEmpty(lastReservedAt);
    var lastBillingAt = prevBillingAt || (isAfterSigningDateCondition ? lastSoldAt : lastReservedAt);

    // scenario 1: billing condition is after signing date but booking not yet sold: let user fill in themselves
    // scenario 2: billing condition is after reserve date but booking not yet reserved: let user fill in themselves
    if (!isReadyToCalculateForSoldAt && !isReadyToCalculateForReserveAt || _lodash2.default.isEmpty(lastBillingAt)) return '';

    var billingAtMoment = (0, _momentTimezone2.default)(lastBillingAt).add(billingDays, 'days');
    return billingAtMoment ? billingAtMoment.toISOString(true) : '';
  };

  this.calculateDownpaymentAmount = function (paymentScheduleDownpayment, spaPrice) {
    if (_lodash2.default.isEmpty(paymentScheduleDownpayment)) return 0;

    var downpaymentPercentage = paymentScheduleDownpayment.downpaymentPercentage,
        downpaymentAmountDecimal = paymentScheduleDownpayment.downpaymentAmountDecimal,
        downpaymentAmountFlat = paymentScheduleDownpayment.downpaymentAmountFlat,
        downpaymentAmountFull = paymentScheduleDownpayment.downpaymentAmountFull,
        downpaymentAmountTimes = paymentScheduleDownpayment.downpaymentAmountTimes;


    if (paymentScheduleDownpayment.downpaymentAmountType === 'percentage') {
      return (0, _decimal3.decimalMul)(spaPrice, downpaymentPercentage / 100);
    }
    return Number(_this3.amountToNumberStr(downpaymentAmountDecimal, downpaymentAmountFlat, downpaymentAmountFull, downpaymentAmountTimes));
  };

  this.getBillableBalance = function (newDepositAmount) {
    var bookingData = _this3.props.bookingData;

    var spaValue = Number((0, _amount.spaFullNumber)(bookingData));
    if (bookingData.bookingFeeDeductiblePaymentPlan) {
      return spaValue;
    }
    var depositAmount = _this3.state.depositAmount;

    return (0, _decimal3.decimalSub)(spaValue, newDepositAmount || depositAmount);
  };

  this.generateDownpaymentCPS = function () {
    var downpaymentBppds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var bookingPaymentPlan = arguments[1];
    var _props3 = _this3.props,
        bookingData = _props3.bookingData,
        t = _props3.t;

    var balance = _this3.getBillableBalance();
    var newcpss = [];

    // use foreach instead to get previous index's transaction date for calculating billingAt
    _lodash2.default.forEach(downpaymentBppds, function (psd, idx) {
      var bppd = _lodash2.default.find(bookingPaymentPlan.bookingPaymentPlanDetails, function (item) {
        return item.id === psd.id;
      });
      var rdplace = _this3.roundingPlace(psd.detailRoundingNearest);
      var currIndex = idx + 1;
      // calculate transaction date
      var transactionDate = _this3.calculateDownpaymentBillingAt({
        billingDays: psd.downpaymentBillingDays,
        billingCondition: psd.downpaymentBillingCondition,
        prevBillingAt: idx !== 0 ? newcpss[idx - 1].transactionDate : undefined,
        lastReservedAt: bookingData.lastReservedAt,
        lastSoldAt: bookingData.lastSoldAt
      });
      // calculate amount
      var transactionAmountNumber = _this3.calculateDownpaymentAmount(psd, balance);
      var roundedTransactionAmountNum = _this3.handleRoundingNearest(rdplace, transactionAmountNumber);

      var _fullToAmount5 = _this3.fullToAmount(roundedTransactionAmountNum),
          decimal = _fullToAmount5.decimal,
          flat = _fullToAmount5.flat,
          times = _fullToAmount5.times,
          full = _fullToAmount5.full;

      newcpss.push({
        id: (0, _uuid.v4)(),
        name: !_lodash2.default.isEmpty(psd.name) ? psd.name : t('Downpayment') + ' ' + currIndex,
        sequenceNo: currIndex,
        transactionDate: transactionDate,
        status: 'record',
        psPaymentScheduleDetailID: psd.id,
        transactionAmountDecimal: decimal,
        transactionAmountFlat: flat,
        transactionAmountFull: full,
        transactionAmountTimes: times,
        detailType: 'downpayment',
        bookingPaymentPlanID: bookingPaymentPlan.id,
        bookingPaymentPlanDetailID: bppd.id
      });

      // calculate balance
      balance = (0, _decimal3.decimalSub)(balance, transactionAmountNumber);
    });
    return newcpss;
  };

  this.generateInstalmentCPS = function (_ref6) {
    var psd = _ref6.psd,
        lastDownpaymentDate = _ref6.lastDownpaymentDate,
        downpayments = _ref6.downpayments,
        bookingPaymentPlan = _ref6.bookingPaymentPlan;
    var t = _this3.props.t;

    if (!psd) return [];

    var totalInstalmentAmount = _this3.calculateTotalInstalment(downpayments);
    var eachInstalment = (0, _decimal3.decimalDiv)(totalInstalmentAmount, psd.detailInstalmentCount);
    var bppd = _lodash2.default.find(bookingPaymentPlan.bookingPaymentPlanDetails, function (item) {
      return item.id === psd.id;
    });

    // rounding
    var rdplace = _this3.roundingPlace(psd.roundingNearest);
    var roundedTransactionAmountNum = _this3.handleRoundingNearest(rdplace, eachInstalment);

    // calculate last instalment amount
    var totalAmountBeforeLast = (0, _decimal3.decimalMul)(roundedTransactionAmountNum, psd.detailInstalmentCount - 1);
    var balanceAmount = (0, _decimal3.decimalSub)(totalInstalmentAmount, totalAmountBeforeLast);

    return [].concat(_toConsumableArray(Array(psd.detailInstalmentCount).keys())).map(function (key) {
      var currIndex = key + 1;
      var isLastIndex = key + 1 === psd.detailInstalmentCount;
      // amount breakdown

      var _fullToAmount6 = _this3.fullToAmount(isLastIndex ? balanceAmount : roundedTransactionAmountNum),
          decimal = _fullToAmount6.decimal,
          flat = _fullToAmount6.flat,
          times = _fullToAmount6.times,
          full = _fullToAmount6.full;

      return {
        id: (0, _uuid.v4)(),
        psPaymentScheduleDetailID: psd.id,
        name: t('Instalment') + ' [' + (key + 1) + ']',
        sequenceNo: currIndex,
        status: 'record',
        transactionAmountDecimal: decimal,
        transactionAmountFlat: flat,
        transactionAmountFull: full,
        transactionAmountTimes: times,
        transactionDate: (0, _momentTimezone2.default)(lastDownpaymentDate).add(key + 1, 'months').toISOString(true),
        detailType: 'instalment',
        bookingPaymentPlanID: bookingPaymentPlan.id,
        bookingPaymentPlanDetailID: bppd.id
      };
    });
  };

  this.roundingPlace = function (roundingNearest) {
    switch (roundingNearest) {
      case 'zero':
        return 0;
      case 'ten':
        return 10;
      case 'hundred':
        return 100;
      case 'thousand':
        return 1000;
      case 'ten_thousand':
        return 10000;
      case 'none':
      default:
        break;
    }
    return null;
  };

  this.clearState = function () {
    return _this3.handleSetState({
      errMessages: [],
      showDatePicker: '',
      isDownpaymentAccordionActive: true,
      isInstalmentAccordionActive: true,
      isCollapseInstalmentContent: true,
      formContractPaymentSchedules: [],
      selectedBookingPaymentPlan: {},
      downpaymentCount: 0,
      instalmentCount: 0,
      oriContractPaymentSchedules: [],
      oriBookingPaymentPlan: {}
    });
  };

  this.handleRoundingNearest = function (place, amount) {
    if (!_lodash2.default.isNumber(amount) || !_lodash2.default.isNumber(place)) {
      return amount;
    }
    var amountDec = new _decimal2.Decimal(Number(amount));
    if (place === 0) {
      return amountDec.round().toNumber();
    }
    return amountDec.div(place).round().mul(place).toNumber();
  };

  this.handleSelectPaymentSchedule = function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e, d) {
      var _props4, bookingPaymentPlan, contractPaymentSchedules, ocpss, newcpss;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              e.preventDefault();
              _props4 = _this3.props, bookingPaymentPlan = _props4.bookingPaymentPlan, contractPaymentSchedules = _props4.contractPaymentSchedules;

              if (!(d.value === bookingPaymentPlan.psPaymentScheduleID)) {
                _context4.next = 8;
                break;
              }

              ocpss = [].concat(_toConsumableArray(contractPaymentSchedules));
              newcpss = _this3.mapCpssWithBppdName(ocpss, bookingPaymentPlan);

              _this3.handleSetState({
                formContractPaymentSchedules: _this3.sortContractPaymentSchedule(newcpss) || [],
                selectedBookingPaymentPlan: (0, _clone2.default)(bookingPaymentPlan),
                downpaymentCount: _lodash2.default.size(_this3.getCpsByDetailType(ocpss)),
                instalmentCount: _lodash2.default.size(_this3.getCpsByDetailType(ocpss, 'instalment')),
                oriContractPaymentSchedules: _this3.sortContractPaymentSchedule(newcpss) || [],
                oriBookingPaymentPlan: (0, _clone2.default)(bookingPaymentPlan)
              });
              _context4.next = 10;
              break;

            case 8:
              _context4.next = 10;
              return _this3.generateBookingPaymentPlan(_this3.props.bookingData, d.value);

            case 10:

              if (_this3.props.onPaymentPlanSelect) {
                _this3.props.onPaymentPlanSelect(d.value);
              }

            case 11:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this3);
    }));

    return function (_x22, _x23) {
      return _ref7.apply(this, arguments);
    };
  }();

  this.validateBillingAt = function () {
    var t = _this3.props.t;

    var errors = [];
    var cpssDownpayment = _this3.getCpsByDetailType(_this3.state.formContractPaymentSchedules, 'downpayment');
    _lodash2.default.forEach(cpssDownpayment, function (d) {
      if (_lodash2.default.isEmpty(d.transactionDate)) {
        errors.push({
          name: 'billingAt_' + d.id,
          message: t('Billing date is required')
        });
      }
    });
    return errors;
  };

  this.handleValidateForm = function () {
    var billingAtErrors = _this3.validateBillingAt();
    _this3.handleSetState({ errMessages: [].concat(_toConsumableArray(billingAtErrors)) });
  };

  this.getErrorMessage = function (name) {
    var errMessages = _this3.state.errMessages;

    var err = _lodash2.default.find(errMessages, function (em) {
      return em.name === name;
    });
    return _lodash2.default.isEmpty(err) ? undefined : err.message;
  };

  this.removeErrorMessage = function (name) {
    var errorStates = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return _lodash2.default.filter(errorStates, function (err) {
      return err.name !== name;
    });
  };

  this.setErrorMessage = function (name, message) {
    var errorStates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    var newErrors = [].concat(_toConsumableArray(errorStates));
    var err = _lodash2.default.find(newErrors, function (em) {
      return em.name === name;
    });
    var errExists = !_lodash2.default.isEmpty(err);
    if (errExists) {
      err.message = message;
    } else {
      newErrors.push({ name: name, message: message });
    }
    return newErrors;
  };

  this.validateTotalAmount = function () {
    var formContractPaymentSchedules = _this3.state.formContractPaymentSchedules;

    var balance = _this3.getBillableBalance();
    var totalCpsAmount = _this3.calculateTotalContractPaymentScheduleAmount(formContractPaymentSchedules);
    return (0, _decimal3.decimalIsEqual)(balance, totalCpsAmount);
  };

  this.handleCheckIfSubmittable = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
    var store, t, _state7, formContractPaymentSchedules, instalmentCount, downpaymentCount, emptyFieldArrs, dcIsZero, icIsZero, totalIsEqualToExpected;

    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            store = _this3.context.store;
            t = _this3.props.t;
            _state7 = _this3.state, formContractPaymentSchedules = _state7.formContractPaymentSchedules, instalmentCount = _state7.instalmentCount, downpaymentCount = _state7.downpaymentCount;
            emptyFieldArrs = _lodash2.default.filter(formContractPaymentSchedules, function (cps) {
              return cps.detailType === 'downpayment' && _lodash2.default.isEmpty(cps.name) || _lodash2.default.isEmpty(cps.transactionDate);
            });
            dcIsZero = Number(downpaymentCount) === 0;
            icIsZero = Number(instalmentCount) === 0;
            totalIsEqualToExpected = _this3.validateTotalAmount();

            if (totalIsEqualToExpected) {
              _context5.next = 10;
              break;
            }

            _context5.next = 10;
            return store.dispatch((0, _flash.flashErrorMessage)({ message: t('Total amount is not the same as the calculated balance', { ns: _translation.TRANSLATION_FILES.translation }) }));

          case 10:
            return _context5.abrupt('return', _lodash2.default.isEmpty(emptyFieldArrs) && !dcIsZero && !icIsZero && totalIsEqualToExpected);

          case 11:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this3);
  }));

  this.renderDropdown = function (_ref9) {
    var label = _ref9.label,
        name = _ref9.name,
        value = _ref9.value,
        options = _ref9.options,
        _ref9$placeholder = _ref9.placeholder,
        placeholder = _ref9$placeholder === undefined ? 'Select' : _ref9$placeholder,
        _ref9$noResultMsg = _ref9.noResultMsg,
        noResultMsg = _ref9$noResultMsg === undefined ? 'No result found' : _ref9$noResultMsg,
        _ref9$isRequired = _ref9.isRequired,
        isRequired = _ref9$isRequired === undefined ? false : _ref9$isRequired;
    return _react2.default.createElement(
      'div',
      null,
      label && _this3.renderLabel(label, isRequired),
      _react2.default.createElement(_semanticUiReact.Form.Select, {
        name: name,
        className: 'dropdown',
        options: options,
        value: value,
        noResultsMessage: noResultMsg,
        selection: true,
        fluid: true,
        search: true,
        onChange: function onChange(e, d) {
          return _this3.handleSelectPaymentSchedule(e, d);
        },
        placeholder: placeholder,
        selectOnBlur: false,
        selectOnNavigation: false
      })
    );
  };

  this.renderAmountInput = function (_ref10) {
    var label = _ref10.label,
        name = _ref10.name,
        value = _ref10.value,
        _ref10$isRequired = _ref10.isRequired,
        isRequired = _ref10$isRequired === undefined ? false : _ref10$isRequired,
        id = _ref10.id,
        disabled = _ref10.disabled;
    return _react2.default.createElement(
      'div',
      null,
      label && _this3.renderLabel(label, isRequired),
      _react2.default.createElement(_semanticUiReact.Input, {
        label: {
          basic: true,
          content: _this3.props.auth.company ? _this3.props.auth.company.currencySymbol : 'MYR'
        },
        iconPosition: 'left',
        fluid: true,
        placeholder: '0.00',
        name: name,
        type: 'number',
        step: '.01',
        value: value,
        disabled: disabled,
        onChange: function onChange(e) {
          return _this3.handleAmountChange(e, id);
        }
      })
    );
  };

  this.handleClearDate = function (name, cpsID) {
    var _state8 = _this3.state,
        formContractPaymentSchedules = _state8.formContractPaymentSchedules,
        errMessages = _state8.errMessages;
    var t = _this3.props.t;

    var errs = _this3.setErrorMessage('billingAt_' + cpsID, t('Billing date is required'), errMessages);

    var cpss = [].concat(_toConsumableArray(formContractPaymentSchedules));
    var targetcps = _lodash2.default.find(cpss, function (cps) {
      return cps.id === cpsID;
    });
    if (name !== 'startBillingDate') {
      targetcps.transactionDate = '';
    }

    _this3.handleSetState({
      formContractPaymentSchedules: cpss,
      errMessages: errs
    });
  };

  this.handleSubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
    var bookingData, _state9, formContractPaymentSchedules, selectedBookingPaymentPlan, submittable;

    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            bookingData = _this3.props.bookingData;
            _state9 = _this3.state, formContractPaymentSchedules = _state9.formContractPaymentSchedules, selectedBookingPaymentPlan = _state9.selectedBookingPaymentPlan;


            _this3.handleValidateForm();
            _this3.validateAppForm();
            _context6.next = 6;
            return _this3.handleCheckIfSubmittable();

          case 6:
            submittable = _context6.sent;


            if (submittable && _this3.props.onSubmit && bookingData && bookingData.id !== '') {
              _this3.props.onSubmit(_extends({}, selectedBookingPaymentPlan, {
                bookingID: bookingData.id,
                contractPaymentSchedules: formContractPaymentSchedules
              }), bookingData.id);
              _this3.clearState();
            }

          case 8:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this3);
  }));

  this.getDateInputMinDate = function (cpsID) {
    var formContractPaymentSchedules = _this3.state.formContractPaymentSchedules;

    var cpssDownpayment = _this3.getCpsByDetailType(formContractPaymentSchedules, 'downpayment');

    var currIdx = _lodash2.default.findIndex(cpssDownpayment, function (d) {
      return d.id === cpsID;
    });
    var prevIdx = currIdx - 1;
    if (prevIdx >= 0 && cpssDownpayment[prevIdx]) {
      return cpssDownpayment[prevIdx].transactionDate;
    }
    return undefined;
  };

  this.getDownpaymentName = function (bpp, bppdID, cpsName) {
    var currBppd = _lodash2.default.find(bpp.bookingPaymentPlanDetails, function (bppd) {
      return bppd.id === bppdID;
    });
    if (!currBppd) return '';
    var edited = !_lodash2.default.isEmpty(cpsName) && cpsName !== currBppd.downpaymentName;
    return edited ? cpsName : currBppd.downpaymentName;
  };

  this.renderDateInput = function (_ref12) {
    var name = _ref12.name,
        label = _ref12.label,
        value = _ref12.value,
        _ref12$isRequired = _ref12.isRequired,
        isRequired = _ref12$isRequired === undefined ? false : _ref12$isRequired,
        disabled = _ref12.disabled,
        cpsID = _ref12.cpsID;

    var isStartBillingDate = name === 'startBillingDate';
    var showDatePickerValue = isStartBillingDate ? name : cpsID;
    var errMsg = _this3.getErrorMessage('billingAt_' + cpsID);
    var t = _this3.props.t;

    return _react2.default.createElement(
      'div',
      { className: 'datePicker' },
      label && _this3.renderLabel(label, isRequired, false),
      _react2.default.createElement(_semanticUiReact.Form.Input, {
        fluid: true,
        placeholder: t('Select date'),
        value: value ? (0, _momentTimezone2.default)(value).format('DD/MM/YYYY') : '',
        onFocus: function onFocus() {
          return _this3.handleSetState({ showDatePicker: showDatePickerValue });
        },
        disabled: disabled,
        name: '',
        icon: value && !isStartBillingDate ? _react2.default.createElement(_semanticUiReact.Icon, {
          color: 'red',
          link: true,
          name: 'x',
          onClick: function onClick() {
            return _this3.handleClearDate(name, cpsID);
          },
          title: 'Clear'
        }) : 'calendar'
      }),
      _react2.default.createElement(_DateTimePicker2.default, {
        onChange: function onChange(dateValue, visible) {
          return _this3.handleDateChange(cpsID, dateValue, visible);
        },
        value: value ? (0, _momentTimezone2.default)(value).toDate() : '',
        visible: _this3.state.showDatePicker === showDatePickerValue,
        minDate: (0, _momentTimezone2.default)(_this3.getDateInputMinDate(cpsID)).add(1, 'day')
      }),
      errMsg && _react2.default.createElement(
        _Helper2.default,
        { type: 'error' },
        errMsg
      )
    );
  };

  this.toggleNumberInput = _lodash2.default.debounce(this.handleNumberInput, 1000);

  this.renderNumberInput = function (_ref13) {
    var label = _ref13.label,
        name = _ref13.name,
        value = _ref13.value,
        _ref13$isRequired = _ref13.isRequired,
        isRequired = _ref13$isRequired === undefined ? false : _ref13$isRequired,
        _ref13$validationLabe = _ref13.validationLabel,
        validationLabel = _ref13$validationLabe === undefined ? '' : _ref13$validationLabe,
        disabled = _ref13.disabled;
    return _react2.default.createElement(
      'div',
      null,
      label && _this3.renderLabel(label, isRequired, false),
      _react2.default.createElement(_AppForm2.default.Input, {
        ref: _this3.validation[name],
        validateLabel: validationLabel,
        validation: [{
          validate: _webValidations.numericRange,
          option: {
            min: 1
          }
        }],
        placeholder: '0',
        name: name,
        type: 'number',
        value: value || 0,
        fluid: true,
        disabled: disabled,
        onChange: function onChange(e) {
          var nv = e.target.value;
          var newValue = _this3.getMutableCpsCount(Number(nv), name === 'downpaymentCount');
          _this3.handleSetState(_defineProperty({}, name, newValue));
          // delay result
          _this3.toggleNumberInput(newValue, name);
        }
      })
    );
  };

  this.renderAccordion = function (_ref14) {
    var name = _ref14.name,
        title = _ref14.title,
        subtitle = _ref14.subtitle,
        content = _ref14.content,
        id = _ref14.id;
    return _react2.default.createElement(
      _semanticUiReact.Accordion,
      { fluid: true, className: 'borderlessAccordion', key: id },
      _react2.default.createElement(
        _semanticUiReact.Accordion.Title,
        {
          active: _this3.state[name],
          onClick: function onClick() {
            return _this3.handleToggle(name);
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 2 },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'span',
                { className: 'text-header' },
                title
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              subtitle && _react2.default.createElement(
                'b',
                { className: 'text-body' },
                subtitle
              ),
              _this3.renderAccordionToggle(_this3.state[name])
            )
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Accordion.Content,
        { className: 'accordionContent', active: _this3.state[name] },
        content
      )
    );
  };

  this.renderTableRow = function (row, isDownpayment, isCollapsible) {
    var t = _this3.props.t;

    var isLastInstalmentRow = _this3.state.instalmentCount === row.idx + 1;
    var isBilledStatus = _this3.checkCpsIsBilled(isDownpayment, row.bookingPaymentPlanDetailID, row.sequenceNo);
    _this3.validation.name = (0, _react.createRef)();
    return _react2.default.createElement(
      _semanticUiReact.Table.Row,
      {
        key: row.id,
        className: 'vertical-align-initial' + (isCollapsible && row.idx === 0 ? ' collapsibleTable' : '')
      },
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { width: 4 },
        isDownpayment ? _react2.default.createElement(_AppForm2.default.Input, {
          validateLabel: (isDownpayment ? 'Downpayment' : 'Instalment') + ' name',
          ref: _this3.validation.name,
          validation: [_webValidations.required],
          name: 'name',
          value: row.name,
          onChange: function onChange(e) {
            return _this3.handleInputChange(e, row.id);
          },
          fluid: true,
          disabled: isBilledStatus
        }) : _this3.renderLabel(row.name, false, false)
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { width: 4 },
        _this3.renderAmountInput({
          idx: row.idx,
          id: row.id,
          name: isDownpayment ? 'downpaymentAmount' : 'instalmentAmount',
          value: row.value || 0,
          disabled: isBilledStatus || !isDownpayment && isLastInstalmentRow
        })
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { width: 4 },
        _this3.renderLabel(t('Billing date'), false, false)
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { width: 4 },
        _this3.renderDateInput({
          name: 'billingDate',
          value: row.billingAt,
          isRequired: true,
          disabled: !isDownpayment || isBilledStatus,
          cpsID: row.id
        })
      )
    );
  };

  this.renderTextButton = function (content, onClick, iconName) {
    return _react2.default.createElement(
      _semanticUiReact.Label,
      {
        as: 'button',
        size: 'small',
        onClick: onClick,
        className: 'textButton'
      },
      content,
      !_lodash2.default.isEmpty(iconName) && _react2.default.createElement(_semanticUiReact.Icon, { name: iconName })
    );
  };

  this.renderTable = function (_ref15) {
    var isDownpayment = _ref15.isDownpayment,
        isCollapsible = _ref15.isCollapsible,
        _ref15$rows = _ref15.rows,
        rows = _ref15$rows === undefined ? [] : _ref15$rows,
        lastRow = _ref15.lastRow;
    var t = _this3.props.t;

    return _react2.default.createElement(
      'section',
      { className: 'mt-24' },
      _react2.default.createElement(
        _semanticUiReact.Table,
        { attached: 'top', className: !isDownpayment && _this3.state.isCollapseInstalmentContent && isCollapsible ? 'bb-none' : '' },
        _react2.default.createElement(
          _semanticUiReact.Table.Body,
          null,
          isCollapsible && lastRow && _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(_semanticUiReact.Table.Cell, { width: 4 }),
            _react2.default.createElement(_semanticUiReact.Table.Cell, { width: 4 }),
            _react2.default.createElement(_semanticUiReact.Table.Cell, { width: 4 }),
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              { width: 4, textAlign: 'right' },
              _this3.renderTextButton(t(_this3.state.isCollapseInstalmentContent ? 'Expand' : 'Collapse', { ns: _translation.TRANSLATION_FILES.translation }), function () {
                return _this3.handleToggle('isCollapseInstalmentContent');
              }, _this3.state.isCollapseInstalmentContent ? 'chevron down' : 'chevron up')
            )
          ),
          rows.map(function (row) {
            return _this3.renderTableRow(row, isDownpayment, isCollapsible);
          })
        )
      ),
      isCollapsible && _this3.state.isCollapseInstalmentContent && lastRow && _react2.default.createElement(
        _semanticUiReact.Table,
        { attached: true, className: 'expandIndicateTable ' + (isCollapsible && 'bb-none') },
        _react2.default.createElement(
          _semanticUiReact.Table.Body,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true, className: 'dividerWithButton' },
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    className: 'tableExpandButton',
                    onClick: function onClick() {
                      return _this3.handleToggle('isCollapseInstalmentContent');
                    }
                  },
                  _react2.default.createElement('img', { src: _expand2.default, alt: 'expand' })
                )
              )
            )
          )
        )
      ),
      isCollapsible && _this3.state.isCollapseInstalmentContent && lastRow && _react2.default.createElement(
        _semanticUiReact.Table,
        { attached: 'bottom' },
        _react2.default.createElement(
          _semanticUiReact.Table.Body,
          null,
          _this3.renderTableRow(lastRow, isDownpayment)
        )
      )
    );
  };

  this.renderDownpaymentContent = function () {
    var cpss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var t = _this3.props.t;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { columns: 3, verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 8, computer: 4 },
            _this3.renderLabel(t('Number of downpayments'), true, false)
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 8, computer: 4 },
            _this3.renderNumberInput({
              name: 'downpaymentCount',
              value: Number(_this3.state.downpaymentCount),
              isRequired: true,
              validationLabel: t('Downpayment count')
            })
          )
        )
      ),
      !_lodash2.default.isEmpty(cpss) && _this3.renderTable({
        isDownpayment: true,
        rows: _lodash2.default.map(cpss, function (cps, idx) {
          return {
            id: cps.id,
            name: cps.name,
            billingAt: cps.transactionDate,
            value: Number(_this3.calculateTransactionAmount(cps)),
            idx: idx,
            bookingPaymentPlanDetailID: cps.bookingPaymentPlanDetailID,
            sequenceNo: cps.sequenceNo
          };
        })
      })
    );
  };

  this.renderInstalmentContent = function () {
    var cpss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var t = _this3.props.t;

    var isCollapsible = _lodash2.default.size(cpss) > 3;
    var instalmentRows = cpss.map(function (cps, idx) {
      return {
        value: Number(_this3.calculateTransactionAmount(cps)),
        billingAt: cps.transactionDate,
        name: t('Instalment') + ' ' + (idx + 1),
        id: cps.id,
        idx: idx,
        sequenceNo: cps.sequenceNo
      };
    });

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { columns: 4, verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 8, computer: 4 },
            _this3.renderLabel(t('Number of instalments'), true, false)
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 8, computer: 4 },
            _this3.renderNumberInput({
              name: 'instalmentCount',
              value: _this3.state.instalmentCount,
              isRequired: true,
              validationLabel: t('Instalment count')
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 8, computer: 4 },
            _this3.renderLabel(t('Start billing date'), true, false)
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 8, computer: 4 },
            _this3.renderDateInput({
              name: 'startBillingDate',
              value: !_lodash2.default.isEmpty(instalmentRows) ? instalmentRows[0].billingAt : '',
              isRequired: true,
              cpsID: !_lodash2.default.isEmpty(instalmentRows) ? instalmentRows[0].id : '',
              disabled: _this3.checkInstalmentHasBilled()
            })
          )
        )
      ),
      _this3.renderTable({
        lastRow: instalmentRows[_lodash2.default.size(cpss) - 1],
        rows: isCollapsible && _this3.state.isCollapseInstalmentContent ? instalmentRows.splice(0, 2) : instalmentRows,
        isCollapsible: isCollapsible
      })
    );
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })((0, _reactRedux.connect)(PaymentPlanForm.mapStateToProps, null, null, { withRef: true })(PaymentPlanForm));

/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _projectStatuses = __webpack_require__(583);

var _projectStatuses2 = _interopRequireDefault(_projectStatuses);

var _bookingNote = __webpack_require__(1040);

var _srRoleAccess = __webpack_require__(196);

var _translation = __webpack_require__(4);

var _translation2 = __webpack_require__(64);

var _strings = __webpack_require__(118);

var _json = __webpack_require__(268);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
/* eslint no-nested-ternary: 0 */


// Still needed for the module-level locale; the feed date renders through Timestamp.
_momentTimezone2.default.locale('en-gb');

var ProjectActivities = function (_Component) {
  _inherits(ProjectActivities, _Component);

  function ProjectActivities() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ProjectActivities);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ProjectActivities.__proto__ || Object.getPrototypeOf(ProjectActivities)).call.apply(_ref, [this].concat(args))), _this), _this.getAddressLabel = function (key) {
      var addressSettings = _this.props.addressSettings;

      if (addressSettings && addressSettings.data) {
        var as = addressSettings.data.find(function (a) {
          return _lodash2.default.camelCase(a.columnName) === key;
        });
        if (as) {
          return as.label;
        }
      }
      return key;
    }, _this.keyToName = function (key) {
      var t = _this.props.t;

      switch (key) {
        case 'address1':
        case 'address2':
        case 'address3':
        case 'address4':
        case 'address5':
        case 'address6':
        case 'address7':
        case 'address8':
        case 'address9':
        case 'address10':
          return _this.getAddressLabel(key);
        default:
          return (0, _translation2.translateModels)(t, key, 'project', (0, _strings.camelToTitle)(key));
      }
    }, _this.renderActivityMessage = function (activity) {
      var t = _this.props.t;

      var activityBefore = (0, _json.parseJSON)(activity.before);
      var activityAfter = (0, _json.parseJSON)(activity.after);
      var afterKeys = Object.keys(activityAfter);
      var changes = [];
      afterKeys.forEach(function (element) {
        var message = void 0;
        var after = '';
        var before = activityBefore[element];
        var mpPublishState = 'removed from';
        if (activity.before) {
          if (!_lodash2.default.isEmpty(activityAfter[element]) || _lodash2.default.isNumber(activityAfter[element]) || _lodash2.default.isBoolean(activityAfter[element])) {
            after = activityAfter[element];
          }
        }
        switch (element) {
          case 'marketplaceIsPublish':
          case 'marketplaceBuyerIsPublish':
            if (before === false && after) {
              mpPublishState = 'launched to';
            }
            message = _react2.default.createElement(
              'span',
              null,
              t('Project is ' + mpPublishState),
              ' ',
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                _this.keyToName(element)
              )
            );
            break;
          case 'statusID':
            before = (0, _translation2.getConstantsLabel)(t, _projectStatuses2.default, before);
            after = (0, _translation2.getConstantsLabel)(t, _projectStatuses2.default, after);
            break;
          case 'address1':
          case 'address2':
            if (!before) message = _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                _this.keyToName(element)
              ),
              ': ',
              _react2.default.createElement(
                'u',
                null,
                after
              )
            );
            break;
          case 'bnDefaultPrivacy':
            before = (0, _translation2.getConstantsLabel)(t, _bookingNote.bookingNoteDefaultPrivacyOptions, before);
            after = (0, _translation2.getConstantsLabel)(t, _bookingNote.bookingNoteDefaultPrivacyOptions, after);
            break;
          case 'bnReadAccessGroupIDs':
          case 'bnWriteAccessGroupIDs':
            before = (0, _translation2.getConstantsLabel)(t, _srRoleAccess.bookingNoteAccessesOptions, before);
            after = (0, _translation2.getConstantsLabel)(t, _srRoleAccess.bookingNoteAccessesOptions, after);
            break;
          case 'rduAccessGroupIDs':
            before = (0, _translation2.getConstantsLabel)(t, _srRoleAccess.rduAccessesOptions, before);
            after = (0, _translation2.getConstantsLabel)(t, _srRoleAccess.rduAccessesOptions, after);
            break;
          case 'paymentReceiptAccessGroupIDs':
            before = (0, _translation2.getConstantsLabel)(t, _srRoleAccess.paymentReceiptAccessesOptions, before);
            after = (0, _translation2.getConstantsLabel)(t, _srRoleAccess.paymentReceiptAccessesOptions, after);
            break;
          default:
            break;
        }
        if (message) {
          changes.push(message);
        } else if (before || after) {
          var keyName = _this.keyToName(element);
          if (before === false && after) {
            var text = t('has been added');
            if (_lodash2.default.isBoolean(after)) text = t('is enabled');
            message = _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation.TRANSLATION_FILES.screens },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  { style: { color: '#666' } },
                  { keyName: keyName }
                ),
                ' ',
                text
              )
            );
          } else if (!before) {
            message = _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                keyName
              ),
              ': ',
              _react2.default.createElement(
                'u',
                null,
                after
              )
            );
          } else if (before && !after) {
            var _text = t('has been removed');
            if (_lodash2.default.isBoolean(before)) _text = t('is disabled');
            message = _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation.TRANSLATION_FILES.screens },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  { style: { color: '#666' } },
                  { keyName: keyName }
                ),
                ' ',
                _text
              )
            );
          } else {
            message = _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation.TRANSLATION_FILES.screens },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  { style: { color: '#666' } },
                  { keyName: keyName }
                ),
                ' changed from ',
                _react2.default.createElement(
                  'u',
                  null,
                  { before: before }
                ),
                ' to ',
                _react2.default.createElement(
                  'u',
                  null,
                  { after: after }
                )
              )
            );
          }
          changes.push(message);
        }
      });
      return _react2.default.createElement(
        _semanticUiReact.List,
        { bulleted: true },
        changes.map(function (element, id) {
          return _react2.default.createElement(
            _semanticUiReact.List.Item,
            { key: id },
            element
          );
        })
      );
    }, _this.renderActivityTitle = function (title) {
      var t = _this.props.t;

      var loweredTitle = title.toLowerCase();

      var copyKeyword = 'Copied from';
      if (title.includes(copyKeyword)) {
        var projectName = title.slice(title.indexOf(copyKeyword) + copyKeyword.length);
        title = title.replace(projectName, '{{project}}');
        return t(title, { project: projectName });
      }
      var packageKeyword = 'package (';
      if (loweredTitle.includes(packageKeyword)) {
        var formulaName = '';
        var formulaKeyword = 'formula (';
        if (loweredTitle.includes(formulaKeyword)) {
          formulaName = title.substring(loweredTitle.indexOf(formulaKeyword) + formulaKeyword.length);
          formulaName = '(' + formulaName.substring(0, formulaName.indexOf(')') + 1);
          title = title.replace(formulaName, '{{formula}}');
          loweredTitle = title.toLowerCase();
        }

        var packageName = title.slice(loweredTitle.indexOf(packageKeyword) + packageKeyword.length);
        packageName = '(' + packageName;
        title = title.replace(packageName, '{{package}}');
        return t(title, { formula: formulaName, package: packageName });
      }
      return t(title);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ProjectActivities, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          data = _props.data,
          t = _props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(
              _semanticUiReact.Feed,
              null,
              data && data.length > 0 ? data.map(function (activity, idx) {
                return _react2.default.createElement(
                  _semanticUiReact.Feed.Event,
                  { key: idx, className: 'activity-logs' },
                  _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: 'user' }),
                  _react2.default.createElement(
                    _semanticUiReact.Feed.Content,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Date,
                      null,
                      _react2.default.createElement(_Timestamp2.default, { timestamp: activity.createdAt, format: 'MMMM Do YYYY, h:mm:ss a' })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Summary,
                      null,
                      _this2.props.hasAccess ? activity.maUserAffiliateID > 0 ? _react2.default.createElement(
                        _reactRouter.Link,
                        { to: '/users/' + activity.maUserAffiliateID + '/' },
                        activity.maCreatedByPreferredName || t('Unknown')
                      ) : '' : activity.maCreatedByPreferredName,
                      ' ' + _this2.renderActivityTitle(activity.message),
                      _this2.props.showAll ? _react2.default.createElement(
                        'span',
                        null,
                        '\xA0',
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { to: '/projects/' + activity.projectID + '/' },
                          activity.projectName
                        )
                      ) : ''
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Extra,
                      { text: true },
                      activity.after && _this2.renderActivityMessage(activity)
                    )
                  )
                );
              }) : this.props.loading ? _react2.default.createElement('br', null) : _react2.default.createElement(
                'center',
                null,
                t('No activity found'),
                '.'
              )
            )
          )
        )
      );
    }
  }]);

  return ProjectActivities;
}(_react.Component);

ProjectActivities.propTypes = {
  data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  hasAccess: _propTypes2.default.bool.isRequired,
  loading: _propTypes2.default.bool.isRequired,
  showAll: _propTypes2.default.bool,
  addressSettings: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.project]))((0, _reactRedux.connect)(ProjectActivities.mapStateToProps)(ProjectActivities));

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _reactI18next = __webpack_require__(3);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _apiEndpoints = __webpack_require__(140);

var endpoints = _interopRequireWildcard(_apiEndpoints);

var _translation = __webpack_require__(4);

var _LawyerItem = __webpack_require__(384);

var _LawyerItem2 = _interopRequireDefault(_LawyerItem);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectPanelLawyers = function (_Component) {
  _inherits(ProjectPanelLawyers, _Component);

  function ProjectPanelLawyers(props) {
    var _this2 = this;

    _classCallCheck(this, ProjectPanelLawyers);

    var _this = _possibleConstructorReturn(this, (ProjectPanelLawyers.__proto__ || Object.getPrototypeOf(ProjectPanelLawyers)).call(this, props));

    _this.setLoading = function () {
      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return new Promise(function (res) {
        return _this.setState({ loading: loading }, function () {
          return res(loading);
        });
      });
    };

    _this.setComponentState = function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Promise(function (res) {
        return _this.setState(state, function () {
          return res(state);
        });
      });
    };

    _this.setLawyers = function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var token = arguments[1];
      var expand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return new Promise(function (res) {
        var lawyers = expand ? [].concat(_this.state.lawyers, data) : data || [];
        var nextToken = _this.state.nextToken;

        nextToken.panel = token;
        _this.setState({
          lawyers: lawyers,
          nextToken: nextToken
        }, function () {
          _this.handleOnChange(lawyers);
          res(data, token);
        });
      });
    };

    _this.setInvited = function () {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var token = arguments[1];
      var expand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      return new Promise(function (res) {
        var invited = expand ? [].concat(_this.state.invited, data) : data || [];
        var nextToken = _this.state.nextToken;

        nextToken.invited = token;
        _this.setState({
          invited: invited,
          nextToken: nextToken
        }, function () {
          return res(data, token);
        });
      });
    };

    _this.refresh = function (token) {
      var projectID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.loanTrackerProjectID;
      var currentTab = _this.state.currentTab;

      if (currentTab === 'invited') {
        _this.fetchInvitedLawyers(token, projectID);
      } else {
        _this.fetchPanelLawyers(token, projectID);
      }
    };

    _this.fetchPanelLawyers = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(nextToken) {
        var projectID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props.loanTrackerProjectID;
        var store, t, query, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.setComponentState({ loading: true });

              case 2:
                store = _this.context.store;
                t = _this.props.t;

                if (projectID) {
                  _context.next = 8;
                  break;
                }

                _context.next = 7;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('This project is not linked in loan tracker', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 7:
                return _context.abrupt('return');

              case 8:
                query = {
                  limit: 10
                };

                if (nextToken) {
                  query.next_token = nextToken;
                }
                res = void 0;
                _context.prev = 11;
                _context.next = 14;
                return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.PANEL_LAWYERS(projectID) + '/?' + _qs2.default.stringify(query), null, 'get', {
                  'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
                }));

              case 14:
                res = _context.sent;
                _context.next = 25;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](11);

                Bugsnag.notifyException(_context.t0);
                _context.next = 22;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 22:
                _context.next = 24;
                return _this.setLoading(false);

              case 24:
                return _context.abrupt('return');

              case 25:
                if (!res) {
                  _context.next = 28;
                  break;
                }

                _context.next = 28;
                return _this.setLawyers(res.items, res.next_token, !!nextToken);

              case 28:
                _context.next = 30;
                return _this.setLoading(false);

              case 30:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[11, 17]]);
      }));

      return function (_x8) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.fetchInvitedLawyers = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(nextToken) {
        var store, t, query, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.setComponentState({ loading: true });

              case 2:
                store = _this.context.store;
                t = _this.props.t;
                query = {
                  limit: 10
                };

                if (nextToken) {
                  query.next_token = nextToken;
                }
                res = void 0;
                _context2.prev = 7;
                _context2.next = 10;
                return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.LAWYER_INVITES + '/?' + _qs2.default.stringify(query), null, 'get', {
                  'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
                }));

              case 10:
                res = _context2.sent;
                _context2.next = 21;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](7);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 18:
                _context2.next = 20;
                return _this.setLoading(false);

              case 20:
                return _context2.abrupt('return');

              case 21:
                if (!res) {
                  _context2.next = 24;
                  break;
                }

                _context2.next = 24;
                return _this.setInvited(res.items, res.next_token, !!nextToken);

              case 24:
                _context2.next = 26;
                return _this.setLoading(false);

              case 26:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[7, 13]]);
      }));

      return function (_x10) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.getAutoAssignOptions = function () {
      return [{ text: 'Booked', value: 'booked' }, { text: 'Reserved', value: 'reserved' }, { text: 'Sold', value: 'sold_spa_signed' }];
    };

    _this.handleLoadMore = function () {
      var loanTrackerProjectID = _this.props.loanTrackerProjectID;
      var _this$state = _this.state,
          nextToken = _this$state.nextToken,
          currentTab = _this$state.currentTab;

      if (loanTrackerProjectID) {
        var token = nextToken[currentTab];
        _this.refresh(token);
      }
    };

    _this.handleChangeTab = function (e, _ref3) {
      var name = _ref3.name,
          value = _ref3.value;

      var currentTab = name || value;
      _this.setState({ currentTab: currentTab }, function () {
        _this.refresh();
      });
    };

    _this.handleOnChange = function (lawyers) {
      var onChange = _this.props.onChange;

      if (onChange) {
        onChange(lawyers);
      }
    };

    _this.handleOnChangeAutoAssignStatus = function (e, value) {
      var onStatusChange = _this.props.onStatusChange;

      if (onStatusChange) {
        onStatusChange(value.value);
      }
    };

    _this.handleOnChangeAssignWithoutIC = function (e, value) {
      var onSettingsChange = _this.props.onSettingsChange;

      if (onSettingsChange) {
        onSettingsChange({
          name: value.name,
          value: value.checked
        });
      }
    };

    _this.handleOnChangeEmails = function (e, _ref4) {
      var name = _ref4.name,
          value = _ref4.value;
      var onEmailsChange = _this.props.onEmailsChange;

      if (onEmailsChange) {
        onEmailsChange(name, value);
      }
    };

    _this.renderItemNode = function (lawyer, idx, currentTab) {
      var itemNode = _this.props.itemNode;

      if (itemNode) {
        return itemNode(lawyer, idx, currentTab);
      }
      return _react2.default.createElement(_LawyerItem2.default, {
        item: lawyer,
        disabled: _this.state.loading
      });
    };

    _this.renderContent = function () {
      var rowNode = _this.props.rowNode;
      var _this$state2 = _this.state,
          currentTab = _this$state2.currentTab,
          lawyers = _this$state2.lawyers,
          invited = _this$state2.invited;

      var list = currentTab === 'invited' ? invited : lawyers;
      if (list.length > 0) {
        return list.map(function (lawyer, idx) {
          if (rowNode) {
            return rowNode(lawyer, idx, currentTab);
          }
          return _react2.default.createElement(
            _semanticUiReact.Table.Row,
            { key: idx },
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              _this.renderItemNode(lawyer, idx, currentTab)
            )
          );
        });
      }
      return _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { textAlign: 'center' },
          _this.renderEmptyNode()
        )
      );
    };

    _this.renderEmptyNode = function () {
      var _this$props = _this.props,
          emptyNode = _this$props.emptyNode,
          t = _this$props.t;
      var currentTab = _this.state.currentTab;

      if (emptyNode) {
        return emptyNode(currentTab);
      }
      return _react2.default.createElement(
        'p',
        null,
        t('No {{currentTab}} lawyer found', { currentTab: currentTab, ns: _translation.TRANSLATION_FILES.screens }),
        '.'
      );
    };

    _this.renderLoadMore = function () {
      var _this$state3 = _this.state,
          currentTab = _this$state3.currentTab,
          lawyers = _this$state3.lawyers,
          invited = _this$state3.invited,
          nextToken = _this$state3.nextToken;
      var t = _this.props.t;

      var list = currentTab === 'invited' ? invited : lawyers;
      if (list.length > 0 && nextToken[currentTab]) {
        return _react2.default.createElement(
          _semanticUiReact.Segment,
          { basic: true, textAlign: 'center' },
          _react2.default.createElement(_semanticUiReact.Button, {
            onClick: _this.handleLoadMore,
            content: t('Load more')
          })
        );
      }
      return null;
    };

    var tabs = [{ text: props.t('Panel Lawyer'), name: 'panel', value: 'panel' }];
    _this.state = {
      loading: false,
      tabs: tabs,
      currentTab: tabs[0].name,
      lawyers: [],
      invited: [],
      nextToken: {}
    };
    return _this;
  }

  _createClass(ProjectPanelLawyers, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var loanTrackerProjectID = this.props.loanTrackerProjectID;

      if (loanTrackerProjectID > 0) {
        this.refresh();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var loanTrackerProjectID = nextProps.loanTrackerProjectID;

      if (loanTrackerProjectID !== this.props.loanTrackerProjectID) {
        this.refresh(null, loanTrackerProjectID);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          allowLawyerAssignWithoutIC = _props.allowLawyerAssignWithoutIC,
          buttonNode = _props.buttonNode,
          extraNode = _props.extraNode,
          panelLawyerSettings = _props.panelLawyerSettings,
          project = _props.project,
          updateProjectLoading = _props.updateProjectLoading,
          t = _props.t;
      var tabs = this.state.tabs;

      var loading = this.state.loading || this.props.loading;
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { className: 'ProjectPanelLawyers' },
        panelLawyerSettings && _react2.default.createElement(
          _semanticUiReact.Form,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { marginBottom: '20px' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, style: { marginTop: '13px' } },
              _react2.default.createElement(
                _semanticUiReact.Header,
                { as: 'h4' },
                'SPA Lawyer Settings'
              ),
              _react2.default.createElement(
                _semanticUiReact.Label,
                { className: 'LawyerAutoAssignSettings' },
                t('Auto-assign case to pre-assigned SPA Lawyers when status is'),
                ' \xA0',
                _react2.default.createElement(_semanticUiReact.Dropdown, {
                  onChange: this.handleOnChangeAutoAssignStatus,
                  options: this.getAutoAssignOptions().map(function (o) {
                    return _extends({}, o, {
                      text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants })
                    });
                  }),
                  selection: true,
                  value: project && project.autoAssignLawyerStatus ? project.autoAssignLawyerStatus : ''
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { basic: true },
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: 'Allow lawyer assignments without purchaser IC',
                  checked: allowLawyerAssignWithoutIC,
                  name: 'allowLawyerAssignWithoutIC',
                  onChange: this.handleOnChangeAssignWithoutIC
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, style: { marginTop: '20px' } },
              _react2.default.createElement(
                _semanticUiReact.Header,
                { as: 'h4' },
                'Lawyer Email Notification'
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Field,
                null,
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'lawyerSpaUpdateEmails' },
                  'SPA Status Update Notification'
                ),
                _react2.default.createElement(_semanticUiReact.Dropdown, {
                  name: 'lawyerSpaUpdateEmails',
                  onChange: this.handleOnChangeEmails,
                  options: project && project.lawyerSpaUpdateEmails ? project.lawyerSpaUpdateEmails.map(function (eml) {
                    return {
                      text: eml,
                      value: eml
                    };
                  }) : [],
                  value: project && project.lawyerSpaUpdateEmails ? project.lawyerSpaUpdateEmails : [],
                  placeholder: t('Add emails'),
                  noResultsMessage: t('Add emails'),
                  search: true,
                  selection: true,
                  fluid: true,
                  multiple: true,
                  allowAdditions: true
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Field,
                null,
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'lawyerLaUpdateEmails' },
                  'LA Status Update Notification'
                ),
                _react2.default.createElement(_semanticUiReact.Dropdown, {
                  name: 'lawyerLaUpdateEmails',
                  onChange: this.handleOnChangeEmails,
                  options: project && project.lawyerLaUpdateEmails ? project.lawyerLaUpdateEmails.map(function (eml) {
                    return {
                      text: eml,
                      value: eml
                    };
                  }) : [],
                  value: project && project.lawyerLaUpdateEmails ? project.lawyerLaUpdateEmails : [],
                  placeholder: t('Add emails'),
                  noResultsMessage: t('Add emails'),
                  search: true,
                  selection: true,
                  fluid: true,
                  multiple: true,
                  allowAdditions: true
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(
              _semanticUiReact.Menu,
              {
                fluid: true,
                attached: 'top',
                tabular: true
              },
              tabs.map(function (tab, key) {
                return _react2.default.createElement(
                  _semanticUiReact.Menu.Item,
                  {
                    key: key,
                    name: tab.name,
                    onClick: _this3.handleChangeTab,
                    active: _this3.state.currentTab === tab.value
                  },
                  tab.text
                );
              }),
              _react2.default.createElement(
                _semanticUiReact.Menu.Menu,
                { position: 'right' },
                buttonNode
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table,
              { unstackable: true, attached: 'bottom' },
              _react2.default.createElement(
                _semanticUiReact.Table.Body,
                null,
                loading && !updateProjectLoading ? _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    { textAlign: 'center' },
                    _react2.default.createElement(_semanticUiReact.Loader, { active: true, inline: 'centered' })
                  )
                ) : this.renderContent()
              )
            ),
            this.renderLoadMore()
          )
        ),
        extraNode ? _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            extraNode
          )
        ) : null
      );
    }
  }]);

  return ProjectPanelLawyers;
}(_react.Component);

ProjectPanelLawyers.contextTypes = {
  store: _propTypes2.default.object
};
ProjectPanelLawyers.propTypes = {
  loanTrackerProjectID: _propTypes2.default.number.isRequired,
  project: _propTypes2.default.shape({
    autoAssignLawyerStatus: _propTypes2.default.string,
    lawyerSpaUpdateEmails: _propTypes2.default.array,
    lawyerLaUpdateEmails: _propTypes2.default.array
  }),
  loading: _propTypes2.default.bool,
  extraNode: _propTypes2.default.node,
  buttonNode: _propTypes2.default.node,
  emptyNode: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onStatusChange: _propTypes2.default.func,
  onSettingsChange: _propTypes2.default.func,
  onEmailsChange: _propTypes2.default.func,
  itemNode: _propTypes2.default.func,
  rowNode: _propTypes2.default.func,
  allowLawyerAssignWithoutIC: _propTypes2.default.bool,
  updateProjectLoading: _propTypes2.default.bool,
  panelLawyerSettings: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
ProjectPanelLawyers.defaultProps = {
  panelLawyerSettings: false
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(ProjectPanelLawyers);

/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnitPackageFeeEdit = exports.ProjectUnitPackageFee = undefined;

var _ProjectUnitPackageFee = __webpack_require__(2172);

var _ProjectUnitPackageFee2 = _interopRequireDefault(_ProjectUnitPackageFee);

var _UnitPackageFeeEdit = __webpack_require__(2173);

var _UnitPackageFeeEdit2 = _interopRequireDefault(_UnitPackageFeeEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.ProjectUnitPackageFee = _ProjectUnitPackageFee2.default;
exports.UnitPackageFeeEdit = _UnitPackageFeeEdit2.default;

/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LawyersReports = exports.DelistReasonsByStatus = exports.ProjectUnitsByStatus = exports.BankAverageAgingSortItems = exports.BankAverageAging = exports.BranchBookingsSortItems = exports.BranchBookings = exports.UsersBookingsSortItems = exports.UsersBookings = exports.BookingsByStatus = undefined;

var _UsersBookings2 = __webpack_require__(2187);

Object.defineProperty(exports, 'UsersBookingsSortItems', {
  enumerable: true,
  get: function get() {
    return _UsersBookings2.sortItems;
  }
});

var _BranchBookings2 = __webpack_require__(2181);

Object.defineProperty(exports, 'BranchBookingsSortItems', {
  enumerable: true,
  get: function get() {
    return _BranchBookings2.sortItems;
  }
});

var _BankAverageAging2 = __webpack_require__(2179);

Object.defineProperty(exports, 'BankAverageAgingSortItems', {
  enumerable: true,
  get: function get() {
    return _BankAverageAging2.sortItems;
  }
});

var _BookingsByStatus2 = __webpack_require__(2180);

var _BookingsByStatus3 = _interopRequireDefault(_BookingsByStatus2);

var _UsersBookings3 = _interopRequireDefault(_UsersBookings2);

var _BranchBookings3 = _interopRequireDefault(_BranchBookings2);

var _BankAverageAging3 = _interopRequireDefault(_BankAverageAging2);

var _ProjectUnitsByStatus2 = __webpack_require__(2186);

var _ProjectUnitsByStatus3 = _interopRequireDefault(_ProjectUnitsByStatus2);

var _DelistReasonsByStatus2 = __webpack_require__(2182);

var _DelistReasonsByStatus3 = _interopRequireDefault(_DelistReasonsByStatus2);

var _LawyersReports2 = __webpack_require__(2183);

var _LawyersReports3 = _interopRequireDefault(_LawyersReports2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BookingsByStatus = _BookingsByStatus3.default;
exports.UsersBookings = _UsersBookings3.default;
exports.BranchBookings = _BranchBookings3.default;
exports.BankAverageAging = _BankAverageAging3.default;
exports.ProjectUnitsByStatus = _ProjectUnitsByStatus3.default;
exports.DelistReasonsByStatus = _DelistReasonsByStatus3.default;
exports.LawyersReports = _LawyersReports3.default;

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchBranch = function (_Component) {
  _inherits(SearchBranch, _Component);

  function SearchBranch(props) {
    _classCallCheck(this, SearchBranch);

    var _this = _possibleConstructorReturn(this, (SearchBranch.__proto__ || Object.getPrototypeOf(SearchBranch)).call(this, props));

    _initialiseProps.call(_this);

    var state = SearchBranch.getPropsToState(props);
    _this.state = _extends({}, state, {
      findBranchesResults: [],
      loading: false,
      showNoResults: true,
      selection: null
    });
    return _this;
  }

  _createClass(SearchBranch, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = SearchBranch.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.setTimer) {
        clearTimeout(this.setTimer);
      }
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, res);
      });
    }
  }, {
    key: 'searchBranches',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
        var store, res, message, _message, json, findBranchesResults, noResultsMessage;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = null;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/search/company_branches/?limit=3&isExternal=false&search=' + value, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 21;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);
                _context.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 19;
                  break;
                }

                _context.next = 17;
                return _context.t0.res.text();

              case 17:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 19:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));

              case 21:
                if (res.ok) {
                  _context.next = 29;
                  break;
                }

                _context.next = 24;
                return res.text();

              case 24:
                _message = _context.sent;
                _context.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 27:
                _context.next = 41;
                break;

              case 29:
                _context.next = 31;
                return res.json();

              case 31:
                json = _context.sent;

                if (!json) {
                  _context.next = 38;
                  break;
                }

                findBranchesResults = json.map(function (obj) {
                  var newResults = {};
                  newResults.key = obj.id;
                  newResults.title = obj.shortName;
                  return newResults;
                });
                _context.next = 36;
                return this.setComponentState({ findBranchesResults: findBranchesResults });

              case 36:
                _context.next = 41;
                break;

              case 38:
                noResultsMessage = 'No results found.';
                _context.next = 41;
                return this.setComponentState({ noResultsMessage: noResultsMessage });

              case 41:
                _context.next = 43;
                return this.setLoading(false);

              case 43:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function searchBranches(_x3) {
        return _ref.apply(this, arguments);
      }

      return searchBranches;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            this.props.selectedValue.key > 0 || this.state.selection ? _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 16 },
                  _react2.default.createElement(_semanticUiReact.Input, {
                    readOnly: true,
                    fluid: true,
                    value: this.props.selectedValue.key > 0 ? '' + this.props.selectedValue.title : '' + this.state.selection.title,
                    icon: _react2.default.createElement(_semanticUiReact.Icon, {
                      title: 'Clear Selection',
                      name: 'x',
                      onClick: this.handleClearSelection,
                      link: true
                    })
                  })
                )
              )
            ) : _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 16 },
                  _react2.default.createElement(_semanticUiReact.Search, {
                    className: 'searchlist',
                    fluid: true,
                    icon: _react2.default.createElement(_semanticUiReact.Icon, {
                      title: 'Clear Selection',
                      name: this.state.value ? 'x' : 'search',
                      onClick: this.state.value && this.handlerClearValue,
                      link: !!this.state.value
                    }),
                    loading: this.state.loading,
                    onResultSelect: this.handleResultSelect,
                    onSearchChange: this.handleSearchChange,
                    results: this.state.findBranchesResults,
                    value: this.state.value,
                    placeholder: 'Find Business Unit...',
                    noResultsMessage: this.state.noResultsMessage,
                    onFocus: function onFocus() {
                      var showNoResults = false;
                      _this4.setState({ showNoResults: showNoResults });
                    },
                    showNoResults: this.state.showNoResults
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return SearchBranch;
}(_react.Component);

SearchBranch.contextTypes = {
  store: _propTypes2.default.object
};
SearchBranch.propTypes = {
  onSelect: _propTypes2.default.func.isRequired,
  onClear: _propTypes2.default.func.isRequired,
  selectedValue: _propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired
  }).isRequired
};
SearchBranch.defaultProps = {
  selectedValue: {
    key: 0,
    title: ''
  }
};

SearchBranch.getPropsToState = function (props) {
  var value = props.value || '';
  var noResultsMessage = 'Loading...';
  return {
    value: value,
    noResultsMessage: noResultsMessage
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.handleSearchChange = function (e, _ref2) {
    var value = _ref2.value;

    clearTimeout(_this5.setTimer);
    var findBranchesResults = [];
    var showNoResults = true;
    var noResultsMessage = 'Loading...';
    _this5.setState({ findBranchesResults: findBranchesResults, noResultsMessage: noResultsMessage, showNoResults: showNoResults, value: value }, function () {
      if (value !== '') {
        _this5.setTimer = setTimeout(function () {
          _this5.searchBranches(value);
        }, 500);
      }
    });
  };

  this.handleResultSelect = function (e, _ref3) {
    var result = _ref3.result;

    _this5.setState({
      result: result,
      value: ''
    }, function () {
      _this5.props.onSelect(result);
    });
  };

  this.handleClearSelection = function () {
    _this5.setState({
      selection: null
    }, function () {
      _this5.props.onClear();
    });
  };

  this.handlerClearValue = function () {
    _this5.setState({
      value: ''
    });
  };
};

exports.default = SearchBranch;

/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.List = exports.SharedNote = undefined;

var _SharedNote = __webpack_require__(2190);

var _SharedNote2 = _interopRequireDefault(_SharedNote);

var _List = __webpack_require__(2189);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SharedNote = _SharedNote2.default;
exports.List = _List2.default;
exports.default = _SharedNote2.default;

/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _ModalConfirm = __webpack_require__(399);

var _ModalConfirm2 = _interopRequireDefault(_ModalConfirm);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TemplateList = function (_Component) {
  _inherits(TemplateList, _Component);

  function TemplateList(props) {
    var _this2 = this;

    _classCallCheck(this, TemplateList);

    var _this = _possibleConstructorReturn(this, (TemplateList.__proto__ || Object.getPrototypeOf(TemplateList)).call(this, props));

    _this.handleChangePage = function (currentPage) {
      _this.setState({ currentPage: currentPage }, function () {
        _this.fetchTemplates(_this.props.where);
      });
    };

    _this.handleCancelDelete = function (e) {
      e.preventDefault();
      _this.setState({
        showConfirm: false,
        selectedTemplateID: ''
      });
    };

    _this.handleConfirmDelete = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var t, store, _this$state, selectedTemplateID, token, message;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              t = _this.props.t;
              store = _this.context.store;
              _this$state = _this.state, selectedTemplateID = _this$state.selectedTemplateID, token = _this$state.token;
              _context.next = 5;
              return _this.setLoading(true);

            case 5:
              _context.prev = 5;
              _context.next = 8;
              return store.dispatch((0, _fetchM.fetchM)('/templates/' + encodeURIComponent(selectedTemplateID) + '/', {
                credentials: 'include',
                method: 'DELETE',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Csrf-Token': token
                }
              }));

            case 8:
              _context.next = 22;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](5);

              Bugsnag.notifyException(_context.t0);

              if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                _context.next = 19;
                break;
              }

              _context.next = 16;
              return _context.t0.res.text();

            case 16:
              message = _context.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
              return _context.abrupt('return');

            case 19:
              _context.next = 21;
              return _this.setLoading(false);

            case 21:
              store.dispatch((0, _flash.flashErrorMessage)(_context.t0));

            case 22:

              _this.setState({
                selectedTemplate: '',
                loading: false,
                showModalConfirm: false
              }, function () {
                _this.fetchTemplates(_this.props.where);
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully deleted', { ns: _translation.TRANSLATION_FILES.translation, name: selectedTemplateID }) }));
              });

            case 23:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[5, 10]]);
    }));

    _this.handleOpenWarningModal = function (e, templateID) {
      if (e) {
        e.preventDefault();
      }
      _this.setState({
        selectedTemplateID: templateID,
        showModalConfirm: true
      });
    };

    _this.handleCloseWarningModal = function (e) {
      if (e) {
        e.preventDefault();
      }
      _this.setState({
        selectedTemplateID: '',
        showModalConfirm: false
      });
    };

    _this.isDefault = function (data) {
      return data.name && data.name.toLowerCase().includes('default');
    };

    _this.state = {
      count: 0,
      limit: 0,
      offset: 0,
      loading: props.loading || true,
      data: [],
      currentPage: 1,
      showConfirm: false,
      selectedTemplateID: '',
      showModalConfirm: false,
      token: ''
    };
    return _this;
  }

  _createClass(TemplateList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchTemplates(this.props.where);
    }
  }, {
    key: 'setTemplates',
    value: function setTemplates() {
      var _this3 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this3.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this4 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this4.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this5 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this5.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchTemplates',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var where = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var store, _props, type, t, query, res, path, message, count, limit, offset, data, token;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _props = this.props, type = _props.type, t = _props.t;
                query = Object.assign({}, where);

                query.page = this.state.currentPage || 1;
                res = void 0;
                path = 'templates';

                if (type === 'sms') {
                  path = 'sms_templates';
                } else {
                  query.templateType = type;
                }
                _context2.prev = 9;
                _context2.next = 12;
                return store.dispatch((0, _fetchM.fetchM)('/' + path + '/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context2.sent;
                _context2.next = 23;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](9);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 20;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 20:
                _context2.next = 22;
                return this.setLoading(false);

              case 22:
                return _context2.abrupt('return');

              case 23:
                if (res.ok) {
                  _context2.next = 31;
                  break;
                }

                _context2.next = 26;
                return res.text();

              case 26:
                message = _context2.sent;
                _context2.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 29:
                _context2.next = 42;
                break;

              case 31:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context2.next = 36;
                return res.json();

              case 36:
                data = _context2.sent;
                _context2.next = 39;
                return this.setTemplates(data);

              case 39:
                // handle token.. etc
                token = res.headers.get('X-Csrf-Token');
                _context2.next = 42;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset,
                  token: token
                });

              case 42:
                _context2.next = 44;
                return this.setLoading(false);

              case 44:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[9, 15]]);
      }));

      function fetchTemplates() {
        return _ref2.apply(this, arguments);
      }

      return fetchTemplates;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props2 = this.props,
          t = _props2.t,
          type = _props2.type;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 20 },
            active: this.state.loading && this.state.data.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(_ModalConfirm2.default, {
          open: this.state.showModalConfirm,
          onClose: this.handleCloseWarningModal,
          onConfirm: this.handleConfirmDelete,
          headerNode: t('Delete Confirmation', { ns: _translation.TRANSLATION_FILES.screens }),
          content: t('Are you sure you want to delete this template?', { ns: _translation.TRANSLATION_FILES.screens })
        }),
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            striped: true, unstackable: true,
            selectable: true
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 5 },
                _react2.default.createElement(_semanticUiReact.Button, {
                  as: _reactRouter.Link,
                  primary: true,
                  size: 'small',
                  icon: 'add',
                  content: t('Template', { ns: _translation.TRANSLATION_FILES.screens }),
                  to: '/settings/' + type + '_templates/new/'
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 4 },
                t('Name', { ns: _translation.TRANSLATION_FILES.screens })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 4 },
                'ID'
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 4 },
                t('Updated At', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null),
              _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null)
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            this.state.data.length > 0 ? this.state.data.map(function (field, key) {
              return _react2.default.createElement(
                _semanticUiReact.Table.Row,
                { key: key },
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { width: 4 },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    {
                      to: !_this6.isDefault(field) ? '/settings/' + type + '_templates/' + encodeURIComponent(field.id) + '/' : ''
                    },
                    field.name
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { width: 4 },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    {
                      to: !_this6.isDefault(field) ? '/settings/' + type + '_templates/' + encodeURIComponent(field.id) + '/' : ''
                    },
                    field.id
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  _react2.default.createElement(_Timestamp2.default, { timestamp: field.updatedAt, format: 'MMMM Do YYYY, h:mm a' })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { collapsing: true, textAlign: 'right' },
                  _react2.default.createElement(_semanticUiReact.Button, {
                    as: _reactRouter.Link,
                    size: 'tiny',
                    icon: 'edit',
                    content: 'Edit',
                    to: '/settings/' + type + '_templates/' + encodeURIComponent(field.id) + '/',
                    disabled: _this6.isDefault(field)
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { collapsing: true, textAlign: 'right' },
                  type !== 'sms' && _react2.default.createElement(_semanticUiReact.Button, {
                    negative: true,
                    size: 'tiny',
                    icon: 'trash',
                    onClick: function onClick(e) {
                      return _this6.handleOpenWarningModal(e, field.id);
                    },
                    disabled: _this6.isDefault(field)
                  })
                )
              );
            }) : _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 5, textAlign: 'center' },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                ) : _react2.default.createElement(
                  'p',
                  null,
                  t('No templates found.', { ns: _translation.TRANSLATION_FILES.translation })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return TemplateList;
}(_react.Component);

TemplateList.contextTypes = {
  store: _propTypes2.default.object
};
TemplateList.propTypes = {
  where: _propTypes2.default.shape({
    limit: _propTypes2.default.number
  }),
  loading: _propTypes2.default.bool,
  type: _propTypes2.default.oneOf(['print', 'sms', 'quotation']).isRequired,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(TemplateList);

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _SizeSuffix = __webpack_require__(316);

var _SizeSuffix2 = _interopRequireDefault(_SizeSuffix);

var _translation = __webpack_require__(4);

var _translation2 = __webpack_require__(64);

var _unitLayout = __webpack_require__(270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitLayoutItem = function (_Component) {
  _inherits(UnitLayoutItem, _Component);

  function UnitLayoutItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UnitLayoutItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UnitLayoutItem.__proto__ || Object.getPrototypeOf(UnitLayoutItem)).call.apply(_ref, [this].concat(args))), _this), _this.statusColor = function (available, total) {
      var percentage = Math.round(available / total * 100);
      switch (true) {
        case percentage >= 75:
          return null;
        case percentage >= 50:
          return 'yellow';
        case percentage >= 25:
          return 'orange';
        default:
          return 'red';
      }
    }, _this.handleOnClick = function (e) {
      if (_this.props.onClick) {
        _this.props.onClick(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UnitLayoutItem, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.name !== nextProps.name || this.props.size !== nextProps.size || this.props.landArea !== nextProps.landArea || this.props.nfa !== nextProps.nfa || this.props.nsa !== nextProps.nsa || JSON.stringify(this.props.summary) !== JSON.stringify(nextProps.summary) || (this.props.project || nextProps.project) && this.props.project.sizeSuffix !== nextProps.project.sizeSuffix || this.props.isMobile !== nextProps.isMobile || this.props.buttonNode && this.props.loading !== nextProps.loading) {
        return true;
      }
      return false;
    }
  }, {
    key: 'checkAs',
    value: function checkAs() {
      if (this.props.to) {
        return _reactRouter.Link;
      }
      if (this.props.onClick) {
        return 'a';
      }
      return null;
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      var countryCode = this.props.auth && this.props.auth.company && typeof this.props.auth.company.countryCode === 'string' ? this.props.auth.company.countryCode.toUpperCase() : '';
      var isVietnam = countryCode === 'VN';
      return _react2.default.createElement(
        _semanticUiReact.Segment,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', verticalAlign: 'middle', doubling: true, stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { textAlign: 'center' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { verticalAlign: 'middle', columns: 'equal' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { only: 'mobile' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'center' },
                    _react2.default.createElement(_semanticUiReact.Header, {
                      as: this.checkAs(),
                      content: this.props.name,
                      onClick: this.handleOnClick,
                      to: this.props.to
                    })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  {
                    style: this.props.isMobile ? {
                      paddingLeft: '1em',
                      paddingRight: '1em'
                    } : null
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'left', className: 'mobile-hide' },
                    _react2.default.createElement(_semanticUiReact.Header, {
                      as: this.checkAs(),
                      content: this.props.name,
                      onClick: this.handleOnClick,
                      to: this.props.to
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_semanticUiReact.Header, {
                      size: 'small',
                      content: isVietnam ? (0, _translation2.translateModels)(t, 'nsa', 'projectUnitLayout') : (0, _translation2.translateModels)(t, 'size', 'projectUnitLayout'),
                      subheader: _react2.default.createElement(_SizeSuffix2.default, {
                        className: 'sub header',
                        size: (0, _unitLayout.layoutAreaValue)(isVietnam, this.props),
                        suffix: this.props.project.sizeSuffix,
                        isVietnam: isVietnam
                      })
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_semanticUiReact.Header, {
                      size: 'small',
                      content: isVietnam ? (0, _translation2.translateModels)(t, 'nfa', 'projectUnitLayout') : (0, _translation2.translateModels)(t, 'landArea', 'projectUnitLayout'),
                      subheader: _react2.default.createElement(_SizeSuffix2.default, {
                        className: 'sub header',
                        size: (0, _unitLayout.layoutLandAreaValue)(isVietnam, this.props),
                        suffix: this.props.project.sizeSuffix,
                        isVietnam: isVietnam
                      })
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Header,
                      { size: 'small' },
                      t('Units'),
                      _react2.default.createElement(
                        _semanticUiReact.Header.Subheader,
                        null,
                        this.props.summary ? this.props.summary.newUnits : '-',
                        '/',
                        this.props.summary ? this.props.summary.totalUnits : '-',
                        this.hasAccess() && this.props.summary && this.props.summary.delistUnits ? _react2.default.createElement('br', null) : null,
                        this.hasAccess() && this.props.summary && this.props.summary.delistUnits ? _react2.default.createElement(
                          'small',
                          null,
                          t('Delist', { ns: _translation.TRANSLATION_FILES.constants }),
                          ': ',
                          this.props.summary.delistUnits
                        ) : null
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 7 },
              this.props.buttonNode ? this.props.buttonNode({
                loading: this.props.loading
              }) : null
            )
          )
        )
      );
    }
  }]);

  return UnitLayoutItem;
}(_react.Component);

UnitLayoutItem.propTypes = {
  name: _propTypes2.default.string,
  size: _propTypes2.default.number,
  landArea: _propTypes2.default.number,
  // CPI-1208: Vietnam's two areas; the list spreads the whole layout record onto this component.
  nfa: _propTypes2.default.number,
  nsa: _propTypes2.default.number,
  summary: _propTypes2.default.shape({
    newUnits: _propTypes2.default.number,
    totalUnits: _propTypes2.default.number,
    delistUnits: _propTypes2.default.number
  }),
  project: _propTypes2.default.shape({
    sizeSuffix: _propTypes2.default.string
  }),
  isMobile: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  buttonNode: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  to: _propTypes2.default.string,
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  t: _propTypes2.default.func
};

UnitLayoutItem.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.projectUnitLayout]))((0, _reactRedux.connect)(UnitLayoutItem.mapStateToProps)(UnitLayoutItem));

/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BookingStatusDropdown = function (_React$Component) {
  _inherits(BookingStatusDropdown, _React$Component);

  function BookingStatusDropdown(props) {
    _classCallCheck(this, BookingStatusDropdown);

    var _this = _possibleConstructorReturn(this, (BookingStatusDropdown.__proto__ || Object.getPrototypeOf(BookingStatusDropdown)).call(this, props));

    _this.getClassFromValue = function (value) {
      var options = _this.props.options;

      var selected = options.find(function (opt) {
        return opt.value === value;
      });
      return selected && selected.className ? selected.className : 'uc-total';
    };

    _this.handleDynamicClass = function (newClass) {
      _this.setState({ dynamicClass: newClass });
    };

    _this.handleOnChange = function (e, _ref) {
      var value = _ref.value;

      var newClass = _this.getClassFromValue(value);
      _this.setState({ dynamicClass: newClass });
      _this.props.onChange(value);
    };

    _this.state = {
      dynamicClass: _this.getClassFromValue(props.value)
    };
    return _this;
  }

  _createClass(BookingStatusDropdown, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value !== this.props.value) {
        var newClass = this.getClassFromValue(this.props.value);
        if (newClass !== this.state.dynamicClass) {
          this.handleDynamicClass(newClass);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          options = _props.options,
          value = _props.value;
      var dynamicClass = this.state.dynamicClass;


      return _react2.default.createElement(_semanticUiReact.Dropdown, {
        fluid: true,
        selection: true,
        floating: true,
        className: 'uc-dropdown-show-all-items uc-booking-status-dropdown ' + dynamicClass,
        options: options.map(function (option) {
          return {
            key: option.key,
            value: option.value,
            text: _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { className: 'uc-booking-status-text' },
                option.count
              ),
              _react2.default.createElement('div', { style: { marginBottom: '4px' } }),
              _react2.default.createElement(
                'span',
                { className: 'uc-booking-status-label' },
                option.valueLabel
              )
            ),
            content: _react2.default.createElement(
              'div',
              { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
              _react2.default.createElement(
                'span',
                { className: 'uc-booking-status-item' },
                option.valueLabel
              ),
              _react2.default.createElement(
                'span',
                { className: 'uc-booking-status-item' },
                option.count
              )
            )
          };
        }),
        onChange: this.handleOnChange,
        value: value,
        icon: _react2.default.createElement('i', { className: 'dropdown icon' })
      });
    }
  }]);

  return BookingStatusDropdown;
}(_react2.default.Component);

BookingStatusDropdown.propTypes = {
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    count: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]).isRequired,
    valueLabel: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired,
    className: _propTypes2.default.string
  })).isRequired,
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.string
};

exports.default = BookingStatusDropdown;

/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FixedBarStatus = function FixedBarStatus(_ref) {
  var className = _ref.className,
      status = _ref.status,
      name = _ref.name,
      count = _ref.count,
      onClick = _ref.onClick,
      selected = _ref.selected,
      style = _ref.style;

  var classNames = ['uc-tab-status'];
  if (className) {
    classNames.push(className);
  }
  if (selected) {
    classNames.push('selected');
  }
  var handleOnClick = function handleOnClick(event) {
    event.preventDefault();
    if (onClick) {
      onClick(status);
    }
  };
  return _react2.default.createElement(
    _semanticUiReact.Grid.Column,
    {
      className: classNames.join(' '),
      onClick: handleOnClick,
      style: style
    },
    _react2.default.createElement(
      'p',
      null,
      count
    ),
    name
  );
};

FixedBarStatus.contextTypes = {
  store: _propTypes2.default.object
};

FixedBarStatus.propTypes = {
  className: _propTypes2.default.string,
  status: _propTypes2.default.string,
  name: _propTypes2.default.string,
  count: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  onClick: _propTypes2.default.func,
  selected: _propTypes2.default.bool,
  style: _propTypes2.default.shape({
    minWidth: _propTypes2.default.string,
    maxWidth: _propTypes2.default.string
  })
};

exports.default = FixedBarStatus;

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _strings = __webpack_require__(118);

var _json = __webpack_require__(268);

var _translation = __webpack_require__(64);

var _translation2 = __webpack_require__(4);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


// Still needed for the module-level locale; the feed date renders through Timestamp.
_momentTimezone2.default.locale('en-gb');

var UserActivities = function (_Component) {
  _inherits(UserActivities, _Component);

  function UserActivities() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserActivities);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserActivities.__proto__ || Object.getPrototypeOf(UserActivities)).call.apply(_ref, [this].concat(args))), _this), _this.translateGroupsToName = function (groups) {
      var t = _this.props.t;

      var text = void 0;
      var accessRoles = [{ text: 'Headquarters', values: [10, 6], description: 'Admin' }, { text: 'Supervisor', values: [10, 11, 12, 13], description: 'BU Leader' }, { text: 'Sales Manager', values: [10, 11, 13], description: 'BU Leader' }, { text: 'Sales Admin', values: [10, 11], description: 'BU Leader' }, { text: 'Agency Admin', values: [10, 21], description: 'Claim C.' }, { text: 'Agent Leader', values: [10, 17] }, { text: 'Agent / Staff', values: [10] }, { text: 'Basic Siteplan', values: [16] }];
      accessRoles.forEach(function (ar) {
        var result = ar.values.every(function (word) {
          return groups.indexOf(word.toString()) > -1;
        });
        if (result && !text) text = t(ar.text, { ns: _translation2.TRANSLATION_FILES.constants }) + ' ' + (ar.description ? '(' + t(ar.description, { ns: _translation2.TRANSLATION_FILES.constants }) + ')' : '');
      });
      if (!text) text = groups;
      return text;
    }, _this.translateStatusToName = function (statusId) {
      var t = _this.props.t;

      var userStatuses = [{ text: 'Active', value: 100 }, { text: 'Suspended', value: 503 }];
      var status = userStatuses.find(function (s) {
        return s.value === statusId;
      });
      return status ? t(status.text, { ns: _translation2.TRANSLATION_FILES.constants }) : null;
    }, _this.renderActivityMessage = function (activity) {
      var t = _this.props.t;

      var activityBefore = (0, _json.parseJSON)(activity.before);
      var activityAfter = (0, _json.parseJSON)(activity.after);
      var afterKeys = Object.keys(activityAfter);
      var changes = [];
      afterKeys.forEach(function (element) {
        var message = void 0;
        var after = '';
        var before = activityBefore[element];
        if (activity.before) {
          after = activityAfter[element];
        }
        switch (element) {
          case 'groups':
            before = activity.before ? _this.translateGroupsToName(activity.before) : null;
            after = activity.after ? _this.translateGroupsToName(activity.after) : null;
            break;
          case 'statusID':
            before = activity.before ? _this.translateStatusToName(before) : null;
            after = activity.after ? _this.translateStatusToName(after) : null;
            break;
          case 'isOldUser':
          case 'loginAttempt':
          case 'profileImageSrc':
          case 'name':
          case 'preferredName':
          case 'email':
          case 'mobile':
          case 'mobilePrefix':
          case 'officeTel':
          case 'officeTelPrefix':
            before = null;
            after = null;
            break;
          default:
            break;
        }
        if (message) {
          changes.push(message);
        } else if (before || after) {
          var keyName = (0, _translation.translateModels)(t, element, 'user', (0, _strings.camelToTitle)(element));
          if (before === false && after) {
            message = _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation2.TRANSLATION_FILES.screens },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  { style: { color: '#666' } },
                  { keyName: keyName }
                ),
                ' has been added'
              )
            );
          } else if (!before) {
            message = _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { style: { color: '#666' } },
                keyName
              ),
              ': ',
              _react2.default.createElement(
                'u',
                null,
                after
              )
            );
          } else if (before && !after) {
            message = _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation2.TRANSLATION_FILES.screens },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  { style: { color: '#666' } },
                  { keyName: keyName }
                ),
                ' has been removed'
              )
            );
          } else {
            message = _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation2.TRANSLATION_FILES.screens },
              _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'span',
                  { style: { color: '#666' } },
                  { keyName: keyName }
                ),
                ' changed from ',
                _react2.default.createElement(
                  'u',
                  null,
                  { before: before }
                ),
                ' to ',
                _react2.default.createElement(
                  'u',
                  null,
                  { after: after }
                )
              )
            );
          }
          changes.push(message);
        }
      });
      return _react2.default.createElement(
        _semanticUiReact.List,
        { bulleted: true },
        changes.map(function (element, id) {
          return _react2.default.createElement(
            _semanticUiReact.List.Item,
            { key: id },
            element
          );
        })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserActivities, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          data = _props.data,
          t = _props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(
              _semanticUiReact.Feed,
              null,
              data && data.length > 0 ? data.map(function (activity, idx) {
                return _react2.default.createElement(
                  _semanticUiReact.Feed.Event,
                  { key: idx, className: 'activity-logs' },
                  _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: 'user' }),
                  _react2.default.createElement(
                    _semanticUiReact.Feed.Content,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Date,
                      null,
                      _react2.default.createElement(_Timestamp2.default, { timestamp: activity.createdAt, format: 'MMMM Do YYYY, h:mm:ss a' })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Summary,
                      null,
                      _this2.props.hasAccess ? activity.creatorAffiliateID > 0 ? _react2.default.createElement(
                        _reactRouter.Link,
                        { to: '/users/' + activity.creatorAffiliateID + '/' },
                        activity.creatorPreferredName || t('Unknown')
                      ) : activity.creatorPreferredName || 'U' + activity.creatorUserID : activity.creatorPreferredName || 'U' + activity.creatorUserID,
                      ' ' + t(activity.message),
                      _this2.props.showAll && _react2.default.createElement(
                        _reactRouter.Link,
                        { to: '/users/' + activity.userAffiliateID + '/' },
                        ' ' + (activity.userPreferredName || 'U' + activity.userID)
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Extra,
                      { text: true },
                      activity.after && _this2.renderActivityMessage(activity)
                    )
                  )
                );
              }) : this.props.loading ? _react2.default.createElement('br', null) : _react2.default.createElement(
                'center',
                null,
                t('No activity found'),
                '.'
              )
            )
          )
        )
      );
    }
  }]);

  return UserActivities;
}(_react.Component);

UserActivities.propTypes = {
  data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  hasAccess: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  showAll: _propTypes2.default.bool
};
exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation2.namespaces), [_translation2.TRANSLATION_FILES.models.user]))(UserActivities);

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var AUTOFILL_NRIC = exports.AUTOFILL_NRIC = 'nric';
var AUTOFILL_PASSPORT = exports.AUTOFILL_PASSPORT = 'passport';
var AUTOFILL_MILITARY = exports.AUTOFILL_MILITARY = 'military';
var AUTOFILL_COMPANY = exports.AUTOFILL_COMPANY = 'company';
var AUTOFILL_ID_NUMBER = exports.AUTOFILL_ID_NUMBER = 'id_number';
var AUTOFILL_PRESET = exports.AUTOFILL_PRESET = 'preset';
var AUTOFILL_MSISDN = exports.AUTOFILL_MSISDN = 'msisdn';
var AUTOFILL_PRS = exports.AUTOFILL_PRS = 'prs';

var AUTOFILL_IDENTITY_TYPES = exports.AUTOFILL_IDENTITY_TYPES = [{ id: 1, name: 'nric' }, { id: 2, name: 'passport' }, { id: 3, name: 'military' }, { id: 4, name: 'company' }, { id: 5, name: 'id_number' }, { id: 6, name: 'preset' }];

var CRM_SEARCH_FIELD_MAPPINGS = exports.CRM_SEARCH_FIELD_MAPPINGS = [{
  label: 'Kartu Tanda Penduduk',
  searchField: 'ktp'
}];

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BOOKING_FEE_PAYMENT_STATUSES = [
// offline payment statuses
{ text: 'Cancelled', value: 'cancelled' }, { text: 'Deduction', value: 'deduction' }, { text: 'Paid (Verified)', value: 'paid' }, { text: 'Pending', value: 'pending' }, { text: 'Paid (Pending Verification)', value: 'pending_verification' },

// online payment statuses
{ text: 'Approved', value: 'approved' }, { text: 'Pending Registration', value: 'new' }, { text: 'Paid', value: 'payment_completed' }, { text: 'Expired', value: 'payment_expired' }, { text: 'Payment Failed', value: 'payment_failed' }, { text: 'Payment Submitted', value: 'payment_submitted' }, { text: 'Payment Initiated', value: 'payment_initiated' }, { text: 'Rejected', value: 'rejected' }];
exports.default = BOOKING_FEE_PAYMENT_STATUSES;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var bookingNoteDefaultPrivacyOptions = exports.bookingNoteDefaultPrivacyOptions = [{
  text: 'Public',
  value: 'public'
}, {
  text: 'Internal',
  value: 'internal'
}, {
  text: 'Only Me',
  value: 'private'
}];

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CU_BU_LEADER_ACCESS = exports.CU_BU_LEADER_ACCESS = 'bu_leader';

var CU_EXTERNAL_STAFF_ACCESS = exports.CU_EXTERNAL_STAFF_ACCESS = 'external_staff';

var CU_STAFF_ACCESS = exports.CU_STAFF_ACCESS = 'staff';

var changeUnitAccessesOptions = exports.changeUnitAccessesOptions = [{
  text: 'BU Leader',
  value: CU_BU_LEADER_ACCESS,
  selected: true
}, {
  text: 'Staff',
  value: CU_STAFF_ACCESS
}, {
  text: 'External Staff',
  value: CU_EXTERNAL_STAFF_ACCESS
}];

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var DOCUMENT_TYPE_OPTIONS = [{ text: 'Bank Loan Document', value: 'bank_loan_document' }, { text: 'Identity', value: 'identity' }, { text: 'Installment Payment', value: 'installment_payment' }, { text: 'Other Documents', value: 'other_documents' }, { text: 'Registration of Interest', value: 'registration_of_interest' }, { text: 'Token Payment', value: 'token_payment' }, { text: 'Token Refund', value: 'token_refund' }, { text: 'Token Payment Receipt', value: 'token_payment_receipt' }];

// CPI-1249: the four types below are generated by the system (the sales form book-api files
// against the opportunity, the banker copy, and the bank-package pair), so they must NOT appear
// in the upload dropdown - DOCUMENT_TYPE_OPTIONS above stays the only source for that. They do
// have to be nameable, otherwise a generated file shows its Type as the literal "N/A".
// These are the remaining four of book-api's twelve `ValidFileTypes`
// (mhub-book-api models/shared_media.go).
var DOCUMENT_TYPE_LABELS = exports.DOCUMENT_TYPE_LABELS = [].concat(DOCUMENT_TYPE_OPTIONS, [{ text: 'Opportunity Form', value: 'opportunity_form' }, { text: 'Banker Opportunity Form', value: 'banker_opportunity_form' }, { text: 'Bank Package Form', value: 'bank_package_form' }, { text: 'Bank Package Image', value: 'bank_package_image' }]);

// getDocumentTypeLabel returns the untranslated label for a backend file_type, or null when the
// value is unknown (an empty string, or a type added to book-api and not yet to this list). The
// caller decides what to render for null - the Documents tab shows a translated "N/A".
var getDocumentTypeLabel = exports.getDocumentTypeLabel = function getDocumentTypeLabel(fileType) {
  if (!fileType) return null;
  var option = DOCUMENT_TYPE_LABELS.find(function (opt) {
    return opt.value === fileType;
  });
  return option ? option.text : null;
};

exports.default = DOCUMENT_TYPE_OPTIONS;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FIRST_TIME_BUYER = [{ text: 'Yes', value: 'yes' }, { text: 'No', value: 'no' }];
exports.default = FIRST_TIME_BUYER;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var LANGUAGE_CODES = [{ text: 'English', value: 'en' }, { text: 'Indonesian', value: 'id' }, { text: 'Vietnamese', value: 'vi' }];

exports.default = LANGUAGE_CODES;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PAYMENT_METHODS = [{ text: 'Panel Banker', value: 'referred_banker' }, { text: 'Preferred Banker', value: 'own_banker' }, { text: 'Cash Buyer', value: 'cash' }, { text: 'Government Loan', value: 'government_loan' }, { text: 'Staff Loan', value: 'staff_loan' }, { text: 'Rent-To-Own', value: 'rent_to_own' }];
exports.default = PAYMENT_METHODS;
var PAYMENT_METHOD_PANEL_BANKER = exports.PAYMENT_METHOD_PANEL_BANKER = 'referred_banker';
var PAYMENT_METHOD_PREFERRED_BANKER = exports.PAYMENT_METHOD_PREFERRED_BANKER = 'own_banker';
var PAYMENT_METHOD_CASH_BUYER = exports.PAYMENT_METHOD_CASH_BUYER = 'cash';
var PAYMENT_METHOD_GOVERNMENT_LOAN = exports.PAYMENT_METHOD_GOVERNMENT_LOAN = 'government_loan';
var PAYMENT_METHOD_STAFF_LOAN = exports.PAYMENT_METHOD_STAFF_LOAN = 'staff_loan';
var PAYMENT_METHOD_RENT_TO_OWN = exports.PAYMENT_METHOD_RENT_TO_OWN = 'rent_to_own';
var PAYMENT_METHOD_BANK_LOAN = exports.PAYMENT_METHOD_BANK_LOAN = 'bank_loan';

// CPI-974 (D2/S1): Vietnam-only source-of-finance option. Deliberately NOT a member of
// PAYMENT_METHODS: that array is the un-gated fallback OPTION list for the Booking Overview
// Source-of-finance select (containers/Bookings/Overview/Info.jsx), so an entry here would be
// selectable in Malaysia - and book-api migration 0526 has made 'bank_loan' a valid FK target,
// so it would persist. Options are assembled per country by utils/vietnam.js
// paymentMethodOpts(auth); this object is the only source of the VN entry.
var PAYMENT_METHOD_BANK_LOAN_OPTION = exports.PAYMENT_METHOD_BANK_LOAN_OPTION = { text: 'Bank Loan', value: PAYMENT_METHOD_BANK_LOAN };

// Label-only lookup table: every payment-method value the app can render a name for, including
// the Vietnam-only ones. NEVER use this as an option list - use paymentMethodOpts(auth).
var PAYMENT_METHOD_LABELS = exports.PAYMENT_METHOD_LABELS = [].concat(PAYMENT_METHODS, [PAYMENT_METHOD_BANK_LOAN_OPTION]);

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Related purchaser's relationship to the primary purchaser. Values match the CRM's
// `relationship_type` on a related customer (and the marketplace's RELATIONSHIP_TYPE_DATA);
// book-api validates the same closed set (models.RelationshipTypeAllowed).
var RELATIONSHIP_TYPE = exports.RELATIONSHIP_TYPE = [{ text: 'Spouse', value: 'Spouse' }, { text: 'Immediate family', value: 'Immediate family' }, { text: 'Relative', value: 'Relative' }, { text: 'Friend', value: 'Friend' }, { text: 'Others', value: 'Others' }, { text: 'Not Applicable', value: 'Not applicable' }];
exports.default = RELATIONSHIP_TYPE;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var RESERVATION_LIMIT = [{ text: 'Unlimited', value: '0' }, { text: '1', value: '1' }, { text: '2', value: '2' }, { text: '3', value: '3' }, { text: '4', value: '4' }, { text: '5', value: '5' }, { text: '6', value: '6' }, { text: '7', value: '7' }, { text: '8', value: '8' }, { text: '9', value: '9' }, { text: '10', value: '10' }, { text: '15', value: '15' }, { text: '20', value: '20' }, { text: '25', value: '25' }, { text: '30', value: '30' }, { text: '35', value: '35' }, { text: '40', value: '40' }, { text: '45', value: '45' }, { text: '50', value: '50' }, { text: '60', value: '60' }, { text: '70', value: '70' }, { text: '80', value: '80' }, { text: '90', value: '90' }, { text: '100', value: '100' }];

exports.default = RESERVATION_LIMIT;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.roleOptions = exports.SR_ROLE_AGENT = exports.SR_ROLE_AGENCY_ADMIN = exports.SR_ROLE_AGENT_LEADER = exports.SR_ROLE_SALES_ADMIN = exports.SR_ROLE_SALES_MANAGER = exports.SR_ROLE_SUPERVISOR = exports.SR_ROLE_HEADQUARTERS = undefined;

var _groups = __webpack_require__(194);

var SR_ROLE_HEADQUARTERS = exports.SR_ROLE_HEADQUARTERS = [_groups.GROUP_ID_DEVELOPER_EXECUTIVE, _groups.GROUP_ID_DEVELOPER_HEADQUARTERS];
var SR_ROLE_SUPERVISOR = exports.SR_ROLE_SUPERVISOR = [_groups.GROUP_ID_DEVELOPER_EXECUTIVE, _groups.GROUP_ID_DEVELOPER_BRANCH_LEADER, _groups.GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR, _groups.GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II];
var SR_ROLE_SALES_MANAGER = exports.SR_ROLE_SALES_MANAGER = [_groups.GROUP_ID_DEVELOPER_EXECUTIVE, _groups.GROUP_ID_DEVELOPER_BRANCH_LEADER, _groups.GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II];
var SR_ROLE_SALES_ADMIN = exports.SR_ROLE_SALES_ADMIN = [_groups.GROUP_ID_DEVELOPER_EXECUTIVE, _groups.GROUP_ID_DEVELOPER_BRANCH_LEADER];
var SR_ROLE_AGENT_LEADER = exports.SR_ROLE_AGENT_LEADER = [_groups.GROUP_ID_DEVELOPER_EXECUTIVE, _groups.GROUP_ID_DEVELOPER_AGENT_LEADER];
var SR_ROLE_AGENCY_ADMIN = exports.SR_ROLE_AGENCY_ADMIN = [_groups.GROUP_ID_DEVELOPER_EXECUTIVE, _groups.GROUP_ID_DEVELOPER_AGENCY_ADMIN];
var SR_ROLE_AGENT = exports.SR_ROLE_AGENT = '910'; // 10 + 900 (FAKE ROLE. Real: 10 + user.affiliate.companyBranch.isExternal)


var roleOptions = exports.roleOptions = function roleOptions() {
  var isExternal = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var isBranchLeader = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return [{ text: 'Headquarters', value: SR_ROLE_HEADQUARTERS.join(','), description: 'Admin', disabled: isExternal || isBranchLeader }, { text: 'Supervisor', value: SR_ROLE_SUPERVISOR.join(','), description: 'BU Leader', disabled: isExternal }, { text: 'Sales Manager', value: SR_ROLE_SALES_MANAGER.join(','), description: 'BU Leader', disabled: isExternal }, { text: 'Sales Admin', value: SR_ROLE_SALES_ADMIN.join(','), description: 'BU Leader', disabled: isExternal }, { text: 'Agent Leader', value: SR_ROLE_AGENT_LEADER.join(','), disabled: !isExternal }, { text: 'Agency Admin', value: SR_ROLE_AGENCY_ADMIN.join(','), description: 'Claim C.', disabled: !isExternal }, { text: isExternal ? 'Agent' : 'Staff', value: _groups.GROUP_ID_DEVELOPER_EXECUTIVE }, { text: 'Basic Siteplan', value: _groups.GROUP_ID_DEVELOPER_SITEPLAN }];
};

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  eslint no-param-reassign: ["error", { "props": false }]*/

var AffiliateMappingForm = function (_Component) {
  _inherits(AffiliateMappingForm, _Component);

  function AffiliateMappingForm(props) {
    _classCallCheck(this, AffiliateMappingForm);

    var _this = _possibleConstructorReturn(this, (AffiliateMappingForm.__proto__ || Object.getPrototypeOf(AffiliateMappingForm)).call(this, props));

    _initialiseProps.call(_this);

    var preset = Object.assign({}, AffiliateMappingForm.defaultValues, props.preset || {});
    _this.state = {
      preset: preset,
      oriPreset: (0, _clone2.default)(preset),
      errMessages: []
    };
    _this.validation = {
      name: (0, _react.createRef)(),
      shortName: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(AffiliateMappingForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var preset = Object.assign({}, AffiliateMappingForm.defaultValues, this.state.preset);
      var oriPreset = this.state.oriPreset;
      if (JSON.stringify(this.props.preset) !== JSON.stringify(nextProps.preset)) {
        preset = Object.assign(preset, nextProps.preset);
        oriPreset = (0, _clone2.default)(preset);
      }
      this.setState({ preset: preset, oriPreset: oriPreset });
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;
      var preset = this.state.preset;

      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref) {
            _this2.form = _ref;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Name', { ns: _translation.TRANSLATION_FILES.translation }),
                  name: 'name',
                  value: preset.name,
                  onChange: this.handleInputChange,
                  ref: this.validation.name,
                  validation: [_webValidations.required]
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Short Name', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'shortName',
                  value: preset.shortName,
                  onChange: this.handleInputChange,
                  ref: this.validation.shortName,
                  validation: [_webValidations.required]
                })
              ),
              _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                label: t('Description', { ns: _translation.TRANSLATION_FILES.screens }),
                name: 'description',
                value: preset.description,
                onChange: this.handleInputChange
              })
            )
          )
        )
      );
    }
  }]);

  return AffiliateMappingForm;
}(_react.Component);

AffiliateMappingForm.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  preset: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
AffiliateMappingForm.contextTypes = {
  store: _propTypes2.default.object
};
AffiliateMappingForm.defaultValues = {
  name: '',
  shortName: '',
  description: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleSubmit = function (event) {
    event.preventDefault();
    var preset = _this3.state.preset;

    _AppForm2.default.validate(_this3.validation, preset).then(function (validations) {
      _this3.props.onSubmit(validations, preset);
    });
  };

  this.handleInputChange = function (event, data) {
    var preset = _this3.state.preset;

    preset[data.name] = data.value;
    _this3.setState({ preset: preset }, function () {
      _this3.handleCheckChanges();
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(AffiliateMappingForm);

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _Form = __webpack_require__(267);

var _Form2 = _interopRequireDefault(_Form);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _UploadModal = __webpack_require__(92);

var _UploadModal2 = _interopRequireDefault(_UploadModal);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _types = __webpack_require__(145);

var _paymentTypes = __webpack_require__(322);

var _paymentTypes2 = _interopRequireDefault(_paymentTypes);

var _bookingFeePaymentStatuses = __webpack_require__(1039);

var _bookingFeePaymentStatuses2 = _interopRequireDefault(_bookingFeePaymentStatuses);

var _translation = __webpack_require__(4);

var _srRoleAccess = __webpack_require__(196);

var _centsFloat = __webpack_require__(175);

var _translation2 = __webpack_require__(64);

var _vietnam = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Item = function (_Component) {
  _inherits(Item, _Component);

  function Item(props) {
    _classCallCheck(this, Item);

    var _this = _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).call(this, props));

    _initialiseProps.call(_this);

    var state = Item.getPropsToState(props);

    _this.state = _extends({
      genericErrMsg: props.t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }),
      loading: false
    }, state);
    return _this;
  }

  _createClass(Item, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Item.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
    // CPI-974 (D): Vietnam is approval-only, so the receipt exists once the payment is 'paid'.

  }, {
    key: 'handleError',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(store, msg, errorObj) {
        var isBugsnag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(false);

              case 2:
                _context.next = 4;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: msg }));

              case 4:
                if (isBugsnag) Bugsnag.notifyException(errorObj);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleError(_x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return handleError;
    }()
  }, {
    key: 'isHideHeader',
    value: function isHideHeader() {
      var data = this.state.data;

      return this.props.hideHeader || data.status === 'cancelled';
    }
  }, {
    key: 'uploadPictures',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e, body) {
        var t, _state, data, genericErrMsg, _context2, store, router, picResponse;

        return regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                t = this.props.t;

                e.preventDefault();
                _state = this.state, data = _state.data, genericErrMsg = _state.genericErrMsg;
                _context2 = this.context, store = _context2.store, router = _context2.router;
                _context3.prev = 4;
                _context3.next = 7;
                return this.setLoading(true);

              case 7:
                _context3.next = 9;
                return (0, _fetchM.serverRequestPost)('/bookings/' + router.params.id + '/pictures/?FPID=' + data.id, store, this.props.token, body, {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'X-Csrf-Token': this.props.token
                  },
                  body: body
                });

              case 9:
                picResponse = _context3.sent;
                _context3.next = 12;
                return this.setLoading(false);

              case 12:
                if (!picResponse.error) {
                  _context3.next = 15;
                  break;
                }

                this.handleError(store, picResponse.message);
                return _context3.abrupt('return');

              case 15:
                this.setState({ uploadModalState: false });
                this.uploadModal.close();
                if (this.props.onUpdated) this.props.onUpdated();
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Upload Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Picture(s) successfully uploaded', { ns: _translation.TRANSLATION_FILES.translation })
                }));
                _context3.next = 24;
                break;

              case 21:
                _context3.prev = 21;
                _context3.t0 = _context3['catch'](4);

                this.handleError(store, genericErrMsg, _context3.t0, true);

              case 24:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee2, this, [[4, 21]]);
      }));

      function uploadPictures(_x6, _x7) {
        return _ref2.apply(this, arguments);
      }

      return uploadPictures;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state2 = this.state,
          data = _state2.data,
          projectCurrencies = _state2.projectCurrencies,
          popUpState = _state2.popUpState,
          uploadModalState = _state2.uploadModalState;
      var _props = this.props,
          auth = _props.auth,
          t = _props.t;

      var rejectedOnlinePayment = data && data.onlinePayment && data.onlinePayment.requestStatus === 'payment_failed';
      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          {
            mobile: 15, tablet: 15, computer: 15,
            className: 'payment-card payment-card-' + this.getPaymentStatus(data),
            style: { backgroundColor: this.props.backgroundColor }
          },
          this.isHideHeader() ? null : _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: data && data.paymentMethodTypeID && data.paymentMethodTypeID !== 'online_payment' ? 8 : 16 },
              _react2.default.createElement(
                _semanticUiReact.Label,
                {
                  className: rejectedOnlinePayment ? 'online-rejected-label' : '',
                  style: { textTransform: 'capitalize' },
                  circular: true,
                  color: !rejectedOnlinePayment ? this.setPaymentStatusColor(this.getStatusBasedOnPaymentMethod(data)) : '',
                  horizontal: true
                },
                (0, _vietnam.vnDepositStatusLabel)(auth, t, this.getStatusBasedOnPaymentMethod(data)) || (0, _translation2.getConstantsLabel)(t, _bookingFeePaymentStatuses2.default, this.getStatusBasedOnPaymentMethod(data))
              )
            ),
            data && data.paymentMethodTypeID && data.paymentMethodTypeID !== 'online_payment' ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 8 },
              _react2.default.createElement(_UploadModal2.default, {
                modalState: uploadModalState,
                trigger: _react2.default.createElement('span', null),
                ref: function ref(_ref4) {
                  _this3.uploadModal = _ref4;
                },
                header: 'pictures',
                loading: this.state.loading,
                onConfirm: function onConfirm(e, file) {
                  _this3.uploadPictures(e, file);
                },
                onClose: this.handleUploadModalClose,
                primary: false,
                content: function content(opt) {
                  return _react2.default.createElement(_Form2.default, {
                    ref: function ref(_ref3) {
                      _this3.form = _ref3;
                    },
                    fileType: 'attachment',
                    loading: _this3.state.loading,
                    onSubmit: opt.onConfirm
                  });
                }
              }),
              _react2.default.createElement(
                _semanticUiReact.Popup,
                {
                  on: 'click',
                  open: popUpState,
                  onOpen: this.togglePopupState,
                  onClose: this.togglePopupState,
                  trigger: _react2.default.createElement(_semanticUiReact.Icon, {
                    color: 'blue',
                    link: true,
                    name: 'ellipsis vertical',
                    size: 'large'
                  })
                },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { centered: true, celled: 'internally', className: 'payment-card-options' },
                  this.canShowReceiptLink(data.status) ? _react2.default.createElement(
                    _reactRouter.Link,
                    {
                      as: 'a',
                      className: 'row',
                      to: _config2.default.get('bookApiURL') + '/bookings/' + this.props.data.bookingID + '/booking_fee_payments/' + this.props.data.id + '/receipt/',
                      target: '_blank'
                    },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { style: { marginTop: '0', marginBottom: '0' } },
                      _react2.default.createElement(
                        _semanticUiReact.Header,
                        { color: 'blue', as: 'h4' },
                        (0, _vietnam.depositLabel)(auth, t, 'Payment Receipt')
                      )
                    )
                  ) : null,
                  _react2.default.createElement(
                    'a',
                    { className: 'row' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      {
                        style: { marginTop: '0', marginBottom: '0' },
                        onClick: this.triggerAddAttachment
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Header,
                        { color: 'blue', as: 'h4' },
                        t('Add Attachment')
                      )
                    )
                  ),
                  this.props.hideCancel ? '' : _react2.default.createElement(
                    'a',
                    { className: 'row' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      {
                        style: { marginTop: '0', marginBottom: '0' },
                        onClick: this.triggerCancelTransaction
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Header,
                        { color: 'red', as: 'h4' },
                        t('Cancel Transaction')
                      )
                    )
                  )
                )
              )
            ) : null
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle', style: { marginTop: '-1rem' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 8 },
              t('Amount'),
              ':'
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 8 },
              _react2.default.createElement(
                'b',
                null,
                _react2.default.createElement(_LoanAmount2.default, {
                  projectCurrencies: projectCurrencies,
                  format: '0,000,000.00',
                  amount: (0, _centsFloat.centsToFloat)(data.amountCents),
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle', style: { marginTop: '-1rem' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 8 },
              t('Method'),
              ':'
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 8 },
              _react2.default.createElement(
                'b',
                null,
                data && data.paymentMethodTypeID && data.paymentMethodTypeID === 'online_payment' ? (0, _translation2.getConstantsLabel)(t, _paymentTypes2.default, data.paymentMethodTypeID).toUpperCase() : (0, _translation2.getConstantsLabel)(t, _paymentTypes2.default, data.paymentMethodTypeID)
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle', style: { marginTop: '-1rem' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 8 },
              t(data && data.paymentMethodTypeID && data.paymentMethodTypeID === 'online_payment' ? 'Request Time' : 'Time'),
              ':'
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 8 },
              data && data.paymentMethodTypeID && data.paymentMethodTypeID === 'online_payment' && data.onlinePayment && data.onlinePayment.requestedAt ? _react2.default.createElement(
                'b',
                null,
                _react2.default.createElement(_Timestamp2.default, { format: 'DD/MM/YY hh:mm a', timestamp: data.onlinePayment.requestedAt })
              ) : _react2.default.createElement(
                'b',
                null,
                _react2.default.createElement(_Timestamp2.default, { format: 'DD/MM/YY hh:mm a', timestamp: data.createdAt })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle', style: { marginTop: '-1rem' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 8 },
              t(data && data.paymentMethodTypeID && data.paymentMethodTypeID === 'online_payment' ? 'Reference No.' : 'Reference'),
              ':'
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 8 },
              _react2.default.createElement(
                'b',
                null,
                data.reference
              )
            )
          ),
          data.paymentMethodTypeID === 'bank_transfer' || data.paymentMethodTypeID === 'cheque' ? _react2.default.createElement(
            'span',
            null,
            data.transferredToBankID ? _react2.default.createElement(
              _semanticUiReact.Grid,
              { verticalAlign: 'middle', style: { marginTop: '-1rem' } },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', width: 8 },
                t('Transferred to'),
                ':'
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', width: 8 },
                _react2.default.createElement(
                  'b',
                  null,
                  this.transformProjectBankAccountData(data.transferredToBankID)
                )
              )
            ) : null
          ) : null,
          data.paymentMethodTypeID === 'virtual_account' ? _react2.default.createElement(
            'span',
            null,
            data.transferredToVABank && data.transferredToVAAccountNumber ? _react2.default.createElement(
              _semanticUiReact.Grid,
              { verticalAlign: 'middle', style: { marginTop: '-1rem' } },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', width: 8 },
                t('Transferred to'),
                ':'
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', width: 8 },
                _react2.default.createElement(
                  'b',
                  null,
                  data.transferredToVABank + ' (' + data.transferredToVAAccountNumber + ')'
                )
              )
            ) : null
          ) : null,
          data.paymentMethodTypeID === 'bank_transfer' || data.paymentMethodTypeID === 'virtual_account' ? _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle', style: { marginTop: '-1rem' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 8 },
              t('Transferred from'),
              ':'
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 8 },
              _react2.default.createElement(
                'b',
                null,
                data.transferredFromBank + ' (' + data.transferredFromAccountNumber + ')'
              )
            )
          ) : null,
          data.paymentMethodTypeID === 'credit_card' ? _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle', style: { marginTop: '-1rem' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 8 },
              t('Card Number'),
              ':'
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 8 },
              _react2.default.createElement(
                _semanticUiReact.Header,
                { as: 'h5' },
                'XXXX XXXX XXXX ',
                data.creditCardLastFourDigits
              )
            )
          ) : null,
          data && data.paymentMethodTypeID && data.paymentMethodTypeID !== 'online_payment' ? _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle', style: { marginTop: '-1rem' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 8 },
              t('Attachment'),
              ':'
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 8 },
              _react2.default.createElement(
                'span',
                null,
                this.getPicturesLength(data) > 0 ? _react2.default.createElement(
                  'button',
                  {
                    className: 'a-button-blue',
                    onClick: function onClick(e) {
                      return _this3.handleViewPictures(e, data);
                    },
                    title: t('View', { ns: _translation.TRANSLATION_FILES.translation })
                  },
                  this.getPicturesLength(data) + ' ' + t('Attachment').toLowerCase()
                ) : _react2.default.createElement(
                  'span',
                  { className: 'color-gray' },
                  t('No Attachment')
                )
              )
            )
          ) : _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle', style: { marginTop: '-1rem' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 8 },
              t('Transaction Time'),
              ':'
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 8 },
              _react2.default.createElement(
                'span',
                null,
                data.onlinePayment && data.onlinePayment.payMSPayment && data.onlinePayment.payMSPayment.updated_at && data.onlinePayment.requestStatus && (data.onlinePayment.requestStatus === 'payment_completed' || data.onlinePayment.requestStatus === 'payment_failed') ? _react2.default.createElement(
                  'b',
                  null,
                  _react2.default.createElement(_Timestamp2.default, { format: 'DD/MM/YY hh:mm a', timestamp: data.onlinePayment.payMSPayment.updated_at })
                ) : ''
              )
            )
          ),
          data && data.paymentMethodTypeID && data.paymentMethodTypeID === 'online_payment' ? _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'tablet computer', tablet: 5, computer: 9 }),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', mobile: 16, tablet: 11, computer: 7 },
              _react2.default.createElement(_semanticUiReact.Button, {
                fluid: true,
                color: 'grey',
                disabled: true,
                content: t('Send Request Payment')
              })
            )
          ) : null,
          data.status === 'cancelled' ? _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_semanticUiReact.Divider, null),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { verticalAlign: 'middle', style: { marginTop: '-1rem' } },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', width: 8 },
                t('Status'),
                ':'
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', width: 8 },
                t('Cancellation')
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { verticalAlign: 'middle', style: { marginTop: '-1rem' } },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', width: 8 },
                t('Reason'),
                ':'
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', width: 8 },
                data.cancelledReason
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { verticalAlign: 'middle', style: { marginTop: '-1rem' } },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', width: 8 },
                t('Deduction'),
                ':'
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', width: 8 },
                '- ',
                _react2.default.createElement(_LoanAmount2.default, {
                  projectCurrencies: projectCurrencies,
                  format: '0,000,000.00',
                  amount: (0, _centsFloat.centsToFloat)(data.amountCents),
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { verticalAlign: 'middle', style: { marginTop: '-1rem' } },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', width: 8 },
                t('Time'),
                ':'
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', width: 8 },
                _react2.default.createElement(_Timestamp2.default, { format: 'DD/MM/YY hh:mm a', timestamp: data.updatedAt })
              )
            )
          ) : null,
          this.props.footer
        )
      );
    }
  }]);

  return Item;
}(_react.Component);

Item.propTypes = {
  auth: _types.StateAuth,
  backgroundColor: _propTypes2.default.string,
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  bookingData: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  defaultObj: _propTypes2.default.shape({}),
  footer: _propTypes2.default.node,
  hideCancel: _propTypes2.default.bool,
  onCancelTransaction: _propTypes2.default.func,
  onUpdated: _propTypes2.default.func,
  openAttachment: _propTypes2.default.func,
  projectBankAccount: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  projectCurrencies: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  hideHeader: _propTypes2.default.bool,
  token: _propTypes2.default.string,
  t: _propTypes2.default.func
};
Item.contextTypes = {
  router: _propTypes2.default.object,
  store: _propTypes2.default.object
};

Item.getPropsToState = function (props) {
  var defaultObj = props.defaultObj;
  var data = Object.assign({}, defaultObj, props.data);
  var projectCurrencies = props.projectCurrencies;
  return {
    data: data,
    defaultObj: defaultObj,
    popUpState: false,
    projectCurrencies: projectCurrencies,
    uploadModalState: false
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.getPaymentStatus = function (data) {
    if (data) {
      if (data.onlinePayment && data.onlinePayment.requestStatus !== '') {
        switch (data.onlinePayment.requestStatus) {
          case 'payment_failed':
            return 'online-failed';
          case 'payment_expired':
          case 'rejected':
            return 'online-expired-rejected';
          default:
            return '';
        }
      }
      return data.status;
    }
    return '';
  };

  this.getPicturesLength = function (data) {
    if (data && data.paymentPictures && data.paymentPictures.length > 0) {
      return data.paymentPictures.length;
    }
    return 0;
  };

  this.getStatusBasedOnPaymentMethod = function (payment) {
    return payment.paymentMethodTypeID === 'online_payment' && payment.onlinePayment && payment.onlinePayment.requestStatus ? payment.onlinePayment.requestStatus : payment.status;
  };

  this.setPaymentStatusColor = function (paymentStatus) {
    switch (paymentStatus) {
      case 'paid':
      case 'payment_completed':
        return 'green';
      case 'payment_expired':
      case 'rejected':
        return 'grey';
      default:
        return 'blue';
    }
  };

  this.hasReceiptForStatus = function (status) {
    if ((0, _vietnam.isVietnamCompany)(_this4.props.auth)) return status === 'paid';
    return status === 'paid' || status === 'pending_verification';
  };

  this.canShowReceiptLink = function (status) {
    return _this4.hasPaymentReceiptAccess() && _this4.hasReceiptForStatus(status);
  };

  this.hasPaymentReceiptAccess = function () {
    var _props2 = _this4.props,
        auth = _props2.auth,
        bookingData = _props2.bookingData;

    if (auth.isAdminBasic || auth.isAdmin) return true;
    if (bookingData && bookingData.project && bookingData.project.paymentReceiptAccessGroupIDs) {
      var uGroupIDs = [].concat(_toConsumableArray(auth.groups.map(function (obj) {
        return obj.id;
      })));
      var uSrRoleIDs = (0, _srRoleAccess.matchGroupIDToSrRoleID)(uGroupIDs, auth.companyBranch.isExternal);
      return (0, _srRoleAccess.hasAnyRequiredRoleIDs)(bookingData.project.paymentReceiptAccessGroupIDs, uSrRoleIDs);
    }
    return false;
  };

  this.handleUploadModalClose = function () {
    _this4.setState({ uploadModalState: false });
  };

  this.handleViewPictures = function (e, payment) {
    e.preventDefault();
    if (_this4.props.openAttachment) _this4.props.openAttachment(payment);
  };

  this.togglePopupState = function () {
    var popUpState = _this4.state.popUpState;

    _this4.setState({ popUpState: !popUpState });
  };

  this.transformProjectBankAccountData = function (projectBankAccountID) {
    var bankText = '';
    var projectBankAccount = _this4.props.projectBankAccount;

    if (!projectBankAccount) return bankText;
    var activeBankAccount = projectBankAccount.filter(function (e) {
      return e.id === projectBankAccountID;
    });
    if (activeBankAccount.length > 0) bankText = activeBankAccount[0].bank + ' (' + activeBankAccount[0].accountNumber + ')';
    return bankText;
  };

  this.triggerAddAttachment = function () {
    _this4.setState({ popUpState: false, uploadModalState: true });
  };

  this.triggerCancelTransaction = function () {
    var data = _this4.state.data;

    _this4.setState({ popUpState: false });
    if (_this4.props.onCancelTransaction) _this4.props.onCancelTransaction(data.id);
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(Item);

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _BookingPayment = __webpack_require__(2250);

var _BookingPayment2 = _interopRequireDefault(_BookingPayment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _BookingPayment2.default;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.routes = undefined;

var _countries = __webpack_require__(60);

var routes = exports.routes = function routes(countryCode) {
  var links = [{ text: (0, _countries.isCountryVietnam)(countryCode) ? 'Sales' : 'Bookings', value: '/bookings/' }];

  if (!(0, _countries.isCountryVietnam)(countryCode)) {
    links.push({ text: 'Unit Progress', value: '/bookings/unit_progress/' });
  }
  return links;
};

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var routes = exports.routes = function routes(id) {
  var links = [{ text: 'Overview', value: '/business_units/' + id + '/' }, { text: 'Activities', value: '/business_units/' + id + '/activities/' }];
  return links;
};

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  eslint no-param-reassign: ["error", { "props": false }]*/

var CancellationReasonForm = function (_Component) {
  _inherits(CancellationReasonForm, _Component);

  function CancellationReasonForm(props) {
    _classCallCheck(this, CancellationReasonForm);

    var _this = _possibleConstructorReturn(this, (CancellationReasonForm.__proto__ || Object.getPrototypeOf(CancellationReasonForm)).call(this, props));

    _initialiseProps.call(_this);

    var preset = Object.assign({}, CancellationReasonForm.defaultValues, props.preset || {});
    _this.state = {
      preset: preset,
      oriPreset: (0, _clone2.default)(preset),
      errMessages: []
    };
    _this.validation = {
      name: (0, _react.createRef)(),
      shortName: (0, _react.createRef)(),
      description: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(CancellationReasonForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var preset = Object.assign({}, CancellationReasonForm.defaultValues, this.state.preset);
      var oriPreset = this.state.oriPreset;
      if (JSON.stringify(this.props.preset) !== JSON.stringify(nextProps.preset)) {
        preset = Object.assign(preset, nextProps.preset);
        oriPreset = (0, _clone2.default)(preset);
      }
      this.setState({ preset: preset, oriPreset: oriPreset });
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var preset = this.state.preset;
      var t = this.props.t;

      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref) {
            _this2.form = _ref;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Name', { ns: _translation.TRANSLATION_FILES.translation }),
                  name: 'name',
                  value: preset.name,
                  onChange: this.handleInputChange,
                  ref: this.validation.name,
                  validation: [_webValidations.required]
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Short Name', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'shortName',
                  value: preset.shortName,
                  onChange: this.handleInputChange,
                  ref: this.validation.shortName,
                  validation: [_webValidations.required]
                })
              ),
              _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                label: t('Description', { ns: _translation.TRANSLATION_FILES.screens }),
                name: 'description',
                value: preset.description,
                onChange: this.handleInputChange,
                ref: this.validation.description
              })
            )
          )
        )
      );
    }
  }]);

  return CancellationReasonForm;
}(_react.Component);

CancellationReasonForm.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  preset: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
CancellationReasonForm.contextTypes = {
  store: _propTypes2.default.object
};
CancellationReasonForm.defaultValues = {
  name: '',
  shortName: '',
  description: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleSubmit = function (event) {
    event.preventDefault();
    var preset = _this3.state.preset;

    _AppForm2.default.validate(_this3.validation, preset).then(function (validations) {
      _this3.props.onSubmit(validations, preset);
    });
  };

  this.handleInputChange = function (event, data) {
    var preset = _this3.state.preset;

    preset[data.name] = data.value;
    _this3.setState({ preset: preset }, function () {
      _this3.handleCheckChanges();
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(CancellationReasonForm);

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _queryString = __webpack_require__(684);

var _queryString2 = _interopRequireDefault(_queryString);

var _fetchM = __webpack_require__(6);

var _reactRouterRedux = __webpack_require__(13);

var _LoanInfo = __webpack_require__(2303);

var _LoanInfo2 = _interopRequireDefault(_LoanInfo);

var _NewIncomeForm = __webpack_require__(2308);

var _NewIncomeForm2 = _interopRequireDefault(_NewIncomeForm);

var _PersonalInfo = __webpack_require__(2310);

var _PersonalInfo2 = _interopRequireDefault(_PersonalInfo);

var _UploadForm = __webpack_require__(394);

var _UploadForm2 = _interopRequireDefault(_UploadForm);

var _flash = __webpack_require__(5);

var _routes = __webpack_require__(403);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/no-unused-prop-types: 0 */


var NewCreditCheck = function (_Component) {
  _inherits(NewCreditCheck, _Component);

  function NewCreditCheck(props) {
    _classCallCheck(this, NewCreditCheck);

    var _this = _possibleConstructorReturn(this, (NewCreditCheck.__proto__ || Object.getPrototypeOf(NewCreditCheck)).call(this, props));

    _initialiseProps.call(_this);

    var state = NewCreditCheck.getPropsToState(props);
    var customerCreditReports = state.customerCreditReports;
    var currentStep = 0;
    if (props.location && props.location.hash.length > 0) {
      var currentTab = props.location.hash.replace('#', '');
      switch (currentTab) {
        case 'new':
          currentStep = 0;
          break;
        case 'document':
          currentStep = 1;
          break;
        case 'identity':
          currentStep = 2;
          break;
        case 'income':
          currentStep = 3;
          break;
        default:
          currentStep = 0;
      }
    }
    _this.state = _extends({}, state, {
      currentStep: currentStep,
      customerCreditReports: customerCreditReports,
      bookingData: [],
      consentForm: null,
      creditCheckReportData: [],
      customerCreditReport: state.customerCreditReport || null,
      custToken: null,
      documentToken: null,
      headerContent: '',
      icFront: null,
      icBack: null,
      incomeToken: null,
      progressPercent: 0,
      reportToken: null,
      isSigned: false
    });
    return _this;
  }

  _createClass(NewCreditCheck, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.pathCheck) {
        this.fetchBooking();
      }
      if (location.search !== '') {
        var values = _queryString2.default.parse(this.props.location.search);
        if (values.currentStep !== '') {
          this.fetchBookingCustomer();
          this.setState({ currentStep: _lodash2.default.toNumber(values.currentStep) });
        }
      }
      this.fetchCustomerCreditReport();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = NewCreditCheck.getPropsToState(nextProps);
      if (this.checkStringify(state.oriData, this.state.oriData)) {
        state.data = this.state.data;
      }
      if (this.checkStringify(state.oriCustomerCreditReport, this.state.oriCustomerCreditReport)) {
        state.customerCreditReport = this.state.customerCreditReport;
      }
      if (this.checkStringify(state.oriIcFrontDocument, this.state.oriIcFrontDocument)) {
        state.icFrontDocument = this.state.icFrontDocument;
      }
      if (this.checkStringify(state.oriIcBackDocument, this.state.oriIcBackDocument)) {
        state.icBackDocument = this.state.icBackDocument;
      }
      if (this.checkStringify(state.oriIncome, this.state.oriIncome)) {
        state.income = this.state.income;
      }
      state.customerCreditReports = this.state.customerCreditReports;
      this.setState(_extends({}, state));
    }
  }, {
    key: 'getCreditCheckToken',
    value: function getCreditCheckToken(callback) {
      var _this2 = this;

      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.customerID + '/credit_reports/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      }).then(function (res) {
        var reportToken = res.headers.get('X-Csrf-Token');
        _this2.setState({
          reportToken: reportToken
        }, function () {
          if (callback) {
            callback();
          }
        });
      });
    }
  }, {
    key: 'getCustToken',
    value: function getCustToken(callback) {
      var _this3 = this;

      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.customerID + '/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      }).then(function (res) {
        var custToken = res.headers.get('X-Csrf-Token');
        _this3.setState({
          custToken: custToken
        }, function () {
          if (callback) {
            callback();
          }
        });
      });
    }
  }, {
    key: 'getDocumentToken',
    value: function getDocumentToken(callback) {
      var _this4 = this;

      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.customerID + '/documents/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      }).then(function (res) {
        var documentToken = res.headers.get('X-Csrf-Token');
        _this4.setState({
          documentToken: documentToken
        }, function () {
          if (callback) {
            callback();
          }
        });
      });
    }
  }, {
    key: 'getIncomeToken',
    value: function getIncomeToken(callback) {
      var _this5 = this;

      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.customerID + '/income/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      }).then(function (res) {
        var incomeToken = res.headers.get('X-Csrf-Token');
        _this5.setState({
          incomeToken: incomeToken
        }, function () {
          if (callback) {
            callback();
          }
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this6 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this6.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'creditCheckToken',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this7 = this;

        var store, res, message, _message, reportToken, json, newCreditCheckReport;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                res = void 0;
                _context.prev = 2;
                _context.next = 5;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.customerID + '/credit_reports/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                res = _context.sent;
                _context.next = 20;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](2);
                _context.next = 12;
                return this.setLoading(false);

              case 12:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 18;
                  break;
                }

                _context.next = 15;
                return _context.t0.res.text();

              case 15:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 18:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 20:
                if (res.ok) {
                  _context.next = 28;
                  break;
                }

                _context.next = 23;
                return res.text();

              case 23:
                _message = _context.sent;
                _context.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 26:
                _context.next = 36;
                break;

              case 28:
                reportToken = res.headers.get('X-Csrf-Token');
                _context.next = 31;
                return res.json();

              case 31:
                json = _context.sent;

                if (!json) {
                  _context.next = 36;
                  break;
                }

                newCreditCheckReport = Object.assign({}, json[0] || {});
                _context.next = 36;
                return this.setComponentState({ reportToken: reportToken, creditCheckReportData: newCreditCheckReport }, function () {
                  _this7.generateCreditCheck(newCreditCheckReport);
                });

              case 36:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));

      function creditCheckToken() {
        return _ref.apply(this, arguments);
      }

      return creditCheckToken;
    }()
  }, {
    key: 'fetchBooking',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, res, message, json, newBookingData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = '';
                _context2.prev = 4;
                _context2.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.props.bookingID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context2.sent;
                _context2.next = 21;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](4);

                if (!(_context2.t0.res && _context2.t0.res.status >= 399 && _context2.t0.res.status < 500)) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 15;
                return _context2.t0.res.text();

              case 15:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 17:
                _context2.next = 19;
                return this.setLoading(false);

              case 19:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));

              case 21:
                _context2.next = 23;
                return res.json();

              case 23:
                json = _context2.sent;

                if (json) {
                  newBookingData = Object.assign({}, json || {});

                  this.setState({ bookingData: newBookingData });
                }
                _context2.next = 27;
                return this.setLoading(false);

              case 27:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10]]);
      }));

      function fetchBooking() {
        return _ref2.apply(this, arguments);
      }

      return fetchBooking;
    }()
  }, {
    key: 'fetchBookingCustomer',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var store, res, json, newData;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = '';
                _context3.prev = 4;
                _context3.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.customerID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context3.sent;
                _context3.next = 18;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](4);

                Bugsnag.notifyException(_context3.t0);
                _context3.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context3.next = 17;
                return this.setLoading(false);

              case 17:
                return _context3.abrupt('return');

              case 18:
                _context3.next = 20;
                return res.json();

              case 20:
                json = _context3.sent;

                if (json) {
                  newData = Object.assign({}, json || {});

                  this.setState({ data: newData });
                }
                _context3.next = 24;
                return this.setLoading(false);

              case 24:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 10]]);
      }));

      function fetchBookingCustomer() {
        return _ref3.apply(this, arguments);
      }

      return fetchBookingCustomer;
    }()
  }, {
    key: 'fetchCustomerCreditReport',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var store, res, message, json, newCreditCheckReport;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                store = this.context.store;
                res = void 0;
                _context4.prev = 2;
                _context4.next = 5;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.customerID + '/credit_reports/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                res = _context4.sent;
                _context4.next = 20;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](2);
                _context4.next = 12;
                return this.setLoading(false);

              case 12:
                if (!(_context4.t0.res && _context4.t0.res.status >= 400 && _context4.t0.res.status < 500)) {
                  _context4.next = 18;
                  break;
                }

                _context4.next = 15;
                return _context4.t0.res.text();

              case 15:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context4.abrupt('return');

              case 18:
                store.dispatch((0, _flash.flashErrorMessage)(_context4.t0));
                return _context4.abrupt('return');

              case 20:
                _context4.next = 22;
                return res.json();

              case 22:
                json = _context4.sent;

                if (json) {
                  newCreditCheckReport = Object.assign({}, json[0] || {});

                  this.setState({ creditCheckReportData: newCreditCheckReport });
                }
                _context4.next = 26;
                return this.setLoading(false);

              case 26:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 8]]);
      }));

      function fetchCustomerCreditReport() {
        return _ref4.apply(this, arguments);
      }

      return fetchCustomerCreditReport;
    }()
  }, {
    key: 'fetchCustomer',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var store, res, message, _message2, data, customerCreditReport;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                store = this.context.store;
                res = void 0;
                _context5.prev = 2;
                _context5.next = 5;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.customerID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                res = _context5.sent;
                _context5.next = 19;
                break;

              case 8:
                _context5.prev = 8;
                _context5.t0 = _context5['catch'](2);

                if (!(_context5.t0.res && _context5.t0.res.status >= 399 && _context5.t0.res.status < 500)) {
                  _context5.next = 15;
                  break;
                }

                _context5.next = 13;
                return _context5.t0.res.text();

              case 13:
                message = _context5.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 15:
                Bugsnag.notifyException(_context5.t0);
                _context5.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 18:
                return _context5.abrupt('return');

              case 19:
                if (res.ok) {
                  _context5.next = 27;
                  break;
                }

                _context5.next = 22;
                return res.text();

              case 22:
                _message2 = _context5.sent;
                _context5.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message2 }));

              case 25:
                _context5.next = 34;
                break;

              case 27:
                _context5.next = 29;
                return res.json();

              case 29:
                data = _context5.sent;

                if (!(data.customerCreditReport && data.customerCreditReport !== null)) {
                  _context5.next = 34;
                  break;
                }

                customerCreditReport = data.customerCreditReport;
                _context5.next = 34;
                return this.setComponentState({
                  customerCreditReport: customerCreditReport
                });

              case 34:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[2, 8]]);
      }));

      function fetchCustomer() {
        return _ref5.apply(this, arguments);
      }

      return fetchCustomer;
    }()
  }, {
    key: 'generateCreditCheck',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(creditCheckReportData) {
        var store, jwtToken, message;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                store = this.context.store;
                _context6.next = 3;
                return this.setLoading(true);

              case 3:
                _context6.prev = 3;
                _context6.next = 6;
                return _auth2.default.currentSession();

              case 6:
                jwtToken = _context6.sent.getAccessToken().getJwtToken();
                _context6.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.customerID + '/credit_reports/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.reportToken,
                    'X-JWT-Token': jwtToken
                  },
                  body: JSON.stringify(creditCheckReportData)
                }));

              case 9:
                _context6.next = 23;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6['catch'](3);
                _context6.next = 15;
                return this.setLoading(false);

              case 15:
                if (!(_context6.t0.res && _context6.t0.res.status >= 400 && _context6.t0.res.status < 500)) {
                  _context6.next = 21;
                  break;
                }

                _context6.next = 18;
                return _context6.t0.res.text();

              case 18:
                message = _context6.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context6.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context6.t0));
                return _context6.abrupt('return');

              case 23:
                _context6.next = 25;
                return this.setLoading(false);

              case 25:
                if (!this.props.pathCheck) {
                  store.dispatch((0, _reactRouterRedux.push)('/customers/' + this.props.customerID + '/'));
                } else {
                  store.dispatch((0, _reactRouterRedux.push)('/bookings/' + this.props.bookingID + '/'));
                }
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Credit score generating', message: this.state.customerDetail.name + '\'s credit report sent' }));

              case 27:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[3, 11]]);
      }));

      function generateCreditCheck(_x2) {
        return _ref6.apply(this, arguments);
      }

      return generateCreditCheck;
    }()
  }, {
    key: 'submitIncome',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(validations, income) {
        var store, errors, customerID, res, message;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context7.next = 5;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context7.abrupt('return');

              case 5:
                _context7.next = 7;
                return this.setLoading(true);

              case 7:
                customerID = this.props.customerID;
                res = void 0;
                _context7.prev = 9;
                _context7.next = 12;
                return this.form.submit('/customers/' + customerID + '/income/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.incomeToken
                  },
                  body: JSON.stringify(income)
                });

              case 12:
                res = _context7.sent;
                _context7.next = 27;
                break;

              case 15:
                _context7.prev = 15;
                _context7.t0 = _context7['catch'](9);
                _context7.next = 19;
                return this.setLoading(false);

              case 19:
                if (!(_context7.t0.res && _context7.t0.res.status >= 400 && _context7.t0.res.status < 500)) {
                  _context7.next = 25;
                  break;
                }

                _context7.next = 22;
                return _context7.t0.res.text();

              case 22:
                message = _context7.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context7.abrupt('return');

              case 25:
                store.dispatch((0, _flash.flashErrorMessage)(_context7.t0));
                return _context7.abrupt('return');

              case 27:
                _context7.next = 29;
                return this.setState({ income: res }, function () {});

              case 29:
                _context7.next = 31;
                return this.setLoading(false);

              case 31:
                _context7.next = 33;
                return this.handleHasChange();

              case 33:
                _context7.next = 35;
                return this.handleNextStep();

              case 35:
                _context7.next = 37;
                return this.handleRefetch();

              case 37:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[9, 15]]);
      }));

      function submitIncome(_x3, _x4) {
        return _ref7.apply(this, arguments);
      }

      return submitIncome;
    }()
  }, {
    key: 'submitLoanInfo',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(creditCheckReportData) {
        var store, creditReport, res, jwtToken, message;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                store = this.context.store;
                _context8.next = 3;
                return this.setLoading(true);

              case 3:
                creditReport = creditCheckReportData;

                if (this.state.bookingData && this.state.bookingData.project && this.state.bookingData.project.id !== '') {
                  creditReport.bookingID = this.state.bookingData.id;
                  creditReport.projectID = this.state.bookingData.project.id;
                  creditReport.projectName = this.state.bookingData.project.name;
                }

                res = '';
                _context8.prev = 6;
                _context8.next = 9;
                return _auth2.default.currentSession();

              case 9:
                jwtToken = _context8.sent.getAccessToken().getJwtToken();
                _context8.next = 12;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.customerID + '/credit_reports/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.reportToken,
                    'X-JWT-Token': jwtToken
                  },
                  body: JSON.stringify(creditCheckReportData)
                }));

              case 12:
                res = _context8.sent;
                _context8.next = 27;
                break;

              case 15:
                _context8.prev = 15;
                _context8.t0 = _context8['catch'](6);
                _context8.next = 19;
                return this.setLoading(false);

              case 19:
                if (!(_context8.t0.res && _context8.t0.res.status >= 400 && _context8.t0.res.status < 500)) {
                  _context8.next = 25;
                  break;
                }

                _context8.next = 22;
                return _context8.t0.res.text();

              case 22:
                message = _context8.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context8.abrupt('return');

              case 25:
                store.dispatch((0, _flash.flashErrorMessage)(_context8.t0));
                return _context8.abrupt('return');

              case 27:
                _context8.next = 29;
                return this.setLoading(false);

              case 29:
                if (res.ok) {
                  this.props.onChange(false); // reset changes to allow user to leave current page
                  if (!this.props.pathCheck) {
                    store.dispatch((0, _reactRouterRedux.push)('/customers/' + this.props.customerID + '/'));
                  } else if (this.props.pathCheck && !this.props.location.pathname.includes('customers/')) {
                    store.dispatch((0, _reactRouterRedux.push)((0, _routes.bookingFlow)(this.state.bookingData, 1)));
                  } else {
                    store.dispatch((0, _reactRouterRedux.push)('/bookings/' + this.state.bookingData.id + '/?section=purchaser'));
                  }
                  store.dispatch((0, _flash.flashSuccessMessage)({
                    header: 'Credit score generating',
                    message: this.state.customerDetail.name + '\'s credit report sent'
                  }));
                }

              case 30:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[6, 15]]);
      }));

      function submitLoanInfo(_x5) {
        return _ref8.apply(this, arguments);
      }

      return submitLoanInfo;
    }()
  }, {
    key: 'submitPersonalInfo',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(validations, data) {
        var store, errors, message;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context9.next = 9;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errors.map(function (l) {
                    return l.message;
                  }) }));
                _context9.next = 8;
                return this.setLoading(false);

              case 8:
                return _context9.abrupt('return');

              case 9:
                _context9.prev = 9;
                _context9.next = 12;
                return this.infoForm.submit('/customers/' + this.props.customerID + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.custToken
                  },
                  body: JSON.stringify(data)
                });

              case 12:
                _context9.next = 24;
                break;

              case 14:
                _context9.prev = 14;
                _context9.t0 = _context9['catch'](9);

                if (!(_context9.t0.res && _context9.t0.res.status >= 400 && _context9.t0.res.status < 500)) {
                  _context9.next = 22;
                  break;
                }

                _context9.next = 19;
                return _context9.t0.res.text();

              case 19:
                message = _context9.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context9.abrupt('return');

              case 22:
                store.dispatch((0, _flash.flashErrorMessage)({ err: _context9.t0 }));
                return _context9.abrupt('return');

              case 24:
                _context9.next = 26;
                return this.setLoading(false);

              case 26:
                _context9.next = 28;
                return this.handleHasChange();

              case 28:
                _context9.next = 30;
                return this.handleNextStep();

              case 30:
                _context9.next = 32;
                return this.handleRefetch();

              case 32:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[9, 14]]);
      }));

      function submitPersonalInfo(_x6, _x7) {
        return _ref9.apply(this, arguments);
      }

      return submitPersonalInfo;
    }()
  }, {
    key: 'uploadDocument',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(body) {
        var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'consent';
        var store, message;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _context10.prev = 3;
                _context10.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.customerID + '/documents/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    // Let browser decide Content-Type
                    'X-Csrf-Token': this.state.documentToken
                  },
                  body: body
                }));

              case 6:
                _context10.next = 21;
                break;

              case 8:
                _context10.prev = 8;
                _context10.t0 = _context10['catch'](3);
                _context10.next = 12;
                return this.setLoading(false);

              case 12:
                Bugsnag.notifyException(_context10.t0);

                if (!(_context10.t0.res && _context10.t0.res.status >= 400 && _context10.t0.res.status < 500)) {
                  _context10.next = 19;
                  break;
                }

                _context10.next = 16;
                return _context10.t0.res.text();

              case 16:
                message = _context10.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context10.abrupt('return');

              case 19:
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context10.abrupt('return');

              case 21:
                _context10.next = 23;
                return this.setLoading(false);

              case 23:
                if (!(key === 'ic')) {
                  _context10.next = 28;
                  break;
                }

                _context10.next = 26;
                return this.icUpload.resetFiles();

              case 26:
                _context10.next = 30;
                break;

              case 28:
                _context10.next = 30;
                return this.consentUpload.resetFiles();

              case 30:
                _context10.next = 32;
                return this.handleHasChange();

              case 32:
                _context10.next = 34;
                return this.handleNextStep();

              case 34:
                _context10.next = 36;
                return this.handleRefetch();

              case 36:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[3, 8]]);
      }));

      function uploadDocument(_x8) {
        return _ref10.apply(this, arguments);
      }

      return uploadDocument;
    }()
  }, {
    key: 'updateIncome',
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(validations, income) {
        var store, errors, res, message;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });
                res = void 0;

                if (!(errors.length > 0)) {
                  _context11.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context11.abrupt('return');

              case 6:
                _context11.next = 8;
                return this.setLoading(true);

              case 8:
                _context11.prev = 8;
                _context11.next = 11;
                return this.form.submit('/customers/' + this.props.customerID + '/income/' + income.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.incomeToken
                  },
                  body: JSON.stringify(income)
                });

              case 11:
                res = _context11.sent;
                _context11.next = 26;
                break;

              case 14:
                _context11.prev = 14;
                _context11.t0 = _context11['catch'](8);
                _context11.next = 18;
                return this.setLoading(false);

              case 18:
                if (!(_context11.t0.res && _context11.t0.res.status >= 400 && _context11.t0.res.status < 500)) {
                  _context11.next = 24;
                  break;
                }

                _context11.next = 21;
                return _context11.t0.res.text();

              case 21:
                message = _context11.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context11.abrupt('return');

              case 24:
                store.dispatch((0, _flash.flashErrorMessage)(_context11.t0));
                return _context11.abrupt('return');

              case 26:
                _context11.next = 28;
                return this.setState({ income: res }, function () {});

              case 28:
                _context11.next = 30;
                return this.setLoading(false);

              case 30:
                _context11.next = 32;
                return this.handleHasChange();

              case 32:
                _context11.next = 34;
                return this.handleNextStep();

              case 34:
                _context11.next = 36;
                return this.handleRefetch();

              case 36:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this, [[8, 14]]);
      }));

      function updateIncome(_x10, _x11) {
        return _ref11.apply(this, arguments);
      }

      return updateIncome;
    }()
  }, {
    key: 'renderStep',
    value: function renderStep() {
      var currentStep = this.state.currentStep;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { centered: true },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { style: { paddingBottom: '0px' } },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 4, tablet: 5, mobile: 8 },
            _react2.default.createElement(
              _semanticUiReact.Header,
              { textAlign: 'left' },
              this.renderHeaderContent()
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 4, tablet: 5, mobile: 8 },
            _react2.default.createElement(
              'p',
              { style: { textAlign: 'right' } },
              currentStep + 1,
              ' of 5'
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 8, tablet: 10, mobile: 16 },
            _react2.default.createElement(
              'div',
              { className: 'progressBar' },
              _react2.default.createElement(_semanticUiReact.Progress, {
                percent: (currentStep + 1) * 20,
                size: 'tiny'
              })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            this.renderStepContent(currentStep)
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              'div',
              { className: 'buttonBorder' },
              _react2.default.createElement(_semanticUiReact.Container, { style: { borderTop: '1px solid rgb(217, 218, 220)', padding: '0.5rem', borderRadius: '0.25rem' } })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { style: { padding: 0 } },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 8, tablet: 10, mobile: 16 },
            _react2.default.createElement(
              'div',
              { className: 'nextButton' },
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  fluid: true,
                  onClick: currentStep === 4 ? this.handleEndStep : this.handleClickNext,
                  disabled: this.props.loading || this.checkNextDisabled()
                },
                currentStep !== 4 ? 'Next' : null,
                currentStep === 4 && this.props.location.pathname.includes('customers/') ? 'Submit' : null,
                currentStep === 4 && !this.props.location.pathname.includes('customers/') ? 'Save and Continue' : null
              )
            ),
            currentStep > 0 ? _react2.default.createElement(
              'div',
              { className: 'backButton' },
              _react2.default.createElement(_semanticUiReact.Button, {
                onClick: this.handlePreviousStep,
                disabled: this.props.loading,
                content: '< Back'
              })
            ) : null
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var newHeader = this.props.newHeader;

      return _react2.default.createElement(
        'div',
        null,
        this.props.pathCheck && _react2.default.createElement(
          _semanticUiReact.Header,
          { as: 'h4', textAlign: 'center' },
          'Booking for ',
          _react2.default.createElement('br', { className: 'large-hide small-hide tablet-hide' }),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/projects/' + (this.state.bookingData.project && this.state.bookingData.project.id) + '/units/' + (this.state.bookingData.projectUnit && this.state.bookingData.projectUnit.id) + '/' },
            this.state.bookingData.projectUnit && this.state.bookingData.projectUnit.reference
          ),
          ', ',
          this.state.bookingData.project && this.state.bookingData.project.name,
          ' ',
          this.state.bookingData.projectUnit && this.state.bookingData.projectUnit.isBumi && _react2.default.createElement(
            _semanticUiReact.Label,
            { size: 'mini' },
            'Bumi'
          )
        ),
        newHeader ? _react2.default.createElement(
          _semanticUiReact.Header,
          { className: 'new_title', as: 'h5', attached: 'top', textAlign: 'center' },
          newHeader
        ) : _react2.default.createElement(
          _semanticUiReact.Divider,
          {
            horizontal: true,
            style: { color: 'rgba(112, 112, 112, 1)' }
          },
          this.props.pathCheck ? 'Customer Assessment' : 'Credit Check'
        ),
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { className: 'stepsContainer ' + (newHeader ? '' : 'customer'), attached: newHeader ? true : false },
          this.renderStep()
        )
      );
    }
  }]);

  return NewCreditCheck;
}(_react.Component);

NewCreditCheck.propTypes = {
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    company: _propTypes2.default.object
  }),
  bookingID: _propTypes2.default.string,
  customerID: _propTypes2.default.string.isRequired,
  customerCreditReportID: _propTypes2.default.string,
  customerCreditReport: _propTypes2.default.shape({
    consentDsrDocumentID: _propTypes2.default.string,
    consentDsrDocument: _propTypes2.default.object
  }),
  customerCreditReports: _propTypes2.default.arrayOf(_propTypes2.default.object),
  data: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  icFrontDocumentID: _propTypes2.default.string,
  icFrontDocument: _propTypes2.default.shape({
    key: _propTypes2.default.string,
    tags: _propTypes2.default.arrayOf(_propTypes2.default.string)
  }),
  icBackDocumentID: _propTypes2.default.string,
  icBackDocument: _propTypes2.default.shape({
    key: _propTypes2.default.string,
    tags: _propTypes2.default.arrayOf(_propTypes2.default.string)
  }),
  identityTypeID: _propTypes2.default.number,
  identity: _propTypes2.default.string,
  incomeID: _propTypes2.default.string,
  income: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    isEmployed: _propTypes2.default.bool
  }),
  loading: _propTypes2.default.bool,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string,
    hash: _propTypes2.default.string
  }),
  onChange: _propTypes2.default.func,
  setLoading: _propTypes2.default.func,
  refetch: _propTypes2.default.func,
  routeParams: _propTypes2.default.shape({
    bookingID: _propTypes2.default.string
  }),
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    customerID: _propTypes2.default.string
  }),
  pathCheck: _propTypes2.default.bool,
  newHeader: _propTypes2.default.string
};
NewCreditCheck.contextTypes = {
  store: _propTypes2.default.object
};
NewCreditCheck.defaultProps = {
  customerCreditReport: null,
  customerCreditReportID: '',
  data: [],
  icFrontDocumentID: '',
  icFrontDocument: null,
  icBackDocumentID: '',
  icBackDocument: null,
  incomeID: '',
  income: null,
  isAgreedToDSRTerms: false
};

NewCreditCheck.getPropsToState = function (props) {
  var customerCreditReportID = props.customerCreditReportID;
  var customerCreditReport = props.customerCreditReport;
  var customerCreditReports = props.customerCreditReports;
  var customerDetail = props.customerDetail;
  var data = props.data;
  var icFrontDocumentID = props.icFrontDocumentID;
  var icFrontDocument = props.icFrontDocument;
  var icBackDocumentID = props.icBackDocumentID;
  var icBackDocument = props.icBackDocument;
  var incomeID = props.incomeID;
  var income = props.income;
  return {
    customerCreditReportID: customerCreditReportID,
    customerCreditReport: customerCreditReport,
    customerCreditReports: customerCreditReports,
    customerDetail: customerDetail,
    data: data,
    icFrontDocumentID: icFrontDocumentID,
    icFrontDocument: icFrontDocument,
    icBackDocumentID: icBackDocumentID,
    icBackDocument: icBackDocument,
    incomeID: incomeID,
    income: income,
    oriCustomerCreditReport: (0, _clone2.default)(customerCreditReport),
    oriData: (0, _clone2.default)(data),
    oriIcFrontDocument: (0, _clone2.default)(icFrontDocument),
    oriIcBackDocument: (0, _clone2.default)(icBackDocument),
    oriIncome: (0, _clone2.default)(income)
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this8 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var callback = arguments[1];

    if (_this8.props.setLoading) {
      return _this8.props.setLoading(loading);
    }
    if (callback) {
      callback();
    }
    return Promise.resolve();
  };

  this.setSignedState = function () {
    _this8.setState({ isSigned: true });
  };

  this.checkNextDisabled = function () {
    var _state = _this8.state,
        consentForm = _state.consentForm,
        currentStep = _state.currentStep,
        customerCreditReport = _state.customerCreditReport,
        data = _state.data,
        incomeID = _state.incomeID,
        icFront = _state.icFront,
        icBack = _state.icBack,
        income = _state.income,
        icFrontDocumentID = _state.icFrontDocumentID,
        icBackDocumentID = _state.icBackDocumentID,
        isAgreedToDSRTerms = _state.isAgreedToDSRTerms,
        isSigned = _state.isSigned;

    var hasCustInfo = data.customerDetail.name !== '' && data.customerDetail.mobilePrefix !== '' && data.customerDetail.mobile !== '';
    var hasConsentID = customerCreditReport && customerCreditReport !== null && customerCreditReport.mCtosXMLStatusID !== 'dsr_generated' && customerCreditReport.consentDsrDocumentID !== null && customerCreditReport.consentDsrDocumentID.length > 0;
    var hasIcFrontID = icFrontDocumentID.length > 0;
    var hasIcBackID = icBackDocumentID.length > 0;
    var hasIncomeID = incomeID.length > 0;
    var hasIcFront = icFront !== null && icFront.file !== null;
    var hasIcBack = icBack !== null && icBack.file !== null;
    var hasIncome = income && income.netIncome !== '' && income.netIncome > 0;
    var hasConsentForm = customerCreditReport && customerCreditReport.consentDsrDocumentID !== '' && customerCreditReport.mCtosXMLStatusID !== 'dsr_generated' && isSigned || consentForm !== null || isSigned;

    switch (currentStep) {
      case 0:
        return !hasCustInfo;
      case 1:
        return !hasConsentForm;
      case 2:
        return !(hasIcFrontID && hasIcBackID || hasIcFront && hasIcBackID || hasIcFrontID && hasIcBack || hasIcFront && hasIcBack);
      case 3:
        return !hasIncome;
      case 4:
        return !(hasConsentID && hasIncomeID && hasIcFrontID && hasIcBackID && isAgreedToDSRTerms);
      default:
        return false;
    }
  };

  this.checkStepContent = function () {
    var currentStep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var checkID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var checkForm = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var defaultCheck = arguments[3];
    var _state2 = _this8.state,
        consentForm = _state2.consentForm,
        customerCreditReport = _state2.customerCreditReport,
        data = _state2.data,
        icFront = _state2.icFront,
        icBack = _state2.icBack,
        icFrontDocumentID = _state2.icFrontDocumentID,
        icBackDocumentID = _state2.icBackDocumentID,
        income = _state2.income,
        incomeID = _state2.incomeID,
        isEmployed = _state2.isEmployed;

    if (checkForm) {
      _this8.fetchCustomer();
    }
    var hasCustInfo = data.customerDetail.name !== '' && data.customerDetail.mobilePrefix !== '' && data.customerDetail.mobile !== '';
    var hasConsentID = customerCreditReport && customerCreditReport !== null && customerCreditReport.mCtosXMLStatusID !== 'dsr_generated' && customerCreditReport.consentDsrDocumentID !== '' && customerCreditReport.consentDsrDocumentID.length > 0;
    var hasIcFrontID = icFrontDocumentID.length > 0;
    var hasIcBackID = icBackDocumentID.length > 0;
    var hasIncomeID = incomeID.length > 0;

    // upload form
    var hasConsentForm = consentForm && consentForm.src && consentForm.src.length > 0;
    var hasIcFront = icFront && icFront.src && icFront.src.length > 0;
    var hasIcBack = icBack && icBack.src && icBack.src.length > 0;
    var hasIncome = income && (income.netIncome !== '' || income.netIncome > 0 || !isEmployed && (income.basicIncome !== '' || income.basicIncome > 0));

    switch (currentStep) {
      case 0:
        return hasCustInfo;
      case 1:
        if (checkID) {
          return hasConsentID;
        }
        if (checkForm) {
          return hasConsentForm;
        }
        return hasConsentForm || hasConsentID;
      case 2:
        return hasIcFrontID && hasIcBackID || hasIcFront && hasIcBackID || hasIcFrontID && hasIcBack || hasIcFront && hasIcBack;
      case 3:
        if (checkID) {
          return hasIncomeID;
        }
        if (checkForm) {
          return hasIncome && !_this8.checkStringify(income, _this8.state.oriIncome);
        }
        return hasIncome || hasIncomeID;
      default:
        if (defaultCheck !== null) {
          return defaultCheck;
        }
    }
    return true;
  };

  this.checkStringify = function (source, target) {
    return JSON.stringify(source) === JSON.stringify(target);
  };

  this.handleCheckBox = function () {
    _this8.setState({
      isAgreedToDSRTerms: !_this8.state.isAgreedToDSRTerms
    });
  };

  this.handleCreateFormData = function (type) {
    var formData = null;
    if (type === 'consent') {
      formData = _this8.consentUpload.getFormData();
      var consentForm = _this8.state.consentForm;

      formData.append('files_0', consentForm.file);
      formData.append('tags_0', consentForm.tags);
      formData.append('names_0', consentForm.name);
      formData.append('degrees_0', consentForm.degree);
    } else if (type === 'ic') {
      formData = _this8.icUpload.getFormData();
      var _state3 = _this8.state,
          icFront = _state3.icFront,
          icBack = _state3.icBack;

      if (icFront) {
        formData.append('files_0', icFront.file);
        formData.append('tags_0', icFront.tags);
        formData.append('names_0', icFront.name);
        formData.append('degrees_0', icFront.degree);
        formData.append('mark_0', true);
      }
      if (icBack) {
        formData.append('files_1', icBack.file);
        formData.append('tags_1', icBack.tags);
        formData.append('names_1', icBack.name);
        formData.append('degrees_1', icBack.degree);
        formData.append('mark_0', true);
      }
    }
    return formData;
  };

  this.handleClickNext = function (event) {
    event.preventDefault();
    if (_this8.checkStepContent(_this8.state.currentStep, false, true, false)) {
      switch (_this8.state.currentStep) {
        case 0:
          _this8.getCustToken(function () {
            _this8.infoForm.handleSubmit(event);
          });
          break;
        case 1:
          _this8.getDocumentToken(function () {
            var formData = _this8.handleCreateFormData('consent');
            _this8.uploadDocument(formData, 'consent');
          });
          break;
        case 2:
          _this8.getDocumentToken(function () {
            var formData = _this8.handleCreateFormData('ic');
            _this8.uploadDocument(formData, 'ic');
          });
          break;
        case 3:
          _this8.getIncomeToken(function () {
            _this8.form.handleSubmit(event);
          });
          break;
        default:
          _this8.handleNextStep();
      }
    } else {
      _this8.handleNextStep();
    }
  };

  this.handleEndStep = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
    return regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return _this8.getCreditCheckToken(function () {
              _this8.loanInfo.handleSubmit(event);
            });

          case 2:
          case 'end':
            return _context12.stop();
        }
      }
    }, _callee12, _this8);
  }));

  this.handleGetForm = function (consentForm) {
    var hasChange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _this8.setState({ consentForm: consentForm }, function () {
      _this8.handleHasChange(hasChange);
    });
  };

  this.handleGetIC = function (ic) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Front';
    var hasChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _this8.setState(_defineProperty({}, 'ic' + direction, ic), function () {
      _this8.handleHasChange(hasChange);
    });
  };

  this.handleHasChange = function () {
    var hasChange = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (_this8.props.onChange) {
      _this8.props.onChange(hasChange);
    }
  };

  this.handleIncomeChange = function (income) {
    _this8.setState({ income: income }, function () {
      _this8.handleHasChange(true);
    });
  };

  this.handleLoanChange = function (income) {
    _this8.setState({ income: income }, function () {
      _this8.handleHasChange(true);
    });
  };

  this.handleNextStep = function () {
    var currentStep = _this8.state.currentStep + 1;
    if (currentStep > 4) {
      currentStep = 0;
    }
    _this8.setState({ currentStep: currentStep });
  };

  this.handlePersonalInfoChanges = function (data) {
    _this8.setState({ data: data }, function () {
      _this8.handleHasChange(true);
    });
  };

  this.handlePreviousStep = function () {
    var currentStep = _this8.state.currentStep - 1;
    if (currentStep <= 0) {
      currentStep = 0;
    }
    _this8.setState({ currentStep: currentStep });
  };

  this.handleRefetch = function () {
    if (_this8.props.refetch) {
      _this8.props.refetch();
    }
  };

  this.renderHeaderContent = function () {
    var currentStep = _this8.state.currentStep;

    var headerContent = '';
    switch (currentStep) {
      case 0:
        headerContent = 'Personal Details';
        break;
      case 1:
        headerContent = 'CTOS Consent';
        break;
      case 2:
        headerContent = 'Verification';
        break;
      case 3:
        headerContent = 'Financial Info';
        break;
      case 4:
        headerContent = 'Loan Info';
        break;
      default:
        currentStep = 0;
    }
    return headerContent;
  };

  this.renderStepContent = function () {
    var currentStep = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var _state4 = _this8.state,
        customerCreditReport = _state4.customerCreditReport,
        data = _state4.data,
        icFrontDocumentID = _state4.icFrontDocumentID,
        icFrontDocument = _state4.icFrontDocument,
        icBackDocumentID = _state4.icBackDocumentID,
        icBackDocument = _state4.icBackDocument,
        income = _state4.income;

    switch (currentStep) {
      case 0:
        {
          return _react2.default.createElement(_PersonalInfo2.default, {
            ref: function ref(_ref13) {
              _this8.infoForm = _ref13;
            },
            data: data,
            onSubmit: function onSubmit(validations, d) {
              _this8.submitPersonalInfo(validations, d);
            },
            onChange: _this8.handlePersonalInfoChanges
          });
        }
      case 1:
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_UploadForm2.default, {
            title: 'NewCreditForm',
            ref: function ref(_ref14) {
              _this8.consentUpload = _ref14;
            },
            loading: _this8.props.loading,
            sampleURL: '/assets/images/samples/document.svg',
            sampleSize: 'small',
            auth: _this8.props.auth,
            tags: ['Consent Form'],
            picture: customerCreditReport && customerCreditReport !== null && customerCreditReport.mCtosXMLStatusID !== 'dsr_generated' && customerCreditReport.consentDsrDocumentID !== '' && customerCreditReport.consentDsrDocumentID.length > 0 ? customerCreditReport.consentDsrDocument : null,
            onChange: _this8.handleGetForm,
            downloadURL: 'https://mhub.my/consent/credit_check/',
            signature: true,
            customerID: _this8.props.customerID,
            customerName: _this8.state.customerDetail.name,
            jobTitle: _this8.state.customerDetail.jobTitle,
            identityTypeID: _this8.props.identityTypeID,
            identity: _this8.props.identity,
            onSigned: _this8.setSignedState
          })
        );
      case 2:
        return _react2.default.createElement(
          _semanticUiReact.Grid,
          { centered: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { computer: 8, tablet: 10, mobile: 16 },
              _react2.default.createElement(_semanticUiReact.Header, { as: 'h2', content: 'Upload IC', textAlign: 'left' })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { computer: 6, tablet: 8, mobile: 16 },
              _react2.default.createElement(_UploadForm2.default, {
                isCompress: true,
                title: 'Front',
                ref: function ref(_ref15) {
                  _this8.icUpload = _ref15;
                },
                setLoading: _this8.setLoading,
                loading: _this8.props.loading,
                sampleURL: '/assets/images/samples/ic_front.svg',
                tags: ['IC Front'],
                picture: icFrontDocumentID && icFrontDocumentID.length > 0 ? icFrontDocument : null,
                onChange: function onChange(ic, hasChange) {
                  return _this8.handleGetIC(ic, 'Front', hasChange);
                }
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { computer: 6, tablet: 8, mobile: 16 },
              _react2.default.createElement(_UploadForm2.default, {
                isCompress: true,
                title: 'Back',
                ref: function ref(_ref16) {
                  _this8.icUpload = _ref16;
                },
                setLoading: _this8.setLoading,
                loading: _this8.props.loading,
                sampleURL: '/assets/images/samples/ic_back.svg',
                tags: ['IC Back'],
                picture: icBackDocumentID && icBackDocumentID.length > 0 ? icBackDocument : null,
                onChange: function onChange(ic, hasChange) {
                  return _this8.handleGetIC(ic, 'Back', hasChange);
                }
              })
            )
          )
        );
      case 3:
        return _react2.default.createElement(
          _semanticUiReact.Grid,
          { centered: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { computer: 8, tablet: 10, mobile: 16 },
              _react2.default.createElement(_semanticUiReact.Header, { as: 'h2', content: 'I am', textAlign: 'left' })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_NewIncomeForm2.default, {
                ref: function ref(_ref17) {
                  _this8.form = _ref17;
                },
                loading: _this8.props.loading,
                customerID: _this8.props.customerID,
                onSubmit: function onSubmit(validations, d, docsChanges) {
                  if (docsChanges) {
                    _this8.updateIncome(validations, d);
                  } else {
                    _this8.submitIncome(validations, d);
                  }
                },
                income: income,
                data: data,
                onChange: _this8.handleIncomeChange
              })
            )
          )
        );
      default:
        return _react2.default.createElement(
          _semanticUiReact.Grid,
          { centered: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { computer: 8, tablet: 10, mobile: 16 },
              _react2.default.createElement(_LoanInfo2.default, {
                ref: function ref(_ref18) {
                  _this8.loanInfo = _ref18;
                },
                loading: _this8.props.loading,
                onSubmit: function onSubmit(d) {
                  _this8.submitLoanInfo(d);
                },
                data: data,
                onChange: _this8.handleLoanChange,
                bookingCustomerData: _this8.state.bookingData,
                creditCheckReportData: _this8.state.creditCheckReportData,
                pathCheck: _this8.props.pathCheck
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { computer: 8, tablet: 10, mobile: 16 },
              _react2.default.createElement(_semanticUiReact.Checkbox, {
                label: 'I hereby declare that the purchasers\' details furnished are true and correct to the best of my knowledge',
                onChange: _this8.handleCheckBox,
                checked: _this8.state.isAgreedToDSRTerms,
                style: { textAlign: 'left' }
              })
            )
          )
        );
    }
  };
};

exports.default = (0, _reactRouter.withRouter)(NewCreditCheck, { withRef: true });

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

var _fetchM = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UploadDocumentForm = function (_Component) {
  _inherits(UploadDocumentForm, _Component);

  function UploadDocumentForm(props) {
    _classCallCheck(this, UploadDocumentForm);

    var _this = _possibleConstructorReturn(this, (UploadDocumentForm.__proto__ || Object.getPrototypeOf(UploadDocumentForm)).call(this, props));

    _this.handleSubmit = function (event) {
      event.preventDefault();
      if (_this.state.uploads.length > 0) {
        var formData = new FormData(_this.form);
        _this.state.uploads.forEach(function (upload, idx) {
          formData.append('files_' + idx, upload.file);
          formData.append('tags_' + idx, _this.state.tags[idx]);
          formData.append('names_' + idx, _this.state.names[idx]);
        });
        if (_this.props.onSubmit) {
          _this.props.onSubmit(event, formData);
        }
      }
    };

    _this.handleOnChange = function () {
      var files = Array.prototype.slice.call(_this.uploadFiles.files);
      _this.uploadFiles.value = null;
      if (window.FileReader) {
        files.forEach(function (file) {
          var reader = new FileReader();
          reader.onloadend = function () {
            var _this$state = _this.state,
                uploads = _this$state.uploads,
                tags = _this$state.tags,
                names = _this$state.names;

            var upload = {
              file: file,
              name: file.name.substring(0, file.name.length - 4),
              src: reader.result
            };
            uploads.push(upload);
            tags.push([]);
            names.push(upload.name);
            _this.setState({
              uploads: uploads,
              tags: tags,
              names: names
            }, function () {
              _this.handleCheckChanges();
            });
          };
          reader.readAsDataURL(file);
        });
      }
    };

    _this.handleRemove = function (event, idx) {
      event.preventDefault();
      var _this$state2 = _this.state,
          uploads = _this$state2.uploads,
          tags = _this$state2.tags,
          names = _this$state2.names;

      uploads.splice(idx, 1);
      tags.splice(idx, 1);
      names.splice(idx, 1);
      _this.setState({ uploads: uploads, tags: tags, names: names });
    };

    _this.handleAddFile = function (event) {
      event.preventDefault();
      _this.uploadFiles.click();
    };

    _this.handleTagsChange = function (e, _ref, idx) {
      var value = _ref.value;
      var tags = _this.state.tags;

      tags[idx] = value;
      _this.setState({ tags: tags });
    };

    _this.handleInputChange = function (e, _ref2, idx) {
      var value = _ref2.value;
      var names = _this.state.names;

      names[idx] = value;
      _this.setState({ names: names });
    };

    _this.handleAddition = function (e, _ref3) {
      var value = _ref3.value;
      var options = _this.state.options;

      if (options.some(function (o) {
        return o.value !== value;
      })) {
        _this.setState({
          options: [{ text: value, value: value }].concat(_toConsumableArray(options))
        });
      }
    };

    _this.state = {
      loading: false,
      uploads: [],
      tags: [],
      names: [],
      options: [],
      hasChanges: false
    };
    return _this;
  }

  _createClass(UploadDocumentForm, [{
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'submit',
    value: function submit(url) {
      var _this3 = this;

      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var store = this.context.store;

      return this.setLoading(true).then(function () {
        return store.dispatch((0, _fetchM.fetchM)(url, opts));
      }).then(function (res) {
        return res.json();
      }).then(function (result) {
        return _this3.setLoading(false).then(function () {
          return result;
        });
      }).catch(function (err) {
        return _this3.setLoading(false).then(function () {
          return Promise.reject(err);
        });
      });
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      var _this4 = this;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true }, function () {
          if (_this4.props.onChange) {
            _this4.props.onChange(true);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      return _react2.default.createElement(
        'form',
        {
          encType: 'multipart/form-data',
          onSubmit: this.handleSubmit,
          name: 'uploadDocuments',
          ref: function ref(_ref7) {
            _this5.form = _ref7;
          }
        },
        _react2.default.createElement('input', {
          ref: function ref(_ref4) {
            _this5.uploadFiles = _ref4;
          },
          type: 'file',
          onChange: this.handleOnChange,
          accept: 'application/pdf',
          multiple: true,
          style: { display: 'none' }
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 'equal' },
            _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'computer' }),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { verticalAlign: 'middle', columns: 'equal' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Button, {
                    fluid: true,
                    compact: true,
                    primary: true,
                    icon: 'add',
                    content: 'PDF',
                    onClick: this.handleAddFile,
                    disabled: this.state.loading
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Button, {
                    fluid: true,
                    compact: true,
                    type: 'submit',
                    positive: true,
                    content: this.props.t('Upload', { ns: _translation.TRANSLATION_FILES.translation }), icon: 'cloud upload',
                    loading: this.state.loading,
                    disabled: this.state.uploads.length < 1 || this.state.loading
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { stackable: true, doubling: true, columns: 1 },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              this.props.t('Uploading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          this.state.uploads.length > 0 ? this.state.uploads.map(function (upload, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { key: idx },
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { padded: true },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { stackable: true, columns: 'equal' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_semanticUiReact.Input, {
                      placeholder: _this5.props.t('Name', { ns: _translation.TRANSLATION_FILES.translation }),
                      fluid: true,
                      value: _this5.state.names[idx],
                      disabled: _this5.state.loading,
                      onChange: function onChange(e, _ref5) {
                        var value = _ref5.value;
                        return _this5.handleInputChange(e, { value: value }, idx);
                      }
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_semanticUiReact.Dropdown, {
                      options: _this5.state.options,
                      placeholder: _this5.props.t('Add tags', { ns: _translation.TRANSLATION_FILES.translation }),
                      search: true,
                      noResultsMessage: _this5.props.t('Add tags', { ns: _translation.TRANSLATION_FILES.translation }),
                      selection: true,
                      fluid: true,
                      multiple: true,
                      allowAdditions: true,
                      value: _this5.state.tags[idx],
                      onAddItem: _this5.handleAddition,
                      disabled: _this5.state.loading,
                      onChange: function onChange(e, _ref6) {
                        var value = _ref6.value;
                        return _this5.handleTagsChange(e, { value: value }, idx);
                      }
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 2 },
                    _react2.default.createElement(_semanticUiReact.Button, {
                      type: 'button',
                      fluid: true,
                      compact: true,
                      icon: 'delete',
                      negative: true,
                      disabled: _this5.state.loading,
                      onClick: function onClick(e) {
                        return _this5.handleRemove(e, idx);
                      }
                    })
                  )
                )
              )
            );
          }) : null
        )
      );
    }
  }]);

  return UploadDocumentForm;
}(_react.Component);

UploadDocumentForm.propTypes = {
  onSubmit: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  t: _propTypes2.default.func
};
UploadDocumentForm.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(UploadDocumentForm);

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _reactRedux = __webpack_require__(9);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _bankCaseStates = __webpack_require__(988);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _BankersList = __webpack_require__(397);

var _BankersList2 = _interopRequireDefault(_BankersList);

var _InviteBankerForm = __webpack_require__(587);

var _InviteBankerForm2 = _interopRequireDefault(_InviteBankerForm);

var _UpdateCaseStatus = __webpack_require__(1080);

var _UpdateCaseStatus2 = _interopRequireDefault(_UpdateCaseStatus);

var _GetStarted = __webpack_require__(2343);

var _GetStarted2 = _interopRequireDefault(_GetStarted);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _Phone = __webpack_require__(126);

var _Phone2 = _interopRequireDefault(_Phone);

var _url = __webpack_require__(19);

var _ic_preferred_green = __webpack_require__(504);

var _ic_preferred_green2 = _interopRequireDefault(_ic_preferred_green);

var _BankCaseStates = __webpack_require__(2510);

var _BankCaseStates2 = _interopRequireDefault(_BankCaseStates);

var _translation = __webpack_require__(4);

var _HLBCampaignCalloutBanner = __webpack_require__(2150);

var _HLBCampaignCalloutBanner2 = _interopRequireDefault(_HLBCampaignCalloutBanner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var LoanTracker = function (_Component) {
  _inherits(LoanTracker, _Component);

  function LoanTracker(props) {
    _classCallCheck(this, LoanTracker);

    var _this = _possibleConstructorReturn(this, (LoanTracker.__proto__ || Object.getPrototypeOf(LoanTracker)).call(this, props));

    _initialiseProps.call(_this);

    var state = LoanTracker.getPropsToState(props);
    var _LoanTracker$defaultD = LoanTracker.defaultData,
        id = _LoanTracker$defaultD.id,
        leadDropID = _LoanTracker$defaultD.leadDropID,
        pinExpiresAt = _LoanTracker$defaultD.pinExpiresAt,
        consentPinCount = _LoanTracker$defaultD.consentPinCount,
        code = _LoanTracker$defaultD.code,
        leadBankersLimit = _LoanTracker$defaultD.leadBankersLimit;

    var allBankCases = [].concat(props.allBankCases);
    var bankCases = [].concat(props.bankCases);
    _this.state = _extends({}, state, {
      id: props.loanTrackerLeadID || id,
      leadDropID: props.loanTrackerLeadDropID || leadDropID,
      code: props.loanTrackerLeadCode || code,
      pinExpiresAt: props.loanTrackerLeadConsentPinExpiresAt || pinExpiresAt,
      consentPinCount: props.loanTrackerLeadConsentPinCount || consentPinCount,
      leadBankersLimit: props.leadBankersLimit || leadBankersLimit,
      showAddBanker: false,
      additionalBankers: [],
      bankersCount: 0,
      allBankCases: allBankCases,
      bankCases: bankCases,
      oriAllBankCases: (0, _clone2.default)(allBankCases),
      oriBankCases: (0, _clone2.default)(bankCases),
      selectedBankCase: null,
      updateStatus: '',
      showUpdateBankCase: false,
      showInviteBanker: false,
      showBankCaseStatesModal: false,
      displayAddBankerContent: true,
      selectedCaseStatus: ''
    });
    return _this;
  }

  _createClass(LoanTracker, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;

      if (this.props.bankCaseStates.data.length < 14) {
        store.dispatch((0, _bankCaseStates.fetchBankCaseStates)());
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var _this2 = this;

      var state = LoanTracker.getPropsToState(props);
      var _LoanTracker$defaultD2 = LoanTracker.defaultData,
          id = _LoanTracker$defaultD2.id,
          leadDropID = _LoanTracker$defaultD2.leadDropID,
          pinExpiresAt = _LoanTracker$defaultD2.pinExpiresAt,
          consentPinCount = _LoanTracker$defaultD2.consentPinCount,
          code = _LoanTracker$defaultD2.code,
          leadBankersLimit = _LoanTracker$defaultD2.leadBankersLimit;
      var _state = this.state,
          allBankCases = _state.allBankCases,
          bankCases = _state.bankCases,
          hasDropCase = _state.hasDropCase,
          oriAllBankCases = _state.oriAllBankCases,
          oriBankCases = _state.oriBankCases;


      if (JSON.stringify(oriBankCases) !== JSON.stringify(props.bankCases)) {
        bankCases = props.bankCases || [];
        oriBankCases = (0, _clone2.default)(bankCases);
      }
      if (JSON.stringify(oriAllBankCases) !== JSON.stringify(props.allBankCases)) {
        allBankCases = props.allBankCases || [];
        oriAllBankCases = (0, _clone2.default)(allBankCases);
      }
      if (hasDropCase !== props.hasDropCase) {
        hasDropCase = props.hasDropCase;
      }

      this.setState(_extends({
        id: props.loanTrackerLeadID || id,
        leadDropID: props.loanTrackerLeadDropID || leadDropID,
        code: props.loanTrackerLeadCode || code,
        pinExpiresAt: props.loanTrackerLeadConsentPinExpiresAt || pinExpiresAt,
        consentPinCount: props.loanTrackerLeadConsentPinCount || consentPinCount,
        leadBankersLimit: props.leadBankersLimit || leadBankersLimit,
        allBankCases: allBankCases,
        bankCases: bankCases,
        hasDropCase: hasDropCase,
        oriAllBankCases: oriAllBankCases,
        oriBankCases: oriBankCases
      }, state), function () {
        _this2.checkBankCasesActivity(allBankCases);
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this3.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'addBanker',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(newBankCases) {
        var isDrop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var store, t, query, res, message, _message;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({
                  drop: isDrop ? 'true' : 'false'
                });
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.props.bookingID + '/loan_trackers/bank_cases/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify({
                    bankCases: newBankCases
                  })
                }));

              case 8:
                res = _context.sent;

                if (!res.ok) {
                  _context.next = 18;
                  break;
                }

                _context.next = 12;
                return this.setComponentState({
                  additionalBankers: [],
                  showAddBanker: false
                });

              case 12:
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Add Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Banker(s) is successfully added', { ns: _translation.TRANSLATION_FILES.translation }) + '.'
                }));

                if (!this.props.onBankerAssignmentSuccess) {
                  _context.next = 16;
                  break;
                }

                _context.next = 16;
                return this.props.onBankerAssignmentSuccess();

              case 16:
                _context.next = 22;
                break;

              case 18:
                _context.next = 20;
                return res.text();

              case 20:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 22:
                _context.next = 35;
                break;

              case 24:
                _context.prev = 24;
                _context.t0 = _context['catch'](5);

                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 33;
                  break;
                }

                _context.next = 29;
                return _context.t0.res.text();

              case 29:
                _message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));
                _context.next = 35;
                break;

              case 33:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({
                  message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.'
                }));

              case 35:
                _context.prev = 35;
                _context.next = 38;
                return this.setLoading(false);

              case 38:
                return _context.finish(35);

              case 39:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 24, 35, 39]]);
      }));

      function addBanker(_x2) {
        return _ref.apply(this, arguments);
      }

      return addBanker;
    }()
  }, {
    key: 'inviteBanker',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(validations, newBanker) {
        var store, t, _state2, bookingStatusID, projectAssignBankCasesStatus, errors, query, message;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                _state2 = this.state, bookingStatusID = _state2.bookingStatusID, projectAssignBankCasesStatus = _state2.projectAssignBankCasesStatus;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context2.next = 9;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context2.abrupt('return');

              case 9:
                _context2.next = 11;
                return this.setComponentState({ showInviteBanker: false });

              case 11:
                query = Object.assign({
                  drop: projectAssignBankCasesStatus !== '' && projectAssignBankCasesStatus === 'booked' && bookingStatusID === 'reserved' ? 'true' : 'false'
                });
                _context2.prev = 12;
                _context2.next = 15;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.props.bookingID + '/loan_trackers/bank_cases/invite/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(newBanker)
                }));

              case 15:
                _context2.next = 30;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2['catch'](12);
                _context2.next = 21;
                return this.setLoading(false);

              case 21:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 27;
                  break;
                }

                _context2.next = 24;
                return _context2.t0.res.text();

              case 24:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 27:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context2.abrupt('return');

              case 30:
                _context2.next = 32;
                return this.setLoading(false);

              case 32:
                _context2.next = 34;
                return this.setComponentState({ showAddBanker: false });

              case 34:
                window.location.reload();
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Invite Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Banker {{name}} is successfully invited', { name: newBanker.name, ns: _translation.TRANSLATION_FILES.translation }) + '.'
                }));

              case 36:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[12, 17]]);
      }));

      function inviteBanker(_x4, _x5) {
        return _ref2.apply(this, arguments);
      }

      return inviteBanker;
    }()
  }, {
    key: 'updateBankCase',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var statusNote = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var loanAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';

        var store, t, _state3, selectedBankCase, updateStatus, body, message, query;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                _state3 = this.state, selectedBankCase = _state3.selectedBankCase, updateStatus = _state3.updateStatus;
                body = Object.assign(selectedBankCase, {
                  loanAmount: loanAmount.toString(),
                  status: updateStatus,
                  statusNote: statusNote
                });
                _context3.prev = 6;
                _context3.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.props.bookingID + '/loan_trackers/bank_cases/' + selectedBankCase.code + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(body)
                }));

              case 9:
                _context3.next = 26;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](6);
                _context3.next = 15;
                return this.setLoading(false);

              case 15:
                _context3.next = 17;
                return this.setComponentState({
                  selectedBankCase: null,
                  updateStatus: ''
                });

              case 17:
                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 23;
                  break;
                }

                _context3.next = 20;
                return _context3.t0.res.text();

              case 20:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 23:
                Bugsnag.notifyException(_context3.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context3.abrupt('return');

              case 26:
                _context3.next = 28;
                return this.setLoading(false);

              case 28:
                query = (0, _url.decodeSearch)(this.props.location.search);

                store.dispatch((0, _reactRouterRedux.push)('/bookings/' + this.props.bookingID + '/?' + (0, _url.encodeSearch)(query)));
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('{{bankName}}\'s case is successfully updated', { bankName: selectedBankCase.bank.shortName, ns: _translation.TRANSLATION_FILES.translation }) + '.'
                }));
                _context3.next = 33;
                return this.setComponentState({
                  selectedBankCase: null,
                  updateStatus: ''
                });

              case 33:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 11]]);
      }));

      function updateBankCase() {
        return _ref3.apply(this, arguments);
      }

      return updateBankCase;
    }()
  }, {
    key: 'nudgeBankCase',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(bankCase) {
        var store, t, message, query;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                _context4.prev = 4;
                _context4.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.props.bookingID + '/loan_trackers/bank_cases/' + bankCase.code + '/nudge/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 7:
                _context4.next = 22;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](4);
                _context4.next = 13;
                return this.setLoading(false);

              case 13:
                if (!(_context4.t0.res && _context4.t0.res.status >= 400 && _context4.t0.res.status < 500)) {
                  _context4.next = 19;
                  break;
                }

                _context4.next = 16;
                return _context4.t0.res.text();

              case 16:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context4.abrupt('return');

              case 19:
                Bugsnag.notifyException(_context4.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context4.abrupt('return');

              case 22:
                _context4.next = 24;
                return this.setLoading(false);

              case 24:
                query = (0, _url.decodeSearch)(this.props.location.search);

                store.dispatch((0, _reactRouterRedux.push)('/bookings/' + this.props.bookingID + '/?' + (0, _url.encodeSearch)(query)));
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('{{bankName}}\'s case is successfully nudged', { bankName: bankCase.bank.shortName, ns: _translation.TRANSLATION_FILES.translation }) + '.'
                }));

              case 27:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 9]]);
      }));

      function nudgeBankCase(_x8) {
        return _ref4.apply(this, arguments);
      }

      return nudgeBankCase;
    }()
  }, {
    key: 'checkBankCasesActivity',
    value: function checkBankCasesActivity() {
      var bankCases = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.allBankCases;
      var leadBankersLimit = this.state.leadBankersLimit;

      var activeCount = 0;
      var bankersCount = 0;
      if (this.state.id > 0) {
        if (leadBankersLimit > 0) {
          activeCount = bankCases.filter(this.activeBankCases).length;
          if (activeCount < leadBankersLimit) {
            bankersCount = leadBankersLimit - activeCount;
          }
        }
      }
      if (bankersCount !== this.state.bankersCount) {
        this.setState({ bankersCount: bankersCount });
      }
    }
  }, {
    key: 'renderMessage',
    value: function renderMessage() {
      var t = this.props.t;

      var list = [];
      if (this.state.id > 0 && this.state.code !== '') {
        list = '';
      } else {
        list = [t('Inform purchaser that their basic contact information will be shared to bankers'), t('PIN will to be sent to purchaser’s registered mobile number (Valid for 72 hours)'), t('Purchaser needs to send this to you to confirm consent')];
      }
      return list;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          bankCaseStates = _props.bankCaseStates,
          disabled = _props.disabled,
          isCashBuyer = _props.isCashBuyer,
          isNotAuthorizedToInviteBanker = _props.isNotAuthorizedToInviteBanker,
          leadStatus = _props.leadStatus,
          projectAssignBankCasesStatus = _props.projectAssignBankCasesStatus,
          projectCurrencies = _props.projectCurrencies,
          projectID = _props.projectID,
          hasSuccessBankCase = _props.hasSuccessBankCase,
          t = _props.t;
      var _state4 = this.state,
          bookingStatusID = _state4.bookingStatusID,
          displayAddBankerContent = _state4.displayAddBankerContent,
          leadDropID = _state4.leadDropID;

      var list = this.renderMessage();
      return _react2.default.createElement(
        'div',
        { className: 'ui grid loan-tracker' },
        _react2.default.createElement(_BankCaseStates2.default, {
          open: this.state.showBankCaseStatesModal,
          onClose: this.handleCloseCaseStatus,
          customerName: this.state.preferredName,
          activeStatus: this.state.selectedBankCase ? this.state.selectedBankCase.status : ''
        }),
        _react2.default.createElement(_BankersList2.default, {
          project: this.props.project,
          bankerSelectionTabs: this.props.bankerSelectionTabs,
          open: this.state.showAddBanker,
          onClose: this.handleCloseAddBanker,
          onConfirm: leadDropID > 0 && projectAssignBankCasesStatus !== '' && projectAssignBankCasesStatus === 'booked' && bookingStatusID === 'reserved' ? this.handleAddBankerDrop : this.handleAddBanker,
          projectID: projectID,
          bankerOnCheck: this.checkBankers,
          bankerOnCheckSelected: this.checkSelectedBankers,
          limit: this.state.bankersCount,
          selected: this.state.additionalBankers,
          bankCases: this.state.bankCases,
          extraNode: !isNotAuthorizedToInviteBanker && _react2.default.createElement(_semanticUiReact.Button, {
            floated: 'left',
            onClick: this.handleShowInviteBanker,
            content: 'Invite'
          })
        }),
        _react2.default.createElement(_InviteBankerForm2.default, {
          ref: function ref(_ref5) {
            _this4.form = _ref5;
          },
          open: this.state.showInviteBanker,
          onClose: this.handleCloseInviteBanker,
          onConfirm: this.handleInviteBanker,
          bankOnCheck: this.checkBanks
        }),
        _react2.default.createElement(_UpdateCaseStatus2.default, {
          open: this.state.showUpdateBankCase,
          onClose: this.handleCloseUpdateBankCase,
          onConfirm: this.handleUpdateBankCase,
          bankerName: this.state.selectedBankCase ? this.state.selectedBankCase.banker.name : '',
          statusName: bankCaseStates && this.state.updateStatus.length > 0 ? bankCaseStates.data.find(function (s) {
            return s.state === _this4.state.updateStatus;
          }).shortName : this.state.updateStatus,
          loanAmount: this.state.selectedBankCase ? this.state.selectedBankCase.loanAmount : '0',
          spaValue: this.state.bookingSPAValue
        }),
        disabled ? _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'center aligned sixteen wide column' },
            _react2.default.createElement(
              _semanticUiReact.Header,
              {
                as: 'h2',
                style: {
                  margin: '1em 0'
                }
              },
              t('Booking is {{status}}', { ns: _translation.TRANSLATION_FILES.screens, status: t(this.renderDisabledText(), { ns: _translation.TRANSLATION_FILES.constants }).toLowerCase() }),
              '.'
            )
          )
        ) : _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'center aligned sixteen wide column' },
            _react2.default.createElement(
              _semanticUiReact.Step.Group,
              { ordered: true, fluid: true },
              _react2.default.createElement(_semanticUiReact.Step, {
                completed: this.state.leadDropID > 0 || this.props.consentTypeID === '1',
                active: this.state.leadDropID === 0,
                title: t(this.props.consentTypeID !== '1' ? 'Get Consent' : 'Get Started')
              }),
              _react2.default.createElement(_semanticUiReact.Step, {
                completed: this.state.id > 0 && this.state.code !== '',
                active: this.state.leadDropID > 0 && this.state.id === 0,
                title: t('Verify')
              }),
              _react2.default.createElement(
                _semanticUiReact.Step,
                {
                  completed: this.state.id > 0 && this.state.code !== '' && this.state.bankCases.length > 0,
                  active: this.state.id > 0 && this.state.code !== '' && this.state.bankCases.length < 1
                },
                _react2.default.createElement(
                  _semanticUiReact.Step.Content,
                  null,
                  _react2.default.createElement(
                    'span',
                    { style: { fontSize: '1.14285714em', fontWeight: 700 } },
                    t('Add Banker')
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { marginTop: '0.5em' }, className: 'left aligned sixteen wide column' },
            list.length > 0 && this.props.consentTypeID !== '1' ? _react2.default.createElement(_semanticUiReact.List, {
              bulleted: true,
              items: list,
              style: {
                marginTop: '0.5em',
                marginBottom: '0.5em'
              }
            }) : null
          )
        ),
        this.isHLBCampaign() && _react2.default.createElement(
          'div',
          { className: 'row', style: { paddingTop: '0em' } },
          _react2.default.createElement(
            'div',
            { className: 'sixteen wide column', style: { display: 'flex', justifyContent: 'center', marginTop: '0.5em' } },
            _react2.default.createElement(_HLBCampaignCalloutBanner2.default, null)
          )
        ),
        this.state.id > 0 && this.state.code !== '' && displayAddBankerContent ? _react2.default.createElement(
          'div',
          { className: 'row', style: { marginBottom: '1rem' } },
          _react2.default.createElement(
            'div',
            { className: 'sixteen wide column' },
            this.state.hasDropCase ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'loan-tracker-warning-col' },
              _react2.default.createElement(
                _semanticUiReact.Label,
                null,
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning sign', color: 'yellow' }),
                t('Please note that banker will receive the case only after the booking is confirmed'),
                '.'
              )
            ) : '',
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { columns: 3, stretched: true, stackable: true, doubling: true },
              this.state.allBankCases.map(function (bankCase, idx) {
                return _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { className: bankCase.leadDropID > 0 ? 'loan-tracker-disabled' : '', key: idx },
                  _react2.default.createElement(
                    _semanticUiReact.Segment,
                    { className: bankCase.leadDropID > 0 || _this4.checkBankCaseUserIsActive(bankCase) ? null : 'inactive-case' },
                    bankCase.leadDropID > 0 || bankCase.status ? _react2.default.createElement(
                      _semanticUiReact.Label,
                      {
                        attached: 'top',
                        color: !bankCase.leadDropID ? _this4.getColor(bankCase.status) : _this4.getPendingDeveloperApprovalCaseColor()
                      },
                      bankCase.leadDropID > 0 || _this4.checkBankCaseUserIsActive(bankCase) ? _react2.default.createElement(_semanticUiReact.Dropdown, {
                        selectOnBlur: false,
                        fluid: true, inline: true,
                        floating: true, scrolling: true, className: 'icon',
                        onClick: function onClick(e) {
                          return _this4.handleShowCaseStatus(e, bankCase);
                        },
                        text: !bankCase.leadDropID ? t(_this4.getCaseText(0, bankCase.status), { ns: _translation.TRANSLATION_FILES.constants }) : t(_this4.getCaseText(bankCase.leadDropID, ''), { ns: _translation.TRANSLATION_FILES.constants }),
                        disabled: disabled || bankCase.leadDropID > 0 || bankCase.status === 'reject_lo_signed_other_bank'
                      }) : bankCaseStates.data.find(function (s) {
                        return s.state === bankCase.status;
                      }).shortName
                    ) : null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      null,
                      _this4.state.id < 1 ? _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 16, textAlign: 'right' },
                          _react2.default.createElement(
                            _semanticUiReact.Label,
                            {
                              as: 'button',
                              attached: 'top right',
                              color: 'red',
                              size: 'mini',
                              onClick: function onClick() {
                                return _this4.handleRemoveBanker(idx);
                              }
                            },
                            _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove', style: { margin: 0 } })
                          )
                        )
                      ) : null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 8, textAlign: 'left' },
                          _react2.default.createElement(
                            _semanticUiReact.Header,
                            { as: 'h4' },
                            bankCase.banker.directToBank && bankCase.bank && bankCase.bank.logoSrc ? _react2.default.createElement(
                              _semanticUiReact.Header.Content,
                              { style: { display: 'inline-flex', alignItems: 'center' } },
                              _react2.default.createElement(_semanticUiReact.Image, { src: bankCase.bank.logoSrc, style: { maxHeight: '35px' } }),
                              bankCase.bank.isExclusive ? _react2.default.createElement(
                                _semanticUiReact.Header.Subheader,
                                { style: { marginLeft: '0.5em' } },
                                _react2.default.createElement(_semanticUiReact.Image, { src: _ic_preferred_green2.default, height: '15', style: { maxWidth: '20px' } })
                              ) : null
                            ) : _react2.default.createElement(
                              _semanticUiReact.Header.Content,
                              null,
                              bankCase.banker.name,
                              _react2.default.createElement(
                                _semanticUiReact.Header.Subheader,
                                null,
                                _react2.default.createElement(
                                  'p',
                                  null,
                                  bankCase.banker.preferredName
                                ),
                                _react2.default.createElement(_Phone2.default, {
                                  mobilePrefix: bankCase.banker.mobilePrefix,
                                  mobile: bankCase.banker.mobile
                                })
                              )
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 8 },
                          _react2.default.createElement(_semanticUiReact.Header, {
                            textAlign: 'right',
                            as: 'h4',
                            content: !bankCase.leadDropID ? bankCase.bank.shortName : bankCase.banker.bank.shortName,
                            subheader: bankCase.leadDropID || _this4.checkBankCaseUserIsActive(bankCase) ? bankCase.banker.bankBranch.name : null
                          })
                        )
                      ),
                      !bankCase.leadDropID && _this4.checkBankCaseUserIsActive(bankCase) && bankCase.status === 'success_li_issued' ? _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        { verticalAlign: 'middle' },
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 5, textAlign: 'left' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Row,
                            { className: 'bankcasecard-subheader' },
                            t('Loan Margin')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Row,
                            null,
                            _this4.getLoanMargin(bankCase.loanAmount)
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 5, textAlign: 'left', style: { padding: 0 } },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Row,
                            { className: 'bankcasecard-subheader' },
                            t('Loan Amount')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Row,
                            null,
                            _react2.default.createElement(_LoanAmount2.default, {
                              projectCurrencies: projectCurrencies,
                              format: '',
                              amount: bankCase.loanAmount > 0 ? bankCase.loanAmount : 0,
                              prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                            })
                          )
                        ),
                        bankCase.latestUpdateAt || bankCase.createdAt ? _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 6, textAlign: 'right' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Row,
                            { className: 'bankcasecard-subheader' },
                            t('Last Updated')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Row,
                            null,
                            _react2.default.createElement(_Timestamp2.default, {
                              timestamp: bankCase.latestUpdateAt ? bankCase.latestUpdateAt : bankCase.createdAt,
                              precise: true
                            })
                          )
                        ) : null
                      ) : _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        { verticalAlign: 'middle' },
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 8, textAlign: 'left' },
                          !bankCase.leadDropID && _this4.checkBankCaseUserIsActive(bankCase) && bankCase.status !== 'success_li_issued' ? _react2.default.createElement(_semanticUiReact.Button, {
                            icon: 'hand pointer',
                            content: t('Nudge'),
                            inverted: (0, _momentTimezone2.default)().isAfter(bankCase.nudgeAt),
                            color: (0, _momentTimezone2.default)().isAfter(bankCase.nudgeAt) ? 'grey' : null,
                            onClick: function onClick() {
                              return _this4.handleNudge(bankCase);
                            },
                            disabled: disabled || leadStatus === 'success' || bankCase.status.startsWith('success') || bankCase.status.startsWith('reject') || (0, _momentTimezone2.default)().isBefore(bankCase.nudgeAt) || hasSuccessBankCase
                          }) : '',
                          bankCase.leadDropID > 0 ? _react2.default.createElement(_semanticUiReact.Label, { size: 'small', color: 'yellow', content: t('Pending developer\'s approval') }) : '',
                          !bankCase.leadDropID && !_this4.checkBankCaseUserIsActive(bankCase) ? _react2.default.createElement(_semanticUiReact.Label, { size: 'small', color: 'yellow', content: t('Pending Registration') }) : ''
                        ),
                        bankCase.latestUpdateAt || bankCase.createdAt ? _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 8, textAlign: 'right' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Row,
                            { className: 'bankcasecard-subheader' },
                            t('Last Updated')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Row,
                            null,
                            _react2.default.createElement(_Timestamp2.default, {
                              timestamp: bankCase.latestUpdateAt ? bankCase.latestUpdateAt : bankCase.createdAt,
                              precise: true
                            })
                          )
                        ) : null
                      )
                    )
                  )
                );
              }),
              (this.state.leadBankersLimit === 0 || this.state.bankersCount > 0) && !disabled && !hasSuccessBankCase ? Array(this.state.bankersCount || 1).fill('Bankers').map(function (ele, key) {
                return _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { key: key, only: key > 0 ? 'tablet computer' : null },
                  _react2.default.createElement(
                    _semanticUiReact.Segment,
                    {
                      style: {
                        display: 'inline-flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center'
                      },
                      secondary: true
                    },
                    key === 0 && !isCashBuyer ? _react2.default.createElement(_semanticUiReact.Button, {
                      positive: true,
                      onClick: _this4.handleShowAddBanker,
                      icon: 'add',
                      content: t('Bankers')
                    }) : null
                  )
                );
              }) : null
            )
          )
        ) : null,
        this.state.id < 1 && !disabled && !hasSuccessBankCase ? _react2.default.createElement(_GetStarted2.default, {
          id: this.state.id,
          leadDropID: this.state.leadDropID,
          code: this.state.code,
          bookingID: this.props.bookingID,
          consentTypeID: this.props.consentTypeID,
          token: this.props.token,
          onSubmit: this.handleGetStarted,
          bankCases: this.state.bankCases,
          setLoading: this.setLoading,
          mobilePrefix: this.props.mobilePrefix,
          mobile: this.props.mobile
        }) : null
      );
    }
  }]);

  return LoanTracker;
}(_react.Component);

LoanTracker.contextTypes = {
  store: _propTypes2.default.object
};
LoanTracker.propTypes = {
  auth: _propTypes2.default.shape({
    companyBranch: _propTypes2.default.object
  }),
  allBankCases: _propTypes2.default.arrayOf(_propTypes2.default.object),
  bankCases: _propTypes2.default.arrayOf(_propTypes2.default.object),
  bankCaseStates: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  bankerOnCheck: _propTypes2.default.func,
  bankerSelectionTabs: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  bookingID: _propTypes2.default.string,
  bookingStatusID: _propTypes2.default.string,
  bookingSPAValue: _propTypes2.default.number,
  consentTypeID: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  hasDropCase: _propTypes2.default.bool,
  hasSuccessBankCase: _propTypes2.default.bool,
  isCashBuyer: _propTypes2.default.bool,
  isNotAuthorizedToInviteBanker: _propTypes2.default.bool,
  loanTrackerLeadDropID: _propTypes2.default.number,
  loanTrackerLeadID: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  leadBankersLimit: _propTypes2.default.number,
  leadStatus: _propTypes2.default.string,
  loanTrackerLeadCode: _propTypes2.default.string,
  loanTrackerLeadConsentPinCount: _propTypes2.default.number,
  loanTrackerLeadConsentPinExpiresAt: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }).isRequired,
  mobile: _propTypes2.default.string,
  mobilePrefix: _propTypes2.default.string,
  preferredName: _propTypes2.default.string,
  projectAssignBankCasesStatus: _propTypes2.default.string,
  projectCurrencies: _propTypes2.default.string,
  projectID: _propTypes2.default.string,
  setLoading: _propTypes2.default.func.isRequired,
  token: _propTypes2.default.string,
  onBankerAssignmentSuccess: _propTypes2.default.func,
  project: _propTypes2.default.shape({
    hlbCampaignIsEnabled: _propTypes2.default.bool
  })
};
LoanTracker.defaultData = {
  id: 0,
  leadDropID: 0,
  code: null,
  pinExpiresAt: null,
  consentPinCount: 0,
  leadBankersLimit: 0
};

LoanTracker.mapStateToProps = function (state) {
  return {
    bankCaseStates: state.bankCaseStates
  };
};

LoanTracker.getPropsToState = function (props) {
  var bookingStatusID = props.bookingStatusID;
  var bookingSPAValue = props.bookingSPAValue;
  var hasDropCase = props.hasDropCase;
  var projectAssignBankCasesStatus = props.projectAssignBankCasesStatus;
  var projectCurrencies = props.projectCurrencies;
  var isCashBuyer = props.isCashBuyer || false;
  var preferredName = props.preferredName;

  return {
    bookingStatusID: bookingStatusID,
    bookingSPAValue: bookingSPAValue,
    hasDropCase: hasDropCase,
    projectAssignBankCasesStatus: projectAssignBankCasesStatus,
    projectCurrencies: projectCurrencies,
    isCashBuyer: isCashBuyer,
    preferredName: preferredName
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.getColor = function (status) {
    if (status.startsWith('reject')) {
      return 'red';
    } else if (status.startsWith('pending')) {
      return 'yellow';
    } else if (status.startsWith('approved') || status.startsWith('success')) {
      return 'green';
    }
    return 'blue';
  };

  this.getLoanMargin = function (loanAmount) {
    var bookingSPAValue = _this5.state.bookingSPAValue;

    var loanMargin = '0%';
    if (loanAmount > 0 && bookingSPAValue > 0) {
      loanMargin = Math.ceil(loanAmount / bookingSPAValue * 100) + '%';
    }

    return loanMargin;
  };

  this.getPendingDeveloperApprovalCaseColor = function () {
    var bookingStatusID = _this5.props.bookingStatusID;

    if (bookingStatusID === 'cancelled_developer' || bookingStatusID === 'cancelled_availability' || bookingStatusID === 'expired') {
      return 'red';
    }
    return 'blue';
  };

  this.getCaseText = function (leadDropID, status) {
    var bookingStatusID = _this5.props.bookingStatusID;

    if (leadDropID > 0) {
      if (bookingStatusID === 'cancelled_developer' || bookingStatusID === 'cancelled_availability' || bookingStatusID === 'expired') {
        return 'Cancelled by developer';
      }
      return 'New';
    }

    switch (status) {
      case 'new':
        return 'New';
      case 'pending_docs':
        return 'Pending Docs';
      case 'pending_docs_submitted':
        return 'Docs Submitted';
      case 'approved_lo_issued':
        return 'LO Issued';
      case 'pending_unreachable':
        return 'Unreachable';
      case 'pending_reappealed':
        return 'Loan Re-appealed';
      case 'reject_wrong_info':
        return 'Wrong Info';
      case 'reject_cancelled':
        return 'Customer Cancelled';
      case 'success_li_issued':
        return 'LO Signed';
      case 'reject_unqualified':
        return 'Unqualified';
      case 'reject_bank':
        return 'Loan Rejected';
      case 'reject_customer':
        return 'Customer Rejected';
      case 'reject_lo_signed_other_bank':
        return 'LO Signed With Another Bank';
      case 'reject_developer':
        return 'Developer Cancelled';
      default:
        return '';
    }
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (_this5.props.setLoading) {
      return _this5.props.setLoading(loading);
    }
    return Promise.resolve();
  };

  this.isHLBCampaign = function () {
    var auth = _this5.props.auth;
    var project = _this5.props.project;

    return !!(auth && auth.companyBranch && auth.companyBranch.isExternal && project && project.hlbCampaignIsEnabled);
  };

  this.handleGetStarted = function (data) {
    var t = _this5.props.t;

    _this5.setState({
      id: data.id || LoanTracker.defaultData.id,
      leadDropID: data.leadDropID || LoanTracker.defaultData.leadDropID,
      code: data.code || LoanTracker.defaultData.code
    }, function () {
      _this5.checkBankCasesActivity();
      var store = _this5.context.store;

      var header = 'Consent Pin sent to purchaser';
      var message = 'Valid for 72 hours';
      if (_this5.state.id > 0) {
        header = 'PIN confirmed';
        message = 'Proceed to add bankers';
      }
      if (_this5.props.consentTypeID !== '1') {
        store.dispatch((0, _flash.flashSuccessMessage)({
          header: t(header, { ns: _translation.TRANSLATION_FILES.translation }),
          message: t(message, { ns: _translation.TRANSLATION_FILES.translation }) + '.'
        }));
      }
    });
  };

  this.handleShowAddBanker = function (e) {
    e.preventDefault();
    _this5.setState({
      showAddBanker: true
    });
  };

  this.handleCloseAddBanker = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this5.setState({
      showAddBanker: false
    });
  };

  this.handleAddBanker = function (e, additionalBankers) {
    e.preventDefault();
    var bankCases = _this5.state.bankCases;

    var newBankBases = additionalBankers.map(function (banker) {
      return {
        bank: banker.bank,
        bankerID: banker.id,
        banker: banker
      };
    });
    if (_this5.state.id < 1) {
      bankCases = _this5.state.oriBankCases.concat(newBankBases);
    }
    _this5.setState({
      bankCases: bankCases,
      additionalBankers: additionalBankers,
      showAddBanker: false
    }, function () {
      _this5.checkBankCasesActivity(bankCases);
      if (_this5.state.id > 0) {
        _this5.addBanker(newBankBases);
      }
    });
  };

  this.handleAddBankerDrop = function (e, additionalBankers) {
    e.preventDefault();
    var newBankDropCases = additionalBankers.map(function (banker) {
      return {
        bank: banker.bank,
        bankerID: banker.id,
        banker: banker
      };
    });
    if (_this5.state.leadDropID > 0) {
      _this5.addBanker(newBankDropCases, true);
    }
  };

  this.handleShowInviteBanker = function (e) {
    e.preventDefault();
    _this5.setState({
      showInviteBanker: true
    });
  };

  this.handleCloseInviteBanker = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this5.setState({
      showInviteBanker: false
    });
  };

  this.handleInviteBanker = function (e, validation, banker) {
    e.preventDefault();
    if (_this5.state.id > 0) {
      _this5.inviteBanker(validation, banker);
    }
  };

  this.activeBankCases = function (bankCase) {
    return !bankCase.leadDropID && (bankCase.status.startsWith('new') || bankCase.status.startsWith('pending') || bankCase.status.startsWith('approved') || bankCase.status === 'reject_wrong_info') || bankCase.leadDropID > 0;
  };

  this.checkBankers = function (banker, bankers) {
    var index = bankers.findIndex(function (i) {
      return i.id === banker.id;
    });
    if (index > -1) {
      return false;
    }
    if (_this5.state.leadBankersLimit > 0 && bankers.length >= _this5.state.bankersCount) {
      return true;
    }
    var allBankCases = _this5.state.allBankCases;

    var bankerIDs = allBankCases.map(function (bankCase) {
      return bankCase.bankerID;
    });
    var activeBankIDs = allBankCases.filter(_this5.activeBankCases).map(function (bankCase) {
      return parseInt(bankCase.banker.bankID, 10);
    });
    return bankers.some(function (b) {
      return b.bankID === banker.bankID;
    }) || bankerIDs.some(function (b) {
      return b === banker.id;
    }) || activeBankIDs.some(function (b) {
      return b === parseInt(banker.bankID, 10);
    }) || _this5.props.bankerOnCheck && _this5.props.bankerOnCheck(banker);
  };

  this.checkSelectedBankers = function (banker) {
    var allBankCases = _this5.state.allBankCases;

    return allBankCases.some(function (bc) {
      return bc.bankerID === banker.id;
    });
  };

  this.checkBanks = function (bank) {
    var allBankCases = _this5.state.allBankCases;

    var activeBankIDs = allBankCases.filter(_this5.activeBankCases).map(function (bankCase) {
      return parseInt(bankCase.banker.bankID, 10);
    });
    return activeBankIDs.some(function (b) {
      return b === parseInt(bank.id, 10);
    });
  };

  this.handleDisplayAddBankerContent = function (e) {
    e.preventDefault();
    var showContent = _this5.state.displayAddBankerContent;
    _this5.setState({ displayAddBankerContent: !showContent });
  };

  this.handleChangeStatus = function (selectedBankCase) {
    var updateStatus = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (selectedBankCase.status !== updateStatus) {
      _this5.setState({
        selectedBankCase: selectedBankCase,
        updateStatus: updateStatus,
        showUpdateBankCase: true
      });
    }
  };

  this.handleCloseUpdateBankCase = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this5.setState({
      showUpdateBankCase: false
    });
  };

  this.handleShowCaseStatus = function (e, bankCase) {
    e.preventDefault();
    _this5.setState({ showBankCaseStatesModal: true, selectedBankCase: bankCase });
  };

  this.handleCloseCaseStatus = function (e, newStatus) {
    if (e) {
      e.preventDefault();
    }
    var selectedBankCase = _this5.state.selectedBankCase;

    if (newStatus !== '' && newStatus !== selectedBankCase.status) {
      _this5.setState({
        updateStatus: newStatus,
        showUpdateBankCase: true
      });
    } else {
      _this5.setState({
        showBankCaseStatesModal: false,
        selectedBankCase: null });
    }
  };

  this.handleUpdateBankCase = function (e) {
    var statusNote = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var loanAmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
    var store = _this5.context.store;
    var t = _this5.props.t;
    var updateStatus = _this5.state.updateStatus;

    if (updateStatus === 'success_li_issued' && Number(loanAmount) <= 0) {
      store.dispatch((0, _flash.flashErrorMessage)({ message: t('Loan Amount is required', { ns: _translation.TRANSLATION_FILES.translation }) }));
      return;
    }
    _this5.setState({
      showUpdateBankCase: false,
      showBankCaseStatesModal: false
    }, function () {
      _this5.updateBankCase(statusNote, loanAmount);
    });
  };

  this.handleRemoveBanker = function (index) {
    var bankCases = _this5.state.bankCases;

    bankCases.splice(index, 1);
    var additionalBankers = bankCases.map(function (bc) {
      return bc.banker;
    });
    _this5.setState({ bankCases: bankCases, additionalBankers: additionalBankers }, function () {
      _this5.checkBankCasesActivity(bankCases);
    });
  };

  this.handleNudge = function (bankCase) {
    _this5.nudgeBankCase(bankCase);
  };

  this.checkBankCaseUserIsActive = function (bankCase) {
    return bankCase.banker.user.statusID === '100';
  };

  this.renderDisabledText = function () {
    var bookingStatusID = _this5.props.bookingStatusID;

    switch (bookingStatusID) {
      case 'cancelled_availability':
      case 'cancelled_developer':
        return 'Cancelled';
      case 'expired':
        return 'Expired';
      case 'sold_spa_signed':
      default:
        return 'Sold';
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(LoanTracker.mapStateToProps)(LoanTracker));

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _translation = __webpack_require__(4);

var _documentType = __webpack_require__(1042);

var _documentType2 = _interopRequireDefault(_documentType);

var _vietnam = __webpack_require__(40);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _AddSharedMedia = __webpack_require__(2508);

var _AddSharedMedia2 = _interopRequireDefault(_AddSharedMedia);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _url = __webpack_require__(19);

var _download = __webpack_require__(361);

var _download2 = _interopRequireDefault(_download);

var _delete = __webpack_require__(3526);

var _delete2 = _interopRequireDefault(_delete);

var _upload = __webpack_require__(3540);

var _upload2 = _interopRequireDefault(_upload);

var _snapshotIdentityDocuments = __webpack_require__(2369);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp', 'tif', 'tiff'];

var Documents = function (_Component) {
  _inherits(Documents, _Component);

  function Documents(props) {
    var _this2 = this;

    _classCallCheck(this, Documents);

    var _this = _possibleConstructorReturn(this, (Documents.__proto__ || Object.getPrototypeOf(Documents)).call(this, props));

    _this.getFileIcon = function () {
      var fileName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var ext = fileName.split('.').pop().toLowerCase();

      if (ext === 'pdf') return 'file pdf outline';
      if (IMAGE_EXTENSIONS.includes(ext)) return 'file image outline';
      if (['doc', 'docx', 'rtf', 'odt'].includes(ext)) return 'file word outline';
      if (['xls', 'xlsx', 'csv', 'ods'].includes(ext)) return 'file excel outline';
      if (['ppt', 'pptx'].includes(ext)) return 'file powerpoint outline';
      if (ext === 'txt') return 'file text outline';

      return 'file alternate outline';
    };

    _this.getDocumentURL = function (doc) {
      return _config2.default.get('bookApiURL') + '/shared_medias/' + doc.id + '/file/' + encodeURIComponent(doc.fileName);
    };

    _this.isImageFile = function (fileName) {
      if (!fileName) return false;
      var ext = fileName.split('.').pop().toLowerCase();
      return IMAGE_EXTENSIONS.includes(ext);
    };

    _this.isProtectedIdentityDocument = function (doc) {
      return !!(doc && (doc.snapshotDocument || doc.currentIdentityDocument));
    };

    _this.isProtectedIdentityUnavailable = function (doc) {
      return !!(doc && (doc.snapshotUnavailable || doc.currentIdentityUnavailable || doc.currentIdentityPending));
    };

    _this.protectedIdentityURL = function (doc) {
      return doc.snapshotURL || doc.identityURL;
    };

    _this.handleOpenDocument = function (e, doc) {
      if (_this.isProtectedIdentityDocument(doc)) {
        if (e && e.preventDefault) e.preventDefault();
        _this.openProtectedIdentityDocument(doc);
        return;
      }
      // A manual image can be opened while a snapshot fetch is pending. It becomes the active
      // preview, so the late snapshot result must not overwrite it.
      _this.snapshotRequestVersion += 1;
      if (_this.state.selectedSnapshotObjectURL) {
        URL.revokeObjectURL(_this.state.selectedSnapshotObjectURL);
        _this.setState({ selectedSnapshotObjectURL: null });
      }
      // Image types open in the existing ViewLarge modal; everything else
      // (and unknown extensions) falls through to the link's default
      // target="_blank" behaviour, opening in a new tab.
      if (_this.isImageFile(doc.fileName)) {
        if (e && e.preventDefault) e.preventDefault();
        _this.setState({
          showLarge: true,
          selectedMedia: {
            url: _this.getDocumentURL(doc),
            label: doc.fileName
          }
        });
      }
    };

    _this.snapshotRequestKey = function (doc) {
      var opportunity = _this.props.opportunity || _this.props.data || {};
      var parent = _this.getParent();
      return [parent.parentType, parent.parentID, opportunity.id, opportunity.snapshot_frozen_at, _this.props.currentIdentityBookingID, doc.customerID, _this.protectedIdentityURL(doc)].join('\0');
    };

    _this.handleCloseLarge = function () {
      _this.snapshotRequestVersion += 1;
      if (_this.state.selectedSnapshotObjectURL) URL.revokeObjectURL(_this.state.selectedSnapshotObjectURL);
      _this.setState({ showLarge: false, selectedMedia: null, selectedSnapshotObjectURL: null });
    };

    _this.handleShowAddMedia = function (e) {
      if (e) e.preventDefault();
      _this.setState({
        showAddMedia: true
      });
    };

    _this.handleCloseAddMedia = function (e) {
      if (e) e.preventDefault();
      _this.setState({
        showAddMedia: false
      });
    };

    _this.formatBytes = function (bytes) {
      var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;

      if (bytes === 0) return '0 Bytes';
      var k = 1024;
      var dm = decimals < 0 ? 0 : decimals;
      var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

      var i = Math.floor(Math.log(bytes) / Math.log(k));
      var value = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));

      return value + ' ' + sizes[i];
    };

    _this.getUniqueDocuments = function (documents) {
      if (!Array.isArray(documents)) return [];

      var seen = new Set();

      return documents.filter(function (doc) {
        var fileType = (doc && doc.fileType) != null ? doc.fileType : '';
        var fileName = (doc && doc.fileName) != null ? doc.fileName : '';
        var fileSizeBytes = (doc && doc.fileSizeBytes) != null ? doc.fileSizeBytes : '';
        var key = fileType + '\0' + fileName + '\0' + fileSizeBytes;

        // Keep rows with no identifying metadata because they cannot be safely deduped.
        if (!fileType && !fileName && fileSizeBytes === '') {
          return true;
        }
        if (seen.has(key)) return false;

        seen.add(key);
        return true;
      });
    };

    _this.getParent = function () {
      var _this$props = _this.props,
          parentType = _this$props.parentType,
          parentID = _this$props.parentID,
          id = _this$props.id;

      return {
        parentType: parentType || 'opportunity',
        parentID: parentID || id
      };
    };

    _this.addDocument = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var store, files, _this$props2, mediaToken, t, _this$getParent, parentType, parentID, uploadPromises;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              store = _this.context.store;
              files = _this.state.files;
              _this$props2 = _this.props, mediaToken = _this$props2.mediaToken, t = _this$props2.t;
              _this$getParent = _this.getParent(), parentType = _this$getParent.parentType, parentID = _this$getParent.parentID;

              if (!(!files || files.length === 0 || !parentID)) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt('return');

            case 6:
              uploadPromises = files.map(function (fileWrapper) {
                var actualBinary = fileWrapper.file;
                var data = new FormData();

                data.append('file', actualBinary);

                var metadata = {
                  parentType: parentType,
                  parentID: parentID,
                  fileName: actualBinary.name || fileWrapper.fileName,
                  fileType: fileWrapper.fileType,
                  sourceApp: 'mhub-book-api'
                };

                data.append('metadata', JSON.stringify(metadata));

                var action = (0, _fetchM.fetchM)('/shared_medias/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'X-CSRF-Token': mediaToken
                  },
                  body: data
                });

                return store.dispatch(action).then(function () {
                  store.dispatch((0, _flash.flashSuccessMessage)({
                    header: t('Success', { ns: _translation.TRANSLATION_FILES.constants }),
                    message: t('FILE_UPLOAD_SUCCESS', { name: actualBinary.name, ns: _translation.TRANSLATION_FILES.screens })
                  }));
                }).catch(function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(err) {
                    var backendMessage, errorText;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            backendMessage = t('FILE_UPLOAD_FAILED', { name: actualBinary.name, ns: _translation.TRANSLATION_FILES.screens });

                            if (!(err.response && typeof err.response.text === 'function')) {
                              _context.next = 11;
                              break;
                            }

                            _context.prev = 2;
                            _context.next = 5;
                            return err.response.text();

                          case 5:
                            errorText = _context.sent;

                            if (errorText) backendMessage = errorText;
                            _context.next = 11;
                            break;

                          case 9:
                            _context.prev = 9;
                            _context.t0 = _context['catch'](2);

                          case 11:

                            store.dispatch((0, _flash.flashErrorMessage)({
                              header: t('Upload Failed', { ns: _translation.TRANSLATION_FILES.screens }),
                              message: backendMessage
                            }));

                          case 12:
                          case 'end':
                            return _context.stop();
                        }
                      }
                    }, _callee, _this2, [[2, 9]]);
                  }));

                  return function (_x3) {
                    return _ref2.apply(this, arguments);
                  };
                }());
              });
              _context2.next = 9;
              return Promise.all(uploadPromises);

            case 9:
              if (_this.mounted) {
                _this.setState({ files: null });
                if (_this.props.fetchDocument) {
                  _this.props.fetchDocument();
                }
              }

            case 10:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.handleOnUpload = function (event, _ref3) {
      var files = _ref3.files;

      event.preventDefault();
      _this.setState({
        showAddMedia: false,
        files: files
      }, function () {
        _this.addDocument();
      });
    };

    _this.handleDownload = function (e, selectedDocument) {
      if (e && e.preventDefault) e.preventDefault();
      if (_this.isProtectedIdentityDocument(selectedDocument)) {
        _this.openProtectedIdentityDocument(selectedDocument, true);
        return;
      }
      _this.downloadDocument(selectedDocument.id, selectedDocument.fileName);
    };

    _this.readSnapshotHeader = function (blob) {
      var header = blob.slice(0, 16);
      if (typeof header.arrayBuffer === 'function') {
        return header.arrayBuffer().then(function (bytes) {
          return new Uint8Array(bytes);
        });
      }
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onload = function () {
          return resolve(new Uint8Array(reader.result));
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(header);
      });
    };

    _this.downloadObjectURL = function (url, fileName) {
      var link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    _this.loadProtectedIdentityMedia = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(doc) {
        var store, blob, detected, fallbackExtension, extension, mimeType;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                store = _this.context.store;
                _context3.next = 3;
                return (0, _fetchM.serverRequestGetBlob)(_this.protectedIdentityURL(doc), store);

              case 3:
                blob = _context3.sent;

                if (blob) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt('return', null);

              case 6:
                _context3.t0 = _snapshotIdentityDocuments.detectSnapshotMediaType;
                _context3.next = 9;
                return _this.readSnapshotHeader(blob);

              case 9:
                _context3.t1 = _context3.sent;
                detected = (0, _context3.t0)(_context3.t1);
                fallbackExtension = (0, _snapshotIdentityDocuments.snapshotDownloadOnlyExtension)(doc.snapshotExtension);

                if (!(!detected && !fallbackExtension)) {
                  _context3.next = 14;
                  break;
                }

                return _context3.abrupt('return', null);

              case 14:
                extension = detected ? detected.extension : fallbackExtension;
                mimeType = detected ? detected.mimeType : 'application/octet-stream';
                return _context3.abrupt('return', {
                  fileName: (0, _snapshotIdentityDocuments.snapshotFileName)(doc.fileName, extension),
                  objectURL: URL.createObjectURL(new Blob([blob], { type: mimeType })),
                  previewable: !!(detected && detected.previewable),
                  pdf: !!(detected && detected.pdf)
                });

              case 17:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.openProtectedIdentityDocument = function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(doc) {
        var download = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var store, requestKey, requestVersion, media;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                store = _this.context.store;
                requestKey = _this.snapshotRequestKey(doc);
                requestVersion = _this.snapshotRequestVersion + 1;

                _this.snapshotRequestVersion = requestVersion;
                media = void 0;
                _context4.prev = 5;
                _context4.next = 8;
                return _this.loadProtectedIdentityMedia(doc);

              case 8:
                media = _context4.sent;
                _context4.next = 15;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](5);

                if (_this.mounted && requestVersion === _this.snapshotRequestVersion && requestKey === _this.snapshotRequestKey(doc)) {
                  store.dispatch((0, _flash.flashErrorMessage)({ message: 'Identity document is unavailable.' }));
                }
                return _context4.abrupt('return');

              case 15:
                if (!(!_this.mounted || requestVersion !== _this.snapshotRequestVersion || requestKey !== _this.snapshotRequestKey(doc))) {
                  _context4.next = 18;
                  break;
                }

                if (media && media.objectURL) URL.revokeObjectURL(media.objectURL);
                return _context4.abrupt('return');

              case 18:
                if (media) {
                  _context4.next = 21;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ message: 'Identity document is unavailable.' }));
                return _context4.abrupt('return');

              case 21:
                if (!(download || !media.previewable)) {
                  _context4.next = 25;
                  break;
                }

                _this.downloadObjectURL(media.objectURL, media.fileName);
                window.setTimeout(function () {
                  return URL.revokeObjectURL(media.objectURL);
                }, 60000);
                return _context4.abrupt('return');

              case 25:

                if (_this.state.selectedSnapshotObjectURL) URL.revokeObjectURL(_this.state.selectedSnapshotObjectURL);
                _this.setState({
                  showLarge: true,
                  selectedSnapshotObjectURL: media.objectURL,
                  selectedMedia: { url: media.objectURL, label: media.fileName }
                });

              case 27:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2, [[5, 11]]);
      }));

      return function (_x5) {
        return _ref5.apply(this, arguments);
      };
    }();

    _this.handleDelete = function (e, selectedDocument) {
      if (e && e.preventDefault) e.preventDefault();
      _this.setState({
        showConfirm: true,
        selectedDocument: selectedDocument
      });
    };

    _this.handleCancelDelete = function () {
      _this.setState({
        showConfirm: false,
        selectedDocument: null
      });
    };

    _this.handleConfirmDelete = function (e) {
      if (e && e.preventDefault) e.preventDefault();
      var selectedDocument = _this.state.selectedDocument;


      _this.handleCancelDelete();
      if (selectedDocument) {
        _this.deleteDocument(selectedDocument.id);
      }
    };

    _this.downloadDocument = function (id, fileName) {
      var downloadUrl = _config2.default.get('bookApiURL') + '/shared_medias/' + id + '/file/' + fileName + '?dl=true';

      var link = document.createElement('a');
      link.href = downloadUrl;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    _this.deleteDocument = function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
        var store, _this$props3, mediaToken, t, res, message;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                store = _this.context.store;
                _this$props3 = _this.props, mediaToken = _this$props3.mediaToken, t = _this$props3.t;
                _context5.prev = 2;
                _context5.next = 5;
                return store.dispatch((0, _fetchM.fetchM)('/shared_medias/' + id + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'X-CSRF-Token': mediaToken
                  }
                }));

              case 5:
                res = _context5.sent;

                if (res.ok) {
                  _context5.next = 12;
                  break;
                }

                _context5.next = 9;
                return res.text();

              case 9:
                message = _context5.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context5.abrupt('return');

              case 12:

                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Document successfully deleted', { ns: _translation.TRANSLATION_FILES.translation })
                }));

                if (_this.props.fetchDocument) {
                  _this.props.fetchDocument();
                }
                _context5.next = 19;
                break;

              case 16:
                _context5.prev = 16;
                _context5.t0 = _context5['catch'](2);

                store.dispatch((0, _flash.flashErrorMessage)(_context5.t0));

              case 19:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this2, [[2, 16]]);
      }));

      return function (_x7) {
        return _ref6.apply(this, arguments);
      };
    }();

    _this.handleFilterOnChange = function (value, queryName) {
      var query = (0, _url.decodeSearch)(_this.props.location.search);
      if (value === 'all') {
        delete query[queryName];
      } else {
        query[queryName] = value;
      }
      _this.setState(_defineProperty({}, queryName, value), function () {
        _this.replaceQuery(query);
      });
    };

    _this.handleClearFilter = function (queryName) {
      var query = (0, _url.decodeSearch)(_this.props.location.search);
      delete query[queryName];
      _this.setState(_defineProperty({}, queryName, ''), function () {
        _this.replaceQuery(query);
      });
    };

    _this.mounted = false;
    _this.snapshotRequestVersion = 0;
    _this.state = {
      showConfirm: false,
      showLarge: false,
      selectedMedia: null,
      selectedDocument: null,
      showAddMedia: false,
      selectedSnapshotObjectURL: null
    };
    return _this;
  }

  _createClass(Documents, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var previous = prevProps.opportunity || prevProps.data || {};
      var current = this.props.opportunity || this.props.data || {};
      var previousParentID = prevProps.parentID || prevProps.id;
      var currentParentID = this.props.parentID || this.props.id;
      if (previous.id !== current.id || previous.snapshot_frozen_at !== current.snapshot_frozen_at || previousParentID !== currentParentID || prevProps.parentType !== this.props.parentType || prevProps.currentIdentityBookingID !== this.props.currentIdentityBookingID || prevProps.currentIdentityMode !== this.props.currentIdentityMode) {
        this.snapshotRequestVersion += 1;
        if (this.state.selectedSnapshotObjectURL) {
          URL.revokeObjectURL(this.state.selectedSnapshotObjectURL);
          // eslint-disable-next-line react/no-did-update-set-state
          this.setState({ showLarge: false, selectedMedia: null, selectedSnapshotObjectURL: null });
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
      this.snapshotRequestVersion += 1;
      if (this.state.selectedSnapshotObjectURL) URL.revokeObjectURL(this.state.selectedSnapshotObjectURL);
    }

    // Helper to get the right icon based on file extension

  }, {
    key: 'replaceQuery',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(query) {
        var store, _getParent, parentType, parentID, url, queryString, res, pathname, documentData;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                store = this.context.store;
                _getParent = this.getParent(), parentType = _getParent.parentType, parentID = _getParent.parentID;

                // A blank parent_id would ask for every active shared media in the database. Never send it.

                if (parentID) {
                  _context6.next = 4;
                  break;
                }

                return _context6.abrupt('return');

              case 4:
                _context6.prev = 4;

                this.setState({ loading: true });

                url = '/shared_medias/?parent_type=' + parentType + '&parent_id=' + parentID;
                queryString = (0, _url.encodeSearch)(query);

                if (queryString) {
                  url += '&' + queryString;
                }
                _context6.next = 11;
                return store.dispatch((0, _fetchM.fetchM)(url, {
                  method: 'GET',
                  credentials: 'include'
                }));

              case 11:
                res = _context6.sent;

                if (!res.ok) {
                  _context6.next = 19;
                  break;
                }

                pathname = this.props.location.pathname;

                store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + queryString));
                _context6.next = 17;
                return res.json();

              case 17:
                documentData = _context6.sent;

                if (this.mounted) {
                  this.setState({
                    documentData: documentData || [],
                    loading: false
                  });
                }

              case 19:
                _context6.next = 24;
                break;

              case 21:
                _context6.prev = 21;
                _context6.t0 = _context6['catch'](4);

                if (this.mounted) {
                  this.setState({ loading: false });
                }

              case 24:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[4, 21]]);
      }));

      function replaceQuery(_x8) {
        return _ref7.apply(this, arguments);
      }

      return replaceQuery;
    }()
  }, {
    key: 'renderFileType',
    value: function renderFileType(fileType) {
      var t = this.props.t;
      // CPI-1249 (A22): name every type book-api can store, so a generated sales form is not "N/A".

      var label = (0, _documentType.getDocumentTypeLabel)(fileType);
      return t(label || 'N/A', { ns: _translation.TRANSLATION_FILES.translation });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          loading = _props.loading,
          t = _props.t,
          auth = _props.auth;

      var rawData = this.state.documentData || this.props.documentData || [];
      var isVietnam = (0, _vietnam.isVietnamCompany)(auth);
      var opportunity = this.props.opportunity || this.props.data;
      var parent = this.getParent();
      // Bookings can retain a previous opportunity while its next booking loads. Snapshot rows are
      // valid only for the document parent currently rendered, never for a merely scoped URL.
      var currentOpportunity = opportunity && parent.parentType === 'opportunity' && String(opportunity.id) === String(parent.parentID) ? opportunity : null;
      var currentIdentityMode = isVietnam && !!this.props.currentIdentityMode;
      var snapshotReady = !currentIdentityMode && isVietnam && (0, _snapshotIdentityDocuments.snapshotIsReady)(currentOpportunity);
      var snapshotDocuments = !currentIdentityMode && isVietnam ? (0, _snapshotIdentityDocuments.getSnapshotIdentityDocuments)(currentOpportunity, _config2.default.get('bookApiURL')) : [];
      var currentIdentityDocuments = currentIdentityMode ? this.props.currentIdentityDocuments || [] : [];
      var sharedDocuments = this.getUniqueDocuments(rawData).filter(function (doc) {
        return !(snapshotReady || currentIdentityMode) || !(0, _snapshotIdentityDocuments.isGeneratedIdentityMirror)(doc);
      });
      var query = (0, _url.decodeSearch)(this.props.location && this.props.location.search || '');
      // Query state is authoritative: the browser Back button must restore unfiltered snapshot rows.
      var search = String(query.search || '').trim().toLowerCase();
      var fileType = query.file_type || '';
      var protectedIdentityDocuments = snapshotDocuments.concat(currentIdentityDocuments);
      var filteredProtectedIdentityDocuments = protectedIdentityDocuments.filter(function (doc) {
        if (fileType && fileType !== 'all' && doc.fileType !== fileType) return false;
        if (!search) return true;
        return [doc.fileName, doc.purchaserName, doc.snapshotLabel, doc.currentIdentityLabel].some(function (value) {
          return value && String(value).toLowerCase().includes(search);
        });
      });
      var data = sharedDocuments.concat(filteredProtectedIdentityDocuments);
      // CPI-1249: only Vietnam has rows of the generated types, so only its dropdown filters them.
      var typeFilterTypes = isVietnam ? _documentType.DOCUMENT_TYPE_LABELS : _documentType2.default;
      var filterOptions = [{ text: t('Type: All', { ns: _translation.TRANSLATION_FILES.translation }), value: 'all' }].concat(_toConsumableArray(typeFilterTypes.map(function (opt) {
        return _extends({}, opt, {
          text: t(opt.text, { ns: _translation.TRANSLATION_FILES.translation })
        });
      })));

      return _react2.default.createElement(
        'div',
        { style: { padding: '1rem' } },
        _react2.default.createElement(_AddSharedMedia2.default, {
          type: 'project',
          open: this.state.showAddMedia,
          onClose: this.handleCloseAddMedia,
          onSubmit: this.handleOnUpload,
          id: this.props.id,
          token: this.props.mediaToken,
          scrolling: true
        }),
        auth && auth.isHeadquarters && _react2.default.createElement(_DeleteConfirm2.default, {
          open: this.state.showConfirm,
          name: this.state.selectedDocument ? this.state.selectedDocument.fileName : '',
          onClose: this.handleCancelDelete,
          onConfirm: this.handleConfirmDelete
        }),
        _react2.default.createElement(_ViewLarge2.default, {
          open: this.state.showLarge,
          onClose: this.handleCloseLarge,
          picture: this.state.selectedMedia,
          src: this.state.selectedMedia ? this.state.selectedMedia.url : undefined
        }),
        _react2.default.createElement(
          'div',
          { className: 'document-header' },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _semanticUiReact.Header,
              { as: 'h2', className: 'header' },
              t('Document uploaded', { ns: _translation.TRANSLATION_FILES.screens })
            ),
            _react2.default.createElement(
              'span',
              { className: 'span' },
              data.length,
              ' ',
              t('found', { ns: _translation.TRANSLATION_FILES.screens })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { stackable: true, className: 'document-search-container' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 4 },
            _react2.default.createElement(_SearchFilter2.default, {
              isLoading: this.state.loading,
              onChange: this.handleFilterOnChange,
              onClose: this.handleClearFilter,
              search: query.search || '',
              placeholder: t('Search document', { ns: _translation.TRANSLATION_FILES.translation })
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 3 },
            _react2.default.createElement(_semanticUiReact.Select, {
              placeholder: t('Type: All', { ns: _translation.TRANSLATION_FILES.translation }),
              options: filterOptions,
              value: fileType || 'all',
              onChange: function onChange(e, _ref8) {
                var value = _ref8.value;
                return _this3.handleFilterOnChange(value, 'file_type');
              },
              fluid: true
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 2, floated: 'right' },
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                color: 'teal',
                fluid: true,
                onClick: this.handleShowAddMedia,
                className: 'document-upload-button'
              },
              _react2.default.createElement('img', { src: _upload2.default, className: 'document-upload-icon', alt: 'uploadIcon' }),
              t('Upload', { ns: _translation.TRANSLATION_FILES.screens })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          { basic: 'very', className: 'document-outline-table', loading: loading },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              { className: 'document-table-header' },
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Name', { ns: _translation.TRANSLATION_FILES.screens })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Date added', { ns: _translation.TRANSLATION_FILES.screens })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Type', { ns: _translation.TRANSLATION_FILES.screens })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Uploaded by', { ns: _translation.TRANSLATION_FILES.screens })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Shared by', { ns: _translation.TRANSLATION_FILES.screens })
              ),
              _react2.default.createElement(_semanticUiReact.Table.HeaderCell, { textAlign: 'right' })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            data.length > 0 ? data.map(function (doc, index) {
              return _react2.default.createElement(
                _semanticUiReact.Table.Row,
                { key: _this3.isProtectedIdentityDocument(doc) ? doc.id : doc.id || index },
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  _react2.default.createElement(
                    'div',
                    { className: 'document-name-row' },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: _this3.getFileIcon(doc.fileName), size: 'large', color: 'teal' }),
                    _react2.default.createElement(
                      'div',
                      { className: 'doc-name-container' },
                      _this3.isProtectedIdentityUnavailable(doc) ? _react2.default.createElement(
                        'span',
                        { className: 'doc-name' },
                        doc.fileName
                      ) : doc.fileName ? _react2.default.createElement(
                        'a',
                        {
                          className: 'doc-name',
                          href: _this3.isProtectedIdentityDocument(doc) ? _this3.protectedIdentityURL(doc) : _this3.getDocumentURL(doc),
                          target: '_blank',
                          rel: 'noopener noreferrer',
                          onClick: function onClick(e) {
                            return _this3.handleOpenDocument(e, doc);
                          }
                        },
                        doc.currentIdentityDocument && doc.currentIdentityLabel ? doc.fileName + ' \xB7 ' + doc.currentIdentityLabel : doc.fileName
                      ) : _react2.default.createElement(
                        'span',
                        { className: 'doc-name' },
                        'Untitled'
                      ),
                      doc.snapshotDocument && _react2.default.createElement(
                        'div',
                        { className: 'doc-context' },
                        doc.purchaserName,
                        ' ',
                        ' · ',
                        doc.snapshotLabel
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'doc-size' },
                        doc.currentIdentityDocument ? Number.isFinite(doc.fileSizeBytes) ? _this3.formatBytes(doc.fileSizeBytes) : '-' : _this3.isProtectedIdentityDocument(doc) ? '-' : _this3.formatBytes(doc.fileSizeBytes) || '1 MB'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  doc.createdAt ? _react2.default.createElement(_Timestamp2.default, { format: 'MMM D, YYYY [at] HH:mm', timestamp: doc.createdAt }) : '-'
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  _this3.renderFileType(doc.fileType)
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  doc.currentIdentityDocument ? doc.uploaderName || '-' : _this3.isProtectedIdentityDocument(doc) ? '-' : doc.uploaderName || 'System'
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  doc.currentIdentityDocument ? doc.shared_by || '-' : _this3.isProtectedIdentityDocument(doc) ? '-' : doc.shared_by || '-'
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { textAlign: 'right' },
                  !_this3.isProtectedIdentityUnavailable(doc) && _react2.default.createElement(
                    _semanticUiReact.Button,
                    { className: 'btn-icon-only', 'aria-label': 'Download', onClick: function onClick(e) {
                        return _this3.handleDownload(e, doc);
                      } },
                    _react2.default.createElement('img', { src: _download2.default, alt: 'download' })
                  ),
                  !_this3.isProtectedIdentityDocument(doc) && auth && auth.isHeadquarters && _react2.default.createElement(
                    _semanticUiReact.Button,
                    { className: 'btn-icon-only', 'aria-label': 'Delete', onClick: function onClick(e) {
                        return _this3.handleDelete(e, doc);
                      } },
                    _react2.default.createElement('img', { src: _delete2.default, alt: 'delete' })
                  )
                )
              );
            }) : _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: '6', textAlign: 'center', className: 'document-not-found' },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'search', size: 'large' }),
                _react2.default.createElement(
                  'p',
                  null,
                  t('No documents match your search', { ns: _translation.TRANSLATION_FILES.screens })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Documents;
}(_react.Component);

Documents.contextTypes = {
  store: _propTypes2.default.object
};
Documents.propTypes = {
  documentData: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    fileName: _propTypes2.default.string,
    fileType: _propTypes2.default.string,
    fileSizeBytes: _propTypes2.default.number,
    uploaderName: _propTypes2.default.string,
    createdAt: _propTypes2.default.string
  })),
  // A frozen CRM opportunity supplies read-only identity snapshot rows for Vietnam only.
  opportunity: _propTypes2.default.object,
  // Booking Documents supplies these current-purchaser rows; standalone Opportunity Documents
  // continues to use the frozen opportunity snapshot path.
  currentIdentityMode: _propTypes2.default.bool,
  currentIdentityDocuments: _propTypes2.default.arrayOf(_propTypes2.default.object),
  currentIdentityBookingID: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  // CPI-1249: shared with the Sales Overview Documents tab, which files against another parent.
  parentType: _propTypes2.default.string,
  parentID: _propTypes2.default.string,
  mediaToken: _propTypes2.default.string,
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  fetchDocument: _propTypes2.default.func,
  t: _propTypes2.default.func
};
Documents.defaultProps = {
  parentType: 'opportunity'
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(Documents);

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _semanticUiReact = __webpack_require__(2);

var _moment = __webpack_require__(12);

var _moment2 = _interopRequireDefault(_moment);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _reactRedux = __webpack_require__(9);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _translation = __webpack_require__(4);

var _displayTime = __webpack_require__(156);

var _opportunityStatuses = __webpack_require__(195);

var _bankStatesAndOppStage = __webpack_require__(2215);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TimelineLog = function (_Component) {
  _inherits(TimelineLog, _Component);

  function TimelineLog() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TimelineLog);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TimelineLog.__proto__ || Object.getPrototypeOf(TimelineLog)).call.apply(_ref, [this].concat(args))), _this), _this.getBookingDisplayStatus = function (statusKey) {
      if (!statusKey) return '';
      var cleanKey = String(statusKey).toLowerCase();
      var statusObj = _opportunityStatuses.SINGLE_STATUS_MAP[cleanKey];
      var readableText = statusObj ? statusObj.text : statusKey;
      return _this.props.t(readableText, { ns: _translation.TRANSLATION_FILES.constants });
    }, _this.getLoanDisplayStatus = function (statusKey) {
      if (!statusKey) return '';
      var cleanKey = String(statusKey).toLowerCase();
      var statusObj = _bankStatesAndOppStage.BANK_STATUS_MAP[cleanKey];
      var readableText = statusObj ? statusObj.text : statusKey;
      return _this.props.t(readableText, { ns: _translation.TRANSLATION_FILES.constants });
    }, _this.getCapitalizedStatus = function (status) {
      if (!status) return '';
      return status.charAt(0).toUpperCase() + status.slice(1).toLowerCase();
    }, _this.getEventTitle = function (log) {
      var source_table = log.source_table,
          source_type = log.source_type;

      switch (source_table) {
        case 'unit_resv_tokens':
        case 'ur_token_payments':
          return 'Payment details updated';
        case 'opportunities':
          // The booking timeline tracks status only — stage is not surfaced. The
          // create event marks the booking's creation; surface it as "Booking
          // created" (mirror leads-v2-web), while later changes read as "Booking
          // status updated".
          return source_type === 'create' ? 'Booking created' : 'Booking status updated';
        case 'bank_cases':
          return source_type === 'create' ? 'Loan created' : 'Loan status updated';
        case 'bank_case_activities':
          return 'Loan status updated';
        case 'lead_activities':
        case 'leads':
          return 'Lead status updated';
        case 'shared_notes':
          return 'Note is added';
        default:
          return 'System updated details';
      }
    }, _this.getLogMessageContent = function (log) {
      switch (log.source_table) {
        case 'unit_resv_tokens':
          return _this.renderTokenAmountPaidLog(log);
        case 'ur_token_payments':
          return _this.renderTokenPaidLog(log);
        case 'opportunities':
          return _this.renderOpportunityStatus(log);
        case 'bank_cases':
          return _this.renderLoanStatus(log);
        case 'shared_notes':
          return _this.renderSharedNote(log);
        default:
          // Banker activity tables (lead_activities, bank_case_activities, leads)
          // and any other source without a custom renderer fall back to the
          // human-readable source_message, so the feed mirrors leads-v2-web
          // instead of silently dropping them.
          return _this.renderGenericMessage(log);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TimelineLog, [{
    key: 'renderTokenAmountPaidLog',
    value: function renderTokenAmountPaidLog(log) {
      var t = this.props.t;

      var before = log.data_before || {};
      var after = log.data_after || {};
      var elements = [];

      if (after.amount_minor_paid !== undefined && before.amount_minor_paid !== after.amount_minor_paid) {
        var currency = after.currency_code || before.currency_code || 'VND';

        var hasValidBefore = before.amount_minor_paid !== undefined && before.amount_minor_paid !== null;
        var displayString = hasValidBefore ? currency + ' ' + before.amount_minor_paid + ' \u2192 ' + currency + ' ' + after.amount_minor_paid : currency + ' ' + after.amount_minor_paid;

        elements.push(_react2.default.createElement(
          'div',
          { key: 'payment-amount', className: 'timeline-diff-line' },
          _react2.default.createElement(
            'strong',
            null,
            t('Total Payment'),
            ':'
          ),
          ' ',
          displayString
        ));
      }

      return elements.length > 0 ? _react2.default.createElement(
        'div',
        null,
        elements
      ) : null;
    }
  }, {
    key: 'renderTokenPaidLog',
    value: function renderTokenPaidLog(log) {
      var t = this.props.t;

      var before = log.data_before || {};
      var after = log.data_after || {};
      var elements = [];

      if (after.status !== undefined && before.status !== after.status) {
        elements.push(_react2.default.createElement(
          'div',
          { key: 'payment-status', className: 'timeline-diff-line' },
          _react2.default.createElement(
            'strong',
            null,
            t('Payment status'),
            ':'
          ),
          ' ',
          before.status ? t(this.getCapitalizedStatus(before.status), { ns: _translation.TRANSLATION_FILES.constants }) + ' \u2192 ' : '',
          t(this.getCapitalizedStatus(after.status), { ns: _translation.TRANSLATION_FILES.constants })
        ));
      }

      if (after.amount_minor !== undefined && before.amount_minor !== after.amount_minor) {
        var currency = after.currency_code || before.currency_code || 'VND';

        var hasValidBefore = before.amount_minor !== undefined && before.amount_minor !== null;
        var displayString = hasValidBefore ? currency + ' ' + before.amount_minor + ' \u2192 ' + currency + ' ' + after.amount_minor : currency + ' ' + after.amount_minor;

        elements.push(_react2.default.createElement(
          'div',
          { key: 'payment-amount', className: 'timeline-diff-line' },
          _react2.default.createElement(
            'strong',
            null,
            t('Payment Made'),
            ':'
          ),
          ' ',
          displayString
        ));
      }

      return elements.length > 0 ? _react2.default.createElement(
        'div',
        null,
        elements
      ) : null;
    }
  }, {
    key: 'renderOpportunityStatus',
    value: function renderOpportunityStatus(log) {
      var t = this.props.t;

      var before = log.data_before || {};
      var after = log.data_after || {};
      var elements = [];

      // Status changes only — stage is intentionally omitted from the timeline.
      // An opportunity log with no status change renders nothing and is skipped.
      if (after.sr_status !== undefined && before.sr_status !== after.sr_status) {
        elements.push(_react2.default.createElement(
          'div',
          { key: 'booking-status', className: 'timeline-diff-line' },
          _react2.default.createElement(
            'strong',
            null,
            t('Booking Status'),
            ':'
          ),
          ' ',
          before.sr_status ? this.getBookingDisplayStatus(before.sr_status) + ' \u2192 ' : '',
          this.getBookingDisplayStatus(after.sr_status)
        ));
      }

      return elements.length > 0 ? _react2.default.createElement(
        'div',
        null,
        elements
      ) : null;
    }
  }, {
    key: 'renderLoanStatus',
    value: function renderLoanStatus(log) {
      var before = log.data_before || {};
      var after = log.data_after || {};
      var meta = log.source_metadata || {};

      // Pre-formatted bank details string resolved by mhub-log-api
      // (bank · branch · package · amount). Empty when not a bank-case log.
      var loanSubtitle = meta.bank_details || '';

      if (log.source_type === 'create') {
        if (!loanSubtitle) return null;
        return _react2.default.createElement(
          'div',
          { style: { color: '#adb5bd', fontSize: '12px', marginTop: '2px' } },
          loanSubtitle
        );
      }

      if (after.status !== undefined && before.status !== after.status) {
        var beforeStatusText = this.getLoanDisplayStatus(before.status) || before.status;
        var afterStatusText = this.getLoanDisplayStatus(after.status) || after.status;

        return _react2.default.createElement(
          'div',
          { className: 'timeline-diff-line' },
          _react2.default.createElement(
            'div',
            null,
            before.status ? beforeStatusText + ' \u2192 ' : '',
            _react2.default.createElement(
              'strong',
              null,
              afterStatusText
            )
          ),
          loanSubtitle && _react2.default.createElement(
            'div',
            { style: { color: '#adb5bd', fontSize: '12px', marginTop: '2px' } },
            loanSubtitle
          )
        );
      }

      return null;
    }
  }, {
    key: 'renderSharedNote',
    value: function renderSharedNote(log) {
      var after = log.data_after || {};
      if (after.note) {
        var decodedNote = decodeURIComponent(after.note);
        return _react2.default.createElement(
          'div',
          { className: 'timeline-diff-line' },
          '\u201C',
          decodedNote,
          '\u201D'
        );
      }
      return null;
    }

    // Fallback for sources without a custom renderer: show the API's
    // human-readable source_message. Null (skipped) when there's no message.

  }, {
    key: 'renderGenericMessage',
    value: function renderGenericMessage(log) {
      if (!log.source_message) return null;
      return _react2.default.createElement(
        'div',
        { className: 'timeline-diff-line' },
        log.source_message
      );
    }
  }, {
    key: 'getUserName',
    value: function getUserName(log) {
      var actor = log.actor;
      var actorName = actor && (typeof actor === 'string' ? actor : actor.name);
      var metadata = log.source_metadata || {};

      return actorName || log.actor_name || metadata.mu_name || 'System';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          _props$activityLog = _props.activityLog,
          activityLog = _props$activityLog === undefined ? [] : _props$activityLog,
          isFullWidth = _props.isFullWidth,
          hasMore = _props.hasMore,
          onLoadMore = _props.onLoadMore,
          isLoadingMore = _props.isLoadingMore,
          countryCode = _props.countryCode;

      var containerClasses = 'showroom-timeline-container ' + (isFullWidth ? 'full-width-timeline' : '');

      if (activityLog.length === 0) {
        return _react2.default.createElement(
          _semanticUiReact.Segment,
          { basic: true, className: containerClasses },
          _react2.default.createElement(
            'div',
            { className: 'no-activity-placeholder' },
            t('No activity yet')
          )
        );
      }

      var lastRenderedDate = null;
      var sortedLog = [].concat(_toConsumableArray(activityLog)).sort(function (a, b) {
        return (0, _moment2.default)(b.source_updated_at).valueOf() - (0, _moment2.default)(a.source_updated_at).valueOf();
      });

      return _react2.default.createElement(
        _semanticUiReact.Segment,
        { basic: true, className: containerClasses },
        _react2.default.createElement(
          _semanticUiReact.Feed,
          { className: 'custom-timeline-feed' },
          sortedLog.map(function (log) {
            var userName = _this2.getUserName(log);
            var timestamp = (0, _displayTime.displayMoment)(log.source_updated_at, countryCode).format('h:mm a');
            var logContent = _this2.getLogMessageContent(log);

            if (!logContent) return null;

            // Same zone as `timestamp` above: the day header groups the events shown beneath it,
            // so reading the two in different zones would file an event under the wrong heading.
            var currentDateLabel = (0, _displayTime.displayMoment)(log.source_updated_at, countryCode).format('ddd, MMM D, YYYY').toUpperCase();
            var showDateHeader = currentDateLabel !== lastRenderedDate;

            if (showDateHeader) {
              lastRenderedDate = currentDateLabel;
            }

            return _react2.default.createElement(
              _react2.default.Fragment,
              { key: log.id },
              showDateHeader && _react2.default.createElement(
                'div',
                { className: 'timeline-day-header' },
                currentDateLabel
              ),
              _react2.default.createElement(
                _semanticUiReact.Feed.Event,
                { className: 'timeline-event-row' },
                _react2.default.createElement(
                  'div',
                  { className: 'timeline-node-container' },
                  _react2.default.createElement('span', { className: 'timeline-circle-node' })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Feed.Content,
                  { className: 'timeline-body-content' },
                  _react2.default.createElement(
                    _semanticUiReact.Feed.Summary,
                    { className: 'timeline-header-title' },
                    t(_this2.getEventTitle(log))
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Feed.Extra,
                    { text: true, className: 'timeline-changes-wrapper' },
                    logContent
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Feed.Meta,
                    { className: 'timeline-footer-meta' },
                    timestamp,
                    ' \u2022 ',
                    userName
                  )
                )
              )
            );
          })
        ),
        hasMore && _react2.default.createElement(
          'div',
          { style: { textAlign: 'center', marginTop: '1.5rem' } },
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              basic: true,
              compact: true,
              size: 'small',
              loading: isLoadingMore,
              disabled: isLoadingMore,
              onClick: onLoadMore
            },
            t('Load more activity')
          )
        )
      );
    }
  }]);

  return TimelineLog;
}(_react.Component);

TimelineLog.propTypes = {
  t: _propTypes2.default.func.isRequired,
  activityLog: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  isFullWidth: _propTypes2.default.bool,
  hasMore: _propTypes2.default.bool,
  onLoadMore: _propTypes2.default.func,
  isLoadingMore: _propTypes2.default.bool,
  countryCode: _propTypes2.default.string
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.translation)((0, _reactRedux.connect)(function (state) {
  return {
    countryCode: state.auth && state.auth.company && state.auth.company.countryCode
  };
})(TimelineLog));

/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _reactRedux = __webpack_require__(9);

var _semanticUiReact = __webpack_require__(2);

var _fetchM = __webpack_require__(6);

var _tags = __webpack_require__(555);

var _pictureTypes = __webpack_require__(392);

var _pictureTypes2 = _interopRequireDefault(_pictureTypes);

var _EditImage = __webpack_require__(560);

var _EditImage2 = _interopRequireDefault(_EditImage);

var _strings = __webpack_require__(118);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UploadPictureForm = function (_Component) {
  _inherits(UploadPictureForm, _Component);

  function UploadPictureForm(props) {
    _classCallCheck(this, UploadPictureForm);

    var _this = _possibleConstructorReturn(this, (UploadPictureForm.__proto__ || Object.getPrototypeOf(UploadPictureForm)).call(this, props));

    _initialiseProps.call(_this);

    var options = props.tags ? [].concat(props.tags).map(function (t) {
      return {
        value: t.name,
        text: t.name
      };
    }) : [];
    _this.state = {
      loading: false,
      uploads: [],
      pictureTags: [],
      pictureTypes: [],
      pictureLabels: [],
      degrees: [],
      options: options,
      fileSizeError: null
    };
    return _this;
  }

  _createClass(UploadPictureForm, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;

      store.dispatch((0, _tags.fetchTags)('picture', true));
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'submit',
    value: function submit(url) {
      var _this3 = this;

      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var store = this.context.store;

      return this.setLoading(true).then(function () {
        return store.dispatch((0, _fetchM.fetchM)(url, opts));
      }).then(function (res) {
        return res.json();
      }).then(function (result) {
        return _this3.setLoading(false).then(function () {
          return _this3.resetFiles();
        }).then(function () {
          return result;
        });
      }).catch(function (err) {
        return _this3.setLoading(false).then(function () {
          return _this3.resetFiles();
        }).then(function () {
          return Promise.reject(err);
        });
      });
    }
  }, {
    key: 'resetFiles',
    value: function resetFiles() {
      // temporary fix for upload modal not closing
      this.setState({
        uploads: [],
        pictureTags: [],
        pictureTypes: [],
        pictureLabels: [],
        degrees: []
      });
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      var _this4 = this;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true }, function () {
          if (_this4.props.onChange) {
            _this4.props.onChange(true);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        'form',
        {
          encType: 'multipart/form-data',
          onSubmit: this.handleSubmit,
          name: 'uploadPictures',
          ref: function ref(_ref5) {
            _this5.form = _ref5;
          }
        },
        _react2.default.createElement('input', {
          ref: function ref(_ref) {
            _this5.uploadFiles = _ref;
          },
          type: 'file',
          onChange: this.handleOnChange,
          accept: 'image/gif, image/jpeg, image/png',
          multiple: true,
          style: { display: 'none' }
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 'equal' },
            _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'computer' }),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { verticalAlign: 'middle', columns: 'equal' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Button, {
                    fluid: true,
                    compact: true,
                    primary: true,
                    icon: 'add',
                    content: t('Images', { ns: _translation.TRANSLATION_FILES.translation }),
                    onClick: this.handleAddFile,
                    disabled: this.state.loading
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Button, {
                    fluid: true,
                    compact: true,
                    type: 'submit',
                    positive: true,
                    content: t('Upload', { ns: _translation.TRANSLATION_FILES.translation }), icon: 'cloud upload',
                    loading: this.state.loading,
                    disabled: this.state.uploads.length < 1 || this.state.loading
                  })
                )
              )
            )
          )
        ),
        this.state.fileSizeError && _react2.default.createElement(
          _semanticUiReact.Message,
          { negative: true },
          _react2.default.createElement(
            _semanticUiReact.Message.Header,
            null,
            t('File Size Error', { ns: _translation.TRANSLATION_FILES.translation })
          ),
          _react2.default.createElement(
            'p',
            null,
            this.state.fileSizeError
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { stackable: true, doubling: true, columns: 2 },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { indeterminate: true, inline: 'centered' },
              t('Uploading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          this.state.uploads.length > 0 ? this.state.uploads.map(function (upload, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { key: idx },
              _react2.default.createElement(
                _semanticUiReact.Segment.Group,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { secondary: true },
                  _react2.default.createElement(_EditImage2.default, {
                    src: upload.src,
                    degree: _this5.state.degrees[idx] || 0
                  }),
                  _react2.default.createElement(_semanticUiReact.Label, {
                    as: 'a',
                    corner: true,
                    color: 'red',
                    icon: 'delete',
                    disabled: _this5.state.loading,
                    onClick: function onClick(e) {
                      return _this5.handleRemove(e, idx);
                    }
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { padded: true },
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { columns: 1 },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      null,
                      _react2.default.createElement(_semanticUiReact.Label, {
                        as: 'a',
                        attached: 'top left',
                        icon: { name: 'repeat', flipped: 'horizontally' },
                        disabled: _this5.state.loading,
                        onClick: function onClick() {
                          return _this5.handleRotate('left', idx);
                        }
                      }),
                      _react2.default.createElement(_semanticUiReact.Label, {
                        as: 'a',
                        attached: 'top right',
                        icon: 'repeat',
                        disabled: _this5.state.loading,
                        onClick: function onClick() {
                          return _this5.handleRotate('right', idx);
                        }
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      null,
                      _react2.default.createElement(_semanticUiReact.Input, {
                        fluid: true,
                        placeholder: 'Label',
                        type: 'text',
                        value: _this5.state.pictureLabels[idx],
                        disabled: _this5.state.loading,
                        onChange: function onChange(e, _ref2) {
                          var value = _ref2.value;
                          return _this5.handleLabelChange(e, value, idx);
                        }
                      }),
                      _react2.default.createElement(_semanticUiReact.Dropdown, {
                        options: _pictureTypes2.default.map(function (status) {
                          return _extends({}, status, {
                            text: t(status.text, { ns: _translation.TRANSLATION_FILES.screens })
                          });
                        }),
                        placeholder: t('Type', { ns: _translation.TRANSLATION_FILES.screens }),
                        search: true,
                        selection: true,
                        fluid: true,
                        value: _this5.state.pictureTypes[idx] || _pictureTypes2.default[0].value,
                        disabled: _this5.state.loading,
                        onChange: function onChange(e, _ref3) {
                          var value = _ref3.value;
                          return _this5.handleTypeChange(e, value, idx);
                        }
                      }),
                      _react2.default.createElement(_semanticUiReact.Dropdown, {
                        options: _this5.state.options,
                        placeholder: t('Add tags', { ns: _translation.TRANSLATION_FILES.translation }),
                        search: true,
                        selection: true,
                        fluid: true,
                        multiple: true,
                        allowAdditions: true,
                        noResultsMessage: t('Add tags', { ns: _translation.TRANSLATION_FILES.translation }),
                        value: _this5.state.pictureTags[idx],
                        onAddItem: _this5.handleAddition,
                        disabled: _this5.state.loading,
                        onChange: function onChange(e, _ref4) {
                          var value = _ref4.value;
                          return _this5.handleTagsChange(e, value, idx);
                        }
                      })
                    )
                  )
                )
              )
            );
          }) : null
        )
      );
    }
  }]);

  return UploadPictureForm;
}(_react.Component);

UploadPictureForm.propTypes = {
  onSubmit: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  tags: _propTypes2.default.arrayOf(_propTypes2.default.object),
  t: _propTypes2.default.func
};
UploadPictureForm.contextTypes = {
  store: _propTypes2.default.object
};

UploadPictureForm.mapStateToProps = function (state) {
  return {
    tags: state.tags.data.picture
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.handleSubmit = function (event) {
    event.preventDefault();
    if (_this6.state.uploads.length > 0) {
      var formData = new FormData(_this6.form);
      _this6.state.uploads.forEach(function (upload, idx) {
        formData.append('files_' + idx, upload.file);
        formData.append('tags_' + idx, _this6.state.pictureTags[idx]);
        formData.append('labels_' + idx, _this6.state.pictureLabels[idx]);
        formData.append('types_' + idx, _this6.state.pictureTypes[idx] || _pictureTypes2.default[0].value);
        formData.append('degrees_' + idx, _this6.state.degrees[idx] || 0);
      });
      if (_this6.props.onSubmit) {
        _this6.props.onSubmit(event, formData);
      }
    }
  };

  this.handleOnChange = function () {
    var files = Array.prototype.slice.call(_this6.uploadFiles.files);
    _this6.uploadFiles.value = null;
    _this6.setState({ fileSizeError: null });
    if (window.FileReader) {
      var maxSizeInBytes = 10 * 1024 * 1024; // 10MB in bytes
      var validFiles = [];
      var invalidFiles = [];
      files.forEach(function (file) {
        if (file.size > maxSizeInBytes) {
          invalidFiles.push(file.name);
        } else {
          validFiles.push(file);
        }
      });

      if (invalidFiles.length > 0) {
        _this6.setState({
          fileSizeError: 'The following files exceed the 10MB size limit and will not be uploaded: ' + invalidFiles.join(', ') + '. Please reduce the file size and try again.'
        });
      }
      validFiles.forEach(function (file) {
        var reader = new FileReader();
        reader.onloadend = function () {
          var _state = _this6.state,
              uploads = _state.uploads,
              pictureTags = _state.pictureTags,
              pictureLabels = _state.pictureLabels;

          var name = file.name.substring(0, file.name.length - 4);
          uploads.push({
            file: file,
            name: name,
            src: reader.result
          });
          pictureTags.push([]);
          var label = (0, _strings.titleCase)((0, _strings.symbolToSpace)(name));
          pictureLabels.push(label);
          _this6.setState({
            uploads: uploads,
            pictureTags: pictureTags,
            pictureLabels: pictureLabels
          }, function () {
            _this6.handleCheckChanges();
          });
        };
        reader.readAsDataURL(file);
      });
    }
  };

  this.handleRemove = function (event, idx) {
    event.preventDefault();
    var _state2 = _this6.state,
        uploads = _state2.uploads,
        degrees = _state2.degrees,
        pictureTags = _state2.pictureTags,
        pictureTypes = _state2.pictureTypes,
        pictureLabels = _state2.pictureLabels;

    uploads.splice(idx, 1);
    degrees.splice(idx, 1);
    pictureTags.splice(idx, 1);
    pictureLabels.splice(idx, 1);
    pictureTypes.splice(idx, 1);
    _this6.setState({ uploads: uploads, degrees: degrees, pictureTags: pictureTags, pictureTypes: pictureTypes, pictureLabels: pictureLabels });
  };

  this.handleAddFile = function (event) {
    event.preventDefault();
    _this6.uploadFiles.click();
  };

  this.handleTagsChange = function (e, value, idx) {
    var pictureTags = _this6.state.pictureTags;

    pictureTags[idx] = value;
    _this6.setState({ pictureTags: pictureTags });
  };

  this.handleTypeChange = function (e, value, idx) {
    var pictureTypes = _this6.state.pictureTypes;

    pictureTypes[idx] = value;
    _this6.setState({ pictureTypes: pictureTypes });
  };

  this.handleLabelChange = function (e, value, idx) {
    var pictureLabels = _this6.state.pictureLabels;

    var newValue = value.replace(/[\\~#%&*{}/:<>?|"]/, '');
    pictureLabels[idx] = newValue;
    _this6.setState({ pictureLabels: pictureLabels });
  };

  this.handleAddition = function (e, _ref6) {
    var value = _ref6.value;
    var options = _this6.state.options;

    if (!options.some(function (o) {
      return o.value === value;
    })) {
      _this6.setState({
        options: [{ text: value, value: value }].concat(_toConsumableArray(options))
      });
    }
  };

  this.handleRotate = function (direction, idx) {
    var degrees = _this6.state.degrees;

    if (!degrees[idx]) {
      degrees[idx] = 0;
    }
    var increment = direction === 'right' ? 1 : -1;
    degrees[idx] += 90 * increment;
    if (degrees[idx] >= 360) {
      degrees[idx] = 0;
    }
    if (degrees[idx] < 0) {
      degrees[idx] = 270;
    }
    _this6.setState({ degrees: degrees });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })((0, _reactRedux.connect)(UploadPictureForm.mapStateToProps, null, null, { withRef: true })(UploadPictureForm));

/***/ }),
/* 1061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _webValidations = __webpack_require__(23);

var _reactRedux = __webpack_require__(9);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _SpecificationTable = __webpack_require__(127);

var _SpecificationTable2 = _interopRequireDefault(_SpecificationTable);

var _translation = __webpack_require__(4);

var _translation2 = __webpack_require__(64);

var _areaLabel = __webpack_require__(223);

var _unitLayout = __webpack_require__(270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitLayoutForm = function (_Component) {
  _inherits(UnitLayoutForm, _Component);

  function UnitLayoutForm(props) {
    _classCallCheck(this, UnitLayoutForm);

    var _this = _possibleConstructorReturn(this, (UnitLayoutForm.__proto__ || Object.getPrototypeOf(UnitLayoutForm)).call(this, props));

    _initialiseProps.call(_this);

    var unitLayout = Object.assign({}, _this.defaultValues(), props.unitLayout || {});
    var currentTab = _this.tabs[0].name;
    if (props.location && props.location.hash.length > 0) {
      currentTab = props.location.hash.replace('#', '');
    }
    var menuIsTab = window.innerWidth < 425;
    var menuIsVertical = window.innerWidth >= 768;
    _this.state = {
      unitLayout: unitLayout,
      oriUnitLayout: (0, _clone2.default)(unitLayout),
      errMessages: [],
      currentTab: currentTab,
      menuIsTab: menuIsTab,
      menuIsVertical: menuIsVertical,
      pictures: [],
      loadingPictures: false
    };
    _this.validation = {
      name: (0, _react.createRef)(),
      virtualTourURL: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(UnitLayoutForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
      if (this.props.projectID && this.isVietnam()) {
        this.fetchProjectPictures();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var unitLayout = Object.assign({}, this.defaultValues(), this.state.unitLayout);
      var oriUnitLayout = this.state.oriUnitLayout;
      if (JSON.stringify(this.props.unitLayout) !== JSON.stringify(nextProps.unitLayout)) {
        unitLayout = Object.assign(unitLayout, nextProps.unitLayout);
        oriUnitLayout = (0, _clone2.default)(unitLayout);
      }
      var currentTab = this.state.currentTab;
      if (nextProps.location && nextProps.location.hash.length > 0) {
        currentTab = nextProps.location.hash.replace('#', '');
      }
      this.setState({
        unitLayout: unitLayout,
        oriUnitLayout: oriUnitLayout,
        currentTab: currentTab
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'isVietnam',
    value: function isVietnam() {
      var company = this.props.auth && this.props.auth.company || {};
      return (0, _areaLabel.isVietnamCountryCode)(company.countryCode);
    }
    // CPI-1208: the six Vietnam-only fields are merged in only for a Vietnamese company.

  }, {
    key: 'defaultValues',
    value: function defaultValues() {
      return this.isVietnam() ? Object.assign({}, UnitLayoutForm.defaultValues, _unitLayout.VN_LAYOUT_DEFAULT_VALUES) : UnitLayoutForm.defaultValues;
    }
  }, {
    key: 'fetchProjectPictures',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, query, res, message, pictures;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                query = { types: ['unit_layout'], limit: 0 };

                this.setState({ loadingPictures: true });
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.projectID + '/pictures/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 17;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                this.setState({ loadingPictures: false });
                return _context.abrupt('return');

              case 17:
                if (res.ok) {
                  _context.next = 25;
                  break;
                }

                _context.next = 20;
                return res.text();

              case 20:
                message = _context.sent;
                _context.next = 23;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 23:
                this.setState({ loadingPictures: false });
                return _context.abrupt('return');

              case 25:
                _context.next = 27;
                return res.json();

              case 27:
                pictures = _context.sent;

                this.setState({
                  loadingPictures: false,
                  pictures: pictures ? pictures.map(function (picture) {
                    return {
                      key: picture.id,
                      text: picture.label && picture.label.trim().length > 0 ? picture.label : picture.id,
                      value: picture.id
                    };
                  }) : []
                });

              case 29:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchProjectPictures() {
        return _ref.apply(this, arguments);
      }

      return fetchProjectPictures;
    }()
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'checkActiveTab',
    value: function checkActiveTab(name) {
      return this.state.currentTab === name ? '' : 'hidden';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      var isVietnam = this.isVietnam();
      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref2) {
            _this2.form = _ref2;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 4 },
              _react2.default.createElement(
                _semanticUiReact.Menu,
                {
                  fluid: true,
                  widths: this.state.menuIsTab ? 1 : null,
                  tabular: !this.state.menuIsTab,
                  vertical: this.state.menuIsVertical
                },
                this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
                  item: true,
                  selectOnBlur: false,
                  options: this.tabs.map(function (tab) {
                    return {
                      text: t(tab.text),
                      name: tab.name,
                      value: tab.value,
                      label: _this2.state.errMessages.some(function (e) {
                        return tab.fields.some(function (f) {
                          return e.key === f;
                        });
                      }) ? {
                        color: 'red',
                        content: '!'
                      } : null
                    };
                  }),
                  onChange: this.handleChangeTab,
                  value: this.state.currentTab,
                  disabled: this.props.loading
                }) : this.tabs.map(function (tab, key) {
                  return _react2.default.createElement(
                    _semanticUiReact.Menu.Item,
                    {
                      key: key,
                      name: tab.name,
                      onClick: _this2.handleChangeTab,
                      active: _this2.state.currentTab === tab.name
                    },
                    t(tab.text),
                    _this2.state.errMessages.some(function (e) {
                      return tab.fields.some(function (f) {
                        return e.key === f;
                      });
                    }) ? _react2.default.createElement(_semanticUiReact.Label, { color: 'red', floating: !_this2.state.menuIsVertical, content: '!' }) : null
                  );
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('info') },
              _react2.default.createElement(_AppForm2.default.Input, {
                label: (0, _translation2.translateModels)(t, 'name', 'projectUnitLayout'),
                name: 'name',
                value: this.state.unitLayout.name,
                onChange: this.handleInputChange,
                ref: this.validation.name,
                validation: [_webValidations.required]
              }),
              isVietnam ? _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: (0, _translation2.translateModels)(t, 'block', 'projectUnitLayout'),
                  name: 'block',
                  value: this.state.unitLayout.block,
                  onChange: this.handleInputChange
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: (0, _translation2.translateModels)(t, 'direction', 'projectUnitLayout'),
                  name: 'direction',
                  value: this.state.unitLayout.direction,
                  onChange: this.handleInputChange
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: (0, _translation2.translateModels)(t, 'view', 'projectUnitLayout'),
                  name: 'view',
                  value: this.state.unitLayout.view,
                  onChange: this.handleInputChange
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: (0, _translation2.translateModels)(t, 'floor', 'projectUnitLayout'),
                  name: 'floor',
                  value: this.state.unitLayout.floor,
                  onChange: this.handleInputChange
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: (0, _translation2.translateModels)(t, 'nfa', 'projectUnitLayout'),
                  type: 'number',
                  step: '0.0001',
                  name: 'nfa',
                  value: this.state.unitLayout.nfa,
                  onChange: this.handleInputChange
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: (0, _translation2.translateModels)(t, 'nsa', 'projectUnitLayout'),
                  type: 'number',
                  step: '0.0001',
                  name: 'nsa',
                  value: this.state.unitLayout.nsa,
                  onChange: this.handleInputChange
                })
              ) : _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: (0, _translation2.translateModels)(t, 'size', 'projectUnitLayout'),
                  type: 'number',
                  step: '0.0001',
                  name: 'size',
                  value: this.state.unitLayout.size,
                  onChange: this.handleInputChange
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: (0, _translation2.translateModels)(t, 'landArea', 'projectUnitLayout'),
                  type: 'number',
                  step: '0.0001',
                  name: 'landArea',
                  value: this.state.unitLayout.landArea,
                  onChange: this.handleInputChange
                })
              ),
              _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                label: (0, _translation2.translateModels)(t, 'overview', 'projectUnitLayout'),
                name: 'overview',
                value: this.state.unitLayout.overview,
                onChange: this.handleInputChange
              }),
              isVietnam && _react2.default.createElement(_semanticUiReact.Form.Select, {
                label: (0, _translation2.translateModels)(t, 'pictureID', 'projectUnitLayout'),
                name: 'pictureID',
                search: true,
                fluid: true,
                clearable: true,
                selectOnBlur: false,
                placeholder: t('Select picture', { ns: _translation.TRANSLATION_FILES.screens }),
                value: this.state.unitLayout.pictureID || '',
                options: this.state.pictures,
                loading: this.state.loadingPictures,
                onChange: this.handleInputChange
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('specifications') },
              _react2.default.createElement(_SpecificationTable2.default, {
                type: 'unit_layouts',
                editable: true,
                isEditing: true,
                hideButton: true,
                data: this.state.unitLayout.specifications,
                onChange: this.handleSpecificationsChange,
                loading: this.props.loading
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('virtual_tour') },
              _react2.default.createElement(_AppForm2.default.Input, {
                label: 'URL',
                name: 'virtualTourURL',
                value: this.state.unitLayout.virtualTourURL,
                onChange: this.handleInputChange,
                ref: this.validation.virtualTourURL
              })
            )
          )
        )
      );
    }
  }]);

  return UnitLayoutForm;
}(_react.Component);

UnitLayoutForm.contextTypes = {
  store: _propTypes2.default.object
};
UnitLayoutForm.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  projectID: _propTypes2.default.string,
  onChange: _propTypes2.default.func,
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  unitLayout: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    hash: _propTypes2.default.string
  }),
  loading: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
UnitLayoutForm.defaultValues = {
  projectID: '',
  name: '',
  size: 0,
  landArea: 0,
  specifications: [],
  overview: '',
  pictureID: ''
};

UnitLayoutForm.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleResize = function () {
    var state = {};
    var menuIsTab = window.innerWidth < 425;
    if (menuIsTab !== _this3.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    var menuIsVertical = window.innerWidth >= 768;
    if (menuIsVertical !== _this3.state.menuIsVertical) {
      state.menuIsVertical = menuIsVertical;
    }
    _this3.setState(_extends({}, state));
  };

  this.handleSubmit = function (event) {
    event.preventDefault();
    var unitLayout = _this3.state.unitLayout;

    if (unitLayout.specifications) {
      unitLayout.specifications = unitLayout.specifications.filter(function (data) {
        return data.name.length > 0 && data.value.length > 0;
      }).map(function (data, idx) {
        return _extends({}, data, {
          position: idx + 1
        });
      });
    }
    _AppForm2.default.validate(_this3.validation, unitLayout).then(function (validations) {
      _this3.setState({
        errMessages: validations.filter(function (v) {
          return !v.isValid;
        })
      });
      var data = (0, _unitLayout.parseLayoutFormValues)(unitLayout, _this3.isVietnam());
      _this3.props.onSubmit(validations, data);
    });
  };

  this.handleInputChange = function (event, data) {
    var unitLayout = _this3.state.unitLayout;

    unitLayout[data.name] = data.value;
    _this3.setState({ unitLayout: unitLayout }, function () {
      _this3.handleCheckChanges();
    });
  };

  this.handleSpecificationsChange = function (data) {
    var unitLayout = _this3.state.unitLayout;

    unitLayout.specifications = data;
    _this3.setState({ unitLayout: unitLayout }, function () {
      _this3.handleCheckChanges();
    });
  };

  this.tabs = [{
    name: 'info',
    value: 'info',
    text: 'Info',
    fields: ['name']
  }, {
    name: 'specifications',
    value: 'specifications',
    text: 'Specifications',
    fields: []
  }, {
    name: 'virtual_tour',
    value: 'virtual_tour',
    text: 'Virtual Tour',
    fields: []
  }];

  this.handleChangeTab = function (e, _ref3) {
    var name = _ref3.name,
        value = _ref3.value;

    var currentTab = name || value;
    _this3.setState({ currentTab: currentTab });
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.projectUnitLayout]), { withRef: true })((0, _reactRedux.connect)(UnitLayoutForm.mapStateToProps, null, null, { withRef: true })(UnitLayoutForm));

/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _webValidations = __webpack_require__(23);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _TextArea = __webpack_require__(383);

var _TextArea2 = _interopRequireDefault(_TextArea);

var _SpecificationTable = __webpack_require__(127);

var _SpecificationTable2 = _interopRequireDefault(_SpecificationTable);

var _amount = __webpack_require__(87);

var _propertyCategories = __webpack_require__(323);

var _storage = __webpack_require__(44);

var _translation = __webpack_require__(4);

var _areaLabel = __webpack_require__(223);

var _vietnam = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  eslint no-param-reassign: ["error", { "props": false }]*/

var UnitForm = function (_Component) {
  _inherits(UnitForm, _Component);

  function UnitForm(props) {
    _classCallCheck(this, UnitForm);

    var _this = _possibleConstructorReturn(this, (UnitForm.__proto__ || Object.getPrototypeOf(UnitForm)).call(this, props));

    _initialiseProps.call(_this);

    var unit = Object.assign({}, UnitForm.defaultValues, props.unit || {});
    if (props.location && props.location.query.unitLayoutID) {
      unit.projectUnitLayoutID = props.location.query.unitLayoutID;
    }
    var globalSettings = {};
    var storeGloablSettings = (0, _storage.getItem)(_config2.default.get('appName') + '.globalSettings');
    if (storeGloablSettings) {
      try {
        globalSettings = JSON.parse(storeGloablSettings).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }
    _this.state = {
      unit: unit,
      unitLayouts: [],
      errMessages: [],
      globalSettings: globalSettings
    };
    _this.validation = {
      reference: (0, _react.createRef)(),
      statusID: (0, _react.createRef)(),
      projectUnitLayoutID: (0, _react.createRef)(),
      size: (0, _react.createRef)(),
      landArea: (0, _react.createRef)(),
      unitLayoutNew: (0, _react.createRef)(),
      view: (0, _react.createRef)(),
      vatPercentage: (0, _react.createRef)(),
      landValue: (0, _react.createRef)(),
      spaValue: (0, _react.createRef)(),
      position: (0, _react.createRef)(),
      colSpan: (0, _react.createRef)(),
      zoneOrBlock: (0, _react.createRef)(),
      streetNumberOrLevel: (0, _react.createRef)(),
      streetOrFacing: (0, _react.createRef)(),
      virtualTourURL: (0, _react.createRef)(),
      companyBranchAllocationIDs: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(UnitForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchProjectUnitLayouts();
      this.fetchCompanyBranches();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var unit = Object.assign({}, UnitForm.defaultValues, this.state.unit);
      if (JSON.stringify(this.props.unit) !== JSON.stringify(nextProps.unit)) {
        unit = Object.assign(unit, nextProps.unit);
      }
      this.setState({ unit: unit });
    }
  }, {
    key: 'getAuth',
    value: function getAuth() {
      var store = this.context.store;

      return store && store.getState && store.getState().auth || null;
    }
    // The three gates this form reads, all false outside Vietnam.

  }, {
    key: 'getVietnamGates',
    value: function getVietnamGates() {
      var auth = this.getAuth();
      var isVietnam = (0, _vietnam.isVietnamCompany)(auth);
      return {
        isVietnam: isVietnam,
        countryCode: auth && auth.company && auth.company.countryCode || '',
        canEditVnPricing: (0, _vietnam.canEditVietnamUnitPricing)(auth)
      };
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'fetchProjectUnitLayouts',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, unitLayouts, unit;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                res = void 0;
                _context.prev = 2;
                _context.next = 5;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/unit_layouts/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                res = _context.sent;
                _context.next = 14;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](2);

                Bugsnag.notifyException(_context.t0);
                _context.next = 13;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 13:
                return _context.abrupt('return');

              case 14:
                if (res.ok) {
                  _context.next = 22;
                  break;
                }

                _context.next = 17;
                return res.text();

              case 17:
                message = _context.sent;
                _context.next = 20;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 20:
                _context.next = 29;
                break;

              case 22:
                _context.next = 24;
                return res.json();

              case 24:
                unitLayouts = _context.sent;

                // handle token.. etc
                unit = this.state.unit;

                if (unit.projectUnitLayoutID.length > 0 && unit.size < 1) {
                  unit.size = unitLayouts.filter(function (ul) {
                    return ul.id === unit.projectUnitLayoutID;
                  })[0].size;
                }
                _context.next = 29;
                return this.setComponentState({
                  unit: unit,
                  unitLayouts: unitLayouts ? unitLayouts.map(function (ul) {
                    var unitLayout = { text: ul.name, name: ul.id, value: ul.id, size: ul.size };
                    return unitLayout;
                  }) : []
                });

              case 29:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));

      function fetchProjectUnitLayouts() {
        return _ref.apply(this, arguments);
      }

      return fetchProjectUnitLayouts;
    }()
  }, {
    key: 'fetchCompanyBranches',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, res, message, json, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                res = void 0;
                _context2.prev = 2;
                _context2.next = 5;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/company_branches/?isExternal=true', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                res = _context2.sent;
                _context2.next = 14;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](2);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 13;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 13:
                return _context2.abrupt('return');

              case 14:
                if (res.ok) {
                  _context2.next = 22;
                  break;
                }

                _context2.next = 17;
                return res.text();

              case 17:
                message = _context2.sent;
                _context2.next = 20;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 20:
                _context2.next = 29;
                break;

              case 22:
                _context2.next = 24;
                return res.json();

              case 24:
                json = _context2.sent;

                if (!json) {
                  _context2.next = 29;
                  break;
                }

                data = json.map(function (obj) {
                  var newResults = {};
                  newResults.text = obj.name;
                  newResults.value = obj.id;
                  return newResults;
                });
                _context2.next = 29;
                return this.setComponentState({
                  companyBranches: data
                });

              case 29:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 8]]);
      }));

      function fetchCompanyBranches() {
        return _ref2.apply(this, arguments);
      }

      return fetchCompanyBranches;
    }()
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;
      var _state = this.state,
          companyBranches = _state.companyBranches,
          globalSettings = _state.globalSettings;

      var _getVietnamGates = this.getVietnamGates(),
          isVietnam = _getVietnamGates.isVietnam,
          countryCode = _getVietnamGates.countryCode,
          canEditVnPricing = _getVietnamGates.canEditVnPricing;

      var statuses = [{ name: 'new', value: 'new', text: t('Available', { ns: _translation.TRANSLATION_FILES.constants }) },
      // { name: 'reserved', value: 'reserved', text: 'Reserved' },
      // { name: 'booked', value: 'booked', text: 'Booked' },
      { name: 'developer_booked', value: 'developer_booked', text: t('Hold', { ns: _translation.TRANSLATION_FILES.constants }) }, { name: 'delist', value: 'delist', text: t('Delist', { ns: _translation.TRANSLATION_FILES.constants }) }];
      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref3) {
            _this3.form = _ref3;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Project', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'projectID',
                  disabled: true,
                  value: this.props.project ? this.props.project.name : t('Project', { ns: _translation.TRANSLATION_FILES.screens })
                }),
                _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    validation: [_webValidations.required],
                    ref: this.validation.projectUnitLayoutID,
                    onChange: this.handleInputChange
                  },
                  _react2.default.createElement(_semanticUiReact.Form.Select, {
                    label: t('Layout Type', { ns: _translation.TRANSLATION_FILES.screens }),
                    name: 'projectUnitLayoutID',
                    search: true,
                    fluid: true,
                    text: this.state.unit.projectUnitLayoutID ? null : t('Select layout type', { ns: _translation.TRANSLATION_FILES.screens }),
                    value: this.state.unit.projectUnitLayoutID,
                    options: this.state.unitLayouts,
                    disabled: this.state.unitLayouts.length === 0
                  })
                )
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Info', { ns: _translation.TRANSLATION_FILES.screens })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Unit Number', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'reference',
                  value: this.state.unit.reference,
                  onChange: this.handleInputChange,
                  ref: this.validation.reference,
                  validation: [_webValidations.required]
                }),
                this.checkStatusDropDown() ? _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    validation: [_webValidations.required],
                    ref: this.validation.statusID,
                    onChange: this.handleInputChange
                  },
                  _react2.default.createElement(_semanticUiReact.Form.Select, {
                    label: t('Status', { ns: _translation.TRANSLATION_FILES.screens }),
                    name: 'statusID',
                    search: true,
                    fluid: true,
                    value: this.state.unit.statusID,
                    options: statuses
                  })
                ) : _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Status', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'statusID',
                  disabled: true,
                  value: t(this.state.unit.status.name, { ns: _translation.TRANSLATION_FILES.constants })
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: (0, _areaLabel.getUnitFormAreaLabel)(t, countryCode),
                  name: 'size',
                  type: 'number',
                  step: '0.0001',
                  value: this.state.unit.size,
                  onChange: this.handleInputChange,
                  ref: this.validation.size,
                  validation: [_webValidations.required, {
                    validate: _webValidations.numericRange,
                    option: {
                      min: 1
                    }
                  }]
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: globalSettings && globalSettings.sellingPrice ? globalSettings.sellingPrice : t('Selling Price', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'spaValue',
                  type: 'number',
                  step: '.01',
                  value: this.state.unit.spaValue,
                  onChange: this.handleInputChange,
                  ref: this.validation.spaValue,
                  validation: [_webValidations.required, {
                    validate: _webValidations.numericRange,
                    option: {
                      min: 1
                    }
                  }]
                })
              ),
              isVietnam && _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: (0, _areaLabel.getLandAreaModelLabel)(t, countryCode),
                  name: 'landArea',
                  type: 'number',
                  step: '0.0001',
                  value: this.state.unit.landArea || 0,
                  onChange: this.handleInputChange,
                  ref: this.validation.landArea,
                  validation: [{
                    validate: _webValidations.numericRange,
                    option: {
                      min: 0
                    }
                  }]
                })
              ),
              isVietnam && _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Unit Layout', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'unitLayoutNew',
                  placeholder: '2PN-2WC',
                  value: this.state.unit.unitLayoutNew || '',
                  onChange: this.handleInputChange,
                  ref: this.validation.unitLayoutNew
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('View', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'view',
                  placeholder: 'SE',
                  value: this.state.unit.view || '',
                  onChange: this.handleInputChange,
                  ref: this.validation.view
                })
              ),
              canEditVnPricing && _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('VAT %', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'vatPercentage',
                  type: 'number',
                  step: '0.001',
                  value: this.state.unit.vatPercentage || 0,
                  onChange: this.handleInputChange,
                  ref: this.validation.vatPercentage,
                  validation: [{
                    validate: _webValidations.numericRange,
                    option: {
                      min: 0,
                      max: 100
                    }
                  }]
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Land Value', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'landValue',
                  type: 'number',
                  step: '0.01',
                  value: this.state.unit.landValue || 0,
                  onChange: this.handleInputChange,
                  ref: this.validation.landValue,
                  validation: [{
                    validate: _webValidations.numericRange,
                    option: {
                      min: 0
                    }
                  }]
                })
              ),
              _react2.default.createElement(_SpecificationTable2.default, {
                type: 'units',
                editable: true,
                isEditing: true,
                hideButton: true,
                data: this.state.unit.specifications,
                onChange: this.handleSpecificationsChange
              }),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Location', { ns: _translation.TRANSLATION_FILES.screens })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: this.props.project && this.props.project.propertyCategory.category === _propertyCategories.PROPERTY_CATEGORY_HIGH_RISE ? t('Block', { ns: _translation.TRANSLATION_FILES.screens }) : t('Zone', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'zoneOrBlock',
                  value: this.state.unit.zoneOrBlock,
                  onChange: this.handleInputChange,
                  ref: this.validation.zoneOrBlock
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: this.props.project && this.props.project.propertyCategory.category === _propertyCategories.PROPERTY_CATEGORY_HIGH_RISE ? t('Level', { ns: _translation.TRANSLATION_FILES.screens }) : t('Street Number', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'streetNumberOrLevel',
                  value: this.state.unit.streetNumberOrLevel,
                  onChange: this.handleInputChange,
                  ref: this.validation.streetNumberOrLevel
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: this.props.project && this.props.project.propertyCategory.category === _propertyCategories.PROPERTY_CATEGORY_HIGH_RISE ? t('Facing', { ns: _translation.TRANSLATION_FILES.screens }) : t('Street', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'streetOrFacing',
                  value: this.state.unit.streetOrFacing,
                  onChange: this.handleInputChange,
                  ref: this.validation.streetOrFacing
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Position', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'position',
                  type: 'number',
                  value: this.state.unit.position,
                  onChange: this.handleInputChange,
                  ref: this.validation.position,
                  validation: [{
                    validate: _webValidations.numericRange,
                    option: {
                      min: 1
                    }
                  }]
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Col Span in sales chart', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'colSpan',
                  type: 'number',
                  value: this.state.unit.colSpan,
                  onChange: this.handleInputChange,
                  ref: this.validation.colSpan,
                  validation: [{
                    validate: _webValidations.numericRange,
                    option: {
                      min: 1
                    }
                  }]
                })
              ),
              _react2.default.createElement(_TextArea2.default, {
                ref: this.validation.address,
                onChange: this.handleInputChange,
                label: t('Address', { ns: _translation.TRANSLATION_FILES.screens }),
                name: 'address',
                value: this.state.unit.address
              }),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Virtual Tour', { ns: _translation.TRANSLATION_FILES.screens })
              ),
              _react2.default.createElement(_AppForm2.default.Input, {
                label: t('URL', { ns: _translation.TRANSLATION_FILES.screens }),
                name: 'virtualTourURL',
                value: this.state.unit.virtualTourURL,
                onChange: this.handleInputChange,
                ref: this.validation.virtualTourURL
              }),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true, style: { margin: '3em 0 2em 0' } },
                t('Agency', { ns: _translation.TRANSLATION_FILES.screens })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_semanticUiReact.Dropdown, {
                  name: 'companyBranchAllocationIDs',
                  onChange: this.handleInputChange,
                  placeholder: t('Select Agency', { ns: _translation.TRANSLATION_FILES.screens }),
                  label: t('Select Agency', { ns: _translation.TRANSLATION_FILES.screens }),
                  fluid: true,
                  multiple: true,
                  selection: true,
                  search: true,
                  options: companyBranches || [],
                  value: this.state.unit.companyBranchAllocationIDs ? this.state.unit.companyBranchAllocationIDs : [],
                  ref: this.validation.companyBranchAllocationIDs
                })
              )
            )
          )
        )
      );
    }
  }]);

  return UnitForm;
}(_react.Component);

UnitForm.propTypes = {
  id: _propTypes2.default.string,
  project: _propTypes2.default.shape({
    name: _propTypes2.default.string,
    propertyCategory: _propTypes2.default.shape({
      category: _propTypes2.default.string
    })
  }),
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  unit: _propTypes2.default.shape({
    reference: _propTypes2.default.string
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object
  }),
  t: _propTypes2.default.func
};
UnitForm.contextTypes = {
  store: _propTypes2.default.object
};
UnitForm.defaultValues = {
  isBumi: false,
  projectID: '',
  projectUnitLayoutID: '',
  reference: '',
  statusID: 'new',
  position: 1,
  spaValue: 0,
  spaDecimal: 0,
  spaFull: 0,
  spaTimes: 100,
  availableUnits: 1,
  size: 0,
  address: '',
  streetNumberOrLevel: '',
  streetOrFacing: '',
  zoneOrBlock: '',
  specifications: [],
  colSpan: 1,
  companyBranchAllocationIDs: [],
  // CPI-1219: Vietnam only on the screen, but harmless defaults everywhere -- an empty string
  // keeps the inputs controlled, and vnUnitTextValues decides whether the keys are ever sent.
  unitLayoutNew: '',
  view: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleSubmit = function (event) {
    event.preventDefault();
    var unit = _this4.state.unit;

    if (unit.specifications) {
      unit.specifications = unit.specifications.filter(function (data) {
        return data.name.length > 0 && data.value.length > 0;
      }).map(function (data, idx) {
        return _extends({}, data, {
          position: idx + 1
        });
      });
    }
    _AppForm2.default.validate(_this4.validation, unit).then(function (validations) {
      var _getVietnamGates2 = _this4.getVietnamGates(),
          isVietnam = _getVietnamGates2.isVietnam,
          canEditVnPricing = _getVietnamGates2.canEditVnPricing;

      var data = Object.assign(unit, _extends({
        spaValue: parseFloat(unit.spaValue),
        size: parseFloat(unit.size),
        position: parseInt(unit.position, 10),
        colSpan: parseInt(unit.colSpan, 10)
      }, isVietnam ? { landArea: parseFloat(unit.landArea) || 0 } : {}, (0, _vietnam.vnUnitTextValues)(unit, isVietnam), canEditVnPricing ? {
        vatPercentage: parseFloat(unit.vatPercentage) || 0,
        landValue: parseFloat(unit.landValue) || 0
      } : {}));
      data = (0, _amount.fullToAmount)(data, unit.spaValue);
      _this4.props.onSubmit(validations, data);
    });
  };

  this.handleInputChange = function (event, _ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    var _state2 = _this4.state,
        unit = _state2.unit,
        unitLayouts = _state2.unitLayouts;

    unit[name] = value;
    if (name === 'projectUnitLayoutID') {
      if (unitLayouts.length > 0 && unit.size === 0) {
        var selectedLayout = unitLayouts.find(function (ul) {
          return ul.id === unit.projectUnitLayoutID;
        });
        if (selectedLayout && selectedLayout.size > 0) {
          unit.size = selectedLayout.size;
        }
      }
    }
    _this4.setState({ unit: unit }, function () {
      _this4.handleCheckChanges();
    });
  };

  this.handleCheckBoxChange = function (event, _ref5) {
    var name = _ref5.name;
    var unit = _this4.state.unit;

    unit[name] = !unit[name];
    _this4.setState({ unit: unit }, function () {
      _this4.handleCheckChanges();
    });
  };

  this.handleSpecificationsChange = function (data) {
    var unit = _this4.state.unit;

    unit.specifications = data;
    _this4.setState({ unit: unit }, function () {
      _this4.handleCheckChanges();
    });
  };

  this.checkStatusDropDown = function () {
    switch (_this4.state.unit.statusID) {
      case 'new':
      case 'developer_booked':
      case 'delist':
        return true;
      default:
        return false;
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(UnitForm);

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  eslint no-param-reassign: ["error", { "props": false }]*/

var ProjectMappingForm = function (_Component) {
  _inherits(ProjectMappingForm, _Component);

  function ProjectMappingForm(props) {
    _classCallCheck(this, ProjectMappingForm);

    var _this = _possibleConstructorReturn(this, (ProjectMappingForm.__proto__ || Object.getPrototypeOf(ProjectMappingForm)).call(this, props));

    _initialiseProps.call(_this);

    var preset = Object.assign({}, ProjectMappingForm.defaultValues, props.preset || {});
    _this.state = {
      preset: preset,
      oriPreset: (0, _clone2.default)(preset),
      errMessages: []
    };
    _this.validation = {
      name: (0, _react.createRef)(),
      shortName: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(ProjectMappingForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var preset = Object.assign({}, ProjectMappingForm.defaultValues, this.state.preset);
      var oriPreset = this.state.oriPreset;
      if (JSON.stringify(this.props.preset) !== JSON.stringify(nextProps.preset)) {
        preset = Object.assign(preset, nextProps.preset);
        oriPreset = (0, _clone2.default)(preset);
      }
      this.setState({ preset: preset, oriPreset: oriPreset });
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;
      var preset = this.state.preset;

      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref) {
            _this2.form = _ref;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Name', { ns: _translation.TRANSLATION_FILES.translation }),
                  name: 'name',
                  value: preset.name,
                  onChange: this.handleInputChange,
                  ref: this.validation.name,
                  validation: [_webValidations.required]
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Short Name', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'shortName',
                  value: preset.shortName,
                  onChange: this.handleInputChange,
                  ref: this.validation.shortName,
                  validation: [_webValidations.required]
                })
              ),
              _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                label: t('Description', { ns: _translation.TRANSLATION_FILES.screens }),
                name: 'description',
                value: preset.description,
                onChange: this.handleInputChange
              })
            )
          )
        )
      );
    }
  }]);

  return ProjectMappingForm;
}(_react.Component);

ProjectMappingForm.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  preset: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
ProjectMappingForm.contextTypes = {
  store: _propTypes2.default.object
};
ProjectMappingForm.defaultValues = {
  name: '',
  shortName: '',
  description: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleSubmit = function (event) {
    event.preventDefault();
    var preset = _this3.state.preset;

    _AppForm2.default.validate(_this3.validation, preset).then(function (validations) {
      _this3.props.onSubmit(validations, preset);
    });
  };

  this.handleInputChange = function (event, data) {
    var preset = _this3.state.preset;

    preset[data.name] = data.value;
    _this3.setState({ preset: preset }, function () {
      _this3.handleCheckChanges();
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(ProjectMappingForm);

/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  eslint no-param-reassign: ["error", { "props": false }]*/

var ProjectSpecificationForm = function (_Component) {
  _inherits(ProjectSpecificationForm, _Component);

  function ProjectSpecificationForm(props) {
    _classCallCheck(this, ProjectSpecificationForm);

    var _this = _possibleConstructorReturn(this, (ProjectSpecificationForm.__proto__ || Object.getPrototypeOf(ProjectSpecificationForm)).call(this, props));

    _initialiseProps.call(_this);

    var preset = Object.assign({}, ProjectSpecificationForm.defaultValues, props.preset || {});
    _this.state = {
      preset: preset,
      oriPreset: (0, _clone2.default)(preset),
      errMessages: []
    };
    _this.validation = {
      name: (0, _react.createRef)(),
      shortName: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(ProjectSpecificationForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var preset = Object.assign({}, ProjectSpecificationForm.defaultValues, this.state.preset);
      var oriPreset = this.state.oriPreset;
      if (JSON.stringify(this.props.preset) !== JSON.stringify(nextProps.preset)) {
        preset = Object.assign(preset, nextProps.preset);
        oriPreset = (0, _clone2.default)(preset);
      }
      this.setState({ preset: preset, oriPreset: oriPreset });
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;
      var preset = this.state.preset;

      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref) {
            _this2.form = _ref;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Name', { ns: _translation.TRANSLATION_FILES.translation }),
                  name: 'name',
                  value: preset.name,
                  onChange: this.handleInputChange,
                  ref: this.validation.name,
                  validation: [_webValidations.required]
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Short Name', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'shortName',
                  value: preset.shortName,
                  onChange: this.handleInputChange,
                  ref: this.validation.shortName,
                  validation: [_webValidations.required]
                })
              ),
              _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                label: t('Description', { ns: _translation.TRANSLATION_FILES.screens }),
                name: 'description',
                value: preset.description,
                onChange: this.handleInputChange
              })
            )
          )
        )
      );
    }
  }]);

  return ProjectSpecificationForm;
}(_react.Component);

ProjectSpecificationForm.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  preset: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
ProjectSpecificationForm.contextTypes = {
  store: _propTypes2.default.object
};
ProjectSpecificationForm.defaultValues = {
  name: '',
  shortName: '',
  description: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleSubmit = function (event) {
    event.preventDefault();
    var preset = _this3.state.preset;

    _AppForm2.default.validate(_this3.validation, preset).then(function (validations) {
      _this3.props.onSubmit(validations, preset);
    });
  };

  this.handleInputChange = function (event, data) {
    var preset = _this3.state.preset;

    preset[data.name] = data.value;
    _this3.setState({ preset: preset }, function () {
      _this3.handleCheckChanges();
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(ProjectSpecificationForm);

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  eslint no-param-reassign: ["error", { "props": false }]*/

var UnitLayoutSpecificationForm = function (_Component) {
  _inherits(UnitLayoutSpecificationForm, _Component);

  function UnitLayoutSpecificationForm(props) {
    _classCallCheck(this, UnitLayoutSpecificationForm);

    var _this = _possibleConstructorReturn(this, (UnitLayoutSpecificationForm.__proto__ || Object.getPrototypeOf(UnitLayoutSpecificationForm)).call(this, props));

    _initialiseProps.call(_this);

    var preset = Object.assign({}, UnitLayoutSpecificationForm.defaultValues, props.preset || {});
    _this.state = {
      preset: preset,
      oriPreset: (0, _clone2.default)(preset),
      errMessages: []
    };
    _this.validation = {
      name: (0, _react.createRef)(),
      shortName: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(UnitLayoutSpecificationForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var preset = Object.assign({}, UnitLayoutSpecificationForm.defaultValues, this.state.preset);
      var oriPreset = this.state.oriPreset;
      if (JSON.stringify(this.props.preset) !== JSON.stringify(nextProps.preset)) {
        preset = Object.assign(preset, nextProps.preset);
        oriPreset = (0, _clone2.default)(preset);
      }
      this.setState({ preset: preset, oriPreset: oriPreset });
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref) {
            _this2.form = _ref;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Name', { ns: _translation.TRANSLATION_FILES.translation }),
                  name: 'name',
                  value: this.state.preset.name,
                  onChange: this.handleInputChange,
                  ref: this.validation.name,
                  validation: [_webValidations.required]
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Short Name', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'shortName',
                  value: this.state.preset.shortName,
                  onChange: this.handleInputChange,
                  ref: this.validation.shortName,
                  validation: [_webValidations.required]
                })
              ),
              _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                label: t('Description', { ns: _translation.TRANSLATION_FILES.screens }),
                name: 'description',
                value: this.state.preset.description,
                onChange: this.handleInputChange
              })
            )
          )
        )
      );
    }
  }]);

  return UnitLayoutSpecificationForm;
}(_react.Component);

UnitLayoutSpecificationForm.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  preset: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
UnitLayoutSpecificationForm.contextTypes = {
  store: _propTypes2.default.object
};
UnitLayoutSpecificationForm.defaultValues = {
  name: '',
  shortName: '',
  description: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleSubmit = function (event) {
    event.preventDefault();
    var preset = _this3.state.preset;

    _AppForm2.default.validate(_this3.validation, preset).then(function (validations) {
      _this3.props.onSubmit(validations, preset);
    });
  };

  this.handleInputChange = function (event, data) {
    var preset = _this3.state.preset;

    preset[data.name] = data.value;
    _this3.setState({ preset: preset }, function () {
      _this3.handleCheckChanges();
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(UnitLayoutSpecificationForm);

/***/ }),
/* 1066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  eslint no-param-reassign: ["error", { "props": false }]*/

var UnitLayoutSpecificationForm = function (_Component) {
  _inherits(UnitLayoutSpecificationForm, _Component);

  function UnitLayoutSpecificationForm(props) {
    _classCallCheck(this, UnitLayoutSpecificationForm);

    var _this = _possibleConstructorReturn(this, (UnitLayoutSpecificationForm.__proto__ || Object.getPrototypeOf(UnitLayoutSpecificationForm)).call(this, props));

    _initialiseProps.call(_this);

    var preset = Object.assign({}, UnitLayoutSpecificationForm.defaultValues, props.preset || {});
    _this.state = {
      preset: preset,
      oriPreset: (0, _clone2.default)(preset),
      errMessages: []
    };
    _this.validation = {
      name: (0, _react.createRef)(),
      shortName: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(UnitLayoutSpecificationForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var preset = Object.assign({}, UnitLayoutSpecificationForm.defaultValues, this.state.preset);
      var oriPreset = this.state.oriPreset;
      if (JSON.stringify(this.props.preset) !== JSON.stringify(nextProps.preset)) {
        preset = Object.assign(preset, nextProps.preset);
        oriPreset = (0, _clone2.default)(preset);
      }
      this.setState({ preset: preset, oriPreset: oriPreset });
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref) {
            _this2.form = _ref;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Name', { ns: _translation.TRANSLATION_FILES.translation }),
                  name: 'name',
                  value: this.state.preset.name,
                  onChange: this.handleInputChange,
                  ref: this.validation.name,
                  validation: [_webValidations.required]
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Short Name', { ns: _translation.TRANSLATION_FILES.screens }),
                  name: 'shortName',
                  value: this.state.preset.shortName,
                  onChange: this.handleInputChange,
                  ref: this.validation.shortName,
                  validation: [_webValidations.required]
                })
              ),
              _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                label: t('Description', { ns: _translation.TRANSLATION_FILES.screens }),
                name: 'description',
                value: this.state.preset.description,
                onChange: this.handleInputChange
              })
            )
          )
        )
      );
    }
  }]);

  return UnitLayoutSpecificationForm;
}(_react.Component);

UnitLayoutSpecificationForm.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  preset: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
UnitLayoutSpecificationForm.contextTypes = {
  store: _propTypes2.default.object
};
UnitLayoutSpecificationForm.defaultValues = {
  name: '',
  shortName: '',
  description: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleSubmit = function (event) {
    event.preventDefault();
    var preset = _this3.state.preset;

    _AppForm2.default.validate(_this3.validation, preset).then(function (validations) {
      _this3.props.onSubmit(validations, preset);
    });
  };

  this.handleInputChange = function (event, data) {
    var preset = _this3.state.preset;

    preset[data.name] = data.value;
    _this3.setState({ preset: preset }, function () {
      _this3.handleCheckChanges();
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(UnitLayoutSpecificationForm);

/***/ }),
/* 1067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _languagePreference = __webpack_require__(325);

var _srbChartExpiry = __webpack_require__(2588);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

__webpack_require__(360);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _webValidations = __webpack_require__(23);

var _index = __webpack_require__(172);

var _Currencies = __webpack_require__(1013);

var _Currencies2 = _interopRequireDefault(_Currencies);

var _BookingFormTemplateList = __webpack_require__(2093);

var _BookingFormTemplateList2 = _interopRequireDefault(_BookingFormTemplateList);

var _BankAccounts = __webpack_require__(2088);

var _BankAccounts2 = _interopRequireDefault(_BankAccounts);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _validations = __webpack_require__(271);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _prompt = __webpack_require__(66);

var _templates = __webpack_require__(380);

var _salesChartTypes = __webpack_require__(1001);

var _payments = __webpack_require__(2229);

var _countries = __webpack_require__(60);

var _intlCallCodes = __webpack_require__(116);

var _intlCallCodes2 = _interopRequireDefault(_intlCallCodes);

var _projectStatuses = __webpack_require__(583);

var _projectStatuses2 = _interopRequireDefault(_projectStatuses);

var _states = __webpack_require__(144);

var _states2 = _interopRequireDefault(_states);

var _promptMessages = __webpack_require__(43);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _Select = __webpack_require__(382);

var _Select2 = _interopRequireDefault(_Select);

var _SpecificationTable = __webpack_require__(127);

var _SpecificationTable2 = _interopRequireDefault(_SpecificationTable);

var _SearchBranch = __webpack_require__(1031);

var _SearchBranch2 = _interopRequireDefault(_SearchBranch);

var _PhoneInput = __webpack_require__(104);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

var _MarkdownText = __webpack_require__(193);

var _MarkdownText2 = _interopRequireDefault(_MarkdownText);

var _UploadModal = __webpack_require__(92);

var _UploadModal2 = _interopRequireDefault(_UploadModal);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _ProjectPricingTier = __webpack_require__(2171);

var _ProjectPricingTier2 = _interopRequireDefault(_ProjectPricingTier);

var _CustomField = __webpack_require__(1014);

var _CustomField2 = _interopRequireDefault(_CustomField);

var _url = __webpack_require__(19);

var _phone = __webpack_require__(146);

var _phone2 = _interopRequireDefault(_phone);

var _TextFieldMarkdownPreview = __webpack_require__(2208);

var _TextFieldMarkdownPreview2 = _interopRequireDefault(_TextFieldMarkdownPreview);

var _DropdownInputNumber = __webpack_require__(2131);

var _DropdownInputNumber2 = _interopRequireDefault(_DropdownInputNumber);

var _ProjectHimsSettingsForm = __webpack_require__(2169);

var _ProjectHimsSettingsForm2 = _interopRequireDefault(_ProjectHimsSettingsForm);

var _SiteplanForm = __webpack_require__(2462);

var _SiteplanForm2 = _interopRequireDefault(_SiteplanForm);

var _SvgForm = __webpack_require__(2463);

var _SvgForm2 = _interopRequireDefault(_SvgForm);

var _ImageForm = __webpack_require__(2461);

var _ImageForm2 = _interopRequireDefault(_ImageForm);

var _UnpublishProjectModal = __webpack_require__(2434);

var _UnpublishProjectModal2 = _interopRequireDefault(_UnpublishProjectModal);

var _MarketplaceTncModal = __webpack_require__(2458);

var _MarketplaceTncModal2 = _interopRequireDefault(_MarketplaceTncModal);

var _propertyCategories = __webpack_require__(323);

var _apps = __webpack_require__(263);

var _DateTimePicker = __webpack_require__(314);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

var _CountdownAdvance = __webpack_require__(559);

var _CountdownAdvance2 = _interopRequireDefault(_CountdownAdvance);

var _companies = __webpack_require__(88);

var _intlFlagCodes = __webpack_require__(141);

var _intlFlagCodes2 = _interopRequireDefault(_intlFlagCodes);

var _paymentTypes = __webpack_require__(322);

var _paymentTypes2 = _interopRequireDefault(_paymentTypes);

var _bookingStatuses = __webpack_require__(128);

var _bookingStatuses2 = _interopRequireDefault(_bookingStatuses);

var _tin = __webpack_require__(155);

var _tin2 = _interopRequireDefault(_tin);

var _translation = __webpack_require__(4);

var _hims = __webpack_require__(221);

var _translation2 = __webpack_require__(64);

var _financeSource = __webpack_require__(402);

var _foreignPurchaseThreshold = __webpack_require__(2579);

var _changeUnitsAccesses = __webpack_require__(1041);

var _srRoleAccess = __webpack_require__(196);

var _bookingNote = __webpack_require__(1040);

var _preSalesLaunch = __webpack_require__(269);

var _DocxTemplaterForm = __webpack_require__(2130);

var _DocxTemplaterForm2 = _interopRequireDefault(_DocxTemplaterForm);

var _MergeTagDictTabList = __webpack_require__(2157);

var _MergeTagDictTabList2 = _interopRequireDefault(_MergeTagDictTabList);

var _DocxTemplateGuides = __webpack_require__(2129);

var _DocxTemplateGuides2 = _interopRequireDefault(_DocxTemplateGuides);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/* eslint-disable max-len */

// import { fetchBobForms } from '../../actions/bobForms';


var isPRS = _config2.default.get('prs');
var inputDateFormat = 'DD/MM/YYYY, hh:mm A';

var ProjectForm = function (_Component) {
  _inherits(ProjectForm, _Component);

  function ProjectForm(props) {
    _classCallCheck(this, ProjectForm);

    var _this = _possibleConstructorReturn(this, (ProjectForm.__proto__ || Object.getPrototypeOf(ProjectForm)).call(this, props));

    _initialiseProps.call(_this);

    var state = ProjectForm.getPropsToState(props);
    var tabs = _this.buildTabs(props);
    var currentTab = tabs[0].name;
    if (props.location && props.location.hash.length > 0) {
      currentTab = props.location.hash.replace('#', '');
    }
    _this.state = _extends({}, state, {
      tabs: tabs,
      currentTab: currentTab,
      errMessages: [],
      genericErrMsg: props.t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }),
      siteplanHasSvg: false,
      siteplanHasImage: false,
      bookingCustomerSuccessEmailTemplates: [],
      openModal: false,
      openTncModal: false,
      systemData: [],
      templatesToken: '',
      isVisible: false,
      companyHimsTokens: [],
      companyHimsTokensLoading: false,
      compulsoryValidTinBeforeUpdateBooking: false
    });
    _this.validation = {
      country: (0, _react.createRef)(),
      statusID: (0, _react.createRef)(),
      name: (0, _react.createRef)(),
      shortName: (0, _react.createRef)(),
      referenceCode: (0, _react.createRef)(),
      phone: (0, _react.createRef)(),
      ownershipType: (0, _react.createRef)(),
      propertyCategoryID: (0, _react.createRef)(),
      minPrice: (0, _react.createRef)(),
      maxPrice: (0, _react.createRef)(),
      minSize: (0, _react.createRef)(),
      maxSize: (0, _react.createRef)(),
      sizeSuffix: (0, _react.createRef)(),
      companyEmail: (0, _react.createRef)(),
      launchModeMinutes: (0, _react.createRef)(),
      creditControlIsUnlinked: (0, _react.createRef)(),
      isCreditControlRebateUpdateDisabled: (0, _react.createRef)(),
      loanTrackerProjectConsentTypeID: (0, _react.createRef)(),
      newBookingEmailNotifications: (0, _react.createRef)(),
      approvedBookingEmailNotifications: (0, _react.createRef)(),
      cancelledBookingEmailNotifications: (0, _react.createRef)(),
      soldStatusBookingEmailNotifications: (0, _react.createRef)(),
      bookingUnitLimit: (0, _react.createRef)(),
      defaultBookingFeeAmount: (0, _react.createRef)(),
      minBookingPaymentAmount: (0, _react.createRef)(),
      newPaymsBillplzSercetKey: (0, _react.createRef)(),
      newPaymsBillplzSignatureKey: (0, _react.createRef)(),
      paymsBillplzCollectionID: (0, _react.createRef)(),
      paymsBillplzCollectionTitle: (0, _react.createRef)(),
      newPaymsIPay88MerchantCode: (0, _react.createRef)(),
      newPaymsIPay88MerchantKey: (0, _react.createRef)(),
      newPaymentApprovalEmailNotifications: (0, _react.createRef)(),
      newPaymentSuccessEmailNotifications: (0, _react.createRef)(),
      mpAllowESignFormAtReserve: (0, _react.createRef)(),
      accessBULNettSellingPrice: (0, _react.createRef)(),
      accessStaffNettSellingPrice: (0, _react.createRef)(),
      bapMaxAttempts: (0, _react.createRef)(),
      himsStrataIsEnabled: (0, _react.createRef)(),
      himsStrataIsHidden: (0, _react.createRef)(),
      himsDefaultSpaLawyerRepID: (0, _react.createRef)(),
      customerReservationMaxLimit: (0, _react.createRef)(),
      foreignPurchaseThreshold: (0, _react.createRef)(),
      srbStoreyPlanExpiryMinutes: (0, _react.createRef)(),
      cuRoleAccesses: (0, _react.createRef)(),
      address8: (0, _react.createRef)(),
      address9: (0, _react.createRef)()
    };
    _this.rtValidation = {
      rtPriceMinor: (0, _react.createRef)(),
      rtValidityDurationDays: (0, _react.createRef)(),
      rtLimitPerOpportunity: (0, _react.createRef)()
    };
    // add validateRef for all enabled address settings
    var enabledAddressSettings = props.addressSettings.data.filter(function (as) {
      return as.enabled;
    });
    if (enabledAddressSettings && enabledAddressSettings.length > 0) {
      enabledAddressSettings.forEach(function (as) {
        var key = _lodash2.default.camelCase(as.columnName);
        _this.validation[key] = (0, _react.createRef)();
      });
    }
    _this.uploadForm = {};
    _this.uploadModal = {};
    _this.himsSettingsForm = (0, _react.createRef)();
    return _this;
  }

  _createClass(ProjectForm, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;

      store.dispatch((0, _templates.fetchTemplates)('print', true));
      store.dispatch((0, _templates.fetchTemplates)('loan_reminder', true));
      store.dispatch((0, _templates.fetchTemplates)('spa_reminder', true));
      store.dispatch((0, _templates.fetchTemplates)('termination', true));
      store.dispatch((0, _templates.fetchTemplates)('saleschart', true));
      store.dispatch((0, _salesChartTypes.fetchSalesChartTypes)(true));
      // store.dispatch(fetchBobForms(true));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchBookingCustomerSuccessEmailTemplates();
      this.fetchSystemSettings();
      this.fetchTemplateP();
      window.addEventListener('resize', this.handleResize, false);

      if (this.hasCompanyHimsEnabled()) {
        this.fetchCompanyHimsTokens();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      // only load svg on sales chart setup tab
      var currentTab = this.state.currentTab;
      if (currentTab === 'sales_chart_setup') {
        var _state = ProjectForm.getPropsToState(nextProps);
        this.checkSiteplan(_state);
      }

      // do not fetch if hashtag changed
      if (this.props.location.hash !== nextProps.location.hash && nextProps.location.action === 'REPLACE') return;

      if (JSON.stringify(this.props.addressSettings.data) !== JSON.stringify(nextProps.addressSettings.data)) {
        // add validateRef for all enabled address settings
        var enabledAddressSettings = nextProps.addressSettings.data.filter(function (as) {
          return as.enabled;
        });
        if (enabledAddressSettings && enabledAddressSettings.length > 0) {
          enabledAddressSettings.forEach(function (as) {
            var key = _lodash2.default.camelCase(as.columnName);
            _this2.validation[key] = (0, _react.createRef)();
          });
        }
      }

      // update state
      var state = ProjectForm.getPropsToState(nextProps);
      var compulsoryValidTinBeforeUpdateBooking = state.oriProject.requireValidTinAtBookingAndSold || state.oriProject.requireValidTinAtSold;
      var tinDropdown = '';
      if (state.oriProject.requireValidTinAtBookingAndSold) {
        tinDropdown = 'booked_and_sold';
      } else if (state.oriProject.requireValidTinAtSold) {
        tinDropdown = 'sold';
      }
      if (JSON.stringify(state.oriProject) === JSON.stringify(this.state.oriProject)) {
        state.project = this.state.project;
        state.srbExpiryEdited = this.state.srbExpiryEdited;
        state.formAccessibilitiesTemplateIDs = this.state.formAccessibilitiesTemplateIDs;
        state.projectReservationTokenSetting = this.state.projectReservationTokenSetting;
        state.oriProjectReservationTokenSetting = this.state.oriProjectReservationTokenSetting;
      }
      if (!this.hasUpdateAccess() && nextProps.auth.company.companyCurrency && !this.state.project.projectCurrency) {
        this.setProjectCurrency();
      }
      if (nextProps.location && nextProps.location.hash.length > 0) {
        currentTab = nextProps.location.hash.replace('#', '');
      }
      var tabs = this.buildTabs(nextProps);
      this.setState(_extends({}, state, {
        tinDropdown: tinDropdown,
        compulsoryValidTinBeforeUpdateBooking: compulsoryValidTinBeforeUpdateBooking,
        tabs: tabs,
        currentTab: currentTab
      }), function () {
        if (_this2.hasCompanyHimsEnabled(nextProps) && !_this2.state.companyHimsTokensLoading && _this2.state.companyHimsTokens && _this2.state.companyHimsTokens.length === 0) {
          _this2.fetchCompanyHimsTokens();
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setProjectCurrency',
    value: function setProjectCurrency() {
      var _props$auth$company$c = this.props.auth.company.companyCurrency,
          companyCurrency = _props$auth$company$c === undefined ? [] : _props$auth$company$c;
      var project = this.state.project;

      project.projectCurrency = companyCurrency.map(function (c) {
        var currency = Object.assign({}, c);
        delete currency.id;
        delete currency.companyId;
        return currency;
      });
      this.setState({ project: project });
    }
  }, {
    key: 'getSiteplanToken',
    value: function getSiteplanToken() {
      var project = this.state.project;
      var store = this.context.store;

      return store.dispatch((0, _fetchM.fetchM)('/projects/' + project.id + '/siteplans/' + project.siteplan.id + '/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      }).then(function (res) {
        var token = res.headers.get('X-Csrf-Token');
        return token;
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this3.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'getLogoToken',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, t, res, token, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                token = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/logos/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 16;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 15:
                return _context.abrupt('return', null);

              case 16:
                if (res.ok) {
                  _context.next = 24;
                  break;
                }

                _context.next = 19;
                return res.text();

              case 19:
                message = _context.sent;
                _context.next = 22;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 22:
                _context.next = 25;
                break;

              case 24:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

              case 25:
                return _context.abrupt('return', token);

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function getLogoToken() {
        return _ref.apply(this, arguments);
      }

      return getLogoToken;
    }()
  }, {
    key: 'uploadSiteplan',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e, body) {
        var store, project, t, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e.preventDefault();
                _context2.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                project = this.state.project;
                t = this.props.t;
                _context2.prev = 6;
                _context2.next = 9;
                return this.uploadForm.siteplan.submit('/projects/' + project.id + '/siteplans/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    // Let browser decide Content-Type
                    'X-Csrf-Token': this.state.token
                  },
                  body: body
                });

              case 9:
                _context2.next = 23;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](6);
                _context2.next = 15;
                return this.setLoading(false);

              case 15:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 21;
                  break;
                }

                _context2.next = 18;
                return _context2.t0.res.text();

              case 18:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));
                return _context2.abrupt('return');

              case 23:
                this.uploadModal.siteplan.close();
                _context2.next = 26;
                return this.setLoading(false);

              case 26:
                store.dispatch((0, _reactRouterRedux.push)('/projects/' + project.id + '/edit/' + this.props.location.hash));
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Upload Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Siteplan successfully uploaded', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 28:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 11]]);
      }));

      function uploadSiteplan(_x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return uploadSiteplan;
    }()
  }, {
    key: 'replaceSiteplan',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e, body, type) {
        var store, project, t, token, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                e.preventDefault();
                _context3.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                project = this.state.project;
                t = this.props.t;
                _context3.next = 8;
                return this.getSiteplanToken();

              case 8:
                token = _context3.sent;
                _context3.prev = 9;

                if (!this.uploadForm[type]) {
                  _context3.next = 13;
                  break;
                }

                _context3.next = 13;
                return this.uploadForm[type].submit('/projects/' + project.id + '/siteplans/' + project.siteplan.id + '/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    // Let browser decide Content-Type
                    'X-Csrf-Token': token
                  },
                  body: body
                });

              case 13:
                _context3.next = 27;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3['catch'](9);
                _context3.next = 19;
                return this.setLoading(false);

              case 19:
                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 25;
                  break;
                }

                _context3.next = 22;
                return _context3.t0.res.text();

              case 22:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 25:
                store.dispatch((0, _flash.flashErrorMessage)(_context3.t0));
                return _context3.abrupt('return');

              case 27:
                if (this.uploadModal[type]) {
                  this.uploadModal[type].close();
                }
                _context3.next = 30;
                return this.setLoading(false);

              case 30:
                store.dispatch((0, _reactRouterRedux.push)('/projects/' + project.id + '/edit/' + this.props.location.hash));
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Upload Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Siteplan successfully replaced', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 32:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[9, 15]]);
      }));

      function replaceSiteplan(_x4, _x5, _x6) {
        return _ref3.apply(this, arguments);
      }

      return replaceSiteplan;
    }()
  }, {
    key: 'checkSiteplan',
    value: function checkSiteplan() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state;
      var oriProject = state.oriProject;

      if (oriProject.siteplan && oriProject.siteplan.id && oriProject.siteplan.key) {
        var siteplan = oriProject.siteplan;

        this.checkSvg((0, _url.siteplanUrl)(this.props.appConfig, siteplan.key + '.svg'));
        this.checkImage((0, _url.siteplanUrl)(this.props.appConfig, siteplan.key + '.jpg'));
      }
    }
  }, {
    key: 'fetchBookingCustomerSuccessEmailTemplates',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var store, t, res, q, message, json, bookingCustomerSuccessEmailTemplates;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                res = null;
                q = Object.assign({
                  limit: 0,
                  templateType: 'customer_booking_success'
                });
                _context4.prev = 4;
                _context4.next = 7;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/templates/?' + _qs2.default.stringify(q), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context4.sent;
                _context4.next = 21;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](4);

                if (!(_context4.t0.res && _context4.t0.res.status >= 400 && _context4.t0.res.status < 500)) {
                  _context4.next = 18;
                  break;
                }

                _context4.next = 15;
                return _context4.t0.res.text();

              case 15:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context4.abrupt('return', null);

              case 18:
                Bugsnag.notifyException(_context4.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context4.abrupt('return', null);

              case 21:
                _context4.next = 23;
                return res.json();

              case 23:
                json = _context4.sent;

                if (!json) {
                  _context4.next = 28;
                  break;
                }

                bookingCustomerSuccessEmailTemplates = json.map(function (obj) {
                  var newResults = {};
                  newResults.value = obj.id;
                  newResults.text = obj.name;
                  return newResults;
                });
                _context4.next = 28;
                return this.setComponentState({ bookingCustomerSuccessEmailTemplates: bookingCustomerSuccessEmailTemplates });

              case 28:
                return _context4.abrupt('return', null);

              case 29:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 10]]);
      }));

      function fetchBookingCustomerSuccessEmailTemplates() {
        return _ref4.apply(this, arguments);
      }

      return fetchBookingCustomerSuccessEmailTemplates;
    }()
  }, {
    key: 'fetchSystemSettings',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var store, t, res, message, systemData, state, agencyAllocationAllocateAll;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context5.prev = 5;
                _context5.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/settings/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context5.sent;
                _context5.next = 19;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5['catch'](5);

                Bugsnag.notifyException(_context5.t0);
                _context5.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context5.next = 18;
                return this.setLoading(false);

              case 18:
                return _context5.abrupt('return');

              case 19:
                if (res.ok) {
                  _context5.next = 27;
                  break;
                }

                _context5.next = 22;
                return res.text();

              case 22:
                message = _context5.sent;
                _context5.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context5.next = 34;
                break;

              case 27:
                _context5.next = 29;
                return res.json();

              case 29:
                systemData = _context5.sent;
                state = { systemData: systemData };

                if (!this.state.project.id) {
                  agencyAllocationAllocateAll = Boolean(systemData.agencyAllocationAllocateAll);
                  // keep the fetched default when new-project state is rebuilt from defaultValues

                  ProjectForm.defaultValues.agencyAllocationAllocateAll = agencyAllocationAllocateAll;
                  state.project = _extends({}, this.state.project, { agencyAllocationAllocateAll: agencyAllocationAllocateAll });
                  state.oriProject = _extends({}, this.state.oriProject, { agencyAllocationAllocateAll: agencyAllocationAllocateAll });
                }
                _context5.next = 34;
                return this.setComponentState(state);

              case 34:
                _context5.next = 36;
                return this.setLoading(false);

              case 36:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[5, 11]]);
      }));

      function fetchSystemSettings() {
        return _ref5.apply(this, arguments);
      }

      return fetchSystemSettings;
    }()
  }, {
    key: 'fetchTemplateP',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var store, t, res, q, message, templatesToken;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                q = Object.assign({
                  templateType: 'print'
                });
                _context6.prev = 6;
                _context6.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/templates/?' + _qs2.default.stringify(q), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context6.sent;
                _context6.next = 20;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6['catch'](6);

                Bugsnag.notifyException(_context6.t0);
                _context6.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context6.next = 19;
                return this.setLoading(false);

              case 19:
                return _context6.abrupt('return');

              case 20:
                if (res.ok) {
                  _context6.next = 28;
                  break;
                }

                _context6.next = 23;
                return res.text();

              case 23:
                message = _context6.sent;
                _context6.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context6.next = 31;
                break;

              case 28:
                templatesToken = res.headers.get('X-CSRF-Token');
                _context6.next = 31;
                return this.setComponentState({
                  templatesToken: templatesToken
                });

              case 31:
                _context6.next = 33;
                return this.setLoading(false);

              case 33:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[6, 12]]);
      }));

      function fetchTemplateP() {
        return _ref6.apply(this, arguments);
      }

      return fetchTemplateP;
    }()
  }, {
    key: 'fetchCompanyHimsTokens',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var store, t, res, message, companyHimsTokens;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.setCompanyHimsTokensLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context7.prev = 5;
                _context7.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/company_hims_tokens/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context7.sent;
                _context7.next = 19;
                break;

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7['catch'](5);

                Bugsnag.notifyException(_context7.t0);
                _context7.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context7.next = 18;
                return this.setCompanyHimsTokensLoading(false);

              case 18:
                return _context7.abrupt('return');

              case 19:
                if (res.ok) {
                  _context7.next = 27;
                  break;
                }

                _context7.next = 22;
                return res.text();

              case 22:
                message = _context7.sent;
                _context7.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context7.next = 32;
                break;

              case 27:
                _context7.next = 29;
                return res.json();

              case 29:
                companyHimsTokens = _context7.sent;
                _context7.next = 32;
                return this.setComponentState({
                  companyHimsTokens: companyHimsTokens
                });

              case 32:
                _context7.next = 34;
                return this.setCompanyHimsTokensLoading(false);

              case 34:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[5, 11]]);
      }));

      function fetchCompanyHimsTokens() {
        return _ref7.apply(this, arguments);
      }

      return fetchCompanyHimsTokens;
    }()
  }, {
    key: 'deletePricingTier',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id) {
        var _this4 = this;

        var store, project, t, data, item, message;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                project = this.state.project;
                t = this.props.t;
                data = project.projectPricings.filter(function (d) {
                  return d.id !== id;
                });
                item = project.projectPricings.find(function (d) {
                  return d.id === id;
                });
                _context8.prev = 7;
                _context8.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + project.id + '/pricing_tiers/' + id + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 10:
                _context8.next = 25;
                break;

              case 12:
                _context8.prev = 12;
                _context8.t0 = _context8['catch'](7);
                _context8.next = 16;
                return this.setLoading(false);

              case 16:
                if (!(_context8.t0.res && _context8.t0.res.status >= 400 && _context8.t0.res.status < 500)) {
                  _context8.next = 22;
                  break;
                }

                _context8.next = 19;
                return _context8.t0.res.text();

              case 19:
                message = _context8.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context8.abrupt('return');

              case 22:
                Bugsnag.notifyException(_context8.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context8.abrupt('return');

              case 25:
                _context8.next = 27;
                return this.setLoading(false);

              case 27:
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Discount Package Deleted', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('{{item}} was successfully removed', { item: item.name, ns: _translation.TRANSLATION_FILES.translation })
                }));
                project.projectPricings = data;
                this.setState({ project: project }, function () {
                  _this4.handleCheckChanges();
                  _this4.props.newFetch();
                });

              case 30:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[7, 12]]);
      }));

      function deletePricingTier(_x8) {
        return _ref8.apply(this, arguments);
      }

      return deletePricingTier;
    }()
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var admin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var dhq = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var dbl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var dbls = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var adminBasic = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      if (admin && this.props.auth.isSuperAdmin) {
        return true;
      }
      if (adminBasic && this.props.auth.isAdminBasic) {
        return true;
      }
      if (dhq && this.props.auth.isHeadquarters) {
        return true;
      }
      if (dbl && this.props.auth.isBranchLeader) {
        return true;
      }
      if (dbls && this.props.auth.isBranchLeaderSupervisorII) {
        return true;
      }
      return false;
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'bulkUpsertAndDeleteProjectFormAccessibilities',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var store, t, _state2, formAccessibilitiesTemplateIDs, project, pendingUpsertPFAs, projectFAs;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                _state2 = this.state, formAccessibilitiesTemplateIDs = _state2.formAccessibilitiesTemplateIDs, project = _state2.project;
                pendingUpsertPFAs = [];

                if (formAccessibilitiesTemplateIDs && formAccessibilitiesTemplateIDs.length > 0) {
                  projectFAs = [];

                  if (project && project.projectFormAccessibilities && project.projectFormAccessibilities.length > 0) {
                    projectFAs = project.projectFormAccessibilities;
                  }
                  pendingUpsertPFAs = formAccessibilitiesTemplateIDs.map(function (templateID) {
                    var pfaIdx = projectFAs.findIndex(function (p) {
                      return p.templateID === templateID;
                    });
                    if (pfaIdx !== -1) {
                      return projectFAs[pfaIdx];
                    }
                    return {
                      projectID: project.id,
                      templateID: templateID,
                      companyBranchIDs: [],
                      companyBranchAwsIDs: [],
                      isEnabledOnReserved: true,
                      isEnabledOnBooked: true,
                      isEnabledOnSold: true,
                      isVisibleToLawyer: true
                    };
                  });
                }
                _context9.prev = 5;
                _context9.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + project.id + '/form_accessibilities/bulk/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(pendingUpsertPFAs)
                }));

              case 8:
                _context9.next = 14;
                break;

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9['catch'](5);

                Bugsnag.notifyException(_context9.t0);
                store.dispatch((0, _flash.flashErrorMessage)(t('An error occured', { ns: _translation.TRANSLATION_FILES.translation })));

              case 14:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[5, 10]]);
      }));

      function bulkUpsertAndDeleteProjectFormAccessibilities() {
        return _ref9.apply(this, arguments);
      }

      return bulkUpsertAndDeleteProjectFormAccessibilities;
    }()
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'handleCheckIfPublish',
    value: function handleCheckIfPublish(e) {
      var _props$project = this.props.project,
          marketplaceIsPublish = _props$project.marketplaceIsPublish,
          statusID = _props$project.statusID;
      var project = this.state.project;

      e.preventDefault();
      var isDeleted = project.statusID === 'draft' || project.statusID === 'archived' || project.statusID === 'deleted';
      if (marketplaceIsPublish && statusID === 'published' && isDeleted) {
        this.setState({ openModal: true });
      } else {
        this.handleSubmit(e);
      }
    }
  }, {
    key: 'handleAddBankAccount',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(validations, _ref11) {
        var value = _ref11.value;

        var _state3, project, genericErrMsg, store, response;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _state3 = this.state, project = _state3.project, genericErrMsg = _state3.genericErrMsg;
                store = this.context.store;

                if (!project.projectBankAccount) project.projectBankAccount = [];

                if (!(0, _validations.validateForm)(store, validations)) {
                  _context10.next = 5;
                  break;
                }

                return _context10.abrupt('return');

              case 5:
                if (this.hasUpdateAccess()) {
                  _context10.next = 9;
                  break;
                }

                // during project creation
                project.projectBankAccount.push(value);
                this.setState({ project: project });
                return _context10.abrupt('return');

              case 9:
                _context10.next = 11;
                return this.setLoading(true);

              case 11:
                _context10.prev = 11;
                _context10.next = 14;
                return (0, _fetchM.serverRequestPost)('/projects/' + project.id + '/bank_accounts/', store, this.props.token, value);

              case 14:
                response = _context10.sent;

                if (!response.error) {
                  _context10.next = 18;
                  break;
                }

                this.handleError(store, response.message);
                return _context10.abrupt('return');

              case 18:
                project.projectBankAccount.push(response.data);
                this.setState({ project: project });
                _context10.next = 22;
                return this.setLoading(false);

              case 22:
                _context10.next = 27;
                break;

              case 24:
                _context10.prev = 24;
                _context10.t0 = _context10['catch'](11);

                this.handleError(store, genericErrMsg, _context10.t0, true);

              case 27:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[11, 24]]);
      }));

      function handleAddBankAccount(_x14, _x15) {
        return _ref10.apply(this, arguments);
      }

      return handleAddBankAccount;
    }()
  }, {
    key: 'handleAddCurrency',
    value: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(validations, _ref13) {
        var value = _ref13.value;

        var _state4, project, genericErrMsg, store, response;

        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _state4 = this.state, project = _state4.project, genericErrMsg = _state4.genericErrMsg;
                store = this.context.store;

                if (!project.projectCurrency) project.projectCurrency = [];

                if (!(0, _validations.validateForm)(store, validations)) {
                  _context11.next = 5;
                  break;
                }

                return _context11.abrupt('return');

              case 5:
                _context11.next = 7;
                return this.setLoading(true);

              case 7:
                if (this.hasUpdateAccess()) {
                  _context11.next = 13;
                  break;
                }

                // during project creation
                project.projectCurrency.push(value);
                this.setState({ project: project });
                _context11.next = 12;
                return this.setLoading(false);

              case 12:
                return _context11.abrupt('return');

              case 13:
                _context11.prev = 13;
                _context11.next = 16;
                return (0, _fetchM.serverRequestPost)('/projects/' + project.id + '/currency/', store, this.props.token, value);

              case 16:
                response = _context11.sent;

                if (!response.error) {
                  _context11.next = 20;
                  break;
                }

                this.handleError(store, response.message);
                return _context11.abrupt('return');

              case 20:
                project.projectCurrency.push(response.data);
                this.setState({ project: project });
                _context11.next = 24;
                return this.setLoading(false);

              case 24:
                _context11.next = 29;
                break;

              case 26:
                _context11.prev = 26;
                _context11.t0 = _context11['catch'](13);

                this.handleError(store, genericErrMsg, _context11.t0, true);

              case 29:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this, [[13, 26]]);
      }));

      function handleAddCurrency(_x16, _x17) {
        return _ref12.apply(this, arguments);
      }

      return handleAddCurrency;
    }()
  }, {
    key: 'handleError',
    value: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(store, msg, errorObj) {
        var isBugsnag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.setLoading(false);

              case 2:
                _context12.next = 4;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: msg }));

              case 4:
                if (isBugsnag) Bugsnag.notifyException(errorObj);

              case 5:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function handleError(_x18, _x19, _x20) {
        return _ref14.apply(this, arguments);
      }

      return handleError;
    }()
  }, {
    key: 'handleMakeDefaultCurrency',
    value: function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(e, _ref16) {
        var value = _ref16.value;

        var _state5, project, genericErrMsg, store, currentDefault, newData, promiseArr, promiseResultArray, noError, _newData;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _state5 = this.state, project = _state5.project, genericErrMsg = _state5.genericErrMsg;
                store = this.context.store;
                currentDefault = project.projectCurrency.find(function (val) {
                  return val.isDefault === true;
                });

                if (currentDefault) {
                  _context13.next = 6;
                  break;
                }

                this.handleError(store, genericErrMsg);
                return _context13.abrupt('return');

              case 6:
                if (this.hasUpdateAccess()) {
                  _context13.next = 13;
                  break;
                }

                // during project creation

                newData = project.projectCurrency.map(function (d) {
                  var currency = d;
                  if (currency.code === currentDefault.code) currency.isDefault = false;
                  if (currency.code === value.code) currency.isDefault = true;

                  return currency;
                });

                project.projectCurrency = newData;
                this.setState({ project: project });
                _context13.next = 12;
                return this.setLoading(false);

              case 12:
                return _context13.abrupt('return');

              case 13:
                _context13.prev = 13;
                _context13.next = 16;
                return this.setLoading(true);

              case 16:
                promiseArr = [(0, _fetchM.serverRequestPut)('/projects/' + project.id + '/currency/' + currentDefault.id + '/', store, this.props.token, { isDefault: false }), (0, _fetchM.serverRequestPut)('/projects/' + project.id + '/currency/' + value.id + '/', store, this.props.token, { isDefault: true })];
                _context13.next = 19;
                return Promise.all(promiseArr);

              case 19:
                promiseResultArray = _context13.sent;
                noError = promiseResultArray.every(function (res) {
                  return res.error === false;
                });

                if (noError) {
                  _context13.next = 24;
                  break;
                }

                this.handleError(store, genericErrMsg);
                return _context13.abrupt('return');

              case 24:
                _newData = project.projectCurrency.map(function (d) {
                  var currency = d;
                  if (currency.id === currentDefault.id) currency.isDefault = false;
                  if (currency.id === value.id) currency.isDefault = true;

                  return currency;
                });

                project.projectCurrency = _newData;
                this.setLoading(false);
                this.setState({ project: project });
                _context13.next = 33;
                break;

              case 30:
                _context13.prev = 30;
                _context13.t0 = _context13['catch'](13);

                this.handleError(store, genericErrMsg, _context13.t0, true);

              case 33:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this, [[13, 30]]);
      }));

      function handleMakeDefaultCurrency(_x22, _x23) {
        return _ref15.apply(this, arguments);
      }

      return handleMakeDefaultCurrency;
    }()
  }, {
    key: 'handleSaveBankAccount',
    value: function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(validations, _ref18) {
        var value = _ref18.value;

        var _state6, project, genericErrMsg, store, i, response;

        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _state6 = this.state, project = _state6.project, genericErrMsg = _state6.genericErrMsg;
                store = this.context.store;

                if (!(0, _validations.validateForm)(store, validations)) {
                  _context14.next = 4;
                  break;
                }

                return _context14.abrupt('return');

              case 4:
                i = project.projectBankAccount.findIndex(function (val) {
                  return val.id === value.id;
                });

                if (!(i === -1)) {
                  _context14.next = 8;
                  break;
                }

                this.handleError(store, genericErrMsg);
                return _context14.abrupt('return');

              case 8:

                // only allow update conversion rate
                project.projectBankAccount[i].isActive = value.isActive;

                if (this.hasUpdateAccess()) {
                  _context14.next = 12;
                  break;
                }

                // during project creation
                this.setState({ project: project });
                return _context14.abrupt('return');

              case 12:
                _context14.next = 14;
                return this.setLoading(true);

              case 14:
                _context14.prev = 14;
                _context14.next = 17;
                return (0, _fetchM.serverRequestPut)('/projects/' + project.id + '/bank_accounts/' + value.id + '/', store, this.props.token, { isActive: value.isActive });

              case 17:
                response = _context14.sent;

                if (!response.error) {
                  _context14.next = 22;
                  break;
                }

                _context14.next = 21;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: response.message }));

              case 21:
                return _context14.abrupt('return');

              case 22:
                this.setState({ project: project });
                _context14.next = 25;
                return this.setLoading(false);

              case 25:
                _context14.next = 30;
                break;

              case 27:
                _context14.prev = 27;
                _context14.t0 = _context14['catch'](14);

                this.handleError(store, genericErrMsg, _context14.t0, true);

              case 30:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this, [[14, 27]]);
      }));

      function handleSaveBankAccount(_x24, _x25) {
        return _ref17.apply(this, arguments);
      }

      return handleSaveBankAccount;
    }()
  }, {
    key: 'handleSaveCurrency',
    value: function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(validations, _ref20) {
        var value = _ref20.value;

        var _state7, project, genericErrMsg, store, i, response;

        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _state7 = this.state, project = _state7.project, genericErrMsg = _state7.genericErrMsg;
                store = this.context.store;

                if (!(0, _validations.validateForm)(store, validations)) {
                  _context15.next = 4;
                  break;
                }

                return _context15.abrupt('return');

              case 4:
                _context15.next = 6;
                return this.setLoading(true);

              case 6:
                i = project.projectCurrency.findIndex(function (val) {
                  return val.code === value.code && val.id === value.id;
                });

                if (!(i === -1)) {
                  _context15.next = 10;
                  break;
                }

                this.handleError(store, genericErrMsg);
                return _context15.abrupt('return');

              case 10:

                // only allow update conversion rate
                project.projectCurrency[i].conversionRatePoint = value.conversionRatePoint;

                if (this.hasUpdateAccess()) {
                  _context15.next = 16;
                  break;
                }

                // during project creation
                this.setState({ project: project });
                _context15.next = 15;
                return this.setLoading(false);

              case 15:
                return _context15.abrupt('return');

              case 16:
                _context15.prev = 16;
                _context15.next = 19;
                return (0, _fetchM.serverRequestPut)('/projects/' + project.id + '/currency/' + value.id + '/', store, this.props.token, { conversionRatePoint: value.conversionRatePoint });

              case 19:
                response = _context15.sent;

                if (!response.error) {
                  _context15.next = 24;
                  break;
                }

                _context15.next = 23;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: response.message }));

              case 23:
                return _context15.abrupt('return');

              case 24:
                this.setState({ project: project });
                _context15.next = 27;
                return this.setLoading(false);

              case 27:
                _context15.next = 32;
                break;

              case 29:
                _context15.prev = 29;
                _context15.t0 = _context15['catch'](16);

                this.handleError(store, genericErrMsg, _context15.t0, true);

              case 32:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this, [[16, 29]]);
      }));

      function handleSaveCurrency(_x26, _x27) {
        return _ref19.apply(this, arguments);
      }

      return handleSaveCurrency;
    }()
  }, {
    key: 'handleSaveTemplateToggle',
    value: function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(id, value) {
        var _state8, genericErrMsg, templatesToken, t, store, response;

        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _state8 = this.state, genericErrMsg = _state8.genericErrMsg, templatesToken = _state8.templatesToken;
                t = this.props.t;
                store = this.context.store;
                _context16.next = 5;
                return this.setLoading(true);

              case 5:
                _context16.prev = 5;
                _context16.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/templates/' + id + '/access/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': templatesToken
                  },
                  body: JSON.stringify(value)
                }));

              case 8:
                response = _context16.sent;

                if (!response.error) {
                  _context16.next = 13;
                  break;
                }

                _context16.next = 12;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: response.message }));

              case 12:
                return _context16.abrupt('return');

              case 13:
                _context16.next = 15;
                return store.dispatch((0, _templates.fetchTemplates)('print', true));

              case 15:
                _context16.next = 17;
                return this.setLoading(false);

              case 17:
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('{{name}} template access updated', { name: value.name, ns: _translation.TRANSLATION_FILES.translation })
                }));
                _context16.next = 23;
                break;

              case 20:
                _context16.prev = 20;
                _context16.t0 = _context16['catch'](5);

                this.handleError(store, genericErrMsg, _context16.t0, true);

              case 23:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this, [[5, 20]]);
      }));

      function handleSaveTemplateToggle(_x28, _x29) {
        return _ref21.apply(this, arguments);
      }

      return handleSaveTemplateToggle;
    }()
  }, {
    key: 'handleUpdateHimsForBookings',
    value: function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var store, project, t, res, message, _message;

        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                project = this.state.project;
                t = this.props.t;
                res = void 0;
                _context17.prev = 6;
                _context17.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + project.id + '/bookings/hims/bulk/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  }
                }));

              case 9:
                res = _context17.sent;
                _context17.next = 26;
                break;

              case 12:
                _context17.prev = 12;
                _context17.t0 = _context17['catch'](6);
                _context17.next = 16;
                return this.setLoading(false);

              case 16:
                if (!(_context17.t0.res && _context17.t0.res.status >= 400 && _context17.t0.res.status < 500)) {
                  _context17.next = 22;
                  break;
                }

                _context17.next = 19;
                return _context17.t0.res.text();

              case 19:
                message = _context17.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context17.abrupt('return');

              case 22:
                Bugsnag.notifyException(_context17.t0);
                _context17.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 25:
                return _context17.abrupt('return');

              case 26:
                if (res.ok) {
                  _context17.next = 34;
                  break;
                }

                _context17.next = 29;
                return res.text();

              case 29:
                _message = _context17.sent;
                _context17.next = 32;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 32:
                _context17.next = 36;
                break;

              case 34:
                _context17.next = 36;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('HIMS data successfully updated in all bookings', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 36:
                _context17.next = 38;
                return this.setLoading(false);

              case 38:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this, [[6, 12]]);
      }));

      function handleUpdateHimsForBookings() {
        return _ref22.apply(this, arguments);
      }

      return handleUpdateHimsForBookings;
    }()
  }, {
    key: 'buyerMarketplaceHasAccess',
    value: function buyerMarketplaceHasAccess() {
      var companyApps = this.props.auth.companyApps;

      if (companyApps) {
        var buyerMarketplace = companyApps.find(function (ca) {
          return ca.appID === _apps.BUYER_MARKETPLACE;
        });
        return buyerMarketplace && buyerMarketplace.hasAccess;
      }
      return false;
    }
  }, {
    key: 'hasSiteplan',
    value: function hasSiteplan(checkType) {
      var _state9 = this.state,
          siteplanHasSvg = _state9.siteplanHasSvg,
          siteplanHasImage = _state9.siteplanHasImage;

      if (checkType) {
        if (checkType === 'svg') {
          return siteplanHasSvg;
        }
        return siteplanHasImage;
      }
      return siteplanHasSvg && siteplanHasImage;
    }
  }, {
    key: 'getCompanyCurrencyOptions',
    value: function getCompanyCurrencyOptions() {
      var _props$auth$company$c2 = this.props.auth.company.companyCurrency,
          companyCurrency = _props$auth$company$c2 === undefined ? [] : _props$auth$company$c2;

      return companyCurrency.map(function (c) {
        return {
          text: c.name,
          value: c.code
        };
      });
    }
  }, {
    key: 'getCompanyDefaultCurrency',
    value: function getCompanyDefaultCurrency() {
      var _props$auth$company$c3 = this.props.auth.company.companyCurrency,
          companyCurrency = _props$auth$company$c3 === undefined ? [] : _props$auth$company$c3;

      var currency = companyCurrency.find(function (c) {
        return c.isDefault;
      }) || {};
      return currency.code || '';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state10 = this.state,
          project = _state10.project,
          oriProject = _state10.oriProject,
          formAccessibilitiesTemplateIDs = _state10.formAccessibilitiesTemplateIDs,
          pTemplates = _state10.pTemplates,
          printTemplates = _state10.printTemplates,
          printLoanReminderTemplates = _state10.printLoanReminderTemplates,
          printSPAReminderTemplates = _state10.printSPAReminderTemplates,
          printTerminationTemplates = _state10.printTerminationTemplates,
          salesChartTemplates = _state10.salesChartTemplates,
          salesChartTypes = _state10.salesChartTypes,
          systemData = _state10.systemData,
          isVisible = _state10.isVisible,
          projectReservationTokenSetting = _state10.projectReservationTokenSetting;
      var t = this.props.t;
      // const bobTypes = [
      //   ...bobForms,
      // ];

      var printTypes = [{ text: t('None', { ns: _translation.TRANSLATION_FILES.constants }), value: 'none' }].concat(_toConsumableArray(printTemplates));
      var docxPrintIsSelected = false;
      if (project.printType !== 'none' && !project.printType.startsWith('db/templates/bookings/')) {
        docxPrintIsSelected = true;
      }
      var printLoanReminderTypes = [{ text: t('None', { ns: _translation.TRANSLATION_FILES.constants }), value: 'none' }].concat(_toConsumableArray(printLoanReminderTemplates));
      var printSPAReminderTypes = [{ text: t('None', { ns: _translation.TRANSLATION_FILES.constants }), value: 'none' }].concat(_toConsumableArray(printSPAReminderTemplates));
      var printTerminationTypes = [{ text: t('None', { ns: _translation.TRANSLATION_FILES.constants }), value: 'none' }].concat(_toConsumableArray(printTerminationTemplates));
      var salesChartTemplateTypes = [{ text: t('Default'), value: 'default' }].concat(_toConsumableArray(salesChartTemplates));
      var exportItems = [{
        text: 'CSV',
        href: _config2.default.get('bookApiURL') + '/projects/' + project.id + '/siteplans/units/?fileType=csv'
      }, {
        text: 'Excel',
        href: _config2.default.get('bookApiURL') + '/projects/' + project.id + '/siteplans/units/?fileType=excel'
      }];
      var customerBookingSuccessEmailTypes = [{ text: t('Default'), value: 'email/booking_confirmed_customer.html' }].concat(_toConsumableArray(this.state.bookingCustomerSuccessEmailTemplates));
      // const billingDateSources = [
      //   { text: translateModels(t, 'spaSigningDate', 'booking'), value: 'spa_signing_date' },
      //   { text: translateModels(t, 'spaStampingDate', 'booking'), value: 'spa_stamping_date' },
      // ];

      var regions = systemData.regions ? systemData.regions : [];
      var regionOptions = regions.map(function (x) {
        return {
          value: x,
          text: x
        };
      });
      var townships = systemData.townships ? systemData.townships : [];
      var townshipOptions = townships.map(function (x) {
        return {
          value: x,
          text: x
        };
      });
      var pathname = this.props.location.pathname;

      var isCUExternalSelected = project.cuRoleAccesses && project.cuRoleAccesses.includes(_changeUnitsAccesses.CU_EXTERNAL_STAFF_ACCESS);

      var _props = this.props,
          addressSettings = _props.addressSettings,
          financeSources = _props.financeSources;

      var enabledFinanceSources = financeSources.data.filter(function (fs) {
        return fs.isEnabled;
      });
      var enabledAddressSettings = addressSettings.data.filter(function (as) {
        return as.enabled;
      });
      // TODO refactor all code related to country checking
      var isMalaysia = project.country.toUpperCase() === 'MY';
      var isVietnam = project.country.toUpperCase() === 'VN';
      // CPI-974 item 18: a Vietnam-only control, gated on the company country through the helper.
      var isVietnamCompany = (0, _countries.isCountryVietnam)(this.props.auth && this.props.auth.company && this.props.auth.company.countryCode);
      var eventTime = project.mpBuyerEventLaunchAt && (isVietnamCompany ? (0, _momentTimezone2.default)(project.mpBuyerEventLaunchAt).local() : (0, _momentTimezone2.default)(project.mpBuyerEventLaunchAt));
      // Hidden: no place to enter a payment on a Vietnamese Sales Overview since CPI-974; re-enable when the payment section returns.
      // const paymentApprovedRequiredStatusOptions = BOOKING_STATUSES
      //   .filter(s => s.value === 'booked' || s.value === 'sold_spa_signed')
      //   .map(s => ({ value: s.value, text: t(s.text, { ns: TRANSLATION_FILES.constants }) }));
      var inputs = enabledAddressSettings.map(function (as, idx) {
        var key = _lodash2.default.camelCase(as.columnName);
        var addressLabel = as.label.toLowerCase();
        var isRequired = as.required;
        var validations = [{
          validate: _webValidations.stringLength,
          option: {
            max: 256
          }
        }];

        // for Skyworld Vietnam, we update the label name for state/city/postcode to province/ward/postalCode
        // and set the required flag to false
        if (isVietnam && addressLabel === 'state') {
          addressLabel = 'cityOrProvince';
          isRequired = false;
        } else if (isVietnam && addressLabel === 'city') {
          addressLabel = 'ward';
          isRequired = false;
        } else if (isVietnam && addressLabel === 'postcode') {
          addressLabel = 'postalCode';
          isRequired = false;
        }

        if (isRequired) {
          validations.push(_webValidations.required);
        }

        var label = '' + (0, _translation2.translateModels)(t, addressLabel, 'project') + (isRequired ? '*' : '');

        if (isMalaysia && as.label.toLowerCase() === 'state') {
          return _react2.default.createElement(
            _AppForm2.default.Validate,
            {
              key: idx,
              validation: as.required ? [_webValidations.required] : null,
              ref: _this5.validation[key],
              onChange: _this5.handleInputChange,
              validateLabel: as.label.toLowerCase() === 'state' ? (0, _translation2.translateModels)(t, 'state', 'project') : as.label
            },
            _react2.default.createElement(_semanticUiReact.Form.Select, {
              name: key,
              fluid: true,
              options: _states2.default,
              placeholder: t('Select {{title}}', { title: label.toLowerCase() }),
              label: label,
              search: true,
              selectOnBlur: false,
              value: project[key]
            })
          );
        }

        return _react2.default.createElement(_AppForm2.default.Input, {
          key: idx,
          autoComplete: 'off',
          name: key,
          onChange: _this5.handleInputChange,
          placeholder: label,
          label: label,
          ref: _this5.validation[key],
          validation: validations,
          value: project[key],
          validateLabel: as.label
        });
      });

      inputs.push.apply(inputs, [_react2.default.createElement(_semanticUiReact.Form.Select, {
        key: 'inputs_region',
        label: (0, _translation2.translateModels)(t, 'region', 'project'),
        name: 'region',
        placeholder: t('{{title}}', { title: (0, _translation2.translateModels)(t, 'region', 'project') }),
        search: true,
        fluid: true,
        onChange: this.handleInputChange,
        value: project.region,
        options: regionOptions,
        noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
      }), _react2.default.createElement(_Select2.default, {
        key: 'inputs_country',
        validation: [_webValidations.required],
        ref: this.validation.country,
        onChange: function onChange(e, data) {
          // Reset state input field
          var as = enabledAddressSettings.find(function (a) {
            return a.label.toLowerCase() === 'state';
          });
          if (as) {
            var key = _lodash2.default.camelCase(as.columnName);
            if (project[key]) {
              project[key] = '';
              _this5.setState({ project: project });
            }
          }
          _this5.handleInputChange(e, data);
        },
        validateLabel: (0, _translation2.translateModels)(t, 'country', 'project'),
        autoComplete: 'off',
        label: (0, _translation2.translateModels)(t, 'country', 'project'),
        name: 'country',
        options: _countries.SELECT_COUNTRIES,
        placeholder: t('Select {{title}}', { title: (0, _translation2.translateModels)(t, 'country', 'project') }),
        selectOnBlur: false,
        value: project.country
      })].concat(_toConsumableArray(!isVietnam ? [_react2.default.createElement(_semanticUiReact.Form.Select, {
        key: 'inputs_township',
        label: (0, _translation2.translateModels)(t, 'township', 'project'),
        name: 'township',
        placeholder: t('Select {{title}}', { title: (0, _translation2.translateModels)(t, 'township', 'project') }),
        search: true,
        fluid: true,
        onChange: this.handleInputChange,
        value: project.township,
        options: townshipOptions
      })] : [])));
      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref36) {
            _this5.form = _ref36;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.props.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 16, tablet: 16, computer: 4 },
              _react2.default.createElement(
                _semanticUiReact.Menu,
                {
                  fluid: true,
                  widths: !this.state.menuIsTab ? 1 : null,
                  tabular: this.state.menuIsTab,
                  vertical: this.state.menuIsVertical
                },
                !this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
                  item: true,
                  selectOnBlur: false,
                  options: this.state.tabs.filter(function (tb) {
                    return tb;
                  }).map(function (tb, k) {
                    var tab = {
                      key: k,
                      text: t(tb.text),
                      name: tb.name,
                      value: tb.value,
                      redirectTo: tb.redirectTo,
                      label: _this5.state.errMessages.some(function (e) {
                        return tb.fields.some(function (f) {
                          return e.key === f;
                        });
                      }) ? {
                        color: 'red',
                        content: '!'
                      } : null
                    };
                    return tab;
                  }),
                  onChange: function onChange(e, props) {
                    var option = _lodash2.default.find(props.options, function (opt) {
                      return opt.name === props.value;
                    });
                    var url = option && option.redirectTo;
                    _this5.handleChangeTab(e, props, url);
                  },
                  value: this.state.currentTab,
                  disabled: this.state.loading
                }) : this.state.tabs.map(function (tab, key) {
                  if (tab) {
                    if (!systemData.docxTemplaterIsEnabled && tab.name === 'docx_templater_setting') {
                      return null;
                    }
                    return _react2.default.createElement(
                      _semanticUiReact.Menu.Item,
                      {
                        key: key,
                        name: tab.name,
                        onClick: function onClick(e, props) {
                          return _this5.handleChangeTab(e, props, tab.redirectTo);
                        },
                        active: _this5.state.currentTab === tab.name
                      },
                      t(tab.text),
                      _this5.state.errMessages.some(function (e) {
                        return tab.fields && tab.fields.some(function (f) {
                          return e.key === f;
                        });
                      }) ? _react2.default.createElement(_semanticUiReact.Label, { color: 'red', floating: !_this5.state.menuIsVertical, content: '!' }) : null
                    );
                  }
                  return null;
                }),
                this.state.menuIsTab ? _react2.default.createElement(
                  _semanticUiReact.Menu.Item,
                  { key: 'switch', name: 'switch' },
                  _react2.default.createElement(
                    'div',
                    { className: 'switch-button' },
                    _react2.default.createElement(_semanticUiReact.Button, {
                      basic: true,
                      as: 'a',
                      href: _config2.default.get('developerURL') + '/c/' + this.props.auth.company.service_company_id + pathname,
                      content: t('Switch to new layout')
                    })
                  )
                ) : null
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('info') },
              _react2.default.createElement(_Select2.default, {
                validation: [_webValidations.required],
                ref: this.validation.statusID,
                onChange: this.handleInputChange,
                label: (0, _translation2.translateModels)(t, 'statusID', 'project'),
                name: 'statusID',
                value: project.statusID,
                options: _projectStatuses2.default.map(function (ps) {
                  return _extends({}, ps, {
                    text: t(ps.text, { ns: _translation.TRANSLATION_FILES.constants })
                  });
                })
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                label: (0, _translation2.translateModels)(t, 'name', 'project'),
                name: 'name',
                value: project.name,
                onChange: this.handleInputChange,
                ref: this.validation.name,
                validation: [_webValidations.required]
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                label: (0, _translation2.translateModels)(t, 'shortName', 'project'),
                name: 'shortName',
                value: project.shortName,
                onChange: this.handleInputChange,
                ref: this.validation.shortName,
                validation: [_webValidations.required]
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                label: (0, _translation2.translateModels)(t, 'referenceCode', 'project'),
                name: 'referenceCode',
                value: project.referenceCode,
                onChange: this.handleInputChange,
                ref: this.validation.referenceCode
              }),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_semanticUiReact.Form.Select, {
                  label: (0, _translation2.translateModels)(t, 'phonePrefix', 'project'),
                  name: 'phonePrefix',
                  value: project.phonePrefix,
                  text: project.phonePrefix === '' ? t('Other', { ns: _translation.TRANSLATION_FILES.constants }) : null,
                  onChange: this.handleInputChange,
                  search: true,
                  options: _intlCallCodes2.default,
                  noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                }),
                _react2.default.createElement(_PhoneInput2.default, {
                  label: (0, _translation2.translateModels)(t, 'phone', 'project'),
                  type: 'tel',
                  name: 'phone',
                  value: project.phone,
                  onChange: this.handleInputChange,
                  ref: this.validation.phone,
                  prefix: project.phonePrefix,
                  placeholder: project.phonePrefix === '60' ? (0, _translation2.translateModels)(t, 'phone', 'project') + ' (e.g. 378317749)' : (0, _translation2.translateModels)(t, 'phone', 'project'),
                  validation: [_webValidations.required, _phone2.default]
                }),
                _react2.default.createElement(_semanticUiReact.Form.Input, {
                  label: (0, _translation2.translateModels)(t, 'published_at', 'project'),
                  type: 'datetime-local',
                  name: 'publishedAt',
                  value: project.publishedAt ? project.publishedAt.substring(0, 16) : '',
                  onChange: function onChange(e, _ref23) {
                    var value = _ref23.value;

                    project.publishedAt = value ? (0, _momentTimezone2.default)(value).format() : null;
                    _this5.setState({ project: project }, function () {
                      _this5.handleCheckChanges();
                    });
                  }
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Type')
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 2 },
                _react2.default.createElement(_Select2.default, {
                  validation: [_webValidations.required],
                  ref: this.validation.ownershipType,
                  onChange: this.handleInputChange,
                  label: (0, _translation2.translateModels)(t, 'ownershipType', 'project'),
                  name: 'ownershipType',
                  value: project.ownershipType,
                  options: this.ownershipTypes.map(function (ot) {
                    return _extends({}, ot, {
                      text: t(ot.text, { ns: _translation.TRANSLATION_FILES.constants })
                    });
                  })
                }),
                _react2.default.createElement(_Select2.default, {
                  validation: [_webValidations.required],
                  ref: this.validation.propertyCategoryID,
                  onChange: this.handleInputChange,
                  label: (0, _translation2.translateModels)(t, 'propertyCategoryID', 'project'),
                  name: 'propertyCategoryID',
                  value: project.propertyCategoryID,
                  options: this.propertyCategoryTypes.map(function (pct) {
                    return _extends({}, pct, {
                      text: t(pct.text, { ns: _translation.TRANSLATION_FILES.constants, storey: pct.storey })
                    });
                  })
                }),
                _react2.default.createElement(
                  _semanticUiReact.Form.Group,
                  { grouped: true },
                  _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Property Type') }),
                  _react2.default.createElement(
                    _semanticUiReact.Form.Group,
                    { grouped: true },
                    _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                      label: (0, _translation2.translateModels)(t, 'isCommercial', 'project'),
                      name: 'isCommercial',
                      checked: project.isCommercial,
                      onChange: this.handleCheckBoxChange
                    }),
                    _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                      label: (0, _translation2.translateModels)(t, 'isIndustrial', 'project'),
                      name: 'isIndustrial',
                      checked: project.isIndustrial,
                      onChange: this.handleCheckBoxChange
                    }),
                    _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                      label: (0, _translation2.translateModels)(t, 'isResidential', 'project'),
                      name: 'isResidential',
                      checked: project.isResidential,
                      onChange: this.handleCheckBoxChange
                    })
                  )
                )
              ),
              (0, _foreignPurchaseThreshold.showsForeignPurchaseThreshold)(this.props.auth) && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Divider,
                  { horizontal: true },
                  t('Foreign Purchase Control')
                ),
                _react2.default.createElement(
                  _semanticUiReact.Form.Group,
                  { widths: 3 },
                  _react2.default.createElement(
                    _semanticUiReact.Form.Field,
                    null,
                    _react2.default.createElement(_AppForm2.default.Input, {
                      label: (0, _translation2.translateModels)(t, 'foreignPurchaseThreshold', 'project'),
                      name: 'foreignPurchaseThreshold',
                      value: project.foreignPurchaseThreshold,
                      onChange: this.handleInputChange,
                      ref: this.validation.foreignPurchaseThreshold,
                      validation: [_foreignPurchaseThreshold.validateForeignPurchaseThreshold],
                      message: t('Enter a value from 0–100. Only numeric input is accepted.'),
                      type: 'text',
                      icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'percent', fitted: true, color: 'grey' })
                    }),
                    _react2.default.createElement(
                      'i',
                      { style: { color: 'grey' } },
                      t('Enter a value from 0–100. Only numeric input is accepted.')
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: (0, _translation2.translateModels)(t, 'manualPrice', 'project'),
                  name: 'manualPrice',
                  checked: project.manualPrice,
                  onChange: this.handleCheckBoxChange
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Minimum'),
                  type: 'text',
                  name: 'minPrice',
                  value: this.formatVND(this.state.project.minPrice),
                  onChange: this.handleInputChange,
                  ref: this.validation.minPrice,
                  disabled: !project.manualPrice
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Maximum'),
                  type: 'text',
                  name: 'maxPrice',
                  value: this.formatVND(this.state.project.maxPrice),
                  onChange: this.handleInputChange,
                  ref: this.validation.maxPrice,
                  disabled: !project.manualPrice
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: (0, _translation2.translateModels)(t, 'manualSize', 'project'),
                  name: 'manualSize',
                  checked: project.manualSize,
                  onChange: this.handleCheckBoxChange
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Minimum'),
                  type: 'number',
                  name: 'minSize',
                  value: project.minSize,
                  onChange: this.handleInputChange,
                  ref: this.validation.minSize,
                  disabled: !project.manualSize,
                  step: '0.0001'
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Maximum'),
                  type: 'number',
                  name: 'maxSize',
                  value: project.maxSize,
                  onChange: this.handleInputChange,
                  ref: this.validation.maxSize,
                  disabled: !project.manualSize,
                  step: '0.0001'
                })
              ),
              _react2.default.createElement(_Select2.default, {
                validation: [_webValidations.required],
                ref: this.validation.sizeSuffix,
                onChange: this.handleInputChange,
                label: (0, _translation2.translateModels)(t, 'sizeSuffix', 'project'),
                name: 'sizeSuffix',
                value: project.sizeSuffix,
                options: this.areaUnits.map(function (an) {
                  return _extends({}, an, {
                    text: isVietnamCompany && an.value === 'square_metres' ? t('Square Metres (m²)', { ns: _translation.TRANSLATION_FILES.constants }) : t(an.text, { ns: _translation.TRANSLATION_FILES.constants })
                  });
                })
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('location') },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { style: { height: '100%' }, verticalAlign: 'top' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,

                    // group 2 inputs into one Form.Group
                    // https://stackoverflow.com/questions/49491452/map-an-array-by-every-two-elements
                    _lodash2.default.chunk(inputs, 2).map(function (p, idx) {
                      return _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal', key: 'group_' + idx },
                        p
                      );
                    })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('specifications') },
              _react2.default.createElement(_SpecificationTable2.default, {
                type: 'projects',
                editable: true,
                isEditing: true,
                hideButton: true,
                data: project.specifications,
                onChange: this.handleSpecificationsChange,
                loading: this.state.loading
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('overview') },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { style: { height: '100%' }, verticalAlign: 'top' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { widths: 'equal' },
                      _react2.default.createElement(_semanticUiReact.Form.Input, {
                        label: (0, _translation2.translateModels)(t, 'overviewTitle', 'project'),
                        name: 'overviewTitle',
                        fluid: true,
                        value: project.overviewTitle,
                        onChange: this.handleInputChange
                      }),
                      _react2.default.createElement(_semanticUiReact.Form.Input, {
                        label: (0, _translation2.translateModels)(t, 'overviewSubTitle', 'project'),
                        name: 'overviewSubTitle',
                        fluid: true,
                        value: project.overviewSubTitle,
                        onChange: this.handleInputChange
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Segment,
                      { padded: true, style: { border: '1px solid rgba(34,36,38,0.15)', borderRadius: 8, marginBottom: '1rem' } },
                      _react2.default.createElement(
                        _semanticUiReact.Form.Field,
                        null,
                        _react2.default.createElement(
                          'label',
                          null,
                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'external alternate' }),
                          ' ',
                          (0, _translation2.translateModels)(t, 'externalLink', 'project')
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Form.Group,
                          { widths: 'equal' },
                          _react2.default.createElement(_semanticUiReact.Form.Input, {
                            width: 6,
                            label: (0, _translation2.translateModels)(t, 'buttonName', 'project'),
                            name: 'overviewExtLinkTitle',
                            value: project.overviewExtLinkTitle || '',
                            onChange: this.handleInputChange
                          }),
                          _react2.default.createElement(_semanticUiReact.Form.Input, {
                            width: 10,
                            label: (0, _translation2.translateModels)(t, 'linkUrl', 'project'),
                            name: 'overviewExtLinkUrl',
                            value: project.overviewExtLinkUrl || '',
                            onChange: this.handleInputChange
                          })
                        )
                      )
                    ),
                    _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                      label: (0, _translation2.translateModels)(t, 'overview', 'project'),
                      name: 'overview',
                      value: project.overview,
                      onChange: this.handleInputChange
                    }),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Preview', { ns: _translation.TRANSLATION_FILES.translation })
                    ),
                    project.overviewTitle || project.overviewSubTitle ? _react2.default.createElement(_semanticUiReact.Header, {
                      as: 'h2',
                      content: project.overviewTitle || project.overviewSubTitle,
                      subheader: project.overviewTitle ? project.overviewSubTitle : null
                    }) : null,
                    project.overviewExtLinkUrl ? _react2.default.createElement(
                      _semanticUiReact.Button,
                      {
                        href: (0, _url.sanitizeUrl)(project.overviewExtLinkUrl),
                        target: '_blank',
                        rel: 'noopener noreferrer',
                        primary: true,
                        compact: true,
                        style: { marginBottom: '0.5rem' }
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'external alternate' }),
                      project.overviewExtLinkTitle
                    ) : null,
                    project.overview ? _react2.default.createElement(_MarkdownText2.default, { content: project.overview }) : null
                  )
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('company_info') },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { style: { height: '100%' } },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Company Info')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { widths: 'equal' },
                      _react2.default.createElement(_semanticUiReact.Form.Input, {
                        label: t('Name'),
                        name: 'companyName',
                        fluid: true,
                        value: project.companyName,
                        onChange: this.handleInputChange
                      }),
                      _react2.default.createElement(_semanticUiReact.Form.Input, {
                        label: t('Registration No.'),
                        name: 'companyRegistrationNo',
                        fluid: true,
                        value: project.companyRegistrationNo,
                        onChange: this.handleInputChange
                      })
                    ),
                    _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                      label: t('Address'),
                      name: 'companyAddress',
                      value: project.companyAddress,
                      onChange: this.handleInputChange
                    }),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { widths: 'equal' },
                      _react2.default.createElement(_semanticUiReact.Form.Input, {
                        label: t('Contact No. {{count}}', { count: 1 }),
                        name: 'companyContactNo1',
                        fluid: true,
                        value: project.companyContactNo1,
                        onChange: this.handleInputChange
                      }),
                      _react2.default.createElement(_semanticUiReact.Form.Input, {
                        label: t('Contact No. {{count}}', { count: 2 }),
                        name: 'companyContactNo2',
                        fluid: true,
                        value: project.companyContactNo2,
                        onChange: this.handleInputChange
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { widths: 'equal' },
                      _react2.default.createElement(_AppForm2.default.Input, {
                        label: t('Email'),
                        name: 'companyEmail',
                        type: 'email',
                        fluid: true,
                        value: project.companyEmail,
                        onChange: this.handleInputChange,
                        validation: [_webValidations.email],
                        ref: this.validation.companyEmail
                      }),
                      _react2.default.createElement(_semanticUiReact.Form.Input, {
                        label: t('Others', { ns: _translation.TRANSLATION_FILES.constants }),
                        name: 'companyOthers',
                        fluid: true,
                        value: project.companyOthers,
                        onChange: this.handleInputChange
                      })
                    )
                  )
                )
              )
            ),
            isMalaysia && this.hasCompanyHimsEnabled() ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: !this.isActiveTab('hims_setup'), className: this.checkActiveTab('hims_setup') },
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: 'HIMS Integration',
                  name: 'himsIsEnabled',
                  checked: project.himsIsEnabled,
                  onChange: this.handleCheckBoxChange
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 8, computer: 8 },
                  _react2.default.createElement(_AppForm2.default.Select, {
                    label: 'Strata Project',
                    name: 'himsStrataIsEnabled',
                    value: project.himsStrataIsEnabled,
                    options: _hims.HIMS_STRATA_OPTIONS,
                    disabled: !project.himsIsEnabled || this.state.companyHimsTokensLoading,
                    validation: project.himsIsEnabled ? [_webValidations.required] : null,
                    ref: this.validation.himsStrataIsEnabled,
                    validateLabel: 'Strata Project',
                    onChange: this.handleInputChange
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 16, computer: 16 },
                  _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    label: 'Hide HIMS Strata fields to agents',
                    name: 'himsStrataIsHidden',
                    checked: project.himsStrataIsHidden,
                    onChange: this.handleCheckBoxChange,
                    disabled: project.himsStrataIsEnabled !== 'yes' || !project.himsIsEnabled || this.state.companyHimsTokensLoading
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 8, computer: 8 },
                  _react2.default.createElement(_AppForm2.default.Select, {
                    label: 'Default SPA lawyer representation in e-SPA',
                    name: 'himsDefaultSpaLawyerRepID',
                    value: project.himsDefaultSpaLawyerRepID,
                    options: _hims.HIMS_SPA_LAWYER_REP_OPTIONS,
                    disabled: !project.himsIsEnabled || this.state.companyHimsTokensLoading,
                    validation: project.himsIsEnabled ? [_webValidations.required] : null,
                    ref: this.validation.himsDefaultSpaLawyerRepID,
                    validateLabel: 'Default SPA lawyer representation in e-SPA',
                    onChange: this.handleInputChange
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                'HIMS Info'
              ),
              _react2.default.createElement(_ProjectHimsSettingsForm2.default, {
                ref: this.himsSettingsForm,
                projectID: project.id,
                companyHimsTokens: this.state.companyHimsTokens,
                onChange: this.handleOnHimsSettingsChange,
                himsSettings: project.projectHimsSettings,
                disabled: !project.himsIsEnabled || this.state.companyHimsTokensLoading
              }),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                'HIMS bookings'
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Segment,
                      { style: { display: 'flex', justifyContent: 'center' } },
                      _react2.default.createElement(
                        _semanticUiReact.Button,
                        {
                          type: 'button',
                          disabled: !project.himsIsEnabled || this.state.companyHimsTokensLoading,
                          onClick: function onClick() {
                            return _this5.handleUpdateHimsForBookings();
                          }
                        },
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh' }),
                        'Applies HIMS data to all HIMS enabled bookings'
                      )
                    )
                  )
                )
              )
            ) : null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('setup') },
              this.hasAccess(true, true, true) && _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Management')
              ),
              this.hasAccess(true, true, false) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  { style: { marginBottom: '4px', fontWeight: 'bold' } },
                  (0, _translation2.translateModels)(t, 'maOwnerCompanyBranchShortName', 'project'),
                  '*'
                ),
                _react2.default.createElement(_SearchBranch2.default, {
                  onClear: this.handleBranchClear,
                  onSelect: this.handleBranchSelect,
                  selectedValue: this.getSelectedBranchValue()
                }),
                _react2.default.createElement('br', null)
              ),
              this.hasAccess(true, true, false) && _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { grouped: true },
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: (0, _translation2.translateModels)(t, 'isPublic', 'project'),
                  name: 'isPublic',
                  checked: project.isPublic,
                  onChange: this.handleCheckBoxChange
                })
              ),
              this.hasAccess(true, true, true) && _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { grouped: true },
                _react2.default.createElement(
                  _semanticUiReact.Form.Group,
                  { grouped: true },
                  _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    label: (0, _translation2.translateModels)(t, 'isLaunchMode', 'project'),
                    name: 'isLaunchMode',
                    checked: project.isLaunchMode,
                    onChange: this.handleCheckBoxChange
                  }),
                  _react2.default.createElement(_AppForm2.default.Input, {
                    disabled: !project.isLaunchMode,
                    label: (0, _translation2.translateModels)(t, 'launchModeMinutes', 'project'),
                    name: 'launchModeMinutes',
                    value: project.launchModeMinutes,
                    validation: [_webValidations.required, {
                      validate: _webValidations.numericRange,
                      option: {
                        min: project.isLaunchMode ? 1 : 0
                      }
                    }],
                    onChange: this.handleInputChange,
                    ref: this.validation.launchModeMinutes,
                    type: 'number',
                    pattern: '[0-9]*'
                  })
                )
              ),
              this.hasAccess(true, true, true) && _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { grouped: true },
                _react2.default.createElement(
                  _semanticUiReact.Form.Group,
                  { grouped: true },
                  _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    disabled: !project.isLaunchMode,
                    label: (0, _translation2.translateModels)(t, 'bapEnabledInLaunchMode', 'project'),
                    name: 'bapIsEnabled',
                    checked: project.bapIsEnabled,
                    onChange: this.handleCheckBoxChange
                  }),
                  _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    disabled: !project.bapIsEnabled || !project.isLaunchMode,
                    label: (0, _translation2.translateModels)(t, 'bapProjectWideMode', 'project'),
                    name: 'bapIsProjectMode',
                    checked: project.bapIsProjectMode,
                    onChange: this.handleCheckBoxChange
                  }),
                  _react2.default.createElement(_AppForm2.default.Input, {
                    disabled: !project.bapIsEnabled || !project.isLaunchMode,
                    label: (0, _translation2.translateModels)(t, 'bapMaxAttempts', 'project'),
                    name: 'bapMaxAttempts',
                    value: project.bapMaxAttempts,
                    validation: [_webValidations.required, {
                      validate: _webValidations.numericRange,
                      option: {
                        min: 1
                      }
                    }],
                    onChange: this.handleInputChange,
                    ref: this.validation.bapMaxAttempts,
                    type: 'number',
                    pattern: '[0-9]*'
                  }),
                  _react2.default.createElement(_DropdownInputNumber2.default, {
                    disabled: !project.bapIsEnabled || !project.isLaunchMode,
                    label: (0, _translation2.translateModels)(t, 'bapAttemptWindow', 'project'),
                    presetOptions: this.state.bapCooldownOptions,
                    placeholder: 'Attempt Window',
                    name: 'bapWindowMinutes',
                    search: true,
                    selection: true,
                    fluid: true,
                    allowAdditions: true,
                    value: project.bapWindowMinutes,
                    onChange: this.handleChangeBAPWindow
                  }),
                  _react2.default.createElement(_DropdownInputNumber2.default, {
                    disabled: !project.bapIsEnabled || !project.isLaunchMode,
                    label: (0, _translation2.translateModels)(t, 'bapCooldownPeriod', 'project'),
                    presetOptions: this.bapMinutesOptions,
                    placeholder: 'Cooldown Minutes',
                    name: 'bapCooldownMinutes',
                    search: true,
                    selection: true,
                    fluid: true,
                    allowAdditions: true,
                    value: project.bapCooldownMinutes,
                    onChange: this.handleChangeBAPCooldown
                  })
                )
              ),
              this.hasAccess(true, true, true) && this.props.appConfig.data.onlinePaymentEnabled && _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { grouped: true },
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: (0, _translation2.translateModels)(t, 'isAPDL', 'project'),
                  name: 'isAPDL',
                  checked: project.isAPDL,
                  onChange: this.handleCheckBoxChange
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Unit Agency Allocation', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                label: t('Agency Allocation Logic', { ns: _translation.TRANSLATION_FILES.translation }),
                name: 'agencyAllocationAllocateAll',
                options: [{ key: 'allocateToAll', text: t('Allocate to all', { ns: _translation.TRANSLATION_FILES.translation }), value: true }, { key: 'allocateToNone', text: t('Allocate to none', { ns: _translation.TRANSLATION_FILES.translation }), value: false }],
                value: Boolean(project.agencyAllocationAllocateAll),
                onChange: this.handleInputChange,
                selection: true,
                fluid: true
              }),
              this.hasAccess(true, true, true) && _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('MHub Buyer App')
              ),
              this.hasAccess(true, true, true) && _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { grouped: true },
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: (0, _translation2.translateModels)(t, 'linkBuyerApp', 'project'),
                  name: 'linkBuyerApp',
                  checked: project.linkBuyerApp,
                  onChange: this.handleCheckBoxChange
                })
              ),
              this.hasAccess(true, true, false) && _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('MHub Bot')
              ),
              this.hasAccess(true, true, false) && _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { grouped: true },
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: (0, _translation2.translateModels)(t, 'isBotEnabled', 'project'),
                  name: 'isBotEnabled',
                  checked: project.isBotEnabled,
                  onChange: this.handleCheckBoxChange
                })
              ),
              this.hasAccess(true, true, true) && this.props.appConfig.data.creditControlIsEnabled && _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Credit Control')
              ),
              this.props.appConfig.data.creditControlIsEnabled && _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { grouped: true },
                this.hasAccess(true, true, true) && _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: (0, _translation2.translateModels)(t, 'creditControlIsUnlinked', 'project'),
                  name: 'creditControlIsUnlinked',
                  checked: project.creditControlIsUnlinked,
                  onChange: this.handleCheckBoxChange
                }),
                this.hasAccess(true, false, false, false, true) && _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: (0, _translation2.translateModels)(t, 'allowPurchaserEditAfterSold', 'project'),
                  name: 'allowPurchaserEditAfterSold',
                  checked: project.allowPurchaserEditAfterSold,
                  onChange: this.handleCheckBoxChange,
                  style: { marginLeft: '20px' }
                }),
                this.hasAccess(true, false, false, false, true) && _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: (0, _translation2.translateModels)(t, 'allowPricingEditAfterSold', 'project'),
                  name: 'allowPricingEditAfterSold',
                  checked: project.allowPricingEditAfterSold,
                  onChange: this.handleCheckBoxChange,
                  style: { marginLeft: '20px' }
                }),
                this.hasAccess(true, true, true) && _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: (0, _translation2.translateModels)(t, 'isCreditControlRebateUpdateDisabled', 'project'),
                  name: 'isCreditControlRebateUpdateDisabled',
                  checked: project.isCreditControlRebateUpdateDisabled,
                  onChange: this.handleCheckBoxChange
                })
              ),
              isMalaysia && this.hasAccess(true, false, false, false, true) && _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                (0, _translation2.translateModels)(t, 'HLB Campaign', 'project')
              ),
              isMalaysia && this.hasAccess(true, false, false, false, true) && _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { grouped: true },
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: (0, _translation2.translateModels)(t, 'enableHLBCampaign', 'project'),
                  name: 'hlbCampaignIsEnabled',
                  checked: project.hlbCampaignIsEnabled,
                  onChange: this.handleCheckBoxChange
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('booking_setup') },
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Loan Tracker')
              ),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: t('Consent SMS PIN required'),
                name: 'loanTrackerProjectConsentTypeID',
                checked: project.loanTrackerProjectConsentTypeID === '2',
                onChange: this.handleConsentCheck
              }),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { grouped: true },
                _react2.default.createElement(
                  _semanticUiReact.Form.Group,
                  { grouped: true },
                  _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    label: (0, _translation2.translateModels)(t, 'loanTrackerDirectConsent', 'project'),
                    name: 'loanTrackerDirectConsent',
                    disabled: true,
                    checked: project.loanTrackerDirectConsent,
                    onChange: this.handleCheckBoxChange
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Booking Flow')
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { grouped: true },
                _react2.default.createElement(
                  _semanticUiReact.Form.Group,
                  { grouped: true },
                  isPRS && _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    label: (0, _translation2.translateModels)(t, 'customerAssessmentFlow', 'project'),
                    name: 'customerAssessmentFlow',
                    checked: project.customerAssessmentFlow,
                    onChange: this.handleCheckBoxChange
                  }),
                  _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    label: (0, _translation2.translateModels)(t, 'paymentFlow', 'project'),
                    name: 'paymentFlow',
                    checked: project.paymentFlow,
                    onChange: this.handleCheckBoxChange
                  }),
                  _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    label: (0, _translation2.translateModels)(t, 'loanTrackerDirectShow', 'project'),
                    name: 'loanTrackerDirectShow',
                    checked: project.loanTrackerDirectShow,
                    onChange: this.handleCheckBoxChange
                  })
                )
              ),
              isVietnamCompany && _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { grouped: true },
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: (0, _translation2.translateModels)(t, 'signatureRequiredForBooked', 'project'),
                  name: 'signatureRequiredForBooked',
                  checked: !!project.signatureRequiredForBooked,
                  onChange: this.handleCheckBoxChange
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Source of Financing')
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { grouped: true },
                _react2.default.createElement(
                  _semanticUiReact.Form.Group,
                  { className: 'form-label' },
                  _react2.default.createElement(
                    _semanticUiReact.Form.Field,
                    { width: 10 },
                    _react2.default.createElement(
                      _semanticUiReact.Segment,
                      { className: 'form-sof-segment' },
                      _react2.default.createElement(
                        _semanticUiReact.Header,
                        { as: 'h4' },
                        t('Visibility settings')
                      ),
                      enabledFinanceSources.length > 0 && enabledFinanceSources.map(function (fs) {
                        return _this5.renderFinanceSourceItem(fs.id);
                      })
                    )
                  )
                )
              ),
              isPRS && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _semanticUiReact.Divider,
                  { horizontal: true },
                  t('Auto-Release')
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 4, computer: 4 },
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { className: 'form-label' },
                        _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Upload Buyer\'s IC') })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { className: 'form-mb1' },
                        _react2.default.createElement(
                          _semanticUiReact.Form.Field,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Segment,
                            null,
                            _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                              toggle: true,
                              label: t(project.arBookingExpNricPicIsEnabled ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                              name: 'arBookingExpNricPicIsEnabled',
                              checked: project.arBookingExpNricPicIsEnabled,
                              onChange: this.handleCheckBoxChange,
                              disabled: !project.arBookingExpIsEnabled || !systemData.arBookingExpIsEnabled
                            })
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 4, computer: 4 },
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { className: 'form-label' },
                        _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Booking fee payment') })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { className: 'form-mb1' },
                        _react2.default.createElement(
                          _semanticUiReact.Form.Field,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Segment,
                            null,
                            _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                              toggle: true,
                              label: t(project.arBookingExpUnpaidIsEnabled ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                              name: 'arBookingExpUnpaidIsEnabled',
                              checked: project.arBookingExpUnpaidIsEnabled,
                              onChange: this.handleCheckBoxChange,
                              disabled: !project.arBookingExpIsEnabled || !systemData.arBookingExpIsEnabled
                            })
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 8, computer: 8 },
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { className: 'form-label' },
                        _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Mortgage') })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { className: 'form-mb1' },
                        _react2.default.createElement(
                          _semanticUiReact.Form.Field,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Segment,
                            null,
                            _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                              toggle: true,
                              label: t(project.arBookingExpMortgageEnabled ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                              name: 'arBookingExpMortgageEnabled',
                              checked: project.arBookingExpMortgageEnabled,
                              onChange: this.handleCheckBoxChange,
                              disabled: !project.arBookingExpIsEnabled || !systemData.arBookingExpIsEnabled
                            })
                          )
                        )
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Email notification')
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Field,
                null,
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'manualSize' },
                  t('New Booking')
                ),
                _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    ref: this.validation.newBookingEmailNotifications,
                    onChange: function onChange(e, _ref24) {
                      var value = _ref24.value;
                      return _this5.handleAddEmail(e, value, 'newBookingEmailNotifications');
                    }
                  },
                  _react2.default.createElement(_semanticUiReact.Dropdown, {
                    name: 'newBookingEmailNotifications',
                    options: project && project.newBookingEmailNotifications ? project.newBookingEmailNotifications.map(function (eml) {
                      return {
                        text: eml,
                        value: eml
                      };
                    }) : [],
                    placeholder: t('Add emails'),
                    noResultsMessage: t('Add emails'),
                    search: true,
                    selection: true,
                    fluid: true,
                    multiple: true,
                    allowAdditions: true,
                    value: project && project.newBookingEmailNotifications ? project.newBookingEmailNotifications : []
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Field,
                null,
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'manualSize' },
                  t('Approved Booking')
                ),
                _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    ref: this.validation.approvedBookingEmailNotifications,
                    onChange: function onChange(e, _ref25) {
                      var value = _ref25.value;
                      return _this5.handleAddEmail(e, value, 'approvedBookingEmailNotifications');
                    }
                  },
                  _react2.default.createElement(_semanticUiReact.Dropdown, {
                    name: 'approvedBookingEmailNotifications',
                    options: project && project.approvedBookingEmailNotifications ? project.approvedBookingEmailNotifications.map(function (eml) {
                      return {
                        text: eml,
                        value: eml
                      };
                    }) : [],
                    placeholder: t('Add emails'),
                    noResultsMessage: t('Add emails'),
                    search: true,
                    selection: true,
                    fluid: true,
                    multiple: true,
                    allowAdditions: true,
                    value: project && project.approvedBookingEmailNotifications ? project.approvedBookingEmailNotifications : []
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Field,
                null,
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'manualSize' },
                  t('Cancelled Booking')
                ),
                _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    ref: this.validation.cancelledBookingEmailNotifications,
                    onChange: function onChange(e, _ref26) {
                      var value = _ref26.value;
                      return _this5.handleAddEmail(e, value, 'cancelledBookingEmailNotifications');
                    }
                  },
                  _react2.default.createElement(_semanticUiReact.Dropdown, {
                    name: 'cancelledBookingEmailNotifications',
                    options: project && project.cancelledBookingEmailNotifications ? project.cancelledBookingEmailNotifications.map(function (eml) {
                      return {
                        text: eml,
                        value: eml
                      };
                    }) : [],
                    placeholder: t('Add emails'),
                    noResultsMessage: t('Add emails'),
                    search: true,
                    selection: true,
                    fluid: true,
                    multiple: true,
                    allowAdditions: true,
                    value: project && project.cancelledBookingEmailNotifications ? project.cancelledBookingEmailNotifications : []
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Field,
                null,
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'manualSize' },
                  t('Sold Booking')
                ),
                _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    ref: this.validation.soldStatusBookingEmailNotifications,
                    onChange: function onChange(e, _ref27) {
                      var value = _ref27.value;
                      return _this5.handleAddEmail(e, value, 'soldStatusBookingEmailNotifications');
                    }
                  },
                  _react2.default.createElement(_semanticUiReact.Dropdown, {
                    name: 'soldStatusBookingEmailNotifications',
                    options: project && project.soldStatusBookingEmailNotifications ? project.soldStatusBookingEmailNotifications.map(function (eml) {
                      return {
                        text: eml,
                        value: eml
                      };
                    }) : [],
                    placeholder: t('Add emails'),
                    noResultsMessage: t('Add emails'),
                    search: true,
                    selection: true,
                    fluid: true,
                    multiple: true,
                    allowAdditions: true,
                    value: project && project.soldStatusBookingEmailNotifications ? project.soldStatusBookingEmailNotifications : []
                  })
                )
              ),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'allowAgentReceiveCancelledBookingEmail', 'project'),
                name: 'allowAgentReceiveCancelledBookingEmail',
                checked: project.allowAgentReceiveCancelledBookingEmail,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'sendCustomerCancelledBookingEmail', 'project'),
                name: 'sendCustomerCancelledBookingEmail',
                checked: project.sendCustomerCancelledBookingEmail,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'sendCustomerSuccessBookingEmail', 'project'),
                name: 'sendCustomerSuccessBookingEmail',
                checked: project.sendCustomerSuccessBookingEmail,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                label: (0, _translation2.translateModels)(t, 'customerBookingSuccessEmailType', 'project'),
                name: 'customerBookingSuccessEmailType',
                fluid: true,
                onChange: this.handleInputChange,
                value: project.customerBookingSuccessEmailType,
                options: customerBookingSuccessEmailTypes,
                disabled: !project.sendCustomerSuccessBookingEmail
              }),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Conversion Details')
              ),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: 'Allow HQ and Supervisor to edit conversion details (Bank Name, Banker Name, Loan Margin, Loan Amount) in booking info',
                name: 'allowEditConversionDetailsIsEnabled',
                checked: project.allowEditConversionDetailsIsEnabled,
                onChange: this.handleCheckBoxChange,
                disabled: !this.props.auth.isHeadquarters
              }),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Reservations/Bookings')
              ),
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                label: t('Bankers Limit'),
                name: 'loanTrackerProjectLeadBankersLimit',
                fluid: true,
                onChange: this.handleInputChange,
                value: project.loanTrackerProjectLeadBankersLimit,
                options: Array(16).fill('Unlimited').map(function (text, key) {
                  return {
                    text: key === 0 ? text : key.toString(),
                    value: key,
                    name: key
                  };
                })
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                label: (0, _translation2.translateModels)(t, 'bookingUnitLimit', 'project'),
                name: 'bookingUnitLimit',
                value: project.bookingUnitLimit,
                validation: [_webValidations.required, {
                  validate: _webValidations.numericRange,
                  option: {
                    min: 1
                  }
                }],
                onChange: this.handleInputChange,
                ref: this.validation.bookingUnitLimit,
                type: 'number',
                pattern: '[0-9]*'
              }),
              project.bookingUnitLimit > 1 && _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'activeBookingsInUnits', 'project'),
                name: 'activeBookingsInUnits',
                checked: project.activeBookingsInUnits,
                onChange: this.handleCheckBoxChange
              }),
              project.bookingUnitLimit > 1 && _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'activeBookingsIncludeWaitlist', 'project'),
                name: 'activeBookingsIncludeWaitlist',
                checked: project.activeBookingsIncludeWaitlist,
                onChange: this.handleCheckBoxChange,
                disabled: !project.activeBookingsInUnits
              }),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Customer Reservation Limit')
              ),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'customerReservationLimitIsEnabled', 'project'),
                name: 'customerReservationLimitIsEnabled',
                checked: project.customerReservationLimitIsEnabled,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                label: (0, _translation2.translateModels)(t, 'customerReservationMaxLimit', 'project'),
                name: 'customerReservationMaxLimit',
                value: project.customerReservationMaxLimit,
                validation: [_webValidations.required, {
                  validate: _webValidations.numericRange,
                  option: {
                    min: 1
                  }
                }],
                onChange: this.handleInputChange,
                ref: this.validation.customerReservationMaxLimit,
                type: 'number',
                pattern: '[0-9]*',
                disabled: !project.customerReservationLimitIsEnabled
              }),
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                label: (0, _translation2.translateModels)(t, 'customerReservationLimitStatusIDs', 'project'),
                name: 'customerReservationLimitStatusIDs',
                fluid: true,
                multiple: true,
                disabled: !project.customerReservationLimitIsEnabled,
                search: true,
                selection: true,
                options: _bookingStatuses2.default.map(function (s) {
                  return _extends({}, s, {
                    text: t(s.text, { ns: _translation.TRANSLATION_FILES.constants })
                  });
                }),
                onChange: this.handleInputChange,
                value: project.customerReservationLimitStatusIDs,
                style: { marginBottom: '10px' }
              }),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('New Reservation/Booking Form')
              ),
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                label: (0, _translation2.translateModels)(t, 'defaultCustomBookingStatusID', 'project'),
                name: 'defaultCustomBookingStatusID',
                fluid: true,
                onChange: this.handleInputChange,
                value: project.defaultCustomBookingStatusID,
                options: this.defaultBookingStatutes.map(function (s) {
                  return _extends({}, s, {
                    text: t(s.text, { ns: _translation.TRANSLATION_FILES.constants })
                  });
                })
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'allowCustomBookingStatus', 'project'),
                name: 'allowCustomBookingStatus',
                checked: project.allowCustomBookingStatus,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'allowStaffEditBookingSPAValue', 'project'),
                name: 'allowStaffEditBookingSPAValue',
                checked: project.allowStaffEditBookingSPAValue,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'allowAgentEditBookingSPAValue', 'project'),
                name: 'allowAgentEditBookingSPAValue',
                checked: project.allowAgentEditBookingSPAValue,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'allowAgentAutofillPurchaserDetails', 'project'),
                name: 'allowAgentAutofillPurchaserDetails',
                checked: project.allowAgentAutofillPurchaserDetails,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'showPurchaserExtraFields', 'project'),
                name: 'showPurchaserExtraFields',
                checked: project.showPurchaserExtraFields,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'requirePricingSelectDuringReserve', 'project'),
                name: 'requirePricingSelectDuringReserve',
                checked: project.requirePricingSelectDuringReserve,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'disableBaseSellingPriceSelection', 'project'),
                name: 'disableBaseSellingPriceSelection',
                checked: project.disableBaseSellingPriceSelection,
                onChange: this.handleCheckBoxChange
              }),
              isVietnamCompany && _react2.default.createElement(
                'p',
                { style: { margin: '-0.5em 0 1em 1.85em', opacity: 0.6 } },
                t('When enabled, Agency users also see no prices on Unit Information and the Sales exports', { ns: _translation.TRANSLATION_FILES.screens })
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: (0, _translation2.translateModels)(t, 'rduIsEnabled', 'project'),
                  name: 'rduIsEnabled',
                  checked: project.rduIsEnabled,
                  onChange: this.handleCheckBoxChange
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Header,
                {
                  as: 'h5',
                  style: project.rduIsEnabled ? { margin: '0 0 5px 0' } : { margin: '0 0 5px 0', opacity: '0.45' }
                },
                (0, _translation2.translateModels)(t, 'rduAccessGroupIDs', 'project')
              ),
              _react2.default.createElement(_semanticUiReact.Dropdown, {
                name: 'rduAccessGroupIDs',
                fluid: true,
                multiple: true,
                disabled: !project.rduIsEnabled,
                search: true,
                selection: true,
                options: _srRoleAccess.rduAccessesOptions.map(function (opt) {
                  return _extends({}, opt, {
                    text: t(opt.text, { ns: _translation.TRANSLATION_FILES.constants })
                  });
                }),
                onChange: this.handleInputChange,
                value: project.rduAccessGroupIDs || [],
                style: { marginBottom: '10px' }
              }),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Reservation/Booking Overview Page')
              ),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'allowAgentManageBooking', 'project'),
                name: 'allowAgentManageBooking',
                checked: project.allowAgentManageBooking,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'allowAgentManageBookingCustomer', 'project'),
                name: 'allowAgentManageBookingCustomer',
                checked: project.allowAgentManageBookingCustomer,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'allowAgentChangeBookingPaymentMethod', 'project'),
                name: 'allowAgentChangeBookingPaymentMethod',
                checked: project.allowAgentChangeBookingPaymentMethod,
                onChange: this.handleCheckBoxChange
              }),
              isVietnamCompany && _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'allowAgentEditSourceOfFinance', 'project'),
                name: 'allowAgentEditSourceOfFinance',
                checked: !!project.allowAgentEditSourceOfFinance,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'allowAgentEditBookingFee', 'project'),
                name: 'allowAgentEditBookingFee',
                checked: project.allowAgentEditBookingFee,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'allowAgentCancelBookingFee', 'project'),
                name: 'allowAgentCancelBookingFee',
                checked: project.allowAgentCancelBookingFee,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'allowAgentChangePrimaryPurchaser', 'project'),
                name: 'allowAgentChangePrimaryPurchaser',
                checked: project.allowAgentChangePrimaryPurchaser,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Share E-Signature')
              ),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'shareESignIsEnabled', 'project'),
                name: 'shareESignIsEnabled',
                checked: project.shareESignIsEnabled,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'shareESignAllowPreviewForm', 'project'),
                name: 'shareESignAllowPreviewForm',
                checked: project.shareESignAllowPreviewForm,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'shareESignSendFormsEmail', 'project'),
                name: 'shareESignSendFormsEmail',
                checked: project.shareESignSendFormsEmail,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'allowAgentShareESign', 'project'),
                name: 'allowAgentShareESign',
                checked: project.allowAgentShareESign,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Booking Printing')
              ),
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                label: _react2.default.createElement(
                  'label',
                  { htmlFor: 'printType' },
                  (0, _translation2.translateModels)(t, 'printType', 'project'),
                  docxPrintIsSelected && _react2.default.createElement(
                    'i',
                    { style: { color: 'grey', marginLeft: '1em' } },
                    '*Form already selected in Form Template'
                  )
                ),
                name: 'printType',
                fluid: true,
                onChange: this.handleInputChange,
                value: project.printType,
                options: printTypes,
                disabled: docxPrintIsSelected
              }),
              _react2.default.createElement(
                _semanticUiReact.Header,
                {
                  as: 'h5',
                  style: { margin: '0 0 5px 0' }
                },
                (0, _translation2.translateModels)(t, 'formAccessibilitiesTemplateIDs', 'project')
              ),
              _react2.default.createElement(_semanticUiReact.Dropdown, {
                name: 'formAccessibilitiesTemplateIDs',
                fluid: true,
                multiple: true,
                search: true,
                selection: true,
                options: printTypes,
                onChange: this.handleInputChange,
                value: formAccessibilitiesTemplateIDs,
                style: { marginBottom: '10px' }
              }),
              project.projectFormAccessibilities && project.projectFormAccessibilities.length > 0 ? _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'printPDF', 'project'),
                name: 'printPDF',
                checked: project.printPDF,
                onChange: this.handleCheckBoxChange
              }) : null,
              project.printType !== 'none' || project.projectFormAccessibilities !== null ? _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                label: (0, _translation2.translateModels)(t, 'printClause', 'project'),
                name: 'printClause',
                value: project.printClause,
                onChange: this.handleInputChange
              }) : null,
              _react2.default.createElement(_semanticUiReact.Form.Input, {
                autoComplete: 'off',
                fluid: true,
                label: (0, _translation2.translateModels)(t, 'customWatermark', 'project'),
                name: 'customWatermark',
                value: project.customWatermark,
                onChange: this.handleInputChange
              }),
              project.printType !== 'none' && project.printClause ? _react2.default.createElement(
                _semanticUiReact.Form.Field,
                { name: 'printClausePreview' },
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'printClausePreview' },
                  t('Preview', { ns: _translation.TRANSLATION_FILES.translation })
                ),
                _react2.default.createElement(_MarkdownText2.default, { content: project.printClause })
              ) : null,
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'hidePrintAgentStaff', 'project'),
                name: 'hidePrintAgentStaff',
                checked: project.hidePrintAgentStaff,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'allowSendFormsEmail', 'project'),
                name: 'allowSendFormsEmail',
                checked: project.allowSendFormsEmail,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: (0, _translation2.translateModels)(t, 'autofillFromUrl', 'project'),
                  name: 'autofillFromUrl',
                  checked: project.autofillFromUrl,
                  onChange: this.handleCheckBoxChange
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: (0, _translation2.translateModels)(t, 'externalAutofillUrl', 'project'),
                  name: 'externalAutofillUrl',
                  value: project.externalAutofillUrl || '',
                  onChange: this.handleInputChange,
                  disabled: !project.autofillFromUrl
                })
              ),
              project.projectFormAccessibilities ? _react2.default.createElement(_BookingFormTemplateList2.default, {
                data: pTemplates.filter(function (pt) {
                  return formAccessibilitiesTemplateIDs.includes(pt.id);
                }) || [],
                loading: this.state.loading,
                handleSaveTemplateToggle: function handleSaveTemplateToggle(id, v) {
                  _this5.handleSaveTemplateToggle(id, v);
                }
              }) : null,
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: (0, _translation2.translateModels)(t, 'cuIsEnabled', 'project'),
                  name: 'cuIsEnabled',
                  checked: project.cuIsEnabled,
                  onChange: this.handleCheckBoxChange
                })
              ),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: t('Change unit within same project'),
                name: 'cuIsEnabled',
                checked: project.cuIsEnabled,
                disabled: true
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'cuOtherProjectIsEnabled', 'project'),
                name: 'cuOtherProjectIsEnabled',
                checked: project.cuOtherProjectIsEnabled,
                onChange: this.handleCheckBoxChange,
                disabled: !project.cuIsEnabled
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'cuDelistOnHoldIsEnabled', 'project'),
                name: 'cuDelistOnHoldIsEnabled',
                checked: project.cuDelistOnHoldIsEnabled,
                onChange: this.handleCheckBoxChange,
                disabled: !project.cuIsEnabled
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'cuFollowPrevBookingDateIsEnabled', 'project'),
                name: 'cuFollowPrevBookingDateIsEnabled',
                checked: project.cuFollowPrevBookingDateIsEnabled,
                onChange: this.handleCheckBoxChange,
                disabled: !project.cuIsEnabled
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'cuDefaultFollowPrevBookingDateIsEnabled', 'project'),
                name: 'cuDefaultFollowPrevBookingDateIsEnabled',
                checked: project.cuDefaultFollowPrevBookingDateIsEnabled,
                onChange: this.handleCheckBoxChange,
                disabled: !project.cuIsEnabled || !project.cuFollowPrevBookingDateIsEnabled,
                style: { marginLeft: '20px' }
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'cuDisabledEditingOfFollowPrevBookingDate', 'project'),
                name: 'cuDisabledEditingOfFollowPrevBookingDate',
                checked: project.cuDisabledEditingOfFollowPrevBookingDate,
                onChange: this.handleCheckBoxChange,
                disabled: !project.cuIsEnabled || !project.cuDefaultFollowPrevBookingDateIsEnabled,
                style: { marginLeft: '40px' }
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'cuAttachmentsRequired', 'project'),
                name: 'cuAttachmentsRequired',
                checked: project.cuAttachmentsRequired,
                onChange: this.handleCheckBoxChange,
                disabled: !project.cuIsEnabled
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'cuReserveNewBooking', 'project'),
                name: 'cuReserveNewBooking',
                checked: project.cuReserveNewBooking,
                onChange: this.handleCheckBoxChange,
                disabled: !project.cuIsEnabled
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'cuReactivatePrevBooking', 'project'),
                name: 'cuReactivatePrevBooking',
                checked: project.cuReactivatePrevBooking,
                onChange: this.handleCheckBoxChange,
                disabled: !project.cuIsEnabled || !project.cuReserveNewBooking,
                style: { marginLeft: '20px' }
              }),
              _react2.default.createElement(
                _semanticUiReact.Header,
                {
                  as: 'h5',
                  style: project.cuIsEnabled ? { margin: '0 0 5px 0' } : { margin: '0 0 5px 0', opacity: '0.45' }
                },
                (0, _translation2.translateModels)(t, 'cuRoleAccesses', 'project')
              ),
              _react2.default.createElement(_AppForm2.default.Select, {
                name: 'cuRoleAccesses',
                ref: this.validation.cuRoleAccesses,
                validate: true,
                fluid: true,
                multiple: true,
                disabled: !project.cuIsEnabled,
                search: true,
                selection: true,
                options: _changeUnitsAccesses.changeUnitAccessesOptions.map(function (opt) {
                  return _extends({}, opt, {
                    text: t(opt.text, { ns: _translation.TRANSLATION_FILES.constants })
                  });
                }),
                onChange: this.handleInputChange,
                value: project.cuRoleAccesses || [],
                style: { marginBottom: '10px' }
              }),
              isCUExternalSelected && _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'cuAllowExternalReserved', 'project'),
                name: 'cuAllowExternalReserved',
                checked: project.cuAllowExternalReserved,
                onChange: this.handleCheckBoxChange,
                disabled: !project.cuIsEnabled
              }),
              isCUExternalSelected && _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'cuAllowExternalBooked', 'project'),
                name: 'cuAllowExternalBooked',
                checked: project.cuAllowExternalBooked,
                onChange: this.handleCheckBoxChange,
                disabled: !project.cuIsEnabled
              }),
              isCUExternalSelected && _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'cuDisableExtEditCancelCriteria', 'project'),
                name: 'cuDisableExtEditCancelCriteria',
                checked: project.cuDisableExtEditCancelCriteria,
                onChange: this.handleCheckBoxChange,
                disabled: !project.cuIsEnabled
              }),
              isMalaysia && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Divider,
                  { horizontal: true },
                  'Tax Identification Number'
                ),
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: 'Compulsory to fill in and validate Tax Identification Number during booking creation',
                  name: 'requireValidTinAtBookingCreation',
                  checked: project.requireValidTinAtBookingCreation,
                  onChange: this.handleCheckBoxChange
                }),
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Form,
                        { as: 'div' },
                        _react2.default.createElement(
                          _semanticUiReact.Form.Group,
                          { widths: 'equal' },
                          _react2.default.createElement(
                            _semanticUiReact.Form.Field,
                            { width: 10, style: { maxWidth: '70%' } },
                            _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                              label: 'Compulsory to have valid Tax Identification Number before update booking to',
                              name: 'compulsoryValidTinBeforeUpdateBooking',
                              checked: this.state.compulsoryValidTinBeforeUpdateBooking,
                              onChange: this.handleCheckBoxChange
                            })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Form.Field,
                            { width: 2, style: { maxWidth: '30%', marginLeft: window.innerWidth < 768 ? '2em' : '0', marginTop: '-0.5em' } },
                            _react2.default.createElement(_semanticUiReact.Form.Select, {
                              disabled: !this.state.compulsoryValidTinBeforeUpdateBooking,
                              name: 'tinDropdown',
                              onChange: this.handleInputChange,
                              value: this.state.tinDropdown,
                              options: _tin2.default.map(function (opt) {
                                return _extends({}, opt, {
                                  text: opt.text
                                });
                              })
                            })
                          )
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  {
                    as: 'h5',
                    style: { margin: '0 0 1rem 2rem' }
                  },
                  'Apply the setting above to:'
                ),
                _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  { style: { margin: '0 0 1rem 1rem' } },
                  _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    radio: true,
                    disabled: !this.state.compulsoryValidTinBeforeUpdateBooking,
                    label: 'All bookings',
                    name: 'tinSettingBookingStartAt',
                    checked: project.tinSettingBookingStartAt === null,
                    value: '',
                    onChange: this.handleCheckBoxChange
                  }),
                  _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    radio: true,
                    disabled: !this.state.compulsoryValidTinBeforeUpdateBooking,
                    label: 'Bookings from start date',
                    name: 'tinSettingBookingStartAt',
                    checked: project.tinSettingBookingStartAt !== null,
                    onChange: this.handleCheckBoxChange
                  }),
                  project.tinSettingBookingStartAt !== null && _react2.default.createElement(
                    _semanticUiReact.Form.Field,
                    null,
                    _react2.default.createElement(_DateTimePicker2.default, {
                      visible: this.state.compulsoryValidTinBeforeUpdateBooking,
                      onChange: function onChange(value, visible) {
                        return _this5.handleTinSettingDateTimeInputChange(value, visible);
                      },
                      value: project.tinSettingBookingStartAt ? (0, _momentTimezone2.default)(project.tinSettingBookingStartAt).toDate() : (0, _momentTimezone2.default)().toDate()
                    })
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Notes')
              ),
              _react2.default.createElement(
                _semanticUiReact.Header,
                {
                  as: 'h5',
                  style: { margin: '0 0 5px 0' }
                },
                (0, _translation2.translateModels)(t, 'bnEmailTitle', 'project')
              ),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: (0, _translation2.translateModels)(t, 'bnEmailIsEnabled', 'project'),
                name: 'bnEmailIsEnabled',
                checked: project.bnEmailIsEnabled,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(
                _semanticUiReact.Header,
                {
                  as: 'h5',
                  style: { margin: '0 0 5px 0' }
                },
                (0, _translation2.translateModels)(t, 'bnReadAccessGroupIDs', 'project')
              ),
              _react2.default.createElement(_semanticUiReact.Dropdown, {
                name: 'bnReadAccessGroupIDs',
                fluid: true,
                multiple: true,
                search: true,
                selection: true,
                options: _srRoleAccess.bookingNoteAccessesOptions.map(function (opt) {
                  return _extends({}, opt, {
                    text: t(opt.text, { ns: _translation.TRANSLATION_FILES.constants })
                  });
                }),
                onChange: this.handleInputChange,
                value: project.bnReadAccessGroupIDs || [],
                style: { marginBottom: '10px' }
              }),
              _react2.default.createElement(
                _semanticUiReact.Header,
                {
                  as: 'h5',
                  style: { margin: '0 0 5px 0' }
                },
                (0, _translation2.translateModels)(t, 'bnWriteAccessGroupIDs', 'project')
              ),
              _react2.default.createElement(_semanticUiReact.Dropdown, {
                name: 'bnWriteAccessGroupIDs',
                fluid: true,
                multiple: true,
                search: true,
                selection: true,
                options: _srRoleAccess.bookingNoteAccessesOptions.map(function (opt) {
                  return _extends({}, opt, {
                    text: t(opt.text, { ns: _translation.TRANSLATION_FILES.constants })
                  });
                }),
                onChange: this.handleInputChange,
                value: project.bnWriteAccessGroupIDs || [],
                style: { marginBottom: '10px' }
              }),
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                label: (0, _translation2.translateModels)(t, 'bnDefaultPrivacy', 'project'),
                name: 'bnDefaultPrivacy',
                fluid: true,
                onChange: this.handleInputChange,
                value: project.bnDefaultPrivacy,
                options: _bookingNote.bookingNoteDefaultPrivacyOptions.map(function (opt) {
                  return _extends({}, opt, {
                    text: t(opt.text, { ns: _translation.TRANSLATION_FILES.constants })
                  });
                })
              }),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Pre-Sales Launch')
              ),
              !(0, _preSalesLaunch.canManagePreSalesLaunch)(this.props.auth) && _react2.default.createElement(
                'i',
                { style: { color: 'grey', display: 'block', marginBottom: '5px' } },
                t('Only HQ can change these settings')
              ),
              ['reserveDisabledRoleIDs', 'salesChartDisabledRoleIDs'].map(function (name) {
                return _react2.default.createElement(
                  _react2.default.Fragment,
                  { key: name },
                  _react2.default.createElement(
                    _semanticUiReact.Header,
                    {
                      as: 'h5',
                      style: { margin: '0 0 5px 0' }
                    },
                    (0, _translation2.translateModels)(t, name, 'project'),
                    _react2.default.createElement(
                      'i',
                      { style: { color: 'grey', marginLeft: '1em' } },
                      t('Leave empty to allow all roles')
                    )
                  ),
                  _react2.default.createElement(_semanticUiReact.Dropdown, {
                    name: name,
                    fluid: true,
                    multiple: true,
                    disabled: !(0, _preSalesLaunch.canManagePreSalesLaunch)(_this5.props.auth),
                    search: true,
                    selection: true,
                    options: _srRoleAccess.preSalesLaunchRoleOptions.map(function (opt) {
                      return _extends({}, opt, {
                        text: t(opt.text, { ns: _translation.TRANSLATION_FILES.constants })
                      });
                    }),
                    onChange: _this5.handleInputChange,
                    value: project[name] || [],
                    style: { marginBottom: '10px' }
                  })
                );
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: !this.isActiveTab('docx_templater_setting'), className: this.checkActiveTab('docx_templater_setting') },
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Form Template')
              ),
              project && project.id && _react2.default.createElement(_DocxTemplaterForm2.default, {
                projectID: project.id,
                project: project,
                onSubmitBankerForm: this.handleBankerFormChange
              }),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Merge-tag Dictionary')
              ),
              _react2.default.createElement(_MergeTagDictTabList2.default, null),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('How-to Guide')
              ),
              _react2.default.createElement(_DocxTemplateGuides2.default, null)
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('payment_setup') },
              this.hasAccess(true, true, true) && _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Bank Accounts')
              ),
              this.hasAccess(true, true, false, true) && _react2.default.createElement(_BankAccounts2.default, {
                data: project.projectBankAccount || [],
                project: project,
                loading: this.state.loading,
                onDefaultAdd: function onDefaultAdd(v, d) {
                  _this5.handleAddBankAccount(v, d);
                },
                onDefaultSave: function onDefaultSave(v, d) {
                  _this5.handleSaveBankAccount(v, d);
                }
              }),
              this.props.appConfig.data.settings && this.props.appConfig.data.settings.virtualAccountIsEnabled && _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Virtual Account', { ns: _translation.TRANSLATION_FILES.constants })
              ),
              this.props.appConfig.data.settings && this.props.appConfig.data.settings.virtualAccountIsEnabled && _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _reactI18next.Trans,
                  { ns: _translation.TRANSLATION_FILES.screens },
                  'To configure Virtual Account for each units, visit this\xA0',
                  _react2.default.createElement(
                    'a',
                    { style: { color: '#0094B3' }, href: '/projects/' + project.id + '/units/edit/' },
                    'page'
                  )
                ),
                '.'
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Payment')
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { grouped: true },
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: (0, _translation2.translateModels)(t, 'paymentFieldsRequired', 'project'),
                  name: 'paymentFieldsRequired',
                  checked: project.paymentFieldsRequired,
                  onChange: this.handleCheckBoxChange
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { grouped: true },
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: _react2.default.createElement(
                    'label',
                    { htmlFor: 'bookingFeeDeductiblePaymentPlan' },
                    (0, _translation2.translateModels)(t, 'bookingFeeDeductiblePaymentPlan', 'project'),
                    ' ',
                    _react2.default.createElement(
                      'i',
                      { style: { color: 'grey', marginLeft: '1em' } },
                      '*',
                      t('only applicable in Payment Plans')
                    )
                  ),
                  name: 'bookingFeeDeductiblePaymentPlan',
                  checked: project.bookingFeeDeductiblePaymentPlan,
                  onChange: this.handleCheckBoxChange
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: (0, _translation2.translateModels)(t, 'defaultBookingFeeAmount', 'project'),
                  name: 'defaultBookingFeeAmount',
                  value: project.defaultBookingFeeAmount,
                  onChange: this.handleInputChange,
                  ref: this.validation.defaultBookingFeeAmount,
                  type: 'number',
                  pattern: '[0-9]*'
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { grouped: true },
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: _react2.default.createElement(
                    'label',
                    { htmlFor: 'minBookingPaymentIsRequired' },
                    (0, _translation2.translateModels)(t, 'minBookingPaymentIsRequired', 'project'),
                    ' ',
                    _react2.default.createElement(
                      'i',
                      { style: { color: 'grey', marginLeft: '1em' } },
                      '(',
                      t('Only for Reserved > Booked Status Change'),
                      ')'
                    )
                  ),
                  name: 'minBookingPaymentIsRequired',
                  checked: project.minBookingPaymentIsRequired,
                  onChange: this.handleCheckBoxChange
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: (0, _translation2.translateModels)(t, 'minBookingPaymentAmount', 'project'),
                  name: 'minBookingPaymentAmount',
                  value: project.minBookingPaymentAmount,
                  onChange: this.handleInputChange,
                  ref: this.validation.minBookingPaymentAmount,
                  validation: project.minBookingPaymentIsRequired ? [_webValidations.required, {
                    validate: _webValidations.numericRange,
                    option: {
                      min: 0,
                      max: project.defaultBookingFeeAmount ? parseFloat(project.defaultBookingFeeAmount) : undefined
                    }
                  }] : null,
                  type: 'number',
                  pattern: '[0-9]*',
                  disabled: !project.minBookingPaymentIsRequired
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Header,
                {
                  as: 'h5',
                  style: { margin: '0 0 5px 0' }
                },
                (0, _translation2.translateModels)(t, 'paymentReceiptAccessGroupIDs', 'project')
              ),
              _react2.default.createElement(_semanticUiReact.Dropdown, {
                name: 'paymentReceiptAccessGroupIDs',
                fluid: true,
                multiple: true,
                search: true,
                selection: true,
                options: _srRoleAccess.paymentReceiptAccessesOptions.map(function (opt) {
                  return _extends({}, opt, {
                    text: t(opt.text, { ns: _translation.TRANSLATION_FILES.constants })
                  });
                }),
                onChange: this.handleInputChange,
                value: project.paymentReceiptAccessGroupIDs || [],
                style: { marginBottom: '10px' }
              }),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Payment Method')
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { grouped: true },
                _react2.default.createElement(
                  _semanticUiReact.Form.Group,
                  { className: 'form-label' },
                  _react2.default.createElement(
                    _semanticUiReact.Form.Field,
                    { width: 10 },
                    _react2.default.createElement(
                      _semanticUiReact.Segment,
                      { className: 'form-sof-segment' },
                      _react2.default.createElement(
                        _semanticUiReact.Header,
                        { as: 'h4' },
                        t('Visibility settings')
                      ),
                      this.props.appConfig.data.settings && this.props.appConfig.data.settings.virtualAccountIsEnabled ? _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        null,
                        _react2.default.createElement(_semanticUiReact.Form.Field, { label: (0, _translation2.getConstantsLabel)(t, _paymentTypes2.default, 'virtual_account'), width: 11 }),
                        _react2.default.createElement(
                          _semanticUiReact.Form.Field,
                          { width: 5 },
                          _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                            toggle: true,
                            label: t('On', { ns: _translation.TRANSLATION_FILES.translation }),
                            name: 'virtual_account',
                            checked: true,
                            disabled: true
                          })
                        )
                      ) : null,
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        null,
                        _react2.default.createElement(_semanticUiReact.Form.Field, { label: (0, _translation2.getConstantsLabel)(t, _paymentTypes2.default, 'bank_transfer'), width: 11 }),
                        _react2.default.createElement(
                          _semanticUiReact.Form.Field,
                          { width: 5 },
                          _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                            toggle: true,
                            label: t(project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.some(function (o) {
                              return o === 'bank_transfer';
                            }) ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                            name: 'bank_transfer',
                            checked: project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.includes('bank_transfer'),
                            onChange: this.handlePaymentTypeChange
                          })
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        null,
                        _react2.default.createElement(_semanticUiReact.Form.Field, { label: (0, _translation2.getConstantsLabel)(t, _paymentTypes2.default, 'cheque'), width: 11 }),
                        _react2.default.createElement(
                          _semanticUiReact.Form.Field,
                          { width: 5 },
                          _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                            toggle: true,
                            label: t(project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.some(function (o) {
                              return o === 'cheque';
                            }) ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                            name: 'cheque',
                            checked: project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.includes('cheque'),
                            onChange: this.handlePaymentTypeChange
                          })
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        null,
                        _react2.default.createElement(_semanticUiReact.Form.Field, { label: (0, _translation2.getConstantsLabel)(t, _paymentTypes2.default, 'cash'), width: 11 }),
                        _react2.default.createElement(
                          _semanticUiReact.Form.Field,
                          { width: 5 },
                          _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                            toggle: true,
                            label: t(project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.some(function (o) {
                              return o === 'cash';
                            }) ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                            name: 'cash',
                            checked: project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.includes('cash'),
                            onChange: this.handlePaymentTypeChange
                          })
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        null,
                        _react2.default.createElement(_semanticUiReact.Form.Field, { label: (0, _translation2.getConstantsLabel)(t, _paymentTypes2.default, 'credit_card'), width: 11 }),
                        _react2.default.createElement(
                          _semanticUiReact.Form.Field,
                          { width: 5 },
                          _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                            toggle: true,
                            label: t(project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.some(function (o) {
                              return o === 'credit_card';
                            }) ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                            name: 'credit_card',
                            checked: project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.includes('credit_card'),
                            onChange: this.handlePaymentTypeChange
                          })
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        null,
                        _react2.default.createElement(_semanticUiReact.Form.Field, { label: (0, _translation2.getConstantsLabel)(t, _paymentTypes2.default, 'online_payment') + ' (' + t('Online Payment') + ')', width: 11 }),
                        _react2.default.createElement(
                          _semanticUiReact.Form.Field,
                          { width: 5 },
                          _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                            toggle: true,
                            label: t(project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.some(function (o) {
                              return o === 'online_payment';
                            }) ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                            name: 'online_payment',
                            checked: project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.includes('online_payment'),
                            onChange: this.handlePaymentTypeChange
                          })
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        null,
                        _react2.default.createElement(_semanticUiReact.Form.Field, { label: (0, _translation2.getConstantsLabel)(t, _paymentTypes2.default, 'others'), width: 11 }),
                        _react2.default.createElement(
                          _semanticUiReact.Form.Field,
                          { width: 5 },
                          _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                            toggle: true,
                            label: t(project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.some(function (o) {
                              return o === 'others';
                            }) ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                            name: 'others',
                            checked: project.paymentTypeOptions && project.paymentTypeOptions.length > 0 && project.paymentTypeOptions.includes('others'),
                            onChange: this.handlePaymentTypeChange
                          })
                        )
                      )
                    )
                  )
                )
              ),
              this.hasAccess(true, true, true) && !this.props.appConfig.data.onlinePaymentEnabled && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _semanticUiReact.Divider,
                  { horizontal: true },
                  t('MHub Pay Online')
                ),
                _react2.default.createElement(
                  _semanticUiReact.Form.Group,
                  { grouped: true },
                  _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    label: (0, _translation2.translateModels)(t, 'onlinePaymentApproval', 'project'),
                    name: 'onlinePaymentApproval',
                    checked: project.onlinePaymentApproval,
                    onChange: this.handleCheckBoxChange
                  })
                ),
                this.props.appConfig.data.paymsPaymentGateway === _payments.PAYMS_PAYMENT_GATEWAY_BILLPLZ ? _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Form.Group,
                    { widths: 'equal' },
                    _react2.default.createElement(_AppForm2.default.Input, {
                      label: (0, _translation2.translateModels)(t, 'newPaymsBillplzSercetKey', 'project'),
                      name: 'newPaymsBillplzSercetKey',
                      value: project.newPaymsBillplzSercetKey,
                      onChange: this.handleInputChange,
                      ref: this.validation.newPaymsBillplzSercetKey
                    }),
                    _react2.default.createElement(_AppForm2.default.Input, {
                      label: (0, _translation2.translateModels)(t, 'newPaymsBillplzSignatureKey', 'project'),
                      name: 'newPaymsBillplzSignatureKey',
                      value: project.newPaymsBillplzSignatureKey,
                      onChange: this.handleInputChange,
                      ref: this.validation.newPaymsBillplzSignatureKey
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Form.Group,
                    { widths: 'equal' },
                    _react2.default.createElement(_AppForm2.default.Input, {
                      label: (0, _translation2.translateModels)(t, 'paymsBillplzCollectionID', 'project'),
                      name: 'paymsBillplzCollectionID',
                      value: project.paymsBillplzCollectionID,
                      onChange: this.handleInputChange,
                      ref: this.validation.paymsBillplzCollectionID
                    }),
                    _react2.default.createElement(_AppForm2.default.Input, {
                      label: (0, _translation2.translateModels)(t, 'paymsBillplzCollectionTitle', 'project'),
                      name: 'paymsBillplzCollectionTitle',
                      value: project.paymsBillplzCollectionTitle,
                      ref: this.validation.paymsBillplzCollectionTitle,
                      disabled: true
                    })
                  )
                ) : '',
                this.props.appConfig.data.paymsPaymentGateway === _payments.PAYMS_PAYMENT_GATEWAY_IPAY88 ? _react2.default.createElement(
                  _semanticUiReact.Form.Group,
                  { widths: 'equal' },
                  _react2.default.createElement(_AppForm2.default.Input, {
                    label: (0, _translation2.translateModels)(t, 'newPaymsIPay88MerchantCode', 'project'),
                    name: 'newPaymsIPay88MerchantCode',
                    value: project.newPaymsIPay88MerchantCode,
                    onChange: this.handleInputChange,
                    ref: this.validation.newPaymsIPay88MerchantCode
                  }),
                  _react2.default.createElement(_AppForm2.default.Input, {
                    label: (0, _translation2.translateModels)(t, 'newPaymsIPay88MerchantKey', 'project'),
                    name: 'newPaymsIPay88MerchantKey',
                    value: project.newPaymsIPay88MerchantKey,
                    onChange: this.handleInputChange,
                    ref: this.validation.newPaymsIPay88MerchantKey
                  })
                ) : ''
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Email notification (MHub Pay)')
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Field,
                null,
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'manualSize' },
                  t('New Payment Approval')
                ),
                _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    ref: this.validation.newPaymentApprovalEmailNotifications,
                    onChange: function onChange(e, _ref28) {
                      var value = _ref28.value;
                      return _this5.handleAddEmail(e, value, 'newPaymentApprovalEmailNotifications');
                    }
                  },
                  _react2.default.createElement(_semanticUiReact.Dropdown, {
                    name: 'newPaymentApprovalEmailNotifications',
                    options: project && project.newPaymentApprovalEmailNotifications ? project.newPaymentApprovalEmailNotifications.map(function (eml) {
                      return {
                        text: eml,
                        value: eml
                      };
                    }) : [],
                    placeholder: t('Add emails'),
                    noResultsMessage: t('Add emails'),
                    search: true,
                    selection: true,
                    fluid: true,
                    multiple: true,
                    allowAdditions: true,
                    value: project && project.newPaymentApprovalEmailNotifications ? project.newPaymentApprovalEmailNotifications : []
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Field,
                null,
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'manualSize' },
                  t('New Payment Success')
                ),
                _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    ref: this.validation.newPaymentSuccessEmailNotifications,
                    onChange: function onChange(e, _ref29) {
                      var value = _ref29.value;
                      return _this5.handleAddEmail(e, value, 'newPaymentSuccessEmailNotifications');
                    }
                  },
                  _react2.default.createElement(_semanticUiReact.Dropdown, {
                    name: 'newPaymentSuccessEmailNotifications',
                    options: project && project.newPaymentSuccessEmailNotifications ? project.newPaymentSuccessEmailNotifications.map(function (eml) {
                      return {
                        text: eml,
                        value: eml
                      };
                    }) : [],
                    placeholder: t('Add emails'),
                    noResultsMessage: t('Add emails'),
                    search: true,
                    selection: true,
                    fluid: true,
                    multiple: true,
                    allowAdditions: true,
                    value: project && project.newPaymentSuccessEmailNotifications ? project.newPaymentSuccessEmailNotifications : []
                  })
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('sales_chart_setup') },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { style: { height: '15%' }, verticalAlign: 'middle', textAlign: 'center' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Storey Plan')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { grouped: true },
                      _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                        toggle: true,
                        label: t(project.salesChartEnabled ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                        name: 'salesChartEnabled',
                        checked: project.salesChartEnabled,
                        onChange: this.handleCheckBoxChange
                      })
                    )
                  )
                )
              ),
              project.id && project.salesChartEnabled ? _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 'equal' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    _react2.default.createElement(_semanticUiReact.Form.Select, {
                      label: t('Type'),
                      name: 'salesChartType',
                      fluid: true,
                      onChange: this.handleInputChange,
                      value: project.salesChartType,
                      options: salesChartTypes
                    }),
                    _react2.default.createElement(_semanticUiReact.Form.Select, {
                      label: t('Template'),
                      name: 'salesChartTemplate',
                      fluid: true,
                      onChange: this.handleInputChange,
                      value: project.salesChartTemplate,
                      options: salesChartTemplateTypes
                    }),
                    _react2.default.createElement(_semanticUiReact.Form.Select, {
                      disabled: !project.isLaunchMode,
                      label: (0, _translation2.translateModels)(t, 'salesChartRefreshSeconds', 'project'),
                      name: 'salesChartRefreshSeconds',
                      fluid: true,
                      onChange: this.handleInputChange,
                      value: project.salesChartRefreshSeconds,
                      options: this.salesChartRefreshTimes
                    }),
                    _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('General Settings:') }),
                    _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                      label: t('Show price per size'),
                      name: 'salesChartSizePrice',
                      checked: project.salesChartSizePrice,
                      onChange: this.handleCheckBoxChange
                    }),
                    _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Agents/Staff Settings:') }),
                    _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                      label: t('Simple View Mode (Units are shown as Available/Unavailable)'),
                      name: 'salesChartSimpleMode',
                      checked: project.siteplanSettings && project.siteplanSettings.salesChartSimpleMode,
                      onChange: this.handleSiteplanSettingsChange
                    }),
                    _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                      label: t('Disable clicks on unavailable units (Storey plan)'),
                      name: 'salesChartDisableClickUnavailable',
                      disabled: project.siteplanSettings && !project.siteplanSettings.salesChartSimpleMode,
                      checked: project.siteplanSettings && project.siteplanSettings.salesChartDisableClickUnavailable,
                      onChange: this.handleSiteplanSettingsChange,
                      style: { marginLeft: '20px' }
                    }),
                    _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                      label: t('Disable clicks on unavailable units (Unit list)'),
                      name: 'unitListDisableClickUnavailable',
                      disabled: project.siteplanSettings && !project.siteplanSettings.salesChartSimpleMode,
                      checked: project.siteplanSettings && project.siteplanSettings.unitListDisableClickUnavailable,
                      onChange: this.handleSiteplanSettingsChange,
                      style: { marginLeft: '20px' }
                    }),
                    _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                      label: t('Hide unit price'),
                      name: 'salesChartHidePrice',
                      disabled: project.siteplanSettings && !project.siteplanSettings.salesChartSimpleMode,
                      checked: project.salesChartHidePrice,
                      onChange: this.handleCheckBoxChange,
                      style: { marginLeft: '20px' }
                    }),
                    _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                      label: t('Hide unit size'),
                      name: 'salesChartHideSize',
                      disabled: project.siteplanSettings && !project.siteplanSettings.salesChartSimpleMode,
                      checked: project.salesChartHideSize,
                      onChange: this.handleCheckBoxChange,
                      style: { marginLeft: '20px' }
                    }),
                    _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                      label: t('Show Delisted units as Unavailable'),
                      name: 'salesChartDelistedAsUnavailable',
                      disabled: project.siteplanSettings && !project.siteplanSettings.salesChartSimpleMode,
                      checked: project.siteplanSettings && project.siteplanSettings.salesChartDelistedAsUnavailable,
                      onChange: this.handleSiteplanSettingsChange,
                      style: { marginLeft: '20px' }
                    }),
                    _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Public Settings:') }),
                    _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                      label: t('Hide price for public share'),
                      name: 'hidePublicPriceSalesChart',
                      disabled: !project.isPublic,
                      checked: project.hidePublicPriceSalesChart,
                      onChange: this.handleCheckBoxChange
                    })
                  )
                )
              ) : null,
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { style: { height: '15%' }, textAlign: 'center' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Interactive Site Plan')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { grouped: true },
                      _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                        toggle: true,
                        label: t(project.siteplanAppEnabled ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                        name: 'siteplanAppEnabled',
                        checked: project.siteplanAppEnabled,
                        onChange: this.handleCheckBoxChange
                      })
                    )
                  )
                )
              ),
              project.id && project.siteplanAppEnabled ? _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 'equal' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'left' },
                    _react2.default.createElement(
                      'b',
                      null,
                      t('Siteplan')
                    ),
                    _react2.default.createElement(_SortButton2.default, {
                      loading: this.state.loading,
                      icon: 'download',
                      header: t('Units Tag'),
                      items: exportItems
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'right' },
                    this.hasSiteplan() ? _react2.default.createElement(_semanticUiReact.Button, {
                      floated: 'right',
                      type: 'button',
                      onClick: this.handlePreviewSaleschart,
                      primary: true,
                      content: t('Preview', { ns: _translation.TRANSLATION_FILES.translation }),
                      disabled: !oriProject.siteplanAppEnabled
                    }) : _react2.default.createElement(_UploadModal2.default, {
                      ref: function ref(_ref31) {
                        _this5.uploadModal.siteplan = _ref31;
                      },
                      header: 'siteplan',
                      loading: this.state.loading,
                      onConfirm: function onConfirm(e, file) {
                        _this5.uploadSiteplan(e, file);
                      },
                      onClose: this.handleCheckBeforeClose,
                      content: function content(opt) {
                        return _react2.default.createElement(_SiteplanForm2.default, {
                          ref: function ref(_ref30) {
                            _this5.uploadForm.siteplan = _ref30;
                          },
                          onSubmit: opt.onConfirm
                        });
                      },
                      disabled: !oriProject.siteplanAppEnabled
                    })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    this.hasSiteplan() ? _react2.default.createElement(
                      _semanticUiReact.Segment.Group,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Segment,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { columns: 'equal', verticalAlign: 'middle', textAlign: 'left' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { width: 3 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('SVG')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { width: 6 },
                            _react2.default.createElement(_semanticUiReact.Label, {
                              basic: true,
                              size: 'small',
                              icon: this.hasSiteplan('svg') ? null : 'warning sign',
                              color: this.hasSiteplan('svg') ? 'green' : 'red',
                              content: t(this.hasSiteplan('svg') ? 'Uploaded' : 'Not uploaded')
                            })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right' },
                            _react2.default.createElement(_UploadModal2.default, {
                              ref: function ref(_ref33) {
                                _this5.uploadModal.svg = _ref33;
                              },
                              header: 'svg',
                              loading: this.state.loading,
                              btnText: this.hasSiteplan('svg') ? t('Replace') : t('Upload', { ns: _translation.TRANSLATION_FILES.translation }),
                              onConfirm: function onConfirm(e, file) {
                                _this5.replaceSiteplan(e, file, 'svg');
                              },
                              onClose: function onClose() {
                                return _this5.handleCheckBeforeClose('svg');
                              },
                              content: function content(opt) {
                                return _react2.default.createElement(_SvgForm2.default, {
                                  appConfig: _this5.props.appConfig,
                                  ref: function ref(_ref32) {
                                    _this5.uploadForm.svg = _ref32;
                                  },
                                  onSubmit: opt.onConfirm,
                                  siteplan: project.siteplan
                                });
                              },
                              disabled: !oriProject.siteplanAppEnabled
                            })
                          )
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Segment,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { columns: 'equal', verticalAlign: 'middle', textAlign: 'left' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { width: 3 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Image')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { width: 6 },
                            _react2.default.createElement(_semanticUiReact.Label, {
                              basic: true,
                              size: 'small',
                              icon: this.hasSiteplan('image') ? null : 'warning sign',
                              color: this.hasSiteplan('image') ? 'green' : 'red',
                              content: t(this.hasSiteplan('image') ? 'Uploaded' : 'Not uploaded')
                            })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right' },
                            _react2.default.createElement(_UploadModal2.default, {
                              ref: function ref(_ref35) {
                                _this5.uploadModal.image = _ref35;
                              },
                              header: 'image',
                              loading: this.state.loading,
                              btnText: this.hasSiteplan('image') ? t('Replace') : t('Upload', { ns: _translation.TRANSLATION_FILES.translation }),
                              onConfirm: function onConfirm(e, file) {
                                _this5.replaceSiteplan(e, file, 'image');
                              },
                              onClose: function onClose() {
                                return _this5.handleCheckBeforeClose('image');
                              },
                              content: function content(opt) {
                                return _react2.default.createElement(_ImageForm2.default, {
                                  appConfig: _this5.props.appConfig,
                                  ref: function ref(_ref34) {
                                    _this5.uploadForm.image = _ref34;
                                  },
                                  onSubmit: opt.onConfirm,
                                  siteplan: project.siteplan
                                });
                              },
                              disabled: !oriProject.siteplanAppEnabled
                            })
                          )
                        )
                      )
                    ) : _react2.default.createElement(_semanticUiReact.Message, {
                      info: true,
                      header: t('Requirement') + ':',
                      list: [t('SVG'), t('JPEG'), t('Both SVG and JPEG must has same resolution.')]
                    })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { widths: 2 },
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { grouped: true },
                        _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Legends') }),
                        _react2.default.createElement(
                          _semanticUiReact.Form.Group,
                          { grouped: true },
                          _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                            label: t('Available', { ns: _translation.TRANSLATION_FILES.constants }),
                            name: 'hideAvailableLegend',
                            checked: project.siteplanSettings && !project.siteplanSettings.hideAvailableLegend,
                            onChange: this.handleSiteplanSettingsChange
                          }),
                          _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                            label: t('Reserved', { ns: _translation.TRANSLATION_FILES.constants }),
                            name: 'hideReservedLegend',
                            checked: project.siteplanSettings && !project.siteplanSettings.hideReservedLegend,
                            onChange: this.handleSiteplanSettingsChange
                          }),
                          _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                            label: t('Booked', { ns: _translation.TRANSLATION_FILES.constants }),
                            name: 'hideBookedLegend',
                            checked: project.siteplanSettings && !project.siteplanSettings.hideBookedLegend,
                            onChange: this.handleSiteplanSettingsChange
                          }),
                          _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                            label: t('Sold', { ns: _translation.TRANSLATION_FILES.constants }),
                            name: 'hideSoldLegend',
                            checked: project.siteplanSettings && !project.siteplanSettings.hideSoldLegend,
                            onChange: this.handleSiteplanSettingsChange
                          }),
                          _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                            label: t('Delist', { ns: _translation.TRANSLATION_FILES.constants }),
                            name: 'hideDelistLegend',
                            checked: project.siteplanSettings && !project.siteplanSettings.hideDelistLegend,
                            onChange: this.handleSiteplanSettingsChange
                          })
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { grouped: true },
                        _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('General Settings:') }),
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          label: t('Hide unit layouts'),
                          name: 'hideLayouts',
                          checked: project.siteplanSettings && project.siteplanSettings.hideLayouts,
                          onChange: this.handleSiteplanSettingsChange
                        }),
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          label: t('Default filter Available'),
                          name: 'defaultFilter',
                          checked: project.siteplanSettings && project.siteplanSettings.defaultFilter,
                          onChange: this.handleSiteplanSettingsChange
                        }),
                        project && project.propertyCategory.category === _propertyCategories.PROPERTY_CATEGORY_HIGH_RISE ? _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          label: t('Hide towers and levels'),
                          name: 'hideTowersAndLevels',
                          checked: project.siteplanSettings && project.siteplanSettings.hideTowersAndLevels,
                          onChange: this.handleSiteplanSettingsChange
                        }) : null,
                        _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Agents/Staff Settings:') }),
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          label: t('Simple View Mode (Units are shown as Available/Unavailable)'),
                          name: 'siteplanSimpleMode',
                          checked: project.siteplanSettings && project.siteplanSettings.siteplanSimpleMode,
                          onChange: this.handleSiteplanSettingsChange
                        }),
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          label: t('Show Delisted units as Unavailable'),
                          name: 'siteplanDelistedAsUnavailable',
                          disabled: project.siteplanSettings && !project.siteplanSettings.siteplanSimpleMode,
                          checked: project.siteplanSettings && project.siteplanSettings.siteplanDelistedAsUnavailable,
                          onChange: this.handleSiteplanSettingsChange,
                          style: { marginLeft: '20px' }
                        }),
                        _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Public Settings:') }),
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          label: t('Hide price for public share'),
                          name: 'hidePublicPriceSiteplan',
                          disabled: !project.isPublic,
                          checked: project.hidePublicPriceSiteplan,
                          onChange: this.handleCheckBoxChange
                        }),
                        _react2.default.createElement(_semanticUiReact.Form.Select, {
                          label: t('Overlay mode'),
                          name: 'overlayMode',
                          fluid: true,
                          onChange: this.handleSiteplanSettingsChange,
                          value: project.siteplanSettings && project.siteplanSettings.overlayMode ? project.siteplanSettings.overlayMode : 'text',
                          options: this.overlayModes.map(function (om) {
                            return _extends({}, om, {
                              text: t(om.text, { ns: _translation.TRANSLATION_FILES.constants })
                            });
                          })
                        })
                      )
                    )
                  )
                )
              ) : null
            ),
            this.hasUpdateAccess() && this.hasAccess(true, true, false) ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('marketplace') },
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Form.Field, {
                    label: _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Header,
                        {
                          as: 'h3',
                          style: { marginBottom: '5px' }
                        },
                        t('Launch your unsold projects to MHub agents to help you sell faster')
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Label,
                        {
                          style: {
                            background: 'transparent',
                            padding: 0,
                            fontSize: '1rem'
                          }
                        },
                        t('For successful booking transaction, these info are required'),
                        ':'
                      )
                    ),
                    style: { marginBottom: '2rem' }
                  }),
                  _react2.default.createElement(
                    _semanticUiReact.List,
                    { bulleted: true },
                    _react2.default.createElement(
                      _semanticUiReact.List.Item,
                      { style: { marginBottom: '2rem' } },
                      _react2.default.createElement(
                        _semanticUiReact.Header,
                        {
                          as: 'h5',
                          style: { marginBottom: '5px' }
                        },
                        t('Documents').toUpperCase()
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Label,
                        {
                          style: {
                            background: 'transparent',
                            padding: 0,
                            fontSize: '1rem'
                          }
                        },
                        t('E-sales kit or PDF Brochure which can be uploaded at'),
                        ' \xA0',
                        _react2.default.createElement(
                          _semanticUiReact.Button,
                          {
                            as: _reactRouter.Link,
                            className: 'flash-button',
                            to: '/projects/' + this.state.project.id + '/documents/',
                            style: {
                              opacity: 1
                            }
                          },
                          t('Documents')
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.List.Item,
                      { style: { marginBottom: '2rem' } },
                      _react2.default.createElement(
                        _semanticUiReact.Header,
                        {
                          as: 'h5',
                          style: { marginBottom: '5px' }
                        },
                        t('Bank Account Info').toUpperCase()
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Label,
                        {
                          style: {
                            background: 'transparent',
                            padding: 0,
                            fontSize: '1rem'
                          }
                        },
                        t('Your account info for agents to bank-in booking fee deposit at'),
                        ' \xA0',
                        _react2.default.createElement(
                          _semanticUiReact.Button,
                          {
                            className: 'flash-button',
                            onClick: function onClick(e) {
                              return _this5.handleNavigatePayment(e, 'payment_setup');
                            }
                          },
                          t('Payment Setup')
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.List.Item,
                      { style: { marginBottom: '2rem' } },
                      _react2.default.createElement(
                        _semanticUiReact.Header,
                        {
                          as: 'h5',
                          style: { marginBottom: '5px' }
                        },
                        t('Booking Fee Deposit').toUpperCase()
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Label,
                        {
                          style: {
                            background: 'transparent',
                            padding: 0,
                            fontSize: '1rem'
                          }
                        },
                        t('The amount you require to secure a unit at'),
                        ' \xA0',
                        _react2.default.createElement(
                          _semanticUiReact.Button,
                          {
                            className: 'flash-button',
                            onClick: function onClick(e) {
                              return _this5.handleNavigatePayment(e, 'payment_setup');
                            }
                          },
                          t('Payment Setup')
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.List.Item,
                      { style: { marginBottom: '2rem' } },
                      _react2.default.createElement(_AppForm2.default.Input, {
                        label: (0, _translation2.translateModels)(t, 'commission', 'project').toUpperCase(),
                        name: 'commission',
                        placeholder: t('e.g 1% or RM5000 - RM50,000'),
                        value: project.commission,
                        onChange: this.handleInputChange
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.List.Item,
                      { style: { marginBottom: '2rem' } },
                      _react2.default.createElement(_AppForm2.default.Input, {
                        label: (0, _translation2.translateModels)(t, 'commissionDescription', 'project').toUpperCase() + ' (' + t('Optional') + ')',
                        name: 'commissionDescription',
                        placeholder: t('e.g First 50% paid upon SPA signed. The other 50% to be paid out after first loan disbursement'),
                        value: project.commissionDescription,
                        onChange: this.handleInputChange
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Form.Group,
                    { widths: 'equal' },
                    _react2.default.createElement(
                      _semanticUiReact.Segment,
                      { style: { marginRight: '1.5em' } },
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { inline: true, style: { margin: 0 } },
                        _react2.default.createElement(
                          _semanticUiReact.Form.Group,
                          { grouped: true, style: { paddingRight: '1.5em', margin: 0 } },
                          _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Launch to Marketplace') })
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Form.Group,
                          { style: { margin: 0 } },
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { grouped: true, style: { paddingLeft: '1.5em' } },
                            _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                              toggle: true,
                              label: t('' + (project.marketplaceIsPublish ? 'Publish' : 'Unpublish') + (project.marketplaceIsPublish === oriProject.marketplaceIsPublish ? 'ed' : '')),
                              name: 'marketplaceIsPublish',
                              checked: project.marketplaceIsPublish,
                              onChange: !project.marketplaceIsPublish && (!project.projectBankAccount || project.defaultBookingFeeAmount <= 0 || !project.documents || !project.commission) ? this.handleFlashMPCriteriaMsg : this.handleCheckBoxChange
                            })
                          )
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Field,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Label,
                          {
                            style: {
                              background: 'transparent',
                              padding: 0,
                              fontSize: '1rem'
                            }
                          },
                          t('I Agree to the'),
                          ' \xA0',
                          _react2.default.createElement(
                            _semanticUiReact.Button,
                            { onClick: this.showTnC, style: { opacity: 1 }, className: 'flash-button' },
                            t('Terms and Conditions')
                          ),
                          _react2.default.createElement(_MarketplaceTncModal2.default, {
                            open: this.state.openTncModal,
                            header: t('Terms and Conditions'),
                            onClose: this.handleOnClose
                          })
                        )
                      )
                    ),
                    this.buyerMarketplaceHasAccess() ? _react2.default.createElement(
                      _semanticUiReact.Segment,
                      { style: { marginTop: '0' } },
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { inline: true, style: { margin: 0 } },
                        _react2.default.createElement(
                          _semanticUiReact.Form.Group,
                          { grouped: true, style: { paddingRight: '1.5em', margin: 0 } },
                          _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Launch to Showroom for Buyers') })
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Form.Group,
                          { style: { margin: 0 } },
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { grouped: true, style: { paddingLeft: '1.5em' } },
                            _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                              toggle: true,
                              label: t('' + (project.marketplaceBuyerIsPublish ? 'Publish' : 'Unpublish') + (project.marketplaceBuyerIsPublish === oriProject.marketplaceBuyerIsPublish ? 'ed' : '')),
                              name: 'marketplaceBuyerIsPublish',
                              checked: project.marketplaceBuyerIsPublish,
                              onChange: !project.marketplaceBuyerIsPublish && (!project.projectBankAccount || project.defaultBookingFeeAmount <= 0 || !project.documents) ? this.handleFlashMPCriteriaMsg : this.handleCheckBoxChange
                            })
                          )
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Field,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Label,
                          {
                            style: {
                              background: 'transparent',
                              padding: 0,
                              fontSize: '1rem'
                            }
                          },
                          t('I Agree to the'),
                          ' \xA0',
                          _react2.default.createElement(
                            _semanticUiReact.Button,
                            { onClick: this.showTnC, style: { opacity: 1 }, className: 'flash-button' },
                            t('Terms and Conditions')
                          ),
                          _react2.default.createElement(_MarketplaceTncModal2.default, {
                            open: this.state.openTncModal,
                            header: t('Terms and Conditions'),
                            onClose: this.handleOnClose
                          })
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal', style: { margin: 0, marginTop: '1em' } },
                        _react2.default.createElement(
                          _semanticUiReact.Form.Group,
                          { inline: true, style: { paddingRight: '1.5em', margin: 0 } },
                          _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Restrict buyer’s access to project'), style: { paddingRight: '0.5em' } }),
                          _react2.default.createElement(_semanticUiReact.Popup, {
                            className: 'srb',
                            content: t('If this toggle is enabled, this project will be invisible inside of SRB unless if access is granted to a customer inside of MHub Lead'),
                            on: 'click',
                            wide: true,
                            positionFixed: true,
                            style: { background: '#596975' },
                            position: 'bottom right',
                            trigger: _react2.default.createElement(_semanticUiReact.Button, {
                              icon: 'info circle',
                              size: 'large',
                              style: { padding: '0 .2em 0 0', background: 'none' }
                            }),
                            pinned: true,
                            inverted: true,
                            onOpen: function onOpen(e) {
                              e.preventDefault();
                            },
                            onClose: function onClose(e) {
                              e.preventDefault();
                            }
                          })
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Form.Group,
                          { style: { margin: 0 } },
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { grouped: true, style: { paddingLeft: '1.5em' } },
                            _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                              toggle: true,
                              label: t(project.isProjectBAC ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                              name: 'isProjectBAC',
                              checked: project.isProjectBAC,
                              onChange: this.handleCheckBoxChange
                            })
                          )
                        )
                      )
                    ) : null
                  ),
                  isVietnamCompany && this.buyerMarketplaceHasAccess() && _react2.default.createElement(
                    _semanticUiReact.Form.Field,
                    null,
                    _react2.default.createElement(_AppForm2.default.Input, {
                      label: t('SRB sales chart expiry (minutes)'),
                      name: 'srbStoreyPlanExpiryMinutes',
                      type: 'number',
                      min: 1,
                      max: 30,
                      step: 1,
                      required: true,
                      disabled: !this.props.auth.isHeadquarters,
                      value: project.srbStoreyPlanExpiryMinutes,
                      onChange: this.handleInputChange,
                      ref: this.validation.srbStoreyPlanExpiryMinutes,
                      validation: [_srbChartExpiry.validateSRBExpiry],
                      message: t('Enter a whole number from 1 to 30 minutes.')
                    }),
                    _react2.default.createElement(
                      'i',
                      null,
                      t('Each opened sales chart session expires after this duration. Reloading does not extend it. Only HQ can edit.')
                    )
                  ),
                  this.buyerMarketplaceHasAccess() ? _react2.default.createElement(
                    _semanticUiReact.Divider,
                    { horizontal: true },
                    t('Booking Form & E-Signing').toUpperCase()
                  ) : null,
                  this.buyerMarketplaceHasAccess() ? _react2.default.createElement(
                    _semanticUiReact.Form.Group,
                    { widths: 'equal' },
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { widths: 'equal', style: { paddingRight: '1.5em' } },
                      _react2.default.createElement(_semanticUiReact.Form.Field, { style: { paddingTop: '.65em' }, label: (0, _translation2.translateModels)(t, 'mpAllowESignFormAtReserve', 'project') }),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        null,
                        _react2.default.createElement(_semanticUiReact.Popup, {
                          className: 'srb',
                          content: t('If this setting is enabled, buyers will have access to the project\'s booking form(s) and e-signing despite being in the Reserved/ Pending status'),
                          on: 'click',
                          wide: true,
                          positionFixed: true,
                          style: { background: '#596975' },
                          position: 'bottom right',
                          trigger: _react2.default.createElement(_semanticUiReact.Button, {
                            icon: 'question circle outline',
                            size: 'large',
                            style: { padding: '0 .2em 0 .3em', background: 'none' }
                          }),

                          pinned: true,
                          inverted: true,
                          onOpen: function onOpen(e) {
                            e.preventDefault();
                          },
                          onClose: function onClose(e) {
                            e.preventDefault();
                          }
                        }),
                        _react2.default.createElement(
                          _semanticUiReact.Form.Group,
                          { grouped: true, style: { paddingLeft: '.5em' } },
                          _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                            toggle: true,
                            label: t(project.mpAllowESignFormAtReserve ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                            name: 'mpAllowESignFormAtReserve',
                            checked: project.mpAllowESignFormAtReserve,
                            onChange: this.handleCheckBoxChange
                          })
                        )
                      )
                    )
                  ) : null,
                  _react2.default.createElement(
                    _semanticUiReact.Divider,
                    { horizontal: true },
                    t('Event Timer').toUpperCase()
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Form.Group,
                    { widths: 'equal' },
                    _react2.default.createElement(
                      _semanticUiReact.Form.Field,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Label,
                        {
                          style: {
                            background: 'transparent',
                            padding: 0
                          }
                        },
                        'Event date'
                      ),
                      _react2.default.createElement(_semanticUiReact.Form.Input, {
                        fluid: true,
                        placeholder: t('Select date and time'),
                        value: eventTime ? eventTime.format(inputDateFormat) : '',
                        onFocus: function onFocus() {
                          return _this5.handleOnVisible(true);
                        },
                        style: { marginTop: '1rem' },
                        icon: project.mpBuyerEventLaunchAt ? _react2.default.createElement(_semanticUiReact.Icon, {
                          color: 'red',
                          link: true,
                          name: 'x',
                          onClick: this.resetEventTimer,
                          title: 'Clear'
                        }) : 'calendar'
                      }),
                      _react2.default.createElement(_DateTimePicker2.default, {
                        minDate: (0, _momentTimezone2.default)(),
                        onChange: function onChange(value, visible) {
                          return _this5.handleDateTimeInputChange(value, visible);
                        },
                        value: project.mpBuyerEventLaunchAt && (0, _momentTimezone2.default)(project.mpBuyerEventLaunchAt).isAfter((0, _momentTimezone2.default)()) ? (0, _momentTimezone2.default)(project.mpBuyerEventLaunchAt).toDate() : (0, _momentTimezone2.default)().toDate(),
                        visible: isVisible,
                        useBrowserTimezone: isVietnamCompany
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Field,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Label,
                        {
                          style: {
                            background: 'transparent',
                            padding: 0
                          }
                        },
                        t('Countdown timer')
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Segment,
                        { className: 'segment1' },
                        _react2.default.createElement(
                          'p',
                          null,
                          t('Time remaining to Event')
                        ),
                        project.mpBuyerEventLaunchAt ? _react2.default.createElement(
                          'div',
                          { className: 'countDownBox', style: { display: 'inline-block', fontSize: '1.5rem' } },
                          _react2.default.createElement(_CountdownAdvance2.default, {
                            targetDate: (0, _momentTimezone2.default)(project.mpBuyerEventLaunchAt).toDate(),
                            timeSeparator: ' : ',
                            format: this.getCountdownFormat(project.mpBuyerEventLaunchAt),
                            showUnit: true,
                            leadingZero: true
                          }),
                          _react2.default.createElement(_semanticUiReact.Button, {
                            content: t('Cancel timer'),
                            inverted: true,
                            color: 'red',
                            type: 'button',
                            style: { marginTop: '1.5rem' },
                            onClick: this.resetEventTimer
                          })
                        ) : _react2.default.createElement(
                          'h4',
                          { style: { display: 'inline-block', fontSize: '1.5rem' } },
                          t('{{count}} days', { count: '0' }),
                          ' : ',
                          t('{{count}} hours', { count: '0' }),
                          ' : ',
                          t('{{count}} minutes', { count: '0' }),
                          ' : ',
                          t('{{count}} seconds', { count: '0' })
                        )
                      )
                    )
                  )
                )
              )
            ) : '',
            this.hasUpdateAccess() ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('booking_fields') },
              _react2.default.createElement(_CustomField2.default, {
                data: project.projectBookingCustomFields || [],
                onChangeData: this.handleOnChangeCustomFieldData,
                type: 'booking'
              })
            ) : '',
            this.hasUpdateAccess() ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('tier_pricing') },
              _react2.default.createElement(_ProjectPricingTier2.default, {
                data: project.projectPricings || [],
                onDelete: this.handlePricingTierDelete,
                onChangeData: this.handlePricingTierChange,
                onSaveData: this.handlePricingSave,
                onDefaultInputChange: this.handleInputChange,
                defaultBumiProjectPricingID: project.defaultBumiProjectPricingID,
                defaultProjectPricingID: project.defaultProjectPricingID
              }),
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { basic: true },
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    fluid: true,
                    primary: true,
                    onClick: this.handleImportPricingClick
                  },
                  'Bulk Import Discount From Excel'
                )
              )
            ) : '',
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('access') },
              this.hasAccess(true, true, false) && _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _semanticUiReact.Divider,
                  { horizontal: true },
                  t('Nett Selling Price')
                ),
                _react2.default.createElement(
                  _semanticUiReact.Form.Group,
                  { widths: 'equal' },
                  _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    label: t('Business Unit Leaders'),
                    name: 'accessBULNettSellingPrice',
                    checked: project.accessBULNettSellingPrice,
                    onChange: this.handleCheckBoxChange
                  }),
                  _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    label: t('Staff & Agent'),
                    name: 'accessStaffNettSellingPrice',
                    checked: project.accessStaffNettSellingPrice,
                    onChange: this.handleCheckBoxChange
                  })
                )
              )
            ),
            this.hasUpdateAccess() ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('letter_settings') },
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                (0, _translation2.translateModels)(t, 'loanReminderLetter', 'project')
              ),
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                label: (0, _translation2.translateModels)(t, 'printLoanReminderType', 'project'),
                name: 'printLoanReminderType',
                fluid: true,
                onChange: this.handleInputChange,
                value: project.printLoanReminderType,
                options: printLoanReminderTypes
              }),
              _react2.default.createElement(_TextFieldMarkdownPreview2.default, {
                data: project.loanReminderLetter || '',
                name: 'loanReminderLetter',
                labelName: (0, _translation2.translateModels)(t, 'loanReminderLetter', 'project'),
                onDefaultInputChange: this.handleInputChange
              }),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                (0, _translation2.translateModels)(t, 'spaReminderLetter', 'project')
              ),
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                label: (0, _translation2.translateModels)(t, 'printSPAType', 'project'),
                name: 'printSPAType',
                fluid: true,
                onChange: this.handleInputChange,
                value: project.printSPAType,
                options: printSPAReminderTypes
              }),
              _react2.default.createElement(_TextFieldMarkdownPreview2.default, {
                data: project.spaReminderLetter || '',
                name: 'spaReminderLetter',
                labelName: (0, _translation2.translateModels)(t, 'spaReminderLetter', 'project'),
                onDefaultInputChange: this.handleInputChange
              }),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                (0, _translation2.translateModels)(t, 'terminationLetter', 'project')
              ),
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                label: (0, _translation2.translateModels)(t, 'printTerminationType', 'project'),
                name: 'printTerminationType',
                fluid: true,
                onChange: this.handleInputChange,
                value: project.printTerminationType,
                options: printTerminationTypes
              }),
              _react2.default.createElement(_TextFieldMarkdownPreview2.default, {
                data: project.terminationLetter || '',
                name: 'terminationLetter',
                labelName: (0, _translation2.translateModels)(t, 'terminationLetter', 'project'),
                onDefaultInputChange: this.handleInputChange
              })
            ) : '',
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('currency_settings') },
              _react2.default.createElement(_Currencies2.default, {
                allowSwitchingDefault: true,
                companyDefaultCurrency: this.getCompanyDefaultCurrency(),
                currenciesProvided: this.getCompanyCurrencyOptions(),
                data: project.projectCurrency || [],
                loading: this.state.loading,
                onDefaultAdd: function onDefaultAdd(v, d) {
                  _this5.handleAddCurrency(v, d);
                },
                onDefaultDelete: function onDefaultDelete(e, d) {
                  _this5.handleDeleteCurrency(e, d);
                },
                onDefaultMakeDefault: function onDefaultMakeDefault(e, d) {
                  _this5.handleMakeDefaultCurrency(e, d);
                },
                onDefaultSave: function onDefaultSave(v, d) {
                  _this5.handleSaveCurrency(v, d);
                }
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('options') },
              _react2.default.createElement(_SpecificationTable2.default, {
                type: 'projectOptions',
                editable: true,
                isEditing: true,
                hideButton: true,
                notFoundNode: _react2.default.createElement(
                  'p',
                  null,
                  t('No API options'),
                  '.'
                ),
                headerNode: t('API Options'),
                data: project.options,
                onChange: this.handleOptionChange,
                loading: this.state.loading
              }),
              _react2.default.createElement(_SpecificationTable2.default, {
                type: 'projectMappings',
                editable: true,
                isEditing: true,
                hideButton: true,
                notFoundNode: _react2.default.createElement(
                  'p',
                  null,
                  t('No Project Mapped yet'),
                  '.'
                ),
                headerNode: t('Project Mapping'),
                data: project.mappings,
                onChange: this.handleMappingChange,
                loading: this.state.loading
              })
            ),
            this.hasUpdateAccess() ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true, className: this.checkActiveTab('reservation_token_settings') },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Divider,
                    { horizontal: true },
                    t('Reservation Token Settings')
                  ),
                  _react2.default.createElement(_AppForm2.default.Input, {
                    label: t('Price'),
                    name: 'priceMinor',
                    type: 'number',
                    min: '1',
                    step: '1',
                    value: projectReservationTokenSetting.priceMinor,
                    validation: [_webValidations.required, {
                      validate: _webValidations.numericRange,
                      option: { min: 1 }
                    }],
                    ref: this.rtValidation.rtPriceMinor,
                    onChange: this.handleReservationTokenSettingChange
                  }),
                  _react2.default.createElement(_AppForm2.default.Input, {
                    label: t('Validity Duration (Days)'),
                    name: 'validityDurationDays',
                    type: 'number',
                    min: '1',
                    step: '1',
                    value: projectReservationTokenSetting.validityDurationDays,
                    validation: [_webValidations.required, {
                      validate: _webValidations.numericRange,
                      option: { min: 1 }
                    }],
                    ref: this.rtValidation.rtValidityDurationDays,
                    onChange: this.handleReservationTokenSettingChange
                  }),
                  _react2.default.createElement(_AppForm2.default.Input, {
                    label: t('Limit Per Opportunity'),
                    name: 'limitPerOpportunity',
                    type: 'number',
                    min: '1',
                    step: '1',
                    value: projectReservationTokenSetting.limitPerOpportunity,
                    validation: [_webValidations.required, {
                      validate: _webValidations.numericRange,
                      option: { min: 1 }
                    }],
                    ref: this.rtValidation.rtLimitPerOpportunity,
                    onChange: this.handleReservationTokenSettingChange
                  }),
                  _react2.default.createElement(_semanticUiReact.Form.Select, {
                    label: t('Currency'),
                    name: 'currencyCode',
                    fluid: true,
                    options: [{ key: 'MYR', text: 'MYR', value: 'MYR' }, { key: 'IDR', text: 'IDR', value: 'IDR' }, { key: 'VND', text: 'VND', value: 'VND' }],
                    value: projectReservationTokenSetting.currencyCode,
                    onChange: this.handleReservationTokenSettingChange
                  })
                )
              )
            ) : null
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true },
              _react2.default.createElement(_UnpublishProjectModal2.default, {
                open: this.state.openModal,
                onConfirm: this.handleSubmit
              })
            )
          )
        )
      );
    }
  }]);

  return ProjectForm;
}(_react.Component);

ProjectForm.propTypes = {
  onClose: _propTypes2.default.bool,
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      creditControlIsEnabled: _propTypes2.default.bool,
      onlinePaymentEnabled: _propTypes2.default.bool,
      paymsPaymentGateway: _propTypes2.default.string,
      himsIsEnabled: _propTypes2.default.bool,
      settings: _propTypes2.default.shape({
        virtualAccountIsEnabled: _propTypes2.default.bool,
        generateQuotationIsEnabled: _propTypes2.default.bool
      })
    })
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isAdminCommunity: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isDeveloperSupervisor: _propTypes2.default.bool,
    isDeveloperSalesManager: _propTypes2.default.bool,
    isDeveloperSalesAdmin: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      companyCurrency: _propTypes2.default.oneOfType([_propTypes2.default.array]),
      countryCode: _propTypes2.default.string,
      service_company_id: _propTypes2.default.string
    }),
    companyApps: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      appID: _propTypes2.default.string
    }))
  }),
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  project: _propTypes2.default.shape({
    name: _propTypes2.default.string,
    marketplaceIsPublish: _propTypes2.default.bool,
    marketplaceBuyerIsPublish: _propTypes2.default.bool,
    isProjectBAC: _propTypes2.default.bool,
    mpAllowESignFormAtReserve: _propTypes2.default.bool,
    statusID: _propTypes2.default.string,
    projectFormAccessibilities: _propTypes2.default.array
  }),
  location: _propTypes2.default.shape({
    hash: _propTypes2.default.string,
    pathname: _propTypes2.default.string,
    action: _propTypes2.default.string,
    query: _propTypes2.default.object
  }),
  loading: _propTypes2.default.bool,
  // bobForms: PropTypes.shape({
  //   data: PropTypes.array,
  // }),
  templates: _propTypes2.default.shape({
    token: _propTypes2.default.string,
    data: _propTypes2.default.shape({
      print: _propTypes2.default.array,
      saleschart: _propTypes2.default.array,
      accessibleIn: _propTypes2.default.array
    })
  }),
  salesChartTypes: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  addressSettings: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  financeSources: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  token: _propTypes2.default.string,
  newFetch: _propTypes2.default.func,
  t: _propTypes2.default.func
};
ProjectForm.contextTypes = {
  store: _propTypes2.default.object
};

ProjectForm.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig,
    auth: state.auth,
    // bobForms: state.bobForms,
    templates: state.templates,
    salesChartTypes: state.salesChartTypes,
    addressSettings: state.addressSettings,
    financeSources: state.financeSources
  };
};

ProjectForm.defaultValues = {
  id: '',
  code: '',
  name: '',
  shortName: '',
  referenceCode: '',
  phonePrefix: '60',
  phone: '',
  address1: '',
  address2: '',
  address3: '',
  address4: '',
  address5: '',
  address6: '',
  address7: '',
  address8: '',
  address9: '',
  address10: '',
  city: '',
  postcode: '',
  state: '',
  region: '',
  township: '',
  agencyAllocationAllocateAll: false,
  country: 'my',
  ownershipType: 'leasehold',
  propertyCategoryID: 'apartment',
  isCommercial: false,
  isIndustrial: false,
  isResidential: false,
  foreignPurchaseThreshold: _foreignPurchaseThreshold.FOREIGN_PURCHASE_THRESHOLD_DEFAULT,
  overviewTitle: '',
  overviewSubTitle: '',
  overview: '',
  specifications: [],
  options: [],
  mappings: [],
  manualPrice: false,
  minPrice: 0,
  maxPrice: 0,
  manualSize: false,
  minSize: 0,
  maxSize: 0,
  sizeSuffix: 'square_feet',
  loanTrackerProjectConsentTypeID: '2',
  newBookingEmailNotifications: [],
  approvedBookingEmailNotifications: [],
  cancelledBookingEmailNotifications: [],
  soldStatusBookingEmailNotifications: [],
  bookingUnitLimit: 1,
  statusID: 'draft',
  salesChartType: 'position',
  salesChartTemplate: 'default',
  siteplanID: '',
  siteplan: {},
  siteplanSettings: {},
  printType: 'none',
  sharedToBankerForms: [],
  printSPAType: 'none',
  printTerminationType: 'none',
  printClause: '',
  maOwnerCompanyBranchID: 0,
  maOwnerCompanyBranchShortName: '',
  loanTrackerDirectShow: true,
  loanTrackerProjectLeadBankersLimit: 6,
  isLaunchMode: false,
  launchModeMinutes: 0,
  defaultCustomBookingStatusID: 'reserved',
  defaultBumiProjectPricingID: '',
  defaultProjectPricingID: '',
  projectPricings: [],
  logoID: '',
  logo: null,
  salesChartRefreshSeconds: 120,
  customWatermark: '',
  linkBuyerApp: false,
  companyName: '',
  companyRegistrationNo: '',
  companyAddress: '',
  companyContactNo1: '',
  companyContactNo2: '',
  companyEmail: '',
  companyOthers: '',
  arBookingExpMoreThanMinutes: '',
  bapIsEnabled: false,
  bapIsProjectMode: false,
  bapMaxAttempts: 3,
  bapWindowMinutes: 30,
  bapCooldownMinutes: 180,
  bnReadAccessGroupIDs: _srRoleAccess.defaultBookingNoteAccesses,
  bnWriteAccessGroupIDs: _srRoleAccess.defaultBookingNoteAccesses,
  bnDefaultPrivacy: 'public',
  rduAccessGroupIDs: _srRoleAccess.defaultRduAccesses,
  paymentReceiptAccessGroupIDs: _srRoleAccess.defaultPaymentReceiptAccesses,
  cuRoleAccesses: [],
  requireValidTinAtBookingCreation: false,
  requireValidTinAtBookingAndSold: false,
  requireValidTinAtSold: false,
  tinSettingBookingStartAt: null,
  allowEditConversionDetailsIsEnabled: false,
  // CPI-974 item 18: statuses that need an approved payment. Empty for every existing project.
  paymentApprovedRequiredStatusIDs: [],
  // CPI-976: Reserved -> Booked needs the purchaser's signature. False for every project today.
  signatureRequiredForBooked: false,
  // Pre-Sales Launch: the roles blocked from reserving and from the Storey Plan. Empty = nobody.
  reserveDisabledRoleIDs: [],
  salesChartDisabledRoleIDs: []
};

ProjectForm.getPropsToState = function (props) {
  var loading = props.loading;
  var user = props.auth;
  if (user && (0, _companies.isForeignCompany)(user.company)) {
    var idx = _intlFlagCodes2.default.findIndex(function (f) {
      return f.countryCode === user.company.countryCode;
    });
    if (idx !== -1) {
      ProjectForm.defaultValues.phonePrefix = _intlFlagCodes2.default[idx].value;
      ProjectForm.defaultValues.country = _intlFlagCodes2.default[idx].countryCode;
    }
  }

  var oriProject = Object.assign({}, ProjectForm.defaultValues, props.project || {});

  if (!props.project) {
    oriProject.maOwnerCompanyBranchID = user.companyBranch.id;
    oriProject.maOwnerCompanyBranchShortName = user.companyBranch.shortName;
  }
  if (!oriProject.manualPrice) {
    oriProject.minPrice = oriProject.summary ? oriProject.summary.minPrice : 0;
    oriProject.maxPrice = oriProject.summary ? oriProject.summary.maxPrice : 0;
  }
  if (!oriProject.manualSize) {
    oriProject.minSize = oriProject.summary ? oriProject.summary.minSize : 0;
    oriProject.maxSize = oriProject.summary ? oriProject.summary.maxSize : 0;
  }
  oriProject.srbStoreyPlanExpiryMinutes = (0, _srbChartExpiry.initialSRBExpiry)(oriProject);
  oriProject.foreignPurchaseThreshold = (0, _foreignPurchaseThreshold.foreignPurchaseThresholdOrDefault)(oriProject.foreignPurchaseThreshold);
  if (!oriProject.specifications) {
    oriProject.specifications = [];
  }
  if (!oriProject.mappings) {
    oriProject.mappings = [];
  }
  if (!oriProject.options) {
    oriProject.options = [];
  }
  if (!oriProject.siteplanSettings) {
    oriProject.siteplanSettings = {};
  }
  if (oriProject.printType === '') {
    oriProject.printType = 'none';
  }
  if (!Array.isArray(oriProject.sharedToBankerForms)) {
    oriProject.sharedToBankerForms = [];
  }
  if (oriProject.printSPAType === '') {
    oriProject.printSPAType = 'none';
  }
  if (oriProject.printTerminationType === '') {
    oriProject.printTerminationType = 'none';
  }
  if (oriProject.salesChartTemplate === '') {
    oriProject.salesChartTemplate = 'default';
  }
  if (oriProject.bapWindowMinutes) {
    oriProject.bapWindowMinutes = oriProject.bapWindowMinutes.toString();
  }
  if (oriProject.bapCooldownMinutes) {
    oriProject.bapCooldownMinutes = oriProject.bapCooldownMinutes.toString();
  }
  var menuIsTab = window.innerWidth >= 991;
  var menuIsVertical = window.innerWidth >= 991;
  // const bForms = props.bobForms && props.bobForms.data
  //   ? [].concat(props.bobForms.data).sort((a, b) => a.title.localeCompare(b.title)) : [];
  // const bobForms = props.templates && props.templates.data && props.templates.data.print && bForms
  //   ? bForms.map(t => ({
  //     value: t.id,
  //     text: t.title,
  //   })) : [];
  var formAccessibilitiesTemplateIDs = props.project && props.project.projectFormAccessibilities && props.project.projectFormAccessibilities.length > 0 ? props.project.projectFormAccessibilities.map(function (p) {
    return p.templateID;
  }) : [];
  var pTemplates = props.templates && props.templates.data && props.templates.data.print ? [].concat(props.templates.data.print).sort(function (a, b) {
    return a.name.localeCompare(b.name);
  }) : [];
  var printTemplates = props.templates && props.templates.data && props.templates.data.print && pTemplates ? pTemplates.map(function (t) {
    return {
      value: t.id,
      text: t.name
    };
  }) : [];
  var printLoanReminderTemplates = props.templates && props.templates.data && props.templates.data.loan_reminder ? [].concat(props.templates.data.loan_reminder).map(function (t) {
    return {
      value: t.id,
      text: t.name
    };
  }) : [];
  var printSPAReminderTemplates = props.templates && props.templates.data && props.templates.data.spa_reminder ? [].concat(props.templates.data.spa_reminder).map(function (t) {
    return {
      value: t.id,
      text: t.name
    };
  }) : [];
  var printTerminationTemplates = props.templates && props.templates.data && props.templates.data.termination ? [].concat(props.templates.data.termination).map(function (t) {
    return {
      value: t.id,
      text: t.name
    };
  }) : [];
  var salesChartTemplates = props.templates && props.templates.data && props.templates.data.saleschart ? [].concat(props.templates.data.saleschart).map(function (t) {
    return {
      value: t.id,
      text: t.name
    };
  }) : [];
  var salesChartTypes = props.salesChartTypes ? [].concat(props.salesChartTypes.data).map(function (_ref37) {
    var value = _ref37.value,
        text = _ref37.text;

    if (value !== 'disabled' && value !== 'custom' && value !== 'saleschart-app') {
      return {
        text: props.t('Pivoted by {{text}}', { text: props.t(text) }),
        value: value
      };
    }
    return { text: text, value: value };
  }) : [];
  var token = props.token;
  if (oriProject && (!oriProject.sourceOfFinanceOptions || oriProject.sourceOfFinanceOptions.length === 0)) {
    oriProject.sourceOfFinanceOptions = (0, _financeSource.getDefaultProjectSourceOfFinanceOptions)();
  }
  var defaultRTSetting = { priceMinor: 0, validityDurationDays: 0, limitPerOpportunity: 0, currencyCode: 'MYR' };
  var projectReservationTokenSetting = _extends({}, defaultRTSetting, props.project && props.project.unitReservationTokenSetting ? props.project.unitReservationTokenSetting : {});
  return {
    loading: loading,
    project: (0, _clone2.default)(oriProject),
    srbExpiryEdited: false,
    oriProject: oriProject,
    formAccessibilitiesTemplateIDs: formAccessibilitiesTemplateIDs,
    menuIsTab: menuIsTab,
    menuIsVertical: menuIsVertical,
    // bForms,
    // bobForms,
    pTemplates: pTemplates,
    printTemplates: printTemplates,
    printLoanReminderTemplates: printLoanReminderTemplates,
    printSPAReminderTemplates: printSPAReminderTemplates,
    printTerminationTemplates: printTerminationTemplates,
    salesChartTemplates: salesChartTemplates,
    salesChartTypes: salesChartTypes,
    token: token,
    projectReservationTokenSetting: projectReservationTokenSetting,
    oriProjectReservationTokenSetting: (0, _clone2.default)(projectReservationTokenSetting)
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.getSelectedBranchValue = function () {
    var project = _this6.state.project;

    var selectedBranchValue = {
      key: project.maOwnerCompanyBranchID.toString() || 0,
      title: project.maOwnerCompanyBranchShortName || ''
    };
    return selectedBranchValue;
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this6.setState({ loading: loading }, res);
    });
  };

  this.setCompanyHimsTokensLoading = function () {
    var companyHimsTokensLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this6.setState({ companyHimsTokensLoading: companyHimsTokensLoading }, res);
    });
  };

  this.handleOnVisible = function (bool) {
    _this6.setState({ isVisible: bool });
  };

  this.handleDateTimeInputChange = function (value, visible) {
    var project = _this6.state.project;
    var isVisible = _this6.state.isVisible;

    var hoursLeft = _momentTimezone2.default.duration((0, _momentTimezone2.default)(value).diff((0, _momentTimezone2.default)())).asHours();
    isVisible = visible;
    if (!visible) {
      _this6.setState({ isVisible: isVisible });
      return;
    }
    if (hoursLeft < 0) {
      // A past date means no event: clear it explicitly - Math.floor(moment().format()) is NaN.
      project.mpBuyerEventLaunchAt = null;
    } else if (hoursLeft > 0) {
      project.mpBuyerEventLaunchAt = (0, _momentTimezone2.default)(value).format();
    }
    _this6.setState({ project: project, isVisible: isVisible }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.handleTinSettingDateTimeInputChange = function (value) {
    var project = _this6.state.project;

    project.tinSettingBookingStartAt = (0, _momentTimezone2.default)(value).format();
    _this6.setState({ project: project }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.getCountdownFormat = function (mpBuyerEventLaunchAt) {
    var hoursLeft = _momentTimezone2.default.duration((0, _momentTimezone2.default)(mpBuyerEventLaunchAt).diff((0, _momentTimezone2.default)())).asHours();
    var daysLeft = _momentTimezone2.default.duration((0, _momentTimezone2.default)(mpBuyerEventLaunchAt).diff((0, _momentTimezone2.default)())).asDays();
    return {
      day: daysLeft > 0 ? 'ddd' : '00',
      hour: hoursLeft < 0 ? 'HH' : '00',
      minute: 'mm',
      second: 'ss'
    };
  };

  this.resetEventTimer = function () {
    var project = _this6.state.project;

    project.mpBuyerEventLaunchAt = null;
    _this6.setState({ project: project }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.hasCompanyHimsEnabled = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this6.props;
    var appConfig = props.appConfig;

    var companyHimsIsEnabled = appConfig && appConfig.data && appConfig.data.himsIsEnabled;
    return _this6.hasAccess(true, true, true, false, true) && companyHimsIsEnabled;
  };

  this.hasCompanyQuotationEnabled = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this6.props;
    var appConfig = props.appConfig;

    var companyQuotationIsEnabled = appConfig && appConfig.data && appConfig.data.settings && appConfig.data.settings.generateQuotationIsEnabled;
    return _this6.hasAccess(true, true, true) && companyQuotationIsEnabled;
  };

  this.checkSvg = function (url) {
    var isRetry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var request = new XMLHttpRequest();
    request.open('GET', url);
    request.setRequestHeader('Content-Type', 'image/svg+xml');
    request.onload = function () {
      if (request.status !== 200) {
        if (!isRetry) {
          var oriProject = _this6.state.oriProject;

          var svgUrl = (0, _url.siteplanUrl)(_this6.props.appConfig, '' + oriProject.siteplan.key + (oriProject.siteplan.svgUploadedAt ? '_' + (0, _momentTimezone2.default)(oriProject.siteplan.svgUploadedAt).format('YYYYMMDDHHmmss') : '') + '.svg');
          // retry once
          _this6.checkSvg(svgUrl, true);
          return;
        }
        _this6.setState({ siteplanHasSvg: false });
        return;
      }
      _this6.setState({ siteplanHasSvg: true });
    };
    request.onerror = function () {
      _this6.setState({ siteplanHasSvg: false });
    };
    request.send();
  };

  this.formatVND = function (val) {
    if (val === undefined || val === null || val === '') return '';
    var stringVal = val.toString().replace(/\D/g, '');
    return stringVal.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  this.checkImage = function (url) {
    var isRetry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var image = new Image();
    image.src = url;
    image.onload = function () {
      _this6.setState({ siteplanHasImage: true });
    };
    image.onerror = function () {
      if (!isRetry) {
        var oriProject = _this6.state.oriProject;

        var imgUrl = (0, _url.siteplanUrl)(_this6.props.appConfig, '' + oriProject.siteplan.key + (oriProject.siteplan.imageUploadedAt ? '_' + (0, _momentTimezone2.default)(oriProject.siteplan.imageUploadedAt).format('YYYYMMDDHHmmss') : '') + '.jpg');
        // retry once
        _this6.checkImage(imgUrl, true);
        return;
      }
      _this6.setState({ siteplanHasImage: false });
    };
  };

  this.checkCountryIsMalaysia = function (country) {
    if (country) {
      if (country.toLowerCase() === 'my') {
        return true;
      }
    }
    return false;
  };

  this.handleResize = function () {
    var state = {};
    var menuIsTab = window.innerWidth >= 991;
    if (menuIsTab !== _this6.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    var menuIsVertical = window.innerWidth >= 991;
    if (menuIsVertical !== _this6.state.menuIsVertical) {
      state.menuIsVertical = menuIsVertical;
    }
    _this6.setState(_extends({}, state));
  };

  this.handleSubmit = function () {
    var _ref38 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(event) {
      var store, t, _state11, project, srbExpiryEdited, srbVietnam, srbExpiry, message, foreignPurchaseThreshold, _ref39, _ref40, validity, errMessages, _state12, projectReservationTokenSetting, oriProjectReservationTokenSetting, rtSaved, bcfs, hasMultiDropdown, i, defaultValue, himsValidations;

      return regeneratorRuntime.wrap(function _callee18$(_context18) {
        while (1) {
          switch (_context18.prev = _context18.next) {
            case 0:
              store = _this6.context.store;
              t = _this6.props.t;

              if (event) event.preventDefault();
              _state11 = _this6.state, project = _state11.project, srbExpiryEdited = _state11.srbExpiryEdited;
              srbVietnam = (0, _countries.isCountryVietnam)(_this6.props.auth && _this6.props.auth.company && _this6.props.auth.company.countryCode);
              srbExpiry = (0, _srbChartExpiry.srbExpirySubmission)(project, srbExpiryEdited, srbVietnam && _this6.props.auth.isHeadquarters);

              if (!srbExpiry.block) {
                _context18.next = 12;
                break;
              }

              message = t('Enter a whole number from 1 to 30 minutes.');

              _this6.setState({ errMessages: [{ key: 'srbStoreyPlanExpiryMinutes', isValid: false, message: message }] });
              store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: [message] }));
              _this6.setLoading(false);
              return _context18.abrupt('return');

            case 12:
              // Reject invalid VN thresholds before any save side effects or state mutation.
              foreignPurchaseThreshold = (0, _foreignPurchaseThreshold.foreignPurchaseThresholdSubmission)(_this6.props.auth, project.foreignPurchaseThreshold);

              if (!foreignPurchaseThreshold.block) {
                _context18.next = 24;
                break;
              }

              _context18.next = 16;
              return _AppForm2.default.validate({ foreignPurchaseThreshold: _this6.validation.foreignPurchaseThreshold }, project);

            case 16:
              _ref39 = _context18.sent;
              _ref40 = _slicedToArray(_ref39, 1);
              validity = _ref40[0];

              // the ref is mounted whenever the section is rendered; the literal is only so a blocked save
              // can never flash an empty list.
              errMessages = validity && !validity.isValid ? [validity] : [{
                key: 'foreignPurchaseThreshold',
                isValid: false,
                message: t('Enter a value from 0–100. Only numeric input is accepted.')
              }];

              _this6.setState({ errMessages: errMessages });
              store.dispatch((0, _flash.flashErrorMessage)({
                header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }),
                list: errMessages.map(function (l) {
                  return l.message;
                })
              }));
              _this6.setLoading(false);
              return _context18.abrupt('return');

            case 24:
              if (!(project && project.id)) {
                _context18.next = 27;
                break;
              }

              _context18.next = 27;
              return _this6.bulkUpsertAndDeleteProjectFormAccessibilities();

            case 27:
              if (!(project && project.id)) {
                _context18.next = 35;
                break;
              }

              _state12 = _this6.state, projectReservationTokenSetting = _state12.projectReservationTokenSetting, oriProjectReservationTokenSetting = _state12.oriProjectReservationTokenSetting;

              if (!(JSON.stringify(projectReservationTokenSetting) !== JSON.stringify(oriProjectReservationTokenSetting))) {
                _context18.next = 35;
                break;
              }

              _context18.next = 32;
              return _this6.saveReservationTokenSettings(true);

            case 32:
              rtSaved = _context18.sent;

              if (!(rtSaved === false)) {
                _context18.next = 35;
                break;
              }

              return _context18.abrupt('return');

            case 35:
              if (project.projectPricings && project.projectPricings.length > 0) {
                project.projectPricings = project.projectPricings.filter(function (d) {
                  return d.name !== '' || d.formulaPrice !== '';
                });
              }
              if (project.specifications) {
                project.specifications = project.specifications.filter(function (data) {
                  return data.name.length > 0 && data.value.length > 0;
                }).map(function (data, idx) {
                  return _extends({}, data, {
                    position: idx + 1
                  });
                });
              }
              if (project.mappings) {
                project.mappings = project.mappings.filter(function (data) {
                  return data.name.length > 0 && data.value.length > 0;
                }).map(function (data, idx) {
                  return _extends({}, data, {
                    position: idx + 1
                  });
                });
              }
              if (project.options) {
                project.options = project.options.filter(function (data) {
                  return data.name.length > 0 && data.value.length > 0;
                }).map(function (data, idx) {
                  return _extends({}, data, {
                    position: idx + 1
                  });
                });
              }
              if (project.printType === 'none') {
                project.printType = '';
              }
              if (project.printSPAType === 'none') {
                project.printSPAType = '';
              }
              if (project.printTerminationType === 'none') {
                project.printTerminationType = '';
              }
              if (project.salesChartTemplate === 'default') {
                project.salesChartTemplate = '';
              }
              project.sharedToBankerForms = _lodash2.default.uniq((project.sharedToBankerForms || []).filter(Boolean));
              if (project.projectFormAccessibilities && project.projectFormAccessibilities.length === 0) {
                project.printPDF = false;
              }
              if (project.projectBookingCustomFields && project.projectBookingCustomFields.length > 0) {
                // set bookingCustomFields multi_dropdown default value
                bcfs = [].concat(_toConsumableArray(project.projectBookingCustomFields));

                if (bcfs && bcfs.length > 0) {
                  hasMultiDropdown = bcfs.findIndex(function (bcf) {
                    return bcf.type === 'dropdown_multi';
                  });

                  if (hasMultiDropdown !== -1) {
                    i = 0;

                    while (i < bcfs.length) {
                      if (bcfs[i].type === 'dropdown_multi') {
                        defaultValue = '';

                        if (_lodash2.default.isArray(bcfs[i].defaultValue)) {
                          defaultValue = bcfs[i].defaultValue.filter(function (v) {
                            return v !== '';
                          }).join(',');
                        }
                        bcfs[i].defaultValue = defaultValue;
                      }
                      i += 1;
                    }
                  }
                }
                project.projectBookingCustomFields = bcfs;
              }
              himsValidations = [];

              if (!(project.projectHimsSettings && project.projectHimsSettings.length > 0 && _this6.himsSettingsForm && _this6.himsSettingsForm.current)) {
                _context18.next = 51;
                break;
              }

              _context18.next = 50;
              return _this6.himsSettingsForm.current.validate();

            case 50:
              himsValidations = _context18.sent;

            case 51:
              if (!(project.paymentTypeOptions && project.paymentTypeOptions.length < 1)) {
                _context18.next = 55;
                break;
              }

              store.dispatch((0, _flash.flashErrorMessage)({ message: t('There must be at least ONE Payment Method enabled', { ns: _translation.TRANSLATION_FILES.translation }) }));
              _this6.setLoading(false);
              return _context18.abrupt('return');

            case 55:
              if (!(project.minPrice % 1 !== 0 || project.maxPrice % 1 !== 0)) {
                _context18.next = 59;
                break;
              }

              store.dispatch((0, _flash.flashErrorMessage)({ message: t('Minimum and Maximum price should not contain decimal points', { ns: _translation.TRANSLATION_FILES.translation }) }));
              _this6.setLoading(false);
              return _context18.abrupt('return');

            case 59:
              _AppForm2.default.validate(_this6.validation, project).then(function (validations) {
                var allValidations = [].concat(validations, himsValidations);
                _this6.setState({
                  errMessages: allValidations.filter(function (v) {
                    return !v.isValid;
                  })
                });
                var data = Object.assign({}, project, {
                  minPrice: project.manualPrice ? parseFloat(project.minPrice) : 0,
                  maxPrice: project.manualPrice ? parseFloat(project.maxPrice) : 0,
                  minSize: project.manualSize ? parseFloat(project.minSize) : 0,
                  maxSize: project.manualSize ? parseFloat(project.maxSize) : 0,
                  bookingUnitLimit: project.bookingUnitLimit ? parseFloat(project.bookingUnitLimit) : 1,
                  defaultBookingFeeAmount: project.defaultBookingFeeAmount ? parseFloat(project.defaultBookingFeeAmount) : 0,
                  minBookingPaymentAmount: project.minBookingPaymentAmount ? parseFloat(project.minBookingPaymentAmount) : 0,
                  loanTrackerProjectLeadBankersLimit: project.loanTrackerProjectLeadBankersLimit ? parseInt(project.loanTrackerProjectLeadBankersLimit, 10) : 0,
                  launchModeMinutes: project.launchModeMinutes ? parseInt(project.launchModeMinutes, 10) : 0,
                  bapMaxAttempts: parseInt(project.bapMaxAttempts, 10),
                  bapWindowMinutes: parseInt(project.bapWindowMinutes, 10),
                  bapCooldownMinutes: parseInt(project.bapCooldownMinutes, 10),
                  customerReservationMaxLimit: project.customerReservationMaxLimit ? parseInt(project.customerReservationMaxLimit, 10) : 1
                });
                if (srbExpiry.omit) {
                  delete data.srbStoreyPlanExpiryMinutes;
                } else {
                  data.srbStoreyPlanExpiryMinutes = srbExpiry.value;
                }
                if (foreignPurchaseThreshold.omit) {
                  delete data.foreignPurchaseThreshold;
                } else {
                  data.foreignPurchaseThreshold = foreignPurchaseThreshold.value;
                }
                _this6.props.onSubmit(allValidations, data);
              });
              _this6.setState({ openModal: false });

            case 61:
            case 'end':
              return _context18.stop();
          }
        }
      }, _callee18, _this6);
    }));

    return function (_x36) {
      return _ref38.apply(this, arguments);
    };
  }();

  this.handleSubmitBankerFormTemplate = function (value) {
    var _state13 = _this6.state,
        oriProject = _state13.oriProject,
        project = _state13.project;

    var payload = _lodash2.default.isObject(value) ? value : {};
    if (Object.prototype.hasOwnProperty.call(payload, 'printType')) {
      oriProject.printType = payload.printType || '';
      project.printType = payload.printType || '';
    }
    if (Object.prototype.hasOwnProperty.call(payload, 'sharedToBankerForms')) {
      var nextSharedToBankerForms = _lodash2.default.uniq((payload.sharedToBankerForms || []).filter(Boolean));
      oriProject.sharedToBankerForms = nextSharedToBankerForms;
      project.sharedToBankerForms = nextSharedToBankerForms;
    }

    if (oriProject.printSPAType === 'none') {
      oriProject.printSPAType = '';
    }
    if (oriProject.printTerminationType === 'none') {
      oriProject.printTerminationType = '';
    }
    if (oriProject.salesChartTemplate === 'default') {
      oriProject.salesChartTemplate = '';
    }
    if (oriProject.projectFormAccessibilities && oriProject.projectFormAccessibilities.length === 0) {
      oriProject.printPDF = false;
    }
    var data = Object.assign({}, oriProject, {
      minPrice: oriProject.manualPrice ? parseFloat(oriProject.minPrice) : 0,
      maxPrice: oriProject.manualPrice ? parseFloat(oriProject.maxPrice) : 0,
      minSize: oriProject.manualSize ? parseFloat(oriProject.minSize) : 0,
      maxSize: oriProject.manualSize ? parseFloat(oriProject.maxSize) : 0,
      bookingUnitLimit: oriProject.bookingUnitLimit ? parseFloat(oriProject.bookingUnitLimit) : 1,
      defaultBookingFeeAmount: oriProject.defaultBookingFeeAmount ? parseFloat(oriProject.defaultBookingFeeAmount) : 0,
      minBookingPaymentAmount: oriProject.minBookingPaymentAmount ? parseFloat(oriProject.minBookingPaymentAmount) : 0,
      loanTrackerProjectLeadBankersLimit: oriProject.loanTrackerProjectLeadBankersLimit ? parseInt(oriProject.loanTrackerProjectLeadBankersLimit, 10) : 0,
      launchModeMinutes: oriProject.launchModeMinutes ? parseInt(oriProject.launchModeMinutes, 10) : 0,
      bapMaxAttempts: parseInt(oriProject.bapMaxAttempts, 10),
      bapWindowMinutes: parseInt(oriProject.bapWindowMinutes, 10),
      bapCooldownMinutes: parseInt(oriProject.bapCooldownMinutes, 10)
    });
    _this6.setState({ oriProject: oriProject, project: project }, function () {
      _this6.props.onSubmit([], data);
    });
  };

  this.handleInputChange = function (event, _ref41) {
    var name = _ref41.name,
        value = _ref41.value;
    var _state14 = _this6.state,
        formAccessibilitiesTemplateIDs = _state14.formAccessibilitiesTemplateIDs,
        project = _state14.project;

    var srbExpiryEdited = _this6.state.srbExpiryEdited || name === 'srbStoreyPlanExpiryMinutes';
    var faTemplateIds = formAccessibilitiesTemplateIDs;
    var input = event.target;
    if (name === 'minPrice' || name === 'maxPrice') {
      var cursor = input.selectionStart;
      var cleanValue = value.replace(/\D/g, '');

      if (cleanValue.length > 15) return;

      _this6.setState({
        project: _extends({}, project, _defineProperty({}, name, cleanValue))
      }, function () {
        input.setSelectionRange(cursor, cursor);
        _this6.handleCheckChanges();
      });

      return;
    }
    if (name === 'formAccessibilitiesTemplateIDs') {
      faTemplateIds = value;
    } else {
      if (name === 'bnReadAccessGroupIDs' || name === 'bnWriteAccessGroupIDs' || name === 'rduAccessGroupIDs' || name === 'paymentReceiptAccessGroupIDs' || name === 'reserveDisabledRoleIDs' || name === 'salesChartDisabledRoleIDs') {
        value.sort();
      }
      project[name] = value;
    }
    if (name === 'launchModeMinutes') {
      project.srbStoreyPlanExpiryMinutes = (0, _srbChartExpiry.currentSRBExpiry)(project, srbExpiryEdited);
    }
    if (name === 'cuRoleAccesses') {
      if (value.includes(_changeUnitsAccesses.CU_EXTERNAL_STAFF_ACCESS)) {
        project.cuAllowExternalReserved = true;
        project.cuAllowExternalBooked = false;
        project.cuDisableExtEditCancelCriteria = true;
      }
    }
    if (name === 'bnReadAccessGroupIDs' || name === 'bnWriteAccessGroupIDs' || name === 'rduAccessGroupIDs' || name === 'paymentReceiptAccessGroupIDs') {
      if (!value.includes(_srRoleAccess.SR_ROLE_ID_DEVELOPER_HEADQUARTERS)) {
        value.unshift(_srRoleAccess.SR_ROLE_ID_DEVELOPER_HEADQUARTERS);
        project[name] = value;
      }
    }
    if (name === 'bookingUnitLimit') {
      if (value <= 1) {
        project.activeBookingsInUnits = false;
        project.activeBookingsIncludeWaitlist = false;
      }
    }
    if (name === 'tinDropdown') {
      if (value === 'booked_and_sold' && !project.requireValidTinAtBookingAndSold) {
        project.requireValidTinAtBookingAndSold = true;
        project.requireValidTinAtSold = false;
      } else if (value === 'sold' && !project.requireValidTinAtSold) {
        project.requireValidTinAtBookingAndSold = false;
        project.requireValidTinAtSold = true;
      } else {
        project.requireValidTinAtBookingAndSold = false;
        project.requireValidTinAtSold = false;
      }
      _this6.setState({ tinDropdown: value });
    }
    _this6.setState({ formAccessibilitiesTemplateIDs: faTemplateIds, project: project, srbExpiryEdited: srbExpiryEdited }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.handleConsentCheck = function (event, data) {
    var project = _this6.state.project;

    if (data.checked) {
      project[data.name] = '2';
    } else {
      project[data.name] = '1';
    }
    _this6.setState({ project: project }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.handleAddEmail = function (event, value, key) {
    var store = _this6.context.store;
    var project = _this6.state.project;
    var t = _this6.props.t;

    var r = new RegExp(_index.RX_EMAIL, 'i');
    if (value.some(function (v) {
      return !r.test(v);
    })) {
      store.dispatch((0, _flash.flashErrorMessage)({ message: t('Invalid email address', { ns: _translation.TRANSLATION_FILES.translation }) }));
      return;
    }
    if (project[key] && project[key].some(function (eml) {
      return value.some(function (v) {
        return eml.text === v;
      });
    })) {
      store.dispatch((0, _flash.flashErrorMessage)({ message: t('Duplicate email address', { ns: _translation.TRANSLATION_FILES.translation }) }));
      return;
    }
    project[key] = value;
    _this6.setState({ project: project }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.handleCheckBoxChange = function (event, data) {
    var _state15 = _this6.state,
        project = _state15.project,
        oriProject = _state15.oriProject;

    project[data.name] = !project[data.name];
    if (data.name === 'isLaunchMode') {
      project.srbStoreyPlanExpiryMinutes = (0, _srbChartExpiry.currentSRBExpiry)(project, _this6.state.srbExpiryEdited);
    }
    if (data.name === 'manualPrice' && !project[data.name]) {
      project.minPrice = (project.summary ? project.summary.minPrice : oriProject.minPrice) || 0;
      project.maxPrice = (project.summary ? project.summary.maxPrice : oriProject.maxPrice) || 0;
    }
    if (data.name === 'manualSize' && !project[data.name]) {
      project.minSize = (project.summary ? project.summary.minSize : oriProject.minSize) || 0;
      project.maxSize = (project.summary ? project.summary.maxSize : oriProject.maxSize) || 0;
    }
    if (data.name === 'loanTrackerDirectShow' && !project[data.name]) {
      project.loanTrackerDirectConsent = false;
    }
    if (data.name === 'arBookingExpIsEnabled' && !project[data.name]) {
      project.arBookingExpUnpaidIsEnabled = false;
      project.arBookingExpNricPicIsEnabled = false;
      project.arBookingExpMortgageEnabled = false;
    }
    if (data.name === 'activeBookingsInUnits' && !project[data.name]) {
      project.activeBookingsIncludeWaitlist = false;
    }
    if (data.name === 'cuIsEnabled' && !project[data.name]) {
      project.cuOtherProjectIsEnabled = false;
      project.cuFollowPrevBookingDateIsEnabled = false;
      project.cuDefaultFollowPrevBookingDateIsEnabled = false;
      project.cuDisabledEditingOfFollowPrevBookingDate = false;
      project.cuAttachmentsRequired = false;
      project.cuReserveNewBooking = false;
      project.cuReactivatePrevBooking = false;
      project.cuAllowExternalReserved = false;
      project.cuAllowExternalBooked = false;
      project.cuDisableExtEditCancelCriteria = false;
    }
    if (data.name === 'cuFollowPrevBookingDateIsEnabled' && !project[data.name]) {
      project.cuDefaultFollowPrevBookingDateIsEnabled = false;
      project.cuDisabledEditingOfFollowPrevBookingDate = false;
    }
    if (data.name === 'cuDefaultFollowPrevBookingDateIsEnabled' && !project[data.name]) {
      project.cuDisabledEditingOfFollowPrevBookingDate = false;
    }
    if (data.name === 'cuReserveNewBooking' && !project[data.name]) {
      project.cuReactivatePrevBooking = false;
    }
    if (data.name === 'compulsoryValidTinBeforeUpdateBooking') {
      var compulsoryValidTinBeforeUpdateBooking = !_this6.state.compulsoryValidTinBeforeUpdateBooking;
      if (!compulsoryValidTinBeforeUpdateBooking) {
        compulsoryValidTinBeforeUpdateBooking = false;
        project.requireValidTinAtBookingAndSold = false;
        project.requireValidTinAtSold = false;
        project.tinSettingBookingStartAt = null;
      } else {
        var selected = _this6.state.tinDropdown;
        compulsoryValidTinBeforeUpdateBooking = true;
        if (selected === 'booked_and_sold') {
          project.requireValidTinAtBookingAndSold = true;
        } else if (selected === 'sold') {
          project.requireValidTinAtSold = true;
        }
      }
      _this6.setState({ compulsoryValidTinBeforeUpdateBooking: compulsoryValidTinBeforeUpdateBooking }, function () {
        _this6.handleCheckChanges();
      });
    }
    if (data.name === 'tinSettingBookingStartAt') {
      project.tinSettingBookingStartAt = data.checked ? data.value : null;
    }
    if (data.name === 'creditControlIsUnlinked') {
      project.allowPurchaserEditAfterSold = project[data.name];
      project.allowPricingEditAfterSold = project[data.name];
      // if (project[data.name]) {
      //   project.autoGenerateBillingAfterSold = false;
      // }
    }
    _this6.setState({ project: project }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.handleFinanceSourcesCheckboxChange = function (e, data) {
    var project = _this6.state.project;

    var sourceOfFinanceOptions = [].concat(_toConsumableArray(project.sourceOfFinanceOptions));
    if (sourceOfFinanceOptions && sourceOfFinanceOptions.length > 0 && sourceOfFinanceOptions.includes(data.name)) {
      sourceOfFinanceOptions = sourceOfFinanceOptions.filter(function (option) {
        return option !== data.name;
      });
    } else {
      sourceOfFinanceOptions.push(data.name);
    }
    project.sourceOfFinanceOptions = sourceOfFinanceOptions;
    _this6.setState({ project: project }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.handlePaymentTypeChange = function (event, data) {
    var project = _this6.state.project;

    if (data.name === 'cash' || data.name === 'cheque' || data.name === 'bank_transfer' || data.name === 'credit_card' || data.name === 'online_payment' || data.name === 'others') {
      var paymentTypeOptions = [].concat(_toConsumableArray(project.paymentTypeOptions));
      if (paymentTypeOptions && paymentTypeOptions.length > 0 && paymentTypeOptions.includes(data.name)) {
        paymentTypeOptions = paymentTypeOptions.filter(function (option) {
          return option !== data.name;
        });
      } else {
        paymentTypeOptions.push(data.name);
      }
      project.paymentTypeOptions = paymentTypeOptions;
    }
    _this6.setState({ project: project }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.handleNavigatePayment = function (e, tab) {
    e.preventDefault();
    _this6.setState({ currentTab: tab });
  };

  this.handleFlashMPCriteriaMsg = function () {
    var store = _this6.context.store;
    var t = _this6.props.t;

    store.dispatch((0, _flash.flashMessage)({ message: _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Header,
          {
            as: 'h5'
          },
          t('Kindly provide the following details to proceed'),
          ':',
          _react2.default.createElement(
            'div',
            { style: { margin: '10px', fontWeight: 'normal' } },
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    className: 'flash-button',
                    onClick: function onClick(e) {
                      return _this6.handleNavigatePayment(e, 'payment_setup');
                    }
                  },
                  t('Bank Accounts')
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    className: 'flash-button',
                    onClick: function onClick(e) {
                      return _this6.handleNavigatePayment(e, 'payment_setup');
                    }
                  },
                  t('Default Booking Fee')
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    as: _reactRouter.Link,
                    className: 'flash-button',
                    to: '/projects/' + _this6.state.project.id + '/documents/'
                  },
                  t('Document/E-Sales Kit')
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    className: 'flash-button',
                    onClick: function onClick(e) {
                      return _this6.handleNavigatePayment(e, 'marketplace');
                    }
                  },
                  t('Commission')
                )
              )
            )
          )
        )
      ),
      type: 'error'
    }));
  };

  this.handleSpecificationsChange = function (data) {
    var project = _this6.state.project;

    project.specifications = data;
    _this6.setState({ project: project }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.handleMappingChange = function (data) {
    var project = _this6.state.project;

    project.mappings = data;
    _this6.setState({ project: project }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.handleOptionChange = function (data) {
    var project = _this6.state.project;

    project.options = data;
    _this6.setState({ project: project }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.handleSiteplanSettingsChange = function (event, _ref42) {
    var name = _ref42.name,
        value = _ref42.value,
        checked = _ref42.checked;
    var project = _this6.state.project;

    if (name === 'overlayMode') {
      project.siteplanSettings[name] = value;
    } else {
      project.siteplanSettings[name] = name === 'hideLayouts' || name === 'salesChartSimpleMode' || name === 'salesChartDelistedAsUnavailable' || name === 'salesChartDisableClickUnavailable' || name === 'unitListDisableClickUnavailable' || name === 'hideTowersAndLevels' || name === 'defaultFilter' || name === 'siteplanSimpleMode' || name === 'siteplanDelistedAsUnavailable' ? checked : !checked;
    }
    if ((name === 'salesChartSimpleMode' || name === 'siteplanSimpleMode') && !checked) {
      if (name === 'salesChartSimpleMode') {
        project.siteplanSettings.salesChartDelistedAsUnavailable = false;
        project.siteplanSettings.salesChartDisableClickUnavailable = false;
        project.siteplanSettings.unitListDisableClickUnavailable = false;
      }
      if (name === 'siteplanSimpleMode') {
        project.siteplanSettings.siteplanDelistedAsUnavailable = false;
      }
    }
    _this6.setState({ project: project }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.handleDeleteCurrency = function () {
    var _ref43 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(e, _ref44) {
      var value = _ref44.value;

      var _state16, project, genericErrMsg, store, indexToBeDeleted, response;

      return regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return _this6.setLoading(true);

            case 2:
              _state16 = _this6.state, project = _state16.project, genericErrMsg = _state16.genericErrMsg;
              store = _this6.context.store;
              indexToBeDeleted = project.projectCurrency.findIndex(function (val) {
                return val.code === value.code;
              });

              if (!(indexToBeDeleted === -1)) {
                _context19.next = 8;
                break;
              }

              _this6.handleError(store, genericErrMsg);
              return _context19.abrupt('return');

            case 8:
              if (_this6.hasUpdateAccess()) {
                _context19.next = 14;
                break;
              }

              // during project creation
              project.projectCurrency.splice(indexToBeDeleted, 1);
              _this6.setState({ project: project });
              _context19.next = 13;
              return _this6.setLoading(false);

            case 13:
              return _context19.abrupt('return');

            case 14:
              _context19.prev = 14;
              _context19.next = 17;
              return (0, _fetchM.serverRequestDelete)('/projects/' + project.id + '/currency/' + value.id + '/', store, _this6.props.token);

            case 17:
              response = _context19.sent;

              if (!response.error) {
                _context19.next = 21;
                break;
              }

              _this6.handleError(store, response.message);
              return _context19.abrupt('return');

            case 21:
              project.projectCurrency.splice(indexToBeDeleted, 1);
              _this6.setState({ project: project });
              _context19.next = 25;
              return _this6.setLoading(false);

            case 25:
              _context19.next = 30;
              break;

            case 27:
              _context19.prev = 27;
              _context19.t0 = _context19['catch'](14);

              _this6.handleError(store, genericErrMsg, _context19.t0, true);

            case 30:
            case 'end':
              return _context19.stop();
          }
        }
      }, _callee19, _this6, [[14, 27]]);
    }));

    return function (_x37, _x38) {
      return _ref43.apply(this, arguments);
    };
  }();

  this.hasUpdateAccess = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this6.props;
    var pathname = props.location.pathname;

    if (pathname.includes('/new/')) {
      return false;
    }
    return true;
  };

  this.canAccessProjectReservationToken = function () {
    var auth = _this6.props.auth;

    return auth.isSuperAdmin || auth.isAdminBasic || auth.isAdminCommunity || auth.isHeadquarters || auth.isDeveloperSalesAdmin || auth.isDeveloperSalesManager || auth.isDeveloperSupervisor;
  };

  this.ownershipTypes = [{ text: 'Leasehold', value: 'leasehold' }, { text: 'Freehold', value: 'freehold' }];
  this.propertyCategoryTypes = [{ text: 'Single Storey Terrace House', value: 'single_storey_terrace_house' }, { text: '{{storey}} Storey Terrace House', value: '2_storey_terrace_house', storey: '2' }, { text: '{{storey}} Storey Terrace House', value: '2_5_storey_terrace_house', storey: '2.5' }, { text: '{{storey}} Storey Terrace House', value: '3_storey_terrace_house', storey: '3' }, { text: '{{storey}} Storey Terrace House', value: '3_5_storey_terrace_house', storey: '3.5' }, { text: 'Home/Land', value: 'home_land' }, { text: 'Apartment', value: 'apartment' }, { text: 'Flat', value: 'flat' }, { text: 'Condominium', value: 'condominium' }, { text: 'Service Residence', value: 'service_residence' }, { text: 'Service Apartment', value: 'service_apartment' }, { text: 'Terrace', value: 'terrace' }, { text: 'Superlink Homes', value: 'superlink_homes' }, { text: 'Townhouse', value: 'townhouse' }, { text: 'Cluster House', value: 'cluster_house' }, { text: 'Single Storey Cluster House', value: 'single_storey_cluster_house' }, { text: '{{storey}} Storey Cluster House', value: '2_storey_cluster_house', storey: '2' }, { text: '{{storey}} Storey Cluster House', value: '2_5_storey_cluster_house', storey: '2.5' }, { text: '{{storey}} Storey Cluster House', value: '3_storey_cluster_house', storey: '3' }, { text: 'Bungalow', value: 'bungalow' }, { text: 'Single Storey Bungalow', value: 'single_storey_bungalow' }, { text: '{{storey}} Storey Bungalow', value: '2_storey_bungalow', storey: '2' }, { text: '{{storey}} Storey Bungalow', value: '2_5_storey_bungalow', storey: '2.5' }, { text: '{{storey}} Storey Bungalow', value: '3_storey_bungalow', storey: '3' }, { text: 'SemiD House', value: 'semi_d' }, { text: 'Single Storey SemiD House', value: 'single_storey_semi_d' }, { text: '{{storey}} Storey SemiD House', value: '2_storey_semi_d', storey: '2' }, { text: '{{storey}} Storey SemiD House', value: '2_5_storey_semi_d', storey: '2.5' }, { text: '{{storey}} Storey SemiD House', value: '3_storey_semi_d', storey: '3' }, { text: 'Villa', value: 'villa' }, { text: 'Retail Office', value: 'retail_office' }, { text: 'Retail Space', value: 'retail_space' }, { text: 'Shop', value: 'shop' }, { text: 'Shop Office', value: 'shop_office' }, { text: '{{storey}} Storey Shop Office', value: '2_storey_shop_office', storey: '2' }, { text: '{{storey}} Storey Shop Office', value: '3_storey_shop_office', storey: '3' }, { text: 'Office', value: 'office' }, { text: 'Office Suites', value: 'office_suites' }, { text: 'Sofo', value: 'sofo' }, { text: 'Soho', value: 'soho' }, { text: 'Sovo', value: 'sovo' }, { text: 'Designer Suites', value: 'designer_suites' }, { text: 'Business Centre', value: 'business_centre' }, { text: 'Hotel Suite', value: 'hotel_suite' }, { text: 'Factory', value: 'factory' }, { text: 'SemiD Factory', value: 'semi_d_factory' }, { text: 'Warehouse', value: 'warehouse' }, { text: 'Detached Factory', value: 'detached_factory' }, { text: 'Light Industrial', value: 'light_industrial' }, { text: 'Link Factory', value: 'link_factory' }, { text: 'Bungalow Land', value: 'bungalow_land' }, { text: 'Strata Villa', value: 'strata_villa' }, { text: 'Commercial Suites', value: 'commercial_suites' }];
  this.areaUnits = [{ text: 'Square Feet (sqft)', value: 'square_feet' }, { text: 'Square Metres (sqm)', value: 'square_metres' }];
  this.overlayModes = [{ text: 'Status Text', value: 'text' }, { text: 'Color', value: 'color' }];

  this.buildTabs = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this6.props;
    return [{
      name: 'info',
      value: 'info',
      text: 'Info',
      fields: ['name', 'shortName', 'phone', 'foreignPurchaseThreshold']
    }, {
      name: 'location',
      value: 'location',
      text: 'Location',
      fields: props.addressSettings.data.filter(function (as) {
        return as.enabled && as.required;
      })
    }, {
      name: 'specifications',
      value: 'specifications',
      text: 'Specifications',
      fields: []
    }, {
      name: 'overview',
      value: 'overview',
      text: 'Description',
      fields: []
    }, {
      name: 'company_info',
      value: 'company_info',
      text: 'Registered Company Info',
      fields: []
    }, {
      name: 'setup',
      value: 'setup',
      text: 'Setup',
      fields: []
    }, {
      name: 'booking_setup',
      value: 'booking_setup',
      text: 'Booking Setup',
      fields: []
    }, props.appConfig && props.appConfig.data && props.appConfig.data.himsIsEnabled && (props.auth.isSuperAdmin || props.auth.isAdminBasic) && {
      name: 'hims_setup',
      value: 'hims_setup',
      text: 'HIMS Setup',
      fields: ['himsStrataIsEnabled']
    }, _this6.hasCompanyQuotationEnabled(props) && _config2.default.get('developerURL') && props.auth.company.service_company_id && {
      name: 'quotation',
      value: 'quotation',
      text: 'Quotation',
      fields: [],
      redirectTo: _config2.default.get('developerURL') + '/c/' + props.auth.company.service_company_id + '/projects/' + props.params.id + '/edit?tab=quotation'
    }, {
      name: 'docx_templater_setting',
      value: 'docx_templater_setting',
      text: 'Form Template',
      fields: []
    }, !isPRS && _config2.default.get('developerURL') && props.auth.company.service_company_id && {
      name: 'auto_release',
      value: 'auto_release',
      text: 'Auto Release',
      fields: [],
      redirectTo: _config2.default.get('developerURL') + '/c/' + props.auth.company.service_company_id + '/projects/' + props.params.id + '/edit?tab=auto_release'
    }, _config2.default.get('developerURL') && props.auth && props.auth.company.service_company_id && (0, _companies.isForeignCompany)(props.auth.company) && {
      name: 'payment_schedule',
      value: 'payment_schedule',
      text: 'Payment Schedules',
      fields: [],
      redirectTo: _config2.default.get('developerURL') + '/c/' + props.auth.company.service_company_id + '/projects/' + props.params.id + '/edit?tab=payment_schedule'
    }, _config2.default.get('developerURL') && props.auth.company.service_company_id && {
      name: 'additional_fees',
      value: 'additional_fees',
      text: 'Additional Fees',
      fields: [],
      redirectTo: _config2.default.get('developerURL') + '/c/' + props.auth.company.service_company_id + '/projects/' + props.params.id + '/edit?tab=additional_fees'
    }, {
      name: 'payment_setup',
      value: 'payment_setup',
      text: 'Payment Setup',
      fields: []
    }, {
      name: 'sales_chart_setup',
      value: 'sales_chart_setup',
      text: 'Sales Chart Setup',
      fields: []
    }, {
      name: 'marketplace',
      value: 'marketplace',
      text: 'Marketplace'
    }, _this6.hasUpdateAccess(props) && {
      name: 'booking_fields',
      value: 'booking_fields',
      text: 'Booking Fields',
      fields: []
    },
    // (this.hasUpdateAccess(props) && props.auth.isAdminBasic) && {
    //   name: 'tier_pricing',
    //   value: 'tier_pricing',
    //   text: 'Discount Package (OLD)',
    //   fields: [],
    // },
    {
      name: 'access',
      value: 'access',
      text: 'Access',
      fields: []
    }, _this6.hasUpdateAccess(props) && {
      name: 'letter_settings',
      value: 'letter_settings',
      text: 'Reminder Letter Settings',
      fields: []
    }, props.auth && !(0, _companies.isForeignCompany)(props.auth.company) && {
      name: 'currency_settings',
      value: 'currency_settings',
      text: 'Currency Settings',
      fields: []
    }, _this6.hasUpdateAccess(props) && {
      name: 'options',
      value: 'api_options',
      text: 'API Options',
      fields: []
    }, _this6.hasUpdateAccess(props) && _this6.canAccessProjectReservationToken() && {
      name: 'reservation_token_settings',
      value: 'reservation_token_settings',
      text: 'Reservation Token Settings',
      fields: []
    }];
  };

  this.salesChartRefreshTimes = [{ text: '15', value: 15 }, { text: '20', value: 20 }, { text: '30', value: 30 }, { text: '40', value: 40 }, { text: '50', value: 50 }, { text: '60', value: 60 }, { text: '120', value: 120 }];
  this.bapMinutesOptions = [{ key: 'o30', text: '30 (30 Minutes)', value: '30' }, { key: 'o60', text: '60 (1 Hour)', value: '60' }, { key: 'o120', text: '120 (2 Hours)', value: '120' }, { key: 'o180', text: '180 (3 Hours)', value: '180' }, { key: 'o360', text: '360 (6 Hours)', value: '360' }, { key: 'o720', text: '720 (12 Hours)', value: '720' }, { key: 'o1440', text: '1440 (1 Day)', value: '1440' }];

  this.handleRedirect = function (url) {
    var store = _this6.context.store;

    if (url.includes(_config2.default.get('developerURL'))) {
      window.location.href = url;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(url));
    }
  };

  this.handleChangeTab = function (e, _ref45, redirectTo) {
    var name = _ref45.name,
        value = _ref45.value;

    if (redirectTo && redirectTo !== '') {
      _this6.handleRedirect(redirectTo);
      return;
    }
    var currentTab = name || value;
    _this6.setState({ currentTab: currentTab }, function () {
      var _props$location = _this6.props.location,
          hash = _props$location.hash,
          pathname = _props$location.pathname;

      if (hash !== '#' + currentTab) {
        var store = _this6.context.store;

        store.dispatch((0, _reactRouterRedux.replace)(pathname + '#' + currentTab));
      }
    });
  };

  this.checkActiveTab = function (name) {
    return _this6.isActiveTab(name) ? '' : 'hidden';
  };

  this.isActiveTab = function (name) {
    return _this6.state.currentTab === name;
  };

  this.handleBranchClear = function () {
    var project = _this6.state.project;

    project.maOwnerCompanyBranchShortName = '';
    project.maOwnerCompanyBranchID = 0;
    _this6.setState({ project: project }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.handleBranchSelect = function (value) {
    var project = _this6.state.project;

    project.maOwnerCompanyBranchShortName = value.title;
    project.maOwnerCompanyBranchID = value.key;
    _this6.setState({ project: project }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.defaultBookingStatutes = [{ text: 'Reserved', value: 'reserved', name: 'reserved' }, { text: 'Booked', value: 'booked', name: 'booked' }];

  this.handlePreviewSaleschart = function (e) {
    e.preventDefault();
    var project = _this6.state.project;

    if (project.id) {
      var chartLanguage = (0, _languagePreference.normalizeLanguage)(_this6.props.i18n.language) || (0, _languagePreference.normalizeLanguage)(_this6.props.auth.language) || 'en';
      var chartOrigin = _config2.default.get('salesChartURL');
      var winObj = window.open(chartOrigin + '/?projectID=' + project.id + '&lang=' + encodeURIComponent(chartLanguage), '_blank');
      winObj.opener = null;
    }
  };

  this.handleCheckBeforeClose = function () {
    var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'siteplan';
    var t = _this6.props.t;

    if (_this6.uploadForm[type] && _this6.uploadForm[type].state.uploads.length > 0) {
      var callback = function callback() {
        if (_this6.uploadModal[type]) {
          _this6.uploadModal[type].close();
        }
      };
      var store = _this6.context.store;

      store.dispatch((0, _prompt.promptChangesMessage)({ message: t(_promptMessages.UPLOAD_PICTURE_PROMPT, { ns: _translation.TRANSLATION_FILES.translation }), callback: callback }));
      return true;
    }
    return false;
  };

  this.handlePricingTierChange = function (data) {
    var project = _this6.state.project;

    project.projectPricings = data;
    _this6.setState({ project: project }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.handlePricingTierDelete = function (id) {
    _this6.deletePricingTier(id);
  };

  this.handlePricingSave = function (data) {
    var project = _this6.state.project;

    project.projectPricings = data;
    _this6.setState({ project: project }, function () {
      _this6.handleCheckChanges();
      _this6.handleSubmit();
    });
  };

  this.handleBankerFormChange = function (bankerFormState) {
    _this6.handleSubmitBankerFormTemplate(bankerFormState);
  };

  this.handleOnChangeCustomFieldData = function (d) {
    var project = _this6.state.project;

    project.projectBookingCustomFields = d;
    _this6.setState({ project: project }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.handleImportPricingClick = function (e) {
    e.preventDefault();
    var store = _this6.context.store;
    var project = _this6.state.project;

    store.dispatch((0, _reactRouterRedux.push)('/projects/' + project.id + '/units/import_pricings/'));
  };

  this.handleChangeBAPWindow = function (value) {
    var project = _this6.state.project;

    project.bapWindowMinutes = value;
    _this6.setState({ project: project }, function () {
      return _this6.handleCheckChanges();
    });
  };

  this.handleChangeBAPCooldown = function (value) {
    var project = _this6.state.project;

    project.bapCooldownMinutes = value;
    _this6.setState({ project: project }, function () {
      return _this6.handleCheckChanges();
    });
  };

  this.handleOnClose = function () {
    _this6.setState({ openTncModal: false });
  };

  this.showTnC = function (e) {
    e.preventDefault();
    _this6.setState({ openTncModal: true });
  };

  this.getFinanceSourceLabel = function (type) {
    var financeSources = _this6.props.financeSources;

    var sources = financeSources.data;
    var idx = sources.findIndex(function (s) {
      return s.id === type;
    });
    if (idx > -1) {
      return sources[idx].label;
    }
    return 'Others';
  };

  this.handleOnHimsSettingsChange = function (data) {
    var _state17 = _this6.state,
        project = _state17.project,
        tabs = _state17.tabs;

    project.projectHimsSettings = data;

    var tabIdx = tabs.findIndex(function (t) {
      return t.name === 'hims_setup' || t.value === 'hims_setup';
    });
    if (tabIdx >= 0) {
      tabs[tabIdx].fields = ['himsStrataIsEnabled'];
      data.forEach(function (d, idx) {
        tabs[tabIdx].fields.push('himsDeveloperCode_' + idx, 'himsDeveloperName_' + idx, 'himsDeveloperLicense_' + idx, 'himsDevelopmentCode_' + idx, 'himsDevelopmentName_' + idx);
      });
    }

    _this6.setState({ project: project, tabs: tabs }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.handleReservationTokenSettingChange = function (_e, _ref46) {
    var name = _ref46.name,
        value = _ref46.value;
    var projectReservationTokenSetting = _this6.state.projectReservationTokenSetting;

    _this6.setState({ projectReservationTokenSetting: _extends({}, projectReservationTokenSetting, _defineProperty({}, name, value)) }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.saveReservationTokenSettings = function () {
    var _ref47 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
      var suppressSuccess = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var store, t, _state18, project, projectReservationTokenSetting, token, rtValidation, validations, payload, res, data, msg;

      return regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              store = _this6.context.store;
              t = _this6.props.t;
              _state18 = _this6.state, project = _state18.project, projectReservationTokenSetting = _state18.projectReservationTokenSetting, token = _state18.token;
              _context20.prev = 3;
              rtValidation = _this6.rtValidation;
              _context20.next = 7;
              return _AppForm2.default.validate(rtValidation, {
                rtPriceMinor: projectReservationTokenSetting.priceMinor,
                rtValidityDurationDays: projectReservationTokenSetting.validityDurationDays,
                rtLimitPerOpportunity: projectReservationTokenSetting.limitPerOpportunity
              });

            case 7:
              validations = _context20.sent;

              if (!validations.some(function (v) {
                return !v.isValid;
              })) {
                _context20.next = 11;
                break;
              }

              store.dispatch((0, _flash.flashErrorMessage)({ message: t('Please fix the errors in Reservation Token Settings before saving') }));
              return _context20.abrupt('return', false);

            case 11:
              payload = _extends({}, projectReservationTokenSetting, {
                priceMinor: Math.max(1, parseInt(projectReservationTokenSetting.priceMinor, 10) || 1),
                validityDurationDays: Math.max(1, parseInt(projectReservationTokenSetting.validityDurationDays, 10) || 1),
                limitPerOpportunity: Math.max(1, parseInt(projectReservationTokenSetting.limitPerOpportunity, 10) || 1)
              });
              _context20.next = 14;
              return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + project.id + '/reservation_token_settings/', {
                method: 'POST',
                credentials: 'include',
                headers: { 'Content-Type': 'application/json', 'X-Csrf-Token': token },
                body: JSON.stringify(payload)
              }));

            case 14:
              res = _context20.sent;

              if (!res.ok) {
                _context20.next = 23;
                break;
              }

              _context20.next = 18;
              return res.json();

            case 18:
              data = _context20.sent;

              _this6.setState({
                projectReservationTokenSetting: data,
                oriProjectReservationTokenSetting: (0, _clone2.default)(data)
              });
              if (!suppressSuccess) {
                store.dispatch((0, _flash.flashSuccessMessage)({ message: t('Reservation token settings saved successfully') }));
              }
              _context20.next = 27;
              break;

            case 23:
              _context20.next = 25;
              return res.text();

            case 25:
              msg = _context20.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: msg }));

            case 27:
              return _context20.abrupt('return', true);

            case 30:
              _context20.prev = 30;
              _context20.t0 = _context20['catch'](3);

              store.dispatch((0, _flash.flashErrorMessage)({ message: _context20.t0.message }));
              return _context20.abrupt('return', false);

            case 34:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, _this6, [[3, 30]]);
    }));

    return function () {
      return _ref47.apply(this, arguments);
    };
  }();

  this.renderFinanceSourceItem = function (fsID) {
    var project = _this6.state.project;
    var t = _this6.props.t;

    var opt = (0, _financeSource.getSourceOfFinanceValue)(fsID);
    var sourcesOnByDefault = !(0, _companies.isForeignCompany)(_this6.props.auth.company) && opt === 'referred_banker';
    var financeSourceLabel = _this6.getFinanceSourceLabel(fsID);
    return _react2.default.createElement(
      _semanticUiReact.Form.Group,
      { key: 'fsr_' + fsID },
      _react2.default.createElement(_semanticUiReact.Form.Field, { label: t(financeSourceLabel, { ns: _translation.TRANSLATION_FILES.constants, defaultValue: financeSourceLabel }) + ' ' + (sourcesOnByDefault ? '(' + t('ON by default') + ')' : ''), width: 11 }),
      _react2.default.createElement(
        _semanticUiReact.Form.Field,
        { width: 5 },
        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
          toggle: true,
          label: t(project.sourceOfFinanceOptions && project.sourceOfFinanceOptions.length > 0 && project.sourceOfFinanceOptions.some(function (o) {
            return o === opt;
          }) ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
          name: opt,
          checked: project.sourceOfFinanceOptions && project.sourceOfFinanceOptions.length > 0 && project.sourceOfFinanceOptions.includes(opt),
          onChange: _this6.handleFinanceSourcesCheckboxChange,
          disabled: sourcesOnByDefault
        })
      )
    );
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.project, _translation.TRANSLATION_FILES.models.booking]), { withRef: true })((0, _reactRouter.withRouter)((0, _reactRedux.connect)(ProjectForm.mapStateToProps, null, null, { withRef: true })(ProjectForm), { withRef: true }));

/***/ }),
/* 1068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _TextArea = __webpack_require__(383);

var _TextArea2 = _interopRequireDefault(_TextArea);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  eslint no-param-reassign: ["error", { "props": false }]*/


var SMSTemplateForm = function (_Component) {
  _inherits(SMSTemplateForm, _Component);

  function SMSTemplateForm(props) {
    _classCallCheck(this, SMSTemplateForm);

    var _this = _possibleConstructorReturn(this, (SMSTemplateForm.__proto__ || Object.getPrototypeOf(SMSTemplateForm)).call(this, props));

    _initialiseProps.call(_this);

    var template = Object.assign({}, SMSTemplateForm.defaultValues, props.template || {});
    _this.state = {
      template: template,
      oriTemplate: (0, _clone2.default)(template),
      errMessages: []
    };
    _this.validation = {
      id: (0, _react.createRef)(),
      name: (0, _react.createRef)(),
      template: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(SMSTemplateForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var template = Object.assign({}, SMSTemplateForm.defaultValues, this.state.template);
      var oriTemplate = this.state.oriTemplate;
      if (JSON.stringify(this.props.template) !== JSON.stringify(nextProps.template)) {
        template = Object.assign(template, nextProps.template);
        oriTemplate = (0, _clone2.default)(template);
      }
      this.setState({ template: template, oriTemplate: oriTemplate });
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;
      var _state = this.state,
          template = _state.template,
          oriTemplate = _state.oriTemplate;

      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref) {
            _this2.form = _ref;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_AppForm2.default.Input, {
                placeholder: 'sms/<template_name>.tmpl',
                disabled: oriTemplate.id !== '',
                label: 'ID',
                name: 'id',
                value: template.id,
                onChange: this.handleInputChange,
                ref: this.validation.id,
                validation: [_webValidations.required]
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                disabled: oriTemplate.name && oriTemplate.name.toLowerCase().includes('default'),
                placeholder: t('Template Name', { ns: _translation.TRANSLATION_FILES.translation }),
                label: t('Name', { ns: _translation.TRANSLATION_FILES.translation }),
                name: 'name',
                value: template.name,
                onChange: this.handleInputChange,
                ref: this.validation.name,
                validation: [_webValidations.required]
              }),
              _react2.default.createElement(_TextArea2.default, {
                disabled: oriTemplate.name && oriTemplate.name.toLowerCase().includes('default'),
                placeholder: t('Paste Go HTML template data here..', { ns: _translation.TRANSLATION_FILES.translation }),
                label: t('Template Data', { ns: _translation.TRANSLATION_FILES.translation }),
                name: 'template',
                value: template.template,
                onChange: this.handleInputChange,
                style: { minHeight: 500 },
                ref: this.validation.template,
                validation: [_webValidations.required]
              }),
              oriTemplate.lastTemplate !== '' && _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                label: t('Previous Template Data (read only)', { ns: _translation.TRANSLATION_FILES.translation }),
                name: 'lastTemplate',
                readOnly: true,
                style: { minHeight: 250 },
                value: template.lastTemplate
              })
            )
          )
        )
      );
    }
  }]);

  return SMSTemplateForm;
}(_react.Component);

SMSTemplateForm.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  template: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
SMSTemplateForm.contextTypes = {
  store: _propTypes2.default.object
};
SMSTemplateForm.defaultValues = {
  id: '',
  name: '',
  template: '',
  lastTemplate: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleSubmit = function (event) {
    event.preventDefault();
    var template = _this3.state.template;

    _AppForm2.default.validate(_this3.validation, template).then(function (validations) {
      _this3.props.onSubmit(validations, template);
    });
  };

  this.handleInputChange = function (event, data) {
    var template = _this3.state.template;

    template[data.name] = data.value;
    _this3.setState({ template: template }, function () {
      _this3.handleCheckChanges();
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(SMSTemplateForm);

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var routes = exports.routes = function routes(id) {
  var links = [{ text: 'Overview', value: '/users/' + id + '/' }, { text: 'Activities', value: '/users/' + id + '/activities/' }];
  return links;
};

/***/ }),
/* 1070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  eslint no-param-reassign: ["error", { "props": false }]*/

var TagForm = function (_Component) {
  _inherits(TagForm, _Component);

  function TagForm(props) {
    _classCallCheck(this, TagForm);

    var _this = _possibleConstructorReturn(this, (TagForm.__proto__ || Object.getPrototypeOf(TagForm)).call(this, props));

    _initialiseProps.call(_this);

    var tag = Object.assign({}, TagForm.defaultValues, props.tag || {});
    _this.state = {
      tag: tag,
      oriTag: (0, _clone2.default)(tag),
      errMessages: []
    };
    _this.validation = {
      name: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(TagForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var tag = Object.assign({}, TagForm.defaultValues, this.state.tag);
      var oriTag = this.state.oriTag;
      if (JSON.stringify(this.props.tag) !== JSON.stringify(nextProps.tag)) {
        tag = Object.assign(tag, nextProps.tag);
        oriTag = (0, _clone2.default)(tag);
      }
      this.setState({ tag: tag, oriTag: oriTag });
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;
      var tag = this.state.tag;

      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref) {
            _this2.form = _ref;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_AppForm2.default.Input, {
                label: t('Name', { ns: _translation.TRANSLATION_FILES.translation }),
                name: 'name',
                value: tag.name,
                onChange: this.handleInputChange,
                ref: this.validation.name,
                validation: [_webValidations.required]
              }),
              _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                label: t('Description', { ns: _translation.TRANSLATION_FILES.screens }),
                name: 'description',
                value: tag.description,
                onChange: this.handleInputChange
              })
            )
          )
        )
      );
    }
  }]);

  return TagForm;
}(_react.Component);

TagForm.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  tag: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
TagForm.contextTypes = {
  store: _propTypes2.default.object
};
TagForm.defaultValues = {
  name: '',
  description: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleSubmit = function (event) {
    event.preventDefault();
    var tag = _this3.state.tag;

    _AppForm2.default.validate(_this3.validation, tag).then(function (validations) {
      _this3.props.onSubmit(validations, tag);
    });
  };

  this.handleInputChange = function (event, data) {
    var tag = _this3.state.tag;

    tag[data.name] = data.value;
    _this3.setState({ tag: tag }, function () {
      _this3.handleCheckChanges();
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(TagForm);

/***/ }),
/* 1071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _TextArea = __webpack_require__(383);

var _TextArea2 = _interopRequireDefault(_TextArea);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  eslint no-param-reassign: ["error", { "props": false }]*/


var QuotationTemplateForm = function (_Component) {
  _inherits(QuotationTemplateForm, _Component);

  function QuotationTemplateForm(props) {
    _classCallCheck(this, QuotationTemplateForm);

    var _this = _possibleConstructorReturn(this, (QuotationTemplateForm.__proto__ || Object.getPrototypeOf(QuotationTemplateForm)).call(this, props));

    _initialiseProps.call(_this);

    var template = Object.assign({}, QuotationTemplateForm.defaultValues, props.template || {});
    _this.state = {
      template: template,
      oriTemplate: (0, _clone2.default)(template),
      errMessages: []
    };
    _this.validation = {
      id: (0, _react.createRef)(),
      name: (0, _react.createRef)(),
      template: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(QuotationTemplateForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var template = Object.assign({}, QuotationTemplateForm.defaultValues, this.state.template);
      var oriTemplate = this.state.oriTemplate;
      if (JSON.stringify(this.props.template) !== JSON.stringify(nextProps.template)) {
        template = Object.assign(template, nextProps.template);
        oriTemplate = (0, _clone2.default)(template);
      }
      this.setState({ template: template, oriTemplate: oriTemplate });
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          template = _state.template,
          oriTemplate = _state.oriTemplate;
      var t = this.props.t;

      var label = this.props.type === 'quotation' ? 'quotations' : 'bookings';
      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref) {
            _this2.form = _ref;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_AppForm2.default.Input, {
                placeholder: 'db/templates/' + label + '/<developer_name>/<project_name>.html',
                disabled: oriTemplate.id !== '',
                label: 'ID',
                name: 'id',
                value: template.id,
                onChange: this.handleInputChange,
                ref: this.validation.id,
                validation: [_webValidations.required]
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                disabled: oriTemplate.name && oriTemplate.name.toLowerCase().includes('default'),
                placeholder: t('Template Name', { ns: _translation.TRANSLATION_FILES.translation }),
                label: t('Name', { ns: _translation.TRANSLATION_FILES.translation }),
                name: 'name',
                value: template.name,
                onChange: this.handleInputChange,
                ref: this.validation.name,
                validation: [_webValidations.required]
              }),
              _react2.default.createElement(_TextArea2.default, {
                disabled: oriTemplate.name && oriTemplate.name.toLowerCase().includes('default'),
                placeholder: t('Paste Go HTML template data here..', { ns: _translation.TRANSLATION_FILES.translation }),
                label: t('Template Data', { ns: _translation.TRANSLATION_FILES.translation }),
                name: 'template',
                value: template.template,
                onChange: this.handleInputChange,
                style: { minHeight: 500 },
                ref: this.validation.template,
                validation: [_webValidations.required]
              }),
              oriTemplate.lastTemplate !== '' && _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                label: t('Previous Template Data (read only)', { ns: _translation.TRANSLATION_FILES.translation }),
                name: 'lastTemplate',
                readOnly: true,
                style: { minHeight: 250 },
                value: template.lastTemplate
              })
            )
          )
        )
      );
    }
  }]);

  return QuotationTemplateForm;
}(_react.Component);

QuotationTemplateForm.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  template: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  type: _propTypes2.default.string,
  t: _propTypes2.default.func
};
QuotationTemplateForm.contextTypes = {
  store: _propTypes2.default.object
};
QuotationTemplateForm.defaultValues = {
  id: '',
  name: '',
  template: '',
  lastTemplate: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleSubmit = function (event) {
    event.preventDefault();
    var template = _this3.state.template;

    _AppForm2.default.validate(_this3.validation, template).then(function (validations) {
      _this3.props.onSubmit(validations, template);
    });
  };

  this.handleInputChange = function (event, data) {
    var template = _this3.state.template;

    template[data.name] = data.value;
    _this3.setState({ template: template }, function () {
      _this3.handleCheckChanges();
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(QuotationTemplateForm);

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _webValidations = __webpack_require__(23);

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _regex = __webpack_require__(143);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// const mediaTypes = [
//   { key: 'video', text: 'Video', value: 'video' },
// ];

var MediaForm = function (_Component) {
  _inherits(MediaForm, _Component);

  function MediaForm(props) {
    _classCallCheck(this, MediaForm);

    var _this = _possibleConstructorReturn(this, (MediaForm.__proto__ || Object.getPrototypeOf(MediaForm)).call(this, props));

    _initialiseProps.call(_this);

    var media = Object.assign({}, MediaForm.defaultValues, props.media || {});
    var oembed = null;
    if (media.data) {
      oembed = media.data;
    }
    _this.state = {
      media: media,
      oriMedia: (0, _clone2.default)(media),
      loading: false,
      errMessages: [],
      hasChanges: false,
      urlSupported: false,
      oembed: oembed
    };
    _this.validation = {
      url: (0, _react.createRef)()
      // type: createRef(),
    };
    return _this;
  }

  _createClass(MediaForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var media = Object.assign({}, MediaForm.defaultValues, this.state.media);
      var _state = this.state,
          oembed = _state.oembed,
          oriMedia = _state.oriMedia;

      if (JSON.stringify(this.props.media) !== JSON.stringify(nextProps.media)) {
        media = Object.assign(media, nextProps.media);
        oriMedia = (0, _clone2.default)(media);

        if (media.data) {
          oembed = media.data;
        }
      }
      this.setState({
        media: media,
        oriMedia: oriMedia,
        oembed: oembed
      });
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;
      var _state2 = this.state,
          media = _state2.media,
          oembed = _state2.oembed;

      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref) {
            _this2.form = _ref;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { stackable: true, columns: 'equal', doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'h4',
                null,
                t('Preview', { ns: _translation.TRANSLATION_FILES.screens })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              _react2.default.createElement(_semanticUiReact.Button, {
                positive: true,
                content: t('Create', { ns: _translation.TRANSLATION_FILES.screens }),
                onClick: this.handleSubmit,
                disabled: !this.state.hasChanges || this.state.loading || this.state.hasChanges && !this.state.urlSupported
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              oembed ? _react2.default.createElement('div', {
                style: {
                  width: '100%',
                  display: 'flex'
                },
                dangerouslySetInnerHTML: { __html: oembed.html }
              }) : null
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_AppForm2.default.Input, {
                validateLabel: 'URL',
                label: _react2.default.createElement(
                  'label',
                  null,
                  'URL',
                  _react2.default.createElement(
                    'small',
                    {
                      style: {
                        fontWeight: 100,
                        marginLeft: '0.5em'
                      }
                    },
                    t('Paste your YouTube or Vimeo video URL here. URLs from other platform are not supported.', { ns: _translation.TRANSLATION_FILES.translation })
                  )
                ),
                name: 'url',
                value: media.url,
                onChange: this.handleInputChange,
                ref: this.validation.url,
                validation: [_webValidations.required, {
                  validate: _webValidations.matchRegex,
                  option: {
                    validRegex: _regex.REG_URL
                  }
                }],
                disabled: this.state.loading
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                label: t('Label', { ns: _translation.TRANSLATION_FILES.screens }),
                name: 'label',
                value: media.label,
                onChange: this.handleInputChange,
                disabled: this.state.loading
              })
            )
          )
        )
      );
    }
  }]);

  return MediaForm;
}(_react.Component);

MediaForm.propTypes = {
  onSubmit: _propTypes2.default.func,
  t: _propTypes2.default.func,
  media: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    url: _propTypes2.default.string,
    type: _propTypes2.default.string,
    label: _propTypes2.default.string
  })
};
MediaForm.contextTypes = {
  store: _propTypes2.default.object
};
MediaForm.defaultValues = {
  url: '',
  type: 'video',
  label: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.setComponentState = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new Promise(function (res) {
      _this3.setState(state, function () {
        res(state);
      });
    });
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this3.setState({ loading: loading }, function () {
        res(loading);
      });
    });
  };

  this.fetchOEmbedData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var t, store, media, validations, errors, query, res, message, _message, oembed;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            t = _this3.props.t;
            store = _this3.context.store;
            media = _this3.state.media;

            if (media.url) {
              _context.next = 5;
              break;
            }

            return _context.abrupt('return');

          case 5:
            _context.next = 7;
            return _AppForm2.default.validate(_this3.validation, media);

          case 7:
            validations = _context.sent;
            errors = validations.filter(function (v) {
              return !v.isValid;
            });

            if (!(errors.length > 0)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt('return');

          case 11:
            _context.next = 13;
            return _this3.setLoading(true);

          case 13:
            query = {
              url: media.url
            };
            res = void 0;
            _context.prev = 15;
            _context.next = 18;
            return store.dispatch((0, _fetchM.fetchM)('/oembed/?' + _qs2.default.stringify(query), {
              credentials: 'include',
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            }));

          case 18:
            res = _context.sent;
            _context.next = 41;
            break;

          case 21:
            _context.prev = 21;
            _context.t0 = _context['catch'](15);

            if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
              _context.next = 33;
              break;
            }

            _context.next = 26;
            return _context.t0.res.text();

          case 26:
            message = _context.sent;

            store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
            _context.next = 30;
            return _this3.setComponentState({ urlSupported: false });

          case 30:
            _context.next = 32;
            return _this3.setLoading(false);

          case 32:
            return _context.abrupt('return');

          case 33:
            Bugsnag.notifyException(_context.t0);
            _context.next = 36;
            return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

          case 36:
            _context.next = 38;
            return _this3.setComponentState({ urlSupported: false });

          case 38:
            _context.next = 40;
            return _this3.setLoading(false);

          case 40:
            return _context.abrupt('return');

          case 41:
            if (res.ok) {
              _context.next = 51;
              break;
            }

            _context.next = 44;
            return res.text();

          case 44:
            _message = _context.sent;
            _context.next = 47;
            return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

          case 47:
            _context.next = 49;
            return _this3.setComponentState({ urlSupported: false });

          case 49:
            _context.next = 57;
            break;

          case 51:
            _context.next = 53;
            return res.json();

          case 53:
            oembed = _context.sent;

            if (oembed && oembed.title) {
              media.label = oembed.title;
            }
            _context.next = 57;
            return _this3.setComponentState({ oembed: oembed, media: media, urlSupported: true });

          case 57:
            _context.next = 59;
            return _this3.setLoading(false);

          case 59:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this3, [[15, 21]]);
  }));

  this.handleSubmit = function (event) {
    event.preventDefault();
    var media = _this3.state.media;

    _AppForm2.default.validate(_this3.validation, media).then(function (validations) {
      _this3.setState({
        errMessages: validations.filter(function (v) {
          return !v.isValid;
        })
      });
      _this3.props.onSubmit(validations, media);
    });
  };

  this.checkHasChanges = function () {
    var media = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.state;
    return JSON.stringify(media) !== JSON.stringify(_this3.state.oriMedia);
  };

  this.debounceFetchOEmbed = _lodash2.default.debounce(this.fetchOEmbedData, 1000);

  this.handleInputChange = function (event, _ref3) {
    var name = _ref3.name,
        value = _ref3.value;
    var media = _this3.state.media;
    var _state3 = _this3.state,
        oembed = _state3.oembed,
        urlSupported = _state3.urlSupported;

    var newValue = value;
    if (name === 'label') {
      newValue = value.replace(/[\\~#%&*{}/:<>?|"]/, '');
    }
    media[name] = newValue;
    if (name === 'url') {
      oembed = null;
      urlSupported = false;
    }

    var hasChanges = _this3.checkHasChanges(media);
    _this3.setState({ media: media, oembed: oembed, hasChanges: hasChanges, urlSupported: urlSupported }, function () {
      if (name === 'url') {
        _this3.debounceFetchOEmbed(newValue);
      }
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(MediaForm);

/***/ }),
/* 1073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _fileSize = __webpack_require__(85);

var _fileSize2 = _interopRequireDefault(_fileSize);

var _flash = __webpack_require__(5);

var _prompt = __webpack_require__(66);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _UploadModal = __webpack_require__(92);

var _UploadModal2 = _interopRequireDefault(_UploadModal);

var _promptMessages = __webpack_require__(43);

var _Form = __webpack_require__(1056);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddDocument = function (_Component) {
  _inherits(AddDocument, _Component);

  function AddDocument(props) {
    _classCallCheck(this, AddDocument);

    var _this = _possibleConstructorReturn(this, (AddDocument.__proto__ || Object.getPrototypeOf(AddDocument)).call(this, props));

    _this.handleChangePage = function (currentPage) {
      _this.setState({ currentPage: currentPage }, function () {
        _this.fetchDocuments();
      });
    };

    _this.handleAddDocument = function (e, data) {
      e.preventDefault();
      if (_this.props.onConfirm) {
        _this.props.onConfirm(e, data);
      }
    };

    _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    };

    _this.handleOnUpload = function (e, data) {
      if (_this.props.onUpload) {
        e.preventDefault();

        var _this$props$onUpload = _this.props.onUpload(data),
            url = _this$props$onUpload.url,
            options = _this$props$onUpload.options;

        if (url && options) {
          _this.upload(url, options);
        }
      }
    };

    _this.handleCheckBeforeClose = function () {
      if (_this.form.state.uploads.length > 0) {
        var callback = function callback() {
          _this.uploadModal.close();
          _this.handleChangePage(_this.state.currentPage);
        };
        var store = _this.context.store;

        store.dispatch((0, _prompt.promptChangesMessage)({ message: _promptMessages.UPLOAD_DOCUMENT_PROMPT, callback: callback }));
        return true;
      }
      return false;
    };

    _this.state = {
      count: 0,
      limit: 0,
      offset: 0,
      loading: true,
      data: [],
      currentPage: 1
    };
    return _this;
  }

  _createClass(AddDocument, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // fetch only when open modal
      if (nextProps.open === true) {
        this.fetchDocuments();
      }
    }
  }, {
    key: 'setDocuments',
    value: function setDocuments() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this2.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchDocuments',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, query, res, message, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = Object.assign(this.props.where || {}, {
                  page: this.state.currentPage || 1
                });
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/documents/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 19;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 16:
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context.next = 38;
                break;

              case 27:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 32;
                return res.json();

              case 32:
                data = _context.sent;
                _context.next = 35;
                return this.setDocuments(data);

              case 35:
                if (this.state.data.length < 1 && query.page > 1) {
                  this.handleChangePage(1);
                }
                // handle token.. etc
                _context.next = 38;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 38:
                _context.next = 40;
                return this.setLoading(false);

              case 40:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchDocuments() {
        return _ref.apply(this, arguments);
      }

      return fetchDocuments;
    }()
  }, {
    key: 'checkAdded',
    value: function checkAdded(data) {
      if (this.props.onCheck) {
        return this.props.onCheck(data);
      }
      return false;
    }
  }, {
    key: 'upload',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, options) {
        var store, t, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                _context2.prev = 2;
                _context2.next = 5;
                return this.form.submit(url, options);

              case 5:
                _context2.next = 18;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](2);

                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 12;
                return _context2.t0.res.text();

              case 12:
                message = _context2.sent;

                if (_context2.t0.res.status === 413) {
                  message = t('Uploaded document/image too large', { ns: _translation.TRANSLATION_FILES.translation });
                }
                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 16:
                store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));
                return _context2.abrupt('return');

              case 18:
                this.uploadModal.close();
                this.handleChangePage(this.state.currentPage);
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Upload Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Document(s) successfully uploaded', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 7]]);
      }));

      function upload(_x4, _x5) {
        return _ref2.apply(this, arguments);
      }

      return upload;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          className: 'add-document',
          open: this.props.open === true,
          onClose: this.handleOnClose,
          closeIcon: 'close',
          size: 'large'
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'image outline', content: t('Add document', { ns: _translation.TRANSLATION_FILES.translation }) }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { scrolling: true },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table,
            {
              striped: true, unstackable: true,
              selectable: true
            },
            _react2.default.createElement(
              _semanticUiReact.Table.Header,
              { fullWidth: true },
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  { colSpan: 4 },
                  this.props.onUpload ? _react2.default.createElement(_UploadModal2.default, {
                    floated: 'right',
                    ref: function ref(_ref5) {
                      _this5.uploadModal = _ref5;
                    },
                    onConfirm: this.handleOnUpload,
                    onClose: this.handleCheckBeforeClose,
                    content: function content(_ref3) {
                      var onConfirm = _ref3.onConfirm;
                      return _react2.default.createElement(_Form2.default, {
                        ref: function ref(_ref4) {
                          _this5.form = _ref4;
                        },
                        onSubmit: onConfirm
                      });
                    }
                  }) : null,
                  _react2.default.createElement(_PageNav2.default, {
                    floated: 'right',
                    currentPage: this.state.currentPage,
                    count: this.state.count,
                    limit: this.state.limit,
                    offset: this.state.offset,
                    dataSize: this.state.data.length,
                    loading: this.state.loading,
                    onChange: this.handleChangePage
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  null,
                  t('Name', { ns: _translation.TRANSLATION_FILES.translation })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  null,
                  t('Size', { ns: _translation.TRANSLATION_FILES.translation })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  null,
                  t('Tags', { ns: _translation.TRANSLATION_FILES.translation })
                ),
                _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null)
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Body,
              null,
              this.state.data.length > 0 ? this.state.data.map(function (file, key) {
                return _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  { key: key },
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'file pdf outline' }),
                    file.name
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    { collapsing: true },
                    (0, _fileSize2.default)(file.size)
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Label.Group,
                      { size: 'tiny' },
                      file.tags && file.tags.length > 0 ? file.tags.map(function (tag, idx) {
                        return _react2.default.createElement(
                          _semanticUiReact.Label,
                          { key: idx, as: 'a' },
                          tag
                        );
                      }) : _react2.default.createElement(
                        'p',
                        null,
                        t('No tags set', { ns: _translation.TRANSLATION_FILES.translation })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    { collapsing: true },
                    _react2.default.createElement(_semanticUiReact.Button, {
                      size: 'tiny',
                      fluid: true,
                      compact: true,
                      primary: !_this5.checkAdded(file),
                      positive: _this5.checkAdded(file),
                      icon: _this5.checkAdded(file) ? 'checkmark' : 'add',
                      content: _this5.checkAdded(file) ? t('Added', { ns: _translation.TRANSLATION_FILES.translation }) : t('Add', { ns: _translation.TRANSLATION_FILES.screens }),
                      disabled: _this5.checkAdded(file),
                      onClick: function onClick(e) {
                        return _this5.handleAddDocument(e, file);
                      }
                    })
                  )
                );
              }) : _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { colSpan: 4, textAlign: 'center' },
                  t('No documents found.', { ns: _translation.TRANSLATION_FILES.translation })
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Footer,
              { fullWidth: true },
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  { colSpan: 4, textAlign: 'right' },
                  _react2.default.createElement(_PageNav2.default, {
                    currentPage: this.state.currentPage,
                    count: this.state.count,
                    limit: this.state.limit,
                    offset: this.state.offset,
                    dataSize: this.state.data.length,
                    loading: this.state.loading,
                    onChange: this.handleChangePage
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return AddDocument;
}(_react.Component);

AddDocument.contextTypes = {
  store: _propTypes2.default.object
};
AddDocument.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  onUpload: _propTypes2.default.func,
  onCheck: _propTypes2.default.func,
  where: _propTypes2.default.shape({}),
  t: _propTypes2.default.func.isRequired
};
exports.default = (0, _reactI18next.withTranslation)()(AddDocument);

/***/ }),
/* 1074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _prompt = __webpack_require__(66);

var _MediaList = __webpack_require__(385);

var _MediaList2 = _interopRequireDefault(_MediaList);

var _UploadModal = __webpack_require__(92);

var _UploadModal2 = _interopRequireDefault(_UploadModal);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _translation = __webpack_require__(4);

var _promptMessages = __webpack_require__(43);

var _Form = __webpack_require__(1072);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddMedia = function (_Component) {
  _inherits(AddMedia, _Component);

  function AddMedia(props) {
    var _this2 = this;

    _classCallCheck(this, AddMedia);

    var _this = _possibleConstructorReturn(this, (AddMedia.__proto__ || Object.getPrototypeOf(AddMedia)).call(this, props));

    _this.fixBody = function () {
      var anotherModal = document.getElementsByClassName('ui page modals');
      if (anotherModal.length > 0) {
        document.body.classList.add('dimmable', 'dimmed');
      }
    };

    _this.handleRefetch = function () {
      if (_this.mediaList) {
        _this.mediaList.getWrappedInstance().handleRefetch();
      }
    };

    _this.handleViewLarge = function (e, selectedMedia) {
      e.preventDefault();
      _this.setState({ selectedMedia: selectedMedia }, function () {
        _this.setState({
          showLarge: true
        });
      });
    };

    _this.handleCloseLarge = function (e) {
      e.preventDefault();
      _this.setState({
        showLarge: false,
        selectedMedia: null
      });
    };

    _this.handleAddPicture = function (e) {
      e.preventDefault();
      if (_this.props.onConfirm) {
        _this.props.onConfirm(e, _this.state.selectedMedia);
      }
      _this.setState({
        selectedMedia: null,
        showAdd: false
      }, function () {
        _this.fixBody();
      });
    };

    _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    };

    _this.checkAdded = function (data) {
      if (_this.props.onCheck) {
        return _this.props.onCheck(data);
      }
      return false;
    };

    _this.handleOnCreate = function (validations, media) {
      if (_this.props.onCreate) {
        var _this$props$onCreate = _this.props.onCreate(media),
            url = _this$props$onCreate.url,
            options = _this$props$onCreate.options;

        if (url && options) {
          _this.createMedia(url, options, validations);
        }
      }
    };

    _this.createMedia = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, options, validations) {
        var t, store, errors, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = _this.props.t;
                store = _this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                _context.prev = 6;
                _context.next = 9;
                return _this.form.submit(url, options);

              case 9:
                _context.next = 21;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](6);

                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 19;
                  break;
                }

                _context.next = 16;
                return _context.t0.res.text();

              case 16:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 19:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 21:
                _this.setState({ uploadModalState: false });
                _this.handleRefetch();
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Create Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Video successfully created', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[6, 11]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleShowAdd = function (e, selectedMedia) {
      e.preventDefault();
      _this.setState({
        showAdd: true,
        selectedMedia: selectedMedia
      });
    };

    _this.handleCancelAdd = function (e) {
      if (e) {
        e.preventDefault();
      }
      _this.setState({
        showAdd: false,
        selectedMedia: null
      }, function () {
        _this.fixBody();
      });
    };

    _this.handleCheckBeforeClose = function () {
      var t = _this.props.t;

      if (_this.form && _this.form.state && _this.form.state.hasChanges) {
        var callback = function callback() {
          _this.setState({ uploadModalState: false });
          _this.handleRefetch();
        };
        var store = _this.context.store;

        store.dispatch((0, _prompt.promptChangesMessage)({ message: t(_promptMessages.DEFAULT_PROMPT, { ns: _translation.TRANSLATION_FILES.translation }), callback: callback }));
        return true;
      }
      return false;
    };

    _this.handleUploadModalStateChange = function (open) {
      _this.setState({ uploadModalState: open });
    };

    _this.state = {
      showLarge: false,
      showAdd: false,
      selectedMedia: null,
      uploadModalState: false
    };
    return _this;
  }

  _createClass(AddMedia, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          className: 'add-picture',
          open: this.props.open,
          onClose: this.handleOnClose,
          closeIcon: 'close',
          size: 'large'
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'image outline', content: t('Add videos', { ns: _translation.TRANSLATION_FILES.translation }) }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { scrolling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle', columns: 'equal' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(_ViewLarge2.default, {
                  open: this.state.showLarge,
                  onClose: this.handleCloseLarge,
                  picture: this.state.selectedMedia,
                  type: 'video'
                }),
                _react2.default.createElement(_MediaList2.default, {
                  ref: function ref(_ref4) {
                    _this3.mediaList = _ref4;
                  },
                  toggleable: true,
                  onViewLarge: this.handleViewLarge,
                  onRemove: this.handleRemove,
                  buttonNode: function buttonNode(_ref2) {
                    var view = _ref2.view,
                        loading = _ref2.loading,
                        item = _ref2.item;
                    return _react2.default.createElement(_semanticUiReact.Button, {
                      compact: true, size: 'small',
                      attached: view === 'card' ? 'bottom' : null,
                      primary: !_this3.checkAdded(item),
                      positive: _this3.checkAdded(item),
                      icon: _this3.checkAdded(item) ? 'checkmark' : 'add',
                      content: _this3.checkAdded(item) ? t('Added', { ns: _translation.TRANSLATION_FILES.translation }) : t('Add', { ns: _translation.TRANSLATION_FILES.translation }),
                      disabled: _this3.checkAdded(item) || loading,
                      onClick: function onClick(e) {
                        return _this3.handleShowAdd(e, item);
                      }
                    });
                  },
                  searchRightNav: this.props.onCreate ? _react2.default.createElement(_UploadModal2.default, {
                    modalState: this.state.uploadModalState,
                    floated: 'right',
                    header: 'video',
                    icon: null,
                    btnText: t('New', { ns: _translation.TRANSLATION_FILES.screens }),
                    onModalStateChange: this.handleUploadModalStateChange,
                    onClose: this.handleCheckBeforeClose,
                    content: function content() {
                      return _react2.default.createElement(_Form2.default, {
                        ref: function ref(_ref3) {
                          _this3.form = _ref3;
                        },
                        onSubmit: _this3.handleOnCreate
                      });
                    }
                  }) : null
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal,
            {
              open: this.state.showAdd,
              onClose: this.handleCancelAdd,
              closeIcon: 'close',
              size: 'large'
            },
            _react2.default.createElement(_semanticUiReact.Header, { icon: 'add', content: ' ' + t('Add video to', { ns: _translation.TRANSLATION_FILES.translation }) + ' ' + this.props.type.replace('_', ' ') }),
            _react2.default.createElement(
              _semanticUiReact.Modal.Content,
              { scrolling: true },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 'equal', stackable: true, doubling: true, textAlign: 'center' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  this.state.selectedMedia && this.state.selectedMedia.data && _react2.default.createElement('div', {
                    style: {
                      width: '100%',
                      display: 'flex',
                      justifyContent: 'center'
                    },
                    dangerouslySetInnerHTML: {
                      __html: this.state.selectedMedia.data.html
                    }
                  })
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Modal.Actions,
              null,
              _react2.default.createElement(_semanticUiReact.Button, { basic: true, negative: true, onClick: this.handleCancelAdd, icon: 'cancel', content: t('Cancel', { ns: _translation.TRANSLATION_FILES.screens }), inverted: true }),
              _react2.default.createElement(_semanticUiReact.Button, { basic: true, positive: true, onClick: this.handleAddPicture, icon: 'add', content: t('Add', { ns: _translation.TRANSLATION_FILES.screens }), inverted: true })
            )
          )
        )
      );
    }
  }]);

  return AddMedia;
}(_react.Component);

AddMedia.contextTypes = {
  store: _propTypes2.default.object
};
AddMedia.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  onCreate: _propTypes2.default.func,
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func,
  type: _propTypes2.default.oneOf(['project', 'unit_layout']).isRequired
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(AddMedia);

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _flash = __webpack_require__(5);

var _prompt = __webpack_require__(66);

var _pictureTypes = __webpack_require__(392);

var _pictureTypes2 = _interopRequireDefault(_pictureTypes);

var _PictureList = __webpack_require__(386);

var _PictureList2 = _interopRequireDefault(_PictureList);

var _UploadModal = __webpack_require__(92);

var _UploadModal2 = _interopRequireDefault(_UploadModal);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _promptMessages = __webpack_require__(43);

var _Form = __webpack_require__(1060);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddPicture = function (_Component) {
  _inherits(AddPicture, _Component);

  function AddPicture(props) {
    var _this2 = this;

    _classCallCheck(this, AddPicture);

    var _this = _possibleConstructorReturn(this, (AddPicture.__proto__ || Object.getPrototypeOf(AddPicture)).call(this, props));

    _this.fixBody = function () {
      var anotherModal = document.getElementsByClassName('ui page modals');
      if (anotherModal.length > 0) {
        document.body.classList.add('dimmable', 'dimmed');
      }
    };

    _this.handleRefetch = function () {
      if (_this.pictureList) {
        _this.pictureList.getWrappedInstance().handleRefetch();
      }
    };

    _this.handleViewLarge = function (e, selectedPicture) {
      e.preventDefault();
      _this.setState({ selectedPicture: selectedPicture }, function () {
        _this.setState({
          showLarge: true
        });
      });
    };

    _this.handleCloseLarge = function (e) {
      e.preventDefault();
      _this.setState({
        showLarge: false,
        selectedPicture: null
      });
    };

    _this.handleAddPicture = function (e) {
      e.preventDefault();
      if (_this.props.onConfirm) {
        _this.props.onConfirm(e, _this.state.selectedPicture, _this.state.referenceType);
      }
      _this.setState({
        selectedPicture: null,
        showAdd: false
      }, function () {
        _this.fixBody();
      });
    };

    _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    };

    _this.handleOnUpload = function (e, data) {
      if (_this.props.onUpload) {
        e.preventDefault();

        var _this$props$onUpload = _this.props.onUpload(data),
            url = _this$props$onUpload.url,
            options = _this$props$onUpload.options;

        if (url && options) {
          _this.upload(url, options);
        }
      }
    };

    _this.upload = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url, options) {
        var t, store, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = _this.props.t;
                store = _this.context.store;
                _context.prev = 2;
                _context.next = 5;
                return _this.form.getWrappedInstance().submit(url, options);

              case 5:
                _context.next = 18;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](2);

                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 16;
                  break;
                }

                _context.next = 12;
                return _context.t0.res.text();

              case 12:
                message = _context.sent;

                if (_context.t0.res.status === 413) {
                  message = t('Uploaded document/image too large', { ns: _translation.TRANSLATION_FILES.translation });
                }
                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 16:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 18:
                _this.setState({ uploadModalState: false });
                _this.handleRefetch();
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Upload Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Picture(s) successfully uploaded', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[2, 7]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleTypeChange = function (e, _ref2) {
      var value = _ref2.value;

      var referenceType = value;
      _this.setState({ referenceType: referenceType });
    };

    _this.handleShowAdd = function (e, selectedPicture) {
      e.preventDefault();
      _this.setState({
        showAdd: true,
        selectedPicture: selectedPicture,
        referenceType: selectedPicture.type
      });
    };

    _this.handleCancelAdd = function (e) {
      if (e) {
        e.preventDefault();
      }
      _this.setState({
        showAdd: false,
        selectedPicture: null,
        referenceType: _pictureTypes2.default[0].value
      }, function () {
        _this.fixBody();
      });
    };

    _this.handleCheckBeforeClose = function () {
      var t = _this.props.t;

      if (_this.form.getWrappedInstance().state.uploads.length > 0) {
        var callback = function callback() {
          _this.form.getWrappedInstance().resetFiles();
          _this.setState({ uploadModalState: false });
          _this.handleRefetch();
        };
        var store = _this.context.store;

        store.dispatch((0, _prompt.promptChangesMessage)({ message: t(_promptMessages.UPLOAD_PICTURE_PROMPT, { ns: _translation.TRANSLATION_FILES.translation }), callback: callback }));
        return true;
      }
      return false;
    };

    _this.handleUploadModalStateChange = function (open) {
      _this.setState({ uploadModalState: open });
    };

    _this.state = {
      showLarge: false,
      showAdd: false,
      selectedPicture: null,
      referenceType: _pictureTypes2.default[0].value,
      uploadModalState: false
    };
    return _this;
  }

  _createClass(AddPicture, [{
    key: 'checkAdded',
    value: function checkAdded(data) {
      if (this.props.onCheck) {
        return this.props.onCheck(data);
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          className: 'add-picture',
          open: this.props.open === true,
          onClose: this.handleOnClose,
          closeIcon: 'close',
          size: 'large'
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'image outline', content: '' + t('addPictures', { ns: _translation.TRANSLATION_FILES.screens }) }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { scrolling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle', columns: 'equal' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(_ViewLarge2.default, {
                  open: this.state.showLarge,
                  onClose: this.handleCloseLarge,
                  picture: this.state.selectedPicture
                }),
                _react2.default.createElement(_PictureList2.default, {
                  ref: function ref(_ref6) {
                    _this3.pictureList = _ref6;
                  },
                  toggleable: true,
                  onViewLarge: this.handleViewLarge,
                  onRemove: this.handleRemove,
                  buttonNode: function buttonNode(_ref3) {
                    var view = _ref3.view,
                        loading = _ref3.loading,
                        picture = _ref3.picture;
                    return _react2.default.createElement(_semanticUiReact.Button, {
                      compact: true, size: 'small',
                      attached: view === 'card' ? 'bottom' : null,
                      primary: !_this3.checkAdded(picture),
                      positive: _this3.checkAdded(picture),
                      icon: _this3.checkAdded(picture) ? 'checkmark' : 'add',
                      content: t(_this3.checkAdded(picture) ? 'added' : 'add', { ns: _translation.TRANSLATION_FILES.screens }),
                      disabled: _this3.checkAdded(picture) || loading,
                      onClick: function onClick(e) {
                        return _this3.handleShowAdd(e, picture);
                      }
                    });
                  },
                  searchRightNav: this.props.onUpload ? _react2.default.createElement(_UploadModal2.default, {
                    modalState: this.state.uploadModalState,
                    floated: 'right',
                    header: t('pictures', { ns: _translation.TRANSLATION_FILES.translation }),
                    onModalStateChange: this.handleUploadModalStateChange,
                    onConfirm: this.handleOnUpload,
                    onClose: this.handleCheckBeforeClose,
                    content: function content(_ref4) {
                      var onConfirm = _ref4.onConfirm;
                      return _react2.default.createElement(_Form2.default, {
                        ref: function ref(_ref5) {
                          _this3.form = _ref5;
                        },
                        onSubmit: onConfirm
                      });
                    }
                  }) : null
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal,
            {
              open: this.state.showAdd,
              onClose: this.handleCancelAdd,
              closeIcon: 'close',
              size: 'large'
            },
            _react2.default.createElement(_semanticUiReact.Header, { icon: 'add', content: ' ' + t('addPictureTo', { ns: _translation.TRANSLATION_FILES.screens }) + ' ' + this.props.type.replace('_', ' ') }),
            _react2.default.createElement(
              _semanticUiReact.Modal.Content,
              { scrolling: true },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 'equal', stackable: true, doubling: true },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_LoadImage2.default, {
                    wrapped: true,
                    picture: this.state.selectedPicture,
                    pictureSize: 70
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { className: 'ui form' },
                  _react2.default.createElement(
                    'div',
                    { className: 'field' },
                    _react2.default.createElement(
                      'label',
                      { htmlFor: 'type' },
                      t('Type', { ns: _translation.TRANSLATION_FILES.screens })
                    ),
                    _react2.default.createElement(_semanticUiReact.Dropdown, {
                      options: _pictureTypes2.default.map(function (status) {
                        return _extends({}, status, {
                          text: t(status.text, { ns: _translation.TRANSLATION_FILES.screens })
                        });
                      }),
                      placeholder: t('Type', { ns: _translation.TRANSLATION_FILES.screens }),
                      name: 'type',
                      search: true,
                      selection: true,
                      fluid: true,
                      value: this.state.referenceType || _pictureTypes2.default[0].value,
                      onChange: this.handleTypeChange
                    })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Modal.Actions,
              null,
              _react2.default.createElement(_semanticUiReact.Button, { basic: true, negative: true, onClick: this.handleCancelAdd, icon: 'cancel', content: t('cancel', { ns: _translation.TRANSLATION_FILES.screens }), inverted: true }),
              _react2.default.createElement(_semanticUiReact.Button, { basic: true, positive: true, onClick: this.handleAddPicture, icon: 'add', content: t('add', { ns: _translation.TRANSLATION_FILES.screens }), inverted: true })
            )
          )
        )
      );
    }
  }]);

  return AddPicture;
}(_react.Component);

AddPicture.contextTypes = {
  store: _propTypes2.default.object
};
AddPicture.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  onUpload: _propTypes2.default.func,
  onCheck: _propTypes2.default.func,
  type: _propTypes2.default.oneOf(['project', 'unit_layout']).isRequired,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(AddPicture);

/***/ }),
/* 1076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormSharingModal = function (_Component) {
  _inherits(FormSharingModal, _Component);

  function FormSharingModal(props) {
    _classCallCheck(this, FormSharingModal);

    var _this = _possibleConstructorReturn(this, (FormSharingModal.__proto__ || Object.getPrototypeOf(FormSharingModal)).call(this, props));

    _this.handleOnOpen = function (e) {
      e.preventDefault();
      _this.setState({ open: true });
    };

    _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
      _this.setState({
        open: false,
        selectedPrintForms: []
      });
    };

    _this.handleInputChange = function (e, _ref) {
      var value = _ref.value;

      var selectedTemplates = _this.props.printTemplates.filter(function (t) {
        return value.includes(t.value);
      });

      var selectedDocxTemplates = selectedTemplates.filter(function (t) {
        return t.type === 'docx';
      }).map(function (t) {
        return t.value;
      });

      var selectedPrintTemplates = selectedTemplates.filter(function (t) {
        return t.type !== 'docx';
      }).map(function (t) {
        return t.value;
      });

      _this.setState({
        selectedDocxTemplates: selectedDocxTemplates,
        selectedPrintTemplates: selectedPrintTemplates,
        selectedPrintForms: value
      });
    };

    _this.handleProceedAndClose = function (e) {
      var onProceed = _this.props.onProceed;
      var _this$state = _this.state,
          selectedDocxTemplates = _this$state.selectedDocxTemplates,
          selectedPrintTemplates = _this$state.selectedPrintTemplates;

      var data = {
        printTemplateIDs: selectedPrintTemplates,
        docxTemplateIDs: selectedDocxTemplates
      };
      onProceed(e, data);
      _this.handleOnClose(e);
    };

    _this.state = {
      open: false,
      selectedPrintForms: []
    };
    return _this;
  }

  _createClass(FormSharingModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var open = nextProps.open;

      if (open) {
        this.setState({ open: open });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          printTemplates = _props.printTemplates;
      var selectedPrintForms = this.state.selectedPrintForms;


      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          className: 'share-email',
          closeOnDimmerClick: false,
          size: 'tiny',
          open: this.state.open,
          onClose: this.handleOnClose,
          onOpen: this.handleOnOpen
        },
        _react2.default.createElement(_semanticUiReact.Header, {
          icon: 'share square',
          content: t('Email Form to Purchaser')
        }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            'div',
            { style: { marginBottom: '40px' } },
            _react2.default.createElement(
              _semanticUiReact.Header,
              {
                as: 'h5',
                style: { margin: '0 0 5px 0' }
              },
              t('Select form to share with Purchaser')
            ),
            _react2.default.createElement(
              _semanticUiReact.Form,
              null,
              _react2.default.createElement(_semanticUiReact.Form.Dropdown, {
                name: 'selectedPrintForms',
                fluid: true,
                multiple: true,
                search: true,
                selection: true,
                placeholder: t('Select form'),
                options: printTemplates,
                onChange: this.handleInputChange,
                value: selectedPrintForms
              })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, {
            onClick: this.handleOnClose,
            content: t('Close', { ns: _translation.TRANSLATION_FILES.translation })
          }),
          _react2.default.createElement(_semanticUiReact.Button, {
            primary: true,
            onClick: this.handleProceedAndClose,
            content: t('Proceed', { ns: _translation.TRANSLATION_FILES.translation }),
            disabled: !selectedPrintForms.length
          })
        )
      );
    }
  }]);

  return FormSharingModal;
}(_react.Component);

FormSharingModal.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onProceed: _propTypes2.default.func,
  printTemplates: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  t: _propTypes2.default.func
};
FormSharingModal.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(FormSharingModal);

/***/ }),
/* 1077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InsufficientCreditCheckModal = function (_Component) {
  _inherits(InsufficientCreditCheckModal, _Component);

  function InsufficientCreditCheckModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InsufficientCreditCheckModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InsufficientCreditCheckModal.__proto__ || Object.getPrototypeOf(InsufficientCreditCheckModal)).call.apply(_ref, [this].concat(args))), _this), _this.handleTopUpCredits = function (e) {
      e.preventDefault();
      window.zE('webWidget', 'reset');
      window.zE('webWidget', 'open');
      _this.props.onClose(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InsufficientCreditCheckModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          className: 'manage manage-credit-check',
          dimmer: true,
          closeOnDimmerClick: true,
          open: this.props.open,
          size: 'small'
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: 'Insufficient credits' }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            'h4',
            null,
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'p',
                null,
                'Not enough balance to perform a Credit Check. Please contact the admin'
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(
            _semanticUiReact.Button,
            { onClick: function onClick(e) {
                return _this2.props.onClose(e);
              }, color: 'grey' },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove' }),
            ' Cancel'
          ),
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              color: 'green',
              as: 'a',
              onClick: this.handleTopUpCredits
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus' }),
            ' Top Up'
          )
        )
      );
    }
  }]);

  return InsufficientCreditCheckModal;
}(_react.Component);

InsufficientCreditCheckModal.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func
};
exports.default = InsufficientCreditCheckModal;

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _webValidations = __webpack_require__(23);

var _apiEndpoints = __webpack_require__(140);

var endpoints = _interopRequireWildcard(_apiEndpoints);

var _flash = __webpack_require__(5);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _PhoneInput = __webpack_require__(104);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

var _intlCallCodes = __webpack_require__(116);

var _intlCallCodes2 = _interopRequireDefault(_intlCallCodes);

var _fetchM = __webpack_require__(6);

var _companies = __webpack_require__(88);

var _intlFlagCodes = __webpack_require__(141);

var _intlFlagCodes2 = _interopRequireDefault(_intlFlagCodes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var actionStyle = { display: 'flex', justifyContent: 'center' };

var InviteLawyerForm = function (_Component) {
  _inherits(InviteLawyerForm, _Component);

  function InviteLawyerForm(props) {
    _classCallCheck(this, InviteLawyerForm);

    var _this = _possibleConstructorReturn(this, (InviteLawyerForm.__proto__ || Object.getPrototypeOf(InviteLawyerForm)).call(this, props));

    _initialiseProps.call(_this);

    var company = props.company;
    var defaultCountryPhoneCode = '60';
    if ((0, _companies.isForeignCompany)(company)) {
      var idx = _intlFlagCodes2.default.findIndex(function (f) {
        return f.countryCode === company.countryCode;
      });
      if (idx !== -1) {
        defaultCountryPhoneCode = _intlFlagCodes2.default[idx].value;
      }
    }
    _this.state = {
      mobilePrefix: defaultCountryPhoneCode,
      mobile: '',
      name: '',
      email: '',
      firm: '',
      errMessages: [],
      invitation: null,
      isInvited: false,
      isExisted: false,
      isPanel: false,
      company: {}
    };
    _this.validation = {
      name: (0, _react.createRef)(),
      email: (0, _react.createRef)(),
      mobilePrefix: (0, _react.createRef)(),
      mobile: (0, _react.createRef)(),
      firm: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(InviteLawyerForm, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          invitation = _state.invitation,
          isExisted = _state.isExisted,
          isInvited = _state.isInvited;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          size: invitation ? 'small' : null,
          open: this.props.open,
          onClose: this.handleOnClose,
          closeIcon: 'close'
        },
        _react2.default.createElement(_semanticUiReact.Header, {
          content: isExisted || isInvited ? 'Account Found' : 'Invite Lawyer',
          subheader: isExisted || isInvited ? null : 'Please fill in lawyer\'s detail.'
        }),
        this.renderContent(),
        this.renderAction()
      );
    }
  }]);

  return InviteLawyerForm;
}(_react.Component);

InviteLawyerForm.contextTypes = {
  store: _propTypes2.default.object
};
InviteLawyerForm.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  projectName: _propTypes2.default.string,
  loanTrackerProjectID: _propTypes2.default.number.isRequired,
  loading: _propTypes2.default.bool,
  setLoading: _propTypes2.default.func,
  company: _propTypes2.default.shape({
    name: _propTypes2.default.string,
    countryCode: _propTypes2.default.string
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.setExternalLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var setLoading = _this2.props.setLoading;

    if (setLoading) {
      setLoading(loading);
    }
  };

  this.setComponentState = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new Promise(function (res) {
      return _this2.setState(state, function () {
        return res(state);
      });
    });
  };

  this.inviteLawyer = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(body) {
      var store, errMessages, loanTrackerProjectID, res, _e$response$data, error_message, error_data, isInvited, isExisted, isPanel, invitation, name;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store = _this2.context.store;
              errMessages = _this2.state.errMessages;

              if (!(errMessages.length > 0)) {
                _context.next = 5;
                break;
              }

              store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errMessages.map(function (l) {
                  return l.message;
                }) }));
              return _context.abrupt('return');

            case 5:
              loanTrackerProjectID = _this2.props.loanTrackerProjectID;

              if (loanTrackerProjectID) {
                _context.next = 10;
                break;
              }

              _context.next = 9;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'This project is not linked in loan tracker.' }));

            case 9:
              return _context.abrupt('return');

            case 10:
              if (!_this2.form) {
                _context.next = 13;
                break;
              }

              _context.next = 13;
              return _this2.form.setLoading(true);

            case 13:
              res = void 0;
              _context.prev = 14;
              _context.next = 17;
              return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.INVITE_LAWYER(loanTrackerProjectID), body, 'post', {
                'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
              }));

            case 17:
              res = _context.sent;
              _context.next = 41;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context['catch'](14);

              if (!_this2.form) {
                _context.next = 25;
                break;
              }

              _context.next = 25;
              return _this2.form.setLoading(false);

            case 25:
              if (!(_context.t0 && _context.t0.response && _context.t0.response.data)) {
                _context.next = 37;
                break;
              }

              _e$response$data = _context.t0.response.data, error_message = _e$response$data.error_message, error_data = _e$response$data.error_data;
              isInvited = false;
              isExisted = false;
              isPanel = false;
              invitation = void 0;

              if (error_message.match(/already invited/i)) {
                invitation = error_data;
                isInvited = true;
                if (invitation) {
                  isExisted = invitation.lawyer_id && invitation.lawyer_id !== '0';
                }
              }
              if (error_message.match(/already exists/i)) {
                isExisted = true;
                if (error_message.match(/Lawyer already exists/i)) {
                  invitation = error_data;
                  isInvited = true;
                  isPanel = error_data.panels.split(',').some(function (p) {
                    return '' + p === '' + loanTrackerProjectID;
                  });
                } else {
                  name = error_data.Attributes.find(function (f) {
                    return f.Name === 'name';
                  }).Value;

                  invitation = {
                    name: name,
                    email: body.email,
                    lawyer_id: error_data.Username
                  };
                }
              }

              if (!invitation) {
                _context.next = 36;
                break;
              }

              _context.next = 36;
              return _this2.setComponentState({ invitation: invitation, isExisted: isExisted, isInvited: isInvited, isPanel: isPanel });

            case 36:
              return _context.abrupt('return');

            case 37:
              Bugsnag.notifyException(_context.t0);
              _context.next = 40;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

            case 40:
              return _context.abrupt('return');

            case 41:
              if (!res) {
                _context.next = 46;
                break;
              }

              _context.next = 44;
              return _this2.setComponentState({ invitation: res });

            case 44:
              _context.next = 46;
              return store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Invite success', message: 'Lawyer ' + res.name + ' is successfully invited.' }));

            case 46:
              if (!_this2.form) {
                _context.next = 49;
                break;
              }

              _context.next = 49;
              return _this2.form.setLoading(false);

            case 49:
              if (_this2.props.onConfirm) {
                _this2.props.onConfirm();
              }

            case 50:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[14, 20]]);
    }));

    return function (_x3) {
      return _ref.apply(this, arguments);
    };
  }();

  this.addPanelLawyer = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(lawyerID) {
      var store, _props, loanTrackerProjectID, projectName, body;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.setExternalLoading(true);

            case 2:
              store = _this2.context.store;
              _props = _this2.props, loanTrackerProjectID = _props.loanTrackerProjectID, projectName = _props.projectName;

              if (loanTrackerProjectID) {
                _context2.next = 8;
                break;
              }

              _context2.next = 7;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'This project is not linked in loan tracker.' }));

            case 7:
              return _context2.abrupt('return');

            case 8:
              body = {
                lawyer_ids: [lawyerID],
                project_name: projectName
              };
              _context2.prev = 9;
              _context2.next = 12;
              return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.PANEL_LAWYERS(loanTrackerProjectID), body, 'put', {
                'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
              }));

            case 12:
              _context2.next = 22;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2['catch'](9);

              Bugsnag.notifyException(_context2.t0);
              _context2.next = 19;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

            case 19:
              _context2.next = 21;
              return _this2.setExternalLoading(false);

            case 21:
              return _context2.abrupt('return');

            case 22:
              _context2.next = 24;
              return store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Add Success', message: 'Panel lawyer(s) successfully added.' }));

            case 24:
              _context2.next = 26;
              return _this2.setExternalLoading(false);

            case 26:
              if (_this2.props.onConfirm) {
                _this2.props.onConfirm();
              }

            case 27:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[9, 14]]);
    }));

    return function (_x4) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.resetData = function () {
    var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

    _this2.setState({
      mobilePrefix: '60',
      mobile: '',
      name: '',
      email: '',
      firm: '',
      errMessages: [],
      invitation: null
    }, cb);
  };

  this.handleSubmit = function (event) {
    event.preventDefault();
    var _state2 = _this2.state,
        name = _state2.name,
        email = _state2.email,
        firm = _state2.firm,
        mobile = _state2.mobile,
        mobilePrefix = _state2.mobilePrefix;
    var _props$company = _this2.props.company,
        company = _props$company === undefined ? {} : _props$company;

    var companyName = company.name;
    var data = {
      name: name,
      email: email,
      firm: firm,
      mobile: mobile,
      mobilePrefix: mobilePrefix
    };
    return _AppForm2.default.validate(_this2.validation, data).then(function (validations) {
      _this2.setState({
        errMessages: validations.filter(function (v) {
          return !v.isValid;
        })
      }, function () {
        var lawyer = {
          name: name,
          email: email.toLowerCase(),
          firm: firm,
          mobile_prefix: mobilePrefix,
          mobile: mobile,
          company_name: companyName
        };
        _this2.inviteLawyer(lawyer);
      });
    });
  };

  this.handleOnClose = function (e) {
    if (_this2.props.onClose) {
      _this2.props.onClose(e);
    }
  };

  this.handleOnConfirm = function (e) {
    if (_this2.props.onConfirm) {
      _this2.props.onConfirm(e);
    }
  };

  this.handleOnSubmit = function (e) {
    e.preventDefault();
    _this2.form.handleSubmit(e);
  };

  this.handleOnChange = function (e, _ref3) {
    var name = _ref3.name,
        value = _ref3.value;

    _this2.setState(_defineProperty({}, name, value));
  };

  this.handleAddPanel = function (e) {
    e.preventDefault();
    _this2.addPanelLawyer(_this2.state.invitation.lawyer_id);
  };

  this.renderContent = function () {
    var _state3 = _this2.state,
        invitation = _state3.invitation,
        isInvited = _state3.isInvited,
        isExisted = _state3.isExisted,
        isPanel = _state3.isPanel;

    if (invitation) {
      if (isExisted) {
        return _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Segment,
            { basic: true, textAlign: 'center' },
            _react2.default.createElement(
              'p',
              null,
              'There is an existing account found with the email address ',
              _react2.default.createElement(
                'strong',
                null,
                invitation.email
              ),
              '.'
            ),
            isInvited && !isPanel ? _react2.default.createElement(
              'p',
              null,
              'Do you want to add ',
              _react2.default.createElement(
                'strong',
                null,
                invitation.name,
                ' (',
                invitation.email,
                ')'
              ),
              ' to Panel Lawyer?'
            ) : null,
            isPanel ? _react2.default.createElement(
              'p',
              null,
              'Lawyer is already added as Panel Lawyer.'
            ) : null
          )
        );
      }
      return _react2.default.createElement(
        _semanticUiReact.Modal.Content,
        null,
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { basic: true, textAlign: 'center' },
          _react2.default.createElement(
            'p',
            null,
            'An activation email has been sent to ',
            _react2.default.createElement(
              'strong',
              null,
              invitation.name,
              ' (',
              invitation.email,
              ')'
            ),
            isInvited && invitation.created_at ? ' on ' + (0, _momentTimezone2.default)(invitation.created_at).format('YYYY-MM-DD') : '',
            '.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'You may assign your case(s) to the lawyer once his/her account is registered and activated.'
          )
        )
      );
    }
    return _this2.renderForm();
  };

  this.renderForm = function () {
    return _react2.default.createElement(
      _semanticUiReact.Modal.Content,
      null,
      _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: _this2.handleSubmit,
          error: _this2.state.errMessages.length > 0,
          ref: function ref(_ref4) {
            _this2.form = _ref4;
          }
        },
        _react2.default.createElement(_AppForm2.default.Input, {
          autoComplete: 'off',
          name: 'name',
          onChange: _this2.handleOnChange,
          label: 'Name',
          ref: _this2.validation.name,
          validation: [_webValidations.required],
          value: _this2.state.name
        }),
        _react2.default.createElement(_AppForm2.default.Input, {
          autoComplete: 'off',
          name: 'email',
          onChange: _this2.handleOnChange,
          label: 'Email Address',
          ref: _this2.validation.email,
          validation: [_webValidations.required, _webValidations.email],
          value: _this2.state.email
        }),
        _react2.default.createElement(
          _semanticUiReact.Form.Group,
          { widths: 'equal' },
          _react2.default.createElement(
            _AppForm2.default.Validate,
            {
              validation: [_webValidations.required],
              ref: _this2.validation.mobilePrefix,
              onChange: _this2.handleOnChange,
              validateLabel: 'Mobile prefix'
            },
            _react2.default.createElement(_semanticUiReact.Form.Select, {
              name: 'mobilePrefix',
              onChange: _this2.handleOnChange,
              options: _intlCallCodes2.default,
              label: 'Mobile Prefix',
              search: true,
              selectOnBlur: false,
              value: _this2.state.mobilePrefix
            })
          ),
          _react2.default.createElement(_PhoneInput2.default, {
            autoComplete: 'off',
            name: 'mobile',
            onChange: _this2.handleOnChange,
            placeholder: _this2.state.mobilePrefix === '60' ? 'Mobile* (e.g. 196756118)' : 'Mobile*',
            label: _this2.state.mobilePrefix === '60' ? 'Mobile* (e.g. 196756118)' : 'Mobile*',
            prefix: _this2.state.mobilePrefix,
            ref: _this2.validation.mobile,
            type: 'tel',
            validation: [_webValidations.required, {
              validate: _webValidations.phoneNumber,
              option: _this2.state.mobilePrefix === 'other' ? {} : {
                isMobile: true,
                phonePrefix: _this2.state.mobilePrefix
              }
            }],
            value: _this2.state.mobile,
            validateLabel: 'Mobile'
          })
        ),
        _react2.default.createElement(_AppForm2.default.Input, {
          autoComplete: 'off',
          name: 'firm',
          onChange: _this2.handleOnChange,
          label: 'Law Firm Name',
          ref: _this2.validation.firm,
          validation: [_webValidations.required],
          value: _this2.state.firm
        })
      )
    );
  };

  this.renderAction = function () {
    var _state4 = _this2.state,
        invitation = _state4.invitation,
        isExisted = _state4.isExisted,
        isInvited = _state4.isInvited,
        isPanel = _state4.isPanel;
    var loading = _this2.props.loading;

    if (invitation) {
      if (isExisted && isInvited && !isPanel) {
        return _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          { style: actionStyle },
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, negative: true, onClick: _this2.handleOnClose, icon: 'cancel', content: 'No', inverted: true, disabled: loading }),
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, positive: true, onClick: _this2.handleAddPanel, icon: 'checkmark', content: 'Yes', inverted: true, disabled: loading })
        );
      }
      return _react2.default.createElement(
        _semanticUiReact.Modal.Actions,
        { style: actionStyle },
        _react2.default.createElement(_semanticUiReact.Button, {
          primary: true,
          onClick: _this2.handleOnClose,
          content: 'OK',
          disabled: loading
        })
      );
    }
    return _react2.default.createElement(
      _semanticUiReact.Modal.Actions,
      null,
      _react2.default.createElement(_semanticUiReact.Button, { basic: true, negative: true, onClick: _this2.handleOnClose, icon: 'cancel', content: 'Cancel', inverted: true, disabled: loading }),
      _react2.default.createElement(_semanticUiReact.Button, { basic: true, positive: true, onClick: _this2.handleOnSubmit, icon: 'checkmark', content: 'Invite', inverted: true, disabled: loading })
    );
  };
};

exports.default = InviteLawyerForm;

/***/ }),
/* 1079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _reactSortableHoc = __webpack_require__(123);

var _flash = __webpack_require__(5);

var _ProjectUnitPackagePricing = __webpack_require__(566);

var _Sortable = __webpack_require__(317);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

var _package_pricing = __webpack_require__(222);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SortableItem = (0, _reactSortableHoc.SortableElement)(function (props) {
  return _react2.default.createElement(
    'div',
    { className: 'sortablehoc_item ' + (props.itemClass ? props.itemClass : '') },
    _react2.default.createElement(
      _semanticUiReact.Segment,
      { className: 'package_pricing_unit' },
      _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 2, tablet: 2, computer: 1 },
            _react2.default.createElement(_Sortable.SortableDragHandle, props)
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 11, tablet: 12, computer: 14 },
            _react2.default.createElement(_ProjectUnitPackagePricing.UnitPackagePricingEdit, _extends({}, props, {
              data: props.value,
              packagePricings: props.packagePricings,
              onChange: props.onChange,
              refValidation: props.refValidation,
              refForm: props.refForm
            }))
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 3, tablet: 2, computer: 1, textAlign: 'right' },
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                size: 'small',
                basic: true,
                compact: true,
                icon: true,
                onClick: function onClick() {
                  return props.onDelete(props.value);
                }
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'trash', color: 'red' })
            )
          )
        )
      )
    )
  );
});

var MultiUnitPackagePricing = function (_Component) {
  _inherits(MultiUnitPackagePricing, _Component);

  function MultiUnitPackagePricing(props) {
    _classCallCheck(this, MultiUnitPackagePricing);

    var _this = _possibleConstructorReturn(this, (MultiUnitPackagePricing.__proto__ || Object.getPrototypeOf(MultiUnitPackagePricing)).call(this, props));

    _initialiseProps.call(_this);

    var state = MultiUnitPackagePricing.getPropsToState(props);
    _this.state = _extends({}, state, {
      showDeleteConfirm: false,
      deleteIDX: null,
      deleteData: Object.assign({}, _package_pricing.PROJECT_UNIT_PACKAGE_PRICING_DEFAULT)
    });
    _this.editRef = [];
    _this.formRef = {};
    return _this;
  }

  _createClass(MultiUnitPackagePricing, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = MultiUnitPackagePricing.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'renderEdit',
    value: function renderEdit() {
      var _this3 = this;

      var _state = this.state,
          data = _state.data,
          showDeleteConfirm = _state.showDeleteConfirm;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_DeleteConfirm2.default, {
          content: 'Are you sure you want to remove this unit pricing package?',
          onClose: this.handleCancelDelete,
          onConfirm: this.handleConfirmDelete,
          open: showDeleteConfirm
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              data.length > 0 ? _react2.default.createElement(_Sortable.SortableContainer, {
                isSortMode: true,
                iconColor: 'blue',
                helperClass: 'sorting',
                data: data,
                lockAxis: 'y',
                lockToContainerEdges: true,
                onSortEnd: this.onSortEnd,
                useDragHandle: true,
                item: function item(props) {
                  return _react2.default.createElement(SortableItem, _extends({}, props, {
                    onChange: function onChange(d) {
                      return _this3.handleOnChange(d, props.idx);
                    },
                    onDelete: function onDelete(d) {
                      return _this3.handleDelete(d, props.idx);
                    },
                    refForm: _this3.setRefForm,
                    refValidation: function refValidation(ref) {
                      return _this3.setRefValidation(ref, props.idx);
                    },
                    packagePricings: _this3.getPackagePricings
                  }));
                }
              }) : _react2.default.createElement(
                _semanticUiReact.Segment,
                { className: 'segment_unit_pricing_package_not_found', textAlign: 'center' },
                'No unit pricing package found'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { textAlign: 'center' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  basic: true,
                  onClick: this.handleAdd
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'add circle', color: 'green' }),
                ' Add pricing package'
              )
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var unit = this.props.unit;

      if (unit) {
        return _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            closeOnEscape: false,
            closeOnDimmerClick: false,
            open: this.props.open === true
          },
          _react2.default.createElement(
            _semanticUiReact.Modal.Header,
            null,
            'Manage Pricing Package for ',
            unit.reference
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Modal.Description,
              null,
              this.renderEdit()
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(_semanticUiReact.Button, { primary: true, onClick: this.handleOnDone, content: 'Confirm', inverted: true })
          )
        );
      }
      return this.renderEdit();
    }
  }]);

  return MultiUnitPackagePricing;
}(_react.Component);

MultiUnitPackagePricing.contextTypes = {
  store: _propTypes2.default.object
};
MultiUnitPackagePricing.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  onChange: _propTypes2.default.func.isRequired,
  onDone: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  packagePricings: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  unit: _propTypes2.default.oneOfType([_propTypes2.default.object.isRequired])
};

MultiUnitPackagePricing.getPropsToState = function (props) {
  var data = props.unit && props.unit.projectUnitPackagePricings ? props.unit.projectUnitPackagePricings : props.data || [];
  var packagePricings = props.packagePricings || [];
  return {
    data: data,
    packagePricings: packagePricings
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onSortEnd = function (_ref) {
    var oldIndex = _ref.oldIndex,
        newIndex = _ref.newIndex;

    var data = _this4.sortDataByIndex((0, _reactSortableHoc.arrayMove)(_this4.state.data, oldIndex, newIndex));
    _this4.setState({ data: data });
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this4.setState({ loading: loading }, function () {
        res(loading);
      });
    });
  };

  this.getPackagePricings = function () {
    var data = _this4.state.data;
    // filter out already added package pricings

    var packagePricings = _this4.state.packagePricings.filter(function (p) {
      return !data.find(function (d) {
        return d.id !== '' && d.projectPackagePricingID === p.id;
      });
    }).sort(function (a, b) {
      return a.orderPriority - b.orderPriority;
    });
    var options = [];
    packagePricings.forEach(function (p) {
      var newItem = {
        text: p.name,
        value: p.id
      };
      // disabled the option once selected
      var selectedItem = data.find(function (d) {
        return d.projectPackagePricingID === p.id;
      });
      if (selectedItem) newItem.disabled = true;
      options.push(newItem);
    });
    return options;
  };

  this.setRefValidation = function (ref, idx) {
    if (ref && ref.props && ref.props.name) {
      if (!_this4.editRef[idx]) _this4.editRef[idx] = {};
      _this4.editRef[idx][ref.props.name] = ref;
    }
  };

  this.setRefForm = function (ref) {
    _this4.formRef = ref;
  };

  this.sortDataByIndex = function (newData) {
    var data = newData;
    data.forEach(function (d, index) {
      data[index].orderPriority = index + 1;
    });
    return data;
  };

  this.asyncForEach = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(array, callback) {
      var index;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              index = 0;

            case 1:
              if (!(index < array.length)) {
                _context.next = 7;
                break;
              }

              _context.next = 4;
              return callback(array[index], index, array);

            case 4:
              index += 1;
              _context.next = 1;
              break;

            case 7:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this4);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.handleOnChange = function (d, idx) {
    var data = _this4.state.data;

    var newData = [];
    data.forEach(function (item, i) {
      if (i === idx) {
        newData.push(d);
      } else {
        newData.push(item);
      }
    });
    _this4.setState({ data: newData }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var hasError, errMessages;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (_this4.editRef[idx]) _AppForm2.default.validate(_this4.editRef[idx], newData[idx]);

              if (!_this4.props.onChange) {
                _context3.next = 10;
                break;
              }

              if (_this4.props.unit) {
                _context3.next = 9;
                break;
              }

              hasError = false;
              errMessages = '';
              _context3.next = 7;
              return _this4.asyncForEach(data, function () {
                var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(db, idxb) {
                  var validations;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          if (!(_this4.editRef[idxb] && !hasError)) {
                            _context2.next = 6;
                            break;
                          }

                          _context2.next = 3;
                          return _AppForm2.default.validate(_this4.editRef[idxb], data[idxb]);

                        case 3:
                          validations = _context2.sent;

                          errMessages = validations.filter(function (v) {
                            return !v.isValid;
                          });
                          if (errMessages.length > 0) {
                            hasError = true;
                          }

                        case 6:
                        case 'end':
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this4);
                }));

                return function (_x5, _x6) {
                  return _ref4.apply(this, arguments);
                };
              }());

            case 7:
              _this4.props.onChange(_this4.state.data, errMessages);
              return _context3.abrupt('return');

            case 9:
              _this4.props.onChange(_this4.state.data);

            case 10:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    })));
  };

  this.handleDelete = function (d, idx) {
    _this4.setState({
      showDeleteConfirm: true,
      deleteIDX: idx,
      deleteData: d
    });
  };

  this.handleCancelDelete = function (e) {
    e.preventDefault();
    _this4.setState({
      showDeleteConfirm: false,
      deleteIDX: null,
      deleteData: Object.assign({}, _package_pricing.PROJECT_UNIT_PACKAGE_PRICING_DEFAULT)
    });
  };

  this.handleConfirmDelete = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e) {
      var _state2, data, deleteIDX, newData;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              e.preventDefault();
              _state2 = _this4.state, data = _state2.data, deleteIDX = _state2.deleteIDX;
              newData = [];

              data.forEach(function (item, i) {
                if (i !== deleteIDX) {
                  newData.push(item);
                }
              });
              _this4.setState({
                data: _this4.sortDataByIndex(newData),
                deleteData: Object.assign({}, _package_pricing.PROJECT_UNIT_PACKAGE_PRICING_DEFAULT),
                deleteIDX: null,
                showDeleteConfirm: false
              }, function () {
                if (_this4.props.onChange) _this4.props.onChange(_this4.state.data);
              });

            case 5:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }));

    return function (_x7) {
      return _ref5.apply(this, arguments);
    };
  }();

  this.handleAdd = function (e) {
    e.preventDefault();
    var data = _this4.state.data;
    var unit = _this4.props.unit;

    var newItem = (0, _clone2.default)(Object.assign({}, _package_pricing.PROJECT_UNIT_PACKAGE_PRICING_DEFAULT, {
      orderPriority: data.length + 1,
      projectID: unit ? unit.projectID : '',
      projectUnitID: unit ? unit.id : ''
    }));
    data.push(newItem);
    _this4.setState({ data: data }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var hasError, errMessages;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!_this4.props.onChange) {
                _context6.next = 9;
                break;
              }

              if (_this4.props.unit) {
                _context6.next = 8;
                break;
              }

              hasError = false;
              errMessages = '';
              _context6.next = 6;
              return _this4.asyncForEach(data, function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(db, idxb) {
                  var validations;
                  return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          if (!(_this4.editRef[idxb] && !hasError)) {
                            _context5.next = 6;
                            break;
                          }

                          _context5.next = 3;
                          return _AppForm2.default.validate(_this4.editRef[idxb], data[idxb]);

                        case 3:
                          validations = _context5.sent;

                          errMessages = validations.filter(function (v) {
                            return !v.isValid;
                          });
                          if (errMessages.length > 0) {
                            hasError = true;
                          }

                        case 6:
                        case 'end':
                          return _context5.stop();
                      }
                    }
                  }, _callee5, _this4);
                }));

                return function (_x8, _x9) {
                  return _ref7.apply(this, arguments);
                };
              }());

            case 6:
              _this4.props.onChange(_this4.state.data, errMessages);
              return _context6.abrupt('return');

            case 8:
              _this4.props.onChange(_this4.state.data);

            case 9:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this4);
    })));
  };

  this.handleOnDone = function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(e) {
      var store, data, hasError;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              e.preventDefault();
              store = _this4.context.store;
              data = _this4.state.data;
              hasError = false;
              _context8.next = 6;
              return _this4.asyncForEach(data, function () {
                var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(d, idx) {
                  var validations, errMessages;
                  return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          if (!(_this4.editRef[idx] && !hasError)) {
                            _context7.next = 9;
                            break;
                          }

                          _context7.next = 3;
                          return _AppForm2.default.validate(_this4.editRef[idx], data[idx]);

                        case 3:
                          validations = _context7.sent;
                          errMessages = validations.filter(function (v) {
                            return !v.isValid;
                          });

                          if (!(errMessages.length > 0)) {
                            _context7.next = 9;
                            break;
                          }

                          hasError = true;
                          _context7.next = 9;
                          return store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errMessages.map(function (l) {
                              return l.message;
                            }) }));

                        case 9:
                        case 'end':
                          return _context7.stop();
                      }
                    }
                  }, _callee7, _this4);
                }));

                return function (_x11, _x12) {
                  return _ref9.apply(this, arguments);
                };
              }());

            case 6:
              if (!hasError && _this4.props.onDone) {
                _this4.props.onDone(e);
              }

            case 7:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this4);
    }));

    return function (_x10) {
      return _ref8.apply(this, arguments);
    };
  }();
};

exports.default = MultiUnitPackagePricing;

/***/ }),
/* 1080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _flash = __webpack_require__(5);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UpdateCaseStatus = function (_Component) {
  _inherits(UpdateCaseStatus, _Component);

  function UpdateCaseStatus(props) {
    _classCallCheck(this, UpdateCaseStatus);

    var _this = _possibleConstructorReturn(this, (UpdateCaseStatus.__proto__ || Object.getPrototypeOf(UpdateCaseStatus)).call(this, props));

    _initialiseProps.call(_this);

    var loanAmount = props.loanAmount;
    _this.state = {
      loanAmount: loanAmount,
      statusNote: ''
    };
    return _this;
  }

  _createClass(UpdateCaseStatus, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var loanAmount = nextProps.loanAmount;
      var loanMargin = this.getLoanMargin(this.state.loanAmount, nextProps.spaValue);
      if (this.props.open !== nextProps.open) {
        this.setState({
          statusNote: ''
        });
      }

      this.setState({ loanAmount: loanAmount, loanMargin: loanMargin });
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          size: 'small',
          open: this.props.open === true,
          onClose: this.handleOnClose
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'info', content: t('Update Loan Status') }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation.TRANSLATION_FILES.screens },
              _react2.default.createElement(
                'p',
                null,
                'Change ',
                _react2.default.createElement(
                  'strong',
                  null,
                  { bankerName: this.props.bankerName }
                ),
                '\'s status to ',
                _react2.default.createElement(
                  'strong',
                  null,
                  { status: this.props.statusName }
                ),
                '?'
              )
            ),
            this.props.statusName === 'LO Signed' ? _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { style: { marginBottom: '1em' } },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tab: 8, computer: 8 },
                  _react2.default.createElement(_semanticUiReact.Form.Select, {
                    fluid: true,
                    label: t('Loan Margin'),
                    name: 'loanMargin',
                    options: this.getPercentageOptions(),
                    placeholder: '0%',
                    selectOnBlur: false,
                    value: this.state.loanMargin,
                    onChange: this.handleOnLoanMarginChange
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tab: 8, computer: 8 },
                  _react2.default.createElement(_semanticUiReact.Form.Input, {
                    fluid: true,
                    name: 'loanAmount',
                    label: t('Loan Amount') + '*',
                    type: 'number',
                    min: '0',
                    value: this.state.loanAmount,
                    onChange: this.handleOnLoanAmountChange,
                    step: '1'
                  })
                )
              )
            ) : null,
            _react2.default.createElement(_semanticUiReact.Form.Input, {
              fluid: true,
              label: t('Status Note'),
              value: this.state.statusNote,
              onChange: this.handleOnChange
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, negative: true, onClick: this.handleOnClose, icon: 'cancel', content: t('No', { ns: _translation.TRANSLATION_FILES.constants }), inverted: true }),
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, positive: true, onClick: this.handleOnComfirm, icon: 'checkmark', content: t('Yes', { ns: _translation.TRANSLATION_FILES.constants }), inverted: true })
        )
      );
    }
  }]);

  return UpdateCaseStatus;
}(_react.Component);

UpdateCaseStatus.contextTypes = {
  store: _propTypes2.default.object
};
UpdateCaseStatus.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  bankerName: _propTypes2.default.string,
  statusName: _propTypes2.default.string,
  loanAmount: _propTypes2.default.string,
  spaValue: _propTypes2.default.number
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getLoanMargin = function (loanAmount, spaValue) {
    var sellingPrice = spaValue || 0;
    var caseLoanAmount = loanAmount ? parseInt(loanAmount, 10) : 0;
    var loanMargin = 0;
    if (sellingPrice > 0 && caseLoanAmount > 0) {
      loanMargin = Math.ceil(caseLoanAmount / sellingPrice * 100);
    }
    return loanMargin;
  };

  this.getPercentageOptions = function () {
    var options = [];
    for (var i = 0; i <= 100; i += 1) {
      options = [].concat(_toConsumableArray(options), [{
        key: i,
        value: i,
        text: i + '%'
      }]);
    }
    return options;
  };

  this.handleOnClose = function (e) {
    if (_this2.props.onClose) {
      _this2.props.onClose(e);
    }
  };

  this.handleOnComfirm = function (e) {
    e.preventDefault();
    var store = _this2.context.store;
    var t = _this2.props.t;

    if (_this2.props.statusName === 'LO Signed') {
      if (parseInt(_this2.state.loanAmount, 10) < 1) {
        return store.dispatch((0, _flash.flashErrorMessage)({ message: t('Loan Amount is required', { ns: _translation.TRANSLATION_FILES.translation }) }));
      }
      if (parseInt(_this2.state.loanAmount, 10) > parseFloat(_this2.props.spaValue)) {
        return store.dispatch((0, _flash.flashErrorMessage)({ message: t('Loan Amount must be less than Selling Price', { ns: _translation.TRANSLATION_FILES.translation }) }));
      }
    }
    if (_this2.props.onConfirm) {
      _this2.props.onConfirm(e, _this2.state.statusNote, _this2.state.loanAmount);
    }
  };

  this.handleOnChange = function (e, _ref) {
    var value = _ref.value;

    _this2.setState({
      statusNote: value
    });
  };

  this.handleOnLoanAmountChange = function (e, _ref2) {
    var value = _ref2.value;
    var spaValue = _this2.props.spaValue;
    var _state = _this2.state,
        loanAmount = _state.loanAmount,
        loanMargin = _state.loanMargin;

    var sellingPrice = spaValue || 0;
    var caseLoanAmount = loanAmount;
    var loanPercent = loanMargin;
    var amount = 0;

    if (value !== '') {
      amount = parseInt(value, 10);
    }
    if (sellingPrice > 0) {
      loanPercent = Math.ceil(amount / sellingPrice * 100);
      caseLoanAmount = amount;
    }

    _this2.setState({ loanAmount: caseLoanAmount, loanMargin: loanPercent });
  };

  this.handleOnLoanMarginChange = function (e, _ref3) {
    var value = _ref3.value;
    var spaValue = _this2.props.spaValue;
    var _state2 = _this2.state,
        loanAmount = _state2.loanAmount,
        loanMargin = _state2.loanMargin;

    var sellingPrice = spaValue || 0;
    var caseLoanAmount = loanAmount;
    var loanPercent = loanMargin;
    var amount = 0;

    if (value !== '') {
      amount = parseInt(value, 10);
    }
    if (sellingPrice > 0) {
      loanPercent = _lodash2.default.toNumber(amount);
      caseLoanAmount = Math.floor(loanPercent / 100 * sellingPrice);
    }

    _this2.setState({
      loanAmount: caseLoanAmount,
      loanMargin: loanPercent
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(UpdateCaseStatus);

/***/ }),
/* 1081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initTelemetry = exports.parseSamplerRatio = exports.DEFAULT_SAMPLER_RATIO = exports.getEndUser = exports.clearEndUser = exports.identifyEndUser = exports.setEndUser = exports.resetTracePropagationOrigins = exports.getIgnoredUrls = exports.getTracePropagationOrigins = exports.isTracedUrl = exports.registerTracePropagationOrigin = exports.toOriginRegExp = undefined;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Browser tracing entry point — deliberately light.
 *
 * This module is imported by both entrypoints and by src/actions/auth.js, so it is in every
 * bundle. It therefore imports nothing from OpenTelemetry: the SDK, zone.js and the
 * instrumentations live in ./telemetrySdk.js, which initTelemetry() requires only when an OTLP
 * endpoint was configured at build time. A build without one never contains that module, so no
 * user pays for tracing that is switched off — no zone.js patching Promise and timers, no
 * wrapped fetch or XHR. See docs/OTEL.md, "Nothing loads when tracing is off".
 *
 * What stays here is the state other modules write before or without tracing: the origins our
 * APIs live on (bookApiURL arrives only after login) and the signed-in caller.
 */

var escapeRegExp = function escapeRegExp(value) {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};

// The end of an origin: a path, query, fragment, or the end of the string — nothing else. Without
// it `^https://book-api.mhub.my` also matches `https://book-api.mhub.my.evil.example` and a
// different port on the same host.
/* eslint no-console: 0 */
var ORIGIN_BOUNDARY = '(?:[/?#]|$)';

var originOf = function originOf(url) {
  try {
    return new URL(url).origin;
  } catch (e) {
    return null;
  }
};

/**
 * Matches any request under `url`'s origin, so instrumentation-fetch/xhr inject `traceparent` on
 * our API calls. urlMatches() does an exact string match for a plain string entry, so a RegExp on
 * the origin is required instead of passing the configured URL through as-is.
 */
var toOriginRegExp = exports.toOriginRegExp = function toOriginRegExp(url) {
  var origin = originOf(url);
  return origin ? new RegExp('^' + escapeRegExp(origin) + ORIGIN_BOUNDARY) : null;
};

// Origins of the MHub APIs this app calls, in registration order.
var tracedOrigins = [];

/**
 * The live allowlist handed to instrumentation-fetch/-xml-http-request.
 *
 * Deliberately one mutable array rather than a value computed once at init: `bookApiURL` is empty
 * until the login bootstrap resolves it per tenant (src/actions/auth.js), so the Showroom API
 * origin is simply not knowable when initTelemetry() runs. Both instrumentations re-read
 * getConfig().propagateTraceHeaderCorsUrls on every request, so appending to this array after
 * registration takes effect immediately.
 */
var propagateTraceHeaderCorsUrls = [];

/**
 * The live `ignoreUrls` handed to the same two instrumentations: one RegExp matching every URL
 * that is NOT under a traced origin. The browser makes CLIENT spans for our own APIs only —
 * third parties (Cognito, S3, Bugsnag, analytics, …) and static files are not traced at all, so
 * they cost no span and their URLs never reach the collector. Re-read per request like the
 * allowlist; rebuilt in place whenever an origin is registered. Nothing is traced until the first
 * origin is.
 */
var ignoreUrls = [/^/];

/**
 * Adds `url`'s origin to the traceparent allowlist (and so stops ignoring it). Safe to call
 * repeatedly and before initTelemetry(); a URL that does not parse is ignored.
 *
 * Returns true when a new origin was added, which is what the tests assert on.
 */
var registerTracePropagationOrigin = exports.registerTracePropagationOrigin = function registerTracePropagationOrigin(url) {
  if (!url) return false;
  var origin = originOf(url);
  if (!origin || tracedOrigins.indexOf(origin) !== -1) return false;

  tracedOrigins.push(origin);
  propagateTraceHeaderCorsUrls.push(toOriginRegExp(origin));
  ignoreUrls[0] = new RegExp('^(?!(?:' + tracedOrigins.map(escapeRegExp).join('|') + ')' + ORIGIN_BOUNDARY + ')');
  return true;
};

/** Whether `url` is under one of the API origins registered above. */
var isTracedUrl = exports.isTracedUrl = function isTracedUrl(url) {
  return tracedOrigins.indexOf(originOf(url)) !== -1;
};

// Exported for tests only — the array identities are what make the live lists work.
var getTracePropagationOrigins = exports.getTracePropagationOrigins = function getTracePropagationOrigins() {
  return propagateTraceHeaderCorsUrls;
};
var getIgnoredUrls = exports.getIgnoredUrls = function getIgnoredUrls() {
  return ignoreUrls;
};
var resetTracePropagationOrigins = exports.resetTracePropagationOrigins = function resetTracePropagationOrigins() {
  tracedOrigins.length = 0;
  propagateTraceHeaderCorsUrls.length = 0;
  ignoreUrls[0] = /^/;
};

// The authenticated caller, stamped on root spans by the SDK's EndUserSpanProcessor. Late-bound
// for the same reason the allowlist is: initTelemetry() runs before render, and nobody has logged
// in yet, so identity cannot be a resource attribute — resources are fixed at init.
var endUser = null;
// Bumped by every setEndUser / clearEndUser, so an ID-token read that resolves late cannot
// bring back a caller who has since logged out or been replaced.
var endUserGeneration = 0;
// Set once startTracing() has run. Until then identifyEndUser() reads no token: an untraced
// build, or a browser that fell back to untraced, makes no extra Cognito call.
var tracingStarted = false;

/** The ID token's `sub` claim, or null when there is no usable one. */
var tokenSubject = function tokenSubject(claims) {
  var sub = claims ? claims.sub : undefined;
  return typeof sub === 'string' && sub !== '' ? sub : null;
};

/**
 * Records who is using the app so a browser span is filterable by caller in SigNoz.
 *
 * `user.id` is the `sub` claim of the caller's Cognito ID token — the value mhub-book-api and
 * mhub-api put on their SERVER spans (OTEL-94: the verified ID token's sub), so a trace carries
 * one user.id from browser to database. It is never the Cognito username: for an SSO user that
 * is `<provider>_<email>` (Staffs/Overview.jsx relies on exactly that), which would put the
 * email on every span. Without a `sub` there is no user.id at all, not a substitute.
 *
 * `mhub.user_id` and `mhub.company_id` are numbers, matching the backend's AttrUserID.Int /
 * AttrCompanyID.Int, so one SigNoz query covers browser and API.
 *
 * Deliberately no email and no name. Every attribute here ships from the browser to the
 * collector on every span, so the rule for introducing one — bounded cardinality, no PII —
 * applies with full force. Note also that anything stamped here is client-controlled: it is
 * filter metadata, never an authorization input. The backend's own user.id is the
 * trustworthy one.
 *
 * Inert when tracing is disabled — nothing reads it.
 */
var setEndUser = exports.setEndUser = function setEndUser(payload, idTokenClaims) {
  if (!payload) return;
  endUserGeneration += 1;
  var attributes = {};

  var subject = tokenSubject(idTokenClaims);
  if (subject) {
    attributes['user.id'] = subject;
  }
  var userID = Number(payload.id);
  if (Number.isFinite(userID) && userID !== 0) {
    attributes['mhub.user_id'] = userID;
  }
  var companyID = Number(payload.affiliate && payload.affiliate.company ? payload.affiliate.company.id : undefined);
  if (Number.isFinite(companyID) && companyID !== 0) {
    attributes['mhub.company_id'] = companyID;
  }

  // An absent attribute and an empty one are different things in SigNoz, so a payload that
  // carries none of these leaves the spans unstamped rather than stamping blanks.
  endUser = Object.keys(attributes).length > 0 ? attributes : null;
};

/**
 * setEndUser for a login: the numeric ids at once, then user.id once the ID token is read.
 *
 * `readIdTokenClaims` returns (a promise of) the decoded Cognito ID token; auth.js passes
 * Amplify's currentSession(), the token fetchM sends to the APIs. It is only called while tracing
 * runs. If it fails, or the token has no `sub`, user.id stays unset. The returned promise settles
 * when that is decided — callers need not wait for it; tests do.
 */
var identifyEndUser = exports.identifyEndUser = function identifyEndUser(payload, readIdTokenClaims) {
  setEndUser(payload);
  if (!payload || !tracingStarted) return Promise.resolve();

  var generation = endUserGeneration;
  return Promise.resolve().then(readIdTokenClaims).then(function (claims) {
    // A logout or a newer login since the read began owns the caller now.
    if (generation === endUserGeneration) setEndUser(payload, claims);
  }).catch(function (e) {
    var reason = e && e.message ? e.message : e;
    console.warn('[telemetry] user.id unset: the ID token could not be read', reason);
  });
};

/** Clears the caller on logout, so the next session's spans cannot inherit the last user. */
var clearEndUser = exports.clearEndUser = function clearEndUser() {
  endUser = null;
  endUserGeneration += 1;
};

var getEndUser = exports.getEndUser = function getEndUser() {
  return endUser;
};

var DEFAULT_SAMPLER_RATIO = exports.DEFAULT_SAMPLER_RATIO = 1;

/**
 * Reads OTEL_TRACES_SAMPLER_ARG: the fraction of traces this browser starts that are recorded.
 *
 * Unset means 1 — every trace, the same default the Go tiers run with. Anything that is not a
 * number from 0 to 1 also means 1, with a warning, which is what the OpenTelemetry SDKs do with
 * a bad ratio: a typo in a build variable must not silently switch tracing off.
 */
var parseSamplerRatio = exports.parseSamplerRatio = function parseSamplerRatio(raw) {
  if (raw === undefined || raw === null || String(raw).trim() === '') return DEFAULT_SAMPLER_RATIO;
  var ratio = Number(raw);
  if (!Number.isFinite(ratio) || ratio < 0 || ratio > 1) {
    console.warn('[telemetry] OTEL_TRACES_SAMPLER_ARG "' + raw + '" is not a number from 0 to 1; ' + 'sampling every trace');
    return DEFAULT_SAMPLER_RATIO;
  }
  return ratio;
};

/**
 * Initialises browser tracing. Returns whether it started. Never throws — tracing must never be
 * able to take the app down (fail open).
 *
 * `routes` is the react-router route element; navigation spans are named from it.
 */
var initTelemetry = exports.initTelemetry = function initTelemetry(routes) {
  // The build-time gate. DefinePlugin inlines OTEL_EXPORTER_OTLP_ENDPOINT, so in a build without
  // an endpoint this test is the literal "" and webpack drops the whole block, require() included:
  // ./telemetrySdk.js, zone.js and the instrumentations are then not in the bundle at all. It has
  // to stay an inline `process.env.…` test — webpack only folds a constant it can see right here.
  if (true) {
    var endpoint = _config2.default.get('otelEndpoint');
    if (!endpoint) return false;

    try {
      // instrumentation-fetch reads TextEncoder while its module evaluates, so this check has to
      // come before the require below: an older browser stays on the untraced path rather than
      // failing to load the app.
      if (typeof TextEncoder === 'undefined' || typeof TextDecoder === 'undefined') {
        console.warn('[telemetry] tracing disabled: TextEncoder/TextDecoder unavailable');
        return false;
      }

      // The browser is the fan-out point: fetchM.js talks to mhub-api via apiURL and to
      // mhub-book-api via bookApiURL. Miss either and half the traces silently orphan.
      // bookApiURL is usually still empty here — auth.js registers it once login resolves it.
      registerTracePropagationOrigin(_config2.default.get('apiURL'));
      registerTracePropagationOrigin(_config2.default.get('bookApiURL'));

      // eslint-disable-next-line global-require

      var _require = __webpack_require__(2534),
          startTracing = _require.startTracing;

      startTracing({
        endpoint: endpoint,
        routes: routes,
        samplerRatio: parseSamplerRatio(_config2.default.get('otelSamplerRatio')),
        propagateTraceHeaderCorsUrls: propagateTraceHeaderCorsUrls,
        ignoreUrls: ignoreUrls,
        isTracedUrl: isTracedUrl,
        getEndUser: getEndUser
      });
      tracingStarted = true;
      return true;
    } catch (e) {
      // Fail open on ANY initialisation failure, not just the ones we can name. Both entrypoints
      // call this before render(), so an uncaught exception here is a blank application — and the
      // exporter does throw on configuration it dislikes: an endpoint with no scheme raises
      // "Could not parse user-provided export URL" synchronously. startTracing() registers
      // nothing before that throw, so there is no half-wired provider.
      console.warn('[telemetry] tracing disabled: initialisation failed', e);
      return false;
    }
  }
  return false;
};

exports.default = initTelemetry;

/***/ }),
/* 1082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStateAdfsProvider = undefined;

var _store = __webpack_require__(1083);

var getStateAdfsProvider = exports.getStateAdfsProvider = function getStateAdfsProvider() {
  return _store.store.getState().auth.adfsProvider;
};
_store.store.subscribe(getStateAdfsProvider);

/***/ }),
/* 1083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.history = exports.store = undefined;

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(13);

var _configureStore = __webpack_require__(2567);

var _configureStore2 = _interopRequireDefault(_configureStore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initialState = window.__INITIAL_STATE__; /* eslint no-underscore-dangle: 0 */

var store = exports.store = (0, _configureStore2.default)(initialState, _reactRouter.browserHistory);

var history = exports.history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PROJECT_FEE_PACKAGE_DEFAULT = {
  id: '',
  projectID: '',
  name: '',
  description: '',
  code: '',
  orderPriority: 0,
  isEnabled: true,
  scheduleStartAt: null,
  scheduleEndAt: null,
  formulas: [],
  businessUnitAccesses: [],
  createdAt: null,
  updatedAt: null
};

var PROJECT_FEE_PACKAGE_ITEM_DEFAULT = {
  id: '',
  projectFeePackageID: '',
  name: '',
  description: '',
  code: '',
  orderPriority: 0,
  isEnabled: true,
  category: 'list_price',
  formulaValue: '',
  newValue: 0,
  valueChange: 0,
  createdAt: null,
  updatedAt: null
};

var PROJECT_UNIT_PACKAGE_FEE_DEFAULT = {
  id: '',
  projectID: '',
  projectUnitID: '',
  projectFeePackageID: '',
  orderPriority: 0,
  totalPrice: 0,
  createdAt: null,
  updatedAt: null
};

exports.PROJECT_FEE_PACKAGE_DEFAULT = PROJECT_FEE_PACKAGE_DEFAULT;
exports.PROJECT_FEE_PACKAGE_ITEM_DEFAULT = PROJECT_FEE_PACKAGE_ITEM_DEFAULT;
exports.PROJECT_UNIT_PACKAGE_FEE_DEFAULT = PROJECT_UNIT_PACKAGE_FEE_DEFAULT;

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BOOKING_CUSTOMER_DEFAULT = {
  address1: '',
  address2: '',
  address3: '',
  address4: '',
  address5: '',
  address6: '',
  address7: '',
  address8: '',
  address9: '',
  address10: '',
  country: 'my',
  customerDetailID: null,
  customerID: null,
  customer: {
    icFrontDocumentID: '',
    icFrontDocument: null,
    icBackDocumentID: '',
    icBackDocument: null,
    specifications: [],
    taxIdentificationNo: '',
    taxTinValidationStatus: null,
    isForeignCompany: false
  },
  signAt: '',
  email: '',
  identity: '',
  identityTypeID: null,
  identityPresetID: '',
  identityPresetLabel: '',
  identityPresetRegex: '',
  prsID: '',
  mobile: '',
  mobilePrefix: '60',
  name: '',
  phone: '',
  phonePrefix: '60',
  preferredName: '',
  title: '',
  jobTitle: '',
  monthlyIncome: '',
  nationality: '',
  citizenship: '',
  gender: '',
  race: '',
  raceOther: '',
  bumi: 'Not Applicable',
  maritalStatus: '',
  relationshipType: '',
  birthdate: '',
  buyerProfileID: '',
  buyerICFront: '',
  buyerICBack: '',
  emergencyContactName: '',
  emergencyContactRelation: '',
  emergencyContactMobilePrefix: '60',
  emergencyContactMobile: '',
  emergencyContactEmail: '',
  emergencyContactIdentity: '',
  externalID: '',
  originCustomerID: ''
};
exports.default = BOOKING_CUSTOMER_DEFAULT;

/***/ }),
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNLOAD_SIGNAL_WINDOW_MS = exports.NETWORK_EVENT_WINDOW_MS = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // MS-6583: gate network-level fetch failures before they reach Bugsnag.
//
// One underlying event — a full-page navigation (the MS-6466 takeover hand-off, a
// redirectToLogin, the min-version reload, the user leaving) aborting the page's in-flight
// fetches, or a flaky connection dropping them — used to cost 2-3 Bugsnag events, because
// every container's catch notifies its own rejection and the two call styles split into two
// error groups (the raw TypeError "Failed to fetch" vs execServerRequest's Error-wrapped
// copy). ~1,200 events/day, none of them actionable: the failing request never names itself
// (no URL survives into the error), and the user is either already navigating away or
// already offline.
//
// This is ONE chokepoint rather than 300 catch-site edits — and it must be a wrapper around
// Bugsnag.notifyException, NOT a beforeNotify hook: the vendored v3.0.6 notifier spends its
// 10-events-per-page allowance BEFORE beforeNotify runs (`O-=1` at the top of A()), so a
// cancelled burst would still mute every later, actionable error on that page. The wrapper
// drops noise before the notifier sees it, leaving the allowance intact. Everything that is
// not a network-level failure passes through untouched. A network failure is dropped when
// the page can explain it (hand-off navigation, unload, hidden tab, offline) and
// rate-limited to one annotated event per window otherwise — so a real outage
// (CORS/DNS/deploy breakage) still surfaces, once, with the context needed to read it.
//
// The allowed event carries what the dropped ones cannot: a per-reason count of the noise
// suppressed since the last one, and — when fetchM attached them (networkDiagnostics.js) —
// the failing request's URL and the page state at the moment it died. That is how the
// unexplained share of MS-6583 gets attributed without a single extra event.


exports.isNetworkFailureMessage = isNetworkFailureMessage;
exports.hasNetworkDiagnostics = hasNetworkDiagnostics;
exports.decideNetworkNoise = decideNetworkNoise;
exports.installBugsnagNetworkNoiseFilter = installBugsnagNetworkNoiseFilter;
exports.resetNetworkNoiseStateForTests = resetNetworkNoiseStateForTests;

var _session = __webpack_require__(404);

// EXACT network-level rejection messages, by source: Chrome "Failed to fetch", Firefox
// "NetworkError when attempting to fetch resource.", Safari "Load failed", and the
// whatwg-fetch polyfill's "Network request failed" (active wherever native fetch is absent —
// book.html deletes window.fetch on Edge). An optional single "TypeError: " prefix covers
// the legacy execServerRequest wrapping still in old bundles. Anchored on purpose: a
// substring match would swallow real errors that merely contain "load failed".
var NETWORK_MESSAGE_RE = /^(?:typeerror:\s*)?(?:failed to fetch|networkerror when attempting to fetch resource\.?|load failed|network request failed)$/i;

// One annotated event per window keeps the canary for a genuine outage without the burst:
// a dead backend fails every page load, so one event per window per user is still a clear
// daily signal in Bugsnag, while a single wifi blip stops costing three events.
var NETWORK_EVENT_WINDOW_MS = exports.NETWORK_EVENT_WINDOW_MS = 10 * 60 * 1000;

// beforeunload fires when a navigation STARTS — and the navigation can then be cancelled by
// an unsaved-changes prompt, with no pagehide/pageshow to say so. The signal is therefore
// time-boxed (same lesson as session.js's hand-off flash window): long enough to cover a
// slow navigation's fetch teardown, short enough that a surviving page resumes reporting.
var UNLOAD_SIGNAL_WINDOW_MS = exports.UNLOAD_SIGNAL_WINDOW_MS = 10 * 1000;

var emptyReasons = function emptyReasons() {
  return {
    handoff: 0,
    unloading: 0,
    hidden: 0,
    offline: 0,
    window: 0
  };
};

var unloadSignalAt = 0;
var lastSentAt = 0;
var suppressedSinceLastSent = 0;
var suppressedByReason = emptyReasons();

function isNetworkFailureMessage(message) {
  return NETWORK_MESSAGE_RE.test(String(message || '').trim());
}

// The first explanation wins; the order is the order of certainty (a hand-off in progress
// explains everything, an offline flag is the weakest).
function explainedBy(env) {
  if (env.handoff) return 'handoff';
  if (env.unloading) return 'unloading';
  if (env.visibility === 'hidden') return 'hidden';
  if (env.online === false) return 'offline';
  return null;
}

// fetchM attaches its diagnostics to every fetch() rejection BEFORE the caller's catch runs —
// and some catches (actions/error.js handleError) rewrite err.message to a generic
// "An error occurred" before notifying. The message no longer says "network", but the
// object still does; without this, that whole path would bypass the filter unannotated.
// Only a rejection whose ORIGINAL message was network-shaped counts (networkFailure, decided
// at attach time): fetch() also rejects for a bad request option or an abort, and those are
// real errors that must reach Bugsnag whatever a catch renamed them to.
function hasNetworkDiagnostics(exception) {
  return !!(exception && (typeof exception === 'undefined' ? 'undefined' : _typeof(exception)) === 'object' && exception.mhubNetwork && _typeof(exception.mhubNetwork) === 'object' && exception.mhubNetwork.networkFailure === true);
}

// Pure decision core, exported for tests. `env` carries the browser facts so tests need no
// jsdom fixture: { handoff, unloading, visibility, online, now }. `diagnosed` says fetchM
// already identified the rejection as a network-level failure (see hasNetworkDiagnostics).
// Returns { action: 'pass' } (not network-shaped: send untouched),
//         { action: 'drop' } (explained or inside the rate window),
//         { action: 'send', network } (the one allowed event, with its annotation).
function decideNetworkNoise(message, env, diagnosed) {
  if (!isNetworkFailureMessage(message) && !diagnosed) {
    return { action: 'pass' };
  }
  // The page can explain the failure — there is nothing to report, but the reason is counted
  // so the next allowed event can say how the silence was spent.
  var explained = explainedBy(env);
  if (explained) {
    suppressedSinceLastSent += 1;
    suppressedByReason[explained] += 1;
    return { action: 'drop' };
  }
  if (env.now - lastSentAt < NETWORK_EVENT_WINDOW_MS) {
    suppressedSinceLastSent += 1;
    suppressedByReason.window += 1;
    return { action: 'drop' };
  }
  lastSentAt = env.now;
  var network = {
    online: env.online,
    visibility: env.visibility,
    suppressedSinceLastSent: suppressedSinceLastSent,
    suppressedByReason: suppressedByReason
  };
  suppressedSinceLastSent = 0;
  suppressedByReason = emptyReasons();
  return { action: 'send', network: network };
}

function installBugsnagNetworkNoiseFilter(win) {
  var w = win || window;
  var bugsnag = w.Bugsnag;
  if (!bugsnag || typeof bugsnag.notifyException !== 'function') {
    return; // notifier script blocked/absent — nothing to filter
  }
  if (bugsnag.notifyException.networkNoiseFiltered) {
    return; // hot reload re-runs the entry — never double-wrap
  }
  w.addEventListener('beforeunload', function () {
    unloadSignalAt = Date.now();
  }, false);
  w.addEventListener('pagehide', function () {
    unloadSignalAt = Date.now();
  }, false);
  // bfcache restore: the page is live again and its failures are reportable again.
  w.addEventListener('pageshow', function () {
    unloadSignalAt = 0;
  }, false);

  var original = bugsnag.notifyException;
  var wrapped = function notifyExceptionFiltered(exception, name, metaData, severity) {
    // v3 signature juggling, mirrored from the notifier: a non-string second argument is
    // the metaData. A string exception delegates to Bugsnag.notify internally — its
    // .message read below is undefined, so it passes through untouched either way.
    var realName = name;
    var realMetaData = metaData;
    if (realName && typeof realName !== 'string') {
      realMetaData = realName;
      realName = undefined;
    }
    var message = exception && (typeof exception === 'undefined' ? 'undefined' : _typeof(exception)) === 'object' ? exception.message || exception.description : exception;
    var now = Date.now();
    var verdict = decideNetworkNoise(message, {
      handoff: (0, _session.isSessionHandoffInProgress)(),
      unloading: unloadSignalAt !== 0 && now - unloadSignalAt < UNLOAD_SIGNAL_WINDOW_MS,
      visibility: w.document && w.document.visibilityState,
      online: w.navigator && w.navigator.onLine,
      now: now
    }, hasNetworkDiagnostics(exception));
    if (verdict.action === 'drop') {
      return undefined;
    }
    if (verdict.action === 'send') {
      var annotated = realMetaData || {};
      annotated.network = verdict.network;
      if (exception && exception.mhubNetwork && _typeof(exception.mhubNetwork) === 'object') {
        // fetchM's diagnostics: the request's URL and the page state when it died.
        Object.assign(annotated.network, exception.mhubNetwork);
      }
      return original.call(bugsnag, exception, realName, annotated, severity);
    }
    return original.call(bugsnag, exception, name, metaData, severity);
  };
  wrapped.networkNoiseFiltered = true;
  bugsnag.notifyException = wrapped;
}

function resetNetworkNoiseStateForTests() {
  unloadSignalAt = 0;
  lastSentAt = 0;
  suppressedSinceLastSent = 0;
  suppressedByReason = emptyReasons();
}

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fromCalendarTile = fromCalendarTile;
exports.toCalendarTile = toCalendarTile;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * react-calendar only speaks browser-local `Date`: its tiles are built as
 * `new Date(year, monthIndex, day)` and its `onChange` hands that same value back.
 * The app, meanwhile, runs every `moment()` in the zone baked into the build —
 * `moment.tz.setDefault(config.get('tzName'))` in `containers/Root.jsx`.
 *
 * Those two zones are independent. Reading a tile's instant through moment
 * (`moment(jsDate)`) therefore reinterprets browser-midnight in the app zone, and when
 * the app zone is behind the browser's it lands on the previous calendar day — clicking
 * the 19th stored the 18th on a +07 build viewed from a +08 machine (CPI-1248 follow-up).
 *
 * These two helpers are mirror images that convert by calendar *fields* rather than by
 * instant, so a tile always means the same calendar day on both sides of the boundary.
 */

/**
 * Turn the browser-local `Date` from react-calendar's `onChange` into a moment on that
 * same calendar day in the app's zone, carrying over the time of day from `timeSource`
 * (the value being edited) so picking a date never silently resets the clock. The optional
 * browser-timezone mode is for inputs that deliberately show a viewer's local time.
 */
function fromCalendarTile(jsDate, timeSource) {
  var useBrowserTimezone = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var date = jsDate instanceof Date && !Number.isNaN(jsDate.getTime()) ? jsDate : new Date();
  var sourceTime = timeSource ? (0, _momentTimezone2.default)(timeSource) : (0, _momentTimezone2.default)();
  var time = useBrowserTimezone ? sourceTime.local() : sourceTime;
  var calendarTime = useBrowserTimezone ? (0, _momentTimezone2.default)().local() : (0, _momentTimezone2.default)();
  return calendarTime.set({
    year: date.getFullYear(),
    month: date.getMonth(),
    date: date.getDate(),
    hour: time.hour(),
    minute: time.minute(),
    second: 0,
    millisecond: 0
  });
}

/**
 * The inverse: express an app-zone value as the browser-local midnight react-calendar
 * expects for its `value`, `minDate` and `maxDate` props. Without this the highlighted
 * tile drifts whenever the app zone is *ahead* of the browser's. Browser-timezone inputs
 * use the viewer's local calendar fields instead of the app's configured fields.
 */
function toCalendarTile(value) {
  var useBrowserTimezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var m = useBrowserTimezone ? (0, _momentTimezone2.default)(value).local() : (0, _momentTimezone2.default)(value);
  if (!m.isValid()) {
    return undefined;
  }
  return new Date(m.year(), m.month(), m.date());
}

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var STATUSES = exports.STATUSES = [{ text: 'Updating', value: 'in_progress' }, { text: 'Completed', value: 'completed' }, { text: 'Failed', value: 'failed' }];

var progressToPercent = exports.progressToPercent = function progressToPercent(balanceCount, totalCount) {
  var percent = totalCount === 0 ? 100 : 0;
  if (balanceCount > 0 && totalCount > 0) {
    percent = Math.trunc(balanceCount / totalCount * 100);
  }
  return percent;
};

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.decimalIsEqual = exports.decimalPercentageOutOfAmount = exports.decimalDiv = exports.decimalMul = exports.decimalSub = exports.decimalSum = undefined;

var _decimal = __webpack_require__(1157);

var _decimal2 = _interopRequireDefault(_decimal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var decimalSum = exports.decimalSum = function decimalSum(number1, number2) {
  return new _decimal2.default(number1).plus(number2).toNumber();
}; /* eslint-disable max-len */
var decimalSub = exports.decimalSub = function decimalSub(number1, number2) {
  return new _decimal2.default(number1).sub(number2).toNumber();
};

var decimalMul = exports.decimalMul = function decimalMul(number1, number2) {
  return new _decimal2.default(number1).mul(number2).toNumber();
};

var decimalDiv = exports.decimalDiv = function decimalDiv(number1, number2) {
  return new _decimal2.default(number1).div(number2).toNumber();
};

var decimalPercentageOutOfAmount = exports.decimalPercentageOutOfAmount = function decimalPercentageOutOfAmount(number1, number2) {
  return new _decimal2.default(number1).div(number2).mul(100).toNumber();
};

var decimalIsEqual = exports.decimalIsEqual = function decimalIsEqual(number1, number2) {
  return new _decimal2.default(number1).equals(number2);
};

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchWithCacheSWR = exports.FetchError = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var fetchAndCache = function () {
  var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(store, url, options, key, cacheType) {
    var res, data, contentType, bodyStr, size;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return store.dispatch((0, _fetchM.fetchM)(url, options));

          case 2:
            res = _context.sent;
            data = null;
            _context.prev = 4;
            contentType = res.headers && res.headers.get && res.headers.get('content-type') || '';

            if (!contentType.includes('application/json')) {
              _context.next = 12;
              break;
            }

            _context.next = 9;
            return res.clone().json();

          case 9:
            data = _context.sent;
            _context.next = 15;
            break;

          case 12:
            _context.next = 14;
            return res.clone().text();

          case 14:
            data = _context.sent;

          case 15:
            _context.next = 19;
            break;

          case 17:
            _context.prev = 17;
            _context.t0 = _context['catch'](4);

          case 19:
            if (res.ok) {
              _context.next = 21;
              break;
            }

            throw new FetchError(res, data);

          case 21:

            // Cache with size estimate
            bodyStr = typeof data === 'string' ? data : JSON.stringify(data);
            size = bodyStr ? bodyStr.length : 0;

            // Memory cache

            if (cacheType === 'memory' || cacheType === 'both') {
              apiCache[key] = {
                res: res.clone(),
                timestamp: Date.now(),
                size: size
              };
            }

            // LocalStorage cache
            if (cacheType === 'localStorage' || cacheType === 'both') {
              saveToLocalStorage(key, {
                body: bodyStr,
                status: res.status,
                statusText: res.statusText,
                headers: Object.fromEntries(res.headers.entries()),
                timestamp: Date.now(),
                size: size
              });
            }

            return _context.abrupt('return', res);

          case 26:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[4, 17]]);
  }));

  return function fetchAndCache(_x5, _x6, _x7, _x8, _x9) {
    return _ref8.apply(this, arguments);
  };
}();

var refreshCache = function () {
  var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(store, url, options, key, cacheType) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!shouldRefreshFlags.has(key)) {
              _context2.next = 2;
              break;
            }

            return _context2.abrupt('return');

          case 2:
            // skip duplicate refresh
            shouldRefreshFlags.add(key);

            _context2.prev = 3;
            _context2.next = 6;
            return fetchAndCache(store, url, options, key, cacheType);

          case 6:
            _context2.next = 11;
            break;

          case 8:
            _context2.prev = 8;
            _context2.t0 = _context2['catch'](3);

            console.error('Background refresh failed', _context2.t0);

          case 11:
            _context2.prev = 11;

            shouldRefreshFlags.delete(key);
            return _context2.finish(11);

          case 14:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this, [[3, 8, 11, 14]]);
  }));

  return function refreshCache(_x10, _x11, _x12, _x13, _x14) {
    return _ref9.apply(this, arguments);
  };
}();

/**
 * Fetch data with cache + SWR (stale-while-revalidate).
 * Modes:
 *   - "ttl"    : Use cache if fresh, else refresh in background (SWR).
 *   - "always" : Always fetch fresh, no cache at all.
 * Cache types:
 *   - "memory"       : (default) only in-memory
 *   - "localStorage" : only localStorage
 *   - "both"         : memory + localStorage
 */


var fetchWithCacheSWR = exports.fetchWithCacheSWR = function () {
  var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(store, url) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var ttl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 30000;
    var cacheKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var mode = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'ttl';
    var cacheType = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'memory';
    var normalizedUrl, key, now, cached, lsCache, res, data, isExpired;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            // getCacheStats(ttl, cacheType);
            cleanupCache(ttl, cacheType);

            normalizedUrl = normalizeUrl(url);
            key = cacheKey || normalizedUrl;
            now = Date.now();

            // check in-memory first (if enabled)

            cached = cacheType === 'memory' || cacheType === 'both' ? apiCache[key] : null;

            // if not in memory, try localStorage

            if (!cached && (cacheType === 'localStorage' || cacheType === 'both')) {
              lsCache = loadFromLocalStorage(key);

              if (lsCache) {
                cached = lsCache;
                if (cacheType === 'both') {
                  apiCache[key] = lsCache;
                }
              }
            }

            if (!(mode === 'always')) {
              _context3.next = 22;
              break;
            }

            _context3.next = 9;
            return store.dispatch((0, _fetchM.fetchM)(url, options));

          case 9:
            res = _context3.sent;
            data = null;
            _context3.prev = 11;
            _context3.next = 14;
            return res.clone().json();

          case 14:
            data = _context3.sent;
            _context3.next = 19;
            break;

          case 17:
            _context3.prev = 17;
            _context3.t0 = _context3['catch'](11);

          case 19:
            if (res.ok) {
              _context3.next = 21;
              break;
            }

            throw new FetchError(res, data);

          case 21:
            return _context3.abrupt('return', res);

          case 22:
            if (!cached) {
              _context3.next = 28;
              break;
            }

            isExpired = now - cached.timestamp > ttl;

            if (isExpired) {
              _context3.next = 26;
              break;
            }

            return _context3.abrupt('return', cached.res.clone());

          case 26:
            refreshCache(store, url, options, key, cacheType);
            return _context3.abrupt('return', cached.res.clone());

          case 28:
            return _context3.abrupt('return', fetchAndCache(store, url, options, key, cacheType));

          case 29:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this, [[11, 17]]);
  }));

  return function fetchWithCacheSWR(_x15, _x16) {
    return _ref10.apply(this, arguments);
  };
}();

exports.clearAllCache = clearAllCache;
exports.getCacheStats = getCacheStats;

var _fetchM = __webpack_require__(6);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-empty */
/* eslint-disable max-len */


// In-memory cache
var apiCache = {};
var LS_PREFIX = 'apiCache:'; // prefix for localStorage keys

// Custom error for API failures

var FetchError = exports.FetchError = function (_Error) {
  _inherits(FetchError, _Error);

  function FetchError(res) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, FetchError);

    var _this = _possibleConstructorReturn(this, (FetchError.__proto__ || Object.getPrototypeOf(FetchError)).call(this, 'Request failed: ' + res.status + ' ' + res.statusText));

    _this.name = 'FetchError';
    _this.res = res;
    _this.data = data;
    return _this;
  }

  return FetchError;
}(Error);

// Helpers for localStorage cache


function saveToLocalStorage(key, _ref) {
  var body = _ref.body,
      status = _ref.status,
      statusText = _ref.statusText,
      headers = _ref.headers,
      timestamp = _ref.timestamp,
      size = _ref.size;

  try {
    localStorage.setItem(LS_PREFIX + key, JSON.stringify({ body: body, status: status, statusText: statusText, headers: headers, timestamp: timestamp, size: size }));
  } catch (err) {
    console.warn('LocalStorage save failed', err);
  }
}

function loadFromLocalStorage(key) {
  try {
    var raw = localStorage.getItem(LS_PREFIX + key);
    if (!raw) return null;
    var parsed = JSON.parse(raw);

    // reconstruct Response
    var res = new Response(parsed.body, {
      status: parsed.status,
      statusText: parsed.statusText,
      headers: parsed.headers
    });

    return {
      res: res,
      timestamp: parsed.timestamp,
      size: parsed.size
    };
  } catch (err) {
    console.warn('LocalStorage load failed', err);
    return null;
  }
}

function removeFromLocalStorage(key) {
  try {
    localStorage.removeItem(LS_PREFIX + key);
  } catch (err) {
    console.warn('LocalStorage remove failed', err);
  }
}

// Cache utilities
function cleanupCache(ttl) {
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'both';

  var now = Date.now();

  // Memory cleanup
  if (source === 'both' || source === 'memory') {
    Object.keys(apiCache).forEach(function (key) {
      if (now - apiCache[key].timestamp > ttl) {
        delete apiCache[key];
        if (source === 'both') removeFromLocalStorage(key); // sync delete
      }
    });
  }

  // LocalStorage cleanup
  if (source === 'both' || source === 'localStorage') {
    for (var i = localStorage.length - 1; i >= 0; i -= 1) {
      var k = localStorage.key(i);
      if (k && k.startsWith(LS_PREFIX)) {
        try {
          var key = k.slice(LS_PREFIX.length);
          var value = localStorage.getItem(k);
          if (!value) {
            localStorage.removeItem(k);
          } else {
            var parsed = JSON.parse(value);
            if (parsed && now - parsed.timestamp > ttl) {
              localStorage.removeItem(k);
              if (source === 'both') delete apiCache[key]; // sync delete
            }
          }
        } catch (err) {
          localStorage.removeItem(k);
        }
      }
    }
  }
}

function clearAllCache() {
  Object.keys(apiCache).forEach(function (key) {
    return delete apiCache[key];
  });
  for (var i = localStorage.length - 1; i >= 0; i -= 1) {
    var k = localStorage.key(i);
    if (k && k.startsWith(LS_PREFIX)) {
      localStorage.removeItem(k);
    }
  }
}

function getCacheStats() {
  var ttl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30000;
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'both';

  var now = Date.now();
  var stats = [];

  // Memory cache stats
  if (source === 'both' || source === 'memory') {
    var memStats = Object.entries(apiCache).map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          _ref3$ = _ref3[1],
          timestamp = _ref3$.timestamp,
          size = _ref3$.size,
          res = _ref3$.res;

      var ageMs = now - timestamp;
      return {
        key: key,
        source: 'memory',
        ageMs: ageMs,
        ageSec: (ageMs / 1000).toFixed(1),
        expired: ageMs > ttl,
        fromCache: true,
        isStale: ageMs > ttl,
        status: res && res.status || 'N/A',
        size: size
      };
    });
    stats = stats.concat(memStats);
  }

  // LocalStorage cache stats
  if (source === 'both' || source === 'localStorage') {
    var lsStats = Object.keys(localStorage).filter(function (k) {
      return k.startsWith(LS_PREFIX);
    }).map(function (k) {
      try {
        var key = k.replace(LS_PREFIX, '');
        var parsed = JSON.parse(localStorage.getItem(k));
        var ageMs = now - parsed.timestamp;
        return {
          key: key,
          source: 'localStorage',
          ageMs: ageMs,
          ageSec: (ageMs / 1000).toFixed(1),
          expired: ageMs > ttl,
          fromCache: true,
          isStale: ageMs > ttl,
          status: parsed.status || 'N/A',
          size: parsed.size || (parsed.body ? parsed.body.length : 0)
        };
      } catch (err) {
        return null;
      }
    }).filter(Boolean);

    stats = stats.concat(lsStats);
  }

  if (stats.length > 0) {
    console.table(stats);
  } else {
    console.log('Cache is empty (' + source + ')');
  }
  return stats;
}

function normalizeUrl(url) {
  try {
    var u = new URL(url, window.location.origin);
    if (!u.search) return u.toString();

    var params = new URLSearchParams(u.search);
    var sorted = [].concat(_toConsumableArray(params.entries())).sort(function (_ref4, _ref5) {
      var _ref7 = _slicedToArray(_ref4, 1),
          a = _ref7[0];

      var _ref6 = _slicedToArray(_ref5, 1),
          b = _ref6[0];

      return a.localeCompare(b);
    });
    u.search = new URLSearchParams(sorted).toString();

    return u.toString();
  } catch (err) {
    return url;
  }
}

var shouldRefreshFlags = new Set();

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var resetDataChanges = exports.resetDataChanges = function resetDataChanges() {
  var originData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var resetData = {};
  Object.keys(defaultObj).forEach(function (e) {
    resetData[e] = originData[e] || '';
  });
  return resetData;
};

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.languageOptions = languageOptions;
// Keep a carried display value visible, but do not offer a disallowed save.
function languageOptions(options, configured, current) {
  var allowed = Array.isArray(configured) ? configured.map(function (code) {
    return String(code).trim().toLowerCase();
  }) : [];
  return options.filter(function (option) {
    return !allowed.length || option.value === 'en' || allowed.includes(option.value) || option.value === current;
  }).map(function (option) {
    return _extends({}, option, { disabled: !!allowed.length && option.value !== 'en' && !allowed.includes(option.value) });
  });
}

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.refreshUserCache = undefined;

// Cache maintenance must not keep a successfully saved language control disabled.
var refreshUserCache = exports.refreshUserCache = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var timer, response;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            timer = void 0;
            _context.prev = 1;
            _context.next = 4;
            return Promise.race([fetch(_config2.default.get('bookApiURL') + '/refresh_user/', { method: 'POST', credentials: 'include' }), new Promise(function (resolve, reject) {
              timer = setTimeout(function () {
                return reject(new Error('User cache refresh timed out'));
              }, 5000);
            })]);

          case 4:
            response = _context.sent;

            if (response.ok) {
              _context.next = 7;
              break;
            }

            throw new Error('User cache refresh failed (' + response.status + ')');

          case 7:
            _context.prev = 7;
            clearTimeout(timer);return _context.finish(7);

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[1,, 7, 10]]);
  }));

  return function refreshUserCache() {
    return _ref.apply(this, arguments);
  };
}();

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shareUnitCopyFormat = shareUnitCopyFormat;
exports.shareUnitToWSFormat = shareUnitToWSFormat;
exports.shareUnitMorCalcCopyFormat = shareUnitMorCalcCopyFormat;

var _jsCookie = __webpack_require__(247);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _numeral = __webpack_require__(681);

var _numeral2 = _interopRequireDefault(_numeral);

var _amount = __webpack_require__(87);

var _propertyCategories = __webpack_require__(323);

var _areaLabel = __webpack_require__(223);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getAreaText(user) {
  var countryCode = user && user.company && user.company.countryCode;
  return (0, _areaLabel.isVietnamCountryCode)(countryCode) ? 'Net Floor Area' : 'Build Up Area';
} /* eslint-disable no-nested-ternary */
/* eslint-disable max-len */


function checkSizeSuffix(suffix, user) {
  switch (suffix) {
    case 'square_metres':
      return (0, _areaLabel.isVietnamCountryCode)(user && user.company && user.company.countryCode) ? ' m²' : ' sqm';
    case 'square_feet':
      return ' sqft';
    default:
      return '';
  }
}

function formatAmount() {
  var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '-';
  var format = arguments[1];

  var loan = void 0;
  if (amount === '-') {
    return 'N/A';
  }
  if (format) {
    loan = (0, _numeral2.default)(amount).format(format);
  } else {
    loan = amount * 1 >= 1000000 && amount * 1 < 100000000 ? (0, _numeral2.default)(amount).format('0.0a') : (0, _numeral2.default)(amount).format('0a');
  }
  return loan;
}

function fAmount() {
  var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

  var currency = 'RM';
  var cookieCurrency = _jsCookie2.default.get('currency');
  if (cookieCurrency) currency = cookieCurrency;
  var format = '000,000,000.00';
  if (amount < 100) format = '0.00';
  if (amount < 100000) format = '0,000.00';
  return currency + ' ' + formatAmount(amount, format);
}

function getInitialBookingPackagePrice(packagePricing) {
  var calculatedPackagePricings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var calculatedPackagePricing = calculatedPackagePricings.find(function (p) {
    return p.id === packagePricing.id;
  });
  var calculations = calculatedPackagePricing && !calculatedPackagePricing.isCustomPrice && calculatedPackagePricing.projectPackagePricing && calculatedPackagePricing.projectPackagePricing.packagePricingCalculations;
  var applicableCalculations = calculations && calculations.filter(function (calculation) {
    return calculation.applyToBooking && (!calculation.projectPackagePricingItem || calculation.projectPackagePricingItem.isEnabled);
  });

  if (applicableCalculations && applicableCalculations.length > 0) {
    return applicableCalculations[applicableCalculations.length - 1].newValue;
  }
  if (calculations) return packagePricing.spaPrice;
  return packagePricing.totalPrice;
}

function shareUnitCopyFormat(unit, user) {
  var calculatedPackagePricings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var currency = 'RM';
  var cookieCurrency = _jsCookie2.default.get('currency');
  if (cookieCurrency) currency = cookieCurrency;
  var fullText = '';
  if (!unit) return fullText;
  var areaText = getAreaText(user);
  var unitInfo = 'Unit Information\n';
  unitInfo += '' + (unit.project && unit.project.name ? '\u2022 Project Name: ' + unit.project.name + '\n' : '');
  unitInfo += '' + (unit.reference ? '\u2022 Unit Number: ' + unit.reference + '\n' : '');
  unitInfo += '' + (unit.projectUnitLayout && unit.projectUnitLayout.name ? '\u2022 Layout Type: ' + unit.projectUnitLayout.name + '\n' : '');
  unitInfo += '' + (unit.size ? '\u2022 ' + areaText + ': ' + parseFloat(unit.size) + checkSizeSuffix(unit.project.sizeSuffix, user) + '\n' : '');
  unitInfo += '' + (unit.landArea ? '\u2022 LandArea: ' + unit.landArea + '\n' : '');
  unitInfo += '' + (unit.streetNumberOrLevel ? '\u2022 ' + (unit.project.propertyCategory.category === _propertyCategories.PROPERTY_CATEGORY_HIGH_RISE ? 'Level:' : 'Street Number:') + ' ' + unit.streetNumberOrLevel + '\n' : '');
  unitInfo += '' + (unit.zoneOrBlock ? '\u2022 ' + (unit.project.propertyCategory.category === _propertyCategories.PROPERTY_CATEGORY_HIGH_RISE ? 'Block:' : 'Zone:') + ' ' + unit.zoneOrBlock + '\n' : '');
  unitInfo += '' + (unit.streetOrFacing ? '\u2022 ' + (unit.project.propertyCategory.category === _propertyCategories.PROPERTY_CATEGORY_HIGH_RISE ? 'Facing:' : 'Street:') + ' ' + unit.streetOrFacing + '\n' : '');
  unitInfo += '' + (unit.spaValue ? '\u2022 Selling Price: ' + currency + ' ' + (0, _amount.spaFullString)(unit, '000,000,000.00') + '\n' : '');
  fullText += unitInfo;
  if (unit.projectUnitLayout && unit.projectUnitLayout.specifications && unit.projectUnitLayout.specifications.length > 0) {
    var layoutType = '\nLayout Type\n';
    unit.projectUnitLayout.specifications.forEach(function (s, i) {
      if (i + 1 > 3) return;
      layoutType += '\u2022 ' + s.name + ': ' + s.value + '\n';
    });
    fullText += layoutType;
  }
  if (unit.specifications && unit.specifications.length > 0) {
    var unitSpecs = '\nUnit Specifications \n';
    unit.specifications.forEach(function (s) {
      unitSpecs += '\u2022 ' + s.name + ': ' + s.value + '\n';
    });
    fullText += unitSpecs;
  }
  if (unit.spaValue && unit.projectUnitPackagePricings && unit.projectUnitPackagePricings.length > 0) {
    var unitPricing = '\nUnit Pricing Packages \n';
    unit.projectUnitPackagePricings.forEach(function (pp, id) {
      if (id > 0) unitPricing += '\n';
      unitPricing += id + 1 + ') ' + (pp.projectPackagePricing && pp.projectPackagePricing.name ? pp.projectPackagePricing.name : pp.customName) + '\n';
      unitPricing += '' + (pp.projectPackagePricing && pp.projectPackagePricing.description ? pp.projectPackagePricing.description + '\n' : pp.customDescription ? pp.customDescription + '\n' : '');
      unitPricing += currency + ' ' + formatAmount(getInitialBookingPackagePrice(pp, calculatedPackagePricings), '000,000,000.00') + '\n';
    });
    fullText += unitPricing;
  }
  if (user && user.preferredName && user.company && user.company.name) {
    fullText += '\nShared by ' + user.preferredName + '\n';
    fullText += 'Generated by MHub on behalf of ' + user.company.name + '\n';
  }
  return fullText;
}

function shareUnitToWSFormat(unit, user) {
  var calculatedPackagePricings = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  var currency = 'RM';
  var cookieCurrency = _jsCookie2.default.get('currency');
  if (cookieCurrency) currency = cookieCurrency;
  var fullText = '';
  if (!unit) return fullText;
  var areaText = getAreaText(user);
  var unitInfo = '🏠 _Unit Information_ \n';
  unitInfo += '' + (unit.project && unit.project.name ? '\u2022 *Project Name:* ' + unit.project.name + '\n' : '');
  unitInfo += '' + (unit.reference ? '\u2022 *Unit Number:* ' + unit.reference + '\n' : '');
  unitInfo += '' + (unit.projectUnitLayout && unit.projectUnitLayout.name ? '\u2022 *Layout Type:* ' + unit.projectUnitLayout.name + '\n' : '');
  unitInfo += '' + (unit.size ? '\u2022 *' + areaText + ':* ' + parseFloat(unit.size) + checkSizeSuffix(unit.project.sizeSuffix, user) + '\n' : '');
  unitInfo += '' + (unit.landArea ? '\u2022 *LandArea:* ' + unit.landArea + '\n' : '');
  unitInfo += '' + (unit.streetNumberOrLevel ? '\u2022 *' + (unit.project.propertyCategory.category === _propertyCategories.PROPERTY_CATEGORY_HIGH_RISE ? 'Level:' : 'Street Number:') + '* ' + unit.streetNumberOrLevel + '\n' : '');
  unitInfo += '' + (unit.zoneOrBlock ? '\u2022 *' + (unit.project.propertyCategory.category === _propertyCategories.PROPERTY_CATEGORY_HIGH_RISE ? 'Block:' : 'Zone:') + '* ' + unit.zoneOrBlock + '\n' : '');
  unitInfo += '' + (unit.streetOrFacing ? '\u2022 *' + (unit.project.propertyCategory.category === _propertyCategories.PROPERTY_CATEGORY_HIGH_RISE ? 'Facing:' : 'Street:') + '* ' + unit.streetOrFacing + '\n' : '');
  unitInfo += '' + (unit.spaValue ? '\u2022 *Selling Price:* ' + currency + ' ' + (0, _amount.spaFullString)(unit, '000,000,000.00') + '\n' : '');
  fullText += unitInfo;
  if (unit.projectUnitLayout && unit.projectUnitLayout.specifications && unit.projectUnitLayout.specifications.length > 0) {
    var layoutType = '\n🚪 _Layout Type_ \n';
    unit.projectUnitLayout.specifications.forEach(function (s, i) {
      if (i + 1 > 3) return;
      layoutType += '\u2022 *' + s.name + ':* ' + s.value + '\n';
    });
    fullText += layoutType;
  }
  if (unit.specifications && unit.specifications.length > 0) {
    var unitSpecs = '\n🗒️ _Unit Specifications_ \n';
    unit.specifications.forEach(function (s) {
      unitSpecs += '\u2022 *' + s.name + ':* ' + s.value + '\n';
    });
    fullText += unitSpecs;
  }
  if (unit.spaValue && unit.projectUnitPackagePricings && unit.projectUnitPackagePricings.length > 0) {
    var unitPricing = '\n⭐ _Unit Pricing Packages_ \n';
    unit.projectUnitPackagePricings.forEach(function (pp, id) {
      if (id > 0) unitPricing += '\n';
      unitPricing += '*' + (id + 1) + ') ' + (pp.projectPackagePricing && pp.projectPackagePricing.name ? pp.projectPackagePricing.name : pp.customName) + '*\n';
      unitPricing += '' + (pp.projectPackagePricing && pp.projectPackagePricing.description ? '_' + pp.projectPackagePricing.description + '_\n' : pp.customDescription ? '_' + pp.customDescription + '_\n' : '');
      unitPricing += '*' + currency + ' ' + formatAmount(getInitialBookingPackagePrice(pp, calculatedPackagePricings), '000,000,000.00') + '*\n';
    });
    fullText += unitPricing;
  }
  if (user && user.preferredName && user.company && user.company.name) {
    fullText += '\n_Shared by *' + user.preferredName + '*_\n';
    fullText += '_Generated by MHub on behalf of ' + user.company.name + '_\n';
  }
  return encodeURIComponent(fullText).replace(/'/g, '%27').replace(/"/g, '%22');
}

function shareUnitMorCalcCopyFormat(unit, calcVal, loanMargin, result, user, pricingPackage) {
  var fullText = '';
  if (!unit) return fullText;
  var areaText = getAreaText(user);
  var unitInfo = '*Unit Information* \n';
  unitInfo += '' + (unit.project && unit.project.name ? '\u2022 Project Name: ' + unit.project.name + '\n' : '');
  unitInfo += '' + (unit.reference ? '\u2022 Unit Number: ' + unit.reference + '\n' : '');
  unitInfo += '' + (unit.projectUnitLayout && unit.projectUnitLayout.name ? '\u2022 Layout Type: ' + unit.projectUnitLayout.name + '\n' : '');
  unitInfo += '' + (unit.size ? '\u2022 ' + areaText + ': ' + parseFloat(unit.size) + checkSizeSuffix(unit.project.sizeSuffix, user) + '\n' : '');
  unitInfo += '' + (unit.landArea ? '\u2022 LandArea: ' + unit.landArea + '\n' : '');
  unitInfo += '' + (unit.streetNumberOrLevel ? '\u2022 ' + (unit.project.propertyCategory.category === _propertyCategories.PROPERTY_CATEGORY_HIGH_RISE ? 'Level:' : 'Street Number:') + ' ' + unit.streetNumberOrLevel + '\n' : '');
  unitInfo += '' + (unit.zoneOrBlock ? '\u2022 ' + (unit.project.propertyCategory.category === _propertyCategories.PROPERTY_CATEGORY_HIGH_RISE ? 'Block:' : 'Zone:') + ' ' + unit.zoneOrBlock + '\n' : '');
  unitInfo += '' + (unit.streetOrFacing ? '\u2022 ' + (unit.project.propertyCategory.category === _propertyCategories.PROPERTY_CATEGORY_HIGH_RISE ? 'Facing:' : 'Street:') + ' ' + unit.streetOrFacing + '\n' : '');
  fullText += unitInfo;
  var unitMCalc = '\n*Mortgage Calculator* \n';
  unitMCalc += '\u2022 SPA Price: ' + fAmount(calcVal.spaPrice) + '\n';
  unitMCalc += '\u2022 Pricing Package name: ' + (pricingPackage !== 'spa_value' ? pricingPackage : 'Base Unit Price') + '\n';
  unitMCalc += '\u2022 Loan margin: ' + loanMargin + '%\n';
  unitMCalc += '\u2022 Loan tenure: ' + calcVal.tenureYear + ' years\n';
  unitMCalc += '\u2022 Interest rate: ' + calcVal.interestRate + '%\n';
  fullText += unitMCalc;
  var unitEstCalc = '\n*Estimated Calculation* \n';
  unitEstCalc += 'Estimated monthly payment: ' + fAmount(result.monthlyLoanPayment) + '\n';
  unitEstCalc += '\nSPA: ' + fAmount(result.totalSPAFees) + '\n';
  unitEstCalc += '\u2022 Legal fee (Property value): ' + fAmount(result.spaLegalFee) + '\n';
  unitEstCalc += '\u2022 Legal fee SST (8%): ' + fAmount(result.spaLegalFeeSST) + '\n';
  unitEstCalc += '\u2022 Legal disbursements*: ' + fAmount(result.spaLegalFeeDisbursements) + '\n';
  unitEstCalc += '\nLoan agreement: ' + fAmount(result.totalLAFees) + '\n';
  unitEstCalc += '\u2022 Legal fee (Loan amount): ' + fAmount(result.laLegalFee) + '\n';
  unitEstCalc += '\u2022 Legal fee SST (8%): ' + fAmount(result.laLegalFeeSST) + '\n';
  unitEstCalc += '\u2022 Legal disbursements: ' + fAmount(result.laLegalFeeDisbursements) + '\n';
  unitEstCalc += '\u2022 Stamp duty: ' + fAmount(result.laStampDuty) + '\n';
  unitEstCalc += '\nValuation fees: ' + fAmount(result.totalValuationFees) + '\n';
  unitEstCalc += '\u2022 Valuation fees (Property value): ' + fAmount(result.valuationFee) + '\n';
  unitEstCalc += '\u2022 Valuation fees SST (8%): ' + fAmount(result.valuationFeeSST) + '\n';
  unitEstCalc += '\u2022 Disbursements*: ' + fAmount(result.valuationFeeDisbursements) + '\n';
  unitEstCalc += '\nInstrument of transfer (MoT / DoA)\n';
  unitEstCalc += '\u2022 Stamp duty: ' + fAmount(result.motStampDuty) + '\n';
  unitEstCalc += '\nEstimated total additional cost: ' + fAmount(result.totalAdditionalFees) + '\n';
  unitEstCalc += '* Actual amount may vary\n';
  fullText += unitEstCalc;
  if (user && user.preferredName && user.company && user.company.name) {
    fullText += '\nShared by ' + user.preferredName + '\n';
    fullText += 'Generated by MHub on behalf of ' + user.company.name + '\n';
  }
  return fullText;
}

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HELD_UNTIL_HEADER = exports.HELD_UNIT_REFERENCE_HEADER = exports.HELD_UNIT_ID_HEADER = exports.UNIT_HELD_M_TYPE = undefined;
exports.parseUnitHeldRefusal = parseUnitHeldRefusal;
exports.preReservedURL = preReservedURL;
exports.heldUnitPagePath = heldUnitPagePath;
exports.shouldReleaseHoldOnLeave = shouldReleaseHoldOnLeave;
exports.canForceReleaseUnitHold = canForceReleaseUnitHold;

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// CPI-1377: the launch-mode unit hold, client side.
//
// book-api owns the hold (project_unit.reserved_by_aws_user + reserved_timeout_expire_at, taken
// by GET .../pre_reserved/ for project.launchModeMinutes and released by ?clear=true). Its
// one-unit rule refuses a second hold with HTTP 412, M-Type error_launch_mode_multi, a plain
// sentence as the body and the held unit in three headers. The decisions the Reserve screen and
// the unit page make around that live here as plain functions, so they can be tested without
// rendering Form.jsx.

var UNIT_HELD_M_TYPE = exports.UNIT_HELD_M_TYPE = 'error_launch_mode_multi';
var HELD_UNIT_ID_HEADER = exports.HELD_UNIT_ID_HEADER = 'M-Held-Unit-Id';
var HELD_UNIT_REFERENCE_HEADER = exports.HELD_UNIT_REFERENCE_HEADER = 'M-Held-Unit-Reference';
var HELD_UNTIL_HEADER = exports.HELD_UNTIL_HEADER = 'M-Held-Until';

var header = function header(headers, name) {
  if (!headers || typeof headers.get !== 'function') return '';
  var value = headers.get(name);
  return typeof value === 'string' ? value : '';
};

// parseUnitHeldRefusal reads the refusal: the body is the sentence the pop-up shows, the held
// unit comes from the headers. The reference is percent-encoded on the wire so a non-ASCII one is
// a valid header value. An older book-api sends no headers, and the pop-up then falls back to the
// sentence with only Close.
function parseUnitHeldRefusal(body, headers) {
  var message = typeof body === 'string' ? body.trim() : '';
  var heldUnitReference = header(headers, HELD_UNIT_REFERENCE_HEADER);
  try {
    heldUnitReference = decodeURIComponent(heldUnitReference);
  } catch (e) {
    // not percent-encoded after all: shown as sent
  }
  return {
    message: message,
    heldUnitID: header(headers, HELD_UNIT_ID_HEADER),
    heldUnitReference: heldUnitReference,
    heldUntil: header(headers, HELD_UNTIL_HEADER)
  };
}

// preReservedURL is the hold endpoint; clear releases the hold on this unit instead of taking it.
function preReservedURL(bookApiURL, projectID, unitID) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$clear = options.clear,
      clear = _options$clear === undefined ? false : _options$clear;

  var query = {};
  if (clear) query.clear = 'true';
  return bookApiURL + '/projects/' + projectID + '/units/' + unitID + '/pre_reserved/?' + _qs2.default.stringify(query);
}

// heldUnitPagePath is where "Go back to A40.07" goes: the held unit's own page.
function heldUnitPagePath(projectID, unitID) {
  return '/projects/' + projectID + '/units/' + unitID + '/';
}

// shouldReleaseHoldOnLeave: leaving the Reserve screen inside the app releases a LIVE hold that no
// reservation was saved against. After a save the booking owns the unit; an expired hold has
// nothing to release.
function shouldReleaseHoldOnLeave(state) {
  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date();

  var _ref = state || {},
      isLaunchMode = _ref.isLaunchMode,
      reservedTimeoutExpireAt = _ref.reservedTimeoutExpireAt,
      bookingSubmitted = _ref.bookingSubmitted;

  if (!isLaunchMode || !reservedTimeoutExpireAt || bookingSubmitted) return false;
  return (0, _momentTimezone2.default)(now).isBefore((0, _momentTimezone2.default)(reservedTimeoutExpireAt));
}

// canForceReleaseUnitHold mirrors book-api: HQ and the platform admins may release a hold that is
// not theirs. Sales Admin, Sales Manager and agency roles may not.
function canForceReleaseUnitHold(auth) {
  if (!auth) return false;
  return Boolean(auth.isSuperAdmin || auth.isAdmin || auth.isHeadquarters);
}

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.progressPercent = exports.exportFiltersSummary = exports.exportsPagePath = exports.exportFiltersFromQuery = exports.VN_BOOKING_EXPORTS_PATH = exports.VN_BOOKING_EXPORT_FILTER_KEYS = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _opportunityStatuses = __webpack_require__(195);

var _tokenPaymentStatuses = __webpack_require__(2232);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// CPI-1281: the Bookings-page filters a queued Excel export carries. Same names as the URL of
// the Bookings list and as the query book-api's POST /opportunity/export/ accepts, so the export
// reproduces the list the user was looking at.
var VN_BOOKING_EXPORT_FILTER_KEYS = exports.VN_BOOKING_EXPORT_FILTER_KEYS = ['group_status', 'sr_status', 'sr_code', 'customer_name', 'token_status_id'];

var VN_BOOKING_EXPORTS_PATH = exports.VN_BOOKING_EXPORTS_PATH = '/opportunities/exports/';

// exportFiltersFromQuery keeps only the allow-listed filters from a decoded Bookings-list query,
// trimmed, with empties and the default pending_payment token tab dropped (it is the list's
// default view, not a token-primary filter).
var exportFiltersFromQuery = exports.exportFiltersFromQuery = function exportFiltersFromQuery() {
  var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return VN_BOOKING_EXPORT_FILTER_KEYS.reduce(function (acc, key) {
    var raw = query[key];
    var value = typeof raw === 'string' ? raw.trim() : '';
    if (!value) return acc;
    if (key === 'token_status_id' && value === _tokenPaymentStatuses.TOKEN_PAYMENT_STATUS.PENDING_PAYMENT) return acc;
    return _extends({}, acc, _defineProperty({}, key, value));
  }, {});
};

var exportsPagePath = exports.exportsPagePath = function exportsPagePath(filters) {
  var search = _qs2.default.stringify(filters || {});
  return search ? VN_BOOKING_EXPORTS_PATH + '?' + search : VN_BOOKING_EXPORTS_PATH;
};

// exportFiltersSummary renders stored filters for the exports table. The first part is always
// the Bookings tab the export was taken from (All Bookings when none was applied), as a bare
// chip with no label; Booking ID and Purchaser Name follow as "Label: value" chips. Labels
// resolve in the caller's default (screens) namespace; tab and status texts are constants
// texts, so they go through `ns`. Unknown values fall back raw.
var exportFiltersSummary = exports.exportFiltersSummary = function exportFiltersSummary() {
  var filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var t = arguments[1];
  var ns = arguments[2];

  var labelFor = function labelFor(map, value) {
    return map[value] ? t(map[value].text, ns) : value;
  };
  var parts = [];
  var f = filters || {};
  if (f.token_status_id) {
    parts.push({ key: 'token_status_id', label: null, value: labelFor(_tokenPaymentStatuses.TOKEN_PAYMENT_STATUS_MAP, f.token_status_id) });
  } else if (f.sr_status) {
    parts.push({ key: 'sr_status', label: null, value: labelFor(_opportunityStatuses.SINGLE_STATUS_MAP, f.sr_status) });
  } else if (f.group_status && f.group_status !== 'total') {
    parts.push({ key: 'group_status', label: null, value: labelFor(_opportunityStatuses.OPPORTUNITY_STATUS_MAP, f.group_status) });
  } else {
    parts.push({ key: 'group_status', label: null, value: t('All Bookings', ns) });
  }
  if (f.sr_code) parts.push({ key: 'sr_code', label: t('Booking ID'), value: f.sr_code });
  if (f.customer_name) parts.push({ key: 'customer_name', label: t('Purchaser Name'), value: f.customer_name });
  return parts;
};

// progressPercent turns book-api's "done/total" into 0-100, tolerating the "0/0" a freshly claimed
// row carries (NaN would otherwise reach the progress bar).
var progressPercent = exports.progressPercent = function progressPercent(progress) {
  if (!progress || typeof progress !== 'string' || progress.indexOf('/') === -1) return 0;

  var _progress$split$map = progress.split('/').map(function (v) {
    return parseInt(v, 10);
  }),
      _progress$split$map2 = _slicedToArray(_progress$split$map, 2),
      done = _progress$split$map2[0],
      total = _progress$split$map2[1];

  if (!total || Number.isNaN(done) || Number.isNaN(total)) return 0;
  return Math.max(0, Math.min(100, Math.floor(done / total * 100)));
};

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2634), __esModule: true };

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(406)
var Buffer = __webpack_require__(42).Buffer
var Transform = __webpack_require__(198)
var inherits = __webpack_require__(41)
var GHASH = __webpack_require__(2602)
var xor = __webpack_require__(327)
var incr32 = __webpack_require__(1099)

function xorTest (a, b) {
  var out = 0
  if (a.length !== b.length) out++

  var len = Math.min(a.length, b.length)
  for (var i = 0; i < len; ++i) {
    out += (a[i] ^ b[i])
  }

  return out
}

function calcIv (self, iv, ck) {
  if (iv.length === 12) {
    self._finID = Buffer.concat([iv, Buffer.from([0, 0, 0, 1])])
    return Buffer.concat([iv, Buffer.from([0, 0, 0, 2])])
  }
  var ghash = new GHASH(ck)
  var len = iv.length
  var toPad = len % 16
  ghash.update(iv)
  if (toPad) {
    toPad = 16 - toPad
    ghash.update(Buffer.alloc(toPad, 0))
  }
  ghash.update(Buffer.alloc(8, 0))
  var ivBits = len * 8
  var tail = Buffer.alloc(8)
  tail.writeUIntBE(ivBits, 0, 8)
  ghash.update(tail)
  self._finID = ghash.state
  var out = Buffer.from(self._finID)
  incr32(out)
  return out
}
function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  var h = Buffer.alloc(4, 0)

  this._cipher = new aes.AES(key)
  var ck = this._cipher.encryptBlock(h)
  this._ghash = new GHASH(ck)
  iv = calcIv(this, iv, ck)

  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._alen = 0
  this._len = 0
  this._mode = mode

  this._authTag = null
  this._called = false
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  if (!this._called && this._alen) {
    var rump = 16 - (this._alen % 16)
    if (rump < 16) {
      rump = Buffer.alloc(rump, 0)
      this._ghash.update(rump)
    }
  }

  this._called = true
  var out = this._mode.encrypt(this, chunk)
  if (this._decrypt) {
    this._ghash.update(chunk)
  } else {
    this._ghash.update(out)
  }
  this._len += chunk.length
  return out
}

StreamCipher.prototype._final = function () {
  if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data')

  var tag = xor(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID))
  if (this._decrypt && xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data')

  this._authTag = tag
  this._cipher.scrub()
}

StreamCipher.prototype.getAuthTag = function getAuthTag () {
  if (this._decrypt || !Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state')

  return this._authTag
}

StreamCipher.prototype.setAuthTag = function setAuthTag (tag) {
  if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state')

  this._authTag = tag
}

StreamCipher.prototype.setAAD = function setAAD (buf) {
  if (this._called) throw new Error('Attempting to set AAD in unsupported state')

  this._ghash.update(buf)
  this._alen += buf.length
}

module.exports = StreamCipher


/***/ }),
/* 1099 */
/***/ (function(module, exports) {

function incr32 (iv) {
  var len = iv.length
  var item
  while (len--) {
    item = iv.readUInt8(len)
    if (item === 255) {
      iv.writeUInt8(0, len)
    } else {
      item++
      iv.writeUInt8(item, len)
      break
    }
  }
}
module.exports = incr32


/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(327)
var Buffer = __webpack_require__(42).Buffer
var incr32 = __webpack_require__(1099)

function getBlock (self) {
  var out = self._cipher.encryptBlockRaw(self._prev)
  incr32(self._prev)
  return out
}

var blockSize = 16
exports.encrypt = function (self, chunk) {
  var chunkNum = Math.ceil(chunk.length / blockSize)
  var start = self._cache.length
  self._cache = Buffer.concat([
    self._cache,
    Buffer.allocUnsafe(chunkNum * blockSize)
  ])
  for (var i = 0; i < chunkNum; i++) {
    var out = getBlock(self)
    var offset = start + i * blockSize
    self._cache.writeUInt32BE(out[0], offset + 0)
    self._cache.writeUInt32BE(out[1], offset + 4)
    self._cache.writeUInt32BE(out[2], offset + 8)
    self._cache.writeUInt32BE(out[3], offset + 12)
  }
  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}


/***/ }),
/* 1101 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

var aes = __webpack_require__(406)
var Buffer = __webpack_require__(42).Buffer
var Transform = __webpack_require__(198)
var inherits = __webpack_require__(41)

function StreamCipher (mode, key, iv, decrypt) {
  Transform.call(this)

  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._cache = Buffer.allocUnsafe(0)
  this._secCache = Buffer.allocUnsafe(0)
  this._decrypt = decrypt
  this._mode = mode
}

inherits(StreamCipher, Transform)

StreamCipher.prototype._update = function (chunk) {
  return this._mode.encrypt(this, chunk, this._decrypt)
}

StreamCipher.prototype._final = function () {
  this._cipher.scrub()
}

module.exports = StreamCipher


/***/ }),
/* 1103 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 1104 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;


/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(436);
var $TypeError = __webpack_require__(282);

var $call = __webpack_require__(603);
var $actualApply = __webpack_require__(2616);

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(655);

var callBindBasic = __webpack_require__(1106);

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};


/***/ }),
/* 1108 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var decode = decodeURIComponent;
var encode = encodeURIComponent;
var pairSplitRegExp = /; */;

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var pairs = str.split(pairSplitRegExp);
  var dec = opt.decode || decode;

  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i];
    var eq_idx = pair.indexOf('=');

    // skip things that don't look like key=value
    if (eq_idx < 0) {
      continue;
    }

    var key = pair.substr(0, eq_idx).trim()
    var val = pair.substr(++eq_idx, pair.length).trim();

    // quoted values
    if ('"' == val[0]) {
      val = val.slice(1, -1);
    }

    // only assign once
    if (undefined == obj[key]) {
      obj[key] = tryDecode(val, dec);
    }
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;
    if (isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + opt.expires.toUTCString();
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),
/* 1110 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(2638);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(273);
var document = __webpack_require__(177).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(199) && !__webpack_require__(330)(function () {
  return Object.defineProperty(__webpack_require__(1112)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(1110);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(407);
var $export = __webpack_require__(227);
var redefine = __webpack_require__(1119);
var hide = __webpack_require__(272);
var Iterators = __webpack_require__(606);
var $iterCreate = __webpack_require__(2644);
var setToStringTag = __webpack_require__(609);
var getPrototypeOf = __webpack_require__(2650);
var ITERATOR = __webpack_require__(275)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(409);
var createDesc = __webpack_require__(410);
var toIObject = __webpack_require__(274);
var toPrimitive = __webpack_require__(614);
var has = __webpack_require__(228);
var IE8_DOM_DEFINE = __webpack_require__(1113);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(199) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(1118);
var hiddenKeys = __webpack_require__(605).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(228);
var toIObject = __webpack_require__(274);
var arrayIndexOf = __webpack_require__(2640)(false);
var IE_PROTO = __webpack_require__(610)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(272);


/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

var cof = __webpack_require__(178);
module.exports = function (it, msg) {
  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
  return +it;
};


/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

var toObject = __webpack_require__(99);
var toAbsoluteIndex = __webpack_require__(237);
var toLength = __webpack_require__(73);

module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
  var O = toObject(this);
  var len = toLength(O.length);
  var to = toAbsoluteIndex(target, len);
  var from = toAbsoluteIndex(start, len);
  var end = arguments.length > 2 ? arguments[2] : undefined;
  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
  var inc = 1;
  if (from < to && to < from + count) {
    inc = -1;
    from += count - 1;
    to += count - 1;
  }
  while (count-- > 0) {
    if (from in O) O[to] = O[from];
    else delete O[to];
    to += inc;
    from += inc;
  } return O;
};


/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(158);
var toObject = __webpack_require__(99);
var IObject = __webpack_require__(332);
var toLength = __webpack_require__(73);

module.exports = function (that, callbackfn, aLen, memo, isRight) {
  aFunction(callbackfn);
  var O = toObject(that);
  var self = IObject(O);
  var length = toLength(O.length);
  var index = isRight ? length - 1 : 0;
  var i = isRight ? -1 : 1;
  if (aLen < 2) for (;;) {
    if (index in self) {
      memo = self[index];
      index += i;
      break;
    }
    index += i;
    if (isRight ? index < 0 : length <= index) {
      throw TypeError('Reduce of empty array with no initial value');
    }
  }
  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
    memo = callbackfn(memo, self[index], index, O);
  }
  return memo;
};


/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__(2667);

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var aFunction = __webpack_require__(158);
var isObject = __webpack_require__(53);
var invoke = __webpack_require__(1128);
var arraySlice = [].slice;
var factories = {};

var construct = function (F, len, args) {
  if (!(len in factories)) {
    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
    // eslint-disable-next-line no-new-func
    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
  } return factories[len](F, args);
};

module.exports = Function.bind || function bind(that /* , ...args */) {
  var fn = aFunction(this);
  var partArgs = arraySlice.call(arguments, 1);
  var bound = function (/* args... */) {
    var args = partArgs.concat(arraySlice.call(arguments));
    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
  };
  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
  return bound;
};


/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(83).f;
var create = __webpack_require__(232);
var redefineAll = __webpack_require__(278);
var ctx = __webpack_require__(160);
var anInstance = __webpack_require__(276);
var forOf = __webpack_require__(416);
var $iterDefine = __webpack_require__(627);
var step = __webpack_require__(1132);
var setSpecies = __webpack_require__(279);
var DESCRIPTORS = __webpack_require__(82);
var fastKey = __webpack_require__(200).fastKey;
var validate = __webpack_require__(239);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var redefineAll = __webpack_require__(278);
var getWeak = __webpack_require__(200).getWeak;
var anObject = __webpack_require__(50);
var isObject = __webpack_require__(53);
var anInstance = __webpack_require__(276);
var forOf = __webpack_require__(416);
var createArrayMethod = __webpack_require__(159);
var $has = __webpack_require__(130);
var validate = __webpack_require__(239);
var arrayFind = createArrayMethod(5);
var arrayFindIndex = createArrayMethod(6);
var id = 0;

// fallback for uncaught frozen keys
var uncaughtFrozenStore = function (that) {
  return that._l || (that._l = new UncaughtFrozenStore());
};
var UncaughtFrozenStore = function () {
  this.a = [];
};
var findUncaughtFrozen = function (store, key) {
  return arrayFind(store.a, function (it) {
    return it[0] === key;
  });
};
UncaughtFrozenStore.prototype = {
  get: function (key) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) return entry[1];
  },
  has: function (key) {
    return !!findUncaughtFrozen(this, key);
  },
  set: function (key, value) {
    var entry = findUncaughtFrozen(this, key);
    if (entry) entry[1] = value;
    else this.a.push([key, value]);
  },
  'delete': function (key) {
    var index = arrayFindIndex(this.a, function (it) {
      return it[0] === key;
    });
    if (~index) this.a.splice(index, 1);
    return !!~index;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;      // collection type
      that._i = id++;      // collection id
      that._l = undefined; // leak store for uncaught frozen objects
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.3.3.2 WeakMap.prototype.delete(key)
      // 23.4.3.3 WeakSet.prototype.delete(value)
      'delete': function (key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
        return data && $has(data, this._i) && delete data[this._i];
      },
      // 23.3.3.4 WeakMap.prototype.has(key)
      // 23.4.3.4 WeakSet.prototype.has(value)
      has: function has(key) {
        if (!isObject(key)) return false;
        var data = getWeak(key);
        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
        return data && $has(data, this._i);
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var data = getWeak(anObject(key), true);
    if (data === true) uncaughtFrozenStore(that).set(key, value);
    else data[that._i] = value;
    return that;
  },
  ufstore: uncaughtFrozenStore
};


/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(82) && !__webpack_require__(51)(function () {
  return Object.defineProperty(__webpack_require__(620)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 1128 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(53);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(50);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(232);
var descriptor = __webpack_require__(236);
var setToStringTag = __webpack_require__(280);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(131)(IteratorPrototype, __webpack_require__(67)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1132 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 1133 */
/***/ (function(module, exports) {

// 20.2.2.20 Math.log1p(x)
module.exports = Math.log1p || function log1p(x) {
  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
};


/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(158);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(82);
var getKeys = __webpack_require__(235);
var gOPS = __webpack_require__(419);
var pIE = __webpack_require__(333);
var toObject = __webpack_require__(99);
var IObject = __webpack_require__(332);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(51)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(83);
var anObject = __webpack_require__(50);
var getKeys = __webpack_require__(235);

module.exports = __webpack_require__(82) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(132);
var gOPN = __webpack_require__(233).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(130);
var toIObject = __webpack_require__(132);
var arrayIndexOf = __webpack_require__(412)(false);
var IE_PROTO = __webpack_require__(632)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(82);
var getKeys = __webpack_require__(235);
var toIObject = __webpack_require__(132);
var isEnum = __webpack_require__(333).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

// all object keys, includes non-enumerable and symbols
var gOPN = __webpack_require__(233);
var gOPS = __webpack_require__(419);
var anObject = __webpack_require__(50);
var Reflect = __webpack_require__(52).Reflect;
module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
  var keys = gOPN.f(anObject(it));
  var getSymbols = gOPS.f;
  return getSymbols ? keys.concat(getSymbols(it)) : keys;
};


/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

var $parseFloat = __webpack_require__(52).parseFloat;
var $trim = __webpack_require__(281).trim;

module.exports = 1 / $parseFloat(__webpack_require__(636) + '-0') !== -Infinity ? function parseFloat(str) {
  var string = $trim(String(str), 3);
  var result = $parseFloat(string);
  return result === 0 && string.charAt(0) == '-' ? -0 : result;
} : $parseFloat;


/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(52).parseInt;
var $trim = __webpack_require__(281).trim;
var ws = __webpack_require__(636);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(50);
var isObject = __webpack_require__(53);
var newPromiseCapability = __webpack_require__(1134);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 1144 */
/***/ (function(module, exports) {

// 7.2.9 SameValue(x, y)
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare
  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
};


/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-string-pad-start-end
var toLength = __webpack_require__(73);
var repeat = __webpack_require__(635);
var defined = __webpack_require__(179);

module.exports = function (that, maxLength, fillString, left) {
  var S = String(defined(that));
  var stringLength = S.length;
  var fillStr = fillString === undefined ? ' ' : String(fillString);
  var intMaxLength = toLength(maxLength);
  if (intMaxLength <= stringLength || fillStr == '') return S;
  var fillLen = intMaxLength - stringLength;
  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
  return left ? stringFiller + S : S + stringFiller;
};


/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

// https://tc39.github.io/ecma262/#sec-toindex
var toInteger = __webpack_require__(163);
var toLength = __webpack_require__(73);
module.exports = function (it) {
  if (it === undefined) return 0;
  var number = toInteger(it);
  var length = toLength(number);
  if (number !== length) throw RangeError('Wrong length!');
  return length;
};


/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(52);
var core = __webpack_require__(78);
var LIBRARY = __webpack_require__(231);
var wksExt = __webpack_require__(639);
var defineProperty = __webpack_require__(83).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(231);
var global = __webpack_require__(52);
var ctx = __webpack_require__(160);
var classof = __webpack_require__(331);
var $export = __webpack_require__(17);
var isObject = __webpack_require__(53);
var aFunction = __webpack_require__(158);
var anInstance = __webpack_require__(276);
var forOf = __webpack_require__(416);
var speciesConstructor = __webpack_require__(334);
var task = __webpack_require__(637).set;
var microtask = __webpack_require__(2674)();
var newPromiseCapabilityModule = __webpack_require__(1134);
var perform = __webpack_require__(2675);
var userAgent = __webpack_require__(423);
var promiseResolve = __webpack_require__(1143);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(67)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(278)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(280)($Promise, PROMISE);
__webpack_require__(279)(PROMISE);
Wrapper = __webpack_require__(78)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(418)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__(630);
__webpack_require__(17)({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__(82) && /./g.flags != 'g') __webpack_require__(83).f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__(415)
});


/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

var MD5 = __webpack_require__(679)

module.exports = function (buffer) {
  return new MD5().update(buffer).digest()
}


/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(41)
var Legacy = __webpack_require__(2827)
var Base = __webpack_require__(198)
var Buffer = __webpack_require__(42).Buffer
var md5 = __webpack_require__(1151)
var RIPEMD160 = __webpack_require__(699)

var sha = __webpack_require__(758)

var ZEROS = Buffer.alloc(128)

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  this._alg = alg
  this._key = key
  if (key.length > blocksize) {
    var hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
    key = hash.update(key).digest()
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }
  this._hash = alg === 'rmd160' ? new RIPEMD160() : sha(alg)
  this._hash.update(ipad)
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.update(data)
}

Hmac.prototype._final = function () {
  var h = this._hash.digest()
  var hash = this._alg === 'rmd160' ? new RIPEMD160() : sha(this._alg)
  return hash.update(this._opad).update(h).digest()
}

module.exports = function createHmac (alg, key) {
  alg = alg.toLowerCase()
  if (alg === 'rmd160' || alg === 'ripemd160') {
    return new Hmac('rmd160', key)
  }
  if (alg === 'md5') {
    return new Legacy(md5, key)
  }
  return new Hmac(alg, key)
}


/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(240));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;
	    var C_enc = C.enc;

	    /**
	     * Base64 encoding strategy.
	     */
	    var Base64 = C_enc.Base64 = {
	        /**
	         * Converts a word array to a Base64 string.
	         *
	         * @param {WordArray} wordArray The word array.
	         *
	         * @return {string} The Base64 string.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var base64String = CryptoJS.enc.Base64.stringify(wordArray);
	         */
	        stringify: function (wordArray) {
	            // Shortcuts
	            var words = wordArray.words;
	            var sigBytes = wordArray.sigBytes;
	            var map = this._map;

	            // Clamp excess bits
	            wordArray.clamp();

	            // Convert
	            var base64Chars = [];
	            for (var i = 0; i < sigBytes; i += 3) {
	                var byte1 = (words[i >>> 2]       >>> (24 - (i % 4) * 8))       & 0xff;
	                var byte2 = (words[(i + 1) >>> 2] >>> (24 - ((i + 1) % 4) * 8)) & 0xff;
	                var byte3 = (words[(i + 2) >>> 2] >>> (24 - ((i + 2) % 4) * 8)) & 0xff;

	                var triplet = (byte1 << 16) | (byte2 << 8) | byte3;

	                for (var j = 0; (j < 4) && (i + j * 0.75 < sigBytes); j++) {
	                    base64Chars.push(map.charAt((triplet >>> (6 * (3 - j))) & 0x3f));
	                }
	            }

	            // Add padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                while (base64Chars.length % 4) {
	                    base64Chars.push(paddingChar);
	                }
	            }

	            return base64Chars.join('');
	        },

	        /**
	         * Converts a Base64 string to a word array.
	         *
	         * @param {string} base64Str The Base64 string.
	         *
	         * @return {WordArray} The word array.
	         *
	         * @static
	         *
	         * @example
	         *
	         *     var wordArray = CryptoJS.enc.Base64.parse(base64String);
	         */
	        parse: function (base64Str) {
	            // Shortcuts
	            var base64StrLength = base64Str.length;
	            var map = this._map;
	            var reverseMap = this._reverseMap;

	            if (!reverseMap) {
	                    reverseMap = this._reverseMap = [];
	                    for (var j = 0; j < map.length; j++) {
	                        reverseMap[map.charCodeAt(j)] = j;
	                    }
	            }

	            // Ignore padding
	            var paddingChar = map.charAt(64);
	            if (paddingChar) {
	                var paddingIndex = base64Str.indexOf(paddingChar);
	                if (paddingIndex !== -1) {
	                    base64StrLength = paddingIndex;
	                }
	            }

	            // Convert
	            return parseLoop(base64Str, base64StrLength, reverseMap);

	        },

	        _map: 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/='
	    };

	    function parseLoop(base64Str, base64StrLength, reverseMap) {
	      var words = [];
	      var nBytes = 0;
	      for (var i = 0; i < base64StrLength; i++) {
	          if (i % 4) {
	              var bits1 = reverseMap[base64Str.charCodeAt(i - 1)] << ((i % 4) * 2);
	              var bits2 = reverseMap[base64Str.charCodeAt(i)] >>> (6 - (i % 4) * 2);
	              var bitsCombined = bits1 | bits2;
	              words[nBytes >>> 2] |= bitsCombined << (24 - (nBytes % 4) * 8);
	              nBytes++;
	          }
	      }
	      return WordArray.create(words, nBytes);
	    }
	}());


	return CryptoJS.enc.Base64;

}));

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory, undef) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(240), __webpack_require__(642), __webpack_require__(2831));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core", "./sha256", "./hmac"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	return CryptoJS.HmacSHA256;

}));

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(240));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Check if typed arrays are supported
	    if (typeof ArrayBuffer != 'function') {
	        return;
	    }

	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var WordArray = C_lib.WordArray;

	    // Reference original init
	    var superInit = WordArray.init;

	    // Augment WordArray.init to handle typed arrays
	    var subInit = WordArray.init = function (typedArray) {
	        // Convert buffers to uint8
	        if (typedArray instanceof ArrayBuffer) {
	            typedArray = new Uint8Array(typedArray);
	        }

	        // Convert other array views to uint8
	        if (
	            typedArray instanceof Int8Array ||
	            (typeof Uint8ClampedArray !== "undefined" && typedArray instanceof Uint8ClampedArray) ||
	            typedArray instanceof Int16Array ||
	            typedArray instanceof Uint16Array ||
	            typedArray instanceof Int32Array ||
	            typedArray instanceof Uint32Array ||
	            typedArray instanceof Float32Array ||
	            typedArray instanceof Float64Array
	        ) {
	            typedArray = new Uint8Array(typedArray.buffer, typedArray.byteOffset, typedArray.byteLength);
	        }

	        // Handle Uint8Array
	        if (typedArray instanceof Uint8Array) {
	            // Shortcut
	            var typedArrayByteLength = typedArray.byteLength;

	            // Extract bytes
	            var words = [];
	            for (var i = 0; i < typedArrayByteLength; i++) {
	                words[i >>> 2] |= typedArray[i] << (24 - (i % 4) * 8);
	            }

	            // Initialize this word array
	            superInit.call(this, words, typedArrayByteLength);
	        } else {
	            // Else call normal init
	            superInit.apply(this, arguments);
	        }
	    };

	    subInit.prototype = WordArray;
	}());


	return CryptoJS.lib.WordArray;

}));

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;;(function (globalScope) {
  'use strict';


  /*!
   *  decimal.js v10.4.3
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js
   *  Copyright (c) 2022 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Licence
   */


  // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //


    // The maximum exponent magnitude.
    // The limit on the value of `toExpNeg`, `toExpPos`, `minE` and `maxE`.
  var EXP_LIMIT = 9e15,                      // 0 to 9e15

    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    MAX_DIGITS = 1e9,                        // 0 to 1e9

    // Base conversion alphabet.
    NUMERALS = '0123456789abcdef',

    // The natural logarithm of 10 (1025 digits).
    LN10 = '2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058',

    // Pi (1025 digits).
    PI = '3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789',


    // The initial configuration properties of the Decimal constructor.
    DEFAULTS = {

      // These values must be integers within the stated ranges (inclusive).
      // Most of these values can be changed at run-time using the `Decimal.config` method.

      // The maximum number of significant digits of the result of a calculation or base conversion.
      // E.g. `Decimal.config({ precision: 20 });`
      precision: 20,                         // 1 to MAX_DIGITS

      // The rounding mode used when rounding to `precision`.
      //
      // ROUND_UP         0 Away from zero.
      // ROUND_DOWN       1 Towards zero.
      // ROUND_CEIL       2 Towards +Infinity.
      // ROUND_FLOOR      3 Towards -Infinity.
      // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
      // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
      // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
      // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
      // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
      //
      // E.g.
      // `Decimal.rounding = 4;`
      // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
      rounding: 4,                           // 0 to 8

      // The modulo mode used when calculating the modulus: a mod n.
      // The quotient (q = a / n) is calculated according to the corresponding rounding mode.
      // The remainder (r) is calculated as: r = a - n * q.
      //
      // UP         0 The remainder is positive if the dividend is negative, else is negative.
      // DOWN       1 The remainder has the same sign as the dividend (JavaScript %).
      // FLOOR      3 The remainder has the same sign as the divisor (Python %).
      // HALF_EVEN  6 The IEEE 754 remainder function.
      // EUCLID     9 Euclidian division. q = sign(n) * floor(a / abs(n)). Always positive.
      //
      // Truncated division (1), floored division (3), the IEEE 754 remainder (6), and Euclidian
      // division (9) are commonly used for the modulus operation. The other rounding modes can also
      // be used, but they may not give useful results.
      modulo: 1,                             // 0 to 9

      // The exponent value at and beneath which `toString` returns exponential notation.
      // JavaScript numbers: -7
      toExpNeg: -7,                          // 0 to -EXP_LIMIT

      // The exponent value at and above which `toString` returns exponential notation.
      // JavaScript numbers: 21
      toExpPos:  21,                         // 0 to EXP_LIMIT

      // The minimum exponent value, beneath which underflow to zero occurs.
      // JavaScript numbers: -324  (5e-324)
      minE: -EXP_LIMIT,                      // -1 to -EXP_LIMIT

      // The maximum exponent value, above which overflow to Infinity occurs.
      // JavaScript numbers: 308  (1.7976931348623157e+308)
      maxE: EXP_LIMIT,                       // 1 to EXP_LIMIT

      // Whether to use cryptographically-secure random number generation, if available.
      crypto: false                          // true/false
    },


  // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //


    Decimal, inexact, noConflict, quadrant,
    external = true,

    decimalError = '[DecimalError] ',
    invalidArgument = decimalError + 'Invalid argument: ',
    precisionLimitExceeded = decimalError + 'Precision limit exceeded',
    cryptoUnavailable = decimalError + 'crypto unavailable',
    tag = '[object Decimal]',

    mathfloor = Math.floor,
    mathpow = Math.pow,

    isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i,
    isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i,
    isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i,
    isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i,

    BASE = 1e7,
    LOG_BASE = 7,
    MAX_SAFE_INTEGER = 9007199254740991,

    LN10_PRECISION = LN10.length - 1,
    PI_PRECISION = PI.length - 1,

    // Decimal.prototype object
    P = { toStringTag: tag };


  // Decimal prototype methods


  /*
   *  absoluteValue             abs
   *  ceil
   *  clampedTo                 clamp
   *  comparedTo                cmp
   *  cosine                    cos
   *  cubeRoot                  cbrt
   *  decimalPlaces             dp
   *  dividedBy                 div
   *  dividedToIntegerBy        divToInt
   *  equals                    eq
   *  floor
   *  greaterThan               gt
   *  greaterThanOrEqualTo      gte
   *  hyperbolicCosine          cosh
   *  hyperbolicSine            sinh
   *  hyperbolicTangent         tanh
   *  inverseCosine             acos
   *  inverseHyperbolicCosine   acosh
   *  inverseHyperbolicSine     asinh
   *  inverseHyperbolicTangent  atanh
   *  inverseSine               asin
   *  inverseTangent            atan
   *  isFinite
   *  isInteger                 isInt
   *  isNaN
   *  isNegative                isNeg
   *  isPositive                isPos
   *  isZero
   *  lessThan                  lt
   *  lessThanOrEqualTo         lte
   *  logarithm                 log
   *  [maximum]                 [max]
   *  [minimum]                 [min]
   *  minus                     sub
   *  modulo                    mod
   *  naturalExponential        exp
   *  naturalLogarithm          ln
   *  negated                   neg
   *  plus                      add
   *  precision                 sd
   *  round
   *  sine                      sin
   *  squareRoot                sqrt
   *  tangent                   tan
   *  times                     mul
   *  toBinary
   *  toDecimalPlaces           toDP
   *  toExponential
   *  toFixed
   *  toFraction
   *  toHexadecimal             toHex
   *  toNearest
   *  toNumber
   *  toOctal
   *  toPower                   pow
   *  toPrecision
   *  toSignificantDigits       toSD
   *  toString
   *  truncated                 trunc
   *  valueOf                   toJSON
   */


  /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */
  P.absoluteValue = P.abs = function () {
    var x = new this.constructor(this);
    if (x.s < 0) x.s = 1;
    return finalise(x);
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of positive Infinity.
   *
   */
  P.ceil = function () {
    return finalise(new this.constructor(this), this.e + 1, 2);
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal clamped to the range
   * delineated by `min` and `max`.
   *
   * min {number|string|Decimal}
   * max {number|string|Decimal}
   *
   */
  P.clampedTo = P.clamp = function (min, max) {
    var k,
      x = this,
      Ctor = x.constructor;
    min = new Ctor(min);
    max = new Ctor(max);
    if (!min.s || !max.s) return new Ctor(NaN);
    if (min.gt(max)) throw Error(invalidArgument + max);
    k = x.cmp(min);
    return k < 0 ? min : x.cmp(max) > 0 ? max : new Ctor(x);
  };


  /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value,
   *   NaN  if the value of either Decimal is NaN.
   *
   */
  P.comparedTo = P.cmp = function (y) {
    var i, j, xdL, ydL,
      x = this,
      xd = x.d,
      yd = (y = new x.constructor(y)).d,
      xs = x.s,
      ys = y.s;

    // Either NaN or ±Infinity?
    if (!xd || !yd) {
      return !xs || !ys ? NaN : xs !== ys ? xs : xd === yd ? 0 : !xd ^ xs < 0 ? 1 : -1;
    }

    // Either zero?
    if (!xd[0] || !yd[0]) return xd[0] ? xs : yd[0] ? -ys : 0;

    // Signs differ?
    if (xs !== ys) return xs;

    // Compare exponents.
    if (x.e !== y.e) return x.e > y.e ^ xs < 0 ? 1 : -1;

    xdL = xd.length;
    ydL = yd.length;

    // Compare digit by digit.
    for (i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i) {
      if (xd[i] !== yd[i]) return xd[i] > yd[i] ^ xs < 0 ? 1 : -1;
    }

    // Compare lengths.
    return xdL === ydL ? 0 : xdL > ydL ^ xs < 0 ? 1 : -1;
  };


  /*
   * Return a new Decimal whose value is the cosine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * cos(0)         = 1
   * cos(-0)        = 1
   * cos(Infinity)  = NaN
   * cos(-Infinity) = NaN
   * cos(NaN)       = NaN
   *
   */
  P.cosine = P.cos = function () {
    var pr, rm,
      x = this,
      Ctor = x.constructor;

    if (!x.d) return new Ctor(NaN);

    // cos(0) = cos(-0) = 1
    if (!x.d[0]) return new Ctor(1);

    pr = Ctor.precision;
    rm = Ctor.rounding;
    Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
    Ctor.rounding = 1;

    x = cosine(Ctor, toLessThanHalfPi(Ctor, x));

    Ctor.precision = pr;
    Ctor.rounding = rm;

    return finalise(quadrant == 2 || quadrant == 3 ? x.neg() : x, pr, rm, true);
  };


  /*
   *
   * Return a new Decimal whose value is the cube root of the value of this Decimal, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   *  cbrt(0)  =  0
   *  cbrt(-0) = -0
   *  cbrt(1)  =  1
   *  cbrt(-1) = -1
   *  cbrt(N)  =  N
   *  cbrt(-I) = -I
   *  cbrt(I)  =  I
   *
   * Math.cbrt(x) = (x < 0 ? -Math.pow(-x, 1/3) : Math.pow(x, 1/3))
   *
   */
  P.cubeRoot = P.cbrt = function () {
    var e, m, n, r, rep, s, sd, t, t3, t3plusx,
      x = this,
      Ctor = x.constructor;

    if (!x.isFinite() || x.isZero()) return new Ctor(x);
    external = false;

    // Initial estimate.
    s = x.s * mathpow(x.s * x, 1 / 3);

     // Math.cbrt underflow/overflow?
     // Pass x to Math.pow as integer, then adjust the exponent of the result.
    if (!s || Math.abs(s) == 1 / 0) {
      n = digitsToString(x.d);
      e = x.e;

      // Adjust n exponent so it is a multiple of 3 away from x exponent.
      if (s = (e - n.length + 1) % 3) n += (s == 1 || s == -2 ? '0' : '00');
      s = mathpow(n, 1 / 3);

      // Rarely, e may be one less than the result exponent value.
      e = mathfloor((e + 1) / 3) - (e % 3 == (e < 0 ? -1 : 2));

      if (s == 1 / 0) {
        n = '5e' + e;
      } else {
        n = s.toExponential();
        n = n.slice(0, n.indexOf('e') + 1) + e;
      }

      r = new Ctor(n);
      r.s = x.s;
    } else {
      r = new Ctor(s.toString());
    }

    sd = (e = Ctor.precision) + 3;

    // Halley's method.
    // TODO? Compare Newton's method.
    for (;;) {
      t = r;
      t3 = t.times(t).times(t);
      t3plusx = t3.plus(x);
      r = divide(t3plusx.plus(x).times(t), t3plusx.plus(t3), sd + 2, 1);

      // TODO? Replace with for-loop and checkRoundingDigits.
      if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
        n = n.slice(sd - 3, sd + 1);

        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or 4999
        // , i.e. approaching a rounding boundary, continue the iteration.
        if (n == '9999' || !rep && n == '4999') {

          // On the first iteration only, check to see if rounding up gives the exact result as the
          // nines may infinitely repeat.
          if (!rep) {
            finalise(t, e + 1, 0);

            if (t.times(t).times(t).eq(x)) {
              r = t;
              break;
            }
          }

          sd += 4;
          rep = 1;
        } else {

          // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
          // If not, then there are further digits and m will be truthy.
          if (!+n || !+n.slice(1) && n.charAt(0) == '5') {

            // Truncate to the first rounding digit.
            finalise(r, e + 1, 1);
            m = !r.times(r).times(r).eq(x);
          }

          break;
        }
      }
    }

    external = true;

    return finalise(r, e, Ctor.rounding, m);
  };


  /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */
  P.decimalPlaces = P.dp = function () {
    var w,
      d = this.d,
      n = NaN;

    if (d) {
      w = d.length - 1;
      n = (w - mathfloor(this.e / LOG_BASE)) * LOG_BASE;

      // Subtract the number of trailing zeros of the last word.
      w = d[w];
      if (w) for (; w % 10 == 0; w /= 10) n--;
      if (n < 0) n = 0;
    }

    return n;
  };


  /*
   *  n / 0 = I
   *  n / N = N
   *  n / I = 0
   *  0 / n = 0
   *  0 / 0 = N
   *  0 / N = N
   *  0 / I = 0
   *  N / n = N
   *  N / 0 = N
   *  N / N = N
   *  N / I = N
   *  I / n = I
   *  I / 0 = I
   *  I / N = N
   *  I / I = N
   *
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   */
  P.dividedBy = P.div = function (y) {
    return divide(this, new this.constructor(y));
  };


  /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */
  P.dividedToIntegerBy = P.divToInt = function (y) {
    var x = this,
      Ctor = x.constructor;
    return finalise(divide(x, new Ctor(y), 0, 1, 1), Ctor.precision, Ctor.rounding);
  };


  /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */
  P.equals = P.eq = function (y) {
    return this.cmp(y) === 0;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number in the
   * direction of negative Infinity.
   *
   */
  P.floor = function () {
    return finalise(new this.constructor(this), this.e + 1, 3);
  };


  /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */
  P.greaterThan = P.gt = function (y) {
    return this.cmp(y) > 0;
  };


  /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */
  P.greaterThanOrEqualTo = P.gte = function (y) {
    var k = this.cmp(y);
    return k == 1 || k === 0;
  };


  /*
   * Return a new Decimal whose value is the hyperbolic cosine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [1, Infinity]
   *
   * cosh(x) = 1 + x^2/2! + x^4/4! + x^6/6! + ...
   *
   * cosh(0)         = 1
   * cosh(-0)        = 1
   * cosh(Infinity)  = Infinity
   * cosh(-Infinity) = Infinity
   * cosh(NaN)       = NaN
   *
   *  x        time taken (ms)   result
   * 1000      9                 9.8503555700852349694e+433
   * 10000     25                4.4034091128314607936e+4342
   * 100000    171               1.4033316802130615897e+43429
   * 1000000   3817              1.5166076984010437725e+434294
   * 10000000  abandoned after 2 minute wait
   *
   * TODO? Compare performance of cosh(x) = 0.5 * (exp(x) + exp(-x))
   *
   */
  P.hyperbolicCosine = P.cosh = function () {
    var k, n, pr, rm, len,
      x = this,
      Ctor = x.constructor,
      one = new Ctor(1);

    if (!x.isFinite()) return new Ctor(x.s ? 1 / 0 : NaN);
    if (x.isZero()) return one;

    pr = Ctor.precision;
    rm = Ctor.rounding;
    Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
    Ctor.rounding = 1;
    len = x.d.length;

    // Argument reduction: cos(4x) = 1 - 8cos^2(x) + 8cos^4(x) + 1
    // i.e. cos(x) = 1 - cos^2(x/4)(8 - 8cos^2(x/4))

    // Estimate the optimum number of times to use the argument reduction.
    // TODO? Estimation reused from cosine() and may not be optimal here.
    if (len < 32) {
      k = Math.ceil(len / 3);
      n = (1 / tinyPow(4, k)).toString();
    } else {
      k = 16;
      n = '2.3283064365386962890625e-10';
    }

    x = taylorSeries(Ctor, 1, x.times(n), new Ctor(1), true);

    // Reverse argument reduction
    var cosh2_x,
      i = k,
      d8 = new Ctor(8);
    for (; i--;) {
      cosh2_x = x.times(x);
      x = one.minus(cosh2_x.times(d8.minus(cosh2_x.times(d8))));
    }

    return finalise(x, Ctor.precision = pr, Ctor.rounding = rm, true);
  };


  /*
   * Return a new Decimal whose value is the hyperbolic sine of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * sinh(x) = x + x^3/3! + x^5/5! + x^7/7! + ...
   *
   * sinh(0)         = 0
   * sinh(-0)        = -0
   * sinh(Infinity)  = Infinity
   * sinh(-Infinity) = -Infinity
   * sinh(NaN)       = NaN
   *
   * x        time taken (ms)
   * 10       2 ms
   * 100      5 ms
   * 1000     14 ms
   * 10000    82 ms
   * 100000   886 ms            1.4033316802130615897e+43429
   * 200000   2613 ms
   * 300000   5407 ms
   * 400000   8824 ms
   * 500000   13026 ms          8.7080643612718084129e+217146
   * 1000000  48543 ms
   *
   * TODO? Compare performance of sinh(x) = 0.5 * (exp(x) - exp(-x))
   *
   */
  P.hyperbolicSine = P.sinh = function () {
    var k, pr, rm, len,
      x = this,
      Ctor = x.constructor;

    if (!x.isFinite() || x.isZero()) return new Ctor(x);

    pr = Ctor.precision;
    rm = Ctor.rounding;
    Ctor.precision = pr + Math.max(x.e, x.sd()) + 4;
    Ctor.rounding = 1;
    len = x.d.length;

    if (len < 3) {
      x = taylorSeries(Ctor, 2, x, x, true);
    } else {

      // Alternative argument reduction: sinh(3x) = sinh(x)(3 + 4sinh^2(x))
      // i.e. sinh(x) = sinh(x/3)(3 + 4sinh^2(x/3))
      // 3 multiplications and 1 addition

      // Argument reduction: sinh(5x) = sinh(x)(5 + sinh^2(x)(20 + 16sinh^2(x)))
      // i.e. sinh(x) = sinh(x/5)(5 + sinh^2(x/5)(20 + 16sinh^2(x/5)))
      // 4 multiplications and 2 additions

      // Estimate the optimum number of times to use the argument reduction.
      k = 1.4 * Math.sqrt(len);
      k = k > 16 ? 16 : k | 0;

      x = x.times(1 / tinyPow(5, k));
      x = taylorSeries(Ctor, 2, x, x, true);

      // Reverse argument reduction
      var sinh2_x,
        d5 = new Ctor(5),
        d16 = new Ctor(16),
        d20 = new Ctor(20);
      for (; k--;) {
        sinh2_x = x.times(x);
        x = x.times(d5.plus(sinh2_x.times(d16.times(sinh2_x).plus(d20))));
      }
    }

    Ctor.precision = pr;
    Ctor.rounding = rm;

    return finalise(x, pr, rm, true);
  };


  /*
   * Return a new Decimal whose value is the hyperbolic tangent of the value in radians of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * tanh(x) = sinh(x) / cosh(x)
   *
   * tanh(0)         = 0
   * tanh(-0)        = -0
   * tanh(Infinity)  = 1
   * tanh(-Infinity) = -1
   * tanh(NaN)       = NaN
   *
   */
  P.hyperbolicTangent = P.tanh = function () {
    var pr, rm,
      x = this,
      Ctor = x.constructor;

    if (!x.isFinite()) return new Ctor(x.s);
    if (x.isZero()) return new Ctor(x);

    pr = Ctor.precision;
    rm = Ctor.rounding;
    Ctor.precision = pr + 7;
    Ctor.rounding = 1;

    return divide(x.sinh(), x.cosh(), Ctor.precision = pr, Ctor.rounding = rm);
  };


  /*
   * Return a new Decimal whose value is the arccosine (inverse cosine) in radians of the value of
   * this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [0, pi]
   *
   * acos(x) = pi/2 - asin(x)
   *
   * acos(0)       = pi/2
   * acos(-0)      = pi/2
   * acos(1)       = 0
   * acos(-1)      = pi
   * acos(1/2)     = pi/3
   * acos(-1/2)    = 2*pi/3
   * acos(|x| > 1) = NaN
   * acos(NaN)     = NaN
   *
   */
  P.inverseCosine = P.acos = function () {
    var halfPi,
      x = this,
      Ctor = x.constructor,
      k = x.abs().cmp(1),
      pr = Ctor.precision,
      rm = Ctor.rounding;

    if (k !== -1) {
      return k === 0
        // |x| is 1
        ? x.isNeg() ? getPi(Ctor, pr, rm) : new Ctor(0)
        // |x| > 1 or x is NaN
        : new Ctor(NaN);
    }

    if (x.isZero()) return getPi(Ctor, pr + 4, rm).times(0.5);

    // TODO? Special case acos(0.5) = pi/3 and acos(-0.5) = 2*pi/3

    Ctor.precision = pr + 6;
    Ctor.rounding = 1;

    x = x.asin();
    halfPi = getPi(Ctor, pr + 4, rm).times(0.5);

    Ctor.precision = pr;
    Ctor.rounding = rm;

    return halfPi.minus(x);
  };


  /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine in radians of the
   * value of this Decimal.
   *
   * Domain: [1, Infinity]
   * Range: [0, Infinity]
   *
   * acosh(x) = ln(x + sqrt(x^2 - 1))
   *
   * acosh(x < 1)     = NaN
   * acosh(NaN)       = NaN
   * acosh(Infinity)  = Infinity
   * acosh(-Infinity) = NaN
   * acosh(0)         = NaN
   * acosh(-0)        = NaN
   * acosh(1)         = 0
   * acosh(-1)        = NaN
   *
   */
  P.inverseHyperbolicCosine = P.acosh = function () {
    var pr, rm,
      x = this,
      Ctor = x.constructor;

    if (x.lte(1)) return new Ctor(x.eq(1) ? 0 : NaN);
    if (!x.isFinite()) return new Ctor(x);

    pr = Ctor.precision;
    rm = Ctor.rounding;
    Ctor.precision = pr + Math.max(Math.abs(x.e), x.sd()) + 4;
    Ctor.rounding = 1;
    external = false;

    x = x.times(x).minus(1).sqrt().plus(x);

    external = true;
    Ctor.precision = pr;
    Ctor.rounding = rm;

    return x.ln();
  };


  /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * asinh(x) = ln(x + sqrt(x^2 + 1))
   *
   * asinh(NaN)       = NaN
   * asinh(Infinity)  = Infinity
   * asinh(-Infinity) = -Infinity
   * asinh(0)         = 0
   * asinh(-0)        = -0
   *
   */
  P.inverseHyperbolicSine = P.asinh = function () {
    var pr, rm,
      x = this,
      Ctor = x.constructor;

    if (!x.isFinite() || x.isZero()) return new Ctor(x);

    pr = Ctor.precision;
    rm = Ctor.rounding;
    Ctor.precision = pr + 2 * Math.max(Math.abs(x.e), x.sd()) + 6;
    Ctor.rounding = 1;
    external = false;

    x = x.times(x).plus(1).sqrt().plus(x);

    external = true;
    Ctor.precision = pr;
    Ctor.rounding = rm;

    return x.ln();
  };


  /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent in radians of the
   * value of this Decimal.
   *
   * Domain: [-1, 1]
   * Range: [-Infinity, Infinity]
   *
   * atanh(x) = 0.5 * ln((1 + x) / (1 - x))
   *
   * atanh(|x| > 1)   = NaN
   * atanh(NaN)       = NaN
   * atanh(Infinity)  = NaN
   * atanh(-Infinity) = NaN
   * atanh(0)         = 0
   * atanh(-0)        = -0
   * atanh(1)         = Infinity
   * atanh(-1)        = -Infinity
   *
   */
  P.inverseHyperbolicTangent = P.atanh = function () {
    var pr, rm, wpr, xsd,
      x = this,
      Ctor = x.constructor;

    if (!x.isFinite()) return new Ctor(NaN);
    if (x.e >= 0) return new Ctor(x.abs().eq(1) ? x.s / 0 : x.isZero() ? x : NaN);

    pr = Ctor.precision;
    rm = Ctor.rounding;
    xsd = x.sd();

    if (Math.max(xsd, pr) < 2 * -x.e - 1) return finalise(new Ctor(x), pr, rm, true);

    Ctor.precision = wpr = xsd - x.e;

    x = divide(x.plus(1), new Ctor(1).minus(x), wpr + pr, 1);

    Ctor.precision = pr + 4;
    Ctor.rounding = 1;

    x = x.ln();

    Ctor.precision = pr;
    Ctor.rounding = rm;

    return x.times(0.5);
  };


  /*
   * Return a new Decimal whose value is the arcsine (inverse sine) in radians of the value of this
   * Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * asin(x) = 2*atan(x/(1 + sqrt(1 - x^2)))
   *
   * asin(0)       = 0
   * asin(-0)      = -0
   * asin(1/2)     = pi/6
   * asin(-1/2)    = -pi/6
   * asin(1)       = pi/2
   * asin(-1)      = -pi/2
   * asin(|x| > 1) = NaN
   * asin(NaN)     = NaN
   *
   * TODO? Compare performance of Taylor series.
   *
   */
  P.inverseSine = P.asin = function () {
    var halfPi, k,
      pr, rm,
      x = this,
      Ctor = x.constructor;

    if (x.isZero()) return new Ctor(x);

    k = x.abs().cmp(1);
    pr = Ctor.precision;
    rm = Ctor.rounding;

    if (k !== -1) {

      // |x| is 1
      if (k === 0) {
        halfPi = getPi(Ctor, pr + 4, rm).times(0.5);
        halfPi.s = x.s;
        return halfPi;
      }

      // |x| > 1 or x is NaN
      return new Ctor(NaN);
    }

    // TODO? Special case asin(1/2) = pi/6 and asin(-1/2) = -pi/6

    Ctor.precision = pr + 6;
    Ctor.rounding = 1;

    x = x.div(new Ctor(1).minus(x.times(x)).sqrt().plus(1)).atan();

    Ctor.precision = pr;
    Ctor.rounding = rm;

    return x.times(2);
  };


  /*
   * Return a new Decimal whose value is the arctangent (inverse tangent) in radians of the value
   * of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi/2, pi/2]
   *
   * atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
   *
   * atan(0)         = 0
   * atan(-0)        = -0
   * atan(1)         = pi/4
   * atan(-1)        = -pi/4
   * atan(Infinity)  = pi/2
   * atan(-Infinity) = -pi/2
   * atan(NaN)       = NaN
   *
   */
  P.inverseTangent = P.atan = function () {
    var i, j, k, n, px, t, r, wpr, x2,
      x = this,
      Ctor = x.constructor,
      pr = Ctor.precision,
      rm = Ctor.rounding;

    if (!x.isFinite()) {
      if (!x.s) return new Ctor(NaN);
      if (pr + 4 <= PI_PRECISION) {
        r = getPi(Ctor, pr + 4, rm).times(0.5);
        r.s = x.s;
        return r;
      }
    } else if (x.isZero()) {
      return new Ctor(x);
    } else if (x.abs().eq(1) && pr + 4 <= PI_PRECISION) {
      r = getPi(Ctor, pr + 4, rm).times(0.25);
      r.s = x.s;
      return r;
    }

    Ctor.precision = wpr = pr + 10;
    Ctor.rounding = 1;

    // TODO? if (x >= 1 && pr <= PI_PRECISION) atan(x) = halfPi * x.s - atan(1 / x);

    // Argument reduction
    // Ensure |x| < 0.42
    // atan(x) = 2 * atan(x / (1 + sqrt(1 + x^2)))

    k = Math.min(28, wpr / LOG_BASE + 2 | 0);

    for (i = k; i; --i) x = x.div(x.times(x).plus(1).sqrt().plus(1));

    external = false;

    j = Math.ceil(wpr / LOG_BASE);
    n = 1;
    x2 = x.times(x);
    r = new Ctor(x);
    px = x;

    // atan(x) = x - x^3/3 + x^5/5 - x^7/7 + ...
    for (; i !== -1;) {
      px = px.times(x2);
      t = r.minus(px.div(n += 2));

      px = px.times(x2);
      r = t.plus(px.div(n += 2));

      if (r.d[j] !== void 0) for (i = j; r.d[i] === t.d[i] && i--;);
    }

    if (k) r = r.times(2 << (k - 1));

    external = true;

    return finalise(r, Ctor.precision = pr, Ctor.rounding = rm, true);
  };


  /*
   * Return true if the value of this Decimal is a finite number, otherwise return false.
   *
   */
  P.isFinite = function () {
    return !!this.d;
  };


  /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */
  P.isInteger = P.isInt = function () {
    return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
  };


  /*
   * Return true if the value of this Decimal is NaN, otherwise return false.
   *
   */
  P.isNaN = function () {
    return !this.s;
  };


  /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */
  P.isNegative = P.isNeg = function () {
    return this.s < 0;
  };


  /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */
  P.isPositive = P.isPos = function () {
    return this.s > 0;
  };


  /*
   * Return true if the value of this Decimal is 0 or -0, otherwise return false.
   *
   */
  P.isZero = function () {
    return !!this.d && this.d[0] === 0;
  };


  /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */
  P.lessThan = P.lt = function (y) {
    return this.cmp(y) < 0;
  };


  /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */
  P.lessThanOrEqualTo = P.lte = function (y) {
    return this.cmp(y) < 1;
  };


  /*
   * Return the logarithm of the value of this Decimal to the specified base, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * If no base is specified, return log[10](arg).
   *
   * log[base](arg) = ln(arg) / ln(base)
   *
   * The result will always be correctly rounded if the base of the log is 10, and 'almost always'
   * otherwise:
   *
   * Depending on the rounding mode, the result may be incorrectly rounded if the first fifteen
   * rounding digits are [49]99999999999999 or [50]00000000000000. In that case, the maximum error
   * between the result and the correctly rounded result will be one ulp (unit in the last place).
   *
   * log[-b](a)       = NaN
   * log[0](a)        = NaN
   * log[1](a)        = NaN
   * log[NaN](a)      = NaN
   * log[Infinity](a) = NaN
   * log[b](0)        = -Infinity
   * log[b](-0)       = -Infinity
   * log[b](-a)       = NaN
   * log[b](1)        = 0
   * log[b](Infinity) = Infinity
   * log[b](NaN)      = NaN
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */
  P.logarithm = P.log = function (base) {
    var isBase10, d, denominator, k, inf, num, sd, r,
      arg = this,
      Ctor = arg.constructor,
      pr = Ctor.precision,
      rm = Ctor.rounding,
      guard = 5;

    // Default base is 10.
    if (base == null) {
      base = new Ctor(10);
      isBase10 = true;
    } else {
      base = new Ctor(base);
      d = base.d;

      // Return NaN if base is negative, or non-finite, or is 0 or 1.
      if (base.s < 0 || !d || !d[0] || base.eq(1)) return new Ctor(NaN);

      isBase10 = base.eq(10);
    }

    d = arg.d;

    // Is arg negative, non-finite, 0 or 1?
    if (arg.s < 0 || !d || !d[0] || arg.eq(1)) {
      return new Ctor(d && !d[0] ? -1 / 0 : arg.s != 1 ? NaN : d ? 0 : 1 / 0);
    }

    // The result will have a non-terminating decimal expansion if base is 10 and arg is not an
    // integer power of 10.
    if (isBase10) {
      if (d.length > 1) {
        inf = true;
      } else {
        for (k = d[0]; k % 10 === 0;) k /= 10;
        inf = k !== 1;
      }
    }

    external = false;
    sd = pr + guard;
    num = naturalLogarithm(arg, sd);
    denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);

    // The result will have 5 rounding digits.
    r = divide(num, denominator, sd, 1);

    // If at a rounding boundary, i.e. the result's rounding digits are [49]9999 or [50]0000,
    // calculate 10 further digits.
    //
    // If the result is known to have an infinite decimal expansion, repeat this until it is clear
    // that the result is above or below the boundary. Otherwise, if after calculating the 10
    // further digits, the last 14 are nines, round up and assume the result is exact.
    // Also assume the result is exact if the last 14 are zero.
    //
    // Example of a result that will be incorrectly rounded:
    // log[1048576](4503599627370502) = 2.60000000000000009610279511444746...
    // The above result correctly rounded using ROUND_CEIL to 1 decimal place should be 2.7, but it
    // will be given as 2.6 as there are 15 zeros immediately after the requested decimal place, so
    // the exact result would be assumed to be 2.6, which rounded using ROUND_CEIL to 1 decimal
    // place is still 2.6.
    if (checkRoundingDigits(r.d, k = pr, rm)) {

      do {
        sd += 10;
        num = naturalLogarithm(arg, sd);
        denominator = isBase10 ? getLn10(Ctor, sd + 10) : naturalLogarithm(base, sd);
        r = divide(num, denominator, sd, 1);

        if (!inf) {

          // Check for 14 nines from the 2nd rounding digit, as the first may be 4.
          if (+digitsToString(r.d).slice(k + 1, k + 15) + 1 == 1e14) {
            r = finalise(r, pr + 1, 0);
          }

          break;
        }
      } while (checkRoundingDigits(r.d, k += 10, rm));
    }

    external = true;

    return finalise(r, pr, rm);
  };


  /*
   * Return a new Decimal whose value is the maximum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|Decimal}
   *
  P.max = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 'lt');
  };
   */


  /*
   * Return a new Decimal whose value is the minimum of the arguments and the value of this Decimal.
   *
   * arguments {number|string|Decimal}
   *
  P.min = function () {
    Array.prototype.push.call(arguments, this);
    return maxOrMin(this.constructor, arguments, 'gt');
  };
   */


  /*
   *  n - 0 = n
   *  n - N = N
   *  n - I = -I
   *  0 - n = -n
   *  0 - 0 = 0
   *  0 - N = N
   *  0 - I = -I
   *  N - n = N
   *  N - 0 = N
   *  N - N = N
   *  N - I = N
   *  I - n = I
   *  I - 0 = I
   *  I - N = N
   *  I - I = N
   *
   * Return a new Decimal whose value is the value of this Decimal minus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */
  P.minus = P.sub = function (y) {
    var d, e, i, j, k, len, pr, rm, xd, xe, xLTy, yd,
      x = this,
      Ctor = x.constructor;

    y = new Ctor(y);

    // If either is not finite...
    if (!x.d || !y.d) {

      // Return NaN if either is NaN.
      if (!x.s || !y.s) y = new Ctor(NaN);

      // Return y negated if x is finite and y is ±Infinity.
      else if (x.d) y.s = -y.s;

      // Return x if y is finite and x is ±Infinity.
      // Return x if both are ±Infinity with different signs.
      // Return NaN if both are ±Infinity with the same sign.
      else y = new Ctor(y.d || x.s !== y.s ? x : NaN);

      return y;
    }

    // If signs differ...
    if (x.s != y.s) {
      y.s = -y.s;
      return x.plus(y);
    }

    xd = x.d;
    yd = y.d;
    pr = Ctor.precision;
    rm = Ctor.rounding;

    // If either is zero...
    if (!xd[0] || !yd[0]) {

      // Return y negated if x is zero and y is non-zero.
      if (yd[0]) y.s = -y.s;

      // Return x if y is zero and x is non-zero.
      else if (xd[0]) y = new Ctor(x);

      // Return zero if both are zero.
      // From IEEE 754 (2008) 6.3: 0 - 0 = -0 - -0 = -0 when rounding to -Infinity.
      else return new Ctor(rm === 3 ? -0 : 0);

      return external ? finalise(y, pr, rm) : y;
    }

    // x and y are finite, non-zero numbers with the same sign.

    // Calculate base 1e7 exponents.
    e = mathfloor(y.e / LOG_BASE);
    xe = mathfloor(x.e / LOG_BASE);

    xd = xd.slice();
    k = xe - e;

    // If base 1e7 exponents differ...
    if (k) {
      xLTy = k < 0;

      if (xLTy) {
        d = xd;
        k = -k;
        len = yd.length;
      } else {
        d = yd;
        e = xe;
        len = xd.length;
      }

      // Numbers with massively different exponents would result in a very high number of
      // zeros needing to be prepended, but this can be avoided while still ensuring correct
      // rounding by limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
      i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;

      if (k > i) {
        k = i;
        d.length = 1;
      }

      // Prepend zeros to equalise exponents.
      d.reverse();
      for (i = k; i--;) d.push(0);
      d.reverse();

    // Base 1e7 exponents equal.
    } else {

      // Check digits to determine which is the bigger number.

      i = xd.length;
      len = yd.length;
      xLTy = i < len;
      if (xLTy) len = i;

      for (i = 0; i < len; i++) {
        if (xd[i] != yd[i]) {
          xLTy = xd[i] < yd[i];
          break;
        }
      }

      k = 0;
    }

    if (xLTy) {
      d = xd;
      xd = yd;
      yd = d;
      y.s = -y.s;
    }

    len = xd.length;

    // Append zeros to `xd` if shorter.
    // Don't add zeros to `yd` if shorter as subtraction only needs to start at `yd` length.
    for (i = yd.length - len; i > 0; --i) xd[len++] = 0;

    // Subtract yd from xd.
    for (i = yd.length; i > k;) {

      if (xd[--i] < yd[i]) {
        for (j = i; j && xd[--j] === 0;) xd[j] = BASE - 1;
        --xd[j];
        xd[i] += BASE;
      }

      xd[i] -= yd[i];
    }

    // Remove trailing zeros.
    for (; xd[--len] === 0;) xd.pop();

    // Remove leading zeros and adjust exponent accordingly.
    for (; xd[0] === 0; xd.shift()) --e;

    // Zero?
    if (!xd[0]) return new Ctor(rm === 3 ? -0 : 0);

    y.d = xd;
    y.e = getBase10Exponent(xd, e);

    return external ? finalise(y, pr, rm) : y;
  };


  /*
   *   n % 0 =  N
   *   n % N =  N
   *   n % I =  n
   *   0 % n =  0
   *  -0 % n = -0
   *   0 % 0 =  N
   *   0 % N =  N
   *   0 % I =  0
   *   N % n =  N
   *   N % 0 =  N
   *   N % N =  N
   *   N % I =  N
   *   I % n =  N
   *   I % 0 =  N
   *   I % N =  N
   *   I % I =  N
   *
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * The result depends on the modulo mode.
   *
   */
  P.modulo = P.mod = function (y) {
    var q,
      x = this,
      Ctor = x.constructor;

    y = new Ctor(y);

    // Return NaN if x is ±Infinity or NaN, or y is NaN or ±0.
    if (!x.d || !y.s || y.d && !y.d[0]) return new Ctor(NaN);

    // Return x if y is ±Infinity or x is ±0.
    if (!y.d || x.d && !x.d[0]) {
      return finalise(new Ctor(x), Ctor.precision, Ctor.rounding);
    }

    // Prevent rounding of intermediate calculations.
    external = false;

    if (Ctor.modulo == 9) {

      // Euclidian division: q = sign(y) * floor(x / abs(y))
      // result = x - q * y    where  0 <= result < abs(y)
      q = divide(x, y.abs(), 0, 3, 1);
      q.s *= y.s;
    } else {
      q = divide(x, y, 0, Ctor.modulo, 1);
    }

    q = q.times(y);

    external = true;

    return x.minus(q);
  };


  /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */
  P.naturalExponential = P.exp = function () {
    return naturalExponential(this);
  };


  /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   */
  P.naturalLogarithm = P.ln = function () {
    return naturalLogarithm(this);
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */
  P.negated = P.neg = function () {
    var x = new this.constructor(this);
    x.s = -x.s;
    return finalise(x);
  };


  /*
   *  n + 0 = n
   *  n + N = N
   *  n + I = I
   *  0 + n = n
   *  0 + 0 = 0
   *  0 + N = N
   *  0 + I = I
   *  N + n = N
   *  N + 0 = N
   *  N + N = N
   *  N + I = N
   *  I + n = I
   *  I + 0 = I
   *  I + N = N
   *  I + I = I
   *
   * Return a new Decimal whose value is the value of this Decimal plus `y`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   */
  P.plus = P.add = function (y) {
    var carry, d, e, i, k, len, pr, rm, xd, yd,
      x = this,
      Ctor = x.constructor;

    y = new Ctor(y);

    // If either is not finite...
    if (!x.d || !y.d) {

      // Return NaN if either is NaN.
      if (!x.s || !y.s) y = new Ctor(NaN);

      // Return x if y is finite and x is ±Infinity.
      // Return x if both are ±Infinity with the same sign.
      // Return NaN if both are ±Infinity with different signs.
      // Return y if x is finite and y is ±Infinity.
      else if (!x.d) y = new Ctor(y.d || x.s === y.s ? x : NaN);

      return y;
    }

     // If signs differ...
    if (x.s != y.s) {
      y.s = -y.s;
      return x.minus(y);
    }

    xd = x.d;
    yd = y.d;
    pr = Ctor.precision;
    rm = Ctor.rounding;

    // If either is zero...
    if (!xd[0] || !yd[0]) {

      // Return x if y is zero.
      // Return y if y is non-zero.
      if (!yd[0]) y = new Ctor(x);

      return external ? finalise(y, pr, rm) : y;
    }

    // x and y are finite, non-zero numbers with the same sign.

    // Calculate base 1e7 exponents.
    k = mathfloor(x.e / LOG_BASE);
    e = mathfloor(y.e / LOG_BASE);

    xd = xd.slice();
    i = k - e;

    // If base 1e7 exponents differ...
    if (i) {

      if (i < 0) {
        d = xd;
        i = -i;
        len = yd.length;
      } else {
        d = yd;
        e = k;
        len = xd.length;
      }

      // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
      k = Math.ceil(pr / LOG_BASE);
      len = k > len ? k + 1 : len + 1;

      if (i > len) {
        i = len;
        d.length = 1;
      }

      // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
      d.reverse();
      for (; i--;) d.push(0);
      d.reverse();
    }

    len = xd.length;
    i = yd.length;

    // If yd is longer than xd, swap xd and yd so xd points to the longer array.
    if (len - i < 0) {
      i = len;
      d = yd;
      yd = xd;
      xd = d;
    }

    // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
    for (carry = 0; i;) {
      carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
      xd[i] %= BASE;
    }

    if (carry) {
      xd.unshift(carry);
      ++e;
    }

    // Remove trailing zeros.
    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
    for (len = xd.length; xd[--len] == 0;) xd.pop();

    y.d = xd;
    y.e = getBase10Exponent(xd, e);

    return external ? finalise(y, pr, rm) : y;
  };


  /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */
  P.precision = P.sd = function (z) {
    var k,
      x = this;

    if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);

    if (x.d) {
      k = getPrecision(x.d);
      if (z && x.e + 1 > k) k = x.e + 1;
    } else {
      k = NaN;
    }

    return k;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */
  P.round = function () {
    var x = this,
      Ctor = x.constructor;

    return finalise(new Ctor(x), x.e + 1, Ctor.rounding);
  };


  /*
   * Return a new Decimal whose value is the sine of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-1, 1]
   *
   * sin(x) = x - x^3/3! + x^5/5! - ...
   *
   * sin(0)         = 0
   * sin(-0)        = -0
   * sin(Infinity)  = NaN
   * sin(-Infinity) = NaN
   * sin(NaN)       = NaN
   *
   */
  P.sine = P.sin = function () {
    var pr, rm,
      x = this,
      Ctor = x.constructor;

    if (!x.isFinite()) return new Ctor(NaN);
    if (x.isZero()) return new Ctor(x);

    pr = Ctor.precision;
    rm = Ctor.rounding;
    Ctor.precision = pr + Math.max(x.e, x.sd()) + LOG_BASE;
    Ctor.rounding = 1;

    x = sine(Ctor, toLessThanHalfPi(Ctor, x));

    Ctor.precision = pr;
    Ctor.rounding = rm;

    return finalise(quadrant > 2 ? x.neg() : x, pr, rm, true);
  };


  /*
   * Return a new Decimal whose value is the square root of this Decimal, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   *  sqrt(-n) =  N
   *  sqrt(N)  =  N
   *  sqrt(-I) =  N
   *  sqrt(I)  =  I
   *  sqrt(0)  =  0
   *  sqrt(-0) = -0
   *
   */
  P.squareRoot = P.sqrt = function () {
    var m, n, sd, r, rep, t,
      x = this,
      d = x.d,
      e = x.e,
      s = x.s,
      Ctor = x.constructor;

    // Negative/NaN/Infinity/zero?
    if (s !== 1 || !d || !d[0]) {
      return new Ctor(!s || s < 0 && (!d || d[0]) ? NaN : d ? x : 1 / 0);
    }

    external = false;

    // Initial estimate.
    s = Math.sqrt(+x);

    // Math.sqrt underflow/overflow?
    // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
    if (s == 0 || s == 1 / 0) {
      n = digitsToString(d);

      if ((n.length + e) % 2 == 0) n += '0';
      s = Math.sqrt(n);
      e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);

      if (s == 1 / 0) {
        n = '5e' + e;
      } else {
        n = s.toExponential();
        n = n.slice(0, n.indexOf('e') + 1) + e;
      }

      r = new Ctor(n);
    } else {
      r = new Ctor(s.toString());
    }

    sd = (e = Ctor.precision) + 3;

    // Newton-Raphson iteration.
    for (;;) {
      t = r;
      r = t.plus(divide(x, t, sd + 2, 1)).times(0.5);

      // TODO? Replace with for-loop and checkRoundingDigits.
      if (digitsToString(t.d).slice(0, sd) === (n = digitsToString(r.d)).slice(0, sd)) {
        n = n.slice(sd - 3, sd + 1);

        // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
        // 4999, i.e. approaching a rounding boundary, continue the iteration.
        if (n == '9999' || !rep && n == '4999') {

          // On the first iteration only, check to see if rounding up gives the exact result as the
          // nines may infinitely repeat.
          if (!rep) {
            finalise(t, e + 1, 0);

            if (t.times(t).eq(x)) {
              r = t;
              break;
            }
          }

          sd += 4;
          rep = 1;
        } else {

          // If the rounding digits are null, 0{0,4} or 50{0,3}, check for an exact result.
          // If not, then there are further digits and m will be truthy.
          if (!+n || !+n.slice(1) && n.charAt(0) == '5') {

            // Truncate to the first rounding digit.
            finalise(r, e + 1, 1);
            m = !r.times(r).eq(x);
          }

          break;
        }
      }
    }

    external = true;

    return finalise(r, e, Ctor.rounding, m);
  };


  /*
   * Return a new Decimal whose value is the tangent of the value in radians of this Decimal.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-Infinity, Infinity]
   *
   * tan(0)         = 0
   * tan(-0)        = -0
   * tan(Infinity)  = NaN
   * tan(-Infinity) = NaN
   * tan(NaN)       = NaN
   *
   */
  P.tangent = P.tan = function () {
    var pr, rm,
      x = this,
      Ctor = x.constructor;

    if (!x.isFinite()) return new Ctor(NaN);
    if (x.isZero()) return new Ctor(x);

    pr = Ctor.precision;
    rm = Ctor.rounding;
    Ctor.precision = pr + 10;
    Ctor.rounding = 1;

    x = x.sin();
    x.s = 1;
    x = divide(x, new Ctor(1).minus(x.times(x)).sqrt(), pr + 10, 0);

    Ctor.precision = pr;
    Ctor.rounding = rm;

    return finalise(quadrant == 2 || quadrant == 4 ? x.neg() : x, pr, rm, true);
  };


  /*
   *  n * 0 = 0
   *  n * N = N
   *  n * I = I
   *  0 * n = 0
   *  0 * 0 = 0
   *  0 * N = N
   *  0 * I = N
   *  N * n = N
   *  N * 0 = N
   *  N * N = N
   *  N * I = N
   *  I * n = I
   *  I * 0 = N
   *  I * N = N
   *  I * I = I
   *
   * Return a new Decimal whose value is this Decimal times `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   */
  P.times = P.mul = function (y) {
    var carry, e, i, k, r, rL, t, xdL, ydL,
      x = this,
      Ctor = x.constructor,
      xd = x.d,
      yd = (y = new Ctor(y)).d;

    y.s *= x.s;

     // If either is NaN, ±Infinity or ±0...
    if (!xd || !xd[0] || !yd || !yd[0]) {

      return new Ctor(!y.s || xd && !xd[0] && !yd || yd && !yd[0] && !xd

        // Return NaN if either is NaN.
        // Return NaN if x is ±0 and y is ±Infinity, or y is ±0 and x is ±Infinity.
        ? NaN

        // Return ±Infinity if either is ±Infinity.
        // Return ±0 if either is ±0.
        : !xd || !yd ? y.s / 0 : y.s * 0);
    }

    e = mathfloor(x.e / LOG_BASE) + mathfloor(y.e / LOG_BASE);
    xdL = xd.length;
    ydL = yd.length;

    // Ensure xd points to the longer array.
    if (xdL < ydL) {
      r = xd;
      xd = yd;
      yd = r;
      rL = xdL;
      xdL = ydL;
      ydL = rL;
    }

    // Initialise the result array with zeros.
    r = [];
    rL = xdL + ydL;
    for (i = rL; i--;) r.push(0);

    // Multiply!
    for (i = ydL; --i >= 0;) {
      carry = 0;
      for (k = xdL + i; k > i;) {
        t = r[k] + yd[i] * xd[k - i - 1] + carry;
        r[k--] = t % BASE | 0;
        carry = t / BASE | 0;
      }

      r[k] = (r[k] + carry) % BASE | 0;
    }

    // Remove trailing zeros.
    for (; !r[--rL];) r.pop();

    if (carry) ++e;
    else r.shift();

    y.d = r;
    y.e = getBase10Exponent(r, e);

    return external ? finalise(y, Ctor.precision, Ctor.rounding) : y;
  };


  /*
   * Return a string representing the value of this Decimal in base 2, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toBinary = function (sd, rm) {
    return toStringBinary(this, 2, sd, rm);
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toDecimalPlaces = P.toDP = function (dp, rm) {
    var x = this,
      Ctor = x.constructor;

    x = new Ctor(x);
    if (dp === void 0) return x;

    checkInt32(dp, 0, MAX_DIGITS);

    if (rm === void 0) rm = Ctor.rounding;
    else checkInt32(rm, 0, 8);

    return finalise(x, dp + x.e + 1, rm);
  };


  /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toExponential = function (dp, rm) {
    var str,
      x = this,
      Ctor = x.constructor;

    if (dp === void 0) {
      str = finiteToString(x, true);
    } else {
      checkInt32(dp, 0, MAX_DIGITS);

      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);

      x = finalise(new Ctor(x), dp + 1, rm);
      str = finiteToString(x, true, dp + 1);
    }

    return x.isNeg() && !x.isZero() ? '-' + str : str;
  };


  /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */
  P.toFixed = function (dp, rm) {
    var str, y,
      x = this,
      Ctor = x.constructor;

    if (dp === void 0) {
      str = finiteToString(x);
    } else {
      checkInt32(dp, 0, MAX_DIGITS);

      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);

      y = finalise(new Ctor(x), dp + x.e + 1, rm);
      str = finiteToString(y, false, dp + y.e + 1);
    }

    // To determine whether to add the minus sign look at the value before it was rounded,
    // i.e. look at `x` rather than `y`.
    return x.isNeg() && !x.isZero() ? '-' + str : str;
  };


  /*
   * Return an array representing the value of this Decimal as a simple fraction with an integer
   * numerator and an integer denominator.
   *
   * The denominator will be a positive non-zero value less than or equal to the specified maximum
   * denominator. If a maximum denominator is not specified, the denominator will be the lowest
   * value necessary to represent the number exactly.
   *
   * [maxD] {number|string|Decimal} Maximum denominator. Integer >= 1 and < Infinity.
   *
   */
  P.toFraction = function (maxD) {
    var d, d0, d1, d2, e, k, n, n0, n1, pr, q, r,
      x = this,
      xd = x.d,
      Ctor = x.constructor;

    if (!xd) return new Ctor(x);

    n1 = d0 = new Ctor(1);
    d1 = n0 = new Ctor(0);

    d = new Ctor(d1);
    e = d.e = getPrecision(xd) - x.e - 1;
    k = e % LOG_BASE;
    d.d[0] = mathpow(10, k < 0 ? LOG_BASE + k : k);

    if (maxD == null) {

      // d is 10**e, the minimum max-denominator needed.
      maxD = e > 0 ? d : n1;
    } else {
      n = new Ctor(maxD);
      if (!n.isInt() || n.lt(n1)) throw Error(invalidArgument + n);
      maxD = n.gt(d) ? (e > 0 ? d : n1) : n;
    }

    external = false;
    n = new Ctor(digitsToString(xd));
    pr = Ctor.precision;
    Ctor.precision = e = xd.length * LOG_BASE * 2;

    for (;;)  {
      q = divide(n, d, 0, 1, 1);
      d2 = d0.plus(q.times(d1));
      if (d2.cmp(maxD) == 1) break;
      d0 = d1;
      d1 = d2;
      d2 = n1;
      n1 = n0.plus(q.times(d2));
      n0 = d2;
      d2 = d;
      d = n.minus(q.times(d2));
      n = d2;
    }

    d2 = divide(maxD.minus(d0), d1, 0, 1, 1);
    n0 = n0.plus(d2.times(n1));
    d0 = d0.plus(d2.times(d1));
    n0.s = n1.s = x.s;

    // Determine which fraction is closer to x, n0/d0 or n1/d1?
    r = divide(n1, d1, e, 1).minus(x).abs().cmp(divide(n0, d0, e, 1).minus(x).abs()) < 1
        ? [n1, d1] : [n0, d0];

    Ctor.precision = pr;
    external = true;

    return r;
  };


  /*
   * Return a string representing the value of this Decimal in base 16, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toHexadecimal = P.toHex = function (sd, rm) {
    return toStringBinary(this, 16, sd, rm);
  };


  /*
   * Returns a new Decimal whose value is the nearest multiple of `y` in the direction of rounding
   * mode `rm`, or `Decimal.rounding` if `rm` is omitted, to the value of this Decimal.
   *
   * The return value will always have the same sign as this Decimal, unless either this Decimal
   * or `y` is NaN, in which case the return value will be also be NaN.
   *
   * The return value is not affected by the value of `precision`.
   *
   * y {number|string|Decimal} The magnitude to round to a multiple of.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toNearest() rounding mode not an integer: {rm}'
   * 'toNearest() rounding mode out of range: {rm}'
   *
   */
  P.toNearest = function (y, rm) {
    var x = this,
      Ctor = x.constructor;

    x = new Ctor(x);

    if (y == null) {

      // If x is not finite, return x.
      if (!x.d) return x;

      y = new Ctor(1);
      rm = Ctor.rounding;
    } else {
      y = new Ctor(y);
      if (rm === void 0) {
        rm = Ctor.rounding;
      } else {
        checkInt32(rm, 0, 8);
      }

      // If x is not finite, return x if y is not NaN, else NaN.
      if (!x.d) return y.s ? x : y;

      // If y is not finite, return Infinity with the sign of x if y is Infinity, else NaN.
      if (!y.d) {
        if (y.s) y.s = x.s;
        return y;
      }
    }

    // If y is not zero, calculate the nearest multiple of y to x.
    if (y.d[0]) {
      external = false;
      x = divide(x, y, 0, rm, 1).times(y);
      external = true;
      finalise(x);

    // If y is zero, return zero with the sign of x.
    } else {
      y.s = x.s;
      x = y;
    }

    return x;
  };


  /*
   * Return the value of this Decimal converted to a number primitive.
   * Zero keeps its sign.
   *
   */
  P.toNumber = function () {
    return +this;
  };


  /*
   * Return a string representing the value of this Decimal in base 8, round to `sd` significant
   * digits using rounding mode `rm`.
   *
   * If the optional `sd` argument is present then return binary exponential notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toOctal = function (sd, rm) {
    return toStringBinary(this, 8, sd, rm);
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`, rounded
   * to `precision` significant digits using rounding mode `rounding`.
   *
   * ECMAScript compliant.
   *
   *   pow(x, NaN)                           = NaN
   *   pow(x, ±0)                            = 1

   *   pow(NaN, non-zero)                    = NaN
   *   pow(abs(x) > 1, +Infinity)            = +Infinity
   *   pow(abs(x) > 1, -Infinity)            = +0
   *   pow(abs(x) == 1, ±Infinity)           = NaN
   *   pow(abs(x) < 1, +Infinity)            = +0
   *   pow(abs(x) < 1, -Infinity)            = +Infinity
   *   pow(+Infinity, y > 0)                 = +Infinity
   *   pow(+Infinity, y < 0)                 = +0
   *   pow(-Infinity, odd integer > 0)       = -Infinity
   *   pow(-Infinity, even integer > 0)      = +Infinity
   *   pow(-Infinity, odd integer < 0)       = -0
   *   pow(-Infinity, even integer < 0)      = +0
   *   pow(+0, y > 0)                        = +0
   *   pow(+0, y < 0)                        = +Infinity
   *   pow(-0, odd integer > 0)              = -0
   *   pow(-0, even integer > 0)             = +0
   *   pow(-0, odd integer < 0)              = -Infinity
   *   pow(-0, even integer < 0)             = +Infinity
   *   pow(finite x < 0, finite non-integer) = NaN
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * Assuming the first 15 rounding digits are each equally likely to be any digit 0-9, the
   * probability of an incorrectly rounded result
   * P([49]9{14} | [50]0{14}) = 2 * 0.2 * 10^-14 = 4e-15 = 1/2.5e+14
   * i.e. 1 in 250,000,000,000,000
   *
   * If a result is incorrectly rounded the maximum error will be 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */
  P.toPower = P.pow = function (y) {
    var e, k, pr, r, rm, s,
      x = this,
      Ctor = x.constructor,
      yn = +(y = new Ctor(y));

    // Either ±Infinity, NaN or ±0?
    if (!x.d || !y.d || !x.d[0] || !y.d[0]) return new Ctor(mathpow(+x, yn));

    x = new Ctor(x);

    if (x.eq(1)) return x;

    pr = Ctor.precision;
    rm = Ctor.rounding;

    if (y.eq(1)) return finalise(x, pr, rm);

    // y exponent
    e = mathfloor(y.e / LOG_BASE);

    // If y is a small integer use the 'exponentiation by squaring' algorithm.
    if (e >= y.d.length - 1 && (k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
      r = intPow(Ctor, x, k, pr);
      return y.s < 0 ? new Ctor(1).div(r) : finalise(r, pr, rm);
    }

    s = x.s;

    // if x is negative
    if (s < 0) {

      // if y is not an integer
      if (e < y.d.length - 1) return new Ctor(NaN);

      // Result is positive if x is negative and the last digit of integer y is even.
      if ((y.d[e] & 1) == 0) s = 1;

      // if x.eq(-1)
      if (x.e == 0 && x.d[0] == 1 && x.d.length == 1) {
        x.s = s;
        return x;
      }
    }

    // Estimate result exponent.
    // x^y = 10^e,  where e = y * log10(x)
    // log10(x) = log10(x_significand) + x_exponent
    // log10(x_significand) = ln(x_significand) / ln(10)
    k = mathpow(+x, yn);
    e = k == 0 || !isFinite(k)
      ? mathfloor(yn * (Math.log('0.' + digitsToString(x.d)) / Math.LN10 + x.e + 1))
      : new Ctor(k + '').e;

    // Exponent estimate may be incorrect e.g. x: 0.999999999999999999, y: 2.29, e: 0, r.e: -1.

    // Overflow/underflow?
    if (e > Ctor.maxE + 1 || e < Ctor.minE - 1) return new Ctor(e > 0 ? s / 0 : 0);

    external = false;
    Ctor.rounding = x.s = 1;

    // Estimate the extra guard digits needed to ensure five correct rounding digits from
    // naturalLogarithm(x). Example of failure without these extra digits (precision: 10):
    // new Decimal(2.32456).pow('2087987436534566.46411')
    // should be 1.162377823e+764914905173815, but is 1.162355823e+764914905173815
    k = Math.min(12, (e + '').length);

    // r = x^y = exp(y*ln(x))
    r = naturalExponential(y.times(naturalLogarithm(x, pr + k)), pr);

    // r may be Infinity, e.g. (0.9999999999999999).pow(-1e+40)
    if (r.d) {

      // Truncate to the required precision plus five rounding digits.
      r = finalise(r, pr + 5, 1);

      // If the rounding digits are [49]9999 or [50]0000 increase the precision by 10 and recalculate
      // the result.
      if (checkRoundingDigits(r.d, pr, rm)) {
        e = pr + 10;

        // Truncate to the increased precision plus five rounding digits.
        r = finalise(naturalExponential(y.times(naturalLogarithm(x, e + k)), e), e + 5, 1);

        // Check for 14 nines from the 2nd rounding digit (the first rounding digit may be 4 or 9).
        if (+digitsToString(r.d).slice(pr + 1, pr + 15) + 1 == 1e14) {
          r = finalise(r, pr + 1, 0);
        }
      }
    }

    r.s = s;
    external = true;
    Ctor.rounding = rm;

    return finalise(r, pr, rm);
  };


  /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */
  P.toPrecision = function (sd, rm) {
    var str,
      x = this,
      Ctor = x.constructor;

    if (sd === void 0) {
      str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);
    } else {
      checkInt32(sd, 1, MAX_DIGITS);

      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);

      x = finalise(new Ctor(x), sd, rm);
      str = finiteToString(x, sd <= x.e || x.e <= Ctor.toExpNeg, sd);
    }

    return x.isNeg() && !x.isZero() ? '-' + str : str;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * 'toSD() digits out of range: {sd}'
   * 'toSD() digits not an integer: {sd}'
   * 'toSD() rounding mode not an integer: {rm}'
   * 'toSD() rounding mode out of range: {rm}'
   *
   */
  P.toSignificantDigits = P.toSD = function (sd, rm) {
    var x = this,
      Ctor = x.constructor;

    if (sd === void 0) {
      sd = Ctor.precision;
      rm = Ctor.rounding;
    } else {
      checkInt32(sd, 1, MAX_DIGITS);

      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);
    }

    return finalise(new Ctor(x), sd, rm);
  };


  /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */
  P.toString = function () {
    var x = this,
      Ctor = x.constructor,
      str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);

    return x.isNeg() && !x.isZero() ? '-' + str : str;
  };


  /*
   * Return a new Decimal whose value is the value of this Decimal truncated to a whole number.
   *
   */
  P.truncated = P.trunc = function () {
    return finalise(new this.constructor(this), this.e + 1, 1);
  };


  /*
   * Return a string representing the value of this Decimal.
   * Unlike `toString`, negative zero will include the minus sign.
   *
   */
  P.valueOf = P.toJSON = function () {
    var x = this,
      Ctor = x.constructor,
      str = finiteToString(x, x.e <= Ctor.toExpNeg || x.e >= Ctor.toExpPos);

    return x.isNeg() ? '-' + str : str;
  };


  // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.


  /*
   *  digitsToString           P.cubeRoot, P.logarithm, P.squareRoot, P.toFraction, P.toPower,
   *                           finiteToString, naturalExponential, naturalLogarithm
   *  checkInt32               P.toDecimalPlaces, P.toExponential, P.toFixed, P.toNearest,
   *                           P.toPrecision, P.toSignificantDigits, toStringBinary, random
   *  checkRoundingDigits      P.logarithm, P.toPower, naturalExponential, naturalLogarithm
   *  convertBase              toStringBinary, parseOther
   *  cos                      P.cos
   *  divide                   P.atanh, P.cubeRoot, P.dividedBy, P.dividedToIntegerBy,
   *                           P.logarithm, P.modulo, P.squareRoot, P.tan, P.tanh, P.toFraction,
   *                           P.toNearest, toStringBinary, naturalExponential, naturalLogarithm,
   *                           taylorSeries, atan2, parseOther
   *  finalise                 P.absoluteValue, P.atan, P.atanh, P.ceil, P.cos, P.cosh,
   *                           P.cubeRoot, P.dividedToIntegerBy, P.floor, P.logarithm, P.minus,
   *                           P.modulo, P.negated, P.plus, P.round, P.sin, P.sinh, P.squareRoot,
   *                           P.tan, P.times, P.toDecimalPlaces, P.toExponential, P.toFixed,
   *                           P.toNearest, P.toPower, P.toPrecision, P.toSignificantDigits,
   *                           P.truncated, divide, getLn10, getPi, naturalExponential,
   *                           naturalLogarithm, ceil, floor, round, trunc
   *  finiteToString           P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf,
   *                           toStringBinary
   *  getBase10Exponent        P.minus, P.plus, P.times, parseOther
   *  getLn10                  P.logarithm, naturalLogarithm
   *  getPi                    P.acos, P.asin, P.atan, toLessThanHalfPi, atan2
   *  getPrecision             P.precision, P.toFraction
   *  getZeroString            digitsToString, finiteToString
   *  intPow                   P.toPower, parseOther
   *  isOdd                    toLessThanHalfPi
   *  maxOrMin                 max, min
   *  naturalExponential       P.naturalExponential, P.toPower
   *  naturalLogarithm         P.acosh, P.asinh, P.atanh, P.logarithm, P.naturalLogarithm,
   *                           P.toPower, naturalExponential
   *  nonFiniteToString        finiteToString, toStringBinary
   *  parseDecimal             Decimal
   *  parseOther               Decimal
   *  sin                      P.sin
   *  taylorSeries             P.cosh, P.sinh, cos, sin
   *  toLessThanHalfPi         P.cos, P.sin
   *  toStringBinary           P.toBinary, P.toHexadecimal, P.toOctal
   *  truncate                 intPow
   *
   *  Throws:                  P.logarithm, P.precision, P.toFraction, checkInt32, getLn10, getPi,
   *                           naturalLogarithm, config, parseOther, random, Decimal
   */


  function digitsToString(d) {
    var i, k, ws,
      indexOfLastWord = d.length - 1,
      str = '',
      w = d[0];

    if (indexOfLastWord > 0) {
      str += w;
      for (i = 1; i < indexOfLastWord; i++) {
        ws = d[i] + '';
        k = LOG_BASE - ws.length;
        if (k) str += getZeroString(k);
        str += ws;
      }

      w = d[i];
      ws = w + '';
      k = LOG_BASE - ws.length;
      if (k) str += getZeroString(k);
    } else if (w === 0) {
      return '0';
    }

    // Remove trailing zeros of last w.
    for (; w % 10 === 0;) w /= 10;

    return str + w;
  }


  function checkInt32(i, min, max) {
    if (i !== ~~i || i < min || i > max) {
      throw Error(invalidArgument + i);
    }
  }


  /*
   * Check 5 rounding digits if `repeating` is null, 4 otherwise.
   * `repeating == null` if caller is `log` or `pow`,
   * `repeating != null` if caller is `naturalLogarithm` or `naturalExponential`.
   */
  function checkRoundingDigits(d, i, rm, repeating) {
    var di, k, r, rd;

    // Get the length of the first word of the array d.
    for (k = d[0]; k >= 10; k /= 10) --i;

    // Is the rounding digit in the first word of d?
    if (--i < 0) {
      i += LOG_BASE;
      di = 0;
    } else {
      di = Math.ceil((i + 1) / LOG_BASE);
      i %= LOG_BASE;
    }

    // i is the index (0 - 6) of the rounding digit.
    // E.g. if within the word 3487563 the first rounding digit is 5,
    // then i = 4, k = 1000, rd = 3487563 % 1000 = 563
    k = mathpow(10, LOG_BASE - i);
    rd = d[di] % k | 0;

    if (repeating == null) {
      if (i < 3) {
        if (i == 0) rd = rd / 100 | 0;
        else if (i == 1) rd = rd / 10 | 0;
        r = rm < 4 && rd == 99999 || rm > 3 && rd == 49999 || rd == 50000 || rd == 0;
      } else {
        r = (rm < 4 && rd + 1 == k || rm > 3 && rd + 1 == k / 2) &&
          (d[di + 1] / k / 100 | 0) == mathpow(10, i - 2) - 1 ||
            (rd == k / 2 || rd == 0) && (d[di + 1] / k / 100 | 0) == 0;
      }
    } else {
      if (i < 4) {
        if (i == 0) rd = rd / 1000 | 0;
        else if (i == 1) rd = rd / 100 | 0;
        else if (i == 2) rd = rd / 10 | 0;
        r = (repeating || rm < 4) && rd == 9999 || !repeating && rm > 3 && rd == 4999;
      } else {
        r = ((repeating || rm < 4) && rd + 1 == k ||
        (!repeating && rm > 3) && rd + 1 == k / 2) &&
          (d[di + 1] / k / 1000 | 0) == mathpow(10, i - 3) - 1;
      }
    }

    return r;
  }


  // Convert string of `baseIn` to an array of numbers of `baseOut`.
  // Eg. convertBase('255', 10, 16) returns [15, 15].
  // Eg. convertBase('ff', 16, 10) returns [2, 5, 5].
  function convertBase(str, baseIn, baseOut) {
    var j,
      arr = [0],
      arrL,
      i = 0,
      strL = str.length;

    for (; i < strL;) {
      for (arrL = arr.length; arrL--;) arr[arrL] *= baseIn;
      arr[0] += NUMERALS.indexOf(str.charAt(i++));
      for (j = 0; j < arr.length; j++) {
        if (arr[j] > baseOut - 1) {
          if (arr[j + 1] === void 0) arr[j + 1] = 0;
          arr[j + 1] += arr[j] / baseOut | 0;
          arr[j] %= baseOut;
        }
      }
    }

    return arr.reverse();
  }


  /*
   * cos(x) = 1 - x^2/2! + x^4/4! - ...
   * |x| < pi/2
   *
   */
  function cosine(Ctor, x) {
    var k, len, y;

    if (x.isZero()) return x;

    // Argument reduction: cos(4x) = 8*(cos^4(x) - cos^2(x)) + 1
    // i.e. cos(x) = 8*(cos^4(x/4) - cos^2(x/4)) + 1

    // Estimate the optimum number of times to use the argument reduction.
    len = x.d.length;
    if (len < 32) {
      k = Math.ceil(len / 3);
      y = (1 / tinyPow(4, k)).toString();
    } else {
      k = 16;
      y = '2.3283064365386962890625e-10';
    }

    Ctor.precision += k;

    x = taylorSeries(Ctor, 1, x.times(y), new Ctor(1));

    // Reverse argument reduction
    for (var i = k; i--;) {
      var cos2x = x.times(x);
      x = cos2x.times(cos2x).minus(cos2x).times(8).plus(1);
    }

    Ctor.precision -= k;

    return x;
  }


  /*
   * Perform division in the specified base.
   */
  var divide = (function () {

    // Assumes non-zero x and k, and hence non-zero result.
    function multiplyInteger(x, k, base) {
      var temp,
        carry = 0,
        i = x.length;

      for (x = x.slice(); i--;) {
        temp = x[i] * k + carry;
        x[i] = temp % base | 0;
        carry = temp / base | 0;
      }

      if (carry) x.unshift(carry);

      return x;
    }

    function compare(a, b, aL, bL) {
      var i, r;

      if (aL != bL) {
        r = aL > bL ? 1 : -1;
      } else {
        for (i = r = 0; i < aL; i++) {
          if (a[i] != b[i]) {
            r = a[i] > b[i] ? 1 : -1;
            break;
          }
        }
      }

      return r;
    }

    function subtract(a, b, aL, base) {
      var i = 0;

      // Subtract b from a.
      for (; aL--;) {
        a[aL] -= i;
        i = a[aL] < b[aL] ? 1 : 0;
        a[aL] = i * base + a[aL] - b[aL];
      }

      // Remove leading zeros.
      for (; !a[0] && a.length > 1;) a.shift();
    }

    return function (x, y, pr, rm, dp, base) {
      var cmp, e, i, k, logBase, more, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0,
        yL, yz,
        Ctor = x.constructor,
        sign = x.s == y.s ? 1 : -1,
        xd = x.d,
        yd = y.d;

      // Either NaN, Infinity or 0?
      if (!xd || !xd[0] || !yd || !yd[0]) {

        return new Ctor(// Return NaN if either NaN, or both Infinity or 0.
          !x.s || !y.s || (xd ? yd && xd[0] == yd[0] : !yd) ? NaN :

          // Return ±0 if x is 0 or y is ±Infinity, or return ±Infinity as y is 0.
          xd && xd[0] == 0 || !yd ? sign * 0 : sign / 0);
      }

      if (base) {
        logBase = 1;
        e = x.e - y.e;
      } else {
        base = BASE;
        logBase = LOG_BASE;
        e = mathfloor(x.e / logBase) - mathfloor(y.e / logBase);
      }

      yL = yd.length;
      xL = xd.length;
      q = new Ctor(sign);
      qd = q.d = [];

      // Result exponent may be one less than e.
      // The digit array of a Decimal from toStringBinary may have trailing zeros.
      for (i = 0; yd[i] == (xd[i] || 0); i++);

      if (yd[i] > (xd[i] || 0)) e--;

      if (pr == null) {
        sd = pr = Ctor.precision;
        rm = Ctor.rounding;
      } else if (dp) {
        sd = pr + (x.e - y.e) + 1;
      } else {
        sd = pr;
      }

      if (sd < 0) {
        qd.push(1);
        more = true;
      } else {

        // Convert precision in number of base 10 digits to base 1e7 digits.
        sd = sd / logBase + 2 | 0;
        i = 0;

        // divisor < 1e7
        if (yL == 1) {
          k = 0;
          yd = yd[0];
          sd++;

          // k is the carry.
          for (; (i < xL || k) && sd--; i++) {
            t = k * base + (xd[i] || 0);
            qd[i] = t / yd | 0;
            k = t % yd | 0;
          }

          more = k || i < xL;

        // divisor >= 1e7
        } else {

          // Normalise xd and yd so highest order digit of yd is >= base/2
          k = base / (yd[0] + 1) | 0;

          if (k > 1) {
            yd = multiplyInteger(yd, k, base);
            xd = multiplyInteger(xd, k, base);
            yL = yd.length;
            xL = xd.length;
          }

          xi = yL;
          rem = xd.slice(0, yL);
          remL = rem.length;

          // Add zeros to make remainder as long as divisor.
          for (; remL < yL;) rem[remL++] = 0;

          yz = yd.slice();
          yz.unshift(0);
          yd0 = yd[0];

          if (yd[1] >= base / 2) ++yd0;

          do {
            k = 0;

            // Compare divisor and remainder.
            cmp = compare(yd, rem, yL, remL);

            // If divisor < remainder.
            if (cmp < 0) {

              // Calculate trial digit, k.
              rem0 = rem[0];
              if (yL != remL) rem0 = rem0 * base + (rem[1] || 0);

              // k will be how many times the divisor goes into the current remainder.
              k = rem0 / yd0 | 0;

              //  Algorithm:
              //  1. product = divisor * trial digit (k)
              //  2. if product > remainder: product -= divisor, k--
              //  3. remainder -= product
              //  4. if product was < remainder at 2:
              //    5. compare new remainder and divisor
              //    6. If remainder > divisor: remainder -= divisor, k++

              if (k > 1) {
                if (k >= base) k = base - 1;

                // product = divisor * trial digit.
                prod = multiplyInteger(yd, k, base);
                prodL = prod.length;
                remL = rem.length;

                // Compare product and remainder.
                cmp = compare(prod, rem, prodL, remL);

                // product > remainder.
                if (cmp == 1) {
                  k--;

                  // Subtract divisor from product.
                  subtract(prod, yL < prodL ? yz : yd, prodL, base);
                }
              } else {

                // cmp is -1.
                // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                if (k == 0) cmp = k = 1;
                prod = yd.slice();
              }

              prodL = prod.length;
              if (prodL < remL) prod.unshift(0);

              // Subtract product from remainder.
              subtract(rem, prod, remL, base);

              // If product was < previous remainder.
              if (cmp == -1) {
                remL = rem.length;

                // Compare divisor and new remainder.
                cmp = compare(yd, rem, yL, remL);

                // If divisor < new remainder, subtract divisor from remainder.
                if (cmp < 1) {
                  k++;

                  // Subtract divisor from remainder.
                  subtract(rem, yL < remL ? yz : yd, remL, base);
                }
              }

              remL = rem.length;
            } else if (cmp === 0) {
              k++;
              rem = [0];
            }    // if cmp === 1, k will be 0

            // Add the next digit, k, to the result array.
            qd[i++] = k;

            // Update the remainder.
            if (cmp && rem[0]) {
              rem[remL++] = xd[xi] || 0;
            } else {
              rem = [xd[xi]];
              remL = 1;
            }

          } while ((xi++ < xL || rem[0] !== void 0) && sd--);

          more = rem[0] !== void 0;
        }

        // Leading zero?
        if (!qd[0]) qd.shift();
      }

      // logBase is 1 when divide is being used for base conversion.
      if (logBase == 1) {
        q.e = e;
        inexact = more;
      } else {

        // To calculate q.e, first get the number of digits of qd[0].
        for (i = 1, k = qd[0]; k >= 10; k /= 10) i++;
        q.e = i + e * logBase - 1;

        finalise(q, dp ? pr + q.e + 1 : pr, rm, more);
      }

      return q;
    };
  })();


  /*
   * Round `x` to `sd` significant digits using rounding mode `rm`.
   * Check for over/under-flow.
   */
   function finalise(x, sd, rm, isTruncated) {
    var digits, i, j, k, rd, roundUp, w, xd, xdi,
      Ctor = x.constructor;

    // Don't round if sd is null or undefined.
    out: if (sd != null) {
      xd = x.d;

      // Infinity/NaN.
      if (!xd) return x;

      // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
      // w: the word of xd containing rd, a base 1e7 number.
      // xdi: the index of w within xd.
      // digits: the number of digits of w.
      // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
      // they had leading zeros)
      // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).

      // Get the length of the first word of the digits array xd.
      for (digits = 1, k = xd[0]; k >= 10; k /= 10) digits++;
      i = sd - digits;

      // Is the rounding digit in the first word of xd?
      if (i < 0) {
        i += LOG_BASE;
        j = sd;
        w = xd[xdi = 0];

        // Get the rounding digit at index j of w.
        rd = w / mathpow(10, digits - j - 1) % 10 | 0;
      } else {
        xdi = Math.ceil((i + 1) / LOG_BASE);
        k = xd.length;
        if (xdi >= k) {
          if (isTruncated) {

            // Needed by `naturalExponential`, `naturalLogarithm` and `squareRoot`.
            for (; k++ <= xdi;) xd.push(0);
            w = rd = 0;
            digits = 1;
            i %= LOG_BASE;
            j = i - LOG_BASE + 1;
          } else {
            break out;
          }
        } else {
          w = k = xd[xdi];

          // Get the number of digits of w.
          for (digits = 1; k >= 10; k /= 10) digits++;

          // Get the index of rd within w.
          i %= LOG_BASE;

          // Get the index of rd within w, adjusted for leading zeros.
          // The number of leading zeros of w is given by LOG_BASE - digits.
          j = i - LOG_BASE + digits;

          // Get the rounding digit at index j of w.
          rd = j < 0 ? 0 : w / mathpow(10, digits - j - 1) % 10 | 0;
        }
      }

      // Are there any non-zero digits after the rounding digit?
      isTruncated = isTruncated || sd < 0 ||
        xd[xdi + 1] !== void 0 || (j < 0 ? w : w % mathpow(10, digits - j - 1));

      // The expression `w % mathpow(10, digits - j - 1)` returns all the digits of w to the right
      // of the digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression
      // will give 714.

      roundUp = rm < 4
        ? (rd || isTruncated) && (rm == 0 || rm == (x.s < 0 ? 3 : 2))
        : rd > 5 || rd == 5 && (rm == 4 || isTruncated || rm == 6 &&

          // Check whether the digit to the left of the rounding digit is odd.
          ((i > 0 ? j > 0 ? w / mathpow(10, digits - j) : 0 : xd[xdi - 1]) % 10) & 1 ||
            rm == (x.s < 0 ? 8 : 7));

      if (sd < 1 || !xd[0]) {
        xd.length = 0;
        if (roundUp) {

          // Convert sd to decimal places.
          sd -= x.e + 1;

          // 1, 0.1, 0.01, 0.001, 0.0001 etc.
          xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
          x.e = -sd || 0;
        } else {

          // Zero.
          xd[0] = x.e = 0;
        }

        return x;
      }

      // Remove excess digits.
      if (i == 0) {
        xd.length = xdi;
        k = 1;
        xdi--;
      } else {
        xd.length = xdi + 1;
        k = mathpow(10, LOG_BASE - i);

        // E.g. 56700 becomes 56000 if 7 is the rounding digit.
        // j > 0 means i > number of leading zeros of w.
        xd[xdi] = j > 0 ? (w / mathpow(10, digits - j) % mathpow(10, j) | 0) * k : 0;
      }

      if (roundUp) {
        for (;;) {

          // Is the digit to be rounded up in the first word of xd?
          if (xdi == 0) {

            // i will be the length of xd[0] before k is added.
            for (i = 1, j = xd[0]; j >= 10; j /= 10) i++;
            j = xd[0] += k;
            for (k = 1; j >= 10; j /= 10) k++;

            // if i != k the length has increased.
            if (i != k) {
              x.e++;
              if (xd[0] == BASE) xd[0] = 1;
            }

            break;
          } else {
            xd[xdi] += k;
            if (xd[xdi] != BASE) break;
            xd[xdi--] = 0;
            k = 1;
          }
        }
      }

      // Remove trailing zeros.
      for (i = xd.length; xd[--i] === 0;) xd.pop();
    }

    if (external) {

      // Overflow?
      if (x.e > Ctor.maxE) {

        // Infinity.
        x.d = null;
        x.e = NaN;

      // Underflow?
      } else if (x.e < Ctor.minE) {

        // Zero.
        x.e = 0;
        x.d = [0];
        // Ctor.underflow = true;
      } // else Ctor.underflow = false;
    }

    return x;
  }


  function finiteToString(x, isExp, sd) {
    if (!x.isFinite()) return nonFiniteToString(x);
    var k,
      e = x.e,
      str = digitsToString(x.d),
      len = str.length;

    if (isExp) {
      if (sd && (k = sd - len) > 0) {
        str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
      } else if (len > 1) {
        str = str.charAt(0) + '.' + str.slice(1);
      }

      str = str + (x.e < 0 ? 'e' : 'e+') + x.e;
    } else if (e < 0) {
      str = '0.' + getZeroString(-e - 1) + str;
      if (sd && (k = sd - len) > 0) str += getZeroString(k);
    } else if (e >= len) {
      str += getZeroString(e + 1 - len);
      if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
    } else {
      if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
      if (sd && (k = sd - len) > 0) {
        if (e + 1 === len) str += '.';
        str += getZeroString(k);
      }
    }

    return str;
  }


  // Calculate the base 10 exponent from the base 1e7 exponent.
  function getBase10Exponent(digits, e) {
    var w = digits[0];

    // Add the number of digits of the first word of the digits array.
    for ( e *= LOG_BASE; w >= 10; w /= 10) e++;
    return e;
  }


  function getLn10(Ctor, sd, pr) {
    if (sd > LN10_PRECISION) {

      // Reset global state in case the exception is caught.
      external = true;
      if (pr) Ctor.precision = pr;
      throw Error(precisionLimitExceeded);
    }
    return finalise(new Ctor(LN10), sd, 1, true);
  }


  function getPi(Ctor, sd, rm) {
    if (sd > PI_PRECISION) throw Error(precisionLimitExceeded);
    return finalise(new Ctor(PI), sd, rm, true);
  }


  function getPrecision(digits) {
    var w = digits.length - 1,
      len = w * LOG_BASE + 1;

    w = digits[w];

    // If non-zero...
    if (w) {

      // Subtract the number of trailing zeros of the last word.
      for (; w % 10 == 0; w /= 10) len--;

      // Add the number of digits of the first word.
      for (w = digits[0]; w >= 10; w /= 10) len++;
    }

    return len;
  }


  function getZeroString(k) {
    var zs = '';
    for (; k--;) zs += '0';
    return zs;
  }


  /*
   * Return a new Decimal whose value is the value of Decimal `x` to the power `n`, where `n` is an
   * integer of type number.
   *
   * Implements 'exponentiation by squaring'. Called by `pow` and `parseOther`.
   *
   */
  function intPow(Ctor, x, n, pr) {
    var isTruncated,
      r = new Ctor(1),

      // Max n of 9007199254740991 takes 53 loop iterations.
      // Maximum digits array length; leaves [28, 34] guard digits.
      k = Math.ceil(pr / LOG_BASE + 4);

    external = false;

    for (;;) {
      if (n % 2) {
        r = r.times(x);
        if (truncate(r.d, k)) isTruncated = true;
      }

      n = mathfloor(n / 2);
      if (n === 0) {

        // To ensure correct rounding when r.d is truncated, increment the last word if it is zero.
        n = r.d.length - 1;
        if (isTruncated && r.d[n] === 0) ++r.d[n];
        break;
      }

      x = x.times(x);
      truncate(x.d, k);
    }

    external = true;

    return r;
  }


  function isOdd(n) {
    return n.d[n.d.length - 1] & 1;
  }


  /*
   * Handle `max` and `min`. `ltgt` is 'lt' or 'gt'.
   */
  function maxOrMin(Ctor, args, ltgt) {
    var y,
      x = new Ctor(args[0]),
      i = 0;

    for (; ++i < args.length;) {
      y = new Ctor(args[i]);
      if (!y.s) {
        x = y;
        break;
      } else if (x[ltgt](y)) {
        x = y;
      }
    }

    return x;
  }


  /*
   * Return a new Decimal whose value is the natural exponential of `x` rounded to `sd` significant
   * digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * Max integer argument: exp('20723265836946413') = 6.3e+9000000000000000
   * Min integer argument: exp('-20723265836946411') = 1.2e-9000000000000000
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(Infinity)  = Infinity
   *  exp(-Infinity) = 0
   *  exp(NaN)       = NaN
   *  exp(±0)        = 1
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   *  The result will always be correctly rounded.
   *
   */
  function naturalExponential(x, sd) {
    var denominator, guard, j, pow, sum, t, wpr,
      rep = 0,
      i = 0,
      k = 0,
      Ctor = x.constructor,
      rm = Ctor.rounding,
      pr = Ctor.precision;

    // 0/NaN/Infinity?
    if (!x.d || !x.d[0] || x.e > 17) {

      return new Ctor(x.d
        ? !x.d[0] ? 1 : x.s < 0 ? 0 : 1 / 0
        : x.s ? x.s < 0 ? 0 : x : 0 / 0);
    }

    if (sd == null) {
      external = false;
      wpr = pr;
    } else {
      wpr = sd;
    }

    t = new Ctor(0.03125);

    // while abs(x) >= 0.1
    while (x.e > -2) {

      // x = x / 2^5
      x = x.times(t);
      k += 5;
    }

    // Use 2 * log10(2^k) + 5 (empirically derived) to estimate the increase in precision
    // necessary to ensure the first 4 rounding digits are correct.
    guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
    wpr += guard;
    denominator = pow = sum = new Ctor(1);
    Ctor.precision = wpr;

    for (;;) {
      pow = finalise(pow.times(x), wpr, 1);
      denominator = denominator.times(++i);
      t = sum.plus(divide(pow, denominator, wpr, 1));

      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
        j = k;
        while (j--) sum = finalise(sum.times(sum), wpr, 1);

        // Check to see if the first 4 rounding digits are [49]999.
        // If so, repeat the summation with a higher precision, otherwise
        // e.g. with precision: 18, rounding: 1
        // exp(18.404272462595034083567793919843761) = 98372560.1229999999 (should be 98372560.123)
        // `wpr - guard` is the index of first rounding digit.
        if (sd == null) {

          if (rep < 3 && checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
            Ctor.precision = wpr += 10;
            denominator = pow = t = new Ctor(1);
            i = 0;
            rep++;
          } else {
            return finalise(sum, Ctor.precision = pr, rm, external = true);
          }
        } else {
          Ctor.precision = pr;
          return sum;
        }
      }

      sum = t;
    }
  }


  /*
   * Return a new Decimal whose value is the natural logarithm of `x` rounded to `sd` significant
   * digits.
   *
   *  ln(-n)        = NaN
   *  ln(0)         = -Infinity
   *  ln(-0)        = -Infinity
   *  ln(1)         = 0
   *  ln(Infinity)  = Infinity
   *  ln(-Infinity) = NaN
   *  ln(NaN)       = NaN
   *
   *  ln(n) (n != 1) is non-terminating.
   *
   */
  function naturalLogarithm(y, sd) {
    var c, c0, denominator, e, numerator, rep, sum, t, wpr, x1, x2,
      n = 1,
      guard = 10,
      x = y,
      xd = x.d,
      Ctor = x.constructor,
      rm = Ctor.rounding,
      pr = Ctor.precision;

    // Is x negative or Infinity, NaN, 0 or 1?
    if (x.s < 0 || !xd || !xd[0] || !x.e && xd[0] == 1 && xd.length == 1) {
      return new Ctor(xd && !xd[0] ? -1 / 0 : x.s != 1 ? NaN : xd ? 0 : x);
    }

    if (sd == null) {
      external = false;
      wpr = pr;
    } else {
      wpr = sd;
    }

    Ctor.precision = wpr += guard;
    c = digitsToString(xd);
    c0 = c.charAt(0);

    if (Math.abs(e = x.e) < 1.5e15) {

      // Argument reduction.
      // The series converges faster the closer the argument is to 1, so using
      // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
      // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
      // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
      // later be divided by this number, then separate out the power of 10 using
      // ln(a*10^b) = ln(a) + b*ln(10).

      // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
      //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
      // max n is 6 (gives 0.7 - 1.3)
      while (c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3) {
        x = x.times(y);
        c = digitsToString(x.d);
        c0 = c.charAt(0);
        n++;
      }

      e = x.e;

      if (c0 > 1) {
        x = new Ctor('0.' + c);
        e++;
      } else {
        x = new Ctor(c0 + '.' + c.slice(1));
      }
    } else {

      // The argument reduction method above may result in overflow if the argument y is a massive
      // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
      // function using ln(x*10^e) = ln(x) + e*ln(10).
      t = getLn10(Ctor, wpr + 2, pr).times(e + '');
      x = naturalLogarithm(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
      Ctor.precision = pr;

      return sd == null ? finalise(x, pr, rm, external = true) : x;
    }

    // x1 is x reduced to a value near 1.
    x1 = x;

    // Taylor series.
    // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
    // where x = (y - 1)/(y + 1)    (|x| < 1)
    sum = numerator = x = divide(x.minus(1), x.plus(1), wpr, 1);
    x2 = finalise(x.times(x), wpr, 1);
    denominator = 3;

    for (;;) {
      numerator = finalise(numerator.times(x2), wpr, 1);
      t = sum.plus(divide(numerator, new Ctor(denominator), wpr, 1));

      if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
        sum = sum.times(2);

        // Reverse the argument reduction. Check that e is not 0 because, besides preventing an
        // unnecessary calculation, -0 + 0 = +0 and to ensure correct rounding -0 needs to stay -0.
        if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
        sum = divide(sum, new Ctor(n), wpr, 1);

        // Is rm > 3 and the first 4 rounding digits 4999, or rm < 4 (or the summation has
        // been repeated previously) and the first 4 rounding digits 9999?
        // If so, restart the summation with a higher precision, otherwise
        // e.g. with precision: 12, rounding: 1
        // ln(135520028.6126091714265381533) = 18.7246299999 when it should be 18.72463.
        // `wpr - guard` is the index of first rounding digit.
        if (sd == null) {
          if (checkRoundingDigits(sum.d, wpr - guard, rm, rep)) {
            Ctor.precision = wpr += guard;
            t = numerator = x = divide(x1.minus(1), x1.plus(1), wpr, 1);
            x2 = finalise(x.times(x), wpr, 1);
            denominator = rep = 1;
          } else {
            return finalise(sum, Ctor.precision = pr, rm, external = true);
          }
        } else {
          Ctor.precision = pr;
          return sum;
        }
      }

      sum = t;
      denominator += 2;
    }
  }


  // ±Infinity, NaN.
  function nonFiniteToString(x) {
    // Unsigned.
    return String(x.s * x.s / 0);
  }


  /*
   * Parse the value of a new Decimal `x` from string `str`.
   */
  function parseDecimal(x, str) {
    var e, i, len;

    // Decimal point?
    if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');

    // Exponential form?
    if ((i = str.search(/e/i)) > 0) {

      // Determine exponent.
      if (e < 0) e = i;
      e += +str.slice(i + 1);
      str = str.substring(0, i);
    } else if (e < 0) {

      // Integer.
      e = str.length;
    }

    // Determine leading zeros.
    for (i = 0; str.charCodeAt(i) === 48; i++);

    // Determine trailing zeros.
    for (len = str.length; str.charCodeAt(len - 1) === 48; --len);
    str = str.slice(i, len);

    if (str) {
      len -= i;
      x.e = e = e - i - 1;
      x.d = [];

      // Transform base

      // e is the base 10 exponent.
      // i is where to slice str to get the first word of the digits array.
      i = (e + 1) % LOG_BASE;
      if (e < 0) i += LOG_BASE;

      if (i < len) {
        if (i) x.d.push(+str.slice(0, i));
        for (len -= LOG_BASE; i < len;) x.d.push(+str.slice(i, i += LOG_BASE));
        str = str.slice(i);
        i = LOG_BASE - str.length;
      } else {
        i -= len;
      }

      for (; i--;) str += '0';
      x.d.push(+str);

      if (external) {

        // Overflow?
        if (x.e > x.constructor.maxE) {

          // Infinity.
          x.d = null;
          x.e = NaN;

        // Underflow?
        } else if (x.e < x.constructor.minE) {

          // Zero.
          x.e = 0;
          x.d = [0];
          // x.constructor.underflow = true;
        } // else x.constructor.underflow = false;
      }
    } else {

      // Zero.
      x.e = 0;
      x.d = [0];
    }

    return x;
  }


  /*
   * Parse the value of a new Decimal `x` from a string `str`, which is not a decimal value.
   */
  function parseOther(x, str) {
    var base, Ctor, divisor, i, isFloat, len, p, xd, xe;

    if (str.indexOf('_') > -1) {
      str = str.replace(/(\d)_(?=\d)/g, '$1');
      if (isDecimal.test(str)) return parseDecimal(x, str);
    } else if (str === 'Infinity' || str === 'NaN') {
      if (!+str) x.s = NaN;
      x.e = NaN;
      x.d = null;
      return x;
    }

    if (isHex.test(str))  {
      base = 16;
      str = str.toLowerCase();
    } else if (isBinary.test(str))  {
      base = 2;
    } else if (isOctal.test(str))  {
      base = 8;
    } else {
      throw Error(invalidArgument + str);
    }

    // Is there a binary exponent part?
    i = str.search(/p/i);

    if (i > 0) {
      p = +str.slice(i + 1);
      str = str.substring(2, i);
    } else {
      str = str.slice(2);
    }

    // Convert `str` as an integer then divide the result by `base` raised to a power such that the
    // fraction part will be restored.
    i = str.indexOf('.');
    isFloat = i >= 0;
    Ctor = x.constructor;

    if (isFloat) {
      str = str.replace('.', '');
      len = str.length;
      i = len - i;

      // log[10](16) = 1.2041... , log[10](88) = 1.9444....
      divisor = intPow(Ctor, new Ctor(base), i, i * 2);
    }

    xd = convertBase(str, base, BASE);
    xe = xd.length - 1;

    // Remove trailing zeros.
    for (i = xe; xd[i] === 0; --i) xd.pop();
    if (i < 0) return new Ctor(x.s * 0);
    x.e = getBase10Exponent(xd, xe);
    x.d = xd;
    external = false;

    // At what precision to perform the division to ensure exact conversion?
    // maxDecimalIntegerPartDigitCount = ceil(log[10](b) * otherBaseIntegerPartDigitCount)
    // log[10](2) = 0.30103, log[10](8) = 0.90309, log[10](16) = 1.20412
    // E.g. ceil(1.2 * 3) = 4, so up to 4 decimal digits are needed to represent 3 hex int digits.
    // maxDecimalFractionPartDigitCount = {Hex:4|Oct:3|Bin:1} * otherBaseFractionPartDigitCount
    // Therefore using 4 * the number of digits of str will always be enough.
    if (isFloat) x = divide(x, divisor, len * 4);

    // Multiply by the binary exponent part if present.
    if (p) x = x.times(Math.abs(p) < 54 ? mathpow(2, p) : Decimal.pow(2, p));
    external = true;

    return x;
  }


  /*
   * sin(x) = x - x^3/3! + x^5/5! - ...
   * |x| < pi/2
   *
   */
  function sine(Ctor, x) {
    var k,
      len = x.d.length;

    if (len < 3) {
      return x.isZero() ? x : taylorSeries(Ctor, 2, x, x);
    }

    // Argument reduction: sin(5x) = 16*sin^5(x) - 20*sin^3(x) + 5*sin(x)
    // i.e. sin(x) = 16*sin^5(x/5) - 20*sin^3(x/5) + 5*sin(x/5)
    // and  sin(x) = sin(x/5)(5 + sin^2(x/5)(16sin^2(x/5) - 20))

    // Estimate the optimum number of times to use the argument reduction.
    k = 1.4 * Math.sqrt(len);
    k = k > 16 ? 16 : k | 0;

    x = x.times(1 / tinyPow(5, k));
    x = taylorSeries(Ctor, 2, x, x);

    // Reverse argument reduction
    var sin2_x,
      d5 = new Ctor(5),
      d16 = new Ctor(16),
      d20 = new Ctor(20);
    for (; k--;) {
      sin2_x = x.times(x);
      x = x.times(d5.plus(sin2_x.times(d16.times(sin2_x).minus(d20))));
    }

    return x;
  }


  // Calculate Taylor series for `cos`, `cosh`, `sin` and `sinh`.
  function taylorSeries(Ctor, n, x, y, isHyperbolic) {
    var j, t, u, x2,
      i = 1,
      pr = Ctor.precision,
      k = Math.ceil(pr / LOG_BASE);

    external = false;
    x2 = x.times(x);
    u = new Ctor(y);

    for (;;) {
      t = divide(u.times(x2), new Ctor(n++ * n++), pr, 1);
      u = isHyperbolic ? y.plus(t) : y.minus(t);
      y = divide(t.times(x2), new Ctor(n++ * n++), pr, 1);
      t = u.plus(y);

      if (t.d[k] !== void 0) {
        for (j = k; t.d[j] === u.d[j] && j--;);
        if (j == -1) break;
      }

      j = u;
      u = y;
      y = t;
      t = j;
      i++;
    }

    external = true;
    t.d.length = k + 1;

    return t;
  }


  // Exponent e must be positive and non-zero.
  function tinyPow(b, e) {
    var n = b;
    while (--e) n *= b;
    return n;
  }


  // Return the absolute value of `x` reduced to less than or equal to half pi.
  function toLessThanHalfPi(Ctor, x) {
    var t,
      isNeg = x.s < 0,
      pi = getPi(Ctor, Ctor.precision, 1),
      halfPi = pi.times(0.5);

    x = x.abs();

    if (x.lte(halfPi)) {
      quadrant = isNeg ? 4 : 1;
      return x;
    }

    t = x.divToInt(pi);

    if (t.isZero()) {
      quadrant = isNeg ? 3 : 2;
    } else {
      x = x.minus(t.times(pi));

      // 0 <= x < pi
      if (x.lte(halfPi)) {
        quadrant = isOdd(t) ? (isNeg ? 2 : 3) : (isNeg ? 4 : 1);
        return x;
      }

      quadrant = isOdd(t) ? (isNeg ? 1 : 4) : (isNeg ? 3 : 2);
    }

    return x.minus(pi).abs();
  }


  /*
   * Return the value of Decimal `x` as a string in base `baseOut`.
   *
   * If the optional `sd` argument is present include a binary exponent suffix.
   */
  function toStringBinary(x, baseOut, sd, rm) {
    var base, e, i, k, len, roundUp, str, xd, y,
      Ctor = x.constructor,
      isExp = sd !== void 0;

    if (isExp) {
      checkInt32(sd, 1, MAX_DIGITS);
      if (rm === void 0) rm = Ctor.rounding;
      else checkInt32(rm, 0, 8);
    } else {
      sd = Ctor.precision;
      rm = Ctor.rounding;
    }

    if (!x.isFinite()) {
      str = nonFiniteToString(x);
    } else {
      str = finiteToString(x);
      i = str.indexOf('.');

      // Use exponential notation according to `toExpPos` and `toExpNeg`? No, but if required:
      // maxBinaryExponent = floor((decimalExponent + 1) * log[2](10))
      // minBinaryExponent = floor(decimalExponent * log[2](10))
      // log[2](10) = 3.321928094887362347870319429489390175864

      if (isExp) {
        base = 2;
        if (baseOut == 16) {
          sd = sd * 4 - 3;
        } else if (baseOut == 8) {
          sd = sd * 3 - 2;
        }
      } else {
        base = baseOut;
      }

      // Convert the number as an integer then divide the result by its base raised to a power such
      // that the fraction part will be restored.

      // Non-integer.
      if (i >= 0) {
        str = str.replace('.', '');
        y = new Ctor(1);
        y.e = str.length - i;
        y.d = convertBase(finiteToString(y), 10, base);
        y.e = y.d.length;
      }

      xd = convertBase(str, 10, base);
      e = len = xd.length;

      // Remove trailing zeros.
      for (; xd[--len] == 0;) xd.pop();

      if (!xd[0]) {
        str = isExp ? '0p+0' : '0';
      } else {
        if (i < 0) {
          e--;
        } else {
          x = new Ctor(x);
          x.d = xd;
          x.e = e;
          x = divide(x, y, sd, rm, 0, base);
          xd = x.d;
          e = x.e;
          roundUp = inexact;
        }

        // The rounding digit, i.e. the digit after the digit that may be rounded up.
        i = xd[sd];
        k = base / 2;
        roundUp = roundUp || xd[sd + 1] !== void 0;

        roundUp = rm < 4
          ? (i !== void 0 || roundUp) && (rm === 0 || rm === (x.s < 0 ? 3 : 2))
          : i > k || i === k && (rm === 4 || roundUp || rm === 6 && xd[sd - 1] & 1 ||
            rm === (x.s < 0 ? 8 : 7));

        xd.length = sd;

        if (roundUp) {

          // Rounding up may mean the previous digit has to be rounded up and so on.
          for (; ++xd[--sd] > base - 1;) {
            xd[sd] = 0;
            if (!sd) {
              ++e;
              xd.unshift(1);
            }
          }
        }

        // Determine trailing zeros.
        for (len = xd.length; !xd[len - 1]; --len);

        // E.g. [4, 11, 15] becomes 4bf.
        for (i = 0, str = ''; i < len; i++) str += NUMERALS.charAt(xd[i]);

        // Add binary exponent suffix?
        if (isExp) {
          if (len > 1) {
            if (baseOut == 16 || baseOut == 8) {
              i = baseOut == 16 ? 4 : 3;
              for (--len; len % i; len++) str += '0';
              xd = convertBase(str, base, baseOut);
              for (len = xd.length; !xd[len - 1]; --len);

              // xd[0] will always be be 1
              for (i = 1, str = '1.'; i < len; i++) str += NUMERALS.charAt(xd[i]);
            } else {
              str = str.charAt(0) + '.' + str.slice(1);
            }
          }

          str =  str + (e < 0 ? 'p' : 'p+') + e;
        } else if (e < 0) {
          for (; ++e;) str = '0' + str;
          str = '0.' + str;
        } else {
          if (++e > len) for (e -= len; e-- ;) str += '0';
          else if (e < len) str = str.slice(0, e) + '.' + str.slice(e);
        }
      }

      str = (baseOut == 16 ? '0x' : baseOut == 2 ? '0b' : baseOut == 8 ? '0o' : '') + str;
    }

    return x.s < 0 ? '-' + str : str;
  }


  // Does not strip trailing zeros.
  function truncate(arr, len) {
    if (arr.length > len) {
      arr.length = len;
      return true;
    }
  }


  // Decimal methods


  /*
   *  abs
   *  acos
   *  acosh
   *  add
   *  asin
   *  asinh
   *  atan
   *  atanh
   *  atan2
   *  cbrt
   *  ceil
   *  clamp
   *  clone
   *  config
   *  cos
   *  cosh
   *  div
   *  exp
   *  floor
   *  hypot
   *  ln
   *  log
   *  log2
   *  log10
   *  max
   *  min
   *  mod
   *  mul
   *  pow
   *  random
   *  round
   *  set
   *  sign
   *  sin
   *  sinh
   *  sqrt
   *  sub
   *  sum
   *  tan
   *  tanh
   *  trunc
   */


  /*
   * Return a new Decimal whose value is the absolute value of `x`.
   *
   * x {number|string|Decimal}
   *
   */
  function abs(x) {
    return new this(x).abs();
  }


  /*
   * Return a new Decimal whose value is the arccosine in radians of `x`.
   *
   * x {number|string|Decimal}
   *
   */
  function acos(x) {
    return new this(x).acos();
  }


  /*
   * Return a new Decimal whose value is the inverse of the hyperbolic cosine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */
  function acosh(x) {
    return new this(x).acosh();
  }


  /*
   * Return a new Decimal whose value is the sum of `x` and `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */
  function add(x, y) {
    return new this(x).plus(y);
  }


  /*
   * Return a new Decimal whose value is the arcsine in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */
  function asin(x) {
    return new this(x).asin();
  }


  /*
   * Return a new Decimal whose value is the inverse of the hyperbolic sine of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */
  function asinh(x) {
    return new this(x).asinh();
  }


  /*
   * Return a new Decimal whose value is the arctangent in radians of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */
  function atan(x) {
    return new this(x).atan();
  }


  /*
   * Return a new Decimal whose value is the inverse of the hyperbolic tangent of `x`, rounded to
   * `precision` significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */
  function atanh(x) {
    return new this(x).atanh();
  }


  /*
   * Return a new Decimal whose value is the arctangent in radians of `y/x` in the range -pi to pi
   * (inclusive), rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * Domain: [-Infinity, Infinity]
   * Range: [-pi, pi]
   *
   * y {number|string|Decimal} The y-coordinate.
   * x {number|string|Decimal} The x-coordinate.
   *
   * atan2(±0, -0)               = ±pi
   * atan2(±0, +0)               = ±0
   * atan2(±0, -x)               = ±pi for x > 0
   * atan2(±0, x)                = ±0 for x > 0
   * atan2(-y, ±0)               = -pi/2 for y > 0
   * atan2(y, ±0)                = pi/2 for y > 0
   * atan2(±y, -Infinity)        = ±pi for finite y > 0
   * atan2(±y, +Infinity)        = ±0 for finite y > 0
   * atan2(±Infinity, x)         = ±pi/2 for finite x
   * atan2(±Infinity, -Infinity) = ±3*pi/4
   * atan2(±Infinity, +Infinity) = ±pi/4
   * atan2(NaN, x) = NaN
   * atan2(y, NaN) = NaN
   *
   */
  function atan2(y, x) {
    y = new this(y);
    x = new this(x);
    var r,
      pr = this.precision,
      rm = this.rounding,
      wpr = pr + 4;

    // Either NaN
    if (!y.s || !x.s) {
      r = new this(NaN);

    // Both ±Infinity
    } else if (!y.d && !x.d) {
      r = getPi(this, wpr, 1).times(x.s > 0 ? 0.25 : 0.75);
      r.s = y.s;

    // x is ±Infinity or y is ±0
    } else if (!x.d || y.isZero()) {
      r = x.s < 0 ? getPi(this, pr, rm) : new this(0);
      r.s = y.s;

    // y is ±Infinity or x is ±0
    } else if (!y.d || x.isZero()) {
      r = getPi(this, wpr, 1).times(0.5);
      r.s = y.s;

    // Both non-zero and finite
    } else if (x.s < 0) {
      this.precision = wpr;
      this.rounding = 1;
      r = this.atan(divide(y, x, wpr, 1));
      x = getPi(this, wpr, 1);
      this.precision = pr;
      this.rounding = rm;
      r = y.s < 0 ? r.minus(x) : r.plus(x);
    } else {
      r = this.atan(divide(y, x, wpr, 1));
    }

    return r;
  }


  /*
   * Return a new Decimal whose value is the cube root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */
  function cbrt(x) {
    return new this(x).cbrt();
  }


  /*
   * Return a new Decimal whose value is `x` rounded to an integer using `ROUND_CEIL`.
   *
   * x {number|string|Decimal}
   *
   */
  function ceil(x) {
    return finalise(x = new this(x), x.e + 1, 2);
  }


  /*
   * Return a new Decimal whose value is `x` clamped to the range delineated by `min` and `max`.
   *
   * x {number|string|Decimal}
   * min {number|string|Decimal}
   * max {number|string|Decimal}
   *
   */
  function clamp(x, min, max) {
    return new this(x).clamp(min, max);
  }


  /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *   maxE       {number}
   *   minE       {number}
   *   modulo     {number}
   *   crypto     {boolean|number}
   *   defaults   {true}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */
  function config(obj) {
    if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
    var i, p, v,
      useDefaults = obj.defaults === true,
      ps = [
        'precision', 1, MAX_DIGITS,
        'rounding', 0, 8,
        'toExpNeg', -EXP_LIMIT, 0,
        'toExpPos', 0, EXP_LIMIT,
        'maxE', 0, EXP_LIMIT,
        'minE', -EXP_LIMIT, 0,
        'modulo', 0, 9
      ];

    for (i = 0; i < ps.length; i += 3) {
      if (p = ps[i], useDefaults) this[p] = DEFAULTS[p];
      if ((v = obj[p]) !== void 0) {
        if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
        else throw Error(invalidArgument + p + ': ' + v);
      }
    }

    if (p = 'crypto', useDefaults) this[p] = DEFAULTS[p];
    if ((v = obj[p]) !== void 0) {
      if (v === true || v === false || v === 0 || v === 1) {
        if (v) {
          if (typeof crypto != 'undefined' && crypto &&
            (crypto.getRandomValues || crypto.randomBytes)) {
            this[p] = true;
          } else {
            throw Error(cryptoUnavailable);
          }
        } else {
          this[p] = false;
        }
      } else {
        throw Error(invalidArgument + p + ': ' + v);
      }
    }

    return this;
  }


  /*
   * Return a new Decimal whose value is the cosine of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */
  function cos(x) {
    return new this(x).cos();
  }


  /*
   * Return a new Decimal whose value is the hyperbolic cosine of `x`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */
  function cosh(x) {
    return new this(x).cosh();
  }


  /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */
  function clone(obj) {
    var i, p, ps;

    /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * v {number|string|Decimal} A numeric value.
     *
     */
    function Decimal(v) {
      var e, i, t,
        x = this;

      // Decimal called without new.
      if (!(x instanceof Decimal)) return new Decimal(v);

      // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
      // which points to Object.
      x.constructor = Decimal;

      // Duplicate.
      if (isDecimalInstance(v)) {
        x.s = v.s;

        if (external) {
          if (!v.d || v.e > Decimal.maxE) {

            // Infinity.
            x.e = NaN;
            x.d = null;
          } else if (v.e < Decimal.minE) {

            // Zero.
            x.e = 0;
            x.d = [0];
          } else {
            x.e = v.e;
            x.d = v.d.slice();
          }
        } else {
          x.e = v.e;
          x.d = v.d ? v.d.slice() : v.d;
        }

        return;
      }

      t = typeof v;

      if (t === 'number') {
        if (v === 0) {
          x.s = 1 / v < 0 ? -1 : 1;
          x.e = 0;
          x.d = [0];
          return;
        }

        if (v < 0) {
          v = -v;
          x.s = -1;
        } else {
          x.s = 1;
        }

        // Fast path for small integers.
        if (v === ~~v && v < 1e7) {
          for (e = 0, i = v; i >= 10; i /= 10) e++;

          if (external) {
            if (e > Decimal.maxE) {
              x.e = NaN;
              x.d = null;
            } else if (e < Decimal.minE) {
              x.e = 0;
              x.d = [0];
            } else {
              x.e = e;
              x.d = [v];
            }
          } else {
            x.e = e;
            x.d = [v];
          }

          return;

        // Infinity, NaN.
        } else if (v * 0 !== 0) {
          if (!v) x.s = NaN;
          x.e = NaN;
          x.d = null;
          return;
        }

        return parseDecimal(x, v.toString());

      } else if (t !== 'string') {
        throw Error(invalidArgument + v);
      }

      // Minus sign?
      if ((i = v.charCodeAt(0)) === 45) {
        v = v.slice(1);
        x.s = -1;
      } else {
        // Plus sign?
        if (i === 43) v = v.slice(1);
        x.s = 1;
      }

      return isDecimal.test(v) ? parseDecimal(x, v) : parseOther(x, v);
    }

    Decimal.prototype = P;

    Decimal.ROUND_UP = 0;
    Decimal.ROUND_DOWN = 1;
    Decimal.ROUND_CEIL = 2;
    Decimal.ROUND_FLOOR = 3;
    Decimal.ROUND_HALF_UP = 4;
    Decimal.ROUND_HALF_DOWN = 5;
    Decimal.ROUND_HALF_EVEN = 6;
    Decimal.ROUND_HALF_CEIL = 7;
    Decimal.ROUND_HALF_FLOOR = 8;
    Decimal.EUCLID = 9;

    Decimal.config = Decimal.set = config;
    Decimal.clone = clone;
    Decimal.isDecimal = isDecimalInstance;

    Decimal.abs = abs;
    Decimal.acos = acos;
    Decimal.acosh = acosh;        // ES6
    Decimal.add = add;
    Decimal.asin = asin;
    Decimal.asinh = asinh;        // ES6
    Decimal.atan = atan;
    Decimal.atanh = atanh;        // ES6
    Decimal.atan2 = atan2;
    Decimal.cbrt = cbrt;          // ES6
    Decimal.ceil = ceil;
    Decimal.clamp = clamp;
    Decimal.cos = cos;
    Decimal.cosh = cosh;          // ES6
    Decimal.div = div;
    Decimal.exp = exp;
    Decimal.floor = floor;
    Decimal.hypot = hypot;        // ES6
    Decimal.ln = ln;
    Decimal.log = log;
    Decimal.log10 = log10;        // ES6
    Decimal.log2 = log2;          // ES6
    Decimal.max = max;
    Decimal.min = min;
    Decimal.mod = mod;
    Decimal.mul = mul;
    Decimal.pow = pow;
    Decimal.random = random;
    Decimal.round = round;
    Decimal.sign = sign;          // ES6
    Decimal.sin = sin;
    Decimal.sinh = sinh;          // ES6
    Decimal.sqrt = sqrt;
    Decimal.sub = sub;
    Decimal.sum = sum;
    Decimal.tan = tan;
    Decimal.tanh = tanh;          // ES6
    Decimal.trunc = trunc;        // ES6

    if (obj === void 0) obj = {};
    if (obj) {
      if (obj.defaults !== true) {
        ps = ['precision', 'rounding', 'toExpNeg', 'toExpPos', 'maxE', 'minE', 'modulo', 'crypto'];
        for (i = 0; i < ps.length;) if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
      }
    }

    Decimal.config(obj);

    return Decimal;
  }


  /*
   * Return a new Decimal whose value is `x` divided by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */
  function div(x, y) {
    return new this(x).div(y);
  }


  /*
   * Return a new Decimal whose value is the natural exponential of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} The power to which to raise the base of the natural log.
   *
   */
  function exp(x) {
    return new this(x).exp();
  }


  /*
   * Return a new Decimal whose value is `x` round to an integer using `ROUND_FLOOR`.
   *
   * x {number|string|Decimal}
   *
   */
  function floor(x) {
    return finalise(x = new this(x), x.e + 1, 3);
  }


  /*
   * Return a new Decimal whose value is the square root of the sum of the squares of the arguments,
   * rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * hypot(a, b, ...) = sqrt(a^2 + b^2 + ...)
   *
   * arguments {number|string|Decimal}
   *
   */
  function hypot() {
    var i, n,
      t = new this(0);

    external = false;

    for (i = 0; i < arguments.length;) {
      n = new this(arguments[i++]);
      if (!n.d) {
        if (n.s) {
          external = true;
          return new this(1 / 0);
        }
        t = n;
      } else if (t.d) {
        t = t.plus(n.times(n));
      }
    }

    external = true;

    return t.sqrt();
  }


  /*
   * Return true if object is a Decimal instance (where Decimal is any Decimal constructor),
   * otherwise return false.
   *
   */
  function isDecimalInstance(obj) {
    return obj instanceof Decimal || obj && obj.toStringTag === tag || false;
  }


  /*
   * Return a new Decimal whose value is the natural logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */
  function ln(x) {
    return new this(x).ln();
  }


  /*
   * Return a new Decimal whose value is the log of `x` to the base `y`, or to base 10 if no base
   * is specified, rounded to `precision` significant digits using rounding mode `rounding`.
   *
   * log[y](x)
   *
   * x {number|string|Decimal} The argument of the logarithm.
   * y {number|string|Decimal} The base of the logarithm.
   *
   */
  function log(x, y) {
    return new this(x).log(y);
  }


  /*
   * Return a new Decimal whose value is the base 2 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */
  function log2(x) {
    return new this(x).log(2);
  }


  /*
   * Return a new Decimal whose value is the base 10 logarithm of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */
  function log10(x) {
    return new this(x).log(10);
  }


  /*
   * Return a new Decimal whose value is the maximum of the arguments.
   *
   * arguments {number|string|Decimal}
   *
   */
  function max() {
    return maxOrMin(this, arguments, 'lt');
  }


  /*
   * Return a new Decimal whose value is the minimum of the arguments.
   *
   * arguments {number|string|Decimal}
   *
   */
  function min() {
    return maxOrMin(this, arguments, 'gt');
  }


  /*
   * Return a new Decimal whose value is `x` modulo `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */
  function mod(x, y) {
    return new this(x).mod(y);
  }


  /*
   * Return a new Decimal whose value is `x` multiplied by `y`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */
  function mul(x, y) {
    return new this(x).mul(y);
  }


  /*
   * Return a new Decimal whose value is `x` raised to the power `y`, rounded to precision
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} The base.
   * y {number|string|Decimal} The exponent.
   *
   */
  function pow(x, y) {
    return new this(x).pow(y);
  }


  /*
   * Returns a new Decimal with a random value equal to or greater than 0 and less than 1, and with
   * `sd`, or `Decimal.precision` if `sd` is omitted, significant digits (or less if trailing zeros
   * are produced).
   *
   * [sd] {number} Significant digits. Integer, 0 to MAX_DIGITS inclusive.
   *
   */
  function random(sd) {
    var d, e, k, n,
      i = 0,
      r = new this(1),
      rd = [];

    if (sd === void 0) sd = this.precision;
    else checkInt32(sd, 1, MAX_DIGITS);

    k = Math.ceil(sd / LOG_BASE);

    if (!this.crypto) {
      for (; i < k;) rd[i++] = Math.random() * 1e7 | 0;

    // Browsers supporting crypto.getRandomValues.
    } else if (crypto.getRandomValues) {
      d = crypto.getRandomValues(new Uint32Array(k));

      for (; i < k;) {
        n = d[i];

        // 0 <= n < 4294967296
        // Probability n >= 4.29e9, is 4967296 / 4294967296 = 0.00116 (1 in 865).
        if (n >= 4.29e9) {
          d[i] = crypto.getRandomValues(new Uint32Array(1))[0];
        } else {

          // 0 <= n <= 4289999999
          // 0 <= (n % 1e7) <= 9999999
          rd[i++] = n % 1e7;
        }
      }

    // Node.js supporting crypto.randomBytes.
    } else if (crypto.randomBytes) {

      // buffer
      d = crypto.randomBytes(k *= 4);

      for (; i < k;) {

        // 0 <= n < 2147483648
        n = d[i] + (d[i + 1] << 8) + (d[i + 2] << 16) + ((d[i + 3] & 0x7f) << 24);

        // Probability n >= 2.14e9, is 7483648 / 2147483648 = 0.0035 (1 in 286).
        if (n >= 2.14e9) {
          crypto.randomBytes(4).copy(d, i);
        } else {

          // 0 <= n <= 2139999999
          // 0 <= (n % 1e7) <= 9999999
          rd.push(n % 1e7);
          i += 4;
        }
      }

      i = k / 4;
    } else {
      throw Error(cryptoUnavailable);
    }

    k = rd[--i];
    sd %= LOG_BASE;

    // Convert trailing digits to zeros according to sd.
    if (k && sd) {
      n = mathpow(10, LOG_BASE - sd);
      rd[i] = (k / n | 0) * n;
    }

    // Remove trailing words which are zero.
    for (; rd[i] === 0; i--) rd.pop();

    // Zero?
    if (i < 0) {
      e = 0;
      rd = [0];
    } else {
      e = -1;

      // Remove leading words which are zero and adjust exponent accordingly.
      for (; rd[0] === 0; e -= LOG_BASE) rd.shift();

      // Count the digits of the first word of rd to determine leading zeros.
      for (k = 1, n = rd[0]; n >= 10; n /= 10) k++;

      // Adjust the exponent for leading zeros of the first word of rd.
      if (k < LOG_BASE) e -= LOG_BASE - k;
    }

    r.e = e;
    r.d = rd;

    return r;
  }


  /*
   * Return a new Decimal whose value is `x` rounded to an integer using rounding mode `rounding`.
   *
   * To emulate `Math.round`, set rounding to 7 (ROUND_HALF_CEIL).
   *
   * x {number|string|Decimal}
   *
   */
  function round(x) {
    return finalise(x = new this(x), x.e + 1, this.rounding);
  }


  /*
   * Return
   *   1    if x > 0,
   *  -1    if x < 0,
   *   0    if x is 0,
   *  -0    if x is -0,
   *   NaN  otherwise
   *
   * x {number|string|Decimal}
   *
   */
  function sign(x) {
    x = new this(x);
    return x.d ? (x.d[0] ? x.s : 0 * x.s) : x.s || NaN;
  }


  /*
   * Return a new Decimal whose value is the sine of `x`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */
  function sin(x) {
    return new this(x).sin();
  }


  /*
   * Return a new Decimal whose value is the hyperbolic sine of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */
  function sinh(x) {
    return new this(x).sinh();
  }


  /*
   * Return a new Decimal whose value is the square root of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   *
   */
  function sqrt(x) {
    return new this(x).sqrt();
  }


  /*
   * Return a new Decimal whose value is `x` minus `y`, rounded to `precision` significant digits
   * using rounding mode `rounding`.
   *
   * x {number|string|Decimal}
   * y {number|string|Decimal}
   *
   */
  function sub(x, y) {
    return new this(x).sub(y);
  }


  /*
   * Return a new Decimal whose value is the sum of the arguments, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * Only the result is rounded, not the intermediate calculations.
   *
   * arguments {number|string|Decimal}
   *
   */
  function sum() {
    var i = 0,
      args = arguments,
      x = new this(args[i]);

    external = false;
    for (; x.s && ++i < args.length;) x = x.plus(args[i]);
    external = true;

    return finalise(x, this.precision, this.rounding);
  }


  /*
   * Return a new Decimal whose value is the tangent of `x`, rounded to `precision` significant
   * digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */
  function tan(x) {
    return new this(x).tan();
  }


  /*
   * Return a new Decimal whose value is the hyperbolic tangent of `x`, rounded to `precision`
   * significant digits using rounding mode `rounding`.
   *
   * x {number|string|Decimal} A value in radians.
   *
   */
  function tanh(x) {
    return new this(x).tanh();
  }


  /*
   * Return a new Decimal whose value is `x` truncated to an integer.
   *
   * x {number|string|Decimal}
   *
   */
  function trunc(x) {
    return finalise(x = new this(x), x.e + 1, 1);
  }


  // Create and configure initial Decimal constructor.
  Decimal = clone(DEFAULTS);
  Decimal.prototype.constructor = Decimal;
  Decimal['default'] = Decimal.Decimal = Decimal;

  // Create the internal constants from their string values.
  LN10 = new Decimal(LN10);
  PI = new Decimal(PI);


  // Export.


  // AMD.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
      return Decimal;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

  // Node and other environments that support module.exports.
  } else if (typeof module != 'undefined' && module.exports) {
    if (typeof Symbol == 'function' && typeof Symbol.iterator == 'symbol') {
      P[Symbol['for']('nodejs.util.inspect.custom')] = P.toString;
      P[Symbol.toStringTag] = 'Decimal';
    }

    module.exports = Decimal;

  // Browser.
  } else {
    if (!globalScope) {
      globalScope = typeof self != 'undefined' && self && self.self == self ? self : window;
    }

    noConflict = globalScope.Decimal;
    Decimal.noConflict = function () {
      globalScope.Decimal = noConflict;
      return Decimal;
    };

    globalScope.Decimal = Decimal;
  }
})(this);


/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(137);
var inherits = __webpack_require__(41);

var utils = __webpack_require__(1159);
var Cipher = __webpack_require__(643);

function DESState() {
  this.tmp = new Array(2);
  this.keys = null;
}

function DES(options) {
  Cipher.call(this, options);

  var state = new DESState();
  this._desState = state;

  this.deriveKeys(state, options.key);
}
inherits(DES, Cipher);
module.exports = DES;

DES.create = function create(options) {
  return new DES(options);
};

var shiftTable = [
  1, 1, 2, 2, 2, 2, 2, 2,
  1, 2, 2, 2, 2, 2, 2, 1
];

DES.prototype.deriveKeys = function deriveKeys(state, key) {
  state.keys = new Array(16 * 2);

  assert.equal(key.length, this.blockSize, 'Invalid key length');

  var kL = utils.readUInt32BE(key, 0);
  var kR = utils.readUInt32BE(key, 4);

  utils.pc1(kL, kR, state.tmp, 0);
  kL = state.tmp[0];
  kR = state.tmp[1];
  for (var i = 0; i < state.keys.length; i += 2) {
    var shift = shiftTable[i >>> 1];
    kL = utils.r28shl(kL, shift);
    kR = utils.r28shl(kR, shift);
    utils.pc2(kL, kR, state.keys, i);
  }
};

DES.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._desState;

  var l = utils.readUInt32BE(inp, inOff);
  var r = utils.readUInt32BE(inp, inOff + 4);

  // Initial Permutation
  utils.ip(l, r, state.tmp, 0);
  l = state.tmp[0];
  r = state.tmp[1];

  if (this.type === 'encrypt')
    this._encrypt(state, l, r, state.tmp, 0);
  else
    this._decrypt(state, l, r, state.tmp, 0);

  l = state.tmp[0];
  r = state.tmp[1];

  utils.writeUInt32BE(out, l, outOff);
  utils.writeUInt32BE(out, r, outOff + 4);
};

DES.prototype._pad = function _pad(buffer, off) {
  var value = buffer.length - off;
  for (var i = off; i < buffer.length; i++)
    buffer[i] = value;

  return true;
};

DES.prototype._unpad = function _unpad(buffer) {
  var pad = buffer[buffer.length - 1];
  for (var i = buffer.length - pad; i < buffer.length; i++)
    assert.equal(buffer[i], pad);

  return buffer.slice(0, buffer.length - pad);
};

DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
  var l = lStart;
  var r = rStart;

  // Apply f() x16 times
  for (var i = 0; i < state.keys.length; i += 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(r, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = r;
    r = (l ^ f) >>> 0;
    l = t;
  }

  // Reverse Initial Permutation
  utils.rip(r, l, out, off);
};

DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
  var l = rStart;
  var r = lStart;

  // Apply f() x16 times
  for (var i = state.keys.length - 2; i >= 0; i -= 2) {
    var keyL = state.keys[i];
    var keyR = state.keys[i + 1];

    // f(r, k)
    utils.expand(l, state.tmp, 0);

    keyL ^= state.tmp[0];
    keyR ^= state.tmp[1];
    var s = utils.substitute(keyL, keyR);
    var f = utils.permute(s);

    var t = l;
    l = (r ^ f) >>> 0;
    r = t;
  }

  // Reverse Initial Permutation
  utils.rip(l, r, out, off);
};


/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.readUInt32BE = function readUInt32BE(bytes, off) {
  var res =  (bytes[0 + off] << 24) |
             (bytes[1 + off] << 16) |
             (bytes[2 + off] << 8) |
             bytes[3 + off];
  return res >>> 0;
};

exports.writeUInt32BE = function writeUInt32BE(bytes, value, off) {
  bytes[0 + off] = value >>> 24;
  bytes[1 + off] = (value >>> 16) & 0xff;
  bytes[2 + off] = (value >>> 8) & 0xff;
  bytes[3 + off] = value & 0xff;
};

exports.ip = function ip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }

  for (var i = 6; i >= 0; i -= 2) {
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
    }
    for (var j = 1; j <= 25; j += 8) {
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.rip = function rip(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  for (var i = 0; i < 4; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outL <<= 1;
      outL |= (inR >>> (j + i)) & 1;
      outL <<= 1;
      outL |= (inL >>> (j + i)) & 1;
    }
  }
  for (var i = 4; i < 8; i++) {
    for (var j = 24; j >= 0; j -= 8) {
      outR <<= 1;
      outR |= (inR >>> (j + i)) & 1;
      outR <<= 1;
      outR |= (inL >>> (j + i)) & 1;
    }
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.pc1 = function pc1(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  // 7, 15, 23, 31, 39, 47, 55, 63
  // 6, 14, 22, 30, 39, 47, 55, 63
  // 5, 13, 21, 29, 39, 47, 55, 63
  // 4, 12, 20, 28
  for (var i = 7; i >= 5; i--) {
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outL <<= 1;
      outL |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outL <<= 1;
    outL |= (inR >> (j + i)) & 1;
  }

  // 1, 9, 17, 25, 33, 41, 49, 57
  // 2, 10, 18, 26, 34, 42, 50, 58
  // 3, 11, 19, 27, 35, 43, 51, 59
  // 36, 44, 52, 60
  for (var i = 1; i <= 3; i++) {
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inR >> (j + i)) & 1;
    }
    for (var j = 0; j <= 24; j += 8) {
      outR <<= 1;
      outR |= (inL >> (j + i)) & 1;
    }
  }
  for (var j = 0; j <= 24; j += 8) {
    outR <<= 1;
    outR |= (inL >> (j + i)) & 1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.r28shl = function r28shl(num, shift) {
  return ((num << shift) & 0xfffffff) | (num >>> (28 - shift));
};

var pc2table = [
  // inL => outL
  14, 11, 17, 4, 27, 23, 25, 0,
  13, 22, 7, 18, 5, 9, 16, 24,
  2, 20, 12, 21, 1, 8, 15, 26,

  // inR => outR
  15, 4, 25, 19, 9, 1, 26, 16,
  5, 11, 23, 8, 12, 7, 17, 0,
  22, 3, 10, 14, 6, 20, 27, 24
];

exports.pc2 = function pc2(inL, inR, out, off) {
  var outL = 0;
  var outR = 0;

  var len = pc2table.length >>> 1;
  for (var i = 0; i < len; i++) {
    outL <<= 1;
    outL |= (inL >>> pc2table[i]) & 0x1;
  }
  for (var i = len; i < pc2table.length; i++) {
    outR <<= 1;
    outR |= (inR >>> pc2table[i]) & 0x1;
  }

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

exports.expand = function expand(r, out, off) {
  var outL = 0;
  var outR = 0;

  outL = ((r & 1) << 5) | (r >>> 27);
  for (var i = 23; i >= 15; i -= 4) {
    outL <<= 6;
    outL |= (r >>> i) & 0x3f;
  }
  for (var i = 11; i >= 3; i -= 4) {
    outR |= (r >>> i) & 0x3f;
    outR <<= 6;
  }
  outR |= ((r & 0x1f) << 1) | (r >>> 31);

  out[off + 0] = outL >>> 0;
  out[off + 1] = outR >>> 0;
};

var sTable = [
  14, 0, 4, 15, 13, 7, 1, 4, 2, 14, 15, 2, 11, 13, 8, 1,
  3, 10, 10, 6, 6, 12, 12, 11, 5, 9, 9, 5, 0, 3, 7, 8,
  4, 15, 1, 12, 14, 8, 8, 2, 13, 4, 6, 9, 2, 1, 11, 7,
  15, 5, 12, 11, 9, 3, 7, 14, 3, 10, 10, 0, 5, 6, 0, 13,

  15, 3, 1, 13, 8, 4, 14, 7, 6, 15, 11, 2, 3, 8, 4, 14,
  9, 12, 7, 0, 2, 1, 13, 10, 12, 6, 0, 9, 5, 11, 10, 5,
  0, 13, 14, 8, 7, 10, 11, 1, 10, 3, 4, 15, 13, 4, 1, 2,
  5, 11, 8, 6, 12, 7, 6, 12, 9, 0, 3, 5, 2, 14, 15, 9,

  10, 13, 0, 7, 9, 0, 14, 9, 6, 3, 3, 4, 15, 6, 5, 10,
  1, 2, 13, 8, 12, 5, 7, 14, 11, 12, 4, 11, 2, 15, 8, 1,
  13, 1, 6, 10, 4, 13, 9, 0, 8, 6, 15, 9, 3, 8, 0, 7,
  11, 4, 1, 15, 2, 14, 12, 3, 5, 11, 10, 5, 14, 2, 7, 12,

  7, 13, 13, 8, 14, 11, 3, 5, 0, 6, 6, 15, 9, 0, 10, 3,
  1, 4, 2, 7, 8, 2, 5, 12, 11, 1, 12, 10, 4, 14, 15, 9,
  10, 3, 6, 15, 9, 0, 0, 6, 12, 10, 11, 1, 7, 13, 13, 8,
  15, 9, 1, 4, 3, 5, 14, 11, 5, 12, 2, 7, 8, 2, 4, 14,

  2, 14, 12, 11, 4, 2, 1, 12, 7, 4, 10, 7, 11, 13, 6, 1,
  8, 5, 5, 0, 3, 15, 15, 10, 13, 3, 0, 9, 14, 8, 9, 6,
  4, 11, 2, 8, 1, 12, 11, 7, 10, 1, 13, 14, 7, 2, 8, 13,
  15, 6, 9, 15, 12, 0, 5, 9, 6, 10, 3, 4, 0, 5, 14, 3,

  12, 10, 1, 15, 10, 4, 15, 2, 9, 7, 2, 12, 6, 9, 8, 5,
  0, 6, 13, 1, 3, 13, 4, 14, 14, 0, 7, 11, 5, 3, 11, 8,
  9, 4, 14, 3, 15, 2, 5, 12, 2, 9, 8, 5, 12, 15, 3, 10,
  7, 11, 0, 14, 4, 1, 10, 7, 1, 6, 13, 0, 11, 8, 6, 13,

  4, 13, 11, 0, 2, 11, 14, 7, 15, 4, 0, 9, 8, 1, 13, 10,
  3, 14, 12, 3, 9, 5, 7, 12, 5, 2, 10, 15, 6, 8, 1, 6,
  1, 6, 4, 11, 11, 13, 13, 8, 12, 1, 3, 4, 7, 10, 14, 7,
  10, 9, 15, 5, 6, 0, 8, 15, 0, 14, 5, 2, 9, 3, 2, 12,

  13, 1, 2, 15, 8, 13, 4, 8, 6, 10, 15, 3, 11, 7, 1, 4,
  10, 12, 9, 5, 3, 6, 14, 11, 5, 0, 0, 14, 12, 9, 7, 2,
  7, 2, 11, 1, 4, 14, 1, 7, 9, 4, 12, 10, 14, 8, 2, 13,
  0, 15, 6, 12, 10, 9, 13, 0, 15, 3, 3, 5, 5, 6, 8, 11
];

exports.substitute = function substitute(inL, inR) {
  var out = 0;
  for (var i = 0; i < 4; i++) {
    var b = (inL >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  for (var i = 0; i < 4; i++) {
    var b = (inR >>> (18 - i * 6)) & 0x3f;
    var sb = sTable[4 * 0x40 + i * 0x40 + b];

    out <<= 4;
    out |= sb;
  }
  return out >>> 0;
};

var permuteTable = [
  16, 25, 12, 11, 3, 20, 4, 15, 31, 17, 9, 6, 27, 14, 1, 22,
  30, 24, 8, 18, 0, 5, 29, 23, 13, 19, 2, 26, 10, 21, 28, 7
];

exports.permute = function permute(num) {
  var out = 0;
  for (var i = 0; i < permuteTable.length; i++) {
    out <<= 1;
    out |= (num >>> permuteTable[i]) & 0x1;
  }
  return out >>> 0;
};

exports.padSplit = function padSplit(num, size, group) {
  var str = num.toString(2);
  while (str.length < size)
    str = '0' + str;

  var out = [];
  for (var i = 0; i < size; i += group)
    out.push(str.slice(i, i + group));
  return out.join(' ');
};


/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

var randomBytes = __webpack_require__(286);
module.exports = findPrime;
findPrime.simpleSieve = simpleSieve;
findPrime.fermatTest = fermatTest;
var BN = __webpack_require__(77);
var TWENTYFOUR = new BN(24);
var MillerRabin = __webpack_require__(1261);
var millerRabin = new MillerRabin();
var ONE = new BN(1);
var TWO = new BN(2);
var FIVE = new BN(5);
var SIXTEEN = new BN(16);
var EIGHT = new BN(8);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var ELEVEN = new BN(11);
var FOUR = new BN(4);
var TWELVE = new BN(12);
var primes = null;

function _getPrimes() {
  if (primes !== null)
    return primes;

  var limit = 0x100000;
  var res = [];
  res[0] = 2;
  for (var i = 1, k = 3; k < limit; k += 2) {
    var sqrt = Math.ceil(Math.sqrt(k));
    for (var j = 0; j < i && res[j] <= sqrt; j++)
      if (k % res[j] === 0)
        break;

    if (i !== j && res[j] <= sqrt)
      continue;

    res[i++] = k;
  }
  primes = res;
  return res;
}

function simpleSieve(p) {
  var primes = _getPrimes();

  for (var i = 0; i < primes.length; i++)
    if (p.modn(primes[i]) === 0) {
      if (p.cmpn(primes[i]) === 0) {
        return true;
      } else {
        return false;
      }
    }

  return true;
}

function fermatTest(p) {
  var red = BN.mont(p);
  return TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}

function findPrime(bits, gen) {
  if (bits < 16) {
    // this is what openssl does
    if (gen === 2 || gen === 5) {
      return new BN([0x8c, 0x7b]);
    } else {
      return new BN([0x8c, 0x27]);
    }
  }
  gen = new BN(gen);

  var num, n2;

  while (true) {
    num = new BN(randomBytes(Math.ceil(bits / 8)));
    while (num.bitLength() > bits) {
      num.ishrn(1);
    }
    if (num.isEven()) {
      num.iadd(ONE);
    }
    if (!num.testn(1)) {
      num.iadd(TWO);
    }
    if (!gen.cmp(TWO)) {
      while (num.mod(TWENTYFOUR).cmp(ELEVEN)) {
        num.iadd(FOUR);
      }
    } else if (!gen.cmp(FIVE)) {
      while (num.mod(TEN).cmp(THREE)) {
        num.iadd(FOUR);
      }
    }
    n2 = num.shrn(1);
    if (simpleSieve(n2) && simpleSieve(num) &&
      fermatTest(n2) && fermatTest(num) &&
      millerRabin.test(n2) && millerRabin.test(num)) {
      return num;
    }
  }

}


/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


module.exports = {
  BOLD: {
    fontWeight: 'bold'
  },
  CODE: {
    fontFamily: 'monospace',
    wordWrap: 'break-word'
  },
  ITALIC: {
    fontStyle: 'italic'
  },
  STRIKETHROUGH: {
    textDecoration: 'line-through'
  },
  UNDERLINE: {
    textDecoration: 'underline'
  }
};

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var _assign = __webpack_require__(121);

function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DraftEditorLeaf = __webpack_require__(1163);

var DraftOffsetKey = __webpack_require__(182);

var React = __webpack_require__(0);

var Scroll = __webpack_require__(649);

var Style = __webpack_require__(431);

var UnicodeBidi = __webpack_require__(650);

var UnicodeBidiDirection = __webpack_require__(432);

var cx = __webpack_require__(244);

var getElementPosition = __webpack_require__(1197);

var getScrollPosition = __webpack_require__(433);

var getViewportDimensions = __webpack_require__(1198);

var invariant = __webpack_require__(48);

var isHTMLElement = __webpack_require__(340);

var nullthrows = __webpack_require__(107);

var SCROLL_BUFFER = 10;

/**
 * Return whether a block overlaps with either edge of the `SelectionState`.
 */
var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
};
/**
 * The default block renderer for a `DraftEditor` component.
 *
 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
 * appropriate decorator and inline style components.
 */


var DraftEditorBlock = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorBlock, _React$Component);

  function DraftEditorBlock() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "_node", void 0);

    return _this;
  }

  var _proto = DraftEditorBlock.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
  }
  /**
   * When a block is mounted and overlaps the selection state, we need to make
   * sure that the cursor is visible to match native behavior. This may not
   * be the case if the user has pressed `RETURN` or pasted some content, since
   * programmatically creating these new blocks and setting the DOM selection
   * will miss out on the browser natively scrolling to that position.
   *
   * To replicate native behavior, if the block overlaps the selection state
   * on mount, force the scroll position. Check the scroll state of the scroll
   * parent, and adjust it to align the entire block to the bottom of the
   * scroll parent.
   */
  ;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.preventScroll) {
      return;
    }

    var selection = this.props.selection;
    var endKey = selection.getEndKey();

    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
      return;
    }

    var blockNode = this._node;

    if (blockNode == null) {
      return;
    }

    var scrollParent = Style.getScrollParent(blockNode);
    var scrollPosition = getScrollPosition(scrollParent);
    var scrollDelta;

    if (scrollParent === window) {
      var nodePosition = getElementPosition(blockNode);
      var nodeBottom = nodePosition.y + nodePosition.height;
      var viewportHeight = getViewportDimensions().height;
      scrollDelta = nodeBottom - viewportHeight;

      if (scrollDelta > 0) {
        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
      }
    } else {
      !isHTMLElement(blockNode) ?  false ? invariant(false, 'blockNode is not an HTMLElement') : invariant(false) : void 0;
      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
      var pOffset = scrollParent.offsetTop + scrollParent.offsetHeight;
      var scrollBottom = pOffset + scrollPosition.y;
      scrollDelta = blockBottom - scrollBottom;

      if (scrollDelta > 0) {
        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
      }
    }
  };

  _proto._renderChildren = function _renderChildren() {
    var _this2 = this;

    var block = this.props.block;
    var blockKey = block.getKey();
    var text = block.getText();
    var lastLeafSet = this.props.tree.size - 1;
    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);
    return this.props.tree.map(function (leafSet, ii) {
      var leavesForLeafSet = leafSet.get('leaves'); // T44088704

      if (leavesForLeafSet.size === 0) {
        return null;
      }

      var lastLeaf = leavesForLeafSet.size - 1;
      var leaves = leavesForLeafSet.map(function (leaf, jj) {
        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
        var start = leaf.get('start');
        var end = leaf.get('end');
        return React.createElement(DraftEditorLeaf, {
          key: offsetKey,
          offsetKey: offsetKey,
          block: block,
          start: start,
          selection: hasSelection ? _this2.props.selection : null,
          forceSelection: _this2.props.forceSelection,
          text: text.slice(start, end),
          styleSet: block.getInlineStyleAt(start),
          customStyleMap: _this2.props.customStyleMap,
          customStyleFn: _this2.props.customStyleFn,
          isLast: ii === lastLeafSet && jj === lastLeaf
        });
      }).toArray();
      var decoratorKey = leafSet.get('decoratorKey');

      if (decoratorKey == null) {
        return leaves;
      }

      if (!_this2.props.decorator) {
        return leaves;
      }

      var decorator = nullthrows(_this2.props.decorator);
      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);

      if (!DecoratorComponent) {
        return leaves;
      }

      var decoratorProps = decorator.getPropsForKey(decoratorKey);
      var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, ii, 0);
      var start = leavesForLeafSet.first().get('start');
      var end = leavesForLeafSet.last().get('end');
      var decoratedText = text.slice(start, end);
      var entityKey = block.getEntityAt(leafSet.get('start')); // Resetting dir to the same value on a child node makes Chrome/Firefox
      // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/

      var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);
      var commonProps = {
        contentState: _this2.props.contentState,
        decoratedText: decoratedText,
        dir: dir,
        start: start,
        end: end,
        blockKey: blockKey,
        entityKey: entityKey,
        offsetKey: decoratorOffsetKey
      };
      return React.createElement(DecoratorComponent, _extends({}, decoratorProps, commonProps, {
        key: decoratorOffsetKey
      }), leaves);
    }).toArray();
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$props = this.props,
        direction = _this$props.direction,
        offsetKey = _this$props.offsetKey;
    var className = cx({
      'public/DraftStyleDefault/block': true,
      'public/DraftStyleDefault/ltr': direction === 'LTR',
      'public/DraftStyleDefault/rtl': direction === 'RTL'
    });
    return React.createElement("div", {
      "data-offset-key": offsetKey,
      className: className,
      ref: function ref(_ref) {
        return _this3._node = _ref;
      }
    }, this._renderChildren());
  };

  return DraftEditorBlock;
}(React.Component);

module.exports = DraftEditorBlock;

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var _assign = __webpack_require__(121);

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DraftEditorTextNode = __webpack_require__(2867);

var React = __webpack_require__(0);

var invariant = __webpack_require__(48);

var isHTMLBRElement = __webpack_require__(1187);

var setDraftEditorSelection = __webpack_require__(2919).setDraftEditorSelection;

/**
 * All leaf nodes in the editor are spans with single text nodes. Leaf
 * elements are styled based on the merging of an optional custom style map
 * and a default style map.
 *
 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
 * DOM Selection API. In this way, top-level components can declaratively
 * maintain the selection state.
 */
var DraftEditorLeaf = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorLeaf, _React$Component);

  function DraftEditorLeaf() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "leaf", void 0);

    return _this;
  }

  var _proto = DraftEditorLeaf.prototype;

  _proto._setSelection = function _setSelection() {
    var selection = this.props.selection; // If selection state is irrelevant to the parent block, no-op.

    if (selection == null || !selection.getHasFocus()) {
      return;
    }

    var _this$props = this.props,
        block = _this$props.block,
        start = _this$props.start,
        text = _this$props.text;
    var blockKey = block.getKey();
    var end = start + text.length;

    if (!selection.hasEdgeWithin(blockKey, start, end)) {
      return;
    } // Determine the appropriate target node for selection. If the child
    // is not a text node, it is a <br /> spacer. In this case, use the
    // <span> itself as the selection target.


    var node = this.leaf;
    !node ?  false ? invariant(false, 'Missing node') : invariant(false) : void 0;
    var child = node.firstChild;
    !child ?  false ? invariant(false, 'Missing child') : invariant(false) : void 0;
    var targetNode;

    if (child.nodeType === Node.TEXT_NODE) {
      targetNode = child;
    } else if (isHTMLBRElement(child)) {
      targetNode = node;
    } else {
      targetNode = child.firstChild;
      !targetNode ?  false ? invariant(false, 'Missing targetNode') : invariant(false) : void 0;
    }

    setDraftEditorSelection(selection, targetNode, blockKey, start, end);
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var leafNode = this.leaf;
    !leafNode ?  false ? invariant(false, 'Missing leafNode') : invariant(false) : void 0;
    var shouldUpdate = leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
    return shouldUpdate;
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this._setSelection();
  };

  _proto.componentDidMount = function componentDidMount() {
    this._setSelection();
  };

  _proto.render = function render() {
    var _this2 = this;

    var block = this.props.block;
    var text = this.props.text; // If the leaf is at the end of its block and ends in a soft newline, append
    // an extra line feed character. Browsers collapse trailing newline
    // characters, which leaves the cursor in the wrong place after a
    // shift+enter. The extra character repairs this.

    if (text.endsWith('\n') && this.props.isLast) {
      text += '\n';
    }

    var _this$props2 = this.props,
        customStyleMap = _this$props2.customStyleMap,
        customStyleFn = _this$props2.customStyleFn,
        offsetKey = _this$props2.offsetKey,
        styleSet = _this$props2.styleSet;
    var styleObj = styleSet.reduce(function (map, styleName) {
      var mergedStyles = {};
      var style = customStyleMap[styleName];

      if (style !== undefined && map.textDecoration !== style.textDecoration) {
        // .trim() is necessary for IE9/10/11 and Edge
        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
      }

      return _assign(map, style, mergedStyles);
    }, {});

    if (customStyleFn) {
      var newStyles = customStyleFn(styleSet, block);
      styleObj = _assign(styleObj, newStyles);
    }

    return React.createElement("span", {
      "data-offset-key": offsetKey,
      ref: function ref(_ref) {
        return _this2.leaf = _ref;
      },
      style: styleObj
    }, React.createElement(DraftEditorTextNode, null, text));
  };

  return DraftEditorLeaf;
}(React.Component);

module.exports = DraftEditorLeaf;

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


module.exports = {
  initODS: function initODS() {},
  handleExtensionCausedError: function handleExtensionCausedError() {}
};

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @legacyServerCallableInstance
 * @format
 * 
 * @emails oncall+draft_js
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var Immutable = __webpack_require__(46);

var Record = Immutable.Record;
var DraftEntityInstanceRecord = Record({
  type: 'TOKEN',
  mutability: 'IMMUTABLE',
  data: Object
});
/**
 * An instance of a document entity, consisting of a `type` and relevant
 * `data`, metadata about the entity.
 *
 * For instance, a "link" entity might provide a URI, and a "mention"
 * entity might provide the mentioned user's ID. These pieces of data
 * may be used when rendering the entity as part of a ContentBlock DOM
 * representation. For a link, the data would be used as an href for
 * the rendered anchor. For a mention, the ID could be used to retrieve
 * a hovercard.
 */

var DraftEntityInstance = /*#__PURE__*/function (_DraftEntityInstanceR) {
  _inheritsLoose(DraftEntityInstance, _DraftEntityInstanceR);

  function DraftEntityInstance() {
    return _DraftEntityInstanceR.apply(this, arguments) || this;
  }

  var _proto = DraftEntityInstance.prototype;

  _proto.getType = function getType() {
    return this.get('type');
  };

  _proto.getMutability = function getMutability() {
    return this.get('mutability');
  };

  _proto.getData = function getData() {
    return this.get('data');
  };

  return DraftEntityInstance;
}(DraftEntityInstanceRecord);

module.exports = DraftEntityInstance;

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


module.exports = {
  logBlockedSelectionEvent: function logBlockedSelectionEvent() {
    return null;
  },
  logSelectionStateFailure: function logSelectionStateFailure() {
    return null;
  }
};

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var TokenizeUtil = __webpack_require__(2924);

var punctuation = TokenizeUtil.getPunctuation(); // The apostrophe and curly single quotes behave in a curious way: when
// surrounded on both sides by word characters, they behave as word chars; when
// either neighbor is punctuation or an end of the string, they behave as
// punctuation.

var CHAMELEON_CHARS = "['\u2018\u2019]"; // Remove the underscore, which should count as part of the removable word. The
// "chameleon chars" also count as punctuation in this regex.

var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;
var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
var DELETE_REGEX = new RegExp(DELETE_STRING);
var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);

function getRemovableWord(text, isBackward) {
  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
  return matches ? matches[0] : text;
}

var DraftRemovableWord = {
  getBackward: function getBackward(text) {
    return getRemovableWord(text, true);
  },
  getForward: function getForward(text) {
    return getRemovableWord(text, false);
  }
};
module.exports = DraftRemovableWord;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftStringKey = {
  stringify: function stringify(key) {
    return '_' + String(key);
  },
  unstringify: function unstringify(key) {
    return key.slice(1);
  }
};
module.exports = DraftStringKey;

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(105);

var EditorState = __webpack_require__(62);

var adjustBlockDepthForContentState = __webpack_require__(2875);

var nullthrows = __webpack_require__(107);

var RichTextEditorUtil = {
  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
    var selection = editorState.getSelection();
    var contentState = editorState.getCurrentContent();
    var entityMap = contentState.getEntityMap();
    return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
      var entity = v.getEntity();
      return !!entity && entityMap.__get(entity).getType() === 'LINK';
    });
  },
  getCurrentBlockType: function getCurrentBlockType(editorState) {
    var selection = editorState.getSelection();
    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
  },
  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
    return {
      url: uri.toString()
    };
  },
  handleKeyCommand: function handleKeyCommand(editorState, command, eventTimeStamp) {
    switch (command) {
      case 'bold':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');

      case 'italic':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');

      case 'underline':
        return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');

      case 'code':
        return RichTextEditorUtil.toggleCode(editorState);

      case 'backspace':
      case 'backspace-word':
      case 'backspace-to-start-of-line':
        return RichTextEditorUtil.onBackspace(editorState);

      case 'delete':
      case 'delete-word':
      case 'delete-to-end-of-block':
        return RichTextEditorUtil.onDelete(editorState);

      default:
        // they may have custom editor commands; ignore those
        return null;
    }
  },
  insertSoftNewline: function insertSoftNewline(editorState) {
    var contentState = DraftModifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);
    var newEditorState = EditorState.push(editorState, contentState, 'insert-characters');
    return EditorState.forceSelection(newEditorState, contentState.getSelectionAfter());
  },

  /**
   * For collapsed selections at the start of styled blocks, backspace should
   * just remove the existing style.
   */
  onBackspace: function onBackspace(editorState) {
    var selection = editorState.getSelection();

    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
      return null;
    } // First, try to remove a preceding atomic block.


    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var blockBefore = content.getBlockBefore(startKey);

    if (blockBefore && blockBefore.getType() === 'atomic') {
      var blockMap = content.getBlockMap()["delete"](blockBefore.getKey());
      var withoutAtomicBlock = content.merge({
        blockMap: blockMap,
        selectionAfter: selection
      });

      if (withoutAtomicBlock !== content) {
        return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
      }
    } // If that doesn't succeed, try to remove the current block style.


    var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);

    if (withoutBlockStyle) {
      return EditorState.push(editorState, withoutBlockStyle, 'change-block-type');
    }

    return null;
  },
  onDelete: function onDelete(editorState) {
    var selection = editorState.getSelection();

    if (!selection.isCollapsed()) {
      return null;
    }

    var content = editorState.getCurrentContent();
    var startKey = selection.getStartKey();
    var block = content.getBlockForKey(startKey);
    var length = block.getLength(); // The cursor is somewhere within the text. Behave normally.

    if (selection.getStartOffset() < length) {
      return null;
    }

    var blockAfter = content.getBlockAfter(startKey);

    if (!blockAfter || blockAfter.getType() !== 'atomic') {
      return null;
    }

    var atomicBlockTarget = selection.merge({
      focusKey: blockAfter.getKey(),
      focusOffset: blockAfter.getLength()
    });
    var withoutAtomicBlock = DraftModifier.removeRange(content, atomicBlockTarget, 'forward');

    if (withoutAtomicBlock !== content) {
      return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
    }

    return null;
  },
  onTab: function onTab(event, editorState, maxDepth) {
    var selection = editorState.getSelection();
    var key = selection.getAnchorKey();

    if (key !== selection.getFocusKey()) {
      return editorState;
    }

    var content = editorState.getCurrentContent();
    var block = content.getBlockForKey(key);
    var type = block.getType();

    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
      return editorState;
    }

    event.preventDefault();
    var depth = block.getDepth();

    if (!event.shiftKey && depth === maxDepth) {
      return editorState;
    }

    var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);
    return EditorState.push(editorState, withAdjustment, 'adjust-depth');
  },
  toggleBlockType: function toggleBlockType(editorState, blockType) {
    var selection = editorState.getSelection();
    var startKey = selection.getStartKey();
    var endKey = selection.getEndKey();
    var content = editorState.getCurrentContent();
    var target = selection; // Triple-click can lead to a selection that includes offset 0 of the
    // following block. The `SelectionState` for this case is accurate, but
    // we should avoid toggling block type for the trailing block because it
    // is a confusing interaction.

    if (startKey !== endKey && selection.getEndOffset() === 0) {
      var blockBefore = nullthrows(content.getBlockBefore(endKey));
      endKey = blockBefore.getKey();
      target = target.merge({
        anchorKey: startKey,
        anchorOffset: selection.getStartOffset(),
        focusKey: endKey,
        focusOffset: blockBefore.getLength(),
        isBackward: false
      });
    }

    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
      return k !== startKey;
    }).reverse().skipWhile(function (_, k) {
      return k !== endKey;
    }).some(function (v) {
      return v.getType() === 'atomic';
    });

    if (hasAtomicBlock) {
      return editorState;
    }

    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;
    return EditorState.push(editorState, DraftModifier.setBlockType(content, target, typeToSet), 'change-block-type');
  },
  toggleCode: function toggleCode(editorState) {
    var selection = editorState.getSelection();
    var anchorKey = selection.getAnchorKey();
    var focusKey = selection.getFocusKey();

    if (selection.isCollapsed() || anchorKey !== focusKey) {
      return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
    }

    return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
  },

  /**
   * Toggle the specified inline style for the selection. If the
   * user's selection is collapsed, apply or remove the style for the
   * internal state. If it is not collapsed, apply the change directly
   * to the document state.
   */
  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
    var selection = editorState.getSelection();
    var currentStyle = editorState.getCurrentInlineStyle(); // If the selection is collapsed, toggle the specified style on or off and
    // set the result as the new inline style override. This will then be
    // used as the inline style for the next character to be inserted.

    if (selection.isCollapsed()) {
      return EditorState.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
    } // If characters are selected, immediately apply or remove the
    // inline style on the document state itself.


    var content = editorState.getCurrentContent();
    var newContent; // If the style is already present for the selection range, remove it.
    // Otherwise, apply it.

    if (currentStyle.has(inlineStyle)) {
      newContent = DraftModifier.removeInlineStyle(content, selection, inlineStyle);
    } else {
      newContent = DraftModifier.applyInlineStyle(content, selection, inlineStyle);
    }

    return EditorState.push(editorState, newContent, 'change-inline-style');
  },
  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
    var withoutLink = DraftModifier.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);
    return EditorState.push(editorState, withoutLink, 'apply-entity');
  },

  /**
   * When a collapsed cursor is at the start of a styled block, changes block
   * type to 'unstyled'. Returns null if selection does not meet that criteria.
   */
  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
    var selection = editorState.getSelection();
    var offset = selection.getAnchorOffset();

    if (selection.isCollapsed() && offset === 0) {
      var key = selection.getAnchorKey();
      var content = editorState.getCurrentContent();
      var block = content.getBlockForKey(key);
      var type = block.getType();
      var blockBefore = content.getBlockBefore(key);

      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block' && blockBefore.getLength() !== 0) {
        return null;
      }

      if (type !== 'unstyled') {
        return DraftModifier.setBlockType(content, selection, 'unstyled');
      }
    }

    return null;
  }
};
module.exports = RichTextEditorUtil;

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var _knownListItemDepthCl;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var CharacterMetadata = __webpack_require__(133);

var ContentBlock = __webpack_require__(241);

var ContentBlockNode = __webpack_require__(134);

var DefaultDraftBlockRenderMap = __webpack_require__(645);

var DraftEntity = __webpack_require__(424);

var URI = __webpack_require__(2925);

var cx = __webpack_require__(244);

var generateRandomKey = __webpack_require__(164);

var getSafeBodyFromHTML = __webpack_require__(1181);

var gkx = __webpack_require__(203);

var _require = __webpack_require__(46),
    List = _require.List,
    Map = _require.Map,
    OrderedSet = _require.OrderedSet;

var isHTMLAnchorElement = __webpack_require__(2903);

var isHTMLBRElement = __webpack_require__(1187);

var isHTMLElement = __webpack_require__(340);

var isHTMLImageElement = __webpack_require__(2904);

var experimentalTreeDataSupport = gkx('draft_tree_data_support');
var NBSP = '&nbsp;';
var SPACE = ' '; // used for replacing characters in HTML

var REGEX_CR = new RegExp('\r', 'g');
var REGEX_LF = new RegExp('\n', 'g');
var REGEX_LEADING_LF = new RegExp('^\n', 'g');
var REGEX_NBSP = new RegExp(NBSP, 'g');
var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
var REGEX_ZWS = new RegExp('&#8203;?', 'g'); // https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight

var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
var notBoldValues = ['light', 'lighter', 'normal', '100', '200', '300', '400'];
var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];
var imgAttr = ['alt', 'className', 'height', 'src', 'width'];
var knownListItemDepthClasses = (_knownListItemDepthCl = {}, _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth0'), 0), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth1'), 1), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth2'), 2), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth3'), 3), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth4'), 4), _knownListItemDepthCl);
var HTMLTagToRawInlineStyleMap = Map({
  b: 'BOLD',
  code: 'CODE',
  del: 'STRIKETHROUGH',
  em: 'ITALIC',
  i: 'ITALIC',
  s: 'STRIKETHROUGH',
  strike: 'STRIKETHROUGH',
  strong: 'BOLD',
  u: 'UNDERLINE',
  mark: 'HIGHLIGHT'
});

/**
 * Build a mapping from HTML tags to draftjs block types
 * out of a BlockRenderMap.
 *
 * The BlockTypeMap for the default BlockRenderMap looks like this:
 *   Map({
 *     h1: 'header-one',
 *     h2: 'header-two',
 *     h3: 'header-three',
 *     h4: 'header-four',
 *     h5: 'header-five',
 *     h6: 'header-six',
 *     blockquote: 'blockquote',
 *     figure: 'atomic',
 *     pre: ['code-block'],
 *     div: 'unstyled',
 *     p: 'unstyled',
 *     li: ['ordered-list-item', 'unordered-list-item'],
 *   })
 */
var buildBlockTypeMap = function buildBlockTypeMap(blockRenderMap) {
  var blockTypeMap = {};
  blockRenderMap.mapKeys(function (blockType, desc) {
    var elements = [desc.element];

    if (desc.aliasedElements !== undefined) {
      elements.push.apply(elements, desc.aliasedElements);
    }

    elements.forEach(function (element) {
      if (blockTypeMap[element] === undefined) {
        blockTypeMap[element] = blockType;
      } else if (typeof blockTypeMap[element] === 'string') {
        blockTypeMap[element] = [blockTypeMap[element], blockType];
      } else {
        blockTypeMap[element].push(blockType);
      }
    });
  });
  return Map(blockTypeMap);
};

var detectInlineStyle = function detectInlineStyle(node) {
  if (isHTMLElement(node)) {
    var element = node; // Currently only used to detect preformatted inline code

    if (element.style.fontFamily.includes('monospace')) {
      return 'CODE';
    }
  }

  return null;
};
/**
 * If we're pasting from one DraftEditor to another we can check to see if
 * existing list item depth classes are being used and preserve this style
 */


var getListItemDepth = function getListItemDepth(node) {
  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  Object.keys(knownListItemDepthClasses).some(function (depthClass) {
    if (node.classList.contains(depthClass)) {
      depth = knownListItemDepthClasses[depthClass];
    }
  });
  return depth;
};
/**
 * Return true if the provided HTML Element can be used to build a
 * Draftjs-compatible link.
 */


var isValidAnchor = function isValidAnchor(node) {
  if (!isHTMLAnchorElement(node)) {
    return false;
  }

  var anchorNode = node;

  if (!anchorNode.href || anchorNode.protocol !== 'http:' && anchorNode.protocol !== 'https:' && anchorNode.protocol !== 'mailto:' && anchorNode.protocol !== 'tel:') {
    return false;
  }

  try {
    // Just checking whether we can actually create a URI
    var _ = new URI(anchorNode.href);

    return true; // We need our catch statements to have arguments, else
    // UglifyJS (which we use for our OSS builds) will crash.
    // eslint-disable-next-line fb-www/no-unused-catch-bindings
  } catch (_) {
    return false;
  }
};
/**
 * Return true if the provided HTML Element can be used to build a
 * Draftjs-compatible image.
 */


var isValidImage = function isValidImage(node) {
  if (!isHTMLImageElement(node)) {
    return false;
  }

  var imageNode = node;
  return !!(imageNode.attributes.getNamedItem('src') && imageNode.attributes.getNamedItem('src').value);
};
/**
 * Try to guess the inline style of an HTML element based on its css
 * styles (font-weight, font-style and text-decoration).
 */


var styleFromNodeAttributes = function styleFromNodeAttributes(node, style) {
  if (!isHTMLElement(node)) {
    return style;
  }

  var htmlElement = node;
  var fontWeight = htmlElement.style.fontWeight;
  var fontStyle = htmlElement.style.fontStyle;
  var textDecoration = htmlElement.style.textDecoration;
  return style.withMutations(function (style) {
    if (boldValues.indexOf(fontWeight) >= 0) {
      style.add('BOLD');
    } else if (notBoldValues.indexOf(fontWeight) >= 0) {
      style.remove('BOLD');
    }

    if (fontStyle === 'italic') {
      style.add('ITALIC');
    } else if (fontStyle === 'normal') {
      style.remove('ITALIC');
    }

    if (textDecoration === 'underline') {
      style.add('UNDERLINE');
    }

    if (textDecoration === 'line-through') {
      style.add('STRIKETHROUGH');
    }

    if (textDecoration === 'none') {
      style.remove('UNDERLINE');
      style.remove('STRIKETHROUGH');
    }
  });
};
/**
 * Determine if a nodeName is a list type, 'ul' or 'ol'
 */


var isListNode = function isListNode(nodeName) {
  return nodeName === 'ul' || nodeName === 'ol';
};
/**
 *  ContentBlockConfig is a mutable data structure that holds all
 *  the information required to build a ContentBlock and an array of
 *  all the child nodes (childConfigs).
 *  It is being used a temporary data structure by the
 *  ContentBlocksBuilder class.
 */


/**
 * ContentBlocksBuilder builds a list of ContentBlocks and an Entity Map
 * out of one (or several) HTMLElement(s).
 *
 * The algorithm has two passes: first it builds a tree of ContentBlockConfigs
 * by walking through the HTML nodes and their children, then it walks the
 * ContentBlockConfigs tree to compute parents/siblings and create
 * the actual ContentBlocks.
 *
 * Typical usage is:
 *     new ContentBlocksBuilder()
 *        .addDOMNode(someHTMLNode)
 *        .addDOMNode(someOtherHTMLNode)
 *       .getContentBlocks();
 *
 */
var ContentBlocksBuilder = /*#__PURE__*/function () {
  // Most of the method in the class depend on the state of the content builder
  // (i.e. currentBlockType, currentDepth, currentEntity etc.). Though it may
  // be confusing at first, it made the code simpler than the alternative which
  // is to pass those values around in every call.
  // The following attributes are used to accumulate text and styles
  // as we are walking the HTML node tree.
  // Describes the future ContentState as a tree of content blocks
  // The content blocks generated from the blockConfigs
  // Entity map use to store links and images found in the HTML nodes
  // Map HTML tags to draftjs block types and disambiguation function
  function ContentBlocksBuilder(blockTypeMap, disambiguate) {
    _defineProperty(this, "characterList", List());

    _defineProperty(this, "currentBlockType", 'unstyled');

    _defineProperty(this, "currentDepth", 0);

    _defineProperty(this, "currentEntity", null);

    _defineProperty(this, "currentText", '');

    _defineProperty(this, "wrapper", null);

    _defineProperty(this, "blockConfigs", []);

    _defineProperty(this, "contentBlocks", []);

    _defineProperty(this, "entityMap", DraftEntity);

    _defineProperty(this, "blockTypeMap", void 0);

    _defineProperty(this, "disambiguate", void 0);

    this.clear();
    this.blockTypeMap = blockTypeMap;
    this.disambiguate = disambiguate;
  }
  /**
   * Clear the internal state of the ContentBlocksBuilder
   */


  var _proto = ContentBlocksBuilder.prototype;

  _proto.clear = function clear() {
    this.characterList = List();
    this.blockConfigs = [];
    this.currentBlockType = 'unstyled';
    this.currentDepth = 0;
    this.currentEntity = null;
    this.currentText = '';
    this.entityMap = DraftEntity;
    this.wrapper = null;
    this.contentBlocks = [];
  }
  /**
   * Add an HTMLElement to the ContentBlocksBuilder
   */
  ;

  _proto.addDOMNode = function addDOMNode(node) {
    var _this$blockConfigs;

    this.contentBlocks = [];
    this.currentDepth = 0; // Converts the HTML node to block config

    (_this$blockConfigs = this.blockConfigs).push.apply(_this$blockConfigs, this._toBlockConfigs([node], OrderedSet())); // There might be some left over text in the builder's
    // internal state, if so make a ContentBlock out of it.


    this._trimCurrentText();

    if (this.currentText !== '') {
      this.blockConfigs.push(this._makeBlockConfig());
    } // for chaining


    return this;
  }
  /**
   * Return the ContentBlocks and the EntityMap that corresponds
   * to the previously added HTML nodes.
   */
  ;

  _proto.getContentBlocks = function getContentBlocks() {
    if (this.contentBlocks.length === 0) {
      if (experimentalTreeDataSupport) {
        this._toContentBlocks(this.blockConfigs);
      } else {
        this._toFlatContentBlocks(this.blockConfigs);
      }
    }

    return {
      contentBlocks: this.contentBlocks,
      entityMap: this.entityMap
    };
  } // ***********************************WARNING******************************
  // The methods below this line are private - don't call them directly.

  /**
   * Generate a new ContentBlockConfig out of the current internal state
   * of the builder, then clears the internal state.
   */
  ;

  _proto._makeBlockConfig = function _makeBlockConfig() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var key = config.key || generateRandomKey();

    var block = _objectSpread({
      key: key,
      type: this.currentBlockType,
      text: this.currentText,
      characterList: this.characterList,
      depth: this.currentDepth,
      parent: null,
      children: List(),
      prevSibling: null,
      nextSibling: null,
      childConfigs: []
    }, config);

    this.characterList = List();
    this.currentBlockType = 'unstyled';
    this.currentText = '';
    return block;
  }
  /**
   * Converts an array of HTML elements to a multi-root tree of content
   * block configs. Some text content may be left in the builders internal
   * state to enable chaining sucessive calls.
   */
  ;

  _proto._toBlockConfigs = function _toBlockConfigs(nodes, style) {
    var blockConfigs = [];

    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var nodeName = node.nodeName.toLowerCase();

      if (nodeName === 'body' || isListNode(nodeName)) {
        // body, ol and ul are 'block' type nodes so create a block config
        // with the text accumulated so far (if any)
        this._trimCurrentText();

        if (this.currentText !== '') {
          blockConfigs.push(this._makeBlockConfig());
        } // body, ol and ul nodes are ignored, but their children are inlined in
        // the parent block config.


        var wasCurrentDepth = this.currentDepth;
        var wasWrapper = this.wrapper;

        if (isListNode(nodeName)) {
          this.wrapper = nodeName;

          if (isListNode(wasWrapper)) {
            this.currentDepth++;
          }
        }

        blockConfigs.push.apply(blockConfigs, this._toBlockConfigs(Array.from(node.childNodes), style));
        this.currentDepth = wasCurrentDepth;
        this.wrapper = wasWrapper;
        continue;
      }

      var blockType = this.blockTypeMap.get(nodeName);

      if (blockType !== undefined) {
        // 'block' type node means we need to create a block config
        // with the text accumulated so far (if any)
        this._trimCurrentText();

        if (this.currentText !== '') {
          blockConfigs.push(this._makeBlockConfig());
        }

        var _wasCurrentDepth = this.currentDepth;
        var _wasWrapper = this.wrapper;
        this.wrapper = nodeName === 'pre' ? 'pre' : this.wrapper;

        if (typeof blockType !== 'string') {
          blockType = this.disambiguate(nodeName, this.wrapper) || blockType[0] || 'unstyled';
        }

        if (!experimentalTreeDataSupport && isHTMLElement(node) && (blockType === 'unordered-list-item' || blockType === 'ordered-list-item')) {
          var htmlElement = node;
          this.currentDepth = getListItemDepth(htmlElement, this.currentDepth);
        }

        var key = generateRandomKey();

        var childConfigs = this._toBlockConfigs(Array.from(node.childNodes), style);

        this._trimCurrentText();

        blockConfigs.push(this._makeBlockConfig({
          key: key,
          childConfigs: childConfigs,
          type: blockType
        }));
        this.currentDepth = _wasCurrentDepth;
        this.wrapper = _wasWrapper;
        continue;
      }

      if (nodeName === '#text') {
        this._addTextNode(node, style);

        continue;
      }

      if (nodeName === 'br') {
        this._addBreakNode(node, style);

        continue;
      }

      if (isValidImage(node)) {
        this._addImgNode(node, style);

        continue;
      }

      if (isValidAnchor(node)) {
        this._addAnchorNode(node, blockConfigs, style);

        continue;
      }

      var newStyle = style;

      if (HTMLTagToRawInlineStyleMap.has(nodeName)) {
        newStyle = newStyle.add(HTMLTagToRawInlineStyleMap.get(nodeName));
      }

      newStyle = styleFromNodeAttributes(node, newStyle);
      var inlineStyle = detectInlineStyle(node);

      if (inlineStyle != null) {
        newStyle = newStyle.add(inlineStyle);
      }

      blockConfigs.push.apply(blockConfigs, this._toBlockConfigs(Array.from(node.childNodes), newStyle));
    }

    return blockConfigs;
  }
  /**
   * Append a string of text to the internal buffer.
   */
  ;

  _proto._appendText = function _appendText(text, style) {
    var _this$characterList;

    this.currentText += text;
    var characterMetadata = CharacterMetadata.create({
      style: style,
      entity: this.currentEntity
    });
    this.characterList = (_this$characterList = this.characterList).push.apply(_this$characterList, Array(text.length).fill(characterMetadata));
  }
  /**
   * Trim the text in the internal buffer.
   */
  ;

  _proto._trimCurrentText = function _trimCurrentText() {
    var l = this.currentText.length;
    var begin = l - this.currentText.trimLeft().length;
    var end = this.currentText.trimRight().length; // We should not trim whitespaces for which an entity is defined.

    var entity = this.characterList.findEntry(function (characterMetadata) {
      return characterMetadata.getEntity() !== null;
    });
    begin = entity !== undefined ? Math.min(begin, entity[0]) : begin;
    entity = this.characterList.reverse().findEntry(function (characterMetadata) {
      return characterMetadata.getEntity() !== null;
    });
    end = entity !== undefined ? Math.max(end, l - entity[0]) : end;

    if (begin > end) {
      this.currentText = '';
      this.characterList = List();
    } else {
      this.currentText = this.currentText.slice(begin, end);
      this.characterList = this.characterList.slice(begin, end);
    }
  }
  /**
   * Add the content of an HTML text node to the internal state
   */
  ;

  _proto._addTextNode = function _addTextNode(node, style) {
    var text = node.textContent;
    var trimmedText = text.trim(); // If we are not in a pre block and the trimmed content is empty,
    // normalize to a single space.

    if (trimmedText === '' && this.wrapper !== 'pre') {
      text = ' ';
    }

    if (this.wrapper !== 'pre') {
      // Trim leading line feed, which is invisible in HTML
      text = text.replace(REGEX_LEADING_LF, ''); // Can't use empty string because MSWord

      text = text.replace(REGEX_LF, SPACE);
    }

    this._appendText(text, style);
  };

  _proto._addBreakNode = function _addBreakNode(node, style) {
    if (!isHTMLBRElement(node)) {
      return;
    }

    this._appendText('\n', style);
  }
  /**
   * Add the content of an HTML img node to the internal state
   */
  ;

  _proto._addImgNode = function _addImgNode(node, style) {
    if (!isHTMLImageElement(node)) {
      return;
    }

    var image = node;
    var entityConfig = {};
    imgAttr.forEach(function (attr) {
      var imageAttribute = image.getAttribute(attr);

      if (imageAttribute) {
        entityConfig[attr] = imageAttribute;
      }
    }); // TODO: T15530363 update this when we remove DraftEntity entirely

    this.currentEntity = this.entityMap.__create('IMAGE', 'IMMUTABLE', entityConfig); // The child text node cannot just have a space or return as content (since
    // we strip those out), unless the image is for presentation only.
    // See https://github.com/facebook/draft-js/issues/231 for some context.

    if (gkx('draftjs_fix_paste_for_img')) {
      if (image.getAttribute('role') !== 'presentation') {
        this._appendText("\uD83D\uDCF7", style);
      }
    } else {
      this._appendText("\uD83D\uDCF7", style);
    }

    this.currentEntity = null;
  }
  /**
   * Add the content of an HTML 'a' node to the internal state. Child nodes
   * (if any) are converted to Block Configs and appended to the provided
   * blockConfig array.
   */
  ;

  _proto._addAnchorNode = function _addAnchorNode(node, blockConfigs, style) {
    // The check has already been made by isValidAnchor but
    // we have to do it again to keep flow happy.
    if (!isHTMLAnchorElement(node)) {
      return;
    }

    var anchor = node;
    var entityConfig = {};
    anchorAttr.forEach(function (attr) {
      var anchorAttribute = anchor.getAttribute(attr);

      if (anchorAttribute) {
        entityConfig[attr] = anchorAttribute;
      }
    });
    entityConfig.url = new URI(anchor.href).toString(); // TODO: T15530363 update this when we remove DraftEntity completely

    this.currentEntity = this.entityMap.__create('LINK', 'MUTABLE', entityConfig || {});
    blockConfigs.push.apply(blockConfigs, this._toBlockConfigs(Array.from(node.childNodes), style));
    this.currentEntity = null;
  }
  /**
   * Walk the BlockConfig tree, compute parent/children/siblings,
   * and generate the corresponding ContentBlockNode
   */
  ;

  _proto._toContentBlocks = function _toContentBlocks(blockConfigs) {
    var parent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var l = blockConfigs.length - 1;

    for (var i = 0; i <= l; i++) {
      var config = blockConfigs[i];
      config.parent = parent;
      config.prevSibling = i > 0 ? blockConfigs[i - 1].key : null;
      config.nextSibling = i < l ? blockConfigs[i + 1].key : null;
      config.children = List(config.childConfigs.map(function (child) {
        return child.key;
      }));
      this.contentBlocks.push(new ContentBlockNode(_objectSpread({}, config)));

      this._toContentBlocks(config.childConfigs, config.key);
    }
  }
  /**
   * Remove 'useless' container nodes from the block config hierarchy, by
   * replacing them with their children.
   */
  ;

  _proto._hoistContainersInBlockConfigs = function _hoistContainersInBlockConfigs(blockConfigs) {
    var _this = this;

    var hoisted = List(blockConfigs).flatMap(function (blockConfig) {
      // Don't mess with useful blocks
      if (blockConfig.type !== 'unstyled' || blockConfig.text !== '') {
        return [blockConfig];
      }

      return _this._hoistContainersInBlockConfigs(blockConfig.childConfigs);
    });
    return hoisted;
  } // ***********************************************************************
  // The two methods below are used for backward compatibility when
  // experimentalTreeDataSupport is disabled.

  /**
   * Same as _toContentBlocks but replaces nested blocks by their
   * text content.
   */
  ;

  _proto._toFlatContentBlocks = function _toFlatContentBlocks(blockConfigs) {
    var _this2 = this;

    var cleanConfigs = this._hoistContainersInBlockConfigs(blockConfigs);

    cleanConfigs.forEach(function (config) {
      var _this2$_extractTextFr = _this2._extractTextFromBlockConfigs(config.childConfigs),
          text = _this2$_extractTextFr.text,
          characterList = _this2$_extractTextFr.characterList;

      _this2.contentBlocks.push(new ContentBlock(_objectSpread({}, config, {
        text: config.text + text,
        characterList: config.characterList.concat(characterList)
      })));
    });
  }
  /**
   * Extract the text and the associated inline styles form an
   * array of content block configs.
   */
  ;

  _proto._extractTextFromBlockConfigs = function _extractTextFromBlockConfigs(blockConfigs) {
    var l = blockConfigs.length - 1;
    var text = '';
    var characterList = List();

    for (var i = 0; i <= l; i++) {
      var config = blockConfigs[i];
      text += config.text;
      characterList = characterList.concat(config.characterList);

      if (text !== '' && config.type !== 'unstyled') {
        text += '\n';
        characterList = characterList.push(characterList.last());
      }

      var children = this._extractTextFromBlockConfigs(config.childConfigs);

      text += children.text;
      characterList = characterList.concat(children.characterList);
    }

    return {
      text: text,
      characterList: characterList
    };
  };

  return ContentBlocksBuilder;
}();
/**
 * Converts an HTML string to an array of ContentBlocks and an EntityMap
 * suitable to initialize the internal state of a Draftjs component.
 */


var convertFromHTMLToContentBlocks = function convertFromHTMLToContentBlocks(html) {
  var DOMBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSafeBodyFromHTML;
  var blockRenderMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultDraftBlockRenderMap;
  // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
  // arbitrary code in whatever environment you're running this in. For an
  // example of how we try to do this in-browser, see getSafeBodyFromHTML.
  // Remove funky characters from the HTML string
  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, ''); // Build a DOM tree out of the HTML string

  var safeBody = DOMBuilder(html);

  if (!safeBody) {
    return null;
  } // Build a BlockTypeMap out of the BlockRenderMap


  var blockTypeMap = buildBlockTypeMap(blockRenderMap); // Select the proper block type for the cases where the blockRenderMap
  // uses multiple block types for the same html tag.

  var disambiguate = function disambiguate(tag, wrapper) {
    if (tag === 'li') {
      return wrapper === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
    }

    return null;
  };

  return new ContentBlocksBuilder(blockTypeMap, disambiguate).addDOMNode(safeBody).getContentBlocks();
};

module.exports = convertFromHTMLToContentBlocks;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Provides utilities for handling draftjs keys.
 *
 * @emails oncall+draft_js
 * 
 * @format
 */


function notEmptyKey(key) {
  return key != null && key != '';
}

module.exports = {
  notEmptyKey: notEmptyKey
};

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftJsDebugLogging = __webpack_require__(1166);

var EditorState = __webpack_require__(62);

var getContentEditableContainer = __webpack_require__(1173);

var getDraftEditorSelection = __webpack_require__(1175);

function editOnSelect(editor) {
  if (editor._blockSelectEvents || editor._latestEditorState !== editor.props.editorState) {
    if (editor._blockSelectEvents) {
      var _editorState = editor.props.editorState;

      var selectionState = _editorState.getSelection();

      DraftJsDebugLogging.logBlockedSelectionEvent({
        // For now I don't think we need any other info
        anonymizedDom: 'N/A',
        extraParams: JSON.stringify({
          stacktrace: new Error().stack
        }),
        selectionState: JSON.stringify(selectionState.toJS())
      });
    }

    return;
  }

  var editorState = editor.props.editorState;
  var documentSelection = getDraftEditorSelection(editorState, getContentEditableContainer(editor));
  var updatedSelectionState = documentSelection.selectionState;

  if (updatedSelectionState !== editorState.getSelection()) {
    if (documentSelection.needsRecovery) {
      editorState = EditorState.forceSelection(editorState, updatedSelectionState);
    } else {
      editorState = EditorState.acceptSelection(editorState, updatedSelectionState);
    }

    editor.update(editorState);
  }
}

module.exports = editOnSelect;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var invariant = __webpack_require__(48);

var isHTMLElement = __webpack_require__(340);

function getContentEditableContainer(editor) {
  var editorNode = editor.editorContainer;
  !editorNode ?  false ? invariant(false, 'Missing editorNode') : invariant(false) : void 0;
  !isHTMLElement(editorNode.firstChild) ?  false ? invariant(false, 'editorNode.firstChild is not an HTMLElement') : invariant(false) : void 0;
  var htmlElement = editorNode.firstChild;
  return htmlElement;
}

module.exports = getContentEditableContainer;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var KeyBindingUtil = __webpack_require__(646);

var Keys = __webpack_require__(430);

var UserAgent = __webpack_require__(106);

var isOSX = UserAgent.isPlatform('Mac OS X'); // Firefox on OSX had a bug resulting in navigation instead of cursor movement.
// This bug was fixed in Firefox 29. Feature detection is virtually impossible
// so we just check the version number. See #342765.

var shouldFixFirefoxMovement = isOSX && UserAgent.isBrowser('Firefox < 29');
var hasCommandModifier = KeyBindingUtil.hasCommandModifier,
    isCtrlKeyCommand = KeyBindingUtil.isCtrlKeyCommand;

function shouldRemoveWord(e) {
  return isOSX && e.altKey || isCtrlKeyCommand(e);
}
/**
 * Get the appropriate undo/redo command for a Z key command.
 */


function getZCommand(e) {
  if (!hasCommandModifier(e)) {
    return null;
  }

  return e.shiftKey ? 'redo' : 'undo';
}

function getDeleteCommand(e) {
  // Allow default "cut" behavior for PCs on Shift + Delete.
  if (!isOSX && e.shiftKey) {
    return null;
  }

  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
}

function getBackspaceCommand(e) {
  if (hasCommandModifier(e) && isOSX) {
    return 'backspace-to-start-of-line';
  }

  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
}
/**
 * Retrieve a bound key command for the given event.
 */


function getDefaultKeyBinding(e) {
  switch (e.keyCode) {
    case 66:
      // B
      return hasCommandModifier(e) ? 'bold' : null;

    case 68:
      // D
      return isCtrlKeyCommand(e) ? 'delete' : null;

    case 72:
      // H
      return isCtrlKeyCommand(e) ? 'backspace' : null;

    case 73:
      // I
      return hasCommandModifier(e) ? 'italic' : null;

    case 74:
      // J
      return hasCommandModifier(e) ? 'code' : null;

    case 75:
      // K
      return isOSX && isCtrlKeyCommand(e) ? 'secondary-cut' : null;

    case 77:
      // M
      return isCtrlKeyCommand(e) ? 'split-block' : null;

    case 79:
      // O
      return isCtrlKeyCommand(e) ? 'split-block' : null;

    case 84:
      // T
      return isOSX && isCtrlKeyCommand(e) ? 'transpose-characters' : null;

    case 85:
      // U
      return hasCommandModifier(e) ? 'underline' : null;

    case 87:
      // W
      return isOSX && isCtrlKeyCommand(e) ? 'backspace-word' : null;

    case 89:
      // Y
      if (isCtrlKeyCommand(e)) {
        return isOSX ? 'secondary-paste' : 'redo';
      }

      return null;

    case 90:
      // Z
      return getZCommand(e) || null;

    case Keys.RETURN:
      return 'split-block';

    case Keys.DELETE:
      return getDeleteCommand(e);

    case Keys.BACKSPACE:
      return getBackspaceCommand(e);
    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.

    case Keys.LEFT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;

    case Keys.RIGHT:
      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;

    default:
      return null;
  }
}

module.exports = getDefaultKeyBinding;

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var getDraftEditorSelectionWithNodes = __webpack_require__(1176);
/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */


function getDraftEditorSelection(editorState, root) {
  var selection = root.ownerDocument.defaultView.getSelection();
  var anchorNode = selection.anchorNode,
      anchorOffset = selection.anchorOffset,
      focusNode = selection.focusNode,
      focusOffset = selection.focusOffset,
      rangeCount = selection.rangeCount;

  if ( // No active selection.
  rangeCount === 0 || // No selection, ever. As in, the user hasn't selected anything since
  // opening the document.
  anchorNode == null || focusNode == null) {
    return {
      selectionState: editorState.getSelection().set('hasFocus', false),
      needsRecovery: false
    };
  }

  return getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset);
}

module.exports = getDraftEditorSelection;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var findAncestorOffsetKey = __webpack_require__(426);

var getSelectionOffsetKeyForNode = __webpack_require__(1182);

var getUpdatedSelectionState = __webpack_require__(1184);

var invariant = __webpack_require__(48);

var isElement = __webpack_require__(242);

var nullthrows = __webpack_require__(107);

/**
 * Convert the current selection range to an anchor/focus pair of offset keys
 * and values that can be interpreted by components.
 */
function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE; // If the selection range lies only on text nodes, the task is simple.
  // Find the nearest offset-aware elements and use the
  // offset values supplied by the selection range.

  if (anchorIsTextNode && focusIsTextNode) {
    return {
      selectionState: getUpdatedSelectionState(editorState, nullthrows(findAncestorOffsetKey(anchorNode)), anchorOffset, nullthrows(findAncestorOffsetKey(focusNode)), focusOffset),
      needsRecovery: false
    };
  }

  var anchorPoint = null;
  var focusPoint = null;
  var needsRecovery = true; // An element is selected. Convert this selection range into leaf offset
  // keys and offset values for consumption at the component level. This
  // is common in Firefox, where select-all and triple click behavior leads
  // to entire elements being selected.
  //
  // Note that we use the `needsRecovery` parameter in the callback here. This
  // is because when certain elements are selected, the behavior for subsequent
  // cursor movement (e.g. via arrow keys) is uncertain and may not match
  // expectations at the component level. For example, if an entire <div> is
  // selected and the user presses the right arrow, Firefox keeps the selection
  // on the <div>. If we allow subsequent keypresses to insert characters
  // natively, they will be inserted into a browser-created text node to the
  // right of that <div>. This is obviously undesirable.
  //
  // With the `needsRecovery` flag, we inform the caller that it is responsible
  // for manually setting the selection state on the rendered document to
  // ensure proper selection state maintenance.

  if (anchorIsTextNode) {
    anchorPoint = {
      key: nullthrows(findAncestorOffsetKey(anchorNode)),
      offset: anchorOffset
    };
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
  } else if (focusIsTextNode) {
    focusPoint = {
      key: nullthrows(findAncestorOffsetKey(focusNode)),
      offset: focusOffset
    };
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
  } else {
    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset); // If the selection is collapsed on an empty block, don't force recovery.
    // This way, on arrow key selection changes, the browser can move the
    // cursor from a non-zero offset on one block, through empty blocks,
    // to a matching non-zero offset on other text blocks.

    if (anchorNode === focusNode && anchorOffset === focusOffset) {
      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
    }
  }

  return {
    selectionState: getUpdatedSelectionState(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
    needsRecovery: needsRecovery
  };
}
/**
 * Identify the first leaf descendant for the given node.
 */


function getFirstLeaf(node) {
  while (node.firstChild && ( // data-blocks has no offset
  isElement(node.firstChild) && node.firstChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.firstChild))) {
    node = node.firstChild;
  }

  return node;
}
/**
 * Identify the last leaf descendant for the given node.
 */


function getLastLeaf(node) {
  while (node.lastChild && ( // data-blocks has no offset
  isElement(node.lastChild) && node.lastChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.lastChild))) {
    node = node.lastChild;
  }

  return node;
}

function getPointForNonTextNode(editorRoot, startNode, childOffset) {
  var node = startNode;
  var offsetKey = findAncestorOffsetKey(node);
  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ?  false ? invariant(false, 'Unknown node in selection range.') : invariant(false) : void 0; // If the editorRoot is the selection, step downward into the content
  // wrapper.

  if (editorRoot === node) {
    node = node.firstChild;
    !isElement(node) ?  false ? invariant(false, 'Invalid DraftEditorContents node.') : invariant(false) : void 0;
    var castedNode = node; // assignment only added for flow :/
    // otherwise it throws in line 200 saying that node can be null or undefined

    node = castedNode;
    !(node.getAttribute('data-contents') === 'true') ?  false ? invariant(false, 'Invalid DraftEditorContents structure.') : invariant(false) : void 0;

    if (childOffset > 0) {
      childOffset = node.childNodes.length;
    }
  } // If the child offset is zero and we have an offset key, we're done.
  // If there's no offset key because the entire editor is selected,
  // find the leftmost ("first") leaf in the tree and use that as the offset
  // key.


  if (childOffset === 0) {
    var key = null;

    if (offsetKey != null) {
      key = offsetKey;
    } else {
      var firstLeaf = getFirstLeaf(node);
      key = nullthrows(getSelectionOffsetKeyForNode(firstLeaf));
    }

    return {
      key: key,
      offset: 0
    };
  }

  var nodeBeforeCursor = node.childNodes[childOffset - 1];
  var leafKey = null;
  var textLength = null;

  if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
    // Our target node may be a leaf or a text node, in which case we're
    // already where we want to be and can just use the child's length as
    // our offset.
    leafKey = nullthrows(offsetKey);
    textLength = getTextContentLength(nodeBeforeCursor);
  } else {
    // Otherwise, we'll look at the child to the left of the cursor and find
    // the last leaf node in its subtree.
    var lastLeaf = getLastLeaf(nodeBeforeCursor);
    leafKey = nullthrows(getSelectionOffsetKeyForNode(lastLeaf));
    textLength = getTextContentLength(lastLeaf);
  }

  return {
    key: leafKey,
    offset: textLength
  };
}
/**
 * Return the length of a node's textContent, regarding single newline
 * characters as zero-length. This allows us to avoid problems with identifying
 * the correct selection offset for empty blocks in IE, in which we
 * render newlines instead of break tags.
 */


function getTextContentLength(node) {
  var textContent = node.textContent;
  return textContent === '\n' ? 0 : textContent.length;
}

module.exports = getDraftEditorSelectionWithNodes;

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var getContentStateFragment = __webpack_require__(427);

function getFragmentFromSelection(editorState) {
  var selectionState = editorState.getSelection();

  if (selectionState.isCollapsed()) {
    return null;
  }

  return getContentStateFragment(editorState.getCurrentContent(), selectionState);
}

module.exports = getFragmentFromSelection;

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */
var ContentBlockNode = __webpack_require__(134);

var getNextDelimiterBlockKey = function getNextDelimiterBlockKey(block, blockMap) {
  var isExperimentalTreeBlock = block instanceof ContentBlockNode;

  if (!isExperimentalTreeBlock) {
    return null;
  }

  var nextSiblingKey = block.getNextSiblingKey();

  if (nextSiblingKey) {
    return nextSiblingKey;
  }

  var parent = block.getParentKey();

  if (!parent) {
    return null;
  }

  var nextNonDescendantBlock = blockMap.get(parent);

  while (nextNonDescendantBlock && !nextNonDescendantBlock.getNextSiblingKey()) {
    var parentKey = nextNonDescendantBlock.getParentKey();
    nextNonDescendantBlock = parentKey ? blockMap.get(parentKey) : null;
  }

  if (!nextNonDescendantBlock) {
    return null;
  }

  return nextNonDescendantBlock.getNextSiblingKey();
};

module.exports = getNextDelimiterBlockKey;

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * 
 * @typechecks
 * @format
 */

/**
 * Retrieve an object's own values as an array. If you want the values in the
 * protoype chain, too, use getObjectValuesIncludingPrototype.
 *
 * If you are looking for a function that creates an Array instance based
 * on an "Array-like" object, use createArrayFrom instead.
 *
 * @param {object} obj An object.
 * @return {array}     The object's values.
 */
function getOwnObjectValues(obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
}

module.exports = getOwnObjectValues;

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UserAgent = __webpack_require__(106);

var invariant = __webpack_require__(48);

var isChrome = UserAgent.isBrowser('Chrome'); // In Chrome, the client rects will include the entire bounds of all nodes that
// begin (have a start tag) within the selection, even if the selection does
// not overlap the entire node. To resolve this, we split the range at each
// start tag and join the client rects together.
// https://code.google.com/p/chromium/issues/detail?id=324437

/* eslint-disable consistent-return */

function getRangeClientRectsChrome(range) {
  var tempRange = range.cloneRange();
  var clientRects = [];

  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
    // If we've climbed up to the common ancestor, we can now use the
    // original start point and stop climbing the tree.
    var atCommonAncestor = ancestor === range.commonAncestorContainer;

    if (atCommonAncestor) {
      tempRange.setStart(range.startContainer, range.startOffset);
    } else {
      tempRange.setStart(tempRange.endContainer, 0);
    }

    var rects = Array.from(tempRange.getClientRects());
    clientRects.push(rects);

    if (atCommonAncestor) {
      var _ref;

      clientRects.reverse();
      return (_ref = []).concat.apply(_ref, clientRects);
    }

    tempRange.setEndBefore(ancestor);
  }

   true ?  false ? invariant(false, 'Found an unexpected detached subtree when getting range client rects.') : invariant(false) : void 0;
}
/* eslint-enable consistent-return */

/**
 * Like range.getClientRects() but normalizes for browser bugs.
 */


var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
  return Array.from(range.getClientRects());
};
module.exports = getRangeClientRects;

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UserAgent = __webpack_require__(106);

var invariant = __webpack_require__(48);

var isOldIE = UserAgent.isBrowser('IE <= 9'); // Provides a dom node that will not execute scripts
// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM

function getSafeBodyFromHTML(html) {
  var doc;
  var root = null; // Provides a safe context

  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
    doc = document.implementation.createHTMLDocument('foo');
    !doc.documentElement ?  false ? invariant(false, 'Missing doc.documentElement') : invariant(false) : void 0;
    doc.documentElement.innerHTML = html;
    root = doc.getElementsByTagName('body')[0];
  }

  return root;
}

module.exports = getSafeBodyFromHTML;

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */

/**
 * Get offset key from a node or it's child nodes. Return the first offset key
 * found on the DOM tree of given node.
 */

var isElement = __webpack_require__(242);

function getSelectionOffsetKeyForNode(node) {
  if (isElement(node)) {
    var castedNode = node;
    var offsetKey = castedNode.getAttribute('data-offset-key');

    if (offsetKey) {
      return offsetKey;
    }

    for (var ii = 0; ii < castedNode.childNodes.length; ii++) {
      var childOffsetKey = getSelectionOffsetKeyForNode(castedNode.childNodes[ii]);

      if (childOffsetKey) {
        return childOffsetKey;
      }
    }
  }

  return null;
}

module.exports = getSelectionOffsetKeyForNode;

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var invariant = __webpack_require__(48);

var TEXT_CLIPPING_REGEX = /\.textClipping$/;
var TEXT_TYPES = {
  'text/plain': true,
  'text/html': true,
  'text/rtf': true
}; // Somewhat arbitrary upper bound on text size. Let's not lock up the browser.

var TEXT_SIZE_UPPER_BOUND = 5000;
/**
 * Extract the text content from a file list.
 */

function getTextContentFromFiles(files, callback) {
  var readCount = 0;
  var results = [];
  files.forEach(function (
  /*blob*/
  file) {
    readFile(file, function (
    /*string*/
    text) {
      readCount++;
      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));

      if (readCount == files.length) {
        callback(results.join('\r'));
      }
    });
  });
}
/**
 * todo isaac: Do work to turn html/rtf into a content fragment.
 */


function readFile(file, callback) {
  if (!global.FileReader || file.type && !(file.type in TEXT_TYPES)) {
    callback('');
    return;
  }

  if (file.type === '') {
    var _contents = ''; // Special-case text clippings, which have an empty type but include
    // `.textClipping` in the file name. `readAsText` results in an empty
    // string for text clippings, so we force the file name to serve
    // as the text value for the file.

    if (TEXT_CLIPPING_REGEX.test(file.name)) {
      _contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
    }

    callback(_contents);
    return;
  }

  var reader = new FileReader();

  reader.onload = function () {
    var result = reader.result;
    !(typeof result === 'string') ?  false ? invariant(false, 'We should be calling "FileReader.readAsText" which returns a string') : invariant(false) : void 0;
    callback(result);
  };

  reader.onerror = function () {
    callback('');
  };

  reader.readAsText(file);
}

module.exports = getTextContentFromFiles;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftOffsetKey = __webpack_require__(182);

var nullthrows = __webpack_require__(107);

function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
  var selection = nullthrows(editorState.getSelection());

  if (!anchorKey || !focusKey) {
    // If we cannot make sense of the updated selection state, stick to the current one.
    if (false) {
      /* eslint-disable-next-line */
      console.warn('Invalid selection state.', arguments, editorState.toJS());
    }

    return selection;
  }

  var anchorPath = DraftOffsetKey.decode(anchorKey);
  var anchorBlockKey = anchorPath.blockKey;
  var anchorLeafBlockTree = editorState.getBlockTree(anchorBlockKey);
  var anchorLeaf = anchorLeafBlockTree && anchorLeafBlockTree.getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);
  var focusPath = DraftOffsetKey.decode(focusKey);
  var focusBlockKey = focusPath.blockKey;
  var focusLeafBlockTree = editorState.getBlockTree(focusBlockKey);
  var focusLeaf = focusLeafBlockTree && focusLeafBlockTree.getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);

  if (!anchorLeaf || !focusLeaf) {
    // If we cannot make sense of the updated selection state, stick to the current one.
    if (false) {
      /* eslint-disable-next-line */
      console.warn('Invalid selection state.', arguments, editorState.toJS());
    }

    return selection;
  }

  var anchorLeafStart = anchorLeaf.get('start');
  var focusLeafStart = focusLeaf.get('start');
  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;
  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;

  if (areEqual) {
    return selection;
  }

  var isBackward = false;

  if (anchorBlockKey === focusBlockKey) {
    var anchorLeafEnd = anchorLeaf.get('end');
    var focusLeafEnd = focusLeaf.get('end');

    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
      isBackward = focusOffset < anchorOffset;
    } else {
      isBackward = focusLeafStart < anchorLeafStart;
    }
  } else {
    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
      return v === anchorBlockKey || v === focusBlockKey;
    }).first();
    isBackward = startKey === focusBlockKey;
  }

  return selection.merge({
    anchorKey: anchorBlockKey,
    anchorOffset: anchorBlockOffset,
    focusKey: focusBlockKey,
    focusOffset: focusBlockOffset,
    isBackward: isBackward
  });
}

module.exports = getUpdatedSelectionState;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function getWindowForNode(node) {
  if (!node || !node.ownerDocument || !node.ownerDocument.defaultView) {
    return window;
  }

  return node.ownerDocument.defaultView;
}

module.exports = getWindowForNode;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/**
 * Maintain persistence for target list when appending and prepending.
 */
function insertIntoList(targetListArg, toInsert, offset) {
  var targetList = targetListArg;

  if (offset === targetList.count()) {
    toInsert.forEach(function (c) {
      targetList = targetList.push(c);
    });
  } else if (offset === 0) {
    toInsert.reverse().forEach(function (c) {
      targetList = targetList.unshift(c);
    });
  } else {
    var head = targetList.slice(0, offset);
    var tail = targetList.slice(offset);
    targetList = head.concat(toInsert, tail).toList();
  }

  return targetList;
}

module.exports = insertIntoList;

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var isElement = __webpack_require__(242);

function isHTMLBRElement(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  return isElement(node) && node.nodeName === 'BR';
}

module.exports = isHTMLBRElement;

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(62);

var UnicodeUtils = __webpack_require__(243);

var moveSelectionBackward = __webpack_require__(648);

var removeTextWithStrategy = __webpack_require__(341);
/**
 * Remove the selected range. If the cursor is collapsed, remove the preceding
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */


function keyCommandPlainBackspace(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
    return moveSelectionBackward(strategyState, charBehind ? UnicodeUtils.getUTF16Length(charBehind, 0) : 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();
  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
}

module.exports = keyCommandPlainBackspace;

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var Immutable = __webpack_require__(46);

var Map = Immutable.Map;

function modifyBlockForContentState(contentState, selectionState, operation) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(operation);
  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = modifyBlockForContentState;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var warning = __webpack_require__(652);
/**
 * Given a collapsed selection, move the focus `maxDistance` forward within
 * the selected block. If the selection will go beyond the end of the block,
 * move focus to the start of the next block, but no further.
 *
 * This function is not Unicode-aware, so surrogate pairs will be treated
 * as having length 2.
 */


function moveSelectionForward(editorState, maxDistance) {
  var selection = editorState.getSelection(); // Should eventually make this an invariant

   false ? warning(selection.isCollapsed(), 'moveSelectionForward should only be called with a collapsed SelectionState') : void 0;
  var key = selection.getStartKey();
  var offset = selection.getStartOffset();
  var content = editorState.getCurrentContent();
  var focusKey = key;
  var focusOffset;
  var block = content.getBlockForKey(key);

  if (maxDistance > block.getText().length - offset) {
    focusKey = content.getKeyAfter(key);
    focusOffset = 0;
  } else {
    focusOffset = offset + maxDistance;
  }

  return selection.merge({
    focusKey: focusKey,
    focusOffset: focusOffset
  });
}

module.exports = moveSelectionForward;

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var ContentBlockNode = __webpack_require__(134);

var generateRandomKey = __webpack_require__(164);

var Immutable = __webpack_require__(46);

var OrderedMap = Immutable.OrderedMap;

var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys(blockMap) {
  var newKeysRef = {}; // we keep track of root blocks in order to update subsequent sibling links

  var lastRootBlock;
  return OrderedMap(blockMap.withMutations(function (blockMapState) {
    blockMapState.forEach(function (block, index) {
      var oldKey = block.getKey();
      var nextKey = block.getNextSiblingKey();
      var prevKey = block.getPrevSiblingKey();
      var childrenKeys = block.getChildKeys();
      var parentKey = block.getParentKey(); // new key that we will use to build linking

      var key = generateRandomKey(); // we will add it here to re-use it later

      newKeysRef[oldKey] = key;

      if (nextKey) {
        var nextBlock = blockMapState.get(nextKey);

        if (nextBlock) {
          blockMapState.setIn([nextKey, 'prevSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'nextSibling'], null);
        }
      }

      if (prevKey) {
        var prevBlock = blockMapState.get(prevKey);

        if (prevBlock) {
          blockMapState.setIn([prevKey, 'nextSibling'], key);
        } else {
          // this can happen when generating random keys for fragments
          blockMapState.setIn([oldKey, 'prevSibling'], null);
        }
      }

      if (parentKey && blockMapState.get(parentKey)) {
        var parentBlock = blockMapState.get(parentKey);
        var parentChildrenList = parentBlock.getChildKeys();
        blockMapState.setIn([parentKey, 'children'], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
      } else {
        // blocks will then be treated as root block nodes
        blockMapState.setIn([oldKey, 'parent'], null);

        if (lastRootBlock) {
          blockMapState.setIn([lastRootBlock.getKey(), 'nextSibling'], key);
          blockMapState.setIn([oldKey, 'prevSibling'], newKeysRef[lastRootBlock.getKey()]);
        }

        lastRootBlock = blockMapState.get(oldKey);
      }

      childrenKeys.forEach(function (childKey) {
        var childBlock = blockMapState.get(childKey);

        if (childBlock) {
          blockMapState.setIn([childKey, 'parent'], key);
        } else {
          blockMapState.setIn([oldKey, 'children'], block.getChildKeys().filter(function (child) {
            return child !== childKey;
          }));
        }
      });
    });
  }).toArray().map(function (block) {
    return [newKeysRef[block.getKey()], block.set('key', newKeysRef[block.getKey()])];
  }));
};

var randomizeContentBlockKeys = function randomizeContentBlockKeys(blockMap) {
  return OrderedMap(blockMap.toArray().map(function (block) {
    var key = generateRandomKey();
    return [key, block.set('key', key)];
  }));
};

var randomizeBlockMapKeys = function randomizeBlockMapKeys(blockMap) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;

  if (!isTreeBasedBlockMap) {
    return randomizeContentBlockKeys(blockMap);
  }

  return randomizeContentBlockNodeKeys(blockMap);
};

module.exports = randomizeBlockMapKeys;

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var CharacterMetadata = __webpack_require__(133);

var findRangesImmutable = __webpack_require__(339);

var invariant = __webpack_require__(48);

function removeEntitiesAtEdges(contentState, selectionState) {
  var blockMap = contentState.getBlockMap();
  var entityMap = contentState.getEntityMap();
  var updatedBlocks = {};
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var startBlock = blockMap.get(startKey);
  var updatedStart = removeForBlock(entityMap, startBlock, startOffset);

  if (updatedStart !== startBlock) {
    updatedBlocks[startKey] = updatedStart;
  }

  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var endBlock = blockMap.get(endKey);

  if (startKey === endKey) {
    endBlock = updatedStart;
  }

  var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);

  if (updatedEnd !== endBlock) {
    updatedBlocks[endKey] = updatedEnd;
  }

  if (!Object.keys(updatedBlocks).length) {
    return contentState.set('selectionAfter', selectionState);
  }

  return contentState.merge({
    blockMap: blockMap.merge(updatedBlocks),
    selectionAfter: selectionState
  });
}
/**
 * Given a list of characters and an offset that is in the middle of an entity,
 * returns the start and end of the entity that is overlapping the offset.
 * Note: This method requires that the offset be in an entity range.
 */


function getRemovalRange(characters, entityKey, offset) {
  var removalRange; // Iterates through a list looking for ranges of matching items
  // based on the 'isEqual' callback.
  // Then instead of returning the result, call the 'found' callback
  // with each range.
  // Then filters those ranges based on the 'filter' callback
  //
  // Here we use it to find ranges of characters with the same entity key.

  findRangesImmutable(characters, // the list to iterate through
  function (a, b) {
    return a.getEntity() === b.getEntity();
  }, // 'isEqual' callback
  function (element) {
    return element.getEntity() === entityKey;
  }, // 'filter' callback
  function (start, end) {
    // 'found' callback
    if (start <= offset && end >= offset) {
      // this entity overlaps the offset index
      removalRange = {
        start: start,
        end: end
      };
    }
  });
  !(typeof removalRange === 'object') ?  false ? invariant(false, 'Removal range must exist within character list.') : invariant(false) : void 0;
  return removalRange;
}

function removeForBlock(entityMap, block, offset) {
  var chars = block.getCharacterList();
  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;

  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
    var entity = entityMap.__get(entityAfterCursor);

    if (entity.getMutability() !== 'MUTABLE') {
      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset),
          start = _getRemovalRange.start,
          end = _getRemovalRange.end;

      var current;

      while (start < end) {
        current = chars.get(start);
        chars = chars.set(start, CharacterMetadata.applyEntity(current, null));
        start++;
      }

      return block.set('characterList', chars);
    }
  }

  return block;
}

module.exports = removeEntitiesAtEdges;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');

function sanitizeDraftText(input) {
  return input.replace(REGEX_BLOCK_DELIMITER, '');
}

module.exports = sanitizeDraftText;

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var PhotosMimeType = __webpack_require__(2923);

var createArrayFromMixed = __webpack_require__(2930);

var emptyFunction = __webpack_require__(1195);

var CR_LF_REGEX = new RegExp("\r\n", 'g');
var LF_ONLY = "\n";
var RICH_TEXT_TYPES = {
  'text/rtf': 1,
  'text/html': 1
};
/**
 * If DataTransferItem is a file then return the Blob of data.
 *
 * @param {object} item
 * @return {?blob}
 */

function getFileFromDataTransfer(item) {
  if (item.kind == 'file') {
    return item.getAsFile();
  }
}

var DataTransfer =
/*#__PURE__*/
function () {
  /**
   * @param {object} data
   */
  function DataTransfer(data) {
    this.data = data; // Types could be DOMStringList or array

    this.types = data.types ? createArrayFromMixed(data.types) : [];
  }
  /**
   * Is this likely to be a rich text data transfer?
   *
   * @return {boolean}
   */


  var _proto = DataTransfer.prototype;

  _proto.isRichText = function isRichText() {
    // If HTML is available, treat this data as rich text. This way, we avoid
    // using a pasted image if it is packaged with HTML -- this may occur with
    // pastes from MS Word, for example.  However this is only rich text if
    // there's accompanying text.
    if (this.getHTML() && this.getText()) {
      return true;
    } // When an image is copied from a preview window, you end up with two
    // DataTransferItems one of which is a file's metadata as text.  Skip those.


    if (this.isImage()) {
      return false;
    }

    return this.types.some(function (type) {
      return RICH_TEXT_TYPES[type];
    });
  };
  /**
   * Get raw text.
   *
   * @return {?string}
   */


  _proto.getText = function getText() {
    var text;

    if (this.data.getData) {
      if (!this.types.length) {
        text = this.data.getData('Text');
      } else if (this.types.indexOf('text/plain') != -1) {
        text = this.data.getData('text/plain');
      }
    }

    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
  };
  /**
   * Get HTML paste data
   *
   * @return {?string}
   */


  _proto.getHTML = function getHTML() {
    if (this.data.getData) {
      if (!this.types.length) {
        return this.data.getData('Text');
      } else if (this.types.indexOf('text/html') != -1) {
        return this.data.getData('text/html');
      }
    }
  };
  /**
   * Is this a link data transfer?
   *
   * @return {boolean}
   */


  _proto.isLink = function isLink() {
    return this.types.some(function (type) {
      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
    });
  };
  /**
   * Get a link url.
   *
   * @return {?string}
   */


  _proto.getLink = function getLink() {
    if (this.data.getData) {
      if (this.types.indexOf('text/x-moz-url') != -1) {
        var url = this.data.getData('text/x-moz-url').split('\n');
        return url[0];
      }

      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
    }

    return null;
  };
  /**
   * Is this an image data transfer?
   *
   * @return {boolean}
   */


  _proto.isImage = function isImage() {
    var isImage = this.types.some(function (type) {
      // Firefox will have a type of application/x-moz-file for images during
      // dragging
      return type.indexOf('application/x-moz-file') != -1;
    });

    if (isImage) {
      return true;
    }

    var items = this.getFiles();

    for (var i = 0; i < items.length; i++) {
      var type = items[i].type;

      if (!PhotosMimeType.isImage(type)) {
        return false;
      }
    }

    return true;
  };

  _proto.getCount = function getCount() {
    if (this.data.hasOwnProperty('items')) {
      return this.data.items.length;
    } else if (this.data.hasOwnProperty('mozItemCount')) {
      return this.data.mozItemCount;
    } else if (this.data.files) {
      return this.data.files.length;
    }

    return null;
  };
  /**
   * Get files.
   *
   * @return {array}
   */


  _proto.getFiles = function getFiles() {
    if (this.data.items) {
      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction.thatReturnsArgument);
    } else if (this.data.files) {
      return Array.prototype.slice.call(this.data.files);
    } else {
      return [];
    }
  };
  /**
   * Are there any files to fetch?
   *
   * @return {boolean}
   */


  _proto.hasFiles = function hasFiles() {
    return this.getFiles().length > 0;
  };

  return DataTransfer;
}();

module.exports = DataTransfer;

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */


var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);

emptyFunction.thatReturnsThis = function () {
  return this;
};

emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/* eslint-disable fb-www/typeof-undefined */

/**
 * Same as document.activeElement but wraps in a try-catch block. In IE it is
 * not safe to call document.activeElement if there is nothing focused.
 *
 * The activeElement will be null only if the document or document body is not
 * yet defined.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */
function getActiveElement(doc)
/*?DOMElement*/
{
  doc = doc || (typeof document !== 'undefined' ? document : undefined);

  if (typeof doc === 'undefined') {
    return null;
  }

  try {
    return doc.activeElement || doc.body;
  } catch (e) {
    return doc.body;
  }
}

module.exports = getActiveElement;

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var getElementRect = __webpack_require__(2932);
/**
 * Gets an element's position in pixels relative to the viewport. The returned
 * object represents the position of the element's top left corner.
 *
 * @param {DOMElement} element
 * @return {object}
 */


function getElementPosition(element) {
  var rect = getElementRect(element);
  return {
    x: rect.left,
    y: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };
}

module.exports = getElementPosition;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks
 */
function getViewportWidth() {
  var width;

  if (document.documentElement) {
    width = document.documentElement.clientWidth;
  }

  if (!width && document.body) {
    width = document.body.clientWidth;
  }

  return width || 0;
}

function getViewportHeight() {
  var height;

  if (document.documentElement) {
    height = document.documentElement.clientHeight;
  }

  if (!height && document.body) {
    height = document.body.clientHeight;
  }

  return height || 0;
}
/**
 * Gets the viewport dimensions including any scrollbars.
 */


function getViewportDimensions() {
  return {
    width: window.innerWidth || getViewportWidth(),
    height: window.innerHeight || getViewportHeight()
  };
}
/**
 * Gets the viewport dimensions excluding any scrollbars.
 */


getViewportDimensions.withoutScrollbars = function () {
  return {
    width: getViewportWidth(),
    height: getViewportHeight()
  };
};

module.exports = getViewportDimensions;

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var curve = exports;

curve.base = __webpack_require__(434);
curve.short = __webpack_require__(2945);
curve.mont = __webpack_require__(2944);
curve.edwards = __webpack_require__(2943);


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Object = __webpack_require__(1200);

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(2967);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.printError = printError;

var _location = __webpack_require__(664);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */
function printError(error) {
  var printedLocations = [];

  if (error.nodes) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = error.nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var node = _step.value;

        if (node.loc) {
          printedLocations.push(highlightSourceAtLocation(node.loc.source, (0, _location.getLocation)(node.loc.source, node.loc.start)));
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } else if (error.source && error.locations) {
    var source = error.source;
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
      for (var _iterator2 = error.locations[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
        var location = _step2.value;
        printedLocations.push(highlightSourceAtLocation(source, location));
      }
    } catch (err) {
      _didIteratorError2 = true;
      _iteratorError2 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
          _iterator2.return();
        }
      } finally {
        if (_didIteratorError2) {
          throw _iteratorError2;
        }
      }
    }
  }

  return printedLocations.length === 0 ? error.message : [error.message].concat(printedLocations).join('\n\n') + '\n';
}
/**
 * Render a helpful description of the location of the error in the GraphQL
 * Source document.
 */


function highlightSourceAtLocation(source, location) {
  var firstLineColumnOffset = source.locationOffset.column - 1;
  var body = whitespace(firstLineColumnOffset) + source.body;
  var lineIndex = location.line - 1;
  var lineOffset = source.locationOffset.line - 1;
  var lineNum = location.line + lineOffset;
  var columnOffset = location.line === 1 ? firstLineColumnOffset : 0;
  var columnNum = location.column + columnOffset;
  var lines = body.split(/\r\n|[\n\r]/g);
  return "".concat(source.name, " (").concat(lineNum, ":").concat(columnNum, ")\n") + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
  ["".concat(lineNum - 1, ": "), lines[lineIndex - 1]], ["".concat(lineNum, ": "), lines[lineIndex]], ['', whitespace(columnNum - 1) + '^'], ["".concat(lineNum + 1, ": "), lines[lineIndex + 1]]]);
}

function printPrefixedLines(lines) {
  var existingLines = lines.filter(function (_ref) {
    var _ = _ref[0],
        line = _ref[1];
    return line !== undefined;
  });
  var padLen = 0;
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = existingLines[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var _ref4 = _step3.value;
      var prefix = _ref4[0];
      padLen = Math.max(padLen, prefix.length);
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return existingLines.map(function (_ref3) {
    var prefix = _ref3[0],
        line = _ref3[1];
    return lpad(padLen, prefix) + line;
  }).join('\n');
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function lpad(len, str) {
  return whitespace(len - str.length) + str;
}

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = applyToJSON;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * The `applyToJSON()` function defines toJSON() and inspect() prototype
 * methods which are aliases for toString().
 */
function applyToJSON(classObject) {
  classObject.prototype.toJSON = classObject.prototype.inspect = classObject.prototype.toString;
}

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPromise;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Returns true if the value acts like a Promise, i.e. has a "then" function,
 * otherwise returns false.
 */
// eslint-disable-next-line no-redeclare
function isPromise(value) {
  return Boolean(value && typeof value.then === 'function');
}

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = blockStringValue;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * Coffeescript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 */
function blockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.

  var commonIndent = null;

  for (var i = 1; i < lines.length; i++) {
    var line = lines[i];
    var indent = leadingWhitespace(line);

    if (indent < line.length && (commonIndent === null || indent < commonIndent)) {
      commonIndent = indent;

      if (commonIndent === 0) {
        break;
      }
    }
  }

  if (commonIndent) {
    for (var _i = 1; _i < lines.length; _i++) {
      lines[_i] = lines[_i].slice(commonIndent);
    }
  } // Remove leading and trailing blank lines.


  while (lines.length > 0 && isBlank(lines[0])) {
    lines.shift();
  }

  while (lines.length > 0 && isBlank(lines[lines.length - 1])) {
    lines.pop();
  } // Return a string of the lines joined with U+000A.


  return lines.join('\n');
}

function leadingWhitespace(str) {
  var i = 0;

  while (i < str.length && (str[i] === ' ' || str[i] === '\t')) {
    i++;
  }

  return i;
}

function isBlank(str) {
  return leadingWhitespace(str) === str.length;
}

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Source = void 0;

var _invariant = _interopRequireDefault(__webpack_require__(108));

var _defineToStringTag = _interopRequireDefault(__webpack_require__(438));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * A representation of source input to GraphQL.
 * `name` and `locationOffset` are optional. They are useful for clients who
 * store GraphQL documents in source files; for example, if the GraphQL input
 * starts at line 40 in a file named Foo.graphql, it might be useful for name to
 * be "Foo.graphql" and location to be `{ line: 40, column: 0 }`.
 * line and column in locationOffset are 1-indexed
 */
var Source = function Source(body, name, locationOffset) {
  _defineProperty(this, "body", void 0);

  _defineProperty(this, "name", void 0);

  _defineProperty(this, "locationOffset", void 0);

  this.body = body;
  this.name = name || 'GraphQL request';
  this.locationOffset = locationOffset || {
    line: 1,
    column: 1
  };
  !(this.locationOffset.line > 0) ? (0, _invariant.default)(0, 'line in locationOffset is 1-indexed and must be positive') : void 0;
  !(this.locationOffset.column > 0) ? (0, _invariant.default)(0, 'column in locationOffset is 1-indexed and must be positive') : void 0;
}; // Conditionally apply `[Symbol.toStringTag]` if `Symbol`s are supported


exports.Source = Source;
(0, _defineToStringTag.default)(Source);

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assertValidName = assertValidName;
exports.isValidNameError = isValidNameError;

var _GraphQLError = __webpack_require__(37);

var _invariant = _interopRequireDefault(__webpack_require__(108));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
var NAME_RX = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * Upholds the spec rules about naming.
 */

function assertValidName(name) {
  var error = isValidNameError(name);

  if (error) {
    throw error;
  }

  return name;
}
/**
 * Returns an Error if a name is invalid.
 */


function isValidNameError(name, node) {
  !(typeof name === 'string') ? (0, _invariant.default)(0, 'Expected string') : void 0;

  if (name.length > 1 && name[0] === '_' && name[1] === '_') {
    return new _GraphQLError.GraphQLError("Name \"".concat(name, "\" must not begin with \"__\", which is reserved by ") + 'GraphQL introspection.', node);
  }

  if (!NAME_RX.test(name)) {
    return new _GraphQLError.GraphQLError("Names must match /^[_a-zA-Z][_a-zA-Z0-9]*$/ but \"".concat(name, "\" does not."), node);
  }
}

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildASTSchema = buildASTSchema;
exports.getDescription = getDescription;
exports.buildSchema = buildSchema;
exports.ASTDefinitionBuilder = void 0;

var _invariant = _interopRequireDefault(__webpack_require__(108));

var _keyMap = _interopRequireDefault(__webpack_require__(183));

var _keyValMap = _interopRequireDefault(__webpack_require__(343));

var _valueFromAST = __webpack_require__(442);

var _validate = __webpack_require__(443);

var _blockStringValue = _interopRequireDefault(__webpack_require__(1207));

var _lexer = __webpack_require__(663);

var _parser = __webpack_require__(283);

var _values = __webpack_require__(658);

var _kinds = __webpack_require__(68);

var _predicates = __webpack_require__(439);

var _definition = __webpack_require__(54);

var _directives = __webpack_require__(136);

var _introspection = __webpack_require__(166);

var _scalars = __webpack_require__(184);

var _schema = __webpack_require__(246);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * This takes the ast of a schema document produced by the parse function in
 * src/language/parser.js.
 *
 * If no schema definition is provided, then it will look for types named Query
 * and Mutation.
 *
 * Given that AST it constructs a GraphQLSchema. The resulting schema
 * has no resolve methods, so execution will use default resolvers.
 *
 * Accepts options as a second argument:
 *
 *    - commentDescriptions:
 *        Provide true to use preceding comments as the description.
 *
 */
function buildASTSchema(documentAST, options) {
  !(documentAST && documentAST.kind === _kinds.Kind.DOCUMENT) ? (0, _invariant.default)(0, 'Must provide valid Document AST') : void 0;

  if (!options || !(options.assumeValid || options.assumeValidSDL)) {
    (0, _validate.assertValidSDL)(documentAST);
  }

  var schemaDef;
  var typeDefs = [];
  var nodeMap = Object.create(null);
  var directiveDefs = [];

  for (var i = 0; i < documentAST.definitions.length; i++) {
    var def = documentAST.definitions[i];

    if (def.kind === _kinds.Kind.SCHEMA_DEFINITION) {
      schemaDef = def;
    } else if ((0, _predicates.isTypeDefinitionNode)(def)) {
      var typeName = def.name.value;

      if (nodeMap[typeName]) {
        throw new Error("Type \"".concat(typeName, "\" was defined more than once."));
      }

      typeDefs.push(def);
      nodeMap[typeName] = def;
    } else if (def.kind === _kinds.Kind.DIRECTIVE_DEFINITION) {
      directiveDefs.push(def);
    }
  }

  var operationTypes = schemaDef ? getOperationTypes(schemaDef) : {
    query: nodeMap.Query,
    mutation: nodeMap.Mutation,
    subscription: nodeMap.Subscription
  };
  var definitionBuilder = new ASTDefinitionBuilder(nodeMap, options, function (typeRef) {
    throw new Error("Type \"".concat(typeRef.name.value, "\" not found in document."));
  });
  var directives = directiveDefs.map(function (def) {
    return definitionBuilder.buildDirective(def);
  }); // If specified directives were not explicitly declared, add them.

  if (!directives.some(function (directive) {
    return directive.name === 'skip';
  })) {
    directives.push(_directives.GraphQLSkipDirective);
  }

  if (!directives.some(function (directive) {
    return directive.name === 'include';
  })) {
    directives.push(_directives.GraphQLIncludeDirective);
  }

  if (!directives.some(function (directive) {
    return directive.name === 'deprecated';
  })) {
    directives.push(_directives.GraphQLDeprecatedDirective);
  } // Note: While this could make early assertions to get the correctly
  // typed values below, that would throw immediately while type system
  // validation with validateSchema() will produce more actionable results.


  return new _schema.GraphQLSchema({
    query: operationTypes.query ? definitionBuilder.buildType(operationTypes.query) : null,
    mutation: operationTypes.mutation ? definitionBuilder.buildType(operationTypes.mutation) : null,
    subscription: operationTypes.subscription ? definitionBuilder.buildType(operationTypes.subscription) : null,
    types: typeDefs.map(function (node) {
      return definitionBuilder.buildType(node);
    }),
    directives: directives,
    astNode: schemaDef,
    assumeValid: options && options.assumeValid,
    allowedLegacyNames: options && options.allowedLegacyNames
  });

  function getOperationTypes(schema) {
    var opTypes = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = schema.operationTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var operationType = _step.value;
        var _typeName = operationType.type.name.value;
        var operation = operationType.operation;

        if (opTypes[operation]) {
          throw new Error("Must provide only one ".concat(operation, " type in schema."));
        }

        if (!nodeMap[_typeName]) {
          throw new Error("Specified ".concat(operation, " type \"").concat(_typeName, "\" not found in document."));
        }

        opTypes[operation] = operationType.type;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return opTypes;
  }
}

var ASTDefinitionBuilder =
/*#__PURE__*/
function () {
  function ASTDefinitionBuilder(typeDefinitionsMap, options, resolveType) {
    _defineProperty(this, "_typeDefinitionsMap", void 0);

    _defineProperty(this, "_options", void 0);

    _defineProperty(this, "_resolveType", void 0);

    _defineProperty(this, "_cache", void 0);

    this._typeDefinitionsMap = typeDefinitionsMap;
    this._options = options;
    this._resolveType = resolveType; // Initialize to the GraphQL built in scalars and introspection types.

    this._cache = (0, _keyMap.default)(_scalars.specifiedScalarTypes.concat(_introspection.introspectionTypes), function (type) {
      return type.name;
    });
  }

  var _proto = ASTDefinitionBuilder.prototype;

  _proto.buildType = function buildType(node) {
    var typeName = node.name.value;

    if (!this._cache[typeName]) {
      if (node.kind === _kinds.Kind.NAMED_TYPE) {
        var defNode = this._typeDefinitionsMap[typeName];
        this._cache[typeName] = defNode ? this._makeSchemaDef(defNode) : this._resolveType(node);
      } else {
        this._cache[typeName] = this._makeSchemaDef(node);
      }
    }

    return this._cache[typeName];
  };

  _proto._buildWrappedType = function _buildWrappedType(typeNode) {
    if (typeNode.kind === _kinds.Kind.LIST_TYPE) {
      return (0, _definition.GraphQLList)(this._buildWrappedType(typeNode.type));
    }

    if (typeNode.kind === _kinds.Kind.NON_NULL_TYPE) {
      return (0, _definition.GraphQLNonNull)( // Note: GraphQLNonNull constructor validates this type
      this._buildWrappedType(typeNode.type));
    }

    return this.buildType(typeNode);
  };

  _proto.buildDirective = function buildDirective(directiveNode) {
    return new _directives.GraphQLDirective({
      name: directiveNode.name.value,
      description: getDescription(directiveNode, this._options),
      locations: directiveNode.locations.map(function (node) {
        return node.value;
      }),
      args: directiveNode.arguments && this._makeInputValues(directiveNode.arguments),
      astNode: directiveNode
    });
  };

  _proto.buildField = function buildField(field) {
    return {
      // Note: While this could make assertions to get the correctly typed
      // value, that would throw immediately while type system validation
      // with validateSchema() will produce more actionable results.
      type: this._buildWrappedType(field.type),
      description: getDescription(field, this._options),
      args: field.arguments && this._makeInputValues(field.arguments),
      deprecationReason: getDeprecationReason(field),
      astNode: field
    };
  };

  _proto.buildInputField = function buildInputField(value) {
    // Note: While this could make assertions to get the correctly typed
    // value, that would throw immediately while type system validation
    var type = this._buildWrappedType(value.type);

    return {
      name: value.name.value,
      type: type,
      description: getDescription(value, this._options),
      defaultValue: (0, _valueFromAST.valueFromAST)(value.defaultValue, type),
      astNode: value
    };
  };

  _proto.buildEnumValue = function buildEnumValue(value) {
    return {
      description: getDescription(value, this._options),
      deprecationReason: getDeprecationReason(value),
      astNode: value
    };
  };

  _proto._makeSchemaDef = function _makeSchemaDef(def) {
    switch (def.kind) {
      case _kinds.Kind.OBJECT_TYPE_DEFINITION:
        return this._makeTypeDef(def);

      case _kinds.Kind.INTERFACE_TYPE_DEFINITION:
        return this._makeInterfaceDef(def);

      case _kinds.Kind.ENUM_TYPE_DEFINITION:
        return this._makeEnumDef(def);

      case _kinds.Kind.UNION_TYPE_DEFINITION:
        return this._makeUnionDef(def);

      case _kinds.Kind.SCALAR_TYPE_DEFINITION:
        return this._makeScalarDef(def);

      case _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION:
        return this._makeInputObjectDef(def);

      default:
        throw new Error("Type kind \"".concat(def.kind, "\" not supported."));
    }
  };

  _proto._makeTypeDef = function _makeTypeDef(def) {
    var _this = this;

    var interfaces = def.interfaces;
    return new _definition.GraphQLObjectType({
      name: def.name.value,
      description: getDescription(def, this._options),
      fields: function fields() {
        return _this._makeFieldDefMap(def);
      },
      // Note: While this could make early assertions to get the correctly
      // typed values, that would throw immediately while type system
      // validation with validateSchema() will produce more actionable results.
      interfaces: interfaces ? function () {
        return interfaces.map(function (ref) {
          return _this.buildType(ref);
        });
      } : [],
      astNode: def
    });
  };

  _proto._makeFieldDefMap = function _makeFieldDefMap(def) {
    var _this2 = this;

    return def.fields ? (0, _keyValMap.default)(def.fields, function (field) {
      return field.name.value;
    }, function (field) {
      return _this2.buildField(field);
    }) : {};
  };

  _proto._makeInputValues = function _makeInputValues(values) {
    var _this3 = this;

    return (0, _keyValMap.default)(values, function (value) {
      return value.name.value;
    }, function (value) {
      return _this3.buildInputField(value);
    });
  };

  _proto._makeInterfaceDef = function _makeInterfaceDef(def) {
    var _this4 = this;

    return new _definition.GraphQLInterfaceType({
      name: def.name.value,
      description: getDescription(def, this._options),
      fields: function fields() {
        return _this4._makeFieldDefMap(def);
      },
      astNode: def
    });
  };

  _proto._makeEnumDef = function _makeEnumDef(def) {
    return new _definition.GraphQLEnumType({
      name: def.name.value,
      description: getDescription(def, this._options),
      values: this._makeValueDefMap(def),
      astNode: def
    });
  };

  _proto._makeValueDefMap = function _makeValueDefMap(def) {
    var _this5 = this;

    return def.values ? (0, _keyValMap.default)(def.values, function (enumValue) {
      return enumValue.name.value;
    }, function (enumValue) {
      return _this5.buildEnumValue(enumValue);
    }) : {};
  };

  _proto._makeUnionDef = function _makeUnionDef(def) {
    var _this6 = this;

    var types = def.types;
    return new _definition.GraphQLUnionType({
      name: def.name.value,
      description: getDescription(def, this._options),
      // Note: While this could make assertions to get the correctly typed
      // values below, that would throw immediately while type system
      // validation with validateSchema() will produce more actionable results.
      types: types ? function () {
        return types.map(function (ref) {
          return _this6.buildType(ref);
        });
      } : [],
      astNode: def
    });
  };

  _proto._makeScalarDef = function _makeScalarDef(def) {
    return new _definition.GraphQLScalarType({
      name: def.name.value,
      description: getDescription(def, this._options),
      astNode: def,
      serialize: function serialize(value) {
        return value;
      }
    });
  };

  _proto._makeInputObjectDef = function _makeInputObjectDef(def) {
    var _this7 = this;

    return new _definition.GraphQLInputObjectType({
      name: def.name.value,
      description: getDescription(def, this._options),
      fields: function fields() {
        return def.fields ? _this7._makeInputValues(def.fields) : {};
      },
      astNode: def
    });
  };

  return ASTDefinitionBuilder;
}();
/**
 * Given a field or enum value node, returns the string value for the
 * deprecation reason.
 */


exports.ASTDefinitionBuilder = ASTDefinitionBuilder;

function getDeprecationReason(node) {
  var deprecated = (0, _values.getDirectiveValues)(_directives.GraphQLDeprecatedDirective, node);
  return deprecated && deprecated.reason;
}
/**
 * Given an ast node, returns its string description.
 * @deprecated: provided to ease adoption and will be removed in v16.
 *
 * Accepts options as a second argument:
 *
 *    - commentDescriptions:
 *        Provide true to use preceding comments as the description.
 *
 */


function getDescription(node, options) {
  if (node.description) {
    return node.description.value;
  }

  if (options && options.commentDescriptions) {
    var rawValue = getLeadingCommentBlock(node);

    if (rawValue !== undefined) {
      return (0, _blockStringValue.default)('\n' + rawValue);
    }
  }
}

function getLeadingCommentBlock(node) {
  var loc = node.loc;

  if (!loc) {
    return;
  }

  var comments = [];
  var token = loc.startToken.prev;

  while (token && token.kind === _lexer.TokenKind.COMMENT && token.next && token.prev && token.line + 1 === token.next.line && token.line !== token.prev.line) {
    var value = String(token.value);
    comments.push(value);
    token = token.prev;
  }

  return comments.reverse().join('\n');
}
/**
 * A helper function to build a GraphQLSchema directly from a source
 * document.
 */


function buildSchema(source, options) {
  return buildASTSchema((0, _parser.parse)(source, options), options);
}

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getIntrospectionQuery = getIntrospectionQuery;
exports.introspectionQuery = void 0;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function getIntrospectionQuery(options) {
  var descriptions = !(options && options.descriptions === false);
  return "\n    query IntrospectionQuery {\n      __schema {\n        queryType { name }\n        mutationType { name }\n        subscriptionType { name }\n        types {\n          ...FullType\n        }\n        directives {\n          name\n          ".concat(descriptions ? 'description' : '', "\n          locations\n          args {\n            ...InputValue\n          }\n        }\n      }\n    }\n\n    fragment FullType on __Type {\n      kind\n      name\n      ").concat(descriptions ? 'description' : '', "\n      fields(includeDeprecated: true) {\n        name\n        ").concat(descriptions ? 'description' : '', "\n        args {\n          ...InputValue\n        }\n        type {\n          ...TypeRef\n        }\n        isDeprecated\n        deprecationReason\n      }\n      inputFields {\n        ...InputValue\n      }\n      interfaces {\n        ...TypeRef\n      }\n      enumValues(includeDeprecated: true) {\n        name\n        ").concat(descriptions ? 'description' : '', "\n        isDeprecated\n        deprecationReason\n      }\n      possibleTypes {\n        ...TypeRef\n      }\n    }\n\n    fragment InputValue on __InputValue {\n      name\n      ").concat(descriptions ? 'description' : '', "\n      type { ...TypeRef }\n      defaultValue\n    }\n\n    fragment TypeRef on __Type {\n      kind\n      name\n      ofType {\n        kind\n        name\n        ofType {\n          kind\n          name\n          ofType {\n            kind\n            name\n            ofType {\n              kind\n              name\n              ofType {\n                kind\n                name\n                ofType {\n                  kind\n                  name\n                  ofType {\n                    kind\n                    name\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  ");
}
/**
 * Deprecated, call getIntrospectionQuery directly.
 *
 * This function will be removed in v15
 */


var introspectionQuery = getIntrospectionQuery();
exports.introspectionQuery = introspectionQuery;

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.valueFromASTUntyped = valueFromASTUntyped;

var _keyValMap = _interopRequireDefault(__webpack_require__(343));

var _isInvalid = _interopRequireDefault(__webpack_require__(204));

var _kinds = __webpack_require__(68);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Produces a JavaScript value given a GraphQL Value AST.
 *
 * Unlike `valueFromAST()`, no type is provided. The resulting JavaScript value
 * will reflect the provided GraphQL value AST.
 *
 * | GraphQL Value        | JavaScript Value |
 * | -------------------- | ---------------- |
 * | Input Object         | Object           |
 * | List                 | Array            |
 * | Boolean              | Boolean          |
 * | String / Enum        | String           |
 * | Int / Float          | Number           |
 * | Null                 | null             |
 *
 */
function valueFromASTUntyped(valueNode, variables) {
  switch (valueNode.kind) {
    case _kinds.Kind.NULL:
      return null;

    case _kinds.Kind.INT:
      return parseInt(valueNode.value, 10);

    case _kinds.Kind.FLOAT:
      return parseFloat(valueNode.value);

    case _kinds.Kind.STRING:
    case _kinds.Kind.ENUM:
    case _kinds.Kind.BOOLEAN:
      return valueNode.value;

    case _kinds.Kind.LIST:
      return valueNode.values.map(function (node) {
        return valueFromASTUntyped(node, variables);
      });

    case _kinds.Kind.OBJECT:
      return (0, _keyValMap.default)(valueNode.fields, function (field) {
        return field.name.value;
      }, function (field) {
        return valueFromASTUntyped(field.value, variables);
      });

    case _kinds.Kind.VARIABLE:
      var variableName = valueNode.name.value;
      return variables && !(0, _isInvalid.default)(variables[variableName]) ? variables[variableName] : undefined;
  }
  /* istanbul ignore next */


  throw new Error('Unexpected value kind: ' + valueNode.kind);
}

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.undefinedFieldMessage = undefinedFieldMessage;
exports.FieldsOnCorrectType = FieldsOnCorrectType;

var _GraphQLError = __webpack_require__(37);

var _suggestionList = _interopRequireDefault(__webpack_require__(344));

var _quotedOrList = _interopRequireDefault(__webpack_require__(662));

var _definition = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function undefinedFieldMessage(fieldName, type, suggestedTypeNames, suggestedFieldNames) {
  var message = "Cannot query field \"".concat(fieldName, "\" on type \"").concat(type, "\".");

  if (suggestedTypeNames.length !== 0) {
    var suggestions = (0, _quotedOrList.default)(suggestedTypeNames);
    message += " Did you mean to use an inline fragment on ".concat(suggestions, "?");
  } else if (suggestedFieldNames.length !== 0) {
    message += " Did you mean ".concat((0, _quotedOrList.default)(suggestedFieldNames), "?");
  }

  return message;
}
/**
 * Fields on correct type
 *
 * A GraphQL document is only valid if all fields selected are defined by the
 * parent type, or are an allowed meta field such as __typename.
 */


function FieldsOnCorrectType(context) {
  return {
    Field: function Field(node) {
      var type = context.getParentType();

      if (type) {
        var fieldDef = context.getFieldDef();

        if (!fieldDef) {
          // This field doesn't exist, lets look for suggestions.
          var schema = context.getSchema();
          var fieldName = node.name.value; // First determine if there are any suggested types to condition on.

          var suggestedTypeNames = getSuggestedTypeNames(schema, type, fieldName); // If there are no suggested types, then perhaps this was a typo?

          var suggestedFieldNames = suggestedTypeNames.length !== 0 ? [] : getSuggestedFieldNames(schema, type, fieldName); // Report an error, including helpful suggestions.

          context.reportError(new _GraphQLError.GraphQLError(undefinedFieldMessage(fieldName, type.name, suggestedTypeNames, suggestedFieldNames), [node]));
        }
      }
    }
  };
}
/**
 * Go through all of the implementations of type, as well as the interfaces that
 * they implement. If any of those types include the provided field, suggest
 * them, sorted by how often the type is referenced, starting with Interfaces.
 */


function getSuggestedTypeNames(schema, type, fieldName) {
  if ((0, _definition.isAbstractType)(type)) {
    var suggestedObjectTypes = [];
    var interfaceUsageCount = Object.create(null);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = schema.getPossibleTypes(type)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var possibleType = _step.value;

        if (!possibleType.getFields()[fieldName]) {
          continue;
        } // This object type defines this field.


        suggestedObjectTypes.push(possibleType.name);
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = possibleType.getInterfaces()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var possibleInterface = _step2.value;

            if (!possibleInterface.getFields()[fieldName]) {
              continue;
            } // This interface type defines this field.


            interfaceUsageCount[possibleInterface.name] = (interfaceUsageCount[possibleInterface.name] || 0) + 1;
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      } // Suggest interface types based on how common they are.

    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    var suggestedInterfaceTypes = Object.keys(interfaceUsageCount).sort(function (a, b) {
      return interfaceUsageCount[b] - interfaceUsageCount[a];
    }); // Suggest both interface and object types.

    return suggestedInterfaceTypes.concat(suggestedObjectTypes);
  } // Otherwise, must be an Object type, which does not have possible fields.


  return [];
}
/**
 * For the field name provided, determine if there are any similar field names
 * that may be the result of a typo.
 */


function getSuggestedFieldNames(schema, type, fieldName) {
  if ((0, _definition.isObjectType)(type) || (0, _definition.isInterfaceType)(type)) {
    var possibleFieldNames = Object.keys(type.getFields());
    return (0, _suggestionList.default)(fieldName, possibleFieldNames);
  } // Otherwise, must be a Union type, which does not define fields.


  return [];
}

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inlineFragmentOnNonCompositeErrorMessage = inlineFragmentOnNonCompositeErrorMessage;
exports.fragmentOnNonCompositeErrorMessage = fragmentOnNonCompositeErrorMessage;
exports.FragmentsOnCompositeTypes = FragmentsOnCompositeTypes;

var _GraphQLError = __webpack_require__(37);

var _printer = __webpack_require__(165);

var _definition = __webpack_require__(54);

var _typeFromAST = __webpack_require__(185);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function inlineFragmentOnNonCompositeErrorMessage(type) {
  return "Fragment cannot condition on non composite type \"".concat(type, "\".");
}

function fragmentOnNonCompositeErrorMessage(fragName, type) {
  return "Fragment \"".concat(fragName, "\" cannot condition on non composite ") + "type \"".concat(type, "\".");
}
/**
 * Fragments on composite type
 *
 * Fragments use a type condition to determine if they apply, since fragments
 * can only be spread into a composite type (object, interface, or union), the
 * type condition must also be a composite type.
 */


function FragmentsOnCompositeTypes(context) {
  return {
    InlineFragment: function InlineFragment(node) {
      var typeCondition = node.typeCondition;

      if (typeCondition) {
        var type = (0, _typeFromAST.typeFromAST)(context.getSchema(), typeCondition);

        if (type && !(0, _definition.isCompositeType)(type)) {
          context.reportError(new _GraphQLError.GraphQLError(inlineFragmentOnNonCompositeErrorMessage((0, _printer.print)(typeCondition)), [typeCondition]));
        }
      }
    },
    FragmentDefinition: function FragmentDefinition(node) {
      var type = (0, _typeFromAST.typeFromAST)(context.getSchema(), node.typeCondition);

      if (type && !(0, _definition.isCompositeType)(type)) {
        context.reportError(new _GraphQLError.GraphQLError(fragmentOnNonCompositeErrorMessage(node.name.value, (0, _printer.print)(node.typeCondition)), [node.typeCondition]));
      }
    }
  };
}

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unknownArgMessage = unknownArgMessage;
exports.unknownDirectiveArgMessage = unknownDirectiveArgMessage;
exports.KnownArgumentNames = KnownArgumentNames;
exports.KnownArgumentNamesOnDirectives = KnownArgumentNamesOnDirectives;

var _GraphQLError = __webpack_require__(37);

var _suggestionList = _interopRequireDefault(__webpack_require__(344));

var _quotedOrList = _interopRequireDefault(__webpack_require__(662));

var _kinds = __webpack_require__(68);

var _directives = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function unknownArgMessage(argName, fieldName, typeName, suggestedArgs) {
  var message = "Unknown argument \"".concat(argName, "\" on field \"").concat(fieldName, "\" of ") + "type \"".concat(typeName, "\".");

  if (suggestedArgs.length) {
    message += " Did you mean ".concat((0, _quotedOrList.default)(suggestedArgs), "?");
  }

  return message;
}

function unknownDirectiveArgMessage(argName, directiveName, suggestedArgs) {
  var message = "Unknown argument \"".concat(argName, "\" on directive \"@").concat(directiveName, "\".");

  if (suggestedArgs.length) {
    message += " Did you mean ".concat((0, _quotedOrList.default)(suggestedArgs), "?");
  }

  return message;
}
/**
 * Known argument names
 *
 * A GraphQL field is only valid if all supplied arguments are defined by
 * that field.
 */


function KnownArgumentNames(context) {
  return _objectSpread({}, KnownArgumentNamesOnDirectives(context), {
    Argument: function Argument(argNode) {
      var argDef = context.getArgument();
      var fieldDef = context.getFieldDef();
      var parentType = context.getParentType();

      if (!argDef && fieldDef && parentType) {
        var argName = argNode.name.value;
        var knownArgsNames = fieldDef.args.map(function (arg) {
          return arg.name;
        });
        context.reportError(new _GraphQLError.GraphQLError(unknownArgMessage(argName, fieldDef.name, parentType.name, (0, _suggestionList.default)(argName, knownArgsNames)), argNode));
      }
    }
  });
} // @internal


function KnownArgumentNamesOnDirectives(context) {
  var directiveArgs = Object.create(null);
  var schema = context.getSchema();
  var definedDirectives = schema ? schema.getDirectives() : _directives.specifiedDirectives;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = definedDirectives[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var directive = _step.value;
      directiveArgs[directive.name] = directive.args.map(function (arg) {
        return arg.name;
      });
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var astDefinitions = context.getDocument().definitions;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = astDefinitions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var def = _step2.value;

      if (def.kind === _kinds.Kind.DIRECTIVE_DEFINITION) {
        directiveArgs[def.name.value] = def.arguments ? def.arguments.map(function (arg) {
          return arg.name.value;
        }) : [];
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return {
    Directive: function Directive(directiveNode) {
      var directiveName = directiveNode.name.value;
      var knownArgs = directiveArgs[directiveName];

      if (directiveNode.arguments && knownArgs) {
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = directiveNode.arguments[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var argNode = _step3.value;
            var argName = argNode.name.value;

            if (knownArgs.indexOf(argName) === -1) {
              var suggestions = (0, _suggestionList.default)(argName, knownArgs);
              context.reportError(new _GraphQLError.GraphQLError(unknownDirectiveArgMessage(argName, directiveName, suggestions), argNode));
            }
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }
      }

      return false;
    }
  };
}

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unknownDirectiveMessage = unknownDirectiveMessage;
exports.misplacedDirectiveMessage = misplacedDirectiveMessage;
exports.KnownDirectives = KnownDirectives;

var _GraphQLError = __webpack_require__(37);

var _kinds = __webpack_require__(68);

var _directiveLocation = __webpack_require__(345);

var _directives = __webpack_require__(136);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function unknownDirectiveMessage(directiveName) {
  return "Unknown directive \"".concat(directiveName, "\".");
}

function misplacedDirectiveMessage(directiveName, location) {
  return "Directive \"".concat(directiveName, "\" may not be used on ").concat(location, ".");
}
/**
 * Known directives
 *
 * A GraphQL document is only valid if all `@directives` are known by the
 * schema and legally positioned.
 */


function KnownDirectives(context) {
  var locationsMap = Object.create(null);
  var schema = context.getSchema();
  var definedDirectives = schema ? schema.getDirectives() : _directives.specifiedDirectives;
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = definedDirectives[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var directive = _step.value;
      locationsMap[directive.name] = directive.locations;
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  var astDefinitions = context.getDocument().definitions;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = astDefinitions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var def = _step2.value;

      if (def.kind === _kinds.Kind.DIRECTIVE_DEFINITION) {
        locationsMap[def.name.value] = def.locations.map(function (name) {
          return name.value;
        });
      }
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return {
    Directive: function Directive(node, key, parent, path, ancestors) {
      var name = node.name.value;
      var locations = locationsMap[name];

      if (!locations) {
        context.reportError(new _GraphQLError.GraphQLError(unknownDirectiveMessage(name), [node]));
        return;
      }

      var candidateLocation = getDirectiveLocationForASTPath(ancestors);

      if (candidateLocation && locations.indexOf(candidateLocation) === -1) {
        context.reportError(new _GraphQLError.GraphQLError(misplacedDirectiveMessage(name, candidateLocation), [node]));
      }
    }
  };
}

function getDirectiveLocationForASTPath(ancestors) {
  var appliedTo = ancestors[ancestors.length - 1];

  if (!Array.isArray(appliedTo)) {
    switch (appliedTo.kind) {
      case _kinds.Kind.OPERATION_DEFINITION:
        switch (appliedTo.operation) {
          case 'query':
            return _directiveLocation.DirectiveLocation.QUERY;

          case 'mutation':
            return _directiveLocation.DirectiveLocation.MUTATION;

          case 'subscription':
            return _directiveLocation.DirectiveLocation.SUBSCRIPTION;
        }

        break;

      case _kinds.Kind.FIELD:
        return _directiveLocation.DirectiveLocation.FIELD;

      case _kinds.Kind.FRAGMENT_SPREAD:
        return _directiveLocation.DirectiveLocation.FRAGMENT_SPREAD;

      case _kinds.Kind.INLINE_FRAGMENT:
        return _directiveLocation.DirectiveLocation.INLINE_FRAGMENT;

      case _kinds.Kind.FRAGMENT_DEFINITION:
        return _directiveLocation.DirectiveLocation.FRAGMENT_DEFINITION;

      case _kinds.Kind.VARIABLE_DEFINITION:
        return _directiveLocation.DirectiveLocation.VARIABLE_DEFINITION;

      case _kinds.Kind.SCHEMA_DEFINITION:
      case _kinds.Kind.SCHEMA_EXTENSION:
        return _directiveLocation.DirectiveLocation.SCHEMA;

      case _kinds.Kind.SCALAR_TYPE_DEFINITION:
      case _kinds.Kind.SCALAR_TYPE_EXTENSION:
        return _directiveLocation.DirectiveLocation.SCALAR;

      case _kinds.Kind.OBJECT_TYPE_DEFINITION:
      case _kinds.Kind.OBJECT_TYPE_EXTENSION:
        return _directiveLocation.DirectiveLocation.OBJECT;

      case _kinds.Kind.FIELD_DEFINITION:
        return _directiveLocation.DirectiveLocation.FIELD_DEFINITION;

      case _kinds.Kind.INTERFACE_TYPE_DEFINITION:
      case _kinds.Kind.INTERFACE_TYPE_EXTENSION:
        return _directiveLocation.DirectiveLocation.INTERFACE;

      case _kinds.Kind.UNION_TYPE_DEFINITION:
      case _kinds.Kind.UNION_TYPE_EXTENSION:
        return _directiveLocation.DirectiveLocation.UNION;

      case _kinds.Kind.ENUM_TYPE_DEFINITION:
      case _kinds.Kind.ENUM_TYPE_EXTENSION:
        return _directiveLocation.DirectiveLocation.ENUM;

      case _kinds.Kind.ENUM_VALUE_DEFINITION:
        return _directiveLocation.DirectiveLocation.ENUM_VALUE;

      case _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION:
      case _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION:
        return _directiveLocation.DirectiveLocation.INPUT_OBJECT;

      case _kinds.Kind.INPUT_VALUE_DEFINITION:
        var parentNode = ancestors[ancestors.length - 3];
        return parentNode.kind === _kinds.Kind.INPUT_OBJECT_TYPE_DEFINITION ? _directiveLocation.DirectiveLocation.INPUT_FIELD_DEFINITION : _directiveLocation.DirectiveLocation.ARGUMENT_DEFINITION;
    }
  }
}

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unknownFragmentMessage = unknownFragmentMessage;
exports.KnownFragmentNames = KnownFragmentNames;

var _GraphQLError = __webpack_require__(37);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function unknownFragmentMessage(fragName) {
  return "Unknown fragment \"".concat(fragName, "\".");
}
/**
 * Known fragment names
 *
 * A GraphQL document is only valid if all `...Fragment` fragment spreads refer
 * to fragments defined in the same document.
 */


function KnownFragmentNames(context) {
  return {
    FragmentSpread: function FragmentSpread(node) {
      var fragmentName = node.name.value;
      var fragment = context.getFragment(fragmentName);

      if (!fragment) {
        context.reportError(new _GraphQLError.GraphQLError(unknownFragmentMessage(fragmentName), [node.name]));
      }
    }
  };
}

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unknownTypeMessage = unknownTypeMessage;
exports.KnownTypeNames = KnownTypeNames;

var _GraphQLError = __webpack_require__(37);

var _suggestionList = _interopRequireDefault(__webpack_require__(344));

var _quotedOrList = _interopRequireDefault(__webpack_require__(662));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function unknownTypeMessage(typeName, suggestedTypes) {
  var message = "Unknown type \"".concat(typeName, "\".");

  if (suggestedTypes.length) {
    message += " Did you mean ".concat((0, _quotedOrList.default)(suggestedTypes), "?");
  }

  return message;
}
/**
 * Known type names
 *
 * A GraphQL document is only valid if referenced types (specifically
 * variable definitions and fragment conditions) are defined by the type schema.
 */


function KnownTypeNames(context) {
  return {
    // TODO: when validating IDL, re-enable these. Experimental version does not
    // add unreferenced types, resulting in false-positive errors. Squelched
    // errors for now.
    ObjectTypeDefinition: function ObjectTypeDefinition() {
      return false;
    },
    InterfaceTypeDefinition: function InterfaceTypeDefinition() {
      return false;
    },
    UnionTypeDefinition: function UnionTypeDefinition() {
      return false;
    },
    InputObjectTypeDefinition: function InputObjectTypeDefinition() {
      return false;
    },
    NamedType: function NamedType(node) {
      var schema = context.getSchema();
      var typeName = node.name.value;
      var type = schema.getType(typeName);

      if (!type) {
        context.reportError(new _GraphQLError.GraphQLError(unknownTypeMessage(typeName, (0, _suggestionList.default)(typeName, Object.keys(schema.getTypeMap()))), [node]));
      }
    }
  };
}

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.anonOperationNotAloneMessage = anonOperationNotAloneMessage;
exports.LoneAnonymousOperation = LoneAnonymousOperation;

var _GraphQLError = __webpack_require__(37);

var _kinds = __webpack_require__(68);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function anonOperationNotAloneMessage() {
  return 'This anonymous operation must be the only defined operation.';
}
/**
 * Lone anonymous operation
 *
 * A GraphQL document is only valid if when it contains an anonymous operation
 * (the query short-hand) that it contains only that one operation definition.
 */


function LoneAnonymousOperation(context) {
  var operationCount = 0;
  return {
    Document: function Document(node) {
      operationCount = node.definitions.filter(function (definition) {
        return definition.kind === _kinds.Kind.OPERATION_DEFINITION;
      }).length;
    },
    OperationDefinition: function OperationDefinition(node) {
      if (!node.name && operationCount > 1) {
        context.reportError(new _GraphQLError.GraphQLError(anonOperationNotAloneMessage(), [node]));
      }
    }
  };
}

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cycleErrorMessage = cycleErrorMessage;
exports.NoFragmentCycles = NoFragmentCycles;

var _GraphQLError = __webpack_require__(37);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function cycleErrorMessage(fragName, spreadNames) {
  var via = spreadNames.length ? ' via ' + spreadNames.join(', ') : '';
  return "Cannot spread fragment \"".concat(fragName, "\" within itself").concat(via, ".");
}

function NoFragmentCycles(context) {
  // Tracks already visited fragments to maintain O(N) and to ensure that cycles
  // are not redundantly reported.
  var visitedFrags = Object.create(null); // Array of AST nodes used to produce meaningful errors

  var spreadPath = []; // Position in the spread path

  var spreadPathIndexByName = Object.create(null);
  return {
    OperationDefinition: function OperationDefinition() {
      return false;
    },
    FragmentDefinition: function FragmentDefinition(node) {
      detectCycleRecursive(node);
      return false;
    }
  }; // This does a straight-forward DFS to find cycles.
  // It does not terminate when a cycle was found but continues to explore
  // the graph to find all possible cycles.

  function detectCycleRecursive(fragment) {
    if (visitedFrags[fragment.name.value]) {
      return;
    }

    var fragmentName = fragment.name.value;
    visitedFrags[fragmentName] = true;
    var spreadNodes = context.getFragmentSpreads(fragment.selectionSet);

    if (spreadNodes.length === 0) {
      return;
    }

    spreadPathIndexByName[fragmentName] = spreadPath.length;

    for (var i = 0; i < spreadNodes.length; i++) {
      var spreadNode = spreadNodes[i];
      var spreadName = spreadNode.name.value;
      var cycleIndex = spreadPathIndexByName[spreadName];
      spreadPath.push(spreadNode);

      if (cycleIndex === undefined) {
        var spreadFragment = context.getFragment(spreadName);

        if (spreadFragment) {
          detectCycleRecursive(spreadFragment);
        }
      } else {
        var cyclePath = spreadPath.slice(cycleIndex);
        var fragmentNames = cyclePath.slice(0, -1).map(function (s) {
          return s.name.value;
        });
        context.reportError(new _GraphQLError.GraphQLError(cycleErrorMessage(spreadName, fragmentNames), cyclePath));
      }

      spreadPath.pop();
    }

    spreadPathIndexByName[fragmentName] = undefined;
  }
}

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.undefinedVarMessage = undefinedVarMessage;
exports.NoUndefinedVariables = NoUndefinedVariables;

var _GraphQLError = __webpack_require__(37);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function undefinedVarMessage(varName, opName) {
  return opName ? "Variable \"$".concat(varName, "\" is not defined by operation \"").concat(opName, "\".") : "Variable \"$".concat(varName, "\" is not defined.");
}
/**
 * No undefined variables
 *
 * A GraphQL operation is only valid if all variables encountered, both directly
 * and via fragment spreads, are defined by that operation.
 */


function NoUndefinedVariables(context) {
  var variableNameDefined = Object.create(null);
  return {
    OperationDefinition: {
      enter: function enter() {
        variableNameDefined = Object.create(null);
      },
      leave: function leave(operation) {
        var usages = context.getRecursiveVariableUsages(operation);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = usages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref2 = _step.value;
            var node = _ref2.node;
            var varName = node.name.value;

            if (variableNameDefined[varName] !== true) {
              context.reportError(new _GraphQLError.GraphQLError(undefinedVarMessage(varName, operation.name && operation.name.value), [node, operation]));
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    },
    VariableDefinition: function VariableDefinition(node) {
      variableNameDefined[node.variable.name.value] = true;
    }
  };
}

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unusedFragMessage = unusedFragMessage;
exports.NoUnusedFragments = NoUnusedFragments;

var _GraphQLError = __webpack_require__(37);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function unusedFragMessage(fragName) {
  return "Fragment \"".concat(fragName, "\" is never used.");
}
/**
 * No unused fragments
 *
 * A GraphQL document is only valid if all fragment definitions are spread
 * within operations, or spread within other fragments spread within operations.
 */


function NoUnusedFragments(context) {
  var operationDefs = [];
  var fragmentDefs = [];
  return {
    OperationDefinition: function OperationDefinition(node) {
      operationDefs.push(node);
      return false;
    },
    FragmentDefinition: function FragmentDefinition(node) {
      fragmentDefs.push(node);
      return false;
    },
    Document: {
      leave: function leave() {
        var fragmentNameUsed = Object.create(null);

        for (var _i = 0; _i < operationDefs.length; _i++) {
          var operation = operationDefs[_i];
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = context.getRecursivelyReferencedFragments(operation)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var fragment = _step.value;
              fragmentNameUsed[fragment.name.value] = true;
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        }

        for (var _i2 = 0; _i2 < fragmentDefs.length; _i2++) {
          var fragmentDef = fragmentDefs[_i2];
          var fragName = fragmentDef.name.value;

          if (fragmentNameUsed[fragName] !== true) {
            context.reportError(new _GraphQLError.GraphQLError(unusedFragMessage(fragName), [fragmentDef]));
          }
        }
      }
    }
  };
}

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.unusedVariableMessage = unusedVariableMessage;
exports.NoUnusedVariables = NoUnusedVariables;

var _GraphQLError = __webpack_require__(37);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function unusedVariableMessage(varName, opName) {
  return opName ? "Variable \"$".concat(varName, "\" is never used in operation \"").concat(opName, "\".") : "Variable \"$".concat(varName, "\" is never used.");
}
/**
 * No unused variables
 *
 * A GraphQL operation is only valid if all variables defined by an operation
 * are used, either directly or within a spread fragment.
 */


function NoUnusedVariables(context) {
  var variableDefs = [];
  return {
    OperationDefinition: {
      enter: function enter() {
        variableDefs = [];
      },
      leave: function leave(operation) {
        var variableNameUsed = Object.create(null);
        var usages = context.getRecursiveVariableUsages(operation);
        var opName = operation.name ? operation.name.value : null;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = usages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref2 = _step.value;
            var node = _ref2.node;
            variableNameUsed[node.name.value] = true;
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        for (var _i = 0; _i < variableDefs.length; _i++) {
          var variableDef = variableDefs[_i];
          var variableName = variableDef.variable.name.value;

          if (variableNameUsed[variableName] !== true) {
            context.reportError(new _GraphQLError.GraphQLError(unusedVariableMessage(variableName, opName), [variableDef]));
          }
        }
      }
    },
    VariableDefinition: function VariableDefinition(def) {
      variableDefs.push(def);
    }
  };
}

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fieldsConflictMessage = fieldsConflictMessage;
exports.OverlappingFieldsCanBeMerged = OverlappingFieldsCanBeMerged;

var _GraphQLError = __webpack_require__(37);

var _inspect = _interopRequireDefault(__webpack_require__(93));

var _find = _interopRequireDefault(__webpack_require__(342));

var _kinds = __webpack_require__(68);

var _printer = __webpack_require__(165);

var _definition = __webpack_require__(54);

var _typeFromAST = __webpack_require__(185);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function fieldsConflictMessage(responseName, reason) {
  return "Fields \"".concat(responseName, "\" conflict because ").concat(reasonMessage(reason)) + '. Use different aliases on the fields to fetch both if this was ' + 'intentional.';
}

function reasonMessage(reason) {
  if (Array.isArray(reason)) {
    return reason.map(function (_ref) {
      var responseName = _ref[0],
          subreason = _ref[1];
      return "subfields \"".concat(responseName, "\" conflict because ").concat(reasonMessage(subreason));
    }).join(' and ');
  }

  return reason;
}
/**
 * Overlapping fields can be merged
 *
 * A selection set is only valid if all fields (including spreading any
 * fragments) either correspond to distinct response names or can be merged
 * without ambiguity.
 */


function OverlappingFieldsCanBeMerged(context) {
  // A memoization for when two fragments are compared "between" each other for
  // conflicts. Two fragments may be compared many times, so memoizing this can
  // dramatically improve the performance of this validator.
  var comparedFragmentPairs = new PairSet(); // A cache for the "field map" and list of fragment names found in any given
  // selection set. Selection sets may be asked for this information multiple
  // times, so this improves the performance of this validator.

  var cachedFieldsAndFragmentNames = new Map();
  return {
    SelectionSet: function SelectionSet(selectionSet) {
      var conflicts = findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, context.getParentType(), selectionSet);

      for (var _i = 0; _i < conflicts.length; _i++) {
        var _ref3 = conflicts[_i];
        var _ref2$ = _ref3[0];
        var responseName = _ref2$[0];
        var reason = _ref2$[1];
        var fields1 = _ref3[1];
        var fields2 = _ref3[2];
        context.reportError(new _GraphQLError.GraphQLError(fieldsConflictMessage(responseName, reason), fields1.concat(fields2)));
      }
    }
  };
}

/**
 * Algorithm:
 *
 * Conflicts occur when two fields exist in a query which will produce the same
 * response name, but represent differing values, thus creating a conflict.
 * The algorithm below finds all conflicts via making a series of comparisons
 * between fields. In order to compare as few fields as possible, this makes
 * a series of comparisons "within" sets of fields and "between" sets of fields.
 *
 * Given any selection set, a collection produces both a set of fields by
 * also including all inline fragments, as well as a list of fragments
 * referenced by fragment spreads.
 *
 * A) Each selection set represented in the document first compares "within" its
 * collected set of fields, finding any conflicts between every pair of
 * overlapping fields.
 * Note: This is the *only time* that a the fields "within" a set are compared
 * to each other. After this only fields "between" sets are compared.
 *
 * B) Also, if any fragment is referenced in a selection set, then a
 * comparison is made "between" the original set of fields and the
 * referenced fragment.
 *
 * C) Also, if multiple fragments are referenced, then comparisons
 * are made "between" each referenced fragment.
 *
 * D) When comparing "between" a set of fields and a referenced fragment, first
 * a comparison is made between each field in the original set of fields and
 * each field in the the referenced set of fields.
 *
 * E) Also, if any fragment is referenced in the referenced selection set,
 * then a comparison is made "between" the original set of fields and the
 * referenced fragment (recursively referring to step D).
 *
 * F) When comparing "between" two fragments, first a comparison is made between
 * each field in the first referenced set of fields and each field in the the
 * second referenced set of fields.
 *
 * G) Also, any fragments referenced by the first must be compared to the
 * second, and any fragments referenced by the second must be compared to the
 * first (recursively referring to step F).
 *
 * H) When comparing two fields, if both have selection sets, then a comparison
 * is made "between" both selection sets, first comparing the set of fields in
 * the first selection set with the set of fields in the second.
 *
 * I) Also, if any fragment is referenced in either selection set, then a
 * comparison is made "between" the other set of fields and the
 * referenced fragment.
 *
 * J) Also, if two fragments are referenced in both selection sets, then a
 * comparison is made "between" the two fragments.
 *
 */
// Find all conflicts found "within" a selection set, including those found
// via spreading in fragments. Called when visiting each SelectionSet in the
// GraphQL Document.
function findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentType, selectionSet) {
  var conflicts = [];

  var _getFieldsAndFragment = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet),
      fieldMap = _getFieldsAndFragment[0],
      fragmentNames = _getFieldsAndFragment[1]; // (A) Find find all conflicts "within" the fields of this selection set.
  // Note: this is the *only place* `collectConflictsWithin` is called.


  collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap);

  if (fragmentNames.length !== 0) {
    // (B) Then collect conflicts between these fields and those represented by
    // each spread fragment name found.
    var comparedFragments = Object.create(null);

    for (var i = 0; i < fragmentNames.length; i++) {
      collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, comparedFragmentPairs, false, fieldMap, fragmentNames[i]); // (C) Then compare this fragment with all other fragments found in this
      // selection set to collect conflicts between fragments spread together.
      // This compares each item in the list of fragment names to every other
      // item in that same list (except for itself).

      for (var j = i + 1; j < fragmentNames.length; j++) {
        collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fragmentNames[i], fragmentNames[j]);
      }
    }
  }

  return conflicts;
} // Collect all conflicts found between a set of fields and a fragment reference
// including via spreading in any nested fragments.


function collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentName) {
  // Memoize so a fragment is not compared for conflicts more than once.
  if (comparedFragments[fragmentName]) {
    return;
  }

  comparedFragments[fragmentName] = true;
  var fragment = context.getFragment(fragmentName);

  if (!fragment) {
    return;
  }

  var _getReferencedFieldsA = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment),
      fieldMap2 = _getReferencedFieldsA[0],
      fragmentNames2 = _getReferencedFieldsA[1]; // Do not compare a fragment's fieldMap to itself.


  if (fieldMap === fieldMap2) {
    return;
  } // (D) First collect any conflicts between the provided collection of fields
  // and the collection of fields represented by the given fragment.


  collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fieldMap2); // (E) Then collect any conflicts between the provided collection of fields
  // and any fragment names found in the given fragment.

  for (var i = 0; i < fragmentNames2.length; i++) {
    collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentNames2[i]);
  }
} // Collect all conflicts found between two fragments, including via spreading in
// any nested fragments.


function collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentName2) {
  // No need to compare a fragment to itself.
  if (fragmentName1 === fragmentName2) {
    return;
  } // Memoize so two fragments are not compared for conflicts more than once.


  if (comparedFragmentPairs.has(fragmentName1, fragmentName2, areMutuallyExclusive)) {
    return;
  }

  comparedFragmentPairs.add(fragmentName1, fragmentName2, areMutuallyExclusive);
  var fragment1 = context.getFragment(fragmentName1);
  var fragment2 = context.getFragment(fragmentName2);

  if (!fragment1 || !fragment2) {
    return;
  }

  var _getReferencedFieldsA2 = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment1),
      fieldMap1 = _getReferencedFieldsA2[0],
      fragmentNames1 = _getReferencedFieldsA2[1];

  var _getReferencedFieldsA3 = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment2),
      fieldMap2 = _getReferencedFieldsA3[0],
      fragmentNames2 = _getReferencedFieldsA3[1]; // (F) First, collect all conflicts between these two collections of fields
  // (not including any nested fragments).


  collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2); // (G) Then collect conflicts between the first fragment and any nested
  // fragments spread in the second fragment.

  for (var j = 0; j < fragmentNames2.length; j++) {
    collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentNames2[j]);
  } // (G) Then collect conflicts between the second fragment and any nested
  // fragments spread in the first fragment.


  for (var i = 0; i < fragmentNames1.length; i++) {
    collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[i], fragmentName2);
  }
} // Find all conflicts found between two selection sets, including those found
// via spreading in fragments. Called when determining if conflicts exist
// between the sub-fields of two overlapping fields.


function findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, parentType1, selectionSet1, parentType2, selectionSet2) {
  var conflicts = [];

  var _getFieldsAndFragment2 = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType1, selectionSet1),
      fieldMap1 = _getFieldsAndFragment2[0],
      fragmentNames1 = _getFieldsAndFragment2[1];

  var _getFieldsAndFragment3 = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType2, selectionSet2),
      fieldMap2 = _getFieldsAndFragment3[0],
      fragmentNames2 = _getFieldsAndFragment3[1]; // (H) First, collect all conflicts between these two collections of field.


  collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2); // (I) Then collect conflicts between the first collection of fields and
  // those referenced by each fragment name associated with the second.

  if (fragmentNames2.length !== 0) {
    var comparedFragments = Object.create(null);

    for (var j = 0; j < fragmentNames2.length; j++) {
      collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragments, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fragmentNames2[j]);
    }
  } // (I) Then collect conflicts between the second collection of fields and
  // those referenced by each fragment name associated with the first.


  if (fragmentNames1.length !== 0) {
    var _comparedFragments = Object.create(null);

    for (var i = 0; i < fragmentNames1.length; i++) {
      collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, _comparedFragments, comparedFragmentPairs, areMutuallyExclusive, fieldMap2, fragmentNames1[i]);
    }
  } // (J) Also collect conflicts between any fragment names by the first and
  // fragment names by the second. This compares each item in the first set of
  // names to each item in the second set of names.


  for (var _i2 = 0; _i2 < fragmentNames1.length; _i2++) {
    for (var _j = 0; _j < fragmentNames2.length; _j++) {
      collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[_i2], fragmentNames2[_j]);
    }
  }

  return conflicts;
} // Collect all Conflicts "within" one collection of fields.


function collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap) {
  // A field map is a keyed collection, where each key represents a response
  // name and the value at that key is a list of all fields which provide that
  // response name. For every response name, if there are multiple fields, they
  // must be compared to find a potential conflict.
  var _arr = Object.keys(fieldMap);

  for (var _i3 = 0; _i3 < _arr.length; _i3++) {
    var responseName = _arr[_i3];
    var fields = fieldMap[responseName]; // This compares every field in the list to every other field in this list
    // (except to itself). If the list only has one item, nothing needs to
    // be compared.

    if (fields.length > 1) {
      for (var i = 0; i < fields.length; i++) {
        for (var j = i + 1; j < fields.length; j++) {
          var conflict = findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, // within one collection is never mutually exclusive
          responseName, fields[i], fields[j]);

          if (conflict) {
            conflicts.push(conflict);
          }
        }
      }
    }
  }
} // Collect all Conflicts between two collections of fields. This is similar to,
// but different from the `collectConflictsWithin` function above. This check
// assumes that `collectConflictsWithin` has already been called on each
// provided collection of fields. This is true because this validator traverses
// each individual selection set.


function collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, fieldMap1, fieldMap2) {
  // A field map is a keyed collection, where each key represents a response
  // name and the value at that key is a list of all fields which provide that
  // response name. For any response name which appears in both provided field
  // maps, each field from the first field map must be compared to every field
  // in the second field map to find potential conflicts.
  var _arr2 = Object.keys(fieldMap1);

  for (var _i4 = 0; _i4 < _arr2.length; _i4++) {
    var responseName = _arr2[_i4];
    var fields2 = fieldMap2[responseName];

    if (fields2) {
      var fields1 = fieldMap1[responseName];

      for (var i = 0; i < fields1.length; i++) {
        for (var j = 0; j < fields2.length; j++) {
          var conflict = findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, fields1[i], fields2[j]);

          if (conflict) {
            conflicts.push(conflict);
          }
        }
      }
    }
  }
} // Determines if there is a conflict between two particular fields, including
// comparing their sub-fields.


function findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, field1, field2) {
  var parentType1 = field1[0],
      node1 = field1[1],
      def1 = field1[2];
  var parentType2 = field2[0],
      node2 = field2[1],
      def2 = field2[2]; // If it is known that two fields could not possibly apply at the same
  // time, due to the parent types, then it is safe to permit them to diverge
  // in aliased field or arguments used as they will not present any ambiguity
  // by differing.
  // It is known that two parent types could never overlap if they are
  // different Object types. Interface or Union types might overlap - if not
  // in the current state of the schema, then perhaps in some future version,
  // thus may not safely diverge.

  var areMutuallyExclusive = parentFieldsAreMutuallyExclusive || parentType1 !== parentType2 && (0, _definition.isObjectType)(parentType1) && (0, _definition.isObjectType)(parentType2); // The return type for each field.

  var type1 = def1 && def1.type;
  var type2 = def2 && def2.type;

  if (!areMutuallyExclusive) {
    // Two aliases must refer to the same field.
    var name1 = node1.name.value;
    var name2 = node2.name.value;

    if (name1 !== name2) {
      return [[responseName, "".concat(name1, " and ").concat(name2, " are different fields")], [node1], [node2]];
    } // Two field calls must have the same arguments.


    if (!sameArguments(node1.arguments || [], node2.arguments || [])) {
      return [[responseName, 'they have differing arguments'], [node1], [node2]];
    }
  }

  if (type1 && type2 && doTypesConflict(type1, type2)) {
    return [[responseName, "they return conflicting types ".concat((0, _inspect.default)(type1), " and ").concat((0, _inspect.default)(type2))], [node1], [node2]];
  } // Collect and compare sub-fields. Use the same "visited fragment names" list
  // for both collections so fields in a fragment reference are never
  // compared to themselves.


  var selectionSet1 = node1.selectionSet;
  var selectionSet2 = node2.selectionSet;

  if (selectionSet1 && selectionSet2) {
    var conflicts = findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, (0, _definition.getNamedType)(type1), selectionSet1, (0, _definition.getNamedType)(type2), selectionSet2);
    return subfieldConflicts(conflicts, responseName, node1, node2);
  }
}

function sameArguments(arguments1, arguments2) {
  if (arguments1.length !== arguments2.length) {
    return false;
  }

  return arguments1.every(function (argument1) {
    var argument2 = (0, _find.default)(arguments2, function (argument) {
      return argument.name.value === argument1.name.value;
    });

    if (!argument2) {
      return false;
    }

    return sameValue(argument1.value, argument2.value);
  });
}

function sameValue(value1, value2) {
  return !value1 && !value2 || (0, _printer.print)(value1) === (0, _printer.print)(value2);
} // Two types conflict if both types could not apply to a value simultaneously.
// Composite types are ignored as their individual field types will be compared
// later recursively. However List and Non-Null types must match.


function doTypesConflict(type1, type2) {
  if ((0, _definition.isListType)(type1)) {
    return (0, _definition.isListType)(type2) ? doTypesConflict(type1.ofType, type2.ofType) : true;
  }

  if ((0, _definition.isListType)(type2)) {
    return true;
  }

  if ((0, _definition.isNonNullType)(type1)) {
    return (0, _definition.isNonNullType)(type2) ? doTypesConflict(type1.ofType, type2.ofType) : true;
  }

  if ((0, _definition.isNonNullType)(type2)) {
    return true;
  }

  if ((0, _definition.isLeafType)(type1) || (0, _definition.isLeafType)(type2)) {
    return type1 !== type2;
  }

  return false;
} // Given a selection set, return the collection of fields (a mapping of response
// name to field nodes and definitions) as well as a list of fragment names
// referenced via fragment spreads.


function getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet) {
  var cached = cachedFieldsAndFragmentNames.get(selectionSet);

  if (!cached) {
    var nodeAndDefs = Object.create(null);
    var fragmentNames = Object.create(null);

    _collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames);

    cached = [nodeAndDefs, Object.keys(fragmentNames)];
    cachedFieldsAndFragmentNames.set(selectionSet, cached);
  }

  return cached;
} // Given a reference to a fragment, return the represented collection of fields
// as well as a list of nested fragment names referenced via fragment spreads.


function getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment) {
  // Short-circuit building a type from the node if possible.
  var cached = cachedFieldsAndFragmentNames.get(fragment.selectionSet);

  if (cached) {
    return cached;
  }

  var fragmentType = (0, _typeFromAST.typeFromAST)(context.getSchema(), fragment.typeCondition);
  return getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragmentType, fragment.selectionSet);
}

function _collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames) {
  for (var i = 0; i < selectionSet.selections.length; i++) {
    var selection = selectionSet.selections[i];

    switch (selection.kind) {
      case _kinds.Kind.FIELD:
        var fieldName = selection.name.value;
        var fieldDef = void 0;

        if ((0, _definition.isObjectType)(parentType) || (0, _definition.isInterfaceType)(parentType)) {
          fieldDef = parentType.getFields()[fieldName];
        }

        var responseName = selection.alias ? selection.alias.value : fieldName;

        if (!nodeAndDefs[responseName]) {
          nodeAndDefs[responseName] = [];
        }

        nodeAndDefs[responseName].push([parentType, selection, fieldDef]);
        break;

      case _kinds.Kind.FRAGMENT_SPREAD:
        fragmentNames[selection.name.value] = true;
        break;

      case _kinds.Kind.INLINE_FRAGMENT:
        var typeCondition = selection.typeCondition;
        var inlineFragmentType = typeCondition ? (0, _typeFromAST.typeFromAST)(context.getSchema(), typeCondition) : parentType;

        _collectFieldsAndFragmentNames(context, inlineFragmentType, selection.selectionSet, nodeAndDefs, fragmentNames);

        break;
    }
  }
} // Given a series of Conflicts which occurred between two sub-fields, generate
// a single Conflict.


function subfieldConflicts(conflicts, responseName, node1, node2) {
  if (conflicts.length > 0) {
    return [[responseName, conflicts.map(function (_ref4) {
      var reason = _ref4[0];
      return reason;
    })], conflicts.reduce(function (allFields, _ref5) {
      var fields1 = _ref5[1];
      return allFields.concat(fields1);
    }, [node1]), conflicts.reduce(function (allFields, _ref6) {
      var fields2 = _ref6[2];
      return allFields.concat(fields2);
    }, [node2])];
  }
}
/**
 * A way to keep track of pairs of things when the ordering of the pair does
 * not matter. We do this by maintaining a sort of double adjacency sets.
 */


var PairSet =
/*#__PURE__*/
function () {
  function PairSet() {
    _defineProperty(this, "_data", void 0);

    this._data = Object.create(null);
  }

  var _proto = PairSet.prototype;

  _proto.has = function has(a, b, areMutuallyExclusive) {
    var first = this._data[a];
    var result = first && first[b];

    if (result === undefined) {
      return false;
    } // areMutuallyExclusive being false is a superset of being true,
    // hence if we want to know if this PairSet "has" these two with no
    // exclusivity, we have to ensure it was added as such.


    if (areMutuallyExclusive === false) {
      return result === false;
    }

    return true;
  };

  _proto.add = function add(a, b, areMutuallyExclusive) {
    _pairSetAdd(this._data, a, b, areMutuallyExclusive);

    _pairSetAdd(this._data, b, a, areMutuallyExclusive);
  };

  return PairSet;
}();

function _pairSetAdd(data, a, b, areMutuallyExclusive) {
  var map = data[a];

  if (!map) {
    map = Object.create(null);
    data[a] = map;
  }

  map[b] = areMutuallyExclusive;
}

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeIncompatibleSpreadMessage = typeIncompatibleSpreadMessage;
exports.typeIncompatibleAnonSpreadMessage = typeIncompatibleAnonSpreadMessage;
exports.PossibleFragmentSpreads = PossibleFragmentSpreads;

var _inspect = _interopRequireDefault(__webpack_require__(93));

var _GraphQLError = __webpack_require__(37);

var _typeComparators = __webpack_require__(441);

var _typeFromAST = __webpack_require__(185);

var _definition = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function typeIncompatibleSpreadMessage(fragName, parentType, fragType) {
  return "Fragment \"".concat(fragName, "\" cannot be spread here as objects of ") + "type \"".concat(parentType, "\" can never be of type \"").concat(fragType, "\".");
}

function typeIncompatibleAnonSpreadMessage(parentType, fragType) {
  return 'Fragment cannot be spread here as objects of ' + "type \"".concat(parentType, "\" can never be of type \"").concat(fragType, "\".");
}
/**
 * Possible fragment spread
 *
 * A fragment spread is only valid if the type condition could ever possibly
 * be true: if there is a non-empty intersection of the possible parent types,
 * and possible types which pass the type condition.
 */


function PossibleFragmentSpreads(context) {
  return {
    InlineFragment: function InlineFragment(node) {
      var fragType = context.getType();
      var parentType = context.getParentType();

      if ((0, _definition.isCompositeType)(fragType) && (0, _definition.isCompositeType)(parentType) && !(0, _typeComparators.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
        context.reportError(new _GraphQLError.GraphQLError(typeIncompatibleAnonSpreadMessage((0, _inspect.default)(parentType), (0, _inspect.default)(fragType)), [node]));
      }
    },
    FragmentSpread: function FragmentSpread(node) {
      var fragName = node.name.value;
      var fragType = getFragmentType(context, fragName);
      var parentType = context.getParentType();

      if (fragType && parentType && !(0, _typeComparators.doTypesOverlap)(context.getSchema(), fragType, parentType)) {
        context.reportError(new _GraphQLError.GraphQLError(typeIncompatibleSpreadMessage(fragName, (0, _inspect.default)(parentType), (0, _inspect.default)(fragType)), [node]));
      }
    }
  };
}

function getFragmentType(context, name) {
  var frag = context.getFragment(name);

  if (frag) {
    var type = (0, _typeFromAST.typeFromAST)(context.getSchema(), frag.typeCondition);

    if ((0, _definition.isCompositeType)(type)) {
      return type;
    }
  }
}

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.missingFieldArgMessage = missingFieldArgMessage;
exports.missingDirectiveArgMessage = missingDirectiveArgMessage;
exports.ProvidedRequiredArguments = ProvidedRequiredArguments;
exports.ProvidedRequiredArgumentsOnDirectives = ProvidedRequiredArgumentsOnDirectives;

var _GraphQLError = __webpack_require__(37);

var _kinds = __webpack_require__(68);

var _inspect = _interopRequireDefault(__webpack_require__(93));

var _keyMap = _interopRequireDefault(__webpack_require__(183));

var _definition = __webpack_require__(54);

var _printer = __webpack_require__(165);

var _directives = __webpack_require__(136);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function missingFieldArgMessage(fieldName, argName, type) {
  return "Field \"".concat(fieldName, "\" argument \"").concat(argName, "\" of type ") + "\"".concat(type, "\" is required but not provided.");
}

function missingDirectiveArgMessage(directiveName, argName, type) {
  return "Directive \"@".concat(directiveName, "\" argument \"").concat(argName, "\" of type ") + "\"".concat(type, "\" is required but not provided.");
}
/**
 * Provided required arguments
 *
 * A field or directive is only valid if all required (non-null without a
 * default value) field arguments have been provided.
 */


function ProvidedRequiredArguments(context) {
  return _objectSpread({}, ProvidedRequiredArgumentsOnDirectives(context), {
    Field: {
      // Validate on leave to allow for deeper errors to appear first.
      leave: function leave(fieldNode) {
        var fieldDef = context.getFieldDef();

        if (!fieldDef) {
          return false;
        }

        var argNodes = fieldNode.arguments || [];
        var argNodeMap = (0, _keyMap.default)(argNodes, function (arg) {
          return arg.name.value;
        });
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = fieldDef.args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var argDef = _step.value;
            var argNode = argNodeMap[argDef.name];

            if (!argNode && (0, _definition.isRequiredArgument)(argDef)) {
              context.reportError(new _GraphQLError.GraphQLError(missingFieldArgMessage(fieldDef.name, argDef.name, (0, _inspect.default)(argDef.type)), [fieldNode]));
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  });
} // @internal


function ProvidedRequiredArgumentsOnDirectives(context) {
  var requiredArgsMap = Object.create(null);
  var schema = context.getSchema();
  var definedDirectives = schema ? schema.getDirectives() : _directives.specifiedDirectives;
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = definedDirectives[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var directive = _step2.value;
      requiredArgsMap[directive.name] = (0, _keyMap.default)(directive.args.filter(_definition.isRequiredArgument), function (arg) {
        return arg.name;
      });
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  var astDefinitions = context.getDocument().definitions;
  var _iteratorNormalCompletion3 = true;
  var _didIteratorError3 = false;
  var _iteratorError3 = undefined;

  try {
    for (var _iterator3 = astDefinitions[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
      var def = _step3.value;

      if (def.kind === _kinds.Kind.DIRECTIVE_DEFINITION) {
        requiredArgsMap[def.name.value] = (0, _keyMap.default)(def.arguments ? def.arguments.filter(isRequiredArgumentNode) : [], function (arg) {
          return arg.name.value;
        });
      }
    }
  } catch (err) {
    _didIteratorError3 = true;
    _iteratorError3 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
        _iterator3.return();
      }
    } finally {
      if (_didIteratorError3) {
        throw _iteratorError3;
      }
    }
  }

  return {
    Directive: {
      // Validate on leave to allow for deeper errors to appear first.
      leave: function leave(directiveNode) {
        var directiveName = directiveNode.name.value;
        var requiredArgs = requiredArgsMap[directiveName];

        if (requiredArgs) {
          var argNodes = directiveNode.arguments || [];
          var argNodeMap = (0, _keyMap.default)(argNodes, function (arg) {
            return arg.name.value;
          });

          var _arr = Object.keys(requiredArgs);

          for (var _i = 0; _i < _arr.length; _i++) {
            var argName = _arr[_i];

            if (!argNodeMap[argName]) {
              var argType = requiredArgs[argName].type;
              context.reportError(new _GraphQLError.GraphQLError(missingDirectiveArgMessage(directiveName, argName, (0, _definition.isType)(argType) ? (0, _inspect.default)(argType) : (0, _printer.print)(argType)), directiveNode));
            }
          }
        }
      }
    }
  };
}

function isRequiredArgumentNode(arg) {
  return arg.type.kind === _kinds.Kind.NON_NULL_TYPE && arg.defaultValue == null;
}

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.noSubselectionAllowedMessage = noSubselectionAllowedMessage;
exports.requiredSubselectionMessage = requiredSubselectionMessage;
exports.ScalarLeafs = ScalarLeafs;

var _inspect = _interopRequireDefault(__webpack_require__(93));

var _GraphQLError = __webpack_require__(37);

var _definition = __webpack_require__(54);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function noSubselectionAllowedMessage(fieldName, type) {
  return "Field \"".concat(fieldName, "\" must not have a selection since ") + "type \"".concat(type, "\" has no subfields.");
}

function requiredSubselectionMessage(fieldName, type) {
  return "Field \"".concat(fieldName, "\" of type \"").concat(type, "\" must have a ") + "selection of subfields. Did you mean \"".concat(fieldName, " { ... }\"?");
}
/**
 * Scalar leafs
 *
 * A GraphQL document is valid only if all leaf fields (fields without
 * sub selections) are of scalar or enum types.
 */


function ScalarLeafs(context) {
  return {
    Field: function Field(node) {
      var type = context.getType();
      var selectionSet = node.selectionSet;

      if (type) {
        if ((0, _definition.isLeafType)((0, _definition.getNamedType)(type))) {
          if (selectionSet) {
            context.reportError(new _GraphQLError.GraphQLError(noSubselectionAllowedMessage(node.name.value, (0, _inspect.default)(type)), [selectionSet]));
          }
        } else if (!selectionSet) {
          context.reportError(new _GraphQLError.GraphQLError(requiredSubselectionMessage(node.name.value, (0, _inspect.default)(type)), [node]));
        }
      }
    }
  };
}

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.singleFieldOnlyMessage = singleFieldOnlyMessage;
exports.SingleFieldSubscriptions = SingleFieldSubscriptions;

var _GraphQLError = __webpack_require__(37);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function singleFieldOnlyMessage(name) {
  return (name ? "Subscription \"".concat(name, "\" ") : 'Anonymous Subscription ') + 'must select only one top level field.';
}
/**
 * Subscriptions must only include one field.
 *
 * A GraphQL subscription is valid only if it contains a single root field.
 */


function SingleFieldSubscriptions(context) {
  return {
    OperationDefinition: function OperationDefinition(node) {
      if (node.operation === 'subscription') {
        if (node.selectionSet.selections.length !== 1) {
          context.reportError(new _GraphQLError.GraphQLError(singleFieldOnlyMessage(node.name && node.name.value), node.selectionSet.selections.slice(1)));
        }
      }
    }
  };
}

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duplicateArgMessage = duplicateArgMessage;
exports.UniqueArgumentNames = UniqueArgumentNames;

var _GraphQLError = __webpack_require__(37);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function duplicateArgMessage(argName) {
  return "There can be only one argument named \"".concat(argName, "\".");
}
/**
 * Unique argument names
 *
 * A GraphQL field or directive is only valid if all supplied arguments are
 * uniquely named.
 */


function UniqueArgumentNames(context) {
  var knownArgNames = Object.create(null);
  return {
    Field: function Field() {
      knownArgNames = Object.create(null);
    },
    Directive: function Directive() {
      knownArgNames = Object.create(null);
    },
    Argument: function Argument(node) {
      var argName = node.name.value;

      if (knownArgNames[argName]) {
        context.reportError(new _GraphQLError.GraphQLError(duplicateArgMessage(argName), [knownArgNames[argName], node.name]));
      } else {
        knownArgNames[argName] = node.name;
      }

      return false;
    }
  };
}

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duplicateDirectiveMessage = duplicateDirectiveMessage;
exports.UniqueDirectivesPerLocation = UniqueDirectivesPerLocation;

var _GraphQLError = __webpack_require__(37);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function duplicateDirectiveMessage(directiveName) {
  return "The directive \"".concat(directiveName, "\" can only be used once at ") + 'this location.';
}
/**
 * Unique directive names per location
 *
 * A GraphQL document is only valid if all directives at a given location
 * are uniquely named.
 */


function UniqueDirectivesPerLocation(context) {
  return {
    // Many different AST nodes may contain directives. Rather than listing
    // them all, just listen for entering any node, and check to see if it
    // defines any directives.
    enter: function enter(node) {
      // Flow can't refine that node.directives will only contain directives,
      var directives = node.directives;

      if (directives) {
        var knownDirectives = Object.create(null);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = directives[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var directive = _step.value;
            var directiveName = directive.name.value;

            if (knownDirectives[directiveName]) {
              context.reportError(new _GraphQLError.GraphQLError(duplicateDirectiveMessage(directiveName), [knownDirectives[directiveName], directive]));
            } else {
              knownDirectives[directiveName] = directive;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  };
}

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duplicateFragmentNameMessage = duplicateFragmentNameMessage;
exports.UniqueFragmentNames = UniqueFragmentNames;

var _GraphQLError = __webpack_require__(37);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function duplicateFragmentNameMessage(fragName) {
  return "There can be only one fragment named \"".concat(fragName, "\".");
}
/**
 * Unique fragment names
 *
 * A GraphQL document is only valid if all defined fragments have unique names.
 */


function UniqueFragmentNames(context) {
  var knownFragmentNames = Object.create(null);
  return {
    OperationDefinition: function OperationDefinition() {
      return false;
    },
    FragmentDefinition: function FragmentDefinition(node) {
      var fragmentName = node.name.value;

      if (knownFragmentNames[fragmentName]) {
        context.reportError(new _GraphQLError.GraphQLError(duplicateFragmentNameMessage(fragmentName), [knownFragmentNames[fragmentName], node.name]));
      } else {
        knownFragmentNames[fragmentName] = node.name;
      }

      return false;
    }
  };
}

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duplicateInputFieldMessage = duplicateInputFieldMessage;
exports.UniqueInputFieldNames = UniqueInputFieldNames;

var _GraphQLError = __webpack_require__(37);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function duplicateInputFieldMessage(fieldName) {
  return "There can be only one input field named \"".concat(fieldName, "\".");
}
/**
 * Unique input field names
 *
 * A GraphQL input object value is only valid if all supplied fields are
 * uniquely named.
 */


function UniqueInputFieldNames(context) {
  var knownNameStack = [];
  var knownNames = Object.create(null);
  return {
    ObjectValue: {
      enter: function enter() {
        knownNameStack.push(knownNames);
        knownNames = Object.create(null);
      },
      leave: function leave() {
        knownNames = knownNameStack.pop();
      }
    },
    ObjectField: function ObjectField(node) {
      var fieldName = node.name.value;

      if (knownNames[fieldName]) {
        context.reportError(new _GraphQLError.GraphQLError(duplicateInputFieldMessage(fieldName), [knownNames[fieldName], node.name]));
      } else {
        knownNames[fieldName] = node.name;
      }

      return false;
    }
  };
}

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duplicateOperationNameMessage = duplicateOperationNameMessage;
exports.UniqueOperationNames = UniqueOperationNames;

var _GraphQLError = __webpack_require__(37);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function duplicateOperationNameMessage(operationName) {
  return "There can be only one operation named \"".concat(operationName, "\".");
}
/**
 * Unique operation names
 *
 * A GraphQL document is only valid if all defined operations have unique names.
 */


function UniqueOperationNames(context) {
  var knownOperationNames = Object.create(null);
  return {
    OperationDefinition: function OperationDefinition(node) {
      var operationName = node.name;

      if (operationName) {
        if (knownOperationNames[operationName.value]) {
          context.reportError(new _GraphQLError.GraphQLError(duplicateOperationNameMessage(operationName.value), [knownOperationNames[operationName.value], operationName]));
        } else {
          knownOperationNames[operationName.value] = operationName;
        }
      }

      return false;
    },
    FragmentDefinition: function FragmentDefinition() {
      return false;
    }
  };
}

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.duplicateVariableMessage = duplicateVariableMessage;
exports.UniqueVariableNames = UniqueVariableNames;

var _GraphQLError = __webpack_require__(37);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function duplicateVariableMessage(variableName) {
  return "There can be only one variable named \"".concat(variableName, "\".");
}
/**
 * Unique variable names
 *
 * A GraphQL operation is only valid if all its variables are uniquely named.
 */


function UniqueVariableNames(context) {
  var knownVariableNames = Object.create(null);
  return {
    OperationDefinition: function OperationDefinition() {
      knownVariableNames = Object.create(null);
    },
    VariableDefinition: function VariableDefinition(node) {
      var variableName = node.variable.name.value;

      if (knownVariableNames[variableName]) {
        context.reportError(new _GraphQLError.GraphQLError(duplicateVariableMessage(variableName), [knownVariableNames[variableName], node.variable.name]));
      } else {
        knownVariableNames[variableName] = node.variable.name;
      }
    }
  };
}

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nonInputTypeOnVarMessage = nonInputTypeOnVarMessage;
exports.VariablesAreInputTypes = VariablesAreInputTypes;

var _GraphQLError = __webpack_require__(37);

var _printer = __webpack_require__(165);

var _definition = __webpack_require__(54);

var _typeFromAST = __webpack_require__(185);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function nonInputTypeOnVarMessage(variableName, typeName) {
  return "Variable \"$".concat(variableName, "\" cannot be non-input type \"").concat(typeName, "\".");
}
/**
 * Variables are input types
 *
 * A GraphQL operation is only valid if all the variables it defines are of
 * input types (scalar, enum, or input object).
 */


function VariablesAreInputTypes(context) {
  return {
    VariableDefinition: function VariableDefinition(node) {
      var type = (0, _typeFromAST.typeFromAST)(context.getSchema(), node.type); // If the variable type is not an input type, return an error.

      if (type && !(0, _definition.isInputType)(type)) {
        var variableName = node.variable.name.value;
        context.reportError(new _GraphQLError.GraphQLError(nonInputTypeOnVarMessage(variableName, (0, _printer.print)(node.type)), [node.type]));
      }
    }
  };
}

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.badVarPosMessage = badVarPosMessage;
exports.VariablesInAllowedPosition = VariablesInAllowedPosition;

var _inspect = _interopRequireDefault(__webpack_require__(93));

var _GraphQLError = __webpack_require__(37);

var _kinds = __webpack_require__(68);

var _definition = __webpack_require__(54);

var _typeComparators = __webpack_require__(441);

var _typeFromAST = __webpack_require__(185);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function badVarPosMessage(varName, varType, expectedType) {
  return "Variable \"$".concat(varName, "\" of type \"").concat(varType, "\" used in ") + "position expecting type \"".concat(expectedType, "\".");
}
/**
 * Variables passed to field arguments conform to type
 */


function VariablesInAllowedPosition(context) {
  var varDefMap = Object.create(null);
  return {
    OperationDefinition: {
      enter: function enter() {
        varDefMap = Object.create(null);
      },
      leave: function leave(operation) {
        var usages = context.getRecursiveVariableUsages(operation);
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = usages[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _ref2 = _step.value;
            var node = _ref2.node,
                type = _ref2.type,
                defaultValue = _ref2.defaultValue;
            var varName = node.name.value;
            var varDef = varDefMap[varName];

            if (varDef && type) {
              // A var type is allowed if it is the same or more strict (e.g. is
              // a subtype of) than the expected type. It can be more strict if
              // the variable type is non-null when the expected type is nullable.
              // If both are list types, the variable item type can be more strict
              // than the expected item type (contravariant).
              var schema = context.getSchema();
              var varType = (0, _typeFromAST.typeFromAST)(schema, varDef.type);

              if (varType && !allowedVariableUsage(schema, varType, varDef.defaultValue, type, defaultValue)) {
                context.reportError(new _GraphQLError.GraphQLError(badVarPosMessage(varName, (0, _inspect.default)(varType), (0, _inspect.default)(type)), [varDef, node]));
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    },
    VariableDefinition: function VariableDefinition(node) {
      varDefMap[node.variable.name.value] = node;
    }
  };
}
/**
 * Returns true if the variable is allowed in the location it was found,
 * which includes considering if default values exist for either the variable
 * or the location at which it is located.
 */


function allowedVariableUsage(schema, varType, varDefaultValue, locationType, locationDefaultValue) {
  if ((0, _definition.isNonNullType)(locationType) && !(0, _definition.isNonNullType)(varType)) {
    var hasNonNullVariableDefaultValue = varDefaultValue && varDefaultValue.kind !== _kinds.Kind.NULL;
    var hasLocationDefaultValue = locationDefaultValue !== undefined;

    if (!hasNonNullVariableDefaultValue && !hasLocationDefaultValue) {
      return false;
    }

    var nullableLocationType = locationType.ofType;
    return (0, _typeComparators.isTypeSubTypeOf)(schema, varType, nullableLocationType);
  }

  return (0, _typeComparators.isTypeSubTypeOf)(schema, varType, locationType);
}

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.specifiedSDLRules = exports.specifiedRules = void 0;

var _ExecutableDefinitions = __webpack_require__(2997);

var _UniqueOperationNames = __webpack_require__(1233);

var _LoneAnonymousOperation = __webpack_require__(1219);

var _SingleFieldSubscriptions = __webpack_require__(1228);

var _KnownTypeNames = __webpack_require__(1218);

var _FragmentsOnCompositeTypes = __webpack_require__(1214);

var _VariablesAreInputTypes = __webpack_require__(1235);

var _ScalarLeafs = __webpack_require__(1227);

var _FieldsOnCorrectType = __webpack_require__(1213);

var _UniqueFragmentNames = __webpack_require__(1231);

var _KnownFragmentNames = __webpack_require__(1217);

var _NoUnusedFragments = __webpack_require__(1222);

var _PossibleFragmentSpreads = __webpack_require__(1225);

var _NoFragmentCycles = __webpack_require__(1220);

var _UniqueVariableNames = __webpack_require__(1234);

var _NoUndefinedVariables = __webpack_require__(1221);

var _NoUnusedVariables = __webpack_require__(1223);

var _KnownDirectives = __webpack_require__(1216);

var _UniqueDirectivesPerLocation = __webpack_require__(1230);

var _KnownArgumentNames = __webpack_require__(1215);

var _UniqueArgumentNames = __webpack_require__(1229);

var _ValuesOfCorrectType = __webpack_require__(669);

var _ProvidedRequiredArguments = __webpack_require__(1226);

var _VariablesInAllowedPosition = __webpack_require__(1236);

var _OverlappingFieldsCanBeMerged = __webpack_require__(1224);

var _UniqueInputFieldNames = __webpack_require__(1232);

var _LoneSchemaDefinition = __webpack_require__(2998);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
// Spec Section: "Executable Definitions"
// Spec Section: "Operation Name Uniqueness"
// Spec Section: "Lone Anonymous Operation"
// Spec Section: "Subscriptions with Single Root Field"
// Spec Section: "Fragment Spread Type Existence"
// Spec Section: "Fragments on Composite Types"
// Spec Section: "Variables are Input Types"
// Spec Section: "Leaf Field Selections"
// Spec Section: "Field Selections on Objects, Interfaces, and Unions Types"
// Spec Section: "Fragment Name Uniqueness"
// Spec Section: "Fragment spread target defined"
// Spec Section: "Fragments must be used"
// Spec Section: "Fragment spread is possible"
// Spec Section: "Fragments must not form cycles"
// Spec Section: "Variable Uniqueness"
// Spec Section: "All Variable Used Defined"
// Spec Section: "All Variables Used"
// Spec Section: "Directives Are Defined"
// Spec Section: "Directives Are Unique Per Location"
// Spec Section: "Argument Names"
// Spec Section: "Argument Uniqueness"
// Spec Section: "Value Type Correctness"
// Spec Section: "Argument Optionality"
// Spec Section: "All Variable Usages Are Allowed"
// Spec Section: "Field Selection Merging"
// Spec Section: "Input Object Field Uniqueness"

/**
 * This set includes all validation rules defined by the GraphQL spec.
 *
 * The order of the rules in this list has been adjusted to lead to the
 * most clear output when encountering multiple validation errors.
 */
var specifiedRules = [_ExecutableDefinitions.ExecutableDefinitions, _UniqueOperationNames.UniqueOperationNames, _LoneAnonymousOperation.LoneAnonymousOperation, _SingleFieldSubscriptions.SingleFieldSubscriptions, _KnownTypeNames.KnownTypeNames, _FragmentsOnCompositeTypes.FragmentsOnCompositeTypes, _VariablesAreInputTypes.VariablesAreInputTypes, _ScalarLeafs.ScalarLeafs, _FieldsOnCorrectType.FieldsOnCorrectType, _UniqueFragmentNames.UniqueFragmentNames, _KnownFragmentNames.KnownFragmentNames, _NoUnusedFragments.NoUnusedFragments, _PossibleFragmentSpreads.PossibleFragmentSpreads, _NoFragmentCycles.NoFragmentCycles, _UniqueVariableNames.UniqueVariableNames, _NoUndefinedVariables.NoUndefinedVariables, _NoUnusedVariables.NoUnusedVariables, _KnownDirectives.KnownDirectives, _UniqueDirectivesPerLocation.UniqueDirectivesPerLocation, _KnownArgumentNames.KnownArgumentNames, _UniqueArgumentNames.UniqueArgumentNames, _ValuesOfCorrectType.ValuesOfCorrectType, _ProvidedRequiredArguments.ProvidedRequiredArguments, _VariablesInAllowedPosition.VariablesInAllowedPosition, _OverlappingFieldsCanBeMerged.OverlappingFieldsCanBeMerged, _UniqueInputFieldNames.UniqueInputFieldNames];
exports.specifiedRules = specifiedRules;
// @internal
var specifiedSDLRules = [_LoneSchemaDefinition.LoneSchemaDefinition, _KnownDirectives.KnownDirectives, _UniqueDirectivesPerLocation.UniqueDirectivesPerLocation, _KnownArgumentNames.KnownArgumentNamesOnDirectives, _UniqueArgumentNames.UniqueArgumentNames, _UniqueInputFieldNames.UniqueInputFieldNames, _ProvidedRequiredArguments.ProvidedRequiredArgumentsOnDirectives];
exports.specifiedSDLRules = specifiedSDLRules;

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Buffer = __webpack_require__(42).Buffer
var Transform = __webpack_require__(759).Transform
var inherits = __webpack_require__(41)

function throwIfNotStringOrBuffer (val, prefix) {
  if (!Buffer.isBuffer(val) && typeof val !== 'string') {
    throw new TypeError(prefix + ' must be a string or a buffer')
  }
}

function HashBase (blockSize) {
  Transform.call(this)

  this._block = Buffer.allocUnsafe(blockSize)
  this._blockSize = blockSize
  this._blockOffset = 0
  this._length = [0, 0, 0, 0]

  this._finalized = false
}

inherits(HashBase, Transform)

HashBase.prototype._transform = function (chunk, encoding, callback) {
  var error = null
  try {
    this.update(chunk, encoding)
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype._flush = function (callback) {
  var error = null
  try {
    this.push(this.digest())
  } catch (err) {
    error = err
  }

  callback(error)
}

HashBase.prototype.update = function (data, encoding) {
  throwIfNotStringOrBuffer(data, 'Data')
  if (this._finalized) throw new Error('Digest already called')
  if (!Buffer.isBuffer(data)) data = Buffer.from(data, encoding)

  // consume data
  var block = this._block
  var offset = 0
  while (this._blockOffset + data.length - offset >= this._blockSize) {
    for (var i = this._blockOffset; i < this._blockSize;) block[i++] = data[offset++]
    this._update()
    this._blockOffset = 0
  }
  while (offset < data.length) block[this._blockOffset++] = data[offset++]

  // update length
  for (var j = 0, carry = data.length * 8; carry > 0; ++j) {
    this._length[j] += carry
    carry = (this._length[j] / 0x0100000000) | 0
    if (carry > 0) this._length[j] -= 0x0100000000 * carry
  }

  return this
}

HashBase.prototype._update = function () {
  throw new Error('_update is not implemented')
}

HashBase.prototype.digest = function (encoding) {
  if (this._finalized) throw new Error('Digest already called')
  this._finalized = true

  var digest = this._digest()
  if (encoding !== undefined) digest = digest.toString(encoding)

  // reset state
  this._block.fill(0)
  this._blockOffset = 0
  for (var i = 0; i < 4; ++i) this._length[i] = 0

  return digest
}

HashBase.prototype._digest = function () {
  throw new Error('_digest is not implemented')
}

module.exports = HashBase


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(167);
var common = __webpack_require__(347);
var shaCommon = __webpack_require__(1241);
var assert = __webpack_require__(137);

var sum32 = utils.sum32;
var sum32_4 = utils.sum32_4;
var sum32_5 = utils.sum32_5;
var ch32 = shaCommon.ch32;
var maj32 = shaCommon.maj32;
var s0_256 = shaCommon.s0_256;
var s1_256 = shaCommon.s1_256;
var g0_256 = shaCommon.g0_256;
var g1_256 = shaCommon.g1_256;

var BlockHash = common.BlockHash;

var sha256_K = [
  0x428a2f98, 0x71374491, 0xb5c0fbcf, 0xe9b5dba5,
  0x3956c25b, 0x59f111f1, 0x923f82a4, 0xab1c5ed5,
  0xd807aa98, 0x12835b01, 0x243185be, 0x550c7dc3,
  0x72be5d74, 0x80deb1fe, 0x9bdc06a7, 0xc19bf174,
  0xe49b69c1, 0xefbe4786, 0x0fc19dc6, 0x240ca1cc,
  0x2de92c6f, 0x4a7484aa, 0x5cb0a9dc, 0x76f988da,
  0x983e5152, 0xa831c66d, 0xb00327c8, 0xbf597fc7,
  0xc6e00bf3, 0xd5a79147, 0x06ca6351, 0x14292967,
  0x27b70a85, 0x2e1b2138, 0x4d2c6dfc, 0x53380d13,
  0x650a7354, 0x766a0abb, 0x81c2c92e, 0x92722c85,
  0xa2bfe8a1, 0xa81a664b, 0xc24b8b70, 0xc76c51a3,
  0xd192e819, 0xd6990624, 0xf40e3585, 0x106aa070,
  0x19a4c116, 0x1e376c08, 0x2748774c, 0x34b0bcb5,
  0x391c0cb3, 0x4ed8aa4a, 0x5b9cca4f, 0x682e6ff3,
  0x748f82ee, 0x78a5636f, 0x84c87814, 0x8cc70208,
  0x90befffa, 0xa4506ceb, 0xbef9a3f7, 0xc67178f2
];

function SHA256() {
  if (!(this instanceof SHA256))
    return new SHA256();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xbb67ae85, 0x3c6ef372, 0xa54ff53a,
    0x510e527f, 0x9b05688c, 0x1f83d9ab, 0x5be0cd19
  ];
  this.k = sha256_K;
  this.W = new Array(64);
}
utils.inherits(SHA256, BlockHash);
module.exports = SHA256;

SHA256.blockSize = 512;
SHA256.outSize = 256;
SHA256.hmacStrength = 192;
SHA256.padLength = 64;

SHA256.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i++)
    W[i] = sum32_4(g1_256(W[i - 2]), W[i - 7], g0_256(W[i - 15]), W[i - 16]);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];
  var f = this.h[5];
  var g = this.h[6];
  var h = this.h[7];

  assert(this.k.length === W.length);
  for (i = 0; i < W.length; i++) {
    var T1 = sum32_5(h, s1_256(e), ch32(e, f, g), this.k[i], W[i]);
    var T2 = sum32(s0_256(a), maj32(a, b, c));
    h = g;
    g = f;
    f = e;
    e = sum32(d, T1);
    d = c;
    c = b;
    b = a;
    a = sum32(T1, T2);
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
  this.h[5] = sum32(this.h[5], f);
  this.h[6] = sum32(this.h[6], g);
  this.h[7] = sum32(this.h[7], h);
};

SHA256.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(167);
var common = __webpack_require__(347);
var assert = __webpack_require__(137);

var rotr64_hi = utils.rotr64_hi;
var rotr64_lo = utils.rotr64_lo;
var shr64_hi = utils.shr64_hi;
var shr64_lo = utils.shr64_lo;
var sum64 = utils.sum64;
var sum64_hi = utils.sum64_hi;
var sum64_lo = utils.sum64_lo;
var sum64_4_hi = utils.sum64_4_hi;
var sum64_4_lo = utils.sum64_4_lo;
var sum64_5_hi = utils.sum64_5_hi;
var sum64_5_lo = utils.sum64_5_lo;

var BlockHash = common.BlockHash;

var sha512_K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
];

function SHA512() {
  if (!(this instanceof SHA512))
    return new SHA512();

  BlockHash.call(this);
  this.h = [
    0x6a09e667, 0xf3bcc908,
    0xbb67ae85, 0x84caa73b,
    0x3c6ef372, 0xfe94f82b,
    0xa54ff53a, 0x5f1d36f1,
    0x510e527f, 0xade682d1,
    0x9b05688c, 0x2b3e6c1f,
    0x1f83d9ab, 0xfb41bd6b,
    0x5be0cd19, 0x137e2179 ];
  this.k = sha512_K;
  this.W = new Array(160);
}
utils.inherits(SHA512, BlockHash);
module.exports = SHA512;

SHA512.blockSize = 1024;
SHA512.outSize = 512;
SHA512.hmacStrength = 192;
SHA512.padLength = 128;

SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
  var W = this.W;

  // 32 x 32bit words
  for (var i = 0; i < 32; i++)
    W[i] = msg[start + i];
  for (; i < W.length; i += 2) {
    var c0_hi = g1_512_hi(W[i - 4], W[i - 3]);  // i - 2
    var c0_lo = g1_512_lo(W[i - 4], W[i - 3]);
    var c1_hi = W[i - 14];  // i - 7
    var c1_lo = W[i - 13];
    var c2_hi = g0_512_hi(W[i - 30], W[i - 29]);  // i - 15
    var c2_lo = g0_512_lo(W[i - 30], W[i - 29]);
    var c3_hi = W[i - 32];  // i - 16
    var c3_lo = W[i - 31];

    W[i] = sum64_4_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
    W[i + 1] = sum64_4_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo);
  }
};

SHA512.prototype._update = function _update(msg, start) {
  this._prepareBlock(msg, start);

  var W = this.W;

  var ah = this.h[0];
  var al = this.h[1];
  var bh = this.h[2];
  var bl = this.h[3];
  var ch = this.h[4];
  var cl = this.h[5];
  var dh = this.h[6];
  var dl = this.h[7];
  var eh = this.h[8];
  var el = this.h[9];
  var fh = this.h[10];
  var fl = this.h[11];
  var gh = this.h[12];
  var gl = this.h[13];
  var hh = this.h[14];
  var hl = this.h[15];

  assert(this.k.length === W.length);
  for (var i = 0; i < W.length; i += 2) {
    var c0_hi = hh;
    var c0_lo = hl;
    var c1_hi = s1_512_hi(eh, el);
    var c1_lo = s1_512_lo(eh, el);
    var c2_hi = ch64_hi(eh, el, fh, fl, gh, gl);
    var c2_lo = ch64_lo(eh, el, fh, fl, gh, gl);
    var c3_hi = this.k[i];
    var c3_lo = this.k[i + 1];
    var c4_hi = W[i];
    var c4_lo = W[i + 1];

    var T1_hi = sum64_5_hi(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);
    var T1_lo = sum64_5_lo(
      c0_hi, c0_lo,
      c1_hi, c1_lo,
      c2_hi, c2_lo,
      c3_hi, c3_lo,
      c4_hi, c4_lo);

    c0_hi = s0_512_hi(ah, al);
    c0_lo = s0_512_lo(ah, al);
    c1_hi = maj64_hi(ah, al, bh, bl, ch, cl);
    c1_lo = maj64_lo(ah, al, bh, bl, ch, cl);

    var T2_hi = sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
    var T2_lo = sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);

    hh = gh;
    hl = gl;

    gh = fh;
    gl = fl;

    fh = eh;
    fl = el;

    eh = sum64_hi(dh, dl, T1_hi, T1_lo);
    el = sum64_lo(dl, dl, T1_hi, T1_lo);

    dh = ch;
    dl = cl;

    ch = bh;
    cl = bl;

    bh = ah;
    bl = al;

    ah = sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
    al = sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
  }

  sum64(this.h, 0, ah, al);
  sum64(this.h, 2, bh, bl);
  sum64(this.h, 4, ch, cl);
  sum64(this.h, 6, dh, dl);
  sum64(this.h, 8, eh, el);
  sum64(this.h, 10, fh, fl);
  sum64(this.h, 12, gh, gl);
  sum64(this.h, 14, hh, hl);
};

SHA512.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};

function ch64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ ((~xh) & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function ch64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ ((~xl) & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_hi(xh, xl, yh, yl, zh) {
  var r = (xh & yh) ^ (xh & zh) ^ (yh & zh);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function maj64_lo(xh, xl, yh, yl, zh, zl) {
  var r = (xl & yl) ^ (xl & zl) ^ (yl & zl);
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 28);
  var c1_hi = rotr64_hi(xl, xh, 2);  // 34
  var c2_hi = rotr64_hi(xl, xh, 7);  // 39

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 28);
  var c1_lo = rotr64_lo(xl, xh, 2);  // 34
  var c2_lo = rotr64_lo(xl, xh, 7);  // 39

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 14);
  var c1_hi = rotr64_hi(xh, xl, 18);
  var c2_hi = rotr64_hi(xl, xh, 9);  // 41

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function s1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 14);
  var c1_lo = rotr64_lo(xh, xl, 18);
  var c2_lo = rotr64_lo(xl, xh, 9);  // 41

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 1);
  var c1_hi = rotr64_hi(xh, xl, 8);
  var c2_hi = shr64_hi(xh, xl, 7);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g0_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 1);
  var c1_lo = rotr64_lo(xh, xl, 8);
  var c2_lo = shr64_lo(xh, xl, 7);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_hi(xh, xl) {
  var c0_hi = rotr64_hi(xh, xl, 19);
  var c1_hi = rotr64_hi(xl, xh, 29);  // 61
  var c2_hi = shr64_hi(xh, xl, 6);

  var r = c0_hi ^ c1_hi ^ c2_hi;
  if (r < 0)
    r += 0x100000000;
  return r;
}

function g1_512_lo(xh, xl) {
  var c0_lo = rotr64_lo(xh, xl, 19);
  var c1_lo = rotr64_lo(xl, xh, 29);  // 61
  var c2_lo = shr64_lo(xh, xl, 6);

  var r = c0_lo ^ c1_lo ^ c2_lo;
  if (r < 0)
    r += 0x100000000;
  return r;
}


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(167);
var rotr32 = utils.rotr32;

function ft_1(s, x, y, z) {
  if (s === 0)
    return ch32(x, y, z);
  if (s === 1 || s === 3)
    return p32(x, y, z);
  if (s === 2)
    return maj32(x, y, z);
}
exports.ft_1 = ft_1;

function ch32(x, y, z) {
  return (x & y) ^ ((~x) & z);
}
exports.ch32 = ch32;

function maj32(x, y, z) {
  return (x & y) ^ (x & z) ^ (y & z);
}
exports.maj32 = maj32;

function p32(x, y, z) {
  return x ^ y ^ z;
}
exports.p32 = p32;

function s0_256(x) {
  return rotr32(x, 2) ^ rotr32(x, 13) ^ rotr32(x, 22);
}
exports.s0_256 = s0_256;

function s1_256(x) {
  return rotr32(x, 6) ^ rotr32(x, 11) ^ rotr32(x, 25);
}
exports.s1_256 = s1_256;

function g0_256(x) {
  return rotr32(x, 7) ^ rotr32(x, 18) ^ (x >>> 3);
}
exports.g0_256 = g0_256;

function g1_256(x) {
  return rotr32(x, 17) ^ rotr32(x, 19) ^ (x >>> 10);
}
exports.g1_256 = g1_256;


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.readState = exports.saveState = undefined;

var _warning = __webpack_require__(212);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var QuotaExceededErrors = {
  QuotaExceededError: true,
  QUOTA_EXCEEDED_ERR: true
};

var SecurityErrors = {
  SecurityError: true
};

var KeyPrefix = '@@History/';

var createKey = function createKey(key) {
  return KeyPrefix + key;
};

var saveState = exports.saveState = function saveState(key, state) {
  if (!window.sessionStorage) {
    // Session storage is not available or hidden.
    // sessionStorage is undefined in Internet Explorer when served via file protocol.
     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;

    return;
  }

  try {
    if (state == null) {
      window.sessionStorage.removeItem(createKey(key));
    } else {
      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
    }
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;

      return;
    }

    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
      // Safari "private mode" throws QuotaExceededError.
       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;

      return;
    }

    throw error;
  }
};

var readState = exports.readState = function readState(key) {
  var json = void 0;
  try {
    json = window.sessionStorage.getItem(createKey(key));
  } catch (error) {
    if (SecurityErrors[error.name]) {
      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
      // attempt to access window.sessionStorage.
       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;

      return undefined;
    }
  }

  if (json) {
    try {
      return JSON.parse(json);
    } catch (error) {
      // Ignore invalid JSON.
    }
  }

  return undefined;
};

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _runTransitionHook = __webpack_require__(674);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _PathUtils = __webpack_require__(206);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var useBasename = function useBasename(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var basename = options.basename;


    var addBasename = function addBasename(location) {
      if (!location) return location;

      if (basename && location.basename == null) {
        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
          location.pathname = location.pathname.substring(basename.length);
          location.basename = basename;

          if (location.pathname === '') location.pathname = '/';
        } else {
          location.basename = '';
        }
      }

      return location;
    };

    var prependBasename = function prependBasename(location) {
      if (!basename) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var pname = object.pathname;
      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
      var pathname = normalizedBasename + normalizedPathname;

      return _extends({}, object, {
        pathname: pathname
      });
    };

    // Override all read methods with basename-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return addBasename(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(addBasename(location));
      });
    };

    // Override all write methods with basename-aware versions.
    var push = function push(location) {
      return history.push(prependBasename(location));
    };

    var replace = function replace(location) {
      return history.replace(prependBasename(location));
    };

    var createPath = function createPath(location) {
      return history.createPath(prependBasename(location));
    };

    var createHref = function createHref(location) {
      return history.createHref(prependBasename(location));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useBasename;

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _queryString = __webpack_require__(684);

var _runTransitionHook = __webpack_require__(674);

var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);

var _LocationUtils = __webpack_require__(284);

var _PathUtils = __webpack_require__(206);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStringifyQuery = function defaultStringifyQuery(query) {
  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
};

var defaultParseQueryString = _queryString.parse;

/**
 * Returns a new createHistory function that may be used to create
 * history objects that know how to handle URL queries.
 */
var useQueries = function useQueries(createHistory) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var history = createHistory(options);
    var stringifyQuery = options.stringifyQuery,
        parseQueryString = options.parseQueryString;


    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;

    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;

    var decodeQuery = function decodeQuery(location) {
      if (!location) return location;

      if (location.query == null) location.query = parseQueryString(location.search.substring(1));

      return location;
    };

    var encodeQuery = function encodeQuery(location, query) {
      if (query == null) return location;

      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
      var queryString = stringifyQuery(query);
      var search = queryString ? '?' + queryString : '';

      return _extends({}, object, {
        search: search
      });
    };

    // Override all read methods with query-aware versions.
    var getCurrentLocation = function getCurrentLocation() {
      return decodeQuery(history.getCurrentLocation());
    };

    var listenBefore = function listenBefore(hook) {
      return history.listenBefore(function (location, callback) {
        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
      });
    };

    var listen = function listen(listener) {
      return history.listen(function (location) {
        return listener(decodeQuery(location));
      });
    };

    // Override all write methods with query-aware versions.
    var push = function push(location) {
      return history.push(encodeQuery(location, location.query));
    };

    var replace = function replace(location) {
      return history.replace(encodeQuery(location, location.query));
    };

    var createPath = function createPath(location) {
      return history.createPath(encodeQuery(location, location.query));
    };

    var createHref = function createHref(location) {
      return history.createHref(encodeQuery(location, location.query));
    };

    var createLocation = function createLocation(location) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));

      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);

      return decodeQuery(newLocation);
    };

    return _extends({}, history, {
      getCurrentLocation: getCurrentLocation,
      listenBefore: listenBefore,
      listen: listen,
      push: push,
      replace: replace,
      createPath: createPath,
      createHref: createHref,
      createLocation: createLocation
    });
  };
};

exports.default = useQueries;

/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaults;
/* harmony export (immutable) */ __webpack_exports__["c"] = hasXMLHttpRequest;
/* harmony export (immutable) */ __webpack_exports__["b"] = makePromise;
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}
function hasXMLHttpRequest() {
  return typeof XMLHttpRequest === 'function' || (typeof XMLHttpRequest === "undefined" ? "undefined" : _typeof(XMLHttpRequest)) === 'object';
}
function isPromise(maybePromise) {
  return !!maybePromise && typeof maybePromise.then === 'function';
}
function makePromise(maybePromise) {
  if (isPromise(maybePromise)) {
    return maybePromise;
  }
  return Promise.resolve(maybePromise);
}

/***/ }),
/* 1246 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};


/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(3029);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(3023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(3025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(3030);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(3077),
    mapCacheDelete = __webpack_require__(3078),
    mapCacheGet = __webpack_require__(3079),
    mapCacheHas = __webpack_require__(3080),
    mapCacheSet = __webpack_require__(3081);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(3036),
    arraySome = __webpack_require__(3043),
    cacheHas = __webpack_require__(3053);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 1252 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 1253 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 1254 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(186),
    stubFalse = __webpack_require__(3100);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(299)(module)))

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(350),
    isObject = __webpack_require__(1258);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 1257 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 1258 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(3049),
    baseUnary = __webpack_require__(3052),
    nodeUtil = __webpack_require__(3084);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["default"] = mergeClassNames;
function mergeClassNames() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args.reduce(function (classList, arg) {
    return typeof arg === 'string' || arg instanceof Array ? classList.concat(arg) : classList;
  }, []).filter(Boolean).join(' ');
}

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

var bn = __webpack_require__(77);
var brorand = __webpack_require__(599);

function MillerRabin(rand) {
  this.rand = rand || new brorand.Rand();
}
module.exports = MillerRabin;

MillerRabin.create = function create(rand) {
  return new MillerRabin(rand);
};

MillerRabin.prototype._randbelow = function _randbelow(n) {
  var len = n.bitLength();
  var min_bytes = Math.ceil(len / 8);

  // Generage random bytes until a number less than n is found.
  // This ensures that 0..n-1 have an equal probability of being selected.
  do
    var a = new bn(this.rand.generate(min_bytes));
  while (a.cmp(n) >= 0);

  return a;
};

MillerRabin.prototype._randrange = function _randrange(start, stop) {
  // Generate a random number greater than or equal to start and less than stop.
  var size = stop.sub(start);
  return start.add(this._randbelow(size));
};

MillerRabin.prototype.test = function test(n, k, cb) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  var prime = true;
  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);
    if (cb)
      cb(a);

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return false;
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s)
      return false;
  }

  return prime;
};

MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
  var len = n.bitLength();
  var red = bn.mont(n);
  var rone = new bn(1).toRed(red);

  if (!k)
    k = Math.max(1, (len / 48) | 0);

  // Find d and s, (n - 1) = (2 ^ s) * d;
  var n1 = n.subn(1);
  for (var s = 0; !n1.testn(s); s++) {}
  var d = n.shrn(s);

  var rn1 = n1.toRed(red);

  for (; k > 0; k--) {
    var a = this._randrange(new bn(2), n1);

    var g = n.gcd(a);
    if (g.cmpn(1) !== 0)
      return g;

    var x = a.toRed(red).redPow(d);
    if (x.cmp(rone) === 0 || x.cmp(rn1) === 0)
      continue;

    for (var i = 1; i < s; i++) {
      x = x.redSqr();

      if (x.cmp(rone) === 0)
        return x.fromRed().subn(1).gcd(n);
      if (x.cmp(rn1) === 0)
        break;
    }

    if (i === s) {
      x = x.redSqr();
      return x.fromRed().subn(1).gcd(n);
    }
  }

  return false;
};


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = exports;

function toArray(msg, enc) {
  if (Array.isArray(msg))
    return msg.slice();
  if (!msg)
    return [];
  var res = [];
  if (typeof msg !== 'string') {
    for (var i = 0; i < msg.length; i++)
      res[i] = msg[i] | 0;
    return res;
  }
  if (enc === 'hex') {
    msg = msg.replace(/[^a-z0-9]+/ig, '');
    if (msg.length % 2 !== 0)
      msg = '0' + msg;
    for (var i = 0; i < msg.length; i += 2)
      res.push(parseInt(msg[i] + msg[i + 1], 16));
  } else {
    for (var i = 0; i < msg.length; i++) {
      var c = msg.charCodeAt(i);
      var hi = c >> 8;
      var lo = c & 0xff;
      if (hi)
        res.push(hi, lo);
      else
        res.push(lo);
    }
  }
  return res;
}
utils.toArray = toArray;

function zero2(word) {
  if (word.length === 1)
    return '0' + word;
  else
    return word;
}
utils.zero2 = zero2;

function toHex(msg) {
  var res = '';
  for (var i = 0; i < msg.length; i++)
    res += zero2(msg[i].toString(16));
  return res;
}
utils.toHex = toHex;

utils.encode = function encode(arr, enc) {
  if (enc === 'hex')
    return toHex(arr);
  else
    return arr;
};


/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var af = moment.defineLocale('af', {
        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM : function (input) {
            return /^nm$/i.test(input);
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Vandag om] LT',
            nextDay : '[Môre om] LT',
            nextWeek : 'dddd [om] LT',
            lastDay : '[Gister om] LT',
            lastWeek : '[Laas] dddd [om] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'oor %s',
            past : '%s gelede',
            s : '\'n paar sekondes',
            ss : '%d sekondes',
            m : '\'n minuut',
            mm : '%d minute',
            h : '\'n uur',
            hh : '%d ure',
            d : '\'n dag',
            dd : '%d dae',
            M : '\'n maand',
            MM : '%d maande',
            y : '\'n jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week : {
            dow : 1, // Maandag is die eerste dag van die week.
            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        }
    });

    return af;

})));


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arDz = moment.defineLocale('ar-dz', {
        months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arDz;

})));


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arKw = moment.defineLocale('ar-kw', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arKw;

})));


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '1',
        '2': '2',
        '3': '3',
        '4': '4',
        '5': '5',
        '6': '6',
        '7': '7',
        '8': '8',
        '9': '9',
        '0': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var arLy = moment.defineLocale('ar-ly', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arLy;

})));


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arMa = moment.defineLocale('ar-ma', {
        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return arMa;

})));


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    };

    var arSa = moment.defineLocale('ar-sa', {
        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'في %s',
            past : 'منذ %s',
            s : 'ثوان',
            ss : '%d ثانية',
            m : 'دقيقة',
            mm : '%d دقائق',
            h : 'ساعة',
            hh : '%d ساعات',
            d : 'يوم',
            dd : '%d أيام',
            M : 'شهر',
            MM : '%d أشهر',
            y : 'سنة',
            yy : '%d سنوات'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return arSa;

})));


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss : '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات'
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return arTn;

})));


/***/ }),
/* 1270 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    }, pluralForm = function (n) {
        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
    }, plurals = {
        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
    }, pluralize = function (u) {
        return function (number, withoutSuffix, string, isFuture) {
            var f = pluralForm(number),
                str = plurals[u][pluralForm(number)];
            if (f === 2) {
                str = str[withoutSuffix ? 0 : 1];
            }
            return str.replace(/%d/i, number);
        };
    }, months = [
        'يناير',
        'فبراير',
        'مارس',
        'أبريل',
        'مايو',
        'يونيو',
        'يوليو',
        'أغسطس',
        'سبتمبر',
        'أكتوبر',
        'نوفمبر',
        'ديسمبر'
    ];

    var ar = moment.defineLocale('ar', {
        months : months,
        monthsShort : months,
        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/\u200FM/\u200FYYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ص|م/,
        isPM : function (input) {
            return 'م' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar : {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'بعد %s',
            past : 'منذ %s',
            s : pluralize('s'),
            ss : pluralize('s'),
            m : pluralize('m'),
            mm : pluralize('m'),
            h : pluralize('h'),
            hh : pluralize('h'),
            d : pluralize('d'),
            dd : pluralize('d'),
            M : pluralize('M'),
            MM : pluralize('M'),
            y : pluralize('y'),
            yy : pluralize('y')
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ar;

})));


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı'
    };

    var az = moment.defineLocale('az', {
        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[sabah saat] LT',
            nextWeek : '[gələn həftə] dddd [saat] LT',
            lastDay : '[dünən] LT',
            lastWeek : '[keçən həftə] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s əvvəl',
            s : 'birneçə saniyə',
            ss : '%d saniyə',
            m : 'bir dəqiqə',
            mm : '%d dəqiqə',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir il',
            yy : '%d il'
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM : function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal : function (number) {
            if (number === 0) {  // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = number % 100 - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return az;

})));


/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            'dd': 'дзень_дні_дзён',
            'MM': 'месяц_месяцы_месяцаў',
            'yy': 'год_гады_гадоў'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months : {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
        },
        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays : {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/
        },
        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., HH:mm',
            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
        },
        calendar : {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'праз %s',
            past : '%s таму',
            s : 'некалькі секунд',
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithPlural,
            hh : relativeTimeWithPlural,
            d : 'дзень',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM : function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return be;

})));


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bg = moment.defineLocale('bg', {
        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Днес в] LT',
            nextDay : '[Утре в] LT',
            nextWeek : 'dddd [в] LT',
            lastDay : '[Вчера в] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[В изминалата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[В изминалия] dddd [в] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'след %s',
            past : 'преди %s',
            s : 'няколко секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дни',
            M : 'месец',
            MM : '%d месеца',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bg;

})));


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var bm = moment.defineLocale('bm', {
        months : 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split('_'),
        monthsShort : 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays : 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort : 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin : 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'MMMM [tile] D [san] YYYY',
            LLL : 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL : 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm'
        },
        calendar : {
            sameDay : '[Bi lɛrɛ] LT',
            nextDay : '[Sini lɛrɛ] LT',
            nextWeek : 'dddd [don lɛrɛ] LT',
            lastDay : '[Kunu lɛrɛ] LT',
            lastWeek : 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s kɔnɔ',
            past : 'a bɛ %s bɔ',
            s : 'sanga dama dama',
            ss : 'sekondi %d',
            m : 'miniti kelen',
            mm : 'miniti %d',
            h : 'lɛrɛ kelen',
            hh : 'lɛrɛ %d',
            d : 'tile kelen',
            dd : 'tile %d',
            M : 'kalo kelen',
            MM : 'kalo %d',
            y : 'san kelen',
            yy : 'san %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return bm;

})));


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '১',
        '2': '২',
        '3': '৩',
        '4': '৪',
        '5': '৫',
        '6': '৬',
        '7': '৭',
        '8': '৮',
        '9': '৯',
        '0': '০'
    },
    numberMap = {
        '১': '1',
        '২': '2',
        '৩': '3',
        '৪': '4',
        '৫': '5',
        '৬': '6',
        '৭': '7',
        '৮': '8',
        '৯': '9',
        '০': '0'
    };

    var bn = moment.defineLocale('bn', {
        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
        longDateFormat : {
            LT : 'A h:mm সময়',
            LTS : 'A h:mm:ss সময়',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm সময়',
            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
        },
        calendar : {
            sameDay : '[আজ] LT',
            nextDay : '[আগামীকাল] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[গতকাল] LT',
            lastWeek : '[গত] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s পরে',
            past : '%s আগে',
            s : 'কয়েক সেকেন্ড',
            ss : '%d সেকেন্ড',
            m : 'এক মিনিট',
            mm : '%d মিনিট',
            h : 'এক ঘন্টা',
            hh : '%d ঘন্টা',
            d : 'এক দিন',
            dd : '%d দিন',
            M : 'এক মাস',
            MM : '%d মাস',
            y : 'এক বছর',
            yy : '%d বছর'
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'রাত' && hour >= 4) ||
                    (meridiem === 'দুপুর' && hour < 5) ||
                    meridiem === 'বিকাল') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bn;

})));


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '༡',
        '2': '༢',
        '3': '༣',
        '4': '༤',
        '5': '༥',
        '6': '༦',
        '7': '༧',
        '8': '༨',
        '9': '༩',
        '0': '༠'
    },
    numberMap = {
        '༡': '1',
        '༢': '2',
        '༣': '3',
        '༤': '4',
        '༥': '5',
        '༦': '6',
        '༧': '7',
        '༨': '8',
        '༩': '9',
        '༠': '0'
    };

    var bo = moment.defineLocale('bo', {
        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[དི་རིང] LT',
            nextDay : '[སང་ཉིན] LT',
            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay : '[ཁ་སང] LT',
            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ལ་',
            past : '%s སྔན་ལ',
            s : 'ལམ་སང',
            ss : '%d སྐར་ཆ།',
            m : 'སྐར་མ་གཅིག',
            mm : '%d སྐར་མ',
            h : 'ཆུ་ཚོད་གཅིག',
            hh : '%d ཆུ་ཚོད',
            d : 'ཉིན་གཅིག',
            dd : '%d ཉིན་',
            M : 'ཟླ་བ་གཅིག',
            MM : '%d ཟླ་བ',
            y : 'ལོ་གཅིག',
            yy : '%d ལོ'
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
                    meridiem === 'དགོང་དག') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return bo;

})));


/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            'mm': 'munutenn',
            'MM': 'miz',
            'dd': 'devezh'
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            'm': 'v',
            'b': 'v',
            'd': 'z'
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var br = moment.defineLocale('br', {
        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h[e]mm A',
            LTS : 'h[e]mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [a viz] MMMM YYYY',
            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
        },
        calendar : {
            sameDay : '[Hiziv da] LT',
            nextDay : '[Warc\'hoazh da] LT',
            nextWeek : 'dddd [da] LT',
            lastDay : '[Dec\'h da] LT',
            lastWeek : 'dddd [paset da] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'a-benn %s',
            past : '%s \'zo',
            s : 'un nebeud segondennoù',
            ss : '%d eilenn',
            m : 'ur vunutenn',
            mm : relativeTimeWithMutation,
            h : 'un eur',
            hh : '%d eur',
            d : 'un devezh',
            dd : relativeTimeWithMutation,
            M : 'ur miz',
            MM : relativeTimeWithMutation,
            y : 'ur bloaz',
            yy : specialMutationForYears
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal : function (number) {
            var output = (number === 1) ? 'añ' : 'vet';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return br;

})));


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return bs;

})));


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ca = moment.defineLocale('ca', {
        months : {
            standalone: 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
            format: 'de gener_de febrer_de març_d\'abril_de maig_de juny_de juliol_d\'agost_de setembre_d\'octubre_de novembre_de desembre'.split('_'),
            isFormat: /D[oD]?(\s)+MMMM/
        },
        monthsShort : 'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin : 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM [de] YYYY',
            ll : 'D MMM YYYY',
            LLL : 'D MMMM [de] YYYY [a les] H:mm',
            lll : 'D MMM YYYY, H:mm',
            LLLL : 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll : 'ddd D MMM YYYY, H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextDay : function () {
                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastDay : function () {
                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'd\'aquí %s',
            past : 'fa %s',
            s : 'uns segons',
            ss : '%d segons',
            m : 'un minut',
            mm : '%d minuts',
            h : 'una hora',
            hh : '%d hores',
            d : 'un dia',
            dd : '%d dies',
            M : 'un mes',
            MM : '%d mesos',
            y : 'un any',
            yy : '%d anys'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal : function (number, period) {
            var output = (number === 1) ? 'r' :
                (number === 2) ? 'n' :
                (number === 3) ? 'r' :
                (number === 4) ? 't' : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ca;

})));


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');

    var monthsParse = [/^led/i, /^úno/i, /^bře/i, /^dub/i, /^kvě/i, /^(čvn|červen$|června)/i, /^(čvc|červenec|července)/i, /^srp/i, /^zář/i, /^říj/i, /^lis/i, /^pro/i];
    // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
    // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
    var monthsRegex = /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
                break;
        }
    }

    var cs = moment.defineLocale('cs', {
        months : months,
        monthsShort : monthsShort,
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex : /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex : /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm',
            l : 'D. M. YYYY'
        },
        calendar : {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'před %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse : /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cs;

})));


/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cv = moment.defineLocale('cv', {
        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
        },
        calendar : {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L'
        },
        relativeTime : {
            future : function (output) {
                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
                return output + affix;
            },
            past : '%s каялла',
            s : 'пӗр-ик ҫеккунт',
            ss : '%d ҫеккунт',
            m : 'пӗр минут',
            mm : '%d минут',
            h : 'пӗр сехет',
            hh : '%d сехет',
            d : 'пӗр кун',
            dd : '%d кун',
            M : 'пӗр уйӑх',
            MM : '%d уйӑх',
            y : 'пӗр ҫул',
            yy : '%d ҫул'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal : '%d-мӗш',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return cv;

})));


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact : true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS : 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return cy;

})));


/***/ }),
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var da = moment.defineLocale('da', {
        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd [d.] D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay : '[i dag kl.] LT',
            nextDay : '[i morgen kl.] LT',
            nextWeek : 'på dddd [kl.] LT',
            lastDay : '[i går kl.] LT',
            lastWeek : '[i] dddd[s kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'få sekunder',
            ss : '%d sekunder',
            m : 'et minut',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dage',
            M : 'en måned',
            MM : '%d måneder',
            y : 'et år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return da;

})));


/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deAt;

})));


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return deCh;

})));


/***/ }),
/* 1286 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            ss : '%d Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;

})));


/***/ }),
/* 1287 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'ޖެނުއަރީ',
        'ފެބްރުއަރީ',
        'މާރިޗު',
        'އޭޕްރީލު',
        'މޭ',
        'ޖޫން',
        'ޖުލައި',
        'އޯގަސްޓު',
        'ސެޕްޓެމްބަރު',
        'އޮކްޓޯބަރު',
        'ނޮވެމްބަރު',
        'ޑިސެމްބަރު'
    ], weekdays = [
        'އާދިއްތަ',
        'ހޯމަ',
        'އަންގާރަ',
        'ބުދަ',
        'ބުރާސްފަތި',
        'ހުކުރު',
        'ހޮނިހިރު'
    ];

    var dv = moment.defineLocale('dv', {
        months : months,
        monthsShort : months,
        weekdays : weekdays,
        weekdaysShort : weekdays,
        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat : {

            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'D/M/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /މކ|މފ/,
        isPM : function (input) {
            return 'މފ' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar : {
            sameDay : '[މިއަދު] LT',
            nextDay : '[މާދަމާ] LT',
            nextWeek : 'dddd LT',
            lastDay : '[އިއްޔެ] LT',
            lastWeek : '[ފާއިތުވި] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ތެރޭގައި %s',
            past : 'ކުރިން %s',
            s : 'ސިކުންތުކޮޅެއް',
            ss : 'd% ސިކުންތު',
            m : 'މިނިޓެއް',
            mm : 'މިނިޓު %d',
            h : 'ގަޑިއިރެއް',
            hh : 'ގަޑިއިރު %d',
            d : 'ދުވަހެއް',
            dd : 'ދުވަސް %d',
            M : 'މަހެއް',
            MM : 'މަސް %d',
            y : 'އަހަރެއް',
            yy : 'އަހަރު %d'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 7,  // Sunday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return dv;

})));


/***/ }),
/* 1288 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }


    var el = moment.defineLocale('el', {
        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (typeof format === 'string' && /D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM : function (input) {
            return ((input + '').toLowerCase()[0] === 'μ');
        },
        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendarEl : {
            sameDay : '[Σήμερα {}] LT',
            nextDay : '[Αύριο {}] LT',
            nextWeek : 'dddd [{}] LT',
            lastDay : '[Χθες {}] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse : 'L'
        },
        calendar : function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
        },
        relativeTime : {
            future : 'σε %s',
            past : '%s πριν',
            s : 'λίγα δευτερόλεπτα',
            ss : '%d δευτερόλεπτα',
            m : 'ένα λεπτό',
            mm : '%d λεπτά',
            h : 'μία ώρα',
            hh : '%d ώρες',
            d : 'μία μέρα',
            dd : '%d μέρες',
            M : 'ένας μήνας',
            MM : '%d μήνες',
            y : 'ένας χρόνος',
            yy : '%d χρόνια'
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4st is the first week of the year.
        }
    });

    return el;

})));


/***/ }),
/* 1289 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enSG = moment.defineLocale('en-SG', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enSG;

})));


/***/ }),
/* 1290 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enAu = moment.defineLocale('en-au', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enAu;

})));


/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enCa = moment.defineLocale('en-ca', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'YYYY-MM-DD',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY h:mm A',
            LLLL : 'dddd, MMMM D, YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enCa;

})));


/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enGb = moment.defineLocale('en-gb', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enGb;

})));


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIe = moment.defineLocale('en-ie', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enIe;

})));


/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enIl = moment.defineLocale('en-il', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    return enIl;

})));


/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var enNz = moment.defineLocale('en-nz', {
        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Today at] LT',
            nextDay : '[Tomorrow at] LT',
            nextWeek : 'dddd [at] LT',
            lastDay : '[Yesterday at] LT',
            lastWeek : '[Last] dddd [at] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'in %s',
            past : '%s ago',
            s : 'a few seconds',
            ss : '%d seconds',
            m : 'a minute',
            mm : '%d minutes',
            h : 'an hour',
            hh : '%d hours',
            d : 'a day',
            dd : '%d days',
            M : 'a month',
            MM : '%d months',
            y : 'a year',
            yy : '%d years'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return enNz;

})));


/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eo = moment.defineLocale('eo', {
        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
        weekdays : 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort : 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin : 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D[-a de] MMMM, YYYY',
            LLL : 'D[-a de] MMMM, YYYY HH:mm',
            LLLL : 'dddd, [la] D[-a de] MMMM, YYYY HH:mm'
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar : {
            sameDay : '[Hodiaŭ je] LT',
            nextDay : '[Morgaŭ je] LT',
            nextWeek : 'dddd [je] LT',
            lastDay : '[Hieraŭ je] LT',
            lastWeek : '[pasinta] dddd [je] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'post %s',
            past : 'antaŭ %s',
            s : 'sekundoj',
            ss : '%d sekundoj',
            m : 'minuto',
            mm : '%d minutoj',
            h : 'horo',
            hh : '%d horoj',
            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
            dd : '%d tagoj',
            M : 'monato',
            MM : '%d monatoj',
            y : 'jaro',
            yy : '%d jaroj'
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal : '%da',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return eo;

})));


/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return esDo;

})));


/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex: /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'MM/DD/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY h:mm A',
            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return esUs;

})));


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');

    var monthsParse = [/^ene/i, /^feb/i, /^mar/i, /^abr/i, /^may/i, /^jun/i, /^jul/i, /^ago/i, /^sep/i, /^oct/i, /^nov/i, /^dic/i];
    var monthsRegex = /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex : monthsRegex,
        monthsShortRegex : monthsRegex,
        monthsStrictRegex : /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex : /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,
        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextDay : function () {
                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastDay : function () {
                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            lastWeek : function () {
                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'en %s',
            past : 'hace %s',
            s : 'unos segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'una hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un año',
            yy : '%d años'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return es;

})));


/***/ }),
/* 1300 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            'ss': [number + 'sekundi', number + 'sekundit'],
            'm' : ['ühe minuti', 'üks minut'],
            'mm': [number + ' minuti', number + ' minutit'],
            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
            'hh': [number + ' tunni', number + ' tundi'],
            'd' : ['ühe päeva', 'üks päev'],
            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
            'MM': [number + ' kuu', number + ' kuud'],
            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
            'yy': [number + ' aasta', number + ' aastat']
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat : {
            LT   : 'H:mm',
            LTS : 'H:mm:ss',
            L    : 'DD.MM.YYYY',
            LL   : 'D. MMMM YYYY',
            LLL  : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[Täna,] LT',
            nextDay  : '[Homme,] LT',
            nextWeek : '[Järgmine] dddd LT',
            lastDay  : '[Eile,] LT',
            lastWeek : '[Eelmine] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s pärast',
            past   : '%s tagasi',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : '%d päeva',
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return et;

})));


/***/ }),
/* 1301 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var eu = moment.defineLocale('eu', {
        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
        monthsParseExact : true,
        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY[ko] MMMM[ren] D[a]',
            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l : 'YYYY-M-D',
            ll : 'YYYY[ko] MMM D[a]',
            lll : 'YYYY[ko] MMM D[a] HH:mm',
            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
        },
        calendar : {
            sameDay : '[gaur] LT[etan]',
            nextDay : '[bihar] LT[etan]',
            nextWeek : 'dddd LT[etan]',
            lastDay : '[atzo] LT[etan]',
            lastWeek : '[aurreko] dddd LT[etan]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s barru',
            past : 'duela %s',
            s : 'segundo batzuk',
            ss : '%d segundo',
            m : 'minutu bat',
            mm : '%d minutu',
            h : 'ordu bat',
            hh : '%d ordu',
            d : 'egun bat',
            dd : '%d egun',
            M : 'hilabete bat',
            MM : '%d hilabete',
            y : 'urte bat',
            yy : '%d urte'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return eu;

})));


/***/ }),
/* 1302 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '۱',
        '2': '۲',
        '3': '۳',
        '4': '۴',
        '5': '۵',
        '6': '۶',
        '7': '۷',
        '8': '۸',
        '9': '۹',
        '0': '۰'
    }, numberMap = {
        '۱': '1',
        '۲': '2',
        '۳': '3',
        '۴': '4',
        '۵': '5',
        '۶': '6',
        '۷': '7',
        '۸': '8',
        '۹': '9',
        '۰': '0'
    };

    var fa = moment.defineLocale('fa', {
        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar : {
            sameDay : '[امروز ساعت] LT',
            nextDay : '[فردا ساعت] LT',
            nextWeek : 'dddd [ساعت] LT',
            lastDay : '[دیروز ساعت] LT',
            lastWeek : 'dddd [پیش] [ساعت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'در %s',
            past : '%s پیش',
            s : 'چند ثانیه',
            ss : 'ثانیه d%',
            m : 'یک دقیقه',
            mm : '%d دقیقه',
            h : 'یک ساعت',
            hh : '%d ساعت',
            d : 'یک روز',
            dd : '%d روز',
            M : 'یک ماه',
            MM : '%d ماه',
            y : 'یک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/[۰-۹]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal : '%dم',
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return fa;

})));


/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
        numbersFuture = [
            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
            numbersPast[7], numbersPast[8], numbersPast[9]
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                return isFuture ? 'sekunnin' : 'sekuntia';
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
    }

    var fi = moment.defineLocale('fi', {
        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'Do MMMM[ta] YYYY',
            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l : 'D.M.YYYY',
            ll : 'Do MMM YYYY',
            lll : 'Do MMM YYYY, [klo] HH.mm',
            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
        },
        calendar : {
            sameDay : '[tänään] [klo] LT',
            nextDay : '[huomenna] [klo] LT',
            nextWeek : 'dddd [klo] LT',
            lastDay : '[eilen] [klo] LT',
            lastWeek : '[viime] dddd[na] [klo] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s päästä',
            past : '%s sitten',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fi;

})));


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fo = moment.defineLocale('fo', {
        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D. MMMM, YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Í dag kl.] LT',
            nextDay : '[Í morgin kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[Í gjár kl.] LT',
            lastWeek : '[síðstu] dddd [kl] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'um %s',
            past : '%s síðani',
            s : 'fá sekund',
            ss : '%d sekundir',
            m : 'ein minuttur',
            mm : '%d minuttir',
            h : 'ein tími',
            hh : '%d tímar',
            d : 'ein dagur',
            dd : '%d dagar',
            M : 'ein mánaður',
            MM : '%d mánaðir',
            y : 'eitt ár',
            yy : '%d ár'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fo;

})));


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCa = moment.defineLocale('fr-ca', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        }
    });

    return frCa;

})));


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var frCh = moment.defineLocale('fr-ch', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal : function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return frCh;

})));


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var fr = moment.defineLocale('fr', {
        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
        monthsParseExact : true,
        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin : 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Aujourd’hui à] LT',
            nextDay : '[Demain à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[Hier à] LT',
            lastWeek : 'dddd [dernier à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dans %s',
            past : 'il y a %s',
            s : 'quelques secondes',
            ss : '%d secondes',
            m : 'une minute',
            mm : '%d minutes',
            h : 'une heure',
            hh : '%d heures',
            d : 'un jour',
            dd : '%d jours',
            M : 'un mois',
            MM : '%d mois',
            y : 'un an',
            yy : '%d ans'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal : function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fr;

})));


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact : true,
        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'oer %s',
            past : '%s lyn',
            s : 'in pear sekonden',
            ss : '%d sekonden',
            m : 'ien minút',
            mm : '%d minuten',
            h : 'ien oere',
            hh : '%d oeren',
            d : 'ien dei',
            dd : '%d dagen',
            M : 'ien moanne',
            MM : '%d moannen',
            y : 'ien jier',
            yy : '%d jierren'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return fy;

})));


/***/ }),
/* 1309 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';



    var months = [
        'Eanáir', 'Feabhra', 'Márta', 'Aibreán', 'Bealtaine', 'Méitheamh', 'Iúil', 'Lúnasa', 'Meán Fómhair', 'Deaireadh Fómhair', 'Samhain', 'Nollaig'
    ];

    var monthsShort = ['Eaná', 'Feab', 'Márt', 'Aibr', 'Beal', 'Méit', 'Iúil', 'Lúna', 'Meán', 'Deai', 'Samh', 'Noll'];

    var weekdays = ['Dé Domhnaigh', 'Dé Luain', 'Dé Máirt', 'Dé Céadaoin', 'Déardaoin', 'Dé hAoine', 'Dé Satharn'];

    var weekdaysShort = ['Dom', 'Lua', 'Mái', 'Céa', 'Déa', 'hAo', 'Sat'];

    var weekdaysMin = ['Do', 'Lu', 'Má', 'Ce', 'Dé', 'hA', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné aig] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d mí',
            y: 'bliain',
            yy: '%d bliain'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ga;

})));


/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
    ];

    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];

    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];

    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];

    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months : months,
        monthsShort : monthsShort,
        monthsParseExact : true,
        weekdays : weekdays,
        weekdaysShort : weekdaysShort,
        weekdaysMin : weekdaysMin,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[An-diugh aig] LT',
            nextDay : '[A-màireach aig] LT',
            nextWeek : 'dddd [aig] LT',
            lastDay : '[An-dè aig] LT',
            lastWeek : 'dddd [seo chaidh] [aig] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ann an %s',
            past : 'bho chionn %s',
            s : 'beagan diogan',
            ss : '%d diogan',
            m : 'mionaid',
            mm : '%d mionaidean',
            h : 'uair',
            hh : '%d uairean',
            d : 'latha',
            dd : '%d latha',
            M : 'mìos',
            MM : '%d mìosan',
            y : 'bliadhna',
            yy : '%d bliadhna'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(d|na|mh)/,
        ordinal : function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gd;

})));


/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var gl = moment.defineLocale('gl', {
        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY H:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
        },
        calendar : {
            sameDay : function () {
                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextDay : function () {
                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
            },
            nextWeek : function () {
                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            lastDay : function () {
                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
            },
            lastWeek : function () {
                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past : 'hai %s',
            s : 'uns segundos',
            ss : '%d segundos',
            m : 'un minuto',
            mm : '%d minutos',
            h : 'unha hora',
            hh : '%d horas',
            d : 'un día',
            dd : '%d días',
            M : 'un mes',
            MM : '%d meses',
            y : 'un ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return gl;

})));


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['thodde secondanim', 'thodde second'],
            'ss': [number + ' secondanim', number + ' second'],
            'm': ['eka mintan', 'ek minute'],
            'mm': [number + ' mintanim', number + ' mintam'],
            'h': ['eka voran', 'ek vor'],
            'hh': [number + ' voranim', number + ' voram'],
            'd': ['eka disan', 'ek dis'],
            'dd': [number + ' disanim', number + ' dis'],
            'M': ['eka mhoinean', 'ek mhoino'],
            'MM': [number + ' mhoineanim', number + ' mhoine'],
            'y': ['eka vorsan', 'ek voros'],
            'yy': [number + ' vorsanim', number + ' vorsam']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months : 'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split('_'),
        monthsShort : 'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays : 'Aitar_Somar_Mongllar_Budvar_Brestar_Sukrar_Son\'var'.split('_'),
        weekdaysShort : 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin : 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'A h:mm [vazta]',
            LTS : 'A h:mm:ss [vazta]',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY A h:mm [vazta]',
            LLLL : 'dddd, MMMM[achea] Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]'
        },
        calendar : {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Ieta to] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fatlo] dddd[,] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s',
            past : '%s adim',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse : /\d{1,2}(er)/,
        ordinal : function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /rati|sokalli|donparam|sanje/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokalli') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokalli';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        }
    });

    return gomLatn;

})));


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
            '1': '૧',
            '2': '૨',
            '3': '૩',
            '4': '૪',
            '5': '૫',
            '6': '૬',
            '7': '૭',
            '8': '૮',
            '9': '૯',
            '0': '૦'
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0'
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split('_'),
        monthsShort: 'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split('_'),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split('_'),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે'
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પેહલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ'
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 6th is the first week of the year.
        }
    });

    return gu;

})));


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var he = moment.defineLocale('he', {
        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [ב]MMMM YYYY',
            LLL : 'D [ב]MMMM YYYY HH:mm',
            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
            l : 'D/M/YYYY',
            ll : 'D MMM YYYY',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd, D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[היום ב־]LT',
            nextDay : '[מחר ב־]LT',
            nextWeek : 'dddd [בשעה] LT',
            lastDay : '[אתמול ב־]LT',
            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'בעוד %s',
            past : 'לפני %s',
            s : 'מספר שניות',
            ss : '%d שניות',
            m : 'דקה',
            mm : '%d דקות',
            h : 'שעה',
            hh : function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d : 'יום',
            dd : function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M : 'חודש',
            MM : function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y : 'שנה',
            yy : function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            }
        },
        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM : function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        }
    });

    return he;

})));


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var hi = moment.defineLocale('hi', {
        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        monthsParseExact: true,
        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm बजे',
            LTS : 'A h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[कल] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[कल] LT',
            lastWeek : '[पिछले] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s में',
            past : '%s पहले',
            s : 'कुछ ही क्षण',
            ss : '%d सेकंड',
            m : 'एक मिनट',
            mm : '%d मिनट',
            h : 'एक घंटा',
            hh : '%d घंटे',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महीने',
            MM : '%d महीने',
            y : 'एक वर्ष',
            yy : '%d वर्ष'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return hi;

})));


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months : {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
        },
        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            ss     : translate,
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hr;

})));


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
    }

    var hu = moment.defineLocale('hu', {
        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY. MMMM D.',
            LLL : 'YYYY. MMMM D. H:mm',
            LLLL : 'YYYY. MMMM D., dddd H:mm'
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar : {
            sameDay : '[ma] LT[-kor]',
            nextDay : '[holnap] LT[-kor]',
            nextWeek : function () {
                return week.call(this, true);
            },
            lastDay : '[tegnap] LT[-kor]',
            lastWeek : function () {
                return week.call(this, false);
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s múlva',
            past : '%s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return hu;

})));


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var hyAm = moment.defineLocale('hy-am', {
        months : {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
        },
        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY թ.',
            LLL : 'D MMMM YYYY թ., HH:mm',
            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
        },
        calendar : {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s հետո',
            past : '%s առաջ',
            s : 'մի քանի վայրկյան',
            ss : '%d վայրկյան',
            m : 'րոպե',
            mm : '%d րոպե',
            h : 'ժամ',
            hh : '%d ժամ',
            d : 'օր',
            dd : '%d օր',
            M : 'ամիս',
            MM : '%d ամիս',
            y : 'տարի',
            yy : '%d տարի'
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem : function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return hyAm;

})));


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum');
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
        },
        calendar : {
            sameDay : '[í dag kl.] LT',
            nextDay : '[á morgun kl.] LT',
            nextWeek : 'dddd [kl.] LT',
            lastDay : '[í gær kl.] LT',
            lastWeek : '[síðasta] dddd [kl.] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'eftir %s',
            past : 'fyrir %s síðan',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : 'klukkustund',
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return is;

})));


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var itCh = moment.defineLocale('it-ch', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return itCh;

})));


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var it = moment.defineLocale('it', {
        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays : 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split('_'),
        weekdaysShort : 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin : 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : function (s) {
                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past : '%s fa',
            s : 'alcuni secondi',
            ss : '%d secondi',
            m : 'un minuto',
            mm : '%d minuti',
            h : 'un\'ora',
            hh : '%d ore',
            d : 'un giorno',
            dd : '%d giorni',
            M : 'un mese',
            MM : '%d mesi',
            y : 'un anno',
            yy : '%d anni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return it;

})));


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ja = moment.defineLocale('ja', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日 dddd HH:mm',
            l : 'YYYY/MM/DD',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日(ddd) HH:mm'
        },
        meridiemParse: /午前|午後/i,
        isPM : function (input) {
            return input === '午後';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar : {
            sameDay : '[今日] LT',
            nextDay : '[明日] LT',
            nextWeek : function (now) {
                if (now.week() < this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay : '[昨日] LT',
            lastWeek : function (now) {
                if (this.week() < now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse : /\d{1,2}日/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s後',
            past : '%s前',
            s : '数秒',
            ss : '%d秒',
            m : '1分',
            mm : '%d分',
            h : '1時間',
            hh : '%d時間',
            d : '1日',
            dd : '%d日',
            M : '1ヶ月',
            MM : '%dヶ月',
            y : '1年',
            yy : '%d年'
        }
    });

    return ja;

})));


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var jv = moment.defineLocale('jv', {
        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar : {
            sameDay : '[Dinten puniko pukul] LT',
            nextDay : '[Mbenjang pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kala wingi pukul] LT',
            lastWeek : 'dddd [kepengker pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'wonten ing %s',
            past : '%s ingkang kepengker',
            s : 'sawetawis detik',
            ss : '%d detik',
            m : 'setunggal menit',
            mm : '%d menit',
            h : 'setunggal jam',
            hh : '%d jam',
            d : 'sedinten',
            dd : '%d dinten',
            M : 'sewulan',
            MM : '%d wulan',
            y : 'setaun',
            yy : '%d taun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return jv;

})));


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ka = moment.defineLocale('ka', {
        months : {
            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
        },
        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays : {
            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
            isFormat: /(წინა|შემდეგ)/
        },
        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[დღეს] LT[-ზე]',
            nextDay : '[ხვალ] LT[-ზე]',
            lastDay : '[გუშინ] LT[-ზე]',
            nextWeek : '[შემდეგ] dddd LT[-ზე]',
            lastWeek : '[წინა] dddd LT-ზე',
            sameElse : 'L'
        },
        relativeTime : {
            future : function (s) {
                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
                    s.replace(/ი$/, 'ში') :
                    s + 'ში';
            },
            past : function (s) {
                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if ((/წელი/).test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
            },
            s : 'რამდენიმე წამი',
            ss : '%d წამი',
            m : 'წუთი',
            mm : '%d წუთი',
            h : 'საათი',
            hh : '%d საათი',
            d : 'დღე',
            dd : '%d დღე',
            M : 'თვე',
            MM : '%d თვე',
            y : 'წელი',
            yy : '%d წელი'
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal : function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week : {
            dow : 1,
            doy : 7
        }
    });

    return ka;

})));


/***/ }),
/* 1325 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші'
    };

    var kk = moment.defineLocale('kk', {
        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгін сағат] LT',
            nextDay : '[Ертең сағат] LT',
            nextWeek : 'dddd [сағат] LT',
            lastDay : '[Кеше сағат] LT',
            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ішінде',
            past : '%s бұрын',
            s : 'бірнеше секунд',
            ss : '%d секунд',
            m : 'бір минут',
            mm : '%d минут',
            h : 'бір сағат',
            hh : '%d сағат',
            d : 'бір күн',
            dd : '%d күн',
            M : 'бір ай',
            MM : '%d ай',
            y : 'бір жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return kk;

})));


/***/ }),
/* 1326 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '១',
        '2': '២',
        '3': '៣',
        '4': '៤',
        '5': '៥',
        '6': '៦',
        '7': '៧',
        '8': '៨',
        '9': '៩',
        '0': '០'
    }, numberMap = {
        '១': '1',
        '២': '2',
        '៣': '3',
        '៤': '4',
        '៥': '5',
        '៦': '6',
        '៧': '7',
        '៨': '8',
        '៩': '9',
        '០': '0'
    };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ'
        },
        dayOfMonthOrdinalParse : /ទី\d{1,2}/,
        ordinal : 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return km;

})));


/***/ }),
/* 1327 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '೧',
        '2': '೨',
        '3': '೩',
        '4': '೪',
        '5': '೫',
        '6': '೬',
        '7': '೭',
        '8': '೮',
        '9': '೯',
        '0': '೦'
    },
    numberMap = {
        '೧': '1',
        '೨': '2',
        '೩': '3',
        '೪': '4',
        '೫': '5',
        '೬': '6',
        '೭': '7',
        '೮': '8',
        '೯': '9',
        '೦': '0'
    };

    var kn = moment.defineLocale('kn', {
        months : 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split('_'),
        monthsShort : 'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split('_'),
        monthsParseExact: true,
        weekdays : 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split('_'),
        weekdaysShort : 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin : 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[ಇಂದು] LT',
            nextDay : '[ನಾಳೆ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ನಿನ್ನೆ] LT',
            lastWeek : '[ಕೊನೆಯ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ನಂತರ',
            past : '%s ಹಿಂದೆ',
            s : 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss : '%d ಸೆಕೆಂಡುಗಳು',
            m : 'ಒಂದು ನಿಮಿಷ',
            mm : '%d ನಿಮಿಷ',
            h : 'ಒಂದು ಗಂಟೆ',
            hh : '%d ಗಂಟೆ',
            d : 'ಒಂದು ದಿನ',
            dd : '%d ದಿನ',
            M : 'ಒಂದು ತಿಂಗಳು',
            MM : '%d ತಿಂಗಳು',
            y : 'ಒಂದು ವರ್ಷ',
            yy : '%d ವರ್ಷ'
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal : function (number) {
            return number + 'ನೇ';
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return kn;

})));


/***/ }),
/* 1328 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ko = moment.defineLocale('ko', {
        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'YYYY.MM.DD.',
            LL : 'YYYY년 MMMM D일',
            LLL : 'YYYY년 MMMM D일 A h:mm',
            LLLL : 'YYYY년 MMMM D일 dddd A h:mm',
            l : 'YYYY.MM.DD.',
            ll : 'YYYY년 MMMM D일',
            lll : 'YYYY년 MMMM D일 A h:mm',
            llll : 'YYYY년 MMMM D일 dddd A h:mm'
        },
        calendar : {
            sameDay : '오늘 LT',
            nextDay : '내일 LT',
            nextWeek : 'dddd LT',
            lastDay : '어제 LT',
            lastWeek : '지난주 dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s 후',
            past : '%s 전',
            s : '몇 초',
            ss : '%d초',
            m : '1분',
            mm : '%d분',
            h : '한 시간',
            hh : '%d시간',
            d : '하루',
            dd : '%d일',
            M : '한 달',
            MM : '%d달',
            y : '일 년',
            yy : '%d년'
        },
        dayOfMonthOrdinalParse : /\d{1,2}(일|월|주)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse : /오전|오후/,
        isPM : function (token) {
            return token === '오후';
        },
        meridiem : function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        }
    });

    return ko;

})));


/***/ }),
/* 1329 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '١',
        '2': '٢',
        '3': '٣',
        '4': '٤',
        '5': '٥',
        '6': '٦',
        '7': '٧',
        '8': '٨',
        '9': '٩',
        '0': '٠'
    }, numberMap = {
        '١': '1',
        '٢': '2',
        '٣': '3',
        '٤': '4',
        '٥': '5',
        '٦': '6',
        '٧': '7',
        '٨': '8',
        '٩': '9',
        '٠': '0'
    },
    months = [
        'کانونی دووەم',
        'شوبات',
        'ئازار',
        'نیسان',
        'ئایار',
        'حوزەیران',
        'تەمموز',
        'ئاب',
        'ئەیلوول',
        'تشرینی یەكەم',
        'تشرینی دووەم',
        'كانونی یەکەم'
    ];


    var ku = moment.defineLocale('ku', {
        months : months,
        monthsShort : months,
        weekdays : 'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysShort : 'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin : 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar : {
            sameDay : '[ئه‌مرۆ كاتژمێر] LT',
            nextDay : '[به‌یانی كاتژمێر] LT',
            nextWeek : 'dddd [كاتژمێر] LT',
            lastDay : '[دوێنێ كاتژمێر] LT',
            lastWeek : 'dddd [كاتژمێر] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'له‌ %s',
            past : '%s',
            s : 'چه‌ند چركه‌یه‌ك',
            ss : 'چركه‌ %d',
            m : 'یه‌ك خوله‌ك',
            mm : '%d خوله‌ك',
            h : 'یه‌ك كاتژمێر',
            hh : '%d كاتژمێر',
            d : 'یه‌ك ڕۆژ',
            dd : '%d ڕۆژ',
            M : 'یه‌ك مانگ',
            MM : '%d مانگ',
            y : 'یه‌ك ساڵ',
            yy : '%d ساڵ'
        },
        preparse: function (string) {
            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                return numberMap[match];
            }).replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            }).replace(/,/g, '،');
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12 // The week that contains Jan 12th is the first week of the year.
        }
    });

    return ku;

})));


/***/ }),
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү'
    };

    var ky = moment.defineLocale('ky', {
        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Бүгүн саат] LT',
            nextDay : '[Эртең саат] LT',
            nextWeek : 'dddd [саат] LT',
            lastDay : '[Кечээ саат] LT',
            lastWeek : '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ичинде',
            past : '%s мурун',
            s : 'бирнече секунд',
            ss : '%d секунд',
            m : 'бир мүнөт',
            mm : '%d мүнөт',
            h : 'бир саат',
            hh : '%d саат',
            d : 'бир күн',
            dd : '%d күн',
            M : 'бир ай',
            MM : '%d ай',
            y : 'бир жыл',
            yy : '%d жыл'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal : function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ky;

})));


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eng Minutt', 'enger Minutt'],
            'h': ['eng Stonn', 'enger Stonn'],
            'd': ['een Dag', 'engem Dag'],
            'M': ['ee Mount', 'engem Mount'],
            'y': ['ee Joer', 'engem Joer']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10, firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        monthsParseExact : true,
        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            }
        },
        relativeTime : {
            future : processFutureTime,
            past : processPastTime,
            s : 'e puer Sekonnen',
            ss : '%d Sekonnen',
            m : processRelativeTime,
            mm : '%d Minutten',
            h : processRelativeTime,
            hh : '%d Stonnen',
            d : processRelativeTime,
            dd : '%d Deeg',
            M : processRelativeTime,
            MM : '%d Méint',
            y : processRelativeTime,
            yy : '%d Joer'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lb;

})));


/***/ }),
/* 1332 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var lo = moment.defineLocale('lo', {
        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar : {
            sameDay : '[ມື້ນີ້ເວລາ] LT',
            nextDay : '[ມື້ອື່ນເວລາ] LT',
            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ອີກ %s',
            past : '%sຜ່ານມາ',
            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss : '%d ວິນາທີ' ,
            m : '1 ນາທີ',
            mm : '%d ນາທີ',
            h : '1 ຊົ່ວໂມງ',
            hh : '%d ຊົ່ວໂມງ',
            d : '1 ມື້',
            dd : '%d ມື້',
            M : '1 ເດືອນ',
            MM : '%d ເດືອນ',
            y : '1 ປີ',
            yy : '%d ປີ'
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal : function (number) {
            return 'ທີ່' + number;
        }
    });

    return lo;

})));


/***/ }),
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss' : 'sekundė_sekundžių_sekundes',
        'm' : 'minutė_minutės_minutę',
        'mm': 'minutės_minučių_minutes',
        'h' : 'valanda_valandos_valandą',
        'hh': 'valandos_valandų_valandas',
        'd' : 'diena_dienos_dieną',
        'dd': 'dienos_dienų_dienas',
        'M' : 'mėnuo_mėnesio_mėnesį',
        'MM': 'mėnesiai_mėnesių_mėnesius',
        'y' : 'metai_metų_metus',
        'yy': 'metai_metų_metus'
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months : {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
        },
        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays : {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
            isFormat: /dddd HH:mm/
        },
        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY [m.] MMMM D [d.]',
            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l : 'YYYY-MM-DD',
            ll : 'YYYY [m.] MMMM D [d.]',
            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
        },
        calendar : {
            sameDay : '[Šiandien] LT',
            nextDay : '[Rytoj] LT',
            nextWeek : 'dddd LT',
            lastDay : '[Vakar] LT',
            lastWeek : '[Praėjusį] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'po %s',
            past : 'prieš %s',
            s : translateSeconds,
            ss : translate,
            m : translateSingular,
            mm : translate,
            h : translateSingular,
            hh : translate,
            d : translateSingular,
            dd : translate,
            M : translateSingular,
            MM : translate,
            y : translateSingular,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal : function (number) {
            return number + '-oji';
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lt;

})));


/***/ }),
/* 1334 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var units = {
        'ss': 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        'h': 'stundas_stundām_stunda_stundas'.split('_'),
        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
        'd': 'dienas_dienām_diena_dienas'.split('_'),
        'dd': 'dienas_dienām_diena_dienas'.split('_'),
        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        'y': 'gada_gadiem_gads_gadi'.split('_'),
        'yy': 'gada_gadiem_gads_gadi'.split('_')
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY.',
            LL : 'YYYY. [gada] D. MMMM',
            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
        },
        calendar : {
            sameDay : '[Šodien pulksten] LT',
            nextDay : '[Rīt pulksten] LT',
            nextWeek : 'dddd [pulksten] LT',
            lastDay : '[Vakar pulksten] LT',
            lastWeek : '[Pagājušā] dddd [pulksten] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'pēc %s',
            past : 'pirms %s',
            s : relativeSeconds,
            ss : relativeTimeWithPlural,
            m : relativeTimeWithSingular,
            mm : relativeTimeWithPlural,
            h : relativeTimeWithSingular,
            hh : relativeTimeWithPlural,
            d : relativeTimeWithSingular,
            dd : relativeTimeWithPlural,
            M : relativeTimeWithSingular,
            MM : relativeTimeWithPlural,
            y : relativeTimeWithSingular,
            yy : relativeTimeWithPlural
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return lv;

})));


/***/ }),
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact : true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mjesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return me;

})));


/***/ }),
/* 1336 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mi;

})));


/***/ }),
/* 1337 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mk = moment.defineLocale('mk', {
        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'D.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay : '[Денес во] LT',
            nextDay : '[Утре во] LT',
            nextWeek : '[Во] dddd [во] LT',
            lastDay : '[Вчера во] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'после %s',
            past : 'пред %s',
            s : 'неколку секунди',
            ss : '%d секунди',
            m : 'минута',
            mm : '%d минути',
            h : 'час',
            hh : '%d часа',
            d : 'ден',
            dd : '%d дена',
            M : 'месец',
            MM : '%d месеци',
            y : 'година',
            yy : '%d години'
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal : function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return mk;

})));


/***/ }),
/* 1338 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ml = moment.defineLocale('ml', {
        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm -നു',
            LTS : 'A h:mm:ss -നു',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm -നു',
            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
        },
        calendar : {
            sameDay : '[ഇന്ന്] LT',
            nextDay : '[നാളെ] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[ഇന്നലെ] LT',
            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s കഴിഞ്ഞ്',
            past : '%s മുൻപ്',
            s : 'അൽപ നിമിഷങ്ങൾ',
            ss : '%d സെക്കൻഡ്',
            m : 'ഒരു മിനിറ്റ്',
            mm : '%d മിനിറ്റ്',
            h : 'ഒരു മണിക്കൂർ',
            hh : '%d മണിക്കൂർ',
            d : 'ഒരു ദിവസം',
            dd : '%d ദിവസം',
            M : 'ഒരു മാസം',
            MM : '%d മാസം',
            y : 'ഒരു വർഷം',
            yy : '%d വർഷം'
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if ((meridiem === 'രാത്രി' && hour >= 4) ||
                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                    meridiem === 'വൈകുന്നേരം') {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        }
    });

    return ml;

})));


/***/ }),
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months : 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split('_'),
        monthsShort : '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split('_'),
        monthsParseExact : true,
        weekdays : 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort : 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin : 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'YYYY оны MMMMын D',
            LLL : 'YYYY оны MMMMын D HH:mm',
            LLLL : 'dddd, YYYY оны MMMMын D HH:mm'
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM : function (input) {
            return input === 'ҮХ';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar : {
            sameDay : '[Өнөөдөр] LT',
            nextDay : '[Маргааш] LT',
            nextWeek : '[Ирэх] dddd LT',
            lastDay : '[Өчигдөр] LT',
            lastWeek : '[Өнгөрсөн] dddd LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s дараа',
            past : '%s өмнө',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        }
    });

    return mn;

})));


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    function relativeTimeMr(number, withoutSuffix, string, isFuture)
    {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's': output = 'काही सेकंद'; break;
                case 'ss': output = '%d सेकंद'; break;
                case 'm': output = 'एक मिनिट'; break;
                case 'mm': output = '%d मिनिटे'; break;
                case 'h': output = 'एक तास'; break;
                case 'hh': output = '%d तास'; break;
                case 'd': output = 'एक दिवस'; break;
                case 'dd': output = '%d दिवस'; break;
                case 'M': output = 'एक महिना'; break;
                case 'MM': output = '%d महिने'; break;
                case 'y': output = 'एक वर्ष'; break;
                case 'yy': output = '%d वर्षे'; break;
            }
        }
        else {
            switch (string) {
                case 's': output = 'काही सेकंदां'; break;
                case 'ss': output = '%d सेकंदां'; break;
                case 'm': output = 'एका मिनिटा'; break;
                case 'mm': output = '%d मिनिटां'; break;
                case 'h': output = 'एका तासा'; break;
                case 'hh': output = '%d तासां'; break;
                case 'd': output = 'एका दिवसा'; break;
                case 'dd': output = '%d दिवसां'; break;
                case 'M': output = 'एका महिन्या'; break;
                case 'MM': output = '%d महिन्यां'; break;
                case 'y': output = 'एका वर्षा'; break;
                case 'yy': output = '%d वर्षां'; break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
        monthsParseExact : true,
        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat : {
            LT : 'A h:mm वाजता',
            LTS : 'A h:mm:ss वाजता',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm वाजता',
            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[उद्या] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात्री') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळी') {
                return hour;
            } else if (meridiem === 'दुपारी') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'सायंकाळी') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात्री';
            } else if (hour < 10) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return mr;

})));


/***/ }),
/* 1341 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var msMy = moment.defineLocale('ms-my', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return msMy;

})));


/***/ }),
/* 1342 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ms = moment.defineLocale('ms', {
        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [pukul] HH.mm',
            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar : {
            sameDay : '[Hari ini pukul] LT',
            nextDay : '[Esok pukul] LT',
            nextWeek : 'dddd [pukul] LT',
            lastDay : '[Kelmarin pukul] LT',
            lastWeek : 'dddd [lepas pukul] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'dalam %s',
            past : '%s yang lepas',
            s : 'beberapa saat',
            ss : '%d saat',
            m : 'seminit',
            mm : '%d minit',
            h : 'sejam',
            hh : '%d jam',
            d : 'sehari',
            dd : '%d hari',
            M : 'sebulan',
            MM : '%d bulan',
            y : 'setahun',
            yy : '%d tahun'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ms;

})));


/***/ }),
/* 1343 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var mt = moment.defineLocale('mt', {
        months : 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split('_'),
        monthsShort : 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays : 'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split('_'),
        weekdaysShort : 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin : 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Illum fil-]LT',
            nextDay : '[Għada fil-]LT',
            nextWeek : 'dddd [fil-]LT',
            lastDay : '[Il-bieraħ fil-]LT',
            lastWeek : 'dddd [li għadda] [fil-]LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'f’ %s',
            past : '%s ilu',
            s : 'ftit sekondi',
            ss : '%d sekondi',
            m : 'minuta',
            mm : '%d minuti',
            h : 'siegħa',
            hh : '%d siegħat',
            d : 'ġurnata',
            dd : '%d ġranet',
            M : 'xahar',
            MM : '%d xhur',
            y : 'sena',
            yy : '%d sni'
        },
        dayOfMonthOrdinalParse : /\d{1,2}º/,
        ordinal: '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return mt;

})));


/***/ }),
/* 1344 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '၁',
        '2': '၂',
        '3': '၃',
        '4': '၄',
        '5': '၅',
        '6': '၆',
        '7': '၇',
        '8': '၈',
        '9': '၉',
        '0': '၀'
    }, numberMap = {
        '၁': '1',
        '၂': '2',
        '၃': '3',
        '၄': '4',
        '၅': '5',
        '၆': '6',
        '၇': '7',
        '၈': '8',
        '၉': '9',
        '၀': '0'
    };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm'
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L'
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss : '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်'
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return my;

})));


/***/ }),
/* 1345 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nb = moment.defineLocale('nb', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact : true,
        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s siden',
            s : 'noen sekunder',
            ss : '%d sekunder',
            m : 'ett minutt',
            mm : '%d minutter',
            h : 'en time',
            hh : '%d timer',
            d : 'en dag',
            dd : '%d dager',
            M : 'en måned',
            MM : '%d måneder',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nb;

})));


/***/ }),
/* 1346 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '१',
        '2': '२',
        '3': '३',
        '4': '४',
        '5': '५',
        '6': '६',
        '7': '७',
        '8': '८',
        '9': '९',
        '0': '०'
    },
    numberMap = {
        '१': '1',
        '२': '2',
        '३': '3',
        '४': '4',
        '५': '5',
        '६': '6',
        '७': '7',
        '८': '8',
        '९': '9',
        '०': '0'
    };

    var ne = moment.defineLocale('ne', {
        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
        monthsParseExact : true,
        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'Aको h:mm बजे',
            LTS : 'Aको h:mm:ss बजे',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, Aको h:mm बजे',
            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar : {
            sameDay : '[आज] LT',
            nextDay : '[भोलि] LT',
            nextWeek : '[आउँदो] dddd[,] LT',
            lastDay : '[हिजो] LT',
            lastWeek : '[गएको] dddd[,] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sमा',
            past : '%s अगाडि',
            s : 'केही क्षण',
            ss : '%d सेकेण्ड',
            m : 'एक मिनेट',
            mm : '%d मिनेट',
            h : 'एक घण्टा',
            hh : '%d घण्टा',
            d : 'एक दिन',
            dd : '%d दिन',
            M : 'एक महिना',
            MM : '%d महिना',
            y : 'एक बर्ष',
            yy : '%d बर्ष'
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return ne;

})));


/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nlBe;

})));


/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');

    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
    var monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
        monthsShort : function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin : 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD-MM-YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'over %s',
            past : '%s geleden',
            s : 'een paar seconden',
            ss : '%d seconden',
            m : 'één minuut',
            mm : '%d minuten',
            h : 'één uur',
            hh : '%d uur',
            d : 'één dag',
            dd : '%d dagen',
            M : 'één maand',
            MM : '%d maanden',
            y : 'één jaar',
            yy : '%d jaar'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal : function (number) {
            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nl;

})));


/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var nn = moment.defineLocale('nn', {
        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY [kl.] H:mm',
            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
        },
        calendar : {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : '%s sidan',
            s : 'nokre sekund',
            ss : '%d sekund',
            m : 'eit minutt',
            mm : '%d minutt',
            h : 'ein time',
            hh : '%d timar',
            d : 'ein dag',
            dd : '%d dagar',
            M : 'ein månad',
            MM : '%d månader',
            y : 'eit år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return nn;

})));


/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '੧',
        '2': '੨',
        '3': '੩',
        '4': '੪',
        '5': '੫',
        '6': '੬',
        '7': '੭',
        '8': '੮',
        '9': '੯',
        '0': '੦'
    },
    numberMap = {
        '੧': '1',
        '੨': '2',
        '੩': '3',
        '੪': '4',
        '੫': '5',
        '੬': '6',
        '੭': '7',
        '੮': '8',
        '੯': '9',
        '੦': '0'
    };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm ਵਜੇ',
            LTS : 'A h:mm:ss ਵਜੇ',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
        },
        calendar : {
            sameDay : '[ਅਜ] LT',
            nextDay : '[ਕਲ] LT',
            nextWeek : '[ਅਗਲਾ] dddd, LT',
            lastDay : '[ਕਲ] LT',
            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s ਵਿੱਚ',
            past : '%s ਪਿਛਲੇ',
            s : 'ਕੁਝ ਸਕਿੰਟ',
            ss : '%d ਸਕਿੰਟ',
            m : 'ਇਕ ਮਿੰਟ',
            mm : '%d ਮਿੰਟ',
            h : 'ਇੱਕ ਘੰਟਾ',
            hh : '%d ਘੰਟੇ',
            d : 'ਇੱਕ ਦਿਨ',
            dd : '%d ਦਿਨ',
            M : 'ਇੱਕ ਮਹੀਨਾ',
            MM : '%d ਮਹੀਨੇ',
            y : 'ਇੱਕ ਸਾਲ',
            yy : '%d ਸਾਲ'
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return paIn;

})));


/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
    function plural(n) {
        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix  ? 'godzina'  : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months : function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (format === '') {
                // Hack: if format empty we know this is used to generate
                // RegExp by moment. Give then back both valid forms of months
                // in RegExp ready format.
                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : '%s temu',
            s : 'kilka sekund',
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : '1 dzień',
            dd : '%d dni',
            M : 'miesiąc',
            MM : translate,
            y : 'rok',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pl;

})));


/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ptBr = moment.defineLocale('pt-br', {
        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'poucos segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº'
    });

    return ptBr;

})));


/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var pt = moment.defineLocale('pt', {
        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin : 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D [de] MMMM [de] YYYY',
            LLL : 'D [de] MMMM [de] YYYY HH:mm',
            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return (this.day() === 0 || this.day() === 6) ?
                    '[Último] dddd [às] LT' : // Saturday + Sunday
                    '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'em %s',
            past : 'há %s',
            s : 'segundos',
            ss : '%d segundos',
            m : 'um minuto',
            mm : '%d minutos',
            h : 'uma hora',
            hh : '%d horas',
            d : 'um dia',
            dd : '%d dias',
            M : 'um mês',
            MM : '%d meses',
            y : 'um ano',
            yy : '%d anos'
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal : '%dº',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return pt;

})));


/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                'ss': 'secunde',
                'mm': 'minute',
                'hh': 'ore',
                'dd': 'zile',
                'MM': 'luni',
                'yy': 'ani'
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY H:mm',
            LLLL : 'dddd, D MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'peste %s',
            past : '%s în urmă',
            s : 'câteva secunde',
            ss : relativeTimeWithPlural,
            m : 'un minut',
            mm : relativeTimeWithPlural,
            h : 'o oră',
            hh : relativeTimeWithPlural,
            d : 'o zi',
            dd : relativeTimeWithPlural,
            M : 'o lună',
            MM : relativeTimeWithPlural,
            y : 'un an',
            yy : relativeTimeWithPlural
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return ro;

})));


/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            'hh': 'час_часа_часов',
            'dd': 'день_дня_дней',
            'MM': 'месяц_месяца_месяцев',
            'yy': 'год_года_лет'
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months : {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
        },
        monthsShort : {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
        },
        weekdays : {
            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
        },
        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse : monthsParse,
        longMonthsParse : monthsParse,
        shortMonthsParse : monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соотвествует только сокращённым формам
        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY г.',
            LLL : 'D MMMM YYYY г., H:mm',
            LLLL : 'dddd, D MMMM YYYY г., H:mm'
        },
        calendar : {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'через %s',
            past : '%s назад',
            s : 'несколько секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'час',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'месяц',
            MM : relativeTimeWithPlural,
            y : 'год',
            yy : relativeTimeWithPlural
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM : function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ru;

})));


/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوري',
        'فيبروري',
        'مارچ',
        'اپريل',
        'مئي',
        'جون',
        'جولاءِ',
        'آگسٽ',
        'سيپٽمبر',
        'آڪٽوبر',
        'نومبر',
        'ڊسمبر'
    ];
    var days = [
        'آچر',
        'سومر',
        'اڱارو',
        'اربع',
        'خميس',
        'جمع',
        'ڇنڇر'
    ];

    var sd = moment.defineLocale('sd', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[اڄ] LT',
            nextDay : '[سڀاڻي] LT',
            nextWeek : 'dddd [اڳين هفتي تي] LT',
            lastDay : '[ڪالهه] LT',
            lastWeek : '[گزريل هفتي] dddd [تي] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s پوء',
            past : '%s اڳ',
            s : 'چند سيڪنڊ',
            ss : '%d سيڪنڊ',
            m : 'هڪ منٽ',
            mm : '%d منٽ',
            h : 'هڪ ڪلاڪ',
            hh : '%d ڪلاڪ',
            d : 'هڪ ڏينهن',
            dd : '%d ڏينهن',
            M : 'هڪ مهينو',
            MM : '%d مهينا',
            y : 'هڪ سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sd;

})));


/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var se = moment.defineLocale('se', {
        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'MMMM D. [b.] YYYY',
            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
        },
        calendar : {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : '%s geažes',
            past : 'maŋit %s',
            s : 'moadde sekunddat',
            ss: '%d sekunddat',
            m : 'okta minuhta',
            mm : '%d minuhtat',
            h : 'okta diimmu',
            hh : '%d diimmut',
            d : 'okta beaivi',
            dd : '%d beaivvit',
            M : 'okta mánnu',
            MM : '%d mánut',
            y : 'okta jahki',
            yy : '%d jagit'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return se;

})));


/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'a h:mm',
            LTS : 'a h:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY MMMM D',
            LLL : 'YYYY MMMM D, a h:mm',
            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
        },
        calendar : {
            sameDay : '[අද] LT[ට]',
            nextDay : '[හෙට] LT[ට]',
            nextWeek : 'dddd LT[ට]',
            lastDay : '[ඊයේ] LT[ට]',
            lastWeek : '[පසුගිය] dddd LT[ට]',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%sකින්',
            past : '%sකට පෙර',
            s : 'තත්පර කිහිපය',
            ss : 'තත්පර %d',
            m : 'මිනිත්තුව',
            mm : 'මිනිත්තු %d',
            h : 'පැය',
            hh : 'පැය %d',
            d : 'දිනය',
            dd : 'දින %d',
            M : 'මාසය',
            MM : 'මාස %d',
            y : 'වසර',
            yy : 'වසර %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal : function (number) {
            return number + ' වැනි';
        },
        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM : function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        }
    });

    return si;

})));


/***/ }),
/* 1359 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return (n > 1) && (n < 5);
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':  // a few seconds / in a few seconds / a few seconds ago
                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
                break;
            case 'm':  // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
                break;
            case 'h':  // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
                break;
            case 'd':  // a day / in a day / a day ago
                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
                break;
            case 'M':  // a month / in a month / a month ago
                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
                break;
            case 'y':  // a year / in a year / a year ago
                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
                break;
        }
    }

    var sk = moment.defineLocale('sk', {
        months : months,
        monthsShort : monthsShort,
        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat : {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'za %s',
            past : 'pred %s',
            s : translate,
            ss : translate,
            m : translate,
            mm : translate,
            h : translate,
            hh : translate,
            d : translate,
            dd : translate,
            M : translate,
            MM : translate,
            y : translate,
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sk;

})));


/***/ }),
/* 1360 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danes ob] LT',
            nextDay  : '[jutri ob] LT',

            nextWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay  : '[včeraj ob] LT',
            lastWeek : function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'čez %s',
            past   : 'pred %s',
            s      : processRelativeTime,
            ss     : processRelativeTime,
            m      : processRelativeTime,
            mm     : processRelativeTime,
            h      : processRelativeTime,
            hh     : processRelativeTime,
            d      : processRelativeTime,
            dd     : processRelativeTime,
            M      : processRelativeTime,
            MM     : processRelativeTime,
            y      : processRelativeTime,
            yy     : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sl;

})));


/***/ }),
/* 1361 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sq = moment.defineLocale('sq', {
        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact : true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem : function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Sot në] LT',
            nextDay : '[Nesër në] LT',
            nextWeek : 'dddd [në] LT',
            lastDay : '[Dje në] LT',
            lastWeek : 'dddd [e kaluar në] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'në %s',
            past : '%s më parë',
            s : 'disa sekonda',
            ss : '%d sekonda',
            m : 'një minutë',
            mm : '%d minuta',
            h : 'një orë',
            hh : '%d orë',
            d : 'një ditë',
            dd : '%d ditë',
            M : 'një muaj',
            MM : '%d muaj',
            y : 'një vit',
            yy : '%d vite'
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sq;

})));


/***/ }),
/* 1362 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једне минуте'],
            mm: ['минут', 'минуте', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            dd: ['дан', 'дана', 'дана'],
            MM: ['месец', 'месеца', 'месеци'],
            yy: ['година', 'године', 'година']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay  : '[јуче у] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'за %s',
            past   : 'пре %s',
            s      : 'неколико секунди',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'дан',
            dd     : translator.translate,
            M      : 'месец',
            MM     : translator.translate,
            y      : 'годину',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return srCyrl;

})));


/***/ }),
/* 1363 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact : true,
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'pre %s',
            s      : 'nekoliko sekundi',
            ss     : translator.translate,
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sr;

})));


/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ss = moment.defineLocale('ss', {
        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Namuhla nga] LT',
            nextDay : '[Kusasa nga] LT',
            nextWeek : 'dddd [nga] LT',
            lastDay : '[Itolo nga] LT',
            lastWeek : 'dddd [leliphelile] [nga] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'nga %s',
            past : 'wenteka nga %s',
            s : 'emizuzwana lomcane',
            ss : '%d mzuzwana',
            m : 'umzuzu',
            mm : '%d emizuzu',
            h : 'lihora',
            hh : '%d emahora',
            d : 'lilanga',
            dd : '%d emalanga',
            M : 'inyanga',
            MM : '%d tinyanga',
            y : 'umnyaka',
            yy : '%d iminyaka'
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem : function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : '%d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ss;

})));


/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sv = moment.defineLocale('sv', {
        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY-MM-DD',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY [kl.] HH:mm',
            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
            lll : 'D MMM YYYY HH:mm',
            llll : 'ddd D MMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'om %s',
            past : 'för %s sedan',
            s : 'några sekunder',
            ss : '%d sekunder',
            m : 'en minut',
            mm : '%d minuter',
            h : 'en timme',
            hh : '%d timmar',
            d : 'en dag',
            dd : '%d dagar',
            M : 'en månad',
            MM : '%d månader',
            y : 'ett år',
            yy : '%d år'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(e|a)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'e' :
                (b === 1) ? 'a' :
                (b === 2) ? 'a' :
                (b === 3) ? 'e' : 'e';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return sv;

})));


/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var sw = moment.defineLocale('sw', {
        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[leo saa] LT',
            nextDay : '[kesho saa] LT',
            nextWeek : '[wiki ijayo] dddd [saat] LT',
            lastDay : '[jana] LT',
            lastWeek : '[wiki iliyopita] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s baadaye',
            past : 'tokea %s',
            s : 'hivi punde',
            ss : 'sekunde %d',
            m : 'dakika moja',
            mm : 'dakika %d',
            h : 'saa limoja',
            hh : 'masaa %d',
            d : 'siku moja',
            dd : 'masiku %d',
            M : 'mwezi mmoja',
            MM : 'miezi %d',
            y : 'mwaka mmoja',
            yy : 'miaka %d'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return sw;

})));


/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var symbolMap = {
        '1': '௧',
        '2': '௨',
        '3': '௩',
        '4': '௪',
        '5': '௫',
        '6': '௬',
        '7': '௭',
        '8': '௮',
        '9': '௯',
        '0': '௦'
    }, numberMap = {
        '௧': '1',
        '௨': '2',
        '௩': '3',
        '௪': '4',
        '௫': '5',
        '௬': '6',
        '௭': '7',
        '௮': '8',
        '௯': '9',
        '௦': '0'
    };

    var ta = moment.defineLocale('ta', {
        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, HH:mm',
            LLLL : 'dddd, D MMMM YYYY, HH:mm'
        },
        calendar : {
            sameDay : '[இன்று] LT',
            nextDay : '[நாளை] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[நேற்று] LT',
            lastWeek : '[கடந்த வாரம்] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s இல்',
            past : '%s முன்',
            s : 'ஒரு சில விநாடிகள்',
            ss : '%d விநாடிகள்',
            m : 'ஒரு நிமிடம்',
            mm : '%d நிமிடங்கள்',
            h : 'ஒரு மணி நேரம்',
            hh : '%d மணி நேரம்',
            d : 'ஒரு நாள்',
            dd : '%d நாட்கள்',
            M : 'ஒரு மாதம்',
            MM : '%d மாதங்கள்',
            y : 'ஒரு வருடம்',
            yy : '%d ஆண்டுகள்'
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal : function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem : function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை';  // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return ta;

})));


/***/ }),
/* 1368 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var te = moment.defineLocale('te', {
        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
        monthsParseExact : true,
        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat : {
            LT : 'A h:mm',
            LTS : 'A h:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY, A h:mm',
            LLLL : 'dddd, D MMMM YYYY, A h:mm'
        },
        calendar : {
            sameDay : '[నేడు] LT',
            nextDay : '[రేపు] LT',
            nextWeek : 'dddd, LT',
            lastDay : '[నిన్న] LT',
            lastWeek : '[గత] dddd, LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s లో',
            past : '%s క్రితం',
            s : 'కొన్ని క్షణాలు',
            ss : '%d సెకన్లు',
            m : 'ఒక నిమిషం',
            mm : '%d నిమిషాలు',
            h : 'ఒక గంట',
            hh : '%d గంటలు',
            d : 'ఒక రోజు',
            dd : '%d రోజులు',
            M : 'ఒక నెల',
            MM : '%d నెలలు',
            y : 'ఒక సంవత్సరం',
            yy : '%d సంవత్సరాలు'
        },
        dayOfMonthOrdinalParse : /\d{1,2}వ/,
        ordinal : '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week : {
            dow : 0, // Sunday is the first day of the week.
            doy : 6  // The week that contains Jan 6th is the first week of the year.
        }
    });

    return te;

})));


/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tet = moment.defineLocale('tet', {
        months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin : 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'iha %s',
            past : '%s liuba',
            s : 'minutu balun',
            ss : 'minutu %d',
            m : 'minutu ida',
            mm : 'minutu %d',
            h : 'oras ida',
            hh : 'oras %d',
            d : 'loron ida',
            dd : 'loron %d',
            M : 'fulan ida',
            MM : 'fulan %d',
            y : 'tinan ida',
            yy : 'tinan %d'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tet;

})));


/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум'
    };

    var tg = moment.defineLocale('tg', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split('_'),
        weekdaysShort : 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin : 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[Имрӯз соати] LT',
            nextDay : '[Пагоҳ соати] LT',
            lastDay : '[Дирӯз соати] LT',
            nextWeek : 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek : 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'баъди %s',
            past : '%s пеш',
            s : 'якчанд сония',
            m : 'як дақиқа',
            mm : '%d дақиқа',
            h : 'як соат',
            hh : '%d соат',
            d : 'як рӯз',
            dd : '%d рӯз',
            M : 'як моҳ',
            MM : '%d моҳ',
            y : 'як сол',
            yy : '%d сол'
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1th is the first week of the year.
        }
    });

    return tg;

})));


/***/ }),
/* 1371 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var th = moment.defineLocale('th', {
        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
        monthsParseExact: true,
        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY เวลา H:mm',
            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar : {
            sameDay : '[วันนี้ เวลา] LT',
            nextDay : '[พรุ่งนี้ เวลา] LT',
            nextWeek : 'dddd[หน้า เวลา] LT',
            lastDay : '[เมื่อวานนี้ เวลา] LT',
            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'อีก %s',
            past : '%sที่แล้ว',
            s : 'ไม่กี่วินาที',
            ss : '%d วินาที',
            m : '1 นาที',
            mm : '%d นาที',
            h : '1 ชั่วโมง',
            hh : '%d ชั่วโมง',
            d : '1 วัน',
            dd : '%d วัน',
            M : '1 เดือน',
            MM : '%d เดือน',
            y : '1 ปี',
            yy : '%d ปี'
        }
    });

    return th;

})));


/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tlPh = moment.defineLocale('tl-ph', {
        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'MM/D/YYYY',
            LL : 'MMMM D, YYYY',
            LLL : 'MMMM D, YYYY HH:mm',
            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
        },
        calendar : {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'sa loob ng %s',
            past : '%s ang nakalipas',
            s : 'ilang segundo',
            ss : '%d segundo',
            m : 'isang minuto',
            mm : '%d minuto',
            h : 'isang oras',
            hh : '%d oras',
            d : 'isang araw',
            dd : '%d araw',
            M : 'isang buwan',
            MM : '%d buwan',
            y : 'isang taon',
            yy : '%d taon'
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal : function (number) {
            return number;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlPh;

})));


/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'leS' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'waQ' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'nem' :
        time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time = (output.indexOf('jaj') !== -1) ?
        time.slice(0, -3) + 'Hu’' :
        (output.indexOf('jar') !== -1) ?
        time.slice(0, -3) + 'wen' :
        (output.indexOf('DIS') !== -1) ?
        time.slice(0, -3) + 'ben' :
        time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
        ten = Math.floor((number % 100) / 10),
        one = number % 10,
        word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
        }
        return (word === '') ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
        monthsParseExact : true,
        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L'
        },
        relativeTime : {
            future : translateFuture,
            past : translatePast,
            s : 'puS lup',
            ss : translate,
            m : 'wa’ tup',
            mm : translate,
            h : 'wa’ rep',
            hh : translate,
            d : 'wa’ jaj',
            dd : translate,
            M : 'wa’ jar',
            MM : translate,
            y : 'wa’ DIS',
            yy : translate
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return tlh;

})));


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {


;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';

    var suffixes = {
        1: '\'inci',
        5: '\'inci',
        8: '\'inci',
        70: '\'inci',
        80: '\'inci',
        2: '\'nci',
        7: '\'nci',
        20: '\'nci',
        50: '\'nci',
        3: '\'üncü',
        4: '\'üncü',
        100: '\'üncü',
        6: '\'ncı',
        9: '\'uncu',
        10: '\'uncu',
        30: '\'uncu',
        60: '\'ıncı',
        90: '\'ıncı'
    };

    var tr = moment.defineLocale('tr', {
        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[bugün saat] LT',
            nextDay : '[yarın saat] LT',
            nextWeek : '[gelecek] dddd [saat] LT',
            lastDay : '[dün] LT',
            lastWeek : '[geçen] dddd [saat] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s sonra',
            past : '%s önce',
            s : 'birkaç saniye',
            ss : '%d saniye',
            m : 'bir dakika',
            mm : '%d dakika',
            h : 'bir saat',
            hh : '%d saat',
            d : 'bir gün',
            dd : '%d gün',
            M : 'bir ay',
            MM : '%d ay',
            y : 'bir yıl',
            yy : '%d yıl'
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {  // special case for zero
                        return number + '\'ıncı';
                    }
                    var a = number % 10,
                        b = number % 100 - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return tr;

})));


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat : {
            LT : 'HH.mm',
            LTS : 'HH.mm.ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM [dallas] YYYY',
            LLL : 'D. MMMM [dallas] YYYY HH.mm',
            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM : function (input) {
            return 'd\'o' === input.toLowerCase();
        },
        meridiem : function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'd\'o' : 'D\'O';
            } else {
                return isLower ? 'd\'a' : 'D\'A';
            }
        },
        calendar : {
            sameDay : '[oxhi à] LT',
            nextDay : '[demà à] LT',
            nextWeek : 'dddd [à] LT',
            lastDay : '[ieiri à] LT',
            lastWeek : '[sür el] dddd [lasteu à] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'osprei %s',
            past : 'ja%s',
            s : processRelativeTime,
            ss : processRelativeTime,
            m : processRelativeTime,
            mm : processRelativeTime,
            h : processRelativeTime,
            hh : processRelativeTime,
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            's': ['viensas secunds', '\'iensas secunds'],
            'ss': [number + ' secunds', '' + number + ' secunds'],
            'm': ['\'n míut', '\'iens míut'],
            'mm': [number + ' míuts', '' + number + ' míuts'],
            'h': ['\'n þora', '\'iensa þora'],
            'hh': [number + ' þoras', '' + number + ' þoras'],
            'd': ['\'n ziua', '\'iensa ziua'],
            'dd': [number + ' ziuas', '' + number + ' ziuas'],
            'M': ['\'n mes', '\'iens mes'],
            'MM': [number + ' mesen', '' + number + ' mesen'],
            'y': ['\'n ar', '\'iens ar'],
            'yy': [number + ' ars', '' + number + ' ars']
        };
        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
    }

    return tzl;

})));


/***/ }),
/* 1376 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzmLatn = moment.defineLocale('tzm-latn', {
        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'dadkh s yan %s',
            past : 'yan %s',
            s : 'imik',
            ss : '%d imik',
            m : 'minuḍ',
            mm : '%d minuḍ',
            h : 'saɛa',
            hh : '%d tassaɛin',
            d : 'ass',
            dd : '%d ossan',
            M : 'ayowr',
            MM : '%d iyyirn',
            y : 'asgas',
            yy : '%d isgasn'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return tzmLatn;

})));


/***/ }),
/* 1377 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var tzm = moment.defineLocale('tzm', {
        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L'
        },
        relativeTime : {
            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past : 'ⵢⴰⵏ %s',
            s : 'ⵉⵎⵉⴽ',
            ss : '%d ⵉⵎⵉⴽ',
            m : 'ⵎⵉⵏⵓⴺ',
            mm : '%d ⵎⵉⵏⵓⴺ',
            h : 'ⵙⴰⵄⴰ',
            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d : 'ⴰⵙⵙ',
            dd : '%d oⵙⵙⴰⵏ',
            M : 'ⴰⵢoⵓⵔ',
            MM : '%d ⵉⵢⵢⵉⵔⵏ',
            y : 'ⴰⵙⴳⴰⵙ',
            yy : '%d ⵉⵙⴳⴰⵙⵏ'
        },
        week : {
            dow : 6, // Saturday is the first day of the week.
            doy : 12  // The week that contains Jan 12th is the first week of the year.
        }
    });

    return tzm;

})));


/***/ }),
/* 1378 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js language configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm'
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L'
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل'
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7 // The week that contains Jan 1st is the first week of the year.
        }
    });

    return ugCn;

})));


/***/ }),
/* 1379 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            'dd': 'день_дні_днів',
            'MM': 'місяць_місяці_місяців',
            'yy': 'рік_роки_років'
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        }
        else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        }
        else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
        };

        if (m === true) {
            return weekdays['nominative'].slice(1, 7).concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
            'accusative' :
            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
                'genitive' :
                'nominative');
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months : {
            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
        },
        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
        weekdays : weekdaysCaseReplace,
        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D MMMM YYYY р.',
            LLL : 'D MMMM YYYY р., HH:mm',
            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
        },
        calendar : {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L'
        },
        relativeTime : {
            future : 'за %s',
            past : '%s тому',
            s : 'декілька секунд',
            ss : relativeTimeWithPlural,
            m : relativeTimeWithPlural,
            mm : relativeTimeWithPlural,
            h : 'годину',
            hh : relativeTimeWithPlural,
            d : 'день',
            dd : relativeTimeWithPlural,
            M : 'місяць',
            MM : relativeTimeWithPlural,
            y : 'рік',
            yy : relativeTimeWithPlural
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uk;

})));


/***/ }),
/* 1380 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var months = [
        'جنوری',
        'فروری',
        'مارچ',
        'اپریل',
        'مئی',
        'جون',
        'جولائی',
        'اگست',
        'ستمبر',
        'اکتوبر',
        'نومبر',
        'دسمبر'
    ];
    var days = [
        'اتوار',
        'پیر',
        'منگل',
        'بدھ',
        'جمعرات',
        'جمعہ',
        'ہفتہ'
    ];

    var ur = moment.defineLocale('ur', {
        months : months,
        monthsShort : months,
        weekdays : days,
        weekdaysShort : days,
        weekdaysMin : days,
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd، D MMMM YYYY HH:mm'
        },
        meridiemParse: /صبح|شام/,
        isPM : function (input) {
            return 'شام' === input;
        },
        meridiem : function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar : {
            sameDay : '[آج بوقت] LT',
            nextDay : '[کل بوقت] LT',
            nextWeek : 'dddd [بوقت] LT',
            lastDay : '[گذشتہ روز بوقت] LT',
            lastWeek : '[گذشتہ] dddd [بوقت] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : '%s بعد',
            past : '%s قبل',
            s : 'چند سیکنڈ',
            ss : '%d سیکنڈ',
            m : 'ایک منٹ',
            mm : '%d منٹ',
            h : 'ایک گھنٹہ',
            hh : '%d گھنٹے',
            d : 'ایک دن',
            dd : '%d دن',
            M : 'ایک ماہ',
            MM : '%d ماہ',
            y : 'ایک سال',
            yy : '%d سال'
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return ur;

})));


/***/ }),
/* 1381 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uzLatn = moment.defineLocale('uz-latn', {
        months : 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split('_'),
        monthsShort : 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays : 'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split('_'),
        weekdaysShort : 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin : 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Bugun soat] LT [da]',
            nextDay : '[Ertaga] LT [da]',
            nextWeek : 'dddd [kuni soat] LT [da]',
            lastDay : '[Kecha soat] LT [da]',
            lastWeek : '[O\'tgan] dddd [kuni soat] LT [da]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Yaqin %s ichida',
            past : 'Bir necha %s oldin',
            s : 'soniya',
            ss : '%d soniya',
            m : 'bir daqiqa',
            mm : '%d daqiqa',
            h : 'bir soat',
            hh : '%d soat',
            d : 'bir kun',
            dd : '%d kun',
            M : 'bir oy',
            MM : '%d oy',
            y : 'bir yil',
            yy : '%d yil'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 7th is the first week of the year.
        }
    });

    return uzLatn;

})));


/***/ }),
/* 1382 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var uz = moment.defineLocale('uz', {
        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'D MMMM YYYY, dddd HH:mm'
        },
        calendar : {
            sameDay : '[Бугун соат] LT [да]',
            nextDay : '[Эртага] LT [да]',
            nextWeek : 'dddd [куни соат] LT [да]',
            lastDay : '[Кеча соат] LT [да]',
            lastWeek : '[Утган] dddd [куни соат] LT [да]',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'Якин %s ичида',
            past : 'Бир неча %s олдин',
            s : 'фурсат',
            ss : '%d фурсат',
            m : 'бир дакика',
            mm : '%d дакика',
            h : 'бир соат',
            hh : '%d соат',
            d : 'бир кун',
            dd : '%d кун',
            M : 'бир ой',
            MM : '%d ой',
            y : 'бир йил',
            yy : '%d йил'
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return uz;

})));


/***/ }),
/* 1383 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var xPseudo = moment.defineLocale('x-pseudo', {
        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
        monthsParseExact : true,
        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact : true,
        longDateFormat : {
            LT : 'HH:mm',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY HH:mm',
            LLLL : 'dddd, D MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay : '[T~ódá~ý át] LT',
            nextDay : '[T~ómó~rró~w át] LT',
            nextWeek : 'dddd [át] LT',
            lastDay : '[Ý~ést~érdá~ý át] LT',
            lastWeek : '[L~ást] dddd [át] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'í~ñ %s',
            past : '%s á~gó',
            s : 'á ~féw ~sécó~ñds',
            ss : '%d s~écóñ~ds',
            m : 'á ~míñ~úté',
            mm : '%d m~íñú~tés',
            h : 'á~ñ hó~úr',
            hh : '%d h~óúrs',
            d : 'á ~dáý',
            dd : '%d d~áýs',
            M : 'á ~móñ~th',
            MM : '%d m~óñt~hs',
            y : 'á ~ýéár',
            yy : '%d ý~éárs'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        },
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return xPseudo;

})));


/***/ }),
/* 1384 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var yo = moment.defineLocale('yo', {
        months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
        monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat : {
            LT : 'h:mm A',
            LTS : 'h:mm:ss A',
            L : 'DD/MM/YYYY',
            LL : 'D MMMM YYYY',
            LLL : 'D MMMM YYYY h:mm A',
            LLLL : 'dddd, D MMMM YYYY h:mm A'
        },
        calendar : {
            sameDay : '[Ònì ni] LT',
            nextDay : '[Ọ̀la ni] LT',
            nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
            lastDay : '[Àna ni] LT',
            lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse : 'L'
        },
        relativeTime : {
            future : 'ní %s',
            past : '%s kọjá',
            s : 'ìsẹjú aayá die',
            ss :'aayá %d',
            m : 'ìsẹjú kan',
            mm : 'ìsẹjú %d',
            h : 'wákati kan',
            hh : 'wákati %d',
            d : 'ọjọ́ kan',
            dd : 'ọjọ́ %d',
            M : 'osù kan',
            MM : 'osù %d',
            y : 'ọdún kan',
            yy : 'ọdún %d'
        },
        dayOfMonthOrdinalParse : /ọjọ́\s\d{1,2}/,
        ordinal : 'ọjọ́ %d',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4 // The week that contains Jan 4th is the first week of the year.
        }
    });

    return yo;

})));


/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhCn = moment.defineLocale('zh-cn', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日Ah点mm分',
            LLLL : 'YYYY年M月D日ddddAh点mm分',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' ||
                    meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime : {
            future : '%s内',
            past : '%s前',
            s : '几秒',
            ss : '%d 秒',
            m : '1 分钟',
            mm : '%d 分钟',
            h : '1 小时',
            hh : '%d 小时',
            d : '1 天',
            dd : '%d 天',
            M : '1 个月',
            MM : '%d 个月',
            y : '1 年',
            yy : '%d 年'
        },
        week : {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return zhCn;

})));


/***/ }),
/* 1386 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhHk = moment.defineLocale('zh-hk', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天]LT',
            nextDay : '[明天]LT',
            nextWeek : '[下]ddddLT',
            lastDay : '[昨天]LT',
            lastWeek : '[上]ddddLT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhHk;

})));


/***/ }),
/* 1387 */
/***/ (function(module, exports, __webpack_require__) {

//! moment.js locale configuration

;(function (global, factory) {
    true ? factory(__webpack_require__(12)) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


    var zhTw = moment.defineLocale('zh-tw', {
        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
        longDateFormat : {
            LT : 'HH:mm',
            LTS : 'HH:mm:ss',
            L : 'YYYY/MM/DD',
            LL : 'YYYY年M月D日',
            LLL : 'YYYY年M月D日 HH:mm',
            LLLL : 'YYYY年M月D日dddd HH:mm',
            l : 'YYYY/M/D',
            ll : 'YYYY年M月D日',
            lll : 'YYYY年M月D日 HH:mm',
            llll : 'YYYY年M月D日dddd HH:mm'
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour : function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem : function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar : {
            sameDay : '[今天] LT',
            nextDay : '[明天] LT',
            nextWeek : '[下]dddd LT',
            lastDay : '[昨天] LT',
            lastWeek : '[上]dddd LT',
            sameElse : 'L'
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal : function (number, period) {
            switch (period) {
                case 'd' :
                case 'D' :
                case 'DDD' :
                    return number + '日';
                case 'M' :
                    return number + '月';
                case 'w' :
                case 'W' :
                    return number + '週';
                default :
                    return number;
            }
        },
        relativeTime : {
            future : '%s內',
            past : '%s前',
            s : '幾秒',
            ss : '%d 秒',
            m : '1 分鐘',
            mm : '%d 分鐘',
            h : '1 小時',
            hh : '%d 小時',
            d : '1 天',
            dd : '%d 天',
            M : '1 個月',
            MM : '%d 個月',
            y : '1 年',
            yy : '%d 年'
        }
    });

    return zhTw;

})));


/***/ }),
/* 1388 */
/***/ (function(module, exports, __webpack_require__) {

exports.pbkdf2 = __webpack_require__(3122)
exports.pbkdf2Sync = __webpack_require__(1391)


/***/ }),
/* 1389 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {var defaultEncoding
/* istanbul ignore next */
if (process.browser) {
  defaultEncoding = 'utf-8'
} else {
  var pVersionMajor = parseInt(process.version.split('.')[0].slice(1), 10)

  defaultEncoding = pVersionMajor >= 6 ? 'utf-8' : 'binary'
}
module.exports = defaultEncoding

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ }),
/* 1390 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs

function checkBuffer (buf, name) {
  if (typeof buf !== 'string' && !Buffer.isBuffer(buf)) {
    throw new TypeError(name + ' must be a buffer or string')
  }
}

module.exports = function (password, salt, iterations, keylen) {
  checkBuffer(password, 'Password')
  checkBuffer(salt, 'Salt')

  if (typeof iterations !== 'number') {
    throw new TypeError('Iterations not a number')
  }

  if (iterations < 0) {
    throw new TypeError('Bad iterations')
  }

  if (typeof keylen !== 'number') {
    throw new TypeError('Key length not a number')
  }

  if (keylen < 0 || keylen > MAX_ALLOC || keylen !== keylen) { /* eslint no-self-compare: 0 */
    throw new TypeError('Bad key length')
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75).Buffer))

/***/ }),
/* 1391 */
/***/ (function(module, exports, __webpack_require__) {

var md5 = __webpack_require__(1151)
var RIPEMD160 = __webpack_require__(699)
var sha = __webpack_require__(758)

var checkParameters = __webpack_require__(1390)
var defaultEncoding = __webpack_require__(1389)
var Buffer = __webpack_require__(42).Buffer
var ZEROS = Buffer.alloc(128)
var sizes = {
  md5: 16,
  sha1: 20,
  sha224: 28,
  sha256: 32,
  sha384: 48,
  sha512: 64,
  rmd160: 20,
  ripemd160: 20
}

function Hmac (alg, key, saltLen) {
  var hash = getDigest(alg)
  var blocksize = (alg === 'sha512' || alg === 'sha384') ? 128 : 64

  if (key.length > blocksize) {
    key = hash(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = Buffer.allocUnsafe(blocksize + sizes[alg])
  var opad = Buffer.allocUnsafe(blocksize + sizes[alg])
  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  var ipad1 = Buffer.allocUnsafe(blocksize + saltLen + 4)
  ipad.copy(ipad1, 0, 0, blocksize)
  this.ipad1 = ipad1
  this.ipad2 = ipad
  this.opad = opad
  this.alg = alg
  this.blocksize = blocksize
  this.hash = hash
  this.size = sizes[alg]
}

Hmac.prototype.run = function (data, ipad) {
  data.copy(ipad, this.blocksize)
  var h = this.hash(ipad)
  h.copy(this.opad, this.blocksize)
  return this.hash(this.opad)
}

function getDigest (alg) {
  function shaFunc (data) {
    return sha(alg).update(data).digest()
  }
  function rmd160Func (data) {
    return new RIPEMD160().update(data).digest()
  }

  if (alg === 'rmd160' || alg === 'ripemd160') return rmd160Func
  if (alg === 'md5') return md5
  return shaFunc
}

function pbkdf2 (password, salt, iterations, keylen, digest) {
  checkParameters(password, salt, iterations, keylen)

  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  digest = digest || 'sha1'

  var hmac = new Hmac(digest, password, salt.length)

  var DK = Buffer.allocUnsafe(keylen)
  var block1 = Buffer.allocUnsafe(salt.length + 4)
  salt.copy(block1, 0, 0, salt.length)

  var destPos = 0
  var hLen = sizes[digest]
  var l = Math.ceil(keylen / hLen)

  for (var i = 1; i <= l; i++) {
    block1.writeUInt32BE(i, salt.length)

    var T = hmac.run(block1, hmac.ipad1)
    var U = T

    for (var j = 1; j < iterations; j++) {
      U = hmac.run(U, hmac.ipad2)
      for (var k = 0; k < hLen; k++) T[k] ^= U[k]
    }

    T.copy(DK, destPos)
    destPos += hLen
  }

  return DK
}

module.exports = pbkdf2


/***/ }),
/* 1392 */
/***/ (function(module, exports, __webpack_require__) {

var createHash = __webpack_require__(336)
var Buffer = __webpack_require__(42).Buffer

module.exports = function (seed, len) {
  var t = Buffer.alloc(0)
  var i = 0
  var c
  while (t.length < len) {
    c = i2ops(i++)
    t = Buffer.concat([t, createHash('sha1').update(seed).update(c).digest()])
  }
  return t.slice(0, len)
}

function i2ops (c) {
  var out = Buffer.allocUnsafe(4)
  out.writeUInt32BE(c, 0)
  return out
}


/***/ }),
/* 1393 */
/***/ (function(module, exports, __webpack_require__) {

var BN = __webpack_require__(77)
var Buffer = __webpack_require__(42).Buffer

function withPublic (paddedMsg, key) {
  return Buffer.from(paddedMsg
    .toRed(BN.mont(key.modulus))
    .redPow(new BN(key.publicExponent))
    .fromRed()
    .toArray())
}

module.exports = withPublic


/***/ }),
/* 1394 */
/***/ (function(module, exports) {

module.exports = function xor (a, b) {
  var len = a.length
  var i = -1
  while (++i < len) {
    a[i] ^= b[i]
  }
  return a
}


/***/ }),
/* 1395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(683);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? { __proto__: null } : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object' && typeof source !== 'function') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if (
                (options && (options.plainObjects || options.allowPrototypes))
                || !has.call(Object.prototype, source)
            ) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(2597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);







var LazyRenderBox = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(LazyRenderBox, _Component);

  function LazyRenderBox() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, LazyRenderBox);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.hiddenClassName || nextProps.visible;
  };

  LazyRenderBox.prototype.render = function render() {
    var _props = this.props,
        hiddenClassName = _props.hiddenClassName,
        visible = _props.visible,
        props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['hiddenClassName', 'visible']);

    if (hiddenClassName || __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.count(props.children) > 1) {
      if (!visible && hiddenClassName) {
        props.className += ' ' + hiddenClassName;
      }
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement('div', props);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(props.children);
  };

  return LazyRenderBox;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

LazyRenderBox.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};


/* harmony default export */ __webpack_exports__["a"] = (LazyRenderBox);

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAlignFromPlacement;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAlignPopupClassName;
/* harmony export (immutable) */ __webpack_exports__["c"] = saveRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function isPointsEq(a1, a2, isAlignPoint) {
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}

function getAlignFromPlacement(builtinPlacements, placementStr, align) {
  var baseAlign = builtinPlacements[placementStr] || {};
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, baseAlign, align);
}

function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  for (var placement in builtinPlacements) {
    if (builtinPlacements.hasOwnProperty(placement)) {
      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
        return prefixCls + '-placement-' + placement;
      }
    }
  }
  return '';
}

function saveRef(name, component) {
  this[name] = component;
}

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addEventListenerWrap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__ = __webpack_require__(2045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);


function addEventListenerWrap(target, eventType, cb, option) {
  /* eslint camelcase: 2 */
  var callback = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates ? function run(e) {
    __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_batchedUpdates(cb, e);
  } : cb;
  return __WEBPACK_IMPORTED_MODULE_0_add_dom_event_listener___default()(target, eventType, callback, option);
}

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = contains;
function contains(root, n) {
  var node = n;

  while (node) {
    if (node === root) {
      return true;
    }

    node = node.parentNode;
  }

  return false;
}

/***/ }),
/* 1401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CenturyView;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Decades = _interopRequireDefault(__webpack_require__(3159));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function CenturyView(props) {
  function renderDecades() {
    return _react["default"].createElement(_Decades["default"], props);
  }

  return _react["default"].createElement("div", {
    className: "react-calendar__century-view"
  }, renderDecades());
}

/***/ }),
/* 1402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DecadeView;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Years = _interopRequireDefault(__webpack_require__(3161));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function DecadeView(props) {
  function renderYears() {
    return _react["default"].createElement(_Years["default"], props);
  }

  return _react["default"].createElement("div", {
    className: "react-calendar__decade-view"
  }, renderYears());
}

/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MonthView;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _Days = _interopRequireDefault(__webpack_require__(3163));

var _Weekdays = _interopRequireDefault(__webpack_require__(3166));

var _WeekNumbers = _interopRequireDefault(__webpack_require__(3165));

var _propTypes2 = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function MonthView(props) {
  var activeStartDate = props.activeStartDate,
      locale = props.locale,
      onMouseLeave = props.onMouseLeave,
      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;

  var calendarTypeProps = props.calendarType,
      formatShortWeekday = props.formatShortWeekday,
      onClickWeekNumber = props.onClickWeekNumber,
      showWeekNumbers = props.showWeekNumbers,
      childProps = _objectWithoutProperties(props, ["calendarType", "formatShortWeekday", "onClickWeekNumber", "showWeekNumbers"]);

  var calendarType = function () {
    if (calendarTypeProps) {
      return calendarTypeProps;
    }

    switch (locale) {
      case 'en-CA':
      case 'en-US':
      case 'es-AR':
      case 'es-BO':
      case 'es-CL':
      case 'es-CO':
      case 'es-CR':
      case 'es-DO':
      case 'es-EC':
      case 'es-GT':
      case 'es-HN':
      case 'es-MX':
      case 'es-NI':
      case 'es-PA':
      case 'es-PE':
      case 'es-PR':
      case 'es-SV':
      case 'es-VE':
      case 'pt-BR':
        return 'US';
      // ar-LB, ar-MA intentionally missing

      case 'ar':
      case 'ar-AE':
      case 'ar-BH':
      case 'ar-DZ':
      case 'ar-EG':
      case 'ar-IQ':
      case 'ar-JO':
      case 'ar-KW':
      case 'ar-LY':
      case 'ar-OM':
      case 'ar-QA':
      case 'ar-SA':
      case 'ar-SD':
      case 'ar-SY':
      case 'ar-YE':
      case 'dv':
      case 'dv-MV':
      case 'ps':
      case 'ps-AR':
        return 'Arabic';

      case 'he':
      case 'he-IL':
        return 'Hebrew';

      default:
        return 'ISO 8601';
    }
  }();

  function renderWeekdays() {
    return _react["default"].createElement(_Weekdays["default"], {
      calendarType: calendarType,
      formatShortWeekday: formatShortWeekday,
      locale: locale,
      onMouseLeave: onMouseLeave
    });
  }

  function renderWeekNumbers() {
    if (!showWeekNumbers) {
      return null;
    }

    return _react["default"].createElement(_WeekNumbers["default"], {
      activeStartDate: activeStartDate,
      calendarType: calendarType,
      onClickWeekNumber: onClickWeekNumber,
      onMouseLeave: onMouseLeave,
      showFixedNumberOfWeeks: showFixedNumberOfWeeks
    });
  }

  function renderDays() {
    return _react["default"].createElement(_Days["default"], _extends({
      calendarType: calendarType
    }, childProps));
  }

  var className = 'react-calendar__month-view';
  return _react["default"].createElement("div", {
    className: [className, showWeekNumbers ? "".concat(className, "--weekNumbers") : ''].join(' ')
  }, _react["default"].createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'flex-end'
    }
  }, renderWeekNumbers(), _react["default"].createElement("div", {
    style: {
      flexGrow: 1,
      width: '100%'
    }
  }, renderWeekdays(), renderDays())));
}

MonthView.propTypes = {
  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
  calendarType: _propTypes2.isCalendarType,
  formatShortWeekday: _propTypes["default"].func,
  locale: _propTypes["default"].string,
  maxDate: _propTypes2.isMaxDate,
  minDate: _propTypes2.isMinDate,
  onChange: _propTypes["default"].func,
  onClickWeekNumber: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  setActiveRange: _propTypes["default"].func,
  showFixedNumberOfWeeks: _propTypes["default"].bool,
  showNeighboringMonth: _propTypes["default"].bool,
  showWeekNumbers: _propTypes["default"].bool,
  value: _propTypes2.isValue,
  valueType: _propTypes["default"].string
};

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = YearView;

var _react = _interopRequireDefault(__webpack_require__(0));

var _Months = _interopRequireDefault(__webpack_require__(3168));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function YearView(props) {
  function renderMonths() {
    return _react["default"].createElement(_Months["default"], props);
  }

  return _react["default"].createElement("div", {
    className: "react-calendar__year-view"
  }, renderMonths());
}

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Calendar", {
  enumerable: true,
  get: function get() {
    return _Calendar["default"];
  }
});
Object.defineProperty(exports, "CenturyView", {
  enumerable: true,
  get: function get() {
    return _CenturyView["default"];
  }
});
Object.defineProperty(exports, "DecadeView", {
  enumerable: true,
  get: function get() {
    return _DecadeView["default"];
  }
});
Object.defineProperty(exports, "YearView", {
  enumerable: true,
  get: function get() {
    return _YearView["default"];
  }
});
Object.defineProperty(exports, "MonthView", {
  enumerable: true,
  get: function get() {
    return _MonthView["default"];
  }
});
exports["default"] = void 0;

var _Calendar = _interopRequireDefault(__webpack_require__(3156));

var _CenturyView = _interopRequireDefault(__webpack_require__(1401));

var _DecadeView = _interopRequireDefault(__webpack_require__(1402));

var _YearView = _interopRequireDefault(__webpack_require__(1404));

var _MonthView = _interopRequireDefault(__webpack_require__(1403));

__webpack_require__(3505);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// File is created during build phase and placed in dist directory
// eslint-disable-next-line import/no-unresolved
var _default = _Calendar["default"];
exports["default"] = _default;

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getTileClasses = exports.between = exports.doRangesOverlap = exports.isRangeWithinRange = exports.isValueWithinRange = exports.callIfDefined = exports.mergeFunctions = void 0;

var _dates = __webpack_require__(122);

/**
 * Returns a function that, when called, calls all the functions
 * passed to it, applying its arguments to them.
 *
 * @param {Function[]} functions
 */
var mergeFunctions = function mergeFunctions() {
  for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
    functions[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return functions.filter(Boolean).forEach(function (f) {
      return f.apply(void 0, args);
    });
  };
};
/**
 * Calls a function, if it's defined, with specified arguments
 * @param {Function} fn
 * @param {Object} args
 */


exports.mergeFunctions = mergeFunctions;

var callIfDefined = function callIfDefined(fn) {
  if (fn && typeof fn === 'function') {
    for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      args[_key3 - 1] = arguments[_key3];
    }

    fn.apply(void 0, args);
  }
};

exports.callIfDefined = callIfDefined;

var isValueWithinRange = function isValueWithinRange(value, range) {
  return range[0] <= value && range[1] >= value;
};

exports.isValueWithinRange = isValueWithinRange;

var isRangeWithinRange = function isRangeWithinRange(greaterRange, smallerRange) {
  return greaterRange[0] <= smallerRange[0] && greaterRange[1] >= smallerRange[1];
};

exports.isRangeWithinRange = isRangeWithinRange;

var doRangesOverlap = function doRangesOverlap(range1, range2) {
  return isValueWithinRange(range1[0], range2) || isValueWithinRange(range1[1], range2);
};
/**
 * Returns a value no smaller than min and no larger than max.
 *
 * @param {*} value Value to return.
 * @param {*} min Minimum return value.
 * @param {*} max Maximum return value.
 */


exports.doRangesOverlap = doRangesOverlap;

var between = function between(value, min, max) {
  if (min && min > value) {
    return min;
  }

  if (max && max < value) {
    return max;
  }

  return value;
};

exports.between = between;

var getTileClasses = function getTileClasses() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      value = _ref.value,
      valueType = _ref.valueType,
      date = _ref.date,
      dateType = _ref.dateType,
      hover = _ref.hover;

  var className = 'react-calendar__tile';
  var classes = [className];

  if (!date) {
    return classes;
  }

  if (!(date instanceof Array) && !dateType) {
    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
  }

  var now = new Date();
  var dateRange = date instanceof Array ? date : (0, _dates.getRange)(dateType, date);

  if (isValueWithinRange(now, dateRange)) {
    classes.push("".concat(className, "--now"));
  }

  if (!value) {
    return classes;
  }

  if (!(value instanceof Array) && !valueType) {
    throw new Error('getTileClasses(): Unable to get tile activity classes because one or more required arguments were not passed.');
  }

  var valueRange = value instanceof Array ? value : (0, _dates.getRange)(valueType, value);

  if (isRangeWithinRange(valueRange, dateRange)) {
    classes.push("".concat(className, "--active"));
  } else if (doRangesOverlap(valueRange, dateRange)) {
    classes.push("".concat(className, "--hasActive"));
  } else if (hover && ( // Date before value
  dateRange[1] < valueRange[0] && doRangesOverlap(dateRange, [hover, valueRange[0]]) || // Date after value
  dateRange[0] > valueRange[1] && doRangesOverlap(dateRange, [valueRange[1], hover]))) {
    classes.push("".concat(className, "--hover"));
  }

  var isRangeStart = isValueWithinRange(valueRange[0], dateRange);
  var isRangeEnd = isValueWithinRange(valueRange[1], dateRange);

  if (isRangeStart) {
    classes.push("".concat(className, "--rangeStart"));
  }

  if (isRangeEnd) {
    classes.push("".concat(className, "--rangeEnd"));
  }

  if (isRangeStart && isRangeEnd) {
    classes.push("".concat(className, "--rangeBothEnds"));
  }

  return classes;
};

exports.getTileClasses = getTileClasses;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classNames = __webpack_require__(461);

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__(462);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Navbar = function (_Component) {
  _inherits(Navbar, _Component);

  function Navbar() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Navbar);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Navbar.__proto__ || Object.getPrototypeOf(Navbar)).call.apply(_ref, [this].concat(args))), _this), _this.handleNextClick = function () {
      if (_this.props.onNextClick) {
        _this.props.onNextClick();
      }
    }, _this.handlePreviousClick = function () {
      if (_this.props.onPreviousClick) {
        _this.props.onPreviousClick();
      }
    }, _this.handleNextKeyDown = function (e) {
      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handleNextClick();
    }, _this.handlePreviousKeyDown = function (e) {
      if (e.keyCode !== _keys.ENTER && e.keyCode !== _keys.SPACE) {
        return;
      }
      e.preventDefault();
      _this.handlePreviousClick();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Navbar, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.labels !== this.props.labels || nextProps.dir !== this.props.dir || this.props.showPreviousButton !== nextProps.showPreviousButton || this.props.showNextButton !== nextProps.showNextButton;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          className = _props.className,
          showPreviousButton = _props.showPreviousButton,
          showNextButton = _props.showNextButton,
          labels = _props.labels,
          dir = _props.dir;


      var previousClickHandler = void 0;
      var nextClickHandler = void 0;
      var previousKeyDownHandler = void 0;
      var nextKeyDownHandler = void 0;
      var shouldShowPrevious = void 0;
      var shouldShowNext = void 0;

      if (dir === 'rtl') {
        previousClickHandler = this.handleNextClick;
        nextClickHandler = this.handlePreviousClick;
        previousKeyDownHandler = this.handleNextKeyDown;
        nextKeyDownHandler = this.handlePreviousKeyDown;
        shouldShowNext = showPreviousButton;
        shouldShowPrevious = showNextButton;
      } else {
        previousClickHandler = this.handlePreviousClick;
        nextClickHandler = this.handleNextClick;
        previousKeyDownHandler = this.handlePreviousKeyDown;
        nextKeyDownHandler = this.handleNextKeyDown;
        shouldShowNext = showNextButton;
        shouldShowPrevious = showPreviousButton;
      }

      var previousClassName = shouldShowPrevious ? classNames.navButtonPrev : classNames.navButtonPrev + ' ' + classNames.navButtonInteractionDisabled;

      var nextClassName = shouldShowNext ? classNames.navButtonNext : classNames.navButtonNext + ' ' + classNames.navButtonInteractionDisabled;

      var previousButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.previousMonth,
        key: 'previous',
        className: previousClassName,
        onKeyDown: shouldShowPrevious ? previousKeyDownHandler : undefined,
        onClick: shouldShowPrevious ? previousClickHandler : undefined
      });

      var nextButton = _react2.default.createElement('span', {
        tabIndex: '0',
        role: 'button',
        'aria-label': labels.nextMonth,
        key: 'right',
        className: nextClassName,
        onKeyDown: shouldShowNext ? nextKeyDownHandler : undefined,
        onClick: shouldShowNext ? nextClickHandler : undefined
      });

      return _react2.default.createElement(
        'div',
        { className: className || classNames.navBar },
        dir === 'rtl' ? [nextButton, previousButton] : [previousButton, nextButton]
      );
    }
  }]);

  return Navbar;
}(_react.Component);

Navbar.propTypes = {
  classNames: _propTypes2.default.shape({
    navBar: _propTypes2.default.string.isRequired,
    navButtonPrev: _propTypes2.default.string.isRequired,
    navButtonNext: _propTypes2.default.string.isRequired,
    navButtonInteractionDisabled: _propTypes2.default.string.isRequired
  }),
  className: _propTypes2.default.string,
  showPreviousButton: _propTypes2.default.bool,
  showNextButton: _propTypes2.default.bool,
  onPreviousClick: _propTypes2.default.func,
  onNextClick: _propTypes2.default.func,
  dir: _propTypes2.default.string,
  labels: _propTypes2.default.shape({
    previousMonth: _propTypes2.default.string.isRequired,
    nextMonth: _propTypes2.default.string.isRequired
  })
};
Navbar.defaultProps = {
  classNames: _classNames2.default,
  dir: 'ltr',
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  showPreviousButton: true,
  showNextButton: true
};
exports.default = Navbar;
//# sourceMappingURL=Navbar.js.map

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekday = function (_Component) {
  _inherits(Weekday, _Component);

  function Weekday() {
    _classCallCheck(this, Weekday);

    return _possibleConstructorReturn(this, (Weekday.__proto__ || Object.getPrototypeOf(Weekday)).apply(this, arguments));
  }

  _createClass(Weekday, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          weekday = _props.weekday,
          className = _props.className,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          localeUtils = _props.localeUtils,
          locale = _props.locale;

      var title = void 0;
      if (weekdaysLong) {
        title = weekdaysLong[weekday];
      } else {
        title = localeUtils.formatWeekdayLong(weekday, locale);
      }
      var content = void 0;
      if (weekdaysShort) {
        content = weekdaysShort[weekday];
      } else {
        content = localeUtils.formatWeekdayShort(weekday, locale);
      }

      return _react2.default.createElement(
        'div',
        { className: className, role: 'columnheader' },
        _react2.default.createElement(
          'abbr',
          { title: title },
          content
        )
      );
    }
  }]);

  return Weekday;
}(_react.Component);

Weekday.propTypes = {
  weekday: _propTypes2.default.number,
  className: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,

  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string)
};
exports.default = Weekday;
//# sourceMappingURL=Weekday.js.map

/***/ }),
/* 1409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export nodesToString */
/* harmony export (immutable) */ __webpack_exports__["a"] = Trans;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_html_parse_stringify__ = __webpack_require__(3016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_js__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__defaults_js__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__i18nInstance_js__ = __webpack_require__(464);



var _excluded = ["format"],
    _excluded2 = ["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







function hasChildren(node, checkLength) {
  if (!node) return false;
  var base = node.props ? node.props.children : node.children;
  if (checkLength) return base.length > 0;
  return !!base;
}

function getChildren(node) {
  if (!node) return [];
  return node.props ? node.props.children : node.children;
}

function hasValidReactChildren(children) {
  if (Object.prototype.toString.call(children) !== '[object Array]') return false;
  return children.every(function (child) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(child);
  });
}

function getAsArray(data) {
  return Array.isArray(data) ? data : [data];
}

function mergeProps(source, target) {
  var newTarget = _objectSpread({}, target);

  newTarget.props = Object.assign(source.props, target.props);
  return newTarget;
}

function nodesToString(children, i18nOptions) {
  if (!children) return '';
  var stringNode = '';
  var childrenArray = getAsArray(children);
  var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
  childrenArray.forEach(function (child, childIndex) {
    if (typeof child === 'string') {
      stringNode += "".concat(child);
    } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(child)) {
      var childPropsCount = Object.keys(child.props).length;
      var shouldKeepChild = keepArray.indexOf(child.type) > -1;
      var childChildren = child.props.children;

      if (!childChildren && shouldKeepChild && childPropsCount === 0) {
        stringNode += "<".concat(child.type, "/>");
      } else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (child.props.i18nIsDynamicList) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') {
        stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
      } else {
        var content = nodesToString(childChildren, i18nOptions);
        stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
      }
    } else if (child === null) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_js__["f" /* warn */])("Trans: the passed in value is invalid - seems you passed in a null child.");
    } else if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(child) === 'object') {
      var format = child.format,
          clone = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(child, _excluded);

      var keys = Object.keys(clone);

      if (keys.length === 1) {
        var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
        stringNode += "{{".concat(value, "}}");
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_js__["f" /* warn */])("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
      }
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_js__["f" /* warn */])("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    }
  });
  return stringNode;
}

function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
  if (targetString === '') return [];
  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
  if (!children && !emptyChildrenButNeedsHandling) return [targetString];
  var data = {};

  function getData(childs) {
    var childrenArray = getAsArray(childs);
    childrenArray.forEach(function (child) {
      if (typeof child === 'string') return;
      if (hasChildren(child)) getData(getChildren(child));else if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(child) === 'object' && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(child)) Object.assign(data, child);
    });
  }

  getData(children);
  var ast = __WEBPACK_IMPORTED_MODULE_4_html_parse_stringify__["a" /* default */].parse("<0>".concat(targetString, "</0>"));

  var opts = _objectSpread(_objectSpread({}, data), combinedTOpts);

  function renderInner(child, node, rootReactNode) {
    var childs = getChildren(child);
    var mappedChildren = mapAST(childs, node.children, rootReactNode);
    return hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
  }

  function pushTranslatedJSX(child, inner, mem, i, isVoid) {
    if (child.dummy) child.children = inner;
    mem.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(child, _objectSpread(_objectSpread({}, child.props), {}, {
      key: i
    }), isVoid ? undefined : inner));
  }

  function mapAST(reactNode, astNode, rootReactNode) {
    var reactNodes = getAsArray(reactNode);
    var astNodes = getAsArray(astNode);
    return astNodes.reduce(function (mem, node, i) {
      var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);

      if (node.type === 'tag') {
        var tmp = reactNodes[parseInt(node.name, 10)];
        if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
        if (!tmp) tmp = {};
        var child = Object.keys(node.attrs).length !== 0 ? mergeProps({
          props: node.attrs
        }, tmp) : tmp;
        var isElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["isValidElement"])(child);
        var isValidTranslationWithChildren = isElement && hasChildren(node, true) && !node.voidElement;
        var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(child) === 'object' && child.dummy && !isElement;
        var isKnownComponent = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(children) === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);

        if (typeof child === 'string') {
          var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
          mem.push(value);
        } else if (hasChildren(child) || isValidTranslationWithChildren) {
            var inner = renderInner(child, node, rootReactNode);
            pushTranslatedJSX(child, inner, mem, i);
          } else if (isEmptyTransWithHTML) {
          var _inner = mapAST(reactNodes, node.children, rootReactNode);

          mem.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(child, _objectSpread(_objectSpread({}, child.props), {}, {
            key: i
          }), _inner));
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (isKnownComponent) {
            var _inner2 = renderInner(child, node, rootReactNode);

            pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }));
            } else {
              var _inner3 = mapAST(reactNodes, node.children, rootReactNode);

              mem.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }, _inner3));
            }
          } else if (node.voidElement) {
            mem.push("<".concat(node.name, " />"));
          } else {
            var _inner4 = mapAST(reactNodes, node.children, rootReactNode);

            mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
          }
        } else if (__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_typeof___default()(child) === 'object' && !isElement) {
          var content = node.children[0] ? translationContent : null;
          if (content) mem.push(content);
        } else if (node.children.length === 1 && translationContent) {
          mem.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(child, _objectSpread(_objectSpread({}, child.props), {}, {
            key: i
          }), translationContent));
        } else {
          mem.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["cloneElement"])(child, _objectSpread(_objectSpread({}, child.props), {}, {
            key: i
          })));
        }
      } else if (node.type === 'text') {
        var wrapTextNodes = i18nOptions.transWrapTextNodes;

        var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);

        if (wrapTextNodes) {
          mem.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(wrapTextNodes, {
            key: "".concat(node.name, "-").concat(i)
          }, _content));
        } else {
          mem.push(_content);
        }
      }

      return mem;
    }, []);
  }

  var result = mapAST([{
    dummy: true,
    children: children || []
  }], ast, getAsArray(children || []));
  return getChildren(result[0]);
}

function Trans(_ref) {
  var children = _ref.children,
      count = _ref.count,
      parent = _ref.parent,
      i18nKey = _ref.i18nKey,
      context = _ref.context,
      _ref$tOptions = _ref.tOptions,
      tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions,
      values = _ref.values,
      defaults = _ref.defaults,
      components = _ref.components,
      ns = _ref.ns,
      i18nFromProps = _ref.i18n,
      tFromProps = _ref.t,
      shouldUnescape = _ref.shouldUnescape,
      additionalProps = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded2);

  var i18n = i18nFromProps || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__i18nInstance_js__["b" /* getI18n */])();

  if (!i18n) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_js__["b" /* warnOnce */])('You will need to pass in an i18next instance by using i18nextReactModule');
    return children;
  }

  var t = tFromProps || i18n.t.bind(i18n) || function (k) {
    return k;
  };

  if (context) tOptions.context = context;

  var reactI18nextOptions = _objectSpread(_objectSpread({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__defaults_js__["b" /* getDefaults */])()), i18n.options && i18n.options.react);

  var namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  var defaultValue = defaults || nodesToString(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
  var hashTransKey = reactI18nextOptions.hashTransKey;
  var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
  var interpolationOverride = values ? tOptions.interpolation : {
    interpolation: _objectSpread(_objectSpread({}, tOptions.interpolation), {}, {
      prefix: '#$?',
      suffix: '?$#'
    })
  };

  var combinedTOpts = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, tOptions), {}, {
    count: count
  }, values), interpolationOverride), {}, {
    defaultValue: defaultValue,
    ns: namespaces
  });

  var translation = key ? t(key, combinedTOpts) : defaultValue;
  var content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
  var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
  return useAsParent ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(useAsParent, additionalProps, content) : content;
}

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initReactI18next; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaults_js__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__i18nInstance_js__ = __webpack_require__(464);


var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__defaults_js__["a" /* setDefaults */])(instance.options.react);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__i18nInstance_js__["a" /* setI18n */])(instance);
  }
};

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useSSR;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_js__ = __webpack_require__(289);


function useSSR(initialI18nStore, initialLanguage) {
  var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var i18nFromProps = props.i18n;

  var _ref = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_1__context_js__["a" /* I18nContext */]) || {},
      i18nFromContext = _ref.i18n;

  var i18n = i18nFromProps || i18nFromContext || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__context_js__["d" /* getI18n */])();
  if (i18n.options && i18n.options.isClone) return;

  if (initialI18nStore && !i18n.initializedStoreOnce) {
    i18n.services.resourceStore.data = initialI18nStore;
    i18n.options.ns = Object.values(initialI18nStore).reduce(function (mem, lngResources) {
      Object.keys(lngResources).forEach(function (ns) {
        if (mem.indexOf(ns) < 0) mem.push(ns);
      });
      return mem;
    }, i18n.options.ns);
    i18n.initializedStoreOnce = true;
    i18n.isInitialized = true;
  }

  if (initialLanguage && !i18n.initializedLanguageOnce) {
    i18n.changeLanguage(initialLanguage);
    i18n.initializedLanguageOnce = true;
  }
}

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_object_assign__);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Iframe = function (_a) {
    var url = _a.url, allowFullScreen = _a.allowFullScreen, position = _a.position, display = _a.display, height = _a.height, width = _a.width, overflow = _a.overflow, styles = _a.styles, onLoad = _a.onLoad, onMouseOver = _a.onMouseOver, onMouseOut = _a.onMouseOut, scrolling = _a.scrolling, id = _a.id, frameBorder = _a.frameBorder, ariaHidden = _a.ariaHidden, sandbox = _a.sandbox, allow = _a.allow, className = _a.className, title = _a.title, ariaLabel = _a.ariaLabel, ariaLabelledby = _a.ariaLabelledby, name = _a.name, target = _a.target, loading = _a.loading, importance = _a.importance, referrerpolicy = _a.referrerpolicy, allowpaymentrequest = _a.allowpaymentrequest, src = _a.src;
    var defaultProps = __WEBPACK_IMPORTED_MODULE_1_object_assign___default()({
        src: src || url,
        target: target || null,
        style: {
            position: position || null,
            display: display || "block",
            overflow: overflow || null
        },
        scrolling: scrolling || null,
        allowpaymentrequest: allowpaymentrequest || null,
        importance: importance || null,
        sandbox: sandbox || null,
        loading: loading || null,
        styles: styles || null,
        name: name || null,
        className: className || null,
        referrerpolicy: referrerpolicy || null,
        title: title || null,
        allow: allow || null,
        id: id || null,
        "aria-labelledby": ariaLabelledby || null,
        "aria-hidden": ariaHidden || null,
        "aria-label": ariaLabel || null,
        width: width || null,
        height: height || null,
        onLoad: onLoad || null,
        onMouseOver: onMouseOver || null,
        onMouseOut: onMouseOut || null
    });
    var props = Object.create(null);
    for (var _i = 0, _b = Object.keys(defaultProps); _i < _b.length; _i++) {
        var prop = _b[_i];
        if (defaultProps[prop] != null) {
            props[prop] = defaultProps[prop];
        }
    }
    for (var _c = 0, _d = Object.keys(props.style); _c < _d.length; _c++) {
        var i = _d[_c];
        if (props.style[i] == null) {
            delete props.style[i];
        }
    }
    if (allowFullScreen) {
        if ("allow" in props) {
            var currentAllow = props.allow.replace("fullscreen", "");
            props.allow = ("fullscreen " + currentAllow.trim()).trim();
        }
        else {
            props.allow = "fullscreen";
        }
    }
    if (frameBorder >= 0) {
        if (!props.style.hasOwnProperty("border")) {
            props.style.border = frameBorder;
        }
    }
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("iframe", __assign({}, props));
};
/* harmony default export */ __webpack_exports__["default"] = (Iframe);


/***/ }),
/* 1413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return usePopper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__popperjs_core__ = __webpack_require__(2033);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_fast_compare__ = __webpack_require__(3178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_fast_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_fast_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(691);





var EMPTY_MODIFIERS = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"](null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS
  };

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"]({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        __WEBPACK_IMPORTED_MODULE_1_react_dom__["flushSync"](function () {
          setState({
            styles: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* fromEntries */])(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["c" /* fromEntries */])(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (__WEBPACK_IMPORTED_MODULE_3_react_fast_compare___default()(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = __WEBPACK_IMPORTED_MODULE_0_react__["useRef"]();
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* useIsomorphicLayoutEffect */])(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils__["d" /* useIsomorphicLayoutEffect */])(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper = options.createPopper || __WEBPACK_IMPORTED_MODULE_2__popperjs_core__["a" /* createPopper */];
    var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

/***/ }),
/* 1414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _propTypes2["default"].shape({
  subscribe: _propTypes2["default"].func.isRequired,
  dispatch: _propTypes2["default"].func.isRequired,
  getState: _propTypes2["default"].func.isRequired
});

/***/ }),
/* 1415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * This action type will be dispatched by the history actions below.
 * If you're writing a middleware to watch for navigation events, be sure to
 * look for actions of this type.
 */
var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';

function updateLocation(method) {
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return {
      type: CALL_HISTORY_METHOD,
      payload: { method: method, args: args }
    };
  };
}

/**
 * These actions correspond to the history API.
 * The associated routerMiddleware will capture these events before they get to
 * your reducer and reissue them as the matching function on your history.
 */
var push = exports.push = updateLocation('push');
var replace = exports.replace = updateLocation('replace');
var go = exports.go = updateLocation('go');
var goBack = exports.goBack = updateLocation('goBack');
var goForward = exports.goForward = updateLocation('goForward');

var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.routerReducer = routerReducer;
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */
var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';

var initialState = {
  locationBeforeTransitions: null
};

/**
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state is discouraged.
 */
function routerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;

  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      type = _ref.type,
      payload = _ref.payload;

  if (type === LOCATION_CHANGE) {
    return _extends({}, state, { locationBeforeTransitions: payload });
  }

  return state;
}

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PropTypes__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ContextUtils__ = __webpack_require__(693);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }








function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
function isEmptyObject(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
  }return true;
}

function resolveToLocation(to, router) {
  return typeof to === 'function' ? to(router.location) : to;
}

/**
 * A <Link> is used to create an <a> element that links to a route.
 * When that route is active, the link gets the value of its
 * activeClassName prop.
 *
 * For example, assuming you have the following route:
 *
 *   <Route path="/posts/:postID" component={Post} />
 *
 * You could use the following component to link to that route:
 *
 *   <Link to={`/posts/${post.id}`} />
 */
var Link = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'Link',

  mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__ContextUtils__["b" /* ContextSubscriber */])('router')],

  contextTypes: {
    router: __WEBPACK_IMPORTED_MODULE_4__PropTypes__["b" /* routerShape */]
  },

  propTypes: {
    to: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"]]),
    activeStyle: __WEBPACK_IMPORTED_MODULE_2_prop_types__["object"],
    activeClassName: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    onlyActiveOnIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types__["bool"].isRequired,
    onClick: __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"],
    target: __WEBPACK_IMPORTED_MODULE_2_prop_types__["string"],
    innerRef: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_prop_types__["oneOfType"])([__WEBPACK_IMPORTED_MODULE_2_prop_types__["string"], __WEBPACK_IMPORTED_MODULE_2_prop_types__["func"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_prop_types__["shape"])({ current: __WEBPACK_IMPORTED_MODULE_2_prop_types__["elementType"] })])
  },

  getDefaultProps: function getDefaultProps() {
    return {
      onlyActiveOnIndex: false,
      style: {}
    };
  },
  handleClick: function handleClick(event) {
    if (this.props.onClick) this.props.onClick(event);

    if (event.defaultPrevented) return;

    var router = this.context.router;

    !router ?  false ? invariant(false, '<Link>s rendered outside of a router context cannot navigate.') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;

    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;

    // If target prop is set (e.g. to "_blank"), let browser handle link.
    /* istanbul ignore if: untestable with Karma */
    if (this.props.target) return;

    event.preventDefault();

    router.push(resolveToLocation(this.props.to, router));
  },
  render: function render() {
    var _props = this.props,
        to = _props.to,
        activeClassName = _props.activeClassName,
        activeStyle = _props.activeStyle,
        onlyActiveOnIndex = _props.onlyActiveOnIndex,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);

    // Ignore if rendered outside the context of router to simplify unit testing.


    var router = this.context.router;


    if (router) {
      // If user does not specify a `to` prop, return an empty anchor tag.
      if (!to) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { ref: innerRef }));
      }

      var toLocation = resolveToLocation(to, router);
      props.href = router.createHref(toLocation);

      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
        if (router.isActive(toLocation, onlyActiveOnIndex)) {
          if (activeClassName) {
            if (props.className) {
              props.className += ' ' + activeClassName;
            } else {
              props.className = activeClassName;
            }
          }

          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
        }
      }
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PatternUtils__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(352);







/**
 * A <Redirect> is used to declare another URL path a client should
 * be sent to when they request a given URL.
 *
 * Redirects are placed alongside routes in the route configuration
 * and are traversed in the same manner.
 */
/* eslint-disable react/require-render-return */
var Redirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Redirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element) {
      var route = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__RouteUtils__["c" /* createRouteFromReactElement */])(element);

      if (route.from) route.path = route.from;

      route.onEnter = function (nextState, replace) {
        var location = nextState.location,
            params = nextState.params;


        var pathname = void 0;
        if (route.to.charAt(0) === '/') {
          pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(route.to, params);
        } else if (!route.to) {
          pathname = location.pathname;
        } else {
          var routeIndex = nextState.routes.indexOf(route);
          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
          pathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__PatternUtils__["a" /* formatPattern */])(pattern, params);
        }

        replace({
          pathname: pathname,
          query: route.query || location.query,
          state: route.state || location.state
        });
      };

      return route;
    },
    getRoutePattern: function getRoutePattern(routes, routeIndex) {
      var parentPattern = '';

      for (var i = routeIndex; i >= 0; i--) {
        var route = routes[i];
        var pattern = route.path || '';

        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;

        if (pattern.indexOf('/') === 0) break;
      }

      return '/' + parentPattern;
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    from: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"], // Alias for path
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Redirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 1421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterObject;
/* harmony export (immutable) */ __webpack_exports__["b"] = assignRouterState;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function createRouterObject(history, transitionManager, state) {
  var router = _extends({}, history, {
    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
    isActive: transitionManager.isActive
  });

  return assignRouterState(router, state);
}

function assignRouterState(router, _ref) {
  var location = _ref.location,
      params = _ref.params,
      routes = _ref.routes;

  router.location = location;
  router.params = params;
  router.routes = routes;

  return router;
}

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMemoryHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__ = __webpack_require__(3013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory__);




function createMemoryHistory(options) {
  // signatures and type checking differ between `useQueries` and
  // `createMemoryHistory`, have to create `memoryHistory` first because
  // `useQueries` doesn't understand the signature
  var memoryHistory = __WEBPACK_IMPORTED_MODULE_2_history_lib_createMemoryHistory___default()(options);
  var createHistory = function createHistory() {
    return memoryHistory;
  };
  var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
  return history;
}

/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useRouterHistory__ = __webpack_require__(1425);


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

function createRouterHistory(createHistory) {
  var history = void 0;
  if (canUseDOM) history = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__useRouterHistory__["a" /* default */])(createHistory)();
  return history;
}

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTransitionManager;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__routerWarning__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__ = __webpack_require__(3207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TransitionUtils__ = __webpack_require__(3204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isActive__ = __webpack_require__(3211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getComponents__ = __webpack_require__(3208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchRoutes__ = __webpack_require__(3213);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function hasAnyProperties(object) {
  for (var p in object) {
    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
  }return false;
}

function createTransitionManager(history, routes) {
  var state = {};

  var _getTransitionUtils = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__TransitionUtils__["a" /* default */])(),
      runEnterHooks = _getTransitionUtils.runEnterHooks,
      runChangeHooks = _getTransitionUtils.runChangeHooks,
      runLeaveHooks = _getTransitionUtils.runLeaveHooks;

  // Signature should be (location, indexOnly), but needs to support (path,
  // query, indexOnly)


  function isActive(location, indexOnly) {
    location = history.createLocation(location);

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isActive__["a" /* default */])(location, indexOnly, state.location, state.routes, state.params);
  }

  var partialNextState = void 0;

  function match(location, callback) {
    if (partialNextState && partialNextState.location === location) {
      // Continue from where we left off.
      finishMatch(partialNextState, callback);
    } else {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
        if (error) {
          callback(error);
        } else if (nextState) {
          finishMatch(_extends({}, nextState, { location: location }), callback);
        } else {
          callback();
        }
      });
    }
  }

  function finishMatch(nextState, callback) {
    var _computeChangedRoutes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, nextState),
        leaveRoutes = _computeChangedRoutes.leaveRoutes,
        changeRoutes = _computeChangedRoutes.changeRoutes,
        enterRoutes = _computeChangedRoutes.enterRoutes;

    runLeaveHooks(leaveRoutes, state);

    // Tear down confirmation hooks for left routes
    leaveRoutes.filter(function (route) {
      return enterRoutes.indexOf(route) === -1;
    }).forEach(removeListenBeforeHooksForRoute);

    // change and enter hooks are run in series
    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
    });

    function finishEnterHooks(error, redirectInfo) {
      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);

      // TODO: Fetch components after state is updated.
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getComponents__["a" /* default */])(nextState, function (error, components) {
        if (error) {
          callback(error);
        } else {
          // TODO: Make match a pure function and have some other API
          // for "match and update state".
          callback(null, null, state = _extends({}, nextState, { components: components }));
        }
      });
    }

    function handleErrorOrRedirect(error, redirectInfo) {
      if (error) callback(error);else callback(null, redirectInfo);
    }
  }

  var RouteGuid = 1;

  function getRouteID(route) {
    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    return route.__id__ || create && (route.__id__ = RouteGuid++);
  }

  var RouteHooks = Object.create(null);

  function getRouteHooksForRoutes(routes) {
    return routes.map(function (route) {
      return RouteHooks[getRouteID(route)];
    }).filter(function (hook) {
      return hook;
    });
  }

  function transitionHook(location, callback) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__matchRoutes__["a" /* default */])(routes, location, function (error, nextState) {
      if (nextState == null) {
        // TODO: We didn't actually match anything, but hang
        // onto error/nextState so we don't have to matchRoutes
        // again in the listen callback.
        callback();
        return;
      }

      // Cache some state here so we don't have to
      // matchRoutes() again in the listen callback.
      partialNextState = _extends({}, nextState, { location: location });

      var hooks = getRouteHooksForRoutes(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__computeChangedRoutes__["a" /* default */])(state, partialNextState).leaveRoutes);

      var result = void 0;
      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
        // Passing the location arg here indicates to
        // the user that this is a transition hook.
        result = hooks[i](location);
      }

      callback(result);
    });
  }

  /* istanbul ignore next: untestable with Karma */
  function beforeUnloadHook() {
    // Synchronously check to see if any route hooks want
    // to prevent the current window/tab from closing.
    if (state.routes) {
      var hooks = getRouteHooksForRoutes(state.routes);

      var message = void 0;
      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
        // Passing no args indicates to the user that this is a
        // beforeunload hook. We don't know the next location.
        message = hooks[i]();
      }

      return message;
    }
  }

  var unlistenBefore = void 0,
      unlistenBeforeUnload = void 0;

  function removeListenBeforeHooksForRoute(route) {
    var routeID = getRouteID(route);
    if (!routeID) {
      return;
    }

    delete RouteHooks[routeID];

    if (!hasAnyProperties(RouteHooks)) {
      // teardown transition & beforeunload hooks
      if (unlistenBefore) {
        unlistenBefore();
        unlistenBefore = null;
      }

      if (unlistenBeforeUnload) {
        unlistenBeforeUnload();
        unlistenBeforeUnload = null;
      }
    }
  }

  /**
   * Registers the given hook function to run before leaving the given route.
   *
   * During a normal transition, the hook function receives the next location
   * as its only argument and can return either a prompt message (string) to show the user,
   * to make sure they want to leave the page; or `false`, to prevent the transition.
   * Any other return value will have no effect.
   *
   * During the beforeunload event (in browsers) the hook receives no arguments.
   * In this case it must return a prompt message to prevent the transition.
   *
   * Returns a function that may be used to unbind the listener.
   */
  function listenBeforeLeavingRoute(route, hook) {
    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
    var routeID = getRouteID(route, true);

    RouteHooks[routeID] = hook;

    if (thereWereNoRouteHooks) {
      // setup transition & beforeunload hooks
      unlistenBefore = history.listenBefore(transitionHook);

      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
    }

    return function () {
      removeListenBeforeHooksForRoute(route);
    };
  }

  /**
   * This is the API for stateful environments. As the location
   * changes, we update state and call the listener. We can also
   * gracefully handle errors and redirects.
   */
  function listen(listener) {
    function historyListener(location) {
      if (state.location === location) {
        listener(null, state);
      } else {
        match(location, function (error, redirectLocation, nextState) {
          if (error) {
            listener(error);
          } else if (redirectLocation) {
            history.replace(redirectLocation);
          } else if (nextState) {
            listener(null, nextState);
          } else {
             false ? warning(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
          }
        });
      }
    }

    // TODO: Only use a single history listener. Otherwise we'll end up with
    // multiple concurrent calls to match.

    // Set up the history listener first in case the initial match redirects.
    var unsubscribe = history.listen(historyListener);

    if (state.location) {
      // Picking up on a matchContext.
      listener(null, state);
    } else {
      historyListener(history.getCurrentLocation());
    }

    return unsubscribe;
  }

  return {
    isActive: isActive,
    match: match,
    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
    listen: listen
  };
}

/***/ }),
/* 1425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useRouterHistory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__ = __webpack_require__(1243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename__);



function useRouterHistory(createHistory) {
  return function (options) {
    var history = __WEBPACK_IMPORTED_MODULE_0_history_lib_useQueries___default()(__WEBPACK_IMPORTED_MODULE_1_history_lib_useBasename___default()(createHistory))(options);
    return history;
  };
}

/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var pna = __webpack_require__(455);
/*</replacement>*/

module.exports = Readable;

/*<replacement>*/
var isArray = __webpack_require__(1246);
/*</replacement>*/

/*<replacement>*/
var Duplex;
/*</replacement>*/

Readable.ReadableState = ReadableState;

/*<replacement>*/
var EE = __webpack_require__(680).EventEmitter;

var EElistenerCount = function (emitter, type) {
  return emitter.listeners(type).length;
};
/*</replacement>*/

/*<replacement>*/
var Stream = __webpack_require__(1429);
/*</replacement>*/

/*<replacement>*/

var Buffer = __webpack_require__(42).Buffer;
var OurUint8Array = global.Uint8Array || function () {};
function _uint8ArrayToBuffer(chunk) {
  return Buffer.from(chunk);
}
function _isUint8Array(obj) {
  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
}

/*</replacement>*/

/*<replacement>*/
var util = __webpack_require__(335);
util.inherits = __webpack_require__(41);
/*</replacement>*/

/*<replacement>*/
var debugUtil = __webpack_require__(3563);
var debug = void 0;
if (debugUtil && debugUtil.debuglog) {
  debug = debugUtil.debuglog('stream');
} else {
  debug = function () {};
}
/*</replacement>*/

var BufferList = __webpack_require__(3220);
var destroyImpl = __webpack_require__(1428);
var StringDecoder;

util.inherits(Readable, Stream);

var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];

function prependListener(emitter, event, fn) {
  // Sadly this is not cacheable as some libraries bundle their own
  // event emitter implementation with them.
  if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);

  // This is a hack to make sure that our error handler is attached before any
  // userland ones.  NEVER DO THIS. This is here only because this code needs
  // to continue to work with older versions of Node.js that do not include
  // the prependListener() method. The goal is to eventually remove this hack.
  if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
}

function ReadableState(options, stream) {
  Duplex = Duplex || __webpack_require__(248);

  options = options || {};

  // Duplex streams are both readable and writable, but share
  // the same options object.
  // However, some cases require setting options to different
  // values for the readable and the writable sides of the duplex stream.
  // These options can be provided separately as readableXXX and writableXXX.
  var isDuplex = stream instanceof Duplex;

  // object stream flag. Used to make read(n) ignore n and to
  // make all the buffer merging and length checks go away
  this.objectMode = !!options.objectMode;

  if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;

  // the point at which it stops calling _read() to fill the buffer
  // Note: 0 is a valid value, means "don't call _read preemptively ever"
  var hwm = options.highWaterMark;
  var readableHwm = options.readableHighWaterMark;
  var defaultHwm = this.objectMode ? 16 : 16 * 1024;

  if (hwm || hwm === 0) this.highWaterMark = hwm;else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;else this.highWaterMark = defaultHwm;

  // cast to ints.
  this.highWaterMark = Math.floor(this.highWaterMark);

  // A linked list is used to store data chunks instead of an array because the
  // linked list can remove elements from the beginning faster than
  // array.shift()
  this.buffer = new BufferList();
  this.length = 0;
  this.pipes = null;
  this.pipesCount = 0;
  this.flowing = null;
  this.ended = false;
  this.endEmitted = false;
  this.reading = false;

  // a flag to be able to tell if the event 'readable'/'data' is emitted
  // immediately, or on a later tick.  We set this to true at first, because
  // any actions that shouldn't happen until "later" should generally also
  // not happen before the first read call.
  this.sync = true;

  // whenever we return null, then we set a flag to say
  // that we're awaiting a 'readable' event emission.
  this.needReadable = false;
  this.emittedReadable = false;
  this.readableListening = false;
  this.resumeScheduled = false;

  // has it been destroyed
  this.destroyed = false;

  // Crypto is kind of old and crusty.  Historically, its default string
  // encoding is 'binary' so we have to make this configurable.
  // Everything else in the universe uses 'utf8', though.
  this.defaultEncoding = options.defaultEncoding || 'utf8';

  // the number of writers that are awaiting a drain event in .pipe()s
  this.awaitDrain = 0;

  // if true, a maybeReadMore has been scheduled
  this.readingMore = false;

  this.decoder = null;
  this.encoding = null;
  if (options.encoding) {
    if (!StringDecoder) StringDecoder = __webpack_require__(760).StringDecoder;
    this.decoder = new StringDecoder(options.encoding);
    this.encoding = options.encoding;
  }
}

function Readable(options) {
  Duplex = Duplex || __webpack_require__(248);

  if (!(this instanceof Readable)) return new Readable(options);

  this._readableState = new ReadableState(options, this);

  // legacy
  this.readable = true;

  if (options) {
    if (typeof options.read === 'function') this._read = options.read;

    if (typeof options.destroy === 'function') this._destroy = options.destroy;
  }

  Stream.call(this);
}

Object.defineProperty(Readable.prototype, 'destroyed', {
  get: function () {
    if (this._readableState === undefined) {
      return false;
    }
    return this._readableState.destroyed;
  },
  set: function (value) {
    // we ignore the value if the stream
    // has not been initialized yet
    if (!this._readableState) {
      return;
    }

    // backward compatibility, the user is explicitly
    // managing destroyed
    this._readableState.destroyed = value;
  }
});

Readable.prototype.destroy = destroyImpl.destroy;
Readable.prototype._undestroy = destroyImpl.undestroy;
Readable.prototype._destroy = function (err, cb) {
  this.push(null);
  cb(err);
};

// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
Readable.prototype.push = function (chunk, encoding) {
  var state = this._readableState;
  var skipChunkCheck;

  if (!state.objectMode) {
    if (typeof chunk === 'string') {
      encoding = encoding || state.defaultEncoding;
      if (encoding !== state.encoding) {
        chunk = Buffer.from(chunk, encoding);
        encoding = '';
      }
      skipChunkCheck = true;
    }
  } else {
    skipChunkCheck = true;
  }

  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};

// Unshift should *always* be something directly out of read()
Readable.prototype.unshift = function (chunk) {
  return readableAddChunk(this, chunk, null, true, false);
};

function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
  var state = stream._readableState;
  if (chunk === null) {
    state.reading = false;
    onEofChunk(stream, state);
  } else {
    var er;
    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
    if (er) {
      stream.emit('error', er);
    } else if (state.objectMode || chunk && chunk.length > 0) {
      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
        chunk = _uint8ArrayToBuffer(chunk);
      }

      if (addToFront) {
        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
      } else if (state.ended) {
        stream.emit('error', new Error('stream.push() after EOF'));
      } else {
        state.reading = false;
        if (state.decoder && !encoding) {
          chunk = state.decoder.write(chunk);
          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
        } else {
          addChunk(stream, state, chunk, false);
        }
      }
    } else if (!addToFront) {
      state.reading = false;
    }
  }

  return needMoreData(state);
}

function addChunk(stream, state, chunk, addToFront) {
  if (state.flowing && state.length === 0 && !state.sync) {
    stream.emit('data', chunk);
    stream.read(0);
  } else {
    // update the buffer info.
    state.length += state.objectMode ? 1 : chunk.length;
    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);

    if (state.needReadable) emitReadable(stream);
  }
  maybeReadMore(stream, state);
}

function chunkInvalid(state, chunk) {
  var er;
  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
    er = new TypeError('Invalid non-string/buffer chunk');
  }
  return er;
}

// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function needMoreData(state) {
  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}

Readable.prototype.isPaused = function () {
  return this._readableState.flowing === false;
};

// backwards compatibility.
Readable.prototype.setEncoding = function (enc) {
  if (!StringDecoder) StringDecoder = __webpack_require__(760).StringDecoder;
  this._readableState.decoder = new StringDecoder(enc);
  this._readableState.encoding = enc;
  return this;
};

// Don't raise the hwm > 8MB
var MAX_HWM = 0x800000;
function computeNewHighWaterMark(n) {
  if (n >= MAX_HWM) {
    n = MAX_HWM;
  } else {
    // Get the next highest power of 2 to prevent increasing hwm excessively in
    // tiny amounts
    n--;
    n |= n >>> 1;
    n |= n >>> 2;
    n |= n >>> 4;
    n |= n >>> 8;
    n |= n >>> 16;
    n++;
  }
  return n;
}

// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function howMuchToRead(n, state) {
  if (n <= 0 || state.length === 0 && state.ended) return 0;
  if (state.objectMode) return 1;
  if (n !== n) {
    // Only flow one buffer at a time
    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
  }
  // If we're asking for more than the current hwm, then raise the hwm.
  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
  if (n <= state.length) return n;
  // Don't have enough
  if (!state.ended) {
    state.needReadable = true;
    return 0;
  }
  return state.length;
}

// you can override either this method, or the async _read(n) below.
Readable.prototype.read = function (n) {
  debug('read', n);
  n = parseInt(n, 10);
  var state = this._readableState;
  var nOrig = n;

  if (n !== 0) state.emittedReadable = false;

  // if we're doing read(0) to trigger a readable event, but we
  // already have a bunch of data in the buffer, then just trigger
  // the 'readable' event and move on.
  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
    debug('read: emitReadable', state.length, state.ended);
    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
    return null;
  }

  n = howMuchToRead(n, state);

  // if we've ended, and we're now clear, then finish it up.
  if (n === 0 && state.ended) {
    if (state.length === 0) endReadable(this);
    return null;
  }

  // All the actual chunk generation logic needs to be
  // *below* the call to _read.  The reason is that in certain
  // synthetic stream cases, such as passthrough streams, _read
  // may be a completely synchronous operation which may change
  // the state of the read buffer, providing enough data when
  // before there was *not* enough.
  //
  // So, the steps are:
  // 1. Figure out what the state of things will be after we do
  // a read from the buffer.
  //
  // 2. If that resulting state will trigger a _read, then call _read.
  // Note that this may be asynchronous, or synchronous.  Yes, it is
  // deeply ugly to write APIs this way, but that still doesn't mean
  // that the Readable class should behave improperly, as streams are
  // designed to be sync/async agnostic.
  // Take note if the _read call is sync or async (ie, if the read call
  // has returned yet), so that we know whether or not it's safe to emit
  // 'readable' etc.
  //
  // 3. Actually pull the requested chunks out of the buffer and return.

  // if we need a readable event, then we need to do some reading.
  var doRead = state.needReadable;
  debug('need readable', doRead);

  // if we currently have less than the highWaterMark, then also read some
  if (state.length === 0 || state.length - n < state.highWaterMark) {
    doRead = true;
    debug('length less than watermark', doRead);
  }

  // however, if we've ended, then there's no point, and if we're already
  // reading, then it's unnecessary.
  if (state.ended || state.reading) {
    doRead = false;
    debug('reading or ended', doRead);
  } else if (doRead) {
    debug('do read');
    state.reading = true;
    state.sync = true;
    // if the length is currently zero, then we *need* a readable event.
    if (state.length === 0) state.needReadable = true;
    // call internal read method
    this._read(state.highWaterMark);
    state.sync = false;
    // If _read pushed data synchronously, then `reading` will be false,
    // and we need to re-evaluate how much data we can return to the user.
    if (!state.reading) n = howMuchToRead(nOrig, state);
  }

  var ret;
  if (n > 0) ret = fromList(n, state);else ret = null;

  if (ret === null) {
    state.needReadable = true;
    n = 0;
  } else {
    state.length -= n;
  }

  if (state.length === 0) {
    // If we have nothing in the buffer, then we want to know
    // as soon as we *do* get something into the buffer.
    if (!state.ended) state.needReadable = true;

    // If we tried to read() past the EOF, then emit end on the next tick.
    if (nOrig !== n && state.ended) endReadable(this);
  }

  if (ret !== null) this.emit('data', ret);

  return ret;
};

function onEofChunk(stream, state) {
  if (state.ended) return;
  if (state.decoder) {
    var chunk = state.decoder.end();
    if (chunk && chunk.length) {
      state.buffer.push(chunk);
      state.length += state.objectMode ? 1 : chunk.length;
    }
  }
  state.ended = true;

  // emit 'readable' now to make sure it gets picked up.
  emitReadable(stream);
}

// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function emitReadable(stream) {
  var state = stream._readableState;
  state.needReadable = false;
  if (!state.emittedReadable) {
    debug('emitReadable', state.flowing);
    state.emittedReadable = true;
    if (state.sync) pna.nextTick(emitReadable_, stream);else emitReadable_(stream);
  }
}

function emitReadable_(stream) {
  debug('emit readable');
  stream.emit('readable');
  flow(stream);
}

// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function maybeReadMore(stream, state) {
  if (!state.readingMore) {
    state.readingMore = true;
    pna.nextTick(maybeReadMore_, stream, state);
  }
}

function maybeReadMore_(stream, state) {
  var len = state.length;
  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
    debug('maybeReadMore read 0');
    stream.read(0);
    if (len === state.length)
      // didn't get any data, stop spinning.
      break;else len = state.length;
  }
  state.readingMore = false;
}

// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
Readable.prototype._read = function (n) {
  this.emit('error', new Error('_read() is not implemented'));
};

Readable.prototype.pipe = function (dest, pipeOpts) {
  var src = this;
  var state = this._readableState;

  switch (state.pipesCount) {
    case 0:
      state.pipes = dest;
      break;
    case 1:
      state.pipes = [state.pipes, dest];
      break;
    default:
      state.pipes.push(dest);
      break;
  }
  state.pipesCount += 1;
  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);

  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;

  var endFn = doEnd ? onend : unpipe;
  if (state.endEmitted) pna.nextTick(endFn);else src.once('end', endFn);

  dest.on('unpipe', onunpipe);
  function onunpipe(readable, unpipeInfo) {
    debug('onunpipe');
    if (readable === src) {
      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
        unpipeInfo.hasUnpiped = true;
        cleanup();
      }
    }
  }

  function onend() {
    debug('onend');
    dest.end();
  }

  // when the dest drains, it reduces the awaitDrain counter
  // on the source.  This would be more elegant with a .once()
  // handler in flow(), but adding and removing repeatedly is
  // too slow.
  var ondrain = pipeOnDrain(src);
  dest.on('drain', ondrain);

  var cleanedUp = false;
  function cleanup() {
    debug('cleanup');
    // cleanup event handlers once the pipe is broken
    dest.removeListener('close', onclose);
    dest.removeListener('finish', onfinish);
    dest.removeListener('drain', ondrain);
    dest.removeListener('error', onerror);
    dest.removeListener('unpipe', onunpipe);
    src.removeListener('end', onend);
    src.removeListener('end', unpipe);
    src.removeListener('data', ondata);

    cleanedUp = true;

    // if the reader is waiting for a drain event from this
    // specific writer, then it would cause it to never start
    // flowing again.
    // So, if this is awaiting a drain, then we just call it now.
    // If we don't know, then assume that we are waiting for one.
    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
  }

  // If the user pushes more data while we're writing to dest then we'll end up
  // in ondata again. However, we only want to increase awaitDrain once because
  // dest will only emit one 'drain' event for the multiple writes.
  // => Introduce a guard on increasing awaitDrain.
  var increasedAwaitDrain = false;
  src.on('data', ondata);
  function ondata(chunk) {
    debug('ondata');
    increasedAwaitDrain = false;
    var ret = dest.write(chunk);
    if (false === ret && !increasedAwaitDrain) {
      // If the user unpiped during `dest.write()`, it is possible
      // to get stuck in a permanently paused state if that write
      // also returned false.
      // => Check whether `dest` is still a piping destination.
      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
        debug('false write response, pause', src._readableState.awaitDrain);
        src._readableState.awaitDrain++;
        increasedAwaitDrain = true;
      }
      src.pause();
    }
  }

  // if the dest has an error, then stop piping into it.
  // however, don't suppress the throwing behavior for this.
  function onerror(er) {
    debug('onerror', er);
    unpipe();
    dest.removeListener('error', onerror);
    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
  }

  // Make sure our error handler is attached before userland ones.
  prependListener(dest, 'error', onerror);

  // Both close and finish should trigger unpipe, but only once.
  function onclose() {
    dest.removeListener('finish', onfinish);
    unpipe();
  }
  dest.once('close', onclose);
  function onfinish() {
    debug('onfinish');
    dest.removeListener('close', onclose);
    unpipe();
  }
  dest.once('finish', onfinish);

  function unpipe() {
    debug('unpipe');
    src.unpipe(dest);
  }

  // tell the dest that it's being piped to
  dest.emit('pipe', src);

  // start the flow if it hasn't been started already.
  if (!state.flowing) {
    debug('pipe resume');
    src.resume();
  }

  return dest;
};

function pipeOnDrain(src) {
  return function () {
    var state = src._readableState;
    debug('pipeOnDrain', state.awaitDrain);
    if (state.awaitDrain) state.awaitDrain--;
    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
      state.flowing = true;
      flow(src);
    }
  };
}

Readable.prototype.unpipe = function (dest) {
  var state = this._readableState;
  var unpipeInfo = { hasUnpiped: false };

  // if we're not piping anywhere, then do nothing.
  if (state.pipesCount === 0) return this;

  // just one destination.  most common case.
  if (state.pipesCount === 1) {
    // passed in one, but it's not the right one.
    if (dest && dest !== state.pipes) return this;

    if (!dest) dest = state.pipes;

    // got a match.
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;
    if (dest) dest.emit('unpipe', this, unpipeInfo);
    return this;
  }

  // slow case. multiple pipe destinations.

  if (!dest) {
    // remove all.
    var dests = state.pipes;
    var len = state.pipesCount;
    state.pipes = null;
    state.pipesCount = 0;
    state.flowing = false;

    for (var i = 0; i < len; i++) {
      dests[i].emit('unpipe', this, unpipeInfo);
    }return this;
  }

  // try to find the right one.
  var index = indexOf(state.pipes, dest);
  if (index === -1) return this;

  state.pipes.splice(index, 1);
  state.pipesCount -= 1;
  if (state.pipesCount === 1) state.pipes = state.pipes[0];

  dest.emit('unpipe', this, unpipeInfo);

  return this;
};

// set up data events if they are asked for
// Ensure readable listeners eventually get something
Readable.prototype.on = function (ev, fn) {
  var res = Stream.prototype.on.call(this, ev, fn);

  if (ev === 'data') {
    // Start flowing on next tick if stream isn't explicitly paused
    if (this._readableState.flowing !== false) this.resume();
  } else if (ev === 'readable') {
    var state = this._readableState;
    if (!state.endEmitted && !state.readableListening) {
      state.readableListening = state.needReadable = true;
      state.emittedReadable = false;
      if (!state.reading) {
        pna.nextTick(nReadingNextTick, this);
      } else if (state.length) {
        emitReadable(this);
      }
    }
  }

  return res;
};
Readable.prototype.addListener = Readable.prototype.on;

function nReadingNextTick(self) {
  debug('readable nexttick read 0');
  self.read(0);
}

// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
Readable.prototype.resume = function () {
  var state = this._readableState;
  if (!state.flowing) {
    debug('resume');
    state.flowing = true;
    resume(this, state);
  }
  return this;
};

function resume(stream, state) {
  if (!state.resumeScheduled) {
    state.resumeScheduled = true;
    pna.nextTick(resume_, stream, state);
  }
}

function resume_(stream, state) {
  if (!state.reading) {
    debug('resume read 0');
    stream.read(0);
  }

  state.resumeScheduled = false;
  state.awaitDrain = 0;
  stream.emit('resume');
  flow(stream);
  if (state.flowing && !state.reading) stream.read(0);
}

Readable.prototype.pause = function () {
  debug('call pause flowing=%j', this._readableState.flowing);
  if (false !== this._readableState.flowing) {
    debug('pause');
    this._readableState.flowing = false;
    this.emit('pause');
  }
  return this;
};

function flow(stream) {
  var state = stream._readableState;
  debug('flow', state.flowing);
  while (state.flowing && stream.read() !== null) {}
}

// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
Readable.prototype.wrap = function (stream) {
  var _this = this;

  var state = this._readableState;
  var paused = false;

  stream.on('end', function () {
    debug('wrapped end');
    if (state.decoder && !state.ended) {
      var chunk = state.decoder.end();
      if (chunk && chunk.length) _this.push(chunk);
    }

    _this.push(null);
  });

  stream.on('data', function (chunk) {
    debug('wrapped data');
    if (state.decoder) chunk = state.decoder.write(chunk);

    // don't skip over falsy values in objectMode
    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;

    var ret = _this.push(chunk);
    if (!ret) {
      paused = true;
      stream.pause();
    }
  });

  // proxy all the other methods.
  // important when wrapping filters and duplexes.
  for (var i in stream) {
    if (this[i] === undefined && typeof stream[i] === 'function') {
      this[i] = function (method) {
        return function () {
          return stream[method].apply(stream, arguments);
        };
      }(i);
    }
  }

  // proxy certain important events.
  for (var n = 0; n < kProxyEvents.length; n++) {
    stream.on(kProxyEvents[n], this.emit.bind(this, kProxyEvents[n]));
  }

  // when we try to consume some more bytes, simply unpause the
  // underlying stream.
  this._read = function (n) {
    debug('wrapped _read', n);
    if (paused) {
      paused = false;
      stream.resume();
    }
  };

  return this;
};

Object.defineProperty(Readable.prototype, 'readableHighWaterMark', {
  // making it explicit this property is not enumerable
  // because otherwise some prototype manipulation in
  // userland will fail
  enumerable: false,
  get: function () {
    return this._readableState.highWaterMark;
  }
});

// exposed for testing purposes only.
Readable._fromList = fromList;

// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromList(n, state) {
  // nothing buffered
  if (state.length === 0) return null;

  var ret;
  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
    // read it all, truncate the list
    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
    state.buffer.clear();
  } else {
    // read part of list
    ret = fromListPartial(n, state.buffer, state.decoder);
  }

  return ret;
}

// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function fromListPartial(n, list, hasStrings) {
  var ret;
  if (n < list.head.data.length) {
    // slice is the same for buffers and strings
    ret = list.head.data.slice(0, n);
    list.head.data = list.head.data.slice(n);
  } else if (n === list.head.data.length) {
    // first chunk is a perfect match
    ret = list.shift();
  } else {
    // result spans more than one buffer
    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
  }
  return ret;
}

// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBufferString(n, list) {
  var p = list.head;
  var c = 1;
  var ret = p.data;
  n -= ret.length;
  while (p = p.next) {
    var str = p.data;
    var nb = n > str.length ? str.length : n;
    if (nb === str.length) ret += str;else ret += str.slice(0, n);
    n -= nb;
    if (n === 0) {
      if (nb === str.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = str.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function copyFromBuffer(n, list) {
  var ret = Buffer.allocUnsafe(n);
  var p = list.head;
  var c = 1;
  p.data.copy(ret);
  n -= p.data.length;
  while (p = p.next) {
    var buf = p.data;
    var nb = n > buf.length ? buf.length : n;
    buf.copy(ret, ret.length - n, 0, nb);
    n -= nb;
    if (n === 0) {
      if (nb === buf.length) {
        ++c;
        if (p.next) list.head = p.next;else list.head = list.tail = null;
      } else {
        list.head = p;
        p.data = buf.slice(nb);
      }
      break;
    }
    ++c;
  }
  list.length -= c;
  return ret;
}

function endReadable(stream) {
  var state = stream._readableState;

  // If we get here before consuming all the bytes, then that is a
  // bug in node.  Should never happen.
  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');

  if (!state.endEmitted) {
    state.ended = true;
    pna.nextTick(endReadableNT, state, stream);
  }
}

function endReadableNT(state, stream) {
  // Check that we didn't get one last unshift.
  if (!state.endEmitted && state.length === 0) {
    state.endEmitted = true;
    stream.readable = false;
    stream.emit('end');
  }
}

function indexOf(xs, x) {
  for (var i = 0, l = xs.length; i < l; i++) {
    if (xs[i] === x) return i;
  }
  return -1;
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56), __webpack_require__(90)))

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.



module.exports = Transform;

var Duplex = __webpack_require__(248);

/*<replacement>*/
var util = __webpack_require__(335);
util.inherits = __webpack_require__(41);
/*</replacement>*/

util.inherits(Transform, Duplex);

function afterTransform(er, data) {
  var ts = this._transformState;
  ts.transforming = false;

  var cb = ts.writecb;

  if (!cb) {
    return this.emit('error', new Error('write callback called multiple times'));
  }

  ts.writechunk = null;
  ts.writecb = null;

  if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);

  cb(er);

  var rs = this._readableState;
  rs.reading = false;
  if (rs.needReadable || rs.length < rs.highWaterMark) {
    this._read(rs.highWaterMark);
  }
}

function Transform(options) {
  if (!(this instanceof Transform)) return new Transform(options);

  Duplex.call(this, options);

  this._transformState = {
    afterTransform: afterTransform.bind(this),
    needTransform: false,
    transforming: false,
    writecb: null,
    writechunk: null,
    writeencoding: null
  };

  // start out asking for a readable event once data is transformed.
  this._readableState.needReadable = true;

  // we have implemented the _read method, and done the other things
  // that Readable wants before the first _read call, so unset the
  // sync guard flag.
  this._readableState.sync = false;

  if (options) {
    if (typeof options.transform === 'function') this._transform = options.transform;

    if (typeof options.flush === 'function') this._flush = options.flush;
  }

  // When the writable side finishes, then flush out anything remaining.
  this.on('prefinish', prefinish);
}

function prefinish() {
  var _this = this;

  if (typeof this._flush === 'function') {
    this._flush(function (er, data) {
      done(_this, er, data);
    });
  } else {
    done(this, null, null);
  }
}

Transform.prototype.push = function (chunk, encoding) {
  this._transformState.needTransform = false;
  return Duplex.prototype.push.call(this, chunk, encoding);
};

// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
Transform.prototype._transform = function (chunk, encoding, cb) {
  throw new Error('_transform() is not implemented');
};

Transform.prototype._write = function (chunk, encoding, cb) {
  var ts = this._transformState;
  ts.writecb = cb;
  ts.writechunk = chunk;
  ts.writeencoding = encoding;
  if (!ts.transforming) {
    var rs = this._readableState;
    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
  }
};

// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
Transform.prototype._read = function (n) {
  var ts = this._transformState;

  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
    ts.transforming = true;
    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
  } else {
    // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
  }
};

Transform.prototype._destroy = function (err, cb) {
  var _this2 = this;

  Duplex.prototype._destroy.call(this, err, function (err2) {
    cb(err2);
    _this2.emit('close');
  });
};

function done(stream, er, data) {
  if (er) return stream.emit('error', er);

  if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);

  // if there's nothing in the write buffer, then that means
  // that nothing more will ever be provided
  if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');

  if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');

  return stream.push(null);
}

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*<replacement>*/

var pna = __webpack_require__(455);
/*</replacement>*/

// undocumented cb() API, needed for core, not for public API
function destroy(err, cb) {
  var _this = this;

  var readableDestroyed = this._readableState && this._readableState.destroyed;
  var writableDestroyed = this._writableState && this._writableState.destroyed;

  if (readableDestroyed || writableDestroyed) {
    if (cb) {
      cb(err);
    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
      pna.nextTick(emitErrorNT, this, err);
    }
    return this;
  }

  // we set destroyed to true before firing error callbacks in order
  // to make it re-entrance safe in case destroy() is called within callbacks

  if (this._readableState) {
    this._readableState.destroyed = true;
  }

  // if this is a duplex stream mark the writable part as destroyed as well
  if (this._writableState) {
    this._writableState.destroyed = true;
  }

  this._destroy(err || null, function (err) {
    if (!cb && err) {
      pna.nextTick(emitErrorNT, _this, err);
      if (_this._writableState) {
        _this._writableState.errorEmitted = true;
      }
    } else if (cb) {
      cb(err);
    }
  });

  return this;
}

function undestroy() {
  if (this._readableState) {
    this._readableState.destroyed = false;
    this._readableState.reading = false;
    this._readableState.ended = false;
    this._readableState.endEmitted = false;
  }

  if (this._writableState) {
    this._writableState.destroyed = false;
    this._writableState.ended = false;
    this._writableState.ending = false;
    this._writableState.finished = false;
    this._writableState.errorEmitted = false;
  }
}

function emitErrorNT(self, err) {
  self.emit('error', err);
}

module.exports = {
  destroy: destroy,
  undestroy: undestroy
};

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(680).EventEmitter;


/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(3507);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 1432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_keyboard_key__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_keyboard_key___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_keyboard_key__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__collections_Menu_MenuItem__ = __webpack_require__(702);







/**
 * An item of a pagination.
 */

var PaginationItem = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(PaginationItem, _Component);

  function PaginationItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleClick = function (e) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_invoke__["a" /* default */])(_this.props, 'onClick', e, _this.props);
    };

    _this.handleKeyDown = function (e) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_invoke__["a" /* default */])(_this.props, 'onKeyDown', e, _this.props);

      if (__WEBPACK_IMPORTED_MODULE_2_keyboard_key___default.a.getCode(e) === __WEBPACK_IMPORTED_MODULE_2_keyboard_key___default.a.Enter) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_invoke__["a" /* default */])(_this.props, 'onClick', e, _this.props);
    };

    _this.handleOverrides = function () {
      return {
        onClick: _this.handleClick,
        onKeyDown: _this.handleKeyDown
      };
    };

    return _this;
  }

  var _proto = PaginationItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        type = _this$props.type;
    var disabled = this.props.disabled || type === 'ellipsisItem';
    return __WEBPACK_IMPORTED_MODULE_6__collections_Menu_MenuItem__["a" /* default */].create(this.props, {
      defaultProps: {
        active: active,
        'aria-current': active,
        'aria-disabled': disabled,
        disabled: disabled,
        onClick: this.handleClick,
        onKeyDown: this.handleKeyDown,
        tabIndex: disabled ? -1 : 0
      },
      overrideProps: this.handleOverrides
    });
  };

  return PaginationItem;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

PaginationItem.handledProps = ["active", "disabled", "onClick", "onKeyDown", "type"];
PaginationItem.propTypes =  false ? {
  /** A pagination item can be active. */
  active: PropTypes.bool,

  /** A pagination item can be disabled. */
  disabled: PropTypes.bool,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Called on key down.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onKeyDown: PropTypes.func,

  /** A pagination should have a type. */
  type: PropTypes.oneOf(['ellipsisItem', 'firstItem', 'prevItem', 'pageItem', 'nextItem', 'lastItem'])
} : {};
PaginationItem.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["e" /* createShorthandFactory */])(PaginationItem, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (PaginationItem);

/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fluentui_react_component_ref__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(8);








/**
 * An inner component that allows you to render children outside their parent.
 */
var PortalInner = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(PortalInner, _Component);

  function PortalInner() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleRef = function (c) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__fluentui_react_component_ref__["c" /* handleRef */])(_this.props.innerRef, c);
    };

    return _this;
  }

  var _proto = PortalInner.prototype;

  _proto.componentDidMount = function componentDidMount() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_invoke__["a" /* default */])(this.props, 'onMount', null, this.props);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_invoke__["a" /* default */])(this.props, 'onUnmount', null, this.props);
  };

  _proto.render = function render() {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["t" /* isBrowser */])()) return null;
    var _this$props = this.props,
        children = _this$props.children,
        _this$props$mountNode = _this$props.mountNode,
        mountNode = _this$props$mountNode === void 0 ? document.body : _this$props$mountNode;
    return /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_react_dom__["createPortal"])( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__fluentui_react_component_ref__["a" /* Ref */], {
      innerRef: this.handleRef
    }, children), mountNode);
  };

  return PortalInner;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

PortalInner.handledProps = ["children", "innerRef", "mountNode", "onMount", "onUnmount"];
PortalInner.propTypes =  false ? {
  /** Primary content. */
  children: PropTypes.node.isRequired,

  /** Called with a ref to the inner node. */
  innerRef: customPropTypes.ref,

  /** The node where the portal should mount. */
  mountNode: PropTypes.any,

  /**
   * Called when the portal is mounted on the DOM
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: PropTypes.func,

  /**
   * Called when the portal is unmounted from the DOM
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: PropTypes.func
} : {};
/* harmony default export */ __webpack_exports__["a"] = (PortalInner);

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__(3239);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Select__["a"]; });



/***/ }),
/* 1436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextArea__ = __webpack_require__(3240);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TextArea__["a"]; });



/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isNil__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_Icon__ = __webpack_require__(95);







/**
 * A divider sub-component for Breadcrumb component.
 */

function BreadcrumbDivider(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      icon = props.icon;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])('divider', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(BreadcrumbDivider, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(BreadcrumbDivider, props);

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isNil__["a" /* default */])(icon)) {
    return __WEBPACK_IMPORTED_MODULE_6__elements_Icon__["a" /* default */].create(icon, {
      defaultProps: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        className: classes
      }),
      autoGenerateKey: false
    });
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isNil__["a" /* default */])(content)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), content);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? '/' : children);
}

BreadcrumbDivider.handledProps = ["as", "children", "className", "content", "icon"];
BreadcrumbDivider.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Render as an `Icon` component with `divider` class instead of a `div`. */
  icon: customPropTypes.itemShorthand
} : {};
BreadcrumbDivider.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["e" /* createShorthandFactory */])(BreadcrumbDivider, function (icon) {
  return {
    icon: icon
  };
});
/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbDivider);

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BreadcrumbSection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(8);







/**
 * A section sub-component for Breadcrumb component.
 */

var BreadcrumbSection = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(BreadcrumbSection, _Component);

  function BreadcrumbSection() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.computeElementType = function () {
      var _this$props = _this.props,
          link = _this$props.link,
          onClick = _this$props.onClick;
      if (link || onClick) return 'a';
    };

    _this.handleClick = function (e) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onClick', e, _this.props);
    };

    return _this;
  }

  var _proto = BreadcrumbSection.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        active = _this$props2.active,
        children = _this$props2.children,
        className = _this$props2.className,
        content = _this$props2.content,
        href = _this$props2.href;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(active, 'active'), 'section', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(BreadcrumbSection, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(BreadcrumbSection, this.props, this.computeElementType);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes,
      href: href,
      onClick: this.handleClick
    }), __WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
  };

  return BreadcrumbSection;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

BreadcrumbSection.handledProps = ["active", "as", "children", "className", "content", "href", "link", "onClick"];

BreadcrumbSection.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Style as the currently active section. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
  href: customPropTypes.every([customPropTypes.disallow(['link']), PropTypes.string]),

  /** Render as an `a` tag instead of a `div`. */
  link: customPropTypes.every([customPropTypes.disallow(['href']), PropTypes.bool]),

  /**
   * Called on click. When passed, the component will render as an `a`
   * tag by default instead of a `div`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func
} : {};
BreadcrumbSection.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["e" /* createShorthandFactory */])(BreadcrumbSection, function (content) {
  return {
    content: content,
    link: true
  };
});

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_Button__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormField__ = __webpack_require__(187);






/**
 * Sugar for <Form.Field control={Button} />.
 * @see Button
 * @see Form
 */

function FormButton(props) {
  var control = props.control;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib__["b" /* getUnhandledProps */])(FormButton, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib__["c" /* getElementType */])(FormButton, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    control: control
  }));
}

FormButton.handledProps = ["as", "control"];
FormButton.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};
FormButton.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_5__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_4__elements_Button__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormButton);

/***/ }),
/* 1440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_Checkbox__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormField__ = __webpack_require__(187);






/**
 * Sugar for <Form.Field control={Checkbox} />.
 * @see Checkbox
 * @see Form
 */

function FormCheckbox(props) {
  var control = props.control;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib__["b" /* getUnhandledProps */])(FormCheckbox, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib__["c" /* getElementType */])(FormCheckbox, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    control: control
  }));
}

FormCheckbox.handledProps = ["as", "control"];
FormCheckbox.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};
FormCheckbox.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_5__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_4__modules_Checkbox__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormCheckbox);

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_Dropdown__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormField__ = __webpack_require__(187);






/**
 * Sugar for <Form.Field control={Dropdown} />.
 * @see Dropdown
 * @see Form
 */

function FormDropdown(props) {
  var control = props.control;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib__["b" /* getUnhandledProps */])(FormDropdown, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib__["c" /* getElementType */])(FormDropdown, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    control: control
  }));
}

FormDropdown.handledProps = ["as", "control"];
FormDropdown.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};
FormDropdown.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_5__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_4__modules_Dropdown__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormDropdown);

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A set of fields can appear grouped together.
 * @see Form
 */

function FormGroup(props) {
  var children = props.children,
      className = props.className,
      grouped = props.grouped,
      inline = props.inline,
      unstackable = props.unstackable,
      widths = props.widths;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(grouped, 'grouped'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(inline, 'inline'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(unstackable, 'unstackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["f" /* useWidthProp */])(widths, null, true), 'fields', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(FormGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(FormGroup, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), children);
}

FormGroup.handledProps = ["as", "children", "className", "grouped", "inline", "unstackable", "widths"];
FormGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Fields can show related choices. */
  grouped: customPropTypes.every([customPropTypes.disallow(['inline']), PropTypes.bool]),

  /** Multiple fields may be inline in a row. */
  inline: customPropTypes.every([customPropTypes.disallow(['grouped']), PropTypes.bool]),

  /** A form group can prevent itself from stacking on mobile. */
  unstackable: PropTypes.bool,

  /** Fields Groups can specify their width in grid columns or automatically divide fields to be equal width. */
  widths: PropTypes.oneOf([].concat(SUI.WIDTHS, ['equal']))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FormGroup);

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__elements_Input__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormField__ = __webpack_require__(187);






/**
 * Sugar for <Form.Field control={Input} />.
 * @see Form
 * @see Input
 */

function FormInput(props) {
  var control = props.control;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib__["b" /* getUnhandledProps */])(FormInput, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib__["c" /* getElementType */])(FormInput, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    control: control
  }));
}

FormInput.handledProps = ["as", "control"];
FormInput.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};
FormInput.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_5__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_4__elements_Input__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormInput);

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addons_Radio__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormField__ = __webpack_require__(187);






/**
 * Sugar for <Form.Field control={Radio} />.
 * @see Form
 * @see Radio
 */

function FormRadio(props) {
  var control = props.control;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib__["b" /* getUnhandledProps */])(FormRadio, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib__["c" /* getElementType */])(FormRadio, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    control: control
  }));
}

FormRadio.handledProps = ["as", "control"];
FormRadio.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};
FormRadio.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_5__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_4__addons_Radio__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormRadio);

/***/ }),
/* 1445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addons_Select__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_Dropdown__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormField__ = __webpack_require__(187);







/**
 * Sugar for <Form.Field control={Select} />.
 * @see Form
 * @see Select
 */

function FormSelect(props) {
  var control = props.control,
      options = props.options;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib__["b" /* getUnhandledProps */])(FormSelect, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib__["c" /* getElementType */])(FormSelect, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    control: control,
    options: options
  }));
}

FormSelect.handledProps = ["as", "control", "options"];
FormSelect.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A FormField control prop. */
  control: FormField.propTypes.control,

  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
  options: PropTypes.arrayOf(PropTypes.shape(Dropdown.Item.propTypes)).isRequired
} : {};
FormSelect.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_6__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_4__addons_Select__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormSelect);

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__addons_TextArea__ = __webpack_require__(1436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormField__ = __webpack_require__(187);






/**
 * Sugar for <Form.Field control={TextArea} />.
 * @see Form
 * @see TextArea
 */

function FormTextArea(props) {
  var control = props.control;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib__["b" /* getUnhandledProps */])(FormTextArea, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib__["c" /* getElementType */])(FormTextArea, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    control: control
  }));
}

FormTextArea.handledProps = ["as", "control"];
FormTextArea.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A FormField control prop. */
  control: FormField.propTypes.control
} : {};
FormTextArea.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_5__FormField__["a" /* default */],
  control: __WEBPACK_IMPORTED_MODULE_4__addons_TextArea__["a" /* default */]
};
/* harmony default export */ __webpack_exports__["a"] = (FormTextArea);

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__GridColumn__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__GridRow__ = __webpack_require__(1448);







/**
 * A grid is used to harmonize negative space in a layout.
 */

function Grid(props) {
  var celled = props.celled,
      centered = props.centered,
      children = props.children,
      className = props.className,
      columns = props.columns,
      container = props.container,
      divided = props.divided,
      doubling = props.doubling,
      inverted = props.inverted,
      padded = props.padded,
      relaxed = props.relaxed,
      reversed = props.reversed,
      stackable = props.stackable,
      stretched = props.stretched,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(centered, 'centered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(container, 'container'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(doubling, 'doubling'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(stackable, 'stackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(stretched, 'stretched'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["h" /* useKeyOrValueAndKey */])(celled, 'celled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["h" /* useKeyOrValueAndKey */])(divided, 'divided'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["h" /* useKeyOrValueAndKey */])(padded, 'padded'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["h" /* useKeyOrValueAndKey */])(relaxed, 'relaxed'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* useMultipleProp */])(reversed, 'reversed'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["n" /* useTextAlignProp */])(textAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["i" /* useVerticalAlignProp */])(verticalAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["f" /* useWidthProp */])(columns, 'column', true), 'grid', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Grid, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(Grid, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), children);
}

Grid.handledProps = ["as", "celled", "centered", "children", "className", "columns", "container", "divided", "doubling", "inverted", "padded", "relaxed", "reversed", "stackable", "stretched", "textAlign", "verticalAlign"];
Grid.Column = __WEBPACK_IMPORTED_MODULE_5__GridColumn__["a" /* default */];
Grid.Row = __WEBPACK_IMPORTED_MODULE_6__GridRow__["a" /* default */];
Grid.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A grid can have rows divided into cells. */
  celled: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['internally'])]),

  /** A grid can have its columns centered. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Represents column count per row in Grid. */
  columns: PropTypes.oneOf([].concat(SUI.WIDTHS, ['equal'])),

  /** A grid can be combined with a container to use the available layout and alignment. */
  container: PropTypes.bool,

  /** A grid can have dividers between its columns. */
  divided: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['vertically'])]),

  /** A grid can double its column width on tablet and mobile sizes. */
  doubling: PropTypes.bool,

  /** A grid's colors can be inverted. */
  inverted: PropTypes.bool,

  /** A grid can preserve its vertical and horizontal gutters on first and last columns. */
  padded: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['horizontally', 'vertically'])]),

  /** A grid can increase its gutters to allow for more negative space. */
  relaxed: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** A grid can specify that its columns should reverse order at different device sizes. */
  reversed: customPropTypes.multipleProp(['computer', 'computer vertically', 'mobile', 'mobile vertically', 'tablet', 'tablet vertically']),

  /** A grid can have its columns stack on-top of each other after reaching mobile breakpoints. */
  stackable: PropTypes.bool,

  /** A grid can stretch its contents to take up the entire grid height. */
  stretched: PropTypes.bool,

  /** A grid can specify its text alignment. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS),

  /** A grid can specify its vertical alignment to have all its columns vertically centered. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Grid);

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A row sub-component for Grid.
 */

function GridRow(props) {
  var centered = props.centered,
      children = props.children,
      className = props.className,
      color = props.color,
      columns = props.columns,
      divided = props.divided,
      only = props.only,
      reversed = props.reversed,
      stretched = props.stretched,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(color, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(centered, 'centered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(divided, 'divided'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(stretched, 'stretched'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* useMultipleProp */])(only, 'only'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["r" /* useMultipleProp */])(reversed, 'reversed'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["n" /* useTextAlignProp */])(textAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["i" /* useVerticalAlignProp */])(verticalAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["f" /* useWidthProp */])(columns, 'column', true), 'row', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(GridRow, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(GridRow, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), children);
}

GridRow.handledProps = ["as", "centered", "children", "className", "color", "columns", "divided", "only", "reversed", "stretched", "textAlign", "verticalAlign"];
GridRow.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A row can have its columns centered. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A grid row can be colored. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Represents column count per line in Row. */
  columns: PropTypes.oneOf([].concat(SUI.WIDTHS, ['equal'])),

  /** A row can have dividers between its columns. */
  divided: PropTypes.bool,

  /** A row can appear only for a specific device, or screen sizes. */
  only: customPropTypes.multipleProp(SUI.VISIBILITY),

  /** A row can specify that its columns should reverse order at different device sizes. */
  reversed: customPropTypes.multipleProp(['computer', 'computer vertically', 'mobile', 'mobile vertically', 'tablet', 'tablet vertically']),

  /** A row can stretch its contents to take up the entire column height. */
  stretched: PropTypes.bool,

  /** A row can specify its text alignment. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS),

  /** A row can specify its vertical alignment to have all its columns vertically centered. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (GridRow);

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MenuHeader__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MenuItem__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MenuMenu__ = __webpack_require__(1451);












/**
 * A menu displays grouped navigation actions.
 * @see Dropdown
 */

var Menu = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Menu, _Component);

  function Menu() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleItemOverrides = function (predefinedProps) {
      return {
        onClick: function onClick(e, itemProps) {
          var index = itemProps.index;

          _this.setState({
            activeIndex: index
          });

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_invoke__["a" /* default */])(predefinedProps, 'onClick', e, itemProps);

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_invoke__["a" /* default */])(_this.props, 'onItemClick', e, itemProps);
        }
      };
    };

    return _this;
  }

  var _proto = Menu.prototype;

  _proto.renderItems = function renderItems() {
    var _this2 = this;

    var items = this.props.items;
    var activeIndex = this.state.activeIndex;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_map__["a" /* default */])(items, function (item, index) {
      return __WEBPACK_IMPORTED_MODULE_10__MenuItem__["a" /* default */].create(item, {
        defaultProps: {
          active: parseInt(activeIndex, 10) === index,
          index: index
        },
        overrideProps: _this2.handleItemOverrides
      });
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        attached = _this$props.attached,
        borderless = _this$props.borderless,
        children = _this$props.children,
        className = _this$props.className,
        color = _this$props.color,
        compact = _this$props.compact,
        fixed = _this$props.fixed,
        floated = _this$props.floated,
        fluid = _this$props.fluid,
        icon = _this$props.icon,
        inverted = _this$props.inverted,
        pagination = _this$props.pagination,
        pointing = _this$props.pointing,
        secondary = _this$props.secondary,
        size = _this$props.size,
        stackable = _this$props.stackable,
        tabular = _this$props.tabular,
        text = _this$props.text,
        vertical = _this$props.vertical,
        widths = _this$props.widths;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(borderless, 'borderless'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(compact, 'compact'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(pagination, 'pagination'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(pointing, 'pointing'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(secondary, 'secondary'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(stackable, 'stackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(text, 'text'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(vertical, 'vertical'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["h" /* useKeyOrValueAndKey */])(attached, 'attached'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["h" /* useKeyOrValueAndKey */])(floated, 'floated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["h" /* useKeyOrValueAndKey */])(icon, 'icon'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["h" /* useKeyOrValueAndKey */])(tabular, 'tabular'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["g" /* useValueAndKey */])(fixed, 'fixed'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["f" /* useWidthProp */])(widths, 'item'), className, 'menu');
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["b" /* getUnhandledProps */])(Menu, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["c" /* getElementType */])(Menu, this.props);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), __WEBPACK_IMPORTED_MODULE_8__lib__["d" /* childrenUtils */].isNil(children) ? this.renderItems() : children);
  };

  return Menu;
}(__WEBPACK_IMPORTED_MODULE_8__lib__["q" /* ModernAutoControlledComponent */]);

Menu.handledProps = ["activeIndex", "as", "attached", "borderless", "children", "className", "color", "compact", "defaultActiveIndex", "fixed", "floated", "fluid", "icon", "inverted", "items", "onItemClick", "pagination", "pointing", "secondary", "size", "stackable", "tabular", "text", "vertical", "widths"];
Menu.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Index of the currently active item. */
  activeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A menu may be attached to other content segments. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** A menu item or menu can have no borders. */
  borderless: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Additional colors can be specified. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A menu can take up only the space necessary to fit its content. */
  compact: PropTypes.bool,

  /** Initial activeIndex value. */
  defaultActiveIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A menu can be fixed to a side of its context. */
  fixed: PropTypes.oneOf(['left', 'right', 'bottom', 'top']),

  /** A menu can be floated. */
  floated: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['right'])]),

  /** A vertical menu may take the size of its container. */
  fluid: PropTypes.bool,

  /** A menu may have just icons (bool) or labeled icons. */
  icon: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['labeled'])]),

  /** A menu may have its colors inverted to show greater contrast. */
  inverted: PropTypes.bool,

  /** Shorthand array of props for Menu. */
  items: customPropTypes.collectionShorthand,

  /**
   * onClick handler for MenuItem. Mutually exclusive with children.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All item props.
   */
  onItemClick: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.func]),

  /** A pagination menu is specially formatted to present links to pages of content. */
  pagination: PropTypes.bool,

  /** A menu can point to show its relationship to nearby content. */
  pointing: PropTypes.bool,

  /** A menu can adjust its appearance to de-emphasize its contents. */
  secondary: PropTypes.bool,

  /** A menu can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium', 'big')),

  /** A menu can stack at mobile resolutions. */
  stackable: PropTypes.bool,

  /** A menu can be formatted to show tabs of information. */
  tabular: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['right'])]),

  /** A menu can be formatted for text content. */
  text: PropTypes.bool,

  /** A vertical menu displays elements vertically. */
  vertical: PropTypes.bool,

  /** A menu can have its items divided evenly. */
  widths: PropTypes.oneOf(SUI.WIDTHS)
} : {};
Menu.autoControlledProps = ['activeIndex'];
Menu.Header = __WEBPACK_IMPORTED_MODULE_9__MenuHeader__["a" /* default */];
Menu.Item = __WEBPACK_IMPORTED_MODULE_10__MenuItem__["a" /* default */];
Menu.Menu = __WEBPACK_IMPORTED_MODULE_11__MenuMenu__["a" /* default */];
Menu.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["e" /* createShorthandFactory */])(Menu, function (items) {
  return {
    items: items
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A menu item may include a header or may itself be a header.
 */

function MenuHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(MenuHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(MenuHeader, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

MenuHeader.handledProps = ["as", "children", "className", "content"];
MenuHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (MenuHeader);

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A menu can contain a sub menu.
 */

function MenuMenu(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      position = props.position;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(position, 'menu', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(MenuMenu, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(MenuMenu, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

MenuMenu.handledProps = ["as", "children", "className", "content", "position"];
MenuMenu.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A sub menu can take left or right position. */
  position: PropTypes.oneOf(['left', 'right'])
} : {};
/* harmony default export */ __webpack_exports__["a"] = (MenuMenu);

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(1449);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Menu__["a"]; });



/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A message can contain a content.
 */

function MessageContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(MessageContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(MessageContent, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

MessageContent.handledProps = ["as", "children", "className", "content"];
MessageContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (MessageContent);

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A message can contain a header.
 */

function MessageHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(MessageHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(MessageHeader, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

MessageHeader.handledProps = ["as", "children", "className", "content"];
MessageHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
MessageHeader.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(MessageHeader, function (val) {
  return {
    content: val
  };
});
/* harmony default export */ __webpack_exports__["a"] = (MessageHeader);

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MessageItem__ = __webpack_require__(703);







/**
 * A message can contain a list of items.
 */

function MessageList(props) {
  var children = props.children,
      className = props.className,
      items = props.items;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])('list', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(MessageList, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(MessageList, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_map__["a" /* default */])(items, __WEBPACK_IMPORTED_MODULE_6__MessageItem__["a" /* default */].create) : children);
}

MessageList.handledProps = ["as", "children", "className", "items"];
MessageList.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand Message.Items. */
  items: customPropTypes.collectionShorthand
} : {};
MessageList.defaultProps = {
  as: 'ul'
};
MessageList.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["e" /* createShorthandFactory */])(MessageList, function (val) {
  return {
    items: val
  };
});
/* harmony default export */ __webpack_exports__["a"] = (MessageList);

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);






function TableBody(props) {
  var children = props.children,
      className = props.className;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(TableBody, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(TableBody, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), children);
}

TableBody.handledProps = ["as", "children", "className"];
TableBody.defaultProps = {
  as: 'tbody'
};
TableBody.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string
} : {};
/* harmony default export */ __webpack_exports__["a"] = (TableBody);

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TableHeader__ = __webpack_require__(704);





/**
 * A table can have a footer.
 */

function TableFooter(props) {
  var as = props.as;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__lib__["b" /* getUnhandledProps */])(TableFooter, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TableHeader__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    as: as
  }));
}

TableFooter.handledProps = ["as"];
TableFooter.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType
} : {};
TableFooter.defaultProps = {
  as: 'tfoot'
};
/* harmony default export */ __webpack_exports__["a"] = (TableFooter);

/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TableCell__ = __webpack_require__(468);






/**
 * A table can have a header cell.
 */

function TableHeaderCell(props) {
  var as = props.as,
      className = props.className,
      sorted = props.sorted;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["g" /* useValueAndKey */])(sorted, 'sorted'), className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(TableHeaderCell, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TableCell__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    as: as,
    className: classes
  }));
}

TableHeaderCell.handledProps = ["as", "className", "sorted"];
TableHeaderCell.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Additional classes. */
  className: PropTypes.string,

  /** A header cell can be sorted in ascending or descending order. */
  sorted: PropTypes.oneOf(['ascending', 'descending'])
} : {};
TableHeaderCell.defaultProps = {
  as: 'th'
};
/* harmony default export */ __webpack_exports__["a"] = (TableHeaderCell);

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TableCell__ = __webpack_require__(468);








/**
 * A table can have rows.
 */

function TableRow(props) {
  var active = props.active,
      cellAs = props.cellAs,
      cells = props.cells,
      children = props.children,
      className = props.className,
      disabled = props.disabled,
      error = props.error,
      negative = props.negative,
      positive = props.positive,
      textAlign = props.textAlign,
      verticalAlign = props.verticalAlign,
      warning = props.warning;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(error, 'error'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(negative, 'negative'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(positive, 'positive'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(warning, 'warning'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["n" /* useTextAlignProp */])(textAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["i" /* useVerticalAlignProp */])(verticalAlign), className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(TableRow, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(TableRow, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_map__["a" /* default */])(cells, function (cell) {
    return __WEBPACK_IMPORTED_MODULE_7__TableCell__["a" /* default */].create(cell, {
      defaultProps: {
        as: cellAs
      }
    });
  }));
}

TableRow.handledProps = ["active", "as", "cellAs", "cells", "children", "className", "disabled", "error", "negative", "positive", "textAlign", "verticalAlign", "warning"];
TableRow.defaultProps = {
  as: 'tr',
  cellAs: 'td'
};
TableRow.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A row can be active or selected by a user. */
  active: PropTypes.bool,

  /** An element type to render as (string or function). */
  cellAs: PropTypes.elementType,

  /** Shorthand array of props for TableCell. */
  cells: customPropTypes.collectionShorthand,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A row can be disabled. */
  disabled: PropTypes.bool,

  /** A row may call attention to an error or a negative value. */
  error: PropTypes.bool,

  /** A row may let a user know whether a value is bad. */
  negative: PropTypes.bool,

  /** A row may let a user know whether a value is good. */
  positive: PropTypes.bool,

  /** A table row can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified')),

  /** A table row can adjust its vertical alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS),

  /** A row may warn a user. */
  warning: PropTypes.bool
} : {};
TableRow.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["e" /* createShorthandFactory */])(TableRow, function (cells) {
  return {
    cells: cells
  };
});
/* harmony default export */ __webpack_exports__["a"] = (TableRow);

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * Used in some Button types, such as `animated`.
 */

function ButtonContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      hidden = props.hidden,
      visible = props.visible;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(visible, 'visible'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(hidden, 'hidden'), 'content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ButtonContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ButtonContent, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ButtonContent.handledProps = ["as", "children", "className", "content", "hidden", "visible"];
ButtonContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Initially hidden, visible on hover. */
  hidden: PropTypes.bool,

  /** Initially visible, hidden on hover. */
  visible: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ButtonContent);

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isNil__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(705);








/**
 * Buttons can be grouped.
 */

function ButtonGroup(props) {
  var attached = props.attached,
      basic = props.basic,
      buttons = props.buttons,
      children = props.children,
      className = props.className,
      color = props.color,
      compact = props.compact,
      content = props.content,
      floated = props.floated,
      fluid = props.fluid,
      icon = props.icon,
      inverted = props.inverted,
      labeled = props.labeled,
      negative = props.negative,
      positive = props.positive,
      primary = props.primary,
      secondary = props.secondary,
      size = props.size,
      toggle = props.toggle,
      vertical = props.vertical,
      widths = props.widths;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(basic, 'basic'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(compact, 'compact'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(icon, 'icon'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(labeled, 'labeled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(negative, 'negative'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(positive, 'positive'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(primary, 'primary'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(secondary, 'secondary'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(toggle, 'toggle'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(vertical, 'vertical'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["h" /* useKeyOrValueAndKey */])(attached, 'attached'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["g" /* useValueAndKey */])(floated, 'floated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["f" /* useWidthProp */])(widths), 'buttons', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(ButtonGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(ButtonGroup, props);

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isNil__["a" /* default */])(buttons)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), __WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_map__["a" /* default */])(buttons, function (button) {
    return __WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */].create(button);
  }));
}

ButtonGroup.handledProps = ["as", "attached", "basic", "buttons", "children", "className", "color", "compact", "content", "floated", "fluid", "icon", "inverted", "labeled", "negative", "positive", "primary", "secondary", "size", "toggle", "vertical", "widths"];
ButtonGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Groups can be attached to other content. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right', 'top', 'bottom'])]),

  /** Groups can be less pronounced. */
  basic: PropTypes.bool,

  /** Array of shorthand Button values. */
  buttons: customPropTypes.collectionShorthand,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Groups can have a shared color. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Groups can reduce their padding to fit into tighter spaces. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Groups can be aligned to the left or right of its container. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** Groups can take the width of their container. */
  fluid: PropTypes.bool,

  /** Groups can be formatted as icons. */
  icon: PropTypes.bool,

  /** Groups can be formatted to appear on dark backgrounds. */
  inverted: PropTypes.bool,

  /** Groups can be formatted as labeled icon buttons. */
  labeled: PropTypes.bool,

  /** Groups can hint towards a negative consequence. */
  negative: PropTypes.bool,

  /** Groups can hint towards a positive consequence. */
  positive: PropTypes.bool,

  /** Groups can be formatted to show different levels of emphasis. */
  primary: PropTypes.bool,

  /** Groups can be formatted to show different levels of emphasis. */
  secondary: PropTypes.bool,

  /** Groups can have different sizes. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** Groups can be formatted to toggle on and off. */
  toggle: PropTypes.bool,

  /** Groups can be formatted to appear vertically. */
  vertical: PropTypes.bool,

  /** Groups can have their widths divided evenly. */
  widths: PropTypes.oneOf(SUI.WIDTHS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ButtonGroup);

/***/ }),
/* 1462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * Button groups can contain conditionals.
 */

function ButtonOr(props) {
  var className = props.className,
      text = props.text;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('or', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ButtonOr, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ButtonOr, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes,
    "data-text": text
  }));
}

ButtonOr.handledProps = ["as", "className", "text"];
ButtonOr.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Additional classes. */
  className: PropTypes.string,

  /** Or buttons can have their text localized, or adjusted by using the text prop. */
  text: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ButtonOr);

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * Header content wraps the main content when there is an adjacent Icon or Image.
 */

function HeaderContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(HeaderContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(HeaderContent, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

HeaderContent.handledProps = ["as", "children", "className", "content"];
HeaderContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (HeaderContent);

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * Headers may contain subheaders.
 */

function HeaderSubheader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('sub header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(HeaderSubheader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(HeaderSubheader, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

HeaderSubheader.handledProps = ["as", "children", "className", "content"];
HeaderSubheader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
HeaderSubheader.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(HeaderSubheader, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (HeaderSubheader);

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);






/**
 * Several icons can be used together as a group.
 */

function IconGroup(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      size = props.size;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(size, 'icons', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(IconGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(IconGroup, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

IconGroup.handledProps = ["as", "children", "className", "content", "size"];
IconGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Size of the icon group. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium'))
} : {};
IconGroup.defaultProps = {
  as: 'i'
};
/* harmony default export */ __webpack_exports__["a"] = (IconGroup);

/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isNil__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_Dimmer__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Label_Label__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ImageGroup__ = __webpack_require__(1467);









/**
 * An image is a graphic representation of something.
 * @see Icon
 */

function Image(props) {
  var avatar = props.avatar,
      bordered = props.bordered,
      centered = props.centered,
      children = props.children,
      circular = props.circular,
      className = props.className,
      content = props.content,
      dimmer = props.dimmer,
      disabled = props.disabled,
      floated = props.floated,
      fluid = props.fluid,
      hidden = props.hidden,
      href = props.href,
      inline = props.inline,
      label = props.label,
      rounded = props.rounded,
      size = props.size,
      spaced = props.spaced,
      verticalAlign = props.verticalAlign,
      wrapped = props.wrapped,
      ui = props.ui;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(ui, 'ui'), size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(avatar, 'avatar'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(bordered, 'bordered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(circular, 'circular'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(centered, 'centered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(hidden, 'hidden'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(inline, 'inline'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(rounded, 'rounded'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["h" /* useKeyOrValueAndKey */])(spaced, 'spaced'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["g" /* useValueAndKey */])(floated, 'floated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["i" /* useVerticalAlignProp */])(verticalAlign, 'aligned'), 'image', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(Image, props);

  var _partitionHTMLProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["l" /* partitionHTMLProps */])(rest, {
    htmlProps: __WEBPACK_IMPORTED_MODULE_5__lib__["m" /* htmlImageProps */]
  }),
      imgTagProps = _partitionHTMLProps[0],
      rootProps = _partitionHTMLProps[1];

  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(Image, props, function () {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isNil__["a" /* default */])(dimmer) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isNil__["a" /* default */])(label) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isNil__["a" /* default */])(wrapped) || !__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) {
      return 'div';
    }
  });

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(content)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), content);
  }

  if (ElementType === 'img') {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rootProps, imgTagProps, {
      className: classes
    }));
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rootProps, {
    className: classes,
    href: href
  }), __WEBPACK_IMPORTED_MODULE_6__modules_Dimmer__["a" /* default */].create(dimmer, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_7__Label_Label__["a" /* default */].create(label, {
    autoGenerateKey: false
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", imgTagProps));
}

Image.handledProps = ["as", "avatar", "bordered", "centered", "children", "circular", "className", "content", "dimmer", "disabled", "floated", "fluid", "hidden", "href", "inline", "label", "rounded", "size", "spaced", "ui", "verticalAlign", "wrapped"];
Image.Group = __WEBPACK_IMPORTED_MODULE_8__ImageGroup__["a" /* default */];
Image.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** An image may be formatted to appear inline with text as an avatar. */
  avatar: PropTypes.bool,

  /** An image may include a border to emphasize the edges of white or transparent content. */
  bordered: PropTypes.bool,

  /** An image can appear centered in a content block. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** An image may appear circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** An image can show that it is disabled and cannot be selected. */
  disabled: PropTypes.bool,

  /** Shorthand for Dimmer. */
  dimmer: customPropTypes.itemShorthand,

  /** An image can sit to the left or right of other content. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** An image can take up the width of its container. */
  fluid: customPropTypes.every([PropTypes.bool, customPropTypes.disallow(['size'])]),

  /** An image can be hidden. */
  hidden: PropTypes.bool,

  /** Renders the Image as an <a> tag with this href. */
  href: PropTypes.string,

  /** An image may appear inline. */
  inline: PropTypes.bool,

  /** Shorthand for Label. */
  label: customPropTypes.itemShorthand,

  /** An image may appear rounded. */
  rounded: PropTypes.bool,

  /** An image may appear at different sizes. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** An image can specify that it needs an additional spacing to separate it from nearby content. */
  spaced: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right'])]),

  /** Whether or not to add the ui className. */
  ui: PropTypes.bool,

  /** An image can specify its vertical alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS),

  /** An image can render wrapped in a `div.ui.image` as alternative HTML markup. */
  wrapped: PropTypes.bool
} : {};
Image.defaultProps = {
  as: 'img',
  ui: true
};
Image.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["e" /* createShorthandFactory */])(Image, function (value) {
  return {
    src: value
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Image);

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A group of images.
 */

function ImageGroup(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      size = props.size;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('ui', size, className, 'images');
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ImageGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ImageGroup, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ImageGroup.handledProps = ["as", "children", "className", "content", "size"];
ImageGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A group of images can be formatted to have the same size. */
  size: PropTypes.oneOf(SUI.SIZES)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ImageGroup);

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);






function LabelDetail(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('detail', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(LabelDetail, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(LabelDetail, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

LabelDetail.handledProps = ["as", "children", "className", "content"];
LabelDetail.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
LabelDetail.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(LabelDetail, function (val) {
  return {
    content: val
  };
});
/* harmony default export */ __webpack_exports__["a"] = (LabelDetail);

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A label can be grouped.
 */

function LabelGroup(props) {
  var children = props.children,
      circular = props.circular,
      className = props.className,
      color = props.color,
      content = props.content,
      size = props.size,
      tag = props.tag;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(circular, 'circular'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(tag, 'tag'), 'labels', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(LabelGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(LabelGroup, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

LabelGroup.handledProps = ["as", "children", "circular", "className", "color", "content", "size", "tag"];
LabelGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Labels can share shapes. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Label group can share colors together. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Label group can share sizes together. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** Label group can share tag formatting. */
  tag: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (LabelGroup);

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isPlainObject__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Image__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ListContent__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ListDescription__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ListHeader__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ListIcon__ = __webpack_require__(710);













/**
 * A list item can contain a set of items.
 */

var ListItem = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ListItem, _Component);

  function ListItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleClick = function (e) {
      var disabled = _this.props.disabled;
      if (!disabled) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(_this.props, 'onClick', e, _this.props);
    };

    return _this;
  }

  var _proto = ListItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        children = _this$props.children,
        className = _this$props.className,
        content = _this$props.content,
        description = _this$props.description,
        disabled = _this$props.disabled,
        header = _this$props.header,
        icon = _this$props.icon,
        image = _this$props.image,
        value = _this$props.value;
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["c" /* getElementType */])(ListItem, this.props);
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(ElementType !== 'li', 'item'), className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["b" /* getUnhandledProps */])(ListItem, this.props);
    var valueProp = ElementType === 'li' ? {
      value: value
    } : {
      'data-value': value
    };

    if (!__WEBPACK_IMPORTED_MODULE_7__lib__["d" /* childrenUtils */].isNil(children)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, valueProp, {
        role: "listitem",
        className: classes,
        onClick: this.handleClick
      }, rest), children);
    }

    var iconElement = __WEBPACK_IMPORTED_MODULE_12__ListIcon__["a" /* default */].create(icon, {
      autoGenerateKey: false
    });
    var imageElement = __WEBPACK_IMPORTED_MODULE_8__Image__["a" /* default */].create(image, {
      autoGenerateKey: false
    }); // See description of `content` prop for explanation about why this is necessary.

    if (! /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["isValidElement"])(content) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isPlainObject__["a" /* default */])(content)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, valueProp, {
        role: "listitem",
        className: classes,
        onClick: this.handleClick
      }, rest), iconElement || imageElement, __WEBPACK_IMPORTED_MODULE_9__ListContent__["a" /* default */].create(content, {
        autoGenerateKey: false,
        defaultProps: {
          header: header,
          description: description
        }
      }));
    }

    var headerElement = __WEBPACK_IMPORTED_MODULE_11__ListHeader__["a" /* default */].create(header, {
      autoGenerateKey: false
    });
    var descriptionElement = __WEBPACK_IMPORTED_MODULE_10__ListDescription__["a" /* default */].create(description, {
      autoGenerateKey: false
    });

    if (iconElement || imageElement) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, valueProp, {
        role: "listitem",
        className: classes,
        onClick: this.handleClick
      }, rest), iconElement || imageElement, (content || headerElement || descriptionElement) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ListContent__["a" /* default */], null, headerElement, descriptionElement, content));
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, valueProp, {
      role: "listitem",
      className: classes,
      onClick: this.handleClick
    }, rest), headerElement, descriptionElement, content);
  };

  return ListItem;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

ListItem.handledProps = ["active", "as", "children", "className", "content", "description", "disabled", "header", "icon", "image", "onClick", "value"];
ListItem.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A list item can active. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /**
   * Shorthand for primary content.
   *
   * Heads up!
   *
   * This is handled slightly differently than the typical `content` prop since
   * the wrapping ListContent is not used when there's no icon or image.
   *
   * If you pass content as:
   * - an element/literal, it's treated as the sibling node to
   * header/description (whether wrapped in Item.Content or not).
   * - a props object, it forces the presence of Item.Content and passes those
   * props to it. If you pass a content prop within that props object, it
   * will be treated as the sibling node to header/description.
   */
  content: customPropTypes.itemShorthand,

  /** Shorthand for ListDescription. */
  description: customPropTypes.itemShorthand,

  /** A list item can disabled. */
  disabled: PropTypes.bool,

  /** Shorthand for ListHeader. */
  header: customPropTypes.itemShorthand,

  /** Shorthand for ListIcon. */
  icon: customPropTypes.every([customPropTypes.disallow(['image']), customPropTypes.itemShorthand]),

  /** Shorthand for Image. */
  image: customPropTypes.every([customPropTypes.disallow(['icon']), customPropTypes.itemShorthand]),

  /** A ListItem can be clicked */
  onClick: PropTypes.func,

  /** A value for an ordered list. */
  value: PropTypes.string
} : {};
ListItem.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["e" /* createShorthandFactory */])(ListItem, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ListItem);

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A list can contain a sub list.
 */

function ListList(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ListList, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ListList, props);
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(ElementType !== 'ul' && ElementType !== 'ol', 'list'), className);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ListList.handledProps = ["as", "children", "className", "content"];
ListList.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ListList);

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A placeholder can contain a header.
 */

function PlaceholderHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      image = props.image;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(image, 'image'), 'header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(PlaceholderHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(PlaceholderHeader, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

PlaceholderHeader.handledProps = ["as", "children", "className", "content", "image"];
PlaceholderHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A placeholder can contain an image. */
  image: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (PlaceholderHeader);

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A placeholder can contain an image.
 */

function PlaceholderImage(props) {
  var className = props.className,
      square = props.square,
      rectangular = props.rectangular;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(square, 'square'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(rectangular, 'rectangular'), 'image', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(PlaceholderImage, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(PlaceholderImage, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }));
}

PlaceholderImage.handledProps = ["as", "className", "rectangular", "square"];
PlaceholderImage.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Additional classes. */
  className: PropTypes.string,

  /** An image can modify size correctly with responsive styles. */
  square: customPropTypes.every([customPropTypes.disallow(['rectangular']), PropTypes.bool]),

  /** An image can modify size correctly with responsive styles. */
  rectangular: customPropTypes.every([customPropTypes.disallow(['square']), PropTypes.bool])
} : {};
/* harmony default export */ __webpack_exports__["a"] = (PlaceholderImage);

/***/ }),
/* 1474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A placeholder can contain have lines of text.
 */

function PlaceholderLine(props) {
  var className = props.className,
      length = props.length;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('line', length, className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(PlaceholderLine, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(PlaceholderLine, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }));
}

PlaceholderLine.handledProps = ["as", "className", "length"];
PlaceholderLine.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Additional classes. */
  className: PropTypes.string,

  /** A line can specify how long its contents should appear. */
  length: PropTypes.oneOf(['full', 'very long', 'long', 'medium', 'short', 'very short'])
} : {};
/* harmony default export */ __webpack_exports__["a"] = (PlaceholderLine);

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A placeholder can contain a paragraph.
 */

function PlaceholderParagraph(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('paragraph', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(PlaceholderParagraph, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(PlaceholderParagraph, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

PlaceholderParagraph.handledProps = ["as", "children", "className", "content"];
PlaceholderParagraph.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (PlaceholderParagraph);

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A content sub-component for the Reveal.
 */

function RevealContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      hidden = props.hidden,
      visible = props.visible;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(hidden, 'hidden'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(visible, 'visible'), 'content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(RevealContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(RevealContent, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

RevealContent.handledProps = ["as", "children", "className", "content", "hidden", "visible"];
RevealContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A reveal may contain content that is visible before interaction. */
  hidden: PropTypes.bool,

  /** A reveal may contain content that is hidden before user interaction. */
  visible: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (RevealContent);

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SegmentGroup__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SegmentInline__ = __webpack_require__(1479);








/**
 * A segment is used to create a grouping of related content.
 */

function Segment(props) {
  var attached = props.attached,
      basic = props.basic,
      children = props.children,
      circular = props.circular,
      className = props.className,
      clearing = props.clearing,
      color = props.color,
      compact = props.compact,
      content = props.content,
      disabled = props.disabled,
      floated = props.floated,
      inverted = props.inverted,
      loading = props.loading,
      placeholder = props.placeholder,
      padded = props.padded,
      piled = props.piled,
      raised = props.raised,
      secondary = props.secondary,
      size = props.size,
      stacked = props.stacked,
      tertiary = props.tertiary,
      textAlign = props.textAlign,
      vertical = props.vertical;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(basic, 'basic'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(circular, 'circular'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(clearing, 'clearing'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(compact, 'compact'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(loading, 'loading'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(placeholder, 'placeholder'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(piled, 'piled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(raised, 'raised'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(secondary, 'secondary'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(stacked, 'stacked'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(tertiary, 'tertiary'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(vertical, 'vertical'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["h" /* useKeyOrValueAndKey */])(attached, 'attached'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["h" /* useKeyOrValueAndKey */])(padded, 'padded'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["n" /* useTextAlignProp */])(textAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["g" /* useValueAndKey */])(floated, 'floated'), 'segment', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(Segment, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(Segment, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

Segment.handledProps = ["as", "attached", "basic", "children", "circular", "className", "clearing", "color", "compact", "content", "disabled", "floated", "inverted", "loading", "padded", "piled", "placeholder", "raised", "secondary", "size", "stacked", "tertiary", "textAlign", "vertical"];
Segment.Group = __WEBPACK_IMPORTED_MODULE_6__SegmentGroup__["a" /* default */];
Segment.Inline = __WEBPACK_IMPORTED_MODULE_7__SegmentInline__["a" /* default */];
Segment.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Attach segment to other content, like a header. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** A basic segment has no special formatting. */
  basic: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** A segment can be circular. */
  circular: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** A segment can clear floated content. */
  clearing: PropTypes.bool,

  /** Segment can be colored. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A segment may take up only as much space as is necessary. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A segment may show its content is disabled. */
  disabled: PropTypes.bool,

  /** Segment content can be floated to the left or right. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A segment can have its colors inverted for contrast. */
  inverted: PropTypes.bool,

  /** A segment may show its content is being loaded. */
  loading: PropTypes.bool,

  /** A segment can increase its padding. */
  padded: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** A segment can be used to reserve space for conditionally displayed content. */
  placeholder: PropTypes.bool,

  /** Formatted to look like a pile of pages. */
  piled: PropTypes.bool,

  /** A segment may be formatted to raise above the page. */
  raised: PropTypes.bool,

  /** A segment can be formatted to appear less noticeable. */
  secondary: PropTypes.bool,

  /** A segment can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** Formatted to show it contains multiple pages. */
  stacked: PropTypes.bool,

  /** A segment can be formatted to appear even less noticeable. */
  tertiary: PropTypes.bool,

  /** Formats content to be aligned as part of a vertical group. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified')),

  /** Formats content to be aligned vertically. */
  vertical: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Segment);

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);






/**
 * A group of segments can be formatted to appear together.
 */

function SegmentGroup(props) {
  var children = props.children,
      className = props.className,
      compact = props.compact,
      content = props.content,
      horizontal = props.horizontal,
      piled = props.piled,
      raised = props.raised,
      size = props.size,
      stacked = props.stacked;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])('ui', size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(compact, 'compact'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(horizontal, 'horizontal'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(piled, 'piled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(raised, 'raised'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(stacked, 'stacked'), 'segments', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(SegmentGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(SegmentGroup, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

SegmentGroup.handledProps = ["as", "children", "className", "compact", "content", "horizontal", "piled", "raised", "size", "stacked"];
SegmentGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A segment may take up only as much space as is necessary. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Formats content to be aligned horizontally. */
  horizontal: PropTypes.bool,

  /** Formatted to look like a pile of pages. */
  piled: PropTypes.bool,

  /** A segment group may be formatted to raise above the page. */
  raised: PropTypes.bool,

  /** A segment group can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** Formatted to show it contains multiple pages. */
  stacked: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SegmentGroup);

/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A placeholder segment can be inline.
 */

function SegmentInline(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('inline', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(SegmentInline, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(SegmentInline, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

SegmentInline.handledProps = ["as", "children", "className", "content"];
SegmentInline.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SegmentInline);

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Icon__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StepContent__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StepDescription__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__StepGroup__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StepTitle__ = __webpack_require__(712);












/**
 * A step shows the completion status of an activity in a series of activities.
 */

var Step = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Step, _Component);

  function Step() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.computeElementType = function () {
      var onClick = _this.props.onClick;
      if (onClick) return 'a';
    };

    _this.handleClick = function (e) {
      var disabled = _this.props.disabled;
      if (!disabled) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onClick', e, _this.props);
    };

    return _this;
  }

  var _proto = Step.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        children = _this$props.children,
        className = _this$props.className,
        completed = _this$props.completed,
        content = _this$props.content,
        description = _this$props.description,
        disabled = _this$props.disabled,
        href = _this$props.href,
        icon = _this$props.icon,
        link = _this$props.link,
        title = _this$props.title;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(completed, 'completed'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(link, 'link'), 'step', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(Step, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(Step, this.props, this.computeElementType);

    if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        className: classes,
        href: href,
        onClick: this.handleClick
      }), children);
    }

    if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(content)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        className: classes,
        href: href,
        onClick: this.handleClick
      }), content);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes,
      href: href,
      onClick: this.handleClick
    }), __WEBPACK_IMPORTED_MODULE_7__Icon__["a" /* default */].create(icon, {
      autoGenerateKey: false
    }), __WEBPACK_IMPORTED_MODULE_8__StepContent__["a" /* default */].create({
      description: description,
      title: title
    }, {
      autoGenerateKey: false
    }));
  };

  return Step;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Step.handledProps = ["active", "as", "children", "className", "completed", "content", "description", "disabled", "href", "icon", "link", "onClick", "ordered", "title"];
Step.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A step can be highlighted as active. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A step can show that a user has completed it. */
  completed: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for StepDescription. */
  description: customPropTypes.itemShorthand,

  /** Show that the Loader is inactive. */
  disabled: PropTypes.bool,

  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
  href: PropTypes.string,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand,

  /** A step can be link. */
  link: PropTypes.bool,

  /**
   * Called on click. When passed, the component will render as an `a`
   * tag by default instead of a `div`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** A step can show a ordered sequence of steps. Passed from StepGroup. */
  ordered: PropTypes.bool,

  /** Shorthand for StepTitle. */
  title: customPropTypes.itemShorthand
} : {};
Step.Content = __WEBPACK_IMPORTED_MODULE_8__StepContent__["a" /* default */];
Step.Description = __WEBPACK_IMPORTED_MODULE_9__StepDescription__["a" /* default */];
Step.Group = __WEBPACK_IMPORTED_MODULE_10__StepGroup__["a" /* default */];
Step.Title = __WEBPACK_IMPORTED_MODULE_11__StepTitle__["a" /* default */];
Step.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["e" /* createShorthandFactory */])(Step, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Step);

/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StepDescription__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StepTitle__ = __webpack_require__(712);







/**
 * A step can contain a content.
 */

function StepContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      title = props.title;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(StepContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(StepContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(content)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), content);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_6__StepTitle__["a" /* default */].create(title, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_5__StepDescription__["a" /* default */].create(description, {
    autoGenerateKey: false
  }));
}

StepContent.handledProps = ["as", "children", "className", "content", "description", "title"];
StepContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for StepDescription. */
  description: customPropTypes.itemShorthand,

  /** Shorthand for StepTitle. */
  title: customPropTypes.itemShorthand
} : {};
StepContent.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(StepContent, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (StepContent);

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_values__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_keys__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_pickBy__ = __webpack_require__(3472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Step__ = __webpack_require__(1480);











var numberMap =  false ? _pickBy(numberToWordMap, function (val, key) {
  return key <= 8;
}) : {};
/**
 * A set of steps.
 */

function StepGroup(props) {
  var attached = props.attached,
      children = props.children,
      className = props.className,
      content = props.content,
      fluid = props.fluid,
      items = props.items,
      ordered = props.ordered,
      size = props.size,
      stackable = props.stackable,
      unstackable = props.unstackable,
      vertical = props.vertical,
      widths = props.widths;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])('ui', size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* useKeyOnly */])(ordered, 'ordered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* useKeyOnly */])(unstackable, 'unstackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* useKeyOnly */])(vertical, 'vertical'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["h" /* useKeyOrValueAndKey */])(attached, 'attached'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["g" /* useValueAndKey */])(stackable, 'stackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["f" /* useWidthProp */])(widths), 'steps', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["b" /* getUnhandledProps */])(StepGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["c" /* getElementType */])(StepGroup, props);

  if (!__WEBPACK_IMPORTED_MODULE_9__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_9__lib__["d" /* childrenUtils */].isNil(content)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), content);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_map__["a" /* default */])(items, function (item) {
    return __WEBPACK_IMPORTED_MODULE_10__Step__["a" /* default */].create(item);
  }));
}

StepGroup.handledProps = ["as", "attached", "children", "className", "content", "fluid", "items", "ordered", "size", "stackable", "unstackable", "vertical", "widths"];
StepGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Steps can be attached to other elements. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A fluid step takes up the width of its container. */
  fluid: PropTypes.bool,

  /** Shorthand array of props for Step. */
  items: customPropTypes.collectionShorthand,

  /** A step can show a ordered sequence of steps. */
  ordered: PropTypes.bool,

  /** Steps can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** A step can stack vertically only on smaller screens. */
  stackable: PropTypes.oneOf(['tablet']),

  /** A step can prevent itself from stacking on mobile. */
  unstackable: PropTypes.bool,

  /** A step can be displayed stacked vertically. */
  vertical: PropTypes.bool,

  /** Steps can be divided evenly inside their parent. */
  widths: PropTypes.oneOf([].concat(_keys(numberMap), _keys(numberMap).map(Number), _values(numberMap)))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (StepGroup);

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createEllipsisItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createFirstPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createPrevItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPageFactory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createNextItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createLastItem; });
/**
 * @param {number} pageNumber
 * @return {Object}
 */
var createEllipsisItem = function createEllipsisItem(pageNumber) {
  return {
    active: false,
    type: 'ellipsisItem',
    value: pageNumber
  };
};
/**
 * @return {Object}
 */

var createFirstPage = function createFirstPage() {
  return {
    active: false,
    type: 'firstItem',
    value: 1
  };
};
/**
 * @param {number} activePage
 * @return {Object}
 */

var createPrevItem = function createPrevItem(activePage) {
  return {
    active: false,
    type: 'prevItem',
    value: Math.max(1, activePage - 1)
  };
};
/**
 * @param {number} activePage
 * @return {function}
 */

var createPageFactory = function createPageFactory(activePage) {
  return function (pageNumber) {
    return {
      active: activePage === pageNumber,
      type: 'pageItem',
      value: pageNumber
    };
  };
};
/**
 * @param {number} activePage
 * @param {number} totalPages
 * @return {Object}
 */

var createNextItem = function createNextItem(activePage, totalPages) {
  return {
    active: false,
    type: 'nextItem',
    value: Math.min(activePage + 1, totalPages)
  };
};
/**
 * @param {number} totalPages
 * @return {Object}
 */

var createLastItem = function createLastItem(totalPages) {
  return {
    active: false,
    type: 'lastItem',
    value: totalPages
  };
};

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isNil__ = __webpack_require__(84);

var hasDocument = typeof document === 'object' && document !== null;
var hasWindow = typeof window === 'object' && window !== null && window.self === window; // eslint-disable-next-line no-confusing-arrow

var isBrowser = function isBrowser() {
  return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isNil__["a" /* default */])(isBrowser.override) ? isBrowser.override : hasDocument && hasWindow;
};

/* harmony default export */ __webpack_exports__["a"] = (isBrowser);

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Copy of sindre's leven, wrapped in dead code elimination for production
// https://github.com/sindresorhus/leven/blob/master/index.js

/* eslint-disable complexity, import/no-mutable-exports, no-multi-assign, no-nested-ternary, no-plusplus */
var leven = function leven() {
  return 0;
};

if (false) {
  var arr = [];
  var charCodeCache = [];

  leven = function leven(a, b) {
    if (a === b) return 0;
    var aLen = a.length;
    var bLen = b.length;
    if (aLen === 0) return bLen;
    if (bLen === 0) return aLen;
    var bCharCode;
    var ret;
    var tmp;
    var tmp2;
    var i = 0;
    var j = 0;

    while (i < aLen) {
      charCodeCache[i] = a.charCodeAt(i);
      arr[i] = ++i;
    }

    while (j < bLen) {
      bCharCode = b.charCodeAt(j);
      tmp = j++;
      ret = j;

      for (i = 0; i < aLen; i++) {
        tmp2 = bCharCode === charCodeCache[i] ? tmp : tmp + 1;
        tmp = arr[i];
        ret = arr[i] = tmp > ret ? tmp2 > ret ? ret + 1 : tmp2 : tmp2 > tmp ? tmp + 1 : tmp2;
      }
    }

    return ret;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (leven);

/***/ }),
/* 1486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AccordionAccordion; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_includes__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_es_isArray__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AccordionPanel__ = __webpack_require__(715);













var warnIfPropsAreInvalid = function warnIfPropsAreInvalid(props, state) {
  var exclusive = props.exclusive;
  var activeIndex = state.activeIndex;
  /* eslint-disable no-console */

  if (exclusive && typeof activeIndex !== 'number') {
    console.error('`activeIndex` must be a number if `exclusive` is true');
  } else if (!exclusive && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isArray__["a" /* default */])(activeIndex)) {
    console.error('`activeIndex` must be an array if `exclusive` is false');
  }
  /* eslint-enable no-console */

};
/**
 * An Accordion can contain sub-accordions.
 */


var AccordionAccordion = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(AccordionAccordion, _Component);

  function AccordionAccordion() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.computeNewIndex = function (index) {
      var exclusive = _this.props.exclusive;
      var activeIndex = _this.state.activeIndex;
      if (exclusive) return index === activeIndex ? -1 : index; // check to see if index is in array, and remove it, if not then add it

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_includes__["a" /* default */])(activeIndex, index) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_without__["a" /* default */])(activeIndex, index) : [].concat(activeIndex, [index]);
    };

    _this.handleTitleClick = function (e, titleProps) {
      var index = titleProps.index;

      _this.setState({
        activeIndex: _this.computeNewIndex(index)
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(_this.props, 'onTitleClick', e, titleProps);
    };

    _this.isIndexActive = function (index) {
      var exclusive = _this.props.exclusive;
      var activeIndex = _this.state.activeIndex;
      return exclusive ? activeIndex === index : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_includes__["a" /* default */])(activeIndex, index);
    };

    return _this;
  }

  var _proto = AccordionAccordion.prototype;

  _proto.getInitialAutoControlledState = function getInitialAutoControlledState(_ref) {
    var exclusive = _ref.exclusive;
    return {
      activeIndex: exclusive ? -1 : []
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    if (false) {
      warnIfPropsAreInvalid(this.props, this.state);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (false) {
      warnIfPropsAreInvalid(this.props, this.state);
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        panels = _this$props.panels;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])('accordion', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["b" /* getUnhandledProps */])(AccordionAccordion, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["c" /* getElementType */])(AccordionAccordion, this.props);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), __WEBPACK_IMPORTED_MODULE_10__lib__["d" /* childrenUtils */].isNil(children) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_map__["a" /* default */])(panels, function (panel, index) {
      return __WEBPACK_IMPORTED_MODULE_11__AccordionPanel__["a" /* default */].create(panel, {
        defaultProps: {
          active: _this2.isIndexActive(index),
          index: index,
          onTitleClick: _this2.handleTitleClick
        }
      });
    }) : children);
  };

  return AccordionAccordion;
}(__WEBPACK_IMPORTED_MODULE_10__lib__["q" /* ModernAutoControlledComponent */]);

AccordionAccordion.handledProps = ["activeIndex", "as", "children", "className", "defaultActiveIndex", "exclusive", "onTitleClick", "panels"];

AccordionAccordion.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Index of the currently active panel. */
  activeIndex: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number])]),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Initial activeIndex value. */
  defaultActiveIndex: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.number), PropTypes.number])]),

  /** Only allow one panel open at a time. */
  exclusive: PropTypes.bool,

  /**
   * Called when a panel title is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All item props.
   */
  onTitleClick: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.func]),

  /** Shorthand array of props for Accordion. */
  panels: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.arrayOf(PropTypes.shape({
    content: customPropTypes.itemShorthand,
    title: customPropTypes.itemShorthand
  }))])
} : {};
AccordionAccordion.defaultProps = {
  exclusive: true
};
AccordionAccordion.autoControlledProps = ['activeIndex'];
AccordionAccordion.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["e" /* createShorthandFactory */])(AccordionAccordion, function (content) {
  return {
    content: content
  };
});

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A dimmable sub-component for Dimmer.
 */

function DimmerDimmable(props) {
  var blurring = props.blurring,
      className = props.className,
      children = props.children,
      content = props.content,
      dimmed = props.dimmed;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(blurring, 'blurring'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(dimmed, 'dimmed'), 'dimmable', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(DimmerDimmable, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(DimmerDimmable, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

DimmerDimmable.handledProps = ["as", "blurring", "children", "className", "content", "dimmed"];
DimmerDimmable.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A dimmable element can blur its contents. */
  blurring: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Controls whether or not the dim is displayed. */
  dimmed: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (DimmerDimmable);

/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DimmerInner; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fluentui_react_component_ref__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(8);








/**
 * An inner element for a Dimmer.
 */

var DimmerInner = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(DimmerInner, _Component);

  function DimmerInner() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.containerRef = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["createRef"])();
    _this.contentRef = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["createRef"])();

    _this.handleClick = function (e) {
      var contentRef = _this.contentRef.current;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onClick', e, _this.props);

      if (contentRef && contentRef !== e.target && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["u" /* doesNodeContainClick */])(contentRef, e)) {
        return;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onClickOutside', e, _this.props);
    };

    return _this;
  }

  var _proto = DimmerInner.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var active = this.props.active;
    this.toggleStyles(active);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var currentActive = this.props.active;
    var prevActive = prevProps.active;
    if (prevActive !== currentActive) this.toggleStyles(currentActive);
  };

  _proto.toggleStyles = function toggleStyles(active) {
    var containerRef = this.containerRef.current;
    if (!containerRef || !containerRef.style) return;

    if (active) {
      containerRef.style.setProperty('display', 'flex', 'important');
    } else {
      containerRef.style.removeProperty('display');
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        children = _this$props.children,
        className = _this$props.className,
        content = _this$props.content,
        disabled = _this$props.disabled,
        inverted = _this$props.inverted,
        page = _this$props.page,
        simple = _this$props.simple,
        verticalAlign = _this$props.verticalAlign;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(active, 'active transition visible'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(page, 'page'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(simple, 'simple'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["i" /* useVerticalAlignProp */])(verticalAlign), 'dimmer', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["b" /* getUnhandledProps */])(DimmerInner, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["c" /* getElementType */])(DimmerInner, this.props);
    var childrenContent = __WEBPACK_IMPORTED_MODULE_7__lib__["d" /* childrenUtils */].isNil(children) ? content : children;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__fluentui_react_component_ref__["a" /* Ref */], {
      innerRef: this.containerRef
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes,
      onClick: this.handleClick
    }), childrenContent && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div", {
      className: "content",
      ref: this.contentRef
    }, childrenContent)));
  };

  return DimmerInner;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

DimmerInner.handledProps = ["active", "as", "children", "className", "content", "disabled", "inverted", "onClick", "onClickOutside", "page", "simple", "verticalAlign"];

DimmerInner.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** An active dimmer will dim its parent container. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A disabled dimmer cannot be activated */
  disabled: PropTypes.bool,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Handles click outside Dimmer's content, but inside Dimmer area.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClickOutside: PropTypes.func,

  /** A dimmer can be formatted to have its colors inverted. */
  inverted: PropTypes.bool,

  /** A dimmer can be formatted to be fixed to the page. */
  page: PropTypes.bool,

  /** A dimmer can be controlled with simple prop. */
  simple: PropTypes.bool,

  /** A dimmer can have its content top or bottom aligned. */
  verticalAlign: PropTypes.oneOf(['bottom', 'top'])
} : {};

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dimmer__ = __webpack_require__(3297);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dimmer__["a"]; });



/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A dropdown menu can contain dividers to separate related content.
 */

function DropdownDivider(props) {
  var className = props.className;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('divider', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(DropdownDivider, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(DropdownDivider, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }));
}

DropdownDivider.handledProps = ["as", "className"];
DropdownDivider.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Additional classes. */
  className: PropTypes.string
} : {};
/* harmony default export */ __webpack_exports__["a"] = (DropdownDivider);

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_Icon__ = __webpack_require__(95);






/**
 * A dropdown menu can contain a header.
 */

function DropdownHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      icon = props.icon;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(DropdownHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(DropdownHeader, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__elements_Icon__["a" /* default */].create(icon, {
    autoGenerateKey: false
  }), content);
}

DropdownHeader.handledProps = ["as", "children", "className", "content", "icon"];
DropdownHeader.propTypes =  false ? {
  /** An element type to render as (string or function) */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand
} : {};
DropdownHeader.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(DropdownHeader, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (DropdownHeader);

/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isNil__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_Flag__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__elements_Icon__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__elements_Image__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__elements_Label__ = __webpack_require__(354);












/**
 * An item sub-component for Dropdown component.
 */

var DropdownItem = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(DropdownItem, _Component);

  function DropdownItem() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleClick = function (e) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(_this.props, 'onClick', e, _this.props);
    };

    return _this;
  }

  var _proto = DropdownItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        children = _this$props.children,
        className = _this$props.className,
        content = _this$props.content,
        disabled = _this$props.disabled,
        description = _this$props.description,
        flag = _this$props.flag,
        icon = _this$props.icon,
        image = _this$props.image,
        label = _this$props.label,
        selected = _this$props.selected,
        text = _this$props.text;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(selected, 'selected'), 'item', className); // add default dropdown icon if item contains another menu

    var iconName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isNil__["a" /* default */])(icon) ? __WEBPACK_IMPORTED_MODULE_7__lib__["d" /* childrenUtils */].someByType(children, 'DropdownMenu') && 'dropdown' : icon;
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["b" /* getUnhandledProps */])(DropdownItem, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["c" /* getElementType */])(DropdownItem, this.props);
    var ariaOptions = {
      role: 'option',
      'aria-disabled': disabled,
      'aria-checked': active,
      'aria-selected': selected
    };

    if (!__WEBPACK_IMPORTED_MODULE_7__lib__["d" /* childrenUtils */].isNil(children)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, ariaOptions, {
        className: classes,
        onClick: this.handleClick
      }), children);
    }

    var flagElement = __WEBPACK_IMPORTED_MODULE_8__elements_Flag__["a" /* default */].create(flag, {
      autoGenerateKey: false
    });
    var iconElement = __WEBPACK_IMPORTED_MODULE_9__elements_Icon__["a" /* default */].create(iconName, {
      autoGenerateKey: false
    });
    var imageElement = __WEBPACK_IMPORTED_MODULE_10__elements_Image__["a" /* default */].create(image, {
      autoGenerateKey: false
    });
    var labelElement = __WEBPACK_IMPORTED_MODULE_11__elements_Label__["a" /* default */].create(label, {
      autoGenerateKey: false
    });
    var descriptionElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["j" /* createShorthand */])('span', function (val) {
      return {
        children: val
      };
    }, description, {
      defaultProps: {
        className: 'description'
      },
      autoGenerateKey: false
    });
    var textElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["j" /* createShorthand */])('span', function (val) {
      return {
        children: val
      };
    }, __WEBPACK_IMPORTED_MODULE_7__lib__["d" /* childrenUtils */].isNil(content) ? text : content, {
      defaultProps: {
        className: 'text'
      },
      autoGenerateKey: false
    });
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, ariaOptions, {
      className: classes,
      onClick: this.handleClick
    }), imageElement, iconElement, flagElement, labelElement, descriptionElement, textElement);
  };

  return DropdownItem;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

DropdownItem.handledProps = ["active", "as", "children", "className", "content", "description", "disabled", "flag", "icon", "image", "label", "onClick", "selected", "text", "value"];
DropdownItem.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Style as the currently chosen item. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Additional text with less emphasis. */
  description: customPropTypes.itemShorthand,

  /** A dropdown item can be disabled. */
  disabled: PropTypes.bool,

  /** Shorthand for Flag. */
  flag: customPropTypes.itemShorthand,

  /** Shorthand for Icon. */
  icon: customPropTypes.itemShorthand,

  /** Shorthand for Image. */
  image: customPropTypes.itemShorthand,

  /** Shorthand for Label. */
  label: customPropTypes.itemShorthand,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * The item currently selected by keyboard shortcut.
   * This is not the active item.
   */
  selected: PropTypes.bool,

  /** Display text. */
  text: customPropTypes.contentShorthand,

  /** Stored value. */
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string])
} : {};
DropdownItem.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["e" /* createShorthandFactory */])(DropdownItem, function (opts) {
  return opts;
});
/* harmony default export */ __webpack_exports__["a"] = (DropdownItem);

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A dropdown menu can contain a menu.
 */

function DropdownMenu(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      direction = props.direction,
      open = props.open,
      scrolling = props.scrolling;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(direction, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(open, 'visible'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(scrolling, 'scrolling'), 'menu transition', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(DropdownMenu, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(DropdownMenu, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

DropdownMenu.handledProps = ["as", "children", "className", "content", "direction", "open", "scrolling"];
DropdownMenu.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A dropdown menu can open to the left or to the right. */
  direction: PropTypes.oneOf(['left', 'right']),

  /** Whether or not the dropdown menu is displayed. */
  open: PropTypes.bool,

  /** A dropdown menu can scroll. */
  scrolling: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (DropdownMenu);

/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_get__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(8);








/**
 * A search item sub-component for Dropdown component.
 */

var DropdownSearchInput = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(DropdownSearchInput, _Component);

  function DropdownSearchInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleChange = function (e) {
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_get__["a" /* default */])(e, 'target.value');

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onChange', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        value: value
      }));
    };

    return _this;
  }

  var _proto = DropdownSearchInput.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        autoComplete = _this$props.autoComplete,
        className = _this$props.className,
        tabIndex = _this$props.tabIndex,
        type = _this$props.type,
        value = _this$props.value;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])('search', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["b" /* getUnhandledProps */])(DropdownSearchInput, this.props);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("input", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      "aria-autocomplete": "list",
      autoComplete: autoComplete,
      className: classes,
      onChange: this.handleChange,
      tabIndex: tabIndex,
      type: type,
      value: value
    }));
  };

  return DropdownSearchInput;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

DropdownSearchInput.handledProps = ["as", "autoComplete", "className", "tabIndex", "type", "value"];
DropdownSearchInput.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** An input can have the auto complete. */
  autoComplete: PropTypes.string,

  /** Additional classes. */
  className: PropTypes.string,

  /** An input can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** The HTML input type. */
  type: PropTypes.string,

  /** Stored value. */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
DropdownSearchInput.defaultProps = {
  autoComplete: 'off',
  type: 'text'
};
DropdownSearchInput.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["e" /* createShorthandFactory */])(DropdownSearchInput, function (type) {
  return {
    type: type
  };
});
/* harmony default export */ __webpack_exports__["a"] = (DropdownSearchInput);

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A dropdown contains a selected value.
 */

function DropdownText(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('divider', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(DropdownText, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(DropdownText, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-atomic": true,
    "aria-live": "polite",
    role: "alert"
  }, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

DropdownText.handledProps = ["as", "children", "className", "content"];
DropdownText.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
DropdownText.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(DropdownText, function (val) {
  return {
    content: val
  };
});
/* harmony default export */ __webpack_exports__["a"] = (DropdownText);

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMenuOptions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_some__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_escapeRegExp__ = __webpack_require__(3456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_deburr__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isFunction__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_includes__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_filter__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);






 // There are times when we need to calculate the options based on a value
// that hasn't yet been persisted to state.

function getMenuOptions(config) {
  var additionLabel = config.additionLabel,
      additionPosition = config.additionPosition,
      allowAdditions = config.allowAdditions,
      deburr = config.deburr,
      multiple = config.multiple,
      options = config.options,
      search = config.search,
      searchQuery = config.searchQuery,
      value = config.value;
  var filteredOptions = options; // filter out active options

  if (multiple) {
    filteredOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_filter__["a" /* default */])(filteredOptions, function (opt) {
      return !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_includes__["a" /* default */])(value, opt.value);
    });
  } // filter by search query


  if (search && searchQuery) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isFunction__["a" /* default */])(search)) {
      filteredOptions = search(filteredOptions, searchQuery);
    } else {
      // remove diacritics on search input and options, if deburr prop is set
      var strippedQuery = deburr ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_deburr__["a" /* default */])(searchQuery) : searchQuery;
      var re = new RegExp(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_escapeRegExp__["a" /* default */])(strippedQuery), 'i');
      filteredOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_filter__["a" /* default */])(filteredOptions, function (opt) {
        return re.test(deburr ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_deburr__["a" /* default */])(opt.text) : opt.text);
      });
    }
  } // insert the "add" item


  if (allowAdditions && search && searchQuery && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_some__["a" /* default */])(filteredOptions, {
    text: searchQuery
  })) {
    var additionLabelElement = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(additionLabel) ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(additionLabel, {
      key: 'addition-label'
    }) : additionLabel || '';
    var addItem = {
      key: 'addition',
      // by using an array, we can pass multiple elements, but when doing so
      // we must specify a `key` for React to know which one is which
      text: [additionLabelElement, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("b", {
        key: "addition-query"
      }, searchQuery)],
      value: searchQuery,
      className: 'addition',
      'data-additional': true
    };
    if (additionPosition === 'top') filteredOptions.unshift(addItem);else filteredOptions.push(addItem);
  }

  return filteredOptions;
}
getMenuOptions.handledProps = [];

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModalActions; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_Button__ = __webpack_require__(469);









/**
 * A modal can contain a row of actions.
 */

var ModalActions = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ModalActions, _Component);

  function ModalActions() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleButtonOverrides = function (predefinedProps) {
      return {
        onClick: function onClick(e, buttonProps) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(predefinedProps, 'onClick', e, buttonProps);

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(_this.props, 'onActionClick', e, buttonProps);
        }
      };
    };

    return _this;
  }

  var _proto = ModalActions.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        actions = _this$props.actions,
        children = _this$props.children,
        className = _this$props.className,
        content = _this$props.content;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])('actions', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["b" /* getUnhandledProps */])(ModalActions, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["c" /* getElementType */])(ModalActions, this.props);

    if (!__WEBPACK_IMPORTED_MODULE_7__lib__["d" /* childrenUtils */].isNil(children)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        className: classes
      }), children);
    }

    if (!__WEBPACK_IMPORTED_MODULE_7__lib__["d" /* childrenUtils */].isNil(content)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        className: classes
      }), content);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_map__["a" /* default */])(actions, function (action) {
      return __WEBPACK_IMPORTED_MODULE_8__elements_Button__["a" /* default */].create(action, {
        overrideProps: _this2.handleButtonOverrides
      });
    }));
  };

  return ModalActions;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

ModalActions.handledProps = ["actions", "as", "children", "className", "content", "onActionClick"];

ModalActions.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Array of shorthand buttons. */
  actions: customPropTypes.collectionShorthand,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /**
   * Action onClick handler when using shorthand `actions`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props from the clicked action.
   */
  onActionClick: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.func])
} : {};
ModalActions.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["e" /* createShorthandFactory */])(ModalActions, function (actions) {
  return {
    actions: actions
  };
});

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A modal can contain content.
 */

function ModalContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      image = props.image,
      scrolling = props.scrolling;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(className, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(image, 'image'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(scrolling, 'scrolling'), 'content');
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ModalContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ModalContent, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ModalContent.handledProps = ["as", "children", "className", "content", "image", "scrolling"];
ModalContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A modal can contain image content. */
  image: PropTypes.bool,

  /** A modal can use the entire size of the screen. */
  scrolling: PropTypes.bool
} : {};
ModalContent.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ModalContent, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ModalContent);

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A modal can contain a description with one or more paragraphs.
 */

function ModalDescription(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('description', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ModalDescription, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ModalDescription, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ModalDescription.handledProps = ["as", "children", "className", "content"];
ModalDescription.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ModalDescription);

/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fluentui_react_component_ref__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);






/**
 * A modal has a dimmer.
 */

function ModalDimmer(props) {
  var blurring = props.blurring,
      children = props.children,
      className = props.className,
      centered = props.centered,
      content = props.content,
      inverted = props.inverted,
      mountNode = props.mountNode,
      scrolling = props.scrolling;
  var ref = __WEBPACK_IMPORTED_MODULE_4_react___default.a.useRef();
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(!centered, 'top aligned'), 'page modals dimmer transition visible active', className);
  var bodyClasses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])('dimmable dimmed', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(blurring, 'blurring'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(scrolling, 'scrolling'));
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(ModalDimmer, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(ModalDimmer, props);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["x" /* useClassNamesOnNode */])(mountNode, bodyClasses);
  __WEBPACK_IMPORTED_MODULE_4_react___default.a.useEffect(function () {
    if (ref.current && ref.current.style) {
      ref.current.style.setProperty('display', 'flex', 'important');
    }
  }, []);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__fluentui_react_component_ref__["a" /* Ref */], {
    innerRef: ref
  }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children));
}

ModalDimmer.handledProps = ["as", "blurring", "centered", "children", "className", "content", "inverted", "mountNode", "scrolling"];
ModalDimmer.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A dimmer can be blurred. */
  blurring: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A dimmer can center its contents in the viewport. */
  centered: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A dimmer can be inverted. */
  inverted: PropTypes.bool,

  /** The node where the modal should mount. Defaults to document.body. */
  mountNode: PropTypes.any,

  /** A dimmer can make body scrollable. */
  scrolling: PropTypes.bool
} : {};
ModalDimmer.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["e" /* createShorthandFactory */])(ModalDimmer, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ModalDimmer);

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A modal can have a header.
 */

function ModalHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ModalHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ModalHeader, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

ModalHeader.handledProps = ["as", "children", "className", "content"];
ModalHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
ModalHeader.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(ModalHeader, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ModalHeader);

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(3302);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Modal__["a"]; });



/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PopupContent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A PopupContent displays the content body of a Popover.
 */

function PopupContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(PopupContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(PopupContent, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}
PopupContent.handledProps = ["as", "children", "className", "content"];
PopupContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** The content of the Popup */
  children: PropTypes.node,

  /** Classes to add to the Popup content className. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
PopupContent.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(PopupContent, function (children) {
  return {
    children: children
  };
});

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PopupHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A PopupHeader displays a header in a Popover.
 */

function PopupHeader(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(PopupHeader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(PopupHeader, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}
PopupHeader.handledProps = ["as", "children", "className", "content"];
PopupHeader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
PopupHeader.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(PopupHeader, function (children) {
  return {
    children: children
  };
});

/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RatingIcon; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_keyboard_key__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_keyboard_key___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_keyboard_key__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(8);








/**
 * An internal icon sub-component for Rating component
 */

var RatingIcon = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(RatingIcon, _Component);

  function RatingIcon() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleClick = function (e) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onClick', e, _this.props);
    };

    _this.handleKeyUp = function (e) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onKeyUp', e, _this.props);

      switch (__WEBPACK_IMPORTED_MODULE_4_keyboard_key___default.a.getCode(e)) {
        case __WEBPACK_IMPORTED_MODULE_4_keyboard_key___default.a.Enter:
        case __WEBPACK_IMPORTED_MODULE_4_keyboard_key___default.a.Spacebar:
          e.preventDefault();

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onClick', e, _this.props);

          break;

        default:
      }
    };

    _this.handleMouseEnter = function (e) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onMouseEnter', e, _this.props);
    };

    return _this;
  }

  var _proto = RatingIcon.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        className = _this$props.className,
        selected = _this$props.selected;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(selected, 'selected'), 'icon', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["b" /* getUnhandledProps */])(RatingIcon, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["c" /* getElementType */])(RatingIcon, this.props);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes,
      onClick: this.handleClick,
      onKeyUp: this.handleKeyUp,
      onMouseEnter: this.handleMouseEnter,
      role: "radio"
    }));
  };

  return RatingIcon;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

RatingIcon.handledProps = ["active", "as", "className", "index", "onClick", "onKeyUp", "onMouseEnter", "selected"];

RatingIcon.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Indicates activity of an icon. */
  active: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** An index of icon inside Rating. */
  index: PropTypes.number,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Called on keyup.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onKeyUp: PropTypes.func,

  /**
   * Called on mouseenter.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onMouseEnter: PropTypes.func,

  /** Indicates selection of an icon. */
  selected: PropTypes.bool
} : {};
RatingIcon.defaultProps = {
  as: 'i'
};

/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SearchCategoryLayout__ = __webpack_require__(3313);







function SearchCategory(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      content = props.content,
      layoutRenderer = props.layoutRenderer,
      renderer = props.renderer;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(active, 'active'), 'category', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(SearchCategory, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(SearchCategory, props);
  var categoryContent = renderer(props);
  var resultsContent = __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), layoutRenderer({
    categoryContent: categoryContent,
    resultsContent: resultsContent
  }));
}

SearchCategory.handledProps = ["active", "as", "children", "className", "content", "layoutRenderer", "name", "renderer", "results"];
SearchCategory.defaultProps = {
  layoutRenderer: __WEBPACK_IMPORTED_MODULE_5__SearchCategoryLayout__["a" /* default */],
  renderer: function renderer(_ref) {
    var name = _ref.name;
    return name;
  }
};
SearchCategory.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** The item currently selected by keyboard shortcut. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Display name. */
  name: PropTypes.string,

  /**
   * Renders the category layout contents.
   *
   * @param {object} props - The SearchCategoryLayout props object.
   * @returns {*} - Renderable category layout contents.
   */
  layoutRenderer: PropTypes.func,

  /**
   * Renders the category contents.
   *
   * @param {object} props - The SearchCategory props object.
   * @returns {*} - Renderable category contents.
   */
  renderer: PropTypes.func,

  /** Array of Search.Result props. */
  results: PropTypes.array
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SearchCategory);

/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SearchResult; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);





 // Note: You technically only need the 'content' wrapper when there's an
// image. However, optionally wrapping it makes this function a lot more
// complicated and harder to read. Since always wrapping it doesn't affect
// the style in any way let's just do that.
//
// Note: To avoid requiring a wrapping div, we return an array here so to
// prevent rendering issues each node needs a unique key.

var defaultRenderer = function defaultRenderer(_ref) {
  var image = _ref.image,
      price = _ref.price,
      title = _ref.title,
      description = _ref.description;
  return [image && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
    key: "image",
    className: "image"
  }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["k" /* createHTMLImage */])(image, {
    autoGenerateKey: false
  })), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
    key: "content",
    className: "content"
  }, price && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
    className: "price"
  }, price), title && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
    className: "title"
  }, title), description && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
    className: "description"
  }, description))];
};

defaultRenderer.handledProps = [];

var SearchResult = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(SearchResult, _Component);

  function SearchResult() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleClick = function (e) {
      var onClick = _this.props.onClick;
      if (onClick) onClick(e, _this.props);
    };

    return _this;
  }

  var _proto = SearchResult.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        className = _this$props.className,
        renderer = _this$props.renderer;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(active, 'active'), 'result', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(SearchResult, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(SearchResult, this.props); // Note: You technically only need the 'content' wrapper when there's an
    // image. However, optionally wrapping it makes this function a lot more
    // complicated and harder to read. Since always wrapping it doesn't affect
    // the style in any way let's just do that.

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes,
      onClick: this.handleClick
    }), renderer(this.props));
  };

  return SearchResult;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

SearchResult.handledProps = ["active", "as", "className", "content", "description", "id", "image", "onClick", "price", "renderer", "title"];

SearchResult.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** The item currently selected by keyboard shortcut. */
  active: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Additional text with less emphasis. */
  description: PropTypes.string,

  /** A unique identifier. */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Add an image to the item. */
  image: PropTypes.string,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** Customized text for price. */
  price: PropTypes.string,

  /**
   * Renders the result contents.
   *
   * @param {object} props - The SearchResult props object.
   * @returns {*} - Renderable result contents.
   */
  renderer: PropTypes.func,

  /** Display title. */
  title: PropTypes.string.isRequired
} : {};
SearchResult.defaultProps = {
  renderer: defaultRenderer
};

/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);






function SearchResults(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('results transition', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(SearchResults, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(SearchResults, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

SearchResults.handledProps = ["as", "children", "className", "content"];
SearchResults.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SearchResults);

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A pushable sub-component for Sidebar.
 */

function SidebarPushable(props) {
  var className = props.className,
      children = props.children,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('pushable', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(SidebarPushable, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(SidebarPushable, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

SidebarPushable.handledProps = ["as", "children", "className", "content"];
SidebarPushable.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SidebarPushable);

/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A pushable sub-component for Sidebar.
 */

function SidebarPusher(props) {
  var className = props.className,
      dimmed = props.dimmed,
      children = props.children,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('pusher', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(dimmed, 'dimmed'), className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(SidebarPusher, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(SidebarPusher, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

SidebarPusher.handledProps = ["as", "children", "className", "content", "dimmed"];
SidebarPusher.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Controls whether or not the dim is displayed. */
  dimmed: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SidebarPusher);

/***/ }),
/* 1511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__elements_Segment_Segment__ = __webpack_require__(1477);






/**
 * A tab pane holds the content of a tab.
 */

function TabPane(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      content = props.content,
      loading = props.loading;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(loading, 'loading'), 'tab', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(TabPane, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(TabPane, props);
  var calculatedDefaultProps = {};

  if (ElementType === __WEBPACK_IMPORTED_MODULE_5__elements_Segment_Segment__["a" /* default */]) {
    calculatedDefaultProps.attached = 'bottom';
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, calculatedDefaultProps, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

TabPane.handledProps = ["active", "as", "children", "className", "content", "loading"];
TabPane.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_5__elements_Segment_Segment__["a" /* default */],
  active: true
};
TabPane.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A tab pane can be active. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A Tab.Pane can display a loading indicator. */
  loading: PropTypes.bool
} : {};
TabPane.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(TabPane, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (TabPane);

/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Transition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_includes__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_get__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TransitionGroup__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__ = __webpack_require__(1515);







var _TRANSITION_CALLBACK_, _TRANSITION_STYLE_TYP;







var TRANSITION_CALLBACK_TYPE = (_TRANSITION_CALLBACK_ = {}, _TRANSITION_CALLBACK_[__WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__["a" /* TRANSITION_STATUS_ENTERED */]] = 'show', _TRANSITION_CALLBACK_[__WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__["b" /* TRANSITION_STATUS_EXITED */]] = 'hide', _TRANSITION_CALLBACK_);
var TRANSITION_STYLE_TYPE = (_TRANSITION_STYLE_TYP = {}, _TRANSITION_STYLE_TYP[__WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__["c" /* TRANSITION_STATUS_ENTERING */]] = 'show', _TRANSITION_STYLE_TYP[__WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__["d" /* TRANSITION_STATUS_EXITING */]] = 'hide', _TRANSITION_STYLE_TYP);
/**
 * A transition is an animation usually used to move content in or out of view.
 */

var Transition = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Transition, _Component);

  function Transition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      status: __WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__["e" /* TRANSITION_STATUS_INITIAL */]
    };

    _this.handleStart = function (nextStatus) {
      var duration = _this.props.duration;
      var durationType = TRANSITION_CALLBACK_TYPE[nextStatus];
      var durationValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["o" /* normalizeTransitionDuration */])(duration, durationType);
      _this.timeoutId = setTimeout(function () {
        return _this.setState({
          status: nextStatus
        });
      }, durationValue);
    };

    _this.updateStatus = function (prevState) {
      if (prevState.status !== _this.state.status) {
        // Timeout should be cleared in any case as previous can lead set to unexpected `nextStatus`
        clearTimeout(_this.timeoutId);

        if (_this.state.nextStatus) {
          _this.handleStart(_this.state.nextStatus);
        }
      }

      if (!prevState.animating && _this.state.animating) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_invoke__["a" /* default */])(_this.props, 'onStart', null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
          status: _this.state.status
        }));
      }

      if (prevState.animating && !_this.state.animating) {
        var callback = _this.state.status === __WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__["a" /* TRANSITION_STATUS_ENTERED */] ? 'onShow' : 'onHide';

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_invoke__["a" /* default */])(_this.props, 'onComplete', null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
          status: _this.state.status
        }));

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_invoke__["a" /* default */])(_this.props, callback, null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
          status: _this.state.status
        }));
      }
    };

    _this.computeClasses = function () {
      var _this$props = _this.props,
          animation = _this$props.animation,
          directional = _this$props.directional,
          children = _this$props.children;
      var _this$state = _this.state,
          animating = _this$state.animating,
          status = _this$state.status;

      var childClasses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_get__["a" /* default */])(children, 'props.className');

      var isDirectional = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])(directional) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_includes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_9__lib__["p" /* SUI */].DIRECTIONAL_TRANSITIONS, animation) : directional;

      if (isDirectional) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(animation, childClasses, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* useKeyOnly */])(animating, 'animating'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* useKeyOnly */])(status === __WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__["c" /* TRANSITION_STATUS_ENTERING */], 'in'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* useKeyOnly */])(status === __WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__["d" /* TRANSITION_STATUS_EXITING */], 'out'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* useKeyOnly */])(status === __WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__["b" /* TRANSITION_STATUS_EXITED */], 'hidden'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* useKeyOnly */])(status !== __WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__["b" /* TRANSITION_STATUS_EXITED */], 'visible'), 'transition');
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(animation, childClasses, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* useKeyOnly */])(animating, 'animating transition'));
    };

    _this.computeStyle = function () {
      var _this$props2 = _this.props,
          children = _this$props2.children,
          duration = _this$props2.duration;
      var status = _this.state.status;

      var childStyle = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_get__["a" /* default */])(children, 'props.style');

      var type = TRANSITION_STYLE_TYPE[status];
      var animationDuration = type && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["o" /* normalizeTransitionDuration */])(duration, type) + "ms";
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, childStyle, {
        animationDuration: animationDuration
      });
    };

    return _this;
  }

  // ----------------------------------------
  // Lifecycle
  // ----------------------------------------
  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var derivedState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__["f" /* computeStatuses */])({
      mountOnShow: props.mountOnShow,
      status: state.status,
      transitionOnMount: props.transitionOnMount,
      visible: props.visible,
      unmountOnHide: props.unmountOnHide
    });
    return derivedState;
  };

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus({});
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    this.updateStatus(prevState);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeoutId);
  } // ----------------------------------------
  // Callback handling
  // ----------------------------------------
  ;

  // ----------------------------------------
  // Render
  // ----------------------------------------
  _proto.render = function render() {
    var children = this.props.children;
    var status = this.state.status;

    if (status === __WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__["g" /* TRANSITION_STATUS_UNMOUNTED */]) {
      return null;
    }

    return /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react__["cloneElement"])(children, {
      className: this.computeClasses(),
      style: this.computeStyle()
    });
  };

  return Transition;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

Transition.INITIAL = __WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__["e" /* TRANSITION_STATUS_INITIAL */];
Transition.ENTERED = __WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__["a" /* TRANSITION_STATUS_ENTERED */];
Transition.ENTERING = __WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__["c" /* TRANSITION_STATUS_ENTERING */];
Transition.EXITED = __WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__["b" /* TRANSITION_STATUS_EXITED */];
Transition.EXITING = __WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__["d" /* TRANSITION_STATUS_EXITING */];
Transition.UNMOUNTED = __WEBPACK_IMPORTED_MODULE_11__utils_computeStatuses__["g" /* TRANSITION_STATUS_UNMOUNTED */];
Transition.Group = __WEBPACK_IMPORTED_MODULE_10__TransitionGroup__["a" /* default */];
Transition.handledProps = ["animation", "children", "directional", "duration", "mountOnShow", "onComplete", "onHide", "onShow", "onStart", "reactKey", "transitionOnMount", "unmountOnHide", "visible"];

Transition.propTypes =  false ? {
  /** Named animation event to used. Must be defined in CSS. */
  animation: PropTypes.oneOfType([PropTypes.oneOf(SUI.TRANSITIONS), PropTypes.string]),

  /** Primary content. */
  children: PropTypes.element.isRequired,

  /** Whether it is directional animation event or not. Use it only for custom transitions. */
  directional: PropTypes.bool,

  /** Duration of the CSS transition animation in milliseconds. */
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    hide: PropTypes.number,
    show: PropTypes.number
  }), PropTypes.string]),

  /** Show the component; triggers the enter or exit animation. */
  visible: PropTypes.bool,

  /** Wait until the first "enter" transition to mount the component (add it to the DOM). */
  mountOnShow: PropTypes.bool,

  /**
   * Callback on each transition that changes visibility to shown.
   *
   * @param {null}
   * @param {object} data - All props with status.
   */
  onComplete: PropTypes.func,

  /**
   * Callback on each transition that changes visibility to hidden.
   *
   * @param {null}
   * @param {object} data - All props with status.
   */
  onHide: PropTypes.func,

  /**
   * Callback on each transition that changes visibility to shown.
   *
   * @param {null}
   * @param {object} data - All props with status.
   */
  onShow: PropTypes.func,

  /**
   * Callback on animation start.
   *
   * @param {null}
   * @param {object} data - All props with status.
   */
  onStart: PropTypes.func,

  /** React's key of the element. */
  reactKey: PropTypes.string,

  /** Run the enter animation when the component mounts, if it is initially shown. */
  transitionOnMount: PropTypes.bool,

  /** Unmount the component (remove it from the DOM) when it is not shown. */
  unmountOnHide: PropTypes.bool
} : {};
Transition.defaultProps = {
  animation: 'fade',
  duration: 500,
  visible: true,
  mountOnShow: true,
  transitionOnMount: false,
  unmountOnHide: false
};

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TransitionGroup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_values__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_get__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_has__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_forEach__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_es_mapValues__ = __webpack_require__(3469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_childMapping__ = __webpack_require__(3321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_wrapChild__ = __webpack_require__(3322);













/**
 * A Transition.Group animates children as they mount and unmount.
 */
var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(TransitionGroup, _React$Component);

  function TransitionGroup() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      // Keeping a callback under the state is a hack to make it accessible under getDerivedStateFromProps()
      handleOnHide: function handleOnHide(nothing, childProps) {
        var reactKey = childProps.reactKey;

        _this.setState(function (state) {
          var children = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state.children);

          delete children[reactKey];
          return {
            children: children
          };
        });
      }
    };
    return _this;
  }

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var animation = props.animation,
        duration = props.duration,
        directional = props.directional;
    var prevMapping = state.children; // A short circuit for an initial render as there will be no `prevMapping`

    if (typeof prevMapping === 'undefined') {
      return {
        children: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash_es_mapValues__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_childMapping__["a" /* getChildMapping */])(props.children), function (child) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_wrapChild__["a" /* default */])(child, state.handleOnHide, {
            animation: animation,
            duration: duration,
            directional: directional
          });
        })
      };
    }

    var nextMapping = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_childMapping__["a" /* getChildMapping */])(props.children);
    var children = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_childMapping__["b" /* mergeChildMappings */])(prevMapping, nextMapping);

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_forEach__["a" /* default */])(children, function (child, key) {
      var hasPrev = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_has__["a" /* default */])(prevMapping, key);

      var hasNext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_has__["a" /* default */])(nextMapping, key);

      var prevChild = prevMapping[key];
      var isLeaving = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_get__["a" /* default */])(prevChild, 'props.visible'); // Heads up!
      // An item is new (entering), it will be picked from `nextChildren`, so it should be wrapped

      if (hasNext && (!hasPrev || isLeaving)) {
        children[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_wrapChild__["a" /* default */])(child, state.handleOnHide, {
          animation: animation,
          duration: duration,
          directional: directional,
          transitionOnMount: true
        });
        return;
      } // Heads up!
      // An item is old (exiting), it will be picked from `prevChildren`, so it has been already
      // wrapped, so should be only updated


      if (!hasNext && hasPrev && !isLeaving) {
        children[key] = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.cloneElement(prevChild, {
          visible: false
        });
        return;
      } // Heads up!
      // An item item hasn't changed transition states, but it will be picked from `nextChildren`,
      // so we should wrap it again


      var _prevChild$props = prevChild.props,
          visible = _prevChild$props.visible,
          transitionOnMount = _prevChild$props.transitionOnMount;
      children[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_wrapChild__["a" /* default */])(child, state.handleOnHide, {
        animation: animation,
        duration: duration,
        directional: directional,
        transitionOnMount: transitionOnMount,
        visible: visible
      });
    });

    return {
      children: children
    };
  };

  var _proto = TransitionGroup.prototype;

  _proto.render = function render() {
    var children = this.state.children;
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["c" /* getElementType */])(TransitionGroup, this.props);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["b" /* getUnhandledProps */])(TransitionGroup, this.props);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ElementType, rest, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_values__["a" /* default */])(children));
  };

  return TransitionGroup;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);

TransitionGroup.handledProps = ["animation", "as", "children", "directional", "duration"];

TransitionGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Named animation event to used. Must be defined in CSS. */
  animation: PropTypes.oneOfType([PropTypes.oneOf(SUI.TRANSITIONS), PropTypes.string]),

  /** Primary content. */
  children: PropTypes.node,

  /** Whether it is directional animation event or not. Use it only for custom transitions. */
  directional: PropTypes.bool,

  /** Duration of the CSS transition animation in milliseconds. */
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    hide: PropTypes.number.isRequired,
    show: PropTypes.number.isRequired
  }), PropTypes.string])
} : {};
TransitionGroup.defaultProps = {
  as: __WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,
  animation: 'fade',
  duration: 500
};

/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Transition__ = __webpack_require__(1512);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Transition__["a"]; });



/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return TRANSITION_STATUS_INITIAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRANSITION_STATUS_ENTERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRANSITION_STATUS_ENTERING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRANSITION_STATUS_EXITED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRANSITION_STATUS_EXITING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return TRANSITION_STATUS_UNMOUNTED; });
/* harmony export (immutable) */ __webpack_exports__["f"] = computeStatuses;
var TRANSITION_STATUS_INITIAL = 'INITIAL';
var TRANSITION_STATUS_ENTERED = 'ENTERED';
var TRANSITION_STATUS_ENTERING = 'ENTERING';
var TRANSITION_STATUS_EXITED = 'EXITED';
var TRANSITION_STATUS_EXITING = 'EXITING';
var TRANSITION_STATUS_UNMOUNTED = 'UNMOUNTED';
/**
 * @param {Object} [options]
 * @param {String} [options.status]
 * @param {Boolean} [options.mountOnShow]
 * @param {Boolean} [options.transitionOnMount]
 * @param {Boolean} [options.visible]
 * @param {Boolean} [options.unmountOnHide]
 */

function computeStatuses(options) {
  var mountOnShow = options.mountOnShow,
      status = options.status,
      transitionOnMount = options.transitionOnMount,
      visible = options.visible,
      unmountOnHide = options.unmountOnHide;

  if (visible) {
    if (status === TRANSITION_STATUS_INITIAL) {
      if (transitionOnMount) {
        return {
          animating: true,
          status: TRANSITION_STATUS_ENTERING,
          nextStatus: TRANSITION_STATUS_ENTERED
        };
      }

      return {
        animating: false,
        status: TRANSITION_STATUS_ENTERED,
        nextStatus: undefined
      };
    }

    if (status === TRANSITION_STATUS_UNMOUNTED) {
      return {
        animating: true,
        status: TRANSITION_STATUS_ENTERING,
        nextStatus: TRANSITION_STATUS_ENTERED
      };
    }

    if (status === TRANSITION_STATUS_EXITED || status === TRANSITION_STATUS_EXITING) {
      return {
        animating: true,
        status: TRANSITION_STATUS_ENTERING,
        nextStatus: TRANSITION_STATUS_ENTERED
      };
    }

    if (status === TRANSITION_STATUS_ENTERING) {
      return {};
    }
    /* istanbul ignore else */


    if (status === TRANSITION_STATUS_ENTERED) {
      return {
        animating: false,
        status: TRANSITION_STATUS_ENTERED,
        nextStatus: undefined
      };
    }
  }

  if (status === TRANSITION_STATUS_INITIAL) {
    if (mountOnShow || unmountOnHide) {
      return {
        animating: false,
        status: TRANSITION_STATUS_UNMOUNTED,
        nextStatus: undefined
      };
    }

    return {
      animating: false,
      status: TRANSITION_STATUS_EXITED,
      nextStatus: undefined
    };
  }

  if (status === TRANSITION_STATUS_ENTERED || status === TRANSITION_STATUS_ENTERING) {
    return {
      animating: true,
      status: TRANSITION_STATUS_EXITING,
      nextStatus: unmountOnHide ? TRANSITION_STATUS_UNMOUNTED : TRANSITION_STATUS_EXITED
    };
  }

  if (status === TRANSITION_STATUS_EXITING) {
    return {};
  }

  if (status === TRANSITION_STATUS_EXITED) {
    return {
      animating: false,
      status: TRANSITION_STATUS_EXITED,
      nextStatus: undefined
    };
  }
  /* istanbul ignore else */


  if (status === TRANSITION_STATUS_UNMOUNTED) {
    return {
      animating: false,
      status: TRANSITION_STATUS_UNMOUNTED,
      nextStatus: undefined
    };
  }
  /* istanbul ignore next */


  throw new Error("Transition:computeStatuses(): an unexpected status transition: { visible: " + visible + ", status: " + status + " }");
}

/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Card; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_Image__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CardContent__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CardDescription__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CardGroup__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CardHeader__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CardMeta__ = __webpack_require__(719);












/**
 * A card displays site content in a manner similar to a playing card.
 */

var Card = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Card, _Component);

  function Card() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleClick = function (e) {
      var onClick = _this.props.onClick;
      if (onClick) onClick(e, _this.props);
    };

    return _this;
  }

  var _proto = Card.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        centered = _this$props.centered,
        children = _this$props.children,
        className = _this$props.className,
        color = _this$props.color,
        content = _this$props.content,
        description = _this$props.description,
        extra = _this$props.extra,
        fluid = _this$props.fluid,
        header = _this$props.header,
        href = _this$props.href,
        image = _this$props.image,
        link = _this$props.link,
        meta = _this$props.meta,
        onClick = _this$props.onClick,
        raised = _this$props.raised;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])('ui', color, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(centered, 'centered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(link, 'link'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(raised, 'raised'), 'card', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(Card, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(Card, this.props, function () {
      if (onClick) return 'a';
    });

    if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        className: classes,
        href: href,
        onClick: this.handleClick
      }), children);
    }

    if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(content)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        className: classes,
        href: href,
        onClick: this.handleClick
      }), content);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes,
      href: href,
      onClick: this.handleClick
    }), __WEBPACK_IMPORTED_MODULE_6__elements_Image__["a" /* default */].create(image, {
      autoGenerateKey: false,
      defaultProps: {
        ui: false,
        wrapped: true
      }
    }), (description || header || meta) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CardContent__["a" /* default */], {
      description: description,
      header: header,
      meta: meta
    }), extra && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__CardContent__["a" /* default */], {
      extra: true
    }, extra));
  };

  return Card;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Card.handledProps = ["as", "centered", "children", "className", "color", "content", "description", "extra", "fluid", "header", "href", "image", "link", "meta", "onClick", "raised"];

Card.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A Card can center itself inside its container. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A Card can be formatted to display different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for CardDescription. */
  description: customPropTypes.itemShorthand,

  /** Shorthand for primary content of CardContent. */
  extra: customPropTypes.contentShorthand,

  /** A Card can be formatted to take up the width of its container. */
  fluid: PropTypes.bool,

  /** Shorthand for CardHeader. */
  header: customPropTypes.itemShorthand,

  /** Render as an `a` tag instead of a `div` and adds the href attribute. */
  href: PropTypes.string,

  /** A card can contain an Image component. */
  image: customPropTypes.itemShorthand,

  /** A card can be formatted to link to other content. */
  link: PropTypes.bool,

  /** Shorthand for CardMeta. */
  meta: customPropTypes.itemShorthand,

  /**
   * Called on click. When passed, the component renders as an `a`
   * tag by default instead of a `div`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /** A Card can be formatted to raise above the page. */
  raised: PropTypes.bool
} : {};
Card.Content = __WEBPACK_IMPORTED_MODULE_7__CardContent__["a" /* default */];
Card.Description = __WEBPACK_IMPORTED_MODULE_8__CardDescription__["a" /* default */];
Card.Group = __WEBPACK_IMPORTED_MODULE_9__CardGroup__["a" /* default */];
Card.Header = __WEBPACK_IMPORTED_MODULE_10__CardHeader__["a" /* default */];
Card.Meta = __WEBPACK_IMPORTED_MODULE_11__CardMeta__["a" /* default */];

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CardDescription__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CardHeader__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CardMeta__ = __webpack_require__(719);









/**
 * A card can contain blocks of content or extra content meant to be formatted separately from the main content.
 */

function CardContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      extra = props.extra,
      header = props.header,
      meta = props.meta,
      textAlign = props.textAlign;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(extra, 'extra'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["n" /* useTextAlignProp */])(textAlign), 'content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(CardContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(CardContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(content)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), content);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_7__CardHeader__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, header, {
    autoGenerateKey: false
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_8__CardMeta__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, meta, {
    autoGenerateKey: false
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__CardDescription__["a" /* default */], function (val) {
    return {
      content: val
    };
  }, description, {
    autoGenerateKey: false
  }));
}

CardContent.handledProps = ["as", "children", "className", "content", "description", "extra", "header", "meta", "textAlign"];
CardContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for CardDescription. */
  description: customPropTypes.itemShorthand,

  /** A card can contain extra content meant to be formatted separately from the main content. */
  extra: PropTypes.bool,

  /** Shorthand for CardHeader. */
  header: customPropTypes.itemShorthand,

  /** Shorthand for CardMeta. */
  meta: customPropTypes.itemShorthand,

  /** A card content can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CardContent);

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Card__ = __webpack_require__(1516);








/**
 * A group of cards.
 */

function CardGroup(props) {
  var centered = props.centered,
      children = props.children,
      className = props.className,
      content = props.content,
      doubling = props.doubling,
      items = props.items,
      itemsPerRow = props.itemsPerRow,
      stackable = props.stackable,
      textAlign = props.textAlign;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(centered, 'centered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(doubling, 'doubling'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(stackable, 'stackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["n" /* useTextAlignProp */])(textAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["f" /* useWidthProp */])(itemsPerRow), 'cards', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(CardGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(CardGroup, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(content)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), content);
  }

  var itemsJSX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_map__["a" /* default */])(items, function (item) {
    var _item$key;

    var key = (_item$key = item.key) != null ? _item$key : [item.header, item.description].join('-');
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Card__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      key: key
    }, item));
  });

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), itemsJSX);
}

CardGroup.handledProps = ["as", "centered", "children", "className", "content", "doubling", "items", "itemsPerRow", "stackable", "textAlign"];
CardGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A group of cards can center itself inside its container. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A group of cards can double its column width for mobile. */
  doubling: PropTypes.bool,

  /** Shorthand array of props for Card. */
  items: customPropTypes.collectionShorthand,

  /** A group of cards can set how many cards should exist in a row. */
  itemsPerRow: PropTypes.oneOf(SUI.WIDTHS),

  /** A group of cards can automatically stack rows to a single columns on mobile devices. */
  stackable: PropTypes.bool,

  /** A card group can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified'))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CardGroup);

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A comment can contain an action.
 */

function CommentAction(props) {
  var active = props.active,
      className = props.className,
      children = props.children,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(active, 'active'), className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(CommentAction, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(CommentAction, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CommentAction.handledProps = ["active", "as", "children", "className", "content"];
CommentAction.defaultProps = {
  as: 'a'
};
CommentAction.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Style as the currently active action. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentAction);

/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A comment can contain an list of actions a user may perform related to this comment.
 */

function CommentActions(props) {
  var className = props.className,
      children = props.children,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('actions', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(CommentActions, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(CommentActions, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CommentActions.handledProps = ["as", "children", "className", "content"];
CommentActions.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentActions);

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A comment can contain an author.
 */

function CommentAuthor(props) {
  var className = props.className,
      children = props.children,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('author', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(CommentAuthor, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(CommentAuthor, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CommentAuthor.handledProps = ["as", "children", "className", "content"];
CommentAuthor.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentAuthor);

/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A comment can contain an image or avatar.
 */

function CommentAvatar(props) {
  var className = props.className,
      src = props.src;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('avatar', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(CommentAvatar, props);

  var _partitionHTMLProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["l" /* partitionHTMLProps */])(rest, {
    htmlProps: __WEBPACK_IMPORTED_MODULE_4__lib__["m" /* htmlImageProps */]
  }),
      imageProps = _partitionHTMLProps[0],
      rootProps = _partitionHTMLProps[1];

  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(CommentAvatar, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rootProps, {
    className: classes
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["k" /* createHTMLImage */])(src, {
    autoGenerateKey: false,
    defaultProps: imageProps
  }));
}

CommentAvatar.handledProps = ["as", "className", "src"];
CommentAvatar.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Additional classes. */
  className: PropTypes.string,

  /** Specifies the URL of the image. */
  src: PropTypes.string
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentAvatar);

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A comment can contain content.
 */

function CommentContent(props) {
  var className = props.className,
      children = props.children,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(className, 'content');
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(CommentContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(CommentContent, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CommentContent.handledProps = ["as", "children", "className", "content"];
CommentContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentContent);

/***/ }),
/* 1524 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);






/**
 * Comments can be grouped.
 */

function CommentGroup(props) {
  var className = props.className,
      children = props.children,
      collapsed = props.collapsed,
      content = props.content,
      minimal = props.minimal,
      size = props.size,
      threaded = props.threaded;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])('ui', size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(collapsed, 'collapsed'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(minimal, 'minimal'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(threaded, 'threaded'), 'comments', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(CommentGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(CommentGroup, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CommentGroup.handledProps = ["as", "children", "className", "collapsed", "content", "minimal", "size", "threaded"];
CommentGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Comments can be collapsed, or hidden from view. */
  collapsed: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Comments can hide extra information unless a user shows intent to interact with a comment. */
  minimal: PropTypes.bool,

  /** Comments can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** A comment list can be threaded to showing the relationship between conversations. */
  threaded: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentGroup);

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A comment can contain metadata about the comment, an arbitrary amount of metadata may be defined.
 */

function CommentMetadata(props) {
  var className = props.className,
      children = props.children,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('metadata', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(CommentMetadata, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(CommentMetadata, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CommentMetadata.handledProps = ["as", "children", "className", "content"];
CommentMetadata.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentMetadata);

/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A comment can contain text.
 */

function CommentText(props) {
  var className = props.className,
      children = props.children,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(className, 'text');
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(CommentText, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(CommentText, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

CommentText.handledProps = ["as", "children", "className", "content"];
CommentText.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (CommentText);

/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FeedContent__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FeedLabel__ = __webpack_require__(722);







/**
 * A feed contains an event.
 */

function FeedEvent(props) {
  var content = props.content,
      children = props.children,
      className = props.className,
      date = props.date,
      extraImages = props.extraImages,
      extraText = props.extraText,
      image = props.image,
      icon = props.icon,
      meta = props.meta,
      summary = props.summary;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('event', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(FeedEvent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(FeedEvent, props);
  var hasContentProp = content || date || extraImages || extraText || meta || summary;
  var contentProps = {
    content: content,
    date: date,
    extraImages: extraImages,
    extraText: extraText,
    meta: meta,
    summary: summary
  };
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedLabel__["a" /* default */], function (val) {
    return {
      icon: val
    };
  }, icon, {
    autoGenerateKey: false
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["j" /* createShorthand */])(__WEBPACK_IMPORTED_MODULE_6__FeedLabel__["a" /* default */], function (val) {
    return {
      image: val
    };
  }, image, {
    autoGenerateKey: false
  }), hasContentProp && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__FeedContent__["a" /* default */], contentProps), children);
}

FeedEvent.handledProps = ["as", "children", "className", "content", "date", "extraImages", "extraText", "icon", "image", "meta", "summary"];
FeedEvent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for FeedContent. */
  content: customPropTypes.itemShorthand,

  /** Shorthand for FeedDate. */
  date: customPropTypes.itemShorthand,

  /** Shorthand for FeedExtra with images. */
  extraImages: customPropTypes.itemShorthand,

  /** Shorthand for FeedExtra with content. */
  extraText: customPropTypes.itemShorthand,

  /** An event can contain icon label. */
  icon: customPropTypes.itemShorthand,

  /** An event can contain image label. */
  image: customPropTypes.itemShorthand,

  /** Shorthand for FeedMeta. */
  meta: customPropTypes.itemShorthand,

  /** Shorthand for FeedSummary. */
  summary: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (FeedEvent);

/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ItemContent__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ItemDescription__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ItemExtra__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ItemGroup__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ItemHeader__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ItemImage__ = __webpack_require__(1531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ItemMeta__ = __webpack_require__(730);












/**
 * An item view presents large collections of site content for display.
 */

function Item(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      extra = props.extra,
      header = props.header,
      image = props.image,
      meta = props.meta;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('item', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Item, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(Item, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_10__ItemImage__["a" /* default */].create(image, {
    autoGenerateKey: false
  }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ItemContent__["a" /* default */], {
    content: content,
    description: description,
    extra: extra,
    header: header,
    meta: meta
  }));
}

Item.handledProps = ["as", "children", "className", "content", "description", "extra", "header", "image", "meta"];
Item.Content = __WEBPACK_IMPORTED_MODULE_5__ItemContent__["a" /* default */];
Item.Description = __WEBPACK_IMPORTED_MODULE_6__ItemDescription__["a" /* default */];
Item.Extra = __WEBPACK_IMPORTED_MODULE_7__ItemExtra__["a" /* default */];
Item.Group = __WEBPACK_IMPORTED_MODULE_8__ItemGroup__["a" /* default */];
Item.Header = __WEBPACK_IMPORTED_MODULE_9__ItemHeader__["a" /* default */];
Item.Image = __WEBPACK_IMPORTED_MODULE_10__ItemImage__["a" /* default */];
Item.Meta = __WEBPACK_IMPORTED_MODULE_11__ItemMeta__["a" /* default */];
Item.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for ItemContent component. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for ItemDescription component. */
  description: customPropTypes.itemShorthand,

  /** Shorthand for ItemExtra component. */
  extra: customPropTypes.itemShorthand,

  /** Shorthand for ItemHeader component. */
  header: customPropTypes.itemShorthand,

  /** Shorthand for ItemImage component. */
  image: customPropTypes.itemShorthand,

  /** Shorthand for ItemMeta component. */
  meta: customPropTypes.itemShorthand
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ItemHeader__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ItemDescription__ = __webpack_require__(727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ItemExtra__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ItemMeta__ = __webpack_require__(730);









/**
 * An item can contain content.
 */

function ItemContent(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      description = props.description,
      extra = props.extra,
      header = props.header,
      meta = props.meta,
      verticalAlign = props.verticalAlign;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["i" /* useVerticalAlignProp */])(verticalAlign), 'content', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(ItemContent, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(ItemContent, props);

  if (!__WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__ItemHeader__["a" /* default */].create(header, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_8__ItemMeta__["a" /* default */].create(meta, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_6__ItemDescription__["a" /* default */].create(description, {
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_7__ItemExtra__["a" /* default */].create(extra, {
    autoGenerateKey: false
  }), content);
}

ItemContent.handledProps = ["as", "children", "className", "content", "description", "extra", "header", "meta", "verticalAlign"];
ItemContent.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Shorthand for ItemDescription component. */
  description: customPropTypes.itemShorthand,

  /** Shorthand for ItemExtra component. */
  extra: customPropTypes.itemShorthand,

  /** Shorthand for ItemHeader component. */
  header: customPropTypes.itemShorthand,

  /** Shorthand for ItemMeta component. */
  meta: customPropTypes.itemShorthand,

  /** Content can specify its vertical alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ItemContent);

/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Item__ = __webpack_require__(1528);








/**
 * A group of items.
 */

function ItemGroup(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      divided = props.divided,
      items = props.items,
      link = props.link,
      relaxed = props.relaxed,
      unstackable = props.unstackable;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(divided, 'divided'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(link, 'link'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(unstackable, 'unstackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["h" /* useKeyOrValueAndKey */])(relaxed, 'relaxed'), 'items', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(ItemGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(ItemGroup, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(content)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), content);
  }

  var itemsJSX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_map__["a" /* default */])(items, function (item) {
    var childKey = item.childKey,
        itemProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(item, ["childKey"]);

    var finalKey = childKey != null ? childKey : [itemProps.content, itemProps.description, itemProps.header, itemProps.meta].join('-');
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Item__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, itemProps, {
      key: finalKey
    }));
  });

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), itemsJSX);
}

ItemGroup.handledProps = ["as", "children", "className", "content", "divided", "items", "link", "relaxed", "unstackable"];
ItemGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Items can be divided to better distinguish between grouped content. */
  divided: PropTypes.bool,

  /** Shorthand array of props for Item. */
  items: customPropTypes.collectionShorthand,

  /** An item can be formatted so that the entire contents link to another page. */
  link: PropTypes.bool,

  /** A group of items can relax its padding to provide more negative space. */
  relaxed: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** Prevent items from stacking on mobile. */
  unstackable: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (ItemGroup);

/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elements_Image__ = __webpack_require__(249);




/**
 * An item can contain an image.
 */

function ItemImage(props) {
  var size = props.size;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["b" /* getUnhandledProps */])(ItemImage, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__elements_Image__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    size: size,
    ui: !!size,
    wrapped: true
  }));
}

ItemImage.handledProps = ["size"];
ItemImage.propTypes =  false ? {
  /** An image may appear at different sizes. */
  size: Image.propTypes.size
} : {};
ItemImage.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["e" /* createShorthandFactory */])(ItemImage, function (src) {
  return {
    src: src
  };
});
/* harmony default export */ __webpack_exports__["a"] = (ItemImage);

/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StatisticGroup__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StatisticLabel__ = __webpack_require__(1534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__StatisticValue__ = __webpack_require__(1535);









/**
 * A statistic emphasizes the current value of an attribute.
 */

function Statistic(props) {
  var children = props.children,
      className = props.className,
      color = props.color,
      content = props.content,
      floated = props.floated,
      horizontal = props.horizontal,
      inverted = props.inverted,
      label = props.label,
      size = props.size,
      text = props.text,
      value = props.value;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["g" /* useValueAndKey */])(floated, 'floated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(horizontal, 'horizontal'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), 'statistic', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(Statistic, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(Statistic, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(content)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), content);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_8__StatisticValue__["a" /* default */].create(value, {
    defaultProps: {
      text: text
    },
    autoGenerateKey: false
  }), __WEBPACK_IMPORTED_MODULE_7__StatisticLabel__["a" /* default */].create(label, {
    autoGenerateKey: false
  }));
}

Statistic.handledProps = ["as", "children", "className", "color", "content", "floated", "horizontal", "inverted", "label", "size", "text", "value"];
Statistic.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A statistic can be formatted to be different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A statistic can sit to the left or right of other content. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A statistic can present its measurement horizontally. */
  horizontal: PropTypes.bool,

  /** A statistic can be formatted to fit on a dark background. */
  inverted: PropTypes.bool,

  /** Label content of the Statistic. */
  label: customPropTypes.contentShorthand,

  /** A statistic can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'big', 'massive', 'medium')),

  /** Format the StatisticValue with smaller font size to fit nicely beside number values. */
  text: PropTypes.bool,

  /** Value content of the Statistic. */
  value: customPropTypes.contentShorthand
} : {};
Statistic.Group = __WEBPACK_IMPORTED_MODULE_6__StatisticGroup__["a" /* default */];
Statistic.Label = __WEBPACK_IMPORTED_MODULE_7__StatisticLabel__["a" /* default */];
Statistic.Value = __WEBPACK_IMPORTED_MODULE_8__StatisticValue__["a" /* default */];
Statistic.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["e" /* createShorthandFactory */])(Statistic, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Statistic);

/***/ }),
/* 1533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Statistic__ = __webpack_require__(1532);








/**
 * A group of statistics.
 */

function StatisticGroup(props) {
  var children = props.children,
      className = props.className,
      color = props.color,
      content = props.content,
      horizontal = props.horizontal,
      inverted = props.inverted,
      items = props.items,
      size = props.size,
      widths = props.widths;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(horizontal, 'horizontal'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["f" /* useWidthProp */])(widths), 'statistics', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(StatisticGroup, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(StatisticGroup, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(content)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), content);
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_map__["a" /* default */])(items, function (item) {
    return __WEBPACK_IMPORTED_MODULE_7__Statistic__["a" /* default */].create(item);
  }));
}

StatisticGroup.handledProps = ["as", "children", "className", "color", "content", "horizontal", "inverted", "items", "size", "widths"];
StatisticGroup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A statistic group can be formatted to be different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A statistic group can present its measurement horizontally. */
  horizontal: PropTypes.bool,

  /** A statistic group can be formatted to fit on a dark background. */
  inverted: PropTypes.bool,

  /** Array of props for Statistic. */
  items: customPropTypes.collectionShorthand,

  /** A statistic group can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'big', 'massive', 'medium')),

  /** A statistic group can have its items divided evenly. */
  widths: PropTypes.oneOf(SUI.WIDTHS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (StatisticGroup);

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A statistic can contain a label to help provide context for the presented value.
 */

function StatisticLabel(props) {
  var children = props.children,
      className = props.className,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('label', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(StatisticLabel, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(StatisticLabel, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

StatisticLabel.handledProps = ["as", "children", "className", "content"];
StatisticLabel.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
StatisticLabel.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(StatisticLabel, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (StatisticLabel);

/***/ }),
/* 1535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A statistic can contain a numeric, icon, image, or text value.
 */

function StatisticValue(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      text = props.text;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(text, 'text'), 'value', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(StatisticValue, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(StatisticValue, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

StatisticValue.handledProps = ["as", "children", "className", "content", "text"];
StatisticValue.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Format the value with smaller font size to fit nicely beside number values. */
  text: PropTypes.bool
} : {};
StatisticValue.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(StatisticValue, function (content) {
  return {
    content: content
  };
});
/* harmony default export */ __webpack_exports__["a"] = (StatisticValue);

/***/ }),
/* 1536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseLodash_js__ = __webpack_require__(740);



/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__baseLodash_js__["a" /* default */].prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

/* harmony default export */ __webpack_exports__["a"] = (LodashWrapper);


/***/ }),
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(110);



/* Built-in method references that are verified to be native. */
var Set = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stackClear_js__ = __webpack_require__(3439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__ = __webpack_require__(3440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stackGet_js__ = __webpack_require__(3441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stackHas_js__ = __webpack_require__(3442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stackSet_js__ = __webpack_require__(3443);







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */](entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = __WEBPACK_IMPORTED_MODULE_1__stackClear_js__["a" /* default */];
Stack.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__["a" /* default */];
Stack.prototype.get = __WEBPACK_IMPORTED_MODULE_3__stackGet_js__["a" /* default */];
Stack.prototype.has = __WEBPACK_IMPORTED_MODULE_4__stackHas_js__["a" /* default */];
Stack.prototype.set = __WEBPACK_IMPORTED_MODULE_5__stackSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Stack);


/***/ }),
/* 1539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(110);



/* Built-in method references that are verified to be native. */
var WeakMap = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayFilter);


/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__(498);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayReduce);


/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (arraySome);


/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

/* harmony default export */ __webpack_exports__["a"] = (baseClamp);


/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayIncludes_js__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__arrayIncludesWith_js__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__arrayMap_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseUnary_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cacheHas_js__ = __webpack_require__(487);







/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of methods like `_.difference` without support
 * for excluding multiple arrays or iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Array} values The values to exclude.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of filtered values.
 */
function baseDifference(array, values, iteratee, comparator) {
  var index = -1,
      includes = __WEBPACK_IMPORTED_MODULE_1__arrayIncludes_js__["a" /* default */],
      isCommon = true,
      length = array.length,
      result = [],
      valuesLength = values.length;

  if (!length) {
    return result;
  }
  if (iteratee) {
    values = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__arrayMap_js__["a" /* default */])(values, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__baseUnary_js__["a" /* default */])(iteratee));
  }
  if (comparator) {
    includes = __WEBPACK_IMPORTED_MODULE_2__arrayIncludesWith_js__["a" /* default */];
    isCommon = false;
  }
  else if (values.length >= LARGE_ARRAY_SIZE) {
    includes = __WEBPACK_IMPORTED_MODULE_5__cacheHas_js__["a" /* default */];
    isCommon = false;
    values = new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */](values);
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee == null ? value : iteratee(value);

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var valuesIndex = valuesLength;
      while (valuesIndex--) {
        if (values[valuesIndex] === computed) {
          continue outer;
        }
      }
      result.push(value);
    }
    else if (!includes(values, computed, comparator)) {
      result.push(value);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseDifference);


/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (baseFindIndex);


/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(69);



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(object) ? result : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, symbolsFunc(object));
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetAllKeys);


/***/ }),
/* 1548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseEach_js__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(169);



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(collection) ? Array(collection.length) : [];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseEach_js__["a" /* default */])(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseMap);


/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseSet_js__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__castPath_js__ = __webpack_require__(357);




/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);

    if (predicate(value, path)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseSet_js__["a" /* default */])(result, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__castPath_js__["a" /* default */])(path, object), value);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (basePickBy);


/***/ }),
/* 1550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseProperty);


/***/ }),
/* 1551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(3340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castPath_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIndex_js__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toKey_js__ = __webpack_require__(292);






/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(object)) {
    return object;
  }
  path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__toKey_js__["a" /* default */])(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(objValue)
          ? objValue
          : (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isIndex_js__["a" /* default */])(path[index + 1]) ? [] : {});
      }
    }
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (baseSet);


/***/ }),
/* 1552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__metaMap_js__ = __webpack_require__(1571);



/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !__WEBPACK_IMPORTED_MODULE_1__metaMap_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */] : function(func, data) {
  __WEBPACK_IMPORTED_MODULE_1__metaMap_js__["a" /* default */].set(func, data);
  return func;
};

/* harmony default export */ __webpack_exports__["a"] = (baseSetData);


/***/ }),
/* 1553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trimmedEndIndex_js__ = __webpack_require__(3447);


/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__trimmedEndIndex_js__["a" /* default */])(string) + 1).replace(reTrimStart, '')
    : string;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTrim);


/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayIncludes_js__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__arrayIncludesWith_js__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__cacheHas_js__ = __webpack_require__(487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createSet_js__ = __webpack_require__(3392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setToArray_js__ = __webpack_require__(748);







/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = __WEBPACK_IMPORTED_MODULE_1__arrayIncludes_js__["a" /* default */],
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = __WEBPACK_IMPORTED_MODULE_2__arrayIncludesWith_js__["a" /* default */];
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__createSet_js__["a" /* default */])(array);
    if (set) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__setToArray_js__["a" /* default */])(set);
    }
    isCommon = false;
    includes = __WEBPACK_IMPORTED_MODULE_3__cacheHas_js__["a" /* default */];
    seen = new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */];
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseUniq);


/***/ }),
/* 1556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(189);


/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */];
}

/* harmony default export */ __webpack_exports__["a"] = (castFunction);


/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSlice_js__ = __webpack_require__(485);


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseSlice_js__["a" /* default */])(array, start, end);
}

/* harmony default export */ __webpack_exports__["a"] = (castSlice);


/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (composeArgs);


/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (composeArgsRight);


/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (copyArray);


/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__composeArgs_js__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__composeArgsRight_js__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__countHolders_js__ = __webpack_require__(3379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createCtor_js__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createRecurry_js__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getHolder_js__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__reorder_js__ = __webpack_require__(3436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__replaceHolders_js__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__root_js__ = __webpack_require__(110);










/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__createCtor_js__["a" /* default */])(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getHolder_js__["a" /* default */])(wrapper),
          holdersCount = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__countHolders_js__["a" /* default */])(args, placeholder);
    }
    if (partials) {
      args = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__composeArgs_js__["a" /* default */])(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__composeArgsRight_js__["a" /* default */])(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__replaceHolders_js__["a" /* default */])(args, placeholder);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__createRecurry_js__["a" /* default */])(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__reorder_js__["a" /* default */])(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== __WEBPACK_IMPORTED_MODULE_8__root_js__["a" /* default */] && this instanceof wrapper) {
      fn = Ctor || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__createCtor_js__["a" /* default */])(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

/* harmony default export */ __webpack_exports__["a"] = (createHybrid);


/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isLaziable_js__ = __webpack_require__(3415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setData_js__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setWrapToString_js__ = __webpack_require__(1575);




/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isLaziable_js__["a" /* default */])(func)) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__setData_js__["a" /* default */])(result, newData);
  }
  result.placeholder = placeholder;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__setWrapToString_js__["a" /* default */])(result, func, bitmask);
}

/* harmony default export */ __webpack_exports__["a"] = (createRecurry);


/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(252);


var defineProperty = (function() {
  try {
    var func = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (defineProperty);


/***/ }),
/* 1564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arraySome_js__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cacheHas_js__ = __webpack_require__(487);




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */] : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__arraySome_js__["a" /* default */])(other, function(othValue, othIndex) {
            if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__cacheHas_js__["a" /* default */])(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalArrays);


/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(56)))

/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metaMap_js__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop_js__ = __webpack_require__(755);



/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !__WEBPACK_IMPORTED_MODULE_0__metaMap_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_1__noop_js__["a" /* default */] : function(func) {
  return __WEBPACK_IMPORTED_MODULE_0__metaMap_js__["a" /* default */].get(func);
};

/* harmony default export */ __webpack_exports__["a"] = (getData);


/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubArray_js__ = __webpack_require__(1587);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_1__stubArray_js__["a" /* default */] : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbols);


/***/ }),
/* 1568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIndex_js__ = __webpack_require__(358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isLength_js__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(292);







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */])(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__isLength_js__["a" /* default */])(length) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isIndex_js__["a" /* default */])(key, length) &&
    (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(object) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (hasPath);


/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(149);


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isStrictComparable);


/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (matchesStrictComparable);


/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WeakMap_js__ = __webpack_require__(1539);


/** Used to store function metadata. */
var metaMap = __WEBPACK_IMPORTED_MODULE_0__WeakMap_js__["a" /* default */] && new __WEBPACK_IMPORTED_MODULE_0__WeakMap_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (metaMap);


/***/ }),
/* 1572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(478);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, this, otherArgs);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overRest);


/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSetData_js__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortOut_js__ = __webpack_require__(1576);



/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shortOut_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseSetData_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (setData);


/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWrapDetails_js__ = __webpack_require__(3405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__insertWrapDetails_js__ = __webpack_require__(3412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__updateWrapDetails_js__ = __webpack_require__(3451);





/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(wrapper, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__insertWrapDetails_js__["a" /* default */])(source, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__updateWrapDetails_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getWrapDetails_js__["a" /* default */])(source), bitmask)));
}

/* harmony default export */ __webpack_exports__["a"] = (setWrapToString);


/***/ }),
/* 1576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (shortOut);


/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__asciiToArray_js__ = __webpack_require__(3338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unicodeToArray_js__ = __webpack_require__(3449);




/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__["a" /* default */])(string)
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__unicodeToArray_js__["a" /* default */])(string)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__asciiToArray_js__["a" /* default */])(string);
}

/* harmony default export */ __webpack_exports__["a"] = (stringToArray);


/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (constant);


/***/ }),
/* 1580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deburrLetter_js__ = __webpack_require__(3394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toString_js__ = __webpack_require__(210);



/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toString_js__["a" /* default */])(string);
  return string && string.replace(reLatin, __WEBPACK_IMPORTED_MODULE_0__deburrLetter_js__["a" /* default */]).replace(reComboMark, '');
}

/* harmony default export */ __webpack_exports__["a"] = (deburr);


/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseDifference_js__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseFlatten_js__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseRest_js__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__ = __webpack_require__(495);





/**
 * Creates an array of `array` values not included in the other given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * **Note:** Unlike `_.pullAll`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...Array} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.without, _.xor
 * @example
 *
 * _.difference([2, 1], [2, 3]);
 * // => [1]
 */
var difference = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseRest_js__["a" /* default */])(function(array, values) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__["a" /* default */])(array)
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseDifference_js__["a" /* default */])(array, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseFlatten_js__["a" /* default */])(values, 1, __WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__["a" /* default */], true))
    : [];
});

/* harmony default export */ __webpack_exports__["a"] = (difference);


/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__forEach_js__ = __webpack_require__(359);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__forEach_js__["a"]; });



/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_js__ = __webpack_require__(209);




/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseFindIndex_js__["a" /* default */])(array, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(predicate, 3), index);
}

/* harmony default export */ __webpack_exports__["a"] = (findIndex);


/***/ }),
/* 1584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__ = __webpack_require__(3347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__(1568);



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (hasIn);


/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseInRange_js__ = __webpack_require__(3348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toFinite_js__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toNumber_js__ = __webpack_require__(501);




/**
 * Checks if `n` is between `start` and up to, but not including, `end`. If
 * `end` is not specified, it's set to `start` with `start` then set to `0`.
 * If `start` is greater than `end` the params are swapped to support
 * negative ranges.
 *
 * @static
 * @memberOf _
 * @since 3.3.0
 * @category Number
 * @param {number} number The number to check.
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 * @see _.range, _.rangeRight
 * @example
 *
 * _.inRange(3, 2, 4);
 * // => true
 *
 * _.inRange(4, 8);
 * // => true
 *
 * _.inRange(4, 2);
 * // => false
 *
 * _.inRange(2, 2);
 * // => false
 *
 * _.inRange(1.2, 2);
 * // => true
 *
 * _.inRange(5.2, 4);
 * // => false
 *
 * _.inRange(-3, -2, -6);
 * // => true
 */
function inRange(number, start, end) {
  start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toFinite_js__["a" /* default */])(start);
  if (end === undefined) {
    end = start;
    start = 0;
  } else {
    end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toFinite_js__["a" /* default */])(end);
  }
  number = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(number);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseInRange_js__["a" /* default */])(number, start, end);
}

/* harmony default export */ __webpack_exports__["a"] = (inRange);


/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(738);


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other);
}

/* harmony default export */ __webpack_exports__["a"] = (isEqual);


/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (stubArray);


/***/ }),
/* 1588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseUniq_js__ = __webpack_require__(1555);


/**
 * Creates a duplicate-free version of an array, using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons, in which only the first occurrence of each element
 * is kept. The order of result values is determined by the order they occur
 * in the array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniq([2, 1, 2]);
 * // => [2, 1]
 */
function uniq(array) {
  return (array && array.length) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseUniq_js__["a" /* default */])(array) : [];
}

/* harmony default export */ __webpack_exports__["a"] = (uniq);


/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56), __webpack_require__(90)))

/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(41)
var Hash = __webpack_require__(297)
var Buffer = __webpack_require__(42).Buffer

var K = [
  0x428A2F98, 0x71374491, 0xB5C0FBCF, 0xE9B5DBA5,
  0x3956C25B, 0x59F111F1, 0x923F82A4, 0xAB1C5ED5,
  0xD807AA98, 0x12835B01, 0x243185BE, 0x550C7DC3,
  0x72BE5D74, 0x80DEB1FE, 0x9BDC06A7, 0xC19BF174,
  0xE49B69C1, 0xEFBE4786, 0x0FC19DC6, 0x240CA1CC,
  0x2DE92C6F, 0x4A7484AA, 0x5CB0A9DC, 0x76F988DA,
  0x983E5152, 0xA831C66D, 0xB00327C8, 0xBF597FC7,
  0xC6E00BF3, 0xD5A79147, 0x06CA6351, 0x14292967,
  0x27B70A85, 0x2E1B2138, 0x4D2C6DFC, 0x53380D13,
  0x650A7354, 0x766A0ABB, 0x81C2C92E, 0x92722C85,
  0xA2BFE8A1, 0xA81A664B, 0xC24B8B70, 0xC76C51A3,
  0xD192E819, 0xD6990624, 0xF40E3585, 0x106AA070,
  0x19A4C116, 0x1E376C08, 0x2748774C, 0x34B0BCB5,
  0x391C0CB3, 0x4ED8AA4A, 0x5B9CCA4F, 0x682E6FF3,
  0x748F82EE, 0x78A5636F, 0x84C87814, 0x8CC70208,
  0x90BEFFFA, 0xA4506CEB, 0xBEF9A3F7, 0xC67178F2
]

var W = new Array(64)

function Sha256 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha256, Hash)

Sha256.prototype.init = function () {
  this._a = 0x6a09e667
  this._b = 0xbb67ae85
  this._c = 0x3c6ef372
  this._d = 0xa54ff53a
  this._e = 0x510e527f
  this._f = 0x9b05688c
  this._g = 0x1f83d9ab
  this._h = 0x5be0cd19

  return this
}

function ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x) {
  return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10)
}

function sigma1 (x) {
  return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7)
}

function gamma0 (x) {
  return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ (x >>> 3)
}

function gamma1 (x) {
  return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ (x >>> 10)
}

Sha256.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0
  var f = this._f | 0
  var g = this._g | 0
  var h = this._h | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 64; ++i) W[i] = (gamma1(W[i - 2]) + W[i - 7] + gamma0(W[i - 15]) + W[i - 16]) | 0

  for (var j = 0; j < 64; ++j) {
    var T1 = (h + sigma1(e) + ch(e, f, g) + K[j] + W[j]) | 0
    var T2 = (sigma0(a) + maj(a, b, c)) | 0

    h = g
    g = f
    f = e
    e = (d + T1) | 0
    d = c
    c = b
    b = a
    a = (T1 + T2) | 0
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
  this._f = (f + this._f) | 0
  this._g = (g + this._g) | 0
  this._h = (h + this._h) | 0
}

Sha256.prototype._hash = function () {
  var H = Buffer.allocUnsafe(32)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)
  H.writeInt32BE(this._h, 28)

  return H
}

module.exports = Sha256


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(41)
var Hash = __webpack_require__(297)
var Buffer = __webpack_require__(42).Buffer

var K = [
  0x428a2f98, 0xd728ae22, 0x71374491, 0x23ef65cd,
  0xb5c0fbcf, 0xec4d3b2f, 0xe9b5dba5, 0x8189dbbc,
  0x3956c25b, 0xf348b538, 0x59f111f1, 0xb605d019,
  0x923f82a4, 0xaf194f9b, 0xab1c5ed5, 0xda6d8118,
  0xd807aa98, 0xa3030242, 0x12835b01, 0x45706fbe,
  0x243185be, 0x4ee4b28c, 0x550c7dc3, 0xd5ffb4e2,
  0x72be5d74, 0xf27b896f, 0x80deb1fe, 0x3b1696b1,
  0x9bdc06a7, 0x25c71235, 0xc19bf174, 0xcf692694,
  0xe49b69c1, 0x9ef14ad2, 0xefbe4786, 0x384f25e3,
  0x0fc19dc6, 0x8b8cd5b5, 0x240ca1cc, 0x77ac9c65,
  0x2de92c6f, 0x592b0275, 0x4a7484aa, 0x6ea6e483,
  0x5cb0a9dc, 0xbd41fbd4, 0x76f988da, 0x831153b5,
  0x983e5152, 0xee66dfab, 0xa831c66d, 0x2db43210,
  0xb00327c8, 0x98fb213f, 0xbf597fc7, 0xbeef0ee4,
  0xc6e00bf3, 0x3da88fc2, 0xd5a79147, 0x930aa725,
  0x06ca6351, 0xe003826f, 0x14292967, 0x0a0e6e70,
  0x27b70a85, 0x46d22ffc, 0x2e1b2138, 0x5c26c926,
  0x4d2c6dfc, 0x5ac42aed, 0x53380d13, 0x9d95b3df,
  0x650a7354, 0x8baf63de, 0x766a0abb, 0x3c77b2a8,
  0x81c2c92e, 0x47edaee6, 0x92722c85, 0x1482353b,
  0xa2bfe8a1, 0x4cf10364, 0xa81a664b, 0xbc423001,
  0xc24b8b70, 0xd0f89791, 0xc76c51a3, 0x0654be30,
  0xd192e819, 0xd6ef5218, 0xd6990624, 0x5565a910,
  0xf40e3585, 0x5771202a, 0x106aa070, 0x32bbd1b8,
  0x19a4c116, 0xb8d2d0c8, 0x1e376c08, 0x5141ab53,
  0x2748774c, 0xdf8eeb99, 0x34b0bcb5, 0xe19b48a8,
  0x391c0cb3, 0xc5c95a63, 0x4ed8aa4a, 0xe3418acb,
  0x5b9cca4f, 0x7763e373, 0x682e6ff3, 0xd6b2b8a3,
  0x748f82ee, 0x5defb2fc, 0x78a5636f, 0x43172f60,
  0x84c87814, 0xa1f0ab72, 0x8cc70208, 0x1a6439ec,
  0x90befffa, 0x23631e28, 0xa4506ceb, 0xde82bde9,
  0xbef9a3f7, 0xb2c67915, 0xc67178f2, 0xe372532b,
  0xca273ece, 0xea26619c, 0xd186b8c7, 0x21c0c207,
  0xeada7dd6, 0xcde0eb1e, 0xf57d4f7f, 0xee6ed178,
  0x06f067aa, 0x72176fba, 0x0a637dc5, 0xa2c898a6,
  0x113f9804, 0xbef90dae, 0x1b710b35, 0x131c471b,
  0x28db77f5, 0x23047d84, 0x32caab7b, 0x40c72493,
  0x3c9ebe0a, 0x15c9bebc, 0x431d67c4, 0x9c100d4c,
  0x4cc5d4be, 0xcb3e42b6, 0x597f299c, 0xfc657e2a,
  0x5fcb6fab, 0x3ad6faec, 0x6c44198c, 0x4a475817
]

var W = new Array(160)

function Sha512 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha512, Hash)

Sha512.prototype.init = function () {
  this._ah = 0x6a09e667
  this._bh = 0xbb67ae85
  this._ch = 0x3c6ef372
  this._dh = 0xa54ff53a
  this._eh = 0x510e527f
  this._fh = 0x9b05688c
  this._gh = 0x1f83d9ab
  this._hh = 0x5be0cd19

  this._al = 0xf3bcc908
  this._bl = 0x84caa73b
  this._cl = 0xfe94f82b
  this._dl = 0x5f1d36f1
  this._el = 0xade682d1
  this._fl = 0x2b3e6c1f
  this._gl = 0xfb41bd6b
  this._hl = 0x137e2179

  return this
}

function Ch (x, y, z) {
  return z ^ (x & (y ^ z))
}

function maj (x, y, z) {
  return (x & y) | (z & (x | y))
}

function sigma0 (x, xl) {
  return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25)
}

function sigma1 (x, xl) {
  return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23)
}

function Gamma0 (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7)
}

function Gamma0l (x, xl) {
  return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25)
}

function Gamma1 (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6)
}

function Gamma1l (x, xl) {
  return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26)
}

function getCarry (a, b) {
  return (a >>> 0) < (b >>> 0) ? 1 : 0
}

Sha512.prototype._update = function (M) {
  var W = this._w

  var ah = this._ah | 0
  var bh = this._bh | 0
  var ch = this._ch | 0
  var dh = this._dh | 0
  var eh = this._eh | 0
  var fh = this._fh | 0
  var gh = this._gh | 0
  var hh = this._hh | 0

  var al = this._al | 0
  var bl = this._bl | 0
  var cl = this._cl | 0
  var dl = this._dl | 0
  var el = this._el | 0
  var fl = this._fl | 0
  var gl = this._gl | 0
  var hl = this._hl | 0

  for (var i = 0; i < 32; i += 2) {
    W[i] = M.readInt32BE(i * 4)
    W[i + 1] = M.readInt32BE(i * 4 + 4)
  }
  for (; i < 160; i += 2) {
    var xh = W[i - 15 * 2]
    var xl = W[i - 15 * 2 + 1]
    var gamma0 = Gamma0(xh, xl)
    var gamma0l = Gamma0l(xl, xh)

    xh = W[i - 2 * 2]
    xl = W[i - 2 * 2 + 1]
    var gamma1 = Gamma1(xh, xl)
    var gamma1l = Gamma1l(xl, xh)

    // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
    var Wi7h = W[i - 7 * 2]
    var Wi7l = W[i - 7 * 2 + 1]

    var Wi16h = W[i - 16 * 2]
    var Wi16l = W[i - 16 * 2 + 1]

    var Wil = (gamma0l + Wi7l) | 0
    var Wih = (gamma0 + Wi7h + getCarry(Wil, gamma0l)) | 0
    Wil = (Wil + gamma1l) | 0
    Wih = (Wih + gamma1 + getCarry(Wil, gamma1l)) | 0
    Wil = (Wil + Wi16l) | 0
    Wih = (Wih + Wi16h + getCarry(Wil, Wi16l)) | 0

    W[i] = Wih
    W[i + 1] = Wil
  }

  for (var j = 0; j < 160; j += 2) {
    Wih = W[j]
    Wil = W[j + 1]

    var majh = maj(ah, bh, ch)
    var majl = maj(al, bl, cl)

    var sigma0h = sigma0(ah, al)
    var sigma0l = sigma0(al, ah)
    var sigma1h = sigma1(eh, el)
    var sigma1l = sigma1(el, eh)

    // t1 = h + sigma1 + ch + K[j] + W[j]
    var Kih = K[j]
    var Kil = K[j + 1]

    var chh = Ch(eh, fh, gh)
    var chl = Ch(el, fl, gl)

    var t1l = (hl + sigma1l) | 0
    var t1h = (hh + sigma1h + getCarry(t1l, hl)) | 0
    t1l = (t1l + chl) | 0
    t1h = (t1h + chh + getCarry(t1l, chl)) | 0
    t1l = (t1l + Kil) | 0
    t1h = (t1h + Kih + getCarry(t1l, Kil)) | 0
    t1l = (t1l + Wil) | 0
    t1h = (t1h + Wih + getCarry(t1l, Wil)) | 0

    // t2 = sigma0 + maj
    var t2l = (sigma0l + majl) | 0
    var t2h = (sigma0h + majh + getCarry(t2l, sigma0l)) | 0

    hh = gh
    hl = gl
    gh = fh
    gl = fl
    fh = eh
    fl = el
    el = (dl + t1l) | 0
    eh = (dh + t1h + getCarry(el, dl)) | 0
    dh = ch
    dl = cl
    ch = bh
    cl = bl
    bh = ah
    bl = al
    al = (t1l + t2l) | 0
    ah = (t1h + t2h + getCarry(al, t1l)) | 0
  }

  this._al = (this._al + al) | 0
  this._bl = (this._bl + bl) | 0
  this._cl = (this._cl + cl) | 0
  this._dl = (this._dl + dl) | 0
  this._el = (this._el + el) | 0
  this._fl = (this._fl + fl) | 0
  this._gl = (this._gl + gl) | 0
  this._hl = (this._hl + hl) | 0

  this._ah = (this._ah + ah + getCarry(this._al, al)) | 0
  this._bh = (this._bh + bh + getCarry(this._bl, bl)) | 0
  this._ch = (this._ch + ch + getCarry(this._cl, cl)) | 0
  this._dh = (this._dh + dh + getCarry(this._dl, dl)) | 0
  this._eh = (this._eh + eh + getCarry(this._el, el)) | 0
  this._fh = (this._fh + fh + getCarry(this._fl, fl)) | 0
  this._gh = (this._gh + gh + getCarry(this._gl, gl)) | 0
  this._hh = (this._hh + hh + getCarry(this._hl, hl)) | 0
}

Sha512.prototype._hash = function () {
  var H = Buffer.allocUnsafe(64)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)
  writeInt64BE(this._gh, this._gl, 48)
  writeInt64BE(this._hh, this._hl, 56)

  return H
}

module.exports = Sha512


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(655);
var callBound = __webpack_require__(1107);
var inspect = __webpack_require__(453);

var $TypeError = __webpack_require__(282);
var $Map = GetIntrinsic('%Map%', true);

/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */
var $mapSize = callBound('Map.prototype.size', true);

/** @type {import('.')} */
module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
	/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {Map<K, V> | undefined} */ var $m;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			if ($m) {
				var result = $mapDelete($m, key);
				if ($mapSize($m) === 0) {
					$m = void undefined;
				}
				return result;
			}
			return false;
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($m) {
				return $mapGet($m, key);
			}
		},
		has: function (key) {
			if ($m) {
				return $mapHas($m, key);
			}
			return false;
		},
		set: function (key, value) {
			if (!$m) {
				// @ts-expect-error TS can't handle narrowing a variable inside a closure
				$m = new $Map();
			}
			$mapSet($m, key, value);
		}
	};

	// @ts-expect-error TODO: figure out why TS is erroring here
	return channel;
};


/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = (function(e,n){return n=n||{},new Promise(function(t,r){var s=new XMLHttpRequest,o=[],u=[],i={},a=function(){return{ok:2==(s.status/100|0),statusText:s.statusText,status:s.status,url:s.responseURL,text:function(){return Promise.resolve(s.responseText)},json:function(){return Promise.resolve(s.responseText).then(JSON.parse)},blob:function(){return Promise.resolve(new Blob([s.response]))},clone:a,headers:{keys:function(){return o},entries:function(){return u},get:function(e){return i[e.toLowerCase()]},has:function(e){return e.toLowerCase()in i}}}};for(var l in s.open(n.method||"get",e,!0),s.onload=function(){s.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm,function(e,n,t){o.push(n=n.toLowerCase()),u.push([n,t]),i[n]=i[n]?i[n]+","+t:t}),t(a())},s.onerror=r,s.withCredentials="include"==n.credentials,n.headers)s.setRequestHeader(l,n.headers[l]);s.send(n.body||null)})});
//# sourceMappingURL=unfetch.module.js.map


/***/ }),
/* 1594 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwLjAwMDUgOC45MDA3MUMyMC4wMDA2IDkuMDE4OTYgMTkuOTc3NSA5LjEzNjA4IDE5LjkzMjQgOS4yNDUzOEMxOS44ODcyIDkuMzU0NjggMTkuODIxIDkuNDU0MDEgMTkuNzM3NSA5LjUzNzcxTDEzLjI5NzUgMTUuOTc2N0MxMy4xMjg3IDE2LjE0NTIgMTIuOSAxNi4yMzk5IDEyLjY2MTUgMTYuMjM5OUMxMi40MjMgMTYuMjM5OSAxMi4xOTQyIDE2LjE0NTIgMTIuMDI1NSAxNS45NzY3TDUuNTg1NDcgOS41Mzc3MUM1LjQxNjY2IDkuMzY4NSA1LjMyMTk5IDkuMTM5MTYgNS4zMjIyNyA4LjkwMDE1QzUuMzIyNTUgOC42NjExMyA1LjQxNzc3IDguNDMyMDIgNS41ODY5NyA4LjI2MzIxQzUuNzU2MTggOC4wOTQ0IDUuOTg1NTIgNy45OTk3MiA2LjIyNDUzIDhDNi40NjM1NSA4LjAwMDI4IDYuNjkyNjYgOC4wOTU1IDYuODYxNDcgOC4yNjQ3MUwxMi42NjE1IDE0LjA2NDdMMTguNDYxNSA4LjI2NDcxQzE4LjU4NzMgOC4xMzkgMTguNzQ3NiA4LjA1MzQxIDE4LjkyMjEgOC4wMTg3NUMxOS4wOTY2IDcuOTg0MDkgMTkuMjc3NCA4LjAwMTkxIDE5LjQ0MTggOC4wNjk5NkMxOS42MDYxIDguMTM4MDEgMTkuNzQ2NiA4LjI1MzI1IDE5Ljg0NTUgOC40MDExMUMxOS45NDQ0IDguNTQ4OTcgMTkuOTk3MyA4LjcyMjgyIDE5Ljk5NzUgOC45MDA3MUwyMC4wMDA1IDguOTAwNzFaIiBmaWxsPSIjNTk2OTc1Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 1595 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuMzIxNzkgMTUuMzM5MkM1LjMyMTYzIDE1LjIyMSA1LjM0NDc4IDE1LjEwMzggNS4zODk5MSAxNC45OTQ1QzUuNDM1MDMgMTQuODg1MiA1LjUwMTI2IDE0Ljc4NTkgNS41ODQ3OSAxNC43MDIyTDEyLjAyNDggOC4yNjMyMUMxMi4xOTM1IDguMDk0NjcgMTIuNDIyMyA4IDEyLjY2MDggOEMxMi44OTkzIDggMTMuMTI4IDguMDk0NjcgMTMuMjk2OCA4LjI2MzIxTDE5LjczNjggMTQuNzAyMkMxOS45MDU2IDE0Ljg3MTQgMjAuMDAwMyAxNS4xMDA4IDIwIDE1LjMzOThDMTkuOTk5NyAxNS41Nzg4IDE5LjkwNDUgMTUuODA3OSAxOS43MzUzIDE1Ljk3NjdDMTkuNTY2MSAxNi4xNDU1IDE5LjMzNjcgMTYuMjQwMiAxOS4wOTc3IDE2LjIzOTlDMTguODU4NyAxNi4yMzk2IDE4LjYyOTYgMTYuMTQ0NCAxOC40NjA4IDE1Ljk3NTJMMTIuNjYwOCAxMC4xNzUyTDYuODYwNzkgMTUuOTc1MkM2LjczNDkzIDE2LjEwMDkgNi41NzQ2MyAxNi4xODY1IDYuNDAwMTUgMTYuMjIxMkM2LjIyNTY4IDE2LjI1NTggNi4wNDQ4NCAxNi4yMzggNS44ODA0OCAxNi4xN0M1LjcxNjEzIDE2LjEwMTkgNS41NzU2MiAxNS45ODY3IDUuNDc2NzIgMTUuODM4OEM1LjM3NzgyIDE1LjY5MDkgNS4zMjQ5NSAxNS41MTcxIDUuMzI0NzkgMTUuMzM5Mkw1LjMyMTc5IDE1LjMzOTJaIiBmaWxsPSIjNTk2OTc1Ii8+Cjwvc3ZnPgo="

/***/ }),
/* 1596 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjM0OTYgMi4yNUg0Ljk0OTYxQzQuNTkxNTcgMi4yNSA0LjI0ODE5IDIuMzkyMjMgMy45OTUwMiAyLjY0NTQxQzMuNzQxODQgMi44OTg1OCAzLjU5OTYxIDMuMjQxOTYgMy41OTk2MSAzLjZWMTQuNEMzLjU5OTYxIDE0Ljc1OCAzLjc0MTg0IDE1LjEwMTQgMy45OTUwMiAxNS4zNTQ2QzQuMjQ4MTkgMTUuNjA3OCA0LjU5MTU3IDE1Ljc1IDQuOTQ5NjEgMTUuNzVIMTMuMDQ5NkMxMy40MDc3IDE1Ljc1IDEzLjc1MSAxNS42MDc4IDE0LjAwNDIgMTUuMzU0NkMxNC4yNTc0IDE1LjEwMTQgMTQuMzk5NiAxNC43NTggMTQuMzk5NiAxNC40VjYuM00xMC4zNDk2IDIuMjVMMTQuMzk5NiA2LjNNMTAuMzQ5NiAyLjI1VjYuM0gxNC4zOTk2IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggb3BhY2l0eT0iMC44IiBkPSJNMTEuNjk5OCA5LjY3NDk5SDYuMjk5OE0xMS42OTk4IDEyLjM3NUg2LjI5OThNNy42NDk4IDYuOTc0OTlINi4yOTk4IiBzdHJva2U9IiMwMDAwMDAiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),
/* 1597 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 1598 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEwOTVfMzQ2NikiPgo8cGF0aCBkPSJNMi4yNSAxNS43NUgxNS43NSIgc3Ryb2tlPSIjMjRBNDc2IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yLjI1IDcuNUgxNS43NSIgc3Ryb2tlPSIjMjRBNDc2IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0zLjc1IDQuNUw5IDIuMjVMMTQuMjUgNC41IiBzdHJva2U9IiMyNEE0NzYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTMgNy41VjE1Ljc1IiBzdHJva2U9IiMyNEE0NzYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTE1IDcuNVYxNS43NSIgc3Ryb2tlPSIjMjRBNDc2IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik02IDEwLjVWMTIuNzUiIHN0cm9rZT0iIzI0QTQ3NiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNOSAxMC41VjEyLjc1IiBzdHJva2U9IiMyNEE0NzYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTEyIDEwLjVWMTIuNzUiIHN0cm9rZT0iIzI0QTQ3NiIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzEwOTVfMzQ2NiI+CjxyZWN0IHdpZHRoPSIxOCIgaGVpZ2h0PSIxOCIgZmlsbD0id2hpdGUiLz4KPC9jbGlwUGF0aD4KPC9kZWZzPgo8L3N2Zz4K"

/***/ }),
/* 1599 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxMyAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTExLjUgMTIuNjI1VjExLjM3NUMxMS41IDEwLjcxMiAxMS4yMzY2IDEwLjA3NjEgMTAuNzY3OCA5LjYwNzIzQzEwLjI5ODkgOS4xMzgzOSA5LjY2MzA0IDguODc1IDkgOC44NzVINEMzLjMzNjk2IDguODc1IDIuNzAxMDcgOS4xMzgzOSAyLjIzMjIzIDkuNjA3MjNDMS43NjMzOSAxMC4wNzYxIDEuNSAxMC43MTIgMS41IDExLjM3NVYxMi42MjVNOSAzLjg3NUM5IDUuMjU1NzEgNy44ODA3MSA2LjM3NSA2LjUgNi4zNzVDNS4xMTkyOSA2LjM3NSA0IDUuMjU1NzEgNCAzLjg3NUM0IDIuNDk0MjkgNS4xMTkyOSAxLjM3NSA2LjUgMS4zNzVDNy44ODA3MSAxLjM3NSA5IDIuNDk0MjkgOSAzLjg3NVoiIHN0cm9rZT0iIzk2OUNBNCIgc3Ryb2tlLXdpZHRoPSIxLjQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v1_js__ = __webpack_require__(3547);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v1", function() { return __WEBPACK_IMPORTED_MODULE_0__v1_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__v3_js__ = __webpack_require__(3548);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v3", function() { return __WEBPACK_IMPORTED_MODULE_1__v3_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__v4_js__ = __webpack_require__(3549);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v4", function() { return __WEBPACK_IMPORTED_MODULE_2__v4_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__v5_js__ = __webpack_require__(3550);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v5", function() { return __WEBPACK_IMPORTED_MODULE_3__v5_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__nil_js__ = __webpack_require__(3544);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "NIL", function() { return __WEBPACK_IMPORTED_MODULE_4__nil_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__version_js__ = __webpack_require__(3551);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "version", function() { return __WEBPACK_IMPORTED_MODULE_5__version_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validate_js__ = __webpack_require__(506);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "validate", function() { return __WEBPACK_IMPORTED_MODULE_6__validate_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__stringify_js__ = __webpack_require__(505);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "stringify", function() { return __WEBPACK_IMPORTED_MODULE_7__stringify_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__parse_js__ = __webpack_require__(1601);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function() { return __WEBPACK_IMPORTED_MODULE_8__parse_js__["a"]; });










/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate_js__ = __webpack_require__(506);


function parse(uuid) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__validate_js__["a" /* default */])(uuid)) {
    throw TypeError('Invalid UUID');
  }

  var v;
  var arr = new Uint8Array(16); // Parse ########-....-....-....-............

  arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
  arr[1] = v >>> 16 & 0xff;
  arr[2] = v >>> 8 & 0xff;
  arr[3] = v & 0xff; // Parse ........-####-....-....-............

  arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
  arr[5] = v & 0xff; // Parse ........-....-####-....-............

  arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
  arr[7] = v & 0xff; // Parse ........-....-....-####-............

  arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
  arr[9] = v & 0xff; // Parse ........-....-....-....-############
  // (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)

  arr[10] = (v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000 & 0xff;
  arr[11] = v / 0x100000000 & 0xff;
  arr[12] = v >>> 24 & 0xff;
  arr[13] = v >>> 16 & 0xff;
  arr[14] = v >>> 8 & 0xff;
  arr[15] = v & 0xff;
  return arr;
}

/* harmony default export */ __webpack_exports__["a"] = (parse);

/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = rng;
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}

/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DNS */
/* unused harmony export URL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__stringify_js__ = __webpack_require__(505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parse_js__ = __webpack_require__(1601);



function stringToBytes(str) {
  str = unescape(encodeURIComponent(str)); // UTF8 escape

  var bytes = [];

  for (var i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i));
  }

  return bytes;
}

var DNS = '6ba7b810-9dad-11d1-80b4-00c04fd430c8';
var URL = '6ba7b811-9dad-11d1-80b4-00c04fd430c8';
/* harmony default export */ __webpack_exports__["a"] = (function (name, version, hashfunc) {
  function generateUUID(value, namespace, buf, offset) {
    if (typeof value === 'string') {
      value = stringToBytes(value);
    }

    if (typeof namespace === 'string') {
      namespace = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__parse_js__["a" /* default */])(namespace);
    }

    if (namespace.length !== 16) {
      throw TypeError('Namespace must be array-like (16 iterable integer values, 0-255)');
    } // Compute hash of namespace and value, Per 4.3
    // Future: Use spread syntax when supported on all platforms, e.g. `bytes =
    // hashfunc([...namespace, ... value])`


    var bytes = new Uint8Array(16 + value.length);
    bytes.set(namespace);
    bytes.set(value, namespace.length);
    bytes = hashfunc(bytes);
    bytes[6] = bytes[6] & 0x0f | version;
    bytes[8] = bytes[8] & 0x3f | 0x80;

    if (buf) {
      offset = offset || 0;

      for (var i = 0; i < 16; ++i) {
        buf[offset + i] = bytes[i];
      }

      return buf;
    }

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__stringify_js__["a" /* default */])(bytes);
  } // Function#name is not settable on some platforms (#270)


  try {
    generateUUID.name = name; // eslint-disable-next-line no-empty
  } catch (err) {} // For CommonJS default export support


  generateUUID.DNS = DNS;
  generateUUID.URL = URL;
  return generateUUID;
});

/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1757);

__webpack_require__(3228);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(109);

var _core = __webpack_require__(71);

var _core2 = _interopRequireDefault(_core);

__webpack_require__(3500);

var _amplifyConfig = __webpack_require__(2081);

var _amplifyConfig2 = _interopRequireDefault(_amplifyConfig);

var _telemetry = __webpack_require__(1081);

var _browser = __webpack_require__(2573);

var _bugsnagNetworkNoise = __webpack_require__(1086);

var _book = __webpack_require__(2566);

var _book2 = _interopRequireDefault(_book);

var _Root = __webpack_require__(2468);

var _Root2 = _interopRequireDefault(_Root);

var _store = __webpack_require__(1083);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// OTEL-6: before render and before the boot-time fetch fan-out, so instrumentation-fetch is
// already patched when the first API call goes out. No-op when no OTLP endpoint is configured.
(0, _telemetry.initTelemetry)(_book2.default); /* eslint no-underscore-dangle: 0 */

(0, _browser.identify)();
// MS-6583: gate network-level fetch failures (navigation aborts, offline blips) before they
// reach Bugsnag — installed before render so the boot-time fetch fan-out is already covered.
(0, _bugsnagNetworkNoise.installBugsnagNetworkNoiseFilter)(window);

_core2.default.configure(_amplifyConfig2.default);

(0, _reactDom.render)(_react2.default.createElement(_Root2.default, { store: _store.store, history: _store.history, routes: _book2.default }), document.getElementById('app'));

/***/ }),
/* 1605 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__API__ = __webpack_require__(772);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "API", function() { return __WEBPACK_IMPORTED_MODULE_0__API__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "APIClass", function() { return __WEBPACK_IMPORTED_MODULE_0__API__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_amplify_api_graphql__ = __webpack_require__(768);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "graphqlOperation", function() { return __WEBPACK_IMPORTED_MODULE_1__aws_amplify_api_graphql__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GraphQLAuthError", function() { return __WEBPACK_IMPORTED_MODULE_1__aws_amplify_api_graphql__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "GRAPHQL_AUTH_MODE", function() { return __WEBPACK_IMPORTED_MODULE_1__aws_amplify_api_graphql__["c"]; });
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */



/*
 * @deprecated use named import
 */
/* harmony default export */ __webpack_exports__["default"] = (__WEBPACK_IMPORTED_MODULE_0__API__["a" /* API */]);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AuthClass */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Auth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(1611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_url__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__OAuth_OAuth__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__urlListener__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Errors__ = __webpack_require__(1607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__types_Auth__ = __webpack_require__(364);
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *	 http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};








var logger = new __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["ConsoleLogger"]('AuthClass');
var USER_ADMIN_SCOPE = 'aws.cognito.signin.user.admin';
// 10 sec, following this guide https://www.nngroup.com/articles/response-times-3-important-limits/
var OAUTH_FLOW_MS_TIMEOUT = 10 * 1000;
var AMPLIFY_SYMBOL = (typeof Symbol !== 'undefined' &&
    typeof Symbol.for === 'function'
    ? Symbol.for('amplify_default')
    : '@@amplify_default');
var dispatchAuthEvent = function (event, data, message) {
    __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["Hub"].dispatch('auth', { event: event, data: data, message: message }, 'Auth', AMPLIFY_SYMBOL);
};
// Cognito Documentation for max device
// tslint:disable-next-line:max-line-length
// https://docs.aws.amazon.com/cognito-user-identity-pools/latest/APIReference/API_ListDevices.html#API_ListDevices_RequestSyntax
var MAX_DEVICES = 60;
/**
 * Provide authentication steps
 */
var AuthClass = /** @class */ (function () {
    /**
     * Initialize Auth with AWS configurations
     * @param {Object} config - Configuration of the Auth
     */
    function AuthClass(config) {
        var _this = this;
        this.userPool = null;
        this.user = null;
        this.oAuthFlowInProgress = false;
        this.Credentials = __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["Credentials"];
        this.wrapRefreshSessionCallback = function (callback) {
            var wrapped = function (error, data) {
                if (data) {
                    dispatchAuthEvent('tokenRefresh', undefined, "New token retrieved");
                }
                else {
                    dispatchAuthEvent('tokenRefresh_failure', error, "Failed to retrieve new token");
                }
                return callback(error, data);
            };
            return wrapped;
        }; // prettier-ignore
        this.configure(config);
        this.currentCredentials = this.currentCredentials.bind(this);
        this.currentUserCredentials = this.currentUserCredentials.bind(this);
        __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["Hub"].listen('auth', function (_a) {
            var payload = _a.payload;
            var event = payload.event;
            switch (event) {
                case 'signIn':
                    _this._storage.setItem('amplify-signin-with-hostedUI', 'false');
                    break;
                case 'signOut':
                    _this._storage.removeItem('amplify-signin-with-hostedUI');
                    break;
                case 'cognitoHostedUI':
                    _this._storage.setItem('amplify-signin-with-hostedUI', 'true');
                    break;
            }
        });
    }
    AuthClass.prototype.getModuleName = function () {
        return 'Auth';
    };
    AuthClass.prototype.configure = function (config) {
        var _this = this;
        if (!config)
            return this._config || {};
        logger.debug('configure Auth');
        var conf = Object.assign({}, this._config, __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["Parser"].parseMobilehubConfig(config).Auth, config);
        this._config = conf;
        var _a = this._config, userPoolId = _a.userPoolId, userPoolWebClientId = _a.userPoolWebClientId, cookieStorage = _a.cookieStorage, oauth = _a.oauth, region = _a.region, identityPoolId = _a.identityPoolId, mandatorySignIn = _a.mandatorySignIn, refreshHandlers = _a.refreshHandlers, identityPoolRegion = _a.identityPoolRegion, clientMetadata = _a.clientMetadata, endpoint = _a.endpoint;
        if (!this._config.storage) {
            // backward compatability
            if (cookieStorage)
                this._storage = new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["b" /* CookieStorage */](cookieStorage);
            else {
                this._storage = config.ssr
                    ? new __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["UniversalStorage"]()
                    : new __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["StorageHelper"]().getStorage();
            }
        }
        else {
            if (!this._isValidAuthStorage(this._config.storage)) {
                logger.error('The storage in the Auth config is not valid!');
                throw new Error('Empty storage object');
            }
            this._storage = this._config.storage;
        }
        this._storageSync = Promise.resolve();
        if (typeof this._storage['sync'] === 'function') {
            this._storageSync = this._storage['sync']();
        }
        if (userPoolId) {
            var userPoolData = {
                UserPoolId: userPoolId,
                ClientId: userPoolWebClientId,
                endpoint: endpoint,
            };
            userPoolData.Storage = this._storage;
            this.userPool = new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["d" /* CognitoUserPool */](userPoolData, this.wrapRefreshSessionCallback);
        }
        this.Credentials.configure({
            mandatorySignIn: mandatorySignIn,
            region: identityPoolRegion || region,
            userPoolId: userPoolId,
            identityPoolId: identityPoolId,
            refreshHandlers: refreshHandlers,
            storage: this._storage,
        });
        // initialize cognitoauth client if hosted ui options provided
        // to keep backward compatibility:
        var cognitoHostedUIConfig = oauth
            ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* isCognitoHostedOpts */])(this._config.oauth)
                ? oauth
                : oauth.awsCognito
            : undefined;
        if (cognitoHostedUIConfig) {
            var cognitoAuthParams = Object.assign({
                cognitoClientId: userPoolWebClientId,
                UserPoolId: userPoolId,
                domain: cognitoHostedUIConfig['domain'],
                scopes: cognitoHostedUIConfig['scope'],
                redirectSignIn: cognitoHostedUIConfig['redirectSignIn'],
                redirectSignOut: cognitoHostedUIConfig['redirectSignOut'],
                responseType: cognitoHostedUIConfig['responseType'],
                Storage: this._storage,
                urlOpener: cognitoHostedUIConfig['urlOpener'],
                clientMetadata: clientMetadata,
            }, cognitoHostedUIConfig['options']);
            this._oAuthHandler = new __WEBPACK_IMPORTED_MODULE_4__OAuth_OAuth__["a" /* default */]({
                scopes: cognitoAuthParams.scopes,
                config: cognitoAuthParams,
                cognitoClientId: cognitoAuthParams.cognitoClientId,
            });
            // **NOTE** - Remove this in a future major release as it is a breaking change
            // Prevents _handleAuthResponse from being called multiple times in Expo
            // See https://github.com/aws-amplify/amplify-js/issues/4388
            var usedResponseUrls_1 = {};
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__urlListener__["a" /* default */])(function (_a) {
                var url = _a.url;
                if (usedResponseUrls_1[url]) {
                    return;
                }
                usedResponseUrls_1[url] = true;
                _this._handleAuthResponse(url);
            });
        }
        dispatchAuthEvent('configured', null, "The Auth category has been configured successfully");
        return this._config;
    };
    /**
     * Sign up with username, password and other attributes like phone, email
     * @param {String | object} params - The user attributes used for signin
     * @param {String[]} restOfAttrs - for the backward compatability
     * @return - A promise resolves callback data if success
     */
    AuthClass.prototype.signUp = function (params) {
        var _this = this;
        var restOfAttrs = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            restOfAttrs[_i - 1] = arguments[_i];
        }
        if (!this.userPool) {
            return this.rejectNoUserPool();
        }
        var username = null;
        var password = null;
        var attributes = [];
        var validationData = null;
        var clientMetadata;
        if (params && typeof params === 'string') {
            username = params;
            password = restOfAttrs ? restOfAttrs[0] : null;
            var email = restOfAttrs ? restOfAttrs[1] : null;
            var phone_number = restOfAttrs ? restOfAttrs[2] : null;
            if (email)
                attributes.push(new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["e" /* CognitoUserAttribute */]({ Name: 'email', Value: email }));
            if (phone_number)
                attributes.push(new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["e" /* CognitoUserAttribute */]({
                    Name: 'phone_number',
                    Value: phone_number,
                }));
        }
        else if (params && typeof params === 'object') {
            username = params['username'];
            password = params['password'];
            if (params && params.clientMetadata) {
                clientMetadata = params.clientMetadata;
            }
            else if (this._config.clientMetadata) {
                clientMetadata = this._config.clientMetadata;
            }
            var attrs_1 = params['attributes'];
            if (attrs_1) {
                Object.keys(attrs_1).map(function (key) {
                    attributes.push(new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["e" /* CognitoUserAttribute */]({ Name: key, Value: attrs_1[key] }));
                });
            }
            var validationDataObject_1 = params['validationData'];
            if (validationDataObject_1) {
                validationData = [];
                Object.keys(validationDataObject_1).map(function (key) {
                    validationData.push(new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["e" /* CognitoUserAttribute */]({
                        Name: key,
                        Value: validationDataObject_1[key],
                    }));
                });
            }
        }
        else {
            return this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].SignUpError);
        }
        if (!username) {
            return this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].EmptyUsername);
        }
        if (!password) {
            return this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].EmptyPassword);
        }
        logger.debug('signUp attrs:', attributes);
        logger.debug('signUp validation data:', validationData);
        return new Promise(function (resolve, reject) {
            _this.userPool.signUp(username, password, attributes, validationData, function (err, data) {
                if (err) {
                    dispatchAuthEvent('signUp_failure', err, username + " failed to signup");
                    reject(err);
                }
                else {
                    dispatchAuthEvent('signUp', data, username + " has signed up successfully");
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    /**
     * Send the verification code to confirm sign up
     * @param {String} username - The username to be confirmed
     * @param {String} code - The verification code
     * @param {ConfirmSignUpOptions} options - other options for confirm signup
     * @return - A promise resolves callback data if success
     */
    AuthClass.prototype.confirmSignUp = function (username, code, options) {
        if (!this.userPool) {
            return this.rejectNoUserPool();
        }
        if (!username) {
            return this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].EmptyUsername);
        }
        if (!code) {
            return this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].EmptyCode);
        }
        var user = this.createCognitoUser(username);
        var forceAliasCreation = options && typeof options.forceAliasCreation === 'boolean'
            ? options.forceAliasCreation
            : true;
        var clientMetadata;
        if (options && options.clientMetadata) {
            clientMetadata = options.clientMetadata;
        }
        else if (this._config.clientMetadata) {
            clientMetadata = this._config.clientMetadata;
        }
        return new Promise(function (resolve, reject) {
            user.confirmRegistration(code, forceAliasCreation, function (err, data) {
                if (err) {
                    reject(err);
                }
                else {
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    /**
     * Resend the verification code
     * @param {String} username - The username to be confirmed
     * @param {ClientMetadata} clientMetadata - Metadata to be passed to Cognito Lambda triggers
     * @return - A promise resolves code delivery details if successful
     */
    AuthClass.prototype.resendSignUp = function (username, clientMetadata) {
        if (clientMetadata === void 0) { clientMetadata = this._config.clientMetadata; }
        if (!this.userPool) {
            return this.rejectNoUserPool();
        }
        if (!username) {
            return this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].EmptyUsername);
        }
        var user = this.createCognitoUser(username);
        return new Promise(function (resolve, reject) {
            user.resendConfirmationCode(function (err, data) {
                if (err) {
                    reject(err);
                }
                else {
                    resolve(data);
                }
            }, clientMetadata);
        });
    };
    /**
     * Sign in
     * @param {String | SignInOpts} usernameOrSignInOpts - The username to be signed in or the sign in options
     * @param {String} password - The password of the username
     * @return - A promise resolves the CognitoUser
     */
    AuthClass.prototype.signIn = function (usernameOrSignInOpts, pw, clientMetadata) {
        if (clientMetadata === void 0) { clientMetadata = this._config.clientMetadata; }
        if (!this.userPool) {
            return this.rejectNoUserPool();
        }
        var username = null;
        var password = null;
        var validationData = {};
        // for backward compatibility
        if (typeof usernameOrSignInOpts === 'string') {
            username = usernameOrSignInOpts;
            password = pw;
        }
        else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__types__["b" /* isUsernamePasswordOpts */])(usernameOrSignInOpts)) {
            if (typeof pw !== 'undefined') {
                logger.warn('The password should be defined under the first parameter object!');
            }
            username = usernameOrSignInOpts.username;
            password = usernameOrSignInOpts.password;
            validationData = usernameOrSignInOpts.validationData;
        }
        else {
            return this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].InvalidUsername);
        }
        if (!username) {
            return this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].EmptyUsername);
        }
        var authDetails = new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["f" /* AuthenticationDetails */]({
            Username: username,
            Password: password,
            ValidationData: validationData,
            ClientMetadata: clientMetadata,
        });
        if (password) {
            return this.signInWithPassword(authDetails);
        }
        else {
            return this.signInWithoutPassword(authDetails);
        }
    };
    /**
     * Return an object with the authentication callbacks
     * @param {CognitoUser} user - the cognito user object
     * @param {} resolve - function called when resolving the current step
     * @param {} reject - function called when rejecting the current step
     * @return - an object with the callback methods for user authentication
     */
    AuthClass.prototype.authCallbacks = function (user, resolve, reject) {
        var _this = this;
        var that = this;
        return {
            onSuccess: function (session) { return __awaiter(_this, void 0, void 0, function () {
                var cred, e_1, currentUser, e_2;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            logger.debug(session);
                            delete user['challengeName'];
                            delete user['challengeParam'];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 4, 5, 9]);
                            return [4 /*yield*/, this.Credentials.clear()];
                        case 2:
                            _a.sent();
                            return [4 /*yield*/, this.Credentials.set(session, 'session')];
                        case 3:
                            cred = _a.sent();
                            logger.debug('succeed to get cognito credentials', cred);
                            return [3 /*break*/, 9];
                        case 4:
                            e_1 = _a.sent();
                            logger.debug('cannot get cognito credentials', e_1);
                            return [3 /*break*/, 9];
                        case 5:
                            _a.trys.push([5, 7, , 8]);
                            return [4 /*yield*/, this.currentUserPoolUser()];
                        case 6:
                            currentUser = _a.sent();
                            that.user = currentUser;
                            dispatchAuthEvent('signIn', currentUser, "A user " + user.getUsername() + " has been signed in");
                            resolve(currentUser);
                            return [3 /*break*/, 8];
                        case 7:
                            e_2 = _a.sent();
                            logger.error('Failed to get the signed in user', e_2);
                            reject(e_2);
                            return [3 /*break*/, 8];
                        case 8: return [7 /*endfinally*/];
                        case 9: return [2 /*return*/];
                    }
                });
            }); },
            onFailure: function (err) {
                logger.debug('signIn failure', err);
                dispatchAuthEvent('signIn_failure', err, user.getUsername() + " failed to signin");
                reject(err);
            },
            customChallenge: function (challengeParam) {
                logger.debug('signIn custom challenge answer required');
                user['challengeName'] = 'CUSTOM_CHALLENGE';
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            mfaRequired: function (challengeName, challengeParam) {
                logger.debug('signIn MFA required');
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            mfaSetup: function (challengeName, challengeParam) {
                logger.debug('signIn mfa setup', challengeName);
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            newPasswordRequired: function (userAttributes, requiredAttributes) {
                logger.debug('signIn new password');
                user['challengeName'] = 'NEW_PASSWORD_REQUIRED';
                user['challengeParam'] = {
                    userAttributes: userAttributes,
                    requiredAttributes: requiredAttributes,
                };
                resolve(user);
            },
            totpRequired: function (challengeName, challengeParam) {
                logger.debug('signIn totpRequired');
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
            selectMFAType: function (challengeName, challengeParam) {
                logger.debug('signIn selectMFAType', challengeName);
                user['challengeName'] = challengeName;
                user['challengeParam'] = challengeParam;
                resolve(user);
            },
        };
    };
    /**
     * Sign in with a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */
    AuthClass.prototype.signInWithPassword = function (authDetails) {
        var _this = this;
        if (this.pendingSignIn) {
            throw new Error('Pending sign-in attempt already in progress');
        }
        var user = this.createCognitoUser(authDetails.getUsername());
        this.pendingSignIn = new Promise(function (resolve, reject) {
            user.authenticateUser(authDetails, _this.authCallbacks(user, function (value) {
                _this.pendingSignIn = null;
                resolve(value);
            }, function (error) {
                _this.pendingSignIn = null;
                reject(error);
            }));
        });
        return this.pendingSignIn;
    };
    /**
     * Sign in without a password
     * @private
     * @param {AuthenticationDetails} authDetails - the user sign in data
     * @return - A promise resolves the CognitoUser object if success or mfa required
     */
    AuthClass.prototype.signInWithoutPassword = function (authDetails) {
        var _this = this;
        var user = this.createCognitoUser(authDetails.getUsername());
        user.setAuthenticationFlowType('CUSTOM_AUTH');
        return new Promise(function (resolve, reject) {
            user.initiateAuth(authDetails, _this.authCallbacks(user, resolve, reject));
        });
    };
    /**
     * This was previously used by an authenticated user to get MFAOptions,
     * but no longer returns a meaningful response. Refer to the documentation for
     * how to setup and use MFA: https://docs.amplify.aws/lib/auth/mfa/q/platform/js
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves the current preferred mfa option if success
     */
    AuthClass.prototype.getMFAOptions = function (user) {
        return new Promise(function (res, rej) {
            user.getMFAOptions(function (err, mfaOptions) {
                if (err) {
                    logger.debug('get MFA Options failed', err);
                    rej(err);
                    return;
                }
                logger.debug('get MFA options success', mfaOptions);
                res(mfaOptions);
                return;
            });
        });
    };
    /**
     * get preferred mfa method
     * @param {CognitoUser} user - the current cognito user
     * @param {GetPreferredMFAOpts} params - options for getting the current user preferred MFA
     */
    AuthClass.prototype.getPreferredMFA = function (user, params) {
        var _this = this;
        var that = this;
        return new Promise(function (res, rej) {
            var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
            var bypassCache = params ? params.bypassCache : false;
            user.getUserData(function (err, data) {
                if (err) {
                    logger.debug('getting preferred mfa failed', err);
                    rej(err);
                    return;
                }
                var mfaType = that._getMfaTypeFromUserData(data);
                if (!mfaType) {
                    rej('invalid MFA Type');
                    return;
                }
                else {
                    res(mfaType);
                    return;
                }
            }, { bypassCache: bypassCache, clientMetadata: clientMetadata });
        });
    };
    AuthClass.prototype._getMfaTypeFromUserData = function (data) {
        var ret = null;
        var preferredMFA = data.PreferredMfaSetting;
        // if the user has used Auth.setPreferredMFA() to setup the mfa type
        // then the "PreferredMfaSetting" would exist in the response
        if (preferredMFA) {
            ret = preferredMFA;
        }
        else {
            // if mfaList exists but empty, then its noMFA
            var mfaList = data.UserMFASettingList;
            if (!mfaList) {
                // if SMS was enabled by using Auth.enableSMS(),
                // the response would contain MFAOptions
                // as for now Cognito only supports for SMS, so we will say it is 'SMS_MFA'
                // if it does not exist, then it should be NOMFA
                var MFAOptions = data.MFAOptions;
                if (MFAOptions) {
                    ret = 'SMS_MFA';
                }
                else {
                    ret = 'NOMFA';
                }
            }
            else if (mfaList.length === 0) {
                ret = 'NOMFA';
            }
            else {
                logger.debug('invalid case for getPreferredMFA', data);
            }
        }
        return ret;
    };
    AuthClass.prototype._getUserData = function (user, params) {
        return new Promise(function (res, rej) {
            user.getUserData(function (err, data) {
                if (err) {
                    logger.debug('getting user data failed', err);
                    rej(err);
                    return;
                }
                else {
                    res(data);
                    return;
                }
            }, params);
        });
    };
    /**
     * set preferred MFA method
     * @param {CognitoUser} user - the current Cognito user
     * @param {string} mfaMethod - preferred mfa method
     * @return - A promise resolve if success
     */
    AuthClass.prototype.setPreferredMFA = function (user, mfaMethod) {
        return __awaiter(this, void 0, void 0, function () {
            var clientMetadata, userData, smsMfaSettings, totpMfaSettings, _a, mfaList, currentMFAType, that;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        clientMetadata = this._config.clientMetadata;
                        return [4 /*yield*/, this._getUserData(user, {
                                bypassCache: true,
                                clientMetadata: clientMetadata,
                            })];
                    case 1:
                        userData = _b.sent();
                        smsMfaSettings = null;
                        totpMfaSettings = null;
                        _a = mfaMethod;
                        switch (_a) {
                            case 'TOTP' || 'SOFTWARE_TOKEN_MFA': return [3 /*break*/, 2];
                            case 'SMS' || 'SMS_MFA': return [3 /*break*/, 3];
                            case 'NOMFA': return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 6];
                    case 2:
                        totpMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true,
                        };
                        return [3 /*break*/, 7];
                    case 3:
                        smsMfaSettings = {
                            PreferredMfa: true,
                            Enabled: true,
                        };
                        return [3 /*break*/, 7];
                    case 4:
                        mfaList = userData['UserMFASettingList'];
                        return [4 /*yield*/, this._getMfaTypeFromUserData(userData)];
                    case 5:
                        currentMFAType = _b.sent();
                        if (currentMFAType === 'NOMFA') {
                            return [2 /*return*/, Promise.resolve('No change for mfa type')];
                        }
                        else if (currentMFAType === 'SMS_MFA') {
                            smsMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false,
                            };
                        }
                        else if (currentMFAType === 'SOFTWARE_TOKEN_MFA') {
                            totpMfaSettings = {
                                PreferredMfa: false,
                                Enabled: false,
                            };
                        }
                        else {
                            return [2 /*return*/, this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].InvalidMFA)];
                        }
                        // if there is a UserMFASettingList in the response
                        // we need to disable every mfa type in that list
                        if (mfaList && mfaList.length !== 0) {
                            // to disable SMS or TOTP if exists in that list
                            mfaList.forEach(function (mfaType) {
                                if (mfaType === 'SMS_MFA') {
                                    smsMfaSettings = {
                                        PreferredMfa: false,
                                        Enabled: false,
                                    };
                                }
                                else if (mfaType === 'SOFTWARE_TOKEN_MFA') {
                                    totpMfaSettings = {
                                        PreferredMfa: false,
                                        Enabled: false,
                                    };
                                }
                            });
                        }
                        return [3 /*break*/, 7];
                    case 6:
                        logger.debug('no validmfa method provided');
                        return [2 /*return*/, this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].NoMFA)];
                    case 7:
                        that = this;
                        return [2 /*return*/, new Promise(function (res, rej) {
                                user.setUserMfaPreference(smsMfaSettings, totpMfaSettings, function (err, result) {
                                    if (err) {
                                        logger.debug('Set user mfa preference error', err);
                                        return rej(err);
                                    }
                                    logger.debug('Set user mfa success', result);
                                    logger.debug('Caching the latest user data into local');
                                    // cache the latest result into user data
                                    user.getUserData(function (err, data) {
                                        if (err) {
                                            logger.debug('getting user data failed', err);
                                            return rej(err);
                                        }
                                        else {
                                            return res(result);
                                        }
                                    }, {
                                        bypassCache: true,
                                        clientMetadata: clientMetadata,
                                    });
                                });
                            })];
                }
            });
        });
    };
    /**
     * diable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */
    AuthClass.prototype.disableSMS = function (user) {
        return new Promise(function (res, rej) {
            user.disableMFA(function (err, data) {
                if (err) {
                    logger.debug('disable mfa failed', err);
                    rej(err);
                    return;
                }
                logger.debug('disable mfa succeed', data);
                res(data);
                return;
            });
        });
    };
    /**
     * enable SMS
     * @deprecated
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves is success
     */
    AuthClass.prototype.enableSMS = function (user) {
        return new Promise(function (res, rej) {
            user.enableMFA(function (err, data) {
                if (err) {
                    logger.debug('enable mfa failed', err);
                    rej(err);
                    return;
                }
                logger.debug('enable mfa succeed', data);
                res(data);
                return;
            });
        });
    };
    /**
     * Setup TOTP
     * @param {CognitoUser} user - the current user
     * @return - A promise resolves with the secret code if success
     */
    AuthClass.prototype.setupTOTP = function (user) {
        return new Promise(function (res, rej) {
            user.associateSoftwareToken({
                onFailure: function (err) {
                    logger.debug('associateSoftwareToken failed', err);
                    rej(err);
                    return;
                },
                associateSecretCode: function (secretCode) {
                    logger.debug('associateSoftwareToken sucess', secretCode);
                    res(secretCode);
                    return;
                },
            });
        });
    };
    /**
     * verify TOTP setup
     * @param {CognitoUser} user - the current user
     * @param {string} challengeAnswer - challenge answer
     * @return - A promise resolves is success
     */
    AuthClass.prototype.verifyTotpToken = function (user, challengeAnswer) {
        logger.debug('verification totp token', user, challengeAnswer);
        return new Promise(function (res, rej) {
            user.verifySoftwareToken(challengeAnswer, 'My TOTP device', {
                onFailure: function (err) {
                    logger.debug('verifyTotpToken failed', err);
                    rej(err);
                    return;
                },
                onSuccess: function (data) {
                    dispatchAuthEvent('signIn', user, "A user " + user.getUsername() + " has been signed in");
                    logger.debug('verifyTotpToken success', data);
                    res(data);
                    return;
                },
            });
        });
    };
    /**
     * Send MFA code to confirm sign in
     * @param {Object} user - The CognitoUser object
     * @param {String} code - The confirmation code
     */
    AuthClass.prototype.confirmSignIn = function (user, code, mfaType, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) { clientMetadata = this._config.clientMetadata; }
        if (!code) {
            return this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].EmptyCode);
        }
        var that = this;
        return new Promise(function (resolve, reject) {
            user.sendMFACode(code, {
                onSuccess: function (session) { return __awaiter(_this, void 0, void 0, function () {
                    var cred, e_3;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                logger.debug(session);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 4, 5, 6]);
                                return [4 /*yield*/, this.Credentials.clear()];
                            case 2:
                                _a.sent();
                                return [4 /*yield*/, this.Credentials.set(session, 'session')];
                            case 3:
                                cred = _a.sent();
                                logger.debug('succeed to get cognito credentials', cred);
                                return [3 /*break*/, 6];
                            case 4:
                                e_3 = _a.sent();
                                logger.debug('cannot get cognito credentials', e_3);
                                return [3 /*break*/, 6];
                            case 5:
                                that.user = user;
                                dispatchAuthEvent('signIn', user, "A user " + user.getUsername() + " has been signed in");
                                resolve(user);
                                return [7 /*endfinally*/];
                            case 6: return [2 /*return*/];
                        }
                    });
                }); },
                onFailure: function (err) {
                    logger.debug('confirm signIn failure', err);
                    reject(err);
                },
            }, mfaType, clientMetadata);
        });
    };
    AuthClass.prototype.completeNewPassword = function (user, password, requiredAttributes, clientMetadata) {
        var _this = this;
        if (requiredAttributes === void 0) { requiredAttributes = {}; }
        if (clientMetadata === void 0) { clientMetadata = this._config.clientMetadata; }
        if (!password) {
            return this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].EmptyPassword);
        }
        var that = this;
        return new Promise(function (resolve, reject) {
            user.completeNewPasswordChallenge(password, requiredAttributes, {
                onSuccess: function (session) { return __awaiter(_this, void 0, void 0, function () {
                    var cred, e_4;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                logger.debug(session);
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 4, 5, 6]);
                                return [4 /*yield*/, this.Credentials.clear()];
                            case 2:
                                _a.sent();
                                return [4 /*yield*/, this.Credentials.set(session, 'session')];
                            case 3:
                                cred = _a.sent();
                                logger.debug('succeed to get cognito credentials', cred);
                                return [3 /*break*/, 6];
                            case 4:
                                e_4 = _a.sent();
                                logger.debug('cannot get cognito credentials', e_4);
                                return [3 /*break*/, 6];
                            case 5:
                                that.user = user;
                                dispatchAuthEvent('signIn', user, "A user " + user.getUsername() + " has been signed in");
                                resolve(user);
                                return [7 /*endfinally*/];
                            case 6: return [2 /*return*/];
                        }
                    });
                }); },
                onFailure: function (err) {
                    logger.debug('completeNewPassword failure', err);
                    dispatchAuthEvent('completeNewPassword_failure', err, _this.user + " failed to complete the new password flow");
                    reject(err);
                },
                mfaRequired: function (challengeName, challengeParam) {
                    logger.debug('signIn MFA required');
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                },
                mfaSetup: function (challengeName, challengeParam) {
                    logger.debug('signIn mfa setup', challengeName);
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                },
                totpRequired: function (challengeName, challengeParam) {
                    logger.debug('signIn mfa setup', challengeName);
                    user['challengeName'] = challengeName;
                    user['challengeParam'] = challengeParam;
                    resolve(user);
                },
            }, clientMetadata);
        });
    };
    /**
     * Send the answer to a custom challenge
     * @param {CognitoUser} user - The CognitoUser object
     * @param {String} challengeResponses - The confirmation code
     */
    AuthClass.prototype.sendCustomChallengeAnswer = function (user, challengeResponses, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) { clientMetadata = this._config.clientMetadata; }
        if (!this.userPool) {
            return this.rejectNoUserPool();
        }
        if (!challengeResponses) {
            return this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].EmptyChallengeResponse);
        }
        var that = this;
        return new Promise(function (resolve, reject) {
            user.sendCustomChallengeAnswer(challengeResponses, _this.authCallbacks(user, resolve, reject), clientMetadata);
        });
    };
    /**
     * Update an authenticated users' attributes
     * @param {CognitoUser} - The currently logged in user object
     * @return {Promise}
     **/
    AuthClass.prototype.updateUserAttributes = function (user, attributes, clientMetadata) {
        if (clientMetadata === void 0) { clientMetadata = this._config.clientMetadata; }
        var attributeList = [];
        var that = this;
        return new Promise(function (resolve, reject) {
            that.userSession(user).then(function (session) {
                for (var key in attributes) {
                    if (key !== 'sub' && key.indexOf('_verified') < 0) {
                        var attr = {
                            Name: key,
                            Value: attributes[key],
                        };
                        attributeList.push(attr);
                    }
                }
                user.updateAttributes(attributeList, function (err, result) {
                    if (err) {
                        return reject(err);
                    }
                    else {
                        return resolve(result);
                    }
                }, clientMetadata);
            });
        });
    };
    /**
     * Return user attributes
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to user attributes if success
     */
    AuthClass.prototype.userAttributes = function (user) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.userSession(user).then(function (session) {
                user.getUserAttributes(function (err, attributes) {
                    if (err) {
                        reject(err);
                    }
                    else {
                        resolve(attributes);
                    }
                });
            });
        });
    };
    AuthClass.prototype.verifiedContact = function (user) {
        var that = this;
        return this.userAttributes(user).then(function (attributes) {
            var attrs = that.attributesToObject(attributes);
            var unverified = {};
            var verified = {};
            if (attrs['email']) {
                if (attrs['email_verified']) {
                    verified['email'] = attrs['email'];
                }
                else {
                    unverified['email'] = attrs['email'];
                }
            }
            if (attrs['phone_number']) {
                if (attrs['phone_number_verified']) {
                    verified['phone_number'] = attrs['phone_number'];
                }
                else {
                    unverified['phone_number'] = attrs['phone_number'];
                }
            }
            return {
                verified: verified,
                unverified: unverified,
            };
        });
    };
    /**
     * Get current authenticated user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */
    AuthClass.prototype.currentUserPoolUser = function (params) {
        var _this = this;
        if (!this.userPool) {
            return this.rejectNoUserPool();
        }
        return new Promise(function (res, rej) {
            _this._storageSync
                .then(function () { return __awaiter(_this, void 0, void 0, function () {
                var user, clientMetadata;
                var _this = this;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!this.isOAuthInProgress()) return [3 /*break*/, 2];
                            logger.debug('OAuth signIn in progress, waiting for resolution...');
                            return [4 /*yield*/, new Promise(function (res) {
                                    var timeoutId = setTimeout(function () {
                                        logger.debug('OAuth signIn in progress timeout');
                                        __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["Hub"].remove('auth', hostedUISignCallback);
                                        res();
                                    }, OAUTH_FLOW_MS_TIMEOUT);
                                    __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["Hub"].listen('auth', hostedUISignCallback);
                                    function hostedUISignCallback(_a) {
                                        var payload = _a.payload;
                                        var event = payload.event;
                                        if (event === 'cognitoHostedUI' ||
                                            event === 'cognitoHostedUI_failure') {
                                            logger.debug("OAuth signIn resolved: " + event);
                                            clearTimeout(timeoutId);
                                            __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["Hub"].remove('auth', hostedUISignCallback);
                                            res();
                                        }
                                    }
                                })];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            user = this.userPool.getCurrentUser();
                            if (!user) {
                                logger.debug('Failed to get user from user pool');
                                rej('No current user');
                                return [2 /*return*/];
                            }
                            clientMetadata = this._config.clientMetadata;
                            // refresh the session if the session expired.
                            user.getSession(function (err, session) { return __awaiter(_this, void 0, void 0, function () {
                                var bypassCache, clientMetadata, _a, scope;
                                var _this = this;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            if (err) {
                                                logger.debug('Failed to get the user session', err);
                                                rej(err);
                                                return [2 /*return*/];
                                            }
                                            bypassCache = params ? params.bypassCache : false;
                                            if (!bypassCache) return [3 /*break*/, 2];
                                            return [4 /*yield*/, this.Credentials.clear()];
                                        case 1:
                                            _b.sent();
                                            _b.label = 2;
                                        case 2:
                                            clientMetadata = this._config.clientMetadata;
                                            _a = session.getAccessToken().decodePayload().scope, scope = _a === void 0 ? '' : _a;
                                            if (scope.split(' ').includes(USER_ADMIN_SCOPE)) {
                                                user.getUserData(function (err, data) {
                                                    if (err) {
                                                        logger.debug('getting user data failed', err);
                                                        // Make sure the user is still valid
                                                        if (err.message === 'User is disabled.' ||
                                                            err.message === 'User does not exist.' ||
                                                            err.message === 'Access Token has been revoked' // Session revoked by another app
                                                        ) {
                                                            rej(err);
                                                        }
                                                        else {
                                                            // the error may also be thrown when lack of permissions to get user info etc
                                                            // in that case we just bypass the error
                                                            res(user);
                                                        }
                                                        return;
                                                    }
                                                    var preferredMFA = data.PreferredMfaSetting || 'NOMFA';
                                                    var attributeList = [];
                                                    for (var i = 0; i < data.UserAttributes.length; i++) {
                                                        var attribute = {
                                                            Name: data.UserAttributes[i].Name,
                                                            Value: data.UserAttributes[i].Value,
                                                        };
                                                        var userAttribute = new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["e" /* CognitoUserAttribute */](attribute);
                                                        attributeList.push(userAttribute);
                                                    }
                                                    var attributes = _this.attributesToObject(attributeList);
                                                    Object.assign(user, { attributes: attributes, preferredMFA: preferredMFA });
                                                    return res(user);
                                                }, { bypassCache: bypassCache, clientMetadata: clientMetadata });
                                            }
                                            else {
                                                logger.debug("Unable to get the user data because the " + USER_ADMIN_SCOPE + " " +
                                                    "is not in the scopes of the access token");
                                                return [2 /*return*/, res(user)];
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, { clientMetadata: clientMetadata });
                            return [2 /*return*/];
                    }
                });
            }); })
                .catch(function (e) {
                logger.debug('Failed to sync cache info into memory', e);
                return rej(e);
            });
        });
    };
    AuthClass.prototype.isOAuthInProgress = function () {
        return this.oAuthFlowInProgress;
    };
    /**
     * Get current authenticated user
     * @param {CurrentUserOpts} - options for getting the current user
     * @return - A promise resolves to current authenticated CognitoUser if success
     */
    AuthClass.prototype.currentAuthenticatedUser = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var federatedUser, e_5, federatedInfo, user, e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger.debug('getting current authenticated user');
                        federatedUser = null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._storageSync];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_5 = _a.sent();
                        logger.debug('Failed to sync cache info into memory', e_5);
                        throw e_5;
                    case 4:
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem('aws-amplify-federatedInfo'));
                            if (federatedInfo) {
                                federatedUser = __assign(__assign({}, federatedInfo.user), { token: federatedInfo.token });
                            }
                        }
                        catch (e) {
                            logger.debug('cannot load federated user from auth storage');
                        }
                        if (!federatedUser) return [3 /*break*/, 5];
                        this.user = federatedUser;
                        logger.debug('get current authenticated federated user', this.user);
                        return [2 /*return*/, this.user];
                    case 5:
                        logger.debug('get current authenticated userpool user');
                        user = null;
                        _a.label = 6;
                    case 6:
                        _a.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, this.currentUserPoolUser(params)];
                    case 7:
                        user = _a.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        e_6 = _a.sent();
                        if (e_6 === 'No userPool') {
                            logger.error('Cannot get the current user because the user pool is missing. ' +
                                'Please make sure the Auth module is configured with a valid Cognito User Pool ID');
                        }
                        logger.debug('The user is not authenticated by the error', e_6);
                        return [2 /*return*/, Promise.reject('The user is not authenticated')];
                    case 9:
                        this.user = user;
                        return [2 /*return*/, this.user];
                }
            });
        });
    };
    /**
     * Get current user's session
     * @return - A promise resolves to session object if success
     */
    AuthClass.prototype.currentSession = function () {
        var that = this;
        logger.debug('Getting current session');
        // Purposely not calling the reject method here because we don't need a console error
        if (!this.userPool) {
            return Promise.reject();
        }
        return new Promise(function (res, rej) {
            that
                .currentUserPoolUser()
                .then(function (user) {
                that
                    .userSession(user)
                    .then(function (session) {
                    res(session);
                    return;
                })
                    .catch(function (e) {
                    logger.debug('Failed to get the current session', e);
                    rej(e);
                    return;
                });
            })
                .catch(function (e) {
                logger.debug('Failed to get the current user', e);
                rej(e);
                return;
            });
        });
    };
    /**
     * Get the corresponding user session
     * @param {Object} user - The CognitoUser object
     * @return - A promise resolves to the session
     */
    AuthClass.prototype.userSession = function (user) {
        if (!user) {
            logger.debug('the user is null');
            return this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].NoUserSession);
        }
        var clientMetadata = this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
        return new Promise(function (resolve, reject) {
            logger.debug('Getting the session from this user:', user);
            user.getSession(function (err, session) {
                if (err) {
                    logger.debug('Failed to get the session from user', user);
                    reject(err);
                    return;
                }
                else {
                    logger.debug('Succeed to get the user session', session);
                    resolve(session);
                    return;
                }
            }, { clientMetadata: clientMetadata });
        });
    };
    /**
     * Get authenticated credentials of current user.
     * @return - A promise resolves to be current user's credentials
     */
    AuthClass.prototype.currentUserCredentials = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_7, federatedInfo;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger.debug('Getting current user credentials');
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._storageSync];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        e_7 = _a.sent();
                        logger.debug('Failed to sync cache info into memory', e_7);
                        throw e_7;
                    case 4:
                        federatedInfo = null;
                        try {
                            federatedInfo = JSON.parse(this._storage.getItem('aws-amplify-federatedInfo'));
                        }
                        catch (e) {
                            logger.debug('failed to get or parse item aws-amplify-federatedInfo', e);
                        }
                        if (federatedInfo) {
                            // refresh the jwt token here if necessary
                            return [2 /*return*/, this.Credentials.refreshFederatedToken(federatedInfo)];
                        }
                        else {
                            return [2 /*return*/, this.currentSession()
                                    .then(function (session) {
                                    logger.debug('getting session success', session);
                                    return _this.Credentials.set(session, 'session');
                                })
                                    .catch(function (error) {
                                    logger.debug('getting session failed', error);
                                    return _this.Credentials.set(null, 'guest');
                                })];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthClass.prototype.currentCredentials = function () {
        logger.debug('getting current credentials');
        return this.Credentials.get();
    };
    /**
     * Initiate an attribute confirmation request
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attributes to be verified
     * @return - A promise resolves to callback data if success
     */
    AuthClass.prototype.verifyUserAttribute = function (user, attr, clientMetadata) {
        if (clientMetadata === void 0) { clientMetadata = this._config.clientMetadata; }
        return new Promise(function (resolve, reject) {
            user.getAttributeVerificationCode(attr, {
                onSuccess: function () {
                    return resolve();
                },
                onFailure: function (err) {
                    return reject(err);
                },
            }, clientMetadata);
        });
    };
    /**
     * Confirm an attribute using a confirmation code
     * @param {Object} user - The CognitoUser
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */
    AuthClass.prototype.verifyUserAttributeSubmit = function (user, attr, code) {
        if (!code) {
            return this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].EmptyCode);
        }
        return new Promise(function (resolve, reject) {
            user.verifyAttribute(attr, code, {
                onSuccess: function (data) {
                    resolve(data);
                    return;
                },
                onFailure: function (err) {
                    reject(err);
                    return;
                },
            });
        });
    };
    AuthClass.prototype.verifyCurrentUserAttribute = function (attr) {
        var that = this;
        return that
            .currentUserPoolUser()
            .then(function (user) { return that.verifyUserAttribute(user, attr); });
    };
    /**
     * Confirm current user's attribute using a confirmation code
     * @param {Object} attr - The attribute to be verified
     * @param {String} code - The confirmation code
     * @return - A promise resolves to callback data if success
     */
    AuthClass.prototype.verifyCurrentUserAttributeSubmit = function (attr, code) {
        var that = this;
        return that
            .currentUserPoolUser()
            .then(function (user) { return that.verifyUserAttributeSubmit(user, attr, code); });
    };
    AuthClass.prototype.cognitoIdentitySignOut = function (opts, user) {
        return __awaiter(this, void 0, void 0, function () {
            var e_8, isSignedInHostedUI;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this._storageSync];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_8 = _a.sent();
                        logger.debug('Failed to sync cache info into memory', e_8);
                        throw e_8;
                    case 3:
                        isSignedInHostedUI = this._oAuthHandler &&
                            this._storage.getItem('amplify-signin-with-hostedUI') === 'true';
                        return [2 /*return*/, new Promise(function (res, rej) {
                                if (opts && opts.global) {
                                    logger.debug('user global sign out', user);
                                    // in order to use global signout
                                    // we must validate the user as an authenticated user by using getSession
                                    var clientMetadata = _this._config.clientMetadata; // TODO: verify behavior if this is override during signIn
                                    user.getSession(function (err, result) {
                                        if (err) {
                                            logger.debug('failed to get the user session', err);
                                            return rej(err);
                                        }
                                        user.globalSignOut({
                                            onSuccess: function (data) {
                                                logger.debug('global sign out success');
                                                if (isSignedInHostedUI) {
                                                    _this.oAuthSignOutRedirect(res, rej);
                                                }
                                                else {
                                                    return res();
                                                }
                                            },
                                            onFailure: function (err) {
                                                logger.debug('global sign out failed', err);
                                                return rej(err);
                                            },
                                        });
                                    }, { clientMetadata: clientMetadata });
                                }
                                else {
                                    logger.debug('user sign out', user);
                                    user.signOut(function () {
                                        if (isSignedInHostedUI) {
                                            _this.oAuthSignOutRedirect(res, rej);
                                        }
                                        else {
                                            return res();
                                        }
                                    });
                                }
                            })];
                }
            });
        });
    };
    AuthClass.prototype.oAuthSignOutRedirect = function (resolve, reject) {
        var isBrowser = __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["JS"].browserOrNode().isBrowser;
        if (isBrowser) {
            this.oAuthSignOutRedirectOrReject(reject);
        }
        else {
            this.oAuthSignOutAndResolve(resolve);
        }
    };
    AuthClass.prototype.oAuthSignOutAndResolve = function (resolve) {
        this._oAuthHandler.signOut();
        resolve();
    };
    AuthClass.prototype.oAuthSignOutRedirectOrReject = function (reject) {
        this._oAuthHandler.signOut(); // this method redirects url
        // App should be redirected to another url otherwise it will reject
        setTimeout(function () { return reject('Signout timeout fail'); }, 3000);
    };
    /**
     * Sign out method
     * @
     * @return - A promise resolved if success
     */
    AuthClass.prototype.signOut = function (opts) {
        return __awaiter(this, void 0, void 0, function () {
            var e_9, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.cleanCachedItems()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_9 = _a.sent();
                        logger.debug('failed to clear cached items');
                        return [3 /*break*/, 3];
                    case 3:
                        if (!this.userPool) return [3 /*break*/, 7];
                        user = this.userPool.getCurrentUser();
                        if (!user) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.cognitoIdentitySignOut(opts, user)];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        logger.debug('no current Cognito user');
                        _a.label = 6;
                    case 6: return [3 /*break*/, 8];
                    case 7:
                        logger.debug('no Congito User pool');
                        _a.label = 8;
                    case 8:
                        /**
                         * Note for future refactor - no reliable way to get username with
                         * Cognito User Pools vs Identity when federating with Social Providers
                         * This is why we need a well structured session object that can be inspected
                         * and information passed back in the message below for Hub dispatch
                         */
                        dispatchAuthEvent('signOut', this.user, "A user has been signed out");
                        this.user = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthClass.prototype.cleanCachedItems = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // clear cognito cached item
                    return [4 /*yield*/, this.Credentials.clear()];
                    case 1:
                        // clear cognito cached item
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Change a password for an authenticated user
     * @param {Object} user - The CognitoUser object
     * @param {String} oldPassword - the current password
     * @param {String} newPassword - the requested new password
     * @return - A promise resolves if success
     */
    AuthClass.prototype.changePassword = function (user, oldPassword, newPassword, clientMetadata) {
        var _this = this;
        if (clientMetadata === void 0) { clientMetadata = this._config.clientMetadata; }
        return new Promise(function (resolve, reject) {
            _this.userSession(user).then(function (session) {
                user.changePassword(oldPassword, newPassword, function (err, data) {
                    if (err) {
                        logger.debug('change password failure', err);
                        return reject(err);
                    }
                    else {
                        return resolve(data);
                    }
                }, clientMetadata);
            });
        });
    };
    /**
     * Initiate a forgot password request
     * @param {String} username - the username to change password
     * @return - A promise resolves if success
     */
    AuthClass.prototype.forgotPassword = function (username, clientMetadata) {
        if (clientMetadata === void 0) { clientMetadata = this._config.clientMetadata; }
        if (!this.userPool) {
            return this.rejectNoUserPool();
        }
        if (!username) {
            return this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].EmptyUsername);
        }
        var user = this.createCognitoUser(username);
        return new Promise(function (resolve, reject) {
            user.forgotPassword({
                onSuccess: function () {
                    resolve();
                    return;
                },
                onFailure: function (err) {
                    logger.debug('forgot password failure', err);
                    dispatchAuthEvent('forgotPassword_failure', err, username + " forgotPassword failed");
                    reject(err);
                    return;
                },
                inputVerificationCode: function (data) {
                    dispatchAuthEvent('forgotPassword', user, username + " has initiated forgot password flow");
                    resolve(data);
                    return;
                },
            }, clientMetadata);
        });
    };
    /**
     * Confirm a new password using a confirmation Code
     * @param {String} username - The username
     * @param {String} code - The confirmation code
     * @param {String} password - The new password
     * @return - A promise that resolves if success
     */
    AuthClass.prototype.forgotPasswordSubmit = function (username, code, password, clientMetadata) {
        if (clientMetadata === void 0) { clientMetadata = this._config.clientMetadata; }
        if (!this.userPool) {
            return this.rejectNoUserPool();
        }
        if (!username) {
            return this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].EmptyUsername);
        }
        if (!code) {
            return this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].EmptyCode);
        }
        if (!password) {
            return this.rejectAuthError(__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].EmptyPassword);
        }
        var user = this.createCognitoUser(username);
        return new Promise(function (resolve, reject) {
            user.confirmPassword(code, password, {
                onSuccess: function () {
                    dispatchAuthEvent('forgotPasswordSubmit', user, username + " forgotPasswordSubmit successful");
                    resolve();
                    return;
                },
                onFailure: function (err) {
                    dispatchAuthEvent('forgotPasswordSubmit_failure', err, username + " forgotPasswordSubmit failed");
                    reject(err);
                    return;
                },
            }, clientMetadata);
        });
    };
    /**
     * Get user information
     * @async
     * @return {Object }- current User's information
     */
    AuthClass.prototype.currentUserInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var source, user, attributes, userAttrs, credentials, e_10, info, err_1, user;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        source = this.Credentials.getCredSource();
                        if (!(!source || source === 'aws' || source === 'userPool')) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.currentUserPoolUser().catch(function (err) {
                                return logger.debug(err);
                            })];
                    case 1:
                        user = _a.sent();
                        if (!user) {
                            return [2 /*return*/, null];
                        }
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 8, , 9]);
                        return [4 /*yield*/, this.userAttributes(user)];
                    case 3:
                        attributes = _a.sent();
                        userAttrs = this.attributesToObject(attributes);
                        credentials = null;
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, this.currentCredentials()];
                    case 5:
                        credentials = _a.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        e_10 = _a.sent();
                        logger.debug('Failed to retrieve credentials while getting current user info', e_10);
                        return [3 /*break*/, 7];
                    case 7:
                        info = {
                            id: credentials ? credentials.identityId : undefined,
                            username: user.getUsername(),
                            attributes: userAttrs,
                        };
                        return [2 /*return*/, info];
                    case 8:
                        err_1 = _a.sent();
                        logger.debug('currentUserInfo error', err_1);
                        return [2 /*return*/, {}];
                    case 9:
                        if (source === 'federated') {
                            user = this.user;
                            return [2 /*return*/, user ? user : {}];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AuthClass.prototype.federatedSignIn = function (providerOrOptions, response, user) {
        return __awaiter(this, void 0, void 0, function () {
            var options, provider, customState, client_id, redirect_uri, provider, loggedInUser, token, identity_id, expires_at, credentials, currentUser;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._config.identityPoolId && !this._config.userPoolId) {
                            throw new Error("Federation requires either a User Pool or Identity Pool in config");
                        }
                        // Ensure backwards compatability
                        if (typeof providerOrOptions === 'undefined') {
                            if (this._config.identityPoolId && !this._config.userPoolId) {
                                throw new Error("Federation with Identity Pools requires tokens passed as arguments");
                            }
                        }
                        if (!(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__types__["c" /* isFederatedSignInOptions */])(providerOrOptions) ||
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__types__["d" /* isFederatedSignInOptionsCustom */])(providerOrOptions) ||
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__types__["e" /* hasCustomState */])(providerOrOptions) ||
                            typeof providerOrOptions === 'undefined')) return [3 /*break*/, 1];
                        options = providerOrOptions || {
                            provider: __WEBPACK_IMPORTED_MODULE_7__types_Auth__["a" /* CognitoHostedUIIdentityProvider */].Cognito,
                        };
                        provider = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__types__["c" /* isFederatedSignInOptions */])(options)
                            ? options.provider
                            : options.customProvider;
                        customState = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__types__["c" /* isFederatedSignInOptions */])(options)
                            ? options.customState
                            : options.customState;
                        if (this._config.userPoolId) {
                            client_id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* isCognitoHostedOpts */])(this._config.oauth)
                                ? this._config.userPoolWebClientId
                                : this._config.oauth.clientID;
                            redirect_uri = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__types__["a" /* isCognitoHostedOpts */])(this._config.oauth)
                                ? this._config.oauth.redirectSignIn
                                : this._config.oauth.redirectUri;
                            this._oAuthHandler.oauthSignIn(this._config.oauth.responseType, this._config.oauth.domain, redirect_uri, client_id, provider, customState);
                        }
                        return [3 /*break*/, 4];
                    case 1:
                        provider = providerOrOptions;
                        // To check if the user is already logged in
                        try {
                            loggedInUser = JSON.stringify(JSON.parse(this._storage.getItem('aws-amplify-federatedInfo')).user);
                            if (loggedInUser) {
                                logger.warn("There is already a signed in user: " + loggedInUser + " in your app.\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tYou should not call Auth.federatedSignIn method again as it may cause unexpected behavior.");
                            }
                        }
                        catch (e) { }
                        token = response.token, identity_id = response.identity_id, expires_at = response.expires_at;
                        return [4 /*yield*/, this.Credentials.set({ provider: provider, token: token, identity_id: identity_id, user: user, expires_at: expires_at }, 'federation')];
                    case 2:
                        credentials = _a.sent();
                        return [4 /*yield*/, this.currentAuthenticatedUser()];
                    case 3:
                        currentUser = _a.sent();
                        dispatchAuthEvent('signIn', currentUser, "A user " + currentUser.username + " has been signed in");
                        logger.debug('federated sign in credentials', credentials);
                        return [2 /*return*/, credentials];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Used to complete the OAuth flow with or without the Cognito Hosted UI
     * @param {String} URL - optional parameter for customers to pass in the response URL
     */
    AuthClass.prototype._handleAuthResponse = function (URL) {
        return __awaiter(this, void 0, void 0, function () {
            var currentUrl, hasCodeOrError, hasTokenOrError, _a, accessToken, idToken, refreshToken, state, session, credentials, isCustomStateIncluded, currentUser, customState, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (this.oAuthFlowInProgress) {
                            logger.debug("Skipping URL " + URL + " current flow in progress");
                            return [2 /*return*/];
                        }
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, , 8, 9]);
                        this.oAuthFlowInProgress = true;
                        if (!this._config.userPoolId) {
                            throw new Error("OAuth responses require a User Pool defined in config");
                        }
                        dispatchAuthEvent('parsingCallbackUrl', { url: URL }, "The callback url is being parsed");
                        currentUrl = URL || (__WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["JS"].browserOrNode().isBrowser ? window.location.href : '');
                        hasCodeOrError = !!(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_url__["parse"])(currentUrl).query || '')
                            .split('&')
                            .map(function (entry) { return entry.split('='); })
                            .find(function (_a) {
                            var _b = __read(_a, 1), k = _b[0];
                            return k === 'code' || k === 'error';
                        });
                        hasTokenOrError = !!(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_url__["parse"])(currentUrl).hash || '#')
                            .substr(1)
                            .split('&')
                            .map(function (entry) { return entry.split('='); })
                            .find(function (_a) {
                            var _b = __read(_a, 1), k = _b[0];
                            return k === 'access_token' || k === 'error';
                        });
                        if (!(hasCodeOrError || hasTokenOrError)) return [3 /*break*/, 7];
                        this._storage.setItem('amplify-redirected-from-hosted-ui', 'true');
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 6, , 7]);
                        return [4 /*yield*/, this._oAuthHandler.handleAuthResponse(currentUrl)];
                    case 3:
                        _a = _b.sent(), accessToken = _a.accessToken, idToken = _a.idToken, refreshToken = _a.refreshToken, state = _a.state;
                        session = new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["g" /* CognitoUserSession */]({
                            IdToken: new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["h" /* CognitoIdToken */]({ IdToken: idToken }),
                            RefreshToken: new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["i" /* CognitoRefreshToken */]({
                                RefreshToken: refreshToken,
                            }),
                            AccessToken: new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["j" /* CognitoAccessToken */]({
                                AccessToken: accessToken,
                            }),
                        });
                        credentials = void 0;
                        if (!this._config.identityPoolId) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.Credentials.set(session, 'session')];
                    case 4:
                        credentials = _b.sent();
                        logger.debug('AWS credentials', credentials);
                        _b.label = 5;
                    case 5:
                        isCustomStateIncluded = /-/.test(state);
                        currentUser = this.createCognitoUser(session.getIdToken().decodePayload()['cognito:username']);
                        // This calls cacheTokens() in Cognito SDK
                        currentUser.setSignInUserSession(session);
                        if (window && typeof window.history !== 'undefined') {
                            window.history.replaceState({}, null, this._config.oauth.redirectSignIn);
                        }
                        dispatchAuthEvent('signIn', currentUser, "A user " + currentUser.getUsername() + " has been signed in");
                        dispatchAuthEvent('cognitoHostedUI', currentUser, "A user " + currentUser.getUsername() + " has been signed in via Cognito Hosted UI");
                        if (isCustomStateIncluded) {
                            customState = state
                                .split('-')
                                .splice(1)
                                .join('-');
                            dispatchAuthEvent('customOAuthState', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["urlSafeDecode"])(customState), "State for user " + currentUser.getUsername());
                        }
                        //#endregion
                        return [2 /*return*/, credentials];
                    case 6:
                        err_2 = _b.sent();
                        logger.debug('Error in cognito hosted auth response', err_2);
                        dispatchAuthEvent('signIn_failure', err_2, "The OAuth response flow failed");
                        dispatchAuthEvent('cognitoHostedUI_failure', err_2, "A failure occurred when returning to the Cognito Hosted UI");
                        dispatchAuthEvent('customState_failure', err_2, "A failure occurred when returning state");
                        return [3 /*break*/, 7];
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        this.oAuthFlowInProgress = false;
                        return [7 /*endfinally*/];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */
    AuthClass.prototype.essentialCredentials = function (credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated,
        };
    };
    AuthClass.prototype.attributesToObject = function (attributes) {
        var _this = this;
        var obj = {};
        if (attributes) {
            attributes.map(function (attribute) {
                if (attribute.Name === 'email_verified' ||
                    attribute.Name === 'phone_number_verified') {
                    obj[attribute.Name] =
                        _this.isTruthyString(attribute.Value) || attribute.Value === true;
                }
                else {
                    obj[attribute.Name] = attribute.Value;
                }
            });
        }
        return obj;
    };
    AuthClass.prototype.isTruthyString = function (value) {
        return (typeof value.toLowerCase === 'function' && value.toLowerCase() === 'true');
    };
    AuthClass.prototype.createCognitoUser = function (username) {
        var userData = {
            Username: username,
            Pool: this.userPool,
        };
        userData.Storage = this._storage;
        var authenticationFlowType = this._config.authenticationFlowType;
        var user = new __WEBPACK_IMPORTED_MODULE_2_amazon_cognito_identity_js__["a" /* CognitoUser */](userData);
        if (authenticationFlowType) {
            user.setAuthenticationFlowType(authenticationFlowType);
        }
        return user;
    };
    AuthClass.prototype._isValidAuthStorage = function (obj) {
        // We need to check if the obj has the functions of Storage
        return (!!obj &&
            typeof obj.getItem === 'function' &&
            typeof obj.setItem === 'function' &&
            typeof obj.removeItem === 'function' &&
            typeof obj.clear === 'function');
    };
    AuthClass.prototype.noUserPoolErrorHandler = function (config) {
        if (config) {
            if (!config.userPoolId || !config.identityPoolId) {
                return __WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].MissingAuthConfig;
            }
        }
        return __WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].NoConfig;
    };
    AuthClass.prototype.rejectAuthError = function (type) {
        return Promise.reject(new __WEBPACK_IMPORTED_MODULE_6__Errors__["a" /* AuthError */](type));
    };
    AuthClass.prototype.rejectNoUserPool = function () {
        var type = this.noUserPoolErrorHandler(this._config);
        return Promise.reject(new __WEBPACK_IMPORTED_MODULE_6__Errors__["b" /* NoUserPoolError */](type));
    };
    AuthClass.prototype.rememberDevice = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currUser, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.currentUserPoolUser()];
                    case 1:
                        currUser = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        logger.debug('The user is not authenticated by the error', error_1);
                        return [2 /*return*/, Promise.reject('The user is not authenticated')];
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [2 /*return*/, new Promise(function (res, rej) {
                                currUser.setDeviceStatusRemembered({
                                    onSuccess: function (data) {
                                        res(data);
                                    },
                                    onFailure: function (err) {
                                        if (err.code === 'InvalidParameterException') {
                                            rej(new __WEBPACK_IMPORTED_MODULE_6__Errors__["a" /* AuthError */](__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].DeviceConfig));
                                        }
                                        else if (err.code === 'NetworkError') {
                                            rej(new __WEBPACK_IMPORTED_MODULE_6__Errors__["a" /* AuthError */](__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].NetworkError));
                                        }
                                        else {
                                            rej(err);
                                        }
                                    },
                                });
                            })];
                }
            });
        });
    };
    AuthClass.prototype.forgetDevice = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currUser, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.currentUserPoolUser()];
                    case 1:
                        currUser = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        logger.debug('The user is not authenticated by the error', error_2);
                        return [2 /*return*/, Promise.reject('The user is not authenticated')];
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [2 /*return*/, new Promise(function (res, rej) {
                                currUser.forgetDevice({
                                    onSuccess: function (data) {
                                        res(data);
                                    },
                                    onFailure: function (err) {
                                        if (err.code === 'InvalidParameterException') {
                                            rej(new __WEBPACK_IMPORTED_MODULE_6__Errors__["a" /* AuthError */](__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].DeviceConfig));
                                        }
                                        else if (err.code === 'NetworkError') {
                                            rej(new __WEBPACK_IMPORTED_MODULE_6__Errors__["a" /* AuthError */](__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].NetworkError));
                                        }
                                        else {
                                            rej(err);
                                        }
                                    },
                                });
                            })];
                }
            });
        });
    };
    AuthClass.prototype.fetchDevices = function () {
        return __awaiter(this, void 0, void 0, function () {
            var currUser, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.currentUserPoolUser()];
                    case 1:
                        currUser = _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_3 = _a.sent();
                        logger.debug('The user is not authenticated by the error', error_3);
                        throw new Error('The user is not authenticated');
                    case 3:
                        currUser.getCachedDeviceKeyAndPassword();
                        return [2 /*return*/, new Promise(function (res, rej) {
                                var cb = {
                                    onSuccess: function (data) {
                                        var deviceList = data.Devices.map(function (device) {
                                            var deviceName = device.DeviceAttributes.find(function (_a) {
                                                var Name = _a.Name;
                                                return Name === 'device_name';
                                            }) || {};
                                            var deviceInfo = {
                                                id: device.DeviceKey,
                                                name: deviceName.Value,
                                            };
                                            return deviceInfo;
                                        });
                                        res(deviceList);
                                    },
                                    onFailure: function (err) {
                                        if (err.code === 'InvalidParameterException') {
                                            rej(new __WEBPACK_IMPORTED_MODULE_6__Errors__["a" /* AuthError */](__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].DeviceConfig));
                                        }
                                        else if (err.code === 'NetworkError') {
                                            rej(new __WEBPACK_IMPORTED_MODULE_6__Errors__["a" /* AuthError */](__WEBPACK_IMPORTED_MODULE_7__types_Auth__["b" /* AuthErrorTypes */].NetworkError));
                                        }
                                        else {
                                            rej(err);
                                        }
                                    },
                                };
                                currUser.listDevices(MAX_DEVICES, null, cb);
                            })];
                }
            });
        });
    };
    return AuthClass;
}());

var Auth = new AuthClass(null);
__WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["Amplify"].register(Auth);
//# sourceMappingURL=Auth.js.map

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NoUserPoolError; });
/* unused harmony export authErrorMessages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_AuthErrorStrings__ = __webpack_require__(773);
/*
 * Copyright 2019-2020 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var logger = new __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["ConsoleLogger"]('AuthError');
var AuthError = /** @class */ (function (_super) {
    __extends(AuthError, _super);
    function AuthError(type) {
        var _this = this;
        var _a = authErrorMessages[type], message = _a.message, log = _a.log;
        _this = _super.call(this, message) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = AuthError;
        Object.setPrototypeOf(_this, AuthError.prototype);
        _this.name = 'AuthError';
        _this.log = log || message;
        logger.error(_this.log);
        return _this;
    }
    return AuthError;
}(Error));

var NoUserPoolError = /** @class */ (function (_super) {
    __extends(NoUserPoolError, _super);
    function NoUserPoolError(type) {
        var _this = _super.call(this, type) || this;
        // Hack for making the custom error class work when transpiled to es5
        // TODO: Delete the following 2 lines after we change the build target to >= es2015
        _this.constructor = NoUserPoolError;
        Object.setPrototypeOf(_this, NoUserPoolError.prototype);
        _this.name = 'NoUserPoolError';
        return _this;
    }
    return NoUserPoolError;
}(AuthError));

var authErrorMessages = {
    noConfig: {
        message: __WEBPACK_IMPORTED_MODULE_1__common_AuthErrorStrings__["a" /* AuthErrorStrings */].DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly.\n            This error is typically caused by one of the following scenarios:\n\n            1. Make sure you're passing the awsconfig object to Amplify.configure() in your app's entry point\n                See https://aws-amplify.github.io/docs/js/authentication#configure-your-app for more information\n            \n            2. There might be multiple conflicting versions of amplify packages in your node_modules.\n\t\t\t\tRefer to our docs site for help upgrading Amplify packages (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js)\n        ",
    },
    missingAuthConfig: {
        message: __WEBPACK_IMPORTED_MODULE_1__common_AuthErrorStrings__["a" /* AuthErrorStrings */].DEFAULT_MSG,
        log: "\n            Error: Amplify has not been configured correctly. \n            The configuration object is missing required auth properties.\n            This error is typically caused by one of the following scenarios:\n\n            1. Did you run `amplify push` after adding auth via `amplify add auth`?\n                See https://aws-amplify.github.io/docs/js/authentication#amplify-project-setup for more information\n\n            2. This could also be caused by multiple conflicting versions of amplify packages, see (https://docs.amplify.aws/lib/troubleshooting/upgrading/q/platform/js) for help upgrading Amplify packages.\n        ",
    },
    emptyUsername: {
        message: __WEBPACK_IMPORTED_MODULE_1__common_AuthErrorStrings__["a" /* AuthErrorStrings */].EMPTY_USERNAME,
    },
    // TODO: should include a list of valid sign-in types
    invalidUsername: {
        message: __WEBPACK_IMPORTED_MODULE_1__common_AuthErrorStrings__["a" /* AuthErrorStrings */].INVALID_USERNAME,
    },
    emptyPassword: {
        message: __WEBPACK_IMPORTED_MODULE_1__common_AuthErrorStrings__["a" /* AuthErrorStrings */].EMPTY_PASSWORD,
    },
    emptyCode: {
        message: __WEBPACK_IMPORTED_MODULE_1__common_AuthErrorStrings__["a" /* AuthErrorStrings */].EMPTY_CODE,
    },
    signUpError: {
        message: __WEBPACK_IMPORTED_MODULE_1__common_AuthErrorStrings__["a" /* AuthErrorStrings */].SIGN_UP_ERROR,
        log: 'The first parameter should either be non-null string or object',
    },
    noMFA: {
        message: __WEBPACK_IMPORTED_MODULE_1__common_AuthErrorStrings__["a" /* AuthErrorStrings */].NO_MFA,
    },
    invalidMFA: {
        message: __WEBPACK_IMPORTED_MODULE_1__common_AuthErrorStrings__["a" /* AuthErrorStrings */].INVALID_MFA,
    },
    emptyChallengeResponse: {
        message: __WEBPACK_IMPORTED_MODULE_1__common_AuthErrorStrings__["a" /* AuthErrorStrings */].EMPTY_CHALLENGE,
    },
    noUserSession: {
        message: __WEBPACK_IMPORTED_MODULE_1__common_AuthErrorStrings__["a" /* AuthErrorStrings */].NO_USER_SESSION,
    },
    deviceConfig: {
        message: __WEBPACK_IMPORTED_MODULE_1__common_AuthErrorStrings__["a" /* AuthErrorStrings */].DEVICE_CONFIG,
    },
    networkError: {
        message: __WEBPACK_IMPORTED_MODULE_1__common_AuthErrorStrings__["a" /* AuthErrorStrings */].NETWORK_ERROR,
    },
    default: {
        message: __WEBPACK_IMPORTED_MODULE_1__common_AuthErrorStrings__["a" /* AuthErrorStrings */].DEFAULT_MSG,
    },
};
//# sourceMappingURL=Errors.js.map

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__urlOpener__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__oauthStorage__ = __webpack_require__(1609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__types_Auth__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_amplify_core__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_crypto_js_sha256__ = __webpack_require__(642);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_crypto_js_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_crypto_js_sha256__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_crypto_js_enc_base64__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_crypto_js_enc_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_crypto_js_enc_base64__);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
 // Used for OAuth parsing of Cognito Hosted UI






var AMPLIFY_SYMBOL = (typeof Symbol !== 'undefined' &&
    typeof Symbol.for === 'function'
    ? Symbol.for('amplify_default')
    : '@@amplify_default');
var dispatchAuthEvent = function (event, data, message) {
    __WEBPACK_IMPORTED_MODULE_4__aws_amplify_core__["Hub"].dispatch('auth', { event: event, data: data, message: message }, 'Auth', AMPLIFY_SYMBOL);
};
var logger = new __WEBPACK_IMPORTED_MODULE_4__aws_amplify_core__["ConsoleLogger"]('OAuth');
var OAuth = /** @class */ (function () {
    function OAuth(_a) {
        var config = _a.config, cognitoClientId = _a.cognitoClientId, _b = _a.scopes, scopes = _b === void 0 ? [] : _b;
        this._urlOpener = config.urlOpener || __WEBPACK_IMPORTED_MODULE_1__urlOpener__["a" /* launchUri */];
        this._config = config;
        this._cognitoClientId = cognitoClientId;
        if (!this.isValidScopes(scopes))
            throw Error('scopes must be a String Array');
        this._scopes = scopes;
    }
    OAuth.prototype.isValidScopes = function (scopes) {
        return (Array.isArray(scopes) && scopes.every(function (scope) { return typeof scope === 'string'; }));
    };
    OAuth.prototype.oauthSignIn = function (responseType, domain, redirectSignIn, clientId, provider, customState) {
        if (responseType === void 0) { responseType = 'code'; }
        if (provider === void 0) { provider = __WEBPACK_IMPORTED_MODULE_3__types_Auth__["a" /* CognitoHostedUIIdentityProvider */].Cognito; }
        var generatedState = this._generateState(32);
        /* encodeURIComponent is not URL safe, use urlSafeEncode instead. Cognito
        single-encodes/decodes url on first sign in and double-encodes/decodes url
        when user already signed in. Using encodeURIComponent, Base32, Base64 add
        characters % or = which on further encoding becomes unsafe. '=' create issue
        for parsing query params.
        Refer: https://github.com/aws-amplify/amplify-js/issues/5218 */
        var state = customState
            ? generatedState + "-" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_amplify_core__["urlSafeEncode"])(customState)
            : generatedState;
        __WEBPACK_IMPORTED_MODULE_2__oauthStorage__["a" /* setState */](state);
        var pkce_key = this._generateRandom(128);
        __WEBPACK_IMPORTED_MODULE_2__oauthStorage__["b" /* setPKCE */](pkce_key);
        var code_challenge = this._generateChallenge(pkce_key);
        var code_challenge_method = 'S256';
        var scopesString = this._scopes.join(' ');
        var queryString = Object.entries(__assign(__assign({ redirect_uri: redirectSignIn, response_type: responseType, client_id: clientId, identity_provider: provider, scope: scopesString, state: state }, (responseType === 'code' ? { code_challenge: code_challenge } : {})), (responseType === 'code' ? { code_challenge_method: code_challenge_method } : {})))
            .map(function (_a) {
            var _b = __read(_a, 2), k = _b[0], v = _b[1];
            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
        })
            .join('&');
        var URL = "https://" + domain + "/oauth2/authorize?" + queryString;
        logger.debug("Redirecting to " + URL);
        this._urlOpener(URL, redirectSignIn);
    };
    OAuth.prototype._handleCodeFlow = function (currentUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var code, currentUrlPathname, redirectSignInPathname, oAuthTokenEndpoint, client_id, redirect_uri, code_verifier, oAuthTokenBody, body, _a, access_token, refresh_token, id_token, error;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        code = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_url__["parse"])(currentUrl).query || '')
                            .split('&')
                            .map(function (pairings) { return pairings.split('='); })
                            .reduce(function (accum, _a) {
                            var _b;
                            var _c = __read(_a, 2), k = _c[0], v = _c[1];
                            return (__assign(__assign({}, accum), (_b = {}, _b[k] = v, _b)));
                        }, { code: undefined }).code;
                        currentUrlPathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_url__["parse"])(currentUrl).pathname || '/';
                        redirectSignInPathname = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_url__["parse"])(this._config.redirectSignIn).pathname || '/';
                        if (!code || currentUrlPathname !== redirectSignInPathname) {
                            return [2 /*return*/];
                        }
                        oAuthTokenEndpoint = 'https://' + this._config.domain + '/oauth2/token';
                        dispatchAuthEvent('codeFlow', {}, "Retrieving tokens from " + oAuthTokenEndpoint);
                        client_id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__types_Auth__["c" /* isCognitoHostedOpts */])(this._config)
                            ? this._cognitoClientId
                            : this._config.clientID;
                        redirect_uri = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__types_Auth__["c" /* isCognitoHostedOpts */])(this._config)
                            ? this._config.redirectSignIn
                            : this._config.redirectUri;
                        code_verifier = __WEBPACK_IMPORTED_MODULE_2__oauthStorage__["c" /* getPKCE */]();
                        oAuthTokenBody = __assign({ grant_type: 'authorization_code', code: code,
                            client_id: client_id,
                            redirect_uri: redirect_uri }, (code_verifier ? { code_verifier: code_verifier } : {}));
                        logger.debug("Calling token endpoint: " + oAuthTokenEndpoint + " with", oAuthTokenBody);
                        body = Object.entries(oAuthTokenBody)
                            .map(function (_a) {
                            var _b = __read(_a, 2), k = _b[0], v = _b[1];
                            return encodeURIComponent(k) + "=" + encodeURIComponent(v);
                        })
                            .join('&');
                        return [4 /*yield*/, fetch(oAuthTokenEndpoint, {
                                method: 'POST',
                                headers: {
                                    'Content-Type': 'application/x-www-form-urlencoded',
                                },
                                body: body,
                            })];
                    case 1: return [4 /*yield*/, (_b.sent()).json()];
                    case 2:
                        _a = _b.sent(), access_token = _a.access_token, refresh_token = _a.refresh_token, id_token = _a.id_token, error = _a.error;
                        if (error) {
                            throw new Error(error);
                        }
                        return [2 /*return*/, {
                                accessToken: access_token,
                                refreshToken: refresh_token,
                                idToken: id_token,
                            }];
                }
            });
        });
    };
    OAuth.prototype._handleImplicitFlow = function (currentUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, id_token, access_token;
            return __generator(this, function (_b) {
                _a = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_url__["parse"])(currentUrl).hash || '#')
                    .substr(1) // Remove # from returned code
                    .split('&')
                    .map(function (pairings) { return pairings.split('='); })
                    .reduce(function (accum, _a) {
                    var _b;
                    var _c = __read(_a, 2), k = _c[0], v = _c[1];
                    return (__assign(__assign({}, accum), (_b = {}, _b[k] = v, _b)));
                }, {
                    id_token: undefined,
                    access_token: undefined,
                }), id_token = _a.id_token, access_token = _a.access_token;
                dispatchAuthEvent('implicitFlow', {}, "Got tokens from " + currentUrl);
                logger.debug("Retrieving implicit tokens from " + currentUrl + " with");
                return [2 /*return*/, {
                        accessToken: access_token,
                        idToken: id_token,
                        refreshToken: null,
                    }];
            });
        });
    };
    OAuth.prototype.handleAuthResponse = function (currentUrl) {
        return __awaiter(this, void 0, void 0, function () {
            var urlParams, error, error_description, state, _a, _b, e_1;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 5, , 6]);
                        urlParams = currentUrl
                            ? __assign(__assign({}, (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_url__["parse"])(currentUrl).hash || '#')
                                .substr(1)
                                .split('&')
                                .map(function (entry) { return entry.split('='); })
                                .reduce(function (acc, _a) {
                                var _b = __read(_a, 2), k = _b[0], v = _b[1];
                                return ((acc[k] = v), acc);
                            }, {})), (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_url__["parse"])(currentUrl).query || '')
                                .split('&')
                                .map(function (entry) { return entry.split('='); })
                                .reduce(function (acc, _a) {
                                var _b = __read(_a, 2), k = _b[0], v = _b[1];
                                return ((acc[k] = v), acc);
                            }, {}))
                            : {};
                        error = urlParams.error, error_description = urlParams.error_description;
                        if (error) {
                            throw new Error(error_description);
                        }
                        state = this._validateState(urlParams);
                        logger.debug("Starting " + this._config.responseType + " flow with " + currentUrl);
                        if (!(this._config.responseType === 'code')) return [3 /*break*/, 2];
                        _a = [{}];
                        return [4 /*yield*/, this._handleCodeFlow(currentUrl)];
                    case 1: return [2 /*return*/, __assign.apply(void 0, [__assign.apply(void 0, _a.concat([(_c.sent())])), { state: state }])];
                    case 2:
                        _b = [{}];
                        return [4 /*yield*/, this._handleImplicitFlow(currentUrl)];
                    case 3: return [2 /*return*/, __assign.apply(void 0, [__assign.apply(void 0, _b.concat([(_c.sent())])), { state: state }])];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_1 = _c.sent();
                        logger.error("Error handling auth response.", e_1);
                        throw e_1;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    OAuth.prototype._validateState = function (urlParams) {
        if (!urlParams) {
            return;
        }
        var savedState = __WEBPACK_IMPORTED_MODULE_2__oauthStorage__["d" /* getState */]();
        var returnedState = urlParams.state;
        // This is because savedState only exists if the flow was initiated by Amplify
        if (savedState && savedState !== returnedState) {
            throw new Error('Invalid state in OAuth flow');
        }
        return returnedState;
    };
    OAuth.prototype.signOut = function () {
        return __awaiter(this, void 0, void 0, function () {
            var oAuthLogoutEndpoint, client_id, signout_uri;
            return __generator(this, function (_a) {
                oAuthLogoutEndpoint = 'https://' + this._config.domain + '/logout?';
                client_id = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__types_Auth__["c" /* isCognitoHostedOpts */])(this._config)
                    ? this._cognitoClientId
                    : this._config.oauth.clientID;
                signout_uri = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__types_Auth__["c" /* isCognitoHostedOpts */])(this._config)
                    ? this._config.redirectSignOut
                    : this._config.returnTo;
                oAuthLogoutEndpoint += Object.entries({
                    client_id: client_id,
                    logout_uri: encodeURIComponent(signout_uri),
                })
                    .map(function (_a) {
                    var _b = __read(_a, 2), k = _b[0], v = _b[1];
                    return k + "=" + v;
                })
                    .join('&');
                dispatchAuthEvent('oAuthSignOut', { oAuth: 'signOut' }, "Signing out from " + oAuthLogoutEndpoint);
                logger.debug("Signing out from " + oAuthLogoutEndpoint);
                return [2 /*return*/, this._urlOpener(oAuthLogoutEndpoint)];
            });
        });
    };
    OAuth.prototype._generateState = function (length) {
        var result = '';
        var i = length;
        var chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        for (; i > 0; --i)
            result += chars[Math.round(Math.random() * (chars.length - 1))];
        return result;
    };
    OAuth.prototype._generateChallenge = function (code) {
        return this._base64URL(__WEBPACK_IMPORTED_MODULE_5_crypto_js_sha256___default()(code));
    };
    OAuth.prototype._base64URL = function (string) {
        return string
            .toString(__WEBPACK_IMPORTED_MODULE_6_crypto_js_enc_base64___default.a)
            .replace(/=/g, '')
            .replace(/\+/g, '-')
            .replace(/\//g, '_');
    };
    OAuth.prototype._generateRandom = function (size) {
        var CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~';
        var buffer = new Uint8Array(size);
        if (typeof window !== 'undefined' && !!window.crypto) {
            window.crypto.getRandomValues(buffer);
        }
        else {
            for (var i = 0; i < size; i += 1) {
                buffer[i] = (Math.random() * CHARSET.length) | 0;
            }
        }
        return this._bufferToString(buffer);
    };
    OAuth.prototype._bufferToString = function (buffer) {
        var CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        var state = [];
        for (var i = 0; i < buffer.byteLength; i += 1) {
            var index = buffer[i] % CHARSET.length;
            state.push(CHARSET[index]);
        }
        return state.join('');
    };
    return OAuth;
}());
/* harmony default export */ __webpack_exports__["a"] = (OAuth);
//# sourceMappingURL=OAuth.js.map

/***/ }),
/* 1609 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return setPKCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPKCE; });
/* unused harmony export clearAll */
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var setState = function (state) {
    window.sessionStorage.setItem('oauth_state', state);
};
var getState = function () {
    var oauth_state = window.sessionStorage.getItem('oauth_state');
    window.sessionStorage.removeItem('oauth_state');
    return oauth_state;
};
var setPKCE = function (private_key) {
    window.sessionStorage.setItem('ouath_pkce_key', private_key);
};
var getPKCE = function () {
    var ouath_pkce_key = window.sessionStorage.getItem('ouath_pkce_key');
    window.sessionStorage.removeItem('ouath_pkce_key');
    return ouath_pkce_key;
};
var clearAll = function () {
    window.sessionStorage.removeItem('ouath_pkce_key');
    window.sessionStorage.removeItem('oauth_state');
};
//# sourceMappingURL=oauthStorage.js.map

/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return launchUri; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var SELF = '_self';
var launchUri = function (url) {
    var windowProxy = window.open(url, SELF);
    if (windowProxy) {
        return Promise.resolve(windowProxy);
    }
    else {
        return Promise.reject();
    }
};
//# sourceMappingURL=urlOpener.js.map

/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Auth__ = __webpack_require__(364);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Auth__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Auth__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Auth__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__Auth__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__Auth__["g"]; });
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__ = __webpack_require__(71);
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = (function (callback) {
    if (__WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["JS"].browserOrNode().isBrowser && window.location) {
        var url = window.location.href;
        callback({ url: url });
    }
    else if (__WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["JS"].browserOrNode().isNode) {
        // continue building on ssr
        (function () { }); // noop
    }
    else {
        throw new Error('Not supported');
    }
});
//# sourceMappingURL=urlListener.js.map

/***/ }),
/* 1613 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BrowserStorageCacheClass */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BrowserStorageCache; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StorageCache__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_amplify_core__ = __webpack_require__(71);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



var logger = new __WEBPACK_IMPORTED_MODULE_2__aws_amplify_core__["ConsoleLogger"]('Cache');
/**
 * Customized storage based on the SessionStorage or LocalStorage with LRU implemented
 */
var BrowserStorageCacheClass = /** @class */ (function (_super) {
    __extends(BrowserStorageCacheClass, _super);
    /**
     * initialize the cache
     * @param config - the configuration of the cache
     */
    function BrowserStorageCacheClass(config) {
        var _this = this;
        var cacheConfig = config
            ? Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__Utils__["a" /* defaultConfig */], config)
            : __WEBPACK_IMPORTED_MODULE_0__Utils__["a" /* defaultConfig */];
        _this = _super.call(this, cacheConfig) || this;
        _this.config.storage = cacheConfig.storage;
        _this.getItem = _this.getItem.bind(_this);
        _this.setItem = _this.setItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        return _this;
    }
    /**
     * decrease current size of the cache
     *
     * @private
     * @param amount - the amount of the cache size which needs to be decreased
     */
    BrowserStorageCacheClass.prototype._decreaseCurSizeInBytes = function (amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize - amount).toString());
    };
    /**
     * increase current size of the cache
     *
     * @private
     * @param amount - the amount of the cache szie which need to be increased
     */
    BrowserStorageCacheClass.prototype._increaseCurSizeInBytes = function (amount) {
        var curSize = this.getCacheCurSize();
        this.config.storage.setItem(this.cacheCurSizeKey, (curSize + amount).toString());
    };
    /**
     * update the visited time if item has been visited
     *
     * @private
     * @param item - the item which need to be refreshed
     * @param prefixedKey - the key of the item
     *
     * @return the refreshed item
     */
    BrowserStorageCacheClass.prototype._refreshItem = function (item, prefixedKey) {
        item.visitedTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Utils__["b" /* getCurrTime */])();
        this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        return item;
    };
    /**
     * check wether item is expired
     *
     * @private
     * @param key - the key of the item
     *
     * @return true if the item is expired.
     */
    BrowserStorageCacheClass.prototype._isExpired = function (key) {
        var text = this.config.storage.getItem(key);
        var item = JSON.parse(text);
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Utils__["b" /* getCurrTime */])() >= item.expires) {
            return true;
        }
        return false;
    };
    /**
     * delete item from cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param size - optional, the byte size of the item
     */
    BrowserStorageCacheClass.prototype._removeItem = function (prefixedKey, size) {
        var itemSize = size
            ? size
            : JSON.parse(this.config.storage.getItem(prefixedKey)).byteSize;
        this._decreaseCurSizeInBytes(itemSize);
        // remove the cache item
        this.config.storage.removeItem(prefixedKey);
    };
    /**
     * put item into cache
     *
     * @private
     * @param prefixedKey - the key of the item
     * @param itemData - the value of the item
     * @param itemSizeInBytes - the byte size of the item
     */
    BrowserStorageCacheClass.prototype._setItem = function (prefixedKey, item) {
        // update the cache size
        this._increaseCurSizeInBytes(item.byteSize);
        try {
            this.config.storage.setItem(prefixedKey, JSON.stringify(item));
        }
        catch (setItemErr) {
            // if failed, we need to rollback the cache size
            this._decreaseCurSizeInBytes(item.byteSize);
            logger.error("Failed to set item " + setItemErr);
        }
    };
    /**
     * total space needed when poping out items
     *
     * @private
     * @param itemSize
     *
     * @return total space needed
     */
    BrowserStorageCacheClass.prototype._sizeToPop = function (itemSize) {
        var spaceItemNeed = this.getCacheCurSize() + itemSize - this.config.capacityInBytes;
        var cacheThresholdSpace = (1 - this.config.warningThreshold) * this.config.capacityInBytes;
        return spaceItemNeed > cacheThresholdSpace
            ? spaceItemNeed
            : cacheThresholdSpace;
    };
    /**
     * see whether cache is full
     *
     * @private
     * @param itemSize
     *
     * @return true if cache is full
     */
    BrowserStorageCacheClass.prototype._isCacheFull = function (itemSize) {
        return itemSize + this.getCacheCurSize() > this.config.capacityInBytes;
    };
    /**
     * scan the storage and find out all the keys owned by this cache
     * also clean the expired keys while scanning
     *
     * @private
     *
     * @return array of keys
     */
    BrowserStorageCacheClass.prototype._findValidKeys = function () {
        var keys = [];
        var keyInCache = [];
        // get all keys in Storage
        for (var i = 0; i < this.config.storage.length; i += 1) {
            keyInCache.push(this.config.storage.key(i));
        }
        // find those items which belong to our cache and also clean those expired items
        for (var i = 0; i < keyInCache.length; i += 1) {
            var key = keyInCache[i];
            if (key.indexOf(this.config.keyPrefix) === 0 &&
                key !== this.cacheCurSizeKey) {
                if (this._isExpired(key)) {
                    this._removeItem(key);
                }
                else {
                    keys.push(key);
                }
            }
        }
        return keys;
    };
    /**
     * get all the items we have, sort them by their priority,
     * if priority is same, sort them by their last visited time
     * pop out items from the low priority (5 is the lowest)
     *
     * @private
     * @param keys - all the keys in this cache
     * @param sizeToPop - the total size of the items which needed to be poped out
     */
    BrowserStorageCacheClass.prototype._popOutItems = function (keys, sizeToPop) {
        var items = [];
        var remainedSize = sizeToPop;
        // get the items from Storage
        for (var i = 0; i < keys.length; i += 1) {
            var val = this.config.storage.getItem(keys[i]);
            if (val != null) {
                var item = JSON.parse(val);
                items.push(item);
            }
        }
        // first compare priority
        // then compare visited time
        items.sort(function (a, b) {
            if (a.priority > b.priority) {
                return -1;
            }
            else if (a.priority < b.priority) {
                return 1;
            }
            else {
                if (a.visitedTime < b.visitedTime) {
                    return -1;
                }
                else
                    return 1;
            }
        });
        for (var i = 0; i < items.length; i += 1) {
            // pop out items until we have enough room for new item
            this._removeItem(items[i].key, items[i].byteSize);
            remainedSize -= items[i].byteSize;
            if (remainedSize <= 0) {
                return;
            }
        }
    };
    /**
     * Set item into cache. You can put number, string, boolean or object.
     * The cache will first check whether has the same key.
     * If it has, it will delete the old item and then put the new item in
     * The cache will pop out items if it is full
     * You can specify the cache item options. The cache will abort and output a warning:
     * If the key is invalid
     * If the size of the item exceeds itemMaxSize.
     * If the value is undefined
     * If incorrect cache item configuration
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param value - the value of the item
     * @param {Object} [options] - optional, the specified meta-data
     */
    BrowserStorageCacheClass.prototype.setItem = function (key, value, options) {
        logger.log("Set item: key is " + key + ", value is " + value + " with options: " + options);
        var prefixedKey = this.config.keyPrefix + key;
        // invalid keys
        if (prefixedKey === this.config.keyPrefix ||
            prefixedKey === this.cacheCurSizeKey) {
            logger.warn("Invalid key: should not be empty or 'CurSize'");
            return;
        }
        if (typeof value === 'undefined') {
            logger.warn("The value of item should not be undefined!");
            return;
        }
        var cacheItemOptions = {
            priority: options && options.priority !== undefined
                ? options.priority
                : this.config.defaultPriority,
            expires: options && options.expires !== undefined
                ? options.expires
                : this.config.defaultTTL + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Utils__["b" /* getCurrTime */])(),
        };
        if (cacheItemOptions.priority < 1 || cacheItemOptions.priority > 5) {
            logger.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");
            return;
        }
        var item = this.fillCacheItem(prefixedKey, value, cacheItemOptions);
        // check wether this item is too big;
        if (item.byteSize > this.config.itemMaxSize) {
            logger.warn("Item with key: " + key + " you are trying to put into is too big!");
            return;
        }
        try {
            // first look into the storage, if it exists, delete it.
            var val = this.config.storage.getItem(prefixedKey);
            if (val) {
                this._removeItem(prefixedKey, JSON.parse(val).byteSize);
            }
            // check whether the cache is full
            if (this._isCacheFull(item.byteSize)) {
                var validKeys = this._findValidKeys();
                // check again and then pop out items
                if (this._isCacheFull(item.byteSize)) {
                    var sizeToPop = this._sizeToPop(item.byteSize);
                    this._popOutItems(validKeys, sizeToPop);
                }
            }
            // put item in the cache
            // may failed due to storage full
            this._setItem(prefixedKey, item);
        }
        catch (e) {
            logger.warn("setItem failed! " + e);
        }
    };
    /**
     * Get item from cache. It will return null if item doesn’t exist or it has been expired.
     * If you specified callback function in the options,
     * then the function will be executed if no such item in the cache
     * and finally put the return value into cache.
     * Please make sure the callback function will return the value you want to put into the cache.
     * The cache will abort output a warning:
     * If the key is invalid
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param {Object} [options] - the options of callback function
     *
     * @return - return the value of the item
     */
    BrowserStorageCacheClass.prototype.getItem = function (key, options) {
        logger.log("Get item: key is " + key + " with options " + options);
        var ret = null;
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix ||
            prefixedKey === this.cacheCurSizeKey) {
            logger.warn("Invalid key: should not be empty or 'CurSize'");
            return null;
        }
        try {
            ret = this.config.storage.getItem(prefixedKey);
            if (ret != null) {
                if (this._isExpired(prefixedKey)) {
                    // if expired, remove that item and return null
                    this._removeItem(prefixedKey, JSON.parse(ret).byteSize);
                    ret = null;
                }
                else {
                    // if not expired, great, return the value and refresh it
                    var item = JSON.parse(ret);
                    item = this._refreshItem(item, prefixedKey);
                    return item.data;
                }
            }
            if (options && options.callback !== undefined) {
                var val = options.callback();
                if (val !== null) {
                    this.setItem(key, val, options);
                }
                return val;
            }
            return null;
        }
        catch (e) {
            logger.warn("getItem failed! " + e);
            return null;
        }
    };
    /**
     * remove item from the cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     * @param key - the key of the item
     */
    BrowserStorageCacheClass.prototype.removeItem = function (key) {
        logger.log("Remove item: key is " + key);
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix ||
            prefixedKey === this.cacheCurSizeKey) {
            return;
        }
        try {
            var val = this.config.storage.getItem(prefixedKey);
            if (val) {
                this._removeItem(prefixedKey, JSON.parse(val).byteSize);
            }
        }
        catch (e) {
            logger.warn("removeItem failed! " + e);
        }
    };
    /**
     * clear the entire cache
     * The cache will abort output a warning:
     * If error happened with browser storage
     */
    BrowserStorageCacheClass.prototype.clear = function () {
        logger.log("Clear Cache");
        var keysToRemove = [];
        for (var i = 0; i < this.config.storage.length; i += 1) {
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0) {
                keysToRemove.push(key);
            }
        }
        try {
            for (var i = 0; i < keysToRemove.length; i += 1) {
                this.config.storage.removeItem(keysToRemove[i]);
            }
        }
        catch (e) {
            logger.warn("clear failed! " + e);
        }
    };
    /**
     * Return all the keys in the cache.
     *
     * @return - all keys in the cache
     */
    BrowserStorageCacheClass.prototype.getAllKeys = function () {
        var keys = [];
        for (var i = 0; i < this.config.storage.length; i += 1) {
            var key = this.config.storage.key(i);
            if (key.indexOf(this.config.keyPrefix) === 0 &&
                key !== this.cacheCurSizeKey) {
                keys.push(key.substring(this.config.keyPrefix.length));
            }
        }
        return keys;
    };
    /**
     * return the current size of the cache
     *
     * @return - current size of the cache
     */
    BrowserStorageCacheClass.prototype.getCacheCurSize = function () {
        var ret = this.config.storage.getItem(this.cacheCurSizeKey);
        if (!ret) {
            this.config.storage.setItem(this.cacheCurSizeKey, '0');
            ret = '0';
        }
        return Number(ret);
    };
    /**
     * Return a new instance of cache with customized configuration.
     * @param config - the customized configuration
     *
     * @return - new instance of Cache
     */
    BrowserStorageCacheClass.prototype.createInstance = function (config) {
        if (!config.keyPrefix || config.keyPrefix === __WEBPACK_IMPORTED_MODULE_0__Utils__["a" /* defaultConfig */].keyPrefix) {
            logger.error('invalid keyPrefix, setting keyPrefix with timeStamp');
            config.keyPrefix = __WEBPACK_IMPORTED_MODULE_0__Utils__["b" /* getCurrTime */].toString();
        }
        return new BrowserStorageCacheClass(config);
    };
    return BrowserStorageCacheClass;
}(__WEBPACK_IMPORTED_MODULE_1__StorageCache__["a" /* StorageCache */]));

var BrowserStorageCache = new BrowserStorageCacheClass();
/**
 * @deprecated use named import
 */
/* unused harmony default export */ var _unused_webpack_default_export = (BrowserStorageCache);
//# sourceMappingURL=BrowserStorageCache.js.map

/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export InMemoryCacheClass */
/* unused harmony export InMemoryCache */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utils__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StorageCache__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_amplify_core__ = __webpack_require__(71);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};



var logger = new __WEBPACK_IMPORTED_MODULE_2__aws_amplify_core__["ConsoleLogger"]('InMemoryCache');
/**
 * Customized in-memory cache with LRU implemented
 * @member cacheObj - object which store items
 * @member cacheList - list of keys in the cache with LRU
 * @member curSizeInBytes - current size of the cache
 * @member maxPriority - max of the priority
 * @member cacheSizeLimit - the limit of cache size
 */
var InMemoryCacheClass = /** @class */ (function (_super) {
    __extends(InMemoryCacheClass, _super);
    /**
     * initialize the cache
     *
     * @param config - the configuration of the cache
     */
    function InMemoryCacheClass(config) {
        var _this = this;
        var cacheConfig = config
            ? Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__Utils__["a" /* defaultConfig */], config)
            : __WEBPACK_IMPORTED_MODULE_0__Utils__["a" /* defaultConfig */];
        _this = _super.call(this, cacheConfig) || this;
        logger.debug('now we start!');
        _this.cacheList = [];
        _this.curSizeInBytes = 0;
        _this.maxPriority = 5;
        _this.getItem = _this.getItem.bind(_this);
        _this.setItem = _this.setItem.bind(_this);
        _this.removeItem = _this.removeItem.bind(_this);
        // initialize list for every priority
        for (var i = 0; i < _this.maxPriority; i += 1) {
            _this.cacheList[i] = new __WEBPACK_IMPORTED_MODULE_0__Utils__["e" /* CacheList */]();
        }
        return _this;
    }
    /**
     * decrease current size of the cache
     *
     * @param amount - the amount of the cache size which needs to be decreased
     */
    InMemoryCacheClass.prototype._decreaseCurSizeInBytes = function (amount) {
        this.curSizeInBytes -= amount;
    };
    /**
     * increase current size of the cache
     *
     * @param amount - the amount of the cache szie which need to be increased
     */
    InMemoryCacheClass.prototype._increaseCurSizeInBytes = function (amount) {
        this.curSizeInBytes += amount;
    };
    /**
     * check whether item is expired
     *
     * @param key - the key of the item
     *
     * @return true if the item is expired.
     */
    InMemoryCacheClass.prototype._isExpired = function (key) {
        var text = __WEBPACK_IMPORTED_MODULE_0__Utils__["f" /* CacheObject */].getItem(key);
        var item = JSON.parse(text);
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Utils__["b" /* getCurrTime */])() >= item.expires) {
            return true;
        }
        return false;
    };
    /**
     * delete item from cache
     *
     * @param prefixedKey - the key of the item
     * @param listIdx - indicates which cache list the key belongs to
     */
    InMemoryCacheClass.prototype._removeItem = function (prefixedKey, listIdx) {
        // delete the key from the list
        this.cacheList[listIdx].removeItem(prefixedKey);
        // decrease the current size of the cache
        this._decreaseCurSizeInBytes(JSON.parse(__WEBPACK_IMPORTED_MODULE_0__Utils__["f" /* CacheObject */].getItem(prefixedKey)).byteSize);
        // finally remove the item from memory
        __WEBPACK_IMPORTED_MODULE_0__Utils__["f" /* CacheObject */].removeItem(prefixedKey);
    };
    /**
     * put item into cache
     *
     * @param prefixedKey - the key of the item
     * @param itemData - the value of the item
     * @param itemSizeInBytes - the byte size of the item
     * @param listIdx - indicates which cache list the key belongs to
     */
    InMemoryCacheClass.prototype._setItem = function (prefixedKey, item, listIdx) {
        // insert the key into the list
        this.cacheList[listIdx].insertItem(prefixedKey);
        // increase the current size of the cache
        this._increaseCurSizeInBytes(item.byteSize);
        // finally add the item into memory
        __WEBPACK_IMPORTED_MODULE_0__Utils__["f" /* CacheObject */].setItem(prefixedKey, JSON.stringify(item));
    };
    /**
     * see whether cache is full
     *
     * @param itemSize
     *
     * @return true if cache is full
     */
    InMemoryCacheClass.prototype._isCacheFull = function (itemSize) {
        return this.curSizeInBytes + itemSize > this.config.capacityInBytes;
    };
    /**
     * check whether the cache contains the key
     *
     * @param key
     */
    InMemoryCacheClass.prototype.containsKey = function (key) {
        var prefixedKey = this.config.keyPrefix + key;
        for (var i = 0; i < this.maxPriority; i += 1) {
            if (this.cacheList[i].containsKey(prefixedKey)) {
                return i + 1;
            }
        }
        return -1;
    };
    /**
     * * Set item into cache. You can put number, string, boolean or object.
     * The cache will first check whether has the same key.
     * If it has, it will delete the old item and then put the new item in
     * The cache will pop out items if it is full
     * You can specify the cache item options. The cache will abort and output a warning:
     * If the key is invalid
     * If the size of the item exceeds itemMaxSize.
     * If the value is undefined
     * If incorrect cache item configuration
     * If error happened with browser storage
     *
     * @param key - the key of the item
     * @param value - the value of the item
     * @param options - optional, the specified meta-data
     *
     * @throws if the item is too big which exceeds the limit of single item size
     * @throws if the key is invalid
     */
    InMemoryCacheClass.prototype.setItem = function (key, value, options) {
        var prefixedKey = this.config.keyPrefix + key;
        // invalid keys
        if (prefixedKey === this.config.keyPrefix ||
            prefixedKey === this.cacheCurSizeKey) {
            logger.warn("Invalid key: should not be empty or 'CurSize'");
            return;
        }
        if (typeof value === 'undefined') {
            logger.warn("The value of item should not be undefined!");
            return;
        }
        var cacheItemOptions = {
            priority: options && options.priority !== undefined
                ? options.priority
                : this.config.defaultPriority,
            expires: options && options.expires !== undefined
                ? options.expires
                : this.config.defaultTTL + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__Utils__["b" /* getCurrTime */])(),
        };
        if (cacheItemOptions.priority < 1 || cacheItemOptions.priority > 5) {
            logger.warn("Invalid parameter: priority due to out or range. It should be within 1 and 5.");
            return;
        }
        var item = this.fillCacheItem(prefixedKey, value, cacheItemOptions);
        // check wether this item is too big;
        if (item.byteSize > this.config.itemMaxSize) {
            logger.warn("Item with key: " + key + " you are trying to put into is too big!");
            return;
        }
        // if key already in the cache, then delete it.
        var presentKeyPrio = this.containsKey(key);
        if (presentKeyPrio !== -1) {
            this._removeItem(prefixedKey, presentKeyPrio - 1);
        }
        // pop out items in the cache when cache is full based on LRU
        // first start from lowest priority cache list
        var cacheListIdx = this.maxPriority - 1;
        while (this._isCacheFull(item.byteSize) && cacheListIdx >= 0) {
            if (!this.cacheList[cacheListIdx].isEmpty()) {
                var popedItemKey = this.cacheList[cacheListIdx].getLastItem();
                this._removeItem(popedItemKey, cacheListIdx);
            }
            else {
                cacheListIdx -= 1;
            }
        }
        this._setItem(prefixedKey, item, Number(item.priority) - 1);
    };
    /**
     * Get item from cache. It will return null if item doesn’t exist or it has been expired.
     * If you specified callback function in the options,
     * then the function will be executed if no such item in the cache
     * and finally put the return value into cache.
     * Please make sure the callback function will return the value you want to put into the cache.
     * The cache will abort output a warning:
     * If the key is invalid
     *
     * @param key - the key of the item
     * @param options - the options of callback function
     */
    InMemoryCacheClass.prototype.getItem = function (key, options) {
        var ret = null;
        var prefixedKey = this.config.keyPrefix + key;
        if (prefixedKey === this.config.keyPrefix ||
            prefixedKey === this.cacheCurSizeKey) {
            logger.warn("Invalid key: should not be empty or 'CurSize'");
            return null;
        }
        // check whether it's in the cachelist
        var presentKeyPrio = this.containsKey(key);
        if (presentKeyPrio !== -1) {
            if (this._isExpired(prefixedKey)) {
                // if expired, remove that item and return null
                this._removeItem(prefixedKey, presentKeyPrio - 1);
            }
            else {
                // if not expired, great, return the value and refresh it
                ret = __WEBPACK_IMPORTED_MODULE_0__Utils__["f" /* CacheObject */].getItem(prefixedKey);
                var item = JSON.parse(ret);
                this.cacheList[item.priority - 1].refresh(prefixedKey);
                return item.data;
            }
        }
        if (options && options.callback !== undefined) {
            var val = options.callback();
            if (val !== null) {
                this.setItem(key, val, options);
            }
            return val;
        }
        return null;
    };
    /**
     * remove item from the cache
     *
     * @param key - the key of the item
     */
    InMemoryCacheClass.prototype.removeItem = function (key) {
        var prefixedKey = this.config.keyPrefix + key;
        // check if the key is in the cache
        var presentKeyPrio = this.containsKey(key);
        if (presentKeyPrio !== -1) {
            this._removeItem(prefixedKey, presentKeyPrio - 1);
        }
    };
    /**
     * clear the entire cache
     */
    InMemoryCacheClass.prototype.clear = function () {
        var e_1, _a;
        for (var i = 0; i < this.maxPriority; i += 1) {
            try {
                for (var _b = (e_1 = void 0, __values(this.cacheList[i].getKeys())), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    this._removeItem(key, i);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
    };
    /**
     * Return all the keys in the cache.
     */
    InMemoryCacheClass.prototype.getAllKeys = function () {
        var e_2, _a;
        var keys = [];
        for (var i = 0; i < this.maxPriority; i += 1) {
            try {
                for (var _b = (e_2 = void 0, __values(this.cacheList[i].getKeys())), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var key = _c.value;
                    keys.push(key.substring(this.config.keyPrefix.length));
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
        return keys;
    };
    /**
     * return the current size of the cache
     *
     * @return the current size of the cache
     */
    InMemoryCacheClass.prototype.getCacheCurSize = function () {
        return this.curSizeInBytes;
    };
    /**
     * Return a new instance of cache with customized configuration.
     * @param config - the customized configuration
     */
    InMemoryCacheClass.prototype.createInstance = function (config) {
        return new InMemoryCacheClass(config);
    };
    return InMemoryCacheClass;
}(__WEBPACK_IMPORTED_MODULE_1__StorageCache__["a" /* StorageCache */]));

var InMemoryCache = new InMemoryCacheClass();
/**
 * @deprecated use named import
 */
/* unused harmony default export */ var _unused_webpack_default_export = (InMemoryCache);
//# sourceMappingURL=InMemoryCache.js.map

/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var DoubleLinkedNode = /** @class */ (function () {
    function DoubleLinkedNode(keyVal) {
        this.key = keyVal ? keyVal : '';
        this.prevNode = null;
        this.nextNode = null;
    }
    return DoubleLinkedNode;
}());
/**
 * double linked list plus a hash table inside
 * each key in the cache stored as a node in the list
 * recently visited node will be rotated to the head
 * so the Last Recently Visited node will be at the tail
 *
 * @member head - dummy head of the linked list
 * @member tail - dummy tail of the linked list
 * @member hashtable - the hashtable which maps cache key to list node
 * @member length - length of the list
 */
var CacheList = /** @class */ (function () {
    /**
     * initialization
     */
    function CacheList() {
        this.head = new DoubleLinkedNode();
        this.tail = new DoubleLinkedNode();
        this.hashtable = {};
        this.length = 0;
        this.head.nextNode = this.tail;
        this.tail.prevNode = this.head;
    }
    /**
     * insert node to the head of the list
     *
     * @param node
     */
    CacheList.prototype.insertNodeToHead = function (node) {
        var tmp = this.head.nextNode;
        this.head.nextNode = node;
        node.nextNode = tmp;
        node.prevNode = this.head;
        tmp.prevNode = node;
        this.length = this.length + 1;
    };
    /**
     * remove node
     *
     * @param node
     */
    CacheList.prototype.removeNode = function (node) {
        node.prevNode.nextNode = node.nextNode;
        node.nextNode.prevNode = node.prevNode;
        node.prevNode = null;
        node.nextNode = null;
        this.length = this.length - 1;
    };
    /**
     * @return true if list is empty
     */
    CacheList.prototype.isEmpty = function () {
        return this.length === 0;
    };
    /**
     * refresh node so it is rotated to the head
     *
     * @param key - key of the node
     */
    CacheList.prototype.refresh = function (key) {
        var node = this.hashtable[key];
        this.removeNode(node);
        this.insertNodeToHead(node);
    };
    /**
     * insert new node to the head and add it in the hashtable
     *
     * @param key - the key of the node
     */
    CacheList.prototype.insertItem = function (key) {
        var node = new DoubleLinkedNode(key);
        this.hashtable[key] = node;
        this.insertNodeToHead(node);
    };
    /**
     * @return the LAST Recently Visited key
     */
    CacheList.prototype.getLastItem = function () {
        return this.tail.prevNode.key;
    };
    /**
     * remove the cache key from the list and hashtable
     * @param key - the key of the node
     */
    CacheList.prototype.removeItem = function (key) {
        var removedItem = this.hashtable[key];
        this.removeNode(removedItem);
        delete this.hashtable[key];
    };
    /**
     * @return length of the list
     */
    CacheList.prototype.getSize = function () {
        return this.length;
    };
    /**
     * @return true if the key is in the hashtable
     * @param key
     */
    CacheList.prototype.containsKey = function (key) {
        return key in this.hashtable;
    };
    /**
     * clean up the list and hashtable
     */
    CacheList.prototype.clearList = function () {
        var e_1, _a;
        try {
            for (var _b = __values(Object.keys(this.hashtable)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (this.hashtable.hasOwnProperty(key)) {
                    delete this.hashtable[key];
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.head.nextNode = this.tail;
        this.tail.prevNode = this.head;
        this.length = 0;
    };
    /**
     * @return all keys in the hashtable
     */
    CacheList.prototype.getKeys = function () {
        return Object.keys(this.hashtable);
    };
    /**
     * mainly for test
     *
     * @param key
     * @return true if key is the head node
     */
    CacheList.prototype.isHeadNode = function (key) {
        var node = this.hashtable[key];
        return node.prevNode === this.head;
    };
    /**
     * mainly for test
     *
     * @param key
     * @return true if key is the tail node
     */
    CacheList.prototype.isTailNode = function (key) {
        var node = this.hashtable[key];
        return node.nextNode === this.tail;
    };
    return CacheList;
}());
/* harmony default export */ __webpack_exports__["a"] = (CacheList);
//# sourceMappingURL=CacheList.js.map

/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultConfig; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getByteLength;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCurrTime;
/* harmony export (immutable) */ __webpack_exports__["c"] = isInteger;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return CacheObject; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__ = __webpack_require__(71);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

/**
 * Default cache config
 */
var defaultConfig = {
    keyPrefix: 'aws-amplify-cache',
    capacityInBytes: 1048576,
    itemMaxSize: 210000,
    defaultTTL: 259200000,
    defaultPriority: 5,
    warningThreshold: 0.8,
    // the storage helper will check if localStorage exists,
    // if not, will use a in-memory object instead
    storage: new __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["StorageHelper"]().getStorage(),
};
/**
 * return the byte size of the string
 * @param str
 */
function getByteLength(str) {
    var ret = 0;
    ret = str.length;
    for (var i = str.length; i >= 0; i -= 1) {
        var charCode = str.charCodeAt(i);
        if (charCode > 0x7f && charCode <= 0x7ff) {
            ret += 1;
        }
        else if (charCode > 0x7ff && charCode <= 0xffff) {
            ret += 2;
        }
        // trail surrogate
        if (charCode >= 0xdc00 && charCode <= 0xdfff) {
            i -= 1;
        }
    }
    return ret;
}
/**
 * get current time
 */
function getCurrTime() {
    var currTime = new Date();
    return currTime.getTime();
}
/**
 * check if passed value is an integer
 */
function isInteger(value) {
    if (Number.isInteger) {
        return Number.isInteger(value);
    }
    return _isInteger(value);
}
function _isInteger(value) {
    return (typeof value === 'number' && isFinite(value) && Math.floor(value) === value);
}
/**
 * provide an object as the in-memory cache
 */
var store = {};
var CacheObject = /** @class */ (function () {
    function CacheObject() {
    }
    CacheObject.clear = function () {
        store = {};
    };
    CacheObject.getItem = function (key) {
        return store[key] || null;
    };
    CacheObject.setItem = function (key, value) {
        store[key] = value;
    };
    CacheObject.removeItem = function (key) {
        delete store[key];
    };
    return CacheObject;
}());

//# sourceMappingURL=CacheUtils.js.map

/***/ }),
/* 1617 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = clientInfo;
/* harmony export (immutable) */ __webpack_exports__["b"] = dimension;
/* unused harmony export browserType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(111);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('ClientDevice_Browser');
function clientInfo() {
    if (typeof window === 'undefined') {
        return {};
    }
    return browserClientInfo();
}
function browserClientInfo() {
    if (typeof window === 'undefined') {
        logger.warn('No window object available to get browser client info');
        return {};
    }
    var nav = window.navigator;
    if (!nav) {
        logger.warn('No navigator object available to get browser client info');
        return {};
    }
    var platform = nav.platform, product = nav.product, vendor = nav.vendor, userAgent = nav.userAgent, language = nav.language;
    var type = browserType(userAgent);
    var timezone = browserTimezone();
    return {
        platform: platform,
        make: product || vendor,
        model: type.type,
        version: type.version,
        appVersion: [type.type, type.version].join('/'),
        language: language,
        timezone: timezone,
    };
}
function dimension() {
    if (typeof window === 'undefined') {
        logger.warn('No window object available to get browser client info');
        return { width: 320, height: 320 };
    }
    return {
        width: window.innerWidth,
        height: window.innerHeight,
    };
}
function browserTimezone() {
    var tzMatch = /\(([A-Za-z\s].*)\)/.exec(new Date().toString());
    return tzMatch ? tzMatch[1] || '' : '';
}
function browserType(userAgent) {
    var operaMatch = /.+(Opera[\s[A-Z]*|OPR[\sA-Z]*)\/([0-9\.]+).*/i.exec(userAgent);
    if (operaMatch) {
        return { type: operaMatch[1], version: operaMatch[2] };
    }
    var ieMatch = /.+(Trident|Edge)\/([0-9\.]+).*/i.exec(userAgent);
    if (ieMatch) {
        return { type: ieMatch[1], version: ieMatch[2] };
    }
    var cfMatch = /.+(Chrome|Firefox|FxiOS)\/([0-9\.]+).*/i.exec(userAgent);
    if (cfMatch) {
        return { type: cfMatch[1], version: cfMatch[2] };
    }
    var sMatch = /.+(Safari)\/([0-9\.]+).*/i.exec(userAgent);
    if (sMatch) {
        return { type: sMatch[1], version: sMatch[2] };
    }
    var awkMatch = /.+(AppleWebKit)\/([0-9\.]+).*/i.exec(userAgent);
    if (awkMatch) {
        return { type: awkMatch[1], version: awkMatch[2] };
    }
    var anyMatch = /.*([A-Z]+)\/([0-9\.]+).*/i.exec(userAgent);
    if (anyMatch) {
        return { type: anyMatch[1], version: anyMatch[2] };
    }
    return { type: '', version: '' };
}
//# sourceMappingURL=browser.js.map

/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientDevice; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__browser__ = __webpack_require__(1617);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

var ClientDevice = /** @class */ (function () {
    function ClientDevice() {
    }
    ClientDevice.clientInfo = function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__browser__["a" /* clientInfo */])();
    };
    ClientDevice.dimension = function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__browser__["b" /* dimension */])();
    };
    return ClientDevice;
}());

/**
 * @deprecated use named import
 */
/* unused harmony default export */ var _unused_webpack_default_export = (ClientDevice);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CredentialsClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Credentials; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StorageHelper__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__JS__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OAuthHelper__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Util__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Platform__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Amplify__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__aws_sdk_credential_provider_cognito_identity__ = __webpack_require__(1697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__aws_sdk_client_cognito_identity__ = __webpack_require__(524);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};









var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('Credentials');
var CREDENTIALS_TTL = 50 * 60 * 1000; // 50 min, can be modified on config if required in the future
var COGNITO_IDENTITY_KEY_PREFIX = 'CognitoIdentityId-';
var CredentialsClass = /** @class */ (function () {
    function CredentialsClass(config) {
        this._gettingCredPromise = null;
        this._refreshHandlers = {};
        // Allow `Auth` to be injected for SSR, but Auth isn't a required dependency for Credentials
        this.Auth = undefined;
        this.configure(config);
        this._refreshHandlers['google'] = __WEBPACK_IMPORTED_MODULE_3__OAuthHelper__["b" /* GoogleOAuth */].refreshGoogleToken;
        this._refreshHandlers['facebook'] = __WEBPACK_IMPORTED_MODULE_3__OAuthHelper__["a" /* FacebookOAuth */].refreshFacebookToken;
    }
    CredentialsClass.prototype.getModuleName = function () {
        return 'Credentials';
    };
    CredentialsClass.prototype.getCredSource = function () {
        return this._credentials_source;
    };
    CredentialsClass.prototype.configure = function (config) {
        if (!config)
            return this._config || {};
        this._config = Object.assign({}, this._config, config);
        var refreshHandlers = this._config.refreshHandlers;
        // If the developer has provided an object of refresh handlers,
        // then we can merge the provided handlers with the current handlers.
        if (refreshHandlers) {
            this._refreshHandlers = __assign(__assign({}, this._refreshHandlers), refreshHandlers);
        }
        this._storage = this._config.storage;
        if (!this._storage) {
            this._storage = new __WEBPACK_IMPORTED_MODULE_1__StorageHelper__["a" /* StorageHelper */]().getStorage();
        }
        this._storageSync = Promise.resolve();
        if (typeof this._storage['sync'] === 'function') {
            this._storageSync = this._storage['sync']();
        }
        return this._config;
    };
    CredentialsClass.prototype.get = function () {
        logger.debug('getting credentials');
        return this._pickupCredentials();
    };
    // currently we only store the guest identity in local storage
    CredentialsClass.prototype._getCognitoIdentityIdStorageKey = function (identityPoolId) {
        return "" + COGNITO_IDENTITY_KEY_PREFIX + identityPoolId;
    };
    CredentialsClass.prototype._pickupCredentials = function () {
        logger.debug('picking up credentials');
        if (!this._gettingCredPromise || !this._gettingCredPromise.isPending()) {
            logger.debug('getting new cred promise');
            this._gettingCredPromise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__JS__["g" /* makeQuerablePromise */])(this._keepAlive());
        }
        else {
            logger.debug('getting old cred promise');
        }
        return this._gettingCredPromise;
    };
    CredentialsClass.prototype._keepAlive = function () {
        return __awaiter(this, void 0, void 0, function () {
            var cred, _a, Auth, user_1, session, refreshToken_1, refreshRequest, err_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        logger.debug('checking if credentials exists and not expired');
                        cred = this._credentials;
                        if (cred && !this._isExpired(cred) && !this._isPastTTL()) {
                            logger.debug('credentials not changed and not expired, directly return');
                            return [2 /*return*/, Promise.resolve(cred)];
                        }
                        logger.debug('need to get a new credential or refresh the existing one');
                        _a = this.Auth, Auth = _a === void 0 ? __WEBPACK_IMPORTED_MODULE_6__Amplify__["b" /* Amplify */].Auth : _a;
                        if (!Auth || typeof Auth.currentUserCredentials !== 'function') {
                            return [2 /*return*/, Promise.reject('No Auth module registered in Amplify')];
                        }
                        if (!(!this._isExpired(cred) && this._isPastTTL())) return [3 /*break*/, 6];
                        logger.debug('ttl has passed but token is not yet expired');
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, Auth.currentUserPoolUser()];
                    case 2:
                        user_1 = _b.sent();
                        return [4 /*yield*/, Auth.currentSession()];
                    case 3:
                        session = _b.sent();
                        refreshToken_1 = session.refreshToken;
                        refreshRequest = new Promise(function (res, rej) {
                            user_1.refreshSession(refreshToken_1, function (err, data) {
                                return err ? rej(err) : res(data);
                            });
                        });
                        return [4 /*yield*/, refreshRequest];
                    case 4:
                        _b.sent(); // note that rejections will be caught and handled in the catch block.
                        return [3 /*break*/, 6];
                    case 5:
                        err_1 = _b.sent();
                        // should not throw because user might just be on guest access or is authenticated through federation
                        logger.debug('Error attempting to refreshing the session', err_1);
                        return [3 /*break*/, 6];
                    case 6: return [2 /*return*/, Auth.currentUserCredentials()];
                }
            });
        });
    };
    CredentialsClass.prototype.refreshFederatedToken = function (federatedInfo) {
        logger.debug('Getting federated credentials');
        var provider = federatedInfo.provider, user = federatedInfo.user, token = federatedInfo.token, identity_id = federatedInfo.identity_id;
        var expires_at = federatedInfo.expires_at;
        // Make sure expires_at is in millis
        expires_at =
            new Date(expires_at).getFullYear() === 1970
                ? expires_at * 1000
                : expires_at;
        var that = this;
        logger.debug('checking if federated jwt token expired');
        if (expires_at > new Date().getTime()) {
            // if not expired
            logger.debug('token not expired');
            return this._setCredentialsFromFederation({
                provider: provider,
                token: token,
                user: user,
                identity_id: identity_id,
                expires_at: expires_at,
            });
        }
        else {
            // if refresh handler exists
            if (that._refreshHandlers[provider] &&
                typeof that._refreshHandlers[provider] === 'function') {
                logger.debug('getting refreshed jwt token from federation provider');
                return this._providerRefreshWithRetry({
                    refreshHandler: that._refreshHandlers[provider],
                    provider: provider,
                    user: user,
                });
            }
            else {
                logger.debug('no refresh handler for provider:', provider);
                this.clear();
                return Promise.reject('no refresh handler for provider');
            }
        }
    };
    CredentialsClass.prototype._providerRefreshWithRetry = function (_a) {
        var _this = this;
        var refreshHandler = _a.refreshHandler, provider = _a.provider, user = _a.user;
        var MAX_DELAY_MS = 10 * 1000;
        // refreshHandler will retry network errors, otherwise it will
        // return NonRetryableError to break out of jitteredExponentialRetry
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__Util__["e" /* jitteredExponentialRetry */])(refreshHandler, [], MAX_DELAY_MS)
            .then(function (data) {
            logger.debug('refresh federated token sucessfully', data);
            return _this._setCredentialsFromFederation({
                provider: provider,
                token: data.token,
                user: user,
                identity_id: data.identity_id,
                expires_at: data.expires_at,
            });
        })
            .catch(function (e) {
            var isNetworkError = typeof e === 'string' &&
                e.toLowerCase().lastIndexOf('network error', e.length) === 0;
            if (!isNetworkError) {
                _this.clear();
            }
            logger.debug('refresh federated token failed', e);
            return Promise.reject('refreshing federation token failed: ' + e);
        });
    };
    CredentialsClass.prototype._isExpired = function (credentials) {
        if (!credentials) {
            logger.debug('no credentials for expiration check');
            return true;
        }
        logger.debug('are these credentials expired?', credentials);
        var ts = Date.now();
        /* returns date object.
            https://github.com/aws/aws-sdk-js-v3/blob/v1.0.0-beta.1/packages/types/src/credentials.ts#L26
        */
        var expiration = credentials.expiration;
        return expiration.getTime() <= ts;
    };
    CredentialsClass.prototype._isPastTTL = function () {
        return this._nextCredentialsRefresh <= Date.now();
    };
    CredentialsClass.prototype._setCredentialsForGuest = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, identityPoolId, region, mandatorySignIn, identityId, _b, cognitoClient, credentials, cognitoIdentityParams, credentialsProvider;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        logger.debug('setting credentials for guest');
                        _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region, mandatorySignIn = _a.mandatorySignIn;
                        if (mandatorySignIn) {
                            return [2 /*return*/, Promise.reject('cannot get guest credentials when mandatory signin enabled')];
                        }
                        if (!identityPoolId) {
                            logger.debug('No Cognito Identity pool provided for unauthenticated access');
                            return [2 /*return*/, Promise.reject('No Cognito Identity pool provided for unauthenticated access')];
                        }
                        if (!region) {
                            logger.debug('region is not configured for getting the credentials');
                            return [2 /*return*/, Promise.reject('region is not configured for getting the credentials')];
                        }
                        _b = this;
                        return [4 /*yield*/, this._getGuestIdentityId()];
                    case 1:
                        identityId = _b._identityId = _c.sent();
                        cognitoClient = new __WEBPACK_IMPORTED_MODULE_8__aws_sdk_client_cognito_identity__["CognitoIdentityClient"]({
                            region: region,
                            customUserAgent: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Platform__["b" /* getAmplifyUserAgent */])(),
                        });
                        credentials = undefined;
                        if (identityId) {
                            cognitoIdentityParams = {
                                identityId: identityId,
                                client: cognitoClient,
                            };
                            credentials = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__aws_sdk_credential_provider_cognito_identity__["fromCognitoIdentity"])(cognitoIdentityParams)();
                        }
                        else {
                            credentialsProvider = function () { return __awaiter(_this, void 0, void 0, function () {
                                var IdentityId, cognitoIdentityParams, credentialsFromCognitoIdentity;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, cognitoClient.send(new __WEBPACK_IMPORTED_MODULE_8__aws_sdk_client_cognito_identity__["GetIdCommand"]({
                                                IdentityPoolId: identityPoolId,
                                            }))];
                                        case 1:
                                            IdentityId = (_a.sent()).IdentityId;
                                            this._identityId = IdentityId;
                                            cognitoIdentityParams = {
                                                client: cognitoClient,
                                                identityId: IdentityId,
                                            };
                                            credentialsFromCognitoIdentity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__aws_sdk_credential_provider_cognito_identity__["fromCognitoIdentity"])(cognitoIdentityParams);
                                            return [2 /*return*/, credentialsFromCognitoIdentity()];
                                    }
                                });
                            }); };
                            credentials = credentialsProvider().catch(function (err) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    throw err;
                                });
                            }); });
                        }
                        return [2 /*return*/, this._loadCredentials(credentials, 'guest', false, null)
                                .then(function (res) {
                                return res;
                            })
                                .catch(function (e) { return __awaiter(_this, void 0, void 0, function () {
                                var credentialsProvider;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(e.name === 'ResourceNotFoundException' &&
                                                e.message === "Identity '" + identityId + "' not found.")) return [3 /*break*/, 2];
                                            logger.debug('Failed to load guest credentials');
                                            return [4 /*yield*/, this._removeGuestIdentityId()];
                                        case 1:
                                            _a.sent();
                                            credentialsProvider = function () { return __awaiter(_this, void 0, void 0, function () {
                                                var IdentityId, cognitoIdentityParams, credentialsFromCognitoIdentity;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0: return [4 /*yield*/, cognitoClient.send(new __WEBPACK_IMPORTED_MODULE_8__aws_sdk_client_cognito_identity__["GetIdCommand"]({
                                                                IdentityPoolId: identityPoolId,
                                                            }))];
                                                        case 1:
                                                            IdentityId = (_a.sent()).IdentityId;
                                                            this._identityId = IdentityId;
                                                            cognitoIdentityParams = {
                                                                client: cognitoClient,
                                                                identityId: IdentityId,
                                                            };
                                                            credentialsFromCognitoIdentity = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__aws_sdk_credential_provider_cognito_identity__["fromCognitoIdentity"])(cognitoIdentityParams);
                                                            return [2 /*return*/, credentialsFromCognitoIdentity()];
                                                    }
                                                });
                                            }); };
                                            credentials = credentialsProvider().catch(function (err) { return __awaiter(_this, void 0, void 0, function () {
                                                return __generator(this, function (_a) {
                                                    throw err;
                                                });
                                            }); });
                                            return [2 /*return*/, this._loadCredentials(credentials, 'guest', false, null)];
                                        case 2: return [2 /*return*/, e];
                                    }
                                });
                            }); })];
                }
            });
        });
    };
    CredentialsClass.prototype._setCredentialsFromFederation = function (params) {
        var provider = params.provider, token = params.token, identity_id = params.identity_id;
        var domains = {
            google: 'accounts.google.com',
            facebook: 'graph.facebook.com',
            amazon: 'www.amazon.com',
            developer: 'cognito-identity.amazonaws.com',
        };
        // Use custom provider url instead of the predefined ones
        var domain = domains[provider] || provider;
        if (!domain) {
            return Promise.reject('You must specify a federated provider');
        }
        var logins = {};
        logins[domain] = token;
        var _a = this._config, identityPoolId = _a.identityPoolId, region = _a.region;
        if (!identityPoolId) {
            logger.debug('No Cognito Federated Identity pool provided');
            return Promise.reject('No Cognito Federated Identity pool provided');
        }
        if (!region) {
            logger.debug('region is not configured for getting the credentials');
            return Promise.reject('region is not configured for getting the credentials');
        }
        var cognitoClient = new __WEBPACK_IMPORTED_MODULE_8__aws_sdk_client_cognito_identity__["CognitoIdentityClient"]({
            region: region,
            customUserAgent: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Platform__["b" /* getAmplifyUserAgent */])(),
        });
        var credentials = undefined;
        if (identity_id) {
            var cognitoIdentityParams = {
                identityId: identity_id,
                logins: logins,
                client: cognitoClient,
            };
            credentials = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__aws_sdk_credential_provider_cognito_identity__["fromCognitoIdentity"])(cognitoIdentityParams)();
        }
        else {
            var cognitoIdentityParams = {
                logins: logins,
                identityPoolId: identityPoolId,
                client: cognitoClient,
            };
            credentials = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__aws_sdk_credential_provider_cognito_identity__["fromCognitoIdentityPool"])(cognitoIdentityParams)();
        }
        return this._loadCredentials(credentials, 'federated', true, params);
    };
    CredentialsClass.prototype._setCredentialsFromSession = function (session) {
        var _this = this;
        logger.debug('set credentials from session');
        var idToken = session.getIdToken().getJwtToken();
        var _a = this._config, region = _a.region, userPoolId = _a.userPoolId, identityPoolId = _a.identityPoolId;
        if (!identityPoolId) {
            logger.debug('No Cognito Federated Identity pool provided');
            return Promise.reject('No Cognito Federated Identity pool provided');
        }
        if (!region) {
            logger.debug('region is not configured for getting the credentials');
            return Promise.reject('region is not configured for getting the credentials');
        }
        var key = 'cognito-idp.' + region + '.amazonaws.com/' + userPoolId;
        var logins = {};
        logins[key] = idToken;
        var cognitoClient = new __WEBPACK_IMPORTED_MODULE_8__aws_sdk_client_cognito_identity__["CognitoIdentityClient"]({
            region: region,
            customUserAgent: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__Platform__["b" /* getAmplifyUserAgent */])(),
        });
        /*
            Retreiving identityId with GetIdCommand to mimic the behavior in the following code in aws-sdk-v3:
            https://git.io/JeDxU

            Note: Retreive identityId from CredentialsProvider once aws-sdk-js v3 supports this.
        */
        var credentialsProvider = function () { return __awaiter(_this, void 0, void 0, function () {
            var guestIdentityId, generatedOrRetrievedIdentityId, IdentityId, _a, _b, AccessKeyId, Expiration, SecretKey, SessionToken, primaryIdentityId;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this._getGuestIdentityId()];
                    case 1:
                        guestIdentityId = _c.sent();
                        if (!!guestIdentityId) return [3 /*break*/, 3];
                        return [4 /*yield*/, cognitoClient.send(new __WEBPACK_IMPORTED_MODULE_8__aws_sdk_client_cognito_identity__["GetIdCommand"]({
                                IdentityPoolId: identityPoolId,
                                Logins: logins,
                            }))];
                    case 2:
                        IdentityId = (_c.sent()).IdentityId;
                        generatedOrRetrievedIdentityId = IdentityId;
                        _c.label = 3;
                    case 3: return [4 /*yield*/, cognitoClient.send(new __WEBPACK_IMPORTED_MODULE_8__aws_sdk_client_cognito_identity__["GetCredentialsForIdentityCommand"]({
                            IdentityId: guestIdentityId || generatedOrRetrievedIdentityId,
                            Logins: logins,
                        }))];
                    case 4:
                        _a = _c.sent(), _b = _a.Credentials, AccessKeyId = _b.AccessKeyId, Expiration = _b.Expiration, SecretKey = _b.SecretKey, SessionToken = _b.SessionToken, primaryIdentityId = _a.IdentityId;
                        this._identityId = primaryIdentityId;
                        if (!guestIdentityId) return [3 /*break*/, 6];
                        // if guestIdentity is found and used by GetCredentialsForIdentity
                        // it will be linked to the logins provided, and disqualified as an unauth identity
                        logger.debug("The guest identity " + guestIdentityId + " has been successfully linked to the logins");
                        if (guestIdentityId === primaryIdentityId) {
                            logger.debug("The guest identity " + guestIdentityId + " has become the primary identity");
                        }
                        // remove it from local storage to avoid being used as a guest Identity by _setCredentialsForGuest
                        return [4 /*yield*/, this._removeGuestIdentityId()];
                    case 5:
                        // remove it from local storage to avoid being used as a guest Identity by _setCredentialsForGuest
                        _c.sent();
                        _c.label = 6;
                    case 6: 
                    // https://github.com/aws/aws-sdk-js-v3/blob/main/packages/credential-provider-cognito-identity/src/fromCognitoIdentity.ts#L40
                    return [2 /*return*/, {
                            accessKeyId: AccessKeyId,
                            secretAccessKey: SecretKey,
                            sessionToken: SessionToken,
                            expiration: Expiration,
                            identityId: primaryIdentityId,
                        }];
                }
            });
        }); };
        var credentials = credentialsProvider().catch(function (err) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw err;
            });
        }); });
        return this._loadCredentials(credentials, 'userPool', true, null);
    };
    CredentialsClass.prototype._loadCredentials = function (credentials, source, authenticated, info) {
        var _this = this;
        var that = this;
        return new Promise(function (res, rej) {
            credentials
                .then(function (credentials) { return __awaiter(_this, void 0, void 0, function () {
                var user, provider, token, expires_at, identity_id;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            logger.debug('Load credentials successfully', credentials);
                            if (this._identityId && !credentials.identityId) {
                                credentials['identityId'] = this._identityId;
                            }
                            that._credentials = credentials;
                            that._credentials.authenticated = authenticated;
                            that._credentials_source = source;
                            that._nextCredentialsRefresh = new Date().getTime() + CREDENTIALS_TTL;
                            if (source === 'federated') {
                                user = Object.assign({ id: this._credentials.identityId }, info.user);
                                provider = info.provider, token = info.token, expires_at = info.expires_at, identity_id = info.identity_id;
                                try {
                                    this._storage.setItem('aws-amplify-federatedInfo', JSON.stringify({
                                        provider: provider,
                                        token: token,
                                        user: user,
                                        expires_at: expires_at,
                                        identity_id: identity_id,
                                    }));
                                }
                                catch (e) {
                                    logger.debug('Failed to put federated info into auth storage', e);
                                }
                            }
                            if (!(source === 'guest')) return [3 /*break*/, 2];
                            return [4 /*yield*/, this._setGuestIdentityId(credentials.identityId)];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2:
                            res(that._credentials);
                            return [2 /*return*/];
                    }
                });
            }); })
                .catch(function (err) {
                if (err) {
                    logger.debug('Failed to load credentials', credentials);
                    logger.debug('Error loading credentials', err);
                    rej(err);
                    return;
                }
            });
        });
    };
    CredentialsClass.prototype.set = function (params, source) {
        if (source === 'session') {
            return this._setCredentialsFromSession(params);
        }
        else if (source === 'federation') {
            return this._setCredentialsFromFederation(params);
        }
        else if (source === 'guest') {
            return this._setCredentialsForGuest();
        }
        else {
            logger.debug('no source specified for setting credentials');
            return Promise.reject('invalid source');
        }
    };
    CredentialsClass.prototype.clear = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._credentials = null;
                this._credentials_source = null;
                logger.debug('removing aws-amplify-federatedInfo from storage');
                this._storage.removeItem('aws-amplify-federatedInfo');
                return [2 /*return*/];
            });
        });
    };
    /* operations on local stored guest identity */
    CredentialsClass.prototype._getGuestIdentityId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var identityPoolId, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        identityPoolId = this._config.identityPoolId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._storageSync];
                    case 2:
                        _a.sent();
                        return [2 /*return*/, this._storage.getItem(this._getCognitoIdentityIdStorageKey(identityPoolId))];
                    case 3:
                        e_1 = _a.sent();
                        logger.debug('Failed to get the cached guest identityId', e_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CredentialsClass.prototype._setGuestIdentityId = function (identityId) {
        return __awaiter(this, void 0, void 0, function () {
            var identityPoolId, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        identityPoolId = this._config.identityPoolId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._storageSync];
                    case 2:
                        _a.sent();
                        this._storage.setItem(this._getCognitoIdentityIdStorageKey(identityPoolId), identityId);
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        logger.debug('Failed to cache guest identityId', e_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    CredentialsClass.prototype._removeGuestIdentityId = function () {
        return __awaiter(this, void 0, void 0, function () {
            var identityPoolId;
            return __generator(this, function (_a) {
                identityPoolId = this._config.identityPoolId;
                logger.debug("removing " + this._getCognitoIdentityIdStorageKey(identityPoolId) + " from storage");
                this._storage.removeItem(this._getCognitoIdentityIdStorageKey(identityPoolId));
                return [2 /*return*/];
            });
        });
    };
    /**
     * Compact version of credentials
     * @param {Object} credentials
     * @return {Object} - Credentials
     */
    CredentialsClass.prototype.shear = function (credentials) {
        return {
            accessKeyId: credentials.accessKeyId,
            sessionToken: credentials.sessionToken,
            secretAccessKey: credentials.secretAccessKey,
            identityId: credentials.identityId,
            authenticated: credentials.authenticated,
        };
    };
    return CredentialsClass;
}());

var Credentials = new CredentialsClass(null);
__WEBPACK_IMPORTED_MODULE_6__Amplify__["b" /* Amplify */].register(Credentials);
/**
 * @deprecated use named import
 */
/* unused harmony default export */ var _unused_webpack_default_export = (Credentials);
//# sourceMappingURL=Credentials.js.map

/***/ }),
/* 1620 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = missingConfig;
/* harmony export (immutable) */ __webpack_exports__["b"] = invalidParameter;
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
function missingConfig(name) {
    return new Error('Missing config value of ' + name);
}
function invalidParameter(name) {
    return new Error('Invalid parameter value of ' + name);
}
//# sourceMappingURL=Errors.js.map

/***/ }),
/* 1621 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export HubClass */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Hub; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(111);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};

var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('Hub');
var AMPLIFY_SYMBOL = (typeof Symbol !== 'undefined' &&
    typeof Symbol.for === 'function'
    ? Symbol.for('amplify_default')
    : '@@amplify_default');
function isLegacyCallback(callback) {
    return callback.onHubCapsule !== undefined;
}
var HubClass = /** @class */ (function () {
    function HubClass(name) {
        this.listeners = [];
        this.patterns = [];
        this.protectedChannels = [
            'core',
            'auth',
            'api',
            'analytics',
            'interactions',
            'pubsub',
            'storage',
            'xr',
        ];
        this.name = name;
    }
    // Note - Need to pass channel as a reference for removal to work and not anonymous function
    HubClass.prototype.remove = function (channel, listener) {
        if (channel instanceof RegExp) {
            var pattern_1 = this.patterns.find(function (_a) {
                var pattern = _a.pattern;
                return pattern.source === channel.source;
            });
            if (!pattern_1) {
                logger.warn("No listeners for " + channel);
                return;
            }
            this.patterns = __spread(this.patterns.filter(function (x) { return x !== pattern_1; }));
        }
        else {
            var holder = this.listeners[channel];
            if (!holder) {
                logger.warn("No listeners for " + channel);
                return;
            }
            this.listeners[channel] = __spread(holder.filter(function (_a) {
                var callback = _a.callback;
                return callback !== listener;
            }));
        }
    };
    HubClass.prototype.dispatch = function (channel, payload, source, ampSymbol) {
        if (source === void 0) { source = ''; }
        if (this.protectedChannels.indexOf(channel) > -1) {
            var hasAccess = ampSymbol === AMPLIFY_SYMBOL;
            if (!hasAccess) {
                logger.warn("WARNING: " + channel + " is protected and dispatching on it can have unintended consequences");
            }
        }
        var capsule = {
            channel: channel,
            payload: __assign({}, payload),
            source: source,
            patternInfo: [],
        };
        try {
            this._toListeners(capsule);
        }
        catch (e) {
            logger.error(e);
        }
    };
    HubClass.prototype.listen = function (channel, callback, listenerName) {
        var _this = this;
        if (listenerName === void 0) { listenerName = 'noname'; }
        var cb;
        // Check for legacy onHubCapsule callback for backwards compatability
        if (isLegacyCallback(callback)) {
            logger.warn("WARNING onHubCapsule is Deprecated. Please pass in a callback.");
            cb = callback.onHubCapsule.bind(callback);
        }
        else if (typeof callback !== 'function') {
            throw new Error('No callback supplied to Hub');
        }
        else {
            cb = callback;
        }
        if (channel instanceof RegExp) {
            this.patterns.push({
                pattern: channel,
                callback: cb,
            });
        }
        else {
            var holder = this.listeners[channel];
            if (!holder) {
                holder = [];
                this.listeners[channel] = holder;
            }
            holder.push({
                name: listenerName,
                callback: cb,
            });
        }
        return function () {
            _this.remove(channel, cb);
        };
    };
    HubClass.prototype._toListeners = function (capsule) {
        var channel = capsule.channel, payload = capsule.payload;
        var holder = this.listeners[channel];
        if (holder) {
            holder.forEach(function (listener) {
                logger.debug("Dispatching to " + channel + " with ", payload);
                try {
                    listener.callback(capsule);
                }
                catch (e) {
                    logger.error(e);
                }
            });
        }
        if (this.patterns.length > 0) {
            if (!payload.message) {
                logger.warn("Cannot perform pattern matching without a message key");
                return;
            }
            var payloadStr_1 = payload.message;
            this.patterns.forEach(function (pattern) {
                var match = payloadStr_1.match(pattern.pattern);
                if (match) {
                    var _a = __read(match), groups = _a.slice(1);
                    var dispatchingCapsule = __assign(__assign({}, capsule), { patternInfo: groups });
                    try {
                        pattern.callback(dispatchingCapsule);
                    }
                    catch (e) {
                        logger.error(e);
                    }
                }
            });
        }
    };
    return HubClass;
}());

/*We export a __default__ instance of HubClass to use it as a
psuedo Singleton for the main messaging bus, however you can still create
your own instance of HubClass() for a separate "private bus" of events.*/
var Hub = new HubClass('__default__');
/**
 * @deprecated use named import
 */
/* unused harmony default export */ var _unused_webpack_default_export = (Hub);
//# sourceMappingURL=Hub.js.map

/***/ }),
/* 1622 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return I18n; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(111);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('I18n');
/**
 * Language transition class
 */
var I18n = /** @class */ (function () {
    /**
     * @constructor
     * Initialize with configurations
     * @param {Object} options
     */
    function I18n(options) {
        /**
         * @private
         */
        this._options = null;
        /**
         * @private
         */
        this._lang = null;
        /**
         * @private
         */
        this._dict = {};
        this._options = Object.assign({}, options);
        this._lang = this._options.language;
        if (!this._lang &&
            typeof window !== 'undefined' &&
            window &&
            window.navigator) {
            this._lang = window.navigator.language;
        }
        logger.debug(this._lang);
    }
    /**
     * @method
     * Explicitly setting language
     * @param {String} lang
     */
    I18n.prototype.setLanguage = function (lang) {
        this._lang = lang;
    };
    /**
     * @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */
    I18n.prototype.get = function (key, defVal) {
        if (defVal === void 0) { defVal = undefined; }
        if (!this._lang) {
            return typeof defVal !== 'undefined' ? defVal : key;
        }
        var lang = this._lang;
        var val = this.getByLanguage(key, lang);
        if (val) {
            return val;
        }
        if (lang.indexOf('-') > 0) {
            val = this.getByLanguage(key, lang.split('-')[0]);
        }
        if (val) {
            return val;
        }
        return typeof defVal !== 'undefined' ? defVal : key;
    };
    /**
     * @method
     * Get value according to specified language
     * @param {String} key
     * @param {String} language - Specified langurage to be used
     * @param {String} defVal - Default value
     */
    I18n.prototype.getByLanguage = function (key, language, defVal) {
        if (defVal === void 0) { defVal = null; }
        if (!language) {
            return defVal;
        }
        var lang_dict = this._dict[language];
        if (!lang_dict) {
            return defVal;
        }
        return lang_dict[key];
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {String} language - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */
    I18n.prototype.putVocabulariesForLanguage = function (language, vocabularies) {
        var lang_dict = this._dict[language];
        if (!lang_dict) {
            lang_dict = this._dict[language] = {};
        }
        Object.assign(lang_dict, vocabularies);
    };
    /**
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */
    I18n.prototype.putVocabularies = function (vocabularies) {
        var _this = this;
        Object.keys(vocabularies).map(function (key) {
            _this.putVocabulariesForLanguage(key, vocabularies[key]);
        });
    };
    return I18n;
}());

//# sourceMappingURL=I18n.js.map

/***/ }),
/* 1623 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return I18n; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__I18n__ = __webpack_require__(1622);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Logger__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Amplify__ = __webpack_require__(300);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */



var logger = new __WEBPACK_IMPORTED_MODULE_1__Logger__["a" /* ConsoleLogger */]('I18n');
var _config = null;
var _i18n = null;
/**
 * Export I18n APIs
 */
var I18n = /** @class */ (function () {
    function I18n() {
    }
    /**
     * @static
     * @method
     * Configure I18n part
     * @param {Object} config - Configuration of the I18n
     */
    I18n.configure = function (config) {
        logger.debug('configure I18n');
        if (!config) {
            return _config;
        }
        _config = Object.assign({}, _config, config.I18n || config);
        I18n.createInstance();
        return _config;
    };
    I18n.getModuleName = function () {
        return 'I18n';
    };
    /**
     * @static
     * @method
     * Create an instance of I18n for the library
     */
    I18n.createInstance = function () {
        logger.debug('create I18n instance');
        if (_i18n) {
            return;
        }
        _i18n = new __WEBPACK_IMPORTED_MODULE_0__I18n__["a" /* I18n */](_config);
    };
    /**
     * @static @method
     * Explicitly setting language
     * @param {String} lang
     */
    I18n.setLanguage = function (lang) {
        I18n.checkConfig();
        return _i18n.setLanguage(lang);
    };
    /**
     * @static @method
     * Get value
     * @param {String} key
     * @param {String} defVal - Default value
     */
    I18n.get = function (key, defVal) {
        if (!I18n.checkConfig()) {
            return typeof defVal === 'undefined' ? key : defVal;
        }
        return _i18n.get(key, defVal);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {String} langurage - Language of the dictionary
     * @param {Object} vocabularies - Object that has key-value as dictionary entry
     */
    I18n.putVocabulariesForLanguage = function (language, vocabularies) {
        I18n.checkConfig();
        return _i18n.putVocabulariesForLanguage(language, vocabularies);
    };
    /**
     * @static
     * @method
     * Add vocabularies for one language
     * @param {Object} vocabularies - Object that has language as key,
     *                                vocabularies of each language as value
     */
    I18n.putVocabularies = function (vocabularies) {
        I18n.checkConfig();
        return _i18n.putVocabularies(vocabularies);
    };
    I18n.checkConfig = function () {
        if (!_i18n) {
            _i18n = new __WEBPACK_IMPORTED_MODULE_0__I18n__["a" /* I18n */](_config);
        }
        return true;
    };
    return I18n;
}());

__WEBPACK_IMPORTED_MODULE_2__Amplify__["b" /* Amplify */].register(I18n);
/**
 * @deprecated use named import
 */
/* unused harmony default export */ var _unused_webpack_default_export = (I18n);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1624 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FacebookOAuth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JS__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Util__ = __webpack_require__(301);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */



var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('CognitoCredentials');
var waitForInit = new Promise(function (res, rej) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__JS__["i" /* browserOrNode */])().isBrowser) {
        logger.debug('not in the browser, directly resolved');
        return res();
    }
    var fb = window['FB'];
    if (fb) {
        logger.debug('FB SDK already loaded');
        return res();
    }
    else {
        setTimeout(function () {
            return res();
        }, 2000);
    }
});
var FacebookOAuth = /** @class */ (function () {
    function FacebookOAuth() {
        this.initialized = false;
        this.refreshFacebookToken = this.refreshFacebookToken.bind(this);
        this._refreshFacebookTokenImpl = this._refreshFacebookTokenImpl.bind(this);
    }
    FacebookOAuth.prototype.refreshFacebookToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.initialized) return [3 /*break*/, 2];
                        logger.debug('need to wait for the Facebook SDK loaded');
                        return [4 /*yield*/, waitForInit];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        logger.debug('finish waiting');
                        _a.label = 2;
                    case 2: return [2 /*return*/, this._refreshFacebookTokenImpl()];
                }
            });
        });
    };
    FacebookOAuth.prototype._refreshFacebookTokenImpl = function () {
        var fb = null;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__JS__["i" /* browserOrNode */])().isBrowser)
            fb = window['FB'];
        if (!fb) {
            var errorMessage = 'no fb sdk available';
            logger.debug(errorMessage);
            return Promise.reject(new __WEBPACK_IMPORTED_MODULE_2__Util__["c" /* NonRetryableError */](errorMessage));
        }
        return new Promise(function (res, rej) {
            fb.getLoginStatus(function (fbResponse) {
                if (!fbResponse || !fbResponse.authResponse) {
                    var errorMessage = 'no response from facebook when refreshing the jwt token';
                    logger.debug(errorMessage);
                    // There is no definitive indication for a network error in
                    // fbResponse, so we are treating it as an invalid token.
                    rej(new __WEBPACK_IMPORTED_MODULE_2__Util__["c" /* NonRetryableError */](errorMessage));
                }
                else {
                    var response = fbResponse.authResponse;
                    var accessToken = response.accessToken, expiresIn = response.expiresIn;
                    var date = new Date();
                    var expires_at = expiresIn * 1000 + date.getTime();
                    if (!accessToken) {
                        var errorMessage = 'the jwtToken is undefined';
                        logger.debug(errorMessage);
                        rej(new __WEBPACK_IMPORTED_MODULE_2__Util__["c" /* NonRetryableError */](errorMessage));
                    }
                    res({
                        token: accessToken,
                        expires_at: expires_at,
                    });
                }
            }, { scope: 'public_profile,email' });
        });
    };
    return FacebookOAuth;
}());

/**
 * @deprecated use named import
 */
/* unused harmony default export */ var _unused_webpack_default_export = (FacebookOAuth);
//# sourceMappingURL=FacebookOAuth.js.map

/***/ }),
/* 1625 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GoogleOAuth; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JS__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Util__ = __webpack_require__(301);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */



var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('CognitoCredentials');
var waitForInit = new Promise(function (res, rej) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__JS__["i" /* browserOrNode */])().isBrowser) {
        logger.debug('not in the browser, directly resolved');
        return res();
    }
    var ga = window['gapi'] && window['gapi'].auth2 ? window['gapi'].auth2 : null;
    if (ga) {
        logger.debug('google api already loaded');
        return res();
    }
    else {
        setTimeout(function () {
            return res();
        }, 2000);
    }
});
var GoogleOAuth = /** @class */ (function () {
    function GoogleOAuth() {
        this.initialized = false;
        this.refreshGoogleToken = this.refreshGoogleToken.bind(this);
        this._refreshGoogleTokenImpl = this._refreshGoogleTokenImpl.bind(this);
    }
    GoogleOAuth.prototype.refreshGoogleToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.initialized) return [3 /*break*/, 2];
                        logger.debug('need to wait for the Google SDK loaded');
                        return [4 /*yield*/, waitForInit];
                    case 1:
                        _a.sent();
                        this.initialized = true;
                        logger.debug('finish waiting');
                        _a.label = 2;
                    case 2: return [2 /*return*/, this._refreshGoogleTokenImpl()];
                }
            });
        });
    };
    GoogleOAuth.prototype._refreshGoogleTokenImpl = function () {
        var ga = null;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__JS__["i" /* browserOrNode */])().isBrowser)
            ga = window['gapi'] && window['gapi'].auth2 ? window['gapi'].auth2 : null;
        if (!ga) {
            logger.debug('no gapi auth2 available');
            return Promise.reject('no gapi auth2 available');
        }
        return new Promise(function (res, rej) {
            ga.getAuthInstance()
                .then(function (googleAuth) {
                if (!googleAuth) {
                    logger.debug('google Auth undefined');
                    rej(new __WEBPACK_IMPORTED_MODULE_2__Util__["c" /* NonRetryableError */]('google Auth undefined'));
                }
                var googleUser = googleAuth.currentUser.get();
                // refresh the token
                if (googleUser.isSignedIn()) {
                    logger.debug('refreshing the google access token');
                    googleUser
                        .reloadAuthResponse()
                        .then(function (authResponse) {
                        var id_token = authResponse.id_token, expires_at = authResponse.expires_at;
                        res({ token: id_token, expires_at: expires_at });
                    })
                        .catch(function (err) {
                        if (err && err.error === 'network_error') {
                            // Not using NonRetryableError so handler will be retried
                            rej('Network error reloading google auth response');
                        }
                        else {
                            rej(new __WEBPACK_IMPORTED_MODULE_2__Util__["c" /* NonRetryableError */]('Failed to reload google auth response'));
                        }
                    });
                }
                else {
                    rej(new __WEBPACK_IMPORTED_MODULE_2__Util__["c" /* NonRetryableError */]('User is not signed in with Google'));
                }
            })
                .catch(function (err) {
                logger.debug('Failed to refresh google token', err);
                rej(new __WEBPACK_IMPORTED_MODULE_2__Util__["c" /* NonRetryableError */]('Failed to refresh google token'));
            });
        });
    };
    return GoogleOAuth;
}());

/**
 * @deprecated use named import
 */
/* unused harmony default export */ var _unused_webpack_default_export = (GoogleOAuth);
//# sourceMappingURL=GoogleOAuth.js.map

/***/ }),
/* 1626 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return version; });
// generated by genversion
var version = '4.1.3';
//# sourceMappingURL=version.js.map

/***/ }),
/* 1627 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AWSCloudWatchProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aws_sdk_client_cloudwatch_logs__ = __webpack_require__(1663);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Logger__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Platform__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Parser__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Util_Constants__ = __webpack_require__(511);
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};






var logger = new __WEBPACK_IMPORTED_MODULE_2__Logger__["a" /* ConsoleLogger */]('AWSCloudWatch');
var AWSCloudWatchProvider = /** @class */ (function () {
    function AWSCloudWatchProvider(config) {
        this.configure(config);
        this._dataTracker = {
            eventUploadInProgress: false,
            logEvents: [],
        };
        this._currentLogBatch = [];
        this._initiateLogPushInterval();
    }
    AWSCloudWatchProvider.prototype.getProviderName = function () {
        return AWSCloudWatchProvider.PROVIDER_NAME;
    };
    AWSCloudWatchProvider.prototype.getCategoryName = function () {
        return AWSCloudWatchProvider.CATEGORY;
    };
    AWSCloudWatchProvider.prototype.getLogQueue = function () {
        return this._dataTracker.logEvents;
    };
    AWSCloudWatchProvider.prototype.configure = function (config) {
        if (!config)
            return this._config || {};
        var conf = Object.assign({}, this._config, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__Parser__["a" /* parseMobileHubConfig */])(config).Logging, config);
        this._config = conf;
        return this._config;
    };
    AWSCloudWatchProvider.prototype.createLogGroup = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var cmd, credentialsOK, client, output, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger.debug('creating new log group in CloudWatch - ', params.logGroupName);
                        cmd = new __WEBPACK_IMPORTED_MODULE_0__aws_sdk_client_cloudwatch_logs__["CreateLogGroupCommand"](params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this._ensureCredentials()];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) {
                            logger.error(__WEBPACK_IMPORTED_MODULE_5__Util_Constants__["f" /* NO_CREDS_ERROR_STRING */]);
                            throw Error;
                        }
                        client = this._initCloudWatchLogs();
                        return [4 /*yield*/, client.send(cmd)];
                    case 3:
                        output = _a.sent();
                        return [2 /*return*/, output];
                    case 4:
                        error_1 = _a.sent();
                        logger.error("error creating log group - " + error_1);
                        throw error_1;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.getLogGroups = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var cmd, credentialsOK, client, output, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger.debug('getting list of log groups');
                        cmd = new __WEBPACK_IMPORTED_MODULE_0__aws_sdk_client_cloudwatch_logs__["DescribeLogGroupsCommand"](params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this._ensureCredentials()];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) {
                            logger.error(__WEBPACK_IMPORTED_MODULE_5__Util_Constants__["f" /* NO_CREDS_ERROR_STRING */]);
                            throw Error;
                        }
                        client = this._initCloudWatchLogs();
                        return [4 /*yield*/, client.send(cmd)];
                    case 3:
                        output = _a.sent();
                        return [2 /*return*/, output];
                    case 4:
                        error_2 = _a.sent();
                        logger.error("error getting log group - " + error_2);
                        throw error_2;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.createLogStream = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var cmd, credentialsOK, client, output, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger.debug('creating new log stream in CloudWatch - ', params.logStreamName);
                        cmd = new __WEBPACK_IMPORTED_MODULE_0__aws_sdk_client_cloudwatch_logs__["CreateLogStreamCommand"](params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this._ensureCredentials()];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) {
                            logger.error(__WEBPACK_IMPORTED_MODULE_5__Util_Constants__["f" /* NO_CREDS_ERROR_STRING */]);
                            throw Error;
                        }
                        client = this._initCloudWatchLogs();
                        return [4 /*yield*/, client.send(cmd)];
                    case 3:
                        output = _a.sent();
                        return [2 /*return*/, output];
                    case 4:
                        error_3 = _a.sent();
                        logger.error("error creating log stream - " + error_3);
                        throw error_3;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.getLogStreams = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var cmd, credentialsOK, client, output, error_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger.debug('getting list of log streams');
                        cmd = new __WEBPACK_IMPORTED_MODULE_0__aws_sdk_client_cloudwatch_logs__["DescribeLogStreamsCommand"](params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this._ensureCredentials()];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) {
                            logger.error(__WEBPACK_IMPORTED_MODULE_5__Util_Constants__["f" /* NO_CREDS_ERROR_STRING */]);
                            throw Error;
                        }
                        client = this._initCloudWatchLogs();
                        return [4 /*yield*/, client.send(cmd)];
                    case 3:
                        output = _a.sent();
                        return [2 /*return*/, output];
                    case 4:
                        error_4 = _a.sent();
                        logger.error("error getting log stream - " + error_4);
                        throw error_4;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.getLogEvents = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var cmd, credentialsOK, client, output, error_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        logger.debug('getting log events from stream - ', params.logStreamName);
                        cmd = new __WEBPACK_IMPORTED_MODULE_0__aws_sdk_client_cloudwatch_logs__["GetLogEventsCommand"](params);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this._ensureCredentials()];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) {
                            logger.error(__WEBPACK_IMPORTED_MODULE_5__Util_Constants__["f" /* NO_CREDS_ERROR_STRING */]);
                            throw Error;
                        }
                        client = this._initCloudWatchLogs();
                        return [4 /*yield*/, client.send(cmd)];
                    case 3:
                        output = _a.sent();
                        return [2 /*return*/, output];
                    case 4:
                        error_5 = _a.sent();
                        logger.error("error getting log events - " + error_5);
                        throw error_5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype.pushLogs = function (logs) {
        logger.debug('pushing log events to Cloudwatch...');
        this._dataTracker.logEvents = __spread(this._dataTracker.logEvents, logs);
    };
    AWSCloudWatchProvider.prototype._validateLogGroupExistsAndCreate = function (logGroupName) {
        return __awaiter(this, void 0, void 0, function () {
            var credentialsOK, currGroups, foundGroups, err_1, errString;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._dataTracker.verifiedLogGroup) {
                            return [2 /*return*/, this._dataTracker.verifiedLogGroup];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 5, , 6]);
                        return [4 /*yield*/, this._ensureCredentials()];
                    case 2:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) {
                            logger.error(__WEBPACK_IMPORTED_MODULE_5__Util_Constants__["f" /* NO_CREDS_ERROR_STRING */]);
                            throw Error;
                        }
                        return [4 /*yield*/, this.getLogGroups({
                                logGroupNamePrefix: logGroupName,
                            })];
                    case 3:
                        currGroups = _a.sent();
                        if (!(typeof currGroups === 'string') && currGroups.logGroups) {
                            foundGroups = currGroups.logGroups.filter(function (group) { return group.logGroupName === logGroupName; });
                            if (foundGroups.length > 0) {
                                this._dataTracker.verifiedLogGroup = foundGroups[0];
                                return [2 /*return*/, foundGroups[0]];
                            }
                        }
                        /**
                         * If we get to this point, it means that the specified log group does not exist
                         * and we should create it.
                         */
                        return [4 /*yield*/, this.createLogGroup({ logGroupName: logGroupName })];
                    case 4:
                        /**
                         * If we get to this point, it means that the specified log group does not exist
                         * and we should create it.
                         */
                        _a.sent();
                        return [2 /*return*/, null];
                    case 5:
                        err_1 = _a.sent();
                        errString = "failure during log group search: " + err_1;
                        logger.error(errString);
                        throw err_1;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._validateLogStreamExists = function (logGroupName, logStreamName) {
        return __awaiter(this, void 0, void 0, function () {
            var credentialsOK, currStreams, foundStreams, err_2, errString;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        return [4 /*yield*/, this._ensureCredentials()];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) {
                            logger.error(__WEBPACK_IMPORTED_MODULE_5__Util_Constants__["f" /* NO_CREDS_ERROR_STRING */]);
                            throw Error;
                        }
                        return [4 /*yield*/, this.getLogStreams({
                                logGroupName: logGroupName,
                                logStreamNamePrefix: logStreamName,
                            })];
                    case 2:
                        currStreams = _a.sent();
                        if (currStreams.logStreams) {
                            foundStreams = currStreams.logStreams.filter(function (stream) { return stream.logStreamName === logStreamName; });
                            if (foundStreams.length > 0) {
                                this._nextSequenceToken = foundStreams[0].uploadSequenceToken;
                                return [2 /*return*/, foundStreams[0]];
                            }
                        }
                        /**
                         * If we get to this point, it means that the specified stream does not
                         * exist, and we should create it now.
                         */
                        return [4 /*yield*/, this.createLogStream({
                                logGroupName: logGroupName,
                                logStreamName: logStreamName,
                            })];
                    case 3:
                        /**
                         * If we get to this point, it means that the specified stream does not
                         * exist, and we should create it now.
                         */
                        _a.sent();
                        return [2 /*return*/, null];
                    case 4:
                        err_2 = _a.sent();
                        errString = "failure during log stream search: " + err_2;
                        logger.error(errString);
                        throw err_2;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._sendLogEvents = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var credentialsOK, cmd, client, output, err_3, errString;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this._ensureCredentials()];
                    case 1:
                        credentialsOK = _a.sent();
                        if (!credentialsOK) {
                            logger.error(__WEBPACK_IMPORTED_MODULE_5__Util_Constants__["f" /* NO_CREDS_ERROR_STRING */]);
                            throw Error;
                        }
                        logger.debug('sending log events to stream - ', params.logStreamName);
                        cmd = new __WEBPACK_IMPORTED_MODULE_0__aws_sdk_client_cloudwatch_logs__["PutLogEventsCommand"](params);
                        client = this._initCloudWatchLogs();
                        return [4 /*yield*/, client.send(cmd)];
                    case 2:
                        output = _a.sent();
                        return [2 /*return*/, output];
                    case 3:
                        err_3 = _a.sent();
                        errString = "failure during log push: " + err_3;
                        logger.error(errString);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._initCloudWatchLogs = function () {
        return new __WEBPACK_IMPORTED_MODULE_0__aws_sdk_client_cloudwatch_logs__["CloudWatchLogsClient"]({
            region: this._config.region,
            credentials: this._config.credentials,
            customUserAgent: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__Platform__["b" /* getAmplifyUserAgent */])(),
            endpoint: this._config.endpoint,
        });
    };
    AWSCloudWatchProvider.prototype._ensureCredentials = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1____["Credentials"].get()
                            .then(function (credentials) {
                            if (!credentials)
                                return false;
                            var cred = __WEBPACK_IMPORTED_MODULE_1____["Credentials"].shear(credentials);
                            logger.debug('set credentials for logging', cred);
                            _this._config.credentials = cred;
                            return true;
                        })
                            .catch(function (error) {
                            logger.warn('ensure credentials error', error);
                            return false;
                        })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._getNextSequenceToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var logStream, err_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this._nextSequenceToken && this._nextSequenceToken.length > 0) {
                            return [2 /*return*/, this._nextSequenceToken];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, this._validateLogGroupExistsAndCreate(this._config.logGroupName)];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this._validateLogStreamExists(this._config.logGroupName, this._config.logStreamName)];
                    case 3:
                        logStream = _a.sent();
                        if (!logStream) {
                            this._nextSequenceToken = '';
                            return [2 /*return*/, ''];
                        }
                        this._nextSequenceToken = logStream.uploadSequenceToken || '';
                        return [2 /*return*/, this._nextSequenceToken];
                    case 4:
                        err_4 = _a.sent();
                        logger.error("failure while getting next sequence token: " + err_4);
                        throw err_4;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._safeUploadLogEvents = function () {
        return __awaiter(this, void 0, void 0, function () {
            var seqToken, logBatch, putLogsPayload, sendLogEventsResponse, err_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        return [4 /*yield*/, this._getNextSequenceToken()];
                    case 1:
                        seqToken = _a.sent();
                        logBatch = this._currentLogBatch.length === 0
                            ? this._getBufferedBatchOfLogs()
                            : this._currentLogBatch;
                        putLogsPayload = {
                            logGroupName: this._config.logGroupName,
                            logStreamName: this._config.logStreamName,
                            logEvents: logBatch,
                            sequenceToken: seqToken,
                        };
                        this._dataTracker.eventUploadInProgress = true;
                        return [4 /*yield*/, this._sendLogEvents(putLogsPayload)];
                    case 2:
                        sendLogEventsResponse = _a.sent();
                        this._nextSequenceToken = sendLogEventsResponse.nextSequenceToken;
                        this._dataTracker.eventUploadInProgress = false;
                        this._currentLogBatch = [];
                        return [2 /*return*/, sendLogEventsResponse];
                    case 3:
                        err_5 = _a.sent();
                        logger.error("error during _safeUploadLogEvents: " + err_5);
                        if (__WEBPACK_IMPORTED_MODULE_5__Util_Constants__["g" /* RETRY_ERROR_CODES */].includes(err_5.name)) {
                            this._getNewSequenceTokenAndSubmit({
                                logEvents: this._currentLogBatch,
                                logGroupName: this._config.logGroupName,
                                logStreamName: this._config.logStreamName,
                            });
                        }
                        else {
                            this._dataTracker.eventUploadInProgress = false;
                            throw err_5;
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._getBufferedBatchOfLogs = function () {
        /**
         * CloudWatch has restrictions on the size of the log events that get sent up.
         * We need to track both the size of each event and the total size of the batch
         * of logs.
         *
         * We also need to ensure that the logs in the batch are sorted in chronological order.
         * https://docs.aws.amazon.com/AmazonCloudWatchLogs/latest/APIReference/API_PutLogEvents.html
         */
        var currentEventIdx = 0;
        var totalByteSize = 0;
        while (currentEventIdx < this._dataTracker.logEvents.length) {
            var currentEvent = this._dataTracker.logEvents[currentEventIdx];
            var eventSize = currentEvent
                ? new TextEncoder().encode(currentEvent.message).length +
                    __WEBPACK_IMPORTED_MODULE_5__Util_Constants__["a" /* AWS_CLOUDWATCH_BASE_BUFFER_SIZE */]
                : 0;
            if (eventSize > __WEBPACK_IMPORTED_MODULE_5__Util_Constants__["d" /* AWS_CLOUDWATCH_MAX_EVENT_SIZE */]) {
                var errString = "Log entry exceeds maximum size for CloudWatch logs. Log size: " + eventSize + ". Truncating log message.";
                logger.warn(errString);
                currentEvent.message = currentEvent.message.substring(0, eventSize);
            }
            if (totalByteSize + eventSize > __WEBPACK_IMPORTED_MODULE_5__Util_Constants__["c" /* AWS_CLOUDWATCH_MAX_BATCH_EVENT_SIZE */])
                break;
            totalByteSize += eventSize;
            currentEventIdx++;
        }
        this._currentLogBatch = this._dataTracker.logEvents.splice(0, currentEventIdx);
        return this._currentLogBatch;
    };
    AWSCloudWatchProvider.prototype._getNewSequenceTokenAndSubmit = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var seqToken, sendLogEventsRepsonse, err_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        this._nextSequenceToken = '';
                        this._dataTracker.eventUploadInProgress = true;
                        return [4 /*yield*/, this._getNextSequenceToken()];
                    case 1:
                        seqToken = _a.sent();
                        payload.sequenceToken = seqToken;
                        return [4 /*yield*/, this._sendLogEvents(payload)];
                    case 2:
                        sendLogEventsRepsonse = _a.sent();
                        this._dataTracker.eventUploadInProgress = false;
                        this._currentLogBatch = [];
                        return [2 /*return*/, sendLogEventsRepsonse];
                    case 3:
                        err_6 = _a.sent();
                        logger.error("error when retrying log submission with new sequence token: " + err_6);
                        this._dataTracker.eventUploadInProgress = false;
                        throw err_6;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    AWSCloudWatchProvider.prototype._initiateLogPushInterval = function () {
        var _this = this;
        if (this._timer) {
            clearInterval(this._timer);
        }
        this._timer = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var err_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 3, , 4]);
                        if (!this._getDocUploadPermissibility()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._safeUploadLogEvents()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [3 /*break*/, 4];
                    case 3:
                        err_7 = _a.sent();
                        logger.error("error when calling _safeUploadLogEvents in the timer interval - " + err_7);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); }, 2000);
    };
    AWSCloudWatchProvider.prototype._getDocUploadPermissibility = function () {
        return ((this._dataTracker.logEvents.length !== 0 ||
            this._currentLogBatch.length !== 0) &&
            !this._dataTracker.eventUploadInProgress);
    };
    AWSCloudWatchProvider.PROVIDER_NAME = __WEBPACK_IMPORTED_MODULE_5__Util_Constants__["e" /* AWS_CLOUDWATCH_PROVIDER_NAME */];
    AWSCloudWatchProvider.CATEGORY = __WEBPACK_IMPORTED_MODULE_5__Util_Constants__["b" /* AWS_CLOUDWATCH_CATEGORY */];
    return AWSCloudWatchProvider;
}());

//# sourceMappingURL=AWSCloudWatchProvider.js.map

/***/ }),
/* 1628 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AWSCloudWatchProvider__ = __webpack_require__(1627);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AWSCloudWatchProvider__["a"]; });

//# sourceMappingURL=index.js.map

/***/ }),
/* 1629 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Linking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AppState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AsyncStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__JS__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StorageHelper__ = __webpack_require__(510);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */


var Linking = {};
var AppState = {
    addEventListener: function (action, handler) { return undefined; },
};
// if not in react native, just use local storage
var AsyncStorage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__JS__["i" /* browserOrNode */])().isBrowser
    ? new __WEBPACK_IMPORTED_MODULE_1__StorageHelper__["a" /* StorageHelper */]().getStorage()
    : undefined;
//# sourceMappingURL=index.js.map

/***/ }),
/* 1630 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ServiceWorkerClass; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JS__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Amplify__ = __webpack_require__(300);
/**
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */



/**
 * Provides a means to registering a service worker in the browser
 * and communicating with it via postMessage events.
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API/
 *
 * postMessage events are currently not supported in all browsers. See:
 * https://developer.mozilla.org/en-US/docs/Web/API/Service_Worker_API
 *
 * At the minmum this class will register the service worker and listen
 * and attempt to dispatch messages on state change and record analytics
 * events based on the service worker lifecycle.
 */
var ServiceWorkerClass = /** @class */ (function () {
    function ServiceWorkerClass() {
        // The AWS Amplify logger
        this._logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('ServiceWorker');
    }
    Object.defineProperty(ServiceWorkerClass.prototype, "serviceWorker", {
        /**
         * Get the currently active service worker
         */
        get: function () {
            return this._serviceWorker;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Register the service-worker.js file in the browser
     * Make sure the service-worker.js is part of the build
     * for example with Angular, modify the angular-cli.json file
     * and add to "assets" array "service-worker.js"
     * @param {string} - (optional) Service worker file. Defaults to "/service-worker.js"
     * @param {string} - (optional) The service worker scope. Defaults to "/"
     *  - API Doc: https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/register
     * @returns {Promise}
     *	- resolve(ServiceWorkerRegistration)
     *	- reject(Error)
     **/
    ServiceWorkerClass.prototype.register = function (filePath, scope) {
        var _this = this;
        if (filePath === void 0) { filePath = '/service-worker.js'; }
        if (scope === void 0) { scope = '/'; }
        this._logger.debug("registering " + filePath);
        this._logger.debug("registering service worker with scope " + scope);
        return new Promise(function (resolve, reject) {
            if (navigator && 'serviceWorker' in navigator) {
                navigator.serviceWorker
                    .register(filePath, {
                    scope: scope,
                })
                    .then(function (registration) {
                    if (registration.installing) {
                        _this._serviceWorker = registration.installing;
                    }
                    else if (registration.waiting) {
                        _this._serviceWorker = registration.waiting;
                    }
                    else if (registration.active) {
                        _this._serviceWorker = registration.active;
                    }
                    _this._registration = registration;
                    _this._setupListeners();
                    _this._logger.debug("Service Worker Registration Success: " + registration);
                    return resolve(registration);
                })
                    .catch(function (error) {
                    _this._logger.debug("Service Worker Registration Failed " + error);
                    return reject(error);
                });
            }
            else {
                return reject(new Error('Service Worker not available'));
            }
        });
    };
    /**
     * Enable web push notifications. If not subscribed, a new subscription will
     * be created and registered.
     * 	Test Push Server: https://web-push-codelab.glitch.me/
     * 	Push Server Libraries: https://github.com/web-push-libs/
     * 	API Doc: https://developers.google.com/web/fundamentals/codelabs/push-notifications/
     * @param publicKey
     * @returns {Promise}
     * 	- resolve(PushSubscription)
     *  - reject(Error)
     */
    ServiceWorkerClass.prototype.enablePush = function (publicKey) {
        var _this = this;
        if (!this._registration)
            throw new Error('Service Worker not registered');
        this._publicKey = publicKey;
        return new Promise(function (resolve, reject) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__JS__["i" /* browserOrNode */])().isBrowser) {
                _this._registration.pushManager.getSubscription().then(function (subscription) {
                    if (subscription) {
                        _this._subscription = subscription;
                        _this._logger.debug("User is subscribed to push: " + JSON.stringify(subscription));
                        resolve(subscription);
                    }
                    else {
                        _this._logger.debug("User is NOT subscribed to push");
                        return _this._registration.pushManager
                            .subscribe({
                            userVisibleOnly: true,
                            applicationServerKey: _this._urlB64ToUint8Array(publicKey),
                        })
                            .then(function (subscription) {
                            _this._subscription = subscription;
                            _this._logger.debug("User subscribed: " + JSON.stringify(subscription));
                            resolve(subscription);
                        })
                            .catch(function (error) {
                            _this._logger.error(error);
                        });
                    }
                });
            }
            else {
                return reject(new Error('Service Worker not available'));
            }
        });
    };
    /**
     * Convert a base64 encoded string to a Uint8 array for the push server key
     * @param base64String
     */
    ServiceWorkerClass.prototype._urlB64ToUint8Array = function (base64String) {
        var padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        var base64 = (base64String + padding)
            .replace(/\-/g, '+')
            .replace(/_/g, '/');
        var rawData = window.atob(base64);
        var outputArray = new Uint8Array(rawData.length);
        for (var i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    };
    /**
     * Send a message to the service worker. The service worker needs
     * to implement `self.addEventListener('message') to handle the
     * message. This ***currently*** does not work in Safari or IE.
     * @param {object | string} - An arbitrary JSON object or string message to send to the service worker
     *	- see: https://developer.mozilla.org/en-US/docs/Web/API/Transferable
     * @returns {Promise}
     **/
    ServiceWorkerClass.prototype.send = function (message) {
        if (this._serviceWorker) {
            this._serviceWorker.postMessage(typeof message === 'object' ? JSON.stringify(message) : message);
        }
    };
    /**
     * Listen for service worker state change and message events
     * https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorker/state
     **/
    ServiceWorkerClass.prototype._setupListeners = function () {
        var _this = this;
        this._serviceWorker.addEventListener('statechange', function (event) {
            var currentState = _this._serviceWorker.state;
            _this._logger.debug("ServiceWorker statechange: " + currentState);
            if (__WEBPACK_IMPORTED_MODULE_2__Amplify__["b" /* Amplify */].Analytics && typeof __WEBPACK_IMPORTED_MODULE_2__Amplify__["b" /* Amplify */].Analytics.record === 'function') {
                __WEBPACK_IMPORTED_MODULE_2__Amplify__["b" /* Amplify */].Analytics.record({
                    name: 'ServiceWorker',
                    attributes: {
                        state: currentState,
                    },
                });
            }
        });
        this._serviceWorker.addEventListener('message', function (event) {
            _this._logger.debug("ServiceWorker message event: " + event);
        });
    };
    return ServiceWorkerClass;
}());

/**
 * @deprecated use named import
 */
/* unused harmony default export */ var _unused_webpack_default_export = (ServiceWorkerClass);
//# sourceMappingURL=ServiceWorker.js.map

/***/ }),
/* 1631 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ServiceWorker__ = __webpack_require__(1630);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ServiceWorker__["a"]; });
/**
 * Copyright 2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 1632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Signer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_crypto_sha256_js__ = __webpack_require__(1658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_crypto_sha256_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__aws_crypto_sha256_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_sdk_util_hex_encoding__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_url__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Util__ = __webpack_require__(301);
/*
 * Copyright 2017-2017 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};





var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger__["a" /* ConsoleLogger */]('Signer');
var DEFAULT_ALGORITHM = 'AWS4-HMAC-SHA256';
var IOT_SERVICE_NAME = 'iotdevicegateway';
var encrypt = function (key, src) {
    var hash = new __WEBPACK_IMPORTED_MODULE_1__aws_crypto_sha256_js__["Sha256"](key);
    hash.update(src);
    return hash.digestSync();
};
var hash = function (src) {
    var arg = src || '';
    var hash = new __WEBPACK_IMPORTED_MODULE_1__aws_crypto_sha256_js__["Sha256"]();
    hash.update(arg);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__aws_sdk_util_hex_encoding__["a" /* toHex */])(hash.digestSync());
};
/**
 * @private
 * RFC 3986 compliant version of encodeURIComponent
 */
var escape_RFC3986 = function (component) {
    return component.replace(/[!'()*]/g, function (c) {
        return ('%' +
            c
                .charCodeAt(0)
                .toString(16)
                .toUpperCase());
    });
};
/**
 * @private
 * Create canonical query string
 *
 */
var canonical_query = function (query) {
    if (!query || query.length === 0) {
        return '';
    }
    return query
        .split('&')
        .map(function (e) {
        var key_val = e.split('=');
        if (key_val.length === 1) {
            return e;
        }
        else {
            var reencoded_val = escape_RFC3986(key_val[1]);
            return key_val[0] + '=' + reencoded_val;
        }
    })
        .sort(function (a, b) {
        var key_a = a.split('=')[0];
        var key_b = b.split('=')[0];
        if (key_a === key_b) {
            return a < b ? -1 : 1;
        }
        else {
            return key_a < key_b ? -1 : 1;
        }
    })
        .join('&');
};
/**
* @private
* Create canonical headers
*
<pre>
CanonicalHeaders =
    CanonicalHeadersEntry0 + CanonicalHeadersEntry1 + ... + CanonicalHeadersEntryN
CanonicalHeadersEntry =
    Lowercase(HeaderName) + ':' + Trimall(HeaderValue) + '\n'
</pre>
*/
var canonical_headers = function (headers) {
    if (!headers || Object.keys(headers).length === 0) {
        return '';
    }
    return (Object.keys(headers)
        .map(function (key) {
        return {
            key: key.toLowerCase(),
            value: headers[key] ? headers[key].trim().replace(/\s+/g, ' ') : '',
        };
    })
        .sort(function (a, b) {
        return a.key < b.key ? -1 : 1;
    })
        .map(function (item) {
        return item.key + ':' + item.value;
    })
        .join('\n') + '\n');
};
/**
 * List of header keys included in the canonical headers.
 * @access private
 */
var signed_headers = function (headers) {
    return Object.keys(headers)
        .map(function (key) {
        return key.toLowerCase();
    })
        .sort()
        .join(';');
};
/**
* @private
* Create canonical request
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-canonical-request.html|Create a Canonical Request}
*
<pre>
CanonicalRequest =
    HTTPRequestMethod + '\n' +
    CanonicalURI + '\n' +
    CanonicalQueryString + '\n' +
    CanonicalHeaders + '\n' +
    SignedHeaders + '\n' +
    HexEncode(Hash(RequestPayload))
</pre>
*/
var canonical_request = function (request) {
    var url_info = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_url__["parse"])(request.url);
    return [
        request.method || '/',
        encodeURIComponent(url_info.pathname).replace(/%2F/gi, '/'),
        canonical_query(url_info.query),
        canonical_headers(request.headers),
        signed_headers(request.headers),
        hash(request.data),
    ].join('\n');
};
var parse_service_info = function (request) {
    var url_info = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_url__["parse"])(request.url), host = url_info.host;
    var matched = host.match(/([^\.]+)\.(?:([^\.]*)\.)?amazonaws\.com$/);
    var parsed = (matched || []).slice(1, 3);
    if (parsed[1] === 'es') {
        // Elastic Search
        parsed = parsed.reverse();
    }
    return {
        service: request.service || parsed[0],
        region: request.region || parsed[1],
    };
};
var credential_scope = function (d_str, region, service) {
    return [d_str, region, service, 'aws4_request'].join('/');
};
/**
* @private
* Create a string to sign
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-create-string-to-sign.html|Create String to Sign}
*
<pre>
StringToSign =
    Algorithm + \n +
    RequestDateTime + \n +
    CredentialScope + \n +
    HashedCanonicalRequest
</pre>
*/
var string_to_sign = function (algorithm, canonical_request, dt_str, scope) {
    return [algorithm, dt_str, scope, hash(canonical_request)].join('\n');
};
/**
* @private
* Create signing key
* Refer to
* {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-calculate-signature.html|Calculate Signature}
*
<pre>
kSecret = your secret access key
kDate = HMAC("AWS4" + kSecret, Date)
kRegion = HMAC(kDate, Region)
kService = HMAC(kRegion, Service)
kSigning = HMAC(kService, "aws4_request")
</pre>
*/
var get_signing_key = function (secret_key, d_str, service_info) {
    logger.debug(service_info);
    var k = 'AWS4' + secret_key, k_date = encrypt(k, d_str), k_region = encrypt(k_date, service_info.region), k_service = encrypt(k_region, service_info.service), k_signing = encrypt(k_service, 'aws4_request');
    return k_signing;
};
var get_signature = function (signing_key, str_to_sign) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__aws_sdk_util_hex_encoding__["a" /* toHex */])(encrypt(signing_key, str_to_sign));
};
/**
 * @private
 * Create authorization header
 * Refer to
 * {@link http://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html|Add the Signing Information}
 */
var get_authorization_header = function (algorithm, access_key, scope, signed_headers, signature) {
    return [
        algorithm + ' ' + 'Credential=' + access_key + '/' + scope,
        'SignedHeaders=' + signed_headers,
        'Signature=' + signature,
    ].join(', ');
};
var Signer = /** @class */ (function () {
    function Signer() {
    }
    /**
    * Sign a HTTP request, add 'Authorization' header to request param
    * @method sign
    * @memberof Signer
    * @static
    *
    * @param {object} request - HTTP request object
    <pre>
    request: {
        method: GET | POST | PUT ...
        url: ...,
        headers: {
            header1: ...
        },
        data: data
    }
    </pre>
    * @param {object} access_info - AWS access credential info
    <pre>
    access_info: {
        access_key: ...,
        secret_key: ...,
        session_token: ...
    }
    </pre>
    * @param {object} [service_info] - AWS service type and region, optional,
    *                                  if not provided then parse out from url
    <pre>
    service_info: {
        service: ...,
        region: ...
    }
    </pre>
    *
    * @returns {object} Signed HTTP request
    */
    Signer.sign = function (request, access_info, service_info) {
        if (service_info === void 0) { service_info = null; }
        request.headers = request.headers || {};
        // datetime string and date string
        var dt = __WEBPACK_IMPORTED_MODULE_4__Util__["f" /* DateUtils */].getDateWithClockOffset(), dt_str = dt.toISOString().replace(/[:\-]|\.\d{3}/g, ''), d_str = dt_str.substr(0, 8);
        var url_info = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_url__["parse"])(request.url);
        request.headers['host'] = url_info.host;
        request.headers['x-amz-date'] = dt_str;
        if (access_info.session_token) {
            request.headers['X-Amz-Security-Token'] = access_info.session_token;
        }
        // Task 1: Create a Canonical Request
        var request_str = canonical_request(request);
        logger.debug(request_str);
        // Task 2: Create a String to Sign
        var serviceInfo = service_info || parse_service_info(request), scope = credential_scope(d_str, serviceInfo.region, serviceInfo.service), str_to_sign = string_to_sign(DEFAULT_ALGORITHM, request_str, dt_str, scope);
        // Task 3: Calculate the Signature
        var signing_key = get_signing_key(access_info.secret_key, d_str, serviceInfo), signature = get_signature(signing_key, str_to_sign);
        // Task 4: Adding the Signing information to the Request
        var authorization_header = get_authorization_header(DEFAULT_ALGORITHM, access_info.access_key, scope, signed_headers(request.headers), signature);
        request.headers['Authorization'] = authorization_header;
        return request;
    };
    Signer.signUrl = function (urlOrRequest, accessInfo, serviceInfo, expiration) {
        var urlToSign = typeof urlOrRequest === 'object' ? urlOrRequest.url : urlOrRequest;
        var method = typeof urlOrRequest === 'object' ? urlOrRequest.method : 'GET';
        var body = typeof urlOrRequest === 'object' ? urlOrRequest.body : undefined;
        var now = __WEBPACK_IMPORTED_MODULE_4__Util__["f" /* DateUtils */].getDateWithClockOffset()
            .toISOString()
            .replace(/[:\-]|\.\d{3}/g, '');
        var today = now.substr(0, 8);
        // Intentionally discarding search
        var _a = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_url__["parse"])(urlToSign, true, true), search = _a.search, parsedUrl = __rest(_a, ["search"]);
        var host = parsedUrl.host;
        var signedHeaders = { host: host };
        var _b = serviceInfo || parse_service_info({ url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_url__["format"])(parsedUrl) }), region = _b.region, service = _b.service;
        var credentialScope = credential_scope(today, region, service);
        // IoT service does not allow the session token in the canonical request
        // https://docs.aws.amazon.com/general/latest/gr/sigv4-add-signature-to-request.html
        var sessionTokenRequired = accessInfo.session_token && service !== IOT_SERVICE_NAME;
        var queryParams = __assign(__assign(__assign({ 'X-Amz-Algorithm': DEFAULT_ALGORITHM, 'X-Amz-Credential': [accessInfo.access_key, credentialScope].join('/'), 'X-Amz-Date': now.substr(0, 16) }, (sessionTokenRequired
            ? { 'X-Amz-Security-Token': "" + accessInfo.session_token }
            : {})), (expiration ? { 'X-Amz-Expires': "" + expiration } : {})), { 'X-Amz-SignedHeaders': Object.keys(signedHeaders).join(',') });
        var canonicalRequest = canonical_request({
            method: method,
            url: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_url__["format"])(__assign(__assign({}, parsedUrl), { query: __assign(__assign({}, parsedUrl.query), queryParams) })),
            headers: signedHeaders,
            data: body,
        });
        var stringToSign = string_to_sign(DEFAULT_ALGORITHM, canonicalRequest, now, credentialScope);
        var signing_key = get_signing_key(accessInfo.secret_key, today, {
            region: region,
            service: service,
        });
        var signature = get_signature(signing_key, stringToSign);
        var additionalQueryParams = __assign({ 'X-Amz-Signature': signature }, (accessInfo.session_token && {
            'X-Amz-Security-Token': accessInfo.session_token,
        }));
        var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_url__["format"])({
            protocol: parsedUrl.protocol,
            slashes: true,
            hostname: parsedUrl.hostname,
            port: parsedUrl.port,
            pathname: parsedUrl.pathname,
            query: __assign(__assign(__assign({}, parsedUrl.query), queryParams), additionalQueryParams),
        });
        return result;
    };
    return Signer;
}());

/**
 * @deprecated use per-function import
 */
/* unused harmony default export */ var _unused_webpack_default_export = (Signer);
//# sourceMappingURL=Signer.js.map

/***/ }),
/* 1633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UniversalStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_universal_cookie__ = __webpack_require__(3514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__JS__ = __webpack_require__(213);


var isBrowser = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__JS__["i" /* browserOrNode */])().isBrowser;
var UniversalStorage = /** @class */ (function () {
    function UniversalStorage(context) {
        if (context === void 0) { context = {}; }
        this.cookies = new __WEBPACK_IMPORTED_MODULE_0_universal_cookie__["a" /* default */]();
        this.store = isBrowser ? window.localStorage : Object.create(null);
        this.cookies = context.req
            ? new __WEBPACK_IMPORTED_MODULE_0_universal_cookie__["a" /* default */](context.req.headers.cookie)
            : new __WEBPACK_IMPORTED_MODULE_0_universal_cookie__["a" /* default */]();
        Object.assign(this.store, this.cookies.getAll());
    }
    Object.defineProperty(UniversalStorage.prototype, "length", {
        get: function () {
            return Object.entries(this.store).length;
        },
        enumerable: true,
        configurable: true
    });
    UniversalStorage.prototype.clear = function () {
        var _this = this;
        Array.from(new Array(this.length))
            .map(function (_, i) { return _this.key(i); })
            .forEach(function (key) { return _this.removeItem(key); });
    };
    UniversalStorage.prototype.getItem = function (key) {
        return this.getLocalItem(key);
    };
    UniversalStorage.prototype.getLocalItem = function (key) {
        return Object.prototype.hasOwnProperty.call(this.store, key)
            ? this.store[key]
            : null;
    };
    UniversalStorage.prototype.getUniversalItem = function (key) {
        return this.cookies.get(key);
    };
    UniversalStorage.prototype.key = function (index) {
        return Object.keys(this.store)[index];
    };
    UniversalStorage.prototype.removeItem = function (key) {
        this.removeLocalItem(key);
        this.removeUniversalItem(key);
    };
    UniversalStorage.prototype.removeLocalItem = function (key) {
        delete this.store[key];
    };
    UniversalStorage.prototype.removeUniversalItem = function (key) {
        this.cookies.remove(key, {
            path: '/',
        });
    };
    UniversalStorage.prototype.setItem = function (key, value) {
        this.setLocalItem(key, value);
        // keys take the shape:
        //  1. `${ProviderPrefix}.${userPoolClientId}.${username}.${tokenType}
        //  2. `${ProviderPrefix}.${userPoolClientId}.LastAuthUser
        var tokenType = key.split('.').pop();
        switch (tokenType) {
            // LastAuthUser is needed for computing other key names
            case 'LastAuthUser':
            // accessToken is required for CognitoUserSession
            case 'accessToken':
            // Required for CognitoUserSession
            case 'idToken':
                this.setUniversalItem(key, value);
            // userData is used when `Auth.currentAuthenticatedUser({ bypassCache: false })`.
            // Can be persisted to speed up calls to `Auth.currentAuthenticatedUser()`
            // case 'userData':
            // refreshToken isn't shared with the server so that the client handles refreshing
            // case 'refreshToken':
            // Ignoring clockDrift on the server for now, but needs testing
            // case 'clockDrift':
        }
    };
    UniversalStorage.prototype.setLocalItem = function (key, value) {
        this.store[key] = value;
    };
    UniversalStorage.prototype.setUniversalItem = function (key, value) {
        this.cookies.set(key, value, {
            path: '/',
            // `httpOnly` cannot be set via JavaScript: https://developer.mozilla.org/en-US/docs/Web/HTTP/Cookies#JavaScript_access_using_Document.cookie
            sameSite: true,
            // Allow unsecure requests to http://localhost:3000/ when in development.
            secure: window.location.hostname === 'localhost' ? false : true,
        });
    };
    return UniversalStorage;
}());

//# sourceMappingURL=index.js.map

/***/ }),
/* 1634 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DateUtils; });
/**
 * Date & time utility functions to abstract the `aws-sdk` away from users.
 * (v2 => v3 modularization is a breaking change)
 *
 * @see https://github.com/aws/aws-sdk-js/blob/6edf586dcc1de7fe8fbfbbd9a0d2b1847921e6e1/lib/util.js#L262
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
// Comment - TODO: remove
var FIVE_MINUTES_IN_MS = 1000 * 60 * 5;
var DateUtils = {
    /**
     * Milliseconds to offset the date to compensate for clock skew between device & services
     */
    clockOffset: 0,
    getDateWithClockOffset: function () {
        if (DateUtils.clockOffset) {
            return new Date(new Date().getTime() + DateUtils.clockOffset);
        }
        else {
            return new Date();
        }
    },
    /**
     * @returns {number} Clock offset in milliseconds
     */
    getClockOffset: function () {
        return DateUtils.clockOffset;
    },
    getHeaderStringFromDate: function (date) {
        if (date === void 0) { date = DateUtils.getDateWithClockOffset(); }
        return date.toISOString().replace(/[:\-]|\.\d{3}/g, '');
    },
    getDateFromHeaderString: function (header) {
        var _a = __read(header.match(/^(\d{4})(\d{2})(\d{2})T(\d{2})(\d{2})(\d{2}).+/), 7), year = _a[1], month = _a[2], day = _a[3], hour = _a[4], minute = _a[5], second = _a[6];
        return new Date(Date.UTC(Number(year), Number(month) - 1, Number(day), Number(hour), Number(minute), Number(second)));
    },
    isClockSkewed: function (serverDate) {
        // API gateway permits client calls that are off by no more than ±5 minutes
        return (Math.abs(serverDate.getTime() - DateUtils.getDateWithClockOffset().getTime()) >= FIVE_MINUTES_IN_MS);
    },
    isClockSkewError: function (error) {
        if (!error.response || !error.response.headers) {
            return false;
        }
        var headers = error.response.headers;
        return Boolean(['BadRequestException', 'InvalidSignatureException'].includes(headers['x-amzn-errortype']) &&
            (headers.date || headers.Date));
    },
    /**
     * @param {number} offset Clock offset in milliseconds
     */
    setClockOffset: function (offset) {
        DateUtils.clockOffset = offset;
    },
};
//# sourceMappingURL=DateUtils.js.map

/***/ }),
/* 1635 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*!
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Christian Speckner <cnspeckn@googlemail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
var Mutex = /** @class */ (function () {
    function Mutex() {
        this._queue = [];
        this._pending = false;
    }
    Mutex.prototype.isLocked = function () {
        return this._pending;
    };
    Mutex.prototype.acquire = function () {
        var _this = this;
        var ticket = new Promise(function (resolve) {
            return _this._queue.push(resolve);
        });
        if (!this._pending) {
            this._dispatchNext();
        }
        return ticket;
    };
    Mutex.prototype.runExclusive = function (callback) {
        return this.acquire().then(function (release) {
            var result;
            try {
                result = callback();
            }
            catch (e) {
                release();
                throw e;
            }
            return Promise.resolve(result).then(function (x) { return (release(), x); }, function (e) {
                release();
                throw e;
            });
        });
    };
    Mutex.prototype._dispatchNext = function () {
        if (this._queue.length > 0) {
            this._pending = true;
            this._queue.shift()(this._dispatchNext.bind(this));
        }
        else {
            this._pending = false;
        }
    };
    return Mutex;
}());
/* harmony default export */ __webpack_exports__["a"] = (Mutex);
//# sourceMappingURL=Mutex.js.map

/***/ }),
/* 1636 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zen_observable_ts__ = __webpack_require__(363);
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};


var ReachabilityNavigator = /** @class */ (function () {
    function ReachabilityNavigator() {
    }
    ReachabilityNavigator.prototype.networkMonitor = function (netInfo) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["browserOrNode"])().isNode) {
            return __WEBPACK_IMPORTED_MODULE_1_zen_observable_ts__["a" /* default */].from([{ online: true }]);
        }
        var globalObj = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__aws_amplify_core__["isWebWorker"])() ? self : window;
        return new __WEBPACK_IMPORTED_MODULE_1_zen_observable_ts__["a" /* default */](function (observer) {
            observer.next({ online: globalObj.navigator.onLine });
            var notifyOnline = function () { return observer.next({ online: true }); };
            var notifyOffline = function () { return observer.next({ online: false }); };
            globalObj.addEventListener('online', notifyOnline);
            globalObj.addEventListener('offline', notifyOffline);
            ReachabilityNavigator._observers.push(observer);
            return function () {
                globalObj.removeEventListener('online', notifyOnline);
                globalObj.removeEventListener('offline', notifyOffline);
                ReachabilityNavigator._observers = ReachabilityNavigator._observers.filter(function (_observer) { return _observer !== observer; });
            };
        });
    };
    // expose observers to simulate offline mode for integration testing
    ReachabilityNavigator._observerOverride = function (status) {
        var e_1, _a;
        var _loop_1 = function (observer) {
            if (observer.closed) {
                ReachabilityNavigator._observers = ReachabilityNavigator._observers.filter(function (_observer) { return _observer !== observer; });
                return "continue";
            }
            observer.next(status);
        };
        try {
            for (var _b = __values(ReachabilityNavigator._observers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var observer = _c.value;
                _loop_1(observer);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    ReachabilityNavigator._observers = [];
    return ReachabilityNavigator;
}());
/* harmony default export */ __webpack_exports__["a"] = (ReachabilityNavigator);
//# sourceMappingURL=Reachability.js.map

/***/ }),
/* 1637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NonRetryableError; });
/* harmony export (immutable) */ __webpack_exports__["b"] = retry;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return jitteredExponentialRetry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Logger_ConsoleLogger__ = __webpack_require__(775);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};

var logger = new __WEBPACK_IMPORTED_MODULE_0__Logger_ConsoleLogger__["a" /* ConsoleLogger */]('Util');
var NonRetryableError = /** @class */ (function (_super) {
    __extends(NonRetryableError, _super);
    function NonRetryableError(message) {
        var _this = _super.call(this, message) || this;
        _this.nonRetryable = true;
        return _this;
    }
    return NonRetryableError;
}(Error));

var isNonRetryableError = function (obj) {
    var key = 'nonRetryable';
    return obj && obj[key];
};
/**
 * @private
 * Internal use of Amplify only
 */
function retry(functionToRetry, args, delayFn, attempt) {
    if (attempt === void 0) { attempt = 1; }
    return __awaiter(this, void 0, void 0, function () {
        var err_1, retryIn_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (typeof functionToRetry !== 'function') {
                        throw Error('functionToRetry must be a function');
                    }
                    logger.debug(functionToRetry.name + " attempt #" + attempt + " with this vars: " + JSON.stringify(args));
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 8]);
                    return [4 /*yield*/, functionToRetry.apply(void 0, __spread(args))];
                case 2: return [2 /*return*/, _a.sent()];
                case 3:
                    err_1 = _a.sent();
                    logger.debug("error on " + functionToRetry.name, err_1);
                    if (isNonRetryableError(err_1)) {
                        logger.debug(functionToRetry.name + " non retryable error", err_1);
                        throw err_1;
                    }
                    retryIn_1 = delayFn(attempt, args, err_1);
                    logger.debug(functionToRetry.name + " retrying in " + retryIn_1 + " ms");
                    if (!(retryIn_1 !== false)) return [3 /*break*/, 6];
                    return [4 /*yield*/, new Promise(function (res) { return setTimeout(res, retryIn_1); })];
                case 4:
                    _a.sent();
                    return [4 /*yield*/, retry(functionToRetry, args, delayFn, attempt + 1)];
                case 5: return [2 /*return*/, _a.sent()];
                case 6: throw err_1;
                case 7: return [3 /*break*/, 8];
                case 8: return [2 /*return*/];
            }
        });
    });
}
var MAX_DELAY_MS = 5 * 60 * 1000;
function jitteredBackoff(maxDelayMs) {
    var BASE_TIME_MS = 100;
    var JITTER_FACTOR = 100;
    return function (attempt) {
        var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
        return delay > maxDelayMs ? false : delay;
    };
}
/**
 * @private
 * Internal use of Amplify only
 */
var jitteredExponentialRetry = function (functionToRetry, args, maxDelayMs) {
    if (maxDelayMs === void 0) { maxDelayMs = MAX_DELAY_MS; }
    return retry(functionToRetry, args, jitteredBackoff(maxDelayMs));
};
//# sourceMappingURL=Retry.js.map

/***/ }),
/* 1638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = urlSafeEncode;
/* harmony export (immutable) */ __webpack_exports__["b"] = urlSafeDecode;
function urlSafeEncode(str) {
    return str
        .split('')
        .map(function (char) {
        return char
            .charCodeAt(0)
            .toString(16)
            .padStart(2, '0');
    })
        .join('');
}
function urlSafeDecode(hex) {
    return hex
        .match(/.{2}/g)
        .map(function (char) { return String.fromCharCode(parseInt(char, 16)); })
        .join('');
}
//# sourceMappingURL=StringUtils.js.map

/***/ }),
/* 1639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AWSAppSyncProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MqttOverWSProvider__ = __webpack_require__(512);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};



var logger = new __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["ConsoleLogger"]('AWSAppSyncProvider');
var AWSAppSyncProvider = /** @class */ (function (_super) {
    __extends(AWSAppSyncProvider, _super);
    function AWSAppSyncProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._topicClient = new Map();
        _this._topicAlias = new Map();
        return _this;
    }
    Object.defineProperty(AWSAppSyncProvider.prototype, "endpoint", {
        get: function () {
            throw new Error('Not supported');
        },
        enumerable: true,
        configurable: true
    });
    AWSAppSyncProvider.prototype.getProviderName = function () {
        return 'AWSAppSyncProvider';
    };
    AWSAppSyncProvider.prototype.publish = function (topics, msg, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('Operation not supported');
            });
        });
    };
    AWSAppSyncProvider.prototype._cleanUp = function (clientId) {
        var _this = this;
        var topicsForClient = Array.from(this._topicClient.entries())
            .filter(function (_a) {
            var _b = __read(_a, 2), c = _b[1];
            return c.clientId === clientId;
        })
            .map(function (_a) {
            var _b = __read(_a, 1), t = _b[0];
            return t;
        });
        topicsForClient.forEach(function (t) { return _this._cleanUpForTopic(t); });
    };
    AWSAppSyncProvider.prototype._cleanUpForTopic = function (topic) {
        this._topicClient.delete(topic);
        this._topicAlias.delete(topic);
    };
    AWSAppSyncProvider.prototype.onDisconnect = function (_a) {
        var _this = this;
        var clientId = _a.clientId, errorCode = _a.errorCode, args = __rest(_a, ["clientId", "errorCode"]);
        if (errorCode !== 0) {
            var topicsForClient = Array.from(this._topicClient.entries())
                .filter(function (_a) {
                var _b = __read(_a, 2), c = _b[1];
                return c.clientId === clientId;
            })
                .map(function (_a) {
                var _b = __read(_a, 1), t = _b[0];
                return t;
            });
            topicsForClient.forEach(function (topic) {
                if (_this._topicObservers.has(topic)) {
                    _this._topicObservers.get(topic).forEach(function (obs) {
                        if (!obs.closed) {
                            obs.error(args);
                        }
                    });
                    _this._topicObservers.delete(topic);
                }
            });
            this._cleanUp(clientId);
        }
    };
    AWSAppSyncProvider.prototype.disconnect = function (clientId) {
        return __awaiter(this, void 0, void 0, function () {
            var client;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.clientsQueue.get(clientId, function () { return null; })];
                    case 1:
                        client = _a.sent();
                        return [4 /*yield*/, _super.prototype.disconnect.call(this, clientId)];
                    case 2:
                        _a.sent();
                        this._cleanUp(clientId);
                        return [2 /*return*/];
                }
            });
        });
    };
    AWSAppSyncProvider.prototype.subscribe = function (topics, options) {
        var _this = this;
        if (options === void 0) { options = {}; }
        var result = new __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */](function (observer) {
            var targetTopics = [].concat(topics);
            logger.debug('Subscribing to topic(s)', targetTopics.join(','));
            (function () { return __awaiter(_this, void 0, void 0, function () {
                var _a, mqttConnections, newSubscriptions, newAliases, map;
                var _this = this;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            // Add these topics to map
                            targetTopics.forEach(function (t) {
                                if (!_this._topicObservers.has(t)) {
                                    _this._topicObservers.set(t, new Set());
                                }
                                _this._topicObservers.get(t).add(observer);
                            });
                            _a = options.mqttConnections, mqttConnections = _a === void 0 ? [] : _a, newSubscriptions = options.newSubscriptions;
                            newAliases = Object.entries(newSubscriptions).map(function (_a) {
                                var _b = __read(_a, 2), alias = _b[0], v = _b[1];
                                return [v.topic, alias];
                            });
                            // Merge new aliases with old ones
                            this._topicAlias = new Map(__spread(Array.from(this._topicAlias.entries()), newAliases));
                            map = Object.entries(targetTopics.reduce(function (acc, elem) {
                                var connectionInfoForTopic = mqttConnections.find(function (c) { return c.topics.indexOf(elem) > -1; });
                                if (connectionInfoForTopic) {
                                    var clientId = connectionInfoForTopic.client, url = connectionInfoForTopic.url;
                                    if (!acc[clientId]) {
                                        acc[clientId] = {
                                            url: url,
                                            topics: new Set(),
                                        };
                                    }
                                    acc[clientId].topics.add(elem);
                                }
                                return acc;
                            }, {}));
                            // reconnect everything we have in the map
                            return [4 /*yield*/, Promise.all(map.map(function (_a) {
                                    var _b = __read(_a, 2), clientId = _b[0], _c = _b[1], url = _c.url, topics = _c.topics;
                                    return __awaiter(_this, void 0, void 0, function () {
                                        var client, err_1;
                                        var _this = this;
                                        return __generator(this, function (_d) {
                                            switch (_d.label) {
                                                case 0:
                                                    client = null;
                                                    _d.label = 1;
                                                case 1:
                                                    _d.trys.push([1, 3, , 4]);
                                                    return [4 /*yield*/, this.connect(clientId, {
                                                            clientId: clientId,
                                                            url: url,
                                                        })];
                                                case 2:
                                                    client = _d.sent();
                                                    return [3 /*break*/, 4];
                                                case 3:
                                                    err_1 = _d.sent();
                                                    observer.error({ message: 'Failed to connect', error: err_1 });
                                                    observer.complete();
                                                    return [2 /*return*/, undefined];
                                                case 4:
                                                    // subscribe to all topics for this client
                                                    // store topic-client mapping
                                                    topics.forEach(function (topic) {
                                                        if (client.isConnected()) {
                                                            client.subscribe(topic);
                                                            _this._topicClient.set(topic, client);
                                                        }
                                                    });
                                                    return [2 /*return*/, client];
                                            }
                                        });
                                    });
                                }))];
                        case 1:
                            // reconnect everything we have in the map
                            _b.sent();
                            return [2 /*return*/];
                    }
                });
            }); })();
            return function () {
                logger.debug('Unsubscribing from topic(s)', targetTopics.join(','));
                targetTopics.forEach(function (t) {
                    var client = _this._topicClient.get(t);
                    if (client && client.isConnected()) {
                        client.unsubscribe(t);
                        _this._topicClient.delete(t);
                        if (!Array.from(_this._topicClient.values()).some(function (c) { return c === client; })) {
                            _this.disconnect(client.clientId);
                        }
                    }
                    _this._topicObservers.delete(t);
                });
            };
        });
        return __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */].from(result).map(function (value) {
            var topic = _this.getTopicForValue(value);
            var alias = _this._topicAlias.get(topic);
            value.data = Object.entries(value.data).reduce(function (obj, _a) {
                var _b = __read(_a, 2), origKey = _b[0], val = _b[1];
                return ((obj[(alias || origKey)] = val), obj);
            }, {});
            return value;
        });
    };
    return AWSAppSyncProvider;
}(__WEBPACK_IMPORTED_MODULE_2__MqttOverWSProvider__["a" /* MqttOverWSProvider */]));

//# sourceMappingURL=AWSAppSyncProvider.js.map

/***/ }),
/* 1640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AWSAppSyncRealTimeProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_graphql__ = __webpack_require__(2972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_url___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_url__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_buffer__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_buffer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_buffer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_amplify_core__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__aws_amplify_cache__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__aws_amplify_auth__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PubSubProvider__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index__ = __webpack_require__(780);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/*
 * Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */










var logger = new __WEBPACK_IMPORTED_MODULE_5__aws_amplify_core__["Logger"]('AWSAppSyncRealTimeProvider');
var AMPLIFY_SYMBOL = (typeof Symbol !== 'undefined' &&
    typeof Symbol.for === 'function'
    ? Symbol.for('amplify_default')
    : '@@amplify_default');
var dispatchApiEvent = function (event, data, message) {
    __WEBPACK_IMPORTED_MODULE_5__aws_amplify_core__["Hub"].dispatch('api', { event: event, data: data, message: message }, 'PubSub', AMPLIFY_SYMBOL);
};
var MAX_DELAY_MS = 5000;
var NON_RETRYABLE_CODES = [400, 401, 403];
var MESSAGE_TYPES;
(function (MESSAGE_TYPES) {
    /**
     * Client -> Server message.
     * This message type is the first message after handshake and this will initialize AWS AppSync RealTime communication
     */
    MESSAGE_TYPES["GQL_CONNECTION_INIT"] = "connection_init";
    /**
     * Server -> Client message
     * This message type is in case there is an issue with AWS AppSync RealTime when establishing connection
     */
    MESSAGE_TYPES["GQL_CONNECTION_ERROR"] = "connection_error";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_CONNECTION_INIT message
     */
    MESSAGE_TYPES["GQL_CONNECTION_ACK"] = "connection_ack";
    /**
     * Client -> Server message.
     * This message type is for register subscriptions with AWS AppSync RealTime
     */
    MESSAGE_TYPES["GQL_START"] = "start";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_START message
     */
    MESSAGE_TYPES["GQL_START_ACK"] = "start_ack";
    /**
     * Server -> Client message.
     * This message type is for subscription message from AWS AppSync RealTime
     */
    MESSAGE_TYPES["GQL_DATA"] = "data";
    /**
     * Server -> Client message.
     * This message type helps the client to know is still receiving messages from AWS AppSync RealTime
     */
    MESSAGE_TYPES["GQL_CONNECTION_KEEP_ALIVE"] = "ka";
    /**
     * Client -> Server message.
     * This message type is for unregister subscriptions with AWS AppSync RealTime
     */
    MESSAGE_TYPES["GQL_STOP"] = "stop";
    /**
     * Server -> Client message.
     * This message type is for the ack response from AWS AppSync RealTime for GQL_STOP message
     */
    MESSAGE_TYPES["GQL_COMPLETE"] = "complete";
    /**
     * Server -> Client message.
     * This message type is for sending error messages from AWS AppSync RealTime to the client
     */
    MESSAGE_TYPES["GQL_ERROR"] = "error";
})(MESSAGE_TYPES || (MESSAGE_TYPES = {}));
var SUBSCRIPTION_STATUS;
(function (SUBSCRIPTION_STATUS) {
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["PENDING"] = 0] = "PENDING";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["CONNECTED"] = 1] = "CONNECTED";
    SUBSCRIPTION_STATUS[SUBSCRIPTION_STATUS["FAILED"] = 2] = "FAILED";
})(SUBSCRIPTION_STATUS || (SUBSCRIPTION_STATUS = {}));
var SOCKET_STATUS;
(function (SOCKET_STATUS) {
    SOCKET_STATUS[SOCKET_STATUS["CLOSED"] = 0] = "CLOSED";
    SOCKET_STATUS[SOCKET_STATUS["READY"] = 1] = "READY";
    SOCKET_STATUS[SOCKET_STATUS["CONNECTING"] = 2] = "CONNECTING";
})(SOCKET_STATUS || (SOCKET_STATUS = {}));
var AWS_APPSYNC_REALTIME_HEADERS = {
    accept: 'application/json, text/javascript',
    'content-encoding': 'amz-1.0',
    'content-type': 'application/json; charset=UTF-8',
};
/**
 * Time in milleseconds to wait for GQL_CONNECTION_INIT message
 */
var CONNECTION_INIT_TIMEOUT = 15000;
/**
 * Time in milleseconds to wait for GQL_START_ACK message
 */
var START_ACK_TIMEOUT = 15000;
/**
 * Default Time in milleseconds to wait for GQL_CONNECTION_KEEP_ALIVE message
 */
var DEFAULT_KEEP_ALIVE_TIMEOUT = 5 * 60 * 1000;
var AWSAppSyncRealTimeProvider = /** @class */ (function (_super) {
    __extends(AWSAppSyncRealTimeProvider, _super);
    function AWSAppSyncRealTimeProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.socketStatus = SOCKET_STATUS.CLOSED;
        _this.keepAliveTimeout = DEFAULT_KEEP_ALIVE_TIMEOUT;
        _this.subscriptionObserverMap = new Map();
        _this.promiseArray = [];
        return _this;
    }
    AWSAppSyncRealTimeProvider.prototype.getProviderName = function () {
        return 'AWSAppSyncRealTimeProvider';
    };
    AWSAppSyncRealTimeProvider.prototype.newClient = function () {
        throw new Error('Not used here');
    };
    AWSAppSyncRealTimeProvider.prototype.publish = function (_topics, _msg, _options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('Operation not supported');
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype.subscribe = function (_topics, options) {
        var _this = this;
        var appSyncGraphqlEndpoint = options.appSyncGraphqlEndpoint;
        return new __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */](function (observer) {
            if (!appSyncGraphqlEndpoint) {
                observer.error({
                    errors: [
                        __assign({}, new __WEBPACK_IMPORTED_MODULE_1_graphql__["a" /* GraphQLError */]("Subscribe only available for AWS AppSync endpoint")),
                    ],
                });
                observer.complete();
            }
            else {
                var subscriptionId_1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_uuid__["v4"])();
                _this._startSubscriptionWithAWSAppSyncRealTime({
                    options: options,
                    observer: observer,
                    subscriptionId: subscriptionId_1,
                }).catch(function (err) {
                    observer.error({
                        errors: [
                            __assign({}, new __WEBPACK_IMPORTED_MODULE_1_graphql__["a" /* GraphQLError */](__WEBPACK_IMPORTED_MODULE_9__index__["b" /* CONTROL_MSG */].REALTIME_SUBSCRIPTION_INIT_ERROR + ": " + err)),
                        ],
                    });
                    observer.complete();
                });
                return function () { return __awaiter(_this, void 0, void 0, function () {
                    var subscriptionState, err_1;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, 3, 4]);
                                // Waiting that subscription has been connected before trying to unsubscribe
                                return [4 /*yield*/, this._waitForSubscriptionToBeConnected(subscriptionId_1)];
                            case 1:
                                // Waiting that subscription has been connected before trying to unsubscribe
                                _a.sent();
                                subscriptionState = (this.subscriptionObserverMap.get(subscriptionId_1) || {}).subscriptionState;
                                if (!subscriptionState) {
                                    // subscription already unsubscribed
                                    return [2 /*return*/];
                                }
                                if (subscriptionState === SUBSCRIPTION_STATUS.CONNECTED) {
                                    this._sendUnsubscriptionMessage(subscriptionId_1);
                                }
                                else {
                                    throw new Error('Subscription never connected');
                                }
                                return [3 /*break*/, 4];
                            case 2:
                                err_1 = _a.sent();
                                logger.debug("Error while unsubscribing " + err_1);
                                return [3 /*break*/, 4];
                            case 3:
                                this._removeSubscriptionObserver(subscriptionId_1);
                                return [7 /*endfinally*/];
                            case 4: return [2 /*return*/];
                        }
                    });
                }); };
            }
        });
    };
    Object.defineProperty(AWSAppSyncRealTimeProvider.prototype, "isSSLEnabled", {
        get: function () {
            return !this.options
                .aws_appsync_dangerously_connect_to_http_endpoint_for_testing;
        },
        enumerable: true,
        configurable: true
    });
    AWSAppSyncRealTimeProvider.prototype._startSubscriptionWithAWSAppSyncRealTime = function (_a) {
        var options = _a.options, observer = _a.observer, subscriptionId = _a.subscriptionId;
        return __awaiter(this, void 0, void 0, function () {
            var appSyncGraphqlEndpoint, authenticationType, query, variables, apiKey, region, _b, graphql_headers, _c, additionalHeaders, subscriptionState, data, dataString, headerObj, _d, _e, subscriptionMessage, stringToAWSRealTime, err_2, _f, message, subscriptionFailedCallback_1, _g, subscriptionFailedCallback, subscriptionReadyCallback;
            var _h;
            var _this = this;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        appSyncGraphqlEndpoint = options.appSyncGraphqlEndpoint, authenticationType = options.authenticationType, query = options.query, variables = options.variables, apiKey = options.apiKey, region = options.region, _b = options.graphql_headers, graphql_headers = _b === void 0 ? function () { return ({}); } : _b, _c = options.additionalHeaders, additionalHeaders = _c === void 0 ? {} : _c;
                        subscriptionState = SUBSCRIPTION_STATUS.PENDING;
                        data = {
                            query: query,
                            variables: variables,
                        };
                        // Having a subscription id map will make it simple to forward messages received
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            query: query,
                            variables: variables,
                            subscriptionState: subscriptionState,
                            startAckTimeoutId: null,
                        });
                        dataString = JSON.stringify(data);
                        _d = [{}];
                        return [4 /*yield*/, this._awsRealTimeHeaderBasedAuth({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                payload: dataString,
                                canonicalUri: '',
                                region: region,
                            })];
                    case 1:
                        _e = [__assign.apply(void 0, _d.concat([(_j.sent())]))];
                        return [4 /*yield*/, graphql_headers()];
                    case 2:
                        headerObj = __assign.apply(void 0, [__assign.apply(void 0, [__assign.apply(void 0, _e.concat([(_j.sent())])), additionalHeaders]), (_h = {}, _h[__WEBPACK_IMPORTED_MODULE_5__aws_amplify_core__["USER_AGENT_HEADER"]] = __WEBPACK_IMPORTED_MODULE_5__aws_amplify_core__["Constants"].userAgent, _h)]);
                        subscriptionMessage = {
                            id: subscriptionId,
                            payload: {
                                data: dataString,
                                extensions: {
                                    authorization: __assign({}, headerObj),
                                },
                            },
                            type: MESSAGE_TYPES.GQL_START,
                        };
                        stringToAWSRealTime = JSON.stringify(subscriptionMessage);
                        _j.label = 3;
                    case 3:
                        _j.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, this._initializeWebSocketConnection({
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                authenticationType: authenticationType,
                                region: region,
                            })];
                    case 4:
                        _j.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        err_2 = _j.sent();
                        logger.debug({ err: err_2 });
                        _f = err_2.message, message = _f === void 0 ? '' : _f;
                        observer.error({
                            errors: [
                                __assign({}, new __WEBPACK_IMPORTED_MODULE_1_graphql__["a" /* GraphQLError */](__WEBPACK_IMPORTED_MODULE_9__index__["b" /* CONTROL_MSG */].CONNECTION_FAILED + ": " + message)),
                            ],
                        });
                        observer.complete();
                        subscriptionFailedCallback_1 = (this.subscriptionObserverMap.get(subscriptionId) || {}).subscriptionFailedCallback;
                        // Notify concurrent unsubscription
                        if (typeof subscriptionFailedCallback_1 === 'function') {
                            subscriptionFailedCallback_1();
                        }
                        return [2 /*return*/];
                    case 6:
                        _g = this.subscriptionObserverMap.get(subscriptionId), subscriptionFailedCallback = _g.subscriptionFailedCallback, subscriptionReadyCallback = _g.subscriptionReadyCallback;
                        // This must be done before sending the message in order to be listening immediately
                        this.subscriptionObserverMap.set(subscriptionId, {
                            observer: observer,
                            subscriptionState: subscriptionState,
                            variables: variables,
                            query: query,
                            subscriptionReadyCallback: subscriptionReadyCallback,
                            subscriptionFailedCallback: subscriptionFailedCallback,
                            startAckTimeoutId: setTimeout(function () {
                                _this._timeoutStartSubscriptionAck.call(_this, subscriptionId);
                            }, START_ACK_TIMEOUT),
                        });
                        if (this.awsRealTimeSocket) {
                            this.awsRealTimeSocket.send(stringToAWSRealTime);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    // Waiting that subscription has been connected before trying to unsubscribe
    AWSAppSyncRealTimeProvider.prototype._waitForSubscriptionToBeConnected = function (subscriptionId) {
        return __awaiter(this, void 0, void 0, function () {
            var subscriptionState;
            var _this = this;
            return __generator(this, function (_a) {
                subscriptionState = this.subscriptionObserverMap.get(subscriptionId).subscriptionState;
                // This in case unsubscribe is invoked before sending start subscription message
                if (subscriptionState === SUBSCRIPTION_STATUS.PENDING) {
                    return [2 /*return*/, new Promise(function (res, rej) {
                            var _a = _this.subscriptionObserverMap.get(subscriptionId), observer = _a.observer, subscriptionState = _a.subscriptionState, variables = _a.variables, query = _a.query;
                            _this.subscriptionObserverMap.set(subscriptionId, {
                                observer: observer,
                                subscriptionState: subscriptionState,
                                variables: variables,
                                query: query,
                                subscriptionReadyCallback: res,
                                subscriptionFailedCallback: rej,
                            });
                        })];
                }
                return [2 /*return*/];
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._sendUnsubscriptionMessage = function (subscriptionId) {
        try {
            if (this.awsRealTimeSocket &&
                this.awsRealTimeSocket.readyState === WebSocket.OPEN &&
                this.socketStatus === SOCKET_STATUS.READY) {
                // Preparing unsubscribe message to stop receiving messages for that subscription
                var unsubscribeMessage = {
                    id: subscriptionId,
                    type: MESSAGE_TYPES.GQL_STOP,
                };
                var stringToAWSRealTime = JSON.stringify(unsubscribeMessage);
                this.awsRealTimeSocket.send(stringToAWSRealTime);
            }
        }
        catch (err) {
            // If GQL_STOP is not sent because of disconnection issue, then there is nothing the client can do
            logger.debug({ err: err });
        }
    };
    AWSAppSyncRealTimeProvider.prototype._removeSubscriptionObserver = function (subscriptionId) {
        this.subscriptionObserverMap.delete(subscriptionId);
        // Verifying 1000ms after removing subscription in case there are new subscription unmount/mount
        setTimeout(this._closeSocketIfRequired.bind(this), 1000);
    };
    AWSAppSyncRealTimeProvider.prototype._closeSocketIfRequired = function () {
        if (this.subscriptionObserverMap.size > 0) {
            // Active subscriptions on the WebSocket
            return;
        }
        if (!this.awsRealTimeSocket) {
            this.socketStatus = SOCKET_STATUS.CLOSED;
            return;
        }
        if (this.awsRealTimeSocket.bufferedAmount > 0) {
            // Still data on the WebSocket
            setTimeout(this._closeSocketIfRequired.bind(this), 1000);
        }
        else {
            logger.debug('closing WebSocket...');
            clearTimeout(this.keepAliveTimeoutId);
            var tempSocket = this.awsRealTimeSocket;
            // Cleaning callbacks to avoid race condition, socket still exists
            tempSocket.onclose = undefined;
            tempSocket.onerror = undefined;
            tempSocket.close(1000);
            this.awsRealTimeSocket = null;
            this.socketStatus = SOCKET_STATUS.CLOSED;
        }
    };
    AWSAppSyncRealTimeProvider.prototype._handleIncomingSubscriptionMessage = function (message) {
        logger.debug("subscription message from AWS AppSync RealTime: " + message.data);
        var _a = JSON.parse(message.data), _b = _a.id, id = _b === void 0 ? '' : _b, payload = _a.payload, type = _a.type;
        var _c = this.subscriptionObserverMap.get(id) || {}, _d = _c.observer, observer = _d === void 0 ? null : _d, _e = _c.query, query = _e === void 0 ? '' : _e, _f = _c.variables, variables = _f === void 0 ? {} : _f, startAckTimeoutId = _c.startAckTimeoutId, subscriptionReadyCallback = _c.subscriptionReadyCallback, subscriptionFailedCallback = _c.subscriptionFailedCallback;
        logger.debug({ id: id, observer: observer, query: query, variables: variables });
        if (type === MESSAGE_TYPES.GQL_DATA && payload && payload.data) {
            if (observer) {
                observer.next(payload);
            }
            else {
                logger.debug("observer not found for id: " + id);
            }
            return;
        }
        if (type === MESSAGE_TYPES.GQL_START_ACK) {
            logger.debug("subscription ready for " + JSON.stringify({ query: query, variables: variables }));
            if (typeof subscriptionReadyCallback === 'function') {
                subscriptionReadyCallback();
            }
            clearTimeout(startAckTimeoutId);
            dispatchApiEvent(__WEBPACK_IMPORTED_MODULE_9__index__["b" /* CONTROL_MSG */].SUBSCRIPTION_ACK, { query: query, variables: variables }, 'Connection established for subscription');
            var subscriptionState = SUBSCRIPTION_STATUS.CONNECTED;
            this.subscriptionObserverMap.set(id, {
                observer: observer,
                query: query,
                variables: variables,
                startAckTimeoutId: null,
                subscriptionState: subscriptionState,
                subscriptionReadyCallback: subscriptionReadyCallback,
                subscriptionFailedCallback: subscriptionFailedCallback,
            });
            // TODO: emit event on hub but it requires to store the id first
            return;
        }
        if (type === MESSAGE_TYPES.GQL_CONNECTION_KEEP_ALIVE) {
            clearTimeout(this.keepAliveTimeoutId);
            this.keepAliveTimeoutId = setTimeout(this._errorDisconnect.bind(this, __WEBPACK_IMPORTED_MODULE_9__index__["b" /* CONTROL_MSG */].TIMEOUT_DISCONNECT), this.keepAliveTimeout);
            return;
        }
        if (type === MESSAGE_TYPES.GQL_ERROR) {
            var subscriptionState = SUBSCRIPTION_STATUS.FAILED;
            this.subscriptionObserverMap.set(id, {
                observer: observer,
                query: query,
                variables: variables,
                startAckTimeoutId: startAckTimeoutId,
                subscriptionReadyCallback: subscriptionReadyCallback,
                subscriptionFailedCallback: subscriptionFailedCallback,
                subscriptionState: subscriptionState,
            });
            observer.error({
                errors: [
                    __assign({}, new __WEBPACK_IMPORTED_MODULE_1_graphql__["a" /* GraphQLError */](__WEBPACK_IMPORTED_MODULE_9__index__["b" /* CONTROL_MSG */].CONNECTION_FAILED + ": " + JSON.stringify(payload))),
                ],
            });
            clearTimeout(startAckTimeoutId);
            observer.complete();
            if (typeof subscriptionFailedCallback === 'function') {
                subscriptionFailedCallback();
            }
        }
    };
    AWSAppSyncRealTimeProvider.prototype._errorDisconnect = function (msg) {
        logger.debug("Disconnect error: " + msg);
        this.subscriptionObserverMap.forEach(function (_a) {
            var observer = _a.observer;
            if (observer && !observer.closed) {
                observer.error({
                    errors: [__assign({}, new __WEBPACK_IMPORTED_MODULE_1_graphql__["a" /* GraphQLError */](msg))],
                });
            }
        });
        this.subscriptionObserverMap.clear();
        if (this.awsRealTimeSocket) {
            this.awsRealTimeSocket.close();
        }
        this.socketStatus = SOCKET_STATUS.CLOSED;
    };
    AWSAppSyncRealTimeProvider.prototype._timeoutStartSubscriptionAck = function (subscriptionId) {
        var _a = this.subscriptionObserverMap.get(subscriptionId) || {}, observer = _a.observer, query = _a.query, variables = _a.variables;
        if (!observer) {
            return;
        }
        this.subscriptionObserverMap.set(subscriptionId, {
            observer: observer,
            query: query,
            variables: variables,
            subscriptionState: SUBSCRIPTION_STATUS.FAILED,
        });
        if (observer && !observer.closed) {
            observer.error({
                errors: [
                    __assign({}, new __WEBPACK_IMPORTED_MODULE_1_graphql__["a" /* GraphQLError */]("Subscription timeout " + JSON.stringify({ query: query, variables: variables }))),
                ],
            });
            // Cleanup will be automatically executed
            observer.complete();
        }
        logger.debug('timeoutStartSubscription', JSON.stringify({ query: query, variables: variables }));
    };
    AWSAppSyncRealTimeProvider.prototype._initializeWebSocketConnection = function (_a) {
        var _this = this;
        var appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, authenticationType = _a.authenticationType, apiKey = _a.apiKey, region = _a.region;
        if (this.socketStatus === SOCKET_STATUS.READY) {
            return;
        }
        return new Promise(function (res, rej) { return __awaiter(_this, void 0, void 0, function () {
            var protocol, discoverableEndpoint, payloadString, headerString, _a, _b, headerQs, payloadQs, awsRealTimeUrl, err_3;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        this.promiseArray.push({ res: res, rej: rej });
                        if (!(this.socketStatus === SOCKET_STATUS.CLOSED)) return [3 /*break*/, 5];
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 4, , 5]);
                        this.socketStatus = SOCKET_STATUS.CONNECTING;
                        protocol = this.isSSLEnabled ? 'wss://' : 'ws://';
                        discoverableEndpoint = appSyncGraphqlEndpoint
                            .replace('https://', protocol)
                            .replace('http://', protocol)
                            .replace('appsync-api', 'appsync-realtime-api')
                            .replace('gogi-beta', 'grt-beta');
                        payloadString = '{}';
                        _b = (_a = JSON).stringify;
                        return [4 /*yield*/, this._awsRealTimeHeaderBasedAuth({
                                authenticationType: authenticationType,
                                payload: payloadString,
                                canonicalUri: '/connect',
                                apiKey: apiKey,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                region: region,
                            })];
                    case 2:
                        headerString = _b.apply(_a, [_c.sent()]);
                        headerQs = __WEBPACK_IMPORTED_MODULE_4_buffer__["Buffer"].from(headerString).toString('base64');
                        payloadQs = __WEBPACK_IMPORTED_MODULE_4_buffer__["Buffer"].from(payloadString).toString('base64');
                        awsRealTimeUrl = discoverableEndpoint + "?header=" + headerQs + "&payload=" + payloadQs;
                        return [4 /*yield*/, this._initializeRetryableHandshake({ awsRealTimeUrl: awsRealTimeUrl })];
                    case 3:
                        _c.sent();
                        this.promiseArray.forEach(function (_a) {
                            var res = _a.res;
                            logger.debug('Notifying connection successful');
                            res();
                        });
                        this.socketStatus = SOCKET_STATUS.READY;
                        this.promiseArray = [];
                        return [3 /*break*/, 5];
                    case 4:
                        err_3 = _c.sent();
                        this.promiseArray.forEach(function (_a) {
                            var rej = _a.rej;
                            return rej(err_3);
                        });
                        this.promiseArray = [];
                        if (this.awsRealTimeSocket &&
                            this.awsRealTimeSocket.readyState === WebSocket.OPEN) {
                            this.awsRealTimeSocket.close(3001);
                        }
                        this.awsRealTimeSocket = null;
                        this.socketStatus = SOCKET_STATUS.CLOSED;
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        }); });
    };
    AWSAppSyncRealTimeProvider.prototype._initializeRetryableHandshake = function (_a) {
        var awsRealTimeUrl = _a.awsRealTimeUrl;
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        logger.debug("Initializaling retryable Handshake");
                        return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__aws_amplify_core__["jitteredExponentialRetry"])(this._initializeHandshake.bind(this), [{ awsRealTimeUrl: awsRealTimeUrl }], MAX_DELAY_MS)];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._initializeHandshake = function (_a) {
        var awsRealTimeUrl = _a.awsRealTimeUrl;
        return __awaiter(this, void 0, void 0, function () {
            var err_4, errorType, errorCode;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        logger.debug("Initializing handshake " + awsRealTimeUrl);
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, (function () {
                                return new Promise(function (res, rej) {
                                    var newSocket = new WebSocket(awsRealTimeUrl, 'graphql-ws');
                                    newSocket.onerror = function () {
                                        logger.debug("WebSocket connection error");
                                    };
                                    newSocket.onclose = function () {
                                        rej(new Error('Connection handshake error'));
                                    };
                                    newSocket.onopen = function () {
                                        _this.awsRealTimeSocket = newSocket;
                                        return res();
                                    };
                                });
                            })()];
                    case 2:
                        _b.sent();
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        return [4 /*yield*/, (function () {
                                return new Promise(function (res, rej) {
                                    var ackOk = false;
                                    _this.awsRealTimeSocket.onerror = function (error) {
                                        logger.debug("WebSocket error " + JSON.stringify(error));
                                    };
                                    _this.awsRealTimeSocket.onclose = function (event) {
                                        logger.debug("WebSocket closed " + event.reason);
                                        rej(new Error(JSON.stringify(event)));
                                    };
                                    _this.awsRealTimeSocket.onmessage = function (message) {
                                        logger.debug("subscription message from AWS AppSyncRealTime: " + message.data + " ");
                                        var data = JSON.parse(message.data);
                                        var type = data.type, _a = data.payload, _b = (_a === void 0 ? {} : _a).connectionTimeoutMs, connectionTimeoutMs = _b === void 0 ? DEFAULT_KEEP_ALIVE_TIMEOUT : _b;
                                        if (type === MESSAGE_TYPES.GQL_CONNECTION_ACK) {
                                            ackOk = true;
                                            _this.keepAliveTimeout = connectionTimeoutMs;
                                            _this.awsRealTimeSocket.onmessage = _this._handleIncomingSubscriptionMessage.bind(_this);
                                            _this.awsRealTimeSocket.onerror = function (err) {
                                                logger.debug(err);
                                                _this._errorDisconnect(__WEBPACK_IMPORTED_MODULE_9__index__["b" /* CONTROL_MSG */].CONNECTION_CLOSED);
                                            };
                                            _this.awsRealTimeSocket.onclose = function (event) {
                                                logger.debug("WebSocket closed " + event.reason);
                                                _this._errorDisconnect(__WEBPACK_IMPORTED_MODULE_9__index__["b" /* CONTROL_MSG */].CONNECTION_CLOSED);
                                            };
                                            res('Cool, connected to AWS AppSyncRealTime');
                                            return;
                                        }
                                        if (type === MESSAGE_TYPES.GQL_CONNECTION_ERROR) {
                                            var _c = data.payload, _d = (_c === void 0 ? {} : _c).errors, _e = __read(_d === void 0 ? [] : _d, 1), _f = _e[0], _g = _f === void 0 ? {} : _f, _h = _g.errorType, errorType = _h === void 0 ? '' : _h, _j = _g.errorCode, errorCode = _j === void 0 ? 0 : _j;
                                            rej({ errorType: errorType, errorCode: errorCode });
                                        }
                                    };
                                    var gqlInit = {
                                        type: MESSAGE_TYPES.GQL_CONNECTION_INIT,
                                    };
                                    _this.awsRealTimeSocket.send(JSON.stringify(gqlInit));
                                    function checkAckOk() {
                                        if (!ackOk) {
                                            rej(new Error("Connection timeout: ack from AWSRealTime was not received on " + CONNECTION_INIT_TIMEOUT + " ms"));
                                        }
                                    }
                                    setTimeout(checkAckOk.bind(_this), CONNECTION_INIT_TIMEOUT);
                                });
                            })()];
                    case 3:
                        // Step 2: wait for ack from AWS AppSyncReaTime after sending init
                        _b.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        err_4 = _b.sent();
                        errorType = err_4.errorType, errorCode = err_4.errorCode;
                        if (NON_RETRYABLE_CODES.includes(errorCode)) {
                            throw new __WEBPACK_IMPORTED_MODULE_5__aws_amplify_core__["NonRetryableError"](errorType);
                        }
                        else if (errorType) {
                            throw new Error(errorType);
                        }
                        else {
                            throw err_4;
                        }
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeHeaderBasedAuth = function (_a) {
        var authenticationType = _a.authenticationType, payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, apiKey = _a.apiKey, region = _a.region;
        return __awaiter(this, void 0, void 0, function () {
            var headerHandler, handler, host, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        headerHandler = {
                            API_KEY: this._awsRealTimeApiKeyHeader.bind(this),
                            AWS_IAM: this._awsRealTimeIAMHeader.bind(this),
                            OPENID_CONNECT: this._awsRealTimeOPENIDHeader.bind(this),
                            AMAZON_COGNITO_USER_POOLS: this._awsRealTimeCUPHeader.bind(this),
                        };
                        handler = headerHandler[authenticationType];
                        if (typeof handler !== 'function') {
                            logger.debug("Authentication type " + authenticationType + " not supported");
                            return [2 /*return*/, ''];
                        }
                        host = __WEBPACK_IMPORTED_MODULE_2_url__["parse"](appSyncGraphqlEndpoint).host;
                        return [4 /*yield*/, handler({
                                payload: payload,
                                canonicalUri: canonicalUri,
                                appSyncGraphqlEndpoint: appSyncGraphqlEndpoint,
                                apiKey: apiKey,
                                region: region,
                                host: host,
                            })];
                    case 1:
                        result = _b.sent();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeCUPHeader = function (_a) {
        var host = _a.host;
        return __awaiter(this, void 0, void 0, function () {
            var session;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__aws_amplify_auth__["default"].currentSession()];
                    case 1:
                        session = _b.sent();
                        return [2 /*return*/, {
                                Authorization: session.getAccessToken().getJwtToken(),
                                host: host,
                            }];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeOPENIDHeader = function (_a) {
        var host = _a.host;
        return __awaiter(this, void 0, void 0, function () {
            var token, federatedInfo, currentUser;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_6__aws_amplify_cache__["a" /* default */].getItem('federatedInfo')];
                    case 1:
                        federatedInfo = _b.sent();
                        if (!federatedInfo) return [3 /*break*/, 2];
                        token = federatedInfo.token;
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_7__aws_amplify_auth__["default"].currentAuthenticatedUser()];
                    case 3:
                        currentUser = _b.sent();
                        if (currentUser) {
                            token = currentUser.token;
                        }
                        _b.label = 4;
                    case 4:
                        if (!token) {
                            throw new Error('No federated jwt');
                        }
                        return [2 /*return*/, {
                                Authorization: token,
                                host: host,
                            }];
                }
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeApiKeyHeader = function (_a) {
        var apiKey = _a.apiKey, host = _a.host;
        return __awaiter(this, void 0, void 0, function () {
            var dt, dtStr;
            return __generator(this, function (_b) {
                dt = new Date();
                dtStr = dt.toISOString().replace(/[:\-]|\.\d{3}/g, '');
                return [2 /*return*/, {
                        host: host,
                        'x-amz-date': dtStr,
                        'x-api-key': apiKey,
                    }];
            });
        });
    };
    AWSAppSyncRealTimeProvider.prototype._awsRealTimeIAMHeader = function (_a) {
        var payload = _a.payload, canonicalUri = _a.canonicalUri, appSyncGraphqlEndpoint = _a.appSyncGraphqlEndpoint, region = _a.region;
        return __awaiter(this, void 0, void 0, function () {
            var endpointInfo, credentialsOK, creds, request, signed_params;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        endpointInfo = {
                            region: region,
                            service: 'appsync',
                        };
                        return [4 /*yield*/, this._ensureCredentials()];
                    case 1:
                        credentialsOK = _b.sent();
                        if (!credentialsOK) {
                            throw new Error('No credentials');
                        }
                        return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_5__aws_amplify_core__["Credentials"].get().then(function (credentials) { return ({
                                secret_key: credentials.secretAccessKey,
                                access_key: credentials.accessKeyId,
                                session_token: credentials.sessionToken,
                            }); })];
                    case 2:
                        creds = _b.sent();
                        request = {
                            url: "" + appSyncGraphqlEndpoint + canonicalUri,
                            data: payload,
                            method: 'POST',
                            headers: __assign({}, AWS_APPSYNC_REALTIME_HEADERS),
                        };
                        signed_params = __WEBPACK_IMPORTED_MODULE_5__aws_amplify_core__["Signer"].sign(request, creds, endpointInfo);
                        return [2 /*return*/, signed_params.headers];
                }
            });
        });
    };
    /**
     * @private
     */
    AWSAppSyncRealTimeProvider.prototype._ensureCredentials = function () {
        return __WEBPACK_IMPORTED_MODULE_5__aws_amplify_core__["Credentials"].get()
            .then(function (credentials) {
            if (!credentials)
                return false;
            var cred = __WEBPACK_IMPORTED_MODULE_5__aws_amplify_core__["Credentials"].shear(credentials);
            logger.debug('set credentials for AWSAppSyncRealTimeProvider', cred);
            return true;
        })
            .catch(function (err) {
            logger.warn('ensure credentials error', err);
            return false;
        });
    };
    return AWSAppSyncRealTimeProvider;
}(__WEBPACK_IMPORTED_MODULE_8__PubSubProvider__["a" /* AbstractPubSubProvider */]));

//# sourceMappingURL=AWSAppSyncRealTimeProvider.js.map

/***/ }),
/* 1641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export AWSIoTProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MqttOverWSProvider__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__ = __webpack_require__(71);
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */


var SERVICE_NAME = 'iotdevicegateway';
var AWSIoTProvider = /** @class */ (function (_super) {
    __extends(AWSIoTProvider, _super);
    function AWSIoTProvider() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AWSIoTProvider.prototype, "region", {
        get: function () {
            return this.options.aws_pubsub_region;
        },
        enumerable: true,
        configurable: true
    });
    AWSIoTProvider.prototype.getProviderName = function () {
        return 'AWSIoTProvider';
    };
    Object.defineProperty(AWSIoTProvider.prototype, "endpoint", {
        get: function () {
            var _this = this;
            return (function () { return __awaiter(_this, void 0, void 0, function () {
                var endpoint, serviceInfo, _a, access_key, secret_key, session_token, result;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            endpoint = this.options.aws_pubsub_endpoint;
                            serviceInfo = {
                                service: SERVICE_NAME,
                                region: this.region,
                            };
                            return [4 /*yield*/, __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["Credentials"].get()];
                        case 1:
                            _a = _b.sent(), access_key = _a.accessKeyId, secret_key = _a.secretAccessKey, session_token = _a.sessionToken;
                            result = __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["Signer"].signUrl(endpoint, { access_key: access_key, secret_key: secret_key, session_token: session_token }, serviceInfo);
                            return [2 /*return*/, result];
                    }
                });
            }); })();
        },
        enumerable: true,
        configurable: true
    });
    return AWSIoTProvider;
}(__WEBPACK_IMPORTED_MODULE_0__MqttOverWSProvider__["a" /* MqttOverWSProvider */]));

//# sourceMappingURL=AWSIotProvider.js.map

/***/ }),
/* 1642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PubSubClass */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PubSub; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Providers__ = __webpack_require__(779);
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/*
 * Copyright 2017-2018 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License"). You may not use this file except in compliance with
 * the License. A copy of the License is located at
 *
 *     http://aws.amazon.com/apache2.0/
 *
 * or in the "license" file accompanying this file. This file is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions
 * and limitations under the License.
 */
// import '../Common/Polyfills';



var isNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["browserOrNode"])().isNode;
var logger = new __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["ConsoleLogger"]('PubSub');
var PubSubClass = /** @class */ (function () {
    /**
     * Initialize PubSub with AWS configurations
     *
     * @param {PubSubOptions} options - Configuration object for PubSub
     */
    function PubSubClass(options) {
        this._options = options;
        logger.debug('PubSub Options', this._options);
        this._pluggables = [];
        this.subscribe = this.subscribe.bind(this);
    }
    Object.defineProperty(PubSubClass.prototype, "awsAppSyncProvider", {
        /**
         * Lazy instantiate AWSAppSyncProvider when it is required by the API category
         */
        get: function () {
            if (!this._awsAppSyncProvider) {
                this._awsAppSyncProvider = new __WEBPACK_IMPORTED_MODULE_2__Providers__["a" /* AWSAppSyncProvider */](this._options);
            }
            return this._awsAppSyncProvider;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PubSubClass.prototype, "awsAppSyncRealTimeProvider", {
        /**
         * Lazy instantiate AWSAppSyncRealTimeProvider when it is required by the API category
         */
        get: function () {
            if (!this._awsAppSyncRealTimeProvider) {
                this._awsAppSyncRealTimeProvider = new __WEBPACK_IMPORTED_MODULE_2__Providers__["b" /* AWSAppSyncRealTimeProvider */](this._options);
            }
            return this._awsAppSyncRealTimeProvider;
        },
        enumerable: true,
        configurable: true
    });
    PubSubClass.prototype.getModuleName = function () {
        return 'PubSub';
    };
    /**
     * Configure PubSub part with configurations
     *
     * @param {PubSubOptions} config - Configuration for PubSub
     * @return {Object} - The current configuration
     */
    PubSubClass.prototype.configure = function (options) {
        var _this = this;
        var opt = options ? options.PubSub || options : {};
        logger.debug('configure PubSub', { opt: opt });
        this._options = Object.assign({}, this._options, opt);
        this._pluggables.map(function (pluggable) { return pluggable.configure(_this._options); });
        return this._options;
    };
    /**
     * add plugin into Analytics category
     * @param {Object} pluggable - an instance of the plugin
     */
    PubSubClass.prototype.addPluggable = function (pluggable) {
        return __awaiter(this, void 0, void 0, function () {
            var config;
            return __generator(this, function (_a) {
                if (pluggable && pluggable.getCategory() === 'PubSub') {
                    this._pluggables.push(pluggable);
                    config = pluggable.configure(this._options);
                    return [2 /*return*/, config];
                }
                return [2 /*return*/];
            });
        });
    };
    PubSubClass.prototype.getProviderByName = function (providerName) {
        if (providerName === __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["INTERNAL_AWS_APPSYNC_PUBSUB_PROVIDER"]) {
            return this.awsAppSyncProvider;
        }
        if (providerName === __WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["INTERNAL_AWS_APPSYNC_REALTIME_PUBSUB_PROVIDER"]) {
            return this.awsAppSyncRealTimeProvider;
        }
        return this._pluggables.find(function (pluggable) { return pluggable.getProviderName() === providerName; });
    };
    PubSubClass.prototype.getProviders = function (options) {
        if (options === void 0) { options = {}; }
        var providerName = options.provider;
        if (!providerName) {
            return this._pluggables;
        }
        var provider = this.getProviderByName(providerName);
        if (!provider) {
            throw new Error("Could not find provider named " + providerName);
        }
        return [provider];
    };
    PubSubClass.prototype.publish = function (topics, msg, options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, Promise.all(this.getProviders(options).map(function (provider) {
                        return provider.publish(topics, msg, options);
                    }))];
            });
        });
    };
    PubSubClass.prototype.subscribe = function (topics, options) {
        if (isNode && this._options && this._options.ssr) {
            throw new Error('Subscriptions are not supported for Server-Side Rendering (SSR)');
        }
        logger.debug('subscribe options', options);
        var providers = this.getProviders(options);
        return new __WEBPACK_IMPORTED_MODULE_0_zen_observable_ts__["a" /* default */](function (observer) {
            var observables = providers.map(function (provider) { return ({
                provider: provider,
                observable: provider.subscribe(topics, options),
            }); });
            var subscriptions = observables.map(function (_a) {
                var provider = _a.provider, observable = _a.observable;
                return observable.subscribe({
                    start: console.error,
                    next: function (value) { return observer.next({ provider: provider, value: value }); },
                    error: function (error) { return observer.error({ provider: provider, error: error }); },
                });
            });
            return function () {
                return subscriptions.forEach(function (subscription) { return subscription.unsubscribe(); });
            };
        });
    };
    return PubSubClass;
}());

var PubSub = new PubSubClass(null);
__WEBPACK_IMPORTED_MODULE_1__aws_amplify_core__["Amplify"].register(PubSub);
//# sourceMappingURL=PubSub.js.map

/***/ }),
/* 1643 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(783);
var bytesToUuid = __webpack_require__(782);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 1644 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(783);
var bytesToUuid = __webpack_require__(782);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 1645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=CryptoOperation.js.map

/***/ }),
/* 1646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=Key.js.map

/***/ }),
/* 1647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=KeyOperation.js.map

/***/ }),
/* 1648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=MsSubtleCrypto.js.map

/***/ }),
/* 1649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.isMsWindow = void 0;
var msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */
function isMsWindow(window) {
    if (quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return msSubtleCryptoMethods
            .map(function (methodName) { return subtle_1[methodName]; })
            .concat(getRandomValues)
            .every(function (method) { return typeof method === "function"; });
    }
    return false;
}
exports.isMsWindow = isMsWindow;
//# sourceMappingURL=MsWindow.js.map

/***/ }),
/* 1650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(31);
tslib_1.__exportStar(__webpack_require__(1645), exports);
tslib_1.__exportStar(__webpack_require__(1646), exports);
tslib_1.__exportStar(__webpack_require__(1647), exports);
tslib_1.__exportStar(__webpack_require__(1648), exports);
tslib_1.__exportStar(__webpack_require__(1649), exports);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Sha256 = void 0;
var ie11Sha256_1 = __webpack_require__(785);
var webCryptoSha256_1 = __webpack_require__(788);
var sha256_js_1 = __webpack_require__(1653);
var supports_web_crypto_1 = __webpack_require__(1660);
var ie11_detection_1 = __webpack_require__(1650);
var util_locate_window_1 = __webpack_require__(526);
var Sha256 = /** @class */ (function () {
    function Sha256(secret) {
        if (supports_web_crypto_1.supportsWebCrypto(util_locate_window_1.locateWindow())) {
            this.hash = new webCryptoSha256_1.Sha256(secret);
        }
        else if (ie11_detection_1.isMsWindow(util_locate_window_1.locateWindow())) {
            this.hash = new ie11Sha256_1.Sha256(secret);
        }
        else {
            this.hash = new sha256_js_1.Sha256(secret);
        }
    }
    Sha256.prototype.update = function (data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function () {
        return this.hash.digest();
    };
    return Sha256;
}());
exports.Sha256 = Sha256;
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.RawSha256 = void 0;
var constants_1 = __webpack_require__(789);
/**
 * @internal
 */
var RawSha256 = /** @class */ (function () {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */
        this.finished = false;
    }
    RawSha256.prototype.update = function (data) {
        if (this.finished) {
            throw new Error("Attempted to update an already finished hash.");
        }
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) {
            throw new Error("Cannot hash more than 2^53 - 1 bits");
        }
        while (byteLength > 0) {
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function () {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for (var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++) {
                    bufferView.setUint8(i, 0);
                }
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for (var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++) {
                bufferView.setUint8(i, 0);
            }
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for (var i = 0; i < 8; i++) {
            out[i * 4] = (this.state[i] >>> 24) & 0xff;
            out[i * 4 + 1] = (this.state[i] >>> 16) & 0xff;
            out[i * 4 + 2] = (this.state[i] >>> 8) & 0xff;
            out[i * 4 + 3] = (this.state[i] >>> 0) & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function () {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for (var i = 0; i < constants_1.BLOCK_SIZE; i++) {
            if (i < 16) {
                this.temp[i] =
                    ((buffer[i * 4] & 0xff) << 24) |
                        ((buffer[i * 4 + 1] & 0xff) << 16) |
                        ((buffer[i * 4 + 2] & 0xff) << 8) |
                        (buffer[i * 4 + 3] & 0xff);
            }
            else {
                var u = this.temp[i - 2];
                var t1_1 = ((u >>> 17) | (u << 15)) ^ ((u >>> 19) | (u << 13)) ^ (u >>> 10);
                u = this.temp[i - 15];
                var t2_1 = ((u >>> 7) | (u << 25)) ^ ((u >>> 18) | (u << 14)) ^ (u >>> 3);
                this.temp[i] =
                    ((t1_1 + this.temp[i - 7]) | 0) + ((t2_1 + this.temp[i - 16]) | 0);
            }
            var t1 = ((((((state4 >>> 6) | (state4 << 26)) ^
                ((state4 >>> 11) | (state4 << 21)) ^
                ((state4 >>> 25) | (state4 << 7))) +
                ((state4 & state5) ^ (~state4 & state6))) |
                0) +
                ((state7 + ((constants_1.KEY[i] + this.temp[i]) | 0)) | 0)) |
                0;
            var t2 = ((((state0 >>> 2) | (state0 << 30)) ^
                ((state0 >>> 13) | (state0 << 19)) ^
                ((state0 >>> 22) | (state0 << 10))) +
                ((state0 & state1) ^ (state0 & state2) ^ (state1 & state2))) |
                0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = (state3 + t1) | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = (t1 + t2) | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}());
exports.RawSha256 = RawSha256;
//# sourceMappingURL=RawSha256.js.map

/***/ }),
/* 1653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(31);
tslib_1.__exportStar(__webpack_require__(1654), exports);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Sha256 = void 0;
var tslib_1 = __webpack_require__(31);
var constants_1 = __webpack_require__(789);
var RawSha256_1 = __webpack_require__(1652);
var util_utf8_browser_1 = __webpack_require__(514);
var Sha256 = /** @class */ (function () {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for (var i = 0; i < constants_1.BLOCK_SIZE; i++) {
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for (var i = 0; i < inner.byteLength; i++) {
                inner[i] = 0;
            }
        }
    }
    Sha256.prototype.update = function (toHash) {
        if (isEmptyData(toHash) || this.error) {
            return;
        }
        try {
            this.hash.update(convertToBuffer(toHash));
        }
        catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */
    Sha256.prototype.digestSync = function () {
        if (this.error) {
            throw this.error;
        }
        if (this.outer) {
            if (!this.outer.finished) {
                this.outer.update(this.hash.digest());
            }
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */
    Sha256.prototype.digest = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.digestSync()];
            });
        });
    };
    return Sha256;
}());
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = convertToBuffer(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}
function isEmptyData(data) {
    if (typeof data === "string") {
        return data.length === 0;
    }
    return data.byteLength === 0;
}
function convertToBuffer(data) {
    if (typeof data === "string") {
        return util_utf8_browser_1.fromUtf8(data);
    }
    if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    }
    return new Uint8Array(data);
}
//# sourceMappingURL=jsSha256.js.map

/***/ }),
/* 1655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fromUtf8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toUtf8; });
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */
var fromUtf8 = function (input) {
    var bytes = [];
    for (var i = 0, len = input.length; i < len; i++) {
        var value = input.charCodeAt(i);
        if (value < 0x80) {
            bytes.push(value);
        }
        else if (value < 0x800) {
            bytes.push((value >> 6) | 192, (value & 63) | 128);
        }
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push((surrogatePair >> 18) | 240, ((surrogatePair >> 12) & 63) | 128, ((surrogatePair >> 6) & 63) | 128, (surrogatePair & 63) | 128);
        }
        else {
            bytes.push((value >> 12) | 224, ((value >> 6) & 63) | 128, (value & 63) | 128);
        }
    }
    return Uint8Array.from(bytes);
};
/**
 * Converts a typed array of bytes containing UTF-8 data into a native JS
 * string.
 *
 * Partly cribbed from the `goog.crypt.utf8ByteArrayToString` function in the
 * Google Closure library, though updated to use typed arrays and to better
 * handle astral plane code points.
 */
var toUtf8 = function (input) {
    var decoded = "";
    for (var i = 0, len = input.length; i < len; i++) {
        var byte = input[i];
        if (byte < 0x80) {
            decoded += String.fromCharCode(byte);
        }
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode(((byte & 31) << 6) | (nextByte & 63));
        }
        else if (240 <= byte && byte < 365) {
            var surrogatePair = [byte, input[++i], input[++i], input[++i]];
            var encoded = "%" + surrogatePair.map(function (byteValue) { return byteValue.toString(16); }).join("%");
            decoded += decodeURIComponent(encoded);
        }
        else {
            decoded += String.fromCharCode(((byte & 15) << 12) | ((input[++i] & 63) << 6) | (input[++i] & 63));
        }
    }
    return decoded;
};
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromUtf8;
/* harmony export (immutable) */ __webpack_exports__["b"] = toUtf8;
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(790);
/**
 * @internal
 */
var RawSha256 = /** @class */ (function () {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */
        this.finished = false;
    }
    RawSha256.prototype.update = function (data) {
        if (this.finished) {
            throw new Error("Attempted to update an already finished hash.");
        }
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) {
            throw new Error("Cannot hash more than 2^53 - 1 bits");
        }
        while (byteLength > 0) {
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function () {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for (var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++) {
                    bufferView.setUint8(i, 0);
                }
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for (var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++) {
                bufferView.setUint8(i, 0);
            }
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for (var i = 0; i < 8; i++) {
            out[i * 4] = (this.state[i] >>> 24) & 0xff;
            out[i * 4 + 1] = (this.state[i] >>> 16) & 0xff;
            out[i * 4 + 2] = (this.state[i] >>> 8) & 0xff;
            out[i * 4 + 3] = (this.state[i] >>> 0) & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function () {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for (var i = 0; i < constants_1.BLOCK_SIZE; i++) {
            if (i < 16) {
                this.temp[i] =
                    ((buffer[i * 4] & 0xff) << 24) |
                        ((buffer[i * 4 + 1] & 0xff) << 16) |
                        ((buffer[i * 4 + 2] & 0xff) << 8) |
                        (buffer[i * 4 + 3] & 0xff);
            }
            else {
                var u = this.temp[i - 2];
                var t1_1 = ((u >>> 17) | (u << 15)) ^ ((u >>> 19) | (u << 13)) ^ (u >>> 10);
                u = this.temp[i - 15];
                var t2_1 = ((u >>> 7) | (u << 25)) ^ ((u >>> 18) | (u << 14)) ^ (u >>> 3);
                this.temp[i] =
                    ((t1_1 + this.temp[i - 7]) | 0) + ((t2_1 + this.temp[i - 16]) | 0);
            }
            var t1 = ((((((state4 >>> 6) | (state4 << 26)) ^
                ((state4 >>> 11) | (state4 << 21)) ^
                ((state4 >>> 25) | (state4 << 7))) +
                ((state4 & state5) ^ (~state4 & state6))) |
                0) +
                ((state7 + ((constants_1.KEY[i] + this.temp[i]) | 0)) | 0)) |
                0;
            var t2 = ((((state0 >>> 2) | (state0 << 30)) ^
                ((state0 >>> 13) | (state0 << 19)) ^
                ((state0 >>> 22) | (state0 << 10))) +
                ((state0 & state1) ^ (state0 & state2) ^ (state1 & state2))) |
                0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = (state3 + t1) | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = (t1 + t2) | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}());
exports.RawSha256 = RawSha256;
//# sourceMappingURL=RawSha256.js.map

/***/ }),
/* 1658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(31);
tslib_1.__exportStar(__webpack_require__(1659), exports);
//# sourceMappingURL=index.js.map

/***/ }),
/* 1659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(31);
var constants_1 = __webpack_require__(790);
var RawSha256_1 = __webpack_require__(1657);
var util_utf8_browser_1 = __webpack_require__(1754);
var Sha256 = /** @class */ (function () {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for (var i = 0; i < constants_1.BLOCK_SIZE; i++) {
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for (var i = 0; i < inner.byteLength; i++) {
                inner[i] = 0;
            }
        }
    }
    Sha256.prototype.update = function (toHash) {
        if (isEmptyData(toHash) || this.error) {
            return;
        }
        try {
            this.hash.update(convertToBuffer(toHash));
        }
        catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */
    Sha256.prototype.digestSync = function () {
        if (this.error) {
            throw this.error;
        }
        if (this.outer) {
            if (!this.outer.finished) {
                this.outer.update(this.hash.digest());
            }
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */
    Sha256.prototype.digest = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.digestSync()];
            });
        });
    };
    return Sha256;
}());
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = convertToBuffer(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}
function isEmptyData(data) {
    if (typeof data === "string") {
        return data.length === 0;
    }
    return data.byteLength === 0;
}
function convertToBuffer(data) {
    if (typeof data === "string") {
        return util_utf8_browser_1.fromUtf8(data);
    }
    if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    }
    return new Uint8Array(data);
}
//# sourceMappingURL=jsSha256.js.map

/***/ }),
/* 1660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(31);
tslib_1.__exportStar(__webpack_require__(1661), exports);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsOERBQW9DIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0ICogZnJvbSBcIi4vc3VwcG9ydHNXZWJDcnlwdG9cIjtcbiJdfQ==

/***/ }),
/* 1661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
var tslib_1 = __webpack_require__(31);
var subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function supportsWebCrypto(window) {
    if (supportsSecureRandom(window) &&
        typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return supportsSubtleCrypto(subtle);
    }
    return false;
}
exports.supportsWebCrypto = supportsWebCrypto;
function supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
exports.supportsSecureRandom = supportsSecureRandom;
function supportsSubtleCrypto(subtle) {
    return (subtle &&
        subtleCryptoMethods.every(function (methodName) { return typeof subtle[methodName] === "function"; }));
}
exports.supportsSubtleCrypto = supportsSubtleCrypto;
function supportsZeroByteGCM(subtle) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var key, zeroByteAuthTag, _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!supportsSubtleCrypto(subtle))
                        return [2 /*return*/, false];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, subtle.generateKey({ name: "AES-GCM", length: 128 }, false, ["encrypt"])];
                case 2:
                    key = _b.sent();
                    return [4 /*yield*/, subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [2 /*return*/, zeroByteAuthTag.byteLength === 16];
                case 4:
                    _a = _b.sent();
                    return [2 /*return*/, false];
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.supportsZeroByteGCM = supportsZeroByteGCM;
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultRegionInfoProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);

// Partition default templates
var AWS_TEMPLATE = "logs.{region}.amazonaws.com";
var AWS_CN_TEMPLATE = "logs.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE = "logs.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE = "logs.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE = "logs.{region}.amazonaws.com";
// Partition regions
var AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2",
]);
var AWS_CN_REGIONS = new Set(["cn-north-1", "cn-northwest-1"]);
var AWS_ISO_REGIONS = new Set(["us-iso-east-1"]);
var AWS_ISO_B_REGIONS = new Set(["us-isob-east-1"]);
var AWS_US_GOV_REGIONS = new Set(["us-gov-east-1", "us-gov-west-1"]);
var defaultRegionInfoProvider = function (region, options) {
    var regionInfo = undefined;
    switch (region) {
        // First, try to match exact region names.
        case "af-south-1":
            regionInfo = {
                hostname: "logs.af-south-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ap-east-1":
            regionInfo = {
                hostname: "logs.ap-east-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ap-northeast-1":
            regionInfo = {
                hostname: "logs.ap-northeast-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "logs.ap-northeast-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "logs.ap-south-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "logs.ap-southeast-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "logs.ap-southeast-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "logs.ca-central-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "logs.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn",
            };
            break;
        case "cn-northwest-1":
            regionInfo = {
                hostname: "logs.cn-northwest-1.amazonaws.com.cn",
                partition: "aws-cn",
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "logs.eu-central-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "logs.eu-north-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "eu-south-1":
            regionInfo = {
                hostname: "logs.eu-south-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "logs.eu-west-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "logs.eu-west-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "logs.eu-west-3.amazonaws.com",
                partition: "aws",
            };
            break;
        case "fips-us-east-1":
            regionInfo = {
                hostname: "logs-fips.us-east-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1",
            };
            break;
        case "fips-us-east-2":
            regionInfo = {
                hostname: "logs-fips.us-east-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-2",
            };
            break;
        case "fips-us-west-1":
            regionInfo = {
                hostname: "logs-fips.us-west-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-1",
            };
            break;
        case "fips-us-west-2":
            regionInfo = {
                hostname: "logs-fips.us-west-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-2",
            };
            break;
        case "me-south-1":
            regionInfo = {
                hostname: "logs.me-south-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "logs.sa-east-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "logs.us-east-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "logs.us-east-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "us-gov-east-1":
            regionInfo = {
                hostname: "logs.us-gov-east-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-east-1",
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "logs.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1",
            };
            break;
        case "us-iso-east-1":
            regionInfo = {
                hostname: "logs.us-iso-east-1.c2s.ic.gov",
                partition: "aws-iso",
            };
            break;
        case "us-isob-east-1":
            regionInfo = {
                hostname: "logs.us-isob-east-1.sc2s.sgov.gov",
                partition: "aws-iso-b",
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "logs.us-west-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "logs.us-west-2.amazonaws.com",
                partition: "aws",
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if (AWS_REGIONS.has(region)) {
                regionInfo = {
                    hostname: AWS_TEMPLATE.replace("{region}", region),
                    partition: "aws",
                };
            }
            if (AWS_CN_REGIONS.has(region)) {
                regionInfo = {
                    hostname: AWS_CN_TEMPLATE.replace("{region}", region),
                    partition: "aws-cn",
                };
            }
            if (AWS_ISO_REGIONS.has(region)) {
                regionInfo = {
                    hostname: AWS_ISO_TEMPLATE.replace("{region}", region),
                    partition: "aws-iso",
                };
            }
            if (AWS_ISO_B_REGIONS.has(region)) {
                regionInfo = {
                    hostname: AWS_ISO_B_TEMPLATE.replace("{region}", region),
                    partition: "aws-iso-b",
                };
            }
            if (AWS_US_GOV_REGIONS.has(region)) {
                regionInfo = {
                    hostname: AWS_US_GOV_TEMPLATE.replace("{region}", region),
                    partition: "aws-us-gov",
                };
            }
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) {
                regionInfo = {
                    hostname: AWS_TEMPLATE.replace("{region}", region),
                    partition: "aws",
                };
            }
    }
    return Promise.resolve(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ signingService: "logs" }, regionInfo));
};
//# sourceMappingURL=endpoints.js.map

/***/ }),
/* 1663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CloudWatchLogsClient__ = __webpack_require__(170);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "CloudWatchLogsClient", function() { return __WEBPACK_IMPORTED_MODULE_0__CloudWatchLogsClient__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CloudWatchLogs__ = __webpack_require__(190);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commands_AssociateKmsKeyCommand__ = __webpack_require__(791);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_CancelExportTaskCommand__ = __webpack_require__(792);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commands_CreateExportTaskCommand__ = __webpack_require__(793);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commands_CreateLogGroupCommand__ = __webpack_require__(794);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "CreateLogGroupCommand", function() { return __WEBPACK_IMPORTED_MODULE_5__commands_CreateLogGroupCommand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__commands_CreateLogStreamCommand__ = __webpack_require__(795);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "CreateLogStreamCommand", function() { return __WEBPACK_IMPORTED_MODULE_6__commands_CreateLogStreamCommand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__commands_DeleteDestinationCommand__ = __webpack_require__(796);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__commands_DeleteLogGroupCommand__ = __webpack_require__(797);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__commands_DeleteLogStreamCommand__ = __webpack_require__(798);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__commands_DeleteMetricFilterCommand__ = __webpack_require__(799);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__commands_DeleteQueryDefinitionCommand__ = __webpack_require__(800);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__commands_DeleteResourcePolicyCommand__ = __webpack_require__(801);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__commands_DeleteRetentionPolicyCommand__ = __webpack_require__(802);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__commands_DeleteSubscriptionFilterCommand__ = __webpack_require__(803);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__commands_DescribeDestinationsCommand__ = __webpack_require__(515);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__pagination_DescribeDestinationsPaginator__ = __webpack_require__(1666);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__commands_DescribeExportTasksCommand__ = __webpack_require__(804);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__commands_DescribeLogGroupsCommand__ = __webpack_require__(516);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "DescribeLogGroupsCommand", function() { return __WEBPACK_IMPORTED_MODULE_18__commands_DescribeLogGroupsCommand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__pagination_DescribeLogGroupsPaginator__ = __webpack_require__(1667);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__commands_DescribeLogStreamsCommand__ = __webpack_require__(517);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "DescribeLogStreamsCommand", function() { return __WEBPACK_IMPORTED_MODULE_20__commands_DescribeLogStreamsCommand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__pagination_DescribeLogStreamsPaginator__ = __webpack_require__(1668);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__commands_DescribeMetricFiltersCommand__ = __webpack_require__(518);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__pagination_DescribeMetricFiltersPaginator__ = __webpack_require__(1669);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__commands_DescribeQueriesCommand__ = __webpack_require__(805);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__commands_DescribeQueryDefinitionsCommand__ = __webpack_require__(806);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__commands_DescribeResourcePoliciesCommand__ = __webpack_require__(807);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__commands_DescribeSubscriptionFiltersCommand__ = __webpack_require__(519);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__pagination_DescribeSubscriptionFiltersPaginator__ = __webpack_require__(1670);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__commands_DisassociateKmsKeyCommand__ = __webpack_require__(808);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__commands_FilterLogEventsCommand__ = __webpack_require__(520);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__pagination_FilterLogEventsPaginator__ = __webpack_require__(1671);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__commands_GetLogEventsCommand__ = __webpack_require__(521);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "GetLogEventsCommand", function() { return __WEBPACK_IMPORTED_MODULE_32__commands_GetLogEventsCommand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__pagination_GetLogEventsPaginator__ = __webpack_require__(1672);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__commands_GetLogGroupFieldsCommand__ = __webpack_require__(809);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__commands_GetLogRecordCommand__ = __webpack_require__(810);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__commands_GetQueryResultsCommand__ = __webpack_require__(811);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__commands_ListTagsLogGroupCommand__ = __webpack_require__(812);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__commands_PutDestinationCommand__ = __webpack_require__(813);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__commands_PutDestinationPolicyCommand__ = __webpack_require__(814);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__commands_PutLogEventsCommand__ = __webpack_require__(815);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "PutLogEventsCommand", function() { return __WEBPACK_IMPORTED_MODULE_40__commands_PutLogEventsCommand__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__commands_PutMetricFilterCommand__ = __webpack_require__(816);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__commands_PutQueryDefinitionCommand__ = __webpack_require__(817);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__commands_PutResourcePolicyCommand__ = __webpack_require__(818);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__commands_PutRetentionPolicyCommand__ = __webpack_require__(819);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__commands_PutSubscriptionFilterCommand__ = __webpack_require__(820);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__commands_StartQueryCommand__ = __webpack_require__(821);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__commands_StopQueryCommand__ = __webpack_require__(822);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__commands_TagLogGroupCommand__ = __webpack_require__(823);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__commands_TestMetricFilterCommand__ = __webpack_require__(824);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__commands_UntagLogGroupCommand__ = __webpack_require__(825);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__pagination_Interfaces__ = __webpack_require__(1673);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__models_index__ = __webpack_require__(1664);
/* unused harmony namespace reexport */





















































//# sourceMappingURL=index.js.map

/***/ }),
/* 1664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_0__ = __webpack_require__(33);
/* unused harmony namespace reexport */

//# sourceMappingURL=index.js.map

/***/ }),
/* 1665 */
/***/ (function(module, exports) {

module.exports = {"name":"@aws-sdk/client-cloudwatch-logs","description":"AWS SDK for JavaScript Cloudwatch Logs Client for Node.js, Browser and React Native","version":"3.6.1","scripts":{"clean":"yarn remove-definitions && yarn remove-dist && yarn remove-documentation","build-documentation":"yarn remove-documentation && typedoc ./","prepublishOnly":"yarn build","pretest":"yarn build:cjs","remove-definitions":"rimraf ./types","remove-dist":"rimraf ./dist","remove-documentation":"rimraf ./docs","test":"exit 0","build:cjs":"tsc -p tsconfig.json","build:es":"tsc -p tsconfig.es.json","build":"yarn build:cjs && yarn build:es","postbuild":"downlevel-dts types types/ts3.4"},"main":"./dist/cjs/index.js","types":"./types/index.d.ts","module":"./dist/es/index.js","browser":{"./runtimeConfig":"./runtimeConfig.browser"},"react-native":{"./runtimeConfig":"./runtimeConfig.native"},"sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"^1.0.0","@aws-crypto/sha256-js":"^1.0.0","@aws-sdk/config-resolver":"3.6.1","@aws-sdk/credential-provider-node":"3.6.1","@aws-sdk/fetch-http-handler":"3.6.1","@aws-sdk/hash-node":"3.6.1","@aws-sdk/invalid-dependency":"3.6.1","@aws-sdk/middleware-content-length":"3.6.1","@aws-sdk/middleware-host-header":"3.6.1","@aws-sdk/middleware-logger":"3.6.1","@aws-sdk/middleware-retry":"3.6.1","@aws-sdk/middleware-serde":"3.6.1","@aws-sdk/middleware-signing":"3.6.1","@aws-sdk/middleware-stack":"3.6.1","@aws-sdk/middleware-user-agent":"3.6.1","@aws-sdk/node-config-provider":"3.6.1","@aws-sdk/node-http-handler":"3.6.1","@aws-sdk/protocol-http":"3.6.1","@aws-sdk/smithy-client":"3.6.1","@aws-sdk/types":"3.6.1","@aws-sdk/url-parser":"3.6.1","@aws-sdk/url-parser-native":"3.6.1","@aws-sdk/util-base64-browser":"3.6.1","@aws-sdk/util-base64-node":"3.6.1","@aws-sdk/util-body-length-browser":"3.6.1","@aws-sdk/util-body-length-node":"3.6.1","@aws-sdk/util-user-agent-browser":"3.6.1","@aws-sdk/util-user-agent-node":"3.6.1","@aws-sdk/util-utf8-browser":"3.6.1","@aws-sdk/util-utf8-node":"3.6.1","tslib":"^2.0.0"},"devDependencies":{"@aws-sdk/client-documentation-generator":"3.6.1","@types/node":"^12.7.5","downlevel-dts":"0.7.0","jest":"^26.1.0","rimraf":"^3.0.0","typedoc":"^0.19.2","typescript":"~4.1.2"},"engines":{"node":">=10.0.0"},"typesVersions":{"<4.0":{"types/*":["types/ts3.4/*"]}},"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-cloudwatch-logs","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-cloudwatch-logs"}}

/***/ }),
/* 1666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export paginateDescribeDestinations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CloudWatchLogs__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CloudWatchLogsClient__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_DescribeDestinationsCommand__ = __webpack_require__(515);




/**
 * @private
 */
var makePagedClientRequest = function (client, input) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.send.apply(client, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([new __WEBPACK_IMPORTED_MODULE_3__commands_DescribeDestinationsCommand__["a" /* DescribeDestinationsCommand */](input)], args))];
                case 1: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
};
/**
 * @private
 */
var makePagedRequest = function (client, input) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.describeDestinations.apply(client, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([input], args))];
                case 1: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
};
function paginateDescribeDestinations(config, input) {
    var additionalArguments = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        additionalArguments[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __asyncGenerator */])(this, arguments, function paginateDescribeDestinations_1() {
        var token, hasNext, page;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = config.startingToken || undefined;
                    hasNext = true;
                    _a.label = 1;
                case 1:
                    if (!hasNext) return [3 /*break*/, 9];
                    input.nextToken = token;
                    input["limit"] = config.pageSize;
                    if (!(config.client instanceof __WEBPACK_IMPORTED_MODULE_1__CloudWatchLogs__["a" /* CloudWatchLogs */])) return [3 /*break*/, 3];
                    return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(makePagedRequest.apply(void 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([config.client, input], additionalArguments)))];
                case 2:
                    page = _a.sent();
                    return [3 /*break*/, 6];
                case 3:
                    if (!(config.client instanceof __WEBPACK_IMPORTED_MODULE_2__CloudWatchLogsClient__["a" /* CloudWatchLogsClient */])) return [3 /*break*/, 5];
                    return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(makePagedClientRequest.apply(void 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([config.client, input], additionalArguments)))];
                case 4:
                    page = _a.sent();
                    return [3 /*break*/, 6];
                case 5: throw new Error("Invalid client, expected CloudWatchLogs | CloudWatchLogsClient");
                case 6: return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(page)];
                case 7: return [4 /*yield*/, _a.sent()];
                case 8:
                    _a.sent();
                    token = page.nextToken;
                    hasNext = !!token;
                    return [3 /*break*/, 1];
                case 9: return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(undefined)];
                case 10: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
}
//# sourceMappingURL=DescribeDestinationsPaginator.js.map

/***/ }),
/* 1667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export paginateDescribeLogGroups */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CloudWatchLogs__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CloudWatchLogsClient__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_DescribeLogGroupsCommand__ = __webpack_require__(516);




/**
 * @private
 */
var makePagedClientRequest = function (client, input) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.send.apply(client, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([new __WEBPACK_IMPORTED_MODULE_3__commands_DescribeLogGroupsCommand__["a" /* DescribeLogGroupsCommand */](input)], args))];
                case 1: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
};
/**
 * @private
 */
var makePagedRequest = function (client, input) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.describeLogGroups.apply(client, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([input], args))];
                case 1: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
};
function paginateDescribeLogGroups(config, input) {
    var additionalArguments = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        additionalArguments[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __asyncGenerator */])(this, arguments, function paginateDescribeLogGroups_1() {
        var token, hasNext, page;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = config.startingToken || undefined;
                    hasNext = true;
                    _a.label = 1;
                case 1:
                    if (!hasNext) return [3 /*break*/, 9];
                    input.nextToken = token;
                    input["limit"] = config.pageSize;
                    if (!(config.client instanceof __WEBPACK_IMPORTED_MODULE_1__CloudWatchLogs__["a" /* CloudWatchLogs */])) return [3 /*break*/, 3];
                    return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(makePagedRequest.apply(void 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([config.client, input], additionalArguments)))];
                case 2:
                    page = _a.sent();
                    return [3 /*break*/, 6];
                case 3:
                    if (!(config.client instanceof __WEBPACK_IMPORTED_MODULE_2__CloudWatchLogsClient__["a" /* CloudWatchLogsClient */])) return [3 /*break*/, 5];
                    return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(makePagedClientRequest.apply(void 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([config.client, input], additionalArguments)))];
                case 4:
                    page = _a.sent();
                    return [3 /*break*/, 6];
                case 5: throw new Error("Invalid client, expected CloudWatchLogs | CloudWatchLogsClient");
                case 6: return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(page)];
                case 7: return [4 /*yield*/, _a.sent()];
                case 8:
                    _a.sent();
                    token = page.nextToken;
                    hasNext = !!token;
                    return [3 /*break*/, 1];
                case 9: return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(undefined)];
                case 10: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
}
//# sourceMappingURL=DescribeLogGroupsPaginator.js.map

/***/ }),
/* 1668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export paginateDescribeLogStreams */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CloudWatchLogs__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CloudWatchLogsClient__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_DescribeLogStreamsCommand__ = __webpack_require__(517);




/**
 * @private
 */
var makePagedClientRequest = function (client, input) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.send.apply(client, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([new __WEBPACK_IMPORTED_MODULE_3__commands_DescribeLogStreamsCommand__["a" /* DescribeLogStreamsCommand */](input)], args))];
                case 1: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
};
/**
 * @private
 */
var makePagedRequest = function (client, input) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.describeLogStreams.apply(client, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([input], args))];
                case 1: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
};
function paginateDescribeLogStreams(config, input) {
    var additionalArguments = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        additionalArguments[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __asyncGenerator */])(this, arguments, function paginateDescribeLogStreams_1() {
        var token, hasNext, page;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = config.startingToken || undefined;
                    hasNext = true;
                    _a.label = 1;
                case 1:
                    if (!hasNext) return [3 /*break*/, 9];
                    input.nextToken = token;
                    input["limit"] = config.pageSize;
                    if (!(config.client instanceof __WEBPACK_IMPORTED_MODULE_1__CloudWatchLogs__["a" /* CloudWatchLogs */])) return [3 /*break*/, 3];
                    return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(makePagedRequest.apply(void 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([config.client, input], additionalArguments)))];
                case 2:
                    page = _a.sent();
                    return [3 /*break*/, 6];
                case 3:
                    if (!(config.client instanceof __WEBPACK_IMPORTED_MODULE_2__CloudWatchLogsClient__["a" /* CloudWatchLogsClient */])) return [3 /*break*/, 5];
                    return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(makePagedClientRequest.apply(void 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([config.client, input], additionalArguments)))];
                case 4:
                    page = _a.sent();
                    return [3 /*break*/, 6];
                case 5: throw new Error("Invalid client, expected CloudWatchLogs | CloudWatchLogsClient");
                case 6: return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(page)];
                case 7: return [4 /*yield*/, _a.sent()];
                case 8:
                    _a.sent();
                    token = page.nextToken;
                    hasNext = !!token;
                    return [3 /*break*/, 1];
                case 9: return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(undefined)];
                case 10: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
}
//# sourceMappingURL=DescribeLogStreamsPaginator.js.map

/***/ }),
/* 1669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export paginateDescribeMetricFilters */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CloudWatchLogs__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CloudWatchLogsClient__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_DescribeMetricFiltersCommand__ = __webpack_require__(518);




/**
 * @private
 */
var makePagedClientRequest = function (client, input) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.send.apply(client, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([new __WEBPACK_IMPORTED_MODULE_3__commands_DescribeMetricFiltersCommand__["a" /* DescribeMetricFiltersCommand */](input)], args))];
                case 1: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
};
/**
 * @private
 */
var makePagedRequest = function (client, input) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.describeMetricFilters.apply(client, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([input], args))];
                case 1: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
};
function paginateDescribeMetricFilters(config, input) {
    var additionalArguments = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        additionalArguments[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __asyncGenerator */])(this, arguments, function paginateDescribeMetricFilters_1() {
        var token, hasNext, page;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = config.startingToken || undefined;
                    hasNext = true;
                    _a.label = 1;
                case 1:
                    if (!hasNext) return [3 /*break*/, 9];
                    input.nextToken = token;
                    input["limit"] = config.pageSize;
                    if (!(config.client instanceof __WEBPACK_IMPORTED_MODULE_1__CloudWatchLogs__["a" /* CloudWatchLogs */])) return [3 /*break*/, 3];
                    return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(makePagedRequest.apply(void 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([config.client, input], additionalArguments)))];
                case 2:
                    page = _a.sent();
                    return [3 /*break*/, 6];
                case 3:
                    if (!(config.client instanceof __WEBPACK_IMPORTED_MODULE_2__CloudWatchLogsClient__["a" /* CloudWatchLogsClient */])) return [3 /*break*/, 5];
                    return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(makePagedClientRequest.apply(void 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([config.client, input], additionalArguments)))];
                case 4:
                    page = _a.sent();
                    return [3 /*break*/, 6];
                case 5: throw new Error("Invalid client, expected CloudWatchLogs | CloudWatchLogsClient");
                case 6: return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(page)];
                case 7: return [4 /*yield*/, _a.sent()];
                case 8:
                    _a.sent();
                    token = page.nextToken;
                    hasNext = !!token;
                    return [3 /*break*/, 1];
                case 9: return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(undefined)];
                case 10: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
}
//# sourceMappingURL=DescribeMetricFiltersPaginator.js.map

/***/ }),
/* 1670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export paginateDescribeSubscriptionFilters */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CloudWatchLogs__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CloudWatchLogsClient__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_DescribeSubscriptionFiltersCommand__ = __webpack_require__(519);




/**
 * @private
 */
var makePagedClientRequest = function (client, input) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.send.apply(client, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([new __WEBPACK_IMPORTED_MODULE_3__commands_DescribeSubscriptionFiltersCommand__["a" /* DescribeSubscriptionFiltersCommand */](input)], args))];
                case 1: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
};
/**
 * @private
 */
var makePagedRequest = function (client, input) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.describeSubscriptionFilters.apply(client, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([input], args))];
                case 1: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
};
function paginateDescribeSubscriptionFilters(config, input) {
    var additionalArguments = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        additionalArguments[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __asyncGenerator */])(this, arguments, function paginateDescribeSubscriptionFilters_1() {
        var token, hasNext, page;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = config.startingToken || undefined;
                    hasNext = true;
                    _a.label = 1;
                case 1:
                    if (!hasNext) return [3 /*break*/, 9];
                    input.nextToken = token;
                    input["limit"] = config.pageSize;
                    if (!(config.client instanceof __WEBPACK_IMPORTED_MODULE_1__CloudWatchLogs__["a" /* CloudWatchLogs */])) return [3 /*break*/, 3];
                    return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(makePagedRequest.apply(void 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([config.client, input], additionalArguments)))];
                case 2:
                    page = _a.sent();
                    return [3 /*break*/, 6];
                case 3:
                    if (!(config.client instanceof __WEBPACK_IMPORTED_MODULE_2__CloudWatchLogsClient__["a" /* CloudWatchLogsClient */])) return [3 /*break*/, 5];
                    return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(makePagedClientRequest.apply(void 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([config.client, input], additionalArguments)))];
                case 4:
                    page = _a.sent();
                    return [3 /*break*/, 6];
                case 5: throw new Error("Invalid client, expected CloudWatchLogs | CloudWatchLogsClient");
                case 6: return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(page)];
                case 7: return [4 /*yield*/, _a.sent()];
                case 8:
                    _a.sent();
                    token = page.nextToken;
                    hasNext = !!token;
                    return [3 /*break*/, 1];
                case 9: return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(undefined)];
                case 10: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
}
//# sourceMappingURL=DescribeSubscriptionFiltersPaginator.js.map

/***/ }),
/* 1671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export paginateFilterLogEvents */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CloudWatchLogs__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CloudWatchLogsClient__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_FilterLogEventsCommand__ = __webpack_require__(520);




/**
 * @private
 */
var makePagedClientRequest = function (client, input) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.send.apply(client, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([new __WEBPACK_IMPORTED_MODULE_3__commands_FilterLogEventsCommand__["a" /* FilterLogEventsCommand */](input)], args))];
                case 1: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
};
/**
 * @private
 */
var makePagedRequest = function (client, input) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.filterLogEvents.apply(client, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([input], args))];
                case 1: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
};
function paginateFilterLogEvents(config, input) {
    var additionalArguments = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        additionalArguments[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __asyncGenerator */])(this, arguments, function paginateFilterLogEvents_1() {
        var token, hasNext, page;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = config.startingToken || undefined;
                    hasNext = true;
                    _a.label = 1;
                case 1:
                    if (!hasNext) return [3 /*break*/, 9];
                    input.nextToken = token;
                    input["limit"] = config.pageSize;
                    if (!(config.client instanceof __WEBPACK_IMPORTED_MODULE_1__CloudWatchLogs__["a" /* CloudWatchLogs */])) return [3 /*break*/, 3];
                    return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(makePagedRequest.apply(void 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([config.client, input], additionalArguments)))];
                case 2:
                    page = _a.sent();
                    return [3 /*break*/, 6];
                case 3:
                    if (!(config.client instanceof __WEBPACK_IMPORTED_MODULE_2__CloudWatchLogsClient__["a" /* CloudWatchLogsClient */])) return [3 /*break*/, 5];
                    return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(makePagedClientRequest.apply(void 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([config.client, input], additionalArguments)))];
                case 4:
                    page = _a.sent();
                    return [3 /*break*/, 6];
                case 5: throw new Error("Invalid client, expected CloudWatchLogs | CloudWatchLogsClient");
                case 6: return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(page)];
                case 7: return [4 /*yield*/, _a.sent()];
                case 8:
                    _a.sent();
                    token = page.nextToken;
                    hasNext = !!token;
                    return [3 /*break*/, 1];
                case 9: return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(undefined)];
                case 10: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
}
//# sourceMappingURL=FilterLogEventsPaginator.js.map

/***/ }),
/* 1672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export paginateGetLogEvents */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CloudWatchLogs__ = __webpack_require__(190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CloudWatchLogsClient__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_GetLogEventsCommand__ = __webpack_require__(521);




/**
 * @private
 */
var makePagedClientRequest = function (client, input) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.send.apply(client, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([new __WEBPACK_IMPORTED_MODULE_3__commands_GetLogEventsCommand__["a" /* GetLogEventsCommand */](input)], args))];
                case 1: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
};
/**
 * @private
 */
var makePagedRequest = function (client, input) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.getLogEvents.apply(client, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([input], args))];
                case 1: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
};
function paginateGetLogEvents(config, input) {
    var additionalArguments = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        additionalArguments[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __asyncGenerator */])(this, arguments, function paginateGetLogEvents_1() {
        var token, hasNext, page;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = config.startingToken || undefined;
                    hasNext = true;
                    _a.label = 1;
                case 1:
                    if (!hasNext) return [3 /*break*/, 9];
                    input.nextToken = token;
                    input["limit"] = config.pageSize;
                    if (!(config.client instanceof __WEBPACK_IMPORTED_MODULE_1__CloudWatchLogs__["a" /* CloudWatchLogs */])) return [3 /*break*/, 3];
                    return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(makePagedRequest.apply(void 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([config.client, input], additionalArguments)))];
                case 2:
                    page = _a.sent();
                    return [3 /*break*/, 6];
                case 3:
                    if (!(config.client instanceof __WEBPACK_IMPORTED_MODULE_2__CloudWatchLogsClient__["a" /* CloudWatchLogsClient */])) return [3 /*break*/, 5];
                    return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(makePagedClientRequest.apply(void 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([config.client, input], additionalArguments)))];
                case 4:
                    page = _a.sent();
                    return [3 /*break*/, 6];
                case 5: throw new Error("Invalid client, expected CloudWatchLogs | CloudWatchLogsClient");
                case 6: return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(page)];
                case 7: return [4 /*yield*/, _a.sent()];
                case 8:
                    _a.sent();
                    token = page.nextForwardToken;
                    hasNext = !!token;
                    return [3 /*break*/, 1];
                case 9: return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(undefined)];
                case 10: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
}
//# sourceMappingURL=GetLogEventsPaginator.js.map

/***/ }),
/* 1673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

//# sourceMappingURL=Interfaces.js.map

/***/ }),
/* 1674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientDefaultValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__package_json__ = __webpack_require__(1665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_crypto_sha256_browser__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_crypto_sha256_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__aws_crypto_sha256_browser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_fetch_http_handler__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_invalid_dependency__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_middleware_retry__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__aws_sdk_util_base64_browser__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__aws_sdk_util_body_length_browser__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__aws_sdk_util_user_agent_browser__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__aws_sdk_util_utf8_browser__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__runtimeConfig_shared__ = __webpack_require__(1675);











/**
 * @internal
 */
var ClientDefaultValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, __WEBPACK_IMPORTED_MODULE_10__runtimeConfig_shared__["a" /* ClientSharedValues */]), { runtime: "browser", base64Decoder: __WEBPACK_IMPORTED_MODULE_6__aws_sdk_util_base64_browser__["a" /* fromBase64 */], base64Encoder: __WEBPACK_IMPORTED_MODULE_6__aws_sdk_util_base64_browser__["b" /* toBase64 */], bodyLengthChecker: __WEBPACK_IMPORTED_MODULE_7__aws_sdk_util_body_length_browser__["a" /* calculateBodyLength */], credentialDefaultProvider: function (_) { return function () { return Promise.reject(new Error("Credential is missing")); }; }, defaultUserAgentProvider: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__aws_sdk_util_user_agent_browser__["a" /* defaultUserAgent */])({
        serviceId: __WEBPACK_IMPORTED_MODULE_10__runtimeConfig_shared__["a" /* ClientSharedValues */].serviceId,
        clientVersion: __WEBPACK_IMPORTED_MODULE_1__package_json___default.a.version,
    }), maxAttempts: __WEBPACK_IMPORTED_MODULE_5__aws_sdk_middleware_retry__["c" /* DEFAULT_MAX_ATTEMPTS */], region: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_invalid_dependency__["a" /* invalidProvider */])("Region is missing"), requestHandler: new __WEBPACK_IMPORTED_MODULE_3__aws_sdk_fetch_http_handler__["a" /* FetchHttpHandler */](), sha256: __WEBPACK_IMPORTED_MODULE_2__aws_crypto_sha256_browser__["Sha256"], streamCollector: __WEBPACK_IMPORTED_MODULE_3__aws_sdk_fetch_http_handler__["b" /* streamCollector */], utf8Decoder: __WEBPACK_IMPORTED_MODULE_9__aws_sdk_util_utf8_browser__["a" /* fromUtf8 */], utf8Encoder: __WEBPACK_IMPORTED_MODULE_9__aws_sdk_util_utf8_browser__["b" /* toUtf8 */] });
//# sourceMappingURL=runtimeConfig.browser.js.map

/***/ }),
/* 1675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientSharedValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__endpoints__ = __webpack_require__(1662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_url_parser__ = __webpack_require__(869);


/**
 * @internal
 */
var ClientSharedValues = {
    apiVersion: "2014-03-28",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: __WEBPACK_IMPORTED_MODULE_0__endpoints__["a" /* defaultRegionInfoProvider */],
    serviceId: "CloudWatch Logs",
    urlParser: __WEBPACK_IMPORTED_MODULE_1__aws_sdk_url_parser__["a" /* parseUrl */],
};
//# sourceMappingURL=runtimeConfig.shared.js.map

/***/ }),
/* 1676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fromUtf8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toUtf8; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pureJs__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__whatwgEncodingApi__ = __webpack_require__(1678);


var fromUtf8 = function (input) {
    return typeof TextEncoder === "function" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__whatwgEncodingApi__["a" /* fromUtf8 */])(input) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__pureJs__["a" /* fromUtf8 */])(input);
};
var toUtf8 = function (input) {
    return typeof TextDecoder === "function" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__whatwgEncodingApi__["b" /* toUtf8 */])(input) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__pureJs__["b" /* toUtf8 */])(input);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFFBQVEsSUFBSSxVQUFVLEVBQUUsTUFBTSxJQUFJLFFBQVEsRUFBRSxNQUFNLFVBQVUsQ0FBQztBQUN0RSxPQUFPLEVBQUUsUUFBUSxJQUFJLG1CQUFtQixFQUFFLE1BQU0sSUFBSSxpQkFBaUIsRUFBRSxNQUFNLHFCQUFxQixDQUFDO0FBS25HLE1BQU0sQ0FBQyxJQUFNLFFBQVEsR0FBRyxVQUFDLEtBQWE7SUFDcEMsT0FBQSxPQUFPLFdBQVcsS0FBSyxVQUFVLENBQUMsQ0FBQyxDQUFDLG1CQUFtQixDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxVQUFVLENBQUMsS0FBSyxDQUFDO0FBQWxGLENBQWtGLENBQUM7QUFFckYsTUFBTSxDQUFDLElBQU0sTUFBTSxHQUFHLFVBQUMsS0FBaUI7SUFDdEMsT0FBQSxPQUFPLFdBQVcsS0FBSyxVQUFVLENBQUMsQ0FBQyxDQUFDLGlCQUFpQixDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDO0FBQTlFLENBQThFLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBmcm9tVXRmOCBhcyBqc0Zyb21VdGY4LCB0b1V0ZjggYXMganNUb1V0ZjggfSBmcm9tIFwiLi9wdXJlSnNcIjtcbmltcG9ydCB7IGZyb21VdGY4IGFzIHRleHRFbmNvZGVyRnJvbVV0ZjgsIHRvVXRmOCBhcyB0ZXh0RW5jb2RlclRvVXRmOCB9IGZyb20gXCIuL3doYXR3Z0VuY29kaW5nQXBpXCI7XG5cbmRlY2xhcmUgY29uc3QgVGV4dERlY29kZXI6IEZ1bmN0aW9uIHwgdW5kZWZpbmVkO1xuZGVjbGFyZSBjb25zdCBUZXh0RW5jb2RlcjogRnVuY3Rpb24gfCB1bmRlZmluZWQ7XG5cbmV4cG9ydCBjb25zdCBmcm9tVXRmOCA9IChpbnB1dDogc3RyaW5nKTogVWludDhBcnJheSA9PlxuICB0eXBlb2YgVGV4dEVuY29kZXIgPT09IFwiZnVuY3Rpb25cIiA/IHRleHRFbmNvZGVyRnJvbVV0ZjgoaW5wdXQpIDoganNGcm9tVXRmOChpbnB1dCk7XG5cbmV4cG9ydCBjb25zdCB0b1V0ZjggPSAoaW5wdXQ6IFVpbnQ4QXJyYXkpOiBzdHJpbmcgPT5cbiAgdHlwZW9mIFRleHREZWNvZGVyID09PSBcImZ1bmN0aW9uXCIgPyB0ZXh0RW5jb2RlclRvVXRmOChpbnB1dCkgOiBqc1RvVXRmOChpbnB1dCk7XG4iXX0=

/***/ }),
/* 1677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fromUtf8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toUtf8; });
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */
var fromUtf8 = function (input) {
    var bytes = [];
    for (var i = 0, len = input.length; i < len; i++) {
        var value = input.charCodeAt(i);
        if (value < 0x80) {
            bytes.push(value);
        }
        else if (value < 0x800) {
            bytes.push((value >> 6) | 192, (value & 63) | 128);
        }
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push((surrogatePair >> 18) | 240, ((surrogatePair >> 12) & 63) | 128, ((surrogatePair >> 6) & 63) | 128, (surrogatePair & 63) | 128);
        }
        else {
            bytes.push((value >> 12) | 224, ((value >> 6) & 63) | 128, (value & 63) | 128);
        }
    }
    return Uint8Array.from(bytes);
};
/**
 * Converts a typed array of bytes containing UTF-8 data into a native JS
 * string.
 *
 * Partly cribbed from the `goog.crypt.utf8ByteArrayToString` function in the
 * Google Closure library, though updated to use typed arrays and to better
 * handle astral plane code points.
 */
var toUtf8 = function (input) {
    var decoded = "";
    for (var i = 0, len = input.length; i < len; i++) {
        var byte = input[i];
        if (byte < 0x80) {
            decoded += String.fromCharCode(byte);
        }
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode(((byte & 31) << 6) | (nextByte & 63));
        }
        else if (240 <= byte && byte < 365) {
            var surrogatePair = [byte, input[++i], input[++i], input[++i]];
            var encoded = "%" + surrogatePair.map(function (byteValue) { return byteValue.toString(16); }).join("%");
            decoded += decodeURIComponent(encoded);
        }
        else {
            decoded += String.fromCharCode(((byte & 15) << 12) | ((input[++i] & 63) << 6) | (input[++i] & 63));
        }
    }
    return decoded;
};
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromUtf8;
/* harmony export (immutable) */ __webpack_exports__["b"] = toUtf8;
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return defaultRegionInfoProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);

// Partition default templates
var AWS_TEMPLATE = "cognito-identity.{region}.amazonaws.com";
var AWS_CN_TEMPLATE = "cognito-identity.{region}.amazonaws.com.cn";
var AWS_ISO_TEMPLATE = "cognito-identity.{region}.c2s.ic.gov";
var AWS_ISO_B_TEMPLATE = "cognito-identity.{region}.sc2s.sgov.gov";
var AWS_US_GOV_TEMPLATE = "cognito-identity.{region}.amazonaws.com";
// Partition regions
var AWS_REGIONS = new Set([
    "af-south-1",
    "ap-east-1",
    "ap-northeast-1",
    "ap-northeast-2",
    "ap-south-1",
    "ap-southeast-1",
    "ap-southeast-2",
    "ca-central-1",
    "eu-central-1",
    "eu-north-1",
    "eu-south-1",
    "eu-west-1",
    "eu-west-2",
    "eu-west-3",
    "me-south-1",
    "sa-east-1",
    "us-east-1",
    "us-east-2",
    "us-west-1",
    "us-west-2",
]);
var AWS_CN_REGIONS = new Set(["cn-north-1", "cn-northwest-1"]);
var AWS_ISO_REGIONS = new Set(["us-iso-east-1"]);
var AWS_ISO_B_REGIONS = new Set(["us-isob-east-1"]);
var AWS_US_GOV_REGIONS = new Set(["us-gov-east-1", "us-gov-west-1"]);
var defaultRegionInfoProvider = function (region, options) {
    var regionInfo = undefined;
    switch (region) {
        // First, try to match exact region names.
        case "ap-northeast-1":
            regionInfo = {
                hostname: "cognito-identity.ap-northeast-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ap-northeast-2":
            regionInfo = {
                hostname: "cognito-identity.ap-northeast-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ap-south-1":
            regionInfo = {
                hostname: "cognito-identity.ap-south-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ap-southeast-1":
            regionInfo = {
                hostname: "cognito-identity.ap-southeast-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ap-southeast-2":
            regionInfo = {
                hostname: "cognito-identity.ap-southeast-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "ca-central-1":
            regionInfo = {
                hostname: "cognito-identity.ca-central-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "cn-north-1":
            regionInfo = {
                hostname: "cognito-identity.cn-north-1.amazonaws.com.cn",
                partition: "aws-cn",
            };
            break;
        case "eu-central-1":
            regionInfo = {
                hostname: "cognito-identity.eu-central-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "eu-north-1":
            regionInfo = {
                hostname: "cognito-identity.eu-north-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "eu-west-1":
            regionInfo = {
                hostname: "cognito-identity.eu-west-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "eu-west-2":
            regionInfo = {
                hostname: "cognito-identity.eu-west-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "eu-west-3":
            regionInfo = {
                hostname: "cognito-identity.eu-west-3.amazonaws.com",
                partition: "aws",
            };
            break;
        case "fips-us-east-1":
            regionInfo = {
                hostname: "cognito-identity-fips.us-east-1.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-1",
            };
            break;
        case "fips-us-east-2":
            regionInfo = {
                hostname: "cognito-identity-fips.us-east-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-east-2",
            };
            break;
        case "fips-us-gov-west-1":
            regionInfo = {
                hostname: "cognito-identity-fips.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
                signingRegion: "us-gov-west-1",
            };
            break;
        case "fips-us-west-2":
            regionInfo = {
                hostname: "cognito-identity-fips.us-west-2.amazonaws.com",
                partition: "aws",
                signingRegion: "us-west-2",
            };
            break;
        case "sa-east-1":
            regionInfo = {
                hostname: "cognito-identity.sa-east-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "us-east-1":
            regionInfo = {
                hostname: "cognito-identity.us-east-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "us-east-2":
            regionInfo = {
                hostname: "cognito-identity.us-east-2.amazonaws.com",
                partition: "aws",
            };
            break;
        case "us-gov-west-1":
            regionInfo = {
                hostname: "cognito-identity.us-gov-west-1.amazonaws.com",
                partition: "aws-us-gov",
            };
            break;
        case "us-west-1":
            regionInfo = {
                hostname: "cognito-identity.us-west-1.amazonaws.com",
                partition: "aws",
            };
            break;
        case "us-west-2":
            regionInfo = {
                hostname: "cognito-identity.us-west-2.amazonaws.com",
                partition: "aws",
            };
            break;
        // Next, try to match partition endpoints.
        default:
            if (AWS_REGIONS.has(region)) {
                regionInfo = {
                    hostname: AWS_TEMPLATE.replace("{region}", region),
                    partition: "aws",
                };
            }
            if (AWS_CN_REGIONS.has(region)) {
                regionInfo = {
                    hostname: AWS_CN_TEMPLATE.replace("{region}", region),
                    partition: "aws-cn",
                };
            }
            if (AWS_ISO_REGIONS.has(region)) {
                regionInfo = {
                    hostname: AWS_ISO_TEMPLATE.replace("{region}", region),
                    partition: "aws-iso",
                };
            }
            if (AWS_ISO_B_REGIONS.has(region)) {
                regionInfo = {
                    hostname: AWS_ISO_B_TEMPLATE.replace("{region}", region),
                    partition: "aws-iso-b",
                };
            }
            if (AWS_US_GOV_REGIONS.has(region)) {
                regionInfo = {
                    hostname: AWS_US_GOV_TEMPLATE.replace("{region}", region),
                    partition: "aws-us-gov",
                };
            }
            // Finally, assume it's an AWS partition endpoint.
            if (regionInfo === undefined) {
                regionInfo = {
                    hostname: AWS_TEMPLATE.replace("{region}", region),
                    partition: "aws",
                };
            }
    }
    return Promise.resolve(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({ signingService: "cognito-identity" }, regionInfo));
};
//# sourceMappingURL=endpoints.js.map

/***/ }),
/* 1680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_0__ = __webpack_require__(72);
/* unused harmony namespace reexport */

//# sourceMappingURL=index.js.map

/***/ }),
/* 1681 */
/***/ (function(module, exports) {

module.exports = {"name":"@aws-sdk/client-cognito-identity","description":"AWS SDK for JavaScript Cognito Identity Client for Node.js, Browser and React Native","version":"3.6.1","scripts":{"clean":"yarn remove-definitions && yarn remove-dist && yarn remove-documentation","build-documentation":"yarn remove-documentation && typedoc ./","prepublishOnly":"yarn build","pretest":"yarn build:cjs","remove-definitions":"rimraf ./types","remove-dist":"rimraf ./dist","remove-documentation":"rimraf ./docs","test:unit":"mocha **/cjs/**/*.spec.js","test:e2e":"mocha **/cjs/**/*.ispec.js && karma start karma.conf.js","test":"yarn test:unit","build:cjs":"tsc -p tsconfig.json","build:es":"tsc -p tsconfig.es.json","build":"yarn build:cjs && yarn build:es","postbuild":"downlevel-dts types types/ts3.4"},"main":"./dist/cjs/index.js","types":"./types/index.d.ts","module":"./dist/es/index.js","browser":{"./runtimeConfig":"./runtimeConfig.browser"},"react-native":{"./runtimeConfig":"./runtimeConfig.native"},"sideEffects":false,"dependencies":{"@aws-crypto/sha256-browser":"^1.0.0","@aws-crypto/sha256-js":"^1.0.0","@aws-sdk/config-resolver":"3.6.1","@aws-sdk/credential-provider-node":"3.6.1","@aws-sdk/fetch-http-handler":"3.6.1","@aws-sdk/hash-node":"3.6.1","@aws-sdk/invalid-dependency":"3.6.1","@aws-sdk/middleware-content-length":"3.6.1","@aws-sdk/middleware-host-header":"3.6.1","@aws-sdk/middleware-logger":"3.6.1","@aws-sdk/middleware-retry":"3.6.1","@aws-sdk/middleware-serde":"3.6.1","@aws-sdk/middleware-signing":"3.6.1","@aws-sdk/middleware-stack":"3.6.1","@aws-sdk/middleware-user-agent":"3.6.1","@aws-sdk/node-config-provider":"3.6.1","@aws-sdk/node-http-handler":"3.6.1","@aws-sdk/protocol-http":"3.6.1","@aws-sdk/smithy-client":"3.6.1","@aws-sdk/types":"3.6.1","@aws-sdk/url-parser":"3.6.1","@aws-sdk/url-parser-native":"3.6.1","@aws-sdk/util-base64-browser":"3.6.1","@aws-sdk/util-base64-node":"3.6.1","@aws-sdk/util-body-length-browser":"3.6.1","@aws-sdk/util-body-length-node":"3.6.1","@aws-sdk/util-user-agent-browser":"3.6.1","@aws-sdk/util-user-agent-node":"3.6.1","@aws-sdk/util-utf8-browser":"3.6.1","@aws-sdk/util-utf8-node":"3.6.1","tslib":"^2.0.0"},"devDependencies":{"@aws-sdk/client-documentation-generator":"3.6.1","@aws-sdk/client-iam":"3.6.1","@types/chai":"^4.2.11","@types/mocha":"^8.0.4","@types/node":"^12.7.5","downlevel-dts":"0.7.0","jest":"^26.1.0","rimraf":"^3.0.0","typedoc":"^0.19.2","typescript":"~4.1.2"},"engines":{"node":">=10.0.0"},"typesVersions":{"<4.0":{"types/*":["types/ts3.4/*"]}},"author":{"name":"AWS SDK for JavaScript Team","url":"https://aws.amazon.com/javascript/"},"license":"Apache-2.0","homepage":"https://github.com/aws/aws-sdk-js-v3/tree/main/clients/client-cognito-identity","repository":{"type":"git","url":"https://github.com/aws/aws-sdk-js-v3.git","directory":"clients/client-cognito-identity"}}

/***/ }),
/* 1682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

//# sourceMappingURL=Interfaces.js.map

/***/ }),
/* 1683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export paginateListIdentityPools */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CognitoIdentity__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CognitoIdentityClient__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__commands_ListIdentityPoolsCommand__ = __webpack_require__(523);




/**
 * @private
 */
var makePagedClientRequest = function (client, input) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.send.apply(client, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([new __WEBPACK_IMPORTED_MODULE_3__commands_ListIdentityPoolsCommand__["a" /* ListIdentityPoolsCommand */](input)], args))];
                case 1: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
};
/**
 * @private
 */
var makePagedRequest = function (client, input) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["c" /* __awaiter */])(void 0, void 0, void 0, function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, client.listIdentityPools.apply(client, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([input], args))];
                case 1: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
};
function paginateListIdentityPools(config, input) {
    var additionalArguments = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        additionalArguments[_i - 2] = arguments[_i];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["g" /* __asyncGenerator */])(this, arguments, function paginateListIdentityPools_1() {
        var token, hasNext, page;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["d" /* __generator */])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    token = config.startingToken || undefined;
                    hasNext = true;
                    _a.label = 1;
                case 1:
                    if (!hasNext) return [3 /*break*/, 9];
                    input.NextToken = token;
                    input["MaxResults"] = config.pageSize;
                    if (!(config.client instanceof __WEBPACK_IMPORTED_MODULE_1__CognitoIdentity__["a" /* CognitoIdentity */])) return [3 /*break*/, 3];
                    return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(makePagedRequest.apply(void 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([config.client, input], additionalArguments)))];
                case 2:
                    page = _a.sent();
                    return [3 /*break*/, 6];
                case 3:
                    if (!(config.client instanceof __WEBPACK_IMPORTED_MODULE_2__CognitoIdentityClient__["a" /* CognitoIdentityClient */])) return [3 /*break*/, 5];
                    return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(makePagedClientRequest.apply(void 0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["f" /* __spread */])([config.client, input], additionalArguments)))];
                case 4:
                    page = _a.sent();
                    return [3 /*break*/, 6];
                case 5: throw new Error("Invalid client, expected CognitoIdentity | CognitoIdentityClient");
                case 6: return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(page)];
                case 7: return [4 /*yield*/, _a.sent()];
                case 8:
                    _a.sent();
                    token = page.NextToken;
                    hasNext = !!token;
                    return [3 /*break*/, 1];
                case 9: return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["h" /* __await */])(undefined)];
                case 10: 
                // @ts-ignore
                return [2 /*return*/, _a.sent()];
            }
        });
    });
}
//# sourceMappingURL=ListIdentityPoolsPaginator.js.map

/***/ }),
/* 1684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientDefaultValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__package_json__ = __webpack_require__(1681);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_crypto_sha256_browser__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_crypto_sha256_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__aws_crypto_sha256_browser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__aws_sdk_fetch_http_handler__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__aws_sdk_invalid_dependency__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__aws_sdk_middleware_retry__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__aws_sdk_util_base64_browser__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__aws_sdk_util_body_length_browser__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__aws_sdk_util_user_agent_browser__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__aws_sdk_util_utf8_browser__ = __webpack_require__(1686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__runtimeConfig_shared__ = __webpack_require__(1685);











/**
 * @internal
 */
var ClientDefaultValues = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["a" /* __assign */])({}, __WEBPACK_IMPORTED_MODULE_10__runtimeConfig_shared__["a" /* ClientSharedValues */]), { runtime: "browser", base64Decoder: __WEBPACK_IMPORTED_MODULE_6__aws_sdk_util_base64_browser__["a" /* fromBase64 */], base64Encoder: __WEBPACK_IMPORTED_MODULE_6__aws_sdk_util_base64_browser__["b" /* toBase64 */], bodyLengthChecker: __WEBPACK_IMPORTED_MODULE_7__aws_sdk_util_body_length_browser__["a" /* calculateBodyLength */], credentialDefaultProvider: function (_) { return function () { return Promise.reject(new Error("Credential is missing")); }; }, defaultUserAgentProvider: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__aws_sdk_util_user_agent_browser__["a" /* defaultUserAgent */])({
        serviceId: __WEBPACK_IMPORTED_MODULE_10__runtimeConfig_shared__["a" /* ClientSharedValues */].serviceId,
        clientVersion: __WEBPACK_IMPORTED_MODULE_1__package_json___default.a.version,
    }), maxAttempts: __WEBPACK_IMPORTED_MODULE_5__aws_sdk_middleware_retry__["c" /* DEFAULT_MAX_ATTEMPTS */], region: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__aws_sdk_invalid_dependency__["a" /* invalidProvider */])("Region is missing"), requestHandler: new __WEBPACK_IMPORTED_MODULE_3__aws_sdk_fetch_http_handler__["a" /* FetchHttpHandler */](), sha256: __WEBPACK_IMPORTED_MODULE_2__aws_crypto_sha256_browser__["Sha256"], streamCollector: __WEBPACK_IMPORTED_MODULE_3__aws_sdk_fetch_http_handler__["b" /* streamCollector */], utf8Decoder: __WEBPACK_IMPORTED_MODULE_9__aws_sdk_util_utf8_browser__["a" /* fromUtf8 */], utf8Encoder: __WEBPACK_IMPORTED_MODULE_9__aws_sdk_util_utf8_browser__["b" /* toUtf8 */] });
//# sourceMappingURL=runtimeConfig.browser.js.map

/***/ }),
/* 1685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ClientSharedValues; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__endpoints__ = __webpack_require__(1679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_url_parser__ = __webpack_require__(869);


/**
 * @internal
 */
var ClientSharedValues = {
    apiVersion: "2014-06-30",
    disableHostPrefix: false,
    logger: {},
    regionInfoProvider: __WEBPACK_IMPORTED_MODULE_0__endpoints__["a" /* defaultRegionInfoProvider */],
    serviceId: "Cognito Identity",
    urlParser: __WEBPACK_IMPORTED_MODULE_1__aws_sdk_url_parser__["a" /* parseUrl */],
};
//# sourceMappingURL=runtimeConfig.shared.js.map

/***/ }),
/* 1686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fromUtf8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toUtf8; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pureJs__ = __webpack_require__(1687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__whatwgEncodingApi__ = __webpack_require__(1688);


var fromUtf8 = function (input) {
    return typeof TextEncoder === "function" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__whatwgEncodingApi__["a" /* fromUtf8 */])(input) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__pureJs__["a" /* fromUtf8 */])(input);
};
var toUtf8 = function (input) {
    return typeof TextDecoder === "function" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__whatwgEncodingApi__["b" /* toUtf8 */])(input) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__pureJs__["b" /* toUtf8 */])(input);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFFBQVEsSUFBSSxVQUFVLEVBQUUsTUFBTSxJQUFJLFFBQVEsRUFBRSxNQUFNLFVBQVUsQ0FBQztBQUN0RSxPQUFPLEVBQUUsUUFBUSxJQUFJLG1CQUFtQixFQUFFLE1BQU0sSUFBSSxpQkFBaUIsRUFBRSxNQUFNLHFCQUFxQixDQUFDO0FBS25HLE1BQU0sQ0FBQyxJQUFNLFFBQVEsR0FBRyxVQUFDLEtBQWE7SUFDcEMsT0FBQSxPQUFPLFdBQVcsS0FBSyxVQUFVLENBQUMsQ0FBQyxDQUFDLG1CQUFtQixDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxVQUFVLENBQUMsS0FBSyxDQUFDO0FBQWxGLENBQWtGLENBQUM7QUFFckYsTUFBTSxDQUFDLElBQU0sTUFBTSxHQUFHLFVBQUMsS0FBaUI7SUFDdEMsT0FBQSxPQUFPLFdBQVcsS0FBSyxVQUFVLENBQUMsQ0FBQyxDQUFDLGlCQUFpQixDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDO0FBQTlFLENBQThFLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBmcm9tVXRmOCBhcyBqc0Zyb21VdGY4LCB0b1V0ZjggYXMganNUb1V0ZjggfSBmcm9tIFwiLi9wdXJlSnNcIjtcbmltcG9ydCB7IGZyb21VdGY4IGFzIHRleHRFbmNvZGVyRnJvbVV0ZjgsIHRvVXRmOCBhcyB0ZXh0RW5jb2RlclRvVXRmOCB9IGZyb20gXCIuL3doYXR3Z0VuY29kaW5nQXBpXCI7XG5cbmRlY2xhcmUgY29uc3QgVGV4dERlY29kZXI6IEZ1bmN0aW9uIHwgdW5kZWZpbmVkO1xuZGVjbGFyZSBjb25zdCBUZXh0RW5jb2RlcjogRnVuY3Rpb24gfCB1bmRlZmluZWQ7XG5cbmV4cG9ydCBjb25zdCBmcm9tVXRmOCA9IChpbnB1dDogc3RyaW5nKTogVWludDhBcnJheSA9PlxuICB0eXBlb2YgVGV4dEVuY29kZXIgPT09IFwiZnVuY3Rpb25cIiA/IHRleHRFbmNvZGVyRnJvbVV0ZjgoaW5wdXQpIDoganNGcm9tVXRmOChpbnB1dCk7XG5cbmV4cG9ydCBjb25zdCB0b1V0ZjggPSAoaW5wdXQ6IFVpbnQ4QXJyYXkpOiBzdHJpbmcgPT5cbiAgdHlwZW9mIFRleHREZWNvZGVyID09PSBcImZ1bmN0aW9uXCIgPyB0ZXh0RW5jb2RlclRvVXRmOChpbnB1dCkgOiBqc1RvVXRmOChpbnB1dCk7XG4iXX0=

/***/ }),
/* 1687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fromUtf8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toUtf8; });
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */
var fromUtf8 = function (input) {
    var bytes = [];
    for (var i = 0, len = input.length; i < len; i++) {
        var value = input.charCodeAt(i);
        if (value < 0x80) {
            bytes.push(value);
        }
        else if (value < 0x800) {
            bytes.push((value >> 6) | 192, (value & 63) | 128);
        }
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push((surrogatePair >> 18) | 240, ((surrogatePair >> 12) & 63) | 128, ((surrogatePair >> 6) & 63) | 128, (surrogatePair & 63) | 128);
        }
        else {
            bytes.push((value >> 12) | 224, ((value >> 6) & 63) | 128, (value & 63) | 128);
        }
    }
    return Uint8Array.from(bytes);
};
/**
 * Converts a typed array of bytes containing UTF-8 data into a native JS
 * string.
 *
 * Partly cribbed from the `goog.crypt.utf8ByteArrayToString` function in the
 * Google Closure library, though updated to use typed arrays and to better
 * handle astral plane code points.
 */
var toUtf8 = function (input) {
    var decoded = "";
    for (var i = 0, len = input.length; i < len; i++) {
        var byte = input[i];
        if (byte < 0x80) {
            decoded += String.fromCharCode(byte);
        }
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode(((byte & 31) << 6) | (nextByte & 63));
        }
        else if (240 <= byte && byte < 365) {
            var surrogatePair = [byte, input[++i], input[++i], input[++i]];
            var encoded = "%" + surrogatePair.map(function (byteValue) { return byteValue.toString(16); }).join("%");
            decoded += decodeURIComponent(encoded);
        }
        else {
            decoded += String.fromCharCode(((byte & 15) << 12) | ((input[++i] & 63) << 6) | (input[++i] & 63));
        }
    }
    return decoded;
};
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromUtf8;
/* harmony export (immutable) */ __webpack_exports__["b"] = toUtf8;
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resolveEndpointsConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);

var resolveEndpointsConfig = function (input) {
    var _a;
    return (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, input), { tls: (_a = input.tls) !== null && _a !== void 0 ? _a : true, endpoint: input.endpoint ? normalizeEndpoint(input) : function () { return getEndPointFromRegion(input); }, isCustomEndpoint: input.endpoint ? true : false }));
};
var normalizeEndpoint = function (input) {
    var endpoint = input.endpoint, urlParser = input.urlParser;
    if (typeof endpoint === "string") {
        var promisified_1 = Promise.resolve(urlParser(endpoint));
        return function () { return promisified_1; };
    }
    else if (typeof endpoint === "object") {
        var promisified_2 = Promise.resolve(endpoint);
        return function () { return promisified_2; };
    }
    return endpoint;
};
var getEndPointFromRegion = function (input) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(void 0, void 0, void 0, function () {
    var _a, tls, region, dnsHostRegex, hostname;
    var _b;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_c) {
        switch (_c.label) {
            case 0:
                _a = input.tls, tls = _a === void 0 ? true : _a;
                return [4 /*yield*/, input.region()];
            case 1:
                region = _c.sent();
                dnsHostRegex = new RegExp(/^([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]{0,61}[a-zA-Z0-9])$/);
                if (!dnsHostRegex.test(region)) {
                    throw new Error("Invalid region in client config");
                }
                return [4 /*yield*/, input.regionInfoProvider(region)];
            case 2:
                hostname = ((_b = (_c.sent())) !== null && _b !== void 0 ? _b : {}).hostname;
                if (!hostname) {
                    throw new Error("Cannot resolve hostname from client config");
                }
                return [2 /*return*/, input.urlParser((tls ? "https:" : "http:") + "//" + hostname)];
        }
    });
}); };
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export REGION_ENV_NAME */
/* unused harmony export REGION_INI_NAME */
/* unused harmony export NODE_REGION_CONFIG_OPTIONS */
/* unused harmony export NODE_REGION_CONFIG_FILE_OPTIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resolveRegionConfig; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);

var REGION_ENV_NAME = "AWS_REGION";
var REGION_INI_NAME = "region";
var NODE_REGION_CONFIG_OPTIONS = {
    environmentVariableSelector: function (env) { return env[REGION_ENV_NAME]; },
    configFileSelector: function (profile) { return profile[REGION_INI_NAME]; },
    default: function () {
        throw new Error("Region is missing");
    },
};
var NODE_REGION_CONFIG_FILE_OPTIONS = {
    preferredFile: "credentials",
};
var resolveRegionConfig = function (input) {
    if (!input.region) {
        throw new Error("Region is missing");
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, input), { region: normalizeRegion(input.region) });
};
var normalizeRegion = function (region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function () { return promisified_1; };
    }
    return region;
};
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ29nbml0b1Byb3ZpZGVyUGFyYW1ldGVycy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9Db2duaXRvUHJvdmlkZXJQYXJhbWV0ZXJzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiIiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBDb2duaXRvSWRlbnRpdHlDbGllbnQgfSBmcm9tIFwiQGF3cy1zZGsvY2xpZW50LWNvZ25pdG8taWRlbnRpdHlcIjtcblxuaW1wb3J0IHsgTG9naW5zIH0gZnJvbSBcIi4vTG9naW5zXCI7XG5cbmV4cG9ydCBpbnRlcmZhY2UgQ29nbml0b1Byb3ZpZGVyUGFyYW1ldGVycyB7XG4gIC8qKlxuICAgKiBUaGUgU0RLIGNsaWVudCB3aXRoIHdoaWNoIHRoZSBjcmVkZW50aWFsIHByb3ZpZGVyIHdpbGwgY29udGFjdCB0aGUgQW1hem9uXG4gICAqIENvZ25pdG8gc2VydmljZS5cbiAgICovXG4gIGNsaWVudDogQ29nbml0b0lkZW50aXR5Q2xpZW50O1xuXG4gIC8qKlxuICAgKiBUaGUgQW1hem9uIFJlc291cmNlIE5hbWUgKEFSTikgb2YgdGhlIHJvbGUgdG8gYmUgYXNzdW1lZCB3aGVuIG11bHRpcGxlXG4gICAqIHJvbGVzIHdlcmUgcmVjZWl2ZWQgaW4gdGhlIHRva2VuIGZyb20gdGhlIGlkZW50aXR5IHByb3ZpZGVyLiBGb3IgZXhhbXBsZSxcbiAgICogYSBTQU1MLWJhc2VkIGlkZW50aXR5IHByb3ZpZGVyLiBUaGlzIHBhcmFtZXRlciBpcyBvcHRpb25hbCBmb3IgaWRlbnRpdHlcbiAgICogcHJvdmlkZXJzIHRoYXQgZG8gbm90IHN1cHBvcnQgcm9sZSBjdXN0b21pemF0aW9uLlxuICAgKi9cbiAgY3VzdG9tUm9sZUFybj86IHN0cmluZztcblxuICAvKipcbiAgICogQSBzZXQgb2Yga2V5LXZhbHVlIHBhaXJzIHRoYXQgbWFwIGV4dGVybmFsIGlkZW50aXR5IHByb3ZpZGVyIG5hbWVzIHRvXG4gICAqIGxvZ2luIHRva2VucyBvciBmdW5jdGlvbnMgdGhhdCByZXR1cm4gcHJvbWlzZXMgZm9yIGxvZ2luIHRva2Vucy4gVGhlXG4gICAqIGxhdHRlciBzaG91bGQgYmUgdXNlZCB3aGVuIGxvZ2luIHRva2VucyBtdXN0IGJlIHBlcmlvZGljYWxseSByZWZyZXNoZWQuXG4gICAqXG4gICAqIExvZ2lucyBzaG91bGQgbm90IGJlIHNwZWNpZmllZCB3aGVuIHRyeWluZyB0byBnZXQgY3JlZGVudGlhbHMgZm9yIGFuXG4gICAqIHVuYXV0aGVudGljYXRlZCBpZGVudGl0eS5cbiAgICovXG4gIGxvZ2lucz86IExvZ2lucztcbn1cbiJdfQ==

/***/ }),
/* 1692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InMemoryStorage; });
var InMemoryStorage = /** @class */ (function () {
    function InMemoryStorage(store) {
        if (store === void 0) { store = {}; }
        this.store = store;
    }
    InMemoryStorage.prototype.getItem = function (key) {
        if (key in this.store) {
            return this.store[key];
        }
        return null;
    };
    InMemoryStorage.prototype.removeItem = function (key) {
        delete this.store[key];
    };
    InMemoryStorage.prototype.setItem = function (key, value) {
        this.store[key] = value;
    };
    return InMemoryStorage;
}());

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5NZW1vcnlTdG9yYWdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL0luTWVtb3J5U3RvcmFnZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQTtJQUNFLHlCQUFvQixLQUFxQztRQUFyQyxzQkFBQSxFQUFBLFVBQXFDO1FBQXJDLFVBQUssR0FBTCxLQUFLLENBQWdDO0lBQUcsQ0FBQztJQUU3RCxpQ0FBTyxHQUFQLFVBQVEsR0FBVztRQUNqQixJQUFJLEdBQUcsSUFBSSxJQUFJLENBQUMsS0FBSyxFQUFFO1lBQ3JCLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQztTQUN4QjtRQUVELE9BQU8sSUFBSSxDQUFDO0lBQ2QsQ0FBQztJQUVELG9DQUFVLEdBQVYsVUFBVyxHQUFXO1FBQ3BCLE9BQU8sSUFBSSxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUN6QixDQUFDO0lBRUQsaUNBQU8sR0FBUCxVQUFRLEdBQVcsRUFBRSxLQUFhO1FBQ2hDLElBQUksQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLEdBQUcsS0FBSyxDQUFDO0lBQzFCLENBQUM7SUFDSCxzQkFBQztBQUFELENBQUMsQUFsQkQsSUFrQkMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBTdG9yYWdlIH0gZnJvbSBcIi4vU3RvcmFnZVwiO1xuXG5leHBvcnQgY2xhc3MgSW5NZW1vcnlTdG9yYWdlIGltcGxlbWVudHMgU3RvcmFnZSB7XG4gIGNvbnN0cnVjdG9yKHByaXZhdGUgc3RvcmU6IHsgW2tleTogc3RyaW5nXTogc3RyaW5nIH0gPSB7fSkge31cblxuICBnZXRJdGVtKGtleTogc3RyaW5nKTogc3RyaW5nIHwgbnVsbCB7XG4gICAgaWYgKGtleSBpbiB0aGlzLnN0b3JlKSB7XG4gICAgICByZXR1cm4gdGhpcy5zdG9yZVtrZXldO1xuICAgIH1cblxuICAgIHJldHVybiBudWxsO1xuICB9XG5cbiAgcmVtb3ZlSXRlbShrZXk6IHN0cmluZyk6IHZvaWQge1xuICAgIGRlbGV0ZSB0aGlzLnN0b3JlW2tleV07XG4gIH1cblxuICBzZXRJdGVtKGtleTogc3RyaW5nLCB2YWx1ZTogc3RyaW5nKTogdm9pZCB7XG4gICAgdGhpcy5zdG9yZVtrZXldID0gdmFsdWU7XG4gIH1cbn1cbiJdfQ==

/***/ }),
/* 1693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return IndexedDbStorage; });
var STORE_NAME = "IdentityIds";
var IndexedDbStorage = /** @class */ (function () {
    function IndexedDbStorage(dbName) {
        if (dbName === void 0) { dbName = "aws:cognito-identity-ids"; }
        this.dbName = dbName;
    }
    IndexedDbStorage.prototype.getItem = function (key) {
        return this.withObjectStore("readonly", function (store) {
            var req = store.get(key);
            return new Promise(function (resolve) {
                req.onerror = function () { return resolve(null); };
                req.onsuccess = function () { return resolve(req.result ? req.result.value : null); };
            });
        }).catch(function () { return null; });
    };
    IndexedDbStorage.prototype.removeItem = function (key) {
        return this.withObjectStore("readwrite", function (store) {
            var req = store.delete(key);
            return new Promise(function (resolve, reject) {
                req.onerror = function () { return reject(req.error); };
                req.onsuccess = function () { return resolve(); };
            });
        });
    };
    IndexedDbStorage.prototype.setItem = function (id, value) {
        return this.withObjectStore("readwrite", function (store) {
            var req = store.put({ id: id, value: value });
            return new Promise(function (resolve, reject) {
                req.onerror = function () { return reject(req.error); };
                req.onsuccess = function () { return resolve(); };
            });
        });
    };
    IndexedDbStorage.prototype.getDb = function () {
        var openDbRequest = self.indexedDB.open(this.dbName, 1);
        return new Promise(function (resolve, reject) {
            openDbRequest.onsuccess = function () {
                resolve(openDbRequest.result);
            };
            openDbRequest.onerror = function () {
                reject(openDbRequest.error);
            };
            openDbRequest.onblocked = function () {
                reject(new Error("Unable to access DB"));
            };
            openDbRequest.onupgradeneeded = function () {
                var db = openDbRequest.result;
                db.onerror = function () {
                    reject(new Error("Failed to create object store"));
                };
                db.createObjectStore(STORE_NAME, { keyPath: "id" });
            };
        });
    };
    IndexedDbStorage.prototype.withObjectStore = function (mode, action) {
        return this.getDb().then(function (db) {
            var tx = db.transaction(STORE_NAME, mode);
            tx.oncomplete = function () { return db.close(); };
            return new Promise(function (resolve, reject) {
                tx.onerror = function () { return reject(tx.error); };
                resolve(action(tx.objectStore(STORE_NAME)));
            }).catch(function (err) {
                db.close();
                throw err;
            });
        });
    };
    return IndexedDbStorage;
}());

//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTG9naW5zLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL0xvZ2lucy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgUHJvdmlkZXIgfSBmcm9tIFwiQGF3cy1zZGsvdHlwZXNcIjtcblxuZXhwb3J0IGludGVyZmFjZSBMb2dpbnMge1xuICBbcHJvdmlkZXJOYW1lOiBzdHJpbmddOiBzdHJpbmcgfCBQcm92aWRlcjxzdHJpbmc+O1xufVxuXG5leHBvcnQgaW50ZXJmYWNlIFJlc29sdmVkTG9naW5zIHtcbiAgW3Byb3ZpZGVyTmFtZTogc3RyaW5nXTogc3RyaW5nO1xufVxuIl19

/***/ }),
/* 1695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiU3RvcmFnZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9TdG9yYWdlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiIiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEEgc3Vic2V0IG9mIHRoZSBTdG9yYWdlIGludGVyZmFjZSBkZWZpbmVkIGluIHRoZSBXSEFUV0cgSFRNTCBzcGVjaWZpY2F0aW9uLlxuICogQWNjZXNzIGJ5IGluZGV4IGlzIG5vdCBzdXBwb3J0ZWQsIGFzIGl0IGNhbm5vdCBiZSByZXBsaWNhdGVkIHdpdGhvdXQgUHJveHlcbiAqIG9iamVjdHMuXG4gKlxuICogVGhlIGludGVyZmFjZSBoYXMgYmVlbiBhdWdtZW50ZWQgdG8gc3VwcG9ydCBhc3luY2hyb25vdXMgc3RvcmFnZVxuICpcbiAqIEBzZWUgaHR0cHM6Ly9odG1sLnNwZWMud2hhdHdnLm9yZy9tdWx0aXBhZ2Uvd2Vic3RvcmFnZS5odG1sI3RoZS1zdG9yYWdlLWludGVyZmFjZVxuICovXG5leHBvcnQgaW50ZXJmYWNlIFN0b3JhZ2Uge1xuICBnZXRJdGVtKGtleTogc3RyaW5nKTogc3RyaW5nIHwgbnVsbCB8IFByb21pc2U8c3RyaW5nIHwgbnVsbD47XG4gIHJlbW92ZUl0ZW0oa2V5OiBzdHJpbmcpOiB2b2lkIHwgUHJvbWlzZTx2b2lkPjtcbiAgc2V0SXRlbShrZXk6IHN0cmluZywgZGF0YTogc3RyaW5nKTogdm9pZCB8IFByb21pc2U8dm9pZD47XG59XG4iXX0=

/***/ }),
/* 1696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromCognitoIdentityPool;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_client_cognito_identity__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_sdk_property_provider__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fromCognitoIdentity__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__localStorage__ = __webpack_require__(1698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resolveLogins__ = __webpack_require__(849);






/**
 * Retrieves or generates a unique identifier using Amazon Cognito's `GetId`
 * operation, then generates temporary AWS credentials using Amazon Cognito's
 * `GetCredentialsForIdentity` operation.
 *
 * Results from `GetId` are cached internally, but results from
 * `GetCredentialsForIdentity` are not.
 */
function fromCognitoIdentityPool(_a) {
    var _this = this;
    var accountId = _a.accountId, _b = _a.cache, cache = _b === void 0 ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__localStorage__["a" /* localStorage */])() : _b, client = _a.client, customRoleArn = _a.customRoleArn, identityPoolId = _a.identityPoolId, logins = _a.logins, _c = _a.userIdentifier, userIdentifier = _c === void 0 ? !logins || Object.keys(logins).length === 0 ? "ANONYMOUS" : undefined : _c;
    var cacheKey = userIdentifier ? "aws:cognito-identity-credentials:" + identityPoolId + ":" + userIdentifier : undefined;
    var provider = function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(_this, void 0, void 0, function () {
        var identityId, _a, _b, IdentityId, _c, _d, _e, _f;
        var _g;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_h) {
            switch (_h.label) {
                case 0:
                    _a = cacheKey;
                    if (!_a) return [3 /*break*/, 2];
                    return [4 /*yield*/, cache.getItem(cacheKey)];
                case 1:
                    _a = (_h.sent());
                    _h.label = 2;
                case 2:
                    identityId = _a;
                    if (!!identityId) return [3 /*break*/, 7];
                    _d = (_c = client).send;
                    _e = __WEBPACK_IMPORTED_MODULE_1__aws_sdk_client_cognito_identity__["GetIdCommand"].bind;
                    _g = {
                        AccountId: accountId,
                        IdentityPoolId: identityPoolId
                    };
                    if (!logins) return [3 /*break*/, 4];
                    return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__resolveLogins__["a" /* resolveLogins */])(logins)];
                case 3:
                    _f = _h.sent();
                    return [3 /*break*/, 5];
                case 4:
                    _f = undefined;
                    _h.label = 5;
                case 5: return [4 /*yield*/, _d.apply(_c, [new (_e.apply(__WEBPACK_IMPORTED_MODULE_1__aws_sdk_client_cognito_identity__["GetIdCommand"], [void 0, (_g.Logins = _f,
                                _g)]))()])];
                case 6:
                    _b = (_h.sent()).IdentityId, IdentityId = _b === void 0 ? throwOnMissingId() : _b;
                    identityId = IdentityId;
                    if (cacheKey) {
                        Promise.resolve(cache.setItem(cacheKey, identityId)).catch(function () { });
                    }
                    _h.label = 7;
                case 7:
                    provider = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fromCognitoIdentity__["a" /* fromCognitoIdentity */])({
                        client: client,
                        customRoleArn: customRoleArn,
                        logins: logins,
                        identityId: identityId,
                    });
                    return [2 /*return*/, provider()];
            }
        });
    }); };
    return function () {
        return provider().catch(function (err) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(_this, void 0, void 0, function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
                if (cacheKey) {
                    Promise.resolve(cache.removeItem(cacheKey)).catch(function () { });
                }
                throw err;
            });
        }); });
    };
}
function throwOnMissingId() {
    throw new __WEBPACK_IMPORTED_MODULE_2__aws_sdk_property_provider__["a" /* ProviderError */]("Response from Amazon Cognito contained no identity ID");
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CognitoProviderParameters__ = __webpack_require__(1691);
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__CognitoProviderParameters__, "fromCognitoIdentity")) __webpack_require__.d(__webpack_exports__, "fromCognitoIdentity", function() { return __WEBPACK_IMPORTED_MODULE_0__CognitoProviderParameters__["fromCognitoIdentity"]; });
/* harmony namespace reexport (by used) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_0__CognitoProviderParameters__, "fromCognitoIdentityPool")) __webpack_require__.d(__webpack_exports__, "fromCognitoIdentityPool", function() { return __WEBPACK_IMPORTED_MODULE_0__CognitoProviderParameters__["fromCognitoIdentityPool"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fromCognitoIdentity__ = __webpack_require__(848);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "fromCognitoIdentity", function() { return __WEBPACK_IMPORTED_MODULE_1__fromCognitoIdentity__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fromCognitoIdentityPool__ = __webpack_require__(1696);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "fromCognitoIdentityPool", function() { return __WEBPACK_IMPORTED_MODULE_2__fromCognitoIdentityPool__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Logins__ = __webpack_require__(1694);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Storage__ = __webpack_require__(1695);
/* unused harmony namespace reexport */





//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyw2QkFBNkIsQ0FBQztBQUM1QyxjQUFjLHVCQUF1QixDQUFDO0FBQ3RDLGNBQWMsMkJBQTJCLENBQUM7QUFDMUMsY0FBYyxVQUFVLENBQUM7QUFDekIsY0FBYyxXQUFXLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgKiBmcm9tIFwiLi9Db2duaXRvUHJvdmlkZXJQYXJhbWV0ZXJzXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9mcm9tQ29nbml0b0lkZW50aXR5XCI7XG5leHBvcnQgKiBmcm9tIFwiLi9mcm9tQ29nbml0b0lkZW50aXR5UG9vbFwiO1xuZXhwb3J0ICogZnJvbSBcIi4vTG9naW5zXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9TdG9yYWdlXCI7XG4iXX0=

/***/ }),
/* 1698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = localStorage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IndexedDbStorage__ = __webpack_require__(1693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__InMemoryStorage__ = __webpack_require__(1692);


var inMemoryStorage = new __WEBPACK_IMPORTED_MODULE_1__InMemoryStorage__["a" /* InMemoryStorage */]();
function localStorage() {
    if (typeof self === "object" && self.indexedDB) {
        return new __WEBPACK_IMPORTED_MODULE_0__IndexedDbStorage__["a" /* IndexedDbStorage */]();
    }
    if (typeof window === "object" && window.localStorage) {
        return window.localStorage;
    }
    return inMemoryStorage;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9jYWxTdG9yYWdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2xvY2FsU3RvcmFnZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsZ0JBQWdCLEVBQUUsTUFBTSxvQkFBb0IsQ0FBQztBQUN0RCxPQUFPLEVBQUUsZUFBZSxFQUFFLE1BQU0sbUJBQW1CLENBQUM7QUFHcEQsSUFBTSxlQUFlLEdBQUcsSUFBSSxlQUFlLEVBQUUsQ0FBQztBQUU5QyxNQUFNLFVBQVUsWUFBWTtJQUMxQixJQUFJLE9BQU8sSUFBSSxLQUFLLFFBQVEsSUFBSSxJQUFJLENBQUMsU0FBUyxFQUFFO1FBQzlDLE9BQU8sSUFBSSxnQkFBZ0IsRUFBRSxDQUFDO0tBQy9CO0lBRUQsSUFBSSxPQUFPLE1BQU0sS0FBSyxRQUFRLElBQUksTUFBTSxDQUFDLFlBQVksRUFBRTtRQUNyRCxPQUFPLE1BQU0sQ0FBQyxZQUFZLENBQUM7S0FDNUI7SUFFRCxPQUFPLGVBQWUsQ0FBQztBQUN6QixDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgSW5kZXhlZERiU3RvcmFnZSB9IGZyb20gXCIuL0luZGV4ZWREYlN0b3JhZ2VcIjtcbmltcG9ydCB7IEluTWVtb3J5U3RvcmFnZSB9IGZyb20gXCIuL0luTWVtb3J5U3RvcmFnZVwiO1xuaW1wb3J0IHsgU3RvcmFnZSB9IGZyb20gXCIuL1N0b3JhZ2VcIjtcblxuY29uc3QgaW5NZW1vcnlTdG9yYWdlID0gbmV3IEluTWVtb3J5U3RvcmFnZSgpO1xuXG5leHBvcnQgZnVuY3Rpb24gbG9jYWxTdG9yYWdlKCk6IFN0b3JhZ2Uge1xuICBpZiAodHlwZW9mIHNlbGYgPT09IFwib2JqZWN0XCIgJiYgc2VsZi5pbmRleGVkREIpIHtcbiAgICByZXR1cm4gbmV3IEluZGV4ZWREYlN0b3JhZ2UoKTtcbiAgfVxuXG4gIGlmICh0eXBlb2Ygd2luZG93ID09PSBcIm9iamVjdFwiICYmIHdpbmRvdy5sb2NhbFN0b3JhZ2UpIHtcbiAgICByZXR1cm4gd2luZG93LmxvY2FsU3RvcmFnZTtcbiAgfVxuXG4gIHJldHVybiBpbk1lbW9yeVN0b3JhZ2U7XG59XG4iXX0=

/***/ }),
/* 1699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchHttpHandler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_sdk_querystring_builder__ = __webpack_require__(1727);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__request_timeout__ = __webpack_require__(1700);




var FetchHttpHandler = /** @class */ (function () {
    function FetchHttpHandler(_a) {
        var _b = _a === void 0 ? {} : _a, requestTimeout = _b.requestTimeout;
        this.requestTimeout = requestTimeout;
    }
    FetchHttpHandler.prototype.destroy = function () {
        // Do nothing. TLS and HTTP/2 connection pooling is handled by the browser.
    };
    FetchHttpHandler.prototype.handle = function (request, _a) {
        var _b = _a === void 0 ? {} : _a, abortSignal = _b.abortSignal;
        var requestTimeoutInMs = this.requestTimeout;
        // if the request was already aborted, prevent doing extra work
        if (abortSignal === null || abortSignal === void 0 ? void 0 : abortSignal.aborted) {
            var abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        var path = request.path;
        if (request.query) {
            var queryString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__aws_sdk_querystring_builder__["a" /* buildQueryString */])(request.query);
            if (queryString) {
                path += "?" + queryString;
            }
        }
        var port = request.port, method = request.method;
        var url = request.protocol + "//" + request.hostname + (port ? ":" + port : "") + path;
        // Request constructor doesn't allow GET/HEAD request with body
        // ref: https://github.com/whatwg/fetch/issues/551
        var body = method === "GET" || method === "HEAD" ? undefined : request.body;
        var requestOptions = {
            body: body,
            headers: new Headers(request.headers),
            method: method,
        };
        // some browsers support abort signal
        if (typeof AbortController !== "undefined") {
            requestOptions["signal"] = abortSignal;
        }
        var fetchRequest = new Request(url, requestOptions);
        var raceOfPromises = [
            fetch(fetchRequest).then(function (response) {
                var e_1, _a;
                var fetchHeaders = response.headers;
                var transformedHeaders = {};
                try {
                    for (var _b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(fetchHeaders.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var pair = _c.value;
                        transformedHeaders[pair[0]] = pair[1];
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                var hasReadableStream = response.body !== undefined;
                // Return the response with buffered body
                if (!hasReadableStream) {
                    return response.blob().then(function (body) { return ({
                        response: new __WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__["HttpResponse"]({
                            headers: transformedHeaders,
                            statusCode: response.status,
                            body: body,
                        }),
                    }); });
                }
                // Return the response with streaming body
                return {
                    response: new __WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__["HttpResponse"]({
                        headers: transformedHeaders,
                        statusCode: response.status,
                        body: response.body,
                    }),
                };
            }),
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__request_timeout__["a" /* requestTimeout */])(requestTimeoutInMs),
        ];
        if (abortSignal) {
            raceOfPromises.push(new Promise(function (resolve, reject) {
                abortSignal.onabort = function () {
                    var abortError = new Error("Request aborted");
                    abortError.name = "AbortError";
                    reject(abortError);
                };
            }));
        }
        return Promise.race(raceOfPromises);
    };
    return FetchHttpHandler;
}());

//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = requestTimeout;
function requestTimeout(timeoutInMs) {
    if (timeoutInMs === void 0) { timeoutInMs = 0; }
    return new Promise(function (resolve, reject) {
        if (timeoutInMs) {
            setTimeout(function () {
                var timeoutError = new Error("Request did not complete within " + timeoutInMs + " ms");
                timeoutError.name = "TimeoutError";
                reject(timeoutError);
            }, timeoutInMs);
        }
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVxdWVzdC10aW1lb3V0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3JlcXVlc3QtdGltZW91dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLFVBQVUsY0FBYyxDQUFDLFdBQWU7SUFBZiw0QkFBQSxFQUFBLGVBQWU7SUFDNUMsT0FBTyxJQUFJLE9BQU8sQ0FBQyxVQUFDLE9BQU8sRUFBRSxNQUFNO1FBQ2pDLElBQUksV0FBVyxFQUFFO1lBQ2YsVUFBVSxDQUFDO2dCQUNULElBQU0sWUFBWSxHQUFHLElBQUksS0FBSyxDQUFDLHFDQUFtQyxXQUFXLFFBQUssQ0FBQyxDQUFDO2dCQUNwRixZQUFZLENBQUMsSUFBSSxHQUFHLGNBQWMsQ0FBQztnQkFDbkMsTUFBTSxDQUFDLFlBQVksQ0FBQyxDQUFDO1lBQ3ZCLENBQUMsRUFBRSxXQUFXLENBQUMsQ0FBQztTQUNqQjtJQUNILENBQUMsQ0FBQyxDQUFDO0FBQ0wsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBmdW5jdGlvbiByZXF1ZXN0VGltZW91dCh0aW1lb3V0SW5NcyA9IDApOiBQcm9taXNlPG5ldmVyPiB7XG4gIHJldHVybiBuZXcgUHJvbWlzZSgocmVzb2x2ZSwgcmVqZWN0KSA9PiB7XG4gICAgaWYgKHRpbWVvdXRJbk1zKSB7XG4gICAgICBzZXRUaW1lb3V0KCgpID0+IHtcbiAgICAgICAgY29uc3QgdGltZW91dEVycm9yID0gbmV3IEVycm9yKGBSZXF1ZXN0IGRpZCBub3QgY29tcGxldGUgd2l0aGluICR7dGltZW91dEluTXN9IG1zYCk7XG4gICAgICAgIHRpbWVvdXRFcnJvci5uYW1lID0gXCJUaW1lb3V0RXJyb3JcIjtcbiAgICAgICAgcmVqZWN0KHRpbWVvdXRFcnJvcik7XG4gICAgICB9LCB0aW1lb3V0SW5Ncyk7XG4gICAgfVxuICB9KTtcbn1cbiJdfQ==

/***/ }),
/* 1701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return streamCollector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_util_base64_browser__ = __webpack_require__(525);


//reference: https://snack.expo.io/r1JCSWRGU
var streamCollector = function (stream) {
    if (typeof Blob === "function" && stream instanceof Blob) {
        return collectBlob(stream);
    }
    return collectStream(stream);
};
function collectBlob(blob) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var base64, arrayBuffer;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, readToBase64(blob)];
                case 1:
                    base64 = _a.sent();
                    arrayBuffer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__aws_sdk_util_base64_browser__["a" /* fromBase64 */])(base64);
                    return [2 /*return*/, new Uint8Array(arrayBuffer)];
            }
        });
    });
}
function collectStream(stream) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var res, reader, isDone, _a, done, value, prior;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_b) {
            switch (_b.label) {
                case 0:
                    res = new Uint8Array(0);
                    reader = stream.getReader();
                    isDone = false;
                    _b.label = 1;
                case 1:
                    if (!!isDone) return [3 /*break*/, 3];
                    return [4 /*yield*/, reader.read()];
                case 2:
                    _a = _b.sent(), done = _a.done, value = _a.value;
                    if (value) {
                        prior = res;
                        res = new Uint8Array(prior.length + value.length);
                        res.set(prior);
                        res.set(value, prior.length);
                    }
                    isDone = done;
                    return [3 /*break*/, 1];
                case 3: return [2 /*return*/, res];
            }
        });
    });
}
function readToBase64(blob) {
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        reader.onloadend = function () {
            var _a;
            // reference: https://developer.mozilla.org/en-US/docs/Web/API/FileReader/readAsDataURL
            // response from readAsDataURL is always prepended with "data:*/*;base64,"
            if (reader.readyState !== 2) {
                return reject(new Error("Reader aborted too early"));
            }
            var result = ((_a = reader.result) !== null && _a !== void 0 ? _a : "");
            // Response can include only 'data:' for empty blob, return empty string in this case.
            // Otherwise, return the string after ','
            var commaIndex = result.indexOf(",");
            var dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = function () { return reject(new Error("Read aborted")); };
        reader.onerror = function () { return reject(reader.error); };
        // reader.readAsArrayBuffer is not always available
        reader.readAsDataURL(blob);
    });
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export invalidFunction */
var invalidFunction = function (message) { return function () {
    throw new Error(message);
}; };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW52YWxpZEZ1bmN0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2ludmFsaWRGdW5jdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsSUFBTSxlQUFlLEdBQUcsVUFBQyxPQUFlLElBQUssT0FBQTtJQUNsRCxNQUFNLElBQUksS0FBSyxDQUFDLE9BQU8sQ0FBQyxDQUFDO0FBQzNCLENBQUMsRUFGbUQsQ0FFbkQsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBpbnZhbGlkRnVuY3Rpb24gPSAobWVzc2FnZTogc3RyaW5nKSA9PiAoKSA9PiB7XG4gIHRocm93IG5ldyBFcnJvcihtZXNzYWdlKTtcbn07XG4iXX0=

/***/ }),
/* 1703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invalidProvider; });
var invalidProvider = function (message) { return function () { return Promise.reject(message); }; };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW52YWxpZFByb3ZpZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2ludmFsaWRQcm92aWRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxNQUFNLENBQUMsSUFBTSxlQUFlLEdBQXVDLFVBQUMsT0FBZSxJQUFLLE9BQUEsY0FBTSxPQUFBLE9BQU8sQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDLEVBQXZCLENBQXVCLEVBQTdCLENBQTZCLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBQcm92aWRlciB9IGZyb20gXCJAYXdzLXNkay90eXBlc1wiO1xuZXhwb3J0IGNvbnN0IGludmFsaWRQcm92aWRlcjogKG1lc3NhZ2U6IHN0cmluZykgPT4gUHJvdmlkZXI8YW55PiA9IChtZXNzYWdlOiBzdHJpbmcpID0+ICgpID0+IFByb21pc2UucmVqZWN0KG1lc3NhZ2UpO1xuIl19

/***/ }),
/* 1704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isArrayBuffer; });
var isArrayBuffer = function (arg) {
    return (typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer) ||
        Object.prototype.toString.call(arg) === "[object ArrayBuffer]";
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxDQUFDLElBQU0sYUFBYSxHQUFHLFVBQUMsR0FBUTtJQUNwQyxPQUFBLENBQUMsT0FBTyxXQUFXLEtBQUssVUFBVSxJQUFJLEdBQUcsWUFBWSxXQUFXLENBQUM7UUFDakUsTUFBTSxDQUFDLFNBQVMsQ0FBQyxRQUFRLENBQUMsSUFBSSxDQUFDLEdBQUcsQ0FBQyxLQUFLLHNCQUFzQjtBQUQ5RCxDQUM4RCxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IGlzQXJyYXlCdWZmZXIgPSAoYXJnOiBhbnkpOiBhcmcgaXMgQXJyYXlCdWZmZXIgPT5cbiAgKHR5cGVvZiBBcnJheUJ1ZmZlciA9PT0gXCJmdW5jdGlvblwiICYmIGFyZyBpbnN0YW5jZW9mIEFycmF5QnVmZmVyKSB8fFxuICBPYmplY3QucHJvdG90eXBlLnRvU3RyaW5nLmNhbGwoYXJnKSA9PT0gXCJbb2JqZWN0IEFycmF5QnVmZmVyXVwiO1xuIl19

/***/ }),
/* 1705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export loggerMiddleware */
/* unused harmony export loggerMiddlewareOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getLoggerPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);

var loggerMiddleware = function () { return function (next, context) { return function (args) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(void 0, void 0, void 0, function () {
    var clientName, commandName, inputFilterSensitiveLog, logger, outputFilterSensitiveLog, response, _a, $metadata, outputWithoutMetadata;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_b) {
        switch (_b.label) {
            case 0:
                clientName = context.clientName, commandName = context.commandName, inputFilterSensitiveLog = context.inputFilterSensitiveLog, logger = context.logger, outputFilterSensitiveLog = context.outputFilterSensitiveLog;
                return [4 /*yield*/, next(args)];
            case 1:
                response = _b.sent();
                if (!logger) {
                    return [2 /*return*/, response];
                }
                if (typeof logger.info === "function") {
                    _a = response.output, $metadata = _a.$metadata, outputWithoutMetadata = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__rest"])(_a, ["$metadata"]);
                    logger.info({
                        clientName: clientName,
                        commandName: commandName,
                        input: inputFilterSensitiveLog(args.input),
                        output: outputFilterSensitiveLog(outputWithoutMetadata),
                        metadata: $metadata,
                    });
                }
                return [2 /*return*/, response];
        }
    });
}); }; }; };
var loggerMiddlewareOptions = {
    name: "loggerMiddleware",
    tags: ["LOGGER"],
    step: "initialize",
    override: true,
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
var getLoggerPlugin = function (options) { return ({
    applyToStack: function (clientStack) {
        clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
    },
}); };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9nZ2VyTWlkZGxld2FyZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9sb2dnZXJNaWRkbGV3YXJlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFZQSxNQUFNLENBQUMsSUFBTSxnQkFBZ0IsR0FBRyxjQUFNLE9BQUEsVUFDcEMsSUFBb0MsRUFDcEMsT0FBZ0MsSUFDRyxPQUFBLFVBQ25DLElBQXFDOzs7OztnQkFFN0IsVUFBVSxHQUE2RSxPQUFPLFdBQXBGLEVBQUUsV0FBVyxHQUFnRSxPQUFPLFlBQXZFLEVBQUUsdUJBQXVCLEdBQXVDLE9BQU8sd0JBQTlDLEVBQUUsTUFBTSxHQUErQixPQUFPLE9BQXRDLEVBQUUsd0JBQXdCLEdBQUssT0FBTyx5QkFBWixDQUFhO2dCQUV0RixxQkFBTSxJQUFJLENBQUMsSUFBSSxDQUFDLEVBQUE7O2dCQUEzQixRQUFRLEdBQUcsU0FBZ0I7Z0JBRWpDLElBQUksQ0FBQyxNQUFNLEVBQUU7b0JBQ1gsc0JBQU8sUUFBUSxFQUFDO2lCQUNqQjtnQkFFRCxJQUFJLE9BQU8sTUFBTSxDQUFDLElBQUksS0FBSyxVQUFVLEVBQUU7b0JBQy9CLEtBQTBDLFFBQVEsQ0FBQyxNQUFNLEVBQXZELFNBQVMsZUFBQSxFQUFLLHFCQUFxQixjQUFyQyxhQUF1QyxDQUFGLENBQXFCO29CQUNoRSxNQUFNLENBQUMsSUFBSSxDQUFDO3dCQUNWLFVBQVUsWUFBQTt3QkFDVixXQUFXLGFBQUE7d0JBQ1gsS0FBSyxFQUFFLHVCQUF1QixDQUFDLElBQUksQ0FBQyxLQUFLLENBQUM7d0JBQzFDLE1BQU0sRUFBRSx3QkFBd0IsQ0FBQyxxQkFBcUIsQ0FBQzt3QkFDdkQsUUFBUSxFQUFFLFNBQVM7cUJBQ3BCLENBQUMsQ0FBQztpQkFDSjtnQkFFRCxzQkFBTyxRQUFRLEVBQUM7OztLQUNqQixFQXZCb0MsQ0F1QnBDLEVBMUJxQyxDQTBCckMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxJQUFNLHVCQUF1QixHQUFnRDtJQUNsRixJQUFJLEVBQUUsa0JBQWtCO0lBQ3hCLElBQUksRUFBRSxDQUFDLFFBQVEsQ0FBQztJQUNoQixJQUFJLEVBQUUsWUFBWTtJQUNsQixRQUFRLEVBQUUsSUFBSTtDQUNmLENBQUM7QUFFRiw2REFBNkQ7QUFDN0QsTUFBTSxDQUFDLElBQU0sZUFBZSxHQUFHLFVBQUMsT0FBWSxJQUEwQixPQUFBLENBQUM7SUFDckUsWUFBWSxFQUFFLFVBQUMsV0FBVztRQUN4QixXQUFXLENBQUMsR0FBRyxDQUFDLGdCQUFnQixFQUFFLEVBQUUsdUJBQXVCLENBQUMsQ0FBQztJQUMvRCxDQUFDO0NBQ0YsQ0FBQyxFQUpvRSxDQUlwRSxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgSHR0cFJlc3BvbnNlIH0gZnJvbSBcIkBhd3Mtc2RrL3Byb3RvY29sLWh0dHBcIjtcbmltcG9ydCB7XG4gIEFic29sdXRlTG9jYXRpb24sXG4gIEhhbmRsZXJFeGVjdXRpb25Db250ZXh0LFxuICBJbml0aWFsaXplSGFuZGxlcixcbiAgSW5pdGlhbGl6ZUhhbmRsZXJBcmd1bWVudHMsXG4gIEluaXRpYWxpemVIYW5kbGVyT3B0aW9ucyxcbiAgSW5pdGlhbGl6ZUhhbmRsZXJPdXRwdXQsXG4gIE1ldGFkYXRhQmVhcmVyLFxuICBQbHVnZ2FibGUsXG59IGZyb20gXCJAYXdzLXNkay90eXBlc1wiO1xuXG5leHBvcnQgY29uc3QgbG9nZ2VyTWlkZGxld2FyZSA9ICgpID0+IDxPdXRwdXQgZXh0ZW5kcyBNZXRhZGF0YUJlYXJlciA9IE1ldGFkYXRhQmVhcmVyPihcbiAgbmV4dDogSW5pdGlhbGl6ZUhhbmRsZXI8YW55LCBPdXRwdXQ+LFxuICBjb250ZXh0OiBIYW5kbGVyRXhlY3V0aW9uQ29udGV4dFxuKTogSW5pdGlhbGl6ZUhhbmRsZXI8YW55LCBPdXRwdXQ+ID0+IGFzeW5jIChcbiAgYXJnczogSW5pdGlhbGl6ZUhhbmRsZXJBcmd1bWVudHM8YW55PlxuKTogUHJvbWlzZTxJbml0aWFsaXplSGFuZGxlck91dHB1dDxPdXRwdXQ+PiA9PiB7XG4gIGNvbnN0IHsgY2xpZW50TmFtZSwgY29tbWFuZE5hbWUsIGlucHV0RmlsdGVyU2Vuc2l0aXZlTG9nLCBsb2dnZXIsIG91dHB1dEZpbHRlclNlbnNpdGl2ZUxvZyB9ID0gY29udGV4dDtcblxuICBjb25zdCByZXNwb25zZSA9IGF3YWl0IG5leHQoYXJncyk7XG5cbiAgaWYgKCFsb2dnZXIpIHtcbiAgICByZXR1cm4gcmVzcG9uc2U7XG4gIH1cblxuICBpZiAodHlwZW9mIGxvZ2dlci5pbmZvID09PSBcImZ1bmN0aW9uXCIpIHtcbiAgICBjb25zdCB7ICRtZXRhZGF0YSwgLi4ub3V0cHV0V2l0aG91dE1ldGFkYXRhIH0gPSByZXNwb25zZS5vdXRwdXQ7XG4gICAgbG9nZ2VyLmluZm8oe1xuICAgICAgY2xpZW50TmFtZSxcbiAgICAgIGNvbW1hbmROYW1lLFxuICAgICAgaW5wdXQ6IGlucHV0RmlsdGVyU2Vuc2l0aXZlTG9nKGFyZ3MuaW5wdXQpLFxuICAgICAgb3V0cHV0OiBvdXRwdXRGaWx0ZXJTZW5zaXRpdmVMb2cob3V0cHV0V2l0aG91dE1ldGFkYXRhKSxcbiAgICAgIG1ldGFkYXRhOiAkbWV0YWRhdGEsXG4gICAgfSk7XG4gIH1cblxuICByZXR1cm4gcmVzcG9uc2U7XG59O1xuXG5leHBvcnQgY29uc3QgbG9nZ2VyTWlkZGxld2FyZU9wdGlvbnM6IEluaXRpYWxpemVIYW5kbGVyT3B0aW9ucyAmIEFic29sdXRlTG9jYXRpb24gPSB7XG4gIG5hbWU6IFwibG9nZ2VyTWlkZGxld2FyZVwiLFxuICB0YWdzOiBbXCJMT0dHRVJcIl0sXG4gIHN0ZXA6IFwiaW5pdGlhbGl6ZVwiLFxuICBvdmVycmlkZTogdHJ1ZSxcbn07XG5cbi8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBAdHlwZXNjcmlwdC1lc2xpbnQvbm8tdW51c2VkLXZhcnNcbmV4cG9ydCBjb25zdCBnZXRMb2dnZXJQbHVnaW4gPSAob3B0aW9uczogYW55KTogUGx1Z2dhYmxlPGFueSwgYW55PiA9PiAoe1xuICBhcHBseVRvU3RhY2s6IChjbGllbnRTdGFjaykgPT4ge1xuICAgIGNsaWVudFN0YWNrLmFkZChsb2dnZXJNaWRkbGV3YXJlKCksIGxvZ2dlck1pZGRsZXdhcmVPcHRpb25zKTtcbiAgfSxcbn0pO1xuIl19

/***/ }),
/* 1706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ENV_MAX_ATTEMPTS */
/* unused harmony export CONFIG_MAX_ATTEMPTS */
/* unused harmony export NODE_MAX_ATTEMPT_CONFIG_OPTIONS */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return resolveRetryConfig; });
/* unused harmony export ENV_RETRY_MODE */
/* unused harmony export CONFIG_RETRY_MODE */
/* unused harmony export NODE_RETRY_MODE_CONFIG_OPTIONS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultStrategy__ = __webpack_require__(855);


var ENV_MAX_ATTEMPTS = "AWS_MAX_ATTEMPTS";
var CONFIG_MAX_ATTEMPTS = "max_attempts";
var NODE_MAX_ATTEMPT_CONFIG_OPTIONS = {
    environmentVariableSelector: function (env) {
        var value = env[ENV_MAX_ATTEMPTS];
        if (!value)
            return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) {
            throw new Error("Environment variable " + ENV_MAX_ATTEMPTS + " mast be a number, got \"" + value + "\"");
        }
        return maxAttempt;
    },
    configFileSelector: function (profile) {
        var value = profile[CONFIG_MAX_ATTEMPTS];
        if (!value)
            return undefined;
        var maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) {
            throw new Error("Shared config file entry " + CONFIG_MAX_ATTEMPTS + " mast be a number, got \"" + value + "\"");
        }
        return maxAttempt;
    },
    default: __WEBPACK_IMPORTED_MODULE_1__defaultStrategy__["a" /* DEFAULT_MAX_ATTEMPTS */],
};
var resolveRetryConfig = function (input) {
    var maxAttempts = normalizeMaxAttempts(input.maxAttempts);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, input), { maxAttempts: maxAttempts, retryStrategy: input.retryStrategy || new __WEBPACK_IMPORTED_MODULE_1__defaultStrategy__["b" /* StandardRetryStrategy */](maxAttempts) });
};
var normalizeMaxAttempts = function (maxAttempts) {
    if (maxAttempts === void 0) { maxAttempts = __WEBPACK_IMPORTED_MODULE_1__defaultStrategy__["a" /* DEFAULT_MAX_ATTEMPTS */]; }
    if (typeof maxAttempts === "number") {
        var promisified_1 = Promise.resolve(maxAttempts);
        return function () { return promisified_1; };
    }
    return maxAttempts;
};
var ENV_RETRY_MODE = "AWS_RETRY_MODE";
var CONFIG_RETRY_MODE = "retry_mode";
var NODE_RETRY_MODE_CONFIG_OPTIONS = {
    environmentVariableSelector: function (env) { return env[ENV_RETRY_MODE]; },
    configFileSelector: function (profile) { return profile[CONFIG_RETRY_MODE]; },
    default: __WEBPACK_IMPORTED_MODULE_1__defaultStrategy__["c" /* DEFAULT_RETRY_MODE */],
};
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getDefaultRetryQuota; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(366);

var getDefaultRetryQuota = function (initialRetryTokens) {
    var MAX_CAPACITY = initialRetryTokens;
    var availableCapacity = initialRetryTokens;
    var getCapacityAmount = function (error) { return (error.name === "TimeoutError" ? __WEBPACK_IMPORTED_MODULE_0__constants__["g" /* TIMEOUT_RETRY_COST */] : __WEBPACK_IMPORTED_MODULE_0__constants__["h" /* RETRY_COST */]); };
    var hasRetryTokens = function (error) { return getCapacityAmount(error) <= availableCapacity; };
    var retrieveRetryTokens = function (error) {
        if (!hasRetryTokens(error)) {
            // retryStrategy should stop retrying, and return last error
            throw new Error("No retry token available");
        }
        var capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    var releaseRetryTokens = function (capacityReleaseAmount) {
        availableCapacity += capacityReleaseAmount !== null && capacityReleaseAmount !== void 0 ? capacityReleaseAmount : __WEBPACK_IMPORTED_MODULE_0__constants__["i" /* NO_RETRY_INCREMENT */];
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens: hasRetryTokens,
        retrieveRetryTokens: retrieveRetryTokens,
        releaseRetryTokens: releaseRetryTokens,
    });
};
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export omitRetryHeadersMiddleware */
/* unused harmony export omitRetryHeadersMiddlewareOptions */
/* unused harmony export getOmitRetryHeadersPlugin */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(366);



var omitRetryHeadersMiddleware = function () { return function (next) { return function (args) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(void 0, void 0, void 0, function () {
    var request;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
        request = args.request;
        if (__WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__["HttpRequest"].isInstance(request)) {
            delete request.headers[__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* INVOCATION_ID_HEADER */]];
            delete request.headers[__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* REQUEST_HEADER */]];
        }
        return [2 /*return*/, next(args)];
    });
}); }; }; };
var omitRetryHeadersMiddlewareOptions = {
    name: "omitRetryHeadersMiddleware",
    tags: ["RETRY", "HEADERS", "OMIT_RETRY_HEADERS"],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true,
};
var getOmitRetryHeadersPlugin = function (options) { return ({
    applyToStack: function (clientStack) {
        clientStack.addRelativeTo(omitRetryHeadersMiddleware(), omitRetryHeadersMiddlewareOptions);
    },
}); };
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export retryMiddleware */
/* unused harmony export retryMiddlewareOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getRetryPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);

var retryMiddleware = function (options) { return function (next, context) { return function (args) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(void 0, void 0, void 0, function () {
    var _a;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_b) {
        if ((_a = options === null || options === void 0 ? void 0 : options.retryStrategy) === null || _a === void 0 ? void 0 : _a.mode)
            context.userAgent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])((context.userAgent || []), [["cfg/retry-mode", options.retryStrategy.mode]]);
        return [2 /*return*/, options.retryStrategy.retry(next, args)];
    });
}); }; }; };
var retryMiddlewareOptions = {
    name: "retryMiddleware",
    tags: ["RETRY"],
    step: "finalizeRequest",
    priority: "high",
    override: true,
};
var getRetryPlugin = function (options) { return ({
    applyToStack: function (clientStack) {
        clientStack.add(retryMiddleware(options), retryMiddlewareOptions);
    },
}); };
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1710 */
/***/ (function(module, exports, __webpack_require__) {

var v1 = __webpack_require__(1711);
var v4 = __webpack_require__(1712);

var uuid = v4;
uuid.v1 = v1;
uuid.v4 = v4;

module.exports = uuid;


/***/ }),
/* 1711 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(859);
var bytesToUuid = __webpack_require__(858);

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;
var _clockseq;

// Previous uuid creation time
var _lastMSecs = 0;
var _lastNSecs = 0;

// See https://github.com/uuidjs/uuid for API details
function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || [];

  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;

  // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189
  if (node == null || clockseq == null) {
    var seedBytes = rng();
    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [
        seedBytes[0] | 0x01,
        seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]
      ];
    }
    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  }

  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();

  // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock
  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;

  // Time since last uuid creation (in msecs)
  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;

  // Per 4.2.1.2, Bump clockseq on clock regression
  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  }

  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval
  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  }

  // Per 4.2.1.2 Throw error if too many uuids are requested
  if (nsecs >= 10000) {
    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq;

  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
  msecs += 12219292800000;

  // `time_low`
  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff;

  // `time_mid`
  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff;

  // `time_high_and_version`
  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
  b[i++] = tmh >>> 16 & 0xff;

  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
  b[i++] = clockseq >>> 8 | 0x80;

  // `clock_seq_low`
  b[i++] = clockseq & 0xff;

  // `node`
  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf ? buf : bytesToUuid(b);
}

module.exports = v1;


/***/ }),
/* 1712 */
/***/ (function(module, exports, __webpack_require__) {

var rng = __webpack_require__(859);
var bytesToUuid = __webpack_require__(858);

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;


/***/ }),
/* 1713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export deserializerMiddlewareOption */
/* unused harmony export serializerMiddlewareOption */
/* harmony export (immutable) */ __webpack_exports__["a"] = getSerdePlugin;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__deserializerMiddleware__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__serializerMiddleware__ = __webpack_require__(861);


var deserializerMiddlewareOption = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: ["DESERIALIZER"],
    override: true,
};
var serializerMiddlewareOption = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: ["SERIALIZER"],
    override: true,
};
function getSerdePlugin(config, serializer, deserializer) {
    return {
        applyToStack: function (commandStack) {
            commandStack.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__deserializerMiddleware__["a" /* deserializerMiddleware */])(config, deserializer), deserializerMiddlewareOption);
            commandStack.add(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__serializerMiddleware__["a" /* serializerMiddleware */])(config, serializer), serializerMiddlewareOption);
        },
    };
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = resolveAwsAuthConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_signature_v4__ = __webpack_require__(1735);


function resolveAwsAuthConfig(input) {
    var _this = this;
    var credentials = input.credentials || input.credentialDefaultProvider(input);
    var normalizedCreds = normalizeProvider(credentials);
    var _a = input.signingEscapePath, signingEscapePath = _a === void 0 ? true : _a, _b = input.systemClockOffset, systemClockOffset = _b === void 0 ? input.systemClockOffset || 0 : _b, sha256 = input.sha256;
    var signer;
    if (input.signer) {
        //if signer is supplied by user, normalize it to a function returning a promise for signer.
        signer = normalizeProvider(input.signer);
    }
    else {
        //construct a provider inferring signing from region.
        signer = function () {
            return normalizeProvider(input.region)()
                .then(function (region) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(_this, void 0, void 0, function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, input.regionInfoProvider(region)];
                    case 1: return [2 /*return*/, [(_a.sent()) || {}, region]];
                }
            }); }); })
                .then(function (_a) {
                var _b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(_a, 2), regionInfo = _b[0], region = _b[1];
                var signingRegion = regionInfo.signingRegion, signingService = regionInfo.signingService;
                //update client's singing region and signing service config if they are resolved.
                //signing region resolving order: user supplied signingRegion -> endpoints.json inferred region -> client region
                input.signingRegion = input.signingRegion || signingRegion || region;
                //signing name resolving order:
                //user supplied signingName -> endpoints.json inferred (credential scope -> model arnNamespace) -> model service id
                input.signingName = input.signingName || signingService || input.serviceId;
                return new __WEBPACK_IMPORTED_MODULE_1__aws_sdk_signature_v4__["a" /* SignatureV4 */]({
                    credentials: normalizedCreds,
                    region: input.signingRegion,
                    service: input.signingName,
                    sha256: sha256,
                    uriEscapePath: signingEscapePath,
                });
            });
        };
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, input), { systemClockOffset: systemClockOffset,
        signingEscapePath: signingEscapePath, credentials: normalizedCreds, signer: signer });
}
function normalizeProvider(input) {
    if (typeof input === "object") {
        var promisified_1 = Promise.resolve(input);
        return function () { return promisified_1; };
    }
    return input;
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export awsAuthMiddleware */
/* unused harmony export awsAuthMiddlewareOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getAwsAuthPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__ = __webpack_require__(171);


var isClockSkewed = function (newServerTime, systemClockOffset) {
    return Math.abs(getSkewCorrectedDate(systemClockOffset).getTime() - newServerTime) >= 300000;
};
var getSkewCorrectedDate = function (systemClockOffset) { return new Date(Date.now() + systemClockOffset); };
function awsAuthMiddleware(options) {
    return function (next, context) {
        return function (args) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
                var signer, _a, output, _b, _c, headers, dateHeader, serverTime;
                var _d;
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            if (!__WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__["HttpRequest"].isInstance(args.request))
                                return [2 /*return*/, next(args)];
                            if (!(typeof options.signer === "function")) return [3 /*break*/, 2];
                            return [4 /*yield*/, options.signer()];
                        case 1:
                            _a = _e.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            _a = options.signer;
                            _e.label = 3;
                        case 3:
                            signer = _a;
                            _b = next;
                            _c = [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, args)];
                            _d = {};
                            return [4 /*yield*/, signer.sign(args.request, {
                                    signingDate: new Date(Date.now() + options.systemClockOffset),
                                    signingRegion: context["signing_region"],
                                    signingService: context["signing_service"],
                                })];
                        case 4: return [4 /*yield*/, _b.apply(void 0, [__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"].apply(void 0, _c.concat([(_d.request = _e.sent(), _d)]))])];
                        case 5:
                            output = _e.sent();
                            headers = output.response.headers;
                            dateHeader = headers && (headers.date || headers.Date);
                            if (dateHeader) {
                                serverTime = Date.parse(dateHeader);
                                if (isClockSkewed(serverTime, options.systemClockOffset)) {
                                    options.systemClockOffset = serverTime - Date.now();
                                }
                            }
                            return [2 /*return*/, output];
                    }
                });
            });
        };
    };
}
var awsAuthMiddlewareOptions = {
    name: "awsAuthMiddleware",
    tags: ["SIGNATURE", "AWSAUTH"],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: true,
};
var getAwsAuthPlugin = function (options) { return ({
    applyToStack: function (clientStack) {
        clientStack.addRelativeTo(awsAuthMiddleware(options), awsAuthMiddlewareOptions);
    },
}); };
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return constructStack; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);

var constructStack = function () {
    var absoluteEntries = [];
    var relativeEntries = [];
    var entriesNameSet = new Set();
    var sort = function (entries) {
        return entries.sort(function (a, b) {
            return stepWeights[b.step] - stepWeights[a.step] ||
                priorityWeights[b.priority || "normal"] - priorityWeights[a.priority || "normal"];
        });
    };
    var removeByName = function (toRemove) {
        var isRemoved = false;
        var filterCb = function (entry) {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var removeByReference = function (toRemove) {
        var isRemoved = false;
        var filterCb = function (entry) {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name)
                    entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    var cloneTo = function (toStack) {
        absoluteEntries.forEach(function (entry) {
            //@ts-ignore
            toStack.add(entry.middleware, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, entry));
        });
        relativeEntries.forEach(function (entry) {
            //@ts-ignore
            toStack.addRelativeTo(entry.middleware, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, entry));
        });
        return toStack;
    };
    var expandRelativeMiddlewareList = function (from) {
        var expandedMiddlewareList = [];
        from.before.forEach(function (entry) {
            if (entry.before.length === 0 && entry.after.length === 0) {
                expandedMiddlewareList.push(entry);
            }
            else {
                expandedMiddlewareList.push.apply(expandedMiddlewareList, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(expandRelativeMiddlewareList(entry)));
            }
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach(function (entry) {
            if (entry.before.length === 0 && entry.after.length === 0) {
                expandedMiddlewareList.push(entry);
            }
            else {
                expandedMiddlewareList.push.apply(expandedMiddlewareList, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(expandRelativeMiddlewareList(entry)));
            }
        });
        return expandedMiddlewareList;
    };
    /**
     * Get a final list of middleware in the order of being executed in the resolved handler.
     */
    var getMiddlewareList = function () {
        var normalizedAbsoluteEntries = [];
        var normalizedRelativeEntries = [];
        var normalizedEntriesNameMap = {};
        absoluteEntries.forEach(function (entry) {
            var normalizedEntry = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, entry), { before: [], after: [] });
            if (normalizedEntry.name)
                normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach(function (entry) {
            var normalizedEntry = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, entry), { before: [], after: [] });
            if (normalizedEntry.name)
                normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach(function (entry) {
            if (entry.toMiddleware) {
                var toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) {
                    throw new Error(entry.toMiddleware + " is not found when adding " + (entry.name || "anonymous") + " middleware " + entry.relation + " " + entry.toMiddleware);
                }
                if (entry.relation === "after") {
                    toMiddleware.after.push(entry);
                }
                if (entry.relation === "before") {
                    toMiddleware.before.push(entry);
                }
            }
        });
        var mainChain = sort(normalizedAbsoluteEntries)
            .map(expandRelativeMiddlewareList)
            .reduce(function (wholeList, expendedMiddlewareList) {
            // TODO: Replace it with Array.flat();
            wholeList.push.apply(wholeList, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(expendedMiddlewareList));
            return wholeList;
        }, []);
        return mainChain.map(function (entry) { return entry.middleware; });
    };
    var stack = {
        add: function (middleware, options) {
            if (options === void 0) { options = {}; }
            var name = options.name, override = options.override;
            var entry = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({ step: "initialize", priority: "normal", middleware: middleware }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override)
                        throw new Error("Duplicate middleware name '" + name + "'");
                    var toOverrideIndex = absoluteEntries.findIndex(function (entry) { return entry.name === name; });
                    var toOverride = absoluteEntries[toOverrideIndex];
                    if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) {
                        throw new Error("\"" + name + "\" middleware with " + toOverride.priority + " priority in " + toOverride.step + " step cannot be " +
                            ("overridden by same-name middleware with " + entry.priority + " priority in " + entry.step + " step."));
                    }
                    absoluteEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: function (middleware, options) {
            var name = options.name, override = options.override;
            var entry = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({ middleware: middleware }, options);
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override)
                        throw new Error("Duplicate middleware name '" + name + "'");
                    var toOverrideIndex = relativeEntries.findIndex(function (entry) { return entry.name === name; });
                    var toOverride = relativeEntries[toOverrideIndex];
                    if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) {
                        throw new Error("\"" + name + "\" middleware " + toOverride.relation + " \"" + toOverride.toMiddleware + "\" middleware cannot be overridden " +
                            ("by same-name middleware " + entry.relation + " \"" + entry.toMiddleware + "\" middleware."));
                    }
                    relativeEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: function () { return cloneTo(constructStack()); },
        use: function (plugin) {
            plugin.applyToStack(stack);
        },
        remove: function (toRemove) {
            if (typeof toRemove === "string")
                return removeByName(toRemove);
            else
                return removeByReference(toRemove);
        },
        removeByTag: function (toRemove) {
            var isRemoved = false;
            var filterCb = function (entry) {
                var tags = entry.tags, name = entry.name;
                if (tags && tags.includes(toRemove)) {
                    if (name)
                        entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: function (from) {
            var cloned = cloneTo(constructStack());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        resolve: function (handler, context) {
            var e_1, _a;
            try {
                for (var _b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(getMiddlewareList().reverse()), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var middleware = _c.value;
                    handler = middleware(handler, context);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return handler;
        },
    };
    return stack;
};
var stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1,
};
var priorityWeights = {
    high: 3,
    normal: 2,
    low: 1,
};
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = resolveUserAgentConfig;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);

function resolveUserAgentConfig(input) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, input), { customUserAgent: typeof input.customUserAgent === "string" ? [[input.customUserAgent]] : input.customUserAgent });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uZmlndXJhdGlvbnMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uZmlndXJhdGlvbnMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQWdCQSxNQUFNLFVBQVUsc0JBQXNCLENBQ3BDLEtBQW9EO0lBRXBELDZCQUNLLEtBQUssS0FDUixlQUFlLEVBQUUsT0FBTyxLQUFLLENBQUMsZUFBZSxLQUFLLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxlQUFlLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxLQUFLLENBQUMsZUFBZSxJQUM5RztBQUNKLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBQcm92aWRlciwgVXNlckFnZW50IH0gZnJvbSBcIkBhd3Mtc2RrL3R5cGVzXCI7XG5leHBvcnQgaW50ZXJmYWNlIFVzZXJBZ2VudElucHV0Q29uZmlnIHtcbiAgLyoqXG4gICAqIFRoZSBjdXN0b20gdXNlciBhZ2VudCBoZWFkZXIgdGhhdCB3b3VsZCBiZSBhcHBlbmRlZCB0byBkZWZhdWx0IG9uZVxuICAgKi9cbiAgY3VzdG9tVXNlckFnZW50Pzogc3RyaW5nIHwgVXNlckFnZW50O1xufVxuaW50ZXJmYWNlIFByZXZpb3VzbHlSZXNvbHZlZCB7XG4gIGRlZmF1bHRVc2VyQWdlbnRQcm92aWRlcjogUHJvdmlkZXI8VXNlckFnZW50PjtcbiAgcnVudGltZTogc3RyaW5nO1xufVxuZXhwb3J0IGludGVyZmFjZSBVc2VyQWdlbnRSZXNvbHZlZENvbmZpZyB7XG4gIGRlZmF1bHRVc2VyQWdlbnRQcm92aWRlcjogUHJvdmlkZXI8VXNlckFnZW50PjtcbiAgY3VzdG9tVXNlckFnZW50PzogVXNlckFnZW50O1xuICBydW50aW1lOiBzdHJpbmc7XG59XG5leHBvcnQgZnVuY3Rpb24gcmVzb2x2ZVVzZXJBZ2VudENvbmZpZzxUPihcbiAgaW5wdXQ6IFQgJiBQcmV2aW91c2x5UmVzb2x2ZWQgJiBVc2VyQWdlbnRJbnB1dENvbmZpZ1xuKTogVCAmIFVzZXJBZ2VudFJlc29sdmVkQ29uZmlnIHtcbiAgcmV0dXJuIHtcbiAgICAuLi5pbnB1dCxcbiAgICBjdXN0b21Vc2VyQWdlbnQ6IHR5cGVvZiBpbnB1dC5jdXN0b21Vc2VyQWdlbnQgPT09IFwic3RyaW5nXCIgPyBbW2lucHV0LmN1c3RvbVVzZXJBZ2VudF1dIDogaW5wdXQuY3VzdG9tVXNlckFnZW50LFxuICB9O1xufVxuIl19

/***/ }),
/* 1718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return USER_AGENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return X_AMZ_USER_AGENT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SPACE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return UA_ESCAPE_REGEX; });
var USER_AGENT = "user-agent";
var X_AMZ_USER_AGENT = "x-amz-user-agent";
var SPACE = " ";
var UA_ESCAPE_REGEX = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnN0YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsSUFBTSxVQUFVLEdBQUcsWUFBWSxDQUFDO0FBRXZDLE1BQU0sQ0FBQyxJQUFNLGdCQUFnQixHQUFHLGtCQUFrQixDQUFDO0FBRW5ELE1BQU0sQ0FBQyxJQUFNLEtBQUssR0FBRyxHQUFHLENBQUM7QUFFekIsTUFBTSxDQUFDLElBQU0sZUFBZSxHQUFHLHdDQUF3QyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IFVTRVJfQUdFTlQgPSBcInVzZXItYWdlbnRcIjtcblxuZXhwb3J0IGNvbnN0IFhfQU1aX1VTRVJfQUdFTlQgPSBcIngtYW16LXVzZXItYWdlbnRcIjtcblxuZXhwb3J0IGNvbnN0IFNQQUNFID0gXCIgXCI7XG5cbmV4cG9ydCBjb25zdCBVQV9FU0NBUEVfUkVHRVggPSAvW15cXCFcXCNcXCRcXCVcXCZcXCdcXCpcXCtcXC1cXC5cXF5cXF9cXGBcXHxcXH5cXGRcXHddL2c7XG4iXX0=

/***/ }),
/* 1719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export userAgentMiddleware */
/* unused harmony export getUserAgentMiddlewareOptions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUserAgentPlugin; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(1718);



/**
 * Build user agent header sections from:
 * 1. runtime-specific default user agent provider;
 * 2. custom user agent from `customUserAgent` client config;
 * 3. handler execution context set by internal SDK components;
 * The built user agent will be set to `x-amz-user-agent` header for ALL the
 * runtimes.
 * Please note that any override to the `user-agent` or `x-amz-user-agent` header
 * in the HTTP request is discouraged. Please use `customUserAgent` client
 * config or middleware setting the `userAgent` context to generate desired user
 * agent.
 */
var userAgentMiddleware = function (options) { return function (next, context) { return function (args) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(void 0, void 0, void 0, function () {
    var request, headers, userAgent, defaultUserAgent, customUserAgent, normalUAValue;
    var _a, _b;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_c) {
        switch (_c.label) {
            case 0:
                request = args.request;
                if (!__WEBPACK_IMPORTED_MODULE_1__aws_sdk_protocol_http__["HttpRequest"].isInstance(request))
                    return [2 /*return*/, next(args)];
                headers = request.headers;
                userAgent = ((_a = context === null || context === void 0 ? void 0 : context.userAgent) === null || _a === void 0 ? void 0 : _a.map(escapeUserAgent)) || [];
                return [4 /*yield*/, options.defaultUserAgentProvider()];
            case 1:
                defaultUserAgent = (_c.sent()).map(escapeUserAgent);
                customUserAgent = ((_b = options === null || options === void 0 ? void 0 : options.customUserAgent) === null || _b === void 0 ? void 0 : _b.map(escapeUserAgent)) || [];
                // Set value to AWS-specific user agent header
                headers[__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* X_AMZ_USER_AGENT */]] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(defaultUserAgent, userAgent, customUserAgent).join(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* SPACE */]);
                normalUAValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(defaultUserAgent.filter(function (section) { return section.startsWith("aws-sdk-"); }), customUserAgent).join(__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* SPACE */]);
                if (options.runtime !== "browser" && normalUAValue) {
                    headers[__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* USER_AGENT */]] = headers[__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* USER_AGENT */]] ? headers[__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* USER_AGENT */]] + " " + normalUAValue : normalUAValue;
                }
                return [2 /*return*/, next(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, args), { request: request }))];
        }
    });
}); }; }; };
/**
 * Escape the each pair according to https://tools.ietf.org/html/rfc5234 and join the pair with pattern `name/version`.
 * User agent name may include prefix like `md/`, `api/`, `os/` etc., we should not escape the `/` after the prefix.
 * @private
 */
var escapeUserAgent = function (_a) {
    var _b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(_a, 2), name = _b[0], version = _b[1];
    var prefixSeparatorIndex = name.indexOf("/");
    var prefix = name.substring(0, prefixSeparatorIndex); // If no prefix, prefix is just ""
    var uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") {
        uaName = uaName.toLowerCase();
    }
    return [prefix, uaName, version]
        .filter(function (item) { return item && item.length > 0; })
        .map(function (item) { return item === null || item === void 0 ? void 0 : item.replace(__WEBPACK_IMPORTED_MODULE_2__constants__["d" /* UA_ESCAPE_REGEX */], "_"); })
        .join("/");
};
var getUserAgentMiddlewareOptions = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: ["SET_USER_AGENT", "USER_AGENT"],
    override: true,
};
var getUserAgentPlugin = function (config) { return ({
    applyToStack: function (clientStack) {
        clientStack.add(userAgentMiddleware(config), getUserAgentMiddlewareOptions);
    },
}); };
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export chain */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ProviderError__ = __webpack_require__(864);


/**
 * Compose a single credential provider function from multiple credential
 * providers. The first provider in the argument list will always be invoked;
 * subsequent providers in the list will be invoked in the order in which the
 * were received if the preceding provider did not successfully resolve.
 *
 * If no providers were received or no provider resolves successfully, the
 * returned promise will be rejected.
 */
function chain() {
    var providers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        providers[_i] = arguments[_i];
    }
    return function () {
        var e_1, _a;
        var promise = Promise.reject(new __WEBPACK_IMPORTED_MODULE_1__ProviderError__["a" /* ProviderError */]("No providers in chain"));
        var _loop_1 = function (provider) {
            promise = promise.catch(function (err) {
                if (err === null || err === void 0 ? void 0 : err.tryNextLink) {
                    return provider();
                }
                throw err;
            });
        };
        try {
            for (var providers_1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(providers), providers_1_1 = providers_1.next(); !providers_1_1.done; providers_1_1 = providers_1.next()) {
                var provider = providers_1_1.value;
                _loop_1(provider);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (providers_1_1 && !providers_1_1.done && (_a = providers_1.return)) _a.call(providers_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return promise;
    };
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fromStatic */
var fromStatic = function (staticValue) { return function () { return Promise.resolve(staticValue); }; };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZnJvbVN0YXRpYy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9mcm9tU3RhdGljLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUVBLE1BQU0sQ0FBQyxJQUFNLFVBQVUsR0FBRyxVQUFJLFdBQWMsSUFBa0IsT0FBQSxjQUFNLE9BQUEsT0FBTyxDQUFDLE9BQU8sQ0FBQyxXQUFXLENBQUMsRUFBNUIsQ0FBNEIsRUFBbEMsQ0FBa0MsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFByb3ZpZGVyIH0gZnJvbSBcIkBhd3Mtc2RrL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCBmcm9tU3RhdGljID0gPFQ+KHN0YXRpY1ZhbHVlOiBUKTogUHJvdmlkZXI8VD4gPT4gKCkgPT4gUHJvbWlzZS5yZXNvbHZlKHN0YXRpY1ZhbHVlKTtcbiJdfQ==

/***/ }),
/* 1722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export memoize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);

var memoize = function (provider, isExpired, requiresRefresh) {
    var result;
    var hasResult;
    if (isExpired === undefined) {
        // This is a static memoization; no need to incorporate refreshing
        return function () {
            if (!hasResult) {
                result = provider();
                hasResult = true;
            }
            return result;
        };
    }
    var isConstant = false;
    return function () { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(void 0, void 0, void 0, function () {
        var resolved;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!hasResult) {
                        result = provider();
                        hasResult = true;
                    }
                    if (isConstant) {
                        return [2 /*return*/, result];
                    }
                    return [4 /*yield*/, result];
                case 1:
                    resolved = _a.sent();
                    if (requiresRefresh && !requiresRefresh(resolved)) {
                        isConstant = true;
                        return [2 /*return*/, resolved];
                    }
                    if (isExpired(resolved)) {
                        return [2 /*return*/, (result = provider())];
                    }
                    return [2 /*return*/, resolved];
            }
        });
    }); };
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWVtb2l6ZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9tZW1vaXplLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUEwQ0EsTUFBTSxDQUFDLElBQU0sT0FBTyxHQUFvQixVQUN0QyxRQUFxQixFQUNyQixTQUFvQyxFQUNwQyxlQUEwQztJQUUxQyxJQUFJLE1BQVcsQ0FBQztJQUNoQixJQUFJLFNBQWtCLENBQUM7SUFDdkIsSUFBSSxTQUFTLEtBQUssU0FBUyxFQUFFO1FBQzNCLGtFQUFrRTtRQUNsRSxPQUFPO1lBQ0wsSUFBSSxDQUFDLFNBQVMsRUFBRTtnQkFDZCxNQUFNLEdBQUcsUUFBUSxFQUFFLENBQUM7Z0JBQ3BCLFNBQVMsR0FBRyxJQUFJLENBQUM7YUFDbEI7WUFDRCxPQUFPLE1BQU0sQ0FBQztRQUNoQixDQUFDLENBQUM7S0FDSDtJQUVELElBQUksVUFBVSxHQUFHLEtBQUssQ0FBQztJQUV2QixPQUFPOzs7OztvQkFDTCxJQUFJLENBQUMsU0FBUyxFQUFFO3dCQUNkLE1BQU0sR0FBRyxRQUFRLEVBQUUsQ0FBQzt3QkFDcEIsU0FBUyxHQUFHLElBQUksQ0FBQztxQkFDbEI7b0JBQ0QsSUFBSSxVQUFVLEVBQUU7d0JBQ2Qsc0JBQU8sTUFBTSxFQUFDO3FCQUNmO29CQUVnQixxQkFBTSxNQUFNLEVBQUE7O29CQUF2QixRQUFRLEdBQUcsU0FBWTtvQkFDN0IsSUFBSSxlQUFlLElBQUksQ0FBQyxlQUFlLENBQUMsUUFBUSxDQUFDLEVBQUU7d0JBQ2pELFVBQVUsR0FBRyxJQUFJLENBQUM7d0JBQ2xCLHNCQUFPLFFBQVEsRUFBQztxQkFDakI7b0JBQ0QsSUFBSSxTQUFTLENBQUMsUUFBUSxDQUFDLEVBQUU7d0JBQ3ZCLHNCQUFPLENBQUMsTUFBTSxHQUFHLFFBQVEsRUFBRSxDQUFDLEVBQUM7cUJBQzlCO29CQUNELHNCQUFPLFFBQVEsRUFBQzs7O1NBQ2pCLENBQUM7QUFDSixDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBQcm92aWRlciB9IGZyb20gXCJAYXdzLXNkay90eXBlc1wiO1xuXG5pbnRlcmZhY2UgTWVtb2l6ZU92ZXJsb2FkIHtcbiAgLyoqXG4gICAqXG4gICAqIERlY29yYXRlcyBhIHByb3ZpZGVyIGZ1bmN0aW9uIHdpdGggZWl0aGVyIHN0YXRpYyBtZW1vaXphdGlvbi5cbiAgICpcbiAgICogVG8gY3JlYXRlIGEgc3RhdGljYWxseSBtZW1vaXplZCBwcm92aWRlciwgc3VwcGx5IGEgcHJvdmlkZXIgYXMgdGhlIG9ubHlcbiAgICogYXJndW1lbnQgdG8gdGhpcyBmdW5jdGlvbi4gVGhlIHByb3ZpZGVyIHdpbGwgYmUgaW52b2tlZCBvbmNlLCBhbmQgYWxsXG4gICAqIGludm9jYXRpb25zIG9mIHRoZSBwcm92aWRlciByZXR1cm5lZCBieSBgbWVtb2l6ZWAgd2lsbCByZXR1cm4gdGhlIHNhbWVcbiAgICogcHJvbWlzZSBvYmplY3QuXG4gICAqXG4gICAqIEBwYXJhbSBwcm92aWRlciBUaGUgcHJvdmlkZXIgd2hvc2UgcmVzdWx0IHNob3VsZCBiZSBjYWNoZWQgaW5kZWZpbml0ZWx5LlxuICAgKi9cbiAgPFQ+KHByb3ZpZGVyOiBQcm92aWRlcjxUPik6IFByb3ZpZGVyPFQ+O1xuXG4gIC8qKlxuICAgKiBEZWNvcmF0ZXMgYSBwcm92aWRlciBmdW5jdGlvbiB3aXRoIHJlZnJlc2hpbmcgbWVtb2l6YXRpb24uXG4gICAqXG4gICAqIEBwYXJhbSBwcm92aWRlciAgICAgICAgICBUaGUgcHJvdmlkZXIgd2hvc2UgcmVzdWx0IHNob3VsZCBiZSBjYWNoZWQuXG4gICAqIEBwYXJhbSBpc0V4cGlyZWQgICAgICAgICBBIGZ1bmN0aW9uIHRoYXQgd2lsbCBldmFsdWF0ZSB0aGUgcmVzb2x2ZWQgdmFsdWUgYW5kXG4gICAqICAgICAgICAgICAgICAgICAgICAgICAgICBkZXRlcm1pbmUgaWYgaXQgaXMgZXhwaXJlZC4gRm9yIGV4YW1wbGUsIHdoZW5cbiAgICogICAgICAgICAgICAgICAgICAgICAgICAgIG1lbW9pemluZyBBV1MgY3JlZGVudGlhbCBwcm92aWRlcnMsIHRoaXMgZnVuY3Rpb25cbiAgICogICAgICAgICAgICAgICAgICAgICAgICAgIHNob3VsZCByZXR1cm4gYHRydWVgIHdoZW4gdGhlIGNyZWRlbnRpYWwnc1xuICAgKiAgICAgICAgICAgICAgICAgICAgICAgICAgZXhwaXJhdGlvbiBpcyBpbiB0aGUgcGFzdCAob3IgdmVyeSBuZWFyIGZ1dHVyZSkgYW5kXG4gICAqICAgICAgICAgICAgICAgICAgICAgICAgICBgZmFsc2VgIG90aGVyd2lzZS5cbiAgICogQHBhcmFtIHJlcXVpcmVzUmVmcmVzaCAgIEEgZnVuY3Rpb24gdGhhdCB3aWxsIGV2YWx1YXRlIHRoZSByZXNvbHZlZCB2YWx1ZSBhbmRcbiAgICogICAgICAgICAgICAgICAgICAgICAgICAgIGRldGVybWluZSBpZiBpdCByZXByZXNlbnRzIHN0YXRpYyB2YWx1ZSBvciBvbmUgdGhhdFxuICAgKiAgICAgICAgICAgICAgICAgICAgICAgICAgd2lsbCBldmVudHVhbGx5IG5lZWQgdG8gYmUgcmVmcmVzaGVkLiBGb3IgZXhhbXBsZSxcbiAgICogICAgICAgICAgICAgICAgICAgICAgICAgIEFXUyBjcmVkZW50aWFscyB0aGF0IGhhdmUgbm8gZGVmaW5lZCBleHBpcmF0aW9uIHdpbGxcbiAgICogICAgICAgICAgICAgICAgICAgICAgICAgIG5ldmVyIG5lZWQgdG8gYmUgcmVmcmVzaGVkLCBzbyB0aGlzIGZ1bmN0aW9uIHdvdWxkXG4gICAqICAgICAgICAgICAgICAgICAgICAgICAgICByZXR1cm4gYHRydWVgIGlmIHRoZSBjcmVkZW50aWFscyByZXNvbHZlZCBieSB0aGVcbiAgICogICAgICAgICAgICAgICAgICAgICAgICAgIHVuZGVybHlpbmcgcHJvdmlkZXIgaGFkIGFuIGV4cGlyYXRpb24gYW5kIGBmYWxzZWBcbiAgICogICAgICAgICAgICAgICAgICAgICAgICAgIG90aGVyd2lzZS5cbiAgICovXG4gIDxUPihcbiAgICBwcm92aWRlcjogUHJvdmlkZXI8VD4sXG4gICAgaXNFeHBpcmVkOiAocmVzb2x2ZWQ6IFQpID0+IGJvb2xlYW4sXG4gICAgcmVxdWlyZXNSZWZyZXNoPzogKHJlc29sdmVkOiBUKSA9PiBib29sZWFuXG4gICk6IFByb3ZpZGVyPFQ+O1xufVxuXG5leHBvcnQgY29uc3QgbWVtb2l6ZTogTWVtb2l6ZU92ZXJsb2FkID0gPFQ+KFxuICBwcm92aWRlcjogUHJvdmlkZXI8VD4sXG4gIGlzRXhwaXJlZD86IChyZXNvbHZlZDogVCkgPT4gYm9vbGVhbixcbiAgcmVxdWlyZXNSZWZyZXNoPzogKHJlc29sdmVkOiBUKSA9PiBib29sZWFuXG4pOiBQcm92aWRlcjxUPiA9PiB7XG4gIGxldCByZXN1bHQ6IGFueTtcbiAgbGV0IGhhc1Jlc3VsdDogYm9vbGVhbjtcbiAgaWYgKGlzRXhwaXJlZCA9PT0gdW5kZWZpbmVkKSB7XG4gICAgLy8gVGhpcyBpcyBhIHN0YXRpYyBtZW1vaXphdGlvbjsgbm8gbmVlZCB0byBpbmNvcnBvcmF0ZSByZWZyZXNoaW5nXG4gICAgcmV0dXJuICgpID0+IHtcbiAgICAgIGlmICghaGFzUmVzdWx0KSB7XG4gICAgICAgIHJlc3VsdCA9IHByb3ZpZGVyKCk7XG4gICAgICAgIGhhc1Jlc3VsdCA9IHRydWU7XG4gICAgICB9XG4gICAgICByZXR1cm4gcmVzdWx0O1xuICAgIH07XG4gIH1cblxuICBsZXQgaXNDb25zdGFudCA9IGZhbHNlO1xuXG4gIHJldHVybiBhc3luYyAoKSA9PiB7XG4gICAgaWYgKCFoYXNSZXN1bHQpIHtcbiAgICAgIHJlc3VsdCA9IHByb3ZpZGVyKCk7XG4gICAgICBoYXNSZXN1bHQgPSB0cnVlO1xuICAgIH1cbiAgICBpZiAoaXNDb25zdGFudCkge1xuICAgICAgcmV0dXJuIHJlc3VsdDtcbiAgICB9XG5cbiAgICBjb25zdCByZXNvbHZlZCA9IGF3YWl0IHJlc3VsdDtcbiAgICBpZiAocmVxdWlyZXNSZWZyZXNoICYmICFyZXF1aXJlc1JlZnJlc2gocmVzb2x2ZWQpKSB7XG4gICAgICBpc0NvbnN0YW50ID0gdHJ1ZTtcbiAgICAgIHJldHVybiByZXNvbHZlZDtcbiAgICB9XG4gICAgaWYgKGlzRXhwaXJlZChyZXNvbHZlZCkpIHtcbiAgICAgIHJldHVybiAocmVzdWx0ID0gcHJvdmlkZXIoKSk7XG4gICAgfVxuICAgIHJldHVybiByZXNvbHZlZDtcbiAgfTtcbn07XG4iXX0=

/***/ }),
/* 1723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaHR0cEhhbmRsZXIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaHR0cEhhbmRsZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEh0dHBIYW5kbGVyT3B0aW9ucywgUmVxdWVzdEhhbmRsZXIgfSBmcm9tIFwiQGF3cy1zZGsvdHlwZXNcIjtcblxuaW1wb3J0IHsgSHR0cFJlcXVlc3QgfSBmcm9tIFwiLi9odHRwUmVxdWVzdFwiO1xuaW1wb3J0IHsgSHR0cFJlc3BvbnNlIH0gZnJvbSBcIi4vaHR0cFJlc3BvbnNlXCI7XG5cbmV4cG9ydCB0eXBlIEh0dHBIYW5kbGVyID0gUmVxdWVzdEhhbmRsZXI8SHR0cFJlcXVlc3QsIEh0dHBSZXNwb25zZSwgSHR0cEhhbmRsZXJPcHRpb25zPjtcbiJdfQ==

/***/ }),
/* 1724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HttpRequest; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);

var HttpRequest = /** @class */ (function () {
    function HttpRequest(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol
            ? options.protocol.substr(-1) !== ":"
                ? options.protocol + ":"
                : options.protocol
            : "https:";
        this.path = options.path ? (options.path.charAt(0) !== "/" ? "/" + options.path : options.path) : "/";
    }
    HttpRequest.isInstance = function (request) {
        //determine if request is a valid httpRequest
        if (!request)
            return false;
        var req = request;
        return ("method" in req &&
            "protocol" in req &&
            "hostname" in req &&
            "path" in req &&
            typeof req["query"] === "object" &&
            typeof req["headers"] === "object");
    };
    HttpRequest.prototype.clone = function () {
        var cloned = new HttpRequest(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, this), { headers: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, this.headers) }));
        if (cloned.query)
            cloned.query = cloneQuery(cloned.query);
        return cloned;
    };
    return HttpRequest;
}());

function cloneQuery(query) {
    return Object.keys(query).reduce(function (carry, paramName) {
        var _a;
        var param = query[paramName];
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, carry), (_a = {}, _a[paramName] = Array.isArray(param) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])(param) : param, _a));
    }, {});
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HttpResponse; });
var HttpResponse = /** @class */ (function () {
    function HttpResponse(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    HttpResponse.isInstance = function (response) {
        //determine if response is a valid HttpResponse
        if (!response)
            return false;
        var resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    };
    return HttpResponse;
}());

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaHR0cFJlc3BvbnNlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2h0dHBSZXNwb25zZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFRQTtJQUtFLHNCQUFZLE9BQTRCO1FBQ3RDLElBQUksQ0FBQyxVQUFVLEdBQUcsT0FBTyxDQUFDLFVBQVUsQ0FBQztRQUNyQyxJQUFJLENBQUMsT0FBTyxHQUFHLE9BQU8sQ0FBQyxPQUFPLElBQUksRUFBRSxDQUFDO1FBQ3JDLElBQUksQ0FBQyxJQUFJLEdBQUcsT0FBTyxDQUFDLElBQUksQ0FBQztJQUMzQixDQUFDO0lBRU0sdUJBQVUsR0FBakIsVUFBa0IsUUFBaUI7UUFDakMsK0NBQStDO1FBQy9DLElBQUksQ0FBQyxRQUFRO1lBQUUsT0FBTyxLQUFLLENBQUM7UUFDNUIsSUFBTSxJQUFJLEdBQUcsUUFBZSxDQUFDO1FBQzdCLE9BQU8sT0FBTyxJQUFJLENBQUMsVUFBVSxLQUFLLFFBQVEsSUFBSSxPQUFPLElBQUksQ0FBQyxPQUFPLEtBQUssUUFBUSxDQUFDO0lBQ2pGLENBQUM7SUFDSCxtQkFBQztBQUFELENBQUMsQUFqQkQsSUFpQkMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBIZWFkZXJCYWcsIEh0dHBNZXNzYWdlLCBIdHRwUmVzcG9uc2UgYXMgSUh0dHBSZXNwb25zZSB9IGZyb20gXCJAYXdzLXNkay90eXBlc1wiO1xuXG50eXBlIEh0dHBSZXNwb25zZU9wdGlvbnMgPSBQYXJ0aWFsPEh0dHBNZXNzYWdlPiAmIHtcbiAgc3RhdHVzQ29kZTogbnVtYmVyO1xufTtcblxuZXhwb3J0IGludGVyZmFjZSBIdHRwUmVzcG9uc2UgZXh0ZW5kcyBJSHR0cFJlc3BvbnNlIHt9XG5cbmV4cG9ydCBjbGFzcyBIdHRwUmVzcG9uc2Uge1xuICBwdWJsaWMgc3RhdHVzQ29kZTogbnVtYmVyO1xuICBwdWJsaWMgaGVhZGVyczogSGVhZGVyQmFnO1xuICBwdWJsaWMgYm9keT86IGFueTtcblxuICBjb25zdHJ1Y3RvcihvcHRpb25zOiBIdHRwUmVzcG9uc2VPcHRpb25zKSB7XG4gICAgdGhpcy5zdGF0dXNDb2RlID0gb3B0aW9ucy5zdGF0dXNDb2RlO1xuICAgIHRoaXMuaGVhZGVycyA9IG9wdGlvbnMuaGVhZGVycyB8fCB7fTtcbiAgICB0aGlzLmJvZHkgPSBvcHRpb25zLmJvZHk7XG4gIH1cblxuICBzdGF0aWMgaXNJbnN0YW5jZShyZXNwb25zZTogdW5rbm93bik6IHJlc3BvbnNlIGlzIEh0dHBSZXNwb25zZSB7XG4gICAgLy9kZXRlcm1pbmUgaWYgcmVzcG9uc2UgaXMgYSB2YWxpZCBIdHRwUmVzcG9uc2VcbiAgICBpZiAoIXJlc3BvbnNlKSByZXR1cm4gZmFsc2U7XG4gICAgY29uc3QgcmVzcCA9IHJlc3BvbnNlIGFzIGFueTtcbiAgICByZXR1cm4gdHlwZW9mIHJlc3Auc3RhdHVzQ29kZSA9PT0gXCJudW1iZXJcIiAmJiB0eXBlb2YgcmVzcC5oZWFkZXJzID09PSBcIm9iamVjdFwiO1xuICB9XG59XG4iXX0=

/***/ }),
/* 1726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isValidHostname */
function isValidHostname(hostname) {
    var hostPattern = /^[a-z0-9][a-z0-9\.\-]*[a-z0-9]$/;
    return hostPattern.test(hostname);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXNWYWxpZEhvc3RuYW1lLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2lzVmFsaWRIb3N0bmFtZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLFVBQVUsZUFBZSxDQUFDLFFBQWdCO0lBQzlDLElBQU0sV0FBVyxHQUFHLGlDQUFpQyxDQUFDO0lBQ3RELE9BQU8sV0FBVyxDQUFDLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQztBQUNwQyxDQUFDIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGZ1bmN0aW9uIGlzVmFsaWRIb3N0bmFtZShob3N0bmFtZTogc3RyaW5nKTogYm9vbGVhbiB7XG4gIGNvbnN0IGhvc3RQYXR0ZXJuID0gL15bYS16MC05XVthLXowLTlcXC5cXC1dKlthLXowLTldJC87XG4gIHJldHVybiBob3N0UGF0dGVybi50ZXN0KGhvc3RuYW1lKTtcbn1cbiJdfQ==

/***/ }),
/* 1727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = buildQueryString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_util_uri_escape__ = __webpack_require__(872);


function buildQueryString(query) {
    var e_1, _a;
    var parts = [];
    try {
        for (var _b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(Object.keys(query).sort()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            var value = query[key];
            key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__aws_sdk_util_uri_escape__["a" /* escapeUri */])(key);
            if (Array.isArray(value)) {
                for (var i = 0, iLen = value.length; i < iLen; i++) {
                    parts.push(key + "=" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__aws_sdk_util_uri_escape__["a" /* escapeUri */])(value[i]));
                }
            }
            else {
                var qsEntry = key;
                if (value || typeof value === "string") {
                    qsEntry += "=" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__aws_sdk_util_uri_escape__["a" /* escapeUri */])(value);
                }
                parts.push(qsEntry);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return parts.join("&");
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parseQueryString;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);

function parseQueryString(querystring) {
    var e_1, _a;
    var query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) {
        try {
            for (var _b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(querystring.split("&")), _c = _b.next(); !_c.done; _c = _b.next()) {
                var pair = _c.value;
                var _d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__read"])(pair.split("="), 2), key = _d[0], _e = _d[1], value = _e === void 0 ? null : _e;
                key = decodeURIComponent(key);
                if (value) {
                    value = decodeURIComponent(value);
                }
                if (!(key in query)) {
                    query[key] = value;
                }
                else if (Array.isArray(query[key])) {
                    query[key].push(value);
                }
                else {
                    query[key] = [query[key], value];
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return query;
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CLOCK_SKEW_ERROR_CODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return THROTTLING_ERROR_CODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TRANSIENT_ERROR_CODES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TRANSIENT_ERROR_STATUS_CODES; });
/**
 * Errors encountered when the client clock and server clock cannot agree on the
 * current time.
 *
 * These errors are retryable, assuming the SDK has enabled clock skew
 * correction.
 */
var CLOCK_SKEW_ERROR_CODES = [
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch",
];
/**
 * Errors that indicate the SDK is being throttled.
 *
 * These errors are always retryable.
 */
var THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException",
];
/**
 * Error codes that indicate transient issues
 */
var TRANSIENT_ERROR_CODES = ["AbortError", "TimeoutError", "RequestTimeout", "RequestTimeoutException"];
/**
 * Error codes that indicate transient issues
 */
var TRANSIENT_ERROR_STATUS_CODES = [500, 502, 503, 504];
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SignatureV4; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_util_hex_encoding__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__credentialDerivation__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getCanonicalHeaders__ = __webpack_require__(1731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getCanonicalQuery__ = __webpack_require__(1732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getPayloadHash__ = __webpack_require__(1733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hasHeader__ = __webpack_require__(1734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__moveHeadersToQuery__ = __webpack_require__(1736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__prepareRequest__ = __webpack_require__(1737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utilDate__ = __webpack_require__(1738);











var SignatureV4 = /** @class */ (function () {
    function SignatureV4(_a) {
        var applyChecksum = _a.applyChecksum, credentials = _a.credentials, region = _a.region, service = _a.service, sha256 = _a.sha256, _b = _a.uriEscapePath, uriEscapePath = _b === void 0 ? true : _b;
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        // default to true if applyChecksum isn't set
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = normalizeRegionProvider(region);
        this.credentialProvider = normalizeCredentialsProvider(credentials);
    }
    SignatureV4.prototype.presign = function (originalRequest, options) {
        if (options === void 0) { options = {}; }
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var _a, signingDate, _b, expiresIn, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, credentials, region, _c, _d, longDate, shortDate, scope, request, canonicalHeaders, _e, _f, _g, _h, _j, _k;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_l) {
                switch (_l.label) {
                    case 0:
                        _a = options.signingDate, signingDate = _a === void 0 ? new Date() : _a, _b = options.expiresIn, expiresIn = _b === void 0 ? 3600 : _b, unsignableHeaders = options.unsignableHeaders, unhoistableHeaders = options.unhoistableHeaders, signableHeaders = options.signableHeaders, signingRegion = options.signingRegion, signingService = options.signingService;
                        return [4 /*yield*/, this.credentialProvider()];
                    case 1:
                        credentials = _l.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [3 /*break*/, 2];
                        _c = signingRegion;
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.regionProvider()];
                    case 3:
                        _c = (_l.sent());
                        _l.label = 4;
                    case 4:
                        region = _c;
                        _d = formatDate(signingDate), longDate = _d.longDate, shortDate = _d.shortDate;
                        if (expiresIn > __WEBPACK_IMPORTED_MODULE_2__constants__["a" /* MAX_PRESIGNED_TTL */]) {
                            return [2 /*return*/, Promise.reject("Signature version 4 presigned URLs" + " must have an expiration date less than one week in" + " the future")];
                        }
                        scope = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__credentialDerivation__["a" /* createScope */])(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__moveHeadersToQuery__["a" /* moveHeadersToQuery */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__prepareRequest__["a" /* prepareRequest */])(originalRequest), { unhoistableHeaders: unhoistableHeaders });
                        if (credentials.sessionToken) {
                            request.query[__WEBPACK_IMPORTED_MODULE_2__constants__["b" /* TOKEN_QUERY_PARAM */]] = credentials.sessionToken;
                        }
                        request.query[__WEBPACK_IMPORTED_MODULE_2__constants__["c" /* ALGORITHM_QUERY_PARAM */]] = __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* ALGORITHM_IDENTIFIER */];
                        request.query[__WEBPACK_IMPORTED_MODULE_2__constants__["e" /* CREDENTIAL_QUERY_PARAM */]] = credentials.accessKeyId + "/" + scope;
                        request.query[__WEBPACK_IMPORTED_MODULE_2__constants__["f" /* AMZ_DATE_QUERY_PARAM */]] = longDate;
                        request.query[__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* EXPIRES_QUERY_PARAM */]] = expiresIn.toString(10);
                        canonicalHeaders = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getCanonicalHeaders__["a" /* getCanonicalHeaders */])(request, unsignableHeaders, signableHeaders);
                        request.query[__WEBPACK_IMPORTED_MODULE_2__constants__["h" /* SIGNED_HEADERS_QUERY_PARAM */]] = getCanonicalHeaderList(canonicalHeaders);
                        _e = request.query;
                        _f = __WEBPACK_IMPORTED_MODULE_2__constants__["i" /* SIGNATURE_QUERY_PARAM */];
                        _g = this.getSignature;
                        _h = [longDate,
                            scope,
                            this.getSigningKey(credentials, region, shortDate, signingService)];
                        _j = this.createCanonicalRequest;
                        _k = [request, canonicalHeaders];
                        return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPayloadHash__["a" /* getPayloadHash */])(originalRequest, this.sha256)];
                    case 5: return [4 /*yield*/, _g.apply(this, _h.concat([_j.apply(this, _k.concat([_l.sent()]))]))];
                    case 6:
                        _e[_f] = _l.sent();
                        return [2 /*return*/, request];
                }
            });
        });
    };
    SignatureV4.prototype.sign = function (toSign, options) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
                if (typeof toSign === "string") {
                    return [2 /*return*/, this.signString(toSign, options)];
                }
                else if (toSign.headers && toSign.payload) {
                    return [2 /*return*/, this.signEvent(toSign, options)];
                }
                else {
                    return [2 /*return*/, this.signRequest(toSign, options)];
                }
                return [2 /*return*/];
            });
        });
    };
    SignatureV4.prototype.signEvent = function (_a, _b) {
        var headers = _a.headers, payload = _a.payload;
        var _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, priorSignature = _b.priorSignature, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var region, _d, _e, shortDate, longDate, scope, hashedPayload, hash, hashedHeaders, _f, stringToSign;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_g) {
                switch (_g.label) {
                    case 0:
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [3 /*break*/, 1];
                        _d = signingRegion;
                        return [3 /*break*/, 3];
                    case 1: return [4 /*yield*/, this.regionProvider()];
                    case 2:
                        _d = (_g.sent());
                        _g.label = 3;
                    case 3:
                        region = _d;
                        _e = formatDate(signingDate), shortDate = _e.shortDate, longDate = _e.longDate;
                        scope = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__credentialDerivation__["a" /* createScope */])(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPayloadHash__["a" /* getPayloadHash */])({ headers: {}, body: payload }, this.sha256)];
                    case 4:
                        hashedPayload = _g.sent();
                        hash = new this.sha256();
                        hash.update(headers);
                        _f = __WEBPACK_IMPORTED_MODULE_1__aws_sdk_util_hex_encoding__["a" /* toHex */];
                        return [4 /*yield*/, hash.digest()];
                    case 5:
                        hashedHeaders = _f.apply(void 0, [_g.sent()]);
                        stringToSign = [
                            __WEBPACK_IMPORTED_MODULE_2__constants__["j" /* EVENT_ALGORITHM_IDENTIFIER */],
                            longDate,
                            scope,
                            priorSignature,
                            hashedHeaders,
                            hashedPayload,
                        ].join("\n");
                        return [2 /*return*/, this.signString(stringToSign, { signingDate: signingDate, signingRegion: region, signingService: signingService })];
                }
            });
        });
    };
    SignatureV4.prototype.signString = function (stringToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var credentials, region, _d, shortDate, hash, _e, _f, _g;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_h) {
                switch (_h.label) {
                    case 0: return [4 /*yield*/, this.credentialProvider()];
                    case 1:
                        credentials = _h.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [3 /*break*/, 2];
                        _d = signingRegion;
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.regionProvider()];
                    case 3:
                        _d = (_h.sent());
                        _h.label = 4;
                    case 4:
                        region = _d;
                        shortDate = formatDate(signingDate).shortDate;
                        _f = (_e = this.sha256).bind;
                        return [4 /*yield*/, this.getSigningKey(credentials, region, shortDate, signingService)];
                    case 5:
                        hash = new (_f.apply(_e, [void 0, _h.sent()]))();
                        hash.update(stringToSign);
                        _g = __WEBPACK_IMPORTED_MODULE_1__aws_sdk_util_hex_encoding__["a" /* toHex */];
                        return [4 /*yield*/, hash.digest()];
                    case 6: return [2 /*return*/, _g.apply(void 0, [_h.sent()])];
                }
            });
        });
    };
    SignatureV4.prototype.signRequest = function (requestToSign, _a) {
        var _b = _a === void 0 ? {} : _a, _c = _b.signingDate, signingDate = _c === void 0 ? new Date() : _c, signableHeaders = _b.signableHeaders, unsignableHeaders = _b.unsignableHeaders, signingRegion = _b.signingRegion, signingService = _b.signingService;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var credentials, region, _d, request, _e, longDate, shortDate, scope, payloadHash, canonicalHeaders, signature;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_f) {
                switch (_f.label) {
                    case 0: return [4 /*yield*/, this.credentialProvider()];
                    case 1:
                        credentials = _f.sent();
                        if (!(signingRegion !== null && signingRegion !== void 0)) return [3 /*break*/, 2];
                        _d = signingRegion;
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.regionProvider()];
                    case 3:
                        _d = (_f.sent());
                        _f.label = 4;
                    case 4:
                        region = _d;
                        request = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__prepareRequest__["a" /* prepareRequest */])(requestToSign);
                        _e = formatDate(signingDate), longDate = _e.longDate, shortDate = _e.shortDate;
                        scope = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__credentialDerivation__["a" /* createScope */])(shortDate, region, signingService !== null && signingService !== void 0 ? signingService : this.service);
                        request.headers[__WEBPACK_IMPORTED_MODULE_2__constants__["k" /* AMZ_DATE_HEADER */]] = longDate;
                        if (credentials.sessionToken) {
                            request.headers[__WEBPACK_IMPORTED_MODULE_2__constants__["l" /* TOKEN_HEADER */]] = credentials.sessionToken;
                        }
                        return [4 /*yield*/, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getPayloadHash__["a" /* getPayloadHash */])(request, this.sha256)];
                    case 5:
                        payloadHash = _f.sent();
                        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__hasHeader__["a" /* hasHeader */])(__WEBPACK_IMPORTED_MODULE_2__constants__["m" /* SHA256_HEADER */], request.headers) && this.applyChecksum) {
                            request.headers[__WEBPACK_IMPORTED_MODULE_2__constants__["m" /* SHA256_HEADER */]] = payloadHash;
                        }
                        canonicalHeaders = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getCanonicalHeaders__["a" /* getCanonicalHeaders */])(request, unsignableHeaders, signableHeaders);
                        return [4 /*yield*/, this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash))];
                    case 6:
                        signature = _f.sent();
                        request.headers[__WEBPACK_IMPORTED_MODULE_2__constants__["n" /* AUTH_HEADER */]] =
                            __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* ALGORITHM_IDENTIFIER */] + " " +
                                ("Credential=" + credentials.accessKeyId + "/" + scope + ", ") +
                                ("SignedHeaders=" + getCanonicalHeaderList(canonicalHeaders) + ", ") +
                                ("Signature=" + signature);
                        return [2 /*return*/, request];
                }
            });
        });
    };
    SignatureV4.prototype.createCanonicalRequest = function (request, canonicalHeaders, payloadHash) {
        var sortedHeaders = Object.keys(canonicalHeaders).sort();
        return request.method + "\n" + this.getCanonicalPath(request) + "\n" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getCanonicalQuery__["a" /* getCanonicalQuery */])(request) + "\n" + sortedHeaders.map(function (name) { return name + ":" + canonicalHeaders[name]; }).join("\n") + "\n\n" + sortedHeaders.join(";") + "\n" + payloadHash;
    };
    SignatureV4.prototype.createStringToSign = function (longDate, credentialScope, canonicalRequest) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var hash, hashedRequest;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        hash = new this.sha256();
                        hash.update(canonicalRequest);
                        return [4 /*yield*/, hash.digest()];
                    case 1:
                        hashedRequest = _a.sent();
                        return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_2__constants__["d" /* ALGORITHM_IDENTIFIER */] + "\n" + longDate + "\n" + credentialScope + "\n" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__aws_sdk_util_hex_encoding__["a" /* toHex */])(hashedRequest)];
                }
            });
        });
    };
    SignatureV4.prototype.getCanonicalPath = function (_a) {
        var path = _a.path;
        if (this.uriEscapePath) {
            var doubleEncoded = encodeURIComponent(path.replace(/^\//, ""));
            return "/" + doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    };
    SignatureV4.prototype.getSignature = function (longDate, credentialScope, keyPromise, canonicalRequest) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
            var stringToSign, hash, _a, _b, _c;
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_d) {
                switch (_d.label) {
                    case 0: return [4 /*yield*/, this.createStringToSign(longDate, credentialScope, canonicalRequest)];
                    case 1:
                        stringToSign = _d.sent();
                        _b = (_a = this.sha256).bind;
                        return [4 /*yield*/, keyPromise];
                    case 2:
                        hash = new (_b.apply(_a, [void 0, _d.sent()]))();
                        hash.update(stringToSign);
                        _c = __WEBPACK_IMPORTED_MODULE_1__aws_sdk_util_hex_encoding__["a" /* toHex */];
                        return [4 /*yield*/, hash.digest()];
                    case 3: return [2 /*return*/, _c.apply(void 0, [_d.sent()])];
                }
            });
        });
    };
    SignatureV4.prototype.getSigningKey = function (credentials, region, shortDate, service) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__credentialDerivation__["b" /* getSigningKey */])(this.sha256, credentials, shortDate, region, service || this.service);
    };
    return SignatureV4;
}());

var formatDate = function (now) {
    var longDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utilDate__["a" /* iso8601 */])(now).replace(/[\-:]/g, "");
    return {
        longDate: longDate,
        shortDate: longDate.substr(0, 8),
    };
};
var getCanonicalHeaderList = function (headers) { return Object.keys(headers).sort().join(";"); };
var normalizeRegionProvider = function (region) {
    if (typeof region === "string") {
        var promisified_1 = Promise.resolve(region);
        return function () { return promisified_1; };
    }
    else {
        return region;
    }
};
var normalizeCredentialsProvider = function (credentials) {
    if (typeof credentials === "object") {
        var promisified_2 = Promise.resolve(credentials);
        return function () { return promisified_2; };
    }
    else {
        return credentials;
    }
};
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCanonicalHeaders;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__constants__ = __webpack_require__(254);


/**
 * @internal
 */
function getCanonicalHeaders(_a, unsignableHeaders, signableHeaders) {
    var e_1, _b;
    var headers = _a.headers;
    var canonical = {};
    try {
        for (var _c = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(Object.keys(headers).sort()), _d = _c.next(); !_d.done; _d = _c.next()) {
            var headerName = _d.value;
            var canonicalHeaderName = headerName.toLowerCase();
            if (canonicalHeaderName in __WEBPACK_IMPORTED_MODULE_1__constants__["s" /* ALWAYS_UNSIGNABLE_HEADERS */] || (unsignableHeaders === null || unsignableHeaders === void 0 ? void 0 : unsignableHeaders.has(canonicalHeaderName)) ||
                __WEBPACK_IMPORTED_MODULE_1__constants__["t" /* PROXY_HEADER_PATTERN */].test(canonicalHeaderName) ||
                __WEBPACK_IMPORTED_MODULE_1__constants__["u" /* SEC_HEADER_PATTERN */].test(canonicalHeaderName)) {
                if (!signableHeaders || (signableHeaders && !signableHeaders.has(canonicalHeaderName))) {
                    continue;
                }
            }
            canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return canonical;
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCanonicalQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_util_uri_escape__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(254);



/**
 * @internal
 */
function getCanonicalQuery(_a) {
    var e_1, _b;
    var _c = _a.query, query = _c === void 0 ? {} : _c;
    var keys = [];
    var serialized = {};
    var _loop_1 = function (key) {
        if (key.toLowerCase() === __WEBPACK_IMPORTED_MODULE_2__constants__["q" /* SIGNATURE_HEADER */]) {
            return "continue";
        }
        keys.push(key);
        var value = query[key];
        if (typeof value === "string") {
            serialized[key] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__aws_sdk_util_uri_escape__["a" /* escapeUri */])(key) + "=" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__aws_sdk_util_uri_escape__["a" /* escapeUri */])(value);
        }
        else if (Array.isArray(value)) {
            serialized[key] = value
                .slice(0)
                .sort()
                .reduce(function (encoded, value) { return encoded.concat([__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__aws_sdk_util_uri_escape__["a" /* escapeUri */])(key) + "=" + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__aws_sdk_util_uri_escape__["a" /* escapeUri */])(value)]); }, [])
                .join("&");
        }
    };
    try {
        for (var _d = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(Object.keys(query).sort()), _e = _d.next(); !_e.done; _e = _d.next()) {
            var key = _e.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_b = _d.return)) _b.call(_d);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return keys
        .map(function (key) { return serialized[key]; })
        .filter(function (serialized) { return serialized; }) // omit any falsy values
        .join("&");
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getPayloadHash;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__aws_sdk_is_array_buffer__ = __webpack_require__(1704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__aws_sdk_util_hex_encoding__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants__ = __webpack_require__(254);




/**
 * @internal
 */
function getPayloadHash(_a, hashConstructor) {
    var headers = _a.headers, body = _a.body;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__awaiter"])(this, void 0, void 0, function () {
        var _b, _c, headerName, hashCtor, _d;
        var e_1, _e;
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__generator"])(this, function (_f) {
            switch (_f.label) {
                case 0:
                    try {
                        for (_b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()) {
                            headerName = _c.value;
                            if (headerName.toLowerCase() === __WEBPACK_IMPORTED_MODULE_3__constants__["m" /* SHA256_HEADER */]) {
                                return [2 /*return*/, headers[headerName]];
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_c && !_c.done && (_e = _b.return)) _e.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    if (!(body == undefined)) return [3 /*break*/, 1];
                    return [2 /*return*/, "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855"];
                case 1:
                    if (!(typeof body === "string" || ArrayBuffer.isView(body) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__aws_sdk_is_array_buffer__["a" /* isArrayBuffer */])(body))) return [3 /*break*/, 3];
                    hashCtor = new hashConstructor();
                    hashCtor.update(body);
                    _d = __WEBPACK_IMPORTED_MODULE_2__aws_sdk_util_hex_encoding__["a" /* toHex */];
                    return [4 /*yield*/, hashCtor.digest()];
                case 2: return [2 /*return*/, _d.apply(void 0, [_f.sent()])];
                case 3: 
                // As any defined body that is not a string or binary data is a stream, this
                // body is unsignable. Attempt to send the request with an unsigned payload,
                // which may or may not be accepted by the service.
                return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_3__constants__["r" /* UNSIGNED_PAYLOAD */]];
            }
        });
    });
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasHeader;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);

function hasHeader(soughtHeader, headers) {
    var e_1, _a;
    soughtHeader = soughtHeader.toLowerCase();
    try {
        for (var _b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(Object.keys(headers)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var headerName = _c.value;
            if (soughtHeader === headerName.toLowerCase()) {
                return true;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return false;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGFzSGVhZGVyLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2hhc0hlYWRlci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBRUEsTUFBTSxVQUFVLFNBQVMsQ0FBQyxZQUFvQixFQUFFLE9BQWtCOztJQUNoRSxZQUFZLEdBQUcsWUFBWSxDQUFDLFdBQVcsRUFBRSxDQUFDOztRQUMxQyxLQUF5QixJQUFBLEtBQUEsU0FBQSxNQUFNLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxDQUFBLGdCQUFBLDRCQUFFO1lBQTFDLElBQU0sVUFBVSxXQUFBO1lBQ25CLElBQUksWUFBWSxLQUFLLFVBQVUsQ0FBQyxXQUFXLEVBQUUsRUFBRTtnQkFDN0MsT0FBTyxJQUFJLENBQUM7YUFDYjtTQUNGOzs7Ozs7Ozs7SUFFRCxPQUFPLEtBQUssQ0FBQztBQUNmLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBIZWFkZXJCYWcgfSBmcm9tIFwiQGF3cy1zZGsvdHlwZXNcIjtcblxuZXhwb3J0IGZ1bmN0aW9uIGhhc0hlYWRlcihzb3VnaHRIZWFkZXI6IHN0cmluZywgaGVhZGVyczogSGVhZGVyQmFnKTogYm9vbGVhbiB7XG4gIHNvdWdodEhlYWRlciA9IHNvdWdodEhlYWRlci50b0xvd2VyQ2FzZSgpO1xuICBmb3IgKGNvbnN0IGhlYWRlck5hbWUgb2YgT2JqZWN0LmtleXMoaGVhZGVycykpIHtcbiAgICBpZiAoc291Z2h0SGVhZGVyID09PSBoZWFkZXJOYW1lLnRvTG93ZXJDYXNlKCkpIHtcbiAgICAgIHJldHVybiB0cnVlO1xuICAgIH1cbiAgfVxuXG4gIHJldHVybiBmYWxzZTtcbn1cbiJdfQ==

/***/ }),
/* 1735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__credentialDerivation__ = __webpack_require__(868);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SignatureV4__ = __webpack_require__(1730);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__SignatureV4__["a"]; });


//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsY0FBYyx3QkFBd0IsQ0FBQztBQUN2QyxjQUFjLGVBQWUsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gXCIuL2NyZWRlbnRpYWxEZXJpdmF0aW9uXCI7XG5leHBvcnQgKiBmcm9tIFwiLi9TaWduYXR1cmVWNFwiO1xuIl19

/***/ }),
/* 1736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = moveHeadersToQuery;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneRequest__ = __webpack_require__(867);


/**
 * @internal
 */
function moveHeadersToQuery(request, options) {
    var e_1, _a;
    var _b;
    if (options === void 0) { options = {}; }
    var _c = typeof request.clone === "function" ? request.clone() : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cloneRequest__["a" /* cloneRequest */])(request), headers = _c.headers, _d = _c.query, query = _d === void 0 ? {} : _d;
    try {
        for (var _e = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(Object.keys(headers)), _f = _e.next(); !_f.done; _f = _e.next()) {
            var name = _f.value;
            var lname = name.toLowerCase();
            if (lname.substr(0, 6) === "x-amz-" && !((_b = options.unhoistableHeaders) === null || _b === void 0 ? void 0 : _b.has(lname))) {
                query[name] = headers[name];
                delete headers[name];
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__assign"])({}, request), { headers: headers,
        query: query });
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = prepareRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneRequest__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(254);



/**
 * @internal
 */
function prepareRequest(request) {
    var e_1, _a;
    // Create a clone of the request object that does not clone the body
    request = typeof request.clone === "function" ? request.clone() : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__cloneRequest__["a" /* cloneRequest */])(request);
    try {
        for (var _b = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__values"])(Object.keys(request.headers)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var headerName = _c.value;
            if (__WEBPACK_IMPORTED_MODULE_2__constants__["v" /* GENERATED_HEADERS */].indexOf(headerName.toLowerCase()) > -1) {
                delete request.headers[headerName];
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return request;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJlcGFyZVJlcXVlc3QuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJlcGFyZVJlcXVlc3QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUVBLE9BQU8sRUFBRSxZQUFZLEVBQUUsTUFBTSxnQkFBZ0IsQ0FBQztBQUM5QyxPQUFPLEVBQUUsaUJBQWlCLEVBQUUsTUFBTSxhQUFhLENBQUM7QUFFaEQ7O0dBRUc7QUFDSCxNQUFNLFVBQVUsY0FBYyxDQUFDLE9BQW9COztJQUNqRCxvRUFBb0U7SUFDcEUsT0FBTyxHQUFHLE9BQVEsT0FBZSxDQUFDLEtBQUssS0FBSyxVQUFVLENBQUMsQ0FBQyxDQUFFLE9BQWUsQ0FBQyxLQUFLLEVBQUUsQ0FBQyxDQUFDLENBQUMsWUFBWSxDQUFDLE9BQU8sQ0FBQyxDQUFDOztRQUUxRyxLQUF5QixJQUFBLEtBQUEsU0FBQSxNQUFNLENBQUMsSUFBSSxDQUFDLE9BQU8sQ0FBQyxPQUFPLENBQUMsQ0FBQSxnQkFBQSw0QkFBRTtZQUFsRCxJQUFNLFVBQVUsV0FBQTtZQUNuQixJQUFJLGlCQUFpQixDQUFDLE9BQU8sQ0FBQyxVQUFVLENBQUMsV0FBVyxFQUFFLENBQUMsR0FBRyxDQUFDLENBQUMsRUFBRTtnQkFDNUQsT0FBTyxPQUFPLENBQUMsT0FBTyxDQUFDLFVBQVUsQ0FBQyxDQUFDO2FBQ3BDO1NBQ0Y7Ozs7Ozs7OztJQUVELE9BQU8sT0FBTyxDQUFDO0FBQ2pCLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBIdHRwUmVxdWVzdCB9IGZyb20gXCJAYXdzLXNkay90eXBlc1wiO1xuXG5pbXBvcnQgeyBjbG9uZVJlcXVlc3QgfSBmcm9tIFwiLi9jbG9uZVJlcXVlc3RcIjtcbmltcG9ydCB7IEdFTkVSQVRFRF9IRUFERVJTIH0gZnJvbSBcIi4vY29uc3RhbnRzXCI7XG5cbi8qKlxuICogQGludGVybmFsXG4gKi9cbmV4cG9ydCBmdW5jdGlvbiBwcmVwYXJlUmVxdWVzdChyZXF1ZXN0OiBIdHRwUmVxdWVzdCk6IEh0dHBSZXF1ZXN0IHtcbiAgLy8gQ3JlYXRlIGEgY2xvbmUgb2YgdGhlIHJlcXVlc3Qgb2JqZWN0IHRoYXQgZG9lcyBub3QgY2xvbmUgdGhlIGJvZHlcbiAgcmVxdWVzdCA9IHR5cGVvZiAocmVxdWVzdCBhcyBhbnkpLmNsb25lID09PSBcImZ1bmN0aW9uXCIgPyAocmVxdWVzdCBhcyBhbnkpLmNsb25lKCkgOiBjbG9uZVJlcXVlc3QocmVxdWVzdCk7XG5cbiAgZm9yIChjb25zdCBoZWFkZXJOYW1lIG9mIE9iamVjdC5rZXlzKHJlcXVlc3QuaGVhZGVycykpIHtcbiAgICBpZiAoR0VORVJBVEVEX0hFQURFUlMuaW5kZXhPZihoZWFkZXJOYW1lLnRvTG93ZXJDYXNlKCkpID4gLTEpIHtcbiAgICAgIGRlbGV0ZSByZXF1ZXN0LmhlYWRlcnNbaGVhZGVyTmFtZV07XG4gICAgfVxuICB9XG5cbiAgcmV0dXJuIHJlcXVlc3Q7XG59XG4iXX0=

/***/ }),
/* 1738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = iso8601;
/* unused harmony export toDate */
function iso8601(time) {
    return toDate(time)
        .toISOString()
        .replace(/\.\d{3}Z$/, "Z");
}
function toDate(time) {
    if (typeof time === "number") {
        return new Date(time * 1000);
    }
    if (typeof time === "string") {
        if (Number(time)) {
            return new Date(Number(time) * 1000);
        }
        return new Date(time);
    }
    return time;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbERhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbERhdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsTUFBTSxVQUFVLE9BQU8sQ0FBQyxJQUE0QjtJQUNsRCxPQUFPLE1BQU0sQ0FBQyxJQUFJLENBQUM7U0FDaEIsV0FBVyxFQUFFO1NBQ2IsT0FBTyxDQUFDLFdBQVcsRUFBRSxHQUFHLENBQUMsQ0FBQztBQUMvQixDQUFDO0FBRUQsTUFBTSxVQUFVLE1BQU0sQ0FBQyxJQUE0QjtJQUNqRCxJQUFJLE9BQU8sSUFBSSxLQUFLLFFBQVEsRUFBRTtRQUM1QixPQUFPLElBQUksSUFBSSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUMsQ0FBQztLQUM5QjtJQUVELElBQUksT0FBTyxJQUFJLEtBQUssUUFBUSxFQUFFO1FBQzVCLElBQUksTUFBTSxDQUFDLElBQUksQ0FBQyxFQUFFO1lBQ2hCLE9BQU8sSUFBSSxJQUFJLENBQUMsTUFBTSxDQUFDLElBQUksQ0FBQyxHQUFHLElBQUksQ0FBQyxDQUFDO1NBQ3RDO1FBQ0QsT0FBTyxJQUFJLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztLQUN2QjtJQUVELE9BQU8sSUFBSSxDQUFDO0FBQ2QsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBmdW5jdGlvbiBpc284NjAxKHRpbWU6IG51bWJlciB8IHN0cmluZyB8IERhdGUpOiBzdHJpbmcge1xuICByZXR1cm4gdG9EYXRlKHRpbWUpXG4gICAgLnRvSVNPU3RyaW5nKClcbiAgICAucmVwbGFjZSgvXFwuXFxkezN9WiQvLCBcIlpcIik7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiB0b0RhdGUodGltZTogbnVtYmVyIHwgc3RyaW5nIHwgRGF0ZSk6IERhdGUge1xuICBpZiAodHlwZW9mIHRpbWUgPT09IFwibnVtYmVyXCIpIHtcbiAgICByZXR1cm4gbmV3IERhdGUodGltZSAqIDEwMDApO1xuICB9XG5cbiAgaWYgKHR5cGVvZiB0aW1lID09PSBcInN0cmluZ1wiKSB7XG4gICAgaWYgKE51bWJlcih0aW1lKSkge1xuICAgICAgcmV0dXJuIG5ldyBEYXRlKE51bWJlcih0aW1lKSAqIDEwMDApO1xuICAgIH1cbiAgICByZXR1cm4gbmV3IERhdGUodGltZSk7XG4gIH1cblxuICByZXR1cm4gdGltZTtcbn1cbiJdfQ==

/***/ }),
/* 1739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Client; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aws_sdk_middleware_stack__ = __webpack_require__(862);

var Client = /** @class */ (function () {
    function Client(config) {
        this.middlewareStack = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__aws_sdk_middleware_stack__["a" /* constructStack */])();
        this.config = config;
    }
    Client.prototype.send = function (command, optionsOrCb, cb) {
        var options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        var callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        var handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) {
            handler(command)
                .then(function (result) { return callback(null, result.output); }, function (err) { return callback(err); })
                .catch(
            // prevent any errors thrown in the callback from triggering an
            // unhandled promise rejection
            function () { });
        }
        else {
            return handler(command).then(function (result) { return result.output; });
        }
    };
    Client.prototype.destroy = function () {
        if (this.config.requestHandler.destroy)
            this.config.requestHandler.destroy();
    };
    return Client;
}());

//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Command; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__aws_sdk_middleware_stack__ = __webpack_require__(862);

var Command = /** @class */ (function () {
    function Command() {
        this.middlewareStack = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__aws_sdk_middleware_stack__["a" /* constructStack */])();
    }
    return Command;
}());

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29tbWFuZC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb21tYW5kLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sRUFBRSxjQUFjLEVBQUUsTUFBTSwyQkFBMkIsQ0FBQztBQUczRDtJQUFBO1FBUVcsb0JBQWUsR0FBb0MsY0FBYyxFQUFpQixDQUFDO0lBTTlGLENBQUM7SUFBRCxjQUFDO0FBQUQsQ0FBQyxBQWRELElBY0MiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjb25zdHJ1Y3RTdGFjayB9IGZyb20gXCJAYXdzLXNkay9taWRkbGV3YXJlLXN0YWNrXCI7XG5pbXBvcnQgeyBDb21tYW5kIGFzIElDb21tYW5kLCBIYW5kbGVyLCBNZXRhZGF0YUJlYXJlciwgTWlkZGxld2FyZVN0YWNrIGFzIElNaWRkbGV3YXJlU3RhY2sgfSBmcm9tIFwiQGF3cy1zZGsvdHlwZXNcIjtcblxuZXhwb3J0IGFic3RyYWN0IGNsYXNzIENvbW1hbmQ8XG4gIElucHV0IGV4dGVuZHMgQ2xpZW50SW5wdXQsXG4gIE91dHB1dCBleHRlbmRzIENsaWVudE91dHB1dCxcbiAgUmVzb2x2ZWRDbGllbnRDb25maWd1cmF0aW9uLFxuICBDbGllbnRJbnB1dCBleHRlbmRzIG9iamVjdCA9IGFueSxcbiAgQ2xpZW50T3V0cHV0IGV4dGVuZHMgTWV0YWRhdGFCZWFyZXIgPSBhbnlcbj4gaW1wbGVtZW50cyBJQ29tbWFuZDxDbGllbnRJbnB1dCwgSW5wdXQsIENsaWVudE91dHB1dCwgT3V0cHV0LCBSZXNvbHZlZENsaWVudENvbmZpZ3VyYXRpb24+IHtcbiAgYWJzdHJhY3QgaW5wdXQ6IElucHV0O1xuICByZWFkb25seSBtaWRkbGV3YXJlU3RhY2s6IElNaWRkbGV3YXJlU3RhY2s8SW5wdXQsIE91dHB1dD4gPSBjb25zdHJ1Y3RTdGFjazxJbnB1dCwgT3V0cHV0PigpO1xuICBhYnN0cmFjdCByZXNvbHZlTWlkZGxld2FyZShcbiAgICBzdGFjazogSU1pZGRsZXdhcmVTdGFjazxDbGllbnRJbnB1dCwgQ2xpZW50T3V0cHV0PixcbiAgICBjb25maWd1cmF0aW9uOiBSZXNvbHZlZENsaWVudENvbmZpZ3VyYXRpb24sXG4gICAgb3B0aW9uczogYW55XG4gICk6IEhhbmRsZXI8SW5wdXQsIE91dHB1dD47XG59XG4iXX0=

/***/ }),
/* 1741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SENSITIVE_STRING */
var SENSITIVE_STRING = "***SensitiveInformation***";
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NvbnN0YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLENBQUMsSUFBTSxnQkFBZ0IsR0FBRyw0QkFBNEIsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBTRU5TSVRJVkVfU1RSSU5HID0gXCIqKipTZW5zaXRpdmVJbmZvcm1hdGlvbioqKlwiO1xuIl19

/***/ }),
/* 1742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dateToUtcString */
/**
 * Builds a proper UTC HttpDate timestamp from a Date object
 * since not all environments will have this as the expected
 * format.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toUTCString
 * > Prior to ECMAScript 2018, the format of the return value
 * > varied according to the platform. The most common return
 * > value was an RFC-1123 formatted date stamp, which is a
 * > slightly updated version of RFC-822 date stamps.
 */
// Build indexes outside so we allocate them once.
var days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
// prettier-ignore
var months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
function dateToUtcString(date) {
    var year = date.getUTCFullYear();
    var month = date.getUTCMonth();
    var dayOfWeek = date.getUTCDay();
    var dayOfMonthInt = date.getUTCDate();
    var hoursInt = date.getUTCHours();
    var minutesInt = date.getUTCMinutes();
    var secondsInt = date.getUTCSeconds();
    // Build 0 prefixed strings for contents that need to be
    // two digits and where we get an integer back.
    var dayOfMonthString = dayOfMonthInt < 10 ? "0" + dayOfMonthInt : "" + dayOfMonthInt;
    var hoursString = hoursInt < 10 ? "0" + hoursInt : "" + hoursInt;
    var minutesString = minutesInt < 10 ? "0" + minutesInt : "" + minutesInt;
    var secondsString = secondsInt < 10 ? "0" + secondsInt : "" + secondsInt;
    return days[dayOfWeek] + ", " + dayOfMonthString + " " + months[month] + " " + year + " " + hoursString + ":" + minutesString + ":" + secondsString + " GMT";
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZG9jdW1lbnQtdHlwZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kb2N1bWVudC10eXBlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiIiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIFNtaXRoeSBkb2N1bWVudCB0eXBlIHZhbHVlcy5cbiAqL1xuLy8gZXNsaW50LWRpc2FibGUtbmV4dC1saW5lIEB0eXBlc2NyaXB0LWVzbGludC9uby1uYW1lc3BhY2VcbmV4cG9ydCBuYW1lc3BhY2UgRG9jdW1lbnRUeXBlIHtcbiAgZXhwb3J0IHR5cGUgVmFsdWUgPSBTY2FsYXIgfCBTdHJ1Y3R1cmUgfCBMaXN0O1xuICBleHBvcnQgdHlwZSBTY2FsYXIgPSBzdHJpbmcgfCBudW1iZXIgfCBib29sZWFuIHwgbnVsbDtcbiAgZXhwb3J0IHR5cGUgU3RydWN0dXJlID0geyBbbWVtYmVyOiBzdHJpbmddOiBWYWx1ZSB9O1xuICBleHBvcnQgaW50ZXJmYWNlIExpc3QgZXh0ZW5kcyBBcnJheTxWYWx1ZT4ge31cbn1cbiJdfQ==

/***/ }),
/* 1744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXhjZXB0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2V4Y2VwdGlvbi50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgUmV0cnlhYmxlVHJhaXQgfSBmcm9tIFwiLi9yZXRyeWFibGUtdHJhaXRcIjtcblxuLyoqXG4gKiBUeXBlIHRoYXQgaXMgaW1wbGVtZW50ZWQgYnkgYWxsIFNtaXRoeSBzaGFwZXMgbWFya2VkIHdpdGggdGhlXG4gKiBlcnJvciB0cmFpdC5cbiAqL1xuZXhwb3J0IGludGVyZmFjZSBTbWl0aHlFeGNlcHRpb24ge1xuICAvKipcbiAgICogVGhlIHNoYXBlIElEIG5hbWUgb2YgdGhlIGV4Y2VwdGlvbi5cbiAgICovXG4gIHJlYWRvbmx5IG5hbWU6IHN0cmluZztcblxuICAvKipcbiAgICogV2hldGhlciB0aGUgY2xpZW50IG9yIHNlcnZlciBhcmUgYXQgZmF1bHQuXG4gICAqL1xuICByZWFkb25seSAkZmF1bHQ6IFwiY2xpZW50XCIgfCBcInNlcnZlclwiO1xuXG4gIC8qKlxuICAgKiBUaGUgc2VydmljZSB0aGF0IGVuY291bnRlcmVkIHRoZSBleGNlcHRpb24uXG4gICAqL1xuICByZWFkb25seSAkc2VydmljZT86IHN0cmluZztcblxuICAvKipcbiAgICogSW5kaWNhdGVzIHRoYXQgYW4gZXJyb3IgTUFZIGJlIHJldHJpZWQgYnkgdGhlIGNsaWVudC5cbiAgICovXG4gIHJlYWRvbmx5ICRyZXRyeWFibGU/OiBSZXRyeWFibGVUcmFpdDtcbn1cbiJdfQ==

/***/ }),
/* 1745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export extendedEncodeURIComponent */
/**
 * Function that wraps encodeURIComponent to encode additional characters
 * to fully adhere to RFC 3986.
 */
function extendedEncodeURIComponent(str) {
    return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
        return "%" + c.charCodeAt(0).toString(16);
    });
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXh0ZW5kZWQtZW5jb2RlLXVyaS1jb21wb25lbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZXh0ZW5kZWQtZW5jb2RlLXVyaS1jb21wb25lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7OztHQUdHO0FBQ0gsTUFBTSxVQUFVLDBCQUEwQixDQUFDLEdBQVc7SUFDcEQsT0FBTyxrQkFBa0IsQ0FBQyxHQUFHLENBQUMsQ0FBQyxPQUFPLENBQUMsVUFBVSxFQUFFLFVBQVUsQ0FBQztRQUM1RCxPQUFPLEdBQUcsR0FBRyxDQUFDLENBQUMsVUFBVSxDQUFDLENBQUMsQ0FBQyxDQUFDLFFBQVEsQ0FBQyxFQUFFLENBQUMsQ0FBQztJQUM1QyxDQUFDLENBQUMsQ0FBQztBQUNMLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEZ1bmN0aW9uIHRoYXQgd3JhcHMgZW5jb2RlVVJJQ29tcG9uZW50IHRvIGVuY29kZSBhZGRpdGlvbmFsIGNoYXJhY3RlcnNcbiAqIHRvIGZ1bGx5IGFkaGVyZSB0byBSRkMgMzk4Ni5cbiAqL1xuZXhwb3J0IGZ1bmN0aW9uIGV4dGVuZGVkRW5jb2RlVVJJQ29tcG9uZW50KHN0cjogc3RyaW5nKTogc3RyaW5nIHtcbiAgcmV0dXJuIGVuY29kZVVSSUNvbXBvbmVudChzdHIpLnJlcGxhY2UoL1shJygpKl0vZywgZnVuY3Rpb24gKGMpIHtcbiAgICByZXR1cm4gXCIlXCIgKyBjLmNoYXJDb2RlQXQoMCkudG9TdHJpbmcoMTYpO1xuICB9KTtcbn1cbiJdfQ==

/***/ }),
/* 1746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getArrayIfSingleItem */
/**
 * The XML parser will set one K:V for a member that could
 * return multiple entries but only has one.
 */
var getArrayIfSingleItem = function (mayBeArray) {
    return Array.isArray(mayBeArray) ? mayBeArray : [mayBeArray];
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LWFycmF5LWlmLXNpbmdsZS1pdGVtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2dldC1hcnJheS1pZi1zaW5nbGUtaXRlbS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7O0dBR0c7QUFDSCxNQUFNLENBQUMsSUFBTSxvQkFBb0IsR0FBRyxVQUFJLFVBQWE7SUFDbkQsT0FBQSxLQUFLLENBQUMsT0FBTyxDQUFDLFVBQVUsQ0FBQyxDQUFDLENBQUMsQ0FBQyxVQUFVLENBQUMsQ0FBQyxDQUFDLENBQUMsVUFBVSxDQUFDO0FBQXJELENBQXFELENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIFRoZSBYTUwgcGFyc2VyIHdpbGwgc2V0IG9uZSBLOlYgZm9yIGEgbWVtYmVyIHRoYXQgY291bGRcbiAqIHJldHVybiBtdWx0aXBsZSBlbnRyaWVzIGJ1dCBvbmx5IGhhcyBvbmUuXG4gKi9cbmV4cG9ydCBjb25zdCBnZXRBcnJheUlmU2luZ2xlSXRlbSA9IDxUPihtYXlCZUFycmF5OiBUKTogVCB8IFRbXSA9PlxuICBBcnJheS5pc0FycmF5KG1heUJlQXJyYXkpID8gbWF5QmVBcnJheSA6IFttYXlCZUFycmF5XTtcbiJdfQ==

/***/ }),
/* 1747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getValueFromTextNode */
/**
 * Recursively parses object and populates value is node from
 * "#text" key if it's available
 */
var getValueFromTextNode = function (obj) {
    var textNodeName = "#text";
    for (var key in obj) {
        if (obj.hasOwnProperty(key) && obj[key][textNodeName] !== undefined) {
            obj[key] = obj[key][textNodeName];
        }
        else if (typeof obj[key] === "object" && obj[key] !== null) {
            obj[key] = getValueFromTextNode(obj[key]);
        }
    }
    return obj;
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZ2V0LXZhbHVlLWZyb20tdGV4dC1ub2RlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2dldC12YWx1ZS1mcm9tLXRleHQtbm9kZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTs7O0dBR0c7QUFDSCxNQUFNLENBQUMsSUFBTSxvQkFBb0IsR0FBRyxVQUFDLEdBQVE7SUFDM0MsSUFBTSxZQUFZLEdBQUcsT0FBTyxDQUFDO0lBQzdCLEtBQUssSUFBTSxHQUFHLElBQUksR0FBRyxFQUFFO1FBQ3JCLElBQUksR0FBRyxDQUFDLGNBQWMsQ0FBQyxHQUFHLENBQUMsSUFBSSxHQUFHLENBQUMsR0FBRyxDQUFDLENBQUMsWUFBWSxDQUFDLEtBQUssU0FBUyxFQUFFO1lBQ25FLEdBQUcsQ0FBQyxHQUFHLENBQUMsR0FBRyxHQUFHLENBQUMsR0FBRyxDQUFDLENBQUMsWUFBWSxDQUFDLENBQUM7U0FDbkM7YUFBTSxJQUFJLE9BQU8sR0FBRyxDQUFDLEdBQUcsQ0FBQyxLQUFLLFFBQVEsSUFBSSxHQUFHLENBQUMsR0FBRyxDQUFDLEtBQUssSUFBSSxFQUFFO1lBQzVELEdBQUcsQ0FBQyxHQUFHLENBQUMsR0FBRyxvQkFBb0IsQ0FBQyxHQUFHLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQztTQUMzQztLQUNGO0lBQ0QsT0FBTyxHQUFHLENBQUM7QUFDYixDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIFJlY3Vyc2l2ZWx5IHBhcnNlcyBvYmplY3QgYW5kIHBvcHVsYXRlcyB2YWx1ZSBpcyBub2RlIGZyb21cbiAqIFwiI3RleHRcIiBrZXkgaWYgaXQncyBhdmFpbGFibGVcbiAqL1xuZXhwb3J0IGNvbnN0IGdldFZhbHVlRnJvbVRleHROb2RlID0gKG9iajogYW55KSA9PiB7XG4gIGNvbnN0IHRleHROb2RlTmFtZSA9IFwiI3RleHRcIjtcbiAgZm9yIChjb25zdCBrZXkgaW4gb2JqKSB7XG4gICAgaWYgKG9iai5oYXNPd25Qcm9wZXJ0eShrZXkpICYmIG9ialtrZXldW3RleHROb2RlTmFtZV0gIT09IHVuZGVmaW5lZCkge1xuICAgICAgb2JqW2tleV0gPSBvYmpba2V5XVt0ZXh0Tm9kZU5hbWVdO1xuICAgIH0gZWxzZSBpZiAodHlwZW9mIG9ialtrZXldID09PSBcIm9iamVjdFwiICYmIG9ialtrZXldICE9PSBudWxsKSB7XG4gICAgICBvYmpba2V5XSA9IGdldFZhbHVlRnJvbVRleHROb2RlKG9ialtrZXldKTtcbiAgICB9XG4gIH1cbiAgcmV0dXJuIG9iajtcbn07XG4iXX0=

/***/ }),
/* 1748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export StringWrapper */
/* unused harmony export LazyJsonString */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);
/**
 * Lazy String holder for JSON typed contents.
 */

/**
 * Because of https://github.com/microsoft/tslib/issues/95,
 * TS 'extends' shim doesn't support extending native types like String.
 * So here we create StringWrapper that duplicate everything from String
 * class including its prototype chain. So we can extend from here.
 */
// @ts-ignore StringWrapper implementation is not a simple constructor
var StringWrapper = function () {
    //@ts-ignore 'this' cannot be assigned to any, but Object.getPrototypeOf accepts any
    var Class = Object.getPrototypeOf(this).constructor;
    var Constructor = Function.bind.apply(String, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__spread"])([null], arguments));
    //@ts-ignore Call wrapped String constructor directly, don't bother typing it.
    var instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
StringWrapper.prototype = Object.create(String.prototype, {
    constructor: {
        value: StringWrapper,
        enumerable: false,
        writable: true,
        configurable: true,
    },
});
Object.setPrototypeOf(StringWrapper, String);
var LazyJsonString = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(LazyJsonString, _super);
    function LazyJsonString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyJsonString.prototype.deserializeJSON = function () {
        return JSON.parse(_super.prototype.toString.call(this));
    };
    LazyJsonString.prototype.toJSON = function () {
        return _super.prototype.toString.call(this);
    };
    LazyJsonString.fromObject = function (object) {
        if (object instanceof LazyJsonString) {
            return object;
        }
        else if (object instanceof String || typeof object === "string") {
            return new LazyJsonString(object);
        }
        return new LazyJsonString(JSON.stringify(object));
    };
    return LazyJsonString;
}(StringWrapper));

//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmV0cnlhYmxlLXRyYWl0LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3JldHJ5YWJsZS10cmFpdC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIiwic291cmNlc0NvbnRlbnQiOlsiLyoqXG4gKiBBIHN0cnVjdHVyZSBzaGFwZSB3aXRoIHRoZSBlcnJvciB0cmFpdC5cbiAqIGh0dHBzOi8vYXdzbGFicy5naXRodWIuaW8vc21pdGh5L3NwZWMvY29yZS5odG1sI3JldHJ5YWJsZS10cmFpdFxuICovXG5leHBvcnQgaW50ZXJmYWNlIFJldHJ5YWJsZVRyYWl0IHtcbiAgLyoqXG4gICAqIEluZGljYXRlcyB0aGF0IHRoZSBlcnJvciBpcyBhIHJldHJ5YWJsZSB0aHJvdHRsaW5nIGVycm9yLlxuICAgKi9cbiAgcmVhZG9ubHkgdGhyb3R0bGluZz86IGJvb2xlYW47XG59XG4iXX0=

/***/ }),
/* 1750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2RrLWVycm9yLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Nkay1lcnJvci50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgTWV0YWRhdGFCZWFyZXIgfSBmcm9tIFwiQGF3cy1zZGsvdHlwZXNcIjtcblxuaW1wb3J0IHsgU21pdGh5RXhjZXB0aW9uIH0gZnJvbSBcIi4vZXhjZXB0aW9uXCI7XG5cbmV4cG9ydCB0eXBlIFNka0Vycm9yID0gRXJyb3IgJiBTbWl0aHlFeGNlcHRpb24gJiBNZXRhZGF0YUJlYXJlcjtcbiJdfQ==

/***/ }),
/* 1751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export splitEvery */
/**
 * Given an input string, splits based on the delimiter after a given
 * number of delimiters has been encountered.
 *
 * @param value The input string to split.
 * @param delimiter The delimiter to split on.
 * @param numDelimiters The number of delimiters to have encountered to split.
 */
function splitEvery(value, delimiter, numDelimiters) {
    // Fail if we don't have a clear number to split on.
    if (numDelimiters <= 0 || !Number.isInteger(numDelimiters)) {
        throw new Error("Invalid number of delimiters (" + numDelimiters + ") for splitEvery.");
    }
    var segments = value.split(delimiter);
    // Short circuit extra logic for the simple case.
    if (numDelimiters === 1) {
        return segments;
    }
    var compoundSegments = [];
    var currentSegment = "";
    for (var i = 0; i < segments.length; i++) {
        if (currentSegment === "") {
            // Start a new segment.
            currentSegment = segments[i];
        }
        else {
            // Compound the current segment with the delimiter.
            currentSegment += delimiter + segments[i];
        }
        if ((i + 1) % numDelimiters === 0) {
            // We encountered the right number of delimiters, so add the entry.
            compoundSegments.push(currentSegment);
            // And reset the current segment.
            currentSegment = "";
        }
    }
    // Handle any leftover segment portion.
    if (currentSegment !== "") {
        compoundSegments.push(currentSegment);
    }
    return compoundSegments;
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export escapeUriPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__escape_uri__ = __webpack_require__(871);

var escapeUriPath = function (uri) { return uri.split("/").map(__WEBPACK_IMPORTED_MODULE_0__escape_uri__["a" /* escapeUri */]).join("/"); };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXNjYXBlLXVyaS1wYXRoLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2VzY2FwZS11cmktcGF0aC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsU0FBUyxFQUFFLE1BQU0sY0FBYyxDQUFDO0FBRXpDLE1BQU0sQ0FBQyxJQUFNLGFBQWEsR0FBRyxVQUFDLEdBQVcsSUFBYSxPQUFBLEdBQUcsQ0FBQyxLQUFLLENBQUMsR0FBRyxDQUFDLENBQUMsR0FBRyxDQUFDLFNBQVMsQ0FBQyxDQUFDLElBQUksQ0FBQyxHQUFHLENBQUMsRUFBdkMsQ0FBdUMsQ0FBQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGVzY2FwZVVyaSB9IGZyb20gXCIuL2VzY2FwZS11cmlcIjtcblxuZXhwb3J0IGNvbnN0IGVzY2FwZVVyaVBhdGggPSAodXJpOiBzdHJpbmcpOiBzdHJpbmcgPT4gdXJpLnNwbGl0KFwiL1wiKS5tYXAoZXNjYXBlVXJpKS5qb2luKFwiL1wiKTtcbiJdfQ==

/***/ }),
/* 1753 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.bowser=t():e.bowser=t()}(this,(function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var i=t[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)r.d(n,i,function(t){return e[t]}.bind(null,i));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=90)}({17:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=r(18),i=function(){function e(){}return e.getFirstMatch=function(e,t){var r=t.match(e);return r&&r.length>0&&r[1]||""},e.getSecondMatch=function(e,t){var r=t.match(e);return r&&r.length>1&&r[2]||""},e.matchAndReturnConst=function(e,t,r){if(e.test(t))return r},e.getWindowsVersionName=function(e){switch(e){case"NT":return"NT";case"XP":return"XP";case"NT 5.0":return"2000";case"NT 5.1":return"XP";case"NT 5.2":return"2003";case"NT 6.0":return"Vista";case"NT 6.1":return"7";case"NT 6.2":return"8";case"NT 6.3":return"8.1";case"NT 10.0":return"10";default:return}},e.getMacOSVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),10===t[0])switch(t[1]){case 5:return"Leopard";case 6:return"Snow Leopard";case 7:return"Lion";case 8:return"Mountain Lion";case 9:return"Mavericks";case 10:return"Yosemite";case 11:return"El Capitan";case 12:return"Sierra";case 13:return"High Sierra";case 14:return"Mojave";case 15:return"Catalina";default:return}},e.getAndroidVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),!(1===t[0]&&t[1]<5))return 1===t[0]&&t[1]<6?"Cupcake":1===t[0]&&t[1]>=6?"Donut":2===t[0]&&t[1]<2?"Eclair":2===t[0]&&2===t[1]?"Froyo":2===t[0]&&t[1]>2?"Gingerbread":3===t[0]?"Honeycomb":4===t[0]&&t[1]<1?"Ice Cream Sandwich":4===t[0]&&t[1]<4?"Jelly Bean":4===t[0]&&t[1]>=4?"KitKat":5===t[0]?"Lollipop":6===t[0]?"Marshmallow":7===t[0]?"Nougat":8===t[0]?"Oreo":9===t[0]?"Pie":void 0},e.getVersionPrecision=function(e){return e.split(".").length},e.compareVersions=function(t,r,n){void 0===n&&(n=!1);var i=e.getVersionPrecision(t),s=e.getVersionPrecision(r),a=Math.max(i,s),o=0,u=e.map([t,r],(function(t){var r=a-e.getVersionPrecision(t),n=t+new Array(r+1).join(".0");return e.map(n.split("."),(function(e){return new Array(20-e.length).join("0")+e})).reverse()}));for(n&&(o=a-Math.min(i,s)),a-=1;a>=o;){if(u[0][a]>u[1][a])return 1;if(u[0][a]===u[1][a]){if(a===o)return 0;a-=1}else if(u[0][a]<u[1][a])return-1}},e.map=function(e,t){var r,n=[];if(Array.prototype.map)return Array.prototype.map.call(e,t);for(r=0;r<e.length;r+=1)n.push(t(e[r]));return n},e.find=function(e,t){var r,n;if(Array.prototype.find)return Array.prototype.find.call(e,t);for(r=0,n=e.length;r<n;r+=1){var i=e[r];if(t(i,r))return i}},e.assign=function(e){for(var t,r,n=e,i=arguments.length,s=new Array(i>1?i-1:0),a=1;a<i;a++)s[a-1]=arguments[a];if(Object.assign)return Object.assign.apply(Object,[e].concat(s));var o=function(){var e=s[t];"object"==typeof e&&null!==e&&Object.keys(e).forEach((function(t){n[t]=e[t]}))};for(t=0,r=s.length;t<r;t+=1)o();return e},e.getBrowserAlias=function(e){return n.BROWSER_ALIASES_MAP[e]},e.getBrowserTypeByAlias=function(e){return n.BROWSER_MAP[e]||""},e}();t.default=i,e.exports=t.default},18:function(e,t,r){"use strict";t.__esModule=!0,t.ENGINE_MAP=t.OS_MAP=t.PLATFORMS_MAP=t.BROWSER_MAP=t.BROWSER_ALIASES_MAP=void 0;t.BROWSER_ALIASES_MAP={"Amazon Silk":"amazon_silk","Android Browser":"android",Bada:"bada",BlackBerry:"blackberry",Chrome:"chrome",Chromium:"chromium",Electron:"electron",Epiphany:"epiphany",Firefox:"firefox",Focus:"focus",Generic:"generic","Google Search":"google_search",Googlebot:"googlebot","Internet Explorer":"ie","K-Meleon":"k_meleon",Maxthon:"maxthon","Microsoft Edge":"edge","MZ Browser":"mz","NAVER Whale Browser":"naver",Opera:"opera","Opera Coast":"opera_coast",PhantomJS:"phantomjs",Puffin:"puffin",QupZilla:"qupzilla",QQ:"qq",QQLite:"qqlite",Safari:"safari",Sailfish:"sailfish","Samsung Internet for Android":"samsung_internet",SeaMonkey:"seamonkey",Sleipnir:"sleipnir",Swing:"swing",Tizen:"tizen","UC Browser":"uc",Vivaldi:"vivaldi","WebOS Browser":"webos",WeChat:"wechat","Yandex Browser":"yandex",Roku:"roku"};t.BROWSER_MAP={amazon_silk:"Amazon Silk",android:"Android Browser",bada:"Bada",blackberry:"BlackBerry",chrome:"Chrome",chromium:"Chromium",electron:"Electron",epiphany:"Epiphany",firefox:"Firefox",focus:"Focus",generic:"Generic",googlebot:"Googlebot",google_search:"Google Search",ie:"Internet Explorer",k_meleon:"K-Meleon",maxthon:"Maxthon",edge:"Microsoft Edge",mz:"MZ Browser",naver:"NAVER Whale Browser",opera:"Opera",opera_coast:"Opera Coast",phantomjs:"PhantomJS",puffin:"Puffin",qupzilla:"QupZilla",qq:"QQ Browser",qqlite:"QQ Browser Lite",safari:"Safari",sailfish:"Sailfish",samsung_internet:"Samsung Internet for Android",seamonkey:"SeaMonkey",sleipnir:"Sleipnir",swing:"Swing",tizen:"Tizen",uc:"UC Browser",vivaldi:"Vivaldi",webos:"WebOS Browser",wechat:"WeChat",yandex:"Yandex Browser"};t.PLATFORMS_MAP={tablet:"tablet",mobile:"mobile",desktop:"desktop",tv:"tv"};t.OS_MAP={WindowsPhone:"Windows Phone",Windows:"Windows",MacOS:"macOS",iOS:"iOS",Android:"Android",WebOS:"WebOS",BlackBerry:"BlackBerry",Bada:"Bada",Tizen:"Tizen",Linux:"Linux",ChromeOS:"Chrome OS",PlayStation4:"PlayStation 4",Roku:"Roku"};t.ENGINE_MAP={EdgeHTML:"EdgeHTML",Blink:"Blink",Trident:"Trident",Presto:"Presto",Gecko:"Gecko",WebKit:"WebKit"}},90:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(91))&&n.__esModule?n:{default:n},s=r(18);function a(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var o=function(){function e(){}var t,r,n;return e.getParser=function(e,t){if(void 0===t&&(t=!1),"string"!=typeof e)throw new Error("UserAgent should be a string");return new i.default(e,t)},e.parse=function(e){return new i.default(e).getResult()},t=e,n=[{key:"BROWSER_MAP",get:function(){return s.BROWSER_MAP}},{key:"ENGINE_MAP",get:function(){return s.ENGINE_MAP}},{key:"OS_MAP",get:function(){return s.OS_MAP}},{key:"PLATFORMS_MAP",get:function(){return s.PLATFORMS_MAP}}],(r=null)&&a(t.prototype,r),n&&a(t,n),e}();t.default=o,e.exports=t.default},91:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=u(r(92)),i=u(r(93)),s=u(r(94)),a=u(r(95)),o=u(r(17));function u(e){return e&&e.__esModule?e:{default:e}}var d=function(){function e(e,t){if(void 0===t&&(t=!1),null==e||""===e)throw new Error("UserAgent parameter can't be empty");this._ua=e,this.parsedResult={},!0!==t&&this.parse()}var t=e.prototype;return t.getUA=function(){return this._ua},t.test=function(e){return e.test(this._ua)},t.parseBrowser=function(){var e=this;this.parsedResult.browser={};var t=o.default.find(n.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.browser=t.describe(this.getUA())),this.parsedResult.browser},t.getBrowser=function(){return this.parsedResult.browser?this.parsedResult.browser:this.parseBrowser()},t.getBrowserName=function(e){return e?String(this.getBrowser().name).toLowerCase()||"":this.getBrowser().name||""},t.getBrowserVersion=function(){return this.getBrowser().version},t.getOS=function(){return this.parsedResult.os?this.parsedResult.os:this.parseOS()},t.parseOS=function(){var e=this;this.parsedResult.os={};var t=o.default.find(i.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.os=t.describe(this.getUA())),this.parsedResult.os},t.getOSName=function(e){var t=this.getOS().name;return e?String(t).toLowerCase()||"":t||""},t.getOSVersion=function(){return this.getOS().version},t.getPlatform=function(){return this.parsedResult.platform?this.parsedResult.platform:this.parsePlatform()},t.getPlatformType=function(e){void 0===e&&(e=!1);var t=this.getPlatform().type;return e?String(t).toLowerCase()||"":t||""},t.parsePlatform=function(){var e=this;this.parsedResult.platform={};var t=o.default.find(s.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.platform=t.describe(this.getUA())),this.parsedResult.platform},t.getEngine=function(){return this.parsedResult.engine?this.parsedResult.engine:this.parseEngine()},t.getEngineName=function(e){return e?String(this.getEngine().name).toLowerCase()||"":this.getEngine().name||""},t.parseEngine=function(){var e=this;this.parsedResult.engine={};var t=o.default.find(a.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.engine=t.describe(this.getUA())),this.parsedResult.engine},t.parse=function(){return this.parseBrowser(),this.parseOS(),this.parsePlatform(),this.parseEngine(),this},t.getResult=function(){return o.default.assign({},this.parsedResult)},t.satisfies=function(e){var t=this,r={},n=0,i={},s=0;if(Object.keys(e).forEach((function(t){var a=e[t];"string"==typeof a?(i[t]=a,s+=1):"object"==typeof a&&(r[t]=a,n+=1)})),n>0){var a=Object.keys(r),u=o.default.find(a,(function(e){return t.isOS(e)}));if(u){var d=this.satisfies(r[u]);if(void 0!==d)return d}var c=o.default.find(a,(function(e){return t.isPlatform(e)}));if(c){var f=this.satisfies(r[c]);if(void 0!==f)return f}}if(s>0){var l=Object.keys(i),h=o.default.find(l,(function(e){return t.isBrowser(e,!0)}));if(void 0!==h)return this.compareVersion(i[h])}},t.isBrowser=function(e,t){void 0===t&&(t=!1);var r=this.getBrowserName().toLowerCase(),n=e.toLowerCase(),i=o.default.getBrowserTypeByAlias(n);return t&&i&&(n=i.toLowerCase()),n===r},t.compareVersion=function(e){var t=[0],r=e,n=!1,i=this.getBrowserVersion();if("string"==typeof i)return">"===e[0]||"<"===e[0]?(r=e.substr(1),"="===e[1]?(n=!0,r=e.substr(2)):t=[],">"===e[0]?t.push(1):t.push(-1)):"="===e[0]?r=e.substr(1):"~"===e[0]&&(n=!0,r=e.substr(1)),t.indexOf(o.default.compareVersions(i,r,n))>-1},t.isOS=function(e){return this.getOSName(!0)===String(e).toLowerCase()},t.isPlatform=function(e){return this.getPlatformType(!0)===String(e).toLowerCase()},t.isEngine=function(e){return this.getEngineName(!0)===String(e).toLowerCase()},t.is=function(e,t){return void 0===t&&(t=!1),this.isBrowser(e,t)||this.isOS(e)||this.isPlatform(e)},t.some=function(e){var t=this;return void 0===e&&(e=[]),e.some((function(e){return t.is(e)}))},e}();t.default=d,e.exports=t.default},92:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n};var s=/version\/(\d+(\.?_?\d+)+)/i,a=[{test:[/googlebot/i],describe:function(e){var t={name:"Googlebot"},r=i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/opera/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opr\/|opios/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/SamsungBrowser/i],describe:function(e){var t={name:"Samsung Internet for Android"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Whale/i],describe:function(e){var t={name:"NAVER Whale Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MZBrowser/i],describe:function(e){var t={name:"MZ Browser"},r=i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/focus/i],describe:function(e){var t={name:"Focus"},r=i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/swing/i],describe:function(e){var t={name:"Swing"},r=i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/coast/i],describe:function(e){var t={name:"Opera Coast"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opt\/\d+(?:.?_?\d+)+/i],describe:function(e){var t={name:"Opera Touch"},r=i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/yabrowser/i],describe:function(e){var t={name:"Yandex Browser"},r=i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/ucbrowser/i],describe:function(e){var t={name:"UC Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Maxthon|mxios/i],describe:function(e){var t={name:"Maxthon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/epiphany/i],describe:function(e){var t={name:"Epiphany"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/puffin/i],describe:function(e){var t={name:"Puffin"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sleipnir/i],describe:function(e){var t={name:"Sleipnir"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/k-meleon/i],describe:function(e){var t={name:"K-Meleon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/micromessenger/i],describe:function(e){var t={name:"WeChat"},r=i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qqbrowser/i],describe:function(e){var t={name:/qqbrowserlite/i.test(e)?"QQ Browser Lite":"QQ Browser"},r=i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/msie|trident/i],describe:function(e){var t={name:"Internet Explorer"},r=i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/\sedg\//i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/edg([ea]|ios)/i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/vivaldi/i],describe:function(e){var t={name:"Vivaldi"},r=i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/seamonkey/i],describe:function(e){var t={name:"SeaMonkey"},r=i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sailfish/i],describe:function(e){var t={name:"Sailfish"},r=i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i,e);return r&&(t.version=r),t}},{test:[/silk/i],describe:function(e){var t={name:"Amazon Silk"},r=i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/phantom/i],describe:function(e){var t={name:"PhantomJS"},r=i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/slimerjs/i],describe:function(e){var t={name:"SlimerJS"},r=i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t={name:"BlackBerry"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t={name:"WebOS Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/bada/i],describe:function(e){var t={name:"Bada"},r=i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/tizen/i],describe:function(e){var t={name:"Tizen"},r=i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qupzilla/i],describe:function(e){var t={name:"QupZilla"},r=i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/firefox|iceweasel|fxios/i],describe:function(e){var t={name:"Firefox"},r=i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/electron/i],describe:function(e){var t={name:"Electron"},r=i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MiuiBrowser/i],describe:function(e){var t={name:"Miui"},r=i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/chromium/i],describe:function(e){var t={name:"Chromium"},r=i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/chrome|crios|crmo/i],describe:function(e){var t={name:"Chrome"},r=i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/GSA/i],describe:function(e){var t={name:"Google Search"},r=i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t={name:"Android Browser"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/playstation 4/i],describe:function(e){var t={name:"PlayStation 4"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/safari|applewebkit/i],describe:function(e){var t={name:"Safari"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/.*/i],describe:function(e){var t=-1!==e.search("\\(")?/^(.*)\/(.*)[ \t]\((.*)/:/^(.*)\/(.*) /;return{name:i.default.getFirstMatch(t,e),version:i.default.getSecondMatch(t,e)}}}];t.default=a,e.exports=t.default},93:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/Roku\/DVP/],describe:function(e){var t=i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i,e);return{name:s.OS_MAP.Roku,version:t}}},{test:[/windows phone/i],describe:function(e){var t=i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.WindowsPhone,version:t}}},{test:[/windows /i],describe:function(e){var t=i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i,e),r=i.default.getWindowsVersionName(t);return{name:s.OS_MAP.Windows,version:t,versionName:r}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(e){var t={name:s.OS_MAP.iOS},r=i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/,e);return r&&(t.version=r),t}},{test:[/macintosh/i],describe:function(e){var t=i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i,e).replace(/[_\s]/g,"."),r=i.default.getMacOSVersionName(t),n={name:s.OS_MAP.MacOS,version:t};return r&&(n.versionName=r),n}},{test:[/(ipod|iphone|ipad)/i],describe:function(e){var t=i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i,e).replace(/[_\s]/g,".");return{name:s.OS_MAP.iOS,version:t}}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t=i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i,e),r=i.default.getAndroidVersionName(t),n={name:s.OS_MAP.Android,version:t};return r&&(n.versionName=r),n}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t=i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i,e),r={name:s.OS_MAP.WebOS};return t&&t.length&&(r.version=t),r}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t=i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i,e)||i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i,e)||i.default.getFirstMatch(/\bbb(\d+)/i,e);return{name:s.OS_MAP.BlackBerry,version:t}}},{test:[/bada/i],describe:function(e){var t=i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Bada,version:t}}},{test:[/tizen/i],describe:function(e){var t=i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Tizen,version:t}}},{test:[/linux/i],describe:function(){return{name:s.OS_MAP.Linux}}},{test:[/CrOS/],describe:function(){return{name:s.OS_MAP.ChromeOS}}},{test:[/PlayStation 4/],describe:function(e){var t=i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.PlayStation4,version:t}}}];t.default=a,e.exports=t.default},94:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/googlebot/i],describe:function(){return{type:"bot",vendor:"Google"}}},{test:[/huawei/i],describe:function(e){var t=i.default.getFirstMatch(/(can-l01)/i,e)&&"Nova",r={type:s.PLATFORMS_MAP.mobile,vendor:"Huawei"};return t&&(r.model=t),r}},{test:[/nexus\s*(?:7|8|9|10).*/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Nexus"}}},{test:[/ipad/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/kftt build/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon",model:"Kindle Fire HD 7"}}},{test:[/silk/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon"}}},{test:[/tablet(?! pc)/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){var t=e.test(/ipod|iphone/i),r=e.test(/like (ipod|iphone)/i);return t&&!r},describe:function(e){var t=i.default.getFirstMatch(/(ipod|iphone)/i,e);return{type:s.PLATFORMS_MAP.mobile,vendor:"Apple",model:t}}},{test:[/nexus\s*[0-6].*/i,/galaxy nexus/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Nexus"}}},{test:[/[^-]mobi/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"blackberry"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"BlackBerry"}}},{test:function(e){return"bada"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"windows phone"===e.getBrowserName()},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Microsoft"}}},{test:function(e){var t=Number(String(e.getOSVersion()).split(".")[0]);return"android"===e.getOSName(!0)&&t>=3},describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){return"android"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"macos"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop,vendor:"Apple"}}},{test:function(e){return"windows"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"linux"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"playstation 4"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}},{test:function(e){return"roku"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}}];t.default=a,e.exports=t.default},95:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:function(e){return"microsoft edge"===e.getBrowserName(!0)},describe:function(e){if(/\sedg\//i.test(e))return{name:s.ENGINE_MAP.Blink};var t=i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i,e);return{name:s.ENGINE_MAP.EdgeHTML,version:t}}},{test:[/trident/i],describe:function(e){var t={name:s.ENGINE_MAP.Trident},r=i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){return e.test(/presto/i)},describe:function(e){var t={name:s.ENGINE_MAP.Presto},r=i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=e.test(/gecko/i),r=e.test(/like gecko/i);return t&&!r},describe:function(e){var t={name:s.ENGINE_MAP.Gecko},r=i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(apple)?webkit\/537\.36/i],describe:function(){return{name:s.ENGINE_MAP.Blink}}},{test:[/(apple)?webkit/i],describe:function(e){var t={name:s.ENGINE_MAP.WebKit},r=i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}}];t.default=a,e.exports=t.default}})}));

/***/ }),
/* 1754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fromUtf8", function() { return fromUtf8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toUtf8", function() { return toUtf8; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pureJs__ = __webpack_require__(1755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__whatwgEncodingApi__ = __webpack_require__(1756);


var fromUtf8 = function (input) {
    return typeof TextEncoder === "function" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__whatwgEncodingApi__["a" /* fromUtf8 */])(input) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__pureJs__["a" /* fromUtf8 */])(input);
};
var toUtf8 = function (input) {
    return typeof TextDecoder === "function" ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__whatwgEncodingApi__["b" /* toUtf8 */])(input) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__pureJs__["b" /* toUtf8 */])(input);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFFBQVEsSUFBSSxVQUFVLEVBQUUsTUFBTSxJQUFJLFFBQVEsRUFBRSxNQUFNLFVBQVUsQ0FBQztBQUN0RSxPQUFPLEVBQUUsUUFBUSxJQUFJLG1CQUFtQixFQUFFLE1BQU0sSUFBSSxpQkFBaUIsRUFBRSxNQUFNLHFCQUFxQixDQUFDO0FBS25HLE1BQU0sQ0FBQyxJQUFNLFFBQVEsR0FBRyxVQUFDLEtBQWE7SUFDcEMsT0FBQSxPQUFPLFdBQVcsS0FBSyxVQUFVLENBQUMsQ0FBQyxDQUFDLG1CQUFtQixDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxVQUFVLENBQUMsS0FBSyxDQUFDO0FBQWxGLENBQWtGLENBQUM7QUFFckYsTUFBTSxDQUFDLElBQU0sTUFBTSxHQUFHLFVBQUMsS0FBaUI7SUFDdEMsT0FBQSxPQUFPLFdBQVcsS0FBSyxVQUFVLENBQUMsQ0FBQyxDQUFDLGlCQUFpQixDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxRQUFRLENBQUMsS0FBSyxDQUFDO0FBQTlFLENBQThFLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBmcm9tVXRmOCBhcyBqc0Zyb21VdGY4LCB0b1V0ZjggYXMganNUb1V0ZjggfSBmcm9tIFwiLi9wdXJlSnNcIjtcbmltcG9ydCB7IGZyb21VdGY4IGFzIHRleHRFbmNvZGVyRnJvbVV0ZjgsIHRvVXRmOCBhcyB0ZXh0RW5jb2RlclRvVXRmOCB9IGZyb20gXCIuL3doYXR3Z0VuY29kaW5nQXBpXCI7XG5cbmRlY2xhcmUgY29uc3QgVGV4dERlY29kZXI6IEZ1bmN0aW9uIHwgdW5kZWZpbmVkO1xuZGVjbGFyZSBjb25zdCBUZXh0RW5jb2RlcjogRnVuY3Rpb24gfCB1bmRlZmluZWQ7XG5cbmV4cG9ydCBjb25zdCBmcm9tVXRmOCA9IChpbnB1dDogc3RyaW5nKTogVWludDhBcnJheSA9PlxuICB0eXBlb2YgVGV4dEVuY29kZXIgPT09IFwiZnVuY3Rpb25cIiA/IHRleHRFbmNvZGVyRnJvbVV0ZjgoaW5wdXQpIDoganNGcm9tVXRmOChpbnB1dCk7XG5cbmV4cG9ydCBjb25zdCB0b1V0ZjggPSAoaW5wdXQ6IFVpbnQ4QXJyYXkpOiBzdHJpbmcgPT5cbiAgdHlwZW9mIFRleHREZWNvZGVyID09PSBcImZ1bmN0aW9uXCIgPyB0ZXh0RW5jb2RlclRvVXRmOChpbnB1dCkgOiBqc1RvVXRmOChpbnB1dCk7XG4iXX0=

/***/ }),
/* 1755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fromUtf8; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return toUtf8; });
/**
 * Converts a JS string from its native UCS-2/UTF-16 representation into a
 * Uint8Array of the bytes used to represent the equivalent characters in UTF-8.
 *
 * Cribbed from the `goog.crypt.stringToUtf8ByteArray` function in the Google
 * Closure library, though updated to use typed arrays.
 */
var fromUtf8 = function (input) {
    var bytes = [];
    for (var i = 0, len = input.length; i < len; i++) {
        var value = input.charCodeAt(i);
        if (value < 0x80) {
            bytes.push(value);
        }
        else if (value < 0x800) {
            bytes.push((value >> 6) | 192, (value & 63) | 128);
        }
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            var surrogatePair = 0x10000 + ((value & 1023) << 10) + (input.charCodeAt(++i) & 1023);
            bytes.push((surrogatePair >> 18) | 240, ((surrogatePair >> 12) & 63) | 128, ((surrogatePair >> 6) & 63) | 128, (surrogatePair & 63) | 128);
        }
        else {
            bytes.push((value >> 12) | 224, ((value >> 6) & 63) | 128, (value & 63) | 128);
        }
    }
    return Uint8Array.from(bytes);
};
/**
 * Converts a typed array of bytes containing UTF-8 data into a native JS
 * string.
 *
 * Partly cribbed from the `goog.crypt.utf8ByteArrayToString` function in the
 * Google Closure library, though updated to use typed arrays and to better
 * handle astral plane code points.
 */
var toUtf8 = function (input) {
    var decoded = "";
    for (var i = 0, len = input.length; i < len; i++) {
        var byte = input[i];
        if (byte < 0x80) {
            decoded += String.fromCharCode(byte);
        }
        else if (192 <= byte && byte < 224) {
            var nextByte = input[++i];
            decoded += String.fromCharCode(((byte & 31) << 6) | (nextByte & 63));
        }
        else if (240 <= byte && byte < 365) {
            var surrogatePair = [byte, input[++i], input[++i], input[++i]];
            var encoded = "%" + surrogatePair.map(function (byteValue) { return byteValue.toString(16); }).join("%");
            decoded += decodeURIComponent(encoded);
        }
        else {
            decoded += String.fromCharCode(((byte & 15) << 12) | ((input[++i] & 63) << 6) | (input[++i] & 63));
        }
    }
    return decoded;
};
//# sourceMappingURL=data:application/json;base64,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

/***/ }),
/* 1756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = fromUtf8;
/* harmony export (immutable) */ __webpack_exports__["b"] = toUtf8;
function fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoid2hhdHdnRW5jb2RpbmdBcGkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvd2hhdHdnRW5jb2RpbmdBcGkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBeUNBLE1BQU0sVUFBVSxRQUFRLENBQUMsS0FBYTtJQUNwQyxPQUFPLElBQUksV0FBVyxFQUFFLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDO0FBQ3pDLENBQUM7QUFFRCxNQUFNLFVBQVUsTUFBTSxDQUFDLEtBQWlCO0lBQ3RDLE9BQU8sSUFBSSxXQUFXLENBQUMsT0FBTyxDQUFDLENBQUMsTUFBTSxDQUFDLEtBQUssQ0FBQyxDQUFDO0FBQ2hELENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEEgZGVjbGFyYXRpb24gb2YgdGhlIGdsb2JhbCBUZXh0RW5jb2RlciBhbmQgVGV4dERlY29kZXIgY29uc3RydWN0b3JzLlxuICpcbiAqIEBzZWUgaHR0cHM6Ly9lbmNvZGluZy5zcGVjLndoYXR3Zy5vcmcvXG4gKi9cbi8vIGVzbGludC1kaXNhYmxlLW5leHQtbGluZSBAdHlwZXNjcmlwdC1lc2xpbnQvbm8tbmFtZXNwYWNlXG5uYW1lc3BhY2UgRW5jb2Rpbmcge1xuICBpbnRlcmZhY2UgVGV4dERlY29kZXJPcHRpb25zIHtcbiAgICBmYXRhbD86IGJvb2xlYW47XG4gICAgaWdub3JlQk9NPzogYm9vbGVhbjtcbiAgfVxuXG4gIGludGVyZmFjZSBUZXh0RGVjb2RlT3B0aW9ucyB7XG4gICAgc3RyZWFtPzogYm9vbGVhbjtcbiAgfVxuXG4gIGludGVyZmFjZSBUZXh0RGVjb2RlciB7XG4gICAgcmVhZG9ubHkgZW5jb2Rpbmc6IHN0cmluZztcbiAgICByZWFkb25seSBmYXRhbDogYm9vbGVhbjtcbiAgICByZWFkb25seSBpZ25vcmVCT006IGJvb2xlYW47XG4gICAgZGVjb2RlKGlucHV0PzogQXJyYXlCdWZmZXIgfCBBcnJheUJ1ZmZlclZpZXcsIG9wdGlvbnM/OiBUZXh0RGVjb2RlT3B0aW9ucyk6IHN0cmluZztcbiAgfVxuXG4gIGV4cG9ydCBpbnRlcmZhY2UgVGV4dERlY29kZXJDb25zdHJ1Y3RvciB7XG4gICAgbmV3IChsYWJlbD86IHN0cmluZywgb3B0aW9ucz86IFRleHREZWNvZGVyT3B0aW9ucyk6IFRleHREZWNvZGVyO1xuICB9XG5cbiAgaW50ZXJmYWNlIFRleHRFbmNvZGVyIHtcbiAgICByZWFkb25seSBlbmNvZGluZzogXCJ1dGYtOFwiO1xuICAgIGVuY29kZShpbnB1dD86IHN0cmluZyk6IFVpbnQ4QXJyYXk7XG4gIH1cblxuICBleHBvcnQgaW50ZXJmYWNlIFRleHRFbmNvZGVyQ29uc3RydWN0b3Ige1xuICAgIG5ldyAoKTogVGV4dEVuY29kZXI7XG4gIH1cbn1cblxuZGVjbGFyZSBjb25zdCBUZXh0RGVjb2RlcjogRW5jb2RpbmcuVGV4dERlY29kZXJDb25zdHJ1Y3RvcjtcblxuZGVjbGFyZSBjb25zdCBUZXh0RW5jb2RlcjogRW5jb2RpbmcuVGV4dEVuY29kZXJDb25zdHJ1Y3RvcjtcblxuZXhwb3J0IGZ1bmN0aW9uIGZyb21VdGY4KGlucHV0OiBzdHJpbmcpOiBVaW50OEFycmF5IHtcbiAgcmV0dXJuIG5ldyBUZXh0RW5jb2RlcigpLmVuY29kZShpbnB1dCk7XG59XG5cbmV4cG9ydCBmdW5jdGlvbiB0b1V0ZjgoaW5wdXQ6IFVpbnQ4QXJyYXkpOiBzdHJpbmcge1xuICByZXR1cm4gbmV3IFRleHREZWNvZGVyKFwidXRmLThcIikuZGVjb2RlKGlucHV0KTtcbn1cbiJdfQ==

/***/ }),
/* 1757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(1758);

var _global = _interopRequireDefault(__webpack_require__(2631));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

if (_global["default"]._babelPolyfill && typeof console !== "undefined" && console.warn) {
  console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended " + "and may have consequences if different versions of the polyfills are applied sequentially. " + "If you do need to load the polyfill more than once, use @babel/polyfill/noConflict " + "instead to bypass the warning.");
}

_global["default"]._babelPolyfill = true;

/***/ }),
/* 1758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(2619);

__webpack_require__(2621);

__webpack_require__(2620);

__webpack_require__(2627);

__webpack_require__(2626);

__webpack_require__(2629);

__webpack_require__(2628);

__webpack_require__(2630);

__webpack_require__(2623);

__webpack_require__(2624);

__webpack_require__(2622);

__webpack_require__(2625);

__webpack_require__(2824);

__webpack_require__(1759);

/***/ }),
/* 1759 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   true ? module.exports : {}
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}


/***/ }),
/* 1760 */
/***/ (function(module, exports) {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
module.exports = _arrayWithHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1761 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(874);
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayLikeToArray;
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

/***/ }),
/* 1763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 1764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(878);

function _defineProperty(obj, key, value) {
  key = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 1765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 1766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(877);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 1767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

/***/ }),
/* 1768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),
/* 1769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__ = __webpack_require__(528);


function _possibleConstructorReturn(self, call) {
  if (call && (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized_js__["a" /* default */])(self);
}

/***/ }),
/* 1770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__ = __webpack_require__(1763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__ = __webpack_require__(1767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__ = __webpack_require__(1772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__ = __webpack_require__(1768);




function _toArray(arr) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles_js__["a" /* default */])(arr) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__iterableToArray_js__["a" /* default */])(arr) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__unsupportedIterableToArray_js__["a" /* default */])(arr) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__nonIterableRest_js__["a" /* default */])();
}

/***/ }),
/* 1771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(370);

function _toPrimitive(input, hint) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

/***/ }),
/* 1772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _unsupportedIterableToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__ = __webpack_require__(1762);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayLikeToArray_js__["a" /* default */])(o, minLen);
}

/***/ }),
/* 1773 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1774 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(1782);
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1775 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1776 */
/***/ (function(module, exports) {

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
module.exports = _iterableToArrayLimit, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1777 */
/***/ (function(module, exports) {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableRest, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1778 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1779 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1780 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(214)["default"];
var assertThisInitialized = __webpack_require__(875);
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1781 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(214)["default"];
function _regeneratorRuntime() {
  "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
    return exports;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function define(obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function value(method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return doneResult();
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    return {
      next: doneResult
    };
  }
  function doneResult() {
    return {
      value: undefined,
      done: !0
    };
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function stop() {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function complete(record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function finish(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    "catch": function _catch(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1782 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1783 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(1761);
var iterableToArray = __webpack_require__(1775);
var unsupportedIterableToArray = __webpack_require__(880);
var nonIterableSpread = __webpack_require__(1778);
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1784 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(214)["default"];
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
module.exports = _toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 1785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventListener; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useEventListener__ = __webpack_require__(881);

var EventListener = /*#__PURE__*/function () {
  function EventListener(props) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__useEventListener__["a" /* useEventListener */])(props);
    return null;
  }

  EventListener.defaultProps = {
    capture: false
  };
  return EventListener;
}();
//# sourceMappingURL=EventListener.js.map


/***/ }),
/* 1786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "documentRef", function() { return documentRef; });
/* unused harmony export windowRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EventListener__ = __webpack_require__(1785);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "EventListener", function() { return __WEBPACK_IMPORTED_MODULE_0__EventListener__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(1787);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useEventListener__ = __webpack_require__(881);
/* unused harmony reexport useEventListener */
var documentRef = {
  current: typeof document === 'undefined' ? null : document
};
var windowRef = {
  current: typeof window === 'undefined' ? null : window
};



//# sourceMappingURL=index.js.map


/***/ }),
/* 1787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

//# sourceMappingURL=types.js.map


/***/ }),
/* 1788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ref; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RefFindNode__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RefForward__ = __webpack_require__(883);

var _excluded = ["children", "innerRef"];




var Ref = function Ref(props) {
  var children = props.children,
      innerRef = props.innerRef,
      rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, _excluded);

  var child = __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(children);
  var ElementType = __WEBPACK_IMPORTED_MODULE_2_react_is__["isForwardRef"](child) ? __WEBPACK_IMPORTED_MODULE_4__RefForward__["a" /* RefForward */] : __WEBPACK_IMPORTED_MODULE_3__RefFindNode__["a" /* RefFindNode */];
  var childWithProps = child && rest && Object.keys(rest).length > 0 ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"](child, rest) : child;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react__["createElement"](ElementType, {
    innerRef: innerRef
  }, childWithProps);
};
//# sourceMappingURL=Ref.js.map


/***/ }),
/* 1789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(255);

var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(256));

var _regenerator = _interopRequireDefault(__webpack_require__(103));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(101));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(369));

var _createClass2 = _interopRequireDefault(__webpack_require__(527));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(102));

var _axios = _interopRequireDefault(__webpack_require__(1842));

var mimeTypes = _interopRequireWildcard(__webpack_require__(3113));

var _qs = _interopRequireDefault(__webpack_require__(14));

var _errors = __webpack_require__(884);

var _types = __webpack_require__(887);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* Opts a CloudFront request into the receipt contract with the upload edge. */
var syncReceiptParams = (0, _defineProperty2.default)({}, _types.SYNC_RECEIPT_QUERY_PARAM, _types.SYNC_RECEIPT_VERSION);
/* What the metadata API answers when asked to delete a record that does not exist. */

var ALREADY_REMOVED_CODES = [_errors.SECURE_DOCUMENTS_ERROR_CODE.NoSuchDocumentException, _errors.SECURE_DOCUMENTS_ERROR_CODE.NoSuchFolderException];

var isSyncReceipt = function isSyncReceipt(resp) {
  return (resp === null || resp === void 0 ? void 0 : resp.sdsReceipt) === _types.SYNC_RECEIPT_VERSION;
};

var SecureDocuments = /*#__PURE__*/function () {
  function SecureDocuments(config) {
    var _this = this;

    (0, _classCallCheck2.default)(this, SecureDocuments);
    (0, _defineProperty2.default)(this, "_axios", void 0);
    (0, _defineProperty2.default)(this, "_config", void 0);
    (0, _defineProperty2.default)(this, "_requestInterceptors", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(req) {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = _objectSpread;
                _context.t1 = _objectSpread({}, req);
                _context.t2 = {};

                _context.t3 = function paramsSerializer(params) {
                  return _qs.default.stringify(params, {
                    skipNulls: true,
                    arrayFormat: 'repeat'
                  });
                };

                _context.t4 = _objectSpread;
                _context.t5 = _objectSpread({
                  Accept: 'application/json'
                }, req.headers);
                _context.t6 = {};
                _context.t7 = "Bearer ";
                _context.next = 10;
                return _this._bearerToken();

              case 10:
                _context.t8 = _context.sent;
                _context.t9 = _context.t7.concat.call(_context.t7, _context.t8);
                _context.t10 = {
                  Authorization: _context.t9
                };
                _context.t11 = (0, _context.t4)(_context.t5, _context.t6, _context.t10);
                _context.t12 = {
                  paramsSerializer: _context.t3,
                  headers: _context.t11
                };
                return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2, _context.t12));

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)(this, "_responseErrorInterceptors", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(err) {
        var _err$response;

        var error;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                error = new _errors.SecureDocumentsError(err.message || 'An error occurred', _errors.SECURE_DOCUMENTS_ERROR_CODE.InternalServerError);

                if (!(_this._isBlobErrorJSON(err) && ((_err$response = err.response) === null || _err$response === void 0 ? void 0 : _err$response.data))) {
                  _context2.next = 5;
                  break;
                }

                _context2.next = 4;
                return _this._blobToJSON(err.response.data);

              case 4:
                error = _context2.sent;

              case 5:
                if (err.response && (0, _errors.isSecureDocumentsError)(err.response.data)) {
                  error = new _errors.SecureDocumentsError(err.response.data.message, err.response.data.code, err.response.data.statusCode);
                }

                return _context2.abrupt("return", Promise.reject(error));

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)(this, "_completeUploadIfReceipt", function (resp) {
      return isSyncReceipt(resp) ? _this._completeUpload(resp) : resp;
    });
    (0, _defineProperty2.default)(this, "_completeRemovalIfReceipt", function (resp) {
      return isSyncReceipt(resp) ? _this._completeRemoval(resp) : resp;
    });
    this._config = config;
    this._axios = _axios.default.create();

    this._axios.interceptors.request.use(this._requestInterceptors);

    this._axios.interceptors.response.use(this._responseInterceptors, this._responseErrorInterceptors);
  }

  (0, _createClass2.default)(SecureDocuments, [{
    key: "_bearerToken",
    value: function () {
      var _bearerToken2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var bearerToken;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(typeof this._config.bearerToken === 'function')) {
                  _context3.next = 6;
                  break;
                }

                _context3.next = 3;
                return this._config.bearerToken();

              case 3:
                bearerToken = _context3.sent;
                _context3.next = 7;
                break;

              case 6:
                bearerToken = this._config.bearerToken;

              case 7:
                return _context3.abrupt("return", bearerToken);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function _bearerToken() {
        return _bearerToken2.apply(this, arguments);
      }

      return _bearerToken;
    }()
  }, {
    key: "_baseURL",
    value: function _baseURL(type) {
      return type === 'lambda' ? this._config.baseURL : this._config.cfDistributionURL;
    }
    /*
      Axios Request Interceptors for Secure Documents Client.
      Includes param serializer for lambda, 'Authorization' and 'Accept' header.
       ! Note: Remember to include `baseURL` in config for request.
    */

  }, {
    key: "_responseInterceptors",

    /*
      Axios Response Interceptors for Secure Documents Client.
    */
    value: function _responseInterceptors(resp) {
      return resp.data;
    }
    /*
      Axios Response Error Interceptors for Secure Documents Client.
    */

  }, {
    key: "_isBlobErrorJSON",
    value: function _isBlobErrorJSON(err) {
      var _err$response2, _err$response3, _err$response3$data$t;

      return err.request.responseType === 'blob' && ((_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : _err$response2.data) instanceof Blob && ((_err$response3 = err.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$data$t = _err$response3.data.type) === null || _err$response3$data$t === void 0 ? void 0 : _err$response3$data$t.toLowerCase().includes('json'));
    }
  }, {
    key: "_blobToJSON",
    value: function _blobToJSON(blob) {
      return new Promise(function (resolve, reject) {
        var reader = new FileReader();

        reader.onload = function () {
          var json;

          try {
            json = JSON.parse(reader.result);
          } catch (err) {
            return reject(err);
          }

          return resolve(json);
        };

        reader.onerror = function () {
          return reject(reader.error);
        };

        reader.readAsText(blob);
      });
    }
    /*
      Access required: none
       Create a Secure Document Folder.
       Accesses granted:
      - Folder - UpdateAccess
      - Folder - UploadDocument
      - Folder - ViewDocument
      - Folder - ReadDocument
      - Folder - AchiveDocument
      - Folder - DeleteDocument
    */

  }, {
    key: "createFolder",
    value: function createFolder(input) {
      return this._axios.post('/securedocumentfolders', undefined, {
        baseURL: this._baseURL('lambda'),
        params: input
      });
    }
    /*
      Access required: none
       Delete Secure Document Folder. All access bounded to this folder will be removed
      before deleting the folder.
    */

  }, {
    key: "deleteFolder",
    value: function deleteFolder(input) {
      return this._axios.delete('/securedocumentfolders', {
        baseURL: this._baseURL('lambda'),
        params: input
      });
    }
    /*
      Access required:
        - Folder - UpdateAccess
        - * Access to be granted.
       Create Secure Document Folder access. Silently ignore error if grantee already has the access.
       Accesses allowed:
        - Folder - UpdateAccess
        - Folder - UploadDocument
        - Folder - ViewDocument
        - Folder - ReadDocument
        - Folder - AchiveDocument
        - Folder - DeleteDocument
    */

  }, {
    key: "createFolderAccess",
    value: function createFolderAccess(input) {
      var operations = input.operations,
          userIDs = input.userIDs,
          userGroups = input.userGroups,
          rest = (0, _objectWithoutProperties2.default)(input, ["operations", "userIDs", "userGroups"]);
      return this._axios.post('/securedocumentfolders/accesses', undefined, {
        baseURL: this._baseURL('lambda'),
        params: _objectSpread(_objectSpread({}, rest), {}, {
          operation: operations,
          userID: userIDs,
          userGroup: userGroups
        })
      });
    }
    /*
      Access required: none
       Validate Secure Document Folder access.
    */

  }, {
    key: "validateFolderAccess",
    value: function validateFolderAccess(input) {
      var operations = input.operations,
          rest = (0, _objectWithoutProperties2.default)(input, ["operations"]);
      return this._axios.get('/securedocumentfolders/accesses', {
        baseURL: this._baseURL('lambda'),
        params: _objectSpread(_objectSpread({}, rest), {}, {
          operation: operations
        })
      });
    }
    /*
      Access required:
        - Folder - UpdateAccess
        - * Access to be granted.
       Update Secure Document Folder access by replacing all access entries specified for the operation(s). Will not remove the callie's access however.
       Accesses allowed:
        - Folder - UpdateAccess
        - Folder - UploadDocument
        - Folder - ViewDocument
        - Folder - ReadDocument
        - Folder - AchiveDocument
        - Folder - DeleteDocument
    */

  }, {
    key: "updateFolderAccess",
    value: function updateFolderAccess(input) {
      var operations = input.operations,
          userIDs = input.userIDs,
          userGroups = input.userGroups,
          rest = (0, _objectWithoutProperties2.default)(input, ["operations", "userIDs", "userGroups"]);
      return this._axios.put('/securedocumentfolders/accesses', undefined, {
        baseURL: this._baseURL('lambda'),
        params: _objectSpread(_objectSpread({}, rest), {}, {
          operation: operations,
          userID: userIDs,
          userGroup: userGroups
        })
      });
    }
    /*
      Access required:
        - Folder - UpdateAccess
        - * Access to be removed.
       Delete Secure Document Folder access. Silently ignore error if removee doesn't have the access.
       Accesses allowed:
        - Folder - UpdateAccess
        - Folder - UploadDocument
        - Folder - ViewDocument
        - Folder - ReadDocument
        - Folder - AchiveDocument
        - Folder - DeleteDocument
    */

  }, {
    key: "deleteFolderAccess",
    value: function deleteFolderAccess(input) {
      var operations = input.operations,
          userIDs = input.userIDs,
          userGroups = input.userGroups,
          rest = (0, _objectWithoutProperties2.default)(input, ["operations", "userIDs", "userGroups"]);
      return this._axios.delete('/securedocumentfolders/accesses', {
        baseURL: this._baseURL('lambda'),
        params: _objectSpread(_objectSpread({}, rest), {}, {
          operation: operations,
          userID: userIDs,
          userGroup: userGroups
        })
      });
    }
    /*
      Access required:
        - Folder - UploadDocument
       Create a Secure Document.
       ! Document will not be uploaded to S3.
       Accesses granted:
        - Document - UpdateAccess
        - Document - ViewDocument
        - Document - ReadDocument
        - Document - AchiveDocument
        - Document - DeleteDocument
    */

  }, {
    key: "createDocument",
    value: function createDocument(input) {
      var id = input.id,
          fileSize = input.fileSize,
          rest = (0, _objectWithoutProperties2.default)(input, ["id", "fileSize"]);
      return this._axios.post('/securedocuments', undefined, {
        baseURL: this._baseURL('lambda'),
        params: rest,
        headers: {
          'x-subject-id': id,
          'x-content-length': "".concat(fileSize)
        }
      });
    }
    /*
      Access required:
        - Folder - UploadDocument
       Upload a Secure Document into a folder.
       Accesses granted:
        - Document - UpdateAccess
        - Document - ViewDocument
        - Document - ReadDocument
        - Document - AchiveDocument
        - Document - DeleteDocument
    */

  }, {
    key: "uploadDocument",
    value: function uploadDocument(input) {
      // Encode each path segment so reserved characters in file names
      // (#, ?, %) reach CloudFront as part of the path instead of being
      // read as a fragment or query string. Segments the browser already
      // encodes (spaces) are unaffected.
      var url = input.path.split('/').map(encodeURIComponent).join('/');

      var upload = this._axios.put(url, input.content, {
        baseURL: this._baseURL('cloudfront'),
        params: _objectSpread({
          documentType: input.documentType
        }, syncReceiptParams),
        headers: {
          // The Blob's own type outranks the filename lookup — the lookup
          // returns false for extensions its MIME database lacks (e.g. .jfif),
          // which used to send a literal 'Content-Type: false' header.
          // Blob is checked defensively: it is not a global in older Node
          // runtimes, and content may be an ArrayBuffer.
          'Content-Type': input.contentType || (typeof Blob !== 'undefined' && input.content instanceof Blob ? input.content.type : '') || mimeTypes.lookup(input.path) || 'application/octet-stream'
        }
      });

      return upload.then(this._completeUploadIfReceipt);
    }
    /*
      Access required: none
       List Secure Documents based on provided folder path.
       Documents will be shown based on accesses on both User ID (ACL) / User Group (RBAC):
        - Folder - ViewDocument
        - Folder - ReadDocument
        - Document - ViewDocument
        - Document - ReadDocument
    */

  }, {
    key: "listDocuments",
    value: function listDocuments(input) {
      return this._axios.get('/securedocuments', {
        baseURL: this._baseURL('lambda'),
        params: input
      });
    }
    /*
      Access required:
        - * Folder - ReadDocument
        - * Document - ReadDocument
       Read Secure Document binary through CloudFront distribution. Usually used to retrieve the binary
      of the document and upload it somewhere else, or download it by creating an `a` element and setting the
      attributes accordingly.
    */

  }, {
    key: "readDocument",
    value: function readDocument(input) {
      var _this2 = this;

      return Promise.resolve(new Promise(function (res, rej) {
        _this2._axios.get(input.path, {
          baseURL: _this2._baseURL('cloudfront'),
          responseType: 'arraybuffer'
        }).then(function (resp) {
          return res({
            content: resp
          });
        }).catch(rej);
      }));
    }
    /*
      Access required:
        - * Folder - DeleteDocument
        - * Document - DeleteDocument
       Delete Secure Document from a folder. All access bounded to this document will be removed
      before deleting the document.
       ! Document will not be deleted from S3.
    */

  }, {
    key: "deleteDocument",
    value: function deleteDocument(input) {
      return this._axios.delete('/securedocuments', {
        baseURL: this._baseURL('lambda'),
        params: input
      });
    }
    /*
      Access required:
        - * Folder - DeleteDocument
        - * Document - DeleteDocument
       Delete Secure Document from a folder. All access bounded to this document will be removed
      before deleting the document.
    */

  }, {
    key: "removeDocument",
    value: function removeDocument(input) {
      var remove = this._axios.delete(input.path, {
        baseURL: this._baseURL('cloudfront'),
        params: syncReceiptParams
      });

      return remove.then(this._completeRemovalIfReceipt);
    }
    /*
      Record an S3 operation the upload edge has receipted: registers an uploaded document, or
      deletes a removed document's record, with the caller's own token. `uploadDocument` and
      `removeDocument` call this themselves; call it directly only to retry after a
      `SecureDocumentsIncompleteError`, which does not send the file again.
       Safe to call again after an attempt whose response was lost:
        - upload: the metadata API treats a repeat of the same create (same document ID, same
          caller) as success and returns the recorded document.
        - removal: a record that is already gone means the removal is done, so this resolves
          with `undefined` instead of the deleted record.
      Any other failure, including an upload that conflicts with a different document at the
      same path, still rejects with `SecureDocumentsIncompleteError`.
    */

  }, {
    key: "completeSync",
    value: function completeSync(receipt) {
      return receipt.operation === 'upload' ? this._completeUpload(receipt) : this._completeRemoval(receipt);
    }
  }, {
    key: "_completeUpload",
    value: function _completeUpload(receipt) {
      var path = receipt.path,
          _receipt$id = receipt.id,
          id = _receipt$id === void 0 ? '' : _receipt$id,
          _receipt$documentType = receipt.documentType,
          documentType = _receipt$documentType === void 0 ? '' : _receipt$documentType,
          _receipt$fileSize = receipt.fileSize,
          fileSize = _receipt$fileSize === void 0 ? 0 : _receipt$fileSize;
      return this.createDocument({
        path: path,
        id: id,
        documentType: documentType,
        fileSize: fileSize
      }).catch(function (err) {
        throw new _errors.SecureDocumentsIncompleteError(err, receipt);
      });
    }
  }, {
    key: "_completeRemoval",
    value: function _completeRemoval(receipt) {
      return this.deleteDocument({
        path: receipt.path
      }).catch(function (err) {
        // The edge only sends a removal receipt after the S3 object is gone, so a record that is
        // already absent is the outcome being asked for (typically an earlier attempt deleted it
        // and its response was lost). Only the API's own "no such document/folder" answer counts.
        if (ALREADY_REMOVED_CODES.includes(err.code)) {
          return undefined;
        }

        throw new _errors.SecureDocumentsIncompleteError(err, receipt);
      });
    }
    /*
      Access required:
        - Document - UpdateAccess
        - * Access to be granted.
       Create Secure Document access. Silently ignore error if grantee already has the access.
       Accesses allowed:
        - Document - UpdateAccess
        - Document - ViewDocument
        - Document - ReadDocument
        - Document - AchiveDocument
        - Document - DeleteDocument
    */

  }, {
    key: "createDocumentAccess",
    value: function createDocumentAccess(input) {
      var operations = input.operations,
          userIDs = input.userIDs,
          userGroups = input.userGroups,
          rest = (0, _objectWithoutProperties2.default)(input, ["operations", "userIDs", "userGroups"]);
      return this._axios.post('/securedocuments/accesses', undefined, {
        baseURL: this._baseURL('lambda'),
        params: _objectSpread(_objectSpread({}, rest), {}, {
          operation: operations,
          userID: userIDs,
          userGroup: userGroups
        })
      });
    }
    /*
      Access required: none
       Validate Secure Document access.
    */

  }, {
    key: "validateDocumentAccess",
    value: function validateDocumentAccess(input) {
      var operations = input.operations,
          rest = (0, _objectWithoutProperties2.default)(input, ["operations"]);
      return this._axios.get('/securedocuments/accesses', {
        baseURL: this._baseURL('lambda'),
        params: _objectSpread(_objectSpread({}, rest), {}, {
          operation: operations
        })
      });
    }
    /*
      Access required:
        - Document - UpdateAccess
        - * Access to be granted.
       Update Secure Document access by replacing all access entries specified for the operation(s). Will not remove the callie's access however.
       Accesses allowed:
        - Document - UpdateAccess
        - Document - ViewDocument
        - Document - ReadDocument
        - Document - AchiveDocument
        - Document - DeleteDocument
    */

  }, {
    key: "updateDocumentAccess",
    value: function updateDocumentAccess(input) {
      var operations = input.operations,
          userIDs = input.userIDs,
          userGroups = input.userGroups,
          rest = (0, _objectWithoutProperties2.default)(input, ["operations", "userIDs", "userGroups"]);
      return this._axios.put('/securedocuments/accesses', undefined, {
        baseURL: this._baseURL('lambda'),
        params: _objectSpread(_objectSpread({}, rest), {}, {
          operation: operations,
          userID: userIDs,
          userGroup: userGroups
        })
      });
    }
    /*
      Access required:
        - Document - UpdateAccess
        - * Access to be removed.
       Delete Secure Document access. Silently ignore error if removee doesn't have the access.
       Accesses allowed:
        - Document - UpdateAccess
        - Document - ViewDocument
        - Document - ReadDocument
        - Document - AchiveDocument
        - Document - DeleteDocument
    */

  }, {
    key: "deleteDocumentAccess",
    value: function deleteDocumentAccess(input) {
      var operations = input.operations,
          userIDs = input.userIDs,
          userGroups = input.userGroups,
          rest = (0, _objectWithoutProperties2.default)(input, ["operations", "userIDs", "userGroups"]);
      return this._axios.delete('/securedocuments/accesses', {
        baseURL: this._baseURL('lambda'),
        params: _objectSpread(_objectSpread({}, rest), {}, {
          operation: operations,
          userID: userIDs,
          userGroup: userGroups
        })
      });
    }
  }]);
  return SecureDocuments;
}();

exports.default = SecureDocuments;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 1791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  SecureDocumentsClient: true
};
Object.defineProperty(exports, "SecureDocumentsClient", {
  enumerable: true,
  get: function get() {
    return _SecureDocumentsClient.default;
  }
});

var _apis = __webpack_require__(1790);

Object.keys(_apis).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _apis[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _apis[key];
    }
  });
});

var _errors = __webpack_require__(884);

Object.keys(_errors).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _errors[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _errors[key];
    }
  });
});

var _SecureDocumentsClient = _interopRequireDefault(__webpack_require__(1789));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9jb3JlL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFDQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBOztBQUNBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0ICogZnJvbSAnLi9hcGlzJztcbmV4cG9ydCAqIGZyb20gJy4vZXJyb3JzJztcbmV4cG9ydCB7IGRlZmF1bHQgYXMgU2VjdXJlRG9jdW1lbnRzQ2xpZW50IH0gZnJvbSAnLi9TZWN1cmVEb2N1bWVudHNDbGllbnQnO1xuIl19

/***/ }),
/* 1792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(255);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var Context = /*#__PURE__*/(0, _react.createContext)({
  client: undefined
});

var SecureDocumentsProvider = function SecureDocumentsProvider(_ref) {
  var client = _ref.client,
      children = _ref.children;
  var context = {
    client: client
  };
  return /*#__PURE__*/_react.default.createElement(Context.Provider, {
    value: context
  }, children);
};

SecureDocumentsProvider.Consumer = Context.Consumer;
SecureDocumentsProvider.Context = Context;
SecureDocumentsProvider.Provider = Context.Provider;
var _default = SecureDocumentsProvider;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9jb250ZXh0L1NlY3VyZURvY3VtZW50c1Byb3ZpZGVyL1NlY3VyZURvY3VtZW50c1Byb3ZpZGVyLnRzeCJdLCJuYW1lcyI6WyJDb250ZXh0IiwiY2xpZW50IiwidW5kZWZpbmVkIiwiU2VjdXJlRG9jdW1lbnRzUHJvdmlkZXIiLCJjaGlsZHJlbiIsImNvbnRleHQiLCJDb25zdW1lciIsIlByb3ZpZGVyIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQTs7QUFPQSxJQUFNQSxPQUFPLGdCQUFHLDBCQUFzQztBQUNwREMsRUFBQUEsTUFBTSxFQUFFQztBQUQ0QyxDQUF0QyxDQUFoQjs7QUFJQSxJQUFNQyx1QkFBaUQsR0FBRyxTQUFwREEsdUJBQW9ELE9BQTBCO0FBQUEsTUFBdkJGLE1BQXVCLFFBQXZCQSxNQUF1QjtBQUFBLE1BQWZHLFFBQWUsUUFBZkEsUUFBZTtBQUNsRixNQUFNQyxPQUFPLEdBQUc7QUFBRUosSUFBQUEsTUFBTSxFQUFOQTtBQUFGLEdBQWhCO0FBQ0Esc0JBQU8sNkJBQUMsT0FBRCxDQUFTLFFBQVQ7QUFBa0IsSUFBQSxLQUFLLEVBQUVJO0FBQXpCLEtBQW1DRCxRQUFuQyxDQUFQO0FBQ0QsQ0FIRDs7QUFLQUQsdUJBQXVCLENBQUNHLFFBQXhCLEdBQW1DTixPQUFPLENBQUNNLFFBQTNDO0FBQ0FILHVCQUF1QixDQUFDSCxPQUF4QixHQUFrQ0EsT0FBbEM7QUFDQUcsdUJBQXVCLENBQUNJLFFBQXhCLEdBQW1DUCxPQUFPLENBQUNPLFFBQTNDO2VBRWVKLHVCIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IGNyZWF0ZUNvbnRleHQgfSBmcm9tICdyZWFjdCc7XG5cbmltcG9ydCB7XG4gIFNlY3VyZURvY3VtZW50c0NvbnRleHQsXG4gIFNlY3VyZURvY3VtZW50c1Byb3ZpZGVyIGFzIF9TZWN1cmVEb2N1bWVudHNQcm92aWRlcixcbn0gZnJvbSAnLi9TZWN1cmVEb2N1bWVudHNQcm92aWRlci50eXBlcyc7XG5cbmNvbnN0IENvbnRleHQgPSBjcmVhdGVDb250ZXh0PFNlY3VyZURvY3VtZW50c0NvbnRleHQ+KHtcbiAgY2xpZW50OiB1bmRlZmluZWQsXG59KTtcblxuY29uc3QgU2VjdXJlRG9jdW1lbnRzUHJvdmlkZXI6IF9TZWN1cmVEb2N1bWVudHNQcm92aWRlciA9ICh7IGNsaWVudCwgY2hpbGRyZW4gfSkgPT4ge1xuICBjb25zdCBjb250ZXh0ID0geyBjbGllbnQgfTtcbiAgcmV0dXJuIDxDb250ZXh0LlByb3ZpZGVyIHZhbHVlPXtjb250ZXh0fT57Y2hpbGRyZW59PC9Db250ZXh0LlByb3ZpZGVyPjtcbn07XG5cblNlY3VyZURvY3VtZW50c1Byb3ZpZGVyLkNvbnN1bWVyID0gQ29udGV4dC5Db25zdW1lcjtcblNlY3VyZURvY3VtZW50c1Byb3ZpZGVyLkNvbnRleHQgPSBDb250ZXh0O1xuU2VjdXJlRG9jdW1lbnRzUHJvdmlkZXIuUHJvdmlkZXIgPSBDb250ZXh0LlByb3ZpZGVyO1xuXG5leHBvcnQgZGVmYXVsdCBTZWN1cmVEb2N1bWVudHNQcm92aWRlcjtcbiJdfQ==

/***/ }),
/* 1793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 1794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _SecureDocumentsProvider.default;
  }
});

var _SecureDocumentsProvider = _interopRequireDefault(__webpack_require__(1792));

var _SecureDocumentsProvider2 = __webpack_require__(1793);

Object.keys(_SecureDocumentsProvider2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SecureDocumentsProvider2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SecureDocumentsProvider2[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9jb250ZXh0L1NlY3VyZURvY3VtZW50c1Byb3ZpZGVyL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBkZWZhdWx0IH0gZnJvbSAnLi9TZWN1cmVEb2N1bWVudHNQcm92aWRlcic7XG5leHBvcnQgKiBmcm9tICcuL1NlY3VyZURvY3VtZW50c1Byb3ZpZGVyLnR5cGVzJztcbiJdfQ==

/***/ }),
/* 1795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(255);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  useCreateFolder: true,
  useDeleteFolder: true,
  useUploadDocument: true,
  useListDocuments: true,
  useReadDocument: true,
  useDeleteDocument: true,
  useRemoveDocument: true,
  useCreateDocumentAccess: true,
  useUpdateDocumentAccess: true,
  useDeleteDocumentAccess: true,
  useSecureDocumentsContext: true,
  useDownloadDocument: true,
  useSecureDocumentsWidget: true
};
Object.defineProperty(exports, "useCreateFolder", {
  enumerable: true,
  get: function get() {
    return _useCreateFolder.default;
  }
});
Object.defineProperty(exports, "useDeleteFolder", {
  enumerable: true,
  get: function get() {
    return _useDeleteFolder.default;
  }
});
Object.defineProperty(exports, "useUploadDocument", {
  enumerable: true,
  get: function get() {
    return _useUploadDocument.default;
  }
});
Object.defineProperty(exports, "useListDocuments", {
  enumerable: true,
  get: function get() {
    return _useListDocuments.default;
  }
});
Object.defineProperty(exports, "useReadDocument", {
  enumerable: true,
  get: function get() {
    return _useReadDocument.default;
  }
});
Object.defineProperty(exports, "useDeleteDocument", {
  enumerable: true,
  get: function get() {
    return _useDeleteDocument.default;
  }
});
Object.defineProperty(exports, "useRemoveDocument", {
  enumerable: true,
  get: function get() {
    return _useRemoveDocument.default;
  }
});
Object.defineProperty(exports, "useCreateDocumentAccess", {
  enumerable: true,
  get: function get() {
    return _useCreateDocumentAccess.default;
  }
});
Object.defineProperty(exports, "useUpdateDocumentAccess", {
  enumerable: true,
  get: function get() {
    return _useUpdateDocumentAccess.default;
  }
});
Object.defineProperty(exports, "useDeleteDocumentAccess", {
  enumerable: true,
  get: function get() {
    return _useDeleteDocumentAccess.default;
  }
});
Object.defineProperty(exports, "useSecureDocumentsContext", {
  enumerable: true,
  get: function get() {
    return _useSecureDocumentsContext.default;
  }
});
Object.defineProperty(exports, "useDownloadDocument", {
  enumerable: true,
  get: function get() {
    return _useDownloadDocument.default;
  }
});
Object.defineProperty(exports, "useSecureDocumentsWidget", {
  enumerable: true,
  get: function get() {
    return _useSecureDocumentsWidget.default;
  }
});

var _useCreateFolder = _interopRequireWildcard(__webpack_require__(1799));

Object.keys(_useCreateFolder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useCreateFolder[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useCreateFolder[key];
    }
  });
});

var _useDeleteFolder = _interopRequireWildcard(__webpack_require__(1808));

Object.keys(_useDeleteFolder).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useDeleteFolder[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useDeleteFolder[key];
    }
  });
});

var _useUploadDocument = _interopRequireWildcard(__webpack_require__(1830));

Object.keys(_useUploadDocument).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useUploadDocument[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useUploadDocument[key];
    }
  });
});

var _useListDocuments = _interopRequireWildcard(__webpack_require__(1814));

Object.keys(_useListDocuments).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useListDocuments[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useListDocuments[key];
    }
  });
});

var _useReadDocument = _interopRequireWildcard(__webpack_require__(886));

Object.keys(_useReadDocument).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useReadDocument[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useReadDocument[key];
    }
  });
});

var _useDeleteDocument = _interopRequireWildcard(__webpack_require__(1802));

Object.keys(_useDeleteDocument).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useDeleteDocument[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useDeleteDocument[key];
    }
  });
});

var _useRemoveDocument = _interopRequireWildcard(__webpack_require__(1819));

Object.keys(_useRemoveDocument).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useRemoveDocument[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useRemoveDocument[key];
    }
  });
});

var _useCreateDocumentAccess = _interopRequireWildcard(__webpack_require__(1796));

Object.keys(_useCreateDocumentAccess).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useCreateDocumentAccess[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useCreateDocumentAccess[key];
    }
  });
});

var _useUpdateDocumentAccess = _interopRequireWildcard(__webpack_require__(1827));

Object.keys(_useUpdateDocumentAccess).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useUpdateDocumentAccess[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useUpdateDocumentAccess[key];
    }
  });
});

var _useDeleteDocumentAccess = _interopRequireWildcard(__webpack_require__(1805));

Object.keys(_useDeleteDocumentAccess).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useDeleteDocumentAccess[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useDeleteDocumentAccess[key];
    }
  });
});

var _useSecureDocumentsContext = _interopRequireWildcard(__webpack_require__(1822));

Object.keys(_useSecureDocumentsContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useSecureDocumentsContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useSecureDocumentsContext[key];
    }
  });
});

var _useDownloadDocument = _interopRequireWildcard(__webpack_require__(1811));

Object.keys(_useDownloadDocument).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useDownloadDocument[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useDownloadDocument[key];
    }
  });
});

var _useSecureDocumentsWidget = _interopRequireWildcard(__webpack_require__(1824));

Object.keys(_useSecureDocumentsWidget).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useSecureDocumentsWidget[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useSecureDocumentsWidget[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useCreateDocumentAccess.default;
  }
});

var _useCreateDocumentAccess = _interopRequireDefault(__webpack_require__(1797));

var _useCreateDocumentAccess2 = __webpack_require__(1798);

Object.keys(_useCreateDocumentAccess2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useCreateDocumentAccess2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useCreateDocumentAccess2[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VDcmVhdGVEb2N1bWVudEFjY2Vzcy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgZGVmYXVsdCB9IGZyb20gJy4vdXNlQ3JlYXRlRG9jdW1lbnRBY2Nlc3MnO1xuZXhwb3J0ICogZnJvbSAnLi91c2VDcmVhdGVEb2N1bWVudEFjY2Vzcy50eXBlcyc7XG4iXX0=

/***/ }),
/* 1797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useCreateDocumentAccess;

var _regenerator = _interopRequireDefault(__webpack_require__(103));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(102));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(101));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(96));

var _react = __webpack_require__(0);

var _context2 = __webpack_require__(112);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*
  Create access for Secure Document React hook.
  Client will be passed through context by `SecureDocumentsProvider`.
  Optionally, client can be passed through options.
*/
function useCreateDocumentAccess() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = (0, _react.useContext)(_context2.SecureDocumentsProvider.Context) || options.client,
      client = _ref.client;

  if (!client) {
    throw new Error('client not found for hook `useCreateDocumentAccess`');
  }

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var createDocumentAccess = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(path, input) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Promise.resolve(new Promise(function (res, rej) {
                setLoading(true);
                client.createDocumentAccess(_objectSpread(_objectSpread({}, input), {}, {
                  path: path
                })).then(function (resp) {
                  var _options$onCompleted;

                  (_options$onCompleted = options.onCompleted) === null || _options$onCompleted === void 0 ? void 0 : _options$onCompleted.call(options, resp);
                  res(resp);
                }).catch(function (err) {
                  var _options$onError;

                  setError(err);
                  (_options$onError = options.onError) === null || _options$onError === void 0 ? void 0 : _options$onError.call(options, err);
                  rej(err);
                }).finally(function () {
                  return setLoading(false);
                });
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function createDocumentAccess(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return [createDocumentAccess, {
    client: client,
    error: error,
    loading: loading
  }];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VDcmVhdGVEb2N1bWVudEFjY2Vzcy91c2VDcmVhdGVEb2N1bWVudEFjY2Vzcy50cyJdLCJuYW1lcyI6WyJ1c2VDcmVhdGVEb2N1bWVudEFjY2VzcyIsIm9wdGlvbnMiLCJTZWN1cmVEb2N1bWVudHNQcm92aWRlciIsIkNvbnRleHQiLCJjbGllbnQiLCJFcnJvciIsImxvYWRpbmciLCJzZXRMb2FkaW5nIiwiZXJyb3IiLCJzZXRFcnJvciIsImNyZWF0ZURvY3VtZW50QWNjZXNzIiwicGF0aCIsImlucHV0IiwiUHJvbWlzZSIsInJlc29sdmUiLCJyZXMiLCJyZWoiLCJ0aGVuIiwicmVzcCIsIm9uQ29tcGxldGVkIiwiY2F0Y2giLCJlcnIiLCJvbkVycm9yIiwiZmluYWxseSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFHQTs7Ozs7O0FBSUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNlLFNBQVNBLHVCQUFULEdBRWlCO0FBQUEsTUFEOUJDLE9BQzhCLHVFQURZLEVBQ1o7O0FBQUEsYUFDWCx1QkFBV0Msa0NBQXdCQyxPQUFuQyxLQUErQ0YsT0FBTyxDQUFDRyxNQUQ1QztBQUFBLE1BQ3RCQSxNQURzQixRQUN0QkEsTUFEc0I7O0FBRTlCLE1BQUksQ0FBQ0EsTUFBTCxFQUFhO0FBQ1gsVUFBTSxJQUFJQyxLQUFKLENBQVUscURBQVYsQ0FBTjtBQUNEOztBQUo2QixrQkFNQSxxQkFBUyxLQUFULENBTkE7QUFBQTtBQUFBLE1BTXZCQyxPQU51QjtBQUFBLE1BTWRDLFVBTmM7O0FBQUEsbUJBT0osc0JBUEk7QUFBQTtBQUFBLE1BT3ZCQyxLQVB1QjtBQUFBLE1BT2hCQyxRQVBnQjs7QUFTOUIsTUFBTUMsb0JBQW9CO0FBQUEsd0ZBQUcsaUJBQzNCQyxJQUQyQixFQUUzQkMsS0FGMkI7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLCtDQUkzQkMsT0FBTyxDQUFDQyxPQUFSLENBQ0UsSUFBSUQsT0FBSixDQUFZLFVBQUNFLEdBQUQsRUFBTUMsR0FBTixFQUFjO0FBQ3hCVCxnQkFBQUEsVUFBVSxDQUFDLElBQUQsQ0FBVjtBQUNBSCxnQkFBQUEsTUFBTSxDQUNITSxvQkFESCxpQ0FDNkJFLEtBRDdCO0FBQ29DRCxrQkFBQUEsSUFBSSxFQUFKQTtBQURwQyxvQkFFR00sSUFGSCxDQUVRLFVBQUNDLElBQUQsRUFBc0M7QUFBQTs7QUFDMUMsMENBQUFqQixPQUFPLENBQUNrQixXQUFSLG1GQUFBbEIsT0FBTyxFQUFlaUIsSUFBZixDQUFQO0FBQ0FILGtCQUFBQSxHQUFHLENBQUNHLElBQUQsQ0FBSDtBQUNELGlCQUxILEVBTUdFLEtBTkgsQ0FNUyxVQUFDQyxHQUFELEVBQWdCO0FBQUE7O0FBQ3JCWixrQkFBQUEsUUFBUSxDQUFDWSxHQUFELENBQVI7QUFDQSxzQ0FBQXBCLE9BQU8sQ0FBQ3FCLE9BQVIsMkVBQUFyQixPQUFPLEVBQVdvQixHQUFYLENBQVA7QUFDQUwsa0JBQUFBLEdBQUcsQ0FBQ0ssR0FBRCxDQUFIO0FBQ0QsaUJBVkgsRUFXR0UsT0FYSCxDQVdXO0FBQUEseUJBQU1oQixVQUFVLENBQUMsS0FBRCxDQUFoQjtBQUFBLGlCQVhYO0FBWUQsZUFkRCxDQURGLENBSjJCOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLEtBQUg7O0FBQUEsb0JBQXBCRyxvQkFBb0I7QUFBQTtBQUFBO0FBQUEsS0FBMUI7O0FBc0JBLFNBQU8sQ0FBQ0Esb0JBQUQsRUFBdUI7QUFBRU4sSUFBQUEsTUFBTSxFQUFOQSxNQUFGO0FBQVVJLElBQUFBLEtBQUssRUFBTEEsS0FBVjtBQUFpQkYsSUFBQUEsT0FBTyxFQUFQQTtBQUFqQixHQUF2QixDQUFQO0FBQ0QiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VDb250ZXh0LCB1c2VTdGF0ZSB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IENyZWF0ZURvY3VtZW50QWNjZXNzSW5wdXQsIENyZWF0ZURvY3VtZW50QWNjZXNzT3V0cHV0IH0gZnJvbSAnLi4vLi4vLi4vY29yZSc7XG5cbmltcG9ydCB7IFNlY3VyZURvY3VtZW50c1Byb3ZpZGVyIH0gZnJvbSAnLi4vLi4vY29udGV4dCc7XG5cbmltcG9ydCB7IFVzZUNyZWF0ZURvY3VtZW50QWNjZXNzT3B0aW9ucywgVXNlQ3JlYXRlRG9jdW1lbnRBY2Nlc3NQcm9wcyB9IGZyb20gJy4vdXNlQ3JlYXRlRG9jdW1lbnRBY2Nlc3MudHlwZXMnO1xuXG4vKlxuICBDcmVhdGUgYWNjZXNzIGZvciBTZWN1cmUgRG9jdW1lbnQgUmVhY3QgaG9vay5cbiAgQ2xpZW50IHdpbGwgYmUgcGFzc2VkIHRocm91Z2ggY29udGV4dCBieSBgU2VjdXJlRG9jdW1lbnRzUHJvdmlkZXJgLlxuICBPcHRpb25hbGx5LCBjbGllbnQgY2FuIGJlIHBhc3NlZCB0aHJvdWdoIG9wdGlvbnMuXG4qL1xuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlQ3JlYXRlRG9jdW1lbnRBY2Nlc3MoXG4gIG9wdGlvbnM6IFVzZUNyZWF0ZURvY3VtZW50QWNjZXNzT3B0aW9ucyA9IHt9LFxuKTogVXNlQ3JlYXRlRG9jdW1lbnRBY2Nlc3NQcm9wcyB7XG4gIGNvbnN0IHsgY2xpZW50IH0gPSB1c2VDb250ZXh0KFNlY3VyZURvY3VtZW50c1Byb3ZpZGVyLkNvbnRleHQpIHx8IG9wdGlvbnMuY2xpZW50O1xuICBpZiAoIWNsaWVudCkge1xuICAgIHRocm93IG5ldyBFcnJvcignY2xpZW50IG5vdCBmb3VuZCBmb3IgaG9vayBgdXNlQ3JlYXRlRG9jdW1lbnRBY2Nlc3NgJyk7XG4gIH1cblxuICBjb25zdCBbbG9hZGluZywgc2V0TG9hZGluZ10gPSB1c2VTdGF0ZShmYWxzZSk7XG4gIGNvbnN0IFtlcnJvciwgc2V0RXJyb3JdID0gdXNlU3RhdGU8RXJyb3I+KCk7XG5cbiAgY29uc3QgY3JlYXRlRG9jdW1lbnRBY2Nlc3MgPSBhc3luYyAoXG4gICAgcGF0aDogc3RyaW5nLFxuICAgIGlucHV0OiBPbWl0PENyZWF0ZURvY3VtZW50QWNjZXNzSW5wdXQsICdwYXRoJz4sXG4gICk6IFByb21pc2U8Q3JlYXRlRG9jdW1lbnRBY2Nlc3NPdXRwdXQ+ID0+XG4gICAgUHJvbWlzZS5yZXNvbHZlKFxuICAgICAgbmV3IFByb21pc2UoKHJlcywgcmVqKSA9PiB7XG4gICAgICAgIHNldExvYWRpbmcodHJ1ZSk7XG4gICAgICAgIGNsaWVudFxuICAgICAgICAgIC5jcmVhdGVEb2N1bWVudEFjY2Vzcyh7IC4uLmlucHV0LCBwYXRoIH0pXG4gICAgICAgICAgLnRoZW4oKHJlc3A6IENyZWF0ZURvY3VtZW50QWNjZXNzT3V0cHV0KSA9PiB7XG4gICAgICAgICAgICBvcHRpb25zLm9uQ29tcGxldGVkPy4ocmVzcCk7XG4gICAgICAgICAgICByZXMocmVzcCk7XG4gICAgICAgICAgfSlcbiAgICAgICAgICAuY2F0Y2goKGVycjogRXJyb3IpID0+IHtcbiAgICAgICAgICAgIHNldEVycm9yKGVycik7XG4gICAgICAgICAgICBvcHRpb25zLm9uRXJyb3I/LihlcnIpO1xuICAgICAgICAgICAgcmVqKGVycik7XG4gICAgICAgICAgfSlcbiAgICAgICAgICAuZmluYWxseSgoKSA9PiBzZXRMb2FkaW5nKGZhbHNlKSk7XG4gICAgICB9KSxcbiAgICApO1xuXG4gIHJldHVybiBbY3JlYXRlRG9jdW1lbnRBY2Nlc3MsIHsgY2xpZW50LCBlcnJvciwgbG9hZGluZyB9XTtcbn1cbiJdfQ==

/***/ }),
/* 1798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 1799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useCreateFolder.default;
  }
});

var _useCreateFolder = _interopRequireDefault(__webpack_require__(1800));

var _useCreateFolder2 = __webpack_require__(1801);

Object.keys(_useCreateFolder2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useCreateFolder2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useCreateFolder2[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VDcmVhdGVGb2xkZXIvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IGRlZmF1bHQgfSBmcm9tICcuL3VzZUNyZWF0ZUZvbGRlcic7XG5leHBvcnQgKiBmcm9tICcuL3VzZUNyZWF0ZUZvbGRlci50eXBlcyc7XG4iXX0=

/***/ }),
/* 1800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useCreateFolder;

var _regenerator = _interopRequireDefault(__webpack_require__(103));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(101));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(96));

var _react = __webpack_require__(0);

var _context2 = __webpack_require__(112);

/*
  Create Secure Document Folder React hook.
  Client will be passed through context by `SecureDocumentsProvider`.
  Optionally, client can be passed through options.
*/
function useCreateFolder() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = (0, _react.useContext)(_context2.SecureDocumentsProvider.Context) || options.client,
      client = _ref.client;

  if (!client) {
    throw new Error('client not found for hook `useCreateFolder`');
  }

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var createFolder = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(path) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Promise.resolve(new Promise(function (res, rej) {
                setLoading(true);
                client.createFolder({
                  path: path
                }).then(function (resp) {
                  var _options$onCompleted;

                  (_options$onCompleted = options.onCompleted) === null || _options$onCompleted === void 0 ? void 0 : _options$onCompleted.call(options, resp);
                  res(resp);
                }).catch(function (err) {
                  var _options$onError;

                  setError(err);
                  (_options$onError = options.onError) === null || _options$onError === void 0 ? void 0 : _options$onError.call(options, err);
                  rej(err);
                }).finally(function () {
                  return setLoading(false);
                });
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function createFolder(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return [createFolder, {
    client: client,
    error: error,
    loading: loading
  }];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 1802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useDeleteDocument.default;
  }
});

var _useDeleteDocument = _interopRequireDefault(__webpack_require__(1803));

var _useDeleteDocument2 = __webpack_require__(1804);

Object.keys(_useDeleteDocument2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useDeleteDocument2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useDeleteDocument2[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VEZWxldGVEb2N1bWVudC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgZGVmYXVsdCB9IGZyb20gJy4vdXNlRGVsZXRlRG9jdW1lbnQnO1xuZXhwb3J0ICogZnJvbSAnLi91c2VEZWxldGVEb2N1bWVudC50eXBlcyc7XG4iXX0=

/***/ }),
/* 1803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDeleteDocument;

var _regenerator = _interopRequireDefault(__webpack_require__(103));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(101));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(96));

var _react = __webpack_require__(0);

var _context2 = __webpack_require__(112);

/*
  Delete Secure Document React hook.
  Client will be passed through context by `SecureDocumentsProvider`.
  Optionally, client can be passed through options.
*/
function useDeleteDocument() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = (0, _react.useContext)(_context2.SecureDocumentsProvider.Context) || options.client,
      client = _ref.client;

  if (!client) {
    throw new Error('client not found for hook `useDeleteDocument`');
  }

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var deleteDocument = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(path) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Promise.resolve(new Promise(function (res, rej) {
                setLoading(true);
                client.deleteDocument({
                  path: path
                }).then(function (resp) {
                  var _options$onCompleted;

                  (_options$onCompleted = options.onCompleted) === null || _options$onCompleted === void 0 ? void 0 : _options$onCompleted.call(options, resp);
                  res(resp);
                }).catch(function (err) {
                  var _options$onError;

                  setError(err);
                  (_options$onError = options.onError) === null || _options$onError === void 0 ? void 0 : _options$onError.call(options, err);
                  rej(err);
                }).finally(function () {
                  return setLoading(false);
                });
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function deleteDocument(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return [deleteDocument, {
    client: client,
    error: error,
    loading: loading
  }];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 1805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useDeleteDocumentAccess.default;
  }
});

var _useDeleteDocumentAccess = _interopRequireDefault(__webpack_require__(1806));

var _useDeleteDocumentAccess2 = __webpack_require__(1807);

Object.keys(_useDeleteDocumentAccess2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useDeleteDocumentAccess2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useDeleteDocumentAccess2[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VEZWxldGVEb2N1bWVudEFjY2Vzcy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgZGVmYXVsdCB9IGZyb20gJy4vdXNlRGVsZXRlRG9jdW1lbnRBY2Nlc3MnO1xuZXhwb3J0ICogZnJvbSAnLi91c2VEZWxldGVEb2N1bWVudEFjY2Vzcy50eXBlcyc7XG4iXX0=

/***/ }),
/* 1806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDeleteDocumentAccess;

var _regenerator = _interopRequireDefault(__webpack_require__(103));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(102));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(101));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(96));

var _react = __webpack_require__(0);

var _context2 = __webpack_require__(112);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*
  Delete access for Secure Document React hook.
  Client will be passed through context by `SecureDocumentsProvider`.
  Optionally, client can be passed through options.
*/
function useDeleteDocumentAccess() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = (0, _react.useContext)(_context2.SecureDocumentsProvider.Context) || options.client,
      client = _ref.client;

  if (!client) {
    throw new Error('client not found for hook `useDeleteDocumentAccess`');
  }

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var deleteDocumentAccess = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(path, input) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Promise.resolve(new Promise(function (res, rej) {
                setLoading(true);
                client.deleteDocumentAccess(_objectSpread(_objectSpread({}, input), {}, {
                  path: path
                })).then(function (resp) {
                  var _options$onCompleted;

                  (_options$onCompleted = options.onCompleted) === null || _options$onCompleted === void 0 ? void 0 : _options$onCompleted.call(options, resp);
                  res(resp);
                }).catch(function (err) {
                  var _options$onError;

                  setError(err);
                  (_options$onError = options.onError) === null || _options$onError === void 0 ? void 0 : _options$onError.call(options, err);
                  rej(err);
                }).finally(function () {
                  return setLoading(false);
                });
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function deleteDocumentAccess(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return [deleteDocumentAccess, {
    client: client,
    error: error,
    loading: loading
  }];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VEZWxldGVEb2N1bWVudEFjY2Vzcy91c2VEZWxldGVEb2N1bWVudEFjY2Vzcy50cyJdLCJuYW1lcyI6WyJ1c2VEZWxldGVEb2N1bWVudEFjY2VzcyIsIm9wdGlvbnMiLCJTZWN1cmVEb2N1bWVudHNQcm92aWRlciIsIkNvbnRleHQiLCJjbGllbnQiLCJFcnJvciIsImxvYWRpbmciLCJzZXRMb2FkaW5nIiwiZXJyb3IiLCJzZXRFcnJvciIsImRlbGV0ZURvY3VtZW50QWNjZXNzIiwicGF0aCIsImlucHV0IiwiUHJvbWlzZSIsInJlc29sdmUiLCJyZXMiLCJyZWoiLCJ0aGVuIiwicmVzcCIsIm9uQ29tcGxldGVkIiwiY2F0Y2giLCJlcnIiLCJvbkVycm9yIiwiZmluYWxseSJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFHQTs7Ozs7O0FBSUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNlLFNBQVNBLHVCQUFULEdBRWlCO0FBQUEsTUFEOUJDLE9BQzhCLHVFQURZLEVBQ1o7O0FBQUEsYUFDWCx1QkFBV0Msa0NBQXdCQyxPQUFuQyxLQUErQ0YsT0FBTyxDQUFDRyxNQUQ1QztBQUFBLE1BQ3RCQSxNQURzQixRQUN0QkEsTUFEc0I7O0FBRTlCLE1BQUksQ0FBQ0EsTUFBTCxFQUFhO0FBQ1gsVUFBTSxJQUFJQyxLQUFKLENBQVUscURBQVYsQ0FBTjtBQUNEOztBQUo2QixrQkFNQSxxQkFBUyxLQUFULENBTkE7QUFBQTtBQUFBLE1BTXZCQyxPQU51QjtBQUFBLE1BTWRDLFVBTmM7O0FBQUEsbUJBT0osc0JBUEk7QUFBQTtBQUFBLE1BT3ZCQyxLQVB1QjtBQUFBLE1BT2hCQyxRQVBnQjs7QUFTOUIsTUFBTUMsb0JBQW9CO0FBQUEsd0ZBQUcsaUJBQzNCQyxJQUQyQixFQUUzQkMsS0FGMkI7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLCtDQUkzQkMsT0FBTyxDQUFDQyxPQUFSLENBQ0UsSUFBSUQsT0FBSixDQUFZLFVBQUNFLEdBQUQsRUFBTUMsR0FBTixFQUFjO0FBQ3hCVCxnQkFBQUEsVUFBVSxDQUFDLElBQUQsQ0FBVjtBQUNBSCxnQkFBQUEsTUFBTSxDQUNITSxvQkFESCxpQ0FDNkJFLEtBRDdCO0FBQ29DRCxrQkFBQUEsSUFBSSxFQUFKQTtBQURwQyxvQkFFR00sSUFGSCxDQUVRLFVBQUNDLElBQUQsRUFBc0M7QUFBQTs7QUFDMUMsMENBQUFqQixPQUFPLENBQUNrQixXQUFSLG1GQUFBbEIsT0FBTyxFQUFlaUIsSUFBZixDQUFQO0FBQ0FILGtCQUFBQSxHQUFHLENBQUNHLElBQUQsQ0FBSDtBQUNELGlCQUxILEVBTUdFLEtBTkgsQ0FNUyxVQUFDQyxHQUFELEVBQWdCO0FBQUE7O0FBQ3JCWixrQkFBQUEsUUFBUSxDQUFDWSxHQUFELENBQVI7QUFDQSxzQ0FBQXBCLE9BQU8sQ0FBQ3FCLE9BQVIsMkVBQUFyQixPQUFPLEVBQVdvQixHQUFYLENBQVA7QUFDQUwsa0JBQUFBLEdBQUcsQ0FBQ0ssR0FBRCxDQUFIO0FBQ0QsaUJBVkgsRUFXR0UsT0FYSCxDQVdXO0FBQUEseUJBQU1oQixVQUFVLENBQUMsS0FBRCxDQUFoQjtBQUFBLGlCQVhYO0FBWUQsZUFkRCxDQURGLENBSjJCOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBLEtBQUg7O0FBQUEsb0JBQXBCRyxvQkFBb0I7QUFBQTtBQUFBO0FBQUEsS0FBMUI7O0FBc0JBLFNBQU8sQ0FBQ0Esb0JBQUQsRUFBdUI7QUFBRU4sSUFBQUEsTUFBTSxFQUFOQSxNQUFGO0FBQVVJLElBQUFBLEtBQUssRUFBTEEsS0FBVjtBQUFpQkYsSUFBQUEsT0FBTyxFQUFQQTtBQUFqQixHQUF2QixDQUFQO0FBQ0QiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VDb250ZXh0LCB1c2VTdGF0ZSB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IERlbGV0ZURvY3VtZW50QWNjZXNzSW5wdXQsIERlbGV0ZURvY3VtZW50QWNjZXNzT3V0cHV0IH0gZnJvbSAnLi4vLi4vLi4vY29yZSc7XG5cbmltcG9ydCB7IFNlY3VyZURvY3VtZW50c1Byb3ZpZGVyIH0gZnJvbSAnLi4vLi4vY29udGV4dCc7XG5cbmltcG9ydCB7IFVzZURlbGV0ZURvY3VtZW50QWNjZXNzT3B0aW9ucywgVXNlRGVsZXRlRG9jdW1lbnRBY2Nlc3NQcm9wcyB9IGZyb20gJy4vdXNlRGVsZXRlRG9jdW1lbnRBY2Nlc3MudHlwZXMnO1xuXG4vKlxuICBEZWxldGUgYWNjZXNzIGZvciBTZWN1cmUgRG9jdW1lbnQgUmVhY3QgaG9vay5cbiAgQ2xpZW50IHdpbGwgYmUgcGFzc2VkIHRocm91Z2ggY29udGV4dCBieSBgU2VjdXJlRG9jdW1lbnRzUHJvdmlkZXJgLlxuICBPcHRpb25hbGx5LCBjbGllbnQgY2FuIGJlIHBhc3NlZCB0aHJvdWdoIG9wdGlvbnMuXG4qL1xuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gdXNlRGVsZXRlRG9jdW1lbnRBY2Nlc3MoXG4gIG9wdGlvbnM6IFVzZURlbGV0ZURvY3VtZW50QWNjZXNzT3B0aW9ucyA9IHt9LFxuKTogVXNlRGVsZXRlRG9jdW1lbnRBY2Nlc3NQcm9wcyB7XG4gIGNvbnN0IHsgY2xpZW50IH0gPSB1c2VDb250ZXh0KFNlY3VyZURvY3VtZW50c1Byb3ZpZGVyLkNvbnRleHQpIHx8IG9wdGlvbnMuY2xpZW50O1xuICBpZiAoIWNsaWVudCkge1xuICAgIHRocm93IG5ldyBFcnJvcignY2xpZW50IG5vdCBmb3VuZCBmb3IgaG9vayBgdXNlRGVsZXRlRG9jdW1lbnRBY2Nlc3NgJyk7XG4gIH1cblxuICBjb25zdCBbbG9hZGluZywgc2V0TG9hZGluZ10gPSB1c2VTdGF0ZShmYWxzZSk7XG4gIGNvbnN0IFtlcnJvciwgc2V0RXJyb3JdID0gdXNlU3RhdGU8RXJyb3I+KCk7XG5cbiAgY29uc3QgZGVsZXRlRG9jdW1lbnRBY2Nlc3MgPSBhc3luYyAoXG4gICAgcGF0aDogc3RyaW5nLFxuICAgIGlucHV0OiBPbWl0PERlbGV0ZURvY3VtZW50QWNjZXNzSW5wdXQsICdwYXRoJz4sXG4gICk6IFByb21pc2U8RGVsZXRlRG9jdW1lbnRBY2Nlc3NPdXRwdXQ+ID0+XG4gICAgUHJvbWlzZS5yZXNvbHZlKFxuICAgICAgbmV3IFByb21pc2UoKHJlcywgcmVqKSA9PiB7XG4gICAgICAgIHNldExvYWRpbmcodHJ1ZSk7XG4gICAgICAgIGNsaWVudFxuICAgICAgICAgIC5kZWxldGVEb2N1bWVudEFjY2Vzcyh7IC4uLmlucHV0LCBwYXRoIH0pXG4gICAgICAgICAgLnRoZW4oKHJlc3A6IERlbGV0ZURvY3VtZW50QWNjZXNzT3V0cHV0KSA9PiB7XG4gICAgICAgICAgICBvcHRpb25zLm9uQ29tcGxldGVkPy4ocmVzcCk7XG4gICAgICAgICAgICByZXMocmVzcCk7XG4gICAgICAgICAgfSlcbiAgICAgICAgICAuY2F0Y2goKGVycjogRXJyb3IpID0+IHtcbiAgICAgICAgICAgIHNldEVycm9yKGVycik7XG4gICAgICAgICAgICBvcHRpb25zLm9uRXJyb3I/LihlcnIpO1xuICAgICAgICAgICAgcmVqKGVycik7XG4gICAgICAgICAgfSlcbiAgICAgICAgICAuZmluYWxseSgoKSA9PiBzZXRMb2FkaW5nKGZhbHNlKSk7XG4gICAgICB9KSxcbiAgICApO1xuXG4gIHJldHVybiBbZGVsZXRlRG9jdW1lbnRBY2Nlc3MsIHsgY2xpZW50LCBlcnJvciwgbG9hZGluZyB9XTtcbn1cbiJdfQ==

/***/ }),
/* 1807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 1808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useDeleteFolder.default;
  }
});

var _useDeleteFolder = _interopRequireDefault(__webpack_require__(1809));

var _useDeleteFolder2 = __webpack_require__(1810);

Object.keys(_useDeleteFolder2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useDeleteFolder2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useDeleteFolder2[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VEZWxldGVGb2xkZXIvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IGRlZmF1bHQgfSBmcm9tICcuL3VzZURlbGV0ZUZvbGRlcic7XG5leHBvcnQgKiBmcm9tICcuL3VzZURlbGV0ZUZvbGRlci50eXBlcyc7XG4iXX0=

/***/ }),
/* 1809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDeleteFolder;

var _regenerator = _interopRequireDefault(__webpack_require__(103));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(101));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(96));

var _react = __webpack_require__(0);

var _context2 = __webpack_require__(112);

/*
  Delete Secure Document Folder React hook.
  Client will be passed through context by `SecureDocumentsProvider`.
  Optionally, client can be passed through options.
*/
function useDeleteFolder() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = (0, _react.useContext)(_context2.SecureDocumentsProvider.Context) || options.client,
      client = _ref.client;

  if (!client) {
    throw new Error('client not found for hook `useDeleteFolder`');
  }

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var deleteFolder = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(path) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Promise.resolve(new Promise(function (res, rej) {
                setLoading(true);
                client.deleteFolder({
                  path: path
                }).then(function (resp) {
                  var _options$onCompleted;

                  (_options$onCompleted = options.onCompleted) === null || _options$onCompleted === void 0 ? void 0 : _options$onCompleted.call(options, resp);
                  res(resp);
                }).catch(function (err) {
                  var _options$onError;

                  setError(err);
                  (_options$onError = options.onError) === null || _options$onError === void 0 ? void 0 : _options$onError.call(options, err);
                  rej(err);
                }).finally(function () {
                  return setLoading(false);
                });
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function deleteFolder(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return [deleteFolder, {
    client: client,
    error: error,
    loading: loading
  }];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 1811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useDownloadDocument.default;
  }
});

var _useDownloadDocument = _interopRequireDefault(__webpack_require__(1812));

var _useDownloadDocument2 = __webpack_require__(1813);

Object.keys(_useDownloadDocument2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useDownloadDocument2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useDownloadDocument2[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VEb3dubG9hZERvY3VtZW50L2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBkZWZhdWx0IH0gZnJvbSAnLi91c2VEb3dubG9hZERvY3VtZW50JztcbmV4cG9ydCAqIGZyb20gJy4vdXNlRG93bmxvYWREb2N1bWVudC50eXBlcyc7XG4iXX0=

/***/ }),
/* 1812 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useDownloadDocument;

var _regenerator = _interopRequireDefault(__webpack_require__(103));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(101));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(96));

var _react = __webpack_require__(0);

var _useReadDocument2 = _interopRequireDefault(__webpack_require__(886));

var _context2 = __webpack_require__(112);

/*
  Download Secure Document React hook.
  Client will be passed through context by `SecureDocumentsProvider`.
  Optionally, client can be passed through options.
*/
function useDownloadDocument() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = (0, _react.useContext)(_context2.SecureDocumentsProvider.Context) || options.client,
      client = _ref.client;

  if (!client) {
    throw new Error('client not found for hook `useDownloadDocument`');
  }

  var _useReadDocument = (0, _useReadDocument2.default)('', {
    skip: true
  }),
      refetch = _useReadDocument.refetch;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var downloadDocument = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(path, fileName) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Promise.resolve(new Promise(function (res, rej) {
                setLoading(true);
                refetch(path).then(function (resp) {
                  var _options$onCompleted;

                  if (resp) {
                    var blob = new Blob([resp.content], {
                      type: 'application/octet-stream'
                    });
                    var link = document.createElement('a');
                    link.href = URL.createObjectURL(blob);
                    link.download = fileName;
                    link.click();
                  }

                  (_options$onCompleted = options.onCompleted) === null || _options$onCompleted === void 0 ? void 0 : _options$onCompleted.call(options);
                  res();
                }).catch(function (err) {
                  var _options$onError;

                  setError(err);
                  (_options$onError = options.onError) === null || _options$onError === void 0 ? void 0 : _options$onError.call(options, err);
                  rej(err);
                }).finally(function () {
                  return setLoading(false);
                });
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function downloadDocument(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return [downloadDocument, {
    client: client,
    error: error,
    loading: loading
  }];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1813 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 1814 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useListDocuments.default;
  }
});

var _useListDocuments = _interopRequireDefault(__webpack_require__(1815));

var _useListDocuments2 = __webpack_require__(1816);

Object.keys(_useListDocuments2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useListDocuments2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useListDocuments2[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VMaXN0RG9jdW1lbnRzL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBkZWZhdWx0IH0gZnJvbSAnLi91c2VMaXN0RG9jdW1lbnRzJztcbmV4cG9ydCAqIGZyb20gJy4vdXNlTGlzdERvY3VtZW50cy50eXBlcyc7XG4iXX0=

/***/ }),
/* 1815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useListDocuments;

var _regenerator = _interopRequireDefault(__webpack_require__(103));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(101));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(96));

var _react = __webpack_require__(0);

var _context2 = __webpack_require__(112);

/*
  List Secure Documents React hook.
  Client will be passed through context by `SecureDocumentsProvider`.
  Optionally, client can be passed through options.
*/
function useListDocuments(path) {
  var filterOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    limit: 10,
    page: 1
  };
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _ref = (0, _react.useContext)(_context2.SecureDocumentsProvider.Context) || options.client,
      client = _ref.client;

  if (!client) {
    throw new Error('client not found for hook `useListSecureDocuments`');
  }

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var documentType = filterOptions.documentType,
      limit = filterOptions.limit,
      page = filterOptions.page,
      selfUploadOnly = filterOptions.selfUploadOnly;
  var onCompleted = options.onCompleted,
      onError = options.onError;
  var fetchDocuments = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_path) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Promise.resolve(new Promise(function (res, rej) {
                setLoading(true);
                client.listDocuments({
                  path: _path,
                  documentType: documentType,
                  limit: limit,
                  page: page,
                  selfUploadOnly: selfUploadOnly
                }).then(function (resp) {
                  setData(resp);
                  onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(resp);
                  res(resp);
                }).catch(function (err) {
                  setError(err);
                  onError === null || onError === void 0 ? void 0 : onError(err);
                  rej(err);
                }).finally(function () {
                  return setLoading(false);
                });
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [client, documentType, limit, page, selfUploadOnly, onCompleted, onError]);
  (0, _react.useEffect)(function () {
    if (!options.skip) {
      fetchDocuments(path);
    }
  }, [fetchDocuments, path, options.skip]);
  return {
    client: client,
    data: data,
    error: error,
    loading: loading,
    refetch: function refetch() {
      var _path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : path;

      return fetchDocuments(_path);
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 1817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useReadDocument;

var _regenerator = _interopRequireDefault(__webpack_require__(103));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(101));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(96));

var _react = __webpack_require__(0);

var _context2 = __webpack_require__(112);

/*
  Read Secure Document React hook.
  Client will be passed through context by `SecureDocumentsProvider`.
  Optionally, client can be passed through options.
*/
function useReadDocument(path) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref = (0, _react.useContext)(_context2.SecureDocumentsProvider.Context) || options.client,
      client = _ref.client;

  if (!client) {
    throw new Error('client not found for hook `useReadDocument`');
  }

  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      loading = _useState4[0],
      setLoading = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var onCompleted = options.onCompleted,
      onError = options.onError;
  var readDocument = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(_path) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Promise.resolve(new Promise(function (res, rej) {
                setLoading(true);
                client.readDocument({
                  path: _path
                }).then(function (resp) {
                  setData(resp || []);
                  onCompleted === null || onCompleted === void 0 ? void 0 : onCompleted(resp);
                  res(resp);
                }).catch(function (err) {
                  setError(err);
                  onError === null || onError === void 0 ? void 0 : onError(err);
                  rej(err);
                }).finally(function () {
                  return setLoading(false);
                });
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [client, onCompleted, onError]);
  (0, _react.useEffect)(function () {
    if (!options.skip) {
      readDocument(path);
    }
  }, [readDocument, path, options.skip]);
  return {
    client: client,
    data: data,
    error: error,
    loading: loading,
    refetch: function refetch() {
      var _path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : path;

      return readDocument(_path);
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 1819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useRemoveDocument.default;
  }
});

var _useRemoveDocument = _interopRequireDefault(__webpack_require__(1820));

var _useRemoveDocument2 = __webpack_require__(1821);

Object.keys(_useRemoveDocument2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useRemoveDocument2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useRemoveDocument2[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VSZW1vdmVEb2N1bWVudC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgZGVmYXVsdCB9IGZyb20gJy4vdXNlUmVtb3ZlRG9jdW1lbnQnO1xuZXhwb3J0ICogZnJvbSAnLi91c2VSZW1vdmVEb2N1bWVudC50eXBlcyc7XG4iXX0=

/***/ }),
/* 1820 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useRemoveDocument;

var _regenerator = _interopRequireDefault(__webpack_require__(103));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(101));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(96));

var _react = __webpack_require__(0);

var _context2 = __webpack_require__(112);

/*
  Delete Secure Document React hook.
  Client will be passed through context by `SecureDocumentsProvider`.
  Optionally, client can be passed through options.
*/
function useRemoveDocument() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = (0, _react.useContext)(_context2.SecureDocumentsProvider.Context) || options.client,
      client = _ref.client;

  if (!client) {
    throw new Error('client not found for hook `useRemoveDocument`');
  }

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var removeDocument = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(path) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Promise.resolve(new Promise(function (res, rej) {
                setLoading(true);
                client.removeDocument({
                  path: path
                }).then(function (resp) {
                  var _options$onCompleted;

                  (_options$onCompleted = options.onCompleted) === null || _options$onCompleted === void 0 ? void 0 : _options$onCompleted.call(options, resp);
                  res(resp);
                }).catch(function (err) {
                  var _options$onError;

                  setError(err);
                  (_options$onError = options.onError) === null || _options$onError === void 0 ? void 0 : _options$onError.call(options, err);
                  rej(err);
                }).finally(function () {
                  return setLoading(false);
                });
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function removeDocument(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return [removeDocument, {
    client: client,
    error: error,
    loading: loading
  }];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1821 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 1822 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useSecureDocumentsContext.default;
  }
});

var _useSecureDocumentsContext = _interopRequireDefault(__webpack_require__(1823));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VTZWN1cmVEb2N1bWVudHNDb250ZXh0L2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7O0FBQUEiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgeyBkZWZhdWx0IH0gZnJvbSAnLi91c2VTZWN1cmVEb2N1bWVudHNDb250ZXh0JztcbiJdfQ==

/***/ }),
/* 1823 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useSecureDocumentsContext;

var _react = __webpack_require__(0);

var _tsInvariant = _interopRequireDefault(__webpack_require__(3511));

var _context = __webpack_require__(112);

function useSecureDocumentsContext() {
  var _useContext = (0, _react.useContext)(_context.SecureDocumentsProvider.Context),
      client = _useContext.client;

  (0, _tsInvariant.default)(client, 'No Secure Documents Client instance can be found. Please ensure that you ' + 'have called `SecureDocumentsProvider` higher up in your tree.');
  return client;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VTZWN1cmVEb2N1bWVudHNDb250ZXh0L3VzZVNlY3VyZURvY3VtZW50c0NvbnRleHQudHMiXSwibmFtZXMiOlsidXNlU2VjdXJlRG9jdW1lbnRzQ29udGV4dCIsIlNlY3VyZURvY3VtZW50c1Byb3ZpZGVyIiwiQ29udGV4dCIsImNsaWVudCJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBR0E7O0FBRWUsU0FBU0EseUJBQVQsR0FBNEQ7QUFBQSxvQkFDdEQsdUJBQVdDLGlDQUF3QkMsT0FBbkMsQ0FEc0Q7QUFBQSxNQUNqRUMsTUFEaUUsZUFDakVBLE1BRGlFOztBQUV6RSw0QkFDRUEsTUFERixFQUVFLDhFQUNFLCtEQUhKO0FBS0EsU0FBT0EsTUFBUDtBQUNEIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgdXNlQ29udGV4dCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBpbnZhcmlhbnQgZnJvbSAndHMtaW52YXJpYW50JztcblxuaW1wb3J0IHsgU2VjdXJlRG9jdW1lbnRzQ2xpZW50IH0gZnJvbSAnLi4vLi4vLi4vY29yZSc7XG5pbXBvcnQgeyBTZWN1cmVEb2N1bWVudHNQcm92aWRlciB9IGZyb20gJy4uLy4uL2NvbnRleHQnO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiB1c2VTZWN1cmVEb2N1bWVudHNDb250ZXh0KCk6IFNlY3VyZURvY3VtZW50c0NsaWVudCB7XG4gIGNvbnN0IHsgY2xpZW50IH0gPSB1c2VDb250ZXh0KFNlY3VyZURvY3VtZW50c1Byb3ZpZGVyLkNvbnRleHQpO1xuICBpbnZhcmlhbnQoXG4gICAgY2xpZW50LFxuICAgICdObyBTZWN1cmUgRG9jdW1lbnRzIENsaWVudCBpbnN0YW5jZSBjYW4gYmUgZm91bmQuIFBsZWFzZSBlbnN1cmUgdGhhdCB5b3UgJyArXG4gICAgICAnaGF2ZSBjYWxsZWQgYFNlY3VyZURvY3VtZW50c1Byb3ZpZGVyYCBoaWdoZXIgdXAgaW4geW91ciB0cmVlLicsXG4gICk7XG4gIHJldHVybiBjbGllbnQ7XG59XG4iXX0=

/***/ }),
/* 1824 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useSecureDocumentsWidget.default;
  }
});

var _useSecureDocumentsWidget = _interopRequireDefault(__webpack_require__(1825));

var _useSecureDocumentsWidget2 = __webpack_require__(1826);

Object.keys(_useSecureDocumentsWidget2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useSecureDocumentsWidget2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useSecureDocumentsWidget2[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VTZWN1cmVEb2N1bWVudHNXaWRnZXQvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7O0FBQ0E7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IGRlZmF1bHQgfSBmcm9tICcuL3VzZVNlY3VyZURvY3VtZW50c1dpZGdldCc7XG5leHBvcnQgKiBmcm9tICcuL3VzZVNlY3VyZURvY3VtZW50c1dpZGdldC50eXBlcyc7XG4iXX0=

/***/ }),
/* 1825 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(103));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(101));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(96));

var _react = __webpack_require__(0);

var _ScriptManager = _interopRequireDefault(__webpack_require__(1837));

var scriptManager = new _ScriptManager.default();

var useSecureDocumentsWidget = function useSecureDocumentsWidget(url, props, options) {
  var rootRef = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      loaded = _useState4[0],
      setLoaded = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var onError = options.onError,
      onLoad = options.onLoad;
  var loadWidget = (0, _react.useCallback)( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            setLoading(true);
            _context.prev = 1;
            _context.next = 4;
            return scriptManager.loadComplete(url);

          case 4:
            setLoaded(true);
            onLoad === null || onLoad === void 0 ? void 0 : onLoad();
            _context.next = 12;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            setError(_context.t0);
            onError === null || onError === void 0 ? void 0 : onError(_context.t0);

          case 12:
            _context.prev = 12;
            setLoading(false);
            return _context.finish(12);

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8, 12, 15]]);
  })), [url, onError, onLoad]);
  (0, _react.useEffect)(function () {
    loadWidget();
  }, [loadWidget]);
  (0, _react.useEffect)(function () {
    var renderWidget = function renderWidget() {
      if (window.SecureDocumentsWidget) {
        var w = new window.SecureDocumentsWidget(props);

        if (rootRef.current) {
          w.render(rootRef.current);
        }
      }
    };

    renderWidget();
  }, [loaded, rootRef, props]);
  return [rootRef, {
    error: error,
    loading: loading,
    loaded: loaded
  }];
};

var _default = useSecureDocumentsWidget;
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1826 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 1827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useUpdateDocumentAccess.default;
  }
});

var _useUpdateDocumentAccess = _interopRequireDefault(__webpack_require__(1828));

var _useUpdateDocumentAccess2 = __webpack_require__(1829);

Object.keys(_useUpdateDocumentAccess2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useUpdateDocumentAccess2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useUpdateDocumentAccess2[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VVcGRhdGVEb2N1bWVudEFjY2Vzcy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgZGVmYXVsdCB9IGZyb20gJy4vdXNlVXBkYXRlRG9jdW1lbnRBY2Nlc3MnO1xuZXhwb3J0ICogZnJvbSAnLi91c2VVcGRhdGVEb2N1bWVudEFjY2Vzcy50eXBlcyc7XG4iXX0=

/***/ }),
/* 1828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useUpdateDocumentAccess;

var _regenerator = _interopRequireDefault(__webpack_require__(103));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(102));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(101));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(96));

var _react = __webpack_require__(0);

var _context2 = __webpack_require__(112);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*
  Create access for Secure Document React hook.
  Client will be passed through context by `SecureDocumentsProvider`.
  Optionally, client can be passed through options.
*/
function useUpdateDocumentAccess() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = (0, _react.useContext)(_context2.SecureDocumentsProvider.Context) || options.client,
      client = _ref.client;

  if (!client) {
    throw new Error('client not found for hook `useUpdateDocumentAccess`');
  }

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var updateDocumentAccess = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(path, input) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Promise.resolve(new Promise(function (res, rej) {
                setLoading(true);
                client.updateDocumentAccess(_objectSpread(_objectSpread({}, input), {}, {
                  path: path
                })).then(function (resp) {
                  var _options$onCompleted;

                  (_options$onCompleted = options.onCompleted) === null || _options$onCompleted === void 0 ? void 0 : _options$onCompleted.call(options, resp);
                  res(resp);
                }).catch(function (err) {
                  var _options$onError;

                  setError(err);
                  (_options$onError = options.onError) === null || _options$onError === void 0 ? void 0 : _options$onError.call(options, err);
                  rej(err);
                }).finally(function () {
                  return setLoading(false);
                });
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function updateDocumentAccess(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return [updateDocumentAccess, {
    client: client,
    error: error,
    loading: loading
  }];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 1830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _useUploadDocument.default;
  }
});

var _useUploadDocument = _interopRequireDefault(__webpack_require__(1831));

var _useUploadDocument2 = __webpack_require__(1832);

Object.keys(_useUploadDocument2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useUploadDocument2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _useUploadDocument2[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9yZWFjdC9ob29rcy91c2VVcGxvYWREb2N1bWVudC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgZGVmYXVsdCB9IGZyb20gJy4vdXNlVXBsb2FkRG9jdW1lbnQnO1xuZXhwb3J0ICogZnJvbSAnLi91c2VVcGxvYWREb2N1bWVudC50eXBlcyc7XG4iXX0=

/***/ }),
/* 1831 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useUploadDocument;

var _regenerator = _interopRequireDefault(__webpack_require__(103));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(102));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(101));

var _slicedToArray2 = _interopRequireDefault(__webpack_require__(96));

var _react = __webpack_require__(0);

var _context2 = __webpack_require__(112);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/*
  Upload Secure Document React hook.
  Client will be passed through context by `SecureDocumentsProvider`.
  Optionally, client can be passed through options.
*/
function useUploadDocument() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _ref = (0, _react.useContext)(_context2.SecureDocumentsProvider.Context) || options.client,
      client = _ref.client;

  if (!client) {
    throw new Error('client not found for hook `useUploadDocument`');
  }

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      error = _useState4[0],
      setError = _useState4[1];

  var uploadDocument = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(path, input) {
      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", Promise.resolve(new Promise(function (res, rej) {
                setLoading(true);
                client.uploadDocument(_objectSpread(_objectSpread({}, input), {}, {
                  path: path
                })).then(function (resp) {
                  var _options$onCompleted;

                  (_options$onCompleted = options.onCompleted) === null || _options$onCompleted === void 0 ? void 0 : _options$onCompleted.call(options, resp);
                  res(resp);
                }).catch(function (err) {
                  var _options$onError;

                  setError(err);
                  (_options$onError = options.onError) === null || _options$onError === void 0 ? void 0 : _options$onError.call(options, err);
                  rej(err);
                }).finally(function () {
                  return setLoading(false);
                });
              })));

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function uploadDocument(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return [uploadDocument, {
    client: client,
    error: error,
    loading: loading
  }];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1832 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 1833 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _context = __webpack_require__(112);

Object.keys(_context).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _context[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _context[key];
    }
  });
});

var _hooks = __webpack_require__(1795);

Object.keys(_hooks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _hooks[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _hooks[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9yZWFjdC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTs7QUFDQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQSIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gJy4vY29udGV4dCc7XG5leHBvcnQgKiBmcm9tICcuL2hvb2tzJztcbiJdfQ==

/***/ }),
/* 1834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _types = __webpack_require__(887);

Object.keys(_types).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _types[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _types[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zaGFyZWQvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgKiBmcm9tICcuL3R5cGVzJztcbiJdfQ==

/***/ }),
/* 1835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(__webpack_require__(103));

var _asyncToGenerator2 = _interopRequireDefault(__webpack_require__(101));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(369));

var _createClass2 = _interopRequireDefault(__webpack_require__(527));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(102));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _default = /*#__PURE__*/function () {
  function _default() {
    var scripts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var retryLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
    (0, _classCallCheck2.default)(this, _default);
    (0, _defineProperty2.default)(this, "scripts", void 0);
    (0, _defineProperty2.default)(this, "retryLimit", void 0);
    this.scripts = scripts;
    this.retryLimit = retryLimit;
  }

  (0, _createClass2.default)(_default, [{
    key: "get",
    value: function get(url) {
      return this.scripts[url];
    }
  }, {
    key: "set",
    value: function set(url, status) {
      this.scripts[url] = _objectSpread({
        url: url
      }, status);
      return this.get(url);
    }
  }, {
    key: "load",
    value: function load(url, type) {
      return new Promise(function (res) {
        var _document$getElements, _document$getElements2;

        var s = document.createElement('script');
        s.onload = res;
        s.type = type;
        s.src = url;
        (_document$getElements = document.getElementsByTagName('head')) === null || _document$getElements === void 0 ? void 0 : (_document$getElements2 = _document$getElements[0]) === null || _document$getElements2 === void 0 ? void 0 : _document$getElements2.appendChild(s);
      });
    }
  }, {
    key: "loadScript",
    value: function () {
      var _loadScript = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url) {
        var type,
            script,
            _args = arguments;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                type = _args.length > 1 && _args[1] !== undefined ? _args[1] : 'text/javascript';
                script = this.get(url);

                if (!script) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt("return", script);

              case 4:
                if (!document.querySelector("script[src=\"".concat(url, "\"]"))) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", this.set(url, {
                  loading: false,
                  loaded: true
                }));

              case 6:
                this.set(url, {
                  loading: true,
                  loaded: false
                });
                _context.next = 9;
                return this.load(url, type);

              case 9:
                return _context.abrupt("return", this.set(url, {
                  loading: false,
                  loaded: true
                }));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function loadScript(_x) {
        return _loadScript.apply(this, arguments);
      }

      return loadScript;
    }()
  }, {
    key: "loadComplete",
    value: function () {
      var _loadComplete = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(url) {
        var _this = this;

        var type,
            s,
            _args3 = arguments;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                type = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : 'text/javascript';
                _context3.next = 3;
                return this.loadScript(url, type);

              case 3:
                s = _context3.sent;

                if (!(s === null || s === void 0 ? void 0 : s.loaded)) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return", s);

              case 6:
                return _context3.abrupt("return", Promise.resolve(new Promise(function (res, rej) {
                  var count = 0;
                  var t = setInterval( /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
                    var ss;
                    return _regenerator.default.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            if (!(count >= _this.retryLimit)) {
                              _context2.next = 4;
                              break;
                            }

                            clearInterval(t);
                            rej(new Error('Script load limit exceeded'));
                            return _context2.abrupt("return");

                          case 4:
                            _context2.next = 6;
                            return _this.loadScript(url, type);

                          case 6:
                            ss = _context2.sent;

                            if (ss === null || ss === void 0 ? void 0 : ss.loaded) {
                              clearInterval(t);
                              res(ss);
                            }

                            count++;

                          case 9:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  })), 100);
                })));

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function loadComplete(_x2) {
        return _loadComplete.apply(this, arguments);
      }

      return loadComplete;
    }()
  }]);
  return _default;
}();

exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsInNvdXJjZXNDb250ZW50IjpbXX0=

/***/ }),
/* 1837 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _ScriptManager.default;
  }
});

var _ScriptManager = _interopRequireDefault(__webpack_require__(1835));

var _ScriptManager2 = __webpack_require__(1836);

Object.keys(_ScriptManager2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ScriptManager2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ScriptManager2[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy91dGlsaXRpZXMvU2NyaXB0TWFuYWdlci9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7QUFBQTs7QUFDQTs7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgZGVmYXVsdCB9IGZyb20gJy4vU2NyaXB0TWFuYWdlcic7XG5leHBvcnQgKiBmcm9tICcuL1NjcmlwdE1hbmFnZXIudHlwZXMnO1xuIl19

/***/ }),
/* 1838 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(255);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.documentFromFile = void 0;

var path = _interopRequireWildcard(__webpack_require__(682));

var documentFromFile = function documentFromFile(file) {
  return {
    fileName: file.name,
    extension: path.extname(file.name),
    mimeType: file.type,
    fileSize: file.size,
    createdAt: new Date().toString() // Not the time when the file was created at.

  };
};

exports.documentFromFile = documentFromFile;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsaXRpZXMvZG9jdW1lbnQudHMiXSwibmFtZXMiOlsiZG9jdW1lbnRGcm9tRmlsZSIsImZpbGUiLCJmaWxlTmFtZSIsIm5hbWUiLCJleHRlbnNpb24iLCJwYXRoIiwiZXh0bmFtZSIsIm1pbWVUeXBlIiwidHlwZSIsImZpbGVTaXplIiwic2l6ZSIsImNyZWF0ZWRBdCIsIkRhdGUiLCJ0b1N0cmluZyJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7O0FBSU8sSUFBTUEsZ0JBQWdCLEdBQUcsU0FBbkJBLGdCQUFtQixDQUFDQyxJQUFEO0FBQUEsU0FBMEM7QUFDeEVDLElBQUFBLFFBQVEsRUFBRUQsSUFBSSxDQUFDRSxJQUR5RDtBQUV4RUMsSUFBQUEsU0FBUyxFQUFFQyxJQUFJLENBQUNDLE9BQUwsQ0FBYUwsSUFBSSxDQUFDRSxJQUFsQixDQUY2RDtBQUd4RUksSUFBQUEsUUFBUSxFQUFFTixJQUFJLENBQUNPLElBSHlEO0FBSXhFQyxJQUFBQSxRQUFRLEVBQUVSLElBQUksQ0FBQ1MsSUFKeUQ7QUFLeEVDLElBQUFBLFNBQVMsRUFBRSxJQUFJQyxJQUFKLEdBQVdDLFFBQVgsRUFMNkQsQ0FLdEM7O0FBTHNDLEdBQTFDO0FBQUEsQ0FBekIiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgKiBhcyBwYXRoIGZyb20gJ3BhdGgnO1xuXG5pbXBvcnQgeyBTZWN1cmVEb2N1bWVudCB9IGZyb20gJy4uL3NoYXJlZCc7XG5cbmV4cG9ydCBjb25zdCBkb2N1bWVudEZyb21GaWxlID0gKGZpbGU6IEZpbGUpOiBQYXJ0aWFsPFNlY3VyZURvY3VtZW50PiA9PiAoe1xuICBmaWxlTmFtZTogZmlsZS5uYW1lLFxuICBleHRlbnNpb246IHBhdGguZXh0bmFtZShmaWxlLm5hbWUpLFxuICBtaW1lVHlwZTogZmlsZS50eXBlLFxuICBmaWxlU2l6ZTogZmlsZS5zaXplLFxuICBjcmVhdGVkQXQ6IG5ldyBEYXRlKCkudG9TdHJpbmcoKSwgLy8gTm90IHRoZSB0aW1lIHdoZW4gdGhlIGZpbGUgd2FzIGNyZWF0ZWQgYXQuXG59KTtcbiJdfQ==

/***/ }),
/* 1839 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(45);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUnsupportedFileMessage = exports.isSupportedFileName = exports.getSupportedFileAccept = exports.getFileExtension = exports.SUPPORTED_FILE_TYPE_CATEGORIES = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(1783));

/*
  Canonical definition of the file types Secure Documents accepts.

  This is the single source of truth shared by every consumer: web widgets
  use it for the file picker's accept filter and pre-upload validation, and
  the upload edge service enforces it server-side. Extend the lists here and
  every consumer follows on its next dependency bump.

  Validation is by file extension only. MIME types are deliberately not
  trusted for acceptance: on the server they come from the caller-controlled
  Content-Type header, so honouring them would let any file through by
  claiming an accepted type.
*/
var SUPPORTED_FILE_TYPE_CATEGORIES = [{
  key: 'images',
  label: 'images',
  extensions: ['.jpg', '.jpeg', '.jpe', '.jfif', '.png', '.gif', '.webp', '.bmp', '.tif', '.tiff', '.heic', '.heif']
}, {
  key: 'documents',
  label: 'documents',
  extensions: ['.pdf', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.txt', '.csv', '.rtf', '.odt', '.ods']
}, {
  key: 'others',
  label: 'archives & email files',
  extensions: ['.zip', '.rar', '.7z', '.msg', '.eml']
}];
exports.SUPPORTED_FILE_TYPE_CATEGORIES = SUPPORTED_FILE_TYPE_CATEGORIES;

var getFileExtension = function getFileExtension(fileName) {
  var base = fileName.split('/').pop() || '';
  var index = base.lastIndexOf('.');
  return index > 0 ? base.slice(index).toLowerCase() : '';
}; // Value for a file input's accept attribute; extension-based so the picker
// filter matches validation exactly.


exports.getFileExtension = getFileExtension;

var getSupportedFileAccept = function getSupportedFileAccept() {
  var _ref;

  return (_ref = []).concat.apply(_ref, (0, _toConsumableArray2.default)(SUPPORTED_FILE_TYPE_CATEGORIES.map(function (category) {
    return category.extensions;
  }))).join(',');
};
/*
  Whether a file is accepted, judged by its file name (or upload path)
  against the extension whitelist.
*/


exports.getSupportedFileAccept = getSupportedFileAccept;

var isSupportedFileName = function isSupportedFileName(fileName) {
  return SUPPORTED_FILE_TYPE_CATEGORIES.some(function (category) {
    return category.extensions.indexOf(getFileExtension(fileName)) >= 0;
  });
};

exports.isSupportedFileName = isSupportedFileName;

var listExtensions = function listExtensions(category) {
  return ((category === null || category === void 0 ? void 0 : category.extensions) || []).map(function (extension) {
    return extension.slice(1).toUpperCase();
  }).join(', ');
};

var findCategory = function findCategory(key) {
  return SUPPORTED_FILE_TYPE_CATEGORIES.filter(function (category) {
    return category.key === key;
  })[0];
};
/*
  Guidance for a refused file: name the file's own type, then show the
  supported list for the category the file looks like — a document-like MIME
  type gets the document list, anything else the full category breakdown.
*/


var getUnsupportedFileMessage = function getUnsupportedFileMessage(fileName, mimeType) {
  var _findCategory;

  var extension = getFileExtension(fileName);
  var subject = extension ? "".concat(extension.slice(1).toUpperCase(), " files are not supported.") : 'This file has no recognisable type.';

  if ((mimeType === null || mimeType === void 0 ? void 0 : mimeType.startsWith('application/')) || (mimeType === null || mimeType === void 0 ? void 0 : mimeType.startsWith('text/'))) {
    return "".concat(subject, " Supported documents: ").concat(listExtensions(findCategory('documents')), ".");
  }

  return "".concat(subject, " You can upload images (").concat(listExtensions(findCategory('images')), "), ") + "documents (".concat(listExtensions(findCategory('documents')), ") ") + "or ".concat((_findCategory = findCategory('others')) === null || _findCategory === void 0 ? void 0 : _findCategory.label, " (").concat(listExtensions(findCategory('others')), ").");
};

exports.getUnsupportedFileMessage = getUnsupportedFileMessage;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 1840 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _document = __webpack_require__(1838);

Object.keys(_document).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _document[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _document[key];
    }
  });
});

var _fileTypes = __webpack_require__(1839);

Object.keys(_fileTypes).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _fileTypes[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _fileTypes[key];
    }
  });
});

var _path = __webpack_require__(1841);

Object.keys(_path).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _path[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _path[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsaXRpZXMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBQ0E7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7O0FBQ0E7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgKiBmcm9tICcuL2RvY3VtZW50JztcbmV4cG9ydCAqIGZyb20gJy4vZmlsZVR5cGVzJztcbmV4cG9ydCAqIGZyb20gJy4vcGF0aCc7XG4iXX0=

/***/ }),
/* 1841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildShowroomBookingsDocumentPath = exports.buildShowroomBookingsFolderPath = exports.buildDocumentPath = exports.buildFolderDocumentPath = exports.buildFolderPath = exports.isDocumentPath = exports.isFolderPath = exports.extractSubjectID = void 0;

/*
  Join path segments with '/' regardless of platform. Node's path.join
  produces backslashes on Windows, which the rest of this module (and the
  server-side path convention) does not accept.
*/
var joinPaths = function joinPaths() {
  for (var _len = arguments.length, segments = new Array(_len), _key = 0; _key < _len; _key++) {
    segments[_key] = arguments[_key];
  }

  return segments.join('/').replace(/\/{2,}/g, '/');
};
/*
  Retrieve request ID for specific subject.
  convention: /{app}/{subject}/{subjectID}
  e.g., /lawyer/cases/case-1232131213
                ^^^^^ ^^^^^^^^^^^^^^^
                Type       ID
*/


var extractSubjectID = function extractSubjectID(_path, type) {
  var id = '';

  if (_path) {
    var paths = _path.split('/');

    if (paths && Array.isArray(paths) && paths.length > 0) {
      var matchIndex = paths.findIndex(function (p) {
        return p === type;
      });

      if (matchIndex > -1 && paths.length >= matchIndex + 1) {
        id = paths[matchIndex + 1];
      }
    }
  }

  return id;
};
/* Checks if provided path is a folder path based on convention. */


exports.extractSubjectID = extractSubjectID;

var isFolderPath = function isFolderPath(_path) {
  return _path.split('/').filter(function (p) {
    return p;
  }).length === 3;
};
/* Checks if provided path is a document path based on convention. */


exports.isFolderPath = isFolderPath;

var isDocumentPath = function isDocumentPath(_path) {
  return _path.split('/').filter(function (p) {
    return p;
  }).length === 4;
};
/* Build folder path based on provided App, Subject, SubjectID. */


exports.isDocumentPath = isDocumentPath;

var buildFolderPath = function buildFolderPath(app, subject, subjectID) {
  return joinPaths(app, subject, subjectID);
};
/* Build document path based on provided folder path. */


exports.buildFolderPath = buildFolderPath;

var buildFolderDocumentPath = function buildFolderDocumentPath(folderPath, fileName) {
  return joinPaths(folderPath, fileName);
};
/* Build document path based on provided App, Subject, SubjectID and FileName. */


exports.buildFolderDocumentPath = buildFolderDocumentPath;

var buildDocumentPath = function buildDocumentPath(app, subject, subjectID, fileName) {
  return buildFolderDocumentPath(buildFolderPath(app, subject, subjectID), fileName);
}; // -- Path

/* Build folder path for Showroom Bookings. */


exports.buildDocumentPath = buildDocumentPath;

var buildShowroomBookingsFolderPath = function buildShowroomBookingsFolderPath(bookingID) {
  return buildFolderPath('showroom', 'bookings', bookingID);
};
/* Build document path for Showroom Bookings. */


exports.buildShowroomBookingsFolderPath = buildShowroomBookingsFolderPath;

var buildShowroomBookingsDocumentPath = function buildShowroomBookingsDocumentPath(bookingID, fileName) {
  return buildFolderDocumentPath(buildShowroomBookingsFolderPath(bookingID), fileName);
};

exports.buildShowroomBookingsDocumentPath = buildShowroomBookingsDocumentPath;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlsaXRpZXMvcGF0aC50cyJdLCJuYW1lcyI6WyJqb2luUGF0aHMiLCJzZWdtZW50cyIsImpvaW4iLCJyZXBsYWNlIiwiZXh0cmFjdFN1YmplY3RJRCIsIl9wYXRoIiwidHlwZSIsImlkIiwicGF0aHMiLCJzcGxpdCIsIkFycmF5IiwiaXNBcnJheSIsImxlbmd0aCIsIm1hdGNoSW5kZXgiLCJmaW5kSW5kZXgiLCJwIiwiaXNGb2xkZXJQYXRoIiwiZmlsdGVyIiwiaXNEb2N1bWVudFBhdGgiLCJidWlsZEZvbGRlclBhdGgiLCJhcHAiLCJzdWJqZWN0Iiwic3ViamVjdElEIiwiYnVpbGRGb2xkZXJEb2N1bWVudFBhdGgiLCJmb2xkZXJQYXRoIiwiZmlsZU5hbWUiLCJidWlsZERvY3VtZW50UGF0aCIsImJ1aWxkU2hvd3Jvb21Cb29raW5nc0ZvbGRlclBhdGgiLCJib29raW5nSUQiLCJidWlsZFNob3dyb29tQm9va2luZ3NEb2N1bWVudFBhdGgiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFFQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0EsSUFBTUEsU0FBUyxHQUFHLFNBQVpBLFNBQVk7QUFBQSxvQ0FBSUMsUUFBSjtBQUFJQSxJQUFBQSxRQUFKO0FBQUE7O0FBQUEsU0FBbUNBLFFBQVEsQ0FDMURDLElBRGtELENBQzdDLEdBRDZDLEVBRWxEQyxPQUZrRCxDQUUxQyxTQUYwQyxFQUUvQixHQUYrQixDQUFuQztBQUFBLENBQWxCO0FBSUE7QUFDQTtBQUNBO0FBQ0E7QUFDQTtBQUNBO0FBQ0E7OztBQUNPLElBQU1DLGdCQUFnQixHQUFHLFNBQW5CQSxnQkFBbUIsQ0FBQ0MsS0FBRCxFQUFnQkMsSUFBaEIsRUFBeUM7QUFDdkUsTUFBSUMsRUFBRSxHQUFHLEVBQVQ7O0FBQ0EsTUFBSUYsS0FBSixFQUFXO0FBQ1QsUUFBTUcsS0FBSyxHQUFHSCxLQUFLLENBQUNJLEtBQU4sQ0FBWSxHQUFaLENBQWQ7O0FBQ0EsUUFBSUQsS0FBSyxJQUFJRSxLQUFLLENBQUNDLE9BQU4sQ0FBY0gsS0FBZCxDQUFULElBQWlDQSxLQUFLLENBQUNJLE1BQU4sR0FBZSxDQUFwRCxFQUF1RDtBQUNyRCxVQUFNQyxVQUFVLEdBQUdMLEtBQUssQ0FBQ00sU0FBTixDQUFnQixVQUFDQyxDQUFEO0FBQUEsZUFBT0EsQ0FBQyxLQUFLVCxJQUFiO0FBQUEsT0FBaEIsQ0FBbkI7O0FBQ0EsVUFBSU8sVUFBVSxHQUFHLENBQUMsQ0FBZCxJQUFtQkwsS0FBSyxDQUFDSSxNQUFOLElBQWdCQyxVQUFVLEdBQUcsQ0FBcEQsRUFBdUQ7QUFDckROLFFBQUFBLEVBQUUsR0FBR0MsS0FBSyxDQUFDSyxVQUFVLEdBQUcsQ0FBZCxDQUFWO0FBQ0Q7QUFDRjtBQUNGOztBQUNELFNBQU9OLEVBQVA7QUFDRCxDQVpNO0FBY1A7Ozs7O0FBQ08sSUFBTVMsWUFBWSxHQUFHLFNBQWZBLFlBQWUsQ0FBQ1gsS0FBRCxFQUE0QjtBQUN0RCxTQUFPQSxLQUFLLENBQUNJLEtBQU4sQ0FBWSxHQUFaLEVBQWlCUSxNQUFqQixDQUF3QixVQUFDRixDQUFEO0FBQUEsV0FBT0EsQ0FBUDtBQUFBLEdBQXhCLEVBQWtDSCxNQUFsQyxLQUE2QyxDQUFwRDtBQUNELENBRk07QUFJUDs7Ozs7QUFDTyxJQUFNTSxjQUFjLEdBQUcsU0FBakJBLGNBQWlCLENBQUNiLEtBQUQsRUFBNEI7QUFDeEQsU0FBT0EsS0FBSyxDQUFDSSxLQUFOLENBQVksR0FBWixFQUFpQlEsTUFBakIsQ0FBd0IsVUFBQ0YsQ0FBRDtBQUFBLFdBQU9BLENBQVA7QUFBQSxHQUF4QixFQUFrQ0gsTUFBbEMsS0FBNkMsQ0FBcEQ7QUFDRCxDQUZNO0FBSVA7Ozs7O0FBQ08sSUFBTU8sZUFBZSxHQUFHLFNBQWxCQSxlQUFrQixDQUFDQyxHQUFELEVBQXlCQyxPQUF6QixFQUEwQ0MsU0FBMUM7QUFBQSxTQUM3QnRCLFNBQVMsQ0FBQ29CLEdBQUQsRUFBTUMsT0FBTixFQUFlQyxTQUFmLENBRG9CO0FBQUEsQ0FBeEI7QUFHUDs7Ozs7QUFDTyxJQUFNQyx1QkFBdUIsR0FBRyxTQUExQkEsdUJBQTBCLENBQUNDLFVBQUQsRUFBcUJDLFFBQXJCO0FBQUEsU0FDckN6QixTQUFTLENBQUN3QixVQUFELEVBQWFDLFFBQWIsQ0FENEI7QUFBQSxDQUFoQztBQUdQOzs7OztBQUNPLElBQU1DLGlCQUFpQixHQUFHLFNBQXBCQSxpQkFBb0IsQ0FDL0JOLEdBRCtCLEVBRS9CQyxPQUYrQixFQUcvQkMsU0FIK0IsRUFJL0JHLFFBSitCO0FBQUEsU0FLcEJGLHVCQUF1QixDQUFDSixlQUFlLENBQUNDLEdBQUQsRUFBTUMsT0FBTixFQUFlQyxTQUFmLENBQWhCLEVBQTJDRyxRQUEzQyxDQUxIO0FBQUEsQ0FBMUIsQyxDQU9QOztBQUVBOzs7OztBQUNPLElBQU1FLCtCQUErQixHQUFHLFNBQWxDQSwrQkFBa0MsQ0FBQ0MsU0FBRDtBQUFBLFNBQzdDVCxlQUFlLENBQUMsVUFBRCxFQUFhLFVBQWIsRUFBeUJTLFNBQXpCLENBRDhCO0FBQUEsQ0FBeEM7QUFHUDs7Ozs7QUFDTyxJQUFNQyxpQ0FBaUMsR0FBRyxTQUFwQ0EsaUNBQW9DLENBQUNELFNBQUQsRUFBb0JILFFBQXBCO0FBQUEsU0FDL0NGLHVCQUF1QixDQUFDSSwrQkFBK0IsQ0FBQ0MsU0FBRCxDQUFoQyxFQUE2Q0gsUUFBN0MsQ0FEd0I7QUFBQSxDQUExQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFNlY3VyZURvY3VtZW50QXBwIH0gZnJvbSAnLi4vc2hhcmVkJztcblxuLypcbiAgSm9pbiBwYXRoIHNlZ21lbnRzIHdpdGggJy8nIHJlZ2FyZGxlc3Mgb2YgcGxhdGZvcm0uIE5vZGUncyBwYXRoLmpvaW5cbiAgcHJvZHVjZXMgYmFja3NsYXNoZXMgb24gV2luZG93cywgd2hpY2ggdGhlIHJlc3Qgb2YgdGhpcyBtb2R1bGUgKGFuZCB0aGVcbiAgc2VydmVyLXNpZGUgcGF0aCBjb252ZW50aW9uKSBkb2VzIG5vdCBhY2NlcHQuXG4qL1xuY29uc3Qgam9pblBhdGhzID0gKC4uLnNlZ21lbnRzOiBzdHJpbmdbXSk6IHN0cmluZyA9PiBzZWdtZW50c1xuICAuam9pbignLycpXG4gIC5yZXBsYWNlKC9cXC97Mix9L2csICcvJyk7XG5cbi8qXG4gIFJldHJpZXZlIHJlcXVlc3QgSUQgZm9yIHNwZWNpZmljIHN1YmplY3QuXG4gIGNvbnZlbnRpb246IC97YXBwfS97c3ViamVjdH0ve3N1YmplY3RJRH1cbiAgZS5nLiwgL2xhd3llci9jYXNlcy9jYXNlLTEyMzIxMzEyMTNcbiAgICAgICAgICAgICAgICBeXl5eXiBeXl5eXl5eXl5eXl5eXl5cbiAgICAgICAgICAgICAgICBUeXBlICAgICAgIElEXG4qL1xuZXhwb3J0IGNvbnN0IGV4dHJhY3RTdWJqZWN0SUQgPSAoX3BhdGg6IHN0cmluZywgdHlwZTogc3RyaW5nKTogc3RyaW5nID0+IHtcbiAgbGV0IGlkID0gJyc7XG4gIGlmIChfcGF0aCkge1xuICAgIGNvbnN0IHBhdGhzID0gX3BhdGguc3BsaXQoJy8nKTtcbiAgICBpZiAocGF0aHMgJiYgQXJyYXkuaXNBcnJheShwYXRocykgJiYgcGF0aHMubGVuZ3RoID4gMCkge1xuICAgICAgY29uc3QgbWF0Y2hJbmRleCA9IHBhdGhzLmZpbmRJbmRleCgocCkgPT4gcCA9PT0gdHlwZSk7XG4gICAgICBpZiAobWF0Y2hJbmRleCA+IC0xICYmIHBhdGhzLmxlbmd0aCA+PSBtYXRjaEluZGV4ICsgMSkge1xuICAgICAgICBpZCA9IHBhdGhzW21hdGNoSW5kZXggKyAxXTtcbiAgICAgIH1cbiAgICB9XG4gIH1cbiAgcmV0dXJuIGlkO1xufTtcblxuLyogQ2hlY2tzIGlmIHByb3ZpZGVkIHBhdGggaXMgYSBmb2xkZXIgcGF0aCBiYXNlZCBvbiBjb252ZW50aW9uLiAqL1xuZXhwb3J0IGNvbnN0IGlzRm9sZGVyUGF0aCA9IChfcGF0aDogc3RyaW5nKTogYm9vbGVhbiA9PiB7XG4gIHJldHVybiBfcGF0aC5zcGxpdCgnLycpLmZpbHRlcigocCkgPT4gcCkubGVuZ3RoID09PSAzO1xufTtcblxuLyogQ2hlY2tzIGlmIHByb3ZpZGVkIHBhdGggaXMgYSBkb2N1bWVudCBwYXRoIGJhc2VkIG9uIGNvbnZlbnRpb24uICovXG5leHBvcnQgY29uc3QgaXNEb2N1bWVudFBhdGggPSAoX3BhdGg6IHN0cmluZyk6IGJvb2xlYW4gPT4ge1xuICByZXR1cm4gX3BhdGguc3BsaXQoJy8nKS5maWx0ZXIoKHApID0+IHApLmxlbmd0aCA9PT0gNDtcbn07XG5cbi8qIEJ1aWxkIGZvbGRlciBwYXRoIGJhc2VkIG9uIHByb3ZpZGVkIEFwcCwgU3ViamVjdCwgU3ViamVjdElELiAqL1xuZXhwb3J0IGNvbnN0IGJ1aWxkRm9sZGVyUGF0aCA9IChhcHA6IFNlY3VyZURvY3VtZW50QXBwLCBzdWJqZWN0OiBzdHJpbmcsIHN1YmplY3RJRDogc3RyaW5nKTogc3RyaW5nID0+XG4gIGpvaW5QYXRocyhhcHAsIHN1YmplY3QsIHN1YmplY3RJRCk7XG5cbi8qIEJ1aWxkIGRvY3VtZW50IHBhdGggYmFzZWQgb24gcHJvdmlkZWQgZm9sZGVyIHBhdGguICovXG5leHBvcnQgY29uc3QgYnVpbGRGb2xkZXJEb2N1bWVudFBhdGggPSAoZm9sZGVyUGF0aDogc3RyaW5nLCBmaWxlTmFtZTogc3RyaW5nKTogc3RyaW5nID0+XG4gIGpvaW5QYXRocyhmb2xkZXJQYXRoLCBmaWxlTmFtZSk7XG5cbi8qIEJ1aWxkIGRvY3VtZW50IHBhdGggYmFzZWQgb24gcHJvdmlkZWQgQXBwLCBTdWJqZWN0LCBTdWJqZWN0SUQgYW5kIEZpbGVOYW1lLiAqL1xuZXhwb3J0IGNvbnN0IGJ1aWxkRG9jdW1lbnRQYXRoID0gKFxuICBhcHA6IFNlY3VyZURvY3VtZW50QXBwLFxuICBzdWJqZWN0OiBzdHJpbmcsXG4gIHN1YmplY3RJRDogc3RyaW5nLFxuICBmaWxlTmFtZTogc3RyaW5nLFxuKTogc3RyaW5nID0+IGJ1aWxkRm9sZGVyRG9jdW1lbnRQYXRoKGJ1aWxkRm9sZGVyUGF0aChhcHAsIHN1YmplY3QsIHN1YmplY3RJRCksIGZpbGVOYW1lKTtcblxuLy8gLS0gUGF0aFxuXG4vKiBCdWlsZCBmb2xkZXIgcGF0aCBmb3IgU2hvd3Jvb20gQm9va2luZ3MuICovXG5leHBvcnQgY29uc3QgYnVpbGRTaG93cm9vbUJvb2tpbmdzRm9sZGVyUGF0aCA9IChib29raW5nSUQ6IHN0cmluZyk6IHN0cmluZyA9PlxuICBidWlsZEZvbGRlclBhdGgoJ3Nob3dyb29tJywgJ2Jvb2tpbmdzJywgYm9va2luZ0lEKTtcblxuLyogQnVpbGQgZG9jdW1lbnQgcGF0aCBmb3IgU2hvd3Jvb20gQm9va2luZ3MuICovXG5leHBvcnQgY29uc3QgYnVpbGRTaG93cm9vbUJvb2tpbmdzRG9jdW1lbnRQYXRoID0gKGJvb2tpbmdJRDogc3RyaW5nLCBmaWxlTmFtZTogc3RyaW5nKTogc3RyaW5nID0+XG4gIGJ1aWxkRm9sZGVyRG9jdW1lbnRQYXRoKGJ1aWxkU2hvd3Jvb21Cb29raW5nc0ZvbGRlclBhdGgoYm9va2luZ0lEKSwgZmlsZU5hbWUpO1xuIl19

/***/ }),
/* 1842 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1843);

/***/ }),
/* 1843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(113);
var bind = __webpack_require__(894);
var Axios = __webpack_require__(1845);
var mergeConfig = __webpack_require__(892);
var defaults = __webpack_require__(893);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(889);
axios.CancelToken = __webpack_require__(1844);
axios.isCancel = __webpack_require__(890);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(1858);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 1844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(889);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 1845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(113);
var buildURL = __webpack_require__(895);
var InterceptorManager = __webpack_require__(1846);
var dispatchRequest = __webpack_require__(1848);
var mergeConfig = __webpack_require__(892);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 1846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(113);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 1847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(1854);
var combineURLs = __webpack_require__(1852);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 1848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(113);
var transformData = __webpack_require__(1851);
var isCancel = __webpack_require__(890);
var defaults = __webpack_require__(893);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 1849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 1850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(891);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 1851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(113);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 1852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 1853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(113);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 1854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 1855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(113);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 1856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(113);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 1857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(113);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 1858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 1859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getMessage;
var _utils = __webpack_require__(97);
var _excluded = ["message"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function getMessage() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultMsg = arguments.length > 1 ? arguments[1] : undefined;
  var message = options.message,
    rest = _objectWithoutProperties(options, _excluded);
  if ((0, _utils.checkValueExist)(message)) {
    if (typeof message === 'function') {
      return message(_objectSpread({}, rest));
    }
    if (typeof message === 'string') {
      return message;
    }
  }
  return defaultMsg;
}

/***/ }),
/* 1860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = assertArray;
function assertArray(value) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  if (!Array.isArray(value)) {
    throw new TypeError("".concat(label, " needs to be an array"));
  }
}

/***/ }),
/* 1861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = assertNumber;
function assertNumber(value) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  if (typeof value !== 'number') {
    throw new TypeError("".concat(label, " needs to be a number"));
  }
}

/***/ }),
/* 1862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = assertShape;
var _assertObject = _interopRequireDefault(__webpack_require__(896));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function assertShape(value) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var label = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'value';
  if (keys.length > 0) {
    (0, _assertObject["default"])(value, label);
    var objKeys = Object.keys(value);
    if (keys.length !== objKeys.length || JSON.stringify(keys) !== JSON.stringify(objKeys)) {
      throw new Error("".concat(label, "'s 'keys' does not matched with keys: ").concat(keys.join(', ')));
    }
  } else {
    throw new Error('assertShape\'s \'keys\' argument is required');
  }
}

/***/ }),
/* 1863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = assertString;
function assertString(value) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  if (typeof value !== 'string') {
    throw new TypeError("".concat(label, " needs to be a string"));
  }
}

/***/ }),
/* 1864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = assertStringOrNumber;
function assertStringOrNumber(value) {
  var label = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'value';
  if (typeof value !== 'string' && typeof value !== 'number') {
    throw new TypeError("".concat(label, " needs to be a string or number"));
  }
}

/***/ }),
/* 1865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = createValidity;
function createValidity(key) {
  return {
    key: key,
    isValid: true
  };
}

/***/ }),
/* 1866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = validate;
var _utils = __webpack_require__(97);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
// validate function
function validate(options) {
  var value = options.value,
    name = options.name,
    label = options.label,
    validations = options.validations,
    message = options.message;
  return new Promise(function (res) {
    var result = (0, _utils.createValidity)(name);
    if (validations.length > 0) {
      var basicProps = {
        key: name,
        label: label || name || 'value',
        message: message
      };
      validations.every(function (v) {
        var validateOption = Object.assign({}, basicProps);
        var validateFunc;
        if (_typeof(v) === 'object' && !Array.isArray(v)) {
          console.warn('Warning: validations props in function \'validate\' will not support object from v0.2.* onwards');
          (0, _utils.assertShape)(v, ['validate', 'options'], 'validation');
          validateFunc = v.validate;
          validateOption = Object.assign(validateOption, v.options); // extends props
        } else {
          validateFunc = v;
        }
        if (validateFunc) {
          try {
            result = validateFunc(value, validateOption);
          } catch (error) {
            result.isValid = false;
            result.message = error.toString();
          }
        }
        return result.isValid;
      });
    }
    res(result);
  });
}

/***/ }),
/* 1867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = arrayLength;
var _utils = __webpack_require__(97);
var _lib = __webpack_require__(124);
function arrayLength(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertArray)(value);
  var message = options.message,
    min = options.min,
    max = options.max,
    equal = options.equal;
  var label = options.label || 'Field';
  var item = options.item || 'items';
  var minProp = parseInt(min, 10) || 0;
  var maxProp = parseInt(max, 10) || 0;
  var equalProp = parseInt(equal, 10) || 0;
  var defaultMsg = "".concat(label, " should be within ").concat(minProp, " to ").concat(maxProp, " ").concat(item);
  if ((0, _utils.checkValueExist)(max)) {
    (0, _utils.assertNumber)(max, 'max');
  } else {
    maxProp = value.length;
    defaultMsg = "".concat(label, " needs to be at least ").concat(minProp, " ").concat(item);
  }
  if ((0, _utils.checkValueExist)(min)) {
    (0, _utils.assertNumber)(min, 'min');
  } else {
    minProp = 0;
    defaultMsg = "".concat(label, " needs to be less than ").concat(maxProp, " ").concat(item);
  }
  if ((0, _utils.checkValueExist)(equal)) {
    (0, _utils.assertNumber)(equal, 'equal');
    // set all values same as equalProp
    minProp = maxProp = equalProp;
  } else {
    equalProp = 0;
  }
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);
  if (value.length > 0) {
    var isEqual = equalProp > 0 && value.length !== equalProp;
    var isMin = equalProp < 1 && value.length < minProp;
    var isMax = equalProp < 1 && value.length > maxProp;
    var messageOptions = {
      key: key,
      message: message,
      label: label,
      item: item,
      isEqual: isEqual,
      isMin: isMin,
      isMax: isMax
    };
    if (isEqual) {
      validity.isValid = false;
      validity.message = (0, _lib.getMessage)(messageOptions, "".concat(label, " should be ").concat(equalProp, " ").concat(item));
    } else if (isMax || isMin) {
      validity.isValid = false;
      validity.message = (0, _lib.getMessage)(messageOptions, defaultMsg);
    }
  }
  return validity;
}

/***/ }),
/* 1868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = capitalize;
var _utils = __webpack_require__(97);
var _lib = __webpack_require__(124);
function capitalize(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertString)(value);
  var message = options.message;
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);
  if (value.length > 0 && !(value === value.toUpperCase())) {
    var label = options.label || 'Field';
    var defaultMsg = "".concat(label, " is required to use all caps");
    var messageOptions = {
      key: key,
      message: message,
      label: label
    };
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, defaultMsg);
  }
  return validity;
}

/***/ }),
/* 1869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = email;
var _utils = __webpack_require__(97);
var _lib = __webpack_require__(124);
var _constants = __webpack_require__(172);
function email(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertString)(value);
  var message = options.message;
  var validRegex = new RegExp(options.validRegex || _constants.RX_EMAIL, 'i');
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);
  if (value.length > 0 && !validRegex.test(value)) {
    var label = options.label || 'Field';
    var messageOptions = {
      key: key,
      message: message,
      label: label,
      validRegex: validRegex
    };
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, "".concat(label, " is not a valid email address"));
  }
  return validity;
}

/***/ }),
/* 1870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = equalTo;
var _utils = __webpack_require__(97);
var _lib = __webpack_require__(124);
function equalTo(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var message = options.message,
    target = options.target;
  var defaultTarget = {
    label: 'Target',
    value: value
  };
  var currentTarget = defaultTarget;
  if ((0, _utils.checkValueExist)(target)) {
    (0, _utils.assertObject)(target, 'target');
    currentTarget = Object.assign(defaultTarget, target);
    (0, _utils.assertShape)(currentTarget, ['label', 'value'], 'target');
  }
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);
  if (value !== currentTarget.value) {
    var label = options.label || 'Field';
    var messageOptions = {
      key: key,
      message: message,
      label: label,
      target: currentTarget
    };
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, "".concat(label, " does not match ").concat(currentTarget.label || 'Target'));
  }
  return validity;
}

/***/ }),
/* 1871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = identity;
var _utils = __webpack_require__(97);
var _lib = __webpack_require__(124);
var _constants = __webpack_require__(172);
function identity(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertString)(value);
  var message = options.message,
    countryCode = options.countryCode,
    identityType = options.identityType;
  var label = options.label || 'Field';
  var defaultMsg = "".concat(label, " has an invalid identity type");
  var defaultRegex = '^\\w*$';
  if ((0, _utils.checkValueExist)(countryCode) && (0, _utils.checkValueExist)(identityType)) {
    var code = String(countryCode).toUpperCase();
    var identityT = String(identityType).toLowerCase();
    var iType = identityT === 'ic_number' ? 'IC' : identityT.replace('_', ' ');
    defaultMsg = "".concat(label, " is not a valid ").concat(iType, " number");
    defaultRegex = _constants.RX_IDENTITY[code][identityT];
  }
  var validRegex = new RegExp(options.validRegex || defaultRegex, 'i');
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);
  if (value.length > 0 && !validRegex.test(value)) {
    var messageOptions = {
      key: key,
      message: message,
      label: label,
      validRegex: validRegex
    };
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, defaultMsg);
  }
  return validity;
}

/***/ }),
/* 1872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isAlpha;
var _utils = __webpack_require__(97);
var _lib = __webpack_require__(124);
var _constants = __webpack_require__(172);
function isAlpha(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertString)(value);
  var message = options.message;
  var validRegex = new RegExp(options.validRegex || _constants.RX_ALPHA, 'i');
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);
  if (value.length > 0 && !validRegex.test(value)) {
    var label = options.label || 'Field';
    var messageOptions = {
      key: key,
      message: message,
      label: label,
      validRegex: validRegex
    };
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, "".concat(label, " should only has alphabets only"));
  }
  return validity;
}

/***/ }),
/* 1873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = matchRegex;
var _utils = __webpack_require__(97);
var _lib = __webpack_require__(124);
var _constants = __webpack_require__(172);
function matchRegex(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertStringOrNumber)(value);
  var message = options.message,
    isPassword = options.isPassword;
  var key = options.key || 'key';
  var defaultRegex = '.*';
  if (isPassword) {
    defaultRegex = _constants.RX_PASSWORD;
  }
  var validRegex = new RegExp(options.validRegex || defaultRegex, 'i');
  var validity = (0, _utils.createValidity)(key || 'key');
  if (value.length > 0 && !validRegex.test(value)) {
    var label = options.label || 'Field';
    var messageOptions = {
      key: key,
      message: message,
      label: label,
      validRegex: validRegex
    };
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, "".concat(label, " does not match the format"));
  }
  return validity;
}

/***/ }),
/* 1874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = numericRange;
var _utils = __webpack_require__(97);
var _lib = __webpack_require__(124);
function numericRange(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertNumber)(value);
  var message = options.message,
    min = options.min,
    max = options.max;
  var label = options.label || 'Field';
  var minProp = parseInt(min, 10) || 0;
  var maxProp = parseInt(max, 10) || 0;
  var defaultMsg = "".concat(label, " should be within ").concat(minProp, " to ").concat(maxProp);
  if ((0, _utils.checkValueExist)(max)) {
    (0, _utils.assertNumber)(max, 'max');
  } else {
    maxProp = value;
    defaultMsg = "".concat(label, " needs to be at least ").concat(minProp);
  }
  if ((0, _utils.checkValueExist)(min)) {
    (0, _utils.assertNumber)(min, 'min');
  } else {
    minProp = 0;
    defaultMsg = "".concat(label, " needs to be less than ").concat(maxProp);
  }
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);
  var isMin = value < minProp;
  var isMax = value > maxProp;
  if (isMax || isMin) {
    var messageOptions = {
      key: key,
      message: message,
      label: label,
      isMin: isMin,
      isMax: isMax
    };
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, defaultMsg);
  }
  return validity;
}

/***/ }),
/* 1875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = phoneNumber;
var _utils = __webpack_require__(97);
var _lib = __webpack_require__(124);
var _constants = __webpack_require__(172);
function phoneNumber(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertString)(value);
  var message = options.message,
    phonePrefix = options.phonePrefix,
    _options$isMobile = options.isMobile,
    isMobile = _options$isMobile === void 0 ? false : _options$isMobile;
  var defaultRegex = '^\\d+$';
  if ((0, _utils.checkValueExist)(phonePrefix)) {
    var pPrefix = String(phonePrefix);
    var prefix = _constants.RX_PHONES[pPrefix];
    if ((0, _utils.checkValueExist)(prefix)) {
      defaultRegex = prefix[String(isMobile)];
    }
  }
  var validRegex = new RegExp(options.validRegex || defaultRegex, 'i');
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);
  if (value.length > 0 && !validRegex.test(value)) {
    var label = options.label || 'Field';
    var defaultMsg = "".concat(label, " is not a valid phone number");
    if (isMobile) {
      defaultMsg = "".concat(label, " is not a valid mobile number");
    }
    var messageOptions = {
      key: key,
      message: message,
      label: label,
      validRegex: validRegex
    };
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, defaultMsg);
  }
  return validity;
}

/***/ }),
/* 1876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = phonePrefix;
var _utils = __webpack_require__(97);
var _lib = __webpack_require__(124);
var _constants = __webpack_require__(172);
function phonePrefix(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertString)(value);
  var message = options.message,
    countryCode = options.countryCode;
  var defaultRegex = "^".concat(Object.keys(_constants.RX_PHONE_PREFIXES).map(function (k) {
    return _constants.RX_PHONE_PREFIXES[k];
  }).join('|'), "$");
  var label = options.label || 'Field';
  var defaultMsg = "".concat(label, " is not a valid phone prefix");
  var messageOptions = {
    key: key,
    message: message,
    label: label,
    validRegex: validRegex
  };
  if ((0, _utils.checkValueExist)(countryCode)) {
    var code = String(countryCode).toUpperCase();
    if ((0, _utils.checkValueExist)(code)) {
      if (Object.prototype.hasOwnProperty.call(_constants.RX_PHONE_PREFIXES, code)) {
        defaultRegex = _constants.RX_PHONE_PREFIXES[code];
      }
    }
  }
  var validRegex = new RegExp(options.validRegex || defaultRegex, 'i');
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);
  if (value.length > 0 && !validRegex.test(value)) {
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, defaultMsg);
  }
  return validity;
}

/***/ }),
/* 1877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = required;
var _utils = __webpack_require__(97);
var _lib = __webpack_require__(124);
function required(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertStringOrNumber)(value);
  var message = options.message;
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);
  if (typeof value === 'string' && value.length === 0) {
    var label = options.label || 'Field';
    var messageOptions = {
      key: key,
      message: message,
      label: label
    };
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, "".concat(label, " is required"));
  }
  return validity;
}

/***/ }),
/* 1878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = stringLength;
var _utils = __webpack_require__(97);
var _lib = __webpack_require__(124);
function stringLength(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertString)(value);
  var message = options.message,
    min = options.min,
    max = options.max,
    equal = options.equal;
  var label = options.label || 'Field';
  var minProp = parseInt(min, 10) || 0;
  var maxProp = parseInt(max, 10) || 0;
  var equalProp = parseInt(equal, 10) || 0;
  var defaultMsg = "".concat(label, " should be within ").concat(minProp, " to ").concat(maxProp, " letters");
  if ((0, _utils.checkValueExist)(max)) {
    (0, _utils.assertNumber)(max, 'max');
  } else {
    maxProp = value.length;
    defaultMsg = "".concat(label, " needs to be at least ").concat(minProp, " letters");
  }
  if ((0, _utils.checkValueExist)(min)) {
    (0, _utils.assertNumber)(min, 'min');
  } else {
    minProp = 0;
    defaultMsg = "".concat(label, " needs to be less than ").concat(maxProp, " letters");
  }
  if ((0, _utils.checkValueExist)(equal)) {
    (0, _utils.assertNumber)(equal, 'equal');
    // set all values same as equalProp
    minProp = maxProp = equalProp;
  } else {
    equalProp = 0;
  }
  var key = options.key || 'key';
  var validity = (0, _utils.createValidity)(key);
  if (value.length > 0) {
    var isEqual = equalProp > 0 && value.length !== equalProp;
    var isMin = equalProp < 1 && value.length < minProp;
    var isMax = equalProp < 1 && value.length > maxProp;
    var messageOptions = {
      key: key,
      message: message,
      label: label,
      isEqual: isEqual,
      isMin: isMin,
      isMax: isMax
    };
    if (isEqual) {
      validity.isValid = false;
      validity.message = (0, _lib.getMessage)(messageOptions, "".concat(label, " should be ").concat(equalProp, " letters"));
    } else if (isMax || isMin) {
      validity.isValid = false;
      validity.message = (0, _lib.getMessage)(messageOptions, defaultMsg);
    }
  }
  return validity;
}

/***/ }),
/* 1879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LogsAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_global_utils__ = __webpack_require__(1880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NoopLoggerProvider__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ProxyLoggerProvider__ = __webpack_require__(899);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



var LogsAPI = /** @class */ (function () {
    function LogsAPI() {
        this._proxyLoggerProvider = new __WEBPACK_IMPORTED_MODULE_2__ProxyLoggerProvider__["a" /* ProxyLoggerProvider */]();
    }
    LogsAPI.getInstance = function () {
        if (!this._instance) {
            this._instance = new LogsAPI();
        }
        return this._instance;
    };
    LogsAPI.prototype.setGlobalLoggerProvider = function (provider) {
        if (__WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["a" /* _global */][__WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["b" /* GLOBAL_LOGS_API_KEY */]]) {
            return this.getLoggerProvider();
        }
        __WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["a" /* _global */][__WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["b" /* GLOBAL_LOGS_API_KEY */]] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["c" /* makeGetter */])(__WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["d" /* API_BACKWARDS_COMPATIBILITY_VERSION */], provider, __WEBPACK_IMPORTED_MODULE_1__NoopLoggerProvider__["a" /* NOOP_LOGGER_PROVIDER */]);
        this._proxyLoggerProvider.setDelegate(provider);
        return provider;
    };
    /**
     * Returns the global logger provider.
     *
     * @returns LoggerProvider
     */
    LogsAPI.prototype.getLoggerProvider = function () {
        var _a, _b;
        return ((_b = (_a = __WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["a" /* _global */][__WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["b" /* GLOBAL_LOGS_API_KEY */]]) === null || _a === void 0 ? void 0 : _a.call(__WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["a" /* _global */], __WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["d" /* API_BACKWARDS_COMPATIBILITY_VERSION */])) !== null && _b !== void 0 ? _b : this._proxyLoggerProvider);
    };
    /**
     * Returns a logger from the global logger provider.
     *
     * @returns Logger
     */
    LogsAPI.prototype.getLogger = function (name, version, options) {
        return this.getLoggerProvider().getLogger(name, version, options);
    };
    /** Remove the global logger provider */
    LogsAPI.prototype.disable = function () {
        delete __WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["a" /* _global */][__WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["b" /* GLOBAL_LOGS_API_KEY */]];
        this._proxyLoggerProvider = new __WEBPACK_IMPORTED_MODULE_2__ProxyLoggerProvider__["a" /* ProxyLoggerProvider */]();
    };
    return LogsAPI;
}());

//# sourceMappingURL=logs.js.map

/***/ }),
/* 1880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GLOBAL_LOGS_API_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _global; });
/* harmony export (immutable) */ __webpack_exports__["c"] = makeGetter;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return API_BACKWARDS_COMPATIBILITY_VERSION; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform__ = __webpack_require__(1882);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var GLOBAL_LOGS_API_KEY = Symbol.for('io.opentelemetry.js.api.logs');
var _global = __WEBPACK_IMPORTED_MODULE_0__platform__["a" /* _globalThis */];
/**
 * Make a function which accepts a version integer and returns the instance of an API if the version
 * is compatible, or a fallback version (usually NOOP) if it is not.
 *
 * @param requiredVersion Backwards compatibility version which is required to return the instance
 * @param instance Instance which should be returned if the required version is compatible
 * @param fallback Fallback instance, usually NOOP, which will be returned if the required version is not compatible
 */
function makeGetter(requiredVersion, instance, fallback) {
    return function (version) {
        return version === requiredVersion ? instance : fallback;
    };
}
/**
 * A number which should be incremented each time a backwards incompatible
 * change is made to the API. This number is used when an API package
 * attempts to access the global API to ensure it is getting a compatible
 * version. If the global API is not compatible with the API package
 * attempting to get it, a NOOP API implementation will be returned.
 */
var API_BACKWARDS_COMPATIBILITY_VERSION = 1;
//# sourceMappingURL=global-utils.js.map

/***/ }),
/* 1881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _globalThis; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Updates to this file should also be replicated to @opentelemetry/api and
// @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */
/** only globals that common to node and browsers are allowed */
// eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var _globalThis = typeof globalThis === 'object'
    ? globalThis
    : typeof self === 'object'
        ? self
        : typeof window === 'object'
            ? window
            : typeof global === 'object'
                ? global
                : {};
//# sourceMappingURL=globalThis.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(56)))

/***/ }),
/* 1882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globalThis__ = __webpack_require__(1881);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__globalThis__["a"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 1883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SeverityNumber */
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SeverityNumber;
(function (SeverityNumber) {
    SeverityNumber[SeverityNumber["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    SeverityNumber[SeverityNumber["TRACE"] = 1] = "TRACE";
    SeverityNumber[SeverityNumber["TRACE2"] = 2] = "TRACE2";
    SeverityNumber[SeverityNumber["TRACE3"] = 3] = "TRACE3";
    SeverityNumber[SeverityNumber["TRACE4"] = 4] = "TRACE4";
    SeverityNumber[SeverityNumber["DEBUG"] = 5] = "DEBUG";
    SeverityNumber[SeverityNumber["DEBUG2"] = 6] = "DEBUG2";
    SeverityNumber[SeverityNumber["DEBUG3"] = 7] = "DEBUG3";
    SeverityNumber[SeverityNumber["DEBUG4"] = 8] = "DEBUG4";
    SeverityNumber[SeverityNumber["INFO"] = 9] = "INFO";
    SeverityNumber[SeverityNumber["INFO2"] = 10] = "INFO2";
    SeverityNumber[SeverityNumber["INFO3"] = 11] = "INFO3";
    SeverityNumber[SeverityNumber["INFO4"] = 12] = "INFO4";
    SeverityNumber[SeverityNumber["WARN"] = 13] = "WARN";
    SeverityNumber[SeverityNumber["WARN2"] = 14] = "WARN2";
    SeverityNumber[SeverityNumber["WARN3"] = 15] = "WARN3";
    SeverityNumber[SeverityNumber["WARN4"] = 16] = "WARN4";
    SeverityNumber[SeverityNumber["ERROR"] = 17] = "ERROR";
    SeverityNumber[SeverityNumber["ERROR2"] = 18] = "ERROR2";
    SeverityNumber[SeverityNumber["ERROR3"] = 19] = "ERROR3";
    SeverityNumber[SeverityNumber["ERROR4"] = 20] = "ERROR4";
    SeverityNumber[SeverityNumber["FATAL"] = 21] = "FATAL";
    SeverityNumber[SeverityNumber["FATAL2"] = 22] = "FATAL2";
    SeverityNumber[SeverityNumber["FATAL3"] = 23] = "FATAL3";
    SeverityNumber[SeverityNumber["FATAL4"] = 24] = "FATAL4";
})(SeverityNumber || (SeverityNumber = {}));
//# sourceMappingURL=LogRecord.js.map

/***/ }),
/* 1884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MetricsAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__metrics_NoopMeterProvider__ = __webpack_require__(1899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__internal_global_utils__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__diag__ = __webpack_require__(257);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



var API_NAME = 'metrics';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */
var MetricsAPI = /** @class */ (function () {
    /** Empty private constructor prevents end users from constructing a new instance of the API */
    function MetricsAPI() {
    }
    /** Get the singleton instance of the Metrics API */
    MetricsAPI.getInstance = function () {
        if (!this._instance) {
            this._instance = new MetricsAPI();
        }
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */
    MetricsAPI.prototype.setGlobalMeterProvider = function (provider) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__internal_global_utils__["a" /* registerGlobal */])(API_NAME, provider, __WEBPACK_IMPORTED_MODULE_2__diag__["a" /* DiagAPI */].instance());
    };
    /**
     * Returns the global meter provider.
     */
    MetricsAPI.prototype.getMeterProvider = function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__internal_global_utils__["b" /* getGlobal */])(API_NAME) || __WEBPACK_IMPORTED_MODULE_0__metrics_NoopMeterProvider__["a" /* NOOP_METER_PROVIDER */];
    };
    /**
     * Returns a meter from the global meter provider.
     */
    MetricsAPI.prototype.getMeter = function (name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */
    MetricsAPI.prototype.disable = function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__internal_global_utils__["c" /* unregisterGlobal */])(API_NAME, __WEBPACK_IMPORTED_MODULE_2__diag__["a" /* DiagAPI */].instance());
    };
    return MetricsAPI;
}());

//# sourceMappingURL=metrics.js.map

/***/ }),
/* 1885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PropagationAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_global_utils__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__propagation_NoopTextMapPropagator__ = __webpack_require__(1903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__propagation_TextMapPropagator__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baggage_context_helpers__ = __webpack_require__(1887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baggage_utils__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__diag__ = __webpack_require__(257);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */






var API_NAME = 'propagation';
var NOOP_TEXT_MAP_PROPAGATOR = new __WEBPACK_IMPORTED_MODULE_1__propagation_NoopTextMapPropagator__["a" /* NoopTextMapPropagator */]();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */
var PropagationAPI = /** @class */ (function () {
    /** Empty private constructor prevents end users from constructing a new instance of the API */
    function PropagationAPI() {
        this.createBaggage = __WEBPACK_IMPORTED_MODULE_4__baggage_utils__["b" /* createBaggage */];
        this.getBaggage = __WEBPACK_IMPORTED_MODULE_3__baggage_context_helpers__["a" /* getBaggage */];
        this.getActiveBaggage = __WEBPACK_IMPORTED_MODULE_3__baggage_context_helpers__["b" /* getActiveBaggage */];
        this.setBaggage = __WEBPACK_IMPORTED_MODULE_3__baggage_context_helpers__["c" /* setBaggage */];
        this.deleteBaggage = __WEBPACK_IMPORTED_MODULE_3__baggage_context_helpers__["d" /* deleteBaggage */];
    }
    /** Get the singleton instance of the Propagator API */
    PropagationAPI.getInstance = function () {
        if (!this._instance) {
            this._instance = new PropagationAPI();
        }
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */
    PropagationAPI.prototype.setGlobalPropagator = function (propagator) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["a" /* registerGlobal */])(API_NAME, propagator, __WEBPACK_IMPORTED_MODULE_5__diag__["a" /* DiagAPI */].instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */
    PropagationAPI.prototype.inject = function (context, carrier, setter) {
        if (setter === void 0) { setter = __WEBPACK_IMPORTED_MODULE_2__propagation_TextMapPropagator__["b" /* defaultTextMapSetter */]; }
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */
    PropagationAPI.prototype.extract = function (context, carrier, getter) {
        if (getter === void 0) { getter = __WEBPACK_IMPORTED_MODULE_2__propagation_TextMapPropagator__["a" /* defaultTextMapGetter */]; }
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */
    PropagationAPI.prototype.fields = function () {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */
    PropagationAPI.prototype.disable = function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["c" /* unregisterGlobal */])(API_NAME, __WEBPACK_IMPORTED_MODULE_5__diag__["a" /* DiagAPI */].instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["b" /* getGlobal */])(API_NAME) || NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}());

//# sourceMappingURL=propagation.js.map

/***/ }),
/* 1886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TraceAPI; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_global_utils__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trace_ProxyTracerProvider__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__trace_spancontext_utils__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__trace_context_utils__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__diag__ = __webpack_require__(257);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var API_NAME = 'trace';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */
var TraceAPI = /** @class */ (function () {
    /** Empty private constructor prevents end users from constructing a new instance of the API */
    function TraceAPI() {
        this._proxyTracerProvider = new __WEBPACK_IMPORTED_MODULE_1__trace_ProxyTracerProvider__["a" /* ProxyTracerProvider */]();
        this.wrapSpanContext = __WEBPACK_IMPORTED_MODULE_2__trace_spancontext_utils__["d" /* wrapSpanContext */];
        this.isSpanContextValid = __WEBPACK_IMPORTED_MODULE_2__trace_spancontext_utils__["a" /* isSpanContextValid */];
        this.deleteSpan = __WEBPACK_IMPORTED_MODULE_3__trace_context_utils__["a" /* deleteSpan */];
        this.getSpan = __WEBPACK_IMPORTED_MODULE_3__trace_context_utils__["b" /* getSpan */];
        this.getActiveSpan = __WEBPACK_IMPORTED_MODULE_3__trace_context_utils__["c" /* getActiveSpan */];
        this.getSpanContext = __WEBPACK_IMPORTED_MODULE_3__trace_context_utils__["d" /* getSpanContext */];
        this.setSpan = __WEBPACK_IMPORTED_MODULE_3__trace_context_utils__["e" /* setSpan */];
        this.setSpanContext = __WEBPACK_IMPORTED_MODULE_3__trace_context_utils__["f" /* setSpanContext */];
    }
    /** Get the singleton instance of the Trace API */
    TraceAPI.getInstance = function () {
        if (!this._instance) {
            this._instance = new TraceAPI();
        }
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */
    TraceAPI.prototype.setGlobalTracerProvider = function (provider) {
        var success = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["a" /* registerGlobal */])(API_NAME, this._proxyTracerProvider, __WEBPACK_IMPORTED_MODULE_4__diag__["a" /* DiagAPI */].instance());
        if (success) {
            this._proxyTracerProvider.setDelegate(provider);
        }
        return success;
    };
    /**
     * Returns the global tracer provider.
     */
    TraceAPI.prototype.getTracerProvider = function () {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["b" /* getGlobal */])(API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */
    TraceAPI.prototype.getTracer = function (name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */
    TraceAPI.prototype.disable = function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["c" /* unregisterGlobal */])(API_NAME, __WEBPACK_IMPORTED_MODULE_4__diag__["a" /* DiagAPI */].instance());
        this._proxyTracerProvider = new __WEBPACK_IMPORTED_MODULE_1__trace_ProxyTracerProvider__["a" /* ProxyTracerProvider */]();
    };
    return TraceAPI;
}());

//# sourceMappingURL=trace.js.map

/***/ }),
/* 1887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getBaggage;
/* harmony export (immutable) */ __webpack_exports__["b"] = getActiveBaggage;
/* harmony export (immutable) */ __webpack_exports__["c"] = setBaggage;
/* harmony export (immutable) */ __webpack_exports__["d"] = deleteBaggage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_context__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_context__ = __webpack_require__(372);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * Baggage key
 */
var BAGGAGE_KEY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__context_context__["a" /* createContextKey */])('OpenTelemetry Baggage Key');
/**
 * Retrieve the current baggage from the given context
 *
 * @param {Context} Context that manage all context values
 * @returns {Baggage} Extracted baggage from the context
 */
function getBaggage(context) {
    return context.getValue(BAGGAGE_KEY) || undefined;
}
/**
 * Retrieve the current baggage from the active/current context
 *
 * @returns {Baggage} Extracted baggage from the context
 */
function getActiveBaggage() {
    return getBaggage(__WEBPACK_IMPORTED_MODULE_0__api_context__["a" /* ContextAPI */].getInstance().active());
}
/**
 * Store a baggage in the given context
 *
 * @param {Context} Context that manage all context values
 * @param {Baggage} baggage that will be set in the actual context
 */
function setBaggage(context, baggage) {
    return context.setValue(BAGGAGE_KEY, baggage);
}
/**
 * Delete the baggage stored in the given context
 *
 * @param {Context} Context that manage all context values
 */
function deleteBaggage(context) {
    return context.deleteValue(BAGGAGE_KEY);
}
//# sourceMappingURL=context-helpers.js.map

/***/ }),
/* 1888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BaggageImpl; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var BaggageImpl = /** @class */ (function () {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function (key) {
        var entry = this._entries.get(key);
        if (!entry) {
            return undefined;
        }
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function () {
        return Array.from(this._entries.entries()).map(function (_a) {
            var _b = __read(_a, 2), k = _b[0], v = _b[1];
            return [k, v];
        });
    };
    BaggageImpl.prototype.setEntry = function (key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function (key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function () {
        var e_1, _a;
        var keys = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            keys[_i] = arguments[_i];
        }
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for (var keys_1 = __values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function () {
        return new BaggageImpl();
    };
    return BaggageImpl;
}());

//# sourceMappingURL=baggage-impl.js.map

/***/ }),
/* 1889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baggageEntryMetadataSymbol; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */
var baggageEntryMetadataSymbol = Symbol('BaggageEntryMetadata');
//# sourceMappingURL=symbol.js.map

/***/ }),
/* 1890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return context; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_context__ = __webpack_require__(371);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

/** Entrypoint for context API */
var context = __WEBPACK_IMPORTED_MODULE_0__api_context__["a" /* ContextAPI */].getInstance();
//# sourceMappingURL=context-api.js.map

/***/ }),
/* 1891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoopContextManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__context__ = __webpack_require__(372);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

var NoopContextManager = /** @class */ (function () {
    function NoopContextManager() {
    }
    NoopContextManager.prototype.active = function () {
        return __WEBPACK_IMPORTED_MODULE_0__context__["b" /* ROOT_CONTEXT */];
    };
    NoopContextManager.prototype.with = function (_context, fn, thisArg) {
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        return fn.call.apply(fn, __spreadArray([thisArg], __read(args), false));
    };
    NoopContextManager.prototype.bind = function (_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function () {
        return this;
    };
    NoopContextManager.prototype.disable = function () {
        return this;
    };
    return NoopContextManager;
}());

//# sourceMappingURL=NoopContextManager.js.map

/***/ }),
/* 1892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return diag; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_diag__ = __webpack_require__(257);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

/**
 * Entrypoint for Diag API.
 * Defines Diagnostic handler used for internal diagnostic logging operations.
 * The default provides a Noop DiagLogger implementation which may be changed via the
 * diag.setLogger(logger: DiagLogger) function.
 */
var diag = __WEBPACK_IMPORTED_MODULE_0__api_diag__["a" /* DiagAPI */].instance();
//# sourceMappingURL=diag-api.js.map

/***/ }),
/* 1893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiagComponentLogger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_global_utils__ = __webpack_require__(258);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */
var DiagComponentLogger = /** @class */ (function () {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    DiagComponentLogger.prototype.debug = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return logProxy('debug', this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return logProxy('error', this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return logProxy('info', this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return logProxy('warn', this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return logProxy('verbose', this._namespace, args);
    };
    return DiagComponentLogger;
}());

function logProxy(funcName, namespace, args) {
    var logger = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_global_utils__["b" /* getGlobal */])('diag');
    // shortcut if logger not set
    if (!logger) {
        return;
    }
    args.unshift(namespace);
    return logger[funcName].apply(logger, __spreadArray([], __read(args), false));
}
//# sourceMappingURL=ComponentLogger.js.map

/***/ }),
/* 1894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DiagConsoleLogger; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var consoleMap = [
    { n: 'error', c: 'error' },
    { n: 'warn', c: 'warn' },
    { n: 'info', c: 'info' },
    { n: 'debug', c: 'debug' },
    { n: 'verbose', c: 'trace' },
];
/**
 * A simple Immutable Console based diagnostic logger which will output any messages to the Console.
 * If you want to limit the amount of logging to a specific level or lower use the
 * {@link createLogLevelDiagLogger}
 */
var DiagConsoleLogger = /** @class */ (function () {
    function DiagConsoleLogger() {
        function _consoleFunc(funcName) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (console) {
                    // Some environments only expose the console when the F12 developer console is open
                    // eslint-disable-next-line no-console
                    var theFunc = console[funcName];
                    if (typeof theFunc !== 'function') {
                        // Not all environments support all functions
                        // eslint-disable-next-line no-console
                        theFunc = console.log;
                    }
                    // One last final check
                    if (typeof theFunc === 'function') {
                        return theFunc.apply(console, args);
                    }
                }
            };
        }
        for (var i = 0; i < consoleMap.length; i++) {
            this[consoleMap[i].n] = _consoleFunc(consoleMap[i].c);
        }
    }
    return DiagConsoleLogger;
}());

//# sourceMappingURL=consoleLogger.js.map

/***/ }),
/* 1895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createLogLevelDiagLogger;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__types__ = __webpack_require__(533);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function createLogLevelDiagLogger(maxLevel, logger) {
    if (maxLevel < __WEBPACK_IMPORTED_MODULE_0__types__["a" /* DiagLogLevel */].NONE) {
        maxLevel = __WEBPACK_IMPORTED_MODULE_0__types__["a" /* DiagLogLevel */].NONE;
    }
    else if (maxLevel > __WEBPACK_IMPORTED_MODULE_0__types__["a" /* DiagLogLevel */].ALL) {
        maxLevel = __WEBPACK_IMPORTED_MODULE_0__types__["a" /* DiagLogLevel */].ALL;
    }
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) {
            return theFunc.bind(logger);
        }
        return function () { };
    }
    return {
        error: _filterFunc('error', __WEBPACK_IMPORTED_MODULE_0__types__["a" /* DiagLogLevel */].ERROR),
        warn: _filterFunc('warn', __WEBPACK_IMPORTED_MODULE_0__types__["a" /* DiagLogLevel */].WARN),
        info: _filterFunc('info', __WEBPACK_IMPORTED_MODULE_0__types__["a" /* DiagLogLevel */].INFO),
        debug: _filterFunc('debug', __WEBPACK_IMPORTED_MODULE_0__types__["a" /* DiagLogLevel */].DEBUG),
        verbose: _filterFunc('verbose', __WEBPACK_IMPORTED_MODULE_0__types__["a" /* DiagLogLevel */].VERBOSE),
    };
}
//# sourceMappingURL=logLevelLogger.js.map

/***/ }),
/* 1896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _makeCompatibilityCheck */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isCompatible; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__version__ = __webpack_require__(909);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
/**
 * Create a function to test an API version to see if it is compatible with the provided ownVersion.
 *
 * The returned function has the following semantics:
 * - Exact match is always compatible
 * - Major versions must match exactly
 *    - 1.x package cannot use global 2.x package
 *    - 2.x package cannot use global 1.x package
 * - The minor version of the API module requesting access to the global API must be less than or equal to the minor version of this API
 *    - 1.3 package may use 1.4 global because the later global contains all functions 1.3 expects
 *    - 1.4 package may NOT use 1.3 global because it may try to call functions which don't exist on 1.3
 * - If the major version is 0, the minor version is treated as the major and the patch is treated as the minor
 * - Patch and build tag differences are not considered at this time
 *
 * @param ownVersion version which should be checked against
 */
function _makeCompatibilityCheck(ownVersion) {
    var acceptedVersions = new Set([ownVersion]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match(re);
    if (!myVersionMatch) {
        // we cannot guarantee compatibility so we always return noop
        return function () { return false; };
    }
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4],
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) {
        return function isExactmatch(globalVersion) {
            return globalVersion === ownVersion;
        };
    }
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) {
            return true;
        }
        if (rejectedVersions.has(globalVersion)) {
            return false;
        }
        var globalVersionMatch = globalVersion.match(re);
        if (!globalVersionMatch) {
            // cannot parse other version
            // we cannot guarantee compatibility so we always noop
            return _reject(globalVersion);
        }
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4],
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) {
            return _reject(globalVersion);
        }
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) {
            return _reject(globalVersion);
        }
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor &&
                ownVersionParsed.patch <= globalVersionParsed.patch) {
                return _accept(globalVersion);
            }
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) {
            return _accept(globalVersion);
        }
        return _reject(globalVersion);
    };
}
/**
 * Test an API version to see if it is compatible with this API.
 *
 * - Exact match is always compatible
 * - Major versions must match exactly
 *    - 1.x package cannot use global 2.x package
 *    - 2.x package cannot use global 1.x package
 * - The minor version of the API module requesting access to the global API must be less than or equal to the minor version of this API
 *    - 1.3 package may use 1.4 global because the later global contains all functions 1.3 expects
 *    - 1.4 package may NOT use 1.3 global because it may try to call functions which don't exist on 1.3
 * - If the major version is 0, the minor version is treated as the major and the patch is treated as the minor
 * - Patch and build tag differences are not considered at this time
 *
 * @param version version of the API requesting an instance of the global API
 */
var isCompatible = _makeCompatibilityCheck(__WEBPACK_IMPORTED_MODULE_0__version__["a" /* VERSION */]);
//# sourceMappingURL=semver.js.map

/***/ }),
/* 1897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return metrics; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_metrics__ = __webpack_require__(1884);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

/** Entrypoint for metrics API */
var metrics = __WEBPACK_IMPORTED_MODULE_0__api_metrics__["a" /* MetricsAPI */].getInstance();
//# sourceMappingURL=metrics-api.js.map

/***/ }),
/* 1898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ValueType; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/** The Type of value. It describes how the data is reported. */
var ValueType;
(function (ValueType) {
    ValueType[ValueType["INT"] = 0] = "INT";
    ValueType[ValueType["DOUBLE"] = 1] = "DOUBLE";
})(ValueType || (ValueType = {}));
//# sourceMappingURL=Metric.js.map

/***/ }),
/* 1899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NoopMeterProvider */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NOOP_METER_PROVIDER; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NoopMeter__ = __webpack_require__(902);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */
var NoopMeterProvider = /** @class */ (function () {
    function NoopMeterProvider() {
    }
    NoopMeterProvider.prototype.getMeter = function (_name, _version, _options) {
        return __WEBPACK_IMPORTED_MODULE_0__NoopMeter__["b" /* NOOP_METER */];
    };
    return NoopMeterProvider;
}());

var NOOP_METER_PROVIDER = new NoopMeterProvider();
//# sourceMappingURL=NoopMeterProvider.js.map

/***/ }),
/* 1900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _globalThis; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */
/** only globals that common to node and browsers are allowed */
// eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var _globalThis = typeof globalThis === 'object'
    ? globalThis
    : typeof self === 'object'
        ? self
        : typeof window === 'object'
            ? window
            : typeof global === 'object'
                ? global
                : {};
//# sourceMappingURL=globalThis.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(56)))

/***/ }),
/* 1901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__globalThis__ = __webpack_require__(1900);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__globalThis__["a"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 1902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return propagation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_propagation__ = __webpack_require__(1885);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

/** Entrypoint for propagation API */
var propagation = __WEBPACK_IMPORTED_MODULE_0__api_propagation__["a" /* PropagationAPI */].getInstance();
//# sourceMappingURL=propagation-api.js.map

/***/ }),
/* 1903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoopTextMapPropagator; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * No-op implementations of {@link TextMapPropagator}.
 */
var NoopTextMapPropagator = /** @class */ (function () {
    function NoopTextMapPropagator() {
    }
    /** Noop inject function does nothing */
    NoopTextMapPropagator.prototype.inject = function (_context, _carrier) { };
    /** Noop extract function does nothing and returns the input context */
    NoopTextMapPropagator.prototype.extract = function (context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function () {
        return [];
    };
    return NoopTextMapPropagator;
}());

//# sourceMappingURL=NoopTextMapPropagator.js.map

/***/ }),
/* 1904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trace; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_trace__ = __webpack_require__(1886);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

/** Entrypoint for trace API */
var trace = __WEBPACK_IMPORTED_MODULE_0__api_trace__["a" /* TraceAPI */].getInstance();
//# sourceMappingURL=trace-api.js.map

/***/ }),
/* 1905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NoopTracerProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NoopTracer__ = __webpack_require__(904);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */
var NoopTracerProvider = /** @class */ (function () {
    function NoopTracerProvider() {
    }
    NoopTracerProvider.prototype.getTracer = function (_name, _version, _options) {
        return new __WEBPACK_IMPORTED_MODULE_0__NoopTracer__["a" /* NoopTracer */]();
    };
    return NoopTracerProvider;
}());

//# sourceMappingURL=NoopTracerProvider.js.map

/***/ }),
/* 1906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SamplingDecision; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @deprecated use the one declared in @opentelemetry/sdk-trace-base instead.
 * A sampling decision that determines how a {@link Span} will be recorded
 * and collected.
 */
var SamplingDecision;
(function (SamplingDecision) {
    /**
     * `Span.isRecording() === false`, span will not be recorded and all events
     * and attributes will be dropped.
     */
    SamplingDecision[SamplingDecision["NOT_RECORD"] = 0] = "NOT_RECORD";
    /**
     * `Span.isRecording() === true`, but `Sampled` flag in {@link TraceFlags}
     * MUST NOT be set.
     */
    SamplingDecision[SamplingDecision["RECORD"] = 1] = "RECORD";
    /**
     * `Span.isRecording() === true` AND `Sampled` flag in {@link TraceFlags}
     * MUST be set.
     */
    SamplingDecision[SamplingDecision["RECORD_AND_SAMPLED"] = 2] = "RECORD_AND_SAMPLED";
})(SamplingDecision || (SamplingDecision = {}));
//# sourceMappingURL=SamplingResult.js.map

/***/ }),
/* 1907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TraceStateImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tracestate_validators__ = __webpack_require__(1908);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var MAX_TRACE_STATE_ITEMS = 32;
var MAX_TRACE_STATE_LEN = 512;
var LIST_MEMBERS_SEPARATOR = ',';
var LIST_MEMBER_KEY_VALUE_SPLITTER = '=';
/**
 * TraceState must be a class and not a simple object type because of the spec
 * requirement (https://www.w3.org/TR/trace-context/#tracestate-field).
 *
 * Here is the list of allowed mutations:
 * - New key-value pair should be added into the beginning of the list
 * - The value of any key can be updated. Modified keys MUST be moved to the
 * beginning of the list.
 */
var TraceStateImpl = /** @class */ (function () {
    function TraceStateImpl(rawTraceState) {
        this._internalState = new Map();
        if (rawTraceState)
            this._parse(rawTraceState);
    }
    TraceStateImpl.prototype.set = function (key, value) {
        // TODO: Benchmark the different approaches(map vs list) and
        // use the faster one.
        var traceState = this._clone();
        if (traceState._internalState.has(key)) {
            traceState._internalState.delete(key);
        }
        traceState._internalState.set(key, value);
        return traceState;
    };
    TraceStateImpl.prototype.unset = function (key) {
        var traceState = this._clone();
        traceState._internalState.delete(key);
        return traceState;
    };
    TraceStateImpl.prototype.get = function (key) {
        return this._internalState.get(key);
    };
    TraceStateImpl.prototype.serialize = function () {
        var _this = this;
        return this._keys()
            .reduce(function (agg, key) {
            agg.push(key + LIST_MEMBER_KEY_VALUE_SPLITTER + _this.get(key));
            return agg;
        }, [])
            .join(LIST_MEMBERS_SEPARATOR);
    };
    TraceStateImpl.prototype._parse = function (rawTraceState) {
        if (rawTraceState.length > MAX_TRACE_STATE_LEN)
            return;
        this._internalState = rawTraceState
            .split(LIST_MEMBERS_SEPARATOR)
            .reverse() // Store in reverse so new keys (.set(...)) will be placed at the beginning
            .reduce(function (agg, part) {
            var listMember = part.trim(); // Optional Whitespace (OWS) handling
            var i = listMember.indexOf(LIST_MEMBER_KEY_VALUE_SPLITTER);
            if (i !== -1) {
                var key = listMember.slice(0, i);
                var value = listMember.slice(i + 1, part.length);
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tracestate_validators__["a" /* validateKey */])(key) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tracestate_validators__["b" /* validateValue */])(value)) {
                    agg.set(key, value);
                }
                else {
                    // TODO: Consider to add warning log
                }
            }
            return agg;
        }, new Map());
        // Because of the reverse() requirement, trunc must be done after map is created
        if (this._internalState.size > MAX_TRACE_STATE_ITEMS) {
            this._internalState = new Map(Array.from(this._internalState.entries())
                .reverse() // Use reverse same as original tracestate parse chain
                .slice(0, MAX_TRACE_STATE_ITEMS));
        }
    };
    TraceStateImpl.prototype._keys = function () {
        return Array.from(this._internalState.keys()).reverse();
    };
    TraceStateImpl.prototype._clone = function () {
        var traceState = new TraceStateImpl();
        traceState._internalState = new Map(this._internalState);
        return traceState;
    };
    return TraceStateImpl;
}());

//# sourceMappingURL=tracestate-impl.js.map

/***/ }),
/* 1908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = validateValue;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var VALID_KEY_CHAR_RANGE = '[_0-9a-z-*/]';
var VALID_KEY = "[a-z]" + VALID_KEY_CHAR_RANGE + "{0,255}";
var VALID_VENDOR_KEY = "[a-z0-9]" + VALID_KEY_CHAR_RANGE + "{0,240}@[a-z]" + VALID_KEY_CHAR_RANGE + "{0,13}";
var VALID_KEY_REGEX = new RegExp("^(?:" + VALID_KEY + "|" + VALID_VENDOR_KEY + ")$");
var VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
var INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
/**
 * Key is opaque string up to 256 characters printable. It MUST begin with a
 * lowercase letter, and can only contain lowercase letters a-z, digits 0-9,
 * underscores _, dashes -, asterisks *, and forward slashes /.
 * For multi-tenant vendor scenarios, an at sign (@) can be used to prefix the
 * vendor name. Vendors SHOULD set the tenant ID at the beginning of the key.
 * see https://www.w3.org/TR/trace-context/#key
 */
function validateKey(key) {
    return VALID_KEY_REGEX.test(key);
}
/**
 * Value is opaque string up to 256 characters printable ASCII RFC0020
 * characters (i.e., the range 0x20 to 0x7E) except comma , and =.
 */
function validateValue(value) {
    return (VALID_VALUE_BASE_REGEX.test(value) &&
        !INVALID_VALUE_COMMA_EQUAL_REGEX.test(value));
}
//# sourceMappingURL=tracestate-validators.js.map

/***/ }),
/* 1909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTraceState;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tracestate_impl__ = __webpack_require__(1907);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function createTraceState(rawTraceState) {
    return new __WEBPACK_IMPORTED_MODULE_0__tracestate_impl__["a" /* TraceStateImpl */](rawTraceState);
}
//# sourceMappingURL=utils.js.map

/***/ }),
/* 1910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpanKind; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SpanKind;
(function (SpanKind) {
    /** Default value. Indicates that the span is used internally. */
    SpanKind[SpanKind["INTERNAL"] = 0] = "INTERNAL";
    /**
     * Indicates that the span covers server-side handling of an RPC or other
     * remote request.
     */
    SpanKind[SpanKind["SERVER"] = 1] = "SERVER";
    /**
     * Indicates that the span covers the client-side wrapper around an RPC or
     * other remote request.
     */
    SpanKind[SpanKind["CLIENT"] = 2] = "CLIENT";
    /**
     * Indicates that the span describes producer sending a message to a
     * broker. Unlike client and server, there is no direct critical path latency
     * relationship between producer and consumer spans.
     */
    SpanKind[SpanKind["PRODUCER"] = 3] = "PRODUCER";
    /**
     * Indicates that the span describes consumer receiving a message from a
     * broker. Unlike client and server, there is no direct critical path latency
     * relationship between producer and consumer spans.
     */
    SpanKind[SpanKind["CONSUMER"] = 4] = "CONSUMER";
})(SpanKind || (SpanKind = {}));
//# sourceMappingURL=span_kind.js.map

/***/ }),
/* 1911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SpanStatusCode; });
/**
 * An enumeration of status codes.
 */
var SpanStatusCode;
(function (SpanStatusCode) {
    /**
     * The default status.
     */
    SpanStatusCode[SpanStatusCode["UNSET"] = 0] = "UNSET";
    /**
     * The operation has been validated by an Application developer or
     * Operator to have completed successfully.
     */
    SpanStatusCode[SpanStatusCode["OK"] = 1] = "OK";
    /**
     * The operation contains an error.
     */
    SpanStatusCode[SpanStatusCode["ERROR"] = 2] = "ERROR";
})(SpanStatusCode || (SpanStatusCode = {}));
//# sourceMappingURL=status.js.map

/***/ }),
/* 1912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(1913);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "getWebAutoInstrumentations", function() { return __WEBPACK_IMPORTED_MODULE_0__utils__["a"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 1913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getWebAutoInstrumentations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_instrumentation_document_load__ = __webpack_require__(1947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__opentelemetry_instrumentation_fetch__ = __webpack_require__(1954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__opentelemetry_instrumentation_user_interaction__ = __webpack_require__(1957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__opentelemetry_instrumentation_xml_http_request__ = __webpack_require__(1963);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var InstrumentationMap = {
    '@opentelemetry/instrumentation-document-load': __WEBPACK_IMPORTED_MODULE_1__opentelemetry_instrumentation_document_load__["DocumentLoadInstrumentation"],
    '@opentelemetry/instrumentation-fetch': __WEBPACK_IMPORTED_MODULE_2__opentelemetry_instrumentation_fetch__["a" /* FetchInstrumentation */],
    '@opentelemetry/instrumentation-user-interaction': __WEBPACK_IMPORTED_MODULE_3__opentelemetry_instrumentation_user_interaction__["UserInteractionInstrumentation"],
    '@opentelemetry/instrumentation-xml-http-request': __WEBPACK_IMPORTED_MODULE_4__opentelemetry_instrumentation_xml_http_request__["a" /* XMLHttpRequestInstrumentation */],
};
function getWebAutoInstrumentations(inputConfigs) {
    var _a;
    if (inputConfigs === void 0) { inputConfigs = {}; }
    for (var _i = 0, _b = Object.keys(inputConfigs); _i < _b.length; _i++) {
        var name_1 = _b[_i];
        if (!Object.prototype.hasOwnProperty.call(InstrumentationMap, name_1)) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].error("Provided instrumentation name \"" + name_1 + "\" not found");
            continue;
        }
    }
    var instrumentations = [];
    for (var _c = 0, _d = Object.keys(InstrumentationMap); _c < _d.length; _c++) {
        var name_2 = _d[_c];
        var Instance = InstrumentationMap[name_2];
        // Defaults are defined by the instrumentation itself
        var userConfig = (_a = inputConfigs[name_2]) !== null && _a !== void 0 ? _a : {};
        if (userConfig.enabled === false) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].debug("Disabling instrumentation for " + name_2);
            continue;
        }
        try {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].debug("Loading instrumentation for " + name_2);
            instrumentations.push(new Instance(userConfig));
        }
        catch (e) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].error(e);
        }
    }
    return instrumentations;
}
//# sourceMappingURL=utils.js.map

/***/ }),
/* 1914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ZoneContextManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(1916);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/// <reference types="zone.js" />


/* Key name to be used to save a context reference in Zone */
var ZONE_CONTEXT_KEY = 'OT_ZONE_CONTEXT';
/**
 * ZoneContextManager
 * This module provides an easy functionality for tracing action between asynchronous operations in web.
 * It was not possible with standard [StackContextManager]{@link https://github.com/open-telemetry/opentelemetry-js/blob/main/packages/opentelemetry-sdk-trace-web/src/StackContextManager.ts}.
 * It heavily depends on [zone.js]{@link https://www.npmjs.com/package/zone.js}.
 * It stores the information about context in zone. Each Context will have always new Zone;
 * It also supports binding a certain Span to a target that has "addEventListener" and "removeEventListener".
 * When this happens a new zone is being created and the provided Span is being assigned to this zone.
 */
var ZoneContextManager = /** @class */ (function () {
    function ZoneContextManager() {
        /**
         * whether the context manager is enabled or not
         */
        this._enabled = false;
        /**
         * Helps to create a unique name for the zones - part of zone name
         */
        this._zoneCounter = 0;
    }
    /**
     * Returns the active context from certain zone name
     * @param activeZone
     */
    ZoneContextManager.prototype._activeContextFromZone = function (activeZone) {
        return (activeZone && activeZone.get(ZONE_CONTEXT_KEY)) || __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["ROOT_CONTEXT"];
    };
    /**
     * @param context A context (span) to be executed within target function
     * @param target Function to be executed within the context
     */
    // eslint-disable-next-line @typescript-eslint/ban-types
    ZoneContextManager.prototype._bindFunction = function (context, target) {
        var manager = this;
        var contextWrapper = function () {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return manager.with(context, function () { return target.apply(_this, args); });
        };
        Object.defineProperty(contextWrapper, 'length', {
            enumerable: false,
            configurable: true,
            writable: false,
            value: target.length,
        });
        return contextWrapper;
    };
    /**
     * @param context A context (span) to be bind to target
     * @param obj target object on which the listeners will be patched
     */
    ZoneContextManager.prototype._bindListener = function (context, obj) {
        var target = obj;
        if (target.__ot_listeners !== undefined) {
            return obj;
        }
        target.__ot_listeners = {};
        if (typeof target.addEventListener === 'function') {
            target.addEventListener = this._patchAddEventListener(target, target.addEventListener, context);
        }
        if (typeof target.removeEventListener === 'function') {
            target.removeEventListener = this._patchRemoveEventListener(target, target.removeEventListener);
        }
        return obj;
    };
    /**
     * Creates a new unique zone name
     */
    ZoneContextManager.prototype._createZoneName = function () {
        this._zoneCounter++;
        var random = Math.random();
        return this._zoneCounter + "-" + random;
    };
    /**
     * Creates a new zone
     * @param zoneName zone name
     * @param context A context (span) to be bind with Zone
     */
    ZoneContextManager.prototype._createZone = function (zoneName, context) {
        var _a;
        return Zone.current.fork({
            name: zoneName,
            properties: (_a = {},
                _a[ZONE_CONTEXT_KEY] = context,
                _a),
        });
    };
    /**
     * Returns the active zone
     */
    ZoneContextManager.prototype._getActiveZone = function () {
        return Zone.current;
    };
    /**
     * Patches addEventListener method
     * @param target any target that has "addEventListener" method
     * @param original reference to the patched method
     * @param [context] context to be bind to the listener
     */
    ZoneContextManager.prototype._patchAddEventListener = function (target, original, context) {
        var contextManager = this;
        return function (event, listener, opts) {
            if (target.__ot_listeners === undefined) {
                target.__ot_listeners = {};
            }
            var listeners = target.__ot_listeners[event];
            if (listeners === undefined) {
                listeners = new WeakMap();
                target.__ot_listeners[event] = listeners;
            }
            var patchedListener = contextManager.bind(context, listener);
            // store a weak reference of the user listener to ours
            listeners.set(listener, patchedListener);
            return original.call(this, event, patchedListener, opts);
        };
    };
    /**
     * Patches removeEventListener method
     * @param target any target that has "removeEventListener" method
     * @param original reference to the patched method
     */
    ZoneContextManager.prototype._patchRemoveEventListener = function (target, original) {
        return function (event, listener) {
            if (target.__ot_listeners === undefined ||
                target.__ot_listeners[event] === undefined) {
                return original.call(this, event, listener);
            }
            var events = target.__ot_listeners[event];
            var patchedListener = events.get(listener);
            events.delete(listener);
            return original.call(this, event, patchedListener || listener);
        };
    };
    /**
     * Returns the active context
     */
    ZoneContextManager.prototype.active = function () {
        if (!this._enabled) {
            return __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["ROOT_CONTEXT"];
        }
        var activeZone = this._getActiveZone();
        var active = this._activeContextFromZone(activeZone);
        if (active) {
            return active;
        }
        return __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["ROOT_CONTEXT"];
    };
    /**
     * Binds a the certain context or the active one to the target function and then returns the target
     * @param context A context (span) to be bind to target
     * @param target a function or event emitter. When target or one of its callbacks is called,
     *  the provided context will be used as the active context for the duration of the call.
     */
    ZoneContextManager.prototype.bind = function (context, target) {
        // if no specific context to propagate is given, we use the current one
        if (context === undefined) {
            context = this.active();
        }
        if (typeof target === 'function') {
            return this._bindFunction(context, target);
        }
        else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* isListenerObject */])(target)) {
            this._bindListener(context, target);
        }
        return target;
    };
    /**
     * Disable the context manager (clears all the contexts)
     */
    ZoneContextManager.prototype.disable = function () {
        this._enabled = false;
        return this;
    };
    /**
     * Enables the context manager and creates a default(root) context
     */
    ZoneContextManager.prototype.enable = function () {
        this._enabled = true;
        return this;
    };
    /**
     * Calls the callback function [fn] with the provided [context].
     *     If [context] is undefined then it will use the active context.
     *     The context will be set as active
     * @param context A context (span) to be called with provided callback
     * @param fn Callback function
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */
    ZoneContextManager.prototype.with = function (context, fn, thisArg) {
        var args = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            args[_i - 3] = arguments[_i];
        }
        var zoneName = this._createZoneName();
        var newZone = this._createZone(zoneName, context);
        return newZone.run(fn, thisArg, args);
    };
    return ZoneContextManager;
}());

//# sourceMappingURL=ZoneContextManager.js.map

/***/ }),
/* 1915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ZoneContextManager__ = __webpack_require__(1914);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ZoneContextManager__["a"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 1916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isListenerObject;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * check if an object has addEventListener and removeEventListener functions then it will return true.
 * Generally only called with a `TargetWithEvents` but may be called with an unknown / any.
 * @param obj - The object to check.
 */
function isListenerObject(obj) {
    if (obj === void 0) { obj = {}; }
    return (typeof obj.addEventListener === 'function' &&
        typeof obj.removeEventListener === 'function');
}
//# sourceMappingURL=util.js.map

/***/ }),
/* 1917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_context_zone_peer_dep__ = __webpack_require__(1915);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ZoneContextManager", function() { return __WEBPACK_IMPORTED_MODULE_0__opentelemetry_context_zone_peer_dep__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zone_js__ = __webpack_require__(3558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_zone_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_zone_js__);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


//# sourceMappingURL=index.js.map

/***/ }),
/* 1918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExportResultCode; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var ExportResultCode;
(function (ExportResultCode) {
    ExportResultCode[ExportResultCode["SUCCESS"] = 0] = "SUCCESS";
    ExportResultCode[ExportResultCode["FAILED"] = 1] = "FAILED";
})(ExportResultCode || (ExportResultCode = {}));
//# sourceMappingURL=ExportResult.js.map

/***/ }),
/* 1919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return W3CBaggagePropagator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trace_suppress_tracing__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(911);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




/**
 * Propagates {@link Baggage} through Context format propagation.
 *
 * Based on the Baggage specification:
 * https://w3c.github.io/baggage/
 */
var W3CBaggagePropagator = /** @class */ (function () {
    function W3CBaggagePropagator() {
    }
    W3CBaggagePropagator.prototype.inject = function (context, carrier, setter) {
        var baggage = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["propagation"].getBaggage(context);
        if (!baggage || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__trace_suppress_tracing__["a" /* isTracingSuppressed */])(context))
            return;
        var keyPairs = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* getKeyPairs */])(baggage)
            .filter(function (pair) {
            return pair.length <= __WEBPACK_IMPORTED_MODULE_2__constants__["e" /* BAGGAGE_MAX_PER_NAME_VALUE_PAIRS */];
        })
            .slice(0, __WEBPACK_IMPORTED_MODULE_2__constants__["f" /* BAGGAGE_MAX_NAME_VALUE_PAIRS */]);
        var headerValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* serializeKeyPairs */])(keyPairs);
        if (headerValue.length > 0) {
            setter.set(carrier, __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* BAGGAGE_HEADER */], headerValue);
        }
    };
    W3CBaggagePropagator.prototype.extract = function (context, carrier, getter) {
        var headerValue = getter.get(carrier, __WEBPACK_IMPORTED_MODULE_2__constants__["g" /* BAGGAGE_HEADER */]);
        var baggageString = Array.isArray(headerValue)
            ? headerValue.join(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* BAGGAGE_ITEMS_SEPARATOR */])
            : headerValue;
        if (!baggageString)
            return context;
        var baggage = {};
        if (baggageString.length === 0) {
            return context;
        }
        var pairs = baggageString.split(__WEBPACK_IMPORTED_MODULE_2__constants__["a" /* BAGGAGE_ITEMS_SEPARATOR */]);
        pairs.forEach(function (entry) {
            var keyPair = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["d" /* parsePairKeyValue */])(entry);
            if (keyPair) {
                var baggageEntry = { value: keyPair.value };
                if (keyPair.metadata) {
                    baggageEntry.metadata = keyPair.metadata;
                }
                baggage[keyPair.key] = baggageEntry;
            }
        });
        if (Object.entries(baggage).length === 0) {
            return context;
        }
        return __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["propagation"].setBaggage(context, __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["propagation"].createBaggage(baggage));
    };
    W3CBaggagePropagator.prototype.fields = function () {
        return [__WEBPACK_IMPORTED_MODULE_2__constants__["g" /* BAGGAGE_HEADER */]];
    };
    return W3CBaggagePropagator;
}());

//# sourceMappingURL=W3CBaggagePropagator.js.map

/***/ }),
/* 1920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AnchoredClock; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A utility for returning wall times anchored to a given point in time. Wall time measurements will
 * not be taken from the system, but instead are computed by adding a monotonic clock time
 * to the anchor point.
 *
 * This is needed because the system time can change and result in unexpected situations like
 * spans ending before they are started. Creating an anchored clock for each local root span
 * ensures that span timings and durations are accurate while preventing span times from drifting
 * too far from the system clock.
 *
 * Only creating an anchored clock once per local trace ensures span times are correct relative
 * to each other. For example, a child span will never have a start time before its parent even
 * if the system clock is corrected during the local trace.
 *
 * Heavily inspired by the OTel Java anchored clock
 * https://github.com/open-telemetry/opentelemetry-java/blob/main/sdk/trace/src/main/java/io/opentelemetry/sdk/trace/AnchoredClock.java
 */
var AnchoredClock = /** @class */ (function () {
    /**
     * Create a new AnchoredClock anchored to the current time returned by systemClock.
     *
     * @param systemClock should be a clock that returns the number of milliseconds since January 1 1970 such as Date
     * @param monotonicClock should be a clock that counts milliseconds monotonically such as window.performance or perf_hooks.performance
     */
    function AnchoredClock(systemClock, monotonicClock) {
        this._monotonicClock = monotonicClock;
        this._epochMillis = systemClock.now();
        this._performanceMillis = monotonicClock.now();
    }
    /**
     * Returns the current time by adding the number of milliseconds since the
     * AnchoredClock was created to the creation epoch time
     */
    AnchoredClock.prototype.now = function () {
        var delta = this._monotonicClock.now() - this._performanceMillis;
        return this._epochMillis + delta;
    };
    return AnchoredClock;
}());

//# sourceMappingURL=anchored-clock.js.map

/***/ }),
/* 1921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = sanitizeAttributes;
/* harmony export (immutable) */ __webpack_exports__["a"] = isAttributeKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = isAttributeValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

function sanitizeAttributes(attributes) {
    var e_1, _a;
    var out = {};
    if (typeof attributes !== 'object' || attributes == null) {
        return out;
    }
    try {
        for (var _b = __values(Object.entries(attributes)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], val = _d[1];
            if (!isAttributeKey(key)) {
                __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn("Invalid attribute key: " + key);
                continue;
            }
            if (!isAttributeValue(val)) {
                __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn("Invalid attribute value set for key: " + key);
                continue;
            }
            if (Array.isArray(val)) {
                out[key] = val.slice();
            }
            else {
                out[key] = val;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return out;
}
function isAttributeKey(key) {
    return typeof key === 'string' && key.length > 0;
}
function isAttributeValue(val) {
    if (val == null) {
        return true;
    }
    if (Array.isArray(val)) {
        return isHomogeneousAttributeValueArray(val);
    }
    return isValidPrimitiveAttributeValue(val);
}
function isHomogeneousAttributeValueArray(arr) {
    var e_2, _a;
    var type;
    try {
        for (var arr_1 = __values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
            var element = arr_1_1.value;
            // null/undefined elements are allowed
            if (element == null)
                continue;
            if (!type) {
                if (isValidPrimitiveAttributeValue(element)) {
                    type = typeof element;
                    continue;
                }
                // encountered an invalid primitive
                return false;
            }
            if (typeof element === type) {
                continue;
            }
            return false;
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return true;
}
function isValidPrimitiveAttributeValue(val) {
    switch (typeof val) {
        case 'number':
        case 'boolean':
        case 'string':
            return true;
    }
    return false;
}
//# sourceMappingURL=attributes.js.map

/***/ }),
/* 1922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["k"] = millisToHrTime;
/* harmony export (immutable) */ __webpack_exports__["b"] = getTimeOrigin;
/* harmony export (immutable) */ __webpack_exports__["c"] = hrTime;
/* harmony export (immutable) */ __webpack_exports__["l"] = timeInputToHrTime;
/* harmony export (immutable) */ __webpack_exports__["d"] = hrTimeDuration;
/* harmony export (immutable) */ __webpack_exports__["h"] = hrTimeToTimeStamp;
/* harmony export (immutable) */ __webpack_exports__["g"] = hrTimeToNanoseconds;
/* harmony export (immutable) */ __webpack_exports__["f"] = hrTimeToMilliseconds;
/* harmony export (immutable) */ __webpack_exports__["e"] = hrTimeToMicroseconds;
/* harmony export (immutable) */ __webpack_exports__["j"] = isTimeInputHrTime;
/* harmony export (immutable) */ __webpack_exports__["i"] = isTimeInput;
/* harmony export (immutable) */ __webpack_exports__["a"] = addHrTimes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform__ = __webpack_require__(916);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var NANOSECOND_DIGITS = 9;
var NANOSECOND_DIGITS_IN_MILLIS = 6;
var MILLISECONDS_TO_NANOSECONDS = Math.pow(10, NANOSECOND_DIGITS_IN_MILLIS);
var SECOND_TO_NANOSECONDS = Math.pow(10, NANOSECOND_DIGITS);
/**
 * Converts a number of milliseconds from epoch to HrTime([seconds, remainder in nanoseconds]).
 * @param epochMillis
 */
function millisToHrTime(epochMillis) {
    var epochSeconds = epochMillis / 1000;
    // Decimals only.
    var seconds = Math.trunc(epochSeconds);
    // Round sub-nanosecond accuracy to nanosecond.
    var nanos = Math.round((epochMillis % 1000) * MILLISECONDS_TO_NANOSECONDS);
    return [seconds, nanos];
}
function getTimeOrigin() {
    var timeOrigin = __WEBPACK_IMPORTED_MODULE_0__platform__["g" /* otperformance */].timeOrigin;
    if (typeof timeOrigin !== 'number') {
        var perf = __WEBPACK_IMPORTED_MODULE_0__platform__["g" /* otperformance */];
        timeOrigin = perf.timing && perf.timing.fetchStart;
    }
    return timeOrigin;
}
/**
 * Returns an hrtime calculated via performance component.
 * @param performanceNow
 */
function hrTime(performanceNow) {
    var timeOrigin = millisToHrTime(getTimeOrigin());
    var now = millisToHrTime(typeof performanceNow === 'number' ? performanceNow : __WEBPACK_IMPORTED_MODULE_0__platform__["g" /* otperformance */].now());
    return addHrTimes(timeOrigin, now);
}
/**
 *
 * Converts a TimeInput to an HrTime, defaults to _hrtime().
 * @param time
 */
function timeInputToHrTime(time) {
    // process.hrtime
    if (isTimeInputHrTime(time)) {
        return time;
    }
    else if (typeof time === 'number') {
        // Must be a performance.now() if it's smaller than process start time.
        if (time < getTimeOrigin()) {
            return hrTime(time);
        }
        else {
            // epoch milliseconds or performance.timeOrigin
            return millisToHrTime(time);
        }
    }
    else if (time instanceof Date) {
        return millisToHrTime(time.getTime());
    }
    else {
        throw TypeError('Invalid input type');
    }
}
/**
 * Returns a duration of two hrTime.
 * @param startTime
 * @param endTime
 */
function hrTimeDuration(startTime, endTime) {
    var seconds = endTime[0] - startTime[0];
    var nanos = endTime[1] - startTime[1];
    // overflow
    if (nanos < 0) {
        seconds -= 1;
        // negate
        nanos += SECOND_TO_NANOSECONDS;
    }
    return [seconds, nanos];
}
/**
 * Convert hrTime to timestamp, for example "2019-05-14T17:00:00.000123456Z"
 * @param time
 */
function hrTimeToTimeStamp(time) {
    var precision = NANOSECOND_DIGITS;
    var tmp = "" + '0'.repeat(precision) + time[1] + "Z";
    var nanoString = tmp.substring(tmp.length - precision - 1);
    var date = new Date(time[0] * 1000).toISOString();
    return date.replace('000Z', nanoString);
}
/**
 * Convert hrTime to nanoseconds.
 * @param time
 */
function hrTimeToNanoseconds(time) {
    return time[0] * SECOND_TO_NANOSECONDS + time[1];
}
/**
 * Convert hrTime to milliseconds.
 * @param time
 */
function hrTimeToMilliseconds(time) {
    return time[0] * 1e3 + time[1] / 1e6;
}
/**
 * Convert hrTime to microseconds.
 * @param time
 */
function hrTimeToMicroseconds(time) {
    return time[0] * 1e6 + time[1] / 1e3;
}
/**
 * check if time is HrTime
 * @param value
 */
function isTimeInputHrTime(value) {
    return (Array.isArray(value) &&
        value.length === 2 &&
        typeof value[0] === 'number' &&
        typeof value[1] === 'number');
}
/**
 * check if input value is a correct types.TimeInput
 * @param value
 */
function isTimeInput(value) {
    return (isTimeInputHrTime(value) ||
        typeof value === 'number' ||
        value instanceof Date);
}
/**
 * Given 2 HrTime formatted times, return their sum as an HrTime.
 */
function addHrTimes(time1, time2) {
    var out = [time1[0] + time2[0], time1[1] + time2[1]];
    // Nanoseconds
    if (out[1] >= SECOND_TO_NANOSECONDS) {
        out[1] -= SECOND_TO_NANOSECONDS;
        out[0] += 1;
    }
    return out;
}
//# sourceMappingURL=time.js.map

/***/ }),
/* 1923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _export;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__trace_suppress_tracing__ = __webpack_require__(373);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * @internal
 * Shared functionality used by Exporters while exporting data, including suppression of Traces.
 */
function _export(exporter, arg) {
    return new Promise(function (resolve) {
        // prevent downstream exporter calls from generating spans
        __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].with(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__trace_suppress_tracing__["b" /* suppressTracing */])(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].active()), function () {
            exporter.export(arg, function (result) {
                resolve(result);
            });
        });
    });
}
//# sourceMappingURL=exporter.js.map

/***/ }),
/* 1924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = validateValue;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var VALID_KEY_CHAR_RANGE = '[_0-9a-z-*/]';
var VALID_KEY = "[a-z]" + VALID_KEY_CHAR_RANGE + "{0,255}";
var VALID_VENDOR_KEY = "[a-z0-9]" + VALID_KEY_CHAR_RANGE + "{0,240}@[a-z]" + VALID_KEY_CHAR_RANGE + "{0,13}";
var VALID_KEY_REGEX = new RegExp("^(?:" + VALID_KEY + "|" + VALID_VENDOR_KEY + ")$");
var VALID_VALUE_BASE_REGEX = /^[ -~]{0,255}[!-~]$/;
var INVALID_VALUE_COMMA_EQUAL_REGEX = /,|=/;
/**
 * Key is opaque string up to 256 characters printable. It MUST begin with a
 * lowercase letter, and can only contain lowercase letters a-z, digits 0-9,
 * underscores _, dashes -, asterisks *, and forward slashes /.
 * For multi-tenant vendor scenarios, an at sign (@) can be used to prefix the
 * vendor name. Vendors SHOULD set the tenant ID at the beginning of the key.
 * see https://www.w3.org/TR/trace-context/#key
 */
function validateKey(key) {
    return VALID_KEY_REGEX.test(key);
}
/**
 * Value is opaque string up to 256 characters printable ASCII RFC0020
 * characters (i.e., the range 0x20 to 0x7E) except comma , and =.
 */
function validateValue(value) {
    return (VALID_VALUE_BASE_REGEX.test(value) &&
        !INVALID_VALUE_COMMA_EQUAL_REGEX.test(value));
}
//# sourceMappingURL=validators.js.map

/***/ }),
/* 1925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RandomIdGenerator; });
var SPAN_ID_BYTES = 8;
var TRACE_ID_BYTES = 16;
/**
 * @deprecated Use the one defined in @opentelemetry/sdk-trace-base instead.
 */
var RandomIdGenerator = /** @class */ (function () {
    function RandomIdGenerator() {
        /**
         * Returns a random 16-byte trace ID formatted/encoded as a 32 lowercase hex
         * characters corresponding to 128 bits.
         */
        this.generateTraceId = getIdGenerator(TRACE_ID_BYTES);
        /**
         * Returns a random 8-byte span ID formatted/encoded as a 16 lowercase hex
         * characters corresponding to 64 bits.
         */
        this.generateSpanId = getIdGenerator(SPAN_ID_BYTES);
    }
    return RandomIdGenerator;
}());

var SHARED_CHAR_CODES_ARRAY = Array(32);
function getIdGenerator(bytes) {
    return function generateId() {
        for (var i = 0; i < bytes * 2; i++) {
            SHARED_CHAR_CODES_ARRAY[i] = Math.floor(Math.random() * 16) + 48;
            // valid hex characters in the range 48-57 and 97-102
            if (SHARED_CHAR_CODES_ARRAY[i] >= 58) {
                SHARED_CHAR_CODES_ARRAY[i] += 39;
            }
        }
        return String.fromCharCode.apply(null, SHARED_CHAR_CODES_ARRAY.slice(0, bytes * 2));
    };
}
//# sourceMappingURL=RandomIdGenerator.js.map

/***/ }),
/* 1926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getEnv;
/* harmony export (immutable) */ __webpack_exports__["a"] = getEnvWithoutDefaults;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_environment__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__globalThis__ = __webpack_require__(915);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * Gets the environment variables
 */
function getEnv() {
    var globalEnv = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_environment__["f" /* parseEnvironment */])(__WEBPACK_IMPORTED_MODULE_1__globalThis__["a" /* _globalThis */]);
    return Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__utils_environment__["c" /* DEFAULT_ENVIRONMENT */], globalEnv);
}
function getEnvWithoutDefaults() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_environment__["f" /* parseEnvironment */])(__WEBPACK_IMPORTED_MODULE_1__globalThis__["a" /* _globalThis */]);
}
//# sourceMappingURL=environment.js.map

/***/ }),
/* 1927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hexToBase64;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_hex_to_binary__ = __webpack_require__(913);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

function hexToBase64(hexStr) {
    return btoa(String.fromCharCode.apply(String, __spreadArray([], __read(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_hex_to_binary__["a" /* hexToBinary */])(hexStr)), false)));
}
//# sourceMappingURL=hex-to-base64.js.map

/***/ }),
/* 1928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return otperformance; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var otperformance = performance;
//# sourceMappingURL=performance.js.map

/***/ }),
/* 1929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SDK_INFO; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__version__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_semantic_conventions__ = __webpack_require__(173);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var _a;


/** Constants describing the SDK in use */
var SDK_INFO = (_a = {},
    _a[__WEBPACK_IMPORTED_MODULE_1__opentelemetry_semantic_conventions__["r" /* SEMRESATTRS_TELEMETRY_SDK_NAME */]] = 'opentelemetry',
    _a[__WEBPACK_IMPORTED_MODULE_1__opentelemetry_semantic_conventions__["n" /* SEMRESATTRS_PROCESS_RUNTIME_NAME */]] = 'browser',
    _a[__WEBPACK_IMPORTED_MODULE_1__opentelemetry_semantic_conventions__["q" /* SEMRESATTRS_TELEMETRY_SDK_LANGUAGE */]] = __WEBPACK_IMPORTED_MODULE_1__opentelemetry_semantic_conventions__["t" /* TELEMETRYSDKLANGUAGEVALUES_WEBJS */],
    _a[__WEBPACK_IMPORTED_MODULE_1__opentelemetry_semantic_conventions__["s" /* SEMRESATTRS_TELEMETRY_SDK_VERSION */]] = __WEBPACK_IMPORTED_MODULE_0__version__["a" /* VERSION */],
    _a);
//# sourceMappingURL=sdk-info.js.map

/***/ }),
/* 1930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = unrefTimer;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function unrefTimer(_timer) { }
//# sourceMappingURL=timer-util.js.map

/***/ }),
/* 1931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CompositePropagator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

/** Combines multiple propagators into a single propagator. */
var CompositePropagator = /** @class */ (function () {
    /**
     * Construct a composite propagator from a list of propagators.
     *
     * @param [config] Configuration object for composite propagator
     */
    function CompositePropagator(config) {
        if (config === void 0) { config = {}; }
        var _a;
        this._propagators = (_a = config.propagators) !== null && _a !== void 0 ? _a : [];
        this._fields = Array.from(new Set(this._propagators
            // older propagators may not have fields function, null check to be sure
            .map(function (p) { return (typeof p.fields === 'function' ? p.fields() : []); })
            .reduce(function (x, y) { return x.concat(y); }, [])));
    }
    /**
     * Run each of the configured propagators with the given context and carrier.
     * Propagators are run in the order they are configured, so if multiple
     * propagators write the same carrier key, the propagator later in the list
     * will "win".
     *
     * @param context Context to inject
     * @param carrier Carrier into which context will be injected
     */
    CompositePropagator.prototype.inject = function (context, carrier, setter) {
        var e_1, _a;
        try {
            for (var _b = __values(this._propagators), _c = _b.next(); !_c.done; _c = _b.next()) {
                var propagator = _c.value;
                try {
                    propagator.inject(context, carrier, setter);
                }
                catch (err) {
                    __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn("Failed to inject with " + propagator.constructor.name + ". Err: " + err.message);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    /**
     * Run each of the configured propagators with the given context and carrier.
     * Propagators are run in the order they are configured, so if multiple
     * propagators write the same context key, the propagator later in the list
     * will "win".
     *
     * @param context Context to add values to
     * @param carrier Carrier from which to extract context
     */
    CompositePropagator.prototype.extract = function (context, carrier, getter) {
        return this._propagators.reduce(function (ctx, propagator) {
            try {
                return propagator.extract(ctx, carrier, getter);
            }
            catch (err) {
                __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn("Failed to extract with " + propagator.constructor.name + ". Err: " + err.message);
            }
            return ctx;
        }, context);
    };
    CompositePropagator.prototype.fields = function () {
        // return a new array so our fields cannot be modified
        return this._fields.slice();
    };
    return CompositePropagator;
}());

//# sourceMappingURL=composite.js.map

/***/ }),
/* 1932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TRACE_PARENT_HEADER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TRACE_STATE_HEADER; });
/* harmony export (immutable) */ __webpack_exports__["d"] = parseTraceParent;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return W3CTraceContextPropagator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__suppress_tracing__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__TraceState__ = __webpack_require__(917);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



var TRACE_PARENT_HEADER = 'traceparent';
var TRACE_STATE_HEADER = 'tracestate';
var VERSION = '00';
var VERSION_PART = '(?!ff)[\\da-f]{2}';
var TRACE_ID_PART = '(?![0]{32})[\\da-f]{32}';
var PARENT_ID_PART = '(?![0]{16})[\\da-f]{16}';
var FLAGS_PART = '[\\da-f]{2}';
var TRACE_PARENT_REGEX = new RegExp("^\\s?(" + VERSION_PART + ")-(" + TRACE_ID_PART + ")-(" + PARENT_ID_PART + ")-(" + FLAGS_PART + ")(-.*)?\\s?$");
/**
 * Parses information from the [traceparent] span tag and converts it into {@link SpanContext}
 * @param traceParent - A meta property that comes from server.
 *     It should be dynamically generated server side to have the server's request trace Id,
 *     a parent span Id that was set on the server's request span,
 *     and the trace flags to indicate the server's sampling decision
 *     (01 = sampled, 00 = not sampled).
 *     for example: '{version}-{traceId}-{spanId}-{sampleDecision}'
 *     For more information see {@link https://www.w3.org/TR/trace-context/}
 */
function parseTraceParent(traceParent) {
    var match = TRACE_PARENT_REGEX.exec(traceParent);
    if (!match)
        return null;
    // According to the specification the implementation should be compatible
    // with future versions. If there are more parts, we only reject it if it's using version 00
    // See https://www.w3.org/TR/trace-context/#versioning-of-traceparent
    if (match[1] === '00' && match[5])
        return null;
    return {
        traceId: match[2],
        spanId: match[3],
        traceFlags: parseInt(match[4], 16),
    };
}
/**
 * Propagates {@link SpanContext} through Trace Context format propagation.
 *
 * Based on the Trace Context specification:
 * https://www.w3.org/TR/trace-context/
 */
var W3CTraceContextPropagator = /** @class */ (function () {
    function W3CTraceContextPropagator() {
    }
    W3CTraceContextPropagator.prototype.inject = function (context, carrier, setter) {
        var spanContext = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].getSpanContext(context);
        if (!spanContext ||
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__suppress_tracing__["a" /* isTracingSuppressed */])(context) ||
            !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["isSpanContextValid"])(spanContext))
            return;
        var traceParent = VERSION + "-" + spanContext.traceId + "-" + spanContext.spanId + "-0" + Number(spanContext.traceFlags || __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["TraceFlags"].NONE).toString(16);
        setter.set(carrier, TRACE_PARENT_HEADER, traceParent);
        if (spanContext.traceState) {
            setter.set(carrier, TRACE_STATE_HEADER, spanContext.traceState.serialize());
        }
    };
    W3CTraceContextPropagator.prototype.extract = function (context, carrier, getter) {
        var traceParentHeader = getter.get(carrier, TRACE_PARENT_HEADER);
        if (!traceParentHeader)
            return context;
        var traceParent = Array.isArray(traceParentHeader)
            ? traceParentHeader[0]
            : traceParentHeader;
        if (typeof traceParent !== 'string')
            return context;
        var spanContext = parseTraceParent(traceParent);
        if (!spanContext)
            return context;
        spanContext.isRemote = true;
        var traceStateHeader = getter.get(carrier, TRACE_STATE_HEADER);
        if (traceStateHeader) {
            // If more than one `tracestate` header is found, we merge them into a
            // single header.
            var state = Array.isArray(traceStateHeader)
                ? traceStateHeader.join(',')
                : traceStateHeader;
            spanContext.traceState = new __WEBPACK_IMPORTED_MODULE_2__TraceState__["a" /* TraceState */](typeof state === 'string' ? state : undefined);
        }
        return __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].setSpanContext(context, spanContext);
    };
    W3CTraceContextPropagator.prototype.fields = function () {
        return [TRACE_PARENT_HEADER, TRACE_STATE_HEADER];
    };
    return W3CTraceContextPropagator;
}());

//# sourceMappingURL=W3CTraceContextPropagator.js.map

/***/ }),
/* 1933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RPCType; });
/* harmony export (immutable) */ __webpack_exports__["d"] = setRPCMetadata;
/* harmony export (immutable) */ __webpack_exports__["b"] = deleteRPCMetadata;
/* harmony export (immutable) */ __webpack_exports__["c"] = getRPCMetadata;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var RPC_METADATA_KEY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["createContextKey"])('OpenTelemetry SDK Context Key RPC_METADATA');
var RPCType;
(function (RPCType) {
    RPCType["HTTP"] = "http";
})(RPCType || (RPCType = {}));
function setRPCMetadata(context, meta) {
    return context.setValue(RPC_METADATA_KEY, meta);
}
function deleteRPCMetadata(context) {
    return context.deleteValue(RPC_METADATA_KEY);
}
function getRPCMetadata(context) {
    return context.getValue(RPC_METADATA_KEY);
}
//# sourceMappingURL=rpc-metadata.js.map

/***/ }),
/* 1934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParentBasedSampler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_global_error_handler__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AlwaysOffSampler__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AlwaysOnSampler__ = __webpack_require__(919);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




/**
 * @deprecated Use the one defined in @opentelemetry/sdk-trace-base instead.
 * A composite sampler that either respects the parent span's sampling decision
 * or delegates to `delegateSampler` for root spans.
 */
var ParentBasedSampler = /** @class */ (function () {
    function ParentBasedSampler(config) {
        var _a, _b, _c, _d;
        this._root = config.root;
        if (!this._root) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_global_error_handler__["a" /* globalErrorHandler */])(new Error('ParentBasedSampler must have a root sampler configured'));
            this._root = new __WEBPACK_IMPORTED_MODULE_3__AlwaysOnSampler__["a" /* AlwaysOnSampler */]();
        }
        this._remoteParentSampled =
            (_a = config.remoteParentSampled) !== null && _a !== void 0 ? _a : new __WEBPACK_IMPORTED_MODULE_3__AlwaysOnSampler__["a" /* AlwaysOnSampler */]();
        this._remoteParentNotSampled =
            (_b = config.remoteParentNotSampled) !== null && _b !== void 0 ? _b : new __WEBPACK_IMPORTED_MODULE_2__AlwaysOffSampler__["a" /* AlwaysOffSampler */]();
        this._localParentSampled =
            (_c = config.localParentSampled) !== null && _c !== void 0 ? _c : new __WEBPACK_IMPORTED_MODULE_3__AlwaysOnSampler__["a" /* AlwaysOnSampler */]();
        this._localParentNotSampled =
            (_d = config.localParentNotSampled) !== null && _d !== void 0 ? _d : new __WEBPACK_IMPORTED_MODULE_2__AlwaysOffSampler__["a" /* AlwaysOffSampler */]();
    }
    ParentBasedSampler.prototype.shouldSample = function (context, traceId, spanName, spanKind, attributes, links) {
        var parentContext = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].getSpanContext(context);
        if (!parentContext || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["isSpanContextValid"])(parentContext)) {
            return this._root.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        }
        if (parentContext.isRemote) {
            if (parentContext.traceFlags & __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["TraceFlags"].SAMPLED) {
                return this._remoteParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
            }
            return this._remoteParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        }
        if (parentContext.traceFlags & __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["TraceFlags"].SAMPLED) {
            return this._localParentSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
        }
        return this._localParentNotSampled.shouldSample(context, traceId, spanName, spanKind, attributes, links);
    };
    ParentBasedSampler.prototype.toString = function () {
        return "ParentBased{root=" + this._root.toString() + ", remoteParentSampled=" + this._remoteParentSampled.toString() + ", remoteParentNotSampled=" + this._remoteParentNotSampled.toString() + ", localParentSampled=" + this._localParentSampled.toString() + ", localParentNotSampled=" + this._localParentNotSampled.toString() + "}";
    };
    return ParentBasedSampler;
}());

//# sourceMappingURL=ParentBasedSampler.js.map

/***/ }),
/* 1935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TraceIdRatioBasedSampler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @deprecated Use the one defined in @opentelemetry/sdk-trace-base instead.
 * Sampler that samples a given fraction of traces based of trace id deterministically.
 */
var TraceIdRatioBasedSampler = /** @class */ (function () {
    function TraceIdRatioBasedSampler(_ratio) {
        if (_ratio === void 0) { _ratio = 0; }
        this._ratio = _ratio;
        this._ratio = this._normalize(_ratio);
        this._upperBound = Math.floor(this._ratio * 0xffffffff);
    }
    TraceIdRatioBasedSampler.prototype.shouldSample = function (context, traceId) {
        return {
            decision: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["isValidTraceId"])(traceId) && this._accumulate(traceId) < this._upperBound
                ? __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["SamplingDecision"].RECORD_AND_SAMPLED
                : __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["SamplingDecision"].NOT_RECORD,
        };
    };
    TraceIdRatioBasedSampler.prototype.toString = function () {
        return "TraceIdRatioBased{" + this._ratio + "}";
    };
    TraceIdRatioBasedSampler.prototype._normalize = function (ratio) {
        if (typeof ratio !== 'number' || isNaN(ratio))
            return 0;
        return ratio >= 1 ? 1 : ratio <= 0 ? 0 : ratio;
    };
    TraceIdRatioBasedSampler.prototype._accumulate = function (traceId) {
        var accumulation = 0;
        for (var i = 0; i < traceId.length / 8; i++) {
            var pos = i * 8;
            var part = parseInt(traceId.slice(pos, pos + 8), 16);
            accumulation = (accumulation ^ part) >>> 0;
        }
        return accumulation;
    };
    return TraceIdRatioBasedSampler;
}());

//# sourceMappingURL=TraceIdRatioBasedSampler.js.map

/***/ }),
/* 1936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BindOnceFuture; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__promise__ = __webpack_require__(1939);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

/**
 * Bind the callback and only invoke the callback once regardless how many times `BindOnceFuture.call` is invoked.
 */
var BindOnceFuture = /** @class */ (function () {
    function BindOnceFuture(_callback, _that) {
        this._callback = _callback;
        this._that = _that;
        this._isCalled = false;
        this._deferred = new __WEBPACK_IMPORTED_MODULE_0__promise__["a" /* Deferred */]();
    }
    Object.defineProperty(BindOnceFuture.prototype, "isCalled", {
        get: function () {
            return this._isCalled;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BindOnceFuture.prototype, "promise", {
        get: function () {
            return this._deferred.promise;
        },
        enumerable: false,
        configurable: true
    });
    BindOnceFuture.prototype.call = function () {
        var _a;
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._isCalled) {
            this._isCalled = true;
            try {
                Promise.resolve((_a = this._callback).call.apply(_a, __spreadArray([this._that], __read(args), false))).then(function (val) { return _this._deferred.resolve(val); }, function (err) { return _this._deferred.reject(err); });
            }
            catch (err) {
                this._deferred.reject(err);
            }
        }
        return this._deferred.promise;
    };
    return BindOnceFuture;
}());

//# sourceMappingURL=callback.js.map

/***/ }),
/* 1937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * based on lodash in order to support esm builds without esModuleInterop.
 * lodash is using MIT License.
 **/
var objectTag = '[object Object]';
var nullTag = '[object Null]';
var undefinedTag = '[object Undefined]';
var funcProto = Function.prototype;
var funcToString = funcProto.toString;
var objectCtorString = funcToString.call(Object);
var getPrototype = overArg(Object.getPrototypeOf, Object);
var objectProto = Object.prototype;
var hasOwnProperty = objectProto.hasOwnProperty;
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
var nativeObjectToString = objectProto.toString;
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
    return function (arg) {
        return func(transform(arg));
    };
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
    if (!isObjectLike(value) || baseGetTag(value) !== objectTag) {
        return false;
    }
    var proto = getPrototype(value);
    if (proto === null) {
        return true;
    }
    var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return (typeof Ctor == 'function' &&
        Ctor instanceof Ctor &&
        funcToString.call(Ctor) === objectCtorString);
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
    if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
    }
    return symToStringTag && symToStringTag in Object(value)
        ? getRawTag(value)
        : objectToString(value);
}
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    var unmasked = false;
    try {
        value[symToStringTag] = undefined;
        unmasked = true;
    }
    catch (e) {
        // silence
    }
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) {
            value[symToStringTag] = tag;
        }
        else {
            delete value[symToStringTag];
        }
    }
    return result;
}
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
    return nativeObjectToString.call(value);
}
//# sourceMappingURL=lodash.merge.js.map

/***/ }),
/* 1938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = merge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lodash_merge__ = __webpack_require__(1937);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable @typescript-eslint/no-explicit-any */

var MAX_LEVEL = 20;
/**
 * Merges objects together
 * @param args - objects / values to be merged
 */
function merge() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var result = args.shift();
    var objects = new WeakMap();
    while (args.length > 0) {
        result = mergeTwoObjects(result, args.shift(), 0, objects);
    }
    return result;
}
function takeValue(value) {
    if (isArray(value)) {
        return value.slice();
    }
    return value;
}
/**
 * Merges two objects
 * @param one - first object
 * @param two - second object
 * @param level - current deep level
 * @param objects - objects holder that has been already referenced - to prevent
 * cyclic dependency
 */
function mergeTwoObjects(one, two, level, objects) {
    if (level === void 0) { level = 0; }
    var result;
    if (level > MAX_LEVEL) {
        return undefined;
    }
    level++;
    if (isPrimitive(one) || isPrimitive(two) || isFunction(two)) {
        result = takeValue(two);
    }
    else if (isArray(one)) {
        result = one.slice();
        if (isArray(two)) {
            for (var i = 0, j = two.length; i < j; i++) {
                result.push(takeValue(two[i]));
            }
        }
        else if (isObject(two)) {
            var keys = Object.keys(two);
            for (var i = 0, j = keys.length; i < j; i++) {
                var key = keys[i];
                result[key] = takeValue(two[key]);
            }
        }
    }
    else if (isObject(one)) {
        if (isObject(two)) {
            if (!shouldMerge(one, two)) {
                return two;
            }
            result = Object.assign({}, one);
            var keys = Object.keys(two);
            for (var i = 0, j = keys.length; i < j; i++) {
                var key = keys[i];
                var twoValue = two[key];
                if (isPrimitive(twoValue)) {
                    if (typeof twoValue === 'undefined') {
                        delete result[key];
                    }
                    else {
                        // result[key] = takeValue(twoValue);
                        result[key] = twoValue;
                    }
                }
                else {
                    var obj1 = result[key];
                    var obj2 = twoValue;
                    if (wasObjectReferenced(one, key, objects) ||
                        wasObjectReferenced(two, key, objects)) {
                        delete result[key];
                    }
                    else {
                        if (isObject(obj1) && isObject(obj2)) {
                            var arr1 = objects.get(obj1) || [];
                            var arr2 = objects.get(obj2) || [];
                            arr1.push({ obj: one, key: key });
                            arr2.push({ obj: two, key: key });
                            objects.set(obj1, arr1);
                            objects.set(obj2, arr2);
                        }
                        result[key] = mergeTwoObjects(result[key], twoValue, level, objects);
                    }
                }
            }
        }
        else {
            result = two;
        }
    }
    return result;
}
/**
 * Function to check if object has been already reference
 * @param obj
 * @param key
 * @param objects
 */
function wasObjectReferenced(obj, key, objects) {
    var arr = objects.get(obj[key]) || [];
    for (var i = 0, j = arr.length; i < j; i++) {
        var info = arr[i];
        if (info.key === key && info.obj === obj) {
            return true;
        }
    }
    return false;
}
function isArray(value) {
    return Array.isArray(value);
}
function isFunction(value) {
    return typeof value === 'function';
}
function isObject(value) {
    return (!isPrimitive(value) &&
        !isArray(value) &&
        !isFunction(value) &&
        typeof value === 'object');
}
function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean' ||
        typeof value === 'undefined' ||
        value instanceof Date ||
        value instanceof RegExp ||
        value === null);
}
function shouldMerge(one, two) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lodash_merge__["a" /* isPlainObject */])(one) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__lodash_merge__["a" /* isPlainObject */])(two)) {
        return false;
    }
    return true;
}
//# sourceMappingURL=merge.js.map

/***/ }),
/* 1939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Deferred; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this._promise = new Promise(function (resolve, reject) {
            _this._resolve = resolve;
            _this._reject = reject;
        });
    }
    Object.defineProperty(Deferred.prototype, "promise", {
        get: function () {
            return this._promise;
        },
        enumerable: false,
        configurable: true
    });
    Deferred.prototype.resolve = function (val) {
        this._resolve(val);
    };
    Deferred.prototype.reject = function (err) {
        this._reject(err);
    };
    return Deferred;
}());

//# sourceMappingURL=promise.js.map

/***/ }),
/* 1940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TimeoutError; });
/* harmony export (immutable) */ __webpack_exports__["b"] = callWithTimeout;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/**
 * Error that is thrown on timeouts.
 */
var TimeoutError = /** @class */ (function (_super) {
    __extends(TimeoutError, _super);
    function TimeoutError(message) {
        var _this = _super.call(this, message) || this;
        // manually adjust prototype to retain `instanceof` functionality when targeting ES5, see:
        // https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(_this, TimeoutError.prototype);
        return _this;
    }
    return TimeoutError;
}(Error));

/**
 * Adds a timeout to a promise and rejects if the specified timeout has elapsed. Also rejects if the specified promise
 * rejects, and resolves if the specified promise resolves.
 *
 * <p> NOTE: this operation will continue even after it throws a {@link TimeoutError}.
 *
 * @param promise promise to use with timeout.
 * @param timeout the timeout in milliseconds until the returned promise is rejected.
 */
function callWithTimeout(promise, timeout) {
    var timeoutHandle;
    var timeoutPromise = new Promise(function timeoutFunction(_resolve, reject) {
        timeoutHandle = setTimeout(function timeoutHandler() {
            reject(new TimeoutError('Operation timed out.'));
        }, timeout);
    });
    return Promise.race([promise, timeoutPromise]).then(function (result) {
        clearTimeout(timeoutHandle);
        return result;
    }, function (reason) {
        clearTimeout(timeoutHandle);
        throw reason;
    });
}
//# sourceMappingURL=timeout.js.map

/***/ }),
/* 1941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = urlMatches;
/* harmony export (immutable) */ __webpack_exports__["a"] = isUrlIgnored;
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function urlMatches(url, urlToMatch) {
    if (typeof urlToMatch === 'string') {
        return url === urlToMatch;
    }
    else {
        return !!url.match(urlToMatch);
    }
}
/**
 * Check if {@param url} should be ignored when comparing against {@param ignoredUrls}
 * @param url
 * @param ignoredUrls
 */
function isUrlIgnored(url, ignoredUrls) {
    var e_1, _a;
    if (!ignoredUrls) {
        return false;
    }
    try {
        for (var ignoredUrls_1 = __values(ignoredUrls), ignoredUrls_1_1 = ignoredUrls_1.next(); !ignoredUrls_1_1.done; ignoredUrls_1_1 = ignoredUrls_1.next()) {
            var ignoreUrl = ignoredUrls_1_1.value;
            if (urlMatches(url, ignoreUrl)) {
                return true;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (ignoredUrls_1_1 && !ignoredUrls_1_1.done && (_a = ignoredUrls_1.return)) _a.call(ignoredUrls_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return false;
}
//# sourceMappingURL=url.js.map

/***/ }),
/* 1942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isWrapped;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Checks if certain function has been already wrapped
 * @param func
 */
function isWrapped(func) {
    return (typeof func === 'function' &&
        typeof func.__original === 'function' &&
        typeof func.__unwrap === 'function' &&
        func.__wrapped === true);
}
//# sourceMappingURL=wrap.js.map

/***/ }),
/* 1943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform__ = __webpack_require__(1945);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "OTLPTraceExporter", function() { return __WEBPACK_IMPORTED_MODULE_0__platform__["a"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint no-restricted-syntax: ["warn", "ExportAllDeclaration"] --
 * TODO: Replace wildcard export with named exports before next major version
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 1944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OTLPTraceExporter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_otlp_exporter_base__ = __webpack_require__(1981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_otlp_transformer__ = __webpack_require__(1992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__opentelemetry_otlp_exporter_base_browser_http__ = __webpack_require__(1980);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();



/**
 * Collector Trace Exporter for Web
 */
var OTLPTraceExporter = /** @class */ (function (_super) {
    __extends(OTLPTraceExporter, _super);
    function OTLPTraceExporter(config) {
        if (config === void 0) { config = {}; }
        return _super.call(this, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_otlp_exporter_base_browser_http__["a" /* createLegacyOtlpBrowserExportDelegate */])(config, __WEBPACK_IMPORTED_MODULE_1__opentelemetry_otlp_transformer__["a" /* JsonTraceSerializer */], 'v1/traces', { 'Content-Type': 'application/json' })) || this;
    }
    return OTLPTraceExporter;
}(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_otlp_exporter_base__["a" /* OTLPExporterBase */]));

//# sourceMappingURL=OTLPTraceExporter.js.map

/***/ }),
/* 1945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OTLPTraceExporter__ = __webpack_require__(1944);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__OTLPTraceExporter__["a"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint no-restricted-syntax: ["warn", "ExportAllDeclaration"] --
 * TODO: Replace wildcard export with named exports before next major version
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 1946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventNames; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var EventNames;
(function (EventNames) {
    EventNames["FIRST_PAINT"] = "firstPaint";
    EventNames["FIRST_CONTENTFUL_PAINT"] = "firstContentfulPaint";
})(EventNames || (EventNames = {}));
//# sourceMappingURL=EventNames.js.map

/***/ }),
/* 1947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instrumentation__ = __webpack_require__(1948);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "DocumentLoadInstrumentation", function() { return __WEBPACK_IMPORTED_MODULE_0__instrumentation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums_AttributeNames__ = __webpack_require__(923);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__types__ = __webpack_require__(1949);
/* unused harmony namespace reexport */
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



//# sourceMappingURL=index.js.map

/***/ }),
/* 1948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DocumentLoadInstrumentation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__opentelemetry_instrumentation__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums_AttributeNames__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__version__ = __webpack_require__(1951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__opentelemetry_semantic_conventions__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(1950);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();





/** @knipignore */



/**
 * This class represents a document load plugin
 */
var DocumentLoadInstrumentation = /** @class */ (function (_super) {
    __extends(DocumentLoadInstrumentation, _super);
    function DocumentLoadInstrumentation(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this, __WEBPACK_IMPORTED_MODULE_5__version__["a" /* PACKAGE_NAME */], __WEBPACK_IMPORTED_MODULE_5__version__["b" /* PACKAGE_VERSION */], config) || this;
        _this.component = 'document-load';
        _this.version = '1';
        _this.moduleName = _this.component;
        return _this;
    }
    DocumentLoadInstrumentation.prototype.init = function () { };
    /**
     * callback to be executed when page is loaded
     */
    DocumentLoadInstrumentation.prototype._onDocumentLoaded = function () {
        var _this = this;
        // Timeout is needed as load event doesn't have yet the performance metrics for loadEnd.
        // Support for event "loadend" is very limited and cannot be used
        window.setTimeout(function () {
            _this._collectPerformance();
        });
    };
    /**
     * Adds spans for all resources
     * @param rootSpan
     */
    DocumentLoadInstrumentation.prototype._addResourcesSpans = function (rootSpan) {
        var _this = this;
        var _a, _b;
        var resources = (_b = (_a = __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["otperformance"]).getEntriesByType) === null || _b === void 0 ? void 0 : _b.call(_a, 'resource');
        if (resources) {
            resources.forEach(function (resource) {
                _this._initResourceSpan(resource, rootSpan);
            });
        }
    };
    /**
     * Collects information about performance and creates appropriate spans
     */
    DocumentLoadInstrumentation.prototype._collectPerformance = function () {
        var _this = this;
        var metaElement = Array.from(document.getElementsByTagName('meta')).find(function (e) { return e.getAttribute('name') === __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["TRACE_PARENT_HEADER"]; });
        var entries = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["a" /* getPerformanceNavigationEntries */])();
        var traceparent = (metaElement && metaElement.content) || '';
        __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].with(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["propagation"].extract(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["ROOT_CONTEXT"], { traceparent: traceparent }), function () {
            var _a;
            var rootSpan = _this._startSpan(__WEBPACK_IMPORTED_MODULE_4__enums_AttributeNames__["a" /* AttributeNames */].DOCUMENT_LOAD, __WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].FETCH_START, entries);
            if (!rootSpan) {
                return;
            }
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].with(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].setSpan(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].active(), rootSpan), function () {
                var fetchSpan = _this._startSpan(__WEBPACK_IMPORTED_MODULE_4__enums_AttributeNames__["a" /* AttributeNames */].DOCUMENT_FETCH, __WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].FETCH_START, entries);
                if (fetchSpan) {
                    fetchSpan.setAttribute(__WEBPACK_IMPORTED_MODULE_6__opentelemetry_semantic_conventions__["f" /* SEMATTRS_HTTP_URL */], location.href);
                    __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].with(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].setSpan(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].active(), fetchSpan), function () {
                        var _a;
                        if (!_this.getConfig().ignoreNetworkEvents) {
                            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["addSpanNetworkEvents"])(fetchSpan, entries);
                        }
                        _this._addCustomAttributesOnSpan(fetchSpan, (_a = _this.getConfig().applyCustomAttributesOnSpan) === null || _a === void 0 ? void 0 : _a.documentFetch);
                        _this._endSpan(fetchSpan, __WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].RESPONSE_END, entries);
                    });
                }
            });
            rootSpan.setAttribute(__WEBPACK_IMPORTED_MODULE_6__opentelemetry_semantic_conventions__["f" /* SEMATTRS_HTTP_URL */], location.href);
            rootSpan.setAttribute(__WEBPACK_IMPORTED_MODULE_6__opentelemetry_semantic_conventions__["d" /* SEMATTRS_HTTP_USER_AGENT */], navigator.userAgent);
            _this._addResourcesSpans(rootSpan);
            if (!_this.getConfig().ignoreNetworkEvents) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["addSpanNetworkEvent"])(rootSpan, __WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].FETCH_START, entries);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["addSpanNetworkEvent"])(rootSpan, __WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].UNLOAD_EVENT_START, entries);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["addSpanNetworkEvent"])(rootSpan, __WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].UNLOAD_EVENT_END, entries);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["addSpanNetworkEvent"])(rootSpan, __WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].DOM_INTERACTIVE, entries);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["addSpanNetworkEvent"])(rootSpan, __WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].DOM_CONTENT_LOADED_EVENT_START, entries);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["addSpanNetworkEvent"])(rootSpan, __WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].DOM_CONTENT_LOADED_EVENT_END, entries);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["addSpanNetworkEvent"])(rootSpan, __WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].DOM_COMPLETE, entries);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["addSpanNetworkEvent"])(rootSpan, __WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].LOAD_EVENT_START, entries);
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["addSpanNetworkEvent"])(rootSpan, __WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].LOAD_EVENT_END, entries);
            }
            if (!_this.getConfig().ignorePerformancePaintEvents) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils__["b" /* addSpanPerformancePaintEvents */])(rootSpan);
            }
            _this._addCustomAttributesOnSpan(rootSpan, (_a = _this.getConfig().applyCustomAttributesOnSpan) === null || _a === void 0 ? void 0 : _a.documentLoad);
            _this._endSpan(rootSpan, __WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].LOAD_EVENT_END, entries);
        });
    };
    /**
     * Helper function for ending span
     * @param span
     * @param performanceName name of performance entry for time end
     * @param entries
     */
    DocumentLoadInstrumentation.prototype._endSpan = function (span, performanceName, entries) {
        // span can be undefined when entries are missing the certain performance - the span will not be created
        if (span) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["hasKey"])(entries, performanceName)) {
                span.end(entries[performanceName]);
            }
            else {
                // just end span
                span.end();
            }
        }
    };
    /**
     * Creates and ends a span with network information about resource added as timed events
     * @param resource
     * @param parentSpan
     */
    DocumentLoadInstrumentation.prototype._initResourceSpan = function (resource, parentSpan) {
        var _a;
        var span = this._startSpan(__WEBPACK_IMPORTED_MODULE_4__enums_AttributeNames__["a" /* AttributeNames */].RESOURCE_FETCH, __WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].FETCH_START, resource, parentSpan);
        if (span) {
            span.setAttribute(__WEBPACK_IMPORTED_MODULE_6__opentelemetry_semantic_conventions__["f" /* SEMATTRS_HTTP_URL */], resource.name);
            if (!this.getConfig().ignoreNetworkEvents) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["addSpanNetworkEvents"])(span, resource);
            }
            this._addCustomAttributesOnResourceSpan(span, resource, (_a = this.getConfig().applyCustomAttributesOnSpan) === null || _a === void 0 ? void 0 : _a.resourceFetch);
            this._endSpan(span, __WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].RESPONSE_END, resource);
        }
    };
    /**
     * Helper function for starting a span
     * @param spanName name of span
     * @param performanceName name of performance entry for time start
     * @param entries
     * @param parentSpan
     */
    DocumentLoadInstrumentation.prototype._startSpan = function (spanName, performanceName, entries, parentSpan) {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_sdk_trace_web__["hasKey"])(entries, performanceName) &&
            typeof entries[performanceName] === 'number') {
            var span = this.tracer.startSpan(spanName, {
                startTime: entries[performanceName],
            }, parentSpan ? __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].setSpan(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].active(), parentSpan) : undefined);
            return span;
        }
        return undefined;
    };
    /**
     * executes callback {_onDocumentLoaded} when the page is loaded
     */
    DocumentLoadInstrumentation.prototype._waitForPageLoad = function () {
        if (window.document.readyState === 'complete') {
            this._onDocumentLoaded();
        }
        else {
            this._onDocumentLoaded = this._onDocumentLoaded.bind(this);
            window.addEventListener('load', this._onDocumentLoaded);
        }
    };
    /**
     * adds custom attributes to root span if configured
     */
    DocumentLoadInstrumentation.prototype._addCustomAttributesOnSpan = function (span, applyCustomAttributesOnSpan) {
        var _this = this;
        if (applyCustomAttributesOnSpan) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__opentelemetry_instrumentation__["safeExecuteInTheMiddle"])(function () { return applyCustomAttributesOnSpan(span); }, function (error) {
                if (!error) {
                    return;
                }
                _this._diag.error('addCustomAttributesOnSpan', error);
            }, true);
        }
    };
    /**
     * adds custom attributes to span if configured
     */
    DocumentLoadInstrumentation.prototype._addCustomAttributesOnResourceSpan = function (span, resource, applyCustomAttributesOnSpan) {
        var _this = this;
        if (applyCustomAttributesOnSpan) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__opentelemetry_instrumentation__["safeExecuteInTheMiddle"])(function () { return applyCustomAttributesOnSpan(span, resource); }, function (error) {
                if (!error) {
                    return;
                }
                _this._diag.error('addCustomAttributesOnResourceSpan', error);
            }, true);
        }
    };
    /**
     * implements enable function
     */
    DocumentLoadInstrumentation.prototype.enable = function () {
        // remove previously attached load to avoid adding the same event twice
        // in case of multiple enable calling.
        window.removeEventListener('load', this._onDocumentLoaded);
        this._waitForPageLoad();
    };
    /**
     * implements disable function
     */
    DocumentLoadInstrumentation.prototype.disable = function () {
        window.removeEventListener('load', this._onDocumentLoaded);
    };
    return DocumentLoadInstrumentation;
}(__WEBPACK_IMPORTED_MODULE_3__opentelemetry_instrumentation__["InstrumentationBase"]));

//# sourceMappingURL=instrumentation.js.map

/***/ }),
/* 1949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

//# sourceMappingURL=types.js.map

/***/ }),
/* 1950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPerformanceNavigationEntries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addSpanPerformancePaintEvents; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_sdk_trace_web__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums_EventNames__ = __webpack_require__(1946);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



var getPerformanceNavigationEntries = function () {
    var _a, _b;
    var entries = {};
    var performanceNavigationTiming = (_b = (_a = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["otperformance"]).getEntriesByType) === null || _b === void 0 ? void 0 : _b.call(_a, 'navigation')[0];
    if (performanceNavigationTiming) {
        var keys = Object.values(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_sdk_trace_web__["PerformanceTimingNames"]);
        keys.forEach(function (key) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_sdk_trace_web__["hasKey"])(performanceNavigationTiming, key)) {
                var value = performanceNavigationTiming[key];
                if (typeof value === 'number') {
                    entries[key] = value;
                }
            }
        });
    }
    else {
        // // fallback to previous version
        var perf = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["otperformance"];
        var performanceTiming_1 = perf.timing;
        if (performanceTiming_1) {
            var keys = Object.values(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_sdk_trace_web__["PerformanceTimingNames"]);
            keys.forEach(function (key) {
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_sdk_trace_web__["hasKey"])(performanceTiming_1, key)) {
                    var value = performanceTiming_1[key];
                    if (typeof value === 'number') {
                        entries[key] = value;
                    }
                }
            });
        }
    }
    return entries;
};
var performancePaintNames = {
    'first-paint': __WEBPACK_IMPORTED_MODULE_2__enums_EventNames__["a" /* EventNames */].FIRST_PAINT,
    'first-contentful-paint': __WEBPACK_IMPORTED_MODULE_2__enums_EventNames__["a" /* EventNames */].FIRST_CONTENTFUL_PAINT,
};
var addSpanPerformancePaintEvents = function (span) {
    var _a, _b;
    var performancePaintTiming = (_b = (_a = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["otperformance"]).getEntriesByType) === null || _b === void 0 ? void 0 : _b.call(_a, 'paint');
    if (performancePaintTiming) {
        performancePaintTiming.forEach(function (_a) {
            var name = _a.name, startTime = _a.startTime;
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_sdk_trace_web__["hasKey"])(performancePaintNames, name)) {
                span.addEvent(performancePaintNames[name], startTime);
            }
        });
    }
};
//# sourceMappingURL=utils.js.map

/***/ }),
/* 1951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PACKAGE_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PACKAGE_NAME; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// this is autogenerated file, see scripts/version-update.js
var PACKAGE_VERSION = '0.44.1';
var PACKAGE_NAME = '@opentelemetry/instrumentation-document-load';
//# sourceMappingURL=version.js.map

/***/ }),
/* 1952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttributeNames; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * https://github.com/open-telemetry/opentelemetry-specification/blob/master/specification/trace/semantic_conventions/http.md
 */
var AttributeNames;
(function (AttributeNames) {
    AttributeNames["COMPONENT"] = "component";
    AttributeNames["HTTP_ERROR_NAME"] = "http.error_name";
    AttributeNames["HTTP_STATUS_TEXT"] = "http.status_text";
})(AttributeNames || (AttributeNames = {}));
//# sourceMappingURL=AttributeNames.js.map

/***/ }),
/* 1953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FetchInstrumentation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_instrumentation__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__opentelemetry_sdk_trace_web__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums_AttributeNames__ = __webpack_require__(1952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__opentelemetry_semantic_conventions__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__version__ = __webpack_require__(1956);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;









// how long to wait for observer to collect information about resources
// this is needed as event "load" is called before observer
// hard to say how long it should really wait, seems like 300ms is
// safe enough
var OBSERVER_WAIT_TIME_MS = 300;
var isNode = typeof process === 'object' && ((_a = process.release) === null || _a === void 0 ? void 0 : _a.name) === 'node';
/**
 * This class represents a fetch plugin for auto instrumentation
 */
var FetchInstrumentation = /** @class */ (function (_super) {
    __extends(FetchInstrumentation, _super);
    function FetchInstrumentation(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this, '@opentelemetry/instrumentation-fetch', __WEBPACK_IMPORTED_MODULE_7__version__["a" /* VERSION */], config) || this;
        _this.component = 'fetch';
        _this.version = __WEBPACK_IMPORTED_MODULE_7__version__["a" /* VERSION */];
        _this.moduleName = _this.component;
        _this._usedResources = new WeakSet();
        _this._tasksCount = 0;
        return _this;
    }
    FetchInstrumentation.prototype.init = function () { };
    /**
     * Add cors pre flight child span
     * @param span
     * @param corsPreFlightRequest
     */
    FetchInstrumentation.prototype._addChildSpan = function (span, corsPreFlightRequest) {
        var childSpan = this.tracer.startSpan('CORS Preflight', {
            startTime: corsPreFlightRequest[__WEBPACK_IMPORTED_MODULE_3__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].FETCH_START],
        }, __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].setSpan(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].active(), span));
        __WEBPACK_IMPORTED_MODULE_3__opentelemetry_sdk_trace_web__["addSpanNetworkEvents"](childSpan, corsPreFlightRequest, this.getConfig().ignoreNetworkEvents);
        childSpan.end(corsPreFlightRequest[__WEBPACK_IMPORTED_MODULE_3__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].RESPONSE_END]);
    };
    /**
     * Adds more attributes to span just before ending it
     * @param span
     * @param response
     */
    FetchInstrumentation.prototype._addFinalSpanAttributes = function (span, response) {
        var parsedUrl = __WEBPACK_IMPORTED_MODULE_3__opentelemetry_sdk_trace_web__["parseUrl"](response.url);
        span.setAttribute(__WEBPACK_IMPORTED_MODULE_5__opentelemetry_semantic_conventions__["a" /* SEMATTRS_HTTP_STATUS_CODE */], response.status);
        if (response.statusText != null) {
            span.setAttribute(__WEBPACK_IMPORTED_MODULE_4__enums_AttributeNames__["a" /* AttributeNames */].HTTP_STATUS_TEXT, response.statusText);
        }
        span.setAttribute(__WEBPACK_IMPORTED_MODULE_5__opentelemetry_semantic_conventions__["b" /* SEMATTRS_HTTP_HOST */], parsedUrl.host);
        span.setAttribute(__WEBPACK_IMPORTED_MODULE_5__opentelemetry_semantic_conventions__["c" /* SEMATTRS_HTTP_SCHEME */], parsedUrl.protocol.replace(':', ''));
        if (typeof navigator !== 'undefined') {
            span.setAttribute(__WEBPACK_IMPORTED_MODULE_5__opentelemetry_semantic_conventions__["d" /* SEMATTRS_HTTP_USER_AGENT */], navigator.userAgent);
        }
    };
    /**
     * Add headers
     * @param options
     * @param spanUrl
     */
    FetchInstrumentation.prototype._addHeaders = function (options, spanUrl) {
        if (!__WEBPACK_IMPORTED_MODULE_3__opentelemetry_sdk_trace_web__["shouldPropagateTraceHeaders"](spanUrl, this.getConfig().propagateTraceHeaderCorsUrls)) {
            var headers = {};
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["propagation"].inject(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].active(), headers);
            if (Object.keys(headers).length > 0) {
                this._diag.debug('headers inject skipped due to CORS policy');
            }
            return;
        }
        if (options instanceof Request) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["propagation"].inject(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].active(), options.headers, {
                set: function (h, k, v) { return h.set(k, typeof v === 'string' ? v : String(v)); },
            });
        }
        else if (options.headers instanceof Headers) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["propagation"].inject(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].active(), options.headers, {
                set: function (h, k, v) { return h.set(k, typeof v === 'string' ? v : String(v)); },
            });
        }
        else if (options.headers instanceof Map) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["propagation"].inject(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].active(), options.headers, {
                set: function (h, k, v) { return h.set(k, typeof v === 'string' ? v : String(v)); },
            });
        }
        else {
            var headers = {};
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["propagation"].inject(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].active(), headers);
            options.headers = Object.assign({}, headers, options.headers || {});
        }
    };
    /**
     * Clears the resource timings and all resources assigned with spans
     *     when {@link FetchPluginConfig.clearTimingResources} is
     *     set to true (default false)
     * @private
     */
    FetchInstrumentation.prototype._clearResources = function () {
        if (this._tasksCount === 0 && this.getConfig().clearTimingResources) {
            performance.clearResourceTimings();
            this._usedResources = new WeakSet();
        }
    };
    /**
     * Creates a new span
     * @param url
     * @param options
     */
    FetchInstrumentation.prototype._createSpan = function (url, options) {
        var _a;
        if (options === void 0) { options = {}; }
        if (__WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__["isUrlIgnored"](url, this.getConfig().ignoreUrls)) {
            this._diag.debug('ignoring span as url matches ignored url');
            return;
        }
        var method = (options.method || 'GET').toUpperCase();
        var spanName = "HTTP " + method;
        return this.tracer.startSpan(spanName, {
            kind: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["SpanKind"].CLIENT,
            attributes: (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_4__enums_AttributeNames__["a" /* AttributeNames */].COMPONENT] = this.moduleName,
                _a[__WEBPACK_IMPORTED_MODULE_5__opentelemetry_semantic_conventions__["e" /* SEMATTRS_HTTP_METHOD */]] = method,
                _a[__WEBPACK_IMPORTED_MODULE_5__opentelemetry_semantic_conventions__["f" /* SEMATTRS_HTTP_URL */]] = url,
                _a),
        });
    };
    /**
     * Finds appropriate resource and add network events to the span
     * @param span
     * @param resourcesObserver
     * @param endTime
     */
    FetchInstrumentation.prototype._findResourceAndAddNetworkEvents = function (span, resourcesObserver, endTime) {
        var resources = resourcesObserver.entries;
        if (!resources.length) {
            if (!performance.getEntriesByType) {
                return;
            }
            // fallback - either Observer is not available or it took longer
            // then OBSERVER_WAIT_TIME_MS and observer didn't collect enough
            // information
            resources = performance.getEntriesByType('resource');
        }
        var resource = __WEBPACK_IMPORTED_MODULE_3__opentelemetry_sdk_trace_web__["getResource"](resourcesObserver.spanUrl, resourcesObserver.startTime, endTime, resources, this._usedResources, 'fetch');
        if (resource.mainRequest) {
            var mainRequest = resource.mainRequest;
            this._markResourceAsUsed(mainRequest);
            var corsPreFlightRequest = resource.corsPreFlightRequest;
            if (corsPreFlightRequest) {
                this._addChildSpan(span, corsPreFlightRequest);
                this._markResourceAsUsed(corsPreFlightRequest);
            }
            __WEBPACK_IMPORTED_MODULE_3__opentelemetry_sdk_trace_web__["addSpanNetworkEvents"](span, mainRequest, this.getConfig().ignoreNetworkEvents);
        }
    };
    /**
     * Marks certain [resource]{@link PerformanceResourceTiming} when information
     * from this is used to add events to span.
     * This is done to avoid reusing the same resource again for next span
     * @param resource
     */
    FetchInstrumentation.prototype._markResourceAsUsed = function (resource) {
        this._usedResources.add(resource);
    };
    /**
     * Finish span, add attributes, network events etc.
     * @param span
     * @param spanData
     * @param response
     */
    FetchInstrumentation.prototype._endSpan = function (span, spanData, response) {
        var _this = this;
        var endTime = __WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__["millisToHrTime"](Date.now());
        var performanceEndTime = __WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__["hrTime"]();
        this._addFinalSpanAttributes(span, response);
        setTimeout(function () {
            var _a;
            (_a = spanData.observer) === null || _a === void 0 ? void 0 : _a.disconnect();
            _this._findResourceAndAddNetworkEvents(span, spanData, performanceEndTime);
            _this._tasksCount--;
            _this._clearResources();
            span.end(endTime);
        }, OBSERVER_WAIT_TIME_MS);
    };
    /**
     * Patches the constructor of fetch
     */
    FetchInstrumentation.prototype._patchConstructor = function () {
        var _this = this;
        return function (original) {
            var plugin = _this;
            return function patchConstructor() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var self = this;
                var url = __WEBPACK_IMPORTED_MODULE_3__opentelemetry_sdk_trace_web__["parseUrl"](args[0] instanceof Request ? args[0].url : String(args[0])).href;
                var options = args[0] instanceof Request ? args[0] : args[1] || {};
                var createdSpan = plugin._createSpan(url, options);
                if (!createdSpan) {
                    return original.apply(this, args);
                }
                var spanData = plugin._prepareSpanData(url);
                if (plugin.getConfig().measureRequestSize) {
                    __WEBPACK_IMPORTED_MODULE_6__utils__["a" /* getFetchBodyLength */].apply(void 0, __spreadArray([], __read(args), false)).then(function (length) {
                        if (!length)
                            return;
                        createdSpan.setAttribute(__WEBPACK_IMPORTED_MODULE_5__opentelemetry_semantic_conventions__["g" /* SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED */], length);
                    })
                        .catch(function (error) {
                        plugin._diag.warn('getFetchBodyLength', error);
                    });
                }
                function endSpanOnError(span, error) {
                    plugin._applyAttributesAfterFetch(span, options, error);
                    plugin._endSpan(span, spanData, {
                        status: error.status || 0,
                        statusText: error.message,
                        url: url,
                    });
                }
                function endSpanOnSuccess(span, response) {
                    plugin._applyAttributesAfterFetch(span, options, response);
                    if (response.status >= 200 && response.status < 400) {
                        plugin._endSpan(span, spanData, response);
                    }
                    else {
                        plugin._endSpan(span, spanData, {
                            status: response.status,
                            statusText: response.statusText,
                            url: url,
                        });
                    }
                }
                function onSuccess(span, resolve, response) {
                    try {
                        var resClone = response.clone();
                        var resClone4Hook_1 = response.clone();
                        var body = resClone.body;
                        if (body) {
                            var reader_1 = body.getReader();
                            var read_1 = function () {
                                reader_1.read().then(function (_a) {
                                    var done = _a.done;
                                    if (done) {
                                        endSpanOnSuccess(span, resClone4Hook_1);
                                    }
                                    else {
                                        read_1();
                                    }
                                }, function (error) {
                                    endSpanOnError(span, error);
                                });
                            };
                            read_1();
                        }
                        else {
                            // some older browsers don't have .body implemented
                            endSpanOnSuccess(span, response);
                        }
                    }
                    finally {
                        resolve(response);
                    }
                }
                function onError(span, reject, error) {
                    try {
                        endSpanOnError(span, error);
                    }
                    finally {
                        reject(error);
                    }
                }
                return new Promise(function (resolve, reject) {
                    return __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].with(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].setSpan(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].active(), createdSpan), function () {
                        plugin._addHeaders(options, url);
                        plugin._tasksCount++;
                        // TypeScript complains about arrow function captured a this typed as globalThis
                        // ts(7041)
                        return original
                            .apply(self, options instanceof Request ? [options] : [url, options])
                            .then(onSuccess.bind(self, createdSpan, resolve), onError.bind(self, createdSpan, reject));
                    });
                });
            };
        };
    };
    FetchInstrumentation.prototype._applyAttributesAfterFetch = function (span, request, result) {
        var _this = this;
        var applyCustomAttributesOnSpan = this.getConfig().applyCustomAttributesOnSpan;
        if (applyCustomAttributesOnSpan) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_instrumentation__["safeExecuteInTheMiddle"])(function () { return applyCustomAttributesOnSpan(span, request, result); }, function (error) {
                if (!error) {
                    return;
                }
                _this._diag.error('applyCustomAttributesOnSpan', error);
            }, true);
        }
    };
    /**
     * Prepares a span data - needed later for matching appropriate network
     *     resources
     * @param spanUrl
     */
    FetchInstrumentation.prototype._prepareSpanData = function (spanUrl) {
        var startTime = __WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__["hrTime"]();
        var entries = [];
        if (typeof PerformanceObserver !== 'function') {
            return { entries: entries, startTime: startTime, spanUrl: spanUrl };
        }
        var observer = new PerformanceObserver(function (list) {
            var perfObsEntries = list.getEntries();
            perfObsEntries.forEach(function (entry) {
                if (entry.initiatorType === 'fetch' && entry.name === spanUrl) {
                    entries.push(entry);
                }
            });
        });
        observer.observe({
            entryTypes: ['resource'],
        });
        return { entries: entries, observer: observer, startTime: startTime, spanUrl: spanUrl };
    };
    /**
     * implements enable function
     */
    FetchInstrumentation.prototype.enable = function () {
        if (isNode) {
            // Node.js v18+ *does* have a global `fetch()`, but this package does not
            // support instrumenting it.
            this._diag.warn("this instrumentation is intended for web usage only, it does not instrument Node.js's fetch()");
            return;
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_instrumentation__["isWrapped"])(fetch)) {
            this._unwrap(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__["_globalThis"], 'fetch');
            this._diag.debug('removing previous patch for constructor');
        }
        this._wrap(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__["_globalThis"], 'fetch', this._patchConstructor());
    };
    /**
     * implements unpatch function
     */
    FetchInstrumentation.prototype.disable = function () {
        if (isNode) {
            return;
        }
        this._unwrap(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__["_globalThis"], 'fetch');
        this._usedResources = new WeakSet();
    };
    return FetchInstrumentation;
}(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_instrumentation__["InstrumentationBase"]));

//# sourceMappingURL=fetch.js.map
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(90)))

/***/ }),
/* 1954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fetch__ = __webpack_require__(1953);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__fetch__["a"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 1955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFetchBodyLength;
/* unused harmony export getXHRBodyLength */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
// Much of the logic here overlaps with the same utils file in opentelemetry-instrumentation-xml-http-request
// These may be unified in the future.

var DIAG_LOGGER = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].createComponentLogger({
    namespace: '@opentelemetry/opentelemetry-instrumentation-fetch/utils',
});
/**
 * Helper function to determine payload content length for fetch requests
 *
 * The fetch API is kinda messy: there are a couple of ways the body can be passed in.
 *
 * In all cases, the body param can be some variation of ReadableStream,
 * and ReadableStreams can only be read once! We want to avoid consuming the body here,
 * because that would mean that the body never gets sent with the actual fetch request.
 *
 * Either the first arg is a Request object, which can be cloned
 *   so we can clone that object and read the body of the clone
 *   without disturbing the original argument
 *   However, reading the body here can only be done async; the body() method returns a promise
 *   this means this entire function has to return a promise
 *
 * OR the first arg is a url/string
 *   in which case the second arg has type RequestInit
 *   RequestInit is NOT cloneable, but RequestInit.body is writable
 *   so we can chain it into ReadableStream.pipeThrough()
 *
 *   ReadableStream.pipeThrough() lets us process a stream and returns a new stream
 *   So we can measure the body length as it passes through the pie, but need to attach
 *   the new stream to the original request
 *   so that the browser still has access to the body.
 *
 * @param body
 * @returns promise that resolves to the content length of the body
 */
function getFetchBodyLength() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    if (args[0] instanceof URL || typeof args[0] === 'string') {
        var requestInit = args[1];
        if (!(requestInit === null || requestInit === void 0 ? void 0 : requestInit.body)) {
            return Promise.resolve();
        }
        if (requestInit.body instanceof ReadableStream) {
            var _a = _getBodyNonDestructively(requestInit.body), body = _a.body, length_1 = _a.length;
            requestInit.body = body;
            return length_1;
        }
        else {
            return Promise.resolve(getXHRBodyLength(requestInit.body));
        }
    }
    else {
        var info = args[0];
        if (!(info === null || info === void 0 ? void 0 : info.body)) {
            return Promise.resolve();
        }
        return info
            .clone()
            .text()
            .then(function (t) { return getByteLength(t); });
    }
}
function _getBodyNonDestructively(body) {
    // can't read a ReadableStream without destroying it
    // but we CAN pipe it through and return a new ReadableStream
    // some (older) platforms don't expose the pipeThrough method and in that scenario, we're out of luck;
    //   there's no way to read the stream without consuming it.
    if (!body.pipeThrough) {
        DIAG_LOGGER.warn('Platform has ReadableStream but not pipeThrough!');
        return {
            body: body,
            length: Promise.resolve(undefined),
        };
    }
    var length = 0;
    var resolveLength;
    var lengthPromise = new Promise(function (resolve) {
        resolveLength = resolve;
    });
    var transform = new TransformStream({
        start: function () { },
        transform: function (chunk, controller) {
            return __awaiter(this, void 0, void 0, function () {
                var bytearray;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, chunk];
                        case 1:
                            bytearray = (_a.sent());
                            length += bytearray.byteLength;
                            controller.enqueue(chunk);
                            return [2 /*return*/];
                    }
                });
            });
        },
        flush: function () {
            resolveLength(length);
        },
    });
    return {
        body: body.pipeThrough(transform),
        length: lengthPromise,
    };
}
/**
 * Helper function to determine payload content length for XHR requests
 * @param body
 * @returns content length
 */
function getXHRBodyLength(body) {
    if (typeof Document !== 'undefined' && body instanceof Document) {
        return new XMLSerializer().serializeToString(document).length;
    }
    // XMLHttpRequestBodyInit expands to the following:
    if (body instanceof Blob) {
        return body.size;
    }
    // ArrayBuffer | ArrayBufferView
    if (body.byteLength !== undefined) {
        return body.byteLength;
    }
    if (body instanceof FormData) {
        return getFormDataSize(body);
    }
    if (body instanceof URLSearchParams) {
        return getByteLength(body.toString());
    }
    if (typeof body === 'string') {
        return getByteLength(body);
    }
    DIAG_LOGGER.warn('unknown body type');
    return undefined;
}
var TEXT_ENCODER = new TextEncoder();
function getByteLength(s) {
    return TEXT_ENCODER.encode(s).byteLength;
}
function getFormDataSize(formData) {
    var e_1, _a;
    var size = 0;
    try {
        for (var _b = __values(formData.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            size += key.length;
            if (value instanceof Blob) {
                size += value.size;
            }
            else {
                size += value.length;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return size;
}
//# sourceMappingURL=utils.js.map

/***/ }),
/* 1956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VERSION; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// this is autogenerated file, see scripts/version-update.js
var VERSION = '0.57.2';
//# sourceMappingURL=version.js.map

/***/ }),
/* 1957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instrumentation__ = __webpack_require__(1958);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "UserInteractionInstrumentation", function() { return __WEBPACK_IMPORTED_MODULE_0__instrumentation__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(1959);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__enums_AttributeNames__ = __webpack_require__(924);
/* unused harmony namespace reexport */
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



//# sourceMappingURL=index.js.map

/***/ }),
/* 1958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return UserInteractionInstrumentation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_instrumentation__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__opentelemetry_sdk_trace_web__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__enums_AttributeNames__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__version__ = __webpack_require__(1960);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
/// <reference types="zone.js" />





/** @knipignore */

var ZONE_CONTEXT_KEY = 'OT_ZONE_CONTEXT';
var EVENT_NAVIGATION_NAME = 'Navigation:';
var DEFAULT_EVENT_NAMES = ['click'];
function defaultShouldPreventSpanCreation() {
    return false;
}
/**
 * This class represents a UserInteraction plugin for auto instrumentation.
 * If zone.js is available then it patches the zone otherwise it patches
 * addEventListener of HTMLElement
 */
var UserInteractionInstrumentation = /** @class */ (function (_super) {
    __extends(UserInteractionInstrumentation, _super);
    function UserInteractionInstrumentation(config) {
        if (config === void 0) { config = {}; }
        var _a;
        var _this = _super.call(this, __WEBPACK_IMPORTED_MODULE_5__version__["a" /* PACKAGE_NAME */], __WEBPACK_IMPORTED_MODULE_5__version__["b" /* PACKAGE_VERSION */], config) || this;
        _this.version = __WEBPACK_IMPORTED_MODULE_5__version__["b" /* PACKAGE_VERSION */];
        _this.moduleName = 'user-interaction';
        _this._spansData = new WeakMap();
        // for addEventListener/removeEventListener state
        _this._wrappedListeners = new WeakMap();
        // for event bubbling
        _this._eventsSpanMap = new WeakMap();
        _this._eventNames = new Set((_a = config === null || config === void 0 ? void 0 : config.eventNames) !== null && _a !== void 0 ? _a : DEFAULT_EVENT_NAMES);
        _this._shouldPreventSpanCreation =
            typeof (config === null || config === void 0 ? void 0 : config.shouldPreventSpanCreation) === 'function'
                ? config.shouldPreventSpanCreation
                : defaultShouldPreventSpanCreation;
        return _this;
    }
    UserInteractionInstrumentation.prototype.init = function () { };
    /**
     * This will check if last task was timeout and will save the time to
     * fix the user interaction when nothing happens
     * This timeout comes from xhr plugin which is needed to collect information
     * about last xhr main request from observer
     * @param task
     * @param span
     */
    UserInteractionInstrumentation.prototype._checkForTimeout = function (task, span) {
        var spanData = this._spansData.get(span);
        if (spanData) {
            if (task.source === 'setTimeout') {
                spanData.hrTimeLastTimeout = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__["hrTime"])();
            }
            else if (task.source !== 'Promise.then' &&
                task.source !== 'setTimeout') {
                spanData.hrTimeLastTimeout = undefined;
            }
        }
    };
    /**
     * Controls whether or not to create a span, based on the event type.
     */
    UserInteractionInstrumentation.prototype._allowEventName = function (eventName) {
        return this._eventNames.has(eventName);
    };
    /**
     * Creates a new span
     * @param element
     * @param eventName
     * @param parentSpan
     */
    UserInteractionInstrumentation.prototype._createSpan = function (element, eventName, parentSpan) {
        var _a;
        if (!(element instanceof HTMLElement)) {
            return undefined;
        }
        if (!element.getAttribute) {
            return undefined;
        }
        if (element.hasAttribute('disabled')) {
            return undefined;
        }
        if (!this._allowEventName(eventName)) {
            return undefined;
        }
        var xpath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__opentelemetry_sdk_trace_web__["getElementXPath"])(element, true);
        try {
            var span = this.tracer.startSpan(eventName, {
                attributes: (_a = {},
                    _a[__WEBPACK_IMPORTED_MODULE_4__enums_AttributeNames__["a" /* AttributeNames */].EVENT_TYPE] = eventName,
                    _a[__WEBPACK_IMPORTED_MODULE_4__enums_AttributeNames__["a" /* AttributeNames */].TARGET_ELEMENT] = element.tagName,
                    _a[__WEBPACK_IMPORTED_MODULE_4__enums_AttributeNames__["a" /* AttributeNames */].TARGET_XPATH] = xpath,
                    _a[__WEBPACK_IMPORTED_MODULE_4__enums_AttributeNames__["a" /* AttributeNames */].HTTP_URL] = window.location.href,
                    _a),
            }, parentSpan
                ? __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__["trace"].setSpan(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__["context"].active(), parentSpan)
                : undefined);
            if (this._shouldPreventSpanCreation(eventName, element, span) === true) {
                return undefined;
            }
            this._spansData.set(span, {
                taskCount: 0,
            });
            return span;
        }
        catch (e) {
            this._diag.error('failed to start create new user interaction span', e);
        }
        return undefined;
    };
    /**
     * Decrement number of tasks that left in zone,
     * This is needed to be able to end span when no more tasks left
     * @param span
     */
    UserInteractionInstrumentation.prototype._decrementTask = function (span) {
        var spanData = this._spansData.get(span);
        if (spanData) {
            spanData.taskCount--;
            if (spanData.taskCount === 0) {
                this._tryToEndSpan(span, spanData.hrTimeLastTimeout);
            }
        }
    };
    /**
     * Return the current span
     * @param zone
     * @private
     */
    UserInteractionInstrumentation.prototype._getCurrentSpan = function (zone) {
        var context = zone.get(ZONE_CONTEXT_KEY);
        if (context) {
            return __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__["trace"].getSpan(context);
        }
        return context;
    };
    /**
     * Increment number of tasks that are run within the same zone.
     *     This is needed to be able to end span when no more tasks left
     * @param span
     */
    UserInteractionInstrumentation.prototype._incrementTask = function (span) {
        var spanData = this._spansData.get(span);
        if (spanData) {
            spanData.taskCount++;
        }
    };
    /**
     * Returns true iff we should use the patched callback; false if it's already been patched
     */
    UserInteractionInstrumentation.prototype.addPatchedListener = function (on, type, listener, wrappedListener) {
        var listener2Type = this._wrappedListeners.get(listener);
        if (!listener2Type) {
            listener2Type = new Map();
            this._wrappedListeners.set(listener, listener2Type);
        }
        var element2patched = listener2Type.get(type);
        if (!element2patched) {
            element2patched = new Map();
            listener2Type.set(type, element2patched);
        }
        if (element2patched.has(on)) {
            return false;
        }
        element2patched.set(on, wrappedListener);
        return true;
    };
    /**
     * Returns the patched version of the callback (or undefined)
     */
    UserInteractionInstrumentation.prototype.removePatchedListener = function (on, type, listener) {
        var listener2Type = this._wrappedListeners.get(listener);
        if (!listener2Type) {
            return undefined;
        }
        var element2patched = listener2Type.get(type);
        if (!element2patched) {
            return undefined;
        }
        var patched = element2patched.get(on);
        if (patched) {
            element2patched.delete(on);
            if (element2patched.size === 0) {
                listener2Type.delete(type);
                if (listener2Type.size === 0) {
                    this._wrappedListeners.delete(listener);
                }
            }
        }
        return patched;
    };
    // utility method to deal with the Function|EventListener nature of addEventListener
    UserInteractionInstrumentation.prototype._invokeListener = function (listener, target, args) {
        if (typeof listener === 'function') {
            return listener.apply(target, args);
        }
        else {
            return listener.handleEvent(args[0]);
        }
    };
    /**
     * This patches the addEventListener of HTMLElement to be able to
     * auto instrument the click events
     * This is done when zone is not available
     */
    UserInteractionInstrumentation.prototype._patchAddEventListener = function () {
        var plugin = this;
        return function (original) {
            return function addEventListenerPatched(type, listener, useCapture) {
                // Forward calls with listener = null
                if (!listener) {
                    return original.call(this, type, listener, useCapture);
                }
                // filter out null (typeof null === 'object')
                var once = useCapture && typeof useCapture === 'object' && useCapture.once;
                var patchedListener = function () {
                    var _this = this;
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    var parentSpan;
                    var event = args[0];
                    var target = event === null || event === void 0 ? void 0 : event.target;
                    if (event) {
                        parentSpan = plugin._eventsSpanMap.get(event);
                    }
                    if (once) {
                        plugin.removePatchedListener(this, type, listener);
                    }
                    var span = plugin._createSpan(target, type, parentSpan);
                    if (span) {
                        if (event) {
                            plugin._eventsSpanMap.set(event, span);
                        }
                        return __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__["context"].with(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__["trace"].setSpan(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__["context"].active(), span), function () {
                            var result = plugin._invokeListener(listener, _this, args);
                            // no zone so end span immediately
                            span.end();
                            return result;
                        });
                    }
                    else {
                        return plugin._invokeListener(listener, this, args);
                    }
                };
                if (plugin.addPatchedListener(this, type, listener, patchedListener)) {
                    return original.call(this, type, patchedListener, useCapture);
                }
            };
        };
    };
    /**
     * This patches the removeEventListener of HTMLElement to handle the fact that
     * we patched the original callbacks
     * This is done when zone is not available
     */
    UserInteractionInstrumentation.prototype._patchRemoveEventListener = function () {
        var plugin = this;
        return function (original) {
            return function removeEventListenerPatched(type, listener, useCapture) {
                var wrappedListener = plugin.removePatchedListener(this, type, listener);
                if (wrappedListener) {
                    return original.call(this, type, wrappedListener, useCapture);
                }
                else {
                    return original.call(this, type, listener, useCapture);
                }
            };
        };
    };
    /**
     * Most browser provide event listener api via EventTarget in prototype chain.
     * Exception to this is IE 11 which has it on the prototypes closest to EventTarget:
     *
     * * - has addEventListener in IE
     * ** - has addEventListener in all other browsers
     * ! - missing in IE
     *
     * HTMLElement -> Element -> Node * -> EventTarget **! -> Object
     * Document -> Node * -> EventTarget **! -> Object
     * Window * -> WindowProperties ! -> EventTarget **! -> Object
     */
    UserInteractionInstrumentation.prototype._getPatchableEventTargets = function () {
        return window.EventTarget
            ? [EventTarget.prototype]
            : [Node.prototype, Window.prototype];
    };
    /**
     * Patches the history api
     */
    UserInteractionInstrumentation.prototype._patchHistoryApi = function () {
        this._unpatchHistoryApi();
        this._wrap(history, 'replaceState', this._patchHistoryMethod());
        this._wrap(history, 'pushState', this._patchHistoryMethod());
        this._wrap(history, 'back', this._patchHistoryMethod());
        this._wrap(history, 'forward', this._patchHistoryMethod());
        this._wrap(history, 'go', this._patchHistoryMethod());
    };
    /**
     * Patches the certain history api method
     */
    UserInteractionInstrumentation.prototype._patchHistoryMethod = function () {
        var plugin = this;
        return function (original) {
            return function patchHistoryMethod() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var url = "" + location.pathname + location.hash + location.search;
                var result = original.apply(this, args);
                var urlAfter = "" + location.pathname + location.hash + location.search;
                if (url !== urlAfter) {
                    plugin._updateInteractionName(urlAfter);
                }
                return result;
            };
        };
    };
    /**
     * unpatch the history api methods
     */
    UserInteractionInstrumentation.prototype._unpatchHistoryApi = function () {
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_instrumentation__["isWrapped"])(history.replaceState))
            this._unwrap(history, 'replaceState');
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_instrumentation__["isWrapped"])(history.pushState))
            this._unwrap(history, 'pushState');
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_instrumentation__["isWrapped"])(history.back))
            this._unwrap(history, 'back');
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_instrumentation__["isWrapped"])(history.forward))
            this._unwrap(history, 'forward');
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_instrumentation__["isWrapped"])(history.go))
            this._unwrap(history, 'go');
    };
    /**
     * Updates interaction span name
     * @param url
     */
    UserInteractionInstrumentation.prototype._updateInteractionName = function (url) {
        var span = __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__["trace"].getSpan(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__["context"].active());
        if (span && typeof span.updateName === 'function') {
            span.updateName(EVENT_NAVIGATION_NAME + " " + url);
        }
    };
    /**
     * Patches zone cancel task - this is done to be able to correctly
     * decrement the number of remaining tasks
     */
    UserInteractionInstrumentation.prototype._patchZoneCancelTask = function () {
        var plugin = this;
        return function (original) {
            return function patchCancelTask(task) {
                var currentZone = Zone.current;
                var currentSpan = plugin._getCurrentSpan(currentZone);
                if (currentSpan && plugin._shouldCountTask(task, currentZone)) {
                    plugin._decrementTask(currentSpan);
                }
                return original.call(this, task);
            };
        };
    };
    /**
     * Patches zone schedule task - this is done to be able to correctly
     * increment the number of tasks running within current zone but also to
     * save time in case of timeout running from xhr plugin when waiting for
     * main request from PerformanceResourceTiming
     */
    UserInteractionInstrumentation.prototype._patchZoneScheduleTask = function () {
        var plugin = this;
        return function (original) {
            return function patchScheduleTask(task) {
                var currentZone = Zone.current;
                var currentSpan = plugin._getCurrentSpan(currentZone);
                if (currentSpan && plugin._shouldCountTask(task, currentZone)) {
                    plugin._incrementTask(currentSpan);
                    plugin._checkForTimeout(task, currentSpan);
                }
                return original.call(this, task);
            };
        };
    };
    /**
     * Patches zone run task - this is done to be able to create a span when
     * user interaction starts
     * @private
     */
    UserInteractionInstrumentation.prototype._patchZoneRunTask = function () {
        var plugin = this;
        return function (original) {
            return function patchRunTask(task, applyThis, applyArgs) {
                var event = Array.isArray(applyArgs) && applyArgs[0] instanceof Event
                    ? applyArgs[0]
                    : undefined;
                var target = event === null || event === void 0 ? void 0 : event.target;
                var span;
                var activeZone = this;
                if (target) {
                    span = plugin._createSpan(target, task.eventName);
                    if (span) {
                        plugin._incrementTask(span);
                        return activeZone.run(function () {
                            try {
                                return __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__["context"].with(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__["trace"].setSpan(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__["context"].active(), span), function () {
                                    var currentZone = Zone.current;
                                    task._zone = currentZone;
                                    return original.call(currentZone, task, applyThis, applyArgs);
                                });
                            }
                            finally {
                                plugin._decrementTask(span);
                            }
                        });
                    }
                }
                else {
                    span = plugin._getCurrentSpan(activeZone);
                }
                try {
                    return original.call(activeZone, task, applyThis, applyArgs);
                }
                finally {
                    if (span && plugin._shouldCountTask(task, activeZone)) {
                        plugin._decrementTask(span);
                    }
                }
            };
        };
    };
    /**
     * Decides if task should be counted.
     * @param task
     * @param currentZone
     * @private
     */
    UserInteractionInstrumentation.prototype._shouldCountTask = function (task, currentZone) {
        if (task._zone) {
            currentZone = task._zone;
        }
        if (!currentZone || !task.data || task.data.isPeriodic) {
            return false;
        }
        var currentSpan = this._getCurrentSpan(currentZone);
        if (!currentSpan) {
            return false;
        }
        if (!this._spansData.get(currentSpan)) {
            return false;
        }
        return task.type === 'macroTask' || task.type === 'microTask';
    };
    /**
     * Will try to end span when such span still exists.
     * @param span
     * @param endTime
     * @private
     */
    UserInteractionInstrumentation.prototype._tryToEndSpan = function (span, endTime) {
        if (span) {
            var spanData = this._spansData.get(span);
            if (spanData) {
                span.end(endTime);
                this._spansData.delete(span);
            }
        }
    };
    /**
     * implements enable function
     */
    UserInteractionInstrumentation.prototype.enable = function () {
        var _this = this;
        var ZoneWithPrototype = this._getZoneWithPrototype();
        this._diag.debug('applying patch to', this.moduleName, this.version, 'zone:', !!ZoneWithPrototype);
        if (ZoneWithPrototype) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_instrumentation__["isWrapped"])(ZoneWithPrototype.prototype.runTask)) {
                this._unwrap(ZoneWithPrototype.prototype, 'runTask');
                this._diag.debug('removing previous patch from method runTask');
            }
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_instrumentation__["isWrapped"])(ZoneWithPrototype.prototype.scheduleTask)) {
                this._unwrap(ZoneWithPrototype.prototype, 'scheduleTask');
                this._diag.debug('removing previous patch from method scheduleTask');
            }
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_instrumentation__["isWrapped"])(ZoneWithPrototype.prototype.cancelTask)) {
                this._unwrap(ZoneWithPrototype.prototype, 'cancelTask');
                this._diag.debug('removing previous patch from method cancelTask');
            }
            this._zonePatched = true;
            this._wrap(ZoneWithPrototype.prototype, 'runTask', this._patchZoneRunTask());
            this._wrap(ZoneWithPrototype.prototype, 'scheduleTask', this._patchZoneScheduleTask());
            this._wrap(ZoneWithPrototype.prototype, 'cancelTask', this._patchZoneCancelTask());
        }
        else {
            this._zonePatched = false;
            var targets = this._getPatchableEventTargets();
            targets.forEach(function (target) {
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_instrumentation__["isWrapped"])(target.addEventListener)) {
                    _this._unwrap(target, 'addEventListener');
                    _this._diag.debug('removing previous patch from method addEventListener');
                }
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_instrumentation__["isWrapped"])(target.removeEventListener)) {
                    _this._unwrap(target, 'removeEventListener');
                    _this._diag.debug('removing previous patch from method removeEventListener');
                }
                _this._wrap(target, 'addEventListener', _this._patchAddEventListener());
                _this._wrap(target, 'removeEventListener', _this._patchRemoveEventListener());
            });
        }
        this._patchHistoryApi();
    };
    /**
     * implements unpatch function
     */
    UserInteractionInstrumentation.prototype.disable = function () {
        var _this = this;
        var ZoneWithPrototype = this._getZoneWithPrototype();
        this._diag.debug('removing patch from', this.moduleName, this.version, 'zone:', !!ZoneWithPrototype);
        if (ZoneWithPrototype && this._zonePatched) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_instrumentation__["isWrapped"])(ZoneWithPrototype.prototype.runTask)) {
                this._unwrap(ZoneWithPrototype.prototype, 'runTask');
            }
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_instrumentation__["isWrapped"])(ZoneWithPrototype.prototype.scheduleTask)) {
                this._unwrap(ZoneWithPrototype.prototype, 'scheduleTask');
            }
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_instrumentation__["isWrapped"])(ZoneWithPrototype.prototype.cancelTask)) {
                this._unwrap(ZoneWithPrototype.prototype, 'cancelTask');
            }
        }
        else {
            var targets = this._getPatchableEventTargets();
            targets.forEach(function (target) {
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_instrumentation__["isWrapped"])(target.addEventListener)) {
                    _this._unwrap(target, 'addEventListener');
                }
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_instrumentation__["isWrapped"])(target.removeEventListener)) {
                    _this._unwrap(target, 'removeEventListener');
                }
            });
        }
        this._unpatchHistoryApi();
    };
    /**
     * returns Zone
     */
    UserInteractionInstrumentation.prototype._getZoneWithPrototype = function () {
        var _window = window;
        return _window.Zone;
    };
    return UserInteractionInstrumentation;
}(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_instrumentation__["InstrumentationBase"]));

//# sourceMappingURL=instrumentation.js.map

/***/ }),
/* 1959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

//# sourceMappingURL=types.js.map

/***/ }),
/* 1960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PACKAGE_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PACKAGE_NAME; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// this is autogenerated file, see scripts/version-update.js
var PACKAGE_VERSION = '0.44.1';
var PACKAGE_NAME = '@opentelemetry/instrumentation-user-interaction';
//# sourceMappingURL=version.js.map

/***/ }),
/* 1961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AttributeNames; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * https://github.com/open-telemetry/opentelemetry-specification/blob/master/specification/trace/semantic_conventions/http.md
 */
var AttributeNames;
(function (AttributeNames) {
    AttributeNames["HTTP_STATUS_TEXT"] = "http.status_text";
})(AttributeNames || (AttributeNames = {}));
//# sourceMappingURL=AttributeNames.js.map

/***/ }),
/* 1962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventNames; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var EventNames;
(function (EventNames) {
    EventNames["METHOD_OPEN"] = "open";
    EventNames["METHOD_SEND"] = "send";
    EventNames["EVENT_ABORT"] = "abort";
    EventNames["EVENT_ERROR"] = "error";
    EventNames["EVENT_LOAD"] = "loaded";
    EventNames["EVENT_TIMEOUT"] = "timeout";
})(EventNames || (EventNames = {}));
//# sourceMappingURL=EventNames.js.map

/***/ }),
/* 1963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__xhr__ = __webpack_require__(1966);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__xhr__["a"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 1964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getXHRBodyLength;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
// Much of the logic here overlaps with the same utils file in opentelemetry-instrumentation-fetch
// These may be unified in the future.

var DIAG_LOGGER = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].createComponentLogger({
    namespace: '@opentelemetry/opentelemetry-instrumentation-xml-http-request/utils',
});
/**
 * Helper function to determine payload content length for XHR requests
 * @param body
 * @returns content length
 */
function getXHRBodyLength(body) {
    if (typeof Document !== 'undefined' && body instanceof Document) {
        return new XMLSerializer().serializeToString(document).length;
    }
    // XMLHttpRequestBodyInit expands to the following:
    if (body instanceof Blob) {
        return body.size;
    }
    // ArrayBuffer | ArrayBufferView
    if (body.byteLength !== undefined) {
        return body.byteLength;
    }
    if (body instanceof FormData) {
        return getFormDataSize(body);
    }
    if (body instanceof URLSearchParams) {
        return getByteLength(body.toString());
    }
    if (typeof body === 'string') {
        return getByteLength(body);
    }
    DIAG_LOGGER.warn('unknown body type');
    return undefined;
}
var TEXT_ENCODER = new TextEncoder();
function getByteLength(s) {
    return TEXT_ENCODER.encode(s).byteLength;
}
function getFormDataSize(formData) {
    var e_1, _a;
    var size = 0;
    try {
        for (var _b = __values(formData.entries()), _c = _b.next(); !_c.done; _c = _b.next()) {
            var _d = __read(_c.value, 2), key = _d[0], value = _d[1];
            size += key.length;
            if (value instanceof Blob) {
                size += value.size;
            }
            else {
                size += value.length;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return size;
}
//# sourceMappingURL=utils.js.map

/***/ }),
/* 1965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VERSION; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// this is autogenerated file, see scripts/version-update.js
var VERSION = '0.57.2';
//# sourceMappingURL=version.js.map

/***/ }),
/* 1966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return XMLHttpRequestInstrumentation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_instrumentation__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__opentelemetry_semantic_conventions__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_web__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__enums_EventNames__ = __webpack_require__(1962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(1964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__version__ = __webpack_require__(1965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__enums_AttributeNames__ = __webpack_require__(1961);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();









// how long to wait for observer to collect information about resources
// this is needed as event "load" is called before observer
// hard to say how long it should really wait, seems like 300ms is
// safe enough
var OBSERVER_WAIT_TIME_MS = 300;
/**
 * This class represents a XMLHttpRequest plugin for auto instrumentation
 */
var XMLHttpRequestInstrumentation = /** @class */ (function (_super) {
    __extends(XMLHttpRequestInstrumentation, _super);
    function XMLHttpRequestInstrumentation(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this, '@opentelemetry/instrumentation-xml-http-request', __WEBPACK_IMPORTED_MODULE_7__version__["a" /* VERSION */], config) || this;
        _this.component = 'xml-http-request';
        _this.version = __WEBPACK_IMPORTED_MODULE_7__version__["a" /* VERSION */];
        _this.moduleName = _this.component;
        _this._tasksCount = 0;
        _this._xhrMem = new WeakMap();
        _this._usedResources = new WeakSet();
        return _this;
    }
    XMLHttpRequestInstrumentation.prototype.init = function () { };
    /**
     * Adds custom headers to XMLHttpRequest
     * @param xhr
     * @param spanUrl
     * @private
     */
    XMLHttpRequestInstrumentation.prototype._addHeaders = function (xhr, spanUrl) {
        var url = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_web__["parseUrl"])(spanUrl).href;
        if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_web__["shouldPropagateTraceHeaders"])(url, this.getConfig().propagateTraceHeaderCorsUrls)) {
            var headers_1 = {};
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["propagation"].inject(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].active(), headers_1);
            if (Object.keys(headers_1).length > 0) {
                this._diag.debug('headers inject skipped due to CORS policy');
            }
            return;
        }
        var headers = {};
        __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["propagation"].inject(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].active(), headers);
        Object.keys(headers).forEach(function (key) {
            xhr.setRequestHeader(key, String(headers[key]));
        });
    };
    /**
     * Add cors pre flight child span
     * @param span
     * @param corsPreFlightRequest
     * @private
     */
    XMLHttpRequestInstrumentation.prototype._addChildSpan = function (span, corsPreFlightRequest) {
        var _this = this;
        __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].with(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].setSpan(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].active(), span), function () {
            var childSpan = _this.tracer.startSpan('CORS Preflight', {
                startTime: corsPreFlightRequest[__WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].FETCH_START],
            });
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_web__["addSpanNetworkEvents"])(childSpan, corsPreFlightRequest, _this.getConfig().ignoreNetworkEvents);
            childSpan.end(corsPreFlightRequest[__WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_web__["PerformanceTimingNames"].RESPONSE_END]);
        });
    };
    /**
     * Add attributes when span is going to end
     * @param span
     * @param xhr
     * @param spanUrl
     * @private
     */
    XMLHttpRequestInstrumentation.prototype._addFinalSpanAttributes = function (span, xhrMem, spanUrl) {
        if (typeof spanUrl === 'string') {
            var parsedUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_web__["parseUrl"])(spanUrl);
            if (xhrMem.status !== undefined) {
                span.setAttribute(__WEBPACK_IMPORTED_MODULE_3__opentelemetry_semantic_conventions__["a" /* SEMATTRS_HTTP_STATUS_CODE */], xhrMem.status);
            }
            if (xhrMem.statusText !== undefined) {
                span.setAttribute(__WEBPACK_IMPORTED_MODULE_8__enums_AttributeNames__["a" /* AttributeNames */].HTTP_STATUS_TEXT, xhrMem.statusText);
            }
            span.setAttribute(__WEBPACK_IMPORTED_MODULE_3__opentelemetry_semantic_conventions__["b" /* SEMATTRS_HTTP_HOST */], parsedUrl.host);
            span.setAttribute(__WEBPACK_IMPORTED_MODULE_3__opentelemetry_semantic_conventions__["c" /* SEMATTRS_HTTP_SCHEME */], parsedUrl.protocol.replace(':', ''));
            // @TODO do we want to collect this or it will be collected earlier once only or
            //    maybe when parent span is not available ?
            span.setAttribute(__WEBPACK_IMPORTED_MODULE_3__opentelemetry_semantic_conventions__["d" /* SEMATTRS_HTTP_USER_AGENT */], navigator.userAgent);
        }
    };
    XMLHttpRequestInstrumentation.prototype._applyAttributesAfterXHR = function (span, xhr) {
        var _this = this;
        var applyCustomAttributesOnSpan = this.getConfig().applyCustomAttributesOnSpan;
        if (typeof applyCustomAttributesOnSpan === 'function') {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_instrumentation__["safeExecuteInTheMiddle"])(function () { return applyCustomAttributesOnSpan(span, xhr); }, function (error) {
                if (!error) {
                    return;
                }
                _this._diag.error('applyCustomAttributesOnSpan', error);
            }, true);
        }
    };
    /**
     * will collect information about all resources created
     * between "send" and "end" with additional waiting for main resource
     * @param xhr
     * @param spanUrl
     * @private
     */
    XMLHttpRequestInstrumentation.prototype._addResourceObserver = function (xhr, spanUrl) {
        var xhrMem = this._xhrMem.get(xhr);
        if (!xhrMem ||
            typeof PerformanceObserver !== 'function' ||
            typeof PerformanceResourceTiming !== 'function') {
            return;
        }
        xhrMem.createdResources = {
            observer: new PerformanceObserver(function (list) {
                var entries = list.getEntries();
                var parsedUrl = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_web__["parseUrl"])(spanUrl);
                entries.forEach(function (entry) {
                    if (entry.initiatorType === 'xmlhttprequest' &&
                        entry.name === parsedUrl.href) {
                        if (xhrMem.createdResources) {
                            xhrMem.createdResources.entries.push(entry);
                        }
                    }
                });
            }),
            entries: [],
        };
        xhrMem.createdResources.observer.observe({
            entryTypes: ['resource'],
        });
    };
    /**
     * Clears the resource timings and all resources assigned with spans
     *     when {@link XMLHttpRequestInstrumentationConfig.clearTimingResources} is
     *     set to true (default false)
     * @private
     */
    XMLHttpRequestInstrumentation.prototype._clearResources = function () {
        if (this._tasksCount === 0 && this.getConfig().clearTimingResources) {
            __WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__["otperformance"].clearResourceTimings();
            this._xhrMem = new WeakMap();
            this._usedResources = new WeakSet();
        }
    };
    /**
     * Finds appropriate resource and add network events to the span
     * @param span
     */
    XMLHttpRequestInstrumentation.prototype._findResourceAndAddNetworkEvents = function (xhrMem, span, spanUrl, startTime, endTime) {
        if (!spanUrl || !startTime || !endTime || !xhrMem.createdResources) {
            return;
        }
        var resources = xhrMem.createdResources.entries;
        if (!resources || !resources.length) {
            // fallback - either Observer is not available or it took longer
            // then OBSERVER_WAIT_TIME_MS and observer didn't collect enough
            // information
            // ts thinks this is the perf_hooks module, but it is the browser performance api
            resources = __WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__["otperformance"].getEntriesByType('resource');
        }
        var resource = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_web__["getResource"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_web__["parseUrl"])(spanUrl).href, startTime, endTime, resources, this._usedResources);
        if (resource.mainRequest) {
            var mainRequest = resource.mainRequest;
            this._markResourceAsUsed(mainRequest);
            var corsPreFlightRequest = resource.corsPreFlightRequest;
            if (corsPreFlightRequest) {
                this._addChildSpan(span, corsPreFlightRequest);
                this._markResourceAsUsed(corsPreFlightRequest);
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_web__["addSpanNetworkEvents"])(span, mainRequest, this.getConfig().ignoreNetworkEvents);
        }
    };
    /**
     * Removes the previous information about span.
     * This might happened when the same xhr is used again.
     * @param xhr
     * @private
     */
    XMLHttpRequestInstrumentation.prototype._cleanPreviousSpanInformation = function (xhr) {
        var xhrMem = this._xhrMem.get(xhr);
        if (xhrMem) {
            var callbackToRemoveEvents = xhrMem.callbackToRemoveEvents;
            if (callbackToRemoveEvents) {
                callbackToRemoveEvents();
            }
            this._xhrMem.delete(xhr);
        }
    };
    /**
     * Creates a new span when method "open" is called
     * @param xhr
     * @param url
     * @param method
     * @private
     */
    XMLHttpRequestInstrumentation.prototype._createSpan = function (xhr, url, method) {
        var _a;
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__["isUrlIgnored"])(url, this.getConfig().ignoreUrls)) {
            this._diag.debug('ignoring span as url matches ignored url');
            return;
        }
        var spanName = method.toUpperCase();
        var currentSpan = this.tracer.startSpan(spanName, {
            kind: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["SpanKind"].CLIENT,
            attributes: (_a = {},
                _a[__WEBPACK_IMPORTED_MODULE_3__opentelemetry_semantic_conventions__["e" /* SEMATTRS_HTTP_METHOD */]] = method,
                _a[__WEBPACK_IMPORTED_MODULE_3__opentelemetry_semantic_conventions__["f" /* SEMATTRS_HTTP_URL */]] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__opentelemetry_sdk_trace_web__["parseUrl"])(url).toString(),
                _a),
        });
        currentSpan.addEvent(__WEBPACK_IMPORTED_MODULE_5__enums_EventNames__["a" /* EventNames */].METHOD_OPEN);
        this._cleanPreviousSpanInformation(xhr);
        this._xhrMem.set(xhr, {
            span: currentSpan,
            spanUrl: url,
        });
        return currentSpan;
    };
    /**
     * Marks certain [resource]{@link PerformanceResourceTiming} when information
     * from this is used to add events to span.
     * This is done to avoid reusing the same resource again for next span
     * @param resource
     * @private
     */
    XMLHttpRequestInstrumentation.prototype._markResourceAsUsed = function (resource) {
        this._usedResources.add(resource);
    };
    /**
     * Patches the method open
     * @private
     */
    XMLHttpRequestInstrumentation.prototype._patchOpen = function () {
        var _this = this;
        return function (original) {
            var plugin = _this;
            return function patchOpen() {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var method = args[0];
                var url = args[1];
                plugin._createSpan(this, url, method);
                return original.apply(this, args);
            };
        };
    };
    /**
     * Patches the method send
     * @private
     */
    XMLHttpRequestInstrumentation.prototype._patchSend = function () {
        var plugin = this;
        function endSpanTimeout(eventName, xhrMem, performanceEndTime, endTime) {
            var callbackToRemoveEvents = xhrMem.callbackToRemoveEvents;
            if (typeof callbackToRemoveEvents === 'function') {
                callbackToRemoveEvents();
            }
            var span = xhrMem.span, spanUrl = xhrMem.spanUrl, sendStartTime = xhrMem.sendStartTime;
            if (span) {
                plugin._findResourceAndAddNetworkEvents(xhrMem, span, spanUrl, sendStartTime, performanceEndTime);
                span.addEvent(eventName, endTime);
                plugin._addFinalSpanAttributes(span, xhrMem, spanUrl);
                span.end(endTime);
                plugin._tasksCount--;
            }
            plugin._clearResources();
        }
        function endSpan(eventName, xhr) {
            var xhrMem = plugin._xhrMem.get(xhr);
            if (!xhrMem) {
                return;
            }
            xhrMem.status = xhr.status;
            xhrMem.statusText = xhr.statusText;
            plugin._xhrMem.delete(xhr);
            if (xhrMem.span) {
                plugin._applyAttributesAfterXHR(xhrMem.span, xhr);
            }
            var performanceEndTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__["hrTime"])();
            var endTime = Date.now();
            // the timeout is needed as observer doesn't have yet information
            // when event "load" is called. Also the time may differ depends on
            // browser and speed of computer
            setTimeout(function () {
                endSpanTimeout(eventName, xhrMem, performanceEndTime, endTime);
            }, OBSERVER_WAIT_TIME_MS);
        }
        function onError() {
            endSpan(__WEBPACK_IMPORTED_MODULE_5__enums_EventNames__["a" /* EventNames */].EVENT_ERROR, this);
        }
        function onAbort() {
            endSpan(__WEBPACK_IMPORTED_MODULE_5__enums_EventNames__["a" /* EventNames */].EVENT_ABORT, this);
        }
        function onTimeout() {
            endSpan(__WEBPACK_IMPORTED_MODULE_5__enums_EventNames__["a" /* EventNames */].EVENT_TIMEOUT, this);
        }
        function onLoad() {
            if (this.status < 299) {
                endSpan(__WEBPACK_IMPORTED_MODULE_5__enums_EventNames__["a" /* EventNames */].EVENT_LOAD, this);
            }
            else {
                endSpan(__WEBPACK_IMPORTED_MODULE_5__enums_EventNames__["a" /* EventNames */].EVENT_ERROR, this);
            }
        }
        function unregister(xhr) {
            xhr.removeEventListener('abort', onAbort);
            xhr.removeEventListener('error', onError);
            xhr.removeEventListener('load', onLoad);
            xhr.removeEventListener('timeout', onTimeout);
            var xhrMem = plugin._xhrMem.get(xhr);
            if (xhrMem) {
                xhrMem.callbackToRemoveEvents = undefined;
            }
        }
        return function (original) {
            return function patchSend() {
                var _this = this;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var xhrMem = plugin._xhrMem.get(this);
                if (!xhrMem) {
                    return original.apply(this, args);
                }
                var currentSpan = xhrMem.span;
                var spanUrl = xhrMem.spanUrl;
                if (currentSpan && spanUrl) {
                    if (plugin.getConfig().measureRequestSize && (args === null || args === void 0 ? void 0 : args[0])) {
                        var body = args[0];
                        var bodyLength = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* getXHRBodyLength */])(body);
                        if (bodyLength !== undefined) {
                            currentSpan.setAttribute(__WEBPACK_IMPORTED_MODULE_3__opentelemetry_semantic_conventions__["g" /* SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED */], bodyLength);
                        }
                    }
                    __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].with(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].setSpan(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].active(), currentSpan), function () {
                        plugin._tasksCount++;
                        xhrMem.sendStartTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_core__["hrTime"])();
                        currentSpan.addEvent(__WEBPACK_IMPORTED_MODULE_5__enums_EventNames__["a" /* EventNames */].METHOD_SEND);
                        _this.addEventListener('abort', onAbort);
                        _this.addEventListener('error', onError);
                        _this.addEventListener('load', onLoad);
                        _this.addEventListener('timeout', onTimeout);
                        xhrMem.callbackToRemoveEvents = function () {
                            unregister(_this);
                            if (xhrMem.createdResources) {
                                xhrMem.createdResources.observer.disconnect();
                            }
                        };
                        plugin._addHeaders(_this, spanUrl);
                        plugin._addResourceObserver(_this, spanUrl);
                    });
                }
                return original.apply(this, args);
            };
        };
    };
    /**
     * implements enable function
     */
    XMLHttpRequestInstrumentation.prototype.enable = function () {
        this._diag.debug('applying patch to', this.moduleName, this.version);
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_instrumentation__["isWrapped"])(XMLHttpRequest.prototype.open)) {
            this._unwrap(XMLHttpRequest.prototype, 'open');
            this._diag.debug('removing previous patch from method open');
        }
        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_instrumentation__["isWrapped"])(XMLHttpRequest.prototype.send)) {
            this._unwrap(XMLHttpRequest.prototype, 'send');
            this._diag.debug('removing previous patch from method send');
        }
        this._wrap(XMLHttpRequest.prototype, 'open', this._patchOpen());
        this._wrap(XMLHttpRequest.prototype, 'send', this._patchSend());
    };
    /**
     * implements disable function
     */
    XMLHttpRequestInstrumentation.prototype.disable = function () {
        this._diag.debug('removing patch from', this.moduleName, this.version);
        this._unwrap(XMLHttpRequest.prototype, 'open');
        this._unwrap(XMLHttpRequest.prototype, 'send');
        this._tasksCount = 0;
        this._xhrMem = new WeakMap();
        this._usedResources = new WeakSet();
    };
    return XMLHttpRequestInstrumentation;
}(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_instrumentation__["InstrumentationBase"]));

//# sourceMappingURL=xhr.js.map

/***/ }),
/* 1967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = registerInstrumentations;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api_logs__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__autoLoaderUtils__ = __webpack_require__(1968);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



/**
 * It will register instrumentations and plugins
 * @param options
 * @return returns function to unload instrumentation and plugins that were
 *   registered
 */
function registerInstrumentations(options) {
    var _a, _b;
    var tracerProvider = options.tracerProvider || __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].getTracerProvider();
    var meterProvider = options.meterProvider || __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["metrics"].getMeterProvider();
    var loggerProvider = options.loggerProvider || __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api_logs__["a" /* logs */].getLoggerProvider();
    var instrumentations = (_b = (_a = options.instrumentations) === null || _a === void 0 ? void 0 : _a.flat()) !== null && _b !== void 0 ? _b : [];
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__autoLoaderUtils__["a" /* enableInstrumentations */])(instrumentations, tracerProvider, meterProvider, loggerProvider);
    return function () {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__autoLoaderUtils__["b" /* disableInstrumentations */])(instrumentations);
    };
}
//# sourceMappingURL=autoLoader.js.map

/***/ }),
/* 1968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = enableInstrumentations;
/* harmony export (immutable) */ __webpack_exports__["b"] = disableInstrumentations;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Enable instrumentations
 * @param instrumentations
 * @param tracerProvider
 * @param meterProvider
 */
function enableInstrumentations(instrumentations, tracerProvider, meterProvider, loggerProvider) {
    for (var i = 0, j = instrumentations.length; i < j; i++) {
        var instrumentation = instrumentations[i];
        if (tracerProvider) {
            instrumentation.setTracerProvider(tracerProvider);
        }
        if (meterProvider) {
            instrumentation.setMeterProvider(meterProvider);
        }
        if (loggerProvider && instrumentation.setLoggerProvider) {
            instrumentation.setLoggerProvider(loggerProvider);
        }
        // instrumentations have been already enabled during creation
        // so enable only if user prevented that by setting enabled to false
        // this is to prevent double enabling but when calling register all
        // instrumentations should be now enabled
        if (!instrumentation.getConfig().enabled) {
            instrumentation.enable();
        }
    }
}
/**
 * Disable instrumentations
 * @param instrumentations
 */
function disableInstrumentations(instrumentations) {
    instrumentations.forEach(function (instrumentation) { return instrumentation.disable(); });
}
//# sourceMappingURL=autoLoaderUtils.js.map

/***/ }),
/* 1969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InstrumentationAbstract; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api_logs__ = __webpack_require__(900);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shimmer__ = __webpack_require__(3495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_shimmer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_shimmer__);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};



/**
 * Base abstract internal class for instrumenting node and web plugins
 */
var InstrumentationAbstract = /** @class */ (function () {
    function InstrumentationAbstract(instrumentationName, instrumentationVersion, config) {
        this.instrumentationName = instrumentationName;
        this.instrumentationVersion = instrumentationVersion;
        this._config = {};
        /* Api to wrap instrumented method */
        this._wrap = __WEBPACK_IMPORTED_MODULE_2_shimmer__["wrap"];
        /* Api to unwrap instrumented methods */
        this._unwrap = __WEBPACK_IMPORTED_MODULE_2_shimmer__["unwrap"];
        /* Api to mass wrap instrumented method */
        this._massWrap = __WEBPACK_IMPORTED_MODULE_2_shimmer__["massWrap"];
        /* Api to mass unwrap instrumented methods */
        this._massUnwrap = __WEBPACK_IMPORTED_MODULE_2_shimmer__["massUnwrap"];
        this.setConfig(config);
        this._diag = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].createComponentLogger({
            namespace: instrumentationName,
        });
        this._tracer = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].getTracer(instrumentationName, instrumentationVersion);
        this._meter = __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["metrics"].getMeter(instrumentationName, instrumentationVersion);
        this._logger = __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api_logs__["a" /* logs */].getLogger(instrumentationName, instrumentationVersion);
        this._updateMetricInstruments();
    }
    Object.defineProperty(InstrumentationAbstract.prototype, "meter", {
        /* Returns meter */
        get: function () {
            return this._meter;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Sets MeterProvider to this plugin
     * @param meterProvider
     */
    InstrumentationAbstract.prototype.setMeterProvider = function (meterProvider) {
        this._meter = meterProvider.getMeter(this.instrumentationName, this.instrumentationVersion);
        this._updateMetricInstruments();
    };
    Object.defineProperty(InstrumentationAbstract.prototype, "logger", {
        /* Returns logger */
        get: function () {
            return this._logger;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Sets LoggerProvider to this plugin
     * @param loggerProvider
     */
    InstrumentationAbstract.prototype.setLoggerProvider = function (loggerProvider) {
        this._logger = loggerProvider.getLogger(this.instrumentationName, this.instrumentationVersion);
    };
    /**
     * @experimental
     *
     * Get module definitions defined by {@link init}.
     * This can be used for experimental compile-time instrumentation.
     *
     * @returns an array of {@link InstrumentationModuleDefinition}
     */
    InstrumentationAbstract.prototype.getModuleDefinitions = function () {
        var _a;
        var initResult = (_a = this.init()) !== null && _a !== void 0 ? _a : [];
        if (!Array.isArray(initResult)) {
            return [initResult];
        }
        return initResult;
    };
    /**
     * Sets the new metric instruments with the current Meter.
     */
    InstrumentationAbstract.prototype._updateMetricInstruments = function () {
        return;
    };
    /* Returns InstrumentationConfig */
    InstrumentationAbstract.prototype.getConfig = function () {
        return this._config;
    };
    /**
     * Sets InstrumentationConfig to this plugin
     * @param config
     */
    InstrumentationAbstract.prototype.setConfig = function (config) {
        // copy config first level properties to ensure they are immutable.
        // nested properties are not copied, thus are mutable from the outside.
        this._config = __assign({ enabled: true }, config);
    };
    /**
     * Sets TraceProvider to this plugin
     * @param tracerProvider
     */
    InstrumentationAbstract.prototype.setTracerProvider = function (tracerProvider) {
        this._tracer = tracerProvider.getTracer(this.instrumentationName, this.instrumentationVersion);
    };
    Object.defineProperty(InstrumentationAbstract.prototype, "tracer", {
        /* Returns tracer */
        get: function () {
            return this._tracer;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Execute span customization hook, if configured, and log any errors.
     * Any semantics of the trigger and info are defined by the specific instrumentation.
     * @param hookHandler The optional hook handler which the user has configured via instrumentation config
     * @param triggerName The name of the trigger for executing the hook for logging purposes
     * @param span The span to which the hook should be applied
     * @param info The info object to be passed to the hook, with useful data the hook may use
     */
    InstrumentationAbstract.prototype._runSpanCustomizationHook = function (hookHandler, triggerName, span, info) {
        if (!hookHandler) {
            return;
        }
        try {
            hookHandler(span, info);
        }
        catch (e) {
            this._diag.error("Error running span customization hook due to exception in handler", { triggerName: triggerName }, e);
        }
    };
    return InstrumentationAbstract;
}());

//# sourceMappingURL=instrumentation.js.map

/***/ }),
/* 1970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InstrumentationNodeModuleDefinition; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var InstrumentationNodeModuleDefinition = /** @class */ (function () {
    function InstrumentationNodeModuleDefinition(name, supportedVersions, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    patch, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    unpatch, files) {
        this.name = name;
        this.supportedVersions = supportedVersions;
        this.patch = patch;
        this.unpatch = unpatch;
        this.files = files || [];
    }
    return InstrumentationNodeModuleDefinition;
}());

//# sourceMappingURL=instrumentationNodeModuleDefinition.js.map

/***/ }),
/* 1971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InstrumentationNodeModuleFile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform_index__ = __webpack_require__(925);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var InstrumentationNodeModuleFile = /** @class */ (function () {
    function InstrumentationNodeModuleFile(name, supportedVersions, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    patch, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    unpatch) {
        this.supportedVersions = supportedVersions;
        this.patch = patch;
        this.unpatch = unpatch;
        this.name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__platform_index__["b" /* normalize */])(name);
    }
    return InstrumentationNodeModuleFile;
}());

//# sourceMappingURL=instrumentationNodeModuleFile.js.map

/***/ }),
/* 1972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InstrumentationBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__instrumentation__ = __webpack_require__(1969);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();

/**
 * Base abstract class for instrumenting web plugins
 */
var InstrumentationBase = /** @class */ (function (_super) {
    __extends(InstrumentationBase, _super);
    function InstrumentationBase(instrumentationName, instrumentationVersion, config) {
        var _this = _super.call(this, instrumentationName, instrumentationVersion, config) || this;
        if (_this._config.enabled) {
            _this.enable();
        }
        return _this;
    }
    return InstrumentationBase;
}(__WEBPACK_IMPORTED_MODULE_0__instrumentation__["a" /* InstrumentationAbstract */]));

//# sourceMappingURL=instrumentation.js.map

/***/ }),
/* 1973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = normalize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Placeholder normalize function to replace the node variant in browser runtimes,
 * this should never be called and will perform a no-op and warn if it is called regardless.
 *
 * This is a workaround to fix https://github.com/open-telemetry/opentelemetry-js/issues/4373 until the instrumentation
 * package can be made node-only.
 *
 * @param path input path
 * @return unmodified path
 * @internal
 */
function normalize(path) {
    __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn('Path normalization is not implemented for this platform. To silence this warning, ensure no node-specific instrumentations are loaded, and node-specific types (e.g. InstrumentationNodeModuleFile), are not used in a browser context)');
    return path;
}
//# sourceMappingURL=noop-normalize.js.map

/***/ }),
/* 1974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = safeExecuteInTheMiddle;
/* harmony export (immutable) */ __webpack_exports__["c"] = safeExecuteInTheMiddleAsync;
/* harmony export (immutable) */ __webpack_exports__["a"] = isWrapped;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/**
 * function to execute patched function and being able to catch errors
 * @param execute - function to be executed
 * @param onFinish - callback to run when execute finishes
 */
function safeExecuteInTheMiddle(execute, onFinish, preventThrowingError) {
    var error;
    var result;
    try {
        result = execute();
    }
    catch (e) {
        error = e;
    }
    finally {
        onFinish(error, result);
        if (error && !preventThrowingError) {
            // eslint-disable-next-line no-unsafe-finally
            throw error;
        }
        // eslint-disable-next-line no-unsafe-finally
        return result;
    }
}
/**
 * Async function to execute patched function and being able to catch errors
 * @param execute - function to be executed
 * @param onFinish - callback to run when execute finishes
 */
function safeExecuteInTheMiddleAsync(execute, onFinish, preventThrowingError) {
    return __awaiter(this, void 0, void 0, function () {
        var error, result, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    return [4 /*yield*/, execute()];
                case 1:
                    result = _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    e_1 = _a.sent();
                    error = e_1;
                    return [3 /*break*/, 4];
                case 3:
                    onFinish(error, result);
                    if (error && !preventThrowingError) {
                        // eslint-disable-next-line no-unsafe-finally
                        throw error;
                    }
                    // eslint-disable-next-line no-unsafe-finally
                    return [2 /*return*/, result];
                case 4: return [2 /*return*/];
            }
        });
    });
}
/**
 * Checks if certain function has been already wrapped
 * @param func
 */
function isWrapped(func) {
    return (typeof func === 'function' &&
        typeof func.__original === 'function' &&
        typeof func.__unwrap === 'function' &&
        func.__wrapped === true);
}
//# sourceMappingURL=utils.js.map

/***/ }),
/* 1975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return OTLPExporterBase; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var OTLPExporterBase = /** @class */ (function () {
    function OTLPExporterBase(_delegate) {
        this._delegate = _delegate;
    }
    /**
     * Export items.
     * @param items
     * @param resultCallback
     */
    OTLPExporterBase.prototype.export = function (items, resultCallback) {
        this._delegate.export(items, resultCallback);
    };
    OTLPExporterBase.prototype.forceFlush = function () {
        return this._delegate.forceFlush();
    };
    OTLPExporterBase.prototype.shutdown = function () {
        return this._delegate.shutdown();
    };
    return OTLPExporterBase;
}());

//# sourceMappingURL=OTLPExporterBase.js.map

/***/ }),
/* 1976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createBoundedQueueExportPromiseHandler;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var BoundedQueueExportPromiseHandler = /** @class */ (function () {
    /**
     * @param concurrencyLimit maximum promises allowed in a queue at the same time.
     */
    function BoundedQueueExportPromiseHandler(concurrencyLimit) {
        this._sendingPromises = [];
        this._concurrencyLimit = concurrencyLimit;
    }
    BoundedQueueExportPromiseHandler.prototype.pushPromise = function (promise) {
        var _this = this;
        if (this.hasReachedLimit()) {
            throw new Error('Concurrency Limit reached');
        }
        this._sendingPromises.push(promise);
        var popPromise = function () {
            var index = _this._sendingPromises.indexOf(promise);
            _this._sendingPromises.splice(index, 1);
        };
        promise.then(popPromise, popPromise);
    };
    BoundedQueueExportPromiseHandler.prototype.hasReachedLimit = function () {
        return this._sendingPromises.length >= this._concurrencyLimit;
    };
    BoundedQueueExportPromiseHandler.prototype.awaitAll = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, Promise.all(this._sendingPromises)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return BoundedQueueExportPromiseHandler;
}());
/**
 * Promise queue for keeping track of export promises. Finished promises will be auto-dequeued.
 * Allows for awaiting all promises in the queue.
 */
function createBoundedQueueExportPromiseHandler(options) {
    return new BoundedQueueExportPromiseHandler(options.concurrencyLimit);
}
//# sourceMappingURL=bounded-queue-export-promise-handler.js.map

/***/ }),
/* 1977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createLegacyOtlpBrowserExportDelegate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__otlp_browser_http_export_delegate__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__convert_legacy_browser_http_options__ = __webpack_require__(926);


/**
 * @deprecated
 * @param config
 * @param serializer
 * @param signalResourcePath
 * @param requiredHeaders
 */
function createLegacyOtlpBrowserExportDelegate(config, serializer, signalResourcePath, requiredHeaders) {
    var useXhr = !!config.headers || typeof navigator.sendBeacon !== 'function';
    var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__convert_legacy_browser_http_options__["a" /* convertLegacyBrowserHttpOptions */])(config, signalResourcePath, requiredHeaders);
    if (useXhr) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__otlp_browser_http_export_delegate__["a" /* createOtlpXhrExportDelegate */])(options, serializer);
    }
    else {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__otlp_browser_http_export_delegate__["b" /* createOtlpSendBeaconExportDelegate */])(options, serializer);
    }
}
//# sourceMappingURL=create-legacy-browser-delegate.js.map

/***/ }),
/* 1978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export CompressionAlgorithm */
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var CompressionAlgorithm;
(function (CompressionAlgorithm) {
    CompressionAlgorithm["NONE"] = "none";
    CompressionAlgorithm["GZIP"] = "gzip";
})(CompressionAlgorithm || (CompressionAlgorithm = {}));
//# sourceMappingURL=legacy-node-configuration.js.map

/***/ }),
/* 1979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeOtlpHttpConfigurationWithDefaults;
/* harmony export (immutable) */ __webpack_exports__["b"] = getHttpConfigurationDefaults;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_configuration__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__(1988);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


function mergeHeaders(userProvidedHeaders, fallbackHeaders, defaultHeaders) {
    var requiredHeaders = __assign({}, defaultHeaders());
    var headers = {};
    return function () {
        // add fallback ones first
        if (fallbackHeaders != null) {
            Object.assign(headers, fallbackHeaders());
        }
        // override with user-provided ones
        if (userProvidedHeaders != null) {
            Object.assign(headers, userProvidedHeaders());
        }
        // override required ones.
        return Object.assign(headers, requiredHeaders);
    };
}
function validateUserProvidedUrl(url) {
    if (url == null) {
        return undefined;
    }
    try {
        new URL(url);
        return url;
    }
    catch (e) {
        throw new Error("Configuration: Could not parse user-provided export URL: '" + url + "'");
    }
}
/**
 * @param userProvidedConfiguration  Configuration options provided by the user in code.
 * @param fallbackConfiguration Fallback to use when the {@link userProvidedConfiguration} does not specify an option.
 * @param defaultConfiguration The defaults as defined by the exporter specification
 */
function mergeOtlpHttpConfigurationWithDefaults(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration) {
    var _a, _b, _c, _d;
    return __assign(__assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_configuration__["b" /* mergeOtlpSharedConfigurationWithDefaults */])(userProvidedConfiguration, fallbackConfiguration, defaultConfiguration)), { headers: mergeHeaders(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__util__["a" /* validateAndNormalizeHeaders */])(userProvidedConfiguration.headers), fallbackConfiguration.headers, defaultConfiguration.headers), url: (_b = (_a = validateUserProvidedUrl(userProvidedConfiguration.url)) !== null && _a !== void 0 ? _a : fallbackConfiguration.url) !== null && _b !== void 0 ? _b : defaultConfiguration.url, agentOptions: (_d = (_c = userProvidedConfiguration.agentOptions) !== null && _c !== void 0 ? _c : fallbackConfiguration.agentOptions) !== null && _d !== void 0 ? _d : defaultConfiguration.agentOptions });
}
function getHttpConfigurationDefaults(requiredHeaders, signalResourcePath) {
    return __assign(__assign({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_configuration__["c" /* getSharedConfigurationDefaults */])()), { headers: function () { return requiredHeaders; }, url: 'http://localhost:4318/' + signalResourcePath, agentOptions: { keepAlive: true } });
}
//# sourceMappingURL=otlp-http-configuration.js.map

/***/ }),
/* 1980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__otlp_browser_http_export_delegate__ = __webpack_require__(927);
/* unused harmony reexport createOtlpXhrExportDelegate */
/* unused harmony reexport createOtlpSendBeaconExportDelegate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__configuration_convert_legacy_browser_http_options__ = __webpack_require__(926);
/* unused harmony reexport convertLegacyBrowserHttpOptions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configuration_create_legacy_browser_delegate__ = __webpack_require__(1977);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__configuration_create_legacy_browser_delegate__["a"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



//# sourceMappingURL=index-browser-http.js.map

/***/ }),
/* 1981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OTLPExporterBase__ = __webpack_require__(1975);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__OTLPExporterBase__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(929);
/* unused harmony reexport OTLPExporterError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__configuration_shared_configuration__ = __webpack_require__(537);
/* unused harmony reexport mergeOtlpSharedConfigurationWithDefaults */
/* unused harmony reexport getSharedConfigurationDefaults */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__configuration_legacy_node_configuration__ = __webpack_require__(1978);
/* unused harmony reexport CompressionAlgorithm */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__otlp_network_export_delegate__ = __webpack_require__(928);
/* unused harmony reexport createOtlpNetworkExportDelegate */
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





//# sourceMappingURL=index.js.map

/***/ }),
/* 1982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isExportRetryable;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseRetryAfterToMills;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function isExportRetryable(statusCode) {
    var retryCodes = [429, 502, 503, 504];
    return retryCodes.includes(statusCode);
}
function parseRetryAfterToMills(retryAfter) {
    if (retryAfter == null) {
        return undefined;
    }
    var seconds = Number.parseInt(retryAfter, 10);
    if (Number.isInteger(seconds)) {
        return seconds > 0 ? seconds * 1000 : -1;
    }
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Retry-After#directives
    var delay = new Date(retryAfter).getTime() - Date.now();
    if (delay >= 0) {
        return delay;
    }
    return 0;
}
//# sourceMappingURL=is-export-retryable.js.map

/***/ }),
/* 1983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createLoggingPartialSuccessResponseHandler;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function isPartialSuccessResponse(response) {
    return Object.prototype.hasOwnProperty.call(response, 'partialSuccess');
}
/**
 * Default response handler that logs a partial success to the console.
 */
function createLoggingPartialSuccessResponseHandler() {
    return {
        handleResponse: function (response) {
            // Partial success MUST never be an empty object according the specification
            // see https://opentelemetry.io/docs/specs/otlp/#partial-success
            if (response == null ||
                !isPartialSuccessResponse(response) ||
                response.partialSuccess == null ||
                Object.keys(response.partialSuccess).length === 0) {
                return;
            }
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn('Received Partial Success response:', JSON.stringify(response.partialSuccess));
        },
    };
}
//# sourceMappingURL=logging-response-handler.js.map

/***/ }),
/* 1984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createOtlpExportDelegate;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__types__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__logging_response_handler__ = __webpack_require__(1983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__opentelemetry_api__ = __webpack_require__(32);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};




var OTLPExportDelegate = /** @class */ (function () {
    function OTLPExportDelegate(_transport, _serializer, _responseHandler, _promiseQueue, _timeout) {
        this._transport = _transport;
        this._serializer = _serializer;
        this._responseHandler = _responseHandler;
        this._promiseQueue = _promiseQueue;
        this._timeout = _timeout;
        this._diagLogger = __WEBPACK_IMPORTED_MODULE_3__opentelemetry_api__["diag"].createComponentLogger({
            namespace: 'OTLPExportDelegate',
        });
    }
    OTLPExportDelegate.prototype.export = function (internalRepresentation, resultCallback) {
        var _this = this;
        this._diagLogger.debug('items to be sent', internalRepresentation);
        // don't do any work if too many exports are in progress.
        if (this._promiseQueue.hasReachedLimit()) {
            resultCallback({
                code: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["ExportResultCode"].FAILED,
                error: new Error('Concurrent export limit reached'),
            });
            return;
        }
        var serializedRequest = this._serializer.serializeRequest(internalRepresentation);
        if (serializedRequest == null) {
            resultCallback({
                code: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["ExportResultCode"].FAILED,
                error: new Error('Nothing to send'),
            });
            return;
        }
        this._promiseQueue.pushPromise(this._transport.send(serializedRequest, this._timeout).then(function (response) {
            if (response.status === 'success') {
                if (response.data != null) {
                    try {
                        _this._responseHandler.handleResponse(_this._serializer.deserializeResponse(response.data));
                    }
                    catch (e) {
                        _this._diagLogger.warn('Export succeeded but could not deserialize response - is the response specification compliant?', e, response.data);
                    }
                }
                // No matter the response, we can consider the export still successful.
                resultCallback({
                    code: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["ExportResultCode"].SUCCESS,
                });
                return;
            }
            else if (response.status === 'failure' && response.error) {
                resultCallback({
                    code: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["ExportResultCode"].FAILED,
                    error: response.error,
                });
                return;
            }
            else if (response.status === 'retryable') {
                resultCallback({
                    code: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["ExportResultCode"].FAILED,
                    error: new __WEBPACK_IMPORTED_MODULE_1__types__["a" /* OTLPExporterError */]('Export failed with retryable status'),
                });
            }
            else {
                resultCallback({
                    code: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["ExportResultCode"].FAILED,
                    error: new __WEBPACK_IMPORTED_MODULE_1__types__["a" /* OTLPExporterError */]('Export failed with unknown error'),
                });
            }
        }, function (reason) {
            return resultCallback({
                code: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["ExportResultCode"].FAILED,
                error: reason,
            });
        }));
    };
    OTLPExportDelegate.prototype.forceFlush = function () {
        return this._promiseQueue.awaitAll();
    };
    OTLPExportDelegate.prototype.shutdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._diagLogger.debug('shutdown started');
                        return [4 /*yield*/, this.forceFlush()];
                    case 1:
                        _a.sent();
                        this._transport.shutdown();
                        return [2 /*return*/];
                }
            });
        });
    };
    return OTLPExportDelegate;
}());
/**
 * Creates a generic delegate for OTLP exports which only contains parts of the OTLP export that are shared across all
 * signals.
 */
function createOtlpExportDelegate(components, settings) {
    return new OTLPExportDelegate(components.transport, components.serializer, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__logging_response_handler__["a" /* createLoggingPartialSuccessResponseHandler */])(), components.promiseHandler, settings.timeout);
}
//# sourceMappingURL=otlp-export-delegate.js.map

/***/ }),
/* 1985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createRetryingTransport;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var MAX_ATTEMPTS = 5;
var INITIAL_BACKOFF = 1000;
var MAX_BACKOFF = 5000;
var BACKOFF_MULTIPLIER = 1.5;
var JITTER = 0.2;
/**
 * Get a pseudo-random jitter that falls in the range of [-JITTER, +JITTER]
 */
function getJitter() {
    return Math.random() * (2 * JITTER) - JITTER;
}
var RetryingTransport = /** @class */ (function () {
    function RetryingTransport(_transport) {
        this._transport = _transport;
    }
    RetryingTransport.prototype.retry = function (data, timeoutMillis, inMillis) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            setTimeout(function () {
                _this._transport.send(data, timeoutMillis).then(resolve, reject);
            }, inMillis);
        });
    };
    RetryingTransport.prototype.send = function (data, timeoutMillis) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var deadline, result, attempts, nextBackoff, backoff, retryInMillis, remainingTimeoutMillis;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        deadline = Date.now() + timeoutMillis;
                        return [4 /*yield*/, this._transport.send(data, timeoutMillis)];
                    case 1:
                        result = _b.sent();
                        attempts = MAX_ATTEMPTS;
                        nextBackoff = INITIAL_BACKOFF;
                        _b.label = 2;
                    case 2:
                        if (!(result.status === 'retryable' && attempts > 0)) return [3 /*break*/, 4];
                        attempts--;
                        backoff = Math.max(Math.min(nextBackoff, MAX_BACKOFF) + getJitter(), 0);
                        nextBackoff = nextBackoff * BACKOFF_MULTIPLIER;
                        retryInMillis = (_a = result.retryInMillis) !== null && _a !== void 0 ? _a : backoff;
                        remainingTimeoutMillis = deadline - Date.now();
                        if (retryInMillis > remainingTimeoutMillis) {
                            return [2 /*return*/, result];
                        }
                        return [4 /*yield*/, this.retry(data, remainingTimeoutMillis, retryInMillis)];
                    case 3:
                        result = _b.sent();
                        return [3 /*break*/, 2];
                    case 4: return [2 /*return*/, result];
                }
            });
        });
    };
    RetryingTransport.prototype.shutdown = function () {
        return this._transport.shutdown();
    };
    return RetryingTransport;
}());
/**
 * Creates an Exporter Transport that retries on 'retryable' response.
 */
function createRetryingTransport(options) {
    return new RetryingTransport(options.transport);
}
//# sourceMappingURL=retrying-transport.js.map

/***/ }),
/* 1986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSendBeaconTransport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var SendBeaconTransport = /** @class */ (function () {
    function SendBeaconTransport(_params) {
        this._params = _params;
    }
    SendBeaconTransport.prototype.send = function (data) {
        var _this = this;
        return new Promise(function (resolve) {
            if (navigator.sendBeacon(_this._params.url, new Blob([data], { type: _this._params.blobType }))) {
                // no way to signal retry, treat everything as success
                __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].debug('SendBeacon success');
                resolve({
                    status: 'success',
                });
            }
            else {
                resolve({
                    status: 'failure',
                    error: new Error('SendBeacon failed'),
                });
            }
        });
    };
    SendBeaconTransport.prototype.shutdown = function () {
        // Intentionally left empty, nothing to do.
    };
    return SendBeaconTransport;
}());
function createSendBeaconTransport(parameters) {
    return new SendBeaconTransport(parameters);
}
//# sourceMappingURL=send-beacon-transport.js.map

/***/ }),
/* 1987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createXhrTransport;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__is_export_retryable__ = __webpack_require__(1982);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};


var XhrTransport = /** @class */ (function () {
    function XhrTransport(_parameters) {
        this._parameters = _parameters;
    }
    XhrTransport.prototype.send = function (data, timeoutMillis) {
        var _this = this;
        return new Promise(function (resolve) {
            var xhr = new XMLHttpRequest();
            xhr.timeout = timeoutMillis;
            xhr.open('POST', _this._parameters.url);
            var headers = _this._parameters.headers();
            Object.entries(headers).forEach(function (_a) {
                var _b = __read(_a, 2), k = _b[0], v = _b[1];
                xhr.setRequestHeader(k, v);
            });
            xhr.ontimeout = function (_) {
                resolve({
                    status: 'failure',
                    error: new Error('XHR request timed out'),
                });
            };
            xhr.onreadystatechange = function () {
                if (xhr.status >= 200 && xhr.status <= 299) {
                    __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].debug('XHR success');
                    resolve({
                        status: 'success',
                    });
                }
                else if (xhr.status && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__is_export_retryable__["a" /* isExportRetryable */])(xhr.status)) {
                    resolve({
                        status: 'retryable',
                        retryInMillis: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__is_export_retryable__["b" /* parseRetryAfterToMills */])(xhr.getResponseHeader('Retry-After')),
                    });
                }
                else if (xhr.status !== 0) {
                    resolve({
                        status: 'failure',
                        error: new Error('XHR request failed with non-retryable status'),
                    });
                }
            };
            xhr.onabort = function () {
                resolve({
                    status: 'failure',
                    error: new Error('XHR request aborted'),
                });
            };
            xhr.onerror = function () {
                resolve({
                    status: 'failure',
                    error: new Error('XHR request errored'),
                });
            };
            xhr.send(data);
        });
    };
    XhrTransport.prototype.shutdown = function () {
        // Intentionally left empty, nothing to do.
    };
    return XhrTransport;
}());
/**
 * Creates an exporter transport that uses XHR to send the data
 * @param parameters applied to each request made by transport
 */
function createXhrTransport(parameters) {
    return new XhrTransport(parameters);
}
//# sourceMappingURL=xhr-transport.js.map

/***/ }),
/* 1988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateAndNormalizeHeaders;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

/**
 * Parses headers from config leaving only those that have defined values
 * @param partialHeaders
 */
function validateAndNormalizeHeaders(partialHeaders) {
    return function () {
        var _a;
        var headers = {};
        Object.entries((_a = partialHeaders === null || partialHeaders === void 0 ? void 0 : partialHeaders()) !== null && _a !== void 0 ? _a : {}).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            if (typeof value !== 'undefined') {
                headers[key] = String(value);
            }
            else {
                __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn("Header \"" + key + "\" has invalid value (" + value + ") and will be ignored");
            }
        });
        return headers;
    };
}
//# sourceMappingURL=util.js.map

/***/ }),
/* 1989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = createResource;
/* harmony export (immutable) */ __webpack_exports__["b"] = createInstrumentationScope;
/* harmony export (immutable) */ __webpack_exports__["a"] = toAttributes;
/* unused harmony export toKeyValue */
/* unused harmony export toAnyValue */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
function createResource(resource) {
    return {
        attributes: toAttributes(resource.attributes),
        droppedAttributesCount: 0,
    };
}
function createInstrumentationScope(scope) {
    return {
        name: scope.name,
        version: scope.version,
    };
}
function toAttributes(attributes) {
    return Object.keys(attributes).map(function (key) { return toKeyValue(key, attributes[key]); });
}
function toKeyValue(key, value) {
    return {
        key: key,
        value: toAnyValue(value),
    };
}
function toAnyValue(value) {
    var t = typeof value;
    if (t === 'string')
        return { stringValue: value };
    if (t === 'number') {
        if (!Number.isInteger(value))
            return { doubleValue: value };
        return { intValue: value };
    }
    if (t === 'boolean')
        return { boolValue: value };
    if (value instanceof Uint8Array)
        return { bytesValue: value };
    if (Array.isArray(value))
        return { arrayValue: { values: value.map(toAnyValue) } };
    if (t === 'object' && value != null)
        return {
            kvlistValue: {
                values: Object.entries(value).map(function (_a) {
                    var _b = __read(_a, 2), k = _b[0], v = _b[1];
                    return toKeyValue(k, v);
                }),
            },
        };
    return {};
}
//# sourceMappingURL=internal.js.map

/***/ }),
/* 1990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hrTimeToNanos */
/* unused harmony export toLongBits */
/* unused harmony export encodeAsLongBits */
/* unused harmony export encodeAsString */
/* harmony export (immutable) */ __webpack_exports__["a"] = getOtlpEncoder;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__ = __webpack_require__(65);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

function hrTimeToNanos(hrTime) {
    var NANOSECONDS = BigInt(1000000000);
    return BigInt(hrTime[0]) * NANOSECONDS + BigInt(hrTime[1]);
}
function toLongBits(value) {
    var low = Number(BigInt.asUintN(32, value));
    var high = Number(BigInt.asUintN(32, value >> BigInt(32)));
    return { low: low, high: high };
}
function encodeAsLongBits(hrTime) {
    var nanos = hrTimeToNanos(hrTime);
    return toLongBits(nanos);
}
function encodeAsString(hrTime) {
    var nanos = hrTimeToNanos(hrTime);
    return nanos.toString();
}
var encodeTimestamp = typeof BigInt !== 'undefined' ? encodeAsString : __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["hrTimeToNanoseconds"];
function identity(value) {
    return value;
}
function optionalHexToBinary(str) {
    if (str === undefined)
        return undefined;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["hexToBinary"])(str);
}
var DEFAULT_ENCODER = {
    encodeHrTime: encodeAsLongBits,
    encodeSpanContext: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["hexToBinary"],
    encodeOptionalSpanContext: optionalHexToBinary,
};
function getOtlpEncoder(options) {
    var _a, _b;
    if (options === undefined) {
        return DEFAULT_ENCODER;
    }
    var useLongBits = (_a = options.useLongBits) !== null && _a !== void 0 ? _a : true;
    var useHex = (_b = options.useHex) !== null && _b !== void 0 ? _b : false;
    return {
        encodeHrTime: useLongBits ? encodeAsLongBits : encodeTimestamp,
        encodeSpanContext: useHex ? identity : __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["hexToBinary"],
        encodeOptionalSpanContext: useHex ? identity : optionalHexToBinary,
    };
}
//# sourceMappingURL=utils.js.map

/***/ }),
/* 1991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sdkSpanToOtlpSpan */
/* unused harmony export toOtlpLink */
/* unused harmony export toOtlpSpanEvent */
/* harmony export (immutable) */ __webpack_exports__["a"] = createExportTraceServiceRequest;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_internal__ = __webpack_require__(1989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_utils__ = __webpack_require__(1990);
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};


function sdkSpanToOtlpSpan(span, encoder) {
    var _a;
    var ctx = span.spanContext();
    var status = span.status;
    return {
        traceId: encoder.encodeSpanContext(ctx.traceId),
        spanId: encoder.encodeSpanContext(ctx.spanId),
        parentSpanId: encoder.encodeOptionalSpanContext(span.parentSpanId),
        traceState: (_a = ctx.traceState) === null || _a === void 0 ? void 0 : _a.serialize(),
        name: span.name,
        // Span kind is offset by 1 because the API does not define a value for unset
        kind: span.kind == null ? 0 : span.kind + 1,
        startTimeUnixNano: encoder.encodeHrTime(span.startTime),
        endTimeUnixNano: encoder.encodeHrTime(span.endTime),
        attributes: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_internal__["a" /* toAttributes */])(span.attributes),
        droppedAttributesCount: span.droppedAttributesCount,
        events: span.events.map(function (event) { return toOtlpSpanEvent(event, encoder); }),
        droppedEventsCount: span.droppedEventsCount,
        status: {
            // API and proto enums share the same values
            code: status.code,
            message: status.message,
        },
        links: span.links.map(function (link) { return toOtlpLink(link, encoder); }),
        droppedLinksCount: span.droppedLinksCount,
    };
}
function toOtlpLink(link, encoder) {
    var _a;
    return {
        attributes: link.attributes ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_internal__["a" /* toAttributes */])(link.attributes) : [],
        spanId: encoder.encodeSpanContext(link.context.spanId),
        traceId: encoder.encodeSpanContext(link.context.traceId),
        traceState: (_a = link.context.traceState) === null || _a === void 0 ? void 0 : _a.serialize(),
        droppedAttributesCount: link.droppedAttributesCount || 0,
    };
}
function toOtlpSpanEvent(timedEvent, encoder) {
    return {
        attributes: timedEvent.attributes
            ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_internal__["a" /* toAttributes */])(timedEvent.attributes)
            : [],
        name: timedEvent.name,
        timeUnixNano: encoder.encodeHrTime(timedEvent.time),
        droppedAttributesCount: timedEvent.droppedAttributesCount || 0,
    };
}
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function createExportTraceServiceRequest(spans, options) {
    var encoder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__common_utils__["a" /* getOtlpEncoder */])(options);
    return {
        resourceSpans: spanRecordsToResourceSpans(spans, encoder),
    };
}
function createResourceMap(readableSpans) {
    var e_1, _a;
    var resourceMap = new Map();
    try {
        for (var readableSpans_1 = __values(readableSpans), readableSpans_1_1 = readableSpans_1.next(); !readableSpans_1_1.done; readableSpans_1_1 = readableSpans_1.next()) {
            var record = readableSpans_1_1.value;
            var ilmMap = resourceMap.get(record.resource);
            if (!ilmMap) {
                ilmMap = new Map();
                resourceMap.set(record.resource, ilmMap);
            }
            // TODO this is duplicated in basic tracer. Consolidate on a common helper in core
            var instrumentationLibraryKey = record.instrumentationLibrary.name + "@" + (record.instrumentationLibrary.version || '') + ":" + (record.instrumentationLibrary.schemaUrl || '');
            var records = ilmMap.get(instrumentationLibraryKey);
            if (!records) {
                records = [];
                ilmMap.set(instrumentationLibraryKey, records);
            }
            records.push(record);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (readableSpans_1_1 && !readableSpans_1_1.done && (_a = readableSpans_1.return)) _a.call(readableSpans_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return resourceMap;
}
function spanRecordsToResourceSpans(readableSpans, encoder) {
    var resourceMap = createResourceMap(readableSpans);
    var out = [];
    var entryIterator = resourceMap.entries();
    var entry = entryIterator.next();
    while (!entry.done) {
        var _a = __read(entry.value, 2), resource = _a[0], ilmMap = _a[1];
        var scopeResourceSpans = [];
        var ilmIterator = ilmMap.values();
        var ilmEntry = ilmIterator.next();
        while (!ilmEntry.done) {
            var scopeSpans = ilmEntry.value;
            if (scopeSpans.length > 0) {
                var spans = scopeSpans.map(function (readableSpan) {
                    return sdkSpanToOtlpSpan(readableSpan, encoder);
                });
                scopeResourceSpans.push({
                    scope: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_internal__["b" /* createInstrumentationScope */])(scopeSpans[0].instrumentationLibrary),
                    spans: spans,
                    schemaUrl: scopeSpans[0].instrumentationLibrary.schemaUrl,
                });
            }
            ilmEntry = ilmIterator.next();
        }
        // TODO SDK types don't provide resource schema URL at this time
        var transformedSpans = {
            resource: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__common_internal__["c" /* createResource */])(resource),
            scopeSpans: scopeResourceSpans,
            schemaUrl: undefined,
        };
        out.push(transformedSpans);
        entry = entryIterator.next();
    }
    return out;
}
//# sourceMappingURL=internal.js.map

/***/ }),
/* 1992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__trace__ = __webpack_require__(1993);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__trace__["a"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// IMPORTANT: exports added here are public

//# sourceMappingURL=index.js.map

/***/ }),
/* 1993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return JsonTraceSerializer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal__ = __webpack_require__(1991);

var JsonTraceSerializer = {
    serializeRequest: function (arg) {
        var request = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal__["a" /* createExportTraceServiceRequest */])(arg, {
            useHex: true,
            useLongBits: false,
        });
        var encoder = new TextEncoder();
        return encoder.encode(JSON.stringify(request));
    },
    deserializeResponse: function (arg) {
        var decoder = new TextDecoder();
        return JSON.parse(decoder.decode(arg));
    },
};
//# sourceMappingURL=trace.js.map

/***/ }),
/* 1994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return detectResources; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return detectResourcesSync; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Resource__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(2007);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};



/**
 * Runs all resource detectors and returns the results merged into a single Resource. Promise
 * does not resolve until all the underlying detectors have resolved, unlike
 * detectResourcesSync.
 *
 * @deprecated use detectResourcesSync() instead.
 * @param config Configuration for resource detection
 */
var detectResources = function (config) {
    if (config === void 0) { config = {}; }
    return __awaiter(void 0, void 0, void 0, function () {
        var resources;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all((config.detectors || []).map(function (d) { return __awaiter(void 0, void 0, void 0, function () {
                        var resource, e_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, d.detect(config)];
                                case 1:
                                    resource = _a.sent();
                                    __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__["diag"].debug(d.constructor.name + " found resource.", resource);
                                    return [2 /*return*/, resource];
                                case 2:
                                    e_1 = _a.sent();
                                    __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__["diag"].debug(d.constructor.name + " failed: " + e_1.message);
                                    return [2 /*return*/, __WEBPACK_IMPORTED_MODULE_0__Resource__["a" /* Resource */].empty()];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); }))];
                case 1:
                    resources = _a.sent();
                    // Future check if verbose logging is enabled issue #1903
                    logResources(resources);
                    return [2 /*return*/, resources.reduce(function (acc, resource) { return acc.merge(resource); }, __WEBPACK_IMPORTED_MODULE_0__Resource__["a" /* Resource */].empty())];
            }
        });
    });
};
/**
 * Runs all resource detectors synchronously, merging their results. In case of attribute collision later resources will take precedence.
 *
 * @param config Configuration for resource detection
 */
var detectResourcesSync = function (config) {
    var _a;
    if (config === void 0) { config = {}; }
    var resources = ((_a = config.detectors) !== null && _a !== void 0 ? _a : []).map(function (d) {
        try {
            var resourceOrPromise_1 = d.detect(config);
            var resource_1;
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* isPromiseLike */])(resourceOrPromise_1)) {
                var createPromise = function () { return __awaiter(void 0, void 0, void 0, function () {
                    var resolvedResource;
                    var _a;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0: return [4 /*yield*/, resourceOrPromise_1];
                            case 1:
                                resolvedResource = _b.sent();
                                return [4 /*yield*/, ((_a = resolvedResource.waitForAsyncAttributes) === null || _a === void 0 ? void 0 : _a.call(resolvedResource))];
                            case 2:
                                _b.sent();
                                return [2 /*return*/, resolvedResource.attributes];
                        }
                    });
                }); };
                resource_1 = new __WEBPACK_IMPORTED_MODULE_0__Resource__["a" /* Resource */]({}, createPromise());
            }
            else {
                resource_1 = resourceOrPromise_1;
            }
            if (resource_1.waitForAsyncAttributes) {
                void resource_1
                    .waitForAsyncAttributes()
                    .then(function () {
                    return __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__["diag"].debug(d.constructor.name + " found resource.", resource_1);
                });
            }
            else {
                __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__["diag"].debug(d.constructor.name + " found resource.", resource_1);
            }
            return resource_1;
        }
        catch (e) {
            __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__["diag"].error(d.constructor.name + " failed: " + e.message);
            return __WEBPACK_IMPORTED_MODULE_0__Resource__["a" /* Resource */].empty();
        }
    });
    var mergedResources = resources.reduce(function (acc, resource) { return acc.merge(resource); }, __WEBPACK_IMPORTED_MODULE_0__Resource__["a" /* Resource */].empty());
    if (mergedResources.waitForAsyncAttributes) {
        void mergedResources.waitForAsyncAttributes().then(function () {
            // Future check if verbose logging is enabled issue #1903
            logResources(resources);
        });
    }
    return mergedResources;
};
/**
 * Writes debug information about the detected resources to the logger defined in the resource detection config, if one is provided.
 *
 * @param resources The array of {@link Resource} that should be logged. Empty entries will be ignored.
 */
var logResources = function (resources) {
    resources.forEach(function (resource) {
        // Print only populated resources
        if (Object.keys(resource.attributes).length > 0) {
            var resourceDebugString = JSON.stringify(resource.attributes, null, 4);
            __WEBPACK_IMPORTED_MODULE_1__opentelemetry_api__["diag"].verbose(resourceDebugString);
        }
    });
};
//# sourceMappingURL=detect-resources.js.map

/***/ }),
/* 1995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return browserDetector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserDetectorSync__ = __webpack_require__(930);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * BrowserDetector will be used to detect the resources related to browser.
 */
var BrowserDetector = /** @class */ (function () {
    function BrowserDetector() {
    }
    BrowserDetector.prototype.detect = function (config) {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0__BrowserDetectorSync__["a" /* browserDetectorSync */].detect(config));
    };
    return BrowserDetector;
}());
var browserDetector = new BrowserDetector();
//# sourceMappingURL=BrowserDetector.js.map

/***/ }),
/* 1996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return envDetector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__EnvDetectorSync__ = __webpack_require__(931);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * EnvDetector can be used to detect the presence of and create a Resource
 * from the OTEL_RESOURCE_ATTRIBUTES environment variable.
 */
var EnvDetector = /** @class */ (function () {
    function EnvDetector() {
    }
    /**
     * Returns a {@link Resource} populated with attributes from the
     * OTEL_RESOURCE_ATTRIBUTES environment variable. Note this is an async
     * function to conform to the Detector interface.
     *
     * @param config The resource detection config
     */
    EnvDetector.prototype.detect = function (config) {
        return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0__EnvDetectorSync__["a" /* envDetectorSync */].detect(config));
    };
    return EnvDetector;
}());
var envDetector = new EnvDetector();
//# sourceMappingURL=EnvDetector.js.map

/***/ }),
/* 1997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__platform__ = __webpack_require__(2005);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__platform__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__platform__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__platform__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__platform__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__platform__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__platform__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__platform__["g"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BrowserDetector__ = __webpack_require__(1995);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__BrowserDetector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__EnvDetector__ = __webpack_require__(1996);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__EnvDetector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__BrowserDetectorSync__ = __webpack_require__(930);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__BrowserDetectorSync__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EnvDetectorSync__ = __webpack_require__(931);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__EnvDetectorSync__["a"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





//# sourceMappingURL=index.js.map

/***/ }),
/* 1998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hostDetector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NoopDetector__ = __webpack_require__(374);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var hostDetector = __WEBPACK_IMPORTED_MODULE_0__NoopDetector__["a" /* noopDetector */];
//# sourceMappingURL=HostDetector.js.map

/***/ }),
/* 1999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return hostDetectorSync; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NoopDetectorSync__ = __webpack_require__(375);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var hostDetectorSync = __WEBPACK_IMPORTED_MODULE_0__NoopDetectorSync__["a" /* noopDetectorSync */];
//# sourceMappingURL=HostDetectorSync.js.map

/***/ }),
/* 2000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return osDetector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NoopDetector__ = __webpack_require__(374);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var osDetector = __WEBPACK_IMPORTED_MODULE_0__NoopDetector__["a" /* noopDetector */];
//# sourceMappingURL=OSDetector.js.map

/***/ }),
/* 2001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return osDetectorSync; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NoopDetectorSync__ = __webpack_require__(375);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var osDetectorSync = __WEBPACK_IMPORTED_MODULE_0__NoopDetectorSync__["a" /* noopDetectorSync */];
//# sourceMappingURL=OSDetectorSync.js.map

/***/ }),
/* 2002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return processDetector; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NoopDetector__ = __webpack_require__(374);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var processDetector = __WEBPACK_IMPORTED_MODULE_0__NoopDetector__["a" /* noopDetector */];
//# sourceMappingURL=ProcessDetector.js.map

/***/ }),
/* 2003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return processDetectorSync; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NoopDetector__ = __webpack_require__(374);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var processDetectorSync = __WEBPACK_IMPORTED_MODULE_0__NoopDetector__["a" /* noopDetector */];
//# sourceMappingURL=ProcessDetectorSync.js.map

/***/ }),
/* 2004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serviceInstanceIdDetectorSync; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NoopDetectorSync__ = __webpack_require__(375);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @experimental
 */
var serviceInstanceIdDetectorSync = __WEBPACK_IMPORTED_MODULE_0__NoopDetectorSync__["a" /* noopDetectorSync */];
//# sourceMappingURL=ServiceInstanceIdDetectorSync.js.map

/***/ }),
/* 2005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__HostDetector__ = __webpack_require__(1998);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__HostDetector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HostDetectorSync__ = __webpack_require__(1999);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__HostDetectorSync__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__OSDetector__ = __webpack_require__(2000);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__OSDetector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OSDetectorSync__ = __webpack_require__(2001);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__OSDetectorSync__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ProcessDetector__ = __webpack_require__(2002);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__ProcessDetector__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ProcessDetectorSync__ = __webpack_require__(2003);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__ProcessDetectorSync__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ServiceInstanceIdDetectorSync__ = __webpack_require__(2004);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__ServiceInstanceIdDetectorSync__["a"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */







//# sourceMappingURL=index.js.map

/***/ }),
/* 2006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultServiceName;
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function defaultServiceName() {
    return 'unknown_service';
}
//# sourceMappingURL=default-service-name.js.map

/***/ }),
/* 2007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isPromiseLike; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var isPromiseLike = function (val) {
    return (val !== null && typeof val === 'object' && typeof val.then === 'function');
};
//# sourceMappingURL=utils.js.map

/***/ }),
/* 2008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ForceFlushState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BasicTracerProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__opentelemetry_resources__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Tracer__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__MultiSpanProcessor__ = __webpack_require__(2009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__export_NoopSpanProcessor__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__platform__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utility__ = __webpack_require__(940);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};









var ForceFlushState;
(function (ForceFlushState) {
    ForceFlushState[ForceFlushState["resolved"] = 0] = "resolved";
    ForceFlushState[ForceFlushState["timeout"] = 1] = "timeout";
    ForceFlushState[ForceFlushState["error"] = 2] = "error";
    ForceFlushState[ForceFlushState["unresolved"] = 3] = "unresolved";
})(ForceFlushState || (ForceFlushState = {}));
/**
 * This class represents a basic tracer provider which platform libraries can extend
 */
var BasicTracerProvider = /** @class */ (function () {
    function BasicTracerProvider(config) {
        if (config === void 0) { config = {}; }
        var _a, _b;
        this._registeredSpanProcessors = [];
        this._tracers = new Map();
        var mergedConfig = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["merge"])({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__config__["a" /* loadDefaultConfig */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utility__["a" /* reconfigureLimits */])(config));
        this.resource = (_a = mergedConfig.resource) !== null && _a !== void 0 ? _a : __WEBPACK_IMPORTED_MODULE_2__opentelemetry_resources__["Resource"].empty();
        if (mergedConfig.mergeResourceWithDefaults) {
            this.resource = __WEBPACK_IMPORTED_MODULE_2__opentelemetry_resources__["Resource"].default().merge(this.resource);
        }
        this._config = Object.assign({}, mergedConfig, {
            resource: this.resource,
        });
        if ((_b = config.spanProcessors) === null || _b === void 0 ? void 0 : _b.length) {
            this._registeredSpanProcessors = __spreadArray([], __read(config.spanProcessors), false);
            this.activeSpanProcessor = new __WEBPACK_IMPORTED_MODULE_5__MultiSpanProcessor__["a" /* MultiSpanProcessor */](this._registeredSpanProcessors);
        }
        else {
            var defaultExporter = this._buildExporterFromEnv();
            if (defaultExporter !== undefined) {
                var batchProcessor = new __WEBPACK_IMPORTED_MODULE_7__platform__["a" /* BatchSpanProcessor */](defaultExporter);
                this.activeSpanProcessor = batchProcessor;
            }
            else {
                this.activeSpanProcessor = new __WEBPACK_IMPORTED_MODULE_6__export_NoopSpanProcessor__["a" /* NoopSpanProcessor */]();
            }
        }
    }
    BasicTracerProvider.prototype.getTracer = function (name, version, options) {
        var key = name + "@" + (version || '') + ":" + ((options === null || options === void 0 ? void 0 : options.schemaUrl) || '');
        if (!this._tracers.has(key)) {
            this._tracers.set(key, new __WEBPACK_IMPORTED_MODULE_3__Tracer__["a" /* Tracer */]({ name: name, version: version, schemaUrl: options === null || options === void 0 ? void 0 : options.schemaUrl }, this._config, this));
        }
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return this._tracers.get(key);
    };
    /**
     * @deprecated please use {@link TracerConfig} spanProcessors property
     * Adds a new {@link SpanProcessor} to this tracer.
     * @param spanProcessor the new SpanProcessor to be added.
     */
    BasicTracerProvider.prototype.addSpanProcessor = function (spanProcessor) {
        if (this._registeredSpanProcessors.length === 0) {
            // since we might have enabled by default a batchProcessor, we disable it
            // before adding the new one
            this.activeSpanProcessor
                .shutdown()
                .catch(function (err) {
                return __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].error('Error while trying to shutdown current span processor', err);
            });
        }
        this._registeredSpanProcessors.push(spanProcessor);
        this.activeSpanProcessor = new __WEBPACK_IMPORTED_MODULE_5__MultiSpanProcessor__["a" /* MultiSpanProcessor */](this._registeredSpanProcessors);
    };
    BasicTracerProvider.prototype.getActiveSpanProcessor = function () {
        return this.activeSpanProcessor;
    };
    /**
     * Register this TracerProvider for use with the OpenTelemetry API.
     * Undefined values may be replaced with defaults, and
     * null values will be skipped.
     *
     * @param config Configuration object for SDK registration
     */
    BasicTracerProvider.prototype.register = function (config) {
        if (config === void 0) { config = {}; }
        __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["trace"].setGlobalTracerProvider(this);
        if (config.propagator === undefined) {
            config.propagator = this._buildPropagatorFromEnv();
        }
        if (config.contextManager) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].setGlobalContextManager(config.contextManager);
        }
        if (config.propagator) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["propagation"].setGlobalPropagator(config.propagator);
        }
    };
    BasicTracerProvider.prototype.forceFlush = function () {
        var timeout = this._config.forceFlushTimeoutMillis;
        var promises = this._registeredSpanProcessors.map(function (spanProcessor) {
            return new Promise(function (resolve) {
                var state;
                var timeoutInterval = setTimeout(function () {
                    resolve(new Error("Span processor did not completed within timeout period of " + timeout + " ms"));
                    state = ForceFlushState.timeout;
                }, timeout);
                spanProcessor
                    .forceFlush()
                    .then(function () {
                    clearTimeout(timeoutInterval);
                    if (state !== ForceFlushState.timeout) {
                        state = ForceFlushState.resolved;
                        resolve(state);
                    }
                })
                    .catch(function (error) {
                    clearTimeout(timeoutInterval);
                    state = ForceFlushState.error;
                    resolve(error);
                });
            });
        });
        return new Promise(function (resolve, reject) {
            Promise.all(promises)
                .then(function (results) {
                var errors = results.filter(function (result) { return result !== ForceFlushState.resolved; });
                if (errors.length > 0) {
                    reject(errors);
                }
                else {
                    resolve();
                }
            })
                .catch(function (error) { return reject([error]); });
        });
    };
    BasicTracerProvider.prototype.shutdown = function () {
        return this.activeSpanProcessor.shutdown();
    };
    /**
     * TS cannot yet infer the type of this.constructor:
     * https://github.com/Microsoft/TypeScript/issues/3841#issuecomment-337560146
     * There is no need to override either of the getters in your child class.
     * The type of the registered component maps should be the same across all
     * classes in the inheritance tree.
     */
    BasicTracerProvider.prototype._getPropagator = function (name) {
        var _a;
        return (_a = this.constructor._registeredPropagators.get(name)) === null || _a === void 0 ? void 0 : _a();
    };
    BasicTracerProvider.prototype._getSpanExporter = function (name) {
        var _a;
        return (_a = this.constructor._registeredExporters.get(name)) === null || _a === void 0 ? void 0 : _a();
    };
    BasicTracerProvider.prototype._buildPropagatorFromEnv = function () {
        var _this = this;
        // per spec, propagators from env must be deduplicated
        var uniquePropagatorNames = Array.from(new Set(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["getEnv"])().OTEL_PROPAGATORS));
        var propagators = uniquePropagatorNames.map(function (name) {
            var propagator = _this._getPropagator(name);
            if (!propagator) {
                __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn("Propagator \"" + name + "\" requested through environment variable is unavailable.");
            }
            return propagator;
        });
        var validPropagators = propagators.reduce(function (list, item) {
            if (item) {
                list.push(item);
            }
            return list;
        }, []);
        if (validPropagators.length === 0) {
            return;
        }
        else if (uniquePropagatorNames.length === 1) {
            return validPropagators[0];
        }
        else {
            return new __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["CompositePropagator"]({
                propagators: validPropagators,
            });
        }
    };
    BasicTracerProvider.prototype._buildExporterFromEnv = function () {
        var exporterName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["getEnv"])().OTEL_TRACES_EXPORTER;
        if (exporterName === 'none' || exporterName === '')
            return;
        var exporter = this._getSpanExporter(exporterName);
        if (!exporter) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].error("Exporter \"" + exporterName + "\" requested through environment variable is unavailable.");
        }
        return exporter;
    };
    BasicTracerProvider._registeredPropagators = new Map([
        ['tracecontext', function () { return new __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["W3CTraceContextPropagator"](); }],
        ['baggage', function () { return new __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["W3CBaggagePropagator"](); }],
    ]);
    BasicTracerProvider._registeredExporters = new Map();
    return BasicTracerProvider;
}());

//# sourceMappingURL=BasicTracerProvider.js.map

/***/ }),
/* 2009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MultiSpanProcessor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__ = __webpack_require__(65);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

/**
 * Implementation of the {@link SpanProcessor} that simply forwards all
 * received events to a list of {@link SpanProcessor}s.
 */
var MultiSpanProcessor = /** @class */ (function () {
    function MultiSpanProcessor(_spanProcessors) {
        this._spanProcessors = _spanProcessors;
    }
    MultiSpanProcessor.prototype.forceFlush = function () {
        var e_1, _a;
        var promises = [];
        try {
            for (var _b = __values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()) {
                var spanProcessor = _c.value;
                promises.push(spanProcessor.forceFlush());
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return new Promise(function (resolve) {
            Promise.all(promises)
                .then(function () {
                resolve();
            })
                .catch(function (error) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["globalErrorHandler"])(error || new Error('MultiSpanProcessor: forceFlush failed'));
                resolve();
            });
        });
    };
    MultiSpanProcessor.prototype.onStart = function (span, context) {
        var e_2, _a;
        try {
            for (var _b = __values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()) {
                var spanProcessor = _c.value;
                spanProcessor.onStart(span, context);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    MultiSpanProcessor.prototype.onEnd = function (span) {
        var e_3, _a;
        try {
            for (var _b = __values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()) {
                var spanProcessor = _c.value;
                spanProcessor.onEnd(span);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    MultiSpanProcessor.prototype.shutdown = function () {
        var e_4, _a;
        var promises = [];
        try {
            for (var _b = __values(this._spanProcessors), _c = _b.next(); !_c.done; _c = _b.next()) {
                var spanProcessor = _c.value;
                promises.push(spanProcessor.shutdown());
            }
        }
        catch (e_4_1) { e_4 = { error: e_4_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_4) throw e_4.error; }
        }
        return new Promise(function (resolve, reject) {
            Promise.all(promises).then(function () {
                resolve();
            }, reject);
        });
    };
    return MultiSpanProcessor;
}());

//# sourceMappingURL=MultiSpanProcessor.js.map

/***/ }),
/* 2010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ExceptionEventName; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
// Event name definitions
var ExceptionEventName = 'exception';
//# sourceMappingURL=enums.js.map

/***/ }),
/* 2011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BatchSpanProcessorBase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__ = __webpack_require__(65);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * Implementation of the {@link SpanProcessor} that batches spans exported by
 * the SDK then pushes them to the exporter pipeline.
 */
var BatchSpanProcessorBase = /** @class */ (function () {
    function BatchSpanProcessorBase(_exporter, config) {
        this._exporter = _exporter;
        this._isExporting = false;
        this._finishedSpans = [];
        this._droppedSpansCount = 0;
        var env = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["getEnv"])();
        this._maxExportBatchSize =
            typeof (config === null || config === void 0 ? void 0 : config.maxExportBatchSize) === 'number'
                ? config.maxExportBatchSize
                : env.OTEL_BSP_MAX_EXPORT_BATCH_SIZE;
        this._maxQueueSize =
            typeof (config === null || config === void 0 ? void 0 : config.maxQueueSize) === 'number'
                ? config.maxQueueSize
                : env.OTEL_BSP_MAX_QUEUE_SIZE;
        this._scheduledDelayMillis =
            typeof (config === null || config === void 0 ? void 0 : config.scheduledDelayMillis) === 'number'
                ? config.scheduledDelayMillis
                : env.OTEL_BSP_SCHEDULE_DELAY;
        this._exportTimeoutMillis =
            typeof (config === null || config === void 0 ? void 0 : config.exportTimeoutMillis) === 'number'
                ? config.exportTimeoutMillis
                : env.OTEL_BSP_EXPORT_TIMEOUT;
        this._shutdownOnce = new __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["BindOnceFuture"](this._shutdown, this);
        if (this._maxExportBatchSize > this._maxQueueSize) {
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn('BatchSpanProcessor: maxExportBatchSize must be smaller or equal to maxQueueSize, setting maxExportBatchSize to match maxQueueSize');
            this._maxExportBatchSize = this._maxQueueSize;
        }
    }
    BatchSpanProcessorBase.prototype.forceFlush = function () {
        if (this._shutdownOnce.isCalled) {
            return this._shutdownOnce.promise;
        }
        return this._flushAll();
    };
    // does nothing.
    BatchSpanProcessorBase.prototype.onStart = function (_span, _parentContext) { };
    BatchSpanProcessorBase.prototype.onEnd = function (span) {
        if (this._shutdownOnce.isCalled) {
            return;
        }
        if ((span.spanContext().traceFlags & __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["TraceFlags"].SAMPLED) === 0) {
            return;
        }
        this._addToBuffer(span);
    };
    BatchSpanProcessorBase.prototype.shutdown = function () {
        return this._shutdownOnce.call();
    };
    BatchSpanProcessorBase.prototype._shutdown = function () {
        var _this = this;
        return Promise.resolve()
            .then(function () {
            return _this.onShutdown();
        })
            .then(function () {
            return _this._flushAll();
        })
            .then(function () {
            return _this._exporter.shutdown();
        });
    };
    /** Add a span in the buffer. */
    BatchSpanProcessorBase.prototype._addToBuffer = function (span) {
        if (this._finishedSpans.length >= this._maxQueueSize) {
            // limit reached, drop span
            if (this._droppedSpansCount === 0) {
                __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].debug('maxQueueSize reached, dropping spans');
            }
            this._droppedSpansCount++;
            return;
        }
        if (this._droppedSpansCount > 0) {
            // some spans were dropped, log once with count of spans dropped
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["diag"].warn("Dropped " + this._droppedSpansCount + " spans because maxQueueSize reached");
            this._droppedSpansCount = 0;
        }
        this._finishedSpans.push(span);
        this._maybeStartTimer();
    };
    /**
     * Send all spans to the exporter respecting the batch size limit
     * This function is used only on forceFlush or shutdown,
     * for all other cases _flush should be used
     * */
    BatchSpanProcessorBase.prototype._flushAll = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var promises = [];
            // calculate number of batches
            var count = Math.ceil(_this._finishedSpans.length / _this._maxExportBatchSize);
            for (var i = 0, j = count; i < j; i++) {
                promises.push(_this._flushOneBatch());
            }
            Promise.all(promises)
                .then(function () {
                resolve();
            })
                .catch(reject);
        });
    };
    BatchSpanProcessorBase.prototype._flushOneBatch = function () {
        var _this = this;
        this._clearTimer();
        if (this._finishedSpans.length === 0) {
            return Promise.resolve();
        }
        return new Promise(function (resolve, reject) {
            var timer = setTimeout(function () {
                // don't wait anymore for export, this way the next batch can start
                reject(new Error('Timeout'));
            }, _this._exportTimeoutMillis);
            // prevent downstream exporter calls from generating spans
            __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].with(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["suppressTracing"])(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["context"].active()), function () {
                // Reset the finished spans buffer here because the next invocations of the _flush method
                // could pass the same finished spans to the exporter if the buffer is cleared
                // outside the execution of this callback.
                var spans;
                if (_this._finishedSpans.length <= _this._maxExportBatchSize) {
                    spans = _this._finishedSpans;
                    _this._finishedSpans = [];
                }
                else {
                    spans = _this._finishedSpans.splice(0, _this._maxExportBatchSize);
                }
                var doExport = function () {
                    return _this._exporter.export(spans, function (result) {
                        var _a;
                        clearTimeout(timer);
                        if (result.code === __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["ExportResultCode"].SUCCESS) {
                            resolve();
                        }
                        else {
                            reject((_a = result.error) !== null && _a !== void 0 ? _a : new Error('BatchSpanProcessor: span export failed'));
                        }
                    });
                };
                var pendingResources = null;
                for (var i = 0, len = spans.length; i < len; i++) {
                    var span = spans[i];
                    if (span.resource.asyncAttributesPending &&
                        span.resource.waitForAsyncAttributes) {
                        pendingResources !== null && pendingResources !== void 0 ? pendingResources : (pendingResources = []);
                        pendingResources.push(span.resource.waitForAsyncAttributes());
                    }
                }
                // Avoid scheduling a promise to make the behavior more predictable and easier to test
                if (pendingResources === null) {
                    doExport();
                }
                else {
                    Promise.all(pendingResources).then(doExport, function (err) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["globalErrorHandler"])(err);
                        reject(err);
                    });
                }
            });
        });
    };
    BatchSpanProcessorBase.prototype._maybeStartTimer = function () {
        var _this = this;
        if (this._isExporting)
            return;
        var flush = function () {
            _this._isExporting = true;
            _this._flushOneBatch()
                .finally(function () {
                _this._isExporting = false;
                if (_this._finishedSpans.length > 0) {
                    _this._clearTimer();
                    _this._maybeStartTimer();
                }
            })
                .catch(function (e) {
                _this._isExporting = false;
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["globalErrorHandler"])(e);
            });
        };
        // we only wait if the queue doesn't have enough elements yet
        if (this._finishedSpans.length >= this._maxExportBatchSize) {
            return flush();
        }
        if (this._timer !== undefined)
            return;
        this._timer = setTimeout(function () { return flush(); }, this._scheduledDelayMillis);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["unrefTimer"])(this._timer);
    };
    BatchSpanProcessorBase.prototype._clearTimer = function () {
        if (this._timer !== undefined) {
            clearTimeout(this._timer);
            this._timer = undefined;
        }
    };
    return BatchSpanProcessorBase;
}());

//# sourceMappingURL=BatchSpanProcessorBase.js.map

/***/ }),
/* 2012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ConsoleSpanExporter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__ = __webpack_require__(65);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};

/**
 * This is implementation of {@link SpanExporter} that prints spans to the
 * console. This class can be used for diagnostic purposes.
 *
 * NOTE: This {@link SpanExporter} is intended for diagnostics use only, output rendered to the console may change at any time.
 */
/* eslint-disable no-console */
var ConsoleSpanExporter = /** @class */ (function () {
    function ConsoleSpanExporter() {
    }
    /**
     * Export spans.
     * @param spans
     * @param resultCallback
     */
    ConsoleSpanExporter.prototype.export = function (spans, resultCallback) {
        return this._sendSpans(spans, resultCallback);
    };
    /**
     * Shutdown the exporter.
     */
    ConsoleSpanExporter.prototype.shutdown = function () {
        this._sendSpans([]);
        return this.forceFlush();
    };
    /**
     * Exports any pending spans in exporter
     */
    ConsoleSpanExporter.prototype.forceFlush = function () {
        return Promise.resolve();
    };
    /**
     * converts span info into more readable format
     * @param span
     */
    ConsoleSpanExporter.prototype._exportInfo = function (span) {
        var _a;
        return {
            resource: {
                attributes: span.resource.attributes,
            },
            instrumentationScope: span.instrumentationLibrary,
            traceId: span.spanContext().traceId,
            parentId: span.parentSpanId,
            traceState: (_a = span.spanContext().traceState) === null || _a === void 0 ? void 0 : _a.serialize(),
            name: span.name,
            id: span.spanContext().spanId,
            kind: span.kind,
            timestamp: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["hrTimeToMicroseconds"])(span.startTime),
            duration: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["hrTimeToMicroseconds"])(span.duration),
            attributes: span.attributes,
            status: span.status,
            events: span.events,
            links: span.links,
        };
    };
    /**
     * Showing spans in console
     * @param spans
     * @param done
     */
    ConsoleSpanExporter.prototype._sendSpans = function (spans, done) {
        var e_1, _a;
        try {
            for (var spans_1 = __values(spans), spans_1_1 = spans_1.next(); !spans_1_1.done; spans_1_1 = spans_1.next()) {
                var span = spans_1_1.value;
                console.dir(this._exportInfo(span), { depth: 3 });
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (spans_1_1 && !spans_1_1.done && (_a = spans_1.return)) _a.call(spans_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (done) {
            return done({ code: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["ExportResultCode"].SUCCESS });
        }
    };
    return ConsoleSpanExporter;
}());

//# sourceMappingURL=ConsoleSpanExporter.js.map

/***/ }),
/* 2013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InMemorySpanExporter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__ = __webpack_require__(65);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};

/**
 * This class can be used for testing purposes. It stores the exported spans
 * in a list in memory that can be retrieved using the `getFinishedSpans()`
 * method.
 */
var InMemorySpanExporter = /** @class */ (function () {
    function InMemorySpanExporter() {
        this._finishedSpans = [];
        /**
         * Indicates if the exporter has been "shutdown."
         * When false, exported spans will not be stored in-memory.
         */
        this._stopped = false;
    }
    InMemorySpanExporter.prototype.export = function (spans, resultCallback) {
        var _a;
        if (this._stopped)
            return resultCallback({
                code: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["ExportResultCode"].FAILED,
                error: new Error('Exporter has been stopped'),
            });
        (_a = this._finishedSpans).push.apply(_a, __spreadArray([], __read(spans), false));
        setTimeout(function () { return resultCallback({ code: __WEBPACK_IMPORTED_MODULE_0__opentelemetry_core__["ExportResultCode"].SUCCESS }); }, 0);
    };
    InMemorySpanExporter.prototype.shutdown = function () {
        this._stopped = true;
        this._finishedSpans = [];
        return this.forceFlush();
    };
    /**
     * Exports any pending spans in the exporter
     */
    InMemorySpanExporter.prototype.forceFlush = function () {
        return Promise.resolve();
    };
    InMemorySpanExporter.prototype.reset = function () {
        this._finishedSpans = [];
    };
    InMemorySpanExporter.prototype.getFinishedSpans = function () {
        return this._finishedSpans;
    };
    return InMemorySpanExporter;
}());

//# sourceMappingURL=InMemorySpanExporter.js.map

/***/ }),
/* 2014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimpleSpanProcessor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__ = __webpack_require__(65);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};


/**
 * An implementation of the {@link SpanProcessor} that converts the {@link Span}
 * to {@link ReadableSpan} and passes it to the configured exporter.
 *
 * Only spans that are sampled are converted.
 *
 * NOTE: This {@link SpanProcessor} exports every ended span individually instead of batching spans together, which causes significant performance overhead with most exporters. For production use, please consider using the {@link BatchSpanProcessor} instead.
 */
var SimpleSpanProcessor = /** @class */ (function () {
    function SimpleSpanProcessor(_exporter) {
        this._exporter = _exporter;
        this._shutdownOnce = new __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["BindOnceFuture"](this._shutdown, this);
        this._unresolvedExports = new Set();
    }
    SimpleSpanProcessor.prototype.forceFlush = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: 
                    // await unresolved resources before resolving
                    return [4 /*yield*/, Promise.all(Array.from(this._unresolvedExports))];
                    case 1:
                        // await unresolved resources before resolving
                        _a.sent();
                        if (!this._exporter.forceFlush) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._exporter.forceFlush()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    SimpleSpanProcessor.prototype.onStart = function (_span, _parentContext) { };
    SimpleSpanProcessor.prototype.onEnd = function (span) {
        var _this = this;
        var _a, _b;
        if (this._shutdownOnce.isCalled) {
            return;
        }
        if ((span.spanContext().traceFlags & __WEBPACK_IMPORTED_MODULE_0__opentelemetry_api__["TraceFlags"].SAMPLED) === 0) {
            return;
        }
        var doExport = function () {
            return __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["internal"]
                ._export(_this._exporter, [span])
                .then(function (result) {
                var _a;
                if (result.code !== __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["ExportResultCode"].SUCCESS) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["globalErrorHandler"])((_a = result.error) !== null && _a !== void 0 ? _a : new Error("SimpleSpanProcessor: span export failed (status " + result + ")"));
                }
            })
                .catch(function (error) {
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["globalErrorHandler"])(error);
            });
        };
        // Avoid scheduling a promise to make the behavior more predictable and easier to test
        if (span.resource.asyncAttributesPending) {
            var exportPromise_1 = (_b = (_a = span.resource).waitForAsyncAttributes) === null || _b === void 0 ? void 0 : _b.call(_a).then(function () {
                if (exportPromise_1 != null) {
                    _this._unresolvedExports.delete(exportPromise_1);
                }
                return doExport();
            }, function (err) { return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["globalErrorHandler"])(err); });
            // store the unresolved exports
            if (exportPromise_1 != null) {
                this._unresolvedExports.add(exportPromise_1);
            }
        }
        else {
            void doExport();
        }
    };
    SimpleSpanProcessor.prototype.shutdown = function () {
        return this._shutdownOnce.call();
    };
    SimpleSpanProcessor.prototype._shutdown = function () {
        return this._exporter.shutdown();
    };
    return SimpleSpanProcessor;
}());

//# sourceMappingURL=SimpleSpanProcessor.js.map

/***/ }),
/* 2015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RandomIdGenerator; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var SPAN_ID_BYTES = 8;
var TRACE_ID_BYTES = 16;
var RandomIdGenerator = /** @class */ (function () {
    function RandomIdGenerator() {
        /**
         * Returns a random 16-byte trace ID formatted/encoded as a 32 lowercase hex
         * characters corresponding to 128 bits.
         */
        this.generateTraceId = getIdGenerator(TRACE_ID_BYTES);
        /**
         * Returns a random 8-byte span ID formatted/encoded as a 16 lowercase hex
         * characters corresponding to 64 bits.
         */
        this.generateSpanId = getIdGenerator(SPAN_ID_BYTES);
    }
    return RandomIdGenerator;
}());

var SHARED_CHAR_CODES_ARRAY = Array(32);
function getIdGenerator(bytes) {
    return function generateId() {
        for (var i = 0; i < bytes * 2; i++) {
            SHARED_CHAR_CODES_ARRAY[i] = Math.floor(Math.random() * 16) + 48;
            // valid hex characters in the range 48-57 and 97-102
            if (SHARED_CHAR_CODES_ARRAY[i] >= 58) {
                SHARED_CHAR_CODES_ARRAY[i] += 39;
            }
        }
        return String.fromCharCode.apply(null, SHARED_CHAR_CODES_ARRAY.slice(0, bytes * 2));
    };
}
//# sourceMappingURL=RandomIdGenerator.js.map

/***/ }),
/* 2016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BatchSpanProcessor; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__export_BatchSpanProcessorBase__ = __webpack_require__(2011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__ = __webpack_require__(65);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


var BatchSpanProcessor = /** @class */ (function (_super) {
    __extends(BatchSpanProcessor, _super);
    function BatchSpanProcessor(_exporter, config) {
        var _this = _super.call(this, _exporter, config) || this;
        _this.onInit(config);
        return _this;
    }
    BatchSpanProcessor.prototype.onInit = function (config) {
        var _this = this;
        if ((config === null || config === void 0 ? void 0 : config.disableAutoFlushOnDocumentHide) !== true &&
            typeof document !== 'undefined') {
            this._visibilityChangeListener = function () {
                if (document.visibilityState === 'hidden') {
                    _this.forceFlush().catch(function (error) {
                        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["globalErrorHandler"])(error);
                    });
                }
            };
            this._pageHideListener = function () {
                _this.forceFlush().catch(function (error) {
                    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["globalErrorHandler"])(error);
                });
            };
            document.addEventListener('visibilitychange', this._visibilityChangeListener);
            // use 'pagehide' event as a fallback for Safari; see https://bugs.webkit.org/show_bug.cgi?id=116769
            document.addEventListener('pagehide', this._pageHideListener);
        }
    };
    BatchSpanProcessor.prototype.onShutdown = function () {
        if (typeof document !== 'undefined') {
            if (this._visibilityChangeListener) {
                document.removeEventListener('visibilitychange', this._visibilityChangeListener);
            }
            if (this._pageHideListener) {
                document.removeEventListener('pagehide', this._pageHideListener);
            }
        }
    };
    return BatchSpanProcessor;
}(__WEBPACK_IMPORTED_MODULE_0__export_BatchSpanProcessorBase__["a" /* BatchSpanProcessorBase */]));

//# sourceMappingURL=BatchSpanProcessor.js.map

/***/ }),
/* 2017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WebTracerProvider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__opentelemetry_sdk_trace_base__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StackContextManager__ = __webpack_require__(941);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();


/**
 * This class represents a web tracer with {@link StackContextManager}
 */
var WebTracerProvider = /** @class */ (function (_super) {
    __extends(WebTracerProvider, _super);
    /**
     * Constructs a new Tracer instance.
     * @param config Web Tracer config
     */
    function WebTracerProvider(config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this, config) || this;
        if (config.contextManager) {
            throw ('contextManager should be defined in register method not in' +
                ' constructor');
        }
        if (config.propagator) {
            throw 'propagator should be defined in register method not in constructor';
        }
        return _this;
    }
    /**
     * Register this TracerProvider for use with the OpenTelemetry API.
     * Undefined values may be replaced with defaults, and
     * null values will be skipped.
     *
     * @param config Configuration object for SDK registration
     */
    WebTracerProvider.prototype.register = function (config) {
        if (config === void 0) { config = {}; }
        if (config.contextManager === undefined) {
            config.contextManager = new __WEBPACK_IMPORTED_MODULE_1__StackContextManager__["a" /* StackContextManager */]();
        }
        if (config.contextManager) {
            config.contextManager.enable();
        }
        _super.prototype.register.call(this, config);
    };
    return WebTracerProvider;
}(__WEBPACK_IMPORTED_MODULE_0__opentelemetry_sdk_trace_base__["BasicTracerProvider"]));

//# sourceMappingURL=WebTracerProvider.js.map

/***/ }),
/* 2018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = hasKey;
/* harmony export (immutable) */ __webpack_exports__["a"] = addSpanNetworkEvent;
/* harmony export (immutable) */ __webpack_exports__["b"] = addSpanNetworkEvents;
/* harmony export (immutable) */ __webpack_exports__["i"] = sortResources;
/* harmony export (immutable) */ __webpack_exports__["d"] = getResource;
/* harmony export (immutable) */ __webpack_exports__["g"] = parseUrl;
/* harmony export (immutable) */ __webpack_exports__["f"] = normalizeUrl;
/* harmony export (immutable) */ __webpack_exports__["c"] = getElementXPath;
/* harmony export (immutable) */ __webpack_exports__["h"] = shouldPropagateTraceHeaders;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__opentelemetry_semantic_conventions__ = __webpack_require__(173);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */



// Used to normalize relative URLs
var urlNormalizingAnchor;
function getUrlNormalizingAnchor() {
    if (!urlNormalizingAnchor) {
        urlNormalizingAnchor = document.createElement('a');
    }
    return urlNormalizingAnchor;
}
/**
 * Helper function to be able to use enum as typed key in type and in interface when using forEach
 * @param obj
 * @param key
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function hasKey(obj, key) {
    return key in obj;
}
/**
 * Helper function for starting an event on span based on {@link PerformanceEntries}
 * @param span
 * @param performanceName name of performance entry for time start
 * @param entries
 * @param refPerfName name of performance entry to use for reference
 */
function addSpanNetworkEvent(span, performanceName, entries, refPerfName) {
    var perfTime = undefined;
    var refTime = undefined;
    if (hasKey(entries, performanceName) &&
        typeof entries[performanceName] === 'number') {
        perfTime = entries[performanceName];
    }
    var refName = refPerfName || __WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].FETCH_START;
    // Use a reference time which is the earliest possible value so that the performance timings that are earlier should not be added
    // using FETCH START time in case no reference is provided
    if (hasKey(entries, refName) && typeof entries[refName] === 'number') {
        refTime = entries[refName];
    }
    if (perfTime !== undefined && refTime !== undefined && perfTime >= refTime) {
        span.addEvent(performanceName, perfTime);
        return span;
    }
    return undefined;
}
/**
 * Helper function for adding network events and content length attributes
 * @param span
 * @param resource
 * @param ignoreNetworkEvents
 */
function addSpanNetworkEvents(span, resource, ignoreNetworkEvents) {
    if (ignoreNetworkEvents === void 0) { ignoreNetworkEvents = false; }
    if (!ignoreNetworkEvents) {
        addSpanNetworkEvent(span, __WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].FETCH_START, resource);
        addSpanNetworkEvent(span, __WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].DOMAIN_LOOKUP_START, resource);
        addSpanNetworkEvent(span, __WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].DOMAIN_LOOKUP_END, resource);
        addSpanNetworkEvent(span, __WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].CONNECT_START, resource);
        if (hasKey(resource, 'name') &&
            resource['name'].startsWith('https:')) {
            addSpanNetworkEvent(span, __WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].SECURE_CONNECTION_START, resource);
        }
        addSpanNetworkEvent(span, __WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].CONNECT_END, resource);
        addSpanNetworkEvent(span, __WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].REQUEST_START, resource);
        addSpanNetworkEvent(span, __WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].RESPONSE_START, resource);
        addSpanNetworkEvent(span, __WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].RESPONSE_END, resource);
    }
    var encodedLength = resource[__WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].ENCODED_BODY_SIZE];
    if (encodedLength !== undefined) {
        span.setAttribute(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_semantic_conventions__["h" /* SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH */], encodedLength);
    }
    var decodedLength = resource[__WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].DECODED_BODY_SIZE];
    // Spec: Not set if transport encoding not used (in which case encoded and decoded sizes match)
    if (decodedLength !== undefined && encodedLength !== decodedLength) {
        span.setAttribute(__WEBPACK_IMPORTED_MODULE_2__opentelemetry_semantic_conventions__["i" /* SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED */], decodedLength);
    }
}
/**
 * sort resources by startTime
 * @param filteredResources
 */
function sortResources(filteredResources) {
    return filteredResources.slice().sort(function (a, b) {
        var valueA = a[__WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].FETCH_START];
        var valueB = b[__WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].FETCH_START];
        if (valueA > valueB) {
            return 1;
        }
        else if (valueA < valueB) {
            return -1;
        }
        return 0;
    });
}
/** Returns the origin if present (if in browser context). */
function getOrigin() {
    return typeof location !== 'undefined' ? location.origin : undefined;
}
/**
 * Get closest performance resource ignoring the resources that have been
 * already used.
 * @param spanUrl
 * @param startTimeHR
 * @param endTimeHR
 * @param resources
 * @param ignoredResources
 * @param initiatorType
 */
function getResource(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType) {
    if (ignoredResources === void 0) { ignoredResources = new WeakSet(); }
    // de-relativize the URL before usage (does no harm to absolute URLs)
    var parsedSpanUrl = parseUrl(spanUrl);
    spanUrl = parsedSpanUrl.toString();
    var filteredResources = filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType);
    if (filteredResources.length === 0) {
        return {
            mainRequest: undefined,
        };
    }
    if (filteredResources.length === 1) {
        return {
            mainRequest: filteredResources[0],
        };
    }
    var sorted = sortResources(filteredResources);
    if (parsedSpanUrl.origin !== getOrigin() && sorted.length > 1) {
        var corsPreFlightRequest = sorted[0];
        var mainRequest = findMainRequest(sorted, corsPreFlightRequest[__WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].RESPONSE_END], endTimeHR);
        var responseEnd = corsPreFlightRequest[__WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].RESPONSE_END];
        var fetchStart = mainRequest[__WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].FETCH_START];
        // no corsPreFlightRequest
        if (fetchStart < responseEnd) {
            mainRequest = corsPreFlightRequest;
            corsPreFlightRequest = undefined;
        }
        return {
            corsPreFlightRequest: corsPreFlightRequest,
            mainRequest: mainRequest,
        };
    }
    else {
        return {
            mainRequest: filteredResources[0],
        };
    }
}
/**
 * Will find the main request skipping the cors pre flight requests
 * @param resources
 * @param corsPreFlightRequestEndTime
 * @param spanEndTimeHR
 */
function findMainRequest(resources, corsPreFlightRequestEndTime, spanEndTimeHR) {
    var spanEndTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["hrTimeToNanoseconds"])(spanEndTimeHR);
    var minTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["hrTimeToNanoseconds"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["timeInputToHrTime"])(corsPreFlightRequestEndTime));
    var mainRequest = resources[1];
    var bestGap;
    var length = resources.length;
    for (var i = 1; i < length; i++) {
        var resource = resources[i];
        var resourceStartTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["hrTimeToNanoseconds"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["timeInputToHrTime"])(resource[__WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].FETCH_START]));
        var resourceEndTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["hrTimeToNanoseconds"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["timeInputToHrTime"])(resource[__WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].RESPONSE_END]));
        var currentGap = spanEndTime - resourceEndTime;
        if (resourceStartTime >= minTime && (!bestGap || currentGap < bestGap)) {
            bestGap = currentGap;
            mainRequest = resource;
        }
    }
    return mainRequest;
}
/**
 * Filter all resources that has started and finished according to span start time and end time.
 *     It will return the closest resource to a start time
 * @param spanUrl
 * @param startTimeHR
 * @param endTimeHR
 * @param resources
 * @param ignoredResources
 */
function filterResourcesForSpan(spanUrl, startTimeHR, endTimeHR, resources, ignoredResources, initiatorType) {
    var startTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["hrTimeToNanoseconds"])(startTimeHR);
    var endTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["hrTimeToNanoseconds"])(endTimeHR);
    var filteredResources = resources.filter(function (resource) {
        var resourceStartTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["hrTimeToNanoseconds"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["timeInputToHrTime"])(resource[__WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].FETCH_START]));
        var resourceEndTime = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["hrTimeToNanoseconds"])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["timeInputToHrTime"])(resource[__WEBPACK_IMPORTED_MODULE_0__enums_PerformanceTimingNames__["a" /* PerformanceTimingNames */].RESPONSE_END]));
        return (resource.initiatorType.toLowerCase() ===
            (initiatorType || 'xmlhttprequest') &&
            resource.name === spanUrl &&
            resourceStartTime >= startTime &&
            resourceEndTime <= endTime);
    });
    if (filteredResources.length > 0) {
        filteredResources = filteredResources.filter(function (resource) {
            return !ignoredResources.has(resource);
        });
    }
    return filteredResources;
}
/**
 * Parses url using URL constructor or fallback to anchor element.
 * @param url
 */
function parseUrl(url) {
    if (typeof URL === 'function') {
        return new URL(url, typeof document !== 'undefined'
            ? document.baseURI
            : typeof location !== 'undefined' // Some JS runtimes (e.g. Deno) don't define this
                ? location.href
                : undefined);
    }
    var element = getUrlNormalizingAnchor();
    element.href = url;
    return element;
}
/**
 * Parses url using URL constructor or fallback to anchor element and serialize
 * it to a string.
 *
 * Performs the steps described in https://html.spec.whatwg.org/multipage/urls-and-fetching.html#parse-a-url
 *
 * @param url
 */
function normalizeUrl(url) {
    var urlLike = parseUrl(url);
    return urlLike.href;
}
/**
 * Get element XPath
 * @param target - target element
 * @param optimised - when id attribute of element is present the xpath can be
 * simplified to contain id
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function getElementXPath(target, optimised) {
    if (target.nodeType === Node.DOCUMENT_NODE) {
        return '/';
    }
    var targetValue = getNodeValue(target, optimised);
    if (optimised && targetValue.indexOf('@id') > 0) {
        return targetValue;
    }
    var xpath = '';
    if (target.parentNode) {
        xpath += getElementXPath(target.parentNode, false);
    }
    xpath += targetValue;
    return xpath;
}
/**
 * get node index within the siblings
 * @param target
 */
function getNodeIndex(target) {
    if (!target.parentNode) {
        return 0;
    }
    var allowedTypes = [target.nodeType];
    if (target.nodeType === Node.CDATA_SECTION_NODE) {
        allowedTypes.push(Node.TEXT_NODE);
    }
    var elements = Array.from(target.parentNode.childNodes);
    elements = elements.filter(function (element) {
        var localName = element.localName;
        return (allowedTypes.indexOf(element.nodeType) >= 0 &&
            localName === target.localName);
    });
    if (elements.length >= 1) {
        return elements.indexOf(target) + 1; // xpath starts from 1
    }
    // if there are no other similar child xpath doesn't need index
    return 0;
}
/**
 * get node value for xpath
 * @param target
 * @param optimised
 */
function getNodeValue(target, optimised) {
    var nodeType = target.nodeType;
    var index = getNodeIndex(target);
    var nodeValue = '';
    if (nodeType === Node.ELEMENT_NODE) {
        var id = target.getAttribute('id');
        if (optimised && id) {
            return "//*[@id=\"" + id + "\"]";
        }
        nodeValue = target.localName;
    }
    else if (nodeType === Node.TEXT_NODE ||
        nodeType === Node.CDATA_SECTION_NODE) {
        nodeValue = 'text()';
    }
    else if (nodeType === Node.COMMENT_NODE) {
        nodeValue = 'comment()';
    }
    else {
        return '';
    }
    // if index is 1 it can be omitted in xpath
    if (nodeValue && index > 1) {
        return "/" + nodeValue + "[" + index + "]";
    }
    return "/" + nodeValue;
}
/**
 * Checks if trace headers should be propagated
 * @param spanUrl
 * @private
 */
function shouldPropagateTraceHeaders(spanUrl, propagateTraceHeaderCorsUrls) {
    var propagateTraceHeaderUrls = propagateTraceHeaderCorsUrls || [];
    if (typeof propagateTraceHeaderUrls === 'string' ||
        propagateTraceHeaderUrls instanceof RegExp) {
        propagateTraceHeaderUrls = [propagateTraceHeaderUrls];
    }
    var parsedSpanUrl = parseUrl(spanUrl);
    if (parsedSpanUrl.origin === getOrigin()) {
        return true;
    }
    else {
        return propagateTraceHeaderUrls.some(function (propagateTraceHeaderUrl) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__opentelemetry_core__["urlMatches"])(spanUrl, propagateTraceHeaderUrl);
        });
    }
}
//# sourceMappingURL=utils.js.map

/***/ }),
/* 2019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SEMRESATTRS_CLOUD_PROVIDER */
/* unused harmony export SEMRESATTRS_CLOUD_ACCOUNT_ID */
/* unused harmony export SEMRESATTRS_CLOUD_REGION */
/* unused harmony export SEMRESATTRS_CLOUD_AVAILABILITY_ZONE */
/* unused harmony export SEMRESATTRS_CLOUD_PLATFORM */
/* unused harmony export SEMRESATTRS_AWS_ECS_CONTAINER_ARN */
/* unused harmony export SEMRESATTRS_AWS_ECS_CLUSTER_ARN */
/* unused harmony export SEMRESATTRS_AWS_ECS_LAUNCHTYPE */
/* unused harmony export SEMRESATTRS_AWS_ECS_TASK_ARN */
/* unused harmony export SEMRESATTRS_AWS_ECS_TASK_FAMILY */
/* unused harmony export SEMRESATTRS_AWS_ECS_TASK_REVISION */
/* unused harmony export SEMRESATTRS_AWS_EKS_CLUSTER_ARN */
/* unused harmony export SEMRESATTRS_AWS_LOG_GROUP_NAMES */
/* unused harmony export SEMRESATTRS_AWS_LOG_GROUP_ARNS */
/* unused harmony export SEMRESATTRS_AWS_LOG_STREAM_NAMES */
/* unused harmony export SEMRESATTRS_AWS_LOG_STREAM_ARNS */
/* unused harmony export SEMRESATTRS_CONTAINER_NAME */
/* unused harmony export SEMRESATTRS_CONTAINER_ID */
/* unused harmony export SEMRESATTRS_CONTAINER_RUNTIME */
/* unused harmony export SEMRESATTRS_CONTAINER_IMAGE_NAME */
/* unused harmony export SEMRESATTRS_CONTAINER_IMAGE_TAG */
/* unused harmony export SEMRESATTRS_DEPLOYMENT_ENVIRONMENT */
/* unused harmony export SEMRESATTRS_DEVICE_ID */
/* unused harmony export SEMRESATTRS_DEVICE_MODEL_IDENTIFIER */
/* unused harmony export SEMRESATTRS_DEVICE_MODEL_NAME */
/* unused harmony export SEMRESATTRS_FAAS_NAME */
/* unused harmony export SEMRESATTRS_FAAS_ID */
/* unused harmony export SEMRESATTRS_FAAS_VERSION */
/* unused harmony export SEMRESATTRS_FAAS_INSTANCE */
/* unused harmony export SEMRESATTRS_FAAS_MAX_MEMORY */
/* unused harmony export SEMRESATTRS_HOST_ID */
/* unused harmony export SEMRESATTRS_HOST_NAME */
/* unused harmony export SEMRESATTRS_HOST_TYPE */
/* unused harmony export SEMRESATTRS_HOST_ARCH */
/* unused harmony export SEMRESATTRS_HOST_IMAGE_NAME */
/* unused harmony export SEMRESATTRS_HOST_IMAGE_ID */
/* unused harmony export SEMRESATTRS_HOST_IMAGE_VERSION */
/* unused harmony export SEMRESATTRS_K8S_CLUSTER_NAME */
/* unused harmony export SEMRESATTRS_K8S_NODE_NAME */
/* unused harmony export SEMRESATTRS_K8S_NODE_UID */
/* unused harmony export SEMRESATTRS_K8S_NAMESPACE_NAME */
/* unused harmony export SEMRESATTRS_K8S_POD_UID */
/* unused harmony export SEMRESATTRS_K8S_POD_NAME */
/* unused harmony export SEMRESATTRS_K8S_CONTAINER_NAME */
/* unused harmony export SEMRESATTRS_K8S_REPLICASET_UID */
/* unused harmony export SEMRESATTRS_K8S_REPLICASET_NAME */
/* unused harmony export SEMRESATTRS_K8S_DEPLOYMENT_UID */
/* unused harmony export SEMRESATTRS_K8S_DEPLOYMENT_NAME */
/* unused harmony export SEMRESATTRS_K8S_STATEFULSET_UID */
/* unused harmony export SEMRESATTRS_K8S_STATEFULSET_NAME */
/* unused harmony export SEMRESATTRS_K8S_DAEMONSET_UID */
/* unused harmony export SEMRESATTRS_K8S_DAEMONSET_NAME */
/* unused harmony export SEMRESATTRS_K8S_JOB_UID */
/* unused harmony export SEMRESATTRS_K8S_JOB_NAME */
/* unused harmony export SEMRESATTRS_K8S_CRONJOB_UID */
/* unused harmony export SEMRESATTRS_K8S_CRONJOB_NAME */
/* unused harmony export SEMRESATTRS_OS_TYPE */
/* unused harmony export SEMRESATTRS_OS_DESCRIPTION */
/* unused harmony export SEMRESATTRS_OS_NAME */
/* unused harmony export SEMRESATTRS_OS_VERSION */
/* unused harmony export SEMRESATTRS_PROCESS_PID */
/* unused harmony export SEMRESATTRS_PROCESS_EXECUTABLE_NAME */
/* unused harmony export SEMRESATTRS_PROCESS_EXECUTABLE_PATH */
/* unused harmony export SEMRESATTRS_PROCESS_COMMAND */
/* unused harmony export SEMRESATTRS_PROCESS_COMMAND_LINE */
/* unused harmony export SEMRESATTRS_PROCESS_COMMAND_ARGS */
/* unused harmony export SEMRESATTRS_PROCESS_OWNER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SEMRESATTRS_PROCESS_RUNTIME_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SEMRESATTRS_PROCESS_RUNTIME_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SEMRESATTRS_PROCESS_RUNTIME_DESCRIPTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEMRESATTRS_SERVICE_NAME; });
/* unused harmony export SEMRESATTRS_SERVICE_NAMESPACE */
/* unused harmony export SEMRESATTRS_SERVICE_INSTANCE_ID */
/* unused harmony export SEMRESATTRS_SERVICE_VERSION */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SEMRESATTRS_TELEMETRY_SDK_NAME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SEMRESATTRS_TELEMETRY_SDK_LANGUAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SEMRESATTRS_TELEMETRY_SDK_VERSION; });
/* unused harmony export SEMRESATTRS_TELEMETRY_AUTO_VERSION */
/* unused harmony export SEMRESATTRS_WEBENGINE_NAME */
/* unused harmony export SEMRESATTRS_WEBENGINE_VERSION */
/* unused harmony export SEMRESATTRS_WEBENGINE_DESCRIPTION */
/* unused harmony export SemanticResourceAttributes */
/* unused harmony export CLOUDPROVIDERVALUES_ALIBABA_CLOUD */
/* unused harmony export CLOUDPROVIDERVALUES_AWS */
/* unused harmony export CLOUDPROVIDERVALUES_AZURE */
/* unused harmony export CLOUDPROVIDERVALUES_GCP */
/* unused harmony export CloudProviderValues */
/* unused harmony export CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS */
/* unused harmony export CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC */
/* unused harmony export CLOUDPLATFORMVALUES_AWS_EC2 */
/* unused harmony export CLOUDPLATFORMVALUES_AWS_ECS */
/* unused harmony export CLOUDPLATFORMVALUES_AWS_EKS */
/* unused harmony export CLOUDPLATFORMVALUES_AWS_LAMBDA */
/* unused harmony export CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK */
/* unused harmony export CLOUDPLATFORMVALUES_AZURE_VM */
/* unused harmony export CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES */
/* unused harmony export CLOUDPLATFORMVALUES_AZURE_AKS */
/* unused harmony export CLOUDPLATFORMVALUES_AZURE_FUNCTIONS */
/* unused harmony export CLOUDPLATFORMVALUES_AZURE_APP_SERVICE */
/* unused harmony export CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE */
/* unused harmony export CLOUDPLATFORMVALUES_GCP_CLOUD_RUN */
/* unused harmony export CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE */
/* unused harmony export CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS */
/* unused harmony export CLOUDPLATFORMVALUES_GCP_APP_ENGINE */
/* unused harmony export CloudPlatformValues */
/* unused harmony export AWSECSLAUNCHTYPEVALUES_EC2 */
/* unused harmony export AWSECSLAUNCHTYPEVALUES_FARGATE */
/* unused harmony export AwsEcsLaunchtypeValues */
/* unused harmony export HOSTARCHVALUES_AMD64 */
/* unused harmony export HOSTARCHVALUES_ARM32 */
/* unused harmony export HOSTARCHVALUES_ARM64 */
/* unused harmony export HOSTARCHVALUES_IA64 */
/* unused harmony export HOSTARCHVALUES_PPC32 */
/* unused harmony export HOSTARCHVALUES_PPC64 */
/* unused harmony export HOSTARCHVALUES_X86 */
/* unused harmony export HostArchValues */
/* unused harmony export OSTYPEVALUES_WINDOWS */
/* unused harmony export OSTYPEVALUES_LINUX */
/* unused harmony export OSTYPEVALUES_DARWIN */
/* unused harmony export OSTYPEVALUES_FREEBSD */
/* unused harmony export OSTYPEVALUES_NETBSD */
/* unused harmony export OSTYPEVALUES_OPENBSD */
/* unused harmony export OSTYPEVALUES_DRAGONFLYBSD */
/* unused harmony export OSTYPEVALUES_HPUX */
/* unused harmony export OSTYPEVALUES_AIX */
/* unused harmony export OSTYPEVALUES_SOLARIS */
/* unused harmony export OSTYPEVALUES_Z_OS */
/* unused harmony export OsTypeValues */
/* unused harmony export TELEMETRYSDKLANGUAGEVALUES_CPP */
/* unused harmony export TELEMETRYSDKLANGUAGEVALUES_DOTNET */
/* unused harmony export TELEMETRYSDKLANGUAGEVALUES_ERLANG */
/* unused harmony export TELEMETRYSDKLANGUAGEVALUES_GO */
/* unused harmony export TELEMETRYSDKLANGUAGEVALUES_JAVA */
/* unused harmony export TELEMETRYSDKLANGUAGEVALUES_NODEJS */
/* unused harmony export TELEMETRYSDKLANGUAGEVALUES_PHP */
/* unused harmony export TELEMETRYSDKLANGUAGEVALUES_PYTHON */
/* unused harmony export TELEMETRYSDKLANGUAGEVALUES_RUBY */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return TELEMETRYSDKLANGUAGEVALUES_WEBJS; });
/* unused harmony export TelemetrySdkLanguageValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(943);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

//----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates//templates/SemanticAttributes.ts.j2
//----------------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------------
// Constant values for SemanticResourceAttributes
//----------------------------------------------------------------------------------------------------------
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_CLOUD_PROVIDER = 'cloud.provider';
var TMP_CLOUD_ACCOUNT_ID = 'cloud.account.id';
var TMP_CLOUD_REGION = 'cloud.region';
var TMP_CLOUD_AVAILABILITY_ZONE = 'cloud.availability_zone';
var TMP_CLOUD_PLATFORM = 'cloud.platform';
var TMP_AWS_ECS_CONTAINER_ARN = 'aws.ecs.container.arn';
var TMP_AWS_ECS_CLUSTER_ARN = 'aws.ecs.cluster.arn';
var TMP_AWS_ECS_LAUNCHTYPE = 'aws.ecs.launchtype';
var TMP_AWS_ECS_TASK_ARN = 'aws.ecs.task.arn';
var TMP_AWS_ECS_TASK_FAMILY = 'aws.ecs.task.family';
var TMP_AWS_ECS_TASK_REVISION = 'aws.ecs.task.revision';
var TMP_AWS_EKS_CLUSTER_ARN = 'aws.eks.cluster.arn';
var TMP_AWS_LOG_GROUP_NAMES = 'aws.log.group.names';
var TMP_AWS_LOG_GROUP_ARNS = 'aws.log.group.arns';
var TMP_AWS_LOG_STREAM_NAMES = 'aws.log.stream.names';
var TMP_AWS_LOG_STREAM_ARNS = 'aws.log.stream.arns';
var TMP_CONTAINER_NAME = 'container.name';
var TMP_CONTAINER_ID = 'container.id';
var TMP_CONTAINER_RUNTIME = 'container.runtime';
var TMP_CONTAINER_IMAGE_NAME = 'container.image.name';
var TMP_CONTAINER_IMAGE_TAG = 'container.image.tag';
var TMP_DEPLOYMENT_ENVIRONMENT = 'deployment.environment';
var TMP_DEVICE_ID = 'device.id';
var TMP_DEVICE_MODEL_IDENTIFIER = 'device.model.identifier';
var TMP_DEVICE_MODEL_NAME = 'device.model.name';
var TMP_FAAS_NAME = 'faas.name';
var TMP_FAAS_ID = 'faas.id';
var TMP_FAAS_VERSION = 'faas.version';
var TMP_FAAS_INSTANCE = 'faas.instance';
var TMP_FAAS_MAX_MEMORY = 'faas.max_memory';
var TMP_HOST_ID = 'host.id';
var TMP_HOST_NAME = 'host.name';
var TMP_HOST_TYPE = 'host.type';
var TMP_HOST_ARCH = 'host.arch';
var TMP_HOST_IMAGE_NAME = 'host.image.name';
var TMP_HOST_IMAGE_ID = 'host.image.id';
var TMP_HOST_IMAGE_VERSION = 'host.image.version';
var TMP_K8S_CLUSTER_NAME = 'k8s.cluster.name';
var TMP_K8S_NODE_NAME = 'k8s.node.name';
var TMP_K8S_NODE_UID = 'k8s.node.uid';
var TMP_K8S_NAMESPACE_NAME = 'k8s.namespace.name';
var TMP_K8S_POD_UID = 'k8s.pod.uid';
var TMP_K8S_POD_NAME = 'k8s.pod.name';
var TMP_K8S_CONTAINER_NAME = 'k8s.container.name';
var TMP_K8S_REPLICASET_UID = 'k8s.replicaset.uid';
var TMP_K8S_REPLICASET_NAME = 'k8s.replicaset.name';
var TMP_K8S_DEPLOYMENT_UID = 'k8s.deployment.uid';
var TMP_K8S_DEPLOYMENT_NAME = 'k8s.deployment.name';
var TMP_K8S_STATEFULSET_UID = 'k8s.statefulset.uid';
var TMP_K8S_STATEFULSET_NAME = 'k8s.statefulset.name';
var TMP_K8S_DAEMONSET_UID = 'k8s.daemonset.uid';
var TMP_K8S_DAEMONSET_NAME = 'k8s.daemonset.name';
var TMP_K8S_JOB_UID = 'k8s.job.uid';
var TMP_K8S_JOB_NAME = 'k8s.job.name';
var TMP_K8S_CRONJOB_UID = 'k8s.cronjob.uid';
var TMP_K8S_CRONJOB_NAME = 'k8s.cronjob.name';
var TMP_OS_TYPE = 'os.type';
var TMP_OS_DESCRIPTION = 'os.description';
var TMP_OS_NAME = 'os.name';
var TMP_OS_VERSION = 'os.version';
var TMP_PROCESS_PID = 'process.pid';
var TMP_PROCESS_EXECUTABLE_NAME = 'process.executable.name';
var TMP_PROCESS_EXECUTABLE_PATH = 'process.executable.path';
var TMP_PROCESS_COMMAND = 'process.command';
var TMP_PROCESS_COMMAND_LINE = 'process.command_line';
var TMP_PROCESS_COMMAND_ARGS = 'process.command_args';
var TMP_PROCESS_OWNER = 'process.owner';
var TMP_PROCESS_RUNTIME_NAME = 'process.runtime.name';
var TMP_PROCESS_RUNTIME_VERSION = 'process.runtime.version';
var TMP_PROCESS_RUNTIME_DESCRIPTION = 'process.runtime.description';
var TMP_SERVICE_NAME = 'service.name';
var TMP_SERVICE_NAMESPACE = 'service.namespace';
var TMP_SERVICE_INSTANCE_ID = 'service.instance.id';
var TMP_SERVICE_VERSION = 'service.version';
var TMP_TELEMETRY_SDK_NAME = 'telemetry.sdk.name';
var TMP_TELEMETRY_SDK_LANGUAGE = 'telemetry.sdk.language';
var TMP_TELEMETRY_SDK_VERSION = 'telemetry.sdk.version';
var TMP_TELEMETRY_AUTO_VERSION = 'telemetry.auto.version';
var TMP_WEBENGINE_NAME = 'webengine.name';
var TMP_WEBENGINE_VERSION = 'webengine.version';
var TMP_WEBENGINE_DESCRIPTION = 'webengine.description';
/**
 * Name of the cloud provider.
 *
 * @deprecated Use ATTR_CLOUD_PROVIDER in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_CLOUD_PROVIDER = TMP_CLOUD_PROVIDER;
/**
 * The cloud account ID the resource is assigned to.
 *
 * @deprecated Use ATTR_CLOUD_ACCOUNT_ID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_CLOUD_ACCOUNT_ID = TMP_CLOUD_ACCOUNT_ID;
/**
 * The geographical region the resource is running. Refer to your provider&#39;s docs to see the available regions, for example [Alibaba Cloud regions](https://www.alibabacloud.com/help/doc-detail/40654.htm), [AWS regions](https://aws.amazon.com/about-aws/global-infrastructure/regions_az/), [Azure regions](https://azure.microsoft.com/en-us/global-infrastructure/geographies/), or [Google Cloud regions](https://cloud.google.com/about/locations).
 *
 * @deprecated Use ATTR_CLOUD_REGION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_CLOUD_REGION = TMP_CLOUD_REGION;
/**
 * Cloud regions often have multiple, isolated locations known as zones to increase availability. Availability zone represents the zone where the resource is running.
 *
 * Note: Availability zones are called &#34;zones&#34; on Alibaba Cloud and Google Cloud.
 *
 * @deprecated Use ATTR_CLOUD_AVAILABILITY_ZONE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_CLOUD_AVAILABILITY_ZONE = TMP_CLOUD_AVAILABILITY_ZONE;
/**
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 *
 * @deprecated Use ATTR_CLOUD_PLATFORM in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_CLOUD_PLATFORM = TMP_CLOUD_PLATFORM;
/**
 * The Amazon Resource Name (ARN) of an [ECS container instance](https://docs.aws.amazon.com/AmazonECS/latest/developerguide/ECS_instances.html).
 *
 * @deprecated Use ATTR_AWS_ECS_CONTAINER_ARN in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_AWS_ECS_CONTAINER_ARN = TMP_AWS_ECS_CONTAINER_ARN;
/**
 * The ARN of an [ECS cluster](https://docs.aws.amazon.com/AmazonECS/latest/developerguide/clusters.html).
 *
 * @deprecated Use ATTR_AWS_ECS_CLUSTER_ARN in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_AWS_ECS_CLUSTER_ARN = TMP_AWS_ECS_CLUSTER_ARN;
/**
 * The [launch type](https://docs.aws.amazon.com/AmazonECS/latest/developerguide/launch_types.html) for an ECS task.
 *
 * @deprecated Use ATTR_AWS_ECS_LAUNCHTYPE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_AWS_ECS_LAUNCHTYPE = TMP_AWS_ECS_LAUNCHTYPE;
/**
 * The ARN of an [ECS task definition](https://docs.aws.amazon.com/AmazonECS/latest/developerguide/task_definitions.html).
 *
 * @deprecated Use ATTR_AWS_ECS_TASK_ARN in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_AWS_ECS_TASK_ARN = TMP_AWS_ECS_TASK_ARN;
/**
 * The task definition family this task definition is a member of.
 *
 * @deprecated Use ATTR_AWS_ECS_TASK_FAMILY in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_AWS_ECS_TASK_FAMILY = TMP_AWS_ECS_TASK_FAMILY;
/**
 * The revision for this task definition.
 *
 * @deprecated Use ATTR_AWS_ECS_TASK_REVISION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_AWS_ECS_TASK_REVISION = TMP_AWS_ECS_TASK_REVISION;
/**
 * The ARN of an EKS cluster.
 *
 * @deprecated Use ATTR_AWS_EKS_CLUSTER_ARN in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_AWS_EKS_CLUSTER_ARN = TMP_AWS_EKS_CLUSTER_ARN;
/**
 * The name(s) of the AWS log group(s) an application is writing to.
 *
 * Note: Multiple log groups must be supported for cases like multi-container applications, where a single application has sidecar containers, and each write to their own log group.
 *
 * @deprecated Use ATTR_AWS_LOG_GROUP_NAMES in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_AWS_LOG_GROUP_NAMES = TMP_AWS_LOG_GROUP_NAMES;
/**
 * The Amazon Resource Name(s) (ARN) of the AWS log group(s).
 *
 * Note: See the [log group ARN format documentation](https://docs.aws.amazon.com/AmazonCloudWatch/latest/logs/iam-access-control-overview-cwl.html#CWL_ARN_Format).
 *
 * @deprecated Use ATTR_AWS_LOG_GROUP_ARNS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_AWS_LOG_GROUP_ARNS = TMP_AWS_LOG_GROUP_ARNS;
/**
 * The name(s) of the AWS log stream(s) an application is writing to.
 *
 * @deprecated Use ATTR_AWS_LOG_STREAM_NAMES in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_AWS_LOG_STREAM_NAMES = TMP_AWS_LOG_STREAM_NAMES;
/**
 * The ARN(s) of the AWS log stream(s).
 *
 * Note: See the [log stream ARN format documentation](https://docs.aws.amazon.com/AmazonCloudWatch/latest/logs/iam-access-control-overview-cwl.html#CWL_ARN_Format). One log group can contain several log streams, so these ARNs necessarily identify both a log group and a log stream.
 *
 * @deprecated Use ATTR_AWS_LOG_STREAM_ARNS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_AWS_LOG_STREAM_ARNS = TMP_AWS_LOG_STREAM_ARNS;
/**
 * Container name.
 *
 * @deprecated Use ATTR_CONTAINER_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_CONTAINER_NAME = TMP_CONTAINER_NAME;
/**
 * Container ID. Usually a UUID, as for example used to [identify Docker containers](https://docs.docker.com/engine/reference/run/#container-identification). The UUID might be abbreviated.
 *
 * @deprecated Use ATTR_CONTAINER_ID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_CONTAINER_ID = TMP_CONTAINER_ID;
/**
 * The container runtime managing this container.
 *
 * @deprecated Use ATTR_CONTAINER_RUNTIME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_CONTAINER_RUNTIME = TMP_CONTAINER_RUNTIME;
/**
 * Name of the image the container was built on.
 *
 * @deprecated Use ATTR_CONTAINER_IMAGE_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_CONTAINER_IMAGE_NAME = TMP_CONTAINER_IMAGE_NAME;
/**
 * Container image tag.
 *
 * @deprecated Use ATTR_CONTAINER_IMAGE_TAGS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_CONTAINER_IMAGE_TAG = TMP_CONTAINER_IMAGE_TAG;
/**
 * Name of the [deployment environment](https://en.wikipedia.org/wiki/Deployment_environment) (aka deployment tier).
 *
 * @deprecated Use ATTR_DEPLOYMENT_ENVIRONMENT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_DEPLOYMENT_ENVIRONMENT = TMP_DEPLOYMENT_ENVIRONMENT;
/**
 * A unique identifier representing the device.
 *
 * Note: The device identifier MUST only be defined using the values outlined below. This value is not an advertising identifier and MUST NOT be used as such. On iOS (Swift or Objective-C), this value MUST be equal to the [vendor identifier](https://developer.apple.com/documentation/uikit/uidevice/1620059-identifierforvendor). On Android (Java or Kotlin), this value MUST be equal to the Firebase Installation ID or a globally unique UUID which is persisted across sessions in your application. More information can be found [here](https://developer.android.com/training/articles/user-data-ids) on best practices and exact implementation details. Caution should be taken when storing personal data or anything which can identify a user. GDPR and data protection laws may apply, ensure you do your own due diligence.
 *
 * @deprecated Use ATTR_DEVICE_ID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_DEVICE_ID = TMP_DEVICE_ID;
/**
 * The model identifier for the device.
 *
 * Note: It&#39;s recommended this value represents a machine readable version of the model identifier rather than the market or consumer-friendly name of the device.
 *
 * @deprecated Use ATTR_DEVICE_MODEL_IDENTIFIER in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_DEVICE_MODEL_IDENTIFIER = TMP_DEVICE_MODEL_IDENTIFIER;
/**
 * The marketing name for the device model.
 *
 * Note: It&#39;s recommended this value represents a human readable version of the device model rather than a machine readable alternative.
 *
 * @deprecated Use ATTR_DEVICE_MODEL_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_DEVICE_MODEL_NAME = TMP_DEVICE_MODEL_NAME;
/**
 * The name of the single function that this runtime instance executes.
 *
 * Note: This is the name of the function as configured/deployed on the FaaS platform and is usually different from the name of the callback function (which may be stored in the [`code.namespace`/`code.function`](../../trace/semantic_conventions/span-general.md#source-code-attributes) span attributes).
 *
 * @deprecated Use ATTR_FAAS_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_FAAS_NAME = TMP_FAAS_NAME;
/**
* The unique ID of the single function that this runtime instance executes.
*
* Note: Depending on the cloud provider, use:

* **AWS Lambda:** The function [ARN](https://docs.aws.amazon.com/general/latest/gr/aws-arns-and-namespaces.html).
Take care not to use the &#34;invoked ARN&#34; directly but replace any
[alias suffix](https://docs.aws.amazon.com/lambda/latest/dg/configuration-aliases.html) with the resolved function version, as the same runtime instance may be invokable with multiple
different aliases.
* **GCP:** The [URI of the resource](https://cloud.google.com/iam/docs/full-resource-names)
* **Azure:** The [Fully Qualified Resource ID](https://docs.microsoft.com/en-us/rest/api/resources/resources/get-by-id).

On some providers, it may not be possible to determine the full ID at startup,
which is why this field cannot be made required. For example, on AWS the account ID
part of the ARN is not available without calling another AWS API
which may be deemed too slow for a short-running lambda function.
As an alternative, consider setting `faas.id` as a span attribute instead.
*
* @deprecated Use ATTR_CLOUD_RESOURCE_ID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
*/
var SEMRESATTRS_FAAS_ID = TMP_FAAS_ID;
/**
* The immutable version of the function being executed.
*
* Note: Depending on the cloud provider and platform, use:

* **AWS Lambda:** The [function version](https://docs.aws.amazon.com/lambda/latest/dg/configuration-versions.html)
  (an integer represented as a decimal string).
* **Google Cloud Run:** The [revision](https://cloud.google.com/run/docs/managing/revisions)
  (i.e., the function name plus the revision suffix).
* **Google Cloud Functions:** The value of the
  [`K_REVISION` environment variable](https://cloud.google.com/functions/docs/env-var#runtime_environment_variables_set_automatically).
* **Azure Functions:** Not applicable. Do not set this attribute.
*
* @deprecated Use ATTR_FAAS_VERSION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
*/
var SEMRESATTRS_FAAS_VERSION = TMP_FAAS_VERSION;
/**
 * The execution environment ID as a string, that will be potentially reused for other invocations to the same function/function version.
 *
 * Note: * **AWS Lambda:** Use the (full) log stream name.
 *
 * @deprecated Use ATTR_FAAS_INSTANCE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_FAAS_INSTANCE = TMP_FAAS_INSTANCE;
/**
 * The amount of memory available to the serverless function in MiB.
 *
 * Note: It&#39;s recommended to set this attribute since e.g. too little memory can easily stop a Java AWS Lambda function from working correctly. On AWS Lambda, the environment variable `AWS_LAMBDA_FUNCTION_MEMORY_SIZE` provides this information.
 *
 * @deprecated Use ATTR_FAAS_MAX_MEMORY in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_FAAS_MAX_MEMORY = TMP_FAAS_MAX_MEMORY;
/**
 * Unique host ID. For Cloud, this must be the instance_id assigned by the cloud provider.
 *
 * @deprecated Use ATTR_HOST_ID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_HOST_ID = TMP_HOST_ID;
/**
 * Name of the host. On Unix systems, it may contain what the hostname command returns, or the fully qualified hostname, or another name specified by the user.
 *
 * @deprecated Use ATTR_HOST_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_HOST_NAME = TMP_HOST_NAME;
/**
 * Type of host. For Cloud, this must be the machine type.
 *
 * @deprecated Use ATTR_HOST_TYPE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_HOST_TYPE = TMP_HOST_TYPE;
/**
 * The CPU architecture the host system is running on.
 *
 * @deprecated Use ATTR_HOST_ARCH in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_HOST_ARCH = TMP_HOST_ARCH;
/**
 * Name of the VM image or OS install the host was instantiated from.
 *
 * @deprecated Use ATTR_HOST_IMAGE_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_HOST_IMAGE_NAME = TMP_HOST_IMAGE_NAME;
/**
 * VM image ID. For Cloud, this value is from the provider.
 *
 * @deprecated Use ATTR_HOST_IMAGE_ID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_HOST_IMAGE_ID = TMP_HOST_IMAGE_ID;
/**
 * The version string of the VM image as defined in [Version Attributes](README.md#version-attributes).
 *
 * @deprecated Use ATTR_HOST_IMAGE_VERSION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_HOST_IMAGE_VERSION = TMP_HOST_IMAGE_VERSION;
/**
 * The name of the cluster.
 *
 * @deprecated Use ATTR_K8S_CLUSTER_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_CLUSTER_NAME = TMP_K8S_CLUSTER_NAME;
/**
 * The name of the Node.
 *
 * @deprecated Use ATTR_K8S_NODE_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_NODE_NAME = TMP_K8S_NODE_NAME;
/**
 * The UID of the Node.
 *
 * @deprecated Use ATTR_K8S_NODE_UID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_NODE_UID = TMP_K8S_NODE_UID;
/**
 * The name of the namespace that the pod is running in.
 *
 * @deprecated Use ATTR_K8S_NAMESPACE_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_NAMESPACE_NAME = TMP_K8S_NAMESPACE_NAME;
/**
 * The UID of the Pod.
 *
 * @deprecated Use ATTR_K8S_POD_UID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_POD_UID = TMP_K8S_POD_UID;
/**
 * The name of the Pod.
 *
 * @deprecated Use ATTR_K8S_POD_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_POD_NAME = TMP_K8S_POD_NAME;
/**
 * The name of the Container in a Pod template.
 *
 * @deprecated Use ATTR_K8S_CONTAINER_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_CONTAINER_NAME = TMP_K8S_CONTAINER_NAME;
/**
 * The UID of the ReplicaSet.
 *
 * @deprecated Use ATTR_K8S_REPLICASET_UID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_REPLICASET_UID = TMP_K8S_REPLICASET_UID;
/**
 * The name of the ReplicaSet.
 *
 * @deprecated Use ATTR_K8S_REPLICASET_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_REPLICASET_NAME = TMP_K8S_REPLICASET_NAME;
/**
 * The UID of the Deployment.
 *
 * @deprecated Use ATTR_K8S_DEPLOYMENT_UID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_DEPLOYMENT_UID = TMP_K8S_DEPLOYMENT_UID;
/**
 * The name of the Deployment.
 *
 * @deprecated Use ATTR_K8S_DEPLOYMENT_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_DEPLOYMENT_NAME = TMP_K8S_DEPLOYMENT_NAME;
/**
 * The UID of the StatefulSet.
 *
 * @deprecated Use ATTR_K8S_STATEFULSET_UID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_STATEFULSET_UID = TMP_K8S_STATEFULSET_UID;
/**
 * The name of the StatefulSet.
 *
 * @deprecated Use ATTR_K8S_STATEFULSET_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_STATEFULSET_NAME = TMP_K8S_STATEFULSET_NAME;
/**
 * The UID of the DaemonSet.
 *
 * @deprecated Use ATTR_K8S_DAEMONSET_UID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_DAEMONSET_UID = TMP_K8S_DAEMONSET_UID;
/**
 * The name of the DaemonSet.
 *
 * @deprecated Use ATTR_K8S_DAEMONSET_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_DAEMONSET_NAME = TMP_K8S_DAEMONSET_NAME;
/**
 * The UID of the Job.
 *
 * @deprecated Use ATTR_K8S_JOB_UID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_JOB_UID = TMP_K8S_JOB_UID;
/**
 * The name of the Job.
 *
 * @deprecated Use ATTR_K8S_JOB_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_JOB_NAME = TMP_K8S_JOB_NAME;
/**
 * The UID of the CronJob.
 *
 * @deprecated Use ATTR_K8S_CRONJOB_UID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_CRONJOB_UID = TMP_K8S_CRONJOB_UID;
/**
 * The name of the CronJob.
 *
 * @deprecated Use ATTR_K8S_CRONJOB_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_K8S_CRONJOB_NAME = TMP_K8S_CRONJOB_NAME;
/**
 * The operating system type.
 *
 * @deprecated Use ATTR_OS_TYPE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_OS_TYPE = TMP_OS_TYPE;
/**
 * Human readable (not intended to be parsed) OS version information, like e.g. reported by `ver` or `lsb_release -a` commands.
 *
 * @deprecated Use ATTR_OS_DESCRIPTION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_OS_DESCRIPTION = TMP_OS_DESCRIPTION;
/**
 * Human readable operating system name.
 *
 * @deprecated Use ATTR_OS_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_OS_NAME = TMP_OS_NAME;
/**
 * The version string of the operating system as defined in [Version Attributes](../../resource/semantic_conventions/README.md#version-attributes).
 *
 * @deprecated Use ATTR_OS_VERSION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_OS_VERSION = TMP_OS_VERSION;
/**
 * Process identifier (PID).
 *
 * @deprecated Use ATTR_PROCESS_PID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_PROCESS_PID = TMP_PROCESS_PID;
/**
 * The name of the process executable. On Linux based systems, can be set to the `Name` in `proc/[pid]/status`. On Windows, can be set to the base name of `GetProcessImageFileNameW`.
 *
 * @deprecated Use ATTR_PROCESS_EXECUTABLE_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_PROCESS_EXECUTABLE_NAME = TMP_PROCESS_EXECUTABLE_NAME;
/**
 * The full path to the process executable. On Linux based systems, can be set to the target of `proc/[pid]/exe`. On Windows, can be set to the result of `GetProcessImageFileNameW`.
 *
 * @deprecated Use ATTR_PROCESS_EXECUTABLE_PATH in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_PROCESS_EXECUTABLE_PATH = TMP_PROCESS_EXECUTABLE_PATH;
/**
 * The command used to launch the process (i.e. the command name). On Linux based systems, can be set to the zeroth string in `proc/[pid]/cmdline`. On Windows, can be set to the first parameter extracted from `GetCommandLineW`.
 *
 * @deprecated Use ATTR_PROCESS_COMMAND in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_PROCESS_COMMAND = TMP_PROCESS_COMMAND;
/**
 * The full command used to launch the process as a single string representing the full command. On Windows, can be set to the result of `GetCommandLineW`. Do not set this if you have to assemble it just for monitoring; use `process.command_args` instead.
 *
 * @deprecated Use ATTR_PROCESS_COMMAND_LINE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_PROCESS_COMMAND_LINE = TMP_PROCESS_COMMAND_LINE;
/**
 * All the command arguments (including the command/executable itself) as received by the process. On Linux-based systems (and some other Unixoid systems supporting procfs), can be set according to the list of null-delimited strings extracted from `proc/[pid]/cmdline`. For libc-based executables, this would be the full argv vector passed to `main`.
 *
 * @deprecated Use ATTR_PROCESS_COMMAND_ARGS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_PROCESS_COMMAND_ARGS = TMP_PROCESS_COMMAND_ARGS;
/**
 * The username of the user that owns the process.
 *
 * @deprecated Use ATTR_PROCESS_OWNER in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_PROCESS_OWNER = TMP_PROCESS_OWNER;
/**
 * The name of the runtime of this process. For compiled native binaries, this SHOULD be the name of the compiler.
 *
 * @deprecated Use ATTR_PROCESS_RUNTIME_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_PROCESS_RUNTIME_NAME = TMP_PROCESS_RUNTIME_NAME;
/**
 * The version of the runtime of this process, as returned by the runtime without modification.
 *
 * @deprecated Use ATTR_PROCESS_RUNTIME_VERSION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_PROCESS_RUNTIME_VERSION = TMP_PROCESS_RUNTIME_VERSION;
/**
 * An additional description about the runtime of the process, for example a specific vendor customization of the runtime environment.
 *
 * @deprecated Use ATTR_PROCESS_RUNTIME_DESCRIPTION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_PROCESS_RUNTIME_DESCRIPTION = TMP_PROCESS_RUNTIME_DESCRIPTION;
/**
 * Logical name of the service.
 *
 * Note: MUST be the same for all instances of horizontally scaled services. If the value was not specified, SDKs MUST fallback to `unknown_service:` concatenated with [`process.executable.name`](process.md#process), e.g. `unknown_service:bash`. If `process.executable.name` is not available, the value MUST be set to `unknown_service`.
 *
 * @deprecated Use ATTR_SERVICE_NAME.
 */
var SEMRESATTRS_SERVICE_NAME = TMP_SERVICE_NAME;
/**
 * A namespace for `service.name`.
 *
 * Note: A string value having a meaning that helps to distinguish a group of services, for example the team name that owns a group of services. `service.name` is expected to be unique within the same namespace. If `service.namespace` is not specified in the Resource then `service.name` is expected to be unique for all services that have no explicit namespace defined (so the empty/unspecified namespace is simply one more valid namespace). Zero-length namespace string is assumed equal to unspecified namespace.
 *
 * @deprecated Use ATTR_SERVICE_NAMESPACE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_SERVICE_NAMESPACE = TMP_SERVICE_NAMESPACE;
/**
 * The string ID of the service instance.
 *
 * Note: MUST be unique for each instance of the same `service.namespace,service.name` pair (in other words `service.namespace,service.name,service.instance.id` triplet MUST be globally unique). The ID helps to distinguish instances of the same service that exist at the same time (e.g. instances of a horizontally scaled service). It is preferable for the ID to be persistent and stay the same for the lifetime of the service instance, however it is acceptable that the ID is ephemeral and changes during important lifetime events for the service (e.g. service restarts). If the service has no inherent unique ID that can be used as the value of this attribute it is recommended to generate a random Version 1 or Version 4 RFC 4122 UUID (services aiming for reproducible UUIDs may also use Version 5, see RFC 4122 for more recommendations).
 *
 * @deprecated Use ATTR_SERVICE_INSTANCE_ID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_SERVICE_INSTANCE_ID = TMP_SERVICE_INSTANCE_ID;
/**
 * The version string of the service API or implementation.
 *
 * @deprecated Use ATTR_SERVICE_VERSION.
 */
var SEMRESATTRS_SERVICE_VERSION = TMP_SERVICE_VERSION;
/**
 * The name of the telemetry SDK as defined above.
 *
 * @deprecated Use ATTR_TELEMETRY_SDK_NAME.
 */
var SEMRESATTRS_TELEMETRY_SDK_NAME = TMP_TELEMETRY_SDK_NAME;
/**
 * The language of the telemetry SDK.
 *
 * @deprecated Use ATTR_TELEMETRY_SDK_LANGUAGE.
 */
var SEMRESATTRS_TELEMETRY_SDK_LANGUAGE = TMP_TELEMETRY_SDK_LANGUAGE;
/**
 * The version string of the telemetry SDK.
 *
 * @deprecated Use ATTR_TELEMETRY_SDK_VERSION.
 */
var SEMRESATTRS_TELEMETRY_SDK_VERSION = TMP_TELEMETRY_SDK_VERSION;
/**
 * The version string of the auto instrumentation agent, if used.
 *
 * @deprecated Use ATTR_TELEMETRY_DISTRO_VERSION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_TELEMETRY_AUTO_VERSION = TMP_TELEMETRY_AUTO_VERSION;
/**
 * The name of the web engine.
 *
 * @deprecated Use ATTR_WEBENGINE_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_WEBENGINE_NAME = TMP_WEBENGINE_NAME;
/**
 * The version of the web engine.
 *
 * @deprecated Use ATTR_WEBENGINE_VERSION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_WEBENGINE_VERSION = TMP_WEBENGINE_VERSION;
/**
 * Additional description of the web engine (e.g. detailed version and edition information).
 *
 * @deprecated Use ATTR_WEBENGINE_DESCRIPTION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMRESATTRS_WEBENGINE_DESCRIPTION = TMP_WEBENGINE_DESCRIPTION;
/**
 * Create exported Value Map for SemanticResourceAttributes values
 * @deprecated Use the SEMRESATTRS_XXXXX constants rather than the SemanticResourceAttributes.XXXXX for bundle minification
 */
var SemanticResourceAttributes = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_CLOUD_PROVIDER,
    TMP_CLOUD_ACCOUNT_ID,
    TMP_CLOUD_REGION,
    TMP_CLOUD_AVAILABILITY_ZONE,
    TMP_CLOUD_PLATFORM,
    TMP_AWS_ECS_CONTAINER_ARN,
    TMP_AWS_ECS_CLUSTER_ARN,
    TMP_AWS_ECS_LAUNCHTYPE,
    TMP_AWS_ECS_TASK_ARN,
    TMP_AWS_ECS_TASK_FAMILY,
    TMP_AWS_ECS_TASK_REVISION,
    TMP_AWS_EKS_CLUSTER_ARN,
    TMP_AWS_LOG_GROUP_NAMES,
    TMP_AWS_LOG_GROUP_ARNS,
    TMP_AWS_LOG_STREAM_NAMES,
    TMP_AWS_LOG_STREAM_ARNS,
    TMP_CONTAINER_NAME,
    TMP_CONTAINER_ID,
    TMP_CONTAINER_RUNTIME,
    TMP_CONTAINER_IMAGE_NAME,
    TMP_CONTAINER_IMAGE_TAG,
    TMP_DEPLOYMENT_ENVIRONMENT,
    TMP_DEVICE_ID,
    TMP_DEVICE_MODEL_IDENTIFIER,
    TMP_DEVICE_MODEL_NAME,
    TMP_FAAS_NAME,
    TMP_FAAS_ID,
    TMP_FAAS_VERSION,
    TMP_FAAS_INSTANCE,
    TMP_FAAS_MAX_MEMORY,
    TMP_HOST_ID,
    TMP_HOST_NAME,
    TMP_HOST_TYPE,
    TMP_HOST_ARCH,
    TMP_HOST_IMAGE_NAME,
    TMP_HOST_IMAGE_ID,
    TMP_HOST_IMAGE_VERSION,
    TMP_K8S_CLUSTER_NAME,
    TMP_K8S_NODE_NAME,
    TMP_K8S_NODE_UID,
    TMP_K8S_NAMESPACE_NAME,
    TMP_K8S_POD_UID,
    TMP_K8S_POD_NAME,
    TMP_K8S_CONTAINER_NAME,
    TMP_K8S_REPLICASET_UID,
    TMP_K8S_REPLICASET_NAME,
    TMP_K8S_DEPLOYMENT_UID,
    TMP_K8S_DEPLOYMENT_NAME,
    TMP_K8S_STATEFULSET_UID,
    TMP_K8S_STATEFULSET_NAME,
    TMP_K8S_DAEMONSET_UID,
    TMP_K8S_DAEMONSET_NAME,
    TMP_K8S_JOB_UID,
    TMP_K8S_JOB_NAME,
    TMP_K8S_CRONJOB_UID,
    TMP_K8S_CRONJOB_NAME,
    TMP_OS_TYPE,
    TMP_OS_DESCRIPTION,
    TMP_OS_NAME,
    TMP_OS_VERSION,
    TMP_PROCESS_PID,
    TMP_PROCESS_EXECUTABLE_NAME,
    TMP_PROCESS_EXECUTABLE_PATH,
    TMP_PROCESS_COMMAND,
    TMP_PROCESS_COMMAND_LINE,
    TMP_PROCESS_COMMAND_ARGS,
    TMP_PROCESS_OWNER,
    TMP_PROCESS_RUNTIME_NAME,
    TMP_PROCESS_RUNTIME_VERSION,
    TMP_PROCESS_RUNTIME_DESCRIPTION,
    TMP_SERVICE_NAME,
    TMP_SERVICE_NAMESPACE,
    TMP_SERVICE_INSTANCE_ID,
    TMP_SERVICE_VERSION,
    TMP_TELEMETRY_SDK_NAME,
    TMP_TELEMETRY_SDK_LANGUAGE,
    TMP_TELEMETRY_SDK_VERSION,
    TMP_TELEMETRY_AUTO_VERSION,
    TMP_WEBENGINE_NAME,
    TMP_WEBENGINE_VERSION,
    TMP_WEBENGINE_DESCRIPTION,
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for CloudProviderValues enum definition
 *
 * Name of the cloud provider.
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD = 'alibaba_cloud';
var TMP_CLOUDPROVIDERVALUES_AWS = 'aws';
var TMP_CLOUDPROVIDERVALUES_AZURE = 'azure';
var TMP_CLOUDPROVIDERVALUES_GCP = 'gcp';
/**
 * Name of the cloud provider.
 *
 * @deprecated Use CLOUD_PROVIDER_VALUE_ALIBABA_CLOUD in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPROVIDERVALUES_ALIBABA_CLOUD = TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD;
/**
 * Name of the cloud provider.
 *
 * @deprecated Use CLOUD_PROVIDER_VALUE_AWS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPROVIDERVALUES_AWS = TMP_CLOUDPROVIDERVALUES_AWS;
/**
 * Name of the cloud provider.
 *
 * @deprecated Use CLOUD_PROVIDER_VALUE_AZURE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPROVIDERVALUES_AZURE = TMP_CLOUDPROVIDERVALUES_AZURE;
/**
 * Name of the cloud provider.
 *
 * @deprecated Use CLOUD_PROVIDER_VALUE_GCP in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPROVIDERVALUES_GCP = TMP_CLOUDPROVIDERVALUES_GCP;
/**
 * The constant map of values for CloudProviderValues.
 * @deprecated Use the CLOUDPROVIDERVALUES_XXXXX constants rather than the CloudProviderValues.XXXXX for bundle minification.
 */
var CloudProviderValues = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_CLOUDPROVIDERVALUES_ALIBABA_CLOUD,
    TMP_CLOUDPROVIDERVALUES_AWS,
    TMP_CLOUDPROVIDERVALUES_AZURE,
    TMP_CLOUDPROVIDERVALUES_GCP,
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for CloudPlatformValues enum definition
 *
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS = 'alibaba_cloud_ecs';
var TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC = 'alibaba_cloud_fc';
var TMP_CLOUDPLATFORMVALUES_AWS_EC2 = 'aws_ec2';
var TMP_CLOUDPLATFORMVALUES_AWS_ECS = 'aws_ecs';
var TMP_CLOUDPLATFORMVALUES_AWS_EKS = 'aws_eks';
var TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA = 'aws_lambda';
var TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK = 'aws_elastic_beanstalk';
var TMP_CLOUDPLATFORMVALUES_AZURE_VM = 'azure_vm';
var TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES = 'azure_container_instances';
var TMP_CLOUDPLATFORMVALUES_AZURE_AKS = 'azure_aks';
var TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS = 'azure_functions';
var TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE = 'azure_app_service';
var TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE = 'gcp_compute_engine';
var TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN = 'gcp_cloud_run';
var TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE = 'gcp_kubernetes_engine';
var TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS = 'gcp_cloud_functions';
var TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE = 'gcp_app_engine';
/**
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 *
 * @deprecated Use CLOUD_PLATFORM_VALUE_ALIBABA_CLOUD_ECS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS = TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS;
/**
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 *
 * @deprecated Use CLOUD_PLATFORM_VALUE_ALIBABA_CLOUD_FC in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC = TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC;
/**
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 *
 * @deprecated Use CLOUD_PLATFORM_VALUE_AWS_EC2 in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPLATFORMVALUES_AWS_EC2 = TMP_CLOUDPLATFORMVALUES_AWS_EC2;
/**
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 *
 * @deprecated Use CLOUD_PLATFORM_VALUE_AWS_ECS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPLATFORMVALUES_AWS_ECS = TMP_CLOUDPLATFORMVALUES_AWS_ECS;
/**
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 *
 * @deprecated Use CLOUD_PLATFORM_VALUE_AWS_EKS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPLATFORMVALUES_AWS_EKS = TMP_CLOUDPLATFORMVALUES_AWS_EKS;
/**
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 *
 * @deprecated Use CLOUD_PLATFORM_VALUE_AWS_LAMBDA in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPLATFORMVALUES_AWS_LAMBDA = TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA;
/**
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 *
 * @deprecated Use CLOUD_PLATFORM_VALUE_AWS_ELASTIC_BEANSTALK in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK = TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK;
/**
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 *
 * @deprecated Use CLOUD_PLATFORM_VALUE_AZURE_VM in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPLATFORMVALUES_AZURE_VM = TMP_CLOUDPLATFORMVALUES_AZURE_VM;
/**
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 *
 * @deprecated Use CLOUD_PLATFORM_VALUE_AZURE_CONTAINER_INSTANCES in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES = TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES;
/**
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 *
 * @deprecated Use CLOUD_PLATFORM_VALUE_AZURE_AKS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPLATFORMVALUES_AZURE_AKS = TMP_CLOUDPLATFORMVALUES_AZURE_AKS;
/**
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 *
 * @deprecated Use CLOUD_PLATFORM_VALUE_AZURE_FUNCTIONS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPLATFORMVALUES_AZURE_FUNCTIONS = TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS;
/**
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 *
 * @deprecated Use CLOUD_PLATFORM_VALUE_AZURE_APP_SERVICE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPLATFORMVALUES_AZURE_APP_SERVICE = TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE;
/**
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 *
 * @deprecated Use CLOUD_PLATFORM_VALUE_GCP_COMPUTE_ENGINE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE = TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE;
/**
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 *
 * @deprecated Use CLOUD_PLATFORM_VALUE_GCP_CLOUD_RUN in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPLATFORMVALUES_GCP_CLOUD_RUN = TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN;
/**
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 *
 * @deprecated Use CLOUD_PLATFORM_VALUE_GCP_KUBERNETES_ENGINE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE = TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE;
/**
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 *
 * @deprecated Use CLOUD_PLATFORM_VALUE_GCP_CLOUD_FUNCTIONS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS = TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS;
/**
 * The cloud platform in use.
 *
 * Note: The prefix of the service SHOULD match the one specified in `cloud.provider`.
 *
 * @deprecated Use CLOUD_PLATFORM_VALUE_GCP_APP_ENGINE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var CLOUDPLATFORMVALUES_GCP_APP_ENGINE = TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE;
/**
 * The constant map of values for CloudPlatformValues.
 * @deprecated Use the CLOUDPLATFORMVALUES_XXXXX constants rather than the CloudPlatformValues.XXXXX for bundle minification.
 */
var CloudPlatformValues = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_ECS,
    TMP_CLOUDPLATFORMVALUES_ALIBABA_CLOUD_FC,
    TMP_CLOUDPLATFORMVALUES_AWS_EC2,
    TMP_CLOUDPLATFORMVALUES_AWS_ECS,
    TMP_CLOUDPLATFORMVALUES_AWS_EKS,
    TMP_CLOUDPLATFORMVALUES_AWS_LAMBDA,
    TMP_CLOUDPLATFORMVALUES_AWS_ELASTIC_BEANSTALK,
    TMP_CLOUDPLATFORMVALUES_AZURE_VM,
    TMP_CLOUDPLATFORMVALUES_AZURE_CONTAINER_INSTANCES,
    TMP_CLOUDPLATFORMVALUES_AZURE_AKS,
    TMP_CLOUDPLATFORMVALUES_AZURE_FUNCTIONS,
    TMP_CLOUDPLATFORMVALUES_AZURE_APP_SERVICE,
    TMP_CLOUDPLATFORMVALUES_GCP_COMPUTE_ENGINE,
    TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_RUN,
    TMP_CLOUDPLATFORMVALUES_GCP_KUBERNETES_ENGINE,
    TMP_CLOUDPLATFORMVALUES_GCP_CLOUD_FUNCTIONS,
    TMP_CLOUDPLATFORMVALUES_GCP_APP_ENGINE,
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for AwsEcsLaunchtypeValues enum definition
 *
 * The [launch type](https://docs.aws.amazon.com/AmazonECS/latest/developerguide/launch_types.html) for an ECS task.
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_AWSECSLAUNCHTYPEVALUES_EC2 = 'ec2';
var TMP_AWSECSLAUNCHTYPEVALUES_FARGATE = 'fargate';
/**
 * The [launch type](https://docs.aws.amazon.com/AmazonECS/latest/developerguide/launch_types.html) for an ECS task.
 *
 * @deprecated Use AWS_ECS_LAUNCHTYPE_VALUE_EC2 in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var AWSECSLAUNCHTYPEVALUES_EC2 = TMP_AWSECSLAUNCHTYPEVALUES_EC2;
/**
 * The [launch type](https://docs.aws.amazon.com/AmazonECS/latest/developerguide/launch_types.html) for an ECS task.
 *
 * @deprecated Use AWS_ECS_LAUNCHTYPE_VALUE_FARGATE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var AWSECSLAUNCHTYPEVALUES_FARGATE = TMP_AWSECSLAUNCHTYPEVALUES_FARGATE;
/**
 * The constant map of values for AwsEcsLaunchtypeValues.
 * @deprecated Use the AWSECSLAUNCHTYPEVALUES_XXXXX constants rather than the AwsEcsLaunchtypeValues.XXXXX for bundle minification.
 */
var AwsEcsLaunchtypeValues = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_AWSECSLAUNCHTYPEVALUES_EC2,
    TMP_AWSECSLAUNCHTYPEVALUES_FARGATE,
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for HostArchValues enum definition
 *
 * The CPU architecture the host system is running on.
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_HOSTARCHVALUES_AMD64 = 'amd64';
var TMP_HOSTARCHVALUES_ARM32 = 'arm32';
var TMP_HOSTARCHVALUES_ARM64 = 'arm64';
var TMP_HOSTARCHVALUES_IA64 = 'ia64';
var TMP_HOSTARCHVALUES_PPC32 = 'ppc32';
var TMP_HOSTARCHVALUES_PPC64 = 'ppc64';
var TMP_HOSTARCHVALUES_X86 = 'x86';
/**
 * The CPU architecture the host system is running on.
 *
 * @deprecated Use HOST_ARCH_VALUE_AMD64 in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var HOSTARCHVALUES_AMD64 = TMP_HOSTARCHVALUES_AMD64;
/**
 * The CPU architecture the host system is running on.
 *
 * @deprecated Use HOST_ARCH_VALUE_ARM32 in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var HOSTARCHVALUES_ARM32 = TMP_HOSTARCHVALUES_ARM32;
/**
 * The CPU architecture the host system is running on.
 *
 * @deprecated Use HOST_ARCH_VALUE_ARM64 in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var HOSTARCHVALUES_ARM64 = TMP_HOSTARCHVALUES_ARM64;
/**
 * The CPU architecture the host system is running on.
 *
 * @deprecated Use HOST_ARCH_VALUE_IA64 in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var HOSTARCHVALUES_IA64 = TMP_HOSTARCHVALUES_IA64;
/**
 * The CPU architecture the host system is running on.
 *
 * @deprecated Use HOST_ARCH_VALUE_PPC32 in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var HOSTARCHVALUES_PPC32 = TMP_HOSTARCHVALUES_PPC32;
/**
 * The CPU architecture the host system is running on.
 *
 * @deprecated Use HOST_ARCH_VALUE_PPC64 in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var HOSTARCHVALUES_PPC64 = TMP_HOSTARCHVALUES_PPC64;
/**
 * The CPU architecture the host system is running on.
 *
 * @deprecated Use HOST_ARCH_VALUE_X86 in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var HOSTARCHVALUES_X86 = TMP_HOSTARCHVALUES_X86;
/**
 * The constant map of values for HostArchValues.
 * @deprecated Use the HOSTARCHVALUES_XXXXX constants rather than the HostArchValues.XXXXX for bundle minification.
 */
var HostArchValues = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_HOSTARCHVALUES_AMD64,
    TMP_HOSTARCHVALUES_ARM32,
    TMP_HOSTARCHVALUES_ARM64,
    TMP_HOSTARCHVALUES_IA64,
    TMP_HOSTARCHVALUES_PPC32,
    TMP_HOSTARCHVALUES_PPC64,
    TMP_HOSTARCHVALUES_X86,
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for OsTypeValues enum definition
 *
 * The operating system type.
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_OSTYPEVALUES_WINDOWS = 'windows';
var TMP_OSTYPEVALUES_LINUX = 'linux';
var TMP_OSTYPEVALUES_DARWIN = 'darwin';
var TMP_OSTYPEVALUES_FREEBSD = 'freebsd';
var TMP_OSTYPEVALUES_NETBSD = 'netbsd';
var TMP_OSTYPEVALUES_OPENBSD = 'openbsd';
var TMP_OSTYPEVALUES_DRAGONFLYBSD = 'dragonflybsd';
var TMP_OSTYPEVALUES_HPUX = 'hpux';
var TMP_OSTYPEVALUES_AIX = 'aix';
var TMP_OSTYPEVALUES_SOLARIS = 'solaris';
var TMP_OSTYPEVALUES_Z_OS = 'z_os';
/**
 * The operating system type.
 *
 * @deprecated Use OS_TYPE_VALUE_WINDOWS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var OSTYPEVALUES_WINDOWS = TMP_OSTYPEVALUES_WINDOWS;
/**
 * The operating system type.
 *
 * @deprecated Use OS_TYPE_VALUE_LINUX in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var OSTYPEVALUES_LINUX = TMP_OSTYPEVALUES_LINUX;
/**
 * The operating system type.
 *
 * @deprecated Use OS_TYPE_VALUE_DARWIN in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var OSTYPEVALUES_DARWIN = TMP_OSTYPEVALUES_DARWIN;
/**
 * The operating system type.
 *
 * @deprecated Use OS_TYPE_VALUE_FREEBSD in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var OSTYPEVALUES_FREEBSD = TMP_OSTYPEVALUES_FREEBSD;
/**
 * The operating system type.
 *
 * @deprecated Use OS_TYPE_VALUE_NETBSD in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var OSTYPEVALUES_NETBSD = TMP_OSTYPEVALUES_NETBSD;
/**
 * The operating system type.
 *
 * @deprecated Use OS_TYPE_VALUE_OPENBSD in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var OSTYPEVALUES_OPENBSD = TMP_OSTYPEVALUES_OPENBSD;
/**
 * The operating system type.
 *
 * @deprecated Use OS_TYPE_VALUE_DRAGONFLYBSD in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var OSTYPEVALUES_DRAGONFLYBSD = TMP_OSTYPEVALUES_DRAGONFLYBSD;
/**
 * The operating system type.
 *
 * @deprecated Use OS_TYPE_VALUE_HPUX in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var OSTYPEVALUES_HPUX = TMP_OSTYPEVALUES_HPUX;
/**
 * The operating system type.
 *
 * @deprecated Use OS_TYPE_VALUE_AIX in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var OSTYPEVALUES_AIX = TMP_OSTYPEVALUES_AIX;
/**
 * The operating system type.
 *
 * @deprecated Use OS_TYPE_VALUE_SOLARIS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var OSTYPEVALUES_SOLARIS = TMP_OSTYPEVALUES_SOLARIS;
/**
 * The operating system type.
 *
 * @deprecated Use OS_TYPE_VALUE_Z_OS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var OSTYPEVALUES_Z_OS = TMP_OSTYPEVALUES_Z_OS;
/**
 * The constant map of values for OsTypeValues.
 * @deprecated Use the OSTYPEVALUES_XXXXX constants rather than the OsTypeValues.XXXXX for bundle minification.
 */
var OsTypeValues = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_OSTYPEVALUES_WINDOWS,
    TMP_OSTYPEVALUES_LINUX,
    TMP_OSTYPEVALUES_DARWIN,
    TMP_OSTYPEVALUES_FREEBSD,
    TMP_OSTYPEVALUES_NETBSD,
    TMP_OSTYPEVALUES_OPENBSD,
    TMP_OSTYPEVALUES_DRAGONFLYBSD,
    TMP_OSTYPEVALUES_HPUX,
    TMP_OSTYPEVALUES_AIX,
    TMP_OSTYPEVALUES_SOLARIS,
    TMP_OSTYPEVALUES_Z_OS,
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for TelemetrySdkLanguageValues enum definition
 *
 * The language of the telemetry SDK.
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_TELEMETRYSDKLANGUAGEVALUES_CPP = 'cpp';
var TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET = 'dotnet';
var TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG = 'erlang';
var TMP_TELEMETRYSDKLANGUAGEVALUES_GO = 'go';
var TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA = 'java';
var TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS = 'nodejs';
var TMP_TELEMETRYSDKLANGUAGEVALUES_PHP = 'php';
var TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON = 'python';
var TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY = 'ruby';
var TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS = 'webjs';
/**
 * The language of the telemetry SDK.
 *
 * @deprecated Use TELEMETRY_SDK_LANGUAGE_VALUE_CPP.
 */
var TELEMETRYSDKLANGUAGEVALUES_CPP = TMP_TELEMETRYSDKLANGUAGEVALUES_CPP;
/**
 * The language of the telemetry SDK.
 *
 * @deprecated Use TELEMETRY_SDK_LANGUAGE_VALUE_DOTNET.
 */
var TELEMETRYSDKLANGUAGEVALUES_DOTNET = TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET;
/**
 * The language of the telemetry SDK.
 *
 * @deprecated Use TELEMETRY_SDK_LANGUAGE_VALUE_ERLANG.
 */
var TELEMETRYSDKLANGUAGEVALUES_ERLANG = TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG;
/**
 * The language of the telemetry SDK.
 *
 * @deprecated Use TELEMETRY_SDK_LANGUAGE_VALUE_GO.
 */
var TELEMETRYSDKLANGUAGEVALUES_GO = TMP_TELEMETRYSDKLANGUAGEVALUES_GO;
/**
 * The language of the telemetry SDK.
 *
 * @deprecated Use TELEMETRY_SDK_LANGUAGE_VALUE_JAVA.
 */
var TELEMETRYSDKLANGUAGEVALUES_JAVA = TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA;
/**
 * The language of the telemetry SDK.
 *
 * @deprecated Use TELEMETRY_SDK_LANGUAGE_VALUE_NODEJS.
 */
var TELEMETRYSDKLANGUAGEVALUES_NODEJS = TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS;
/**
 * The language of the telemetry SDK.
 *
 * @deprecated Use TELEMETRY_SDK_LANGUAGE_VALUE_PHP.
 */
var TELEMETRYSDKLANGUAGEVALUES_PHP = TMP_TELEMETRYSDKLANGUAGEVALUES_PHP;
/**
 * The language of the telemetry SDK.
 *
 * @deprecated Use TELEMETRY_SDK_LANGUAGE_VALUE_PYTHON.
 */
var TELEMETRYSDKLANGUAGEVALUES_PYTHON = TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON;
/**
 * The language of the telemetry SDK.
 *
 * @deprecated Use TELEMETRY_SDK_LANGUAGE_VALUE_RUBY.
 */
var TELEMETRYSDKLANGUAGEVALUES_RUBY = TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY;
/**
 * The language of the telemetry SDK.
 *
 * @deprecated Use TELEMETRY_SDK_LANGUAGE_VALUE_WEBJS.
 */
var TELEMETRYSDKLANGUAGEVALUES_WEBJS = TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS;
/**
 * The constant map of values for TelemetrySdkLanguageValues.
 * @deprecated Use the TELEMETRYSDKLANGUAGEVALUES_XXXXX constants rather than the TelemetrySdkLanguageValues.XXXXX for bundle minification.
 */
var TelemetrySdkLanguageValues = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_TELEMETRYSDKLANGUAGEVALUES_CPP,
    TMP_TELEMETRYSDKLANGUAGEVALUES_DOTNET,
    TMP_TELEMETRYSDKLANGUAGEVALUES_ERLANG,
    TMP_TELEMETRYSDKLANGUAGEVALUES_GO,
    TMP_TELEMETRYSDKLANGUAGEVALUES_JAVA,
    TMP_TELEMETRYSDKLANGUAGEVALUES_NODEJS,
    TMP_TELEMETRYSDKLANGUAGEVALUES_PHP,
    TMP_TELEMETRYSDKLANGUAGEVALUES_PYTHON,
    TMP_TELEMETRYSDKLANGUAGEVALUES_RUBY,
    TMP_TELEMETRYSDKLANGUAGEVALUES_WEBJS,
]);
//# sourceMappingURL=SemanticResourceAttributes.js.map

/***/ }),
/* 2020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SemanticResourceAttributes__ = __webpack_require__(2019);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticResourceAttributes__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticResourceAttributes__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticResourceAttributes__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticResourceAttributes__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticResourceAttributes__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticResourceAttributes__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticResourceAttributes__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticResourceAttributes__["h"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable no-restricted-syntax --
 * These re-exports are only of constants, only one-level deep at this point,
 * and should not cause problems for tree-shakers.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 2021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ATTR_ASPNETCORE_RATE_LIMITING_RESULT */
/* unused harmony export ASPNETCORE_RATE_LIMITING_RESULT_VALUE_ACQUIRED */
/* unused harmony export ASPNETCORE_RATE_LIMITING_RESULT_VALUE_ENDPOINT_LIMITER */
/* unused harmony export ASPNETCORE_RATE_LIMITING_RESULT_VALUE_GLOBAL_LIMITER */
/* unused harmony export ASPNETCORE_RATE_LIMITING_RESULT_VALUE_REQUEST_CANCELED */
/* unused harmony export ATTR_TELEMETRY_SDK_LANGUAGE */
/* unused harmony export TELEMETRY_SDK_LANGUAGE_VALUE_CPP */
/* unused harmony export TELEMETRY_SDK_LANGUAGE_VALUE_DOTNET */
/* unused harmony export TELEMETRY_SDK_LANGUAGE_VALUE_ERLANG */
/* unused harmony export TELEMETRY_SDK_LANGUAGE_VALUE_GO */
/* unused harmony export TELEMETRY_SDK_LANGUAGE_VALUE_JAVA */
/* unused harmony export TELEMETRY_SDK_LANGUAGE_VALUE_NODEJS */
/* unused harmony export TELEMETRY_SDK_LANGUAGE_VALUE_PHP */
/* unused harmony export TELEMETRY_SDK_LANGUAGE_VALUE_PYTHON */
/* unused harmony export TELEMETRY_SDK_LANGUAGE_VALUE_RUBY */
/* unused harmony export TELEMETRY_SDK_LANGUAGE_VALUE_RUST */
/* unused harmony export TELEMETRY_SDK_LANGUAGE_VALUE_SWIFT */
/* unused harmony export TELEMETRY_SDK_LANGUAGE_VALUE_WEBJS */
/* unused harmony export ATTR_TELEMETRY_SDK_NAME */
/* unused harmony export ATTR_TELEMETRY_SDK_VERSION */
/* unused harmony export ATTR_ASPNETCORE_DIAGNOSTICS_HANDLER_TYPE */
/* unused harmony export ATTR_ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT */
/* unused harmony export ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_ABORTED */
/* unused harmony export ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_HANDLED */
/* unused harmony export ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_SKIPPED */
/* unused harmony export ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_UNHANDLED */
/* unused harmony export ATTR_ASPNETCORE_RATE_LIMITING_POLICY */
/* unused harmony export ATTR_ASPNETCORE_REQUEST_IS_UNHANDLED */
/* unused harmony export ATTR_ASPNETCORE_ROUTING_IS_FALLBACK */
/* unused harmony export ATTR_ASPNETCORE_ROUTING_MATCH_STATUS */
/* unused harmony export ASPNETCORE_ROUTING_MATCH_STATUS_VALUE_FAILURE */
/* unused harmony export ASPNETCORE_ROUTING_MATCH_STATUS_VALUE_SUCCESS */
/* unused harmony export ATTR_CLIENT_ADDRESS */
/* unused harmony export ATTR_CLIENT_PORT */
/* unused harmony export ATTR_ERROR_TYPE */
/* unused harmony export ERROR_TYPE_VALUE_OTHER */
/* unused harmony export ATTR_EXCEPTION_ESCAPED */
/* unused harmony export ATTR_EXCEPTION_MESSAGE */
/* unused harmony export ATTR_EXCEPTION_STACKTRACE */
/* unused harmony export ATTR_EXCEPTION_TYPE */
/* unused harmony export ATTR_HTTP_REQUEST_HEADER */
/* unused harmony export ATTR_HTTP_REQUEST_METHOD */
/* unused harmony export HTTP_REQUEST_METHOD_VALUE_OTHER */
/* unused harmony export HTTP_REQUEST_METHOD_VALUE_CONNECT */
/* unused harmony export HTTP_REQUEST_METHOD_VALUE_DELETE */
/* unused harmony export HTTP_REQUEST_METHOD_VALUE_GET */
/* unused harmony export HTTP_REQUEST_METHOD_VALUE_HEAD */
/* unused harmony export HTTP_REQUEST_METHOD_VALUE_OPTIONS */
/* unused harmony export HTTP_REQUEST_METHOD_VALUE_PATCH */
/* unused harmony export HTTP_REQUEST_METHOD_VALUE_POST */
/* unused harmony export HTTP_REQUEST_METHOD_VALUE_PUT */
/* unused harmony export HTTP_REQUEST_METHOD_VALUE_TRACE */
/* unused harmony export ATTR_HTTP_REQUEST_METHOD_ORIGINAL */
/* unused harmony export ATTR_HTTP_REQUEST_RESEND_COUNT */
/* unused harmony export ATTR_HTTP_RESPONSE_HEADER */
/* unused harmony export ATTR_HTTP_RESPONSE_STATUS_CODE */
/* unused harmony export ATTR_HTTP_ROUTE */
/* unused harmony export ATTR_JVM_GC_ACTION */
/* unused harmony export ATTR_JVM_GC_NAME */
/* unused harmony export ATTR_JVM_MEMORY_POOL_NAME */
/* unused harmony export ATTR_JVM_MEMORY_TYPE */
/* unused harmony export JVM_MEMORY_TYPE_VALUE_HEAP */
/* unused harmony export JVM_MEMORY_TYPE_VALUE_NON_HEAP */
/* unused harmony export ATTR_JVM_THREAD_DAEMON */
/* unused harmony export ATTR_JVM_THREAD_STATE */
/* unused harmony export JVM_THREAD_STATE_VALUE_BLOCKED */
/* unused harmony export JVM_THREAD_STATE_VALUE_NEW */
/* unused harmony export JVM_THREAD_STATE_VALUE_RUNNABLE */
/* unused harmony export JVM_THREAD_STATE_VALUE_TERMINATED */
/* unused harmony export JVM_THREAD_STATE_VALUE_TIMED_WAITING */
/* unused harmony export JVM_THREAD_STATE_VALUE_WAITING */
/* unused harmony export ATTR_NETWORK_LOCAL_ADDRESS */
/* unused harmony export ATTR_NETWORK_LOCAL_PORT */
/* unused harmony export ATTR_NETWORK_PEER_ADDRESS */
/* unused harmony export ATTR_NETWORK_PEER_PORT */
/* unused harmony export ATTR_NETWORK_PROTOCOL_NAME */
/* unused harmony export ATTR_NETWORK_PROTOCOL_VERSION */
/* unused harmony export ATTR_NETWORK_TRANSPORT */
/* unused harmony export NETWORK_TRANSPORT_VALUE_PIPE */
/* unused harmony export NETWORK_TRANSPORT_VALUE_QUIC */
/* unused harmony export NETWORK_TRANSPORT_VALUE_TCP */
/* unused harmony export NETWORK_TRANSPORT_VALUE_UDP */
/* unused harmony export NETWORK_TRANSPORT_VALUE_UNIX */
/* unused harmony export ATTR_NETWORK_TYPE */
/* unused harmony export NETWORK_TYPE_VALUE_IPV4 */
/* unused harmony export NETWORK_TYPE_VALUE_IPV6 */
/* unused harmony export ATTR_OTEL_SCOPE_NAME */
/* unused harmony export ATTR_OTEL_SCOPE_VERSION */
/* unused harmony export ATTR_OTEL_STATUS_CODE */
/* unused harmony export OTEL_STATUS_CODE_VALUE_ERROR */
/* unused harmony export OTEL_STATUS_CODE_VALUE_OK */
/* unused harmony export ATTR_OTEL_STATUS_DESCRIPTION */
/* unused harmony export ATTR_SERVER_ADDRESS */
/* unused harmony export ATTR_SERVER_PORT */
/* unused harmony export ATTR_SERVICE_NAME */
/* unused harmony export ATTR_SERVICE_VERSION */
/* unused harmony export ATTR_SIGNALR_CONNECTION_STATUS */
/* unused harmony export SIGNALR_CONNECTION_STATUS_VALUE_APP_SHUTDOWN */
/* unused harmony export SIGNALR_CONNECTION_STATUS_VALUE_NORMAL_CLOSURE */
/* unused harmony export SIGNALR_CONNECTION_STATUS_VALUE_TIMEOUT */
/* unused harmony export ATTR_SIGNALR_TRANSPORT */
/* unused harmony export SIGNALR_TRANSPORT_VALUE_LONG_POLLING */
/* unused harmony export SIGNALR_TRANSPORT_VALUE_SERVER_SENT_EVENTS */
/* unused harmony export SIGNALR_TRANSPORT_VALUE_WEB_SOCKETS */
/* unused harmony export ATTR_URL_FRAGMENT */
/* unused harmony export ATTR_URL_FULL */
/* unused harmony export ATTR_URL_PATH */
/* unused harmony export ATTR_URL_QUERY */
/* unused harmony export ATTR_URL_SCHEME */
/* unused harmony export ATTR_USER_AGENT_ORIGINAL */
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
//----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates/registry/stable/attributes.ts.j2
//----------------------------------------------------------------------------------------------------------
/**
 * Rate-limiting result, shows whether the lease was acquired or contains a rejection reason
 *
 * @example acquired
 * @example request_canceled
 */
var ATTR_ASPNETCORE_RATE_LIMITING_RESULT = 'aspnetcore.rate_limiting.result';
/**
  * Enum value "acquired" for attribute {@link ATTR_ASPNETCORE_RATE_LIMITING_RESULT}.
  */
var ASPNETCORE_RATE_LIMITING_RESULT_VALUE_ACQUIRED = "acquired";
/**
  * Enum value "endpoint_limiter" for attribute {@link ATTR_ASPNETCORE_RATE_LIMITING_RESULT}.
  */
var ASPNETCORE_RATE_LIMITING_RESULT_VALUE_ENDPOINT_LIMITER = "endpoint_limiter";
/**
  * Enum value "global_limiter" for attribute {@link ATTR_ASPNETCORE_RATE_LIMITING_RESULT}.
  */
var ASPNETCORE_RATE_LIMITING_RESULT_VALUE_GLOBAL_LIMITER = "global_limiter";
/**
  * Enum value "request_canceled" for attribute {@link ATTR_ASPNETCORE_RATE_LIMITING_RESULT}.
  */
var ASPNETCORE_RATE_LIMITING_RESULT_VALUE_REQUEST_CANCELED = "request_canceled";
/**
 * The language of the telemetry SDK.
 */
var ATTR_TELEMETRY_SDK_LANGUAGE = 'telemetry.sdk.language';
/**
  * Enum value "cpp" for attribute {@link ATTR_TELEMETRY_SDK_LANGUAGE}.
  */
var TELEMETRY_SDK_LANGUAGE_VALUE_CPP = "cpp";
/**
  * Enum value "dotnet" for attribute {@link ATTR_TELEMETRY_SDK_LANGUAGE}.
  */
var TELEMETRY_SDK_LANGUAGE_VALUE_DOTNET = "dotnet";
/**
  * Enum value "erlang" for attribute {@link ATTR_TELEMETRY_SDK_LANGUAGE}.
  */
var TELEMETRY_SDK_LANGUAGE_VALUE_ERLANG = "erlang";
/**
  * Enum value "go" for attribute {@link ATTR_TELEMETRY_SDK_LANGUAGE}.
  */
var TELEMETRY_SDK_LANGUAGE_VALUE_GO = "go";
/**
  * Enum value "java" for attribute {@link ATTR_TELEMETRY_SDK_LANGUAGE}.
  */
var TELEMETRY_SDK_LANGUAGE_VALUE_JAVA = "java";
/**
  * Enum value "nodejs" for attribute {@link ATTR_TELEMETRY_SDK_LANGUAGE}.
  */
var TELEMETRY_SDK_LANGUAGE_VALUE_NODEJS = "nodejs";
/**
  * Enum value "php" for attribute {@link ATTR_TELEMETRY_SDK_LANGUAGE}.
  */
var TELEMETRY_SDK_LANGUAGE_VALUE_PHP = "php";
/**
  * Enum value "python" for attribute {@link ATTR_TELEMETRY_SDK_LANGUAGE}.
  */
var TELEMETRY_SDK_LANGUAGE_VALUE_PYTHON = "python";
/**
  * Enum value "ruby" for attribute {@link ATTR_TELEMETRY_SDK_LANGUAGE}.
  */
var TELEMETRY_SDK_LANGUAGE_VALUE_RUBY = "ruby";
/**
  * Enum value "rust" for attribute {@link ATTR_TELEMETRY_SDK_LANGUAGE}.
  */
var TELEMETRY_SDK_LANGUAGE_VALUE_RUST = "rust";
/**
  * Enum value "swift" for attribute {@link ATTR_TELEMETRY_SDK_LANGUAGE}.
  */
var TELEMETRY_SDK_LANGUAGE_VALUE_SWIFT = "swift";
/**
  * Enum value "webjs" for attribute {@link ATTR_TELEMETRY_SDK_LANGUAGE}.
  */
var TELEMETRY_SDK_LANGUAGE_VALUE_WEBJS = "webjs";
/**
 * The name of the telemetry SDK as defined above.
 *
 * @example opentelemetry
 *
 * @note The OpenTelemetry SDK **MUST** set the `telemetry.sdk.name` attribute to `opentelemetry`.
 * If another SDK, like a fork or a vendor-provided implementation, is used, this SDK **MUST** set the
 * `telemetry.sdk.name` attribute to the fully-qualified class or module name of this SDK's main entry point
 * or another suitable identifier depending on the language.
 * The identifier `opentelemetry` is reserved and **MUST NOT** be used in this case.
 * All custom identifiers **SHOULD** be stable across different versions of an implementation.
 */
var ATTR_TELEMETRY_SDK_NAME = 'telemetry.sdk.name';
/**
 * The version string of the telemetry SDK.
 *
 * @example 1.2.3
 */
var ATTR_TELEMETRY_SDK_VERSION = 'telemetry.sdk.version';
/**
 * Full type name of the [`IExceptionHandler`](https://learn.microsoft.com/dotnet/api/microsoft.aspnetcore.diagnostics.iexceptionhandler) implementation that handled the exception.
 *
 * @example Contoso.MyHandler
 */
var ATTR_ASPNETCORE_DIAGNOSTICS_HANDLER_TYPE = 'aspnetcore.diagnostics.handler.type';
/**
 * ASP.NET Core exception middleware handling result
 *
 * @example handled
 * @example unhandled
 */
var ATTR_ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT = 'aspnetcore.diagnostics.exception.result';
/**
  * Enum value "aborted" for attribute {@link ATTR_ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT}.
  */
var ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_ABORTED = "aborted";
/**
  * Enum value "handled" for attribute {@link ATTR_ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT}.
  */
var ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_HANDLED = "handled";
/**
  * Enum value "skipped" for attribute {@link ATTR_ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT}.
  */
var ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_SKIPPED = "skipped";
/**
  * Enum value "unhandled" for attribute {@link ATTR_ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT}.
  */
var ASPNETCORE_DIAGNOSTICS_EXCEPTION_RESULT_VALUE_UNHANDLED = "unhandled";
/**
 * Rate limiting policy name.
 *
 * @example fixed
 * @example sliding
 * @example token
 */
var ATTR_ASPNETCORE_RATE_LIMITING_POLICY = 'aspnetcore.rate_limiting.policy';
/**
 * Flag indicating if request was handled by the application pipeline.
 *
 * @example true
 */
var ATTR_ASPNETCORE_REQUEST_IS_UNHANDLED = 'aspnetcore.request.is_unhandled';
/**
 * A value that indicates whether the matched route is a fallback route.
 *
 * @example true
 */
var ATTR_ASPNETCORE_ROUTING_IS_FALLBACK = 'aspnetcore.routing.is_fallback';
/**
 * Match result - success or failure
 *
 * @example success
 * @example failure
 */
var ATTR_ASPNETCORE_ROUTING_MATCH_STATUS = 'aspnetcore.routing.match_status';
/**
  * Enum value "failure" for attribute {@link ATTR_ASPNETCORE_ROUTING_MATCH_STATUS}.
  */
var ASPNETCORE_ROUTING_MATCH_STATUS_VALUE_FAILURE = "failure";
/**
  * Enum value "success" for attribute {@link ATTR_ASPNETCORE_ROUTING_MATCH_STATUS}.
  */
var ASPNETCORE_ROUTING_MATCH_STATUS_VALUE_SUCCESS = "success";
/**
 * Client address - domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.
 *
 * @example client.example.com
 * @example 10.1.2.80
 * @example /tmp/my.sock
 *
 * @note When observed from the server side, and when communicating through an intermediary, `client.address` **SHOULD** represent the client address behind any intermediaries,  for example proxies, if it's available.
 */
var ATTR_CLIENT_ADDRESS = 'client.address';
/**
 * Client port number.
 *
 * @example 65123
 *
 * @note When observed from the server side, and when communicating through an intermediary, `client.port` **SHOULD** represent the client port behind any intermediaries,  for example proxies, if it's available.
 */
var ATTR_CLIENT_PORT = 'client.port';
/**
 * Describes a class of error the operation ended with.
 *
 * @example timeout
 * @example java.net.UnknownHostException
 * @example server_certificate_invalid
 * @example 500
 *
 * @note The `error.type` **SHOULD** be predictable, and **SHOULD** have low cardinality.
 *
 * When `error.type` is set to a type (e.g., an exception type), its
 * canonical class name identifying the type within the artifact **SHOULD** be used.
 *
 * Instrumentations **SHOULD** document the list of errors they report.
 *
 * The cardinality of `error.type` within one instrumentation library **SHOULD** be low.
 * Telemetry consumers that aggregate data from multiple instrumentation libraries and applications
 * should be prepared for `error.type` to have high cardinality at query time when no
 * additional filters are applied.
 *
 * If the operation has completed successfully, instrumentations **SHOULD NOT** set `error.type`.
 *
 * If a specific domain defines its own set of error identifiers (such as HTTP or gRPC status codes),
 * it's **RECOMMENDED** to:
 *
 *   - Use a domain-specific attribute
 *   - Set `error.type` to capture all errors, regardless of whether they are defined within the domain-specific set or not.
 */
var ATTR_ERROR_TYPE = 'error.type';
/**
  * Enum value "_OTHER" for attribute {@link ATTR_ERROR_TYPE}.
  */
var ERROR_TYPE_VALUE_OTHER = "_OTHER";
/**
 * **SHOULD** be set to true if the exception event is recorded at a point where it is known that the exception is escaping the scope of the span.
 *
 * @note An exception is considered to have escaped (or left) the scope of a span,
 * if that span is ended while the exception is still logically "in flight".
 * This may be actually "in flight" in some languages (e.g. if the exception
 * is passed to a Context manager's `__exit__` method in Python) but will
 * usually be caught at the point of recording the exception in most languages.
 *
 * It is usually not possible to determine at the point where an exception is thrown
 * whether it will escape the scope of a span.
 * However, it is trivial to know that an exception
 * will escape, if one checks for an active exception just before ending the span,
 * as done in the [example for recording span exceptions](https://opentelemetry.io/docs/specs/semconv/exceptions/exceptions-spans/#recording-an-exception).
 *
 * It follows that an exception may still escape the scope of the span
 * even if the `exception.escaped` attribute was not set or set to false,
 * since the event might have been recorded at a time where it was not
 * clear whether the exception will escape.
 */
var ATTR_EXCEPTION_ESCAPED = 'exception.escaped';
/**
 * The exception message.
 *
 * @example Division by zero
 * @example Can't convert 'int' object to str implicitly
 */
var ATTR_EXCEPTION_MESSAGE = 'exception.message';
/**
 * A stacktrace as a string in the natural representation for the language runtime. The representation is to be determined and documented by each language SIG.
 *
 * @example "Exception in thread "main" java.lang.RuntimeException: Test exception\\n at com.example.GenerateTrace.methodB(GenerateTrace.java:13)\\n at com.example.GenerateTrace.methodA(GenerateTrace.java:9)\\n at com.example.GenerateTrace.main(GenerateTrace.java:5)\\n"
 */
var ATTR_EXCEPTION_STACKTRACE = 'exception.stacktrace';
/**
 * The type of the exception (its fully-qualified class name, if applicable). The dynamic type of the exception should be preferred over the static type in languages that support it.
 *
 * @example java.net.ConnectException
 * @example OSError
 */
var ATTR_EXCEPTION_TYPE = 'exception.type';
/**
 * HTTP request headers, `<key>` being the normalized HTTP Header name (lowercase), the value being the header values.
 *
 * @example http.request.header.content-type=["application/json"]
 * @example http.request.header.x-forwarded-for=["1.2.3.4", "1.2.3.5"]
 *
 * @note Instrumentations **SHOULD** require an explicit configuration of which headers are to be captured. Including all request headers can be a security risk - explicit configuration helps avoid leaking sensitive information.
 * The `User-Agent` header is already captured in the `user_agent.original` attribute. Users **MAY** explicitly configure instrumentations to capture them even though it is not recommended.
 * The attribute value **MUST** consist of either multiple header values as an array of strings or a single-item array containing a possibly comma-concatenated string, depending on the way the HTTP library provides access to headers.
 */
var ATTR_HTTP_REQUEST_HEADER = function (key) { return "http.request.header." + key; };
/**
 * HTTP request method.
 *
 * @example GET
 * @example POST
 * @example HEAD
 *
 * @note HTTP request method value **SHOULD** be "known" to the instrumentation.
 * By default, this convention defines "known" methods as the ones listed in [RFC9110](https://www.rfc-editor.org/rfc/rfc9110.html#name-methods)
 * and the PATCH method defined in [RFC5789](https://www.rfc-editor.org/rfc/rfc5789.html).
 *
 * If the HTTP request method is not known to instrumentation, it **MUST** set the `http.request.method` attribute to `_OTHER`.
 *
 * If the HTTP instrumentation could end up converting valid HTTP request methods to `_OTHER`, then it **MUST** provide a way to override
 * the list of known HTTP methods. If this override is done via environment variable, then the environment variable **MUST** be named
 * OTEL_INSTRUMENTATION_HTTP_KNOWN_METHODS and support a comma-separated list of case-sensitive known HTTP methods
 * (this list **MUST** be a full override of the default known method, it is not a list of known methods in addition to the defaults).
 *
 * HTTP method names are case-sensitive and `http.request.method` attribute value **MUST** match a known HTTP method name exactly.
 * Instrumentations for specific web frameworks that consider HTTP methods to be case insensitive, **SHOULD** populate a canonical equivalent.
 * Tracing instrumentations that do so, **MUST** also set `http.request.method_original` to the original value.
 */
var ATTR_HTTP_REQUEST_METHOD = 'http.request.method';
/**
  * Enum value "_OTHER" for attribute {@link ATTR_HTTP_REQUEST_METHOD}.
  */
var HTTP_REQUEST_METHOD_VALUE_OTHER = "_OTHER";
/**
  * Enum value "CONNECT" for attribute {@link ATTR_HTTP_REQUEST_METHOD}.
  */
var HTTP_REQUEST_METHOD_VALUE_CONNECT = "CONNECT";
/**
  * Enum value "DELETE" for attribute {@link ATTR_HTTP_REQUEST_METHOD}.
  */
var HTTP_REQUEST_METHOD_VALUE_DELETE = "DELETE";
/**
  * Enum value "GET" for attribute {@link ATTR_HTTP_REQUEST_METHOD}.
  */
var HTTP_REQUEST_METHOD_VALUE_GET = "GET";
/**
  * Enum value "HEAD" for attribute {@link ATTR_HTTP_REQUEST_METHOD}.
  */
var HTTP_REQUEST_METHOD_VALUE_HEAD = "HEAD";
/**
  * Enum value "OPTIONS" for attribute {@link ATTR_HTTP_REQUEST_METHOD}.
  */
var HTTP_REQUEST_METHOD_VALUE_OPTIONS = "OPTIONS";
/**
  * Enum value "PATCH" for attribute {@link ATTR_HTTP_REQUEST_METHOD}.
  */
var HTTP_REQUEST_METHOD_VALUE_PATCH = "PATCH";
/**
  * Enum value "POST" for attribute {@link ATTR_HTTP_REQUEST_METHOD}.
  */
var HTTP_REQUEST_METHOD_VALUE_POST = "POST";
/**
  * Enum value "PUT" for attribute {@link ATTR_HTTP_REQUEST_METHOD}.
  */
var HTTP_REQUEST_METHOD_VALUE_PUT = "PUT";
/**
  * Enum value "TRACE" for attribute {@link ATTR_HTTP_REQUEST_METHOD}.
  */
var HTTP_REQUEST_METHOD_VALUE_TRACE = "TRACE";
/**
 * Original HTTP method sent by the client in the request line.
 *
 * @example GeT
 * @example ACL
 * @example foo
 */
var ATTR_HTTP_REQUEST_METHOD_ORIGINAL = 'http.request.method_original';
/**
 * The ordinal number of request resending attempt (for any reason, including redirects).
 *
 * @example 3
 *
 * @note The resend count **SHOULD** be updated each time an HTTP request gets resent by the client, regardless of what was the cause of the resending (e.g. redirection, authorization failure, 503 Server Unavailable, network issues, or any other).
 */
var ATTR_HTTP_REQUEST_RESEND_COUNT = 'http.request.resend_count';
/**
 * HTTP response headers, `<key>` being the normalized HTTP Header name (lowercase), the value being the header values.
 *
 * @example http.response.header.content-type=["application/json"]
 * @example http.response.header.my-custom-header=["abc", "def"]
 *
 * @note Instrumentations **SHOULD** require an explicit configuration of which headers are to be captured. Including all response headers can be a security risk - explicit configuration helps avoid leaking sensitive information.
 * Users **MAY** explicitly configure instrumentations to capture them even though it is not recommended.
 * The attribute value **MUST** consist of either multiple header values as an array of strings or a single-item array containing a possibly comma-concatenated string, depending on the way the HTTP library provides access to headers.
 */
var ATTR_HTTP_RESPONSE_HEADER = function (key) { return "http.response.header." + key; };
/**
 * [HTTP response status code](https://tools.ietf.org/html/rfc7231#section-6).
 *
 * @example 200
 */
var ATTR_HTTP_RESPONSE_STATUS_CODE = 'http.response.status_code';
/**
 * The matched route, that is, the path template in the format used by the respective server framework.
 *
 * @example /users/:userID?
 * @example {controller}/{action}/{id?}
 *
 * @note **MUST NOT** be populated when this is not supported by the HTTP server framework as the route attribute should have low-cardinality and the URI path can NOT substitute it.
 * **SHOULD** include the [application root](/docs/http/http-spans.md#http-server-definitions) if there is one.
 */
var ATTR_HTTP_ROUTE = 'http.route';
/**
 * Name of the garbage collector action.
 *
 * @example end of minor GC
 * @example end of major GC
 *
 * @note Garbage collector action is generally obtained via [GarbageCollectionNotificationInfo#getGcAction()](https://docs.oracle.com/en/java/javase/11/docs/api/jdk.management/com/sun/management/GarbageCollectionNotificationInfo.html#getGcAction()).
 */
var ATTR_JVM_GC_ACTION = 'jvm.gc.action';
/**
 * Name of the garbage collector.
 *
 * @example G1 Young Generation
 * @example G1 Old Generation
 *
 * @note Garbage collector name is generally obtained via [GarbageCollectionNotificationInfo#getGcName()](https://docs.oracle.com/en/java/javase/11/docs/api/jdk.management/com/sun/management/GarbageCollectionNotificationInfo.html#getGcName()).
 */
var ATTR_JVM_GC_NAME = 'jvm.gc.name';
/**
 * Name of the memory pool.
 *
 * @example G1 Old Gen
 * @example G1 Eden space
 * @example G1 Survivor Space
 *
 * @note Pool names are generally obtained via [MemoryPoolMXBean#getName()](https://docs.oracle.com/en/java/javase/11/docs/api/java.management/java/lang/management/MemoryPoolMXBean.html#getName()).
 */
var ATTR_JVM_MEMORY_POOL_NAME = 'jvm.memory.pool.name';
/**
 * The type of memory.
 *
 * @example heap
 * @example non_heap
 */
var ATTR_JVM_MEMORY_TYPE = 'jvm.memory.type';
/**
  * Enum value "heap" for attribute {@link ATTR_JVM_MEMORY_TYPE}.
  */
var JVM_MEMORY_TYPE_VALUE_HEAP = "heap";
/**
  * Enum value "non_heap" for attribute {@link ATTR_JVM_MEMORY_TYPE}.
  */
var JVM_MEMORY_TYPE_VALUE_NON_HEAP = "non_heap";
/**
 * Whether the thread is daemon or not.
 */
var ATTR_JVM_THREAD_DAEMON = 'jvm.thread.daemon';
/**
 * State of the thread.
 *
 * @example runnable
 * @example blocked
 */
var ATTR_JVM_THREAD_STATE = 'jvm.thread.state';
/**
  * Enum value "blocked" for attribute {@link ATTR_JVM_THREAD_STATE}.
  */
var JVM_THREAD_STATE_VALUE_BLOCKED = "blocked";
/**
  * Enum value "new" for attribute {@link ATTR_JVM_THREAD_STATE}.
  */
var JVM_THREAD_STATE_VALUE_NEW = "new";
/**
  * Enum value "runnable" for attribute {@link ATTR_JVM_THREAD_STATE}.
  */
var JVM_THREAD_STATE_VALUE_RUNNABLE = "runnable";
/**
  * Enum value "terminated" for attribute {@link ATTR_JVM_THREAD_STATE}.
  */
var JVM_THREAD_STATE_VALUE_TERMINATED = "terminated";
/**
  * Enum value "timed_waiting" for attribute {@link ATTR_JVM_THREAD_STATE}.
  */
var JVM_THREAD_STATE_VALUE_TIMED_WAITING = "timed_waiting";
/**
  * Enum value "waiting" for attribute {@link ATTR_JVM_THREAD_STATE}.
  */
var JVM_THREAD_STATE_VALUE_WAITING = "waiting";
/**
 * Local address of the network connection - IP address or Unix domain socket name.
 *
 * @example 10.1.2.80
 * @example /tmp/my.sock
 */
var ATTR_NETWORK_LOCAL_ADDRESS = 'network.local.address';
/**
 * Local port number of the network connection.
 *
 * @example 65123
 */
var ATTR_NETWORK_LOCAL_PORT = 'network.local.port';
/**
 * Peer address of the network connection - IP address or Unix domain socket name.
 *
 * @example 10.1.2.80
 * @example /tmp/my.sock
 */
var ATTR_NETWORK_PEER_ADDRESS = 'network.peer.address';
/**
 * Peer port number of the network connection.
 *
 * @example 65123
 */
var ATTR_NETWORK_PEER_PORT = 'network.peer.port';
/**
 * [OSI application layer](https://osi-model.com/application-layer/) or non-OSI equivalent.
 *
 * @example amqp
 * @example http
 * @example mqtt
 *
 * @note The value **SHOULD** be normalized to lowercase.
 */
var ATTR_NETWORK_PROTOCOL_NAME = 'network.protocol.name';
/**
 * The actual version of the protocol used for network communication.
 *
 * @example 1.1
 * @example 2
 *
 * @note If protocol version is subject to negotiation (for example using [ALPN](https://www.rfc-editor.org/rfc/rfc7301.html)), this attribute **SHOULD** be set to the negotiated version. If the actual protocol version is not known, this attribute **SHOULD NOT** be set.
 */
var ATTR_NETWORK_PROTOCOL_VERSION = 'network.protocol.version';
/**
 * [OSI transport layer](https://osi-model.com/transport-layer/) or [inter-process communication method](https://wikipedia.org/wiki/Inter-process_communication).
 *
 * @example tcp
 * @example udp
 *
 * @note The value **SHOULD** be normalized to lowercase.
 *
 * Consider always setting the transport when setting a port number, since
 * a port number is ambiguous without knowing the transport. For example
 * different processes could be listening on TCP port 12345 and UDP port 12345.
 */
var ATTR_NETWORK_TRANSPORT = 'network.transport';
/**
  * Enum value "pipe" for attribute {@link ATTR_NETWORK_TRANSPORT}.
  */
var NETWORK_TRANSPORT_VALUE_PIPE = "pipe";
/**
  * Enum value "quic" for attribute {@link ATTR_NETWORK_TRANSPORT}.
  */
var NETWORK_TRANSPORT_VALUE_QUIC = "quic";
/**
  * Enum value "tcp" for attribute {@link ATTR_NETWORK_TRANSPORT}.
  */
var NETWORK_TRANSPORT_VALUE_TCP = "tcp";
/**
  * Enum value "udp" for attribute {@link ATTR_NETWORK_TRANSPORT}.
  */
var NETWORK_TRANSPORT_VALUE_UDP = "udp";
/**
  * Enum value "unix" for attribute {@link ATTR_NETWORK_TRANSPORT}.
  */
var NETWORK_TRANSPORT_VALUE_UNIX = "unix";
/**
 * [OSI network layer](https://osi-model.com/network-layer/) or non-OSI equivalent.
 *
 * @example ipv4
 * @example ipv6
 *
 * @note The value **SHOULD** be normalized to lowercase.
 */
var ATTR_NETWORK_TYPE = 'network.type';
/**
  * Enum value "ipv4" for attribute {@link ATTR_NETWORK_TYPE}.
  */
var NETWORK_TYPE_VALUE_IPV4 = "ipv4";
/**
  * Enum value "ipv6" for attribute {@link ATTR_NETWORK_TYPE}.
  */
var NETWORK_TYPE_VALUE_IPV6 = "ipv6";
/**
 * The name of the instrumentation scope - (`InstrumentationScope.Name` in OTLP).
 *
 * @example io.opentelemetry.contrib.mongodb
 */
var ATTR_OTEL_SCOPE_NAME = 'otel.scope.name';
/**
 * The version of the instrumentation scope - (`InstrumentationScope.Version` in OTLP).
 *
 * @example 1.0.0
 */
var ATTR_OTEL_SCOPE_VERSION = 'otel.scope.version';
/**
 * Name of the code, either "OK" or "ERROR". **MUST NOT** be set if the status code is UNSET.
 */
var ATTR_OTEL_STATUS_CODE = 'otel.status_code';
/**
  * Enum value "ERROR" for attribute {@link ATTR_OTEL_STATUS_CODE}.
  */
var OTEL_STATUS_CODE_VALUE_ERROR = "ERROR";
/**
  * Enum value "OK" for attribute {@link ATTR_OTEL_STATUS_CODE}.
  */
var OTEL_STATUS_CODE_VALUE_OK = "OK";
/**
 * Description of the Status if it has a value, otherwise not set.
 *
 * @example resource not found
 */
var ATTR_OTEL_STATUS_DESCRIPTION = 'otel.status_description';
/**
 * Server domain name if available without reverse DNS lookup; otherwise, IP address or Unix domain socket name.
 *
 * @example example.com
 * @example 10.1.2.80
 * @example /tmp/my.sock
 *
 * @note When observed from the client side, and when communicating through an intermediary, `server.address` **SHOULD** represent the server address behind any intermediaries, for example proxies, if it's available.
 */
var ATTR_SERVER_ADDRESS = 'server.address';
/**
 * Server port number.
 *
 * @example 80
 * @example 8080
 * @example 443
 *
 * @note When observed from the client side, and when communicating through an intermediary, `server.port` **SHOULD** represent the server port behind any intermediaries, for example proxies, if it's available.
 */
var ATTR_SERVER_PORT = 'server.port';
/**
 * Logical name of the service.
 *
 * @example shoppingcart
 *
 * @note **MUST** be the same for all instances of horizontally scaled services. If the value was not specified, SDKs **MUST** fallback to `unknown_service:` concatenated with [`process.executable.name`](process.md), e.g. `unknown_service:bash`. If `process.executable.name` is not available, the value **MUST** be set to `unknown_service`.
 */
var ATTR_SERVICE_NAME = 'service.name';
/**
 * The version string of the service API or implementation. The format is not defined by these conventions.
 *
 * @example 2.0.0
 * @example a01dbef8a
 */
var ATTR_SERVICE_VERSION = 'service.version';
/**
 * SignalR HTTP connection closure status.
 *
 * @example app_shutdown
 * @example timeout
 */
var ATTR_SIGNALR_CONNECTION_STATUS = 'signalr.connection.status';
/**
  * Enum value "app_shutdown" for attribute {@link ATTR_SIGNALR_CONNECTION_STATUS}.
  */
var SIGNALR_CONNECTION_STATUS_VALUE_APP_SHUTDOWN = "app_shutdown";
/**
  * Enum value "normal_closure" for attribute {@link ATTR_SIGNALR_CONNECTION_STATUS}.
  */
var SIGNALR_CONNECTION_STATUS_VALUE_NORMAL_CLOSURE = "normal_closure";
/**
  * Enum value "timeout" for attribute {@link ATTR_SIGNALR_CONNECTION_STATUS}.
  */
var SIGNALR_CONNECTION_STATUS_VALUE_TIMEOUT = "timeout";
/**
 * [SignalR transport type](https://github.com/dotnet/aspnetcore/blob/main/src/SignalR/docs/specs/TransportProtocols.md)
 *
 * @example web_sockets
 * @example long_polling
 */
var ATTR_SIGNALR_TRANSPORT = 'signalr.transport';
/**
  * Enum value "long_polling" for attribute {@link ATTR_SIGNALR_TRANSPORT}.
  */
var SIGNALR_TRANSPORT_VALUE_LONG_POLLING = "long_polling";
/**
  * Enum value "server_sent_events" for attribute {@link ATTR_SIGNALR_TRANSPORT}.
  */
var SIGNALR_TRANSPORT_VALUE_SERVER_SENT_EVENTS = "server_sent_events";
/**
  * Enum value "web_sockets" for attribute {@link ATTR_SIGNALR_TRANSPORT}.
  */
var SIGNALR_TRANSPORT_VALUE_WEB_SOCKETS = "web_sockets";
/**
 * The [URI fragment](https://www.rfc-editor.org/rfc/rfc3986#section-3.5) component
 *
 * @example SemConv
 */
var ATTR_URL_FRAGMENT = 'url.fragment';
/**
 * Absolute URL describing a network resource according to [RFC3986](https://www.rfc-editor.org/rfc/rfc3986)
 *
 * @example https://www.foo.bar/search?q=OpenTelemetry#SemConv
 * @example //localhost
 *
 * @note For network calls, URL usually has `scheme://host[:port][path][?query][#fragment]` format, where the fragment is not transmitted over HTTP, but if it is known, it **SHOULD** be included nevertheless.
 * `url.full` **MUST NOT** contain credentials passed via URL in form of `https://username:password@www.example.com/`. In such case username and password **SHOULD** be redacted and attribute's value **SHOULD** be `https://REDACTED:REDACTED@www.example.com/`.
 * `url.full` **SHOULD** capture the absolute URL when it is available (or can be reconstructed). Sensitive content provided in `url.full` **SHOULD** be scrubbed when instrumentations can identify it.
 */
var ATTR_URL_FULL = 'url.full';
/**
 * The [URI path](https://www.rfc-editor.org/rfc/rfc3986#section-3.3) component
 *
 * @example /search
 *
 * @note Sensitive content provided in `url.path` **SHOULD** be scrubbed when instrumentations can identify it.
 */
var ATTR_URL_PATH = 'url.path';
/**
 * The [URI query](https://www.rfc-editor.org/rfc/rfc3986#section-3.4) component
 *
 * @example q=OpenTelemetry
 *
 * @note Sensitive content provided in `url.query` **SHOULD** be scrubbed when instrumentations can identify it.
 */
var ATTR_URL_QUERY = 'url.query';
/**
 * The [URI scheme](https://www.rfc-editor.org/rfc/rfc3986#section-3.1) component identifying the used protocol.
 *
 * @example https
 * @example ftp
 * @example telnet
 */
var ATTR_URL_SCHEME = 'url.scheme';
/**
 * Value of the [HTTP User-Agent](https://www.rfc-editor.org/rfc/rfc9110.html#field.user-agent) header sent by the client.
 *
 * @example CERN-LineMode/2.15 libwww/2.17b3
 * @example Mozilla/5.0 (iPhone; CPU iPhone OS 14_7_1 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.1.2 Mobile/15E148 Safari/604.1
 * @example YourApp/1.0.0 grpc-java-okhttp/1.27.2
 */
var ATTR_USER_AGENT_ORIGINAL = 'user_agent.original';
//# sourceMappingURL=stable_attributes.js.map

/***/ }),
/* 2022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export METRIC_ASPNETCORE_DIAGNOSTICS_EXCEPTIONS */
/* unused harmony export METRIC_ASPNETCORE_RATE_LIMITING_ACTIVE_REQUEST_LEASES */
/* unused harmony export METRIC_ASPNETCORE_RATE_LIMITING_QUEUED_REQUESTS */
/* unused harmony export METRIC_ASPNETCORE_RATE_LIMITING_REQUEST_TIME_IN_QUEUE */
/* unused harmony export METRIC_ASPNETCORE_RATE_LIMITING_REQUEST_LEASE_DURATION */
/* unused harmony export METRIC_ASPNETCORE_RATE_LIMITING_REQUESTS */
/* unused harmony export METRIC_ASPNETCORE_ROUTING_MATCH_ATTEMPTS */
/* unused harmony export METRIC_HTTP_CLIENT_REQUEST_DURATION */
/* unused harmony export METRIC_HTTP_SERVER_REQUEST_DURATION */
/* unused harmony export METRIC_JVM_CLASS_COUNT */
/* unused harmony export METRIC_JVM_CLASS_LOADED */
/* unused harmony export METRIC_JVM_CLASS_UNLOADED */
/* unused harmony export METRIC_JVM_CPU_COUNT */
/* unused harmony export METRIC_JVM_CPU_RECENT_UTILIZATION */
/* unused harmony export METRIC_JVM_CPU_TIME */
/* unused harmony export METRIC_JVM_GC_DURATION */
/* unused harmony export METRIC_JVM_MEMORY_COMMITTED */
/* unused harmony export METRIC_JVM_MEMORY_LIMIT */
/* unused harmony export METRIC_JVM_MEMORY_USED */
/* unused harmony export METRIC_JVM_MEMORY_USED_AFTER_LAST_GC */
/* unused harmony export METRIC_JVM_THREAD_COUNT */
/* unused harmony export METRIC_KESTREL_ACTIVE_CONNECTIONS */
/* unused harmony export METRIC_KESTREL_ACTIVE_TLS_HANDSHAKES */
/* unused harmony export METRIC_KESTREL_CONNECTION_DURATION */
/* unused harmony export METRIC_KESTREL_QUEUED_CONNECTIONS */
/* unused harmony export METRIC_KESTREL_QUEUED_REQUESTS */
/* unused harmony export METRIC_KESTREL_REJECTED_CONNECTIONS */
/* unused harmony export METRIC_KESTREL_TLS_HANDSHAKE_DURATION */
/* unused harmony export METRIC_KESTREL_UPGRADED_CONNECTIONS */
/* unused harmony export METRIC_SIGNALR_SERVER_ACTIVE_CONNECTIONS */
/* unused harmony export METRIC_SIGNALR_SERVER_CONNECTION_DURATION */
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
//----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates/register/stable/metrics.ts.j2
//----------------------------------------------------------------------------------------------------------
/**
 * Number of exceptions caught by exception handling middleware.
 *
 * @note Meter name: `Microsoft.AspNetCore.Diagnostics`; Added in: ASP.NET Core 8.0
 */
var METRIC_ASPNETCORE_DIAGNOSTICS_EXCEPTIONS = 'aspnetcore.diagnostics.exceptions';
/**
 * Number of requests that are currently active on the server that hold a rate limiting lease.
 *
 * @note Meter name: `Microsoft.AspNetCore.RateLimiting`; Added in: ASP.NET Core 8.0
 */
var METRIC_ASPNETCORE_RATE_LIMITING_ACTIVE_REQUEST_LEASES = 'aspnetcore.rate_limiting.active_request_leases';
/**
 * Number of requests that are currently queued, waiting to acquire a rate limiting lease.
 *
 * @note Meter name: `Microsoft.AspNetCore.RateLimiting`; Added in: ASP.NET Core 8.0
 */
var METRIC_ASPNETCORE_RATE_LIMITING_QUEUED_REQUESTS = 'aspnetcore.rate_limiting.queued_requests';
/**
 * The time the request spent in a queue waiting to acquire a rate limiting lease.
 *
 * @note Meter name: `Microsoft.AspNetCore.RateLimiting`; Added in: ASP.NET Core 8.0
 */
var METRIC_ASPNETCORE_RATE_LIMITING_REQUEST_TIME_IN_QUEUE = 'aspnetcore.rate_limiting.request.time_in_queue';
/**
 * The duration of rate limiting lease held by requests on the server.
 *
 * @note Meter name: `Microsoft.AspNetCore.RateLimiting`; Added in: ASP.NET Core 8.0
 */
var METRIC_ASPNETCORE_RATE_LIMITING_REQUEST_LEASE_DURATION = 'aspnetcore.rate_limiting.request_lease.duration';
/**
 * Number of requests that tried to acquire a rate limiting lease.
 *
 * @note Requests could be:
 *
 *   - Rejected by global or endpoint rate limiting policies
 *   - Canceled while waiting for the lease.
 *
 * Meter name: `Microsoft.AspNetCore.RateLimiting`; Added in: ASP.NET Core 8.0
 */
var METRIC_ASPNETCORE_RATE_LIMITING_REQUESTS = 'aspnetcore.rate_limiting.requests';
/**
 * Number of requests that were attempted to be matched to an endpoint.
 *
 * @note Meter name: `Microsoft.AspNetCore.Routing`; Added in: ASP.NET Core 8.0
 */
var METRIC_ASPNETCORE_ROUTING_MATCH_ATTEMPTS = 'aspnetcore.routing.match_attempts';
/**
 * Duration of HTTP client requests.
 */
var METRIC_HTTP_CLIENT_REQUEST_DURATION = 'http.client.request.duration';
/**
 * Duration of HTTP server requests.
 */
var METRIC_HTTP_SERVER_REQUEST_DURATION = 'http.server.request.duration';
/**
 * Number of classes currently loaded.
 */
var METRIC_JVM_CLASS_COUNT = 'jvm.class.count';
/**
 * Number of classes loaded since JVM start.
 */
var METRIC_JVM_CLASS_LOADED = 'jvm.class.loaded';
/**
 * Number of classes unloaded since JVM start.
 */
var METRIC_JVM_CLASS_UNLOADED = 'jvm.class.unloaded';
/**
 * Number of processors available to the Java virtual machine.
 */
var METRIC_JVM_CPU_COUNT = 'jvm.cpu.count';
/**
 * Recent CPU utilization for the process as reported by the JVM.
 *
 * @note The value range is [0.0,1.0]. This utilization is not defined as being for the specific interval since last measurement (unlike `system.cpu.utilization`). [Reference](https://docs.oracle.com/en/java/javase/17/docs/api/jdk.management/com/sun/management/OperatingSystemMXBean.html#getProcessCpuLoad()).
 */
var METRIC_JVM_CPU_RECENT_UTILIZATION = 'jvm.cpu.recent_utilization';
/**
 * CPU time used by the process as reported by the JVM.
 */
var METRIC_JVM_CPU_TIME = 'jvm.cpu.time';
/**
 * Duration of JVM garbage collection actions.
 */
var METRIC_JVM_GC_DURATION = 'jvm.gc.duration';
/**
 * Measure of memory committed.
 */
var METRIC_JVM_MEMORY_COMMITTED = 'jvm.memory.committed';
/**
 * Measure of max obtainable memory.
 */
var METRIC_JVM_MEMORY_LIMIT = 'jvm.memory.limit';
/**
 * Measure of memory used.
 */
var METRIC_JVM_MEMORY_USED = 'jvm.memory.used';
/**
 * Measure of memory used, as measured after the most recent garbage collection event on this pool.
 */
var METRIC_JVM_MEMORY_USED_AFTER_LAST_GC = 'jvm.memory.used_after_last_gc';
/**
 * Number of executing platform threads.
 */
var METRIC_JVM_THREAD_COUNT = 'jvm.thread.count';
/**
 * Number of connections that are currently active on the server.
 *
 * @note Meter name: `Microsoft.AspNetCore.Server.Kestrel`; Added in: ASP.NET Core 8.0
 */
var METRIC_KESTREL_ACTIVE_CONNECTIONS = 'kestrel.active_connections';
/**
 * Number of TLS handshakes that are currently in progress on the server.
 *
 * @note Meter name: `Microsoft.AspNetCore.Server.Kestrel`; Added in: ASP.NET Core 8.0
 */
var METRIC_KESTREL_ACTIVE_TLS_HANDSHAKES = 'kestrel.active_tls_handshakes';
/**
 * The duration of connections on the server.
 *
 * @note Meter name: `Microsoft.AspNetCore.Server.Kestrel`; Added in: ASP.NET Core 8.0
 */
var METRIC_KESTREL_CONNECTION_DURATION = 'kestrel.connection.duration';
/**
 * Number of connections that are currently queued and are waiting to start.
 *
 * @note Meter name: `Microsoft.AspNetCore.Server.Kestrel`; Added in: ASP.NET Core 8.0
 */
var METRIC_KESTREL_QUEUED_CONNECTIONS = 'kestrel.queued_connections';
/**
 * Number of HTTP requests on multiplexed connections (HTTP/2 and HTTP/3) that are currently queued and are waiting to start.
 *
 * @note Meter name: `Microsoft.AspNetCore.Server.Kestrel`; Added in: ASP.NET Core 8.0
 */
var METRIC_KESTREL_QUEUED_REQUESTS = 'kestrel.queued_requests';
/**
 * Number of connections rejected by the server.
 *
 * @note Connections are rejected when the currently active count exceeds the value configured with `MaxConcurrentConnections`.
 * Meter name: `Microsoft.AspNetCore.Server.Kestrel`; Added in: ASP.NET Core 8.0
 */
var METRIC_KESTREL_REJECTED_CONNECTIONS = 'kestrel.rejected_connections';
/**
 * The duration of TLS handshakes on the server.
 *
 * @note Meter name: `Microsoft.AspNetCore.Server.Kestrel`; Added in: ASP.NET Core 8.0
 */
var METRIC_KESTREL_TLS_HANDSHAKE_DURATION = 'kestrel.tls_handshake.duration';
/**
 * Number of connections that are currently upgraded (WebSockets). .
 *
 * @note The counter only tracks HTTP/1.1 connections.
 *
 * Meter name: `Microsoft.AspNetCore.Server.Kestrel`; Added in: ASP.NET Core 8.0
 */
var METRIC_KESTREL_UPGRADED_CONNECTIONS = 'kestrel.upgraded_connections';
/**
 * Number of connections that are currently active on the server.
 *
 * @note Meter name: `Microsoft.AspNetCore.Http.Connections`; Added in: ASP.NET Core 8.0
 */
var METRIC_SIGNALR_SERVER_ACTIVE_CONNECTIONS = 'signalr.server.active_connections';
/**
 * The duration of connections on the server.
 *
 * @note Meter name: `Microsoft.AspNetCore.Http.Connections`; Added in: ASP.NET Core 8.0
 */
var METRIC_SIGNALR_SERVER_CONNECTION_DURATION = 'signalr.server.connection.duration';
//# sourceMappingURL=stable_metrics.js.map

/***/ }),
/* 2023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SEMATTRS_AWS_LAMBDA_INVOKED_ARN */
/* unused harmony export SEMATTRS_DB_SYSTEM */
/* unused harmony export SEMATTRS_DB_CONNECTION_STRING */
/* unused harmony export SEMATTRS_DB_USER */
/* unused harmony export SEMATTRS_DB_JDBC_DRIVER_CLASSNAME */
/* unused harmony export SEMATTRS_DB_NAME */
/* unused harmony export SEMATTRS_DB_STATEMENT */
/* unused harmony export SEMATTRS_DB_OPERATION */
/* unused harmony export SEMATTRS_DB_MSSQL_INSTANCE_NAME */
/* unused harmony export SEMATTRS_DB_CASSANDRA_KEYSPACE */
/* unused harmony export SEMATTRS_DB_CASSANDRA_PAGE_SIZE */
/* unused harmony export SEMATTRS_DB_CASSANDRA_CONSISTENCY_LEVEL */
/* unused harmony export SEMATTRS_DB_CASSANDRA_TABLE */
/* unused harmony export SEMATTRS_DB_CASSANDRA_IDEMPOTENCE */
/* unused harmony export SEMATTRS_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT */
/* unused harmony export SEMATTRS_DB_CASSANDRA_COORDINATOR_ID */
/* unused harmony export SEMATTRS_DB_CASSANDRA_COORDINATOR_DC */
/* unused harmony export SEMATTRS_DB_HBASE_NAMESPACE */
/* unused harmony export SEMATTRS_DB_REDIS_DATABASE_INDEX */
/* unused harmony export SEMATTRS_DB_MONGODB_COLLECTION */
/* unused harmony export SEMATTRS_DB_SQL_TABLE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SEMATTRS_EXCEPTION_TYPE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SEMATTRS_EXCEPTION_MESSAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SEMATTRS_EXCEPTION_STACKTRACE; });
/* unused harmony export SEMATTRS_EXCEPTION_ESCAPED */
/* unused harmony export SEMATTRS_FAAS_TRIGGER */
/* unused harmony export SEMATTRS_FAAS_EXECUTION */
/* unused harmony export SEMATTRS_FAAS_DOCUMENT_COLLECTION */
/* unused harmony export SEMATTRS_FAAS_DOCUMENT_OPERATION */
/* unused harmony export SEMATTRS_FAAS_DOCUMENT_TIME */
/* unused harmony export SEMATTRS_FAAS_DOCUMENT_NAME */
/* unused harmony export SEMATTRS_FAAS_TIME */
/* unused harmony export SEMATTRS_FAAS_CRON */
/* unused harmony export SEMATTRS_FAAS_COLDSTART */
/* unused harmony export SEMATTRS_FAAS_INVOKED_NAME */
/* unused harmony export SEMATTRS_FAAS_INVOKED_PROVIDER */
/* unused harmony export SEMATTRS_FAAS_INVOKED_REGION */
/* unused harmony export SEMATTRS_NET_TRANSPORT */
/* unused harmony export SEMATTRS_NET_PEER_IP */
/* unused harmony export SEMATTRS_NET_PEER_PORT */
/* unused harmony export SEMATTRS_NET_PEER_NAME */
/* unused harmony export SEMATTRS_NET_HOST_IP */
/* unused harmony export SEMATTRS_NET_HOST_PORT */
/* unused harmony export SEMATTRS_NET_HOST_NAME */
/* unused harmony export SEMATTRS_NET_HOST_CONNECTION_TYPE */
/* unused harmony export SEMATTRS_NET_HOST_CONNECTION_SUBTYPE */
/* unused harmony export SEMATTRS_NET_HOST_CARRIER_NAME */
/* unused harmony export SEMATTRS_NET_HOST_CARRIER_MCC */
/* unused harmony export SEMATTRS_NET_HOST_CARRIER_MNC */
/* unused harmony export SEMATTRS_NET_HOST_CARRIER_ICC */
/* unused harmony export SEMATTRS_PEER_SERVICE */
/* unused harmony export SEMATTRS_ENDUSER_ID */
/* unused harmony export SEMATTRS_ENDUSER_ROLE */
/* unused harmony export SEMATTRS_ENDUSER_SCOPE */
/* unused harmony export SEMATTRS_THREAD_ID */
/* unused harmony export SEMATTRS_THREAD_NAME */
/* unused harmony export SEMATTRS_CODE_FUNCTION */
/* unused harmony export SEMATTRS_CODE_NAMESPACE */
/* unused harmony export SEMATTRS_CODE_FILEPATH */
/* unused harmony export SEMATTRS_CODE_LINENO */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SEMATTRS_HTTP_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SEMATTRS_HTTP_URL; });
/* unused harmony export SEMATTRS_HTTP_TARGET */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SEMATTRS_HTTP_HOST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SEMATTRS_HTTP_SCHEME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SEMATTRS_HTTP_STATUS_CODE; });
/* unused harmony export SEMATTRS_HTTP_FLAVOR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SEMATTRS_HTTP_USER_AGENT; });
/* unused harmony export SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED; });
/* unused harmony export SEMATTRS_HTTP_SERVER_NAME */
/* unused harmony export SEMATTRS_HTTP_ROUTE */
/* unused harmony export SEMATTRS_HTTP_CLIENT_IP */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_TABLE_NAMES */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_CONSUMED_CAPACITY */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_ITEM_COLLECTION_METRICS */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_CONSISTENT_READ */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_PROJECTION */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_LIMIT */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_ATTRIBUTES_TO_GET */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_INDEX_NAME */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_SELECT */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_EXCLUSIVE_START_TABLE */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_TABLE_COUNT */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_SCAN_FORWARD */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_SEGMENT */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_TOTAL_SEGMENTS */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_COUNT */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_SCANNED_COUNT */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS */
/* unused harmony export SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES */
/* unused harmony export SEMATTRS_MESSAGING_SYSTEM */
/* unused harmony export SEMATTRS_MESSAGING_DESTINATION */
/* unused harmony export SEMATTRS_MESSAGING_DESTINATION_KIND */
/* unused harmony export SEMATTRS_MESSAGING_TEMP_DESTINATION */
/* unused harmony export SEMATTRS_MESSAGING_PROTOCOL */
/* unused harmony export SEMATTRS_MESSAGING_PROTOCOL_VERSION */
/* unused harmony export SEMATTRS_MESSAGING_URL */
/* unused harmony export SEMATTRS_MESSAGING_MESSAGE_ID */
/* unused harmony export SEMATTRS_MESSAGING_CONVERSATION_ID */
/* unused harmony export SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES */
/* unused harmony export SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES */
/* unused harmony export SEMATTRS_MESSAGING_OPERATION */
/* unused harmony export SEMATTRS_MESSAGING_CONSUMER_ID */
/* unused harmony export SEMATTRS_MESSAGING_RABBITMQ_ROUTING_KEY */
/* unused harmony export SEMATTRS_MESSAGING_KAFKA_MESSAGE_KEY */
/* unused harmony export SEMATTRS_MESSAGING_KAFKA_CONSUMER_GROUP */
/* unused harmony export SEMATTRS_MESSAGING_KAFKA_CLIENT_ID */
/* unused harmony export SEMATTRS_MESSAGING_KAFKA_PARTITION */
/* unused harmony export SEMATTRS_MESSAGING_KAFKA_TOMBSTONE */
/* unused harmony export SEMATTRS_RPC_SYSTEM */
/* unused harmony export SEMATTRS_RPC_SERVICE */
/* unused harmony export SEMATTRS_RPC_METHOD */
/* unused harmony export SEMATTRS_RPC_GRPC_STATUS_CODE */
/* unused harmony export SEMATTRS_RPC_JSONRPC_VERSION */
/* unused harmony export SEMATTRS_RPC_JSONRPC_REQUEST_ID */
/* unused harmony export SEMATTRS_RPC_JSONRPC_ERROR_CODE */
/* unused harmony export SEMATTRS_RPC_JSONRPC_ERROR_MESSAGE */
/* unused harmony export SEMATTRS_MESSAGE_TYPE */
/* unused harmony export SEMATTRS_MESSAGE_ID */
/* unused harmony export SEMATTRS_MESSAGE_COMPRESSED_SIZE */
/* unused harmony export SEMATTRS_MESSAGE_UNCOMPRESSED_SIZE */
/* unused harmony export SemanticAttributes */
/* unused harmony export DBSYSTEMVALUES_OTHER_SQL */
/* unused harmony export DBSYSTEMVALUES_MSSQL */
/* unused harmony export DBSYSTEMVALUES_MYSQL */
/* unused harmony export DBSYSTEMVALUES_ORACLE */
/* unused harmony export DBSYSTEMVALUES_DB2 */
/* unused harmony export DBSYSTEMVALUES_POSTGRESQL */
/* unused harmony export DBSYSTEMVALUES_REDSHIFT */
/* unused harmony export DBSYSTEMVALUES_HIVE */
/* unused harmony export DBSYSTEMVALUES_CLOUDSCAPE */
/* unused harmony export DBSYSTEMVALUES_HSQLDB */
/* unused harmony export DBSYSTEMVALUES_PROGRESS */
/* unused harmony export DBSYSTEMVALUES_MAXDB */
/* unused harmony export DBSYSTEMVALUES_HANADB */
/* unused harmony export DBSYSTEMVALUES_INGRES */
/* unused harmony export DBSYSTEMVALUES_FIRSTSQL */
/* unused harmony export DBSYSTEMVALUES_EDB */
/* unused harmony export DBSYSTEMVALUES_CACHE */
/* unused harmony export DBSYSTEMVALUES_ADABAS */
/* unused harmony export DBSYSTEMVALUES_FIREBIRD */
/* unused harmony export DBSYSTEMVALUES_DERBY */
/* unused harmony export DBSYSTEMVALUES_FILEMAKER */
/* unused harmony export DBSYSTEMVALUES_INFORMIX */
/* unused harmony export DBSYSTEMVALUES_INSTANTDB */
/* unused harmony export DBSYSTEMVALUES_INTERBASE */
/* unused harmony export DBSYSTEMVALUES_MARIADB */
/* unused harmony export DBSYSTEMVALUES_NETEZZA */
/* unused harmony export DBSYSTEMVALUES_PERVASIVE */
/* unused harmony export DBSYSTEMVALUES_POINTBASE */
/* unused harmony export DBSYSTEMVALUES_SQLITE */
/* unused harmony export DBSYSTEMVALUES_SYBASE */
/* unused harmony export DBSYSTEMVALUES_TERADATA */
/* unused harmony export DBSYSTEMVALUES_VERTICA */
/* unused harmony export DBSYSTEMVALUES_H2 */
/* unused harmony export DBSYSTEMVALUES_COLDFUSION */
/* unused harmony export DBSYSTEMVALUES_CASSANDRA */
/* unused harmony export DBSYSTEMVALUES_HBASE */
/* unused harmony export DBSYSTEMVALUES_MONGODB */
/* unused harmony export DBSYSTEMVALUES_REDIS */
/* unused harmony export DBSYSTEMVALUES_COUCHBASE */
/* unused harmony export DBSYSTEMVALUES_COUCHDB */
/* unused harmony export DBSYSTEMVALUES_COSMOSDB */
/* unused harmony export DBSYSTEMVALUES_DYNAMODB */
/* unused harmony export DBSYSTEMVALUES_NEO4J */
/* unused harmony export DBSYSTEMVALUES_GEODE */
/* unused harmony export DBSYSTEMVALUES_ELASTICSEARCH */
/* unused harmony export DBSYSTEMVALUES_MEMCACHED */
/* unused harmony export DBSYSTEMVALUES_COCKROACHDB */
/* unused harmony export DbSystemValues */
/* unused harmony export DBCASSANDRACONSISTENCYLEVELVALUES_ALL */
/* unused harmony export DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM */
/* unused harmony export DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM */
/* unused harmony export DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM */
/* unused harmony export DBCASSANDRACONSISTENCYLEVELVALUES_ONE */
/* unused harmony export DBCASSANDRACONSISTENCYLEVELVALUES_TWO */
/* unused harmony export DBCASSANDRACONSISTENCYLEVELVALUES_THREE */
/* unused harmony export DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE */
/* unused harmony export DBCASSANDRACONSISTENCYLEVELVALUES_ANY */
/* unused harmony export DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL */
/* unused harmony export DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL */
/* unused harmony export DbCassandraConsistencyLevelValues */
/* unused harmony export FAASTRIGGERVALUES_DATASOURCE */
/* unused harmony export FAASTRIGGERVALUES_HTTP */
/* unused harmony export FAASTRIGGERVALUES_PUBSUB */
/* unused harmony export FAASTRIGGERVALUES_TIMER */
/* unused harmony export FAASTRIGGERVALUES_OTHER */
/* unused harmony export FaasTriggerValues */
/* unused harmony export FAASDOCUMENTOPERATIONVALUES_INSERT */
/* unused harmony export FAASDOCUMENTOPERATIONVALUES_EDIT */
/* unused harmony export FAASDOCUMENTOPERATIONVALUES_DELETE */
/* unused harmony export FaasDocumentOperationValues */
/* unused harmony export FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD */
/* unused harmony export FAASINVOKEDPROVIDERVALUES_AWS */
/* unused harmony export FAASINVOKEDPROVIDERVALUES_AZURE */
/* unused harmony export FAASINVOKEDPROVIDERVALUES_GCP */
/* unused harmony export FaasInvokedProviderValues */
/* unused harmony export NETTRANSPORTVALUES_IP_TCP */
/* unused harmony export NETTRANSPORTVALUES_IP_UDP */
/* unused harmony export NETTRANSPORTVALUES_IP */
/* unused harmony export NETTRANSPORTVALUES_UNIX */
/* unused harmony export NETTRANSPORTVALUES_PIPE */
/* unused harmony export NETTRANSPORTVALUES_INPROC */
/* unused harmony export NETTRANSPORTVALUES_OTHER */
/* unused harmony export NetTransportValues */
/* unused harmony export NETHOSTCONNECTIONTYPEVALUES_WIFI */
/* unused harmony export NETHOSTCONNECTIONTYPEVALUES_WIRED */
/* unused harmony export NETHOSTCONNECTIONTYPEVALUES_CELL */
/* unused harmony export NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE */
/* unused harmony export NETHOSTCONNECTIONTYPEVALUES_UNKNOWN */
/* unused harmony export NetHostConnectionTypeValues */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_GPRS */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_EDGE */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_UMTS */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_CDMA */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0 */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_HSPA */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_IDEN */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_LTE */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_GSM */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_NR */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA */
/* unused harmony export NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA */
/* unused harmony export NetHostConnectionSubtypeValues */
/* unused harmony export HTTPFLAVORVALUES_HTTP_1_0 */
/* unused harmony export HTTPFLAVORVALUES_HTTP_1_1 */
/* unused harmony export HTTPFLAVORVALUES_HTTP_2_0 */
/* unused harmony export HTTPFLAVORVALUES_SPDY */
/* unused harmony export HTTPFLAVORVALUES_QUIC */
/* unused harmony export HttpFlavorValues */
/* unused harmony export MESSAGINGDESTINATIONKINDVALUES_QUEUE */
/* unused harmony export MESSAGINGDESTINATIONKINDVALUES_TOPIC */
/* unused harmony export MessagingDestinationKindValues */
/* unused harmony export MESSAGINGOPERATIONVALUES_RECEIVE */
/* unused harmony export MESSAGINGOPERATIONVALUES_PROCESS */
/* unused harmony export MessagingOperationValues */
/* unused harmony export RPCGRPCSTATUSCODEVALUES_OK */
/* unused harmony export RPCGRPCSTATUSCODEVALUES_CANCELLED */
/* unused harmony export RPCGRPCSTATUSCODEVALUES_UNKNOWN */
/* unused harmony export RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT */
/* unused harmony export RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED */
/* unused harmony export RPCGRPCSTATUSCODEVALUES_NOT_FOUND */
/* unused harmony export RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS */
/* unused harmony export RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED */
/* unused harmony export RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED */
/* unused harmony export RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION */
/* unused harmony export RPCGRPCSTATUSCODEVALUES_ABORTED */
/* unused harmony export RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE */
/* unused harmony export RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED */
/* unused harmony export RPCGRPCSTATUSCODEVALUES_INTERNAL */
/* unused harmony export RPCGRPCSTATUSCODEVALUES_UNAVAILABLE */
/* unused harmony export RPCGRPCSTATUSCODEVALUES_DATA_LOSS */
/* unused harmony export RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED */
/* unused harmony export RpcGrpcStatusCodeValues */
/* unused harmony export MESSAGETYPEVALUES_SENT */
/* unused harmony export MESSAGETYPEVALUES_RECEIVED */
/* unused harmony export MessageTypeValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__internal_utils__ = __webpack_require__(943);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

//----------------------------------------------------------------------------------------------------------
// DO NOT EDIT, this is an Auto-generated file from scripts/semconv/templates//templates/SemanticAttributes.ts.j2
//----------------------------------------------------------------------------------------------------------
//----------------------------------------------------------------------------------------------------------
// Constant values for SemanticAttributes
//----------------------------------------------------------------------------------------------------------
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_AWS_LAMBDA_INVOKED_ARN = 'aws.lambda.invoked_arn';
var TMP_DB_SYSTEM = 'db.system';
var TMP_DB_CONNECTION_STRING = 'db.connection_string';
var TMP_DB_USER = 'db.user';
var TMP_DB_JDBC_DRIVER_CLASSNAME = 'db.jdbc.driver_classname';
var TMP_DB_NAME = 'db.name';
var TMP_DB_STATEMENT = 'db.statement';
var TMP_DB_OPERATION = 'db.operation';
var TMP_DB_MSSQL_INSTANCE_NAME = 'db.mssql.instance_name';
var TMP_DB_CASSANDRA_KEYSPACE = 'db.cassandra.keyspace';
var TMP_DB_CASSANDRA_PAGE_SIZE = 'db.cassandra.page_size';
var TMP_DB_CASSANDRA_CONSISTENCY_LEVEL = 'db.cassandra.consistency_level';
var TMP_DB_CASSANDRA_TABLE = 'db.cassandra.table';
var TMP_DB_CASSANDRA_IDEMPOTENCE = 'db.cassandra.idempotence';
var TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT = 'db.cassandra.speculative_execution_count';
var TMP_DB_CASSANDRA_COORDINATOR_ID = 'db.cassandra.coordinator.id';
var TMP_DB_CASSANDRA_COORDINATOR_DC = 'db.cassandra.coordinator.dc';
var TMP_DB_HBASE_NAMESPACE = 'db.hbase.namespace';
var TMP_DB_REDIS_DATABASE_INDEX = 'db.redis.database_index';
var TMP_DB_MONGODB_COLLECTION = 'db.mongodb.collection';
var TMP_DB_SQL_TABLE = 'db.sql.table';
var TMP_EXCEPTION_TYPE = 'exception.type';
var TMP_EXCEPTION_MESSAGE = 'exception.message';
var TMP_EXCEPTION_STACKTRACE = 'exception.stacktrace';
var TMP_EXCEPTION_ESCAPED = 'exception.escaped';
var TMP_FAAS_TRIGGER = 'faas.trigger';
var TMP_FAAS_EXECUTION = 'faas.execution';
var TMP_FAAS_DOCUMENT_COLLECTION = 'faas.document.collection';
var TMP_FAAS_DOCUMENT_OPERATION = 'faas.document.operation';
var TMP_FAAS_DOCUMENT_TIME = 'faas.document.time';
var TMP_FAAS_DOCUMENT_NAME = 'faas.document.name';
var TMP_FAAS_TIME = 'faas.time';
var TMP_FAAS_CRON = 'faas.cron';
var TMP_FAAS_COLDSTART = 'faas.coldstart';
var TMP_FAAS_INVOKED_NAME = 'faas.invoked_name';
var TMP_FAAS_INVOKED_PROVIDER = 'faas.invoked_provider';
var TMP_FAAS_INVOKED_REGION = 'faas.invoked_region';
var TMP_NET_TRANSPORT = 'net.transport';
var TMP_NET_PEER_IP = 'net.peer.ip';
var TMP_NET_PEER_PORT = 'net.peer.port';
var TMP_NET_PEER_NAME = 'net.peer.name';
var TMP_NET_HOST_IP = 'net.host.ip';
var TMP_NET_HOST_PORT = 'net.host.port';
var TMP_NET_HOST_NAME = 'net.host.name';
var TMP_NET_HOST_CONNECTION_TYPE = 'net.host.connection.type';
var TMP_NET_HOST_CONNECTION_SUBTYPE = 'net.host.connection.subtype';
var TMP_NET_HOST_CARRIER_NAME = 'net.host.carrier.name';
var TMP_NET_HOST_CARRIER_MCC = 'net.host.carrier.mcc';
var TMP_NET_HOST_CARRIER_MNC = 'net.host.carrier.mnc';
var TMP_NET_HOST_CARRIER_ICC = 'net.host.carrier.icc';
var TMP_PEER_SERVICE = 'peer.service';
var TMP_ENDUSER_ID = 'enduser.id';
var TMP_ENDUSER_ROLE = 'enduser.role';
var TMP_ENDUSER_SCOPE = 'enduser.scope';
var TMP_THREAD_ID = 'thread.id';
var TMP_THREAD_NAME = 'thread.name';
var TMP_CODE_FUNCTION = 'code.function';
var TMP_CODE_NAMESPACE = 'code.namespace';
var TMP_CODE_FILEPATH = 'code.filepath';
var TMP_CODE_LINENO = 'code.lineno';
var TMP_HTTP_METHOD = 'http.method';
var TMP_HTTP_URL = 'http.url';
var TMP_HTTP_TARGET = 'http.target';
var TMP_HTTP_HOST = 'http.host';
var TMP_HTTP_SCHEME = 'http.scheme';
var TMP_HTTP_STATUS_CODE = 'http.status_code';
var TMP_HTTP_FLAVOR = 'http.flavor';
var TMP_HTTP_USER_AGENT = 'http.user_agent';
var TMP_HTTP_REQUEST_CONTENT_LENGTH = 'http.request_content_length';
var TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED = 'http.request_content_length_uncompressed';
var TMP_HTTP_RESPONSE_CONTENT_LENGTH = 'http.response_content_length';
var TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED = 'http.response_content_length_uncompressed';
var TMP_HTTP_SERVER_NAME = 'http.server_name';
var TMP_HTTP_ROUTE = 'http.route';
var TMP_HTTP_CLIENT_IP = 'http.client_ip';
var TMP_AWS_DYNAMODB_TABLE_NAMES = 'aws.dynamodb.table_names';
var TMP_AWS_DYNAMODB_CONSUMED_CAPACITY = 'aws.dynamodb.consumed_capacity';
var TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS = 'aws.dynamodb.item_collection_metrics';
var TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = 'aws.dynamodb.provisioned_read_capacity';
var TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = 'aws.dynamodb.provisioned_write_capacity';
var TMP_AWS_DYNAMODB_CONSISTENT_READ = 'aws.dynamodb.consistent_read';
var TMP_AWS_DYNAMODB_PROJECTION = 'aws.dynamodb.projection';
var TMP_AWS_DYNAMODB_LIMIT = 'aws.dynamodb.limit';
var TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET = 'aws.dynamodb.attributes_to_get';
var TMP_AWS_DYNAMODB_INDEX_NAME = 'aws.dynamodb.index_name';
var TMP_AWS_DYNAMODB_SELECT = 'aws.dynamodb.select';
var TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = 'aws.dynamodb.global_secondary_indexes';
var TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = 'aws.dynamodb.local_secondary_indexes';
var TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE = 'aws.dynamodb.exclusive_start_table';
var TMP_AWS_DYNAMODB_TABLE_COUNT = 'aws.dynamodb.table_count';
var TMP_AWS_DYNAMODB_SCAN_FORWARD = 'aws.dynamodb.scan_forward';
var TMP_AWS_DYNAMODB_SEGMENT = 'aws.dynamodb.segment';
var TMP_AWS_DYNAMODB_TOTAL_SEGMENTS = 'aws.dynamodb.total_segments';
var TMP_AWS_DYNAMODB_COUNT = 'aws.dynamodb.count';
var TMP_AWS_DYNAMODB_SCANNED_COUNT = 'aws.dynamodb.scanned_count';
var TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = 'aws.dynamodb.attribute_definitions';
var TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = 'aws.dynamodb.global_secondary_index_updates';
var TMP_MESSAGING_SYSTEM = 'messaging.system';
var TMP_MESSAGING_DESTINATION = 'messaging.destination';
var TMP_MESSAGING_DESTINATION_KIND = 'messaging.destination_kind';
var TMP_MESSAGING_TEMP_DESTINATION = 'messaging.temp_destination';
var TMP_MESSAGING_PROTOCOL = 'messaging.protocol';
var TMP_MESSAGING_PROTOCOL_VERSION = 'messaging.protocol_version';
var TMP_MESSAGING_URL = 'messaging.url';
var TMP_MESSAGING_MESSAGE_ID = 'messaging.message_id';
var TMP_MESSAGING_CONVERSATION_ID = 'messaging.conversation_id';
var TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES = 'messaging.message_payload_size_bytes';
var TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES = 'messaging.message_payload_compressed_size_bytes';
var TMP_MESSAGING_OPERATION = 'messaging.operation';
var TMP_MESSAGING_CONSUMER_ID = 'messaging.consumer_id';
var TMP_MESSAGING_RABBITMQ_ROUTING_KEY = 'messaging.rabbitmq.routing_key';
var TMP_MESSAGING_KAFKA_MESSAGE_KEY = 'messaging.kafka.message_key';
var TMP_MESSAGING_KAFKA_CONSUMER_GROUP = 'messaging.kafka.consumer_group';
var TMP_MESSAGING_KAFKA_CLIENT_ID = 'messaging.kafka.client_id';
var TMP_MESSAGING_KAFKA_PARTITION = 'messaging.kafka.partition';
var TMP_MESSAGING_KAFKA_TOMBSTONE = 'messaging.kafka.tombstone';
var TMP_RPC_SYSTEM = 'rpc.system';
var TMP_RPC_SERVICE = 'rpc.service';
var TMP_RPC_METHOD = 'rpc.method';
var TMP_RPC_GRPC_STATUS_CODE = 'rpc.grpc.status_code';
var TMP_RPC_JSONRPC_VERSION = 'rpc.jsonrpc.version';
var TMP_RPC_JSONRPC_REQUEST_ID = 'rpc.jsonrpc.request_id';
var TMP_RPC_JSONRPC_ERROR_CODE = 'rpc.jsonrpc.error_code';
var TMP_RPC_JSONRPC_ERROR_MESSAGE = 'rpc.jsonrpc.error_message';
var TMP_MESSAGE_TYPE = 'message.type';
var TMP_MESSAGE_ID = 'message.id';
var TMP_MESSAGE_COMPRESSED_SIZE = 'message.compressed_size';
var TMP_MESSAGE_UNCOMPRESSED_SIZE = 'message.uncompressed_size';
/**
 * The full invoked ARN as provided on the `Context` passed to the function (`Lambda-Runtime-Invoked-Function-Arn` header on the `/runtime/invocation/next` applicable).
 *
 * Note: This may be different from `faas.id` if an alias is involved.
 *
 * @deprecated Use ATTR_AWS_LAMBDA_INVOKED_ARN in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_LAMBDA_INVOKED_ARN = TMP_AWS_LAMBDA_INVOKED_ARN;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use ATTR_DB_SYSTEM in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_SYSTEM = TMP_DB_SYSTEM;
/**
 * The connection string used to connect to the database. It is recommended to remove embedded credentials.
 *
 * @deprecated Use ATTR_DB_CONNECTION_STRING in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_CONNECTION_STRING = TMP_DB_CONNECTION_STRING;
/**
 * Username for accessing the database.
 *
 * @deprecated Use ATTR_DB_USER in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_USER = TMP_DB_USER;
/**
 * The fully-qualified class name of the [Java Database Connectivity (JDBC)](https://docs.oracle.com/javase/8/docs/technotes/guides/jdbc/) driver used to connect.
 *
 * @deprecated Use ATTR_DB_JDBC_DRIVER_CLASSNAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_JDBC_DRIVER_CLASSNAME = TMP_DB_JDBC_DRIVER_CLASSNAME;
/**
 * If no [tech-specific attribute](#call-level-attributes-for-specific-technologies) is defined, this attribute is used to report the name of the database being accessed. For commands that switch the database, this should be set to the target database (even if the command fails).
 *
 * Note: In some SQL databases, the database name to be used is called &#34;schema name&#34;.
 *
 * @deprecated Use ATTR_DB_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_NAME = TMP_DB_NAME;
/**
 * The database statement being executed.
 *
 * Note: The value may be sanitized to exclude sensitive information.
 *
 * @deprecated Use ATTR_DB_STATEMENT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_STATEMENT = TMP_DB_STATEMENT;
/**
 * The name of the operation being executed, e.g. the [MongoDB command name](https://docs.mongodb.com/manual/reference/command/#database-operations) such as `findAndModify`, or the SQL keyword.
 *
 * Note: When setting this to an SQL keyword, it is not recommended to attempt any client-side parsing of `db.statement` just to get this property, but it should be set if the operation name is provided by the library being instrumented. If the SQL statement has an ambiguous operation, or performs more than one operation, this value may be omitted.
 *
 * @deprecated Use ATTR_DB_OPERATION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_OPERATION = TMP_DB_OPERATION;
/**
 * The Microsoft SQL Server [instance name](https://docs.microsoft.com/en-us/sql/connect/jdbc/building-the-connection-url?view=sql-server-ver15) connecting to. This name is used to determine the port of a named instance.
 *
 * Note: If setting a `db.mssql.instance_name`, `net.peer.port` is no longer required (but still recommended if non-standard).
 *
 * @deprecated Use ATTR_DB_MSSQL_INSTANCE_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_MSSQL_INSTANCE_NAME = TMP_DB_MSSQL_INSTANCE_NAME;
/**
 * The name of the keyspace being accessed. To be used instead of the generic `db.name` attribute.
 *
 * @deprecated Use ATTR_DB_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_CASSANDRA_KEYSPACE = TMP_DB_CASSANDRA_KEYSPACE;
/**
 * The fetch size used for paging, i.e. how many rows will be returned at once.
 *
 * @deprecated Use ATTR_DB_CASSANDRA_PAGE_SIZE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_CASSANDRA_PAGE_SIZE = TMP_DB_CASSANDRA_PAGE_SIZE;
/**
 * The consistency level of the query. Based on consistency values from [CQL](https://docs.datastax.com/en/cassandra-oss/3.0/cassandra/dml/dmlConfigConsistency.html).
 *
 * @deprecated Use ATTR_DB_CASSANDRA_CONSISTENCY_LEVEL in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_CASSANDRA_CONSISTENCY_LEVEL = TMP_DB_CASSANDRA_CONSISTENCY_LEVEL;
/**
 * The name of the primary table that the operation is acting upon, including the schema name (if applicable).
 *
 * Note: This mirrors the db.sql.table attribute but references cassandra rather than sql. It is not recommended to attempt any client-side parsing of `db.statement` just to get this property, but it should be set if it is provided by the library being instrumented. If the operation is acting upon an anonymous table, or more than one table, this value MUST NOT be set.
 *
 * @deprecated Use ATTR_DB_CASSANDRA_TABLE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_CASSANDRA_TABLE = TMP_DB_CASSANDRA_TABLE;
/**
 * Whether or not the query is idempotent.
 *
 * @deprecated Use ATTR_DB_CASSANDRA_IDEMPOTENCE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_CASSANDRA_IDEMPOTENCE = TMP_DB_CASSANDRA_IDEMPOTENCE;
/**
 * The number of times a query was speculatively executed. Not set or `0` if the query was not executed speculatively.
 *
 * @deprecated Use ATTR_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT = TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT;
/**
 * The ID of the coordinating node for a query.
 *
 * @deprecated Use ATTR_DB_CASSANDRA_COORDINATOR_ID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_CASSANDRA_COORDINATOR_ID = TMP_DB_CASSANDRA_COORDINATOR_ID;
/**
 * The data center of the coordinating node for a query.
 *
 * @deprecated Use ATTR_DB_CASSANDRA_COORDINATOR_DC in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_CASSANDRA_COORDINATOR_DC = TMP_DB_CASSANDRA_COORDINATOR_DC;
/**
 * The [HBase namespace](https://hbase.apache.org/book.html#_namespace) being accessed. To be used instead of the generic `db.name` attribute.
 *
 * @deprecated Use ATTR_DB_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_HBASE_NAMESPACE = TMP_DB_HBASE_NAMESPACE;
/**
 * The index of the database being accessed as used in the [`SELECT` command](https://redis.io/commands/select), provided as an integer. To be used instead of the generic `db.name` attribute.
 *
 * @deprecated Use ATTR_DB_REDIS_DATABASE_INDEX in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_REDIS_DATABASE_INDEX = TMP_DB_REDIS_DATABASE_INDEX;
/**
 * The collection being accessed within the database stated in `db.name`.
 *
 * @deprecated Use ATTR_DB_MONGODB_COLLECTION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_MONGODB_COLLECTION = TMP_DB_MONGODB_COLLECTION;
/**
 * The name of the primary table that the operation is acting upon, including the schema name (if applicable).
 *
 * Note: It is not recommended to attempt any client-side parsing of `db.statement` just to get this property, but it should be set if it is provided by the library being instrumented. If the operation is acting upon an anonymous table, or more than one table, this value MUST NOT be set.
 *
 * @deprecated Use ATTR_DB_SQL_TABLE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_DB_SQL_TABLE = TMP_DB_SQL_TABLE;
/**
 * The type of the exception (its fully-qualified class name, if applicable). The dynamic type of the exception should be preferred over the static type in languages that support it.
 *
 * @deprecated Use ATTR_EXCEPTION_TYPE.
 */
var SEMATTRS_EXCEPTION_TYPE = TMP_EXCEPTION_TYPE;
/**
 * The exception message.
 *
 * @deprecated Use ATTR_EXCEPTION_MESSAGE.
 */
var SEMATTRS_EXCEPTION_MESSAGE = TMP_EXCEPTION_MESSAGE;
/**
 * A stacktrace as a string in the natural representation for the language runtime. The representation is to be determined and documented by each language SIG.
 *
 * @deprecated Use ATTR_EXCEPTION_STACKTRACE.
 */
var SEMATTRS_EXCEPTION_STACKTRACE = TMP_EXCEPTION_STACKTRACE;
/**
* SHOULD be set to true if the exception event is recorded at a point where it is known that the exception is escaping the scope of the span.
*
* Note: An exception is considered to have escaped (or left) the scope of a span,
if that span is ended while the exception is still logically &#34;in flight&#34;.
This may be actually &#34;in flight&#34; in some languages (e.g. if the exception
is passed to a Context manager&#39;s `__exit__` method in Python) but will
usually be caught at the point of recording the exception in most languages.

It is usually not possible to determine at the point where an exception is thrown
whether it will escape the scope of a span.
However, it is trivial to know that an exception
will escape, if one checks for an active exception just before ending the span,
as done in the [example above](#exception-end-example).

It follows that an exception may still escape the scope of the span
even if the `exception.escaped` attribute was not set or set to false,
since the event might have been recorded at a time where it was not
clear whether the exception will escape.
*
* @deprecated Use ATTR_EXCEPTION_ESCAPED.
*/
var SEMATTRS_EXCEPTION_ESCAPED = TMP_EXCEPTION_ESCAPED;
/**
 * Type of the trigger on which the function is executed.
 *
 * @deprecated Use ATTR_FAAS_TRIGGER in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_FAAS_TRIGGER = TMP_FAAS_TRIGGER;
/**
 * The execution ID of the current function execution.
 *
 * @deprecated Use ATTR_FAAS_INVOCATION_ID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_FAAS_EXECUTION = TMP_FAAS_EXECUTION;
/**
 * The name of the source on which the triggering operation was performed. For example, in Cloud Storage or S3 corresponds to the bucket name, and in Cosmos DB to the database name.
 *
 * @deprecated Use ATTR_FAAS_DOCUMENT_COLLECTION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_FAAS_DOCUMENT_COLLECTION = TMP_FAAS_DOCUMENT_COLLECTION;
/**
 * Describes the type of the operation that was performed on the data.
 *
 * @deprecated Use ATTR_FAAS_DOCUMENT_OPERATION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_FAAS_DOCUMENT_OPERATION = TMP_FAAS_DOCUMENT_OPERATION;
/**
 * A string containing the time when the data was accessed in the [ISO 8601](https://www.iso.org/iso-8601-date-and-time-format.html) format expressed in [UTC](https://www.w3.org/TR/NOTE-datetime).
 *
 * @deprecated Use ATTR_FAAS_DOCUMENT_TIME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_FAAS_DOCUMENT_TIME = TMP_FAAS_DOCUMENT_TIME;
/**
 * The document name/table subjected to the operation. For example, in Cloud Storage or S3 is the name of the file, and in Cosmos DB the table name.
 *
 * @deprecated Use ATTR_FAAS_DOCUMENT_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_FAAS_DOCUMENT_NAME = TMP_FAAS_DOCUMENT_NAME;
/**
 * A string containing the function invocation time in the [ISO 8601](https://www.iso.org/iso-8601-date-and-time-format.html) format expressed in [UTC](https://www.w3.org/TR/NOTE-datetime).
 *
 * @deprecated Use ATTR_FAAS_TIME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_FAAS_TIME = TMP_FAAS_TIME;
/**
 * A string containing the schedule period as [Cron Expression](https://docs.oracle.com/cd/E12058_01/doc/doc.1014/e12030/cron_expressions.htm).
 *
 * @deprecated Use ATTR_FAAS_CRON in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_FAAS_CRON = TMP_FAAS_CRON;
/**
 * A boolean that is true if the serverless function is executed for the first time (aka cold-start).
 *
 * @deprecated Use ATTR_FAAS_COLDSTART in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_FAAS_COLDSTART = TMP_FAAS_COLDSTART;
/**
 * The name of the invoked function.
 *
 * Note: SHOULD be equal to the `faas.name` resource attribute of the invoked function.
 *
 * @deprecated Use ATTR_FAAS_INVOKED_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_FAAS_INVOKED_NAME = TMP_FAAS_INVOKED_NAME;
/**
 * The cloud provider of the invoked function.
 *
 * Note: SHOULD be equal to the `cloud.provider` resource attribute of the invoked function.
 *
 * @deprecated Use ATTR_FAAS_INVOKED_PROVIDER in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_FAAS_INVOKED_PROVIDER = TMP_FAAS_INVOKED_PROVIDER;
/**
 * The cloud region of the invoked function.
 *
 * Note: SHOULD be equal to the `cloud.region` resource attribute of the invoked function.
 *
 * @deprecated Use ATTR_FAAS_INVOKED_REGION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_FAAS_INVOKED_REGION = TMP_FAAS_INVOKED_REGION;
/**
 * Transport protocol used. See note below.
 *
 * @deprecated Use ATTR_NET_TRANSPORT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_NET_TRANSPORT = TMP_NET_TRANSPORT;
/**
 * Remote address of the peer (dotted decimal for IPv4 or [RFC5952](https://tools.ietf.org/html/rfc5952) for IPv6).
 *
 * @deprecated Use ATTR_NET_PEER_IP in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_NET_PEER_IP = TMP_NET_PEER_IP;
/**
 * Remote port number.
 *
 * @deprecated Use ATTR_NET_PEER_PORT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_NET_PEER_PORT = TMP_NET_PEER_PORT;
/**
 * Remote hostname or similar, see note below.
 *
 * @deprecated Use ATTR_NET_PEER_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_NET_PEER_NAME = TMP_NET_PEER_NAME;
/**
 * Like `net.peer.ip` but for the host IP. Useful in case of a multi-IP host.
 *
 * @deprecated Use ATTR_NET_HOST_IP in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_NET_HOST_IP = TMP_NET_HOST_IP;
/**
 * Like `net.peer.port` but for the host port.
 *
 * @deprecated Use ATTR_NET_HOST_PORT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_NET_HOST_PORT = TMP_NET_HOST_PORT;
/**
 * Local hostname or similar, see note below.
 *
 * @deprecated Use ATTR_NET_HOST_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_NET_HOST_NAME = TMP_NET_HOST_NAME;
/**
 * The internet connection type currently being used by the host.
 *
 * @deprecated Use ATTR_NETWORK_CONNECTION_TYPE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_NET_HOST_CONNECTION_TYPE = TMP_NET_HOST_CONNECTION_TYPE;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use ATTR_NETWORK_CONNECTION_SUBTYPE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_NET_HOST_CONNECTION_SUBTYPE = TMP_NET_HOST_CONNECTION_SUBTYPE;
/**
 * The name of the mobile carrier.
 *
 * @deprecated Use ATTR_NETWORK_CARRIER_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_NET_HOST_CARRIER_NAME = TMP_NET_HOST_CARRIER_NAME;
/**
 * The mobile carrier country code.
 *
 * @deprecated Use ATTR_NETWORK_CARRIER_MCC in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_NET_HOST_CARRIER_MCC = TMP_NET_HOST_CARRIER_MCC;
/**
 * The mobile carrier network code.
 *
 * @deprecated Use ATTR_NETWORK_CARRIER_MNC in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_NET_HOST_CARRIER_MNC = TMP_NET_HOST_CARRIER_MNC;
/**
 * The ISO 3166-1 alpha-2 2-character country code associated with the mobile carrier network.
 *
 * @deprecated Use ATTR_NETWORK_CARRIER_ICC in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_NET_HOST_CARRIER_ICC = TMP_NET_HOST_CARRIER_ICC;
/**
 * The [`service.name`](../../resource/semantic_conventions/README.md#service) of the remote service. SHOULD be equal to the actual `service.name` resource attribute of the remote service if any.
 *
 * @deprecated Use ATTR_PEER_SERVICE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_PEER_SERVICE = TMP_PEER_SERVICE;
/**
 * Username or client_id extracted from the access token or [Authorization](https://tools.ietf.org/html/rfc7235#section-4.2) header in the inbound request from outside the system.
 *
 * @deprecated Use ATTR_ENDUSER_ID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_ENDUSER_ID = TMP_ENDUSER_ID;
/**
 * Actual/assumed role the client is making the request under extracted from token or application security context.
 *
 * @deprecated Use ATTR_ENDUSER_ROLE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_ENDUSER_ROLE = TMP_ENDUSER_ROLE;
/**
 * Scopes or granted authorities the client currently possesses extracted from token or application security context. The value would come from the scope associated with an [OAuth 2.0 Access Token](https://tools.ietf.org/html/rfc6749#section-3.3) or an attribute value in a [SAML 2.0 Assertion](http://docs.oasis-open.org/security/saml/Post2.0/sstc-saml-tech-overview-2.0.html).
 *
 * @deprecated Use ATTR_ENDUSER_SCOPE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_ENDUSER_SCOPE = TMP_ENDUSER_SCOPE;
/**
 * Current &#34;managed&#34; thread ID (as opposed to OS thread ID).
 *
 * @deprecated Use ATTR_THREAD_ID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_THREAD_ID = TMP_THREAD_ID;
/**
 * Current thread name.
 *
 * @deprecated Use ATTR_THREAD_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_THREAD_NAME = TMP_THREAD_NAME;
/**
 * The method or function name, or equivalent (usually rightmost part of the code unit&#39;s name).
 *
 * @deprecated Use ATTR_CODE_FUNCTION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_CODE_FUNCTION = TMP_CODE_FUNCTION;
/**
 * The &#34;namespace&#34; within which `code.function` is defined. Usually the qualified class or module name, such that `code.namespace` + some separator + `code.function` form a unique identifier for the code unit.
 *
 * @deprecated Use ATTR_CODE_NAMESPACE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_CODE_NAMESPACE = TMP_CODE_NAMESPACE;
/**
 * The source code file name that identifies the code unit as uniquely as possible (preferably an absolute file path).
 *
 * @deprecated Use ATTR_CODE_FILEPATH in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_CODE_FILEPATH = TMP_CODE_FILEPATH;
/**
 * The line number in `code.filepath` best representing the operation. It SHOULD point within the code unit named in `code.function`.
 *
 * @deprecated Use ATTR_CODE_LINENO in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_CODE_LINENO = TMP_CODE_LINENO;
/**
 * HTTP request method.
 *
 * @deprecated Use ATTR_HTTP_METHOD in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_HTTP_METHOD = TMP_HTTP_METHOD;
/**
 * Full HTTP request URL in the form `scheme://host[:port]/path?query[#fragment]`. Usually the fragment is not transmitted over HTTP, but if it is known, it should be included nevertheless.
 *
 * Note: `http.url` MUST NOT contain credentials passed via URL in form of `https://username:password@www.example.com/`. In such case the attribute&#39;s value should be `https://www.example.com/`.
 *
 * @deprecated Use ATTR_HTTP_URL in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_HTTP_URL = TMP_HTTP_URL;
/**
 * The full request target as passed in a HTTP request line or equivalent.
 *
 * @deprecated Use ATTR_HTTP_TARGET in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_HTTP_TARGET = TMP_HTTP_TARGET;
/**
 * The value of the [HTTP host header](https://tools.ietf.org/html/rfc7230#section-5.4). An empty Host header should also be reported, see note.
 *
 * Note: When the header is present but empty the attribute SHOULD be set to the empty string. Note that this is a valid situation that is expected in certain cases, according the aforementioned [section of RFC 7230](https://tools.ietf.org/html/rfc7230#section-5.4). When the header is not set the attribute MUST NOT be set.
 *
 * @deprecated Use ATTR_HTTP_HOST in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_HTTP_HOST = TMP_HTTP_HOST;
/**
 * The URI scheme identifying the used protocol.
 *
 * @deprecated Use ATTR_HTTP_SCHEME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_HTTP_SCHEME = TMP_HTTP_SCHEME;
/**
 * [HTTP response status code](https://tools.ietf.org/html/rfc7231#section-6).
 *
 * @deprecated Use ATTR_HTTP_STATUS_CODE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_HTTP_STATUS_CODE = TMP_HTTP_STATUS_CODE;
/**
 * Kind of HTTP protocol used.
 *
 * Note: If `net.transport` is not specified, it can be assumed to be `IP.TCP` except if `http.flavor` is `QUIC`, in which case `IP.UDP` is assumed.
 *
 * @deprecated Use ATTR_HTTP_FLAVOR in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_HTTP_FLAVOR = TMP_HTTP_FLAVOR;
/**
 * Value of the [HTTP User-Agent](https://tools.ietf.org/html/rfc7231#section-5.5.3) header sent by the client.
 *
 * @deprecated Use ATTR_HTTP_USER_AGENT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_HTTP_USER_AGENT = TMP_HTTP_USER_AGENT;
/**
 * The size of the request payload body in bytes. This is the number of bytes transferred excluding headers and is often, but not always, present as the [Content-Length](https://tools.ietf.org/html/rfc7230#section-3.3.2) header. For requests using transport encoding, this should be the compressed size.
 *
 * @deprecated Use ATTR_HTTP_REQUEST_CONTENT_LENGTH in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH = TMP_HTTP_REQUEST_CONTENT_LENGTH;
/**
 * The size of the uncompressed request payload body after transport decoding. Not set if transport encoding not used.
 *
 * @deprecated Use ATTR_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED = TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED;
/**
 * The size of the response payload body in bytes. This is the number of bytes transferred excluding headers and is often, but not always, present as the [Content-Length](https://tools.ietf.org/html/rfc7230#section-3.3.2) header. For requests using transport encoding, this should be the compressed size.
 *
 * @deprecated Use ATTR_HTTP_RESPONSE_CONTENT_LENGTH in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH = TMP_HTTP_RESPONSE_CONTENT_LENGTH;
/**
 * The size of the uncompressed response payload body after transport decoding. Not set if transport encoding not used.
 *
 * @deprecated Use ATTR_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED = TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED;
/**
 * The primary server name of the matched virtual host. This should be obtained via configuration. If no such configuration can be obtained, this attribute MUST NOT be set ( `net.host.name` should be used instead).
 *
 * Note: `http.url` is usually not readily available on the server side but would have to be assembled in a cumbersome and sometimes lossy process from other information (see e.g. open-telemetry/opentelemetry-python/pull/148). It is thus preferred to supply the raw data that is available.
 *
 * @deprecated Use ATTR_HTTP_SERVER_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_HTTP_SERVER_NAME = TMP_HTTP_SERVER_NAME;
/**
 * The matched route (path template).
 *
 * @deprecated Use ATTR_HTTP_ROUTE.
 */
var SEMATTRS_HTTP_ROUTE = TMP_HTTP_ROUTE;
/**
* The IP address of the original client behind all proxies, if known (e.g. from [X-Forwarded-For](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/X-Forwarded-For)).
*
* Note: This is not necessarily the same as `net.peer.ip`, which would
identify the network-level peer, which may be a proxy.

This attribute should be set when a source of information different
from the one used for `net.peer.ip`, is available even if that other
source just confirms the same value as `net.peer.ip`.
Rationale: For `net.peer.ip`, one typically does not know if it
comes from a proxy, reverse proxy, or the actual client. Setting
`http.client_ip` when it&#39;s the same as `net.peer.ip` means that
one is at least somewhat confident that the address is not that of
the closest proxy.
*
* @deprecated Use ATTR_HTTP_CLIENT_IP in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
*/
var SEMATTRS_HTTP_CLIENT_IP = TMP_HTTP_CLIENT_IP;
/**
 * The keys in the `RequestItems` object field.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_TABLE_NAMES in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_TABLE_NAMES = TMP_AWS_DYNAMODB_TABLE_NAMES;
/**
 * The JSON-serialized value of each item in the `ConsumedCapacity` response field.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_CONSUMED_CAPACITY in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_CONSUMED_CAPACITY = TMP_AWS_DYNAMODB_CONSUMED_CAPACITY;
/**
 * The JSON-serialized value of the `ItemCollectionMetrics` response field.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_ITEM_COLLECTION_METRICS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_ITEM_COLLECTION_METRICS = TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS;
/**
 * The value of the `ProvisionedThroughput.ReadCapacityUnits` request parameter.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY = TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY;
/**
 * The value of the `ProvisionedThroughput.WriteCapacityUnits` request parameter.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY = TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY;
/**
 * The value of the `ConsistentRead` request parameter.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_CONSISTENT_READ in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_CONSISTENT_READ = TMP_AWS_DYNAMODB_CONSISTENT_READ;
/**
 * The value of the `ProjectionExpression` request parameter.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_PROJECTION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_PROJECTION = TMP_AWS_DYNAMODB_PROJECTION;
/**
 * The value of the `Limit` request parameter.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_LIMIT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_LIMIT = TMP_AWS_DYNAMODB_LIMIT;
/**
 * The value of the `AttributesToGet` request parameter.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_ATTRIBUTES_TO_GET in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_ATTRIBUTES_TO_GET = TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET;
/**
 * The value of the `IndexName` request parameter.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_INDEX_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_INDEX_NAME = TMP_AWS_DYNAMODB_INDEX_NAME;
/**
 * The value of the `Select` request parameter.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_SELECT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_SELECT = TMP_AWS_DYNAMODB_SELECT;
/**
 * The JSON-serialized value of each item of the `GlobalSecondaryIndexes` request field.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES = TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES;
/**
 * The JSON-serialized value of each item of the `LocalSecondaryIndexes` request field.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES = TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES;
/**
 * The value of the `ExclusiveStartTableName` request parameter.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_EXCLUSIVE_START_TABLE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_EXCLUSIVE_START_TABLE = TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE;
/**
 * The the number of items in the `TableNames` response parameter.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_TABLE_COUNT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_TABLE_COUNT = TMP_AWS_DYNAMODB_TABLE_COUNT;
/**
 * The value of the `ScanIndexForward` request parameter.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_SCAN_FORWARD in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_SCAN_FORWARD = TMP_AWS_DYNAMODB_SCAN_FORWARD;
/**
 * The value of the `Segment` request parameter.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_SEGMENT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_SEGMENT = TMP_AWS_DYNAMODB_SEGMENT;
/**
 * The value of the `TotalSegments` request parameter.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_TOTAL_SEGMENTS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_TOTAL_SEGMENTS = TMP_AWS_DYNAMODB_TOTAL_SEGMENTS;
/**
 * The value of the `Count` response parameter.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_COUNT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_COUNT = TMP_AWS_DYNAMODB_COUNT;
/**
 * The value of the `ScannedCount` response parameter.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_SCANNED_COUNT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_SCANNED_COUNT = TMP_AWS_DYNAMODB_SCANNED_COUNT;
/**
 * The JSON-serialized value of each item in the `AttributeDefinitions` request field.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS = TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS;
/**
 * The JSON-serialized value of each item in the the `GlobalSecondaryIndexUpdates` request field.
 *
 * @deprecated Use ATTR_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES = TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES;
/**
 * A string identifying the messaging system.
 *
 * @deprecated Use ATTR_MESSAGING_SYSTEM in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_MESSAGING_SYSTEM = TMP_MESSAGING_SYSTEM;
/**
 * The message destination name. This might be equal to the span name but is required nevertheless.
 *
 * @deprecated Use ATTR_MESSAGING_DESTINATION_NAME in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_MESSAGING_DESTINATION = TMP_MESSAGING_DESTINATION;
/**
 * The kind of message destination.
 *
 * @deprecated Removed in semconv v1.20.0.
 */
var SEMATTRS_MESSAGING_DESTINATION_KIND = TMP_MESSAGING_DESTINATION_KIND;
/**
 * A boolean that is true if the message destination is temporary.
 *
 * @deprecated Use ATTR_MESSAGING_DESTINATION_TEMPORARY in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_MESSAGING_TEMP_DESTINATION = TMP_MESSAGING_TEMP_DESTINATION;
/**
 * The name of the transport protocol.
 *
 * @deprecated Use ATTR_NETWORK_PROTOCOL_NAME.
 */
var SEMATTRS_MESSAGING_PROTOCOL = TMP_MESSAGING_PROTOCOL;
/**
 * The version of the transport protocol.
 *
 * @deprecated Use ATTR_NETWORK_PROTOCOL_VERSION.
 */
var SEMATTRS_MESSAGING_PROTOCOL_VERSION = TMP_MESSAGING_PROTOCOL_VERSION;
/**
 * Connection string.
 *
 * @deprecated Removed in semconv v1.17.0.
 */
var SEMATTRS_MESSAGING_URL = TMP_MESSAGING_URL;
/**
 * A value used by the messaging system as an identifier for the message, represented as a string.
 *
 * @deprecated Use ATTR_MESSAGING_MESSAGE_ID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_MESSAGING_MESSAGE_ID = TMP_MESSAGING_MESSAGE_ID;
/**
 * The [conversation ID](#conversations) identifying the conversation to which the message belongs, represented as a string. Sometimes called &#34;Correlation ID&#34;.
 *
 * @deprecated Use ATTR_MESSAGING_MESSAGE_CONVERSATION_ID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_MESSAGING_CONVERSATION_ID = TMP_MESSAGING_CONVERSATION_ID;
/**
 * The (uncompressed) size of the message payload in bytes. Also use this attribute if it is unknown whether the compressed or uncompressed payload size is reported.
 *
 * @deprecated Use ATTR_MESSAGING_MESSAGE_BODY_SIZE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES = TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES;
/**
 * The compressed size of the message payload in bytes.
 *
 * @deprecated Removed in semconv v1.22.0.
 */
var SEMATTRS_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES = TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES;
/**
 * A string identifying the kind of message consumption as defined in the [Operation names](#operation-names) section above. If the operation is &#34;send&#34;, this attribute MUST NOT be set, since the operation can be inferred from the span kind in that case.
 *
 * @deprecated Use ATTR_MESSAGING_OPERATION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_MESSAGING_OPERATION = TMP_MESSAGING_OPERATION;
/**
 * The identifier for the consumer receiving a message. For Kafka, set it to `{messaging.kafka.consumer_group} - {messaging.kafka.client_id}`, if both are present, or only `messaging.kafka.consumer_group`. For brokers, such as RabbitMQ and Artemis, set it to the `client_id` of the client consuming the message.
 *
 * @deprecated Removed in semconv v1.21.0.
 */
var SEMATTRS_MESSAGING_CONSUMER_ID = TMP_MESSAGING_CONSUMER_ID;
/**
 * RabbitMQ message routing key.
 *
 * @deprecated Use ATTR_MESSAGING_RABBITMQ_DESTINATION_ROUTING_KEY in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_MESSAGING_RABBITMQ_ROUTING_KEY = TMP_MESSAGING_RABBITMQ_ROUTING_KEY;
/**
 * Message keys in Kafka are used for grouping alike messages to ensure they&#39;re processed on the same partition. They differ from `messaging.message_id` in that they&#39;re not unique. If the key is `null`, the attribute MUST NOT be set.
 *
 * Note: If the key type is not string, it&#39;s string representation has to be supplied for the attribute. If the key has no unambiguous, canonical string form, don&#39;t include its value.
 *
 * @deprecated Use ATTR_MESSAGING_KAFKA_MESSAGE_KEY in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_MESSAGING_KAFKA_MESSAGE_KEY = TMP_MESSAGING_KAFKA_MESSAGE_KEY;
/**
 * Name of the Kafka Consumer Group that is handling the message. Only applies to consumers, not producers.
 *
 * @deprecated Use ATTR_MESSAGING_KAFKA_CONSUMER_GROUP in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_MESSAGING_KAFKA_CONSUMER_GROUP = TMP_MESSAGING_KAFKA_CONSUMER_GROUP;
/**
 * Client Id for the Consumer or Producer that is handling the message.
 *
 * @deprecated Use ATTR_MESSAGING_CLIENT_ID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_MESSAGING_KAFKA_CLIENT_ID = TMP_MESSAGING_KAFKA_CLIENT_ID;
/**
 * Partition the message is sent to.
 *
 * @deprecated Use ATTR_MESSAGING_KAFKA_DESTINATION_PARTITION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_MESSAGING_KAFKA_PARTITION = TMP_MESSAGING_KAFKA_PARTITION;
/**
 * A boolean that is true if the message is a tombstone.
 *
 * @deprecated Use ATTR_MESSAGING_KAFKA_MESSAGE_TOMBSTONE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_MESSAGING_KAFKA_TOMBSTONE = TMP_MESSAGING_KAFKA_TOMBSTONE;
/**
 * A string identifying the remoting system.
 *
 * @deprecated Use ATTR_RPC_SYSTEM in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_RPC_SYSTEM = TMP_RPC_SYSTEM;
/**
 * The full (logical) name of the service being called, including its package name, if applicable.
 *
 * Note: This is the logical name of the service from the RPC interface perspective, which can be different from the name of any implementing class. The `code.namespace` attribute may be used to store the latter (despite the attribute name, it may include a class name; e.g., class with method actually executing the call on the server side, RPC client stub class on the client side).
 *
 * @deprecated Use ATTR_RPC_SERVICE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_RPC_SERVICE = TMP_RPC_SERVICE;
/**
 * The name of the (logical) method being called, must be equal to the $method part in the span name.
 *
 * Note: This is the logical name of the method from the RPC interface perspective, which can be different from the name of any implementing method/function. The `code.function` attribute may be used to store the latter (e.g., method actually executing the call on the server side, RPC client stub method on the client side).
 *
 * @deprecated Use ATTR_RPC_METHOD in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_RPC_METHOD = TMP_RPC_METHOD;
/**
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 *
 * @deprecated Use ATTR_RPC_GRPC_STATUS_CODE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_RPC_GRPC_STATUS_CODE = TMP_RPC_GRPC_STATUS_CODE;
/**
 * Protocol version as in `jsonrpc` property of request/response. Since JSON-RPC 1.0 does not specify this, the value can be omitted.
 *
 * @deprecated Use ATTR_RPC_JSONRPC_VERSION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_RPC_JSONRPC_VERSION = TMP_RPC_JSONRPC_VERSION;
/**
 * `id` property of request or response. Since protocol allows id to be int, string, `null` or missing (for notifications), value is expected to be cast to string for simplicity. Use empty string in case of `null` value. Omit entirely if this is a notification.
 *
 * @deprecated Use ATTR_RPC_JSONRPC_REQUEST_ID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_RPC_JSONRPC_REQUEST_ID = TMP_RPC_JSONRPC_REQUEST_ID;
/**
 * `error.code` property of response if it is an error response.
 *
 * @deprecated Use ATTR_RPC_JSONRPC_ERROR_CODE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_RPC_JSONRPC_ERROR_CODE = TMP_RPC_JSONRPC_ERROR_CODE;
/**
 * `error.message` property of response if it is an error response.
 *
 * @deprecated Use ATTR_RPC_JSONRPC_ERROR_MESSAGE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_RPC_JSONRPC_ERROR_MESSAGE = TMP_RPC_JSONRPC_ERROR_MESSAGE;
/**
 * Whether this is a received or sent message.
 *
 * @deprecated Use ATTR_MESSAGE_TYPE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_MESSAGE_TYPE = TMP_MESSAGE_TYPE;
/**
 * MUST be calculated as two different counters starting from `1` one for sent messages and one for received message.
 *
 * Note: This way we guarantee that the values will be consistent between different implementations.
 *
 * @deprecated Use ATTR_MESSAGE_ID in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_MESSAGE_ID = TMP_MESSAGE_ID;
/**
 * Compressed size of the message in bytes.
 *
 * @deprecated Use ATTR_MESSAGE_COMPRESSED_SIZE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_MESSAGE_COMPRESSED_SIZE = TMP_MESSAGE_COMPRESSED_SIZE;
/**
 * Uncompressed size of the message in bytes.
 *
 * @deprecated Use ATTR_MESSAGE_UNCOMPRESSED_SIZE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var SEMATTRS_MESSAGE_UNCOMPRESSED_SIZE = TMP_MESSAGE_UNCOMPRESSED_SIZE;
/**
 * Create exported Value Map for SemanticAttributes values
 * @deprecated Use the SEMATTRS_XXXXX constants rather than the SemanticAttributes.XXXXX for bundle minification
 */
var SemanticAttributes = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_AWS_LAMBDA_INVOKED_ARN,
    TMP_DB_SYSTEM,
    TMP_DB_CONNECTION_STRING,
    TMP_DB_USER,
    TMP_DB_JDBC_DRIVER_CLASSNAME,
    TMP_DB_NAME,
    TMP_DB_STATEMENT,
    TMP_DB_OPERATION,
    TMP_DB_MSSQL_INSTANCE_NAME,
    TMP_DB_CASSANDRA_KEYSPACE,
    TMP_DB_CASSANDRA_PAGE_SIZE,
    TMP_DB_CASSANDRA_CONSISTENCY_LEVEL,
    TMP_DB_CASSANDRA_TABLE,
    TMP_DB_CASSANDRA_IDEMPOTENCE,
    TMP_DB_CASSANDRA_SPECULATIVE_EXECUTION_COUNT,
    TMP_DB_CASSANDRA_COORDINATOR_ID,
    TMP_DB_CASSANDRA_COORDINATOR_DC,
    TMP_DB_HBASE_NAMESPACE,
    TMP_DB_REDIS_DATABASE_INDEX,
    TMP_DB_MONGODB_COLLECTION,
    TMP_DB_SQL_TABLE,
    TMP_EXCEPTION_TYPE,
    TMP_EXCEPTION_MESSAGE,
    TMP_EXCEPTION_STACKTRACE,
    TMP_EXCEPTION_ESCAPED,
    TMP_FAAS_TRIGGER,
    TMP_FAAS_EXECUTION,
    TMP_FAAS_DOCUMENT_COLLECTION,
    TMP_FAAS_DOCUMENT_OPERATION,
    TMP_FAAS_DOCUMENT_TIME,
    TMP_FAAS_DOCUMENT_NAME,
    TMP_FAAS_TIME,
    TMP_FAAS_CRON,
    TMP_FAAS_COLDSTART,
    TMP_FAAS_INVOKED_NAME,
    TMP_FAAS_INVOKED_PROVIDER,
    TMP_FAAS_INVOKED_REGION,
    TMP_NET_TRANSPORT,
    TMP_NET_PEER_IP,
    TMP_NET_PEER_PORT,
    TMP_NET_PEER_NAME,
    TMP_NET_HOST_IP,
    TMP_NET_HOST_PORT,
    TMP_NET_HOST_NAME,
    TMP_NET_HOST_CONNECTION_TYPE,
    TMP_NET_HOST_CONNECTION_SUBTYPE,
    TMP_NET_HOST_CARRIER_NAME,
    TMP_NET_HOST_CARRIER_MCC,
    TMP_NET_HOST_CARRIER_MNC,
    TMP_NET_HOST_CARRIER_ICC,
    TMP_PEER_SERVICE,
    TMP_ENDUSER_ID,
    TMP_ENDUSER_ROLE,
    TMP_ENDUSER_SCOPE,
    TMP_THREAD_ID,
    TMP_THREAD_NAME,
    TMP_CODE_FUNCTION,
    TMP_CODE_NAMESPACE,
    TMP_CODE_FILEPATH,
    TMP_CODE_LINENO,
    TMP_HTTP_METHOD,
    TMP_HTTP_URL,
    TMP_HTTP_TARGET,
    TMP_HTTP_HOST,
    TMP_HTTP_SCHEME,
    TMP_HTTP_STATUS_CODE,
    TMP_HTTP_FLAVOR,
    TMP_HTTP_USER_AGENT,
    TMP_HTTP_REQUEST_CONTENT_LENGTH,
    TMP_HTTP_REQUEST_CONTENT_LENGTH_UNCOMPRESSED,
    TMP_HTTP_RESPONSE_CONTENT_LENGTH,
    TMP_HTTP_RESPONSE_CONTENT_LENGTH_UNCOMPRESSED,
    TMP_HTTP_SERVER_NAME,
    TMP_HTTP_ROUTE,
    TMP_HTTP_CLIENT_IP,
    TMP_AWS_DYNAMODB_TABLE_NAMES,
    TMP_AWS_DYNAMODB_CONSUMED_CAPACITY,
    TMP_AWS_DYNAMODB_ITEM_COLLECTION_METRICS,
    TMP_AWS_DYNAMODB_PROVISIONED_READ_CAPACITY,
    TMP_AWS_DYNAMODB_PROVISIONED_WRITE_CAPACITY,
    TMP_AWS_DYNAMODB_CONSISTENT_READ,
    TMP_AWS_DYNAMODB_PROJECTION,
    TMP_AWS_DYNAMODB_LIMIT,
    TMP_AWS_DYNAMODB_ATTRIBUTES_TO_GET,
    TMP_AWS_DYNAMODB_INDEX_NAME,
    TMP_AWS_DYNAMODB_SELECT,
    TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEXES,
    TMP_AWS_DYNAMODB_LOCAL_SECONDARY_INDEXES,
    TMP_AWS_DYNAMODB_EXCLUSIVE_START_TABLE,
    TMP_AWS_DYNAMODB_TABLE_COUNT,
    TMP_AWS_DYNAMODB_SCAN_FORWARD,
    TMP_AWS_DYNAMODB_SEGMENT,
    TMP_AWS_DYNAMODB_TOTAL_SEGMENTS,
    TMP_AWS_DYNAMODB_COUNT,
    TMP_AWS_DYNAMODB_SCANNED_COUNT,
    TMP_AWS_DYNAMODB_ATTRIBUTE_DEFINITIONS,
    TMP_AWS_DYNAMODB_GLOBAL_SECONDARY_INDEX_UPDATES,
    TMP_MESSAGING_SYSTEM,
    TMP_MESSAGING_DESTINATION,
    TMP_MESSAGING_DESTINATION_KIND,
    TMP_MESSAGING_TEMP_DESTINATION,
    TMP_MESSAGING_PROTOCOL,
    TMP_MESSAGING_PROTOCOL_VERSION,
    TMP_MESSAGING_URL,
    TMP_MESSAGING_MESSAGE_ID,
    TMP_MESSAGING_CONVERSATION_ID,
    TMP_MESSAGING_MESSAGE_PAYLOAD_SIZE_BYTES,
    TMP_MESSAGING_MESSAGE_PAYLOAD_COMPRESSED_SIZE_BYTES,
    TMP_MESSAGING_OPERATION,
    TMP_MESSAGING_CONSUMER_ID,
    TMP_MESSAGING_RABBITMQ_ROUTING_KEY,
    TMP_MESSAGING_KAFKA_MESSAGE_KEY,
    TMP_MESSAGING_KAFKA_CONSUMER_GROUP,
    TMP_MESSAGING_KAFKA_CLIENT_ID,
    TMP_MESSAGING_KAFKA_PARTITION,
    TMP_MESSAGING_KAFKA_TOMBSTONE,
    TMP_RPC_SYSTEM,
    TMP_RPC_SERVICE,
    TMP_RPC_METHOD,
    TMP_RPC_GRPC_STATUS_CODE,
    TMP_RPC_JSONRPC_VERSION,
    TMP_RPC_JSONRPC_REQUEST_ID,
    TMP_RPC_JSONRPC_ERROR_CODE,
    TMP_RPC_JSONRPC_ERROR_MESSAGE,
    TMP_MESSAGE_TYPE,
    TMP_MESSAGE_ID,
    TMP_MESSAGE_COMPRESSED_SIZE,
    TMP_MESSAGE_UNCOMPRESSED_SIZE,
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for DbSystemValues enum definition
 *
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_DBSYSTEMVALUES_OTHER_SQL = 'other_sql';
var TMP_DBSYSTEMVALUES_MSSQL = 'mssql';
var TMP_DBSYSTEMVALUES_MYSQL = 'mysql';
var TMP_DBSYSTEMVALUES_ORACLE = 'oracle';
var TMP_DBSYSTEMVALUES_DB2 = 'db2';
var TMP_DBSYSTEMVALUES_POSTGRESQL = 'postgresql';
var TMP_DBSYSTEMVALUES_REDSHIFT = 'redshift';
var TMP_DBSYSTEMVALUES_HIVE = 'hive';
var TMP_DBSYSTEMVALUES_CLOUDSCAPE = 'cloudscape';
var TMP_DBSYSTEMVALUES_HSQLDB = 'hsqldb';
var TMP_DBSYSTEMVALUES_PROGRESS = 'progress';
var TMP_DBSYSTEMVALUES_MAXDB = 'maxdb';
var TMP_DBSYSTEMVALUES_HANADB = 'hanadb';
var TMP_DBSYSTEMVALUES_INGRES = 'ingres';
var TMP_DBSYSTEMVALUES_FIRSTSQL = 'firstsql';
var TMP_DBSYSTEMVALUES_EDB = 'edb';
var TMP_DBSYSTEMVALUES_CACHE = 'cache';
var TMP_DBSYSTEMVALUES_ADABAS = 'adabas';
var TMP_DBSYSTEMVALUES_FIREBIRD = 'firebird';
var TMP_DBSYSTEMVALUES_DERBY = 'derby';
var TMP_DBSYSTEMVALUES_FILEMAKER = 'filemaker';
var TMP_DBSYSTEMVALUES_INFORMIX = 'informix';
var TMP_DBSYSTEMVALUES_INSTANTDB = 'instantdb';
var TMP_DBSYSTEMVALUES_INTERBASE = 'interbase';
var TMP_DBSYSTEMVALUES_MARIADB = 'mariadb';
var TMP_DBSYSTEMVALUES_NETEZZA = 'netezza';
var TMP_DBSYSTEMVALUES_PERVASIVE = 'pervasive';
var TMP_DBSYSTEMVALUES_POINTBASE = 'pointbase';
var TMP_DBSYSTEMVALUES_SQLITE = 'sqlite';
var TMP_DBSYSTEMVALUES_SYBASE = 'sybase';
var TMP_DBSYSTEMVALUES_TERADATA = 'teradata';
var TMP_DBSYSTEMVALUES_VERTICA = 'vertica';
var TMP_DBSYSTEMVALUES_H2 = 'h2';
var TMP_DBSYSTEMVALUES_COLDFUSION = 'coldfusion';
var TMP_DBSYSTEMVALUES_CASSANDRA = 'cassandra';
var TMP_DBSYSTEMVALUES_HBASE = 'hbase';
var TMP_DBSYSTEMVALUES_MONGODB = 'mongodb';
var TMP_DBSYSTEMVALUES_REDIS = 'redis';
var TMP_DBSYSTEMVALUES_COUCHBASE = 'couchbase';
var TMP_DBSYSTEMVALUES_COUCHDB = 'couchdb';
var TMP_DBSYSTEMVALUES_COSMOSDB = 'cosmosdb';
var TMP_DBSYSTEMVALUES_DYNAMODB = 'dynamodb';
var TMP_DBSYSTEMVALUES_NEO4J = 'neo4j';
var TMP_DBSYSTEMVALUES_GEODE = 'geode';
var TMP_DBSYSTEMVALUES_ELASTICSEARCH = 'elasticsearch';
var TMP_DBSYSTEMVALUES_MEMCACHED = 'memcached';
var TMP_DBSYSTEMVALUES_COCKROACHDB = 'cockroachdb';
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_OTHER_SQL in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_OTHER_SQL = TMP_DBSYSTEMVALUES_OTHER_SQL;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_MSSQL in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_MSSQL = TMP_DBSYSTEMVALUES_MSSQL;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_MYSQL in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_MYSQL = TMP_DBSYSTEMVALUES_MYSQL;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_ORACLE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_ORACLE = TMP_DBSYSTEMVALUES_ORACLE;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_DB2 in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_DB2 = TMP_DBSYSTEMVALUES_DB2;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_POSTGRESQL in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_POSTGRESQL = TMP_DBSYSTEMVALUES_POSTGRESQL;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_REDSHIFT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_REDSHIFT = TMP_DBSYSTEMVALUES_REDSHIFT;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_HIVE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_HIVE = TMP_DBSYSTEMVALUES_HIVE;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_CLOUDSCAPE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_CLOUDSCAPE = TMP_DBSYSTEMVALUES_CLOUDSCAPE;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_HSQLDB in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_HSQLDB = TMP_DBSYSTEMVALUES_HSQLDB;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_PROGRESS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_PROGRESS = TMP_DBSYSTEMVALUES_PROGRESS;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_MAXDB in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_MAXDB = TMP_DBSYSTEMVALUES_MAXDB;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_HANADB in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_HANADB = TMP_DBSYSTEMVALUES_HANADB;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_INGRES in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_INGRES = TMP_DBSYSTEMVALUES_INGRES;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_FIRSTSQL in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_FIRSTSQL = TMP_DBSYSTEMVALUES_FIRSTSQL;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_EDB in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_EDB = TMP_DBSYSTEMVALUES_EDB;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_CACHE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_CACHE = TMP_DBSYSTEMVALUES_CACHE;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_ADABAS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_ADABAS = TMP_DBSYSTEMVALUES_ADABAS;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_FIREBIRD in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_FIREBIRD = TMP_DBSYSTEMVALUES_FIREBIRD;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_DERBY in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_DERBY = TMP_DBSYSTEMVALUES_DERBY;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_FILEMAKER in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_FILEMAKER = TMP_DBSYSTEMVALUES_FILEMAKER;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_INFORMIX in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_INFORMIX = TMP_DBSYSTEMVALUES_INFORMIX;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_INSTANTDB in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_INSTANTDB = TMP_DBSYSTEMVALUES_INSTANTDB;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_INTERBASE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_INTERBASE = TMP_DBSYSTEMVALUES_INTERBASE;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_MARIADB in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_MARIADB = TMP_DBSYSTEMVALUES_MARIADB;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_NETEZZA in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_NETEZZA = TMP_DBSYSTEMVALUES_NETEZZA;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_PERVASIVE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_PERVASIVE = TMP_DBSYSTEMVALUES_PERVASIVE;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_POINTBASE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_POINTBASE = TMP_DBSYSTEMVALUES_POINTBASE;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_SQLITE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_SQLITE = TMP_DBSYSTEMVALUES_SQLITE;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_SYBASE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_SYBASE = TMP_DBSYSTEMVALUES_SYBASE;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_TERADATA in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_TERADATA = TMP_DBSYSTEMVALUES_TERADATA;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_VERTICA in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_VERTICA = TMP_DBSYSTEMVALUES_VERTICA;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_H2 in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_H2 = TMP_DBSYSTEMVALUES_H2;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_COLDFUSION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_COLDFUSION = TMP_DBSYSTEMVALUES_COLDFUSION;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_CASSANDRA in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_CASSANDRA = TMP_DBSYSTEMVALUES_CASSANDRA;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_HBASE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_HBASE = TMP_DBSYSTEMVALUES_HBASE;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_MONGODB in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_MONGODB = TMP_DBSYSTEMVALUES_MONGODB;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_REDIS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_REDIS = TMP_DBSYSTEMVALUES_REDIS;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_COUCHBASE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_COUCHBASE = TMP_DBSYSTEMVALUES_COUCHBASE;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_COUCHDB in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_COUCHDB = TMP_DBSYSTEMVALUES_COUCHDB;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_COSMOSDB in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_COSMOSDB = TMP_DBSYSTEMVALUES_COSMOSDB;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_DYNAMODB in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_DYNAMODB = TMP_DBSYSTEMVALUES_DYNAMODB;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_NEO4J in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_NEO4J = TMP_DBSYSTEMVALUES_NEO4J;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_GEODE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_GEODE = TMP_DBSYSTEMVALUES_GEODE;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_ELASTICSEARCH in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_ELASTICSEARCH = TMP_DBSYSTEMVALUES_ELASTICSEARCH;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_MEMCACHED in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_MEMCACHED = TMP_DBSYSTEMVALUES_MEMCACHED;
/**
 * An identifier for the database management system (DBMS) product being used. See below for a list of well-known identifiers.
 *
 * @deprecated Use DB_SYSTEM_VALUE_COCKROACHDB in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBSYSTEMVALUES_COCKROACHDB = TMP_DBSYSTEMVALUES_COCKROACHDB;
/**
 * The constant map of values for DbSystemValues.
 * @deprecated Use the DBSYSTEMVALUES_XXXXX constants rather than the DbSystemValues.XXXXX for bundle minification.
 */
var DbSystemValues = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_DBSYSTEMVALUES_OTHER_SQL,
    TMP_DBSYSTEMVALUES_MSSQL,
    TMP_DBSYSTEMVALUES_MYSQL,
    TMP_DBSYSTEMVALUES_ORACLE,
    TMP_DBSYSTEMVALUES_DB2,
    TMP_DBSYSTEMVALUES_POSTGRESQL,
    TMP_DBSYSTEMVALUES_REDSHIFT,
    TMP_DBSYSTEMVALUES_HIVE,
    TMP_DBSYSTEMVALUES_CLOUDSCAPE,
    TMP_DBSYSTEMVALUES_HSQLDB,
    TMP_DBSYSTEMVALUES_PROGRESS,
    TMP_DBSYSTEMVALUES_MAXDB,
    TMP_DBSYSTEMVALUES_HANADB,
    TMP_DBSYSTEMVALUES_INGRES,
    TMP_DBSYSTEMVALUES_FIRSTSQL,
    TMP_DBSYSTEMVALUES_EDB,
    TMP_DBSYSTEMVALUES_CACHE,
    TMP_DBSYSTEMVALUES_ADABAS,
    TMP_DBSYSTEMVALUES_FIREBIRD,
    TMP_DBSYSTEMVALUES_DERBY,
    TMP_DBSYSTEMVALUES_FILEMAKER,
    TMP_DBSYSTEMVALUES_INFORMIX,
    TMP_DBSYSTEMVALUES_INSTANTDB,
    TMP_DBSYSTEMVALUES_INTERBASE,
    TMP_DBSYSTEMVALUES_MARIADB,
    TMP_DBSYSTEMVALUES_NETEZZA,
    TMP_DBSYSTEMVALUES_PERVASIVE,
    TMP_DBSYSTEMVALUES_POINTBASE,
    TMP_DBSYSTEMVALUES_SQLITE,
    TMP_DBSYSTEMVALUES_SYBASE,
    TMP_DBSYSTEMVALUES_TERADATA,
    TMP_DBSYSTEMVALUES_VERTICA,
    TMP_DBSYSTEMVALUES_H2,
    TMP_DBSYSTEMVALUES_COLDFUSION,
    TMP_DBSYSTEMVALUES_CASSANDRA,
    TMP_DBSYSTEMVALUES_HBASE,
    TMP_DBSYSTEMVALUES_MONGODB,
    TMP_DBSYSTEMVALUES_REDIS,
    TMP_DBSYSTEMVALUES_COUCHBASE,
    TMP_DBSYSTEMVALUES_COUCHDB,
    TMP_DBSYSTEMVALUES_COSMOSDB,
    TMP_DBSYSTEMVALUES_DYNAMODB,
    TMP_DBSYSTEMVALUES_NEO4J,
    TMP_DBSYSTEMVALUES_GEODE,
    TMP_DBSYSTEMVALUES_ELASTICSEARCH,
    TMP_DBSYSTEMVALUES_MEMCACHED,
    TMP_DBSYSTEMVALUES_COCKROACHDB,
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for DbCassandraConsistencyLevelValues enum definition
 *
 * The consistency level of the query. Based on consistency values from [CQL](https://docs.datastax.com/en/cassandra-oss/3.0/cassandra/dml/dmlConfigConsistency.html).
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL = 'all';
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM = 'each_quorum';
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM = 'quorum';
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM = 'local_quorum';
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE = 'one';
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO = 'two';
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE = 'three';
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE = 'local_one';
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY = 'any';
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL = 'serial';
var TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL = 'local_serial';
/**
 * The consistency level of the query. Based on consistency values from [CQL](https://docs.datastax.com/en/cassandra-oss/3.0/cassandra/dml/dmlConfigConsistency.html).
 *
 * @deprecated Use DB_CASSANDRA_CONSISTENCY_LEVEL_VALUE_ALL in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBCASSANDRACONSISTENCYLEVELVALUES_ALL = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL;
/**
 * The consistency level of the query. Based on consistency values from [CQL](https://docs.datastax.com/en/cassandra-oss/3.0/cassandra/dml/dmlConfigConsistency.html).
 *
 * @deprecated Use DB_CASSANDRA_CONSISTENCY_LEVEL_VALUE_EACH_QUORUM in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM;
/**
 * The consistency level of the query. Based on consistency values from [CQL](https://docs.datastax.com/en/cassandra-oss/3.0/cassandra/dml/dmlConfigConsistency.html).
 *
 * @deprecated Use DB_CASSANDRA_CONSISTENCY_LEVEL_VALUE_QUORUM in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM;
/**
 * The consistency level of the query. Based on consistency values from [CQL](https://docs.datastax.com/en/cassandra-oss/3.0/cassandra/dml/dmlConfigConsistency.html).
 *
 * @deprecated Use DB_CASSANDRA_CONSISTENCY_LEVEL_VALUE_LOCAL_QUORUM in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM;
/**
 * The consistency level of the query. Based on consistency values from [CQL](https://docs.datastax.com/en/cassandra-oss/3.0/cassandra/dml/dmlConfigConsistency.html).
 *
 * @deprecated Use DB_CASSANDRA_CONSISTENCY_LEVEL_VALUE_ONE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBCASSANDRACONSISTENCYLEVELVALUES_ONE = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE;
/**
 * The consistency level of the query. Based on consistency values from [CQL](https://docs.datastax.com/en/cassandra-oss/3.0/cassandra/dml/dmlConfigConsistency.html).
 *
 * @deprecated Use DB_CASSANDRA_CONSISTENCY_LEVEL_VALUE_TWO in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBCASSANDRACONSISTENCYLEVELVALUES_TWO = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO;
/**
 * The consistency level of the query. Based on consistency values from [CQL](https://docs.datastax.com/en/cassandra-oss/3.0/cassandra/dml/dmlConfigConsistency.html).
 *
 * @deprecated Use DB_CASSANDRA_CONSISTENCY_LEVEL_VALUE_THREE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBCASSANDRACONSISTENCYLEVELVALUES_THREE = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE;
/**
 * The consistency level of the query. Based on consistency values from [CQL](https://docs.datastax.com/en/cassandra-oss/3.0/cassandra/dml/dmlConfigConsistency.html).
 *
 * @deprecated Use DB_CASSANDRA_CONSISTENCY_LEVEL_VALUE_LOCAL_ONE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE;
/**
 * The consistency level of the query. Based on consistency values from [CQL](https://docs.datastax.com/en/cassandra-oss/3.0/cassandra/dml/dmlConfigConsistency.html).
 *
 * @deprecated Use DB_CASSANDRA_CONSISTENCY_LEVEL_VALUE_ANY in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBCASSANDRACONSISTENCYLEVELVALUES_ANY = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY;
/**
 * The consistency level of the query. Based on consistency values from [CQL](https://docs.datastax.com/en/cassandra-oss/3.0/cassandra/dml/dmlConfigConsistency.html).
 *
 * @deprecated Use DB_CASSANDRA_CONSISTENCY_LEVEL_VALUE_SERIAL in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL;
/**
 * The consistency level of the query. Based on consistency values from [CQL](https://docs.datastax.com/en/cassandra-oss/3.0/cassandra/dml/dmlConfigConsistency.html).
 *
 * @deprecated Use DB_CASSANDRA_CONSISTENCY_LEVEL_VALUE_LOCAL_SERIAL in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL = TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL;
/**
 * The constant map of values for DbCassandraConsistencyLevelValues.
 * @deprecated Use the DBCASSANDRACONSISTENCYLEVELVALUES_XXXXX constants rather than the DbCassandraConsistencyLevelValues.XXXXX for bundle minification.
 */
var DbCassandraConsistencyLevelValues = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ALL,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_EACH_QUORUM,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_QUORUM,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_QUORUM,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ONE,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_TWO,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_THREE,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_ONE,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_ANY,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_SERIAL,
    TMP_DBCASSANDRACONSISTENCYLEVELVALUES_LOCAL_SERIAL,
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for FaasTriggerValues enum definition
 *
 * Type of the trigger on which the function is executed.
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_FAASTRIGGERVALUES_DATASOURCE = 'datasource';
var TMP_FAASTRIGGERVALUES_HTTP = 'http';
var TMP_FAASTRIGGERVALUES_PUBSUB = 'pubsub';
var TMP_FAASTRIGGERVALUES_TIMER = 'timer';
var TMP_FAASTRIGGERVALUES_OTHER = 'other';
/**
 * Type of the trigger on which the function is executed.
 *
 * @deprecated Use FAAS_TRIGGER_VALUE_DATASOURCE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var FAASTRIGGERVALUES_DATASOURCE = TMP_FAASTRIGGERVALUES_DATASOURCE;
/**
 * Type of the trigger on which the function is executed.
 *
 * @deprecated Use FAAS_TRIGGER_VALUE_HTTP in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var FAASTRIGGERVALUES_HTTP = TMP_FAASTRIGGERVALUES_HTTP;
/**
 * Type of the trigger on which the function is executed.
 *
 * @deprecated Use FAAS_TRIGGER_VALUE_PUBSUB in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var FAASTRIGGERVALUES_PUBSUB = TMP_FAASTRIGGERVALUES_PUBSUB;
/**
 * Type of the trigger on which the function is executed.
 *
 * @deprecated Use FAAS_TRIGGER_VALUE_TIMER in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var FAASTRIGGERVALUES_TIMER = TMP_FAASTRIGGERVALUES_TIMER;
/**
 * Type of the trigger on which the function is executed.
 *
 * @deprecated Use FAAS_TRIGGER_VALUE_OTHER in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var FAASTRIGGERVALUES_OTHER = TMP_FAASTRIGGERVALUES_OTHER;
/**
 * The constant map of values for FaasTriggerValues.
 * @deprecated Use the FAASTRIGGERVALUES_XXXXX constants rather than the FaasTriggerValues.XXXXX for bundle minification.
 */
var FaasTriggerValues = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_FAASTRIGGERVALUES_DATASOURCE,
    TMP_FAASTRIGGERVALUES_HTTP,
    TMP_FAASTRIGGERVALUES_PUBSUB,
    TMP_FAASTRIGGERVALUES_TIMER,
    TMP_FAASTRIGGERVALUES_OTHER,
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for FaasDocumentOperationValues enum definition
 *
 * Describes the type of the operation that was performed on the data.
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_FAASDOCUMENTOPERATIONVALUES_INSERT = 'insert';
var TMP_FAASDOCUMENTOPERATIONVALUES_EDIT = 'edit';
var TMP_FAASDOCUMENTOPERATIONVALUES_DELETE = 'delete';
/**
 * Describes the type of the operation that was performed on the data.
 *
 * @deprecated Use FAAS_DOCUMENT_OPERATION_VALUE_INSERT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var FAASDOCUMENTOPERATIONVALUES_INSERT = TMP_FAASDOCUMENTOPERATIONVALUES_INSERT;
/**
 * Describes the type of the operation that was performed on the data.
 *
 * @deprecated Use FAAS_DOCUMENT_OPERATION_VALUE_EDIT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var FAASDOCUMENTOPERATIONVALUES_EDIT = TMP_FAASDOCUMENTOPERATIONVALUES_EDIT;
/**
 * Describes the type of the operation that was performed on the data.
 *
 * @deprecated Use FAAS_DOCUMENT_OPERATION_VALUE_DELETE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var FAASDOCUMENTOPERATIONVALUES_DELETE = TMP_FAASDOCUMENTOPERATIONVALUES_DELETE;
/**
 * The constant map of values for FaasDocumentOperationValues.
 * @deprecated Use the FAASDOCUMENTOPERATIONVALUES_XXXXX constants rather than the FaasDocumentOperationValues.XXXXX for bundle minification.
 */
var FaasDocumentOperationValues = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_FAASDOCUMENTOPERATIONVALUES_INSERT,
    TMP_FAASDOCUMENTOPERATIONVALUES_EDIT,
    TMP_FAASDOCUMENTOPERATIONVALUES_DELETE,
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for FaasInvokedProviderValues enum definition
 *
 * The cloud provider of the invoked function.
 *
 * Note: SHOULD be equal to the `cloud.provider` resource attribute of the invoked function.
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD = 'alibaba_cloud';
var TMP_FAASINVOKEDPROVIDERVALUES_AWS = 'aws';
var TMP_FAASINVOKEDPROVIDERVALUES_AZURE = 'azure';
var TMP_FAASINVOKEDPROVIDERVALUES_GCP = 'gcp';
/**
 * The cloud provider of the invoked function.
 *
 * Note: SHOULD be equal to the `cloud.provider` resource attribute of the invoked function.
 *
 * @deprecated Use FAAS_INVOKED_PROVIDER_VALUE_ALIBABA_CLOUD in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD = TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD;
/**
 * The cloud provider of the invoked function.
 *
 * Note: SHOULD be equal to the `cloud.provider` resource attribute of the invoked function.
 *
 * @deprecated Use FAAS_INVOKED_PROVIDER_VALUE_AWS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var FAASINVOKEDPROVIDERVALUES_AWS = TMP_FAASINVOKEDPROVIDERVALUES_AWS;
/**
 * The cloud provider of the invoked function.
 *
 * Note: SHOULD be equal to the `cloud.provider` resource attribute of the invoked function.
 *
 * @deprecated Use FAAS_INVOKED_PROVIDER_VALUE_AZURE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var FAASINVOKEDPROVIDERVALUES_AZURE = TMP_FAASINVOKEDPROVIDERVALUES_AZURE;
/**
 * The cloud provider of the invoked function.
 *
 * Note: SHOULD be equal to the `cloud.provider` resource attribute of the invoked function.
 *
 * @deprecated Use FAAS_INVOKED_PROVIDER_VALUE_GCP in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var FAASINVOKEDPROVIDERVALUES_GCP = TMP_FAASINVOKEDPROVIDERVALUES_GCP;
/**
 * The constant map of values for FaasInvokedProviderValues.
 * @deprecated Use the FAASINVOKEDPROVIDERVALUES_XXXXX constants rather than the FaasInvokedProviderValues.XXXXX for bundle minification.
 */
var FaasInvokedProviderValues = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_FAASINVOKEDPROVIDERVALUES_ALIBABA_CLOUD,
    TMP_FAASINVOKEDPROVIDERVALUES_AWS,
    TMP_FAASINVOKEDPROVIDERVALUES_AZURE,
    TMP_FAASINVOKEDPROVIDERVALUES_GCP,
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for NetTransportValues enum definition
 *
 * Transport protocol used. See note below.
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_NETTRANSPORTVALUES_IP_TCP = 'ip_tcp';
var TMP_NETTRANSPORTVALUES_IP_UDP = 'ip_udp';
var TMP_NETTRANSPORTVALUES_IP = 'ip';
var TMP_NETTRANSPORTVALUES_UNIX = 'unix';
var TMP_NETTRANSPORTVALUES_PIPE = 'pipe';
var TMP_NETTRANSPORTVALUES_INPROC = 'inproc';
var TMP_NETTRANSPORTVALUES_OTHER = 'other';
/**
 * Transport protocol used. See note below.
 *
 * @deprecated Use NET_TRANSPORT_VALUE_IP_TCP in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETTRANSPORTVALUES_IP_TCP = TMP_NETTRANSPORTVALUES_IP_TCP;
/**
 * Transport protocol used. See note below.
 *
 * @deprecated Use NET_TRANSPORT_VALUE_IP_UDP in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETTRANSPORTVALUES_IP_UDP = TMP_NETTRANSPORTVALUES_IP_UDP;
/**
 * Transport protocol used. See note below.
 *
 * @deprecated Removed in v1.21.0.
 */
var NETTRANSPORTVALUES_IP = TMP_NETTRANSPORTVALUES_IP;
/**
 * Transport protocol used. See note below.
 *
 * @deprecated Removed in v1.21.0.
 */
var NETTRANSPORTVALUES_UNIX = TMP_NETTRANSPORTVALUES_UNIX;
/**
 * Transport protocol used. See note below.
 *
 * @deprecated Use NET_TRANSPORT_VALUE_PIPE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETTRANSPORTVALUES_PIPE = TMP_NETTRANSPORTVALUES_PIPE;
/**
 * Transport protocol used. See note below.
 *
 * @deprecated Use NET_TRANSPORT_VALUE_INPROC in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETTRANSPORTVALUES_INPROC = TMP_NETTRANSPORTVALUES_INPROC;
/**
 * Transport protocol used. See note below.
 *
 * @deprecated Use NET_TRANSPORT_VALUE_OTHER in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETTRANSPORTVALUES_OTHER = TMP_NETTRANSPORTVALUES_OTHER;
/**
 * The constant map of values for NetTransportValues.
 * @deprecated Use the NETTRANSPORTVALUES_XXXXX constants rather than the NetTransportValues.XXXXX for bundle minification.
 */
var NetTransportValues = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_NETTRANSPORTVALUES_IP_TCP,
    TMP_NETTRANSPORTVALUES_IP_UDP,
    TMP_NETTRANSPORTVALUES_IP,
    TMP_NETTRANSPORTVALUES_UNIX,
    TMP_NETTRANSPORTVALUES_PIPE,
    TMP_NETTRANSPORTVALUES_INPROC,
    TMP_NETTRANSPORTVALUES_OTHER,
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for NetHostConnectionTypeValues enum definition
 *
 * The internet connection type currently being used by the host.
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI = 'wifi';
var TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED = 'wired';
var TMP_NETHOSTCONNECTIONTYPEVALUES_CELL = 'cell';
var TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE = 'unavailable';
var TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN = 'unknown';
/**
 * The internet connection type currently being used by the host.
 *
 * @deprecated Use NETWORK_CONNECTION_TYPE_VALUE_WIFI in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONTYPEVALUES_WIFI = TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI;
/**
 * The internet connection type currently being used by the host.
 *
 * @deprecated Use NETWORK_CONNECTION_TYPE_VALUE_WIRED in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONTYPEVALUES_WIRED = TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED;
/**
 * The internet connection type currently being used by the host.
 *
 * @deprecated Use NETWORK_CONNECTION_TYPE_VALUE_CELL in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONTYPEVALUES_CELL = TMP_NETHOSTCONNECTIONTYPEVALUES_CELL;
/**
 * The internet connection type currently being used by the host.
 *
 * @deprecated Use NETWORK_CONNECTION_TYPE_VALUE_UNAVAILABLE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE = TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE;
/**
 * The internet connection type currently being used by the host.
 *
 * @deprecated Use NETWORK_CONNECTION_TYPE_VALUE_UNKNOWN in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONTYPEVALUES_UNKNOWN = TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN;
/**
 * The constant map of values for NetHostConnectionTypeValues.
 * @deprecated Use the NETHOSTCONNECTIONTYPEVALUES_XXXXX constants rather than the NetHostConnectionTypeValues.XXXXX for bundle minification.
 */
var NetHostConnectionTypeValues = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_NETHOSTCONNECTIONTYPEVALUES_WIFI,
    TMP_NETHOSTCONNECTIONTYPEVALUES_WIRED,
    TMP_NETHOSTCONNECTIONTYPEVALUES_CELL,
    TMP_NETHOSTCONNECTIONTYPEVALUES_UNAVAILABLE,
    TMP_NETHOSTCONNECTIONTYPEVALUES_UNKNOWN,
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for NetHostConnectionSubtypeValues enum definition
 *
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS = 'gprs';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE = 'edge';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS = 'umts';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA = 'cdma';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0 = 'evdo_0';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A = 'evdo_a';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT = 'cdma2000_1xrtt';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA = 'hsdpa';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA = 'hsupa';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA = 'hspa';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN = 'iden';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B = 'evdo_b';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE = 'lte';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD = 'ehrpd';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP = 'hspap';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM = 'gsm';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA = 'td_scdma';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN = 'iwlan';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR = 'nr';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA = 'nrnsa';
var TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA = 'lte_ca';
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_GPRS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_GPRS = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_EDGE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_EDGE = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_UMTS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_UMTS = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_CDMA in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_CDMA = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_EVDO_0 in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0 = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_EVDO_A in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_CDMA2000_1XRTT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_HSDPA in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_HSUPA in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_HSPA in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_HSPA = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_IDEN in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_IDEN = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_EVDO_B in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_LTE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_LTE = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_EHRPD in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_HSPAP in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_GSM in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_GSM = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_TD_SCDMA in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_IWLAN in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_NR in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_NR = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_NRNSA in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA;
/**
 * This describes more details regarding the connection.type. It may be the type of cell technology connection, but it could be used for describing details about a wifi connection.
 *
 * @deprecated Use NETWORK_CONNECTION_SUBTYPE_VALUE_LTE_CA in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA = TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA;
/**
 * The constant map of values for NetHostConnectionSubtypeValues.
 * @deprecated Use the NETHOSTCONNECTIONSUBTYPEVALUES_XXXXX constants rather than the NetHostConnectionSubtypeValues.XXXXX for bundle minification.
 */
var NetHostConnectionSubtypeValues = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GPRS,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EDGE,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_UMTS,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_0,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_A,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_CDMA2000_1XRTT,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSDPA,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSUPA,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPA,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IDEN,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EVDO_B,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_EHRPD,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_HSPAP,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_GSM,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_TD_SCDMA,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_IWLAN,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NR,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_NRNSA,
    TMP_NETHOSTCONNECTIONSUBTYPEVALUES_LTE_CA,
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for HttpFlavorValues enum definition
 *
 * Kind of HTTP protocol used.
 *
 * Note: If `net.transport` is not specified, it can be assumed to be `IP.TCP` except if `http.flavor` is `QUIC`, in which case `IP.UDP` is assumed.
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_HTTPFLAVORVALUES_HTTP_1_0 = '1.0';
var TMP_HTTPFLAVORVALUES_HTTP_1_1 = '1.1';
var TMP_HTTPFLAVORVALUES_HTTP_2_0 = '2.0';
var TMP_HTTPFLAVORVALUES_SPDY = 'SPDY';
var TMP_HTTPFLAVORVALUES_QUIC = 'QUIC';
/**
 * Kind of HTTP protocol used.
 *
 * Note: If `net.transport` is not specified, it can be assumed to be `IP.TCP` except if `http.flavor` is `QUIC`, in which case `IP.UDP` is assumed.
 *
 * @deprecated Use HTTP_FLAVOR_VALUE_HTTP_1_0 in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var HTTPFLAVORVALUES_HTTP_1_0 = TMP_HTTPFLAVORVALUES_HTTP_1_0;
/**
 * Kind of HTTP protocol used.
 *
 * Note: If `net.transport` is not specified, it can be assumed to be `IP.TCP` except if `http.flavor` is `QUIC`, in which case `IP.UDP` is assumed.
 *
 * @deprecated Use HTTP_FLAVOR_VALUE_HTTP_1_1 in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var HTTPFLAVORVALUES_HTTP_1_1 = TMP_HTTPFLAVORVALUES_HTTP_1_1;
/**
 * Kind of HTTP protocol used.
 *
 * Note: If `net.transport` is not specified, it can be assumed to be `IP.TCP` except if `http.flavor` is `QUIC`, in which case `IP.UDP` is assumed.
 *
 * @deprecated Use HTTP_FLAVOR_VALUE_HTTP_2_0 in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var HTTPFLAVORVALUES_HTTP_2_0 = TMP_HTTPFLAVORVALUES_HTTP_2_0;
/**
 * Kind of HTTP protocol used.
 *
 * Note: If `net.transport` is not specified, it can be assumed to be `IP.TCP` except if `http.flavor` is `QUIC`, in which case `IP.UDP` is assumed.
 *
 * @deprecated Use HTTP_FLAVOR_VALUE_SPDY in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var HTTPFLAVORVALUES_SPDY = TMP_HTTPFLAVORVALUES_SPDY;
/**
 * Kind of HTTP protocol used.
 *
 * Note: If `net.transport` is not specified, it can be assumed to be `IP.TCP` except if `http.flavor` is `QUIC`, in which case `IP.UDP` is assumed.
 *
 * @deprecated Use HTTP_FLAVOR_VALUE_QUIC in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var HTTPFLAVORVALUES_QUIC = TMP_HTTPFLAVORVALUES_QUIC;
/**
 * The constant map of values for HttpFlavorValues.
 * @deprecated Use the HTTPFLAVORVALUES_XXXXX constants rather than the HttpFlavorValues.XXXXX for bundle minification.
 */
var HttpFlavorValues = {
    HTTP_1_0: TMP_HTTPFLAVORVALUES_HTTP_1_0,
    HTTP_1_1: TMP_HTTPFLAVORVALUES_HTTP_1_1,
    HTTP_2_0: TMP_HTTPFLAVORVALUES_HTTP_2_0,
    SPDY: TMP_HTTPFLAVORVALUES_SPDY,
    QUIC: TMP_HTTPFLAVORVALUES_QUIC,
};
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for MessagingDestinationKindValues enum definition
 *
 * The kind of message destination.
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE = 'queue';
var TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC = 'topic';
/**
 * The kind of message destination.
 *
 * @deprecated Removed in semconv v1.20.0.
 */
var MESSAGINGDESTINATIONKINDVALUES_QUEUE = TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE;
/**
 * The kind of message destination.
 *
 * @deprecated Removed in semconv v1.20.0.
 */
var MESSAGINGDESTINATIONKINDVALUES_TOPIC = TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC;
/**
 * The constant map of values for MessagingDestinationKindValues.
 * @deprecated Use the MESSAGINGDESTINATIONKINDVALUES_XXXXX constants rather than the MessagingDestinationKindValues.XXXXX for bundle minification.
 */
var MessagingDestinationKindValues = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_MESSAGINGDESTINATIONKINDVALUES_QUEUE,
    TMP_MESSAGINGDESTINATIONKINDVALUES_TOPIC,
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for MessagingOperationValues enum definition
 *
 * A string identifying the kind of message consumption as defined in the [Operation names](#operation-names) section above. If the operation is &#34;send&#34;, this attribute MUST NOT be set, since the operation can be inferred from the span kind in that case.
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_MESSAGINGOPERATIONVALUES_RECEIVE = 'receive';
var TMP_MESSAGINGOPERATIONVALUES_PROCESS = 'process';
/**
 * A string identifying the kind of message consumption as defined in the [Operation names](#operation-names) section above. If the operation is &#34;send&#34;, this attribute MUST NOT be set, since the operation can be inferred from the span kind in that case.
 *
 * @deprecated Use MESSAGING_OPERATION_TYPE_VALUE_RECEIVE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var MESSAGINGOPERATIONVALUES_RECEIVE = TMP_MESSAGINGOPERATIONVALUES_RECEIVE;
/**
 * A string identifying the kind of message consumption as defined in the [Operation names](#operation-names) section above. If the operation is &#34;send&#34;, this attribute MUST NOT be set, since the operation can be inferred from the span kind in that case.
 *
 * @deprecated Use MESSAGING_OPERATION_TYPE_VALUE_PROCESS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var MESSAGINGOPERATIONVALUES_PROCESS = TMP_MESSAGINGOPERATIONVALUES_PROCESS;
/**
 * The constant map of values for MessagingOperationValues.
 * @deprecated Use the MESSAGINGOPERATIONVALUES_XXXXX constants rather than the MessagingOperationValues.XXXXX for bundle minification.
 */
var MessagingOperationValues = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_MESSAGINGOPERATIONVALUES_RECEIVE,
    TMP_MESSAGINGOPERATIONVALUES_PROCESS,
]);
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for RpcGrpcStatusCodeValues enum definition
 *
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_RPCGRPCSTATUSCODEVALUES_OK = 0;
var TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED = 1;
var TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN = 2;
var TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT = 3;
var TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED = 4;
var TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND = 5;
var TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS = 6;
var TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED = 7;
var TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED = 8;
var TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION = 9;
var TMP_RPCGRPCSTATUSCODEVALUES_ABORTED = 10;
var TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE = 11;
var TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED = 12;
var TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL = 13;
var TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE = 14;
var TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS = 15;
var TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED = 16;
/**
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 *
 * @deprecated Use RPC_GRPC_STATUS_CODE_VALUE_OK in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var RPCGRPCSTATUSCODEVALUES_OK = TMP_RPCGRPCSTATUSCODEVALUES_OK;
/**
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 *
 * @deprecated Use RPC_GRPC_STATUS_CODE_VALUE_CANCELLED in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var RPCGRPCSTATUSCODEVALUES_CANCELLED = TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED;
/**
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 *
 * @deprecated Use RPC_GRPC_STATUS_CODE_VALUE_UNKNOWN in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var RPCGRPCSTATUSCODEVALUES_UNKNOWN = TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN;
/**
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 *
 * @deprecated Use RPC_GRPC_STATUS_CODE_VALUE_INVALID_ARGUMENT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT = TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT;
/**
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 *
 * @deprecated Use RPC_GRPC_STATUS_CODE_VALUE_DEADLINE_EXCEEDED in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED = TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED;
/**
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 *
 * @deprecated Use RPC_GRPC_STATUS_CODE_VALUE_NOT_FOUND in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var RPCGRPCSTATUSCODEVALUES_NOT_FOUND = TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND;
/**
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 *
 * @deprecated Use RPC_GRPC_STATUS_CODE_VALUE_ALREADY_EXISTS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS = TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS;
/**
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 *
 * @deprecated Use RPC_GRPC_STATUS_CODE_VALUE_PERMISSION_DENIED in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED = TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED;
/**
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 *
 * @deprecated Use RPC_GRPC_STATUS_CODE_VALUE_RESOURCE_EXHAUSTED in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED = TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED;
/**
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 *
 * @deprecated Use RPC_GRPC_STATUS_CODE_VALUE_FAILED_PRECONDITION in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION = TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION;
/**
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 *
 * @deprecated Use RPC_GRPC_STATUS_CODE_VALUE_ABORTED in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var RPCGRPCSTATUSCODEVALUES_ABORTED = TMP_RPCGRPCSTATUSCODEVALUES_ABORTED;
/**
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 *
 * @deprecated Use RPC_GRPC_STATUS_CODE_VALUE_OUT_OF_RANGE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE = TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE;
/**
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 *
 * @deprecated Use RPC_GRPC_STATUS_CODE_VALUE_UNIMPLEMENTED in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED = TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED;
/**
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 *
 * @deprecated Use RPC_GRPC_STATUS_CODE_VALUE_INTERNAL in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var RPCGRPCSTATUSCODEVALUES_INTERNAL = TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL;
/**
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 *
 * @deprecated Use RPC_GRPC_STATUS_CODE_VALUE_UNAVAILABLE in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var RPCGRPCSTATUSCODEVALUES_UNAVAILABLE = TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE;
/**
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 *
 * @deprecated Use RPC_GRPC_STATUS_CODE_VALUE_DATA_LOSS in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var RPCGRPCSTATUSCODEVALUES_DATA_LOSS = TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS;
/**
 * The [numeric status code](https://github.com/grpc/grpc/blob/v1.33.2/doc/statuscodes.md) of the gRPC request.
 *
 * @deprecated Use RPC_GRPC_STATUS_CODE_VALUE_UNAUTHENTICATED in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED = TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED;
/**
 * The constant map of values for RpcGrpcStatusCodeValues.
 * @deprecated Use the RPCGRPCSTATUSCODEVALUES_XXXXX constants rather than the RpcGrpcStatusCodeValues.XXXXX for bundle minification.
 */
var RpcGrpcStatusCodeValues = {
    OK: TMP_RPCGRPCSTATUSCODEVALUES_OK,
    CANCELLED: TMP_RPCGRPCSTATUSCODEVALUES_CANCELLED,
    UNKNOWN: TMP_RPCGRPCSTATUSCODEVALUES_UNKNOWN,
    INVALID_ARGUMENT: TMP_RPCGRPCSTATUSCODEVALUES_INVALID_ARGUMENT,
    DEADLINE_EXCEEDED: TMP_RPCGRPCSTATUSCODEVALUES_DEADLINE_EXCEEDED,
    NOT_FOUND: TMP_RPCGRPCSTATUSCODEVALUES_NOT_FOUND,
    ALREADY_EXISTS: TMP_RPCGRPCSTATUSCODEVALUES_ALREADY_EXISTS,
    PERMISSION_DENIED: TMP_RPCGRPCSTATUSCODEVALUES_PERMISSION_DENIED,
    RESOURCE_EXHAUSTED: TMP_RPCGRPCSTATUSCODEVALUES_RESOURCE_EXHAUSTED,
    FAILED_PRECONDITION: TMP_RPCGRPCSTATUSCODEVALUES_FAILED_PRECONDITION,
    ABORTED: TMP_RPCGRPCSTATUSCODEVALUES_ABORTED,
    OUT_OF_RANGE: TMP_RPCGRPCSTATUSCODEVALUES_OUT_OF_RANGE,
    UNIMPLEMENTED: TMP_RPCGRPCSTATUSCODEVALUES_UNIMPLEMENTED,
    INTERNAL: TMP_RPCGRPCSTATUSCODEVALUES_INTERNAL,
    UNAVAILABLE: TMP_RPCGRPCSTATUSCODEVALUES_UNAVAILABLE,
    DATA_LOSS: TMP_RPCGRPCSTATUSCODEVALUES_DATA_LOSS,
    UNAUTHENTICATED: TMP_RPCGRPCSTATUSCODEVALUES_UNAUTHENTICATED,
};
/* ----------------------------------------------------------------------------------------------------------
 * Constant values for MessageTypeValues enum definition
 *
 * Whether this is a received or sent message.
 * ---------------------------------------------------------------------------------------------------------- */
// Temporary local constants to assign to the individual exports and the namespaced version
// Required to avoid the namespace exports using the unminifiable export names for some package types
var TMP_MESSAGETYPEVALUES_SENT = 'SENT';
var TMP_MESSAGETYPEVALUES_RECEIVED = 'RECEIVED';
/**
 * Whether this is a received or sent message.
 *
 * @deprecated Use MESSAGE_TYPE_VALUE_SENT in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var MESSAGETYPEVALUES_SENT = TMP_MESSAGETYPEVALUES_SENT;
/**
 * Whether this is a received or sent message.
 *
 * @deprecated Use MESSAGE_TYPE_VALUE_RECEIVED in [incubating entry-point]({@link https://github.com/open-telemetry/opentelemetry-js/blob/main/semantic-conventions/README.md#unstable-semconv}).
 */
var MESSAGETYPEVALUES_RECEIVED = TMP_MESSAGETYPEVALUES_RECEIVED;
/**
 * The constant map of values for MessageTypeValues.
 * @deprecated Use the MESSAGETYPEVALUES_XXXXX constants rather than the MessageTypeValues.XXXXX for bundle minification.
 */
var MessageTypeValues = 
/*#__PURE__*/ __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__internal_utils__["a" /* createConstMap */])([
    TMP_MESSAGETYPEVALUES_SENT,
    TMP_MESSAGETYPEVALUES_RECEIVED,
]);
//# sourceMappingURL=SemanticAttributes.js.map

/***/ }),
/* 2024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SemanticAttributes__ = __webpack_require__(2023);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticAttributes__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticAttributes__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticAttributes__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticAttributes__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticAttributes__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticAttributes__["f"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticAttributes__["g"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticAttributes__["h"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticAttributes__["i"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticAttributes__["j"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticAttributes__["k"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_0__SemanticAttributes__["l"]; });
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable no-restricted-syntax --
 * These re-exports are only of constants, only one-level deep at this point,
 * and should not cause problems for tree-shakers.
 */

//# sourceMappingURL=index.js.map

/***/ }),
/* 2025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getClippingRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getViewportRect_js__ = __webpack_require__(2031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getDocumentRect_js__ = __webpack_require__(2027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listScrollParents_js__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getOffsetParent_js__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getDocumentElement_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__getComputedStyle_js__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__instanceOf_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__getBoundingClientRect_js__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getParentNode_js__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__contains_js__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__getNodeName_js__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_rectToClientRect_js__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_math_js__ = __webpack_require__(217);















function getInnerBoundingClientRect(element, strategy) {
  var rect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__getBoundingClientRect_js__["a" /* default */])(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === __WEBPACK_IMPORTED_MODULE_0__enums_js__["c" /* viewport */] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_rectToClientRect_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getViewportRect_js__["a" /* default */])(element, strategy)) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__instanceOf_js__["a" /* isElement */])(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12__utils_rectToClientRect_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getDocumentRect_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getDocumentElement_js__["a" /* default */])(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__listScrollParents_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__getParentNode_js__["a" /* default */])(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__getComputedStyle_js__["a" /* default */])(element).position) >= 0;
  var clipperElement = canEscapeClipping && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__instanceOf_js__["b" /* isHTMLElement */])(element) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getOffsetParent_js__["a" /* default */])(element) : element;

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__instanceOf_js__["a" /* isElement */])(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__instanceOf_js__["a" /* isElement */])(clippingParent) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__contains_js__["a" /* default */])(clippingParent, clipperElement) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__getNodeName_js__["a" /* default */])(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_math_js__["b" /* max */])(rect.top, accRect.top);
    accRect.right = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_math_js__["c" /* min */])(rect.right, accRect.right);
    accRect.bottom = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_math_js__["c" /* min */])(rect.bottom, accRect.bottom);
    accRect.left = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils_math_js__["b" /* max */])(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

/***/ }),
/* 2026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getCompositeRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getNodeScroll_js__ = __webpack_require__(2029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getNodeName_js__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instanceOf_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getWindowScrollBarX_js__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getDocumentElement_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isScrollParent_js__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_math_js__ = __webpack_require__(217);









function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_math_js__["a" /* round */])(rect.width) / element.offsetWidth || 1;
  var scaleY = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_math_js__["a" /* round */])(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(offsetParent);
  var offsetParentIsScaled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(offsetParent) && isElementScaled(offsetParent);
  var documentElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getDocumentElement_js__["a" /* default */])(offsetParent);
  var rect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__["a" /* default */])(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getNodeName_js__["a" /* default */])(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__isScrollParent_js__["a" /* default */])(documentElement)) {
      scroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getNodeScroll_js__["a" /* default */])(offsetParent);
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(offsetParent)) {
      offsets = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getBoundingClientRect_js__["a" /* default */])(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getWindowScrollBarX_js__["a" /* default */])(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

/***/ }),
/* 2027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getDocumentRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getDocumentElement_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getComputedStyle_js__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getWindowScrollBarX_js__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getWindowScroll_js__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_math_js__ = __webpack_require__(217);




 // Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getDocumentElement_js__["a" /* default */])(element);
  var winScroll = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__getWindowScroll_js__["a" /* default */])(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_math_js__["b" /* max */])(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_math_js__["b" /* max */])(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getWindowScrollBarX_js__["a" /* default */])(element);
  var y = -winScroll.scrollTop;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getComputedStyle_js__["a" /* default */])(body || html).direction === 'rtl') {
    x += __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__utils_math_js__["b" /* max */])(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

/***/ }),
/* 2028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getHTMLElementScroll;
function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

/***/ }),
/* 2029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getNodeScroll;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindowScroll_js__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getWindow_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__instanceOf_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getHTMLElementScroll_js__ = __webpack_require__(2028);




function getNodeScroll(node) {
  if (node === __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getWindow_js__["a" /* default */])(node) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__instanceOf_js__["b" /* isHTMLElement */])(node)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getWindowScroll_js__["a" /* default */])(node);
  } else {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__getHTMLElementScroll_js__["a" /* default */])(node);
  }
}

/***/ }),
/* 2030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getScrollParent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getParentNode_js__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isScrollParent_js__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getNodeName_js__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__instanceOf_js__ = __webpack_require__(125);




function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getNodeName_js__["a" /* default */])(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__instanceOf_js__["b" /* isHTMLElement */])(node) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isScrollParent_js__["a" /* default */])(node)) {
    return node;
  }

  return getScrollParent(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getParentNode_js__["a" /* default */])(node));
}

/***/ }),
/* 2031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getViewportRect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getWindow_js__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__ = __webpack_require__(191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getWindowScrollBarX_js__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isLayoutViewport_js__ = __webpack_require__(945);




function getViewportRect(element, strategy) {
  var win = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getWindow_js__["a" /* default */])(element);
  var html = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getDocumentElement_js__["a" /* default */])(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isLayoutViewport_js__["a" /* default */])();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getWindowScrollBarX_js__["a" /* default */])(element),
    y: y
  };
}

/***/ }),
/* 2032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isTableElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNodeName_js__ = __webpack_require__(215);

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNodeName_js__["a" /* default */])(element)) >= 0;
}

/***/ }),
/* 2033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(114);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modifiers_index_js__ = __webpack_require__(950);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createPopper_js__ = __webpack_require__(542);
/* unused harmony reexport popperGenerator */
/* unused harmony reexport detectOverflow */
/* unused harmony reexport createPopperBase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__popper_js__ = __webpack_require__(2034);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__popper_js__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__popper_lite_js__ = __webpack_require__(953);
/* unused harmony reexport createPopperLite */

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules



/***/ }),
/* 2034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createPopper; });
/* unused harmony export defaultModifiers */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPopper_js__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modifiers_eventListeners_js__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modifiers_popperOffsets_js__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modifiers_computeStyles_js__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modifiers_applyStyles_js__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modifiers_offset_js__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modifiers_flip_js__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modifiers_preventOverflow_js__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modifiers_arrow_js__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modifiers_hide_js__ = __webpack_require__(949);
/* unused harmony reexport popperGenerator */
/* unused harmony reexport detectOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__popper_lite_js__ = __webpack_require__(953);
/* unused harmony reexport createPopperLite */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modifiers_index_js__ = __webpack_require__(950);
/* unused harmony namespace reexport */










var defaultModifiers = [__WEBPACK_IMPORTED_MODULE_1__modifiers_eventListeners_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__modifiers_popperOffsets_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__modifiers_computeStyles_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__modifiers_applyStyles_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__modifiers_offset_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__modifiers_flip_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__modifiers_preventOverflow_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__modifiers_arrow_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__modifiers_hide_js__["a" /* default */]];
var createPopper = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createPopper_js__["a" /* popperGenerator */])({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules

 // eslint-disable-next-line import/no-unused-modules



/***/ }),
/* 2035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = computeAutoPlacement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getVariation_js__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__enums_js__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__detectOverflow_js__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getBasePlacement_js__ = __webpack_require__(216);




function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? __WEBPACK_IMPORTED_MODULE_1__enums_js__["n" /* placements */] : _options$allowedAutoP;
  var variation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getVariation_js__["a" /* default */])(placement);
  var placements = variation ? flipVariations ? __WEBPACK_IMPORTED_MODULE_1__enums_js__["o" /* variationPlacements */] : __WEBPACK_IMPORTED_MODULE_1__enums_js__["o" /* variationPlacements */].filter(function (placement) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getVariation_js__["a" /* default */])(placement) === variation;
  }) : __WEBPACK_IMPORTED_MODULE_1__enums_js__["e" /* basePlacements */];
  var allowedPlacements = placements.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__detectOverflow_js__["a" /* default */])(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__getBasePlacement_js__["a" /* default */])(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

/***/ }),
/* 2036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

/***/ }),
/* 2037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getAltAxis;
function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

/***/ }),
/* 2038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOppositePlacement;
var hash = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/***/ }),
/* 2039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOppositeVariationPlacement;
var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

/***/ }),
/* 2040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mergeByName;
function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

/***/ }),
/* 2041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = orderModifiers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__enums_js__ = __webpack_require__(114);
 // source: https://stackoverflow.com/questions/49875255

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return __WEBPACK_IMPORTED_MODULE_0__enums_js__["a" /* modifierPhases */].reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

/***/ }),
/* 2042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:!0});var env=__webpack_require__(2961);__webpack_require__(1);var React=__webpack_require__(0);function _typeof(e){return(_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function _classCallCheck(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function _defineProperties(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function _createClass(e,t,n){return t&&_defineProperties(e.prototype,t),n&&_defineProperties(e,n),e}function _defineProperty(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}function _inherits(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&_setPrototypeOf(e,t)}function _getPrototypeOf(e){return(_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function _setPrototypeOf(e,t){return(_setPrototypeOf=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function _assertThisInitialized(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function _possibleConstructorReturn(e,t){return!t||"object"!=typeof t&&"function"!=typeof t?_assertThisInitialized(e):t}var EventSet=function(){function e(t){_classCallCheck(this,e),_defineProperty(this,"handlers",void 0),this.handlers=t.slice(0)}return _createClass(e,[{key:"addHandlers",value:function(t){for(var n=this.handlers.slice(0),r=t.length,o=0;o<r;o+=1)n.push(t[o]);return new e(n)}},{key:"dispatchEvent",value:function(e,t){var n=this.handlers.length-1;if(t){for(var r=n;r>=0;r-=1)this.handlers[r].called||(this.handlers[r].called=!0,this.handlers[r](e));for(var o=n;o>=0;o-=1)this.handlers[o].called=!1}else{(0,this.handlers[n])(e)}}},{key:"hasHandlers",value:function(){return this.handlers.length>0}},{key:"removeHandlers",value:function(t){for(var n=[],r=this.handlers.length,o=0;o<r;o+=1){var a=this.handlers[o];-1===t.indexOf(a)&&n.push(a)}return new e(n)}}]),e}();function cloneMap(e){var t=new Map;return e.forEach(function(e,n){t.set(n,e)}),t}function normalizeHandlers(e){return Array.isArray(e)?e:[e]}var isRefObject=function(e){return null!==e&&"object"===_typeof(e)&&e.hasOwnProperty("current")};function normalizeTarget(e){return"document"===e?document:"window"===e?window:isRefObject(e)?e.current||document:e||document}var EventPool=function(){function e(t,n){_classCallCheck(this,e),_defineProperty(this,"handlerSets",void 0),_defineProperty(this,"poolName",void 0),this.handlerSets=n,this.poolName=t}return _createClass(e,[{key:"addHandlers",value:function(t,n){var r=cloneMap(this.handlerSets);if(r.has(t)){var o=r.get(t);r.set(t,o.addHandlers(n))}else r.set(t,new EventSet(n));return new e(this.poolName,r)}},{key:"dispatchEvent",value:function(e,t){var n=this.handlerSets.get(e),r="default"===this.poolName;n&&n.dispatchEvent(t,r)}},{key:"hasHandlers",value:function(e){if(!e)return this.handlerSets.size>0;var t=this.handlerSets.get(e);return!!t&&t.hasHandlers()}},{key:"removeHandlers",value:function(t,n){var r=cloneMap(this.handlerSets);if(!r.has(t))return new e(this.poolName,r);var o=r.get(t).removeHandlers(n);return o.hasHandlers()?r.set(t,o):r.delete(t),new e(this.poolName,r)}}]),e}();_defineProperty(EventPool,"createByType",function(e,t,n){var r=new Map;return r.set(t,new EventSet(n)),new EventPool(e,r)});var EventTarget=function(){function e(t){var n=this;_classCallCheck(this,e),_defineProperty(this,"handlers",new Map),_defineProperty(this,"pools",new Map),_defineProperty(this,"target",void 0),_defineProperty(this,"createEmitter",function(e){return function(t){n.pools.forEach(function(n){n.dispatchEvent(e,t)})}}),this.target=t}return _createClass(e,[{key:"addHandlers",value:function(e,t,n){if(this.pools.has(e)){var r=this.pools.get(e);this.pools.set(e,r.addHandlers(t,n))}else this.pools.set(e,EventPool.createByType(e,t,n));this.handlers.has(t)||this.addTargetHandler(t)}},{key:"hasHandlers",value:function(){return this.handlers.size>0}},{key:"removeHandlers",value:function(e,t,n){if(this.pools.has(e)){var r=this.pools.get(e).removeHandlers(t,n);r.hasHandlers()?this.pools.set(e,r):this.pools.delete(e);var o=!1;this.pools.forEach(function(e){return o=o||e.hasHandlers(t)}),o||this.removeTargetHandler(t)}}},{key:"addTargetHandler",value:function(e){var t=this.createEmitter(e);this.handlers.set(e,t),this.target.addEventListener(e,t,!0)}},{key:"removeTargetHandler",value:function(e){this.handlers.has(e)&&(this.target.removeEventListener(e,this.handlers.get(e),!0),this.handlers.delete(e))}}]),e}(),EventStack=function(){function e(){var t=this;_classCallCheck(this,e),_defineProperty(this,"targets",new Map),_defineProperty(this,"getTarget",function(e){var n=!(arguments.length>1&&void 0!==arguments[1])||arguments[1],r=normalizeTarget(e);if(t.targets.has(r))return t.targets.get(r);if(!n)return null;var o=new EventTarget(r);return t.targets.set(r,o),o}),_defineProperty(this,"removeTarget",function(e){t.targets.delete(normalizeTarget(e))})}return _createClass(e,[{key:"sub",value:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(env.canUseDOM){var r=n.target,o=void 0===r?document:r,a=n.pool,s=void 0===a?"default":a;this.getTarget(o).addHandlers(s,e,normalizeHandlers(t))}}},{key:"unsub",value:function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};if(env.canUseDOM){var r=n.target,o=void 0===r?document:r,a=n.pool,s=void 0===a?"default":a,i=this.getTarget(o,!1);i&&(i.removeHandlers(s,e,normalizeHandlers(t)),i.hasHandlers()||this.removeTarget(o))}}}]),e}(),instance=new EventStack,EventStack$1=function(e){function t(){return _classCallCheck(this,t),_possibleConstructorReturn(this,_getPrototypeOf(t).apply(this,arguments))}return _inherits(t,React.PureComponent),_createClass(t,[{key:"componentDidMount",value:function(){this.subscribe(this.props)}},{key:"componentDidUpdate",value:function(e){this.unsubscribe(e),this.subscribe(this.props)}},{key:"componentWillUnmount",value:function(){this.unsubscribe(this.props)}},{key:"subscribe",value:function(e){var t=e.name,n=e.on,r=e.pool,o=e.target;instance.sub(t,n,{pool:r,target:o})}},{key:"unsubscribe",value:function(e){var t=e.name,n=e.on,r=e.pool,o=e.target;instance.unsub(t,n,{pool:r,target:o})}},{key:"render",value:function(){return null}}]),t}();_defineProperty(EventStack$1,"defaultProps",{pool:"default",target:"document"}),EventStack$1.propTypes={},exports.instance=instance,exports.default=EventStack$1;


/***/ }),
/* 2043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * base event object for custom and dom event.
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, "__esModule", {
  value: true
});
function returnFalse() {
  return false;
}

function returnTrue() {
  return true;
}

function EventBaseObject() {
  this.timeStamp = Date.now();
  this.target = undefined;
  this.currentTarget = undefined;
}

EventBaseObject.prototype = {
  isEventObject: 1,

  constructor: EventBaseObject,

  isDefaultPrevented: returnFalse,

  isPropagationStopped: returnFalse,

  isImmediatePropagationStopped: returnFalse,

  preventDefault: function preventDefault() {
    this.isDefaultPrevented = returnTrue;
  },

  stopPropagation: function stopPropagation() {
    this.isPropagationStopped = returnTrue;
  },

  stopImmediatePropagation: function stopImmediatePropagation() {
    this.isImmediatePropagationStopped = returnTrue;
    // fixed 1.2
    // call stopPropagation implicitly
    this.stopPropagation();
  },

  halt: function halt(immediate) {
    if (immediate) {
      this.stopImmediatePropagation();
    } else {
      this.stopPropagation();
    }
    this.preventDefault();
  }
};

exports["default"] = EventBaseObject;
module.exports = exports["default"];

/***/ }),
/* 2044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @ignore
 * event object for dom
 * @author yiminghe@gmail.com
 */



Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventBaseObject = __webpack_require__(2043);

var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);

var _objectAssign = __webpack_require__(121);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var TRUE = true;
var FALSE = false;
var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];

function isNullOrUndefined(w) {
  return w === null || w === undefined;
}

var eventNormalizers = [{
  reg: /^key/,
  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
  fix: function fix(event, nativeEvent) {
    if (isNullOrUndefined(event.which)) {
      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
    }

    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
    if (event.metaKey === undefined) {
      event.metaKey = event.ctrlKey;
    }
  }
}, {
  reg: /^touch/,
  props: ['touches', 'changedTouches', 'targetTouches']
}, {
  reg: /^hashchange$/,
  props: ['newURL', 'oldURL']
}, {
  reg: /^gesturechange$/i,
  props: ['rotation', 'scale']
}, {
  reg: /^(mousewheel|DOMMouseScroll)$/,
  props: [],
  fix: function fix(event, nativeEvent) {
    var deltaX = undefined;
    var deltaY = undefined;
    var delta = undefined;
    var wheelDelta = nativeEvent.wheelDelta;
    var axis = nativeEvent.axis;
    var wheelDeltaY = nativeEvent.wheelDeltaY;
    var wheelDeltaX = nativeEvent.wheelDeltaX;
    var detail = nativeEvent.detail;

    // ie/webkit
    if (wheelDelta) {
      delta = wheelDelta / 120;
    }

    // gecko
    if (detail) {
      // press control e.detail == 1 else e.detail == 3
      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
    }

    // Gecko
    if (axis !== undefined) {
      if (axis === event.HORIZONTAL_AXIS) {
        deltaY = 0;
        deltaX = 0 - delta;
      } else if (axis === event.VERTICAL_AXIS) {
        deltaX = 0;
        deltaY = delta;
      }
    }

    // Webkit
    if (wheelDeltaY !== undefined) {
      deltaY = wheelDeltaY / 120;
    }
    if (wheelDeltaX !== undefined) {
      deltaX = -1 * wheelDeltaX / 120;
    }

    // 默认 deltaY (ie)
    if (!deltaX && !deltaY) {
      deltaY = delta;
    }

    if (deltaX !== undefined) {
      /**
       * deltaX of mousewheel event
       * @property deltaX
       * @member Event.DomEvent.Object
       */
      event.deltaX = deltaX;
    }

    if (deltaY !== undefined) {
      /**
       * deltaY of mousewheel event
       * @property deltaY
       * @member Event.DomEvent.Object
       */
      event.deltaY = deltaY;
    }

    if (delta !== undefined) {
      /**
       * delta of mousewheel event
       * @property delta
       * @member Event.DomEvent.Object
       */
      event.delta = delta;
    }
  }
}, {
  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
  fix: function fix(event, nativeEvent) {
    var eventDoc = undefined;
    var doc = undefined;
    var body = undefined;
    var target = event.target;
    var button = nativeEvent.button;

    // Calculate pageX/Y if missing and clientX/Y available
    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
      eventDoc = target.ownerDocument || document;
      doc = eventDoc.documentElement;
      body = eventDoc.body;
      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
    }

    // which for click: 1 === left; 2 === middle; 3 === right
    // do not use button
    if (!event.which && button !== undefined) {
      if (button & 1) {
        event.which = 1;
      } else if (button & 2) {
        event.which = 3;
      } else if (button & 4) {
        event.which = 2;
      } else {
        event.which = 0;
      }
    }

    // add relatedTarget, if necessary
    if (!event.relatedTarget && event.fromElement) {
      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
    }

    return event;
  }
}];

function retTrue() {
  return TRUE;
}

function retFalse() {
  return FALSE;
}

function DomEventObject(nativeEvent) {
  var type = nativeEvent.type;

  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';

  _EventBaseObject2['default'].call(this);

  this.nativeEvent = nativeEvent;

  // in case dom event has been mark as default prevented by lower dom node
  var isDefaultPrevented = retFalse;
  if ('defaultPrevented' in nativeEvent) {
    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
  } else if ('getPreventDefault' in nativeEvent) {
    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
  } else if ('returnValue' in nativeEvent) {
    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
  }

  this.isDefaultPrevented = isDefaultPrevented;

  var fixFns = [];
  var fixFn = undefined;
  var l = undefined;
  var prop = undefined;
  var props = commonProps.concat();

  eventNormalizers.forEach(function (normalizer) {
    if (type.match(normalizer.reg)) {
      props = props.concat(normalizer.props);
      if (normalizer.fix) {
        fixFns.push(normalizer.fix);
      }
    }
  });

  l = props.length;

  // clone properties of the original event object
  while (l) {
    prop = props[--l];
    this[prop] = nativeEvent[prop];
  }

  // fix target property, if necessary
  if (!this.target && isNative) {
    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
  }

  // check if target is a text node (safari)
  if (this.target && this.target.nodeType === 3) {
    this.target = this.target.parentNode;
  }

  l = fixFns.length;

  while (l) {
    fixFn = fixFns[--l];
    fixFn(this, nativeEvent);
  }

  this.timeStamp = nativeEvent.timeStamp || Date.now();
}

var EventBaseObjectProto = _EventBaseObject2['default'].prototype;

(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
  constructor: DomEventObject,

  preventDefault: function preventDefault() {
    var e = this.nativeEvent;

    // if preventDefault exists run it on the original event
    if (e.preventDefault) {
      e.preventDefault();
    } else {
      // otherwise set the returnValue property of the original event to FALSE (IE)
      e.returnValue = FALSE;
    }

    EventBaseObjectProto.preventDefault.call(this);
  },

  stopPropagation: function stopPropagation() {
    var e = this.nativeEvent;

    // if stopPropagation exists run it on the original event
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      // otherwise set the cancelBubble property of the original event to TRUE (IE)
      e.cancelBubble = TRUE;
    }

    EventBaseObjectProto.stopPropagation.call(this);
  }
});

exports['default'] = DomEventObject;
module.exports = exports['default'];

/***/ }),
/* 2045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = addEventListener;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _EventObject = __webpack_require__(2044);

var _EventObject2 = _interopRequireDefault(_EventObject);

function addEventListener(target, eventType, callback, option) {
  function wrapCallback(e) {
    var ne = new _EventObject2['default'](e);
    callback.call(target, ne);
  }

  if (target.addEventListener) {
    var _ret = (function () {
      var useCapture = false;
      if (typeof option === 'object') {
        useCapture = option.capture || false;
      } else if (typeof option === 'boolean') {
        useCapture = option;
      }

      target.addEventListener(eventType, wrapCallback, option || false);

      return {
        v: {
          remove: function remove() {
            target.removeEventListener(eventType, wrapCallback, useCapture);
          }
        }
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else if (target.attachEvent) {
    target.attachEvent('on' + eventType, wrapCallback);
    return {
      remove: function remove() {
        target.detachEvent('on' + eventType, wrapCallback);
      }
    };
  }
}

module.exports = exports['default'];

/***/ }),
/* 2046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AuthenticationDetails; });
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */

/** @class */
var AuthenticationDetails = /*#__PURE__*/function () {
  /**
   * Constructs a new AuthenticationDetails object
   * @param {object=} data Creation options.
   * @param {string} data.Username User being authenticated.
   * @param {string} data.Password Plain-text password to authenticate with.
   * @param {(AttributeArg[])?} data.ValidationData Application extra metadata.
   * @param {(AttributeArg[])?} data.AuthParamaters Authentication paramaters for custom auth.
   */
  function AuthenticationDetails(data) {
    var _ref = data || {},
        ValidationData = _ref.ValidationData,
        Username = _ref.Username,
        Password = _ref.Password,
        AuthParameters = _ref.AuthParameters,
        ClientMetadata = _ref.ClientMetadata;

    this.validationData = ValidationData || {};
    this.authParameters = AuthParameters || {};
    this.clientMetadata = ClientMetadata || {};
    this.username = Username;
    this.password = Password;
  }
  /**
   * @returns {string} the record's username
   */


  var _proto = AuthenticationDetails.prototype;

  _proto.getUsername = function getUsername() {
    return this.username;
  }
  /**
   * @returns {string} the record's password
   */
  ;

  _proto.getPassword = function getPassword() {
    return this.password;
  }
  /**
   * @returns {Array} the record's validationData
   */
  ;

  _proto.getValidationData = function getValidationData() {
    return this.validationData;
  }
  /**
   * @returns {Array} the record's authParameters
   */
  ;

  _proto.getAuthParameters = function getAuthParameters() {
    return this.authParameters;
  }
  /**
   * @returns {ClientMetadata} the clientMetadata for a Lambda trigger
   */
  ;

  _proto.getClientMetadata = function getClientMetadata() {
    return this.clientMetadata;
  };

  return AuthenticationDetails;
}();



/***/ }),
/* 2047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Client; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_unfetch__ = __webpack_require__(3022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_unfetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_unfetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserAgent__ = __webpack_require__(972);
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }




var CognitoError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(CognitoError, _Error);

  function CognitoError(message, code, name, statusCode) {
    var _this;

    _this = _Error.call(this, message) || this;
    _this.code = code;
    _this.name = name;
    _this.statusCode = statusCode;
    return _this;
  }

  return CognitoError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
/** @class */


var Client = /*#__PURE__*/function () {
  /**
   * Constructs a new AWS Cognito Identity Provider client object
   * @param {string} region AWS region
   * @param {string} endpoint endpoint
   * @param {object} fetchOptions options for fetch API (only credentials is supported)
   */
  function Client(region, endpoint, fetchOptions) {
    this.endpoint = endpoint || "https://cognito-idp." + region + ".amazonaws.com/";

    var _ref = fetchOptions || {},
        credentials = _ref.credentials;

    this.fetchOptions = credentials ? {
      credentials: credentials
    } : {};
  }
  /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @returns Promise<object>
   */


  var _proto = Client.prototype;

  _proto.promisifyRequest = function promisifyRequest(operation, params) {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.request(operation, params, function (err, data) {
        if (err) {
          reject(new CognitoError(err.message, err.code, err.name, err.statusCode));
        } else {
          resolve(data);
        }
      });
    });
  };

  _proto.requestWithRetry = function requestWithRetry(operation, params, callback) {
    var _this3 = this;

    var MAX_DELAY_IN_MILLIS = 5 * 1000;
    jitteredExponentialRetry(function (p) {
      return new Promise(function (res, rej) {
        _this3.request(operation, p, function (error, result) {
          if (error) {
            rej(error);
          } else {
            res(result);
          }
        });
      });
    }, [params], MAX_DELAY_IN_MILLIS).then(function (result) {
      return callback(null, result);
    })["catch"](function (error) {
      return callback(error);
    });
  }
  /**
   * Makes an unauthenticated request on AWS Cognito Identity Provider API
   * using fetch
   * @param {string} operation API operation
   * @param {object} params Input parameters
   * @param {function} callback Callback called when a response is returned
   * @returns {void}
   */
  ;

  _proto.request = function request(operation, params, callback) {
    var headers = {
      'Content-Type': 'application/x-amz-json-1.1',
      'X-Amz-Target': "AWSCognitoIdentityProviderService." + operation,
      'X-Amz-User-Agent': __WEBPACK_IMPORTED_MODULE_1__UserAgent__["b" /* default */].prototype.userAgent
    };
    var options = Object.assign({}, this.fetchOptions, {
      headers: headers,
      method: 'POST',
      mode: 'cors',
      cache: 'no-cache',
      body: JSON.stringify(params)
    });
    var response;
    var responseJsonData;
    fetch(this.endpoint, options).then(function (resp) {
      response = resp;
      return resp;
    }, function (err) {
      // If error happens here, the request failed
      // if it is TypeError throw network error
      if (err instanceof TypeError) {
        throw new Error('Network error');
      }

      throw err;
    }).then(function (resp) {
      return resp.json()["catch"](function () {
        return {};
      });
    }).then(function (data) {
      // return parsed body stream
      if (response.ok) return callback(null, data);
      responseJsonData = data; // Taken from aws-sdk-js/lib/protocol/json.js
      // eslint-disable-next-line no-underscore-dangle

      var code = (data.__type || data.code).split('#').pop();
      var error = {
        code: code,
        name: code,
        message: data.message || data.Message || null
      };
      return callback(error);
    })["catch"](function (err) {
      // first check if we have a service error
      if (response && response.headers && response.headers.get('x-amzn-errortype')) {
        try {
          var code = response.headers.get('x-amzn-errortype').split(':')[0];
          var error = {
            code: code,
            name: code,
            statusCode: response.status,
            message: response.status ? response.status.toString() : null
          };
          return callback(error);
        } catch (ex) {
          return callback(err);
        } // otherwise check if error is Network error

      } else if (err instanceof Error && err.message === 'Network error') {
        var _error = {
          code: 'NetworkError',
          name: err.name,
          message: err.message
        };
        return callback(_error);
      } else {
        return callback(err);
      }
    });
  };

  return Client;
}();


var logger = {
  debug: function debug() {// Intentionally blank. This package doesn't have logging
  }
};
/**
 * For now, all errors are retryable.
 */

var NonRetryableError = /*#__PURE__*/function (_Error2) {
  _inheritsLoose(NonRetryableError, _Error2);

  function NonRetryableError(message) {
    var _this4;

    _this4 = _Error2.call(this, message) || this;
    _this4.nonRetryable = true;
    return _this4;
  }

  return NonRetryableError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var isNonRetryableError = function isNonRetryableError(obj) {
  var key = 'nonRetryable';
  return obj && obj[key];
};

function retry(functionToRetry, args, delayFn, attempt) {
  if (attempt === void 0) {
    attempt = 1;
  }

  if (typeof functionToRetry !== 'function') {
    throw Error('functionToRetry must be a function');
  }

  logger.debug(functionToRetry.name + " attempt #" + attempt + " with args: " + JSON.stringify(args));
  return functionToRetry.apply(void 0, args)["catch"](function (err) {
    logger.debug("error on " + functionToRetry.name, err);

    if (isNonRetryableError(err)) {
      logger.debug(functionToRetry.name + " non retryable error", err);
      throw err;
    }

    var retryIn = delayFn(attempt, args, err);
    logger.debug(functionToRetry.name + " retrying in " + retryIn + " ms");

    if (retryIn !== false) {
      return new Promise(function (res) {
        return setTimeout(res, retryIn);
      }).then(function () {
        return retry(functionToRetry, args, delayFn, attempt + 1);
      });
    } else {
      throw err;
    }
  });
}

function jitteredBackoff(maxDelayMs) {
  var BASE_TIME_MS = 100;
  var JITTER_FACTOR = 100;
  return function (attempt) {
    var delay = Math.pow(2, attempt) * BASE_TIME_MS + JITTER_FACTOR * Math.random();
    return delay > maxDelayMs ? false : delay;
  };
}

var MAX_DELAY_MS = 5 * 60 * 1000;

function jitteredExponentialRetry(functionToRetry, args, maxDelayMs) {
  if (maxDelayMs === void 0) {
    maxDelayMs = MAX_DELAY_MS;
  }

  return retry(functionToRetry, args, jitteredBackoff(maxDelayMs));
}

;

/***/ }),
/* 2048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CognitoUserPool; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Client__ = __webpack_require__(2047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CognitoUser__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__StorageHelper__ = __webpack_require__(971);
/*!
 * Copyright 2016 Amazon.com,
 * Inc. or its affiliates. All Rights Reserved.
 *
 * Licensed under the Amazon Software License (the "License").
 * You may not use this file except in compliance with the
 * License. A copy of the License is located at
 *
 *     http://aws.amazon.com/asl/
 *
 * or in the "license" file accompanying this file. This file is
 * distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR
 * CONDITIONS OF ANY KIND, express or implied. See the License
 * for the specific language governing permissions and
 * limitations under the License.
 */



/** @class */

var CognitoUserPool = /*#__PURE__*/function () {
  /**
   * Constructs a new CognitoUserPool object
   * @param {object} data Creation options.
   * @param {string} data.UserPoolId Cognito user pool id.
   * @param {string} data.ClientId User pool application client id.
   * @param {string} data.endpoint Optional custom service endpoint.
   * @param {object} data.fetchOptions Optional options for fetch API.
   *        (only credentials option is supported)
   * @param {object} data.Storage Optional storage object.
   * @param {boolean} data.AdvancedSecurityDataCollectionFlag Optional:
   *        boolean flag indicating if the data collection is enabled
   *        to support cognito advanced security features. By default, this
   *        flag is set to true.
   */
  function CognitoUserPool(data, wrapRefreshSessionCallback) {
    var _ref = data || {},
        UserPoolId = _ref.UserPoolId,
        ClientId = _ref.ClientId,
        endpoint = _ref.endpoint,
        fetchOptions = _ref.fetchOptions,
        AdvancedSecurityDataCollectionFlag = _ref.AdvancedSecurityDataCollectionFlag;

    if (!UserPoolId || !ClientId) {
      throw new Error('Both UserPoolId and ClientId are required.');
    }

    if (!/^[\w-]+_.+$/.test(UserPoolId)) {
      throw new Error('Invalid UserPoolId format.');
    }

    var region = UserPoolId.split('_')[0];
    this.userPoolId = UserPoolId;
    this.clientId = ClientId;
    this.client = new __WEBPACK_IMPORTED_MODULE_0__Client__["a" /* default */](region, endpoint, fetchOptions);
    /**
     * By default, AdvancedSecurityDataCollectionFlag is set to true,
     * if no input value is provided.
     */

    this.advancedSecurityDataCollectionFlag = AdvancedSecurityDataCollectionFlag !== false;
    this.storage = data.Storage || new __WEBPACK_IMPORTED_MODULE_2__StorageHelper__["a" /* default */]().getStorage();

    if (wrapRefreshSessionCallback) {
      this.wrapRefreshSessionCallback = wrapRefreshSessionCallback;
    }
  }
  /**
   * @returns {string} the user pool id
   */


  var _proto = CognitoUserPool.prototype;

  _proto.getUserPoolId = function getUserPoolId() {
    return this.userPoolId;
  }
  /**
   * @returns {string} the client id
   */
  ;

  _proto.getClientId = function getClientId() {
    return this.clientId;
  }
  /**
   * @typedef {object} SignUpResult
   * @property {CognitoUser} user New user.
   * @property {bool} userConfirmed If the user is already confirmed.
   */

  /**
   * method for signing up a user
   * @param {string} username User's username.
   * @param {string} password Plain-text initial password entered by user.
   * @param {(AttributeArg[])=} userAttributes New user attributes.
   * @param {(AttributeArg[])=} validationData Application metadata.
   * @param {(AttributeArg[])=} clientMetadata Client metadata.
   * @param {nodeCallback<SignUpResult>} callback Called on error or with the new user.
   * @param {ClientMetadata} clientMetadata object which is passed from client to Cognito Lambda trigger
   * @returns {void}
   */
  ;

  _proto.signUp = function signUp(username, password, userAttributes, validationData, callback, clientMetadata) {
    var _this = this;

    var jsonReq = {
      ClientId: this.clientId,
      Username: username,
      Password: password,
      UserAttributes: userAttributes,
      ValidationData: validationData,
      ClientMetadata: clientMetadata
    };

    if (this.getUserContextData(username)) {
      jsonReq.UserContextData = this.getUserContextData(username);
    }

    this.client.request('SignUp', jsonReq, function (err, data) {
      if (err) {
        return callback(err, null);
      }

      var cognitoUser = {
        Username: username,
        Pool: _this,
        Storage: _this.storage
      };
      var returnData = {
        user: new __WEBPACK_IMPORTED_MODULE_1__CognitoUser__["a" /* default */](cognitoUser),
        userConfirmed: data.UserConfirmed,
        userSub: data.UserSub,
        codeDeliveryDetails: data.CodeDeliveryDetails
      };
      return callback(null, returnData);
    });
  }
  /**
   * method for getting the current user of the application from the local storage
   *
   * @returns {CognitoUser} the user retrieved from storage
   */
  ;

  _proto.getCurrentUser = function getCurrentUser() {
    var lastUserKey = "CognitoIdentityServiceProvider." + this.clientId + ".LastAuthUser";
    var lastAuthUser = this.storage.getItem(lastUserKey);

    if (lastAuthUser) {
      var cognitoUser = {
        Username: lastAuthUser,
        Pool: this,
        Storage: this.storage
      };
      return new __WEBPACK_IMPORTED_MODULE_1__CognitoUser__["a" /* default */](cognitoUser);
    }

    return null;
  }
  /**
   * This method returns the encoded data string used for cognito advanced security feature.
   * This would be generated only when developer has included the JS used for collecting the
   * data on their client. Please refer to documentation to know more about using AdvancedSecurity
   * features
   * @param {string} username the username for the context data
   * @returns {string} the user context data
   **/
  ;

  _proto.getUserContextData = function getUserContextData(username) {
    if (typeof AmazonCognitoAdvancedSecurityData === 'undefined') {
      return undefined;
    }
    /* eslint-disable */


    var amazonCognitoAdvancedSecurityDataConst = AmazonCognitoAdvancedSecurityData;
    /* eslint-enable */

    if (this.advancedSecurityDataCollectionFlag) {
      var advancedSecurityData = amazonCognitoAdvancedSecurityDataConst.getData(username, this.userPoolId, this.clientId);

      if (advancedSecurityData) {
        var userContextData = {
          EncodedData: advancedSecurityData
        };
        return userContextData;
      }
    }

    return {};
  };

  return CognitoUserPool;
}();



/***/ }),
/* 2049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CookieStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);

/** @class */

var CookieStorage = /*#__PURE__*/function () {
  /**
   * Constructs a new CookieStorage object
   * @param {object} data Creation options.
   * @param {string} data.domain Cookies domain (mandatory).
   * @param {string} data.path Cookies path (default: '/')
   * @param {integer} data.expires Cookie expiration (in days, default: 365)
   * @param {boolean} data.secure Cookie secure flag (default: true)
   * @param {string} data.sameSite Cookie request behaviour (default: null)
   */
  function CookieStorage(data) {
    if (data.domain) {
      this.domain = data.domain;
    } else {
      throw new Error('The domain of cookieStorage can not be undefined.');
    }

    if (data.path) {
      this.path = data.path;
    } else {
      this.path = '/';
    }

    if (Object.prototype.hasOwnProperty.call(data, 'expires')) {
      this.expires = data.expires;
    } else {
      this.expires = 365;
    }

    if (Object.prototype.hasOwnProperty.call(data, 'secure')) {
      this.secure = data.secure;
    } else {
      this.secure = true;
    }

    if (Object.prototype.hasOwnProperty.call(data, 'sameSite')) {
      if (!['strict', 'lax', 'none'].includes(data.sameSite)) {
        throw new Error('The sameSite value of cookieStorage must be "lax", "strict" or "none".');
      }

      if (data.sameSite === 'none' && !this.secure) {
        throw new Error('sameSite = None requires the Secure attribute in latest browser versions.');
      }

      this.sameSite = data.sameSite;
    } else {
      this.sameSite = null;
    }
  }
  /**
   * This is used to set a specific item in storage
   * @param {string} key - the key for the item
   * @param {object} value - the value
   * @returns {string} value that was set
   */


  var _proto = CookieStorage.prototype;

  _proto.setItem = function setItem(key, value) {
    var options = {
      path: this.path,
      expires: this.expires,
      domain: this.domain,
      secure: this.secure
    };

    if (this.sameSite) {
      options.sameSite = this.sameSite;
    }

    __WEBPACK_IMPORTED_MODULE_0_js_cookie__["set"](key, value, options);
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie__["get"](key);
  }
  /**
   * This is used to get a specific key from storage
   * @param {string} key - the key for the item
   * This is used to clear the storage
   * @returns {string} the data item
   */
  ;

  _proto.getItem = function getItem(key) {
    return __WEBPACK_IMPORTED_MODULE_0_js_cookie__["get"](key);
  }
  /**
   * This is used to remove an item from storage
   * @param {string} key - the key being set
   * @returns {string} value - value that was deleted
   */
  ;

  _proto.removeItem = function removeItem(key) {
    var options = {
      path: this.path,
      expires: this.expires,
      domain: this.domain,
      secure: this.secure
    };

    if (this.sameSite) {
      options.sameSite = this.sameSite;
    }

    return __WEBPACK_IMPORTED_MODULE_0_js_cookie__["remove"](key, options);
  }
  /**
   * This is used to clear the storage of optional
   * items that were previously set
   * @returns {} an empty object
   */
  ;

  _proto.clear = function clear() {
    var cookies = __WEBPACK_IMPORTED_MODULE_0_js_cookie__["get"]();
    var numKeys = Object.keys(cookies).length;

    for (var index = 0; index < numKeys; ++index) {
      this.removeItem(Object.keys(cookies)[index]);
    }

    return {};
  };

  return CookieStorage;
}();



/***/ }),
/* 2050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["a"] = cryptoSecureRandomInt;
var crypto; // Native crypto from window (Browser)

if (typeof window !== 'undefined' && window.crypto) {
  crypto = window.crypto;
} // Native (experimental IE 11) crypto from window (Browser)


if (!crypto && typeof window !== 'undefined' && window.msCrypto) {
  crypto = window.msCrypto;
} // Native crypto from global (NodeJS)


if (!crypto && typeof global !== 'undefined' && global.crypto) {
  crypto = global.crypto;
} // Native crypto import via require (NodeJS)


if (!crypto && "function" === 'function') {
  try {
    crypto = __webpack_require__(3559);
  } catch (err) {}
}
/*
 * Cryptographically secure pseudorandom number generator
 * As Math.random() is cryptographically not safe to use
 */


function cryptoSecureRandomInt() {
  if (crypto) {
    // Use getRandomValues method (Browser)
    if (typeof crypto.getRandomValues === 'function') {
      try {
        return crypto.getRandomValues(new Uint32Array(1))[0];
      } catch (err) {}
    } // Use randomBytes method (NodeJS)


    if (typeof crypto.randomBytes === 'function') {
      try {
        return crypto.randomBytes(4).readInt32LE();
      } catch (err) {}
    }
  }

  throw new Error('Native crypto module could not be used to get secure random number.');
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(56)))

/***/ }),
/* 2051 */
/***/ (function(module, exports, __webpack_require__) {

var asn1 = __webpack_require__(310);
var inherits = __webpack_require__(41);

var api = exports;

api.define = function define(name, body) {
  return new Entity(name, body);
};

function Entity(name, body) {
  this.name = name;
  this.body = body;

  this.decoders = {};
  this.encoders = {};
};

Entity.prototype._createNamed = function createNamed(base) {
  var named;
  try {
    named = __webpack_require__(3552).runInThisContext(
      '(function ' + this.name + '(entity) {\n' +
      '  this._initNamed(entity);\n' +
      '})'
    );
  } catch (e) {
    named = function (entity) {
      this._initNamed(entity);
    };
  }
  inherits(named, base);
  named.prototype._initNamed = function initnamed(entity) {
    base.call(this, entity);
  };

  return new named(this);
};

Entity.prototype._getDecoder = function _getDecoder(enc) {
  enc = enc || 'der';
  // Lazily create decoder
  if (!this.decoders.hasOwnProperty(enc))
    this.decoders[enc] = this._createNamed(asn1.decoders[enc]);
  return this.decoders[enc];
};

Entity.prototype.decode = function decode(data, enc, options) {
  return this._getDecoder(enc).decode(data, options);
};

Entity.prototype._getEncoder = function _getEncoder(enc) {
  enc = enc || 'der';
  // Lazily create encoder
  if (!this.encoders.hasOwnProperty(enc))
    this.encoders[enc] = this._createNamed(asn1.encoders[enc]);
  return this.encoders[enc];
};

Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter);
};


/***/ }),
/* 2052 */
/***/ (function(module, exports, __webpack_require__) {

var Reporter = __webpack_require__(311).Reporter;
var EncoderBuffer = __webpack_require__(311).EncoderBuffer;
var DecoderBuffer = __webpack_require__(311).DecoderBuffer;
var assert = __webpack_require__(137);

// Supported tags
var tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
];

// Public methods list
var methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags);

// Overrided methods list
var overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
];

function Node(enc, parent) {
  var state = {};
  this._baseState = state;

  state.enc = enc;

  state.parent = parent || null;
  state.children = null;

  // State
  state.tag = null;
  state.args = null;
  state.reverseArgs = null;
  state.choice = null;
  state.optional = false;
  state.any = false;
  state.obj = false;
  state.use = null;
  state.useDecoder = null;
  state.key = null;
  state['default'] = null;
  state.explicit = null;
  state.implicit = null;
  state.contains = null;

  // Should create new instance on each method
  if (!state.parent) {
    state.children = [];
    this._wrap();
  }
}
module.exports = Node;

var stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
];

Node.prototype.clone = function clone() {
  var state = this._baseState;
  var cstate = {};
  stateProps.forEach(function(prop) {
    cstate[prop] = state[prop];
  });
  var res = new this.constructor(cstate.parent);
  res._baseState = cstate;
  return res;
};

Node.prototype._wrap = function wrap() {
  var state = this._baseState;
  methods.forEach(function(method) {
    this[method] = function _wrappedMethod() {
      var clone = new this.constructor(this);
      state.children.push(clone);
      return clone[method].apply(clone, arguments);
    };
  }, this);
};

Node.prototype._init = function init(body) {
  var state = this._baseState;

  assert(state.parent === null);
  body.call(this);

  // Filter children
  state.children = state.children.filter(function(child) {
    return child._baseState.parent === this;
  }, this);
  assert.equal(state.children.length, 1, 'Root node can have only one child');
};

Node.prototype._useArgs = function useArgs(args) {
  var state = this._baseState;

  // Filter children and args
  var children = args.filter(function(arg) {
    return arg instanceof this.constructor;
  }, this);
  args = args.filter(function(arg) {
    return !(arg instanceof this.constructor);
  }, this);

  if (children.length !== 0) {
    assert(state.children === null);
    state.children = children;

    // Replace parent to maintain backward link
    children.forEach(function(child) {
      child._baseState.parent = this;
    }, this);
  }
  if (args.length !== 0) {
    assert(state.args === null);
    state.args = args;
    state.reverseArgs = args.map(function(arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object)
        return arg;

      var res = {};
      Object.keys(arg).forEach(function(key) {
        if (key == (key | 0))
          key |= 0;
        var value = arg[key];
        res[value] = key;
      });
      return res;
    });
  }
};

//
// Overrided methods
//

overrided.forEach(function(method) {
  Node.prototype[method] = function _overrided() {
    var state = this._baseState;
    throw new Error(method + ' not implemented for encoding: ' + state.enc);
  };
});

//
// Public methods
//

tags.forEach(function(tag) {
  Node.prototype[tag] = function _tagMethod() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);

    assert(state.tag === null);
    state.tag = tag;

    this._useArgs(args);

    return this;
  };
});

Node.prototype.use = function use(item) {
  assert(item);
  var state = this._baseState;

  assert(state.use === null);
  state.use = item;

  return this;
};

Node.prototype.optional = function optional() {
  var state = this._baseState;

  state.optional = true;

  return this;
};

Node.prototype.def = function def(val) {
  var state = this._baseState;

  assert(state['default'] === null);
  state['default'] = val;
  state.optional = true;

  return this;
};

Node.prototype.explicit = function explicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.explicit = num;

  return this;
};

Node.prototype.implicit = function implicit(num) {
  var state = this._baseState;

  assert(state.explicit === null && state.implicit === null);
  state.implicit = num;

  return this;
};

Node.prototype.obj = function obj() {
  var state = this._baseState;
  var args = Array.prototype.slice.call(arguments);

  state.obj = true;

  if (args.length !== 0)
    this._useArgs(args);

  return this;
};

Node.prototype.key = function key(newKey) {
  var state = this._baseState;

  assert(state.key === null);
  state.key = newKey;

  return this;
};

Node.prototype.any = function any() {
  var state = this._baseState;

  state.any = true;

  return this;
};

Node.prototype.choice = function choice(obj) {
  var state = this._baseState;

  assert(state.choice === null);
  state.choice = obj;
  this._useArgs(Object.keys(obj).map(function(key) {
    return obj[key];
  }));

  return this;
};

Node.prototype.contains = function contains(item) {
  var state = this._baseState;

  assert(state.use === null);
  state.contains = item;

  return this;
};

//
// Decoding
//

Node.prototype._decode = function decode(input, options) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return input.wrapResult(state.children[0]._decode(input, options));

  var result = state['default'];
  var present = true;

  var prevKey = null;
  if (state.key !== null)
    prevKey = input.enterKey(state.key);

  // Check if tag is there
  if (state.optional) {
    var tag = null;
    if (state.explicit !== null)
      tag = state.explicit;
    else if (state.implicit !== null)
      tag = state.implicit;
    else if (state.tag !== null)
      tag = state.tag;

    if (tag === null && !state.any) {
      // Trial and Error
      var save = input.save();
      try {
        if (state.choice === null)
          this._decodeGeneric(state.tag, input, options);
        else
          this._decodeChoice(input, options);
        present = true;
      } catch (e) {
        present = false;
      }
      input.restore(save);
    } else {
      present = this._peekTag(input, tag, state.any);

      if (input.isError(present))
        return present;
    }
  }

  // Push object on stack
  var prevObj;
  if (state.obj && present)
    prevObj = input.enterObject();

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      var explicit = this._decodeTag(input, state.explicit);
      if (input.isError(explicit))
        return explicit;
      input = explicit;
    }

    var start = input.offset;

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      if (state.any)
        var save = input.save();
      var body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      );
      if (input.isError(body))
        return body;

      if (state.any)
        result = input.raw(save);
      else
        input = body;
    }

    if (options && options.track && state.tag !== null)
      options.track(input.path(), start, input.length, 'tagged');

    if (options && options.track && state.tag !== null)
      options.track(input.path(), input.offset, input.length, 'content');

    // Select proper method for tag
    if (state.any)
      result = result;
    else if (state.choice === null)
      result = this._decodeGeneric(state.tag, input, options);
    else
      result = this._decodeChoice(input, options);

    if (input.isError(result))
      return result;

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren(child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options);
      });
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      var data = new DecoderBuffer(result);
      result = this._getUse(state.contains, input._reporterState.obj)
          ._decode(data, options);
    }
  }

  // Pop object
  if (state.obj && present)
    result = input.leaveObject(prevObj);

  // Set key
  if (state.key !== null && (result !== null || present === true))
    input.leaveKey(prevKey, state.key, result);
  else if (prevKey !== null)
    input.exitKey(prevKey);

  return result;
};

Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
  var state = this._baseState;

  if (tag === 'seq' || tag === 'set')
    return null;
  if (tag === 'seqof' || tag === 'setof')
    return this._decodeList(input, tag, state.args[0], options);
  else if (/str$/.test(tag))
    return this._decodeStr(input, tag, options);
  else if (tag === 'objid' && state.args)
    return this._decodeObjid(input, state.args[0], state.args[1], options);
  else if (tag === 'objid')
    return this._decodeObjid(input, null, null, options);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._decodeTime(input, tag, options);
  else if (tag === 'null_')
    return this._decodeNull(input, options);
  else if (tag === 'bool')
    return this._decodeBool(input, options);
  else if (tag === 'objDesc')
    return this._decodeStr(input, tag, options);
  else if (tag === 'int' || tag === 'enum')
    return this._decodeInt(input, state.args && state.args[0], options);

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
        ._decode(input, options);
  } else {
    return input.error('unknown tag: ' + tag);
  }
};

Node.prototype._getUse = function _getUse(entity, obj) {

  var state = this._baseState;
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj);
  assert(state.useDecoder._baseState.parent === null);
  state.useDecoder = state.useDecoder._baseState.children[0];
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone();
    state.useDecoder._baseState.implicit = state.implicit;
  }
  return state.useDecoder;
};

Node.prototype._decodeChoice = function decodeChoice(input, options) {
  var state = this._baseState;
  var result = null;
  var match = false;

  Object.keys(state.choice).some(function(key) {
    var save = input.save();
    var node = state.choice[key];
    try {
      var value = node._decode(input, options);
      if (input.isError(value))
        return false;

      result = { type: key, value: value };
      match = true;
    } catch (e) {
      input.restore(save);
      return false;
    }
    return true;
  }, this);

  if (!match)
    return input.error('Choice not matched');

  return result;
};

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
  return new EncoderBuffer(data, this.reporter);
};

Node.prototype._encode = function encode(data, reporter, parent) {
  var state = this._baseState;
  if (state['default'] !== null && state['default'] === data)
    return;

  var result = this._encodeValue(data, reporter, parent);
  if (result === undefined)
    return;

  if (this._skipDefault(result, reporter, parent))
    return;

  return result;
};

Node.prototype._encodeValue = function encode(data, reporter, parent) {
  var state = this._baseState;

  // Decode root node
  if (state.parent === null)
    return state.children[0]._encode(data, reporter || new Reporter());

  var result = null;

  // Set reporter to share it with a child class
  this.reporter = reporter;

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state['default'] !== null)
      data = state['default']
    else
      return;
  }

  // Encode children first
  var content = null;
  var primitive = false;
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter);
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter);
    primitive = true;
  } else if (state.children) {
    content = state.children.map(function(child) {
      if (child._baseState.tag === 'null_')
        return child._encode(null, reporter, data);

      if (child._baseState.key === null)
        return reporter.error('Child should have a key');
      var prevKey = reporter.enterKey(child._baseState.key);

      if (typeof data !== 'object')
        return reporter.error('Child expected, but input is not object');

      var res = child._encode(data[child._baseState.key], reporter, data);
      reporter.leaveKey(prevKey);

      return res;
    }, this).filter(function(child) {
      return child;
    });
    content = this._createEncoderBuffer(content);
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      // TODO(indutny): this should be thrown on DSL level
      if (!(state.args && state.args.length === 1))
        return reporter.error('Too many args for : ' + state.tag);

      if (!Array.isArray(data))
        return reporter.error('seqof/setof, but data is not Array');

      var child = this.clone();
      child._baseState.implicit = null;
      content = this._createEncoderBuffer(data.map(function(item) {
        var state = this._baseState;

        return this._getUse(state.args[0], data)._encode(item, reporter);
      }, child));
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter);
    } else {
      content = this._encodePrimitive(state.tag, data);
      primitive = true;
    }
  }

  // Encode data itself
  var result;
  if (!state.any && state.choice === null) {
    var tag = state.implicit !== null ? state.implicit : state.tag;
    var cls = state.implicit === null ? 'universal' : 'context';

    if (tag === null) {
      if (state.use === null)
        reporter.error('Tag could be omitted only for .use()');
    } else {
      if (state.use === null)
        result = this._encodeComposite(tag, primitive, cls, content);
    }
  }

  // Wrap in explicit
  if (state.explicit !== null)
    result = this._encodeComposite(state.explicit, false, 'context', result);

  return result;
};

Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
  var state = this._baseState;

  var node = state.choice[data.type];
  if (!node) {
    assert(
        false,
        data.type + ' not found in ' +
            JSON.stringify(Object.keys(state.choice)));
  }
  return node._encode(data.value, reporter);
};

Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
  var state = this._baseState;

  if (/str$/.test(tag))
    return this._encodeStr(data, tag);
  else if (tag === 'objid' && state.args)
    return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
  else if (tag === 'objid')
    return this._encodeObjid(data, null, null);
  else if (tag === 'gentime' || tag === 'utctime')
    return this._encodeTime(data, tag);
  else if (tag === 'null_')
    return this._encodeNull();
  else if (tag === 'int' || tag === 'enum')
    return this._encodeInt(data, state.args && state.reverseArgs[0]);
  else if (tag === 'bool')
    return this._encodeBool(data);
  else if (tag === 'objDesc')
    return this._encodeStr(data, tag);
  else
    throw new Error('Unsupported tag: ' + tag);
};

Node.prototype._isNumstr = function isNumstr(str) {
  return /^[0-9 ]*$/.test(str);
};

Node.prototype._isPrintstr = function isPrintstr(str) {
  return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};


/***/ }),
/* 2053 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(41);

function Reporter(options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  };
}
exports.Reporter = Reporter;

Reporter.prototype.isError = function isError(obj) {
  return obj instanceof ReporterError;
};

Reporter.prototype.save = function save() {
  var state = this._reporterState;

  return { obj: state.obj, pathLen: state.path.length };
};

Reporter.prototype.restore = function restore(data) {
  var state = this._reporterState;

  state.obj = data.obj;
  state.path = state.path.slice(0, data.pathLen);
};

Reporter.prototype.enterKey = function enterKey(key) {
  return this._reporterState.path.push(key);
};

Reporter.prototype.exitKey = function exitKey(index) {
  var state = this._reporterState;

  state.path = state.path.slice(0, index - 1);
};

Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
  var state = this._reporterState;

  this.exitKey(index);
  if (state.obj !== null)
    state.obj[key] = value;
};

Reporter.prototype.path = function path() {
  return this._reporterState.path.join('/');
};

Reporter.prototype.enterObject = function enterObject() {
  var state = this._reporterState;

  var prev = state.obj;
  state.obj = {};
  return prev;
};

Reporter.prototype.leaveObject = function leaveObject(prev) {
  var state = this._reporterState;

  var now = state.obj;
  state.obj = prev;
  return now;
};

Reporter.prototype.error = function error(msg) {
  var err;
  var state = this._reporterState;

  var inherited = msg instanceof ReporterError;
  if (inherited) {
    err = msg;
  } else {
    err = new ReporterError(state.path.map(function(elem) {
      return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
  }

  if (!state.options.partial)
    throw err;

  if (!inherited)
    state.errors.push(err);

  return err;
};

Reporter.prototype.wrapResult = function wrapResult(result) {
  var state = this._reporterState;
  if (!state.options.partial)
    return result;

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  };
};

function ReporterError(path, msg) {
  this.path = path;
  this.rethrow(msg);
};
inherits(ReporterError, Error);

ReporterError.prototype.rethrow = function rethrow(msg) {
  this.message = msg + ' at: ' + (this.path || '(shallow)');
  if (Error.captureStackTrace)
    Error.captureStackTrace(this, ReporterError);

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message);
    } catch (e) {
      this.stack = e.stack;
    }
  }
  return this;
};


/***/ }),
/* 2054 */
/***/ (function(module, exports, __webpack_require__) {

var constants = __webpack_require__(976);

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
};
exports.tagClassByName = constants._reverse(exports.tagClass);

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
};
exports.tagByName = constants._reverse(exports.tag);


/***/ }),
/* 2055 */
/***/ (function(module, exports, __webpack_require__) {

var decoders = exports;

decoders.der = __webpack_require__(977);
decoders.pem = __webpack_require__(2056);


/***/ }),
/* 2056 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(41);
var Buffer = __webpack_require__(75).Buffer;

var DERDecoder = __webpack_require__(977);

function PEMDecoder(entity) {
  DERDecoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMDecoder, DERDecoder);
module.exports = PEMDecoder;

PEMDecoder.prototype.decode = function decode(data, options) {
  var lines = data.toString().split(/[\r\n]+/g);

  var label = options.label.toUpperCase();

  var re = /^-----(BEGIN|END) ([^-]+)-----$/;
  var start = -1;
  var end = -1;
  for (var i = 0; i < lines.length; i++) {
    var match = lines[i].match(re);
    if (match === null)
      continue;

    if (match[2] !== label)
      continue;

    if (start === -1) {
      if (match[1] !== 'BEGIN')
        break;
      start = i;
    } else {
      if (match[1] !== 'END')
        break;
      end = i;
      break;
    }
  }
  if (start === -1 || end === -1)
    throw new Error('PEM section not found for: ' + label);

  var base64 = lines.slice(start + 1, end).join('');
  // Remove excessive symbols
  base64.replace(/[^a-z0-9\+\/=]+/gi, '');

  var input = new Buffer(base64, 'base64');
  return DERDecoder.prototype.decode.call(this, input, options);
};


/***/ }),
/* 2057 */
/***/ (function(module, exports, __webpack_require__) {

var encoders = exports;

encoders.der = __webpack_require__(978);
encoders.pem = __webpack_require__(2058);


/***/ }),
/* 2058 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(41);

var DEREncoder = __webpack_require__(978);

function PEMEncoder(entity) {
  DEREncoder.call(this, entity);
  this.enc = 'pem';
};
inherits(PEMEncoder, DEREncoder);
module.exports = PEMEncoder;

PEMEncoder.prototype.encode = function encode(data, options) {
  var buf = DEREncoder.prototype.encode.call(this, data);

  var p = buf.toString('base64');
  var out = [ '-----BEGIN ' + options.label + '-----' ];
  for (var i = 0; i < p.length; i += 64)
    out.push(p.slice(i, i + 64));
  out.push('-----END ' + options.label + '-----');
  return out.join('\n');
};


/***/ }),
/* 2059 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2060);

/***/ }),
/* 2060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(115);
var bind = __webpack_require__(985);
var Axios = __webpack_require__(2062);
var mergeConfig = __webpack_require__(983);
var defaults = __webpack_require__(984);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(980);
axios.CancelToken = __webpack_require__(2061);
axios.isCancel = __webpack_require__(981);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(2076);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(2072);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 2061 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(980);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 2062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(115);
var buildURL = __webpack_require__(986);
var InterceptorManager = __webpack_require__(2063);
var dispatchRequest = __webpack_require__(2065);
var mergeConfig = __webpack_require__(983);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 2063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(115);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 2064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(2071);
var combineURLs = __webpack_require__(2069);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 2065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(115);
var transformData = __webpack_require__(2068);
var isCancel = __webpack_require__(981);
var defaults = __webpack_require__(984);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 2066 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 2067 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(982);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 2068 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(115);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 2069 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 2070 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(115);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 2071 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 2072 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return (typeof payload === 'object') && (payload.isAxiosError === true);
};


/***/ }),
/* 2073 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(115);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 2074 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(115);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 2075 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(115);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 2076 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 2077 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchBanks = fetchBanks;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function banksRequest() {
  return {
    type: _actions.BANKS_REQUEST
  };
}

function banksSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.BANKS_SUCCESS,
    payload: {
      data: data,
      token: token
    }
  };
}

function banksError(message) {
  return {
    type: _actions.BANKS_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchBanks() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(banksRequest());
    if (!fresh) {
      var banksData = {};
      try {
        banksData = JSON.parse(localStorage.getItem(_config2.default.get('appName') + '.banks')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!banksData.data || _config2.default.get('version') !== banksData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(banksData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(banksSuccess(banksData.data));
        return Promise.resolve();
      }
    }
    return dispatch((0, _fetchM.fetchM)(_config2.default.get('apiURL') + '/banks/', {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        localStorage.setItem(_config2.default.get('appName') + '.banks', JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(banksSuccess(data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, banksError));
    });
  };
}

/***/ }),
/* 2078 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchHimsDistricts = fetchHimsDistricts;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function himsDistrictsRequest() {
  return {
    type: _actions.HIMS_DISTRICTS_REQUEST
  };
}

function himsDistrictsSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.HIMS_DISTRICTS_SUCCESS,
    payload: {
      data: data,
      token: token
    }
  };
}

function himsDistrictsError(message) {
  return {
    type: _actions.HIMS_DISTRICTS_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchHimsDistricts() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    var himsDistrictsData = {};
    dispatch(himsDistrictsRequest());
    if (!fresh) {
      try {
        himsDistrictsData = JSON.parse(localStorage.getItem(_config2.default.get('appName') + '.himsDistricts')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!himsDistrictsData.data || _config2.default.get('version') !== himsDistrictsData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(himsDistrictsData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(himsDistrictsSuccess(himsDistrictsData.data));
        return Promise.resolve();
      }
    }
    return dispatch((0, _fetchM.fetchM)('/hims/districts/', {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        localStorage.setItem(_config2.default.get('appName') + '.himsDistricts', JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(himsDistrictsSuccess(data, token));
    }).catch(function (err) {
      // reuse data from localStorage in case of error
      if (himsDistrictsData.data) {
        dispatch(himsDistrictsSuccess(himsDistrictsData.data));
        return Promise.resolve();
      }
      dispatch((0, _error.handleError)(err, himsDistrictsError));
      return Promise.reject(err);
    });
  };
}

/***/ }),
/* 2079 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchProjectBusinessUnits = fetchProjectBusinessUnits;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _actions = __webpack_require__(25);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _error = __webpack_require__(63);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function projectBusinessUnitsRequest() {
  return {
    type: _actions.PROJECT_BUSINESS_UNITS_REQUEST
  };
}

function projectBusinessUnitsSuccess(data) {
  var token = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return {
    type: _actions.PROJECT_BUSINESS_UNIT_SUCCESS,
    payload: {
      data: data,
      token: token
    }
  };
}

function projectBusinessUnitsError(message) {
  return {
    type: _actions.PROJECT_BUSINESS_UNIT_FAILURE,
    payload: {
      statusText: message
    }
  };
}

function fetchProjectBusinessUnits() {
  var fresh = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return function (dispatch) {
    var token = null;
    var reload = false;
    dispatch(projectBusinessUnitsRequest());
    if (!fresh) {
      var projectBusinessUnitsData = {};
      try {
        projectBusinessUnitsData = JSON.parse((0, _storage.getItem)(_config2.default.get('appName') + '.projectBusinessUnits')) || {};
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      if (!projectBusinessUnitsData.data || _config2.default.get('version') !== projectBusinessUnitsData.version || (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(projectBusinessUnitsData.createdAt).add(1, 'day'))) {
        reload = true;
      }
      if (!reload) {
        dispatch(projectBusinessUnitsSuccess(projectBusinessUnitsData.data));
        return Promise.resolve();
      }
    }
    return dispatch((0, _fetchM.fetchM)('/projects/company_branches/', {
      credentials: 'include'
    })).then(function (res) {
      token = res.headers.get('X-Csrf-Token');
      return res.json();
    }).then(function (data) {
      try {
        (0, _storage.setItem)(_config2.default.get('appName') + '.projectBusinessUnits', JSON.stringify({
          data: data,
          createdAt: (0, _momentTimezone2.default)().toDate(),
          version: _config2.default.get('version')
        }));
      } catch (e) {
        Bugsnag.notifyException(e);
      }
      dispatch(projectBusinessUnitsSuccess(data, token));
    }).catch(function (err) {
      return dispatch((0, _error.handleError)(err, projectBusinessUnitsError));
    });
  };
}

/***/ }),
/* 2080 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sdsClient = undefined;

var _securedocumentsSdkJs = __webpack_require__(885);

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var sdsClient = exports.sdsClient = new _securedocumentsSdkJs.SecureDocumentsClient({
  baseURL: _config2.default.get('secureDocumentsApiURL'),
  cfDistributionURL: _config2.default.get('secureDocumentsBoxURL'),
  bearerToken: function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return _auth2.default.currentSession();

            case 3:
              return _context.abrupt('return', _context.sent.getAccessToken().getJwtToken());

            case 6:
              _context.prev = 6;
              _context.t0 = _context['catch'](0);
              return _context.abrupt('return', '');

            case 9:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, undefined, [[0, 6]]);
    }));

    return function bearerToken() {
      return _ref.apply(this, arguments);
    };
  }()
});

/***/ }),
/* 2081 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

// Auth config
var Auth = {
  region: "ap-southeast-1",
  userPoolId: "ap-southeast-1_gTvAvTmqn",
  identityPoolId: "ap-southeast-1:708137a7-ca0e-4860-a218-5f1736b101af",
  userPoolWebClientId: "5cjv8obilg2m306dt9kptbmtst",
  cookieStorage: {
    domain: ".mhub.my",
    secure: "production" !== 'development'
  },
  authenticationFlowType: 'USER_PASSWORD_AUTH'
};
if (false) {
  Auth.oauth = {
    domain: process.env.AWS_OAUTH_DOMAIN,
    scope: ['phone', 'email', 'profile', 'openid', 'aws.cognito.signin.user.admin'],
    redirectSignIn: _config2.default.get('startURL'),
    redirectSignOut: _config2.default.get('startURL'),
    // 'code' for Authorization code grant
    // 'token' for Implicit grant
    responseType: 'code',
    // optional, for Cognito hosted ui specified options
    options: {
      // Indicates if the data collection is enabled to support
      // Cognito advanced security features. By default, this flag is set to true.
      AdvancedSecurityDataCollectionFlag: false
    }
  };
}

// API config
var endpoints = [];
if (true) {
  endpoints.push({
    name: 'lawyerAPI',
    endpoint: "https://lawyer-service.prod.mhub.my",
    region: "ap-southeast-1",
    custom_header: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                return _context.abrupt('return', {
                  'Content-Type': 'application/json'
                  // 'X-Api-Token': process.env.LAWYER_API_TOKEN,
                });

              case 1:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, undefined);
      }));

      return function custom_header() {
        return _ref.apply(this, arguments);
      };
    }()
  });
}

var amplifyConfig = {
  Auth: Auth
};

if (endpoints.length > 0) {
  amplifyConfig.API = {
    endpoints: endpoints
  };
}

exports.default = amplifyConfig;

/***/ }),
/* 2082 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddRemarkModal = function (_Component) {
  _inherits(AddRemarkModal, _Component);

  function AddRemarkModal() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, AddRemarkModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddRemarkModal.__proto__ || Object.getPrototypeOf(AddRemarkModal)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      remarkMessage: '',
      ccIDs: [],
      loading: false
    }, _this.setLoading = function (loading) {
      return new Promise(function (res) {
        return _this.setState({ loading: loading }, res);
      });
    }, _this.isCheckedAll = function () {
      var ccIDs = _this.state.ccIDs;
      var bankCases = _this.props.bankCases;

      if (bankCases.length === 0) return false;
      return ccIDs.length === bankCases.length;
    }, _this.isChecked = function (item) {
      return _this.state.ccIDs.includes(item.id);
    }, _this.handleCheckBoxAll = function () {
      var bankCases = _this.props.bankCases;


      _this.setState({
        ccIDs: _this.isCheckedAll() ? [] : bankCases.map(function (c) {
          return c.id;
        })
      });
    }, _this.handleCheckBox = function (item) {
      _this.setState(function (prev) {
        var exists = prev.ccIDs.includes(item.id);
        return {
          ccIDs: exists ? prev.ccIDs.filter(function (id) {
            return id !== item.id;
          }) : [].concat(_toConsumableArray(prev.ccIDs), [item.id])
        };
      });
    }, _this.handleTextAreaChange = function (e) {
      _this.setState({ remarkMessage: e.target.value });
    }, _this.handleSubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var store, _this$props, opportunityID, token, onSuccess, onClose, _this$state, remarkMessage, ccIDs, data, message;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store = _this.context.store;
              _this$props = _this.props, opportunityID = _this$props.opportunityID, token = _this$props.token, onSuccess = _this$props.onSuccess, onClose = _this$props.onClose;
              _this$state = _this.state, remarkMessage = _this$state.remarkMessage, ccIDs = _this$state.ccIDs;

              if (!(!opportunityID || !token)) {
                _context.next = 5;
                break;
              }

              return _context.abrupt('return');

            case 5:
              data = {
                message: remarkMessage,
                type: 'message',
                ccIDs: ccIDs
              };
              _context.next = 8;
              return _this.setLoading(true);

            case 8:
              _context.prev = 8;
              _context.next = 11;
              return store.dispatch((0, _fetchM.fetchM)('/opportunity/' + opportunityID + '/loan_tracker/activity_logs/', {
                credentials: 'include',
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Csrf-Token': token
                },
                body: JSON.stringify(data)
              }));

            case 11:

              store.dispatch((0, _flash.flashSuccessMessage)({
                header: 'Success',
                message: 'Remark was successfully added.'
              }));

              // 👇 notify parent if needed
              if (onSuccess) onSuccess();

              // reset state
              _this.setState({
                remarkMessage: '',
                ccIDs: []
              });

              onClose();
              _context.next = 28;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context['catch'](8);

              if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                _context.next = 26;
                break;
              }

              _context.next = 22;
              return _context.t0.res.text();

            case 22:
              message = _context.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
              _context.next = 28;
              break;

            case 26:
              Bugsnag.notifyException(_context.t0);
              store.dispatch((0, _flash.flashErrorMessage)({
                message: 'There was an error with your request. Please try again.'
              }));

            case 28:
              _context.next = 30;
              return _this.setLoading(false);

            case 30:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[8, 17]]);
    })), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddRemarkModal, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          t = _props.t,
          open = _props.open,
          bankCases = _props.bankCases,
          onClose = _props.onClose;
      var _state = this.state,
          remarkMessage = _state.remarkMessage,
          loading = _state.loading;


      return _react2.default.createElement(
        _semanticUiReact.Modal,
        { size: 'tiny', open: open, onClose: onClose },
        _react2.default.createElement(
          _semanticUiReact.Modal.Header,
          null,
          t('Add Remark', { ns: _translation.TRANSLATION_FILES.translation })
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Form,
            null,
            _react2.default.createElement('textarea', {
              placeholder: t('Type your message here', { ns: _translation.TRANSLATION_FILES.translation }),
              onChange: this.handleTextAreaChange,
              value: remarkMessage,
              maxLength: '160',
              style: { resize: 'none', minHeight: '5.5em', width: '100%' }
            }),
            _react2.default.createElement(
              'div',
              { style: { textAlign: 'right' } },
              _react2.default.createElement(
                'small',
                null,
                remarkMessage.length,
                ' / 160'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Form.Group,
              null,
              _react2.default.createElement(
                'small',
                null,
                t('Notify:', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              bankCases.map(function (item) {
                return _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  key: item.id,
                  label: item.bank.shortName,
                  onChange: function onChange() {
                    return _this3.handleCheckBox(item);
                  },
                  checked: _this3.isChecked(item)
                });
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: t('All', { ns: _translation.TRANSLATION_FILES.translation }),
                onChange: this.handleCheckBoxAll,
                checked: this.isCheckedAll()
              })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(
            _semanticUiReact.Button,
            { onClick: onClose },
            t('Cancel', { ns: _translation.TRANSLATION_FILES.translation })
          ),
          _react2.default.createElement(_semanticUiReact.Button, {
            onClick: this.handleSubmit,
            loading: loading,
            disabled: !remarkMessage,
            primary: true,
            content: t('Add', { ns: _translation.TRANSLATION_FILES.translation })
          })
        )
      );
    }
  }]);

  return AddRemarkModal;
}(_react.Component);

AddRemarkModal.contextTypes = {
  store: _propTypes2.default.object
};
AddRemarkModal.propTypes = {
  open: _propTypes2.default.bool,
  bankCases: _propTypes2.default.array,
  opportunityID: _propTypes2.default.string,
  token: _propTypes2.default.string,
  onClose: _propTypes2.default.func,
  onSuccess: _propTypes2.default.func
};
AddRemarkModal.defaultProps = {
  bankCases: []
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(AddRemarkModal);

/***/ }),
/* 2083 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _webValidations = __webpack_require__(23);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddressSettingList = function (_Component) {
  _inherits(AddressSettingList, _Component);

  function AddressSettingList(props) {
    _classCallCheck(this, AddressSettingList);

    var _this = _possibleConstructorReturn(this, (AddressSettingList.__proto__ || Object.getPrototypeOf(AddressSettingList)).call(this, props));

    _this.handleLabelChange = function (event, _ref) {
      var name = _ref.name,
          value = _ref.value;
      var data = _this.state.data;

      var index = data.findIndex(function (d) {
        return d.columnName === name;
      });
      if (index >= 0) {
        data[index].label = value;
      }
      _this.setState({ data: data }, function () {
        _this.props.onChange(data);
      });
    };

    _this.handleRequiredChange = function (event, _ref2) {
      var name = _ref2.name;
      var data = _this.state.data;

      var index = data.findIndex(function (f) {
        return f.columnName === name;
      });
      if (index >= 0) {
        data[index].required = !data[index].required;
      }
      _this.setState({ data: data }, function () {
        _this.props.onChange(data);
      });
    };

    _this.handleEnabledChange = function (event, _ref3) {
      var name = _ref3.name;
      var data = _this.state.data;

      var index = data.findIndex(function (f) {
        return f.columnName === name;
      });
      if (index >= 0) {
        data[index].enabled = !data[index].enabled;
      }
      _this.setState({ data: data }, function () {
        _this.props.onChange(data);
      });
    };

    _this.state = {
      count: 0,
      loading: props.loading || true,
      data: [],
      errMessages: []
    };
    _this.validation = {};
    return _this;
  }

  _createClass(AddressSettingList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchAddressSettings();
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'validate',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this4 = this;

        var data, stateData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = this.state.data;
                stateData = data.reduce(function (d, cur) {
                  var _extends2;

                  return _extends({}, d, (_extends2 = {}, _defineProperty(_extends2, cur.columnName + '_label', cur.label), _defineProperty(_extends2, cur.columnName + '_required', cur.required), _defineProperty(_extends2, cur.columnName + '_enabled', cur.enabled), _extends2));
                }, {});
                return _context.abrupt('return', _AppForm2.default.validate(this.validation, stateData).then(function (validations) {
                  _this4.setState({
                    errMessages: validations.filter(function (v) {
                      return !v.isValid;
                    })
                  });
                  return validations;
                }));

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function validate() {
        return _ref4.apply(this, arguments);
      }

      return validate;
    }()
  }, {
    key: 'fetchAddressSettings',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, t, query, res, message, count, token, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = {
                  page: 'all'
                };
                res = void 0;
                _context2.prev = 6;
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/address_settings/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context2.sent;
                _context2.next = 20;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context2.next = 19;
                return this.setLoading(false);

              case 19:
                return _context2.abrupt('return');

              case 20:
                if (res.ok) {
                  _context2.next = 28;
                  break;
                }

                _context2.next = 23;
                return res.text();

              case 23:
                message = _context2.sent;
                _context2.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context2.next = 36;
                break;

              case 28:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                token = res.headers.get('X-Csrf-Token');
                _context2.next = 32;
                return res.json();

              case 32:
                data = _context2.sent;
                _context2.next = 35;
                return this.setComponentState({
                  count: count,
                  token: token,
                  data: data || []
                });

              case 35:
                this.props.onOriChange(data);

              case 36:
                _context2.next = 38;
                return this.setLoading(false);

              case 38:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 12]]);
      }));

      function fetchAddressSettings() {
        return _ref5.apply(this, arguments);
      }

      return fetchAddressSettings;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 20 },
            active: this.state.loading && this.state.data.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            striped: true, unstackable: true,
            selectable: true
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 4 },
                t('Field')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 4 },
                t('Label')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 3, textAlign: 'right' },
                t('Required')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 3, textAlign: 'right' },
                t('Enabled')
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            this.state.data.length > 0 ? this.state.data.map(function (field, key) {
              var columnName = _lodash2.default.startCase(field.columnName);
              columnName = columnName.split(' ');
              columnName = t(columnName[0]).concat(' ', columnName[1]);
              // add validateRef
              _this5.validation[field.columnName + '_label'] = (0, _react.createRef)();
              return _react2.default.createElement(
                _semanticUiReact.Table.Row,
                { key: key },
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { width: 4 },
                  columnName
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { width: 4 },
                  _react2.default.createElement(_AppForm2.default.Input, {
                    validateLabel: t('{{columnName}}\'s Label', { columnName: columnName }),
                    name: field.columnName,
                    value: field.label,
                    validation: [_webValidations.required],
                    onChange: _this5.handleLabelChange,
                    ref: _this5.validation[field.columnName + '_label']
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { textAlign: 'right' },
                  _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    toggle: true,
                    checked: field.required,
                    name: field.columnName,
                    onChange: _this5.handleRequiredChange
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { textAlign: 'right' },
                  _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    toggle: true,
                    checked: field.enabled,
                    name: field.columnName,
                    onChange: _this5.handleEnabledChange
                  })
                )
              );
            }) : _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 4, textAlign: 'center' },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                ) : _react2.default.createElement(
                  'p',
                  null,
                  t('No address fields found'),
                  '.'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return AddressSettingList;
}(_react.Component);

AddressSettingList.contextTypes = {
  store: _propTypes2.default.object
};
AddressSettingList.propTypes = {
  loading: _propTypes2.default.bool,
  onOriChange: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func.isRequired
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(AddressSettingList);

/***/ }),
/* 2084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddBankerAnnouncement = function (_Component) {
  _inherits(AddBankerAnnouncement, _Component);

  function AddBankerAnnouncement(props) {
    var _this2 = this;

    _classCallCheck(this, AddBankerAnnouncement);

    var _this = _possibleConstructorReturn(this, (AddBankerAnnouncement.__proto__ || Object.getPrototypeOf(AddBankerAnnouncement)).call(this, props));

    _this.handleOnClose = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(showBankers) {
        var store;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = _this.context.store;
                _context.prev = 1;
                _context.next = 4;
                return (0, _fetchM.serverRequestPut)(_config2.default.get('apiURL') + '/profile/', store, _this.state.token, { announcementAddBanker: (0, _momentTimezone2.default)().format('YYYY-MM-DDTHH:mm:ss') + 'Z' });

              case 4:
                _context.next = 9;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context['catch'](1);

                Bugsnag.notifyException(_context.t0);

              case 9:
                _this.setState({
                  show: false
                }, function () {
                  if (showBankers) {
                    store.dispatch((0, _reactRouterRedux.push)('/preferred_bankers/'));
                  }
                });

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 6]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.state = {
      show: false,
      token: null
    };
    return _this;
  }

  _createClass(AddBankerAnnouncement, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.fetchProfile();
      var show = nextProps.show;

      this.setState({
        show: show
      });
    }
  }, {
    key: 'fetchProfile',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, res, token;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                res = void 0;
                _context2.prev = 2;
                _context2.next = 5;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('apiURL') + '/profile/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                res = _context2.sent;
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](2);

                Bugsnag.notifyException(_context2.t0);

              case 11:
                if (res.ok) {
                  token = res.headers.get('X-Csrf-Token');

                  this.setState({
                    token: token
                  });
                }

              case 12:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 8]]);
      }));

      function fetchProfile() {
        return _ref2.apply(this, arguments);
      }

      return fetchProfile;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var show = this.state.show;
      var auth = this.props.auth;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          size: 'small',
          open: show,
          onClose: this.handleOnClose
        },
        _react2.default.createElement(_semanticUiReact.Header, { content: 'Hello ' + auth.preferredName }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            'Welcome to MHub, a people-powered property platform! To get started, you may add or invite your preferred bankers by clicking the button below.'
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { positive: true, onClick: function onClick() {
              return _this3.handleOnClose(true);
            }, content: 'Add Banker' }),
          _react2.default.createElement(_semanticUiReact.Button, { onClick: function onClick() {
              return _this3.handleOnClose(false);
            }, content: 'Close' })
        )
      );
    }
  }]);

  return AddBankerAnnouncement;
}(_react.Component);

AddBankerAnnouncement.propTypes = {
  auth: _propTypes2.default.shape({
    preferredName: _propTypes2.default.string
  }),
  show: _propTypes2.default.bool
};
AddBankerAnnouncement.contextTypes = {
  store: _propTypes2.default.object
};

AddBankerAnnouncement.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

exports.default = (0, _reactRedux.connect)(AddBankerAnnouncement.mapStateToProps)(AddBankerAnnouncement);

/***/ }),
/* 2085 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _reactRouter = __webpack_require__(18);

var _reactGa = __webpack_require__(288);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _apps = __webpack_require__(263);

var _translation = __webpack_require__(4);

var _moduleAccess = __webpack_require__(595);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var AppFooter = function (_Component) {
  _inherits(AppFooter, _Component);

  function AppFooter(props) {
    _classCallCheck(this, AppFooter);

    var _this = _possibleConstructorReturn(this, (AppFooter.__proto__ || Object.getPrototypeOf(AppFooter)).call(this, props));

    _this.gaEvent = function (e, module) {
      _reactGa2.default.event('BOOK_FOOTER_LINK', {
        category: 'BOOK_FOOTER_LINK',
        action: module.route || module.link,
        route: module.route || module.link,
        label: module.name,
        name: module.name
      });
    };

    _this.modulesFiltered = function () {
      return _this.modules().filter(function (module) {
        if (_this.props.auth.isSuperAdmin && module.isSuperAdmin) {
          return module.isSuperAdmin;
        }
        if (_this.props.auth.isHeadquarters && module.isHeadquarters) {
          return module.isHeadquarters;
        }
        if (_this.props.auth.isBranchLeader && module.isBranchLeader) {
          return module.isBranchLeader;
        }
        if (_this.props.auth.isDeveloper && module.isDeveloper) {
          return module.isDeveloper;
        }
        if (_this.props.auth.isSiteplan && module.isSiteplan) {
          return module.isSiteplan;
        }
        if (_this.props.auth.isBranchLeaderSupervisorII && module.isBranchLeaderSupervisorII) {
          return module.isBranchLeaderSupervisorII;
        }
        if (_this.props.auth.isAdminBasic && module.isAdminBasic) {
          return module.isAdminBasic;
        }
        if (_this.props.auth.isAdminCommunity && module.isAdminCommunity) {
          return module.isAdminCommunity;
        }
        return false;
      });
    };

    _this.state = {
      leadURL: ''
    };
    return _this;
  }

  _createClass(AppFooter, [{
    key: 'getLeadURL',
    value: function getLeadURL() {
      var auth = this.props.auth;

      if (auth && auth.companyApps) {
        var leadv2 = auth.companyApps.find(function (ca) {
          return ca.appID === _apps.LEADV2;
        });
        return leadv2.webURL;
      }
      return '';
    }
  }, {
    key: 'hasLeadAccess',
    value: function hasLeadAccess() {
      var auth = this.props.auth;

      if (auth && auth.companyApps) {
        var leadv2 = auth.companyApps.find(function (ca) {
          return ca.appID === _apps.LEADV2;
        });
        if (leadv2) {
          if (leadv2.trialEndsAt && (0, _momentTimezone2.default)(leadv2.trialEndsAt).unix() > (0, _momentTimezone2.default)().unix() || !leadv2.trialEndsAt) {
            return true;
          }
        }
      }
      return false;
    }
  }, {
    key: 'modules',
    value: function modules() {
      var restrictedAccess = (0, _moduleAccess.restrictedModuleAccess)(this.props.auth);
      return [{
        name: 'View All Projects',
        route: '/projects/',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: true,
        isSiteplan: true,
        isSuperAdmin: true,
        isBranchLeaderSupervisorII: false
      }, {
        name: 'View All Bookings',
        route: '/bookings/',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: true,
        isSiteplan: false,
        isSuperAdmin: true,
        isBranchLeaderSupervisorII: false
      }, {
        name: 'Manage Bookings',
        route: '/bookings/manage/',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: false,
        isSiteplan: false,
        isSuperAdmin: true,
        isBranchLeaderSupervisorII: false
      }, this.hasLeadAccess() && {
        name: 'Lead Management',
        link: this.getLeadURL(),
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: true,
        isSiteplan: true,
        isSuperAdmin: true,
        isBranchLeaderSupervisorII: false
      }, {
        name: 'Add New Project',
        route: '/projects/new/',
        enabled: true,
        isBranchLeader: false,
        isHeadquarters: true,
        isDeveloper: false,
        isSiteplan: false,
        isSuperAdmin: true,
        isBranchLeaderSupervisorII: true
      }, {
        name: 'Add New User',
        route: '/users/new/',
        enabled: true,
        isBranchLeader: this.props.auth.isBranchLeaderSupervisor || false,
        isHeadquarters: true,
        isDeveloper: false,
        isSiteplan: false,
        isSuperAdmin: true,
        isBranchLeaderSupervisorII: false
      }, {
        name: 'Manage Media',
        route: '/media/',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: false,
        isSiteplan: false,
        isSuperAdmin: true,
        isBranchLeaderSupervisorII: false
      }, _extends({
        name: 'Manage Payments',
        route: '/payments/',
        enabled: true,
        isBranchLeader: false,
        isDeveloper: false,
        isHeadquarters: true,
        isSuperAdmin: true,
        isBranchLeaderSupervisorII: false
      }, restrictedAccess), _extends({
        name: 'Manage Bankers',
        route: '/preferred_bankers/',
        enabled: true,
        isDeveloper: true,
        isHeadquarters: true,
        isSuperAdmin: true
      }, restrictedAccess), {
        name: 'Manage Agencies',
        route: '/business_units/',
        enabled: true,
        isDeveloper: false,
        isHeadquarters: true,
        isSuperAdmin: true
      }, {
        name: 'Help',
        route: 'https://drive.google.com/drive/folders/1U6gMqLGf06-8mGZGPcKG3Ukn6-spYaQ-',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: true,
        isSiteplan: true,
        isSuperAdmin: true
      }];
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        'footer',
        { className: 'app-footer' },
        _react2.default.createElement(
          'div',
          { className: 'app-quick-links-footer' },
          _react2.default.createElement(
            _semanticUiReact.Container,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { style: { paddingTop: '1em', paddingBottom: '0.5em', fontSize: '14px' } },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(
                    'b',
                    null,
                    t('Quick Links')
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 8, computer: 8 },
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      { className: 'app-link-links', columns: 3 },
                      this.modulesFiltered().map(function (module, idx) {
                        return _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          {
                            className: 'app-link-list',
                            name: module.name,
                            key: idx,
                            as: _reactRouter.Link,
                            to: module.link ? '' : module.route,
                            href: module.link && module.link,
                            onClick: function onClick(e) {
                              return _this2.gaEvent(e, module);
                            },
                            target: module.name === 'Help' || module.name === 'Lead Management' ? '_blank' : null
                          },
                          t(module.name)
                        );
                      })
                    )
                  )
                ),
                _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'tablet computer', tablet: 8, computer: 8 })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'app-copyright-footer' },
          _react2.default.createElement(
            _semanticUiReact.Container,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { mobile: 16, tablet: 11, computer: 12 },
                'Copyright \xA9 ',
                (0, _momentTimezone2.default)().format('YYYY'),
                ' - TRB Ventures Sdn Bhd. All rights reserved.'
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { className: 'app-footer-v', mobile: 16, tablet: 5, computer: 4 },
                'v',
                _config2.default.get('version'),
                _config2.default.get('server') === 'development' || _config2.default.get('server') === 'staging' ? ' | ' + _config2.default.get('gitBranch') + ' (' + _config2.default.get('gitHash') + ')' : ''
              )
            )
          )
        )
      );
    }
  }]);

  return AppFooter;
}(_react.Component);

AppFooter.propTypes = {
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isDeveloper: _propTypes2.default.bool,
    isSiteplan: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isBranchLeaderSupervisor: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isAdminCommunity: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  })
};

AppFooter.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)((0, _reactRedux.connect)(AppFooter.mapStateToProps)(AppFooter));

/***/ }),
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fetchM = __webpack_require__(6);

var _Input = __webpack_require__(1003);

var _Input2 = _interopRequireDefault(_Input);

var _Helper = __webpack_require__(381);

var _Helper2 = _interopRequireDefault(_Helper);

var _Validate = __webpack_require__(219);

var _Validate2 = _interopRequireDefault(_Validate);

var _Select = __webpack_require__(382);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AppForm = function (_Component) {
  _inherits(AppForm, _Component);

  function AppForm(props) {
    _classCallCheck(this, AppForm);

    var _this = _possibleConstructorReturn(this, (AppForm.__proto__ || Object.getPrototypeOf(AppForm)).call(this, props));

    _this.setLoading = function () {
      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return new Promise(function (res) {
        _this.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    };

    _this.handleSubmit = function (event) {
      _this.props.onSubmit(event);
    };

    _this.state = {
      loading: false
    };
    return _this;
  }

  _createClass(AppForm, [{
    key: 'submit',
    value: function submit(url) {
      var _this2 = this;

      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var store = this.context.store;

      return this.setLoading(true).then(function () {
        return store.dispatch((0, _fetchM.fetchM)(url, opts));
      }).then(function (res) {
        return res.json();
      }).then(function (result) {
        return _this2.setLoading(false).then(function () {
          return result;
        });
      }).catch(function (err) {
        return _this2.setLoading(false).then(function () {
          return Promise.reject(err);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _semanticUiReact.Form,
        {
          as: this.props.as,
          className: this.props.className,
          onSubmit: this.handleSubmit,
          error: this.props.error,
          loading: this.state.loading,
          id: this.props.id
        },
        this.props.children
      );
    }
  }]);

  return AppForm;
}(_react.Component);

AppForm.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  children: _propTypes2.default.node,
  error: _propTypes2.default.bool,
  id: _propTypes2.default.string,
  as: _propTypes2.default.string,
  className: _propTypes2.default.string
};
AppForm.contextTypes = {
  store: _propTypes2.default.object
};

AppForm.validate = function (objRefs, values) {
  // objRefs should be an object with refs
  var validations = [];
  Object.keys(objRefs).forEach(function (key) {
    var ref = objRefs[key];
    // ref should be Validate component
    if (!ref || ref && !ref.current) {
      return;
    }

    // access `validate` function from Validate component
    var validate = ref.current.validate;
    var validateRef = ref.current.validateRef;

    if (validateRef && validateRef.current) {
      validate = validateRef.current.validate;
    }
    if (validate) {
      validations.push(validate(values[key]));
    }
  });
  return Promise.all(validations);
};

AppForm.Input = _Input2.default;
AppForm.Helper = _Helper2.default;
AppForm.Validate = _Validate2.default;
AppForm.Select = _Select2.default;
exports.default = AppForm;

/***/ }),
/* 2087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _apps = __webpack_require__(263);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AppMenu = function (_Component) {
  _inherits(AppMenu, _Component);

  function AppMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AppMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AppMenu.__proto__ || Object.getPrototypeOf(AppMenu)).call.apply(_ref, [this].concat(args))), _this), _this.handlePushLink = function (url) {
      var store = _this.context.store;

      store.dispatch((0, _reactRouterRedux.push)(url));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AppMenu, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isSiteplan = _props.isSiteplan,
          apps = _props.apps;

      var appsAccess = apps ? apps.filter(function (app) {
        if (isSiteplan) {
          return app.hasAccess && app.appID !== _apps.SHOWROOM;
        }
        return app.hasAccess;
      }) : [];

      return _react2.default.createElement(
        _semanticUiReact.Menu,
        { secondary: true },
        Array.isArray(appsAccess) && appsAccess.length > 0 ? appsAccess.map(function (app) {
          return _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            {
              key: app.appID,
              name: app.app.shortName,
              href: app.appID !== 'showroom' ? app.webURL : null,
              active: app.appID === 'showroom',
              onClick: app.appID === 'showroom' ? function () {
                return _this2.handlePushLink('/');
              } : function () {}
            },
            app.app.shortName,
            app.expiresText && _react2.default.createElement(
              'p',
              { style: { fontStyle: 'italic', fontSize: '9px' } },
              '\xA0\xA0',
              app.expiresText
            )
          );
        }) : null
      );
    }
  }]);

  return AppMenu;
}(_react.Component);

AppMenu.contextTypes = {
  store: _propTypes2.default.object
};
AppMenu.propTypes = {
  isSiteplan: _propTypes2.default.bool,
  apps: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    appID: _propTypes2.default.string.isRequired,
    webURL: _propTypes2.default.string,
    app: _propTypes2.default.shape({
      shortName: _propTypes2.default.string.isRequired
    }).isRequired
  }))
};
exports.default = AppMenu;

/***/ }),
/* 2088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _webValidations = __webpack_require__(23);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _SelectBank = __webpack_require__(218);

var _SelectBank2 = _interopRequireDefault(_SelectBank);

var _translation = __webpack_require__(4);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BankAccounts = function (_Component) {
  _inherits(BankAccounts, _Component);

  function BankAccounts(props) {
    _classCallCheck(this, BankAccounts);

    var _this = _possibleConstructorReturn(this, (BankAccounts.__proto__ || Object.getPrototypeOf(BankAccounts)).call(this, props));

    _initialiseProps.call(_this);

    var state = _this.getPropsToState(props);
    _this.validationForEdit = {};
    _this.validationForCreate = {
      newBank: (0, _react.createRef)(),
      newAccountNumber: (0, _react.createRef)()
    };
    _this.state = _extends({
      dataToBeDelete: {},
      isEditing: false,
      isNew: false
    }, state);
    return _this;
  }

  _createClass(BankAccounts, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = this.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          auth = _props.auth,
          t = _props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 20 },
            active: this.state.loading && this.state.data.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _AppForm2.default,
          {
            onSubmit: this.handleSubmit,
            ref: function ref(_ref) {
              _this2.form = _ref;
            },
            as: 'div'
          },
          _react2.default.createElement(
            _semanticUiReact.Table,
            {
              striped: true,
              selectable: true,
              padded: true
            },
            _react2.default.createElement(
              _semanticUiReact.Table.Header,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  { colSpan: 4, textAlign: 'left' },
                  _react2.default.createElement(_semanticUiReact.Button, {
                    disabled: this.state.isNew,
                    primary: true,
                    size: 'small',
                    icon: 'add',
                    content: t('Add', { ns: _translation.TRANSLATION_FILES.translation }),
                    onClick: this.onClickAdd
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  null,
                  t('Bank')
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  null,
                  t('Account Number')
                ),
                _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null),
                _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null)
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Body,
              null,
              this.state.data.length > 0 ? this.state.data.map(function (value, index) {
                return _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  { key: index },
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    value.bank
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    value.accountNumber
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    { textAlign: 'right' },
                    value.isActive ? _react2.default.createElement(
                      _semanticUiReact.Label,
                      { color: 'blue', basic: true, horizontal: true },
                      t('Active', { ns: _translation.TRANSLATION_FILES.constants })
                    ) : _react2.default.createElement(
                      _semanticUiReact.Label,
                      { color: 'grey', basic: true, horizontal: true },
                      t('Inactive', { ns: _translation.TRANSLATION_FILES.constants })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    _react2.default.createElement(_semanticUiReact.Popup, {
                      trigger: _react2.default.createElement(
                        _semanticUiReact.Button,
                        {
                          negative: value.isActive,
                          positive: !value.isActive,
                          name: 'isActive',
                          className: 'ui compact icon primary button',
                          onClick: function onClick(e) {
                            return _this2.onSave(index, e, { name: 'isActive', value: !value.isActive });
                          }
                        },
                        value.isActive ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'close' }) : _react2.default.createElement(_semanticUiReact.Icon, { name: 'check' })
                      ), content: t(value.isActive ? 'Deactivate' : 'Activate')
                    })
                  )
                );
              }) : _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { colSpan: 4, textAlign: 'center' },
                  this.state.loading ? _react2.default.createElement(
                    _semanticUiReact.Loader,
                    { active: true, inline: 'centered' },
                    t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                  ) : t('No bank account found') + '.'
                )
              )
            ),
            this.state.isNew ? _react2.default.createElement(
              _semanticUiReact.Table.Body,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                { active: true },
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  _react2.default.createElement(_SelectBank2.default, {
                    country: auth && auth.company ? auth.company.countryCode : '',
                    validation: [_webValidations.required],
                    validateLabel: t('Bank'),
                    ref: this.validationForCreate.newBank,
                    onChange: this.handleSelectChange,
                    text: this.state.selectedBank ? null : t('Select {{title}}', { title: t('Bank') }),
                    autoComplete: 'off',
                    name: 'selectedBank',
                    value: this.state.selectedBank
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  _react2.default.createElement(_AppForm2.default.Input, {
                    hideMessage: true,
                    validateLabel: t('Account Number'),
                    name: 'newAccountNumber',
                    value: this.state.newAccountNumber,
                    onChange: this.handleInputChange,
                    ref: this.validationForCreate.newAccountNumber,
                    validation: [_webValidations.required],
                    type: 'text'
                  })
                ),
                _react2.default.createElement(_semanticUiReact.Table.Cell, null),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { collapsing: true },
                  _react2.default.createElement(_semanticUiReact.Popup, {
                    trigger: _react2.default.createElement(
                      _semanticUiReact.Button,
                      {
                        positive: true,
                        className: 'ui compact icon primary button',
                        onClick: this.onCreate
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus' })
                    ), content: t('Create', { ns: _translation.TRANSLATION_FILES.translation })
                  }),
                  _react2.default.createElement(_semanticUiReact.Popup, {
                    trigger: _react2.default.createElement(
                      _semanticUiReact.Button,
                      {
                        negative: true,
                        className: 'ui compact icon primary button',
                        onClick: this.onCancelCreate
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'close' })
                    ), content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation })
                  })
                )
              )
            ) : null
          )
        )
      );
    }
  }]);

  return BankAccounts;
}(_react.Component);

BankAccounts.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  project: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  loading: _propTypes2.default.bool,
  onDefaultAdd: _propTypes2.default.func.isRequired,
  onDefaultSave: _propTypes2.default.func.isRequired
};
BankAccounts.contextTypes = {
  store: _propTypes2.default.object
};
BankAccounts.defaultBankAccount = {
  selectedBank: null,
  newBank: '',
  newAccountNumber: '',
  isEditing: false
};

BankAccounts.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getPropsToState = function (props) {
    var data = props.data;
    var loading = props.loading;

    return _extends({
      data: data,
      loading: loading
    }, BankAccounts.defaultBankAccount);
  };

  this.handleEditChange = function (index, event, _ref2) {
    var value = _ref2.value,
        name = _ref2.name;

    event.preventDefault();
    var extraState = {};
    if (name === 'isEdit') {
      // toggle isEditing flag to allow only one edit at a time
      extraState.isEditing = !_this3.state.isEditing;
    }

    var data = _this3.state.data;

    data[index] = Object.assign({}, data[index], _defineProperty({}, name, value));
    _this3.setState(_extends({
      data: data
    }, extraState));
  };

  this.handleInputChange = function (e, d) {
    _this3.setState(_defineProperty({}, d.name, d.value));
  };

  this.handleSelectChange = function (e, d) {
    _this3.setState({
      newBank: d.value,
      selectedBank: d.value
    });
  };

  this.handleSubmit = function (e) {
    e.preventDefault();
  };

  this.onClickAdd = function (e) {
    e.preventDefault();
    _this3.setState({ isNew: true });
  };

  this.onCancelCreate = function (e) {
    e.preventDefault();
    _this3.setState({
      isNew: false
    });
  };

  this.onCreate = function (e) {
    e.preventDefault();
    return _AppForm2.default.validate(_this3.validationForCreate, _this3.state).then(function (validations) {
      var value = {
        bank: _this3.state.newBank,
        accountNumber: _this3.state.newAccountNumber,
        isActive: true
      };
      _this3.props.onDefaultAdd(validations, { value: value });
    });
  };

  this.onSave = function (index, e, _ref3) {
    var name = _ref3.name,
        value = _ref3.value;

    e.preventDefault();
    var store = _this3.context.store;
    var _props2 = _this3.props,
        project = _props2.project,
        t = _props2.t;

    var bankAccount = _this3.state.data[index];

    if (name === 'isActive' && !value) {
      if (project.marketplaceIsPublish || project.marketplaceBuyerIsPublish) {
        return store.dispatch((0, _flash.flashMessage)({
          header: t('Error', { ns: _translation.TRANSLATION_FILES.translation }),
          message: t('At least an active bank account is required to launch project to Marketplace', { ns: _translation.TRANSLATION_FILES.translation }),
          icon: 'warning sign',
          type: 'error'
        }));
      }
    }

    bankAccount[name] = value;
    var data = {
      bank: bankAccount.bank,
      accountNumber: bankAccount.accountNumber,
      id: bankAccount.id,
      isActive: bankAccount.isActive,
      index: index
    };

    return _AppForm2.default.validate(_this3.validationForEdit, data).then(function (validations) {
      _this3.props.onDefaultSave(validations, { value: data });
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(BankAccounts.mapStateToProps)(BankAccounts));

/***/ }),
/* 2089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getBank = function getBank(banks, bankID) {
  return banks.data.find(function (b) {
    return '' + b.id === '' + bankID;
  });
};

var BankIcon = function BankIcon(_ref) {
  var bankID = _ref.bankID,
      banks = _ref.banks,
      type = _ref.type;

  if (banks.isFetching) {
    return _react2.default.createElement(
      'span',
      null,
      '...'
    );
  }
  var bank = getBank(banks, bankID);
  if (!bank) {
    return _react2.default.createElement(
      'span',
      null,
      'N/A'
    );
  }
  return _react2.default.createElement(
    'div',
    { className: bank.code.toLowerCase() + ' brands ' + (type || 'round') },
    _react2.default.createElement(
      'span',
      null,
      bank.shortName || bank.code
    )
  );
};

BankIcon.propTypes = {
  bankID: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  banks: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }).isRequired,
  type: _propTypes2.default.string
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    banks: state.banks
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(BankIcon);

/***/ }),
/* 2090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _UploadModal = __webpack_require__(92);

var _UploadModal2 = _interopRequireDefault(_UploadModal);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

var _Form = __webpack_require__(267);

var _Form2 = _interopRequireDefault(_Form);

var _fileSize = __webpack_require__(85);

var _fileSize2 = _interopRequireDefault(_fileSize);

var _url = __webpack_require__(19);

var _translation = __webpack_require__(4);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// components

// containers

// utils


// Still needed for the module-level locale; the upload time renders through Timestamp.
_momentTimezone2.default.locale('en-gb');

var BookingAttachment = function (_Component) {
  _inherits(BookingAttachment, _Component);

  function BookingAttachment(props) {
    _classCallCheck(this, BookingAttachment);

    var _this = _possibleConstructorReturn(this, (BookingAttachment.__proto__ || Object.getPrototypeOf(BookingAttachment)).call(this, props));

    _initialiseProps.call(_this);

    var state = BookingAttachment.getPropsToState(props);
    _this.state = _extends({}, state, {
      loading: false,
      showDeleteAttachmentConfirm: false,
      deleteFile: null
    });
    _this.validation = {};
    return _this;
  }

  _createClass(BookingAttachment, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.onRef(this);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = BookingAttachment.getPropsToState(nextProps);
      // don't allow state to override data if oriData is same
      if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
        state.data = this.state.data;
      }
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.props.onRef(undefined);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          data = _state.data,
          deleteFile = _state.deleteFile,
          uploadModalState = _state.uploadModalState;
      var _props = this.props,
          isMobile = _props.isMobile,
          t = _props.t;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Header,
          { className: 'new_title', as: 'h5', attached: 'top', textAlign: 'center' },
          t('Attachment').toUpperCase()
        ),
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { attached: true },
          _react2.default.createElement(_UploadModal2.default, {
            modalState: uploadModalState,
            trigger: _react2.default.createElement('span', null),
            ref: function ref(_ref2) {
              _this2.uploadModal = _ref2;
            },
            header: 'attachments',
            loading: this.state.loading,
            onConfirm: function onConfirm(e, file) {
              return _this2.handleUploadDocs(e, file);
            },
            onClose: this.handleUploadModalClose,
            primary: false,
            content: function content(opt) {
              return _react2.default.createElement(_Form2.default, {
                ref: function ref(_ref) {
                  _this2.form = _ref;
                },
                fileType: 'attachment',
                loading: _this2.state.loading,
                onSubmit: opt.onConfirm,
                btnText: 'Attachments'
              });
            }
          }),
          _react2.default.createElement(_DeleteConfirm2.default, {
            open: this.state.showDeleteAttachmentConfirm,
            onClose: this.handleCancelDeleteAttachment,
            onConfirm: this.handleConfirmDeleteAttachment,
            name: deleteFile ? deleteFile.name : ''
          }),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'center' },
                _react2.default.createElement(
                  'p',
                  null,
                  t('You may upload documents / attachments at the Document Sharing tab above. This section will no longer be supported'),
                  '.',
                  _react2.default.createElement('br', null),
                  t('Your previous uploads will still remain'),
                  '.'
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                data.bookingAttachments && data.bookingAttachments.length > 0 ? _react2.default.createElement(
                  'span',
                  null,
                  data.bookingAttachments.map(function (file, id) {
                    return _react2.default.createElement(
                      _semanticUiReact.Segment,
                      { key: id },
                      _react2.default.createElement(
                        _semanticUiReact.Grid,
                        {
                          columns: 'equal',
                          verticalAlign: 'middle',
                          as: 'a'
                        },
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          {
                            mobile: 16,
                            tablet: 13,
                            computer: 13,
                            textAlign: isMobile ? 'center' : 'left',
                            href: (0, _url.AWSUrl)(_this2.props.appConfig, encodeURI(file.key)),
                            target: '_blank',
                            style: isMobile ? { paddingBottom: '0.5em', overflowX: 'hidden' } : { overflowX: 'hidden' }
                          },
                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'file image outline' }),
                          file.name,
                          _react2.default.createElement(
                            'span',
                            { className: 'mobile-hide' },
                            ' (',
                            (0, _fileSize2.default)(file.size),
                            ')'
                          ),
                          _react2.default.createElement(
                            'small',
                            { className: 'large-hide small-hide tablet-hide' },
                            _react2.default.createElement('br', null),
                            (0, _fileSize2.default)(file.size)
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          {
                            mobile: 16,
                            tablet: 3,
                            computer: 3,
                            textAlign: isMobile ? 'center' : 'right',
                            style: isMobile ? { paddingTop: '0.5em' } : {}
                          },
                          _react2.default.createElement(
                            'small',
                            { style: { paddingRight: '1em' } },
                            _react2.default.createElement(_Timestamp2.default, { timestamp: file.createdAt, format: 'DD/MM/YY hh:mm a' })
                          ),
                          _react2.default.createElement(_semanticUiReact.Button, {
                            compact: true,
                            negative: true,
                            type: 'button',
                            size: 'tiny',
                            icon: 'trash',
                            onClick: function onClick(e) {
                              return _this2.handleDeleteAttachment(e, file);
                            }
                          })
                        )
                      )
                    );
                  })
                ) : null
              )
            )
          )
        )
      );
    }
  }]);

  return BookingAttachment;
}(_react.Component);

BookingAttachment.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      noeticIsEnabled: _propTypes2.default.bool,
      lawyerIsEnabled: _propTypes2.default.bool
    })
  }),
  onRef: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  data: _propTypes2.default.shape({
    bookingAttachments: _propTypes2.default.array
  }),
  isMobile: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  uploadModalState: _propTypes2.default.bool
};

BookingAttachment.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig
  };
};

BookingAttachment.getPropsToState = function (props) {
  var data = Object.assign({}, props.data);
  var loading = props.loading;
  var uploadModalState = props.uploadModalState;
  var errMessages = [];
  return {
    data: data,
    errMessages: errMessages,
    loading: loading,
    oriData: (0, _clone2.default)(data),
    uploadModalState: uploadModalState
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleUploadModalClose = function () {
    _this3.setState({ uploadModalState: false });
  };

  this.handleCancelDeleteAttachment = function (e) {
    e.preventDefault();
    _this3.setState({
      showDeleteAttachmentConfirm: false,
      deleteFile: null
    });
  };

  this.handleConfirmDeleteAttachment = function (e) {
    e.preventDefault();
    var fileID = _this3.state.deleteFile.id;
    _this3.setState({
      showDeleteAttachmentConfirm: false,
      deleteFile: null
    }, function () {
      _this3.props.onDelete(fileID);
    });
  };

  this.handleDeleteAttachment = function (e, file) {
    e.preventDefault();
    _this3.setState({
      showDeleteAttachmentConfirm: true,
      deleteFile: file
    });
  };

  this.handleUploadDocs = function (e, file) {
    e.preventDefault();
    _this3.props.onSubmit(file);
  };

  this.triggerAddAttachment = function () {
    _this3.setState({ uploadModalState: true });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)((0, _reactRedux.connect)(BookingAttachment.mapStateToProps)(BookingAttachment));

/***/ }),
/* 2091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _CTOSResult = __webpack_require__(2113);

var _CTOSResult2 = _interopRequireDefault(_CTOSResult);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BookingCreditCheck = function BookingCreditCheck(_ref, _ref2) {
  var auth = _ref.auth,
      customerData = _ref.customerData,
      data = _ref.data;
  var store = _ref2.store;
  return customerData && customerData.customer && customerData.customer.customerCreditReport ? _react2.default.createElement(
    _semanticUiReact.Grid,
    { className: 'creditCheckGrid' },
    customerData.customer.customerCreditReportID !== '' ? _react2.default.createElement(
      _semanticUiReact.Grid,
      { centered: true },
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { mobile: 16, tablet: 14, computer: 16 },
          _react2.default.createElement(_CTOSResult2.default, {
            customerData: customerData,
            customerDataID: customerData.customer.id,
            data: data
          })
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          _react2.default.createElement(_semanticUiReact.Button, {
            content: 'Run credit check',
            color: 'blue',
            onClick: function onClick() {
              store.dispatch((0, _reactRouterRedux.push)('/bookings/' + data.id + '/customers/' + customerData.customer.id + '/credit_check/'));
            }
          })
        )
      )
    ) : _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { className: 'credit-check-booking' },
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { className: 'box-wrap', mobile: 16, tablet: 16, computer: 9 },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', divided: true, className: 'box', columns: 'equal' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { stretched: true },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'score', textAlign: 'left', mobile: 7, tablet: 4, computer: 4 },
              _react2.default.createElement(
                'p',
                null,
                'CTOS Score:'
              ),
              _react2.default.createElement(_semanticUiReact.Header, { as: 'h2', content: '-', style: { marginTop: 0 } })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'score', textAlign: 'left', mobile: 9, tablet: 4, computer: 4 },
              _react2.default.createElement(
                'p',
                null,
                'DSR:'
              ),
              _react2.default.createElement(_semanticUiReact.Header, { as: 'h2', content: '-', style: { marginTop: 0 } })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'last-column', textAlign: 'center', mobile: 16, tablet: 8, computer: 8 },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { verticalAlign: 'middle', className: 'box' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { stretched: true },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { className: 'time', mobile: 16, tablet: 8, computer: 7, textAlign: 'center' },
                    customerData.customer.customerCreditReport.createdAt !== null ? _react2.default.createElement(_Timestamp2.default, {
                      timestamp: customerData.customer.customerCreditReport.createdAt
                    }) : null
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { className: 'button-check', mobile: 16, tablet: 8, computer: 9, textAlign: 'center' },
                    _react2.default.createElement(
                      _semanticUiReact.Button,
                      {
                        type: 'button',
                        size: 'small',
                        color: 'blue',
                        onClick: function onClick() {
                          store.dispatch((0, _reactRouterRedux.push)('/bookings/' + data.id + '/customers/' + customerData.customer.id + '/credit_check/'));
                        }
                      },
                      'Run Credit check'
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  ) : null;
};

BookingCreditCheck.propTypes = {
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool
  }),
  customerData: _propTypes2.default.shape({
    customer: _propTypes2.default.object
  }),
  data: _propTypes2.default.shape({
    id: _propTypes2.default.string
  })
};

BookingCreditCheck.contextTypes = {
  store: _propTypes2.default.object
};

exports.default = BookingCreditCheck;

/***/ }),
/* 2092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _translation = __webpack_require__(4);

var _vietnamPricing = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var BookingFeePackage = function (_Component) {
  _inherits(BookingFeePackage, _Component);

  function BookingFeePackage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BookingFeePackage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BookingFeePackage.__proto__ || Object.getPrototypeOf(BookingFeePackage)).call.apply(_ref, [this].concat(args))), _this), _this.hasPackage = function (data) {
      return data.packageFee && data.packageFee.id !== '';
    }, _this.hasRecalculateAccess = function () {
      var auth = _this.props.auth;

      if (auth.isAdminBasic || auth.isSuperAdmin) return true;
      return false;
    }, _this.hasEditPackageAccess = function () {
      var _this$props = _this.props,
          auth = _this$props.auth,
          data = _this$props.data;

      return data.statusID === 'sold_spa_signed' && (auth.isAdmin || auth.isAdminBasic || auth.isSuperAdmin) || auth.isDeveloperSupervisor || auth.isDeveloperSalesManager || auth.isDeveloperSalesAdmin || auth.isHeadquarters;
    }, _this.disablePricingEditAfterSold = function (data) {
      return data && data.statusID === 'sold_spa_signed' && data.project && !data.project.allowPricingEditAfterSold;
    }, _this.isVNPackageLocked = function () {
      return (0, _vietnamPricing.isPricingPackageLocked)(_this.props.auth, _this.props.data && _this.props.data.statusID, 'fee');
    }, _this.handleRecalculate = function (e, data) {
      if (_this.props.onCheckRecalculate) {
        _this.props.onCheckRecalculate(data.checked);
      }
    }, _this.renderDescription = function (itemDesc) {
      var iDesc = itemDesc;
      if (iDesc.includes('\n')) {
        iDesc = iDesc.split('\n').map(function (desc, idx) {
          return _react2.default.createElement(
            'span',
            { key: idx },
            desc,
            _react2.default.createElement('br', null)
          );
        });
      }
      return iDesc;
    }, _this.renderTextButton = function (title, name, placement) {
      var _this$props2 = _this.props,
          data = _this$props2.data,
          t = _this$props2.t;

      if (_this.isVNPackageLocked()) {
        return null;
      }
      return _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(_semanticUiReact.Label, {
          as: 'button',
          attached: placement || undefined,
          size: 'small',
          content: title,
          onClick: function onClick() {
            return _this.props.openModal && _this.props.openModal(name, true);
          },
          className: 'textButton',
          disabled: _this.disablePricingEditAfterSold(data)
        }),
        disabled: !_this.disablePricingEditAfterSold(data),
        content: t('Pricing details are locked because the booking has been marked as Sold', { ns: _translation.TRANSLATION_FILES.translation })
      });
    }, _this.renderHeader = function () {
      var _this$props3 = _this.props,
          data = _this$props3.data,
          availablePackages = _this$props3.availablePackages,
          t = _this$props3.t;

      return _react2.default.createElement(
        'span',
        null,
        _this.hasPackage(data) ? _react2.default.createElement(
          'span',
          null,
          t('Additional Fee Package'),
          ':\xA0',
          _react2.default.createElement(
            'span',
            { className: 'text_name italic' },
            data.packageFee.name
          )
        ) : _react2.default.createElement(
          'span',
          null,
          t('No Additional Fees added')
        ),
        _this.hasEditPackageAccess() && availablePackages && availablePackages.length > 0 && _this.renderTextButton(t((_this.hasPackage(data) ? 'Edit' : 'Add') + ' Package'), 'showEditFeePackageModal'),
        _this.isVNPackageLocked() && _react2.default.createElement(
          'span',
          { className: 'text_formula_small' },
          '\xA0',
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', size: 'small' }),
          t((0, _vietnamPricing.vnPackageLockMessage)(_this.props.auth, data && data.statusID, 'fee'))
        )
      );
    }, _this.renderFeePackageBreakdown = function () {
      var data = _this.props.data;

      var projectCurrencies = data.project.projectCurrency || null;
      var items = data && data.packageFee && data.packageFee.items ? data.packageFee.items : [];
      return items.filter(function (c) {
        return c.isEnabled;
      }).map(function (calc, idx) {
        return _react2.default.createElement(
          _semanticUiReact.Table.Row,
          { key: idx, className: 'row_formula_items' },
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'text_formula_small' },
            calc.name
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'text_description' },
            _this.renderDescription(calc.description)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { textAlign: 'right' },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'div_inline_block' },
                _react2.default.createElement(_semanticUiReact.Icon, { color: 'green', size: 'small', name: 'plus' })
              ),
              _react2.default.createElement(
                'div',
                { className: 'div_inline_block text_add' },
                _react2.default.createElement(_LoanAmount2.default, {
                  precise: false,
                  projectCurrencies: projectCurrencies,
                  format: '0,000,000.00',
                  amount: calc.valueChange,
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                })
              )
            )
          )
        );
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  // CPI-977 requirements 7/11: Vietnam locks the fee package on the same rule as the pricing package.


  _createClass(BookingFeePackage, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          isEditing = _props.isEditing,
          t = _props.t;

      var projectCurrencies = data.project.projectCurrency || null;
      var hasFormulas = data && data.packageFee && data.packageFee.items && data.packageFee.items.length > 0;
      return _react2.default.createElement(
        'div',
        { className: 'bookingPricingPackage' },
        data && data.packageFee && !data.packageFee.isCustomPrice && this.hasEditPackageAccess() && this.renderTextButton(t('Customise formula(s)'), 'showCustomiseFeePackageFormulaModal', 'top right'),
        _react2.default.createElement(
          _semanticUiReact.Table,
          { compact: true, unstackable: true, structured: true },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 3 },
                this.renderHeader(),
                isEditing && this.hasRecalculateAccess() ? _react2.default.createElement(
                  'div',
                  { className: 'mobile-hide tablet-hide div_recalculate' },
                  _react2.default.createElement(_semanticUiReact.Checkbox
                  // eslint-disable-next-line jsx-a11y/label-has-for
                  , { label: _react2.default.createElement(
                      'label',
                      null,
                      t('Force recalculate additional fee package'),
                      ' ',
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning sign' })
                    ),
                    onChange: this.handleRecalculate,
                    disabled: this.disablePricingEditAfterSold(data)
                  })
                ) : ''
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            this.hasPackage(data) ? _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 3 },
                _react2.default.createElement(
                  'span',
                  { className: 'text_description' },
                  data.packageFee ? this.renderDescription(data.packageFee.description) : ''
                )
              )
            ) : null,
            this.hasPackage(data) ? _react2.default.createElement(
              _semanticUiReact.Table.Row,
              { negative: true },
              _react2.default.createElement(_semanticUiReact.Table.Cell, { colSpan: 3 })
            ) : null,
            hasFormulas ? this.renderFeePackageBreakdown() : null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              { negative: true },
              _react2.default.createElement(_semanticUiReact.Table.Cell, { colSpan: 3 })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              { className: 'row_total' },
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 2 },
                t('Total Additional Fees')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'right' },
                data.packageFee ? _react2.default.createElement(_LoanAmount2.default, {
                  precise: false,
                  projectCurrencies: projectCurrencies,
                  format: '0,000,000.00',
                  amount: data.packageFee.totalPrice,
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                }) : '-'
              )
            )
          )
        )
      );
    }
  }]);

  return BookingFeePackage;
}(_react.Component);

BookingFeePackage.propTypes = {
  availablePackages: _propTypes2.default.arrayOf(_propTypes2.default.shape()),
  data: _propTypes2.default.shape(),
  onCheckRecalculate: _propTypes2.default.func,
  isEditing: _propTypes2.default.bool,
  auth: _propTypes2.default.shape({
    isSuperAdmin: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isAdmin: _propTypes2.default.bool,
    isDeveloperSupervisor: _propTypes2.default.bool,
    isDeveloperSalesManager: _propTypes2.default.bool,
    isDeveloperSalesAdmin: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool
  }),
  openModal: _propTypes2.default.func,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(BookingFeePackage);

/***/ }),
/* 2093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BookingFormTemplateList = function (_Component) {
  _inherits(BookingFormTemplateList, _Component);

  function BookingFormTemplateList(props) {
    _classCallCheck(this, BookingFormTemplateList);

    var _this = _possibleConstructorReturn(this, (BookingFormTemplateList.__proto__ || Object.getPrototypeOf(BookingFormTemplateList)).call(this, props));

    _initialiseProps.call(_this);

    var state = _this.getPropsToState(props);
    _this.validationForEdit = {};
    _this.validationForCreate = {};
    _this.state = _extends({
      dataToBeDelete: {},
      isEditing: false,
      isNew: false,
      showDeleteConfirm: false
    }, state);
    return _this;
  }

  _createClass(BookingFormTemplateList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = this.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 20 },
            active: this.state.loading && this.state.data.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _AppForm2.default,
          {
            ref: function ref(_ref) {
              _this2.form = _ref;
            },
            as: 'div'
          },
          _react2.default.createElement(
            _semanticUiReact.Table,
            {
              striped: true,
              selectable: true,
              padded: true,
              unstackable: true
            },
            _react2.default.createElement(
              _semanticUiReact.Table.Header,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  { colSpan: 16, textAlign: 'left' },
                  _react2.default.createElement(
                    _semanticUiReact.Header,
                    { style: { marginTop: '.5em', marginBottom: '.5em' }, as: 'h3' },
                    t('Booking form visibility')
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  { colSpan: 4 },
                  t('Booking Form')
                ),
                _react2.default.createElement(_semanticUiReact.Table.HeaderCell, { colSpan: 5 }),
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  { colSpan: 3 },
                  t('Visibility to buyer')
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Body,
              null,
              this.state.data.length > 0 ? this.state.data.map(function (value, index) {
                return _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  { key: index },
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    { colSpan: 4 },
                    value.name
                  ),
                  _react2.default.createElement(_semanticUiReact.Table.Cell, { colSpan: 5 }),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    { colSpan: 3 },
                    _react2.default.createElement(
                      _semanticUiReact.Button,
                      {
                        style: { marginRight: '1em' },
                        size: 'tiny',
                        basic: true,
                        disabled: _this2.state.loading,
                        className: 'ui compact icon button',
                        onClick: function onClick(e) {
                          return _this2.onSave(index, e);
                        }
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'eye', color: _this2.hasSRBAccess(value.accessibleIn || []) ? "green" : "grey" })
                    ),
                    t(_this2.hasSRBAccess(value.accessibleIn || []) ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation })
                  )
                );
              }) : _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { colSpan: 16, textAlign: 'center' },
                  this.state.loading ? _react2.default.createElement(
                    _semanticUiReact.Loader,
                    { active: true, inline: 'centered' },
                    t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                  ) : t('No print form found') + '.'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return BookingFormTemplateList;
}(_react.Component);

BookingFormTemplateList.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  loading: _propTypes2.default.bool,
  handleSaveTemplateToggle: _propTypes2.default.func.isRequired
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getPropsToState = function (props) {
    var data = props.data;
    var loading = props.loading;

    return {
      data: data,
      loading: loading
    };
  };

  this.hasSRBAccess = function (accessibleIn) {
    var srbAccess = 'SRB';
    return accessibleIn.includes(srbAccess);
  };

  this.onSave = function (index, e) {
    e.preventDefault();
    var srbAccess = 'SRB';
    var data = _this3.state.data[index];
    var accessibleIn = data.accessibleIn || [];
    if (accessibleIn.includes(srbAccess)) {
      accessibleIn = accessibleIn.filter(function (i) {
        return i !== srbAccess;
      });
    } else {
      accessibleIn.push(srbAccess);
    }
    var id = encodeURIComponent(data.id);
    data.accessibleIn = accessibleIn;
    return _this3.props.handleSaveTemplateToggle(id, data);
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(BookingFormTemplateList);

/***/ }),
/* 2094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _BookingNote = __webpack_require__(313);

var _translation = __webpack_require__(4);

var _types = __webpack_require__(145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */


var BookingNote = function (_Component) {
  _inherits(BookingNote, _Component);

  function BookingNote(props) {
    var _this2 = this;

    _classCallCheck(this, BookingNote);

    var _this = _possibleConstructorReturn(this, (BookingNote.__proto__ || Object.getPrototypeOf(BookingNote)).call(this, props));

    _this.setRefreshCooldown = function () {
      _this.refreshCooldown = setInterval(function () {
        _this.setState({ isRefreshing: false });
        clearInterval(_this.refreshCooldown);
      }, 5000); // 5 seconds
    };

    _this.handleClickRefresh = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (e) e.preventDefault();

                if (!(_this.listRef && _this.listRef.current)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 4;
                return _this.setComponentState({ loading: true, isRefreshing: true });

              case 4:
                _context.next = 6;
                return _this.listRef.current.fetchStateData(false);

              case 6:
                _context.next = 8;
                return _this.setLoading(false);

              case 8:
                _this.setRefreshCooldown();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleForceRefresh = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var prependData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this.listRef && _this.listRef.current)) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 3;
                return _this.setLoading(true);

              case 3:
                _context2.next = 5;
                return _this.listRef.current.fetchStateData(prependData);

              case 5:
                _context2.next = 7;
                return _this.setLoading(false);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function () {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.handleClickExpand = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (e) e.preventDefault();
                _context3.next = 3;
                return _this.setComponentState(function (prevState) {
                  return { isExpanded: !prevState.isExpanded };
                });

              case 3:
                if (_this.props.onExpand) _this.props.onExpand(_this.state.isExpanded);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.handleOnNoteDelete = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(bnID) {
        var listPos, store, t, message;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // fix for loading dimmer
                listPos = 0;

                if (!(_this.listRef && _this.listRef.current)) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 4;
                return _this.listRef.current.getScrollPostion();

              case 4:
                listPos = _context4.sent;

              case 5:
                if (!(_this.listRef && _this.listRef.current)) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 8;
                return _this.listRef.current.scrollToTop();

              case 8:
                store = _this.context.store;
                t = _this.props.t;
                _context4.next = 12;
                return _this.setLoading(true);

              case 12:
                _context4.prev = 12;
                _context4.next = 15;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + _this.props.bookingID + '/notes/' + bnID + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': _this.props.token
                  }
                }));

              case 15:
                _context4.next = 33;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4['catch'](12);
                _context4.next = 21;
                return _this.setLoading(false);

              case 21:
                if (!(_context4.t0.res && _context4.t0.res.status >= 400 && _context4.t0.res.status < 500)) {
                  _context4.next = 27;
                  break;
                }

                _context4.next = 24;
                return _context4.t0.res.text();

              case 24:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context4.abrupt('return');

              case 27:
                Bugsnag.notifyException(_context4.t0);
                _context4.next = 30;
                return _this.setLoading(false);

              case 30:
                _context4.next = 32;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 32:
                return _context4.abrupt('return');

              case 33:
                if (!(_this.listRef && _this.listRef.current)) {
                  _context4.next = 36;
                  break;
                }

                _context4.next = 36;
                return _this.listRef.current.deleteStateData(bnID);

              case 36:
                _context4.next = 38;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Note successfully deleted', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 38:
                _context4.next = 40;
                return _this.setLoading(false);

              case 40:
                if (!(_this.listRef && _this.listRef.current)) {
                  _context4.next = 43;
                  break;
                }

                _context4.next = 43;
                return _this.listRef.current.scrollToPosition(listPos);

              case 43:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2, [[12, 17]]);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.handleOnNoteEdit = function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(bNote) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this.setComponentState({ noteEditing: bNote });

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this2);
      }));

      return function (_x5) {
        return _ref5.apply(this, arguments);
      };
    }();

    _this.handleEditorCancel = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this.setState({ noteEditing: null });

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this2);
    }));

    _this.handleEditorAdd = function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(encodedMDNote, privacyValue) {
        var store, t, request, res, message, _message;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(_this.listRef && _this.listRef.current)) {
                  _context7.next = 3;
                  break;
                }

                _context7.next = 3;
                return _this.listRef.current.scrollToTop();

              case 3:
                store = _this.context.store;
                t = _this.props.t;
                _context7.next = 7;
                return _this.setLoading(true);

              case 7:
                request = {
                  note: encodedMDNote,
                  privacy: privacyValue
                };
                res = '';
                _context7.prev = 9;
                _context7.next = 12;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + _this.props.bookingID + '/notes/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': _this.props.token
                  },
                  body: JSON.stringify(request)
                }));

              case 12:
                res = _context7.sent;
                _context7.next = 31;
                break;

              case 15:
                _context7.prev = 15;
                _context7.t0 = _context7['catch'](9);
                _context7.next = 19;
                return _this.setLoading(false);

              case 19:
                if (!(_context7.t0.res && _context7.t0.res.status >= 400 && _context7.t0.res.status < 500)) {
                  _context7.next = 25;
                  break;
                }

                _context7.next = 22;
                return _context7.t0.res.text();

              case 22:
                message = _context7.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context7.abrupt('return');

              case 25:
                Bugsnag.notifyException(_context7.t0);
                _context7.next = 28;
                return _this.setLoading(false);

              case 28:
                _context7.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 30:
                return _context7.abrupt('return');

              case 31:
                if (res.ok) {
                  _context7.next = 40;
                  break;
                }

                _context7.next = 34;
                return res.text();

              case 34:
                _message = _context7.sent;
                _context7.next = 37;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 37:
                _context7.next = 39;
                return _this.setLoading(false);

              case 39:
                return _context7.abrupt('return');

              case 40:
                if (!(_this.listRef && _this.listRef.current)) {
                  _context7.next = 43;
                  break;
                }

                _context7.next = 43;
                return _this.listRef.current.fetchStateData(true);

              case 43:
                if (!(_this.editorRef && _this.editorRef.current)) {
                  _context7.next = 46;
                  break;
                }

                _context7.next = 46;
                return _this.editorRef.current.resetEditor();

              case 46:
                _context7.next = 48;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Add Note Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Note successfully added', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 48:
                _context7.next = 50;
                return _this.setLoading(false);

              case 50:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this2, [[9, 15]]);
      }));

      return function (_x6, _x7) {
        return _ref7.apply(this, arguments);
      };
    }();

    _this.handleEditorUpdate = function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(encodedMDNote, privacyValue) {
        var listPos, store, noteEditing, t, request, res, message, _message2, bNote;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                // fix for loading dimmer
                listPos = 0;

                if (!(_this.listRef && _this.listRef.current)) {
                  _context8.next = 5;
                  break;
                }

                _context8.next = 4;
                return _this.listRef.current.getScrollPostion();

              case 4:
                listPos = _context8.sent;

              case 5:
                if (!(_this.listRef && _this.listRef.current)) {
                  _context8.next = 8;
                  break;
                }

                _context8.next = 8;
                return _this.listRef.current.scrollToTop();

              case 8:
                store = _this.context.store;
                noteEditing = _this.state.noteEditing;
                t = _this.props.t;

                if (!(noteEditing && noteEditing.id !== '')) {
                  _context8.next = 67;
                  break;
                }

                if (!(noteEditing.note !== encodedMDNote || noteEditing.privacy !== privacyValue)) {
                  _context8.next = 67;
                  break;
                }

                _context8.next = 15;
                return _this.setLoading(true);

              case 15:
                request = noteEditing;

                request.note = encodedMDNote;
                request.privacy = privacyValue;
                res = '';
                _context8.prev = 19;
                _context8.next = 22;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + _this.props.bookingID + '/notes/' + request.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': _this.props.token
                  },
                  body: JSON.stringify(request)
                }));

              case 22:
                res = _context8.sent;
                _context8.next = 41;
                break;

              case 25:
                _context8.prev = 25;
                _context8.t0 = _context8['catch'](19);
                _context8.next = 29;
                return _this.setLoading(false);

              case 29:
                if (!(_context8.t0.res && _context8.t0.res.status >= 400 && _context8.t0.res.status < 500)) {
                  _context8.next = 35;
                  break;
                }

                _context8.next = 32;
                return _context8.t0.res.text();

              case 32:
                message = _context8.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context8.abrupt('return');

              case 35:
                Bugsnag.notifyException(_context8.t0);
                _context8.next = 38;
                return _this.setLoading(false);

              case 38:
                _context8.next = 40;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 40:
                return _context8.abrupt('return');

              case 41:
                if (res.ok) {
                  _context8.next = 50;
                  break;
                }

                _context8.next = 44;
                return res.text();

              case 44:
                _message2 = _context8.sent;
                _context8.next = 47;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message2 }));

              case 47:
                _context8.next = 49;
                return _this.setComponentState({ loading: false, noteEditing: null });

              case 49:
                return _context8.abrupt('return');

              case 50:
                _context8.next = 52;
                return res.json();

              case 52:
                bNote = _context8.sent;

                if (!(bNote && _this.listRef && _this.listRef.current)) {
                  _context8.next = 56;
                  break;
                }

                _context8.next = 56;
                return _this.listRef.current.updateStateData(bNote);

              case 56:
                if (!(_this.editorRef && _this.editorRef.current)) {
                  _context8.next = 59;
                  break;
                }

                _context8.next = 59;
                return _this.editorRef.current.resetEditor(true);

              case 59:
                _context8.next = 61;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Note successfully updated', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 61:
                _context8.next = 63;
                return _this.setComponentState({ loading: false, noteEditing: null });

              case 63:
                if (!(bNote && _this.listRef && _this.listRef.current)) {
                  _context8.next = 66;
                  break;
                }

                _context8.next = 66;
                return _this.listRef.current.scrollToPosition(listPos);

              case 66:
                return _context8.abrupt('return');

              case 67:
                if (!(_this.editorRef && _this.editorRef.current)) {
                  _context8.next = 70;
                  break;
                }

                _context8.next = 70;
                return _this.editorRef.current.resetEditor(true);

              case 70:
                _context8.next = 72;
                return _this.setComponentState({ loading: false, noteEditing: null });

              case 72:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this2, [[19, 25]]);
      }));

      return function (_x8, _x9) {
        return _ref8.apply(this, arguments);
      };
    }();

    _this.isInternalUser = function () {
      var user = _this.props.auth;
      if (!user.companyBranch.isExternal) return true;
      return false;
    };

    _this.state = {
      isRefreshing: false,
      loading: false,
      noteEditing: null,
      token: '',
      isExpanded: false
    };
    _this.listRef = _react2.default.createRef();
    _this.editorRef = _react2.default.createRef();
    _this.refreshCooldown = null;
    return _this;
  }

  _createClass(BookingNote, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.setRef) {
        this.props.setRef(this);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.refreshCooldown !== null) clearInterval(this.refreshCooldown);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState(state) {
      var _this3 = this;

      return new Promise(function (resolve) {
        _this3.setState(function (prevState) {
          var nextState = typeof state === 'function' ? state(prevState) : state;
          return nextState;
        }, function () {
          return resolve(_this3.state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
    // trigger from list, confirm delete button

    // trigger from list, edit button

    // trigger from note editor, cancel edit button

    // trigger from note editor, add button

    // trigger from note editor, update button

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          auth = _props.auth,
          bookingID = _props.bookingID,
          isDisabled = _props.isDisabled,
          hasEditAccess = _props.hasEditAccess,
          showExpand = _props.showExpand,
          t = _props.t;
      var _state = this.state,
          loading = _state.loading,
          isExpanded = _state.isExpanded,
          isRefreshing = _state.isRefreshing,
          noteEditing = _state.noteEditing;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16, className: isExpanded ? '' : 'mobile-half-left-padding' },
            _react2.default.createElement(
              _semanticUiReact.Segment.Group,
              { className: 'booking-note ' + (showExpand ? 'expand-mode' : '') },
              _react2.default.createElement(_semanticUiReact.Dimmer, {
                active: isDisabled,
                inverted: true,
                style: { zIndex: 20 }
              }),
              _react2.default.createElement(
                _semanticUiReact.Header,
                { size: 'tiny', textAlign: 'center', className: 'bn-header' },
                t('Notes')
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_semanticUiReact.Button, {
                  className: 'bn-refresh',
                  disabled: isRefreshing,
                  icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh', loading: isRefreshing, fitted: true, size: 'small' }),
                  onClick: this.handleClickRefresh,
                  title: 'Refresh'
                }),
                showExpand ? _react2.default.createElement(_semanticUiReact.Button, {
                  className: 'bn-expand',
                  icon: _react2.default.createElement(_semanticUiReact.Icon, { name: isExpanded ? 'compress' : 'expand', fitted: true, size: 'small' }),
                  onClick: this.handleClickExpand,
                  title: isExpanded ? 'Minimize' : 'Maximize'
                }) : ''
              ),
              _react2.default.createElement(_BookingNote.List, {
                auth: auth,
                bookingID: bookingID,
                hasEditAccess: hasEditAccess,
                noteEditingID: noteEditing && noteEditing.id || '',
                noteOnDelete: this.handleOnNoteDelete,
                noteOnEdit: this.handleOnNoteEdit,
                ref: this.listRef,
                requestLoading: loading,
                isExpanded: isExpanded
              }),
              hasEditAccess ? _react2.default.createElement(_BookingNote.NoteEditor, {
                bookingNote: noteEditing,
                defaultPrivacy: this.props.defaultPrivacy,
                loading: loading,
                onAdd: this.handleEditorAdd,
                onCancel: this.handleEditorCancel,
                onUpdate: this.handleEditorUpdate,
                ref: this.editorRef,
                showInternalPrivacy: this.isInternalUser(),
                auth: this.props.auth,
                settings: this.props.appConfig && this.props.appConfig.data && this.props.appConfig.data.settings
              }) : ''
            )
          )
        )
      );
    }
  }]);

  return BookingNote;
}(_react.Component);

BookingNote.propTypes = {
  auth: _types.StateAuth,
  bookingID: _propTypes2.default.string,
  checkHasChanges: _propTypes2.default.func,
  defaultPrivacy: _propTypes2.default.string,
  hasEditAccess: _propTypes2.default.bool,
  isDisabled: _propTypes2.default.bool,
  onCheck: _propTypes2.default.func,
  onExpand: _propTypes2.default.func,
  setRef: _propTypes2.default.func,
  showExpand: _propTypes2.default.bool,
  token: _propTypes2.default.string,
  t: _propTypes2.default.func,
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      settings: _propTypes2.default.shape({
        notesExternalPlaceholder: _propTypes2.default.string
      })
    })
  })
};

BookingNote.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

BookingNote.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(BookingNote.mapStateToProps)(BookingNote));

/***/ }),
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

var _ListItem = __webpack_require__(1007);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _types = __webpack_require__(145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-confusing-arrow */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-unused-prop-types */


var List = function (_Component) {
  _inherits(List, _Component);

  _createClass(List, null, [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (prevState.internalLoading !== nextProps.requestLoading) {
        return {
          internalLoading: nextProps.requestLoading
        };
      }
      return null;
    }
  }]);

  function List(props) {
    var _this2 = this;

    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _this.getScrollPostion = function () {
      var scrollDiv = document.getElementsByClassName('bn-list');
      if (scrollDiv.length > 0) {
        return scrollDiv[0].scrollTop;
      }
      return 0;
    };

    _this.scrollToBottom = function () {
      var scrollDiv = document.getElementsByClassName('bn-list');
      if (scrollDiv.length > 0) {
        scrollDiv[0].scrollTop = scrollDiv[0].scrollHeight;
      }
    };

    _this.scrollToTop = function () {
      var scrollDiv = document.getElementsByClassName('bn-list');
      if (scrollDiv.length > 0) {
        scrollDiv[0].scrollTop = 0;
      }
    };

    _this.scrollToPosition = function (position) {
      var scrollDiv = document.getElementsByClassName('bn-list');
      if (scrollDiv.length > 0) {
        scrollDiv[0].scrollTop = position;
      }
    };

    _this.handleScroll = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        var _e$target, scrollTop, scrollHeight, clientHeight, _this$state, dataCurrentPage, dataLastPage, dataFetching;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _e$target = e.target, scrollTop = _e$target.scrollTop, scrollHeight = _e$target.scrollHeight, clientHeight = _e$target.clientHeight;
                _this$state = _this.state, dataCurrentPage = _this$state.dataCurrentPage, dataLastPage = _this$state.dataLastPage, dataFetching = _this$state.dataFetching;

                if (!(scrollTop + clientHeight >= scrollHeight - 10 && !dataFetching && dataCurrentPage + 1 <= dataLastPage)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return _this.fetchNotes(dataCurrentPage + 1);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleNoteOnDelete = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(bnID, type) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = type;
                _context2.next = _context2.t0 === 'close' ? 3 : _context2.t0 === 'open' ? 5 : _context2.t0 === 'delete' ? 7 : 3;
                break;

              case 3:
                _this.setState({ noteDeleting: '' });
                return _context2.abrupt('break', 13);

              case 5:
                _this.setState({ noteDeleting: bnID });
                return _context2.abrupt('break', 13);

              case 7:
                _context2.next = 9;
                return _this.setComponentState({ noteDeleting: '', internalLoading: true });

              case 9:
                if (!_this.props.noteOnDelete) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 12;
                return _this.props.noteOnDelete(bnID);

              case 12:
                return _context2.abrupt('break', 13);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.handleNoteOnEdit = function (bNote) {
      if (_this.props.noteOnEdit) _this.props.noteOnEdit(bNote);
    };

    _this.deleteStateData = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(bnID) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this.setComponentState(function (prevState) {
                  return { internalLoading: false, data: prevState.data.filter(function (d) {
                      return d.id !== bnID;
                    }) };
                });

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x4) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.updateStateData = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(bNote) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this.setComponentState(function (prevState) {
                  return {
                    data: prevState.data.map(function (obj) {
                      return obj.id === bNote.id ? _extends({}, obj, { note: bNote.note, updatedAt: bNote.updatedAt, privacy: bNote.privacy }) : obj;
                    })
                  };
                });

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }));

      return function (_x5) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.fetchStateData = function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var prependNew = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(prependNew && !_this.state.dataFirstFetch)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt('return');

              case 2:
                _context5.next = 4;
                return _this.fetchNotes(1, prependNew);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this2);
      }));

      return function () {
        return _ref5.apply(this, arguments);
      };
    }();

    _this.hasFirstFetchData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', _this.state.dataFirstFetch);

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this2);
    }));

    _this.state = {
      internalLoading: false,
      data: [],
      dataCurrentPage: 1,
      dataLastPage: 1,
      dataFetching: true,
      dataFirstFetch: false,
      noteDeleting: ''
    };
    return _this;
  }

  _createClass(List, [{
    key: 'componentDidMount',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.addScrollEvent();

                if (!(this.props.bookingID !== '')) {
                  _context7.next = 4;
                  break;
                }

                _context7.next = 4;
                return this.fetchNotes();

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function componentDidMount() {
        return _ref7.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(prevProps) {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(prevProps.bookingID !== this.props.bookingID)) {
                  _context8.next = 3;
                  break;
                }

                _context8.next = 3;
                return this.fetchNotes();

              case 3:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function componentDidUpdate(_x7) {
        return _ref8.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.removeScrollEvent();

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function componentWillUnmount() {
        return _ref9.apply(this, arguments);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'setComponentState',
    value: function setComponentState(state) {
      var _this3 = this;

      return new Promise(function (resolve) {
        _this3.setState(function (prevState) {
          var nextState = typeof state === 'function' ? state(prevState) : state;
          return nextState;
        }, function () {
          return resolve(_this3.state);
        });
      });
    }
  }, {
    key: 'setDataFetching',
    value: function setDataFetching() {
      var _this4 = this;

      var dataFetching = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ dataFetching: dataFetching }, function () {
          res(dataFetching);
        });
      });
    }
  }, {
    key: 'addScrollEvent',
    value: function addScrollEvent() {
      var scrollDiv = document.getElementsByClassName('bn-list');
      if (scrollDiv.length > 0) {
        scrollDiv[0].addEventListener('scroll', this.handleScroll, false);
      }
    }
  }, {
    key: 'removeScrollEvent',
    value: function removeScrollEvent() {
      var scrollDiv = document.getElementsByClassName('bn-list');
      if (scrollDiv.length > 0) {
        scrollDiv[0].addEventListener('scroll', this.handleScroll, false);
      }
    }
  }, {
    key: 'hasManageAccess',
    value: function hasManageAccess(bNoteUserID) {
      if (!this.props.hasEditAccess) return false;
      var user = this.props.auth;
      if (user.isAdminBasic || user.isSuperAdmin) {
        return true;
      }
      if (bNoteUserID === user.id) {
        return true;
      }
      return false;
    }
  }, {
    key: 'hasAdminAccess',
    value: function hasAdminAccess() {
      var user = this.props.auth;
      if (user.isHeadquarters || user.isAdminBasic || user.isSuperAdmin) {
        return true;
      }
      return false;
    }
  }, {
    key: 'fetchNotes',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var prependNew = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var _state, currentData, dataCurrentPage, store, t, query, res, message, count, limit, data, newData;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.setDataFetching(true);

              case 2:
                if (page > 1) this.scrollToBottom();
                _state = this.state, currentData = _state.data, dataCurrentPage = _state.dataCurrentPage;
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({});

                query.page = page;
                res = void 0;
                _context10.prev = 9;
                _context10.next = 12;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.props.bookingID + '/notes/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context10.sent;
                _context10.next = 23;
                break;

              case 15:
                _context10.prev = 15;
                _context10.t0 = _context10['catch'](9);

                Bugsnag.notifyException(_context10.t0);
                _context10.next = 20;
                return this.setDataFetching(false);

              case 20:
                _context10.next = 22;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 22:
                return _context10.abrupt('return');

              case 23:
                if (res.ok) {
                  _context10.next = 32;
                  break;
                }

                _context10.next = 26;
                return res.text();

              case 26:
                message = _context10.sent;
                _context10.next = 29;
                return this.setDataFetching(false);

              case 29:
                _context10.next = 31;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 31:
                return _context10.abrupt('return');

              case 32:
                count = parseInt(res.headers.get('M-Data-count'), 10) || 0;
                limit = parseInt(res.headers.get('M-Data-limit'), 10) || 0;
                // const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                // const token = res.headers.get('X-Csrf-Token');

                _context10.next = 36;
                return res.json();

              case 36:
                data = _context10.sent;
                newData = page === 1 ? data : [].concat(_toConsumableArray(currentData), _toConsumableArray(data));

                if (prependNew && currentData && data) {
                  newData = [].concat(_toConsumableArray(data.filter(function (ni) {
                    return !currentData.some(function (oi) {
                      return oi.id === ni.id;
                    });
                  })), _toConsumableArray(currentData)); // prepend new data
                }
                _context10.next = 41;
                return this.setComponentState({
                  data: newData,
                  dataCurrentPage: prependNew ? dataCurrentPage : page,
                  dataLastPage: Math.ceil(count / limit),
                  dataFetching: false,
                  dataFirstFetch: true
                });

              case 41:
                if (prependNew) this.scrollToTop();

              case 42:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[9, 15]]);
      }));

      function fetchNotes() {
        return _ref10.apply(this, arguments);
      }

      return fetchNotes;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      // console.log(this.state.dataFirstFetch)
      var _state2 = this.state,
          bookingNotes = _state2.data,
          dataFetching = _state2.dataFetching,
          noteDeleting = _state2.noteDeleting,
          internalLoading = _state2.internalLoading;
      var _props = this.props,
          bookingID = _props.bookingID,
          isExpanded = _props.isExpanded,
          noteEditingID = _props.noteEditingID,
          loading = _props.requestLoading,
          t = _props.t;

      return _react2.default.createElement(
        _semanticUiReact.Segment,
        { className: 'bn-list ' + (isExpanded ? 'is-expanded' : '') + ' ' + (loading || noteDeleting || noteEditingID ? 'is-write-mode' : '') },
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            active: loading || internalLoading,
            inverted: true,
            style: { zIndex: 20 }
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Feed,
          null,
          bookingID !== '' && bookingNotes && bookingNotes.length > 0 ? bookingNotes.map(function (bNote, idx) {
            return _react2.default.createElement(_ListItem2.default, {
              key: idx,
              listIndex: idx,
              isLastIndex: bookingNotes.length > 1 && bookingNotes.length === idx + 1,
              bookingNote: bNote,
              onEdit: _this5.handleNoteOnEdit,
              onDelete: _this5.handleNoteOnDelete,
              noteIsDeleting: noteDeleting === bNote.id,
              noteIsEditing: noteEditingID === bNote.id,
              noteIsDisabled: noteEditingID !== '' && noteEditingID !== bNote.id,
              canManage: _this5.hasManageAccess(bNote.muID),
              hasAccess: _this5.hasAdminAccess()
            });
          }) : !dataFetching ? _react2.default.createElement(_ListItem.ListItemEmpty, { t: t }) : '',
          dataFetching ? _react2.default.createElement(_ListItem.ListItemPlaceholder, null) : ''
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.propTypes = {
  auth: _types.StateAuth,
  bookingID: _propTypes2.default.string,
  hasEditAccess: _propTypes2.default.bool, // user's role has edit access from project settings
  isExpanded: _propTypes2.default.bool, // expanded layout mode
  noteEditingID: _propTypes2.default.string, // current note id that is being edited
  noteOnDelete: _propTypes2.default.func, // send note id for delete request
  noteOnEdit: _propTypes2.default.func, // send BookingNotePropTypes object for edit
  requestLoading: _propTypes2.default.bool, // loading state when add, update & delete note request
  t: _propTypes2.default.func
};
List.defaultProps = {
  bookingID: '',
  noteEditingID: '',
  requestLoading: false
};
List.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(List);

/***/ }),
/* 2096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomButtons = function CustomButtons(_ref) {
  var onButtonAdd = _ref.onButtonAdd,
      onButtonCancel = _ref.onButtonCancel,
      onButtonUpdate = _ref.onButtonUpdate,
      submitIsDisable = _ref.submitIsDisable,
      isEdit = _ref.isEdit,
      t = _ref.t;

  if (isEdit) {
    return _react2.default.createElement(
      'div',
      { className: 'rdw-custom-buttons' },
      _react2.default.createElement(
        _semanticUiReact.Button,
        { compact: true, basic: true, icon: true, color: 'grey', size: 'small', className: 'rdw-cancel-button', onClick: onButtonCancel },
        _react2.default.createElement(_semanticUiReact.Icon, { name: 'x' })
      ),
      _react2.default.createElement(
        _semanticUiReact.Button,
        { compact: true, basic: true, color: 'blue', size: 'small', className: 'rdw-update-button', disabled: submitIsDisable, onClick: onButtonUpdate },
        _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' }),
        t('Update', { ns: _translation.TRANSLATION_FILES.translation })
      )
    );
  }
  return _react2.default.createElement(
    'div',
    { className: 'rdw-custom-buttons' },
    _react2.default.createElement(
      _semanticUiReact.Button,
      { compact: true, basic: true, color: 'blue', size: 'small', className: 'rdw-add-button', disabled: submitIsDisable, onClick: onButtonAdd },
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'send' }),
      t('Add Note')
    )
  );
}; /* eslint-disable max-len */
/* eslint-disable no-unused-vars */


CustomButtons.propTypes = {
  isEdit: _propTypes2.default.bool,
  onButtonAdd: _propTypes2.default.func.isRequired,
  onButtonCancel: _propTypes2.default.func.isRequired,
  onButtonUpdate: _propTypes2.default.func.isRequired,
  submitIsDisable: _propTypes2.default.bool,
  t: _propTypes2.default.func
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(CustomButtons);

/***/ }),
/* 2097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */


var CustomDropdownPrivacy = function (_Component) {
  _inherits(CustomDropdownPrivacy, _Component);

  function CustomDropdownPrivacy(props) {
    _classCallCheck(this, CustomDropdownPrivacy);

    var _this = _possibleConstructorReturn(this, (CustomDropdownPrivacy.__proto__ || Object.getPrototypeOf(CustomDropdownPrivacy)).call(this, props));

    _this.handleDDChange = function (e, _ref) {
      var value = _ref.value;

      e.preventDefault();
      _this.setState({ value: value, onFocus: false }, function () {
        if (_this.props.onChange) _this.props.onChange(value);
      });
    };

    _this.handleOnClickChange = function () {
      _this.setState({ onFocus: !_this.state.onFocus });
    };

    _this.state = {
      onFocus: false
    };
    return _this;
  }

  _createClass(CustomDropdownPrivacy, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          showInternalPrivacy = _props.showInternalPrivacy,
          privacyValue = _props.privacyValue,
          t = _props.t;
      var onFocus = this.state.onFocus;

      var privacyOptions = [{ key: 'public', value: 'public', text: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'globe' }),
          ' ',
          t('Public')
        ) }];
      if (showInternalPrivacy) {
        privacyOptions.push({ key: 'internal', value: 'internal', text: _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'users' }),
            ' ',
            t('Internal')
          ) });
      }
      privacyOptions.push({ key: 'private', value: 'private', text: _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock' }),
          ' ',
          t('Only Me')
        ) });
      return _react2.default.createElement(
        'div',
        { className: 'rdw-custom-dropdown-privacy' },
        _react2.default.createElement(_semanticUiReact.Dropdown, {
          disabled: privacyValue === '',
          fluid: true,
          onChange: this.handleDDChange,
          onClick: this.handleOnClickChange,
          open: onFocus,
          options: privacyOptions,
          selection: true,
          selectOnBlur: false,
          value: privacyValue || 'public'
        })
      );
    }
  }]);

  return CustomDropdownPrivacy;
}(_react.Component);

CustomDropdownPrivacy.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  showInternalPrivacy: _propTypes2.default.bool,
  privacyValue: _propTypes2.default.string,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.constants)(CustomDropdownPrivacy);

/***/ }),
/* 2098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CustomButtons = __webpack_require__(2096);

var _CustomButtons2 = _interopRequireDefault(_CustomButtons);

var _CustomDropdownPrivacy = __webpack_require__(2097);

var _CustomDropdownPrivacy2 = _interopRequireDefault(_CustomDropdownPrivacy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-unused-vars */
/* eslint-disable react/no-unused-prop-types */
var CustomOptions = function CustomOptions(_ref) {
  var editorState = _ref.editorState,
      isEdit = _ref.isEdit,
      onButtonAdd = _ref.onButtonAdd,
      onButtonCancel = _ref.onButtonCancel,
      onButtonUpdate = _ref.onButtonUpdate,
      onPrivacyChange = _ref.onPrivacyChange,
      privacyValue = _ref.privacyValue,
      showInternalPrivacy = _ref.showInternalPrivacy,
      submitIsDisable = _ref.submitIsDisable;
  return _react2.default.createElement(
    'div',
    { className: 'rdw-custom-options' },
    _react2.default.createElement(_CustomDropdownPrivacy2.default, {
      onChange: onPrivacyChange,
      privacyValue: privacyValue,
      showInternalPrivacy: showInternalPrivacy
    }),
    _react2.default.createElement(_CustomButtons2.default, {
      isEdit: isEdit,
      onButtonAdd: onButtonAdd,
      onButtonCancel: onButtonCancel,
      onButtonUpdate: onButtonUpdate,
      submitIsDisable: submitIsDisable
    })
  );
};

CustomOptions.propTypes = {
  editorState: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  isEdit: _propTypes2.default.bool,
  onButtonAdd: _propTypes2.default.func.isRequired,
  onButtonCancel: _propTypes2.default.func.isRequired,
  onButtonUpdate: _propTypes2.default.func.isRequired,
  onPrivacyChange: _propTypes2.default.func.isRequired,
  privacyValue: _propTypes2.default.string,
  showInternalPrivacy: _propTypes2.default.bool,
  submitIsDisable: _propTypes2.default.bool
};

exports.default = CustomOptions;

/***/ }),
/* 2099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _markdownDraftJs = __webpack_require__(450);

var _reactDraftWysiwyg = __webpack_require__(3176);

var _draftJs = __webpack_require__(338);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _translation = __webpack_require__(4);

var _CustomOptions = __webpack_require__(2098);

var _CustomOptions2 = _interopRequireDefault(_CustomOptions);

var _types = __webpack_require__(145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-unused-prop-types */


var NoteEditor = function (_Component) {
  _inherits(NoteEditor, _Component);

  function NoteEditor(props) {
    _classCallCheck(this, NoteEditor);

    var _this = _possibleConstructorReturn(this, (NoteEditor.__proto__ || Object.getPrototypeOf(NoteEditor)).call(this, props));

    _initialiseProps.call(_this);

    var newState = {
      editorPrivacy: _this.defaultPrivacyToEditorPrivacy(props.defaultPrivacy, props.showInternalPrivacy),
      editorState: _draftJs.EditorState.createEmpty()
    };
    if (props.bookingNote && props.bookingNote.note) {
      newState.editorState = _this.bookingNoteToEditorState(props.bookingNote);
    }
    _this.state = newState;
    _this.propUpdateTimeout = null;
    return _this;
  }

  _createClass(NoteEditor, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var bookingNoteChanged = JSON.stringify(nextProps.bookingNote) !== JSON.stringify(this.props.bookingNote);
      var defaultPrivacyChanged = nextProps.defaultPrivacy !== this.props.defaultPrivacy;
      if (bookingNoteChanged || defaultPrivacyChanged) {
        var newState = this.state;
        // when changed to edit mode
        if (JSON.stringify(nextProps.bookingNote) !== JSON.stringify(this.props.bookingNote)) {
          newState.editorState = this.bookingNoteToEditorState(nextProps.bookingNote);
          if (nextProps.bookingNote && nextProps.bookingNote.privacy) {
            newState.editorPrivacy = nextProps.bookingNote.privacy;
            this.setState(newState);
            return; // don't set default privacy below if already setting to the note's privacy
          }
        }
        if (nextProps.defaultPrivacy !== this.state.editorPrivacy) {
          newState.editorPrivacy = this.defaultPrivacyToEditorPrivacy(nextProps.defaultPrivacy, nextProps.showInternalPrivacy);
        }
        this.setState(newState);
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState(state) {
      var _this2 = this;

      return new Promise(function (resolve) {
        _this2.setState(function (prevState) {
          var nextState = typeof state === 'function' ? state(prevState) : state;
          return nextState;
        }, function () {
          return resolve(_this2.state);
        });
      });
    }
  }, {
    key: 'getPlaceholder',
    value: function getPlaceholder() {
      var _props = this.props,
          auth = _props.auth,
          settings = _props.settings,
          t = _props.t;
      // for agents

      if (auth && auth.companyBranch && auth.companyBranch.isExternal && auth.isDeveloper && !auth.isSuperAdmin && !auth.isHeadquarters && !auth.isBranchLeader && settings && settings.notesExternalPlaceholder) {
        return settings.notesExternalPlaceholder;
      }

      return t('Type a note') + '...';
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          editorState = _state.editorState,
          editorPrivacy = _state.editorPrivacy;
      var _props2 = this.props,
          loading = _props2.loading,
          hideCustomOptions = _props2.hideCustomOptions,
          showInternalPrivacy = _props2.showInternalPrivacy,
          bookingNote = _props2.bookingNote;

      return _react2.default.createElement(
        _semanticUiReact.Segment,
        { className: 'b-note-editor-rdw' },
        _react2.default.createElement(_semanticUiReact.Dimmer, {
          active: loading,
          inverted: true,
          style: { zIndex: 20 }
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'no-padding' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, className: 'no-padding' },
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { basic: true },
                _react2.default.createElement(_reactDraftWysiwyg.Editor, {
                  wrapperClassName: 'b-note-editor-rdw-wrapper',
                  toolbar: this.editorToolBar,
                  toolbarCustomButtons: !hideCustomOptions ? [_react2.default.createElement(_CustomOptions2.default, {
                    hideCustomOptions: hideCustomOptions,
                    isEdit: bookingNote && bookingNote.note !== '',
                    submitIsDisable: this.isEditorStateIsEmpty(editorState) || this.isEditorStateUnchanged(editorState, editorPrivacy, bookingNote),
                    privacyValue: this.state.editorPrivacy,
                    onPrivacyChange: this.handleOnPrivacyChange,
                    onButtonAdd: this.handleOnButtonAdd,
                    onButtonCancel: this.handleOnButtonCancel,
                    onButtonUpdate: this.handleOnButtonUpdate,
                    showInternalPrivacy: showInternalPrivacy
                  })] : undefined,
                  editorState: editorState,
                  onEditorStateChange: this.handleOnEditorStateChange,
                  stripPastedStyles: true,
                  spellCheck: true,
                  placeholder: this.getPlaceholder()
                })
              )
            )
          )
        )
      );
    }
  }]);

  return NoteEditor;
}(_react.Component);

NoteEditor.propTypes = {
  defaultPrivacy: _propTypes2.default.string, // privacy from project default value
  hideCustomOptions: _propTypes2.default.bool, // hides custom options (dropdown and action buttons)
  showInternalPrivacy: _propTypes2.default.bool, // if can show internal option in privacy dropdown
  bookingNote: _types.BookingNotePropTypes, // for edit
  loading: _propTypes2.default.bool, // loading state when adding new note or updating note
  onCancel: _propTypes2.default.func, // cancel edit
  onAdd: _propTypes2.default.func, // create new (send encoded markdown and privacy value)
  onUpdate: _propTypes2.default.func, // edit (send encoded markdown and privacy value)
  t: _propTypes2.default.func,
  settings: _propTypes2.default.shape({
    notesExternalPlaceholder: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isDeveloper: _propTypes2.default.bool,
    companyBranch: _propTypes2.default.shape({
      isExternal: _propTypes2.default.bool
    })
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.bookingNoteToMDValue = function (bookingNote) {
    if (bookingNote && bookingNote.note) {
      var bNote = bookingNote.note;
      try {
        var hasNoSpaces = bNote.indexOf(' ') === -1;
        if (hasNoSpaces) {
          return decodeURIComponent(bNote.replace(/\+/g, ' '));
        }
        return decodeURIComponent(bNote);
      } catch (e) {
        return bNote;
      }
    }
    return '';
  };

  this.bookingNoteToEditorState = function (bookingNote) {
    var mdValue = _this3.bookingNoteToMDValue(bookingNote);
    if (mdValue) {
      var rawData = (0, _markdownDraftJs.markdownToDraft)(mdValue, {
        preserveNewlines: true,
        blockStyles: {
          ins_open: 'UNDERLINE'
        },
        remarkableOptions: {
          enable: {
            inline: 'ins'
          }
        }
      });
      var contentState = (0, _draftJs.convertFromRaw)(rawData);
      var editorState = _draftJs.EditorState.createWithContent(contentState);
      return editorState;
    }
    return _draftJs.EditorState.createEmpty();
  };

  this.defaultPrivacyToEditorPrivacy = function (defaultPrivacy, showInternalPrivacy) {
    if (defaultPrivacy !== '') {
      if (!showInternalPrivacy && defaultPrivacy === 'internal') {
        return 'public';
      }
      return defaultPrivacy;
    }
    return '';
  };

  this.draftJSToMarkdownWrapper = function (rawContentState) {
    var extendedStyleItems = {
      UNDERLINE: {
        open: function open() {
          return '++';
        },
        close: function close() {
          return '++';
        }
      }
    };
    return (0, _markdownDraftJs.draftToMarkdown)(rawContentState, {
      styleItems: extendedStyleItems,
      preserveNewlines: true
    });
  };

  this.escapeLineBreaks = function (input) {
    var newInput = input;

    // TODO Booking Notes
    // console.log(JSON.stringify({ data: newInput }));

    if (newInput.includes('1.') || newInput.includes('- ')) {
      // has list
      // newInput = newInput.replace(/\n\n/g, '\n&nbsp;\n');

      // newInput = newInput.replace(/(-.*?\n!-)/g, '$1\n&nbsp;\n');
      // newInput = newInput.replace(/\n{5,}/g, '\n\n\n\n');
      // newInput = newInput.replace(/\n\n/g, '\n&nbsp;\n');
    } else {
      // fix line breaks '\n\n' -> '\n&nbsp;\n'
      newInput = newInput.replace(/\n(?=\n)/g, '\n&nbsp;');
      // fix pasting text with line breaks '\n \n' -> '\n&nbsp;\n'
      newInput = newInput.replace(/\n\s(?=\n)/g, '\n&nbsp;');
      // fix line breaks '\r\n\r\n' -> '\n&nbsp;\n'
      newInput = newInput.replace(/\r\n\s(?=\n)/g, '\n&nbsp;');
      // fix pasting text with line breaks '\r\n \r\n' -> '\n&nbsp;\n'
      newInput = newInput.replace(/\r\n\s(?=\r\n)/g, '\n&nbsp;');
    }

    // newInput = newInput.replace(/^(?![\w-]+\n)(?:\n(?!.*\n))*\n/g, '&nbsp;');
    // newInput = newInput.replace(/^(?!.*-.*\n.*-.*$)\n(?=.*\n.*$)/g, '\n&nbsp;');
    // newInput = newInput.replace(/^-[\w\s]+(\n)+$/g, match => match.replace(/\n/g, '&nbsp;\n'));
    // newInput = newInput.replace(/^[^-].*?(\n)+$/g, match => match.replace(/\n/g, '&nbsp;\n'));
    // newInput = newInput.replace(/(-.*?\n)(?=\n)/g, '$1\n&nbsp;');
    // newInput = newInput.replace(/([^-].*?\n)(?=\n)/g, '$1&nbsp;');

    // console.log(JSON.stringify({ data: newInput }));
    return newInput;
  };

  this.editorStateToMarkdownEncoded = function (editorState) {
    var contentState = editorState.getCurrentContent();
    var rawContentState = (0, _draftJs.convertToRaw)(contentState);
    var markdownValue = _this3.draftJSToMarkdownWrapper(rawContentState);
    markdownValue = _this3.escapeLineBreaks(markdownValue); // TODO Booking Notes
    return encodeURIComponent(markdownValue);
  };

  this.isEditorStateIsEmpty = function (editorState) {
    var contentState = editorState.getCurrentContent();
    var textLength = contentState.getPlainText().replace(/\s/g, '').length;
    if (textLength < 1) return true;
    return false;
  };

  this.isEditorStateUnchanged = function (editorState, editorPrivacy, bookingNote) {
    if (bookingNote && bookingNote.privacy !== editorPrivacy) return false;
    if (bookingNote && bookingNote.note !== '') {
      var noteMDEncoded = _this3.editorStateToMarkdownEncoded(editorState);
      return bookingNote.note === noteMDEncoded;
    }
    return false;
  };

  this.handleOnEditorStateChange = function (newEditorState) {
    _this3.setState({
      editorState: newEditorState
    }, function () {
      // if hideCustomOptions is true then trigger props onUpdate with debouncer
      if (_this3.props.hideCustomOptions) {
        if (_this3.propUpdateTimeout) {
          clearTimeout(_this3.propUpdateTimeout);
        }
        _this3.propUpdateTimeout = setTimeout(function () {
          if (_this3.props.onUpdate) {
            var noteMDEncoded = _this3.editorStateToMarkdownEncoded(newEditorState);
            if (_this3.props.onUpdate) _this3.props.onUpdate(noteMDEncoded, _this3.state.editorPrivacy);
          }
          _this3.propUpdateTimeout = null;
        }, 100); // 100ms debounce delay
      }
    });
  };

  this.handleOnButtonAdd = function (e) {
    e.preventDefault();
    var _state2 = _this3.state,
        editorPrivacy = _state2.editorPrivacy,
        editorState = _state2.editorState;

    var noteMDEncoded = _this3.editorStateToMarkdownEncoded(editorState);
    if (_this3.props.onAdd) _this3.props.onAdd(noteMDEncoded, editorPrivacy);
  };

  this.handleOnButtonUpdate = function (e) {
    e.preventDefault();
    var _state3 = _this3.state,
        editorPrivacy = _state3.editorPrivacy,
        editorState = _state3.editorState;

    var noteMDEncoded = _this3.editorStateToMarkdownEncoded(editorState);
    if (_this3.props.onUpdate) _this3.props.onUpdate(noteMDEncoded, editorPrivacy);
  };

  this.handleOnButtonCancel = function (e) {
    e.preventDefault();
    if (_this3.props.onCancel) _this3.props.onCancel();
  };

  this.handleOnPrivacyChange = function (editorPrivacy) {
    _this3.setState({ editorPrivacy: editorPrivacy });
  };

  this.resetEditor = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var resetPrivacy = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var props, changedState;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              props = _this3.props;
              changedState = {
                editorState: _draftJs.EditorState.createEmpty()
              };

              if (resetPrivacy) changedState.editorPrivacy = _this3.defaultPrivacyToEditorPrivacy(props.defaultPrivacy, props.showInternalPrivacy);
              _context.next = 5;
              return _this3.setComponentState(changedState);

            case 5:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }));

    return function () {
      return _ref.apply(this, arguments);
    };
  }();

  this.editorToolBar = {
    options: ['inline', 'list', 'emoji'],
    inline: {
      options: ['bold', 'italic', 'underline', 'strikethrough']
    },
    list: {
      options: ['unordered', 'ordered']
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(NoteEditor);

/***/ }),
/* 2100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _NoteEditor = __webpack_require__(2099);

var _NoteEditor2 = _interopRequireDefault(_NoteEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _NoteEditor2.default;

/***/ }),
/* 2101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatNoteTimestamp = formatNoteTimestamp;
exports.formatNoteTooltip = formatNoteTooltip;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _displayTime = __webpack_require__(156);

var _countries = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The note list shows a relative/calendar label next to each note and the full timestamp in its
 * tooltip. Both have to describe the same instant in the same zone, so they live here together
 * rather than being formatted separately at the two JSX call sites.
 *
 * Kept as plain JS (no JSX) so the calendar decisions can be tested directly: the Jest transform
 * in this repo does not compile JSX.
 */

/**
 * The label under the note author. `language` drives Moment's global locale exactly as before —
 * month names and `fromNow()` wording are translated by it.
 */
function formatNoteTimestamp(timestamp, countryCode, _ref) {
  var language = _ref.language,
      atLabel = _ref.atLabel,
      yesterdayAtLabel = _ref.yesterdayAtLabel;

  // Deliberately unchanged from the original note list: this sets Moment's *global* locale from
  // the interface language, and the surrounding screens have always depended on that side effect.
  // Narrowing it to this value alone would be a separate, wider change, so it is preserved as-is.
  _momentTimezone2.default.locale(language);
  var now = (0, _displayTime.displayNow)(countryCode);
  var targetDate = (0, _displayTime.displayMoment)(timestamp, countryCode);
  if (now.isSame(targetDate, 'day')) {
    return targetDate.fromNow();
  }
  // `subtract` mutates, and the original code relied on `now` staying mutated for the year check
  // below. Vietnam needs an intact `now` so that check runs on the viewer's own calendar year;
  // MY/ID keep the existing reference so their output does not change at all.
  var yesterdayReference = (0, _countries.isCountryVietnam)(countryCode) ? now.clone() : now;
  if (yesterdayReference.subtract(1, 'days').isSame(targetDate, 'day')) {
    return targetDate.format('[' + yesterdayAtLabel + '] h:mm A');
  }
  if (now.isSame(targetDate, 'year')) {
    return targetDate.format('MMMM Do [' + atLabel + '] h:mm A');
  }
  return targetDate.format('MMMM Do YYYY [' + atLabel + '] h:mm A');
}

/**
 * The hover tooltip. `atLabel` differs per call site — the created tooltip is translated, the
 * edited one has always used a literal "at" — so it stays a caller decision.
 */
function formatNoteTooltip(timestamp, countryCode, atLabel) {
  return (0, _displayTime.displayMoment)(timestamp, countryCode).format('dddd, MMMM Do YYYY [' + atLabel + '] h:mm A');
}

/***/ }),
/* 2102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _translation = __webpack_require__(4);

var _vietnamPricing = __webpack_require__(197);

var _vietnam = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var BookingPricingPackage = function (_Component) {
  _inherits(BookingPricingPackage, _Component);

  function BookingPricingPackage() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BookingPricingPackage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BookingPricingPackage.__proto__ || Object.getPrototypeOf(BookingPricingPackage)).call.apply(_ref, [this].concat(args))), _this), _this.getPackagePricingName = function () {
      var data = _this.props.data;

      if (data && data.packagePricing) {
        var pp = data.packagePricing;
        return pp.isCustomPrice ? pp.customName : pp.name;
      }
      return '';
    }, _this.hasPackage = function (data) {
      var notCustom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (notCustom && data.packagePricing && data.packagePricing.projectPackagePricingID === '') return false;
      if (data.packagePricing && data.packagePricing.id !== '') return true;
      return false;
    }, _this.hasRecalculateAccess = function () {
      var auth = _this.props.auth;

      if (auth.isAdminBasic || auth.isSuperAdmin) return true;
      return false;
    }, _this.hasEditPackageAccess = function () {
      var _this$props = _this.props,
          auth = _this$props.auth,
          data = _this$props.data;

      return data.statusID === 'sold_spa_signed' && (auth.isAdmin || auth.isAdminBasic || auth.isSuperAdmin) || auth.isDeveloperSupervisor || auth.isDeveloperSalesManager || auth.isDeveloperSalesAdmin || auth.isHeadquarters;
    }, _this.disablePricingEditAfterSold = function (data) {
      return data && data.statusID === 'sold_spa_signed' && data.project && !data.project.allowPricingEditAfterSold;
    }, _this.isVNPricingLocked = function () {
      return (0, _vietnamPricing.isPricingPackageLocked)(_this.props.auth, _this.props.data && _this.props.data.statusID);
    }, _this.isVNHeaderOnly = function () {
      return (0, _vietnam.isVietnamCompany)(_this.props.auth);
    }, _this.handleRecalculate = function (e, data) {
      if (_this.props.onCheckRecalculate) {
        _this.props.onCheckRecalculate(data.checked);
      }
    }, _this.renderCalculationType = function (type, value, format, rounding) {
      var _this$props2 = _this.props,
          globalSettings = _this$props2.globalSettings,
          t = _this$props2.t;

      var listPriceName = globalSettings && globalSettings.unitSellingPrice ? globalSettings.unitSellingPrice.toLowerCase() : t('Unit Selling Price').toLowerCase();
      var spaPriceName = globalSettings && globalSettings.sellingPrice ? globalSettings.sellingPrice.toLowerCase() : t('Selling Price').toLowerCase();
      var roundingType = '';
      if (rounding.includes('round')) {
        roundingType = 'round';
      }
      if (rounding.includes('round_up')) {
        roundingType = 'round up decimals';
      }
      if (rounding.includes('round_down')) {
        roundingType = 'round down decimals';
      }
      if (roundingType) {
        roundingType = ' (' + t(roundingType) + ')';
      }
      if (format === 'custom') {
        return t('Custom formula');
      }
      var text = format === 'percentage' ? value + '%' : t('fixed amount');
      switch (type) {
        case 'deduct_from_list_price':
          return t('Deduct {{value}} from {{name}}', { value: text, name: '' + listPriceName + roundingType });
        case 'deduct_from_spa_price':
          return t('Deduct {{value}} from {{name}}', { value: text, name: '' + spaPriceName + roundingType });
        case 'deduct_from_sub_total':
          return t('Deduct {{value}} from {{name}}', { value: text, name: '' + t('above\'s subtotal') + roundingType });
        case 'add_from_list_price':
          return t('Add {{value}} from {{name}}', { value: text, name: '' + listPriceName + roundingType });
        case 'add_from_spa_price':
          return t('Add {{value}} from {{name}}', { value: text, name: '' + spaPriceName + roundingType });
        case 'add_from_sub_total':
          return t('Add {{value}} from {{name}}', { value: text, name: '' + t('above\'s subtotal') + roundingType });
        case 'free_item':
          return t('Free Item');
        case 'custom_formula':
          return t('Custom formula');
        default:
          return '';
      }
    }, _this.renderCalculationChangePrefix = function (type) {
      if (type.includes('deduct')) {
        return _react2.default.createElement(_semanticUiReact.Icon, { color: 'red', size: 'small', name: 'minus' });
      }
      if (type.includes('add')) {
        return _react2.default.createElement(_semanticUiReact.Icon, { color: 'green', size: 'small', name: 'plus' });
      }
      return '';
    }, _this.renderCalculationChangeClass = function (type) {
      if (type.includes('deduct')) {
        return 'text_deduct';
      }
      if (type.includes('add')) {
        return 'text_add';
      }
      return '';
    }, _this.renderDescription = function (itemDesc) {
      var iDesc = itemDesc;
      if (iDesc.includes('\n')) {
        iDesc = iDesc.split('\n').map(function (desc, idx) {
          return _react2.default.createElement(
            'span',
            { key: idx },
            desc,
            _react2.default.createElement('br', null)
          );
        });
      }
      return iDesc;
    }, _this.renderTextButton = function (title, name, placement) {
      var _this$props3 = _this.props,
          data = _this$props3.data,
          t = _this$props3.t;

      if (_this.isVNPricingLocked()) {
        return null;
      }
      return _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: _react2.default.createElement(_semanticUiReact.Label, {
          as: 'button',
          attached: placement || undefined,
          size: 'small',
          content: t(title),
          onClick: function onClick() {
            return _this.props.openModal && _this.props.openModal(name, true);
          },
          className: 'textButton',
          disabled: _this.disablePricingEditAfterSold(data)
        }),
        disabled: !_this.disablePricingEditAfterSold(data),
        content: t('Pricing details are locked because the booking has been marked as Sold', { ns: _translation.TRANSLATION_FILES.translation })
      });
    }, _this.renderHeader = function () {
      var _this$props4 = _this.props,
          data = _this$props4.data,
          availablePP = _this$props4.availablePP,
          t = _this$props4.t;

      return _react2.default.createElement(
        'span',
        null,
        _this.hasPackage(data) ? _react2.default.createElement(
          'span',
          null,
          'Pricing Package:\xA0',
          _react2.default.createElement(
            'span',
            { className: 'text_name italic' },
            _this.getPackagePricingName()
          )
        ) : _react2.default.createElement(
          'span',
          null,
          t('No Pricing Package added')
        ),
        _this.hasEditPackageAccess() && availablePP && availablePP.length > 0 && _this.renderTextButton((_this.hasPackage(data) ? 'Edit' : 'Add') + ' Package', 'showEditPackageModal'),
        _this.isVNPricingLocked() && _react2.default.createElement(
          'span',
          { className: 'text_formula_small' },
          '\xA0',
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', size: 'small' }),
          t((0, _vietnamPricing.vnPackageLockMessage)(_this.props.auth, data && data.statusID))
        )
      );
    }, _this.renderPackagePricingCalculations = function (type) {
      var _this$props5 = _this.props,
          data = _this$props5.data,
          t = _this$props5.t;

      var projectCurrencies = data.project.projectCurrency || null;
      var calculations = data && data.packagePricing && data.packagePricing.calculations ? data.packagePricing.calculations : [];
      var category = type === 'spa' ? 'spa_price' : 'list_price';
      return calculations.filter(function (c) {
        return c.category === category && c.isEnabled;
      }).map(function (calc, idx) {
        var name = calc.isAdhoc && calc.title === 'free_item' ? calc.formulaValue : calc.name;
        return _react2.default.createElement(
          _semanticUiReact.Table.Row,
          { key: idx, className: 'row_formula_items' },
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'text_formula_small' },
            calc.isSubTotal ? t('Sub total') : name
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'text_description' },
            _this.renderDescription(calc.description)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'text_description', textAlign: 'right' },
            _this.renderCalculationType(calc.calculationType, calc.formulaValue, calc.format, calc.rounding)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { textAlign: 'right' },
            !calc.isSubTotal ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'div',
                { className: 'div_inline_block' },
                _this.renderCalculationChangePrefix(calc.calculationType)
              ),
              _react2.default.createElement(
                'div',
                { className: 'div_inline_block ' + _this.renderCalculationChangeClass(calc.calculationType) },
                _react2.default.createElement(_LoanAmount2.default, {
                  precise: false,
                  projectCurrencies: projectCurrencies,
                  format: '0,000,000.00',
                  amount: calc.valueChange,
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                })
              )
            ) : ''
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { textAlign: 'right' },
            _react2.default.createElement(_LoanAmount2.default, {
              precise: false,
              projectCurrencies: projectCurrencies,
              format: '0,000,000.00',
              amount: calc.newValue,
              prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
            })
          )
        );
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BookingPricingPackage, [{
    key: 'hasAccessNettSellingPrice',
    value: function hasAccessNettSellingPrice(project) {
      var auth = this.props.auth;

      if (auth.isSuperAdmin || auth.isHeadquarters) {
        return true;
      }
      if (project && project.accessBULNettSellingPrice && auth.isBranchLeader) {
        return true;
      }
      if (project && project.accessStaffNettSellingPrice && auth && auth.companyBranch) {
        return true;
      }
      return false;
    }
    // CPI-977 requirements 7/11: in Vietnam the pricing package is HQ-only while Reserved and frozen from Booked.

    // CPI-977 (PO, 14 Sep): Vietnam shows only the header - package name, Edit Package and the
    // lock notice. The price breakdown and the formula editor stay hidden for now.


    // The whole card is read-only under the Vietnam lock; the reason is said once, in the header.

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          isEditing = _props.isEditing,
          globalSettings = _props.globalSettings,
          t = _props.t;

      var projectCurrencies = data.project.projectCurrency || null;
      var hasCalculations = data && data.packagePricing && data.packagePricing.calculations && data.packagePricing.calculations.length > 0;
      var hasSpaCalculations = hasCalculations && data.packagePricing.calculations.filter(function (c) {
        return c.category === 'spa_price' && c.isEnabled;
      }).length > 0;
      return _react2.default.createElement(
        'div',
        { className: 'bookingPricingPackage' },
        !this.isVNHeaderOnly() && this.hasPackage(data) && !data.packagePricing.isCustomPrice && this.hasEditPackageAccess() && this.renderTextButton('Customise formula(s)', 'showCustomiseFormulaModal', 'top right'),
        _react2.default.createElement(
          _semanticUiReact.Table,
          { compact: true, unstackable: true, structured: true },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 5 },
                this.renderHeader(),
                isEditing && this.hasRecalculateAccess() ? _react2.default.createElement(
                  'div',
                  { className: 'mobile-hide tablet-hide div_recalculate' },
                  _react2.default.createElement(_semanticUiReact.Checkbox
                  // eslint-disable-next-line jsx-a11y/label-has-for
                  , { label: _react2.default.createElement(
                      'label',
                      null,
                      t('Force recalculate pricing package from project unit'),
                      ' ',
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning sign' })
                    ),
                    onChange: this.handleRecalculate,
                    disabled: this.disablePricingEditAfterSold(data) || this.isVNPricingLocked()
                  })
                ) : ''
              )
            )
          ),
          !this.isVNHeaderOnly() && _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            this.hasPackage(data) ? _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 5 },
                _react2.default.createElement(
                  'span',
                  { className: 'text_description' },
                  data.packagePricing ? this.renderDescription(data.packagePricing.description) : ''
                )
              )
            ) : null,
            this.hasPackage(data) ? _react2.default.createElement(
              _semanticUiReact.Table.Row,
              { negative: true },
              _react2.default.createElement(_semanticUiReact.Table.Cell, { colSpan: 5 })
            ) : null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              { className: 'row_total' },
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 1, style: { width: '20%' } },
                _react2.default.createElement(
                  'b',
                  null,
                  globalSettings && globalSettings.unitSellingPrice ? globalSettings.unitSellingPrice : t('Unit Selling Price')
                )
              ),
              _react2.default.createElement(_semanticUiReact.Table.Cell, { colSpan: 1, style: { width: '25%' } }),
              _react2.default.createElement(_semanticUiReact.Table.Cell, { colSpan: 1, style: { width: '20%' } }),
              _react2.default.createElement(_semanticUiReact.Table.Cell, { colSpan: 1, style: { width: '13%' } }),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { style: { width: '13%' }, textAlign: 'right' },
                _react2.default.createElement(_LoanAmount2.default, {
                  projectCurrencies: projectCurrencies,
                  format: '0,000,000.00',
                  amount: data.unitSellingPrice,
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              { negative: true },
              _react2.default.createElement(_semanticUiReact.Table.Cell, { colSpan: 5 })
            ),
            hasCalculations ? this.renderPackagePricingCalculations('list') : null,
            this.hasPackage(data, true) ? _react2.default.createElement(
              _semanticUiReact.Table.Row,
              { negative: true },
              _react2.default.createElement(_semanticUiReact.Table.Cell, { colSpan: 5 })
            ) : null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              { className: 'row_total' },
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 2 },
                this.hasPackage(data) ? t('Total') + ' ' : '',
                globalSettings && globalSettings.sellingPrice ? globalSettings.sellingPrice : t('Selling Price')
              ),
              _react2.default.createElement(_semanticUiReact.Table.Cell, { colSpan: 2 }),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 1, textAlign: 'right' },
                data.packagePricing || data.spaAmount ? _react2.default.createElement(_LoanAmount2.default, {
                  precise: false,
                  projectCurrencies: projectCurrencies,
                  format: '0,000,000.00',
                  amount: data.packagePricing && data.packagePricing.spaPrice || data.spaAmount,
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                }) : '-'
              )
            ),
            hasSpaCalculations ? _react2.default.createElement(
              _semanticUiReact.Table.Row,
              { negative: true },
              _react2.default.createElement(_semanticUiReact.Table.Cell, { colSpan: 5 })
            ) : null,
            hasCalculations ? this.renderPackagePricingCalculations('spa') : null,
            hasSpaCalculations ? _react2.default.createElement(
              _semanticUiReact.Table.Row,
              { negative: true },
              _react2.default.createElement(_semanticUiReact.Table.Cell, { colSpan: 5 })
            ) : null,
            this.hasAccessNettSellingPrice(data.project) ? _react2.default.createElement(
              _semanticUiReact.Table.Row,
              { className: 'row_total' },
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 2 },
                this.hasPackage(data) ? t('Total') + ' ' : '',
                globalSettings && globalSettings.nettSellingPrice ? globalSettings.nettSellingPrice : t('Nett Selling Price')
              ),
              _react2.default.createElement(_semanticUiReact.Table.Cell, { colSpan: 2 }),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 1, textAlign: 'right' },
                data.packagePricing || data.nettSellingPrice ? _react2.default.createElement(_LoanAmount2.default, {
                  precise: false,
                  projectCurrencies: projectCurrencies,
                  format: '0,000,000.00',
                  amount: data.packagePricing.totalPrice || data.nettSellingPrice,
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                }) : '-'
              )
            ) : ''
          )
        )
      );
    }
  }]);

  return BookingPricingPackage;
}(_react.Component);

BookingPricingPackage.propTypes = {
  availablePP: _propTypes2.default.arrayOf(_propTypes2.default.shape()),
  data: _propTypes2.default.shape(),
  onCheckRecalculate: _propTypes2.default.func,
  isEditing: _propTypes2.default.bool,
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.shape({ countryCode: _propTypes2.default.string }),
    isSuperAdmin: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isAdmin: _propTypes2.default.bool,
    isDeveloperSupervisor: _propTypes2.default.bool,
    isDeveloperSalesManager: _propTypes2.default.bool,
    isDeveloperSalesAdmin: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool
  }),
  globalSettings: _propTypes2.default.shape(),
  openModal: _propTypes2.default.func,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(BookingPricingPackage);

/***/ }),
/* 2103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _CountdownAdvance = __webpack_require__(559);

var _CountdownAdvance2 = _interopRequireDefault(_CountdownAdvance);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var ISOFormat = 'YYYY-MM-DDTHH:mm:ss.SSSZ';

var AutoReleaseTimer = function (_Component) {
  _inherits(AutoReleaseTimer, _Component);

  function AutoReleaseTimer(props) {
    _classCallCheck(this, AutoReleaseTimer);

    var _this = _possibleConstructorReturn(this, (AutoReleaseTimer.__proto__ || Object.getPrototypeOf(AutoReleaseTimer)).call(this, props));

    _this.getCountdownFormat = function (endTime) {
      var minutesLeft = _momentTimezone2.default.duration((0, _momentTimezone2.default)(endTime).diff((0, _momentTimezone2.default)())).asMinutes();
      var hoursLeft = _momentTimezone2.default.duration((0, _momentTimezone2.default)(endTime).diff((0, _momentTimezone2.default)())).asHours();
      return {
        day: hoursLeft > 24 ? 'DD' : '',
        hour: minutesLeft > 60 ? 'HH' : '',
        minute: 'MM',
        second: 'SS'
      };
    };

    _this.getPercentage = function (partialValue, totalValue) {
      return parseInt(100 * partialValue / totalValue, 10);
    };

    _this.handleCountdownFinish = function () {
      if (_this.props.handleCountdownFinish) _this.props.handleCountdownFinish();
    };

    _this.handleOnChangeCountdown = function (countdownSeconds, remainingMS) {
      var remainingSeconds = parseInt(Math.floor(remainingMS * 0.001), 10);
      var newPercentage = 100 - _this.getPercentage(remainingSeconds, countdownSeconds);
      if (_this.state.percentage !== newPercentage) {
        _this.setState({ percentage: newPercentage });
      }
    };

    _this.state = {
      showCountdown: true,
      percentage: 0
    };
    return _this;
  }

  _createClass(AutoReleaseTimer, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          countdownSeconds = _props.countdownSeconds,
          countdownText = _props.countdownText,
          data = _props.data;

      var createdAtMoment = _momentTimezone2.default.tz(data.createdAt, ISOFormat);
      var endTime = createdAtMoment.clone().add(countdownSeconds, 'seconds');

      if ((0, _momentTimezone2.default)(endTime).unix() > (0, _momentTimezone2.default)(data.createdAt).unix() && (0, _momentTimezone2.default)(endTime).unix() > (0, _momentTimezone2.default)().unix()) {
        return _react2.default.createElement(
          _semanticUiReact.Message,
          { negative: true, style: { textAlign: 'center' } },
          _react2.default.createElement(
            'p',
            { style: { marginBottom: '0.5em' } },
            countdownText
          ),
          _react2.default.createElement(
            _semanticUiReact.Progress,
            { percent: this.state.percentage, size: 'tiny', color: 'red', active: true },
            _react2.default.createElement(_CountdownAdvance2.default, {
              targetDate: (0, _momentTimezone2.default)(endTime, 'ddd, DD MMM YYYY HH:mm:ss ZZ'),
              timeSeparator: ' ',
              onFinished: this.handleCountdownFinish,
              format: this.getCountdownFormat(endTime),
              showLegend: true,
              onChange: function onChange(remainingMS) {
                return _this2.handleOnChangeCountdown(countdownSeconds, remainingMS);
              }
            }),
            ' remaining'
          )
        );
      }
      return null;
    }
  }]);

  return AutoReleaseTimer;
}(_react.Component);

AutoReleaseTimer.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]).isRequired,
  countdownSeconds: _propTypes2.default.number,
  countdownText: _propTypes2.default.string,
  handleCountdownFinish: _propTypes2.default.func
};
AutoReleaseTimer.defaultProps = {
  countdownSeconds: 600,
  countdownText: '10 minutes.'
};
exports.default = AutoReleaseTimer;

/***/ }),
/* 2104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _NotificationItem = __webpack_require__(2105);

var _NotificationItem2 = _interopRequireDefault(_NotificationItem);

var _NotificationIcon = __webpack_require__(1008);

var _NotificationIcon2 = _interopRequireDefault(_NotificationIcon);

var _Timestamp = __webpack_require__(2106);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LeadActivity = function (_Component) {
  _inherits(LeadActivity, _Component);

  function LeadActivity(props) {
    _classCallCheck(this, LeadActivity);

    var _this = _possibleConstructorReturn(this, (LeadActivity.__proto__ || Object.getPrototypeOf(LeadActivity)).call(this, props));

    _this.setLoading = function () {
      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return new Promise(function (res) {
        _this.setState({ loading: loading }, res);
      });
    };

    _this.handleCheckBoxAll = function () {
      var bankCases = _this.props.bankCases;

      var ccIDs = [];
      if (!_this.isCheckedAll()) bankCases.forEach(function (c) {
        return ccIDs.push(c.id);
      });
      _this.setState({ ccIDs: ccIDs });
    };

    _this.handleCheckBox = function (item) {
      var ccIDs = _this.state.ccIDs;

      if (_this.isChecked(item)) {
        var index = ccIDs.indexOf(item.id);
        if (index > -1) {
          ccIDs.splice(index, 1);
        }
      } else {
        ccIDs.push(item.id);
      }
      _this.setState({ ccIDs: ccIDs });
    };

    _this.handleTextAreaChange = function (event) {
      _this.setState(_defineProperty({}, event.target.name, event.target.value));
    };

    _this.handleOnConfirm = function (e) {
      e.preventDefault();
      var data = {
        code: _this.props.leadCode,
        message: _this.state.remarkMessage,
        type: 'message',
        ccIDs: _this.state.ccIDs
      };
      _this.setState({ showAddRemark: false, remarkMessage: '', ccIDs: [] }, function () {
        _this.submitRemark(data);
      });
    };

    _this.handleShowAddRemark = function (e) {
      e.preventDefault();
      _this.setState({ showAddRemark: true });
    };

    _this.handleCloseAddRemark = function (e) {
      e.preventDefault();
      _this.setState({ showAddRemark: false, remarkMessage: '', ccIDs: [] });
    };

    _this.state = {
      remarkMessage: '',
      ccIDs: [],
      showAddRemark: false
    };
    return _this;
  }

  _createClass(LeadActivity, [{
    key: 'submitRemark',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var store, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _context.prev = 3;
                _context.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.props.bookingID + '/add_lead_activity/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(data)
                }));

              case 6:
                _context.next = 21;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](3);
                _context.next = 12;
                return this.setLoading(false);

              case 12:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 18;
                  break;
                }

                _context.next = 15;
                return _context.t0.res.text();

              case 15:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 18:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context.abrupt('return');

              case 21:
                _context.next = 23;
                return this.setLoading(false);

              case 23:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Success', message: 'Remark was successfully added.' }));
                if (this.props.fetchNewBooking) this.props.fetchNewBooking();

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 8]]);
      }));

      function submitRemark(_x2) {
        return _ref.apply(this, arguments);
      }

      return submitRemark;
    }()
  }, {
    key: 'isCheckedAll',
    value: function isCheckedAll() {
      var ccIDs = this.state.ccIDs;
      var bankCases = this.props.bankCases;

      if (ccIDs.length === bankCases.length) return true;
      return false;
    }
  }, {
    key: 'isChecked',
    value: function isChecked(item) {
      var ccIDs = this.state.ccIDs;

      return ccIDs.includes(item.id);
    }
  }, {
    key: 'renderModal',
    value: function renderModal() {
      var _this2 = this;

      var bankCases = this.props.bankCases;
      var _state = this.state,
          remarkMessage = _state.remarkMessage,
          showAddRemark = _state.showAddRemark;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        { size: 'tiny', open: showAddRemark },
        _react2.default.createElement(
          _semanticUiReact.Modal.Header,
          null,
          'Add Remark'
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Form,
            null,
            _react2.default.createElement(
              _semanticUiReact.Form.Group,
              { style: { marginBottom: '0.2em' } },
              _react2.default.createElement('textarea', {
                name: 'remarkMessage',
                className: 'semantic-textbox',
                placeholder: 'Type your message here',
                onChange: this.handleTextAreaChange,
                style: { resize: 'none', minHeight: '5.5em', maxHeight: '5.5em', width: '100%' },
                maxLength: '160',
                value: remarkMessage
              })
            ),
            _react2.default.createElement(
              'div',
              { style: { textAlign: 'right', marginBottom: '0.25em' } },
              _react2.default.createElement(
                'small',
                null,
                remarkMessage.length,
                ' of 160 characters'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Form.Group,
              { style: { marginBottom: '0' } },
              _react2.default.createElement(
                'small',
                { style: { padding: '0.1em' } },
                'Notify: '
              ),
              bankCases && bankCases.length > 0 ? bankCases.map(function (item, idx) {
                return _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  key: idx,
                  label: item.bank.shortName,
                  onChange: function onChange() {
                    return _this2.handleCheckBox(item);
                  },
                  checked: _this2.isChecked(item)
                });
              }) : '',
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: 'All',
                onChange: this.handleCheckBoxAll,
                checked: this.isCheckedAll()
              })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(
            _semanticUiReact.Button,
            { onClick: this.handleCloseAddRemark },
            'Cancel'
          ),
          _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleOnConfirm, disabled: remarkMessage === '', primary: true, icon: 'checkmark', labelPosition: 'right', content: 'Add' })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.props.data;

      return _react2.default.createElement(
        'div',
        null,
        this.renderModal(),
        data && data.length > 0 ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _semanticUiReact.Divider,
            { horizontal: true },
            'Timeline'
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { reversed: 'mobile vertically' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 16, tablet: 16, computer: 14 },
              data.map(function (item, index) {
                return _react2.default.createElement(_NotificationItem2.default, {
                  item: item,
                  key: index,
                  leftComponent: _react2.default.createElement(_NotificationIcon2.default, {
                    status: item.type
                  }),
                  timestamp: _react2.default.createElement(_Timestamp2.default, {
                    timestamp: item.createdAt,
                    precise: true
                  }),
                  showFullOnClick: true
                });
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 16, tablet: 16, computer: 2 },
              _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleShowAddRemark, fluid: true, primary: true, compact: true, size: 'small', content: 'Add Remark' })
            )
          )
        ) : ''
      );
    }
  }]);

  return LeadActivity;
}(_react.Component);

LeadActivity.contextTypes = {
  store: _propTypes2.default.object
};
LeadActivity.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  bankCases: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  leadCode: _propTypes2.default.string,
  token: _propTypes2.default.string,
  bookingID: _propTypes2.default.string,
  fetchNewBooking: _propTypes2.default.func
};
LeadActivity.defaultProps = {
  data: [],
  bankCases: [],
  leadCode: '',
  token: '',
  bookingIDL: ''
};
exports.default = LeadActivity;

/***/ }),
/* 2105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _marked = __webpack_require__(678);

var _marked2 = _interopRequireDefault(_marked);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-danger */
/* eslint-disable import/extensions */


var NotificationItem = function (_Component) {
  _inherits(NotificationItem, _Component);

  function NotificationItem(props) {
    _classCallCheck(this, NotificationItem);

    var _this = _possibleConstructorReturn(this, (NotificationItem.__proto__ || Object.getPrototypeOf(NotificationItem)).call(this, props));

    _this.primaryColumnSize = function () {
      if (_this.props.leftComponent) {
        return 'col-xs-7 col-md-9 col-lg-7';
      }
      return 'col-xs-9 col-md-10';
    };

    var item = props.item || {};

    var msg = props.item.message || '';
    if (props.message) {
      msg = props.message;
    }

    _this.state = {
      msg: msg,
      item: item
    };
    return _this;
  }

  _createClass(NotificationItem, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var item = nextProps.item || {};
      var msg = nextProps.item.message || '';
      if (nextProps.message) {
        msg = nextProps.message;
      }
      this.setState({
        msg: msg,
        item: item
      });
    }
  }, {
    key: 'innerHtml',
    value: function innerHtml() {
      return { __html: _marked2.default.parse(this.state.msg) };
    }
  }, {
    key: 'render',
    value: function render() {
      _marked2.default.setOptions({ sanitize: true });
      var classNames = ['list-item', 'notification-item'];
      if (this.props.className) {
        classNames.push(this.props.className);
      }
      if (this.props.selected) {
        classNames.push('selected');
      }
      if (this.props.disabled) {
        classNames.push('disabled');
      }
      return _react2.default.createElement(
        'div',
        {
          className: classNames.join(' ')
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            this.props.leftComponent ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 2, tablet: 1, computer: 1, textAlign: 'center', verticalAlign: 'middle', style: { padding: '0' } },
              this.props.leftComponent
            ) : null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 14, tablet: 15, computer: 15, textAlign: 'left', verticalAlign: 'middle', style: { padding: '0' } },
              _react2.default.createElement(
                'small',
                { style: { marginLeft: '0.5em' } },
                _react2.default.createElement(
                  'i',
                  null,
                  this.props.timestamp
                ),
                _react2.default.createElement('br', null)
              ),
              _react2.default.createElement('div', {
                dangerouslySetInnerHTML: this.innerHtml()
              })
            )
          )
        )
      );
    }
  }]);

  return NotificationItem;
}(_react.Component);

NotificationItem.propTypes = {
  className: _propTypes2.default.string,
  item: _propTypes2.default.object.isRequired,
  onClick: _propTypes2.default.func,
  selected: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  leftComponent: _propTypes2.default.node,
  timestamp: _propTypes2.default.object,
  url: _propTypes2.default.string,
  message: _propTypes2.default.string,
  disabledOnClick: _propTypes2.default.func
};

NotificationItem.contextTypes = {
  store: _propTypes2.default.object
};

exports.default = NotificationItem;

/***/ }),
/* 2106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _displayTime = __webpack_require__(156);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Timestamp = function Timestamp(_ref) {
  var timestamp = _ref.timestamp,
      precise = _ref.precise,
      countryCode = _ref.countryCode;

  var time = void 0;
  // Vietnam reads the value and the reference clock in the viewer's browser zone, so the
  // Today/Yesterday and year branches below follow the viewer's own calendar.
  var t = (0, _displayTime.displayMoment)(timestamp, countryCode);
  var startYear = (0, _displayTime.displayNow)(countryCode).startOf('year');
  var accurateTime = function accurateTime(tMoment, tStart) {
    var now = (0, _displayTime.displayNow)(countryCode);
    var minutes = now.diff(tMoment, 'minutes');
    var hours = now.diff(tMoment, 'hours');
    var days = now.diff(tMoment, 'days');
    if (minutes < 60) {
      return tMoment.startOf('minute').fromNow();
    }
    if (hours <= 12) {
      return tMoment.startOf('hour').fromNow();
    }
    if (days < 2) {
      return tMoment.calendar(now, {
        sameDay: '[Today] hh:mm a',
        lastDay: '[Yesterday] hh:mm a',
        lastWeek: 'DD MMM hh:mm a',
        sameElse: 'DD MMM hh:mm a'
      });
    }
    if (tMoment.isAfter(tStart)) {
      return tMoment.format('DD MMM hh:mm a');
    }
    return tMoment.format('DD/MM/YY hh:mm a');
  };
  var simpleTime = function simpleTime(tMoment, tStart) {
    if (tMoment.isAfter(tStart)) {
      return tMoment.format('DD MMM');
    }
    return tMoment.format('DD MMM YYYY');
  };
  if (precise) {
    time = accurateTime(t, startYear);
  } else {
    time = simpleTime(t, startYear);
  }
  return _react2.default.createElement(
    'span',
    { className: 'timestamp' },
    time
  );
};

Timestamp.propTypes = {
  timestamp: _propTypes2.default.oneOfType([_propTypes2.default.string]),
  precise: _propTypes2.default.bool,
  countryCode: _propTypes2.default.string
};

// Same reactive company selector as the shared components/Timestamp, so login, company
// switching and logout update a mounted timeline without a reload.
exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    countryCode: state.auth && state.auth.company && state.auth.company.countryCode
  };
})(Timestamp);

/***/ }),
/* 2107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _LeadActivity = __webpack_require__(2104);

var _LeadActivity2 = _interopRequireDefault(_LeadActivity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _LeadActivity2.default;

/***/ }),
/* 2108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _markdownDraftJs = __webpack_require__(450);

var _draftJs = __webpack_require__(338);

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

var _semanticUiReact = __webpack_require__(2);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _url = __webpack_require__(19);

var _isbase = __webpack_require__(157);

var _isbase2 = _interopRequireDefault(_isbase);

var _Filters = __webpack_require__(86);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _PopupButtonList = __webpack_require__(2168);

var _PopupButtonList2 = _interopRequireDefault(_PopupButtonList);

var _SearchIn = __webpack_require__(570);

var _SearchIn2 = _interopRequireDefault(_SearchIn);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _FixedBarStatus = __webpack_require__(1018);

var _FixedBarStatus2 = _interopRequireDefault(_FixedBarStatus);

var _apiEndpoints = __webpack_require__(140);

var endpoints = _interopRequireWildcard(_apiEndpoints);

var _dateRanges = __webpack_require__(265);

var _bookingStatuses = __webpack_require__(128);

var _countries = __webpack_require__(60);

var _vietnam = __webpack_require__(40);

var _lawyerCaseStatuses = __webpack_require__(142);

var _paymentStatuses = __webpack_require__(321);

var _paymentStatuses2 = _interopRequireDefault(_paymentStatuses);

var _translation = __webpack_require__(4);

var _fetchWithCacheSWR = __webpack_require__(1090);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint jsx-a11y/no-static-element-interactions: 0 */

var tabs = [{ value: 'all', name: 'all', text: 'All', header: 'Latest Bookings' }, { value: 'aging_by_units', name: 'aging_by_units', text: 'Aging By Units', header: 'Aging By Units' }, { value: 'aging_by_bankers', name: 'aging_by_bankers', text: 'Aging By Bankers', header: 'Aging By Bankers' }, { value: 'aging_by_lawyers', name: 'aging_by_lawyers', text: 'Aging By Lawyers', header: 'Aging By Lawyers' }];

var allFilterNames = ['bookingStatusMulti', 'dateRange', 'dateFrom', 'dateTo', 'cancelledDateRange', 'cancelledDateFrom', 'cancelledDateTo', 'expiredDateRange', 'expiredDateFrom', 'expiredDateTo', 'bookedDateRange', 'bookedDateFrom', 'bookedDateTo', 'soldDateRange', 'soldDateFrom', 'soldDateTo', 'paymentStatus', 'filteredProjects', 'agingRange', 'loanStatus', 'agingDuration', 'lawyerCaseType', 'lawyerCaseStatus'];

var BookingsList = function (_Component) {
  _inherits(BookingsList, _Component);

  function BookingsList(props) {
    _classCallCheck(this, BookingsList);

    var _this = _possibleConstructorReturn(this, (BookingsList.__proto__ || Object.getPrototypeOf(BookingsList)).call(this, props));

    _initialiseProps.call(_this);

    var state = BookingsList.getPropsToState(props);
    var summary = Object.assign({}, BookingsList.summaryDefault);
    _this.state = _extends({
      loading: true,
      count: 0,
      limit: 0,
      offset: 0,
      data: [],
      summary: summary
    }, state, {
      mpUserLoading: false,
      mpUserDetails: {},
      isChanging: false,
      projectOpts: [],
      filteredProjects: []
    });
    return _this;
  }

  _createClass(BookingsList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      this.fetchProjects();
      if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
        delete query.page;
      }
      var hasLawyerAccess = this.props.auth && this.props.auth.companyBranch && !this.props.auth.isExternalAgentLeader;
      var lawyerIsEnabled = this.props.appConfig && this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled && hasLawyerAccess;
      var showLawyerTab = lawyerIsEnabled && !(0, _countries.isCountryVietnam)(this.props.auth.company.countryCode);
      var tabss = showLawyerTab ? tabs : tabs.filter(function (t) {
        return t.value !== 'aging_by_lawyers';
      });
      if (query.tab && !tabss.some(function (t) {
        return t.value === query.tab;
      })) {
        delete query.tab;
      }
      this.replaceQuery(query);
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var currentTab = this.state.currentTab;

      var state = BookingsList.getPropsToState(nextProps);
      this.setState(state, function () {
        if (currentTab !== state.currentTab) {
          _this2.replaceQuery({
            tab: state.currentTab
          }, true);
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.setTimer) {
        clearTimeout(this.setTimer);
      }
      if (this.setStaffTimer) {
        clearTimeout(this.setStaffTimer);
      }
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setMPUserLoading',
    value: function setMPUserLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ mpUserLoading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'setLoadingProjectSearch',
    value: function setLoadingProjectSearch() {
      var _this4 = this;

      var loadingProjectSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loadingProjectSearch: loadingProjectSearch }, res);
      });
    }
  }, {
    key: 'setLoadingStaffSearch',
    value: function setLoadingStaffSearch() {
      var _this5 = this;

      var loadingStaffSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this5.setState({ loadingStaffSearch: loadingStaffSearch }, res);
      });
    }
  }, {
    key: 'setBookings',
    value: function setBookings() {
      var _this6 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this6.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this7 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this7.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this8 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this8.setState({ loading: loading }, function () {
          if (_this8.props.onLoading) {
            _this8.props.onLoading(loading);
          }
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchProjects',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, t, query, res, message, _message, data, newProjectOpts;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({
                  limit: 0,
                  showAsOptions: true
                });
                _context.next = 5;
                return this.setLoadingProjectSearch(true);

              case 5:
                res = void 0;
                _context.prev = 6;
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/projects/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context.sent;
                _context.next = 24;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                if (!(_context.t0.res && _context.t0.res.status >= 399 && _context.t0.res.status < 500)) {
                  _context.next = 19;
                  break;
                }

                _context.next = 17;
                return _context.t0.res.text();

              case 17:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 19:
                _context.next = 21;
                return this.setLoadingProjectSearch(false);

              case 21:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context.abrupt('return');

              case 24:
                if (res.ok) {
                  _context.next = 32;
                  break;
                }

                _context.next = 27;
                return res.text();

              case 27:
                _message = _context.sent;
                _context.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 30:
                _context.next = 39;
                break;

              case 32:
                _context.next = 34;
                return res.json();

              case 34:
                data = _context.sent;
                newProjectOpts = this.state.projectOpts;

                if (data && data.length > 0) {
                  newProjectOpts = data.map(function (d) {
                    return { value: d.id, text: d.name };
                  });
                }

                _context.next = 39;
                return this.setComponentState({ projectOpts: newProjectOpts });

              case 39:
                _context.next = 41;
                return this.setLoadingProjectSearch(false);

              case 41:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));

      function fetchProjects() {
        return _ref.apply(this, arguments);
      }

      return fetchProjects;
    }()
  }, {
    key: 'fetchBookings',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var t, store, query, res, limit, stringifyQuery, count, offset, que, url, urlOptions, message, _message2, _count, _limit, _offset, data, _que;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                query = Object.assign(q, this.props.where || {});
                res = void 0;

                if (!(this.props.appConfig && this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled && this.state.currentTab === 'aging_by_lawyers')) {
                  _context2.next = 54;
                  break;
                }

                if (query.projectFilter) {
                  query.project_code = atob(query.projectFilter);
                  delete query.projectFilter;
                }
                if (this.props.projectUnitID) {
                  query.project_unit_id = this.props.projectUnitID;
                }
                if (this.props.appConfig && this.props.appConfig.data) {
                  query.company_id = this.props.appConfig.data.companyID;
                }
                limit = 10;

                query.limit = limit;
                query.from = (query.page - 1) * limit;
                delete query.tab;
                delete query.page;
                if (query.lawyerCaseStatus) {
                  query.status = query.lawyerCaseStatus;
                  delete query.lawyerCaseStatus;
                }
                if (query.lawyerCaseType) {
                  query.type = query.lawyerCaseType;
                  delete query.lawyerCaseType;
                }
                if (query.agingDuration && query.agingDuration.startsWith('more_than_')) {
                  query.duration = parseInt(query.agingDuration.replace('more_than_', '').replace('_days', ''), 10);
                  delete query.agingDuration;
                }
                if (query.searchIn === 'lawyer') {
                  query.lawyer = query.search;
                  delete query.search;
                }
                if (query.searchIn === 'firm') {
                  query.firm = query.search;
                  delete query.search;
                }
                _context2.prev = 20;
                _context2.next = 23;
                return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.BOOKING_AGING_CASES + '/?' + _qs2.default.stringify(query), null, 'get', {
                  'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
                }));

              case 23:
                res = _context2.sent;
                _context2.next = 34;
                break;

              case 26:
                _context2.prev = 26;
                _context2.t0 = _context2['catch'](20);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 31;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 31:
                _context2.next = 33;
                return this.setLoading(false);

              case 33:
                return _context2.abrupt('return');

              case 34:
                if (!res) {
                  _context2.next = 51;
                  break;
                }

                stringifyQuery = _qs2.default.stringify(query);
                count = res.total_hits;
                offset = query.from;
                _context2.next = 40;
                return this.setBookings(res.items);

              case 40:
                if (this.props.hideBookingList) {
                  this.props.bookingListLength(this.state.data.length);
                }

                if (!(this.state.data.length < 1 && query.from >= limit)) {
                  _context2.next = 49;
                  break;
                }

                que = (0, _url.decodeSearch)(this.props.location.search);
                _context2.next = 45;
                return this.setComponentState({
                  offset: 0
                });

              case 45:
                que.page = 1;
                this.replaceQuery(que);
                _context2.next = 51;
                break;

              case 49:
                _context2.next = 51;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset,
                  stringifyQuery: stringifyQuery
                });

              case 51:
                _context2.next = 53;
                return this.setLoading(false);

              case 53:
                return _context2.abrupt('return');

              case 54:

                if (this.props.projectUnitID) {
                  query.projectUnitID = this.props.projectUnitID;
                }

                url = '/bookings/?' + _qs2.default.stringify(query);
                urlOptions = {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                };
                _context2.prev = 57;

                if (!(this.state.currentTab === 'aging_by_bankers')) {
                  _context2.next = 64;
                  break;
                }

                _context2.next = 61;
                return (0, _fetchWithCacheSWR.fetchWithCacheSWR)(store, url, urlOptions, 15000, // current ttl
                null, 'ttl', 'localStorage');

              case 61:
                res = _context2.sent;
                _context2.next = 67;
                break;

              case 64:
                _context2.next = 66;
                return store.dispatch((0, _fetchM.fetchM)(url, urlOptions));

              case 66:
                res = _context2.sent;

              case 67:
                _context2.next = 81;
                break;

              case 69:
                _context2.prev = 69;
                _context2.t1 = _context2['catch'](57);

                if (!(_context2.t1.res && _context2.t1.res.status >= 399 && _context2.t1.res.status < 500)) {
                  _context2.next = 76;
                  break;
                }

                _context2.next = 74;
                return _context2.t1.res.text();

              case 74:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 76:
                _context2.next = 78;
                return this.setLoading(false);

              case 78:
                Bugsnag.notifyException(_context2.t1);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context2.abrupt('return');

              case 81:
                if (res.ok) {
                  _context2.next = 89;
                  break;
                }

                _context2.next = 84;
                return res.text();

              case 84:
                _message2 = _context2.sent;
                _context2.next = 87;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message2 }));

              case 87:
                _context2.next = 106;
                break;

              case 89:
                _count = parseInt(res.headers.get('M-Data-count'), 10);
                _limit = parseInt(res.headers.get('M-Data-limit'), 10);
                _offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context2.next = 94;
                return res.json();

              case 94:
                data = _context2.sent;
                _context2.next = 97;
                return this.setBookings(data);

              case 97:
                if (this.props.hideBookingList) {
                  this.props.bookingListLength(this.state.data.length);
                }

                if (!(this.state.data.length < 1 && query.page > 1)) {
                  _context2.next = 104;
                  break;
                }

                _que = (0, _url.decodeSearch)(this.props.location.search);

                _que.page = 1;
                this.replaceQuery(_que);
                _context2.next = 106;
                break;

              case 104:
                _context2.next = 106;
                return this.setComponentState({
                  count: _count,
                  limit: _limit,
                  offset: _offset
                });

              case 106:
                _context2.next = 108;
                return this.setLoading(false);

              case 108:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[20, 26], [57, 69]]);
      }));

      function fetchBookings() {
        return _ref2.apply(this, arguments);
      }

      return fetchBookings;
    }()
  }, {
    key: 'fetchBookingSummaries',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var store, t, query, res, message, summary;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign(q, this.props.where || {});

                if (this.props.projectUnitID) {
                  query.projectUnitID = this.props.projectUnitID;
                }
                res = void 0;
                _context3.prev = 7;
                _context3.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/summary/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 10:
                res = _context3.sent;
                _context3.next = 21;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3['catch'](7);

                Bugsnag.notifyException(_context3.t0);
                _context3.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 18:
                _context3.next = 20;
                return this.setLoading(false);

              case 20:
                return _context3.abrupt('return');

              case 21:
                if (res.ok) {
                  _context3.next = 29;
                  break;
                }

                _context3.next = 24;
                return res.text();

              case 24:
                message = _context3.sent;
                _context3.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 27:
                _context3.next = 34;
                break;

              case 29:
                _context3.next = 31;
                return res.json();

              case 31:
                summary = _context3.sent;
                _context3.next = 34;
                return this.setComponentState({ summary: summary });

              case 34:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[7, 13]]);
      }));

      function fetchBookingSummaries() {
        return _ref3.apply(this, arguments);
      }

      return fetchBookingSummaries;
    }()
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isBranchLeader || this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasAdminAccess',
    value: function hasAdminAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasInternalDEAccess',
    value: function hasInternalDEAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var auth = this.props.auth;
      if (auth && auth.companyBranch && !auth.companyBranch.isExternal) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasStaffAccess',
    value: function hasStaffAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isSuperAdmin || this.props.auth.isHeadquarters) {
        return true;
      }
      return check;
    }
  }, {
    key: 'searchStaffs',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(value) {
        var store, t, res, message, json, findStaffResults, noStaffResultsMessage;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                _context4.next = 4;
                return this.setLoadingStaffSearch(true);

              case 4:
                res = null;
                _context4.prev = 5;
                _context4.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/search/staffs/?isExternal=false&limit=3&search=' + value, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context4.sent;
                _context4.next = 22;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](5);

                if (!(_context4.t0.res && _context4.t0.res.status >= 400 && _context4.t0.res.status < 500)) {
                  _context4.next = 18;
                  break;
                }

                _context4.next = 16;
                return _context4.t0.res.text();

              case 16:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 18:
                _context4.next = 20;
                return this.setLoadingStaffSearch(false);

              case 20:
                Bugsnag.notifyException(_context4.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 22:
                if (res.ok) {
                  _context4.next = 28;
                  break;
                }

                _context4.next = 25;
                return this.setLoadingStaffSearch(false);

              case 25:
                throw new Error('Not OK');

              case 28:
                _context4.next = 30;
                return this.setLoadingStaffSearch(false);

              case 30:
                _context4.next = 32;
                return res.json();

              case 32:
                json = _context4.sent;

                if (json) {
                  findStaffResults = json.map(function (obj) {
                    var newResults = {};
                    newResults.key = obj.id.toString();
                    newResults.title = obj.name;
                    newResults.price = obj.preferredName;
                    newResults.description = obj.email;
                    return newResults;
                  });

                  this.setState({ findStaffResults: findStaffResults });
                } else {
                  noStaffResultsMessage = t('No results found', { ns: _translation.TRANSLATION_FILES.translation }) + '.';

                  this.setState({ noStaffResultsMessage: noStaffResultsMessage });
                }

              case 34:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 11]]);
      }));

      function searchStaffs(_x13) {
        return _ref4.apply(this, arguments);
      }

      return searchStaffs;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var fetch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var store = this.context.store;
      var _props$location = this.props.location,
          pathname = _props$location.pathname,
          search = _props$location.search;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      var bookingStatus = (0, _url.decodeSearch)(search).bookingStatus;
      var bookingStatusMulti = (0, _url.decodeSearch)(search).bookingStatusMulti;
      var paymentStatus = (0, _url.decodeSearch)(search).paymentStatus;
      var lawyerCaseType = (0, _url.decodeSearch)(search).lawyerCaseType;
      var lawyerCaseStatus = (0, _url.decodeSearch)(search).lawyerCaseStatus;
      if (query.bookingStatus && !bookingStatus || query.bookingStatusMulti && !bookingStatusMulti || query.paymentStatus && !paymentStatus || query.lawyerCaseStatus && !lawyerCaseStatus || query.lawyerCaseType && !lawyerCaseType) {
        queryNew.page = 1;
      }
      if (fetch) {
        this.fetchBookings(queryNew);
        if (this.state.currentTab === 'all') {
          this.fetchBookingSummaries(queryNew);
        }
      }
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));
    }
    // CPI-1209 (PO, 5 Sep): the Booking ID column on this copy of the table, from utils/vietnam.

  }, {
    key: 'isShowLoanReminderLetter',
    value: function isShowLoanReminderLetter() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var criteria = this.state.currentTab === 'aging_by_units' && data.project.printLoanReminderType !== '' && (data.bookingStatus.id === 'booked' || data.bookingStatus.id === 'reserved') && this.checkGroupAccess(this.props.auth.groups) && data.currentAge >= 14 && data.currentAge <= 42;

      return criteria;
    }
  }, {
    key: 'isShowSpaReminderLetter',
    value: function isShowSpaReminderLetter() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var criteria = this.state.currentTab === 'aging_by_units' && data.project.printSPAType !== '' && (data.bookingStatus.id === 'booked' || data.bookingStatus.id === 'reserved') && this.checkGroupAccess(this.props.auth.groups) && data.currentAge >= 28;

      return criteria;
    }
  }, {
    key: 'isShowTerminationLetter',
    value: function isShowTerminationLetter() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var criteria = this.state.currentTab === 'aging_by_units' && data.project.printTerminationType !== '' && data.bookingStatus.id === 'sold_spa_signed' && this.checkGroupAccess(this.props.auth.groups) && data.currentAge >= 21;

      return criteria;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      if (this.props.hideBookingList && this.state.data.length < 1) {
        return _react2.default.createElement(_semanticUiReact.Grid, null);
      }
      var _state = this.state,
          currentTab = _state.currentTab,
          loading = _state.loading,
          data = _state.data,
          tabss = _state.tabss;
      var t = this.props.t;

      var sortItems = currentTab === 'aging_by_lawyers' ? [{
        text: 'Date Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'created_at',
        sortDirection: 'asc'
      }, {
        text: 'Date Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'created_at',
        sortDirection: 'desc'
      }, {
        text: 'Unit Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'property.unit_no.keyword',
        sortDirection: 'asc'
      }, {
        text: 'Unit Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'property.unit_no.keyword',
        sortDirection: 'desc'
      }, {
        text: 'Status Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'status.keyword',
        sortDirection: 'asc'
      }, {
        text: 'Status Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'status.keyword',
        sortDirection: 'desc'
      }, {
        text: 'Type Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'type.keyword',
        sortDirection: 'asc'
      }, {
        text: 'Type Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'type.keyword',
        sortDirection: 'desc'
      }, {
        text: 'Days Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'aging_days',
        sortDirection: 'asc'
      }, {
        text: 'Days Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'aging_days',
        sortDirection: 'desc'
      }, {
        text: 'Purchaser Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'purchaser.name.keyword',
        sortDirection: 'asc'
      }, {
        text: 'Purchaser Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'purchaser.name.keyword',
        sortDirection: 'desc'
      }] : [{
        text: 'Created Date Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.created_at' : 'booking.created_at',
        sortDirection: 'asc'
      }, {
        text: 'Created Date Descending',
        icon: 'sort alphabet descending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.created_at' : 'booking.created_at',
        sortDirection: 'desc'
      }, {
        text: 'Unit Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.reference_no' : 'project_unit.reference',
        sortDirection: 'asc'
      }, {
        text: 'Unit Descending',
        icon: 'sort alphabet descending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.reference_no' : 'project_unit.reference',
        sortDirection: 'desc'
      }, {
        text: 'Status Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.status' : 'booking_status.name',
        sortDirection: 'asc'
      }, {
        text: 'Status Descending',
        icon: 'sort alphabet descending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.status' : 'booking_status.name',
        sortDirection: 'desc'
      }, {
        text: 'Reserved By Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'affiliate.name' : 'booking.ma_created_by_preferred_name',
        sortDirection: 'asc'
      }, {
        text: 'Reserved By Descending',
        icon: 'sort alphabet descending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'affiliate.name' : 'booking.ma_created_by_preferred_name',
        sortDirection: 'desc'
      }, {
        text: 'Assigned Staff Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'booking.assigned_ma_preferred_name',
        sortDirection: 'asc'
      }, {
        text: 'Assigned Staff Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'booking.assigned_ma_preferred_name',
        sortDirection: 'desc'
      }, {
        text: 'Days Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: this.handleGetDaysSortColumn(),
        sortDirection: 'asc'
      }, {
        text: 'Days Descending',
        icon: 'sort alphabet descending',
        sortColumn: this.handleGetDaysSortColumn(),
        sortDirection: 'desc'
      }, {
        text: 'Banker Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'bankers.name',
        sortDirection: 'asc'
      }, {
        text: 'Banker Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'bankers.name',
        sortDirection: 'desc'
      }, {
        text: 'Bank Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'banks.short_name',
        sortDirection: 'asc'
      }, {
        text: 'Bank Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'banks.short_name',
        sortDirection: 'desc'
      }, {
        text: 'Code Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'bank_case.lead_id',
        sortDirection: 'asc'
      }, {
        text: 'Code Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'bank_case.lead_id',
        sortDirection: 'desc'
      }];
      sortItems.push.apply(sortItems, _toConsumableArray(this.statusDateSortItems()));
      var isMalaysia = this.props.auth.company && this.props.auth.company.countryCode === 'my';
      // CPI-1209: the plain Excel / CSV items. isCountryVietnam, not `!== 'my'`, which would add ID.
      var showPlainExports = isMalaysia || (0, _countries.isCountryVietnam)(this.props.auth.company && this.props.auth.company.countryCode);
      var exportItems = currentTab === 'aging_by_lawyers' ? [{
        text: 'Excel',
        icon: 'download',
        onClick: function () {
          var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
            var store, response;
            return regeneratorRuntime.wrap(function _callee5$(_context5) {
              while (1) {
                switch (_context5.prev = _context5.next) {
                  case 0:
                    store = _this9.context.store;
                    _context5.prev = 1;
                    _context5.next = 4;
                    return (0, _fetchM.serverRequestGet)('/bookings/export/aging/lawyers/?' + _this9.state.stringifyQuery, store);

                  case 4:
                    response = _context5.sent;

                    if (!response.error) {
                      _context5.next = 9;
                      break;
                    }

                    _context5.next = 8;
                    return store.dispatch((0, _flash.flashErrorMessage)({ message: response.message }));

                  case 8:
                    return _context5.abrupt('return');

                  case 9:
                    store.dispatch((0, _flash.flashSuccessMessage)({
                      header: t('Request Success', { ns: _translation.TRANSLATION_FILES.translation }),
                      message: t('We are processing your report, will send via email once the report is ready', { ns: _translation.TRANSLATION_FILES.translation }) + '.'
                    }));
                    _context5.next = 16;
                    break;

                  case 12:
                    _context5.prev = 12;
                    _context5.t0 = _context5['catch'](1);
                    _context5.next = 16;
                    return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

                  case 16:
                  case 'end':
                    return _context5.stop();
                }
              }
            }, _callee5, _this9, [[1, 12]]);
          }));

          return function onClick() {
            return _ref5.apply(this, arguments);
          };
        }()
      }] : this.exportItemsManager();
      if (currentTab !== 'aging_by_lawyers' && showPlainExports) {
        exportItems.push({
          text: 'Excel',
          icon: 'download',
          href: this.exportURL('excel')
        }, {
          text: 'CSV',
          icon: 'download',
          href: this.exportURL('csv')
        }, {
          isDivider: true
        });
      }
      if (currentTab !== 'aging_by_lawyers' && (0, _vietnam.showsPaymentExcelExport)(this.props.auth)) {
        exportItems.push({
          text: 'Payment\nExcel',
          icon: 'download',
          href: _config2.default.get('bookApiURL') + '/bookings/export/payments/?',
          dataTarget: 'paymentexcel'
        });
      }
      if (currentTab !== 'all' && currentTab !== 'aging_by_lawyers') {
        exportItems.push({
          text: 'Excel\n(detailed)',
          icon: 'download',
          href: this.exportURL('excel', false, true)
        });
      }
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { verticalAlign: 'middle', className: 'booking-list' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'tab-menu' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(
              _semanticUiReact.Menu,
              {
                attached: 'top',
                tabular: true
              },
              tabss.map(function (tab, key) {
                return _react2.default.createElement(
                  _semanticUiReact.Menu.Item,
                  {
                    key: key,
                    name: tab.name,
                    onClick: _this9.handleChangeTab,
                    active: currentTab === tab.name
                  },
                  t(tab.text, { ns: _translation.namespaces[tab.name === 'all' ? 1 : 0] }).toUpperCase()
                );
              })
            )
          )
        ),
        this.renderMenuTool(),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'app--listdata' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Dimmer,
              {
                inverted: true, style: { zIndex: 20 },
                active: loading && data.length > 0
              },
              _react2.default.createElement(
                _semanticUiReact.Loader,
                { inline: 'centered' },
                t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { className: 'booking-data' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { className: 'header' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 10, tablet: 6, computer: 6 },
                  _react2.default.createElement(
                    _semanticUiReact.Header,
                    { as: 'h2' },
                    this.getTabHeader()
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 6, tablet: 10, computer: 10, textAlign: 'right', className: 'download' },
                  _react2.default.createElement(_SortButton2.default, {
                    floated: 'right',
                    loading: loading,
                    items: sortItems,
                    onSort: this.handleSortData
                  }),
                  exportItems.length > 0 && _react2.default.createElement(_SortButton2.default, {
                    floated: 'right',
                    icon: 'download',
                    loading: loading,
                    items: exportItems
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 16 },
                  _react2.default.createElement(
                    _semanticUiReact.Table,
                    { basic: 'very', sortable: true, className: 'bookings' },
                    this.renderTableHeaders(sortItems),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Body,
                      null,
                      data.length > 0 ? data.map(this.renderTableRow) : _react2.default.createElement(
                        _semanticUiReact.Table.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Table.Cell,
                          { colSpan: 10, textAlign: 'center' },
                          loading ? _react2.default.createElement(
                            _semanticUiReact.Loader,
                            { active: true, inline: 'centered' },
                            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                          ) : _react2.default.createElement(
                            'p',
                            null,
                            t('No bookings found'),
                            '.'
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'center' },
            _react2.default.createElement(_PageNav2.default, {
              upward: true,
              currentPage: this.state.currentPage,
              count: this.state.count,
              limit: this.state.limit,
              offset: this.state.offset,
              dataSize: data.length,
              loading: loading,
              onChange: this.handleChangePage,
              noScrollTop: this.props.noScrollTop
            })
          )
        )
      );
    }
  }]);

  return BookingsList;
}(_react.Component);

BookingsList.contextTypes = {
  store: _propTypes2.default.object
};
BookingsList.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      companyID: _propTypes2.default.number,
      lawyerIsEnabled: _propTypes2.default.bool
    })
  }),
  where: _propTypes2.default.shape({}),
  projectUnitID: _propTypes2.default.string,
  onLoading: _propTypes2.default.func,
  noScrollTop: _propTypes2.default.bool,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isBranchLeaderSupervisor: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    groups: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      code: _propTypes2.default.string
    })),
    companyBranch: _propTypes2.default.shape({
      isExternal: _propTypes2.default.bool
    }),
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    }),
    isExternalAgentLeader: _propTypes2.default.bool
  }),
  hideBookingList: _propTypes2.default.bool,
  bookingListLength: _propTypes2.default.func,
  isUnitOverview: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
BookingsList.defaultProps = {
  hideBookingList: false
};

BookingsList.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

BookingsList.getPropsToState = function (props) {
  var windowWidth = window.innerWidth;
  var isMobile = windowWidth < 768;
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var searchIn = query.searchIn || '';
  var dateRange = query.dateRange || '';
  var cancelledDateRange = query.cancelledDateRange || '';
  var expiredDateRange = query.expiredDateRange || '';
  var bookedDateRange = query.bookedDateRange || '';
  var soldDateRange = query.soldDateRange || '';
  var loanStatus = query.loanStatus || [];
  var duration = query.duration || '';
  var bookingStatus = query.bookingStatus || '';
  var bookingStatusMulti = query.bookingStatusMulti || [];
  var agingRange = query.agingRange || '';
  var agingDuration = query.agingDuration || '';
  var paymentStatus = query.paymentStatus || [];
  var lawyerCaseType = query.lawyerCaseType || '';
  var lawyerCaseStatus = query.lawyerCaseStatus || '';
  var projectFilter = (0, _isbase2.default)(query.projectFilter) && _qs2.default.parse(atob(query.projectFilter)).name || '';
  var staffFilter = (0, _isbase2.default)(query.staffFilter) && _qs2.default.parse(atob(query.staffFilter)).name || '';
  var dateFrom = query.dateFrom ? query.dateFrom : '';
  var dateTo = query.dateTo ? query.dateTo : '';
  var cancelledDateFrom = query.cancelledDateFrom ? query.cancelledDateFrom : '';
  var cancelledDateTo = query.cancelledDateTo ? query.cancelledDateTo : '';
  var expiredDateFrom = query.expiredDateFrom ? query.expiredDateFrom : '';
  var expiredDateTo = query.expiredDateTo ? query.expiredDateTo : '';
  var bookedDateFrom = query.bookedDateFrom ? query.bookedDateFrom : '';
  var bookedDateTo = query.bookedDateTo ? query.bookedDateTo : '';
  var soldDateFrom = query.soldDateFrom ? query.soldDateFrom : '';
  var soldDateTo = query.soldDateTo ? query.soldDateTo : '';
  var loadingProjectSearch = false;
  var loadingStaffSearch = false;
  var findProjectResults = [];
  var findStaffResults = [];
  var loadingMessage = props.t('Loading', { ns: _translation.TRANSLATION_FILES.translation }) + '...';
  var noResultsMessage = loadingMessage;
  var noStaffResultsMessage = loadingMessage;
  var hasLawyerAccess = props.auth && props.auth.companyBranch && !props.auth.isExternalAgent;
  var lawyerIsEnabled = props.appConfig && props.appConfig.data && props.appConfig.data.lawyerIsEnabled && hasLawyerAccess;
  // CPI-1209 (A37): Vietnam has no lawyer module, so the Aging By Lawyers tab is dropped there.
  var showLawyerTab = lawyerIsEnabled && !(0, _countries.isCountryVietnam)(props.auth && props.auth.company && props.auth.company.countryCode);
  // const hasAccess = props.auth.isHeadquarters || props.auth.isSuperAdmin;
  var tabss = showLawyerTab ? tabs : tabs.filter(function (t) {
    return t.value !== 'aging_by_lawyers';
  });
  var currentTab = tabss.some(function (t) {
    return t.value === query.tab;
  }) ? query.tab : tabs[0].value;
  return {
    isMobile: isMobile,
    search: search,
    searchIn: searchIn,
    dateRange: dateRange,
    cancelledDateRange: cancelledDateRange,
    expiredDateRange: expiredDateRange,
    bookedDateRange: bookedDateRange,
    soldDateRange: soldDateRange,
    loanStatus: loanStatus,
    duration: duration,
    bookingStatus: bookingStatus,
    bookingStatusMulti: bookingStatusMulti,
    agingRange: agingRange,
    agingDuration: agingDuration,
    paymentStatus: paymentStatus,
    projectFilter: projectFilter,
    staffFilter: staffFilter,
    dateTo: dateTo,
    dateFrom: dateFrom,
    cancelledDateFrom: cancelledDateFrom,
    cancelledDateTo: cancelledDateTo,
    expiredDateFrom: expiredDateFrom,
    expiredDateTo: expiredDateTo,
    bookedDateFrom: bookedDateFrom,
    bookedDateTo: bookedDateTo,
    soldDateFrom: soldDateFrom,
    soldDateTo: soldDateTo,
    loadingProjectSearch: loadingProjectSearch,
    loadingStaffSearch: loadingStaffSearch,
    findProjectResults: findProjectResults,
    findStaffResults: findStaffResults,
    noResultsMessage: noResultsMessage,
    noStaffResultsMessage: noStaffResultsMessage,
    currentPage: currentPage,
    currentTab: currentTab,
    lawyerCaseStatus: lawyerCaseStatus,
    lawyerCaseType: lawyerCaseType,
    tabss: tabss,
    stringifyQuery: ''
  };
};

BookingsList.summaryDefault = {
  count: 0,
  reservedCount: 0,
  bookedCount: 0,
  cancelledDeveloperCount: 0,
  pendingCancellationCount: 0,
  cancelledCount: 0,
  soldCount: 0,
  loanCount: 0
};

var _initialiseProps = function _initialiseProps() {
  var _this10 = this;

  this.getStatusCount = function (status) {
    var summary = _this10.state.summary;

    if (_this10.state.loading) {
      return '...';
    }
    switch (status) {
      case 'total':
        return summary.count;
      case 'reserved':
        return summary.reservedCount;
      case 'booked':
        return summary.bookedCount;
      case 'pending_cancellation':
        return summary.pendingCancellationCount || 0;
      case 'cancelled_developer':
        return summary.cancelledDeveloperCount;
      case 'cancelled_availability':
        return summary.cancelledCount;
      case 'sold_spa_signed':
        return summary.soldCount;
      case 'expired':
        return summary.expiredCount || 0;
      default:
        return 0;
    }
  };

  this.getSelectedStatus = function (status) {
    var bookingStatus = _this10.state.bookingStatus;

    if (status === 'total') {
      return bookingStatus === '';
    } else if (bookingStatus !== '') {
      return bookingStatus === status;
    }
    return false;
  };

  this.getTabHeader = function () {
    var currentTab = _this10.state.currentTab;
    var t = _this10.props.t;

    return t(tabs.find(function (tab) {
      return currentTab === tab.value;
    }).header);
  };

  this.getBankCaseStatusColor = function (status) {
    if (status.startsWith('reject')) {
      return 'red';
    } else if (status.startsWith('pending')) {
      return 'yellow';
    } else if (status.startsWith('approved') || status.startsWith('success')) {
      return 'green';
    }
    return 'blue';
  };

  this.getBankCaseStatuses = function (data) {
    var values = [];
    if (data.bankCasesStatuses) {
      data.bankCasesStatuses.forEach(function (bcs) {
        values.push({
          iconColor: _this10.getBankCaseStatusColor(bcs.status),
          value: bcs.bankShortName
        });
      });
    }
    return values;
  };

  this.getRowClassName = function (statusID) {
    if (statusID === 'cancelled_availability') {
      return 'row-colors booking_row_cancelled_availability';
    }
    if (statusID === 'cancelled_developer' || statusID === _lawyerCaseStatuses.DEVELOPER_CANCELLED) {
      return 'row-colors booking_row_cancelled_developer';
    }
    return 'row-colors';
  };

  this.getAgingColor = function () {
    var days = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (days >= 30) {
      return 'red';
    }
    if (days >= 14) {
      return 'yellow';
    }
    return null;
  };

  this.getAllFilterNames = function () {
    var removeBookingStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (removeBookingStatus) return allFilterNames.filter(function (fn) {
      return fn !== 'bookingStatusMulti';
    });
    return allFilterNames;
  };

  this.fetchMarketplaceUserDetails = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(userID) {
      var store, t, url, response;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              store = _this10.context.store;
              t = _this10.props.t;
              url = '/marketplace/staffs/' + userID + '/';
              _context6.prev = 3;
              _context6.next = 6;
              return _this10.setMPUserLoading(true);

            case 6:
              _context6.next = 8;
              return (0, _fetchM.serverRequestGet)(url, store);

            case 8:
              response = _context6.sent;

              if (!response.error) {
                _context6.next = 13;
                break;
              }

              _context6.next = 12;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: response.message }));

            case 12:
              return _context6.abrupt('return');

            case 13:
              _context6.next = 15;
              return _this10.setState({ mpUserDetails: response.data });

            case 15:
              _context6.next = 17;
              return _this10.setMPUserLoading(false);

            case 17:
              _context6.next = 26;
              break;

            case 19:
              _context6.prev = 19;
              _context6.t0 = _context6['catch'](3);

              Bugsnag.notifyException(_context6.t0);
              _context6.next = 24;
              return _this10.setMPUserLoading(false);

            case 24:
              _context6.next = 26;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

            case 26:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this10, [[3, 19]]);
    }));

    return function (_x21) {
      return _ref6.apply(this, arguments);
    };
  }();

  this.handleResize = function () {
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    if (isMobile !== _this10.state.isMobile) {
      _this10.setState({ isMobile: isMobile });
    }
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this10.props.location.search);
    query.page = currentPage;
    _this10.setState({ currentPage: currentPage }, function () {
      _this10.replaceQuery(query);
    });
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this10.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this10.replaceQuery(query, true);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var clearSearch = false;
    var query = (0, _url.decodeSearch)(_this10.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (filter === 'search') {
        clearSearch = true;
      }
      if (filter === 'agingRange' || filter === 'loanStatus') {
        delete query.sortColumn;
        delete query.sortDirection;
      }
      if (filter === 'filteredProjects') {
        delete query.projectCode;
        delete query.projectFilter;
        hasQuery = true;
        _this10.setState({
          filteredProjects: [],
          isChanging: false
        });
      }
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
        _this10.setState({ isChanging: false });
      }
    });
    var cb = function cb() {
      if (hasQuery) {
        _this10.replaceQuery(query, true);
      }
    };
    if (clearSearch) {
      _this10.setState({ search: '' }, function () {
        cb();
      });
    } else {
      cb();
    }
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this10.props.location.search);
    query[queryName] = value;
    if (queryName === 'agingRange' || queryName === 'loanStatus') {
      delete query.sortColumn;
      delete query.sortDirection;
    }
    if (queryName === 'lawyerCaseType' && !(0, _lawyerCaseStatuses.getLawyerCaseStatuses)(value).some(function (s) {
      return s.value === query.lawyerCaseStatus;
    })) {
      delete query.lawyerCaseStatus;
    }
    var refetch = queryName !== 'searchIn' || queryName === 'searchIn' && _this10.state.search.length > 0;
    if (queryName === 'dateRange' && query.dateRange === 'custom' && (!query.dateFrom || !query.dateTo)) {
      refetch = false;
    }
    if (queryName === 'cancelledDateRange' && query.cancelledDateRange === 'custom' && (!query.cancelledDateFrom || !query.cancelledDateTo)) {
      refetch = false;
    }
    if (queryName === 'expiredDateRange' && query.expiredDateRange === 'custom' && (!query.expiredDateFrom || !query.expiredDateTo)) {
      refetch = false;
    }
    if (queryName === 'bookedDateRange' && query.bookedDateRange === 'custom' && (!query.bookedDateFrom || !query.bookedDateTo)) {
      refetch = false;
    }
    if (queryName === 'soldDateRange' && query.soldDateRange === 'custom' && (!query.soldDateFrom || !query.soldDateTo)) {
      refetch = false;
    }
    _this10.replaceQuery(query, true, refetch);
  };

  this.handleSetDateRange = function (name, from, to) {
    var query = (0, _url.decodeSearch)(_this10.props.location.search);
    switch (name) {
      case 'dateRange':
        query.dateFrom = from;
        query.dateTo = to;
        break;
      case 'cancelledDateRange':
        query.cancelledDateFrom = from;
        query.cancelledDateTo = to;
        break;
      case 'expiredDateRange':
        query.expiredDateFrom = from;
        query.expiredDateTo = to;
        break;
      case 'bookedDateRange':
        query.bookedDateFrom = from;
        query.bookedDateTo = to;
        break;
      case 'soldDateRange':
        query.soldDateFrom = from;
        query.soldDateTo = to;
        break;
      default:
        break;
    }
    _this10.replaceQuery(query, true);
  };

  this.handleReplaceStatus = function () {
    var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var query = (0, _url.decodeSearch)(_this10.props.location.search);
    if (status !== '') {
      query.bookingStatus = status;
    } else {
      delete query.bookingStatus;
    }
    if (status !== 'cancelled_developer') {
      delete query.cancelledDateRange;
      delete query.cancelledDateFrom;
      delete query.cancelledDateTo;
    }
    if (status !== 'expired') {
      delete query.expiredDateRange;
      delete query.expiredDateFrom;
      delete query.expiredDateTo;
    }
    if (status !== 'booked') {
      delete query.bookedDateRange;
      delete query.bookedDateFrom;
      delete query.bookedDateTo;
    }
    if (status !== 'sold_spa_signed') {
      delete query.soldDateRange;
      delete query.soldDateFrom;
      delete query.soldDateTo;
    }
    _this10.replaceQuery(query);
  };

  this.handleSearchStaff = function (value) {
    var t = _this10.props.t;

    clearTimeout(_this10.setStaffTimer);
    var findStaffResults = [];
    var noStaffResultsMessage = t('Loading', { ns: _translation.TRANSLATION_FILES.translation }) + '...';
    _this10.setState({ findStaffResults: findStaffResults, noStaffResultsMessage: noStaffResultsMessage, staffFilter: value }, function () {
      if (value !== '') {
        _this10.setStaffTimer = setTimeout(function () {
          _this10.searchStaffs(value);
        }, 500);
      }
    });
  };

  this.handleFilterProjects = function (e, _ref7) {
    var name = _ref7.name,
        value = _ref7.value;
    var currentTab = _this10.state.currentTab;

    var isCurrentTabLawyer = currentTab === 'aging_by_lawyers';
    var filteredProjects = isCurrentTabLawyer ? [value] : value;
    _this10.setState({ filteredProjects: filteredProjects }, function () {
      var query = (0, _url.decodeSearch)(_this10.props.location.search);
      query[name] = btoa(value);
      _this10.replaceQuery(query, true);
    });
  };

  this.handleSelectProject = function (project, queryName) {
    var query = (0, _url.decodeSearch)(_this10.props.location.search);
    var internalQuery = {};
    internalQuery.id = project.key;
    internalQuery.name = project.title;
    query[queryName] = btoa(_qs2.default.stringify(internalQuery));
    _this10.replaceQuery(query, true);
  };

  this.handleSelectStaff = function (staff, queryName) {
    var query = (0, _url.decodeSearch)(_this10.props.location.search);
    var internalQuery = {};
    internalQuery.id = staff.key;
    internalQuery.name = staff.title;
    query[queryName] = btoa(_qs2.default.stringify(internalQuery));
    _this10.replaceQuery(query, true);
  };

  this.exportURL = function (fileType) {
    var primary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var detailed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var _props = _this10.props,
        location = _props.location,
        projectUnitID = _props.projectUnitID;

    var url = _config2.default.get('bookApiURL') + '/reports/bookings/';
    if (location && location.search) {
      url += '' + location.search;
    }
    if (projectUnitID) {
      url += '&projectUnitID=' + projectUnitID;
    }
    if (primary) {
      url += '&primaryOnly=true';
    }
    url += '&fileType=' + fileType;
    if (detailed) {
      url += '&detailed=true';
    }
    return url;
  };

  this.getDataTarget = function (idx) {
    return { 'data-bot-target': 'row' + (idx + 1) + '-bookinglist' };
  };

  this.getDatasetAttributes = function (daname, davalue) {
    var newDavalue = davalue;
    if (newDavalue === '') newDavalue = 'NULL';
    if (newDavalue === 'Not Applicable') newDavalue = 'N/A';
    var datasetName = 'data-bot-' + daname;
    return _defineProperty({}, datasetName, newDavalue);
  };

  this.showBookingIDColumn = function () {
    return (0, _vietnam.showBookingIDColumn)(_this10.props.auth);
  };

  this.showProjectColumn = function () {
    return (0, _countries.isCountryVietnam)(_this10.props.auth.company.countryCode);
  };

  this.showPendingCancellation = function () {
    return (0, _countries.isCountryVietnam)(_this10.props.auth.company.countryCode);
  };

  this.handleChangeTab = function (e, _ref9) {
    var name = _ref9.name,
        value = _ref9.value;

    var currentTab = name || value;
    _this10.setState({
      currentTab: currentTab,
      data: [],
      filteredProjects: [],
      offset: 0,
      count: 0,
      limit: 0
    }, function () {
      if (_this10.props.isUnitOverview) {
        _this10.replaceQuery({
          tab: currentTab,
          section: 'bookings'
        }, true);
      } else {
        _this10.replaceQuery({
          tab: currentTab
        }, true);
      }
    });
  };

  this.agingRanges = [{
    value: 'all',
    text: 'All',
    sortColumn: 'aging_summary.current_age'
  }, {
    value: 'reserved_to_today',
    text: 'Reserved To Today',
    sortColumn: 'aging_summary.reserved_to_today_age'
  }, {
    value: 'reserved_to_booked',
    text: 'Reserved To Booked',
    sortColumn: 'aging_summary.booked_age'
  }, {
    value: 'reserved_to_sold',
    text: 'Reserved To Sold',
    sortColumn: 'aging_summary.reserved_to_sold_age'
  }, {
    value: 'booked_to_today',
    text: 'Booked To Today',
    sortColumn: 'aging_summary.booked_to_today_age'
  }, {
    value: 'booked_to_sold',
    text: 'Booked To Sold',
    sortColumn: 'aging_summary.sold_age'
  }];
  this.loanStatuses = [{
    value: 'new',
    text: 'New',
    sortColumn: 'summary.current_age'
  }, {
    value: 'pending_docs',
    text: 'Pending Docs',
    sortColumn: 'summary.current_age'
  }, {
    value: 'pending_docs_submitted',
    text: 'Docs Submitted',
    sortColumn: 'summary.current_age'
  }, {
    value: 'approved_lo_issued',
    text: 'LO Approved',
    sortColumn: 'summary.current_age'
  }, {
    value: 'success_li_issued',
    text: 'LO Signed',
    sortColumn: 'summary.created_to_success_li_issued_age'
  }, {
    value: 'reject_unqualified',
    text: 'Unqualified',
    sortColumn: 'summary.created_to_reject_unqualified_age'
  }, {
    value: 'reject_bank',
    text: 'Bank Rejected',
    sortColumn: 'summary.created_to_reject_bank_age'
  }, {
    value: 'reject_customer',
    text: 'Customer Rejected',
    sortColumn: 'summary.created_to_reject_customer_age'
  }, {
    value: 'reject_cancelled',
    text: 'Customer Cancelled',
    sortColumn: 'summary.created_to_reject_cancelled_age'
  }, {
    value: 'reject_lo_signed_other_bank',
    text: 'LO Signed With Another Bank',
    sortColumn: 'summary.created_to_reject_lo_signed_other_bank_age'
  }, {
    value: 'reject_developer',
    text: 'Developer Cancelled',
    sortColumn: 'summary.created_to_reject_developer_age'
  }];

  this.hasMPDetailsAccess = function () {
    var auth = _this10.props.auth;

    return auth.isHeadquarters || auth.isBranchLeaderSupervisor;
  };

  this.cellCheckSorted = function (column) {
    var isReversed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var _decodeSearch = (0, _url.decodeSearch)(_this10.props.location.search),
        sortColumn = _decodeSearch.sortColumn,
        sortDirection = _decodeSearch.sortDirection;

    var currentTab = _this10.state.currentTab;
    // API default sorted by created at descending

    if (!sortColumn) {
      if (currentTab === 'all' && column === 'booking.created_at' || currentTab === 'aging_by_units' && _this10.agingRanges.some(function (age) {
        return age.sortColumn === column;
      }) || currentTab === 'aging_by_bankers' && (_this10.loanStatuses.some(function (status) {
        return status.sortColumn === column;
      }) || column === 'summary.current_age') || currentTab === 'aging_by_lawyers' && column === 'aging_days') {
        return 'descending';
      }
    }
    if (column === sortColumn) {
      if (isReversed) {
        return sortDirection === 'asc' ? 'descending' : 'ascending';
      }
      return sortDirection === 'asc' ? 'ascending' : 'descending';
    }
    return null;
  };

  this.handleCellSort = function (column) {
    var query = (0, _url.decodeSearch)(_this10.props.location.search);
    var sortColumn = query.sortColumn,
        sortDirection = query.sortDirection;
    var currentTab = _this10.state.currentTab;

    var direction = 'asc';
    if (!sortColumn && currentTab === 'aging_by_lawyers' && column === 'aging_days') {
      direction = 'desc';
    } else if (column === sortColumn) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc';
    }
    _this10.handleSortData(column, direction);
  };

  this.handleGetDaysSortColumn = function () {
    if (_this10.state.currentTab === 'aging_by_bankers') {
      if (_this10.loanStatuses.some(function (status) {
        return status.value === _this10.state.loanStatus;
      })) {
        return _this10.loanStatuses.find(function (status) {
          return status.value === _this10.state.loanStatus;
        }).sortColumn;
      }
      return _this10.loanStatuses[0].sortColumn;
    }
    if (_this10.agingRanges.some(function (age) {
      return age.value === _this10.state.agingRange;
    })) {
      return _this10.agingRanges.find(function (age) {
        return age.value === _this10.state.agingRange;
      }).sortColumn;
    }
    return _this10.agingRanges[0].sortColumn;
  };

  this.exportItemsAdmin = function () {
    if (_this10.hasAdminAccess() && _this10.state.currentTab !== 'aging_by_bankers') {
      var _props2 = _this10.props,
          location = _props2.location,
          projectUnitID = _props2.projectUnitID;

      var url = _config2.default.get('bookApiURL') + '/reports/bookings/customer_details/';
      if (location && location.search) {
        url += '' + location.search;
      }
      if (projectUnitID) {
        url += '&projectUnitID=' + projectUnitID;
      }
      return [{
        text: 'Excel\nwith\nCustomer\nDetails',
        icon: 'download',
        href: url + '&fileType=excel'
      }, {
        text: 'Excel\n(primary)\nwith\nCustomer\nDetails',
        icon: 'download',
        href: url + '&fileType=excel&primaryOnly=true'
      }, {
        text: 'CSV\nwith\nCustomer\nDetails',
        icon: 'download',
        href: url + '&fileType=csv'
      }, {
        text: 'CSV\n(primary)\nwith\nCustomer\nDetails',
        icon: 'download',
        href: url + '&fileType=csv&primaryOnly=true'
      }];
    }
    return [];
  };

  this.exportItemsPrimary = function () {
    if (_this10.state.currentTab !== 'aging_by_bankers') {
      return [{
        text: 'Excel\n(primary)',
        icon: 'download',
        href: _this10.exportURL('excel', true)
      }, {
        text: 'CSV\n(primary)',
        icon: 'download',
        href: _this10.exportURL('csv', true)
      }];
    }
    return [];
  };

  this.exportItemsManager = function () {
    var isMalaysia = _this10.props.auth.company && _this10.props.auth.company.countryCode === 'my';
    if (_this10.hasAccess() && _this10.state.currentTab !== 'aging_by_bankers') {
      var query = (0, _url.decodeSearch)(_this10.props.location.search);
      query.page = 'all';
      var exportItems = [{
        text: 'Full\nExcel',
        icon: 'download',
        href: _config2.default.get('bookApiURL') + '/bookings/export/?' + _qs2.default.stringify(query),
        dataTarget: 'fullexcel'
      }, {
        text: 'Updated Today',
        icon: 'download',
        href: _config2.default.get('bookApiURL') + '/bookings/export/?page=all&updatedToday=true',
        dataTarget: 'updatedtoday'
      }, {
        isDivider: true
      }];
      if (_this10.state.currentTab === 'all' && isMalaysia) {
        exportItems.push({
          text: 'Loan Approval',
          icon: 'download',
          href: _config2.default.get('bookApiURL') + '/bookings/export/loan_approvals/?' + _qs2.default.stringify(query),
          dataTarget: 'loanapproval'
        }, {
          text: 'Booking Notes',
          icon: 'download',
          href: _config2.default.get('bookApiURL') + '/bookings/export/notes/?' + _qs2.default.stringify(query),
          dataTarget: 'bookingnotes'
        }, {
          isDivider: true
        });
      }
      return exportItems;
    }
    return [];
  };

  this.checkGroupAccess = function (groups) {
    var roles = [{ text: 'Headquarters', value: '10,6' }, { text: 'Supervisor', value: '10,11,12,13' }, { text: 'Sales Manager', value: '10,11,13' }, { text: 'Sales Admin', value: '10,11' }];
    var rolesArr = [];
    if (groups) {
      groups.forEach(function (g) {
        rolesArr.push(g.id);
      });
      rolesArr.sort();
      var role = roles.find(function (g) {
        return g.value === String(rolesArr.toString());
      });
      if (role && role.text) {
        return role.text;
      }
    }
    return null;
  };

  this.hasLawyerSPASignedDate = function (date) {
    if (date) {
      if (date.length > 1 && date[1]) {
        return true;
      }
    }
    return false;
  };

  this.handlePrint = function () {
    _auth2.default.currentSession();
  };

  this.statusDateSortItems = function () {
    var bookingStatus = _this10.state.bookingStatus;

    var label = '';
    var column = '';
    switch (bookingStatus) {
      case 'cancelled_developer':
        label = 'Cancelled';
        column = 'l_cancelled_developer_at';
        break;
      case 'expired':
        label = 'Expired';
        column = 'l_expired_at';
        break;
      case 'booked':
        label = 'Booked';
        column = 'l_booked_at';
        break;
      case 'sold_spa_signed':
        label = 'Sold';
        column = 'l_sold_at';
        break;
      default:
        break;
    }
    return !_this10.props.projectUnitID && column ? [{
      text: label + ' Date Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'booking.' + column,
      sortDirection: 'asc'
    }, {
      text: label + ' Date Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'booking.' + column,
      sortDirection: 'desc'
    }] : [];
  };

  this.bookingNoteToMarkdown = function (bNote) {
    try {
      var hasNoSpaces = bNote.indexOf(' ') === -1;
      if (hasNoSpaces) {
        return decodeURIComponent(bNote.replace(/\+/g, ' '));
      }
      return decodeURIComponent(bNote);
    } catch (e) {
      return bNote;
    }
  };

  this.bookingNoteToEditorState = function (bookingNote) {
    var mdValue = _this10.bookingNoteToMarkdown(bookingNote);
    if (mdValue) {
      var rawData = (0, _markdownDraftJs.markdownToDraft)(mdValue, {
        preserveNewlines: true,
        blockStyles: {
          ins_open: 'UNDERLINE'
        },
        remarkableOptions: {
          enable: {
            inline: 'ins'
          }
        }
      });
      var contentState = (0, _draftJs.convertFromRaw)(rawData);
      var editorState = _draftJs.EditorState.createWithContent(contentState);
      return editorState;
    }
    return _draftJs.EditorState.createEmpty();
  };

  this.bookingNoteFormated = function (bookingData) {
    if (!bookingData) return '';
    if (!bookingData.latestBookingNote) return bookingData.remarkInternal; // deprecated old field
    // convert markdown to draft-js and then back to plaintext properly with custom formatings.
    var editorState = _this10.bookingNoteToEditorState(bookingData.latestBookingNote);
    var contentState = editorState.getCurrentContent();
    var plainText = contentState.getPlainText();
    var maxLength = 180;
    if (plainText && plainText.length > maxLength) {
      plainText = plainText.substring(0, maxLength) + '...';
    }
    return plainText;
  };

  this.hasBookingNote = function (bookingData) {
    if (bookingData && (bookingData.latestBookingNote || bookingData.remarkInternal)) return true;
    return false;
  };

  this.renderStatusDateFilter = function () {
    var _state2 = _this10.state,
        bookingStatus = _state2.bookingStatus,
        loading = _state2.loading;

    var filter = '';
    var filterFrom = '';
    var filterTo = '';
    var headerText = '';
    switch (bookingStatus) {
      case 'cancelled_developer':
        filter = 'cancelledDateRange';
        filterFrom = 'cancelledDateFrom';
        filterTo = 'cancelledDateTo';
        headerText = 'Cancelled Date Range';
        break;
      case 'expired':
        filter = 'expiredDateRange';
        filterFrom = 'expiredDateFrom';
        filterTo = 'expiredDateTo';
        headerText = 'Expired Date Range';
        break;
      case 'booked':
        filter = 'bookedDateRange';
        filterFrom = 'bookedDateFrom';
        filterTo = 'bookedDateTo';
        headerText = 'Booked Date Range';
        break;
      case 'sold_spa_signed':
        filter = 'soldDateRange';
        filterFrom = 'soldDateFrom';
        filterTo = 'soldDateTo';
        headerText = 'Sold Date Range';
        break;
      default:
        break;
    }
    return filter && !_this10.props.projectUnitID && _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      {
        className: 'filter',
        mobile: 8,
        tablet: 5,
        computer: 4
      },
      _react2.default.createElement(_Filters.BookingDatePicker, {
        filterName: filter,
        filterNameFrom: filterFrom,
        filterNameTo: filterTo,
        headerText: headerText,
        placeholder: 'Select ' + headerText,
        dateFrom: _this10.state[filterFrom],
        dateTo: _this10.state[filterTo],
        onChange: _this10.handleFilterOnChange,
        onClose: _this10.handleClearFilter,
        onResetRange: _this10.handleClearFilter,
        onSetRange: function onSetRange(from, to) {
          return _this10.handleSetDateRange(filter, from, to);
        },
        value: _this10.state[filter],
        disabled: loading
      })
    );
  };

  this.renderMenuTool = function () {
    var _props3 = _this10.props,
        projectUnitID = _props3.projectUnitID,
        t = _props3.t;
    var _state3 = _this10.state,
        currentTab = _state3.currentTab,
        isMobile = _state3.isMobile,
        loading = _state3.loading,
        loadingProjectSearch = _state3.loadingProjectSearch,
        isChanging = _state3.isChanging;

    var isCurrentTabAll = currentTab === 'all';
    var isCurrentTabUnit = currentTab === 'aging_by_units';
    var isCurrentTabBanker = currentTab === 'aging_by_bankers';
    var isCurrentTabLawyer = currentTab === 'aging_by_lawyers';
    var searchAreas = isCurrentTabLawyer ? [{ value: 'all', text: t('All', { ns: _translation.TRANSLATION_FILES.constants }) }, { value: 'lawyer', text: t('Lawyer') }, { value: 'firm', text: t('Law Firm') }] : [{ value: 'all', text: t('All', { ns: _translation.TRANSLATION_FILES.constants }) }, { value: 'booking.assigned_ma_preferred_name', text: t('Assigned staff') }, { value: isCurrentTabBanker ? 'affiliate.name' : 'booking.ma_created_by_preferred_name', text: isCurrentTabBanker ? t('Reserved by') : (0, _vietnam.createdByLabel)(_this10.props.auth, t, t('Reserved by')) }, { value: isCurrentTabBanker ? 'company_branch.name' : 'booking.ma_user_affiliate_company_branch_short_name', text: t('Business Unit') }];
    if (isCurrentTabBanker) {
      searchAreas.push({ value: 'bankers.name', text: t('Banker') }, { value: 'banks.name,banks.short_name', text: t('Bank') });
    }
    var statusTabs = (0, _bookingStatuses.bookingStatusesTabs)(_this10.showPendingCancellation());
    return _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { className: 'toolbar' },
      isCurrentTabAll ? _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 16 },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          {
            className: 'status',
            columns: 'equal',
            textAlign: 'left',
            verticalAlign: 'middle',
            stretched: true
          },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            statusTabs.map(function (status, key) {
              return _react2.default.createElement(_FixedBarStatus2.default, {
                key: key,
                status: status.value,
                name: t(status.text, { ns: _translation.TRANSLATION_FILES.constants }),
                count: _this10.getStatusCount(status.value),
                selected: _this10.getSelectedStatus(status.value),
                onClick: status.value === 'total' ? function () {
                  return _this10.handleReplaceStatus();
                } : _this10.handleReplaceStatus
              });
            })
          )
        )
      ) : null,
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 16 },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          {
            className: 'filters booking',
            columns: 'equal',
            textAlign: 'left',
            verticalAlign: 'middle'
          },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            isCurrentTabAll ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter',
                mobile: projectUnitID ? 7 : 8,
                tablet: projectUnitID ? 7 : 5,
                computer: 4
              },
              _react2.default.createElement(_Filters.BookingDatePicker, {
                filterName: 'dateRange',
                filterNameFrom: 'dateFrom',
                filterNameTo: 'dateTo',
                headerText: 'Created Date Range',
                placeholder: 'Select Created Date Range',
                dateFrom: _this10.state.dateFrom,
                dateTo: _this10.state.dateTo,
                onChange: _this10.handleFilterOnChange,
                onClose: _this10.handleClearFilter,
                onResetRange: _this10.handleClearFilter,
                onSetRange: function onSetRange(from, to) {
                  return _this10.handleSetDateRange('dateRange', from, to);
                },
                value: _this10.state.dateRange,
                disabled: loading
              })
            ) : null,
            _this10.renderStatusDateFilter(),
            isCurrentTabAll ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter',
                mobile: projectUnitID ? 7 : 8,
                tablet: projectUnitID ? 7 : 6,
                computer: projectUnitID ? 4 : 3
              },
              _react2.default.createElement(_Filters.BookingSelectListMultiple, {
                filterName: 'bookingStatusMulti',
                onChange: _this10.handleFilterOnChange,
                onClose: _this10.handleClearFilter,
                options: (0, _bookingStatuses.bookingStatusesAll)(_this10.showPendingCancellation()).map(function (_ref10) {
                  var value = _ref10.value,
                      text = _ref10.text;
                  return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                }),
                placeholder: t('Booking Status'),
                value: _this10.state.bookingStatusMulti,
                disabled: loading
              })
            ) : null,
            isCurrentTabAll ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter',
                mobile: projectUnitID ? 7 : 8,
                tablet: projectUnitID ? 7 : 6,
                computer: projectUnitID ? 4 : 3
              },
              _react2.default.createElement(_Filters.BookingSelectListMultiple, {
                filterName: 'paymentStatus',
                onChange: _this10.handleFilterOnChange,
                onClose: _this10.handleClearFilter,
                options: _paymentStatuses2.default.map(function (_ref11) {
                  var value = _ref11.value,
                      text = _ref11.text;
                  return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                }),
                placeholder: t('Payment Status'),
                value: _this10.state.paymentStatus,
                disabled: loading
              })
            ) : null,
            !projectUnitID && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter',
                mobile: isChanging ? 14 : 16,
                tablet: isChanging ? 6 : 7,
                computer: 4,
                style: isCurrentTabAll && isMobile ? { paddingTop: '0.5rem' } : null
              },
              _react2.default.createElement(_semanticUiReact.Dropdown, {
                disabled: loading || loadingProjectSearch,
                fluid: true,
                loading: loadingProjectSearch,
                multiple: !isCurrentTabLawyer,
                name: 'projectFilter',
                onChange: _this10.handleFilterProjects,
                options: _this10.state.projectOpts,
                placeholder: t('Find Project'),
                search: true,
                selection: true,
                value: !isCurrentTabLawyer ? _this10.state.filteredProjects : _this10.state.filteredProjects[0] || ''
              })
            ),
            isCurrentTabUnit ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter',
                mobile: projectUnitID ? 7 : 8,
                tablet: projectUnitID ? 7 : 4,
                computer: projectUnitID ? 4 : 3
              },
              _react2.default.createElement(_Filters.BookingSelectList, {
                filterName: 'agingRange',
                onChange: _this10.handleFilterOnChange,
                onClose: _this10.handleClearFilter,
                options: _this10.agingRanges.map(function (_ref12) {
                  var value = _ref12.value,
                      text = _ref12.text;
                  return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                }),
                placeholder: t('Aging Range'),
                value: _this10.state.agingRange,
                disabled: loading
              })
            ) : null,
            isCurrentTabBanker ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter',
                mobile: projectUnitID ? 7 : 8,
                tablet: projectUnitID ? 7 : 4,
                computer: projectUnitID ? 4 : 3
              },
              _react2.default.createElement(_Filters.BookingSelectListMultiple, {
                filterName: 'loanStatus',
                onChange: _this10.handleFilterOnChange,
                onClose: _this10.handleClearFilter,
                options: _this10.loanStatuses.map(function (_ref13) {
                  var value = _ref13.value,
                      text = _ref13.text;
                  return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                }),
                placeholder: t('Loan Status'),
                value: _this10.state.loanStatus,
                disabled: loading
              })
            ) : null,
            isCurrentTabLawyer ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter',
                mobile: 8,
                tablet: 4,
                computer: 3
              },
              _react2.default.createElement(_Filters.BookingSelectList, {
                filterName: 'lawyerCaseType',
                onChange: _this10.handleFilterOnChange,
                onClose: _this10.handleClearFilter,
                options: _lawyerCaseStatuses.LAWYER_CASE_TYPES.map(function (_ref14) {
                  var value = _ref14.value,
                      text = _ref14.text;
                  return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                }),
                placeholder: t('Case Type'),
                value: _this10.state.lawyerCaseType,
                disabled: loading
              })
            ) : null,
            isCurrentTabLawyer ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter',
                mobile: 8,
                tablet: 4,
                computer: 3,
                style: isMobile && !projectUnitID ? { paddingTop: '0.5rem' } : null
              },
              _react2.default.createElement(_Filters.BookingSelectList, {
                filterName: 'lawyerCaseStatus',
                onChange: _this10.handleFilterOnChange,
                onClose: _this10.handleClearFilter,
                options: (0, _lawyerCaseStatuses.getLawyerCaseStatuses)(_this10.state.lawyerCaseType).map(function (_ref15) {
                  var value = _ref15.value,
                      text = _ref15.text;
                  return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                }),
                placeholder: t('Case Status'),
                value: _this10.state.lawyerCaseStatus,
                disabled: loading
              })
            ) : null,
            currentTab !== 'all' ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter',
                mobile: !isCurrentTabLawyer && projectUnitID ? 7 : 8,
                tablet: !isCurrentTabLawyer && projectUnitID ? 7 : 4,
                computer: !isCurrentTabLawyer && projectUnitID ? 4 : 3,
                style: isMobile && (!projectUnitID || projectUnitID && isCurrentTabLawyer) ? { paddingTop: '0.5rem' } : null
              },
              _react2.default.createElement(_Filters.BookingSelectList, {
                filterName: 'agingDuration',
                onChange: _this10.handleFilterOnChange,
                onClose: _this10.handleClearFilter,
                options: _dateRanges.AGING_DATE_RANGE.map(function (_ref16) {
                  var value = _ref16.value,
                      text = _ref16.text;
                  return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                }),
                placeholder: t('Duration'),
                value: _this10.state.agingDuration,
                disabled: loading
              })
            ) : null,
            isCurrentTabUnit ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter',
                mobile: projectUnitID ? 7 : 8,
                tablet: projectUnitID ? 7 : 4,
                computer: projectUnitID ? 4 : 3
              },
              _react2.default.createElement(_Filters.BookingSelectListMultiple, {
                filterName: 'bookingStatusMulti',
                onChange: _this10.handleFilterOnChange,
                onClose: _this10.handleClearFilter,
                options: (0, _bookingStatuses.bookingStatusesAll)(_this10.showPendingCancellation()).map(function (_ref17) {
                  var value = _ref17.value,
                      text = _ref17.text;
                  return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                }),
                placeholder: t('Booking Status'),
                value: _this10.state.bookingStatusMulti,
                disabled: loading
              })
            ) : null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'clear ' + (isCurrentTabLawyer && !projectUnitID ? 'tablet-hide mobile-hide' : ''),
                textAlign: 'center',
                verticalAlign: 'middle',
                mobile: !isCurrentTabLawyer && projectUnitID ? 2 : 2,
                tablet: !isCurrentTabLawyer && projectUnitID ? 2 : 1,
                computer: isCurrentTabLawyer ? projectUnitID ? 2 : 3 : projectUnitID ? 3 : 1
              },
              _this10.getAllFilterNames(false).some(function (filterName) {
                return _this10.state[filterName] && _this10.state[filterName].length > 0;
              }) ? _react2.default.createElement(
                'a',
                { onClick: function onClick() {
                    return _this10.handleClearFilter.apply(_this10, _toConsumableArray(_this10.getAllFilterNames(false)));
                  } },
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  { size: 'small', color: 'red' },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove', fitted: true })
                )
              ) : null
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                mobile: !isCurrentTabBanker && !projectUnitID ? 13 : 16,
                tablet: isCurrentTabAll && !projectUnitID ? 8 : !isCurrentTabBanker && !projectUnitID ? 10 : 16,
                computer: !isCurrentTabBanker && !projectUnitID ? 16 : 5,
                style: !projectUnitID && !isCurrentTabBanker || projectUnitID && isCurrentTabUnit ? { paddingTop: '0.5rem' } : null
              },
              _react2.default.createElement(_SearchIn2.default, {
                isLoading: loading,
                onChange: _this10.handleFilterOnChange,
                onSearchInChange: _this10.handleFilterOnChange,
                onClear: _this10.handleClearFilter,
                search: _this10.state.search,
                searchIn: _this10.state.searchIn,
                options: searchAreas,
                isFullSize: !isCurrentTabBanker && !projectUnitID
              })
            ),
            !projectUnitID && isCurrentTabLawyer ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'clear',
                textAlign: 'right',
                only: 'tablet mobile',
                mobile: 2,
                tablet: 1
              },
              _this10.getAllFilterNames(false).some(function (filterName) {
                return _this10.state[filterName] && _this10.state[filterName].length > 0;
              }) ? _react2.default.createElement(
                'a',
                { onClick: function onClick() {
                    return _this10.handleClearFilter.apply(_this10, _toConsumableArray(_this10.getAllFilterNames(false)));
                  } },
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  { size: 'small', color: 'red' },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove', fitted: true })
                )
              ) : null
            ) : null
          )
        )
      )
    );
  };

  this.renderStatusDateCell = function (isHeader) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var t = _this10.props.t;
    var bookingStatus = _this10.state.bookingStatus;

    var label = '';
    var date = '';
    switch (bookingStatus) {
      case 'cancelled_developer':
        label = 'Cancelled';
        date = data.lastCancelledDeveloperAt;
        break;
      case 'expired':
        label = 'Expired';
        date = data.lastExpiredAt;
        break;
      case 'booked':
        label = 'Booked';
        date = data.lastBookedAt;
        break;
      case 'sold_spa_signed':
        label = 'Sold';
        date = data.lastSoldAt;
        break;
      default:
        break;
    }
    if (isHeader) {
      return _react2.default.createElement(
        'span',
        null,
        t('Created'),
        !_this10.props.projectUnitID && label && _react2.default.createElement(
          'span',
          null,
          '\xA0&',
          _react2.default.createElement('br', null),
          t(label, { ns: _translation.TRANSLATION_FILES.constants })
        )
      );
    }
    return !_this10.props.projectUnitID && date && _react2.default.createElement(
      'small',
      null,
      _react2.default.createElement(_Timestamp2.default, {
        timestamp: date,
        format: 'DD/M/YYYY'
      }),
      _react2.default.createElement('br', null),
      _react2.default.createElement(_Timestamp2.default, {
        timestamp: date,
        format: 'hh:mm a'
      })
    );
  };

  this.renderTableHeaders = function (sortItems) {
    var _props4 = _this10.props,
        projectUnitID = _props4.projectUnitID,
        t = _props4.t;
    var currentTab = _this10.state.currentTab;

    var isCurrentTabAll = currentTab === 'all';
    var isCurrentTabBanker = currentTab === 'aging_by_bankers';
    var isCurrentTabLawyer = currentTab === 'aging_by_lawyers';
    return _react2.default.createElement(
      _semanticUiReact.Table.Header,
      { className: 'mobile-hide' },
      _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        !isCurrentTabAll ? _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            collapsing: true,
            sorted: _this10.cellCheckSorted(sortItems[isCurrentTabLawyer ? 8 : 10].sortColumn, isCurrentTabLawyer),
            onClick: function onClick() {
              return _this10.handleCellSort(sortItems[isCurrentTabLawyer ? 8 : 10].sortColumn);
            }
          },
          t('Days')
        ) : null,
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            collapsing: true,
            sorted: _this10.cellCheckSorted(sortItems[0].sortColumn),
            onClick: function onClick() {
              return _this10.handleCellSort(sortItems[0].sortColumn);
            }
          },
          _this10.renderStatusDateCell(true)
        ),
        _this10.showBookingIDColumn() ? _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          { className: 'mobile-hide' },
          t('Booking ID', { ns: _translation.TRANSLATION_FILES.translation })
        ) : null,
        _this10.showProjectColumn() ? _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          { className: 'mobile-hide' },
          t('Project', { ns: _translation.TRANSLATION_FILES.screens })
        ) : null,
        !projectUnitID ? _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            sorted: _this10.cellCheckSorted(sortItems[2].sortColumn),
            onClick: function onClick() {
              return _this10.handleCellSort(sortItems[2].sortColumn);
            }
          },
          t('Unit')
        ) : null,
        isCurrentTabAll ? _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          { className: 'mobile-hide' },
          t('Customer')
        ) : null,
        projectUnitID && isCurrentTabBanker ? _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            collapsing: true,
            sorted: isCurrentTabLawyer ? null : _this10.cellCheckSorted(sortItems[16].sortColumn),
            onClick: isCurrentTabLawyer ? null : function () {
              return _this10.handleCellSort(sortItems[16].sortColumn);
            }
          },
          t('Code')
        ) : null,
        !isCurrentTabBanker && !isCurrentTabLawyer && _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          { collapsing: true },
          t('Bank')
        ),
        isCurrentTabLawyer && _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            sorted: _this10.cellCheckSorted(sortItems[10].sortColumn),
            onClick: function onClick() {
              return _this10.handleCellSort(sortItems[10].sortColumn);
            }
          },
          t('Purchaser')
        ),
        isCurrentTabLawyer && _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            sorted: _this10.cellCheckSorted(sortItems[6].sortColumn),
            onClick: function onClick() {
              return _this10.handleCellSort(sortItems[6].sortColumn);
            }
          },
          t('Type')
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            sorted: _this10.cellCheckSorted(sortItems[4].sortColumn),
            onClick: function onClick() {
              return _this10.handleCellSort(sortItems[4].sortColumn);
            }
          },
          t('Status')
        ),
        isCurrentTabBanker && _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            collapsing: true,
            sorted: _this10.cellCheckSorted(sortItems[12].sortColumn),
            onClick: function onClick() {
              return _this10.handleCellSort(sortItems[12].sortColumn);
            }
          },
          t('Banker')
        ),
        isCurrentTabLawyer && _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            sorted: isCurrentTabLawyer ? null : _this10.cellCheckSorted(sortItems[4].sortColumn),
            onClick: isCurrentTabLawyer ? null : function () {
              return _this10.handleCellSort(sortItems[4].sortColumn);
            }
          },
          t('Lawyer')
        ),
        isCurrentTabBanker && _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            collapsing: true,
            sorted: _this10.cellCheckSorted(sortItems[14].sortColumn),
            onClick: function onClick() {
              return _this10.handleCellSort(sortItems[14].sortColumn);
            }
          },
          t('Bank')
        ),
        !isCurrentTabLawyer && _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            collapsing: true,
            sorted: _this10.cellCheckSorted(sortItems[6].sortColumn),
            onClick: function onClick() {
              return _this10.handleCellSort(sortItems[6].sortColumn);
            }
          },
          isCurrentTabBanker ? t('Reserved by') : (0, _vietnam.createdByLabel)(_this10.props.auth, t, t('Reserved by'))
        ),
        !isCurrentTabLawyer && _this10.hasInternalDEAccess() ? _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            collapsing: true,
            sorted: _this10.cellCheckSorted(sortItems[8].sortColumn),
            onClick: function onClick() {
              return _this10.handleCellSort(sortItems[8].sortColumn);
            }
          },
          t('Assigned staff')
        ) : null,
        _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null),
        _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null)
      )
    );
  };

  this.renderTableRow = function (data, idx) {
    var _state4 = _this10.state,
        currentTab = _state4.currentTab,
        mpUserLoading = _state4.mpUserLoading,
        mpUserDetails = _state4.mpUserDetails;
    var t = _this10.props.t;

    var isPendingCancellation = _this10.showPendingCancellation() && (0, _bookingStatuses.isBookingPendingCancellation)(data);
    if (currentTab === 'aging_by_lawyers') {
      var statusOption = _lawyerCaseStatuses.LAWYER_ALL_STATUSES.find(function (s) {
        return s.value === data.status;
      });
      var status = '';
      if (statusOption) {
        status = t(statusOption.text, { ns: _translation.TRANSLATION_FILES.constants });
      }
      return _react2.default.createElement(
        _semanticUiReact.Table.Row,
        {
          key: idx,
          className: _this10.getRowClassName(data.status)
        },
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { collapsing: true, className: 'days' },
          _react2.default.createElement(
            'span',
            { className: 'mobile-hide' },
            _react2.default.createElement(_semanticUiReact.Header, {
              color: _this10.getAgingColor(data.aging_days || 0),
              content: data.aging_days || 0
            })
          ),
          _react2.default.createElement(
            'span',
            { className: 'computer-hide' },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/bookings/' + data.booking_id + '/' },
              data.purchaser && data.purchaser.name || '',
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron right', style: { float: 'right' } })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { collapsing: true },
          _react2.default.createElement(
            'span',
            { className: 'mobile-hide' },
            _react2.default.createElement(_Timestamp2.default, {
              timestamp: data.created_at,
              format: 'DD/M/YYYY'
            }),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_Timestamp2.default, {
              timestamp: data.created_at,
              format: 'hh:mm a'
            })
          ),
          currentTab === 'all' && _react2.default.createElement(
            'span',
            { className: 'computer-hide' },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/bookings/' + data.booking_id + '/' },
              data.purchaser && data.purchaser.name || '',
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron right', style: { float: 'right' } })
            )
          )
        ),
        !_this10.props.projectUnitID ? _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { title: data.code, to: '/bookings/' + data.booking_id + '/' },
            data.property.unit_no,
            ', ',
            data.property.project_name
          ),
          _this10.hasBookingNote(data) && _react2.default.createElement(_semanticUiReact.Popup, {
            trigger: _react2.default.createElement(
              'div',
              { className: 'mobile-hide', style: { float: 'right', color: 'rgba(0,0,0,.5)' } },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'sticky note', color: 'grey' })
            ),
            content: _this10.bookingNoteFormated(data),
            size: 'mini',
            inverted: true
          })
        ) : null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { collapsing: true },
          _react2.default.createElement(
            'span',
            { className: 'mobile-hide' },
            data.purchaser.name
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { collapsing: true },
          _react2.default.createElement(
            'span',
            { className: 'mobile-hide' },
            data.type
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { collapsing: true },
          _react2.default.createElement(
            'span',
            { className: 'mobile-hide', title: _this10.hasLawyerSPASignedDate(data.status_updated_at) && data.type === 'SPA' && 'SPA Signed At ' + (0, _momentTimezone2.default)(data.status_updated_at[1]).format('DD-MM-YYYY, hh:mm a') },
            status,
            _this10.hasLawyerSPASignedDate(data.status_updated_at) && data.type === 'SPA' && _react2.default.createElement(_semanticUiReact.Popup, {
              trigger: _react2.default.createElement(
                'div',
                { className: 'mobile-hide', style: { float: 'right', color: 'rgba(0,0,0,.5)' } },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'sticky note', color: 'grey' })
              ),
              content: t('SPA Signed At') + ' ' + (0, _momentTimezone2.default)(data.status_updated_at[1]).format('DD-MM-YYYY, hh:mm a'),
              size: 'mini',
              inverted: true
            })
          ),
          _react2.default.createElement(
            'span',
            { className: 'computer-hide' },
            _react2.default.createElement(
              'small',
              null,
              status
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { collapsing: true },
          _react2.default.createElement(
            'span',
            { className: 'mobile-hide' },
            data.lawyer.name
          ),
          _react2.default.createElement(
            'span',
            { className: 'computer-hide' },
            _react2.default.createElement(
              'small',
              null,
              data.lawyer.name
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { collapsing: true },
          _react2.default.createElement(
            'span',
            { className: 'computer-hide' },
            _react2.default.createElement(
              'small',
              null,
              _react2.default.createElement(_Timestamp2.default, {
                timestamp: data.created_at,
                format: 'DD/M/YYYY'
              }),
              _react2.default.createElement('br', null),
              _react2.default.createElement(_Timestamp2.default, {
                timestamp: data.created_at,
                format: 'hh:mm a'
              })
            ),
            _react2.default.createElement(_semanticUiReact.Header, {
              floated: 'right',
              color: _this10.getAgingColor(data.aging_days || 0),
              content: data.aging_days || 0
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { collapsing: true, textAlign: 'right' },
          _react2.default.createElement(
            'span',
            { className: 'mobile-hide' },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/bookings/' + data.booking_id + '/' },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron right' })
            )
          )
        )
      );
    }
    return _react2.default.createElement(
      _semanticUiReact.Table.Row,
      _extends({
        key: idx,
        className: _this10.getRowClassName(data.statusID)
      }, _this10.getDataTarget(idx), _this10.getDatasetAttributes('bookingid', data.id), _this10.getDatasetAttributes('unitno', data.projectUnit.reference), _this10.getDatasetAttributes('projectname', data.project.shortName), _this10.getDatasetAttributes('purchasername', currentTab === 'aging_by_bankers' ? data.name : data.bookingCustomer && data.bookingCustomer.name || '')),
      currentTab !== 'all' ? _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true, className: 'days' },
        _react2.default.createElement(
          'span',
          { className: 'mobile-hide' },
          _react2.default.createElement(_semanticUiReact.Header, {
            color: _this10.getAgingColor(data.currentAge),
            content: data.currentAge
          })
        ),
        _react2.default.createElement(
          'span',
          { className: 'computer-hide' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/bookings/' + data.id + '/' },
            (currentTab === 'aging_by_bankers' ? data.name : data.bookingCustomer && data.bookingCustomer.name) || '',
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron right', style: { float: 'right' } })
          )
        )
      ) : null,
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true },
        _react2.default.createElement(
          'span',
          { className: 'mobile-hide' },
          _react2.default.createElement(_Timestamp2.default, {
            timestamp: data.createdAt,
            format: 'DD/M/YYYY'
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement(_Timestamp2.default, {
            timestamp: data.createdAt,
            format: 'hh:mm a'
          }),
          _react2.default.createElement('br', null),
          _this10.renderStatusDateCell(false, data)
        ),
        currentTab === 'all' && _react2.default.createElement(
          'span',
          { className: 'computer-hide' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/bookings/' + data.id + '/' },
            data.bookingCustomer && data.bookingCustomer.name,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron right', style: { float: 'right' } })
          )
        )
      ),
      _this10.showBookingIDColumn() ? _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'mobile-hide' },
        (0, _vietnam.bookingIDCellValue)(data)
      ) : null,
      _this10.showProjectColumn() ? _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'mobile-hide' },
        data.project && data.project.name || '-'
      ) : null,
      !_this10.props.projectUnitID ? _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        null,
        _react2.default.createElement(
          _reactRouter.Link,
          { title: data.code, to: '/bookings/' + data.id + '/' },
          data.projectUnit.reference,
          ', ',
          data.project.shortName,
          data.projectUnit.isBumi && _react2.default.createElement(
            _semanticUiReact.Label,
            { size: 'mini', style: { marginLeft: '0.5em' } },
            (0, _vietnam.unitQuotaChipLabel)(_this10.props.auth, t)
          ),
          data.origin && data.origin.includes('marketplace') && _react2.default.createElement(
            _semanticUiReact.Label,
            { size: 'mini', style: { marginLeft: '0.5em', backgroundColor: '#e6fff2', color: '#008040' } },
            data.origin.includes('_') ? t('Showroom Buyer') : t('Marketplace')
          ),
          data.buyerProfileID && data.buyerProfileID !== '' && _react2.default.createElement(
            _semanticUiReact.Label,
            { size: 'mini', style: { marginLeft: '0.5em', backgroundColor: '#F5F6F7', color: '#586976' } },
            t('Buyer')
          )
        ),
        _this10.hasBookingNote(data) && _react2.default.createElement(_semanticUiReact.Popup, {
          trigger: _react2.default.createElement(
            'div',
            { className: 'mobile-hide', style: { float: 'right', color: 'rgba(0,0,0,.5)' } },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'sticky note', color: 'grey' })
          ),
          content: _this10.bookingNoteFormated(data),
          size: 'mini',
          inverted: true
        })
      ) : null,
      currentTab === 'all' ? _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'mobile-hide' },
        _react2.default.createElement(
          _reactRouter.Link,
          { title: data.code, to: '/bookings/' + data.id + '/' },
          data.bookingCustomer && data.bookingCustomer.name
        )
      ) : null,
      _this10.props.projectUnitID && currentTab === 'aging_by_bankers' ? _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true },
        _react2.default.createElement(
          'span',
          { className: 'mobile-hide' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/bookings/' + data.id + '/' },
            data.code
          )
        ),
        _react2.default.createElement(
          'span',
          { className: 'computer-hide' },
          data.code
        )
      ) : null,
      currentTab !== 'aging_by_bankers' && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true },
        _react2.default.createElement(
          'span',
          { className: 'mobile-hide' },
          data.loanTrackerLeadID > 0 ? data.bankCaseCount > 0 ? _react2.default.createElement(_PopupButtonList2.default, {
            size: 'tiny',
            data: _this10.getBankCaseStatuses(data),
            buttonContent: _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark', color: 'green' }),
              _react2.default.createElement(
                'small',
                null,
                data.bankCaseCount + ' referred'
              )
            )
          }) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark', color: 'green' }),
            _react2.default.createElement(
              'small',
              null,
              data.bankCaseCount + ' referred'
            )
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'delete', color: 'red' }),
            _react2.default.createElement(
              'small',
              null,
              data.loanTrackerLeadDropID > 0 ? t('PIN required') : t('Not added')
            )
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        null,
        _react2.default.createElement(
          'span',
          { className: 'mobile-hide' },
          currentTab === 'aging_by_bankers' ? data.statusName : _react2.default.createElement(
            'span',
            null,
            isPendingCancellation ? t('Pending Cancellation', { ns: _translation.TRANSLATION_FILES.constants }) : data.bookingStatus ? t(data.bookingStatus.name, { ns: _translation.TRANSLATION_FILES.constants }) : '',
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'small',
              null,
              data.paymentStatus ? t(data.paymentStatus.name, { ns: _translation.TRANSLATION_FILES.constants }) : ''
            )
          )
        ),
        _react2.default.createElement(
          'span',
          { className: 'computer-hide' },
          _react2.default.createElement(
            'small',
            null,
            currentTab === 'aging_by_bankers' ? data.statusName : (isPendingCancellation ? t('Pending Cancellation', { ns: _translation.TRANSLATION_FILES.constants }) : data.bookingStatus ? t(data.bookingStatus.name, { ns: _translation.TRANSLATION_FILES.constants }) : '') + ' - ' + (data.paymentStatus ? data.paymentStatus.name : '')
          ),
          _this10.hasInternalDEAccess() && data.assignedMaPreferredName ? _react2.default.createElement(
            'small',
            { style: { float: 'right' } },
            _react2.default.createElement(
              'em',
              null,
              t('Assigned') + ': ' + data.assignedMaPreferredName
            )
          ) : null
        )
      ),
      currentTab === 'aging_by_bankers' && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true },
        _react2.default.createElement(
          'small',
          null,

          // show logo if banker is direct to bank and bank logo exist
          data.bankerDirectToBank && data.bankLogoSrc ? _react2.default.createElement(_semanticUiReact.Image, { src: data.bankLogoSrc, style: { maxHeight: '20px', display: 'inline-block' } }) : data.banker
        ),
        _react2.default.createElement(
          'small',
          { className: 'computer-hide', style: { float: 'right', marginRight: '0.5em' } },
          data.bankShortName
        )
      ),
      currentTab === 'aging_by_bankers' && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true },
        _react2.default.createElement(
          'span',
          { className: 'mobile-hide' },
          _react2.default.createElement(
            'small',
            null,
            data.bankShortName
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true },
        _react2.default.createElement(
          'span',
          { className: 'mobile-hide' },
          data.origin && data.origin.includes('marketplace') && _this10.hasMPDetailsAccess() ? data.origin.includes('_') ? _react2.default.createElement(
            _semanticUiReact.Popup,
            {
              on: 'click',
              trigger: _react2.default.createElement(
                'a',
                null,
                data.maCreatedByPreferredName
              ),
              size: 'mini',
              inverted: true,
              position: 'bottom right',
              disabled: true,
              flowing: true
            },
            data.bookingCustomer ? _react2.default.createElement(
              'span',
              { style: { fontSize: '15px' } },
              _react2.default.createElement(
                'div',
                null,
                t('Name') + ': ' + data.bookingCustomer.name
              ),
              data.bookingCustomer.email ? _react2.default.createElement(
                'div',
                null,
                t('Email') + ': ' + data.bookingCustomer.email
              ) : null,
              _react2.default.createElement(
                'div',
                null,
                t('Mobile') + ': ' + data.bookingCustomer.mobilePrefix + data.bookingCustomer.mobile
              )
            ) : null
          ) : _react2.default.createElement(
            _semanticUiReact.Popup,
            {
              on: 'click',
              trigger: _react2.default.createElement(
                'a',
                null,
                data.maCreatedByPreferredName
              ),
              onOpen: function onOpen() {
                _this10.fetchMarketplaceUserDetails(data.maUserID);
              },
              size: 'mini',
              inverted: true,
              position: 'bottom right',
              disabled: true,
              flowing: true
            },
            mpUserLoading ? _react2.default.createElement(
              _semanticUiReact.Loader,
              { active: true, inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            ) : _react2.default.createElement(
              'span',
              { style: { fontSize: '15px' } },
              _react2.default.createElement(
                'div',
                null,
                t('Name') + ': ' + mpUserDetails.fullName
              ),
              _react2.default.createElement(
                'div',
                null,
                t('Email') + ': ' + mpUserDetails.email
              ),
              _react2.default.createElement(
                'div',
                null,
                t('Mobile') + ': ' + mpUserDetails.mobilePrefix + mpUserDetails.mobile
              ),
              mpUserDetails.agencyName ? _react2.default.createElement(
                'div',
                null,
                t('Agency Name') + ': ' + mpUserDetails.agencyName
              ) : null,
              mpUserDetails.registrationNumber ? _react2.default.createElement(
                'div',
                null,
                t('Registration Number') + ': ' + mpUserDetails.registrationNumber
              ) : null
            )
          ) : _this10.hasStaffAccess() ? _react2.default.createElement(
            _reactRouter.Link,
            { to: '/users/' + (currentTab === 'aging_by_bankers' ? data.createdByID : data.maUserAffiliateID) + '/' },
            currentTab === 'aging_by_bankers' ? data.createdBy : data.maCreatedByPreferredName
          ) : currentTab === 'aging_by_bankers' ? data.createdBy : data.maCreatedByPreferredName,
          currentTab !== 'aging_by_bankers' ? _react2.default.createElement(
            'small',
            null,
            _react2.default.createElement('br', null),
            data.origin && data.origin.includes('marketplace_') ? t('Buyer') : data.maUserAffiliateCompanyBranchShortName
          ) : ''
        ),
        _react2.default.createElement(
          'span',
          { className: 'computer-hide' },
          _react2.default.createElement(
            'small',
            null,
            _react2.default.createElement(_Timestamp2.default, {
              timestamp: data.createdAt,
              format: 'DD/M/YYYY'
            }),
            _react2.default.createElement('br', null),
            _react2.default.createElement(_Timestamp2.default, {
              timestamp: data.createdAt,
              format: 'hh:mm a'
            })
          ),
          _this10.hasBookingNote(data) && currentTab === 'all' && _react2.default.createElement(_semanticUiReact.Popup, {
            trigger: _react2.default.createElement(
              'div',
              { className: 'computer-hide', style: { float: 'right', color: 'rgba(0,0,0,.5)' } },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'sticky note', color: 'grey' })
            ),
            content: _this10.bookingNoteFormated(data),
            size: 'mini',
            inverted: true
          }),
          currentTab !== 'all' ? _react2.default.createElement(_semanticUiReact.Header, {
            floated: 'right',
            color: _this10.getAgingColor(data.currentAge),
            content: data.currentAge
          }) : null
        )
      ),
      _this10.hasInternalDEAccess() ? _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true, textAlign: 'left' },
        _react2.default.createElement(
          'span',
          { className: 'mobile-hide' },
          data.assignedMaPreferredName ? data.assignedMaPreferredName : '-'
        )
      ) : null,
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true },
        _react2.default.createElement(
          'span',
          { className: 'mobile-hide' },
          _this10.isShowTerminationLetter(data) ? _react2.default.createElement(_semanticUiReact.Popup, {
            trigger: _react2.default.createElement(
              _reactRouter.Link,
              {
                as: 'a',
                className: 'ui compact icon primary button',
                to: _config2.default.get('bookApiURL') + '/bookings/' + data.id + '/print/termination/',
                target: '_blank',
                onClick: _this10.handlePrint
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'print' })
            ), content: t('Print Termination Letter')
          }) : null,
          _this10.isShowLoanReminderLetter(data) ? _react2.default.createElement(_semanticUiReact.Popup, {
            trigger: _react2.default.createElement(
              _reactRouter.Link,
              {
                as: 'a',
                className: 'ui compact icon primary button',
                to: _config2.default.get('bookApiURL') + '/bookings/' + data.id + '/print/loan_reminder/',
                target: '_blank',
                onClick: _this10.handlePrint
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'print' })
            ), content: t('Print Loan Reminder Letter')
          }) : null,
          _this10.isShowSpaReminderLetter(data) ? _react2.default.createElement(_semanticUiReact.Popup, {
            trigger: _react2.default.createElement(
              _reactRouter.Link,
              {
                as: 'a',
                className: 'ui compact icon primary button',
                to: _config2.default.get('bookApiURL') + '/bookings/' + data.id + '/print/spa_reminder/',
                target: '_blank',
                onClick: _this10.handlePrint
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'print' })
            ), content: t('Print SPA Reminder Letter')
          }) : null
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true },
        _react2.default.createElement(
          'span',
          { className: 'mobile-hide' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/bookings/' + data.id + '/' },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron right' })
          )
        )
      )
    );
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRouter.withRouter)((0, _reactRedux.connect)(BookingsList.mapStateToProps)(BookingsList)));

/***/ }),
/* 2109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(13);

var _i18next = __webpack_require__(94);

var _i18next2 = _interopRequireDefault(_i18next);

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _PictureItem = __webpack_require__(564);

var _PictureItem2 = _interopRequireDefault(_PictureItem);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _url = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BranchLogoList = function (_Component) {
  _inherits(BranchLogoList, _Component);

  function BranchLogoList(props) {
    _classCallCheck(this, BranchLogoList);

    var _this = _possibleConstructorReturn(this, (BranchLogoList.__proto__ || Object.getPrototypeOf(BranchLogoList)).call(this, props));

    _initialiseProps.call(_this);

    var state = BranchLogoList.getPropsToState(props);
    var view = props.view || 'list';
    _this.state = _extends({
      count: 0,
      limit: 0,
      offset: 0,
      data: [],
      view: view
    }, state);
    return _this;
  }

  _createClass(BranchLogoList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
        delete query.page;
      }
      this.replaceQuery(query);
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = BranchLogoList.getPropsToState(nextProps);
      if (nextProps.view) {
        if (this.state.view !== nextProps.view) {
          state.view = nextProps.view;
        }
      }
      this.setState(state);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setLogos',
    value: function setLogos() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this2.setState({
          data: data || []
        }, function () {
          res(data);
          if (_this2.props.onChange) {
            _this2.props.onChange(_this2.state.data);
          }
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchLogos',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var store, query, url, res, message, count, limit, offset, data, que;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = Object.assign(q, this.props.where || {});
                url = '/company_branches/logos/?' + _qs2.default.stringify(query);
                res = void 0;
                _context.prev = 6;
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchM)(url, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context.sent;
                _context.next = 20;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                Bugsnag.notifyException(_context.t0);
                _context.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 17:
                _context.next = 19;
                return this.setLoading(false);

              case 19:
                return _context.abrupt('return');

              case 20:
                if (res.ok) {
                  _context.next = 28;
                  break;
                }

                _context.next = 23;
                return res.text();

              case 23:
                message = _context.sent;
                _context.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context.next = 44;
                break;

              case 28:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context.next = 33;
                return res.json();

              case 33:
                data = _context.sent;
                _context.next = 36;
                return this.setLogos(data);

              case 36:
                if (!(this.state.data.length < 1 && query.page > 1)) {
                  _context.next = 42;
                  break;
                }

                que = (0, _url.decodeSearch)(this.props.location.search);

                que.page = 1;
                this.replaceQuery(que);
                _context.next = 44;
                break;

              case 42:
                _context.next = 44;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 44:
                _context.next = 46;
                return this.setLoading(false);

              case 46:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));

      function fetchLogos() {
        return _ref.apply(this, arguments);
      }

      return fetchLogos;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;
      var pathname = this.props.location.pathname;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      this.fetchLogos(queryNew);
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));
    }
  }, {
    key: 'handleRefetch',
    value: function handleRefetch() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      this.replaceQuery(query);
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this5 = this;

      if (this.state.view === 'list') {
        return this.state.data.length > 0 ? this.state.data.map(function (logo, key) {
          return _react2.default.createElement(
            _semanticUiReact.Table.Row,
            {
              key: key,
              disabled: _this5.handleOnCheck(logo),
              onClick: function onClick(e) {
                return _this5.handleOnClick(e, logo);
              }
            },
            !_this5.state.isMobile && _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              { width: 5 },
              _react2.default.createElement(_LoadImage2.default, {
                constrain: true,
                as: 'a',
                centered: true,
                size: 'tiny',
                picture: logo,
                pictureSize: 50,
                extension: 'png',
                onClick: function onClick(e) {
                  return _this5.handleViewLarge(e, logo);
                }
              })
            ),
            !_this5.state.isMobile && _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              { width: 5 },
              _this5.renderLabel(logo)
            ),
            _this5.state.isMobile ? _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 'equal' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 6 },
                  _react2.default.createElement(_LoadImage2.default, {
                    constrain: true,
                    as: 'a',
                    centered: true,
                    size: 'tiny',
                    picture: logo,
                    pictureSize: 50,
                    extension: 'png',
                    onClick: function onClick(e) {
                      return _this5.handleViewLarge(e, logo);
                    }
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { columns: 'equal' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 16 },
                        _this5.renderLabel(logo)
                      )
                    ),
                    _this5.props.buttonNode ? _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 16, textAlign: 'right' },
                        _this5.props.buttonNode({
                          loading: _this5.state.loading,
                          logo: logo,
                          view: _this5.state.view,
                          isMobile: _this5.state.isMobile
                        })
                      )
                    ) : null
                  )
                )
              )
            ) : null,
            !_this5.state.isMobile && _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              _this5.props.buttonNode ? _react2.default.createElement(
                'div',
                { className: 'picture-list-buttons' },
                _this5.props.buttonNode({
                  loading: _this5.state.loading,
                  logo: logo,
                  view: _this5.state.view,
                  isMobile: _this5.state.isMobile
                })
              ) : null
            )
          );
        }) : _react2.default.createElement(
          _semanticUiReact.Table.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { colSpan: this.state.isMobile ? null : 3, textAlign: 'center' },
            this.state.loading ? _react2.default.createElement(
              _semanticUiReact.Loader,
              { active: true, inline: 'centered' },
              _i18next2.default.t('Loading', { ns: 'translation' })
            ) : this.props.notFoundNode || _react2.default.createElement(
              'p',
              null,
              _i18next2.default.t('No logos found', { ns: 'screens' })
            )
          )
        );
      }
      return _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(
            _semanticUiReact.Card.Group,
            { itemsPerRow: this.state.data.length > 0 ? 4 : 1, doubling: true, stackable: true },
            this.state.data.length > 0 ? this.state.data.map(function (logo, key) {
              return _react2.default.createElement(_PictureItem2.default, {
                key: key,
                picture: logo,
                pictureSize: 50,
                onViewLarge: function onViewLarge(e) {
                  return _this5.handleViewLarge(e, logo);
                },
                onRemove: function onRemove(e) {
                  return _this5.handleOnRemove(e, logo);
                },
                extension: 'png',
                hideTags: true,
                fixedSize: true,
                buttonNode: _this5.props.buttonNode ? _this5.props.buttonNode({
                  loading: _this5.state.loading,
                  logo: logo,
                  view: _this5.state.view
                }) : null
              });
            }) : _react2.default.createElement(
              _semanticUiReact.Card,
              null,
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { textAlign: 'center', vertical: true },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  _i18next2.default.t('Loading', { ns: 'translation' })
                ) : this.props.notFoundNode || _react2.default.createElement(
                  'p',
                  null,
                  _i18next2.default.t('No logos found', { ns: 'screens' })
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          count = _state.count,
          limit = _state.limit,
          offset = _state.offset,
          data = _state.data,
          loading = _state.loading,
          currentPage = _state.currentPage,
          view = _state.view;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 20 },
            active: this.state.loading && this.state.data.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            _i18next2.default.t('Loading', { ns: 'translation' })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            fixed: view === 'card',
            striped: true, unstackable: true
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: this.state.isMobile ? null : 3 },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { columns: 1, verticalAlign: 'middle' },
                  this.props.toggleable && _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_semanticUiReact.Label, {
                      as: 'button',
                      attached: 'top left',
                      size: 'small',
                      icon: (view === 'list' ? 'block' : 'list') + ' layout',
                      content: view === 'list' ? _i18next2.default.t('Card', { ns: 'screens' }) : _i18next2.default.t('List', { ns: 'screens' }),
                      onClick: this.handleToggleView,
                      disabled: this.state.loading
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    this.props.headerNode ? this.props.headerNode({
                      count: count,
                      limit: limit,
                      offset: offset,
                      dataSize: data.length,
                      loading: loading,
                      currentPage: currentPage,
                      onChange: this.handleChangePage
                    }) : _react2.default.createElement(_SearchFilter2.default, {
                      inTable: true,
                      advanceFilter: this.state.advanceFilter,
                      isLoading: loading,
                      onChange: this.handleFilterOnChange,
                      onClose: this.handleClearFilter,
                      search: this.state.search,
                      setAdvanceFilter: this.handleSetAdvanceFilter,
                      leftNav: _react2.default.createElement(_PageNav2.default, {
                        currentPage: currentPage,
                        count: count,
                        limit: limit,
                        offset: offset,
                        dataSize: data.length,
                        loading: loading,
                        onChange: this.handleChangePage
                      }),
                      rightNav: this.props.searchRightNav
                    })
                  )
                )
              )
            ),
            view === 'list' && !this.state.isMobile && _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                _i18next2.default.t('Logo', { ns: 'screens' })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                _i18next2.default.t('Label', { ns: 'screens' })
              ),
              _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null)
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            this.renderBody()
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Footer,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: this.state.isMobile ? null : 3 },
                this.props.footerNode ? this.props.footerNode({
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: data.length,
                  loading: loading,
                  currentPage: currentPage,
                  onChange: this.handleChangePage
                }) : _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { columns: 'equal', verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_PageNav2.default, {
                      upward: true,
                      currentPage: currentPage,
                      count: count,
                      limit: limit,
                      offset: offset,
                      dataSize: data.length,
                      loading: loading,
                      onChange: this.handleChangePage
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return BranchLogoList;
}(_react.Component);

BranchLogoList.propTypes = {
  notFoundNode: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onCheck: _propTypes2.default.func,
  onViewLarge: _propTypes2.default.func,
  onRemove: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  headerNode: _propTypes2.default.func,
  footerNode: _propTypes2.default.func,
  buttonNode: _propTypes2.default.func,
  where: _propTypes2.default.shape({}),
  toggleable: _propTypes2.default.bool,
  view: _propTypes2.default.oneOf(['list', 'card']),
  searchRightNav: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  })
};
BranchLogoList.contextTypes = {
  store: _propTypes2.default.object
};

BranchLogoList.getPropsToState = function (props) {
  var advanceFilter = false;
  var isMobile = window.innerWidth < 768;
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var types = query.types || [];
  if (types && types.length > 0) {
    advanceFilter = true;
  }
  return {
    advanceFilter: advanceFilter,
    isMobile: isMobile,
    currentPage: currentPage,
    search: search,
    types: types
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.handleResize = function () {
    var isMobile = window.innerWidth < 768;
    if (isMobile !== _this6.state.isMobile) {
      _this6.setState({ isMobile: isMobile });
    }
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.page = currentPage;
    _this6.setState({
      currentPage: currentPage
    });
    _this6.replaceQuery(query);
  };

  this.handleOnClick = function (e, logo) {
    if (_this6.props.onClick) {
      _this6.props.onClick(e, logo);
    }
  };

  this.handleToggleView = function (e) {
    e.preventDefault();
    var view = _this6.state.view === 'list' ? 'card' : 'list';
    _this6.setState({ view: view });
  };

  this.handleOnCheck = function (logo) {
    if (_this6.props.onCheck) {
      return _this6.props.onCheck({ logo: logo });
    }
    return false;
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    _this6.setState({
      search: ''
    }, function () {
      if (hasQuery) {
        _this6.replaceQuery(query, true);
      }
    });
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query[queryName] = value;
    _this6.replaceQuery(query, true);
  };

  this.handleSetAdvanceFilter = function (advanceFilter) {
    _this6.setState({
      advanceFilter: advanceFilter
    });
  };

  this.handleViewLarge = function (e, logo) {
    if (_this6.props.onViewLarge) {
      _this6.props.onViewLarge(e, logo);
    }
  };

  this.handleOnRemove = function (e, logo) {
    if (_this6.props.onRemove) {
      _this6.props.onRemove(e, logo);
    }
  };

  this.renderLabel = function (logo) {
    if (logo.label && logo.label.trim().length > 0) {
      return logo.label;
    }
    if (_this6.state.isMobile) {
      return _react2.default.createElement(
        'span',
        { className: 'grey-text' },
        'No label set'
      );
    }
    return '-';
  };
};

exports.default = (0, _reactRouter.withRouter)(BranchLogoList, { withRef: true });

/***/ }),
/* 2110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _Phone = __webpack_require__(126);

var _Phone2 = _interopRequireDefault(_Phone);

var _NotificationIcon = __webpack_require__(1008);

var _NotificationIcon2 = _interopRequireDefault(_NotificationIcon);

var _bankCaseStatuses = __webpack_require__(264);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BuyerBankerCard = function (_Component) {
  _inherits(BuyerBankerCard, _Component);

  function BuyerBankerCard() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BuyerBankerCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BuyerBankerCard.__proto__ || Object.getPrototypeOf(BuyerBankerCard)).call.apply(_ref, [this].concat(args))), _this), _this.getStatusColor = function (status) {
      switch (status) {
        case 'pending_unreachable':
        case 'pending_docs':
        case 'pending_docs_submitted':
        case 'pending_reappealed':
          return 'status-pending';

        case 'new':
          return 'status-new';

        case 'approved_lo_issued':
          return 'status-approved';

        case 'reject_wrong_info':
        case 'reject_bank':
        case 'reject_developer':
        case 'reject_cancelled':
        case 'reject_customer':
        case 'reject_unqualified':
        case 'reject_lo_signed_other_bank':
          return 'status-reject';

        case 'success_li_issued':
          return 'status-success';

        default:
          return 'status-default';
      }
    }, _this.getOptions = function () {
      var _this$props = _this.props,
          data = _this$props.data,
          bankCaseStates = _this$props.bankCaseStates;
      var bankCase = data.bankCase;

      if (bankCaseStates) {
        return bankCaseStates.data.filter(function (s) {
          return s.state === bankCase.previousStatus || s.state === bankCase.status || s.state === 'reject_developer';
        }).map(function (s, key) {
          return {
            key: key,
            text: s.shortName,
            value: s.state,
            name: s.state,
            disabled: s.state !== bankCase.previousStatus && s.state !== 'reject_developer'
          };
        });
      }
      return [];
    }, _this.handleOnChange = function (e, _ref2) {
      var value = _ref2.value;
      var _this$props2 = _this.props,
          data = _this$props2.data,
          onChangeStatus = _this$props2.onChangeStatus;

      if (onChangeStatus) {
        onChangeStatus(e, data.bankCase, value);
      }
    }, _this.handleOnMessage = function (e) {
      var _this$props3 = _this.props,
          data = _this$props3.data,
          onMessage = _this$props3.onMessage;

      if (onMessage) {
        onMessage(e, data);
      }
    }, _this.handleOnNudge = function (e) {
      var _this$props4 = _this.props,
          data = _this$props4.data,
          onNudge = _this$props4.onNudge;

      if (onNudge) {
        onNudge(e, data.bankCase);
      }
    }, _this.renderButtons = function () {
      var _this$props5 = _this.props,
          data = _this$props5.data,
          disabled = _this$props5.disabled,
          isSold = _this$props5.isSold,
          onMessage = _this$props5.onMessage,
          onNudge = _this$props5.onNudge;
      var bankCase = data.bankCase;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { className: 'actions' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { textAlign: 'center' },
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              as: 'a',
              icon: true,
              circular: true,
              size: 'small',
              color: 'blue',
              href: 'tel:+' + bankCase.banker.mobilePrefix + bankCase.banker.mobile
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'phone', size: 'big' }),
            _react2.default.createElement(
              'span',
              null,
              'Call'
            )
          )
        ),
        onMessage ? _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { textAlign: 'center' },
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              icon: true,
              circular: true,
              size: 'small',
              color: 'blue',
              onClick: _this.handleOnMessage,
              disabled: disabled
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'comments', size: 'big' }),
            _react2.default.createElement(
              'span',
              null,
              'Message'
            )
          )
        ) : null,
        onNudge ? _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { textAlign: 'center' },
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              icon: true,
              circular: true,
              size: 'small',
              color: 'blue',
              onClick: _this.handleOnNudge,
              disabled: disabled || isSold || bankCase.status.startsWith('success') || bankCase.status.startsWith('reject') || (0, _momentTimezone2.default)().isBefore(bankCase.nudgeAt)
            },
            _react2.default.createElement(_NotificationIcon2.default, { status: 'nudge' }),
            _react2.default.createElement(
              'span',
              null,
              'Nudge'
            )
          )
        ) : null
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BuyerBankerCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          isSold = _props.isSold,
          disabled = _props.disabled,
          onChangeStatus = _props.onChangeStatus;
      var bankCase = data.bankCase;

      var isReject = _bankCaseStatuses.REJECTED_STATUSES.some(function (s) {
        return s === bankCase.status;
      });
      var statusColor = this.getStatusColor(bankCase.status);
      return _react2.default.createElement(
        'div',
        { className: 'buyer-banker-card ' + (isReject ? 'cancelled' : '') },
        _react2.default.createElement(
          _semanticUiReact.Header,
          { as: 'h4' },
          bankCase.banker.name
        ),
        _react2.default.createElement(_Phone2.default, {
          mobilePrefix: bankCase.banker.mobilePrefix,
          mobile: bankCase.banker.mobile
        }),
        !isReject ? this.renderButtons() : null,
        _react2.default.createElement(_semanticUiReact.Dropdown, {
          selectOnBlur: false,
          fluid: true,
          floating: true,
          scrolling: true,
          className: 'icon ' + statusColor,
          selection: true,
          onChange: this.handleOnChange,
          options: this.getOptions(),
          value: bankCase.status,
          disabled: disabled || isSold || isReject || !onChangeStatus
        })
      );
    }
  }]);

  return BuyerBankerCard;
}(_react.Component);

BuyerBankerCard.propTypes = {
  data: _propTypes2.default.shape({
    bankCase: _propTypes2.default.object
  }),
  bankCaseStates: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  isSold: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool,
  onChangeStatus: _propTypes2.default.func,
  onMessage: _propTypes2.default.func,
  onNudge: _propTypes2.default.func
};
BuyerBankerCard.defaultProps = {
  disabled: false
};

BuyerBankerCard.mapStateToProps = function (state) {
  return {
    bankCaseStates: state.bankCaseStates
  };
};

exports.default = (0, _reactRedux.connect)(BuyerBankerCard.mapStateToProps)(BuyerBankerCard);

/***/ }),
/* 2111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _buyerCommitments = __webpack_require__(2218);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BuyerCheckResult = function (_Component) {
  _inherits(BuyerCheckResult, _Component);

  function BuyerCheckResult(props) {
    _classCallCheck(this, BuyerCheckResult);

    var _this = _possibleConstructorReturn(this, (BuyerCheckResult.__proto__ || Object.getPrototypeOf(BuyerCheckResult)).call(this, props));

    _this.getCreditHistory = function (brickScore) {
      switch (brickScore) {
        case 5:
          return 'Excellent';
        case 4:
          return 'Good';
        case 3:
          return 'Average';
        case 2:
          return 'Below Average';
        case 1:
          return 'Poor';
        default:
          return '-';
      }
    };

    _this.handleToggleCommitment = function () {
      var showCommitment = _this.state.showCommitment;

      _this.setState({ showCommitment: !showCommitment });
    };

    _this.isEligible = function () {
      var data = _this.props.data;
      var loanEligibleRanges = data.loan_eligible_ranges,
          mhubCheck = data._mhub_check;

      if (loanEligibleRanges && mhubCheck) {
        var loanAmount = loanEligibleRanges.loan_amount;
        var brickScore = mhubCheck.brick_score;

        if (loanAmount > 0 && brickScore > 1) {
          return true;
        }
      }
      return false;
    };

    _this.renderEligibleLoanAmount = function () {
      var _this$props = _this.props,
          data = _this$props.data,
          projectCurrencies = _this$props.projectCurrencies;
      var loanEligibleRanges = data.loan_eligible_ranges;

      var isEligible = _this.isEligible();
      if (!isEligible) {
        return _react2.default.createElement(
          _semanticUiReact.Segment,
          { className: 'eligible-loan-amount not-eligible' },
          _react2.default.createElement(
            'p',
            null,
            'Eligible Loan Amount'
          ),
          _react2.default.createElement(
            _semanticUiReact.Header,
            { as: 'h2' },
            'Not Eligible'
          )
        );
      }
      return _react2.default.createElement(
        _semanticUiReact.Segment,
        { className: 'eligible-loan-amount' },
        _react2.default.createElement(
          'p',
          null,
          'Eligible Loan Amount'
        ),
        _react2.default.createElement(
          _semanticUiReact.Header,
          { as: 'h2' },
          _react2.default.createElement(_LoanAmount2.default, {
            projectCurrencies: projectCurrencies,
            format: '0,000,000',
            amount: loanEligibleRanges ? (loanEligibleRanges.min_loan_amount || 0) / 100 : 0,
            prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
          }),
          '\xA0-\xA0',
          _react2.default.createElement(_LoanAmount2.default, {
            projectCurrencies: projectCurrencies,
            format: '0,000,000',
            amount: loanEligibleRanges ? (loanEligibleRanges.max_loan_amount || 0) / 100 : 0,
            prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
          })
        )
      );
    };

    _this.renderCommitmentList = function (title, selector) {
      var _this$props2 = _this.props,
          projectCurrencies = _this$props2.projectCurrencies,
          data = _this$props2.data;
      var ccris = data._ccris;

      var amount = 0;
      if (selector != null) {
        var list = ccris.commitments.filter(selector);
        if (list && list.length > 0) {
          amount = list.reduce(function (a, c) {
            var installmentAmount = c.installment_amount,
                commitmentMonthly = c.commitment_monthly;

            var installment = installmentAmount || 0;
            var monthly = commitmentMonthly || 0;
            var monthlyRepayment = installment > 0 ? installment : monthly;
            return a + monthlyRepayment;
          }, 0);
        }
      }
      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { key: title },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          title
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { textAlign: 'right' },
          _react2.default.createElement(_LoanAmount2.default, {
            projectCurrencies: projectCurrencies,
            amount: amount ? amount || 0 : 0,
            format: '0,000,000'
          })
        )
      );
    };

    _this.renderCommitmentDetails = function () {
      var showCommitment = _this.state.showCommitment;
      var _this$props3 = _this.props,
          projectCurrencies = _this$props3.projectCurrencies,
          data = _this$props3.data;
      var ccris = data._ccris;

      if (ccris) {
        return _react2.default.createElement(
          _semanticUiReact.Accordion,
          null,
          _react2.default.createElement(
            _semanticUiReact.Accordion.Title,
            {
              as: _semanticUiReact.Button,
              basic: true,
              compact: true,
              index: 0,
              className: 'show-commitment',
              active: showCommitment,
              onClick: _this.handleToggleCommitment
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: showCommitment ? 'chevron up' : 'chevron down' }),
            showCommitment ? 'Hide' : 'Show',
            ' Monthly Commitment'
          ),
          _react2.default.createElement(
            _semanticUiReact.Accordion.Content,
            { active: showCommitment },
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { className: 'commitment', verticalAlign: 'middle' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { className: 'header' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  'Details'
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'right' },
                  'RM'
                )
              ),
              _this.renderCommitmentList('Car Loan', _buyerCommitments.isCommitmentVehicle),
              _this.renderCommitmentList('Home Loan', _buyerCommitments.isCommitmentHouse),
              _this.renderCommitmentList('Student Loan', function (c) {
                return c.is_ptptn;
              }),
              _this.renderCommitmentList('Credit Card', _buyerCommitments.isCommitmentCreditCard),
              _this.renderCommitmentList('Personal Loan', _buyerCommitments.isCommitmentPersonal),
              _this.renderCommitmentList('Others', _buyerCommitments.isCommitmentOther),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { className: 'total-amount' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  'Total'
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'right' },
                  _react2.default.createElement(_LoanAmount2.default, {
                    projectCurrencies: projectCurrencies,
                    amount: ccris ? (ccris.total_commitment || 0) / 100 : 0,
                    format: '0,000,000'
                  })
                )
              )
            )
          )
        );
      }
      return null;
    };

    _this.state = {
      showCommitment: false
    };
    return _this;
  }

  _createClass(BuyerCheckResult, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isMobile = _props.isMobile,
          projectCurrencies = _props.projectCurrencies,
          data = _props.data;
      var ccris = data._ccris,
          incomeNet = data.income_net,
          dsrScore = data.dsr_score,
          mhubCheck = data._mhub_check;
      var brickScore = mhubCheck.brick_score,
          bankruptcy = mhubCheck.bankruptcy;

      return _react2.default.createElement(
        'div',
        { className: 'buyer-check-result' },
        _react2.default.createElement(
          _semanticUiReact.Segment.Group,
          {
            className: 'dashboard',
            horizontal: !isMobile
          },
          this.renderEligibleLoanAmount(),
          _react2.default.createElement(
            _semanticUiReact.Segment,
            null,
            _react2.default.createElement(
              'p',
              null,
              'DSR'
            ),
            _react2.default.createElement(
              _semanticUiReact.Header,
              { as: 'h2' },
              dsrScore ? dsrScore + '%' : '-'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Segment,
            null,
            _react2.default.createElement(
              'p',
              null,
              'MHub Brick Score'
            ),
            _react2.default.createElement(
              _semanticUiReact.Header,
              { as: 'h2' },
              this.getCreditHistory(brickScore)
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { className: 'details', columns: 2, verticalAlign: 'bottom' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              'Bankruptcy Status:'
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              bankruptcy ? 'Yes' : 'No'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              'Nett Income:'
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              _react2.default.createElement(_LoanAmount2.default, {
                projectCurrencies: projectCurrencies,
                amount: (parseInt(incomeNet, 10) || 0) / 100,
                format: '0,000,000',
                prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              'Monthly Commitment:'
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              _react2.default.createElement(_LoanAmount2.default, {
                projectCurrencies: projectCurrencies,
                amount: ccris ? (ccris.total_commitment || 0) / 100 : 0,
                format: '0,000,000',
                prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
              })
            )
          )
        ),
        this.renderCommitmentDetails()
      );
    }
  }]);

  return BuyerCheckResult;
}(_react.Component);

BuyerCheckResult.propTypes = {
  data: _propTypes2.default.shape({
    _ccris: _propTypes2.default.object,
    _mhub_check: _propTypes2.default.object,
    loan_eligible_ranges: _propTypes2.default.object,
    income_net: _propTypes2.default.string,
    dsr_score: _propTypes2.default.number
  }),
  isMobile: _propTypes2.default.bool,
  projectCurrencies: _propTypes2.default.arrayOf(_propTypes2.default.object)
};
exports.default = BuyerCheckResult;

/***/ }),
/* 2112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _BuyerBankerCard = __webpack_require__(2110);

var _BuyerBankerCard2 = _interopRequireDefault(_BuyerBankerCard);

var _bankCaseStatuses = __webpack_require__(264);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BuyerLoanCard = function (_Component) {
  _inherits(BuyerLoanCard, _Component);

  function BuyerLoanCard(props) {
    _classCallCheck(this, BuyerLoanCard);

    var _this = _possibleConstructorReturn(this, (BuyerLoanCard.__proto__ || Object.getPrototypeOf(BuyerLoanCard)).call(this, props));

    _initialiseProps.call(_this);

    var state = BuyerLoanCard.getPropsToState(props);
    _this.state = _extends({}, state, {
      showHistory: false
    });
    return _this;
  }

  _createClass(BuyerLoanCard, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = BuyerLoanCard.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          projectCurrencies = _props.projectCurrencies,
          onUpdateStatus = _props.onUpdateStatus,
          onMessage = _props.onMessage,
          onNudge = _props.onNudge,
          isSold = _props.isSold,
          disabled = _props.disabled;
      var _state = this.state,
          data = _state.data,
          isActive = _state.isActive,
          cancelledLoans = _state.cancelledLoans,
          showHistory = _state.showHistory;

      return _react2.default.createElement(
        _semanticUiReact.Segment.Group,
        { className: 'buyer-loan-card' },
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { className: 'headers', title: data && data.loan ? data.loan.name : '' },
          data && data.loan ? _react2.default.createElement(
            'div',
            { className: 'row' },
            data.loan.imgs_thumb ? _react2.default.createElement(_LoadImage2.default, {
              shape: 'circular',
              src: data.loan.imgs_thumb.x010
            }) : null,
            _react2.default.createElement(
              'span',
              null,
              data.loan.name
            )
          ) : null
        ),
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { className: 'details' },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            data && !data.is_sr ? _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { verticalAlign: 'bottom' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                'Monthly Repayment:'
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right' },
                _react2.default.createElement(_LoanAmount2.default, {
                  projectCurrencies: projectCurrencies,
                  amount: (this.calculateMonthlyPayment(data.loan_amount, data.loan_rate_points, data.loan_years) || 0) / 100,
                  format: '0,000,000.00',
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                })
              )
            ) : null,
            data && !data.is_sr ? _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { verticalAlign: 'bottom' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                'Interest Rate:'
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right' },
                data.loan_rate_points ? data.loan_rate_points / 1000 + ' % P.A.' : '-'
              )
            ) : null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { verticalAlign: 'bottom' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                'Borrowing:'
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right' },
                _react2.default.createElement(_LoanAmount2.default, {
                  projectCurrencies: projectCurrencies,
                  amount: data ? (data.loan_amount || 0) / 100 : 0,
                  format: '0,000,000',
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                })
              )
            ),
            data && !data.is_sr && data.loan_years ? _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'years' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 16, textAlign: 'right' },
                'Over ',
                data.loan_years,
                ' years'
              )
            ) : null
          ),
          !isSold && !isActive ? _react2.default.createElement(_semanticUiReact.Button, {
            className: 'assign',
            fluid: true,
            color: 'blue',
            onClick: this.handleOnAssign,
            content: 'Assign Banker',
            disabled: disabled || isSold
          }) : null,
          !isActive && cancelledLoans.length > 0 ? this.renderHistoryButton() : null
        ),
        isActive && data && data.bankCase ? _react2.default.createElement(
          _semanticUiReact.Segment,
          null,
          _react2.default.createElement(_BuyerBankerCard2.default, {
            data: data,
            onChangeStatus: onUpdateStatus,
            onMessage: onMessage,
            onNudge: onNudge,
            isSold: isSold,
            disabled: disabled
          }),
          cancelledLoans.length > 0 ? this.renderHistoryButton() : null
        ) : null,
        showHistory && cancelledLoans.length > 0 ? cancelledLoans.map(function (l, i) {
          return _react2.default.createElement(
            _semanticUiReact.Segment,
            { key: i },
            _react2.default.createElement(_BuyerBankerCard2.default, {
              data: l,
              disabled: true
            })
          );
        }) : null
      );
    }
  }]);

  return BuyerLoanCard;
}(_react.Component);

BuyerLoanCard.propTypes = {
  loans: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    loan: _propTypes2.default.object,
    loan_rate_points: _propTypes2.default.number,
    loan_amount: _propTypes2.default.number,
    loan_years: _propTypes2.default.number,
    imgs_thumb: _propTypes2.default.object
  })),
  bankCases: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  onAssign: _propTypes2.default.func,
  onMessage: _propTypes2.default.func,
  onNudge: _propTypes2.default.func,
  onUpdateStatus: _propTypes2.default.func,
  projectCurrencies: _propTypes2.default.arrayOf(_propTypes2.default.object),
  isSold: _propTypes2.default.bool,
  disabled: _propTypes2.default.bool
};
BuyerLoanCard.defaultProps = {
  loans: [],
  bankCases: [],
  isSold: false,
  disabled: false
};

BuyerLoanCard.getPropsToState = function (props) {
  var loans = props.loans,
      bankCases = props.bankCases;

  var data = loans.find(function (l) {
    return !_bankCaseStatuses.REJECTED_STATUSES.some(function (s) {
      return s === l.status;
    });
  });
  if (!data) {
    data = loans[0];
  }
  var isActive = data && data.status ? !_bankCaseStatuses.REJECTED_STATUSES.some(function (s) {
    return s === data.status;
  }) && data.case_id > 0 && data.case_id !== '' : false;
  var cancelledLoans = loans.reduce(function (result, la) {
    var app = la;
    if (la.case_id > 0) {
      var bankCase = bankCases.find(function (bc) {
        return bc.id === la.case_id;
      });
      if (bankCase) {
        app.bankCase = bankCase;
      }
    }
    if (app.id !== data.id) {
      result.push(app);
    } else if (!isActive && app.case_id > 0) {
      result.push(app);
    }
    return result;
  }, []);
  if (isActive) {
    var bankCase = bankCases.find(function (bc) {
      return bc.id === data.case_id;
    });
    if (bankCase) {
      data.bankCase = bankCase;
    }
  }
  return {
    isActive: isActive,
    data: data,
    cancelledLoans: cancelledLoans
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleOnAssign = function (e) {
    var onAssign = _this2.props.onAssign;
    var data = _this2.state.data;

    if (onAssign) {
      onAssign(e, data);
    }
  };

  this.handleToggleHistory = function () {
    var showHistory = _this2.state.showHistory;

    _this2.setState({ showHistory: !showHistory });
  };

  this.calculateMonthlyPayment = function (loanCents, interest, years) {
    var multiplier = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1000;

    var months = years * 12;
    if (interest === 0) {
      return loanCents / months;
    }
    var rate = interest / multiplier / 100 / 12;
    var x = Math.pow(1 + rate, months);
    return parseInt(rate / (x - 1) * loanCents * x, 10);
  };

  this.renderHistoryButton = function () {
    var disabled = _this2.props.disabled;
    var showHistory = _this2.state.showHistory;

    return _react2.default.createElement(
      _semanticUiReact.Button,
      {
        as: _semanticUiReact.Button,
        basic: true,
        compact: true,
        className: 'show-history',
        onClick: _this2.handleToggleHistory,
        disabled: disabled
      },
      _react2.default.createElement(_semanticUiReact.Icon, { name: showHistory ? 'chevron up' : 'chevron down' }),
      showHistory ? 'Hide' : 'View',
      ' History'
    );
  };
};

exports.default = BuyerLoanCard;

/***/ }),
/* 2113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _ctos = __webpack_require__(3516);

var _ctos2 = _interopRequireDefault(_ctos);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _CreditCheckInfoModal = __webpack_require__(2118);

var _CreditCheckInfoModal2 = _interopRequireDefault(_CreditCheckInfoModal);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var CTOSResult = function (_Component) {
  _inherits(CTOSResult, _Component);

  function CTOSResult(props) {
    _classCallCheck(this, CTOSResult);

    var _this = _possibleConstructorReturn(this, (CTOSResult.__proto__ || Object.getPrototypeOf(CTOSResult)).call(this, props));

    _this.ctosScore = [{ color: 'rgba(206, 0, 0, 1)', name: 'Very Weak', value: '300-528' }, { color: 'rgba(247, 148, 30, 1)', name: 'Weak', value: '529-650' }, { color: 'rgba(242, 227, 0, 1)', name: 'Below Average', value: '651-696' }, { color: 'rgba(216, 218, 23, 1)', name: 'Above Average', value: '697-717' }, { color: 'rgba(166, 206, 57, 1)', name: 'Good', value: '718-743' }, { color: 'rgba(0, 152, 74, 1)', name: 'Excellent', value: '744-850' }];

    _this.handleOpenHTML = function (e, customerData) {
      e.preventDefault();
      var url = _config2.default.get('bookApiURL') + '/customers/' + _this.props.customerDataID + '/credit_reports/' + customerData.customer.customerCreditReport.id + '/response/' + customerData.customer.customerCreditReport.mCtosHTMLRequestID + '/';
      window.open(url, 'credit-report-' + customerData.customer.customerCreditReport.mCtosHTMLRequestID, '');
    };

    _this.showCTOSInfo = function () {
      _this.setState({ openCTOSModal: true, openDSRModal: false });
    };

    _this.showDSRInfo = function () {
      _this.setState({ openDSRModal: true, openCTOSModal: false });
    };

    _this.state = {
      companyApp: [],
      ctosColor: '',
      ctosColorShadow: '',
      ctosStatus: '',
      loading: false,
      openCTOSModal: false,
      openDSRModal: false
    };
    return _this;
  }

  _createClass(CTOSResult, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getCtosInfo();
      if (this.props.auth && (this.props.auth.isBranchLeader || this.props.auth.isDeveloperStaff || this.props.auth.isExternalAgencyAdmin || this.props.auth.isExternalAgent || this.props.auth.isExternalAgentLeader)) {
        this.fetchCompanyApp();
      }
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'getCtosInfo',
    value: function getCtosInfo() {
      var customerData = this.props.customerData;

      var ctosScore = _lodash2.default.toNumber(customerData.customer.customerCreditReport.ctosScore);

      switch (ctosScore !== 0) {
        case ctosScore > 0 && ctosScore < 300:
          this.setState({ ctosColor: 'rgba(206, 0, 0, 1)', ctosColorShadow: 'rgba(206, 0, 0, 0.53)', ctosStatus: 'No Score' });
          break;
        case ctosScore > 299 && ctosScore < 529:
          this.setState({ ctosColor: 'rgba(206, 0, 0, 1)', ctosColorShadow: 'rgba(206, 0, 0, 0.53)', ctosStatus: 'Very Weak' });
          break;
        case ctosScore > 528 && ctosScore < 651:
          this.setState({ ctosColor: 'rgba(247, 148, 30, 1)', ctosColorShadow: 'rgba(247, 148, 30, 0.53)', ctosStatus: 'Weak' });
          break;
        case ctosScore > 650 && ctosScore < 697:
          this.setState({ ctosColor: 'rgba(242, 227, 0, 1)', ctosColorShadow: 'rgba(242, 227, 0, 0.53)', ctosStatus: 'Below Average' });
          break;
        case ctosScore > 696 && ctosScore < 718:
          this.setState({ ctosColor: 'rgba(216, 218, 23, 1)', ctosColorShadow: 'rgba(216, 218, 23, 0.53)', ctosStatus: 'Above Average' });
          break;
        case ctosScore > 717 && ctosScore < 744:
          this.setState({ ctosColor: 'rgba(166, 206, 57, 1)', ctosColorShadow: 'rgba(166, 206, 57, 0.53)', ctosStatus: 'Good' });
          break;
        case ctosScore > 743:
          this.setState({ ctosColor: 'rgba(0, 152, 74, 1)', ctosColorShadow: 'rgba(0, 152, 74, 0.53)', ctosStatus: 'Excellent' });
          break;
        default:
          break;
      }
    }
  }, {
    key: 'getLoanAmount',
    value: function getLoanAmount() {
      var customerData = this.props.customerData;

      var dsrBaseRate = 4.45 / 100;
      var dsrBaseRatePerMonth = dsrBaseRate / 12;

      // get birth year of purchaser
      var ICNumber = customerData.customer.identity;
      var firstICDigit = ICNumber.substring(0, 1);
      var firstTwoICDigits = ICNumber.substring(0, 2);
      var bornYear = 0;
      if (firstICDigit === '0') {
        var str1 = '20';
        bornYear = _lodash2.default.toNumber(str1.concat(firstTwoICDigits));
      } else {
        var _str = '19';
        bornYear = _lodash2.default.toNumber(_str.concat(firstTwoICDigits));
      }

      // get current year
      var d = (0, _momentTimezone2.default)().toDate();
      var currentYear = _lodash2.default.toNumber(d.getFullYear());

      // get age of purchaser
      var purchaserAge = _lodash2.default.toNumber(currentYear) - _lodash2.default.toNumber(bornYear);

      // get loan tenure based on age
      var tenure = 35;
      if (_lodash2.default.toNumber(purchaserAge) + _lodash2.default.toNumber(tenure) > 70) {
        tenure = 70 - purchaserAge;
        if (tenure <= 0) {
          tenure = 0;
        }
      }

      var prevMonthlyCommitment = 0;

      if (customerData.customer.customerCreditReport.dsr !== 0) {
        // get user commitment before loan
        var dsrBefore = _lodash2.default.toNumber(customerData.customer.customerCreditReport.dsr) / 100;
        prevMonthlyCommitment = _lodash2.default.toNumber(customerData.customer.customerCreditReport.incomeNet) * _lodash2.default.toNumber(dsrBefore);
      }

      // get user max affordable commitment
      var maxDsr = 0.6;
      var maxMonthlyCommitment = _lodash2.default.toNumber(customerData.customer.customerCreditReport.incomeNet) * maxDsr;
      var affordableMonthlyCommitment = _lodash2.default.toNumber(maxMonthlyCommitment) - _lodash2.default.toNumber(prevMonthlyCommitment);

      // calculate max loan amount
      var pv = _lodash2.default.toNumber(affordableMonthlyCommitment) / _lodash2.default.toNumber(dsrBaseRatePerMonth);
      var n = -(_lodash2.default.toNumber(tenure) * 12);
      var rate = 1 + _lodash2.default.toNumber(dsrBaseRatePerMonth);
      var pRate = Math.pow(_lodash2.default.toNumber(rate), _lodash2.default.toNumber(n));
      var subPRate = 1 - _lodash2.default.toNumber(pRate);
      return _lodash2.default.toNumber(pv) * _lodash2.default.toNumber(subPRate);
    }
  }, {
    key: 'fetchCompanyApp',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, _message, companyApp;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                _context.next = 3;
                return this.setLoading(true);

              case 3:
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/company/company_app/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 22;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);
                _context.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 17;
                return _context.t0.res.text();

              case 17:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 20:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 22:
                if (res.ok) {
                  _context.next = 30;
                  break;
                }

                _context.next = 25;
                return res.text();

              case 25:
                _message = _context.sent;
                _context.next = 28;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 28:
                _context.next = 34;
                break;

              case 30:
                _context.next = 32;
                return res.json();

              case 32:
                companyApp = _context.sent;

                if (companyApp !== null) {
                  this.setState({ companyApp: companyApp });
                }

              case 34:
                _context.next = 36;
                return this.setLoading(false);

              case 36:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchCompanyApp() {
        return _ref.apply(this, arguments);
      }

      return fetchCompanyApp;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var store = this.context.store;
      var _props = this.props,
          auth = _props.auth,
          customerData = _props.customerData,
          data = _props.data;
      var _state = this.state,
          companyApp = _state.companyApp,
          ctosColor = _state.ctosColor,
          ctosColorShadow = _state.ctosColorShadow,
          ctosStatus = _state.ctosStatus;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { centered: true, stackable: true },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 7, tablet: 8, mobile: 8 },
            _react2.default.createElement(
              _semanticUiReact.Container,
              {
                style: {
                  borderRadius: '0.25rem',
                  boxShadow: customerData.customer.customerCreditReport.mCtosXMLStatusID !== 'dsr_generated' ? '1px 1px 1px 2px rgba(0, 0, 0, 0.16)' : '0px 1px 0px 1px rgba(0, 0, 0, 0.16)',
                  height: customerData.customer.customerCreditReport.mCtosXMLStatusID !== 'dsr_generated' ? '20rem' : '36rem'
                }
              },
              customerData.customer.customerCreditReport.mCtosXMLStatusID !== 'dsr_generated' ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  { as: 'h2', style: { fontSize: '12px', color: 'black', paddingTop: '2rem' } },
                  _react2.default.createElement(
                    'div',
                    { className: 'ctosDsrHeader' },
                    'CTOS ',
                    _react2.default.createElement(
                      _semanticUiReact.Button,
                      { onClick: this.showCTOSInfo },
                      _react2.default.createElement(
                        'p',
                        { style: { padding: '0 0.5rem', display: 'inline', border: '1px solid', borderRadius: '50%' } },
                        'i'
                      )
                    )
                  )
                ),
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'clock', style: { color: 'orange', marginTop: '4rem', fontSize: '5rem', height: '4rem !important' } }),
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  { as: 'h4', style: { marginTop: '0' } },
                  _react2.default.createElement(
                    _semanticUiReact.Header.Content,
                    { style: { color: 'orange' } },
                    'Pending Request'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Header.Subheader,
                    { style: { color: 'orange' } },
                    'Please check again later'
                  )
                )
              ) : _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Container,
                      {
                        className: 'ctosScoreContainer',
                        style: {
                          background: ctosColor,
                          boxShadow: '0px 3px 0px 0px ' + ctosColorShadow
                        }
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Header,
                        { as: 'h2', style: { fontSize: '12px', color: 'white', paddingTop: '2rem', marginBottom: '0' } },
                        _react2.default.createElement(
                          'div',
                          { className: 'ctosDsrHeader' },
                          'CTOS ',
                          _react2.default.createElement(
                            _semanticUiReact.Button,
                            { onClick: this.showCTOSInfo },
                            _react2.default.createElement(
                              'p',
                              { style: { padding: '0 0.5rem', display: 'inline', border: '1px solid', borderRadius: '50%', color: 'white' } },
                              'i'
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(_semanticUiReact.Header, {
                        as: 'h1',
                        content: customerData.customer.customerCreditReport.ctosScore,
                        style: { color: 'white', margin: 0 }
                      }),
                      _react2.default.createElement(_semanticUiReact.Label, {
                        content: ctosStatus,
                        style: { background: 'transparent', color: 'white' }
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { style: { padding: '1rem' } },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_semanticUiReact.Header, {
                      as: 'h4',
                      content: 'CTOS Scoring',
                      textAlign: 'left',
                      style: { margin: '1rem' }
                    }),
                    this.ctosScore.map(function (ctosScore, key) {
                      return _react2.default.createElement(
                        _semanticUiReact.Label,
                        { as: 'div', key: key, style: { width: '100%', background: 'transparent' } },
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle', style: { color: ctosScore.color, float: 'left' } }),
                        _react2.default.createElement(
                          'p',
                          { style: { display: 'inline', float: 'left', margin: 0 } },
                          ctosScore.name
                        ),
                        _react2.default.createElement(
                          'p',
                          { style: { display: 'inline', float: 'right', margin: 0 } },
                          ctosScore.value
                        )
                      );
                    })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  auth && (auth.isHeadquarters || auth.isSuperAdmin || companyApp && companyApp.allowBranchLeaderDownload && auth.isBranchLeader || companyApp && companyApp.allowStaffDownload && auth.isDeveloperStaff || companyApp && companyApp.allowAgentDownload && (auth.isExternalAgentLeader || auth.isExternalAgent || auth.isExternalAgencyAdmin)) ? _react2.default.createElement(
                    'div',
                    { className: 'ctosButton' },
                    _react2.default.createElement(_semanticUiReact.Button, {
                      basic: true,
                      content: 'Full Report',
                      onClick: function onClick(e) {
                        return _this3.handleOpenHTML(e, customerData);
                      }
                    })
                  ) : null
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_CreditCheckInfoModal2.default, {
                      open: this.state.openCTOSModal,
                      header: 'CTOS'
                    })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 7, tablet: 8, mobile: 8 },
            _react2.default.createElement(
              _semanticUiReact.Container,
              {
                style: {
                  borderRadius: '0.25rem',
                  boxShadow: customerData.customer.customerCreditReport.mCtosXMLStatusID !== 'dsr_generated' ? '1px 1px 1px 2px rgba(0, 0, 0, 0.16)' : '0px 1px 0px 1px rgba(0, 0, 0, 0.16)',
                  height: customerData.customer.customerCreditReport.mCtosXMLStatusID !== 'dsr_generated' ? '20rem' : '36rem'
                }
              },
              customerData.customer.customerCreditReport.mCtosXMLStatusID !== 'dsr_generated' ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  { as: 'h2', style: { fontSize: '12px', color: 'black', paddingTop: '2rem' } },
                  _react2.default.createElement(
                    'div',
                    { className: 'ctosDsrHeader' },
                    'DSR ',
                    _react2.default.createElement(
                      _semanticUiReact.Button,
                      { onClick: this.showDSRInfo },
                      _react2.default.createElement(
                        'p',
                        { style: { padding: '0 0.5rem', display: 'inline', border: '1px solid', borderRadius: '50%' } },
                        'i'
                      )
                    )
                  )
                ),
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'clock', style: { color: 'orange', marginTop: '4rem', fontSize: '5rem', height: '4rem !important' } }),
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  { as: 'h4', style: { marginTop: '0' } },
                  _react2.default.createElement(
                    _semanticUiReact.Header.Content,
                    { style: { color: 'orange' } },
                    'Pending Request'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Header.Subheader,
                    { style: { color: 'orange' } },
                    'Please check again later'
                  )
                )
              ) : _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Container,
                      {
                        style: {
                          padding: '2rem',
                          borderTopLeftRadius: '0.25rem',
                          borderTopRightRadius: '0.25rem',
                          background: 'rgba(231, 236, 241, 1)',
                          height: '10rem'
                        }
                      },
                      _react2.default.createElement(
                        'div',
                        { className: customerData.customer.customerCreditReport.dsrScoreAfter > 0 ? 'ctosDSRContainerLeft' : null },
                        _react2.default.createElement(
                          _semanticUiReact.Header,
                          { as: 'h2', style: { fontSize: '12px', color: 'black', paddingTop: '1rem', marginBottom: '0' } },
                          _react2.default.createElement(
                            'div',
                            { className: 'ctosDsrHeader' },
                            'DSR ',
                            _react2.default.createElement(
                              _semanticUiReact.Button,
                              { onClick: this.showDSRInfo },
                              _react2.default.createElement(
                                'p',
                                { style: { padding: '0 0.5rem', display: 'inline', border: '1px solid', borderRadius: '50%' } },
                                'i'
                              )
                            )
                          )
                        ),
                        _react2.default.createElement(_semanticUiReact.Header, {
                          as: 'h1',
                          content: customerData.customer.customerCreditReport.dsr + '%',
                          style: { color: 'black', margin: 0 }
                        })
                      ),
                      customerData.customer.customerCreditReport.dsrScoreAfter > 0 ? _react2.default.createElement(
                        'div',
                        { className: 'ctosDSRContainerRight' },
                        _react2.default.createElement(
                          _semanticUiReact.Header,
                          { as: 'h2', style: { fontSize: '12px', color: 'black', paddingTop: '1rem', marginBottom: '0' } },
                          'DSR After'
                        ),
                        _react2.default.createElement(_semanticUiReact.Header, {
                          as: 'h1',
                          content: customerData.customer.customerCreditReport.dsrScoreAfter + '%',
                          style: { color: 'black', margin: 0 }
                        })
                      ) : null
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { style: { padding: '1rem', marginTop: '0.5rem' } },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { as: 'div', style: { width: '100%', background: 'transparent' } },
                      _react2.default.createElement(_semanticUiReact.Header, { as: 'h5', style: { float: 'left', margin: 0 }, content: 'Net Income' }),
                      _react2.default.createElement(
                        'p',
                        { style: { display: 'inline', float: 'right', margin: 0 } },
                        _react2.default.createElement(_LoanAmount2.default, {
                          format: '0,000,000.00',
                          amount: customerData.customer.customerCreditReport.incomeNet,
                          prefix: _react2.default.createElement(_CurrencySymbol2.default, null),
                          precise: false
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { as: 'div', style: { width: '100%', background: 'transparent' } },
                      _react2.default.createElement(_semanticUiReact.Header, { as: 'h5', style: { float: 'left', margin: 0 }, content: 'Housing Loan Amount' }),
                      _react2.default.createElement(
                        'p',
                        { style: { display: 'inline', float: 'right', margin: 0 } },
                        _react2.default.createElement(_LoanAmount2.default, {
                          format: '0,000,000.00',
                          amount: customerData.customer.customerCreditReport.currentLoanAmount,
                          prefix: _react2.default.createElement(_CurrencySymbol2.default, null),
                          precise: false
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { as: 'div', style: { width: '100%', background: 'transparent' } },
                      _react2.default.createElement(
                        _semanticUiReact.Header,
                        { as: 'h5', style: { float: 'left', margin: 0 }, textAlign: 'left' },
                        'Maximum Loan Amount ',
                        _react2.default.createElement('br', null),
                        ' (based on 60% DSR)'
                      ),
                      _react2.default.createElement(
                        'p',
                        { style: { display: 'inline', float: 'right', margin: 0 } },
                        _react2.default.createElement(_LoanAmount2.default, {
                          format: '0,000,000.00',
                          amount: this.getLoanAmount(),
                          prefix: _react2.default.createElement(_CurrencySymbol2.default, null),
                          precise: false
                        })
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { style: { marginTop: '9rem' } },
                  _react2.default.createElement(
                    'div',
                    { className: 'ctosButton' },
                    _react2.default.createElement(_semanticUiReact.Button, {
                      basic: true,
                      content: 'Edit Income',
                      onClick: function onClick() {
                        store.dispatch((0, _reactRouterRedux.push)('/bookings/' + data.id + '/customers/' + customerData.customerID + '/income/' + customerData.customer.incomeID + '/'));
                      }
                    })
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_CreditCheckInfoModal2.default, {
                      open: this.state.openDSRModal,
                      header: 'DSR'
                    })
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { style: { marginTop: '1rem' } },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Label,
              { className: 'ctosFooterLabel', as: 'div', style: { background: 'transparent', fontSize: '9px', color: 'rgba(162, 174, 183, 1)' } },
              'Powered by ',
              _react2.default.createElement(_semanticUiReact.Image, { src: _ctos2.default, size: 'mini' }),
              '. Registrars of CRAs 100% secure'
            )
          )
        )
      );
    }
  }]);

  return CTOSResult;
}(_react.Component);

CTOSResult.contextTypes = {
  store: _propTypes2.default.object
};

CTOSResult.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

CTOSResult.propTypes = {
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isDeveloperStaff: _propTypes2.default.bool,
    isExternalAgentLeader: _propTypes2.default.bool,
    isExternalAgent: _propTypes2.default.bool,
    isExternalAgencyAdmin: _propTypes2.default.bool
  }),
  customerData: _propTypes2.default.shape({
    customer: _propTypes2.default.shape({
      customerCreditReport: _propTypes2.default.shape({
        id: _propTypes2.default.string,
        ctosScore: _propTypes2.default.string,
        dsr: _propTypes2.default.number,
        dsrScoreAfter: _propTypes2.default.number,
        incomeNet: _propTypes2.default.number,
        currentLoanAmount: _propTypes2.default.number,
        mCtosHTMLRequestID: _propTypes2.default.string
      })
    })
  }),
  customerDataID: _propTypes2.default.string,
  data: _propTypes2.default.shape({
    id: _propTypes2.default.string
  })
};
exports.default = (0, _reactRedux.connect)(CTOSResult.mapStateToProps)(CTOSResult);

/***/ }),
/* 2114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _opportunityStatuses = __webpack_require__(195);

var _OpportunityCancelModal = __webpack_require__(262);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var CancelRequestDetail = function (_Component) {
  _inherits(CancelRequestDetail, _Component);

  function CancelRequestDetail(props) {
    var _this2 = this;

    _classCallCheck(this, CancelRequestDetail);

    var _this = _possibleConstructorReturn(this, (CancelRequestDetail.__proto__ || Object.getPrototypeOf(CancelRequestDetail)).call(this, props));

    _this.getBannerClassName = function (status) {
      if (_this.isCancelled(status)) {
        return 'cancel-container-approved';
      }
      return 'cancel-container-received';
    };

    _this.isCancelled = function (status) {
      return status === _opportunityStatuses.OPPORTUNITY_STATUS.CANCELLED || status === _opportunityStatuses.OPPORTUNITY_STATUS.CANCELLED_ERROR;
    };

    _this.handleOpenConfirm = function (type) {
      _this.setState({
        isConfirmOpen: true,
        confirmType: type
      });
    };

    _this.handleCloseConfirm = function () {
      _this.setState({ isConfirmOpen: false, confirmType: null });
    };

    _this.handleConfirmAction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props, onUpdateOpportunity, data, confirmType, finalStatus, isUndo;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, onUpdateOpportunity = _this$props.onUpdateOpportunity, data = _this$props.data;
              confirmType = _this.state.confirmType;

              if (!(onUpdateOpportunity && confirmType && data && data.sr_prev_status)) {
                _context.next = 18;
                break;
              }

              finalStatus = confirmType;
              isUndo = confirmType === 'UNDO_CANCELLATION';

              _this.setState({ isSubmitting: true });

              if (isUndo) {
                finalStatus = data.sr_prev_status;
              }

              _context.prev = 7;
              _context.next = 10;
              return onUpdateOpportunity(finalStatus, '', null, '', isUndo);

            case 10:
              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context['catch'](7);

              console.error('Failed to update opportunity status:', _context.t0);

            case 15:
              _context.prev = 15;

              _this.setState({ isSubmitting: false });
              return _context.finish(15);

            case 18:
              _this.handleCloseConfirm();

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[7, 12, 15, 18]]);
    }));

    _this.renderStatusBannerHeader = function (status) {
      var t = _this.props.t;

      if (_this.isCancelled(status)) {
        return _react2.default.createElement(
          'div',
          { className: 'cancel-header-title text-success' },
          _react2.default.createElement(
            'strong',
            null,
            t('Cancellation approved')
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { className: 'cancel-header-title text-warning' },
        _react2.default.createElement(
          'strong',
          null,
          t('Cancellation request received')
        )
      );
    };

    _this.state = {
      isConfirmOpen: false,
      confirmType: null,
      isSubmitting: false
    };
    return _this;
  }

  // CPI-1226: both terminal cancellations read as "approved"; only the CRM's grouping differs.


  _createClass(CancelRequestDetail, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          t = _props.t,
          data = _props.data,
          hasAccess = _props.hasAccess;
      var _state = this.state,
          isConfirmOpen = _state.isConfirmOpen,
          confirmType = _state.confirmType,
          isSubmitting = _state.isSubmitting;

      var currentStatus = data && data.sr_status;
      var isApprove = confirmType === _opportunityStatuses.OPPORTUNITY_STATUS.CANCELLED;

      var requestorName = data && data.primary_customer && data.primary_customer.name || '-';

      return _react2.default.createElement(
        'div',
        { className: 'cancel-detail-wrapper' },
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { className: 'cancel-status-block ' + this.getBannerClassName(currentStatus) },
          _react2.default.createElement(
            'div',
            { className: 'cancel-banner-top-row' },
            this.renderStatusBannerHeader(currentStatus),
            currentStatus === _opportunityStatuses.OPPORTUNITY_STATUS.PENDING_CANCELLATION && hasAccess && _react2.default.createElement(
              'div',
              { className: 'cancel-actions-header-group' },
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  className: 'btn-cancel-action btn-approve-cancel',
                  onClick: function onClick() {
                    return _this3.handleOpenConfirm(_opportunityStatuses.OPPORTUNITY_STATUS.CANCELLED);
                  }
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' }),
                ' ',
                t('Approve Cancellation')
              ),
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  className: 'btn-cancel-action btn-undo-cancel',
                  onClick: function onClick() {
                    return _this3.handleOpenConfirm('UNDO_CANCELLATION');
                  }
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'undo' }),
                ' ',
                t('Undo Cancellation')
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { style: { marginTop: '1rem' }, columns: 'equal', className: 'cancel-fields-grid' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'field-row' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 4, className: 'field-label' },
                t('Requestor name')
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 12, className: 'field-value text-green font-weight-bold' },
                requestorName
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'field-row' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 4, className: 'field-label' },
                t('Cancellation category')
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 12, className: 'field-value' },
                (0, _OpportunityCancelModal.cancellationCategoryLabel)(data.sr_cancellation_type) ? t((0, _OpportunityCancelModal.cancellationCategoryLabel)(data.sr_cancellation_type)) : '-'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'field-row' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 4, className: 'field-label' },
                t('Cancellation reason')
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 12, className: 'field-value' },
                data.sr_cancellation_reason || '-'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'field-row' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 4, className: 'field-label' },
                t('Cancellation requested at')
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 12, className: 'field-value' },
                data.sr_cancellation_at ? _react2.default.createElement(_Timestamp2.default, { timestamp: data.sr_cancellation_at, format: 'DD MMM YYYY, hh:mm a' }) : '-'
              )
            ),
            this.isCancelled(currentStatus) && _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'field-row' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 4, className: 'field-label' },
                t('Cancellation approved at')
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 12, className: 'field-value' },
                data.sr_cancelled_at ? _react2.default.createElement(_Timestamp2.default, { timestamp: data.sr_cancelled_at, format: 'DD MMM YYYY, hh:mm a' }) : '-'
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            open: isConfirmOpen,
            onClose: this.handleCloseConfirm,
            size: isApprove ? 'mini' : 'tiny',
            closeIcon: true
          },
          _react2.default.createElement(
            _semanticUiReact.Modal.Header,
            null,
            isApprove ? t('Approve Cancellation') : t('Undo Cancellation')
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            isApprove ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'p',
                { className: 'confirm-approve-text' },
                t('Are you sure you want to approve this cancellation request')
              )
            ) : _react2.default.createElement(
              'div',
              { className: 'reject-refund-wrapper' },
              _react2.default.createElement(
                'p',
                { className: 'confirm-reject-text' },
                t('Are you sure you want to undo this cancellation request')
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(
              _semanticUiReact.Button,
              { basic: true, onClick: this.handleCloseConfirm },
              t('Cancel')
            ),
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                color: 'teal',
                onClick: this.handleConfirmAction,
                loading: isSubmitting
              },
              t('Confirm')
            )
          )
        )
      );
    }
  }]);

  return CancelRequestDetail;
}(_react.Component);

CancelRequestDetail.propTypes = {
  data: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    sr_status: _propTypes2.default.string,
    sr_prev_status: _propTypes2.default.string,
    primary_customer: _propTypes2.default.shape({
      name: _propTypes2.default.string
    }),
    sr_cancellation_reason: _propTypes2.default.string,
    sr_cancellation_type: _propTypes2.default.string,
    sr_cancellation_at: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)])
  }).isRequired,
  t: _propTypes2.default.func.isRequired,
  hasAccess: _propTypes2.default.bool,
  onUpdateOpportunity: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)()(CancelRequestDetail);

/***/ }),
/* 2115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _promptMessages = __webpack_require__(43);

var _MarkdownText = __webpack_require__(193);

var _MarkdownText2 = _interopRequireDefault(_MarkdownText);

var _prompt = __webpack_require__(66);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChangesPrompt = function (_Component) {
  _inherits(ChangesPrompt, _Component);

  function ChangesPrompt(props) {
    _classCallCheck(this, ChangesPrompt);

    var _this = _possibleConstructorReturn(this, (ChangesPrompt.__proto__ || Object.getPrototypeOf(ChangesPrompt)).call(this, props));

    _this.fixBody = function () {
      var anotherModal = document.getElementsByClassName('ui page modals');
      if (anotherModal.length > 0) {
        // fix for modal prompt over existing modal
        document.body.classList.add('dimmable', 'dimmed');
      }
    };

    _this.handleOnCancel = function () {
      _this.close();
    };

    _this.handleOnComfirm = function () {
      _this.close(function () {
        var prompt = _this.props.prompt;

        if (prompt && prompt.callback) {
          prompt.callback();
        }
      });
    };

    _this.handleResetPrompt = function () {
      var store = _this.context.store;

      store.dispatch((0, _prompt.resetPromptMessage)());
    };

    _this.state = {
      show: false
    };
    return _this;
  }

  _createClass(ChangesPrompt, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var prompt = nextProps.prompt;

      if (prompt) {
        this.setState({
          show: prompt.show
        });
      }
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      this.fixBody();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.fixBody();
    }
  }, {
    key: 'close',
    value: function close(callback) {
      var _this2 = this;

      this.setState({
        show: false
      }, function () {
        if (callback) {
          callback();
        }
        _this2.handleResetPrompt();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          prompt = _props.prompt,
          t = _props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          size: 'small',
          open: this.state.show,
          onClose: this.handleOnCancel
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: prompt.icon, content: t(prompt.header) }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            _react2.default.createElement(
              _MarkdownText2.default,
              null,
              t(prompt.message || _promptMessages.DEFAULT_PROMPT)
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleOnCancel, content: t(prompt.samePage ? 'Keep Editing' : 'Stay') }),
          _react2.default.createElement(_semanticUiReact.Button, { color: 'blue', onClick: this.handleOnComfirm, content: t(prompt.samePage ? 'Cancel' : 'Leave') })
        )
      );
    }
  }]);

  return ChangesPrompt;
}(_react.Component);

ChangesPrompt.propTypes = {
  prompt: _propTypes2.default.shape({
    callback: _propTypes2.default.func,
    header: _propTypes2.default.node,
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    samePage: _propTypes2.default.bool,
    message: _propTypes2.default.node,
    show: _propTypes2.default.bool
  }),
  t: _propTypes2.default.func
};
ChangesPrompt.contextTypes = {
  store: _propTypes2.default.object
};


var mapStateToProps = function mapStateToProps(state) {
  return {
    prompt: state.prompt
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.translation)((0, _reactRedux.connect)(mapStateToProps)(ChangesPrompt));

/***/ }),
/* 2116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ContentExpand = function (_Component) {
  _inherits(ContentExpand, _Component);

  function ContentExpand(props) {
    _classCallCheck(this, ContentExpand);

    var _this = _possibleConstructorReturn(this, (ContentExpand.__proto__ || Object.getPrototypeOf(ContentExpand)).call(this, props));

    _this.handleExpand = function (e) {
      e.preventDefault();
      _this.setState({ isExpanded: true });
    };

    _this.state = {
      isExpanded: false
    };
    return _this;
  }

  _createClass(ContentExpand, [{
    key: 'render',
    value: function render() {
      if (this.props.expandable) {
        if (!this.state.isExpanded) {
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              {
                className: 'a-button-blue text_expand_single',
                onClick: this.handleExpand,
                title: 'View more',
                style: { width: this.props.width }
              },
              this.props.shortText
            )
          );
        }
        return _react2.default.createElement(
          'div',
          { className: 'text_expand', style: { width: this.props.width } },
          this.props.fullContent
        );
      }
      return _react2.default.createElement(
        'div',
        { className: 'text_expand', style: { width: this.props.width } },
        this.props.shortText
      );
    }
  }]);

  return ContentExpand;
}(_react.Component);

ContentExpand.propTypes = {
  shortText: _propTypes2.default.node.isRequired,
  fullContent: _propTypes2.default.node.isRequired,
  expandable: _propTypes2.default.bool,
  width: _propTypes2.default.string.isRequired
};

exports.default = ContentExpand;

/***/ }),
/* 2117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _reactRouter = __webpack_require__(18);

var _Identity = __webpack_require__(315);

var _Identity2 = _interopRequireDefault(_Identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CreditCheckConsentTemplate = function CreditCheckConsentTemplate(_ref) {
  var company = _ref.company,
      customerID = _ref.customerID,
      customerName = _ref.customerName,
      jobTitle = _ref.jobTitle,
      identity = _ref.identity,
      identityTypeID = _ref.identityTypeID;
  return _react2.default.createElement(
    'div',
    { className: 'consent-box' },
    _react2.default.createElement(
      'p',
      null,
      _react2.default.createElement(
        'b',
        null,
        (0, _momentTimezone2.default)().format('DD MMM YYYY')
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'detail' },
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h5',
          null,
          _react2.default.createElement(
            'b',
            null,
            company.name
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          company.address1,
          ', ',
          company.postcode,
          ', ',
          company.state,
          ', ',
          company.country
        )
      )
    ),
    _react2.default.createElement('br', null),
    _react2.default.createElement(
      'p',
      null,
      'Dear Sir/Madam,'
    ),
    _react2.default.createElement(
      'h4',
      null,
      'RE: Consent Authorisation'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Pursuant to the CRA Act and Central Bank of Malaysia Act, I/we the undersigned do hereby give my/our consent to you, TRB Ventures Sdn Bhd (MHub) and CTOS Data Systems Sdn Bhd (\u201CCTOS\u201D), a registered credit reporting agency under the CRA Act to process my/our company and personal data.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'By this consent, I/We understand and agree that:'
    ),
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'ol',
        null,
        _react2.default.createElement(
          'li',
          null,
          'You may conduct credit/trade check, CCRIS and DCHEQUE checks on us and where applicable with CTOS at any time for as long as I/we have a trade relationship with you or where any dues remain unpaid and outstanding with you, for any one or more of the following purposes:',
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              '- Opening of account'
            ),
            _react2.default.createElement(
              'li',
              null,
              '- Legal documentation consequent to a contract or facility granted by you'
            ),
            _react2.default.createElement(
              'li',
              null,
              '- Credit/Account monitoring'
            ),
            _react2.default.createElement(
              'li',
              null,
              '- Credit/Account evaluation'
            ),
            _react2.default.createElement(
              'li',
              null,
              '- Credit/Account review'
            ),
            _react2.default.createElement(
              'li',
              null,
              '- Debt recovery'
            )
          )
        ),
        _react2.default.createElement(
          'li',
          null,
          'You may disclose any information on the Parties\u2019 conduct of their accounts with you, to any business entity/ies for bona fide trade checking at any time. The Parties are also aware and understand that such information will be provided to a credit reporting agency/ies, who may in turn share such information to subscribers of their service.'
        ),
        _react2.default.createElement(
          'li',
          null,
          'Where you require any processing of our application to be processed by any processing centre located outside Malaysia (including your Head Office), the Parties hereby give consent to CTOS to disclose their credit, CCRIS & DCHEQUE reports to such locations outside Malaysia.'
        ),
        _react2.default.createElement(
          'li',
          null,
          'Apart from the above, the Parties undersigned do give our consent to you and the CTOS, to process my/our personal data as per the PDPA Act.'
        )
      ),
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'b',
          null,
          customerName,
          ' ',
          _react2.default.createElement('br', null),
          _react2.default.createElement(_Identity2.default, { type: identityTypeID, identity: identity }),
          ' ',
          _react2.default.createElement('br', null),
          jobTitle !== '' ? jobTitle : _react2.default.createElement(
            _reactRouter.Link,
            { to: '/customers/' + customerID + '/', target: '_blank' },
            'Add Job Title'
          )
        )
      ),
      _react2.default.createElement(
        _reactRouter.Link,
        { to: '/customers/' + customerID + '/', target: '_blank' },
        'Edit'
      )
    )
  );
}; /* eslint max-len: 0*/


CreditCheckConsentTemplate.propTypes = {
  company: _propTypes2.default.shape({
    name: _propTypes2.default.string,
    address1: _propTypes2.default.string,
    postcode: _propTypes2.default.string,
    state: _propTypes2.default.string,
    country: _propTypes2.default.string
  }).isRequired,
  jobTitle: _propTypes2.default.string.isRequired,
  customerName: _propTypes2.default.string.isRequired,
  identity: _propTypes2.default.string.isRequired,
  identityTypeID: _propTypes2.default.number.isRequired,
  customerID: _propTypes2.default.string.isRequired
};

CreditCheckConsentTemplate.defaultProps = {};

exports.default = CreditCheckConsentTemplate;

/***/ }),
/* 2118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreditCheckInfoModal = function (_Component) {
  _inherits(CreditCheckInfoModal, _Component);

  function CreditCheckInfoModal(props) {
    _classCallCheck(this, CreditCheckInfoModal);

    var _this = _possibleConstructorReturn(this, (CreditCheckInfoModal.__proto__ || Object.getPrototypeOf(CreditCheckInfoModal)).call(this, props));

    _initialiseProps.call(_this);

    var state = CreditCheckInfoModal.getPropsToState(props);
    _this.state = _extends({}, state);
    return _this;
  }

  _createClass(CreditCheckInfoModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = CreditCheckInfoModal.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'close',
    value: function close(callback) {
      this.setState({
        open: false
      }, function () {
        if (callback) {
          callback();
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          open: this.state.open,
          onClose: this.handleOnClose,
          closeIcon: 'close',
          size: 'mini'
        },
        _react2.default.createElement(_semanticUiReact.Header, { as: 'h4', content: this.props.header, style: { background: '#F4F5F7' } }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                this.props.header === 'DSR' ? _react2.default.createElement(
                  'p',
                  null,
                  'Debt Service Ratio (DSR) is one of the key parameters used by financial institutions to determine the capacity of a potential borrower to take on a new mortgage after taking into account his/her other existing debts. Typically your DSR should not go beyond 70% after including the mortgage you are applying for.'
                ) : null,
                this.props.header === 'CTOS' ? _react2.default.createElement(
                  'a',
                  { href: 'https://www.ctoscredit.com.my/', target: '_blank' },
                  'https://www.ctoscredit.com.my/'
                ) : null
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { centered: true },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  'div',
                  { className: 'ctosDsrModalButton' },
                  _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleOnClose, content: 'Okay' })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return CreditCheckInfoModal;
}(_react.Component);

CreditCheckInfoModal.propTypes = {
  header: _propTypes2.default.string,
  open: _propTypes2.default.bool
};

CreditCheckInfoModal.getPropsToState = function (props) {
  var open = props.open;
  return {
    open: open
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleOnClose = function () {
    _this2.close();
  };
};

exports.default = CreditCheckInfoModal;

/***/ }),
/* 2119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

var _semanticUiReact = __webpack_require__(2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint jsx-a11y/no-static-element-interactions: 0 */


var CreditCheckManageButton = function (_Component) {
  _inherits(CreditCheckManageButton, _Component);

  function CreditCheckManageButton(props) {
    _classCallCheck(this, CreditCheckManageButton);

    var _this = _possibleConstructorReturn(this, (CreditCheckManageButton.__proto__ || Object.getPrototypeOf(CreditCheckManageButton)).call(this, props));

    _initialiseProps.call(_this);

    var data = Object.assign({}, props.data);
    var modal = {
      isOpen: false,
      header: '',
      headerIcon: 'warning sign',
      message: '',
      actionButtonText: 'Yes',
      customerName: '',
      customerID: '',
      customerCreditReportID: '',
      token: '',
      type: ''
    };
    _this.state = {
      creditReport: null,
      data: data,
      loading: false,
      modal: modal,
      updating: false
    };
    return _this;
  }

  _createClass(CreditCheckManageButton, [{
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, res);
      });
    }
  }, {
    key: 'setUpdating',
    value: function setUpdating() {
      var _this4 = this;

      var updating = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ updating: updating }, res);
      });
    }
  }, {
    key: 'creditCheckToken',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, _message, reportToken;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                _context.next = 3;
                return this.setLoading(true);

              case 3:
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.state.modal.customerID + '/credit_reports/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 22;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);
                _context.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 17;
                return _context.t0.res.text();

              case 17:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 20:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 22:
                if (res.ok) {
                  _context.next = 30;
                  break;
                }

                _context.next = 25;
                return res.text();

              case 25:
                _message = _context.sent;
                _context.next = 28;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 28:
                _context.next = 32;
                break;

              case 30:
                reportToken = res.headers.get('X-Csrf-Token');

                this.setState({ reportToken: reportToken });

              case 32:
                _context.next = 34;
                return this.setLoading(false);

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function creditCheckToken() {
        return _ref.apply(this, arguments);
      }

      return creditCheckToken;
    }()
  }, {
    key: 'generateCreditCheck',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, res, jwtToken, message, _message2, modal, creditReport;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                _context2.next = 3;
                return this.setUpdating(true);

              case 3:
                res = void 0;
                _context2.prev = 4;
                _context2.next = 7;
                return _auth2.default.currentSession();

              case 7:
                jwtToken = _context2.sent.getAccessToken().getJwtToken();
                _context2.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.state.modal.customerID + '/credit_reports/' + this.state.modal.customerCreditReportID + '/status/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-JWT-Token': jwtToken
                  }
                }));

              case 10:
                res = _context2.sent;
                _context2.next = 25;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](4);
                _context2.next = 17;
                return this.setUpdating(false);

              case 17:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 23;
                  break;
                }

                _context2.next = 20;
                return _context2.t0.res.text();

              case 20:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 23:
                store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));
                return _context2.abrupt('return');

              case 25:
                if (res.ok) {
                  _context2.next = 33;
                  break;
                }

                _context2.next = 28;
                return res.text();

              case 28:
                _message2 = _context2.sent;
                _context2.next = 31;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message2 }));

              case 31:
                _context2.next = 42;
                break;

              case 33:
                modal = this.state.modal;

                modal.isOpen = false;
                _context2.next = 37;
                return res.json();

              case 37:
                creditReport = _context2.sent;
                _context2.next = 40;
                return this.setComponentState({
                  modal: modal,
                  creditReport: creditReport
                });

              case 40:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Credit score generating', message: this.state.modal.customerName + '\'s credit report sent' }));
                window.location.reload();

              case 42:
                _context2.next = 44;
                return this.setUpdating(false);

              case 44:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 13]]);
      }));

      function generateCreditCheck() {
        return _ref2.apply(this, arguments);
      }

      return generateCreditCheck;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          modal = _state.modal,
          updating = _state.updating,
          creditReport = _state.creditReport;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Modal,
          { className: 'manage manage-credit-check', dimmer: true, closeOnDimmerClick: true, open: modal.isOpen, size: 'small' },
          modal.type !== 'generate' ? _react2.default.createElement(
            _semanticUiReact.Header,
            null,
            _react2.default.createElement('img', { className: 'icon-credit', alt: 'alert', src: modal.headerIcon }),
            _react2.default.createElement(
              _semanticUiReact.Header.Content,
              null,
              modal.header
            )
          ) : _react2.default.createElement(_semanticUiReact.Header, { icon: modal.headerIcon, content: modal.header }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              'h4',
              null,
              modal.message
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            modal.type !== 'notAvailable' ? _react2.default.createElement(
              _semanticUiReact.Button,
              { onClick: this.handleCloseModal, color: 'grey' },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove' }),
              ' ',
              modal.type === 'generate' ? 'No' : 'Cancel'
            ) : _react2.default.createElement(
              _semanticUiReact.Button,
              { onClick: this.handleCloseModal, color: 'green' },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' }),
              ' Ok'
            ),
            modal.type === 'generate' ? _react2.default.createElement(
              _semanticUiReact.Button,
              {
                onClick: this.handlerGenerateCreditCheck,
                color: 'green',
                disabled: updating || !updating && creditReport && creditReport.mCtosXMLStatusID === 'request_pending'
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' }),
              ' ',
              modal.actionButtonText
            ) : null,
            modal.type === 'insufficientCredit' ? _react2.default.createElement(
              _semanticUiReact.Button,
              {
                color: 'green',
                as: 'a',
                onClick: this.handleGetSupport
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'plus' }),
              modal.actionButtonText
            ) : null
          )
        ),
        this.buttonCheck()
      );
    }
  }]);

  return CreditCheckManageButton;
}(_react.Component);

CreditCheckManageButton.contextTypes = {
  store: _propTypes2.default.object
};
CreditCheckManageButton.propTypes = {
  index: _propTypes2.default.number,
  companyAppCredit: _propTypes2.default.shape({
    credit: _propTypes2.default.string
  }),
  data: _propTypes2.default.shape({
    customer: _propTypes2.default.object
  }),
  isAgent: _propTypes2.default.bool,
  creditsAmount: _propTypes2.default.number
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.handlerGenerateCreditCheck = function () {
    _this5.generateCreditCheck();
  };

  this.handleCloseModal = function () {
    var modal = Object.assign({}, _this5.state.modal);
    modal.isOpen = false;
    _this5.setState({ modal: modal });
  };

  this.handleGetSupport = function () {
    var modal = Object.assign({}, _this5.state.modal);
    modal.isOpen = false;
    _this5.setState({ modal: modal }, function () {
      window.zE('webWidget', 'reset');
      window.zE('webWidget', 'open');
    });
  };

  this.handleOpenModal = function (index, type, customerName, customerID, customerCreditReportID, actionButtonText, headerIcon, header, message) {
    var modal = Object.assign({}, _this5.state.modal);
    if (type === 'generate') {
      _this5.creditCheckToken();
    }
    modal.index = index;
    modal.type = type;
    modal.customerCreditReportID = customerCreditReportID;
    modal.customerName = customerName;
    modal.customerID = customerID;
    modal.isOpen = true;
    modal.header = header;
    modal.message = message;
    modal.headerIcon = headerIcon;
    modal.actionButtonText = actionButtonText;
    _this5.setState({ modal: modal });
  };

  this.buttonText = function (status, updating, creditReport) {
    var isAgent = _this5.props.isAgent;

    var text = 'Generate now!';
    if (updating || status === 'request_pending' || status === 'request_mhub_ctos_received' || !updating && creditReport && creditReport.mCtosXMLStatusID === 'request_pending' || isAgent) {
      text = 'Pending';
    }
    if (status === 'request_ctos_muliple_entities') {
      text = 'Multiple entities';
    }
    return text;
  };

  this.disabledCheck = function (updating, creditReport, data) {
    var isAgent = _this5.props.isAgent;

    return updating || !updating && creditReport && creditReport.mCtosXMLStatusID === 'request_pending' || data.consentDsrDocumentID === '' || !data.isAgreedToDSRTerms || data.customer && (data.customer.icFrontDocumentID === '' || data.customer.icBackDocumentID === '' || data.customer.incomeID === '') || data.mCtosXMLStatusID === 'request_pending' || data.mCtosXMLStatusID === 'request_mhub_ctos_received' || isAgent;
  };

  this.buttonCheck = function () {
    var _props = _this5.props,
        companyAppCredit = _props.companyAppCredit,
        data = _props.data,
        isAgent = _props.isAgent;
    var _state2 = _this5.state,
        updating = _state2.updating,
        creditReport = _state2.creditReport;

    var status = data.mCtosXMLStatusID;
    switch (status) {
      case 'request_ctos_bad_request':
        return _react2.default.createElement(
          'div',
          {
            className: 'clickable',
            onClick: function onClick(e) {
              e.preventDefault();
              _this5.handleOpenModal(_this5.props.index, 'notAvailable', data.customer.customerDetail.name, data.customerID, data.id, 'Yes', '/assets/images/icons/red_alert.svg', 'Wrong Info', _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  data.customer.customerDetail.name,
                  '\xA0 currently does not have credit report with CTOS.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'How do we resolve this?'
                ),
                _react2.default.createElement(
                  'ul',
                  { style: { marginLeft: '1.5em' } },
                  _react2.default.createElement(
                    'li',
                    null,
                    'Check IC Number validity'
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    'Make sure name matches IC'
                  )
                )
              ));
            },
            role: 'button'
          },
          _react2.default.createElement('img', { className: 'icon-credit', alt: 'alert', src: '/assets/images/icons/red_alert.svg' }),
          '\xA0Wrong Info'
        );
      case 'request_ctos_not_available':
        return _react2.default.createElement(
          'div',
          {
            className: 'clickable',
            onClick: function onClick(e) {
              e.preventDefault();
              _this5.handleOpenModal(_this5.props.index, 'notAvailable', data.customer.customerDetail.name, data.customerID, data.id, 'Yes', '/assets/images/icons/red_alert.svg', 'Report is not available', _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  data.customer.customerDetail.name,
                  '\xA0 currently does not have report with CTOS.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'How do we resolve this?'
                ),
                _react2.default.createElement(
                  'ul',
                  { style: { marginLeft: '1.5em' } },
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Button,
                      {
                        compact: true,
                        size: 'mini',
                        color: data.mCtosXMLStatusID === 'request_pending' || data.mCtosXMLStatusID === 'request_mhub_ctos_received' || updating || !updating && creditReport && creditReport.mCtosXMLStatusID === 'request_pending' || isAgent ? 'orange' : 'green',
                        className: 'button-credit-check',
                        disabled: _this5.disabledCheck(updating, creditReport, data),
                        onClick: function onClick(e) {
                          e.preventDefault();
                          if (!_this5.props.creditsAmount || _this5.props.creditsAmount && _this5.props.creditsAmount < 10) {
                            _this5.handleOpenModal(_this5.props.index, 'insufficientCredit', data.customer.customerDetail.name, data.customerID, data.id, 'Top Up', '/assets/images/icons/red_alert.svg', 'Insufficient credits', _react2.default.createElement(
                              'span',
                              null,
                              _react2.default.createElement(
                                'p',
                                null,
                                'Not enough balance to perform a Credit Check. Please contact the admin'
                              )
                            ));
                          } else {
                            _this5.handleOpenModal(_this5.props.index, 'generate', data.customer.customerDetail.name, data.customerID, data.id, 'Yes', 'dashboard', _react2.default.createElement(
                              'span',
                              null,
                              'Generate Credit score?'
                            ), _react2.default.createElement(
                              'span',
                              null,
                              data.customer.customerDetail.name,
                              '\'',
                              's ',
                              'credit score will be generate.'
                            ));
                          }
                        }
                      },
                      _this5.buttonText(data.mCtosXMLStatusID, updating, creditReport)
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    'If the issue does not solve. Please contact the admin.'
                  )
                )
              ));
            },
            role: 'button'
          },
          _react2.default.createElement('img', { className: 'icon-credit', alt: 'alert', src: '/assets/images/icons/red_alert.svg' }),
          '\xA0Report not available'
        );
      case 'request_ctos_report_empty':
        return _react2.default.createElement(
          'div',
          {
            className: 'clickable',
            onClick: function onClick(e) {
              e.preventDefault();
              _this5.handleOpenModal(_this5.props.index, 'notAvailable', data.customer.customerDetail.name, data.customerID, data.id, 'Yes', '/assets/images/icons/red_alert.svg', 'Report is empty', _react2.default.createElement(
                'span',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  data.customer.customerDetail.name,
                  '\xA0 currently does not have report with CTOS.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'How do we resolve this?'
                ),
                _react2.default.createElement(
                  'ul',
                  { style: { marginLeft: '1.5em' } },
                  _react2.default.createElement(
                    'li',
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Button,
                      {
                        compact: true,
                        size: 'mini',
                        color: data.mCtosXMLStatusID === 'request_pending' || data.mCtosXMLStatusID === 'request_mhub_ctos_received' || updating || !updating && creditReport && creditReport.mCtosXMLStatusID === 'request_pending' || isAgent ? 'orange' : 'green',
                        className: 'button-credit-check',
                        disabled: _this5.disabledCheck(updating, creditReport, data),
                        onClick: function onClick(e) {
                          e.preventDefault();
                          if (!_this5.props.creditsAmount || _this5.props.creditsAmount && _this5.props.creditsAmount < 10) {
                            _this5.handleOpenModal(_this5.props.index, 'insufficientCredit', data.customer.customerDetail.name, data.customerID, data.id, 'Top Up', '/assets/images/icons/red_alert.svg', 'Insufficient credits', _react2.default.createElement(
                              'span',
                              null,
                              _react2.default.createElement(
                                'p',
                                null,
                                'Not enough balance to perform a Credit Check. Please contact the admin'
                              )
                            ));
                          } else {
                            _this5.handleOpenModal(_this5.props.index, 'generate', data.customer.customerDetail.name, data.customerID, data.id, 'Yes', 'dashboard', _react2.default.createElement(
                              'span',
                              null,
                              'Generate Credit score?'
                            ), _react2.default.createElement(
                              'span',
                              null,
                              data.customer.customerDetail.name,
                              '\'',
                              's ',
                              'credit score will be generate.'
                            ));
                          }
                        }
                      },
                      _this5.buttonText(data.mCtosXMLStatusID, updating, creditReport)
                    )
                  ),
                  _react2.default.createElement(
                    'li',
                    null,
                    'If the issue does not solve. Please contact the admin.'
                  )
                )
              ));
            },
            role: 'button'
          },
          _react2.default.createElement('img', { className: 'icon-credit', alt: 'alert', src: '/assets/images/icons/red_alert.svg' }),
          '\xA0Report is empty'
        );
      case 'request_ctos_muliple_entities':
        return _react2.default.createElement(
          _reactRouter.Link,
          {
            className: 'clickable',
            to: '/customers/' + data.customerID + '/credit_checks/' + data.id + '/multiple_entities/'
          },
          _react2.default.createElement('img', { className: 'icon-credit', alt: 'alert', src: '/assets/images/icons/red_alert.svg' }),
          '\xA0Multiple entities'
        );
      // case 'new':
      //   return (
      //     <div
      //       className="clickable"
      //       onClick={(e) => {
      //         e.preventDefault();
      //         this.handleOpenModal(
      //           this.props.index,
      //           'notAvailable',
      //           data.customer.customerDetail.name,
      //           data.customerID,
      //           data.id,
      //           'Yes',
      //           '/assets/images/icons/yellow_alert_cc.svg',
      //           'Incomplete Info',
      //           <span>
      //             <p>
      //               {data.customer.customerDetail.name}&nbsp;
      //               did not complete all the credit check steps
      //             </p>
      //             <p>
      //               How do we resolve this?
      //             </p>
      //             <ul style={{ marginLeft: '1.5em' }}>
      //               <li>Make sure all the steps are completed and successfully submitted</li>
      //             </ul>
      //           </span>,
      //         );
      //       }
      //     }
      //       role="button"
      //     >
      //       <img className="icon-credit" alt="alert" src="/assets/images/icons/yellow_alert_cc.svg" />
      //       &nbsp;Incomplete Info
      //     </div>
      //   );
      default:
        return _react2.default.createElement(
          _semanticUiReact.Button,
          {
            compact: true,
            size: 'mini',
            color: data.mCtosXMLStatusID === 'request_pending' || data.mCtosXMLStatusID === 'request_mhub_ctos_received' || updating || !updating && creditReport && creditReport.mCtosXMLStatusID === 'request_pending' || isAgent ? 'orange' : 'green',
            className: 'button-credit-check',
            disabled: _this5.disabledCheck(updating, creditReport, data),
            onClick: function onClick(e) {
              e.preventDefault();

              if (!_this5.props.creditsAmount || _this5.props.creditsAmount && _this5.props.creditsAmount < 10) {
                _this5.handleOpenModal(_this5.props.index, 'insufficientCredit', data.customer.customerDetail.name, data.customerID, data.id, 'Top Up', '/assets/images/icons/red_alert.svg', 'Insufficient credits', _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement(
                    'p',
                    null,
                    'Not enough balance to perform a Credit Check. Please contact the admin'
                  )
                ));
              } else {
                _this5.handleOpenModal(_this5.props.index, 'generate', data.customer.customerDetail.name, data.customerID, data.id, 'Yes', 'dashboard', _react2.default.createElement(
                  'span',
                  null,
                  'Generate Credit score?'
                ), _react2.default.createElement(
                  'span',
                  null,
                  data.customer.customerDetail.name,
                  '\'',
                  's ',
                  'credit score will be generate.'
                ));
              }
            }
          },
          _this5.buttonText(data.mCtosXMLStatusID, updating, creditReport)
        );
    }
  };
};

exports.default = CreditCheckManageButton;

/***/ }),
/* 2120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scoreScales = __webpack_require__(2230);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getScoreScale = function getScoreScale(score) {
  return _scoreScales.SCORE_SCALES.find(function (s) {
    return s.scale <= score;
  });
};

var checkStatus = function checkStatus(status) {
  var statusBool = false;
  switch (status) {
    case 'request_ctos_bad_request':
      statusBool = true;
      break;
    case 'request_ctos_muliple_entities':
      statusBool = true;
      break;
    default:
      statusBool = false;
  }
  return statusBool;
};

var CreditCheckScoreCTOS = function CreditCheckScoreCTOS(_ref) {
  var mCtosXMLStatusID = _ref.mCtosXMLStatusID,
      ctosScore = _ref.ctosScore;

  var scale = getScoreScale(ctosScore);
  return _react2.default.createElement(
    'div',
    { className: 'score' },
    _react2.default.createElement(
      'h1',
      null,
      'CTOS SCORE'
    ),
    mCtosXMLStatusID !== 'dsr_generated' ? _react2.default.createElement(
      'div',
      { className: (checkStatus(mCtosXMLStatusID) ? 'bad' : 'pending') + ' round icon' },
      checkStatus(mCtosXMLStatusID) ? _react2.default.createElement('img', { alt: 'bad', src: '/assets/images/icons/red_alert.svg' }) : _react2.default.createElement('img', { alt: 'pending', src: '/assets/images/icons/pending.svg' })
    ) : _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: 'success round icon', style: { background: scale.color } },
        _react2.default.createElement(
          'span',
          { className: 'value' },
          ctosScore
        )
      ),
      _react2.default.createElement(
        'h2',
        { style: { textTransform: 'uppercase', fontWeight: 'lighter' } },
        scale.title
      )
    ),
    mCtosXMLStatusID === 'dsr_generated' && _react2.default.createElement(
      'div',
      { className: 'breakdown' },
      _scoreScales.SCORE_SCALES.map(function (score) {
        return _react2.default.createElement(
          'div',
          { key: score.scale, className: 'breakdown-item' },
          _react2.default.createElement('span', { className: 'indicator', style: { background: score.color } }),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h5',
              null,
              score.title
            ),
            _react2.default.createElement(
              'p',
              null,
              score.subtitle
            )
          )
        );
      })
    )
  );
};

CreditCheckScoreCTOS.propTypes = {
  mCtosXMLStatusID: _propTypes2.default.string,
  ctosScore: _propTypes2.default.string
};

CreditCheckScoreCTOS.defaultProps = {
  mCtosXMLStatusID: 'new',
  ctosScore: '0'
};

exports.default = CreditCheckScoreCTOS;

/***/ }),
/* 2121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var checkStatus = function checkStatus(status) {
  var statusBool = false;
  switch (status) {
    case 'request_ctos_bad_request':
      statusBool = true;
      break;
    case 'request_ctos_muliple_entities':
      statusBool = true;
      break;
    default:
      statusBool = false;
  }
  return statusBool;
};

var CreditCheckScoreDSR = function CreditCheckScoreDSR(_ref) {
  var mCtosXMLStatusID = _ref.mCtosXMLStatusID,
      dsr = _ref.dsr,
      dsrScoreAfter = _ref.dsrScoreAfter,
      currentLoanAmount = _ref.currentLoanAmount,
      netIncome = _ref.netIncome;
  return _react2.default.createElement(
    'div',
    { className: 'score' },
    _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'h1',
        null,
        'DSR'
      ),
      mCtosXMLStatusID !== 'dsr_generated' ? _react2.default.createElement(
        'div',
        { className: (checkStatus(mCtosXMLStatusID) ? 'bad' : 'pending') + ' round icon' },
        checkStatus(mCtosXMLStatusID) ? _react2.default.createElement('img', { alt: 'bad', src: '/assets/images/icons/red_alert.svg' }) : _react2.default.createElement('img', { alt: 'pending', src: '/assets/images/icons/pending.svg' })
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'success round icon' },
          _react2.default.createElement(
            'span',
            { className: 'value' },
            dsr,
            _react2.default.createElement(
              'span',
              { className: 'value small' },
              '%'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          { style: { marginTop: '1.2em' } },
          'This DSR % calculation is generated based on the Net Income you have declared.'
        )
      )
    ),
    currentLoanAmount > 0 ? _react2.default.createElement(
      'div',
      { style: { marginTop: '3em' } },
      _react2.default.createElement(
        'h1',
        null,
        'DSR (After)'
      ),
      mCtosXMLStatusID !== 'dsr_generated' || dsrScoreAfter && dsrScoreAfter <= 0 ? _react2.default.createElement(
        'div',
        { className: (checkStatus(mCtosXMLStatusID) ? 'bad' : 'pending') + ' round icon' },
        checkStatus(mCtosXMLStatusID) ? _react2.default.createElement('img', { alt: 'bad', src: '/assets/images/icons/red_alert.svg' }) : _react2.default.createElement('img', { alt: 'pending', src: '/assets/images/icons/pending.svg' })
      ) : _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'success round icon' },
          _react2.default.createElement(
            'span',
            { className: 'value' },
            dsrScoreAfter,
            _react2.default.createElement(
              'span',
              { className: 'value small' },
              '%'
            )
          )
        ),
        _react2.default.createElement(
          'p',
          { style: { marginTop: '1.2em' } },
          'This DSR % calculation is generated based on the \xA0Net Income and Housing Loan you have declared.'
        )
      )
    ) : null,
    mCtosXMLStatusID === 'dsr_generated' && _react2.default.createElement(
      'div',
      { className: 'breakdown', style: { height: 'auto' } },
      _react2.default.createElement(
        'table',
        { style: { width: '100%', tableLayout: 'fixed' } },
        _react2.default.createElement(
          'tbody',
          null,
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Net income :'
              )
            ),
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(_LoanAmount2.default, {
                format: '0,000,000.00',
                amount: netIncome,
                prefix: 'RM\xA0'
              })
            )
          ),
          _react2.default.createElement(
            'tr',
            null,
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Housing loan amount :'
              )
            ),
            _react2.default.createElement(
              'td',
              null,
              _react2.default.createElement(_LoanAmount2.default, {
                format: '0,000,000.00',
                amount: currentLoanAmount,
                prefix: 'RM\xA0'
              })
            )
          )
        )
      )
    )
  );
};

CreditCheckScoreDSR.propTypes = {
  mCtosXMLStatusID: _propTypes2.default.string,
  dsr: _propTypes2.default.number,
  dsrScoreAfter: _propTypes2.default.number,
  currentLoanAmount: _propTypes2.default.number,
  netIncome: _propTypes2.default.number
};

CreditCheckScoreDSR.defaultProps = {
  mCtosXMLStatusID: 'new',
  dsr: 0
};

exports.default = CreditCheckScoreDSR;

/***/ }),
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _CreditCheckScoreCTOS = __webpack_require__(2120);

var _CreditCheckScoreCTOS2 = _interopRequireDefault(_CreditCheckScoreCTOS);

var _CreditCheckScoreDSR = __webpack_require__(2121);

var _CreditCheckScoreDSR2 = _interopRequireDefault(_CreditCheckScoreDSR);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var statusText = function statusText(status) {
  var nodeText = void 0;
  switch (status) {
    case 'request_ctos_bad_request':
      nodeText = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          'Report not available'
        ),
        _react2.default.createElement(
          'p',
          null,
          'currently does not have credit  report with CTOS.'
        ),
        _react2.default.createElement(
          'p',
          { style: { marginBottom: '.1em' } },
          'How do we resolve this?'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'ul',
            { style: { listStylePosition: 'inside' } },
            _react2.default.createElement(
              'li',
              null,
              'Check IC Number validity'
            ),
            _react2.default.createElement(
              'li',
              null,
              'Make sure name matches IC'
            )
          )
        )
      );
      break;
    case 'request_ctos_muliple_entities':
      nodeText = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          'Multiple entities'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Currently have multiple entities with CTOS.'
        ),
        _react2.default.createElement(
          'p',
          { style: { marginBottom: '.1em' } },
          'How do we resolve this?'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'ul',
            { style: { listStylePosition: 'inside' } },
            _react2.default.createElement(
              'li',
              null,
              'Please contact admin for more info'
            )
          )
        )
      );
      break;
    default:
      nodeText = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          'Pending Request'
        ),
        _react2.default.createElement(
          'p',
          null,
          'Please check again later.'
        )
      );
  }
  return nodeText;
};

var CreditCheckScores = function CreditCheckScores(_ref) {
  var allowBranchLeaderDownload = _ref.allowBranchLeaderDownload,
      allowStaffDownload = _ref.allowStaffDownload,
      allowAgentDownload = _ref.allowAgentDownload,
      auth = _ref.auth,
      mCtosHTMLStatusID = _ref.mCtosHTMLStatusID,
      mCtosXMLStatusID = _ref.mCtosXMLStatusID,
      currentLoanAmount = _ref.currentLoanAmount,
      dsr = _ref.dsr,
      dsrScoreAfter = _ref.dsrScoreAfter,
      ctosScore = _ref.ctosScore,
      createdAt = _ref.createdAt,
      editClick = _ref.editClick,
      openHTML = _ref.openHTML,
      netIncome = _ref.netIncome;
  return _react2.default.createElement(
    'div',
    { className: 'credit-check-scores' },
    mCtosXMLStatusID === 'dsr_generated' && _react2.default.createElement(
      'p',
      {
        className: 'clear',
        style: {
          marginBottom: '1em',
          fontSize: '1.2em'
        }
      },
      'Generated on ',
      _react2.default.createElement(_Timestamp2.default, { timestamp: createdAt })
    ),
    _react2.default.createElement(
      'div',
      { className: 'scores clear' },
      _react2.default.createElement(_CreditCheckScoreCTOS2.default, {
        ctosScore: ctosScore,
        mCtosXMLStatusID: mCtosXMLStatusID
      }),
      _react2.default.createElement(_CreditCheckScoreDSR2.default, {
        dsr: dsr,
        dsrScoreAfter: dsrScoreAfter,
        currentLoanAmount: currentLoanAmount,
        mCtosXMLStatusID: mCtosXMLStatusID,
        netIncome: netIncome
      })
    ),
    mCtosXMLStatusID !== 'dsr_generated' ? _react2.default.createElement(
      'div',
      { className: 'status text-center' },
      statusText(mCtosXMLStatusID)
    ) : _react2.default.createElement(
      'div',
      { className: 'status text-center' },
      _react2.default.createElement(
        _semanticUiReact.Button,
        {
          onClick: editClick,
          size: 'small',
          color: 'blue'
        },
        _react2.default.createElement(_semanticUiReact.Icon, { name: 'pencil' }),
        'Edit Income'
      ),
      mCtosHTMLStatusID === 'request_success' && auth && (auth.isSuperAdmin || auth.isHeadquarters || auth.isBranchLeader && allowBranchLeaderDownload || auth.isDeveloperStaff && allowStaffDownload || (auth.isExternalAgentLeader || auth.isExternalAgent || auth.isExternalAgencyAdmin) && allowAgentDownload) ? _react2.default.createElement(
        _semanticUiReact.Button,
        {
          onClick: openHTML,
          size: 'small',
          color: 'blue'
        },
        'HTML Report'
      ) : null
    )
  );
};

CreditCheckScores.propTypes = {
  allowBranchLeaderDownload: _propTypes2.default.bool,
  allowAgentDownload: _propTypes2.default.bool,
  allowStaffDownload: _propTypes2.default.bool,
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isDeveloperStaff: _propTypes2.default.bool,
    isExternalAgentLeader: _propTypes2.default.bool,
    isExternalAgent: _propTypes2.default.bool,
    isExternalAgencyAdmin: _propTypes2.default.bool
  }),
  mCtosHTMLStatusID: _propTypes2.default.string,
  mCtosXMLStatusID: _propTypes2.default.string,
  currentLoanAmount: _propTypes2.default.number,
  dsr: _propTypes2.default.number,
  dsrScoreAfter: _propTypes2.default.number,
  ctosScore: _propTypes2.default.string,
  createdAt: _propTypes2.default.string,
  editClick: _propTypes2.default.func,
  openHTML: _propTypes2.default.func,
  netIncome: _propTypes2.default.number
};

CreditCheckScores.defaultProps = {
  mCtosXMLStatusID: 'new',
  dsr: 0,
  ctosScore: null,
  auth: null
};

exports.default = CreditCheckScores;

/***/ }),
/* 2123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var steps = [{
  icon: 'verification',
  title: 'Verification',
  description: 'Upload form signed by purchaser'
}, {
  icon: 'ic_small',
  title: 'Photo of IC',
  description: 'Upload photo of IC front and back'
}, {
  icon: 'income',
  title: 'Income',
  description: 'Input either basic or detailed income'
}, {
  icon: 'credit_check',
  title: 'Generate Score',
  description: 'CTOS & DSR score'
}];

var CreditCheckSplash = function CreditCheckSplash(_ref) {
  var actionNode = _ref.actionNode;
  return _react2.default.createElement(
    _semanticUiReact.Grid,
    { stackable: true, doubling: true, style: { marginTop: '1em' }, textAlign: 'center' },
    _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { columns: 4 },
      steps.map(function (step, idx) {
        return _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { key: idx },
          _react2.default.createElement(
            _semanticUiReact.Header,
            { as: 'h3', icon: true },
            _react2.default.createElement(
              'i',
              { className: 'blue circular inverted icon' },
              _react2.default.createElement('img', { src: '/assets/images/icons/' + step.icon + '.svg', alt: '' })
            ),
            idx + 1,
            '. ',
            step.title,
            _react2.default.createElement(
              _semanticUiReact.Header.Subheader,
              null,
              step.description
            )
          ),
          idx === 0 ? _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'strong',
              null,
              _react2.default.createElement(
                'a',
                {
                  href: 'https://mhub.my/consent/credit_check/',
                  style: { color: '#57B4CA' }
                },
                'Download Form'
              )
            )
          ) : null
        );
      })
    ),
    actionNode
  );
};

CreditCheckSplash.propTypes = {
  actionNode: _propTypes2.default.node
};

exports.default = CreditCheckSplash;

/***/ }),
/* 2124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerBookings = function (_Component) {
  _inherits(CustomerBookings, _Component);

  function CustomerBookings(props) {
    _classCallCheck(this, CustomerBookings);

    var _this = _possibleConstructorReturn(this, (CustomerBookings.__proto__ || Object.getPrototypeOf(CustomerBookings)).call(this, props));

    _initialiseProps.call(_this);

    var state = CustomerBookings.getPropsToState(props);
    _this.state = _extends({}, state, {
      count: 0,
      data: [],
      limit: 0,
      loading: true,
      offset: 0
    });
    return _this;
  }

  _createClass(CustomerBookings, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
        delete query.page;
      }
      this.fetchBookingCustomers(query);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      var state = CustomerBookings.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchBookingCustomers',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var t, store, query, res, message, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/customers/' + this.props.params.id + '/booking_customers/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 10:
                res = _context.sent;
                _context.next = 21;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                Bugsnag.notifyException(_context.t0);
                _context.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 18:
                _context.next = 20;
                return this.setLoading(false);

              case 20:
                return _context.abrupt('return');

              case 21:
                if (res.ok) {
                  _context.next = 29;
                  break;
                }

                _context.next = 24;
                return res.text();

              case 24:
                message = _context.sent;
                _context.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 27:
                _context.next = 37;
                break;

              case 29:
                count = parseInt(res.headers.get('M-Data-Count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context.next = 34;
                return res.json();

              case 34:
                data = _context.sent;
                _context.next = 37;
                return this.setComponentState({
                  count: count,
                  data: data,
                  limit: limit,
                  offset: offset
                });

              case 37:
                _context.next = 39;
                return this.setLoading(false);

              case 39:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function fetchBookingCustomers(_x3) {
        return _ref.apply(this, arguments);
      }

      return fetchBookingCustomers;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;
      var pathname = this.props.location.pathname;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      this.fetchBookingCustomers(queryNew);
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.state.data;
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Dimmer,
              {
                inverted: true, style: { zIndex: 20 },
                active: this.state.loading
              },
              _react2.default.createElement(
                _semanticUiReact.Loader,
                { inline: 'centered' },
                t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
              )
            ),
            data && data.length > 0 ? _react2.default.createElement(
              _semanticUiReact.Table,
              {
                celled: true,
                stackable: true
              },
              _react2.default.createElement(
                _semanticUiReact.Table.Header,
                { className: 'mobile-hide' },
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    t('Unit') + ', ' + t('Project') + ', ' + t('Booking')
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    t('Purchaser')
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Body,
                null,
                data.map(function (item, idx) {
                  return _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    {
                      key: idx
                    },
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      { collapsing: true },
                      _react2.default.createElement(
                        _reactRouter.Link,
                        {
                          className: 'large-hide small-hide tablet-hide',
                          to: '/bookings/' + item.booking.id + '/',
                          style: {
                            float: 'right'
                          }
                        },
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron right' })
                      ),
                      _react2.default.createElement(
                        _reactRouter.Link,
                        { to: '/bookings/' + item.booking.id + '/' },
                        item.booking.projectUnit.reference,
                        ', ',
                        item.booking.project.shortName,
                        _react2.default.createElement(
                          'span',
                          { className: 'mobile-hide' },
                          ',\xA0'
                        ),
                        _react2.default.createElement('br', { className: 'large-hide' }),
                        _react2.default.createElement(
                          'small',
                          null,
                          item.booking.code
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      '' + (item.title === 'Not Applicable' ? '' : item.title + ' ') + item.name + ' (' + item.preferredName + ')'
                    )
                  );
                })
              )
            ) : _react2.default.createElement(
              _semanticUiReact.Item,
              { style: { paddingTop: '1em' } },
              _react2.default.createElement(
                _semanticUiReact.Item.Content,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { textAlign: 'center' },
                  this.state.loading ? _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }) : 'No bookings found.'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'center' },
            _react2.default.createElement(_PageNav2.default, {
              currentPage: this.state.currentPage,
              count: this.state.count,
              limit: this.state.limit,
              offset: this.state.offset,
              dataSize: this.state.data ? this.state.data.length : 0,
              loading: this.state.loading,
              onChange: this.handleChangePage,
              noScrollTop: true
            })
          )
        )
      );
    }
  }]);

  return CustomerBookings;
}(_react.Component);

CustomerBookings.contextTypes = {
  store: _propTypes2.default.object
};
CustomerBookings.propTypes = {
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }).isRequired,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }).isRequired,
  t: _propTypes2.default.func
};

CustomerBookings.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  return {
    currentPage: currentPage
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.getValueName = function (value, arr) {
    var valueName = arr.find(function (vn) {
      return vn.value === value;
    });
    if (valueName && valueName.text) {
      return valueName.text;
    }
    return '';
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    query.page = currentPage;
    _this4.setState({
      currentPage: currentPage
    });
    _this4.replaceQuery(query);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    if (hasQuery) {
      _this4.replaceQuery(query, true);
    }
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    query[queryName] = value;
    _this4.replaceQuery(query, true);
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(CustomerBookings);

/***/ }),
/* 2125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _translation = __webpack_require__(4);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _vietnamPricing = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */


var CustomiseFeePackageFormulaModal = function (_Component) {
  _inherits(CustomiseFeePackageFormulaModal, _Component);

  function CustomiseFeePackageFormulaModal(props) {
    _classCallCheck(this, CustomiseFeePackageFormulaModal);

    var _this = _possibleConstructorReturn(this, (CustomiseFeePackageFormulaModal.__proto__ || Object.getPrototypeOf(CustomiseFeePackageFormulaModal)).call(this, props));

    _initialiseProps.call(_this);

    var state = CustomiseFeePackageFormulaModal.getPropsToState(props);
    _this.state = _extends({}, state);
    return _this;
  }

  _createClass(CustomiseFeePackageFormulaModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = CustomiseFeePackageFormulaModal.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          bookingData = _props.bookingData,
          loading = _props.loading,
          t = _props.t;

      var options = this.renderOptions();
      // CPI-977 requirements 7/11: belt and braces - the modal is also reachable by a deep link.
      var statusID = bookingData && bookingData.statusID;
      if ((0, _vietnamPricing.isPricingPackageLocked)(this.props.auth, statusID, 'fee')) {
        return _react2.default.createElement(
          'section',
          { className: 'edit_package_pricing' },
          _react2.default.createElement(
            'p',
            { className: 'text-body' },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock' }),
            this.props.t((0, _vietnamPricing.vnPackageLockMessage)(this.props.auth, statusID, 'fee'))
          )
        );
      }
      return _react2.default.createElement(
        'section',
        { className: 'edit_package_pricing' },
        _react2.default.createElement(
          'p',
          { className: 'text-header' },
          t('Fee formula(s)', { ns: _translation.TRANSLATION_FILES.translation })
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 1 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              this.renderFields(options)
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'p',
                null,
                t('Would you like to add more fee formula? Go to', { ns: _translation.TRANSLATION_FILES.translation }),
                '\xA0',
                _react2.default.createElement(
                  'a',
                  { className: 'link', href: this.getDevPPUrl() },
                  t('Additional Fees', { ns: _translation.TRANSLATION_FILES.translation })
                ),
                '\xA0',
                t('to add, remove or edit fee formula(s).', { ns: _translation.TRANSLATION_FILES.translation })
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 1 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              _react2.default.createElement(_semanticUiReact.Button, {
                content: t('Save', { ns: _translation.TRANSLATION_FILES.translation }),
                disabled: !bookingData || !bookingData.packageFeeID,
                loading: loading,
                className: 'submit-button text-title',
                onClick: this.handleSubmit
              })
            )
          )
        )
      );
    }
  }]);

  return CustomiseFeePackageFormulaModal;
}(_react.Component);

CustomiseFeePackageFormulaModal.contextTypes = {
  store: _propTypes2.default.object
};
CustomiseFeePackageFormulaModal.propTypes = {
  auth: _propTypes2.default.shape({
    isSuperAdmin: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool
  }),
  bookingData: _propTypes2.default.shape(),
  isMobile: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  serviceCompanyID: _propTypes2.default.string,
  t: _propTypes2.default.func
};

CustomiseFeePackageFormulaModal.getPropsToState = function (props) {
  var bookingData = props.bookingData,
      open = props.open;

  var formulas = [];
  // control modal state externally instead of based on trigger if modalState provided
  if (open && bookingData && bookingData.packageFee && bookingData.packageFee.items && bookingData.packageFee.items.length > 0) {
    formulas = (0, _clone2.default)(bookingData.packageFee.items);
  }
  return {
    formulas: formulas
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getDevPPUrl = function () {
    var _props2 = _this2.props,
        bookingData = _props2.bookingData,
        serviceCompanyID = _props2.serviceCompanyID;

    var projectUrl = _config2.default.get('developerURL') + '/c/' + serviceCompanyID + '/projects/' + bookingData.projectID + '/';
    if (bookingData && bookingData.packageFee && bookingData.packageFee.projectFeePackageID && serviceCompanyID) {
      return projectUrl.concat('additional_fees/' + bookingData.packageFee.projectFeePackageID);
    }
    return projectUrl.concat('edit?tab=additional_fees');
  };

  this.handleOnChange = function (e, target) {
    var value = target.value,
        checked = target.checked;
    var formulas = _this2.state.formulas;

    var updatedFormulas = [].concat(_toConsumableArray(formulas));
    if (updatedFormulas.length > 0) {
      var idx = updatedFormulas.findIndex(function (ci) {
        return ci.id === value;
      });
      if (idx !== -1) {
        updatedFormulas[idx].isEnabled = checked;
      }
      _this2.setState({ formulas: updatedFormulas });
    }
  };

  this.handleSubmit = function () {
    var formulas = _this2.state.formulas;
    var _props3 = _this2.props,
        onSubmit = _props3.onSubmit,
        onClose = _props3.onClose;

    if (onSubmit) {
      onSubmit(formulas);
    }
    onClose();
  };

  this.renderOptions = function () {
    var formulas = _this2.state.formulas;

    var cItems = [];
    if (formulas.length > 0) {
      formulas.forEach(function (item) {
        cItems.push({
          id: item.id,
          name: item.name,
          checked: item.isEnabled,
          disabled: item.isRequired
        });
      });
    }
    return cItems;
  };

  this.renderFields = function (items) {
    return items && items.map(function (item) {
      return _react2.default.createElement(
        'section',
        {
          className: 'checkboxContainer',
          key: item.id
        },
        _react2.default.createElement(_semanticUiReact.Checkbox, {
          value: item.id,
          checked: item.checked,
          onChange: _this2.handleOnChange,
          disabled: item.disabled
        }),
        _react2.default.createElement(
          'div',
          { className: 'checkboxLabel' },
          _react2.default.createElement(
            'p',
            { className: 'text-title' },
            item.name
          )
        )
      );
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(CustomiseFeePackageFormulaModal);

/***/ }),
/* 2126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _reactI18next = __webpack_require__(3);

var _webValidations = __webpack_require__(23);

var _uuid = __webpack_require__(1600);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _translation = __webpack_require__(4);

var _vietnamPricing = __webpack_require__(197);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */


var CustomiseFormulaModal = function (_Component) {
  _inherits(CustomiseFormulaModal, _Component);

  function CustomiseFormulaModal(props) {
    _classCallCheck(this, CustomiseFormulaModal);

    var _this = _possibleConstructorReturn(this, (CustomiseFormulaModal.__proto__ || Object.getPrototypeOf(CustomiseFormulaModal)).call(this, props));

    _initialiseProps.call(_this);

    var state = CustomiseFormulaModal.getPropsToState(props);
    _this.validation = {};
    state.calculations.forEach(function (c) {
      if (c.isAdhoc) {
        _this.validation[c.id] = (0, _react.createRef)();
      }
    });

    _this.state = _extends({}, state, {
      loading: false,
      adhocFormulas: [],
      errMessages: []
    });
    return _this;
  }

  _createClass(CustomiseFormulaModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.open) {
        this.fetchPPAdhocFormulas();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      if (nextProps.open === true && this.props.open !== nextProps.open) {
        this.fetchPPAdhocFormulas();
      }

      var state = CustomiseFormulaModal.getPropsToState(nextProps);
      this.validation = {};
      state.calculations.forEach(function (c) {
        if (c.isAdhoc) {
          _this2.validation[c.id] = (0, _react.createRef)();
        }
      });
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          globalSettings = _props.globalSettings,
          bookingData = _props.bookingData,
          loading = _props.loading,
          t = _props.t;
      var adhocFormulas = this.state.adhocFormulas;

      var listCalcs = this.getCalculations('list_price');
      var spaCalcs = this.getCalculations('spa_price');
      var listAdhocs = this.getAdhocCalculations('list_price');
      var spaAdhocs = this.getAdhocCalculations('spa_price');
      // CPI-977 requirements 7/11: belt and braces - the modal is also reachable by a deep link.
      var statusID = bookingData && bookingData.statusID;
      if ((0, _vietnamPricing.isPricingPackageLocked)(this.props.auth, statusID, 'pricing')) {
        return _react2.default.createElement(
          'section',
          { className: 'edit_package_pricing' },
          _react2.default.createElement(
            'p',
            { className: 'text-body' },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock' }),
            this.props.t((0, _vietnamPricing.vnPackageLockMessage)(this.props.auth, statusID, 'pricing'))
          )
        );
      }
      return _react2.default.createElement(
        'section',
        { className: 'edit_package_pricing' },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'p',
                { className: 'text-header' },
                'Formula(s)'
              ),
              listCalcs.length > 0 && this.renderFieldHeader(globalSettings && globalSettings.unitSellingPrice ? globalSettings.unitSellingPrice : t('Unit Selling Price')),
              listCalcs.length > 0 && this.renderFields(listCalcs),
              spaCalcs.length > 0 && this.renderFieldHeader(globalSettings && globalSettings.sellingPrice ? globalSettings.sellingPrice : t('Selling Price')),
              spaCalcs.length > 0 && this.renderFields(spaCalcs)
            ),
            adhocFormulas.length > 0 || listAdhocs.length > 0 || spaAdhocs.length > 0 ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'div',
                {
                  style: {
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: '-0.6em',
                    marginBottom: '1em'
                  }
                },
                _react2.default.createElement(
                  'p',
                  { className: 'text-header', style: { margin: 0 } },
                  'Adhoc Formula(s)'
                ),
                adhocFormulas.length > 0 && _react2.default.createElement(
                  _semanticUiReact.Dropdown,
                  {
                    icon: 'add',
                    floating: true,
                    button: true,
                    color: 'blue',
                    className: 'icon',
                    selectOnBlur: false,
                    noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }),
                    style: {
                      marginLeft: '0.5em',
                      padding: '0.5em'
                    },
                    disabled: this.state.loading
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Dropdown.Menu,
                    { style: { zIndex: 60 } },
                    adhocFormulas.map(function (af) {
                      return _react2.default.createElement(_semanticUiReact.Dropdown.Item, {
                        key: af.id,
                        value: af.id,
                        onClick: _this3.handleAddAdhoc,
                        text: af.name
                      });
                    })
                  )
                )
              ),
              listAdhocs.length > 0 && this.renderFieldHeader(globalSettings && globalSettings.unitSellingPrice ? globalSettings.unitSellingPrice : t('Unit Selling Price')),
              listAdhocs.length > 0 && this.renderAdhocFields(listAdhocs),
              spaAdhocs.length > 0 && this.renderFieldHeader(globalSettings && globalSettings.sellingPrice ? globalSettings.sellingPrice : t('Selling Price')),
              spaAdhocs.length > 0 && this.renderAdhocFields(spaAdhocs)
            ) : null
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'p',
                null,
                'Would you like to add more formula? Go to\xA0',
                _react2.default.createElement(
                  'a',
                  { className: 'link', href: this.getDevPPUrl() },
                  'Pricing Package'
                ),
                '\xA0 to add, remove or edit formula(s).'
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 1 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              _react2.default.createElement(_semanticUiReact.Button, {
                content: 'Save',
                disabled: !bookingData || !bookingData.packagePricingID,
                loading: loading,
                className: 'submit-button text-title',
                onClick: this.handleSubmit
              })
            )
          )
        )
      );
    }
  }]);

  return CustomiseFormulaModal;
}(_react.Component);

CustomiseFormulaModal.contextTypes = {
  store: _propTypes2.default.object
};
CustomiseFormulaModal.propTypes = {
  auth: _propTypes2.default.shape({
    isSuperAdmin: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool
  }),
  bookingData: _propTypes2.default.shape(),
  isMobile: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  packagePricings: _propTypes2.default.arrayOf(_propTypes2.default.shape()),
  serviceCompanyID: _propTypes2.default.string,
  globalSettings: _propTypes2.default.shape(),
  t: _propTypes2.default.func
};

CustomiseFormulaModal.getPropsToState = function (props) {
  var bookingData = props.bookingData,
      open = props.open;

  var calculations = [];
  // control modal state externally instead of based on trigger if modalState provided
  if (open && bookingData && bookingData.packagePricing && bookingData.packagePricing.calculations && bookingData.packagePricing.calculations.length > 0) {
    calculations = (0, _clone2.default)(bookingData.packagePricing.calculations);
  }
  return {
    calculations: calculations
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this4.setState({ loading: loading }, res);
    });
  };

  this.setAdhocFormulas = function (data) {
    return new Promise(function (res) {
      _this4.setState({ adhocFormulas: data || [] }, res);
    });
  };

  this.setComponentState = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new Promise(function (res) {
      _this4.setState(state, function () {
        res(state);
      });
    });
  };

  this.getDevPPUrl = function () {
    var _props2 = _this4.props,
        bookingData = _props2.bookingData,
        serviceCompanyID = _props2.serviceCompanyID;

    if (bookingData && bookingData.packagePricing && bookingData.packagePricing.projectPackagePricingID && serviceCompanyID) {
      return _config2.default.get('developerURL') + '/c/' + serviceCompanyID + '/projects/' + bookingData.projectID + '/package_pricings/' + bookingData.packagePricing.projectPackagePricingID;
    }
    return '';
  };

  this.getFormulaTitle = function (title) {
    switch (title) {
      case 'discount':
        return 'Discount';
      case 'rebate':
        return 'Rebate';
      case 'add_on':
        return 'Add-on';
      case 'free_item':
        return 'Free item';
      case 'custom':
        return 'Custom';
      case 'tax':
        return 'Tax';
      default:
        return '';
    }
  };

  this.getCalculations = function (category) {
    var t = _this4.props.t;
    var calculations = _this4.state.calculations;

    var cItems = calculations.filter(function (c) {
      return c.category === category && !c.isAdhoc;
    }).map(function (calc) {
      return {
        id: calc.id,
        name: calc.isSubTotal ? t('Sub total') : calc.name,
        formulaTitle: calc.isSubTotal ? 'Subtotal' : _this4.getFormulaTitle(calc.title),
        checked: calc.isEnabled,
        orderPriority: calc.orderPriority,
        disabled: calc.isRequired
      };
    });
    return cItems;
  };

  this.getAdhocCalculations = function (category) {
    var calculations = _this4.state.calculations;

    var cItems = calculations.filter(function (c) {
      return c.category === category && c.isAdhoc;
    }).map(function (calc) {
      return {
        id: calc.id,
        name: calc.name,
        title: calc.title,
        formulaTitle: '' + (calc.isAdhoc ? 'Adhoc ' : '') + _this4.getFormulaTitle(calc.title),
        orderPriority: calc.orderPriority,
        formulaValue: calc.formulaValue,
        formulaValueMin: calc.formulaValueMin,
        formulaValueMax: calc.formulaValueMax
      };
    });
    return cItems;
  };

  this.fetchPPAdhocFormulas = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(calcs) {
      var store, _props3, t, bookingData, res, message, data;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this4.setLoading(true);

            case 2:
              store = _this4.context.store;
              _props3 = _this4.props, t = _props3.t, bookingData = _props3.bookingData;
              res = '';
              _context.prev = 5;
              _context.next = 8;
              return store.dispatch((0, _fetchM.fetchM)('/projects/' + bookingData.projectID + '/package_pricings/' + bookingData.packagePricing.projectPackagePricingID + '/formulas/?isAdhoc=true&isEnabled=true', {
                credentials: 'include',
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify(calcs)
              }));

            case 8:
              res = _context.sent;
              _context.next = 24;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](5);
              _context.next = 15;
              return _this4.setLoading(false);

            case 15:
              if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                _context.next = 21;
                break;
              }

              _context.next = 18;
              return _context.t0.res.text();

            case 18:
              message = _context.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
              return _context.abrupt('return');

            case 21:
              Bugsnag.notifyException(_context.t0);
              store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
              return _context.abrupt('return');

            case 24:
              _context.next = 26;
              return res.json();

            case 26:
              data = _context.sent;
              _context.next = 29;
              return _this4.setAdhocFormulas(data);

            case 29:
              _context.next = 31;
              return _this4.setLoading(false);

            case 31:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this4, [[5, 11]]);
    }));

    return function (_x3) {
      return _ref.apply(this, arguments);
    };
  }();

  this.handleOnCheck = function (e, target) {
    var value = target.value,
        checked = target.checked;
    var calculations = _this4.state.calculations;

    var updatedCalculationItems = [].concat(_toConsumableArray(calculations));
    if (updatedCalculationItems.length > 0) {
      var idx = updatedCalculationItems.findIndex(function (ci) {
        return ci.id === value;
      });
      if (idx !== -1) {
        updatedCalculationItems[idx].isEnabled = checked;
      }
      _this4.setState({ calculations: updatedCalculationItems });
    }
  };

  this.handleAdhocChange = function (event, data) {
    var calculations = _this4.state.calculations;

    var updatedCalculationItems = [].concat(_toConsumableArray(calculations));
    if (updatedCalculationItems.length > 0) {
      var idx = updatedCalculationItems.findIndex(function (ci) {
        return ci.id === data.name;
      });
      if (idx !== -1) {
        updatedCalculationItems[idx].formulaValue = data.value;
      }
      _this4.setState({ calculations: updatedCalculationItems });
    }
  };

  this.handleAddAdhoc = function (event, data) {
    var _state = _this4.state,
        calculations = _state.calculations,
        adhocFormulas = _state.adhocFormulas;

    var updatedCalculationItems = [].concat(_toConsumableArray(calculations));
    if (adhocFormulas.length > 0) {
      var adhocItem = adhocFormulas.find(function (a) {
        return a.id === data.value;
      });
      if (adhocItem) {
        var id = 'temp_' + (0, _uuid.v4)();
        var category = adhocItem.calculationType === 'deduct_from_list_price' ? 'list_price' : 'spa_price';
        var orderPriority = calculations.filter(function (c) {
          return c.category === category;
        }).length + 1;
        updatedCalculationItems.push({
          id: id,
          category: category,
          orderPriority: orderPriority,
          projectPackagePricingItemID: adhocItem.id,
          projectPackagePricingItem: adhocItem,
          name: adhocItem.name,
          description: adhocItem.description,
          code: adhocItem.code,
          title: adhocItem.title,
          format: adhocItem.format,
          calculationType: adhocItem.calculationType,
          rounding: adhocItem.rounding,
          formulaValue: adhocItem.title === 'free_item' ? '' : 0,
          formulaValueMin: adhocItem.formulaValueMin,
          formulaValueMax: adhocItem.formulaValueMax,
          isRequired: false,
          isAdhoc: true,
          isEnabled: true
        });
        _this4.validation[id] = (0, _react.createRef)();
      }
      _this4.setState({ calculations: updatedCalculationItems });
    }
  };

  this.handleRemoveAdhoc = function (adhocID) {
    var calculations = _this4.state.calculations;

    var updatedCalculationItems = [].concat(_toConsumableArray(calculations));
    if (updatedCalculationItems.length > 0) {
      var idx = updatedCalculationItems.findIndex(function (ci) {
        return ci.id === adhocID;
      });
      if (idx !== -1) {
        delete _this4.validation[updatedCalculationItems[idx].id];
        updatedCalculationItems.splice(idx, 1);
      }
      _this4.setState({ calculations: updatedCalculationItems });
    }
  };

  this.handleSubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var calculations, _props4, onSubmit, onClose, t, data, validations, errMessages, store;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            calculations = _this4.state.calculations;
            _props4 = _this4.props, onSubmit = _props4.onSubmit, onClose = _props4.onClose, t = _props4.t;

            if (!onSubmit) {
              _context2.next = 18;
              break;
            }

            data = {};

            calculations.forEach(function (c) {
              if (_this4.validation[c.id]) {
                data[c.id] = c.formulaValue;
              }
            });
            _context2.next = 7;
            return _AppForm2.default.validate(_this4.validation, data);

          case 7:
            validations = _context2.sent;
            errMessages = validations.filter(function (v) {
              return !v.isValid;
            });
            _context2.next = 11;
            return _this4.setComponentState({
              errMessages: errMessages
            });

          case 11:
            if (!(errMessages.length > 0)) {
              _context2.next = 17;
              break;
            }

            store = _this4.context.store;
            _context2.next = 15;
            return _this4.setLoading(false);

          case 15:
            store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errMessages.map(function (l) {
                return l.message;
              }) }));
            return _context2.abrupt('return');

          case 17:
            onSubmit(calculations);

          case 18:
            onClose();

          case 19:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this4);
  }));

  this.renderFieldHeader = function (text) {
    return _react2.default.createElement(
      'section',
      { className: 'checkboxContainer containerHeader' },
      _react2.default.createElement(
        'p',
        { className: 'text-title' },
        text
      )
    );
  };

  this.renderFields = function (items) {
    return items && items.map(function (item) {
      return _react2.default.createElement(
        'section',
        {
          className: 'checkboxContainer',
          key: item.id
        },
        _react2.default.createElement(_semanticUiReact.Checkbox, {
          value: item.id,
          checked: item.checked,
          onChange: _this4.handleOnCheck,
          disabled: item.disabled
        }),
        _react2.default.createElement(
          'div',
          { className: 'checkboxLabel' },
          _react2.default.createElement(
            'p',
            { className: 'text-title' },
            item.name
          ),
          _react2.default.createElement(
            'p',
            { className: 'text-subtitle' },
            item.formulaTitle
          )
        )
      );
    });
  };

  this.renderAdhocFields = function (items) {
    return items && items.map(function (item) {
      var isFreeItem = item.title === 'free_item';
      var validations = [_webValidations.required];
      if (!isFreeItem) {
        validations.push({
          validate: _webValidations.numericRange,
          option: {
            min: parseInt(item.formulaValueMin, 10),
            max: parseInt(item.formulaValueMax, 10)
          }
        });
      }
      return _react2.default.createElement(
        'section',
        {
          className: 'checkboxContainer',
          key: item.id
        },
        _react2.default.createElement(_AppForm2.default.Input, {
          style: { width: '100%' },
          autoComplete: 'off',
          name: item.id,
          onChange: _this4.handleAdhocChange,
          type: isFreeItem ? 'text' : 'number',
          step: isFreeItem ? null : '.01',
          label: item.name + ' (' + item.formulaTitle + ')',
          ref: _this4.validation[item.id],
          validation: validations,
          value: item.formulaValue,
          validateLabel: item.name
        }),
        _react2.default.createElement(_semanticUiReact.Button, {
          tiny: true,
          color: 'red',
          icon: 'trash alternate',
          disabled: _this4.props.loading,
          loading: _this4.props.loading,
          style: { marginLeft: '1em', marginBottom: '1px' },
          onClick: function onClick() {
            return _this4.handleRemoveAdhoc(item.id);
          }
        })
      );
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(CustomiseFormulaModal);

/***/ }),
/* 2127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DelistReasonModal = function DelistReasonModal(_ref) {
  var open = _ref.open,
      onConfirm = _ref.onConfirm,
      onCancel = _ref.onCancel,
      reasons = _ref.reasons,
      selectedReason = _ref.selectedReason,
      onReasonChange = _ref.onReasonChange,
      loading = _ref.loading,
      t = _ref.t;

  var reasonOptions = reasons.map(function (reason) {
    return {
      key: reason.id,
      text: reason.label,
      value: reason.id
    };
  });

  // "No Reason" option
  reasonOptions.unshift({
    key: '',
    text: t('No Reason'),
    value: ''
  });

  return _react2.default.createElement(
    _semanticUiReact.Modal,
    {
      open: open,
      onClose: onCancel,
      size: 'tiny',
      closeIcon: !loading,
      closeOnDimmerClick: !loading
    },
    _react2.default.createElement(
      _semanticUiReact.Modal.Header,
      null,
      t('Delist Unit')
    ),
    _react2.default.createElement(
      _semanticUiReact.Modal.Content,
      null,
      _react2.default.createElement(
        _semanticUiReact.Form,
        null,
        _react2.default.createElement(
          _semanticUiReact.Form.Field,
          null,
          _react2.default.createElement(
            'label',
            null,
            t('Delist Reason'),
            ' (',
            t('Optional'),
            ')'
          ),
          _react2.default.createElement(_semanticUiReact.Dropdown, {
            placeholder: t('Select reason...'),
            fluid: true,
            selection: true,
            options: reasonOptions,
            value: selectedReason,
            onChange: function onChange(e, _ref2) {
              var value = _ref2.value;
              return onReasonChange(value);
            },
            disabled: loading
          })
        ),
        _react2.default.createElement(
          'p',
          { style: { color: '#666', fontSize: '0.9em', marginTop: '10px' } },
          t('You can proceed without selecting a reason. This is optional.')
        )
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Modal.Actions,
      null,
      _react2.default.createElement(
        _semanticUiReact.Button,
        {
          onClick: onCancel,
          disabled: loading
        },
        t('Cancel', { ns: _translation.TRANSLATION_FILES.translation })
      ),
      _react2.default.createElement(
        _semanticUiReact.Button,
        {
          primary: true,
          onClick: onConfirm,
          loading: loading,
          disabled: loading
        },
        t('Confirm', { ns: _translation.TRANSLATION_FILES.translation })
      )
    )
  );
};

DelistReasonModal.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  onConfirm: _propTypes2.default.func.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  reasons: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired
  })).isRequired,
  selectedReason: _propTypes2.default.string,
  onReasonChange: _propTypes2.default.func.isRequired,
  loading: _propTypes2.default.bool,
  t: _propTypes2.default.func.isRequired
};

DelistReasonModal.defaultProps = {
  selectedReason: '',
  loading: false
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(DelistReasonModal);

/***/ }),
/* 2128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _reactSortableHoc = __webpack_require__(123);

var _webValidations = __webpack_require__(23);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DragHandle = (0, _reactSortableHoc.SortableHandle)(function () {
  return _react2.default.createElement(_semanticUiReact.Icon, { name: 'bars', style: { cursor: 'grab' } });
});

var SortableItem = (0, _reactSortableHoc.SortableElement)(function (_ref) {
  var reason = _ref.reason,
      onEdit = _ref.onEdit,
      onDelete = _ref.onDelete,
      onNameChange = _ref.onNameChange,
      onLabelChange = _ref.onLabelChange,
      isEditing = _ref.isEditing,
      validation = _ref.validation,
      t = _ref.t,
      isHQ = _ref.isHQ;
  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    null,
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { width: 1, textAlign: 'center' },
      isHQ && _react2.default.createElement(DragHandle, null)
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { width: 6, textAlign: 'center' },
      isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
        validateLabel: t('Reason Name'),
        name: 'reason_' + reason.id,
        value: reason.label,
        validation: [_webValidations.required],
        onChange: function onChange(e, _ref2) {
          var value = _ref2.value;
          return onLabelChange(reason.id, value);
        },
        ref: validation['reason_' + reason.id]
      }) : reason.label
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { width: 3, textAlign: 'center' },
      reason.isDefault ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'check', color: 'green' }) : _react2.default.createElement(_semanticUiReact.Icon, { name: 'times', color: 'grey' })
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { width: 3, textAlign: 'center' },
      isHQ && _react2.default.createElement(
        _react2.default.Fragment,
        null,
        reason.isDefault || reason.isInUse ? _react2.default.createElement(_semanticUiReact.Icon, {
          name: 'lock',
          color: 'grey',
          title: reason.isDefault ? t('Default reason cannot be modified') : t('Cannot delete, this reason is currently being used by delisted units')
        }) : _react2.default.createElement(
          _react2.default.Fragment,
          null,
          isEditing ? _react2.default.createElement(_semanticUiReact.Button, {
            size: 'mini',
            color: 'green',
            icon: 'save',
            content: t('Save'),
            onClick: function onClick() {
              return onEdit(reason.id, true);
            }
          }) : _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(_semanticUiReact.Button, {
              size: 'mini',
              icon: 'edit',
              content: t('Edit'),
              onClick: function onClick() {
                return onEdit(reason.id, false);
              }
            }),
            _react2.default.createElement(_semanticUiReact.Button, {
              size: 'mini',
              color: 'red',
              icon: 'trash',
              content: t('Delete'),
              onClick: function onClick() {
                return onDelete(reason.id);
              }
            })
          )
        )
      )
    )
  );
});

var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref3) {
  var reasons = _ref3.reasons,
      onEdit = _ref3.onEdit,
      onDelete = _ref3.onDelete,
      onNameChange = _ref3.onNameChange,
      onLabelChange = _ref3.onLabelChange,
      editingReasonID = _ref3.editingReasonID,
      validation = _ref3.validation,
      t = _ref3.t,
      isHQ = _ref3.isHQ;
  return _react2.default.createElement(
    _semanticUiReact.Table.Body,
    null,
    reasons.map(function (reason, index) {
      return _react2.default.createElement(SortableItem, {
        key: reason.id,
        index: index,
        reason: reason,
        onEdit: onEdit,
        onDelete: onDelete,
        onNameChange: onNameChange,
        onLabelChange: onLabelChange,
        isEditing: editingReasonID === reason.id,
        validation: validation,
        t: t,
        isHQ: isHQ,
        disabled: !isHQ
      });
    })
  );
});

var DelistReasonsList = function (_Component) {
  _inherits(DelistReasonsList, _Component);

  function DelistReasonsList(props) {
    var _this2 = this;

    _classCallCheck(this, DelistReasonsList);

    var _this = _possibleConstructorReturn(this, (DelistReasonsList.__proto__ || Object.getPrototypeOf(DelistReasonsList)).call(this, props));

    _this.handleAddNew = function () {
      _this.setState({ showAddForm: true, newReasonName: '' });
    };

    _this.handleCancelAdd = function () {
      _this.setState({ showAddForm: false, newReasonName: '', editingReasonID: null });
    };

    _this.handleSaveNew = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$state, newReasonName, token, store, t, validations, res, label, name, message;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$state = _this.state, newReasonName = _this$state.newReasonName, token = _this$state.token;
              store = _this.context.store;
              t = _this.props.t;

              // Validate

              _context.next = 5;
              return _AppForm2.default.validate({ newReason: _this.newReasonValidation }, { newReason: newReasonName });

            case 5:
              validations = _context.sent;

              if (!validations.some(function (v) {
                return !v.isValid;
              })) {
                _context.next = 8;
                break;
              }

              return _context.abrupt('return');

            case 8:
              _context.next = 10;
              return _this.setLoading(true);

            case 10:
              res = void 0;
              _context.prev = 11;

              // Generate label from name (convert snake_case/lowercase to Title Case)
              label = newReasonName.trim();
              name = label.toLowerCase().replace(/\s+/g, '_');
              _context.next = 16;
              return store.dispatch((0, _fetchM.fetchM)('/settings/delist_reasons/', {
                credentials: 'include',
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Csrf-Token': token
                },
                body: JSON.stringify({
                  name: name,
                  label: label
                })
              }));

            case 16:
              res = _context.sent;
              _context.next = 27;
              break;

            case 19:
              _context.prev = 19;
              _context.t0 = _context['catch'](11);

              Bugsnag.notifyException(_context.t0);
              _context.next = 24;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred', { ns: _translation.TRANSLATION_FILES.translation }) }));

            case 24:
              _context.next = 26;
              return _this.setLoading(false);

            case 26:
              return _context.abrupt('return');

            case 27:
              if (res.ok) {
                _context.next = 35;
                break;
              }

              _context.next = 30;
              return res.text();

            case 30:
              message = _context.sent;
              _context.next = 33;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

            case 33:
              _context.next = 40;
              break;

            case 35:
              _context.next = 37;
              return store.dispatch((0, _flash.flashSuccessMessage)({ message: t('Delist reason added successfully') }));

            case 37:
              _this.setState({ showAddForm: false, newReasonName: '' });
              _context.next = 40;
              return _this.fetchDelistReasons();

            case 40:
              _context.next = 42;
              return _this.setLoading(false);

            case 42:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[11, 19]]);
    }));

    _this.handleEdit = function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(reasonID, save) {
        var _this$state2, reasons, token, store, t, reason, validations, res, name, errorMessage, message;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this$state2 = _this.state, reasons = _this$state2.reasons, token = _this$state2.token;
                store = _this.context.store;
                t = _this.props.t;

                if (!save) {
                  _context2.next = 55;
                  break;
                }

                // Validate
                reason = reasons.find(function (r) {
                  return r.id === reasonID;
                });
                _context2.next = 7;
                return _AppForm2.default.validate(_defineProperty({}, 'reason_' + reasonID, _this.validation['reason_' + reasonID]), _defineProperty({}, 'reason_' + reasonID, reason.label));

              case 7:
                validations = _context2.sent;

                if (!validations.some(function (v) {
                  return !v.isValid;
                })) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt('return');

              case 10:
                _context2.next = 12;
                return _this.setLoading(true);

              case 12:
                res = void 0;
                _context2.prev = 13;

                // Generate name from label
                name = reason.label.toLowerCase().replace(/\s+/g, '_');
                _context2.next = 17;
                return store.dispatch((0, _fetchM.fetchM)('/settings/delist_reasons/' + reasonID + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': token
                  },
                  body: JSON.stringify({
                    name: name,
                    label: reason.label
                  })
                }));

              case 17:
                res = _context2.sent;
                _context2.next = 38;
                break;

              case 20:
                _context2.prev = 20;
                _context2.t0 = _context2['catch'](13);

                Bugsnag.notifyException(_context2.t0);
                errorMessage = t('An error occurred', { ns: _translation.TRANSLATION_FILES.translation });

                if (!_context2.t0.res) {
                  _context2.next = 33;
                  break;
                }

                _context2.prev = 25;
                _context2.next = 28;
                return _context2.t0.res.text();

              case 28:
                errorMessage = _context2.sent;
                _context2.next = 33;
                break;

              case 31:
                _context2.prev = 31;
                _context2.t1 = _context2['catch'](25);

              case 33:
                _context2.next = 35;
                return store.dispatch((0, _flash.flashErrorMessage)({ header: 'Unable to Proceed', message: errorMessage }));

              case 35:
                _context2.next = 37;
                return _this.setLoading(false);

              case 37:
                return _context2.abrupt('return');

              case 38:
                if (res.ok) {
                  _context2.next = 46;
                  break;
                }

                _context2.next = 41;
                return res.text();

              case 41:
                message = _context2.sent;
                _context2.next = 44;
                return store.dispatch((0, _flash.flashErrorMessage)({ header: 'Unable to Proceed', message: message }));

              case 44:
                _context2.next = 51;
                break;

              case 46:
                _context2.next = 48;
                return store.dispatch((0, _flash.flashSuccessMessage)({ message: t('Delist reason updated successfully') }));

              case 48:
                _this.setState({ editingReasonID: null });
                _context2.next = 51;
                return _this.fetchDelistReasons();

              case 51:
                _context2.next = 53;
                return _this.setLoading(false);

              case 53:
                _context2.next = 56;
                break;

              case 55:
                _this.setState({ editingReasonID: reasonID });

              case 56:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[13, 20], [25, 31]]);
      }));

      return function (_x, _x2) {
        return _ref5.apply(this, arguments);
      };
    }();

    _this.handleDelete = function (reasonID) {
      _this.setState({ deleteConfirmOpen: true, deleteReasonID: reasonID });
    };

    _this.handleConfirmDelete = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _this$state3, deleteReasonID, token, store, t, res, errorMessage, message;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$state3 = _this.state, deleteReasonID = _this$state3.deleteReasonID, token = _this$state3.token;
              store = _this.context.store;
              t = _this.props.t;
              _context3.next = 5;
              return _this.setLoading(true);

            case 5:
              _this.setState({ deleteConfirmOpen: false });

              res = void 0;
              _context3.prev = 7;
              _context3.next = 10;
              return store.dispatch((0, _fetchM.fetchM)('/settings/delist_reasons/' + deleteReasonID + '/', {
                credentials: 'include',
                method: 'DELETE',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Csrf-Token': token
                }
              }));

            case 10:
              res = _context3.sent;
              _context3.next = 31;
              break;

            case 13:
              _context3.prev = 13;
              _context3.t0 = _context3['catch'](7);

              Bugsnag.notifyException(_context3.t0);
              errorMessage = t('An error occurred', { ns: _translation.TRANSLATION_FILES.translation });

              if (!_context3.t0.res) {
                _context3.next = 26;
                break;
              }

              _context3.prev = 18;
              _context3.next = 21;
              return _context3.t0.res.text();

            case 21:
              errorMessage = _context3.sent;
              _context3.next = 26;
              break;

            case 24:
              _context3.prev = 24;
              _context3.t1 = _context3['catch'](18);

            case 26:
              _context3.next = 28;
              return store.dispatch((0, _flash.flashErrorMessage)({ header: 'Unable to Proceed', message: errorMessage }));

            case 28:
              _context3.next = 30;
              return _this.setLoading(false);

            case 30:
              return _context3.abrupt('return');

            case 31:
              if (res.ok) {
                _context3.next = 39;
                break;
              }

              _context3.next = 34;
              return res.text();

            case 34:
              message = _context3.sent;
              _context3.next = 37;
              return store.dispatch((0, _flash.flashErrorMessage)({ header: 'Unable to Proceed', message: message }));

            case 37:
              _context3.next = 43;
              break;

            case 39:
              _context3.next = 41;
              return store.dispatch((0, _flash.flashSuccessMessage)({ message: t('Delist reason deleted successfully') }));

            case 41:
              _context3.next = 43;
              return _this.fetchDelistReasons();

            case 43:
              _context3.next = 45;
              return _this.setLoading(false);

            case 45:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2, [[7, 13], [18, 24]]);
    }));

    _this.handleCancelDelete = function () {
      _this.setState({ deleteConfirmOpen: false, deleteReasonID: null });
    };

    _this.handleNameChange = function (reasonID, value) {
      var reasons = _this.state.reasons;

      var index = reasons.findIndex(function (r) {
        return r.id === reasonID;
      });
      if (index >= 0) {
        reasons[index].name = value;
        _this.setState({ reasons: reasons });
      }
    };

    _this.handleLabelChange = function (reasonID, value) {
      var reasons = _this.state.reasons;

      var index = reasons.findIndex(function (r) {
        return r.id === reasonID;
      });
      if (index >= 0) {
        reasons[index].label = value;
        _this.setState({ reasons: reasons });
      }
    };

    _this.handleSortEnd = function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref8) {
        var oldIndex = _ref8.oldIndex,
            newIndex = _ref8.newIndex;

        var _this$state4, reasons, token, store, t, reorderedReasons, _reorderedReasons$spl, _reorderedReasons$spl2, removed, updates, res, message;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(oldIndex === newIndex)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return');

              case 2:
                _this$state4 = _this.state, reasons = _this$state4.reasons, token = _this$state4.token;
                store = _this.context.store;
                t = _this.props.t;

                // Reorder array

                reorderedReasons = [].concat(_toConsumableArray(reasons));
                _reorderedReasons$spl = reorderedReasons.splice(oldIndex, 1), _reorderedReasons$spl2 = _slicedToArray(_reorderedReasons$spl, 1), removed = _reorderedReasons$spl2[0];

                reorderedReasons.splice(newIndex, 0, removed);

                // Update positions
                updates = reorderedReasons.map(function (reason, index) {
                  return {
                    id: reason.id,
                    position: index + 1
                  };
                });


                _this.setState({ reasons: reorderedReasons });

                _context4.next = 12;
                return _this.setLoading(true);

              case 12:
                res = void 0;
                _context4.prev = 13;
                _context4.next = 16;
                return store.dispatch((0, _fetchM.fetchM)('/settings/delist_reasons/reorder/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': token
                  },
                  body: JSON.stringify(updates)
                }));

              case 16:
                res = _context4.sent;
                _context4.next = 29;
                break;

              case 19:
                _context4.prev = 19;
                _context4.t0 = _context4['catch'](13);

                Bugsnag.notifyException(_context4.t0);
                _context4.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 24:
                _context4.next = 26;
                return _this.fetchDelistReasons();

              case 26:
                _context4.next = 28;
                return _this.setLoading(false);

              case 28:
                return _context4.abrupt('return');

              case 29:
                if (res.ok) {
                  _context4.next = 39;
                  break;
                }

                _context4.next = 32;
                return res.text();

              case 32:
                message = _context4.sent;
                _context4.next = 35;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 35:
                _context4.next = 37;
                return _this.fetchDelistReasons();

              case 37:
                _context4.next = 41;
                break;

              case 39:
                _context4.next = 41;
                return store.dispatch((0, _flash.flashSuccessMessage)({ message: t('Order updated successfully') }));

              case 41:
                _context4.next = 43;
                return _this.setLoading(false);

              case 43:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2, [[13, 19]]);
      }));

      return function (_x3) {
        return _ref7.apply(this, arguments);
      };
    }();

    _this.state = {
      loading: true,
      reasons: [],
      editingReasonID: null,
      deleteConfirmOpen: false,
      deleteReasonID: null,
      newReasonName: '',
      showAddForm: false,
      token: null
    };
    _this.validation = {};
    _this.newReasonValidation = (0, _react.createRef)();
    return _this;
  }

  _createClass(DelistReasonsList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchDelistReasons();
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchDelistReasons',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var store, t, res, message, token, reasons;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context5.prev = 5;
                _context5.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/settings/delist_reasons/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context5.sent;
                _context5.next = 19;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5['catch'](5);

                Bugsnag.notifyException(_context5.t0);
                _context5.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context5.next = 18;
                return this.setLoading(false);

              case 18:
                return _context5.abrupt('return');

              case 19:
                if (res.ok) {
                  _context5.next = 27;
                  break;
                }

                _context5.next = 22;
                return res.text();

              case 22:
                message = _context5.sent;
                _context5.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context5.next = 34;
                break;

              case 27:
                token = res.headers.get('X-Csrf-Token');
                _context5.next = 30;
                return res.json();

              case 30:
                reasons = _context5.sent;

                // Sort by position
                reasons.sort(function (a, b) {
                  return a.position - b.position;
                });
                _context5.next = 34;
                return this.setComponentState({
                  token: token,
                  reasons: reasons || []
                });

              case 34:
                _context5.next = 36;
                return this.setLoading(false);

              case 36:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[5, 11]]);
      }));

      function fetchDelistReasons() {
        return _ref9.apply(this, arguments);
      }

      return fetchDelistReasons;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props = this.props,
          t = _props.t,
          isHeadquarters = _props.isHeadquarters,
          isSuperAdmin = _props.isSuperAdmin,
          isAdminBasic = _props.isAdminBasic;
      var _state = this.state,
          reasons = _state.reasons,
          loading = _state.loading,
          showAddForm = _state.showAddForm,
          newReasonName = _state.newReasonName,
          editingReasonID = _state.editingReasonID,
          deleteConfirmOpen = _state.deleteConfirmOpen;

      var isHQ = isHeadquarters || isSuperAdmin || isAdminBasic;

      // Add validation refs
      reasons.forEach(function (reason) {
        if (!_this5.validation['reason_' + reason.id]) {
          _this5.validation['reason_' + reason.id] = (0, _react.createRef)();
        }
      });

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 20 },
            active: loading && reasons.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Message,
          { info: true },
          _react2.default.createElement(
            _semanticUiReact.Message.Header,
            null,
            t('Delist Reasons Management')
          ),
          _react2.default.createElement(
            'p',
            null,
            t('Manage the list of reasons that can be selected when delisting a unit. Default reasons cannot be edited or deleted.')
          ),
          _react2.default.createElement(
            'p',
            null,
            t('Reasons that are currently in use by delisted units cannot be deleted.')
          ),
          !isHQ && _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'em',
              null,
              t('Only HQ roles can manage delist reasons.')
            )
          )
        ),
        isHQ && _react2.default.createElement(
          _semanticUiReact.Segment,
          null,
          showAddForm ? _react2.default.createElement(
            _semanticUiReact.Form,
            null,
            _react2.default.createElement(
              _semanticUiReact.Form.Group,
              null,
              _react2.default.createElement(
                _semanticUiReact.Form.Field,
                { width: 10 },
                _react2.default.createElement(_AppForm2.default.Input, {
                  validateLabel: t('New Reason Name'),
                  name: 'newReason',
                  value: newReasonName,
                  validation: [_webValidations.required],
                  onChange: function onChange(e, _ref10) {
                    var value = _ref10.value;
                    return _this5.setState({ newReasonName: value });
                  },
                  ref: this.newReasonValidation,
                  placeholder: t('Enter reason name...')
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Field,
                { width: 3 },
                _react2.default.createElement(_semanticUiReact.Button, {
                  color: 'green',
                  icon: 'check',
                  content: t('Save'),
                  onClick: this.handleSaveNew,
                  fluid: true
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Field,
                { width: 3 },
                _react2.default.createElement(_semanticUiReact.Button, {
                  icon: 'cancel',
                  content: t('Cancel'),
                  onClick: this.handleCancelAdd,
                  fluid: true
                })
              )
            )
          ) : _react2.default.createElement(_semanticUiReact.Button, {
            color: 'blue',
            icon: 'plus',
            content: t('Add New Reason'),
            onClick: this.handleAddNew
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          { striped: true, unstackable: true, celled: true },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 1, textAlign: 'center' },
                isHQ ? t('Order') : ''
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 6, textAlign: 'center' },
                t('Reason Name')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 3, textAlign: 'center' },
                t('Default')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 3, textAlign: 'center' },
                t('Actions')
              )
            )
          ),
          reasons.length > 0 ? _react2.default.createElement(SortableList, {
            reasons: reasons,
            onSortEnd: this.handleSortEnd,
            useDragHandle: true,
            onEdit: this.handleEdit,
            onDelete: this.handleDelete,
            onNameChange: this.handleNameChange,
            onLabelChange: this.handleLabelChange,
            editingReasonID: editingReasonID,
            validation: this.validation,
            t: t,
            isHQ: isHQ,
            lockAxis: 'y',
            helperClass: 'sortable-helper'
          }) : _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 4, textAlign: 'center' },
                loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                ) : _react2.default.createElement(
                  'p',
                  null,
                  t('No delist reasons found'),
                  '.'
                )
              )
            )
          )
        ),
        _react2.default.createElement(_semanticUiReact.Confirm, {
          open: deleteConfirmOpen,
          header: t('Delete Delist Reason'),
          content: t('Are you sure you want to delete this delist reason? This action cannot be undone.'),
          cancelButton: t('Cancel'),
          confirmButton: t('Delete'),
          onCancel: this.handleCancelDelete,
          onConfirm: this.handleConfirmDelete
        })
      );
    }
  }]);

  return DelistReasonsList;
}(_react.Component);

DelistReasonsList.contextTypes = {
  store: _propTypes2.default.object
};
DelistReasonsList.propTypes = {
  isHeadquarters: _propTypes2.default.bool,
  isSuperAdmin: _propTypes2.default.bool,
  isAdminBasic: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(DelistReasonsList);

/***/ }),
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _docxTemplate = __webpack_require__(2222);

var _docxTemplate2 = _interopRequireDefault(_docxTemplate);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-danger */


var DocxTemplateGuides = function (_Component) {
  _inherits(DocxTemplateGuides, _Component);

  function DocxTemplateGuides(props) {
    _classCallCheck(this, DocxTemplateGuides);

    var _this = _possibleConstructorReturn(this, (DocxTemplateGuides.__proto__ || Object.getPrototypeOf(DocxTemplateGuides)).call(this, props));

    _initialiseProps.call(_this);

    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    var tabs = _docxTemplate2.default;
    _this.state = {
      isMobile: isMobile,
      loading: true,
      mergeTags: [],
      filteredMergeTags: [],
      currentTab: tabs[0]
    };
    return _this;
  }

  _createClass(DocxTemplateGuides, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;
      var _state = this.state,
          currentTab = _state.currentTab,
          isMobile = _state.isMobile;

      var tabs = _docxTemplate2.default;
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { verticalAlign: 'middle', className: 'merge-tag-tab' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'tab-menu' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            isMobile ? _react2.default.createElement(
              'div',
              { style: { marginBottom: '10px' } },
              _react2.default.createElement(
                'div',
                { style: { display: 'flex', gap: '8px', alignItems: 'center' } },
                _react2.default.createElement(_semanticUiReact.Dropdown, {
                  fluid: true,
                  selection: true,
                  options: tabs.map(function (tab) {
                    return {
                      key: tab.value,
                      text: t(tab.text, { ns: _translation.TRANSLATION_FILES.translation }),
                      value: tab.value
                    };
                  }),
                  value: currentTab.value,
                  onChange: function onChange(e, _ref) {
                    var value = _ref.value;
                    return _this3.handleChangeTab(e, { name: value });
                  },
                  style: { flex: 1 }
                })
              )
            ) : _react2.default.createElement(
              'div',
              { style: { overflowX: 'auto', overflowY: 'hidden', whiteSpace: 'nowrap' } },
              _react2.default.createElement(
                _semanticUiReact.Menu,
                { attached: 'top', tabular: true, style: { minWidth: 'max-content', flexWrap: 'nowrap' } },
                tabs.map(function (tab, key) {
                  return _react2.default.createElement(
                    _semanticUiReact.Menu.Item,
                    {
                      key: key,
                      name: tab.value,
                      onClick: _this3.handleChangeTab,
                      active: currentTab.value === tab.value
                    },
                    t(tab.text, { ns: _translation.TRANSLATION_FILES.translation })
                  );
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Segment,
              {
                attached: isMobile ? false : 'bottom',
                style: {
                  height: '450px',
                  overflowY: 'scroll',
                  overflowX: 'hidden',
                  borderTop: isMobile ? '1px solid #d4d4d5' : 'none'
                }
              },
              this.renderTabContent()
            )
          )
        )
      );
    }
  }]);

  return DocxTemplateGuides;
}(_react.Component);

DocxTemplateGuides.contextTypes = {
  store: _propTypes2.default.object
};
DocxTemplateGuides.propTypes = {
  t: _propTypes2.default.func
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleResize = function () {
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    if (isMobile !== _this4.state.isMobile) {
      _this4.setState({ isMobile: isMobile });
    }
  };

  this.handleChangeTab = function (e, _ref2) {
    var name = _ref2.name;

    var tabs = _docxTemplate2.default;
    var currentTab = tabs.find(function (tab) {
      return tab.value === name;
    });
    _this4.setState({
      currentTab: currentTab
    });
  };

  this.renderTabContent = function () {
    var t = _this4.props.t;
    var currentTab = _this4.state.currentTab;

    return _react2.default.createElement(
      'div',
      null,
      currentTab && currentTab.contents && currentTab.contents.map(function (content, contentIndex) {
        return _react2.default.createElement(
          'div',
          { key: contentIndex, style: { marginBottom: '32px' } },
          _react2.default.createElement(
            'h3',
            { style: { marginBottom: '8px' } },
            t(content.title, { ns: _translation.TRANSLATION_FILES.translation })
          ),
          content.sections && content.sections.length > 0 && _react2.default.createElement(
            'div',
            { style: { marginTop: '10px' } },
            content.sections.map(function (section, sectionIndex) {
              return _react2.default.createElement(
                'div',
                { key: sectionIndex, style: { marginBottom: '24px' } },
                section.description && _react2.default.createElement(
                  'p',
                  null,
                  t(section.description, { ns: _translation.TRANSLATION_FILES.translation })
                ),
                content.title === 'Supported Fonts' && _react2.default.createElement(
                  'ul',
                  { style: { paddingLeft: '35px', marginTop: '8px' } },
                  _docxTemplate.DOCX_TEMPLATE_SUPPORTED_FONTS.map(function (font, idx) {
                    return _react2.default.createElement(
                      'li',
                      { key: idx, style: { marginBottom: '4px' } },
                      font
                    );
                  })
                ),
                section.examples && section.examples.length > 0 && _react2.default.createElement(
                  'div',
                  { style: { marginLeft: '16px', marginTop: '8px' } },
                  section.examples.map(function (item, itemIndex) {
                    return _react2.default.createElement(
                      'div',
                      { key: itemIndex, style: { marginBottom: '20px' } },
                      _react2.default.createElement(
                        'h4',
                        { style: { marginBottom: '4px' } },
                        t(item.title, { ns: _translation.TRANSLATION_FILES.translation })
                      ),
                      _react2.default.createElement(
                        'div',
                        { style: { margin: '4px 0' } },
                        _react2.default.createElement(
                          'strong',
                          null,
                          t('Input', { ns: _translation.TRANSLATION_FILES.translation }),
                          ':'
                        ),
                        _react2.default.createElement(
                          'pre',
                          { style: { paddingLeft: '60px', whiteSpace: 'pre-line', margin: 0 } },
                          _react2.default.createElement('code', { dangerouslySetInnerHTML: { __html: item.syntax } })
                        )
                      ),
                      item.syntaxImage && _react2.default.createElement(
                        'div',
                        { style: { marginTop: '8px' } },
                        _react2.default.createElement('img', { src: '/assets/images/docxtemplates/' + item.syntaxImage, alt: 'syntax', style: { maxWidth: '100%', borderRadius: '8px' } })
                      ),
                      _react2.default.createElement(
                        'div',
                        { style: { margin: '4px 0' } },
                        _react2.default.createElement(
                          'strong',
                          null,
                          t('Result', { ns: _translation.TRANSLATION_FILES.translation }),
                          ':'
                        ),
                        _react2.default.createElement(
                          'pre',
                          { style: { paddingLeft: '60px', whiteSpace: 'pre-line', margin: 0 } },
                          _react2.default.createElement('code', { dangerouslySetInnerHTML: { __html: item.output } })
                        )
                      ),
                      item.outputImage && _react2.default.createElement(
                        'div',
                        { style: { marginTop: '8px' } },
                        _react2.default.createElement('img', { src: '/assets/images/docxtemplates/' + item.outputImage, alt: 'output', style: { maxWidth: '100%', borderRadius: '8px' } })
                      )
                    );
                  })
                )
              );
            })
          )
        );
      })
    );
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(DocxTemplateGuides);

/***/ }),
/* 2130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _reactSortableHoc = __webpack_require__(123);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

var _ImportFromProjectModal = __webpack_require__(2154);

var _ImportFromProjectModal2 = _interopRequireDefault(_ImportFromProjectModal);

var _UploadModal = __webpack_require__(92);

var _UploadModal2 = _interopRequireDefault(_UploadModal);

var _Form = __webpack_require__(267);

var _Form2 = _interopRequireDefault(_Form);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

var _BusinessUnitDropdownWithCategories = __webpack_require__(2198);

var _BusinessUnitDropdownWithCategories2 = _interopRequireDefault(_BusinessUnitDropdownWithCategories);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FORM_TYPE_CONFIG = {
  token_payment: { label: 'Token Payment', color: '#e67e22' },
  opportunity: { label: 'Opportunity', color: '#16a085' },
  booking: { label: 'Booking', color: '#2185d0' }
};
var DEFAULT_FORM_TYPE = FORM_TYPE_CONFIG.booking;

var DragHandle = (0, _reactSortableHoc.SortableHandle)(function (_ref) {
  var idx = _ref.idx,
      disabled = _ref.disabled;
  return _react2.default.createElement(
    'div',
    {
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '5px',
        minWidth: '40px',
        color: '#bbbbbb',
        cursor: disabled ? 'default' : 'grab',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none'
      }
    },
    _react2.default.createElement(
      'span',
      { style: { fontSize: '12px', fontWeight: 'bold' } },
      idx + 1
    ),
    _react2.default.createElement(_semanticUiReact.Icon, { size: 'small', disabled: disabled, name: 'content' })
  );
});

var SortableItem = (0, _reactSortableHoc.SortableElement)(function (_ref2) {
  var data = _ref2.data,
      idx = _ref2.idx,
      itemDisabled = _ref2.itemDisabled,
      renderActionButtons = _ref2.renderActionButtons,
      t = _ref2.t;
  return _react2.default.createElement(
    'div',
    {
      style: {
        border: '1px solid #ddd',
        borderRadius: '5px',
        marginBottom: '10px',
        padding: '10px',
        backgroundColor: '#fff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        userSelect: 'none',
        WebkitUserSelect: 'none',
        MozUserSelect: 'none',
        msUserSelect: 'none'
      }
    },
    _react2.default.createElement(
      'div',
      { style: { display: 'flex', alignItems: 'center', flex: 1 } },
      _react2.default.createElement(
        'div',
        { style: { marginRight: '10px', minWidth: '50px' } },
        _react2.default.createElement(DragHandle, { idx: idx, disabled: itemDisabled })
      ),
      _react2.default.createElement(
        'div',
        { style: { flex: 1 } },
        _react2.default.createElement(
          'div',
          { style: { fontWeight: 'bold', marginBottom: '5px' } },
          data.name
        ),
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px', color: '#666' } },
          _react2.default.createElement(_Timestamp2.default, { timestamp: data.createdAt, format: 'DD/MM/YY' })
        ),
        _react2.default.createElement(
          'div',
          { style: { fontWeight: 'bold', marginBottom: '5px' } },
          function () {
            var _ref3 = FORM_TYPE_CONFIG[data.formType] || DEFAULT_FORM_TYPE,
                label = _ref3.label,
                color = _ref3.color;

            return _react2.default.createElement(
              'span',
              {
                style: {
                  fontSize: '10px',
                  padding: '2px 6px',
                  borderRadius: '3px',
                  backgroundColor: color,
                  color: '#fff',
                  display: 'inline-block'
                }
              },
              t(label, { ns: _translation.TRANSLATION_FILES.translation })
            );
          }()
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { style: { marginLeft: '10px' } },
      renderActionButtons(data)
    )
  );
});

var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref4) {
  var items = _ref4.items,
      onDeleteItem = _ref4.onDeleteItem,
      disabled = _ref4.disabled,
      renderActionButtons = _ref4.renderActionButtons,
      t = _ref4.t;
  return _react2.default.createElement(
    _semanticUiReact.Segment,
    { className: items.length > 0 ? 'sortable' : '', textAlign: items.length > 0 ? null : 'center' },
    items.length > 0 ? items.map(function (data, index) {
      return _react2.default.createElement(SortableItem, {
        data: data,
        idx: index,
        index: index,
        key: 'item-' + (data.id || index),
        onDeleteItem: onDeleteItem,
        disabled: disabled,
        itemDisabled: disabled,
        renderActionButtons: renderActionButtons,
        t: t
      });
    }) : _react2.default.createElement(
      'p',
      null,
      t('No templates found.', { ns: _translation.TRANSLATION_FILES.translation })
    )
  );
});

var DocxTemplaterForm = function (_Component) {
  _inherits(DocxTemplaterForm, _Component);

  function DocxTemplaterForm(props) {
    _classCallCheck(this, DocxTemplaterForm);

    var _this = _possibleConstructorReturn(this, (DocxTemplaterForm.__proto__ || Object.getPrototypeOf(DocxTemplaterForm)).call(this, props));

    _initialiseProps.call(_this);

    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    _this.state = {
      isMobile: isMobile,
      loading: true,
      data: [],
      fileUploaded: {},
      showConfirmDelete: false,
      selectedTemplate: null,
      openPopupItemId: null,
      openSharablePopupId: null,
      openFormTypePopupId: null,
      companyBranches: [],
      fullCompanyBranches: []
    };
    return _this;
  }

  _createClass(DocxTemplaterForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchProjectTemplates();
      this.fetchCompanyBranches();
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchProjectTemplates',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _props, projectID, t, store, res, message, token, data, templatesWithPosition;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                _props = this.props, projectID = _props.projectID, t = _props.t;
                store = this.context.store;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/docxtemplates/projects/' + projectID + '/templates/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 19;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context.next = 33;
                break;

              case 27:
                token = res.headers.get('X-Csrf-Token');
                _context.next = 30;
                return res.json();

              case 30:
                data = _context.sent;
                templatesWithPosition = (data || []).map(function (template, index) {
                  return _extends({}, template, {
                    position: template.position || index + 1
                  });
                });

                this.setState({
                  data: templatesWithPosition,
                  token: token
                });

              case 33:
                _context.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchProjectTemplates() {
        return _ref5.apply(this, arguments);
      }

      return fetchProjectTemplates;
    }()
  }, {
    key: 'uploadTemplate',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e, body) {
        var _props2, projectID, t, store, res, errorData;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                e.preventDefault();
                _props2 = this.props, projectID = _props2.projectID, t = _props2.t;
                store = this.context.store;


                if (body instanceof FormData) {
                  body.append('form_type', 'booking');
                }

                this.setLoading(true);
                _context2.prev = 5;
                _context2.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/docxtemplates/projects/' + projectID + '/templates/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'X-Csrf-Token': this.state.token
                  },
                  body: body
                }));

              case 8:
                res = _context2.sent;


                this.setLoading(false);
                _context2.next = 12;
                return res.text();

              case 12:
                this.setState({ file: null }, function () {
                  store.dispatch((0, _flash.flashSuccessMessage)({
                    header: t('Upload Success', { ns: _translation.TRANSLATION_FILES.translation }),
                    message: t('Template successfully uploaded', { ns: _translation.TRANSLATION_FILES.translation })
                  }));
                });
                this.fetchProjectTemplates();
                this.handleUploadModalClose();
                _context2.next = 41;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2['catch'](5);

                this.setLoading(false);

                if (!(_context2.t0.res && _context2.t0.res.status === 409)) {
                  _context2.next = 35;
                  break;
                }

                _context2.prev = 21;
                _context2.next = 24;
                return _context2.t0.res.json();

              case 24:
                errorData = _context2.sent;

                if (errorData.error === 'duplicate_templates' && errorData.duplicateTemplates) {
                  store.dispatch((0, _flash.flashErrorMessage)({
                    header: t('Error: Identical file name detected', { ns: _translation.TRANSLATION_FILES.translation }),
                    list: errorData.duplicateTemplates
                  }));
                } else {
                  store.dispatch((0, _flash.flashErrorMessage)({
                    message: errorData.message || t('Failed to upload template', { ns: _translation.TRANSLATION_FILES.translation })
                  }));
                }
                _context2.next = 31;
                break;

              case 28:
                _context2.prev = 28;
                _context2.t1 = _context2['catch'](21);

                _context2.t0.res.text().then(function (message) {
                  store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                });

              case 31:
                this.setState({ file: null });
                return _context2.abrupt('return');

              case 35:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 39;
                  break;
                }

                _context2.t0.res.text().then(function (message) {
                  store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                });
                this.setState({ file: null });
                return _context2.abrupt('return');

              case 39:

                store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));
                this.setState({ file: null });

              case 41:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 17], [21, 28]]);
      }));

      function uploadTemplate(_x2, _x3) {
        return _ref6.apply(this, arguments);
      }

      return uploadTemplate;
    }()
  }, {
    key: 'fetchTemplate',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id) {
        var store, t, res, token, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                token = void 0;
                _context3.prev = 4;
                _context3.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/docxtemplates/templates/' + id + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context3.sent;
                _context3.next = 18;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](4);

                Bugsnag.notifyException(_context3.t0);
                _context3.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 15:
                _context3.next = 17;
                return this.setLoading(false);

              case 17:
                return _context3.abrupt('return', null);

              case 18:
                if (res.ok) {
                  _context3.next = 26;
                  break;
                }

                _context3.next = 21;
                return res.text();

              case 21:
                message = _context3.sent;
                _context3.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context3.next = 27;
                break;

              case 26:
                token = res.headers.get('X-Csrf-Token');

              case 27:
                return _context3.abrupt('return', token);

              case 28:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 10]]);
      }));

      function fetchTemplate(_x4) {
        return _ref7.apply(this, arguments);
      }

      return fetchTemplate;
    }()
  }, {
    key: 'downloadTemplate',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
        var t, store, res, message, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                _context4.prev = 5;
                _context4.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/docxtemplates/templates/' + id + '/download/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context4.sent;
                _context4.next = 19;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](5);

                Bugsnag.notifyException(_context4.t0);
                _context4.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context4.next = 18;
                return this.setLoading(false);

              case 18:
                return _context4.abrupt('return');

              case 19:
                if (res.ok) {
                  _context4.next = 27;
                  break;
                }

                _context4.next = 22;
                return res.text();

              case 22:
                message = _context4.sent;
                _context4.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context4.next = 31;
                break;

              case 27:
                _context4.next = 29;
                return res.json();

              case 29:
                data = _context4.sent;

                if (data.download_url) {
                  window.open(data.download_url, '_blank');
                }

              case 31:
                _context4.next = 33;
                return this.setLoading(false);

              case 33:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 11]]);
      }));

      function downloadTemplate(_x5) {
        return _ref8.apply(this, arguments);
      }

      return downloadTemplate;
    }()
  }, {
    key: 'previewTemplate',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
        var store, res, message, _message, blob, url;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context5.prev = 4;
                _context5.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/docxtemplates/templates/' + id + '/preview/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context5.sent;
                _context5.next = 23;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](4);
                _context5.next = 14;
                return this.setState({ loading: false });

              case 14:

                Bugsnag.notifyException(_context5.t0);

                if (!(_context5.t0.res && _context5.t0.res.status >= 400 && _context5.t0.res.status < 500)) {
                  _context5.next = 21;
                  break;
                }

                _context5.next = 18;
                return _context5.t0.res.text();

              case 18:
                message = _context5.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context5.abrupt('return');

              case 21:

                store.dispatch((0, _flash.flashErrorMessage)(_context5.t0));
                return _context5.abrupt('return');

              case 23:
                if (res.ok) {
                  _context5.next = 31;
                  break;
                }

                _context5.next = 26;
                return res.text();

              case 26:
                _message = _context5.sent;
                _context5.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 29:
                _context5.next = 36;
                break;

              case 31:
                _context5.next = 33;
                return res.blob();

              case 33:
                blob = _context5.sent;


                // Create a temporary URL for the Blob
                url = window.URL.createObjectURL(blob);

                // Open the PDF in a new tab for preview

                window.open(url, '_blank');

              case 36:
                _context5.next = 38;
                return this.setLoading(false);

              case 38:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[4, 10]]);
      }));

      function previewTemplate(_x6) {
        return _ref9.apply(this, arguments);
      }

      return previewTemplate;
    }()
  }, {
    key: 'deleteTemplate',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
        var store, t, token, message;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                _context6.next = 4;
                return this.fetchTemplate(id);

              case 4:
                token = _context6.sent;

                this.setLoading(true);
                _context6.prev = 6;
                _context6.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/docxtemplates/templates/' + id + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': token
                  }
                }));

              case 9:
                _context6.next = 22;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6['catch'](6);

                Bugsnag.notifyException(_context6.t0);

                if (!(_context6.t0.res.status >= 400 && _context6.t0.res.status < 500)) {
                  _context6.next = 21;
                  break;
                }

                _context6.next = 17;
                return _context6.t0.res.text();

              case 17:
                message = _context6.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                this.setLoading(false);
                return _context6.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context6.t0));

              case 22:
                this.setLoading(false);
                this.fetchProjectTemplates();
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Template successfully deleted', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 25:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[6, 11]]);
      }));

      function deleteTemplate(_x7) {
        return _ref10.apply(this, arguments);
      }

      return deleteTemplate;
    }()
  }, {
    key: 'updateTemplate',
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(tmpl) {
        var store, t, token, message;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                _context7.next = 4;
                return this.fetchTemplate(tmpl.id);

              case 4:
                token = _context7.sent;

                this.setLoading(true);
                _context7.prev = 6;
                _context7.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/docxtemplates/templates/' + tmpl.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': token
                  },
                  body: JSON.stringify(tmpl)
                }));

              case 9:
                _context7.next = 22;
                break;

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7['catch'](6);

                Bugsnag.notifyException(_context7.t0);

                if (!(_context7.t0.res.status >= 400 && _context7.t0.res.status < 500)) {
                  _context7.next = 21;
                  break;
                }

                _context7.next = 17;
                return _context7.t0.res.text();

              case 17:
                message = _context7.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                this.setLoading(false);
                return _context7.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context7.t0));

              case 22:
                this.setLoading(false);
                this.fetchProjectTemplates();
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Template successfully updated', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 25:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[6, 11]]);
      }));

      function updateTemplate(_x8) {
        return _ref11.apply(this, arguments);
      }

      return updateTemplate;
    }()
  }, {
    key: 'importTemplate',
    value: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(body) {
        var _props3, projectID, t, store, errorData;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                this.setLoading(true);
                _props3 = this.props, projectID = _props3.projectID, t = _props3.t;
                store = this.context.store;
                _context8.prev = 3;
                _context8.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/docxtemplates/projects/' + projectID + '/templates/import/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'X-Csrf-Token': this.state.token,
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(body)
                }));

              case 6:

                this.setLoading(false);
                this.fetchProjectTemplates();
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Import Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Templates successfully imported', { ns: _translation.TRANSLATION_FILES.translation })
                }));
                _context8.next = 32;
                break;

              case 11:
                _context8.prev = 11;
                _context8.t0 = _context8['catch'](3);

                this.setLoading(false);

                if (!(_context8.t0.res && _context8.t0.res.status === 409)) {
                  _context8.next = 28;
                  break;
                }

                _context8.prev = 15;
                _context8.next = 18;
                return _context8.t0.res.json();

              case 18:
                errorData = _context8.sent;

                if (errorData.error === 'duplicate_templates' && errorData.duplicateTemplates) {
                  store.dispatch((0, _flash.flashErrorMessage)({
                    header: t('Error: Identical file name detected', { ns: _translation.TRANSLATION_FILES.translation }),
                    list: errorData.duplicateTemplates
                  }));
                } else {
                  store.dispatch((0, _flash.flashErrorMessage)({
                    message: errorData.message || t('Failed to import templates', { ns: _translation.TRANSLATION_FILES.translation })
                  }));
                }
                _context8.next = 25;
                break;

              case 22:
                _context8.prev = 22;
                _context8.t1 = _context8['catch'](15);

                // If the response isn't valid JSON, fall back to text
                _context8.t0.res.text().then(function (message) {
                  store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                });

              case 25:
                return _context8.abrupt('return');

              case 28:
                if (!(_context8.t0.res && _context8.t0.res.status >= 400 && _context8.t0.res.status < 500)) {
                  _context8.next = 31;
                  break;
                }

                _context8.t0.res.text().then(function (message) {
                  store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                });
                return _context8.abrupt('return');

              case 31:

                store.dispatch((0, _flash.flashErrorMessage)(_context8.t0));

              case 32:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[3, 11], [15, 22]]);
      }));

      function importTemplate(_x9) {
        return _ref12.apply(this, arguments);
      }

      return importTemplate;
    }()
  }, {
    key: 'fetchCompanyBranches',
    value: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var store, t, res, message, branchesData, dropdownOptions;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context9.prev = 3;
                _context9.next = 6;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/company_branches/?page=all&getProjects=true', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 6:
                res = _context9.sent;
                _context9.next = 15;
                break;

              case 9:
                _context9.prev = 9;
                _context9.t0 = _context9['catch'](3);

                Bugsnag.notifyException(_context9.t0);
                _context9.next = 14;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 14:
                return _context9.abrupt('return');

              case 15:
                if (res.ok) {
                  _context9.next = 23;
                  break;
                }

                _context9.next = 18;
                return res.text();

              case 18:
                message = _context9.sent;
                _context9.next = 21;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 21:
                _context9.next = 29;
                break;

              case 23:
                _context9.next = 25;
                return res.json();

              case 25:
                branchesData = _context9.sent;


                // Create dropdown options with categories
                dropdownOptions = [];

                // Add individual branches with labels

                if (branchesData) {
                  branchesData.forEach(function (ul) {
                    var label = ul.isExternal ? t('Agency', { ns: _translation.TRANSLATION_FILES.screens }) : t('Internal', { ns: _translation.TRANSLATION_FILES.constants });
                    var branch = {
                      content: _react2.default.createElement(
                        _semanticUiReact.Header,
                        { as: 'h5', style: { margin: 0 } },
                        _react2.default.createElement(
                          'div',
                          { style: { display: 'flex', justifyContent: 'space-between', width: '100%' } },
                          _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                              'div',
                              null,
                              ul.shortName
                            ),
                            _react2.default.createElement(
                              'div',
                              { style: { fontSize: '0.8em', color: 'gray' } },
                              ul.name
                            )
                          )
                        )
                      ),
                      description: ul.isExternal ? t('Agency', { ns: _translation.TRANSLATION_FILES.screens }) : t('Internal', { ns: _translation.TRANSLATION_FILES.constants }),
                      key: ul.id,
                      name: ul.shortName,
                      text: ul.shortName + ' | ' + label,
                      value: ul.id
                    };
                    dropdownOptions.push(branch);
                  });
                }

                this.setState({
                  companyBranches: dropdownOptions,
                  fullCompanyBranches: branchesData || []
                });

              case 29:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[3, 9]]);
      }));

      function fetchCompanyBranches() {
        return _ref13.apply(this, arguments);
      }

      return fetchCompanyBranches;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          data = _state.data,
          isMobile = _state.isMobile,
          selectedTemplate = _state.selectedTemplate;
      var _props4 = this.props,
          projectID = _props4.projectID,
          t = _props4.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        { style: { maxWidth: '700px' } },
        _react2.default.createElement(_DeleteConfirm2.default, {
          open: this.state.showConfirmDelete,
          onClose: this.handleCancelDelete,
          onConfirm: this.handleConfirmDelete,
          name: selectedTemplate ? selectedTemplate.name : ''
        }),
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', marginBottom: '12px' } },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              { style: { fontWeight: 'bold' } },
              '\xA0\xA0',
              t('Manage Template', { ns: _translation.TRANSLATION_FILES.translation })
            ),
            _react2.default.createElement(
              'i',
              null,
              '\xA0\xA0',
              isMobile ? '(.docx)' : t('(Only applicable to .docx format)', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { marginLeft: 'auto' } },
            _react2.default.createElement(_UploadModal2.default, {
              trigger: _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  style: { marginLeft: '0.5em' },
                  primary: true,
                  icon: isMobile,
                  type: 'button'
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'upload' }),
                !isMobile && t('Upload File', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              ref: function ref(_ref14) {
                _this3.uploadModal = _ref14;
              },
              header: '.docx files',
              loading: this.state.loading,
              onConfirm: function onConfirm(e, file) {
                _this3.uploadTemplate(e, file);
              },
              onClose: this.handleUploadModalClose,
              primary: false,
              content: function content(opt) {
                return _react2.default.createElement(_Form2.default, {
                  fileType: 'docx',
                  btnText: t('Files', { ns: _translation.TRANSLATION_FILES.translation }),
                  loading: _this3.state.loading,
                  onSubmit: opt.onConfirm
                });
              }
            }),
            _react2.default.createElement(_ImportFromProjectModal2.default, {
              projectID: projectID,
              onConfirm: this.handleConfirmImport,
              trigger: _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  style: { marginLeft: '5px' },
                  primary: true,
                  icon: isMobile,
                  type: 'button'
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'folder open' }),
                !isMobile && t('Import from project', { ns: _translation.TRANSLATION_FILES.translation })
              )
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { marginTop: '20px' } },
          _react2.default.createElement(SortableList, {
            helperClass: 'docxTemplates isSorting',
            items: this.getSortedData(data),
            lockAxis: 'y',
            lockToContainerEdges: true,
            onSortEnd: this.onSortEnd,
            useDragHandle: true,
            disabled: this.state.loading,
            renderActionButtons: this.renderActionButtons,
            t: t
          }),
          this.state.loading && _react2.default.createElement(
            _semanticUiReact.Segment,
            { textAlign: 'center' },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { active: true, inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          )
        )
      );
    }
  }]);

  return DocxTemplaterForm;
}(_react.Component);

DocxTemplaterForm.contextTypes = {
  store: _propTypes2.default.object
};
DocxTemplaterForm.propTypes = {
  projectID: _propTypes2.default.string,
  t: _propTypes2.default.func,
  project: _propTypes2.default.shape({
    printType: _propTypes2.default.string,
    sharedToBankerForms: _propTypes2.default.arrayOf(_propTypes2.default.string)
  }),
  onSubmitBankerForm: _propTypes2.default.func
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleUploadModalClose = function () {
    _this4.uploadModal.close();
  };

  this.handleCancelDelete = function (e) {
    e.preventDefault();
    _this4.setState({
      showConfirmDelete: false,
      selectedTemplate: null
    });
  };

  this.handleDelete = function (e, selectedTemplate) {
    e.preventDefault();
    _this4.setState({
      selectedTemplate: selectedTemplate
    }, function () {
      _this4.setState({
        showConfirmDelete: true
      });
    });
  };

  this.handleConfirmDelete = function (e) {
    e.preventDefault();
    var selectedTemplate = _this4.state.selectedTemplate;

    _this4.setState({
      showConfirmDelete: false
    }, function () {
      _this4.deleteTemplate(selectedTemplate.id);
    });
  };

  this.handleDownload = function (e, selectedTemplate) {
    e.preventDefault();
    _this4.downloadTemplate(selectedTemplate.id);
  };

  this.handlePreview = function (e, selectedTemplate) {
    e.preventDefault();
    _this4.previewTemplate(selectedTemplate.id);
  };

  this.handleConfirmImport = function (body) {
    _this4.importTemplate(body);
  };

  this.handleEnableTemplate = function (e, template) {
    e.preventDefault();
    var newTemp = _extends({}, template, {
      isEnabled: !template.isEnabled
    });
    _this4.updateTemplate(newTemp);
  };

  this.handleResize = function () {
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    var isTablet = windowWidth >= 768 && windowWidth < 992;
    if (isMobile !== _this4.state.isMobile) {
      _this4.setState({ isMobile: isMobile });
    }
    if (isTablet !== _this4.state.isTablet) {
      _this4.setState({ isTablet: isTablet });
    }
  };

  this.onSortEnd = function (_ref15) {
    var oldIndex = _ref15.oldIndex,
        newIndex = _ref15.newIndex;
    return _this4.sortDataByIndex((0, _reactSortableHoc.arrayMove)(_this4.state.data, oldIndex, newIndex));
  };

  this.getSortedData = function (data) {
    return data.sort(function (a, b) {
      return (a.position || 0) - (b.position || 0);
    });
  };

  this.sortDataByIndex = function (newData) {
    var data = newData;
    data.forEach(function (d, index) {
      data[index].position = index + 1;
    });
    _this4.setState({ data: data }, function () {
      _this4.updateTemplatePositions();
    });
  };

  this.updateTemplatePositions = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
    var store, t, updates, updatePromises;
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            store = _this4.context.store;
            t = _this4.props.t;
            _context11.prev = 2;
            updates = _this4.state.data.map(function (template) {
              return {
                id: template.id,
                position: template.position
              };
            });
            updatePromises = updates.map(function () {
              var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(update) {
                var token;
                return regeneratorRuntime.wrap(function _callee10$(_context10) {
                  while (1) {
                    switch (_context10.prev = _context10.next) {
                      case 0:
                        _context10.next = 2;
                        return _this4.fetchTemplate(update.id);

                      case 2:
                        token = _context10.sent;
                        return _context10.abrupt('return', store.dispatch((0, _fetchM.fetchM)('/docxtemplates/templates/' + update.id + '/', {
                          credentials: 'include',
                          method: 'PUT',
                          headers: {
                            'Content-Type': 'application/json',
                            'X-Csrf-Token': token
                          },
                          body: JSON.stringify({ position: update.position })
                        })));

                      case 4:
                      case 'end':
                        return _context10.stop();
                    }
                  }
                }, _callee10, _this4);
              }));

              return function (_x10) {
                return _ref17.apply(this, arguments);
              };
            }());
            _context11.next = 7;
            return Promise.all(updatePromises);

          case 7:
            _context11.next = 13;
            break;

          case 9:
            _context11.prev = 9;
            _context11.t0 = _context11['catch'](2);

            Bugsnag.notifyException(_context11.t0);
            store.dispatch((0, _flash.flashErrorMessage)({
              message: t('Failed to update template positions', { ns: _translation.TRANSLATION_FILES.translation })
            }));

          case 13:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, _this4, [[2, 9]]);
  }));

  this.resolveSharedToBanker = function () {
    var project = _this4.props.project;

    if (!project) {
      return [];
    }
    var sharedToBankerForms = Array.isArray(project.sharedToBankerForms) ? project.sharedToBankerForms : [];
    return sharedToBankerForms.filter(Boolean);
  };

  this.resolveTemplateFormType = function (template) {
    return template && template.formType || 'booking';
  };

  this.computeNextBankerFormState = function (template) {
    var project = _this4.props.project;
    var data = _this4.state.data;

    var templateID = template.id;
    var formType = _this4.resolveTemplateFormType(template);
    var currentPrintType = project && project.printType || '';
    var currentSharedToBanker = _this4.resolveSharedToBanker();
    var isSelected = formType === 'booking' ? currentPrintType === templateID || currentSharedToBanker.includes(templateID) : currentSharedToBanker.includes(templateID);

    var nextPrintType = currentPrintType;
    var nextSharedToBanker = currentSharedToBanker.filter(function (id) {
      return id !== templateID;
    });

    if (isSelected) {
      if (formType === 'booking' && currentPrintType === templateID) {
        nextPrintType = '';
      }
    } else {
      var sameFormTypeIDs = (data || []).filter(function (item) {
        return _this4.resolveTemplateFormType(item) === formType;
      }).map(function (item) {
        return item.id;
      });

      nextSharedToBanker = nextSharedToBanker.filter(function (id) {
        return !sameFormTypeIDs.includes(id);
      });
      nextSharedToBanker.push(templateID);

      if (formType === 'booking') {
        nextPrintType = templateID;
      }
    }

    if (nextPrintType && !nextSharedToBanker.includes(nextPrintType)) {
      nextSharedToBanker.push(nextPrintType);
    }

    return {
      printType: nextPrintType,
      sharedToBankerForms: Array.from(new Set(nextSharedToBanker))
    };
  };

  this.handleUpdateBankerTemplate = function (e, template) {
    e.preventDefault();
    var nextState = _this4.computeNextBankerFormState(template);
    _this4.props.onSubmitBankerForm(nextState);
  };

  this.checkIsBankerFormTemplate = function (template) {
    var project = _this4.props.project;

    var sharedToBanker = _this4.resolveSharedToBanker();
    var formType = _this4.resolveTemplateFormType(template);

    if (formType === 'booking') {
      return project.printType === template.id || sharedToBanker.includes(template.id);
    }
    return sharedToBanker.includes(template.id);
  };

  this.handleStatusChange = function () {
    var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(itemId, statusType, isChecked) {
      var template, updatedTemplate;
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              template = _this4.state.data.find(function (item) {
                return item.id === itemId;
              });

              if (template) {
                _context12.next = 3;
                break;
              }

              return _context12.abrupt('return');

            case 3:
              updatedTemplate = _extends({}, template);
              _context12.t0 = statusType;
              _context12.next = _context12.t0 === 'reserved' ? 7 : _context12.t0 === 'booked' ? 9 : _context12.t0 === 'cancelled' ? 11 : _context12.t0 === 'sold' ? 13 : _context12.t0 === 'lawyer' ? 15 : _context12.t0 === 'srb' ? 17 : 19;
              break;

            case 7:
              updatedTemplate.isEnabledOnReserved = isChecked;
              return _context12.abrupt('break', 20);

            case 9:
              updatedTemplate.isEnabledOnBooked = isChecked;
              return _context12.abrupt('break', 20);

            case 11:
              updatedTemplate.isEnabledOnCancelled = isChecked;
              return _context12.abrupt('break', 20);

            case 13:
              updatedTemplate.isEnabledOnSold = isChecked;
              return _context12.abrupt('break', 20);

            case 15:
              updatedTemplate.isVisibleToLawyer = isChecked;
              return _context12.abrupt('break', 20);

            case 17:
              updatedTemplate.isVisibleToSrb = isChecked;
              return _context12.abrupt('break', 20);

            case 19:
              return _context12.abrupt('break', 20);

            case 20:
              _context12.next = 22;
              return _this4.updateTemplate(updatedTemplate);

            case 22:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this4);
    }));

    return function (_x11, _x12, _x13) {
      return _ref18.apply(this, arguments);
    };
  }();

  this.handleBusinessUnitChange = function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(itemId, businessUnitIds) {
      var template, updatedTemplate;
      return regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              template = _this4.state.data.find(function (item) {
                return item.id === itemId;
              });

              if (template) {
                _context13.next = 3;
                break;
              }

              return _context13.abrupt('return');

            case 3:
              updatedTemplate = _extends({}, template, {
                visibleToBusinessUnits: businessUnitIds
              });
              _context13.next = 6;
              return _this4.updateTemplate(updatedTemplate);

            case 6:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this4);
    }));

    return function (_x14, _x15) {
      return _ref19.apply(this, arguments);
    };
  }();

  this.handleFormTypeChange = function () {
    var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(itemId, formType) {
      var template, originalFetchProjectTemplates, existing;
      return regeneratorRuntime.wrap(function _callee15$(_context15) {
        while (1) {
          switch (_context15.prev = _context15.next) {
            case 0:
              template = _this4.state.data.find(function (item) {
                return item.id === itemId;
              });

              if (template) {
                _context15.next = 3;
                break;
              }

              return _context15.abrupt('return');

            case 3:
              _this4.setState({ openFormTypePopupId: null });
              originalFetchProjectTemplates = _this4.fetchProjectTemplates;

              _this4.fetchProjectTemplates = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
                return regeneratorRuntime.wrap(function _callee14$(_context14) {
                  while (1) {
                    switch (_context14.prev = _context14.next) {
                      case 0:
                      case 'end':
                        return _context14.stop();
                    }
                  }
                }, _callee14, _this4);
              }));
              _context15.prev = 6;

              if (!(formType === 'token_payment')) {
                _context15.next = 12;
                break;
              }

              existing = _this4.state.data.find(function (templateItem) {
                return templateItem.id !== itemId && templateItem.formType === 'token_payment';
              });

              if (!existing) {
                _context15.next = 12;
                break;
              }

              _context15.next = 12;
              return _this4.updateTemplate(_extends({}, existing, { formType: 'booking' }));

            case 12:
              _context15.next = 14;
              return _this4.updateTemplate(_extends({}, template, { formType: formType }));

            case 14:
              _context15.prev = 14;

              _this4.fetchProjectTemplates = originalFetchProjectTemplates;
              return _context15.finish(14);

            case 17:
              _context15.next = 19;
              return _this4.fetchProjectTemplates();

            case 19:
            case 'end':
              return _context15.stop();
          }
        }
      }, _callee15, _this4, [[6,, 14, 17]]);
    }));

    return function (_x16, _x17) {
      return _ref20.apply(this, arguments);
    };
  }();

  this.renderActionButtons = function (item) {
    var t = _this4.props.t;
    var _state2 = _this4.state,
        loading = _state2.loading,
        isMobile = _state2.isMobile;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(
        'div',
        { className: 'ui buttons', style: { marginRight: '5px' } },
        _react2.default.createElement(_semanticUiReact.Popup, {
          content: t('Visible in bookings', { ns: _translation.TRANSLATION_FILES.translation }),
          disabled: loading,
          size: 'mini',
          trigger: _react2.default.createElement(
            _semanticUiReact.Button,
            {
              icon: true,
              color: item.isEnabled ? 'blue' : undefined,
              size: 'small',
              compact: true,
              style: {
                padding: '8px',
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                margin: 0
              },
              onClick: function onClick(e) {
                return _this4.handleEnableTemplate(e, item);
              }
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'eye', color: item.isEnabled ? '' : 'blue' })
          )
        }),
        _react2.default.createElement(
          _semanticUiReact.Popup
          // content="Set status"
          ,
          { disabled: loading || !item.isEnabled,
            size: 'mini',
            flowing: true,
            on: 'click',
            position: isMobile ? 'bottom left' : 'bottom center',
            className: 'status-popup',
            open: _this4.state.openPopupItemId === item.id,
            onOpen: function onOpen() {
              return _this4.setState({ openPopupItemId: item.id });
            },
            onClose: function onClose() {
              return _this4.setState({ openPopupItemId: null });
            },
            trigger: _react2.default.createElement(
              _semanticUiReact.Button,
              {
                type: 'button',
                icon: true,
                color: item.isEnabled ? 'blue' : undefined,
                size: 'small',
                compact: true,
                style: {
                  padding: '8px',
                  borderTopLeftRadius: 0,
                  borderBottomLeftRadius: 0,
                  margin: 0
                },
                disabled: !item.isEnabled
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'dropdown', style: { margin: 0 } })
            )
          },
          _react2.default.createElement(
            'div',
            { style: { padding: '5px', minWidth: '300px', maxWidth: '300px' } },
            _react2.default.createElement(
              'div',
              { style: { fontWeight: 'bold', marginBottom: '8px' } },
              t('Visible in booking status', { ns: _translation.TRANSLATION_FILES.translation })
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', alignItems: 'center', marginBottom: '8px' } },
              _react2.default.createElement(
                'div',
                { className: 'ui checkbox', style: { width: 'auto' } },
                _react2.default.createElement('input', {
                  type: 'checkbox',
                  id: 'reserved-' + item.id,
                  name: 'reserved',
                  checked: item && item.isEnabledOnReserved || false,
                  onChange: function onChange(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    _this4.handleStatusChange(item.id, 'reserved', e.target.checked);
                  }
                }),
                _react2.default.createElement('label', { htmlFor: 'reserved-' + item.id })
              ),
              _react2.default.createElement(
                'div',
                { style: { flex: 1, paddingLeft: '8px' } },
                _react2.default.createElement(
                  'span',
                  null,
                  t('Reserved', { ns: _translation.TRANSLATION_FILES.constants })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', alignItems: 'center', marginBottom: '8px' } },
              _react2.default.createElement(
                'div',
                { className: 'ui checkbox', style: { width: 'auto' } },
                _react2.default.createElement('input', {
                  type: 'checkbox',
                  id: 'booked-' + item.id,
                  name: 'booked',
                  checked: item && item.isEnabledOnBooked || false,
                  onChange: function onChange(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    _this4.handleStatusChange(item.id, 'booked', e.target.checked);
                  }
                }),
                _react2.default.createElement('label', { htmlFor: 'booked-' + item.id })
              ),
              _react2.default.createElement(
                'div',
                { style: { flex: 1, paddingLeft: '8px' } },
                _react2.default.createElement(
                  'span',
                  null,
                  t('Booked', { ns: _translation.TRANSLATION_FILES.constants })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', alignItems: 'center', marginBottom: '8px' } },
              _react2.default.createElement(
                'div',
                { className: 'ui checkbox', style: { width: 'auto' } },
                _react2.default.createElement('input', {
                  type: 'checkbox',
                  id: 'sold-' + item.id,
                  name: 'sold',
                  checked: item && item.isEnabledOnSold || false,
                  onChange: function onChange(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    _this4.handleStatusChange(item.id, 'sold', e.target.checked);
                  }
                }),
                _react2.default.createElement('label', { htmlFor: 'sold-' + item.id })
              ),
              _react2.default.createElement(
                'div',
                { style: { flex: 1, paddingLeft: '8px' } },
                _react2.default.createElement(
                  'span',
                  null,
                  t('Sold', { ns: _translation.TRANSLATION_FILES.constants })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', alignItems: 'center', marginBottom: '8px' } },
              _react2.default.createElement(
                'div',
                { className: 'ui checkbox', style: { width: 'auto' } },
                _react2.default.createElement('input', {
                  type: 'checkbox',
                  id: 'cancelled-' + item.id,
                  name: 'cancelled',
                  checked: item && item.isEnabledOnCancelled || false,
                  onChange: function onChange(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    _this4.handleStatusChange(item.id, 'cancelled', e.target.checked);
                  }
                }),
                _react2.default.createElement('label', { htmlFor: 'cancelled-' + item.id })
              ),
              _react2.default.createElement(
                'div',
                { style: { flex: 1, paddingLeft: '8px' } },
                _react2.default.createElement(
                  'span',
                  null,
                  'Cancelled'
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { marginTop: '8px', paddingTop: '8px', borderTop: '1px solid #e1e1e1' } },
              _react2.default.createElement(_BusinessUnitDropdownWithCategories2.default, {
                placeholder: t('Select Business Units', { ns: _translation.TRANSLATION_FILES.translation }),
                value: item && item.visibleToBusinessUnits || [],
                onChange: function onChange(businessUnitIds) {
                  _this4.handleBusinessUnitChange(item.id, businessUnitIds);
                },
                style: { maxWidth: '280px' },
                companyBranches: _this4.state.companyBranches,
                fullCompanyBranches: _this4.state.fullCompanyBranches
              })
            )
          )
        )
      ),
      _react2.default.createElement(_semanticUiReact.Popup, {
        content: t('Shareable to bankers (maximum one form per form type)', { ns: _translation.TRANSLATION_FILES.translation }),
        disabled: loading,
        size: 'mini',
        trigger: _react2.default.createElement(
          _semanticUiReact.Button,
          {
            icon: true,
            color: _this4.checkIsBankerFormTemplate(item) ? 'blue' : null,
            size: 'small',
            compact: true,
            style: { padding: '8px', marginLeft: '5px' },
            onClick: function onClick(e) {
              return _this4.handleUpdateBankerTemplate(e, item);
            }
          },
          _react2.default.createElement(_semanticUiReact.Icon, {
            name: 'university',
            color: _this4.checkIsBankerFormTemplate(item) ? null : 'blue'
          })
        )
      }),
      _react2.default.createElement(
        _semanticUiReact.Popup,
        {
          disabled: loading,
          size: 'mini',
          flowing: true,
          on: 'click',
          position: 'bottom center',
          className: 'status-popup',
          open: _this4.state.openFormTypePopupId === item.id,
          onOpen: function onOpen() {
            return _this4.setState({ openFormTypePopupId: item.id });
          },
          onClose: function onClose() {
            return _this4.setState({ openFormTypePopupId: null });
          },
          trigger: _react2.default.createElement(
            _semanticUiReact.Button,
            {
              type: 'button',
              icon: true,
              color: 'blue',
              size: 'small',
              compact: true,
              style: { padding: '8px', marginLeft: '5px' }
            },
            _react2.default.createElement(_semanticUiReact.Icon, {
              name: 'file alternate outline',
              style: { margin: 0 }
            })
          )
        },
        _react2.default.createElement(
          'div',
          { style: { padding: '5px', minWidth: '150px' } },
          _react2.default.createElement(
            'div',
            { style: { fontWeight: 'bold', marginBottom: '8px' } },
            t('Form Type', { ns: _translation.TRANSLATION_FILES.translation })
          ),
          [{ value: 'booking', label: 'Booking' }, { value: 'opportunity', label: 'Opportunity' }, { value: 'token_payment', label: 'Token Payment' }].map(function (_ref22) {
            var value = _ref22.value,
                label = _ref22.label;
            return _react2.default.createElement(
              'div',
              {
                key: value,
                className: 'ui checkbox',
                style: { display: 'block', marginBottom: '8px' }
              },
              _react2.default.createElement('input', {
                type: 'radio',
                id: 'formtype-' + value + '-' + item.id,
                name: 'formtype-' + item.id,
                checked: (item.formType || 'booking') === value,
                onChange: function onChange() {
                  return _this4.handleFormTypeChange(item.id, value);
                }
              }),
              _react2.default.createElement(
                'label',
                { htmlFor: 'formtype-' + value + '-' + item.id },
                t(label, { ns: _translation.TRANSLATION_FILES.translation })
              )
            );
          })
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Popup
        // content="Share options"
        ,
        { disabled: loading,
          size: 'mini',
          flowing: true,
          on: 'click',
          position: 'bottom center',
          className: 'status-popup',
          open: _this4.state.openSharablePopupId === item.id,
          onOpen: function onOpen() {
            return _this4.setState({ openSharablePopupId: item.id });
          },
          onClose: function onClose() {
            return _this4.setState({ openSharablePopupId: null });
          },
          trigger: _react2.default.createElement(
            _semanticUiReact.Button,
            {
              type: 'button',
              icon: true,
              color: item.isEnabled ? 'blue' : undefined,
              size: 'small',
              compact: true,
              style: { padding: '8px', marginLeft: '5px' },
              disabled: !item.isEnabled
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'share square', style: { margin: 0 } })
          )
        },
        _react2.default.createElement(
          'div',
          { style: { padding: '5px', minWidth: '120px' } },
          _react2.default.createElement(
            'div',
            { style: { fontWeight: 'bold', marginBottom: '8px' } },
            t('Shareable to', { ns: _translation.TRANSLATION_FILES.translation }),
            ':'
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'ui checkbox',
              style: { display: 'block', marginBottom: '8px' }
            },
            _react2.default.createElement('input', {
              type: 'checkbox',
              id: 'lawyer-' + item.id,
              name: 'lawyer',
              checked: item && item.isVisibleToLawyer || false,
              onChange: function onChange(e) {
                e.preventDefault();
                e.stopPropagation();
                _this4.handleStatusChange(item.id, 'lawyer', e.target.checked);
              }
            }),
            _react2.default.createElement(
              'label',
              { htmlFor: 'lawyer-' + item.id },
              t('Lawyer', { ns: _translation.TRANSLATION_FILES.screens })
            )
          ),
          _react2.default.createElement(
            'div',
            {
              className: 'ui checkbox',
              style: { display: 'block', marginBottom: '8px' }
            },
            _react2.default.createElement('input', {
              type: 'checkbox',
              id: 'srb-' + item.id,
              name: 'srb',
              checked: item && item.isVisibleToSrb || false,
              onChange: function onChange(e) {
                e.preventDefault();
                e.stopPropagation();
                _this4.handleStatusChange(item.id, 'srb', e.target.checked);
              }
            }),
            _react2.default.createElement(
              'label',
              { htmlFor: 'srb-' + item.id },
              t('Showroom for Buyer', { ns: _translation.TRANSLATION_FILES.translation })
            )
          )
        )
      ),
      _react2.default.createElement(_semanticUiReact.Popup, {
        content: t('Preview', { ns: _translation.TRANSLATION_FILES.screens }),
        disabled: loading,
        size: 'mini',
        trigger: _react2.default.createElement(
          _semanticUiReact.Button,
          {
            icon: true,
            color: 'blue',
            size: 'small',
            compact: true,
            style: { padding: '8px', marginLeft: '5px' },
            onClick: function onClick(e) {
              return _this4.handlePreview(e, item);
            }
          },
          _react2.default.createElement(
            'svg',
            {
              xmlns: 'http://www.w3.org/2000/svg',
              width: '15',
              height: '24',
              viewBox: '0 0 24 24',
              fill: 'currentColor',
              style: { fontSize: '15px', margin: -3 },
              className: 'icon icon-tabler icons-tabler-filled icon-tabler-zoom-code'
            },
            _react2.default.createElement(
              'g',
              { transform: 'scale(1.2) translate(-2 -2)' },
              _react2.default.createElement('path', { stroke: 'none', d: 'M0 0h24v24H0z', fill: 'none' }),
              _react2.default.createElement('path', { d: 'M14 3.072a8 8 0 0 1 2.32 11.834l5.387 5.387a1 1 0 0 1 -1.414 1.414l-5.388 -5.387a8 8 0 0 1 -12.905 -6.32l.005 -.285a8 8 0 0 1 11.995 -6.643m-5.293 4.22a1 1 0 0 0 -1.414 0l-2 2a1 1 0 0 0 0 1.415l2 2a1 1 0 0 0 1.414 0l.083 -.094a1 1 0 0 0 -.083 -1.32l-1.292 -1.293l1.292 -1.293a1 1 0 0 0 0 -1.414m4 0a1 1 0 0 0 -1.414 0l-.083 .095a1 1 0 0 0 .083 1.32l1.292 1.292l-1.292 1.293a1 1 0 0 0 1.414 1.414l2 -2a1 1 0 0 0 0 -1.414z' })
            )
          )
        )
      }),
      _react2.default.createElement(_semanticUiReact.Popup, {
        content: t('Download', { ns: _translation.TRANSLATION_FILES.translation }),
        disabled: loading,
        size: 'mini',
        trigger: _react2.default.createElement(
          _semanticUiReact.Button,
          {
            icon: true,
            color: 'blue',
            size: 'small',
            compact: true,
            style: { padding: '8px', marginLeft: '5px' },
            onClick: function onClick(e) {
              return _this4.handleDownload(e, item);
            }
          },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'download', style: { margin: 0 } })
        )
      }),
      _react2.default.createElement(_semanticUiReact.Popup, {
        content: t('Delete', { ns: _translation.TRANSLATION_FILES.translation }),
        disabled: loading,
        size: 'mini',
        trigger: _react2.default.createElement(
          _semanticUiReact.Button,
          {
            icon: true,
            color: 'red',
            size: 'small',
            compact: true,
            style: { padding: '8px', marginLeft: '5px' },
            onClick: function onClick(e) {
              return _this4.handleDelete(e, item);
            },
            disabled: item.docxFileKey && item.docxFileKey.indexOf('templates/default_templates/') === 0
          },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'trash', style: { margin: 0 } })
        )
      })
    );
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(DocxTemplaterForm);

/***/ }),
/* 2131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */
/* eslint-disable max-len */


var DropdownInputNumber = function (_Component) {
  _inherits(DropdownInputNumber, _Component);

  function DropdownInputNumber(props) {
    _classCallCheck(this, DropdownInputNumber);

    var _this = _possibleConstructorReturn(this, (DropdownInputNumber.__proto__ || Object.getPrototypeOf(DropdownInputNumber)).call(this, props));

    _initialiseProps.call(_this);

    var state = DropdownInputNumber.getPropsToState(props);
    _this.state = _extends({}, state);
    return _this;
  }

  _createClass(DropdownInputNumber, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = DropdownInputNumber.getPropsToState(nextProps);
      if (JSON.stringify(this.state.value) !== JSON.stringify(state.value) && state.value !== '') {
        this.setState(_extends({}, state));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          disabled = _props.disabled,
          label = _props.label,
          name = _props.name,
          placeholder = _props.placeholder;
      var _state = this.state,
          presetOptions = _state.presetOptions,
          value = _state.value;

      return _react2.default.createElement(_semanticUiReact.Form.Select, {
        label: label,
        options: presetOptions,
        placeholder: placeholder,
        name: name,
        search: true,
        selection: true,
        fluid: true,
        allowAdditions: true,
        onAddItem: this.handleAddition,
        value: value,
        onChange: this.handleChange,
        disabled: disabled
      });
    }
  }]);

  return DropdownInputNumber;
}(_react.Component);

DropdownInputNumber.propTypes = {
  disabled: _propTypes2.default.bool,
  label: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string.isRequired,
  minValue: _propTypes2.default.number,
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  presetOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string,
    text: _propTypes2.default.string,
    value: _propTypes2.default.string
  }))
};
DropdownInputNumber.defaultProps = {
  minValue: 1
};

DropdownInputNumber.getPropsToState = function (props) {
  var newProps = {
    presetOptions: [].concat(_toConsumableArray(DropdownInputNumber.defaultOptions))
  };
  if (props.presetOptions) {
    newProps.presetOptions = [].concat(_toConsumableArray(props.presetOptions));
  }
  if (props.value) {
    var optionExists = newProps.presetOptions.findIndex(function (po) {
      return po.value === props.value;
    });
    if (optionExists === -1) {
      newProps.presetOptions = [{ key: props.value, text: props.value, value: props.value }].concat(_toConsumableArray(newProps.presetOptions));
    }
    newProps.value = props.value;
  }
  return newProps;
};

DropdownInputNumber.defaultOptions = [{ key: 'o15', text: '15 (15 Minutes)', value: '15' }, { key: 'o30', text: '30 (30 Minutes)', value: '30' }, { key: 'o60', text: '60 (1 Hour)', value: '60' }, { key: 'o180', text: '180 (3 Hours)', value: '180' }, { key: 'o360', text: '360 (6 Hours)', value: '360' }, { key: 'o720', text: '720 (12 Hours)', value: '720' }, { key: 'o1440', text: '1440 (1 Day)', value: '1440' }];

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleAddition = function (e, _ref) {
    var value = _ref.value;

    var numberVal = value.replace(/\D/g, '').substring(0, 9);
    if (!numberVal) numberVal = _this2.props.minValue;
    var presetOptions = _this2.state.presetOptions;

    var exists = _this2.state.presetOptions.findIndex(function (co) {
      return co.value === numberVal;
    });
    if (exists === -1) {
      presetOptions = [{ key: numberVal, text: numberVal, value: numberVal }].concat(_toConsumableArray(_this2.state.presetOptions));
    }
    _this2.setState({
      presetOptions: presetOptions,
      value: numberVal
    });
  };

  this.handleChange = function (e, d) {
    _this2.setState({ value: d.value }, function () {
      if (_this2.props.onChange) _this2.props.onChange(d.value, d);
    });
  };
};

exports.default = DropdownInputNumber;

/***/ }),
/* 2132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _apps = __webpack_require__(263);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DropdownMenu = function (_Component) {
  _inherits(DropdownMenu, _Component);

  function DropdownMenu() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DropdownMenu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DropdownMenu.__proto__ || Object.getPrototypeOf(DropdownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.handleNavigatePage = function (e, d) {
      e.preventDefault();
      var store = _this.context.store;

      if (d && d.value) {
        window.location.href = d.value;
      } else {
        store.dispatch((0, _reactRouterRedux.push)('/'));
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DropdownMenu, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isSiteplan = _props.isSiteplan,
          apps = _props.apps;

      var appsAccess = apps ? apps.filter(function (app) {
        if (isSiteplan) {
          return app.hasAccess && app.appID !== _apps.SHOWROOM;
        }
        return app.hasAccess;
      }) : [];

      return _react2.default.createElement(
        _semanticUiReact.Dropdown,
        {
          className: 'top-menu-dropdown',
          text: 'Showroom',
          selectOnBlur: false
        },
        _react2.default.createElement(
          _semanticUiReact.Dropdown.Menu,
          { style: { zIndex: 60 } },
          Array.isArray(appsAccess) && appsAccess.length > 0 ? appsAccess.map(function (app) {
            return _react2.default.createElement(
              _semanticUiReact.Dropdown.Item,
              {
                name: app.app.shortName,
                key: app.appID,
                value: app.appID === 'showroom' ? null : app.webURL,
                onClick: _this2.handleNavigatePage,
                active: app.appID === 'showroom'
              },
              app.app.shortName
            );
          }) : null
        )
      );
    }
  }]);

  return DropdownMenu;
}(_react.Component);

DropdownMenu.contextTypes = {
  store: _propTypes2.default.object
};
DropdownMenu.propTypes = {
  isSiteplan: _propTypes2.default.bool,
  apps: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    appID: _propTypes2.default.string.isRequired,
    webURL: _propTypes2.default.string,
    app: _propTypes2.default.shape({
      shortName: _propTypes2.default.string.isRequired
    }).isRequired
  }))
};
exports.default = DropdownMenu;

/***/ }),
/* 2133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _vietnamPricing = __webpack_require__(197);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */


var EditFeePackageModal = function (_Component) {
  _inherits(EditFeePackageModal, _Component);

  function EditFeePackageModal(props) {
    _classCallCheck(this, EditFeePackageModal);

    var _this = _possibleConstructorReturn(this, (EditFeePackageModal.__proto__ || Object.getPrototypeOf(EditFeePackageModal)).call(this, props));

    _this.handleOnResetCalculationItems = function (pp) {
      var isBooking = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var isBookingPP = isBooking && pp && pp.items && pp.items.length > 0;
      var isProjectPP = !isBooking && pp && pp && pp.projectFeePackage && pp.projectFeePackage.formulas && pp.projectFeePackage.formulas.length > 0;
      if (isBookingPP || isProjectPP) {
        var formulas = isBookingPP ? pp.items.filter(function (bc) {
          return bc.isEnabled;
        }) : pp.projectFeePackage.formulas;
        _this.setState({
          bookingFpItems: isBookingPP ? formulas : [],
          projectFpItems: isBookingPP ? [] : formulas
        });
      } else {
        _this.setState({
          bookingFpItems: [],
          projectFpItems: []
        });
      }
    };

    _this.handleSelectFeePackage = function (e, data) {
      e.preventDefault();
      _this.handleSetSelectedFeePackage(data.value);
      _this.setState({ selection: data.value });
    };

    _this.handleSetSelectedFeePackage = function (selected) {
      var _this$props = _this.props,
          bookingData = _this$props.bookingData,
          feePackages = _this$props.feePackages;

      if (selected) {
        if (feePackages && feePackages.length > 0) {
          var selectedPP = feePackages.find(function (pp) {
            return pp.projectFeePackageID === selected;
          });
          if (selectedPP) {
            if (bookingData.packageFee && bookingData.packageFee.projectFeePackageID === selected) {
              _this.setState({
                isCurrentBookingFP: true,
                currentBookingFeePackage: bookingData.packageFee,
                selectedFeePackageItem: {}
              });
              _this.handleOnResetCalculationItems(bookingData.packageFee, true);
            } else {
              _this.setState({
                isCurrentBookingFP: false,
                currentBookingFeePackage: {},
                selectedFeePackageItem: selectedPP
              });
              _this.handleOnResetCalculationItems(selectedPP);
            }
          } else if (bookingData && bookingData.packageFeeID) {
            // not in unit package pricing
            _this.setState({
              isCurrentBookingFP: true,
              currentBookingFeePackage: bookingData.packageFee,
              selectedFeePackageItem: {}
            });
            _this.handleOnResetCalculationItems(bookingData.packageFee, true);
          }
        } else {
          _this.setState({
            isCurrentBookingFP: false,
            currentBookingFeePackage: {},
            selectedFeePackageItem: {}
          });
          _this.handleOnResetCalculationItems(null);
        }
      }
    };

    _this.handleSubmit = function () {
      var selectedFeePackageItem = _this.state.selectedFeePackageItem;
      var _this$props2 = _this.props,
          onSubmit = _this$props2.onSubmit,
          onClose = _this$props2.onClose;

      if (onSubmit && selectedFeePackageItem) {
        onSubmit(selectedFeePackageItem);
      }
      onClose();
    };

    _this.shapeOptions = function (pp, bookingData) {
      if (pp || bookingData.packageFeeID) {
        var newPP = pp.map(function (d) {
          var id = d.projectFeePackage.id;
          var optText = d.projectFeePackage.name;
          var optDescp = d.projectFeePackage.description;

          return {
            text: optText,
            description: optDescp,
            value: id,
            content: _react2.default.createElement(
              _semanticUiReact.Header,
              { className: 'ddPricingTierItem' },
              _react2.default.createElement(
                'div',
                { className: 'name' },
                optText
              ),
              _react2.default.createElement(
                _semanticUiReact.Header.Subheader,
                null,
                optDescp
              )
            )
          };
        });
        if (bookingData.packageFee) {
          var inPP = pp.find(function (p) {
            return p.id === bookingData.packageFeeID;
          });
          if (!inPP) {
            newPP.unshift({
              text: bookingData.packageFee.name,
              description: bookingData.packageFee.description,
              value: bookingData.packageFee.projectFeePackageID,
              content: _react2.default.createElement(
                _semanticUiReact.Header,
                { className: 'ddPricingTierItem' },
                _react2.default.createElement(
                  'div',
                  { className: 'name' },
                  bookingData.packageFee.name
                ),
                _react2.default.createElement(
                  _semanticUiReact.Header.Subheader,
                  null,
                  bookingData.packageFee.description
                )
              )
            });
          }
        }
        return newPP;
      }
      return [];
    };

    _this.renderAmountWithCurrency = function (amount, currency) {
      return _react2.default.createElement(_LoanAmount2.default, {
        projectCurrencies: currency,
        format: '0,000,000.00',
        amount: amount ? amount.toFixed(2) : '0.00',
        prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
      });
    };

    _this.renderContent = function (i, currency) {
      var isCurrentBookingFP = _this.state.isCurrentBookingFP;

      var items = isCurrentBookingFP ? i : i.filter(function (c) {
        return c.applyToBooking;
      });
      if (items && items.length > 0) {
        return _react2.default.createElement(
          'div',
          { style: { width: '100%' } },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { columns: 2, className: 'itemContents' },
            items.map(function (item) {
              return _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { key: item.id, className: 'itemRow' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'left', width: 9 },
                  _react2.default.createElement(
                    'p',
                    { className: 'text-item' },
                    _react2.default.createElement(
                      'span',
                      null,
                      item.name
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'right', width: 7 },
                  _react2.default.createElement(
                    'p',
                    { className: 'text-item' },
                    _react2.default.createElement(
                      'span',
                      { className: 'text_add' },
                      _react2.default.createElement(_semanticUiReact.Icon, { color: 'green', size: 'small', name: 'plus' }),
                      '\xA0',
                      _this.renderAmountWithCurrency(item.valueChange, currency)
                    )
                  )
                )
              );
            })
          )
        );
      }
      return null;
    };

    _this.renderPriceBreakdown = function (_ref) {
      var listPrice = _ref.listPrice,
          spaPrice = _ref.spaPrice,
          nettPrice = _ref.nettPrice,
          currency = _ref.currency;
      var _this$state = _this.state,
          bookingFpItems = _this$state.bookingFpItems,
          isCurrentBookingFP = _this$state.isCurrentBookingFP,
          projectFpItems = _this$state.projectFpItems,
          currentBookingFeePackage = _this$state.currentBookingFeePackage,
          selectedFeePackageItem = _this$state.selectedFeePackageItem;

      var items = isCurrentBookingFP ? bookingFpItems : projectFpItems;
      var totalPrice = isCurrentBookingFP ? currentBookingFeePackage.totalPrice : selectedFeePackageItem.totalPrice;
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { columns: 2 },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              'List price'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right' },
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              _this.renderAmountWithCurrency(listPrice, currency)
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              'SPA price'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right' },
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              _this.renderAmountWithCurrency(spaPrice, currency)
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              'Nett selling price'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right' },
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              _this.renderAmountWithCurrency(nettPrice, currency)
            )
          )
        ),
        _react2.default.createElement(_semanticUiReact.Divider, null),
        items.length > 0 ? _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'packageFormula' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 12 },
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              'Fee formula(s)'
            )
          )
        ) : _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              'Fee formula(s)'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right' },
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              'N/A'
            )
          )
        ),
        _this.renderContent(items, currency),
        _react2.default.createElement(_semanticUiReact.Divider, { style: { width: '100%' } }),
        totalPrice && _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'totalPrice' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              'Total additional fees'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right' },
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              _this.renderAmountWithCurrency(totalPrice, currency)
            )
          )
        )
      );
    };

    _this.state = {
      bookingFpItems: [],
      bookingSpaItems: [],
      currentBookingFeePackage: {},
      isCurrentBookingFP: true,
      projectFpItems: [],
      projectSpaItems: [],
      selectedFeePackageItem: {},
      selection: ''
    };
    return _this;
  }

  _createClass(EditFeePackageModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var selectedFeePackage = this.props.selectedFeePackage;

      if (selectedFeePackage) {
        this.handleSetSelectedFeePackage(selectedFeePackage);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          bookingData = _props.bookingData,
          isMobile = _props.isMobile,
          loading = _props.loading,
          feePackages = _props.feePackages,
          selectedFeePackage = _props.selectedFeePackage;
      var selectedFeePackageItem = this.state.selectedFeePackageItem;
      var selection = this.state.selection;
      // CPI-977 requirements 7/11: belt and braces - the modal is also reachable by a deep link.

      var statusID = bookingData && bookingData.statusID;
      if ((0, _vietnamPricing.isPricingPackageLocked)(this.props.auth, statusID, 'fee')) {
        return _react2.default.createElement(
          'section',
          { className: 'edit_package_pricing' },
          _react2.default.createElement(
            'p',
            { className: 'text-body' },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock' }),
            this.props.t((0, _vietnamPricing.vnPackageLockMessage)(this.props.auth, statusID, 'fee'))
          )
        );
      }
      return _react2.default.createElement(
        'section',
        { className: 'edit_package_pricing' },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: isMobile ? 1 : 2 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'ppSelection' },
              _react2.default.createElement(
                'p',
                { className: 'text-body' },
                'If you wish to edit Fee Formulas in the Package, please select the right package, save, exit and choose Customise formula(s)'
              ),
              _react2.default.createElement(
                'p',
                { className: 'text-subtitle' },
                'Additional fee package\xA0',
                _react2.default.createElement(
                  'span',
                  { style: { color: 'red' } },
                  '*'
                )
              ),
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                className: 'ddPricingTierDropdown',
                options: this.shapeOptions(feePackages, bookingData),
                value: selection || selectedFeePackage,
                selection: true,
                fluid: true,
                onChange: this.handleSelectFeePackage,
                noResultsMessage: 'No additional fee package found.',
                placeholder: 'Select Additional Fee Package'
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'div',
                { className: 'packagePricingBreakdown' },
                this.renderPriceBreakdown({
                  listPrice: bookingData.unitSellingPrice,
                  spaPrice: bookingData.spaValue,
                  nettPrice: bookingData.nettSellingPrice,
                  currency: bookingData.project.projectCurrency
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 1 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              _react2.default.createElement(_semanticUiReact.Button, {
                content: 'Save Package',
                disabled: !selectedFeePackageItem || !selectedFeePackageItem.id,
                loading: loading,
                className: 'submit-button text-title',
                onClick: this.handleSubmit
              })
            )
          )
        )
      );
    }
  }]);

  return EditFeePackageModal;
}(_react.Component);

EditFeePackageModal.contextTypes = {
  store: _propTypes2.default.object
};
EditFeePackageModal.propTypes = {
  onClose: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  selectedFeePackage: _propTypes2.default.string,
  auth: _propTypes2.default.shape({
    isSuperAdmin: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool
  }),
  feePackages: _propTypes2.default.arrayOf(_propTypes2.default.shape()),
  isMobile: _propTypes2.default.bool,
  bookingData: _propTypes2.default.shape(),
  t: _propTypes2.default.func
};
exports.default = EditFeePackageModal;

/***/ }),
/* 2134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(12);

var _moment2 = _interopRequireDefault(_moment);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _amount = __webpack_require__(87);

var _vietnamPricing = __webpack_require__(197);

var _vietnam = __webpack_require__(40);

var _translation = __webpack_require__(4);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */


var isPackagePricingRequired = _config2.default.get('isPackagePricingRequired');

var EditPackageModal = function (_Component) {
  _inherits(EditPackageModal, _Component);

  function EditPackageModal(props) {
    _classCallCheck(this, EditPackageModal);

    var _this = _possibleConstructorReturn(this, (EditPackageModal.__proto__ || Object.getPrototypeOf(EditPackageModal)).call(this, props));

    _this.getCalculationTypeClassname = function (type) {
      switch (type) {
        case 'subtotal':
          return 'subtotal';
        default:
          return 'itemRow';
      }
    };

    _this.convertTextClass = function (isSubtotal) {
      if (isSubtotal) {
        return 'text-subtitle';
      }
      return 'text-item';
    };

    _this.handleOnResetCalculationItems = function (pp) {
      var isBooking = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var isBookingPP = isBooking && pp && pp.calculations && pp.calculations.length > 0;
      var isProjectPP = !isBooking && pp && pp && pp.projectPackagePricing && pp.projectPackagePricing.packagePricingCalculations && pp.projectPackagePricing.packagePricingCalculations.length > 0;
      if (isBookingPP || isProjectPP) {
        var bookingCalculations = isBookingPP ? pp.calculations.filter(function (bc) {
          return bc.isEnabled;
        }) : [];
        var calculations = isBookingPP ? bookingCalculations : pp.projectPackagePricing.packagePricingCalculations;
        var listItems = calculations.filter(function (cc) {
          return cc.category === 'list_price';
        });
        var spaItems = calculations.filter(function (cc) {
          return cc.category === 'spa_price';
        });
        if (isBookingPP) {
          _this.setState({ bookingListItems: listItems, bookingSpaItems: spaItems });
          _this.setState({ projectListItems: [], projectSpaItems: [] });
        } else {
          _this.setState({ projectListItems: listItems, projectSpaItems: spaItems });
          _this.setState({ bookingListItems: [], bookingSpaItems: [] });
        }
      } else {
        _this.setState({ bookingListItems: [], bookingSpaItems: [] });
        _this.setState({ projectListItems: [], projectSpaItems: [] });
      }
    };

    _this.handleSelectPackagePricing = function (e, data) {
      e.preventDefault();
      _this.handleSetSelectedPackagePricingItem(data.value);
      _this.setState({ selection: data.value });
    };

    _this.handleSetSelectedPackagePricingItem = function (selected) {
      var isDefaultCustom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          bookingData = _this$props.bookingData,
          packagePricings = _this$props.packagePricings;

      if (selected) {
        if (selected === 'base_selling_price') {
          _this.setState({
            isCurrentBookingPP: false,
            currentBookingPackagePricing: {},
            selectedPackagePricingItem: {
              spaPrice: bookingData.unitSellingPrice,
              totalPrice: bookingData.unitSellingPrice,
              listPrice: bookingData.unitSellingPrice
            }
          });
          _this.handleOnResetCalculationItems(null);
        } else if (packagePricings && packagePricings.length > 0) {
          var selectedPP = packagePricings.find(function (pp) {
            return pp.projectPackagePricingID === selected;
          });
          var customPricePP = packagePricings.find(function (pp) {
            return isDefaultCustom ? pp.customName === selected : pp.id === selected;
          });
          if (selectedPP || customPricePP) {
            if (bookingData.packagePricing && bookingData.packagePricing.projectPackagePricingID === selected) {
              _this.setState({
                isCurrentBookingPP: true,
                currentBookingPackagePricing: bookingData.packagePricing,
                selectedPackagePricingItem: {}
              });
              _this.handleOnResetCalculationItems(bookingData.packagePricing, true);
            } else {
              var pp = selectedPP || customPricePP;
              _this.setState({
                isCurrentBookingPP: false,
                currentBookingPackagePricing: {},
                selectedPackagePricingItem: pp
              });
              if (customPricePP && customPricePP) {
                _this.setState({ selection: customPricePP.id });
              }
              _this.handleOnResetCalculationItems(pp);
            }
          } else if (bookingData && bookingData.packagePricingID) {
            // not in unit package pricing
            _this.setState({
              isCurrentBookingPP: true,
              currentBookingPackagePricing: bookingData.packagePricing,
              selectedPackagePricingItem: {}
            });
            _this.handleOnResetCalculationItems(bookingData.packagePricing, true);
          }
        } else {
          _this.setState({
            isCurrentBookingPP: false,
            currentBookingPackagePricing: {},
            selectedPackagePricingItem: {}
          });
          _this.handleOnResetCalculationItems(null);
        }
      }
    };

    _this.handleSubmit = function () {
      var selectedPackagePricingItem = _this.state.selectedPackagePricingItem;
      var _this$props2 = _this.props,
          onSubmit = _this$props2.onSubmit,
          onClose = _this$props2.onClose;

      if (onSubmit && selectedPackagePricingItem) {
        onSubmit(selectedPackagePricingItem);
      }
      onClose();
    };

    _this.filterPackagePricings = function (packagePricings) {
      var bookingData = _this.props.bookingData;

      var newPackagePricings = [].concat(_toConsumableArray(packagePricings));

      if (packagePricings && packagePricings.length > 0) {
        packagePricings.forEach(function (pp, idx) {
          // Check for schedule dates if it's not a custom price
          if (!pp.isCustomPrice && pp.projectPackagePricing) {
            var sStart = pp.projectPackagePricing.scheduleStartAt;
            var sEnd = pp.projectPackagePricing.scheduleEndAt;

            // Check if package is expired based on schedule
            if (sStart && (0, _moment2.default)(sStart).unix() > (0, _moment2.default)().unix() || sEnd && (0, _moment2.default)(sEnd).unix() < (0, _moment2.default)().unix()) {
              newPackagePricings[idx] = _extends({}, newPackagePricings[idx], { disabled: true });
            } else if (pp.projectPackagePricing.bumiPurchaserOnly) {
              // Check bumi purchaser only restriction
              if (bookingData && bookingData.bookingCustomer.bumi === 'Bumiputera') {
                newPackagePricings[idx] = _extends({}, newPackagePricings[idx], { disabled: false });
              } else {
                newPackagePricings[idx] = _extends({}, newPackagePricings[idx], { disabled: true });
              }
            }
          }
        });
      }

      return newPackagePricings;
    };

    _this.shapeOptions = function (pp, bookingData) {
      // Apply schedule date filtering first
      var filteredPP = pp ? _this.filterPackagePricings(pp) : [];

      var baseSellingPriceItem = {
        value: 'base_selling_price',
        text: 'Base Selling Price',
        disabled: isPackagePricingRequired && filteredPP && filteredPP.length > 0 || _this.state.disableBaseSellingPrice,
        content: _react2.default.createElement(
          _semanticUiReact.Header,
          { className: 'ddPricingTierItem' },
          _react2.default.createElement(
            'div',
            { className: 'name' },
            'Base Selling Price'
          )
        )
      };
      var newPP = [baseSellingPriceItem];
      if (filteredPP || bookingData.packagePricingID) {
        filteredPP.forEach(function (d) {
          var id = d.isCustomPrice ? d.id : d.projectPackagePricing.id;
          var optText = d.isCustomPrice ? d.customName : d.projectPackagePricing.name;
          var optDescp = d.isCustomPrice ? d.customDescription : d.projectPackagePricing.description;

          var newItem = {
            key: id,
            text: optText,
            description: optDescp,
            value: id,
            disabled: d.disabled || false,
            content: _react2.default.createElement(
              _semanticUiReact.Header,
              { className: 'ddPricingTierItem' },
              _react2.default.createElement(
                'div',
                { className: 'name' },
                optText
              ),
              _react2.default.createElement(
                _semanticUiReact.Header.Subheader,
                null,
                optDescp
              )
            )
          };
          newPP.push(newItem);
        });
        if (bookingData.packagePricing) {
          var inPP = filteredPP.find(function (p) {
            return p.id === bookingData.packagePricingID;
          });
          if (!inPP) {
            var text = bookingData.packagePricing.name || baseSellingPriceItem.text;
            var value = bookingData.packagePricing.projectPackagePricingID || baseSellingPriceItem.value;
            newPP.unshift({
              key: 'npp_' + value,
              text: text,
              description: bookingData.packagePricing.description,
              value: value,
              content: _react2.default.createElement(
                _semanticUiReact.Header,
                { className: 'ddPricingTierItem' },
                _react2.default.createElement(
                  'div',
                  { className: 'name' },
                  text
                ),
                _react2.default.createElement(
                  _semanticUiReact.Header.Subheader,
                  null,
                  bookingData.packagePricing.description
                )
              )
            });
          }
        }
        // CPI-977 (PO, 14 Sep): a Vietnam booking always carries a named package, so Base
        // Selling Price is not offered here either - same rule as the reservation form.
        if ((0, _vietnam.isVietnamCompany)(_this.props.auth)) {
          return newPP.filter(function (opt) {
            return opt.value !== 'base_selling_price';
          });
        }
        return newPP;
      }
      return [];
    };

    _this.renderFormulaChangeClass = function (type) {
      if (type.includes('deduct')) {
        return 'text_deduct';
      }
      if (type.includes('add')) {
        return 'text_add';
      }
      return '';
    };

    _this.renderFormulaChangePrefix = function (type) {
      if (type.includes('deduct')) {
        return _react2.default.createElement(_semanticUiReact.Icon, { color: 'red', size: 'small', name: 'minus' });
      }
      if (type.includes('add')) {
        return _react2.default.createElement(_semanticUiReact.Icon, { color: 'green', size: 'small', name: 'plus' });
      }
      return '';
    };

    _this.renderAmountWithCurrency = function (amount, currency) {
      return _react2.default.createElement(_LoanAmount2.default, {
        projectCurrencies: currency,
        format: '0,000,000.00',
        amount: amount ? amount.toFixed(2) : '0.00',
        prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
      });
    };

    _this.renderContent = function (type, i, currency) {
      var isCurrentBookingPP = _this.state.isCurrentBookingPP;

      var items = isCurrentBookingPP ? i : i.filter(function (c) {
        return c.applyToBooking;
      });
      if (items && items.length > 0) {
        return _react2.default.createElement(
          'div',
          { style: { width: '100%' } },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { columns: 2, className: 'itemContents' },
            items.map(function (item) {
              return _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { key: item.id, className: _this.getCalculationTypeClassname(item.isSubTotal ? 'subtotal' : type) },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'left', width: 9 },
                  _react2.default.createElement(
                    'p',
                    { className: '' + _this.convertTextClass(item.isSubTotal) },
                    item.isSubTotal ? _react2.default.createElement(
                      'span',
                      null,
                      'Sub total'
                    ) : _react2.default.createElement(
                      'span',
                      null,
                      isCurrentBookingPP ? item.name : item.projectPackagePricingItem.name
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'right', width: 7 },
                  _react2.default.createElement(
                    'p',
                    { className: '' + _this.convertTextClass(item.isSubTotal) },
                    _react2.default.createElement(
                      'span',
                      { className: '' + _this.renderFormulaChangeClass(isCurrentBookingPP ? item.calculationType : item.projectPackagePricingItem.calculationType) },
                      _this.renderFormulaChangePrefix(isCurrentBookingPP ? item.calculationType : item.projectPackagePricingItem.calculationType),
                      '\xA0',
                      _this.renderAmountWithCurrency(item.isSubTotal ? item.newValue : item.valueChange, currency)
                    )
                  )
                )
              );
            })
          )
        );
      }
      return null;
    };

    _this.renderPriceBreakdown = function (_ref) {
      var listPrice = _ref.listPrice,
          currency = _ref.currency;
      var bookingData = _this.props.bookingData;
      var _this$state = _this.state,
          bookingListItems = _this$state.bookingListItems,
          bookingSpaItems = _this$state.bookingSpaItems,
          currentBookingPackagePricing = _this$state.currentBookingPackagePricing,
          isCurrentBookingPP = _this$state.isCurrentBookingPP,
          projectListItems = _this$state.projectListItems,
          projectSpaItems = _this$state.projectSpaItems,
          selectedPackagePricingItem = _this$state.selectedPackagePricingItem;

      var spaValue = 0;
      var nettValue = 0;
      var listItems = isCurrentBookingPP ? bookingListItems : projectListItems;
      var spaItems = isCurrentBookingPP ? bookingSpaItems : projectSpaItems;
      if (isCurrentBookingPP && currentBookingPackagePricing && currentBookingPackagePricing.id) {
        spaValue = currentBookingPackagePricing.spaPrice;
        nettValue = currentBookingPackagePricing.totalPrice;
      } else if (!isCurrentBookingPP && selectedPackagePricingItem) {
        spaValue = selectedPackagePricingItem.spaPrice;
        nettValue = selectedPackagePricingItem.totalPrice;
      } else if (bookingData) {
        spaValue = parseFloat((0, _amount.spaFullNumber)(bookingData));
        nettValue = bookingData.nettSellingPrice;
      }
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { columns: 2 },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              'List price'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right' },
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              _this.renderAmountWithCurrency(listPrice, currency)
            )
          )
        ),
        _react2.default.createElement(_semanticUiReact.Divider, null),
        listItems.length > 0 || spaItems.length > 0 ? _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'packageFormula' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 12 },
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              'Package formula'
            )
          )
        ) : _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              'Package formula'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right' },
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              'N/A'
            )
          )
        ),
        _this.renderContent('list', listItems, currency),
        _react2.default.createElement(_semanticUiReact.Divider, { style: { width: '100%' } }),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'packageFormula' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              'SPA value'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right' },
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              _this.renderAmountWithCurrency(spaValue, currency)
            )
          )
        ),
        _this.renderContent('spa', spaItems, currency),
        _this.hasAccessNettSellingPrice(bookingData.project) && _react2.default.createElement(_semanticUiReact.Divider, null),
        _this.hasAccessNettSellingPrice(bookingData.project) && nettValue && _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'totalPrice' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              'Nett selling price'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right' },
            _react2.default.createElement(
              'p',
              { className: 'text-title' },
              _this.renderAmountWithCurrency(nettValue, currency)
            )
          )
        )
      );
    };

    _this.state = {
      bookingListItems: [],
      bookingSpaItems: [],
      currentBookingPackagePricing: {},
      isCurrentBookingPP: true,
      projectListItems: [],
      projectSpaItems: [],
      selectedPackagePricingItem: {},
      selection: '',
      disableBaseSellingPrice: props.bookingData && props.bookingData.project ? props.bookingData.project.disableBaseSellingPriceSelection : false
    };
    return _this;
  }

  _createClass(EditPackageModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          selectedPackagePricing = _props.selectedPackagePricing,
          selectedCustomPPName = _props.selectedCustomPPName;

      if (selectedPackagePricing || selectedCustomPPName) {
        var selectedPP = selectedPackagePricing || selectedCustomPPName;
        this.handleSetSelectedPackagePricingItem(selectedPP, selectedCustomPPName !== '');
      }
    }
  }, {
    key: 'hasAccessNettSellingPrice',
    value: function hasAccessNettSellingPrice(project) {
      var auth = this.props.auth;

      if (auth.isSuperAdmin || auth.isHeadquarters) {
        return true;
      }
      if (project && project.accessBULNettSellingPrice && auth.isBranchLeader) {
        return true;
      }
      if (project && project.accessStaffNettSellingPrice && auth && auth.companyBranch) {
        return true;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          bookingData = _props2.bookingData,
          isMobile = _props2.isMobile,
          loading = _props2.loading,
          packagePricings = _props2.packagePricings,
          selectedPackagePricing = _props2.selectedPackagePricing;
      var _state = this.state,
          selectedPackagePricingItem = _state.selectedPackagePricingItem,
          selection = _state.selection;

      var noChanges = !selection || selection === selectedPackagePricing;
      // CPI-977 (PO, 14 Sep): Vietnam sees the dropdown only - no price breakdown column and no
      // pointer to the formula editor, which is hidden on the Sales Info card as well.
      var vnDropdownOnly = (0, _vietnam.isVietnamCompany)(this.props.auth);
      // CPI-977 requirements 7/11: belt and braces - the modal is also reachable by a deep link.
      if ((0, _vietnamPricing.isPricingPackageLocked)(this.props.auth, bookingData && bookingData.statusID)) {
        var t = this.props.t;

        return _react2.default.createElement(
          'section',
          { className: 'edit_package_pricing' },
          _react2.default.createElement(
            'p',
            { className: 'text-body' },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock' }),
            t((0, _vietnamPricing.vnPackageLockMessage)(this.props.auth, bookingData && bookingData.statusID))
          )
        );
      }
      return _react2.default.createElement(
        'section',
        { className: 'edit_package_pricing' },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: isMobile || vnDropdownOnly ? 1 : 2 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'ppSelection' },
              !vnDropdownOnly && _react2.default.createElement(
                'p',
                { className: 'text-body' },
                'If you wish to edit Formula Items in the Package, please select the right package, save, exit and choose Customise formula(s)'
              ),
              _react2.default.createElement(
                'p',
                { className: 'text-subtitle' },
                'Pricing package\xA0',
                _react2.default.createElement(
                  'span',
                  { style: { color: 'red' } },
                  '*'
                )
              ),
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                className: 'ddPricingTierDropdown',
                options: this.shapeOptions(packagePricings, bookingData),
                value: selection || selectedPackagePricing,
                selection: true,
                fluid: true,
                onChange: this.handleSelectPackagePricing,
                noResultsMessage: 'No pricing package found.',
                placeholder: 'Select Pricing Package'
              })
            ),
            !vnDropdownOnly && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'div',
                { className: 'packagePricingBreakdown' },
                this.renderPriceBreakdown({
                  listPrice: bookingData.unitSellingPrice,
                  currency: bookingData.project.projectCurrency
                })
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 1 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              _react2.default.createElement(_semanticUiReact.Button, {
                content: 'Save Package',
                disabled: noChanges && (!selectedPackagePricingItem || !selectedPackagePricingItem.id),
                loading: loading,
                className: 'submit-button text-title',
                onClick: this.handleSubmit
              })
            )
          )
        )
      );
    }
  }]);

  return EditPackageModal;
}(_react.Component);

EditPackageModal.contextTypes = {
  store: _propTypes2.default.object
};
EditPackageModal.propTypes = {
  onClose: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  selectedPackagePricing: _propTypes2.default.string,
  selectedCustomPPName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.shape({ countryCode: _propTypes2.default.string }),
    isSuperAdmin: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool
  }),
  packagePricings: _propTypes2.default.arrayOf(_propTypes2.default.shape()),
  isMobile: _propTypes2.default.bool,
  bookingData: _propTypes2.default.shape(),
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(EditPackageModal);

/***/ }),
/* 2135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _translation = __webpack_require__(4);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
/* eslint no-nested-ternary: 0 */


// Still needed for the module-level locale; the feed date renders through Timestamp.
_momentTimezone2.default.locale('en-gb');

var ExportActivities = function (_Component) {
  _inherits(ExportActivities, _Component);

  function ExportActivities() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ExportActivities);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ExportActivities.__proto__ || Object.getPrototypeOf(ExportActivities)).call.apply(_ref, [this].concat(args))), _this), _this.renderActivityTitle = function (exportType, fileName) {
      var t = _this.props.t;

      var exportedLabel = t('Exported', { ns: _translation.TRANSLATION_FILES.translation, defaultValue: 'Exported' });

      return exportedLabel + ': ' + exportType + ' (' + fileName + ')';
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ExportActivities, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          data = _props.data,
          t = _props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(
              _semanticUiReact.Feed,
              null,
              data && data.length > 0 ? data.map(function (activity, idx) {
                return _react2.default.createElement(
                  _semanticUiReact.Feed.Event,
                  { key: idx, className: 'activity-logs' },
                  _react2.default.createElement(_semanticUiReact.Feed.Label, { icon: 'user' }),
                  _react2.default.createElement(
                    _semanticUiReact.Feed.Content,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Date,
                      null,
                      _react2.default.createElement(_Timestamp2.default, { timestamp: activity.createdAt, format: 'MMMM Do YYYY, h:mm:ss a' })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Feed.Summary,
                      null,
                      _this2.props.hasAccess ? activity.userAffiliateID > 0 ? _react2.default.createElement(
                        _reactRouter.Link,
                        { to: '/users/' + activity.userAffiliateID + '/' },
                        activity.userPreferredName || t('Unknown')
                      ) : '' : activity.userPreferredName,
                      ' ' + _this2.renderActivityTitle(activity.exportType, activity.fileName)
                    ),
                    _this2.props.showAll ? _react2.default.createElement(
                      _semanticUiReact.Feed.Extra,
                      { text: true },
                      _react2.default.createElement(
                        _semanticUiReact.List,
                        { bulleted: true },
                        _react2.default.createElement(
                          _semanticUiReact.List.Item,
                          null,
                          _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(
                              'span',
                              { style: { color: '#666' } },
                              t('File Name:', { ns: _translation.TRANSLATION_FILES.translation })
                            ),
                            ' ',
                            _react2.default.createElement(
                              'u',
                              null,
                              activity.fileName
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.List.Item,
                          null,
                          _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(
                              'span',
                              { style: { color: '#666' } },
                              t('File Download Link:', { ns: _translation.TRANSLATION_FILES.translation })
                            ),
                            ' ',
                            _react2.default.createElement(
                              'u',
                              null,
                              activity.fileLink
                            )
                          )
                        )
                      )
                    ) : ''
                  )
                );
              }) : this.props.loading ? _react2.default.createElement('br', null) : _react2.default.createElement(
                'center',
                null,
                t('No activity found'),
                '.'
              )
            )
          )
        )
      );
    }
  }]);

  return ExportActivities;
}(_react.Component);

ExportActivities.propTypes = {
  data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  hasAccess: _propTypes2.default.bool.isRequired,
  loading: _propTypes2.default.bool.isRequired,
  showAll: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces)))((0, _reactRedux.connect)(ExportActivities.mapStateToProps)(ExportActivities));

/***/ }),
/* 2136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _InputCalendarRange = __webpack_require__(1016);

var _InputCalendarRange2 = _interopRequireDefault(_InputCalendarRange);

var _dateRanges = __webpack_require__(265);

var _dateRanges2 = _interopRequireDefault(_dateRanges);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BookingDatePicker = function (_Component) {
  _inherits(BookingDatePicker, _Component);

  function BookingDatePicker(props) {
    _classCallCheck(this, BookingDatePicker);

    var _this = _possibleConstructorReturn(this, (BookingDatePicker.__proto__ || Object.getPrototypeOf(BookingDatePicker)).call(this, props));

    _initialiseProps.call(_this);

    var state = BookingDatePicker.getPropsToState(props);
    _this.state = _extends({}, state, {
      open: false
    });
    return _this;
  }

  _createClass(BookingDatePicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var value = this.state.value;

      var state = BookingDatePicker.getPropsToState(nextProps);
      this.setState(_extends({}, state), function () {
        if (value === 'custom' && value !== state.value) {
          _this2.date.handleReset();
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      var classNames = ['booking'];
      if (this.state.value.length > 0) {
        classNames.push('selected');
      }
      return _react2.default.createElement(
        _semanticUiReact.Dropdown,
        {
          className: classNames.join(' '),
          fluid: true,
          open: this.state.open,
          header: t(this.props.headerText),
          text: this.state.value && this.props.options && this.props.options.length > 0 ? t(this.props.options.find(function (o) {
            return o.value === _this3.state.value;
          }).text, { ns: _translation.TRANSLATION_FILES.constants }) : null,
          placeholder: t(this.props.placeholder),
          selectOnBlur: false,
          value: this.state.value,
          onClick: this.handleOpen,
          onBlur: this.handleBlur,
          disabled: this.props.disabled
        },
        _react2.default.createElement(
          _semanticUiReact.Dropdown.Menu,
          { style: { right: '-10em' } },
          this.props.headerText && _react2.default.createElement(_semanticUiReact.Dropdown.Header, { content: t(this.props.headerText) }),
          this.props.options && this.props.options.length > 0 && this.props.options.some(function (v) {
            return v.value === 'custom';
          }) && _react2.default.createElement(
            _semanticUiReact.Dropdown.Item,
            { onClick: this.handleOnCustomChange, value: 'custom' },
            _react2.default.createElement(_semanticUiReact.Dropdown.Header, { content: t('Custom Date Range', { ns: _translation.TRANSLATION_FILES.constants }) }),
            _react2.default.createElement(_InputCalendarRange2.default, {
              ref: function ref(_ref) {
                _this3.date = _ref;
              },
              filterNameFrom: this.props.filterNameFrom,
              filterNameTo: this.props.filterNameTo,
              dateFrom: this.props.dateFrom,
              dateTo: this.props.dateTo,
              onReset: this.props.onResetRange,
              onSetRange: this.handleSetRange
            })
          ),
          this.props.options && this.props.options.length > 0 ? this.props.options.filter(function (v) {
            return v.value !== 'custom';
          }).map(function (opt, idx) {
            return _react2.default.createElement(_semanticUiReact.Dropdown.Item, {
              key: idx,
              value: opt.value,
              text: t(opt.text, { ns: _translation.TRANSLATION_FILES.constants }),
              onClick: _this3.handleOnChange
            });
          }) : null
        )
      );
    }
  }]);

  return BookingDatePicker;
}(_react.Component);

BookingDatePicker.propTypes = {
  dateFrom: _propTypes2.default.string,
  dateTo: _propTypes2.default.string,
  filterName: _propTypes2.default.string.isRequired,
  filterNameFrom: _propTypes2.default.string.isRequired,
  filterNameTo: _propTypes2.default.string.isRequired,
  headerText: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  onResetRange: _propTypes2.default.func.isRequired,
  onSetRange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired
  })).isRequired,
  placeholder: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
BookingDatePicker.defaultProps = {
  hasSearch: false,
  headerText: 'Date Range',
  options: _dateRanges2.default,
  placeholder: 'Select Date Range',
  value: '',
  disabled: false
};

BookingDatePicker.getPropsToState = function (props) {
  var value = props.value || '';
  return {
    value: value
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleOnChange = function (e, _ref2) {
    var value = _ref2.value;

    _this4.setState({ value: value }, function () {
      if (_this4.props.dateFrom || _this4.props.dateTo) {
        _this4.date.handleReset();
      }
      _this4.props.onChange(value, _this4.props.filterName);
    });
  };

  this.handleOnCustomChange = function (e, _ref3) {
    var value = _ref3.value;

    var hasChange = _this4.state.value !== value;
    _this4.setState({ value: value, open: false }, function () {
      if (hasChange) {
        _this4.props.onChange(value, _this4.props.filterName);
      }
    });
  };

  this.handleClose = function () {
    _this4.setState({ value: '' }, function () {
      _this4.props.onClose(_this4.props.filterName);
    });
  };

  this.handleSetRange = function (from, to) {
    var onSetRange = _this4.props.onSetRange;

    var value = 'custom';
    _this4.setState({ value: value, open: from && !to }, function () {
      _this4.props.onChange(value, _this4.props.filterName);
      if (onSetRange) {
        if (from && to) {
          onSetRange(from, to);
        }
      }
    });
  };

  this.handleOpen = function () {
    _this4.setState(function (prevState) {
      return {
        open: !prevState.open
      };
    });
  };

  this.handleBlur = function () {
    _this4.setState({ open: false });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(BookingDatePicker);

/***/ }),
/* 2137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BookingDatePicker = __webpack_require__(2136);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BookingDatePicker).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BookingSearchList = function (_Component) {
  _inherits(BookingSearchList, _Component);

  function BookingSearchList(props) {
    _classCallCheck(this, BookingSearchList);

    var _this = _possibleConstructorReturn(this, (BookingSearchList.__proto__ || Object.getPrototypeOf(BookingSearchList)).call(this, props));

    _initialiseProps.call(_this);

    var state = BookingSearchList.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(BookingSearchList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = BookingSearchList.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classNames = ['booking', 'searchlist'];
      if (this.state.value.length > 0) {
        classNames.push('selected');
      }
      return _react2.default.createElement(_semanticUiReact.Search, {
        aligned: 'left',
        className: classNames.join(' '),
        fluid: true,
        icon: this.props.icon || 'caret down',
        loading: this.props.loading,
        onResultSelect: this.handleResultSelect,
        onSearchChange: this.handleSearchChange,
        results: this.props.results,
        value: this.state.value,
        placeholder: this.props.placeholder,
        noResultsMessage: this.props.noResultsMessage,
        onFocus: function onFocus() {
          var showNoResults = false;
          _this2.setState({ showNoResults: showNoResults });
        },
        showNoResults: this.state.showNoResults,
        disabled: this.props.disabled
      });
    }
  }]);

  return BookingSearchList;
}(_react.Component);

BookingSearchList.propTypes = {
  isActive: _propTypes2.default.bool.isRequired,
  onSelect: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  filterName: _propTypes2.default.string.isRequired,
  loading: _propTypes2.default.bool.isRequired,
  icon: _propTypes2.default.string,
  results: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired,
    description: _propTypes2.default.string.isRequired,
    image: _propTypes2.default.string
  })).isRequired,
  placeholder: _propTypes2.default.string,
  noResultsMessage: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string,
  disabled: _propTypes2.default.bool
};
BookingSearchList.defaultProps = {
  hasSearch: false,
  headerText: 'Find Options',
  options: [],
  placeholder: 'Find Options...',
  value: '',
  disabled: false
};

BookingSearchList.getPropsToState = function (props) {
  var value = props.value || '';
  var showNoResults = props.showNoResults || true;
  return {
    value: value,
    showNoResults: showNoResults
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleClose = function () {
    _this3.setState({ value: '' }, function () {
      _this3.props.onClose(_this3.props.filterName);
    });
  };

  this.handleResultSelect = function (e, _ref) {
    var result = _ref.result;

    _this3.props.onSelect(result, _this3.props.filterName);
  };

  this.handleSearchChange = function (e, _ref2) {
    var value = _ref2.value;

    var showNoResults = true;
    _this3.setState({
      value: value,
      showNoResults: showNoResults
    }, function () {
      _this3.props.onChange(value);
    });
  };
};

exports.default = BookingSearchList;

/***/ }),
/* 2139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BookingSelectListMultiple = function (_Component) {
  _inherits(BookingSelectListMultiple, _Component);

  // The selected values arrive from the page URL. An over-long list used to come back as an object
  // ({ 0: 'a', 1: 'b', ... }) and a single plain value as a string; either one made `.some`/`.push`
  // throw during render and blanked the whole page (CPI-1444). Always work on an array.
  function BookingSelectListMultiple(props) {
    _classCallCheck(this, BookingSelectListMultiple);

    var _this = _possibleConstructorReturn(this, (BookingSelectListMultiple.__proto__ || Object.getPrototypeOf(BookingSelectListMultiple)).call(this, props));

    _initialiseProps.call(_this);

    var state = BookingSelectListMultiple.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(BookingSelectListMultiple, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = BookingSelectListMultiple.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var classNames = ['booking'];
      if (this.state.value.length > 0) {
        classNames.push('selected');
      }
      return _react2.default.createElement(_semanticUiReact.Dropdown, {
        className: classNames.join(' '),
        closeOnChange: false,
        fluid: true,
        header: this.props.headerText,
        onChange: this.handleOnChange,
        options: this.state.options.map(function (op) {
          return _extends({}, op, {
            icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'square ' + (_this2.state.value.some(function (v) {
                return v === op.value;
              }) ? 'check' : 'outline') })
          });
        }),
        renderLabel: this.props.renderLabel,
        selectOnBlur: false,
        text: this.state.value.length > 0 ? this.state.value.length + ' ' + (this.props.selectedText || 'selected') || null : this.props.placeholder,
        placeholder: this.state.value.length > 0 ? null : this.props.placeholder,
        disabled: this.props.disabled,
        value: '',
        scrolling: true,
        search: true
      });
    }
  }]);

  return BookingSelectListMultiple;
}(_react.Component);

BookingSelectListMultiple.propTypes = {
  disabled: _propTypes2.default.bool,
  filterName: _propTypes2.default.string.isRequired,
  headerText: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired
  })).isRequired,
  placeholder: _propTypes2.default.string,
  // Usually an array; an over-long URL list arrives as { 0: .., 1: .. } and a single URL value
  // as a plain string. toValueArray accepts all three (CPI-1444).
  value: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.string.isRequired), _propTypes2.default.objectOf(_propTypes2.default.string), _propTypes2.default.string]),
  search: _propTypes2.default.string,
  renderLabel: _propTypes2.default.func,
  selectedText: _propTypes2.default.string
};
BookingSelectListMultiple.defaultProps = {
  hasSearch: false,
  options: [],
  placeholder: 'Select an Option',
  value: [] };

BookingSelectListMultiple.toValueArray = function (value) {
  if (Array.isArray(value)) {
    return value;
  }
  if (value && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
    return Object.keys(value).sort(function (a, b) {
      return Number(a) - Number(b);
    }).map(function (key) {
      return value[key];
    }).filter(function (v) {
      return typeof v === 'string';
    });
  }
  if (typeof value === 'string' && value !== '') {
    return [value];
  }
  return [];
};

BookingSelectListMultiple.getPropsToState = function (props) {
  var value = BookingSelectListMultiple.toValueArray(props.value);
  var options = props.options || [];
  var search = props.search || '';
  var limit = props.limit || 0;
  if (limit > 0) {
    options = options.map(function (d) {
      return _extends({
        disabled: limit > 0 && value.length >= limit
      }, d);
    });
  }
  return {
    value: value,
    options: options,
    search: search
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleOnChange = function (e, _ref) {
    var value = _ref.value;

    var current = [].concat(_this3.state.value);
    var index = current.findIndex(function (v) {
      return v === value;
    });
    if (index >= 0) {
      current.splice(index, 1);
    } else {
      current.push(value);
    }
    var newValue = current;
    _this3.setState({ value: newValue }, function () {
      _this3.props.onChange(newValue, _this3.props.filterName);
    });
  };
};

exports.default = BookingSelectListMultiple;

/***/ }),
/* 2140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _InputCalendarRange = __webpack_require__(2141);

var _InputCalendarRange2 = _interopRequireDefault(_InputCalendarRange);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DatePicker = function (_Component) {
  _inherits(DatePicker, _Component);

  function DatePicker(props) {
    _classCallCheck(this, DatePicker);

    var _this = _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).call(this, props));

    _initialiseProps.call(_this);

    var state = DatePicker.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(DatePicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = DatePicker.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          this.state.custom ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 16, tablet: 16, computer: 16 },
            _react2.default.createElement(_InputCalendarRange2.default, {
              filterNameFrom: this.props.filterNameFrom,
              filterNameTo: this.props.filterNameTo,
              dateFrom: this.props.dateFrom,
              dateTo: this.props.dateTo,
              onClose: this.handleClose,
              onReset: this.props.onResetRange,
              onSetRange: this.props.onSetRange
            })
          ) : _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 16, tablet: 16, computer: 16 },
            _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 14 },
                  _react2.default.createElement(_semanticUiReact.Dropdown, {
                    fluid: true,
                    header: t(this.props.headerText),
                    onChange: this.handleOnChange,
                    options: this.props.options,
                    placeholder: t(this.props.placeholder),
                    search: this.props.hasSearch,
                    selection: true,
                    selectOnBlur: false,
                    value: this.state.value
                  })
                ),
                (this.state.value.length > 0 || this.state.value.length > 0 && this.state.value !== 'custom') && _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 2, verticalAlign: 'middle', className: 'clearicon' },
                  _react2.default.createElement(_semanticUiReact.Button, {
                    as: 'a',
                    circular: true,
                    icon: 'x',
                    onClick: this.handleClose,
                    size: 'mini',
                    title: 'Clear'
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return DatePicker;
}(_react.Component);

DatePicker.propTypes = {
  dateFrom: _propTypes2.default.string,
  dateTo: _propTypes2.default.string,
  filterName: _propTypes2.default.string.isRequired,
  filterNameFrom: _propTypes2.default.string.isRequired,
  filterNameTo: _propTypes2.default.string.isRequired,
  hasSearch: _propTypes2.default.bool,
  headerText: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  onResetRange: _propTypes2.default.func.isRequired,
  onSetRange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired
  })).isRequired,
  placeholder: _propTypes2.default.string,
  t: _propTypes2.default.func
};
DatePicker.defaultProps = {
  hasSearch: false,
  headerText: 'Select Date Range',
  options: [],
  placeholder: 'Select Date Range',
  value: ''
};

DatePicker.getPropsToState = function (props) {
  var value = props.value || '';
  var custom = props.value === 'custom';
  return {
    value: value,
    custom: custom
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleOnChange = function (e, _ref) {
    var value = _ref.value;

    _this2.setState({
      value: value,
      custom: value === 'custom'
    }, function () {
      _this2.props.onChange(value, _this2.props.filterName);
    });
  };

  this.handleClose = function () {
    _this2.setState({
      value: ''
    }, function () {
      _this2.props.onClose(_this2.props.filterName);
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(DatePicker);

/***/ }),
/* 2141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _reactDayPicker = __webpack_require__(687);

var _reactDayPicker2 = _interopRequireDefault(_reactDayPicker);

__webpack_require__(360);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

__webpack_require__(452);

__webpack_require__(451);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InputCalendarRange = function (_Component) {
  _inherits(InputCalendarRange, _Component);

  function InputCalendarRange(props) {
    _classCallCheck(this, InputCalendarRange);

    var _this = _possibleConstructorReturn(this, (InputCalendarRange.__proto__ || Object.getPrototypeOf(InputCalendarRange)).call(this, props));

    _this.inputFrom = null;
    _this.inputTo = null;
    _this.clickedInside = false;
    _this.clickTimeout = null;

    _this.handleContainerMouseDown = function () {
      _this.clickedInside = true;
      // The input's onBlur method is called from a queue right after onMouseDown event.
      // setTimeout adds another callback in the queue, but is called later than onBlur event
      _this.clickTimeout = setTimeout(function () {
        _this.clickedInside = false;
      }, 0);
    };

    _this.handleInputFromFocus = function () {
      if (_this.state.showOverlayRight) {
        _this.setState({
          showOverlayRight: false,
          showOverlay: true
        }, function () {
          _this.inputFrom.focus();
        });
      } else {
        _this.setState({
          showOverlay: true
        });
      }
    };

    _this.handleInputToFocus = function () {
      if (!_this.state.from) {
        _this.setState({
          showOverlayRight: false,
          showOverlay: true
        }, function () {
          _this.inputFrom.focus();
        });
      } else {
        _this.setState({
          showOverlayRight: true,
          showOverlay: false
        }, function () {
          _this.inputTo.focus();
        });
      }
    };

    _this.handleInputFromBlur = function () {
      var showOverlay = _this.clickedInside;
      _this.setState({
        showOverlay: showOverlay
      });
      // Force input's focus if blur event was caused by clicking on the calendar
      if (showOverlay && !_this.state.from) {
        _this.inputFrom.focus();
      }
    };

    _this.handleInputToBlur = function () {
      var showOverlayRight = _this.clickedInside;
      if (!_this.state.showOverlay) {
        _this.setState({
          showOverlayRight: showOverlayRight
        });
      }
    };

    _this.handleDayClick = function (day) {
      var range = _reactDayPicker.DateUtils.addDayToRange(day, _this.state);
      _this.setState(range, function () {
        if (_this.state.from && !_this.state.to) {
          _this.inputTo.focus();
          _this.setState({
            showOverlay: false,
            showOverlayRight: true
          });
        }
        if (_this.state.from && _this.state.to) {
          _this.setState({
            showOverlay: false,
            showOverlayRight: false
          }, function () {
            if (_this.state.showOverlayRight) {
              _this.inputTo.blur();
            }
            _this.props.onSetRange((0, _momentTimezone2.default)(_this.state.from).format('YYYY-MM-DD'), (0, _momentTimezone2.default)(_this.state.to).format('YYYY-MM-DD'));
          });
        }
      });
    };

    _this.handleReset = function () {
      _this.setState({
        from: null,
        to: null,
        showOverlay: false,
        showOverlayRight: false
      }, function () {
        _this.inputFrom.blur();
        _this.inputTo.blur();
        _this.props.onReset(_this.props.filterNameFrom, _this.props.filterNameTo);
      });
    };

    _this.handleClose = function () {
      _this.props.onClose();
    };

    _this.state = {
      showOverlay: false,
      showOverlayRight: false,
      value: '',
      from: _this.props.dateFrom ? new Date(_this.props.dateFrom) : null,
      to: _this.props.dateTo ? new Date(_this.props.dateTo) : null
    };
    return _this;
  }

  _createClass(InputCalendarRange, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearTimeout(this.clickTimeout);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var overlayStyle = {
        position: 'absolute',
        background: 'white',
        boxShadow: '0 2px 5px rgba(0, 0, 0, .15)',
        zIndex: '9999'
      };
      var overlayStyleRight = {
        position: 'absolute',
        background: 'white',
        boxShadow: '0 2px 5px rgba(0, 0, 0, .15)',
        zIndex: '9999',
        right: '0'
      };
      var _props = this.props,
          t = _props.t,
          i18n = _props.i18n;

      // Update moment locale when language changes

      var localeMap = {
        en: 'en-gb',
        vi: 'vi',
        id: 'id'
      };
      var currentLocale = localeMap[i18n.language] || 'en-gb';
      if (_momentTimezone2.default.locale() !== currentLocale) _momentTimezone2.default.locale(currentLocale);

      // Configure DayPicker locale
      var localeUtils = _extends({}, _reactDayPicker.LocaleUtils, {
        formatMonthTitle: function formatMonthTitle(date) {
          var monthIndex = date.getMonth();
          var monthName = _momentTimezone2.default.localeData(currentLocale).months()[monthIndex];
          var year = date.getFullYear();
          return monthName + ' ' + year;
        },
        formatWeekdayShort: function formatWeekdayShort(index) {
          return _momentTimezone2.default.localeData(currentLocale).weekdaysShort()[index];
        },
        formatWeekdayLong: function formatWeekdayLong(index) {
          return _momentTimezone2.default.localeData(currentLocale).weekdays()[index];
        }
      });

      var _state = this.state,
          from = _state.from,
          to = _state.to,
          showOverlay = _state.showOverlay,
          showOverlayRight = _state.showOverlayRight;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { onMouseDown: this.handleContainerMouseDown },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 7, tablet: 7, computer: 7 },
            _react2.default.createElement(
              'div',
              { className: 'ui fluid icon input' },
              _react2.default.createElement('input', {
                type: 'text',
                ref: function ref(el) {
                  _this2.inputFrom = el;
                },
                placeholder: t('Start date'),
                value: from ? (0, _momentTimezone2.default)(from).format('L') : '',
                onFocus: this.handleInputFromFocus,
                onBlur: this.handleInputFromBlur,
                readOnly: true
              }),
              _react2.default.createElement('i', { 'aria-hidden': 'true', className: 'calendar icon' })
            ),
            showOverlay && _react2.default.createElement(
              'div',
              { style: { position: 'relative' } },
              _react2.default.createElement(
                'div',
                { style: overlayStyle },
                _react2.default.createElement(_reactDayPicker2.default, {
                  numberOfMonths: 1,
                  selectedDays: [from, { from: from, to: to }],
                  onDayClick: this.handleDayClick,
                  locale: currentLocale,
                  localeUtils: localeUtils
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 7, tablet: 7, computer: 7 },
            _react2.default.createElement(
              'div',
              { className: 'ui fluid icon input' },
              _react2.default.createElement('input', {
                type: 'text',
                ref: function ref(el) {
                  _this2.inputTo = el;
                },
                placeholder: t('End date'),
                value: to ? (0, _momentTimezone2.default)(to).format('L') : '',
                onFocus: this.handleInputToFocus,
                onBlur: this.handleInputToBlur,
                readOnly: true
              }),
              _react2.default.createElement('i', { 'aria-hidden': 'true', className: 'calendar icon' })
            ),
            showOverlayRight && _react2.default.createElement(
              'div',
              { style: { position: 'relative' } },
              _react2.default.createElement(
                'div',
                { style: overlayStyleRight },
                _react2.default.createElement(_reactDayPicker2.default, {
                  numberOfMonths: 1,
                  selectedDays: [from, { from: from, to: to }],
                  onDayClick: this.handleDayClick,
                  locale: currentLocale,
                  localeUtils: localeUtils
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 2, verticalAlign: 'middle', className: 'clearicon' },
            _react2.default.createElement(_semanticUiReact.Button, {
              as: 'a',
              icon: to || from ? 'x' : 'arrow left',
              size: 'mini',
              circular: true,
              onClick: to || from ? this.handleReset : this.handleClose,
              title: to || from ? 'Reset' : 'Go Back'
            })
          )
        )
      );
    }
  }]);

  return InputCalendarRange;
}(_react.Component);

InputCalendarRange.propTypes = {
  dateFrom: _propTypes2.default.string,
  dateTo: _propTypes2.default.string,
  filterNameFrom: _propTypes2.default.string.isRequired,
  filterNameTo: _propTypes2.default.string.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  onSetRange: _propTypes2.default.func.isRequired,
  onReset: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(InputCalendarRange);

/***/ }),
/* 2142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DatePicker = __webpack_require__(2140);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DatePicker).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchList = function (_Component) {
  _inherits(SearchList, _Component);

  function SearchList(props) {
    _classCallCheck(this, SearchList);

    var _this = _possibleConstructorReturn(this, (SearchList.__proto__ || Object.getPrototypeOf(SearchList)).call(this, props));

    _initialiseProps.call(_this);

    var state = SearchList.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(SearchList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = SearchList.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'left', width: 14 },
                  _react2.default.createElement(_semanticUiReact.Search, {
                    aligned: 'left',
                    className: 'searchlist',
                    fluid: true,
                    icon: this.props.icon || 'caret down',
                    loading: this.props.loading,
                    onResultSelect: this.handleResultSelect,
                    onSearchChange: this.handleSearchChange,
                    results: this.props.results,
                    value: this.state.value,
                    placeholder: this.props.placeholder,
                    noResultsMessage: this.props.noResultsMessage,
                    onFocus: function onFocus() {
                      var showNoResults = false;
                      _this2.setState({ showNoResults: showNoResults });
                    },
                    showNoResults: this.state.showNoResults
                  })
                ),
                this.props.isActive && _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 2, verticalAlign: 'middle', className: 'clearicon' },
                  _react2.default.createElement(_semanticUiReact.Button, {
                    as: 'a',
                    circular: true,
                    icon: 'x',
                    onClick: this.handleClose,
                    size: 'mini',
                    title: 'Clear'
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return SearchList;
}(_react.Component);

SearchList.propTypes = {
  isActive: _propTypes2.default.bool.isRequired,
  onSelect: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  filterName: _propTypes2.default.string.isRequired,
  loading: _propTypes2.default.bool.isRequired,
  icon: _propTypes2.default.string,
  results: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired,
    description: _propTypes2.default.string.isRequired,
    image: _propTypes2.default.string
  })).isRequired,
  placeholder: _propTypes2.default.string,
  noResultsMessage: _propTypes2.default.string.isRequired,
  value: _propTypes2.default.string
};
SearchList.defaultProps = {
  hasSearch: false,
  headerText: 'Find Options',
  options: [],
  placeholder: 'Find Options...',
  value: ''
};

SearchList.getPropsToState = function (props) {
  var value = props.value || '';
  var showNoResults = props.showNoResults || true;
  return {
    value: value,
    showNoResults: showNoResults
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleClose = function () {
    _this3.setState({
      value: ''
    }, function () {
      _this3.props.onClose(_this3.props.filterName);
    });
  };

  this.handleResultSelect = function (e, _ref) {
    var result = _ref.result;

    _this3.props.onSelect(result, _this3.props.filterName);
  };

  this.handleSearchChange = function (e, _ref2) {
    var value = _ref2.value;

    var showNoResults = true;
    _this3.setState({
      value: value,
      showNoResults: showNoResults
    }, function () {
      _this3.props.onChange(value);
    });
  };
};

exports.default = SearchList;

/***/ }),
/* 2144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectList = function (_Component) {
  _inherits(SelectList, _Component);

  function SelectList(props) {
    _classCallCheck(this, SelectList);

    var _this = _possibleConstructorReturn(this, (SelectList.__proto__ || Object.getPrototypeOf(SelectList)).call(this, props));

    _initialiseProps.call(_this);

    var state = SelectList.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(SelectList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = SelectList.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 14 },
                  _react2.default.createElement(_semanticUiReact.Dropdown, {
                    disabled: this.props.disabled,
                    fluid: true,
                    header: this.props.headerText && this.props.headerText,
                    onChange: this.handleOnChange,
                    options: this.props.options,
                    placeholder: this.props.placeholder,
                    search: this.props.hasSearch,
                    selection: true,
                    selectOnBlur: false,
                    value: this.state.value,
                    open: this.state.onFocus,
                    onClick: this.handleOnFocusChange,
                    noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                  })
                ),
                this.props.value.length > 0 && _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 2, verticalAlign: 'middle', className: 'clearicon' },
                  _react2.default.createElement(_semanticUiReact.Button, {
                    as: 'a',
                    circular: true,
                    icon: 'x',
                    onClick: this.handleClose,
                    size: 'mini',
                    title: 'Clear'
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return SelectList;
}(_react.Component);

SelectList.propTypes = {
  disabled: _propTypes2.default.bool,
  filterName: _propTypes2.default.string.isRequired,
  hasSearch: _propTypes2.default.bool,
  headerText: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired
  })).isRequired,
  placeholder: _propTypes2.default.string,
  value: _propTypes2.default.string,
  onFocus: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
SelectList.defaultProps = {
  hasSearch: false,
  options: [],
  placeholder: 'Select an Option',
  value: '',
  onFocus: false
};

SelectList.getPropsToState = function (props) {
  var value = props.value || '';
  var onFocus = props.onFocus;
  return {
    value: value,
    onFocus: onFocus
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleOnChange = function (e, _ref) {
    var value = _ref.value;

    _this2.setState({
      value: value,
      onFocus: false
    }, function () {
      _this2.props.onChange(value, _this2.props.filterName);
    });
  };

  this.handleClose = function () {
    _this2.setState({
      value: ''
    }, function () {
      _this2.props.onClose(_this2.props.filterName);
    });
  };

  this.handleOnFocusChange = function () {
    _this2.setState({ onFocus: !_this2.state.onFocus });
  };
};

exports.default = (0, _reactI18next.withTranslation)([_translation.TRANSLATION_FILES.translation], { withRef: true })(SelectList);

/***/ }),
/* 2145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _i18next = __webpack_require__(94);

var _i18next2 = _interopRequireDefault(_i18next);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectListMultiple = function (_Component) {
  _inherits(SelectListMultiple, _Component);

  function SelectListMultiple(props) {
    _classCallCheck(this, SelectListMultiple);

    var _this = _possibleConstructorReturn(this, (SelectListMultiple.__proto__ || Object.getPrototypeOf(SelectListMultiple)).call(this, props));

    _initialiseProps.call(_this);

    var state = SelectListMultiple.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(SelectListMultiple, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = SelectListMultiple.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 14 },
                  _react2.default.createElement(_semanticUiReact.Dropdown, {
                    fluid: true,
                    header: this.props.headerText,
                    multiple: true,
                    onChange: this.handleOnChange,
                    options: this.state.options,
                    placeholder: this.props.placeholder,
                    search: this.props.hasSearch,
                    selection: true,
                    renderLabel: this.props.renderLabel,
                    selectOnBlur: false,
                    value: this.state.value,
                    disabled: this.props.disabled,
                    noResultsMessage: _i18next2.default.t('No results found', { ns: 'translation' })
                  })
                ),
                this.props.value.length > 0 && _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 2, verticalAlign: 'middle', className: 'clearicon' },
                  _react2.default.createElement(_semanticUiReact.Button, {
                    as: 'a',
                    circular: true,
                    icon: 'x',
                    onClick: this.handleClose,
                    size: 'mini',
                    title: 'Clear'
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return SelectListMultiple;
}(_react.Component);

SelectListMultiple.propTypes = {
  filterName: _propTypes2.default.string.isRequired,
  hasSearch: _propTypes2.default.bool,
  headerText: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired
  })).isRequired,
  placeholder: _propTypes2.default.string,
  value: _propTypes2.default.arrayOf(_propTypes2.default.string.isRequired),
  disabled: _propTypes2.default.bool,
  renderLabel: _propTypes2.default.func
};
SelectListMultiple.defaultProps = {
  hasSearch: false,
  headerText: 'Select Options',
  options: [],
  placeholder: 'Select Options',
  value: []
};

SelectListMultiple.getPropsToState = function (props) {
  var value = props.value || [];
  var options = props.options || [];
  var limit = props.limit || 0;
  if (limit > 0) {
    options = options.map(function (d) {
      return _extends({
        disabled: limit > 0 && value.length >= limit
      }, d);
    });
  }
  // #FIX: add blank space. text & value cannot be same as description value.
  options = options.map(function (d) {
    if (d.shortName) {
      return _extends({}, d, {
        description: ' ' + d.shortName
      });
    }
    return _extends({}, d);
  });
  return {
    value: value,
    options: options
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleOnChange = function (e, _ref) {
    var value = _ref.value;

    _this2.setState({
      value: value
    }, function () {
      _this2.props.onChange(value, _this2.props.filterName);
    });
  };

  this.handleClose = function () {
    _this2.setState({
      value: []
    }, function () {
      _this2.props.onClose(_this2.props.filterName);
    });
  };
};

exports.default = SelectListMultiple;

/***/ }),
/* 2146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _webValidations = __webpack_require__(23);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FinanceSourceList = function (_Component) {
  _inherits(FinanceSourceList, _Component);

  function FinanceSourceList(props) {
    _classCallCheck(this, FinanceSourceList);

    var _this = _possibleConstructorReturn(this, (FinanceSourceList.__proto__ || Object.getPrototypeOf(FinanceSourceList)).call(this, props));

    _this.handleLabelChange = function (event, _ref) {
      var name = _ref.name,
          value = _ref.value;
      var data = _this.state.data;

      var index = data.findIndex(function (d) {
        return d.id === name;
      });
      if (index >= 0) {
        data[index].label = value;
      }
      _this.setState({ data: data }, function () {
        _this.props.onChange(data);
      });
    };

    _this.handleEnabledChange = function (event, _ref2) {
      var name = _ref2.name;
      var data = _this.state.data;

      var index = data.findIndex(function (f) {
        return f.id === name;
      });
      if (index >= 0) {
        data[index].isEnabled = !data[index].isEnabled;
      }
      _this.setState({ data: data }, function () {
        _this.props.onChange(data);
      });
    };

    _this.handleOnAddFinanceSource = function () {
      var newData = _this.state.data;
      newData.push({
        id: (0, _momentTimezone2.default)().toDate().getTime(),
        label: '',
        isDefault: false,
        isEnabled: false
      });
      _this.setState({ data: newData }, function () {
        _this.props.onChange(newData);
      });
    };

    _this.handleOnRemoveFinanceSource = function (id) {
      var newData = _this.state.data.filter(function (d) {
        return d.id !== id;
      });
      _this.setState({ data: newData }, function () {
        _this.props.onChange(newData);
      });
    };

    _this.renderFinanceItem = function (key, field) {
      return _react2.default.createElement(
        _semanticUiReact.Table.Row,
        { key: key },
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { width: 9 },
          field.isDefault ? _this.props.t(field.label, { ns: _translation.TRANSLATION_FILES.constants }) : _react2.default.createElement(_AppForm2.default.Input, {
            validateLabel: 'Label',
            name: field.id,
            value: field.label,
            validation: [_webValidations.required],
            onChange: _this.handleLabelChange,
            ref: function ref(_ref3) {
              _this.validation[field.id + '_label'] = _ref3;
            }
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { width: 3, textAlign: 'right' },
          _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
            toggle: true,
            checked: field.isEnabled,
            name: field.id,
            onChange: _this.handleEnabledChange,
            disabled: !_this.props.isForeignCompany && field.id.toString().includes('referred_banker')
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { width: 1, textAlign: 'right' },
          !field.createdAt && _react2.default.createElement(_semanticUiReact.Button, {
            floated: 'right',
            negative: true,
            type: 'button',
            size: 'small',
            icon: 'trash',
            onClick: function onClick() {
              return _this.handleOnRemoveFinanceSource(field.id);
            }
          })
        )
      );
    };

    _this.state = {
      count: 0,
      loading: props.loading || true,
      data: [],
      errMessages: []
    };
    _this.validation = {};
    return _this;
  }

  _createClass(FinanceSourceList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchFinanceSources();
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'validate',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this4 = this;

        var data, stateData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = this.state.data;
                stateData = data.reduce(function (d, cur) {
                  return _extends({}, d, _defineProperty({}, cur.id + '_label', cur.label));
                }, {});
                return _context.abrupt('return', _AppForm2.default.validate(this.validation, stateData).then(function (validations) {
                  _this4.setState({
                    errMessages: validations.filter(function (v) {
                      return !v.isValid;
                    })
                  });
                  return validations;
                }));

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function validate() {
        return _ref4.apply(this, arguments);
      }

      return validate;
    }()
  }, {
    key: 'fetchFinanceSources',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var t, store, query, res, message, count, token, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                query = {
                  page: 'all'
                };
                res = void 0;
                _context2.prev = 6;
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/finance_sources/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context2.sent;
                _context2.next = 20;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context2.next = 19;
                return this.setLoading(false);

              case 19:
                return _context2.abrupt('return');

              case 20:
                if (res.ok) {
                  _context2.next = 28;
                  break;
                }

                _context2.next = 23;
                return res.text();

              case 23:
                message = _context2.sent;
                _context2.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context2.next = 36;
                break;

              case 28:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                token = res.headers.get('X-Csrf-Token');
                _context2.next = 32;
                return res.json();

              case 32:
                data = _context2.sent;
                _context2.next = 35;
                return this.setComponentState({
                  count: count,
                  token: token,
                  data: data
                });

              case 35:
                this.props.onOriChange(data);

              case 36:
                _context2.next = 38;
                return this.setLoading(false);

              case 38:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 12]]);
      }));

      function fetchFinanceSources() {
        return _ref5.apply(this, arguments);
      }

      return fetchFinanceSources;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 20 },
            active: this.state.loading && this.state.data.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            striped: true, unstackable: true,
            selectable: true
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 9 },
                t('Label', { ns: _translation.TRANSLATION_FILES.screens })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 3, textAlign: 'right' },
                t('Enabled', { ns: _translation.TRANSLATION_FILES.screens })
              ),
              _react2.default.createElement(_semanticUiReact.Table.HeaderCell, { width: 1 })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            this.state.data.length > 0 ? this.state.data.map(function (field, key) {
              return _this5.renderFinanceItem(key, field);
            }) : _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 3, textAlign: 'center' },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                ) : _react2.default.createElement(
                  'p',
                  null,
                  t('No finance sources found.', { ns: _translation.TRANSLATION_FILES.translation })
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 3, textAlign: 'center' },
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    primary: true, compact: true,
                    disabled: this.state.loading,
                    onClick: this.handleOnAddFinanceSource
                  },
                  '+ ',
                  t('Add New Source', { ns: _translation.TRANSLATION_FILES.translation })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return FinanceSourceList;
}(_react.Component);

FinanceSourceList.contextTypes = {
  store: _propTypes2.default.object
};
FinanceSourceList.propTypes = {
  loading: _propTypes2.default.bool,
  onOriChange: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  isForeignCompany: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(FinanceSourceList);

/***/ }),
/* 2147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Flash = function (_Component) {
  _inherits(Flash, _Component);

  function Flash(props) {
    _classCallCheck(this, Flash);

    var _this = _possibleConstructorReturn(this, (Flash.__proto__ || Object.getPrototypeOf(Flash)).call(this, props));

    _this.handleDismiss = function () {
      _this.close();
    };

    _this.timer = null;
    _this.state = {
      visible: false
    };
    return _this;
  }

  _createClass(Flash, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var flash = nextProps.flash;

      if (flash) {
        var visible = flash.show;
        this.clearTimer();
        this.setState({
          visible: visible
        }, function () {
          if (flash.autoHideDuration > 0) {
            if (visible) {
              _this2.timer = setTimeout(function () {
                _this2.close();
              }, flash.autoHideDuration);
            }
          }
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearTimer();
    }
  }, {
    key: 'clearTimer',
    value: function clearTimer() {
      clearTimeout(this.timer);
    }
  }, {
    key: 'close',
    value: function close() {
      var _this3 = this;

      this.clearTimer();
      this.setState({
        visible: false
      }, function () {
        setTimeout(function () {
          var store = _this3.context.store;

          store.dispatch((0, _flash.resetFlashMessage)());
        }, 600);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var flash = this.props.flash;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        { className: 'flash ' + (this.state.visible ? 'show' : '') },
        _react2.default.createElement(_semanticUiReact.Message, {
          onDismiss: this.handleDismiss,
          header: flash.header,
          content: flash.message,
          list: flash.list,
          icon: flash.icon,
          color: flash.color && !flash.type ? flash.color : null,
          error: flash.type === 'error',
          info: flash.type === 'info',
          negative: flash.type === 'negative',
          positive: flash.type === 'positive',
          success: flash.type === 'success',
          warning: flash.type === 'warning'
        })
      );
    }
  }]);

  return Flash;
}(_react.Component);

Flash.propTypes = {
  flash: _propTypes2.default.shape({
    header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    message: _propTypes2.default.string,
    list: _propTypes2.default.arrayOf(_propTypes2.default.string),
    icon: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    color: _propTypes2.default.string,
    type: _propTypes2.default.string,
    show: _propTypes2.default.bool,
    autoHideDuration: _propTypes2.default.number
  })
};

Flash.contextTypes = {
  store: _propTypes2.default.object
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    flash: state.flash
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Flash);

/***/ }),
/* 2148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

__webpack_require__(3506);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var classNames = function classNames(className, _ref) {
  var vertical = _ref.vertical;

  var names = [];
  if (className) {
    names.push(className);
  }
  if (vertical) {
    names.push('vertical');
  }
  return names.join(' ');
};

var FormGroup = function FormGroup(_ref2) {
  var children = _ref2.children,
      vertical = _ref2.vertical;
  return _react2.default.createElement(
    'div',
    { className: classNames('FormGroup', { vertical: vertical }) },
    children
  );
};

FormGroup.propTypes = {
  children: _propTypes2.default.node.isRequired,
  vertical: _propTypes2.default.bool
};

FormGroup.defaultProps = {
  vertical: false
};

var InputGroup = function InputGroup(_ref3) {
  var children = _ref3.children;
  return _react2.default.createElement(
    'div',
    { className: 'InputGroup' },
    children
  );
};

InputGroup.propTypes = {
  children: _propTypes2.default.node.isRequired
};

FormGroup.InputGroup = InputGroup;

exports.default = FormGroup;

/***/ }),
/* 2149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _reactRouter = __webpack_require__(18);

var _semanticUiReact = __webpack_require__(2);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _url = __webpack_require__(19);

var _Filters = __webpack_require__(86);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _SearchIn = __webpack_require__(570);

var _SearchIn2 = _interopRequireDefault(_SearchIn);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _ModalNotice = __webpack_require__(588);

var _ModalNotice2 = _interopRequireDefault(_ModalNotice);

var _HimsErrorLog = __webpack_require__(1022);

var _HimsErrorLog2 = _interopRequireDefault(_HimsErrorLog);

var _hims = __webpack_require__(221);

var _strings = __webpack_require__(118);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint jsx-a11y/no-static-element-interactions: 0 */

var allFilterNames = ['dateRange', 'dateFrom', 'dateTo', 'projectFilter', 'status', 'search'];

var HIMSBookingsList = function (_Component) {
  _inherits(HIMSBookingsList, _Component);

  function HIMSBookingsList(props) {
    _classCallCheck(this, HIMSBookingsList);

    var _this = _possibleConstructorReturn(this, (HIMSBookingsList.__proto__ || Object.getPrototypeOf(HIMSBookingsList)).call(this, props));

    _initialiseProps.call(_this);

    var state = HIMSBookingsList.getPropsToState(props);
    var shiftSelect = { start: null, end: null };
    _this.state = _extends({
      loading: true,
      count: 0,
      data: [],
      dataByStatus: []
    }, state, {
      isChanging: false,
      projectOpts: [],
      filteredProjects: [],
      shiftSelect: shiftSelect,
      errorModalOpen: false,
      isSelectedAll: false,
      himsErrorLog: null
    });
    return _this;
  }

  _createClass(HIMSBookingsList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      this.fetchProjects();
      if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
        delete query.page;
      }
      this.replaceQuery(query);
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = HIMSBookingsList.getPropsToState(nextProps);
      this.setState(state);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'fetchProjects',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var store, query, res, message, _message, data, newProjectOpts;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                query = Object.assign({
                  limit: 0,
                  showAsOptions: true,
                  hims: true
                });
                _context.next = 4;
                return this.setLoadingProjectSearch(true);

              case 4:
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 23;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                if (!(_context.t0.res && _context.t0.res.status >= 399 && _context.t0.res.status < 500)) {
                  _context.next = 18;
                  break;
                }

                _context.next = 16;
                return _context.t0.res.text();

              case 16:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 18:
                _context.next = 20;
                return this.setLoadingProjectSearch(false);

              case 20:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context.abrupt('return');

              case 23:
                if (res.ok) {
                  _context.next = 31;
                  break;
                }

                _context.next = 26;
                return res.text();

              case 26:
                _message = _context.sent;
                _context.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 29:
                _context.next = 38;
                break;

              case 31:
                _context.next = 33;
                return res.json();

              case 33:
                data = _context.sent;
                newProjectOpts = this.state.projectOpts;

                if (data && data.length > 0) {
                  newProjectOpts = data.map(function (d) {
                    return { value: d.id, text: d.name };
                  });
                }

                _context.next = 38;
                return this.setState({ projectOpts: newProjectOpts }, function () {
                  _this2.handleFilterProjects(null, { name: 'projectFilter', value: [newProjectOpts[0].value] });
                });

              case 38:
                _context.next = 40;
                return this.setLoadingProjectSearch(false);

              case 40:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchProjects() {
        return _ref.apply(this, arguments);
      }

      return fetchProjects;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var fetch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var store = this.context.store;
      var _props$location = this.props.location,
          pathname = _props$location.pathname,
          search = _props$location.search;

      var queryNew = query;
      this.setState({ isSelectedAll: false });
      if (resetPage) {
        queryNew.page = 1;
      }
      var status = (0, _url.decodeSearch)(search).status;
      if (query.status && !status) {
        queryNew.page = 1;
      }
      if (fetch) {
        this.fetchBookings(queryNew);
      }
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          loading = _state.loading,
          dataByStatus = _state.dataByStatus,
          isMobile = _state.isMobile,
          errorModalOpen = _state.errorModalOpen,
          himsErrorLog = _state.himsErrorLog;

      var sortItems = [{
        text: 'Unit Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'project_unit.reference',
        sortDirection: 'asc'
      }, {
        text: 'Unit Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'project_unit.reference',
        sortDirection: 'desc'
      }, {
        text: 'Date Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'booking.created_at',
        sortDirection: 'asc'
      }, {
        text: 'Date Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'booking.created_at',
        sortDirection: 'desc'
      }, {
        text: 'Booking Status Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'booking_status.name',
        sortDirection: 'asc'
      }, {
        text: 'Booking Status Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'booking_status.name',
        sortDirection: 'desc'
      }];
      var exportItems = [{
        text: 'Excel',
        icon: 'download',
        href: this.exportURL()
      }];
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { verticalAlign: 'middle', className: 'booking-list' },
        _react2.default.createElement(_ModalNotice2.default, {
          open: errorModalOpen,
          onClose: this.handleCloseErrorModal,
          headerNode: 'HIMS Error Logs',
          content: himsErrorLog ? _react2.default.createElement(_HimsErrorLog2.default, himsErrorLog) : ''
        }),
        this.renderMenuTool(),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'app--listdata' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Dimmer,
              {
                inverted: true, style: { zIndex: 20 },
                active: loading && dataByStatus.length > 0
              },
              _react2.default.createElement(
                _semanticUiReact.Loader,
                { inline: 'centered' },
                'Loading'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { className: 'booking-data', columns: 'equal', verticalAlign: 'middle' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { className: 'header' },
                isMobile && _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'center', mobile: 2 },
                  _react2.default.createElement(_semanticUiReact.Checkbox, {
                    checked: this.state.isSelectedAll,
                    disabled: dataByStatus.length < 1,
                    onChange: function onChange(e) {
                      if (dataByStatus.length > 0) _this3.handleCheckboxSelectAll(e);
                    }
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 7, tablet: 6, computer: 6 },
                  _react2.default.createElement(
                    _semanticUiReact.Header,
                    { as: 'h2' },
                    'Latest Bookings'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 7, tablet: 10, computer: 10, textAlign: 'right', className: 'download' },
                  _react2.default.createElement(
                    _semanticUiReact.Button,
                    {
                      floated: 'right',
                      style: { marginLeft: '0.5em' },
                      primary: true,
                      icon: isMobile,
                      disabled: this.state.loading || !dataByStatus.some(function (b) {
                        return b.isSelected;
                      }),
                      onClick: this.batchSyncSelectedBookings
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'redo' }),
                    !isMobile && 'Sync to HIMS'
                  ),
                  _react2.default.createElement(_SortButton2.default, {
                    floated: 'right',
                    loading: loading,
                    items: sortItems,
                    onSort: this.handleSortData
                  }),
                  exportItems.length > 0 && _react2.default.createElement(_SortButton2.default, {
                    floated: 'right',
                    icon: 'download',
                    loading: loading,
                    items: exportItems
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 16 },
                  _react2.default.createElement(
                    _semanticUiReact.Table,
                    { basic: 'very', sortable: true, className: 'hims_bookings' },
                    this.renderTableHeaders(sortItems),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Body,
                      null,
                      dataByStatus.length > 0 ? dataByStatus.map(this.renderTableRow) : _react2.default.createElement(
                        _semanticUiReact.Table.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Table.Cell,
                          { colSpan: 10, textAlign: 'center' },
                          loading ? _react2.default.createElement(
                            _semanticUiReact.Loader,
                            { active: true, inline: 'centered' },
                            'Loading'
                          ) : _react2.default.createElement(
                            'p',
                            null,
                            'No bookings found.'
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'center' },
            _react2.default.createElement(_PageNav2.default, {
              upward: true,
              currentPage: this.state.currentPage,
              count: this.state.count,
              limit: this.state.limit,
              offset: this.state.offset,
              dataSize: dataByStatus.length,
              loading: loading,
              onChange: this.handleChangePage,
              noScrollTop: this.props.noScrollTop
            })
          )
        )
      );
    }
  }]);

  return HIMSBookingsList;
}(_react.Component);

HIMSBookingsList.contextTypes = {
  store: _propTypes2.default.object
};
HIMSBookingsList.propTypes = {
  where: _propTypes2.default.shape({}),
  onLoading: _propTypes2.default.func,
  noScrollTop: _propTypes2.default.bool,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  })
};

HIMSBookingsList.getPropsToState = function (props) {
  var windowWidth = window.innerWidth;
  var isMobile = windowWidth < 768;
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var limit = 30;
  var offset = (currentPage - 1) * limit;
  var search = query.search || '';
  var searchIn = query.searchIn || '';
  var dateRange = query.dateRange || '';
  var projectFilter = query.projectFilter || '';
  var dateFrom = query.dateFrom ? query.dateFrom : '';
  var dateTo = query.dateTo ? query.dateTo : '';
  var loadingProjectSearch = false;
  var findProjectResults = [];
  var status = query.status || '';
  return {
    isMobile: isMobile,
    search: search,
    searchIn: searchIn,
    dateRange: dateRange,
    projectFilter: projectFilter,
    dateTo: dateTo,
    dateFrom: dateFrom,
    loadingProjectSearch: loadingProjectSearch,
    findProjectResults: findProjectResults,
    currentPage: currentPage,
    limit: limit,
    offset: offset,
    status: status
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleCloseErrorModal = function (e) {
    e.preventDefault();
    _this4.setState({ errorModalOpen: false, himsErrorLog: null });
  };

  this.handleOpenErrorModal = function (e, himsErrorLog) {
    e.preventDefault();
    _this4.setState({ errorModalOpen: true, himsErrorLog: himsErrorLog });
  };

  this.handleCheckboxClick = function (event, b) {
    var _state2 = _this4.state,
        shiftSelect = _state2.shiftSelect,
        data = _state2.data;

    var index = data.findIndex(function (r) {
      return r.id === b.id;
    });
    if (event.shiftKey) {
      if (data[shiftSelect.start].isSelected !== data[index].isSelected) {
        shiftSelect.end = null;
      }
      if (shiftSelect.start === null) {
        shiftSelect.start = index;
      }
      if (shiftSelect.start !== index) {
        if (shiftSelect.start > index) {
          data.forEach(function (d, idx) {
            if (_this4.isBookingSelectable(d)) {
              if (idx >= index && idx <= shiftSelect.start) {
                data[idx].isSelected = data[shiftSelect.start].isSelected;
              }
              if (shiftSelect.end && idx >= shiftSelect.end && idx <= index) {
                data[idx].isSelected = !data[shiftSelect.start].isSelected;
              }
            }
          });
        }
        if (shiftSelect.start < index) {
          data.forEach(function (d, idx) {
            if (_this4.isBookingSelectable(d)) {
              if (idx >= shiftSelect.start && idx <= index) {
                data[idx].isSelected = data[shiftSelect.start].isSelected;
              }
              if (shiftSelect.end && idx >= index && idx <= shiftSelect.end) {
                data[idx].isSelected = !data[shiftSelect.start].isSelected;
              }
            }
          });
        }
        shiftSelect.end = index;
      } else {
        data[index].isSelected = !data[index].isSelected;
      }
    } else {
      data[index].isSelected = !data[index].isSelected;
      shiftSelect.start = index;
      shiftSelect.end = null;
    }
    _this4.setState({ shiftSelect: shiftSelect, data: data, isSelectedAll: false });
  };

  this.isBookingSelectable = function (data) {
    if (data && (!data.himsServiceID || data.himsHasChanges || data.himsServiceStatus === 'failed' || data.himsServiceErrors && data.himsServiceErrors.length > 0)) {
      return true;
    }
    return false;
  };

  this.handleCheckboxSelectAll = function () {
    var _state3 = _this4.state,
        shiftSelect = _state3.shiftSelect,
        data = _state3.data;

    var isSelectedAll = !_this4.state.isSelectedAll;
    shiftSelect.start = null;
    shiftSelect.end = null;
    data.forEach(function (d, idx) {
      if (_this4.isBookingSelectable(d)) {
        data[idx].isSelected = !_this4.state.isSelectedAll;
      }
    });
    _this4.setState({ shiftSelect: shiftSelect, data: data, isSelectedAll: isSelectedAll });
  };

  this.getDataByPage = function (page) {
    var replaceQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var _state4 = _this4.state,
        data = _state4.data,
        limit = _state4.limit,
        status = _state4.status;

    var newData = data || [];
    var count = data.length || 0;

    // filter by status
    if (status) {
      var cleanStatus = status.replace('hims-', '');
      newData = newData.filter(function (b) {
        return b.himsServiceStatus === (cleanStatus === 'pending' ? '' : cleanStatus);
      });
      count = newData.length;
    }

    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    var currentPage = parseInt(page, 10);
    var offset = (currentPage - 1) * limit;
    query.page = currentPage;
    newData = newData.slice((page - 1) * limit, page * limit);

    _this4.setState({ dataByStatus: newData, count: count, currentPage: currentPage, offset: offset });
    if (replaceQuery) _this4.replaceQuery(query);
  };

  this.setLoadingProjectSearch = function () {
    var loadingProjectSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this4.setState({ loadingProjectSearch: loadingProjectSearch }, res);
    });
  };

  this.setBookings = function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return new Promise(function (res) {
      _this4.setState({
        data: data || []
      }, function () {
        res(data);
      });
    });
  };

  this.setComponentState = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new Promise(function (res) {
      _this4.setState(state, function () {
        res(state);
      });
    });
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this4.setState({ loading: loading }, function () {
        if (_this4.props.onLoading) {
          _this4.props.onLoading(loading);
        }
        res(loading);
      });
    });
  };

  this.fetchBookings = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var store, query, res, message, _message2, count, token, data, que, currentPage;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this4.setLoading(true);

            case 2:
              store = _this4.context.store;
              query = Object.assign(q, _this4.props.where || {});
              res = void 0;

              if (_this4.props.projectUnitID) {
                query.projectUnitID = _this4.props.projectUnitID;
              }

              _context2.prev = 6;
              _context2.next = 9;
              return store.dispatch((0, _fetchM.fetchM)('/bookings/hims/?' + _qs2.default.stringify(query), {
                credentials: 'include',
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }));

            case 9:
              res = _context2.sent;
              _context2.next = 24;
              break;

            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2['catch'](6);

              if (!(_context2.t0.res && _context2.t0.res.status >= 399 && _context2.t0.res.status < 500)) {
                _context2.next = 19;
                break;
              }

              _context2.next = 17;
              return _context2.t0.res.text();

            case 17:
              message = _context2.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

            case 19:
              _context2.next = 21;
              return _this4.setLoading(false);

            case 21:
              Bugsnag.notifyException(_context2.t0);
              store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
              return _context2.abrupt('return');

            case 24:
              if (res.ok) {
                _context2.next = 32;
                break;
              }

              _context2.next = 27;
              return res.text();

            case 27:
              _message2 = _context2.sent;
              _context2.next = 30;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: _message2 }));

            case 30:
              _context2.next = 49;
              break;

            case 32:
              count = parseInt(res.headers.get('M-Data-count'), 10);
              token = res.headers.get('X-Csrf-Token');
              _context2.next = 36;
              return res.json();

            case 36:
              data = _context2.sent;
              _context2.next = 39;
              return _this4.setBookings(data ? data.map(function (d) {
                return Object.assign({}, d, { isSelected: false });
              }) : []);

            case 39:
              que = (0, _url.decodeSearch)(_this4.props.location.search);
              currentPage = parseInt(que.page, 10) || 1;

              if (!(_this4.state.data.length < 1 && query.page > 1)) {
                _context2.next = 46;
                break;
              }

              que.page = 1;
              _this4.replaceQuery(que);
              _context2.next = 48;
              break;

            case 46:
              _context2.next = 48;
              return _this4.setComponentState({
                count: count,
                token: token
              });

            case 48:
              _this4.getDataByPage(currentPage || 1);

            case 49:
              _context2.next = 51;
              return _this4.setLoading(false);

            case 51:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this4, [[6, 12]]);
    }));

    return function () {
      return _ref2.apply(this, arguments);
    };
  }();

  this.batchSyncSelectedBookings = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var ids, store, res, message, que;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this4.setLoading(true);

          case 2:
            ids = _this4.state.data.filter(function (d) {
              return d.isSelected;
            }).map(function (d) {
              return d.id;
            });
            store = _this4.context.store;
            res = void 0;
            _context3.prev = 5;
            _context3.next = 8;
            return store.dispatch((0, _fetchM.fetchM)('/bookings/hims/bulk/', {
              credentials: 'include',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Csrf-Token': _this4.state.token
              },
              body: JSON.stringify({ ids: ids })
            }));

          case 8:
            res = _context3.sent;
            _context3.next = 19;
            break;

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3['catch'](5);

            Bugsnag.notifyException(_context3.t0);
            _context3.next = 16;
            return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

          case 16:
            _context3.next = 18;
            return _this4.setLoading(false);

          case 18:
            return _context3.abrupt('return');

          case 19:
            if (res.ok) {
              _context3.next = 25;
              break;
            }

            _context3.next = 22;
            return res.text();

          case 22:
            message = _context3.sent;
            _context3.next = 25;
            return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

          case 25:
            _context3.next = 27;
            return _this4.setLoading(false);

          case 27:
            que = (0, _url.decodeSearch)(_this4.props.location.search);

            que.page = 1;
            _this4.replaceQuery(que);

            _context3.next = 32;
            return store.dispatch((0, _flash.flashSuccessMessage)({ message: 'HIMS sync successfully triggered' }));

          case 32:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this4, [[5, 11]]);
  }));

  this.handleResize = function () {
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    if (isMobile !== _this4.state.isMobile) {
      _this4.setState({ isMobile: isMobile });
    }
  };

  this.handleChangePage = function (page) {
    var limit = _this4.state.limit;

    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
      query.page = 1;
    }
    var currentPage = parseInt(page || query.page, 10);
    var offset = (currentPage - 1) * limit;
    query.page = currentPage;
    _this4.setState({ currentPage: currentPage, offset: offset }, function () {
      _this4.replaceQuery(query);
    });
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this4.replaceQuery(query, true);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var clearSearch = false;
    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (filter === 'search') {
        clearSearch = true;
      }
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
        _this4.setState({ isChanging: false });
      }
      if (filter === 'projectFilter') {
        _this4.setState({
          filteredProjects: []
        });
      }
    });
    var cb = function cb() {
      if (hasQuery) {
        _this4.replaceQuery(query, true);
      }
    };
    if (clearSearch) {
      _this4.setState({ search: '' }, function () {
        cb();
      });
    } else {
      cb();
    }
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    query[queryName] = value;
    var refetch = queryName !== 'searchIn' || queryName === 'searchIn' && _this4.state.search.length > 0;
    if (queryName === 'dateRange' && query.dateRange === 'custom' && (!query.dateFrom || !query.dateTo)) {
      refetch = false;
    }
    _this4.setState({ isChanging: true });
    _this4.replaceQuery(query, true, refetch);
  };

  this.handleSetDateRange = function (from, to) {
    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    query.dateFrom = from;
    query.dateTo = to;
    _this4.replaceQuery(query, true);
  };

  this.handleReplaceStatus = function () {
    var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    if (status !== '') {
      query.status = status;
    } else {
      delete query.status;
    }
    _this4.replaceQuery(query, true, false);
    _this4.setState({ status: status }, function () {
      _this4.getDataByPage(query.page);
    });
  };

  this.handleFilterProjects = function (e, _ref4) {
    var name = _ref4.name,
        value = _ref4.value;

    _this4.setState({
      filteredProjects: value,
      isChanging: true
    });
    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    query[name] = btoa(value);
    _this4.replaceQuery(query, true);
  };

  this.exportURL = function () {
    var location = _this4.props.location;

    var url = _config2.default.get('bookApiURL') + '/bookings/hims/export/';
    if (location && location.search) {
      url += '' + location.search;
    }
    return url;
  };

  this.cellCheckSorted = function (column) {
    var isReversed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var _decodeSearch = (0, _url.decodeSearch)(_this4.props.location.search),
        sortColumn = _decodeSearch.sortColumn,
        sortDirection = _decodeSearch.sortDirection;
    // API default sorted by created at descending


    if (!sortColumn) {
      return 'descending';
    }
    if (column === sortColumn) {
      if (isReversed) {
        return sortDirection === 'asc' ? 'descending' : 'ascending';
      }
      return sortDirection === 'asc' ? 'ascending' : 'descending';
    }
    return null;
  };

  this.handleCellSort = function (column) {
    var _decodeSearch2 = (0, _url.decodeSearch)(_this4.props.location.search),
        sortColumn = _decodeSearch2.sortColumn,
        sortDirection = _decodeSearch2.sortDirection;

    var direction = 'asc';
    if (column === sortColumn) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc';
    }
    _this4.handleSortData(column, direction);
  };

  this.renderMenuTool = function () {
    var _state5 = _this4.state,
        isMobile = _state5.isMobile,
        loading = _state5.loading,
        loadingProjectSearch = _state5.loadingProjectSearch,
        isChanging = _state5.isChanging;

    var syncStatuses = [{ text: 'All', value: 'all', name: 'all' }].concat(_toConsumableArray(_hims.HIMS_BOOKING_SYNC_STATUSES));
    return _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { className: 'toolbar new' },
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 16 },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          {
            className: 'filters booking',
            columns: 'equal',
            textAlign: 'left',
            verticalAlign: 'middle'
          },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter',
                mobile: 16,
                tablet: 8,
                computer: 2,
                style: isMobile ? { marginBottom: '6px' } : null
              },
              _react2.default.createElement(
                'label',
                { htmlFor: 'status', style: { fontWeight: 600, marginBottom: '5px', display: 'block' } },
                'Sync Status'
              ),
              _react2.default.createElement(_Filters.BookingSelectList, {
                filterName: 'status',
                onChange: _this4.handleReplaceStatus,
                options: syncStatuses,
                placeholder: 'Status',
                value: _this4.state.status || 'all',
                disabled: loading
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter',
                mobile: 16,
                tablet: 8,
                computer: 3
              },
              _react2.default.createElement(
                'label',
                { htmlFor: 'dateRange', style: { fontWeight: 600, marginBottom: '5px', display: 'block' } },
                'Date Range'
              ),
              _react2.default.createElement(_Filters.BookingDatePicker, {
                filterName: 'dateRange',
                filterNameFrom: 'dateFrom',
                filterNameTo: 'dateTo',
                headerText: 'Date Range',
                placeholder: 'Select Date Range',
                dateFrom: _this4.state.dateFrom,
                dateTo: _this4.state.dateTo,
                onChange: _this4.handleFilterOnChange,
                onClose: _this4.handleClearFilter,
                onResetRange: _this4.handleClearFilter,
                onSetRange: _this4.handleSetDateRange,
                value: _this4.state.dateRange,
                disabled: loading
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter',
                mobile: isChanging ? 14 : 16,
                tablet: isChanging ? 7 : 8,
                computer: 6,
                style: isMobile ? { paddingTop: '0.5rem' } : null
              },
              _react2.default.createElement(
                'label',
                { htmlFor: 'projectFilter', style: { fontWeight: 600, marginBottom: '5px', display: 'block' } },
                'Project'
              ),
              _react2.default.createElement(_semanticUiReact.Dropdown, {
                disabled: loading || loadingProjectSearch,
                fluid: true,
                loading: loadingProjectSearch,
                multiple: true,
                name: 'projectFilter',
                onChange: _this4.handleFilterProjects,
                options: _this4.state.projectOpts,
                placeholder: 'Find Project',
                search: true,
                selection: true,
                value: _this4.state.filteredProjects
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'clear',
                textAlign: 'center',
                verticalAlign: 'middle',
                mobile: 2,
                tablet: 1,
                computer: 1,
                style: { marginTop: '20px' }
              },
              allFilterNames.some(function (filterName) {
                return _this4.state[filterName] && _this4.state[filterName].length > 0;
              }) ? _react2.default.createElement(
                'a',
                { onClick: function onClick() {
                    return _this4.handleClearFilter.apply(_this4, allFilterNames);
                  } },
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  { icon: true, basic: true, className: 'teal-remove' },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove circle', size: 'large' })
                )
              ) : null
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                floated: 'right',
                mobile: 16,
                tablet: 8,
                computer: 4
              },
              _react2.default.createElement(
                'label',
                { htmlFor: 'search', style: { fontWeight: 600, marginBottom: '5px', display: 'block' } },
                'Search'
              ),
              _react2.default.createElement(_SearchIn2.default, {
                isLoading: loading,
                onChange: _this4.handleFilterOnChange,
                onSearchInChange: _this4.handleFilterOnChange,
                onClear: _this4.handleClearFilter,
                search: _this4.state.search,
                placeholder: 'Search by unit & purchaser'
              })
            )
          )
        )
      )
    );
  };

  this.renderMobileCell = function (data) {
    return _react2.default.createElement(
      _semanticUiReact.Grid,
      {
        columns: 'equal',
        verticalAlign: 'middle'
      },
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { textAlign: 'center', mobile: 2 },
        _react2.default.createElement(_semanticUiReact.Checkbox, {
          checked: data.isSelected,
          name: 'isSelected',
          disabled: !_this4.isBookingSelectable(data)
        })
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        _react2.default.createElement(
          _reactRouter.Link,
          { title: data.code, to: '/bookings/' + data.id + '/' },
          data.bookingCustomer && data.bookingCustomer.name
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { title: data.code, to: '/bookings/' + data.id + '/', style: { fontWeight: 'normal' } },
            data.projectUnit.reference,
            ', ',
            data.project.shortName
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { style: { fontWeight: 'normal' } },
          _react2.default.createElement(
            'small',
            null,
            data.bookingStatus ? data.bookingStatus.name : '',
            ' -',
            _react2.default.createElement(
              _reactRouter.Link,
              {
                onClick: function onClick(e) {
                  return _this4.handleOpenErrorModal(e, {
                    httpStatus: data.himsServiceHttpStatus,
                    response: data.himsServiceResponse,
                    action: data.himsServiceAction,
                    errors: data.himsServiceErrors
                  });
                }
              },
              (0, _strings.titleCase)(data.himsServiceStatus) || 'Pending Sync',
              (!data.himsServiceID || data.himsHasChanges) && data.himsServiceStatus !== '' && _react2.default.createElement(
                _semanticUiReact.Label,
                { size: 'mini', style: { marginLeft: '0.5em', backgroundColor: '#e6fff2', color: '#008040' } },
                'Pending Sync'
              )
            )
          )
        ),
        _react2.default.createElement(
          'small',
          { style: { fontWeight: 'normal' } },
          _react2.default.createElement(_Timestamp2.default, {
            timestamp: data.createdAt,
            format: 'DD/M/YYYY'
          })
        )
      ),
      _react2.default.createElement(
        _reactRouter.Link,
        { to: '/bookings/' + data.booking_id + '/' },
        _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron right', style: { float: 'right' } })
      )
    );
  };

  this.renderTableHeaders = function (sortItems) {
    var data = _this4.state.data;

    return _react2.default.createElement(
      _semanticUiReact.Table.Header,
      { className: 'mobile-hide' },
      _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            onClick: function onClick(e) {
              if (data.length > 0) _this4.handleCheckboxSelectAll(e);
            }
          },
          _react2.default.createElement(_semanticUiReact.Checkbox, {
            checked: _this4.state.isSelectedAll,
            disabled: data.length < 1
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          { collapsing: true },
          'Status'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            collapsing: true,
            sorted: _this4.cellCheckSorted(sortItems[3].sortColumn),
            onClick: function onClick() {
              return _this4.handleCellSort(sortItems[3].sortColumn);
            }
          },
          'Created'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          'Last Sync'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          'Unit'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          'Booking status'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          'Customer'
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          'Reserved by'
        ),
        _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null)
      )
    );
  };

  this.renderTableRow = function (data, idx) {
    var himsStatus = (0, _strings.titleCase)(data.himsServiceStatus) || 'Pending Sync';
    var disabled = !_this4.isBookingSelectable(data);
    return _react2.default.createElement(
      _semanticUiReact.Table.Row,
      { key: idx },
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        {
          onClick: function onClick(e) {
            return _this4.handleCheckboxClick(e, data);
          },
          className: 'clickable computer-hide',
          disabled: disabled
        },
        _this4.renderMobileCell(data)
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        {
          onClick: function onClick(e) {
            return _this4.handleCheckboxClick(e, data);
          },
          className: 'clickable mobile-hide',
          disabled: disabled
        },
        _react2.default.createElement(_semanticUiReact.Checkbox, {
          checked: data.isSelected,
          name: 'isSelected',
          disabled: disabled
        })
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true, className: 'mobile-hide' },
        data.himsServiceErrors && data.himsServiceErrors.length > 0 ? _react2.default.createElement(
          _reactRouter.Link,
          {
            onClick: function onClick(e) {
              return _this4.handleOpenErrorModal(e, {
                httpStatus: data.himsServiceHttpStatus,
                response: data.himsServiceResponse,
                action: data.himsServiceAction,
                errors: data.himsServiceErrors
              });
            }
          },
          himsStatus
        ) : himsStatus,
        (!data.himsServiceID || data.himsHasChanges) && data.himsServiceStatus && _react2.default.createElement(
          _semanticUiReact.Label,
          { size: 'mini', style: { marginLeft: '0.5em', backgroundColor: '#e6fff2', color: '#008040' } },
          'Pending Sync'
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true, className: 'mobile-hide' },
        _react2.default.createElement(_Timestamp2.default, {
          timestamp: data.createdAt,
          format: 'DD/M/YYYY'
        })
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'mobile-hide' },
        data.himsServiceUpdatedAt ? _react2.default.createElement(_Timestamp2.default, {
          timestamp: data.himsServiceUpdatedAt,
          format: 'DD/M/YYYY'
        }) : '-'
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'mobile-hide' },
        _react2.default.createElement(
          _reactRouter.Link,
          { title: data.code, to: '/bookings/' + data.id + '/' },
          data.projectUnit.reference,
          ', ',
          data.project.shortName
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'mobile-hide' },
        data.bookingStatus ? data.bookingStatus.name : ''
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'mobile-hide' },
        _react2.default.createElement(
          _reactRouter.Link,
          { title: data.code, to: '/bookings/' + data.id + '/' },
          data.bookingCustomer && data.bookingCustomer.name
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true, textAlign: 'left', className: 'mobile-hide' },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/users/' + data.maUserAffiliateID + '/' },
          data.maCreatedByPreferredName
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true, className: 'mobile-hide' },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/bookings/' + data.id + '/' },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron right' })
        )
      )
    );
  };
};

exports.default = (0, _reactRouter.withRouter)(HIMSBookingsList);

/***/ }),
/* 2150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _gift = __webpack_require__(3532);

var _gift2 = _interopRequireDefault(_gift);

var _HLBCampaignInfoModal = __webpack_require__(2151);

var _HLBCampaignInfoModal2 = _interopRequireDefault(_HLBCampaignInfoModal);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HLBCampaignCalloutBanner = function (_Component) {
  _inherits(HLBCampaignCalloutBanner, _Component);

  function HLBCampaignCalloutBanner(props) {
    var _this2 = this;

    _classCallCheck(this, HLBCampaignCalloutBanner);

    var _this = _possibleConstructorReturn(this, (HLBCampaignCalloutBanner.__proto__ || Object.getPrototypeOf(HLBCampaignCalloutBanner)).call(this, props));

    _this.handleFindOutMore = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({ openInfoModal: true });

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.handleOnCloseInfo = function () {
      _this.setState({ openInfoModal: false });
    };

    _this.state = {
      openInfoModal: false
    };
    return _this;
  }

  _createClass(HLBCampaignCalloutBanner, [{
    key: 'render',
    value: function render() {
      var t = this.props.t;


      return _react2.default.createElement(
        'div',
        { className: 'hlb-campaign-callout-banner' },
        _react2.default.createElement(
          'div',
          { className: 'hlb-campaign-callout-banner-text' },
          _react2.default.createElement('img', { src: _gift2.default, width: 20, alt: 'gift' }),
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'strong',
              null,
              t('MHub Rewards', { ns: _translation.TRANSLATION_FILES.translation }),
              ':'
            ),
            '\xA0\xA0',
            t('Get RM10 from MHub for every case you send to Hong Leong Bank!*', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(_semanticUiReact.Button, {
          className: 'hlb-campaign-callout-banner-button',
          content: t('Find out more', { ns: _translation.TRANSLATION_FILES.translation }),
          onClick: this.handleFindOutMore
        }),
        _react2.default.createElement(_HLBCampaignInfoModal2.default, {
          show: this.state.openInfoModal,
          handleOnClose: this.handleOnCloseInfo
        })
      );
    }
  }]);

  return HLBCampaignCalloutBanner;
}(_react.Component);

HLBCampaignCalloutBanner.propTypes = {
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(HLBCampaignCalloutBanner);

/***/ }),
/* 2151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _gift_black = __webpack_require__(3533);

var _gift_black2 = _interopRequireDefault(_gift_black);

var _close = __webpack_require__(298);

var _close2 = _interopRequireDefault(_close);

var _external_arrow_teal = __webpack_require__(3531);

var _external_arrow_teal2 = _interopRequireDefault(_external_arrow_teal);

var _how_to_add_banker_ = __webpack_require__(3518);

var _how_to_add_banker_2 = _interopRequireDefault(_how_to_add_banker_);

var _HLBCampaignMainBanner = __webpack_require__(1020);

var _HLBCampaignMainBanner2 = _interopRequireDefault(_HLBCampaignMainBanner);

var _HLBCampaignTncModal = __webpack_require__(1021);

var _HLBCampaignTncModal2 = _interopRequireDefault(_HLBCampaignTncModal);

var _HLBCampaignJoinModal = __webpack_require__(1019);

var _HLBCampaignJoinModal2 = _interopRequireDefault(_HLBCampaignJoinModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HLBCampaignInfoModal = function (_Component) {
  _inherits(HLBCampaignInfoModal, _Component);

  function HLBCampaignInfoModal(props) {
    var _this2 = this;

    _classCallCheck(this, HLBCampaignInfoModal);

    var _this = _possibleConstructorReturn(this, (HLBCampaignInfoModal.__proto__ || Object.getPrototypeOf(HLBCampaignInfoModal)).call(this, props));

    _this.handleOnJoin = function () {
      _this.setState({ showHLBJoinModal: true });
    };

    _this.handleOnCloseJoin = function () {
      _this.setState({ showHLBJoinModal: false });
      _this.props.handleOnClose();
    };

    _this.handleOnOpenTnc = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.setState({ openTncModal: true });

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.handleOnCloseTnc = function () {
      _this.setState({ openTncModal: false });
    };

    _this.state = {
      openTncModal: false,
      showHLBJoinModal: false
    };
    return _this;
  }

  _createClass(HLBCampaignInfoModal, [{
    key: 'render',
    value: function render() {
      var show = this.props.show;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        { size: 'small', open: show, onClose: this.props.handleOnClose },
        _react2.default.createElement(
          _semanticUiReact.Modal.Header,
          { style: { fontWeight: '600' } },
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', justifyContent: 'space-between' } },
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', justifyContent: 'start', gap: '0.5em', alignItems: 'center' } },
              _react2.default.createElement('img', {
                src: _gift_black2.default,
                width: 24,
                alt: 'gift'
              }),
              _react2.default.createElement(
                'span',
                { style: { fontSize: '18px' } },
                'MHub Rewards'
              )
            ),
            _react2.default.createElement(
              'button',
              {
                type: 'button',
                onClick: this.props.handleOnClose,
                style: {
                  background: 'none',
                  border: 'none',
                  padding: 0,
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center'
                },
                'aria-label': 'Close'
              },
              _react2.default.createElement('img', {
                src: _close2.default,
                width: 20,
                alt: 'close'
              })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { className: 'hlb-campaign-welcome-modal-content' },
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            _react2.default.createElement(_HLBCampaignMainBanner2.default, null)
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: { marginTop: '1em' } },
            _react2.default.createElement(
              _semanticUiReact.Header,
              null,
              'Cash Rewards'
            ),
            _react2.default.createElement(
              _semanticUiReact.List,
              { bulleted: true },
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Earn RM10 for every case you send to Hong Leong Bank through MHub Showroom'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Valid only for cases sent during the Campaign period and for projects where HLB appears as panel bank'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: { marginTop: '1em' } },
            _react2.default.createElement(
              _semanticUiReact.Header,
              null,
              'More Info'
            ),
            _react2.default.createElement(
              _semanticUiReact.List,
              { bulleted: true },
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Choose any of the Hong Leong Bank bankers in Showroom to qualify for cash payout'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'You will only be eligible for the cash payout if you submit your bank account details. Those who don\'t will not be entitled. ',
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: 'hlb-campaign-link', onClick: this.handleOnJoin, style: { textDecoration: 'underline' } },
                  'Click here to submit'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Cash payout will be made on the 15th and 30th of every month to the account that you nominated'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Only eligible for project with Hong Leong Bank End-financing'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'Project that has no end-financing available quota won\'t be eligible for this campaign'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                'You can also send cases to bankers from other banks in Showroom however you will not be eligible for cash payout for those cases'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: { marginTop: '1em' } },
            _react2.default.createElement(
              _semanticUiReact.Header,
              null,
              'How to add Banker'
            ),
            _react2.default.createElement(_semanticUiReact.Image, { src: _how_to_add_banker_2.default })
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: { marginTop: '1em' } },
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } },
              _react2.default.createElement(
                _reactRouter.Link,
                {
                  className: 'hlb-campaign-link',
                  style: { display: 'flex', alignItems: 'center', gap: '0.5em', textDecoration: 'none' },
                  onClick: this.handleOnOpenTnc
                },
                _react2.default.createElement('img', { src: _external_arrow_teal2.default, width: 10, alt: 'external link' }),
                _react2.default.createElement(
                  'span',
                  { style: { fontWeight: '600' } },
                  'Terms and conditions'
                )
              ),
              _react2.default.createElement(_semanticUiReact.Button, { style: { backgroundColor: '#0094B3', color: '#FFFFFF' }, content: 'Join', onClick: this.handleOnJoin })
            )
          ),
          _react2.default.createElement(_HLBCampaignTncModal2.default, {
            open: this.state.openTncModal,
            onClose: this.handleOnCloseTnc
          }),
          _react2.default.createElement(_HLBCampaignJoinModal2.default, {
            show: this.state.showHLBJoinModal,
            onClose: this.handleOnCloseJoin
          })
        )
      );
    }
  }]);

  return HLBCampaignInfoModal;
}(_react.Component);

HLBCampaignInfoModal.propTypes = {
  show: _propTypes2.default.bool,
  handleOnClose: _propTypes2.default.func
};
exports.default = HLBCampaignInfoModal;

/***/ }),
/* 2152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(18);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gift_blue = __webpack_require__(1597);

var _gift_blue2 = _interopRequireDefault(_gift_blue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HLBEligibleBanner = function (_Component) {
  _inherits(HLBEligibleBanner, _Component);

  function HLBEligibleBanner() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, HLBEligibleBanner);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = HLBEligibleBanner.__proto__ || Object.getPrototypeOf(HLBEligibleBanner)).call.apply(_ref, [this].concat(args))), _this), _this.handleJoinCampaign = function (e) {
      e.preventDefault();
      if (_this.props.onJoinCampaign) {
        _this.props.onJoinCampaign();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(HLBEligibleBanner, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'hlb-eligible-banner' },
        _react2.default.createElement('img', { src: _gift_blue2.default, width: 20, alt: 'gift' }),
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            'strong',
            null,
            'MHub Rewards: '
          ),
          'Hong Leong Bank selected. You are eligible for RM10 cash payout. To qualify, fill up your bank information,',
          _react2.default.createElement(
            _reactRouter.Link,
            { onClick: this.handleJoinCampaign },
            ' click here.'
          )
        )
      );
    }
  }]);

  return HLBEligibleBanner;
}(_react.Component);

HLBEligibleBanner.propTypes = {
  onJoinCampaign: _propTypes2.default.func
};
exports.default = HLBEligibleBanner;

/***/ }),
/* 2153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _gift_white = __webpack_require__(3534);

var _gift_white2 = _interopRequireDefault(_gift_white);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HLBRewardsTag = function (_Component) {
  _inherits(HLBRewardsTag, _Component);

  function HLBRewardsTag() {
    _classCallCheck(this, HLBRewardsTag);

    return _possibleConstructorReturn(this, (HLBRewardsTag.__proto__ || Object.getPrototypeOf(HLBRewardsTag)).apply(this, arguments));
  }

  _createClass(HLBRewardsTag, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: 'hlb-campaign-rewards-tag' },
        _react2.default.createElement('img', { src: _gift_white2.default, width: 12, alt: 'Gift Icon' }),
        _react2.default.createElement(
          'span',
          null,
          'MHub Rewards'
        )
      );
    }
  }]);

  return HLBRewardsTag;
}(_react.Component);

exports.default = HLBRewardsTag;

/***/ }),
/* 2154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _i18next = __webpack_require__(94);

var _i18next2 = _interopRequireDefault(_i18next);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImportFromProjectModal = function (_Component) {
  _inherits(ImportFromProjectModal, _Component);

  function ImportFromProjectModal(props) {
    _classCallCheck(this, ImportFromProjectModal);

    var _this = _possibleConstructorReturn(this, (ImportFromProjectModal.__proto__ || Object.getPrototypeOf(ImportFromProjectModal)).call(this, props));

    _this.setComponentState = function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Promise(function (res) {
        _this.setState(state, function () {
          res(state);
        });
      });
    };

    _this.handleOnOpen = function () {
      _this.setState({ open: true });
    };

    _this.handleOnClose = function () {
      _this.setState({
        open: false,
        templates: [],
        selectedProjectID: null,
        selectedTemplateIDs: []
      });
    };

    _this.handleOnDropdownChange = function (e, _ref) {
      var value = _ref.value;

      _this.setState({
        selectedProjectID: value,
        templates: [],
        selectedTemplateIDs: []
      }, function () {
        _this.fetchProjectTemplates();
      });
    };

    _this.handleOnCheckboxChange = function (e, _ref2) {
      var value = _ref2.value;
      var _this$state = _this.state,
          templates = _this$state.templates,
          selectedTemplateIDs = _this$state.selectedTemplateIDs;

      var updatedTemplates = templates.map(function (template) {
        if (template.id === value) {
          return _extends({}, template, { selected: !template.selected });
        }
        return template;
      });

      var isSelected = selectedTemplateIDs.includes(value);
      var updatedSelectedValues = isSelected ? selectedTemplateIDs.filter(function (v) {
        return v !== value;
      }) : [].concat(_toConsumableArray(selectedTemplateIDs), [value]);

      _this.setState({
        templates: updatedTemplates,
        selectedTemplateIDs: updatedSelectedValues
      });
    };

    _this.handleOnConfirm = function (e) {
      e.preventDefault();
      var _this$state2 = _this.state,
          selectedProjectID = _this$state2.selectedProjectID,
          selectedTemplateIDs = _this$state2.selectedTemplateIDs;
      var onConfirm = _this.props.onConfirm;

      var body = {
        project_id: selectedProjectID,
        template_ids: selectedTemplateIDs
      };
      if (onConfirm) {
        onConfirm(body);
      }
      _this.handleOnClose();
    };

    _this.renderContent = function () {
      var _this$state3 = _this.state,
          templates = _this$state3.templates,
          selectedProjectID = _this$state3.selectedProjectID;

      if (templates.length > 0) {
        return _react2.default.createElement(
          _semanticUiReact.Segment,
          { style: { maxHeight: '300px', overflowY: 'auto' } },
          _this.renderTemplateCheckboxes()
        );
      }
      if (selectedProjectID) {
        return _react2.default.createElement(
          'i',
          null,
          _i18next2.default.t('No templates found', { ns: 'translation' })
        );
      }
      return _react2.default.createElement(
        'i',
        null,
        _i18next2.default.t('Please select a project first', { ns: 'translation' })
      );
    };

    _this.renderTemplateCheckboxes = function () {
      var templates = _this.state.templates;

      return templates.map(function (template) {
        return _react2.default.createElement(
          _semanticUiReact.Grid,
          { key: template.id },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { floated: 'left', width: 10 },
              _react2.default.createElement(
                'span',
                null,
                template.name
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { floated: 'right', width: 2 },
              _react2.default.createElement(_semanticUiReact.Checkbox, {
                value: template.id,
                checked: template.selected,
                onChange: _this.handleOnCheckboxChange
              })
            )
          )
        );
      });
    };

    _this.state = {
      open: false,
      onClose: false,
      loading: false,
      disableTemplate: true,
      projectOpts: [],
      selectedProjectID: null,
      selectedTemplateIDs: [],
      templates: [],
      errMessages: []
    };
    return _this;
  }

  _createClass(ImportFromProjectModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchProjects();
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchProjects',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, projectID, query, res, message, _message, data, projectOpts;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                projectID = this.props.projectID;
                _context.next = 4;
                return this.setLoading(true);

              case 4:
                query = {
                  limit: 0,
                  showAsOptions: true
                };
                res = void 0;
                _context.prev = 6;
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/docxtemplates/projects/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context.sent;
                _context.next = 24;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                if (!(_context.t0.res && _context.t0.res.status >= 399 && _context.t0.res.status < 500)) {
                  _context.next = 19;
                  break;
                }

                _context.next = 17;
                return _context.t0.res.text();

              case 17:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 19:
                _context.next = 21;
                return this.setLoading(false);

              case 21:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: _i18next2.default.t('There was an error with your request. Please try again.', { ns: 'translation' }) }));
                return _context.abrupt('return');

              case 24:
                if (res.ok) {
                  _context.next = 32;
                  break;
                }

                _context.next = 27;
                return res.text();

              case 27:
                _message = _context.sent;
                _context.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 30:
                _context.next = 39;
                break;

              case 32:
                _context.next = 34;
                return res.json();

              case 34:
                data = _context.sent;
                projectOpts = this.state.projectOpts;

                if (data && data.length > 0) {
                  projectOpts = data.filter(function (d) {
                    return d.id !== projectID && d.statusID !== 'deleted';
                  }).map(function (d) {
                    return { value: d.id, text: d.name };
                  });
                }
                _context.next = 39;
                return this.setComponentState({ projectOpts: projectOpts });

              case 39:
                _context.next = 41;
                return this.setLoading(false);

              case 41:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));

      function fetchProjects() {
        return _ref3.apply(this, arguments);
      }

      return fetchProjects;
    }()
  }, {
    key: 'fetchProjectTemplates',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var selectedProjectID, store, res, message, data, templates;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                selectedProjectID = this.state.selectedProjectID;
                store = this.context.store;
                res = void 0;
                _context2.prev = 5;
                _context2.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/docxtemplates/projects/' + selectedProjectID + '/templates/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context2.sent;
                _context2.next = 19;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](5);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _i18next2.default.t('An error occurred, please refresh page', { ns: 'translation' }) }));

              case 16:
                _context2.next = 18;
                return this.setLoading(false);

              case 18:
                return _context2.abrupt('return');

              case 19:
                if (res.ok) {
                  _context2.next = 27;
                  break;
                }

                _context2.next = 22;
                return res.text();

              case 22:
                message = _context2.sent;
                _context2.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context2.next = 32;
                break;

              case 27:
                _context2.next = 29;
                return res.json();

              case 29:
                data = _context2.sent;

                // select all by default
                templates = (data || []).filter(function (template) {
                  return template.docxFileKey && template.docxFileKey.indexOf('templates/default_templates/') !== 0;
                }).map(function (template) {
                  return _extends({}, template, {
                    selected: true
                  });
                });

                this.setState({
                  templates: templates,
                  selectedTemplateIDs: templates.map(function (t) {
                    return t.id;
                  })
                });

              case 32:
                _context2.next = 34;
                return this.setLoading(false);

              case 34:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 11]]);
      }));

      function fetchProjectTemplates() {
        return _ref4.apply(this, arguments);
      }

      return fetchProjectTemplates;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          loading = _state.loading,
          open = _state.open,
          projectOpts = _state.projectOpts,
          selectedProjectID = _state.selectedProjectID,
          selectedTemplateIDs = _state.selectedTemplateIDs;
      var trigger = this.props.trigger;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          size: 'tiny',
          onOpen: this.handleOnOpen,
          onClose: function onClose() {
            return _this3.handleOnClose();
          },
          open: open,
          trigger: trigger
        },
        _react2.default.createElement(_semanticUiReact.Header, { as: 'h3', icon: 'file', align: 'content-center', content: _i18next2.default.t('Import Template from other Project', { ns: 'translation' }) }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(_semanticUiReact.Header, { as: 'h5', content: _i18next2.default.t('Import from', { ns: 'translation' }) }),
                _react2.default.createElement(_semanticUiReact.Dropdown, {
                  name: 'selectedProjectID',
                  placeholder: _i18next2.default.t('Select Project', { ns: 'screens' }),
                  fluid: true,
                  search: true,
                  selection: true,
                  options: projectOpts,
                  onChange: this.handleOnDropdownChange,
                  value: selectedProjectID || '',
                  noResultsMessage: _i18next2.default.t('No results found', { ns: 'translation' })
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { className: !selectedProjectID ? 'disabled' : '' },
                _react2.default.createElement(_semanticUiReact.Header, { as: 'h5', content: _i18next2.default.t('Templates', { ns: 'translation' }) }),
                this.renderContent()
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              compact: true,
              color: 'red',
              onClick: this.handleOnClose
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'close' }),
            _i18next2.default.t('Cancel', { ns: 'translation' })
          ),
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              compact: true,
              color: 'green',
              onClick: this.handleOnConfirm,
              disabled: loading || selectedTemplateIDs.length < 1
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'check' }),
            _i18next2.default.t('Confirm', { ns: 'translation' })
          )
        )
      );
    }
  }]);

  return ImportFromProjectModal;
}(_react.Component);

ImportFromProjectModal.contextTypes = {
  store: _propTypes2.default.object
};
ImportFromProjectModal.propTypes = {
  trigger: _propTypes2.default.node,
  onConfirm: _propTypes2.default.func,
  projectID: _propTypes2.default.string
};
exports.default = ImportFromProjectModal;

/***/ }),
/* 2155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageSwitcher = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _i18next = __webpack_require__(94);

var _i18next2 = _interopRequireDefault(_i18next);

var _reactI18next = __webpack_require__(3);

var _languageOptions = __webpack_require__(1092);

var _refreshUserCache = __webpack_require__(1093);

var _displayLanguage = __webpack_require__(594);

var _languages = __webpack_require__(1044);

var _languages2 = _interopRequireDefault(_languages);

var _translation = __webpack_require__(4);

var _flash = __webpack_require__(5);

var _languagePreference = __webpack_require__(325);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LanguageSwitcher = exports.LanguageSwitcher = function (_Component) {
  _inherits(LanguageSwitcher, _Component);

  function LanguageSwitcher() {
    var _ref,
        _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, LanguageSwitcher);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LanguageSwitcher.__proto__ || Object.getPrototypeOf(LanguageSwitcher)).call.apply(_ref, [this].concat(args))), _this), _this.state = { isUpdating: false, language: (0, _languagePreference.normalizeLanguage)(_i18next2.default.language) || 'en' }, _this.handleI18nChange = function (language) {
      _this.setState({ language: (0, _languagePreference.normalizeLanguage)(language) || 'en' });
    }, _this.handleLanguageChange = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event) {
        var language, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                language = event.target.value;

                _this.setState({ isUpdating: true, saveWarning: null });
                // Saving failure must not undo the language currently being presented.
                _i18next2.default.emit('explicitLanguageSelected', language);
                (0, _displayLanguage.changeDisplayLanguage)(_i18next2.default, language);
                _context.prev = 4;
                _context.next = 7;
                return (0, _languagePreference.saveLanguagePreference)(language);

              case 7:
                _this.setState({ retryAvailable: false });
                // book-api caches the user independently of the durable profile.
                _context.prev = 8;
                _context.next = 11;
                return (0, _refreshUserCache.refreshUserCache)();

              case 11:
                _context.next = 16;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](8);
                Bugsnag.notifyException(_context.t0);

              case 16:
                _context.next = 24;
                break;

              case 18:
                _context.prev = 18;
                _context.t1 = _context['catch'](4);

                if (!_context.t1.blocked) Bugsnag.notifyException(_context.t1);
                message = _this.props.t(_context.t1.code === 'LANGUAGE_SAVE_UNCONFIRMED' ? 'Language save is still unconfirmed. This tab keeps your selection. Wait for the connection to recover before retrying.' : 'Failed to update language', { ns: _translation.TRANSLATION_FILES.translation });

                _this.setState({ saveWarning: _context.t1.code === 'LANGUAGE_SAVE_UNCONFIRMED' ? message : null, retryAvailable: true });
                if (!_context.t1.blocked) _this.context.store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.prev = 24;

                _this.setState({ isUpdating: false });
                return _context.finish(24);

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[4, 18, 24, 27], [8, 13]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LanguageSwitcher, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      _i18next2.default.on('languageChanged', this.handleI18nChange);
      this.unsubscribeSaveStatus = (0, _languagePreference.subscribeLanguageSaveStatus)(function (pending) {
        return _this3.setState({
          saveWarning: pending ? _this3.props.t('Language save is still unconfirmed. This tab keeps your selection. Wait for the connection to recover before retrying.', { ns: _translation.TRANSLATION_FILES.translation }) : null });
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _i18next2.default.off('languageChanged', this.handleI18nChange);if (this.unsubscribeSaveStatus) this.unsubscribeSaveStatus();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          t = _props.t,
          auth = _props.auth;
      var _state = this.state,
          isUpdating = _state.isUpdating,
          language = _state.language;

      var options = (0, _languageOptions.languageOptions)(_languages2.default, auth && auth.company && auth.company.activeLanguageCodes, language);
      return _react2.default.createElement(
        'div',
        { className: 'language-switcher' },
        _react2.default.createElement(
          'select',
          { onChange: this.handleLanguageChange, value: language, disabled: isUpdating },
          options.map(function (l) {
            return _react2.default.createElement(
              'option',
              { key: l.value, value: l.value, disabled: l.disabled },
              t(l.text, { ns: _translation.TRANSLATION_FILES.constants })
            );
          })
        ),
        this.state.retryAvailable && _react2.default.createElement(
          'button',
          { type: 'button', disabled: isUpdating, onClick: function onClick() {
              return _this4.handleLanguageChange({ target: { value: language } });
            } },
          t('Retry', { ns: _translation.TRANSLATION_FILES.translation })
        ),
        this.state.saveWarning && _react2.default.createElement(
          'span',
          { role: 'alert' },
          this.state.saveWarning
        ),
        isUpdating && _react2.default.createElement(
          'span',
          { className: 'spinner' },
          '\u27F3'
        )
      );
    }
  }]);

  return LanguageSwitcher;
}(_react.Component);

LanguageSwitcher.propTypes = {
  t: _propTypes2.default.func.isRequired,
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.shape({ activeLanguageCodes: _propTypes2.default.arrayOf(_propTypes2.default.string) })
  })
};
LanguageSwitcher.defaultProps = { auth: null };
LanguageSwitcher.contextTypes = { store: _propTypes2.default.object };
exports.default = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth };
})((0, _reactI18next.withTranslation)()(LanguageSwitcher));

/***/ }),
/* 2156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _translation = __webpack_require__(4);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable camelcase */


var MediaItem = function (_Component) {
  _inherits(MediaItem, _Component);

  function MediaItem(props) {
    _classCallCheck(this, MediaItem);

    var _this = _possibleConstructorReturn(this, (MediaItem.__proto__ || Object.getPrototypeOf(MediaItem)).call(this, props));

    _this.getThumbnailUrl = function (media) {
      if (media && media.data && media.data.thumbnail_url) {
        return media.data.thumbnail_url;
      }
      return '';
    };

    _this.handleShowDimmed = function () {
      _this.setState({ active: true });
    };

    _this.handleHideDimmed = function () {
      _this.setState({ active: false });
    };

    _this.state = {
      active: false
    };
    return _this;
  }

  _createClass(MediaItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;
      var active = this.state.active;

      var thumbnailUrl = this.getThumbnailUrl(this.props.media);
      return _react2.default.createElement(
        _semanticUiReact.Card,
        { className: this.props.fixedSize ? 'picture-item-fixed-size' : 'picture-item' },
        _react2.default.createElement(
          _semanticUiReact.Dimmer.Dimmable,
          {
            dimmed: active,
            className: 'center',
            onMouseEnter: function onMouseEnter() {
              return _this2.handleShowDimmed();
            },
            onMouseLeave: this.handleHideDimmed
          },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: active },
            this.props.onViewLarge ? _react2.default.createElement(_semanticUiReact.Button, {
              primary: true,
              icon: 'zoom',
              content: t('View', { ns: _translation.TRANSLATION_FILES.translation }),
              onClick: function onClick(e) {
                return _this2.props.onViewLarge(e);
              }
            }) : null,
            this.props.onRemove ? _react2.default.createElement(_semanticUiReact.Label, {
              as: 'a',
              corner: true,
              color: 'red',
              icon: 'close',
              onClick: function onClick(e) {
                return _this2.props.onRemove(e);
              }
            }) : null
          ),
          _react2.default.createElement(_LoadImage2.default, {
            centered: true,
            asBackground: this.props.fixedSize,
            size: this.props.size,
            src: thumbnailUrl,
            labelNode: this.props.labelNode,
            isVideo: true
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Card.Content,
          null,
          this.props.media ? this.props.media.label : '-'
        ),
        this.props.buttonNode
      );
    }
  }]);

  return MediaItem;
}(_react.Component);

MediaItem.propTypes = {
  media: _propTypes2.default.shape({
    label: _propTypes2.default.string,
    url: _propTypes2.default.string,
    data: _propTypes2.default.shape({
      html: _propTypes2.default.node
    })
  }),
  labelNode: _propTypes2.default.node,
  buttonNode: _propTypes2.default.node,
  onViewLarge: _propTypes2.default.func,
  onRemove: _propTypes2.default.func,
  size: _propTypes2.default.string,
  fixedSize: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
MediaItem.defaultProps = {
  fixedSize: null
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(MediaItem);

/***/ }),
/* 2157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var tabs = [{ value: 'all', name: 'all', text: 'All', header: 'ALL' }, { value: 'booking', name: 'booking', text: 'Booking', header: 'Booking' }, { value: 'project', name: 'project', text: 'Project', header: 'Project' }, { value: 'unit', name: 'unit', text: 'Unit', header: 'Unit' }, { value: 'pricing_package', name: 'pricing_package', text: 'Pricing Package', header: 'Pricing Package' }, { value: 'purchaser', name: 'purchaser', text: 'Purchaser', header: 'Purchaser' }, { value: 'custom', name: 'custom', text: 'Custom', header: 'Custom' }];

var MergeTagDictTabList = function (_Component) {
  _inherits(MergeTagDictTabList, _Component);

  function MergeTagDictTabList(props) {
    _classCallCheck(this, MergeTagDictTabList);

    var _this = _possibleConstructorReturn(this, (MergeTagDictTabList.__proto__ || Object.getPrototypeOf(MergeTagDictTabList)).call(this, props));

    _initialiseProps.call(_this);

    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    _this.state = {
      isMobile: isMobile,
      loading: true,
      mergeTags: [],
      filteredMergeTags: [],
      currentTab: tabs[0]
    };
    return _this;
  }

  _createClass(MergeTagDictTabList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchMergeTags();
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchMergeTags',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var t, store, res, message, mergeTags;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/mergetags/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 19;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ header: t('Error', { ns: _translation.TRANSLATION_FILES.constants }), message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ header: t('Error', { ns: _translation.TRANSLATION_FILES.constants }), message: message }));

              case 25:
                _context.next = 31;
                break;

              case 27:
                _context.next = 29;
                return res.json();

              case 29:
                mergeTags = _context.sent;

                if (mergeTags && mergeTags.length > 0) {
                  this.setState({
                    mergeTags: mergeTags,
                    filteredMergeTags: mergeTags
                  });
                }

              case 31:
                _context.next = 33;
                return this.setLoading(false);

              case 33:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchMergeTags() {
        return _ref.apply(this, arguments);
      }

      return fetchMergeTags;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          currentTab = _state.currentTab,
          filteredMergeTags = _state.filteredMergeTags,
          isMobile = _state.isMobile,
          loading = _state.loading;
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { verticalAlign: 'middle', className: 'merge-tag-tab' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'tab-menu' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            isMobile ? _react2.default.createElement(
              'div',
              { style: { marginBottom: '10px' } },
              _react2.default.createElement(
                'div',
                { style: { display: 'flex', gap: '8px', alignItems: 'center' } },
                _react2.default.createElement(_semanticUiReact.Dropdown, {
                  fluid: true,
                  selection: true,
                  options: tabs.map(function (tab) {
                    return {
                      key: tab.value,
                      text: tab.header,
                      value: tab.value
                    };
                  }),
                  value: currentTab.value,
                  onChange: function onChange(e, _ref2) {
                    var value = _ref2.value;
                    return _this3.handleChangeTab(e, { name: value });
                  },
                  style: { flex: 1 }
                }),
                this.renderCopyAllButton()
              )
            ) : _react2.default.createElement(
              'div',
              { style: { overflowX: 'auto', overflowY: 'hidden', whiteSpace: 'nowrap' } },
              _react2.default.createElement(
                _semanticUiReact.Menu,
                { attached: 'top', tabular: true, style: { minWidth: 'max-content', flexWrap: 'nowrap' } },
                tabs.map(function (tab, key) {
                  return _react2.default.createElement(
                    _semanticUiReact.Menu.Item,
                    {
                      key: key,
                      name: tab.name,
                      onClick: _this3.handleChangeTab,
                      active: currentTab.value === tab.value
                    },
                    t(tab.header, { ns: _translation.TRANSLATION_FILES.screens })
                  );
                }),
                _react2.default.createElement(
                  _semanticUiReact.Menu.Menu,
                  { position: 'right', style: { paddingTop: '5px', paddingBottom: '5px', paddingLeft: '10px' } },
                  this.renderCopyAllButton()
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Segment,
              {
                attached: isMobile ? false : 'bottom',
                style: {
                  height: '350px',
                  overflowY: 'scroll',
                  overflowX: 'hidden',
                  borderTop: isMobile ? '1px solid #d4d4d5' : 'none'
                }
              },
              loading ? _react2.default.createElement(
                _semanticUiReact.Loader,
                { active: true, inline: 'centered' },
                t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
              ) : filteredMergeTags.map(function (mergeTag) {
                return _this3.renderMergeTag(mergeTag);
              })
            )
          )
        )
      );
    }
  }]);

  return MergeTagDictTabList;
}(_react.Component);

MergeTagDictTabList.contextTypes = {
  store: _propTypes2.default.object
};
MergeTagDictTabList.propTypes = {
  t: _propTypes2.default.func
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleResize = function () {
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    if (isMobile !== _this4.state.isMobile) {
      _this4.setState({ isMobile: isMobile });
    }
  };

  this.handleChangeTab = function (e, _ref3) {
    var name = _ref3.name,
        value = _ref3.value;

    var currentTab = tabs.find(function (tab) {
      return tab.name === name || tab.value === value;
    });
    // Filter the tags based on the selected tab
    var filteredMergeTags = currentTab.value === 'all' ? _this4.state.mergeTags : _this4.state.mergeTags.filter(function (mergeTag) {
      return mergeTag.tag === currentTab.value;
    });
    _this4.setState({
      currentTab: currentTab,
      filteredMergeTags: filteredMergeTags
    });
  };

  this.handleCopy = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(text) {
      var t, store, textArea;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              t = _this4.props.t;
              store = _this4.context.store;
              _context2.prev = 2;

              if (!navigator.clipboard) {
                _context2.next = 8;
                break;
              }

              _context2.next = 6;
              return navigator.clipboard.writeText(text);

            case 6:
              _context2.next = 15;
              break;

            case 8:
              textArea = document.createElement('textarea'); // Create a temporary textarea

              textArea.value = text; // Set the value to the text you want to copy
              document.body.appendChild(textArea); // Append the textarea to the document body

              textArea.select(); // Select the text inside the textarea
              textArea.setSelectionRange(0, 99999); // For mobile devices
              document.execCommand('copy');
              document.body.removeChild(textArea);

            case 15:
              _context2.next = 17;
              return store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Success', { ns: _translation.TRANSLATION_FILES.constants }), message: t('Copied merge tag(s) to clipboard', { ns: _translation.TRANSLATION_FILES.translation }) }));

            case 17:
              _context2.next = 24;
              break;

            case 19:
              _context2.prev = 19;
              _context2.t0 = _context2['catch'](2);
              _context2.next = 23;
              return store.dispatch((0, _flash.flashErrorMessage)({ header: t('Error', { ns: _translation.TRANSLATION_FILES.constants }), message: t('Failed to copy merge tags', { ns: _translation.TRANSLATION_FILES.translation }) }));

            case 23:
              console.error('Failed to copy merge tags', _context2.t0);

            case 24:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this4, [[2, 19]]);
    }));

    return function (_x2) {
      return _ref4.apply(this, arguments);
    };
  }();

  this.renderMergeTag = function (mergeTag) {
    var t = _this4.props.t;

    return _react2.default.createElement(
      'div',
      { key: mergeTag.mergetag, style: { marginBottom: '3px' } },
      _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          'strong',
          null,
          t(mergeTag.title, { ns: _translation.TRANSLATION_FILES.translation })
        ),
        ': ',
        mergeTag.syntax
      ),
      _react2.default.createElement(_semanticUiReact.Popup, {
        hoverable: true,
        size: 'mini',
        content: t('Click to copy', { ns: _translation.TRANSLATION_FILES.translation }),
        trigger: _react2.default.createElement(_semanticUiReact.Icon, {
          style: { cursor: 'pointer' },
          name: 'file outline',
          color: 'blue',
          onClick: function onClick() {
            return _this4.handleCopy(mergeTag.syntax);
          }
        })
      })
    );
  };

  this.renderCopyAllButton = function () {
    var t = _this4.props.t;
    var filteredMergeTags = _this4.state.filteredMergeTags;

    return _react2.default.createElement(_semanticUiReact.Button, {
      basic: true,
      color: 'blue',
      size: 'small',
      content: t('Copy All', { ns: _translation.TRANSLATION_FILES.translation }),
      icon: 'copy outline',
      type: 'button',
      onClick: function onClick() {
        var allTags = filteredMergeTags.map(function (tag) {
          return t(tag.title, { ns: _translation.TRANSLATION_FILES.translation }) + ': ' + tag.syntax;
        }).join('\n');
        _this4.handleCopy(allTags);
      }
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(MergeTagDictTabList);

/***/ }),
/* 2158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _sharing = __webpack_require__(1094);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */


var MortgageCalculator = function (_Component) {
  _inherits(MortgageCalculator, _Component);

  function MortgageCalculator(props) {
    _classCallCheck(this, MortgageCalculator);

    var _this = _possibleConstructorReturn(this, (MortgageCalculator.__proto__ || Object.getPrototypeOf(MortgageCalculator)).call(this, props));

    _initialiseProps.call(_this);

    var state = MortgageCalculator.getPropsToState(props);
    _this.state = _extends({}, state, {
      selectedPricingPackage: 'spa_value',
      loading: false
    });
    _this.validation = {
      spaPrice: (0, _react.createRef)(),
      loanAmount: (0, _react.createRef)(),
      tenureYear: (0, _react.createRef)(),
      interestRate: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(MortgageCalculator, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = MortgageCalculator.getPropsToState(nextProps);
      if (JSON.stringify(this.state.data.spaPrice) !== JSON.stringify(state.data.spaPrice) || JSON.stringify(this.state.packagePricings) !== JSON.stringify(state.packagePricings)) {
        this.setState(_extends({}, state));
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'calculateLoan',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, data, _props, projectID, unitID, validations, errMessages, body, res, message, result;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                data = this.state.data;
                _props = this.props, projectID = _props.projectID, unitID = _props.unitID;
                _context.next = 7;
                return _AppForm2.default.validate(this.validation, data);

              case 7:
                validations = _context.sent;
                errMessages = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errMessages.length > 0)) {
                  _context.next = 14;
                  break;
                }

                _context.next = 12;
                return this.setLoading(false);

              case 12:
                store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errMessages.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 14:
                body = Object.assign(data, {
                  spaPrice: parseFloat(data.spaPrice),
                  loanAmount: parseFloat(data.loanAmount),
                  tenureYear: parseFloat(data.tenureYear),
                  interestRate: parseFloat(data.interestRate)
                });
                res = void 0;
                _context.prev = 16;
                _context.next = 19;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + projectID + '/units/' + unitID + '/calc_mortgage/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(body)
                }));

              case 19:
                res = _context.sent;
                _context.next = 35;
                break;

              case 22:
                _context.prev = 22;
                _context.t0 = _context['catch'](16);
                _context.next = 26;
                return this.setLoading(false);

              case 26:
                Bugsnag.notifyException(_context.t0);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 33;
                  break;
                }

                _context.next = 30;
                return _context.t0.res.text();

              case 30:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 33:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 35:
                _context.next = 37;
                return res.json();

              case 37:
                result = _context.sent;
                _context.next = 40;
                return this.setLoading(false);

              case 40:
                _context.next = 42;
                return this.setComponentState({ result: result });

              case 42:
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: 'Calculate Success',
                  message: 'Result has been generated'
                }));

              case 43:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[16, 22]]);
      }));

      function calculateLoan() {
        return _ref.apply(this, arguments);
      }

      return calculateLoan;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          data = _state.data,
          loanMargin = _state.loanMargin,
          selectedPricingPackage = _state.selectedPricingPackage,
          loading = _state.loading;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { className: 'MortgageCalculator' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 16, tablet: 8, computer: 8 },
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { verticalAlign: 'middle' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', width: 5 },
                _react2.default.createElement(
                  'b',
                  null,
                  'SPA price'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', width: 11 },
                _react2.default.createElement(_semanticUiReact.Form.Select, {
                  className: 'ppDropdown',
                  options: this.getPricingPackages(),
                  value: selectedPricingPackage,
                  selection: true,
                  fluid: true,
                  onChange: this.handlePricingPackageChange
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { verticalAlign: 'middle' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', width: 5 },
                _react2.default.createElement(
                  'b',
                  null,
                  'Loan amount'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', width: 11 },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'left', computer: 4, tablet: 6, mobile: 5, style: { paddingRight: '0' } },
                    _react2.default.createElement(_semanticUiReact.Form.Select, {
                      fluid: true,
                      name: 'loanMargin',
                      options: this.getLoanMarginOptions(),
                      placeholder: '0%',
                      selectOnBlur: false,
                      value: loanMargin,
                      onChange: this.handleChange
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'right', computer: 12, tablet: 10, mobile: 11 },
                    _react2.default.createElement(_AppForm2.default.Input, {
                      hideMessage: true,
                      name: 'loanAmount',
                      type: 'number',
                      min: '0',
                      value: data.loanAmount,
                      validateLabel: 'Loan amount',
                      onChange: this.handleAmountChange,
                      step: '.01',
                      ref: this.validation.loanAmount,
                      validation: [function (v, o) {
                        return (0, _webValidations.numericRange)(v, _extends({}, o, {
                          min: 1,
                          max: data.spaPrice
                        }));
                      }]
                    })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { verticalAlign: 'middle' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', width: 5 },
                _react2.default.createElement(
                  'b',
                  null,
                  'Loan tenure (Years)'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', width: 11 },
                _react2.default.createElement(_AppForm2.default.Input, {
                  hideMessage: true,
                  validateLabel: 'Loan tenure (Years)',
                  name: 'tenureYear',
                  value: data.tenureYear,
                  onChange: this.handleChange,
                  ref: this.validation.tenureYear,
                  validation: [_webValidations.required, {
                    validate: _webValidations.numericRange,
                    option: {
                      min: 1,
                      max: 35
                    }
                  }],
                  type: 'number',
                  step: '.1'
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { verticalAlign: 'middle' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', width: 5 },
                _react2.default.createElement(
                  'b',
                  null,
                  'Interest rate (%)'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', width: 11 },
                _react2.default.createElement(_AppForm2.default.Input, {
                  hideMessage: true,
                  validateLabel: 'Interest rate (%)',
                  placeholder: 'Interest rate (%)',
                  name: 'interestRate',
                  value: data.interestRate,
                  onChange: this.handleChange,
                  ref: this.validation.interestRate,
                  validation: [_webValidations.required, {
                    validate: _webValidations.numericRange,
                    option: {
                      min: 1,
                      max: 100
                    }
                  }],
                  type: 'number',
                  step: '.1'
                })
              )
            ),
            _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '2rem 0' } }),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'p',
                { className: 'title' },
                'Additional discount'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { style: { marginTop: '1.5em', marginBottom: '4.5rem' }, computer: 8, tablet: 16, mobile: 16 },
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { grouped: true },
                _react2.default.createElement(
                  _semanticUiReact.Form.Group,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Form.Field,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { className: 'form-group' },
                      _react2.default.createElement(_semanticUiReact.Form.Field, { className: 'form-label', label: 'Free SPA legal fee' }),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Field,
                        { className: 'form-value' },
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          toggle: true,
                          name: 'freeSPALegalFee',
                          checked: data.freeSPALegalFee,
                          onChange: this.handleCheckboxChange
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { className: 'form-group' },
                      _react2.default.createElement(_semanticUiReact.Form.Field, { className: 'form-label', label: 'Free SPA legal disbursements' }),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Field,
                        { className: 'form-value' },
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          toggle: true,
                          name: 'freeSPALegalFeeDisbursements',
                          checked: data.freeSPALegalFeeDisbursements,
                          onChange: this.handleCheckboxChange
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { className: 'form-group' },
                      _react2.default.createElement(_semanticUiReact.Form.Field, { className: 'form-label', label: 'Free SPA stamp duty / MoT' }),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Field,
                        { className: 'form-value' },
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          toggle: true,
                          name: 'freeSPAMOTStampDuty',
                          checked: data.freeSPAMOTStampDuty,
                          onChange: this.handleCheckboxChange
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { className: 'form-group' },
                      _react2.default.createElement(_semanticUiReact.Form.Field, { className: 'form-label', label: 'Free Loan legal fee' }),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Field,
                        { className: 'form-value' },
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          toggle: true,
                          name: 'freeLALegalFee',
                          checked: data.freeLALegalFee,
                          onChange: this.handleCheckboxChange
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { className: 'form-group' },
                      _react2.default.createElement(_semanticUiReact.Form.Field, { className: 'form-label', label: 'Free Loan legal disbursements' }),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Field,
                        { className: 'form-value' },
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          toggle: true,
                          name: 'freeLALegalFeeDisbursements',
                          checked: data.freeLALegalFeeDisbursements,
                          onChange: this.handleCheckboxChange
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { className: 'form-group' },
                      _react2.default.createElement(_semanticUiReact.Form.Field, { className: 'form-label', label: 'Free Loan stamp duty' }),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Field,
                        { className: 'form-value' },
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          toggle: true,
                          name: 'freeLAStampDuty',
                          checked: data.freeLAStampDuty,
                          onChange: this.handleCheckboxChange
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { className: 'form-group' },
                      _react2.default.createElement(_semanticUiReact.Form.Field, { className: 'form-label', label: 'Free Valuation fee' }),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Field,
                        { className: 'form-value' },
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          toggle: true,
                          name: 'freeValuationFee',
                          checked: data.freeValuationFee,
                          onChange: this.handleCheckboxChange
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { className: 'form-group' },
                      _react2.default.createElement(_semanticUiReact.Form.Field, { className: 'form-label', label: 'First time home buyer' }),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Field,
                        { className: 'form-value' },
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          toggle: true,
                          name: 'firstTimeBuyer',
                          checked: data.firstTimeBuyer,
                          onChange: this.handleCheckboxChange
                        })
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(_semanticUiReact.Button, {
              primary: true,
              content: 'Calculate',
              onClick: this.handleCalculateLoan,
              disabled: loading,
              floated: 'right'
            }),
            _react2.default.createElement(_semanticUiReact.Button, {
              floated: 'right',
              onClick: function onClick(e) {
                e.preventDefault();
                _this3.handleResetChanges();
              },
              disabled: loading,
              basic: true,
              content: 'Reset to default',
              style: { marginRight: '1rem' }
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { style: this.props.isMobile ? { marginTop: '2rem' } : null, mobile: 16, tablet: 8, computer: 8 },
            this.renderResultSegment()
          )
        )
      );
    }
  }]);

  return MortgageCalculator;
}(_react.Component);

MortgageCalculator.contextTypes = {
  store: _propTypes2.default.object
};
MortgageCalculator.propTypes = {
  packagePricings: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  projectCurrencies: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  projectID: _propTypes2.default.string,
  unitID: _propTypes2.default.string,
  spaValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  token: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool,
  unitData: _propTypes2.default.shape({
    project: _propTypes2.default.shape({
      maOwnerCompanyBranchID: _propTypes2.default.number
    })
  }),
  userAuth: _propTypes2.default.shape({
    isDeveloper: _propTypes2.default.bool,
    isSiteplan: _propTypes2.default.bool,
    isBranchLeader: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isExternalAgencyAdmin: _propTypes2.default.bool,
    allowEditUnitPrice: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool
  })
};

MortgageCalculator.getPropsToState = function (props) {
  var packagePricings = props.packagePricings || [];
  var token = props.token || '';
  var data = Object.assign({}, MortgageCalculator.defaultValues);
  var result = Object.assign({}, MortgageCalculator.defaultResult);
  var loanMargin = 90;
  data.spaPrice = parseFloat(props.spaValue);
  data.loanAmount = Math.floor(loanMargin / 100 * data.spaPrice);
  return {
    data: data,
    loanMargin: loanMargin,
    packagePricings: packagePricings,
    result: result,
    token: token
  };
};

MortgageCalculator.defaultValues = {
  loanAmount: 0,
  tenureYear: 35,
  interestRate: 0,
  freeSPALegalFee: false,
  freeSPALegalFeeDisbursements: false,
  freeSPAMOTStampDuty: false,
  freeLALegalFee: false,
  freeLALegalFeeDisbursements: false,
  freeLAStampDuty: false,
  freeValuationFee: false,
  firstTimeBuyer: false
};
MortgageCalculator.defaultResult = {
  monthlyLoanPayment: 0,
  spaLegalFee: 0,
  spaLegalFeeSST: 0,
  spaLegalFeeDisbursements: 0,
  laLegalFee: 0,
  laLegalFeeSST: 0,
  laLegalFeeDisbursements: 0,
  laStampDuty: 0,
  valuationFee: 0,
  valuationFeeSST: 0,
  valuationFeeDisbursements: 0,
  totalSPAFees: 0,
  totalLAFees: 0,
  totalValuationFees: 0,
  motStampDuty: 0,
  totalAdditionalFees: 0
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this4.setState({ loading: loading }, function () {
        res(loading);
      });
    });
  };

  this.getPricingPackages = function () {
    var spaValue = _this4.props.spaValue;

    var packagePricings = _this4.state.packagePricings.sort(function (a, b) {
      return a.orderPriority - b.orderPriority;
    });
    var options = [{
      text: spaValue,
      amount: spaValue,
      value: 'spa_value',
      content: _react2.default.createElement(
        _semanticUiReact.Header,
        { className: 'ppItem' },
        _react2.default.createElement(
          'div',
          { className: 'name' },
          'Unit base selling price'
        ),
        _react2.default.createElement(
          'div',
          { className: 'value' },
          _react2.default.createElement(_LoanAmount2.default, {
            precise: false,
            format: '0,000,000.00',
            amount: spaValue,
            prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
          })
        )
      )
    }];
    packagePricings.forEach(function (p) {
      var name = p.isCustomPrice ? p.customName : p.projectPackagePricing.name;
      var newItem = {
        text: p.spaPrice,
        amount: p.spaPrice,
        value: p.id,
        content: _react2.default.createElement(
          _semanticUiReact.Header,
          { className: 'ppItem' },
          _react2.default.createElement(
            'div',
            { className: 'name' },
            name
          ),
          _react2.default.createElement(
            'div',
            { className: 'value' },
            _react2.default.createElement(_LoanAmount2.default, {
              precise: false,
              format: '0,000,000.00',
              amount: p.spaPrice,
              prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
            })
          )
        )
      };
      options.push(newItem);
    });
    return options;
  };

  this.getLoanMarginOptions = function () {
    var options = [];
    for (var i = 0; i <= 100; i += 1) {
      options = [].concat(_toConsumableArray(options), [{
        key: i,
        value: i,
        text: i + '%'
      }]);
    }
    return options.sort(function (a, b) {
      return b.value - a.value;
    });
  };

  this.handleCheckboxChange = function (e, d) {
    var data = _this4.state.data;

    data[d.name] = !data[d.name];
    _this4.setState({ data: data });
  };

  this.handleAmountChange = function (e, d) {
    var _state2 = _this4.state,
        data = _state2.data,
        loanMargin = _state2.loanMargin;

    var loanPercent = loanMargin;
    var amount = 0;
    if (d.value !== '') {
      amount = parseFloat(d.value);
    }
    loanPercent = Math.ceil(amount / data.spaPrice * 100);
    data.loanAmount = amount;
    _this4.setState({ data: data, loanMargin: loanPercent });
  };

  this.handlePricingPackageChange = function (e, d) {
    var _state3 = _this4.state,
        data = _state3.data,
        loanMargin = _state3.loanMargin;

    var selectedPP = d.options.find(function (o) {
      return o.value === d.value;
    });
    if (selectedPP) {
      data.spaPrice = selectedPP.amount;
      data.loanAmount = Math.floor(loanMargin / 100 * data.spaPrice);
    }
    _this4.setState({ data: data, selectedPricingPackage: d.value });
  };

  this.handleChange = function (e, d) {
    var data = _this4.state.data;
    var loanMargin = _this4.state.loanMargin;

    if (d.name === 'loanMargin') {
      loanMargin = _lodash2.default.toNumber(d.value);
      data.loanAmount = Math.floor(loanMargin / 100 * data.spaPrice);
    }
    data[d.name] = d.value;
    _this4.setState({ data: data, loanMargin: loanMargin });
  };

  this.handleCalculateLoan = function () {
    _this4.calculateLoan();
  };

  this.handleResetChanges = function () {
    var data = Object.assign({}, MortgageCalculator.defaultValues);
    var result = Object.assign({}, MortgageCalculator.defaultResult);
    var loanMargin = 90;
    data.spaPrice = parseFloat(_this4.props.spaValue);
    data.loanAmount = Math.floor(loanMargin / 100 * data.spaPrice);
    _this4.setState({
      data: data,
      loanMargin: loanMargin,
      result: result,
      selectedPricingPackage: 'spa_value'
    });
  };

  this.handleCopyShareInfo = function (e) {
    e.preventDefault();
    var store = _this4.context.store;
    var userAuth = _this4.props.userAuth;
    var _state4 = _this4.state,
        data = _state4.data,
        loanMargin = _state4.loanMargin,
        result = _state4.result,
        selectedPricingPackage = _state4.selectedPricingPackage,
        packagePricings = _state4.packagePricings;
    var unitData = _this4.props.unitData;

    var selectedPricingPackageName = 'Unit base selling price';
    if (selectedPricingPackage !== 'spa_value') {
      var selectedPP = packagePricings.find(function (p) {
        return p.id === selectedPricingPackage;
      });
      selectedPricingPackageName = selectedPP.isCustomPrice ? selectedPP.customName : selectedPP.projectPackagePricing.name;
    }
    var copyText = (0, _sharing.shareUnitMorCalcCopyFormat)(unitData, data, loanMargin, result, userAuth, selectedPricingPackageName);
    var textArea = document.createElement('textarea');
    textArea.value = copyText;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('Copy');
    textArea.remove();
    store.dispatch((0, _flash.flashSuccessMessage)({
      header: 'Copy Success',
      message: 'Successfully copied cost details to your clipboard'
    }));
  };

  this.renderResultSegment = function () {
    var _state5 = _this4.state,
        loading = _state5.loading,
        result = _state5.result;
    var projectCurrencies = _this4.props.projectCurrencies;

    var resultData = [{ name: 'totalSPAFees', title: 'SPA', value: result.totalSPAFees, isTotal: true }, { name: 'spaLegalFee', title: 'Legal fee (Property value)', value: result.spaLegalFee }, { name: 'spaLegalFeeSST', title: 'Legal fee SST (8%)', value: result.spaLegalFeeSST }, { name: 'spaLegalFeeDisbursements', title: 'Legal disbursements*', value: result.spaLegalFeeDisbursements }, { name: 'totalLAFees', title: 'Loan agreement', value: result.totalLAFees, isTotal: true }, { name: 'laLegalFee', title: 'Legal fee (Loan amount)', value: result.laLegalFee }, { name: 'laLegalFeeSST', title: 'Legal fee SST (8%)', value: result.laLegalFeeSST }, { name: 'laLegalFeeDisbursements', title: 'Legal disbursements*', value: result.laLegalFeeDisbursements }, { name: 'laStampDuty', title: 'Stamp duty', value: result.laStampDuty }, { name: 'totalValuationFees', title: 'Valuation fees', value: result.totalValuationFees, isTotal: true }, { name: 'valuationFee', title: 'Valuation fee (Property value)', value: result.valuationFee }, { name: 'valuationFeeSST', title: 'Valuation fee SST (8%)', value: result.valuationFeeSST }, { name: 'valuationFeeDisbursements', title: 'Disbursements*', value: result.valuationFeeDisbursements }, { name: 'totalMotStampDuty', title: 'Instrument of transfer (MoT / DoA)', value: '', isTotal: true }, { name: 'motStampDuty', title: 'Stamp duty', value: result.motStampDuty }];
    return _react2.default.createElement(
      _semanticUiReact.Segment,
      { className: 'resultBreakdown' },
      _react2.default.createElement(
        _semanticUiReact.Grid,
        { className: 'totalGrid', columns: 2 },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 13 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { paddingTop: '1rem' }, className: 'title' },
            'Estimated monthly payment'
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'value' },
            _react2.default.createElement(_LoanAmount2.default, {
              projectCurrencies: projectCurrencies,
              format: '0,000,000.00',
              amount: result.monthlyLoanPayment,
              prefix: _react2.default.createElement(_CurrencySymbol2.default, null),
              precise: false
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { verticalAlign: 'middle', textAlign: 'right', width: 3 },
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              basic: true,
              icon: true,
              size: 'small',
              title: 'Click to copy',
              onClick: _this4.handleCopyShareInfo
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'copy outline' })
          )
        )
      ),
      _react2.default.createElement(_semanticUiReact.Divider, null),
      _react2.default.createElement(
        _semanticUiReact.Dimmer,
        { style: { zIndex: 20 }, active: loading, inverted: true },
        loading && _react2.default.createElement(
          _semanticUiReact.Loader,
          { inline: 'centered' },
          'Loading'
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 16, style: { marginBottom: '1rem' } },
        _react2.default.createElement(
          'p',
          { className: 'title' },
          'Additional cost'
        )
      ),
      resultData.map(function (rd, idx) {
        return _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', key: idx },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 10, tablet: 8, mobile: 9, verticalAlign: 'middle' },
            _react2.default.createElement(
              'p',
              { className: rd.isTotal ? 'totalFee' : 'fee' },
              rd.title
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 6, tablet: 8, mobile: 7, verticalAlign: 'middle', textAlign: 'right' },
            _react2.default.createElement(
              'p',
              {
                className: rd.isTotal || rd.name === 'motStampDuty' ? 'totalFee' : 'fee',
                style: { paddingTop: rd.name === 'motStampDuty' ? '0' : undefined }
              },
              rd.value !== '' ? _react2.default.createElement(_LoanAmount2.default, {
                projectCurrencies: projectCurrencies,
                format: '0,000,000.00',
                amount: rd.value,
                prefix: _react2.default.createElement(_CurrencySymbol2.default, null),
                precise: false
              }) : ''
            )
          )
        );
      }),
      _react2.default.createElement(_semanticUiReact.Divider, null),
      _react2.default.createElement(
        _semanticUiReact.Grid,
        { columns: 2, className: 'totalGrid' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 10, className: 'title' },
            'Estimated total additional cost'
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 6, textAlign: 'right' },
            '* Actual amount may vary'
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { className: 'value' },
          _react2.default.createElement(_LoanAmount2.default, {
            projectCurrencies: projectCurrencies,
            format: '0,000,000.00',
            amount: result.totalAdditionalFees,
            prefix: _react2.default.createElement(_CurrencySymbol2.default, null),
            precise: false
          })
        )
      )
    );
  };
};

exports.default = MortgageCalculator;

/***/ }),
/* 2159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchMultiUnits = function (_Component) {
  _inherits(SearchMultiUnits, _Component);

  function SearchMultiUnits(props) {
    _classCallCheck(this, SearchMultiUnits);

    var _this = _possibleConstructorReturn(this, (SearchMultiUnits.__proto__ || Object.getPrototypeOf(SearchMultiUnits)).call(this, props));

    _initialiseProps.call(_this);

    var state = SearchMultiUnits.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(SearchMultiUnits, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = SearchMultiUnits.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          searchValue = _state.searchValue,
          statusValue = _state.statusValue;
      var multiFilter = this.props.multiFilter;

      return _react2.default.createElement(
        'form',
        { onSubmit: this.handleSearchSubmit },
        _react2.default.createElement(_semanticUiReact.Input, {
          className: 'multi-edit-search',
          icon: _react2.default.createElement(_semanticUiReact.Icon, {
            circular: true,
            color: 'teal',
            inverted: true,
            link: true,
            name: 'search',
            onClick: this.handleSearchSubmit,
            title: 'Search'
          }),
          label: !multiFilter && _react2.default.createElement(_semanticUiReact.Dropdown, {
            basic: true,
            onChange: this.handleStatusOnChange,
            options: this.props.statusOptions,
            selectOnBlur: false,
            value: statusValue
          }),
          onChange: this.handleSearchOnChange,
          placeholder: this.props.t('Search...', { ns: _translation.TRANSLATION_FILES.translation }),
          value: searchValue
        })
      );
    }
  }]);

  return SearchMultiUnits;
}(_react.Component);

SearchMultiUnits.propTypes = {
  searchOnChange: _propTypes2.default.func,
  searchOnSubmit: _propTypes2.default.func.isRequired,
  searchValue: _propTypes2.default.string.isRequired,
  statusOnChange: _propTypes2.default.func,
  statusOptions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string,
    value: _propTypes2.default.string
  })),
  statusValue: _propTypes2.default.string,
  multiFilter: _propTypes2.default.bool,
  t: _propTypes2.default.func
};

SearchMultiUnits.getPropsToState = function (props) {
  var searchValue = props.searchValue || '';
  var statusValue = props.statusValue || '';
  return {
    searchValue: searchValue,
    statusValue: statusValue
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleSearchOnChange = function (e, data) {
    _this2.setState({ searchValue: data.value }, function () {
      if (_this2.props.searchOnChange) {
        _this2.props.searchOnChange(e, data);
      }
    });
  };

  this.handleSearchSubmit = function (e) {
    e.preventDefault();
    _this2.props.searchOnSubmit(_this2.state.searchValue);
  };

  this.handleStatusOnChange = function (e, data) {
    _this2.setState({ searchValue: data.value }, function () {
      if (_this2.props.statusOnChange) {
        _this2.props.statusOnChange(e, data);
      }
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(SearchMultiUnits);

/***/ }),
/* 2160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var steps = [{
  icon: 'Verify',
  title: 'Verification',
  description: 'Consent form and verification for purchaser to e-sign'
}, {
  icon: 'IC',
  title: 'Photo of IC',
  description: 'IC Front and Back'
}, {
  icon: 'income_new',
  title: 'Purchaser\'s Income',
  description: 'Input either basic or detailed income'
}]; /* eslint-disable react/jsx-no-target-blank */


var CreditCheckSplash = function CreditCheckSplash(_ref) {
  var actionNode = _ref.actionNode;
  return _react2.default.createElement(
    _semanticUiReact.Grid,
    { stackable: true, doubling: true, textAlign: 'center' },
    _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { columns: 4 },
      steps.map(function (step, idx) {
        return _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { key: idx },
          _react2.default.createElement(
            _semanticUiReact.Header,
            { as: 'h3', icon: true, style: { color: '#00233B' } },
            _react2.default.createElement(
              'i',
              { className: 'green circular inverted icon' },
              _react2.default.createElement('img', { src: '/assets/images/icons/' + step.icon + '.svg', alt: '' })
            ),
            idx + 1,
            '. ',
            step.title,
            _react2.default.createElement(
              _semanticUiReact.Header,
              { as: 'h5', style: { color: 'rgba(0, 35, 59, 0.9)', marginTop: 0 } },
              step.description
            )
          )
        );
      })
    ),
    _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { style: { padding: '1rem' } },
      _react2.default.createElement(
        _semanticUiReact.Header,
        {
          as: 'h5',
          style: { color: 'rgba(114, 140, 152, 1)', fontWeight: 'normal' }
        },
        'If Purchaser is not available to e-sign, you may ',
        _react2.default.createElement(
          'a',
          { className: 'consentLink', href: 'https://mhub.my/consent/credit_check/', target: '_blank' },
          'download the Consent Form'
        ),
        _react2.default.createElement('br', null),
        'to send it over to the Puchaser and get them to send signed copy to you.'
      )
    ),
    actionNode
  );
};

CreditCheckSplash.propTypes = {
  actionNode: _propTypes2.default.node
};

exports.default = CreditCheckSplash;

/***/ }),
/* 2161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint-disable react/self-closing-comp */
/* eslint max-len: 0*/

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Logo = function Logo(_ref) {
  var isFetching = _ref.isFetching,
      mhub = _ref.mhub,
      customLogoSrc = _ref.customLogoSrc;
  return _react2.default.createElement(
    _reactRouter.Link,
    { to: '/', className: customLogoSrc === '' && 'logo ' + (isFetching ? 'loading' : '') },
    customLogoSrc === '' ? _react2.default.createElement(
      'svg',
      {
        version: '1.0',
        xmlns: 'http://www.w3.org/2000/svg',
        x: '0px',
        y: '0px',
        viewBox: '0 0 204 44',
        enableBackground: 'new 0 0 204 44'
      },
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('polygon', { className: 'brick-1', fill: '#0094B3', points: '22.1,22.7 1,43.8 1,22.7' }),
        _react2.default.createElement('polygon', { className: 'brick-8', fill: '#28A181', points: '23.7,22.7 44.8,43.8 44.8,22.7' }),
        _react2.default.createElement('polygon', { className: 'brick-7', fill: '#28A181', points: '67.5,22.7 46.3,43.8 46.3,22.7' }),
        _react2.default.createElement('polygon', { className: 'brick-5', fill: '#358337', points: '69,22.7 90.1,43.8 90.1,22.7' }),
        _react2.default.createElement('polygon', { className: 'brick-2', fill: '#0094B3', points: '22.1,0 1,21.1 22.1,21.1' }),
        _react2.default.createElement('polygon', { className: 'brick-4', fill: '#8AC193', points: '67.5,0 46.3,21.1 67.5,21.1' }),
        _react2.default.createElement('polygon', { className: 'brick-3', fill: '#8AC193', points: '23.7,0 44.8,21.1 23.7,21.1' }),
        _react2.default.createElement('polygon', { className: 'brick-6', fill: '#358337', points: '69,0 90.1,21.1 69,21.1' })
      ),
      mhub ? _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('path', { fill: '#272727', d: 'M117.9,33.3V23l-3,5.3h-3.4l-3-5.3v10.3h-5.3V11.8h5.2l4.8,9.5l4.8-9.5h5.2v21.5H117.9z' }),
        _react2.default.createElement('path', { fill: '#555555', d: 'M144.8,33.3v-8.5h-5.6v8.5h-5.3V11.8h5.3v8.3h5.6v-8.3h5.3v21.5H144.8z' }),
        _react2.default.createElement('path', { fill: '#555555', d: 'M168.5,33.5c-4.5,0-8.1-3-8.1-7.7v-14h5.3v13.8c0,2,1.1,3.1,2.8,3.1s2.9-1.1,2.9-3.1V11.8h5.3v13.9C176.6,30.5,172.9,33.5,168.5,33.5z' }),
        _react2.default.createElement('path', { fill: '#555555', d: 'M196.3,33.3H187V11.8h8.9c4.5,0,6.8,2.5,6.8,6.2c0,2.4-1.7,3.8-2.4,4.3c0.9,0.5,2.7,1.7,2.7,4.7C203,31.1,200.1,33.3,196.3,33.3z M195.5,16.6h-3.3v3.5h3.3c1.4,0,1.9-0.9,1.9-1.7S197,16.6,195.5,16.6z M195.8,24.8h-3.6v3.8h3.6c1.4,0,1.9-1,1.9-1.9S197.2,24.8,195.8,24.8z' })
      ) : null
    ) : _react2.default.createElement('img', { className: 'logo_custom_wl', alt: 'Logo', src: customLogoSrc })
  );
};

Logo.propTypes = {
  isFetching: _propTypes2.default.bool,
  mhub: _propTypes2.default.bool,
  customLogoSrc: _propTypes2.default.string.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return _extends({}, state.fetchM);
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(Logo);

/***/ }),
/* 2162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _translation = __webpack_require__(4);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _Phone = __webpack_require__(126);

var _Phone2 = _interopRequireDefault(_Phone);

var _amount = __webpack_require__(87);

var _user = __webpack_require__(1599);

var _user2 = _interopRequireDefault(_user);

var _fetchM = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BankCases = function (_Component) {
  _inherits(BankCases, _Component);

  _createClass(BankCases, null, [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var updates = {};
      if (nextProps.projectCurrencies !== prevState.projectCurrencies) {
        updates.projectCurrencies = nextProps.projectCurrencies || '';
      }
      if (nextProps.bankCases !== prevState.propBankCases) {
        updates.propBankCases = nextProps.bankCases;
        updates.bankCases = nextProps.bankCases || [];
      }
      return Object.keys(updates).length > 0 ? updates : null;
    }
  }]);

  function BankCases(props) {
    var _this2 = this;

    _classCallCheck(this, BankCases);

    var _this = _possibleConstructorReturn(this, (BankCases.__proto__ || Object.getPrototypeOf(BankCases)).call(this, props));

    _this.getCaseText = function (status) {
      switch (status) {
        case 'new':
          return 'New';
        case 'pending_docs':
          return 'Pending Docs';
        case 'pending_docs_submitted':
          return 'Docs Submitted';
        case 'approved_lo_issued':
          return 'LO Issued';
        case 'pending_unreachable':
          return 'Unreachable';
        case 'pending_reappealed':
          return 'Loan Re-appealed';
        case 'pending_meeting':
          return 'Pending Meeting';
        case 'meeting_completed':
          return 'Meeting Completed';
        case 'reject_wrong_info':
          return 'Wrong Info';
        case 'reject_cancelled':
          return 'Customer Cancelled';
        case 'success_li_issued':
          return 'LO Signed';
        case 'reject_unqualified':
          return 'Unqualified';
        case 'reject_bank':
          return 'Loan Rejected';
        case 'reject_customer':
          return 'Customer Rejected';
        case 'reject_lo_signed_other_bank':
          return 'LO Signed With Another Bank';
        case 'reject_developer':
          return 'Developer Cancelled';
        default:
          return '';
      }
    };

    _this.getColor = function (status) {
      if (!status) return 'blue';
      if (status.startsWith('reject')) return 'red';
      if (status.startsWith('pending')) return 'yellow';
      if (status.startsWith('approved') || status.startsWith('success') || status.startsWith('meeting')) return 'green';
      return 'blue';
    };

    _this.revokeBlobURLs = function () {
      Object.values(_this.blobURLs).forEach(function (url) {
        return URL.revokeObjectURL(url);
      });
      _this.blobURLs = {};
    };

    _this.resetAvatarCaches = function () {
      _this.revokeBlobURLs();
      _this.setState({ avatarBlobURLs: {}, avatarLoading: {} });
    };

    _this.fetchAvatars = function (bankCases) {
      var opportunityID = _this.props.opportunityID;

      if (!opportunityID) return;
      var queuedMediaIDs = new Set();
      bankCases.forEach(function (bankCase) {
        var mediaID = bankCase.banker && bankCase.banker.profilePictureMediaID;
        if (!mediaID || queuedMediaIDs.has(mediaID)) return;
        if (Object.prototype.hasOwnProperty.call(_this.state.avatarBlobURLs, mediaID) || _this.state.avatarLoading[mediaID]) return;
        queuedMediaIDs.add(mediaID);
        _this.fetchAvatar(mediaID, opportunityID);
      });
    };

    _this.fetchAvatar = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(mediaID, opportunityID) {
        var store, res, blob, blobURL;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = _this.context.store;

                if (store) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                _this.setState(function (prevState) {
                  return {
                    avatarLoading: _extends({}, prevState.avatarLoading, _defineProperty({}, mediaID, true))
                  };
                });
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/opportunity/' + opportunityID + '/loan_tracker/lt_shared_media/' + mediaID + '/', { credentials: 'include', method: 'GET', ignoreNotFound: true }));

              case 7:
                res = _context.sent;

                if (_this.mounted) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return');

              case 10:
                if (res.ok) {
                  _context.next = 13;
                  break;
                }

                _this.setState(function (prevState) {
                  return {
                    avatarBlobURLs: _extends({}, prevState.avatarBlobURLs, _defineProperty({}, mediaID, null)),
                    avatarLoading: _extends({}, prevState.avatarLoading, _defineProperty({}, mediaID, false))
                  };
                });
                return _context.abrupt('return');

              case 13:
                _context.next = 15;
                return res.blob();

              case 15:
                blob = _context.sent;

                if (_this.mounted) {
                  _context.next = 18;
                  break;
                }

                return _context.abrupt('return');

              case 18:
                blobURL = URL.createObjectURL(blob);

                _this.blobURLs[mediaID] = blobURL;
                _this.setState(function (prevState) {
                  return {
                    avatarBlobURLs: _extends({}, prevState.avatarBlobURLs, _defineProperty({}, mediaID, blobURL)),
                    avatarLoading: _extends({}, prevState.avatarLoading, _defineProperty({}, mediaID, false))
                  };
                });
                _context.next = 28;
                break;

              case 23:
                _context.prev = 23;
                _context.t0 = _context['catch'](4);

                if (_this.mounted) {
                  _context.next = 27;
                  break;
                }

                return _context.abrupt('return');

              case 27:
                _this.setState(function (prevState) {
                  return {
                    avatarBlobURLs: _extends({}, prevState.avatarBlobURLs, _defineProperty({}, mediaID, null)),
                    avatarLoading: _extends({}, prevState.avatarLoading, _defineProperty({}, mediaID, false))
                  };
                });

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[4, 23]]);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.renderBankerAvatar = function (bankCase) {
      var _this$state = _this.state,
          avatarBlobURLs = _this$state.avatarBlobURLs,
          avatarLoading = _this$state.avatarLoading;

      var mediaID = bankCase.banker && bankCase.banker.profilePictureMediaID;
      var isLoading = mediaID && avatarLoading[mediaID];
      var blobURL = mediaID && avatarBlobURLs[mediaID];
      var src = blobURL || _user2.default;

      if (isLoading) {
        return _react2.default.createElement(
          'div',
          {
            style: {
              width: '44px',
              height: '44px',
              borderRadius: '50%',
              background: '#f3f4f6',
              border: '1px solid rgba(34, 36, 38, 0.08)',
              flexShrink: 0,
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: 'rgba(0,0,0,0.4)'
            }
          },
          _react2.default.createElement(_semanticUiReact.Icon, { loading: true, name: 'spinner' })
        );
      }

      var bankerName = bankCase.banker && bankCase.banker.name;
      return _react2.default.createElement(_semanticUiReact.Image, {
        src: src,
        alt: bankerName || '',
        style: {
          width: '44px',
          height: '44px',
          borderRadius: '50%',
          objectFit: 'cover',
          background: '#f3f4f6',
          border: '1px solid rgba(34, 36, 38, 0.08)',
          flexShrink: 0
        }
      });
    };

    _this.state = {
      projectCurrencies: props.projectCurrencies || '',
      propBankCases: props.bankCases,
      bankCases: props.bankCases || [],
      avatarBlobURLs: {},
      avatarLoading: {}
    };
    _this.blobURLs = {};
    _this.mounted = false;
    return _this;
  }

  _createClass(BankCases, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      this.fetchAvatars(this.props.bankCases || []);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.opportunityID !== this.props.opportunityID) {
        this.resetAvatarCaches();
        this.fetchAvatars(this.props.bankCases || []);
        return;
      }
      if (prevProps.bankCases !== this.props.bankCases) {
        this.fetchAvatars(this.props.bankCases || []);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
      this.revokeBlobURLs();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;
      var _state = this.state,
          bankCases = _state.bankCases,
          projectCurrencies = _state.projectCurrencies;
      var leadLoanAmount = this.props.leadLoanAmount;


      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { columns: 2, stretched: true, stackable: true, doubling: true },
        bankCases.map(function (bankCase) {
          var statusText = t(_this3.getCaseText(bankCase.status), { ns: _translation.TRANSLATION_FILES.constants });

          var statusColor = _this3.getColor(bankCase.status);

          return _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { key: bankCase.id },
            _react2.default.createElement(
              _semanticUiReact.Segment,
              { raised: true, padded: true, className: 'bankcases-segment' },
              _react2.default.createElement(
                'div',
                { className: 'card-header' },
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  { as: 'h4', className: 'header' },
                  _this3.renderBankerAvatar(bankCase),
                  _react2.default.createElement(
                    _semanticUiReact.Header.Content,
                    { className: 'header-content' },
                    bankCase.bank ? bankCase.bank.shortName || bankCase.bank.name : '',
                    _react2.default.createElement(
                      _semanticUiReact.Header.Subheader,
                      null,
                      bankCase.banker && bankCase.banker.bankBranch ? bankCase.banker.bankBranch.name : ''
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  {
                    basic: true,
                    color: statusColor,
                    className: 'header-status'
                  },
                  statusText
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'banker-section' },
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  { as: 'h4', className: 'banker-header' },
                  bankCase.banker.name
                ),
                _react2.default.createElement(
                  _semanticUiReact.List,
                  { className: 'banker-list' },
                  _react2.default.createElement(
                    _semanticUiReact.List.Item,
                    null,
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'phone', className: 'banker-phone' }),
                    _react2.default.createElement(
                      _semanticUiReact.List.Content,
                      null,
                      _react2.default.createElement(_Phone2.default, {
                        mobilePrefix: bankCase.banker.mobilePrefix,
                        mobile: bankCase.banker.mobile,
                        className: 'banker-link'
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.List.Item,
                    null,
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'mail outline' }),
                    _react2.default.createElement(
                      _semanticUiReact.List.Content,
                      null,
                      bankCase.banker.email || '—'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'footer-section' },
                _react2.default.createElement(
                  'div',
                  { className: 'footer-loan-container' },
                  _react2.default.createElement(
                    'div',
                    { className: 'footer-title' },
                    t('Loan amount applied', { ns: _translation.TRANSLATION_FILES.constants })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'footer-content' },
                    projectCurrencies,
                    ' ',
                    (0, _amount.formatAmountIntl)(Number(bankCase.loanAmount) || Number(leadLoanAmount) || 0, 'vi-VN')
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'footer-update-container' },
                  _react2.default.createElement(
                    'div',
                    { className: 'footer-title' },
                    t('Last updated on', { ns: _translation.TRANSLATION_FILES.constants })
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'footer-content' },
                    _react2.default.createElement(_Timestamp2.default, {
                      timestamp: bankCase.latestUpdateAt || bankCase.createdAt,
                      format: 'DD/MM/YY hh:mm a'
                    })
                  )
                )
              )
            )
          );
        })
      );
    }
  }]);

  return BankCases;
}(_react.Component);

BankCases.contextTypes = {
  store: _propTypes2.default.object
};
BankCases.propTypes = {
  bankCases: _propTypes2.default.arrayOf(_propTypes2.default.object),
  projectCurrencies: _propTypes2.default.string,
  leadLoanAmount: _propTypes2.default.number,
  opportunityID: _propTypes2.default.string,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(BankCases);

/***/ }),
/* 2163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _markdownDraftJs = __webpack_require__(450);

var _draftJs = __webpack_require__(338);

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

var _semanticUiReact = __webpack_require__(2);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _url = __webpack_require__(19);

var _isbase = __webpack_require__(157);

var _isbase2 = _interopRequireDefault(_isbase);

var _UCBookingDatePicker = __webpack_require__(576);

var _UCBookingDatePicker2 = _interopRequireDefault(_UCBookingDatePicker);

var _UCBookingSelectList = __webpack_require__(577);

var _UCBookingSelectListMultiple = __webpack_require__(578);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _vietnam = __webpack_require__(40);

var _vnBookingExport = __webpack_require__(1096);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _UCSearchIn = __webpack_require__(579);

var _UCSearchIn2 = _interopRequireDefault(_UCSearchIn);

var _UCSortButton = __webpack_require__(580);

var _UCSortButton2 = _interopRequireDefault(_UCSortButton);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _UCFixedBarStatus = __webpack_require__(1036);

var _UCFixedBarStatus2 = _interopRequireDefault(_UCFixedBarStatus);

var _lawyerCaseStatuses = __webpack_require__(142);

var _translation = __webpack_require__(4);

var _UCBookingStatusDropdown = __webpack_require__(1035);

var _UCBookingStatusDropdown2 = _interopRequireDefault(_UCBookingStatusDropdown);

var _download = __webpack_require__(361);

var _download2 = _interopRequireDefault(_download);

var _sort = __webpack_require__(765);

var _sort2 = _interopRequireDefault(_sort);

var _loan_green = __webpack_require__(1598);

var _loan_green2 = _interopRequireDefault(_loan_green);

var _document_black = __webpack_require__(1596);

var _document_black2 = _interopRequireDefault(_document_black);

var _credit_card_disabled = __webpack_require__(761);

var _credit_card_disabled2 = _interopRequireDefault(_credit_card_disabled);

var _credit_card_yellow = __webpack_require__(763);

var _credit_card_yellow2 = _interopRequireDefault(_credit_card_yellow);

var _credit_card_green = __webpack_require__(762);

var _credit_card_green2 = _interopRequireDefault(_credit_card_green);

var _loan_disabled = __webpack_require__(764);

var _loan_disabled2 = _interopRequireDefault(_loan_disabled);

var _UCBPopup = __webpack_require__(575);

var _UCBPopup2 = _interopRequireDefault(_UCBPopup);

var _UCBStatusFlag = __webpack_require__(389);

var _UCBStatusFlag2 = _interopRequireDefault(_UCBStatusFlag);

var _opportunityStatuses = __webpack_require__(195);

var _paymentRefundStatuses = __webpack_require__(2228);

var _sourceOfFinanceStatuses = __webpack_require__(584);

var _strings = __webpack_require__(118);

var _currencyMinor = __webpack_require__(326);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var allFilterNames = ['search', 'searchIn', 'customer_name', 'dateRange', 'dateFrom', 'dateTo', 'pendingApprovalDateRange', 'pendingApprovalDateFrom', 'pendingApprovalDateTo', 'approvedDateRange', 'approvedDateFrom', 'approvedDateTo', 'pendingRejectionDateRange', 'pendingRejectionDateFrom', 'pendingRejectionDateTo', 'rejectedDateRange', 'rejectedDateFrom', 'rejectedDateTo', 'pendingCancellationDateRange', 'pendingCancellationDateFrom', 'pendingCancellationDateTo', 'cancelledDateRange', 'cancelledDateFrom', 'cancelledDateTo', 'pendingRefundDateRange', 'pendingRefundDateFrom', 'pendingRefundDateTo', 'refundedDateRange', 'refundedDateFrom', 'refundedDateTo', 'paymentStatus', 'paymentRefundStatus', 'sourceOfFinance', 'loanStatus', 'filteredProjects', 'token_status_id', 'sr_code'];

var urtColorMap = {
  pending_payment: null,
  partially_paid: 'yellow',
  paid_unverified: 'orange',
  paid_verified: 'green',
  expired: 'grey',
  partially_refunded: 'blue',
  refunded: 'blue',
  cancelled: 'red'
};

var OpportunityList = function (_Component) {
  _inherits(OpportunityList, _Component);

  function OpportunityList(props) {
    _classCallCheck(this, OpportunityList);

    var _this = _possibleConstructorReturn(this, (OpportunityList.__proto__ || Object.getPrototypeOf(OpportunityList)).call(this, props));

    _initialiseProps.call(_this);

    var state = OpportunityList.getPropsToState(props);
    var summary = Object.assign({}, OpportunityList.summaryDefault);
    _this.state = _extends({}, state, {
      loading: true,
      count: 0,
      limit: 0,
      offset: 0,
      // for opportunity listing
      cursorPaginations: [], // stack of { pit_id, search_after } per visited page (for Prev)
      currentPageCursor: null, // cursor used to fetch the currently displayed page
      nextCursor: null, // cursor from latest API response (used to fetch next page)
      data: [],
      summary: summary,
      mpUserLoading: false,
      mpUserDetails: {},
      isChanging: false,
      projectOpts: [],
      filteredProjects: [],
      activeAccordionIndex: -1,
      isMobile: state.screenWidth <= 767,
      isTablet: state.screenWidth > 767 && state.screenWidth <= 991,
      isComputer: state.screenWidth > 991,
      projectArData: [],
      srCodeInput: '',
      customerNameInput: '',
      systemData: [],
      allBankCases: [],
      hasDropCase: false,
      loadingCount: 0
    });
    return _this;
  }

  _createClass(OpportunityList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);

      if (query.sr_code) {
        this.setState({ srCodeInput: query.sr_code });
      }
      if (query.customer_name) {
        this.setState({ customerNameInput: query.customer_name });
      }
      this.fetchSystemSettings();
      this.fetchProjects();
      this.replaceQuery(query, true, false);
      this.handleResize();
      this.setStickyWidth();
      this.updateStickyShadows();
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('resize', this.setStickyWidth);
      window.addEventListener('resize', this.updateStickyShadows);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var oldQuery = (0, _url.decodeSearch)(this.props.location.search) || {};
      var nextQuery = (0, _url.decodeSearch)(nextProps.location.search) || {};
      if (nextQuery.sr_code !== oldQuery.sr_code) {
        this.setState({
          srCodeInput: nextQuery.sr_code || ''
        });
      }
      if (nextQuery.customer_name !== oldQuery.customer_name) {
        this.setState({
          customerNameInput: nextQuery.customer_name || ''
        });
      }
      var state = OpportunityList.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.setTimer) {
        clearTimeout(this.setTimer);
      }
      if (this.setStaffTimer) {
        clearTimeout(this.setStaffTimer);
      }
      this.clearPitExpireTimer();
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('resize', this.setStickyWidth);
      window.removeEventListener('resize', this.updateStickyShadows);
    }
    // True while an sr_status-driven tab is the filter; none is, since CPI-1226 re-pointed Error.

  }, {
    key: 'setMPUserLoading',
    value: function setMPUserLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ mpUserLoading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'setLoadingProjectSearch',
    value: function setLoadingProjectSearch() {
      var _this3 = this;

      var loadingProjectSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loadingProjectSearch: loadingProjectSearch }, res);
      });
    }
  }, {
    key: 'setLoadingStaffSearch',
    value: function setLoadingStaffSearch() {
      var _this4 = this;

      var loadingStaffSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loadingStaffSearch: loadingStaffSearch }, res);
      });
    }
  }, {
    key: 'setBookings',
    value: function setBookings() {
      var _this5 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this5.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this6 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this6.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this7 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this7.setState(function (prev) {
          var count = prev.loadingCount || 0;

          var newCount = loading ? count + 1 : Math.max(count - 1, 0); // prevent negative

          var newLoading = newCount > 0;

          return {
            loadingCount: newCount,
            loading: newLoading
          };
        }, function () {
          if (_this7.props.onLoading) {
            _this7.props.onLoading(_this7.state.loading);
          }
          res(_this7.state.loading);
        });
      });
    }
  }, {
    key: 'fetchSystemSettings',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, t, res, message, systemData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context.prev = 3;
                _context.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/settings/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 6:
                res = _context.sent;
                _context.next = 15;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](3);

                Bugsnag.notifyException(_context.t0);
                _context.next = 14;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 14:
                return _context.abrupt('return');

              case 15:
                if (res.ok) {
                  _context.next = 23;
                  break;
                }

                _context.next = 18;
                return res.text();

              case 18:
                message = _context.sent;
                _context.next = 21;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 21:
                _context.next = 28;
                break;

              case 23:
                _context.next = 25;
                return res.json();

              case 25:
                systemData = _context.sent;
                _context.next = 28;
                return this.setState({
                  systemData: systemData
                });

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 9]]);
      }));

      function fetchSystemSettings() {
        return _ref.apply(this, arguments);
      }

      return fetchSystemSettings;
    }()
  }, {
    key: 'fetchProjects',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, t, query, res, message, _message, data, newProjectOpts, newProjectArData;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({
                  limit: 0,
                  showAsOptions: false
                });
                _context2.next = 5;
                return this.setLoading(true);

              case 5:
                res = void 0;
                _context2.prev = 6;
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/projects/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context2.sent;
                _context2.next = 24;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);

                if (!(_context2.t0.res && _context2.t0.res.status >= 399 && _context2.t0.res.status < 500)) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 17;
                return _context2.t0.res.text();

              case 17:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 19:
                _context2.next = 21;
                return this.setLoading(false);

              case 21:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context2.abrupt('return');

              case 24:
                if (res.ok) {
                  _context2.next = 32;
                  break;
                }

                _context2.next = 27;
                return res.text();

              case 27:
                _message = _context2.sent;
                _context2.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 30:
                _context2.next = 40;
                break;

              case 32:
                _context2.next = 34;
                return res.json();

              case 34:
                data = _context2.sent;
                newProjectOpts = this.state.projectOpts;
                newProjectArData = this.state.projectArData;

                if (data && data.length > 0) {
                  newProjectOpts = data.map(function (d) {
                    return { value: d.id, text: d.name };
                  });
                  newProjectArData = data.map(function (d) {
                    return _extends({}, d);
                  });
                }
                _context2.next = 40;
                return this.setComponentState({ projectOpts: newProjectOpts, projectArData: newProjectArData });

              case 40:
                _context2.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 12]]);
      }));

      function fetchProjects() {
        return _ref2.apply(this, arguments);
      }

      return fetchProjects;
    }()
  }, {
    key: 'fetchBookingSummaries',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var store, t, query, res, message, summary;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign(q, {});

                if (this.props.projectUnitID) {
                  query.projectUnitID = this.props.projectUnitID;
                }
                if (q && q.sr_code) {
                  query.sr_code = q.sr_code;
                } else if (this.state.sr_code) {
                  query.sr_code = this.state.sr_code;
                } else {
                  delete query.sr_code;
                }
                if (query.limit) delete query.limit;
                if (query.pit_id) delete query.pit_id;
                if (query.search_after) delete query.search_after;

                res = void 0;
                _context3.prev = 11;
                _context3.next = 14;
                return store.dispatch((0, _fetchM.fetchM)('/opportunity/summary/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 14:
                res = _context3.sent;
                _context3.next = 25;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3['catch'](11);
                _context3.next = 21;
                return this.setLoading(false);

              case 21:
                Bugsnag.notifyException(_context3.t0);
                _context3.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 24:
                return _context3.abrupt('return');

              case 25:
                if (res.ok) {
                  _context3.next = 33;
                  break;
                }

                _context3.next = 28;
                return res.text();

              case 28:
                message = _context3.sent;
                _context3.next = 31;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 31:
                _context3.next = 38;
                break;

              case 33:
                _context3.next = 35;
                return res.json();

              case 35:
                summary = _context3.sent;
                _context3.next = 38;
                return this.setComponentState({ summary: summary });

              case 38:
                _context3.next = 40;
                return this.setLoading(false);

              case 40:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[11, 17]]);
      }));

      function fetchBookingSummaries() {
        return _ref3.apply(this, arguments);
      }

      return fetchBookingSummaries;
    }()
  }, {
    key: 'fetchBookings',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var t, opportunityStatus, store, query, effectiveTokenStatus, isTokenFilter, res, srCode, url, urlOptions, message, _message2, limit, data, count, offset, newCursor;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                opportunityStatus = this.state.opportunityStatus;
                store = this.context.store;
                query = Object.assign({}, q);


                if (query.sortColumn) {
                  query.sort_by = query.sortColumn;
                  query.sort_order = query.sortDirection;

                  delete query.sortColumn;
                  delete query.sortDirection;
                } else {
                  delete query.sort_by;
                  delete query.sort_order;
                }
                effectiveTokenStatus = query.token_status_id || this.state.tokenStatus;
                isTokenFilter = !!effectiveTokenStatus && effectiveTokenStatus !== 'pending_payment';
                res = void 0;


                if (this.props.projectUnitID) {
                  query.projectUnitID = this.props.projectUnitID;
                }
                srCode = typeof query.sr_code === 'string' ? query.sr_code.trim() : '';


                if (srCode) {
                  query.sr_code = srCode;
                } else {
                  delete query.sr_code;
                }

                if (isTokenFilter) {
                  query.token_status_id = effectiveTokenStatus;
                  query.page = Math.max(1, parseInt(query.page, 10) || 1);
                  delete query.pit_id;
                  delete query.search_after;
                  delete query.sr_status;
                } else {
                  if (opportunityStatus) {
                    query.group_status = opportunityStatus;
                  }
                  if (this.state.srStatus) {
                    query.sr_status = this.state.srStatus;
                  }
                  delete query.token_status_id;
                  delete query.page;
                }

                query.limit = 30;
                url = '/opportunity/?' + _qs2.default.stringify(query);
                urlOptions = {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                };
                _context4.prev = 17;
                _context4.next = 20;
                return store.dispatch((0, _fetchM.fetchM)(url, urlOptions));

              case 20:
                res = _context4.sent;
                _context4.next = 35;
                break;

              case 23:
                _context4.prev = 23;
                _context4.t0 = _context4['catch'](17);

                if (!(_context4.t0.res && _context4.t0.res.status >= 399 && _context4.t0.res.status < 500)) {
                  _context4.next = 30;
                  break;
                }

                _context4.next = 28;
                return _context4.t0.res.text();

              case 28:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 30:
                _context4.next = 32;
                return this.setLoading(false);

              case 32:
                Bugsnag.notifyException(_context4.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context4.abrupt('return');

              case 35:
                if (res.ok) {
                  _context4.next = 43;
                  break;
                }

                _context4.next = 38;
                return res.text();

              case 38:
                _message2 = _context4.sent;
                _context4.next = 41;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message2 }));

              case 41:
                _context4.next = 50;
                break;

              case 43:
                limit = parseInt(res.headers.get('M-Data-Limit'), 10);
                _context4.next = 46;
                return res.json();

              case 46:
                data = _context4.sent;
                _context4.next = 49;
                return this.setBookings(data.opportunities);

              case 49:

                if (isTokenFilter) {
                  count = parseInt(res.headers.get('M-Data-Count'), 10) || 0;
                  offset = parseInt(res.headers.get('M-Data-Offset'), 10) || 0;

                  this.setState({ limit: limit, count: count, offset: offset, nextCursor: null });
                } else {
                  newCursor = data.search_after && data.opportunities && data.opportunities.length === limit ? { pit_id: data.pit_id, search_after: data.search_after } : null;

                  this.setState({ limit: limit, nextCursor: newCursor });
                }

              case 50:
                _context4.next = 52;
                return this.setLoading(false);

              case 52:
                this.setStickyWidth();
                this.updateStickyShadows();

              case 54:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[17, 23]]);
      }));

      function fetchBookings() {
        return _ref4.apply(this, arguments);
      }

      return fetchBookings;
    }()
  }, {
    key: 'handleAccordionClick',
    value: function handleAccordionClick(e, valIndex) {
      var index = valIndex.index;

      this.setState(function (prevState) {
        return {
          activeAccordionIndex: prevState.activeAccordionIndex === index ? -1 : index
        };
      });
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isBranchLeader || this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasAdminAccess',
    value: function hasAdminAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasInternalDEAccess',
    value: function hasInternalDEAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var auth = this.props.auth;
      if (auth && auth.companyBranch && !auth.companyBranch.isExternal) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasStaffAccess',
    value: function hasStaffAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isSuperAdmin || this.props.auth.isHeadquarters) {
        return true;
      }
      return check;
    }
  }, {
    key: 'searchStaffs',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(value) {
        var store, t, res, message, json, findStaffResults, noStaffResultsMessage;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                _context5.next = 4;
                return this.setLoadingStaffSearch(true);

              case 4:
                res = null;
                _context5.prev = 5;
                _context5.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/search/staffs/?isExternal=false&limit=3&search=' + value, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context5.sent;
                _context5.next = 22;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5['catch'](5);

                if (!(_context5.t0.res && _context5.t0.res.status >= 400 && _context5.t0.res.status < 500)) {
                  _context5.next = 18;
                  break;
                }

                _context5.next = 16;
                return _context5.t0.res.text();

              case 16:
                message = _context5.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 18:
                _context5.next = 20;
                return this.setLoadingStaffSearch(false);

              case 20:
                Bugsnag.notifyException(_context5.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 22:
                if (res.ok) {
                  _context5.next = 28;
                  break;
                }

                _context5.next = 25;
                return this.setLoadingStaffSearch(false);

              case 25:
                throw new Error('Not OK');

              case 28:
                _context5.next = 30;
                return this.setLoadingStaffSearch(false);

              case 30:
                _context5.next = 32;
                return res.json();

              case 32:
                json = _context5.sent;

                if (json) {
                  findStaffResults = json.map(function (obj) {
                    var newResults = {};
                    newResults.key = obj.id.toString();
                    newResults.title = obj.name;
                    newResults.price = obj.preferredName;
                    newResults.description = obj.email;
                    return newResults;
                  });

                  this.setState({ findStaffResults: findStaffResults });
                } else {
                  noStaffResultsMessage = t('No results found', { ns: _translation.TRANSLATION_FILES.translation }) + '.';

                  this.setState({ noStaffResultsMessage: noStaffResultsMessage });
                }

              case 34:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[5, 11]]);
      }));

      function searchStaffs(_x13) {
        return _ref5.apply(this, arguments);
      }

      return searchStaffs;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var _state = this.state,
          loading = _state.loading,
          data = _state.data,
          cursorPaginations = _state.cursorPaginations,
          limit = _state.limit,
          nextCursor = _state.nextCursor,
          count = _state.count,
          offset = _state.offset,
          tokenStatus = _state.tokenStatus,
          currentPage = _state.currentPage;

      var isTokenFilter = !!tokenStatus && tokenStatus !== 'pending_payment';
      var t = this.props.t;

      var sortItems = [];
      sortItems.push.apply(sortItems, _toConsumableArray(this.statusDateSortItems()));
      var isMalaysia = this.props.auth.company && this.props.auth.company.countryCode === 'my';
      var exportItems = this.exportItemsManager();
      if (isMalaysia) {
        exportItems.push({
          text: 'Excel',
          icon: 'download',
          href: this.exportURL('excel')
        }, {
          text: 'CSV',
          icon: 'download',
          href: this.exportURL('csv')
        }, {
          isDivider: true
        });
      }
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { verticalAlign: 'middle', padded: 'vertically' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            this.renderMenuTool()
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Dimmer,
              {
                inverted: true, style: { zIndex: 20 },
                active: loading && data.length > 0
              },
              _react2.default.createElement(
                _semanticUiReact.Loader,
                { inline: 'centered' },
                t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 10, tablet: 6, computer: 6, verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Header,
                    { as: 'h3' },
                    this.getTabHeader()
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 6, tablet: 10, computer: 10 },

                  // CPI-1281: Vietnam downloads run as a queued export (the CRM list pages behind a
                  // short-lived cursor), so the icon opens the Booking Exports page with these filters.
                  (0, _vietnam.isVietnamCompany)(this.props.auth) && _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center' } },
                    _react2.default.createElement(_semanticUiReact.Popup, {
                      size: 'tiny',
                      style: { backgroundColor: '#596975' },
                      basic: true,
                      inverted: true,
                      content: t('Download', { ns: _translation.TRANSLATION_FILES.translation }),
                      position: 'bottom center',
                      trigger: _react2.default.createElement(
                        _reactRouter.Link,
                        {
                          to: (0, _vnBookingExport.exportsPagePath)((0, _vnBookingExport.exportFiltersFromQuery)((0, _url.decodeSearch)(this.props.location.search))),
                          'data-bot-target': 'download-bookings',
                          style: {
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '50%',
                            padding: '11px',
                            transition: 'background-color 0.2s ease',
                            cursor: 'pointer'
                          },
                          onMouseEnter: function onMouseEnter(e) {
                            var currentTarget = e.currentTarget;

                            currentTarget.style.backgroundColor = '#f4f5f7';
                          },
                          onMouseLeave: function onMouseLeave(e) {
                            var currentTarget = e.currentTarget;

                            currentTarget.style.backgroundColor = 'transparent';
                          }
                        },
                        _react2.default.createElement('img', { src: _download2.default, width: 20, alt: 'download' })
                      )
                    })
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 16 },
                  _react2.default.createElement(
                    'div',
                    { style: { overflowX: 'auto' } },
                    _react2.default.createElement(
                      _semanticUiReact.Table,
                      { className: 'uc-table uc-booking-list-table', basic: 'very', sortable: true },
                      this.renderTableHeaders(sortItems),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Body,
                        null,
                        data.length > 0 ? data.map(this.renderTableRow) : _react2.default.createElement(
                          _semanticUiReact.Table.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Table.Cell,
                            { colSpan: 11, textAlign: 'center' },
                            loading ? _react2.default.createElement(
                              _semanticUiReact.Loader,
                              { active: true, inline: 'centered' },
                              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                            ) : _react2.default.createElement(
                              'p',
                              null,
                              t('No bookings found'),
                              '.'
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'center' },
            _react2.default.createElement(_PageNav2.default, {
              upward: true,
              isCursorPagination: !isTokenFilter,
              currentPage: isTokenFilter ? currentPage : cursorPaginations.length + 1,
              nextCursor: nextCursor,
              cursorStack: cursorPaginations,
              count: count,
              limit: limit,
              offset: offset,
              dataSize: data.length,
              loading: loading,
              onChange: isTokenFilter ? this.handleChangePageOffset : function (param) {
                return _this8.handlePageChange(param);
              },
              noScrollTop: this.props.noScrollTop
            })
          )
        )
      );
    }
  }]);

  return OpportunityList;
}(_react.Component);

OpportunityList.contextTypes = {
  store: _propTypes2.default.object,
  router: _propTypes2.default.object
};
OpportunityList.propTypes = {
  where: _propTypes2.default.shape({}),
  projectUnitID: _propTypes2.default.string,
  onLoading: _propTypes2.default.func,
  noScrollTop: _propTypes2.default.bool,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isBranchLeaderSupervisor: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    groups: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      code: _propTypes2.default.string
    })),
    companyBranch: _propTypes2.default.shape({
      isExternal: _propTypes2.default.bool
    }),
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  t: _propTypes2.default.func
};
OpportunityList.defaultProps = {
  hideBookingList: false
};

OpportunityList.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

OpportunityList.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var sr_code = query.sr_code || '';
  var customer_name = query.customer_name || '';
  var search = query.search || '';
  var searchIn = query.searchIn || '';
  var dateRange = query.dateRange || '';
  var dateFrom = query.dateFrom ? query.dateFrom : '';
  var dateTo = query.dateTo ? query.dateTo : '';
  var pendingApprovalDateRange = query.pendingApprovalDateRange || '';
  var pendingApprovalDateFrom = query.pendingApprovalDateFrom ? query.pendingApprovalDateFrom : '';
  var pendingApprovalDateTo = query.pendingApprovalDateTo ? query.pendingApprovalDateTo : '';
  var approvedDateRange = query.approvedDateRange || '';
  var approvedDateFrom = query.approvedDateFrom ? query.approvedDateFrom : '';
  var approvedDateTo = query.approvedDateTo ? query.approvedDateTo : '';
  var pendingRejectionDateRange = query.pendingRejectionDateRange || '';
  var pendingRejectionDateFrom = query.pendingRejectionDateFrom ? query.pendingRejectionDateFrom : '';
  var pendingRejectionDateTo = query.pendingRejectionDateTo ? query.pendingRejectionDateTo : '';
  var rejectedDateRange = query.rejectedDateRange || '';
  var rejectedDateFrom = query.rejectedDateFrom ? query.rejectedDateFrom : '';
  var rejectedDateTo = query.rejectedDateTo ? query.rejectedDateTo : '';
  var pendingCancellationDateRange = query.pendingCancellationDateRange || '';
  var pendingCancellationDateFrom = query.pendingCancellationDateFrom ? query.pendingCancellationDateFrom : '';
  var pendingCancellationDateTo = query.pendingCancellationDateTo ? query.pendingCancellationDateTo : '';
  var cancelledDateRange = query.cancelledDateRange || '';
  var cancelledDateFrom = query.cancelledDateFrom ? query.cancelledDateFrom : '';
  var cancelledDateTo = query.cancelledDateTo ? query.cancelledDateTo : '';
  var pendingRefundDateRange = query.pendingRefundDateRange || '';
  var pendingRefundDateFrom = query.pendingRefundDateFrom ? query.pendingRefundDateFrom : '';
  var pendingRefundDateTo = query.pendingRefundDateTo ? query.pendingRefundDateTo : '';
  var refundedDateRange = query.refundedDateRange || '';
  var refundedDateFrom = query.refundedDateFrom ? query.refundedDateFrom : '';
  var refundedDateTo = query.refundedDateTo ? query.refundedDateTo : '';
  var opportunityStatus = query.group_status || '';
  var srStatus = query.sr_status || '';
  var tokenStatus = query.token_status_id || '';
  var paymentStatus = query.paymentStatus || [];
  var paymentRefundStatus = query.paymentRefundStatus || [];
  var sourceOfFinance = query.sourceOfFinance || '';
  var loanStatus = query.loanStatus || [];
  var projectFilter = (0, _isbase2.default)(query.projectFilter) && _qs2.default.parse(atob(query.projectFilter)).name || '';
  var staffFilter = (0, _isbase2.default)(query.staffFilter) && _qs2.default.parse(atob(query.staffFilter)).name || ''; // change?
  var loadingProjectSearch = false;
  var loadingStaffSearch = false;
  var findProjectResults = [];
  var findStaffResults = [];
  var loadingMessage = props.t('Loading', { ns: _translation.TRANSLATION_FILES.translation }) + '...';
  var noResultsMessage = loadingMessage;
  var noStaffResultsMessage = loadingMessage;
  // const hasAccess = props.auth.isHeadquarters || props.auth.isSuperAdmin;
  var screenWidth = window.innerWidth;
  return {
    search: search,
    searchIn: searchIn,
    sr_code: sr_code,
    dateRange: dateRange,
    dateTo: dateTo,
    dateFrom: dateFrom,
    pendingApprovalDateRange: pendingApprovalDateRange,
    pendingApprovalDateFrom: pendingApprovalDateFrom,
    pendingApprovalDateTo: pendingApprovalDateTo,
    approvedDateRange: approvedDateRange,
    approvedDateFrom: approvedDateFrom,
    approvedDateTo: approvedDateTo,
    pendingRejectionDateRange: pendingRejectionDateRange,
    pendingRejectionDateFrom: pendingRejectionDateFrom,
    pendingRejectionDateTo: pendingRejectionDateTo,
    rejectedDateRange: rejectedDateRange,
    rejectedDateFrom: rejectedDateFrom,
    rejectedDateTo: rejectedDateTo,
    pendingCancellationDateRange: pendingCancellationDateRange,
    pendingCancellationDateFrom: pendingCancellationDateFrom,
    pendingCancellationDateTo: pendingCancellationDateTo,
    cancelledDateRange: cancelledDateRange,
    cancelledDateFrom: cancelledDateFrom,
    cancelledDateTo: cancelledDateTo,
    pendingRefundDateRange: pendingRefundDateRange,
    pendingRefundDateFrom: pendingRefundDateFrom,
    pendingRefundDateTo: pendingRefundDateTo,
    refundedDateRange: refundedDateRange,
    refundedDateFrom: refundedDateFrom,
    refundedDateTo: refundedDateTo,
    opportunityStatus: opportunityStatus,
    tokenStatus: tokenStatus,
    paymentStatus: paymentStatus,
    paymentRefundStatus: paymentRefundStatus,
    sourceOfFinance: sourceOfFinance,
    loanStatus: loanStatus,
    projectFilter: projectFilter,
    staffFilter: staffFilter,
    loadingProjectSearch: loadingProjectSearch,
    loadingStaffSearch: loadingStaffSearch,
    findProjectResults: findProjectResults,
    findStaffResults: findStaffResults,
    noResultsMessage: noResultsMessage,
    noStaffResultsMessage: noStaffResultsMessage,
    currentPage: currentPage,
    stringifyQuery: '',
    screenWidth: screenWidth,
    srStatus: srStatus,
    customer_name: customer_name
  };
};

OpportunityList.summaryDefault = {
  all: 0,
  pending_approval: 0,
  approved: 0,
  pending_closure: 0,
  pending_refund: 0,
  closed: 0
};

var _initialiseProps = function _initialiseProps() {
  var _this9 = this;

  this.isSingleStatusTabActive = function () {
    return _this9.state.opportunityStatus === '' && _opportunityStatuses.SINGLE_STATUS_TAB_VALUES.indexOf(_this9.state.srStatus) > -1;
  };

  this.getStatusCount = function (status) {
    var summary = _this9.state.summary;

    if (_this9.state.loading || !summary) {
      return '...';
    }
    if (_opportunityStatuses.SINGLE_STATUS_TAB_VALUES.indexOf(status) > -1) {
      return _this9.getIndividualStatusCount(status);
    }
    switch (status) {
      case _opportunityStatuses.OPPORTUNITY_STATUS_GROUP.TOTAL:
        return summary.all || 0;
      case _opportunityStatuses.OPPORTUNITY_STATUS_GROUP.PENDING_APPROVAL:
        return summary.pending_approval ? summary.pending_approval.count : 0;
      case _opportunityStatuses.OPPORTUNITY_STATUS_GROUP.APPROVED:
        return summary.approved ? summary.approved.count : 0;
      case _opportunityStatuses.OPPORTUNITY_STATUS_GROUP.PENDING_CLOSURE:
        return summary.pending_closure ? summary.pending_closure.count : 0;
      case _opportunityStatuses.OPPORTUNITY_STATUS_GROUP.CLOSED:
        return summary.closed ? summary.closed.count : 0;
      case _opportunityStatuses.OPPORTUNITY_STATUS_GROUP.ERROR:
        return summary.error ? summary.error.count : 0;
      case _opportunityStatuses.OPPORTUNITY_STATUS_GROUP.PENDING_REFUND:
        return summary.pending_refund ? summary.pending_refund.count : 0;
      default:
        return 0;
    }
  };

  this.getSelectedStatus = function (status) {
    var _state2 = _this9.state,
        opportunityStatus = _state2.opportunityStatus,
        srStatus = _state2.srStatus;

    if (_opportunityStatuses.SINGLE_STATUS_TAB_VALUES.indexOf(status) > -1) {
      return opportunityStatus === '' && srStatus === status;
    }
    if (status === 'total') {
      // All Bookings must go dark while an sr_status tab is active - both clear group_status.
      return opportunityStatus === '' && !_this9.isSingleStatusTabActive();
    } else if (opportunityStatus !== '') {
      return opportunityStatus === status;
    }
    return false;
  };

  this.getTabHeader = function () {
    var opportunityStatus = _this9.state.opportunityStatus;
    var t = _this9.props.t;

    var statusValue = _this9.isSingleStatusTabActive() && _this9.state.srStatus || opportunityStatus || _opportunityStatuses.DEFAULT_OPPORTUNITY_STATUS;
    // group_status comes off the URL with no allow-list, so fall back rather than index undefined.
    var tab = _opportunityStatuses.OPPORTUNITY_STATUSES_TABS.find(function (status) {
      return statusValue === status.value;
    }) || _opportunityStatuses.OPPORTUNITY_STATUS_MAP[_opportunityStatuses.DEFAULT_OPPORTUNITY_STATUS];
    return t(tab.header, { ns: _translation.TRANSLATION_FILES.constants });
  };

  this.getBankCaseStatusColor = function (status) {
    if (status.startsWith('reject')) {
      return 'red';
    } else if (status.startsWith('pending')) {
      return 'yellow';
    } else if (status.startsWith('approved') || status.startsWith('success')) {
      return 'green';
    }
    return 'blue';
  };

  this.getBankCaseStatuses = function (data) {
    var values = [];
    if (data.bankCasesStatuses) {
      data.bankCasesStatuses.forEach(function (bcs) {
        values.push({
          iconColor: _this9.getBankCaseStatusColor(bcs.status),
          value: bcs.bankShortName
        });
      });
    }
    return values;
  };

  this.getRowClassName = function (statusID) {
    if (statusID === 'cancelled_availability') {
      return 'row-colors booking_row_cancelled_availability';
    }
    if (statusID === 'cancelled_developer' || statusID === _lawyerCaseStatuses.DEVELOPER_CANCELLED) {
      return 'row-colors booking_row_cancelled_developer';
    }
    return 'row-colors';
  };

  this.getAgingColor = function () {
    var days = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (days >= 30) {
      return 'red';
    }
    if (days >= 14) {
      return 'yellow';
    }
    return null;
  };

  this.getBookingIcon = function (bookingStatus) {
    switch (bookingStatus) {
      case _opportunityStatuses.OPPORTUNITY_STATUS.PAID_UNVERIFIED:
      case _opportunityStatuses.OPPORTUNITY_STATUS.PAID_VERIFIED:
      case _opportunityStatuses.OPPORTUNITY_STATUS.APPROVED:
      case _opportunityStatuses.OPPORTUNITY_STATUS.PAYMENT_MADE:
        return _credit_card_green2.default;
      case _opportunityStatuses.OPPORTUNITY_STATUS.PARTIALLY_PAID_UNVERIFIED:
        return _credit_card_yellow2.default;
      default:
        return _credit_card_disabled2.default;
    }
  };

  this.getSourceOfFinanceIcon = function (FinanceSource) {
    switch (FinanceSource) {
      case 'bank_loan':
        return _loan_green2.default;
      default:
        return _loan_disabled2.default;
    }
  };

  this.getAllFilterNames = function () {
    var removeBookingStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (removeBookingStatus) return allFilterNames.filter(function (fn) {
      return fn !== 'bookingStatusMulti';
    });
    return allFilterNames;
  };

  this.getDataTarget = function (idx) {
    return { 'data-bot-target': 'row' + (idx + 1) + '-bookinglist' };
  };

  this.getDatasetAttributes = function (daname, davalue) {
    var newDavalue = davalue;
    if (newDavalue === '') newDavalue = 'NULL';
    if (newDavalue === 'Not Applicable') newDavalue = 'N/A';
    var datasetName = 'data-bot-' + daname;
    return _defineProperty({}, datasetName, newDavalue);
  };

  this.setStickyWidth = function () {
    var table = document.querySelector('table');

    if (!table) return;

    if (_this9.isTableOverflowing(table)) {
      // Table is overflowing - apply sticky
      document.querySelectorAll('tr').forEach(function (row) {
        // Left sticky
        var stickyLeftCols = Array.from(row.querySelectorAll('.uc-sticky-col.uc-left'));
        var cumulativeLeft = 0;
        stickyLeftCols.forEach(function (colParam) {
          var col = colParam;
          col.style.left = cumulativeLeft + 'px';
          cumulativeLeft += col.offsetWidth;
        });

        // Right sticky
        var stickyRightCols = Array.from(row.querySelectorAll('.uc-sticky-col.uc-right')).reverse();
        var cumulativeRight = 0;
        stickyRightCols.forEach(function (colParam) {
          var col = colParam;
          col.style.right = cumulativeRight + 'px';
          cumulativeRight += col.offsetWidth;
        });
      });

      // Enable shadows
      table.classList.add('has-overflow');
    } else {
      // No overflow - reset positions
      document.querySelectorAll('.uc-sticky-col').forEach(function (colElem) {
        var col = colElem;
        col.style.left = '';
        col.style.right = '';
      });

      // Disable shadows
      table.classList.remove('has-overflow');
    }
  };

  this.getAllBankCases = function (bankCases, bankCaseDrops) {
    var hasDropCase = false;
    var allCases = [];
    if (bankCases) {
      var bankerIDs = new Set(bankCases.map(function (bc) {
        return bc.bankerID;
      }));
      allCases = bankCaseDrops ? [].concat(_toConsumableArray(bankCases), _toConsumableArray(bankCaseDrops.filter(function (bcd) {
        if (!bankerIDs.has(bcd.bankerID)) {
          hasDropCase = true;
          return true;
        }
      }))) : [].concat(_toConsumableArray(bankCases));
    } else if (bankCaseDrops) {
      allCases = [].concat(_toConsumableArray(bankCaseDrops));
      hasDropCase = true;
    }

    return _extends({}, allCases, {
      hasDropCase: hasDropCase
    });
  };

  this.handleResize = function () {
    var screenWidth = window.innerWidth;

    _this9.setState({
      screenWidth: screenWidth,
      isMobile: screenWidth <= 767,
      isTablet: screenWidth > 767 && screenWidth <= 991,
      isComputer: screenWidth > 991 });
  };

  this.isTableOverflowing = function (table) {
    var parent = table.parentElement;
    return table.scrollWidth > parent.clientWidth;
  };

  this.updateStickyShadows = function () {
    // Remove old shadow classes
    document.querySelectorAll('.uc-sticky-shadow-left, .uc-sticky-shadow-right').forEach(function (el) {
      el.classList.remove('uc-sticky-shadow-left', 'uc-sticky-shadow-right');
    });

    // Loop over all table rows
    document.querySelectorAll('tr').forEach(function (row) {
      // Find the first sticky LEFT cell in this row
      var firstStickyLeft = row.querySelector('th.uc-sticky-col.uc-left, td.uc-sticky-col.uc-left');
      if (firstStickyLeft) {
        firstStickyLeft.classList.add('uc-sticky-shadow-left');
      }

      // Find the first sticky RIGHT cell in this row
      var firstStickyRight = row.querySelector('th.uc-sticky-col.uc-right, td.uc-sticky-col.uc-right');
      if (firstStickyRight) {
        firstStickyRight.classList.add('uc-sticky-shadow-right');
      }
    });
  };

  this.handlePageChange = function (param) {
    var type = param.type,
        cursor = param.cursor;
    // cursor params live in state only — never read from URL

    var query = (0, _url.decodeSearch)(_this9.props.location.search);

    if (type === 'next') {
      // Save the cursor used to reach the current page so Prev can return here
      _this9.setState(function (prev) {
        return {
          cursorPaginations: [].concat(_toConsumableArray(prev.cursorPaginations), [prev.currentPageCursor]),
          currentPageCursor: cursor
        };
      }, function () {
        var fetchQuery = cursor ? _extends({}, query, { pit_id: cursor.pit_id, search_after: cursor.search_after }) : _extends({}, query);
        _this9.resetPitExpireTimer();
        _this9.fetchBookings(fetchQuery);
      });
    } else if (type === 'prev') {
      _this9.setState(function (prev) {
        var newStack = [].concat(_toConsumableArray(prev.cursorPaginations));
        var prevCursor = newStack.length > 0 ? newStack.pop() : null;
        return { cursorPaginations: newStack, currentPageCursor: prevCursor };
      }, function () {
        var currentPageCursor = _this9.state.currentPageCursor;

        var fetchQuery = currentPageCursor ? _extends({}, query, { pit_id: currentPageCursor.pit_id, search_after: currentPageCursor.search_after }) : _extends({}, query);
        if (currentPageCursor) {
          _this9.resetPitExpireTimer();
        } else {
          // Back to page 1 — no active PIT to track
          _this9.clearPitExpireTimer();
        }
        _this9.fetchBookings(fetchQuery);
      });
    }
  };

  this.handleChangePageOffset = function (currentPage) {
    var store = _this9.context.store;
    var pathname = _this9.props.location.pathname;

    var query = (0, _url.decodeSearch)(_this9.props.location.search);
    query.page = currentPage;
    _this9.setState({ currentPage: currentPage });
    store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(query)));
    _this9.fetchBookings(query);
  };

  this.handleTokenStatusFilter = function (value) {
    var query = (0, _url.decodeSearch)(_this9.props.location.search);
    if (value) {
      query.token_status_id = value;
    } else {
      delete query.token_status_id;
    }
    delete query.page;
    _this9.setState({ currentPage: 1 }, function () {
      _this9.replaceQuery(query, true, true);
    });
  };

  this.resetPitExpireTimer = function () {
    if (_this9.pitExpireTimer) {
      clearTimeout(_this9.pitExpireTimer);
    }
    // PIT lasts 4 minutes; reset cursor history so next/prev interaction goes back to page 1
    _this9.pitExpireTimer = setTimeout(function () {
      _this9.setState({ cursorPaginations: [], nextCursor: null, currentPageCursor: null });
    }, 4 * 60 * 1000);
  };

  this.clearPitExpireTimer = function () {
    if (_this9.pitExpireTimer) {
      clearTimeout(_this9.pitExpireTimer);
      _this9.pitExpireTimer = null;
    }
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this9.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;

    // Reset cursor stack because sorting changes the order
    _this9.replaceQuery(query, true, true);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var clearSearch = false;
    var query = (0, _url.decodeSearch)(_this9.props.location.search);

    queryArray.forEach(function (filter) {
      if (filter === 'sr_code') {
        _this9.setState({ sr_code: '', srCodeInput: '' });
      }
      if (filter === 'customer_name') {
        _this9.setState({ customer_name: '', customerNameInput: '' });
      }
      if (filter === 'search') clearSearch = true;

      if (filter === 'agingRange' || filter === 'loanStatus') {
        delete query.sortColumn;
        delete query.sortDirection;
      }

      if (filter === 'filteredProjects') {
        delete query.projectCode;
        delete query.projectFilter;
        hasQuery = true;
        _this9.setState({ filteredProjects: [], isChanging: false });
      }

      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
        _this9.setState({ isChanging: false });
      }
    });

    var cb = function cb() {
      if (hasQuery) {
        // reset cursor stack when filters change
        _this9.replaceQuery(query, true, true);
      }
    };

    if (clearSearch) {
      _this9.setState({ search: '' }, cb);
    } else {
      cb();
    }
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this9.props.location.search);
    if (queryName === 'sr_code') {
      var trimmedValue = value ? value.trim() : '';

      delete query.group_status;
      delete query.sr_status;
      delete query.sortColumn;
      delete query.sortDirection;
      delete query.page;
      delete query.customer_name;

      if (trimmedValue !== '') {
        query[queryName] = trimmedValue;
      } else {
        delete query[queryName];
      }

      _this9.setState({
        sr_code: trimmedValue,
        opportunityStatus: null,
        customerNameInput: '',
        srStatus: null,
        currentPage: 1
      });
    } else if (queryName === 'customer_name') {
      var _trimmedValue = value ? value.trim() : '';

      delete query.page;

      if (_trimmedValue !== '') {
        query[queryName] = _trimmedValue;
      } else {
        delete query[queryName];
      }

      _this9.setState({
        customer_name: _trimmedValue
      });
    } else {
      query[queryName] = value;
      _this9.replaceQuery(query);
    }
    var refetch = queryName !== 'searchIn' || queryName === 'searchIn' && _this9.state.search.length > 0;
    if (queryName === 'dateRange' && query.dateRange === 'custom' && (!query.dateFrom || !query.dateTo)) {
      refetch = false;
    }
    if (queryName === 'cancelledDateRange' && query.cancelledDateRange === 'custom' && (!query.cancelledDateFrom || !query.cancelledDateTo)) {
      refetch = false;
    }
    if (queryName === 'expiredDateRange' && query.expiredDateRange === 'custom' && (!query.expiredDateFrom || !query.expiredDateTo)) {
      refetch = false;
    }
    if (queryName === 'bookedDateRange' && query.bookedDateRange === 'custom' && (!query.bookedDateFrom || !query.bookedDateTo)) {
      refetch = false;
    }
    if (queryName === 'soldDateRange' && query.soldDateRange === 'custom' && (!query.soldDateFrom || !query.soldDateTo)) {
      refetch = false;
    }

    _this9.replaceQuery(query, refetch, true);
  };

  this.handleSetDateRange = function (name, from, to) {
    var query = (0, _url.decodeSearch)(_this9.props.location.search);
    switch (name) {
      case 'dateRange':
        query.dateFrom = from;
        query.dateTo = to;
        break;
      case 'pendingApprovalDateRange':
        query.pendingApprovalDateFrom = from;
        query.pendingApprovalDateTo = to;
        break;
      case 'approvedDateRange':
        query.approvedDateFrom = from;
        query.approvedDateTo = to;
        break;
      case 'pendingRejectionDateRange':
        query.pendingRejectionDateFrom = from;
        query.pendingRejectionDateTo = to;
        break;
      case 'rejectedDateRange':
        query.rejectedDateFrom = from;
        query.rejectedDateTo = to;
        break;
      case 'pendingCancellationDateRange':
        query.pendingCancellationDateFrom = from;
        query.pendingCancellationDateTo = to;
        break;
      case 'cancelledDateRange':
        query.cancelledDateFrom = from;
        query.cancelledDateTo = to;
        break;
      case 'pendingRefundDateRange':
        query.pendingRefundDateFrom = from;
        query.pendingRefundDateTo = to;
        break;
      case 'refundedDateRange':
        query.refundedDateFrom = from;
        query.refundedDateTo = to;
        break;
      default:
        break;
    }
    _this9.replaceQuery(query, true, true);
  };

  this.handleReplaceStatus = function () {
    var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var query = (0, _url.decodeSearch)(_this9.props.location.search);
    if (status !== '' && status !== _opportunityStatuses.OPPORTUNITY_STATUS_GROUP.TOTAL) {
      query.group_status = status;
    } else {
      delete query.group_status;
    }
    delete query.sr_status;
    delete query.sr_code;
    delete query.customer_name;
    if (status !== _opportunityStatuses.OPPORTUNITY_STATUS_GROUP.PENDING_APPROVAL) {
      delete query.pendingApprovalDateRange;
      delete query.pendingApprovalDateFrom;
      delete query.pendingApprovalDateTo;
    }
    if (status !== _opportunityStatuses.OPPORTUNITY_STATUS_GROUP.APPROVED) {
      delete query.approvedDateRange;
      delete query.approvedDateFrom;
      delete query.approvedDateTo;
    }
    if (status !== _opportunityStatuses.OPPORTUNITY_STATUS_GROUP.PENDING_CLOSURE) {
      delete query.pendingRejectionDateRange;
      delete query.pendingRejectionDateFrom;
      delete query.pendingRejectionDateTo;
    }
    delete query.token_status_id;
    delete query.page;
    delete query.sortColumn;
    delete query.sortDirection;
    if (status !== _opportunityStatuses.OPPORTUNITY_STATUS_GROUP.PENDING_REFUND) {
      delete query.pendingRefundDateRange;
      delete query.pendingRefundDateFrom;
      delete query.pendingRefundDateTo;
    }
    if (status !== _opportunityStatuses.OPPORTUNITY_STATUS_GROUP.CLOSED && status !== _opportunityStatuses.OPPORTUNITY_STATUS_GROUP.ERROR) {
      delete query.cancelledDateRange;
      delete query.cancelledDateFrom;
      delete query.cancelledDateTo;
    }
    _this9.setState({ srCodeInput: '', customerNameInput: '' });
    _this9.replaceQuery(query, true, true);
  };

  this.handleSearchStaff = function (value) {
    var t = _this9.props.t;

    clearTimeout(_this9.setStaffTimer);
    var findStaffResults = [];
    var noStaffResultsMessage = t('Loading', { ns: _translation.TRANSLATION_FILES.translation }) + '...';
    _this9.setState({ findStaffResults: findStaffResults, noStaffResultsMessage: noStaffResultsMessage, staffFilter: value }, function () {
      if (value !== '') {
        _this9.setStaffTimer = setTimeout(function () {
          _this9.searchStaffs(value);
        }, 500);
      }
    });
  };

  this.handleFilterProjects = function (e, _ref7) {
    var name = _ref7.name,
        value = _ref7.value;

    var filteredProjects = value;
    _this9.setState({ filteredProjects: filteredProjects }, function () {
      var query = (0, _url.decodeSearch)(_this9.props.location.search);
      query[name] = btoa(value);
      _this9.replaceQuery(query, true, true);
    });
  };

  this.handleSelectProject = function (project, queryName) {
    var query = (0, _url.decodeSearch)(_this9.props.location.search);
    var internalQuery = {};
    internalQuery.id = project.key;
    internalQuery.name = project.title;
    query[queryName] = btoa(_qs2.default.stringify(internalQuery));
    _this9.replaceQuery(query, true, true);
  };

  this.handleSelectStaff = function (staff, queryName) {
    var query = (0, _url.decodeSearch)(_this9.props.location.search);
    var internalQuery = {};
    internalQuery.id = staff.key;
    internalQuery.name = staff.title;
    query[queryName] = btoa(_qs2.default.stringify(internalQuery));
    _this9.replaceQuery(query, true, true);
  };

  this.replaceQuery = function (query) {
    var fetch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var resetCursor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var store = _this9.context.store;
    var pathname = _this9.props.location.pathname;

    var queryNew = Object.assign({}, query);

    // Cursor params must never appear in the URL
    delete queryNew.pit_id;
    delete queryNew.search_after;

    if (resetCursor) {
      _this9.setState({ cursorPaginations: [], nextCursor: null, currentPageCursor: null });
      _this9.clearPitExpireTimer();
    }

    if (fetch) {
      // Filter/sort fetches always restart from page 1 — no cursor needed
      _this9.fetchBookings(queryNew);
      _this9.fetchBookingSummaries(queryNew);
    }

    store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));
  };

  this.exportURL = function (fileType) {
    var primary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var detailed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var _props = _this9.props,
        location = _props.location,
        projectUnitID = _props.projectUnitID;

    var url = _config2.default.get('bookApiURL') + '/reports/bookings/';
    if (location && location.search) {
      url += '' + location.search;
    }
    if (projectUnitID) {
      url += '&projectUnitID=' + projectUnitID;
    }
    if (primary) {
      url += '&primaryOnly=true';
    }
    url += '&fileType=' + fileType;
    if (detailed) {
      url += '&detailed=true';
    }
    return url;
  };

  this.hasMPDetailsAccess = function () {
    var auth = _this9.props.auth;

    return auth.isHeadquarters || auth.isBranchLeaderSupervisor;
  };

  this.cellCheckSorted = function (column) {
    var isReversed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var _decodeSearch = (0, _url.decodeSearch)(_this9.props.location.search),
        sortColumn = _decodeSearch.sortColumn,
        sortDirection = _decodeSearch.sortDirection;

    if (!sortColumn) {
      if (column === 'created_at') {
        return 'descending';
      }
    }

    if (column === sortColumn) {
      if (isReversed) {
        return sortDirection === 'asc' ? 'descending' : 'ascending';
      }
      return sortDirection === 'asc' ? 'ascending' : 'descending';
    }
    return null;
  };

  this.handleCellSort = function (column) {
    var _decodeSearch2 = (0, _url.decodeSearch)(_this9.props.location.search),
        sortColumn = _decodeSearch2.sortColumn,
        sortDirection = _decodeSearch2.sortDirection;

    var direction = 'asc';
    if (column === sortColumn) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc';
    }
    _this9.handleSortData(column, direction);
  };

  this.exportItemsAdmin = function () {
    if (_this9.hasAdminAccess() && _this9.state.currentTab !== 'aging_by_bankers') {
      var _props2 = _this9.props,
          location = _props2.location,
          projectUnitID = _props2.projectUnitID;

      var url = _config2.default.get('bookApiURL') + '/reports/bookings/customer_details/';
      if (location && location.search) {
        url += '' + location.search;
      }
      if (projectUnitID) {
        url += '&projectUnitID=' + projectUnitID;
      }
      return [{
        text: 'Excel\nwith\nCustomer\nDetails',
        icon: 'download',
        href: url + '&fileType=excel'
      }, {
        text: 'Excel\n(primary)\nwith\nCustomer\nDetails',
        icon: 'download',
        href: url + '&fileType=excel&primaryOnly=true'
      }, {
        text: 'CSV\nwith\nCustomer\nDetails',
        icon: 'download',
        href: url + '&fileType=csv'
      }, {
        text: 'CSV\n(primary)\nwith\nCustomer\nDetails',
        icon: 'download',
        href: url + '&fileType=csv&primaryOnly=true'
      }];
    }
    return [];
  };

  this.exportItemsPrimary = function () {
    if (_this9.state.currentTab !== 'aging_by_bankers') {
      return [{
        text: 'Excel\n(primary)',
        icon: 'download',
        href: _this9.exportURL('excel', true)
      }, {
        text: 'CSV\n(primary)',
        icon: 'download',
        href: _this9.exportURL('csv', true)
      }];
    }
    return [];
  };

  this.handleSingleStatusOnChange = function (singleStatusValue) {
    var query = (0, _url.decodeSearch)(_this9.props.location.search);

    if (singleStatusValue && singleStatusValue !== '__all__') {
      query.sr_status = singleStatusValue;
    } else {
      delete query.sr_status;
    }
    delete query.group_status;
    delete query.sr_code;
    delete query.page;
    delete query.sortColumn;
    delete query.sortDirection;
    delete query.customer_name;
    _this9.setState({ srCodeInput: '', customerNameInput: '' });

    _this9.replaceQuery(query, true, true);
  };

  this.exportItemsManager = function () {
    var isMalaysia = _this9.props.auth.company && _this9.props.auth.company.countryCode === 'my';
    if (_this9.hasAccess() && _this9.state.currentTab !== 'aging_by_bankers') {
      var query = (0, _url.decodeSearch)(_this9.props.location.search);
      query.page = 'all';
      var exportItems = [{
        text: 'Full\nExcel',
        icon: 'download',
        href: _config2.default.get('bookApiURL') + '/bookings/export/?' + _qs2.default.stringify(query),
        dataTarget: 'fullexcel'
      }, {
        text: 'Updated Today',
        icon: 'download',
        href: _config2.default.get('bookApiURL') + '/bookings/export/?page=all&updatedToday=true',
        dataTarget: 'updatedtoday'
      }, {
        isDivider: true
      }];
      if (_this9.state.currentTab === 'all' && isMalaysia) {
        exportItems.push({
          text: 'Loan Approval',
          icon: 'download',
          href: _config2.default.get('bookApiURL') + '/bookings/export/loan_approvals/?' + _qs2.default.stringify(query),
          dataTarget: 'loanapproval'
        }, {
          text: 'Booking Notes',
          icon: 'download',
          href: _config2.default.get('bookApiURL') + '/bookings/export/notes/?' + _qs2.default.stringify(query),
          dataTarget: 'bookingnotes'
        }, {
          isDivider: true
        });
      }
      return exportItems;
    }
    return [];
  };

  this.checkGroupAccess = function (groups) {
    var roles = [{ text: 'Headquarters', value: '10,6' }, { text: 'Supervisor', value: '10,11,12,13' }, { text: 'Sales Manager', value: '10,11,13' }, { text: 'Sales Admin', value: '10,11' }];
    var rolesArr = [];
    if (groups) {
      groups.forEach(function (g) {
        rolesArr.push(g.id);
      });
      rolesArr.sort();
      var role = roles.find(function (g) {
        return g.value === String(rolesArr.toString());
      });
      if (role && role.text) {
        return role.text;
      }
    }
    return null;
  };

  this.hasLawyerSPASignedDate = function (date) {
    if (date) {
      if (date.length > 1 && date[1]) {
        return true;
      }
    }
    return false;
  };

  this.handlePrint = function () {
    _auth2.default.currentSession();
  };

  this.statusDateSortItems = function () {
    var opportunityStatus = _this9.state.opportunityStatus;

    var label = '';
    var column = '';
    switch (opportunityStatus) {
      case 'cancelled_developer':
        label = 'Cancelled';
        column = 'l_cancelled_developer_at';
        break;
      case 'expired':
        label = 'Expired';
        column = 'l_expired_at';
        break;
      case 'booked':
        label = 'Booked';
        column = 'l_booked_at';
        break;
      case 'sold_spa_signed':
        label = 'Sold';
        column = 'l_sold_at';
        break;
      default:
        break;
    }
    return !_this9.props.projectUnitID && column ? [{
      text: label + ' Date Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'booking.' + column,
      sortDirection: 'asc'
    }, {
      text: label + ' Date Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'booking.' + column,
      sortDirection: 'desc'
    }] : [];
  };

  this.bookingNoteToMarkdown = function (bNote) {
    try {
      var hasNoSpaces = bNote.indexOf(' ') === -1;
      if (hasNoSpaces) {
        return decodeURIComponent(bNote.replace(/\+/g, ' '));
      }
      return decodeURIComponent(bNote);
    } catch (e) {
      return bNote;
    }
  };

  this.bookingNoteToEditorState = function (bookingNote) {
    var mdValue = _this9.bookingNoteToMarkdown(bookingNote);
    if (mdValue) {
      var rawData = (0, _markdownDraftJs.markdownToDraft)(mdValue, {
        preserveNewlines: true,
        blockStyles: {
          ins_open: 'UNDERLINE'
        },
        remarkableOptions: {
          enable: {
            inline: 'ins'
          }
        }
      });
      var contentState = (0, _draftJs.convertFromRaw)(rawData);
      var editorState = _draftJs.EditorState.createWithContent(contentState);
      return editorState;
    }
    return _draftJs.EditorState.createEmpty();
  };

  this.bookingNoteFormated = function (bookingData) {
    if (!bookingData) return '';
    if (!bookingData.latestBookingNote) return bookingData.remarkInternal; // deprecated old field
    // convert markdown to draft-js and then back to plaintext properly with custom formatings.
    var editorState = _this9.bookingNoteToEditorState(bookingData.latestBookingNote);
    var contentState = editorState.getCurrentContent();
    var plainText = contentState.getPlainText();
    var maxLength = 180;
    if (plainText && plainText.length > maxLength) {
      plainText = plainText.substring(0, maxLength) + '...';
    }
    return plainText;
  };

  this.getIndividualStatusCount = function (statusKey) {
    var _state3 = _this9.state,
        summary = _state3.summary,
        loading = _state3.loading;

    if (loading || !summary) {
      return '...';
    }

    // 'error' is CPI-1226's group; without it the per-status count for cancelled_error reads 0.
    var macroGroups = ['pending_approval', 'approved', 'pending_closure', 'pending_refund', 'closed', 'error'];
    var totalCount = 0;

    macroGroups.forEach(function (group) {
      if (summary[group] && summary[group].statuses && summary[group].statuses[statusKey] !== undefined) {
        // Changed from = to += to accumulate numbers across groups safely
        totalCount += summary[group].statuses[statusKey];
      }
    });

    return totalCount;
  };

  this.hasBookingNote = function (bookingData) {
    if (bookingData && (bookingData.latestBookingNote || bookingData.remarkInternal)) return true;
    return false;
  };

  this.renderStatusDateFilter = function () {
    var t = _this9.props.t;
    var _state4 = _this9.state,
        opportunityStatus = _state4.opportunityStatus,
        loading = _state4.loading,
        isMobile = _state4.isMobile;

    var filter = '';
    var filterFrom = '';
    var filterTo = '';
    var headerText = '';
    switch (opportunityStatus) {
      case _opportunityStatuses.OPPORTUNITY_STATUS.APPROVED:
        filter = 'approvedDateRange';
        filterFrom = 'approvedDateFrom';
        filterTo = 'approvedDateTo';
        headerText = 'Approved Date Range';
        break;
      case _opportunityStatuses.OPPORTUNITY_STATUS.PENDING_CANCELLATION:
        filter = 'pendingCancellationDateRange';
        filterFrom = 'pendingCancellationDateFrom';
        filterTo = 'pendingCancellationDateTo';
        headerText = 'Pending Cancellation Date Range';
        break;
      case _opportunityStatuses.OPPORTUNITY_STATUS_GROUP.ERROR:
        filter = 'cancelledDateRange';
        filterFrom = 'cancelledDateFrom';
        filterTo = 'cancelledDateTo';
        headerText = 'Cancelled Date Range';
        break;
      case _opportunityStatuses.OPPORTUNITY_STATUS.PENDING_REFUND:
        filter = 'pendingRefundDateRange';
        filterFrom = 'pendingRefundDateFrom';
        filterTo = 'pendingRefundDateTo';
        headerText = 'Pending Refund Date Range';
        break;
      case _opportunityStatuses.OPPORTUNITY_STATUS.REFUNDED:
        filter = 'refundedDateRange';
        filterFrom = 'refundedDateFrom';
        filterTo = 'refundedDateTo';
        headerText = 'Refunded Date Range';
        break;
      default:
        break;
    }
    return filter && !_this9.props.projectUnitID && _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      {
        className: 'filter tight-column',
        mobile: 16,
        tablet: 5,
        computer: 5,
        style: { paddingBottom: isMobile ? '1rem' : '0rem' }
      },
      _react2.default.createElement(_UCBookingDatePicker2.default, {
        filterName: filter,
        filterNameFrom: filterFrom,
        filterNameTo: filterTo,
        headerText: t(headerText, { ns: _translation.TRANSLATION_FILES.screens }),
        placeholder: t('Select ' + headerText, { ns: _translation.TRANSLATION_FILES.screens }),
        dateFrom: _this9.state[filterFrom],
        dateTo: _this9.state[filterTo],
        onChange: _this9.handleFilterOnChange,
        onClose: _this9.handleClearFilter,
        onResetRange: _this9.handleClearFilter,
        onSetRange: function onSetRange(from, to) {
          return _this9.handleSetDateRange(filter, from, to);
        },
        value: _this9.state[filter],
        disabled: loading,
        label: t(headerText, { ns: _translation.TRANSLATION_FILES.screens })
      })
    );
  };

  this.renderDefaultClearFilter = function () {
    var isMobile = _this9.state.isMobile;

    return (_this9.getAllFilterNames().some(function (filterName) {
      return _this9.state[filterName] && _this9.state[filterName].length > 0;
    }) || _this9.state.search.length > 0) && _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { style: { paddingBottom: '0rem', paddingTop: isMobile ? '0rem' : '1rem' } },
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        {
          verticalAlign: 'middle'
        },
        _react2.default.createElement(_semanticUiReact.Button, {
          className: 'uc-clear-button',
          content: 'Clear all',
          onClick: function onClick() {
            return _this9.handleClearFilter.apply(_this9, _toConsumableArray(_this9.getAllFilterNames()));
          }
        })
      )
    );
  };

  this.handleResetAll = function () {
    var cleanQuery = {};
    _this9.setState({
      srCodeInput: '',
      sr_code: '',
      search: '',
      customerNameInput: '',
      customer_name: '',
      opportunityStatus: '',
      srStatus: '',
      paymentStatus: [],
      paymentRefundStatus: [],
      sourceOfFinance: '',
      loanStatus: [],
      filteredProjects: [],
      currentPage: 1
    }, function () {
      _this9.replaceQuery(cleanQuery, true, true);
    });
  };

  this.renderAccordionDefaultView = function (searchAreas) {
    var _props3 = _this9.props,
        projectUnitID = _props3.projectUnitID,
        t = _props3.t;
    var _state5 = _this9.state,
        loading = _state5.loading,
        loadingProjectSearch = _state5.loadingProjectSearch,
        activeAccordionIndex = _state5.activeAccordionIndex,
        isTablet = _state5.isTablet,
        isMobile = _state5.isMobile;

    return _react2.default.createElement(
      _semanticUiReact.Accordion,
      { fluid: true, className: 'uc-accordion shadow-border', style: { paddingBottom: !isMobile && activeAccordionIndex !== 0 ? '1.5rem' : '0.5rem' } },
      _react2.default.createElement(
        _semanticUiReact.Accordion.Title,
        {
          style: { paddingBottom: '1rem' },
          active: activeAccordionIndex === 0,
          index: 0
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 'equal', style: { paddingBottom: activeAccordionIndex === 0 ? '1rem' : '0rem' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'tight-column',
                tablet: 5,
                computer: 5
              },
              _react2.default.createElement(_UCSearchIn2.default, {
                isLoading: loading,
                onChange: _this9.handleFilterOnChange,
                onSearchInChange: _this9.handleFilterOnChange,
                onClear: _this9.handleClearFilter,
                search: _this9.state.search,
                searchIn: _this9.state.searchIn,
                options: searchAreas,
                label: t('Keywords', { ns: _translation.TRANSLATION_FILES.screens })
              })
            ),
            !projectUnitID && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter tight-column',
                tablet: 5,
                computer: 5
              },
              _react2.default.createElement(
                'div',
                { className: 'field' },
                _react2.default.createElement(
                  'label',
                  {
                    className: 'ui',
                    htmlFor: 'projectFilter',
                    style: { fontWeight: 'bold', margin: '0 0 0.28571429rem 0', fontSize: '.92857143em', display: 'block' }
                  },
                  t('Projects', { ns: _translation.TRANSLATION_FILES.screens })
                ),
                _react2.default.createElement(_semanticUiReact.Dropdown, {
                  fluid: true,
                  search: true,
                  selection: true,
                  floating: true,
                  disabled: loading || loadingProjectSearch,
                  loading: loadingProjectSearch,
                  multiple: true,
                  name: 'projectFilter',
                  onChange: _this9.handleFilterProjects,
                  options: _this9.state.projectOpts,
                  placeholder: t('Find Project'),
                  value: _this9.state.filteredProjects[0] || ''
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter tight-column',
                tablet: 5,
                computer: 5
              },
              _react2.default.createElement(_UCBookingSelectListMultiple.BookingSelectListMultiple, {
                filterName: 'Booking Status',
                onChange: _this9.handleFilterOnChange,
                onClose: _this9.handleClearFilter,
                options: _opportunityStatuses.SINGLE_STATUS_FILTER_OPTIONS.map(function (_ref8) {
                  var value = _ref8.value,
                      text = _ref8.text;
                  return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) + ' (' + _this9.getIndividualStatusCount(value) + ')' };
                }),
                placeholder: t('Booking Status'),
                value: _this9.state.srStatus,
                disabled: loading,
                label: t('Booking Status', { ns: _translation.TRANSLATION_FILES.screens }),
                selectedText: t('selected', { ns: _translation.TRANSLATION_FILES.translation })
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 1, style: { paddingLeft: isTablet ? '0rem' : '0.7rem' }, textAlign: 'left' },
              _react2.default.createElement(_semanticUiReact.Popup, {
                size: 'tiny',
                style: { backgroundColor: '#596975' },
                basic: true,
                inverted: true,
                content: activeAccordionIndex === 0 ? t('Collapse', { ns: _translation.TRANSLATION_FILES.translation }) : t('Expand', { ns: _translation.TRANSLATION_FILES.translation }),
                position: 'bottom center',
                trigger: _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    icon: true,
                    circular: true,
                    onClick: function onClick(e) {
                      return _this9.handleAccordionClick(e, { index: activeAccordionIndex === 0 ? -1 : 0 });
                    },
                    className: 'uc-accordion-toggle-btn ' + (activeAccordionIndex === 0 ? 'rotated' : '')
                  },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron down' })
                )
              })
            )
          ),
          activeAccordionIndex !== 0 && _this9.renderDefaultClearFilter()
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Transition,
        { visible: activeAccordionIndex === 0, animation: 'slide down', duration: 200 },
        _react2.default.createElement(
          _semanticUiReact.Accordion.Content,
          { active: activeAccordionIndex === 0, style: { paddingBottom: '2rem' } },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            {
              textAlign: 'left',
              verticalAlign: 'middle'
            },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { style: { paddingBottom: '0rem' } },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter tight-column',
                  tablet: 5,
                  computer: 5
                },
                _react2.default.createElement(_UCBookingSelectListMultiple.BookingSelectListMultiple, {
                  filterName: 'paymentRefundStatus',
                  onChange: _this9.handleFilterOnChange,
                  onClose: _this9.handleClearFilter,
                  options: _paymentRefundStatuses.PAYMENT_REFUND_STATUSES.map(function (_ref9) {
                    var value = _ref9.value,
                        text = _ref9.text;
                    return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                  }),
                  value: _this9.state.paymentRefundStatus,
                  placeholder: t('Payment Refund Status'),
                  disabled: loading,
                  label: t('Payment Refund Status', { ns: _translation.TRANSLATION_FILES.screens })
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter tight-column',
                  tablet: 5,
                  computer: 5
                },
                _react2.default.createElement(_UCBookingSelectList.BookingSelectList, {
                  filterName: 'sourceOfFinance',
                  onChange: _this9.handleFilterOnChange,
                  onClose: _this9.handleClearFilter,
                  options: _sourceOfFinanceStatuses.SOURCE_OF_FINANCE_STATUSES.map(function (_ref10) {
                    var value = _ref10.value,
                        text = _ref10.text;
                    return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                  }),
                  value: _this9.state.sourceOfFinance,
                  disabled: loading,
                  label: t('Source of finance', { ns: _translation.TRANSLATION_FILES.screens })
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter tight-column',
                  tablet: 5,
                  computer: 5
                },
                _react2.default.createElement(_UCBookingDatePicker2.default, {
                  filterName: 'dateRange',
                  filterNameFrom: 'dateFrom',
                  filterNameTo: 'dateTo',
                  headerText: t('Created Date Range'),
                  placeholder: t('Select Created Date Range'),
                  dateFrom: _this9.state.dateFrom,
                  dateTo: _this9.state.dateTo,
                  onChange: _this9.handleFilterOnChange,
                  onClose: _this9.handleClearFilter,
                  onResetRange: _this9.handleClearFilter,
                  onSetRange: function onSetRange(from, to) {
                    return _this9.handleSetDateRange('dateRange', from, to);
                  },
                  value: _this9.state.dateRange,
                  disabled: loading,
                  label: t('Created Date Range')
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { style: { paddingBottom: '0rem' } },
              _this9.renderStatusDateFilter()
            ),
            _this9.renderDefaultClearFilter()
          )
        )
      )
    );
  };

  this.renderAccordionMobileView = function (searchAreas) {
    var _props4 = _this9.props,
        projectUnitID = _props4.projectUnitID,
        t = _props4.t;
    var _state6 = _this9.state,
        loading = _state6.loading,
        loadingProjectSearch = _state6.loadingProjectSearch,
        activeAccordionIndex = _state6.activeAccordionIndex;

    return _react2.default.createElement(
      _semanticUiReact.Accordion,
      { fluid: true, className: 'uc-accordion shadow-border' },
      _react2.default.createElement(
        _semanticUiReact.Accordion.Title,
        {
          // style={{ paddingBottom: '1rem' }}
          active: activeAccordionIndex === 0,
          index: 0
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                style: { paddingBottom: activeAccordionIndex !== 0 ? '1rem' : '0rem' },
                width: 16
              },
              _react2.default.createElement(_UCSearchIn2.default, {
                isLoading: loading,
                onChange: _this9.handleFilterOnChange,
                onSearchInChange: _this9.handleFilterOnChange,
                onClear: _this9.handleClearFilter,
                search: _this9.state.search,
                searchIn: _this9.state.searchIn,
                options: searchAreas,
                isFullSize: true,
                label: t('Keywords', { ns: _translation.TRANSLATION_FILES.screens })
              })
            ),
            activeAccordionIndex !== 0 && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, textAlign: 'center' },
              _react2.default.createElement(_semanticUiReact.Popup, {
                size: 'tiny',
                style: { backgroundColor: '#596975' },
                basic: true,
                inverted: true,
                content: activeAccordionIndex === 0 ? t('Collapse') : t('Expand'),
                position: 'bottom center',
                trigger: _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    onClick: function onClick(e) {
                      return _this9.handleAccordionClick(e, { index: activeAccordionIndex === 0 ? -1 : 0 });
                    },
                    className: 'uc-accordion-toggle-btn'
                  },
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', alignItems: 'center', gap: '6px' } },
                    _react2.default.createElement(
                      'span',
                      { style: { fontSize: '12px', fontWeight: '400' } },
                      t('More')
                    ),
                    _react2.default.createElement(_semanticUiReact.Icon, { style: { fontSize: '12px', fontWeight: '400' }, name: 'chevron down' })
                  )
                )
              })
            )
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Transition,
        { visible: activeAccordionIndex === 0, animation: 'slide down', duration: 200 },
        _react2.default.createElement(
          _semanticUiReact.Accordion.Content,
          { active: activeAccordionIndex === 0 },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            {
              textAlign: 'left',
              verticalAlign: 'middle'
            },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { style: { paddingBottom: '0rem' } },
              !projectUnitID && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter',
                  width: 16,
                  style: { paddingBottom: '1rem' }
                },
                _react2.default.createElement(
                  'div',
                  { className: 'field' },
                  _react2.default.createElement(
                    'label',
                    {
                      className: 'ui',
                      htmlFor: 'projectFilter',
                      style: { fontWeight: 'bold', margin: '0 0 0.28571429rem 0', fontSize: '.92857143em', display: 'block' }
                    },
                    t('Projects', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(_semanticUiReact.Dropdown, {
                    fluid: true,
                    search: true,
                    selection: true,
                    floating: true,
                    disabled: loading || loadingProjectSearch,
                    loading: loadingProjectSearch,
                    multiple: true,
                    name: 'projectFilter',
                    onChange: _this9.handleFilterProjects,
                    options: _this9.state.projectOpts,
                    placeholder: t('Find Project'),
                    value: _this9.state.filteredProjects
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter',
                  width: 16,
                  style: { paddingBottom: '1rem' }
                },
                _react2.default.createElement(_UCBookingSelectListMultiple.BookingSelectListMultiple, {
                  filterName: 'Booking Status',
                  onChange: _this9.handleFilterOnChange,
                  onClose: _this9.handleClearFilter,
                  options: _opportunityStatuses.SINGLE_STATUS_FILTER_OPTIONS.map(function (_ref11) {
                    var value = _ref11.value,
                        text = _ref11.text;
                    return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) + ' (' + _this9.getIndividualStatusCount(value) + ')' };
                  }),
                  placeholder: t('Booking Status'),
                  value: _this9.state.srStatus,
                  disabled: loading,
                  label: t('Booking Status', { ns: _translation.TRANSLATION_FILES.screens })
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter',
                  width: 16,
                  style: { paddingBottom: '1rem' }
                },
                _react2.default.createElement(_UCBookingDatePicker2.default, {
                  filterName: 'dateRange',
                  filterNameFrom: 'dateFrom',
                  filterNameTo: 'dateTo',
                  headerText: t('Created Date Range'),
                  placeholder: t('Select Created Date Range', { ns: _translation.TRANSLATION_FILES.screens }),
                  dateFrom: _this9.state.dateFrom,
                  dateTo: _this9.state.dateTo,
                  onChange: _this9.handleFilterOnChange,
                  onClose: _this9.handleClearFilter,
                  onResetRange: _this9.handleClearFilter,
                  onSetRange: function onSetRange(from, to) {
                    return _this9.handleSetDateRange('dateRange', from, to);
                  },
                  value: _this9.state.dateRange,
                  disabled: loading,
                  label: t('Created Date Range', { ns: _translation.TRANSLATION_FILES.screens })
                })
              ),
              _this9.renderStatusDateFilter()
            ),
            _this9.renderDefaultClearFilter(),
            activeAccordionIndex === 0 && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, style: { paddingTop: '0rem' }, textAlign: 'center' },
              _react2.default.createElement(_semanticUiReact.Popup, {
                size: 'tiny',
                style: { backgroundColor: '#596975' },
                basic: true,
                inverted: true,
                content: activeAccordionIndex === 0 ? t('Collapse') : t('Expand'),
                position: 'bottom center',
                trigger: _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    onClick: function onClick(e) {
                      return _this9.handleAccordionClick(e, { index: activeAccordionIndex === 0 ? -1 : 0 });
                    },
                    className: 'uc-accordion-toggle-btn'
                  },
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', alignItems: 'center', gap: '6px' } },
                    _react2.default.createElement(
                      'span',
                      { style: { fontSize: '12px', fontWeight: '400' } },
                      t('Less')
                    ),
                    _react2.default.createElement(_semanticUiReact.Icon, { style: { fontSize: '12px', fontWeight: '400' }, name: 'chevron up' })
                  )
                )
              })
            )
          )
        )
      )
    );
  };

  this.renderMenuTool = function () {
    var t = _this9.props.t;
    var isMobile = _this9.state.isMobile;

    var searchAreas = [{ value: 'all', text: t('All', { ns: _translation.TRANSLATION_FILES.constants }) }, { value: 'purchaser', text: t('Purchaser', { ns: _translation.TRANSLATION_FILES.constants }) }, { value: 'assigned_agent', text: t('Assigned Agent', { ns: _translation.TRANSLATION_FILES.constants }) }];
    return _react2.default.createElement(
      _semanticUiReact.Grid,
      { columns: 'equal' },
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          isMobile ? _react2.default.createElement(_UCBookingStatusDropdown2.default, {
            options: _opportunityStatuses.OPPORTUNITY_STATUSES_TABS.map(function (status) {
              return {
                key: status.value,
                value: status.value,
                count: _this9.getStatusCount(status.value),
                valueLabel: t(status.text, { ns: _translation.TRANSLATION_FILES.constants }),
                className: status.className
              };
            }),
            onChange: function onChange(e) {
              if (_opportunityStatuses.SINGLE_STATUS_TAB_VALUES.indexOf(e) > -1) {
                _this9.handleSingleStatusOnChange(e);
              } else if (e === _opportunityStatuses.DEFAULT_OPPORTUNITY_STATUS) {
                _this9.handleReplaceStatus();
              } else {
                _this9.handleReplaceStatus(e);
              }
            },
            value: _this9.isSingleStatusTabActive() ? _this9.state.srStatus : _this9.state.opportunityStatus === '' ? _opportunityStatuses.OPPORTUNITY_STATUS_MAP[_opportunityStatuses.DEFAULT_OPPORTUNITY_STATUS].value : _this9.state.opportunityStatus
          }) : _react2.default.createElement(
            _semanticUiReact.Grid,
            {
              className: 'status',
              columns: 'equal',
              textAlign: 'left',
              verticalAlign: 'bottom'
            },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { style: { paddingTop: 0 } },
              _opportunityStatuses.OPPORTUNITY_STATUSES_TABS.map(function (status, key) {
                return _react2.default.createElement(_UCFixedBarStatus2.default, {
                  key: key,
                  className: status.className,
                  status: status.value,
                  name: t(status.text, { ns: _translation.TRANSLATION_FILES.constants }),
                  count: _this9.getStatusCount(status.value),
                  selected: _this9.getSelectedStatus(status.value),
                  onClick: status.singleStatus ? _this9.handleSingleStatusOnChange : status.value === _opportunityStatuses.DEFAULT_OPPORTUNITY_STATUS ? function () {
                    return _this9.handleReplaceStatus();
                  } : _this9.handleReplaceStatus,
                  style: { maxWidth: 'none' }
                });
              })
            )
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { style: { paddingTop: '0.5rem' } },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 16 },
          _react2.default.createElement(
            'div',
            { className: 'uc-accordion shadow-border', style: { padding: '0.75rem 1.5rem' } },
            _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { style: { paddingTop: '0.5rem', paddingBottom: '0.5rem' } },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { tablet: 5, computer: 4 },
                  _react2.default.createElement(_UCBookingSelectList.BookingSelectList, {
                    filterName: 'sr_status' // Updates query tracking mapping to target row status fields
                    , onChange: function onChange(value) {
                      return _this9.handleSingleStatusOnChange(value === '__all__' ? '' : value);
                    },
                    options: [{ value: '__all__', text: t('All Statuses', { ns: _translation.TRANSLATION_FILES.constants }) }].concat(_toConsumableArray(_opportunityStatuses.SINGLE_STATUS_FILTER_OPTIONS.map(function (_ref12) {
                      var value = _ref12.value,
                          text = _ref12.text;
                      return {
                        value: value,
                        text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) + ' (' + _this9.getIndividualStatusCount(value) + ')'
                      };
                    }))),
                    placeholder: t('Select Status'),
                    value: _this9.state.srStatus || '__all__',
                    disabled: _this9.state.loading,
                    label: t('Booking Status', { ns: _translation.TRANSLATION_FILES.screens })
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  {
                    className: 'tight-column',
                    tablet: 5,
                    computer: 5
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'field' },
                    _react2.default.createElement(
                      'label',
                      { className: 'opportunity-search' },
                      t('Booking ID', { ns: _translation.TRANSLATION_FILES.screens })
                    ),
                    _react2.default.createElement(_semanticUiReact.Input, {
                      fluid: true,
                      placeholder: t('Search Booking ID...', { ns: _translation.TRANSLATION_FILES.constants }),
                      value: _this9.state.srCodeInput,
                      disabled: _this9.state.loading,
                      onChange: function onChange(e, _ref13) {
                        var value = _ref13.value;
                        return _this9.setState({ srCodeInput: value });
                      },
                      onKeyDown: function onKeyDown(e) {
                        if (e.key === 'Enter') {
                          _this9.handleFilterOnChange(_this9.state.srCodeInput, 'sr_code');
                        }
                      },
                      action: {
                        icon: 'search',
                        color: 'teal',
                        basic: true,
                        disabled: _this9.state.loading,
                        onClick: function onClick() {
                          return _this9.handleFilterOnChange(_this9.state.srCodeInput, 'sr_code');
                        }
                      }
                    })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { className: 'tight-column', tablet: 4, computer: 4 },
                  _react2.default.createElement(
                    'div',
                    { className: 'field' },
                    _react2.default.createElement(
                      'label',
                      { className: 'opportunity-search' },
                      t('Purchaser Name', { ns: _translation.TRANSLATION_FILES.screens })
                    ),
                    _react2.default.createElement(_semanticUiReact.Input, {
                      fluid: true,
                      placeholder: t('Search Customer Name...', { ns: _translation.TRANSLATION_FILES.constants }),
                      value: _this9.state.customerNameInput,
                      disabled: _this9.state.loading,
                      onChange: function onChange(e, _ref14) {
                        var value = _ref14.value;
                        return _this9.setState({ customerNameInput: value });
                      },
                      onKeyDown: function onKeyDown(e) {
                        if (e.key === 'Enter') {
                          _this9.handleFilterOnChange(_this9.state.customerNameInput, 'customer_name');
                        }
                      },
                      action: {
                        icon: 'search',
                        color: 'teal',
                        basic: true,
                        disabled: _this9.state.loading,
                        onClick: function onClick() {
                          return _this9.handleFilterOnChange(_this9.state.customerNameInput, 'customer_name');
                        }
                      }
                    })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  {
                    tablet: 3,
                    computer: 3,
                    verticalAlign: 'bottom',
                    textAlign: 'right',
                    style: { paddingBottom: '2px' }
                  },
                  _react2.default.createElement(_semanticUiReact.Button, {
                    basic: true,
                    size: 'small',
                    icon: 'refresh',
                    color: 'black',
                    content: t('Clear', { ns: _translation.TRANSLATION_FILES.constants }),
                    disabled: _this9.state.loading,
                    onClick: _this9.handleResetAll
                  })
                )
              )
            )
          )
        )
      )
    );
  };

  this.renderStatusDateCell = function (isHeader) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var t = _this9.props.t;
    var opportunityStatus = _this9.state.opportunityStatus;

    var label = '';
    var date = '';
    switch (opportunityStatus) {
      case _opportunityStatuses.OPPORTUNITY_STATUS.APPROVED:
        label = _opportunityStatuses.OPPORTUNITY_STATUS_MAP[_opportunityStatuses.OPPORTUNITY_STATUS.APPROVED].text;
        date = data.lastExpiredAt;
        break;
      case _opportunityStatuses.OPPORTUNITY_STATUS.PENDING_CANCELLATION:
        label = _opportunityStatuses.OPPORTUNITY_STATUS_MAP[_opportunityStatuses.OPPORTUNITY_STATUS.PENDING_CANCELLATION].text;
        date = data.lastSoldAt;
        break;
      // OPPORTUNITY_STATUS_MAP is keyed by tab value, and the Error tab's value is now the group.
      case _opportunityStatuses.OPPORTUNITY_STATUS_GROUP.ERROR:
        label = _opportunityStatuses.OPPORTUNITY_STATUS_MAP[_opportunityStatuses.OPPORTUNITY_STATUS_GROUP.ERROR].text;
        date = data.lastSoldAt;
        break;
      case _opportunityStatuses.OPPORTUNITY_STATUS.PENDING_REFUND:
        label = _opportunityStatuses.OPPORTUNITY_STATUS_MAP[_opportunityStatuses.OPPORTUNITY_STATUS.PENDING_REFUND].text;
        date = data.lastSoldAt;
        break;
      case _opportunityStatuses.OPPORTUNITY_STATUS.REFUNDED:
        label = _opportunityStatuses.OPPORTUNITY_STATUS_MAP[_opportunityStatuses.OPPORTUNITY_STATUS.REFUNDED].text;
        date = data.lastSoldAt;
        break;
      default:
        break;
    }
    if (isHeader) {
      return _react2.default.createElement(
        'span',
        null,
        t('Created'),
        !_this9.props.projectUnitID && label && _react2.default.createElement(
          'span',
          null,
          '\xA0&',
          _react2.default.createElement('br', null),
          t(label, { ns: _translation.TRANSLATION_FILES.constants })
        )
      );
    }
    return !_this9.props.projectUnitID && date && _react2.default.createElement(
      'small',
      null,
      _react2.default.createElement(_Timestamp2.default, {
        timestamp: date,
        format: 'DD/M/YYYY HH:mm:ss'
      })
    );
  };

  this.renderTableHeaders = function (sortItems) {
    var t = _this9.props.t;

    return _react2.default.createElement(
      _semanticUiReact.Table.Header,
      { className: 'mobile-hide' },
      _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            style: { cursor: 'pointer', userSelect: 'none' },
            sorted: _this9.cellCheckSorted('created_at'),
            onClick: function onClick() {
              return _this9.handleCellSort('created_at');
            }
          },
          _this9.renderStatusDateCell(true)
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          { collapsing: true, className: 'mobile-hide' },
          t('Booking ID')
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          { className: 'mobile-hide' },
          t('Project')
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          { className: 'mobile-hide' },
          t('Purchaser')
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          t('Assigned Agent')
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          { className: 'mobile-hide' },
          t('Payment Amount (VND)')
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          { className: 'mobile-hide' },
          t('Source of Finance')
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            collapsing: true
            // sorted={this.cellCheckSorted(sortItems[4].sortColumn)}
            // onClick={() => this.handleCellSort(sortItems[4].sortColumn)}
            , className: 'uc-sticky-col uc-right'
          },
          t('Status')
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          { collapsing: true, className: 'uc-sticky-col uc-right' },
          t('Progress')
        )
      )
    );
  };

  this.renderProgressCell = function (data) {
    var t = _this9.props.t;

    var iconSize = 18;
    var bookingStatus = data && data.sr_status ? data.sr_status : null;
    var financeStatus = data && data.sr_source_of_finance ? data.sr_source_of_finance : null;
    var bookingIcon = _react2.default.createElement('img', {
      src: _this9.getBookingIcon(bookingStatus),
      width: iconSize,
      alt: 'booking status'
    });
    var loanIcon = _react2.default.createElement('img', {
      src: _this9.getSourceOfFinanceIcon(financeStatus),
      width: iconSize,
      alt: 'loan'
    });
    var docIcon = _react2.default.createElement('img', {
      src: _document_black2.default,
      width: iconSize,
      alt: 'notes'
    });
    return _react2.default.createElement(
      'div',
      { className: 'verticalAlign-mid', style: { display: 'inline-flex', justifyContent: 'start', gap: 16 } },
      _react2.default.createElement(_UCBPopup2.default
      // touchAsClicked={!isComputer}
      , { trigger: bookingIcon,
        content: '' + t(bookingStatus && _opportunityStatuses.SINGLE_STATUS_MAP[bookingStatus] ? _opportunityStatuses.SINGLE_STATUS_MAP[bookingStatus].text : 'None', { ns: _translation.TRANSLATION_FILES.constants })
      }),
      _react2.default.createElement(_UCBPopup2.default
      // touchAsClicked={!isComputer}
      , { trigger: loanIcon,
        content: '' + t(financeStatus && _sourceOfFinanceStatuses.SOURCE_OF_FINANCE_STATUS_MAP[financeStatus] ? _sourceOfFinanceStatuses.SOURCE_OF_FINANCE_STATUS_MAP[financeStatus].text : 'None', { ns: _translation.TRANSLATION_FILES.constants })
      }),
      _react2.default.createElement(_UCBPopup2.default
      // touchAsClicked={!isComputer}
      , { trigger: docIcon,
        content: '' + t('Document uploaded')
      })
    );
  };

  this.renderTableRow = function (data, idx) {
    var isMobile = _this9.state.isMobile;
    var t = _this9.props.t;


    var prepData = _extends({
      id: '',
      code: '',
      name: '',
      createdAt: '',
      statusID: '',
      status: '',
      statusName: '',
      origin: '',
      buyerProfileID: '',
      created_at: '',
      bookingCustomer: null,
      paymentStatus: ''
    }, data);
    prepData.project = _extends({ shortName: '', name: '' }, data && data.project || {});
    var statusValue = prepData.sr_status && _opportunityStatuses.SINGLE_STATUS_MAP[prepData.sr_status] || _opportunityStatuses.SINGLE_STATUS_MAP[_opportunityStatuses.OPPORTUNITY_STATUS.PENDING_PAYMENT];
    var statusTag = _react2.default.createElement(_UCBStatusFlag2.default, { text: t(statusValue.text, { ns: _translation.TRANSLATION_FILES.constants }), value: 'opportunity-' + statusValue.value });
    return _react2.default.createElement(
      _semanticUiReact.Table.Row,
      _extends({
        key: idx,
        className: _this9.getRowClassName(prepData.statusID)
      }, _this9.getDataTarget(idx), _this9.getDatasetAttributes('bookingid', prepData.booking_id), _this9.getDatasetAttributes('unitno', prepData.unit_number), _this9.getDatasetAttributes('projectname', prepData.project_name), _this9.getDatasetAttributes('purchasername', prepData.primary_customer ? prepData.primary_customer.name : ''), {
        onClick: isMobile ? function () {
          return _this9.context.router.push('/opportunities/' + prepData.id + '/');
        } : null
      }),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        null,
        _react2.default.createElement(
          'span',
          { className: 'mobile-hide' },
          _react2.default.createElement(_Timestamp2.default, {
            timestamp: prepData.created_at,
            format: 'DD/M/YYYY HH:mm:ss'
          }),
          _react2.default.createElement('br', null),
          _this9.renderStatusDateCell(false, prepData)
        ),
        _react2.default.createElement(
          'span',
          { className: 'computer-hide' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/opportunities/' + prepData.id + '/' },
            prepData.primary_customer ? prepData.primary_customer.name : ''
          )
        )
      ),
      isMobile && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { style: { marginTop: '0.45em' } },
        statusTag
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true, className: 'mobile-hide' },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/opportunities/' + prepData.id + '/' },
          prepData.sr_code || '-'
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'mobile-hide' },
        (0, _strings.titleCase)(prepData.project_name || '')
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'mobile-hide' },
        _react2.default.createElement(
          _reactRouter.Link,
          { to: '/opportunities/' + prepData.id + '/?section=purchaser' },
          prepData.primary_customer ? prepData.primary_customer.name : ''
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'mobile-hide' },
        prepData.assign_to_name || ''
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'mobile-hide' },
        function () {
          var token = prepData.unit_reservation_token;
          var amountMinor = token && token.amountMinorPaid || 0;
          var code = token && token.currencyCode || 'VND';
          return (0, _currencyMinor.formatMinorAmount)(amountMinor, code);
        }()
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'mobile-hide' },
        prepData.sr_source_of_finance && _sourceOfFinanceStatuses.SOURCE_OF_FINANCE_STATUS_MAP[prepData.sr_source_of_finance] ? t(_sourceOfFinanceStatuses.SOURCE_OF_FINANCE_STATUS_MAP[prepData.sr_source_of_finance].text, { ns: _translation.TRANSLATION_FILES.constants }) : ''
      ),
      !isMobile && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true, className: 'uc-sticky-col uc-right' },
        statusTag
      ),
      isMobile ? _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { style: { marginTop: '0.5em' } },
        _react2.default.createElement(
          'div',
          {
            style: {
              display: 'flex',
              alignItems: 'middle',
              justifyContent: 'space-between',
              width: '100%'
            }
          },
          _this9.renderProgressCell(prepData)
        )
      ) : _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'uc-sticky-col uc-right' },
        _this9.renderProgressCell(prepData)
      )
    );
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRouter.withRouter)((0, _reactRedux.connect)(OpportunityList.mapStateToProps)(OpportunityList)));

/***/ }),
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpportunityOverviewDetail = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRedux = __webpack_require__(9);

var _RefundRequestDetail = __webpack_require__(2178);

var _RefundRequestDetail2 = _interopRequireDefault(_RefundRequestDetail);

var _CancelRequestDetail = __webpack_require__(2114);

var _CancelRequestDetail2 = _interopRequireDefault(_CancelRequestDetail);

var _OpportunityCancelModal = __webpack_require__(262);

var _OpportunityCancelModal2 = _interopRequireDefault(_OpportunityCancelModal);

var _translation = __webpack_require__(4);

var _UCOverviewDetail = __webpack_require__(2211);

var _UCBStatusFlag = __webpack_require__(389);

var _UCBStatusFlag2 = _interopRequireDefault(_UCBStatusFlag);

var _UCBPopup = __webpack_require__(575);

var _UCBPopup2 = _interopRequireDefault(_UCBPopup);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _document_black = __webpack_require__(1596);

var _document_black2 = _interopRequireDefault(_document_black);

var _flash = __webpack_require__(5);

var _credit_card_disabled = __webpack_require__(761);

var _credit_card_disabled2 = _interopRequireDefault(_credit_card_disabled);

var _credit_card_yellow = __webpack_require__(763);

var _credit_card_yellow2 = _interopRequireDefault(_credit_card_yellow);

var _credit_card_green = __webpack_require__(762);

var _credit_card_green2 = _interopRequireDefault(_credit_card_green);

var _loan_disabled = __webpack_require__(764);

var _loan_disabled2 = _interopRequireDefault(_loan_disabled);

var _loan_green = __webpack_require__(1598);

var _loan_green2 = _interopRequireDefault(_loan_green);

var _fetchM = __webpack_require__(6);

var _sourceOfFinanceStatuses = __webpack_require__(584);

var _opportunityStatuses = __webpack_require__(195);

var _refundRefetch = __webpack_require__(1025);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


// Named export for lifecycle tests; the default export below is the wrapped one the app uses.
var OpportunityOverviewDetail = exports.OpportunityOverviewDetail = function (_Component) {
  _inherits(OpportunityOverviewDetail, _Component);

  function OpportunityOverviewDetail(props) {
    _classCallCheck(this, OpportunityOverviewDetail);

    var _this = _possibleConstructorReturn(this, (OpportunityOverviewDetail.__proto__ || Object.getPrototypeOf(OpportunityOverviewDetail)).call(this, props));

    _this.clearRefundRecord = function () {
      // Bumping the version also invalidates any in-flight read so a late response is dropped.
      _this.refundRequestVersion = (_this.refundRequestVersion || 0) + 1;
      if (_this.state.refundRecord != null) _this.setState({ refundRecord: null });
    };

    _this.fetchSpecificRefund = function () {
      var store = _this.context.store;
      var data = _this.props.data;

      if (!data || !data.id) return;

      var url = '/unit_reservation_refunds/opportunity/' + data.id + '/';
      _this.refundRequestVersion = (_this.refundRequestVersion || 0) + 1;
      var requestVersion = _this.refundRequestVersion;
      var isCurrent = function isCurrent() {
        return _this.mounted !== false && requestVersion === _this.refundRequestVersion;
      };

      var action = (0, _fetchM.fetchM)(url, {
        credentials: 'include',
        method: 'GET',
        ignoreNotFound: true,
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (store) {
        store.dispatch(action).then(function (response) {
          if (response && response.ok) {
            return response.json();
          }
          if (response && response.status === 404) {
            return null;
          }
          throw new Error('Network response was not ok');
        }).then(function (record) {
          if (!isCurrent()) return;
          // A 404 is authoritative: there is no record for this booking, so none may be shown.
          _this.setState({ refundRecord: record || null });
        }).catch(function () {});
      }
    };

    _this.getBookingIcon = function (bookingStatus) {
      switch (bookingStatus) {
        case _opportunityStatuses.OPPORTUNITY_STATUS.PAID_UNVERIFIED:
        case _opportunityStatuses.OPPORTUNITY_STATUS.PAID_VERIFIED:
        case _opportunityStatuses.OPPORTUNITY_STATUS.APPROVED:
        case _opportunityStatuses.OPPORTUNITY_STATUS.PAYMENT_MADE:
          return _credit_card_green2.default;
        case _opportunityStatuses.OPPORTUNITY_STATUS.PARTIALLY_PAID_UNVERIFIED:
          return _credit_card_yellow2.default;
        default:
          return _credit_card_disabled2.default;
      }
    };

    _this.getSourceOfFinanceIcon = function (FinanceSource) {
      switch (FinanceSource) {
        case 'bank_loan':
          return _loan_green2.default;
        default:
          return _loan_disabled2.default;
      }
    };

    _this.handleOpenConfirm = function (type) {
      _this.setState({ isConfirmOpen: true, confirmType: type });
    };

    _this.handleCloseConfirm = function () {
      _this.setState({ isConfirmOpen: false, confirmType: null });
    };

    _this.handleConfirmAction = function () {
      var onUpdateOpportunity = _this.props.onUpdateOpportunity;
      var confirmType = _this.state.confirmType;

      // trigger onUpdateOpportunity only if both of these values are present

      if (onUpdateOpportunity && confirmType) {
        onUpdateOpportunity(confirmType);
      }
      _this.handleCloseConfirm();
    };

    _this.handleSubmitRefundRequest = function () {
      var store = _this.context.store;
      var _this$props = _this.props,
          data = _this$props.data,
          refundToken = _this$props.refundToken,
          paymentData = _this$props.paymentData,
          t = _this$props.t,
          fetchBooking = _this$props.fetchBooking;

      var url = '/unit_reservation_refunds/';
      var bodyPayload = {
        opportunityID: data.id,
        amountMinor: paymentData.amountMinorPaid ? paymentData.amountMinorPaid : 0,
        currencyCode: paymentData.currencyCode,
        reason: data.sr_cancellation_reason ? data.sr_cancellation_reason : '-',
        bankName: data.primary_customer && data.primary_customer.contact ? data.primary_customer.contact.bank_name : '',
        bankAccountNumber: data.primary_customer && data.primary_customer.contact ? data.primary_customer.contact.bank_account_number : '',
        bankAccountName: data.primary_customer && data.primary_customer.contact ? data.primary_customer.contact.bank_account_name : '',
        projectName: data.project_name,
        purchaserName: data.primary_customer ? data.primary_customer.name : ''
      };
      var action = (0, _fetchM.fetchM)(url, {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': refundToken
        },
        body: JSON.stringify(bodyPayload)
      });

      if (store) {
        store.dispatch(action).then(function (response) {
          if (response && response.ok) {
            // Fetch the refund record
            _this.fetchSpecificRefund();
            // Refetch booking to get updated sr_status
            if (fetchBooking) {
              fetchBooking();
            }
          }
        }).catch(function (error) {
          store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) }));
        });
      }
    };

    _this.handleOpenCancelModal = function () {
      _this.setState({ isCancelModalOpen: true });
    };

    _this.handleCloseCancelModal = function () {
      _this.setState({ isCancelModalOpen: false });
    };

    _this.handleOpenRefundConfirm = function () {
      _this.setState({ isRefundConfirmOpen: true });
    };

    _this.handleCloseRefundConfirm = function () {
      _this.setState({ isRefundConfirmOpen: false });
    };

    _this.handleConfirmRefund = function () {
      _this.handleSubmitRefundRequest();
      _this.setState({ isRefundConfirmOpen: false });
    };

    _this.handleSubmitCancellationRequest = function (status, reason, cancellationType) {
      var onUpdateOpportunity = _this.props.onUpdateOpportunity;

      if (onUpdateOpportunity) onUpdateOpportunity(status, reason, null, cancellationType);
    };

    _this.checkAccess = function () {
      var auth = _this.props.auth;

      if (auth.isAdminBasic || auth.isAdmin || auth.isSuperAdmin || auth.isHeadquarters) {
        return true;
      }
      return false;
    };

    _this.renderHero = function () {
      return _react2.default.createElement(_semanticUiReact.Image, { src: 'https://react.semantic-ui.com/images/wireframe/image.png', rounded: true, style: { width: '60px', height: '60px' } });
    };

    _this.renderProgressIcons = function (data) {
      var t = _this.props.t;

      var iconSize = 18;
      var bookingStatus = data && data.sr_status ? data.sr_status : null;
      var financeStatus = data && data.sr_source_of_finance ? data.sr_source_of_finance : null;
      var bookingIcon = _react2.default.createElement('img', {
        src: _this.getBookingIcon(bookingStatus),
        width: iconSize,
        alt: 'booking status'
      });
      var loanIcon = _react2.default.createElement('img', {
        src: _this.getSourceOfFinanceIcon(financeStatus),
        width: iconSize,
        alt: 'loan'
      });
      var documentIcon = _react2.default.createElement('img', {
        // src={this.hasBookingNote(data) ? NotesSvg : NotesDisabledSvg}
        src: _document_black2.default,
        width: iconSize,
        alt: 'document'
      });
      return _react2.default.createElement(
        'div',
        { className: 'verticalAlign-mid', style: { display: 'inline-flex', justifyContent: 'start', gap: 8 } },
        _react2.default.createElement(_UCBPopup2.default
        // touchAsClicked={!isComputer}
        , { trigger: bookingIcon,
          content: '' + t(bookingStatus && _opportunityStatuses.SINGLE_STATUS_MAP[bookingStatus] ? _opportunityStatuses.SINGLE_STATUS_MAP[bookingStatus].text : 'None', { ns: _translation.TRANSLATION_FILES.constants })
        }),
        _react2.default.createElement(_UCBPopup2.default, {
          trigger: loanIcon,
          content: '' + t(financeStatus && _sourceOfFinanceStatuses.SOURCE_OF_FINANCE_STATUS_MAP[financeStatus] ? _sourceOfFinanceStatuses.SOURCE_OF_FINANCE_STATUS_MAP[financeStatus].text : 'None', { ns: _translation.TRANSLATION_FILES.constants })
        }),
        _react2.default.createElement(_UCBPopup2.default
        // touchAsClicked={!isComputer}
        , { trigger: documentIcon,
          content: '' + t('Document uploaded')
        })
      );
    };

    _this.renderTitle = function (t) {
      var data = _this.props.data;

      var statusId = data.sr_status;
      var currentStatus = _opportunityStatuses.SINGLE_STATUS_MAP[statusId] || _opportunityStatuses.SINGLE_STATUS_MAP[_opportunityStatuses.OPPORTUNITY_STATUS.PENDING_PAYMENT];
      var project = data && data.project_name || '';
      var customer = data && data.primary_customer && data.primary_customer.name || '';
      return _react2.default.createElement(
        'div',
        { style: { flex: 1, minWidth: 0 } },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', style: { margin: 0 } },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { padding: 0 } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, style: { paddingLeft: 0 } },
              _react2.default.createElement(
                'div',
                { style: { display: 'flex', alignItems: 'center', gap: 8 } },
                _react2.default.createElement(
                  'span',
                  { style: { fontSize: 24, fontWeight: 'bold', wordBreak: 'break-all', flexShrink: 1, minWidth: 0 } },
                  project,
                  project && customer ? ' - ' : '',
                  customer
                ),
                _react2.default.createElement(
                  'div',
                  { style: { flexShrink: 0, display: 'flex', alignItems: 'center', gap: 8 } },
                  currentStatus ? _react2.default.createElement(_UCBStatusFlag2.default, { text: t(currentStatus.text, { ns: _translation.TRANSLATION_FILES.constants }), value: 'opportunity-' + currentStatus.value }) : null,
                  _this.renderProgressIcons(data)
                )
              )
            )
          )
        )
      );
    };

    _this.renderSubtitle = function () {
      var _this$props2 = _this.props,
          data = _this$props2.data,
          t = _this$props2.t;


      var record = Array.isArray(data) ? data[0] : data;

      if (!record || !record.created_at) {
        return _react2.default.createElement(
          'span',
          { style: { fontSize: 12, color: '#969CA4' } },
          t('Created at', { ns: _translation.TRANSLATION_FILES.translation }),
          ' --/--/----'
        );
      }

      if (isNaN(new Date(record.created_at).getTime())) {
        return _react2.default.createElement(
          'span',
          { style: { fontSize: 12, color: '#969CA4' } },
          t('Invalid Date', { ns: _translation.TRANSLATION_FILES.translation })
        );
      }

      return _react2.default.createElement(
        'span',
        { style: { fontSize: 12, color: '#969CA4' } },
        t('Created at', { ns: _translation.TRANSLATION_FILES.translation }),
        ' ',
        _react2.default.createElement(_Timestamp2.default, { timestamp: record.created_at, format: 'DD/MM/YYYY HH:mm:ss' })
      );
    };

    _this.renderCancellationButtons = function () {
      var _this$props3 = _this.props,
          loading = _this$props3.loading,
          t = _this$props3.t;

      return [_react2.default.createElement(
        _semanticUiReact.Button,
        {
          key: 'approve',
          className: 'btn-outcome btn-initiate-refund',
          basic: true,
          disabled: loading,
          onClick: function onClick() {
            return _this.handleOpenRefundConfirm();
          }
        },
        _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh', color: 'blue' }),
        t('Initiate refund', { ns: _translation.TRANSLATION_FILES.translation })
      )];
    };

    _this.renderActionButtons = function () {
      var _this$props4 = _this.props,
          loading = _this$props4.loading,
          t = _this$props4.t;

      return [_react2.default.createElement(
        _semanticUiReact.Button,
        {
          key: 'approve',
          className: 'uc-button',
          basic: true,
          disabled: loading,
          onClick: function onClick() {
            return _this.handleOpenConfirm(_opportunityStatuses.OPPORTUNITY_STATUS.APPROVED);
          }
        },
        _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle outline', color: 'green' }),
        t('Approve', { ns: _translation.TRANSLATION_FILES.translation })
      ), _react2.default.createElement(
        _semanticUiReact.Button,
        {
          key: 'cancel-req',
          className: 'uc-button',
          basic: true,
          disabled: loading,
          onClick: _this.handleOpenCancelModal
        },
        _react2.default.createElement(_semanticUiReact.Icon, { name: 'times circle outline', color: 'red' }),
        t('Cancel', { ns: _translation.TRANSLATION_FILES.translation })
      )];
    };

    _this.renderOtherActions = function () {
      var _this$props5 = _this.props,
          t = _this$props5.t,
          data = _this$props5.data;

      var hasLinkedBooking = !!(data && data.booking_id);
      var isCancelDisabled = hasLinkedBooking && data.booking_status_id !== 'cancelled_developer';
      var cancelTooltip = isCancelDisabled ? t('Cancel option is disabled as the unit has been reserved', { ns: _translation.TRANSLATION_FILES.translation }) : t('Cancel Booking', { ns: _translation.TRANSLATION_FILES.translation });
      var allowedDropdownStatuses = [_opportunityStatuses.OPPORTUNITY_STATUS.PENDING_PAYMENT, _opportunityStatuses.OPPORTUNITY_STATUS.PAYMENT_MADE, _opportunityStatuses.OPPORTUNITY_STATUS.PARTIALLY_PAID_UNVERIFIED, _opportunityStatuses.OPPORTUNITY_STATUS.PAID_UNVERIFIED, _opportunityStatuses.OPPORTUNITY_STATUS.PAID_VERIFIED, _opportunityStatuses.OPPORTUNITY_STATUS.APPROVED, _opportunityStatuses.OPPORTUNITY_STATUS.PENDING_REFUND, _opportunityStatuses.OPPORTUNITY_STATUS.VERIFICATION_REJECTED];

      if (!allowedDropdownStatuses.includes(data.sr_status)) {
        return null;
      }

      var trigger = _react2.default.createElement(
        'span',
        {
          onClick: isCancelDisabled ? undefined : _this.handleOpenCancelModal,
          'aria-label': cancelTooltip,
          style: {
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: isCancelDisabled ? 'not-allowed' : 'pointer',
            opacity: isCancelDisabled ? 0.45 : 1,
            userSelect: 'none'
          }
        },
        _react2.default.createElement(_semanticUiReact.Icon, { name: 'ellipsis vertical', color: 'grey' })
      );

      return _react2.default.createElement(_semanticUiReact.Popup, {
        trigger: trigger,
        content: cancelTooltip,
        position: 'bottom right',
        size: 'mini',
        inverted: true,
        on: 'hover'
      });
    };

    _this.renderConfirmModal = function () {
      var _modalConfigs;

      var t = _this.props.t;
      var _this$state = _this.state,
          isConfirmOpen = _this$state.isConfirmOpen,
          confirmType = _this$state.confirmType;


      var modalConfigs = (_modalConfigs = {}, _defineProperty(_modalConfigs, _opportunityStatuses.OPPORTUNITY_STATUS.APPROVED, {
        icon: 'check circle outline',
        color: 'green',
        header: 'Confirm Approval',
        content: 'Are you sure you want to approve this opportunity?',
        buttonText: 'Yes, Approve',
        buttonColor: 'green'
      }), _defineProperty(_modalConfigs, 'REJECT_TO_PREVIOUS_STATUS', {
        icon: 'times circle outline',
        color: 'red',
        header: 'Confirm Rejection',
        content: 'Are you sure you want to reject this opportunity?',
        buttonText: 'Yes, Reject',
        buttonColor: 'red'
      }), _modalConfigs);

      var config = modalConfigs[confirmType];

      if (!config) return null;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          open: isConfirmOpen,
          onClose: _this.handleCloseConfirm,
          size: 'mini'
        },
        _react2.default.createElement(
          _semanticUiReact.Modal.Header,
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { name: config.icon, color: config.color }),
          t(config.header, { ns: _translation.TRANSLATION_FILES.translation })
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            'p',
            null,
            t(config.content, { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(
            _semanticUiReact.Button,
            { basic: true, onClick: _this.handleCloseConfirm },
            t('Cancel', { ns: _translation.TRANSLATION_FILES.translation })
          ),
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              color: config.buttonColor,
              onClick: _this.handleConfirmAction
            },
            t(config.buttonText, { ns: _translation.TRANSLATION_FILES.translation })
          )
        )
      );
    };

    _this.renderRefundConfirmModal = function () {
      var t = _this.props.t;
      var isRefundConfirmOpen = _this.state.isRefundConfirmOpen;


      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          open: isRefundConfirmOpen,
          onClose: _this.handleCloseRefundConfirm,
          size: 'mini'
        },
        _react2.default.createElement(
          _semanticUiReact.Modal.Header,
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh', color: 'blue' }),
          t('Initiate refund', { ns: _translation.TRANSLATION_FILES.translation })
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            'p',
            null,
            t('Do you wish to initiate refund?', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(
            _semanticUiReact.Button,
            { basic: true, onClick: _this.handleCloseRefundConfirm },
            t('Cancel', { ns: _translation.TRANSLATION_FILES.translation })
          ),
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              color: 'blue',
              onClick: _this.handleConfirmRefund
            },
            t('Initiate refund', { ns: _translation.TRANSLATION_FILES.translation })
          )
        )
      );
    };

    _this.renderCancelModal = function () {
      var data = _this.props.data;

      return _react2.default.createElement(_OpportunityCancelModal2.default, {
        open: _this.state.isCancelModalOpen,
        srCode: data.sr_code,
        onClose: _this.handleCloseCancelModal,
        onSubmit: _this.handleSubmitCancellationRequest
      });
    };

    _this.state = {
      isConfirmOpen: false,
      confirmType: null,
      isCancelModalOpen: false,
      isRefundConfirmOpen: false
    };
    return _this;
  }

  _createClass(OpportunityOverviewDetail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      var _props = this.props,
          auth = _props.auth,
          data = _props.data,
          refundData = _props.refundData;

      var hasPermission = auth && (auth.isAdmin || auth.isSuperAdmin || auth.isHeadquarters || auth.isAdminBasic);
      // Use refundData passed from parent
      if (hasPermission && data && data.id && refundData && refundData.length > 0) {
        var refund = refundData.find(function (r) {
          return r.opportunityID === data.id;
        });
        if (refund) {
          this.setState({ refundRecord: refund });
        }
      }
      // Read the specific refund record for the latest status, but only when the opportunity's
      // sr_status can carry one; otherwise Book API answers 404 for every read.
      if (hasPermission && data && data.id && (0, _refundRefetch.opportunityCanHaveRefund)(data)) {
        this.fetchSpecificRefund();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props2 = this.props,
          auth = _props2.auth,
          data = _props2.data,
          refundData = _props2.refundData;


      var currentId = data && data.id;
      if (!currentId) return;

      var hasPermission = auth && (auth.isAdmin || auth.isSuperAdmin || auth.isHeadquarters || auth.isAdminBasic);

      if (!hasPermission) {
        this.clearRefundRecord();
        return;
      }

      // This component stays mounted across a booking switch. A record read for the previous
      // booking must never be rendered against the next one, and a late response for it must be
      // dropped, even when the next booking is also in a refund state.
      var prevId = prevProps.data && prevProps.data.id;
      if (String(prevId) !== String(currentId)) this.clearRefundRecord();

      var prevRefundData = prevProps.refundData;

      // Field comparison, not `prevProps.data !== data`: Overview rebuilds `data` as a fresh object
      // on every state reset, which re-issued this GET on every render (CPI-1388). A change in the
      // parent's refund list is still an explicit refresh and still re-reads.
      if ((0, _refundRefetch.shouldRefetchRefund)(prevProps.data, data, _refundRefetch.refundKeyOfOpportunity) || prevRefundData !== refundData) {
        // Re-read the specific refund record for the latest status, but only for an sr_status that
        // can carry one; any other status would just be another 404.
        if (!(0, _refundRefetch.opportunityCanHaveRefund)(data)) {
          this.clearRefundRecord();
          return;
        }
        if (refundData && refundData.length > 0) {
          var refund = refundData.find(function (r) {
            return r.opportunityID === data.id;
          });
          if (refund) {
            this.setState({ refundRecord: refund });
          }
        }
        this.fetchSpecificRefund();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }

    // CPI-1226: the modal hands back the scenario as the fourth argument (the third is the target).

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props,
          t = _props3.t,
          data = _props3.data,
          _props3$paymentData = _props3.paymentData,
          paymentData = _props3$paymentData === undefined ? {} : _props3$paymentData;
      var refundRecord = this.state.refundRecord;

      var isPendingApproval = [_opportunityStatuses.OPPORTUNITY_STATUS.PAID_VERIFIED].includes(data.sr_status);
      var isCancellationApproved = [_opportunityStatuses.OPPORTUNITY_STATUS.CANCELLED].includes(data.sr_status);
      // The panel carrying the cancellation category, reason, requestor and approved-at.
      var showCancelRequestDetail = [_opportunityStatuses.OPPORTUNITY_STATUS.PENDING_CANCELLATION, _opportunityStatuses.OPPORTUNITY_STATUS.CANCELLED, _opportunityStatuses.OPPORTUNITY_STATUS.CANCELLED_ERROR].includes(data.sr_status);
      var hasAccess = this.checkAccess();
      var actionButton = void 0;
      var otherActions = void 0;
      var includeCancelButton = [_opportunityStatuses.OPPORTUNITY_STATUS.PENDING_PAYMENT, _opportunityStatuses.OPPORTUNITY_STATUS.PAYMENT_MADE, _opportunityStatuses.OPPORTUNITY_STATUS.PARTIALLY_PAID_UNVERIFIED, _opportunityStatuses.OPPORTUNITY_STATUS.PAID_UNVERIFIED, _opportunityStatuses.OPPORTUNITY_STATUS.PAID_VERIFIED, _opportunityStatuses.OPPORTUNITY_STATUS.VERIFICATION_REJECTED, _opportunityStatuses.OPPORTUNITY_STATUS.APPROVED].includes(data.sr_status);
      if (includeCancelButton) {
        otherActions = this.renderOtherActions();
      } else {
        otherActions = null;
      }

      if (isPendingApproval && hasAccess) {
        actionButton = this.renderActionButtons();
      } else if (isCancellationApproved && hasAccess && paymentData && paymentData.amountMinorPaid > 0) {
        actionButton = this.renderCancellationButtons();
      } else {
        actionButton = null;
      }
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(_UCOverviewDetail.OverviewDetail
        // hero={this.renderHero()} // TODO: temp hide
        , { title: this.renderTitle(t),
          subtitle: this.renderSubtitle(),
          actionButtons: actionButton,
          otherActions: otherActions
        }),
        this.renderConfirmModal(),
        this.renderRefundConfirmModal(),
        this.renderCancelModal(),
        showCancelRequestDetail && _react2.default.createElement(
          _semanticUiReact.Segment,
          { basic: true, style: { padding: 0 } },
          _react2.default.createElement(_CancelRequestDetail2.default, {
            data: data,
            hasAccess: hasAccess,
            onUpdateOpportunity: this.props.onUpdateOpportunity
          })
        ),
        refundRecord != null && (data.sr_status === _opportunityStatuses.OPPORTUNITY_STATUS.PENDING_REFUND || data.sr_status === _opportunityStatuses.OPPORTUNITY_STATUS.REFUNDED || data.sr_status === _opportunityStatuses.OPPORTUNITY_STATUS.REFUND_DECLINED) && _react2.default.createElement(
          _semanticUiReact.Segment,
          { basic: true },
          _react2.default.createElement(_RefundRequestDetail2.default, { data: data, refund: refundRecord, refundToken: this.props.refundToken, onUpdateOpportunity: this.props.onUpdateOpportunity, onSuccess: function onSuccess() {
              return _this2.fetchSpecificRefund();
            } })
        )
      );
    }
  }]);

  return OpportunityOverviewDetail;
}(_react.Component);

OpportunityOverviewDetail.contextTypes = {
  store: _propTypes2.default.object
};
OpportunityOverviewDetail.propTypes = {
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isAdmin: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool
  }),
  t: _propTypes2.default.func,
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  paymentData: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  refundData: _propTypes2.default.array,
  refundToken: _propTypes2.default.string,
  fetchRefunds: _propTypes2.default.func,
  fetchBooking: _propTypes2.default.func,
  onUpdateOpportunity: _propTypes2.default.func,
  loading: _propTypes2.default.bool
};

OpportunityOverviewDetail.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(OpportunityOverviewDetail.mapStateToProps)(OpportunityOverviewDetail));

/***/ }),
/* 2165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _close = __webpack_require__(298);

var _close2 = _interopRequireDefault(_close);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PackagingPricingModal = function (_Component) {
  _inherits(PackagingPricingModal, _Component);

  function PackagingPricingModal(props) {
    _classCallCheck(this, PackagingPricingModal);

    var _this = _possibleConstructorReturn(this, (PackagingPricingModal.__proto__ || Object.getPrototypeOf(PackagingPricingModal)).call(this, props));

    _initialiseProps.call(_this);

    var state = PackagingPricingModal.getPropsToState(props);
    _this.state = _extends({
      open: false
    }, state);
    return _this;
  }

  _createClass(PackagingPricingModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = PackagingPricingModal.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate() {
      this.fixBody();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.fixBody();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var open = this.state.open;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          className: 'upload-modal packagePricingModal',
          open: open,
          onOpen: this.handleOnOpen,
          onClose: function onClose() {
            return _this2.handleOnClose();
          },
          size: 'large'
        },
        _react2.default.createElement(
          'section',
          { className: 'modal-header text-header' },
          this.props.header,
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              basic: true,
              className: 'closeButton',
              onClick: function onClick() {
                return _this2.handleOnClose();
              }
            },
            _react2.default.createElement('img', { src: _close2.default, alt: 'close' })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 1 },
            active: this.props.loading
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            'Loading'
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          this.props.content({ open: open, onClose: this.handleOnClose })
        )
      );
    }
  }]);

  return PackagingPricingModal;
}(_react.Component);

PackagingPricingModal.contextTypes = {
  store: _propTypes2.default.object
};
PackagingPricingModal.propTypes = {
  header: _propTypes2.default.string,
  onClose: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  content: _propTypes2.default.func,
  modalState: _propTypes2.default.bool
};

PackagingPricingModal.getPropsToState = function (props) {
  var state = {};
  // control modal state externally instead of based on trigger if modalState provided
  if (props.modalState) state.open = props.modalState;
  return _extends({}, state);
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.fixBody = function () {
    var anotherModal = document.getElementsByClassName('ui page modals');
    if (anotherModal && anotherModal.length > 0) {
      document.body.classList.add('dimmable', 'dimmed');
    }
  };

  this.handleOnOpen = function () {
    _this3.setState({ open: true });
  };

  this.handleOnClose = function () {
    _this3.setState({ open: false }, function () {
      if (_this3.props.onClose) {
        _this3.props.onClose();
      }
    });
  };
};

exports.default = PackagingPricingModal;

/***/ }),
/* 2166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _close = __webpack_require__(298);

var _close2 = _interopRequireDefault(_close);

var _translation = __webpack_require__(4);

var _PaymentPlanForm = __webpack_require__(1026);

var _PaymentPlanForm2 = _interopRequireDefault(_PaymentPlanForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/sort-comp */
/* eslint-disable max-len */
/* eslint-disable arrow-parens */


var PaymentPlanModal = function (_Component) {
  _inherits(PaymentPlanModal, _Component);

  function PaymentPlanModal(props) {
    _classCallCheck(this, PaymentPlanModal);

    var _this = _possibleConstructorReturn(this, (PaymentPlanModal.__proto__ || Object.getPrototypeOf(PaymentPlanModal)).call(this, props));

    _this.handleSetState = function (state) {
      return _this.setState(function (prev) {
        return _extends({}, prev, state);
      });
    };

    _this.handlePlanSelected = function (paymentScheduleID) {
      _this.setState({ paymentScheduleID: paymentScheduleID });
    };

    _this.handleSaveDisabled = function (isSaveDisabled) {
      _this.setState({ isSaveDisabled: isSaveDisabled });
    };

    _this.handleClose = function () {
      if (_this.props.onClose) {
        _this.props.onClose();
      }
    };

    _this.handleSubmit = function () {
      _this.form.getWrappedInstance().handleSubmit();
    };

    _this.state = {
      paymentScheduleID: '',
      isSaveDisabled: true
    };
    return _this;
  }

  _createClass(PaymentPlanModal, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          loading = _props.loading,
          open = _props.open,
          bookingPaymentPlan = _props.bookingPaymentPlan,
          t = _props.t;
      var paymentScheduleID = this.state.paymentScheduleID;

      // workaround to show dropdown option list overflow outside of modal

      var noBpp = bookingPaymentPlan && bookingPaymentPlan.id === '';

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          closeOnDimmerClick: false,
          size: 'large',
          open: open,
          onClose: function onClose() {
            return _this2.handleClose();
          },
          className: 'paymentPlanModal'
        },
        _react2.default.createElement(
          'section',
          { className: 'modal-header text-header' },
          t(noBpp ? 'Add' : 'Edit', { ns: _translation.TRANSLATION_FILES.translation }) + ' ' + t('Payment Plan'),
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              basic: true,
              className: 'closeButton',
              onClick: function onClick() {
                return _this2.handleClose();
              }
            },
            _react2.default.createElement('img', { src: _close2.default, alt: 'close' })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 1 },
            active: loading
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { className: 'modal-content' + (noBpp && paymentScheduleID === '' ? ' modal-content-overflow' : '') },
          _react2.default.createElement(_PaymentPlanForm2.default, {
            ref: function ref(_ref) {
              _this2.form = _ref;
            },
            token: this.props.token,
            onSubmit: this.props.onSubmit,
            bookingPaymentPlan: bookingPaymentPlan,
            contractPaymentSchedules: this.props.contractPaymentSchedules,
            bookingData: this.props.bookingData,
            onPaymentPlanSelect: this.handlePlanSelected,
            onSaveDisabled: this.handleSaveDisabled
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          { className: 'text-center' },
          _react2.default.createElement(_semanticUiReact.Button, {
            type: 'submit',
            content: t('Save', { ns: _translation.TRANSLATION_FILES.translation }),
            disabled: this.state.isSaveDisabled,
            loading: loading,
            onClick: this.handleSubmit,
            className: 'submit-button text-title'
          })
        )
      );
    }
  }]);

  return PaymentPlanModal;
}(_react.Component);

PaymentPlanModal.contextTypes = {
  store: _propTypes2.default.object
};
PaymentPlanModal.propTypes = {
  onClose: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  open: _propTypes2.default.bool,
  token: _propTypes2.default.string,
  onSubmit: _propTypes2.default.func,
  paymentSchedules: _propTypes2.default.arrayOf(_propTypes2.default.shape()), // all payment schedule
  bookingPaymentPlan: _propTypes2.default.shape(),
  contractPaymentSchedules: _propTypes2.default.arrayOf(_propTypes2.default.shape()), //  list pending / billed cps
  bookingData: _propTypes2.default.shape(),
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(PaymentPlanModal);

/***/ }),
/* 2167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PaymentPlanModal = __webpack_require__(2166);

Object.defineProperty(exports, 'PaymentPlanModal', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PaymentPlanModal).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopupButtonList = function (_Component) {
  _inherits(PopupButtonList, _Component);

  function PopupButtonList() {
    _classCallCheck(this, PopupButtonList);

    return _possibleConstructorReturn(this, (PopupButtonList.__proto__ || Object.getPrototypeOf(PopupButtonList)).apply(this, arguments));
  }

  _createClass(PopupButtonList, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;
      return _react2.default.createElement(
        _semanticUiReact.Popup,
        {
          className: 'popupList',
          trigger: _react2.default.createElement(
            _semanticUiReact.Button,
            {
              className: 'icon',
              compact: true
            },
            this.props.buttonContent
          ),
          on: 'focus',
          wide: 'very',
          size: this.props.size,
          position: 'bottom center',
          basic: true
        },
        _react2.default.createElement(
          'div',
          { style: { width: '70px' } },
          _react2.default.createElement(
            _semanticUiReact.List,
            { size: this.props.size },
            data && data.length > 0 ? data.map(function (item, id) {
              return _react2.default.createElement(
                _semanticUiReact.List.Item,
                { key: id },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle', color: item.iconColor || '' }),
                ' ',
                item.value
              );
            }) : ''
          )
        )
      );
    }
  }]);

  return PopupButtonList;
}(_react.Component);

PopupButtonList.propTypes = {
  buttonContent: _propTypes2.default.node.isRequired,
  size: _propTypes2.default.string,
  data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
};
PopupButtonList.defaultProps = {
  size: 'tiny'
};
exports.default = PopupButtonList;

/***/ }),
/* 2169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

__webpack_require__(360);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */

// import _ from 'lodash';


var ProjectHimsSettingsForm = function (_Component) {
  _inherits(ProjectHimsSettingsForm, _Component);

  function ProjectHimsSettingsForm(props) {
    _classCallCheck(this, ProjectHimsSettingsForm);

    var _this = _possibleConstructorReturn(this, (ProjectHimsSettingsForm.__proto__ || Object.getPrototypeOf(ProjectHimsSettingsForm)).call(this, props));

    _initialiseProps.call(_this);

    var state = ProjectHimsSettingsForm.getPropsToState(props);
    var data = props.himsSettings || [];
    var validations = [];
    data.forEach(function (d, idx) {
      validations[idx] = _this.newValidationObject();
    });
    _this.state = _extends({}, state, {
      oriData: (0, _clone2.default)(data),
      data: data,
      validations: validations
    });
    return _this;
  }

  _createClass(ProjectHimsSettingsForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var state = ProjectHimsSettingsForm.getPropsToState(nextProps);
      var validations = this.state.validations;

      if (nextProps.projectID !== this.props.projectID) {
        var data = nextProps.himsSettings || [];
        state.oriData = (0, _clone2.default)(data);
        state.data = data;
        validations = [];
        state.data.forEach(function (d, idx) {
          validations[idx] = _this2.newValidationObject();
        });
      }
      this.setState(_extends({}, state, {
        validations: validations
      }));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var disabled = this.props.disabled;
      var data = this.state.data;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { verticalAlign: 'middle' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 11, tablet: 13, computer: 13 },
            _react2.default.createElement(
              'p',
              { style: disabled ? { opacity: 'calc(.2025)', color: 'rgba(0,0,0,.87)' } : {} },
              'Retrieve data from HIMS and fill in the boxes below. Ensure the data is accurate.'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 5, tablet: 3, computer: 3, textAlign: 'right' },
            _react2.default.createElement(_semanticUiReact.Button, {
              primary: true,
              style: { margin: 0 },
              type: 'button',
              size: 'small',
              icon: 'add',
              content: 'Add',
              disabled: disabled || data.length >= 10,
              onClick: this.handleAddRow
            })
          )
        ),
        data && data.length > 0 && data.map(function (hs, idx) {
          return _this3.renderRow(hs, idx);
        })
      );
    }
  }]);

  return ProjectHimsSettingsForm;
}(_react.Component);

ProjectHimsSettingsForm.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  projectID: _propTypes2.default.string,
  companyHimsTokens: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    developerCode: _propTypes2.default.string,
    developerName: _propTypes2.default.string
  })),
  himsSettings: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    himsDeveloperCode: _propTypes2.default.string,
    himsDeveloperName: _propTypes2.default.string,
    himsDeveloperLicense: _propTypes2.default.string,
    himsDevelopmentCode: _propTypes2.default.string,
    himsDevelopmentName: _propTypes2.default.string
  })),
  disabled: _propTypes2.default.bool
};

ProjectHimsSettingsForm.getPropsToState = function (props) {
  var companyHimsTokens = props.companyHimsTokens;

  return {
    companyHimsTokens: companyHimsTokens.map(function (cht) {
      return {
        value: cht.developerCode,
        text: cht.developerCode + ' - ' + cht.developerName
      };
    })
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleOnChange = function (data) {
    var validations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this4.state.validations;

    _this4.setState({ data: data, validations: validations });
    if (_this4.props.onChange) {
      _this4.props.onChange(data);
    }
  };

  this.validate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var allValidations, data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            allValidations = {};

            _this4.state.validations.forEach(function (v, idx) {
              allValidations['himsDeveloperCode_' + idx] = v.himsDeveloperCode;
              allValidations['himsDeveloperName_' + idx] = v.himsDeveloperName;
              allValidations['himsDeveloperLicense_' + idx] = v.himsDeveloperLicense;
              allValidations['himsDevelopmentCode_' + idx] = v.himsDevelopmentCode;
              allValidations['himsDevelopmentName_' + idx] = v.himsDevelopmentName;
            });
            data = {};

            _this4.state.data.forEach(function (d, idx) {
              data['himsDeveloperCode_' + idx] = d.himsDeveloperCode;
              data['himsDeveloperName_' + idx] = d.himsDeveloperName;
              data['himsDeveloperLicense_' + idx] = d.himsDeveloperLicense;
              data['himsDevelopmentCode_' + idx] = d.himsDevelopmentCode;
              data['himsDevelopmentName_' + idx] = d.himsDevelopmentName;
            });
            return _context.abrupt('return', _AppForm2.default.validate(allValidations, data));

          case 5:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this4);
  }));

  this.handleInputChange = function (_ref2, idx) {
    var name = _ref2.name,
        value = _ref2.value;
    var data = _this4.state.data;
    var companyHimsTokens = _this4.props.companyHimsTokens;

    if (name === 'himsDeveloperCode') {
      var himsToken = companyHimsTokens.find(function (cht) {
        return cht.developerCode === value;
      });
      if (himsToken) {
        // change all
        data = data.map(function (d) {
          return _extends({}, d, {
            himsDeveloperCode: himsToken.developerCode,
            himsDeveloperName: himsToken.developerName
          });
        });
      }
    } else {
      data[idx][name] = value;
    }
    _this4.handleOnChange(data);
  };

  this.handleAddRow = function () {
    var projectID = _this4.props.projectID;
    var _state = _this4.state,
        data = _state.data,
        validations = _state.validations;

    if (data.length >= 10) {
      return;
    }
    data.push({
      projectID: projectID,
      himsDeveloperCode: data.length > 0 ? data[0].himsDeveloperCode : '',
      himsDeveloperName: data.length > 0 ? data[0].himsDeveloperName : '',
      himsDeveloperLicense: '',
      himsDevelopmentCode: '',
      himsDevelopmentName: ''
    });
    validations.push(_this4.newValidationObject());
    _this4.handleOnChange(data, validations);
  };

  this.handleRemoveRow = function (idx) {
    var _state2 = _this4.state,
        data = _state2.data,
        validations = _state2.validations;

    data.splice(idx, 1);
    validations.splice(idx, 1);
    _this4.handleOnChange(data, validations);
  };

  this.newValidationObject = function () {
    return {
      himsDeveloperCode: (0, _react.createRef)(),
      himsDeveloperName: (0, _react.createRef)(),
      himsDeveloperLicense: (0, _react.createRef)(),
      himsDevelopmentCode: (0, _react.createRef)(),
      himsDevelopmentName: (0, _react.createRef)()
    };
  };

  this.renderRow = function (hs, idx) {
    var disabled = _this4.props.disabled;
    var _state3 = _this4.state,
        companyHimsTokens = _state3.companyHimsTokens,
        validations = _state3.validations;

    var validationRef = validations[idx];
    var asterisk = disabled ? '' : '*';
    return _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { key: idx },
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        _react2.default.createElement(
          _semanticUiReact.Segment,
          null,
          _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal' },
            _react2.default.createElement(_AppForm2.default.Select, {
              label: 'Developer Code - Kod Pemaju',
              validateName: 'himsDeveloperCode_' + idx,
              name: 'himsDeveloperCode',
              fluid: true,
              value: hs.himsDeveloperCode,
              options: companyHimsTokens,
              onChange: function onChange(e, d) {
                return _this4.handleInputChange(d, idx);
              },
              placeholder: 'Select Developer Code' + asterisk,
              validation: disabled ? null : [_webValidations.required],
              ref: validationRef ? validationRef.himsDeveloperCode : null,
              disabled: disabled || companyHimsTokens.length === 0 || idx > 0
            }),
            _react2.default.createElement(_AppForm2.default.Input, {
              label: 'Developer Name - Nama Pemaju',
              validateName: 'himsDeveloperName_' + idx,
              name: 'himsDeveloperName',
              fluid: true,
              value: hs.himsDeveloperName,
              validation: disabled ? null : [_webValidations.required],
              ref: validationRef ? validationRef.himsDeveloperName : null,
              disabled: true
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal' },
            _react2.default.createElement(_AppForm2.default.Input, {
              label: 'Developer License Number - No Lesen',
              validateName: 'himsDeveloperLicense_' + idx,
              name: 'himsDeveloperLicense',
              fluid: true,
              value: hs.himsDeveloperLicense,
              onChange: function onChange(e, d) {
                return _this4.handleInputChange(d, idx);
              },
              validation: disabled ? null : [_webValidations.required],
              ref: validationRef ? validationRef.himsDeveloperLicense : null,
              disabled: disabled
            }),
            _react2.default.createElement(
              _AppForm2.default.Validate,
              {
                label: 'Development Project Code - Kod Pemajuan',
                validateName: 'himsDevelopmentCode_' + idx,
                name: 'himsDevelopmentCode',
                onChange: function onChange(e, d) {
                  return _this4.handleInputChange(d, idx);
                },
                validation: disabled ? null : [_webValidations.required],
                ref: validationRef ? validationRef.himsDevelopmentCode : null
              },
              _react2.default.createElement(_semanticUiReact.Form.Input, {
                fluid: true,
                label: 'Development Project Code - Kod Pemajuan',
                name: 'himsDevelopmentCode',
                value: hs.himsDevelopmentCode,
                disabled: disabled
              }),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'small',
                  { style: disabled ? { opacity: 'calc(.2025)', color: 'rgba(0,0,0,.87)' } : {} },
                  '(This is required to pull information from HIMS)'
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal', style: { alignItems: 'end', marginBottom: 0 } },
            _react2.default.createElement(_AppForm2.default.Input, {
              label: 'Development Project Name - Nama Pemajuan',
              validateName: 'himsDevelopmentName_' + idx,
              name: 'himsDevelopmentName',
              fluid: true,
              value: hs.himsDevelopmentName,
              onChange: function onChange(e, d) {
                return _this4.handleInputChange(d, idx);
              },
              validation: disabled ? null : [_webValidations.required],
              ref: validationRef ? validationRef.himsDevelopmentName : null,
              disabled: disabled
            }),
            _react2.default.createElement(
              'div',
              { style: { width: '100%', textAlign: 'right', paddingRight: '0.5em' } },
              _react2.default.createElement(_semanticUiReact.Button, {
                size: 'tiny',
                type: 'button',
                compact: true,
                negative: true,
                icon: 'remove',
                content: 'Remove',
                disabled: disabled,
                onClick: function onClick() {
                  return _this4.handleRemoveRow(idx);
                }
              })
            )
          )
        )
      )
    );
  };
};

exports.default = ProjectHimsSettingsForm;

/***/ }),
/* 2170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactSortableHoc = __webpack_require__(123);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _BankerItem = __webpack_require__(556);

var _BankerItem2 = _interopRequireDefault(_BankerItem);

var _BankersList = __webpack_require__(397);

var _BankersList2 = _interopRequireDefault(_BankersList);

var _InviteBankerForm = __webpack_require__(587);

var _InviteBankerForm2 = _interopRequireDefault(_InviteBankerForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DragHandle = (0, _reactSortableHoc.SortableHandle)(function (_ref) {
  var idx = _ref.idx,
      disabled = _ref.disabled;
  return _react2.default.createElement(
    _semanticUiReact.Grid,
    { columns: 'equal', centered: true, verticalAlign: 'middle' },
    _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { style: { color: '#bbbbbb' } },
      idx + 1
    ),
    _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      null,
      _react2.default.createElement(_semanticUiReact.Icon, { size: 'large', disabled: disabled, name: 'content' })
    )
  );
});

var SortableItem = (0, _reactSortableHoc.SortableElement)(function (_ref2) {
  var data = _ref2.data,
      idx = _ref2.idx,
      onDeleteItem = _ref2.onDeleteItem,
      itemDisabled = _ref2.itemDisabled;
  return _react2.default.createElement(_BankerItem2.default, {
    custom: true,
    showSummary: true,
    banker: data,
    disabled: itemDisabled,
    leftComponent: _react2.default.createElement(DragHandle, { idx: idx, disabled: itemDisabled }),
    rightComponent: _react2.default.createElement(_semanticUiReact.Button, {
      onClick: function onClick(e) {
        return onDeleteItem(e, idx);
      },
      negative: true,
      icon: 'trash',
      compact: true,
      disabled: itemDisabled
    })
  });
});

var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref3) {
  var items = _ref3.items,
      onDeleteItem = _ref3.onDeleteItem,
      disabled = _ref3.disabled;
  return _react2.default.createElement(
    _semanticUiReact.Segment,
    { className: items.length > 0 ? 'sortable' : '', textAlign: items.length > 0 ? null : 'center' },
    items.length > 0 ? items.map(function (data, index) {
      return _react2.default.createElement(SortableItem, {
        data: data,
        idx: index // SortableElement didn't pass index props, so we need to add idx here
        , index: index,
        key: 'item-' + index,
        onDeleteItem: onDeleteItem,
        disabled: disabled,
        itemDisabled: disabled
      });
    }) : _react2.default.createElement(
      'p',
      null,
      'No bankers.'
    )
  );
});

var ProjectPanelBankers = function (_Component) {
  _inherits(ProjectPanelBankers, _Component);

  function ProjectPanelBankers(props) {
    _classCallCheck(this, ProjectPanelBankers);

    var _this = _possibleConstructorReturn(this, (ProjectPanelBankers.__proto__ || Object.getPrototypeOf(ProjectPanelBankers)).call(this, props));

    _initialiseProps.call(_this);

    var state = ProjectPanelBankers.getPropsToState(props);
    _this.state = _extends({}, state, {
      showAddBanker: false,
      showInviteBanker: false
    });
    return _this;
  }

  _createClass(ProjectPanelBankers, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = ProjectPanelBankers.getPropsToState(nextProps);
      if (JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data)) {
        this.setState(_extends({}, state));
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'inviteBanker',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, newBanker) {
        var store, errors, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 5;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 5:
                _context.next = 7;
                return this.setLoading(true);

              case 7:
                _context.prev = 7;
                _context.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.projectID + '/bankers/invite/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(newBanker)
                }));

              case 10:
                _context.next = 25;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](7);
                _context.next = 16;
                return this.setLoading(false);

              case 16:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 22;
                  break;
                }

                _context.next = 19;
                return _context.t0.res.text();

              case 19:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 22:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context.abrupt('return');

              case 25:
                _context.next = 27;
                return this.setLoading(false);

              case 27:
                _context.next = 29;
                return this.setComponentState({ showAddBanker: false, showInviteBanker: false });

              case 29:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Invite Success', message: 'Banker ' + newBanker.name + ' is successfully invited.' }));

              case 30:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 12]]);
      }));

      function inviteBanker(_x2, _x3) {
        return _ref4.apply(this, arguments);
      }

      return inviteBanker;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          allowAgentSalesTeamBankerInvitation = _props.allowAgentSalesTeamBankerInvitation,
          autoAssignStatus = _props.autoAssignStatus,
          autoShareFormToBanker = _props.autoShareFormToBanker,
          bankerSelectionTabs = _props.bankerSelectionTabs,
          defaultBookingStatusID = _props.defaultBookingStatusID,
          disabled = _props.disabled;
      var data = this.state.data;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { className: 'ProjectPanelBankers' },
        _react2.default.createElement(_InviteBankerForm2.default, {
          auth: this.props.auth,
          ref: function ref(_ref5) {
            _this3.form = _ref5;
          },
          open: this.state.showInviteBanker,
          onClose: this.handleCloseInviteBanker,
          onConfirm: this.handleInviteBanker
        }),
        _react2.default.createElement(
          _semanticUiReact.Divider,
          { horizontal: true },
          'Bankers Selection Settings'
        ),
        _react2.default.createElement(
          _semanticUiReact.Header,
          { as: 'h4' },
          'Auto-assign'
        ),
        _react2.default.createElement(_semanticUiReact.Label, { content: 'Auto-assign case to Bankers when status is' }),
        _react2.default.createElement(_semanticUiReact.Dropdown, {
          onChange: this.handleOnChangeAutoAssignStatus,
          options: this.getAutoAssignOptions(),
          selection: true,
          value: autoAssignStatus,
          disabled: defaultBookingStatusID === 'booked'
        }),
        _react2.default.createElement(
          _semanticUiReact.Header,
          { as: 'h4' },
          'Invite new bankers during unit booking ',
          _react2.default.createElement(
            'small',
            { style: { fontWeight: 100 } },
            '(Applies to all user except Headquarters role)'
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { className: 'form-sof-checkbox' },
          _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
            toggle: true,
            label: allowAgentSalesTeamBankerInvitation ? 'On' : 'Off',
            name: 'allowAgentSalesTeamBankerInvitation',
            checked: allowAgentSalesTeamBankerInvitation,
            onChange: this.handleCheckBoxChange
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Header,
          { as: 'h4' },
          'Auto-share'
        ),
        _react2.default.createElement(_semanticUiReact.Label, { content: 'Automatically share booking form once Banker is assigned' }),
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { className: 'form-sof-checkbox' },
          _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
            toggle: true,
            label: autoShareFormToBanker ? 'On' : 'Off',
            name: 'autoShareFormToBanker',
            checked: autoShareFormToBanker,
            onChange: this.handleCheckBoxChange
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Divider,
          { horizontal: true },
          'Bankers Selection Tabs'
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 7, tablet: 16, mobile: 16 },
            _react2.default.createElement(
              _semanticUiReact.Form.Group,
              { grouped: true },
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Segment,
                    { className: 'form-sof-segment' },
                    _react2.default.createElement(
                      _semanticUiReact.Header,
                      { as: 'h4' },
                      'Visibility settings'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { className: 'form-group' },
                      _react2.default.createElement(_semanticUiReact.Form.Field, { className: 'form-label', label: 'Panel (ON by default)' }),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Field,
                        { className: 'form-value' },
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          toggle: true,
                          label: 'On',
                          name: 'panel_banker',
                          checked: true,
                          disabled: true
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { className: 'form-group' },
                      _react2.default.createElement(_semanticUiReact.Form.Field, { className: 'form-label', label: 'Preferred' }),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Field,
                        { className: 'form-value' },
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          toggle: true,
                          label: bankerSelectionTabs && bankerSelectionTabs.length > 0 && bankerSelectionTabs.some(function (o) {
                            return o === 'preferred_banker';
                          }) ? 'On' : 'Off',
                          name: 'preferred_banker',
                          checked: bankerSelectionTabs && bankerSelectionTabs.length > 0 && bankerSelectionTabs.includes('preferred_banker'),
                          onChange: this.handleCheckBoxChange
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { className: 'form-group' },
                      _react2.default.createElement(_semanticUiReact.Form.Field, { className: 'form-label', label: 'All' }),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Field,
                        { className: 'form-value' },
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          toggle: true,
                          label: bankerSelectionTabs && bankerSelectionTabs.length > 0 && bankerSelectionTabs.some(function (o) {
                            return o === 'all';
                          }) ? 'On' : 'Off',
                          name: 'all',
                          checked: bankerSelectionTabs && bankerSelectionTabs.length > 0 && bankerSelectionTabs.includes('all'),
                          onChange: this.handleCheckBoxChange
                        })
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Divider,
          { horizontal: true },
          'Bankers List'
        ),
        _react2.default.createElement(_BankersList2.default, {
          open: this.state.showAddBanker,
          onClose: this.handleCloseAddBanker,
          onConfirm: this.handleAddBanker,
          selected: data,
          only: true,
          extraNode: _react2.default.createElement(_semanticUiReact.Button, {
            floated: 'left',
            onClick: this.handleShowInviteBanker,
            content: 'Invite'
          })
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(SortableList, {
              helperClass: 'projectPanelBankers isSorting',
              items: this.getSortedData(data),
              lockAxis: 'y',
              lockToContainerEdges: true,
              onDeleteItem: this.handleOnDelete,
              onSortEnd: this.onSortEnd,
              useDragHandle: true,
              disabled: disabled
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16, textAlign: 'center' },
            _react2.default.createElement(_semanticUiReact.Button, {
              primary: true,
              content: 'Add Banker',
              onClick: this.handleShowAddBanker,
              disabled: disabled
            })
          )
        )
      );
    }
  }]);

  return ProjectPanelBankers;
}(_react.Component);

ProjectPanelBankers.contextTypes = {
  store: _propTypes2.default.object
};
ProjectPanelBankers.propTypes = {
  allowAgentSalesTeamBankerInvitation: _propTypes2.default.bool,
  autoAssignStatus: _propTypes2.default.string,
  autoShareFormToBanker: _propTypes2.default.bool,
  bankerSelectionTabs: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  defaultBookingStatusID: _propTypes2.default.string,
  projectID: _propTypes2.default.string.isRequired,
  token: _propTypes2.default.string,
  data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  onChange: _propTypes2.default.func,
  onCheckboxChange: _propTypes2.default.func,
  onStatusChange: _propTypes2.default.func,
  disabled: _propTypes2.default.bool,
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.object
  })
};
ProjectPanelBankers.defaultProps = {
  data: [],
  token: '',
  onChange: null,
  disabled: false
};

ProjectPanelBankers.getPropsToState = function (props) {
  var data = props.data || [];
  var bankerSelectionTabs = props.bankerSelectionTabs || [];
  return {
    bankerSelectionTabs: bankerSelectionTabs,
    data: data
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onSortEnd = function (_ref6) {
    var oldIndex = _ref6.oldIndex,
        newIndex = _ref6.newIndex;
    return _this4.sortDataByIndex((0, _reactSortableHoc.arrayMove)(_this4.state.data, oldIndex, newIndex));
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this4.setState({ loading: loading }, res);
    });
  };

  this.getAutoAssignOptions = function () {
    return [{ text: 'Booked', value: 'booked' }, { text: 'Reserved', value: 'reserved' }];
  };

  this.getSortedData = function (data) {
    return data.sort(function (a, b) {
      return a.position - b.position;
    });
  };

  this.sortDataByIndex = function (newData) {
    var data = newData;
    data.forEach(function (d, index) {
      data[index].position = index + 1;
    });
    _this4.setState({ data: data }, function () {
      var onChange = _this4.props.onChange;

      if (onChange) {
        onChange(data);
      }
    });
  };

  this.handleShowAddBanker = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this4.setState({
      showAddBanker: true
    });
  };

  this.handleCloseAddBanker = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this4.setState({
      showAddBanker: false
    });
  };

  this.handleAddBanker = function (e, data) {
    if (e) {
      e.preventDefault();
    }
    _this4.setState({
      data: data,
      showAddBanker: false
    }, function () {
      var onChange = _this4.props.onChange;

      if (onChange) {
        onChange(data);
      }
    });
  };

  this.handleShowInviteBanker = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this4.setState({
      showInviteBanker: true
    });
  };

  this.handleCloseInviteBanker = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this4.setState({
      showInviteBanker: false
    });
  };

  this.handleInviteBanker = function (e, validation, banker) {
    if (e) {
      e.preventDefault();
    }
    _this4.inviteBanker(validation, banker);
  };

  this.handleOnChangeAutoAssignStatus = function (e, value) {
    var onStatusChange = _this4.props.onStatusChange;

    if (onStatusChange) {
      onStatusChange(value.value);
    }
  };

  this.handleCheckBoxChange = function (e, value) {
    var onCheckboxChange = _this4.props.onCheckboxChange;

    if (onCheckboxChange) {
      onCheckboxChange(value.name);
    }
  };

  this.handleOnDelete = function (e, index) {
    if (e) {
      e.preventDefault();
    }
    var data = _this4.state.data;
    data.splice(index, 1);
    _this4.sortDataByIndex(data);
  };
};

exports.default = ProjectPanelBankers;

/***/ }),
/* 2171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _reactSortableHoc = __webpack_require__(123);

var _TierPricingSchedule = __webpack_require__(2530);

var _TierPricingSchedule2 = _interopRequireDefault(_TierPricingSchedule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DragHandle = (0, _reactSortableHoc.SortableHandle)(function () {
  return _react2.default.createElement(_semanticUiReact.Icon, { size: 'large', disabled: true, name: 'content' });
});

var SortableItem = (0, _reactSortableHoc.SortableElement)(function (_ref) {
  var data = _ref.data,
      idx = _ref.idx,
      _onChange = _ref.onChange,
      onDeleteItem = _ref.onDeleteItem,
      onSchedule = _ref.onSchedule;

  var inputDateFormat = 'DD/MM/YYYY, hh:mm A';
  var scheduleColor = null;
  var scheduleIcon = 'calendar outline';
  var scheduleTitle = 'Set schedule';
  if (data.scheduleStartAt && data.scheduleEndAt) {
    if ((0, _momentTimezone2.default)(data.scheduleStartAt).unix() < (0, _momentTimezone2.default)().unix() && (0, _momentTimezone2.default)(data.scheduleEndAt).unix() > (0, _momentTimezone2.default)().unix()) {
      scheduleIcon = 'calendar check';
      scheduleColor = 'green';
      scheduleTitle = 'Active schedule: ' + (0, _momentTimezone2.default)(data.scheduleStartAt).format(inputDateFormat) + ' - ' + (0, _momentTimezone2.default)(data.scheduleEndAt).format(inputDateFormat);
    } else if ((0, _momentTimezone2.default)(data.scheduleStartAt).unix() > (0, _momentTimezone2.default)().unix()) {
      scheduleIcon = 'calendar check';
      scheduleColor = 'teal';
      scheduleTitle = 'Future schedule: ' + (0, _momentTimezone2.default)(data.scheduleStartAt).format(inputDateFormat) + ' - ' + (0, _momentTimezone2.default)(data.scheduleEndAt).format(inputDateFormat);
    } else {
      scheduleIcon = 'calendar times';
      scheduleColor = 'red';
      scheduleTitle = 'Schedule ended';
    }
  } else if (data.scheduleStartAt) {
    if ((0, _momentTimezone2.default)(data.scheduleStartAt).unix() < (0, _momentTimezone2.default)().unix()) {
      scheduleIcon = 'calendar check';
      scheduleColor = 'green';
      scheduleTitle = 'Active schedule: ' + (0, _momentTimezone2.default)(data.scheduleStartAt).format(inputDateFormat) + ' - n/a';
    } else {
      scheduleIcon = 'calendar check';
      scheduleColor = 'teal';
      scheduleTitle = 'Future schedule: ' + (0, _momentTimezone2.default)(data.scheduleStartAt).format(inputDateFormat) + ' - n/a';
    }
  } else if (data.scheduleEndAt) {
    if ((0, _momentTimezone2.default)(data.scheduleEndAt).unix() > (0, _momentTimezone2.default)().unix()) {
      scheduleIcon = 'calendar check';
      scheduleColor = 'green';
      scheduleTitle = 'Active schedule: n/a - ' + (0, _momentTimezone2.default)(data.scheduleEndAt).format(inputDateFormat);
    } else {
      scheduleIcon = 'calendar times';
      scheduleColor = 'red';
      scheduleTitle = 'Schedule ended';
    }
  }
  return _react2.default.createElement(
    _semanticUiReact.Grid,
    { className: 'item' },
    _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { verticalAlign: 'middle' },
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { mobile: 3, tablet: 1, computer: 1 },
        _react2.default.createElement(DragHandle, null)
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { mobile: 10, tablet: 13, computer: 14 },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'compact' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 16, tablet: 16, computer: 5 },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { verticalAlign: 'middle', className: 'compact' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 12 },
                    _react2.default.createElement(_semanticUiReact.Input, {
                      fluid: true,
                      name: 'name',
                      onChange: function onChange(e, d) {
                        return _onChange(e, d, idx);
                      },
                      placeholder: 'Name*',
                      value: data.name
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 4 },
                    _react2.default.createElement(
                      _semanticUiReact.Button,
                      { circular: true, size: 'small', icon: true, color: scheduleColor, title: scheduleTitle, onClick: function onClick(e) {
                          return onSchedule(e, data, idx);
                        } },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: scheduleIcon, fitted: true })
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 16, tablet: 16, computer: 5 },
              _react2.default.createElement(_semanticUiReact.Input, {
                fluid: true,
                name: 'description',
                onChange: function onChange(e, d) {
                  return _onChange(e, d, idx);
                },
                placeholder: 'Description',
                value: data.description
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 16, tablet: 16, computer: 6 },
              _react2.default.createElement(_semanticUiReact.Input, {
                fluid: true,
                name: 'formulaPrice',
                onChange: function onChange(e, d) {
                  return _onChange(e, d, idx);
                },
                placeholder: 'Nett Price / Formula*',
                value: data.formulaPrice
              })
            )
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { mobile: 3, tablet: 2, computer: 1, className: 'colRight' },
        _react2.default.createElement(_semanticUiReact.Button, {
          onClick: function onClick(e) {
            return onDeleteItem(e, idx);
          },
          negative: true,
          icon: 'trash',
          compact: true
        })
      )
    )
  );
});

var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref2) {
  var addButtonIsDisabled = _ref2.addButtonIsDisabled,
      helpModal = _ref2.helpModal,
      items = _ref2.items,
      onAdd = _ref2.onAdd,
      onChange = _ref2.onChange,
      onDeleteItem = _ref2.onDeleteItem,
      onSchedule = _ref2.onSchedule;
  return _react2.default.createElement(
    _semanticUiReact.Segment,
    { color: 'teal' },
    _react2.default.createElement(
      _semanticUiReact.Grid,
      { className: 'head' },
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { verticalAlign: 'middle' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { textAlign: 'center' },
          _react2.default.createElement(
            'h3',
            null,
            'Discount Package Setup ',
            _react2.default.createElement(_semanticUiReact.Button, { onClick: helpModal, circular: true, icon: 'help', size: 'mini' })
          )
        )
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Grid,
      { className: 'item mobile-hide' },
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { verticalAlign: 'middle' },
        _react2.default.createElement(_semanticUiReact.Grid.Column, { width: 1 }),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 14 },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'compact' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 5, textAlign: 'center' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'compact' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 12 },
                    _react2.default.createElement(
                      'b',
                      null,
                      'Name*'
                    )
                  ),
                  _react2.default.createElement(_semanticUiReact.Grid.Column, { width: 4 })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 5, textAlign: 'center' },
                _react2.default.createElement(
                  'b',
                  null,
                  'Description'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 6, textAlign: 'center' },
                _react2.default.createElement(
                  'b',
                  null,
                  'Nett Price / Formula*'
                )
              )
            )
          )
        ),
        _react2.default.createElement(_semanticUiReact.Grid.Column, { width: 1 })
      )
    ),
    items.map(function (data, index) {
      return _react2.default.createElement(SortableItem, {
        data: data,
        idx: index,
        index: index,
        key: 'item-' + index,
        onChange: onChange,
        onDeleteItem: onDeleteItem,
        onSchedule: onSchedule
      });
    }),
    _react2.default.createElement(
      _semanticUiReact.Grid,
      { className: 'foot' },
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { verticalAlign: 'middle' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { textAlign: 'center' },
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              fluid: true,
              onClick: onAdd,
              disabled: addButtonIsDisabled()
            },
            'Add Discount Package'
          )
        )
      )
    )
  );
});

var ProjectPricingTier = function (_Component) {
  _inherits(ProjectPricingTier, _Component);

  function ProjectPricingTier(props) {
    _classCallCheck(this, ProjectPricingTier);

    var _this = _possibleConstructorReturn(this, (ProjectPricingTier.__proto__ || Object.getPrototypeOf(ProjectPricingTier)).call(this, props));

    _initialiseProps.call(_this);

    var state = ProjectPricingTier.getPropsToState(props);
    _this.state = _extends({}, state, {
      deleteModalIsOpen: false,
      deleteItemName: '',
      deleteItemIndex: null,
      helpModalIsOpen: false,
      scheduleModalIsOpen: false,
      scheduleData: null,
      scheduleIndex: null
    });
    return _this;
  }

  _createClass(ProjectPricingTier, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = ProjectPricingTier.getPropsToState(nextProps);
      if (JSON.stringify(this.state.data) !== JSON.stringify(state.data)) {
        this.setState(_extends({}, state));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          data = _state.data,
          deleteItemName = _state.deleteItemName,
          deleteModalIsOpen = _state.deleteModalIsOpen,
          helpModalIsOpen = _state.helpModalIsOpen,
          scheduleModalIsOpen = _state.scheduleModalIsOpen,
          scheduleData = _state.scheduleData;
      var _props = this.props,
          defaultBumiProjectPricingID = _props.defaultBumiProjectPricingID,
          defaultProjectPricingID = _props.defaultProjectPricingID,
          onDefaultInputChange = _props.onDefaultInputChange;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { className: 'projectPricingTier' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(_TierPricingSchedule2.default, {
              data: scheduleData,
              onClose: this.handleOnScheduleClose,
              onConfirm: this.handleOnScheduleConfirm,
              open: scheduleModalIsOpen
            }),
            _react2.default.createElement(
              _semanticUiReact.Modal,
              { open: helpModalIsOpen, size: 'small' },
              _react2.default.createElement(_semanticUiReact.Header, { icon: 'help', content: 'Formula Help' }),
              _react2.default.createElement(
                _semanticUiReact.Modal.Content,
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  'Formula Operators & Syntax'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  _semanticUiReact.List,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.List.Item,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { size: 'small' },
                      '+'
                    ),
                    ' Addition.',
                    _react2.default.createElement('br', null)
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.List.Item,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { size: 'small' },
                      '-'
                    ),
                    ' Subtraction.',
                    _react2.default.createElement('br', null)
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.List.Item,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { size: 'small' },
                      '*'
                    ),
                    ' Multiplication.',
                    _react2.default.createElement('br', null)
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.List.Item,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { size: 'small' },
                      '/'
                    ),
                    ' Division.',
                    _react2.default.createElement('br', null)
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.List.Item,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { size: 'small' },
                      '.'
                    ),
                    ' Decimal point for cents.',
                    _react2.default.createElement('br', null)
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.List.Item,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { size: 'small' },
                      '('
                    ),
                    ' ',
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { size: 'small' },
                      ')'
                    ),
                    ' Parenthesis to control order of evaluation.',
                    _react2.default.createElement('br', null)
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.List.Item,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { size: 'small' },
                      'SPA_VALUE'
                    ),
                    ' or ',
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { size: 'small' },
                      'SELLING_PRICE'
                    ),
                    ' Selling price of unit.'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.List.Item,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { size: 'small' },
                      'ROUND(value)'
                    ),
                    ' Rounds cents to the nearest ones.'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.List.Item,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { size: 'small' },
                      'CEIL(value)'
                    ),
                    ' Rounds cents up to the nearest ones.'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.List.Item,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { size: 'small' },
                      'FLOOR(value)'
                    ),
                    ' Rounds cents down to the nearest ones.'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.List.Item,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { size: 'small' },
                      'PERCENT(value, percentage)'
                    ),
                    ' Get percent of value.'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.List.Item,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { size: 'small' },
                      'TIER("Tier Name")'
                    ),
                    ' Get value of another tier.'
                  )
                ),
                _react2.default.createElement(
                  'b',
                  null,
                  'Examples'
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  _semanticUiReact.List,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.List.Item,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { size: 'small' },
                      'SPA Value-3%-7%-2%-RM500'
                    ),
                    ' would be ',
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { color: 'grey', size: 'small' },
                      '(((SPA_VALUE*(1-0.03))*(1-0.07))*(1-0.02))-500'
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.List.Item,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { size: 'small' },
                      'RM250,000.00'
                    ),
                    ' would be ',
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { color: 'grey', size: 'small' },
                      '250000.00'
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Modal.Actions,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  { onClick: this.handleHelpModalClose },
                  'Close'
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Modal,
              { open: deleteModalIsOpen, basic: true, size: 'small' },
              _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: 'WARNING: Delete Confirmation' }),
              _react2.default.createElement(
                _semanticUiReact.Modal.Content,
                null,
                _react2.default.createElement(
                  'h4',
                  null,
                  'Are you sure you want to delete this discount package?',
                  deleteItemName ? ' (' + deleteItemName + ')' : ''
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  'This cannot be undone.'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Modal.Actions,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  { onClick: this.handleDeleteModalCancel },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove' }),
                  ' Cancel'
                ),
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  { negative: true, onClick: this.handleDeleteModalConfirm },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'trash' }),
                  ' Delete'
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Segment,
              { color: 'teal' },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { className: 'head' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'center' },
                    _react2.default.createElement(
                      'h3',
                      null,
                      'Discount Package Settings'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { widths: 'equal' },
                      _react2.default.createElement(_semanticUiReact.Form.Select, {
                        fluid: true,
                        label: 'Default Discount Package',
                        name: 'defaultProjectPricingID',
                        onChange: onDefaultInputChange,
                        options: this.getDefaultOptions(),
                        placeholder: 'Disabled',
                        search: true,
                        value: defaultProjectPricingID
                      }),
                      _react2.default.createElement(_semanticUiReact.Form.Select, {
                        fluid: true,
                        label: 'Default Bumi Discount Package',
                        name: 'defaultBumiProjectPricingID',
                        onChange: onDefaultInputChange,
                        options: this.getDefaultOptions(),
                        placeholder: 'Disabled',
                        search: true,
                        value: defaultBumiProjectPricingID
                      })
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
            _react2.default.createElement(SortableList, {
              addButtonIsDisabled: this.checkAddButtonDisabled,
              helperClass: 'projectPricingTier isSorting',
              helpModal: this.handleHelpModal,
              items: this.getSortedData(data),
              lockAxis: 'y',
              lockToContainerEdges: true,
              onAdd: this.handleOnAdd,
              onChange: this.handleOnChange,
              onDeleteItem: this.handleOnDelete,
              onSortEnd: this.onSortEnd,
              useDragHandle: true,
              onSchedule: this.handleOnSchedule
            })
          )
        )
      );
    }
  }]);

  return ProjectPricingTier;
}(_react.Component);

ProjectPricingTier.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  onDelete: _propTypes2.default.func.isRequired,
  onChangeData: _propTypes2.default.func.isRequired,
  onSaveData: _propTypes2.default.func.isRequired,
  onDefaultInputChange: _propTypes2.default.func.isRequired,
  defaultBumiProjectPricingID: _propTypes2.default.string.isRequired,
  defaultProjectPricingID: _propTypes2.default.string.isRequired
};
ProjectPricingTier.defaultValues = {
  id: '',
  position: 1,
  name: '',
  description: '',
  formulaPrice: ''
};

ProjectPricingTier.getPropsToState = function (props) {
  var data = props.data || [];
  return {
    data: data
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onSortEnd = function (_ref3) {
    var oldIndex = _ref3.oldIndex,
        newIndex = _ref3.newIndex;

    _this2.sortDataByIndex((0, _reactSortableHoc.arrayMove)(_this2.state.data, oldIndex, newIndex));
  };

  this.getDefaultOptions = function () {
    var data = _this2.props.data.filter(function (d) {
      return d.id !== '';
    }).sort(function (a, b) {
      return a.position - b.position;
    });
    var options = [{
      text: 'Disabled',
      value: ''
    }];
    data.forEach(function (d) {
      return options.push({
        text: d.name,
        value: d.id
      });
    });
    return options;
  };

  this.getSortedData = function (data) {
    return data.sort(function (a, b) {
      return a.position - b.position;
    });
  };

  this.sortDataByIndex = function (newData) {
    var data = newData;
    data.forEach(function (d, index) {
      data[index].position = index + 1;
    });
    _this2.setState({ data: data }, function () {
      return _this2.props.onChangeData(_this2.state.data);
    });
  };

  this.handleOnChange = function (e, data, index) {
    var newData = _this2.state.data;
    newData[index][data.name] = data.value;
    _this2.setState({ data: newData }, function () {
      return _this2.props.onChangeData(_this2.state.data);
    });
  };

  this.handleOnAdd = function (e) {
    e.preventDefault();
    var data = _this2.state.data;
    var lastID = data.length;
    var newItem = Object.assign({}, ProjectPricingTier.defaultValues);
    if (lastID > 0) {
      newItem.position = data[lastID - 1].position;
    }
    data.push(newItem);
    _this2.sortDataByIndex(data);
  };

  this.handleOnDelete = function (e, index) {
    e.preventDefault();
    var data = _this2.state.data;
    _this2.setState({
      deleteModalIsOpen: true,
      deleteItemName: data[index].name,
      deleteItemIndex: index
    });
  };

  this.handleDeleteModalConfirm = function () {
    var data = _this2.state.data;
    var deleteID = data[_this2.state.deleteItemIndex].id;
    if (deleteID !== '') {
      _this2.props.onDelete(deleteID);
    } else {
      data.splice(_this2.state.deleteItemIndex, 1);
      _this2.sortDataByIndex(data);
    }
    _this2.setState({
      deleteModalIsOpen: false,
      deleteItemName: '',
      deleteItemIndex: null
    });
  };

  this.handleDeleteModalCancel = function () {
    _this2.setState({
      deleteModalIsOpen: false,
      deleteItemName: '',
      deleteItemIndex: null
    });
  };

  this.handleHelpModal = function (e) {
    e.preventDefault();
    _this2.setState({
      helpModalIsOpen: true
    });
  };

  this.handleHelpModalClose = function () {
    _this2.setState({
      helpModalIsOpen: false
    });
  };

  this.handleOnSchedule = function (e, data, idx) {
    e.preventDefault();
    _this2.setState({
      scheduleModalIsOpen: true,
      scheduleData: data,
      scheduleIndex: idx
    });
  };

  this.handleOnScheduleConfirm = function (e, newData) {
    var _state2 = _this2.state,
        data = _state2.data,
        scheduleIndex = _state2.scheduleIndex;

    data[scheduleIndex] = newData;
    _this2.setState({
      scheduleModalIsOpen: false,
      scheduleData: null,
      scheduleIndex: null
    }, function () {
      _this2.props.onSaveData(data);
    });
  };

  this.handleOnScheduleClose = function () {
    _this2.setState({
      scheduleModalIsOpen: false,
      scheduleData: null,
      scheduleIndex: null
    });
  };

  this.checkAddButtonDisabled = function () {
    var blankCount = _this2.state.data.filter(function (d) {
      return d.name === '' || d.formulaPrice === '';
    }).length;
    if (blankCount > 0) {
      return true;
    }
    return false;
  };
};

exports.default = ProjectPricingTier;

/***/ }),
/* 2172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectUnitPackageFeeView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _reactSortableHoc = __webpack_require__(123);

var _ = __webpack_require__(1029);

var _Sortable = __webpack_require__(317);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _EditableBox = __webpack_require__(153);

var _EditableBox2 = _interopRequireDefault(_EditableBox);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

var _additional_fee = __webpack_require__(1084);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */


var ProjectUnitPackageFeeView = exports.ProjectUnitPackageFeeView = function ProjectUnitPackageFeeView(_ref) {
  var unitPackageFees = _ref.unitPackageFees,
      _ref$projectCurrencie = _ref.projectCurrencies,
      projectCurrencies = _ref$projectCurrencie === undefined ? [] : _ref$projectCurrencie,
      isPreviewing = _ref.isPreviewing,
      calculateFeePackage = _ref.calculateFeePackage;

  var items = [];

  var _useTranslation = (0, _reactI18next.useTranslation)(_translation.TRANSLATION_FILES.screens),
      t = _useTranslation.t;

  unitPackageFees.sort(function (a, b) {
    return a.orderPriority - b.orderPriority;
  }).forEach(function (d) {
    var formulas = [];

    var pupp = calculateFeePackage.find(function (data) {
      return data.id === d.id;
    });
    if (calculateFeePackage && pupp != null) {
      if (pupp.projectFeePackage.formulas) {
        formulas = [].concat(_toConsumableArray(pupp.projectFeePackage.formulas));
      }
    }

    var newItem = {
      isSPAValue: false,
      projectFeePackageID: d.projectFeePackageID,
      listPrice: d.listPrice,
      spaPrice: d.spaPrice,
      nettPrice: d.nettPrice,
      totalPrice: d.totalPrice,
      formulas: formulas
    };

    if (d.projectFeePackage) {
      var iDesc = d.projectFeePackage.description;
      if (iDesc.includes('\n')) {
        iDesc = iDesc.split('\n').map(function (desc, idx) {
          return _react2.default.createElement(
            'span',
            { key: idx },
            desc,
            _react2.default.createElement('br', null)
          );
        });
      }
      newItem.projectFeePackage = {
        name: d.projectFeePackage.name,
        description: iDesc
      };
    }
    items.push(newItem);
  });
  var renderApplyToBookingRemarks = function renderApplyToBookingRemarks(title, applyToBooking) {
    return _react2.default.createElement(
      'span',
      null,
      title,
      _react2.default.createElement(
        'span',
        { className: 'packagePricingApplyToBookingFlag', style: { color: applyToBooking ? 'green' : 'red' } },
        'Formula item will ',
        !applyToBooking && 'not',
        ' be applied onto the initial booking'
      )
    );
  };
  if (items.length <= 0) {
    return _react2.default.createElement(
      _semanticUiReact.Grid,
      { className: 'projectUnitPackagePricingView projectUnitPreview', textAlign: 'center' },
      t('No Additional Fees added'),
      '.'
    );
  }
  return _react2.default.createElement(
    _semanticUiReact.Grid,
    { className: 'projectUnitPackagePricingView projectUnitPreview', columns: 2 },
    isPreviewing ? items.map(function (data, idx) {
      var formulas = data.formulas && data.formulas.length > 0 ? data.formulas : [];

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { container: true, key: idx },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { columns: 16 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 8, textAlign: 'left' },
            _react2.default.createElement(
              'h3',
              null,
              data.projectFeePackage && data.projectFeePackage.name ? data.projectFeePackage.name : ''
            ),
            _react2.default.createElement(
              'small',
              null,
              data.projectFeePackage && data.projectFeePackage.description ? data.projectFeePackage.description : ''
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 8, textAlign: 'right' },
            _react2.default.createElement(
              'h3',
              null,
              _react2.default.createElement(_LoanAmount2.default, {
                projectCurrencies: projectCurrencies,
                format: '0,000,000.00',
                amount: data.totalPrice,
                prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
              })
            )
          )
        ),
        formulas.map(function (formula, key) {
          return _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 16, key: key },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 11 },
              _react2.default.createElement(
                'h5',
                null,
                formula && formula.name ? renderApplyToBookingRemarks(formula.name, formula.applyToBooking) : ''
              ),
              _react2.default.createElement(
                'small',
                null,
                formula && formula.description ? formula.description : ''
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 5 },
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'small',
                  null,
                  _react2.default.createElement(_semanticUiReact.Icon, { color: 'green', size: 'small', name: 'plus' })
                ),
                _react2.default.createElement(
                  'span',
                  {
                    className: 'div_inline_block text_add'
                  },
                  _react2.default.createElement(_LoanAmount2.default, {
                    projectCurrencies: projectCurrencies,
                    format: '0,000,000.00',
                    amount: formula.valueChange,
                    prefix: _react2.default.createElement(_CurrencySymbol2.default, null),
                    precise: false
                  })
                )
              )
            )
          );
        }),
        _react2.default.createElement(_semanticUiReact.Divider, null)
      );
    }) :
    // when preview button is not clicked only show packages with pricing
    items.map(function (data, idx) {
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { container: true, key: idx, className: 'singlePPItemRow' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 8, verticalAlign: 'middle', textAlign: 'right' },
            _react2.default.createElement(
              _semanticUiReact.Header,
              { as: 'h4', className: data.isSPAValue ? 'spaValue' : '' },
              data.projectFeePackage && data.projectFeePackage.name ? data.projectFeePackage.name : '',
              _react2.default.createElement(
                _semanticUiReact.Header.Subheader,
                null,
                data.projectFeePackage && data.projectFeePackage.description ? data.projectFeePackage.description : ''
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 8, verticalAlign: 'middle' },
            _react2.default.createElement(
              'h3',
              { className: data.isSPAValue ? 'spaValue' : '' },
              _react2.default.createElement(_LoanAmount2.default, {
                projectCurrencies: projectCurrencies,
                format: '0,000,000.00',
                amount: data.totalPrice,
                prefix: _react2.default.createElement(_CurrencySymbol2.default, null),
                precise: false
              })
            )
          )
        )
      );
    })
  );
};
ProjectUnitPackageFeeView.propTypes = {
  projectCurrencies: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  unitPackageFees: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  isPreviewing: _propTypes2.default.bool,
  calculateFeePackage: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired
};

var SortableItem = (0, _reactSortableHoc.SortableElement)(function (props) {
  return _react2.default.createElement(
    'div',
    { className: 'sortablehoc_item ' + (props.itemClass ? props.itemClass : '') },
    _react2.default.createElement(
      _semanticUiReact.Segment,
      { className: 'package_pricing_unit' },
      _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 2, tablet: 2, computer: 1 },
            _react2.default.createElement(_Sortable.SortableDragHandle, props)
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 11, tablet: 12, computer: 12 },
            _react2.default.createElement(_.UnitPackageFeeEdit, _extends({}, props, {
              data: props.value,
              feePackages: props.feePackages,
              onChange: props.onChange,
              refValidation: props.refValidation,
              refForm: props.refForm
            }))
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 3, tablet: 2, computer: 3, textAlign: 'right', style: { paddingLeft: '0' } },
            _react2.default.createElement(
              _semanticUiReact.Popup,
              {
                trigger: _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    basic: true,
                    style: { padding: '0.5em' }
                  },
                  _react2.default.createElement(_semanticUiReact.Icon, {
                    name: 'ellipsis horizontal',
                    rotated: 'clockwise',
                    style: { margin: '0 auto' }
                  })
                ),
                size: 'small',
                position: 'bottom right',
                flowing: true,
                hoverable: true,
                wide: true,
                className: 'popupUnitInfo'
              },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Menu,
                      { fluid: true, vertical: true, className: 'unitInfoPPpopupButton' },
                      _react2.default.createElement(
                        _semanticUiReact.Menu.Item,
                        { className: 'deleteUnitPackageFee' },
                        _react2.default.createElement(
                          _semanticUiReact.Button,
                          {
                            size: 'small',
                            basic: true,
                            onClick: function onClick() {
                              return props.onDelete(props.value);
                            }
                          },
                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'trash', color: 'red' }),
                          _react2.default.createElement(
                            'span',
                            null,
                            props.t('Delete', { ns: _translation.TRANSLATION_FILES.translation })
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  );
});

var ProjectUnitPackageFee = function (_Component) {
  _inherits(ProjectUnitPackageFee, _Component);

  function ProjectUnitPackageFee(props) {
    _classCallCheck(this, ProjectUnitPackageFee);

    var _this = _possibleConstructorReturn(this, (ProjectUnitPackageFee.__proto__ || Object.getPrototypeOf(ProjectUnitPackageFee)).call(this, props));

    _initialiseProps.call(_this);

    var state = ProjectUnitPackageFee.getPropsToState(props);
    _this.state = _extends({}, state, {
      editing: false,
      showDeleteConfirm: false,
      deleteIDX: null,
      deleteData: Object.assign({}, _additional_fee.PROJECT_UNIT_PACKAGE_FEE_DEFAULT),
      showPreview: false
    });
    _this.editRef = [];
    _this.formRef = {};
    return _this;
  }

  _createClass(ProjectUnitPackageFee, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = ProjectUnitPackageFee.getPropsToState(nextProps);
      if (JSON.stringify(this.state.data) !== JSON.stringify(state.data)) {
        this.setState(_extends({}, state));
      }
      if (JSON.stringify(this.state.calculateFeePackage) !== JSON.stringify(state.calculateFeePackage)) {
        this.setState({
          calculateFeePackage: state.calculateFeePackage
        });
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'deleteUnitPackageFee',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id, callBack) {
        var store, _props, projectID, unitID, res, message, _message;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _props = this.props, projectID = _props.projectID, unitID = _props.unitID;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + projectID + '/units/' + unitID + '/fee_packages/' + id + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 25;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);
                _context.next = 15;
                return this.setLoading(false);

              case 15:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                Bugsnag.notifyException(_context.t0);
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 24:
                return _context.abrupt('return');

              case 25:
                if (res.ok) {
                  _context.next = 33;
                  break;
                }

                _context.next = 28;
                return res.text();

              case 28:
                _message = _context.sent;
                _context.next = 31;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 31:
                _context.next = 35;
                break;

              case 33:
                _context.next = 35;
                return store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Delete Success', message: 'Unit additional fee package successfully deleted' }));

              case 35:
                _context.next = 37;
                return this.setLoading(false);

              case 37:
                if (callBack) callBack();

              case 38:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function deleteUnitPackageFee(_x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return deleteUnitPackageFee;
    }()
  }, {
    key: 'updateUnitPackageFees',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, _props2, projectID, unitID, data, res, message, _message2;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _props2 = this.props, projectID = _props2.projectID, unitID = _props2.unitID;
                data = this.state.data.filter(function (d) {
                  var newD = d;
                  newD.totalPrice = parseFloat(d.totalPrice);
                  return newD;
                });
                res = void 0;
                _context2.prev = 6;
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + projectID + '/units/' + unitID + '/fee_packages/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(data)
                }));

              case 9:
                res = _context2.sent;
                _context2.next = 26;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);
                _context2.next = 16;
                return this.setLoading(false);

              case 16:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 22;
                  break;
                }

                _context2.next = 19;
                return _context2.t0.res.text();

              case 19:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 22:
                Bugsnag.notifyException(_context2.t0);
                _context2.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 25:
                return _context2.abrupt('return');

              case 26:
                if (res.ok) {
                  _context2.next = 34;
                  break;
                }

                _context2.next = 29;
                return res.text();

              case 29:
                _message2 = _context2.sent;
                _context2.next = 32;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message2 }));

              case 32:
                _context2.next = 40;
                break;

              case 34:
                if (!this.props.newFetch) {
                  _context2.next = 37;
                  break;
                }

                _context2.next = 37;
                return this.props.newFetch();

              case 37:
                _context2.next = 39;
                return store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Update Success', message: 'Unit additional fee package successfully updated' }));

              case 39:
                if (this.props.handleResetCheck) this.props.handleResetCheck();

              case 40:
                _context2.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 12]]);
      }));

      function updateUnitPackageFees() {
        return _ref3.apply(this, arguments);
      }

      return updateUnitPackageFees;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          data = _state.data,
          loading = _state.loading,
          showDeleteConfirm = _state.showDeleteConfirm,
          showPreview = _state.showPreview,
          calculateFeePackage = _state.calculateFeePackage;
      var _props3 = this.props,
          projectCurrencies = _props3.projectCurrencies,
          hasEditAccess = _props3.hasEditAccess,
          hasPreviewPriceAccess = _props3.hasPreviewPriceAccess,
          t = _props3.t;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_DeleteConfirm2.default, {
          content: t('Are you sure you want to delete this unit additional fee package?'),
          onClose: this.handleCancelDelete,
          onConfirm: this.handleConfirmDelete,
          open: showDeleteConfirm
        }),
        _react2.default.createElement(_EditableBox2.default, {
          editable: hasEditAccess,
          isEditing: this.state.editing,
          loading: loading,
          onCancel: this.handleResetEditing,
          onClick: this.handleUpdate,
          onEdit: this.handleEditing,
          showPreview: showPreview,
          content: function content(_ref4) {
            var isEditing = _ref4.isEditing;
            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { style: { zIndex: 20 }, active: _this3.state.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              hasPreviewPriceAccess && data && data.length > 0 ? _react2.default.createElement(_semanticUiReact.Button, {
                as: 'button',
                attached: 'top',
                style: {
                  background: showPreview ? '#eae8e8' : 'none',
                  top: hasEditAccess ? '-2.5em' : '0',
                  borderRadius: '0.2em',
                  paddingRight: '1.5em',
                  display: isEditing ? 'none' : 'inline-block',
                  marginBottom: hasEditAccess ? '0' : '2em'
                },
                content: t(showPreview ? 'Close' : 'Preview Fee Breakdown', { ns: showPreview && _translation.TRANSLATION_FILES.translation }),
                icon: showPreview ? 'close' : 'eye',
                size: 'tiny',
                onClick: _this3.handleTogglePreview
              }) : null,
              isEditing ? _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    data.length > 0 ? _react2.default.createElement(_Sortable.SortableContainer, {
                      isSortMode: true,
                      iconColor: 'blue',
                      helperClass: 'sorting',
                      data: data,
                      lockAxis: 'y',
                      lockToContainerEdges: true,
                      onSortEnd: _this3.onSortEnd,
                      useDragHandle: true,
                      item: function item(props) {
                        return _react2.default.createElement(SortableItem, _extends({}, props, {
                          onChange: function onChange(d) {
                            return _this3.handleOnChange(d, props.idx);
                          },
                          onDelete: function onDelete(d) {
                            return _this3.handleDelete(d, props.idx);
                          },
                          refForm: _this3.setRefForm,
                          refValidation: function refValidation(ref) {
                            return _this3.setRefValidation(ref, props.idx);
                          },
                          feePackages: _this3.getFeePackages,
                          t: t
                        }));
                      }
                    }) : _react2.default.createElement(
                      _semanticUiReact.Segment,
                      { className: 'segment_unit_pricing_package_not_found', textAlign: 'center' },
                      t('No unit additional fee package found')
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { textAlign: 'center' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    _react2.default.createElement(
                      _semanticUiReact.Button,
                      {
                        basic: true,
                        onClick: _this3.handleAdd
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'add circle', color: 'green' }),
                      ' ',
                      t('Add additional fee package')
                    )
                  )
                )
              ) : _react2.default.createElement(ProjectUnitPackageFeeView, {
                unitPackageFees: data,
                projectCurrencies: projectCurrencies,
                isPreviewing: showPreview,
                calculateFeePackage: calculateFeePackage
              })
            );
          }
        })
      );
    }
  }]);

  return ProjectUnitPackageFee;
}(_react.Component);

ProjectUnitPackageFee.contextTypes = {
  store: _propTypes2.default.object
};
ProjectUnitPackageFee.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  handleCheckChanges: _propTypes2.default.func,
  handleResetCheck: _propTypes2.default.func,
  hasEditAccess: _propTypes2.default.bool,
  hasPreviewPriceAccess: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  newFetch: _propTypes2.default.func,
  feePackages: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  projectCurrencies: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  projectID: _propTypes2.default.string,
  unitID: _propTypes2.default.string,
  spaValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  token: _propTypes2.default.string,
  calculateFeePackage: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  t: _propTypes2.default.func
};

ProjectUnitPackageFee.getPropsToState = function (props) {
  var data = props.data || [];
  var loading = props.loading;
  var feePackages = props.feePackages || [];
  var calculateFeePackage = props.calculateFeePackage || [];
  var token = props.token || '';

  return {
    data: data,
    oriData: (0, _clone2.default)(data),
    loading: loading,
    feePackages: feePackages,
    calculateFeePackage: calculateFeePackage,
    token: token
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onSortEnd = function (_ref5) {
    var oldIndex = _ref5.oldIndex,
        newIndex = _ref5.newIndex;

    var data = _this4.sortDataByIndex((0, _reactSortableHoc.arrayMove)(_this4.state.data, oldIndex, newIndex));
    _this4.setState({ data: data }, function () {
      if (_this4.props.handleCheckChanges) _this4.props.handleCheckChanges();
    });
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this4.setState({ loading: loading }, function () {
        res(loading);
      });
    });
  };

  this.getFeePackages = function () {
    var data = _this4.state.data;

    var feePackages = _this4.state.feePackages.filter(function (p) {
      return !data.find(function (d) {
        return d.id !== '' && d.projectFeePackageID === p.id;
      });
    }).sort(function (a, b) {
      return a.orderPriority - b.orderPriority;
    });
    var options = [];
    feePackages.forEach(function (p) {
      var newItem = {
        text: p.name,
        value: p.id
      };
      // disabled the option once selected
      var selectedItem = data.find(function (d) {
        return d.projectFeePackageID === p.id;
      });
      if (selectedItem) newItem.disabled = true;
      options.push(newItem);
    });
    return options;
  };

  this.setRefValidation = function (ref, idx) {
    if (ref && ref.props && ref.props.name) {
      if (!_this4.editRef[idx]) _this4.editRef[idx] = {};
      _this4.editRef[idx][ref.props.name] = ref;
    }
  };

  this.setRefForm = function (ref) {
    _this4.formRef = ref;
  };

  this.sortDataByIndex = function (newData) {
    var data = newData;
    data.forEach(function (d, index) {
      data[index].orderPriority = index + 1;
    });
    return data;
  };

  this.asyncForEach = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(array, callback) {
      var index;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              index = 0;

            case 1:
              if (!(index < array.length)) {
                _context3.next = 7;
                break;
              }

              _context3.next = 4;
              return callback(array[index], index, array);

            case 4:
              index += 1;
              _context3.next = 1;
              break;

            case 7:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }));

    return function (_x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }();

  this.handleEditing = function () {
    _this4.setState({ editing: true });
  };

  this.handleResetEditing = function () {
    if (_this4.props.handleResetCheck) _this4.props.handleResetCheck();
    _this4.setState({
      editing: false
    }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(JSON.stringify(_this4.state.data) !== JSON.stringify(_this4.props.data))) {
                _context4.next = 4;
                break;
              }

              if (!_this4.props.newFetch) {
                _context4.next = 4;
                break;
              }

              _context4.next = 4;
              return _this4.props.newFetch();

            case 4:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    })));
  };

  this.handleUpdate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
    var store, data, hasError;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!(JSON.stringify(_this4.state.data) === JSON.stringify(_this4.state.oriData))) {
              _context6.next = 4;
              break;
            }

            _context6.next = 3;
            return _this4.setComponentState({ editing: false });

          case 3:
            return _context6.abrupt('return');

          case 4:
            store = _this4.context.store;
            data = _this4.state.data;
            hasError = false;
            _context6.next = 9;
            return _this4.asyncForEach(data, function () {
              var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(d, idx) {
                var validations, errMessages;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!(_this4.editRef[idx] && !hasError)) {
                          _context5.next = 9;
                          break;
                        }

                        _context5.next = 3;
                        return _AppForm2.default.validate(_this4.editRef[idx], data[idx]);

                      case 3:
                        validations = _context5.sent;
                        errMessages = validations.filter(function (v) {
                          return !v.isValid;
                        });

                        if (!(errMessages.length > 0)) {
                          _context5.next = 9;
                          break;
                        }

                        hasError = true;
                        _context5.next = 9;
                        return store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errMessages.map(function (l) {
                            return l.message;
                          }) }));

                      case 9:
                      case 'end':
                        return _context5.stop();
                    }
                  }
                }, _callee5, _this4);
              }));

              return function (_x7, _x8) {
                return _ref9.apply(this, arguments);
              };
            }());

          case 9:
            if (hasError) {
              _context6.next = 14;
              break;
            }

            _context6.next = 12;
            return _this4.updateUnitPackageFees();

          case 12:
            _context6.next = 14;
            return _this4.setComponentState({ editing: false });

          case 14:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this4);
  }));

  this.handleOnChange = function (d, idx) {
    var data = _this4.state.data;

    var newData = [];
    data.forEach(function (item, i) {
      if (i === idx) {
        newData.push(d);
      } else {
        newData.push(item);
      }
    });
    _this4.setState({ data: newData }, function () {
      if (_this4.editRef[idx]) _AppForm2.default.validate(_this4.editRef[idx], newData[idx]);
      if (_this4.props.handleCheckChanges) _this4.props.handleCheckChanges();
    });
  };

  this.handleDelete = function (d, idx) {
    _this4.setState({
      showDeleteConfirm: true,
      deleteIDX: idx,
      deleteData: d
    });
  };

  this.handleCancelDelete = function (e) {
    e.preventDefault();
    _this4.setState({
      showDeleteConfirm: false,
      deleteIDX: null,
      deleteData: Object.assign({}, _additional_fee.PROJECT_UNIT_PACKAGE_FEE_DEFAULT)
    });
  };

  this.handleConfirmDelete = function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(e) {
      var deleteData;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              e.preventDefault();
              deleteData = _this4.state.deleteData;

              if (!(deleteData.id !== '')) {
                _context7.next = 7;
                break;
              }

              _context7.next = 5;
              return _this4.deleteUnitPackageFee(deleteData.id, function () {
                _this4.confirmDelete();
              });

            case 5:
              _context7.next = 8;
              break;

            case 7:
              _this4.confirmDelete();

            case 8:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this4);
    }));

    return function (_x9) {
      return _ref10.apply(this, arguments);
    };
  }();

  this.confirmDelete = function () {
    var _state2 = _this4.state,
        data = _state2.data,
        deleteIDX = _state2.deleteIDX;

    var newData = [];
    data.forEach(function (item, i) {
      if (i !== deleteIDX) {
        newData.push(item);
      }
    });
    _this4.setState({
      data: _this4.sortDataByIndex(newData),
      deleteData: Object.assign({}, _additional_fee.PROJECT_UNIT_PACKAGE_FEE_DEFAULT),
      deleteIDX: null,
      showDeleteConfirm: false
    }, function () {
      if (_this4.props.handleCheckChanges) _this4.props.handleCheckChanges();
    });
  };

  this.handleAdd = function (e) {
    e.preventDefault();
    var data = _this4.state.data;
    var _props4 = _this4.props,
        projectID = _props4.projectID,
        unitID = _props4.unitID;

    var newItem = (0, _clone2.default)(Object.assign({}, _additional_fee.PROJECT_UNIT_PACKAGE_FEE_DEFAULT, {
      orderPriority: data.length + 1,
      projectID: projectID,
      projectUnitID: unitID
    }));
    data.push(newItem);
    _this4.setState({ data: data }, function () {
      if (_this4.props.handleCheckChanges) _this4.props.handleCheckChanges();
    });
  };

  this.handleTogglePreview = function (e) {
    e.preventDefault();
    _this4.setState(function (prevState) {
      return {
        showPreview: !prevState.showPreview
      };
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(ProjectUnitPackageFee);

/***/ }),
/* 2173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _additional_fee = __webpack_require__(1084);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-nested-ternary */
/* eslint-disable max-len */


var UnitPackageFeeEdit = function (_Component) {
  _inherits(UnitPackageFeeEdit, _Component);

  function UnitPackageFeeEdit() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UnitPackageFeeEdit);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UnitPackageFeeEdit.__proto__ || Object.getPrototypeOf(UnitPackageFeeEdit)).call.apply(_ref, [this].concat(args))), _this), _this.handleSave = function (e) {
      if (e) e.preventDefault();
      var data = _this.props.data;

      if (_this.props.onChange) _this.props.onChange(data);
    }, _this.handleInputChange = function (e, d) {
      var data = _this.props.data;

      data[d.name] = d.value;
      if (_this.props.onChange) _this.props.onChange(data);
    }, _this.handleCheckboxChange = function (e, d) {
      var data = _this.props.data;

      data[d.name] = !data[d.name];
      if (data[d.name]) {
        if (data.id === '') data.projectFeePackageID = '';
        data.totalPrice = '';
      }
      if (_this.props.onChange) _this.props.onChange(data);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UnitPackageFeeEdit, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          t = _props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _AppForm2.default,
              {
                as: 'div',
                onSubmit: this.handleSave,
                ref: this.props.refForm
              },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { verticalAlign: 'middle', className: 'row_enable_package_custom_price' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { mobile: 16, tablet: 12, computer: 13 },
                    data.id !== '' && data.projectFeePackageID !== '' ? _react2.default.createElement(
                      'span',
                      null,
                      _react2.default.createElement(
                        'span',
                        { className: 'text_name' },
                        data.projectFeePackage.name,
                        data.projectFeePackage.description !== '' ? ': ' : ''
                      ),
                      data.projectFeePackage.description !== '' ? _react2.default.createElement(
                        'span',
                        { className: 'text_description' },
                        data.projectFeePackage.description
                      ) : ''
                    ) : '',
                    _react2.default.createElement(
                      _AppForm2.default.Validate,
                      {
                        name: 'projectFeePackageID',
                        onChange: this.handleInputChange,
                        ref: this.props.refValidation,
                        validateLabel: t('Additional Fee Package'),
                        validation: data.id === '' ? [_webValidations.required] : null,
                        style: data.id === '' ? {} : { display: 'none' }
                      },
                      _react2.default.createElement(_semanticUiReact.Form.Select, {
                        fluid: true,
                        name: 'projectFeePackageID',
                        options: this.props.feePackages(),
                        placeholder: t('Select Additional Fee Package'),
                        search: true,
                        selectOnBlur: true,
                        value: data.projectFeePackageID
                      })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return UnitPackageFeeEdit;
}(_react.Component);

UnitPackageFeeEdit.propTypes = {
  data: _propTypes2.default.shape(),
  onChange: _propTypes2.default.func,
  feePackages: _propTypes2.default.func,
  refForm: _propTypes2.default.func,
  refValidation: _propTypes2.default.func,
  t: _propTypes2.default.func
};
UnitPackageFeeEdit.defaultProps = {
  data: Object.assign({}, _additional_fee.PROJECT_UNIT_PACKAGE_FEE_DEFAULT)
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(UnitPackageFeeEdit);

/***/ }),
/* 2174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectUnitPackagePricingView = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _reactSortableHoc = __webpack_require__(123);

var _ = __webpack_require__(566);

var _Sortable = __webpack_require__(317);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _EditableBox = __webpack_require__(153);

var _EditableBox2 = _interopRequireDefault(_EditableBox);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

var _package_pricing = __webpack_require__(222);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _storage = __webpack_require__(44);

var _translation = __webpack_require__(4);

var _QuotationPackageSelection = __webpack_require__(2177);

var _QuotationPackageSelection2 = _interopRequireDefault(_QuotationPackageSelection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */


var ProjectUnitPackagePricingView = exports.ProjectUnitPackagePricingView = function ProjectUnitPackagePricingView(_ref) {
  var unitPackagePricings = _ref.unitPackagePricings,
      spaValue = _ref.spaValue,
      _ref$projectCurrencie = _ref.projectCurrencies,
      projectCurrencies = _ref$projectCurrencie === undefined ? [] : _ref$projectCurrencie,
      isPreviewing = _ref.isPreviewing,
      calculatePackagePricing = _ref.calculatePackagePricing,
      sellingPriceCustomName = _ref.sellingPriceCustomName,
      t = _ref.t;

  var items = [{
    listPrice: spaValue,
    spaPrice: spaValue,
    totalPrice: spaValue,
    projectPackagePricing: {
      name: sellingPriceCustomName || t('Selling Price'),
      description: t('Unit Base Selling Price')
    },
    isSPAValue: true
  }];

  unitPackagePricings.sort(function (a, b) {
    return a.orderPriority - b.orderPriority;
  }).forEach(function (d) {
    var calculations = [];

    if (calculatePackagePricing && calculatePackagePricing.some(function (data) {
      return data.id === d.id;
    })) {
      var pupp = calculatePackagePricing.find(function (data) {
        return data.id === d.id;
      });
      if (!pupp.isCustomPrice && pupp.projectPackagePricing.packagePricingCalculations) {
        calculations = [].concat(_toConsumableArray(pupp.projectPackagePricing.packagePricingCalculations));
      }
    }

    var newItem = {
      customDescription: d.customDescription,
      customName: d.customName,
      isCustomPrice: d.isCustomPrice,
      isSPAValue: false,
      projectPackagePricingID: d.projectPackagePricingID,
      listPrice: d.listPrice,
      spaPrice: d.spaPrice,
      totalPrice: d.totalPrice,
      packagePricingCalculations: calculations
    };

    if (d.projectPackagePricing) {
      var iDesc = d.projectPackagePricing.description;
      if (iDesc.includes('\n')) {
        iDesc = iDesc.split('\n').map(function (desc, idx) {
          return _react2.default.createElement(
            'span',
            { key: idx },
            desc,
            _react2.default.createElement('br', null)
          );
        });
      }
      newItem.projectPackagePricing = {
        name: d.projectPackagePricing.name,
        description: iDesc
      };
    }
    items.push(newItem);
  });
  var renderFormulaChangeClass = function renderFormulaChangeClass(type) {
    if (type.includes('deduct')) {
      return 'text_deduct';
    }
    if (type.includes('add')) {
      return 'text_add';
    }
    return '';
  };
  var renderFormulaChangePrefix = function renderFormulaChangePrefix(type) {
    if (type.includes('deduct')) {
      return _react2.default.createElement(_semanticUiReact.Icon, { color: 'red', size: 'small', name: 'minus' });
    }
    if (type.includes('add')) {
      return _react2.default.createElement(_semanticUiReact.Icon, { color: 'green', size: 'small', name: 'plus' });
    }
    return '';
  };
  var customFormulaPrefix = function customFormulaPrefix(unitSpaValue, packageTotalPrice) {
    if (unitSpaValue < packageTotalPrice) {
      return 'custom_formula_add';
    } else if (unitSpaValue > packageTotalPrice) {
      return 'custom_formula_deduct';
    }
    return '';
  };
  var renderApplyToBookingRemarks = function renderApplyToBookingRemarks(title, applyToBooking) {
    return _react2.default.createElement(
      'span',
      null,
      title,
      _react2.default.createElement(
        'span',
        { className: 'packagePricingApplyToBookingFlag', style: { color: applyToBooking ? 'green' : 'red' } },
        t('Formula item will' + (!applyToBooking ? ' not' : '') + ' be applied onto the initial booking')
      )
    );
  };
  return _react2.default.createElement(
    _semanticUiReact.Grid,
    { className: 'projectUnitPackagePricingView projectUnitPreview', columns: 2 },
    isPreviewing ? items.map(function (data, idx) {
      if (data.isCustomPrice) {
        // render section for base selling price
        return _react2.default.createElement(
          _semanticUiReact.Grid,
          { container: true, key: idx },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8, textAlign: 'left' },
              _react2.default.createElement(
                'h3',
                null,
                data.customName || '',
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'small', pointing: 'left', style: { marginLeft: '1em' } },
                  t('Custom')
                )
              ),
              _react2.default.createElement(
                'small',
                null,
                data.customDescription || ''
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8, textAlign: 'right' },
              _react2.default.createElement(
                'h3',
                null,
                _react2.default.createElement(_LoanAmount2.default, {
                  projectCurrencies: projectCurrencies,
                  format: '0,000,000.00',
                  amount: data.totalPrice,
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null),
                  precise: false
                })
              )
            )
          ),
          _react2.default.createElement(_semanticUiReact.Divider, null)
        );
      }

      var listCalculations = data.packagePricingCalculations && data.packagePricingCalculations.length > 0 ? data.packagePricingCalculations.filter(function (ppc) {
        return ppc.category === 'list_price';
      }) : [];
      var spaCalculations = data.packagePricingCalculations && data.packagePricingCalculations.length > 0 ? data.packagePricingCalculations.filter(function (ppc) {
        return ppc.category === 'spa_price';
      }) : [];

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { container: true, key: idx },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { columns: 16 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 8, textAlign: 'left' },
            _react2.default.createElement(
              'h3',
              null,
              data.projectPackagePricingID !== '' ? data.projectPackagePricing && data.projectPackagePricing.name ? data.projectPackagePricing.name : '' : ''
            ),
            _react2.default.createElement(
              'small',
              null,
              data.projectPackagePricingID !== '' ? data.projectPackagePricing && data.projectPackagePricing.description ? data.projectPackagePricing.description : '' : ''
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 8, textAlign: 'right' },
            _react2.default.createElement(
              'h3',
              null,
              _react2.default.createElement(_LoanAmount2.default, {
                projectCurrencies: projectCurrencies,
                format: '0,000,000.00',
                amount: data.totalPrice,
                prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
              })
            )
          )
        ),
        !data.isSPAValue && _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { columns: 16 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'left', width: 8 },
            _react2.default.createElement(
              'h4',
              null,
              t('Unit Base Selling Price')
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right', width: 8 },
            _react2.default.createElement(
              'h4',
              null,
              _react2.default.createElement(_LoanAmount2.default, {
                projectCurrencies: projectCurrencies,
                format: '0,000,000.00',
                amount: data.listPrice,
                prefix: _react2.default.createElement(_CurrencySymbol2.default, null),
                precise: false
              })
            )
          )
        ),
        listCalculations.map(function (ppc, key) {
          var customFormulaType = customFormulaPrefix(spaValue, data.totalPrice);
          var customFormulaCalculationType = ppc.projectPackagePricingItem.calculationType === 'custom_formula' ? customFormulaType : ppc.projectPackagePricingItem.calculationType;
          return _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 16, key: key },
            ppc.isSubTotal ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 11 },
              _react2.default.createElement(
                'h5',
                null,
                t('Sub Total')
              )
            ) : _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 11 },
              _react2.default.createElement(
                'h5',
                null,
                ppc && ppc.projectPackagePricingItem && ppc.projectPackagePricingItem.name ? renderApplyToBookingRemarks(ppc.projectPackagePricingItem.name, ppc.applyToBooking) : ''
              ),
              _react2.default.createElement(
                'small',
                null,
                ppc && ppc.projectPackagePricingItem && ppc.projectPackagePricingItem.description ? ppc.projectPackagePricingItem.description : ''
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 5 },
              _react2.default.createElement(_LoanAmount2.default, {
                projectCurrencies: projectCurrencies,
                format: '0,000,000.00',
                amount: ppc.newValue,
                prefix: _react2.default.createElement(_CurrencySymbol2.default, null),
                precise: false
              }),
              _react2.default.createElement(
                'small',
                null,
                !ppc.isSubTotal && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'small',
                    null,
                    renderFormulaChangePrefix(customFormulaCalculationType)
                  ),
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'div_inline_block ' + renderFormulaChangeClass(customFormulaCalculationType)
                    },
                    _react2.default.createElement(_LoanAmount2.default, {
                      projectCurrencies: projectCurrencies,
                      format: '0,000,000.00',
                      amount: ppc.valueChange,
                      prefix: _react2.default.createElement(_CurrencySymbol2.default, null),
                      precise: false
                    })
                  )
                )
              )
            )
          );
        }),
        !data.isSPAValue && _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { columns: 16 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'left', width: 8 },
            _react2.default.createElement(
              'h4',
              null,
              t('Total Selling Price SPA')
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right', width: 8 },
            _react2.default.createElement(
              'h4',
              null,
              _react2.default.createElement(_LoanAmount2.default, {
                projectCurrencies: projectCurrencies,
                format: '0,000,000.00',
                amount: data.spaPrice,
                prefix: _react2.default.createElement(_CurrencySymbol2.default, null),
                precise: false
              })
            )
          )
        ),
        spaCalculations.map(function (ppc, key) {
          var customFormulaType = customFormulaPrefix(spaValue, data.totalPrice);
          var customFormulaCalculationType = ppc.projectPackagePricingItem.calculationType === 'custom_formula' ? customFormulaType : ppc.projectPackagePricingItem.calculationType;
          return _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 16, key: key },
            ppc.isSubTotal ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 11 },
              _react2.default.createElement(
                'h5',
                null,
                t('Sub Total')
              )
            ) : _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 11 },
              _react2.default.createElement(
                'h5',
                null,
                ppc && ppc.projectPackagePricingItem && ppc.projectPackagePricingItem.name ? renderApplyToBookingRemarks(ppc.projectPackagePricingItem.name, ppc.applyToBooking) : ''
              ),
              _react2.default.createElement(
                'small',
                null,
                ppc && ppc.projectPackagePricingItem && ppc.projectPackagePricingItem.description ? ppc.projectPackagePricingItem.description : ''
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 5 },
              _react2.default.createElement(_LoanAmount2.default, {
                projectCurrencies: projectCurrencies,
                format: '0,000,000.00',
                amount: ppc.newValue,
                prefix: _react2.default.createElement(_CurrencySymbol2.default, null),
                precise: false
              }),
              _react2.default.createElement(
                'small',
                null,
                !ppc.isSubTotal && _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'small',
                    null,
                    renderFormulaChangePrefix(customFormulaCalculationType)
                  ),
                  _react2.default.createElement(
                    'span',
                    {
                      className: 'div_inline_block ' + renderFormulaChangeClass(customFormulaCalculationType)
                    },
                    _react2.default.createElement(_LoanAmount2.default, {
                      projectCurrencies: projectCurrencies,
                      format: '0,000,000.00',
                      amount: ppc.valueChange,
                      prefix: _react2.default.createElement(_CurrencySymbol2.default, null),
                      precise: false
                    })
                  )
                )
              )
            )
          );
        }),
        _react2.default.createElement(_semanticUiReact.Divider, null)
      );
    }) :
    // when preview button is not clicked only show packages with pricing
    items.map(function (data, idx) {
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { container: true, key: idx, className: 'singlePPItemRow' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 8, verticalAlign: 'middle', textAlign: 'right' },
            _react2.default.createElement(
              _semanticUiReact.Header,
              { as: 'h4', className: data.isSPAValue ? 'spaValue' : '' },
              data.projectPackagePricingID !== '' ? data.projectPackagePricing && data.projectPackagePricing.name ? data.projectPackagePricing.name : '' : data.customName || '',
              _react2.default.createElement(
                _semanticUiReact.Header.Subheader,
                null,
                data.projectPackagePricingID !== '' ? data.projectPackagePricing && data.projectPackagePricing.description ? data.projectPackagePricing.description : '' : data.customDescription || ''
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 8, verticalAlign: 'middle' },
            _react2.default.createElement(
              'h3',
              { className: data.isSPAValue ? 'spaValue' : '' },
              _react2.default.createElement(_LoanAmount2.default, {
                projectCurrencies: projectCurrencies,
                format: '0,000,000.00',
                amount: data.totalPrice,
                prefix: _react2.default.createElement(_CurrencySymbol2.default, null),
                precise: false
              })
            )
          )
        )
      );
    })
  );
};
ProjectUnitPackagePricingView.propTypes = {
  projectCurrencies: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  unitPackagePricings: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  spaValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  isPreviewing: _propTypes2.default.bool,
  calculatePackagePricing: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  sellingPriceCustomName: _propTypes2.default.string,
  t: _propTypes2.default.func
};

var SortableItem = (0, _reactSortableHoc.SortableElement)(function (props) {
  return _react2.default.createElement(
    'div',
    { className: 'sortablehoc_item ' + (props.itemClass ? props.itemClass : '') },
    _react2.default.createElement(
      _semanticUiReact.Segment,
      { className: 'package_pricing_unit' },
      _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 2, tablet: 2, computer: 1 },
            _react2.default.createElement(_Sortable.SortableDragHandle, props)
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 11, tablet: 12, computer: 12 },
            _react2.default.createElement(_.UnitPackagePricingEdit, _extends({}, props, {
              data: props.value,
              packagePricings: props.packagePricings,
              onChange: props.onChange,
              refValidation: props.refValidation,
              refForm: props.refForm
            }))
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 3, tablet: 2, computer: 3, textAlign: 'right', style: { paddingLeft: '0' } },
            _react2.default.createElement(
              _semanticUiReact.Popup,
              {
                trigger: _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    basic: true,
                    style: { padding: '0.5em' }
                  },
                  _react2.default.createElement(_semanticUiReact.Icon, {
                    name: 'ellipsis horizontal',
                    rotated: 'clockwise',
                    style: { margin: '0 auto' }
                  })
                ),
                size: 'small',
                position: 'bottom right',
                flowing: true,
                hoverable: true,
                wide: true,
                className: 'popupUnitInfo'
              },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Menu,
                      { fluid: true, vertical: true, className: 'unitInfoPPpopupButton' },
                      _react2.default.createElement(
                        _semanticUiReact.Menu.Item,
                        null,
                        _react2.default.createElement(
                          'small',
                          null,
                          props.t('Visible in')
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Menu.Item,
                        null,
                        _react2.default.createElement(
                          'span',
                          null,
                          props.t('Marketplace')
                        ),
                        _react2.default.createElement(_semanticUiReact.Checkbox, {
                          fitted: true,
                          toggle: true,
                          name: 'MP',
                          checked: props.value.accessibleIn ? !!props.value.accessibleIn.includes('MP') : false,
                          onClick: function onClick(e, data) {
                            return props.onVisibilityChange(data, props.value, 'accessibleIn');
                          }
                        })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Menu.Item,
                        null,
                        _react2.default.createElement(
                          'span',
                          null,
                          props.t('Showroom for buyers')
                        ),
                        _react2.default.createElement(_semanticUiReact.Checkbox, {
                          fitted: true,
                          toggle: true,
                          name: 'SRB',
                          checked: props.value.accessibleIn ? !!props.value.accessibleIn.includes('SRB') : false,
                          onClick: function onClick(e, data) {
                            return props.onVisibilityChange(data, props.value, 'accessibleIn');
                          }
                        })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Menu.Item,
                        { className: 'deleteUnitPackagePricing' },
                        _react2.default.createElement(
                          _semanticUiReact.Button,
                          {
                            size: 'small',
                            basic: true,
                            onClick: function onClick() {
                              return props.onDelete(props.value);
                            }
                          },
                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'trash', color: 'red' }),
                          _react2.default.createElement(
                            'span',
                            null,
                            props.t('Delete', { ns: _translation.TRANSLATION_FILES.translation })
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      )
    )
  );
});

var ProjectUnitPackagePricing = function (_Component) {
  _inherits(ProjectUnitPackagePricing, _Component);

  function ProjectUnitPackagePricing(props) {
    _classCallCheck(this, ProjectUnitPackagePricing);

    var _this = _possibleConstructorReturn(this, (ProjectUnitPackagePricing.__proto__ || Object.getPrototypeOf(ProjectUnitPackagePricing)).call(this, props));

    _initialiseProps.call(_this);

    var state = ProjectUnitPackagePricing.getPropsToState(props);
    _this.state = _extends({}, state, {
      editing: false,
      showDeleteConfirm: false,
      deleteIDX: null,
      deleteData: Object.assign({}, _package_pricing.PROJECT_UNIT_PACKAGE_PRICING_DEFAULT),
      showPreview: false
    });
    _this.editRef = [];
    _this.formRef = {};
    return _this;
  }

  _createClass(ProjectUnitPackagePricing, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = ProjectUnitPackagePricing.getPropsToState(nextProps);
      if (JSON.stringify(this.state.data) !== JSON.stringify(state.data)) {
        this.setState(_extends({}, state));
      }
      if (JSON.stringify(this.state.calculatePackagePricing) !== JSON.stringify(state.calculatePackagePricing)) {
        this.setState({
          calculatePackagePricing: state.calculatePackagePricing
        });
      }
      if (this.state.showQuotationOpts !== state.showQuotationOpts) {
        this.setState({ showQuotationOpts: state.showQuotationOpts });
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'deleteUnitPackagePricing',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id, callBack) {
        var store, _props, projectID, unitID, t, res, message, _message;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _props = this.props, projectID = _props.projectID, unitID = _props.unitID, t = _props.t;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + projectID + '/units/' + unitID + '/package_pricings/' + id + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 25;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);
                _context.next = 15;
                return this.setLoading(false);

              case 15:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                Bugsnag.notifyException(_context.t0);
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 24:
                return _context.abrupt('return');

              case 25:
                if (res.ok) {
                  _context.next = 33;
                  break;
                }

                _context.next = 28;
                return res.text();

              case 28:
                _message = _context.sent;
                _context.next = 31;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 31:
                _context.next = 35;
                break;

              case 33:
                _context.next = 35;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Unit pricing package successfully deleted', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 35:
                _context.next = 37;
                return this.setLoading(false);

              case 37:
                if (callBack) callBack();

              case 38:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function deleteUnitPackagePricing(_x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return deleteUnitPackagePricing;
    }()
  }, {
    key: 'updateUnitPackagePricings',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, _props2, projectID, unitID, t, data, res, message, _message2;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _props2 = this.props, projectID = _props2.projectID, unitID = _props2.unitID, t = _props2.t;
                data = this.state.data.filter(function (d) {
                  var newD = d;
                  newD.totalPrice = parseFloat(d.totalPrice);
                  return newD;
                });
                res = void 0;
                _context2.prev = 6;
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + projectID + '/units/' + unitID + '/package_pricings/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(data)
                }));

              case 9:
                res = _context2.sent;
                _context2.next = 26;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);
                _context2.next = 16;
                return this.setLoading(false);

              case 16:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 22;
                  break;
                }

                _context2.next = 19;
                return _context2.t0.res.text();

              case 19:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 22:
                Bugsnag.notifyException(_context2.t0);
                _context2.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 25:
                return _context2.abrupt('return');

              case 26:
                if (res.ok) {
                  _context2.next = 34;
                  break;
                }

                _context2.next = 29;
                return res.text();

              case 29:
                _message2 = _context2.sent;
                _context2.next = 32;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message2 }));

              case 32:
                _context2.next = 40;
                break;

              case 34:
                if (!this.props.newFetch) {
                  _context2.next = 37;
                  break;
                }

                _context2.next = 37;
                return this.props.newFetch();

              case 37:
                _context2.next = 39;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Unit pricing package successfully updated', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 39:
                if (this.props.handleResetCheck) this.props.handleResetCheck();

              case 40:
                _context2.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 12]]);
      }));

      function updateUnitPackagePricings() {
        return _ref3.apply(this, arguments);
      }

      return updateUnitPackagePricings;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          calculatePackagePricing = _state.calculatePackagePricing,
          data = _state.data,
          globalSettings = _state.globalSettings,
          loading = _state.loading,
          showDeleteConfirm = _state.showDeleteConfirm,
          showPreview = _state.showPreview;
      var _props3 = this.props,
          hasEditAccess = _props3.hasEditAccess,
          hasGenerateQuotationAccess = _props3.hasGenerateQuotationAccess,
          hasPreviewPriceAccess = _props3.hasPreviewPriceAccess,
          isBumiUnit = _props3.isBumiUnit,
          newFetch = _props3.newFetch,
          onToggleQuotationPreview = _props3.onToggleQuotationPreview,
          projectCurrencies = _props3.projectCurrencies,
          projectDefaultBFP = _props3.projectDefaultBFP,
          projectDefaultBumiPackagePricingID = _props3.projectDefaultBumiPackagePricingID,
          projectDefaultPackagePricingID = _props3.projectDefaultPackagePricingID,
          projectID = _props3.projectID,
          projectName = _props3.projectName,
          projectQuatationCode = _props3.projectQuatationCode,
          showQuotationOpts = _props3.showQuotationOpts,
          spaValue = _props3.spaValue,
          t = _props3.t,
          unitID = _props3.unitID,
          unitReference = _props3.unitReference,
          isMobile = _props3.isMobile;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_DeleteConfirm2.default, {
          content: t('Are you sure you want to delete this unit pricing package') + '?',
          onClose: this.handleCancelDelete,
          onConfirm: this.handleConfirmDelete,
          open: showDeleteConfirm
        }),
        _react2.default.createElement(_EditableBox2.default, {
          editable: hasEditAccess,
          isEditing: this.state.editing,
          loading: loading,
          onCancel: this.handleResetEditing,
          onClick: this.handleUpdate,
          onEdit: this.handleEditing,
          showPreview: showPreview || showQuotationOpts,
          content: function content(_ref4) {
            var isEditing = _ref4.isEditing;
            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { style: { zIndex: 20 }, active: _this3.state.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                'div',
                { style: { display: 'flex', flexDirection: isMobile ? 'column' : 'row', alignItems: isMobile ? 'flex-start' : 'center', justifyContent: 'flex-start' } },
                hasPreviewPriceAccess && !showQuotationOpts && _react2.default.createElement(_semanticUiReact.Button, {
                  as: 'button',
                  attached: 'top',
                  style: _extends({
                    background: showPreview ? '#eae8e8' : 'none',
                    width: isMobile ? '63%' : '29%',
                    top: hasEditAccess && !showPreview ? '-2.5em' : '0',
                    borderRadius: '0.2em',
                    paddingRight: '1.5em',
                    display: isEditing ? 'none' : 'inline-block',
                    marginBottom: !hasEditAccess || showPreview ? '1.5em' : '0',
                    marginLeft: isMobile ? '0' : '1em'
                  }, isMobile && { marginBottom: '0.8em' }),
                  content: t(showPreview ? 'Close' : 'Preview Price Breakdown', { ns: _translation.TRANSLATION_FILES.translation }),
                  icon: showPreview ? 'close' : 'eye',
                  size: 'tiny',
                  name: 'showPreview',
                  onClick: _this3.handleTogglePreview
                }),
                hasGenerateQuotationAccess && !showPreview && !showQuotationOpts && _react2.default.createElement(_semanticUiReact.Button, {
                  as: 'button',
                  attached: 'top',
                  style: {
                    background: 'none',
                    width: isMobile ? '63%' : '29%',
                    top: hasEditAccess ? '-2.5em' : '0',
                    borderRadius: '0.2em',
                    paddingRight: '1.5em',
                    display: isEditing ? 'none' : 'inline-block',
                    marginBottom: hasEditAccess ? '0' : '1.5em',
                    marginLeft: isMobile ? '0' : '1em'
                  },
                  content: t('Generate Quotation'),
                  icon: 'print',
                  size: 'tiny',
                  name: 'showQuotationOpts',
                  onClick: function onClick() {
                    return onToggleQuotationPreview(true);
                  }
                })
              ),
              isEditing ? _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    data.length > 0 ? _react2.default.createElement(_Sortable.SortableContainer, {
                      isSortMode: true,
                      iconColor: 'blue',
                      helperClass: 'sorting',
                      data: data,
                      lockAxis: 'y',
                      lockToContainerEdges: true,
                      onSortEnd: _this3.onSortEnd,
                      useDragHandle: true,
                      item: function item(props) {
                        return _react2.default.createElement(SortableItem, _extends({}, props, {
                          onChange: function onChange(d) {
                            return _this3.handleOnChange(d, props.idx);
                          },
                          onVisibilityChange: function onVisibilityChange(e) {
                            return _this3.onVisibilityChange(e, props.value, 'accessibleIn', props.idx);
                          },
                          onDelete: function onDelete(d) {
                            return _this3.handleDelete(d, props.idx);
                          },
                          refForm: _this3.setRefForm,
                          refValidation: function refValidation(ref) {
                            return _this3.setRefValidation(ref, props.idx);
                          },
                          packagePricings: _this3.getPackagePricings,
                          t: t
                        }));
                      }
                    }) : _react2.default.createElement(
                      _semanticUiReact.Segment,
                      { className: 'segment_unit_pricing_package_not_found', textAlign: 'center' },
                      t('No unit pricing package found')
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { textAlign: 'center' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    _react2.default.createElement(
                      _semanticUiReact.Button,
                      {
                        basic: true,
                        onClick: _this3.handleAdd
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'add circle', color: 'green' }),
                      ' ',
                      t('Add pricing package')
                    )
                  )
                )
              ) : _react2.default.createElement(
                'div',
                null,
                !showQuotationOpts && _react2.default.createElement(ProjectUnitPackagePricingView, {
                  unitPackagePricings: data,
                  projectCurrencies: projectCurrencies,
                  spaValue: spaValue,
                  isPreviewing: showPreview && !showQuotationOpts,
                  calculatePackagePricing: calculatePackagePricing,
                  sellingPriceCustomName: globalSettings && globalSettings.sellingPrice,
                  t: t
                }),
                _react2.default.createElement(_QuotationPackageSelection2.default, {
                  calculatePackagePricing: calculatePackagePricing,
                  isBumiUnit: isBumiUnit,
                  isPreviewing: showQuotationOpts,
                  newFetch: newFetch,
                  onTogglePreview: onToggleQuotationPreview,
                  projectDefaultBookingFeeAmount: projectDefaultBFP,
                  projectDefaultBumiPackagePricingID: projectDefaultBumiPackagePricingID,
                  projectDefaultPackagePricingID: projectDefaultPackagePricingID,
                  projectID: projectID,
                  projectName: projectName,
                  projectQuatationCode: projectQuatationCode,
                  sellingPriceCustomName: globalSettings && globalSettings.sellingPrice,
                  spaValue: spaValue,
                  t: t,
                  token: _this3.state.token,
                  unitID: unitID,
                  unitPackagePricings: data,
                  unitReference: unitReference
                })
              )
            );
          }
        })
      );
    }
  }]);

  return ProjectUnitPackagePricing;
}(_react.Component);

ProjectUnitPackagePricing.contextTypes = {
  store: _propTypes2.default.object
};
ProjectUnitPackagePricing.propTypes = {
  calculatePackagePricing: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  data: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  handleCheckChanges: _propTypes2.default.func,
  handleResetCheck: _propTypes2.default.func,
  hasEditAccess: _propTypes2.default.bool,
  hasGenerateQuotationAccess: _propTypes2.default.bool,
  hasPreviewPriceAccess: _propTypes2.default.bool,
  isBumiUnit: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  newFetch: _propTypes2.default.func,
  onToggleQuotationPreview: _propTypes2.default.func,
  packagePricings: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  projectCurrencies: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  projectDefaultBFP: _propTypes2.default.number,
  projectDefaultBumiPackagePricingID: _propTypes2.default.string,
  projectDefaultPackagePricingID: _propTypes2.default.string,
  projectID: _propTypes2.default.string,
  projectName: _propTypes2.default.string,
  projectQuatationCode: _propTypes2.default.string,
  showQuotationOpts: _propTypes2.default.bool,
  spaValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  token: _propTypes2.default.string,
  t: _propTypes2.default.func,
  unitID: _propTypes2.default.string,
  unitReference: _propTypes2.default.string,
  isMobile: _propTypes2.default.bool
};

ProjectUnitPackagePricing.getPropsToState = function (props) {
  var data = props.data || [];
  var loading = props.loading;
  var packagePricings = props.packagePricings || [];
  var calculatePackagePricing = props.calculatePackagePricing || [];
  var token = props.token || '';
  var showQuotationOpts = props.showQuotationOpts || false;

  var globalSettings = {};
  var storeGloablSettings = (0, _storage.getItem)(_config2.default.get('appName') + '.globalSettings');
  if (storeGloablSettings) {
    try {
      globalSettings = JSON.parse(storeGloablSettings).data || [];
    } catch (e) {
      Bugsnag.notifyException(e);
    }
  }

  return {
    data: data,
    oriData: (0, _clone2.default)(data),
    loading: loading,
    packagePricings: packagePricings,
    calculatePackagePricing: calculatePackagePricing,
    token: token,
    globalSettings: globalSettings,
    showQuotationOpts: showQuotationOpts
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onSortEnd = function (_ref5) {
    var oldIndex = _ref5.oldIndex,
        newIndex = _ref5.newIndex;

    var data = _this4.sortDataByIndex((0, _reactSortableHoc.arrayMove)(_this4.state.data, oldIndex, newIndex));
    _this4.setState({ data: data }, function () {
      if (_this4.props.handleCheckChanges) _this4.props.handleCheckChanges();
    });
  };

  this.onVisibilityChange = function (d, pp, nameField, idx) {
    var name = d.name;
    var newData = pp.accessibleIn ? pp.accessibleIn : [];
    var data = _this4.state.data;


    if (name === 'SRB') {
      var isAccessible = newData ? newData.includes('SRB') : false;
      if (isAccessible === true) {
        var index = newData.indexOf('SRB');
        newData.splice(index, 1);
      } else if (isAccessible === false) {
        newData.push(name);
        data[idx][nameField] = newData;
      }
    } else if (name === 'MP') {
      var _isAccessible = newData ? newData.includes('MP') : false;
      if (_isAccessible === true) {
        var _index = newData.indexOf('MP');
        newData.splice(_index, 1);
      } else if (_isAccessible === false) {
        newData.push(name);
        data[idx][nameField] = newData;
      }
    }
    _this4.setState({ data: data });
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this4.setState({ loading: loading }, function () {
        res(loading);
      });
    });
  };

  this.getPackagePricings = function () {
    var data = _this4.state.data;
    // filter out already added package pricings

    var packagePricings = _this4.state.packagePricings.filter(function (p) {
      return !data.find(function (d) {
        return d.id !== '' && d.projectPackagePricingID === p.id;
      });
    }).sort(function (a, b) {
      return a.orderPriority - b.orderPriority;
    });
    var options = [];
    packagePricings.forEach(function (p) {
      var newItem = {
        text: p.name,
        value: p.id
      };
      // disabled the option once selected
      var selectedItem = data.find(function (d) {
        return d.projectPackagePricingID === p.id;
      });
      if (selectedItem) newItem.disabled = true;
      options.push(newItem);
    });
    return options;
  };

  this.setRefValidation = function (ref, idx) {
    if (ref && ref.props && ref.props.name) {
      if (!_this4.editRef[idx]) _this4.editRef[idx] = {};
      _this4.editRef[idx][ref.props.name] = ref;
    }
  };

  this.setRefForm = function (ref) {
    _this4.formRef = ref;
  };

  this.sortDataByIndex = function (newData) {
    var data = newData;
    data.forEach(function (d, index) {
      data[index].orderPriority = index + 1;
    });
    return data;
  };

  this.asyncForEach = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(array, callback) {
      var index;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              index = 0;

            case 1:
              if (!(index < array.length)) {
                _context3.next = 7;
                break;
              }

              _context3.next = 4;
              return callback(array[index], index, array);

            case 4:
              index += 1;
              _context3.next = 1;
              break;

            case 7:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }));

    return function (_x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }();

  this.handleEditing = function () {
    _this4.setState({ editing: true });
  };

  this.handleResetEditing = function () {
    if (_this4.props.handleResetCheck) _this4.props.handleResetCheck();
    _this4.setState({
      editing: false
    }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!(JSON.stringify(_this4.state.data) !== JSON.stringify(_this4.props.data))) {
                _context4.next = 4;
                break;
              }

              if (!_this4.props.newFetch) {
                _context4.next = 4;
                break;
              }

              _context4.next = 4;
              return _this4.props.newFetch();

            case 4:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    })));
  };

  this.handleUpdate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
    var store, data, t, hasError;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            if (!(JSON.stringify(_this4.state.data) === JSON.stringify(_this4.state.oriData))) {
              _context6.next = 4;
              break;
            }

            _context6.next = 3;
            return _this4.setComponentState({ editing: false });

          case 3:
            return _context6.abrupt('return');

          case 4:
            store = _this4.context.store;
            data = _this4.state.data;
            t = _this4.props.t;
            hasError = false;
            _context6.next = 10;
            return _this4.asyncForEach(data, function () {
              var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(d, idx) {
                var validations, errMessages;
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        if (!(_this4.editRef[idx] && !hasError)) {
                          _context5.next = 9;
                          break;
                        }

                        _context5.next = 3;
                        return _AppForm2.default.validate(_this4.editRef[idx], data[idx]);

                      case 3:
                        validations = _context5.sent;
                        errMessages = validations.filter(function (v) {
                          return !v.isValid;
                        });

                        if (!(errMessages.length > 0)) {
                          _context5.next = 9;
                          break;
                        }

                        hasError = true;
                        _context5.next = 9;
                        return store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errMessages.map(function (l) {
                            return l.message;
                          }) }));

                      case 9:
                      case 'end':
                        return _context5.stop();
                    }
                  }
                }, _callee5, _this4);
              }));

              return function (_x7, _x8) {
                return _ref9.apply(this, arguments);
              };
            }());

          case 10:
            if (hasError) {
              _context6.next = 15;
              break;
            }

            _context6.next = 13;
            return _this4.updateUnitPackagePricings();

          case 13:
            _context6.next = 15;
            return _this4.setComponentState({ editing: false });

          case 15:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, _this4);
  }));

  this.handleOnChange = function (d, idx) {
    var data = _this4.state.data;

    var newData = [];
    data.forEach(function (item, i) {
      if (i === idx) {
        newData.push(d);
      } else {
        newData.push(item);
      }
    });
    _this4.setState({ data: newData }, function () {
      if (_this4.editRef[idx]) _AppForm2.default.validate(_this4.editRef[idx], newData[idx]);
      if (_this4.props.handleCheckChanges) _this4.props.handleCheckChanges();
    });
  };

  this.handleDelete = function (d, idx) {
    _this4.setState({
      showDeleteConfirm: true,
      deleteIDX: idx,
      deleteData: d
    });
  };

  this.handleCancelDelete = function (e) {
    e.preventDefault();
    _this4.setState({
      showDeleteConfirm: false,
      deleteIDX: null,
      deleteData: Object.assign({}, _package_pricing.PROJECT_UNIT_PACKAGE_PRICING_DEFAULT)
    });
  };

  this.handleConfirmDelete = function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(e) {
      var deleteData;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              e.preventDefault();
              deleteData = _this4.state.deleteData;

              if (!(deleteData.id !== '')) {
                _context7.next = 7;
                break;
              }

              _context7.next = 5;
              return _this4.deleteUnitPackagePricing(deleteData.id, function () {
                _this4.confirmDelete();
              });

            case 5:
              _context7.next = 8;
              break;

            case 7:
              _this4.confirmDelete();

            case 8:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this4);
    }));

    return function (_x9) {
      return _ref10.apply(this, arguments);
    };
  }();

  this.confirmDelete = function () {
    var _state2 = _this4.state,
        data = _state2.data,
        deleteIDX = _state2.deleteIDX;

    var newData = [];
    data.forEach(function (item, i) {
      if (i !== deleteIDX) {
        newData.push(item);
      }
    });
    _this4.setState({
      data: _this4.sortDataByIndex(newData),
      deleteData: Object.assign({}, _package_pricing.PROJECT_UNIT_PACKAGE_PRICING_DEFAULT),
      deleteIDX: null,
      showDeleteConfirm: false
    }, function () {
      if (_this4.props.handleCheckChanges) _this4.props.handleCheckChanges();
    });
  };

  this.handleAdd = function (e) {
    e.preventDefault();
    var data = _this4.state.data;
    var _props4 = _this4.props,
        projectID = _props4.projectID,
        unitID = _props4.unitID;

    var newItem = (0, _clone2.default)(Object.assign({}, _package_pricing.PROJECT_UNIT_PACKAGE_PRICING_DEFAULT, {
      orderPriority: data.length + 1,
      projectID: projectID,
      projectUnitID: unitID,
      accessibleIn: ['MP', 'SRB']
    }));
    data.push(newItem);
    _this4.setState({ data: data }, function () {
      if (_this4.props.handleCheckChanges) _this4.props.handleCheckChanges();
    });
  };

  this.handleTogglePreview = function (e, data) {
    e.preventDefault();
    var name = data.name;

    _this4.setState(function (prevState) {
      return _extends({}, prevState, _defineProperty({}, name, !prevState[name]));
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(ProjectUnitPackagePricing);

/***/ }),
/* 2175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _package_pricing = __webpack_require__(222);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-nested-ternary */
/* eslint-disable max-len */


var UnitPackagePricingEdit = function (_Component) {
  _inherits(UnitPackagePricingEdit, _Component);

  function UnitPackagePricingEdit() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UnitPackagePricingEdit);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UnitPackagePricingEdit.__proto__ || Object.getPrototypeOf(UnitPackagePricingEdit)).call.apply(_ref, [this].concat(args))), _this), _this.handleSave = function (e) {
      if (e) e.preventDefault();
      var data = _this.props.data;

      if (_this.props.onChange) _this.props.onChange(data);
    }, _this.handleInputChange = function (e, d) {
      var data = _this.props.data;

      data[d.name] = d.value;
      if (_this.props.onChange) _this.props.onChange(data);
    }, _this.handleCheckboxChange = function (e, d) {
      var data = _this.props.data;

      data[d.name] = !data[d.name];
      if (data[d.name]) {
        if (data.id === '') data.projectPackagePricingID = '';
        data.totalPrice = '';
        data.customName = '';
        data.customDescription = '';
      }
      if (_this.props.onChange) _this.props.onChange(data);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UnitPackagePricingEdit, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _AppForm2.default,
              {
                as: 'div',
                onSubmit: this.handleSave,
                ref: this.props.refForm
              },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { verticalAlign: 'middle', className: 'row_enable_package_custom_price' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { mobile: 16, tablet: 12, computer: 13 },
                    data.id !== '' && data.projectPackagePricingID !== '' ? _react2.default.createElement(
                      'span',
                      null,
                      _react2.default.createElement(
                        'span',
                        { className: 'text_name' },
                        data.projectPackagePricing.name,
                        data.projectPackagePricing.description !== '' ? ': ' : ''
                      ),
                      data.projectPackagePricing.description !== '' ? _react2.default.createElement(
                        'span',
                        { className: 'text_description' },
                        data.projectPackagePricing.description
                      ) : ''
                    ) : '',
                    _react2.default.createElement(_AppForm2.default.Input, {
                      name: 'totalPrice',
                      onChange: this.handleInputChange,
                      placeholder: 'Custom Amount',
                      ref: this.props.refValidation,
                      step: '.01',
                      type: 'number',
                      validateLabel: 'Custom Amount',
                      validation: data.isCustomPrice ? [_webValidations.required, {
                        validate: _webValidations.numericRange,
                        option: {
                          min: 0.01,
                          max: 2147483647
                        }
                      }] : null,
                      value: data.totalPrice,
                      style: data.isCustomPrice ? {} : { display: 'none' }
                    }),
                    _react2.default.createElement(
                      _AppForm2.default.Validate,
                      {
                        name: 'projectPackagePricingID',
                        onChange: this.handleInputChange,
                        ref: this.props.refValidation,
                        validateLabel: 'Pricing Package',
                        validation: !data.isCustomPrice && data.id === '' ? [_webValidations.required] : null,
                        style: !data.isCustomPrice && data.id === '' ? {} : { display: 'none' }
                      },
                      _react2.default.createElement(_semanticUiReact.Form.Select, {
                        fluid: true,
                        name: 'projectPackagePricingID',
                        options: this.props.packagePricings(),
                        placeholder: 'Select Pricing Package',
                        search: true,
                        selectOnBlur: true,
                        value: data.projectPackagePricingID
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'row_name_desc', style: data.isCustomPrice && data.projectPackagePricingID === '' ? {} : { display: 'none' } },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { mobile: 16, tablet: 6, computer: 6 },
                    _react2.default.createElement(_AppForm2.default.Input, {
                      placeholder: 'Custom Name',
                      name: 'customName',
                      onChange: this.handleInputChange,
                      ref: this.props.refValidation,
                      type: 'text',
                      validateLabel: 'Custom Name',
                      validation: data.isCustomPrice && data.projectPackagePricingID === '' ? [_webValidations.required, {
                        validate: _webValidations.stringLength,
                        option: {
                          max: 128
                        }
                      }] : null,
                      value: data.customName
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { mobile: 16, tablet: 10, computer: 10 },
                    _react2.default.createElement(_AppForm2.default.Input, {
                      placeholder: 'Custom Description',
                      name: 'customDescription',
                      onChange: this.handleInputChange,
                      ref: this.props.refValidation,
                      type: 'text',
                      validateLabel: 'Custom Description',
                      value: data.customDescription
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return UnitPackagePricingEdit;
}(_react.Component);

UnitPackagePricingEdit.propTypes = {
  data: _propTypes2.default.shape(),
  onChange: _propTypes2.default.func,
  packagePricings: _propTypes2.default.func,
  refForm: _propTypes2.default.func,
  refValidation: _propTypes2.default.func
};
UnitPackagePricingEdit.defaultProps = {
  data: Object.assign({}, _package_pricing.PROJECT_UNIT_PACKAGE_PRICING_DEFAULT)
};
exports.default = UnitPackagePricingEdit;

/***/ }),
/* 2176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectUnitPricingTierView = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactSortableHoc = __webpack_require__(123);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DragHandle = (0, _reactSortableHoc.SortableHandle)(function () {
  return _react2.default.createElement(_semanticUiReact.Icon, { size: 'large', disabled: true, name: 'content' });
});

var SortableItem = (0, _reactSortableHoc.SortableElement)(function (_ref) {
  var projectTiers = _ref.projectTiers,
      data = _ref.data,
      idx = _ref.idx,
      _onChange = _ref.onChange,
      onDeleteItem = _ref.onDeleteItem,
      isExistingData = _ref.isExistingData,
      isModal = _ref.isModal;
  return _react2.default.createElement(
    _semanticUiReact.Grid,
    { className: 'item' },
    _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { verticalAlign: 'middle' },
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { mobile: 3, tablet: 2, computer: 1 },
        _react2.default.createElement(DragHandle, null)
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { mobile: 10, tablet: 12, computer: isModal ? 13 : 14 },
        isExistingData && data.projectPricing ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              'b',
              null,
              data.projectPricing.name
            ),
            _react2.default.createElement('br', null),
            data.projectPricing.description
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { verticalAlign: 'middle' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { mobile: 16, tablet: 6, computer: isModal ? 5 : 4 },
                _react2.default.createElement(_semanticUiReact.Checkbox, {
                  label: 'Custom Price',
                  checked: data.isCustomPrice,
                  onChange: function onChange(e, d) {
                    return _onChange(e, d, idx, 'isCustomPrice');
                  }
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { mobile: 16, tablet: 10, computer: isModal ? 11 : 12 },
                _react2.default.createElement(_semanticUiReact.Input, {
                  fluid: true,
                  size: 'small',
                  onChange: function onChange(e, d) {
                    return _onChange(e, d, idx, 'totalPrice');
                  },
                  value: data.totalPrice,
                  type: 'number',
                  step: '.01',
                  disabled: !data.isCustomPrice
                })
              )
            )
          )
        ) : _react2.default.createElement(
          _semanticUiReact.Form.Group,
          { widths: 'equal' },
          _react2.default.createElement(_semanticUiReact.Form.Select, {
            fluid: true,
            onChange: function onChange(e, d) {
              return _onChange(e, d, idx, 'projectPricingID');
            },
            options: projectTiers,
            placeholder: 'Select Project Discount Package',
            search: true,
            value: data.projectPricingID
          })
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { mobile: 3, tablet: 2, computer: isModal ? 2 : 1, className: 'colRight' },
        _react2.default.createElement(_semanticUiReact.Button, {
          onClick: function onClick(e) {
            return onDeleteItem(e, idx);
          },
          negative: true,
          icon: 'trash',
          compact: true
        })
      )
    )
  );
});

var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref2) {
  var addButtonIsDisabled = _ref2.addButtonIsDisabled,
      projectTiers = _ref2.projectTiers,
      items = _ref2.items,
      onAdd = _ref2.onAdd,
      onChange = _ref2.onChange,
      onDeleteItem = _ref2.onDeleteItem,
      isModal = _ref2.isModal;
  return _react2.default.createElement(
    'div',
    { className: 'contain' },
    items.map(function (data, index) {
      return _react2.default.createElement(SortableItem, {
        data: data,
        idx: index,
        index: index,
        key: 'item-' + index,
        onChange: onChange,
        onDeleteItem: onDeleteItem,
        projectTiers: projectTiers,
        isExistingData: !!data.projectPricing,
        isModal: isModal
      });
    }),
    _react2.default.createElement(
      _semanticUiReact.Grid,
      { className: 'foot' },
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { verticalAlign: 'middle' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { textAlign: 'center' },
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              fluid: true,
              onClick: onAdd,
              disabled: addButtonIsDisabled()
            },
            'Add Discount Package'
          )
        )
      )
    )
  );
});

var ProjectUnitPricingTierView = exports.ProjectUnitPricingTierView = function ProjectUnitPricingTierView(_ref3) {
  var tiers = _ref3.tiers,
      spaValue = _ref3.spaValue,
      _ref3$projectCurrenci = _ref3.projectCurrencies,
      projectCurrencies = _ref3$projectCurrenci === undefined ? [] : _ref3$projectCurrenci,
      sellingPriceCustomName = _ref3.sellingPriceCustomName;

  var _useTranslation = (0, _reactI18next.useTranslation)(_translation.TRANSLATION_FILES.screens),
      t = _useTranslation.t;

  var items = [{
    totalPrice: spaValue,
    projectPricing: {
      name: sellingPriceCustomName || t('Selling Price'),
      description: t('Unit Base Selling Price')
    },
    isSPAValue: true
  }];
  tiers.sort(function (a, b) {
    return a.position - b.position;
  }).forEach(function (d) {
    var newItem = {
      totalPrice: d.totalPrice,
      isSPAValue: false
    };
    if (d.projectPricing) {
      newItem.projectPricing = {
        name: d.projectPricing.name,
        description: d.projectPricing.description
      };
    }
    items.push(newItem);
  });
  return _react2.default.createElement(
    _semanticUiReact.Grid,
    { className: 'projectPricingTierView' },
    items.map(function (data, idx) {
      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { key: idx, verticalAlign: 'middle' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 8, textAlign: 'right' },
          _react2.default.createElement(
            'h3',
            { className: data.isSPAValue ? 'spaValue' : '' },
            _react2.default.createElement(_LoanAmount2.default, {
              projectCurrencies: projectCurrencies,
              format: '0,000,000.00',
              amount: data.totalPrice && data.totalPrice ? data.totalPrice : '',
              prefix: _react2.default.createElement(_CurrencySymbol2.default, null),
              precise: false
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 8 },
          _react2.default.createElement(
            _semanticUiReact.Header,
            { as: 'h4', className: data.isSPAValue ? 'spaValue' : '' },
            data.projectPricing && data.projectPricing.name ? data.projectPricing.name : '',
            _react2.default.createElement(
              _semanticUiReact.Header.Subheader,
              null,
              data.projectPricing && data.projectPricing.description ? data.projectPricing.description : ''
            )
          )
        )
      );
    })
  );
};

ProjectUnitPricingTierView.propTypes = {
  projectCurrencies: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  tiers: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  spaValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  sellingPriceCustomName: _propTypes2.default.string
};

var ProjectUnitPricingTierEdit = function (_Component) {
  _inherits(ProjectUnitPricingTierEdit, _Component);

  function ProjectUnitPricingTierEdit(props) {
    _classCallCheck(this, ProjectUnitPricingTierEdit);

    var _this = _possibleConstructorReturn(this, (ProjectUnitPricingTierEdit.__proto__ || Object.getPrototypeOf(ProjectUnitPricingTierEdit)).call(this, props));

    _initialiseProps.call(_this);

    var state = ProjectUnitPricingTierEdit.getPropsToState(props);
    _this.state = _extends({}, state, {
      deleteModalIsOpen: false,
      deleteItemName: '',
      deleteItemIndex: null
    });
    return _this;
  }

  _createClass(ProjectUnitPricingTierEdit, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = ProjectUnitPricingTierEdit.getPropsToState(nextProps);
      if (JSON.stringify(this.state.data) !== JSON.stringify(state.data)) {
        this.setState(_extends({}, state));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          data = _state.data,
          deleteItemName = _state.deleteItemName,
          deleteModalIsOpen = _state.deleteModalIsOpen;
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { className: 'projectUnitPricingTier' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(
              _semanticUiReact.Modal,
              { open: deleteModalIsOpen, basic: true, size: 'small' },
              _react2.default.createElement(_semanticUiReact.Header, { icon: 'trash', content: t('Delete Confirmation') }),
              _react2.default.createElement(
                _semanticUiReact.Modal.Content,
                null,
                _react2.default.createElement(
                  'h4',
                  null,
                  t('Are you sure you want to delete this discount package'),
                  '?',
                  deleteItemName ? ' (' + deleteItemName + ')' : ''
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Modal.Actions,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  { basic: true, color: 'red', inverted: true, onClick: this.handleDeleteModalCancel },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove' }),
                  ' ',
                  t('No', { ns: _translation.TRANSLATION_FILES.constants })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  { color: 'green', inverted: true, onClick: this.handleDeleteModalConfirm },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' }),
                  ' ',
                  t('Delete', { ns: _translation.TRANSLATION_FILES.translation })
                )
              )
            ),
            _react2.default.createElement(SortableList, {
              addButtonIsDisabled: this.checkAddButtonDisabled,
              helperClass: 'projectUnitPricingTier isSorting',
              items: this.getData(data),
              lockAxis: 'y',
              lockToContainerEdges: true,
              onAdd: this.handleOnAdd,
              onChange: this.handleOnChange,
              onDeleteItem: this.handleOnDelete,
              onSortEnd: this.onSortEnd,
              projectTiers: this.getprojectTiers(),
              isModal: this.props.isModal,
              useDragHandle: true
            })
          )
        )
      );
    }
  }]);

  return ProjectUnitPricingTierEdit;
}(_react.Component);

ProjectUnitPricingTierEdit.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  projectTiers: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  onDelete: _propTypes2.default.func,
  onChangeData: _propTypes2.default.func.isRequired,
  isModal: _propTypes2.default.bool
};
ProjectUnitPricingTierEdit.defaultValues = {
  id: '',
  projectPricingID: '',
  position: 1,
  totalPrice: 0,
  tierName: ''
};

ProjectUnitPricingTierEdit.getPropsToState = function (props) {
  var data = props.data || [];
  var projectTiers = props.projectTiers || [];
  return {
    data: data,
    projectTiers: projectTiers
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onSortEnd = function (_ref4) {
    var oldIndex = _ref4.oldIndex,
        newIndex = _ref4.newIndex;

    _this2.sortDataByIndex((0, _reactSortableHoc.arrayMove)(_this2.state.data, oldIndex, newIndex));
  };

  this.getData = function (data) {
    var newData = data;
    newData.forEach(function (d, idx) {
      if (d.projectPricing && d.projectPricing.name) {
        newData[idx].tierName = d.projectPricing.name;
      }
    });
    return _this2.getSortedData(newData);
  };

  this.getprojectTiers = function () {
    var data = _this2.state.data;
    var projectTiers = _this2.state.projectTiers.filter(function (p) {
      return !data.find(function (d) {
        return d.id !== '' && d.projectPricingID === p.id;
      });
    }).sort(function (a, b) {
      return a.position - b.position;
    });
    var options = [];
    projectTiers.forEach(function (p) {
      var newItem = {
        text: p.name,
        value: p.id,
        description: p.description
      };
      var selectedItem = data.find(function (d) {
        return d.projectPricingID === p.id;
      });
      if (selectedItem) newItem.disabled = true;
      options.push(newItem);
    });
    return options;
  };

  this.getSortedData = function (data) {
    return data.sort(function (a, b) {
      return a.position - b.position;
    });
  };

  this.sortDataByIndex = function (newData) {
    var data = newData;
    data.forEach(function (d, index) {
      data[index].position = index + 1;
    });
    _this2.setState({ data: data }, function () {
      return _this2.props.onChangeData(_this2.state.data);
    });
  };

  this.handleOnChange = function (e, data, index, type) {
    var newData = _this2.state.data;
    if (type === 'projectPricingID') {
      var item = _this2.state.projectTiers.find(function (d) {
        return d.id === data.value;
      });
      newData[index].projectPricingID = data.value;
      newData[index].tierName = item.name;
      if (_this2.props.isModal) {
        newData[index].projectPricing = {
          name: item.name
        };
      }
    }
    if (type === 'totalPrice') {
      newData[index].totalPrice = data.value;
    }
    if (type === 'isCustomPrice') {
      newData[index].isCustomPrice = !newData[index].isCustomPrice;
    }
    _this2.setState({ data: newData }, function () {
      return _this2.props.onChangeData(_this2.state.data);
    });
  };

  this.handleOnAdd = function (e) {
    e.preventDefault();
    var data = _this2.state.data;
    var lastID = data.length;
    var newItem = Object.assign({}, ProjectUnitPricingTierEdit.defaultValues);
    if (lastID > 0) {
      newItem.position = data[lastID - 1].position;
    }
    data.push(newItem);
    _this2.sortDataByIndex(data);
  };

  this.handleOnDelete = function (e, index) {
    e.preventDefault();
    var data = _this2.state.data;
    _this2.setState({
      deleteModalIsOpen: true,
      deleteItemName: data[index].tierName,
      deleteItemIndex: index
    });
  };

  this.handleDeleteModalConfirm = function () {
    var data = _this2.state.data;
    var deleteID = '';
    if (data[_this2.state.deleteItemIndex] && data[_this2.state.deleteItemIndex].id) {
      deleteID = data[_this2.state.deleteItemIndex].id;
    }
    if (deleteID !== '' && _this2.props.onDelete) {
      _this2.props.onDelete(deleteID);
    } else {
      data.splice(_this2.state.deleteItemIndex, 1);
      _this2.sortDataByIndex(data);
    }
    _this2.setState({
      deleteModalIsOpen: false,
      deleteItemName: '',
      deleteItemIndex: null
    });
  };

  this.handleDeleteModalCancel = function () {
    _this2.setState({
      deleteModalIsOpen: false,
      deleteItemName: '',
      deleteItemIndex: null
    });
  };

  this.checkAddButtonDisabled = function () {
    var tiers = _this2.getprojectTiers().filter(function (d) {
      return !d.disabled;
    }).length;
    var blankCount = _this2.state.data.filter(function (d) {
      return d.projectPricingID === '';
    }).length;
    if (blankCount > 0 || tiers < 1) {
      return true;
    }
    return false;
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(ProjectUnitPricingTierEdit);

/***/ }),
/* 2177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/label-has-for */


var QuotationPackageSelection = function (_Component) {
  _inherits(QuotationPackageSelection, _Component);

  function QuotationPackageSelection(props) {
    _classCallCheck(this, QuotationPackageSelection);

    var _this = _possibleConstructorReturn(this, (QuotationPackageSelection.__proto__ || Object.getPrototypeOf(QuotationPackageSelection)).call(this, props));

    _initialiseProps.call(_this);

    var state = QuotationPackageSelection.getPropsToState(props);

    // added 0% to 100% options
    var percentageOpts = [];
    for (var i = 100; i >= 0; i -= 1) {
      percentageOpts.push({
        key: i,
        value: i + '%',
        text: i + '%'
      });
    }

    _this.state = _extends({}, state, {
      items: [],
      loading: false,
      percentageOpts: percentageOpts,
      printQuotationModal: false
    });
    return _this;
  }

  _createClass(QuotationPackageSelection, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = QuotationPackageSelection.getPropsToState(nextProps);
      this.setState(state);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          onTogglePreview = _props.onTogglePreview;
      var _state = this.state,
          isPreviewing = _state.isPreviewing,
          items = _state.items,
          quotationPackage = _state.quotationPackage;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { className: 'quotation-grid' },
        this.renderPrintQuotationModal(),
        isPreviewing && _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(_semanticUiReact.Button, {
              content: t('Close', { ns: _translation.TRANSLATION_FILES.translation }),
              icon: 'close',
              name: 'showQuotationOpts',
              onClick: function onClick() {
                return onTogglePreview(false);
              },
              size: 'tiny'
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(_semanticUiReact.Button, {
              color: 'teal',
              content: t('Print quotation'),
              disabled: !quotationPackage.packagePricingID,
              name: 'printQuotation',
              onClick: function onClick() {
                return _this2.handleDisplayModal(true);
              }
            })
          )
        ),
        isPreviewing && items && items.length > 0 && _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Accordion,
              null,
              items.map(function (data, idx) {
                return _this2.renderPackageAndCalculations(data, idx);
              })
            )
          )
        )
      );
    }
  }]);

  return QuotationPackageSelection;
}(_react.Component);

QuotationPackageSelection.contextTypes = {
  store: _propTypes2.default.object
};
QuotationPackageSelection.propTypes = {
  calculatePackagePricing: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  isBumiUnit: _propTypes2.default.bool,
  isPreviewing: _propTypes2.default.bool,
  newFetch: _propTypes2.default.func,
  onTogglePreview: _propTypes2.default.func,
  projectDefaultBookingFeeAmount: _propTypes2.default.number,
  projectDefaultBumiPackagePricingID: _propTypes2.default.string,
  projectDefaultPackagePricingID: _propTypes2.default.string,
  projectID: _propTypes2.default.string,
  projectName: _propTypes2.default.string,
  projectQuatationCode: _propTypes2.default.string,
  sellingPriceCustomName: _propTypes2.default.string,
  spaValue: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
  t: _propTypes2.default.func,
  token: _propTypes2.default.string,
  unitID: _propTypes2.default.string,
  unitReference: _propTypes2.default.string,
  unitPackagePricings: _propTypes2.default.oneOfType([_propTypes2.default.array])
};

QuotationPackageSelection.getPropsToState = function (props) {
  var calculatePackagePricing = props.calculatePackagePricing || [];
  var isPreviewing = props.isPreviewing;
  var token = props.token || '';

  var accordions = {
    base_price: false
  };

  // assign default package pricing (unit base selling price) to items
  var items = [{
    isSPAValue: true,
    listPrice: props.spaValue,
    projectPackagePricing: {
      name: props.sellingPriceCustomName || 'Selling Price',
      description: 'Unit Base Selling Price'
    },
    projectPackagePricingID: 'base_price',
    spaPrice: props.spaValue,
    totalPrice: props.spaValue
  }];

  // range through packages and calculations and push into items
  props.unitPackagePricings.sort(function (a, b) {
    return a.orderPriority - b.orderPriority;
  }).forEach(function (d) {
    var calculations = [];

    if (props.calculatePackagePricing && props.calculatePackagePricing.some(function (data) {
      return data.id === d.id;
    })) {
      var pupp = props.calculatePackagePricing.find(function (data) {
        return data.id === d.id;
      });
      if (!pupp.isCustomPrice && pupp.projectPackagePricing.packagePricingCalculations) {
        calculations = pupp.projectPackagePricing.packagePricingCalculations.map(function (c) {
          return _extends({}, c, {
            isSelected: c.projectPackagePricingItem && c.projectPackagePricingItem.isEnabled && c.applyToBooking,
            isItemRequired: c.projectPackagePricingItem && c.projectPackagePricingItem.isRequired
          });
        });
      }
    }

    var newItem = {
      customDescription: d.customDescription,
      customName: d.customName,
      isCustomPrice: d.isCustomPrice,
      isSPAValue: false,
      listPrice: d.listPrice,
      packagePricingCalculations: calculations,
      projectPackagePricingID: d.projectPackagePricingID,
      spaPrice: d.spaPrice,
      totalPrice: d.totalPrice
    };

    if (d.projectPackagePricing) {
      var iDesc = d.projectPackagePricing.description;
      if (iDesc.includes('\n')) {
        iDesc = iDesc.split('\n').map(function (desc, idx) {
          return _react2.default.createElement(
            'span',
            { key: idx },
            desc,
            _react2.default.createElement('br', null)
          );
        });
      }
      newItem.projectPackagePricing = {
        name: d.projectPackagePricing.name,
        description: iDesc
      };
    }
    items.push(newItem);

    accordions[d.projectPackagePricingID] = false;
  });

  // added quotation package to be used to generate quotation
  var quotationPackage = {
    packagePricingID: props.projectDefaultPackagePricingID ? props.projectDefaultPackagePricingID : '',
    bookingFeeAmount: props.projectDefaultBookingFeeAmount ? props.projectDefaultBookingFeeAmount : 0,
    marginOfFinance: '90%',
    calculations: []
  };

  // assign default selected package
  if (props.isBumiUnit && props.projectDefaultBumiPackagePricingID) {
    quotationPackage.packagePricingID = props.projectDefaultBumiPackagePricingID;
  }
  if (quotationPackage.packagePricingID !== '') {
    accordions[quotationPackage.packagePricingID] = true;
  }

  return {
    accordions: accordions,
    calculatePackagePricing: calculatePackagePricing,
    isPreviewing: isPreviewing,
    items: items,
    quotationPackage: quotationPackage,
    token: token
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleAccordionChange = function (e, ppID) {
    e.preventDefault();
    if (ppID !== 'base_price') {
      var newAccordions = _this3.state.accordions;
      newAccordions[ppID] = !newAccordions[ppID];
      _this3.setState({ accordions: newAccordions });
    }
  };

  this.findSubTotalCalcIndex = function (idx, data) {
    // find nearest subtotal calculation index
    for (var i = idx - 1; i >= 0; i -= 1) {
      if (data[i].isSubTotal) {
        return i;
      }
    }
    return -1;
  };

  this.handleCalculationCheckboxChange = function (e, d, calc) {
    var value = d.value,
        checked = d.checked;
    var items = _this3.state.items;


    if (calc) {
      var newItems = [].concat(_toConsumableArray(items));
      var packageIdx = newItems.findIndex(function (p) {
        return p.projectPackagePricingID === calc.projectPackagePricingID;
      });
      if (packageIdx > -1) {
        var calcIdx = newItems[packageIdx].packagePricingCalculations.findIndex(function (c) {
          return c.id === value;
        });
        if (calcIdx > -1) {
          newItems[packageIdx].packagePricingCalculations[calcIdx].isSelected = checked;
          _this3.setState({ items: [].concat(_toConsumableArray(newItems)) });
        }
      }
    }
  };

  this.handleDisplayModal = function (isOpen) {
    return _this3.setState({ printQuotationModal: isOpen });
  };

  this.handleModalInputChange = function (e, d) {
    var quotationPackage = _this3.state.quotationPackage;

    quotationPackage[d.name] = d.value;

    _this3.setState({ quotationPackage: quotationPackage });
  };

  this.handlePackageChange = function (e, d) {
    var value = d.value;

    var newAccordions = _this3.state.accordions;
    if (value !== 'base_price') {
      newAccordions[value] = true;
    }
    var qp = _this3.state.quotationPackage;
    qp.packagePricingID = value;

    _this3.setState({ quotationPackage: qp, accordions: newAccordions });
  };

  this.generateQuotationForm = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var store, _props2, projectID, projectQuatationCode, unitID, unitReference, t, _state2, items, quotationPackage, itemIdx, selectedPackageCalcs, i, subIdx, res, message, blob, url, link, filename;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _this3.setState({ loading: true });

          case 2:
            store = _this3.context.store;
            _props2 = _this3.props, projectID = _props2.projectID, projectQuatationCode = _props2.projectQuatationCode, unitID = _props2.unitID, unitReference = _props2.unitReference, t = _props2.t;
            _state2 = _this3.state, items = _state2.items, quotationPackage = _state2.quotationPackage;

            // validate item

            itemIdx = items.findIndex(function (i) {
              return i.projectPackagePricingID === quotationPackage.packagePricingID;
            });

            if (!(itemIdx <= -1)) {
              _context.next = 10;
              break;
            }

            _context.next = 9;
            return store.dispatch((0, _flash.flashErrorMessage)({ message: t('Package not found. Please refresh the page', { ns: _translation.TRANSLATION_FILES.translation }) }));

          case 9:
            return _context.abrupt('return');

          case 10:

            // send selected calculations to backend
            selectedPackageCalcs = items[itemIdx].packagePricingCalculations;

            if (selectedPackageCalcs && selectedPackageCalcs.length > 0) {
              for (i = 0; i < selectedPackageCalcs.length; i += 1) {
                // find subtotal calculation
                if (selectedPackageCalcs[i].isSelected && selectedPackageCalcs[i].projectPackagePricingItem && selectedPackageCalcs[i].projectPackagePricingItem.calculationType === 'deduct_from_sub_total') {
                  subIdx = _this3.findSubTotalCalcIndex(i, selectedPackageCalcs);

                  if (subIdx > -1) {
                    selectedPackageCalcs[subIdx].isSelected = true;
                  }
                }
              }
            }
            quotationPackage.calculations = selectedPackageCalcs.filter(function (c) {
              return c.isSelected;
            });

            quotationPackage.bookingFeeAmount = Number(quotationPackage.bookingFeeAmount);

            if (!isNaN(quotationPackage.bookingFeeAmount)) {
              _context.next = 18;
              break;
            }

            _context.next = 17;
            return store.dispatch((0, _flash.flashErrorMessage)({ message: 'Booking fee amount is not a number' }));

          case 17:
            return _context.abrupt('return');

          case 18:
            res = void 0;
            _context.prev = 19;
            _context.next = 22;
            return store.dispatch((0, _fetchM.fetchM)('/projects/' + projectID + '/units/' + unitID + '/print_quotation/', {
              credentials: 'include',
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Csrf-Token': _this3.props.token
              },
              body: JSON.stringify(quotationPackage)
            }));

          case 22:
            res = _context.sent;
            _context.next = 38;
            break;

          case 25:
            _context.prev = 25;
            _context.t0 = _context['catch'](19);
            _context.next = 29;
            return _this3.setState({ loading: false });

          case 29:

            Bugsnag.notifyException(_context.t0);

            if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
              _context.next = 36;
              break;
            }

            _context.next = 33;
            return _context.t0.res.text();

          case 33:
            message = _context.sent;

            store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
            return _context.abrupt('return');

          case 36:

            store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
            return _context.abrupt('return');

          case 38:
            _context.next = 40;
            return res.blob();

          case 40:
            blob = _context.sent;


            // Create a temporary URL for the blob
            url = window.URL.createObjectURL(blob);

            // Create a link element to trigger the download

            link = document.createElement('a');

            link.href = url;

            // set filename
            filename = 'Quotation.pdf';

            if (projectQuatationCode && unitReference) {
              filename = 'Quotation-' + projectQuatationCode + ',' + unitReference + '.pdf';
            }
            link.download = filename;

            document.body.appendChild(link);

            // Trigger the download
            link.click();

            // Clean up
            link.remove();
            window.URL.revokeObjectURL(url);

            _this3.setState({ loading: false, printQuotationModal: false }, function () {
              // refetch all including project activity logs
              _this3.props.newFetch();
            });

          case 52:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this3, [[19, 25]]);
  }));

  this.renderApplyToBookingRemarks = function (title, applyToBooking) {
    var t = _this3.props.t;

    return _react2.default.createElement(
      'span',
      null,
      title,
      _react2.default.createElement(
        'span',
        { className: 'packagePricingApplyToBookingFlag', style: { color: applyToBooking ? 'green' : 'red' } },
        t('Formula item will' + (!applyToBooking ? ' not' : '') + ' be applied onto the initial booking')
      )
    );
  };

  this.renderSubtotal = function () {
    var t = _this3.props.t;

    return _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { className: 'quotation-subtitle' },
      _react2.default.createElement(
        'h5',
        null,
        t('Sub Total')
      )
    );
  };

  this.renderCalculations = function (ppc) {
    return _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { className: 'quotation-calculations' },
      _react2.default.createElement(_semanticUiReact.Checkbox, {
        value: ppc.id,
        checked: ppc.isSelected,
        disabled: ppc.isItemRequired,
        onChange: function onChange(e, d) {
          return _this3.handleCalculationCheckboxChange(e, d, ppc);
        },
        label: _react2.default.createElement(
          'label',
          null,
          ppc && ppc.projectPackagePricingItem && ppc.projectPackagePricingItem.name ? _this3.renderApplyToBookingRemarks(ppc.projectPackagePricingItem.name, ppc.applyToBooking) : ''
        )
      }),
      _react2.default.createElement(
        'small',
        null,
        ppc && ppc.projectPackagePricingItem && ppc.projectPackagePricingItem.description ? ppc.projectPackagePricingItem.description : ''
      )
    );
  };

  this.renderPackageAndCalculations = function (data, idx) {
    var t = _this3.props.t;
    var _state3 = _this3.state,
        accordions = _state3.accordions,
        quotationPackage = _state3.quotationPackage;

    var listCalculations = data.packagePricingCalculations && data.packagePricingCalculations.length > 0 ? data.packagePricingCalculations.filter(function (ppc) {
      return ppc.category === 'list_price';
    }) : [];
    var spaCalculations = data.packagePricingCalculations && data.packagePricingCalculations.length > 0 ? data.packagePricingCalculations.filter(function (ppc) {
      return ppc.category === 'spa_price';
    }) : [];
    return _react2.default.createElement(
      'div',
      { key: idx },
      _react2.default.createElement(
        _semanticUiReact.Accordion.Title,
        {
          key: idx,
          active: accordions[data.projectPackagePricingID],
          index: data.projectPackagePricingID
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_semanticUiReact.Checkbox, {
                radio: true,
                checked: quotationPackage.packagePricingID === data.projectPackagePricingID,
                value: data.projectPackagePricingID,
                onClick: _this3.handlePackageChange,
                label: _react2.default.createElement(
                  'label',
                  null,
                  _react2.default.createElement(
                    'h3',
                    null,
                    data.projectPackagePricingID !== '' ? data.projectPackagePricing && data.projectPackagePricing.name ? data.projectPackagePricing.name : '' : ''
                  )
                )
              }),
              _react2.default.createElement(
                'small',
                null,
                data.projectPackagePricingID !== '' ? data.projectPackagePricing && data.projectPackagePricing.description ? data.projectPackagePricing.description : '' : ''
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              data.projectPackagePricingID !== 'base_price' && _react2.default.createElement(
                _semanticUiReact.Button,
                { basic: true, disabled: quotationPackage.packagePricingID === data.projectPackagePricingID, onClick: function onClick(e) {
                    return _this3.handleAccordionChange(e, data.projectPackagePricingID);
                  } },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron ' + (accordions[data.projectPackagePricingID] ? 'up' : 'down') })
              )
            )
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Accordion.Content,
        { active: accordions[data.projectPackagePricingID] },
        !data.isSPAValue && _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { columns: 16 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'left', width: 8 },
            _react2.default.createElement(
              'h4',
              null,
              t('Unit Base Selling Price')
            )
          )
        ),
        listCalculations.map(function (ppc, key) {
          return _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 16, key: key },
            ppc.isSubTotal ? _this3.renderSubtotal() : _this3.renderCalculations(ppc)
          );
        }),
        !data.isSPAValue && _this3.renderSubtotal(),
        spaCalculations.map(function (ppc, key) {
          return _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { key: key },
            ppc.isSubTotal ? _this3.renderSubtotal() : _this3.renderCalculations(ppc)
          );
        })
      )
    );
  };

  this.renderPrintQuotationModal = function () {
    var t = _this3.props.t;
    var _state4 = _this3.state,
        loading = _state4.loading,
        percentageOpts = _state4.percentageOpts,
        printQuotationModal = _state4.printQuotationModal,
        quotationPackage = _state4.quotationPackage;

    return _react2.default.createElement(
      _semanticUiReact.Modal,
      {
        className: 'quotation-modal',
        closeOnDimmerClick: false,
        disabled: loading,
        onClose: function onClose() {
          return _this3.handleDisplayModal(false);
        },
        open: printQuotationModal,
        size: 'tiny'
      },
      _react2.default.createElement(
        _semanticUiReact.Modal.Header,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_semanticUiReact.Header, { as: 'h3', content: t('Print quotation') })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_semanticUiReact.Button, { basic: true, icon: 'close', onClick: function onClick() {
                  return _this3.handleDisplayModal(false);
                } })
            )
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Modal.Content,
        null,
        _react2.default.createElement(
          _semanticUiReact.Modal.Description,
          null,
          'Fill up the following and click Generate.'
        ),
        _react2.default.createElement(_semanticUiReact.Form.Input, {
          disabled: loading,
          label: _react2.default.createElement(
            'label',
            null,
            'Part first 10% of the Purchase Price',
            _react2.default.createElement(
              'span',
              null,
              ' *'
            )
          ),
          name: 'bookingFeeAmount',
          onChange: _this3.handleModalInputChange,
          value: quotationPackage.bookingFeeAmount
        }),
        _react2.default.createElement(_semanticUiReact.Form.Select, {
          disabled: loading,
          fluid: true,
          label: _react2.default.createElement(
            'label',
            null,
            t('Margin of financing'),
            _react2.default.createElement(
              'span',
              null,
              ' *'
            )
          ),
          name: 'marginOfFinance',
          onChange: _this3.handleModalInputChange,
          options: percentageOpts,
          selectOnBlur: false,
          value: quotationPackage.marginOfFinance
        })
      ),
      _react2.default.createElement(
        _semanticUiReact.Modal.Actions,
        null,
        _react2.default.createElement(_semanticUiReact.Button, { basic: true, disabled: loading, onClick: function onClick() {
            return _this3.handleDisplayModal(false);
          }, content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }) }),
        _react2.default.createElement(_semanticUiReact.Button, { color: 'blue', disabled: loading, onClick: _this3.generateQuotationForm, content: 'Generate' })
      )
    );
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(QuotationPackageSelection);

/***/ }),
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _translation = __webpack_require__(4);

var _OpportunityCancelModal = __webpack_require__(262);

var _currencyMinor = __webpack_require__(326);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


// Actions


var RefundRequestDetail = function (_Component) {
  _inherits(RefundRequestDetail, _Component);

  function RefundRequestDetail(props) {
    var _this2 = this;

    _classCallCheck(this, RefundRequestDetail);

    var _this = _possibleConstructorReturn(this, (RefundRequestDetail.__proto__ || Object.getPrototypeOf(RefundRequestDetail)).call(this, props));

    _this.handleOpenConfirm = function (type) {
      _this.setState({
        isConfirmOpen: true,
        confirmType: type,
        amountMinorRefunded: '',
        rejectionReason: ''
      });
    };

    _this.handleCloseConfirm = function () {
      _this.setState({ isConfirmOpen: false, confirmType: null });
    };

    _this.handleConfirmAction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$props, refund, refundToken, t, onUpdateOpportunity, confirmType, store, url, action, response, opportunityStatus;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, refund = _this$props.refund, refundToken = _this$props.refundToken, t = _this$props.t, onUpdateOpportunity = _this$props.onUpdateOpportunity;
              confirmType = _this.state.confirmType;
              store = _this.context.store;
              url = '/unit_reservation_refunds/' + refund.id + '/status/';

              _this.setState({ isSubmitting: true });

              _context.prev = 5;
              action = (0, _fetchM.fetchM)(url, {
                method: 'PUT',
                credentials: 'include',
                headers: {
                  'Content-Type': 'application/json',
                  'X-CSRF-Token': refundToken
                },
                body: JSON.stringify({
                  status: confirmType, // 'approved' or 'declined'
                  rejectionReason: '-',
                  amountMinorRefunded: confirmType === 'approved' ? refund ? refund.amountMinor : 0 : 0
                })
              });
              _context.next = 9;
              return store.dispatch(action);

            case 9:
              response = _context.sent;


              if (response) {
                // Update local state immediately to show the new status
                _this.setState(function (prevState) {
                  return {
                    refund: _extends({}, prevState.refund, {
                      status: confirmType
                    })
                  };
                });

                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Success', { ns: _translation.TRANSLATION_FILES.constants }),
                  message: t('Refund status updated successfully')
                }));

                // Update opportunity status based on refund decision
                if (onUpdateOpportunity) {
                  opportunityStatus = confirmType === 'approved' ? 'refunded' : 'refund_declined';

                  onUpdateOpportunity(opportunityStatus);
                }

                if (_this.props.onSuccess) {
                  _this.props.onSuccess();
                }
                _this.handleCloseConfirm();
              }
              _context.next = 16;
              break;

            case 13:
              _context.prev = 13;
              _context.t0 = _context['catch'](5);

              store.dispatch((0, _flash.flashErrorMessage)({
                header: t('Error', { ns: _translation.TRANSLATION_FILES.constants }),
                message: t('Error updating refund status')
              }));

            case 16:
              _context.prev = 16;

              _this.setState({ isSubmitting: false });
              return _context.finish(16);

            case 19:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[5, 13, 16, 19]]);
    }));

    _this.renderStatusBannerHeader = function (status) {
      var t = _this.props.t;

      switch (status) {
        case 'approved':
          return _react2.default.createElement(
            'div',
            { className: 'refund-header-title text-success' },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle outline' }),
            _react2.default.createElement(
              'strong',
              null,
              t('Refund completed')
            )
          );
        case 'declined':
          return _react2.default.createElement(
            'div',
            { className: 'refund-header-title text-danger' },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'times circle outline' }),
            _react2.default.createElement(
              'strong',
              null,
              t('Refund declined')
            )
          );
        default:
          return _react2.default.createElement(
            'div',
            { className: 'refund-header-title text-warning' },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'clock outline' }),
            _react2.default.createElement(
              'strong',
              null,
              t('Pending refund')
            )
          );
      }
    };

    _this.getBannerClassName = function (status) {
      switch (status) {
        case 'approved':
          return 'refund-container-completed';
        case 'declined':
          return 'refund-container-denied';
        default:
          return 'refund-container-pending';
      }
    };

    _this.state = {
      isConfirmOpen: false,
      confirmType: null,
      isSubmitting: false,
      amountMinorRefunded: '',
      rejectionReason: '',
      refund: props.refund
    };
    return _this;
  }

  _createClass(RefundRequestDetail, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Sync refund prop changes to state
      if (prevProps.refund !== this.props.refund) {
        this.setState({ refund: this.props.refund });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          t = _props.t,
          loading = _props.loading,
          _props$data = _props.data,
          data = _props$data === undefined ? {} : _props$data;
      var _state = this.state,
          isConfirmOpen = _state.isConfirmOpen,
          confirmType = _state.confirmType,
          isSubmitting = _state.isSubmitting,
          refund = _state.refund;


      var currentStatus = refund && refund.status;
      var isPending = currentStatus === 'pending' || !currentStatus;
      var isApprove = confirmType === 'approved';
      var currencyCode = refund && refund.currencyCode;

      // Format currency presentation values dynamically
      var displayAmount = refund ? (0, _currencyMinor.formatMinorNumber)(refund.amountMinor, currencyCode) : '0';

      return _react2.default.createElement(
        'div',
        { className: 'refund-detail-wrapper' },
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { className: 'refund-status-block ' + this.getBannerClassName(currentStatus) },
          _react2.default.createElement(
            'div',
            { className: 'refund-banner-top-row' },
            this.renderStatusBannerHeader(currentStatus)
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { style: { marginTop: '1rem' }, columns: 'equal', className: 'refund-fields-grid' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'field-row' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 6, className: 'field-label' },
                t('Requestor name')
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 10, textAlign: 'right', className: 'field-value font-weight-bold' },
                refund.purchaserName || '-'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'field-row' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 6, className: 'field-label' },
                t('Cancellation category')
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 10, textAlign: 'right', className: 'field-value' },
                (0, _OpportunityCancelModal.cancellationCategoryLabel)(data.sr_cancellation_type) ? t((0, _OpportunityCancelModal.cancellationCategoryLabel)(data.sr_cancellation_type)) : '-'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'field-row' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 6, className: 'field-label' },
                t('Cancellation reason')
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 10, textAlign: 'right', className: 'field-value' },
                data.sr_cancellation_reason || '-'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'field-row' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 6, className: 'field-label' },
                t('Request received at')
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 10, textAlign: 'right', className: 'field-value' },
                data.sr_cancellation_at ? _react2.default.createElement(_Timestamp2.default, { timestamp: data.sr_cancellation_at, format: 'DD MMM YYYY, hh:mm a' }) : '-'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'field-row' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 6, className: 'field-label' },
                t('Cancellation approved at')
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 10, textAlign: 'right', className: 'field-value' },
                data.sr_cancelled_at ? _react2.default.createElement(_Timestamp2.default, { timestamp: data.sr_cancelled_at, format: 'DD MMM YYYY, hh:mm a' }) : '-'
              )
            ),
            _react2.default.createElement('hr', { className: 'divider-line' }),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'field-row' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 6, className: 'field-label' },
                t('Refund requested at')
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 10, textAlign: 'right', className: 'field-value' },
                refund.createdAt ? _react2.default.createElement(_Timestamp2.default, { timestamp: refund.createdAt, format: 'DD MMM YYYY, hh:mm a' }) : '-'
              )
            ),
            currentStatus === 'approved' && _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'field-row' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 6, className: 'field-label' },
                t('Refund completed at')
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 10, textAlign: 'right', className: 'field-value' },
                refund.processedAt ? _react2.default.createElement(_Timestamp2.default, { timestamp: refund.processedAt, format: 'DD MMM YYYY, hh:mm a' }) : '-'
              )
            ),
            currentStatus === 'declined' && _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'field-row' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 6, className: 'field-label' },
                t('Refund declined at')
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 10, textAlign: 'right', className: 'field-value' },
                refund.processedAt ? _react2.default.createElement(_Timestamp2.default, { timestamp: refund.processedAt, format: 'DD MMM YYYY, hh:mm a' }) : '-'
              )
            )
          ),
          isPending && _react2.default.createElement(
            'div',
            { className: 'refund-actions-footer' },
            _react2.default.createElement(
              'p',
              { className: 'outcome-confirmation-text' },
              t('Confirm the refund outcome for'),
              ' ',
              _react2.default.createElement(
                'strong',
                null,
                (currencyCode || 'VND') + ' ' + displayAmount
              ),
              ':'
            ),
            _react2.default.createElement(
              'div',
              { className: 'buttons-group' },
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  className: 'btn-outcome btn-complete',
                  onClick: function onClick() {
                    return _this3.handleOpenConfirm('approved');
                  }
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' }),
                ' ',
                t('Refund completed')
              ),
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  className: 'btn-outcome btn-deny',
                  onClick: function onClick() {
                    return _this3.handleOpenConfirm('declined');
                  }
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'close' }),
                ' ',
                t('Refund declined')
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            open: isConfirmOpen,
            onClose: this.handleCloseConfirm,
            size: isApprove ? 'mini' : 'tiny',
            closeIcon: true
          },
          _react2.default.createElement(
            _semanticUiReact.Modal.Header,
            null,
            isApprove ? t('Approve refund request') : t('Reject refund request')
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            isApprove ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'p',
                { className: 'confirm-approve-text' },
                t('Are you sure you want to approve this refund of'),
                ' ',
                _react2.default.createElement(
                  'strong',
                  null,
                  (currencyCode || 'VND') + ' ' + displayAmount
                ),
                '?'
              ),
              _react2.default.createElement(
                'p',
                { className: 'approve-info-text', style: { color: '#555555', fontSize: '0.9rem' } },
                t('Once approved, refunds will be processed for all received payments.')
              )
            ) : _react2.default.createElement(
              'div',
              { className: 'reject-refund-wrapper' },
              _react2.default.createElement(
                'p',
                { className: 'confirm-reject-text' },
                t('Are you sure you want to reject this refund request?')
              ),
              _react2.default.createElement(
                'div',
                { style: { marginTop: '1rem' } },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', className: 'info-icon', style: { color: '#0288D1', marginRight: '6px' } }),
                _react2.default.createElement(
                  'span',
                  { className: 'reject-info-text', style: { color: '#555555', fontSize: '0.9rem' } },
                  t('A notification will be sent to the agent and buyer upon confirmation.')
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(
              _semanticUiReact.Button,
              { basic: true, onClick: this.handleCloseConfirm },
              t('Cancel')
            ),
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                color: 'teal',
                onClick: this.handleConfirmAction,
                loading: isSubmitting,
                disabled: loading || isSubmitting
              },
              t('Confirm')
            )
          )
        )
      );
    }
  }]);

  return RefundRequestDetail;
}(_react.Component);

RefundRequestDetail.contextTypes = {
  store: _propTypes2.default.object
};
RefundRequestDetail.propTypes = {
  refund: _propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    opportunityID: _propTypes2.default.string.isRequired,
    status: _propTypes2.default.string,
    amountMinor: _propTypes2.default.number.isRequired,
    currencyCode: _propTypes2.default.string.isRequired,
    reason: _propTypes2.default.string.isRequired,
    bankName: _propTypes2.default.string.isRequired,
    bankAccountNumber: _propTypes2.default.string.isRequired,
    bankAccountName: _propTypes2.default.string.isRequired,
    projectName: _propTypes2.default.string.isRequired,
    purchaserName: _propTypes2.default.string.isRequired,
    rejectionReason: _propTypes2.default.string,
    processedBy: _propTypes2.default.string,
    // Date tracking parameters mapping to backend properties
    processedAt: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
    createdAt: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
    updatedAt: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)])
  }).isRequired,
  refundToken: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  onSuccess: _propTypes2.default.func,
  onUpdateOpportunity: _propTypes2.default.func,
  t: _propTypes2.default.func.isRequired,
  data: _propTypes2.default.shape({
    sr_cancellation_reason: _propTypes2.default.string,
    sr_cancellation_type: _propTypes2.default.string,
    sr_cancellation_at: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)])
  })
};
exports.default = (0, _reactI18next.withTranslation)()(RefundRequestDetail);

/***/ }),
/* 2179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortItems = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _url = __webpack_require__(19);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _BookingSelectList = __webpack_require__(1017);

var _BookingSelectList2 = _interopRequireDefault(_BookingSelectList);

var _bankCaseStatuses = __webpack_require__(264);

var _bankCaseStatuses2 = _interopRequireDefault(_bankCaseStatuses);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sortItems = exports.sortItems = [{
  text: 'Bank Ascending',
  icon: 'sort alphabet ascending',
  sortColumn: 'bank.short_name',
  sortDirection: 'asc',
  status: null
}, {
  text: 'Bank Descending',
  icon: 'sort alphabet descending',
  sortColumn: 'bank.short_name',
  sortDirection: 'desc',
  status: null
}, {
  text: 'New Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'average_new_age',
  sortDirection: 'asc',
  status: 'new'
}, {
  text: 'New Descending',
  icon: 'sort numeric descending',
  sortColumn: 'average_new_age',
  sortDirection: 'desc',
  status: 'new'
}, {
  text: 'Pending Docs Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'average_pending_docs_age',
  sortDirection: 'asc',
  status: 'pending_docs'
}, {
  text: 'Pending Docs Descending',
  icon: 'sort numeric descending',
  sortColumn: 'average_pending_docs_age',
  sortDirection: 'desc',
  status: 'pending_docs'
}, {
  text: 'Docs Submitted Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'average_pending_docs_submitted_age',
  sortDirection: 'asc',
  status: 'pending_docs_submitted'
}, {
  text: 'Docs Submitted Descending',
  icon: 'sort numeric descending',
  sortColumn: 'average_pending_docs_submitted_age',
  sortDirection: 'desc',
  status: 'pending_docs_submitted'
}, {
  text: 'LO Issued Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'average_approved_lo_issued_age',
  sortDirection: 'asc',
  status: 'approved_lo_issued'
}, {
  text: 'LO Issued Descending',
  icon: 'sort numeric descending',
  sortColumn: 'average_approved_lo_issued_age',
  sortDirection: 'desc',
  status: 'approved_lo_issued'
}, {
  text: 'Unreachable Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'average_pending_unreachable_age',
  sortDirection: 'asc',
  status: 'pending_unreachable'
}, {
  text: 'Unreachable Descending',
  icon: 'sort numeric descending',
  sortColumn: 'average_pending_unreachable_age',
  sortDirection: 'desc',
  status: 'pending_unreachable'
}, {
  text: 'Loan Re-appealed Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'average_pending_reappealed_age',
  sortDirection: 'asc',
  status: 'pending_reappealed'
}, {
  text: 'Loan Re-appealed Descending',
  icon: 'sort numeric descending',
  sortColumn: 'average_pending_reappealed_age',
  sortDirection: 'desc',
  status: 'pending_reappealed'
}, {
  text: 'Wrong Info Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'average_reject_wrong_info_age',
  sortDirection: 'asc',
  status: 'reject_wrong_info'
}, {
  text: 'Wrong Info Descending',
  icon: 'sort numeric descending',
  sortColumn: 'average_reject_wrong_info_age',
  sortDirection: 'desc',
  status: 'reject_wrong_info'
}, {
  text: 'Customer Cancelled Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'average_reject_cancelled_age',
  sortDirection: 'asc',
  status: 'reject_cancelled'
}, {
  text: 'Customer Cancelled Descending',
  icon: 'sort numeric descending',
  sortColumn: 'average_reject_cancelled_age',
  sortDirection: 'desc',
  status: 'reject_cancelled'
}, {
  text: 'LO Signed Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'average_success_li_issued_age',
  sortDirection: 'asc',
  status: 'success_li_issued'
}, {
  text: 'LO Signed Descending',
  icon: 'sort numeric descending',
  sortColumn: 'average_success_li_issued_age',
  sortDirection: 'desc',
  status: 'success_li_issued'
}, {
  text: 'Unqualified Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'average_reject_unqualified_age',
  sortDirection: 'asc',
  status: 'reject_unqualified'
}, {
  text: 'Unqualified Descending',
  icon: 'sort numeric descending',
  sortColumn: 'average_reject_unqualified_age',
  sortDirection: 'desc',
  status: 'reject_unqualified'
}, {
  text: 'Loan Rejected Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'average_reject_bank_age',
  sortDirection: 'asc',
  status: 'reject_bank'
}, {
  text: 'Loan Rejected Descending',
  icon: 'sort numeric descending',
  sortColumn: 'average_reject_bank_age',
  sortDirection: 'desc',
  status: 'reject_bank'
}, {
  text: 'Customer Rejected Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'average_reject_customer_age',
  sortDirection: 'asc',
  status: 'reject_customer'
}, {
  text: 'Customer Rejected Descending',
  icon: 'sort numeric descending',
  sortColumn: 'average_reject_customer_age',
  sortDirection: 'desc',
  status: 'reject_customer'
}, {
  text: 'LO Signed With Another Bank Descending',
  icon: 'sort numeric descending',
  sortColumn: 'average_reject_lo_signed_other_bank_age',
  sortDirection: 'desc',
  status: 'reject_lo_signed_other_bank'
}, {
  text: 'LO Signed With Another Bank Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'average_reject_lo_signed_other_bank_age',
  sortDirection: 'asc',
  status: 'reject_lo_signed_other_bank'
}, {
  text: 'Developer Cancelled Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'average_reject_developer_age',
  sortDirection: 'asc',
  status: 'reject_developer'
}, {
  text: 'Developer Cancelled Descending',
  icon: 'sort numeric descending',
  sortColumn: 'average_reject_developer_age',
  sortDirection: 'desc',
  status: 'reject_developer'
}, {
  text: 'Current Total Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'total_current_average',
  sortDirection: 'asc',
  status: 'total_current_average'
}, {
  text: 'Current Total Descending',
  icon: 'sort numeric descending',
  sortColumn: 'total_current_average',
  sortDirection: 'desc',
  status: 'total_current_average'
}, {
  text: 'Closed Total Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'total_closed_average',
  sortDirection: 'asc',
  status: 'total_closed_average'
}, {
  text: 'Closed Total Descending',
  icon: 'sort numeric descending',
  sortColumn: 'total_closed_average',
  sortDirection: 'desc',
  status: 'total_closed_average'
}];

var BankAverageAging = function (_Component) {
  _inherits(BankAverageAging, _Component);

  function BankAverageAging(props) {
    _classCallCheck(this, BankAverageAging);

    var _this = _possibleConstructorReturn(this, (BankAverageAging.__proto__ || Object.getPrototypeOf(BankAverageAging)).call(this, props));

    _initialiseProps.call(_this);

    var state = BankAverageAging.getPropsToState(props);
    _this.state = _extends({}, state, {
      data: [],
      bankActives: [],
      loading: true
    });
    return _this;
  }

  _createClass(BankAverageAging, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      this.fetchReports(query);
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var state = BankAverageAging.getPropsToState(nextProps);
      var query = BankAverageAging.getQueryData(this.props);
      var newQuery = BankAverageAging.getQueryData(nextProps);
      var refetch = !_lodash2.default.isEqual(query.projectID, newQuery.projectID) || !_lodash2.default.isEqual(query.sortColumn, newQuery.sortColumn) || !_lodash2.default.isEqual(query.sortDirection, newQuery.sortDirection) || !_lodash2.default.isEqual(query.search, newQuery.search) || !_lodash2.default.isEqual(query.dateRange, newQuery.dateRange) || !_lodash2.default.isEqual(query.dateTo, newQuery.dateTo) || !_lodash2.default.isEqual(query.dateFrom, newQuery.dateFrom) || !_lodash2.default.isEqual(query.statusGroup, newQuery.statusGroup) || !_lodash2.default.isEqual(query.status, newQuery.status) || !_lodash2.default.isEqual(query.bankID, newQuery.bankID);
      this.setState(_extends({}, state), function () {
        if (refetch) {
          var q = (0, _url.decodeSearch)(nextProps.location.search);
          _this2.fetchReports(q);
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'cellCheckSorted',
    value: function cellCheckSorted(key) {
      var defaultCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var column = sortItems[key].sortColumn;

      var _decodeSearch = (0, _url.decodeSearch)(this.props.location.search),
          sortColumn = _decodeSearch.sortColumn,
          sortDirection = _decodeSearch.sortDirection;

      if (defaultCell && sortColumn === undefined) {
        return 'ascending';
      }
      if (column === sortColumn) {
        return sortDirection === 'asc' ? 'ascending' : 'descending';
      }
      return null;
    }
  }, {
    key: 'fetchReports',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var store, t, query, projectID, res, message, data, bankActives;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, q);

                delete query.projectID;
                projectID = q.projectID || '';

                if (projectID !== '') {
                  query.projectID = projectID;
                }
                res = void 0;
                _context.prev = 9;
                _context.next = 12;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/reports/bookings/banks/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context.sent;
                _context.next = 23;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](9);

                Bugsnag.notifyException(_context.t0);
                _context.next = 20;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 20:
                _context.next = 22;
                return this.setLoading(false);

              case 22:
                return _context.abrupt('return');

              case 23:
                if (res.ok) {
                  _context.next = 31;
                  break;
                }

                _context.next = 26;
                return res.text();

              case 26:
                message = _context.sent;
                _context.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 29:
                _context.next = 37;
                break;

              case 31:
                _context.next = 33;
                return res.json();

              case 33:
                data = _context.sent;
                bankActives = data.bankReports.map(function () {
                  return false;
                });
                _context.next = 37;
                return this.setComponentState({
                  data: data,
                  bankActives: bankActives
                });

              case 37:
                _context.next = 39;
                return this.setLoading(false);

              case 39:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 15]]);
      }));

      function fetchReports(_x4) {
        return _ref.apply(this, arguments);
      }

      return fetchReports;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var store = this.context.store;
      var pathname = this.props.location.pathname;

      var queryNew = query;
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));
    }
  }, {
    key: 'render',
    value: function render() {
      var data = this.state.data;
      var t = this.props.t;

      var _checkStatus = this.checkStatus(),
          showCustom = _checkStatus.showCustom;

      var _BankAverageAging$get = BankAverageAging.getQueryData(this.props),
          statusGroup = _BankAverageAging$get.statusGroup;

      var classNames = ['bank-report'];
      if (statusGroup === 'all') {
        classNames.push('vertical-header');
      }
      if (showCustom) {
        classNames.push('custom-group');
      }
      var filteredData = data && data.bankReports && data.bankReports.length > 0 ? data.bankReports.filter(function (item) {
        return item.totalCurrentAverage > 0 || item.totalClosedAverage > 0;
      }) : [];
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { style: { margin: '-1rem 0' } },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Segment,
              { color: this.props.headerColor },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'users-bookings table' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { className: 'mobile-report-table' },
                    _react2.default.createElement(
                      _semanticUiReact.Dimmer,
                      {
                        inverted: true, style: { zIndex: 20 },
                        active: this.state.loading
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Loader,
                        { inline: 'centered' },
                        t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table,
                      {
                        celled: true,
                        compact: true,
                        unstackable: true,
                        structured: true,
                        sortable: this.state.isMobile || statusGroup !== 'all',
                        className: classNames.join(' ')
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Header,
                        null,
                        this.renderTableHeader()
                      ),
                      filteredData.length > 0 ? _react2.default.createElement(
                        _semanticUiReact.Table.Body,
                        null,
                        filteredData.map(this.renderTableBody),
                        this.renderTotalRow()
                      ) : _react2.default.createElement(
                        _semanticUiReact.Table.Body,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Table.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Table.Cell,
                            { colSpan: this.getColSpan() },
                            _react2.default.createElement(
                              _semanticUiReact.Segment,
                              { basic: true, textAlign: 'center' },
                              this.state.loading ? _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }) : t('No reports found') + '.'
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return BankAverageAging;
}(_react.Component);

BankAverageAging.contextTypes = {
  store: _propTypes2.default.object
};
BankAverageAging.propTypes = {
  headerColor: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }).isRequired,
  onFilterChange: _propTypes2.default.func,
  onFilterClose: _propTypes2.default.func,
  t: _propTypes2.default.func
};

BankAverageAging.getQueryData = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var projectID = query.projectID || '';
  var sortColumn = query.sortColumn || '';
  var sortDirection = query.sortDirection || '';
  var search = query.search || '';
  var dateRange = query.dateRange || '';
  var dateFrom = query.dateFrom ? query.dateFrom : '';
  var dateTo = query.dateTo ? query.dateTo : '';
  var bankID = query.bankID ? query.bankID : [];
  var statusGroup = query.statusGroup || 'all';
  var status = query.status ? query.status : '';
  return {
    bankID: bankID,
    projectID: projectID,
    sortColumn: sortColumn,
    sortDirection: sortDirection,
    search: search,
    dateRange: dateRange,
    dateFrom: dateFrom,
    dateTo: dateTo,
    statusGroup: statusGroup,
    status: status
  };
};

BankAverageAging.getPropsToState = function (props) {
  var windowWidth = window.innerWidth;
  var isMobile = windowWidth < 768;
  var query = (0, _url.decodeSearch)(props.location.search);
  var status = query.status || '';
  return {
    isMobile: isMobile,
    status: status
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.getColSpan = function () {
    var isMobile = _this5.state.isMobile;

    var _checkStatus2 = _this5.checkStatus(),
        showCurrent = _checkStatus2.showCurrent,
        showClosed = _checkStatus2.showClosed,
        showCustom = _checkStatus2.showCustom;

    if (showCustom) {
      return 2;
    }
    var span = 1; // bank column
    if (showCurrent) {
      var currentSpan = 1 + (isMobile ? 0 : _bankCaseStatuses.CURRENT_STATUSES.filter(_this5.filterStatus).length);
      span += currentSpan;
    }
    if (showClosed) {
      var closedSpan = 1 + (isMobile ? 0 : _bankCaseStatuses.CLOSED_STATUSES.filter(_this5.filterStatus).length);
      span += closedSpan;
    }
    return span;
  };

  this.handleResize = function () {
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    if (isMobile !== _this5.state.isMobile) {
      _this5.setState({ isMobile: isMobile });
    }
  };

  this.handleCellSort = function (key) {
    var defaultCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var column = sortItems[key].sortColumn;

    var _decodeSearch2 = (0, _url.decodeSearch)(_this5.props.location.search),
        sortColumn = _decodeSearch2.sortColumn,
        sortDirection = _decodeSearch2.sortDirection;

    var direction = 'asc';
    if (defaultCell && sortColumn === undefined) {
      direction = 'desc';
    }
    if (column === sortColumn) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc';
    }
    _this5.handleSortData(column, direction);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this5.replaceQuery(query);
  };

  this.handleTitleClick = function (e, idx) {
    var bankActives = _this5.state.bankActives;

    bankActives[idx] = !bankActives[idx];
    _this5.setState({ bankActives: bankActives });
  };

  this.filterStatus = function (cs) {
    var _BankAverageAging$get2 = BankAverageAging.getQueryData(_this5.props),
        status = _BankAverageAging$get2.status,
        statusGroup = _BankAverageAging$get2.statusGroup;

    switch (statusGroup) {
      case 'current':
        return _bankCaseStatuses.CURRENT_STATUSES.some(function (s) {
          return cs === s;
        });
      case 'closed':
        return _bankCaseStatuses.CLOSED_STATUSES.some(function (s) {
          return cs === s;
        });
      case 'custom':
        if (status && status.length > 0) {
          return status.some(function (s) {
            return s === cs;
          });
        }
        break;
      default:
    }
    return true;
  };

  this.filterStatusCount = function (cs, bankData) {
    var count = bankData[_lodash2.default.camelCase('average_' + cs + '_age')];

    var _BankAverageAging$get3 = BankAverageAging.getQueryData(_this5.props),
        status = _BankAverageAging$get3.status,
        statusGroup = _BankAverageAging$get3.statusGroup;

    if (statusGroup && statusGroup === 'custom' && status !== '') {
      return cs === status;
    }
    return count > 0;
  };

  this.checkStatus = function () {
    var _BankAverageAging$get4 = BankAverageAging.getQueryData(_this5.props),
        statusGroup = _BankAverageAging$get4.statusGroup;

    var showCurrent = statusGroup === 'all' || statusGroup === 'current';
    var showClosed = statusGroup === 'all' || statusGroup === 'closed';
    var showCustom = statusGroup === 'custom';
    return {
      showCurrent: showCurrent,
      showClosed: showClosed,
      showCustom: showCustom
    };
  };

  this.renderHeaderCell = function (status, idx, className) {
    if (sortItems.some(function (item) {
      return item.status === status;
    })) {
      var isMobile = _this5.state.isMobile;
      var t = _this5.props.t;

      var _BankAverageAging$get5 = BankAverageAging.getQueryData(_this5.props),
          statusGroup = _BankAverageAging$get5.statusGroup;

      var key = sortItems.findIndex(function (item) {
        return item.status === status;
      });
      var statusItem = sortItems.find(function (item) {
        return item.status === status;
      });
      var text = statusItem.text.substring(0, statusItem.text.lastIndexOf(' '));
      var translatedText = t(text, { ns: _translation.TRANSLATION_FILES.constants });
      return _react2.default.createElement(
        _semanticUiReact.Table.HeaderCell,
        {
          key: idx,
          className: className,
          sorted: _this5.cellCheckSorted(key),
          onClick: isMobile || statusGroup !== 'all' ? function () {
            return _this5.handleCellSort(key);
          } : null
        },
        isMobile || statusGroup !== 'all' ? _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'small',
            null,
            translatedText
          ),
          '\xA0',
          _this5.cellCheckSorted(key) ? null : _react2.default.createElement(_semanticUiReact.Icon, {
            inverted: true, color: 'grey',
            name: 'sort'
          })
        ) : _react2.default.createElement(
          'div',
          { className: 'text' },
          translatedText
        )
      );
    }
    return null;
  };

  this.renderDataCell = function (status, idx, bankData) {
    return _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      {
        key: idx,
        textAlign: 'right'
      },
      bankData[_lodash2.default.camelCase('average_' + status + '_age')]
    );
  };

  this.renderListItem = function (status, idx, bankData) {
    if (sortItems.some(function (item) {
      return item.status === status;
    })) {
      var t = _this5.props.t;

      var statusItem = sortItems.find(function (item) {
        return item.status === status;
      });
      var text = statusItem.text.substring(0, statusItem.text.lastIndexOf(' '));
      var count = bankData[_lodash2.default.camelCase('average_' + status + '_age')];
      return _react2.default.createElement(
        _semanticUiReact.List.Item,
        { key: idx },
        _react2.default.createElement(
          _semanticUiReact.List.Content,
          null,
          _react2.default.createElement(
            'small',
            { style: { float: 'left' } },
            t(text, { ns: _translation.TRANSLATION_FILES.constants })
          ),
          _react2.default.createElement(
            'small',
            { style: { float: 'right' } },
            count
          )
        )
      );
    }
    return null;
  };

  this.renderTableHeader = function () {
    var isMobile = _this5.state.isMobile;
    var t = _this5.props.t;

    var _BankAverageAging$get6 = BankAverageAging.getQueryData(_this5.props),
        statusGroup = _BankAverageAging$get6.statusGroup;

    var _checkStatus3 = _this5.checkStatus(),
        showCurrent = _checkStatus3.showCurrent,
        showClosed = _checkStatus3.showClosed,
        showCustom = _checkStatus3.showCustom;

    var key = sortItems.findIndex(function (item) {
      return item.status === _this5.state.status;
    });
    var currentTotalkey = sortItems.findIndex(function (item) {
      return item.sortColumn === 'total_current_average';
    });
    var closedTotalkey = sortItems.findIndex(function (item) {
      return item.sortColumn === 'total_closed_average';
    });
    return _react2.default.createElement(
      _semanticUiReact.Table.Row,
      { style: { borderBottom: '#bbb 2px solid' }, verticalAlign: 'bottom' },
      _react2.default.createElement(
        _semanticUiReact.Table.HeaderCell,
        {
          className: 'bank bold',
          sorted: _this5.cellCheckSorted(0, true),
          onClick: isMobile || statusGroup !== 'all' ? function () {
            return _this5.handleCellSort(0, true);
          } : null
        },
        isMobile || statusGroup !== 'all' ? _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'small',
            null,
            t('Bank')
          ),
          '\xA0',
          _this5.cellCheckSorted(0, true) ? null : _react2.default.createElement(_semanticUiReact.Icon, {
            inverted: true, color: 'grey',
            name: 'sort'
          })
        ) : _react2.default.createElement(
          'div',
          { className: 'text' },
          t('Bank')
        )
      ),
      showCustom && _react2.default.createElement(
        _semanticUiReact.Table.HeaderCell,
        {
          sorted: key > 0 ? _this5.cellCheckSorted(key) : null,
          onClick: key > 0 ? function () {
            return _this5.handleCellSort(key);
          } : null,
          style: { display: 'flex' }
        },
        _react2.default.createElement(_BookingSelectList2.default, {
          style: { flex: 1 },
          filterName: 'status',
          onChange: _this5.props.onFilterChange,
          onClose: _this5.props.onFilterClose,
          options: _bankCaseStatuses2.default.map(function (s) {
            return _extends({}, s, {
              text: t(s.text, { ns: _translation.TRANSLATION_FILES.constants })
            });
          }),
          placeholder: t('Select Status'),
          value: _this5.state.status,
          disabled: _this5.state.loading
        }),
        key > 0 && (_this5.cellCheckSorted(key) ? null : _react2.default.createElement(_semanticUiReact.Icon, {
          inverted: true, color: 'grey',
          name: 'sort'
        }))
      ),
      !isMobile && showCurrent && _bankCaseStatuses.CURRENT_STATUSES.filter(_this5.filterStatus).map(function (s, idx) {
        return _this5.renderHeaderCell(s, idx, 'current');
      }),
      (showCurrent || isMobile && !showClosed && !showCurrent && !showCustom) && _react2.default.createElement(
        _semanticUiReact.Table.HeaderCell,
        {
          className: 'current bold',
          sorted: _this5.cellCheckSorted(currentTotalkey),
          onClick: isMobile || statusGroup !== 'all' ? function () {
            return _this5.handleCellSort(currentTotalkey);
          } : null,
          style: showClosed ? {
            borderLeft: '#bbb 2px solid',
            borderRight: '2px solid #2185D0'
          } : { borderLeft: '#bbb 2px solid' }
        },
        isMobile || statusGroup !== 'all' ? _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'small',
            null,
            t('Current Total')
          ),
          '\xA0',
          _this5.cellCheckSorted(currentTotalkey) ? null : _react2.default.createElement(_semanticUiReact.Icon, {
            inverted: true, color: 'grey',
            name: 'sort'
          })
        ) : _react2.default.createElement(
          'div',
          { className: 'text' },
          t('Current Total')
        )
      ),
      !isMobile && showClosed && _bankCaseStatuses.CLOSED_STATUSES.filter(_this5.filterStatus).map(function (s, idx) {
        return _this5.renderHeaderCell(s, idx, 'closed');
      }),
      (showClosed || isMobile && !showClosed && !showCurrent && !showCustom) && _react2.default.createElement(
        _semanticUiReact.Table.HeaderCell,
        {
          className: 'closed bold',
          sorted: _this5.cellCheckSorted(closedTotalkey),
          onClick: isMobile || statusGroup !== 'all' ? function () {
            return _this5.handleCellSort(closedTotalkey);
          } : null,
          style: { borderLeft: '#bbb 2px solid' }
        },
        isMobile || statusGroup !== 'all' ? _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(
            'small',
            null,
            t('Closed Total')
          ),
          '\xA0',
          _this5.cellCheckSorted(closedTotalkey) ? null : _react2.default.createElement(_semanticUiReact.Icon, {
            inverted: true, color: 'grey',
            name: 'sort'
          })
        ) : _react2.default.createElement(
          'div',
          { className: 'text' },
          t('Closed Total')
        )
      )
    );
  };

  this.renderTableBody = function (item, idx, arr) {
    var _state = _this5.state,
        isMobile = _state.isMobile,
        bankActives = _state.bankActives;

    var _BankAverageAging$get7 = BankAverageAging.getQueryData(_this5.props),
        status = _BankAverageAging$get7.status;

    var _checkStatus4 = _this5.checkStatus(),
        showCurrent = _checkStatus4.showCurrent,
        showClosed = _checkStatus4.showClosed,
        showCustom = _checkStatus4.showCustom;

    return _react2.default.createElement(
      _semanticUiReact.Table.Row,
      {
        key: idx,
        verticalAlign: 'top',
        style: idx === arr.length - 1 ? { borderBottom: '#bbb 2px solid' } : null
      },
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        null,
        isMobile && !showCustom ? _react2.default.createElement(
          _semanticUiReact.Accordion,
          null,
          _react2.default.createElement(
            _semanticUiReact.Accordion.Title,
            {
              active: bankActives[idx],
              onClick: function onClick(e) {
                return _this5.handleTitleClick(e, idx);
              }
            },
            item.bank && item.bank.shortName,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'angle ' + (bankActives[idx] ? 'down' : 'right'), style: { float: 'right' } })
          )
        ) : item.bank && item.bank.shortName
      ),
      showCustom && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { textAlign: 'right' },
        status && status !== '' && item[_lodash2.default.camelCase('average_' + status + '_age')]
      ),
      !isMobile && showCurrent && _bankCaseStatuses.CURRENT_STATUSES.filter(_this5.filterStatus).map(function (state, sidx) {
        return _this5.renderDataCell(state, sidx, item);
      }),
      (showCurrent || isMobile && !showClosed && !showCurrent && !showCustom) && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        {
          textAlign: 'right',
          style: showClosed ? {
            borderLeft: '#bbb 2px solid',
            borderRight: '2px solid #2185D0'
          } : { borderLeft: '#bbb 2px solid' }
        },
        isMobile ? _react2.default.createElement(
          _semanticUiReact.Accordion,
          null,
          _react2.default.createElement(
            _semanticUiReact.Accordion.Title,
            {
              active: bankActives[idx],
              onClick: function onClick(e) {
                return _this5.handleTitleClick(e, idx);
              }
            },
            _react2.default.createElement(
              'strong',
              { style: { fontSize: '1.1em' } },
              item.totalCurrentAverage
            )
          ),
          showCurrent && _react2.default.createElement(
            _semanticUiReact.Accordion.Content,
            { active: bankActives[idx] },
            _react2.default.createElement(
              _semanticUiReact.List,
              { relaxed: true },
              _bankCaseStatuses.CURRENT_STATUSES.map(function (cs, i) {
                return _this5.renderListItem(cs, i, item);
              })
            )
          )
        ) : _react2.default.createElement(
          'strong',
          { style: { fontSize: '1.1em' } },
          item.totalCurrentAverage
        )
      ),
      !isMobile && showClosed && _bankCaseStatuses.CLOSED_STATUSES.filter(_this5.filterStatus).map(function (state, sidx) {
        return _this5.renderDataCell(state, sidx, item);
      }),
      (showClosed || isMobile && !showClosed && !showCurrent && !showCustom) && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        {
          textAlign: 'right',
          style: { borderLeft: '#bbb 2px solid' }
        },
        isMobile ? _react2.default.createElement(
          _semanticUiReact.Accordion,
          null,
          _react2.default.createElement(
            _semanticUiReact.Accordion.Title,
            {
              active: bankActives[idx],
              onClick: function onClick(e) {
                return _this5.handleTitleClick(e, idx);
              }
            },
            _react2.default.createElement(
              'strong',
              { style: { fontSize: '1.1em' } },
              item.totalClosedAverage
            )
          ),
          showClosed && _react2.default.createElement(
            _semanticUiReact.Accordion.Content,
            { active: bankActives[idx] },
            _react2.default.createElement(
              _semanticUiReact.List,
              { relaxed: true },
              _bankCaseStatuses.CLOSED_STATUSES.map(function (cs, i) {
                return _this5.renderListItem(cs, i, item);
              })
            )
          )
        ) : _react2.default.createElement(
          'strong',
          { style: { fontSize: '1.1em' } },
          item.totalClosedAverage
        )
      )
    );
  };

  this.renderTotalRow = function () {
    var _state2 = _this5.state,
        data = _state2.data,
        isMobile = _state2.isMobile;

    var _BankAverageAging$get8 = BankAverageAging.getQueryData(_this5.props),
        status = _BankAverageAging$get8.status;

    var _checkStatus5 = _this5.checkStatus(),
        showCurrent = _checkStatus5.showCurrent,
        showClosed = _checkStatus5.showClosed,
        showCustom = _checkStatus5.showCustom;

    var totalAverage = 0;
    if (showCustom) {
      if (status === '') {
        return null;
      }
      if (_bankCaseStatuses.CURRENT_STATUSES.some(function (s) {
        return s === status;
      })) {
        totalAverage = data.totalCurrentAverage;
      } else if (_bankCaseStatuses.CLOSED_STATUSES.some(function (s) {
        return s === status;
      })) {
        totalAverage = data.totalClosedAverage;
      }
    }
    return _react2.default.createElement(
      _semanticUiReact.Table.Row,
      { style: { borderBottom: '#bbb 2px solid' } },
      (showCurrent || showCustom) && _react2.default.createElement(_semanticUiReact.Table.Cell, {
        colSpan: 1 + (showCustom || isMobile ? 0 : _bankCaseStatuses.CURRENT_STATUSES.filter(_this5.filterStatus).length)
      }),
      (showCurrent || isMobile && !showClosed && !showCurrent && !showCustom) && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        {
          textAlign: 'right',
          style: showClosed ? {
            borderLeft: '#bbb 2px solid',
            borderRight: '2px solid #2185D0'
          } : { borderLeft: '#bbb 2px solid' }
        },
        _react2.default.createElement(
          'strong',
          { style: { fontSize: '1.2em' } },
          data.totalCurrentAverage
        )
      ),
      showClosed && (isMobile && !showCurrent || !isMobile) && _react2.default.createElement(_semanticUiReact.Table.Cell, {
        colSpan: (isMobile ? 0 : _bankCaseStatuses.CLOSED_STATUSES.filter(_this5.filterStatus).length) + (showCurrent ? 0 : 1)
      }),
      (showClosed || isMobile && !showClosed && !showCurrent && !showCustom) && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        {
          textAlign: 'right',
          style: { borderLeft: '#bbb 2px solid' }
        },
        _react2.default.createElement(
          'strong',
          { style: { fontSize: '1.2em' } },
          data.totalClosedAverage
        )
      ),
      showCustom && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { textAlign: 'right' },
        _react2.default.createElement(
          'strong',
          { style: { fontSize: '1.2em' } },
          totalAverage
        )
      )
    );
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(BankAverageAging);

/***/ }),
/* 2180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _reactCountup = __webpack_require__(686);

var _reactCountup2 = _interopRequireDefault(_reactCountup);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _url = __webpack_require__(19);

var _currencies = __webpack_require__(592);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _bookingStatuses = __webpack_require__(128);

var _bookingStatuses2 = _interopRequireDefault(_bookingStatuses);

var _translation = __webpack_require__(4);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _OverallBookingReports = __webpack_require__(2184);

var _OverallBookingReports2 = _interopRequireDefault(_OverallBookingReports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint prefer-spread: 0 */


var BookingsByStatus = function (_Component) {
  _inherits(BookingsByStatus, _Component);

  function BookingsByStatus(props) {
    _classCallCheck(this, BookingsByStatus);

    var _this = _possibleConstructorReturn(this, (BookingsByStatus.__proto__ || Object.getPrototypeOf(BookingsByStatus)).call(this, props));

    _initialiseProps.call(_this);

    var projectCurrencies = props.projectCurrencies;
    _this.state = {
      reportData: [],
      loading: true,
      projectCurrencies: projectCurrencies
    };
    return _this;
  }

  _createClass(BookingsByStatus, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchReports();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var query = BookingsByStatus.getQueryData(this.props);
      var newQuery = BookingsByStatus.getQueryData(nextProps);
      var projectCurrencies = nextProps.projectCurrencies;
      this.setState({
        projectCurrencies: projectCurrencies
      });
      if (query.dateRange !== newQuery.dateRange || query.dateTo !== newQuery.dateTo || query.dateFrom !== newQuery.dateFrom || query.projectID !== newQuery.projectID || query.businessUnitID !== newQuery.businessUnitID) {
        this.setState({
          reportData: []
        }, function () {
          _this2.fetchReports(nextProps);
        });
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'getConversionAmount',
    value: function getConversionAmount(amount) {
      var _state$projectCurrenc = this.state.projectCurrencies,
          projectCurrencies = _state$projectCurrenc === undefined ? [] : _state$projectCurrenc;
      var company = this.props.auth.company;

      var companyBaseCurrency = (0, _currencies.getCompanyBaseCurrency)(company);
      var displayCurrency = (0, _currencies.getDisplayCurrency)();
      var companyCurrencyInProject = projectCurrencies.find(function (e) {
        return e.code === companyBaseCurrency.code;
      });
      var displayCurrencyInProject = projectCurrencies.find(function (e) {
        return e.code === displayCurrency;
      });
      var projectBaseCurrency = projectCurrencies.find(function (e) {
        return e.isDefault;
      });
      return (0, _currencies.calcConversionAmount)(companyCurrencyInProject, displayCurrencyInProject, projectBaseCurrency, amount);
    }
  }, {
    key: 'setDisplayCurrencySymbol',
    value: function setDisplayCurrencySymbol(appConfig) {
      // if there is projectCurrencies, means it is in project level, else is company wide,
      // thus should show base currency symbol instead of display currency symbol
      var _state$projectCurrenc2 = this.state.projectCurrencies,
          projectCurrencies = _state$projectCurrenc2 === undefined ? [] : _state$projectCurrenc2;

      if (projectCurrencies.length > 0) {
        return (0, _currencies.getDisplayCurrencySymbol)();
      }
      return appConfig && appConfig.data && appConfig.data.currency ? appConfig.data.currency.symbol : '';
    }
  }, {
    key: 'fetchReports',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        var store, t, q, projectID, query, res, message, reportData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                q = (0, _url.decodeSearch)(props.location.search);
                projectID = props.projectID || q.projectID || '';
                query = Object.assign({}, q);

                if (projectID !== '') {
                  query.projectID = projectID;
                }
                res = void 0;
                _context.prev = 9;
                _context.next = 12;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/reports/bookings/statuses/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context.sent;
                _context.next = 23;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](9);

                Bugsnag.notifyException(_context.t0);
                _context.next = 20;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 20:
                _context.next = 22;
                return this.setLoading(false);

              case 22:
                return _context.abrupt('return');

              case 23:
                if (res.ok) {
                  _context.next = 31;
                  break;
                }

                _context.next = 26;
                return res.text();

              case 26:
                message = _context.sent;
                _context.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 29:
                _context.next = 36;
                break;

              case 31:
                _context.next = 33;
                return res.json();

              case 33:
                reportData = _context.sent;
                _context.next = 36;
                return this.setComponentState({
                  reportData: reportData
                });

              case 36:
                _context.next = 38;
                return this.setLoading(false);

              case 38:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 15]]);
      }));

      function fetchReports() {
        return _ref.apply(this, arguments);
      }

      return fetchReports;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          barChart = _props.barChart,
          headerColor = _props.headerColor,
          t = _props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { style: { margin: '-1rem 0' } },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { style: barChart && { paddingTop: '0' } },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Dimmer,
              {
                inverted: true, style: { zIndex: 20 },
                active: this.state.loading
              },
              _react2.default.createElement(
                _semanticUiReact.Loader,
                { inline: 'centered' },
                t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
              )
            ),
            barChart ? _react2.default.createElement(
              _semanticUiReact.Segment,
              { color: headerColor },
              this.renderTable()
            ) : this.renderTable(),
            (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) && _react2.default.createElement(_OverallBookingReports2.default, {
              location: this.props.location
            })
          )
        )
      );
    }
  }]);

  return BookingsByStatus;
}(_react.Component);

BookingsByStatus.contextTypes = {
  store: _propTypes2.default.object
};
BookingsByStatus.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      currency: _propTypes2.default.shape({
        code: _propTypes2.default.string,
        symbol: _propTypes2.default.string
      })
    })
  }),
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.object,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool
  }),
  barChart: _propTypes2.default.bool,
  headerColor: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }).isRequired,
  projectID: _propTypes2.default.string,
  projectCurrencies: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  t: _propTypes2.default.func
};

BookingsByStatus.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig,
    auth: state.auth
  };
};

BookingsByStatus.getQueryData = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var projectID = query.projectID || '';
  var dateRange = query.dateRange || '';
  var dateFrom = query.dateFrom ? query.dateFrom : '';
  var dateTo = query.dateTo ? query.dateTo : '';
  var businessUnitID = query.businessUnitID ? query.businessUnitID : '';
  return {
    projectID: projectID,
    dateRange: dateRange,
    dateFrom: dateFrom,
    dateTo: dateTo,
    businessUnitID: businessUnitID
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.getValueName = function (value, arr) {
    var t = _this5.props.t;

    var valueName = arr.find(function (vn) {
      return vn.value === value;
    });
    if (valueName && valueName.text) {
      return t(valueName.text, { ns: _translation.TRANSLATION_FILES.constants });
    }
    return '';
  };

  this.getBarStatusColor = function (statusID) {
    switch (statusID) {
      case 'reserved':
        return 'yellow';
      case 'booked':
        return 'red';
      case 'cancelled_developer':
        return 'brown';
      case 'cancelled_availability':
        return 'brown';
      case 'expired':
        return 'brown';
      case 'sold_spa_signed':
        return 'teal';
      default:
        return 'teal';
    }
  };

  this.getBarPercent = function (data, statusCount) {
    var total = Math.max.apply(Math, data.map(function (m) {
      if (m.statusID !== 'total') {
        return m.count;
      }
      return 0;
    }));
    if (total) {
      return Math.floor(statusCount / total * 100);
    }
    return 0;
  };

  this.checkData = function (data) {
    var newData = [];
    var arr = ['reserved', 'booked', 'cancelled_developer', 'sold_spa_signed', 'cancelled_availability', 'expired', 'total'];
    data.forEach(function (s) {
      var newStatus = s;
      switch (newStatus.statusID) {
        case 'reserved':
          {
            newStatus.order = 1;
            newData.push(newStatus);
            break;
          }
        case 'booked':
          {
            newStatus.order = 2;
            newData.push(newStatus);
            break;
          }
        case 'cancelled_developer':
          {
            newStatus.order = 3;
            newData.push(newStatus);
            break;
          }
        case 'sold_spa_signed':
          {
            newStatus.order = 4;
            newData.push(newStatus);
            break;
          }
        case 'cancelled_availability':
          {
            newStatus.order = 5;
            newData.push(newStatus);
            break;
          }
        case 'expired':
          {
            newStatus.order = 6;
            newData.push(newStatus);
            break;
          }
        case 'total':
          {
            break; // remove total
          }
        default:
          newData.push(newStatus);
          break;
      }
    });
    arr.forEach(function (s, idx) {
      var newStatus = {
        order: idx,
        statusID: s,
        count: 0,
        sumSPAValue: 0
      };
      var found = data.find(function (f) {
        return f.statusID === s;
      });
      if (!found) {
        newData.push(newStatus);
      }
    });
    var sortedData = newData.sort(function (a, b) {
      if (a.order < b.order) {
        return -1;
      }
      if (a.order > b.order) {
        return 1;
      }
      return 0;
    });
    return sortedData;
  };

  this.renderTable = function () {
    var _props2 = _this5.props,
        barChart = _props2.barChart,
        headerColor = _props2.headerColor,
        appConfig = _props2.appConfig,
        t = _props2.t;
    var projectCurrencies = _this5.state.projectCurrencies;

    var data = _this5.checkData(_this5.state.reportData);
    if (data && data.length > 0) {
      return _react2.default.createElement(
        _semanticUiReact.Table,
        {
          basic: barChart && 'very',
          celled: !barChart,
          structured: !barChart,
          color: !barChart ? headerColor : null,
          compact: true,
          unstackable: true
        },
        _react2.default.createElement(
          _semanticUiReact.Table.Header,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              null,
              t('Booking Status')
            ),
            barChart && _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { textAlign: barChart ? 'left' : 'right', className: barChart ? 'hide-mobile-six-hundred-px' : null },
              t('Count')
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { textAlign: 'right' },
              t('Selling Price Sum')
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { textAlign: 'right' },
              t('Nett Price Sum')
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Body,
          null,
          data.map(function (statusReport, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Table.Row,
              {
                key: idx,
                style: statusReport.statusID === 'total' ? { fontWeight: 'bold' } : {}
              },
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                _this5.getValueName(statusReport.statusID, _bookingStatuses2.default)
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'right' },
                barChart ? _react2.default.createElement(_reactCountup2.default, {
                  duration: 2.1,
                  end: _this5.state.loading ? 0 : statusReport.count,
                  start: 0,
                  useEasing: true
                }) : statusReport.count
              ),
              barChart && _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'left', className: 'hide-mobile-six-hundred-px', width: 3 },
                _react2.default.createElement(_semanticUiReact.Progress, {
                  className: 'progress-barchart ' + statusReport.statusID,
                  percent: _this5.state.loading ? 0 : _this5.getBarPercent(data, statusReport.count)
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'right' },
                barChart ? _react2.default.createElement(_reactCountup2.default, {
                  decimals: 2,
                  redraw: true,
                  duration: 2,
                  end: _this5.getConversionAmount(statusReport.sumSPAValue),
                  prefix: _this5.setDisplayCurrencySymbol(appConfig),
                  useEasing: true,
                  useGrouping: true,
                  separator: ','
                }) : _react2.default.createElement(_LoanAmount2.default, {
                  projectCurrencies: projectCurrencies,
                  amount: statusReport.sumSPAValue,
                  format: '0,000,000.00',
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'right' },
                barChart ? _react2.default.createElement(_reactCountup2.default, {
                  decimals: 2,
                  redraw: true,
                  duration: 2,
                  end: _this5.getConversionAmount(statusReport.sumNettValue),
                  prefix: _this5.setDisplayCurrencySymbol(appConfig),
                  useEasing: true,
                  useGrouping: true,
                  separator: ','
                }) : _react2.default.createElement(_LoanAmount2.default, {
                  projectCurrencies: projectCurrencies,
                  amount: statusReport.sumNettValue,
                  format: '0,000,000.00',
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                })
              )
            );
          })
        )
      );
    }
    return null;
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(BookingsByStatus.mapStateToProps)(BookingsByStatus));

/***/ }),
/* 2181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortItems = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _bookingStatuses = __webpack_require__(128);

var _bookingStatuses2 = _interopRequireDefault(_bookingStatuses);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sortItems = exports.sortItems = [{
  text: 'Branch Ascending',
  icon: 'sort alphabet ascending',
  sortColumn: 'name',
  sortDirection: 'asc'
}, {
  text: 'Branch Descending',
  icon: 'sort alphabet descending',
  sortColumn: 'name',
  sortDirection: 'desc'
}, {
  text: 'Count Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'count',
  sortDirection: 'asc'
}, {
  text: 'Count Descending',
  icon: 'sort numeric descending',
  sortColumn: 'count',
  sortDirection: 'desc'
}, {
  text: 'Selling Price Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'spa_value',
  sortDirection: 'asc'
}, {
  text: 'Selling Price Descending',
  icon: 'sort numeric descending',
  sortColumn: 'spa_value',
  sortDirection: 'desc'
}];

var BranchBookings = function (_Component) {
  _inherits(BranchBookings, _Component);

  function BranchBookings(props) {
    _classCallCheck(this, BranchBookings);

    var _this = _possibleConstructorReturn(this, (BranchBookings.__proto__ || Object.getPrototypeOf(BranchBookings)).call(this, props));

    _initialiseProps.call(_this);

    var state = BranchBookings.getPropsToState(props);
    _this.state = _extends({}, state, {
      count: 0,
      data: [],
      limit: 0,
      loading: true,
      offset: 0
    });
    return _this;
  }

  _createClass(BranchBookings, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
        delete query.page;
      }
      this.fetchReports(query);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var query = BranchBookings.getQueryData(this.props);
      var newQuery = BranchBookings.getQueryData(nextProps);
      var refetch = query.projectID !== newQuery.projectID || query.sortColumn !== newQuery.sortColumn || query.sortDirection !== newQuery.sortDirection || query.search !== newQuery.search || query.dateRange !== newQuery.dateRange || query.dateTo !== newQuery.dateTo || query.dateFrom !== newQuery.dateFrom || query.page !== newQuery.page;
      var state = BranchBookings.getPropsToState(nextProps);
      this.setState(_extends({}, state), function () {
        if (refetch) {
          var q = (0, _url.decodeSearch)(nextProps.location.search);
          _this2.fetchReports(q);
        }
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cb = arguments[1];

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
          if (cb) {
            cb();
          }
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
          if (_this4.props.onLoading) {
            _this4.props.onLoading(loading);
          }
        });
      });
    }
  }, {
    key: 'cellCheckSorted',
    value: function cellCheckSorted(key) {
      var defaultCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var column = sortItems[key].sortColumn;

      var _decodeSearch = (0, _url.decodeSearch)(this.props.location.search),
          sortColumn = _decodeSearch.sortColumn,
          sortDirection = _decodeSearch.sortDirection;

      if (defaultCell && sortColumn === undefined) {
        return 'ascending';
      }
      if (column === sortColumn) {
        return sortDirection === 'asc' ? 'ascending' : 'descending';
      }
      return null;
    }
  }, {
    key: 'fetchReports',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var store, t, query, projectID, res, message, count, limit, offset, json, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, q);

                delete query.projectID;
                projectID = this.props.projectID || q.projectID || '';

                if (projectID !== '') {
                  query.projectID = projectID;
                }
                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                res = void 0;
                _context.prev = 10;
                _context.next = 13;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/reports/bookings/branch/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 13:
                res = _context.sent;
                _context.next = 24;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](10);

                Bugsnag.notifyException(_context.t0);
                _context.next = 21;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 21:
                _context.next = 23;
                return this.setLoading(false);

              case 23:
                return _context.abrupt('return');

              case 24:
                if (res.ok) {
                  _context.next = 32;
                  break;
                }

                _context.next = 27;
                return res.text();

              case 27:
                message = _context.sent;
                _context.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 30:
                _context.next = 41;
                break;

              case 32:
                count = parseInt(res.headers.get('M-Data-Count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context.next = 37;
                return res.json();

              case 37:
                json = _context.sent;
                data = this.generatePivot(json, 'maUserAffiliateCompanyBranchID', 'maUserAffiliateCompanyBranchShortName');
                _context.next = 41;
                return this.setComponentState({
                  count: count,
                  data: data,
                  limit: limit,
                  offset: offset
                }, this.handleOnPageNavData);

              case 41:
                _context.next = 43;
                return this.setLoading(false);

              case 43:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[10, 16]]);
      }));

      function fetchReports(_x4) {
        return _ref.apply(this, arguments);
      }

      return fetchReports;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;
      var pathname = this.props.location.pathname;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));
    }
  }, {
    key: 'setPrefix',
    value: function setPrefix() {
      var _state$projectCurrenc = this.state.projectCurrencies,
          projectCurrencies = _state$projectCurrenc === undefined ? [] : _state$projectCurrenc;
      var _props$appConfig = this.props.appConfig,
          appConfig = _props$appConfig === undefined ? null : _props$appConfig;

      if (projectCurrencies.length > 0) {
        return _react2.default.createElement(_CurrencySymbol2.default, null);
      }
      return appConfig && appConfig.data && appConfig.data.currency ? appConfig.data.currency.symbol : '';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state = this.state,
          data = _state.data,
          projectCurrencies = _state.projectCurrencies;
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { style: { margin: '-1rem 0' } },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Segment,
              { color: this.props.headerColor },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'users-bookings table' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { className: 'mobile-report-table' },
                    _react2.default.createElement(
                      _semanticUiReact.Dimmer,
                      {
                        inverted: true, style: { zIndex: 20 },
                        active: this.state.loading
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Loader,
                        { inline: 'centered' },
                        t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                      )
                    ),
                    data && data.length > 0 ? _react2.default.createElement(
                      _semanticUiReact.Table,
                      {
                        celled: true,
                        compact: true,
                        unstackable: true,
                        structured: true,
                        sortable: true,
                        style: { marginTop: 0 }
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Header,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Table.Row,
                          {
                            style: { borderBottom: '#bbb 2px solid' }
                          },
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            {
                              sorted: this.cellCheckSorted(0, true),
                              onClick: function onClick() {
                                return _this5.handleCellSort(0, true);
                              }
                            },
                            t('Business Unit'),
                            '\xA0',
                            this.cellCheckSorted(0, true) ? null : _react2.default.createElement(_semanticUiReact.Icon, {
                              inverted: true, color: 'grey',
                              name: 'sort'
                            })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            t('Booking Status')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            {
                              textAlign: 'right',
                              sorted: this.cellCheckSorted(2),
                              onClick: function onClick() {
                                return _this5.handleCellSort(2);
                              }
                            },
                            this.cellCheckSorted(2) ? null : _react2.default.createElement(_semanticUiReact.Icon, {
                              inverted: true, color: 'grey',
                              name: 'sort'
                            }),
                            '\xA0',
                            t('Count')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            {
                              textAlign: 'right',
                              sorted: this.cellCheckSorted(4),
                              onClick: function onClick() {
                                return _this5.handleCellSort(4);
                              }
                            },
                            this.cellCheckSorted(4) ? null : _react2.default.createElement(_semanticUiReact.Icon, {
                              inverted: true, color: 'grey',
                              name: 'sort'
                            }),
                            '\xA0',
                            t('Selling Price Sum')
                          )
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Body,
                        null,
                        data.map(function (pivoted) {
                          return pivoted.data.map(function (pivotedData, idxp) {
                            return _react2.default.createElement(
                              _semanticUiReact.Table.Row,
                              {
                                key: idxp,
                                style: pivoted.data.length === idxp + 1 ? { borderBottom: '#bbb 2px solid' } : {}
                              },
                              pivoted.rowSpan && idxp === 0 && _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                {
                                  rowSpan: pivoted.rowSpan,
                                  style: { borderBottom: '#bbb 2px solid' }
                                },
                                pivoted.title
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _this5.getValueName(pivotedData.statusID, _bookingStatuses2.default)
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { textAlign: 'right' },
                                pivotedData.count
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { textAlign: 'right' },
                                _react2.default.createElement(_LoanAmount2.default, {
                                  projectCurrencies: projectCurrencies,
                                  format: '0,000,000.00',
                                  amount: pivotedData.sumSPAValue,
                                  prefix: _this5.setPrefix()
                                })
                              )
                            );
                          });
                        })
                      )
                    ) : _react2.default.createElement(
                      _semanticUiReact.Item,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Item.Content,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Segment,
                          { textAlign: 'center' },
                          this.state.loading ? _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }) : t('No reports found') + '.'
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'center' },
                    _react2.default.createElement(_PageNav2.default, {
                      upward: true,
                      currentPage: this.state.currentPage,
                      count: this.state.count,
                      limit: this.state.limit,
                      offset: this.state.offset,
                      dataSize: this.state.data.length,
                      loading: this.state.loading,
                      onChange: this.handleChangePage,
                      noScrollTop: true
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return BranchBookings;
}(_react.Component);

BranchBookings.contextTypes = {
  store: _propTypes2.default.object
};
BranchBookings.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      currency: _propTypes2.default.shape({
        code: _propTypes2.default.string,
        symbol: _propTypes2.default.string
      })
    })
  }),
  headerColor: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }).isRequired,
  onLoading: _propTypes2.default.func,
  onPageNav: _propTypes2.default.func,
  projectID: _propTypes2.default.string,
  projectCurrencies: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  t: _propTypes2.default.func
};

BranchBookings.getQueryData = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var projectID = query.projectID || '';
  var sortColumn = query.sortColumn || '';
  var sortDirection = query.sortDirection || '';
  var page = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var dateRange = query.dateRange || '';
  var dateFrom = query.dateFrom ? query.dateFrom : '';
  var dateTo = query.dateTo ? query.dateTo : '';
  return {
    projectID: projectID,
    sortColumn: sortColumn,
    sortDirection: sortDirection,
    page: page,
    search: search,
    dateRange: dateRange,
    dateFrom: dateFrom,
    dateTo: dateTo
  };
};

BranchBookings.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var projectCurrencies = props.projectCurrencies;
  return {
    currentPage: currentPage,
    projectCurrencies: projectCurrencies
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.getValueName = function (value, arr) {
    var t = _this6.props.t;

    var valueName = arr.find(function (vn) {
      return vn.value === value;
    });
    if (valueName && valueName.text) {
      return t(valueName.text, { ns: _translation.TRANSLATION_FILES.constants });
    }
    return '';
  };

  this.generatePivot = function (data, pivotKey, pivotTitle) {
    var pivot = [];
    data.forEach(function (d) {
      var keyValue = d[pivotKey];
      // check if business unit is in array
      var pivotIndex = pivot.findIndex(function (p) {
        return p.keyValue === keyValue;
      });
      var pivotData = {
        data: [],
        key: pivotKey,
        keyValue: keyValue,
        rowSpan: 0,
        title: ''
      };
      if (pivotIndex >= 0) {
        // pivot exist, reuse same entry
        pivotData = pivot[pivotIndex];
      }
      // generate pivot data
      pivotData.data.push(d);
      pivotData.rowSpan = pivotData.data.length;
      pivotData.title = d[pivotTitle];
      if (pivotIndex >= 0) {
        pivot[pivotIndex] = pivotData;
      } else {
        pivot.push(pivotData);
      }
    });
    return pivot;
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.page = currentPage;
    _this6.setState({ currentPage: currentPage }, function () {
      _this6.replaceQuery(query);
    });
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    if (hasQuery) {
      _this6.replaceQuery(query, true);
    }
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query[queryName] = value;
    _this6.replaceQuery(query, true);
  };

  this.handleCellSort = function (key) {
    var defaultCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var column = sortItems[key].sortColumn;

    var _decodeSearch2 = (0, _url.decodeSearch)(_this6.props.location.search),
        sortColumn = _decodeSearch2.sortColumn,
        sortDirection = _decodeSearch2.sortDirection;

    var direction = 'asc';
    if (defaultCell && sortColumn === undefined) {
      direction = 'desc';
    }
    if (column === sortColumn) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc';
    }
    _this6.handleSortData(column, direction);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this6.replaceQuery(query, true);
  };

  this.handleOnPageNavData = function () {
    var onPageNav = _this6.props.onPageNav;

    if (onPageNav) {
      var _state2 = _this6.state,
          count = _state2.count,
          data = _state2.data,
          limit = _state2.limit,
          offset = _state2.offset;

      var dataSize = data.length || 0;
      onPageNav({ count: count, dataSize: dataSize, limit: limit, offset: offset });
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(BranchBookings);

/***/ }),
/* 2182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _reactCountup = __webpack_require__(686);

var _reactCountup2 = _interopRequireDefault(_reactCountup);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _url = __webpack_require__(19);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DelistReasonsByStatus = function (_Component) {
  _inherits(DelistReasonsByStatus, _Component);

  function DelistReasonsByStatus(props) {
    _classCallCheck(this, DelistReasonsByStatus);

    var _this = _possibleConstructorReturn(this, (DelistReasonsByStatus.__proto__ || Object.getPrototypeOf(DelistReasonsByStatus)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      reportData: [],
      reasonsMap: {},
      loading: true,
      refetch: true
    };
    return _this;
  }

  _createClass(DelistReasonsByStatus, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchDelistReasonDefinitions();
      this.fetchReports();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var query = DelistReasonsByStatus.getQueryData(this.props);
      var newQuery = DelistReasonsByStatus.getQueryData(nextProps);
      var refetch = newQuery.dateRange === 'custom' ? !!(newQuery.dateFrom && newQuery.dateTo) : true;
      this.setState({
        refetch: refetch
      });
      if (query.dateRange !== newQuery.dateRange || query.dateTo !== newQuery.dateTo || query.dateFrom !== newQuery.dateFrom || query.projectID !== newQuery.projectID || query.businessUnitID !== newQuery.businessUnitID || newQuery.projectID !== '' && query.projectUnitLayoutID !== newQuery.projectUnitLayoutID) {
        if (refetch) {
          this.setState({
            reportData: []
          }, function () {
            _this2.fetchReports(nextProps);
          });
        }
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
    // The report endpoint returns the reason label, but we also fallback to the master
    // delist-reason list (fetched from /settings/delist_reasons/) for additional lookup

  }, {
    key: 'fetchDelistReasonDefinitions',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, reasons, reasonsMap;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                res = void 0;
                _context.prev = 2;
                _context.next = 5;
                return store.dispatch((0, _fetchM.fetchM)('/settings/delist_reasons/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                res = _context.sent;
                _context.next = 12;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](2);

                Bugsnag.notifyException(_context.t0);
                return _context.abrupt('return');

              case 12:
                if (!(res && res.ok)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 15;
                return res.json();

              case 15:
                reasons = _context.sent;
                reasonsMap = {};

                (reasons || []).forEach(function (reason) {
                  if (reason.id) {
                    reasonsMap[reason.id] = reason.label;
                  }
                  if (reason.name) {
                    reasonsMap[reason.name] = reason.label;
                  }
                });
                _context.next = 20;
                return this.setComponentState({ reasonsMap: reasonsMap });

              case 20:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));

      function fetchDelistReasonDefinitions() {
        return _ref.apply(this, arguments);
      }

      return fetchDelistReasonDefinitions;
    }()
  }, {
    key: 'fetchReports',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        var store, t, q, query, projectID, projectUnitLayoutID, res, apiUrl, message, reportData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                q = (0, _url.decodeSearch)(props.location.search);
                query = Object.assign({}, q);

                delete query.projectID;
                delete query.projectUnitLayoutID;
                projectID = props.projectID || q.projectID || '';
                projectUnitLayoutID = q.projectUnitLayoutID || '';

                if (projectID !== '') {
                  query.projectID = projectID;
                  if (projectUnitLayoutID !== '') {
                    query.projectUnitLayoutID = projectUnitLayoutID;
                  }
                }
                res = void 0;
                _context2.prev = 12;
                apiUrl = _config2.default.get('bookApiURL') + '/reports/project_units/delist_reasons/';
                _context2.next = 16;
                return store.dispatch((0, _fetchM.fetchM)(apiUrl + '?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 16:
                res = _context2.sent;
                _context2.next = 27;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2['catch'](12);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 24:
                _context2.next = 26;
                return this.setLoading(false);

              case 26:
                return _context2.abrupt('return');

              case 27:
                if (res.ok) {
                  _context2.next = 35;
                  break;
                }

                _context2.next = 30;
                return res.text();

              case 30:
                message = _context2.sent;
                _context2.next = 33;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 33:
                _context2.next = 40;
                break;

              case 35:
                _context2.next = 37;
                return res.json();

              case 37:
                reportData = _context2.sent;
                _context2.next = 40;
                return this.setComponentState({
                  reportData: reportData
                });

              case 40:
                _context2.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[12, 19]]);
      }));

      function fetchReports() {
        return _ref2.apply(this, arguments);
      }

      return fetchReports;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          barChart = _props.barChart,
          headerColor = _props.headerColor,
          t = _props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { style: { margin: '-1rem 0' } },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { style: barChart && { paddingTop: '0' } },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Dimmer,
              {
                inverted: true, style: { zIndex: 20 },
                active: this.state.loading
              },
              _react2.default.createElement(
                _semanticUiReact.Loader,
                { inline: 'centered' },
                t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
              )
            ),
            barChart ? _react2.default.createElement(
              _semanticUiReact.Segment,
              { color: headerColor },
              this.renderTable()
            ) : this.renderTable()
          )
        )
      );
    }
  }]);

  return DelistReasonsByStatus;
}(_react.Component);

DelistReasonsByStatus.contextTypes = {
  store: _propTypes2.default.object
};
DelistReasonsByStatus.propTypes = {
  barChart: _propTypes2.default.bool,
  headerColor: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }).isRequired,
  projectID: _propTypes2.default.string,
  t: _propTypes2.default.func
};

DelistReasonsByStatus.mapStateToProps = function () {
  return {};
};

DelistReasonsByStatus.getQueryData = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var projectID = query.projectID || '';
  var projectUnitLayoutID = query.projectUnitLayoutID || '';
  var dateRange = query.dateRange || '';
  var dateFrom = query.dateFrom ? query.dateFrom : '';
  var dateTo = query.dateTo ? query.dateTo : '';
  var businessUnitID = query.businessUnitID ? query.businessUnitID : '';
  return {
    projectID: projectID,
    projectUnitLayoutID: projectUnitLayoutID,
    dateRange: dateRange,
    dateFrom: dateFrom,
    dateTo: dateTo,
    businessUnitID: businessUnitID
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.getReasonLabel = function (reasonReport) {
    var t = _this5.props.t;
    var reasonsMap = _this5.state.reasonsMap;

    if (!reasonReport) {
      return t('No Reason');
    }
    // Candidate identifiers that could appear in the report payload.
    var candidates = [reasonReport.delistReasonID, reasonReport.delistReasonId, reasonReport.delistReasonName, reasonReport.delistReason, reasonReport.reasonID, reasonReport.name, reasonReport.id].filter(function (v) {
      return v != null && v !== '';
    });
    // Look the candidate up in the master map (keyed by id and by name).
    for (var i = 0; i < candidates.length; i += 1) {
      var key = candidates[i];
      if (reasonsMap[key]) {
        return reasonsMap[key];
      }
    }
    // Fall back to any label the report itself provided, then the raw name.
    var fallback = reasonReport.delistReasonLabel || reasonReport.reasonLabel || reasonReport.label || reasonReport.delistReasonName || reasonReport.name;
    return fallback || t('No Reason');
  };

  this.getBarPercent = function (data, count) {
    var total = Math.max.apply(Math, _toConsumableArray(data.filter(function (m) {
      return m.delistReasonID !== 'total';
    }).map(function (m) {
      return m.count;
    })));
    if (total) {
      return Math.floor(count / total * 100);
    }
    return 0;
  };

  this.getBarColor = function (reasonReport) {
    var t = _this5.props.t;

    var reasonLabel = _this5.getReasonLabel(reasonReport);

    if (reasonLabel === t('No Reason') || !reasonReport.delistReasonID || reasonReport.delistReasonID === '') {
      return 'grey';
    }

    var colors = ['blue', 'orange', 'green', 'teal', 'purple', 'pink', 'yellow', 'red'];
    var hash = (reasonReport.delistReasonID || '').split('').reduce(function (acc, char) {
      return acc + char.charCodeAt(0);
    }, 0);
    return colors[hash % colors.length];
  };

  this.checkData = function (reportData) {
    if (!reportData || reportData.length === 0) {
      return [];
    }
    // Calculate total
    var total = reportData.reduce(function (sum, item) {
      return sum + item.count;
    }, 0);
    return [].concat(_toConsumableArray(reportData), [{
      delistReasonID: 'total',
      delistReasonLabel: 'Total',
      count: total
    }]);
  };

  this.renderTable = function () {
    var _props2 = _this5.props,
        barChart = _props2.barChart,
        headerColor = _props2.headerColor,
        t = _props2.t;

    var data = _this5.checkData(_this5.state.reportData);
    if (data && data.length > 0) {
      return _react2.default.createElement(
        _semanticUiReact.Table,
        {
          basic: barChart && 'very',
          celled: !barChart,
          structured: !barChart,
          color: !barChart ? headerColor : null,
          compact: true,
          unstackable: true
        },
        _react2.default.createElement(
          _semanticUiReact.Table.Header,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { collapsing: true },
              t('Delist Reason')
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { textAlign: 'right', collapsing: true, style: { paddingLeft: '17em' } },
              !barChart && t('Count')
            ),
            barChart && _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { textAlign: 'left' },
              t('Count')
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Body,
          null,
          data.map(function (reasonReport, idx) {
            var isTotal = reasonReport.delistReasonID === 'total';
            var boldStyle = isTotal ? { fontWeight: 'bold' } : {};
            return _react2.default.createElement(
              _semanticUiReact.Table.Row,
              { key: idx },
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { collapsing: true, style: boldStyle },
                isTotal ? t('Total') : _this5.getReasonLabel(reasonReport)
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                {
                  textAlign: 'right',
                  collapsing: true,
                  style: _extends({}, boldStyle, { paddingLeft: '3em' })
                },
                barChart ? _react2.default.createElement(_reactCountup2.default, {
                  duration: 2.1,
                  end: _this5.state.loading ? 0 : reasonReport.count,
                  start: 0,
                  useEasing: true
                }) : reasonReport.count
              ),
              barChart && _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'left', className: 'hide-mobile-six-hundred-px' },
                !isTotal && _react2.default.createElement(
                  'div',
                  { style: { width: '320px', maxWidth: '100%' } },
                  _react2.default.createElement(_semanticUiReact.Progress, {
                    className: 'progress-barchart',
                    color: _this5.getBarColor(reasonReport),
                    percent: _this5.state.loading ? 0 : _this5.getBarPercent(data, reasonReport.count)
                  })
                )
              )
            );
          })
        )
      );
    }
    return _react2.default.createElement(
      'div',
      { style: { padding: '1em', textAlign: 'center', color: '#999' } },
      t('No delist reasons recorded yet')
    );
  };
};

exports.default = (0, _reactRedux.connect)(DelistReasonsByStatus.mapStateToProps)((0, _reactI18next.withTranslation)()(DelistReasonsByStatus));

/***/ }),
/* 2183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _url = __webpack_require__(19);

var _flash = __webpack_require__(5);

var _apiEndpoints = __webpack_require__(140);

var endpoints = _interopRequireWildcard(_apiEndpoints);

var _translation = __webpack_require__(4);

var _fetchM = __webpack_require__(6);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LawyersReports = function (_Component) {
  _inherits(LawyersReports, _Component);

  function LawyersReports(props) {
    _classCallCheck(this, LawyersReports);

    var _this = _possibleConstructorReturn(this, (LawyersReports.__proto__ || Object.getPrototypeOf(LawyersReports)).call(this, props));

    _initialiseProps.call(_this);

    var state = LawyersReports.getPropsToState(props);
    _this.state = _extends({}, state, {
      count: 0,
      data: [],
      limit: 0,
      loading: false,
      offset: 0
    });
    return _this;
  }

  _createClass(LawyersReports, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.companyID > 0 && this.state.loading === false && this.state.data.length === 0) {
        this.fetchReports();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var state = LawyersReports.getPropsToState(nextProps);
      var query = LawyersReports.getQueryData(this.props);
      var newQuery = LawyersReports.getQueryData(nextProps);
      var refetch = !_lodash2.default.isEqual(query.projectID, newQuery.projectID) || !_lodash2.default.isEqual(query.lawyerID, newQuery.lawyerID) || !_lodash2.default.isEqual(query.firmName, newQuery.firmName) || !_lodash2.default.isEqual(query.companyID, newQuery.companyID);
      this.setState(_extends({}, state), function () {
        if (refetch) {
          var q = (0, _url.decodeSearch)(nextProps.location.search);
          _this2.fetchReports(q);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      if (this.props.companyID > 0 && this.state.loading === false && this.state.data.length === 0) {
        this.fetchReports();
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cb = arguments[1];

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
          if (cb) {
            cb();
          }
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
          if (_this4.props.onLoading) {
            _this4.props.onLoading(loading);
          }
        });
      });
    }
  }, {
    key: 'fetchReports',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var store, t, query, res, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, q);
                res = void 0;
                _context.prev = 6;
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.LAWYER_REPORT_CASES_SUMMARY_COUNT(this.props.companyID) + '/?' + _qs2.default.stringify(query), null, 'get', {
                  'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
                }));

              case 9:
                res = _context.sent;
                _context.next = 20;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                Bugsnag.notifyException(_context.t0);
                _context.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context.next = 19;
                return this.setLoading(false);

              case 19:
                return _context.abrupt('return');

              case 20:
                if (!res) {
                  _context.next = 26;
                  break;
                }

                data = this.generatePivot(res);
                _context.next = 24;
                return this.setComponentState({
                  data: data
                });

              case 24:
                _context.next = 27;
                break;

              case 26:
                this.setState({ data: [] });

              case 27:
                _context.next = 29;
                return this.setLoading(false);

              case 29:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));

      function fetchReports(_x3) {
        return _ref.apply(this, arguments);
      }

      return fetchReports;
    }()
  }, {
    key: 'render',
    value: function render() {
      var data = this.state.data;
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { style: { margin: '-1rem 0' } },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Segment,
              { color: this.props.headerColor },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'users-bookings table' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { className: 'mobile-report-table' },
                    _react2.default.createElement(
                      _semanticUiReact.Dimmer,
                      {
                        inverted: true, style: { zIndex: 20 },
                        active: this.state.loading
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Loader,
                        { inline: 'centered' },
                        t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                      )
                    ),
                    data && data.length > 0 ? _react2.default.createElement(
                      _semanticUiReact.Table,
                      {
                        celled: true,
                        compact: true,
                        unstackable: true,
                        structured: true,
                        sortable: true,
                        style: { marginTop: 0 }
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Header,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Table.Row,
                          {
                            style: { borderBottom: '#bbb 2px solid' }
                          },
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { sorted: 'ascending' },
                            t('Lawyer')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            t('SPA Status')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { textAlign: 'right' },
                            t('Count')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            t('LA Status')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { textAlign: 'right' },
                            t('Count')
                          )
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Body,
                        null,
                        this.renderRow(data)
                      )
                    ) : _react2.default.createElement(
                      _semanticUiReact.Item,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Item.Content,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Segment,
                          { textAlign: 'center' },
                          this.state.loading ? _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }) : t('No reports found') + '.'
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LawyersReports;
}(_react.Component);

LawyersReports.contextTypes = {
  store: _propTypes2.default.object
};
LawyersReports.propTypes = {
  headerColor: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }).isRequired,
  onLoading: _propTypes2.default.func,
  companyID: _propTypes2.default.number,
  t: _propTypes2.default.func
};

LawyersReports.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  return {
    currentPage: currentPage
  };
};

LawyersReports.getQueryData = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var projectID = query.projectID || '';
  var lawyerID = query.lawyerID || '';
  var firmName = query.firmName || '';
  return {
    projectID: projectID,
    lawyerID: lawyerID,
    firmName: firmName
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.getValueName = function (value, arr) {
    var valueName = arr.find(function (vn) {
      return vn.value === value;
    });
    if (valueName && valueName.text) {
      return valueName.text;
    }
    return '';
  };

  this.generatePivot = function (data) {
    var pivot = [];
    data.forEach(function (d) {
      if (d.cases_summary_count) {
        var pivotData = {
          dataSPA: [],
          dataLA: [],
          key: d.userID,
          rowSpan: 0,
          name: d.name,
          firm: d.firm
        };
        var spa = d.cases_summary_count.SPA;
        var la = d.cases_summary_count.LA;
        pivotData.dataSPA = [{
          title: 'Pending Appointment',
          count: spa.PENDING_APPOINTMENT_COUNT.doc_count
        }, {
          title: 'SPA Signed Pending',
          count: spa.SPA_SIGNED_PENDING_COUNT.doc_count
        }, {
          title: 'SPA Signed',
          count: spa.SPA_SIGNED_COUNT.doc_count
        }, {
          title: 'SPA Received',
          count: spa.SPA_RECEIVED_COUNT.doc_count
        }, {
          title: 'Developer Signed',
          count: spa.DEVELOPER_SIGNED_COUNT.doc_count
        }, {
          title: 'Lawyer Collected',
          count: spa.LAWYER_COLLECTED_COUNT.doc_count
        }, {
          title: 'SPA Stamped',
          count: spa.SOLD_COUNT.doc_count
        }, {
          title: 'Developer Received',
          count: spa.DEVELOPER_RECEIVED_COUNT.doc_count
        }, {
          title: 'Developer Cancelled',
          count: spa.DEVELOPER_CANCELLED_COUNT.doc_count
        }, {
          title: 'Total SPA',
          count: spa.doc_count
        }];
        pivotData.dataLA = [{
          title: 'New',
          count: la.NEW_COUNT.doc_count
        }, {
          title: 'LA Signed By Borrower',
          count: la.LA_SIGNED_BY_BORROWER_COUNT.doc_count
        }, {
          title: 'LA Signed By Bank',
          count: la.LA_SIGNED_BY_BANK_COUNT.doc_count
        }, {
          title: 'LOU Signed & Issued',
          count: la.LOU_SIGNED_ISSUED_COUNT.doc_count
        }, {
          title: 'LA Stamped',
          count: la.LA_STAMPED_COUNT.doc_count
        }, {
          title: 'Advice Bank for 1st Draw Down',
          count: la.ADVICE_BANK_COUNT.doc_count
        }, {
          title: '1st Disbursement',
          count: la.FIRST_DISBURSEMENT_COUNT.doc_count
        }, {
          title: 'Developer Cancelled',
          count: la.DEVELOPER_CANCELLED_COUNT.doc_count
        }, {
          title: '',
          count: ''
        }, {
          title: 'Total LA',
          count: la.doc_count
        }];
        pivotData.rowSpan = pivotData.dataSPA.length;
        if (pivotData.dataLA.length > pivotData.dataSPA.length) {
          pivotData.rowSpan = pivotData.dataLA.length;
        }
        pivot.push(pivotData);
      }
    });
    return pivot;
  };

  this.getDataTitle = function (title) {
    var t = _this5.props.t;

    if (title === '') {
      return title;
    }
    return t(title, { ns: _translation.namespaces[title === 'Total LA' || title === 'Total SPA' ? 0 : 1] });
  };

  this.renderRow = function (data) {
    return data.map(function (pivoted) {
      return pivoted.dataSPA.map(function (pivotedData, pdid) {
        return _react2.default.createElement(
          _semanticUiReact.Table.Row,
          {
            key: pdid,
            style: pivoted.dataSPA.length === pdid + 1 ? { borderBottom: '#bbb 2px solid' } : {}
          },
          pivoted.rowSpan && pdid === 0 && _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            {
              rowSpan: pivoted.rowSpan,
              style: { borderBottom: '#bbb 2px solid' }
            },
            _react2.default.createElement(
              'h4',
              null,
              pivoted.name,
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'small',
                null,
                pivoted.firm
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { style: pivotedData.title === 'Total SPA' ? { fontWeight: 'bold' } : {} },
            _this5.getDataTitle(pivotedData.title)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { textAlign: 'right', style: pivotedData.title === 'Total SPA' ? { fontWeight: 'bold' } : {} },
            pivotedData.count
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { style: pivoted.dataLA[pdid].title === 'Total LA' ? { fontWeight: 'bold' } : {} },
            _this5.getDataTitle(pivoted.dataLA[pdid].title)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { textAlign: 'right', style: pivoted.dataLA[pdid].title === 'Total LA' ? { fontWeight: 'bold' } : {} },
            pivoted.dataLA[pdid].count
          )
        );
      });
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(LawyersReports);

/***/ }),
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _url = __webpack_require__(19);

var _fileSize = __webpack_require__(85);

var _fileSize2 = _interopRequireDefault(_fileSize);

var _valueToText = __webpack_require__(98);

var _valueToText2 = _interopRequireDefault(_valueToText);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverallBookingReports = function (_Component) {
  _inherits(OverallBookingReports, _Component);

  function OverallBookingReports(props) {
    _classCallCheck(this, OverallBookingReports);

    var _this = _possibleConstructorReturn(this, (OverallBookingReports.__proto__ || Object.getPrototypeOf(OverallBookingReports)).call(this, props));

    _initialiseProps.call(_this);

    var state = OverallBookingReports.getPropsToState(props);
    _this.state = _extends({}, state, {
      loading: true,
      count: 0,
      limit: 0,
      offset: 0,
      data: [],
      token: '',
      generating: false
    });
    return _this;
  }

  _createClass(OverallBookingReports, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var query = (0, _url.decodeSearch)(this.props.location.search);
      this.fetchReports(query);
      this.ticker = setInterval(function () {
        if (_this2.state.generating && _this2.state.currentPage === 1) {
          _this2.fetchReports(query, true);
        }
      }, 1800);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      var query = (0, _url.decodeSearch)(nextProps.location.search);
      var state = OverallBookingReports.getPropsToState(nextProps);
      this.setState(_extends({}, state), function () {
        return _this3.fetchReports(query);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.ticker) {
        clearInterval(this.ticker);
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this4 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this4.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this5 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this5.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchReports',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var store, t, query, res, message, token, count, limit, offset, data, generating;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (silent) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, q);

                if (query.ob_page) query.page = query.ob_page;
                delete query.ob_page;
                res = void 0;
                _context.prev = 9;
                _context.next = 12;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/reports/overall/bookings/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context.sent;
                _context.next = 24;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](9);

                Bugsnag.notifyException(_context.t0);
                _context.next = 20;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 20:
                if (silent) {
                  _context.next = 23;
                  break;
                }

                _context.next = 23;
                return this.setLoading(false);

              case 23:
                return _context.abrupt('return');

              case 24:
                if (res.ok) {
                  _context.next = 32;
                  break;
                }

                _context.next = 27;
                return res.text();

              case 27:
                message = _context.sent;
                _context.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 30:
                _context.next = 43;
                break;

              case 32:
                token = res.headers.get('X-Csrf-Token');
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 38;
                return res.json();

              case 38:
                data = _context.sent;
                generating = false;

                if (data && data[0]) {
                  if (!generating && data[0].statusID === 'new') generating = true;
                }
                // handle token
                _context.next = 43;
                return this.setComponentState({
                  token: token,
                  count: count,
                  limit: limit,
                  offset: offset,
                  data: data,
                  generating: generating
                });

              case 43:
                if (silent) {
                  _context.next = 46;
                  break;
                }

                _context.next = 46;
                return this.setLoading(false);

              case 46:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 15]]);
      }));

      function fetchReports(_x3) {
        return _ref.apply(this, arguments);
      }

      return fetchReports;
    }()
  }, {
    key: 'generateReport',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, t, message, query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                _context2.prev = 4;
                _context2.next = 7;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/reports/overall/bookings/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  }
                }));

              case 7:
                _context2.next = 22;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](4);
                _context2.next = 13;
                return this.setLoading(false);

              case 13:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 16;
                return _context2.t0.res.text();

              case 16:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 19:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context2.abrupt('return');

              case 22:
                _context2.next = 24;
                return this.setLoading(false);

              case 24:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Generating Report', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Report has been added to the queue', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                query = (0, _url.decodeSearch)(this.props.location.search);

                query.ob_page = 1;
                this.fetchReports(query);

              case 28:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 9]]);
      }));

      function generateReport() {
        return _ref2.apply(this, arguments);
      }

      return generateReport;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;
      var pathname = this.props.location.pathname;

      var queryNew = query;
      if (resetPage) {
        queryNew.ob_page = 1;
      }
      this.fetchReports(queryNew);
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _state = this.state,
          count = _state.count,
          currentPage = _state.currentPage,
          limit = _state.limit,
          loading = _state.loading,
          offset = _state.offset,
          data = _state.data,
          generating = _state.generating;
      var t = this.props.t;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true,
            active: this.state.loading
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            stackable: true,
            selectable: true
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 2 },
                _react2.default.createElement(
                  'h3',
                  null,
                  t('Overall Booking Reports')
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 2, textAlign: 'right' },
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    primary: true,
                    onClick: this.handleGenerateReport,
                    disabled: generating
                  },
                  generating ? _react2.default.createElement(
                    'span',
                    null,
                    t('Generating'),
                    ' \xA0\xA0'
                  ) : t('Generate Report'),
                  generating && _react2.default.createElement(_semanticUiReact.Icon, { loading: generating, name: 'spinner' })
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { className: 'mobile-hide' },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Name')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Size')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Date')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Status')
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            data && data.length > 0 ? data.map(function (file, key) {
              return _react2.default.createElement(
                _semanticUiReact.Table.Row,
                { key: key },
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { width: 6 },
                  file.statusID === 'completed' ? _react2.default.createElement(
                    'a',
                    {
                      href: _config2.default.get('bookApiURL') + '/reports/overall/bookings/' + file.id + '/' + file.name,
                      target: '_blank',
                      rel: 'noopener noreferrer'
                    },
                    _react2.default.createElement(
                      'b',
                      null,
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'download' }),
                      ' ',
                      file.name
                    )
                  ) : _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel outline' }),
                    ' ',
                    file.name
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { collapsing: true },
                  file.size ? (0, _fileSize2.default)(file.size) : '-'
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { collapsing: true },
                  _react2.default.createElement(_Timestamp2.default, { timestamp: file.createdAt, format: 'MMMM Do YYYY, h:mm a' })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { width: 4 },
                  _react2.default.createElement(
                    _semanticUiReact.Progress,
                    {
                      size: 'small',
                      percent: _this6.progressToPercent(file),
                      progress: true,
                      color: file.statusID === 'new' ? 'blue' : null,
                      success: file.statusID === 'completed',
                      error: file.statusID === 'failed',
                      active: file.statusID === 'new'
                    },
                    t((0, _valueToText2.default)(_this6.STATUSES, file.statusID), { ns: _translation.TRANSLATION_FILES.constants })
                  )
                )
              );
            }) : _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 4, textAlign: 'center' },
                t('No reports found'),
                '.'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Footer,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 4, textAlign: 'center' },
                _react2.default.createElement(_PageNav2.default, {
                  upward: true,
                  currentPage: currentPage,
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: data && data.length || 0,
                  loading: loading,
                  onChange: this.handleChangePage
                })
              )
            )
          )
        )
      );
    }
  }]);

  return OverallBookingReports;
}(_react.Component);

OverallBookingReports.contextTypes = {
  store: _propTypes2.default.object
};
OverallBookingReports.propTypes = {
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }).isRequired
};

OverallBookingReports.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

OverallBookingReports.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.ob_page, 10) || 1;
  return {
    currentPage: currentPage
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this7.props.location.search);
    query.ob_page = currentPage;
    _this7.setState({ currentPage: currentPage }, function () {
      _this7.replaceQuery(query);
    });
  };

  this.progressToPercent = function (file) {
    var percent = 0;
    if (file.progress && file.progress.includes('/')) {
      var data = file.progress.split('/');
      var percentFor = parseInt(data[0], 10);
      var percentOf = parseInt(data[1], 10);
      percent = Math.floor(percentFor / percentOf * 100);
    }
    return percent;
  };

  this.handleGenerateReport = function (e) {
    e.preventDefault();
    _this7.setState({ generating: true }, function () {
      _this7.generateReport();
    });
  };

  this.STATUSES = [{ text: 'Generating', value: 'new' }, { text: 'Completed', value: 'completed' }, { text: 'Failed', value: 'failed' }];
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(OverallBookingReports.mapStateToProps)(OverallBookingReports));

/***/ }),
/* 2185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _url = __webpack_require__(19);

var _fileSize = __webpack_require__(85);

var _fileSize2 = _interopRequireDefault(_fileSize);

var _valueToText = __webpack_require__(98);

var _valueToText2 = _interopRequireDefault(_valueToText);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OverallUnitReports = function (_Component) {
  _inherits(OverallUnitReports, _Component);

  function OverallUnitReports(props) {
    _classCallCheck(this, OverallUnitReports);

    var _this = _possibleConstructorReturn(this, (OverallUnitReports.__proto__ || Object.getPrototypeOf(OverallUnitReports)).call(this, props));

    _initialiseProps.call(_this);

    var state = OverallUnitReports.getPropsToState(props);
    _this.state = _extends({}, state, {
      loading: true,
      count: 0,
      limit: 0,
      offset: 0,
      data: [],
      token: '',
      generating: false,
      refetch: true // whether need to re-call api; fix calendar pick for the from date always call api
    });
    return _this;
  }

  _createClass(OverallUnitReports, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var query = (0, _url.decodeSearch)(this.props.location.search);
      this.fetchReports(query);
      this.ticker = setInterval(function () {
        if (_this2.state.generating && _this2.state.currentPage === 1) {
          _this2.fetchReports(query, true);
        }
      }, 1800);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      var query = (0, _url.decodeSearch)(nextProps.location.search);
      var state = OverallUnitReports.getPropsToState(nextProps);
      var refetch = query.dateRange === 'custom' ? !!(query.dateFrom && query.dateTo) : true;
      this.setState(_extends({}, state, { refetch: refetch }), function () {
        if (refetch) {
          _this3.fetchReports(query);
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.ticker) {
        clearInterval(this.ticker);
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this4 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this4.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this5 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this5.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchReports',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var store, t, query, res, message, token, count, limit, offset, data, generating;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (silent) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, q);

                if (query.ou_page) query.page = query.ou_page;
                delete query.ou_page;
                res = void 0;
                _context.prev = 9;
                _context.next = 12;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/reports/overall/units/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context.sent;
                _context.next = 24;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](9);

                Bugsnag.notifyException(_context.t0);
                _context.next = 20;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 20:
                if (silent) {
                  _context.next = 23;
                  break;
                }

                _context.next = 23;
                return this.setLoading(false);

              case 23:
                return _context.abrupt('return');

              case 24:
                if (res.ok) {
                  _context.next = 32;
                  break;
                }

                _context.next = 27;
                return res.text();

              case 27:
                message = _context.sent;
                _context.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 30:
                _context.next = 43;
                break;

              case 32:
                token = res.headers.get('X-Csrf-Token');
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 38;
                return res.json();

              case 38:
                data = _context.sent;
                generating = false;

                if (data && data[0]) {
                  if (!generating && data[0].statusID === 'new') generating = true;
                }
                // handle token
                _context.next = 43;
                return this.setComponentState({
                  token: token,
                  count: count,
                  limit: limit,
                  offset: offset,
                  data: data,
                  generating: generating
                });

              case 43:
                if (silent) {
                  _context.next = 46;
                  break;
                }

                _context.next = 46;
                return this.setLoading(false);

              case 46:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 15]]);
      }));

      function fetchReports(_x3) {
        return _ref.apply(this, arguments);
      }

      return fetchReports;
    }()
  }, {
    key: 'generateReport',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, t, message, query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                _context2.prev = 4;
                _context2.next = 7;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/reports/overall/units/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  }
                }));

              case 7:
                _context2.next = 22;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](4);
                _context2.next = 13;
                return this.setLoading(false);

              case 13:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 16;
                return _context2.t0.res.text();

              case 16:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 19:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context2.abrupt('return');

              case 22:
                _context2.next = 24;
                return this.setLoading(false);

              case 24:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Generating Report', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Report has been added to the queue', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                query = (0, _url.decodeSearch)(this.props.location.search);

                query.ou_page = 1;
                this.fetchReports(query);

              case 28:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 9]]);
      }));

      function generateReport() {
        return _ref2.apply(this, arguments);
      }

      return generateReport;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;
      var pathname = this.props.location.pathname;

      var queryNew = query;
      if (resetPage) {
        queryNew.ou_page = 1;
      }
      if (this.state.refetch) {
        this.fetchReports(queryNew);
      }
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _state = this.state,
          count = _state.count,
          currentPage = _state.currentPage,
          limit = _state.limit,
          loading = _state.loading,
          offset = _state.offset,
          data = _state.data,
          generating = _state.generating;
      var _props = this.props,
          t = _props.t,
          appConfig = _props.appConfig;

      var reportHour = appConfig && appConfig.data && appConfig.data.settings && appConfig.data.settings.generateOverallUnitReportTime ? appConfig.data.settings.generateOverallUnitReportTime : null;
      var formattedTime = this.convertTo12HourFormat(reportHour);
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true,
            active: this.state.loading
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            stackable: true,
            selectable: true
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 2 },
                _react2.default.createElement(
                  'h3',
                  null,
                  t('Overall Unit Reports')
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('Reports are automatically generated at {{time}} daily', { time: formattedTime }),
                  '.'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 2, textAlign: 'right' },
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    primary: true,
                    onClick: this.handleGenerateReport,
                    disabled: generating
                  },
                  generating ? _react2.default.createElement(
                    'span',
                    null,
                    t('Generating'),
                    ' \xA0\xA0'
                  ) : t('Generate Report'),
                  generating && _react2.default.createElement(_semanticUiReact.Icon, { loading: generating, name: 'spinner' })
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { className: 'mobile-hide' },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Name')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Size')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Date')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Status')
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            data && data.length > 0 ? data.map(function (file, key) {
              return _react2.default.createElement(
                _semanticUiReact.Table.Row,
                { key: key },
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { width: 6 },
                  file.statusID === 'completed' ? _react2.default.createElement(
                    'a',
                    {
                      href: _config2.default.get('bookApiURL') + '/reports/overall/units/' + file.id + '/' + file.name,
                      target: '_blank',
                      rel: 'noopener noreferrer'
                    },
                    _react2.default.createElement(
                      'b',
                      null,
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'download' }),
                      ' ',
                      file.name
                    )
                  ) : _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel outline' }),
                    ' ',
                    file.name
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { collapsing: true },
                  file.size ? (0, _fileSize2.default)(file.size) : '-'
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { collapsing: true },
                  _react2.default.createElement(_Timestamp2.default, { timestamp: file.createdAt, format: 'MMMM Do YYYY, h:mm a' })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { width: 4 },
                  _react2.default.createElement(
                    _semanticUiReact.Progress,
                    {
                      size: 'small',
                      percent: _this6.progressToPercent(file),
                      progress: true,
                      color: file.statusID === 'new' ? 'blue' : null,
                      success: file.statusID === 'completed',
                      error: file.statusID === 'failed',
                      active: file.statusID === 'new'
                    },
                    t((0, _valueToText2.default)(_this6.STATUSES, file.statusID), { ns: _translation.TRANSLATION_FILES.constants })
                  )
                )
              );
            }) : _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 4, textAlign: 'center' },
                t('No reports found'),
                '.'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Footer,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 4, textAlign: 'center' },
                _react2.default.createElement(_PageNav2.default, {
                  upward: true,
                  currentPage: currentPage,
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: data && data.length || 0,
                  loading: loading,
                  onChange: this.handleChangePage
                })
              )
            )
          )
        )
      );
    }
  }]);

  return OverallUnitReports;
}(_react.Component);

OverallUnitReports.contextTypes = {
  store: _propTypes2.default.object
};
OverallUnitReports.propTypes = {
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }).isRequired,
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      settings: _propTypes2.default.shape({
        generateOverallUnitReportTime: _propTypes2.default.string
      })
    })
  }),
  t: _propTypes2.default.func
};

OverallUnitReports.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

OverallUnitReports.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.ou_page, 10) || 1;
  return {
    currentPage: currentPage
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this7.props.location.search);
    query.ou_page = currentPage;
    _this7.setState({ currentPage: currentPage }, function () {
      _this7.replaceQuery(query);
    });
  };

  this.progressToPercent = function (file) {
    var percent = 0;
    if (file.progress && file.progress.includes('/')) {
      var data = file.progress.split('/');
      var percentFor = parseInt(data[0], 10);
      var percentOf = parseInt(data[1], 10);
      percent = Math.floor(percentFor / percentOf * 100);
    }
    return percent;
  };

  this.handleGenerateReport = function (e) {
    e.preventDefault();
    _this7.setState({ generating: true }, function () {
      _this7.generateReport();
    });
  };

  this.convertTo12HourFormat = function (time) {
    if (!time) return '5:00pm';

    // Split the time into hours, minutes and seconds

    var _time$split$map = time.split(':').map(Number),
        _time$split$map2 = _slicedToArray(_time$split$map, 3),
        hours = _time$split$map2[0],
        minutes = _time$split$map2[1],
        seconds = _time$split$map2[2];

    var timePeriod = hours >= 12 ? 'pm' : 'am';

    var formattedHours = hours % 12 || 12;

    // Format the string to 12 hour clock format eg: 17:00:00 will be 5:00pm
    return formattedHours + ':' + minutes.toString().padStart(2, '0') + timePeriod;
  };

  this.STATUSES = [{ text: 'Generating', value: 'new' }, { text: 'Completed', value: 'completed' }, { text: 'Failed', value: 'failed' }];
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(OverallUnitReports.mapStateToProps)(OverallUnitReports));

/***/ }),
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _reactCountup = __webpack_require__(686);

var _reactCountup2 = _interopRequireDefault(_reactCountup);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _url = __webpack_require__(19);

var _currencies = __webpack_require__(592);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _unitStatuses = __webpack_require__(266);

var _translation = __webpack_require__(4);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _OverallUnitReports = __webpack_require__(2185);

var _OverallUnitReports2 = _interopRequireDefault(_OverallUnitReports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint prefer-spread: 0 */


var ProjectUnitsByStatus = function (_Component) {
  _inherits(ProjectUnitsByStatus, _Component);

  function ProjectUnitsByStatus(props) {
    _classCallCheck(this, ProjectUnitsByStatus);

    var _this = _possibleConstructorReturn(this, (ProjectUnitsByStatus.__proto__ || Object.getPrototypeOf(ProjectUnitsByStatus)).call(this, props));

    _initialiseProps.call(_this);

    var projectCurrencies = props.projectCurrencies;
    _this.state = {
      reportData: [],
      loading: true,
      projectCurrencies: projectCurrencies,
      refetch: true // whether need to re-call api; fix calendar pick for the from date always call api
    };
    return _this;
  }

  _createClass(ProjectUnitsByStatus, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchReports();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var query = ProjectUnitsByStatus.getQueryData(this.props);
      var newQuery = ProjectUnitsByStatus.getQueryData(nextProps);
      var projectCurrencies = nextProps.projectCurrencies;
      var refetch = newQuery.dateRange === 'custom' ? !!(newQuery.dateFrom && newQuery.dateTo) : true;
      this.setState({
        projectCurrencies: projectCurrencies,
        refetch: refetch
      });
      if (query.dateRange !== newQuery.dateRange || query.dateTo !== newQuery.dateTo || query.dateFrom !== newQuery.dateFrom || query.projectID !== newQuery.projectID || query.businessUnitID !== newQuery.businessUnitID || newQuery.projectID !== '' && query.projectUnitLayoutID !== newQuery.projectUnitLayoutID) {
        if (refetch) {
          this.setState({
            reportData: []
          }, function () {
            _this2.fetchReports(nextProps);
          });
        }
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'getConversionAmount',
    value: function getConversionAmount(amount) {
      var _state$projectCurrenc = this.state.projectCurrencies,
          projectCurrencies = _state$projectCurrenc === undefined ? [] : _state$projectCurrenc;
      var company = this.props.auth.company;

      var companyBaseCurrency = (0, _currencies.getCompanyBaseCurrency)(company);
      var displayCurrency = (0, _currencies.getDisplayCurrency)();
      var companyCurrencyInProject = projectCurrencies.find(function (e) {
        return e.code === companyBaseCurrency.code;
      });
      var displayCurrencyInProject = projectCurrencies.find(function (e) {
        return e.code === displayCurrency;
      });
      var projectBaseCurrency = projectCurrencies.find(function (e) {
        return e.isDefault;
      });
      return (0, _currencies.calcConversionAmount)(companyCurrencyInProject, displayCurrencyInProject, projectBaseCurrency, amount);
    }
  }, {
    key: 'setDisplayCurrencySymbol',
    value: function setDisplayCurrencySymbol(appConfig) {
      // if there is projectCurrencies, means it is in project level, else is company wide,
      // thus should show base currency symbol instead of display currency symbol
      var _state$projectCurrenc2 = this.state.projectCurrencies,
          projectCurrencies = _state$projectCurrenc2 === undefined ? [] : _state$projectCurrenc2;

      if (projectCurrencies.length > 0) {
        return (0, _currencies.getDisplayCurrencySymbol)();
      }
      return appConfig && appConfig.data && appConfig.data.currency ? appConfig.data.currency.symbol : '';
    }
  }, {
    key: 'fetchReports',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
        var store, t, q, query, projectID, projectUnitLayoutID, res, message, reportData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                q = (0, _url.decodeSearch)(props.location.search);
                query = Object.assign({}, q);

                delete query.projectID;
                delete query.projectUnitLayoutID;
                projectID = props.projectID || q.projectID || '';
                projectUnitLayoutID = q.projectUnitLayoutID || '';

                if (projectID !== '') {
                  query.projectID = projectID;
                  if (projectUnitLayoutID !== '') {
                    query.projectUnitLayoutID = projectUnitLayoutID;
                  }
                }
                res = void 0;
                _context.prev = 12;
                _context.next = 15;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/reports/project_units/statuses/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 15:
                res = _context.sent;
                _context.next = 26;
                break;

              case 18:
                _context.prev = 18;
                _context.t0 = _context['catch'](12);

                Bugsnag.notifyException(_context.t0);
                _context.next = 23;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 23:
                _context.next = 25;
                return this.setLoading(false);

              case 25:
                return _context.abrupt('return');

              case 26:
                if (res.ok) {
                  _context.next = 34;
                  break;
                }

                _context.next = 29;
                return res.text();

              case 29:
                message = _context.sent;
                _context.next = 32;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 32:
                _context.next = 39;
                break;

              case 34:
                _context.next = 36;
                return res.json();

              case 36:
                reportData = _context.sent;
                _context.next = 39;
                return this.setComponentState({
                  reportData: reportData
                });

              case 39:
                _context.next = 41;
                return this.setLoading(false);

              case 41:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[12, 18]]);
      }));

      function fetchReports() {
        return _ref.apply(this, arguments);
      }

      return fetchReports;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          barChart = _props.barChart,
          headerColor = _props.headerColor,
          t = _props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { style: { margin: '-1rem 0' } },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { style: barChart && { paddingTop: '0' } },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Dimmer,
              {
                inverted: true, style: { zIndex: 20 },
                active: this.state.loading
              },
              _react2.default.createElement(
                _semanticUiReact.Loader,
                { inline: 'centered' },
                t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
              )
            ),
            barChart ? _react2.default.createElement(
              _semanticUiReact.Segment,
              { color: headerColor },
              this.renderTable()
            ) : this.renderTable(),
            (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) && _react2.default.createElement(_OverallUnitReports2.default, {
              location: this.props.location
            })
          )
        )
      );
    }
  }]);

  return ProjectUnitsByStatus;
}(_react.Component);

ProjectUnitsByStatus.contextTypes = {
  store: _propTypes2.default.object
};
ProjectUnitsByStatus.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      currency: _propTypes2.default.shape({
        code: _propTypes2.default.string,
        symbol: _propTypes2.default.string
      })
    })
  }),
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.object,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool
  }),
  barChart: _propTypes2.default.bool,
  headerColor: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }).isRequired,
  projectID: _propTypes2.default.string,
  projectCurrencies: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  t: _propTypes2.default.func
};

ProjectUnitsByStatus.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig,
    auth: state.auth
  };
};

ProjectUnitsByStatus.getQueryData = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var projectID = query.projectID || '';
  var projectUnitLayoutID = query.projectUnitLayoutID || '';
  var dateRange = query.dateRange || '';
  var dateFrom = query.dateFrom ? query.dateFrom : '';
  var dateTo = query.dateTo ? query.dateTo : '';
  var businessUnitID = query.businessUnitID ? query.businessUnitID : '';
  return {
    projectID: projectID,
    projectUnitLayoutID: projectUnitLayoutID,
    dateRange: dateRange,
    dateFrom: dateFrom,
    dateTo: dateTo,
    businessUnitID: businessUnitID
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.getValueName = function (value, arr) {
    var t = _this5.props.t;

    var valueName = arr.find(function (vn) {
      return vn.value === value;
    });
    if (valueName && valueName.text) {
      return t(valueName.text, { ns: _translation.TRANSLATION_FILES.constants });
    }
    return _react2.default.createElement(
      'span',
      { style: { textTransform: 'capitalize' } },
      t(value)
    );
  };

  this.getBarStatusColor = function (statusID) {
    switch (statusID) {
      case 'new':
        return 'green';
      case 'reserved':
        return 'yellow';
      case 'booked':
        return 'red';
      case 'sold_spa_signed':
        return 'teal';
      case 'delist':
        return 'grey';
      case 'total':
        return 'blue';
      default:
        return 'black';
    }
  };

  this.getBarPercent = function (data, statusCount) {
    var total = Math.max.apply(Math, data.map(function (m) {
      if (m.statusID !== 'total') {
        return m.count;
      }
      return 0;
    }));
    if (total) {
      return Math.floor(statusCount / total * 100);
    }
    return 0;
  };

  this.checkData = function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var combineData = [];
    var statusMap = [{ from: 'new', to: 'new', order: 1 }, { from: 'reserved', to: 'reserved', order: 2 }, { from: 'developer_reserved', to: 'reserved', order: 2 }, { from: 'booked', to: 'booked', order: 3 }, { from: 'developer_booked', to: 'booked', order: 3 }, { from: 'sold_spa_signed', to: 'sold_spa_signed', order: 4 }, { from: 'developer_sold', to: 'sold_spa_signed', order: 4 }, { from: 'delist', to: 'delist', order: 5 }, { from: 'total', to: 'total', order: 6 }];
    statusMap.forEach(function (s) {
      var d = data.find(function (f) {
        return f.statusID === s.from;
      });
      var idx = combineData.findIndex(function (f) {
        return f.statusID === s.to;
      });
      if (idx > -1) {
        combineData[idx].count += d ? d.count : 0;
        combineData[idx].sumSPAValue += d ? d.sumSPAValue : 0;
      } else {
        var ds = {
          statusID: s.to,
          count: d ? d.count : 0,
          sumSPAValue: d ? d.sumSPAValue : 0,
          order: s.order
        };
        combineData.push(ds);
      }
    });
    return combineData.sort(function (a, b) {
      if (a.order < b.order) {
        return -1;
      }
      if (a.order > b.order) {
        return 1;
      }
      return 0;
    });
  };

  this.renderTable = function () {
    var _props2 = _this5.props,
        barChart = _props2.barChart,
        headerColor = _props2.headerColor,
        appConfig = _props2.appConfig,
        t = _props2.t;
    var projectCurrencies = _this5.state.projectCurrencies;

    var data = _this5.checkData(_this5.state.reportData);
    if (data && data.length > 0) {
      return _react2.default.createElement(
        _semanticUiReact.Table,
        {
          basic: barChart && 'very',
          celled: !barChart,
          structured: !barChart,
          color: !barChart ? headerColor : null,
          compact: true,
          unstackable: true
        },
        _react2.default.createElement(
          _semanticUiReact.Table.Header,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              null,
              t('Unit Status')
            ),
            barChart && _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { textAlign: barChart ? 'left' : 'right', className: barChart ? 'hide-mobile-six-hundred-px' : null },
              t('Count')
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { textAlign: 'right' },
              t('Selling Price Sum')
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Body,
          null,
          data.map(function (statusReport, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Table.Row,
              {
                key: idx,
                style: statusReport.statusID === 'total' ? { fontWeight: 'bold' } : {}
              },
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                null,
                _this5.getValueName(statusReport.statusID, _unitStatuses.UNIT_STATUSES_HQ_BASIC)
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'right' },
                barChart ? _react2.default.createElement(_reactCountup2.default, {
                  duration: 2.1,
                  end: _this5.state.loading ? 0 : statusReport.count,
                  start: 0,
                  useEasing: true
                }) : statusReport.count
              ),
              barChart && _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'left', className: 'hide-mobile-six-hundred-px', width: 3 },
                statusReport.statusID !== 'total' && _react2.default.createElement(_semanticUiReact.Progress, {
                  className: 'progress-barchart ' + statusReport.statusID,
                  percent: _this5.state.loading ? 0 : _this5.getBarPercent(data, statusReport.count)
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { textAlign: 'right' },
                barChart && _this5.state.refetch ? _react2.default.createElement(_reactCountup2.default, {
                  decimals: 2,
                  redraw: true,
                  duration: 2,
                  end: _this5.getConversionAmount(statusReport.sumSPAValue),
                  prefix: _this5.setDisplayCurrencySymbol(appConfig),
                  useEasing: true,
                  useGrouping: true,
                  separator: ','
                }) : _react2.default.createElement(_LoanAmount2.default, {
                  projectCurrencies: projectCurrencies,
                  amount: statusReport.sumSPAValue,
                  format: '0,000,000.00',
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                })
              )
            );
          })
        )
      );
    }
    return null;
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(ProjectUnitsByStatus.mapStateToProps)(ProjectUnitsByStatus));

/***/ }),
/* 2187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortItems = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _bookingStatuses = __webpack_require__(128);

var _bookingStatuses2 = _interopRequireDefault(_bookingStatuses);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sortItems = exports.sortItems = [{
  text: 'Name Ascending',
  icon: 'sort alphabet ascending',
  sortColumn: 'name',
  sortDirection: 'asc'
}, {
  text: 'Name Descending',
  icon: 'sort alphabet descending',
  sortColumn: 'name',
  sortDirection: 'desc'
}, {
  text: 'Count Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'count',
  sortDirection: 'asc'
}, {
  text: 'Count Descending',
  icon: 'sort numeric descending',
  sortColumn: 'count',
  sortDirection: 'desc'
}, {
  text: 'Selling Price Ascending',
  icon: 'sort numeric ascending',
  sortColumn: 'spa_value',
  sortDirection: 'asc'
}, {
  text: 'Selling Price Descending',
  icon: 'sort numeric descending',
  sortColumn: 'spa_value',
  sortDirection: 'desc'
}];

var UsersBookings = function (_Component) {
  _inherits(UsersBookings, _Component);

  function UsersBookings(props) {
    _classCallCheck(this, UsersBookings);

    var _this = _possibleConstructorReturn(this, (UsersBookings.__proto__ || Object.getPrototypeOf(UsersBookings)).call(this, props));

    _initialiseProps.call(_this);

    var state = UsersBookings.getPropsToState(props);
    _this.state = _extends({}, state, {
      count: 0,
      data: [],
      limit: 0,
      loading: true,
      offset: 0
    });
    return _this;
  }

  _createClass(UsersBookings, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
        delete query.page;
      }
      this.fetchReports(query);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var query = UsersBookings.getQueryData(this.props);
      var newQuery = UsersBookings.getQueryData(nextProps);
      var refetch = query.projectID !== newQuery.projectID || query.sortColumn !== newQuery.sortColumn || query.sortDirection !== newQuery.sortDirection || query.search !== newQuery.search || query.dateRange !== newQuery.dateRange || query.dateTo !== newQuery.dateTo || query.dateFrom !== newQuery.dateFrom || query.page !== newQuery.page;
      var state = UsersBookings.getPropsToState(nextProps);
      this.setState(_extends({}, state), function () {
        if (refetch) {
          var q = (0, _url.decodeSearch)(nextProps.location.search);
          _this2.fetchReports(q);
        }
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var cb = arguments[1];

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
          if (cb) {
            cb();
          }
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
          if (_this4.props.onLoading) {
            _this4.props.onLoading(loading);
          }
        });
      });
    }
  }, {
    key: 'cellCheckSorted',
    value: function cellCheckSorted(key) {
      var defaultCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var column = sortItems[key].sortColumn;

      var _decodeSearch = (0, _url.decodeSearch)(this.props.location.search),
          sortColumn = _decodeSearch.sortColumn,
          sortDirection = _decodeSearch.sortDirection;

      if (defaultCell && sortColumn === undefined) {
        return 'ascending';
      }
      if (column === sortColumn) {
        return sortDirection === 'asc' ? 'ascending' : 'descending';
      }
      return null;
    }
  }, {
    key: 'fetchReports',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var store, t, query, projectID, res, message, count, limit, offset, json, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, q);

                delete query.projectID;
                projectID = this.props.projectID || q.projectID || '';

                if (projectID !== '') {
                  query.projectID = projectID;
                }
                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                res = void 0;
                _context.prev = 10;
                _context.next = 13;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/reports/users/bookings/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 13:
                res = _context.sent;
                _context.next = 24;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](10);

                Bugsnag.notifyException(_context.t0);
                _context.next = 21;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 21:
                _context.next = 23;
                return this.setLoading(false);

              case 23:
                return _context.abrupt('return');

              case 24:
                if (res.ok) {
                  _context.next = 32;
                  break;
                }

                _context.next = 27;
                return res.text();

              case 27:
                message = _context.sent;
                _context.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 30:
                _context.next = 41;
                break;

              case 32:
                count = parseInt(res.headers.get('M-Data-Count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context.next = 37;
                return res.json();

              case 37:
                json = _context.sent;
                data = this.generatePivot(json);
                _context.next = 41;
                return this.setComponentState({
                  count: count,
                  data: data,
                  limit: limit,
                  offset: offset
                }, this.handleOnPageNavData);

              case 41:
                _context.next = 43;
                return this.setLoading(false);

              case 43:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[10, 16]]);
      }));

      function fetchReports(_x4) {
        return _ref.apply(this, arguments);
      }

      return fetchReports;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;
      var pathname = this.props.location.pathname;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));
    }
  }, {
    key: 'setPrefix',
    value: function setPrefix() {
      var _state$projectCurrenc = this.state.projectCurrencies,
          projectCurrencies = _state$projectCurrenc === undefined ? [] : _state$projectCurrenc;
      var _props$appConfig = this.props.appConfig,
          appConfig = _props$appConfig === undefined ? null : _props$appConfig;

      if (projectCurrencies.length > 0) {
        return _react2.default.createElement(_CurrencySymbol2.default, null);
      }
      return appConfig && appConfig.data && appConfig.data.currency ? appConfig.data.currency.symbol : '';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state = this.state,
          data = _state.data,
          projectCurrencies = _state.projectCurrencies;
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { style: { margin: '-1rem 0' } },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Segment,
              { color: this.props.headerColor },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'users-bookings table' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { className: 'mobile-report-table' },
                    _react2.default.createElement(
                      _semanticUiReact.Dimmer,
                      {
                        inverted: true, style: { zIndex: 20 },
                        active: this.state.loading
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Loader,
                        { inline: 'centered' },
                        t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                      )
                    ),
                    data && data.length > 0 ? _react2.default.createElement(
                      _semanticUiReact.Table,
                      {
                        celled: true,
                        compact: true,
                        unstackable: true,
                        structured: true,
                        sortable: true,
                        style: { marginTop: 0 }
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Header,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Table.Row,
                          {
                            style: { borderBottom: '#bbb 2px solid' }
                          },
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            {
                              sorted: this.cellCheckSorted(0, true),
                              onClick: function onClick() {
                                return _this5.handleCellSort(0, true);
                              }
                            },
                            t('Name'),
                            '\xA0',
                            this.cellCheckSorted(0, true) ? null : _react2.default.createElement(_semanticUiReact.Icon, {
                              inverted: true, color: 'grey',
                              name: 'sort'
                            })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            t('Booking Status')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            {
                              textAlign: 'right',
                              sorted: this.cellCheckSorted(2),
                              onClick: function onClick() {
                                return _this5.handleCellSort(2);
                              }
                            },
                            this.cellCheckSorted(2) ? null : _react2.default.createElement(_semanticUiReact.Icon, {
                              inverted: true, color: 'grey',
                              name: 'sort'
                            }),
                            '\xA0',
                            t('Count')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            {
                              textAlign: 'right',
                              sorted: this.cellCheckSorted(4),
                              onClick: function onClick() {
                                return _this5.handleCellSort(4);
                              }
                            },
                            this.cellCheckSorted(4) ? null : _react2.default.createElement(_semanticUiReact.Icon, {
                              inverted: true, color: 'grey',
                              name: 'sort'
                            }),
                            '\xA0',
                            t('Selling Price Sum')
                          )
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Body,
                        null,
                        data.map(function (pivoted) {
                          return pivoted.data.map(function (pivotedData, idxp) {
                            return _react2.default.createElement(
                              _semanticUiReact.Table.Row,
                              {
                                key: idxp,
                                style: pivoted.data.length === idxp + 1 ? { borderBottom: '#bbb 2px solid' } : {}
                              },
                              pivoted.rowSpan && idxp === 0 && _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                {
                                  rowSpan: pivoted.rowSpan,
                                  style: { borderBottom: '#bbb 2px solid' }
                                },
                                pivoted.preferredName,
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(
                                  'small',
                                  null,
                                  pivoted.branchShortName
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { style: pivotedData.title === 'Total' ? { fontWeight: 'bold' } : {} },
                                pivotedData.title
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { textAlign: 'right', style: pivotedData.title === 'Total' ? { fontWeight: 'bold' } : {} },
                                pivotedData.count
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { textAlign: 'right', style: pivotedData.title === 'Total' ? { fontWeight: 'bold' } : {} },
                                _react2.default.createElement(_LoanAmount2.default, {
                                  projectCurrencies: projectCurrencies,
                                  format: '0,000,000.00',
                                  amount: pivotedData.sumSPAValue,
                                  prefix: _this5.setPrefix()
                                })
                              )
                            );
                          });
                        })
                      )
                    ) : _react2.default.createElement(
                      _semanticUiReact.Item,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Item.Content,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Segment,
                          { textAlign: 'center' },
                          this.state.loading ? _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }) : t('No reports found') + '.'
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'center' },
                    _react2.default.createElement(_PageNav2.default, {
                      upward: true,
                      currentPage: this.state.currentPage,
                      count: this.state.count,
                      limit: this.state.limit,
                      offset: this.state.offset,
                      dataSize: this.state.data.length,
                      loading: this.state.loading,
                      onChange: this.handleChangePage,
                      noScrollTop: true
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return UsersBookings;
}(_react.Component);

UsersBookings.contextTypes = {
  store: _propTypes2.default.object
};
UsersBookings.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      currency: _propTypes2.default.shape({
        code: _propTypes2.default.string,
        symbol: _propTypes2.default.string
      })
    })
  }),
  headerColor: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }).isRequired,
  onLoading: _propTypes2.default.func,
  onPageNav: _propTypes2.default.func,
  projectID: _propTypes2.default.string,
  projectCurrencies: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  t: _propTypes2.default.func
};

UsersBookings.getQueryData = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var projectID = query.projectID || '';
  var sortColumn = query.sortColumn || '';
  var sortDirection = query.sortDirection || '';
  var page = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var dateRange = query.dateRange || '';
  var dateFrom = query.dateFrom ? query.dateFrom : '';
  var dateTo = query.dateTo ? query.dateTo : '';
  return {
    projectID: projectID,
    sortColumn: sortColumn,
    sortDirection: sortDirection,
    page: page,
    search: search,
    dateRange: dateRange,
    dateFrom: dateFrom,
    dateTo: dateTo
  };
};

UsersBookings.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var projectCurrencies = props.projectCurrencies;
  return {
    currentPage: currentPage,
    projectCurrencies: projectCurrencies
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.getValueName = function (value, arr) {
    var t = _this6.props.t;

    var valueName = arr.find(function (vn) {
      return vn.value === value;
    });
    if (valueName && valueName.text) {
      return t(valueName.text, { ns: _translation.TRANSLATION_FILES.constants });
    }
    return '';
  };

  this.generatePivot = function (data) {
    var t = _this6.props.t;

    var pivot = [];
    data.forEach(function (d) {
      var pivotData = {
        data: [],
        key: d.userID,
        rowSpan: 0,
        preferredName: d.preferredName,
        branchShortName: d.branchShortName
      };
      var dataArr = [{
        title: _this6.getValueName('reserved', _bookingStatuses2.default),
        count: d.reservedCount,
        sumSPAValue: d.reservedSPAValue
      }, {
        title: _this6.getValueName('booked', _bookingStatuses2.default),
        count: d.bookedCount,
        sumSPAValue: d.bookedSPAValue
      }, {
        title: _this6.getValueName('sold_spa_signed', _bookingStatuses2.default),
        count: d.soldCount,
        sumSPAValue: d.soldSPAValue
      }, {
        title: _this6.getValueName('cancelled_developer', _bookingStatuses2.default),
        count: d.cancelledDeveloperCount,
        sumSPAValue: d.cancelledDeveloperSPAValue
      }, {
        title: _this6.getValueName('cancelled_availability', _bookingStatuses2.default),
        count: d.cancelledAvailabilityCount,
        sumSPAValue: d.cancelledAvailabilitySPAValue
      }, {
        title: _this6.getValueName('expired', _bookingStatuses2.default),
        count: d.expiredCount,
        sumSPAValue: d.expiredSPAValue
      }, {
        title: t('Total', { ns: _translation.TRANSLATION_FILES.constants }),
        count: d.totalCount,
        sumSPAValue: d.totalSpaValue
      }];
      // filtered out disabled row
      pivotData.data = dataArr.filter(function (v) {
        return !v.disabled;
      });
      pivotData.rowSpan = pivotData.data.length;
      pivot.push(pivotData);
    });
    return pivot;
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.page = currentPage;
    _this6.setState({ currentPage: currentPage }, function () {
      _this6.replaceQuery(query);
    });
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    if (hasQuery) {
      _this6.replaceQuery(query, true);
    }
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query[queryName] = value;
    _this6.replaceQuery(query, true);
  };

  this.handleCellSort = function (key) {
    var defaultCell = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var column = sortItems[key].sortColumn;

    var _decodeSearch2 = (0, _url.decodeSearch)(_this6.props.location.search),
        sortColumn = _decodeSearch2.sortColumn,
        sortDirection = _decodeSearch2.sortDirection;

    var direction = 'asc';
    if (defaultCell && sortColumn === undefined) {
      direction = 'desc';
    }
    if (column === sortColumn) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc';
    }
    _this6.handleSortData(column, direction);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this6.replaceQuery(query, true);
  };

  this.handleOnPageNavData = function () {
    var onPageNav = _this6.props.onPageNav;

    if (onPageNav) {
      var _state2 = _this6.state,
          count = _state2.count,
          data = _state2.data,
          limit = _state2.limit,
          offset = _state2.offset;

      var dataSize = data.length || 0;
      onPageNav({ count: count, dataSize: dataSize, limit: limit, offset: offset });
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(UsersBookings);

/***/ }),
/* 2188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _amount = __webpack_require__(87);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchProjectUnit = function (_Component) {
  _inherits(SearchProjectUnit, _Component);

  function SearchProjectUnit(props) {
    _classCallCheck(this, SearchProjectUnit);

    var _this = _possibleConstructorReturn(this, (SearchProjectUnit.__proto__ || Object.getPrototypeOf(SearchProjectUnit)).call(this, props));

    _initialiseProps.call(_this);

    var state = SearchProjectUnit.getPropsToState(props);
    _this.state = _extends({}, state, {
      findProjectUnitsResults: [],
      loading: false,
      showNoResults: true,
      selection: null
    });
    return _this;
  }

  _createClass(SearchProjectUnit, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = SearchProjectUnit.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.setTimer) {
        clearTimeout(this.setTimer);
      }
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, res);
      });
    }
  }, {
    key: 'searchProjectUnits',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(value) {
        var _this4 = this;

        var store, t, res, message, _message, json, findProjectUnitsResults, noResultsMessage;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = null;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/search/project_units/?limit=30&projectID=' + this.props.projectID + '&search=' + value, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 22;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);
                _context.next = 15;
                return this.setLoading(false);

              case 15:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 20:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 22:
                if (res.ok) {
                  _context.next = 30;
                  break;
                }

                _context.next = 25;
                return res.text();

              case 25:
                _message = _context.sent;
                _context.next = 28;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 28:
                _context.next = 42;
                break;

              case 30:
                _context.next = 32;
                return res.json();

              case 32:
                json = _context.sent;

                if (!json) {
                  _context.next = 39;
                  break;
                }

                findProjectUnitsResults = json.map(function (obj) {
                  var newResults = {};
                  newResults.key = obj.id;
                  newResults.title = obj.reference + ', ' + obj.projectUnitLayoutName;
                  newResults.description = t('Size') + ': ' + obj.size + ' | ' + t('Price') + ': ' + _this4.props.appConfig.data.currency.symbol + (0, _amount.spaFullString)(obj, '000,000,000.00');
                  newResults.price = t(_this4.checkStatusID(obj.statusID, obj.status), { ns: _translation.TRANSLATION_FILES.constants });
                  newResults.hrefLang = obj.statusID;
                  newResults.className = obj.statusID !== 'new' ? 'unit-list-grey' : '';
                  return newResults;
                });
                _context.next = 37;
                return this.setComponentState({ findProjectUnitsResults: findProjectUnitsResults });

              case 37:
                _context.next = 42;
                break;

              case 39:
                noResultsMessage = t('No results found', { ns: _translation.TRANSLATION_FILES.translation }) + '.';
                _context.next = 42;
                return this.setComponentState({ noResultsMessage: noResultsMessage });

              case 42:
                _context.next = 44;
                return this.setLoading(false);

              case 44:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function searchProjectUnits(_x3) {
        return _ref.apply(this, arguments);
      }

      return searchProjectUnits;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            this.props.selectedValue.key !== '' || this.state.selection ? _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 16 },
                  _react2.default.createElement(_semanticUiReact.Input, {
                    readOnly: true,
                    fluid: true,
                    value: this.props.selectedValue.key !== '' ? '' + this.props.selectedValue.title : '' + this.state.selection.title,
                    icon: _react2.default.createElement(_semanticUiReact.Icon, {
                      title: t('Clear Selection'),
                      name: 'x',
                      onClick: this.handleClearSelection,
                      link: true
                    })
                  })
                )
              )
            ) : _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 16 },
                  _react2.default.createElement(_semanticUiReact.Search, {
                    className: 'searchlist scrollresults',
                    fluid: true,
                    icon: _react2.default.createElement(_semanticUiReact.Icon, {
                      title: t('Clear Selection'),
                      name: this.state.value ? 'x' : 'search',
                      onClick: this.state.value && this.handlerClearValue,
                      link: !!this.state.value
                    }),
                    loading: this.state.loading,
                    onResultSelect: this.handleResultSelect,
                    onSearchChange: this.handleSearchChange,
                    results: this.state.findProjectUnitsResults,
                    value: this.state.value,
                    placeholder: t('Search Project Unit') + '...',
                    noResultsMessage: this.state.noResultsMessage,
                    onFocus: function onFocus() {
                      var showNoResults = false;
                      _this5.setState({ showNoResults: showNoResults });
                    },
                    showNoResults: this.state.showNoResults
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return SearchProjectUnit;
}(_react.Component);

SearchProjectUnit.contextTypes = {
  store: _propTypes2.default.object
};
SearchProjectUnit.propTypes = {
  onSelect: _propTypes2.default.func.isRequired,
  onClear: _propTypes2.default.func.isRequired,
  selectedValue: _propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired
  }).isRequired,
  projectID: _propTypes2.default.string.isRequired,
  hasAccess: _propTypes2.default.bool.isRequired,
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      currency: _propTypes2.default.shape({
        symbol: _propTypes2.default.string.isRequired
      }).isRequired
    }).isRequired
  }).isRequired
};
SearchProjectUnit.defaultProps = {
  selectedValue: {
    key: 0,
    title: ''
  }
};

SearchProjectUnit.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig
  };
};

SearchProjectUnit.getPropsToState = function (props) {
  var value = props.value || '';
  var noResultsMessage = 'Loading...';
  return {
    value: value,
    noResultsMessage: noResultsMessage
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.checkStatusID = function (statusID, status) {
    switch (statusID) {
      case 'developer_reserved':
        return 'Reserved';
      case 'developer_booked':
        return 'Booked';
      case 'developer_sold':
      case 'sold_spa_signed':
        return _this6.props.hasAccess ? 'Sold' : 'Booked';
      default:
        return status;
    }
  };

  this.handleSearchChange = function (e, _ref2) {
    var value = _ref2.value;
    var t = _this6.props.t;

    clearTimeout(_this6.setTimer);
    var findProjectUnitsResults = [];
    var showNoResults = true;
    var noResultsMessage = t('Loading', { ns: _translation.TRANSLATION_FILES.translation }) + '...';
    _this6.setState({ findProjectUnitsResults: findProjectUnitsResults, noResultsMessage: noResultsMessage, showNoResults: showNoResults, value: value }, function () {
      if (value !== '') {
        _this6.setTimer = setTimeout(function () {
          _this6.searchProjectUnits(value);
        }, 500);
      }
    });
  };

  this.handleResultSelect = function (e, _ref3) {
    var result = _ref3.result;

    var newSelection = result;
    if (result.price !== 'new') {
      newSelection = null;
    }
    _this6.setState({
      selection: newSelection,
      value: ''
    }, function () {
      _this6.props.onSelect(result);
    });
  };

  this.handleClearSelection = function () {
    _this6.setState({
      selection: null
    }, function () {
      _this6.props.onClear();
    });
  };

  this.handlerClearValue = function () {
    _this6.setState({
      value: ''
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(SearchProjectUnit.mapStateToProps)(SearchProjectUnit));

/***/ }),
/* 2189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

var _ListItem = __webpack_require__(1007);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _types = __webpack_require__(145);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-confusing-arrow */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/no-danger */
/* eslint-disable react/no-unused-prop-types */


var List = function (_Component) {
  _inherits(List, _Component);

  _createClass(List, null, [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (prevState.internalLoading !== nextProps.requestLoading) {
        return {
          internalLoading: nextProps.requestLoading
        };
      }
      return null;
    }
  }]);

  function List(props) {
    var _this2 = this;

    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _this.getScrollPostion = function () {
      var scrollDiv = document.getElementsByClassName('bn-list');
      if (scrollDiv.length > 0) {
        return scrollDiv[0].scrollTop;
      }
      return 0;
    };

    _this.scrollToBottom = function () {
      var scrollDiv = document.getElementsByClassName('bn-list');
      if (scrollDiv.length > 0) {
        scrollDiv[0].scrollTop = scrollDiv[0].scrollHeight;
      }
    };

    _this.scrollToTop = function () {
      var scrollDiv = document.getElementsByClassName('bn-list');
      if (scrollDiv.length > 0) {
        scrollDiv[0].scrollTop = 0;
      }
    };

    _this.scrollToPosition = function (position) {
      var scrollDiv = document.getElementsByClassName('bn-list');
      if (scrollDiv.length > 0) {
        scrollDiv[0].scrollTop = position;
      }
    };

    _this.handleScroll = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        var _e$target, scrollTop, scrollHeight, clientHeight, _this$state, dataCurrentPage, dataLastPage, dataFetching;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _e$target = e.target, scrollTop = _e$target.scrollTop, scrollHeight = _e$target.scrollHeight, clientHeight = _e$target.clientHeight;
                _this$state = _this.state, dataCurrentPage = _this$state.dataCurrentPage, dataLastPage = _this$state.dataLastPage, dataFetching = _this$state.dataFetching;

                if (!(scrollTop + clientHeight >= scrollHeight - 10 && !dataFetching && dataCurrentPage + 1 <= dataLastPage)) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return _this.fetchNotes(dataCurrentPage + 1);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleNoteOnDelete = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(bnID, type) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.t0 = type;
                _context2.next = _context2.t0 === 'close' ? 3 : _context2.t0 === 'open' ? 5 : _context2.t0 === 'delete' ? 7 : 3;
                break;

              case 3:
                _this.setState({ noteDeleting: '' });
                return _context2.abrupt('break', 13);

              case 5:
                _this.setState({ noteDeleting: bnID });
                return _context2.abrupt('break', 13);

              case 7:
                _context2.next = 9;
                return _this.setComponentState({ noteDeleting: '', internalLoading: true });

              case 9:
                if (!_this.props.noteOnDelete) {
                  _context2.next = 12;
                  break;
                }

                _context2.next = 12;
                return _this.props.noteOnDelete(bnID);

              case 12:
                return _context2.abrupt('break', 13);

              case 13:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.handleNoteOnEdit = function (bNote) {
      if (_this.props.noteOnEdit) _this.props.noteOnEdit(bNote);
    };

    _this.deleteStateData = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(bnID) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this.setComponentState(function (prevState) {
                  return { internalLoading: false, data: prevState.data.filter(function (d) {
                      return d.id !== bnID;
                    }) };
                });

              case 2:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x4) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.updateStateData = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(bNote) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this.setComponentState(function (prevState) {
                  return {
                    data: prevState.data.map(function (obj) {
                      return obj.id === bNote.id ? _extends({}, obj, { note: bNote.note, updatedAt: bNote.updatedAt, privacy: bNote.privacy }) : obj;
                    })
                  };
                });

              case 2:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2);
      }));

      return function (_x5) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.fetchStateData = function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var prependNew = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!(prependNew && !_this.state.dataFirstFetch)) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt('return');

              case 2:
                _context5.next = 4;
                return _this.fetchNotes(1, prependNew);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this2);
      }));

      return function () {
        return _ref5.apply(this, arguments);
      };
    }();

    _this.hasFirstFetchData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              return _context6.abrupt('return', _this.state.dataFirstFetch);

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this2);
    }));

    _this.state = {
      internalLoading: false,
      data: [],
      dataCurrentPage: 1,
      dataLastPage: 1,
      dataFetching: true,
      dataFirstFetch: false,
      noteDeleting: ''
    };
    return _this;
  }

  _createClass(List, [{
    key: 'componentDidMount',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this.addScrollEvent();

                if (!(this.props.parentID !== '')) {
                  _context7.next = 4;
                  break;
                }

                _context7.next = 4;
                return this.fetchNotes();

              case 4:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function componentDidMount() {
        return _ref7.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(prevProps) {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!(prevProps.parentID !== this.props.parentID && this.props.parentID !== '')) {
                  _context8.next = 3;
                  break;
                }

                _context8.next = 3;
                return this.fetchNotes();

              case 3:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function componentDidUpdate(_x7) {
        return _ref8.apply(this, arguments);
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                this.removeScrollEvent();

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function componentWillUnmount() {
        return _ref9.apply(this, arguments);
      }

      return componentWillUnmount;
    }()
  }, {
    key: 'setComponentState',
    value: function setComponentState(state) {
      var _this3 = this;

      return new Promise(function (resolve) {
        _this3.setState(function (prevState) {
          var nextState = typeof state === 'function' ? state(prevState) : state;
          return nextState;
        }, function () {
          return resolve(_this3.state);
        });
      });
    }
  }, {
    key: 'setDataFetching',
    value: function setDataFetching() {
      var _this4 = this;

      var dataFetching = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ dataFetching: dataFetching }, function () {
          res(dataFetching);
        });
      });
    }
  }, {
    key: 'addScrollEvent',
    value: function addScrollEvent() {
      var scrollDiv = document.getElementsByClassName('bn-list');
      if (scrollDiv.length > 0) {
        scrollDiv[0].addEventListener('scroll', this.handleScroll, false);
      }
    }
  }, {
    key: 'removeScrollEvent',
    value: function removeScrollEvent() {
      var scrollDiv = document.getElementsByClassName('bn-list');
      if (scrollDiv.length > 0) {
        scrollDiv[0].removeEventListener('scroll', this.handleScroll, false);
      }
    }
  }, {
    key: 'hasManageAccess',
    value: function hasManageAccess(bNoteUserID) {
      if (!this.props.hasEditAccess) return false;
      var user = this.props.auth;
      if (user.isAdminBasic || user.isSuperAdmin) {
        return true;
      }
      if (bNoteUserID === user.id) {
        return true;
      }
      return false;
    }
  }, {
    key: 'hasAdminAccess',
    value: function hasAdminAccess() {
      var user = this.props.auth;
      if (user.isHeadquarters || user.isAdminBasic || user.isSuperAdmin) {
        return true;
      }
      return false;
    }
  }, {
    key: 'fetchNotes',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var prependNew = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var _state, currentData, dataCurrentPage, store, _props, t, parentType, parentID, query, res, message, count, limit, token, data, newData, dataLastPage;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.setDataFetching(true);

              case 2:
                if (page > 1) this.scrollToBottom();
                _state = this.state, currentData = _state.data, dataCurrentPage = _state.dataCurrentPage;
                store = this.context.store;
                _props = this.props, t = _props.t, parentType = _props.parentType, parentID = _props.parentID;
                query = Object.assign({});

                query.page = page;
                query.parent_type = parentType;
                query.parent_id = parentID;
                res = void 0;
                _context10.prev = 11;
                _context10.next = 14;
                return store.dispatch((0, _fetchM.fetchM)('/shared_notes/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 14:
                res = _context10.sent;
                _context10.next = 25;
                break;

              case 17:
                _context10.prev = 17;
                _context10.t0 = _context10['catch'](11);

                Bugsnag.notifyException(_context10.t0);
                _context10.next = 22;
                return this.setDataFetching(false);

              case 22:
                _context10.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 24:
                return _context10.abrupt('return');

              case 25:
                if (res.ok) {
                  _context10.next = 34;
                  break;
                }

                _context10.next = 28;
                return res.text();

              case 28:
                message = _context10.sent;
                _context10.next = 31;
                return this.setDataFetching(false);

              case 31:
                _context10.next = 33;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 33:
                return _context10.abrupt('return');

              case 34:
                count = parseInt(res.headers.get('M-Data-count'), 10) || 0;
                limit = parseInt(res.headers.get('M-Data-limit'), 10) || 0;
                // const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;

                token = res.headers.get('X-Csrf-Token');

                if (token && this.props.onTokenReceived) {
                  this.props.onTokenReceived(token);
                }
                _context10.next = 40;
                return res.json();

              case 40:
                data = _context10.sent;
                newData = page === 1 ? data : [].concat(_toConsumableArray(currentData), _toConsumableArray(data));

                if (prependNew && currentData && data) {
                  newData = [].concat(_toConsumableArray(data.filter(function (ni) {
                    return !currentData.some(function (oi) {
                      return oi.id === ni.id;
                    });
                  })), _toConsumableArray(currentData)); // prepend new data
                }
                dataLastPage = limit > 0 ? Math.ceil(count / limit) : 1;
                _context10.next = 46;
                return this.setComponentState({
                  data: newData,
                  dataCurrentPage: prependNew ? dataCurrentPage : page,
                  dataLastPage: dataLastPage,
                  dataFetching: false,
                  dataFirstFetch: true
                });

              case 46:
                if (prependNew) this.scrollToTop();

              case 47:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[11, 17]]);
      }));

      function fetchNotes() {
        return _ref10.apply(this, arguments);
      }

      return fetchNotes;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      // console.log(this.state.dataFirstFetch)
      var _state2 = this.state,
          bookingNotes = _state2.data,
          dataFetching = _state2.dataFetching,
          noteDeleting = _state2.noteDeleting,
          internalLoading = _state2.internalLoading;
      var _props2 = this.props,
          parentID = _props2.parentID,
          isExpanded = _props2.isExpanded,
          noteEditingID = _props2.noteEditingID,
          loading = _props2.requestLoading,
          t = _props2.t;

      return _react2.default.createElement(
        _semanticUiReact.Segment,
        { className: 'bn-list ' + (isExpanded ? 'is-expanded' : '') + ' ' + (loading || noteDeleting || noteEditingID ? 'is-write-mode' : '') },
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            active: loading || internalLoading,
            inverted: true,
            style: { zIndex: 20 }
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Feed,
          null,
          parentID !== '' && bookingNotes && bookingNotes.length > 0 ? bookingNotes.map(function (bNote, idx) {
            return _react2.default.createElement(_ListItem2.default, {
              key: bNote.id,
              listIndex: idx,
              isLastIndex: bookingNotes.length > 1 && bookingNotes.length === idx + 1,
              bookingNote: bNote,
              onEdit: _this5.handleNoteOnEdit,
              onDelete: _this5.handleNoteOnDelete,
              noteIsDeleting: noteDeleting === bNote.id,
              noteIsEditing: noteEditingID === bNote.id,
              noteIsDisabled: noteEditingID !== '' && noteEditingID !== bNote.id,
              canManage: _this5.hasManageAccess(bNote.muID),
              hasAccess: _this5.hasAdminAccess()
            });
          }) : !dataFetching ? _react2.default.createElement(_ListItem.ListItemEmpty, { t: t }) : '',
          dataFetching ? _react2.default.createElement(_ListItem.ListItemPlaceholder, null) : ''
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.propTypes = {
  auth: _types.StateAuth,
  parentType: _propTypes2.default.string,
  parentID: _propTypes2.default.string,
  hasEditAccess: _propTypes2.default.bool, // user's role has edit access from project settings
  isExpanded: _propTypes2.default.bool, // expanded layout mode
  noteEditingID: _propTypes2.default.string, // current note id that is being edited
  noteOnDelete: _propTypes2.default.func, // send note id for delete request
  noteOnEdit: _propTypes2.default.func, // send BookingNotePropTypes object for edit
  requestLoading: _propTypes2.default.bool, // loading state when add, update & delete note request
  onTokenReceived: _propTypes2.default.func,
  t: _propTypes2.default.func
};
List.defaultProps = {
  parentID: '',
  noteEditingID: '',
  requestLoading: false
};
List.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(List);

/***/ }),
/* 2190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _ = __webpack_require__(1032);

var _translation = __webpack_require__(4);

var _types = __webpack_require__(145);

var _BookingNote = __webpack_require__(313);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */


var SharedNote = function (_Component) {
  _inherits(SharedNote, _Component);

  function SharedNote(props) {
    var _this2 = this;

    _classCallCheck(this, SharedNote);

    var _this = _possibleConstructorReturn(this, (SharedNote.__proto__ || Object.getPrototypeOf(SharedNote)).call(this, props));

    _this.setRefreshCooldown = function () {
      _this.refreshCooldown = setInterval(function () {
        _this.setState({ isRefreshing: false });
        clearInterval(_this.refreshCooldown);
      }, 5000); // 5 seconds
    };

    _this.handleClickRefresh = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (e) e.preventDefault();

                if (!(_this.listRef && _this.listRef.current)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 4;
                return _this.setComponentState({ loading: true, isRefreshing: true });

              case 4:
                _context.next = 6;
                return _this.listRef.current.fetchStateData(false);

              case 6:
                _context.next = 8;
                return _this.setLoading(false);

              case 8:
                _this.setRefreshCooldown();

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleForceRefresh = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var prependData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this.listRef && _this.listRef.current)) {
                  _context2.next = 7;
                  break;
                }

                _context2.next = 3;
                return _this.setLoading(true);

              case 3:
                _context2.next = 5;
                return _this.listRef.current.fetchStateData(prependData);

              case 5:
                _context2.next = 7;
                return _this.setLoading(false);

              case 7:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }));

      return function () {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.handleClickExpand = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e) {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (e) e.preventDefault();
                _context3.next = 3;
                return _this.setComponentState(function (prevState) {
                  return { isExpanded: !prevState.isExpanded };
                });

              case 3:
                if (_this.props.onExpand) _this.props.onExpand(_this.state.isExpanded);

              case 4:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2);
      }));

      return function (_x3) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.handleOnNoteDelete = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(bnID) {
        var listPos, store, t, message;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                // fix for loading dimmer
                listPos = 0;

                if (!(_this.listRef && _this.listRef.current)) {
                  _context4.next = 5;
                  break;
                }

                _context4.next = 4;
                return _this.listRef.current.getScrollPostion();

              case 4:
                listPos = _context4.sent;

              case 5:
                if (!(_this.listRef && _this.listRef.current)) {
                  _context4.next = 8;
                  break;
                }

                _context4.next = 8;
                return _this.listRef.current.scrollToTop();

              case 8:
                store = _this.context.store;
                t = _this.props.t;
                _context4.next = 12;
                return _this.setLoading(true);

              case 12:
                _context4.prev = 12;
                _context4.next = 15;
                return store.dispatch((0, _fetchM.fetchM)('/shared_notes/' + bnID + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': _this.state.token
                  }
                }));

              case 15:
                _context4.next = 33;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4['catch'](12);
                _context4.next = 21;
                return _this.setLoading(false);

              case 21:
                if (!(_context4.t0.res && _context4.t0.res.status >= 400 && _context4.t0.res.status < 500)) {
                  _context4.next = 27;
                  break;
                }

                _context4.next = 24;
                return _context4.t0.res.text();

              case 24:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context4.abrupt('return');

              case 27:
                Bugsnag.notifyException(_context4.t0);
                _context4.next = 30;
                return _this.setLoading(false);

              case 30:
                _context4.next = 32;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 32:
                return _context4.abrupt('return');

              case 33:
                if (!(_this.listRef && _this.listRef.current)) {
                  _context4.next = 36;
                  break;
                }

                _context4.next = 36;
                return _this.listRef.current.deleteStateData(bnID);

              case 36:
                _context4.next = 38;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Note successfully deleted', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 38:
                _context4.next = 40;
                return _this.setLoading(false);

              case 40:
                if (!(_this.listRef && _this.listRef.current)) {
                  _context4.next = 43;
                  break;
                }

                _context4.next = 43;
                return _this.listRef.current.scrollToPosition(listPos);

              case 43:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2, [[12, 17]]);
      }));

      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.handleOnNoteEdit = function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(bNote) {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this.setComponentState({ noteEditing: bNote });

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this2);
      }));

      return function (_x5) {
        return _ref5.apply(this, arguments);
      };
    }();

    _this.handleEditorCancel = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _this.setState({ noteEditing: null });

            case 1:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this2);
    }));

    _this.handleEditorAdd = function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(encodedMDNote, privacyValue) {
        var store, _this$props, parentType, parentID, t, request, res, message, _message;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (!(_this.listRef && _this.listRef.current)) {
                  _context7.next = 3;
                  break;
                }

                _context7.next = 3;
                return _this.listRef.current.scrollToTop();

              case 3:
                store = _this.context.store;
                _this$props = _this.props, parentType = _this$props.parentType, parentID = _this$props.parentID, t = _this$props.t;
                _context7.next = 7;
                return _this.setLoading(true);

              case 7:
                request = {
                  parentType: parentType,
                  parentID: parentID,
                  note: encodedMDNote,
                  privacy: privacyValue
                };
                res = '';
                _context7.prev = 9;
                _context7.next = 12;
                return store.dispatch((0, _fetchM.fetchM)('/shared_notes/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': _this.state.token
                  },
                  body: JSON.stringify(request)
                }));

              case 12:
                res = _context7.sent;
                _context7.next = 31;
                break;

              case 15:
                _context7.prev = 15;
                _context7.t0 = _context7['catch'](9);
                _context7.next = 19;
                return _this.setLoading(false);

              case 19:
                if (!(_context7.t0.res && _context7.t0.res.status >= 400 && _context7.t0.res.status < 500)) {
                  _context7.next = 25;
                  break;
                }

                _context7.next = 22;
                return _context7.t0.res.text();

              case 22:
                message = _context7.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context7.abrupt('return');

              case 25:
                Bugsnag.notifyException(_context7.t0);
                _context7.next = 28;
                return _this.setLoading(false);

              case 28:
                _context7.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 30:
                return _context7.abrupt('return');

              case 31:
                if (res.ok) {
                  _context7.next = 40;
                  break;
                }

                _context7.next = 34;
                return res.text();

              case 34:
                _message = _context7.sent;
                _context7.next = 37;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 37:
                _context7.next = 39;
                return _this.setLoading(false);

              case 39:
                return _context7.abrupt('return');

              case 40:
                if (!(_this.listRef && _this.listRef.current)) {
                  _context7.next = 43;
                  break;
                }

                _context7.next = 43;
                return _this.listRef.current.fetchStateData(true);

              case 43:
                if (!(_this.editorRef && _this.editorRef.current)) {
                  _context7.next = 46;
                  break;
                }

                _context7.next = 46;
                return _this.editorRef.current.resetEditor();

              case 46:
                _context7.next = 48;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Add Note Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Note successfully added', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 48:
                _context7.next = 50;
                return _this.setLoading(false);

              case 50:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this2, [[9, 15]]);
      }));

      return function (_x6, _x7) {
        return _ref7.apply(this, arguments);
      };
    }();

    _this.handleEditorUpdate = function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(encodedMDNote, privacyValue) {
        var listPos, store, noteEditing, t, request, res, message, _message2, bNote;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                // fix for loading dimmer
                listPos = 0;

                if (!(_this.listRef && _this.listRef.current)) {
                  _context8.next = 5;
                  break;
                }

                _context8.next = 4;
                return _this.listRef.current.getScrollPostion();

              case 4:
                listPos = _context8.sent;

              case 5:
                if (!(_this.listRef && _this.listRef.current)) {
                  _context8.next = 8;
                  break;
                }

                _context8.next = 8;
                return _this.listRef.current.scrollToTop();

              case 8:
                store = _this.context.store;
                noteEditing = _this.state.noteEditing;
                t = _this.props.t;

                if (!(noteEditing && noteEditing.id !== '')) {
                  _context8.next = 65;
                  break;
                }

                if (!(noteEditing.note !== encodedMDNote || noteEditing.privacy !== privacyValue)) {
                  _context8.next = 65;
                  break;
                }

                _context8.next = 15;
                return _this.setLoading(true);

              case 15:
                request = _extends({}, noteEditing, {
                  note: encodedMDNote,
                  privacy: privacyValue
                });
                res = '';
                _context8.prev = 17;
                _context8.next = 20;
                return store.dispatch((0, _fetchM.fetchM)('/shared_notes/' + request.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': _this.state.token
                  },
                  body: JSON.stringify(request)
                }));

              case 20:
                res = _context8.sent;
                _context8.next = 39;
                break;

              case 23:
                _context8.prev = 23;
                _context8.t0 = _context8['catch'](17);
                _context8.next = 27;
                return _this.setLoading(false);

              case 27:
                if (!(_context8.t0.res && _context8.t0.res.status >= 400 && _context8.t0.res.status < 500)) {
                  _context8.next = 33;
                  break;
                }

                _context8.next = 30;
                return _context8.t0.res.text();

              case 30:
                message = _context8.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context8.abrupt('return');

              case 33:
                Bugsnag.notifyException(_context8.t0);
                _context8.next = 36;
                return _this.setLoading(false);

              case 36:
                _context8.next = 38;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 38:
                return _context8.abrupt('return');

              case 39:
                if (res.ok) {
                  _context8.next = 48;
                  break;
                }

                _context8.next = 42;
                return res.text();

              case 42:
                _message2 = _context8.sent;
                _context8.next = 45;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message2 }));

              case 45:
                _context8.next = 47;
                return _this.setComponentState({ loading: false, noteEditing: null });

              case 47:
                return _context8.abrupt('return');

              case 48:
                _context8.next = 50;
                return res.json();

              case 50:
                bNote = _context8.sent;

                if (!(bNote && _this.listRef && _this.listRef.current)) {
                  _context8.next = 54;
                  break;
                }

                _context8.next = 54;
                return _this.listRef.current.updateStateData(bNote);

              case 54:
                if (!(_this.editorRef && _this.editorRef.current)) {
                  _context8.next = 57;
                  break;
                }

                _context8.next = 57;
                return _this.editorRef.current.resetEditor(true);

              case 57:
                _context8.next = 59;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Note successfully updated', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 59:
                _context8.next = 61;
                return _this.setComponentState({ loading: false, noteEditing: null });

              case 61:
                if (!(bNote && _this.listRef && _this.listRef.current)) {
                  _context8.next = 64;
                  break;
                }

                _context8.next = 64;
                return _this.listRef.current.scrollToPosition(listPos);

              case 64:
                return _context8.abrupt('return');

              case 65:
                if (!(_this.editorRef && _this.editorRef.current)) {
                  _context8.next = 68;
                  break;
                }

                _context8.next = 68;
                return _this.editorRef.current.resetEditor(true);

              case 68:
                _context8.next = 70;
                return _this.setComponentState({ loading: false, noteEditing: null });

              case 70:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this2, [[17, 23]]);
      }));

      return function (_x8, _x9) {
        return _ref8.apply(this, arguments);
      };
    }();

    _this.isInternalUser = function () {
      var user = _this.props.auth;
      if (!user.companyBranch.isExternal) return true;
      return false;
    };

    _this.state = {
      isRefreshing: false,
      loading: false,
      noteEditing: null,
      token: '',
      isExpanded: false
    };
    _this.listRef = _react2.default.createRef();
    _this.editorRef = _react2.default.createRef();
    _this.refreshCooldown = null;
    return _this;
  }

  _createClass(SharedNote, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.setRef) {
        this.props.setRef(this);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.refreshCooldown !== null) clearInterval(this.refreshCooldown);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState(state) {
      var _this3 = this;

      return new Promise(function (resolve) {
        _this3.setState(function (prevState) {
          var nextState = typeof state === 'function' ? state(prevState) : state;
          return nextState;
        }, function () {
          return resolve(_this3.state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
    // trigger from list, confirm delete button

    // trigger from list, edit button

    // trigger from note editor, cancel edit button

    // trigger from note editor, add button

    // trigger from note editor, update button

  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props = this.props,
          auth = _props.auth,
          isDisabled = _props.isDisabled,
          hasEditAccess = _props.hasEditAccess,
          parentType = _props.parentType,
          parentID = _props.parentID,
          showExpand = _props.showExpand,
          t = _props.t;
      var _state = this.state,
          loading = _state.loading,
          isExpanded = _state.isExpanded,
          isRefreshing = _state.isRefreshing,
          noteEditing = _state.noteEditing;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16, className: isExpanded ? '' : 'mobile-half-left-padding' },
            _react2.default.createElement(
              _semanticUiReact.Segment.Group,
              { className: 'booking-note ' + (showExpand ? 'expand-mode' : '') },
              _react2.default.createElement(_semanticUiReact.Dimmer, {
                active: isDisabled,
                inverted: true,
                style: { zIndex: 20 }
              }),
              _react2.default.createElement(
                _semanticUiReact.Header,
                { size: 'tiny', textAlign: 'center', className: 'bn-header' },
                t('Notes')
              ),
              _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_semanticUiReact.Button, {
                  className: 'bn-refresh',
                  disabled: isRefreshing,
                  icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh', loading: isRefreshing, fitted: true, size: 'small' }),
                  onClick: this.handleClickRefresh,
                  title: 'Refresh'
                }),
                showExpand ? _react2.default.createElement(_semanticUiReact.Button, {
                  className: 'bn-expand',
                  icon: _react2.default.createElement(_semanticUiReact.Icon, { name: isExpanded ? 'compress' : 'expand', fitted: true, size: 'small' }),
                  onClick: this.handleClickExpand,
                  title: isExpanded ? 'Minimize' : 'Maximize'
                }) : ''
              ),
              _react2.default.createElement(_.List, {
                auth: auth,
                parentType: parentType,
                parentID: parentID,
                hasEditAccess: hasEditAccess,
                noteEditingID: noteEditing && noteEditing.id || '',
                noteOnDelete: this.handleOnNoteDelete,
                noteOnEdit: this.handleOnNoteEdit,
                ref: this.listRef,
                requestLoading: loading,
                isExpanded: isExpanded,
                onTokenReceived: function onTokenReceived(token) {
                  _this5.setState({ token: token });
                }
              }),
              hasEditAccess ? _react2.default.createElement(_BookingNote.NoteEditor, {
                bookingNote: noteEditing,
                defaultPrivacy: this.props.defaultPrivacy,
                loading: loading,
                onAdd: this.handleEditorAdd,
                onCancel: this.handleEditorCancel,
                onUpdate: this.handleEditorUpdate,
                ref: this.editorRef,
                showInternalPrivacy: this.isInternalUser(),
                auth: this.props.auth,
                settings: this.props.appConfig && this.props.appConfig.data && this.props.appConfig.data.settings
              }) : ''
            )
          )
        )
      );
    }
  }]);

  return SharedNote;
}(_react.Component);

SharedNote.propTypes = {
  auth: _types.StateAuth,
  parentType: _propTypes2.default.string,
  parentID: _propTypes2.default.string,
  checkHasChanges: _propTypes2.default.func,
  defaultPrivacy: _propTypes2.default.string,
  hasEditAccess: _propTypes2.default.bool,
  isDisabled: _propTypes2.default.bool,
  onCheck: _propTypes2.default.func,
  onExpand: _propTypes2.default.func,
  setRef: _propTypes2.default.func,
  showExpand: _propTypes2.default.bool,
  token: _propTypes2.default.string,
  t: _propTypes2.default.func,
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      settings: _propTypes2.default.shape({
        notesExternalPlaceholder: _propTypes2.default.string
      })
    })
  })
};

SharedNote.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

SharedNote.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(SharedNote.mapStateToProps)(SharedNote));

/***/ }),
/* 2191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SidebarNav = function SidebarNav(_ref) {
  var children = _ref.children,
      sidebar = _ref.sidebar,
      visible = _ref.visible,
      onClose = _ref.onClose;
  return _react2.default.createElement(
    _semanticUiReact.Sidebar.Pushable,
    null,
    sidebar,
    _react2.default.createElement(
      _semanticUiReact.Sidebar.Pusher,
      { dimmed: visible, className: (visible ? 'no-scoll' : '') + ' app', onClick: onClose },
      children
    )
  );
};

SidebarNav.propTypes = {
  children: _propTypes2.default.node,
  sidebar: _propTypes2.default.node,
  visible: _propTypes2.default.bool,
  onClose: _propTypes2.default.func
};

exports.default = SidebarNav;

/***/ }),
/* 2192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _trimCanvas = __webpack_require__(3510);

var _trimCanvas2 = _interopRequireDefault(_trimCanvas);

var _bezier = __webpack_require__(2193);

var _bezier2 = _interopRequireDefault(_bezier);

var _point = __webpack_require__(2194);

var _point2 = _interopRequireDefault(_point);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/forbid-prop-types: 0, no-underscore-dangle: 0*/


var SignatureCanvas = function (_Component) {
  _inherits(SignatureCanvas, _Component);

  function SignatureCanvas() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SignatureCanvas);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SignatureCanvas.__proto__ || Object.getPrototypeOf(SignatureCanvas)).call.apply(_ref, [this].concat(args))), _this), _this.getCanvas = function () {
      return _this.canvasS;
    }, _this.getTrimmedCanvas = function () {
      // copy the canvas
      var copy = document.createElement('canvas');
      copy.width = _this.canvasS.width;
      copy.height = _this.canvasS.height;
      copy.getContext('2d').drawImage(_this.canvasS, 0, 0);
      // then trim it
      return (0, _trimCanvas2.default)(copy);
    }, _this.clear = function () {
      var ctx = _this.contextS;
      var canvas = _this.canvasS;

      ctx.fillStyle = _this.props.backgroundColor;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      _this._reset();
    }, _this.fromDataURL = function (dataURL, options) {
      var image = new Image();
      var opts = options || {};
      var ratio = opts.ratio || window.devicePixelRatio || 1;
      var width = opts.width || _this.canvasS.width / ratio;
      var height = opts.height || _this.canvasS.height / ratio;

      _this._reset();
      image.onload = function () {
        return _this.contextS.drawImage(image, 0, 0, width, height);
      };
      image.src = dataURL;
      _this._isEmpty = false;
    }, _this.isEmpty = function () {
      return _this._isEmpty;
    }, _this._checkClearOnResize = function () {
      _this._resizeCanvas();
    }, _this._resizeCanvas = function () {
      var data = void 0;
      if (!_this.props.clearOnResize) {
        data = !_this.isEmpty() ? _this.getCanvas().toDataURL() : '';
      }

      var ctx = _this.contextS;
      var canvas = _this.canvasS;
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
      /* When zoomed out to less than 100%, for some very strange reason,
        some browsers report devicePixelRatio as less than 1
        and only part of the canvas is cleared then. */
      var ratio = Math.max(window.devicePixelRatio || 1, 1);

      // get the space outside the canvas size
      var w = window.innerWidth - canvas.offsetWidth;
      var h = window.innerHeight - canvas.offsetHeight;

      canvas.width = (window.innerWidth - w) * ratio;
      canvas.height = (window.innerHeight - h - 98) * ratio;
      ctx.scale(ratio, ratio);
      _this.clear();
      if (!_this.props.clearOnResize && data !== '') {
        var options = {};
        options.ratio = ratio || '';
        _this.fromDataURL(data, options);
      }
    }, _this._reset = function () {
      _this.points = [];
      _this._lastVelocity = 0;
      _this._lastWidth = (_this.props.minWidth + _this.props.maxWidth) / 2;
      _this._isEmpty = true;
      _this.contextS.fillStyle = _this.props.penColor;
    }, _this._handleMouseEvents = function () {
      _this._mouseButtonDown = false;

      _this.canvasS.addEventListener('mousedown', _this._handleMouseDown);
      _this.canvasS.addEventListener('mousemove', _this._handleMouseMove);
      document.addEventListener('mouseup', _this._handleMouseUp);

      window.addEventListener('resize', _this._checkClearOnResize);
    }, _this._handleTouchEvents = function () {
      // Pass touch events to canvas element on mobile IE and Edge.
      _this.canvasS.style.msTouchAction = 'none';
      _this.canvasS.style.touchAction = 'none';
      _this.canvasS.addEventListener('touchstart', _this._handleTouchStart);
      _this.canvasS.addEventListener('touchmove', _this._handleTouchMove);
      document.addEventListener('touchend', _this._handleTouchEnd);
    }, _this.off = function () {
      _this.canvasS.removeEventListener('mousedown', _this._handleMouseDown);
      _this.canvasS.removeEventListener('mousemove', _this._handleMouseMove);
      document.removeEventListener('mouseup', _this._handleMouseUp);

      _this.canvasS.removeEventListener('touchstart', _this._handleTouchStart);
      _this.canvasS.removeEventListener('touchmove', _this._handleTouchMove);
      document.removeEventListener('touchend', _this._handleTouchEnd);

      window.removeEventListener('resize', _this._checkClearOnResize);
    }, _this._handleMouseDown = function (ev) {
      if (ev.which === 1) {
        _this._mouseButtonDown = true;
        _this._strokeBegin(ev);
      }
    }, _this._handleMouseMove = function (ev) {
      if (_this._mouseButtonDown) {
        _this._strokeUpdate(ev);
      }
    }, _this._handleMouseUp = function (ev) {
      if (ev.which === 1 && _this._mouseButtonDown) {
        _this._mouseButtonDown = false;
        _this._strokeEnd(ev);
      }
    }, _this._handleTouchStart = function (ev) {
      var touch = ev.changedTouches[0];
      _this._strokeBegin(touch);
    }, _this._handleTouchMove = function (ev) {
      // prevent scrolling
      ev.preventDefault();

      var touch = ev.changedTouches[0];
      _this._strokeUpdate(touch);
    }, _this._handleTouchEnd = function (ev) {
      var wasCanvasTouched = ev.target === _this.canvasS;
      if (wasCanvasTouched) {
        _this._strokeEnd(ev);
      }
    }, _this._strokeUpdate = function (ev) {
      var point = _this._createPoint(ev);
      _this._addPoint(point);
    }, _this._strokeBegin = function (ev) {
      _this._reset();
      _this._strokeUpdate(ev);
      _this.props.onBegin(ev);
    }, _this._strokeDraw = function (point) {
      var ctx = _this.contextS;
      var dotSize = typeof _this.props.dotSize === 'function' ? _this.props.dotSize(_this.props.minWidth, _this.props.maxWidth) : _this.props.dotSize;

      ctx.beginPath();
      _this._drawPoint(point.x, point.y, dotSize);
      ctx.closePath();
      ctx.fill();
    }, _this._strokeEnd = function (ev) {
      var canDrawCurve = _this.points.length > 2;
      var point = _this.points[0];

      if (!canDrawCurve && point) {
        _this._strokeDraw(point);
      }

      _this.props.onEnd(ev);
    }, _this._createPoint = function (ev) {
      var rect = _this.canvasS.getBoundingClientRect();
      return new _point2.default(ev.clientX - rect.left, ev.clientY - rect.top);
    }, _this._addPoint = function (point) {
      var points = _this.points;
      var c2 = void 0;
      var c3 = void 0;
      var curve = void 0;
      var tmp = void 0;

      points.push(point);

      if (points.length > 2) {
        // To reduce the initial lag make it work with 3 points
        // by copying the first point to the beginning.
        if (points.length === 3) points.unshift(points[0]);

        tmp = _this._calculateCurveControlPoints(points[0], points[1], points[2]);
        c2 = tmp.c2;
        tmp = _this._calculateCurveControlPoints(points[1], points[2], points[3]);
        c3 = tmp.c1;
        curve = new _bezier2.default(points[1], c2, c3, points[2]);
        _this._addCurve(curve);

        // Remove the first element from the list,
        // so that we always have no more than 4 points in points array.
        points.shift();
      }
    }, _this._calculateCurveControlPoints = function (s1, s2, s3) {
      var dx1 = s1.x - s2.x;
      var dy1 = s1.y - s2.y;
      var dx2 = s2.x - s3.x;
      var dy2 = s2.y - s3.y;

      var m1 = { x: (s1.x + s2.x) / 2.0, y: (s1.y + s2.y) / 2.0 };
      var m2 = { x: (s2.x + s3.x) / 2.0, y: (s2.y + s3.y) / 2.0 };

      var l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
      var l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);

      var dxm = m1.x - m2.x;
      var dym = m1.y - m2.y;

      var k = l2 / (l1 + l2);
      var cm = { x: m2.x + dxm * k, y: m2.y + dym * k };

      var tx = s2.x - cm.x;
      var ty = s2.y - cm.y;

      return {
        c1: new _point2.default(m1.x + tx, m1.y + ty),
        c2: new _point2.default(m2.x + tx, m2.y + ty)
      };
    }, _this._addCurve = function (curve) {
      var startPoint = curve.startPoint;
      var endPoint = curve.endPoint;
      var velocity = void 0;

      velocity = endPoint.velocityFrom(startPoint);
      velocity = _this.props.velocityFilterWeight * velocity + (1 - _this.props.velocityFilterWeight) * _this._lastVelocity;

      var newWidth = _this._strokeWidth(velocity);
      _this._drawCurve(curve, _this._lastWidth, newWidth);

      _this._lastVelocity = velocity;
      _this._lastWidth = newWidth;
    }, _this._drawPoint = function (x, y, size) {
      var ctx = _this.contextS;

      ctx.moveTo(x, y);
      ctx.arc(x, y, size, 0, 2 * Math.PI, false);
      _this._isEmpty = false;
    }, _this._drawCurve = function (curve, startWidth, endWidth) {
      var ctx = _this.contextS;
      var widthDelta = endWidth - startWidth;
      var width = void 0;
      var t = void 0;
      var tt = void 0;
      var ttt = void 0;
      var u = void 0;
      var uu = void 0;
      var uuu = void 0;
      var x = void 0;
      var y = void 0;

      var drawSteps = Math.floor(curve.length());
      ctx.beginPath();
      for (var i = 0; i < drawSteps; i += 1) {
        // Calculate the Bezier (x, y) coordinate for this step.
        t = i / drawSteps;
        tt = t * t;
        ttt = tt * t;
        u = 1 - t;
        uu = u * u;
        uuu = uu * u;

        x = uuu * curve.startPoint.x;
        x += 3 * uu * t * curve.control1.x;
        x += 3 * u * tt * curve.control2.x;
        x += ttt * curve.endPoint.x;

        y = uuu * curve.startPoint.y;
        y += 3 * uu * t * curve.control1.y;
        y += 3 * u * tt * curve.control2.y;
        y += ttt * curve.endPoint.y;

        width = startWidth + ttt * widthDelta;
        _this._drawPoint(x, y, width);
      }
      ctx.closePath();
      ctx.fill();
    }, _this._strokeWidth = function (velocity) {
      return Math.max(_this.props.maxWidth / (velocity + 1), _this.props.minWidth);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SignatureCanvas, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.contextS = this.canvasS.getContext('2d');

      this._handleMouseEvents();
      this._handleTouchEvents();
      this._resizeCanvas();
      this.clear();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.off();
    }

    // return the canvas ref for operations like toDataURL


    // return a trimmed copy of the canvas

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var canvasProps = this.props.canvasProps;

      return _react2.default.createElement('canvas', _extends({ ref: function ref(_ref2) {
          _this2.canvasS = _ref2;
        } }, canvasProps));
    }
  }]);

  return SignatureCanvas;
}(_react.Component);

SignatureCanvas.propTypes = {
  velocityFilterWeight: _propTypes2.default.number,
  minWidth: _propTypes2.default.number,
  maxWidth: _propTypes2.default.number,
  dotSize: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  penColor: _propTypes2.default.string,
  onEnd: _propTypes2.default.func,
  onBegin: _propTypes2.default.func,
  canvasProps: _propTypes2.default.object,
  clearOnResize: _propTypes2.default.bool,
  backgroundColor: _propTypes2.default.string
};
SignatureCanvas.defaultProps = {
  velocityFilterWeight: 0.001,
  minWidth: 0.5,
  maxWidth: 2.5,
  dotSize: function dotSize(minWidth, maxWidth) {
    return (minWidth + maxWidth) / 2;
  },
  penColor: 'black',
  onEnd: function onEnd() {},
  onBegin: function onBegin() {},
  backgroundColor: 'rgba(0,0,0,0)',
  clearOnResize: true
};
exports.default = SignatureCanvas;

/***/ }),
/* 2193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint one-var: ["error", "always"]*/

var Bezier = function () {
  function Bezier(startPoint, control1, control2, endPoint) {
    _classCallCheck(this, Bezier);

    this.point = function (t, start, c1, c2, end) {
      return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
    };

    this.startPoint = startPoint;
    this.control1 = control1;
    this.control2 = control2;
    this.endPoint = endPoint;
  }

  _createClass(Bezier, [{
    key: "length",
    value: function length() {
      var steps = 10;
      var length = 0,
          i = void 0,
          t = void 0,
          cx = void 0,
          cy = void 0,
          px = void 0,
          py = void 0,
          xdiff = void 0,
          ydiff = void 0;

      for (i = 0; i <= steps; i += 1) {
        t = i / steps;
        cx = this.point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
        cy = this.point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
        if (i > 0) {
          xdiff = cx - px;
          ydiff = cy - py;
          length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
        }
        px = cx;
        py = cy;
      }
      return length;
    }
  }]);

  return Bezier;
}();

exports.default = Bezier;

/***/ }),
/* 2194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Point = function () {
  function Point(x, y, time) {
    _classCallCheck(this, Point);

    this.x = x;
    this.y = y;
    this.time = time || new Date().getTime();
  }

  _createClass(Point, [{
    key: "velocityFrom",
    value: function velocityFrom(start) {
      return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 1;
    }
  }, {
    key: "distanceTo",
    value: function distanceTo(start) {
      return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
    }
  }]);

  return Point;
}();

exports.default = Point;

/***/ }),
/* 2195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSortableHoc = __webpack_require__(123);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SortableContainer = (0, _reactSortableHoc.SortableContainer)(function (props) {
  return _react2.default.createElement(
    'div',
    { className: 'sortablehoc ' + (props.containerClass ? props.containerClass : '') },
    props.headerNode ? props.headerNode : '',

    // eslint-disable-next-line no-nested-ternary
    props.data.length > 0 ? props.data.map(function (value, index) {
      return props.item ? props.item(_extends({
        index: index,
        idx: index,
        key: 'item-' + index,
        value: value
      }, props)) : '';
    }) : props.notFound ? props.notFound : '',
    props.footerNode ? props.footerNode : ''
  );
});

SortableContainer.propTypes = {
  containerClass: _propTypes2.default.string,
  data: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  footerNode: _propTypes2.default.node,
  headerNode: _propTypes2.default.node,
  notFound: _propTypes2.default.node
};

exports.default = SortableContainer;

/***/ }),
/* 2196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactSortableHoc = __webpack_require__(123);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SortableDragHandle = (0, _reactSortableHoc.SortableHandle)(function (_ref) {
  var iconClass = _ref.iconClass,
      iconColor = _ref.iconColor,
      iconName = _ref.iconName,
      iconSize = _ref.iconSize,
      iconDisabled = _ref.iconDisabled;
  return _react2.default.createElement(_semanticUiReact.Icon, {
    className: 'dragicon ' + iconClass,
    color: iconColor,
    disabled: iconDisabled,
    name: iconName,
    size: iconSize
  });
});

SortableDragHandle.propTypes = {
  iconClass: _propTypes2.default.string,
  iconColor: _propTypes2.default.string,
  iconName: _propTypes2.default.string,
  iconSize: _propTypes2.default.string,
  iconDisabled: _propTypes2.default.bool
};

SortableDragHandle.defaultProps = {
  iconClass: '',
  iconColor: null,
  iconName: 'content',
  iconSize: 'large',
  iconDisabled: true
};

exports.default = SortableDragHandle;

/***/ }),
/* 2197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dropdownStyle = {
  margin: 0
};

var BusinessUnitDropdown = function (_Component) {
  _inherits(BusinessUnitDropdown, _Component);

  function BusinessUnitDropdown(props) {
    _classCallCheck(this, BusinessUnitDropdown);

    var _this = _possibleConstructorReturn(this, (BusinessUnitDropdown.__proto__ || Object.getPrototypeOf(BusinessUnitDropdown)).call(this, props));

    _initialiseProps.call(_this);

    var state = BusinessUnitDropdown.getPropsToState(props);
    _this.state = _extends({}, state, {
      branches: [],
      fullBranches: [],
      loading: true,
      value: props.value ? props.value : []
    });
    return _this;
  }

  _createClass(BusinessUnitDropdown, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchCompanyBranches();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = BusinessUnitDropdown.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this2.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchCompanyBranches',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, branches;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                res = void 0;
                _context.prev = 2;
                _context.next = 5;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/company_branches/?page=all&getProjects=true', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                res = _context.sent;
                _context.next = 16;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](2);
                _context.next = 12;
                return this.setLoading(false);

              case 12:
                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                return _context.abrupt('return');

              case 16:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 19;
                return this.setLoading(false);

              case 19:
                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 33;
                break;

              case 26:
                _context.next = 28;
                return res.json();

              case 28:
                branches = _context.sent;
                _context.next = 31;
                return this.setComponentState({
                  branches: branches ? branches.map(function (ul) {
                    var branch = {
                      content: _react2.default.createElement(_semanticUiReact.Header, { as: 'h5', style: dropdownStyle, content: ul.shortName, subheader: ul.name }),
                      description: ul.isExternal ? 'Agency' : '',
                      key: ul.id,
                      name: ul.shortName,
                      text: ul.shortName,
                      value: ul.id
                    };
                    return branch;
                  }) : [],
                  fullBranches: branches
                });

              case 31:
                _context.next = 33;
                return this.setLoading(false);

              case 33:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));

      function fetchCompanyBranches() {
        return _ref.apply(this, arguments);
      }

      return fetchCompanyBranches;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          branches = _state.branches,
          loading = _state.loading,
          value = _state.value;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'label_bu_access' },
          'Business Unit Access'
        ),
        _react2.default.createElement(_semanticUiReact.Dropdown, {
          fluid: true,
          loading: loading,
          multiple: true,
          onChange: this.handleOnChange,
          options: branches,
          search: true,
          selection: true,
          placeholder: 'Select Business Unit Access',
          value: value
        })
      );
    }
  }]);

  return BusinessUnitDropdown;
}(_react.Component);

BusinessUnitDropdown.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired
};
BusinessUnitDropdown.contextTypes = {
  store: _propTypes2.default.object
};

BusinessUnitDropdown.getPropsToState = function (props) {
  var value = props.value || [];
  return {
    value: value
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleOnChange = function (e, _ref2) {
    var value = _ref2.value;

    if (_this4.props.onChange) {
      _this4.props.onChange(value);
    }
  };
};

exports.default = BusinessUnitDropdown;

/***/ }),
/* 2198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BusinessUnitDropdownWithCategories = function (_Component) {
  _inherits(BusinessUnitDropdownWithCategories, _Component);

  function BusinessUnitDropdownWithCategories(props) {
    _classCallCheck(this, BusinessUnitDropdownWithCategories);

    var _this = _possibleConstructorReturn(this, (BusinessUnitDropdownWithCategories.__proto__ || Object.getPrototypeOf(BusinessUnitDropdownWithCategories)).call(this, props));

    _initialiseProps.call(_this);

    var state = BusinessUnitDropdownWithCategories.getPropsToState(props);
    _this.state = _extends({}, state, {
      isOpen: false
    });
    return _this;
  }

  _createClass(BusinessUnitDropdownWithCategories, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = BusinessUnitDropdownWithCategories.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this2.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'getInternalBranchIds',
    value: function getInternalBranchIds() {
      var fullBranches = this.state.fullBranches;

      return fullBranches.filter(function (branch) {
        return !branch.isExternal;
      }).map(function (branch) {
        return branch.id;
      });
    }
  }, {
    key: 'getExternalBranchIds',
    value: function getExternalBranchIds() {
      var fullBranches = this.state.fullBranches;

      return fullBranches.filter(function (branch) {
        return branch.isExternal;
      }).map(function (branch) {
        return branch.id;
      });
    }
  }, {
    key: 'getAllBranchIds',
    value: function getAllBranchIds() {
      var fullBranches = this.state.fullBranches;

      return fullBranches.map(function (branch) {
        return branch.id;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          branches = _state.branches,
          value = _state.value,
          placeholder = _state.placeholder,
          fullBranches = _state.fullBranches;
      var style = this.props.style;

      var safeValue = Array.isArray(value) ? value : [];
      var dynamicOptions = [];
      var hasInternalBranches = fullBranches && fullBranches.some(function (branch) {
        return !branch.isExternal;
      });
      var hasExternalBranches = fullBranches && fullBranches.some(function (branch) {
        return branch.isExternal;
      });
      var branchById = fullBranches ? fullBranches.reduce(function (acc, branch) {
        return _extends({}, acc, _defineProperty({}, branch.id, branch));
      }, {}) : {};
      var selectedInternalIds = safeValue.filter(function (id) {
        var branch = branchById[id];
        return branch && !branch.isExternal;
      });
      var selectedExternalIds = safeValue.filter(function (id) {
        var branch = branchById[id];
        return branch && branch.isExternal;
      });
      var allInternalIds = this.getInternalBranchIds();
      var allExternalIds = this.getExternalBranchIds();
      var allIds = this.getAllBranchIds();
      var hasUnselectItems = safeValue.length < allIds.length;
      var hasUnselectInternalItems = hasInternalBranches && selectedInternalIds.length < allInternalIds.length;
      var hasUnselectExternalItems = hasExternalBranches && selectedExternalIds.length < allExternalIds.length;
      if (hasUnselectItems) {
        dynamicOptions.push({
          key: 'select-all',
          text: 'Select All',
          value: 'select-all',
          content: _react2.default.createElement(_semanticUiReact.Header, { as: 'h5', style: { margin: 0 }, content: 'Select All' })
        });
      }
      if (hasUnselectInternalItems) {
        dynamicOptions.push({
          key: 'select-all-internal',
          text: 'Select All Internal',
          value: 'select-all-internal',
          content: _react2.default.createElement(_semanticUiReact.Header, { as: 'h5', style: { margin: 0 }, content: 'Select All Internal' })
        });
      }
      if (hasUnselectExternalItems) {
        dynamicOptions.push({
          key: 'select-all-agency',
          text: 'Select All Agency',
          value: 'select-all-agency',
          content: _react2.default.createElement(_semanticUiReact.Header, { as: 'h5', style: { margin: 0 }, content: 'Select All Agency' })
        });
      }
      var hasSelectedItems = safeValue.length > 0;
      var hasSelectedInternalItems = selectedInternalIds.length > 0;
      var hasSelectedExternalItems = selectedExternalIds.length > 0;
      if (hasSelectedItems) {
        dynamicOptions.push({
          key: 'deselect-all',
          text: 'Deselect All',
          value: 'deselect-all',
          content: _react2.default.createElement(_semanticUiReact.Header, { as: 'h5', style: { margin: 0 }, content: 'Deselect All' })
        });
      }
      if (hasSelectedInternalItems) {
        dynamicOptions.push({
          key: 'deselect-all-internal',
          text: 'Deselect All Internal',
          value: 'deselect-all-internal',
          content: _react2.default.createElement(_semanticUiReact.Header, { as: 'h5', style: { margin: 0 }, content: 'Deselect All Internal' })
        });
      }
      if (hasSelectedExternalItems) {
        dynamicOptions.push({
          key: 'deselect-all-agency',
          text: 'Deselect All Agency',
          value: 'deselect-all-agency',
          content: _react2.default.createElement(_semanticUiReact.Header, { as: 'h5', style: { margin: 0 }, content: 'Deselect All Agency' })
        });
      }
      var allOptions = [].concat(dynamicOptions, _toConsumableArray(branches));
      var remaining = this.getRemainingText();
      return _react2.default.createElement(
        'div',
        { className: 'business-unit-dropdown' },
        _react2.default.createElement(
          'div',
          { style: { fontWeight: 'bold', marginBottom: '8px' } },
          'Visibility by Business Unit'
        ),
        _react2.default.createElement(
          'div',
          { style: { position: 'relative' } },
          _react2.default.createElement(_semanticUiReact.Dropdown, {
            fluid: true,
            multiple: true,
            onChange: this.handleOnChange,
            onOpen: this.handleOnOpen,
            onClose: this.handleOnClose,
            options: allOptions,
            search: true,
            selection: true,
            placeholder: placeholder || 'Select Business Unit Access',
            value: safeValue,
            style: style,
            renderLabel: this.renderLabel
          }),
          remaining && _react2.default.createElement(
            'div',
            {
              style: {
                position: 'absolute',
                right: '30px',
                top: '50%',
                transform: 'translateY(-50%)',
                pointerEvents: 'none',
                zIndex: 1
              }
            },
            remaining
          )
        )
      );
    }
  }]);

  return BusinessUnitDropdownWithCategories;
}(_react.Component);

BusinessUnitDropdownWithCategories.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  placeholder: _propTypes2.default.string,
  style: _propTypes2.default.shape({}),
  companyBranches: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  fullCompanyBranches: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
};
BusinessUnitDropdownWithCategories.contextTypes = {
  store: _propTypes2.default.object
};

BusinessUnitDropdownWithCategories.getPropsToState = function (props) {
  var value = Array.isArray(props.value) ? props.value : [];
  var placeholder = props.placeholder;
  var companyBranches = props.companyBranches || [];
  var fullCompanyBranches = props.fullCompanyBranches || [];
  return {
    value: value,
    placeholder: placeholder,
    branches: companyBranches,
    fullBranches: fullCompanyBranches
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleOnChange = function (e, _ref) {
    var value = _ref.value;

    var newValue = [].concat(_toConsumableArray(value));

    // Handle special select all cases
    if (value.includes('select-all')) {
      // Select all branches
      newValue = _this3.getAllBranchIds();
    } else if (value.includes('select-all-internal')) {
      // Remove the special value and add all internal branches
      newValue = newValue.filter(function (v) {
        return v !== 'select-all-internal';
      });
      var internalIds = _this3.getInternalBranchIds();
      // Add internal IDs that aren't already selected
      internalIds.forEach(function (id) {
        if (!newValue.includes(id)) {
          newValue.push(id);
        }
      });
    } else if (value.includes('select-all-agency')) {
      // Remove the special value and add all external branches
      newValue = newValue.filter(function (v) {
        return v !== 'select-all-agency';
      });
      var externalIds = _this3.getExternalBranchIds();
      // Add external IDs that aren't already selected
      externalIds.forEach(function (id) {
        if (!newValue.includes(id)) {
          newValue.push(id);
        }
      });
    } else if (value.includes('deselect-all')) {
      newValue = [];
    } else if (value.includes('deselect-all-internal')) {
      newValue = newValue.filter(function (v) {
        return v !== 'deselect-all-internal';
      });
      var _internalIds = _this3.getInternalBranchIds();
      newValue = newValue.filter(function (id) {
        return !_internalIds.includes(id);
      });
    } else if (value.includes('deselect-all-agency')) {
      newValue = newValue.filter(function (v) {
        return v !== 'deselect-all-agency';
      });
      var _externalIds = _this3.getExternalBranchIds();
      newValue = newValue.filter(function (id) {
        return !_externalIds.includes(id);
      });
    }

    // Filter out special values and divider
    newValue = newValue.filter(function (v) {
      return v !== 'select-all' && v !== 'select-all-internal' && v !== 'select-all-agency' && v !== 'deselect-all' && v !== 'deselect-all-internal' && v !== 'deselect-all-agency' && v !== 'divider';
    });

    if (_this3.props.onChange) {
      _this3.props.onChange(newValue);
    }
  };

  this.handleOnOpen = function () {
    _this3.setState({ isOpen: true });
  };

  this.handleOnClose = function () {
    _this3.setState({ isOpen: false });
  };

  this.renderLabel = function (label) {
    var _state2 = _this3.state,
        isOpen = _state2.isOpen,
        value = _state2.value,
        branches = _state2.branches;

    var safeValue = Array.isArray(value) ? value : [];
    if (isOpen || safeValue.length <= 1) {
      return _extends({}, label, {
        content: label.text
      });
    }
    var selectedBranches = branches.filter(function (branch) {
      return safeValue.includes(branch.value);
    });
    var firstValue = selectedBranches.length > 0 ? selectedBranches[0].value : null;

    if (label.value !== firstValue) {
      return null;
    }
    return _extends({}, label, {
      content: _react2.default.createElement(
        'span',
        { style: { fontSize: '12px' } },
        label.text
      )
    });
  };

  this.getRemainingText = function () {
    var _state3 = _this3.state,
        isOpen = _state3.isOpen,
        value = _state3.value;

    var safeValue = Array.isArray(value) ? value : [];

    if (!isOpen && safeValue.length > 1) {
      var remaining = safeValue.length - 1;
      return _react2.default.createElement(
        'span',
        {
          style: {
            fontSize: '12px',
            color: '#999',
            marginLeft: '4px',
            fontWeight: 'normal'
          }
        },
        '+',
        remaining
      );
    }
    return null;
  };
};

exports.default = BusinessUnitDropdownWithCategories;

/***/ }),
/* 2199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormulaDropdownInput = function (_Component) {
  _inherits(FormulaDropdownInput, _Component);

  function FormulaDropdownInput(props) {
    _classCallCheck(this, FormulaDropdownInput);

    var _this = _possibleConstructorReturn(this, (FormulaDropdownInput.__proto__ || Object.getPrototypeOf(FormulaDropdownInput)).call(this, props));

    _this.getFormulaTypes = function (data) {
      if (data.orderPriority > 1) {
        return [{ text: 'Deduct percentage of selling price', value: 'discount_percent_original_price' }, { text: 'Deduct percentage of selling price (Round Up Decimals)', value: 'discount_percent_original_price_round_up' }, { text: 'Deduct percentage of selling price (Round Down Decimals)', value: 'discount_percent_original_price_round_down' }, { text: 'Deduct percentage of selling price (Round Up Ringgit)', value: 'discount_percent_original_price_round_up_ringgit' }, { text: 'Deduct percentage of selling price (Round Down Ringgit)', value: 'discount_percent_original_price_round_down_ringgit' }, { text: 'Deduct percentage of above formula total', value: 'discount_percent_previous_item' }, { text: 'Deduct percentage of above formula total (Round Up Decimals)', value: 'discount_percent_previous_item_round_up' }, { text: 'Deduct percentage of above formula total (Round Down Decimals)', value: 'discount_percent_previous_item_round_down' }, { text: 'Deduct percentage of above formula total (Round Up Ringgit)', value: 'discount_percent_previous_item_round_up_ringgit' }, { text: 'Deduct percentage of above formula total (Round Down Ringgit)', value: 'discount_percent_previous_item_round_down_ringgit' }, { text: 'Deduct fixed amount', value: 'discount_fixed_amount' }, { text: 'Add percentage of selling price', value: 'add_percent_original_price' }, { text: 'Add percentage of selling price (Round Up Decimals)', value: 'add_percent_original_price_round_up' }, { text: 'Add percentage of selling price (Round Down Decimals)', value: 'add_percent_original_price_round_down' }, { text: 'Add percentage of selling price (Round Up Ringgit)', value: 'add_percent_original_price_round_up_ringgit' }, { text: 'Add percentage of selling price (Round Down Ringgit)', value: 'add_percent_original_price_round_down_ringgit' }, { text: 'Add percentage of above\'s formula total', value: 'add_percent_previous_item' }, { text: 'Add percentage of above\'s formula total (Round Up Decimals)', value: 'add_percent_previous_item_round_up' }, { text: 'Add percentage of above\'s formula total (Round Down Decimals)', value: 'add_percent_previous_item_round_down' }, { text: 'Add percentage of above\'s formula total (Round Up Ringgit)', value: 'add_percent_previous_item_round_up_ringgit' }, { text: 'Add percentage of above\'s formula total (Round Down Ringgit)', value: 'add_percent_previous_item_round_down_ringgit' }, { text: 'Add fixed amount', value: 'add_fixed_amount' }, { text: 'Custom Formula', value: 'custom_formula', disabled: true }];
      }
      return [{ text: 'Deduct percentage of selling price', value: 'discount_percent_original_price' }, { text: 'Deduct percentage of selling price (Round Up Decimals)', value: 'discount_percent_original_price_round_up' }, { text: 'Deduct percentage of selling price (Round Down Decimals)', value: 'discount_percent_original_price_round_down' }, { text: 'Deduct percentage of selling price (Round Up Ringgit)', value: 'discount_percent_original_price_round_up_ringgit' }, { text: 'Deduct percentage of selling price (Round Down Ringgit)', value: 'discount_percent_original_price_round_down_ringgit' }, { text: 'Deduct percentage of above formula total', value: 'discount_percent_previous_item', disabled: true }, { text: 'Deduct percentage of above formula total (Round Up Decimals)', value: 'discount_percent_previous_item_round_up', disabled: true }, { text: 'Deduct percentage of above formula total (Round Down Decimals)', value: 'discount_percent_previous_item_round_down', disabled: true }, { text: 'Deduct percentage of above formula total (Round Up Ringgit)', value: 'discount_percent_previous_item_round_up_ringgit', disabled: true }, { text: 'Deduct percentage of above formula total (Round Down Ringgit)', value: 'discount_percent_previous_item_round_down_ringgit', disabled: true }, { text: 'Deduct fixed amount', value: 'discount_fixed_amount' }, { text: 'Add percentage of selling price', value: 'add_percent_original_price' }, { text: 'Add percentage of selling price (Round Up Decimals)', value: 'add_percent_original_price_round_up' }, { text: 'Add percentage of selling price (Round Down Decimals)', value: 'add_percent_original_price_round_down' }, { text: 'Add percentage of selling price (Round Up Ringgit)', value: 'add_percent_original_price_round_up_ringgit' }, { text: 'Add percentage of selling price (Round Down Ringgit)', value: 'add_percent_original_price_round_down_ringgit' }, { text: 'Add percentage of above\'s formula total', value: 'add_percent_previous_item', disabled: true }, { text: 'Add percentage of above\'s formula total (Round Up Decimals)', value: 'add_percent_previous_item_round_up', disabled: true }, { text: 'Add percentage of above\'s formula total (Round Down Decimals)', value: 'add_percent_previous_item_round_down', disabled: true }, { text: 'Add percentage of above\'s formula total (Round Up Ringgit)', value: 'add_percent_previous_item_round_up_ringgit', disabled: true }, { text: 'Add percentage of above\'s formula total (Round Down Ringgit)', value: 'add_percent_previous_item_round_down_ringgit', disabled: true }, { text: 'Add fixed amount', value: 'add_fixed_amount' }, { text: 'Custom Formula', value: 'custom_formula' }];
    };

    _this.getFormulaTypeValidation = function (data) {
      switch (data.formulaType) {
        case 'discount_percent_original_price':
        case 'discount_percent_original_price_round_up':
        case 'discount_percent_original_price_round_down':
        case 'discount_percent_original_price_round_up_ringgit':
        case 'discount_percent_original_price_round_down_ringgit':
        case 'discount_percent_previous_item':
        case 'discount_percent_previous_item_round_up':
        case 'discount_percent_previous_item_round_down':
        case 'discount_percent_previous_item_round_up_ringgit':
        case 'discount_percent_previous_item_round_down_ringgit':
        case 'add_percent_original_price':
        case 'add_percent_original_price_round_up':
        case 'add_percent_original_price_round_down':
        case 'add_percent_original_price_round_up_ringgit':
        case 'add_percent_original_price_round_down_ringgit':
        case 'add_percent_previous_item':
        case 'add_percent_previous_item_round_up':
        case 'add_percent_previous_item_round_down':
        case 'add_percent_previous_item_round_up_ringgit':
        case 'add_percent_previous_item_round_down_ringgit':
          return [_webValidations.required, {
            validate: _webValidations.numericRange,
            option: {
              min: 0.01,
              max: 100
            }
          }];
        case 'discount_fixed_amount':
        case 'add_fixed_amount':
          return [_webValidations.required, {
            validate: _webValidations.numericRange,
            option: {
              min: 0.00,
              max: 2147483647
            }
          }];
        case 'custom_formula':
          return [_webValidations.required];
        default:
          return null;
      }
    };

    _this.getFormulaValuePlaceholder = function (data) {
      switch (data.formulaType) {
        case 'discount_percent_original_price':
        case 'discount_percent_previous_item':
          return 'Deduct percent';
        case 'discount_percent_original_price_round_up':
        case 'discount_percent_previous_item_round_up':
          return 'Deduct percent (round up decimals)';
        case 'discount_percent_original_price_round_up_ringgit':
        case 'discount_percent_previous_item_round_up_ringgit':
          return 'Deduct percent (round up ringgit)';
        case 'discount_percent_original_price_round_down':
        case 'discount_percent_previous_item_round_down':
          return 'Deduct percent (round down decimals)';
        case 'discount_percent_original_price_round_down_ringgit':
        case 'discount_percent_previous_item_round_down_ringgit':
          return 'Deduct percent (round down ringgit)';
        case 'discount_fixed_amount':
          return 'Deduct amount';
        case 'add_percent_original_price':
        case 'add_percent_previous_item':
          return 'Additional percent';
        case 'add_percent_original_price_round_up':
        case 'add_percent_previous_item_round_up':
          return 'Additional percent (round up decimals)';
        case 'add_percent_original_price_round_up_ringgit':
        case 'add_percent_previous_item_round_up_ringgit':
          return 'Additional percent (round up ringgit)';
        case 'add_percent_original_price_round_down':
        case 'add_percent_previous_item_round_down':
          return 'Additional percent (round down decimals)';
        case 'add_percent_original_price_round_down_ringgit':
        case 'add_percent_previous_item_round_down_ringgit':
          return 'Additional percent (round down ringgit)';
        case 'add_fixed_amount':
          return 'Additional amount';
        case 'custom_formula':
          return 'Custom formula';
        default:
          return '';
      }
    };

    _this.handleOnChange = function (e, value) {
      if (_this.props.onChange) {
        _this.props.onChange(e, value);
      }
    };

    _this.handleHelpModal = function (e) {
      e.preventDefault();
      _this.setState({
        helpModalIsOpen: true
      });
    };

    _this.handleHelpModalClose = function () {
      _this.setState({
        helpModalIsOpen: false
      });
    };

    _this.state = {
      helpModalIsOpen: false
    };
    return _this;
  }

  _createClass(FormulaDropdownInput, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;
      var helpModalIsOpen = this.state.helpModalIsOpen;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Modal,
          { open: helpModalIsOpen, size: 'small', onClose: this.handleHelpModalClose },
          _react2.default.createElement(_semanticUiReact.Header, { icon: 'help', content: 'Custom Formula Help' }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              'b',
              null,
              'Formula Operators & Syntax'
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              _semanticUiReact.List,
              null,
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'small' },
                  '+'
                ),
                ' Addition.',
                _react2.default.createElement('br', null)
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'small' },
                  '-'
                ),
                ' Subtraction.',
                _react2.default.createElement('br', null)
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'small' },
                  '*'
                ),
                ' Multiplication.',
                _react2.default.createElement('br', null)
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'small' },
                  '/'
                ),
                ' Division.',
                _react2.default.createElement('br', null)
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'small' },
                  '.'
                ),
                ' Decimal point for cents.',
                _react2.default.createElement('br', null)
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'small' },
                  '('
                ),
                ' ',
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'small' },
                  ')'
                ),
                ' Parenthesis to control order of evaluation.',
                _react2.default.createElement('br', null)
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'small' },
                  'SPA_VALUE'
                ),
                ' or ',
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'small' },
                  'SELLING_PRICE'
                ),
                ' Selling price of unit.'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'small' },
                  'ROUND(value)'
                ),
                ' Rounds cents to the nearest ones.'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'small' },
                  'CEIL(value)'
                ),
                ' Rounds cents up to the nearest ones.'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'small' },
                  'FLOOR(value)'
                ),
                ' Rounds cents down to the nearest ones.'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'small' },
                  'PERCENT(value, percentage)'
                ),
                ' Get percent of value.'
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'small' },
                  _react2.default.createElement(
                    'strike',
                    null,
                    'TIER("Tier Name")'
                  )
                ),
                ' ',
                _react2.default.createElement(
                  'strike',
                  null,
                  'Get value of another tier.'
                )
              )
            ),
            _react2.default.createElement(
              'b',
              null,
              'Examples'
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              _semanticUiReact.List,
              null,
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'small' },
                  'SPA Value-3%-7%-2%-RM500'
                ),
                ' would be ',
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { color: 'grey', size: 'small' },
                  '(((SPA_VALUE*(1-0.03))*(1-0.07))*(1-0.02))-500'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'small' },
                  'RM250,000.00'
                ),
                ' would be ',
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { color: 'grey', size: 'small' },
                  '250000.00'
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(
              _semanticUiReact.Button,
              { onClick: this.handleHelpModalClose },
              'Close'
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'row_formula_dropdown_input' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 16, tablet: 8, computer: 8 },
            _react2.default.createElement(
              'div',
              { className: 'label_formula_type' },
              'Formula Type'
            ),
            _react2.default.createElement(_semanticUiReact.Dropdown, {
              fluid: true,
              name: 'formulaType',
              onChange: this.handleOnChange,
              options: this.getFormulaTypes(data),
              placeholder: 'Select Formula Type',
              ref: this.props.refValidation,
              selection: true,
              value: data.formulaType
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 16, tablet: 8, computer: 8 },
            _react2.default.createElement(_AppForm2.default.Input, {
              label: 'Formula Value',
              name: 'formulaValue',
              onChange: this.handleOnChange,
              placeholder: this.getFormulaValuePlaceholder(data),
              ref: this.props.refValidation,
              step: data.formulaType === 'custom_formula' ? null : '.01',
              type: data.formulaType === 'custom_formula' ? 'text' : 'number',
              validateLabel: 'Formula Value',
              validation: this.getFormulaTypeValidation(data),
              value: data.formulaValue,
              icon: data.formulaType === 'custom_formula' ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'help', fitted: true, inverted: true, color: 'teal', className: 'icon_custom_formula_help', circular: true, onClick: this.handleHelpModal }) : null
            })
          )
        )
      );
    }
  }]);

  return FormulaDropdownInput;
}(_react.Component);

FormulaDropdownInput.propTypes = {
  data: _propTypes2.default.shape(),
  onChange: _propTypes2.default.func.isRequired,
  refValidation: _propTypes2.default.func
};
exports.default = FormulaDropdownInput;

/***/ }),
/* 2200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _BusinessUnitDropdown = __webpack_require__(2197);

var _BusinessUnitDropdown2 = _interopRequireDefault(_BusinessUnitDropdown);

var _SchedulePicker = __webpack_require__(2202);

var _SchedulePicker2 = _interopRequireDefault(_SchedulePicker);

var _SortablePackagePricingItem = __webpack_require__(2204);

var _SortablePackagePricingItem2 = _interopRequireDefault(_SortablePackagePricingItem);

var _package_pricing = __webpack_require__(222);

var _vietnamPricing = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */


var PackagePricingEdit = function (_Component) {
  _inherits(PackagePricingEdit, _Component);

  // CPI-977: state holds what the agent typed; converting on every keystroke would eat the decimal.
  function PackagePricingEdit(props) {
    _classCallCheck(this, PackagePricingEdit);

    var _this = _possibleConstructorReturn(this, (PackagePricingEdit.__proto__ || Object.getPrototypeOf(PackagePricingEdit)).call(this, props));

    _this.handleDepositRateChange = function (e, d) {
      var data = _this.props.data;

      data.depositRate = (0, _vietnamPricing.depositPercentToRate)(d.value);
      _this.setState({ depositRatePercent: d.value });
      if (_this.props.onChange) _this.props.onChange(data);
    };

    _this.handleDelete = function (e) {
      e.preventDefault();
      var data = _this.props.data;

      if (_this.props.onDelete) _this.props.onDelete(data);
    };

    _this.handleSave = function (e) {
      if (e) e.preventDefault();
      var data = _this.props.data;

      if (_this.props.onChange) _this.props.onChange(data);
    };

    _this.handleInputChange = function (e, d) {
      var data = _this.props.data;

      data[d.name] = d.value;
      if (_this.props.onChange) _this.props.onChange(data);
    };

    _this.handleCheckboxChange = function (e, d) {
      var data = _this.props.data;

      data[d.name] = !data[d.name];
      if (_this.props.onChange) _this.props.onChange(data);
    };

    _this.handleScheduleConfirm = function (value) {
      var data = _this.props.data;

      data.scheduleStartAt = value.scheduleStartAt;
      data.scheduleEndAt = value.scheduleEndAt;
      if (_this.props.onChange) _this.props.onChange(data);
    };

    _this.handleBUAccessChange = function (value) {
      var data = _this.props.data;

      data.businessUnitAccesses = value;
      if (_this.props.onChange) _this.props.onChange(data);
    };

    _this.handleItemChange = function (value) {
      var data = _this.props.data;
      // TODO: change to packagePricingCalculations

      data.packagePricingItems = value;
      if (_this.props.onChange) _this.props.onChange(data);
    };

    _this.handleDeleteItem = function (id, callback) {
      if (_this.props.onDeleteItem) _this.props.onDeleteItem(id, callback);
    };

    _this.handleEditingItem = function (ids, data) {
      if (_this.props.onEditingItems) _this.props.onEditingItems(ids, data);
    };

    _this.handleSortItems = function (isSorting) {
      if (_this.props.onSortItems) _this.props.onSortItems(isSorting);
    };

    _this.handleBulkMangeUnits = function () {
      var add = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var data = _this.props.data;

      if (_this.props.onBulkManageUnits) _this.props.onBulkManageUnits(add, data.id);
    };

    _this.handleBulkUpdateUnits = function () {
      var data = _this.props.data;

      if (_this.props.onBulkUpdateUnits) _this.props.onBulkUpdateUnits(data.id);
    };

    _this.renderDepositRate = function () {
      if (!_this.props.isVietnam) {
        return null;
      }
      var depositRatePercent = _this.state.depositRatePercent;

      var isValid = (0, _vietnamPricing.isDepositRatePercentValid)(depositRatePercent);
      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { className: 'row_deposit_rate' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { mobile: 16, tablet: 6, computer: 6 },
          _react2.default.createElement(_semanticUiReact.Form.Input, {
            label: 'Deposit rate (%)',
            max: _vietnamPricing.DEPOSIT_RATE_PERCENT_MAX,
            min: 0,
            name: 'depositRate',
            onChange: _this.handleDepositRateChange,
            placeholder: 'e.g. 10',
            step: '0.01',
            type: 'number',
            value: depositRatePercent
          }),
          _react2.default.createElement(
            'p',
            { className: 'text-subtitle', style: isValid ? null : { color: 'red' } },
            isValid ? 'Percentage of the nett price collected as the deposit. Leave empty to collect the project\u2019s fixed reservation amount instead.' : 'Enter a percentage between 0 and ' + _vietnamPricing.DEPOSIT_RATE_PERCENT_MAX + '. Anything else is stored as no rate, and the project\u2019s fixed reservation amount applies.'
          )
        )
      );
    };

    _this.state = {
      depositRatePercent: (0, _vietnamPricing.depositRateToPercent)(props.data && props.data.depositRate)
    };
    return _this;
  }
  // An invalid or empty box writes null, not 0 - book-api reads NULL as "no rate on this package".


  _createClass(PackagePricingEdit, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.props.data;

      return _react2.default.createElement(
        'div',
        { className: 'sortablehoc_item' },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _AppForm2.default,
                {
                  as: 'div',
                  onSubmit: this.handleSave,
                  ref: this.props.refForm
                },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { className: 'row_name_desc' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 6, computer: 6 },
                      _react2.default.createElement(_AppForm2.default.Input, {
                        label: 'Package Name',
                        name: 'name',
                        onChange: this.handleInputChange,
                        ref: this.props.refValidation,
                        type: 'text',
                        validateLabel: 'Package Name',
                        validation: [_webValidations.required, {
                          validate: _webValidations.stringLength,
                          option: {
                            max: 128
                          }
                        }],
                        value: data.name
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 10, computer: 10 },
                      _react2.default.createElement(_semanticUiReact.Label, { className: 'row_label', content: 'Package Description' }),
                      _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                        name: 'description',
                        onChange: this.handleInputChange,
                        type: 'text',
                        value: data.description,
                        rows: 1,
                        style: { whiteSpace: 'pre-wrap' }
                      })
                    )
                  ),
                  this.renderDepositRate(),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { className: 'row_schedule_bu_access' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 16, computer: 10 },
                      _react2.default.createElement(_SchedulePicker2.default, {
                        data: data,
                        onConfirm: this.handleScheduleConfirm
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 16, computer: 6 },
                      _react2.default.createElement(_BusinessUnitDropdown2.default, {
                        onChange: this.handleBUAccessChange,
                        value: data.businessUnitAccesses || []
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { verticalAlign: 'top', className: 'row_enable_bumi_delete' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 5, computer: 4 },
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        null,
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          checked: data.isEnabled,
                          label: 'Enable Package',
                          name: 'isEnabled',
                          onChange: this.handleCheckboxChange,
                          ref: this.props.refValidation,
                          toggle: true
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 8, computer: 10 },
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        null,
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          checked: data.bumiPurchaserOnly,
                          label: 'Package for primary bumi purchaser only',
                          name: 'bumiPurchaserOnly',
                          onChange: this.handleCheckboxChange,
                          ref: this.props.refValidation
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 3, computer: 2, className: 'column_delete' },
                      _react2.default.createElement(
                        _semanticUiReact.Button,
                        {
                          size: 'small',
                          basic: true,
                          compact: true,
                          icon: true,
                          onClick: this.handleDelete
                        },
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'trash', color: 'red' })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { className: 'row_formula' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16 },
                      _react2.default.createElement(_semanticUiReact.Divider, null),
                      _react2.default.createElement(_SortablePackagePricingItem2.default
                      // TODO: change to packagePricingCalculations
                      , { data: data.packagePricingItems || [],
                        onChange: this.handleItemChange,
                        onDeleteItem: this.handleDeleteItem,
                        onEditingItems: this.handleEditingItem,
                        onSortItems: this.handleSortItems
                      })
                    )
                  ),
                  _react2.default.createElement(_semanticUiReact.Divider, null),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { textAlign: 'center', className: 'row_bulk_manage_unit_pp', centered: true },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 15, computer: 12 },
                      _react2.default.createElement(
                        _semanticUiReact.Grid,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { mobile: 16, tablet: 6, computer: 6, verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Button,
                              {
                                size: 'small',
                                basic: true,
                                compact: true,
                                disabled: data.id === '',
                                onClick: function onClick() {
                                  return _this2.handleBulkUpdateUnits();
                                }
                              },
                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh' }),
                              'Recalculate in all units'
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { mobile: 16, tablet: 4, computer: 4, verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Button,
                              {
                                size: 'small',
                                primary: true,
                                basic: true,
                                compact: true,
                                disabled: data.id === '',
                                onClick: function onClick() {
                                  return _this2.handleBulkMangeUnits(true);
                                }
                              },
                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark', color: 'blue' }),
                              'Apply to all units'
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { mobile: 16, tablet: 6, computer: 6, verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Button,
                              {
                                size: 'small',
                                negative: true,
                                basic: true,
                                compact: true,
                                disabled: data.id === '',
                                onClick: function onClick() {
                                  return _this2.handleBulkMangeUnits(false);
                                }
                              },
                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'x', color: 'red' }),
                              'Remove from all units'
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return PackagePricingEdit;
}(_react.Component);

PackagePricingEdit.propTypes = {
  data: _propTypes2.default.shape(),
  // CPI-977: the deposit rate is a Vietnam-only package setting, passed down from the container.
  isVietnam: _propTypes2.default.bool,
  onBulkManageUnits: _propTypes2.default.func,
  onBulkUpdateUnits: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  onDeleteItem: _propTypes2.default.func,
  onEditingItems: _propTypes2.default.func,
  onSortItems: _propTypes2.default.func,
  refForm: _propTypes2.default.func,
  refValidation: _propTypes2.default.func
};
PackagePricingEdit.defaultProps = {
  data: Object.assign({}, _package_pricing.PROJECT_PACKAGE_PRICING_DEFAULT),
  isVietnam: false };
exports.default = PackagePricingEdit;

/***/ }),
/* 2201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _FormulaDropdownInput = __webpack_require__(2199);

var _FormulaDropdownInput2 = _interopRequireDefault(_FormulaDropdownInput);

var _package_pricing = __webpack_require__(222);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PackagePricingItemEdit = function (_Component) {
  _inherits(PackagePricingItemEdit, _Component);

  function PackagePricingItemEdit() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, PackagePricingItemEdit);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PackagePricingItemEdit.__proto__ || Object.getPrototypeOf(PackagePricingItemEdit)).call.apply(_ref, [this].concat(args))), _this), _this.handleDelete = function (e) {
      e.preventDefault();
      var data = _this.props.data;

      if (_this.props.onDelete) _this.props.onDelete(data);
    }, _this.handleSave = function (e) {
      if (e) e.preventDefault();
      var data = _this.props.data;

      if (_this.props.onChange) _this.props.onChange(data);
    }, _this.handleInputChange = function (e, d) {
      var data = _this.props.data;

      data[d.name] = d.value;
      if (_this.props.onChange) _this.props.onChange(data);
    }, _this.handleCheckboxChange = function (e, d) {
      var data = _this.props.data;

      data[d.name] = !data[d.name];
      if (_this.props.onChange) _this.props.onChange(data);
    }, _this.handleScheduleConfirm = function (value) {
      var data = _this.props.data;

      data.scheduleStartAt = value.scheduleStartAt;
      data.scheduleEndAt = value.scheduleEndAt;
      if (_this.props.onChange) _this.props.onChange(data);
    }, _this.handleBUAccessChange = function (value) {
      var data = _this.props.data;

      data.businessUnitAccesses = value;
      if (_this.props.onChange) _this.props.onChange(data);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(PackagePricingItemEdit, [{
    key: 'render',
    value: function render() {
      var data = this.props.data;

      return _react2.default.createElement(
        'div',
        { className: 'sortablehoc_item' },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _AppForm2.default,
                {
                  as: 'div',
                  onSubmit: this.handleSave,
                  ref: this.props.refForm
                },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { className: 'row_name_desc' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 6, computer: 6 },
                      _react2.default.createElement(_AppForm2.default.Input, {
                        label: 'Formula Name',
                        name: 'name',
                        onChange: this.handleInputChange,
                        placeholder: 'Formula Name',
                        ref: this.props.refValidation,
                        type: 'text',
                        validateLabel: 'Formula Name',
                        validation: [_webValidations.required, {
                          validate: _webValidations.stringLength,
                          option: {
                            max: 128
                          }
                        }],
                        value: data.name
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 10, computer: 10 },
                      _react2.default.createElement(_semanticUiReact.Label, { className: 'row_label', content: 'Formula Description' }),
                      _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                        name: 'description',
                        onChange: this.handleInputChange,
                        placeholder: 'Formula Description',
                        type: 'text',
                        rows: 1,
                        value: data.description
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { verticalAlign: 'middle', className: 'row_enable_formula_delete' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 5, computer: 3 },
                      _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                        checked: data.isEnabled,
                        label: 'Enable Formula',
                        name: 'isEnabled',
                        onChange: this.handleCheckboxChange,
                        ref: this.props.refValidation,
                        toggle: true
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 9, computer: 12 },
                      _react2.default.createElement(_FormulaDropdownInput2.default, _extends({}, this.props, {
                        data: data,
                        onChange: this.handleInputChange
                      }))
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 2, computer: 1, className: 'column_delete' },
                      _react2.default.createElement(
                        _semanticUiReact.Button,
                        {
                          size: 'small',
                          basic: true,
                          compact: true,
                          icon: true,
                          onClick: this.handleDelete
                        },
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'trash', color: 'red' })
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return PackagePricingItemEdit;
}(_react.Component);

PackagePricingItemEdit.propTypes = {
  data: _propTypes2.default.shape(),
  onChange: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  refForm: _propTypes2.default.func,
  refValidation: _propTypes2.default.func
};
PackagePricingItemEdit.defaultProps = {
  data: Object.assign({}, _package_pricing.PROJECT_PACKAGE_PRICING_ITEM_DEFAULT)
};
exports.default = PackagePricingItemEdit;

/***/ }),
/* 2202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _DateTimePicker = __webpack_require__(314);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_momentTimezone2.default.locale('en-gb');

var inputDateFormat = 'DD/MM/YYYY, hh:mm A';

var SchedulePicker = function (_Component) {
  _inherits(SchedulePicker, _Component);

  function SchedulePicker(props) {
    _classCallCheck(this, SchedulePicker);

    var _this = _possibleConstructorReturn(this, (SchedulePicker.__proto__ || Object.getPrototypeOf(SchedulePicker)).call(this, props));

    _initialiseProps.call(_this);

    var data = Object.assign({
      scheduleStartAt: null,
      scheduleEndAt: null
    }, props.data || {});
    _this.state = {
      data: data,
      visibleStart: false,
      visibleEnd: false
    };
    return _this;
  }

  _createClass(SchedulePicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var data = Object.assign({
        scheduleStartAt: null,
        scheduleEndAt: null
      }, nextProps.data || {});
      this.setState({
        data: data
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          data = _state.data,
          visibleStart = _state.visibleStart,
          visibleEnd = _state.visibleEnd;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 16, tablet: 8, computer: 8 },
            _react2.default.createElement(
              'div',
              { className: 'ui form' },
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_semanticUiReact.Form.Input, {
                  label: 'Schedule Start',
                  fluid: true,
                  placeholder: 'Click to setup start date',
                  value: data.scheduleStartAt ? (0, _momentTimezone2.default)(data.scheduleStartAt).format(inputDateFormat) : '',
                  readOnly: true,
                  onFocus: function onFocus() {
                    return _this2.handleOnVisible('visibleStart');
                  },
                  icon: data.scheduleStartAt ? _react2.default.createElement(_semanticUiReact.Icon, {
                    color: 'red',
                    link: true,
                    name: 'x',
                    onClick: function onClick(e) {
                      return _this2.handleOnClear(e, 'scheduleStartAt');
                    },
                    title: 'Clear'
                  }) : 'calendar'
                })
              ),
              _react2.default.createElement(_DateTimePicker2.default, {
                closeableCompact: false,
                maxDate: data.scheduleEndAt && data.scheduleEndAt,
                noPadding: true,
                onChange: function onChange(value, visible) {
                  return _this2.handleOnChange(value, 'scheduleStartAt', visible);
                },
                value: data.scheduleStartAt ? (0, _momentTimezone2.default)(data.scheduleStartAt).toDate() : '',
                visible: visibleStart
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 16, tablet: 8, computer: 8 },
            _react2.default.createElement(
              'div',
              { className: 'ui form' },
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_semanticUiReact.Form.Input, {
                  label: 'Schedule End',
                  fluid: true,
                  placeholder: 'Click to setup end date',
                  value: data.scheduleEndAt ? (0, _momentTimezone2.default)(data.scheduleEndAt).format(inputDateFormat) : '',
                  readOnly: true,
                  onFocus: function onFocus() {
                    return _this2.handleOnVisible('visibleEnd');
                  },
                  icon: data.scheduleEndAt ? _react2.default.createElement(_semanticUiReact.Icon, {
                    color: 'red',
                    link: true,
                    name: 'x',
                    onClick: function onClick(e) {
                      return _this2.handleOnClear(e, 'scheduleEndAt');
                    },
                    title: 'Clear'
                  }) : 'calendar'
                })
              ),
              _react2.default.createElement(_DateTimePicker2.default, {
                closeableCompact: false,
                minDate: data.scheduleStartAt && data.scheduleStartAt,
                onChange: function onChange(value, visible) {
                  return _this2.handleOnChange(value, 'scheduleEndAt', visible);
                },
                noPadding: true,
                value: data.scheduleEndAt ? (0, _momentTimezone2.default)(data.scheduleEndAt).toDate() : '',
                visible: visibleEnd
              })
            )
          )
        )
      );
    }
  }]);

  return SchedulePicker;
}(_react.Component);

SchedulePicker.propTypes = {
  data: _propTypes2.default.shape({
    scheduleStartAt: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.instanceOf(Date)]),
    scheduleEndAt: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.instanceOf(Date)])
  }),
  onConfirm: _propTypes2.default.func
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleOnVisible = function (visibleID) {
    var states = _this3.state;
    states.visibleStart = false;
    states.visibleEnd = false;
    states[visibleID] = true;
    _this3.setState(states);
  };

  this.handleOnHide = function (visibleID) {
    _this3.setState(_defineProperty({}, visibleID, false));
  };

  this.handleOnClear = function (e, visibleID) {
    var data = _this3.state.data;

    if (visibleID === 'scheduleStartAt') {
      data.scheduleStartAt = null;
    } else if (visibleID === 'scheduleEndAt') {
      data.scheduleEndAt = null;
    }
    _this3.setState(_defineProperty({ data: data }, visibleID, false), function () {
      _this3.handleOnComfirm();
    });
  };

  this.handleOnChange = function (value, id, visible) {
    var _this3$setState3;

    var data = _this3.state.data;
    var _state2 = _this3.state,
        visibleStart = _state2.visibleStart,
        visibleEnd = _state2.visibleEnd;

    if (id === 'scheduleStartAt') {
      visibleStart = visible;
    } else if (id === 'scheduleEndAt') {
      visibleEnd = visible;
    }
    data[id] = value || null;
    _this3.setState((_this3$setState3 = { data: data }, _defineProperty(_this3$setState3, id, value), _defineProperty(_this3$setState3, 'visibleStart', visibleStart), _defineProperty(_this3$setState3, 'visibleEnd', visibleEnd), _this3$setState3), function () {
      _this3.handleOnComfirm();
    });
  };

  this.handleOnComfirm = function () {
    var data = _this3.state.data;

    if (_this3.props.onConfirm) {
      _this3.props.onConfirm(data);
    }
  };
};

exports.default = SchedulePicker;

/***/ }),
/* 2203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _reactSortableHoc = __webpack_require__(123);

var _PackagePricingEdit = __webpack_require__(2200);

var _PackagePricingEdit2 = _interopRequireDefault(_PackagePricingEdit);

var _ = __webpack_require__(317);

var _flash = __webpack_require__(5);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

var _package_pricing = __webpack_require__(222);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */


var SortableItem = (0, _reactSortableHoc.SortableElement)(function (props) {
  return _react2.default.createElement(
    'div',
    { className: 'sortablehoc_item ' + (props.itemClass ? props.itemClass : '') },
    _react2.default.createElement(
      _semanticUiReact.Segment,
      { raised: props.isEditing(), className: 'package ' + (props.isEditing() ? 'editing' : '') },
      _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'row_item' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 2, tablet: 2, computer: 1, verticalAlign: 'middle' },
            props.isSortMode ? _react2.default.createElement(
              'div',
              { className: 'sorting_buttons' },
              _react2.default.createElement(_.SortableDragHandle, props)
            ) : _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _semanticUiReact.Label,
                { basic: props.value.isEnabled, color: props.value.isEnabled ? null : 'red', circular: true },
                props.value.orderPriority
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 10, tablet: 11, computer: 13, verticalAlign: 'middle' },
            props.isEditing() ? props.getStatusText() : _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { className: 'text_name' },
                props.value.name,
                props.value.description !== '' ? ':' : ''
              ),
              ' ',
              _react2.default.createElement(
                'span',
                { className: 'text_description' },
                props.isEditing() ? '' : props.value.description
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 4, tablet: 3, computer: 2, textAlign: 'right' },
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                size: 'tiny',
                compact: true,
                disabled: props.isSortMode || props.isSortingItems || props.isEditingItems(),
                onClick: function onClick(e) {
                  return props.handleCopy(e, props.idx);
                },
                icon: true
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'copy', color: 'blue', fitted: true })
            ),
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                size: 'tiny',
                color: 'blue',
                compact: true,
                disabled: props.isSortMode || props.isSortingItems || props.isEditingItems(),
                onClick: function onClick(e) {
                  return props.handleEdit(e, props.idx);
                }
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'edit' }),
              props.isEditing() ? 'Done' : 'Edit'
            )
          )
        ),
        props.isEditing() ? _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(_PackagePricingEdit2.default, {
              data: props.value,
              isVietnam: props.isVietnam,
              onBulkManageUnits: props.onBulkManageUnits,
              onBulkUpdateUnits: props.onBulkUpdateUnits,
              onChange: props.onChange,
              onDelete: props.onDelete,
              onDeleteItem: props.onDeleteItem,
              onEditingItems: props.onEditingItems,
              onSortItems: props.onSortItems,
              refForm: props.setRefForm,
              refValidation: props.setRefValidation
            })
          )
        ) : ''
      )
    )
  );
});

var SortablePackagePricing = function (_Component) {
  _inherits(SortablePackagePricing, _Component);

  function SortablePackagePricing(props) {
    _classCallCheck(this, SortablePackagePricing);

    var _this = _possibleConstructorReturn(this, (SortablePackagePricing.__proto__ || Object.getPrototypeOf(SortablePackagePricing)).call(this, props));

    _initialiseProps.call(_this);

    var state = SortablePackagePricing.getPropsToState(props);
    _this.state = _extends({}, state, {
      isEditing: [],
      isEditingItems: [],
      isSortMode: false,
      isSortingItems: false,
      showDeleteConfirm: false,
      deleteIDX: null,
      deleteData: Object.assign({}, _package_pricing.PROJECT_PACKAGE_PRICING_DEFAULT)
    });
    _this.editRef = [];
    _this.formRef = {};
    return _this;
  }

  _createClass(SortablePackagePricing, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = SortablePackagePricing.getPropsToState(nextProps);
      if (JSON.stringify(this.state.data) === JSON.stringify(state.data)) {
        this.setState(_extends({}, state));
      } else {
        // collapse all editing forms on save
        this.setState(_extends({}, state, { isEditing: [], isEditingItems: [] }));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          data = _state.data,
          deleteData = _state.deleteData,
          isEditing = _state.isEditing,
          isSortMode = _state.isSortMode,
          isSortingItems = _state.isSortingItems,
          showDeleteConfirm = _state.showDeleteConfirm;

      return _react2.default.createElement(
        _semanticUiReact.Segment,
        { className: 'project_package_pricing' },
        _react2.default.createElement(_DeleteConfirm2.default, {
          content: 'Are you sure you want to delete pricing package ' + deleteData.orderPriority + '?',
          onClose: this.handleCancelDelete,
          onConfirm: this.handleConfirmDelete,
          open: showDeleteConfirm
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { verticalAlign: 'middle' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8, textAlign: 'left' },
              _react2.default.createElement(
                _semanticUiReact.Header,
                { as: 'h3', className: 'header_title' },
                'Pricing Package Setup'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8, textAlign: 'right' },
              _react2.default.createElement(
                _semanticUiReact.Button,
                { disabled: isEditing.length > 0 || data.length < 1, basic: !isSortMode, active: isSortMode, color: isSortMode ? 'blue' : null, compact: true, onClick: this.handleToggleSort },
                _react2.default.createElement(_semanticUiReact.Icon, { name: isSortMode ? 'toggle on' : 'toggle off', color: isSortMode ? null : 'blue' }),
                'Sort Package'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'row_content' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              data.length > 0 ? _react2.default.createElement(_.SortableContainer, {
                isSortMode: isSortMode,
                iconColor: 'blue',
                helperClass: 'sorting',
                data: data,
                lockAxis: 'y',
                lockToContainerEdges: true,
                onSortEnd: this.onSortEnd,
                useDragHandle: true,
                item: function item(props) {
                  return _react2.default.createElement(SortableItem, _extends({}, props, {
                    getStatusText: function getStatusText() {
                      return _this2.getStatusText(props.idx);
                    },
                    handleCopy: _this2.handleCopy,
                    handleEdit: _this2.handleEdit,
                    isEditing: function isEditing() {
                      return _this2.checkIsEditing(props.idx);
                    },
                    isVietnam: _this2.props.isVietnam,
                    isEditingItems: function isEditingItems() {
                      return _this2.checkIsEditingItems(props.idx);
                    },
                    isSortingItems: isSortingItems,
                    onBulkManageUnits: _this2.handleBulkManageUnits,
                    onBulkUpdateUnits: _this2.handleBulkUpdateUnits,
                    onChange: function onChange(d) {
                      return _this2.handleOnChange(d, props.idx);
                    },
                    onDelete: function onDelete(d) {
                      return _this2.handleDelete(d, props.idx);
                    },
                    onDeleteItem: function onDeleteItem(itemID, callBack) {
                      return _this2.handleDeleteItem(props.value.id || '', itemID, callBack, props.idx);
                    },
                    onEditingItems: function onEditingItems(iIDs, iDatas) {
                      return _this2.handleEditingItems(iIDs, iDatas, props.idx);
                    },
                    onSortItems: _this2.handleSortItems,
                    setRefForm: _this2.setRefForm,
                    setRefValidation: function setRefValidation(ref) {
                      return _this2.setRefValidation(ref, props.idx);
                    }
                  }));
                }
              }) : _react2.default.createElement(
                _semanticUiReact.Segment,
                { className: 'segment_pricing_package_not_found', textAlign: 'center' },
                'No pricing package found'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { textAlign: 'center', className: 'row_button_add' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  basic: true,
                  disabled: isEditing.length > 0,
                  onClick: this.handleAdd
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'add circle', color: 'green' }),
                ' Add pricing package'
              )
            )
          )
        )
      );
    }
  }]);

  return SortablePackagePricing;
}(_react.Component);

SortablePackagePricing.contextTypes = {
  store: _propTypes2.default.object
};
SortablePackagePricing.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  handleBulkManageUnits: _propTypes2.default.func,
  // CPI-977: passed down so the edit form can offer the deposit-rate field; false elsewhere.
  isVietnam: _propTypes2.default.bool,
  handleBulkUpdateUnits: _propTypes2.default.func,
  handleDelete: _propTypes2.default.func,
  handleDeleteItem: _propTypes2.default.func,
  onChangeData: _propTypes2.default.func,
  onEdit: _propTypes2.default.func
};

SortablePackagePricing.getPropsToState = function (props) {
  var data = props.data || [];
  return {
    data: data
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onSortEnd = function (_ref) {
    var oldIndex = _ref.oldIndex,
        newIndex = _ref.newIndex;

    var data = _this3.sortDataByIndex((0, _reactSortableHoc.arrayMove)(_this3.state.data, oldIndex, newIndex));
    _this3.setState({ data: data }, function () {
      if (_this3.props.onChangeData) _this3.props.onChangeData(data);
    });
  };

  this.setRefValidation = function (ref, idx) {
    if (ref && ref.props && ref.props.name) {
      if (!_this3.editRef[idx]) _this3.editRef[idx] = {};
      _this3.editRef[idx][ref.props.name] = ref;
    }
  };

  this.setRefForm = function (ref) {
    _this3.formRef = ref;
  };

  this.getStatusText = function (idx) {
    var data = _this3.state.data;

    var inputDateFormat = 'DD/MM/YYYY, hh:mm A';
    var statusColor = 'green';
    var statusIcon = 'check';
    var statusTitle = 'Active';
    var statusLabel = 'Active';
    if (data[idx]) {
      if (data[idx].isEnabled) {
        if (data[idx].scheduleStartAt && data[idx].scheduleEndAt) {
          if ((0, _momentTimezone2.default)(data[idx].scheduleStartAt).unix() < (0, _momentTimezone2.default)().unix() && (0, _momentTimezone2.default)(data[idx].scheduleEndAt).unix() > (0, _momentTimezone2.default)().unix()) {
            statusIcon = 'calendar check';
            statusColor = 'green';
            statusTitle = 'Active schedule: ' + (0, _momentTimezone2.default)(data[idx].scheduleStartAt).format(inputDateFormat) + ' - ' + (0, _momentTimezone2.default)(data[idx].scheduleEndAt).format(inputDateFormat);
          } else if ((0, _momentTimezone2.default)(data[idx].scheduleStartAt).unix() > (0, _momentTimezone2.default)().unix()) {
            statusIcon = 'calendar check';
            statusColor = 'yellow';
            statusTitle = 'Future schedule: ' + (0, _momentTimezone2.default)(data[idx].scheduleStartAt).format(inputDateFormat) + ' - ' + (0, _momentTimezone2.default)(data[idx].scheduleEndAt).format(inputDateFormat);
          } else {
            statusIcon = 'calendar times';
            statusColor = 'red';
            statusTitle = 'Schedule ended';
            statusLabel = 'Expired';
          }
        } else if (data[idx].scheduleStartAt) {
          if ((0, _momentTimezone2.default)(data[idx].scheduleStartAt).unix() < (0, _momentTimezone2.default)().unix()) {
            statusIcon = 'calendar check';
            statusColor = 'green';
            statusTitle = 'Active schedule: ' + (0, _momentTimezone2.default)(data[idx].scheduleStartAt).format(inputDateFormat) + ' - Not set';
          } else {
            statusIcon = 'calendar check';
            statusColor = 'yellow';
            statusTitle = 'Future schedule: ' + (0, _momentTimezone2.default)(data[idx].scheduleStartAt).format(inputDateFormat) + ' - Not set';
          }
        } else if (data[idx].scheduleEndAt) {
          if ((0, _momentTimezone2.default)(data[idx].scheduleEndAt).unix() > (0, _momentTimezone2.default)().unix()) {
            statusIcon = 'calendar check';
            statusColor = 'green';
            statusTitle = 'Active schedule: Now - ' + (0, _momentTimezone2.default)(data[idx].scheduleEndAt).format(inputDateFormat);
          } else {
            statusIcon = 'calendar times';
            statusColor = 'red';
            statusTitle = 'Schedule ended';
            statusLabel = 'Expired';
          }
        }
      } else {
        statusIcon = 'x';
        statusColor = 'red';
        statusTitle = 'Disabled';
        statusLabel = 'Disabled';
      }
    }
    return _react2.default.createElement(_semanticUiReact.Popup, {
      trigger: _react2.default.createElement(
        _semanticUiReact.Label,
        { tag: true, size: 'tiny', color: statusColor, style: { cursor: 'help' } },
        _react2.default.createElement(_semanticUiReact.Icon, { fitted: true, name: statusIcon }),
        statusLabel
      ),
      content: statusTitle,
      inverted: true,
      position: 'bottom center',
      wide: 'very'
    });
  };

  this.checkIsEditing = function (id) {
    return _this3.state.isEditing.includes(id);
  };

  this.checkIsEditingItems = function () {
    return _this3.state.isEditingItems.length > 0;
  };

  this.sortDataByIndex = function (newData) {
    var data = newData;
    data.forEach(function (d, index) {
      data[index].orderPriority = index + 1;
    });
    return data;
  };

  this.handleEdit = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e, idx) {
      var _state2, data, isEditing, store, validations, errMessages;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (e) e.preventDefault();
              _state2 = _this3.state, data = _state2.data, isEditing = _state2.isEditing;

              if (!_this3.state.isEditing.includes(idx)) {
                _context.next = 13;
                break;
              }

              store = _this3.context.store;
              _context.next = 6;
              return _AppForm2.default.validate(_this3.editRef[idx], data[idx]);

            case 6:
              validations = _context.sent;
              errMessages = validations.filter(function (v) {
                return !v.isValid;
              });

              if (!(errMessages.length > 0)) {
                _context.next = 11;
                break;
              }

              store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errMessages.map(function (l) {
                  return l.message;
                }) }));
              return _context.abrupt('return');

            case 11:
              _this3.setState({ isEditing: isEditing.filter(function (ai) {
                  return ai !== idx;
                }) }, function () {
                if (_this3.props.onEdit) _this3.props.onEdit(_this3.state.isEditing.length > 0, _this3.state.data);
              });
              return _context.abrupt('return');

            case 13:
              isEditing.push(idx);
              _this3.setState({ isEditing: isEditing }, function () {
                if (_this3.props.onEdit) _this3.props.onEdit(_this3.state.isEditing.length > 0, _this3.state.data);
              });

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.handleToggleSort = function (e) {
    e.preventDefault();
    _this3.setState({ isSortMode: !_this3.state.isSortMode });
  };

  this.handleEditingItems = function (itemIDs, itemsData, packagePricingIDX) {
    var data = _this3.state.data;
    var isEditingItems = _this3.state.isEditingItems;
    // TODO: change to packagePricingCalculations

    data[packagePricingIDX].packagePricingItems = itemsData;
    if (itemIDs.length > 0) {
      if (!isEditingItems.includes(packagePricingIDX)) isEditingItems.push(packagePricingIDX);
    } else {
      isEditingItems = isEditingItems.filter(function (ai) {
        return ai !== packagePricingIDX;
      });
    }
    _this3.setState({ isEditingItems: isEditingItems, data: data });
  };

  this.handleOnChange = function (d, idx) {
    var data = _this3.state.data;

    var newData = [];
    data.forEach(function (item, i) {
      if (i === idx) {
        newData.push(d);
      } else {
        newData.push(item);
      }
    });
    _this3.setState({ data: newData }, function () {
      if (_this3.editRef[idx]) _AppForm2.default.validate(_this3.editRef[idx], newData[idx]);
      if (_this3.props.onChangeData) _this3.props.onChangeData(newData);
    });
  };

  this.handleDelete = function (d, idx) {
    _this3.setState({
      showDeleteConfirm: true,
      deleteIDX: idx,
      deleteData: d
    });
  };

  this.handleCancelDelete = function (e) {
    e.preventDefault();
    _this3.setState({
      showDeleteConfirm: false,
      deleteIDX: null,
      deleteData: Object.assign({}, _package_pricing.PROJECT_PACKAGE_PRICING_DEFAULT)
    });
  };

  this.handleConfirmDelete = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
      var deleteData;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              e.preventDefault();
              deleteData = _this3.state.deleteData;

              if (!(deleteData.id !== '' && _this3.props.handleDelete)) {
                _context2.next = 7;
                break;
              }

              _context2.next = 5;
              return _this3.props.handleDelete(deleteData.id, function () {
                _this3.confirmDelete();
              });

            case 5:
              _context2.next = 8;
              break;

            case 7:
              _this3.confirmDelete();

            case 8:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  this.confirmDelete = function () {
    var _state3 = _this3.state,
        data = _state3.data,
        deleteIDX = _state3.deleteIDX;
    var isEditingItems = _this3.state.isEditingItems;

    var newData = [];
    data.forEach(function (item, i) {
      if (i !== deleteIDX) {
        newData.push(item);
      }
    });
    isEditingItems = isEditingItems.filter(function (ai) {
      return ai !== deleteIDX;
    });
    _this3.setState({
      data: _this3.sortDataByIndex(newData),
      deleteData: Object.assign({}, _package_pricing.PROJECT_PACKAGE_PRICING_DEFAULT),
      deleteIDX: null,
      isEditingItems: isEditingItems,
      showDeleteConfirm: false
    }, function () {
      return _this3.handleEdit(null, deleteIDX);
    });
  };

  this.handleDeleteItem = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id, itemID, callBack, packagePricingIDX) {
      var isEditingItems;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              isEditingItems = _this3.state.isEditingItems;

              if (!(itemID !== '' && _this3.props.handleDeleteItem)) {
                _context3.next = 7;
                break;
              }

              _context3.next = 4;
              return _this3.props.handleDeleteItem(id, itemID, callBack);

            case 4:
              _this3.setState({ isEditingItems: isEditingItems.filter(function (ai) {
                  return ai !== packagePricingIDX;
                }) });
              _context3.next = 8;
              break;

            case 7:
              _this3.setState({ isEditingItems: isEditingItems.filter(function (ai) {
                  return ai !== packagePricingIDX;
                }) }, function () {
                callBack();
              });

            case 8:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }));

    return function (_x4, _x5, _x6, _x7) {
      return _ref4.apply(this, arguments);
    };
  }();

  this.handleAdd = function (e) {
    e.preventDefault();
    var _state4 = _this3.state,
        isEditing = _state4.isEditing,
        data = _state4.data;

    isEditing.push(data.length);
    var newItem = (0, _clone2.default)(Object.assign({}, _package_pricing.PROJECT_PACKAGE_PRICING_DEFAULT, {
      orderPriority: data.length + 1
    }));
    data.push(newItem);
    _this3.setState({ isEditing: isEditing, data: data }, function () {
      if (_this3.props.onEdit) _this3.props.onEdit(_this3.state.isEditing.length > 0, _this3.state.data);
    });
  };

  this.handleSortItems = function (isSortingItems) {
    _this3.setState({ isSortingItems: !isSortingItems });
  };

  this.handleBulkManageUnits = function (isAdd, idx) {
    if (_this3.props.handleBulkManageUnits) _this3.props.handleBulkManageUnits(isAdd, idx);
  };

  this.handleBulkUpdateUnits = function (idx) {
    if (_this3.props.handleBulkUpdateUnits) _this3.props.handleBulkUpdateUnits(idx);
  };

  this.handleCopy = function (e, idx) {
    e.preventDefault();
    var _state5 = _this3.state,
        isEditing = _state5.isEditing,
        data = _state5.data;

    isEditing.push(data.length);
    var newItem = (0, _clone2.default)(Object.assign({}, data[idx], {
      orderPriority: data.length + 1,
      id: '',
      createdAt: null,
      updatedAt: null
    }));
    // TODO: change to packagePricingCalculations
    if (newItem.packagePricingItems) {
      var newItems = newItem.packagePricingItems;
      newItem.packagePricingItems.forEach(function (d, pid) {
        newItems[pid].id = '';
        newItems[pid].projectPackagePricingID = '';
        newItems[pid].createdAt = null;
        newItems[pid].updatedAt = null;
      });
      newItem.packagePricingItems = newItems;
    }
    data.push(newItem);
    _this3.setState({ isEditing: isEditing, data: data }, function () {
      if (_this3.props.onEdit) _this3.props.onEdit(_this3.state.isEditing.length > 0, _this3.state.data, true);
    });
  };
};

exports.default = SortablePackagePricing;

/***/ }),
/* 2204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _reactSortableHoc = __webpack_require__(123);

var _ = __webpack_require__(317);

var _PackagePricingItemEdit = __webpack_require__(2201);

var _PackagePricingItemEdit2 = _interopRequireDefault(_PackagePricingItemEdit);

var _flash = __webpack_require__(5);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

var _package_pricing = __webpack_require__(222);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */


var SortableItem = (0, _reactSortableHoc.SortableElement)(function (props) {
  return _react2.default.createElement(
    'div',
    { className: 'sortablehoc_item ' + (props.itemClass ? props.itemClass : '') },
    _react2.default.createElement(
      _semanticUiReact.Segment,
      { className: 'item ' + (props.isEditing() ? 'editing' : '') },
      _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'row_item' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 2, tablet: 2, computer: 1, verticalAlign: 'middle' },
            props.isSortMode ? _react2.default.createElement(
              'div',
              { className: 'sorting_buttons' },
              _react2.default.createElement(_.SortableDragHandle, props)
            ) : _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _semanticUiReact.Label,
                { basic: props.value.isEnabled, color: props.value.isEnabled ? null : 'red', circular: true },
                props.value.orderPriority
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 10, tablet: 11, computer: 13, verticalAlign: 'middle' },
            props.isEditing() ? '' : _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'span',
                { className: 'text_name' },
                props.value.name,
                props.value.description !== '' ? ':' : ''
              ),
              ' ',
              _react2.default.createElement(
                'span',
                { className: 'text_description' },
                props.isEditing() ? '' : props.value.description
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { mobile: 4, tablet: 3, computer: 2, textAlign: 'right' },
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                size: 'tiny',
                color: 'blue',
                compact: true,
                disabled: props.isSortMode,
                onClick: function onClick(e) {
                  return props.handleEdit(e, props.idx);
                }
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'edit' }),
              props.isEditing() ? 'Done' : 'Edit'
            )
          )
        ),
        props.isEditing() ? _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(_PackagePricingItemEdit2.default, {
              data: props.value,
              onChange: props.onChange,
              onDelete: props.onDelete,
              refForm: props.setRefForm,
              refValidation: props.setRefValidation
            })
          )
        ) : ''
      )
    )
  );
});

var SortablePackagePricingItem = function (_Component) {
  _inherits(SortablePackagePricingItem, _Component);

  function SortablePackagePricingItem(props) {
    _classCallCheck(this, SortablePackagePricingItem);

    var _this = _possibleConstructorReturn(this, (SortablePackagePricingItem.__proto__ || Object.getPrototypeOf(SortablePackagePricingItem)).call(this, props));

    _initialiseProps.call(_this);

    var state = SortablePackagePricingItem.getPropsToState(props);
    _this.state = _extends({}, state, {
      isEditing: [],
      isSortMode: false,
      showDeleteItemConfirm: false,
      deleteItemIDX: null,
      deleteItemData: Object.assign({}, _package_pricing.PROJECT_PACKAGE_PRICING_ITEM_DEFAULT)
    });
    _this.editRef = [];
    _this.formRef = {};
    return _this;
  }

  _createClass(SortablePackagePricingItem, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          data = _state.data,
          deleteItemData = _state.deleteItemData,
          isEditing = _state.isEditing,
          isSortMode = _state.isSortMode,
          showDeleteItemConfirm = _state.showDeleteItemConfirm;

      return _react2.default.createElement(
        _semanticUiReact.Segment,
        { basic: true, className: 'project_package_pricing_item' },
        _react2.default.createElement(_DeleteConfirm2.default, {
          content: 'Are you sure you want to delete fomula ' + deleteItemData.orderPriority + '?',
          onClose: this.handleCancelDeleteItem,
          onConfirm: this.handleConfirmDeleteItem,
          open: showDeleteItemConfirm
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { verticalAlign: 'middle' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8, textAlign: 'left' },
              _react2.default.createElement(
                _semanticUiReact.Header,
                { as: 'h4', className: 'header_title' },
                'Formula(s)'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8, textAlign: 'right' },
              _react2.default.createElement(
                _semanticUiReact.Button,
                { disabled: isEditing.length > 0 || data.length < 1, basic: !isSortMode, active: isSortMode, color: isSortMode ? 'blue' : null, compact: true, onClick: this.handleToggleSort },
                _react2.default.createElement(_semanticUiReact.Icon, { name: isSortMode ? 'toggle on' : 'toggle off', color: isSortMode ? null : 'blue' }),
                'Sort Formula'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'row_content' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              data.length > 0 ? _react2.default.createElement(_.SortableContainer, {
                isSortMode: isSortMode,
                iconColor: 'blue',
                helperClass: 'sorting',
                data: data,
                lockAxis: 'y',
                lockToContainerEdges: true,
                onSortEnd: this.onSortEnd,
                useDragHandle: true,
                item: function item(props) {
                  return _react2.default.createElement(SortableItem, _extends({}, props, {
                    handleEdit: _this2.handleEdit,
                    isEditing: function isEditing() {
                      return _this2.checkIsEditiing(props.idx);
                    },
                    onChange: function onChange(d) {
                      return _this2.handleChangeItem(d, props.idx);
                    },
                    onDelete: function onDelete(d) {
                      return _this2.handleDeleteItem(d, props.idx);
                    },
                    setRefForm: _this2.setRefForm,
                    setRefValidation: function setRefValidation(ref) {
                      return _this2.setRefValidation(ref, props.idx);
                    }
                  }));
                }
              }) : _react2.default.createElement(
                _semanticUiReact.Segment,
                { className: 'segment_formula_not_found', textAlign: 'center' },
                'No formula(s) found'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { textAlign: 'center', className: 'row_button_add' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  basic: true,
                  onClick: this.handleAddItem
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'add circle', color: 'green' }),
                ' Add formula'
              )
            )
          )
        )
      );
    }
  }]);

  return SortablePackagePricingItem;
}(_react.Component);

SortablePackagePricingItem.contextTypes = {
  store: _propTypes2.default.object
};
SortablePackagePricingItem.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  onChange: _propTypes2.default.func,
  onDeleteItem: _propTypes2.default.func,
  onEditingItems: _propTypes2.default.func,
  onSortItems: _propTypes2.default.func
};

SortablePackagePricingItem.getPropsToState = function (props) {
  var data = props.data || [];
  return {
    data: data
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onSortEnd = function (_ref) {
    var oldIndex = _ref.oldIndex,
        newIndex = _ref.newIndex;

    var data = _this3.sortDataByIndex((0, _reactSortableHoc.arrayMove)(_this3.state.data, oldIndex, newIndex));
    _this3.setState({ data: data }, function () {
      if (_this3.props.onChange) _this3.props.onChange(data);
    });
  };

  this.setRefValidation = function (ref, idx) {
    if (ref && ref.props && ref.props.name) {
      if (!_this3.editRef[idx]) _this3.editRef[idx] = {};
      _this3.editRef[idx][ref.props.name] = ref;
    }
  };

  this.setRefForm = function (ref) {
    _this3.formRef = ref;
  };

  this.checkIsEditiing = function (id) {
    return _this3.state.isEditing.includes(id);
  };

  this.sortDataByIndex = function (newData) {
    var data = newData;
    data.forEach(function (d, index) {
      data[index].orderPriority = index + 1;
    });
    return data;
  };

  this.handleEdit = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e, idx) {
      var _state2, data, isEditing, store, validations, errMessages;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (e) e.preventDefault();
              _state2 = _this3.state, data = _state2.data, isEditing = _state2.isEditing;

              if (!_this3.state.isEditing.includes(idx)) {
                _context.next = 13;
                break;
              }

              store = _this3.context.store;
              _context.next = 6;
              return _AppForm2.default.validate(_this3.editRef[idx], data[idx]);

            case 6:
              validations = _context.sent;
              errMessages = validations.filter(function (v) {
                return !v.isValid;
              });

              if (!(errMessages.length > 0)) {
                _context.next = 11;
                break;
              }

              store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errMessages.map(function (l) {
                  return l.message;
                }) }));
              return _context.abrupt('return');

            case 11:
              _this3.setState({ isEditing: isEditing.filter(function (ai) {
                  return ai !== idx;
                }) }, function () {
                if (_this3.props.onEditingItems) _this3.props.onEditingItems(_this3.state.isEditing, data);
              });
              return _context.abrupt('return');

            case 13:
              isEditing.push(idx);
              _this3.setState({ isEditing: isEditing }, function () {
                if (_this3.props.onEditingItems) _this3.props.onEditingItems(_this3.state.isEditing, data);
              });

            case 15:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }));

    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.handleToggleSort = function (e) {
    e.preventDefault();
    _this3.setState({ isSortMode: !_this3.state.isSortMode }, function () {
      if (_this3.props.onSortItems) _this3.props.onSortItems(!_this3.state.isSortMode);
    });
  };

  this.handleChangeItem = function (d, idx) {
    var data = _this3.state.data;

    var newData = [];
    data.forEach(function (item, i) {
      if (i === idx) {
        newData.push(d);
      } else {
        newData.push(item);
      }
    });
    _this3.setState({ data: newData }, function () {
      if (_this3.editRef[idx]) _AppForm2.default.validate(_this3.editRef[idx], newData[idx]);
      if (_this3.props.onChange) _this3.props.onChange(newData);
    });
  };

  this.handleDeleteItem = function (d, idx) {
    _this3.setState({
      showDeleteItemConfirm: true,
      deleteItemIDX: idx,
      deleteItemData: d
    });
  };

  this.handleCancelDeleteItem = function (e) {
    e.preventDefault();
    _this3.setState({
      showDeleteItemConfirm: false,
      deleteItemIDX: null,
      deleteItemData: Object.assign({}, _package_pricing.PROJECT_PACKAGE_PRICING_ITEM_DEFAULT)
    });
  };

  this.handleConfirmDeleteItem = function (e) {
    e.preventDefault();
    var deleteItemData = _this3.state.deleteItemData;

    if (_this3.props.onDeleteItem) {
      _this3.props.onDeleteItem(deleteItemData.id, function () {
        _this3.confirmDeleteItem();
      });
    }
  };

  this.confirmDeleteItem = function () {
    var _state3 = _this3.state,
        data = _state3.data,
        deleteItemIDX = _state3.deleteItemIDX;

    var newData = [];
    data.forEach(function (item, i) {
      if (i !== deleteItemIDX) {
        newData.push(item);
      }
    });
    _this3.setState({
      data: _this3.sortDataByIndex(newData),
      showDeleteItemConfirm: false,
      deleteItemIDX: null,
      deleteItemData: Object.assign({}, _package_pricing.PROJECT_PACKAGE_PRICING_ITEM_DEFAULT)
    }, function () {
      return _this3.handleEdit(null, deleteItemIDX);
    });
  };

  this.handleAddItem = function (e) {
    e.preventDefault();
    var _state4 = _this3.state,
        isEditing = _state4.isEditing,
        data = _state4.data;

    isEditing.push(data.length);
    var newItem = (0, _clone2.default)(Object.assign({}, _package_pricing.PROJECT_PACKAGE_PRICING_ITEM_DEFAULT, {
      orderPriority: data.length + 1
    }));
    data.push(newItem);
    _this3.setState({ isEditing: isEditing, data: data }, function () {
      if (_this3.props.onEditingItems) _this3.props.onEditingItems(isEditing, data);
    });
  };
};

exports.default = SortablePackagePricingItem;

/***/ }),
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SortablePackagePricing = __webpack_require__(2203);

var _SortablePackagePricing2 = _interopRequireDefault(_SortablePackagePricing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SortablePackagePricing2.default;

/***/ }),
/* 2206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TagList = function (_Component) {
  _inherits(TagList, _Component);

  function TagList(props) {
    _classCallCheck(this, TagList);

    var _this = _possibleConstructorReturn(this, (TagList.__proto__ || Object.getPrototypeOf(TagList)).call(this, props));

    _this.handleChangePage = function (currentPage) {
      _this.setState({ currentPage: currentPage }, function () {
        _this.fetchTags(_this.props.where);
      });
    };

    _this.handleCancelDelete = function (e) {
      e.preventDefault();
      _this.setState({
        showConfirm: false,
        selectedTag: null
      });
    };

    _this.handleDelete = function (e, selectedTag) {
      e.preventDefault();
      _this.setState({
        selectedTag: selectedTag
      }, function () {
        _this.setState({
          showConfirm: true
        });
      });
    };

    _this.handleConfirmDelete = function (e) {
      e.preventDefault();
      _this.setState({
        showConfirm: false
      }, function () {
        _this.deleteTag(_this.state.selectedTag.id);
      });
    };

    _this.state = {
      count: 0,
      limit: 0,
      offset: 0,
      loading: props.loading || true,
      data: [],
      currentPage: 1,
      showConfirm: false,
      selectedTag: null
    };
    return _this;
  }

  _createClass(TagList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchTags(this.props.where);
    }
  }, {
    key: 'setTags',
    value: function setTags() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this2.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchTag',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var store, t, res, token, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                token = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/tags/' + this.props.type + '/' + id + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 15:
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                return _context.abrupt('return', null);

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 27;
                break;

              case 26:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

              case 27:
                return _context.abrupt('return', token);

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchTag(_x4) {
        return _ref.apply(this, arguments);
      }

      return fetchTag;
    }()
  }, {
    key: 'fetchTags',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var where = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var store, t, query, res, message, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, where);

                query.page = this.state.currentPage || 1;
                res = void 0;
                _context2.prev = 7;
                _context2.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/tags/' + this.props.type + '/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 10:
                res = _context2.sent;
                _context2.next = 21;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](7);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 18:
                _context2.next = 20;
                return this.setLoading(false);

              case 20:
                return _context2.abrupt('return');

              case 21:
                if (res.ok) {
                  _context2.next = 29;
                  break;
                }

                _context2.next = 24;
                return res.text();

              case 24:
                message = _context2.sent;
                _context2.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 27:
                _context2.next = 39;
                break;

              case 29:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context2.next = 34;
                return res.json();

              case 34:
                data = _context2.sent;
                _context2.next = 37;
                return this.setTags(data);

              case 37:
                _context2.next = 39;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 39:
                _context2.next = 41;
                return this.setLoading(false);

              case 41:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 13]]);
      }));

      function fetchTags() {
        return _ref2.apply(this, arguments);
      }

      return fetchTags;
    }()
  }, {
    key: 'deleteTag',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id) {
        var store, t, token, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                _context3.next = 4;
                return this.fetchTag(id);

              case 4:
                token = _context3.sent;
                _context3.next = 7;
                return this.setState({ loading: true });

              case 7:
                _context3.prev = 7;
                _context3.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/tags/' + this.props.type + '/' + id + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': token
                  }
                }));

              case 10:
                _context3.next = 22;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](7);

                Bugsnag.notifyException(_context3.t0);

                if (!(_context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 21;
                  break;
                }

                _context3.next = 18;
                return _context3.t0.res.text();

              case 18:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context3.t0));

              case 22:
                _context3.next = 24;
                return this.setState({ loading: false });

              case 24:
                this.handleChangePage(1);
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Tag successfully deleted', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 26:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[7, 12]]);
      }));

      function deleteTag(_x6) {
        return _ref3.apply(this, arguments);
      }

      return deleteTag;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state = this.state,
          count = _state.count,
          limit = _state.limit,
          offset = _state.offset,
          loading = _state.loading,
          currentPage = _state.currentPage;
      var t = this.props.t;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_DeleteConfirm2.default, {
          open: this.state.showConfirm,
          onClose: this.handleCancelDelete,
          onConfirm: this.handleConfirmDelete,
          name: this.state.selectedTag ? this.state.selectedTag.name : ''
        }),
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 20 },
            active: this.state.loading && this.state.data.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            striped: true, unstackable: true,
            selectable: true
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 4 },
                _react2.default.createElement(_semanticUiReact.Button, {
                  as: _reactRouter.Link,
                  primary: true,
                  size: 'small',
                  icon: 'add',
                  content: t('Tags', { ns: _translation.TRANSLATION_FILES.translation }),
                  to: '/settings/tags/new/'
                }),
                this.props.headerNode ? this.props.headerNode({
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: this.state.data.length,
                  loading: loading,
                  currentPage: currentPage,
                  onChange: this.handleChangePage
                }) : _react2.default.createElement(_PageNav2.default, {
                  floated: 'right',
                  currentPage: currentPage,
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: this.state.data.length,
                  loading: loading,
                  onChange: this.handleChangePage
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 4 },
                t('Name')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { width: 4 },
                t('Short Name')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 2 },
                t('Description')
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            this.state.data.length > 0 ? this.state.data.map(function (field, key) {
              return _react2.default.createElement(
                _semanticUiReact.Table.Row,
                { key: key },
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { width: 4 },
                  _react2.default.createElement(
                    _reactRouter.Link,
                    {
                      to: '/settings/tags/' + field.id + '/'
                    },
                    field.name
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { width: 4 },
                  field.type
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  field.description || '-'
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { collapsing: true, textAlign: 'right' },
                  _react2.default.createElement(_semanticUiReact.Button, {
                    compact: true,
                    negative: true,
                    type: 'button',
                    size: 'tiny',
                    icon: 'cancel',
                    onClick: function onClick(e) {
                      return _this5.handleDelete(e, field);
                    }
                  })
                )
              );
            }) : _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 4, textAlign: 'center' },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                ) : _react2.default.createElement(
                  'p',
                  null,
                  t('No tags found'),
                  '.'
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Footer,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 4, textAlign: 'right' },
                this.props.footerNode ? this.props.footerNode({
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: this.state.data.length,
                  loading: loading,
                  currentPage: currentPage,
                  onChange: this.handleChangePage
                }) : _react2.default.createElement(_PageNav2.default, {
                  upward: true,
                  currentPage: currentPage,
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: this.state.data.length,
                  loading: loading,
                  onChange: this.handleChangePage
                })
              )
            )
          )
        )
      );
    }
  }]);

  return TagList;
}(_react.Component);

TagList.contextTypes = {
  store: _propTypes2.default.object
};
TagList.propTypes = {
  headerNode: _propTypes2.default.func,
  footerNode: _propTypes2.default.func,
  where: _propTypes2.default.shape({
    limit: _propTypes2.default.number
  }),
  loading: _propTypes2.default.bool,
  type: _propTypes2.default.oneOf(['picture']).isRequired
};
TagList.defaultProps = {
  type: 'picture'
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(TagList);

/***/ }),
/* 2207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextExpand = function (_Component) {
  _inherits(TextExpand, _Component);

  function TextExpand(props) {
    _classCallCheck(this, TextExpand);

    var _this = _possibleConstructorReturn(this, (TextExpand.__proto__ || Object.getPrototypeOf(TextExpand)).call(this, props));

    _this.handleExpand = function (e) {
      e.preventDefault();
      _this.setState({ isExpanded: true });
    };

    _this.state = {
      isExpanded: true
    };
    if (props.text && props.text.length > props.minChar) {
      _this.state.isExpanded = false;
    }
    return _this;
  }

  _createClass(TextExpand, [{
    key: 'render',
    value: function render() {
      if (!this.state.isExpanded) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'button',
            {
              className: 'a-button-blue text_expand_single',
              style: { width: this.props.width },
              onClick: this.handleExpand,
              title: 'View more'
            },
            this.props.text
          )
        );
      }
      return _react2.default.createElement(
        'div',
        { className: 'text_expand', style: { width: this.props.width } },
        this.props.text
      );
    }
  }]);

  return TextExpand;
}(_react.Component);

TextExpand.propTypes = {
  text: _propTypes2.default.string.isRequired,
  minChar: _propTypes2.default.number,
  width: _propTypes2.default.string.isRequired
};

TextExpand.defaultProps = {
  minChar: 24
};

exports.default = TextExpand;

/***/ }),
/* 2208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _MarkdownText = __webpack_require__(193);

var _MarkdownText2 = _interopRequireDefault(_MarkdownText);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextFieldMarkdownPreview = function (_Component) {
  _inherits(TextFieldMarkdownPreview, _Component);

  function TextFieldMarkdownPreview(props) {
    _classCallCheck(this, TextFieldMarkdownPreview);

    var _this = _possibleConstructorReturn(this, (TextFieldMarkdownPreview.__proto__ || Object.getPrototypeOf(TextFieldMarkdownPreview)).call(this, props));

    _initialiseProps.call(_this);

    var state = TextFieldMarkdownPreview.getPropsToState(props);
    _this.state = _extends({}, state);
    return _this;
  }

  _createClass(TextFieldMarkdownPreview, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = nextProps;
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          data = _state.data,
          name = _state.name,
          labelName = _state.labelName,
          isPreview = _state.isPreview;
      var t = this.props.t;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
          label: t('Show Preview'),
          name: 'isPreview',
          checked: isPreview,
          onChange: this.toggleCheckboxChange
        }),
        _react2.default.createElement(_semanticUiReact.Form.TextArea, {
          label: labelName,
          name: name,
          value: data,
          onChange: this.handleTextAreaChange
        }),
        isPreview ? _react2.default.createElement(
          _semanticUiReact.Form.Field,
          { name: name },
          _react2.default.createElement(
            'label',
            { htmlFor: name },
            t('Preview', { ns: _translation.TRANSLATION_FILES.translation })
          ),
          _react2.default.createElement(_MarkdownText2.default, { content: data })
        ) : null
      );
    }
  }]);

  return TextFieldMarkdownPreview;
}(_react.Component);

TextFieldMarkdownPreview.propTypes = {
  data: _propTypes2.default.string.isRequired,
  name: _propTypes2.default.string.isRequired,
  labelName: _propTypes2.default.string.isRequired,
  onDefaultInputChange: _propTypes2.default.func.isRequired
};

TextFieldMarkdownPreview.getPropsToState = function (props) {
  var data = props.data;
  var name = props.name;
  var labelName = props.labelName;
  return {
    data: data,
    name: name,
    isPreview: false,
    labelName: labelName
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleTextAreaChange = function (e, _ref) {
    var value = _ref.value;

    _this2.setState({ data: value }, function () {
      // trigger changes to parent component
      _this2.props.onDefaultInputChange(e, { value: value, name: _this2.state.name });
    });
  };

  this.toggleCheckboxChange = function (e) {
    e.preventDefault();
    _this2.setState({
      isPreview: !_this2.state.isPreview
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(TextFieldMarkdownPreview);

/***/ }),
/* 2209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_momentTimezone2.default.locale('en-gb');

var TimePicker = function (_Component) {
  _inherits(TimePicker, _Component);

  function TimePicker(props) {
    _classCallCheck(this, TimePicker);

    var _this = _possibleConstructorReturn(this, (TimePicker.__proto__ || Object.getPrototypeOf(TimePicker)).call(this, props));

    _this.getTime = function (value) {
      var useBrowserTimezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return useBrowserTimezone ? (0, _momentTimezone2.default)(value).local() : (0, _momentTimezone2.default)(value);
    };

    _this.setTime = function () {
      var hour = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var minute = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var m = (0, _momentTimezone2.default)(_this.state.time);
      m.set({
        hour: hour,
        minute: minute,
        second: 0
      });
      m.toISOString();
      m.format();
      return m;
    };

    _this.format24Hour = function (hour) {
      var isAM = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.state.isAM;

      var newHour = hour;
      if (isAM && hour === '12') {
        newHour = 0;
      } else if (!isAM && hour === '12') {
        newHour = 12;
      } else if (!isAM) {
        newHour = parseInt(hour, 10) + 12;
      }
      return newHour;
    };

    _this.handleHour = function (e) {
      var decrement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      e.persist();
      e.preventDefault();
      if (_this.stepTimer) clearTimeout(_this.stepTimer);
      var _this$state = _this.state,
          visible = _this$state.visible,
          minute = _this$state.minute;
      var hour = _this.state.hour;
      // increase/decrease value

      if (decrement) {
        hour = (parseInt(hour, 10) - 1).toString().padStart(2, '0');
      } else {
        hour = (parseInt(hour, 10) + 1).toString().padStart(2, '0');
      }
      // set 12 hour format
      if (hour === '13') {
        hour = '01';
      } else if (hour === '00') {
        hour = '12';
      }
      // transition
      visible.hour = !visible.hour;
      _this.setState({
        hour: hour,
        visible: visible,
        time: _this.setTime(_this.format24Hour(hour), minute)
      }, function () {
        if (_this.props.onChange) _this.props.onChange(_this.state.time.toDate());
      });
    };

    _this.handleMinute = function (e) {
      var decrement = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      e.persist();
      e.preventDefault();
      if (_this.stepTimer) clearTimeout(_this.stepTimer);
      var _this$state2 = _this.state,
          visible = _this$state2.visible,
          hour = _this$state2.hour;
      var minute = _this.state.minute;
      // increase/decrease value

      if (decrement) {
        minute = (parseInt(minute, 10) - 1).toString().padStart(2, '0');
      } else {
        minute = (parseInt(minute, 10) + 1).toString().padStart(2, '0');
      }
      // set number range
      if (minute === '60') {
        minute = '00';
      } else if (minute === '-1') {
        minute = '59';
      }
      // transition
      visible.minute = !visible.minute;
      _this.setState({
        minute: minute,
        visible: visible,
        time: _this.setTime(_this.format24Hour(hour), minute)
      }, function () {
        if (_this.props.onChange) _this.props.onChange(_this.state.time.toDate());
      });
    };

    _this.handleAMPM = function (e) {
      e.preventDefault();
      if (_this.stepTimer) clearTimeout(_this.stepTimer);
      var _this$state3 = _this.state,
          visible = _this$state3.visible,
          hour = _this$state3.hour,
          minute = _this$state3.minute;
      // transition

      visible.isAM = !visible.isAM;
      _this.setState({
        isAM: !_this.state.isAM,
        hour: hour,
        visible: visible,
        time: _this.setTime(_this.format24Hour(hour, !_this.state.isAM), minute)
      }, function () {
        if (_this.props.onChange) _this.props.onChange(_this.state.time.toDate());
      });
    };

    _this.handleTicker = function (_ref, action) {
      var e = _ref.e,
          decrement = _ref.decrement;
      var timeout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 150;
      var count = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

      if (count < 500) {
        action(e, decrement);
        _this.stepTimer = setTimeout(function () {
          _this.handleTicker({ e: e, decrement: decrement }, action, timeout - 5, count + 1);
        }, timeout);
      }
    };

    _this.handleClearTicker = function () {
      clearTimeout(_this.stepTimer);
    };

    var time = _this.getTime(props.value, props.useBrowserTimezone);
    _this.state = {
      time: time,
      hour: (0, _momentTimezone2.default)(time).format('hh'),
      minute: (0, _momentTimezone2.default)(time).format('mm'),
      isAM: (0, _momentTimezone2.default)(time).format('a') === 'am',
      visible: {
        hour: true,
        minute: true,
        isAM: true
      }
    };
    return _this;
  }

  _createClass(TimePicker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var time = this.getTime(nextProps.value, nextProps.useBrowserTimezone);
      this.setState({
        time: time,
        hour: (0, _momentTimezone2.default)(time).format('hh'),
        minute: (0, _momentTimezone2.default)(time).format('mm'),
        isAM: (0, _momentTimezone2.default)(time).format('a') === 'am'
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          hour = _state.hour,
          minute = _state.minute,
          isAM = _state.isAM,
          visible = _state.visible;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 3, className: 'clock_top controls' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_semanticUiReact.Icon, {
                name: 'chevron up',
                fitted: true, size: 'big',
                onTouchEnd: this.handleClearTicker,
                onTouchCancel: this.handleClearTicker,
                onMouseUp: this.handleClearTicker,
                onMouseOut: this.handleClearTicker,
                onMouseDown: function onMouseDown(e) {
                  return _this2.handleTicker({ e: e }, _this2.handleHour);
                }
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_semanticUiReact.Icon, {
                name: 'chevron up',
                fitted: true, size: 'big',
                onTouchEnd: this.handleClearTicker,
                onTouchCancel: this.handleClearTicker,
                onMouseUp: this.handleClearTicker,
                onMouseOut: this.handleClearTicker,
                onMouseDown: function onMouseDown(e) {
                  return _this2.handleTicker({ e: e }, _this2.handleMinute);
                }
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_semanticUiReact.Icon, {
                name: 'chevron up',
                fitted: true, size: 'big',
                onClick: this.handleAMPM
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 3, className: 'clock_numbers' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Transition,
                { animation: 'pulse', duration: 150, visible: visible.hour },
                _react2.default.createElement(
                  'h2',
                  { className: 'clock_number' },
                  hour
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Transition,
                { animation: 'pulse', duration: 150, visible: visible.minute },
                _react2.default.createElement(
                  'h2',
                  { className: 'clock_number' },
                  minute
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Transition,
                { animation: 'pulse', duration: 150, visible: visible.isAM },
                _react2.default.createElement(
                  'h2',
                  { className: 'clock_number' },
                  isAM ? 'AM' : 'PM'
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 3, className: 'clock_bottom controls' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_semanticUiReact.Icon, {
                name: 'chevron down',
                fitted: true, size: 'big',
                onTouchEnd: this.handleClearTicker,
                onTouchCancel: this.handleClearTicker,
                onMouseUp: this.handleClearTicker,
                onMouseOut: this.handleClearTicker,
                onMouseDown: function onMouseDown(e) {
                  return _this2.handleTicker({ e: e, decrement: true }, _this2.handleHour);
                }
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_semanticUiReact.Icon, {
                name: 'chevron down',
                fitted: true, size: 'big',
                onTouchEnd: this.handleClearTicker,
                onTouchCancel: this.handleClearTicker,
                onMouseUp: this.handleClearTicker,
                onMouseOut: this.handleClearTicker,
                onMouseDown: function onMouseDown(e) {
                  return _this2.handleTicker({ e: e, decrement: true }, _this2.handleMinute);
                }
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_semanticUiReact.Icon, {
                name: 'chevron down',
                fitted: true, size: 'big',
                onClick: this.handleAMPM
              })
            )
          )
        )
      );
    }
  }]);

  return TimePicker;
}(_react.Component);

TimePicker.propTypes = {
  value: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, _propTypes2.default.instanceOf(Date)]),
  onChange: _propTypes2.default.func,
  useBrowserTimezone: _propTypes2.default.bool
};
exports.default = TimePicker;

/***/ }),
/* 2210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _markdownDraftJs = __webpack_require__(450);

var _draftJs = __webpack_require__(338);

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

var _i18next = __webpack_require__(94);

var _semanticUiReact = __webpack_require__(2);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _url = __webpack_require__(19);

var _isbase = __webpack_require__(157);

var _isbase2 = _interopRequireDefault(_isbase);

var _UCBookingDatePicker = __webpack_require__(576);

var _UCBookingDatePicker2 = _interopRequireDefault(_UCBookingDatePicker);

var _UCBookingSelectList = __webpack_require__(577);

var _UCBookingSelectListMultiple = __webpack_require__(578);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _UCSearchIn = __webpack_require__(579);

var _UCSearchIn2 = _interopRequireDefault(_UCSearchIn);

var _UCSortButton = __webpack_require__(580);

var _UCSortButton2 = _interopRequireDefault(_UCSortButton);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _UCFixedBarStatus = __webpack_require__(1036);

var _UCFixedBarStatus2 = _interopRequireDefault(_UCFixedBarStatus);

var _apiEndpoints = __webpack_require__(140);

var endpoints = _interopRequireWildcard(_apiEndpoints);

var _dateRanges = __webpack_require__(265);

var _bookingStatuses = __webpack_require__(128);

var _lawyerCaseStatuses = __webpack_require__(142);

var _paymentStatuses = __webpack_require__(321);

var _paymentStatuses2 = _interopRequireDefault(_paymentStatuses);

var _translation = __webpack_require__(4);

var _OpportunityCancelModal = __webpack_require__(262);

var _strings = __webpack_require__(118);

var _UCBookingStatusDropdown = __webpack_require__(1035);

var _UCBookingStatusDropdown2 = _interopRequireDefault(_UCBookingStatusDropdown);

var _download = __webpack_require__(361);

var _download2 = _interopRequireDefault(_download);

var _sort = __webpack_require__(765);

var _sort2 = _interopRequireDefault(_sort);

var _clock_disabled = __webpack_require__(3523);

var _clock_disabled2 = _interopRequireDefault(_clock_disabled);

var _clock_yellow = __webpack_require__(3525);

var _clock_yellow2 = _interopRequireDefault(_clock_yellow);

var _clock_red = __webpack_require__(3524);

var _clock_red2 = _interopRequireDefault(_clock_red);

var _notes_disabled = __webpack_require__(3539);

var _notes_disabled2 = _interopRequireDefault(_notes_disabled);

var _notes = __webpack_require__(3538);

var _notes2 = _interopRequireDefault(_notes);

var _credit_card_disabled = __webpack_require__(761);

var _credit_card_disabled2 = _interopRequireDefault(_credit_card_disabled);

var _credit_card_yellow = __webpack_require__(763);

var _credit_card_yellow2 = _interopRequireDefault(_credit_card_yellow);

var _credit_card_green = __webpack_require__(762);

var _credit_card_green2 = _interopRequireDefault(_credit_card_green);

var _legal_disabled = __webpack_require__(3536);

var _legal_disabled2 = _interopRequireDefault(_legal_disabled);

var _legal = __webpack_require__(3535);

var _legal2 = _interopRequireDefault(_legal);

var _loan_disabled = __webpack_require__(764);

var _loan_disabled2 = _interopRequireDefault(_loan_disabled);

var _loan = __webpack_require__(3537);

var _loan2 = _interopRequireDefault(_loan);

var _user = __webpack_require__(1599);

var _user2 = _interopRequireDefault(_user);

var _building = __webpack_require__(3521);

var _building2 = _interopRequireDefault(_building);

var _calendar = __webpack_require__(3522);

var _calendar2 = _interopRequireDefault(_calendar);

var _UCBPopup = __webpack_require__(575);

var _UCBPopup2 = _interopRequireDefault(_UCBPopup);

var _UCBStatusFlag = __webpack_require__(389);

var _UCBStatusFlag2 = _interopRequireDefault(_UCBStatusFlag);

var _bankCaseStatuses = __webpack_require__(264);

var _bankCaseStatuses2 = _interopRequireDefault(_bankCaseStatuses);

var _time = __webpack_require__(2590);

var _fetchWithCacheSWR = __webpack_require__(1090);

var _countries = __webpack_require__(60);

var _vietnam = __webpack_require__(40);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint jsx-a11y/no-static-element-interactions: 0 */

var isPRS = _config2.default.get('prs');

var tabs = [{ value: 'all', name: 'all', text: 'All', header: 'Latest Bookings' }, { value: 'aging_by_units', name: 'aging_by_units', text: 'Aging By Units', header: 'Aging By Units' }, { value: 'aging_by_bankers', name: 'aging_by_bankers', text: 'Aging By Bankers', header: 'Aging By Bankers' }, { value: 'aging_by_lawyers', name: 'aging_by_lawyers', text: 'Aging By Lawyers', header: 'Aging By Lawyers' }];

var allFilterNames = ['search', 'searchIn', 'bookingStatusMulti', 'dateRange', 'dateFrom', 'dateTo', 'cancelledDateRange', 'cancelledDateFrom', 'cancelledDateTo', 'expiredDateRange', 'expiredDateFrom', 'expiredDateTo', 'bookedDateRange', 'bookedDateFrom', 'bookedDateTo', 'soldDateRange', 'soldDateFrom', 'soldDateTo', 'paymentStatus', 'filteredProjects', 'agingRange', 'loanStatus', 'agingDuration', 'lawyerCaseType', 'lawyerCaseStatus'];

var BookingsList = function (_Component) {
  _inherits(BookingsList, _Component);

  function BookingsList(props) {
    _classCallCheck(this, BookingsList);

    var _this = _possibleConstructorReturn(this, (BookingsList.__proto__ || Object.getPrototypeOf(BookingsList)).call(this, props));

    _initialiseProps.call(_this);

    var state = BookingsList.getPropsToState(props);
    var summary = Object.assign({}, BookingsList.summaryDefault);
    _this.state = _extends({
      loading: true,
      count: 0,
      limit: 0,
      offset: 0,
      data: [],
      summary: summary
    }, state, {
      mpUserLoading: false,
      mpUserDetails: {},
      isChanging: false,
      projectOpts: [],
      filteredProjects: [],
      activeAccordionIndex: -1,
      isMobile: state.screenWidth <= 767,
      isTablet: state.screenWidth > 767 && state.screenWidth <= 991,
      isComputer: state.screenWidth > 991,
      projectArData: [],
      systemData: [],
      allBankCases: [],
      hasDropCase: false
    });
    return _this;
  }

  _createClass(BookingsList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      if (!isPRS) {
        this.fetchSystemSettings();
      }
      this.fetchProjects();
      if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
        delete query.page;
      }
      var hasLawyerAccess = this.props.auth && this.props.auth.companyBranch && !this.props.auth.isExternalAgentLeader;
      var lawyerIsEnabled = this.props.appConfig && this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled && hasLawyerAccess;
      // CPI-1209 (A37): a bookmarked ?tab=aging_by_lawyers is dropped for Vietnam too.
      var showLawyerTab = lawyerIsEnabled && !(0, _countries.isCountryVietnam)(this.props.auth.company.countryCode);
      var tabss = showLawyerTab ? tabs : tabs.filter(function (t) {
        return t.value !== 'aging_by_lawyers';
      });
      if (query.tab && !tabss.some(function (t) {
        return t.value === query.tab;
      })) {
        delete query.tab;
      }
      this.replaceQuery(query);
      this.handleResize();
      this.setStickyWidth();
      this.updateStickyShadows();
      window.addEventListener('resize', this.handleResize);
      window.addEventListener('resize', this.setStickyWidth);
      window.addEventListener('resize', this.updateStickyShadows);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var currentTab = this.state.currentTab;

      var state = BookingsList.getPropsToState(nextProps);
      this.setState(state, function () {
        if (currentTab !== state.currentTab) {
          _this2.replaceQuery({
            tab: state.currentTab
          }, true);
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.setTimer) {
        clearTimeout(this.setTimer);
      }
      if (this.setStaffTimer) {
        clearTimeout(this.setStaffTimer);
      }
      window.removeEventListener('resize', this.handleResize);
      window.removeEventListener('resize', this.setStickyWidth);
      window.removeEventListener('resize', this.updateStickyShadows());
    }
  }, {
    key: 'setMPUserLoading',
    value: function setMPUserLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ mpUserLoading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'setLoadingProjectSearch',
    value: function setLoadingProjectSearch() {
      var _this4 = this;

      var loadingProjectSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loadingProjectSearch: loadingProjectSearch }, res);
      });
    }
  }, {
    key: 'setLoadingStaffSearch',
    value: function setLoadingStaffSearch() {
      var _this5 = this;

      var loadingStaffSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this5.setState({ loadingStaffSearch: loadingStaffSearch }, res);
      });
    }
  }, {
    key: 'setBookings',
    value: function setBookings() {
      var _this6 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this6.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this7 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this7.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this8 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this8.setState({ loading: loading }, function () {
          if (_this8.props.onLoading) {
            _this8.props.onLoading(loading);
          }
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchSystemSettings',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, t, res, message, systemData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context.prev = 3;
                _context.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/settings/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 6:
                res = _context.sent;
                _context.next = 15;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](3);

                Bugsnag.notifyException(_context.t0);
                _context.next = 14;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 14:
                return _context.abrupt('return');

              case 15:
                if (res.ok) {
                  _context.next = 23;
                  break;
                }

                _context.next = 18;
                return res.text();

              case 18:
                message = _context.sent;
                _context.next = 21;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 21:
                _context.next = 28;
                break;

              case 23:
                _context.next = 25;
                return res.json();

              case 25:
                systemData = _context.sent;
                _context.next = 28;
                return this.setState({
                  systemData: systemData
                });

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 9]]);
      }));

      function fetchSystemSettings() {
        return _ref.apply(this, arguments);
      }

      return fetchSystemSettings;
    }()
  }, {
    key: 'fetchProjects',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, t, query, res, message, _message, data, newProjectOpts, newProjectArData;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({
                  limit: 0,
                  showAsOptions: false
                });
                _context2.next = 5;
                return this.setLoading(true);

              case 5:
                res = void 0;
                _context2.prev = 6;
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/projects/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context2.sent;
                _context2.next = 24;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);

                if (!(_context2.t0.res && _context2.t0.res.status >= 399 && _context2.t0.res.status < 500)) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 17;
                return _context2.t0.res.text();

              case 17:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 19:
                _context2.next = 21;
                return this.setLoading(false);

              case 21:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context2.abrupt('return');

              case 24:
                if (res.ok) {
                  _context2.next = 32;
                  break;
                }

                _context2.next = 27;
                return res.text();

              case 27:
                _message = _context2.sent;
                _context2.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 30:
                _context2.next = 40;
                break;

              case 32:
                _context2.next = 34;
                return res.json();

              case 34:
                data = _context2.sent;
                newProjectOpts = this.state.projectOpts;
                newProjectArData = this.state.projectArData;

                if (data && data.length > 0) {
                  newProjectOpts = data.map(function (d) {
                    return { value: d.id, text: d.name };
                  });
                  newProjectArData = data.map(function (d) {
                    return _extends({}, d);
                  });
                }
                _context2.next = 40;
                return this.setComponentState({ projectOpts: newProjectOpts, projectArData: newProjectArData });

              case 40:
                _context2.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 12]]);
      }));

      function fetchProjects() {
        return _ref2.apply(this, arguments);
      }

      return fetchProjects;
    }()
  }, {
    key: 'fetchBookings',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this9 = this;

        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var t, store, query, res, limit, stringifyQuery, count, offset, que, url, urlOptions, message, _message2, _count, _limit, _offset, data, _que;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                query = Object.assign(q, this.props.where || {});
                res = void 0;

                if (!(this.props.appConfig && this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled && this.state.currentTab === 'aging_by_lawyers')) {
                  _context4.next = 54;
                  break;
                }

                if (query.projectFilter) {
                  query.project_code = atob(query.projectFilter);
                  delete query.projectFilter;
                }
                if (this.props.projectUnitID) {
                  query.project_unit_id = this.props.projectUnitID;
                }
                if (this.props.appConfig && this.props.appConfig.data) {
                  query.company_id = this.props.appConfig.data.companyID;
                }
                limit = 10;

                query.limit = limit;
                query.from = (query.page - 1) * limit;
                delete query.tab;
                delete query.page;
                if (query.lawyerCaseStatus) {
                  query.status = query.lawyerCaseStatus;
                  delete query.lawyerCaseStatus;
                }
                if (query.lawyerCaseType) {
                  query.type = query.lawyerCaseType;
                  delete query.lawyerCaseType;
                }
                if (query.agingDuration && query.agingDuration.startsWith('more_than_')) {
                  query.duration = parseInt(query.agingDuration.replace('more_than_', '').replace('_days', ''), 10);
                  delete query.agingDuration;
                }
                if (query.searchIn === 'lawyer') {
                  query.lawyer = query.search;
                  delete query.search;
                }
                if (query.searchIn === 'firm') {
                  query.firm = query.search;
                  delete query.search;
                }
                _context4.prev = 20;
                _context4.next = 23;
                return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.BOOKING_AGING_CASES + '/?' + _qs2.default.stringify(query), null, 'get', {
                  'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
                }));

              case 23:
                res = _context4.sent;
                _context4.next = 34;
                break;

              case 26:
                _context4.prev = 26;
                _context4.t0 = _context4['catch'](20);

                Bugsnag.notifyException(_context4.t0);
                _context4.next = 31;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 31:
                _context4.next = 33;
                return this.setLoading(false);

              case 33:
                return _context4.abrupt('return');

              case 34:
                if (!res) {
                  _context4.next = 51;
                  break;
                }

                stringifyQuery = _qs2.default.stringify(query);
                count = res.total_hits;
                offset = query.from;
                _context4.next = 40;
                return this.setBookings(res.items);

              case 40:
                if (this.props.hideBookingList) {
                  this.props.bookingListLength(this.state.data.length);
                }

                if (!(this.state.data.length < 1 && query.from >= limit)) {
                  _context4.next = 49;
                  break;
                }

                que = (0, _url.decodeSearch)(this.props.location.search);
                _context4.next = 45;
                return this.setComponentState({
                  offset: 0
                });

              case 45:
                que.page = 1;
                this.replaceQuery(que);
                _context4.next = 51;
                break;

              case 49:
                _context4.next = 51;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset,
                  stringifyQuery: stringifyQuery
                });

              case 51:
                _context4.next = 53;
                return this.setLoading(false);

              case 53:
                return _context4.abrupt('return');

              case 54:

                if (this.props.projectUnitID) {
                  query.projectUnitID = this.props.projectUnitID;
                }
                url = '/bookings/?' + _qs2.default.stringify(query);
                urlOptions = {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                };
                _context4.prev = 57;

                if (!(this.state.currentTab === 'aging_by_bankers')) {
                  _context4.next = 64;
                  break;
                }

                _context4.next = 61;
                return (0, _fetchWithCacheSWR.fetchWithCacheSWR)(store, url, urlOptions, 15000, // current ttl
                null, 'ttl', 'localStorage');

              case 61:
                res = _context4.sent;
                _context4.next = 67;
                break;

              case 64:
                _context4.next = 66;
                return store.dispatch((0, _fetchM.fetchM)(url, urlOptions));

              case 66:
                res = _context4.sent;

              case 67:
                _context4.next = 81;
                break;

              case 69:
                _context4.prev = 69;
                _context4.t1 = _context4['catch'](57);

                if (!(_context4.t1.res && _context4.t1.res.status >= 399 && _context4.t1.res.status < 500)) {
                  _context4.next = 76;
                  break;
                }

                _context4.next = 74;
                return _context4.t1.res.text();

              case 74:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 76:
                _context4.next = 78;
                return this.setLoading(false);

              case 78:
                Bugsnag.notifyException(_context4.t1);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context4.abrupt('return');

              case 81:
                if (res.ok) {
                  _context4.next = 89;
                  break;
                }

                _context4.next = 84;
                return res.text();

              case 84:
                _message2 = _context4.sent;
                _context4.next = 87;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message2 }));

              case 87:
                _context4.next = 110;
                break;

              case 89:
                _count = parseInt(res.headers.get('M-Data-count'), 10);
                _limit = parseInt(res.headers.get('M-Data-limit'), 10);
                _offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context4.next = 94;
                return res.json();

              case 94:
                data = _context4.sent;

                if (!(data && data.length > 0 && (this.state.currentTab === 'all' || this.state.currentTab === 'aging_by_units'))) {
                  _context4.next = 99;
                  break;
                }

                _context4.next = 98;
                return Promise.all(data.map(function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(d) {
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            // TODO: comment first waiting for updated api calls+confirmation by backend team
                            // let bookingCustomers = null;
                            // if (this.state.currentTab === 'all') {
                            //   bookingCustomers = await this.fetchBookingCustomers(d.id);
                            // }

                            // let lawyer = null;
                            // let bookingBankCases = null;
                            if (_this9.state.currentTab === 'all' || _this9.state.currentTab === 'aging_by_units') {
                              // lawyer = await this.fetchAllLawyerCasesDetails(d.id);
                              // bookingBankCases = d.loanTrackerLeadCode !== '' ? await this.fetchBankCaseDrops(d) : null;
                            }

                            return _context3.abrupt('return', _extends({}, d));

                          case 2:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this9);
                  }));

                  return function (_x8) {
                    return _ref4.apply(this, arguments);
                  };
                }()
                // bookingCustomers,
                // lawyer,
                // bookingBankCases,
                ));

              case 98:
                data = _context4.sent;

              case 99:
                _context4.next = 101;
                return this.setBookings(data);

              case 101:
                if (this.props.hideBookingList) {
                  this.props.bookingListLength(this.state.data.length);
                }

                if (!(this.state.data.length < 1 && query.page > 1)) {
                  _context4.next = 108;
                  break;
                }

                _que = (0, _url.decodeSearch)(this.props.location.search);

                _que.page = 1;
                this.replaceQuery(_que);
                _context4.next = 110;
                break;

              case 108:
                _context4.next = 110;
                return this.setComponentState({
                  count: _count,
                  limit: _limit,
                  offset: _offset
                });

              case 110:
                _context4.next = 112;
                return this.setLoading(false);

              case 112:
                this.setStickyWidth();
                this.updateStickyShadows();

              case 114:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[20, 26], [57, 69]]);
      }));

      function fetchBookings() {
        return _ref3.apply(this, arguments);
      }

      return fetchBookings;
    }()
  }, {
    key: 'fetchBookingCustomers',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(bookingID) {
        var store, bookingCustomers, res, message, _message3, data;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                bookingCustomers = {};
                res = void 0;
                _context5.prev = 5;
                _context5.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + bookingID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context5.sent;
                _context5.next = 20;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5['catch'](5);

                if (!(_context5.t0.res && _context5.t0.res.status >= 399 && _context5.t0.res.status < 500)) {
                  _context5.next = 18;
                  break;
                }

                _context5.next = 16;
                return _context5.t0.res.text();

              case 16:
                message = _context5.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 18:
                Bugsnag.notifyException(_context5.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));

              case 20:
                if (res.ok) {
                  _context5.next = 28;
                  break;
                }

                _context5.next = 23;
                return res.text();

              case 23:
                _message3 = _context5.sent;
                _context5.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message3 }));

              case 26:
                _context5.next = 32;
                break;

              case 28:
                _context5.next = 30;
                return res.json();

              case 30:
                data = _context5.sent;

                bookingCustomers = data.bookingCustomers;

              case 32:
                return _context5.abrupt('return', bookingCustomers);

              case 33:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[5, 11]]);
      }));

      function fetchBookingCustomers(_x9) {
        return _ref5.apply(this, arguments);
      }

      return fetchBookingCustomers;
    }()
  }, {
    key: 'fetchBookingSummaries',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var store, t, query, res, message, summary;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign(q, this.props.where || {});

                if (this.props.projectUnitID) {
                  query.projectUnitID = this.props.projectUnitID;
                }
                res = void 0;
                _context6.prev = 7;
                _context6.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/summary/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 10:
                res = _context6.sent;
                _context6.next = 21;
                break;

              case 13:
                _context6.prev = 13;
                _context6.t0 = _context6['catch'](7);

                Bugsnag.notifyException(_context6.t0);
                _context6.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 18:
                _context6.next = 20;
                return this.setLoading(false);

              case 20:
                return _context6.abrupt('return');

              case 21:
                if (res.ok) {
                  _context6.next = 29;
                  break;
                }

                _context6.next = 24;
                return res.text();

              case 24:
                message = _context6.sent;
                _context6.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 27:
                _context6.next = 34;
                break;

              case 29:
                _context6.next = 31;
                return res.json();

              case 31:
                summary = _context6.sent;
                _context6.next = 34;
                return this.setComponentState({ summary: summary });

              case 34:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[7, 13]]);
      }));

      function fetchBookingSummaries() {
        return _ref6.apply(this, arguments);
      }

      return fetchBookingSummaries;
    }()
  }, {
    key: 'fetchLawyer',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var lawyerID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var store, t, res;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                if (lawyerID) {
                  _context7.next = 2;
                  break;
                }

                return _context7.abrupt('return', null);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context7.prev = 5;
                _context7.next = 8;
                return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.LAWYER(lawyerID), null, 'get', {
                  'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
                }));

              case 8:
                res = _context7.sent;
                return _context7.abrupt('return', res);

              case 12:
                _context7.prev = 12;
                _context7.t0 = _context7['catch'](5);

                Bugsnag.notifyException(_context7.t0);
                _context7.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                return _context7.abrupt('return', null);

              case 18:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[5, 12]]);
      }));

      function fetchLawyer() {
        return _ref7.apply(this, arguments);
      }

      return fetchLawyer;
    }()
  }, {
    key: 'handleAccordionClick',
    value: function handleAccordionClick(e, valIndex) {
      var index = valIndex.index;

      this.setState(function (prevState) {
        return {
          activeAccordionIndex: prevState.activeIndex === index ? -1 : index
        };
      });
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isBranchLeader || this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasAdminAccess',
    value: function hasAdminAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasInternalDEAccess',
    value: function hasInternalDEAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var auth = this.props.auth;
      if (auth && auth.companyBranch && !auth.companyBranch.isExternal) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasStaffAccess',
    value: function hasStaffAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isSuperAdmin || this.props.auth.isHeadquarters) {
        return true;
      }
      return check;
    }
  }, {
    key: 'searchStaffs',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(value) {
        var store, t, res, message, json, findStaffResults, noStaffResultsMessage;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                _context8.next = 4;
                return this.setLoadingStaffSearch(true);

              case 4:
                res = null;
                _context8.prev = 5;
                _context8.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/search/staffs/?isExternal=false&limit=3&search=' + value, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context8.sent;
                _context8.next = 22;
                break;

              case 11:
                _context8.prev = 11;
                _context8.t0 = _context8['catch'](5);

                if (!(_context8.t0.res && _context8.t0.res.status >= 400 && _context8.t0.res.status < 500)) {
                  _context8.next = 18;
                  break;
                }

                _context8.next = 16;
                return _context8.t0.res.text();

              case 16:
                message = _context8.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 18:
                _context8.next = 20;
                return this.setLoadingStaffSearch(false);

              case 20:
                Bugsnag.notifyException(_context8.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 22:
                if (res.ok) {
                  _context8.next = 28;
                  break;
                }

                _context8.next = 25;
                return this.setLoadingStaffSearch(false);

              case 25:
                throw new Error('Not OK');

              case 28:
                _context8.next = 30;
                return this.setLoadingStaffSearch(false);

              case 30:
                _context8.next = 32;
                return res.json();

              case 32:
                json = _context8.sent;

                if (json) {
                  findStaffResults = json.map(function (obj) {
                    var newResults = {};
                    newResults.key = obj.id.toString();
                    newResults.title = obj.name;
                    newResults.price = obj.preferredName;
                    newResults.description = obj.email;
                    return newResults;
                  });

                  this.setState({ findStaffResults: findStaffResults });
                } else {
                  noStaffResultsMessage = t('No results found', { ns: _translation.TRANSLATION_FILES.translation }) + '.';

                  this.setState({ noStaffResultsMessage: noStaffResultsMessage });
                }

              case 34:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[5, 11]]);
      }));

      function searchStaffs(_x16) {
        return _ref8.apply(this, arguments);
      }

      return searchStaffs;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var fetch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var store = this.context.store;
      var _props$location = this.props.location,
          pathname = _props$location.pathname,
          search = _props$location.search;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      var bookingStatus = (0, _url.decodeSearch)(search).bookingStatus;
      var bookingStatusMulti = (0, _url.decodeSearch)(search).bookingStatusMulti;
      var paymentStatus = (0, _url.decodeSearch)(search).paymentStatus;
      var lawyerCaseType = (0, _url.decodeSearch)(search).lawyerCaseType;
      var lawyerCaseStatus = (0, _url.decodeSearch)(search).lawyerCaseStatus;
      if (query.bookingStatus && !bookingStatus || query.bookingStatusMulti && !bookingStatusMulti || query.paymentStatus && !paymentStatus || query.lawyerCaseStatus && !lawyerCaseStatus || query.lawyerCaseType && !lawyerCaseType) {
        queryNew.page = 1;
      }
      if (fetch) {
        this.fetchBookings(queryNew);
        if (this.state.currentTab === 'all') {
          this.fetchBookingSummaries(queryNew);
        }
      }
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));
    }
    // CPI-974 (D9) / CPI-1209: the Booking ID column; rule and cell value live in utils/vietnam.js.

    // CPI-1226: why a booking was cancelled; book-api mirrors both values onto the booking row.

    // CPI-1209 (A33/A34): Pending Cancellation is a view of the cancellation request, not a status.

  }, {
    key: 'isShowLoanReminderLetter',
    value: function isShowLoanReminderLetter() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var criteria = this.state.currentTab === 'aging_by_units' && data.project.printLoanReminderType !== '' && (data.bookingStatus.id === 'booked' || data.bookingStatus.id === 'reserved') && this.checkGroupAccess(this.props.auth.groups) && data.currentAge >= 14 && data.currentAge <= 42;

      return criteria;
    }
  }, {
    key: 'isShowSpaReminderLetter',
    value: function isShowSpaReminderLetter() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var criteria = this.state.currentTab === 'aging_by_units' && data.project.printSPAType !== '' && (data.bookingStatus.id === 'booked' || data.bookingStatus.id === 'reserved') && this.checkGroupAccess(this.props.auth.groups) && data.currentAge >= 28;

      return criteria;
    }
  }, {
    key: 'isShowTerminationLetter',
    value: function isShowTerminationLetter() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var criteria = this.state.currentTab === 'aging_by_units' && data.project.printTerminationType !== '' && data.bookingStatus.id === 'sold_spa_signed' && this.checkGroupAccess(this.props.auth.groups) && data.currentAge >= 21;

      return criteria;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this10 = this;

      if (this.props.hideBookingList && this.state.data.length < 1) {
        return _react2.default.createElement(_semanticUiReact.Grid, null);
      }
      var _state = this.state,
          currentTab = _state.currentTab,
          loading = _state.loading,
          data = _state.data,
          tabss = _state.tabss,
          isMobile = _state.isMobile,
          isComputer = _state.isComputer;
      var t = this.props.t;

      var sortItems = currentTab === 'aging_by_lawyers' ? [{
        text: 'Date Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'created_at',
        sortDirection: 'asc'
      }, {
        text: 'Date Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'created_at',
        sortDirection: 'desc'
      }, {
        text: 'Unit Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'property.unit_no.keyword',
        sortDirection: 'asc'
      }, {
        text: 'Unit Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'property.unit_no.keyword',
        sortDirection: 'desc'
      }, {
        text: 'Status Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'status.keyword',
        sortDirection: 'asc'
      }, {
        text: 'Status Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'status.keyword',
        sortDirection: 'desc'
      }, {
        text: 'Type Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'type.keyword',
        sortDirection: 'asc'
      }, {
        text: 'Type Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'type.keyword',
        sortDirection: 'desc'
      }, {
        text: 'Days Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'updated_at',
        sortDirection: 'asc'
      }, {
        text: 'Days Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'updated_at',
        sortDirection: 'desc'
      }, {
        text: 'Purchaser Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'purchaser.name.keyword',
        sortDirection: 'asc'
      }, {
        text: 'Purchaser Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'purchaser.name.keyword',
        sortDirection: 'desc'
      }] : [{
        text: 'Created Date Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.created_at' : 'booking.created_at',
        sortDirection: 'asc'
      }, {
        text: 'Created Date Descending',
        icon: 'sort alphabet descending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.created_at' : 'booking.created_at',
        sortDirection: 'desc'
      }, {
        text: 'Unit Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.reference_no' : 'project_unit.reference',
        sortDirection: 'asc'
      }, {
        text: 'Unit Descending',
        icon: 'sort alphabet descending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.reference_no' : 'project_unit.reference',
        sortDirection: 'desc'
      }, {
        text: 'Status Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.status' : 'booking_status.name',
        sortDirection: 'asc'
      }, {
        text: 'Status Descending',
        icon: 'sort alphabet descending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'bank_case.status' : 'booking_status.name',
        sortDirection: 'desc'
      }, {
        text: 'Reserved By Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'affiliate.name' : 'booking.ma_created_by_preferred_name',
        sortDirection: 'asc'
      }, {
        text: 'Reserved By Descending',
        icon: 'sort alphabet descending',
        sortColumn: currentTab === 'aging_by_bankers' ? 'affiliate.name' : 'booking.ma_created_by_preferred_name',
        sortDirection: 'desc'
      }, {
        text: 'Assigned Staff Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'booking.assigned_ma_preferred_name',
        sortDirection: 'asc'
      }, {
        text: 'Assigned Staff Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'booking.assigned_ma_preferred_name',
        sortDirection: 'desc'
      }, {
        text: 'Days Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: this.handleGetDaysSortColumn(),
        sortDirection: 'asc'
      }, {
        text: 'Days Descending',
        icon: 'sort alphabet descending',
        sortColumn: this.handleGetDaysSortColumn(),
        sortDirection: 'desc'
      }, {
        text: 'Banker Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'bankers.name',
        sortDirection: 'asc'
      }, {
        text: 'Banker Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'bankers.name',
        sortDirection: 'desc'
      }, {
        text: 'Bank Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'banks.short_name',
        sortDirection: 'asc'
      }, {
        text: 'Bank Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'banks.short_name',
        sortDirection: 'desc'
      }, {
        text: 'Code Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'bank_case.lead_id',
        sortDirection: 'asc'
      }, {
        text: 'Code Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'bank_case.lead_id',
        sortDirection: 'desc'
      }];
      sortItems.push.apply(sortItems, _toConsumableArray(this.statusDateSortItems()));
      var isMalaysia = this.props.auth.company && this.props.auth.company.countryCode === 'my';
      // CPI-1209: the plain Excel / CSV items. isCountryVietnam, not `!== 'my'`, which would add ID.
      var showPlainExports = isMalaysia || (0, _countries.isCountryVietnam)(this.props.auth.company && this.props.auth.company.countryCode);
      var exportItems = currentTab === 'aging_by_lawyers' ? [{
        text: 'Excel',
        icon: 'download',
        onClick: function () {
          var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
            var store, response;
            return regeneratorRuntime.wrap(function _callee9$(_context9) {
              while (1) {
                switch (_context9.prev = _context9.next) {
                  case 0:
                    store = _this10.context.store;
                    _context9.prev = 1;
                    _context9.next = 4;
                    return (0, _fetchM.serverRequestGet)('/bookings/export/aging/lawyers/?' + _this10.state.stringifyQuery, store);

                  case 4:
                    response = _context9.sent;

                    if (!response.error) {
                      _context9.next = 9;
                      break;
                    }

                    _context9.next = 8;
                    return store.dispatch((0, _flash.flashErrorMessage)({ message: response.message }));

                  case 8:
                    return _context9.abrupt('return');

                  case 9:
                    store.dispatch((0, _flash.flashSuccessMessage)({
                      header: t('Request Success', { ns: _translation.TRANSLATION_FILES.translation }),
                      message: t('We are processing your report, will send via email once the report is ready', { ns: _translation.TRANSLATION_FILES.translation }) + '.'
                    }));
                    _context9.next = 16;
                    break;

                  case 12:
                    _context9.prev = 12;
                    _context9.t0 = _context9['catch'](1);
                    _context9.next = 16;
                    return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

                  case 16:
                  case 'end':
                    return _context9.stop();
                }
              }
            }, _callee9, _this10, [[1, 12]]);
          }));

          return function onClick() {
            return _ref9.apply(this, arguments);
          };
        }()
      }] : this.exportItemsManager();
      if (currentTab !== 'aging_by_lawyers' && showPlainExports) {
        exportItems.push({
          text: 'Excel',
          icon: 'download',
          href: this.exportURL('excel')
        }, {
          text: 'CSV',
          icon: 'download',
          href: this.exportURL('csv')
        }, {
          isDivider: true
        });
      }
      if (currentTab !== 'aging_by_lawyers' && (0, _vietnam.showsPaymentExcelExport)(this.props.auth)) {
        exportItems.push({
          text: 'Payment\nExcel',
          icon: 'download',
          href: _config2.default.get('bookApiURL') + '/bookings/export/payments/?',
          dataTarget: 'paymentexcel'
        });
      }
      if (currentTab !== 'all' && currentTab !== 'aging_by_lawyers') {
        exportItems.push({
          text: 'Excel\n(detailed)',
          icon: 'download',
          href: this.exportURL('excel', false, true)
        });
      }
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { verticalAlign: 'middle', padded: 'vertically' },
        isMobile ? _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            this.renderAgingTabsMobile()
          )
        ) : _react2.default.createElement(
          _semanticUiReact.Menu,
          { pointing: true, secondary: true, style: { padding: '0.5em 0em 0em' } },
          tabss.map(function (tab, key) {
            return _react2.default.createElement(
              _semanticUiReact.Menu.Item,
              {
                className: 'uc-aging-tab',
                style: { backgroundColor: currentTab === tab.name ? '#E5FAF2' : 'transparent' },
                key: key,
                name: tab.name,
                onClick: _this10.handleChangeTab,
                active: currentTab === tab.name
              },
              (0, _strings.titleCase)(t(tab.text, { ns: _translation.namespaces[tab.name === 'all' ? 1 : 0] }))
            );
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            this.renderMenuTool()
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Dimmer,
              {
                inverted: true, style: { zIndex: 20 },
                active: loading && data.length > 0
              },
              _react2.default.createElement(
                _semanticUiReact.Loader,
                { inline: 'centered' },
                t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 10, tablet: 6, computer: 6, verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Header,
                    { as: 'h3' },
                    this.getTabHeader()
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 6, tablet: 10, computer: 10 },
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', justifyContent: 'end', alignItems: 'center' } },
                    exportItems.length > 0 && _react2.default.createElement(_semanticUiReact.Popup, {
                      size: 'tiny',
                      style: { backgroundColor: '#596975' },
                      basic: true,
                      inverted: true,
                      disabled: !isComputer,
                      content: t('Download', { ns: _translation.TRANSLATION_FILES.translation }),
                      position: 'bottom center',
                      trigger: _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_UCSortButton2.default, {
                          floated: 'right',
                          icon: _react2.default.createElement(
                            'div',
                            {
                              style: {
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                padding: '11px',
                                transition: 'background-color 0.2s ease',
                                cursor: 'pointer'
                              },
                              onMouseEnter: function onMouseEnter(e) {
                                return e.currentTarget.style.backgroundColor = '#f4f5f7';
                              },
                              onMouseLeave: function onMouseLeave(e) {
                                return e.currentTarget.style.backgroundColor = 'transparent';
                              }
                            },
                            _react2.default.createElement('img', { src: _download2.default, width: 20, alt: 'download' })
                          ),
                          loading: loading,
                          items: exportItems
                        })
                      )
                    }),
                    _react2.default.createElement(_semanticUiReact.Popup, {
                      size: 'tiny',
                      style: { backgroundColor: '#596975' },
                      basic: true,
                      inverted: true,
                      disabled: !isComputer,
                      content: t('Sort'),
                      position: 'bottom center',
                      trigger: _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(_UCSortButton2.default, {
                          floated: 'right',
                          icon: _react2.default.createElement(
                            'div',
                            {
                              style: {
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                padding: '8px',
                                transition: 'background-color 0.2s ease',
                                cursor: 'pointer'
                              },
                              onMouseEnter: function onMouseEnter(e) {
                                return e.currentTarget.style.backgroundColor = '#f4f5f7';
                              },
                              onMouseLeave: function onMouseLeave(e) {
                                return e.currentTarget.style.backgroundColor = 'transparent';
                              }
                            },
                            _react2.default.createElement('img', { src: _sort2.default, width: 24, alt: 'sort' })
                          ),
                          loading: loading,
                          items: sortItems,
                          onSort: this.handleSortData
                        })
                      )
                    })
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 16 },
                  _react2.default.createElement(
                    'div',
                    { style: { overflowX: 'auto' } },
                    _react2.default.createElement(
                      _semanticUiReact.Table,
                      { className: 'uc-table uc-booking-list-table', basic: 'very', sortable: true },
                      this.renderTableHeaders(sortItems),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Body,
                        null,
                        data.length > 0 ? data.map(this.renderTableRow) : _react2.default.createElement(
                          _semanticUiReact.Table.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Table.Cell,
                            { colSpan: 10, textAlign: 'center' },
                            loading ? _react2.default.createElement(
                              _semanticUiReact.Loader,
                              { active: true, inline: 'centered' },
                              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                            ) : _react2.default.createElement(
                              'p',
                              null,
                              t('No bookings found'),
                              '.'
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'center' },
            _react2.default.createElement(_PageNav2.default, {
              upward: true,
              currentPage: this.state.currentPage,
              count: this.state.count,
              limit: this.state.limit,
              offset: this.state.offset,
              dataSize: data.length,
              loading: loading,
              onChange: this.handleChangePage,
              noScrollTop: this.props.noScrollTop
            })
          )
        )
      );
    }
  }]);

  return BookingsList;
}(_react.Component);

BookingsList.contextTypes = {
  store: _propTypes2.default.object,
  router: _propTypes2.default.object
};
BookingsList.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      companyID: _propTypes2.default.number,
      lawyerIsEnabled: _propTypes2.default.bool
    })
  }),
  where: _propTypes2.default.shape({}),
  projectUnitID: _propTypes2.default.string,
  onLoading: _propTypes2.default.func,
  noScrollTop: _propTypes2.default.bool,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isBranchLeaderSupervisor: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    groups: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      code: _propTypes2.default.string
    })),
    companyBranch: _propTypes2.default.shape({
      isExternal: _propTypes2.default.bool
    }),
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  hideBookingList: _propTypes2.default.bool,
  bookingListLength: _propTypes2.default.func,
  isUnitOverview: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
BookingsList.defaultProps = {
  hideBookingList: false
};

BookingsList.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

BookingsList.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var searchIn = query.searchIn || '';
  var dateRange = query.dateRange || '';
  var cancelledDateRange = query.cancelledDateRange || '';
  var expiredDateRange = query.expiredDateRange || '';
  var bookedDateRange = query.bookedDateRange || '';
  var soldDateRange = query.soldDateRange || '';
  var loanStatus = query.loanStatus || [];
  var duration = query.duration || '';
  var bookingStatus = query.bookingStatus || '';
  var bookingStatusMulti = query.bookingStatusMulti || [];
  var agingRange = query.agingRange || '';
  var agingDuration = query.agingDuration || '';
  var paymentStatus = query.paymentStatus || [];
  var lawyerCaseType = query.lawyerCaseType || '';
  var lawyerCaseStatus = query.lawyerCaseStatus || '';
  var projectFilter = (0, _isbase2.default)(query.projectFilter) && _qs2.default.parse(atob(query.projectFilter)).name || '';
  var staffFilter = (0, _isbase2.default)(query.staffFilter) && _qs2.default.parse(atob(query.staffFilter)).name || '';
  var dateFrom = query.dateFrom ? query.dateFrom : '';
  var dateTo = query.dateTo ? query.dateTo : '';
  var cancelledDateFrom = query.cancelledDateFrom ? query.cancelledDateFrom : '';
  var cancelledDateTo = query.cancelledDateTo ? query.cancelledDateTo : '';
  var expiredDateFrom = query.expiredDateFrom ? query.expiredDateFrom : '';
  var expiredDateTo = query.expiredDateTo ? query.expiredDateTo : '';
  var bookedDateFrom = query.bookedDateFrom ? query.bookedDateFrom : '';
  var bookedDateTo = query.bookedDateTo ? query.bookedDateTo : '';
  var soldDateFrom = query.soldDateFrom ? query.soldDateFrom : '';
  var soldDateTo = query.soldDateTo ? query.soldDateTo : '';
  var loadingProjectSearch = false;
  var loadingStaffSearch = false;
  var findProjectResults = [];
  var findStaffResults = [];
  var loadingMessage = props.t('Loading', { ns: _translation.TRANSLATION_FILES.translation }) + '...';
  var noResultsMessage = loadingMessage;
  var noStaffResultsMessage = loadingMessage;
  var hasLawyerAccess = props.auth && props.auth.companyBranch && !props.auth.isExternalAgent;
  var lawyerIsEnabled = props.appConfig && props.appConfig.data && props.appConfig.data.lawyerIsEnabled && hasLawyerAccess;
  // const hasAccess = props.auth.isHeadquarters || props.auth.isSuperAdmin;
  // CPI-1209 (A37): Vietnam has no lawyer module, so the Aging By Lawyers tab is dropped there.
  var showLawyerTab = lawyerIsEnabled && !(0, _countries.isCountryVietnam)(props.auth && props.auth.company && props.auth.company.countryCode);
  var tabss = showLawyerTab ? tabs : tabs.filter(function (t) {
    return t.value !== 'aging_by_lawyers';
  });
  var currentTab = tabss.some(function (t) {
    return t.value === query.tab;
  }) ? query.tab : tabs[0].value;
  var screenWidth = window.innerWidth;
  return {
    search: search,
    searchIn: searchIn,
    dateRange: dateRange,
    cancelledDateRange: cancelledDateRange,
    expiredDateRange: expiredDateRange,
    bookedDateRange: bookedDateRange,
    soldDateRange: soldDateRange,
    loanStatus: loanStatus,
    duration: duration,
    bookingStatus: bookingStatus,
    bookingStatusMulti: bookingStatusMulti,
    agingRange: agingRange,
    agingDuration: agingDuration,
    paymentStatus: paymentStatus,
    projectFilter: projectFilter,
    staffFilter: staffFilter,
    dateTo: dateTo,
    dateFrom: dateFrom,
    cancelledDateFrom: cancelledDateFrom,
    cancelledDateTo: cancelledDateTo,
    expiredDateFrom: expiredDateFrom,
    expiredDateTo: expiredDateTo,
    bookedDateFrom: bookedDateFrom,
    bookedDateTo: bookedDateTo,
    soldDateFrom: soldDateFrom,
    soldDateTo: soldDateTo,
    loadingProjectSearch: loadingProjectSearch,
    loadingStaffSearch: loadingStaffSearch,
    findProjectResults: findProjectResults,
    findStaffResults: findStaffResults,
    noResultsMessage: noResultsMessage,
    noStaffResultsMessage: noStaffResultsMessage,
    currentPage: currentPage,
    currentTab: currentTab,
    lawyerCaseStatus: lawyerCaseStatus,
    lawyerCaseType: lawyerCaseType,
    tabss: tabss,
    stringifyQuery: '',
    screenWidth: screenWidth
  };
};

BookingsList.summaryDefault = {
  count: 0,
  reservedCount: 0,
  bookedCount: 0,
  cancelledDeveloperCount: 0,
  pendingCancellationCount: 0,
  cancelledCount: 0,
  soldCount: 0,
  loanCount: 0
};

var _initialiseProps = function _initialiseProps() {
  var _this11 = this;

  this.getStatusCount = function (status) {
    var summary = _this11.state.summary;

    if (_this11.state.loading) {
      return '...';
    }
    switch (status) {
      case 'total':
        return summary.count;
      case 'reserved':
        return summary.reservedCount;
      case 'booked':
        return summary.bookedCount;
      case _bookingStatuses.BOOKING_STATUS_PENDING_CANCELLATION:
        return summary.pendingCancellationCount || 0;
      case 'cancelled_developer':
        return summary.cancelledDeveloperCount;
      case 'cancelled_availability':
        return summary.cancelledCount;
      case 'sold_spa_signed':
        return summary.soldCount;
      case 'expired':
        return summary.expiredCount || 0;
      default:
        return 0;
    }
  };

  this.getSelectedStatus = function (status) {
    var bookingStatus = _this11.state.bookingStatus;

    if (status === 'total') {
      return bookingStatus === '';
    } else if (bookingStatus !== '') {
      return bookingStatus === status;
    }
    return false;
  };

  this.getTabHeader = function () {
    var currentTab = _this11.state.currentTab;
    var _props = _this11.props,
        t = _props.t,
        auth = _props.auth;


    return t(currentTab === 'all' && (0, _countries.isCountryVietnam)(auth.company.countryCode) ? 'Latest Sales' : tabs.find(function (tab) {
      return currentTab === tab.value;
    }).header);
  };

  this.getBankCaseStatusColor = function (status) {
    if (status.startsWith('reject')) {
      return 'red';
    } else if (status.startsWith('pending')) {
      return 'yellow';
    } else if (status.startsWith('approved') || status.startsWith('success')) {
      return 'green';
    }
    return 'blue';
  };

  this.getBankCaseStatuses = function (data) {
    var values = [];
    if (data.bankCasesStatuses) {
      data.bankCasesStatuses.forEach(function (bcs) {
        values.push({
          iconColor: _this11.getBankCaseStatusColor(bcs.status),
          value: bcs.bankShortName
        });
      });
    }
    return values;
  };

  this.getRowClassName = function (statusID) {
    if (statusID === 'cancelled_availability') {
      return 'row-colors booking_row_cancelled_availability';
    }
    if (statusID === 'cancelled_developer' || statusID === _lawyerCaseStatuses.DEVELOPER_CANCELLED) {
      return 'row-colors booking_row_cancelled_developer';
    }
    return 'row-colors';
  };

  this.getAgingColor = function () {
    var days = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

    if (days >= 30) {
      return 'red';
    }
    if (days >= 14) {
      return 'yellow';
    }
    return null;
  };

  this.getPaymentIcon = function (paymentStatus) {
    switch (paymentStatus) {
      case 'paid':
        return _credit_card_green2.default;
      case 'partial_paid':
        return _credit_card_yellow2.default;
      default:
        return _credit_card_disabled2.default;
    }
  };

  this.getAllFilterNames = function () {
    var removeBookingStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (removeBookingStatus) return allFilterNames.filter(function (fn) {
      return fn !== 'bookingStatusMulti';
    });
    return allFilterNames;
  };

  this.fetchMarketplaceUserDetails = function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(userID) {
      var store, t, url, response;
      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              store = _this11.context.store;
              t = _this11.props.t;
              url = '/marketplace/staffs/' + userID + '/';
              _context10.prev = 3;
              _context10.next = 6;
              return _this11.setMPUserLoading(true);

            case 6:
              _context10.next = 8;
              return (0, _fetchM.serverRequestGet)(url, store);

            case 8:
              response = _context10.sent;

              if (!response.error) {
                _context10.next = 13;
                break;
              }

              _context10.next = 12;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: response.message }));

            case 12:
              return _context10.abrupt('return');

            case 13:
              _context10.next = 15;
              return _this11.setState({ mpUserDetails: response.data });

            case 15:
              _context10.next = 17;
              return _this11.setMPUserLoading(false);

            case 17:
              _context10.next = 26;
              break;

            case 19:
              _context10.prev = 19;
              _context10.t0 = _context10['catch'](3);

              Bugsnag.notifyException(_context10.t0);
              _context10.next = 24;
              return _this11.setMPUserLoading(false);

            case 24:
              _context10.next = 26;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

            case 26:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this11, [[3, 19]]);
    }));

    return function (_x24) {
      return _ref10.apply(this, arguments);
    };
  }();

  this.fetchAllLawyerCasesDetails = function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
      var bookingID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var spaLawyer, laLawyer, results, i, _t, lawyer;

      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _context11.next = 2;
              return _this11.setLoading(true);

            case 2:
              spaLawyer = void 0;
              laLawyer = void 0;

              // Fetch SPA and LA cases in parallel

              _context11.next = 6;
              return Promise.all([_this11.fetchLawyerCases('SPA', bookingID), _this11.fetchLawyerCases('LA', bookingID)]);

            case 6:
              results = _context11.sent;
              i = 0;

            case 8:
              if (!(i < results.length)) {
                _context11.next = 18;
                break;
              }

              _t = results[i];

              if (!(_t.items && _t.items.length > 0 && _t.items[0].status !== _lawyerCaseStatuses.DEVELOPER_CANCELLED)) {
                _context11.next = 15;
                break;
              }

              _context11.next = 13;
              return _this11.fetchLawyer(_t.items[0].lawyer_id);

            case 13:
              lawyer = _context11.sent;

              if (lawyer) {
                if (_t.type === 'SPA') {
                  spaLawyer = lawyer;
                }
                if (_t.type === 'LA') {
                  laLawyer = lawyer;
                }
              }

            case 15:
              i++;
              _context11.next = 8;
              break;

            case 18:
              return _context11.abrupt('return', {
                spaLawyer: spaLawyer,
                laLawyer: laLawyer
              });

            case 19:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this11);
    }));

    return function () {
      return _ref11.apply(this, arguments);
    };
  }();

  this.fetchLawyerCases = function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(type, bookingID) {
      var store, query, res;
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              store = _this11.context.store;
              query = {
                limit: 1,
                type: type
              };
              res = void 0;
              _context12.prev = 3;
              _context12.next = 6;
              return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.BOOKING_CASES(bookingID) + '/?' + _qs2.default.stringify(query), null, 'get', {
                'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
              }));

            case 6:
              res = _context12.sent;
              _context12.next = 13;
              break;

            case 9:
              _context12.prev = 9;
              _context12.t0 = _context12['catch'](3);

              Bugsnag.notifyException(_context12.t0);
              return _context12.abrupt('return', []);

            case 13:
              return _context12.abrupt('return', res);

            case 14:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this11, [[3, 9]]);
    }));

    return function (_x26, _x27) {
      return _ref12.apply(this, arguments);
    };
  }();

  this.fetchBankCaseDrops = function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(booking) {
      var store, res, bankCases, message, _message4, data;

      return regeneratorRuntime.wrap(function _callee13$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              store = _this11.context.store;
              res = void 0;
              bankCases = {};
              _context13.prev = 3;
              _context13.next = 6;
              return store.dispatch((0, _fetchM.fetchM)('/bookings/' + booking.id + '/loan_trackers/bank_cases/drop/', {
                credentials: 'include',
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Csrf-Token': _this11.props.token
                }
              }));

            case 6:
              res = _context13.sent;
              _context13.next = 19;
              break;

            case 9:
              _context13.prev = 9;
              _context13.t0 = _context13['catch'](3);

              if (!(_context13.t0.res && _context13.t0.res.status >= 400 && _context13.t0.res.status < 500)) {
                _context13.next = 17;
                break;
              }

              _context13.next = 14;
              return _context13.t0.res.text();

            case 14:
              message = _context13.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
              return _context13.abrupt('return', bankCases);

            case 17:
              Bugsnag.notifyException(_context13.t0);
              // store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
              return _context13.abrupt('return', bankCases);

            case 19:
              if (res.ok) {
                _context13.next = 27;
                break;
              }

              _context13.next = 22;
              return res.text();

            case 22:
              _message4 = _context13.sent;
              _context13.next = 25;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: _message4 }));

            case 25:
              _context13.next = 31;
              break;

            case 27:
              _context13.next = 29;
              return res.json();

            case 29:
              data = _context13.sent;

              if (data && data.length > 0) {
                bankCases = _this11.getAllBankCases(booking.bankCases, data);
              } else {
                bankCases = _this11.getAllBankCases(booking.bankCases);
              }

            case 31:
              return _context13.abrupt('return', bankCases);

            case 32:
            case 'end':
              return _context13.stop();
          }
        }
      }, _callee13, _this11, [[3, 9]]);
    }));

    return function (_x28) {
      return _ref13.apply(this, arguments);
    };
  }();

  this.getAllBankCases = function (bankCases, bankCaseDrops) {
    var hasDropCase = false;
    var allCases = [];
    if (bankCases) {
      var bankerIDs = new Set(bankCases.map(function (bc) {
        return bc.bankerID;
      }));
      allCases = bankCaseDrops ? [].concat(_toConsumableArray(bankCases), _toConsumableArray(bankCaseDrops.filter(function (bcd) {
        if (!bankerIDs.has(bcd.bankerID)) {
          hasDropCase = true;
          return true;
        }
      }))) : [].concat(_toConsumableArray(bankCases));
    } else if (bankCaseDrops) {
      allCases = [].concat(_toConsumableArray(bankCaseDrops));
      hasDropCase = true;
    }

    return _extends({}, allCases, {
      hasDropCase: hasDropCase
    });
  };

  this.checkAutoReleaseTimer = function (data, project) {
    var _state2 = _this11.state,
        allBankCases = _state2.allBankCases,
        systemData = _state2.systemData;
    // if booking is reserved & system's AR is turned on

    if (data && data.statusID === 'reserved' && systemData && project && systemData.arBookingExpIsEnabled) {
      var primaryBookingCustomer = data.bookingCustomers && data.bookingCustomers.find(function (bc) {
        return bc.customerID === data.customerID;
      }) || data.bookingCustomer;

      var systemTimer = systemData.arBookingExpMoreThanMinutes !== '' && systemData.arBookingExpMoreThanMinutes !== '0';
      var projectTimer = project.arBookingExpMoreThanMinutes !== '' && project.arBookingExpMoreThanMinutes !== '0';
      var hasFrontIC = primaryBookingCustomer && primaryBookingCustomer.customer && primaryBookingCustomer.customer.icFrontDocumentID;
      var hasBackIC = primaryBookingCustomer && primaryBookingCustomer.customer && primaryBookingCustomer.customer.icBackDocumentID;
      var hasPaid = data.paymentStatusID && data.paymentStatusID === 'paid';
      var hasMortgageAdded = allBankCases && allBankCases.length > 0;
      var isBankerSourceOfFinance = data.paymentMethodID === 'own_banker' || data.paymentMethodID === 'referred_banker';
      var allPurchasersHasUploadedIC = data.bookingCustomers && data.bookingCustomers.length > 0 && data.bookingCustomers.filter(function (c) {
        return !c.customer.icFrontDocumentID || !c.customer.icBackDocumentID;
      }).length === 0;

      if (systemTimer || projectTimer) {
        var sysARPaymentEnabled = systemData.arBookingExpUnpaidIsEnabled;
        var sysARNricEnabled = systemData.arBookingExpNricPicIsEnabled;
        var sysARAllNricEnabled = systemData.arBookingExpAllNricPicsIsEnabled;
        var sysARMortgageEnabled = systemData.arBookingExpMortgageEnabled && isBankerSourceOfFinance;

        var projARPaymentEnabled = project.arBookingExpUnpaidIsEnabled;
        var projARNricEnabled = project.arBookingExpNricPicIsEnabled;
        var projARAllNricEnabled = project.arBookingExpAllNricPicsIsEnabled;
        var projARMortgageEnabled = project.arBookingExpMortgageEnabled && isBankerSourceOfFinance;

        // if either one of the system's requirements is enabled
        if (sysARPaymentEnabled || sysARNricEnabled || sysARAllNricEnabled || sysARMortgageEnabled) {
          // Payment enabled & payment condition fulfilled
          var sysConditionFulfilledPayment = sysARPaymentEnabled && hasPaid;
          // IC enabled & IC condition fulfilled
          var sysConditionFulfilledNric = sysARNricEnabled && hasBackIC && hasFrontIC;
          // Additional Purchasers IC enabled & all IC condition fulfilled
          if (sysARAllNricEnabled) {
            sysConditionFulfilledNric = allPurchasersHasUploadedIC;
          }
          // All IC enabled & All IC condition fulfilled
          // Mortgage enabled & mortgage condition fulfilled
          var sysConditionFulfilledMortgage = sysARMortgageEnabled && hasMortgageAdded;
          if (
          // all enabled and all conditions fulfilled
          sysConditionFulfilledPayment && sysConditionFulfilledNric && sysARMortgageEnabled ||
          // IC & mortgage enabled & both conditions fulfilled, payment disabled
          !sysARPaymentEnabled && sysConditionFulfilledNric && sysConditionFulfilledMortgage ||
          // Payment & mortgage enabled & both conditions fulfilled, NRIC disabled
          sysConditionFulfilledPayment && !sysARNricEnabled && sysConditionFulfilledMortgage ||
          // Payment & IC enabled & both conditions fulfilled, mortgage disabled
          sysConditionFulfilledPayment && sysConditionFulfilledNric && !sysARMortgageEnabled ||
          // Mortgage enabled & mortgage condition fulfilled, payment & nric disabled
          !sysARPaymentEnabled && !sysARNricEnabled && sysConditionFulfilledMortgage ||
          // IC enabled & IC condition fulfilled, payment & mortgage disabled
          !sysARPaymentEnabled && sysConditionFulfilledNric && !sysARMortgageEnabled ||
          // Payment enabled & payment condition fulfilled, nric & mortgage disabled
          sysConditionFulfilledPayment && !sysARNricEnabled && !sysARMortgageEnabled) {
            return false;
          }
          // if project AR is turned on & 1 of the requirements is enabled
        } else if (project.arBookingExpIsEnabled && (projARPaymentEnabled || projARNricEnabled || projARAllNricEnabled || projARMortgageEnabled)) {
          // Payment enabled & payment condition fulfilled
          var projConditionFulfilledPayment = projARPaymentEnabled && hasPaid;
          // IC enabled & IC condition fulfilled
          var projConditionFulfilledNric = projARNricEnabled && hasBackIC && hasFrontIC;
          // Additional Purchasers IC enabled & all IC condition fulfilled
          if (projARAllNricEnabled) {
            projConditionFulfilledNric = allPurchasersHasUploadedIC;
          }
          // Mortgage enabled & mortgage condition fulfilled
          var projConditionFulfilledMortgage = projARMortgageEnabled && hasMortgageAdded;
          if (
          // all enabled and all conditions fulfilled
          projConditionFulfilledPayment && projConditionFulfilledNric && projARMortgageEnabled ||
          // IC & mortgage enabled & both conditions fulfilled, payment disabled
          !projARPaymentEnabled && projConditionFulfilledNric && projConditionFulfilledMortgage ||
          // Payment & mortgage enabled & both conditions fulfilled, NRIC disabled
          projConditionFulfilledPayment && !projARNricEnabled && projConditionFulfilledMortgage ||
          // Payment & IC enabled & both conditions fulfilled, mortgage disabled
          projConditionFulfilledPayment && projConditionFulfilledNric && !projARMortgageEnabled ||
          // Mortgage enabled & mortgage condition fulfilled, payment & nric disabled
          !projARPaymentEnabled && !projARNricEnabled && projConditionFulfilledMortgage ||
          // IC enabled & IC condition fulfilled, payment & mortgage disabled
          !projARPaymentEnabled && projConditionFulfilledNric && !projARMortgageEnabled ||
          // Payment enabled & payment condition fulfilled, nric & mortgage disabled
          projConditionFulfilledPayment && !projARNricEnabled && !projARMortgageEnabled) {
            return false;
          }
          // project AR is not on
        } else if (!project.arBookingExpIsEnabled) {
          return false;
          // none of the requirements is on
        } else if (!sysARPaymentEnabled && !sysARNricEnabled && !sysARAllNricEnabled && !sysARMortgageEnabled && !projARPaymentEnabled && !projARNricEnabled && !projARAllNricEnabled && !projARMortgageEnabled) {
          return false;
        }
        return true;
      }
    }
    return false;
  };

  this.handleResize = function () {
    _this11.setState({
      screenWidth: window.innerWidth,
      isMobile: _this11.state.screenWidth <= 767,
      isTablet: _this11.state.screenWidth > 767 && _this11.state.screenWidth <= 991,
      isComputer: _this11.state.screenWidth > 991
    });
  };

  this.isTableOverflowing = function (table) {
    var parent = table.parentElement;
    return table.scrollWidth > parent.clientWidth;
  };

  this.setStickyWidth = function () {
    var table = document.querySelector('table');

    if (!table) return;

    if (_this11.isTableOverflowing(table)) {
      // Table is overflowing - apply sticky
      document.querySelectorAll('tr').forEach(function (row) {
        // Left sticky
        var stickyLeftCols = Array.from(row.querySelectorAll('.uc-sticky-col.uc-left'));
        var cumulativeLeft = 0;
        stickyLeftCols.forEach(function (colParam) {
          var col = colParam;
          col.style.left = cumulativeLeft + 'px';
          cumulativeLeft += col.offsetWidth;
        });

        // Right sticky
        var stickyRightCols = Array.from(row.querySelectorAll('.uc-sticky-col.uc-right')).reverse();
        var cumulativeRight = 0;
        stickyRightCols.forEach(function (colParam) {
          var col = colParam;
          col.style.right = cumulativeRight + 'px';
          cumulativeRight += col.offsetWidth;
        });
      });

      // Enable shadows
      table.classList.add('has-overflow');
    } else {
      // No overflow - reset positions
      document.querySelectorAll('.uc-sticky-col').forEach(function (colElem) {
        var col = colElem;
        col.style.left = '';
        col.style.right = '';
      });

      // Disable shadows
      table.classList.remove('has-overflow');
    }
  };

  this.updateStickyShadows = function () {
    // Remove old shadow classes
    document.querySelectorAll('.uc-sticky-shadow-left, .uc-sticky-shadow-right').forEach(function (el) {
      el.classList.remove('uc-sticky-shadow-left', 'uc-sticky-shadow-right');
    });

    // Loop over all table rows
    document.querySelectorAll('tr').forEach(function (row) {
      // Find the first sticky LEFT cell in this row
      var firstStickyLeft = row.querySelector('th.uc-sticky-col.uc-left, td.uc-sticky-col.uc-left');
      if (firstStickyLeft) {
        firstStickyLeft.classList.add('uc-sticky-shadow-left');
      }

      // Find the first sticky RIGHT cell in this row
      var firstStickyRight = row.querySelector('th.uc-sticky-col.uc-right, td.uc-sticky-col.uc-right');
      if (firstStickyRight) {
        firstStickyRight.classList.add('uc-sticky-shadow-right');
      }
    });
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this11.props.location.search);
    query.page = currentPage;
    _this11.setState({ currentPage: currentPage }, function () {
      _this11.replaceQuery(query);
    });
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this11.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this11.replaceQuery(query, true);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var clearSearch = false;
    var query = (0, _url.decodeSearch)(_this11.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (filter === 'search') {
        clearSearch = true;
      }
      if (filter === 'agingRange' || filter === 'loanStatus') {
        delete query.sortColumn;
        delete query.sortDirection;
      }
      if (filter === 'filteredProjects') {
        delete query.projectCode;
        delete query.projectFilter;
        hasQuery = true;
        _this11.setState({
          filteredProjects: [],
          isChanging: false
        });
      }
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
        _this11.setState({ isChanging: false });
      }
    });
    var cb = function cb() {
      if (hasQuery) {
        _this11.replaceQuery(query, true);
      }
    };
    if (clearSearch) {
      _this11.setState({ search: '' }, function () {
        cb();
      });
    } else {
      cb();
    }
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this11.props.location.search);
    query[queryName] = value;
    if (queryName === 'agingRange' || queryName === 'loanStatus') {
      delete query.sortColumn;
      delete query.sortDirection;
    }
    if (queryName === 'lawyerCaseType' && !(0, _lawyerCaseStatuses.getLawyerCaseStatuses)(value).some(function (s) {
      return s.value === query.lawyerCaseStatus;
    })) {
      delete query.lawyerCaseStatus;
    }
    var refetch = queryName !== 'searchIn' || queryName === 'searchIn' && _this11.state.search.length > 0;
    if (queryName === 'dateRange' && query.dateRange === 'custom' && (!query.dateFrom || !query.dateTo)) {
      refetch = false;
    }
    if (queryName === 'cancelledDateRange' && query.cancelledDateRange === 'custom' && (!query.cancelledDateFrom || !query.cancelledDateTo)) {
      refetch = false;
    }
    if (queryName === 'expiredDateRange' && query.expiredDateRange === 'custom' && (!query.expiredDateFrom || !query.expiredDateTo)) {
      refetch = false;
    }
    if (queryName === 'bookedDateRange' && query.bookedDateRange === 'custom' && (!query.bookedDateFrom || !query.bookedDateTo)) {
      refetch = false;
    }
    if (queryName === 'soldDateRange' && query.soldDateRange === 'custom' && (!query.soldDateFrom || !query.soldDateTo)) {
      refetch = false;
    }
    _this11.replaceQuery(query, true, refetch);
  };

  this.handleSetDateRange = function (name, from, to) {
    var query = (0, _url.decodeSearch)(_this11.props.location.search);
    switch (name) {
      case 'dateRange':
        query.dateFrom = from;
        query.dateTo = to;
        break;
      case 'cancelledDateRange':
        query.cancelledDateFrom = from;
        query.cancelledDateTo = to;
        break;
      case 'expiredDateRange':
        query.expiredDateFrom = from;
        query.expiredDateTo = to;
        break;
      case 'bookedDateRange':
        query.bookedDateFrom = from;
        query.bookedDateTo = to;
        break;
      case 'soldDateRange':
        query.soldDateFrom = from;
        query.soldDateTo = to;
        break;
      default:
        break;
    }
    _this11.replaceQuery(query, true);
  };

  this.handleReplaceStatus = function () {
    var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var query = (0, _url.decodeSearch)(_this11.props.location.search);
    if (status !== '') {
      query.bookingStatus = status;
    } else {
      delete query.bookingStatus;
    }
    if (status !== 'cancelled_developer') {
      delete query.cancelledDateRange;
      delete query.cancelledDateFrom;
      delete query.cancelledDateTo;
    }
    if (status !== 'expired') {
      delete query.expiredDateRange;
      delete query.expiredDateFrom;
      delete query.expiredDateTo;
    }
    if (status !== 'booked') {
      delete query.bookedDateRange;
      delete query.bookedDateFrom;
      delete query.bookedDateTo;
    }
    if (status !== 'sold_spa_signed') {
      delete query.soldDateRange;
      delete query.soldDateFrom;
      delete query.soldDateTo;
    }
    _this11.replaceQuery(query);
  };

  this.handleSearchStaff = function (value) {
    var t = _this11.props.t;

    clearTimeout(_this11.setStaffTimer);
    var findStaffResults = [];
    var noStaffResultsMessage = t('Loading', { ns: _translation.TRANSLATION_FILES.translation }) + '...';
    _this11.setState({ findStaffResults: findStaffResults, noStaffResultsMessage: noStaffResultsMessage, staffFilter: value }, function () {
      if (value !== '') {
        _this11.setStaffTimer = setTimeout(function () {
          _this11.searchStaffs(value);
        }, 500);
      }
    });
  };

  this.handleFilterProjects = function (e, _ref14) {
    var name = _ref14.name,
        value = _ref14.value;
    var currentTab = _this11.state.currentTab;

    var isCurrentTabLawyer = currentTab === 'aging_by_lawyers';
    var filteredProjects = isCurrentTabLawyer ? [value] : value;
    _this11.setState({ filteredProjects: filteredProjects }, function () {
      var query = (0, _url.decodeSearch)(_this11.props.location.search);
      query[name] = btoa(value);
      _this11.replaceQuery(query, true);
    });
  };

  this.handleSelectProject = function (project, queryName) {
    var query = (0, _url.decodeSearch)(_this11.props.location.search);
    var internalQuery = {};
    internalQuery.id = project.key;
    internalQuery.name = project.title;
    query[queryName] = btoa(_qs2.default.stringify(internalQuery));
    _this11.replaceQuery(query, true);
  };

  this.handleSelectStaff = function (staff, queryName) {
    var query = (0, _url.decodeSearch)(_this11.props.location.search);
    var internalQuery = {};
    internalQuery.id = staff.key;
    internalQuery.name = staff.title;
    query[queryName] = btoa(_qs2.default.stringify(internalQuery));
    _this11.replaceQuery(query, true);
  };

  this.exportURL = function (fileType) {
    var primary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var detailed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var _props2 = _this11.props,
        location = _props2.location,
        projectUnitID = _props2.projectUnitID;

    var url = _config2.default.get('bookApiURL') + '/reports/bookings/';
    if (location && location.search) {
      url += '' + location.search;
    }
    if (projectUnitID) {
      url += '&projectUnitID=' + projectUnitID;
    }
    if (primary) {
      url += '&primaryOnly=true';
    }
    url += '&fileType=' + fileType;
    if (detailed) {
      url += '&detailed=true';
    }
    return url;
  };

  this.getDataTarget = function (idx) {
    return { 'data-bot-target': 'row' + (idx + 1) + '-bookinglist' };
  };

  this.getDatasetAttributes = function (daname, davalue) {
    var newDavalue = davalue;
    if (newDavalue === '') newDavalue = 'NULL';
    if (newDavalue === 'Not Applicable') newDavalue = 'N/A';
    var datasetName = 'data-bot-' + daname;
    return _defineProperty({}, datasetName, newDavalue);
  };

  this.showBookingIDColumn = function () {
    return (0, _vietnam.showBookingIDColumn)(_this11.props.auth);
  };

  this.showCancellationReasonColumn = function () {
    var auth = _this11.props.auth;

    return (0, _countries.isCountryVietnam)(auth.company.countryCode);
  };

  this.showProjectColumn = function () {
    var auth = _this11.props.auth;

    return (0, _countries.isCountryVietnam)(auth.company.countryCode);
  };

  this.showPendingCancellation = function () {
    var auth = _this11.props.auth;

    return (0, _countries.isCountryVietnam)(auth.company.countryCode);
  };

  this.renderCancellationReason = function (row) {
    var label = (0, _OpportunityCancelModal.cancellationCategoryLabel)(row.srCancellationType);
    var translatedLabel = label ? _this11.props.t(label, { ns: _translation.TRANSLATION_FILES.translation }) : '';
    return translatedLabel || '-';
  };

  this.handleChangeTab = function (e, _ref16) {
    var name = _ref16.name,
        value = _ref16.value;

    var currentTab = name || value;
    _this11.setState({
      currentTab: currentTab,
      data: [],
      filteredProjects: [],
      offset: 0,
      count: 0,
      limit: 0
    }, function () {
      if (_this11.props.isUnitOverview) {
        _this11.replaceQuery({
          tab: currentTab,
          section: 'bookings'
        }, true);
      } else {
        _this11.replaceQuery({
          tab: currentTab
        }, true);
      }
    });
  };

  this.agingRanges = [{
    value: 'all',
    text: 'All',
    sortColumn: 'aging_summary.current_age'
  }, {
    value: 'reserved_to_today',
    text: 'Reserved To Today',
    sortColumn: 'aging_summary.reserved_to_today_age'
  }, {
    value: 'reserved_to_booked',
    text: 'Reserved To Booked',
    sortColumn: 'aging_summary.booked_age'
  }, {
    value: 'reserved_to_sold',
    text: 'Reserved To Sold',
    sortColumn: 'aging_summary.reserved_to_sold_age'
  }, {
    value: 'booked_to_today',
    text: 'Booked To Today',
    sortColumn: 'aging_summary.booked_to_today_age'
  }, {
    value: 'booked_to_sold',
    text: 'Booked To Sold',
    sortColumn: 'aging_summary.sold_age'
  }];
  this.loanStatuses = [{
    value: 'new',
    text: 'New',
    sortColumn: 'summary.current_age'
  }, {
    value: 'pending_docs',
    text: 'Pending Docs',
    sortColumn: 'summary.current_age'
  }, {
    value: 'pending_docs_submitted',
    text: 'Docs Submitted',
    sortColumn: 'summary.current_age'
  }, {
    value: 'approved_lo_issued',
    text: 'LO Approved',
    sortColumn: 'summary.current_age'
  }, {
    value: 'success_li_issued',
    text: 'LO Signed',
    sortColumn: 'summary.created_to_success_li_issued_age'
  }, {
    value: 'reject_unqualified',
    text: 'Unqualified',
    sortColumn: 'summary.created_to_reject_unqualified_age'
  }, {
    value: 'reject_bank',
    text: 'Bank Rejected',
    sortColumn: 'summary.created_to_reject_bank_age'
  }, {
    value: 'reject_customer',
    text: 'Customer Rejected',
    sortColumn: 'summary.created_to_reject_customer_age'
  }, {
    value: 'reject_cancelled',
    text: 'Customer Cancelled',
    sortColumn: 'summary.created_to_reject_cancelled_age'
  }, {
    value: 'reject_lo_signed_other_bank',
    text: 'LO Signed With Another Bank',
    sortColumn: 'summary.created_to_reject_lo_signed_other_bank_age'
  }, {
    value: 'reject_developer',
    text: 'Developer Cancelled',
    sortColumn: 'summary.created_to_reject_developer_age'
  }];

  this.hasMPDetailsAccess = function () {
    var auth = _this11.props.auth;

    return auth.isHeadquarters || auth.isBranchLeaderSupervisor;
  };

  this.cellCheckSorted = function (column) {
    var isReversed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    var _decodeSearch = (0, _url.decodeSearch)(_this11.props.location.search),
        sortColumn = _decodeSearch.sortColumn,
        sortDirection = _decodeSearch.sortDirection;

    var currentTab = _this11.state.currentTab;

    // API default sorted by descending if no sortColumn in URL

    if (!sortColumn) {
      if (currentTab === 'all' && column === 'booking.created_at' || currentTab === 'aging_by_units' && _this11.agingRanges.some(function (age) {
        return age.sortColumn === column;
      }) || currentTab === 'aging_by_bankers' && (_this11.loanStatuses.some(function (status) {
        return status.sortColumn === column;
      }) || column === 'summary.current_age') || currentTab === 'aging_by_lawyers' && column === 'updated_at') {
        return 'descending';
      }
    }

    if (column === sortColumn) {
      if (isReversed) {
        return sortDirection === 'asc' ? 'descending' : 'ascending';
      }
      return sortDirection === 'asc' ? 'ascending' : 'descending';
    }
    return null;
  };

  this.handleCellSort = function (column) {
    var _decodeSearch2 = (0, _url.decodeSearch)(_this11.props.location.search),
        sortColumn = _decodeSearch2.sortColumn,
        sortDirection = _decodeSearch2.sortDirection;

    var currentTab = _this11.state.currentTab;


    var direction = 'asc';
    if (!sortColumn && currentTab === 'aging_by_lawyers' && column === 'updated_at') {
      direction = 'desc';
    } else if (column === sortColumn) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc';
    }

    _this11.handleSortData(column, direction);
  };

  this.handleGetDaysSortColumn = function () {
    if (_this11.state.currentTab === 'aging_by_bankers') {
      if (_this11.loanStatuses.some(function (status) {
        return status.value === _this11.state.loanStatus;
      })) {
        return _this11.loanStatuses.find(function (status) {
          return status.value === _this11.state.loanStatus;
        }).sortColumn;
      }
      return _this11.loanStatuses[0].sortColumn;
    }
    if (_this11.agingRanges.some(function (age) {
      return age.value === _this11.state.agingRange;
    })) {
      return _this11.agingRanges.find(function (age) {
        return age.value === _this11.state.agingRange;
      }).sortColumn;
    }
    return _this11.agingRanges[0].sortColumn;
  };

  this.exportItemsAdmin = function () {
    if (_this11.hasAdminAccess() && _this11.state.currentTab !== 'aging_by_bankers') {
      var _props3 = _this11.props,
          location = _props3.location,
          projectUnitID = _props3.projectUnitID;

      var url = _config2.default.get('bookApiURL') + '/reports/bookings/customer_details/';
      if (location && location.search) {
        url += '' + location.search;
      }
      if (projectUnitID) {
        url += '&projectUnitID=' + projectUnitID;
      }
      return [{
        text: 'Excel\nwith\nCustomer\nDetails',
        icon: 'download',
        href: url + '&fileType=excel'
      }, {
        text: 'Excel\n(primary)\nwith\nCustomer\nDetails',
        icon: 'download',
        href: url + '&fileType=excel&primaryOnly=true'
      }, {
        text: 'CSV\nwith\nCustomer\nDetails',
        icon: 'download',
        href: url + '&fileType=csv'
      }, {
        text: 'CSV\n(primary)\nwith\nCustomer\nDetails',
        icon: 'download',
        href: url + '&fileType=csv&primaryOnly=true'
      }];
    }
    return [];
  };

  this.exportItemsPrimary = function () {
    if (_this11.state.currentTab !== 'aging_by_bankers') {
      return [{
        text: 'Excel\n(primary)',
        icon: 'download',
        href: _this11.exportURL('excel', true)
      }, {
        text: 'CSV\n(primary)',
        icon: 'download',
        href: _this11.exportURL('csv', true)
      }];
    }
    return [];
  };

  this.exportItemsManager = function () {
    var isMalaysia = _this11.props.auth.company && _this11.props.auth.company.countryCode === 'my';
    if (_this11.hasAccess() && _this11.state.currentTab !== 'aging_by_bankers') {
      var query = (0, _url.decodeSearch)(_this11.props.location.search);
      query.page = 'all';
      var exportItems = [{
        text: 'Full\nExcel',
        icon: 'download',
        href: _config2.default.get('bookApiURL') + '/bookings/export/?' + _qs2.default.stringify(query),
        dataTarget: 'fullexcel'
      }, {
        text: 'Updated Today',
        icon: 'download',
        href: _config2.default.get('bookApiURL') + '/bookings/export/?page=all&updatedToday=true',
        dataTarget: 'updatedtoday'
      }, {
        isDivider: true
      }];
      if (_this11.state.currentTab === 'all' && isMalaysia) {
        exportItems.push({
          text: 'Loan Approval',
          icon: 'download',
          href: _config2.default.get('bookApiURL') + '/bookings/export/loan_approvals/?' + _qs2.default.stringify(query),
          dataTarget: 'loanapproval'
        }, {
          text: 'Booking Notes',
          icon: 'download',
          href: _config2.default.get('bookApiURL') + '/bookings/export/notes/?' + _qs2.default.stringify(query),
          dataTarget: 'bookingnotes'
        }, {
          isDivider: true
        });
      }
      return exportItems;
    }
    return [];
  };

  this.checkGroupAccess = function (groups) {
    var roles = [{ text: 'Headquarters', value: '10,6' }, { text: 'Supervisor', value: '10,11,12,13' }, { text: 'Sales Manager', value: '10,11,13' }, { text: 'Sales Admin', value: '10,11' }];
    var rolesArr = [];
    if (groups) {
      groups.forEach(function (g) {
        rolesArr.push(g.id);
      });
      rolesArr.sort();
      var role = roles.find(function (g) {
        return g.value === String(rolesArr.toString());
      });
      if (role && role.text) {
        return role.text;
      }
    }
    return null;
  };

  this.hasLawyerSPASignedDate = function (date) {
    if (date) {
      if (date.length > 1 && date[1]) {
        return true;
      }
    }
    return false;
  };

  this.handlePrint = function () {
    _auth2.default.currentSession();
  };

  this.statusDateSortItems = function () {
    var bookingStatus = _this11.state.bookingStatus;

    var label = '';
    var column = '';
    switch (bookingStatus) {
      case 'cancelled_developer':
        label = 'Cancelled';
        column = 'l_cancelled_developer_at';
        break;
      case 'expired':
        label = 'Expired';
        column = 'l_expired_at';
        break;
      case 'booked':
        label = 'Booked';
        column = 'l_booked_at';
        break;
      case 'sold_spa_signed':
        label = 'Sold';
        column = 'l_sold_at';
        break;
      default:
        break;
    }
    return !_this11.props.projectUnitID && column ? [{
      text: label + ' Date Ascending',
      icon: 'sort alphabet ascending',
      sortColumn: 'booking.' + column,
      sortDirection: 'asc'
    }, {
      text: label + ' Date Descending',
      icon: 'sort alphabet descending',
      sortColumn: 'booking.' + column,
      sortDirection: 'desc'
    }] : [];
  };

  this.bookingNoteToMarkdown = function (bNote) {
    try {
      var hasNoSpaces = bNote.indexOf(' ') === -1;
      if (hasNoSpaces) {
        return decodeURIComponent(bNote.replace(/\+/g, ' '));
      }
      return decodeURIComponent(bNote);
    } catch (e) {
      return bNote;
    }
  };

  this.bookingNoteToEditorState = function (bookingNote) {
    var mdValue = _this11.bookingNoteToMarkdown(bookingNote);
    if (mdValue) {
      var rawData = (0, _markdownDraftJs.markdownToDraft)(mdValue, {
        preserveNewlines: true,
        blockStyles: {
          ins_open: 'UNDERLINE'
        },
        remarkableOptions: {
          enable: {
            inline: 'ins'
          }
        }
      });
      var contentState = (0, _draftJs.convertFromRaw)(rawData);
      var editorState = _draftJs.EditorState.createWithContent(contentState);
      return editorState;
    }
    return _draftJs.EditorState.createEmpty();
  };

  this.bookingNoteFormated = function (bookingData) {
    if (!bookingData) return '';
    if (!bookingData.latestBookingNote) return bookingData.remarkInternal; // deprecated old field
    // convert markdown to draft-js and then back to plaintext properly with custom formatings.
    var editorState = _this11.bookingNoteToEditorState(bookingData.latestBookingNote);
    var contentState = editorState.getCurrentContent();
    var plainText = contentState.getPlainText();
    var maxLength = 180;
    if (plainText && plainText.length > maxLength) {
      plainText = plainText.substring(0, maxLength) + '...';
    }
    return plainText;
  };

  this.hasBookingNote = function (bookingData) {
    if (bookingData && (bookingData.latestBookingNote || bookingData.remarkInternal)) return true;
    return false;
  };

  this.renderStatusDateFilter = function () {
    var _state3 = _this11.state,
        bookingStatus = _state3.bookingStatus,
        loading = _state3.loading,
        isMobile = _state3.isMobile;

    var filter = '';
    var filterFrom = '';
    var filterTo = '';
    var headerText = '';
    switch (bookingStatus) {
      case 'cancelled_developer':
        filter = 'cancelledDateRange';
        filterFrom = 'cancelledDateFrom';
        filterTo = 'cancelledDateTo';
        headerText = 'Cancelled Date Range';
        break;
      case 'expired':
        filter = 'expiredDateRange';
        filterFrom = 'expiredDateFrom';
        filterTo = 'expiredDateTo';
        headerText = 'Expired Date Range';
        break;
      case 'booked':
        filter = 'bookedDateRange';
        filterFrom = 'bookedDateFrom';
        filterTo = 'bookedDateTo';
        headerText = 'Booked Date Range';
        break;
      case 'sold_spa_signed':
        filter = 'soldDateRange';
        filterFrom = 'soldDateFrom';
        filterTo = 'soldDateTo';
        headerText = 'Sold Date Range';
        break;
      default:
        break;
    }
    return filter && !_this11.props.projectUnitID && _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      {
        className: 'filter tight-column',
        mobile: 16,
        tablet: 5,
        computer: 5,
        style: { paddingBottom: isMobile ? '1rem' : '0rem' }
      },
      _react2.default.createElement(_UCBookingDatePicker2.default, {
        filterName: filter,
        filterNameFrom: filterFrom,
        filterNameTo: filterTo,
        headerText: (0, _i18next.t)(headerText, { ns: _translation.TRANSLATION_FILES.screens }),
        placeholder: (0, _i18next.t)('Select ' + headerText, { ns: _translation.TRANSLATION_FILES.screens }),
        dateFrom: _this11.state[filterFrom],
        dateTo: _this11.state[filterTo],
        onChange: _this11.handleFilterOnChange,
        onClose: _this11.handleClearFilter,
        onResetRange: _this11.handleClearFilter,
        onSetRange: function onSetRange(from, to) {
          return _this11.handleSetDateRange(filter, from, to);
        },
        value: _this11.state[filter],
        disabled: loading,
        label: (0, _i18next.t)(headerText, { ns: _translation.TRANSLATION_FILES.screens })
      })
    );
  };

  this.renderAgingTabsMobile = function () {
    var _state4 = _this11.state,
        currentTab = _state4.currentTab,
        tabss = _state4.tabss;
    var t = _this11.props.t;

    return _react2.default.createElement(_semanticUiReact.Dropdown, {
      className: 'uc-dropdown-show-all-items',
      fluid: true,
      selection: true,
      floating: true,
      options: tabss.map(function (tab) {
        return {
          key: tab.name,
          value: tab.name,
          text: (0, _strings.titleCase)(t(tab.text, { ns: _translation.namespaces[tab.name === 'all' ? 1 : 0] }))
        };
      }),
      value: currentTab,
      onChange: _this11.handleChangeTab
    });
  };

  this.renderDefaultClearFilter = function () {
    var isMobile = _this11.state.isMobile;
    var t = _this11.props.t;

    return (_this11.getAllFilterNames(false).some(function (filterName) {
      return _this11.state[filterName] && _this11.state[filterName].length > 0;
    }) || _this11.state.search.length > 0) && _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { style: { paddingBottom: '0rem', paddingTop: isMobile ? '0rem' : '1rem' } },
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        {
          verticalAlign: 'middle'
        },
        _react2.default.createElement(_semanticUiReact.Button, {
          className: 'uc-clear-button',
          content: t('Clear all', { ns: _translation.TRANSLATION_FILES.translation }),
          onClick: function onClick() {
            return _this11.handleClearFilter.apply(_this11, _toConsumableArray(_this11.getAllFilterNames(false)));
          }
        })
      )
    );
  };

  this.renderAccordionDefaultView = function (searchAreas) {
    var _props4 = _this11.props,
        projectUnitID = _props4.projectUnitID,
        t = _props4.t;
    var _state5 = _this11.state,
        currentTab = _state5.currentTab,
        loading = _state5.loading,
        loadingProjectSearch = _state5.loadingProjectSearch,
        activeAccordionIndex = _state5.activeAccordionIndex,
        isTablet = _state5.isTablet,
        isMobile = _state5.isMobile;

    var isCurrentTabAll = currentTab === 'all';
    var isCurrentTabUnit = currentTab === 'aging_by_units';
    var isCurrentTabBanker = currentTab === 'aging_by_bankers';
    var isCurrentTabLawyer = currentTab === 'aging_by_lawyers';
    return _react2.default.createElement(
      _semanticUiReact.Accordion,
      { fluid: true, className: 'uc-accordion shadow-border', style: { paddingBottom: !isMobile && activeAccordionIndex !== 0 ? '1.5rem' : '0.5rem' } },
      _react2.default.createElement(
        _semanticUiReact.Accordion.Title,
        {
          style: { paddingBottom: '1rem' },
          active: activeAccordionIndex === 0,
          index: 0
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 'equal', style: { paddingBottom: activeAccordionIndex === 0 ? '1rem' : '0rem' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'tight-column',
                tablet: 5,
                computer: 5
              },
              _react2.default.createElement(_UCSearchIn2.default, {
                isLoading: loading,
                onChange: _this11.handleFilterOnChange,
                onSearchInChange: _this11.handleFilterOnChange,
                onClear: _this11.handleClearFilter,
                search: _this11.state.search,
                searchIn: _this11.state.searchIn,
                options: searchAreas,
                isFullSize: !isCurrentTabBanker && !projectUnitID,
                label: t('Keywords', { ns: _translation.TRANSLATION_FILES.screens })
              })
            ),
            !projectUnitID && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter tight-column',
                tablet: 5,
                computer: 5
              },
              _react2.default.createElement(
                'div',
                { className: 'field' },
                _react2.default.createElement(
                  'label',
                  {
                    className: 'ui',
                    htmlFor: 'projectFilter',
                    style: { fontWeight: 'bold', margin: '0 0 0.28571429rem 0', fontSize: '.92857143em', display: 'block' }
                  },
                  t('Projects', { ns: _translation.TRANSLATION_FILES.screens })
                ),
                _react2.default.createElement(_semanticUiReact.Dropdown, {
                  fluid: true,
                  search: true,
                  selection: true,
                  floating: true,
                  disabled: loading || loadingProjectSearch,
                  loading: loadingProjectSearch,
                  multiple: !isCurrentTabLawyer,
                  name: 'projectFilter',
                  onChange: _this11.handleFilterProjects,
                  options: _this11.state.projectOpts,
                  placeholder: t('Find Project'),
                  value: !isCurrentTabLawyer ? _this11.state.filteredProjects : _this11.state.filteredProjects[0] || '',
                  noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                })
              )
            ),
            isCurrentTabAll && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter tight-column',
                tablet: 5,
                computer: 5
              },
              _react2.default.createElement(_UCBookingSelectListMultiple.BookingSelectListMultiple, {
                filterName: 'bookingStatusMulti',
                onChange: _this11.handleFilterOnChange,
                onClose: _this11.handleClearFilter,
                options: (0, _bookingStatuses.bookingStatusesAll)(_this11.showPendingCancellation()).map(function (_ref17) {
                  var value = _ref17.value,
                      text = _ref17.text;
                  return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                }),
                placeholder: t('Booking Status'),
                value: _this11.state.bookingStatusMulti,
                disabled: loading,
                label: t('Booking Status', { ns: _translation.TRANSLATION_FILES.screens })
              })
            ),
            isCurrentTabUnit && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter tight-column',
                tablet: 5,
                computer: 5
              },
              _react2.default.createElement(_UCBookingSelectListMultiple.BookingSelectListMultiple, {
                filterName: 'bookingStatusMulti',
                onChange: _this11.handleFilterOnChange,
                onClose: _this11.handleClearFilter,
                options: (0, _bookingStatuses.bookingStatusesAll)(_this11.showPendingCancellation()).map(function (_ref18) {
                  var value = _ref18.value,
                      text = _ref18.text;
                  return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                }),
                placeholder: t('Booking Status'),
                value: _this11.state.bookingStatusMulti,
                disabled: loading,
                label: t('Booking Status', { ns: _translation.TRANSLATION_FILES.screens })
              })
            ),
            isCurrentTabBanker && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter tight-column',
                tablet: 5,
                computer: 5
              },
              _react2.default.createElement(_UCBookingSelectListMultiple.BookingSelectListMultiple, {
                filterName: 'loanStatus',
                onChange: _this11.handleFilterOnChange,
                onClose: _this11.handleClearFilter,
                options: _this11.loanStatuses.map(function (_ref19) {
                  var value = _ref19.value,
                      text = _ref19.text;
                  return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                }),
                placeholder: t('Loan Status'),
                value: _this11.state.loanStatus,
                disabled: loading,
                label: t('Loan Status', { ns: _translation.TRANSLATION_FILES.screens })
              })
            ),
            isCurrentTabLawyer && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter tight-column',
                tablet: 5,
                computer: 5
              },
              _react2.default.createElement(_UCBookingSelectList.BookingSelectList, {
                filterName: 'lawyerCaseType',
                onChange: _this11.handleFilterOnChange,
                onClose: _this11.handleClearFilter,
                options: _lawyerCaseStatuses.LAWYER_CASE_TYPES.map(function (_ref20) {
                  var value = _ref20.value,
                      text = _ref20.text;
                  return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                }),
                placeholder: t('Case Type'),
                value: _this11.state.lawyerCaseType,
                disabled: loading,
                label: t('Case Type', { ns: _translation.TRANSLATION_FILES.screens })
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 1, style: { paddingLeft: isTablet ? '0rem' : '0.7rem' }, textAlign: 'left' },
              _react2.default.createElement(_semanticUiReact.Popup, {
                size: 'tiny',
                style: { backgroundColor: '#596975' },
                basic: true,
                inverted: true,
                content: activeAccordionIndex === 0 ? t('Collapse', { ns: _translation.TRANSLATION_FILES.translation }) : t('Expand', { ns: _translation.TRANSLATION_FILES.translation }),
                position: 'bottom center',
                trigger: _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    icon: true,
                    circular: true,
                    onClick: function onClick(e) {
                      return _this11.handleAccordionClick(e, { index: activeAccordionIndex === 0 ? -1 : 0 });
                    },
                    className: 'uc-accordion-toggle-btn ' + (activeAccordionIndex === 0 ? 'rotated' : '')
                  },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron down' })
                )
              })
            )
          ),
          activeAccordionIndex !== 0 && _this11.renderDefaultClearFilter()
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Transition,
        { visible: activeAccordionIndex === 0, animation: 'slide down', duration: 200 },
        _react2.default.createElement(
          _semanticUiReact.Accordion.Content,
          { active: activeAccordionIndex === 0, style: { paddingBottom: '2rem' } },
          _react2.default.createElement(
            _semanticUiReact.Grid
            // className="filters booking"
            ,
            { textAlign: 'left',
              verticalAlign: 'middle'
            },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { style: { paddingBottom: '0rem' } },
              isCurrentTabAll && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter tight-column',
                  tablet: 5,
                  computer: 5
                },
                _react2.default.createElement(_UCBookingSelectListMultiple.BookingSelectListMultiple, {
                  filterName: 'paymentStatus',
                  onChange: _this11.handleFilterOnChange,
                  onClose: _this11.handleClearFilter,
                  options: _paymentStatuses2.default.map(function (_ref21) {
                    var value = _ref21.value,
                        text = _ref21.text;
                    return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                  }),
                  placeholder: t('Payment Status'),
                  value: _this11.state.paymentStatus,
                  disabled: loading,
                  label: t('Payment Status', { ns: _translation.TRANSLATION_FILES.screens })
                })
              ),
              isCurrentTabAll && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter tight-column',
                  tablet: 5,
                  computer: 5
                },
                _react2.default.createElement(_UCBookingDatePicker2.default, {
                  filterName: 'dateRange',
                  filterNameFrom: 'dateFrom',
                  filterNameTo: 'dateTo',
                  headerText: t('Created Date Range'),
                  placeholder: t('Select Created Date Range'),
                  dateFrom: _this11.state.dateFrom,
                  dateTo: _this11.state.dateTo,
                  onChange: _this11.handleFilterOnChange,
                  onClose: _this11.handleClearFilter,
                  onResetRange: _this11.handleClearFilter,
                  onSetRange: function onSetRange(from, to) {
                    return _this11.handleSetDateRange('dateRange', from, to);
                  },
                  value: _this11.state.dateRange,
                  disabled: loading,
                  label: t('Created Date Range')
                })
              ),
              _this11.renderStatusDateFilter(),
              isCurrentTabUnit && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter tight-column',
                  tablet: 5,
                  computer: 5
                },
                _react2.default.createElement(_UCBookingSelectList.BookingSelectList, {
                  filterName: 'agingRange',
                  onChange: _this11.handleFilterOnChange,
                  onClose: _this11.handleClearFilter,
                  options: _this11.agingRanges.map(function (_ref22) {
                    var value = _ref22.value,
                        text = _ref22.text;
                    return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                  }),
                  placeholder: t('Aging Range'),
                  value: _this11.state.agingRange,
                  disabled: loading,
                  label: t('Aging Range', { ns: _translation.TRANSLATION_FILES.screens })
                })
              ),
              isCurrentTabLawyer && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter tight-column',
                  tablet: 5,
                  computer: 5
                },
                _react2.default.createElement(_UCBookingSelectList.BookingSelectList, {
                  filterName: 'lawyerCaseStatus',
                  onChange: _this11.handleFilterOnChange,
                  onClose: _this11.handleClearFilter,
                  options: (0, _lawyerCaseStatuses.getLawyerCaseStatuses)(_this11.state.lawyerCaseType).map(function (_ref23) {
                    var value = _ref23.value,
                        text = _ref23.text;
                    return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                  }),
                  placeholder: t('Case Status'),
                  value: _this11.state.lawyerCaseStatus,
                  disabled: loading,
                  label: t('Case Status', { ns: _translation.TRANSLATION_FILES.screens })
                })
              ),
              currentTab !== 'all' && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter tight-column',
                  tablet: 5,
                  computer: 5
                },
                _react2.default.createElement(_UCBookingSelectList.BookingSelectList, {
                  filterName: 'agingDuration',
                  onChange: _this11.handleFilterOnChange,
                  onClose: _this11.handleClearFilter,
                  options: _dateRanges.AGING_DATE_RANGE.map(function (_ref24) {
                    var value = _ref24.value,
                        text = _ref24.text;
                    return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                  }),
                  placeholder: t('Duration'),
                  value: _this11.state.agingDuration,
                  disabled: loading,
                  label: t('Duration', { ns: _translation.TRANSLATION_FILES.screens })
                })
              )
            ),
            _this11.renderDefaultClearFilter()
          )
        )
      )
    );
  };

  this.renderAccordionMobileView = function (searchAreas) {
    var _props5 = _this11.props,
        projectUnitID = _props5.projectUnitID,
        t = _props5.t;
    var _state6 = _this11.state,
        currentTab = _state6.currentTab,
        loading = _state6.loading,
        loadingProjectSearch = _state6.loadingProjectSearch,
        activeAccordionIndex = _state6.activeAccordionIndex;

    var isCurrentTabAll = currentTab === 'all';
    var isCurrentTabUnit = currentTab === 'aging_by_units';
    var isCurrentTabBanker = currentTab === 'aging_by_bankers';
    var isCurrentTabLawyer = currentTab === 'aging_by_lawyers';
    return _react2.default.createElement(
      _semanticUiReact.Accordion,
      { fluid: true, className: 'uc-accordion shadow-border' },
      _react2.default.createElement(
        _semanticUiReact.Accordion.Title,
        {
          // style={{ paddingBottom: '1rem' }}
          active: activeAccordionIndex === 0,
          index: 0
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                style: { paddingBottom: activeAccordionIndex !== 0 ? '1rem' : '0rem' },
                width: 16
              },
              _react2.default.createElement(_UCSearchIn2.default, {
                isLoading: loading,
                onChange: _this11.handleFilterOnChange,
                onSearchInChange: _this11.handleFilterOnChange,
                onClear: _this11.handleClearFilter,
                search: _this11.state.search,
                searchIn: _this11.state.searchIn,
                options: searchAreas,
                isFullSize: !isCurrentTabBanker && !projectUnitID,
                label: t('Keywords', { ns: _translation.TRANSLATION_FILES.screens })
              })
            ),
            activeAccordionIndex !== 0 && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, textAlign: 'center' },
              _react2.default.createElement(_semanticUiReact.Popup, {
                size: 'tiny',
                style: { backgroundColor: '#596975' },
                basic: true,
                inverted: true,
                content: activeAccordionIndex === 0 ? t('Collapse') : t('Expand'),
                position: 'bottom center',
                trigger: _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    onClick: function onClick(e) {
                      return _this11.handleAccordionClick(e, { index: activeAccordionIndex === 0 ? -1 : 0 });
                    },
                    className: 'uc-accordion-toggle-btn'
                  },
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', alignItems: 'center', gap: '6px' } },
                    _react2.default.createElement(
                      'span',
                      { style: { fontSize: '12px', fontWeight: '400' } },
                      t('More')
                    ),
                    _react2.default.createElement(_semanticUiReact.Icon, { style: { fontSize: '12px', fontWeight: '400' }, name: 'chevron down' })
                  )
                )
              })
            )
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Transition,
        { visible: activeAccordionIndex === 0, animation: 'slide down', duration: 200 },
        _react2.default.createElement(
          _semanticUiReact.Accordion.Content,
          { active: activeAccordionIndex === 0 },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            {
              textAlign: 'left',
              verticalAlign: 'middle'
            },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { style: { paddingBottom: '0rem' } },
              !projectUnitID && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter',
                  width: 16,
                  style: { paddingBottom: '1rem' }
                },
                _react2.default.createElement(
                  'div',
                  { className: 'field' },
                  _react2.default.createElement(
                    'label',
                    {
                      className: 'ui',
                      htmlFor: 'projectFilter',
                      style: { fontWeight: 'bold', margin: '0 0 0.28571429rem 0', fontSize: '.92857143em', display: 'block' }
                    },
                    t('Projects', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(_semanticUiReact.Dropdown, {
                    fluid: true,
                    search: true,
                    selection: true,
                    floating: true,
                    disabled: loading || loadingProjectSearch,
                    loading: loadingProjectSearch,
                    multiple: !isCurrentTabLawyer,
                    name: 'projectFilter',
                    onChange: _this11.handleFilterProjects,
                    options: _this11.state.projectOpts,
                    placeholder: t('Find Project'),
                    value: !isCurrentTabLawyer ? _this11.state.filteredProjects : _this11.state.filteredProjects[0] || ''
                  })
                )
              ),
              isCurrentTabAll && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter',
                  width: 16,
                  style: { paddingBottom: '1rem' }
                },
                _react2.default.createElement(_UCBookingSelectListMultiple.BookingSelectListMultiple, {
                  filterName: 'bookingStatusMulti',
                  onChange: _this11.handleFilterOnChange,
                  onClose: _this11.handleClearFilter,
                  options: (0, _bookingStatuses.bookingStatusesAll)(_this11.showPendingCancellation()).map(function (_ref25) {
                    var value = _ref25.value,
                        text = _ref25.text;
                    return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                  }),
                  placeholder: t('Booking Status'),
                  value: _this11.state.bookingStatusMulti,
                  disabled: loading,
                  label: t('Booking Status', { ns: _translation.TRANSLATION_FILES.screens })
                })
              ),
              isCurrentTabAll && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter',
                  width: 16,
                  style: { paddingBottom: '1rem' }
                },
                _react2.default.createElement(_UCBookingSelectListMultiple.BookingSelectListMultiple, {
                  filterName: 'paymentStatus',
                  onChange: _this11.handleFilterOnChange,
                  onClose: _this11.handleClearFilter,
                  options: _paymentStatuses2.default.map(function (_ref26) {
                    var value = _ref26.value,
                        text = _ref26.text;
                    return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                  }),
                  placeholder: t('Payment Status'),
                  value: _this11.state.paymentStatus,
                  disabled: loading,
                  label: t('Payment Status', { ns: _translation.TRANSLATION_FILES.screens })
                })
              ),
              isCurrentTabUnit && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter',
                  width: 16,
                  style: { paddingBottom: '1rem' }
                },
                _react2.default.createElement(_UCBookingSelectListMultiple.BookingSelectListMultiple, {
                  filterName: 'bookingStatusMulti',
                  onChange: _this11.handleFilterOnChange,
                  onClose: _this11.handleClearFilter,
                  options: (0, _bookingStatuses.bookingStatusesAll)(_this11.showPendingCancellation()).map(function (_ref27) {
                    var value = _ref27.value,
                        text = _ref27.text;
                    return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                  }),
                  placeholder: t('Booking Status'),
                  value: _this11.state.bookingStatusMulti,
                  disabled: loading,
                  label: t('Booking Status', { ns: _translation.TRANSLATION_FILES.screens })
                })
              ),
              isCurrentTabBanker && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter',
                  width: 16,
                  style: { paddingBottom: '1rem' }
                },
                _react2.default.createElement(_UCBookingSelectListMultiple.BookingSelectListMultiple, {
                  filterName: 'loanStatus',
                  onChange: _this11.handleFilterOnChange,
                  onClose: _this11.handleClearFilter,
                  options: _this11.loanStatuses.map(function (_ref28) {
                    var value = _ref28.value,
                        text = _ref28.text;
                    return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                  }),
                  placeholder: t('Loan Status'),
                  value: _this11.state.loanStatus,
                  disabled: loading,
                  label: t('Loan Status', { ns: _translation.TRANSLATION_FILES.screens })
                })
              ),
              isCurrentTabLawyer && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter',
                  width: 16,
                  style: { paddingBottom: '1rem' }
                },
                _react2.default.createElement(_UCBookingSelectList.BookingSelectList, {
                  filterName: 'lawyerCaseType',
                  onChange: _this11.handleFilterOnChange,
                  onClose: _this11.handleClearFilter,
                  options: _lawyerCaseStatuses.LAWYER_CASE_TYPES.map(function (_ref29) {
                    var value = _ref29.value,
                        text = _ref29.text;
                    return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                  }),
                  placeholder: t('Case Type'),
                  value: _this11.state.lawyerCaseType,
                  disabled: loading,
                  label: t('Case Type', { ns: _translation.TRANSLATION_FILES.screens })
                })
              ),
              isCurrentTabAll && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter',
                  width: 16,
                  style: { paddingBottom: '1rem' }
                },
                _react2.default.createElement(_UCBookingDatePicker2.default, {
                  filterName: 'dateRange',
                  filterNameFrom: 'dateFrom',
                  filterNameTo: 'dateTo',
                  headerText: t('Created Date Range'),
                  placeholder: t('Select Created Date Range', { ns: _translation.TRANSLATION_FILES.screens }),
                  dateFrom: _this11.state.dateFrom,
                  dateTo: _this11.state.dateTo,
                  onChange: _this11.handleFilterOnChange,
                  onClose: _this11.handleClearFilter,
                  onResetRange: _this11.handleClearFilter,
                  onSetRange: function onSetRange(from, to) {
                    return _this11.handleSetDateRange('dateRange', from, to);
                  },
                  value: _this11.state.dateRange,
                  disabled: loading,
                  label: t('Created Date Range', { ns: _translation.TRANSLATION_FILES.screens })
                })
              ),
              _this11.renderStatusDateFilter(),
              isCurrentTabUnit && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter',
                  width: 16,
                  style: { paddingBottom: '1rem' }
                },
                _react2.default.createElement(_UCBookingSelectList.BookingSelectList, {
                  filterName: 'agingRange',
                  onChange: _this11.handleFilterOnChange,
                  onClose: _this11.handleClearFilter,
                  options: _this11.agingRanges.map(function (_ref30) {
                    var value = _ref30.value,
                        text = _ref30.text;
                    return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                  }),
                  placeholder: t('Aging Range'),
                  value: _this11.state.agingRange,
                  disabled: loading,
                  label: t('Aging Range', { ns: _translation.TRANSLATION_FILES.screens })
                })
              ),
              isCurrentTabLawyer && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter',
                  width: 16,
                  style: { paddingBottom: '1rem' }
                },
                _react2.default.createElement(_UCBookingSelectList.BookingSelectList, {
                  filterName: 'lawyerCaseStatus',
                  onChange: _this11.handleFilterOnChange,
                  onClose: _this11.handleClearFilter,
                  options: (0, _lawyerCaseStatuses.getLawyerCaseStatuses)(_this11.state.lawyerCaseType).map(function (_ref31) {
                    var value = _ref31.value,
                        text = _ref31.text;
                    return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                  }),
                  placeholder: t('Case Status'),
                  value: _this11.state.lawyerCaseStatus,
                  disabled: loading,
                  label: t('Case Status', { ns: _translation.TRANSLATION_FILES.screens })
                })
              ),
              currentTab !== 'all' && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter',
                  width: 16,
                  style: { paddingBottom: '1rem' }
                },
                _react2.default.createElement(_UCBookingSelectList.BookingSelectList, {
                  filterName: 'agingDuration',
                  onChange: _this11.handleFilterOnChange,
                  onClose: _this11.handleClearFilter,
                  options: _dateRanges.AGING_DATE_RANGE.map(function (_ref32) {
                    var value = _ref32.value,
                        text = _ref32.text;
                    return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                  }),
                  placeholder: t('Duration'),
                  value: _this11.state.agingDuration,
                  disabled: loading,
                  label: t('Duration', { ns: _translation.TRANSLATION_FILES.screens })
                })
              )
            ),
            _this11.renderDefaultClearFilter(),
            activeAccordionIndex === 0 && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, style: { paddingTop: '0rem' }, textAlign: 'center' },
              _react2.default.createElement(_semanticUiReact.Popup, {
                size: 'tiny',
                style: { backgroundColor: '#596975' },
                basic: true,
                inverted: true,
                content: activeAccordionIndex === 0 ? t('Collapse') : t('Expand'),
                position: 'bottom center',
                trigger: _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    onClick: function onClick(e) {
                      return _this11.handleAccordionClick(e, { index: activeAccordionIndex === 0 ? -1 : 0 });
                    },
                    className: 'uc-accordion-toggle-btn'
                  },
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', alignItems: 'center', gap: '6px' } },
                    _react2.default.createElement(
                      'span',
                      { style: { fontSize: '12px', fontWeight: '400' } },
                      t('Less')
                    ),
                    _react2.default.createElement(_semanticUiReact.Icon, { style: { fontSize: '12px', fontWeight: '400' }, name: 'chevron up' })
                  )
                )
              })
            )
          )
        )
      )
    );
  };

  this.renderMenuTool = function () {
    var _props6 = _this11.props,
        projectUnitID = _props6.projectUnitID,
        t = _props6.t;
    var _state7 = _this11.state,
        currentTab = _state7.currentTab,
        loading = _state7.loading,
        loadingProjectSearch = _state7.loadingProjectSearch,
        isChanging = _state7.isChanging,
        isMobile = _state7.isMobile,
        isComputer = _state7.isComputer,
        isTablet = _state7.isTablet;

    var isCurrentTabAll = currentTab === 'all';
    var isCurrentTabUnit = currentTab === 'aging_by_units';
    var isCurrentTabBanker = currentTab === 'aging_by_bankers';
    var isCurrentTabLawyer = currentTab === 'aging_by_lawyers';
    var searchAreas = isCurrentTabLawyer ? [{ value: 'all', text: t('All', { ns: _translation.TRANSLATION_FILES.constants }) }, { value: 'lawyer', text: t('Lawyer') }, { value: 'firm', text: t('Law Firm') }] : [{ value: 'all', text: t('All', { ns: _translation.TRANSLATION_FILES.constants }) }, { value: 'booking.assigned_ma_preferred_name', text: t('Assigned staff') }, { value: isCurrentTabBanker ? 'affiliate.name' : 'booking.ma_created_by_preferred_name', text: isCurrentTabBanker ? t('Reserved by') : (0, _vietnam.createdByLabel)(_this11.props.auth, t, t('Reserved by')) }, { value: isCurrentTabBanker ? 'company_branch.name' : 'booking.ma_user_affiliate_company_branch_short_name', text: t('Business Unit') }];
    if (isCurrentTabBanker) {
      searchAreas.push({ value: 'bankers.name', text: t('Banker') }, { value: 'banks.name,banks.short_name', text: t('Bank') });
    }
    var statusTabs = (0, _bookingStatuses.bookingStatusesTabs)(_this11.showPendingCancellation());
    return _react2.default.createElement(
      _semanticUiReact.Grid,
      { columns: 'equal' },
      isCurrentTabAll && _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          isMobile ? _react2.default.createElement(_UCBookingStatusDropdown2.default, {
            options: statusTabs.map(function (status) {
              return {
                key: status.value,
                value: status.value,
                count: _this11.getStatusCount(status.value),
                valueLabel: t(status.text, { ns: _translation.TRANSLATION_FILES.constants }),
                className: status.className
              };
            }),
            onChange: function onChange(e) {
              if (e === 'total') {
                _this11.handleReplaceStatus();
              } else {
                _this11.handleReplaceStatus(e);
              }
            },
            value: _this11.state.bookingStatus === '' ? statusTabs[0].value : _this11.state.bookingStatus
          }) : _react2.default.createElement(
            _semanticUiReact.Grid,
            {
              className: 'status',
              columns: 'equal',
              textAlign: 'left',
              verticalAlign: 'bottom'
            },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { style: { paddingTop: 0 } },
              statusTabs.map(function (status, key) {
                return _react2.default.createElement(_UCFixedBarStatus2.default, {
                  key: key,
                  className: status.className,
                  status: status.value,
                  name: t(status.text, { ns: _translation.TRANSLATION_FILES.constants }),
                  count: _this11.getStatusCount(status.value),
                  selected: _this11.getSelectedStatus(status.value),
                  onClick: status.value === 'total' ? function () {
                    return _this11.handleReplaceStatus();
                  } : _this11.handleReplaceStatus
                });
              })
            )
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        null,
        isMobile ? _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 16 },
          _this11.renderAccordionMobileView(searchAreas)
        ) : _this11.renderAccordionDefaultView(searchAreas)
      )
    );
  };

  this.renderStatusDateCell = function (isHeader) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var t = _this11.props.t;
    var bookingStatus = _this11.state.bookingStatus;

    var label = '';
    var date = '';
    switch (bookingStatus) {
      case 'cancelled_developer':
        label = 'Cancelled';
        date = data.lastCancelledDeveloperAt;
        break;
      case 'expired':
        label = 'Expired';
        date = data.lastExpiredAt;
        break;
      case 'booked':
        label = 'Booked';
        date = data.lastBookedAt;
        break;
      case 'sold_spa_signed':
        label = 'Sold';
        date = data.lastSoldAt;
        break;
      default:
        break;
    }
    if (isHeader) {
      return _react2.default.createElement(
        'span',
        null,
        t('Created'),
        !_this11.props.projectUnitID && label && _react2.default.createElement(
          'span',
          null,
          '\xA0&',
          _react2.default.createElement('br', null),
          t(label, { ns: _translation.TRANSLATION_FILES.constants })
        )
      );
    }
    return !_this11.props.projectUnitID && date && _react2.default.createElement(
      'small',
      null,
      _react2.default.createElement(_Timestamp2.default, {
        timestamp: date,
        format: 'DD/M/YYYY'
      })
    );
  };

  this.renderTableHeaders = function (sortItems) {
    var _props7 = _this11.props,
        projectUnitID = _props7.projectUnitID,
        t = _props7.t;
    var currentTab = _this11.state.currentTab;

    var isCurrentTabAll = currentTab === 'all';
    var isCurrentTabUnit = currentTab === 'aging_by_units';
    var isCurrentTabBanker = currentTab === 'aging_by_bankers';
    var isCurrentTabLawyer = currentTab === 'aging_by_lawyers';
    return _react2.default.createElement(
      _semanticUiReact.Table.Header,
      { className: 'mobile-hide' },
      _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        !isCurrentTabAll && _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            sorted: _this11.cellCheckSorted(sortItems[isCurrentTabLawyer ? 8 : 10].sortColumn, isCurrentTabLawyer),
            onClick: function onClick() {
              return _this11.handleCellSort(sortItems[isCurrentTabLawyer ? 8 : 10].sortColumn);
            }
          },
          t('Days')
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            sorted: _this11.cellCheckSorted(sortItems[0].sortColumn),
            onClick: function onClick() {
              return _this11.handleCellSort(sortItems[0].sortColumn);
            }
          },
          _this11.renderStatusDateCell(true)
        ),
        _this11.showProjectColumn() ? _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          { className: 'mobile-hide' },
          t('Project', { ns: _translation.TRANSLATION_FILES.screens })
        ) : null,
        !projectUnitID ? _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            sorted: _this11.cellCheckSorted(sortItems[2].sortColumn),
            onClick: function onClick() {
              return _this11.handleCellSort(sortItems[2].sortColumn);
            }
          },
          t('Unit')
        ) : null,
        _this11.showBookingIDColumn() ? _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          { className: 'mobile-hide' },
          t('Booking ID', { ns: _translation.TRANSLATION_FILES.translation })
        ) : null,
        isCurrentTabAll ? _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          { className: 'mobile-hide' },
          t('Customer')
        ) : null,
        !isCurrentTabLawyer && _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            sorted: _this11.cellCheckSorted(sortItems[6].sortColumn),
            onClick: function onClick() {
              return _this11.handleCellSort(sortItems[6].sortColumn);
            }
          },
          isCurrentTabBanker ? t('Reserved by') : (0, _vietnam.createdByLabel)(_this11.props.auth, t, t('Reserved by'))
        ),
        isCurrentTabLawyer && _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            sorted: _this11.cellCheckSorted(sortItems[10].sortColumn),
            onClick: function onClick() {
              return _this11.handleCellSort(sortItems[10].sortColumn);
            }
          },
          t('Purchaser')
        ),
        isCurrentTabLawyer && _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            sorted: _this11.cellCheckSorted(sortItems[6].sortColumn),
            onClick: function onClick() {
              return _this11.handleCellSort(sortItems[6].sortColumn);
            }
          },
          t('Type')
        ),
        isCurrentTabBanker && _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            sorted: _this11.cellCheckSorted(sortItems[12].sortColumn),
            onClick: function onClick() {
              return _this11.handleCellSort(sortItems[12].sortColumn);
            }
          },
          t('Banker')
        ),
        isCurrentTabLawyer && _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            sorted: isCurrentTabLawyer ? null : _this11.cellCheckSorted(sortItems[4].sortColumn),
            onClick: isCurrentTabLawyer ? null : function () {
              return _this11.handleCellSort(sortItems[4].sortColumn);
            }
          },
          t('Lawyer')
        ),
        isCurrentTabBanker && _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            collapsing: true,
            sorted: _this11.cellCheckSorted(sortItems[14].sortColumn),
            onClick: function onClick() {
              return _this11.handleCellSort(sortItems[14].sortColumn);
            }
          },
          t('Bank')
        ),
        !isCurrentTabLawyer && _this11.hasInternalDEAccess() ? _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            sorted: _this11.cellCheckSorted(sortItems[8].sortColumn),
            onClick: function onClick() {
              return _this11.handleCellSort(sortItems[8].sortColumn);
            }
          },
          t('Assigned staff')
        ) : null,
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          {
            collapsing: true,
            sorted: _this11.cellCheckSorted(sortItems[4].sortColumn),
            onClick: function onClick() {
              return _this11.handleCellSort(sortItems[4].sortColumn);
            },
            className: 'uc-sticky-col uc-right'
          },
          t('Status')
        ),
        _this11.showCancellationReasonColumn() ? _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          { className: 'mobile-hide' },
          t('Cancellation reason', { ns: _translation.TRANSLATION_FILES.translation })
        ) : null,
        !(isCurrentTabBanker || isCurrentTabLawyer) && _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          { collapsing: true, className: 'uc-sticky-col uc-right' },
          t('Progress')
        )
      )
    );
  };

  this.renderProgressCell = function (data) {
    var t = _this11.props.t;
    var _state8 = _this11.state,
        systemData = _state8.systemData,
        projectArData = _state8.projectArData,
        isComputer = _state8.isComputer,
        isMobile = _state8.isMobile;

    var iconSize = !isMobile ? 18 : 20;
    var project = projectArData.find(function (p) {
      return p.id === data.project.id;
    }) || {};
    var isAutoReleaseTimerEnabled = _this11.checkAutoReleaseTimer(data, project);
    var createdAt = (0, _momentTimezone2.default)(data.createdAt);
    var systemTimer = systemData.arBookingExpMoreThanMinutes !== '' && systemData.arBookingExpMoreThanMinutes !== '0';
    var secondsBeforeExpired = systemTimer ? Number(systemData.arBookingExpMoreThanMinutes) * 60 : Number(project.arBookingExpMoreThanMinutes) * 60;
    var endAt = createdAt.clone().add(secondsBeforeExpired, 'seconds');
    var currentPercent = (0, _time.getProgressPercent)(createdAt, Date.now(), endAt);
    var afterProjectSettingDate = (0, _momentTimezone2.default)(project.arBookingStartDate).diff((0, _momentTimezone2.default)(createdAt)) <= 0;
    var enabledForBookingStartDate = !project.arBookingAllUnderReserved && project.arBookingStartDate && afterProjectSettingDate;
    var isOutsideAutoReleaseTimer = (0, _momentTimezone2.default)().isBefore(createdAt) || (0, _momentTimezone2.default)().isAfter(endAt);
    var autoReleaseIcon = _react2.default.createElement('img', {
      src: isAutoReleaseTimerEnabled && !isOutsideAutoReleaseTimer && (project.arBookingAllUnderReserved || enabledForBookingStartDate) ? currentPercent < 80 ? _clock_yellow2.default : currentPercent >= 80 && currentPercent < 100 ? _clock_red2.default : _clock_disabled2.default : _clock_disabled2.default,
      width: iconSize,
      alt: 'auto release'
    });
    var noteIcon = _react2.default.createElement('img', {
      src: _this11.hasBookingNote(data) ? _notes2.default : _notes_disabled2.default,
      width: iconSize,
      alt: 'notes'
    });
    var paymentIcon = _react2.default.createElement('img', {
      src: _this11.getPaymentIcon(data.paymentStatus.id),
      width: iconSize,
      alt: 'payment'
    });
    var loanIcon = _react2.default.createElement('img', {
      src: data.bankCaseCount > 0 ? _loan2.default : _loan_disabled2.default,
      width: iconSize,
      alt: 'loan'
    });
    return _react2.default.createElement(
      'div',
      { className: 'verticalAlign-mid', style: { display: 'inline-flex', justifyContent: 'start', gap: !isMobile ? '16px' : '0px' } },
      _react2.default.createElement(_UCBPopup2.default, {
        touchAsClicked: !isComputer,
        trigger: !isMobile ? autoReleaseIcon : _react2.default.createElement(_semanticUiReact.Button, {
          className: 'uc-icon-button',
          icon: autoReleaseIcon
        }),
        content: t('Auto Release') + ': ' + (isAutoReleaseTimerEnabled && !isOutsideAutoReleaseTimer && (project.arBookingAllUnderReserved || enabledForBookingStartDate) ? currentPercent === 100 ? '--' : (0, _time.getRemainingTimeSimple)(endAt) : t('None', { ns: _translation.TRANSLATION_FILES.constants }))
      }),
      _react2.default.createElement(_UCBPopup2.default, {
        touchAsClicked: !isComputer,
        trigger: !isMobile ? noteIcon : _react2.default.createElement(_semanticUiReact.Button, {
          className: 'uc-icon-button',
          icon: noteIcon
        }),
        content: t('Note') + ': ' + (_this11.hasBookingNote(data) ? _this11.bookingNoteFormated(data) : '--')
      }),
      data.paymentStatus && _react2.default.createElement(_UCBPopup2.default, {
        touchAsClicked: !isComputer,
        trigger: !isMobile ? paymentIcon : _react2.default.createElement(_semanticUiReact.Button, {
          className: 'uc-icon-button',
          icon: paymentIcon
        }),
        content: t('Payment') + ': ' + t(data.paymentStatus.name, { ns: _translation.TRANSLATION_FILES.constants })
      }),
      _react2.default.createElement(_UCBPopup2.default, {
        touchAsClicked: !isComputer,
        trigger: !isMobile ? loanIcon : _react2.default.createElement(_semanticUiReact.Button, {
          className: 'uc-icon-button',
          icon: loanIcon
        }),
        content: data.bankCaseCount > 0 && data.bankCasesStatuses ? _react2.default.createElement(
          'div',
          { style: { display: 'inline-flex', flexDirection: 'column', rowGap: '0.5em' } },
          _react2.default.createElement(
            'span',
            null,
            t('Loan'),
            ':'
          ),
          data.bankCasesStatuses.map(function (bcs, i) {
            return _react2.default.createElement(
              _semanticUiReact.List.Item,
              { key: i },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle', color: _this11.getBankCaseStatusColor(bcs.status) || '' }),
              ' ',
              bcs.bankShortName
            );
          })
        ) : t('Loan') + ': ' + t('Not assigned')
      })
    );
  };

  this.renderTableRow = function (data, idx) {
    var _state9 = _this11.state,
        currentTab = _state9.currentTab,
        mpUserLoading = _state9.mpUserLoading,
        mpUserDetails = _state9.mpUserDetails,
        isMobile = _state9.isMobile,
        isComputer = _state9.isComputer;
    var t = _this11.props.t;


    var prepData = _extends({
      id: '',
      code: '',
      name: '',
      currentAge: 0,
      createdAt: '',
      statusID: '',
      status: '',
      statusName: '',
      origin: '',
      buyerProfileID: '',
      booking_id: '',
      aging_days: 0,
      created_at: '',
      bookingCustomer: null,
      bookingStatus: null,
      paymentStatus: { id: '', name: '' }
    }, data);
    prepData.projectUnit = _extends({ isBumi: false, reference: '' }, data && data.projectUnit || {});
    prepData.project = _extends({ shortName: '', name: '' }, data && data.project || {});
    prepData.paymentStatus = _extends({ id: '', name: '' }, data && data.paymentStatus || {});

    // TODO: comment first waiting for updated api calls+confirmation by backend team
    // const secondaryPurchasers = currentTab === 'all' && data.bookingCustomers
    //   ? data.bookingCustomers.filter(c => c.id !== data.bookingCustomer.id).map(c => c.name)
    //   : [];
    var secondaryPurchasers = 0;
    var isCurrentTabAll = currentTab === 'all';
    var isCurrentTabUnit = currentTab === 'aging_by_units';
    var isCurrentTabBanker = currentTab === 'aging_by_bankers';
    var isCurrentTabLawyer = currentTab === 'aging_by_lawyers';
    var isPendingCancellation = _this11.showPendingCancellation() && (0, _bookingStatuses.isBookingPendingCancellation)(prepData);
    var statusTag = isCurrentTabBanker ? prepData ? function () {
      var bankStatus = _bankCaseStatuses2.default.find(function (e) {
        return e.value === prepData.status;
      });
      return bankStatus ? _react2.default.createElement(_UCBStatusFlag2.default, { text: t(prepData.statusName, { ns: _translation.TRANSLATION_FILES.constants }), value: bankStatus.color }) : null;
    }() : null : isPendingCancellation ? _react2.default.createElement(_UCBStatusFlag2.default, { text: t('Pending Cancellation', { ns: _translation.TRANSLATION_FILES.constants }), value: 'opportunity-pending_cancellation' }) : prepData.bookingStatus ? _react2.default.createElement(_UCBStatusFlag2.default, { text: t(prepData.bookingStatus.name, { ns: _translation.TRANSLATION_FILES.constants }), value: prepData.bookingStatus.id }) : null;
    var bookingHaveAdditionalTags = !isCurrentTabLawyer ? prepData.projectUnit.isBumi || prepData.origin.includes('marketplace') || prepData.buyerProfileID !== '' : false;

    if (isCurrentTabLawyer) {
      var statusOption = _lawyerCaseStatuses.LAWYER_ALL_STATUSES.find(function (s) {
        return s.value === prepData.status;
      });
      var status = '';
      if (statusOption) {
        status = t(statusOption.text, { ns: _translation.TRANSLATION_FILES.constants });
      }
      return _react2.default.createElement(
        _semanticUiReact.Table.Row,
        {
          key: idx,
          className: _this11.getRowClassName(prepData.status),
          onClick: isMobile ? function () {
            return _this11.context.router.push('/bookings/' + prepData.booking_id + '/');
          } : null
        },
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { collapsing: true, className: 'days' },
          _react2.default.createElement(
            'span',
            { className: 'mobile-hide' },
            _react2.default.createElement(_semanticUiReact.Header, {
              color: _this11.getAgingColor(data.aging_days || 0),
              content: data.aging_days || 0
            })
          ),
          _react2.default.createElement(
            'span',
            { className: 'computer-hide' },
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/bookings/' + data.booking_id + '/' },
              data.purchaser && data.purchaser.name || ''
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { className: 'computer-hide', style: { marginTop: '0.45em' } },
          statusOption && _react2.default.createElement(_UCBStatusFlag2.default, { text: status, value: statusOption.color })
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { collapsing: true, className: 'mobile-hide' },
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(_Timestamp2.default, {
              timestamp: data.created_at,
              format: 'DD/M/YYYY'
            })
          )
        ),
        !_this11.props.projectUnitID ? _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          null,
          _react2.default.createElement(
            'div',
            { className: 'mobile-hide' },
            _react2.default.createElement(
              _reactRouter.Link,
              { title: data.code, to: '/bookings/' + data.booking_id + '/' },
              data.property && data.property.unit_no,
              ', ',
              data.property && data.property.project_name
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'computer-hide', style: { display: 'flex', flexDirection: 'column', gap: '0.7em', marginTop: '0.3em' } },
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'div',
                { style: { display: 'inline-flex', gap: '0.5em', alignItems: 'start' } },
                _react2.default.createElement('img', { style: { marginTop: '0.3em' }, src: _building2.default, alt: 'calendar', width: 20 }),
                data.property && data.property.unit_no,
                ' \u2022 ',
                data.property && data.property.project_name
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-flex', gap: '0.5em' } },
              _react2.default.createElement('img', { src: _calendar2.default, alt: 'calendar', width: 16 }),
              _react2.default.createElement(_Timestamp2.default, {
                timestamp: data.createdAt,
                format: 'DD/M/YYYY'
              })
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                null,
                t('Lawyer'),
                ':\xA0\xA0',
                data.lawyer ? data.lawyer.name : '-'
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', justifyContent: 'space-between' } },
              _react2.default.createElement(_UCBStatusFlag2.default, { text: data.type, value: 'status-ghost' }),
              _react2.default.createElement(_semanticUiReact.Header, {
                floated: 'right',
                color: _this11.getAgingColor(data.aging_days),
                content: data.aging_days
              })
            )
          )
        ) : null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { className: 'mobile-hide' },
          _react2.default.createElement(
            'span',
            null,
            data.purchaser && data.purchaser.name
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { collapsing: true, className: 'mobile-hide' },
          _react2.default.createElement(
            'span',
            null,
            data.type
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { className: 'mobile-hide' },
          _react2.default.createElement(
            'span',
            null,
            data.lawyer && data.lawyer.name
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { collapsing: true, className: 'mobile-hide' },
          statusOption && _react2.default.createElement(_UCBStatusFlag2.default, { text: status, value: statusOption.color })
        )
      );
    }
    return _react2.default.createElement(
      _semanticUiReact.Table.Row,
      _extends({
        key: idx,
        className: _this11.getRowClassName(prepData.statusID)
      }, _this11.getDataTarget(idx), _this11.getDatasetAttributes('bookingid', prepData.id), _this11.getDatasetAttributes('unitno', prepData.projectUnit.reference), _this11.getDatasetAttributes('projectname', prepData.project.shortName), _this11.getDatasetAttributes('purchasername', isCurrentTabBanker ? prepData.name : prepData.bookingCustomer ? prepData.bookingCustomer.name : ''), {
        onClick: isMobile ? function () {
          return _this11.context.router.push('/bookings/' + prepData.id + '/');
        } : null
      }),
      !isMobile && currentTab !== 'all' && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'days' },
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_semanticUiReact.Header, {
            color: _this11.getAgingColor(prepData.currentAge),
            content: prepData.currentAge
          })
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        null,
        _react2.default.createElement(
          'span',
          { className: 'mobile-hide' },
          _react2.default.createElement(_Timestamp2.default, {
            timestamp: prepData.createdAt,
            format: 'DD/M/YYYY'
          }),
          _react2.default.createElement('br', null),
          _this11.renderStatusDateCell(false, prepData)
        ),
        _react2.default.createElement(
          'span',
          { className: 'computer-hide' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/bookings/' + prepData.id + '/' },
            isCurrentTabBanker ? prepData.name : prepData.bookingCustomer ? prepData.bookingCustomer.name : ''
          )
        )
      ),
      _this11.showProjectColumn() ? _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'mobile-hide' },
        prepData.project.name || '-'
      ) : null,
      isMobile && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { style: { marginTop: '0.45em' } },
        statusTag
      ),
      !_this11.props.projectUnitID ? _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        null,
        _react2.default.createElement(
          'div',
          { className: 'mobile-hide' },
          _react2.default.createElement(
            _reactRouter.Link,
            { style: { fontSize: 14 }, title: prepData.code, to: '/bookings/' + prepData.id + '/' },
            prepData.projectUnit.reference
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'span',
            { className: 'uc-table-cell-subtitle1' },
            prepData.project.name
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', gap: '0.5em' } },
            prepData.projectUnit.isBumi && _react2.default.createElement(
              _semanticUiReact.Label,
              { className: 'uc-label-ghost', size: 'mini' },
              (0, _vietnam.unitQuotaChipLabel)(_this11.props.auth, t)
            ),
            prepData.origin.includes('marketplace') && _react2.default.createElement(
              _semanticUiReact.Label,
              { className: 'uc-label-ghost', size: 'mini' },
              prepData.origin.includes('_') ? t('Showroom for Buyer') : t('Marketplace')
            ),
            prepData.buyerProfileID !== '' && _react2.default.createElement(
              _semanticUiReact.Label,
              { className: 'uc-label-ghost', size: 'mini' },
              t('Buyer')
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'computer-hide', style: { display: 'flex', flexDirection: 'column', gap: '0.7em', marginTop: '0.3em' } },
          _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-flex', gap: '0.5em', alignItems: 'start' } },
              _react2.default.createElement('img', { src: _building2.default, alt: 'Calendar', width: 20 }),
              prepData.projectUnit.reference,
              ' \u2022 ',
              prepData.project.name
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { display: 'inline-flex', gap: '0.5em' } },
            _react2.default.createElement('img', { src: _calendar2.default, alt: 'Calendar', width: 16 }),
            _react2.default.createElement(_Timestamp2.default, {
              timestamp: prepData.createdAt,
              format: 'DD/M/YYYY'
            })
          ),
          isCurrentTabUnit && _react2.default.createElement(
            'div',
            null,
            _this11.hasInternalDEAccess() ? _react2.default.createElement(
              'span',
              null,
              t('Assigned staff'),
              ':\xA0\xA0',
              data.assignedMaPreferredName ? data.assignedMaPreferredName : '-'
            ) : null
          ),
          isCurrentTabBanker && _react2.default.createElement(
            'div',
            { style: { display: 'inline-flex', direction: 'row', alignItems: 'center', gap: '0.5em' } },
            _react2.default.createElement(
              'span',
              null,
              t('Banker'),
              ':\xA0\xA0',

              // show logo if banker is direct to bank and bank logo exist
              data.bankerDirectToBank && data.bankLogoSrc ? _react2.default.createElement(_semanticUiReact.Image, { src: data.bankLogoSrc, style: { maxHeight: '20px', display: 'inline-block' } }) : data.banker
            ),
            _react2.default.createElement(_UCBStatusFlag2.default, { text: data.bankShortName, value: 'status-info-dim' })
          ),
          isCurrentTabBanker && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'span',
              null,
              t('Reserved by'),
              ':\xA0\xA0',
              data.createdBy
            ),
            !bookingHaveAdditionalTags && _react2.default.createElement(_semanticUiReact.Header, {
              floated: 'right',
              color: _this11.getAgingColor(data.currentAge),
              content: data.currentAge
            })
          ),
          bookingHaveAdditionalTags && _react2.default.createElement(
            'div',
            { style: { display: 'flex', justifyContent: 'space-between' } },
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', gap: '0.5em', marginTop: '0.2em' } },
              data.projectUnit.isBumi && _react2.default.createElement(
                _semanticUiReact.Label,
                { className: 'uc-label-ghost', size: 'medium', style: { paddingTop: '4px', paddingBottom: '4px' } },
                (0, _vietnam.unitQuotaChipLabel)(_this11.props.auth, t)
              ),
              data.origin && data.origin.includes('marketplace') && _react2.default.createElement(
                _semanticUiReact.Label,
                { className: 'uc-label-ghost', size: 'medium', style: { paddingTop: '4px', paddingBottom: '4px' } },
                data.origin.includes('_') ? t('Showroom for Buyer') : t('Marketplace')
              ),
              data.buyerProfileID && data.buyerProfileID !== '' && _react2.default.createElement(
                _semanticUiReact.Label,
                { className: 'uc-label-ghost', size: 'medium', style: { paddingTop: '4px', paddingBottom: '4px' } },
                t('Buyer')
              )
            ),
            !['all', 'aging_by_units'].includes(currentTab) && _react2.default.createElement(_semanticUiReact.Header, {
              floated: 'right',
              color: _this11.getAgingColor(data.currentAge),
              content: data.currentAge
            })
          )
        )
      ) : null,
      _this11.showBookingIDColumn() ? _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'mobile-hide' },
        (0, _vietnam.bookingIDCellValue)(prepData)
      ) : null,
      currentTab === 'all' ? _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'mobile-hide' },
        _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/bookings/' + data.id + '/' },
            data.bookingCustomer && data.bookingCustomer.name
          )
        )
      ) : null,
      !isMobile && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        null,
        _react2.default.createElement(
          'span',
          null,
          data.origin && data.origin.includes('marketplace') && _this11.hasMPDetailsAccess() ? data.origin.includes('_') ? _react2.default.createElement(
            _semanticUiReact.Popup,
            {
              on: 'click',
              trigger: _react2.default.createElement(
                'a',
                null,
                data.maCreatedByPreferredName
              ),
              size: 'mini',
              inverted: true,
              position: 'bottom right',
              disabled: true,
              flowing: true
            },
            data.bookingCustomer ? _react2.default.createElement(
              'span',
              { style: { fontSize: '15px' } },
              _react2.default.createElement(
                'div',
                null,
                t('Name') + ': ' + data.bookingCustomer.name
              ),
              data.bookingCustomer.email ? _react2.default.createElement(
                'div',
                null,
                t('Email') + ': ' + data.bookingCustomer.email
              ) : null,
              _react2.default.createElement(
                'div',
                null,
                t('Mobile') + ': ' + data.bookingCustomer.mobilePrefix + data.bookingCustomer.mobile
              )
            ) : null
          ) : _react2.default.createElement(
            _semanticUiReact.Popup,
            {
              on: 'click',
              trigger: _react2.default.createElement(
                'a',
                null,
                data.maCreatedByPreferredName
              ),
              onOpen: function onOpen() {
                _this11.fetchMarketplaceUserDetails(data.maUserID);
              },
              size: 'mini',
              inverted: true,
              position: 'bottom right',
              disabled: true,
              flowing: true
            },
            mpUserLoading ? _react2.default.createElement(
              _semanticUiReact.Loader,
              { active: true, inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            ) : _react2.default.createElement(
              'span',
              { style: { fontSize: '15px' } },
              _react2.default.createElement(
                'div',
                null,
                t('Name') + ': ' + mpUserDetails.fullName
              ),
              _react2.default.createElement(
                'div',
                null,
                t('Email') + ': ' + mpUserDetails.email
              ),
              _react2.default.createElement(
                'div',
                null,
                t('Mobile') + ': ' + mpUserDetails.mobilePrefix + mpUserDetails.mobile
              ),
              mpUserDetails.agencyName ? _react2.default.createElement(
                'div',
                null,
                t('Agency Name') + ': ' + mpUserDetails.agencyName
              ) : null,
              mpUserDetails.registrationNumber ? _react2.default.createElement(
                'div',
                null,
                t('Registration Number') + ': ' + mpUserDetails.registrationNumber
              ) : null
            )
          ) : _this11.hasStaffAccess() ? _react2.default.createElement(
            _reactRouter.Link,
            { to: '/users/' + (currentTab === 'aging_by_bankers' ? data.createdByID : data.maUserAffiliateID) + '/' },
            currentTab === 'aging_by_bankers' ? data.createdBy : data.maCreatedByPreferredName
          ) : currentTab === 'aging_by_bankers' ? data.createdBy : data.maCreatedByPreferredName,
          currentTab !== 'aging_by_bankers' ? _react2.default.createElement(
            'small',
            null,
            _react2.default.createElement('br', null),
            data.origin && data.origin.includes('marketplace_') ? t('Buyer') : data.maUserAffiliateCompanyBranchShortName
          ) : ''
        )
      ),
      _this11.props.projectUnitID && currentTab === 'aging_by_bankers' ? _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true },
        _react2.default.createElement(
          'span',
          { className: 'mobile-hide' },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/bookings/' + data.id + '/' },
            data.code
          )
        ),
        _react2.default.createElement(
          'span',
          { className: 'computer-hide' },
          data.code
        )
      ) : null,
      !isMobile && currentTab === 'aging_by_bankers' && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true },
        _react2.default.createElement(
          'span',
          null,

          // show logo if banker is direct to bank and bank logo exist
          data.bankerDirectToBank && data.bankLogoSrc ? _react2.default.createElement(_semanticUiReact.Image, { src: data.bankLogoSrc, style: { maxHeight: '20px', display: 'inline-block' } }) : data.banker
        )
      ),
      !isMobile && currentTab === 'aging_by_bankers' && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true },
        _react2.default.createElement(
          'span',
          null,
          data.bankShortName
        )
      ),
      !isMobile && _this11.hasInternalDEAccess() ? _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        null,
        _react2.default.createElement(
          'span',
          null,
          data.assignedMaPreferredName ? data.assignedMaPreferredName : '-'
        )
      ) : null,
      !isMobile && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true, className: 'uc-sticky-col uc-right' },
        statusTag
      ),
      _this11.showCancellationReasonColumn() ? _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'mobile-hide' },
        _this11.renderCancellationReason(prepData)
      ) : null,
      isMobile ? (isCurrentTabAll || isCurrentTabUnit) && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { style: { marginTop: '0.5em' } },
        _react2.default.createElement(
          'div',
          {
            style: {
              display: 'flex',
              alignItems: 'middle',
              justifyContent: 'space-between',
              width: '100%'
            }
          },
          _this11.renderProgressCell(prepData),
          currentTab !== 'all' && _react2.default.createElement(_semanticUiReact.Header, {
            style: {
              marginTop: 0,
              marginRight: '0.5em',
              lineHeight: '1.5',
              alignSelf: 'center'
            },
            color: _this11.getAgingColor(prepData.currentAge),
            content: prepData.currentAge
          })
        )
      ) : (isCurrentTabAll || isCurrentTabUnit) && _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'uc-sticky-col uc-right' },
        _this11.renderProgressCell(prepData)
      )
    );
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRouter.withRouter)((0, _reactRedux.connect)(BookingsList.mapStateToProps)(BookingsList)));

/***/ }),
/* 2211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OverviewDetail = undefined;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OverviewDetail = exports.OverviewDetail = function OverviewDetail(_ref) {
  var hero = _ref.hero,
      title = _ref.title,
      subtitle = _ref.subtitle,
      actionButtons = _ref.actionButtons,
      otherActions = _ref.otherActions;
  return _react2.default.createElement(
    _semanticUiReact.Grid,
    { columns: 2 },
    _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 16 },
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', justifyContent: 'start', gap: 24 } },
          hero,
          _react2.default.createElement(
            'div',
            { style: { display: 'flex', flex: 1, flexDirection: 'column', justifyContent: 'space-between' } },
            _react2.default.createElement(
              'div',
              { style: { display: 'flex', justifyContent: 'space-between' } },
              title,
              _react2.default.createElement(
                'div',
                { style: { display: 'flex', justifyContent: 'end', alignItems: 'center', gap: 8, flexWrap: 'wrap' } },
                actionButtons,
                otherActions
              )
            ),
            subtitle
          )
        )
      )
    )
  );
};

OverviewDetail.propTypes = {
  hero: _propTypes2.default.node,
  title: _propTypes2.default.node,
  subtitle: _propTypes2.default.node,
  actionButtons: _propTypes2.default.node,
  otherActions: _propTypes2.default.node
};

/***/ }),
/* 2212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-unused-prop-types */


var SectionTab = function (_Component) {
  _inherits(SectionTab, _Component);

  function SectionTab(props) {
    _classCallCheck(this, SectionTab);

    var _this = _possibleConstructorReturn(this, (SectionTab.__proto__ || Object.getPrototypeOf(SectionTab)).call(this, props));

    _initialiseProps.call(_this);

    var state = SectionTab.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(SectionTab, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = SectionTab.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          isMobile = _props.isMobile,
          t = _props.t;
      var _state = this.state,
          isSticky = _state.isSticky,
          loading = _state.loading,
          tabs = _state.tabs,
          tabID = _state.tabID;

      var filteredTabs = tabs.filter(function (tab) {
        return !tab.disabled;
      });
      var renderRedDot = function renderRedDot(tab) {
        return tab.showDot && _react2.default.createElement('span', { className: 'show-dot' });
      };
      return _react2.default.createElement(
        'div',
        null,
        isSticky ? _react2.default.createElement(
          _semanticUiReact.Button.Group,
          { className: 'uc-section-tabs sticky', compact: true, fluid: true, size: isMobile ? 'mini' : 'tiny', disabled: loading },
          filteredTabs.map(function (tab, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Button,
              { key: idx, active: tabID === tab.id, onClick: function onClick(e) {
                  return _this2.handleTabClick(e, tab);
                }, disabled: tab.isLocked, style: isMobile ? { fontSize: '0.65rem' } : {} },
              t(tab.title).toUpperCase(),
              renderRedDot(tab)
            );
          })
        ) : isMobile ? _react2.default.createElement(
          _semanticUiReact.Button.Group,
          { className: 'uc-section-tabs', compact: true, fluid: true, size: 'mini', disabled: loading },
          filteredTabs.map(function (tab, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Button,
              { key: idx, active: tabID === tab.id, disabled: tab.isLocked, onClick: function onClick(e) {
                  return _this2.handleTabClick(e, tab);
                } },
              t(tab.title).toUpperCase(),
              renderRedDot(tab)
            );
          })
        ) : _react2.default.createElement(
          _semanticUiReact.Button.Group,
          { className: 'uc-section-tabs', fluid: true, disabled: loading },
          filteredTabs.map(function (tab, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Button,
              { key: idx, active: tabID === tab.id, disabled: tab.isLocked, onClick: function onClick(e) {
                  return _this2.handleTabClick(e, tab);
                } },
              _react2.default.createElement(
                _semanticUiReact.Header,
                { as: 'h5', inverted: tabID === tab.id },
                t(tab.title).toUpperCase(),
                renderRedDot(tab)
              )
            );
          })
        )
      );
    }
  }]);

  return SectionTab;
}(_react.Component);

SectionTab.propTypes = {
  isMobile: _propTypes2.default.bool,
  isSticky: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  onTabChange: _propTypes2.default.func,
  tabs: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  tabID: _propTypes2.default.number,
  t: _propTypes2.default.func
};
SectionTab.defaultProps = {
  isMobile: false,
  tabID: 1
};

SectionTab.getPropsToState = function (props) {
  var bookingID = props.bookingID || '';
  var isSticky = props.isSticky;
  var loading = props.loading;
  var tabs = props.tabs || [];
  var tabID = props.tabID;
  return {
    bookingID: bookingID,
    isSticky: isSticky,
    loading: loading,
    tabs: tabs,
    tabID: tabID
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleTabClick = function (e, tab) {
    var isSticky = _this3.state.isSticky;

    e.preventDefault();
    _this3.setState({ tabID: tab.id }, function () {
      if (_this3.props.onTabChange) {
        _this3.props.onTabChange(_extends({}, tab, {
          isSticky: isSticky
        }));
      }
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens, { withRef: true })(SectionTab);

/***/ }),
/* 2213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _AddRemarkModal = __webpack_require__(2082);

var _AddRemarkModal2 = _interopRequireDefault(_AddRemarkModal);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Timeline = function Timeline(_ref) {
  var _ref$data = _ref.data,
      data = _ref$data === undefined ? [] : _ref$data,
      title = _ref.title,
      hasMore = _ref.hasMore,
      onLoadMore = _ref.onLoadMore,
      _ref$loading = _ref.loading,
      loading = _ref$loading === undefined ? false : _ref$loading,
      _ref$bankCases = _ref.bankCases,
      bankCases = _ref$bankCases === undefined ? [] : _ref$bankCases,
      opportunityID = _ref.opportunityID,
      token = _ref.token,
      fetchActivityLogs = _ref.fetchActivityLogs,
      loadMoreLabel = _ref.loadMoreLabel,
      _ref$hideAddRemark = _ref.hideAddRemark,
      hideAddRemark = _ref$hideAddRemark === undefined ? false : _ref$hideAddRemark;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      hoveredItem = _useState2[0],
      setHoveredItem = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showAddRemark = _useState4[0],
      setShowAddRemark = _useState4[1];

  var formatBold = function formatBold(text) {
    if (!text) return '';
    var parts = text.split(/(\*\*.*?\*\*)/g);
    return _react2.default.createElement(
      'span',
      null,
      parts.map(function (part, index) {
        var boldMatch = part.match(/^\*\*(.*?)\*\*$/);
        if (boldMatch) return _react2.default.createElement(
          'strong',
          { key: index },
          boldMatch[1]
        );
        return _react2.default.createElement(
          _react2.default.Fragment,
          { key: index },
          part
        );
      })
    );
  };
  return _react2.default.createElement(
    'div',
    { className: 'uc-timeline' },
    _react2.default.createElement(_AddRemarkModal2.default, {
      open: showAddRemark,
      bankCases: bankCases,
      opportunityID: opportunityID,
      token: token,
      onClose: function onClose() {
        return setShowAddRemark(false);
      },
      onSuccess: fetchActivityLogs
    }),
    _react2.default.createElement(
      'div',
      { className: 'uc-timeline-title-header', style: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' } },
      title || '',
      !hideAddRemark && _react2.default.createElement(_semanticUiReact.Icon, {
        name: 'plus',
        className: 'minimal-plus-icon',
        role: 'button',
        tabIndex: 0,
        'aria-label': 'Add remark',
        onClick: function onClick() {
          return setShowAddRemark(true);
        },
        onKeyDown: function onKeyDown(e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            e.preventDefault();
            e.stopPropagation();
            setShowAddRemark(true);
          }
        },
        style: { cursor: 'pointer' }
      })
    ),
    data.map(function (item, index) {
      return _react2.default.createElement(
        'div',
        {
          key: item.id,
          className: 'uc-timeline-item',
          onMouseEnter: function onMouseEnter() {
            return setHoveredItem(index);
          },
          onMouseLeave: function onMouseLeave() {
            return setHoveredItem(null);
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'uc-timeline-icon' },
          _react2.default.createElement(_semanticUiReact.Icon, { name: hoveredItem === index ? 'circle' : 'circle outline', color: 'grey', size: 'small' })
        ),
        (index < data.length - 1 || hasMore) && _react2.default.createElement('div', { className: 'uc-timeline-line' }),
        _react2.default.createElement(
          'div',
          { className: 'uc-timeline-content' },
          _react2.default.createElement(
            'div',
            { className: 'uc-timeline-title' },
            formatBold(item.title)
          ),
          item.description && _react2.default.createElement(
            'div',
            { className: 'uc-timeline-description' },
            formatBold(item.description)
          ),
          _react2.default.createElement(
            'div',
            { className: 'uc-timeline-date' },
            _react2.default.createElement(_Timestamp2.default, { timestamp: item.date, format: 'DD/MM/YYYY hh:mm:ss A' }),
            item.userName && ' \u2022 ' + item.userName
          )
        )
      );
    }),
    hasMore && _react2.default.createElement(
      'div',
      { className: 'uc-timeline-item' },
      _react2.default.createElement(
        'div',
        { className: 'uc-timeline-icon' },
        _react2.default.createElement(_semanticUiReact.Icon, { name: 'circle', color: 'grey', size: 'small' })
      ),
      _react2.default.createElement(
        'div',
        { className: 'uc-timeline-content' },
        loading ? _react2.default.createElement(_semanticUiReact.Loader, { active: true, inline: true, size: 'small' }) : _react2.default.createElement(
          'div',
          {
            role: 'button',
            tabIndex: 0,
            'aria-label': 'Load more',
            onClick: onLoadMore,
            onKeyDown: function onKeyDown(e) {
              if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                e.preventDefault();
                e.stopPropagation();
                onLoadMore();
              }
            },
            style: { cursor: 'pointer', textAlign: 'center' }
          },
          _react2.default.createElement(
            'span',
            { style: { verticalAlign: 'middle' } },
            loadMoreLabel || 'Load More'
          ),
          ' ',
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron down', color: 'grey', size: 'small', style: { marginLeft: '5px', verticalAlign: 'middle' } })
        )
      )
    )
  );
};

Timeline.propTypes = {
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    title: _propTypes2.default.string,
    description: _propTypes2.default.string,
    date: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.instanceOf(Date)]),
    userName: _propTypes2.default.string
  })),
  title: _propTypes2.default.string,
  hasMore: _propTypes2.default.bool,
  onLoadMore: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  token: _propTypes2.default.string,
  opportunityID: _propTypes2.default.string,
  bankCases: _propTypes2.default.arrayOf(_propTypes2.default.object),
  fetchActivityLogs: _propTypes2.default.func,
  loadMoreLabel: _propTypes2.default.string,
  hideAddRemark: _propTypes2.default.bool
};

exports.default = Timeline;

/***/ }),
/* 2214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ACTIVITY_DATE_FORMAT = undefined;
exports.formatLegalDate = formatLegalDate;
exports.formatInstantAsDate = formatInstantAsDate;

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _displayTime = __webpack_require__(156);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Activity logs print some values as a bare calendar date, and two different kinds of field end up
 * in that same shape:
 *
 * - `spaSigningDate` / `spaStampingDate` are legal calendar dates. A contract signed on the 18th
 *   was signed on the 18th for everyone, so these keep the configured zone.
 * - `approvedAt` / `cancelledAt` / `lastSoldAt` / `lastBookedAt` are real instants that merely
 *   happen to be rendered without a clock. Their calendar day has to be the viewer's, or a VN
 *   approval at 23:30 local reads as the previous day.
 *
 * The two are one line apart in `BookingActivities`, so they are expressed as two named functions
 * here: the difference is intentional and testable rather than an inconsistency.
 */

var ACTIVITY_DATE_FORMAT = exports.ACTIVITY_DATE_FORMAT = 'MMMM Do YYYY';

/** Legal calendar date — identical for every viewer, never converted. */
function formatLegalDate(value) {
  return (0, _momentTimezone2.default)(value).format(ACTIVITY_DATE_FORMAT);
}

/** A true instant shown as a date only — the calendar day follows the viewer for VN. */
function formatInstantAsDate(value, countryCode) {
  return (0, _displayTime.displayMoment)(value, countryCode).format(ACTIVITY_DATE_FORMAT);
}

/***/ }),
/* 2215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BANK_STATUS_OPTIONS = exports.BANK_STATUS_OPTIONS = [{ value: 'new', text: 'New' }, { value: 'pending_unreachable', text: 'Unreachable' }, { value: 'pending_docs', text: 'Pending Docs' }, { value: 'pending_docs_submitted', text: 'Docs Submitted' }, { value: 'pending_reappealed', text: 'Loan Re-appealed' }, { value: 'pending_meeting', text: 'Pending Meeting' }, { value: 'meeting_completed', text: 'Meeting Completed' }, { value: 'reject_bank', text: 'Loan Rejected' }, { value: 'reject_customer', text: 'Customer Rejected' }, { value: 'reject_cancelled', text: 'Cancelled' }, { value: 'reject_developer', text: 'Cancelled by Developer' }, { value: 'approved_lo_issued', text: 'LO Issued' }, { value: 'success_li_issued', text: 'LO Signed' }, { value: 'archived', text: 'Archived' }, { value: 'reject_unqualified', text: 'Unqualified' }, { value: 'reject_lo_signed_other_bank', text: 'LO Signed with another bank' }, { value: 'reject_wrong_info', text: 'Wrong Info' }];

var STAGE_STATUS_OPTIONS = exports.STAGE_STATUS_OPTIONS = [{ value: 'new', text: 'New' }, { value: 'follow_up', text: 'Follow-up' }, { value: 'reserved', text: 'Reserved' }, { value: 'booked', text: 'Booked' }, { value: 'won', text: 'Won' }, { value: 'lost', text: 'Lost' }];

var BANK_STATUS_MAP = exports.BANK_STATUS_MAP = BANK_STATUS_OPTIONS.reduce(function (acc, tab) {
  return _extends({}, acc, _defineProperty({}, tab.value, tab));
}, {});

var STAGE_STATUS_MAP = exports.STAGE_STATUS_MAP = STAGE_STATUS_OPTIONS.reduce(function (acc, option) {
  return _extends({}, acc, _defineProperty({}, option.value, option));
}, {});

/***/ }),
/* 2216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BUMI_FILTER = [{ text: 'Bumiputera', value: 'true' }, { text: 'Non-Bumiputera', value: 'false' }];
exports.default = BUMI_FILTER;

/***/ }),
/* 2217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BUYER_BOOKING_STATUS_DRAFT_OPTION = exports.BUYER_BOOKING_STATUS_DRAFT_OPTION = { text: 'Draft', value: 'draft', name: 'draft' };
var BUYER_BOOKING_STATUS_NEW_OPTION = exports.BUYER_BOOKING_STATUS_NEW_OPTION = { text: 'Booking Linked', value: 'new', name: 'new' };
var BUYER_BOOKING_STATUS_CHECK_LINKED_OPTION = exports.BUYER_BOOKING_STATUS_CHECK_LINKED_OPTION = { text: 'Credit Check Completed', value: 'check_linked', name: 'check_linked' };
var BUYER_BOOKING_STATUS_LOAN_SUBMITTED_OPTION = exports.BUYER_BOOKING_STATUS_LOAN_SUBMITTED_OPTION = { text: 'Lender Connected', value: 'loan_submitted', name: 'loan_submitted' };
var BUYER_BOOKING_STATUS_SOLD_OPTION = exports.BUYER_BOOKING_STATUS_SOLD_OPTION = { text: 'Sold', value: 'sold', name: 'sold' };
var BUYER_BOOKING_STATUS_CANCEL_REQUESTED_OPTION = exports.BUYER_BOOKING_STATUS_CANCEL_REQUESTED_OPTION = { text: 'Cancel Requested', value: 'cancel_requested', name: 'cancel_requested' };
var BUYER_BOOKING_STATUS_CANCELLED_OPTION = exports.BUYER_BOOKING_STATUS_CANCELLED_OPTION = { text: 'Cancelled', value: 'cancelled', name: 'cancelled' };
var BUYER_BOOKING_STATUS_EXPIRED_OPTION = exports.BUYER_BOOKING_STATUS_EXPIRED_OPTION = { text: 'Expired', value: 'expired', name: 'expired' };

var BUYER_BOOKING_STATUSES = [BUYER_BOOKING_STATUS_NEW_OPTION, BUYER_BOOKING_STATUS_CHECK_LINKED_OPTION, BUYER_BOOKING_STATUS_LOAN_SUBMITTED_OPTION, BUYER_BOOKING_STATUS_SOLD_OPTION, BUYER_BOOKING_STATUS_CANCEL_REQUESTED_OPTION, BUYER_BOOKING_STATUS_CANCELLED_OPTION, BUYER_BOOKING_STATUS_EXPIRED_OPTION];

exports.default = BUYER_BOOKING_STATUSES;

/***/ }),
/* 2218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isCommitmentOther = exports.isCommitmentVehicle = exports.isCommitmentPersonal = exports.isCommitmentCreditCard = exports.isCommitmentHouse = exports.isCommitmentSpecialOther = undefined;

var _collateralCodes = __webpack_require__(2219);

var _facilityCodes = __webpack_require__(2223);

var isCommitmentSpecialOther = exports.isCommitmentSpecialOther = function isCommitmentSpecialOther(commitment) {
  return (0, _facilityCodes.isFacilityCodeSpecialOther)(commitment.loantype);
};

var isCommitmentHouse = exports.isCommitmentHouse = function isCommitmentHouse(commitment) {
  return (0, _facilityCodes.isFacilityCodeHouse)(commitment.loantype);
};

var isCommitmentCreditCard = exports.isCommitmentCreditCard = function isCommitmentCreditCard(commitment) {
  return (0, _facilityCodes.isFacilityCodeCreditCard)(commitment.loantype);
};

var isCommitmentPersonal = exports.isCommitmentPersonal = function isCommitmentPersonal(commitment) {
  return !commitment.is_ptptn && ((0, _facilityCodes.isFacilityCodePersonal)(commitment.loantype) || isCommitmentSpecialOther(commitment) && ((0, _collateralCodes.isCollateralCodePersonal)(commitment.collateral_code) || commitment.collaterals && commitment.collaterals.length > 0 && (0, _collateralCodes.isCollateralCodePersonal)(commitment.collaterals[0].code)));
};

var isCommitmentVehicle = exports.isCommitmentVehicle = function isCommitmentVehicle(commitment) {
  return (0, _facilityCodes.isFacilityCodeVehicle)(commitment.loantype) || isCommitmentSpecialOther(commitment) && ((0, _collateralCodes.isCollateralCodeVehicle)(commitment.collateral_code) || commitment.collaterals && commitment.collaterals.length > 0 && (0, _collateralCodes.isCollateralCodeVehicle)(commitment.collaterals[0].code));
};

var isCommitmentOther = exports.isCommitmentOther = function isCommitmentOther(commitment) {
  return !commitment.is_ptptn && !isCommitmentVehicle(commitment) && !isCommitmentHouse(commitment) && !isCommitmentCreditCard(commitment) && !isCommitmentPersonal(commitment);
};

/***/ }),
/* 2219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var clean = '00'; // collateral clean
var property = '10'; // collateral property
var quotedShares = '21'; // collateral quoated shares
var unquotedShared = '22'; // collateral unquoted shared
var unitTrusts = '23'; // collateral unit trusts
var otherFinancialAssets = '29'; // collateral other financial assets
var motorVehicle = '30'; // collateral motor vehicle
var otherVehicle = '40'; // collateral other vehicle
var concessionContractual = '50'; // collateral concession and contractual rights
var plantMachinery = '60'; // collateral plant and machinery
var financialGuarantee = '70'; // collateral financial guarantee
var negativePledge = '80'; // collateral negative pledge
var otherAssets = '00'; // collateral other assets
var secured = '99'; // collateral secured (details unknown)

var COLLATERAL_CODES = exports.COLLATERAL_CODES = [clean, property, quotedShares, unquotedShared, unitTrusts, otherFinancialAssets, motorVehicle, otherVehicle, concessionContractual, plantMachinery, financialGuarantee, negativePledge, otherAssets, secured];

var isCollateralCodeVehicle = exports.isCollateralCodeVehicle = function isCollateralCodeVehicle(code) {
  return [motorVehicle, otherVehicle].some(function (c) {
    return c === code;
  });
};

var isCollateralCodePersonal = exports.isCollateralCodePersonal = function isCollateralCodePersonal(code) {
  return [clean, property, unitTrusts, otherFinancialAssets, secured].some(function (c) {
    return c === code;
  });
};

var isCollateralCodeOther = exports.isCollateralCodeOther = function isCollateralCodeOther(code) {
  return !isCollateralCodeVehicle(code) && !isCollateralCodePersonal(code);
};

/***/ }),
/* 2220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var CTOS_STATUSES = [{ text: 'All', value: 'All' }, { text: 'New', value: 'new' }, { text: 'Pending', value: 'pending' }, { text: 'Multiple Entity', value: 'multiple_entities' }, { text: 'Success', value: 'success' }, { text: 'Failed', value: 'failed' }];
exports.default = CTOS_STATUSES;

/***/ }),
/* 2221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// Imported and modified from https://gist.github.com/AmrMekkawy/a5425a4dd4e453a4eb4d
var CURRENCIES = [{ value: 'USD', text: 'United States Dollars' }, { value: 'EUR', text: 'Euro' }, { value: 'GBP', text: 'United Kingdom Pounds' }, { value: 'DZD', text: 'Algeria Dinars' }, { value: 'ARP', text: 'Argentina Pesos' }, { value: 'AUD', text: 'Australia Dollars' }, { value: 'ATS', text: 'Austria Schillings' }, { value: 'BSD', text: 'Bahamas Dollars' }, { value: 'BBD', text: 'Barbados Dollars' }, { value: 'BEF', text: 'Belgium Francs' }, { value: 'BMD', text: 'Bermuda Dollars' }, { value: 'BRR', text: 'Brazil Real' }, { value: 'BGL', text: 'Bulgaria Lev' }, { value: 'CAD', text: 'Canada Dollars' }, { value: 'CLP', text: 'Chile Pesos' }, { value: 'CNY', text: 'China Yuan Renmimbi' }, { value: 'CYP', text: 'Cyprus Pounds' }, { value: 'CSK', text: 'Czech Republic Koruna' }, { value: 'DKK', text: 'Denmark Kroner' }, { value: 'NLG', text: 'Dutch Guilders' }, { value: 'EGP', text: 'Egypt Pounds' }, { value: 'FJD', text: 'Fiji Dollars' }, { value: 'FIM', text: 'Finland Markka' }, { value: 'FRF', text: 'France Francs' }, { value: 'DEM', text: 'Germany Deutsche Marks' }, { value: 'GRD', text: 'Greece Drachmas' }, { value: 'HKD', text: 'Hong Kong Dollars' }, { value: 'HUF', text: 'Hungary Forint' }, { value: 'ISK', text: 'Iceland Krona' }, { value: 'INR', text: 'India Rupees' }, { value: 'IDR', text: 'Indonesia Rupiah' }, { value: 'IEP', text: 'Ireland Punt' }, { value: 'ILS', text: 'Israel New Shekels' }, { value: 'ITL', text: 'Italy Lira' }, { value: 'JMD', text: 'Jamaica Dollars' }, { value: 'JPY', text: 'Japan Yen' }, { value: 'JOD', text: 'Jordan Dinar' }, { value: 'LBP', text: 'Lebanon Pounds' }, { value: 'LUF', text: 'Luxembourg Francs' }, { value: 'MYR', text: 'Malaysia Ringgit' }, { value: 'MXP', text: 'Mexico Pesos' }, { value: 'NZD', text: 'New Zealand Dollars' }, { value: 'NOK', text: 'Norway Kroner' }, { value: 'PKR', text: 'Pakistan Rupees' }, { value: 'PHP', text: 'Philippines Pesos' }, { value: 'PLZ', text: 'Poland Zloty' }, { value: 'PTE', text: 'Portugal Escudo' }, { value: 'ROL', text: 'Romania Leu' }, { value: 'RUR', text: 'Russia Rubles' }, { value: 'SAR', text: 'Saudi Arabia Riyal' }, { value: 'SGD', text: 'Singapore Dollars' }, { value: 'SKK', text: 'Slovakia Koruna' }, { value: 'ZAR', text: 'South Africa Rand' }, { value: 'KRW', text: 'South Korea Won' }, { value: 'ESP', text: 'Spain Pesetas' }, { value: 'SDD', text: 'Sudan Dinar' }, { value: 'SEK', text: 'Sweden Krona' }, { value: 'CHF', text: 'Switzerland Francs' }, { value: 'TWD', text: 'Taiwan Dollars' }, { value: 'THB', text: 'Thailand Baht' }, { value: 'TTD', text: 'Trinidad and Tobago Dollars' }, { value: 'TRL', text: 'Turkey Lira' }, { value: 'VEB', text: 'Venezuela Bolivar' }, { value: 'ZMK', text: 'Zambia Kwacha' }, { value: 'XCD', text: 'Eastern Caribbean Dollars' }, { value: 'XDR', text: 'Special Drawing Right (IMF)' }, { value: 'XAG', text: 'Silver Ounces' }, { value: 'XAU', text: 'Gold Ounces' }, { value: 'XPD', text: 'Palladium Ounces' }, { value: 'XPT', text: 'Platinum Ounces' }];

exports.default = CURRENCIES;

/***/ }),
/* 2222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BASIC_TAB = {
  text: 'Basic',
  value: 'basic',
  contents: [{
    title: 'Basic Display',
    sections: [{
      description: 'Display raw values from the system (e.g. purchaser name, price, status)',
      examples: [{
        title: 'Example 1: Pull primary purchaser name',
        syntax: 'Name: {P1_Name}',
        output: 'Name: Ali bin Abu'
      }, {
        title: 'Example 2: Pull primary purchaser address',
        syntax: '{P1_Address1}\n{P1_Address2}\n{P1_Postcode} {P1_City}\n{P1_State}',
        output: 'No 33 Lorong 5\nTaman Bunga Flora\n43500 Gopeng\nPerak'
      }]
    }]
  }, {
    title: 'Formatting',
    sections: [{
      description: 'Text decorations like bold, italic, underline, colors, and etc can be apply directly from template file',
      examples: [{
        title: 'Uppercase',
        syntax: 'Name: {P1_Name | upper}',
        output: 'Name: ALI BIN ABU'
      }, {
        title: 'Lowercase',
        syntax: 'Name: {P1_Name | lower}',
        output: 'Name: ali bin abu'
      }, {
        title: 'Title Case',
        syntax: '{P1_Name | title}',
        output: 'Name: Ali Bin Abu'
      }]
    }, {
      description: 'Text decorations like bold, italic, underline, colors, and etc can be apply directly from template file',
      examples: [{
        title: 'Bold',
        syntax: 'Name: <b>{P1_Name}</b>',
        output: 'Name: <b>Ali Bin Abu</b>'
      }, {
        title: 'Italic',
        syntax: 'Name: <i>{P1_Name}</i>',
        output: 'Name: <i>Ali Bin Abu</i>'
      }, {
        title: 'Underline',
        syntax: 'Name: <u>{P1_Name}</u>',
        output: 'Name: <u>Ali bin Abu</u>'
      }]
    }]
  }, {
    title: 'Number Format',
    sections: [{
      description: 'Format number/price with a commas and decimal places',
      examples: [{
        title: 'Format Price',
        syntax: 'SPA Price: RM {SPA_Price | formatnumber}',
        output: 'SPA Price: RM 1,500.00'
      }]
    }]
  }, {
    title: "Purchaser's NRIC Format",
    sections: [{
      description: "Format purchaser's with '-'",
      examples: [{
        title: "Format Purchaser's NRIC",
        syntax: "Primary Purchaser's NRIC: {P1_ID_No | formatnric}",
        output: "Primary Purchaser's NRIC: 123456-78-9012"
      }, {
        title: "Format Purchaser's NRIC with ID type checking",
        syntax: "Primary Purchaser's NRIC: {P1_ID_Type == 1 ? (P1_ID_No | formatnric) : P1_ID_No}",
        output: "Primary Purchaser's NRIC: 123456-78-9012"
      }]
    }]
  }, {
    title: 'Booking and Unit Custom Fields Mergetag',
    sections: [{
      description: 'Display Booking and Unit custom fields',
      examples: [{
        title: "Booking Custom Field is built using its 'Field Label'",
        syntax: '{bcf_&lt;Field Label&gt;}. eg. SPA Solicitor Name: {bcf_SPA_Solicitor_Name}',
        output: 'SPA Solicitor Name: John Doe'
      }, {
        title: "Unit Custom Field is built using its 'Field Label'",
        syntax: '{ucf_&lt;Field Label&gt;}. eg. Unit Name: {ucf_Unit_Name}',
        output: 'Unit Name: Unit A'
      }]
    }]
  }, {
    title: 'Unit and Project Specification Mergetag',
    sections: [{
      description: 'Display unit and project specification fields',
      examples: [{
        title: 'Unit specification is built using it\'s \'Field Name\'',
        syntax: '{us_&lt;Field Name&gt;}. eg. SPA Solicitor Name: {us_SPA_Solicitor_Name}',
        output: 'SPA Solicitor Name: John Doe'
      }, {
        title: 'Project specification is built using it\'s \'Field Name\'',
        syntax: '{ps_&lt;Field Name&gt;}. eg. Project Name: {ps_Project_Name}',
        output: 'Project Name: Project A'
      }]
    }]
  }, {
    title: 'Variable Assignments/Declarations',
    sections: [{
      description: 'Create variable to store value and can be use within the template',
      examples: [{
        title: 'Direct Variable Assignment',
        syntax: '{@promoMerdekaAmount = 8000}\nPromo Merdeka Amount: {promoMerdekaAmount}',
        output: 'Promo Merdeka Amount: 8000'
      }, {
        title: 'Variable Assignment in Pricing Package items (Promo Merdeka)',
        syntax: '{#Pricing_Package}\n{#Name == "Promo Merdeka" && IsEnabled}\n{@promoMerdekaAmount = ValueChange}\n{/}\n{/}\nPromo Merdeka Amount: {promoMerdekaAmount}',
        output: 'Promo Merdeka Amount: 8000'
      }]
    }]
  }, {
    title: 'String to Int or Float Conversion',
    sections: [{
      description: 'Convert string to integer or float for mathematical operations',
      examples: [{
        title: 'Convert String to Int, eg. FormulaValue = \'5\'',
        syntax: 'FormulaValue: {FormulaValue | toInt}',
        output: 'FormulaValue: 5'
      }, {
        title: 'Convert String to Float, eg. FormulaValue = \'5.5\'',
        syntax: 'FormulaValue: {FormulaValue | toFloat}',
        output: 'FormulaValue: 5.5'
      }]
    }]
  }, {
    title: "Purchaser's Age by Birthdate",
    sections: [{
      description: "Get purchaser's age by birthdate",
      examples: [{
        title: "Get Purchaser's Age",
        syntax: "Primary Purchaser's Age: {P1_Birthdate | age}",
        output: "Primary Purchaser's Age: 35"
      }]
    }]
  }, {
    title: 'Supported Fonts',
    sections: [{
      description: 'Ensure to use fonts are supported to avoid issues when generating forms'
    }]
  }]
};

var CONDITIONS_TAB = {
  text: 'Conditions',
  value: 'conditions',
  contents: [{
    title: 'Pricing Package Condition',
    sections: [{
      description: 'Purpose: To check if pricing package is not empty and list out all available pricing package (both enabled and disabled)',
      examples: [{
        // title: '',
        syntax: '{#Pricing_Package.length > 0}\n{#Pricing_Package}\nName: {Name | title}\nDescription: {Description}\nValue: {FormulaValue}\nNew Price: RM {NewValue | formatnumber}\nPrice Change: RM {ValueChange | formatnumber}\n{/}\n{/}',
        output: 'Name: Bumi Discount\nDescription: Discount for bumi buyer\nValue: 8\nNew Price: RM 230,000.60\nPrice Changes: RM 20,000.05'
      }]
    }, {
      description: 'Purpose: To check if pricing package is not empty and list out all enabled pricing package',
      examples: [{
        // title: '',
        syntax: '{#Pricing_Package.length > 0}\n{#Pricing_Package}\n{#IsEnabled}\nName: {Name | title}\nDescription: {Description}\nValue: {FormulaValue}\nNew Price: RM {NewValue | formatnumber}\nPrice Change: RM {ValueChange | formatnumber}\n{/}\n{/}\n{/}',
        output: 'Name: Bumi Discount\nDescription: Discount for bumi buyer\nValue: 8\nNew Price: RM 230,000.60\nPrice Changes: RM 20,000.05'
      }]
    }]
  }, {
    title: 'Gender',
    sections: [{
      description: 'Purpose: To have a custom format for gender',
      examples: [{
        // title: '',
        syntax: '{#P1_Gender == "Male"} <u>M</u> / F{/}\n{^P1_Gender == "Male"} M / <u>F</u> {/}',
        output: 'M / <u>F</u>'
      }]
    }]
  }]
};

var CHECKBOXES_TAB = {
  text: 'Checkboxes',
  value: 'checkboxes',
  contents: [{
    title: 'Booking Payment Method Checkbox',
    sections: [{
      description: 'Purpose: To tick on selected payment method',
      examples: [{
        // title: '',
        // syntax: '',
        syntaxImage: 'source_finance_checkbox_input.png',
        // output: '',
        outputImage: 'source_finance_checkbox_output.png'
      }]
    }]
  }]
};

var LIST_TAB = {
  text: 'List / Tables',
  value: 'list_tables',
  contents: [{
    title: 'Direct usage of embedding mergetag in table',
    sections: [{
      description: 'Display purchaser name in a table',
      examples: [{
        syntaxImage: 'source_purchaser_name_table_input.png',
        outputImage: 'source_purchaser_name_table_output.png'
      }]
    }]
  }, {
    title: 'Display Projectunit Specifications (Listing)',
    sections: [{
      description: 'Display projectunit specifications in a table',
      examples: [{
        syntaxImage: 'source_projectunitspecs_input.png',
        outputImage: 'source_projectunitspecs_output.png'
      }]
    }]
  }, {
    title: 'Display Pricing Package in a table',
    sections: [{
      description: 'Display all Pricing Package',
      examples: [{
        syntaxImage: 'source_pricing_package_list_input.png',
        outputImage: 'source_pricing_package_list_output.png'
      }]
    }]
  }]
};

var IMAGES_TAB = {
  text: 'Signatures',
  value: 'signatures',
  contents: [{
    title: 'Direct usage of purchaser signature mergetag',
    sections: [{
      description: 'Display purchaser signature image',
      examples: [{
        syntax: '{%P1_Signature}',
        outputImage: 'source_purchaser_signature_output.png'
      }]
    }]
  }, {
    title: 'Purchaser signature with condition check',
    sections: [{
      description: 'Check if purchaser signature is available before displaying the image',
      examples: [{
        // title: '',
        syntax: '{#P1_Signature}{%P1_Signature}{/}',
        // syntaxImage: 'source_finance_checkbox_input.png',
        // output: '',
        outputImage: 'source_purchaser_signature_output.png'
      }]
    }]
  }]
};

var DATE_TAB = {
  text: 'Date',
  value: 'date',
  contents: [{
    title: 'Date Formatting',
    sections: [{
      description: 'Format date into selected format',
      examples: [{
        syntax: '{Booking_CreatedAt | date:\'YYYY-MM-DD\'}',
        output: '2025-04-18'
      }, {
        syntax: '{Booking_CreatedAt | date:\'DD-MM-YYYY\'}',
        output: '18-04-2025'
      }, {
        syntax: '{Booking_CreatedAt | date:\'MM-DD-YYYY\'}',
        output: '04-18-2025'
      }, {
        syntax: '{Booking_CreatedAt | date:\'DD-MMM-YYYY\'}',
        output: '18-Apr-2025'
      }, {
        syntax: '{Booking_CreatedAt | date:\'MMM DD, YYYY\'}',
        output: 'Apr 18, 2025'
      }, {
        syntax: '{Booking_CreatedAt | date:\'MMMM DD, YYYY\'}',
        output: 'April 18, 2025'
      }, {
        syntax: '{Booking_CreatedAt | date:\'DD MMMM YYYY\'}',
        output: '18 April 2025'
      }, {
        syntax: '{Booking_CreatedAt | date:\'YYYY/MM/DD\'}',
        output: '2025/04/18'
      }, {
        syntax: '{Booking_CreatedAt | date:\'DD/MM/YYYY\'}',
        output: '18/04/2025'
      }, {
        syntax: '{Booking_CreatedAt | date:\'MM/DD/YYYY\'}',
        output: '04/18/2025'
      }]
    }]
  }, {
    title: 'Current Date Mergetag',
    sections: [{
      description: 'Mergetag to display current date',
      examples: [{
        syntax: '{currentDate}',
        output: '2025-09-18 10:49:30'
      }, {
        syntax: 'Date formatter can be applied to this mergetag as well, e.g. {currentDate | date:\'DD-MM-YYYY\'}',
        output: '18-09-2025'
      }, {
        syntax: '{currentYear}',
        output: '2025'
      }, {
        syntax: '{currentMonth}',
        output: 'September'
      }, {
        syntax: '{currentDay}',
        output: '18'
      }]
    }]
  }]
};

var OPERATORS_TAB = {
  text: 'Operators',
  value: 'operators',
  contents: [{
    title: 'Supported Operators',
    sections: [{
      // description: 'Additional Operator, e.g. SPA_Price = 100000.00',
      description: 'General Operations',
      examples: [{
        title: 'Operation on raw number',
        syntax: '{SPA_Price + 50000.00}',
        output: '150000.00'
      }, {
        title: 'Operation on mergetag',
        syntax: '{SPA_Price + SPA_Price}',
        output: '200000.00'
      }]
    }, {
      description: 'Additional Operator, e.g. SPA_Price = 100000.00',
      examples: [{
        title: 'Addition mergetag with raw number',
        syntax: '{SPA_Price + 50000.00}',
        output: '150000.00'
      }, {
        title: 'Addition mergetag with mergetag',
        syntax: '{SPA_Price + SPA_Price}',
        output: '200000.00'
      }, {
        title: 'Multiple Addition Operation',
        syntax: '{SPA_Price + SPA_Price + SPA_Price}',
        output: '300000.00'
      }]
    }, {
      description: 'Substraction Operator, e.g. SPA_Price = 100000.00, Discount = 10000.00',
      examples: [{
        title: 'Substraction mergetag with raw number',
        syntax: '{SPA_Price - 50000.00}',
        output: '50000.00'
      }, {
        title: 'Substraction mergetag with mergetag',
        syntax: '{@Discount = 10000.00}\n{SPA_Price - Discount}',
        output: '90000.00'
      }, {
        title: 'Multiple Substraction mergetag with mergetag',
        syntax: '{@Discount = 10000.00}\n{SPA_Price - Discount - 50000.00}',
        output: '40000.00'
      }]
    }, {
      description: 'Multiplication Operator, e.g. SPA_Price = 100000.00, Times = 5',
      examples: [{
        title: 'Multiplication mergetag with raw number',
        syntax: '{SPA_Price * 5}',
        output: '500000.00'
      }, {
        title: 'Multiplication mergetag with mergetag',
        syntax: '{@Times = 5}\n{SPA_Price * Times}',
        output: '500000.00'
      }, {
        title: 'Multiple Multiplication Operation',
        syntax: '{@Times = 5}\n{SPA_Price * Times * 5}',
        output: '2500000.00'
      }]
    }, {
      description: 'Division Operator, e.g. SPA_Price = 100000.00, DivNumber = 5',
      examples: [{
        title: 'Division mergetag with raw number',
        syntax: '{SPA_Price / 5}',
        output: '20000.00'
      }, {
        title: 'Division mergetag with mergetag',
        syntax: '{@DivNumber = 5}\n{SPA_Price / DivNumber}',
        output: '20000.00'
      }, {
        title: 'Multiple Division Operation',
        syntax: '{@DivNumber = 5}\n{SPA_Price / DivNumber / 5}',
        output: '4000.00'
      }]
    }]
  }, {
    title: 'Pricing Package Operation Example',
    sections: [{
      description: 'Additional in Pricing Package Items',
      examples: [{
        title: 'Additional with single condition and field selection',
        syntax: "{Pricing_Package | where:'IsEnabled == true' | sumBy:'ValueChange'}",
        output: '500000.00'
      }, {
        title: 'Additional with multiple condition and field selection',
        syntax: "{Pricing_Package | sumIf:'(Name == \"test1\" || Name == \"111\") && IsEnabled == true':'ValueChange'}",
        output: '500000.00'
      }]
    }]
  }]
};

var DOCX_TEMPLATE_SUPPORTED_FONTS = exports.DOCX_TEMPLATE_SUPPORTED_FONTS = ['Arial', 'Times New Roman', 'Calibri', 'Garamond', 'Cambria', 'Verdana', 'Georgia', 'Book Antiqua', 'Tahoma', 'Trebuchet MS'];

var DOCX_TEMPLATE_GUIDES = [BASIC_TAB, CONDITIONS_TAB, CHECKBOXES_TAB, LIST_TAB, IMAGES_TAB, DATE_TAB, OPERATORS_TAB];

exports.default = DOCX_TEMPLATE_GUIDES;

/***/ }),
/* 2223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var BACUSEXP = 'BACUSEXP'; // BANKER ACCEPTANCES - EXPORT, CUSTOMER LIABILITIES
var BACUSIMP = 'BACUSIMP'; // BANKER ACCEPTANCES - IMPORT, CUSTOMER LIABILITIES
var BACUSPCH = 'BACUSPCH'; // BANKER ACCEPTANCES - PURCHASE/SALES, CUSTOMER LIABILITIES
var BANKACCP = 'BANKACCP'; // BANKER ACCEPTANCES - PURCHASE/SALES, CUSTOMER LIABILITIES
var BAOWNEXP = 'BAOWNEXP'; // BANKER ACCEPTANCES - EXPORT, OWN BILLS DISCOUNTED
var BAOWNIMP = 'BAOWNIMP'; // BANKER ACCEPTANCES - IMPORT,  OWN BILLS DISCOUNTED
var BAOWNPCH = 'BAOWNPCH'; // BANKER ACCEPTANCES - PURCHASE/SALES,  OWN BILLS DISCOUNTED
var BLOKDNSG = 'BLOKDNSG'; // BLOCK DISCOUNTING FOR NON-SCHEDULED GOODS BILLS DISCOUNTED
var BLOKDREC = 'BLOKDREC'; // BLOCK DISCOUNTING RECEIVABLESEDULED GOODS
var BLOKDSCG = 'BLOKDSCG'; // BLOCK DISCOUNTING FOR SCHEDULED GOODS
var BRIDGING = 'BRIDGING'; // CONSTRUCTION BRIDGING LOAN/FINANCEODS
var BRLNFNCE = 'BRLNFNCE'; // BRIDGING LOANS/FINANCINGAN/FINANCE
var CHRGCARD = 'CHRGCARD'; // CHARGE CARDANS/FINANCING
var CRDTCARD = 'CRDTCARD'; // CREDIT CARD
var DMBLPCHD = 'DMBLPCHD'; // DOMESTIC BILLS PURCHASED
var EXPCRDRE = 'EXPCRDRE'; // EXPORT CREDIT REFINANCING
var FACTORNG = 'FACTORNG'; // FACTORING RECEIVABLENCING
var FGBLPCHD = 'FGBLPCHD'; // FOREIGN BILLS PURCHASED
var FLRSTCKG = 'FLRSTCKG'; // FLOOR STOCKING LOANS/FINANCING
var FNGNTRDE = 'FNGNTRDE'; // FINANCIAL GUARANTEE - NON-TRADE
var FNGTRADE = 'FNGTRADE'; // FINANCIAL GUARANTEE - TRADERADE
var FNINSOFN = 'FNINSOFN'; // FINANCIAL INSTITUTION OWN FUND
var FWFGNECH = 'FWFGNECH'; // FORWARD FOREIGN EXCHANGEN FUND
var HLFNNNPS = 'HLFNNNPS'; // NON-PRIORITY HOUSING LOAN/FINANCE
var HLFNPRSR = 'HLFNPRSR'; // PRIORITY SECTOR HOUSING LOAN/FINANCE
var HRPCNSCG = 'HRPCNSCG'; // HIRE PURCHASE FOR NON-SCHEDULED GOODS
var HRPCSCGD = 'HRPCSCGD'; // HIRE PURCHASE FOR SCHEDULED GOODSOODS
var HSLNFNCE = 'HSLNFNCE'; // HOUSING LOANS/FINANCINGULED GOODS
var ISBENECT = 'ISBENECT'; // BENEVOLENT CREDITANCING
var ISEQYFNG = 'ISEQYFNG'; // EQUITY FINANCINGT
var ISPJTFNG = 'ISPJTFNG'; // PROJECT FINANCING
var ISPWNBKG = 'ISPWNBKG'; // PAWNBROKINGANCING
var LEASING = 'LEASING'; // LEASING RECEIVABLES
var LOANSTCK = 'LOANSTCK'; // LOAN STOCK (ARISING FROM RESTRUCTURING)
var LTCREDIT = 'LTCREDIT'; // LETTER OF CREDITING FROM RESTRUCTURING)
var MICROEFN = 'MICROEFN'; // MICRO ENTERPRISE FUND
var OHRPCREC = 'OHRPCREC'; // OTHER HIRE PURCHASE RECEIVABLES
var OPCQPCHD = 'OPCQPCHD'; // OUTPORT CHEQUE PURCHASEDIVABLES
var OTHLNFIN = 'OTHLNFIN'; // OTHER LOANS/FINANCINGSED
var OTLNFNCE = 'OTLNFNCE'; // OTHER TERM LOANS/FINANCING
var OTSHTFAC = 'OTSHTFAC'; // OTHER OFF-BALANCE SHEET FACILITIES
var OTTRDDIS = 'OTTRDDIS'; // OTHER TRADE BILLS DISCOUNTEDLITIES
var OTTRDFAC = 'OTTRDFAC'; // OTHER TRADE FACILITIESOUNTED
var OVRDRAFT = 'OVRDRAFT'; // OVERDRAFTDE FACILITIES
var PCPASCAR = 'PCPASCAR'; // PURCHASE OF PASSENGER CARS
var PELNFNCE = 'PELNFNCE'; // PERSONAL LOANS/FINANCINGRS
var PGRANTEE = 'PGRANTEE'; // PERFORMANCE GUARANTEEING
var POSHPECR = 'POSHPECR'; // POST-SHIPMENT ECRNTEE
var PRESHPCR = 'PRESHPCR'; // PRE-SHIPMENT ECRR
var RVVGCRDT = 'RVVGCRDT'; // REVOLVING CREDIT
var SBLTCRDT = 'SBLTCRDT'; // STANDBY LETTER OF CREDIT
var SHMARGIN = 'SHMARGIN'; // SHARE MARGIN FINANCINGIT
var SHPGRTEE = 'SHPGRTEE'; // SHIPPING GUARANTEECING
var STLNFNCE = 'STLNFNCE'; // STAFF LOAN/FINANCE
var TEMPOVDT = 'TEMPOVDT'; // TEMPORARY OVERDRAFT
var TFWORECO = 'TFWORECO'; // TRADE FINANCE WITHOUT RECOURSE
var TRECEIPT = 'TRECEIPT'; // TRUST RECEIPTSWITHOUT RECOURSE

var FACILITY_CODES = exports.FACILITY_CODES = [BACUSEXP, BACUSIMP, BACUSPCH, BANKACCP, BAOWNEXP, BAOWNIMP, BAOWNPCH, BLOKDNSG, BLOKDREC, BLOKDSCG, BRIDGING, BRLNFNCE, CHRGCARD, CRDTCARD, DMBLPCHD, EXPCRDRE, FACTORNG, FGBLPCHD, FLRSTCKG, FNGNTRDE, FNGTRADE, FNINSOFN, FWFGNECH, HLFNNNPS, HLFNPRSR, HRPCNSCG, HRPCSCGD, HSLNFNCE, ISBENECT, ISEQYFNG, ISPJTFNG, ISPWNBKG, LEASING, LOANSTCK, LTCREDIT, MICROEFN, OHRPCREC, OPCQPCHD, OTHLNFIN, OTLNFNCE, OTSHTFAC, OTTRDDIS, OTTRDFAC, OVRDRAFT, PCPASCAR, PELNFNCE, PGRANTEE, POSHPECR, PRESHPCR, RVVGCRDT, SBLTCRDT, SHMARGIN, SHPGRTEE, STLNFNCE, TEMPOVDT, TFWORECO, TRECEIPT];

var isFacilityCodeVehicle = exports.isFacilityCodeVehicle = function isFacilityCodeVehicle(code) {
  return [HRPCNSCG, HRPCSCGD, PCPASCAR, OHRPCREC].some(function (c) {
    return c === code;
  });
};

var isFacilityCodeCreditCard = exports.isFacilityCodeCreditCard = function isFacilityCodeCreditCard(code) {
  return [CHRGCARD, CRDTCARD].some(function (c) {
    return c === code;
  });
};

var isFacilityCodeHouse = exports.isFacilityCodeHouse = function isFacilityCodeHouse(code) {
  return [HLFNNNPS, HLFNPRSR, HSLNFNCE].some(function (c) {
    return c === code;
  });
};

var isFacilityCodePersonal = exports.isFacilityCodePersonal = function isFacilityCodePersonal(code) {
  return code === PELNFNCE;
};

var isFacilityCodeSpecialOther = exports.isFacilityCodeSpecialOther = function isFacilityCodeSpecialOther(code) {
  return code === OTLNFNCE;
};

var isFacilityCodeOther = exports.isFacilityCodeOther = function isFacilityCodeOther(code) {
  return !isFacilityCodeVehicle(code) && !isFacilityCodeCreditCard(code) && !isFacilityCodeHouse(code) && !isFacilityCodePersonal(code);
};

/***/ }),
/* 2224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var IFCA_STATUSES = [{ text: 'Not Initiated', value: 'none' }, { text: 'Synchronizing', value: 'syncing' }, { text: 'Success', value: 'success' }, { text: 'Failed', value: 'failed' }];
exports.default = IFCA_STATUSES;

/***/ }),
/* 2225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var INSOFT_STATUSES = [{ text: 'Not Initiated', value: 'none' }, { text: 'Synchronizing', value: 'syncing' }, { text: 'Success', value: 'success' }, { text: 'Failed', value: 'failed' }];
exports.default = INSOFT_STATUSES;

/***/ }),
/* 2226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var JDE_STATUSES = [{ text: 'Not Initiated', value: 'none' }, { text: 'Success', value: 'success' }, { text: 'Failed', value: 'failed' }];
exports.default = JDE_STATUSES;

/***/ }),
/* 2227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var NOETIC_STATUSES = [{ text: 'Not Initiated', value: 'none' }, { text: 'Synchronizing', value: 'syncing' }, { text: 'Success', value: 'success' }, { text: 'Failed', value: 'failed' }];
exports.default = NOETIC_STATUSES;

/***/ }),
/* 2228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PAYMENT_REFUND_STATUS = exports.PAYMENT_REFUND_STATUS = {
  PENDING_REFUND: 'pending_refund',
  REFUNDED: 'refunded'
};

var PAYMENT_REFUND_STATUSES = exports.PAYMENT_REFUND_STATUSES = [{ text: 'Pending Refund', value: PAYMENT_REFUND_STATUS.PENDING_REFUND }, { text: 'Refunded', value: PAYMENT_REFUND_STATUS.REFUNDED }];

/***/ }),
/* 2229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var PAYMS_PAYMENT_GATEWAY_BILLPLZ = exports.PAYMS_PAYMENT_GATEWAY_BILLPLZ = 'BILLPLZ';
var PAYMS_PAYMENT_GATEWAY_IPAY88 = exports.PAYMS_PAYMENT_GATEWAY_IPAY88 = 'IPAY88';
var PAYMS_PAYMENT_GATEWAY_RAZERPAY = exports.PAYMS_PAYMENT_GATEWAY_RAZERPAY = 'RAZERPAY';

/***/ }),
/* 2230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SCORE_SCALES = exports.SCORE_SCALES = [{
  scale: 300,
  title: 'Very Weak',
  subtitle: '300-528',
  color: '#ED1C24'
}, {
  scale: 529,
  title: 'Weak',
  subtitle: '529-650',
  color: '#F7941E'
}, {
  scale: 651,
  title: 'Below Average',
  subtitle: '651-696',
  color: '#F2E300'
}, {
  scale: 697,
  title: 'Above Average',
  subtitle: '697-717',
  color: '#D8DA17'
}, {
  scale: 718,
  title: 'Good',
  subtitle: '718-743',
  color: '#A6CE39'
}, {
  scale: 744,
  title: 'Excellent',
  subtitle: '744-850',
  color: '#00984A'
}, {
  scale: 0,
  title: 'No score',
  subtitle: null,
  color: '#A6A6A6'
}].sort(function (a, b) {
  return b.scale - a.scale;
});

/***/ }),
/* 2231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SRP_LOAN_TYPE = [{ text: 'Yes', value: 'yes' }, { text: 'No', value: 'no' }];
exports.default = SRP_LOAN_TYPE;

/***/ }),
/* 2232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TOKEN_PAYMENT_STATUS = exports.TOKEN_PAYMENT_STATUS = {
  PENDING_PAYMENT: 'pending_payment',
  PARTIALLY_PAID: 'partially_paid',
  PAID_UNVERIFIED: 'paid_unverified',
  PAID_VERIFIED: 'paid_verified',
  EXPIRED: 'expired',
  PARTIALLY_REFUNDED: 'partially_refunded',
  REFUNDED: 'refunded',
  CANCELLED: 'cancelled'
};

var TOKEN_PAYMENT_STATUSES = [{ text: 'Pending Payment', value: TOKEN_PAYMENT_STATUS.PENDING_PAYMENT }, { text: 'Partially Paid', value: TOKEN_PAYMENT_STATUS.PARTIALLY_PAID }, { text: 'Paid Unverified', value: TOKEN_PAYMENT_STATUS.PAID_UNVERIFIED }, { text: 'Paid Verified', value: TOKEN_PAYMENT_STATUS.PAID_VERIFIED }, { text: 'Expired', value: TOKEN_PAYMENT_STATUS.EXPIRED }, { text: 'Partially Refunded', value: TOKEN_PAYMENT_STATUS.PARTIALLY_REFUNDED }, { text: 'Refunded', value: TOKEN_PAYMENT_STATUS.REFUNDED }, { text: 'Cancelled', value: TOKEN_PAYMENT_STATUS.CANCELLED }];

var TOKEN_PAYMENT_STATUS_MAP = exports.TOKEN_PAYMENT_STATUS_MAP = TOKEN_PAYMENT_STATUSES.reduce(function (acc, val) {
  return _extends({}, acc, _defineProperty({}, val.value, val));
}, {});

exports.default = TOKEN_PAYMENT_STATUSES;

/***/ }),
/* 2233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _semanticUiReact = __webpack_require__(2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _reactRouter = __webpack_require__(18);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _url = __webpack_require__(19);

var _isbase = __webpack_require__(157);

var _isbase2 = _interopRequireDefault(_isbase);

var _Filters = __webpack_require__(86);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Accounting = function (_Component) {
  _inherits(Accounting, _Component);

  function Accounting(props) {
    _classCallCheck(this, Accounting);

    var _this = _possibleConstructorReturn(this, (Accounting.__proto__ || Object.getPrototypeOf(Accounting)).call(this, props));

    _initialiseProps.call(_this);

    var state = Accounting.getPropsToState(props);
    state.data = [];
    _this.state = _extends({
      loading: true,
      count: 0,
      limit: 10,
      offset: 0,
      token: ''
    }, state);
    var query = (0, _url.decodeSearch)(props.location.search);
    if (query.projectFilter && query.projectFilter.length > 0) {
      _this.state.advanceFilter = true;
    }
    return _this;
  }

  _createClass(Accounting, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      this.fetchBookings(query);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Accounting.getPropsToState(nextProps);
      var query = (0, _url.decodeSearch)(nextProps.location.search);
      if (this.state.limit < 0) {
        this.fetchBookings(query);
        state.loading = this.state.loading;
      }
      state.token = this.state.token;
      if (query.projectFilter && query.projectFilter.length > 0) {
        state.advanceFilter = true;
      }
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoadingSearch',
    value: function setLoadingSearch() {
      var _this3 = this;

      var loadingSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loadingSearch: loadingSearch }, res);
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'setBookings',
    value: function setBookings() {
      var _this5 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this5.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'fetchBookings',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var store, query, res, message, _message, count, limit, offset, token, data, newData, que;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = Object.assign(q, this.props.where || {});
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/noetic/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 23;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                if (!(_context.t0.res && _context.t0.res.status >= 399 && _context.t0.res.status < 500)) {
                  _context.next = 18;
                  break;
                }

                _context.next = 16;
                return _context.t0.res.text();

              case 16:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 18:
                _context.next = 20;
                return this.setLoading(false);

              case 20:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context.abrupt('return');

              case 23:
                if (res.ok) {
                  _context.next = 31;
                  break;
                }

                _context.next = 26;
                return res.text();

              case 26:
                _message = _context.sent;
                _context.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 29:
                _context.next = 50;
                break;

              case 31:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                token = res.headers.get('X-CSRF-Token');
                _context.next = 37;
                return res.json();

              case 37:
                data = _context.sent;
                newData = [];

                if (data) {
                  newData = data;
                  data.forEach(function (d, idx) {
                    newData[idx].send = false;
                  });
                }
                _context.next = 42;
                return this.setBookings(newData);

              case 42:
                if (!(this.state.data.length < 1 && query.page > 1)) {
                  _context.next = 48;
                  break;
                }

                que = (0, _url.decodeSearch)(this.props.location.search);

                que.page = 1;
                this.replaceQuery(que);
                _context.next = 50;
                break;

              case 48:
                _context.next = 50;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset,
                  token: token
                });

              case 50:
                _context.next = 52;
                return this.setLoading(false);

              case 52:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchBookings() {
        return _ref.apply(this, arguments);
      }

      return fetchBookings;
    }()
  }, {
    key: 'searchProjects',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(value) {
        var _this6 = this;

        var store, res, message, json, findProjectResults, noResultsMessage;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                _context2.next = 3;
                return this.setLoadingSearch(true);

              case 3:
                res = null;
                _context2.prev = 4;
                _context2.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/search/projects/?limit=3&search=' + value, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context2.sent;
                _context2.next = 21;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](4);

                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 15;
                return _context2.t0.res.text();

              case 15:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 17:
                _context2.next = 19;
                return this.setLoadingSearch(false);

              case 19:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));

              case 21:
                if (res.ok) {
                  _context2.next = 27;
                  break;
                }

                _context2.next = 24;
                return this.setLoadingSearch(false);

              case 24:
                throw new Error('Not OK');

              case 27:
                _context2.next = 29;
                return this.setLoadingSearch(false);

              case 29:
                _context2.next = 31;
                return res.json();

              case 31:
                json = _context2.sent;

                if (json) {
                  findProjectResults = json.map(function (obj) {
                    var newResults = {};
                    newResults.key = obj.id;
                    newResults.title = obj.shortName;
                    newResults.description = obj.state;
                    if (obj.pictureKey !== '') {
                      newResults.image = (0, _url.AWSUrl)(_this6.props.appConfig, obj.pictureKey + '010.jpg');
                    } else {
                      newResults.image = '/assets/images/placeholder_x100.jpg';
                    }
                    return newResults;
                  });

                  this.setState({ findProjectResults: findProjectResults });
                } else {
                  noResultsMessage = 'No results found.';

                  this.setState({ noResultsMessage: noResultsMessage });
                }

              case 33:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10]]);
      }));

      function searchProjects(_x6) {
        return _ref2.apply(this, arguments);
      }

      return searchProjects;
    }()
  }, {
    key: 'submitNoetic',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
        var store, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _context3.prev = 3;
                _context3.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/noetic/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(data)
                }));

              case 6:
                _context3.next = 21;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](3);
                _context3.next = 12;
                return this.setLoading(false);

              case 12:
                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 18;
                  break;
                }

                _context3.next = 15;
                return _context3.t0.res.text();

              case 15:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 18:
                Bugsnag.notifyException(_context3.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context3.abrupt('return');

              case 21:
                _context3.next = 23;
                return this.setLoading(false);

              case 23:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Success', message: 'Selected booking(s) has been added to the noetic synchronizing queue' }));
                this.fetchBookings();

              case 25:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 8]]);
      }));

      function submitNoetic(_x7) {
        return _ref3.apply(this, arguments);
      }

      return submitNoetic;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      store.dispatch((0, _reactRouterRedux.replace)('/accounting/?' + (0, _url.encodeSearch)(query)));
      this.fetchBookings(query);
    }
  }, {
    key: 'pushQuery',
    value: function pushQuery(query) {
      var store = this.context.store;

      store.dispatch((0, _reactRouterRedux.replace)('/accounting/?' + (0, _url.encodeSearch)(query)));
      this.fetchBookings(query);
    }
  }, {
    key: 'hasSelectedItems',
    value: function hasSelectedItems() {
      var data = this.state.data;

      var isSelected = false;
      data.forEach(function (d) {
        if (d.send) {
          isSelected = true;
        }
      });
      return isSelected;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var query = (0, _url.decodeSearch)(this.props.location.search);
      var _state = this.state,
          data = _state.data,
          loading = _state.loading;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: 'Post-Sale',
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              disabled: !this.hasSelectedItems() || loading,
              icon: 'check circle',
              content: 'Send Selected',
              color: 'green',
              size: 'medium',
              compact: true,
              onClick: this.handleSendSelected
            })
          )
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { padding: '0' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              _react2.default.createElement(
                'b',
                null,
                'Send Booked and Sold Booking(s) To Noetic'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _SearchFilter2.default,
                {
                  advanceFilter: this.state.advanceFilter,
                  isLoading: this.state.loading,
                  onChange: this.handleFilterOnChange,
                  onClose: this.handleClearFilter,
                  search: this.state.search,
                  setAdvanceFilter: this.handleSetAdvanceFilter,
                  placeholder: 'Search...',
                  leftNav: _react2.default.createElement(_PageNav2.default, {
                    currentPage: this.state.currentPage,
                    count: this.state.count,
                    limit: this.state.limit,
                    offset: this.state.offset,
                    dataSize: this.state.data.length,
                    loading: this.state.loading,
                    onChange: this.handleChangePage
                  }),
                  rightNav: _react2.default.createElement(_SortButton2.default, {
                    floated: 'right',
                    loading: this.state.loading,
                    items: this.sortItems,
                    onSort: this.handleSortData
                  })
                },
                _react2.default.createElement(_Filters.SearchList, {
                  filterName: 'projectFilter',
                  icon: 'find',
                  isActive: query.projectFilter && query.projectFilter.length > 0 || false,
                  loading: this.state.loadingSearch,
                  noResultsMessage: this.state.noResultsMessage,
                  onChange: this.handleSearchProject,
                  onClose: this.handleClearFilter,
                  onSelect: this.handleSelectProject,
                  placeholder: 'Find Project',
                  results: this.state.findProjectResults,
                  value: this.state.projectFilter
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement('br', { className: 'large-hide' }),
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  'Loading'
                )
              ),
              data.length > 0 ? _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 2, className: 'equal height' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    _react2.default.createElement(
                      'div',
                      { style: { overflowX: 'auto' } },
                      _react2.default.createElement(
                        _semanticUiReact.Table,
                        {
                          compact: true,
                          unstackable: true,
                          selectable: true
                        },
                        _react2.default.createElement(
                          _semanticUiReact.Table.Header,
                          { className: 'mobile-hide' },
                          _react2.default.createElement(
                            _semanticUiReact.Table.Row,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              null,
                              'Date'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              null,
                              'Booking'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              null,
                              'Unit'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              null,
                              'Purchaser'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              { textAlign: 'center' },
                              'Send'
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Table.Body,
                          null,
                          data.map(function (d, idx) {
                            return _react2.default.createElement(
                              _semanticUiReact.Table.Row,
                              {
                                key: idx
                              },
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _react2.default.createElement(_Timestamp2.default, {
                                  timestamp: d.createdAt,
                                  format: 'DD/M/YYYY'
                                })
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _react2.default.createElement(
                                  _reactRouter.Link,
                                  { to: '/bookings/' + d.id + '/' },
                                  d.code
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _react2.default.createElement(
                                  _reactRouter.Link,
                                  { title: d.code, to: '/bookings/' + d.id + '/' },
                                  d.projectUnit.reference,
                                  ', ',
                                  d.project.shortName,
                                  d.projectUnit.isBumi && _react2.default.createElement(
                                    _semanticUiReact.Label,
                                    { size: 'mini', style: { marginLeft: '0.5em' } },
                                    'Bumi'
                                  )
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _react2.default.createElement(
                                  _reactRouter.Link,
                                  { title: d.code, to: '/bookings/' + d.id + '/' },
                                  d.bookingCustomer && d.bookingCustomer.name
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { collapsing: true, textAlign: 'center' },
                                _react2.default.createElement(_semanticUiReact.Checkbox, {
                                  toggle: true,
                                  checked: d.send,
                                  onChange: function onChange(e) {
                                    return _this7.handleCheckboxChange(e, idx);
                                  }
                                })
                              )
                            );
                          })
                        )
                      )
                    )
                  )
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Item,
                      { style: {} },
                      _react2.default.createElement(
                        _semanticUiReact.Item.Content,
                        null,
                        !loading ? _react2.default.createElement(
                          _semanticUiReact.Segment,
                          { textAlign: 'center' },
                          _react2.default.createElement(
                            'p',
                            null,
                            'No bookings found.'
                          )
                        ) : ''
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Accounting;
}(_react.Component);

Accounting.contextTypes = {
  appConfig: _propTypes2.default.shape({}),
  store: _propTypes2.default.object
};
Accounting.propTypes = {
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  })
};

Accounting.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig
  };
};

Accounting.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var advanceFilter = false;
  var projectFilter = (0, _isbase2.default)(query.projectFilter) && _qs2.default.parse(atob(query.projectFilter)).name || '';
  return {
    currentPage: currentPage,
    search: search,
    advanceFilter: advanceFilter,
    projectFilter: projectFilter,
    loadingSearch: false,
    findProjectResults: [],
    noResultsMessage: 'Loading...'
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this8 = this;

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    query.page = currentPage;
    _this8.setState({
      currentPage: currentPage
    });
    _this8.pushQuery(query);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this8.replaceQuery(query, true);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    _this8.setState({
      search: ''
    }, function () {
      if (hasQuery) {
        _this8.replaceQuery(query, true);
      }
    });
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    query[queryName] = value;
    _this8.replaceQuery(query, true);
  };

  this.handleSetAdvanceFilter = function (advanceFilter) {
    _this8.setState({
      advanceFilter: advanceFilter
    });
  };

  this.handleSearchProject = function (value) {
    clearTimeout(_this8.setTimer);
    // always reset results to null before finding
    var findProjectResults = [];
    var noResultsMessage = 'Loading...';
    _this8.setState({ findProjectResults: findProjectResults, noResultsMessage: noResultsMessage, projectFilter: value }, function () {
      if (value !== '') {
        _this8.setTimer = setTimeout(function () {
          _this8.searchProjects(value);
        }, 500);
      }
    });
  };

  this.handleSelectProject = function (project, queryName) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    var internalQuery = {};
    internalQuery.id = project.key;
    internalQuery.name = project.title;
    query[queryName] = btoa(_qs2.default.stringify(internalQuery));
    _this8.replaceQuery(query, true);
  };

  this.handleCheckboxChange = function (e, id) {
    var data = _this8.state.data;

    data[id].send = !data[id].send;
    _this8.setState({ data: data });
  };

  this.handleSendSelected = function (e) {
    e.preventDefault();
    var data = _this8.state.data;

    var ids = [];
    data.forEach(function (d) {
      if (d.send) {
        ids.push(d.id);
      }
    });
    _this8.submitNoetic(ids);
  };

  this.sortItems = [{
    text: 'Oldest Booking First',
    icon: 'sort alphabet ascending',
    sortColumn: 'booking.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Latest Booking First',
    icon: 'sort alphabet descending',
    sortColumn: 'booking.created_at',
    sortDirection: 'desc'
  }];
};

exports.default = (0, _reactRedux.connect)(Accounting.mapStateToProps)(Accounting);

/***/ }),
/* 2234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Accounting = __webpack_require__(2233);

var _Accounting2 = _interopRequireDefault(_Accounting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Accounting2.default;

/***/ }),
/* 2235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _semanticUiReact = __webpack_require__(2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _reactRouter = __webpack_require__(18);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _url = __webpack_require__(19);

var _isbase = __webpack_require__(157);

var _isbase2 = _interopRequireDefault(_isbase);

var _Filters = __webpack_require__(86);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountingIFCA = function (_Component) {
  _inherits(AccountingIFCA, _Component);

  function AccountingIFCA(props) {
    _classCallCheck(this, AccountingIFCA);

    var _this = _possibleConstructorReturn(this, (AccountingIFCA.__proto__ || Object.getPrototypeOf(AccountingIFCA)).call(this, props));

    _initialiseProps.call(_this);

    var state = AccountingIFCA.getPropsToState(props);
    state.data = [];
    _this.state = _extends({
      loading: true,
      count: 0,
      limit: 10,
      offset: 0,
      token: ''
    }, state);
    var query = (0, _url.decodeSearch)(props.location.search);
    if (query.projectFilter && query.projectFilter.length > 0) {
      _this.state.advanceFilter = true;
    }
    return _this;
  }

  _createClass(AccountingIFCA, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      this.fetchBookings(query);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = AccountingIFCA.getPropsToState(nextProps);
      var query = (0, _url.decodeSearch)(nextProps.location.search);
      if (this.state.limit < 0) {
        this.fetchBookings(query);
        state.loading = this.state.loading;
      }
      state.token = this.state.token;
      if (query.projectFilter && query.projectFilter.length > 0) {
        state.advanceFilter = true;
      }
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoadingSearch',
    value: function setLoadingSearch() {
      var _this3 = this;

      var loadingSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loadingSearch: loadingSearch }, res);
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'setBookings',
    value: function setBookings() {
      var _this5 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this5.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'fetchBookings',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var store, query, res, message, _message, count, limit, offset, token, data, newData, que;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = Object.assign(q, this.props.where || {});
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/ifca/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 23;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                if (!(_context.t0.res && _context.t0.res.status >= 399 && _context.t0.res.status < 500)) {
                  _context.next = 18;
                  break;
                }

                _context.next = 16;
                return _context.t0.res.text();

              case 16:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 18:
                _context.next = 20;
                return this.setLoading(false);

              case 20:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context.abrupt('return');

              case 23:
                if (res.ok) {
                  _context.next = 31;
                  break;
                }

                _context.next = 26;
                return res.text();

              case 26:
                _message = _context.sent;
                _context.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 29:
                _context.next = 50;
                break;

              case 31:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                token = res.headers.get('X-CSRF-Token');
                _context.next = 37;
                return res.json();

              case 37:
                data = _context.sent;
                newData = [];

                if (data) {
                  newData = data;
                  data.forEach(function (d, idx) {
                    newData[idx].send = false;
                  });
                }
                _context.next = 42;
                return this.setBookings(newData);

              case 42:
                if (!(this.state.data.length < 1 && query.page > 1)) {
                  _context.next = 48;
                  break;
                }

                que = (0, _url.decodeSearch)(this.props.location.search);

                que.page = 1;
                this.replaceQuery(que);
                _context.next = 50;
                break;

              case 48:
                _context.next = 50;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset,
                  token: token
                });

              case 50:
                _context.next = 52;
                return this.setLoading(false);

              case 52:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchBookings() {
        return _ref.apply(this, arguments);
      }

      return fetchBookings;
    }()
  }, {
    key: 'searchProjects',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(value) {
        var _this6 = this;

        var store, res, message, json, findProjectResults, noResultsMessage;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                _context2.next = 3;
                return this.setLoadingSearch(true);

              case 3:
                res = null;
                _context2.prev = 4;
                _context2.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/search/projects/?limit=3&search=' + value, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context2.sent;
                _context2.next = 21;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](4);

                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 15;
                return _context2.t0.res.text();

              case 15:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 17:
                _context2.next = 19;
                return this.setLoadingSearch(false);

              case 19:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));

              case 21:
                if (res.ok) {
                  _context2.next = 27;
                  break;
                }

                _context2.next = 24;
                return this.setLoadingSearch(false);

              case 24:
                throw new Error('Not OK');

              case 27:
                _context2.next = 29;
                return this.setLoadingSearch(false);

              case 29:
                _context2.next = 31;
                return res.json();

              case 31:
                json = _context2.sent;

                if (json) {
                  findProjectResults = json.map(function (obj) {
                    var newResults = {};
                    newResults.key = obj.id;
                    newResults.title = obj.shortName;
                    newResults.description = obj.state;
                    if (obj.pictureKey !== '') {
                      newResults.image = (0, _url.AWSUrl)(_this6.props.appConfig, obj.pictureKey + '010.jpg');
                    } else {
                      newResults.image = '/assets/images/placeholder_x100.jpg';
                    }
                    return newResults;
                  });

                  this.setState({ findProjectResults: findProjectResults });
                } else {
                  noResultsMessage = 'No results found.';

                  this.setState({ noResultsMessage: noResultsMessage });
                }

              case 33:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10]]);
      }));

      function searchProjects(_x6) {
        return _ref2.apply(this, arguments);
      }

      return searchProjects;
    }()
  }, {
    key: 'submitIFCA',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
        var store, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _context3.prev = 3;
                _context3.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/ifca/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(data)
                }));

              case 6:
                _context3.next = 21;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](3);
                _context3.next = 12;
                return this.setLoading(false);

              case 12:
                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 18;
                  break;
                }

                _context3.next = 15;
                return _context3.t0.res.text();

              case 15:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 18:
                Bugsnag.notifyException(_context3.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context3.abrupt('return');

              case 21:
                _context3.next = 23;
                return this.setLoading(false);

              case 23:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Success', message: 'Selected booking(s) has been added to the ifca synchronizing queue' }));
                this.fetchBookings();

              case 25:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 8]]);
      }));

      function submitIFCA(_x7) {
        return _ref3.apply(this, arguments);
      }

      return submitIFCA;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      store.dispatch((0, _reactRouterRedux.replace)('/accounting/?' + (0, _url.encodeSearch)(query)));
      this.fetchBookings(query);
    }
  }, {
    key: 'pushQuery',
    value: function pushQuery(query) {
      var store = this.context.store;

      store.dispatch((0, _reactRouterRedux.replace)('/accounting/?' + (0, _url.encodeSearch)(query)));
      this.fetchBookings(query);
    }
  }, {
    key: 'hasSelectedItems',
    value: function hasSelectedItems() {
      var data = this.state.data;

      var isSelected = false;
      data.forEach(function (d) {
        if (d.send) {
          isSelected = true;
        }
      });
      return isSelected;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var query = (0, _url.decodeSearch)(this.props.location.search);
      var _state = this.state,
          data = _state.data,
          loading = _state.loading;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: 'Post-Sale',
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              disabled: !this.hasSelectedItems() || loading,
              icon: 'check circle',
              content: 'Send Selected',
              color: 'green',
              size: 'medium',
              compact: true,
              onClick: this.handleSendSelected
            })
          )
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { padding: '0' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              _react2.default.createElement(
                'b',
                null,
                'Send Sold Booking(s) To IFCA'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _SearchFilter2.default,
                {
                  advanceFilter: this.state.advanceFilter,
                  isLoading: this.state.loading,
                  onChange: this.handleFilterOnChange,
                  onClose: this.handleClearFilter,
                  search: this.state.search,
                  setAdvanceFilter: this.handleSetAdvanceFilter,
                  placeholder: 'Search...',
                  leftNav: _react2.default.createElement(_PageNav2.default, {
                    currentPage: this.state.currentPage,
                    count: this.state.count,
                    limit: this.state.limit,
                    offset: this.state.offset,
                    dataSize: this.state.data.length,
                    loading: this.state.loading,
                    onChange: this.handleChangePage
                  }),
                  rightNav: _react2.default.createElement(_SortButton2.default, {
                    floated: 'right',
                    loading: this.state.loading,
                    items: this.sortItems,
                    onSort: this.handleSortData
                  })
                },
                _react2.default.createElement(_Filters.SearchList, {
                  filterName: 'projectFilter',
                  icon: 'find',
                  isActive: query.projectFilter && query.projectFilter.length > 0 || false,
                  loading: this.state.loadingSearch,
                  noResultsMessage: this.state.noResultsMessage,
                  onChange: this.handleSearchProject,
                  onClose: this.handleClearFilter,
                  onSelect: this.handleSelectProject,
                  placeholder: 'Find Project',
                  results: this.state.findProjectResults,
                  value: this.state.projectFilter
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement('br', { className: 'large-hide' }),
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  'Loading'
                )
              ),
              data.length > 0 ? _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 2, className: 'equal height' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    _react2.default.createElement(
                      'div',
                      { style: { overflowX: 'auto' } },
                      _react2.default.createElement(
                        _semanticUiReact.Table,
                        {
                          compact: true,
                          unstackable: true,
                          selectable: true
                        },
                        _react2.default.createElement(
                          _semanticUiReact.Table.Header,
                          { className: 'mobile-hide' },
                          _react2.default.createElement(
                            _semanticUiReact.Table.Row,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              null,
                              'Date'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              null,
                              'Booking'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              null,
                              'Unit'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              null,
                              'Purchaser'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              { textAlign: 'center' },
                              'Send'
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Table.Body,
                          null,
                          data.map(function (d, idx) {
                            return _react2.default.createElement(
                              _semanticUiReact.Table.Row,
                              {
                                key: idx
                              },
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _react2.default.createElement(_Timestamp2.default, {
                                  timestamp: d.createdAt,
                                  format: 'DD/M/YYYY'
                                })
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _react2.default.createElement(
                                  _reactRouter.Link,
                                  { to: '/bookings/' + d.id + '/' },
                                  d.code
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _react2.default.createElement(
                                  _reactRouter.Link,
                                  { title: d.code, to: '/bookings/' + d.id + '/' },
                                  d.projectUnit.reference,
                                  ', ',
                                  d.project.shortName,
                                  d.projectUnit.isBumi && _react2.default.createElement(
                                    _semanticUiReact.Label,
                                    { size: 'mini', style: { marginLeft: '0.5em' } },
                                    'Bumi'
                                  )
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _react2.default.createElement(
                                  _reactRouter.Link,
                                  { title: d.code, to: '/bookings/' + d.id + '/' },
                                  d.bookingCustomer && d.bookingCustomer.name
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { collapsing: true, textAlign: 'center' },
                                _react2.default.createElement(_semanticUiReact.Checkbox, {
                                  toggle: true,
                                  checked: d.send,
                                  onChange: function onChange(e) {
                                    return _this7.handleCheckboxChange(e, idx);
                                  }
                                })
                              )
                            );
                          })
                        )
                      )
                    )
                  )
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Item,
                      { style: {} },
                      _react2.default.createElement(
                        _semanticUiReact.Item.Content,
                        null,
                        !loading ? _react2.default.createElement(
                          _semanticUiReact.Segment,
                          { textAlign: 'center' },
                          _react2.default.createElement(
                            'p',
                            null,
                            'No bookings found.'
                          )
                        ) : ''
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return AccountingIFCA;
}(_react.Component);

AccountingIFCA.contextTypes = {
  appConfig: _propTypes2.default.shape({}),
  store: _propTypes2.default.object
};
AccountingIFCA.propTypes = {
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  })
};

AccountingIFCA.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig
  };
};

AccountingIFCA.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var advanceFilter = false;
  var projectFilter = (0, _isbase2.default)(query.projectFilter) && _qs2.default.parse(atob(query.projectFilter)).name || '';
  return {
    currentPage: currentPage,
    search: search,
    advanceFilter: advanceFilter,
    projectFilter: projectFilter,
    loadingSearch: false,
    findProjectResults: [],
    noResultsMessage: 'Loading...'
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this8 = this;

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    query.page = currentPage;
    _this8.setState({
      currentPage: currentPage
    });
    _this8.pushQuery(query);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this8.replaceQuery(query, true);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    _this8.setState({
      search: ''
    }, function () {
      if (hasQuery) {
        _this8.replaceQuery(query, true);
      }
    });
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    query[queryName] = value;
    _this8.replaceQuery(query, true);
  };

  this.handleSetAdvanceFilter = function (advanceFilter) {
    _this8.setState({
      advanceFilter: advanceFilter
    });
  };

  this.handleSearchProject = function (value) {
    clearTimeout(_this8.setTimer);
    // always reset results to null before finding
    var findProjectResults = [];
    var noResultsMessage = 'Loading...';
    _this8.setState({ findProjectResults: findProjectResults, noResultsMessage: noResultsMessage, projectFilter: value }, function () {
      if (value !== '') {
        _this8.setTimer = setTimeout(function () {
          _this8.searchProjects(value);
        }, 500);
      }
    });
  };

  this.handleSelectProject = function (project, queryName) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    var internalQuery = {};
    internalQuery.id = project.key;
    internalQuery.name = project.title;
    query[queryName] = btoa(_qs2.default.stringify(internalQuery));
    _this8.replaceQuery(query, true);
  };

  this.handleCheckboxChange = function (e, id) {
    var data = _this8.state.data;

    data[id].send = !data[id].send;
    _this8.setState({ data: data });
  };

  this.handleSendSelected = function (e) {
    e.preventDefault();
    var data = _this8.state.data;

    var ids = [];
    data.forEach(function (d) {
      if (d.send) {
        ids.push(d.id);
      }
    });
    _this8.submitIFCA(ids);
  };

  this.sortItems = [{
    text: 'Oldest Booking First',
    icon: 'sort alphabet ascending',
    sortColumn: 'booking.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Latest Booking First',
    icon: 'sort alphabet descending',
    sortColumn: 'booking.created_at',
    sortDirection: 'desc'
  }];
};

exports.default = (0, _reactRedux.connect)(AccountingIFCA.mapStateToProps)(AccountingIFCA);

/***/ }),
/* 2236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _AccountingIFCA = __webpack_require__(2235);

var _AccountingIFCA2 = _interopRequireDefault(_AccountingIFCA);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AccountingIFCA2.default;

/***/ }),
/* 2237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _semanticUiReact = __webpack_require__(2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _reactRouter = __webpack_require__(18);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _url = __webpack_require__(19);

var _isbase = __webpack_require__(157);

var _isbase2 = _interopRequireDefault(_isbase);

var _Filters = __webpack_require__(86);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountingInsoft = function (_Component) {
  _inherits(AccountingInsoft, _Component);

  function AccountingInsoft(props) {
    _classCallCheck(this, AccountingInsoft);

    var _this = _possibleConstructorReturn(this, (AccountingInsoft.__proto__ || Object.getPrototypeOf(AccountingInsoft)).call(this, props));

    _initialiseProps.call(_this);

    var state = AccountingInsoft.getPropsToState(props);
    state.data = [];
    _this.state = _extends({
      loading: true,
      count: 0,
      limit: 10,
      offset: 0,
      token: ''
    }, state);
    var query = (0, _url.decodeSearch)(props.location.search);
    if (query.projectFilter && query.projectFilter.length > 0) {
      _this.state.advanceFilter = true;
    }
    return _this;
  }

  _createClass(AccountingInsoft, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      this.fetchBookings(query);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = AccountingInsoft.getPropsToState(nextProps);
      var query = (0, _url.decodeSearch)(nextProps.location.search);
      if (this.state.limit < 0) {
        this.fetchBookings(query);
        state.loading = this.state.loading;
      }
      state.token = this.state.token;
      if (query.projectFilter && query.projectFilter.length > 0) {
        state.advanceFilter = true;
      }
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoadingSearch',
    value: function setLoadingSearch() {
      var _this3 = this;

      var loadingSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loadingSearch: loadingSearch }, res);
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'setBookings',
    value: function setBookings() {
      var _this5 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this5.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'fetchBookings',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var store, query, res, message, _message, count, limit, offset, token, data, newData, que;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = Object.assign(q, this.props.where || {});
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/insoft/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 23;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                if (!(_context.t0.res && _context.t0.res.status >= 399 && _context.t0.res.status < 500)) {
                  _context.next = 18;
                  break;
                }

                _context.next = 16;
                return _context.t0.res.text();

              case 16:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 18:
                _context.next = 20;
                return this.setLoading(false);

              case 20:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context.abrupt('return');

              case 23:
                if (res.ok) {
                  _context.next = 31;
                  break;
                }

                _context.next = 26;
                return res.text();

              case 26:
                _message = _context.sent;
                _context.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 29:
                _context.next = 50;
                break;

              case 31:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                token = res.headers.get('X-CSRF-Token');
                _context.next = 37;
                return res.json();

              case 37:
                data = _context.sent;
                newData = [];

                if (data) {
                  newData = data;
                  data.forEach(function (d, idx) {
                    newData[idx].send = false;
                  });
                }
                _context.next = 42;
                return this.setBookings(newData);

              case 42:
                if (!(this.state.data.length < 1 && query.page > 1)) {
                  _context.next = 48;
                  break;
                }

                que = (0, _url.decodeSearch)(this.props.location.search);

                que.page = 1;
                this.replaceQuery(que);
                _context.next = 50;
                break;

              case 48:
                _context.next = 50;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset,
                  token: token
                });

              case 50:
                _context.next = 52;
                return this.setLoading(false);

              case 52:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchBookings() {
        return _ref.apply(this, arguments);
      }

      return fetchBookings;
    }()
  }, {
    key: 'searchProjects',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(value) {
        var _this6 = this;

        var store, res, message, json, findProjectResults, noResultsMessage;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                _context2.next = 3;
                return this.setLoadingSearch(true);

              case 3:
                res = null;
                _context2.prev = 4;
                _context2.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/search/projects/?limit=3&search=' + value, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context2.sent;
                _context2.next = 21;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](4);

                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 15;
                return _context2.t0.res.text();

              case 15:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 17:
                _context2.next = 19;
                return this.setLoadingSearch(false);

              case 19:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));

              case 21:
                if (res.ok) {
                  _context2.next = 27;
                  break;
                }

                _context2.next = 24;
                return this.setLoadingSearch(false);

              case 24:
                throw new Error('Not OK');

              case 27:
                _context2.next = 29;
                return this.setLoadingSearch(false);

              case 29:
                _context2.next = 31;
                return res.json();

              case 31:
                json = _context2.sent;

                if (json) {
                  findProjectResults = json.map(function (obj) {
                    var newResults = {};
                    newResults.key = obj.id;
                    newResults.title = obj.shortName;
                    newResults.description = obj.state;
                    if (obj.pictureKey !== '') {
                      newResults.image = (0, _url.AWSUrl)(_this6.props.appConfig, obj.pictureKey + '010.jpg');
                    } else {
                      newResults.image = '/assets/images/placeholder_x100.jpg';
                    }
                    return newResults;
                  });

                  this.setState({ findProjectResults: findProjectResults });
                } else {
                  noResultsMessage = 'No results found.';

                  this.setState({ noResultsMessage: noResultsMessage });
                }

              case 33:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10]]);
      }));

      function searchProjects(_x6) {
        return _ref2.apply(this, arguments);
      }

      return searchProjects;
    }()
  }, {
    key: 'submitInsoft',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
        var store, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _context3.prev = 3;
                _context3.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/insoft/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(data)
                }));

              case 6:
                _context3.next = 21;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](3);
                _context3.next = 12;
                return this.setLoading(false);

              case 12:
                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 18;
                  break;
                }

                _context3.next = 15;
                return _context3.t0.res.text();

              case 15:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 18:
                Bugsnag.notifyException(_context3.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context3.abrupt('return');

              case 21:
                _context3.next = 23;
                return this.setLoading(false);

              case 23:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Success', message: 'Selected booking(s) has been added to the insoft synchronizing queue' }));
                this.fetchBookings();

              case 25:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 8]]);
      }));

      function submitInsoft(_x7) {
        return _ref3.apply(this, arguments);
      }

      return submitInsoft;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      store.dispatch((0, _reactRouterRedux.replace)('/accounting/?' + (0, _url.encodeSearch)(query)));
      this.fetchBookings(query);
    }
  }, {
    key: 'pushQuery',
    value: function pushQuery(query) {
      var store = this.context.store;

      store.dispatch((0, _reactRouterRedux.replace)('/accounting/?' + (0, _url.encodeSearch)(query)));
      this.fetchBookings(query);
    }
  }, {
    key: 'hasSelectedItems',
    value: function hasSelectedItems() {
      var data = this.state.data;

      var isSelected = false;
      data.forEach(function (d) {
        if (d.send) {
          isSelected = true;
        }
      });
      return isSelected;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var query = (0, _url.decodeSearch)(this.props.location.search);
      var _state = this.state,
          data = _state.data,
          loading = _state.loading;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: 'Post-Sale',
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              disabled: !this.hasSelectedItems() || loading,
              icon: 'check circle',
              content: 'Send Selected',
              color: 'green',
              size: 'medium',
              compact: true,
              onClick: this.handleSendSelected
            })
          )
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { padding: '0' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              _react2.default.createElement(
                'b',
                null,
                'Send Sold Booking(s) To Insoft'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _SearchFilter2.default,
                {
                  advanceFilter: this.state.advanceFilter,
                  isLoading: this.state.loading,
                  onChange: this.handleFilterOnChange,
                  onClose: this.handleClearFilter,
                  search: this.state.search,
                  setAdvanceFilter: this.handleSetAdvanceFilter,
                  placeholder: 'Search...',
                  leftNav: _react2.default.createElement(_PageNav2.default, {
                    currentPage: this.state.currentPage,
                    count: this.state.count,
                    limit: this.state.limit,
                    offset: this.state.offset,
                    dataSize: this.state.data.length,
                    loading: this.state.loading,
                    onChange: this.handleChangePage
                  }),
                  rightNav: _react2.default.createElement(_SortButton2.default, {
                    floated: 'right',
                    loading: this.state.loading,
                    items: this.sortItems,
                    onSort: this.handleSortData
                  })
                },
                _react2.default.createElement(_Filters.SearchList, {
                  filterName: 'projectFilter',
                  icon: 'find',
                  isActive: query.projectFilter && query.projectFilter.length > 0 || false,
                  loading: this.state.loadingSearch,
                  noResultsMessage: this.state.noResultsMessage,
                  onChange: this.handleSearchProject,
                  onClose: this.handleClearFilter,
                  onSelect: this.handleSelectProject,
                  placeholder: 'Find Project',
                  results: this.state.findProjectResults,
                  value: this.state.projectFilter
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement('br', { className: 'large-hide' }),
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  'Loading'
                )
              ),
              data.length > 0 ? _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 2, className: 'equal height' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    _react2.default.createElement(
                      'div',
                      { style: { overflowX: 'auto' } },
                      _react2.default.createElement(
                        _semanticUiReact.Table,
                        {
                          compact: true,
                          unstackable: true,
                          selectable: true
                        },
                        _react2.default.createElement(
                          _semanticUiReact.Table.Header,
                          { className: 'mobile-hide' },
                          _react2.default.createElement(
                            _semanticUiReact.Table.Row,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              null,
                              'Date'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              null,
                              'Booking'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              null,
                              'Unit'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              null,
                              'Purchaser'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              { textAlign: 'center' },
                              'Send'
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Table.Body,
                          null,
                          data.map(function (d, idx) {
                            return _react2.default.createElement(
                              _semanticUiReact.Table.Row,
                              {
                                key: idx
                              },
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _react2.default.createElement(_Timestamp2.default, {
                                  timestamp: d.createdAt,
                                  format: 'DD/M/YYYY'
                                })
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _react2.default.createElement(
                                  _reactRouter.Link,
                                  { to: '/bookings/' + d.id + '/' },
                                  d.code
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _react2.default.createElement(
                                  _reactRouter.Link,
                                  { title: d.code, to: '/bookings/' + d.id + '/' },
                                  d.projectUnit.reference,
                                  ', ',
                                  d.project.shortName,
                                  d.projectUnit.isBumi && _react2.default.createElement(
                                    _semanticUiReact.Label,
                                    { size: 'mini', style: { marginLeft: '0.5em' } },
                                    'Bumi'
                                  )
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _react2.default.createElement(
                                  _reactRouter.Link,
                                  { title: d.code, to: '/bookings/' + d.id + '/' },
                                  d.bookingCustomer && d.bookingCustomer.name
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { collapsing: true, textAlign: 'center' },
                                _react2.default.createElement(_semanticUiReact.Checkbox, {
                                  toggle: true,
                                  checked: d.send,
                                  onChange: function onChange(e) {
                                    return _this7.handleCheckboxChange(e, idx);
                                  }
                                })
                              )
                            );
                          })
                        )
                      )
                    )
                  )
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Item,
                      { style: {} },
                      _react2.default.createElement(
                        _semanticUiReact.Item.Content,
                        null,
                        !loading ? _react2.default.createElement(
                          _semanticUiReact.Segment,
                          { textAlign: 'center' },
                          _react2.default.createElement(
                            'p',
                            null,
                            'No bookings found.'
                          )
                        ) : ''
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return AccountingInsoft;
}(_react.Component);

AccountingInsoft.contextTypes = {
  appConfig: _propTypes2.default.shape({}),
  store: _propTypes2.default.object
};
AccountingInsoft.propTypes = {
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  })
};

AccountingInsoft.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig
  };
};

AccountingInsoft.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var advanceFilter = false;
  var projectFilter = (0, _isbase2.default)(query.projectFilter) && _qs2.default.parse(atob(query.projectFilter)).name || '';
  return {
    currentPage: currentPage,
    search: search,
    advanceFilter: advanceFilter,
    projectFilter: projectFilter,
    loadingSearch: false,
    findProjectResults: [],
    noResultsMessage: 'Loading...'
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this8 = this;

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    query.page = currentPage;
    _this8.setState({
      currentPage: currentPage
    });
    _this8.pushQuery(query);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this8.replaceQuery(query, true);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    _this8.setState({
      search: ''
    }, function () {
      if (hasQuery) {
        _this8.replaceQuery(query, true);
      }
    });
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    query[queryName] = value;
    _this8.replaceQuery(query, true);
  };

  this.handleSetAdvanceFilter = function (advanceFilter) {
    _this8.setState({
      advanceFilter: advanceFilter
    });
  };

  this.handleSearchProject = function (value) {
    clearTimeout(_this8.setTimer);
    // always reset results to null before finding
    var findProjectResults = [];
    var noResultsMessage = 'Loading...';
    _this8.setState({ findProjectResults: findProjectResults, noResultsMessage: noResultsMessage, projectFilter: value }, function () {
      if (value !== '') {
        _this8.setTimer = setTimeout(function () {
          _this8.searchProjects(value);
        }, 500);
      }
    });
  };

  this.handleSelectProject = function (project, queryName) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    var internalQuery = {};
    internalQuery.id = project.key;
    internalQuery.name = project.title;
    query[queryName] = btoa(_qs2.default.stringify(internalQuery));
    _this8.replaceQuery(query, true);
  };

  this.handleCheckboxChange = function (e, id) {
    var data = _this8.state.data;

    data[id].send = !data[id].send;
    _this8.setState({ data: data });
  };

  this.handleSendSelected = function (e) {
    e.preventDefault();
    var data = _this8.state.data;

    var ids = [];
    data.forEach(function (d) {
      if (d.send) {
        ids.push(d.id);
      }
    });
    _this8.submitInsoft(ids);
  };

  this.sortItems = [{
    text: 'Oldest Booking First',
    icon: 'sort alphabet ascending',
    sortColumn: 'booking.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Latest Booking First',
    icon: 'sort alphabet descending',
    sortColumn: 'booking.created_at',
    sortDirection: 'desc'
  }];
};

exports.default = (0, _reactRedux.connect)(AccountingInsoft.mapStateToProps)(AccountingInsoft);

/***/ }),
/* 2238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _AccountingInsoft = __webpack_require__(2237);

var _AccountingInsoft2 = _interopRequireDefault(_AccountingInsoft);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AccountingInsoft2.default;

/***/ }),
/* 2239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Overview = __webpack_require__(2240);

var _Overview2 = _interopRequireDefault(_Overview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Activities = function (_Component) {
  _inherits(Activities, _Component);

  function Activities() {
    _classCallCheck(this, Activities);

    return _possibleConstructorReturn(this, (Activities.__proto__ || Object.getPrototypeOf(Activities)).apply(this, arguments));
  }

  _createClass(Activities, [{
    key: 'renderChild',
    value: function renderChild() {
      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Activities;
}(_react.Component);

Activities.propTypes = {
  children: _propTypes2.default.node
};
Activities.contextTypes = {
  store: _propTypes2.default.object
};
Activities.Overview = _Overview2.default;
exports.default = Activities;

/***/ }),
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _reactRedux = __webpack_require__(9);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _addressSettings = __webpack_require__(152);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _BookingActivities = __webpack_require__(1005);

var _BookingActivities2 = _interopRequireDefault(_BookingActivities);

var _ProjectUnitActivities = __webpack_require__(565);

var _ProjectUnitActivities2 = _interopRequireDefault(_ProjectUnitActivities);

var _ProjectActivities = __webpack_require__(1027);

var _ProjectActivities2 = _interopRequireDefault(_ProjectActivities);

var _ExportActivities = __webpack_require__(2135);

var _ExportActivities2 = _interopRequireDefault(_ExportActivities);

var _translation = __webpack_require__(4);

var _UserActivities = __webpack_require__(1037);

var _UserActivities2 = _interopRequireDefault(_UserActivities);

var _BusinessUnitActivities = __webpack_require__(1009);

var _BusinessUnitActivities2 = _interopRequireDefault(_BusinessUnitActivities);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var Overview = function (_Component) {
  _inherits(Overview, _Component);

  function Overview(props) {
    _classCallCheck(this, Overview);

    var _this = _possibleConstructorReturn(this, (Overview.__proto__ || Object.getPrototypeOf(Overview)).call(this, props));

    _initialiseProps.call(_this);

    var menuIsTab = window.innerWidth <= 590;
    var state = Overview.getPropsToState(props);
    _this.state = _extends({}, state, {
      loading: true,
      menuIsTab: menuIsTab,
      bookingsData: [],
      bookingsLimit: 0,
      bookingsOffset: 0,
      bookingsCount: 0,
      unitsData: [],
      unitsLimit: 0,
      unitsOffset: 0,
      unitsCount: 0,
      projectsData: [],
      projectsLimit: 0,
      projectsOffset: 0,
      projectsCount: 0,
      exportsData: [],
      exportsLimit: 0,
      exportsOffset: 0,
      exportsCount: 0,
      usersData: [],
      usersLimit: 0,
      usersOffset: 0,
      usersCount: 0,
      businessUnitsData: [],
      businessUnitsLimit: 0,
      businessUnitsOffset: 0,
      businessUnitsCount: 0
    });
    return _this;
  }

  _createClass(Overview, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;

      store.dispatch((0, _addressSettings.fetchAddressSettings)());
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
      var store = this.context.store;
      var _props$location = this.props.location,
          pathname = _props$location.pathname,
          query = _props$location.query;

      if (pathname === '/activities/') {
        this.getBookingActivities(query);
        store.dispatch((0, _reactRouterRedux.replace)('/activities/bookings/'));
      }
      if (pathname === '/activities/bookings/') {
        this.getBookingActivities(query);
      }
      if (pathname === '/activities/project_units/') {
        this.getProjectUnitActivities(query);
      }
      if (pathname === '/activities/projects/') {
        this.getProjectActivities(query);
      }
      if (pathname === '/activities/exports/') {
        this.getExportActivities(query);
      }
      if (pathname === '/activities/users/') {
        this.getUserActivities(query);
      }
      if (pathname === '/activities/business_units/') {
        this.getBusinessUnitActivities(query);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _nextProps$location = nextProps.location,
          pathname = _nextProps$location.pathname,
          query = _nextProps$location.query;

      var state = Overview.getPropsToState(nextProps);
      if (pathname === '/activities/bookings/') {
        if (!this.state.bookingsData) {
          this.getBookingActivities(query);
        }
      }
      if (pathname === '/activities/project_units/') {
        if (!this.state.unitsData) {
          this.getProjectUnitActivities(query);
        }
      }
      if (pathname === '/activities/projects/') {
        if (!this.state.projectsData) {
          this.getProjectActivities(query);
        }
      }
      if (pathname === '/activities/users/') {
        if (!this.state.usersData) {
          this.getUserActivities(query);
        }
      }
      if (pathname === '/activities/business_units/') {
        if (!this.state.businessUnitsData) {
          this.getBusinessUnitActivities(query);
        }
      }
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'getBookingActivities',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var t, store, query, queryString, res, message, bookingsData, bookingsCount, bookingsLimit, bookingsOffset;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                _context.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                queryString = '';
                res = null;

                if (_qs2.default.stringify(query)) {
                  queryString = '?' + _qs2.default.stringify(query);
                }
                _context.prev = 9;
                _context.next = 12;
                return store.dispatch((0, _fetchM.fetchM)('/activities/bookings/' + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context.sent;
                _context.next = 26;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](9);
                _context.next = 19;
                return this.setLoading(false);

              case 19:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 24;
                  break;
                }

                _context.next = 22;
                return _context.t0.res.text();

              case 22:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 26:
                if (res.ok) {
                  _context.next = 32;
                  break;
                }

                _context.next = 29;
                return this.setLoading(false);

              case 29:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
                _context.next = 42;
                break;

              case 32:
                _context.next = 34;
                return res.json();

              case 34:
                bookingsData = _context.sent;
                bookingsCount = parseInt(res.headers.get('M-Data-count'), 10);
                bookingsLimit = parseInt(res.headers.get('M-Data-limit'), 10);
                bookingsOffset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 40;
                return this.setComponentState({
                  bookingsCount: bookingsCount,
                  bookingsLimit: bookingsLimit,
                  bookingsOffset: bookingsOffset,
                  bookingsData: bookingsData
                });

              case 40:
                _context.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 15]]);
      }));

      function getBookingActivities(_x3) {
        return _ref.apply(this, arguments);
      }

      return getBookingActivities;
    }()
  }, {
    key: 'getProjectUnitActivities',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(q) {
        var t, store, query, queryString, res, message, unitsData, unitsCount, unitsLimit, unitsOffset;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                t = this.props.t;
                _context2.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                queryString = '';
                res = null;

                if (_qs2.default.stringify(query)) {
                  queryString = '?' + _qs2.default.stringify(query);
                }
                _context2.prev = 9;
                _context2.next = 12;
                return store.dispatch((0, _fetchM.fetchM)('/activities/project_units/' + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context2.sent;
                _context2.next = 26;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](9);
                _context2.next = 19;
                return this.setLoading(false);

              case 19:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 24;
                  break;
                }

                _context2.next = 22;
                return _context2.t0.res.text();

              case 22:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 26:
                if (res.ok) {
                  _context2.next = 32;
                  break;
                }

                _context2.next = 29;
                return this.setLoading(false);

              case 29:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
                _context2.next = 42;
                break;

              case 32:
                _context2.next = 34;
                return res.json();

              case 34:
                unitsData = _context2.sent;
                unitsCount = parseInt(res.headers.get('M-Data-count'), 10);
                unitsLimit = parseInt(res.headers.get('M-Data-limit'), 10);
                unitsOffset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context2.next = 40;
                return this.setComponentState({
                  unitsCount: unitsCount,
                  unitsLimit: unitsLimit,
                  unitsOffset: unitsOffset,
                  unitsData: unitsData
                });

              case 40:
                _context2.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[9, 15]]);
      }));

      function getProjectUnitActivities(_x4) {
        return _ref2.apply(this, arguments);
      }

      return getProjectUnitActivities;
    }()
  }, {
    key: 'getProjectActivities',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(q) {
        var t, store, query, queryString, res, message, projectsData, projectsCount, projectsLimit, projectsOffset;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                t = this.props.t;
                _context3.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                queryString = '';
                res = null;

                if (_qs2.default.stringify(query)) {
                  queryString = '?' + _qs2.default.stringify(query);
                }
                _context3.prev = 9;
                _context3.next = 12;
                return store.dispatch((0, _fetchM.fetchM)('/activities/projects/' + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context3.sent;
                _context3.next = 26;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3['catch'](9);
                _context3.next = 19;
                return this.setLoading(false);

              case 19:
                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 24;
                  break;
                }

                _context3.next = 22;
                return _context3.t0.res.text();

              case 22:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                Bugsnag.notifyException(_context3.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 26:
                if (res.ok) {
                  _context3.next = 32;
                  break;
                }

                _context3.next = 29;
                return this.setLoading(false);

              case 29:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
                _context3.next = 42;
                break;

              case 32:
                _context3.next = 34;
                return res.json();

              case 34:
                projectsData = _context3.sent;
                projectsCount = parseInt(res.headers.get('M-Data-count'), 10);
                projectsLimit = parseInt(res.headers.get('M-Data-limit'), 10);
                projectsOffset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context3.next = 40;
                return this.setComponentState({
                  projectsCount: projectsCount,
                  projectsLimit: projectsLimit,
                  projectsOffset: projectsOffset,
                  projectsData: projectsData
                });

              case 40:
                _context3.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[9, 15]]);
      }));

      function getProjectActivities(_x5) {
        return _ref3.apply(this, arguments);
      }

      return getProjectActivities;
    }()
  }, {
    key: 'getExportActivities',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(q) {
        var t, store, query, queryString, res, message, exportsData, exportsCount, exportsLimit, exportsOffset;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                t = this.props.t;
                _context4.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                queryString = '';
                res = null;

                if (_qs2.default.stringify(query)) {
                  queryString = '?' + _qs2.default.stringify(query);
                }
                _context4.prev = 9;
                _context4.next = 12;
                return store.dispatch((0, _fetchM.fetchM)('/activities/exports/' + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context4.sent;
                _context4.next = 26;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4['catch'](9);
                _context4.next = 19;
                return this.setLoading(false);

              case 19:
                if (!(_context4.t0.res && _context4.t0.res.status >= 400 && _context4.t0.res.status < 500)) {
                  _context4.next = 24;
                  break;
                }

                _context4.next = 22;
                return _context4.t0.res.text();

              case 22:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                Bugsnag.notifyException(_context4.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 26:
                if (res.ok) {
                  _context4.next = 32;
                  break;
                }

                _context4.next = 29;
                return this.setLoading(false);

              case 29:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
                _context4.next = 42;
                break;

              case 32:
                _context4.next = 34;
                return res.json();

              case 34:
                exportsData = _context4.sent;
                exportsCount = parseInt(res.headers.get('M-Data-count'), 10);
                exportsLimit = parseInt(res.headers.get('M-Data-limit'), 10);
                exportsOffset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context4.next = 40;
                return this.setComponentState({
                  exportsCount: exportsCount,
                  exportsLimit: exportsLimit,
                  exportsOffset: exportsOffset,
                  exportsData: exportsData
                });

              case 40:
                _context4.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[9, 15]]);
      }));

      function getExportActivities(_x6) {
        return _ref4.apply(this, arguments);
      }

      return getExportActivities;
    }()
  }, {
    key: 'getUserActivities',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(q) {
        var t, store, query, queryString, res, message, usersData, usersCount, usersLimit, usersOffset;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                t = this.props.t;
                _context5.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                queryString = '';
                res = null;

                if (_qs2.default.stringify(query)) {
                  queryString = '?' + _qs2.default.stringify(query);
                }
                _context5.prev = 9;
                _context5.next = 12;
                return store.dispatch((0, _fetchM.fetchM)('/activities/users/' + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context5.sent;
                _context5.next = 26;
                break;

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5['catch'](9);
                _context5.next = 19;
                return this.setLoading(false);

              case 19:
                if (!(_context5.t0.res && _context5.t0.res.status >= 400 && _context5.t0.res.status < 500)) {
                  _context5.next = 24;
                  break;
                }

                _context5.next = 22;
                return _context5.t0.res.text();

              case 22:
                message = _context5.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                Bugsnag.notifyException(_context5.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 26:
                if (res.ok) {
                  _context5.next = 32;
                  break;
                }

                _context5.next = 29;
                return this.setLoading(false);

              case 29:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
                _context5.next = 42;
                break;

              case 32:
                _context5.next = 34;
                return res.json();

              case 34:
                usersData = _context5.sent;
                usersCount = parseInt(res.headers.get('M-Data-count'), 10);
                usersLimit = parseInt(res.headers.get('M-Data-limit'), 10);
                usersOffset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context5.next = 40;
                return this.setComponentState({
                  usersCount: usersCount,
                  usersLimit: usersLimit,
                  usersOffset: usersOffset,
                  usersData: usersData
                });

              case 40:
                _context5.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[9, 15]]);
      }));

      function getUserActivities(_x7) {
        return _ref5.apply(this, arguments);
      }

      return getUserActivities;
    }()
  }, {
    key: 'getBusinessUnitActivities',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(q) {
        var t, store, query, queryString, res, message, businessUnitsData, businessUnitsCount, businessUnitsLimit, businessUnitsOffset;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                queryString = '';
                res = null;

                if (_qs2.default.stringify(query)) {
                  queryString = '?' + _qs2.default.stringify(query);
                }
                _context6.prev = 9;
                _context6.next = 12;
                return store.dispatch((0, _fetchM.fetchM)('/activities/business_units/' + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context6.sent;
                _context6.next = 26;
                break;

              case 15:
                _context6.prev = 15;
                _context6.t0 = _context6['catch'](9);
                _context6.next = 19;
                return this.setLoading(false);

              case 19:
                if (!(_context6.t0.res && _context6.t0.res.status >= 400 && _context6.t0.res.status < 500)) {
                  _context6.next = 24;
                  break;
                }

                _context6.next = 22;
                return _context6.t0.res.text();

              case 22:
                message = _context6.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                Bugsnag.notifyException(_context6.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 26:
                if (res.ok) {
                  _context6.next = 32;
                  break;
                }

                _context6.next = 29;
                return this.setLoading(false);

              case 29:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
                _context6.next = 42;
                break;

              case 32:
                _context6.next = 34;
                return res.json();

              case 34:
                businessUnitsData = _context6.sent;
                businessUnitsCount = parseInt(res.headers.get('M-Data-count'), 10);
                businessUnitsLimit = parseInt(res.headers.get('M-Data-limit'), 10);
                businessUnitsOffset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context6.next = 40;
                return this.setComponentState({
                  businessUnitsCount: businessUnitsCount,
                  businessUnitsLimit: businessUnitsLimit,
                  businessUnitsOffset: businessUnitsOffset,
                  businessUnitsData: businessUnitsData
                });

              case 40:
                _context6.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[9, 15]]);
      }));

      function getBusinessUnitActivities(_x8) {
        return _ref6.apply(this, arguments);
      }

      return getBusinessUnitActivities;
    }()
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var hq = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var admin = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

      if (this.props.auth.isHeadquarters && hq) {
        return true;
      }
      if (this.props.auth.isAdminBasic && admin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'replaceQuery',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(query) {
        var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var store, queryNew;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                queryNew = query;

                if (resetPage) queryNew.page = 1;

                if (!(this.getTabName() === 'bookings')) {
                  _context7.next = 8;
                  break;
                }

                _context7.next = 8;
                return this.getBookingActivities(query);

              case 8:
                if (!(this.getTabName() === 'project_units')) {
                  _context7.next = 11;
                  break;
                }

                _context7.next = 11;
                return this.getProjectUnitActivities(query);

              case 11:
                if (!(this.getTabName() === 'projects')) {
                  _context7.next = 14;
                  break;
                }

                _context7.next = 14;
                return this.getProjectActivities(query);

              case 14:
                if (!(this.getTabName() === 'exports')) {
                  _context7.next = 17;
                  break;
                }

                _context7.next = 17;
                return this.getExportActivities(query);

              case 17:
                if (!(this.getTabName() === 'users')) {
                  _context7.next = 20;
                  break;
                }

                _context7.next = 20;
                return this.getUserActivities(query);

              case 20:
                if (!(this.getTabName() === 'business_units')) {
                  _context7.next = 23;
                  break;
                }

                _context7.next = 23;
                return this.getBusinessUnitActivities(query);

              case 23:
                store.dispatch((0, _reactRouterRedux.replace)('/activities/' + this.getTabName() + '/?' + (0, _url.encodeSearch)(queryNew)));
                _context7.next = 26;
                return this.setLoading(false);

              case 26:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function replaceQuery(_x12) {
        return _ref7.apply(this, arguments);
      }

      return replaceQuery;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var pathname = this.props.location.pathname;
      var t = this.props.t;
      var _state = this.state,
          bookingsData = _state.bookingsData,
          unitsData = _state.unitsData,
          projectsData = _state.projectsData,
          exportsData = _state.exportsData,
          usersData = _state.usersData,
          businessUnitsData = _state.businessUnitsData;

      var links = [{ text: 'Bookings', value: '/activities/bookings/' }, { text: 'Project Units', value: '/activities/project_units/' }, { text: 'Projects', value: '/activities/projects/' }, { text: 'Data Exports', value: '/activities/exports/' }, { text: 'Users', value: '/activities/users/' }, { text: 'Business Units', value: '/activities/business_units/' }];
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Activity Logs'),
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname,
            disabled: this.state.loading
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: t(link.text),
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this4.handleMenu(e, link);
              }
            });
          })
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              this.getTabName() === 'bookings' ? _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 16 },
                          _react2.default.createElement(_SearchFilter2.default, {
                            isLoading: this.state.loading,
                            onChange: this.handleFilterOnChange,
                            onClose: this.handleClearFilter,
                            search: this.state.search,
                            placeholder: t('Search by booking code', { ns: _translation.TRANSLATION_FILES.translation }),
                            leftNav: _react2.default.createElement(_PageNav2.default, {
                              currentPage: this.state.bookingsCurrentPage,
                              count: this.state.bookingsCount,
                              limit: this.state.bookingsLimit,
                              offset: this.state.bookingsOffset,
                              dataSize: this.state.bookingsData.length,
                              loading: this.state.loading,
                              onChange: this.handleChangePage
                            }),
                            rightNav: _react2.default.createElement(_SortButton2.default, {
                              floated: 'right',
                              loading: this.state.loading,
                              items: this.bookingsSortItems,
                              onSort: this.handleSortData
                            })
                          })
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16, textAlign: 'center' },
                      _react2.default.createElement(
                        _semanticUiReact.Divider,
                        { horizontal: true },
                        t('Booking Activity Logs')
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Segment,
                        null,
                        _react2.default.createElement(_BookingActivities2.default, {
                          data: bookingsData || [],
                          hasAccess: this.hasAccess(),
                          loading: this.state.loading,
                          showAll: true
                        })
                      )
                    )
                  )
                )
              ) : '',
              this.getTabName() === 'project_units' ? _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 16 },
                          _react2.default.createElement(_SearchFilter2.default, {
                            isLoading: this.state.loading,
                            onChange: this.handleFilterOnChange,
                            onClose: this.handleClearFilter,
                            search: this.state.search,
                            placeholder: t('Search by unit number', { ns: _translation.TRANSLATION_FILES.translation }),
                            leftNav: _react2.default.createElement(_PageNav2.default, {
                              currentPage: this.state.unitsCurrentPage,
                              count: this.state.unitsCount,
                              limit: this.state.unitsLimit,
                              offset: this.state.unitsOffset,
                              dataSize: this.state.unitsData.length,
                              loading: this.state.loading,
                              onChange: this.handleChangePage
                            }),
                            rightNav: _react2.default.createElement(_SortButton2.default, {
                              floated: 'right',
                              loading: this.state.loading,
                              items: this.unitsSortItems,
                              onSort: this.handleSortData
                            })
                          })
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16, textAlign: 'center' },
                      _react2.default.createElement(
                        _semanticUiReact.Divider,
                        { horizontal: true },
                        t('Project Unit Activity Logs')
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Segment,
                        null,
                        _react2.default.createElement(_ProjectUnitActivities2.default, {
                          data: unitsData || [],
                          hasAccess: this.hasAccess(),
                          loading: this.state.loading,
                          showAll: true
                        })
                      )
                    )
                  )
                )
              ) : '',
              this.getTabName() === 'projects' ? _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 16 },
                          _react2.default.createElement(_SearchFilter2.default, {
                            isLoading: this.state.loading,
                            onChange: this.handleFilterOnChange,
                            onClose: this.handleClearFilter,
                            search: this.state.search,
                            placeholder: t('Search by project name', { ns: _translation.TRANSLATION_FILES.translation }),
                            leftNav: _react2.default.createElement(_PageNav2.default, {
                              currentPage: this.state.projectsCurrentPage,
                              count: this.state.projectsCount,
                              limit: this.state.projectsLimit,
                              offset: this.state.projectsOffset,
                              dataSize: this.state.projectsData.length,
                              loading: this.state.loading,
                              onChange: this.handleChangePage
                            }),
                            rightNav: _react2.default.createElement(_SortButton2.default, {
                              floated: 'right',
                              loading: this.state.loading,
                              items: this.projectsSortItems,
                              onSort: this.handleSortData
                            })
                          })
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16, textAlign: 'center' },
                      _react2.default.createElement(
                        _semanticUiReact.Divider,
                        { horizontal: true },
                        t('Project Activity Logs')
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Segment,
                        null,
                        _react2.default.createElement(_ProjectActivities2.default, {
                          data: projectsData || [],
                          hasAccess: this.hasAccess(),
                          loading: this.state.loading,
                          showAll: true
                        })
                      )
                    )
                  )
                )
              ) : '',
              this.getTabName() === 'exports' ? _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 16 },
                          _react2.default.createElement(_SearchFilter2.default, {
                            isLoading: this.state.loading,
                            onChange: this.handleFilterOnChange,
                            onClose: this.handleClearFilter,
                            search: this.state.search,
                            placeholder: t('Search by export type or exported file name', { ns: _translation.TRANSLATION_FILES.translation }),
                            leftNav: _react2.default.createElement(_PageNav2.default, {
                              currentPage: this.state.exportsCurrentPage,
                              count: this.state.exportsCount,
                              limit: this.state.exportsLimit,
                              offset: this.state.exportsOffset,
                              dataSize: this.state.exportsData.length,
                              loading: this.state.loading,
                              onChange: this.handleChangePage
                            }),
                            rightNav: _react2.default.createElement(_SortButton2.default, {
                              floated: 'right',
                              loading: this.state.loading,
                              items: this.exportsSortItems,
                              onSort: this.handleSortData
                            })
                          })
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16, textAlign: 'center' },
                      _react2.default.createElement(
                        _semanticUiReact.Divider,
                        { horizontal: true },
                        t('Data Export Activity Logs')
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Segment,
                        null,
                        _react2.default.createElement(_ExportActivities2.default, {
                          data: exportsData || [],
                          hasAccess: this.hasAccess(),
                          loading: this.state.loading,
                          showAll: this.hasAccess(false, false, true)
                        })
                      )
                    )
                  )
                )
              ) : '',
              this.getTabName() === 'users' ? _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 16 },
                          _react2.default.createElement(_SearchFilter2.default, {
                            isLoading: this.state.loading,
                            onChange: this.handleFilterOnChange,
                            onClose: this.handleClearFilter,
                            search: this.state.search,
                            placeholder: t('Search by user name', { ns: _translation.TRANSLATION_FILES.translation }),
                            leftNav: _react2.default.createElement(_PageNav2.default, {
                              currentPage: this.state.usersCurrentPage,
                              count: this.state.usersCount,
                              limit: this.state.usersLimit,
                              offset: this.state.usersOffset,
                              dataSize: this.state.usersData.length,
                              loading: this.state.loading,
                              onChange: this.handleChangePage
                            }),
                            rightNav: _react2.default.createElement(_SortButton2.default, {
                              floated: 'right',
                              loading: this.state.loading,
                              items: this.usersSortItems,
                              onSort: this.handleSortData
                            })
                          })
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16, textAlign: 'center' },
                      _react2.default.createElement(
                        _semanticUiReact.Divider,
                        { horizontal: true },
                        t('User Activity Logs')
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Segment,
                        null,
                        _react2.default.createElement(_UserActivities2.default, {
                          data: usersData || [],
                          hasAccess: this.hasAccess(),
                          loading: this.state.loading,
                          showAll: true
                        })
                      )
                    )
                  )
                )
              ) : '',
              this.getTabName() === 'business_units' ? _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 16 },
                          _react2.default.createElement(_SearchFilter2.default, {
                            isLoading: this.state.loading,
                            onChange: this.handleFilterOnChange,
                            onClose: this.handleClearFilter,
                            search: this.state.search,
                            placeholder: t('Search by business unit name', { ns: _translation.TRANSLATION_FILES.translation }),
                            leftNav: _react2.default.createElement(_PageNav2.default, {
                              currentPage: this.state.businessUnitsCurrentPage,
                              count: this.state.businessUnitsCount,
                              limit: this.state.businessUnitsLimit,
                              offset: this.state.businessUnitsOffset,
                              dataSize: this.state.businessUnitsData.length,
                              loading: this.state.loading,
                              onChange: this.handleChangePage
                            }),
                            rightNav: _react2.default.createElement(_SortButton2.default, {
                              floated: 'right',
                              loading: this.state.loading,
                              items: this.businessUnitsSortItems,
                              onSort: this.handleSortData
                            })
                          })
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16, textAlign: 'center' },
                      _react2.default.createElement(
                        _semanticUiReact.Divider,
                        { horizontal: true },
                        t('Business Unit Activity Logs')
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Segment,
                        null,
                        _react2.default.createElement(_BusinessUnitActivities2.default, {
                          data: businessUnitsData || [],
                          hasAccess: this.hasAccess(),
                          loading: this.state.loading,
                          showAll: true
                        })
                      )
                    )
                  )
                )
              ) : ''
            )
          )
        )
      );
    }
  }]);

  return Overview;
}(_react.Component);

Overview.contextTypes = {
  store: _propTypes2.default.object
};
Overview.propTypes = {
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};

Overview.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

Overview.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var bookingsCurrentPage = parseInt(query.page, 10) || 1;
  var unitsCurrentPage = parseInt(query.page, 10) || 1;
  var projectsCurrentPage = parseInt(query.page, 10) || 1;
  var exportsCurrentPage = parseInt(query.page, 10) || 1;
  var usersCurrentPage = parseInt(query.page, 10) || 1;
  var businessUnitsCurrentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  return {
    bookingsCurrentPage: bookingsCurrentPage,
    unitsCurrentPage: unitsCurrentPage,
    projectsCurrentPage: projectsCurrentPage,
    exportsCurrentPage: exportsCurrentPage,
    usersCurrentPage: usersCurrentPage,
    businessUnitsCurrentPage: businessUnitsCurrentPage,
    search: search
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.getTabName = function () {
    var pathname = _this5.props.location.pathname;

    if (pathname === '/activities/bookings/') {
      return 'bookings';
    }
    if (pathname === '/activities/project_units/') {
      return 'project_units';
    }
    if (pathname === '/activities/projects/') {
      return 'projects';
    }
    if (pathname === '/activities/exports/') {
      return 'exports';
    }
    if (pathname === '/activities/users/') {
      return 'users';
    }
    if (pathname === '/activities/business_units/') {
      return 'business_units';
    }
    return '';
  };

  this.handleResize = function () {
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this5.state.menuIsTab) {
      _this5.setState({ menuIsTab: menuIsTab });
    }
  };

  this.handleMenu = function (e, _ref8) {
    var value = _ref8.value;
    var store = _this5.context.store;

    if (value.includes('/activities/bookings/')) {
      _this5.getBookingActivities();
    }
    if (value.includes('/activities/project_units/')) {
      _this5.getProjectUnitActivities();
    }
    if (value.includes('/activities/projects/')) {
      _this5.getProjectActivities();
    }
    if (value.includes('/activities/exports/')) {
      _this5.getExportActivities();
    }
    if (value.includes('/activities/users/')) {
      _this5.getUserActivities();
    }
    if (value.includes('/activities/business_units/')) {
      _this5.getBusinessUnitActivities();
    }
    store.dispatch((0, _reactRouterRedux.replace)(value));
  };

  this.handleClearFilter = function () {
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    delete query.search;
    _this5.setState({
      search: ''
    }, function () {
      _this5.replaceQuery(query, true);
    });
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    query[queryName] = value;
    _this5.replaceQuery(query, false);
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    query.page = currentPage;
    var _state2 = _this5.state,
        bookingsCurrentPage = _state2.bookingsCurrentPage,
        unitsCurrentPage = _state2.unitsCurrentPage,
        projectsCurrentPage = _state2.projectsCurrentPage,
        exportsCurrentPage = _state2.exportsCurrentPage,
        usersCurrentPage = _state2.usersCurrentPage,
        businessUnitsCurrentPage = _state2.businessUnitsCurrentPage;

    if (_this5.getTabName() === 'bookings') {
      bookingsCurrentPage = currentPage;
    }
    if (_this5.getTabName() === 'project_units') {
      unitsCurrentPage = currentPage;
    }
    if (_this5.getTabName() === 'projects') {
      projectsCurrentPage = currentPage;
    }
    if (_this5.getTabName() === 'projects') {
      exportsCurrentPage = currentPage;
    }
    if (_this5.getTabName() === 'users') {
      usersCurrentPage = currentPage;
    }
    if (_this5.getTabName() === 'business_units') {
      businessUnitsCurrentPage = currentPage;
    }
    _this5.setState({
      bookingsCurrentPage: bookingsCurrentPage,
      unitsCurrentPage: unitsCurrentPage,
      projectsCurrentPage: projectsCurrentPage,
      exportsCurrentPage: exportsCurrentPage,
      usersCurrentPage: usersCurrentPage,
      businessUnitsCurrentPage: businessUnitsCurrentPage
    });
    _this5.replaceQuery(query);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this5.replaceQuery(query);
  };

  this.bookingsSortItems = [{
    text: 'Date Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'booking_activity.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Date Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'booking_activity.created_at',
    sortDirection: 'desc'
  }];
  this.unitsSortItems = [{
    text: 'Date Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'project_unit_activity.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Date Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'project_unit_activity.created_at',
    sortDirection: 'desc'
  }];
  this.projectsSortItems = [{
    text: 'Date Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'project_activity.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Date Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'project_activity.created_at',
    sortDirection: 'desc'
  }];
  this.exportsSortItems = [{
    text: 'Date Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'export_activity.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Date Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'export_activity.created_at',
    sortDirection: 'desc'
  }];
  this.usersSortItems = [{
    text: 'Date Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'user_activity.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Date Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'user_activity.created_at',
    sortDirection: 'desc'
  }];
  this.businessUnitsSortItems = [{
    text: 'Date Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'business_unit_activity.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Date Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'business_unit_activity.created_at',
    sortDirection: 'desc'
  }];
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Overview.mapStateToProps)(Overview));

/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Activities = __webpack_require__(2239);

var _Activities2 = _interopRequireDefault(_Activities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Activities2.default;

/***/ }),
/* 2242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _checkChanges = __webpack_require__(61);

var _promptMessages = __webpack_require__(43);

var _translation = __webpack_require__(4);

var _List = __webpack_require__(2244);

var _List2 = _interopRequireDefault(_List);

var _New = __webpack_require__(2245);

var _New2 = _interopRequireDefault(_New);

var _Edit = __webpack_require__(2243);

var _Edit2 = _interopRequireDefault(_Edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AffiliateMappings = function (_Component) {
  _inherits(AffiliateMappings, _Component);

  function AffiliateMappings(props) {
    _classCallCheck(this, AffiliateMappings);

    var _this = _possibleConstructorReturn(this, (AffiliateMappings.__proto__ || Object.getPrototypeOf(AffiliateMappings)).call(this, props));

    _this.state = {
      token: null,
      loading: true,
      data: null
    };
    return _this;
  }

  _createClass(AffiliateMappings, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.params.affiliateMappingID) {
        this.fetchAffiliateMapping();
      } else if (this.props.location.pathname.includes('/new/')) {
        this.fetchAffiliateMappings();
      } else {
        this.setLoading(false);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var pathname = nextProps.location.pathname;

      if (nextProps.params.affiliateMappingID) {
        if (pathname !== this.props.location.pathname) {
          this.fetchAffiliateMapping();
        }
      } else if (pathname.includes('/new/')) {
        this.fetchAffiliateMappings();
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchAffiliateMapping',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var t, store, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                _context.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/mappings/affiliates/' + this.props.params.affiliateMappingID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 19;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context.next = 33;
                break;

              case 27:
                token = res.headers.get('X-Csrf-Token');
                _context.next = 30;
                return res.json();

              case 30:
                data = _context.sent;
                _context.next = 33;
                return this.setComponentState({
                  token: token,
                  data: data
                });

              case 33:
                _context.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchAffiliateMapping() {
        return _ref.apply(this, arguments);
      }

      return fetchAffiliateMapping;
    }()
  }, {
    key: 'fetchAffiliateMappings',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var t, store, query, res, message, token;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                t = this.props.t;
                _context2.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                query = Object.assign({
                  page: 1
                }, q);
                res = void 0;
                _context2.prev = 6;
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/mappings/affiliates/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context2.sent;
                _context2.next = 20;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context2.next = 19;
                return this.setLoading(false);

              case 19:
                return _context2.abrupt('return');

              case 20:
                if (res.ok) {
                  _context2.next = 28;
                  break;
                }

                _context2.next = 23;
                return res.text();

              case 23:
                message = _context2.sent;
                _context2.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context2.next = 31;
                break;

              case 28:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context2.next = 31;
                return this.setComponentState({
                  token: token
                });

              case 31:
                _context2.next = 33;
                return this.setLoading(false);

              case 33:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 12]]);
      }));

      function fetchAffiliateMappings() {
        return _ref2.apply(this, arguments);
      }

      return fetchAffiliateMappings;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this4 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this4.state.token,
          loading: _this4.state.loading,
          data: _this4.state.data,
          affiliateMappingID: _this4.props.params.affiliateMappingID
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return AffiliateMappings;
}(_react.Component);

AffiliateMappings.propTypes = {
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object
  }),
  params: _propTypes2.default.shape({
    affiliateMappingID: _propTypes2.default.string
  })
};
AffiliateMappings.contextTypes = {
  store: _propTypes2.default.object
};
AffiliateMappings.List = _List2.default;
AffiliateMappings.New = (0, _checkChanges.checkChanges)(_New2.default, { message: _promptMessages.NEW_MAPPING_PROMPT });
AffiliateMappings.Edit = (0, _checkChanges.checkChanges)(_Edit2.default);


var TranslatedAffiliateMappings = (0, _reactI18next.withTranslation)(_translation.namespaces)(AffiliateMappings);
TranslatedAffiliateMappings.List = AffiliateMappings.List;
TranslatedAffiliateMappings.New = AffiliateMappings.New;
TranslatedAffiliateMappings.Edit = AffiliateMappings.Edit;
exports.default = TranslatedAffiliateMappings;

/***/ }),
/* 2243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1049);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Edit = function (_Component) {
  _inherits(Edit, _Component);

  function Edit(props) {
    _classCallCheck(this, Edit);

    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(Edit, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, preset) {
        var _this2 = this;

        var t, store, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.form.submit('/mappings/affiliates/' + this.props.affiliateMappingID + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(preset)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false);
                });
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully updated', { ns: _translation.TRANSLATION_FILES.translation, name: res.name }) }));

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Edit {{name}}', { ns: _translation.TRANSLATION_FILES.translation, name: this.props.data ? this.props.data.name : t('preset', { ns: _translation.TRANSLATION_FILES.translation }) }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Update', { ns: _translation.TRANSLATION_FILES.translation }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, preset) {
            _this3.submit(validations, preset);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading,
          preset: this.props.data
        })
      );
    }
  }]);

  return Edit;
}(_react.Component);

Edit.propTypes = {
  affiliateMappingID: _propTypes2.default.string,
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
Edit.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(Edit);

/***/ }),
/* 2244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _MappingPresetList = __webpack_require__(563);

var _MappingPresetList2 = _interopRequireDefault(_MappingPresetList);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    var state = List.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(List, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('User Mapping Settings')
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', columns: 'equal', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Specification Presets')
              ),
              _react2.default.createElement(_MappingPresetList2.default, {
                loading: this.state.loading,
                type: 'affiliates'
              })
            )
          )
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  return {
    loading: loading
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(List);

/***/ }),
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1049);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var New = function (_Component) {
  _inherits(New, _Component);

  function New(props) {
    _classCallCheck(this, New);

    var _this = _possibleConstructorReturn(this, (New.__proto__ || Object.getPrototypeOf(New)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments[1];

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges, callback);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(New, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, preset) {
        var _this2 = this;

        var t, store, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.form.submit('/mappings/affiliates/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(preset)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false, function (noChanges) {
                    if (noChanges) {
                      store.dispatch((0, _reactRouterRedux.goBack)());
                      store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Create Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully created', { ns: _translation.TRANSLATION_FILES.translation, name: res.name }) }));
                    }
                  });
                });

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('New preset', { ns: _translation.TRANSLATION_FILES.translation }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Create', { ns: _translation.TRANSLATION_FILES.screens }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, preset) {
            _this3.submit(validations, preset);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading
        })
      );
    }
  }]);

  return New;
}(_react.Component);

New.propTypes = {
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
New.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(New);

/***/ }),
/* 2246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _AffiliateMappings = __webpack_require__(2242);

var _AffiliateMappings2 = _interopRequireDefault(_AffiliateMappings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AffiliateMappings2.default;

/***/ }),
/* 2247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AppLoading = function (_Component) {
  _inherits(AppLoading, _Component);

  function AppLoading() {
    _classCallCheck(this, AppLoading);

    return _possibleConstructorReturn(this, (AppLoading.__proto__ || Object.getPrototypeOf(AppLoading)).apply(this, arguments));
  }

  _createClass(AppLoading, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var preloader = document.getElementById('preloader-container');
      if (preloader && preloader.classList) {
        preloader.classList.add('app-loading');
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.auth.isAuthenticated && !this.props.auth.isAuthenticating) {
        var store = this.context.store;

        store.dispatch((0, _reactRouterRedux.push)('/'));
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var preloader = document.getElementById('preloader-container');
      if (preloader && preloader.classList) {
        preloader.classList.remove('app-loading');
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement('span', null);
    }
  }]);

  return AppLoading;
}(_react.Component);

AppLoading.propTypes = {
  auth: _propTypes2.default.shape({
    isAuthenticated: _propTypes2.default.bool,
    isAuthenticating: _propTypes2.default.bool
  })
};

AppLoading.contextTypes = {
  store: _propTypes2.default.object
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.auth
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(AppLoading);

/***/ }),
/* 2248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRedux = __webpack_require__(9);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _reactRouter = __webpack_require__(18);

var _jsCookie = __webpack_require__(247);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _reactGa = __webpack_require__(288);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _reactI18next = __webpack_require__(3);

var _groups = __webpack_require__(194);

var _apps = __webpack_require__(263);

var _translation = __webpack_require__(4);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _bookQuery = __webpack_require__(990);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _addressSettings = __webpack_require__(152);

var _affiliateMappings = __webpack_require__(987);

var _appConfig = __webpack_require__(379);

var _bankCaseStates = __webpack_require__(988);

var _banks = __webpack_require__(2077);

var _bobForms = __webpack_require__(989);

var _cancellationReasons = __webpack_require__(991);

var _auth = __webpack_require__(552);

var _currencySetting = __webpack_require__(553);

var _customOptions = __webpack_require__(312);

var _financeSources = __webpack_require__(992);

var _globalSettings = __webpack_require__(993);

var _himsPostcodes = __webpack_require__(994);

var _identityPresets = __webpack_require__(995);

var _phoneValidationPresets = __webpack_require__(996);

var _projectMappings = __webpack_require__(997);

var _projectOptions = __webpack_require__(998);

var _projectSpecifications = __webpack_require__(999);

var _projectUnitLayoutSpecifications = __webpack_require__(1000);

var _projectUnitSpecifications = __webpack_require__(554);

var _salesChartTypes = __webpack_require__(1001);

var _tags = __webpack_require__(555);

var _templates = __webpack_require__(380);

var _AddBankerAnnouncement = __webpack_require__(2084);

var _AddBankerAnnouncement2 = _interopRequireDefault(_AddBankerAnnouncement);

var _Flash = __webpack_require__(2147);

var _Flash2 = _interopRequireDefault(_Flash);

var _AppFooter = __webpack_require__(2085);

var _AppFooter2 = _interopRequireDefault(_AppFooter);

var _Sidebar = __webpack_require__(2191);

var _Sidebar2 = _interopRequireDefault(_Sidebar);

var _ChangesPrompt = __webpack_require__(2115);

var _ChangesPrompt2 = _interopRequireDefault(_ChangesPrompt);

var _NewLogo = __webpack_require__(2161);

var _NewLogo2 = _interopRequireDefault(_NewLogo);

var _AppMenu = __webpack_require__(2087);

var _AppMenu2 = _interopRequireDefault(_AppMenu);

var _DropdownMenu = __webpack_require__(2132);

var _DropdownMenu2 = _interopRequireDefault(_DropdownMenu);

var _LanguageSwitcher = __webpack_require__(2155);

var _LanguageSwitcher2 = _interopRequireDefault(_LanguageSwitcher);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _companies = __webpack_require__(88);

var _url = __webpack_require__(19);

var _displayLanguage = __webpack_require__(594);

var _languagePreference = __webpack_require__(325);

var _countries = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var isPRS = _config2.default.get('prs');

var BookApp = function (_Component) {
  _inherits(BookApp, _Component);

  function BookApp(props) {
    var _this2 = this;

    _classCallCheck(this, BookApp);

    var _this = _possibleConstructorReturn(this, (BookApp.__proto__ || Object.getPrototypeOf(BookApp)).call(this, props));

    _this.onChangeCurrencyDropdown = function (e, _ref) {
      var value = _ref.value;

      e.preventDefault();
      if (value !== _this.state.defaultCurrency) {
        _jsCookie2.default.set('currency', value, { expires: 30 });
        window.location.reload();
      }
    };

    _this.showAddBankerAnnouncement = function () {
      var auth = _this.props.auth;

      return auth.companyBranch.isExternal && !auth.announcementAddBanker;
    };

    _this.fetchNotifications = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event, nextToken) {
        var notifications, t, url, data, store, response, notif;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                event.preventDefault();
                event.stopPropagation();
                notifications = _this.state.notifications;
                t = _this.props.t;
                url = '/notifications/';

                if (nextToken) {
                  url = '/notifications/?nextToken=' + nextToken;
                }
                data = _this.props.appConfig.data;
                store = _this.context.store;
                _context.prev = 8;
                _context.next = 11;
                return (0, _fetchM.serverRequestGet)(url, store);

              case 11:
                response = _context.sent;
                _context.next = 14;
                return _this.setNotificationLoading(false);

              case 14:
                if (!response.error) {
                  _context.next = 18;
                  break;
                }

                _context.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: response.message }));

              case 17:
                return _context.abrupt('return');

              case 18:
                if (data.notification_counter && data.notification_counter.notifications > 0) {
                  // reset unread notification to zero
                  data.notification_counter.notifications = 0;
                  _this.resetNotification();
                }
                notif = response.data;

                if (notifications.items) {
                  notif = notifications;
                  notif.items = notifications.items.concat(response.data.items);
                  notif.next_token = response.data.next_token;
                  if (!response.data.next_token) delete notif.next_token;
                }
                _context.next = 23;
                return _this.setState({ notifications: notif });

              case 23:
                _context.next = 32;
                break;

              case 25:
                _context.prev = 25;
                _context.t0 = _context['catch'](8);

                Bugsnag.notifyException(_context.t0);
                _context.next = 30;
                return _this.setNotificationLoading(false);

              case 30:
                _context.next = 32;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 32:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[8, 25]]);
      }));

      return function (_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.logout = function (event) {
      event.preventDefault();
      var store = _this.context.store;

      store.dispatch((0, _auth.logoutAndRedirect)());
    };

    _this.togglePopupState = function () {
      var popUpState = _this.state.popUpState;

      _this.setState({ popUpState: !popUpState });
    };

    _this.toggleVisibility = function () {
      return _this.setState({ visible: !_this.state.visible });
    };

    _this.closeMenu = function () {
      if (_this.state.visible) {
        _this.setState({ visible: false, activeIndex: 0 });
      }
    };

    _this.checkGroupAccess = function (groups) {
      var teamLeaders = [_groups.DEVELOPER_TEAM_LEADER];
      var roles = [{ text: 'Headquarters', value: '10,6' }, { text: 'Supervisor', value: '10,11,12,13' }, { text: 'Sales Manager', value: '10,11,13' }, { text: 'Sales Admin', value: '10,11' }, { text: 'Agent Leader', value: '10,17' }, { text: 'Agency Admin', value: '10,21' }, { text: '', value: '10' }];
      var rolesArr = [];
      if (groups) {
        if (groups.some(function (g) {
          return g.code === _groups.SUPER_ADMIN;
        })) {
          return 'Super Admin';
        }
        if (groups.some(function (g) {
          return g.code === _groups.ADMIN_COMMUNITY;
        })) {
          return 'Admin Community';
        }
        if (groups.some(function (g) {
          return g.code === _groups.ADMIN;
        })) {
          return 'Admin';
        }
        if (teamLeaders.some(function (tl) {
          return groups.some(function (g) {
            return g.code === tl;
          });
        })) {
          return 'Team Leader';
        }
        groups.forEach(function (g) {
          rolesArr.push(g.id);
        });
        rolesArr.sort();
        var role = roles.find(function (g) {
          return g.value === String(rolesArr.toString());
        });
        if (role && role.text) {
          return role.text;
        }
      }
      return null;
    };

    _this.handleOnClick = function (e, titleProps) {
      var index = titleProps.index;
      var activeIndex = _this.state.activeIndex;

      var newIndex = activeIndex === index ? -1 : index;

      _this.setState({ activeIndex: newIndex });
    };

    _this.handleResize = function () {
      var state = {};
      var windowWidth = window.innerWidth;
      var isMobile = windowWidth < 768;
      if (isMobile !== _this.state.isMobile) {
        state.isMobile = isMobile;
        _this.setState(_extends({}, state));
      }
    };

    _this.gaEvent = function (e, module) {
      _reactGa2.default.event('BOOK_TOP_MENU', {
        category: 'BOOK_TOP_MENU',
        action: module.route || module.link,
        route: module.route || module.link,
        label: module.name,
        name: module.name
      });
    };

    _this.getMHubAccountLink = function () {
      var env = _config2.default.get('server');
      switch (env) {
        case 'development':
          return 'https://account.stage.mhub.my/ ';
        case 'staging':
          return 'https://account.stage.mhub.my/ ';
        case 'demo':
          return 'https://account.demo.mhub.my/';
        default:
          return 'https://account.mhub.my';
      }
    };

    _this.getResponsiveMenuProperty = function (apps) {
      var classNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var isDropdown = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var appsLength = apps.filter(function (a) {
        return a.hasAccess === true;
      }).length;
      if (isDropdown) {
        if (appsLength > 5) return { className: classNames + ' large-hide', only: 'mobile tablet computer', mobile: 6, tablet: 5, computer: 4 };
        if (appsLength > 4) return { className: classNames, only: 'mobile tablet', mobile: 6, tablet: 5 };
        return { className: classNames, only: 'mobile', mobile: 6 };
      }
      if (appsLength > 5) return { className: classNames, only: 'large screen', largeScreen: 13 };
      if (appsLength > 4) return { className: classNames, only: 'computer', computer: 13 };
      return { className: classNames, only: 'tablet computer', tablet: 11, computer: 13 };
    };

    _this.initLanguage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              window.history.replaceState({}, '', (0, _url.cleanURL)('lang'));
              _context2.next = 3;
              return (0, _displayLanguage.initializeDisplayLanguage)(_this.props.i18n, (0, _languagePreference.normalizeLanguage)(_this.props.auth.language) || 'en', _languagePreference.readLanguagePreference, function () {
                return !_this.languageUnmounted;
              });

            case 3:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.filterApps = function () {
      return _this.state.apps.sort(function (a, b) {
        return a.order - b.order;
      });
    };

    _this.state = {
      visible: false,
      notifications: [],
      notificationLoading: false,
      path: _this.props.location.pathname || '',
      apps: [{
        appID: _apps.SHOWROOM,
        app: { shortName: 'Showroom' },
        hasAccess: true,
        order: 1
      }],
      defaultCurrency: '',
      activeIndex: 0,
      isMobile: window.innerWidth < 768,
      popUpState: false
    };
    return _this;
  }

  _createClass(BookApp, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this3 = this;

      var store = this.context.store;
      var _props = this.props,
          auth = _props.auth,
          appConfig = _props.appConfig;

      this.initLanguage();
      var promises = [store.dispatch((0, _appConfig.fetchAppConfig)()).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _banks.fetchBanks)(false)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _bankCaseStates.fetchBankCaseStates)(false)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), isPRS && store.dispatch((0, _projectOptions.fetchProjectOptions)(true)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _projectMappings.fetchProjectMappings)(true)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _projectSpecifications.fetchProjectSpecifications)(true)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _projectUnitLayoutSpecifications.fetchProjectUnitLayoutSpecifications)(true)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _projectUnitSpecifications.fetchProjectUnitSpecifications)(true)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _tags.fetchTags)('picture', false)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _templates.fetchTemplates)('print', false)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _templates.fetchTemplates)('spa_reminder', false)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _templates.fetchTemplates)('termination', false)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _templates.fetchTemplates)('saleschart', false)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _salesChartTypes.fetchSalesChartTypes)(false)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _auth.fetchCompanyCurrencies)()).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _bobForms.fetchBobForms)(false)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _globalSettings.fetchGlobalSettings)(true)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _affiliateMappings.fetchAffiliateMappings)(true)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _bookQuery.extractBookQuery)(this.props)), store.dispatch((0, _cancellationReasons.fetchCancellationReasons)(true)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _addressSettings.fetchAddressSettings)(true)).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _identityPresets.fetchIdentityPresets)()).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _financeSources.fetchFinanceSources)()).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _phoneValidationPresets.fetchPhoneValidationPresets)()).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      }), store.dispatch((0, _customOptions.fetchCustomOptions)()).catch(function (err) {
        return store.dispatch((0, _flash.flashErrorMessage)(err));
      })];
      if (auth && auth.company) {
        if ((0, _companies.isForeignCompany)(auth.company)) {
          promises.push(store.dispatch((0, _currencySetting.fetchCurrencySetting)()).catch(function (err) {
            return store.dispatch((0, _flash.flashErrorMessage)(err));
          }));
        }
        if (appConfig && appConfig.data && appConfig.data.himsIsEnabled) {
          promises.push(store.dispatch((0, _himsPostcodes.fetchHimsPostcodes)(false))
          // .catch(err => store.dispatch(flashErrorMessage(err))),
          );
        }
      }
      return Promise.all(promises).then(function () {
        var apps = _this3.state.apps;

        var companyCurrency = _this3.props.auth.company.companyCurrency || [];
        // set currency for display
        var defaultCurrency = _this3.getDefaultCurrencyDisplay(companyCurrency);
        // if (this.props.appConfig.data.leadManagementIsEnabled) {
        //   apps.unshift({
        //     appID: LEAD,
        //     webURL: this.props.appConfig.data.leadManagementWebURL,
        //     app: { shortName: 'Lead' },
        //     hasAccess: true,
        //     order: 3,
        //   });
        // }
        if (_this3.props.auth && _this3.props.auth.companyApps) {
          var loanTracker = _this3.props.auth.companyApps.find(function (ca) {
            return ca.appID === _apps.LOAN_TRACKER;
          });
          if (loanTracker && _config2.default.get('loanTrackerURL')) {
            apps.unshift({
              appID: _apps.LOAN_TRACKER,
              webURL: _config2.default.get('loanTrackerURL'),
              app: { shortName: 'Loan Tracker' },
              hasAccess: loanTracker.hasAccess,
              order: 2
            });
          }
          var leadv2 = _this3.props.auth.companyApps.find(function (ca) {
            return ca.appID === _apps.LEADV2;
          });
          if (leadv2) {
            if (leadv2.trialEndsAt && (0, _momentTimezone2.default)(leadv2.trialEndsAt).unix() > (0, _momentTimezone2.default)().unix() || !leadv2.trialEndsAt) {
              apps.unshift({
                appID: _apps.LEADV2,
                webURL: leadv2.webURL,
                app: { shortName: 'CRM' },
                hasAccess: leadv2.hasAccess,
                order: 3,
                expiresText: leadv2.trialEndsAt && (0, _momentTimezone2.default)(leadv2.trialEndsAt).diff((0, _momentTimezone2.default)(), 'days') + ' days free trial'
              });
            }
          }
        }
        if (_config2.default.get('mpURL') && _this3.props.auth.companyBranch.isExternal && _this3.props.auth.companyApps && _this3.props.auth.companyApps.find(function (ca) {
          return ca.appID === _apps.MARKETPLACE;
        })) {
          apps.unshift({
            appID: _apps.MARKETPLACE,
            webURL: _config2.default.get('mpURL'),
            app: { shortName: 'Marketplace' },
            hasAccess: true,
            order: 4
          });
        }
        if (_this3.props.auth && _this3.props.auth.companyApps) {
          var creditControl = _this3.props.auth.companyApps.find(function (ca) {
            return ca.appID === _apps.CREDIT_CONTROL;
          });
          if (creditControl) {
            if ((creditControl.trialEndsAt && (0, _momentTimezone2.default)(creditControl.trialEndsAt).unix() > (0, _momentTimezone2.default)().unix() || !creditControl.trialEndsAt) && _this3.props.auth && _this3.props.auth.companyBranch && !_this3.props.auth.companyBranch.isExternal) {
              apps.unshift({
                appID: _apps.CREDIT_CONTROL,
                webURL: creditControl.webURL,
                app: { shortName: 'Credit Control' },
                hasAccess: creditControl.hasAccess,
                order: 5,
                expiresText: creditControl.trialEndsAt && (0, _momentTimezone2.default)(creditControl.trialEndsAt).diff((0, _momentTimezone2.default)(), 'days') + ' days free trial'
              });
            }
          }
        }
        if (_this3.props.auth && _this3.props.auth.companyApps && (_this3.props.auth.isHeadquarters || _this3.props.auth.isSuperAdmin)) {
          var analyticsData = _this3.props.auth.companyApps.find(function (ca) {
            return ca.appID === _apps.ANALYTICS;
          });
          if (analyticsData) {
            apps.unshift({
              appID: _apps.ANALYTICS,
              webURL: analyticsData.webURL,
              app: { shortName: 'Analytics' },
              hasAccess: analyticsData.hasAccess,
              order: 6
            });
          }
        }
        if (_this3.props.auth && _this3.props.auth.companyApps) {
          var commissionTracker = _this3.props.auth.companyApps.find(function (ca) {
            return ca.appID === _apps.COMMISSION_TRACKER;
          });
          if (commissionTracker) {
            apps.unshift({
              appID: _apps.COMMISSION_TRACKER,
              webURL: commissionTracker.webURL,
              app: { shortName: 'Commission' },
              hasAccess: commissionTracker.hasAccess,
              order: 7,
              expiresText: ''
            });
          }
        }
        if (_this3.props.auth && _this3.props.auth.companyApps) {
          var eInvoice = _this3.props.auth.companyApps.find(function (ca) {
            return ca.appID === _apps.EINVOICE;
          });
          if (eInvoice) {
            apps.unshift({
              appID: _apps.EINVOICE,
              webURL: eInvoice.webURL,
              app: { shortName: 'e-Invoice' },
              hasAccess: eInvoice.hasAccess,
              order: 8,
              expiresText: ''
            });
          }
        }
        _this3.setState({
          apps: apps,
          defaultCurrency: defaultCurrency
        });
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.state.path !== !nextProps.location.pathname) {
        this.closeMenu();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.languageUnmounted = true;
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'getDefaultCurrencyDisplay',
    value: function getDefaultCurrencyDisplay() {
      var companyCurrency = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      // Set default currency from cookies if exist
      // else use company default and set cookies
      var cookieCurrency = _jsCookie2.default.get('currency');
      if (!cookieCurrency) {
        var _ref4 = companyCurrency.find(function (c) {
          return c.isDefault;
        }) || {},
            _ref4$code = _ref4.code,
            code = _ref4$code === undefined ? null : _ref4$code;

        if (!code) {
          // company currency is not set, returns null, currency dropdown will not be display
          return code;
        }
        cookieCurrency = code;
        _jsCookie2.default.set('currency', cookieCurrency, { expires: 30 });
      }
      return cookieCurrency;
    }
  }, {
    key: 'getCurrencyOptions',
    value: function getCurrencyOptions() {
      var _this4 = this;

      var activeIndex = this.state.activeIndex;

      var currencies = this.props.auth.company.companyCurrency;
      if (!currencies) currencies = [];
      return currencies.map(function (c, i) {
        return activeIndex === 1 ? _react2.default.createElement(
          _semanticUiReact.Menu.Item,
          { className: 'sub', name: 'user', key: i, value: c.code, onClick: _this4.onChangeCurrencyDropdown },
          _react2.default.createElement(
            _semanticUiReact.Accordion.Content,
            { active: activeIndex === 1 },
            _react2.default.createElement(_semanticUiReact.Icon, {
              name: 'dollar',
              style: { marginLeft: '1rem' }
            }),
            c.code
          )
        ) : null;
      });
    }
  }, {
    key: 'companyCurrencyOptions',
    value: function companyCurrencyOptions() {
      // Format options according to Semantic UI dropdown
      var currencies = this.props.auth.company.companyCurrency;
      if (!currencies) currencies = [];
      return currencies.map(function (c) {
        return {
          text: c.code,
          value: c.code,
          content: _react2.default.createElement(_semanticUiReact.Header, { size: 'small', content: c.code, subheader: c.name })
          // content: `${c.code}  ${c.name}`,
        };
      });
    }
  }, {
    key: 'resetNotification',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var store;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                store = this.context.store;
                _context3.prev = 1;
                _context3.next = 4;
                return (0, _fetchM.serverRequestPost)('/notifications/reset/', store);

              case 4:
                _context3.next = 9;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3['catch'](1);

                Bugsnag.notifyException(_context3.t0);

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[1, 6]]);
      }));

      function resetNotification() {
        return _ref5.apply(this, arguments);
      }

      return resetNotification;
    }()
  }, {
    key: 'setNotificationIcon',
    value: function setNotificationIcon() {
      var data = this.props.appConfig.data;

      if (data.notification_counter && data.notification_counter.notifications > 0) {
        return _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'bell outline' }),
          _react2.default.createElement(
            _semanticUiReact.Label,
            { size: 'tiny', circular: true, color: 'teal', floating: true },
            data.notification_counter.notifications > 9 ? '9+' : data.notification_counter.notifications
          )
        );
      }
      return _react2.default.createElement(_semanticUiReact.Icon, { name: 'bell outline' });
    }
  }, {
    key: 'hasAccessDE',
    value: function hasAccessDE() {
      var _props2 = this.props,
          auth = _props2.auth,
          appConfig = _props2.appConfig;

      if (auth && auth.companyBranch && !auth.companyBranch.isExternal && appConfig && appConfig.data && appConfig.data.customerOwnedByDeveloperExecutive) {
        return true;
      }
      return false;
    }
  }, {
    key: 'modules',
    value: function modules() {
      return [{
        name: 'Home',
        route: '/',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: true,
        isSiteplan: true,
        isSuperAdmin: true
      }, {
        name: 'Projects',
        route: '/projects/',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: true,
        isSiteplan: true,
        isSuperAdmin: true
      }, {
        name: 'Bookings',
        route: (0, _countries.isCountryVietnam)(this.props.auth.company.countryCode) ? '/opportunities/' : '/bookings/',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: true,
        isSiteplan: false,
        isSuperAdmin: true,
        hideForExternal: (0, _countries.isCountryVietnam)(this.props.auth.company.countryCode)
      }].concat(_toConsumableArray((0, _countries.isCountryVietnam)(this.props.auth.company.countryCode) ? [{
        name: 'Sales',
        route: '/bookings/',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: true,
        isSiteplan: false,
        isSuperAdmin: true
      }] : []), [{
        name: 'Customers',
        route: '/customers/',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: this.hasAccessDE() || false,
        isSiteplan: false,
        isSuperAdmin: true
      }, {
        name: 'Users',
        route: '/users/',
        enabled: true,
        isBranchLeader: this.props.auth.isBranchLeaderSupervisor || false,
        isHeadquarters: true,
        isDeveloper: false,
        isSiteplan: false,
        isSuperAdmin: true
      },
      // {
      //   name: 'Pictures',
      //   route: '/pictures/',
      //   enabled: true,
      // },
      {
        name: 'Help',
        route: 'https://drive.google.com/drive/folders/1U6gMqLGf06-8mGZGPcKG3Ukn6-spYaQ-',
        enabled: true,
        isBranchLeader: true,
        isHeadquarters: true,
        isDeveloper: true,
        isSiteplan: true,
        isSuperAdmin: true
      }]);
    }
  }, {
    key: 'setNotificationLoading',
    value: function setNotificationLoading() {
      var _this5 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this5.setState({ notificationLoading: loading }, function () {
          res(loading);
        });
      });
    }

    // Read only at load, never when returning to an existing tab.

  }, {
    key: 'parseNotificationData',
    value: function parseNotificationData(notif) {
      var parsedNotif = notif;

      try {
        // console.log('notif', notif);
        parsedNotif.data = JSON.parse(notif.data);
        parsedNotif.changes = JSON.parse(notif.changes);
        if (notif.user) {
          parsedNotif.user = JSON.parse(notif.user);
        }
      } catch (e) {
        Bugsnag.notifyException(e);
        return parsedNotif;
      }
      return parsedNotif;
    }
  }, {
    key: 'renderNotificationContent',
    value: function renderNotificationContent(notif) {
      switch (notif.tpl_action) {
        case 'update_notes':
          return _react2.default.createElement(
            'div',
            { className: 'text-ellipsis' },
            notif.user.name || '',
            ' updated Booking Notes to',
            _react2.default.createElement(
              'div',
              { className: 'text-ellipsis', style: { width: '200px' } },
              notif.changes[0].value
            ),
            _react2.default.createElement(
              'div',
              { style: { textAlign: 'right' } },
              'at ',
              _react2.default.createElement(_Timestamp2.default, { format: 'YYYY-MM-DD', timestamp: notif.created_at })
            )
          );
        default:
          return null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props3 = this.props,
          auth = _props3.auth,
          t = _props3.t;
      var pathname = this.props.location.pathname;
      var _state = this.state,
          activeIndex = _state.activeIndex,
          defaultCurrency = _state.defaultCurrency,
          isMobile = _state.isMobile,
          popUpState = _state.popUpState;

      var groupAccess = this.checkGroupAccess(this.props.auth.groups);
      var apps = this.filterApps();
      return _react2.default.createElement(
        'div',
        { className: 'main-app' },
        _react2.default.createElement(
          _Sidebar2.default,
          {
            visible: this.state.visible,
            onClose: this.closeMenu,
            sidebar: _react2.default.createElement(
              _semanticUiReact.Sidebar,
              {
                as: _semanticUiReact.Menu,
                ref: function ref(_ref6) {
                  _this6.menuBar = _ref6;
                },
                animation: 'overlay',
                width: 'thin',
                direction: 'right',
                visible: this.state.visible,
                icon: 'labeled',
                vertical: true,
                inverted: true,
                className: 'side'
              },
              _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                { as: 'a', className: 'main', name: 'user', onClick: this.closeMenu },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'close' })
              ),
              defaultCurrency ? _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                { className: 'sub', name: 'user' },
                _react2.default.createElement(
                  _semanticUiReact.Accordion,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Accordion.Title,
                    {
                      style: { color: 'white' },
                      active: activeIndex === 1
                      // content={defaultCurrency}
                      , index: 1,
                      onClick: this.handleOnClick
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, {
                      name: 'dropdown',
                      style: { marginLeft: '1rem' }
                    }),
                    defaultCurrency
                  ),
                  this.getCurrencyOptions()
                )
              ) : null,
              _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                { as: _reactRouter.Link, className: 'sub', to: '/profile/', name: 'user' },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'user' }),
                t('Profile')
              ),
              _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                { as: _reactRouter.Link, className: 'sub', to: 'https://drive.google.com/drive/folders/1U6gMqLGf06-8mGZGPcKG3Ukn6-spYaQ-', target: '_blank', name: 'user' },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle' }),
                t('Help & Support')
              ),
              _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                { as: 'a', className: 'sub', onClick: this.logout, name: 'user' },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'log out' }),
                t('Logout')
              )
            )
          },
          _react2.default.createElement(
            'div',
            { className: 'top-app-menu-wrapper' },
            _react2.default.createElement(
              _semanticUiReact.Container,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { className: 'top-app-menu' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    {
                      mobile: 4,
                      tablet: 3,
                      computer: 2,
                      className: this.props.auth.company.customLogoSrc === '' ? '' : 'logo_custom_container'
                    },
                    _react2.default.createElement(_NewLogo2.default, {
                      mhub: !isMobile,
                      customLogoSrc: this.props.auth.company.customLogoSrc
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    _extends({ style: { paddingTop: '0.45em' } }, this.getResponsiveMenuProperty(apps)),
                    _react2.default.createElement(_AppMenu2.default, {
                      apps: apps,
                      isSiteplan: this.props.auth.isSiteplan
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    this.getResponsiveMenuProperty(apps, 'column_book_app_dropdown_menu', true),
                    _react2.default.createElement(_DropdownMenu2.default, {
                      apps: apps,
                      isSiteplan: this.props.auth.isSiteplan
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { style: isMobile ? { paddingTop: '0.8em', marginRight: '1em' } : { paddingTop: '0.8em' }, mobile: 2, tablet: 1, computer: 1 },
                    _react2.default.createElement(
                      _semanticUiReact.Popup,
                      {
                        on: 'click',
                        open: popUpState,
                        onOpen: this.togglePopupState,
                        onClose: this.togglePopupState,
                        trigger: _react2.default.createElement('img', { alt: 'top-menu-user', src: '/assets/images/icons/User.svg', style: { width: '3em', height: '2em', cursor: 'pointer' } })
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Grid,
                        { className: 'top-popup-menu' },
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Row,
                          { style: { borderBottom: '1px solid #DBDDDE', background: '#F8F8F8' } },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            null,
                            _react2.default.createElement(
                              'b',
                              null,
                              this.props.auth.preferredName
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _reactRouter.Link,
                          {
                            as: 'a',
                            to: '/profile/',
                            className: 'row popup-row',
                            onClick: this.togglePopupState
                          },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { className: 'popup-col' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Row,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                null,
                                _react2.default.createElement('img', { alt: 'top-menu-user', src: '/assets/images/icons/User.svg', style: { width: '3em', height: '2em', cursor: 'pointer' } })
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                null,
                                t('My Profile')
                              )
                            )
                          )
                        ),
                        this.props.auth && (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) ? _react2.default.createElement(
                          _reactRouter.Link,
                          {
                            as: 'a',
                            to: this.getMHubAccountLink(),
                            className: 'row popup-row',
                            target: '_blank'
                          },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { className: 'popup-col' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Row,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                null,
                                _react2.default.createElement('img', { alt: 'top-menu-user', src: '/assets/images/icons/accountSVG.svg', style: { width: '3em', height: '2em', cursor: 'pointer' } })
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                null,
                                t('MHub account')
                              )
                            )
                          )
                        ) : null,
                        _react2.default.createElement(
                          _reactRouter.Link,
                          {
                            onClick: this.logout,
                            className: 'row popup-row',
                            'data-bot-target': 'signout'
                          },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { className: 'popup-col' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Row,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                null,
                                _react2.default.createElement('img', { alt: 'top-menu-user', src: '/assets/images/icons/LogoutSVG.svg', style: { width: '3em', height: '2em', cursor: 'pointer' } })
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                null,
                                t('Sign out')
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'app-menu-wrapper' },
            _react2.default.createElement(
              'div',
              { className: 'app-menu-wrap' },
              _react2.default.createElement(
                _semanticUiReact.Container,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { className: 'middle-app-menu' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { tablet: 13, computer: 13 },
                      _react2.default.createElement(
                        'div',
                        { className: 'app-menu-details' },
                        _react2.default.createElement(
                          'div',
                          { className: 'details', style: { alignSelf: 'normal' } },
                          _react2.default.createElement(
                            'div',
                            { className: 'item' },
                            _react2.default.createElement(
                              'div',
                              null,
                              _react2.default.createElement(
                                'h2',
                                null,
                                this.props.auth.preferredName
                              )
                            ),
                            groupAccess ? _react2.default.createElement(
                              'div',
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Label,
                                { size: 'tiny' },
                                t(groupAccess, { ns: _translation.TRANSLATION_FILES.constants })
                              )
                            ) : null
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'item' },
                            _react2.default.createElement(
                              'h5',
                              null,
                              this.props.auth.companyBranch.shortName,
                              ' | ',
                              _react2.default.createElement(
                                'span',
                                { className: 'company_shortname' },
                                this.props.auth.company.shortName
                              )
                            )
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { style: { textAlign: 'right' }, only: 'tablet computer', tablet: 3, computer: 3, className: 'app-menu-options' },

                      // Make sure default currency is set before render dropdown
                      !(0, _companies.isForeignCompany)(auth.company) && _react2.default.createElement(_LanguageSwitcher2.default, null),
                      auth.company && (0, _companies.isForeignCompany)(auth.company) && _react2.default.createElement(_LanguageSwitcher2.default, null)
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Menu,
                  {
                    className: 'app-menu',
                    pointing: true,
                    secondary: true
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Menu.Menu,
                    null,
                    this.modules().filter(function (module) {
                      var companyBranch = _this6.props.auth.companyBranch;
                      if (companyBranch && companyBranch.isExternal && module.hideForExternal) {
                        return false;
                      }
                      if (_this6.props.auth.isSuperAdmin) {
                        return module.isSuperAdmin;
                      }
                      if (_this6.props.auth.isHeadquarters) {
                        return module.isHeadquarters;
                      }
                      if (_this6.props.auth.isBranchLeader) {
                        return module.isBranchLeader;
                      }
                      if (_this6.props.auth.isDeveloper) {
                        return module.isDeveloper;
                      }
                      if (_this6.props.auth.isSiteplan) {
                        return module.isSiteplan;
                      }
                      return true;
                    }).map(function (module, idx) {
                      return _react2.default.createElement(_semanticUiReact.Menu.Item, {
                        className: 'top-menu',
                        key: idx,
                        as: _reactRouter.Link,
                        name: module.name !== 'Help' || module.name === 'Help' && !isMobile ? t(module.name) : '',
                        content: module.name !== 'Help' || module.name === 'Help' && !isMobile ? t(module.name) : '',
                        disabled: !module.enabled,
                        active: module.route === '/' ? pathname === module.route : pathname.startsWith(module.route),
                        to: module.link ? '' : module.route,
                        href: module.link && module.link,
                        onClick: function onClick(e) {
                          return _this6.gaEvent(e, module);
                        },
                        icon: module.name === 'Help' && isMobile ? 'info circle' : null,
                        target: module.name === 'Help' || module.name === 'Marketplace' ? '_blank' : null
                      });
                    })
                  )
                )
              ),
              _react2.default.createElement('div', { className: 'header-cover' })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'app-content' },
            this.props.children
          ),
          _react2.default.createElement(_AppFooter2.default, null)
        ),
        _react2.default.createElement(_Flash2.default, null),
        _react2.default.createElement(_ChangesPrompt2.default, null),
        (0, _countries.isCountryVietnam)(this.props.auth.company.countryCode) ? null : _react2.default.createElement(_AddBankerAnnouncement2.default, { show: this.showAddBankerAnnouncement() })
      );
    }
  }]);

  return BookApp;
}(_react.Component);

BookApp.propTypes = {
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string
  }),
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      customerOwnedByDeveloperExecutive: _propTypes2.default.bool,
      leadManagementIsEnabled: _propTypes2.default.bool,
      leadManagementWebURL: _propTypes2.default.string,
      himsIsEnabled: _propTypes2.default.bool
    })
  }),
  auth: _propTypes2.default.shape({
    preferredName: _propTypes2.default.string,
    company: _propTypes2.default.shape({
      shortName: _propTypes2.default.string,
      customLogoSrc: _propTypes2.default.string,
      companyCurrency: _propTypes2.default.oneOfType([_propTypes2.default.array]),
      isHeadquarters: _propTypes2.default.bool,
      isSuperAdmin: _propTypes2.default.bool,
      countryCode: _propTypes2.default.string
    }),
    companyBranch: _propTypes2.default.shape({
      shortName: _propTypes2.default.string,
      isExternal: _propTypes2.default.bool
    }),
    companyApps: _propTypes2.default.oneOfType([_propTypes2.default.array]),
    language: _propTypes2.default.string,
    isBranchLeaderSupervisor: _propTypes2.default.bool,
    isBranchLeader: _propTypes2.default.bool,
    isDeveloper: _propTypes2.default.bool,
    isSiteplan: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    groups: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      code: _propTypes2.default.string
    }))
  }),
  t: _propTypes2.default.func,
  i18n: _propTypes2.default.shape({
    language: _propTypes2.default.string
  })
};

BookApp.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig,
    auth: state.auth
  };
};

BookApp.propTypes = {
  children: _propTypes2.default.node
};

BookApp.contextTypes = {
  store: _propTypes2.default.object
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(BookApp.mapStateToProps)(BookApp));

/***/ }),
/* 2249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _reactGa = __webpack_require__(288);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _BookDash = __webpack_require__(573);

var _BookDash2 = _interopRequireDefault(_BookDash);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _translation = __webpack_require__(4);

var _countries = __webpack_require__(60);

var _moduleAccess = __webpack_require__(595);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var BookDash = function (_Component) {
  _inherits(BookDash, _Component);

  function BookDash(props) {
    _classCallCheck(this, BookDash);

    var _this = _possibleConstructorReturn(this, (BookDash.__proto__ || Object.getPrototypeOf(BookDash)).call(this, props));

    _this.gaEvent = function (e, module) {
      _reactGa2.default.event('BOOK_DASH', {
        category: 'BOOK_DASH',
        action: module.route || module.link,
        route: module.route || module.link,
        label: module.name,
        name: module.name
      });
    };

    _this.state = {
      loading: false,
      companyApp: []
    };
    return _this;
  }

  _createClass(BookDash, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props$auth = this.props.auth,
          auth = _props$auth === undefined ? {} : _props$auth;

      if (auth.creditCheckAccess) {
        this.getCredit();
      }
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'getCredit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, companyAppCredit, _message;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                _context.prev = 1;
                _context.next = 4;
                return this.setLoading(true);

              case 4:
                _context.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/company/credit/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 6:
                res = _context.sent;

                if (res.ok) {
                  _context.next = 15;
                  break;
                }

                _context.next = 10;
                return res.text();

              case 10:
                message = _context.sent;
                _context.next = 13;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 13:
                _context.next = 21;
                break;

              case 15:
                _context.next = 17;
                return res.json();

              case 17:
                companyAppCredit = _context.sent;

                if (!(companyAppCredit !== null)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 21;
                return this.setState({ companyApp: companyAppCredit.companyApp });

              case 21:
                _context.next = 23;
                return this.setLoading(false);

              case 23:
                _context.next = 36;
                break;

              case 25:
                _context.prev = 25;
                _context.t0 = _context['catch'](1);
                _context.next = 29;
                return this.setLoading(false);

              case 29:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 35;
                  break;
                }

                _context.next = 32;
                return _context.t0.res.text();

              case 32:
                _message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));
                return _context.abrupt('return');

              case 35:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));

              case 36:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 25]]);
      }));

      function getCredit() {
        return _ref.apply(this, arguments);
      }

      return getCredit;
    }()
  }, {
    key: 'isNotExternalAgencyAdmin',
    value: function isNotExternalAgencyAdmin() {
      var auth = this.props.auth;
      if (auth && auth.isExternalAgencyAdmin) {
        return false;
      }
      return true;
    }
  }, {
    key: 'hasAccessDE',
    value: function hasAccessDE() {
      var auth = this.props.auth;
      var appConfig = this.props.appConfig;
      if (auth && auth.companyBranch && !auth.companyBranch.isExternal && appConfig && appConfig.data && appConfig.data.customerOwnedByDeveloperExecutive) {
        return true;
      }
      return false;
    }
  }, {
    key: 'hasNoetic',
    value: function hasNoetic() {
      var appConfig = this.props.appConfig;
      if (appConfig && appConfig.data && appConfig.data.noeticIsEnabled) {
        return true;
      }
      return false;
    }
  }, {
    key: 'hasIFCA',
    value: function hasIFCA() {
      var appConfig = this.props.appConfig;
      if (appConfig && appConfig.data && appConfig.data.ifcaIsEnabled) {
        return true;
      }
      return false;
    }
  }, {
    key: 'hasInsoft',
    value: function hasInsoft() {
      var appConfig = this.props.appConfig;
      if (appConfig && appConfig.data && appConfig.data.insoftIsEnabled) {
        return true;
      }
      return false;
    }
  }, {
    key: 'hasSalesforce',
    value: function hasSalesforce() {
      var appConfig = this.props.appConfig;
      if (appConfig && appConfig.data && appConfig.data.externalServiceIsEnabled && appConfig.data.externalServiceSFModeType === 2 // is IJM
      ) {
          return true;
        }
      return false;
    }
  }, {
    key: 'modules',
    value: function modules() {
      var leadLink = _config2.default.get('env') === 'production' ? 'https://leads.mhub.my' : 'https://lead.stage.mhub.my';
      if (this.props.appConfig.data.leadManagementWebURL !== '') {
        leadLink = this.props.appConfig.data.leadManagementWebURL;
      }
      var isCreditAccess = this.props.auth.creditCheckAccess && this.state.companyApp && !this.state.companyApp.requiredHQApproval && !this.props.auth.isBranchLeader && true;
      var settings = this.props.appConfig.data.settings;

      var companyCountryCode = this.props.auth && this.props.auth.company && this.props.auth.company.countryCode;
      var restrictedAccess = (0, _moduleAccess.restrictedModuleAccess)(this.props.auth);
      return [{
        name: 'Projects',
        description: 'Project Details, Sales Chart, Reports',
        type: 'projects',
        route: '/projects/',
        icon: 'building',
        enabled: true,
        isBranchLeader: true,
        isDeveloper: true,
        isSiteplan: true,
        isHeadquarters: true,
        isSuperAdmin: true,
        isDeveloperSupervisor: false,
        isDeveloperSalesManager: false,
        isDeveloperSalesAdmin: false
      }, {
        name: 'Bookings',
        description: 'Reservations, Payment & Loan Status',
        type: 'bookings',
        route: (0, _countries.isCountryVietnam)(companyCountryCode) ? '/opportunities/' : '/bookings/',
        icon: 'book',
        enabled: true,
        isBranchLeader: true,
        isDeveloper: true,
        isSiteplan: false,
        isHeadquarters: true,
        isSuperAdmin: true,
        isDeveloperSupervisor: false,
        isDeveloperSalesManager: false,
        isDeveloperSalesAdmin: false,
        hideForExternal: (0, _countries.isCountryVietnam)(companyCountryCode)
      }].concat(_toConsumableArray((0, _countries.isCountryVietnam)(companyCountryCode) ? [{
        name: 'Sales',
        description: 'Reservations, Payment & Loan Status',
        type: 'bookings',
        route: '/bookings/',
        icon: 'book',
        enabled: true,
        isBranchLeader: true,
        isDeveloper: true,
        isSiteplan: false,
        isHeadquarters: true,
        isSuperAdmin: true,
        isDeveloperSupervisor: false,
        isDeveloperSalesManager: false,
        isDeveloperSalesAdmin: false
      }] : []), [{
        name: 'Users',
        description: 'User Access & Permissions',
        type: 'staff',
        route: '/users/',
        icon: 'users',
        enabled: true,
        isBranchLeader: this.props.auth.isBranchLeaderSupervisor || false,
        isDeveloper: false,
        isSiteplan: false,
        isHeadquarters: true,
        isSuperAdmin: true,
        isDeveloperSupervisor: false,
        isDeveloperSalesManager: false,
        isDeveloperSalesAdmin: false
      }, {
        name: 'Lead Management',
        description: 'View and Manage Leads',
        type: 'lead',
        link: leadLink,
        icon: 'settings',
        enabled: true,
        isBranchLeader: this.props.appConfig.data.leadManagementIsEnabled,
        isDeveloper: this.props.appConfig.data.leadManagementIsEnabled,
        isHeadquarters: this.props.appConfig.data.leadManagementIsEnabled,
        isSuperAdmin: this.props.appConfig.data.leadManagementIsEnabled,
        isDeveloperSupervisor: false,
        isDeveloperSalesManager: false,
        isDeveloperSalesAdmin: false
      }, this.hasNoetic() && {
        name: 'Post-Sale',
        description: 'Synchronize Bookings to Noetic',
        type: 'accounting',
        route: '/accounting/',
        icon: 'accounting',
        enabled: true,
        isBranchLeader: true,
        isDeveloper: false,
        isSiteplan: false,
        isHeadquarters: true,
        isSuperAdmin: true,
        isDeveloperSupervisor: false,
        isDeveloperSalesManager: false,
        isDeveloperSalesAdmin: false
      }, this.hasIFCA() && {
        name: 'Post-Sale',
        description: 'Synchronize Bookings to IFCA',
        type: 'accounting',
        route: '/accounting_ifca/',
        icon: 'accounting',
        enabled: true,
        isBranchLeader: true,
        isDeveloper: false,
        isSiteplan: false,
        isHeadquarters: true,
        isSuperAdmin: true,
        isDeveloperSupervisor: false,
        isDeveloperSalesManager: false,
        isDeveloperSalesAdmin: false
      }, this.hasInsoft() && {
        name: 'Post-Sale',
        description: 'Synchronize Bookings to Insoft',
        type: 'accounting',
        route: '/accounting_insoft/',
        icon: 'accounting',
        enabled: true,
        isBranchLeader: true,
        isDeveloper: false,
        isSiteplan: false,
        isHeadquarters: true,
        isSuperAdmin: true,
        isDeveloperSupervisor: false,
        isDeveloperSalesManager: false,
        isDeveloperSalesAdmin: false
      }, _extends({
        name: 'Payments',
        description: 'View and Manage Payments',
        type: 'payments',
        route: '/payments/',
        icon: 'settings',
        enabled: true,
        isBranchLeader: false,
        isDeveloper: false,
        isHeadquarters: true,
        isSuperAdmin: true,
        isDeveloperSupervisor: settings && settings.canManagePaymentSupervisor,
        isDeveloperSalesManager: settings && settings.canManagePaymentSalesManager,
        isDeveloperSalesAdmin: settings && settings.canManagePaymentSalesAdmin
      }, restrictedAccess), {
        name: 'Customers',
        description: 'Contact information',
        type: 'customers',
        route: '/customers/',
        icon: 'child',
        enabled: true,
        isBranchLeader: true,
        isDeveloper: this.hasAccessDE() || false,
        isSiteplan: false,
        isHeadquarters: true,
        isSuperAdmin: true,
        isDeveloperSupervisor: false,
        isDeveloperSalesManager: false,
        isDeveloperSalesAdmin: false
      }, _extends({
        name: 'Bankers',
        description: 'View and Manage Panel Bankers and Preferred Bankers',
        type: 'preferred_bankers',
        route: '/preferred_bankers/',
        enabled: this.isNotExternalAgencyAdmin() && settings && !settings.bookingHideLoanTracker,
        isDeveloper: true,
        isHeadquarters: true,
        isSuperAdmin: true,
        isDeveloperSupervisor: false,
        isDeveloperSalesManager: false,
        isDeveloperSalesAdmin: false
      }, restrictedAccess), {
        name: 'Media',
        description: 'View and Manage Photos and Documents',
        type: 'pictures',
        route: '/media/',
        icon: 'picture',
        enabled: true,
        isBranchLeader: false,
        isDeveloper: false,
        isSiteplan: false,
        isHeadquarters: true,
        isSuperAdmin: true,
        isDeveloperSupervisor: false,
        isDeveloperSalesManager: false,
        isDeveloperSalesAdmin: false
      }, {
        name: 'Credit Checks',
        description: 'Manage and Run Purchaser Credit Scores',
        type: 'creditcheck',
        route: '/customers/manage/credit_checks/',
        icon: 'dashboard',
        enabled: true,
        isBranchLeader: false,
        isDeveloper: isCreditAccess,
        isSiteplan: false,
        isHeadquarters: this.props.auth.creditCheckAccess && true,
        isSuperAdmin: this.props.auth.creditCheckAccess && true,
        isDeveloperSupervisor: false,
        isDeveloperSalesManager: false,
        isDeveloperSalesAdmin: false
      }, _extends({
        name: 'Reports',
        description: 'Project Units, Bookings, Users Performance',
        type: 'reports',
        route: '/reports/',
        icon: 'chart bar',
        enabled: true,
        isBranchLeader: false,
        isDeveloper: false,
        isSiteplan: false,
        isHeadquarters: true,
        isSuperAdmin: true,
        isDeveloperSupervisor: false,
        isDeveloperSalesManager: false,
        isDeveloperSalesAdmin: false
      }, restrictedAccess), {
        name: 'Activity Logs',
        description: 'Booking & Project Unit Activities',
        type: 'activities',
        route: '/activities/',
        icon: 'chart bar',
        enabled: true,
        isBranchLeader: false,
        isDeveloper: false,
        isSiteplan: false,
        isHeadquarters: true,
        isSuperAdmin: true,
        isDeveloperSupervisor: false,
        isDeveloperSalesManager: false,
        isDeveloperSalesAdmin: false
      }, this.hasSalesforce() && {
        name: 'Salesforce Sync',
        description: 'View Salesforce Integration Status',
        type: 'settings',
        route: '/integrations/sf/',
        icon: 'settings',
        enabled: true,
        isBranchLeader: false,
        isDeveloper: false,
        isSiteplan: false,
        isHeadquarters: true,
        isSuperAdmin: true,
        isDeveloperSupervisor: false,
        isDeveloperSalesManager: false,
        isDeveloperSalesAdmin: false
      }, {
        name: 'Settings',
        description: 'Specification Presets, Currency Settings & Business Unit Setup',
        type: 'settings',
        route: '/settings/',
        icon: 'settings',
        enabled: true,
        isBranchLeader: false,
        isDeveloper: false,
        isSiteplan: false,
        isHeadquarters: true,
        isSuperAdmin: true,
        isDeveloperSupervisor: false,
        isDeveloperSalesManager: false,
        isDeveloperSalesAdmin: false
      }]);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { doubling: true, columns: 4, className: 'dash_grid' },
          this.modules().filter(function (module) {
            if (!module.enabled) return false;
            var companyBranch = _this3.props.auth.companyBranch;
            if (companyBranch && companyBranch.isExternal && module.hideForExternal) {
              return false;
            }
            if (_this3.props.auth.isSuperAdmin && module.isSuperAdmin) {
              return true;
            }
            if (_this3.props.auth.isAdminBasic && module.isAdminBasic) {
              return true;
            }
            if (_this3.props.auth.isAdminCommunity && module.isAdminCommunity) {
              return true;
            }
            if (_this3.props.auth.isHeadquarters && module.isHeadquarters) {
              return true;
            }
            if (_this3.props.auth.isBranchLeader && module.isBranchLeader) {
              return true;
            }
            if (_this3.props.auth.isDeveloper && module.isDeveloper) {
              return true;
            }
            if (_this3.props.auth.isSiteplan && module.isSiteplan) {
              return true;
            }
            if (_this3.props.auth.isDeveloperSupervisor && module.isDeveloperSupervisor) {
              return true;
            }
            if (_this3.props.auth.isDeveloperSalesManager && module.isDeveloperSalesManager) {
              return true;
            }
            if (_this3.props.auth.isDeveloperSalesAdmin && module.isDeveloperSalesAdmin) {
              return true;
            }
            return false;
          }).map(function (module, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { key: idx },
              _react2.default.createElement(
                _reactRouter.Link,
                {
                  type: 'a',
                  href: module.link && module.link,
                  target: module.link && '_blank',
                  to: module.link ? '' : module.route,
                  onClick: function onClick(e) {
                    return _this3.gaEvent(e, module);
                  }
                },
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  { textAlign: 'center', as: 'h3' },
                  _react2.default.createElement(
                    'p',
                    null,
                    _react2.default.createElement(_BookDash2.default, {
                      type: module.type,
                      width: '6em',
                      height: '6em',
                      backfill: '#F8F8F8',
                      iconfill: '#00233B'
                    })
                  ),
                  t(module.name).toUpperCase(),
                  _react2.default.createElement(
                    _semanticUiReact.Header.Subheader,
                    null,
                    t(module.description)
                  )
                )
              )
            );
          })
        )
      );
    }
  }]);

  return BookDash;
}(_react.Component);

BookDash.contextTypes = {
  store: _propTypes2.default.object
};
BookDash.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      customerOwnedByDeveloperExecutive: _propTypes2.default.bool,
      noeticIsEnabled: _propTypes2.default.bool,
      ifcaIsEnabled: _propTypes2.default.bool,
      insoftIsEnabled: _propTypes2.default.bool,
      onlinePaymentEnabled: _propTypes2.default.bool,
      leadManagementIsEnabled: _propTypes2.default.bool,
      leadManagementWebURL: _propTypes2.default.string,
      settings: _propTypes2.default.shape({
        canManagePaymentSupervisor: _propTypes2.default.bool,
        canManagePaymentSalesManager: _propTypes2.default.bool,
        canManagePaymentSalesAdmin: _propTypes2.default.bool,
        bookingHideLoanTracker: _propTypes2.default.bool
      })
    })
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isBranchLeaderSupervisor: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isDeveloper: _propTypes2.default.bool,
    isDeveloperSupervisor: _propTypes2.default.bool,
    isDeveloperSalesManager: _propTypes2.default.bool,
    isDeveloperSalesAdmin: _propTypes2.default.bool,
    isExternalAgent: _propTypes2.default.bool,
    isExternalAgencyAdmin: _propTypes2.default.bool,
    isSiteplan: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isAdminCommunity: _propTypes2.default.bool,
    creditCheckAccess: _propTypes2.default.bool,
    companyBranch: _propTypes2.default.shape({
      isExternal: _propTypes2.default.bool
    }),
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  t: _propTypes2.default.func
};
BookDash.defaultProps = {
  appConfig: {},
  auth: {}
};

BookDash.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig,
    auth: state.auth
  };
};

BookDash.contextTypes = {
  store: _propTypes2.default.object
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)((0, _reactRedux.connect)(BookDash.mapStateToProps)(BookDash));

/***/ }),
/* 2250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _webValidations = __webpack_require__(23);

var _Delete = __webpack_require__(2251);

var _Delete2 = _interopRequireDefault(_Delete);

var _List = __webpack_require__(2253);

var _List2 = _interopRequireDefault(_List);

var _New = __webpack_require__(2254);

var _New2 = _interopRequireDefault(_New);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _TotalAmountModal = __webpack_require__(2255);

var _TotalAmountModal2 = _interopRequireDefault(_TotalAmountModal);

var _types = __webpack_require__(145);

var _centsFloat = __webpack_require__(175);

var _validations = __webpack_require__(271);

var _translation = __webpack_require__(64);

var _vietnam = __webpack_require__(40);

var _translation2 = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
/* eslint no-nested-ternary: 0 */


var BookingPayment = function (_Component) {
  _inherits(BookingPayment, _Component);

  function BookingPayment(props) {
    _classCallCheck(this, BookingPayment);

    var _this = _possibleConstructorReturn(this, (BookingPayment.__proto__ || Object.getPrototypeOf(BookingPayment)).call(this, props));

    _initialiseProps.call(_this);

    var state = BookingPayment.getPropsToState(props);
    _this.validation = {
      paymentAmount: (0, _react.createRef)()
    };
    _this.state = _extends({}, state, {
      openTotalAmount: false,
      hasChanged: false
    });
    return _this;
  }

  _createClass(BookingPayment, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = BookingPayment.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setNewPaymentBgColor',
    value: function setNewPaymentBgColor() {
      var paymentAmountMoreThanZero = this.state.paymentAmountMoreThanZero;

      return paymentAmountMoreThanZero ? '#E8F3FA' : '#E5E5E5';
    }
  }, {
    key: 'setNewPaymentButtonColor',
    value: function setNewPaymentButtonColor() {
      var paymentAmountMoreThanZero = this.state.paymentAmountMoreThanZero;

      return paymentAmountMoreThanZero ? 'blue' : 'grey';
    }
  }, {
    key: 'isShowCancelButton',
    value: function isShowCancelButton() {
      var _state = this.state,
          isEditBookingPayment = _state.isEditBookingPayment,
          paymentAmountMoreThanZero = _state.paymentAmountMoreThanZero;

      return isEditBookingPayment && paymentAmountMoreThanZero;
    }
  }, {
    key: 'handleSetState',
    value: function handleSetState() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.setState(state);
    }
  }, {
    key: 'hasPaymentActionAccess',
    value: function hasPaymentActionAccess(hasAccess, maUserID, statusID) {
      var auth = this.props.auth;
      if (!auth.companyBranch.isExternal) {
        return true;
      }
      if (hasAccess && auth.companyBranch.isExternal && statusID === 'reserved') {
        if (auth.isExternalAgentLeader) {
          return true;
        } else if (maUserID === auth.id) {
          return true;
        }
      }
      return false;
    }
    // CPI-974 (D5): Vietnam restricts cancelling a deposit to the SA / HQ family.

  }, {
    key: 'hasDepositCancelAccess',
    value: function hasDepositCancelAccess() {
      return (0, _vietnam.hasVietnamElevatedAccess)(this.props.auth);
    }
    // MS-6329: production's payment-proof deletion gate. Kept alongside the Vietnam gate above
    // so Malaysia behaves exactly as master does.

  }, {
    key: 'hasPaymentDeleteAccess',
    value: function hasPaymentDeleteAccess() {
      var auth = this.props.auth;

      return auth && (auth.isSuperAdmin || auth.isAdminBasic || auth.isHeadquarters || auth.isDeveloperSupervisor || auth.isDeveloperSalesManager || auth.isDeveloperSalesAdmin);
    }
  }, {
    key: 'renderPaymentSection',
    value: function renderPaymentSection() {
      var _this2 = this;

      var _state2 = this.state,
          data = _state2.data,
          oriData = _state2.oriData,
          hasPaymentMade = _state2.hasPaymentMade,
          isCancelTransaction = _state2.isCancelTransaction,
          isEditBookingFeePayment = _state2.isEditBookingFeePayment,
          paymentAmountMoreThanZero = _state2.paymentAmountMoreThanZero,
          paymentToBeCancel = _state2.paymentToBeCancel,
          projectCurrencies = _state2.projectCurrencies;
      var _props = this.props,
          auth = _props.auth,
          t = _props.t;

      var projectBankAccount = data.project.projectBankAccount || [];

      var newSection = _react2.default.createElement(_New2.default, {
        bookingData: this.state.data,
        projectBankAccount: projectBankAccount,
        onUpdated: this.handlePaymentUpdated,
        defaultObj: BookingPayment.defaultBookingPayment,
        checkChanges: this.props.checkChanges,
        resetChanges: this.handleResetInputChange,
        token: this.props.token
      });

      if (!hasPaymentMade) {
        return _react2.default.createElement(
          'span',
          null,
          isEditBookingFeePayment ? newSection : _react2.default.createElement(
            'div',
            {
              className: 'content-centered',
              style: { backgroundColor: this.setNewPaymentBgColor(), borderRadius: '10px' }
            },
            _react2.default.createElement(_semanticUiReact.Button, {
              className: 'booking-new-payment-button',
              size: 'large',
              color: this.setNewPaymentButtonColor(),
              disabled: !paymentAmountMoreThanZero || this.props.disabled || !this.hasPaymentActionAccess(oriData.project && oriData.project.allowAgentChangeBookingPaymentMethod, oriData.maUserID, oriData.statusID),
              onClick: function onClick() {
                _this2.handleSetState({ isEditBookingFeePayment: true });
              },
              content: (0, _vietnam.depositLabel)(auth, t, 'New Payment')
            })
          )
        );
      }
      if (isCancelTransaction) {
        return _react2.default.createElement(_Delete2.default, {
          checkChanges: this.props.checkChanges,
          data: paymentToBeCancel,
          onUpdated: this.handlePaymentUpdated,
          projectBankAccount: projectBankAccount,
          projectCurrencies: projectCurrencies,
          resetChanges: this.handleResetTransaction,
          token: this.props.token
        });
      }
      if (hasPaymentMade) {
        return _react2.default.createElement(
          'div',
          null,
          isEditBookingFeePayment ? newSection : _react2.default.createElement(
            'div',
            { style: { textAlign: 'center' } },
            _react2.default.createElement(_semanticUiReact.Button, {
              color: 'blue',
              onClick: function onClick() {
                _this2.handleSetState({ isEditBookingFeePayment: true });
              },
              content: (0, _vietnam.depositLabel)(auth, t, 'Add Payment'),
              disabled: !this.hasPaymentActionAccess(oriData.project && oriData.project.allowAgentChangeBookingPaymentMethod, oriData.maUserID, oriData.statusID)
            }),
            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
            _react2.default.createElement(_List2.default, {
              auth: auth,
              data: data,
              hideCancel: (0, _vietnam.isVietnamCompany)(auth) ? !this.hasDepositCancelAccess() : !this.hasPaymentDeleteAccess() || !this.hasPaymentActionAccess(oriData.project && oriData.project.allowAgentCancelBookingFee, oriData.maUserID, oriData.statusID),
              onUpdated: this.handlePaymentUpdated,
              onCancelTransaction: this.onCancelTransaction,
              projectBankAccount: projectBankAccount,
              token: this.props.token
            })
          )
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state3 = this.state,
          data = _state3.data,
          isEditBookingPayment = _state3.isEditBookingPayment,
          oriData = _state3.oriData,
          projectCurrencies = _state3.projectCurrencies,
          hasChanged = _state3.hasChanged;
      var _props2 = this.props,
          auth = _props2.auth,
          _props2$defaultBookin = _props2.defaultBookingFeeAmount,
          defaultBookingFeeAmount = _props2$defaultBookin === undefined ? 0 : _props2$defaultBookin,
          t = _props2.t;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Header,
          { className: 'new_title', as: 'h5', attached: 'top', textAlign: 'center' },
          t('Payment').toUpperCase()
        ),
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { attached: true },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { mobile: 16, tablet: 8, computer: 8 },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  null,
                  isEditBookingPayment ? _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'left', width: 11 },
                    (0, _vietnam.isVietnamCompany)(auth) ? _react2.default.createElement(
                      _reactI18next.Trans,
                      { ns: _translation2.TRANSLATION_FILES.screens, components: { b: _react2.default.createElement('strong', null) } },
                      'Key in ',
                      _react2.default.createElement(
                        'b',
                        null,
                        'total amount'
                      ),
                      ' of deposit required'
                    ) : _react2.default.createElement(
                      _reactI18next.Trans,
                      { ns: _translation2.TRANSLATION_FILES.screens, components: { b: _react2.default.createElement('strong', null) } },
                      'Key in ',
                      _react2.default.createElement(
                        'b',
                        null,
                        'total amount'
                      ),
                      ' of booking fee deposit required'
                    ),
                    '.\xA0',
                    _react2.default.createElement(
                      _semanticUiReact.Button,
                      { onClick: this.showTotalAmount, style: { opacity: 1, color: 'black' }, className: 'flash-button' },
                      _react2.default.createElement(_semanticUiReact.Icon, {
                        name: 'info circle'
                      })
                    )
                  ) : null,
                  isEditBookingPayment ? _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'right', width: 5 },
                    oriData.paymentStatus ? _react2.default.createElement(
                      _semanticUiReact.Label,
                      {
                        circular: true,
                        color: this.setPaymentStatusColor(oriData.paymentStatus),
                        horizontal: true
                      },
                      (0, _vietnam.vnDepositStatusLabel)(auth, t, oriData.paymentStatus.id) || t(oriData.paymentStatus.name, { ns: _translation2.TRANSLATION_FILES.constants })
                    ) : null
                  ) : null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'right' },
                    isEditBookingPayment || this.props.disabled || !this.hasPaymentActionAccess(oriData.project && oriData.project.allowAgentEditBookingFee, oriData.maUserID, oriData.statusID) ? null : _react2.default.createElement(_semanticUiReact.Label, {
                      as: 'button',
                      attached: 'top right',
                      size: 'small',
                      content: t('Edit', { ns: _translation2.TRANSLATION_FILES.translation }),
                      icon: 'edit',
                      onClick: function onClick() {
                        _this3.handleSetState({ isEditBookingPayment: true });
                      },
                      className: 'editable-button'
                    })
                  )
                ),
                isEditBookingPayment ? null : _react2.default.createElement(
                  _semanticUiReact.Grid,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'right' },
                    oriData.paymentStatus ? _react2.default.createElement(
                      _semanticUiReact.Label,
                      {
                        circular: true,
                        color: this.setPaymentStatusColor(oriData.paymentStatus),
                        horizontal: true
                      },
                      (0, _vietnam.vnDepositStatusLabel)(auth, t, oriData.paymentStatus.id) || t(oriData.paymentStatus.name, { ns: _translation2.TRANSLATION_FILES.constants })
                    ) : null
                  )
                ),
                _react2.default.createElement(_TotalAmountModal2.default, {
                  open: this.state.openTotalAmount,
                  onClose: this.handleOnClose
                }),
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'left', width: 8 },
                    _react2.default.createElement(
                      'b',
                      null,
                      (0, _vietnam.depositLabel)(auth, t, isEditBookingPayment ? 'Booking Fee Amount' : 'Booking Fee')
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'right', width: 8 },
                    isEditBookingPayment ? _react2.default.createElement(
                      _AppForm2.default,
                      {
                        onSubmit: this.handleSaveBookingPayment
                      },
                      _react2.default.createElement(_AppForm2.default.Input, {
                        disabled: this.props.disabled,
                        hideMessage: true,
                        validateLabel: t('Amount'),
                        placeholder: defaultBookingFeeAmount.toString(),
                        name: 'paymentAmount',
                        value: data.paymentAmount === 0 || '' ? hasChanged ? data.paymentAmount : defaultBookingFeeAmount : data.paymentAmount,
                        onChange: this.handleInputChange,
                        ref: this.validation.paymentAmount,
                        validation: oriData.paymentPaidCents !== 0 ? [_webValidations.required, {
                          validate: _webValidations.numericRange,
                          option: {
                            min: 1
                          }
                        }] : [{
                          validate: _webValidations.numericRange,
                          option: {
                            min: 0
                          }
                        }],
                        type: 'number'
                      })
                    ) : oriData.paymentAmount ? _react2.default.createElement(_LoanAmount2.default, {
                      projectCurrencies: projectCurrencies,
                      format: '0,000,000.00',
                      amount: oriData.paymentAmount,
                      prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                    }) : '-'
                  )
                ),
                isEditBookingPayment ? null : _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'left', width: 8 },
                    _react2.default.createElement(
                      'b',
                      null,
                      t('Payments Made')
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'right', width: 8 },
                    _react2.default.createElement(_LoanAmount2.default, {
                      projectCurrencies: projectCurrencies,
                      format: '0,000,000.00',
                      amount: (0, _centsFloat.centsToFloat)(oriData.paymentPaidCents),
                      prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                    })
                  )
                ),
                isEditBookingPayment ? null : _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'left', width: 8 },
                    _react2.default.createElement(
                      'b',
                      null,
                      t('Outstanding')
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'right', width: 8 },
                    oriData.paymentAmount ? _react2.default.createElement(_LoanAmount2.default, {
                      projectCurrencies: projectCurrencies,
                      format: '0,000,000.00',
                      amount: oriData.paymentAmount - (0, _centsFloat.centsToFloat)(oriData.paymentPaidCents),
                      prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                    }) : '-'
                  )
                ),
                isEditBookingPayment ? null : _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'left', width: 8 },
                    _react2.default.createElement(
                      'b',
                      null,
                      (0, _translation.translateModels)(t, 'bookingFeeDeductiblePaymentPlan', 'booking')
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'right', width: 8 },
                    t(oriData.bookingFeeDeductiblePaymentPlan ? 'Yes' : 'No', { ns: _translation2.TRANSLATION_FILES.constants })
                  )
                ),
                isEditBookingPayment ? _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'left', width: 8 },
                    _react2.default.createElement(
                      'b',
                      null,
                      t('Notes')
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'right', width: 8 },
                    _react2.default.createElement(_semanticUiReact.Form.Input, {
                      fluid: true,
                      name: 'paymentNotes',
                      onChange: this.handleInputChange,
                      placeholder: t('Notes'),
                      value: data.paymentNotes,
                      disabled: this.props.disabled
                    })
                  )
                ) : _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { verticalAlign: 'middle' },
                  _react2.default.createElement('hr', { style: { width: '90%', textAlign: 'right', margin: '0 auto' } }),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { style: { paddingTop: '1px' }, textAlign: 'left', width: 16 },
                    _react2.default.createElement(
                      'span',
                      { style: { color: '#808080' } },
                      oriData.paymentNotes || '-'
                    )
                  )
                ),
                isEditBookingPayment ? _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { verticalAlign: 'middle' },
                  _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    name: 'bookingFeeDeductiblePaymentPlan',
                    label: (0, _translation.translateModels)(t, 'bookingFeeDeductiblePaymentPlan', 'booking'),
                    onChange: this.handleCheckBoxChange,
                    checked: data.bookingFeeDeductiblePaymentPlan,
                    disabled: this.props.disabled
                  })
                ) : null,
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { verticalAlign: 'middle' },
                  _react2.default.createElement(_semanticUiReact.Grid.Column, { textAlign: 'left', only: 'tablet computer', tablet: 6, computer: 8 }),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'right', mobile: 16, tablet: 5, computer: 4 },
                    this.isShowCancelButton() ? _react2.default.createElement(_semanticUiReact.Button, {
                      fluid: true,
                      onClick: function onClick() {
                        _this3.handleResetInputChange('BookingPayment');
                      },
                      basic: true,
                      content: t('Cancel', { ns: _translation2.TRANSLATION_FILES.translation })
                    }) : null
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'right', mobile: 16, tablet: 5, computer: 4 },
                    isEditBookingPayment && !this.props.disabled ? _react2.default.createElement(_semanticUiReact.Button, {
                      className: 'payment-save',
                      fluid: true,
                      onClick: this.handleSaveBookingPayment,
                      color: 'blue',
                      content: t('Save', { ns: _translation2.TRANSLATION_FILES.translation })
                    }) : null
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { mobile: 16, tablet: 8, computer: 8 },
                this.renderPaymentSection()
              )
            )
          )
        )
      );
    }
  }]);

  return BookingPayment;
}(_react.Component);

BookingPayment.propTypes = {
  auth: _types.StateAuth,
  checkChanges: _propTypes2.default.func,
  disabled: _propTypes2.default.bool,
  defaultBookingFeeAmount: _propTypes2.default.number,
  fetchNewBooking: _propTypes2.default.func,
  resetChanges: _propTypes2.default.func,
  token: _propTypes2.default.string,
  updateBookingPayment: _propTypes2.default.func,
  t: _propTypes2.default.func
};
BookingPayment.contextTypes = {
  store: _propTypes2.default.object
};

BookingPayment.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

BookingPayment.defaultBookingPayment = {
  bookingID: '',
  paymentTypeID: '',
  paymentType: {
    name: ''
  },
  paymentStatusID: '',
  paymentAmount: '',
  paymentPictures: [],
  paymentAt: '',
  paymentReference: '',
  paymentNotes: '',
  bookingFeeDeductiblePaymentPlan: false,
  project: {
    projectCurrency: null
  }
};

BookingPayment.getPropsToState = function (props) {
  var data = Object.assign({}, BookingPayment.defaultBookingPayment, props.data);
  var projectCurrencies = data.project.projectCurrency;
  var isEditBookingPayment = parseFloat(props.data.paymentAmount || 0) <= 0;
  var hasPaymentMade = props.data.bookingFeePayments && props.data.bookingFeePayments.length > 0;
  return {
    data: data,
    hasPaymentMade: hasPaymentMade,
    isCancelTransaction: false,
    isEditBookingFeePayment: false,
    isEditBookingPayment: isEditBookingPayment,
    paymentAmountMoreThanZero: parseFloat(props.data.paymentAmount) > 0,
    paymentToBeCancel: {},
    oriData: Object.assign({}, props.data),
    projectCurrencies: projectCurrencies
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onCancelTransaction = function (paymentId) {
    var data = _this4.state.data;

    var paymentToBeCancel = data.bookingFeePayments.find(function (e) {
      return e.id === paymentId;
    });
    if (paymentToBeCancel) {
      _this4.setState({
        isCancelTransaction: true,
        paymentToBeCancel: paymentToBeCancel
      });
    }
  };

  this.setPaymentStatusColor = function (paymentStatus) {
    if (paymentStatus.id === 'paid') return 'green';
    return 'grey';
  };

  this.handlePaymentUpdated = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!_this4.props.fetchNewBooking) {
              _context.next = 3;
              break;
            }

            _context.next = 3;
            return _this4.props.fetchNewBooking();

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this4);
  }));

  this.handleInputChange = function (event, _ref2) {
    var name = _ref2.name,
        value = _ref2.value;

    event.preventDefault();
    if (_this4.props.checkChanges) _this4.props.checkChanges('isBookingPaymentChanged');
    var data = _this4.state.data;

    data[name] = value;
    if (value > 0 || value === '') {
      _this4.setState({ hasChanged: true });
    }
    _this4.setState({ data: data });
  };

  this.handleCheckBoxChange = function (event, _ref3) {
    var name = _ref3.name;

    event.preventDefault();
    if (_this4.props.checkChanges) _this4.props.checkChanges('isBookingPaymentChanged');
    var data = _this4.state.data;

    data[name] = !data[name];
    _this4.setState({ hasChanged: true, data: data });
  };

  this.handleResetInputChange = function () {
    var _stateToUpdate;

    var sectionName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'BookingPayment';
    var oriData = _this4.state.oriData;

    var stateToUpdate = (_stateToUpdate = {}, _defineProperty(_stateToUpdate, 'isEdit' + sectionName, false), _defineProperty(_stateToUpdate, 'data', oriData), _stateToUpdate);
    _this4.setState(stateToUpdate, function () {
      if (_this4.props.resetChanges) _this4.props.resetChanges('is' + sectionName + 'Changed');
    });
  };

  this.handleResetTransaction = function () {
    _this4.setState({
      isCancelTransaction: false,
      paymentToBeCancel: {}
    });
    _this4.handleResetInputChange('BookingFeePayment');
  };

  this.handleSaveBookingPayment = function (e) {
    e.preventDefault();
    var store = _this4.context.store;
    var _state$data = _this4.state.data,
        paymentAmount = _state$data.paymentAmount,
        paymentNotes = _state$data.paymentNotes,
        bookingFeeDeductiblePaymentPlan = _state$data.bookingFeeDeductiblePaymentPlan;

    return _AppForm2.default.validate(_this4.validation, _this4.state.data).then(function (validations) {
      if ((0, _validations.validateForm)(store, validations)) return;
      _this4.props.updateBookingPayment({
        paymentAmount: parseFloat(paymentAmount),
        paymentNotes: paymentNotes,
        bookingFeeDeductiblePaymentPlan: bookingFeeDeductiblePaymentPlan
      });
      if (_this4.props.resetChanges) _this4.props.resetChanges('isBookingPaymentChanged');
      _this4.setState({ isEditBookingPayment: false });
    });
  };

  this.handleOnClose = function () {
    _this4.setState({ openTotalAmount: false });
  };

  this.showTotalAmount = function (e) {
    e.preventDefault();
    _this4.setState({ openTotalAmount: true });
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation2.namespaces), [_translation2.TRANSLATION_FILES.models.booking]))((0, _reactRedux.connect)(BookingPayment.mapStateToProps)(BookingPayment));

/***/ }),
/* 2251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _reactI18next = __webpack_require__(3);

var _Item = __webpack_require__(1050);

var _Item2 = _interopRequireDefault(_Item);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _centsFloat = __webpack_require__(175);

var _inputChanges = __webpack_require__(1091);

var _validations = __webpack_require__(271);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Delete = function (_Component) {
  _inherits(Delete, _Component);

  function Delete(props) {
    _classCallCheck(this, Delete);

    var _this = _possibleConstructorReturn(this, (Delete.__proto__ || Object.getPrototypeOf(Delete)).call(this, props));

    _initialiseProps.call(_this);

    var state = Delete.getPropsToState(props);
    _this.validation = {
      cancelledReason: (0, _react.createRef)()
    };
    _this.state = _extends({
      genericErrMsg: props.t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }),
      loading: false
    }, state);
    return _this;
  }

  _createClass(Delete, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Delete.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'handleError',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(store, msg, errorObj) {
        var isBugsnag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(false);

              case 2:
                _context.next = 4;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: msg }));

              case 4:
                if (isBugsnag) Bugsnag.notifyException(errorObj);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleError(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return handleError;
    }()
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'renderCancelTransactionItemFooter',
    value: function renderCancelTransactionItemFooter() {
      var _this3 = this;

      var _state = this.state,
          data = _state.data,
          projectCurrencies = _state.projectCurrencies;
      var t = this.props.t;

      return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _AppForm2.default,
          {
            onSubmit: this.handleConfirmCancelTransaction,
            ref: function ref(_ref2) {
              _this3.form = _ref2;
            }
          },
          _react2.default.createElement(
            _semanticUiReact.Divider,
            { horizontal: true },
            _react2.default.createElement(
              _semanticUiReact.Header,
              { as: 'h4', style: { marginBottom: '0', color: '#CE0000' } },
              t('Cancel Payment')
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Header,
            { as: 'h5', style: { marginTop: '0', color: '#CE0000' } },
            t('Cancel and deduct payment of'),
            ' ',
            _react2.default.createElement(_LoanAmount2.default, {
              projectCurrencies: projectCurrencies,
              format: '0,000,000.00',
              amount: (0, _centsFloat.centsToFloat)(data.amountCents),
              prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
            }),
            ' ?'
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle', style: { marginTop: '-1rem' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 2 },
              _react2.default.createElement(
                'b',
                null,
                t('Reason')
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 14 },
              _react2.default.createElement(_AppForm2.default.Input, {
                type: 'text',
                hideMessage: true,
                name: 'cancelledReason',
                validateLabel: t('Reason'),
                value: data.cancelledReason,
                onChange: this.handleInputChange,
                ref: this.validation.cancelledReason,
                validation: [_webValidations.required],
                placeholder: t('Reason')
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle', style: { marginTop: '-1rem' } },
            _react2.default.createElement(_semanticUiReact.Grid.Column, { textAlign: 'left', width: 2 }),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 7 },
              _react2.default.createElement(_semanticUiReact.Button, {
                onClick: function onClick(e) {
                  e.preventDefault();
                  _this3.handleResetInputChange('BookingFeePayment');
                },
                fluid: true,
                basic: true,
                content: t('No', { ns: _translation.TRANSLATION_FILES.constants })
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 7 },
              _react2.default.createElement(_semanticUiReact.Button, {
                fluid: true,
                color: 'blue',
                onClick: this.handleConfirmCancelTransaction,
                content: t('Yes', { ns: _translation.TRANSLATION_FILES.constants })
              })
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          data = _state2.data,
          projectBankAccount = _state2.projectBankAccount,
          projectCurrencies = _state2.projectCurrencies;
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { centered: true },
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
          this.state.loading && _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(_Item2.default, {
          backgroundColor: '#FFE5E5',
          data: data,
          footer: this.renderCancelTransactionItemFooter(),
          projectBankAccount: projectBankAccount,
          projectCurrencies: projectCurrencies,
          hideHeader: true
        })
      );
    }
  }]);

  return Delete;
}(_react.Component);

Delete.propTypes = {
  checkChanges: _propTypes2.default.func,
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  onUpdated: _propTypes2.default.func,
  projectBankAccount: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  projectCurrencies: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  resetChanges: _propTypes2.default.func,
  token: _propTypes2.default.string
};
Delete.contextTypes = {
  router: _propTypes2.default.object,
  store: _propTypes2.default.object
};

Delete.getPropsToState = function (props) {
  var data = props.data;
  var projectBankAccount = props.projectBankAccount;
  var projectCurrencies = props.projectCurrencies;
  return {
    data: data,
    projectBankAccount: projectBankAccount,
    projectCurrencies: projectCurrencies
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleConfirmCancelTransaction = function (event) {
    event.preventDefault();
    var _context2 = _this4.context,
        store = _context2.store,
        router = _context2.router;
    var _state3 = _this4.state,
        data = _state3.data,
        genericErrMsg = _state3.genericErrMsg;
    var t = _this4.props.t;

    return _AppForm2.default.validate(_this4.validation, data).then(function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(validations) {
        var response;
        return regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!(0, _validations.validateForm)(store, validations)) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt('return');

              case 2:
                _context3.prev = 2;
                _context3.next = 5;
                return _this4.setLoading(true);

              case 5:
                _context3.next = 7;
                return (0, _fetchM.serverRequestDelete)('/bookings/' + router.params.id + '/booking_fee_payments/' + data.id + '/', store, _this4.props.token, { cancelledReason: data.cancelledReason });

              case 7:
                response = _context3.sent;
                _context3.next = 10;
                return _this4.setLoading(false);

              case 10:
                _this4.handleResetInputChange();

                if (!response.error) {
                  _context3.next = 14;
                  break;
                }

                _this4.handleError(store, response.message);
                return _context3.abrupt('return');

              case 14:
                if (!_this4.props.onUpdated) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 17;
                return _this4.props.onUpdated();

              case 17:
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Cancel Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Payment successfully cancelled', { ns: _translation.TRANSLATION_FILES.translation })
                }));
                _context3.next = 24;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t0 = _context3['catch'](2);

                _this4.handleResetInputChange();
                _this4.handleError(store, genericErrMsg, _context3.t0, true);

              case 24:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee2, _this4, [[2, 20]]);
      }));

      return function (_x6) {
        return _ref3.apply(this, arguments);
      };
    }());
  };

  this.handleInputChange = function (event, _ref4) {
    var name = _ref4.name,
        value = _ref4.value;

    if (_this4.props.checkChanges) _this4.props.checkChanges('isBookingFeePaymentChanged');
    var data = _this4.state.data;

    data[name] = value;
    _this4.setState({ data: data });
  };

  this.handleResetInputChange = function () {
    var sectionName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'BookingFeePayment';
    var oriData = _this4.state.oriData;

    var data = (0, _inputChanges.resetDataChanges)(oriData, { cancelledReason: '' });
    _this4.setState({ data: data }, function () {
      if (_this4.props.resetChanges) _this4.props.resetChanges(sectionName);
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(Delete);

/***/ }),
/* 2252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _webValidations = __webpack_require__(23);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _flash = __webpack_require__(5);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _SelectBank = __webpack_require__(218);

var _SelectBank2 = _interopRequireDefault(_SelectBank);

var _UploadModal = __webpack_require__(92);

var _UploadModal2 = _interopRequireDefault(_UploadModal);

var _paymentTypes = __webpack_require__(322);

var _paymentTypes2 = _interopRequireDefault(_paymentTypes);

var _translation = __webpack_require__(4);

var _virtualAccount = __webpack_require__(393);

var _Form = __webpack_require__(267);

var _Form2 = _interopRequireDefault(_Form);

var _PaymentRequest = __webpack_require__(2527);

var _PaymentRequest2 = _interopRequireDefault(_PaymentRequest);

var _NotifyAddPurchaserEmail = __webpack_require__(2525);

var _NotifyAddPurchaserEmail2 = _interopRequireDefault(_NotifyAddPurchaserEmail);

var _booking = __webpack_require__(129);

var _booking2 = _interopRequireDefault(_booking);

var _inputChanges = __webpack_require__(1091);

var _validations = __webpack_require__(271);

var _centsFloat = __webpack_require__(175);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isPRS = _config2.default.get('prs');

var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form(props) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

    _initialiseProps.call(_this);

    _this.validation = {
      transferredToBankID: (0, _react.createRef)(),
      transferredFromBank: (0, _react.createRef)(),
      transferredFromAccountNumber: (0, _react.createRef)(),
      creditCardLastFourDigits: (0, _react.createRef)(),
      paymentMethodTypeID: (0, _react.createRef)(),
      amountCents: (0, _react.createRef)(),
      reference: (0, _react.createRef)(),
      transferredToVAAccountNumber: (0, _react.createRef)()
    };
    var state = _this.getPropsToState(props);
    _this.state = _extends({
      loading: false,
      picturesUploaded: {},
      picturesUploadedCount: 0,
      openPaymentRequestModal: false,
      openNotifyAddPurchaserEmailModal: false
    }, state);
    return _this;
  }

  _createClass(Form, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = this.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'paymentTypes',
    value: function paymentTypes() {
      var bookingData = this.state.bookingData;
      var t = this.props.t;

      var paymentTypes = [];
      var hasOnlinePayment = this.props.appConfig.data.onlinePaymentEnabled;
      var hasVirtualAccountPayment = this.props.appConfig.data.settings.virtualAccountIsEnabled;
      var isMPBooking = bookingData && bookingData.origin.includes('marketplace');
      _paymentTypes2.default.forEach(function (item) {
        var newItem = Object.assign({}, item);
        bookingData.project.paymentTypeOptions.forEach(function (value) {
          if (value === item.value) {
            if (newItem.value === 'online_payment') {
              newItem.disabled = !hasOnlinePayment || isMPBooking;
            }
            paymentTypes.push(newItem);
          }
        });
        if (newItem.value === 'virtual_account' && hasVirtualAccountPayment) {
          paymentTypes.push(newItem);
        }
      });
      return paymentTypes.map(function (pt) {
        return _extends({}, pt, {
          text: t(pt.text, { ns: _translation.TRANSLATION_FILES.constants })
        });
      });
    }
  }, {
    key: 'uploadPictures',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e, body) {
        var store, t;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                store = this.context.store;
                t = this.props.t;

                this.setState({
                  picturesUploaded: body,
                  picturesUploadedCount: body.get('total_attached')
                });
                this.uploadModal.close();
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Attached', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Picture(s) attached', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function uploadPictures(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return uploadPictures;
    }()
  }, {
    key: 'renderConditionalFieldsBasedOnPaymentMethod',
    value: function renderConditionalFieldsBasedOnPaymentMethod() {
      var _state = this.state,
          data = _state.data,
          isMobile = _state.isMobile,
          isTablet = _state.isTablet,
          _state$projectBankAcc = _state.projectBankAccount,
          projectBankAccount = _state$projectBankAcc === undefined ? [] : _state$projectBankAcc;
      var _props = this.props,
          auth = _props.auth,
          t = _props.t;

      var toRender = null;
      switch (data.paymentMethodTypeID) {
        case 'bank_transfer':
        case 'virtual_account':
          toRender = _react2.default.createElement(
            'span',
            null,
            data.paymentMethodTypeID === 'bank_transfer' && projectBankAccount.length > 0 ? _react2.default.createElement(
              _semanticUiReact.Grid,
              { verticalAlign: 'middle' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', width: 4 },
                _react2.default.createElement(
                  'b',
                  null,
                  t('Transferred to')
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', width: 12 },
                _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    hideMessage: true,
                    validateLabel: t('Transferred to'),
                    ref: this.validation.transferredToBankID,
                    onChange: this.handleInputChange
                  },
                  _react2.default.createElement(_semanticUiReact.Form.Select, {
                    fluid: true,
                    label: '',
                    name: 'transferredToBankID',
                    options: projectBankAccount,
                    placeholder: t('Select {{title}}', { title: t('Account') }),
                    selectOnBlur: false,
                    value: data.transferredToBankID
                  })
                )
              )
            ) : null,
            data.paymentMethodTypeID === 'virtual_account' && _react2.default.createElement(
              _semanticUiReact.Grid,
              { verticalAlign: 'middle' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', width: 4 },
                _react2.default.createElement(
                  'b',
                  null,
                  t('Transferred to')
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', width: 12 },
                _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    hideMessage: true,
                    validateLabel: t('Transferred to'),
                    validation: [_webValidations.required],
                    ref: this.validation.transferredToVAAccountNumber,
                    onChange: this.handleInputChange
                  },
                  _react2.default.createElement(_semanticUiReact.Form.Select, {
                    fluid: true,
                    label: '',
                    name: 'transferredToVAAccountNumber',
                    options: this.transformUnitVAData(),
                    placeholder: t('Select {{title}}', { title: t('Account') }),
                    selectOnBlur: false,
                    value: data.transferredToVAAccountNumber
                  })
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { verticalAlign: 'middle' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', width: 4 },
                _react2.default.createElement(
                  'b',
                  null,
                  t('Transferred from')
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', width: 12 },
                _react2.default.createElement(_SelectBank2.default, {
                  country: auth && auth.company ? auth.company.countryCode : '',
                  fullWidth: isMobile || isTablet,
                  validateLabel: t('Transferred from'),
                  ref: this.validation.transferredFromBank,
                  onChange: this.handleInputChange,
                  name: 'transferredFromBank',
                  placeholder: t('Select {{title}}', { title: t('Bank') }),
                  value: data.transferredFromBank
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { verticalAlign: 'middle' },
              _react2.default.createElement(_semanticUiReact.Grid.Column, { textAlign: 'left', width: 4 }),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', width: 12 },
                _react2.default.createElement(_AppForm2.default.Input, {
                  type: 'text',
                  hideMessage: true,
                  name: 'transferredFromAccountNumber',
                  validateLabel: t('Account number'),
                  value: data.transferredFromAccountNumber,
                  onChange: this.handleInputChange,
                  ref: this.validation.transferredFromAccountNumber,
                  placeholder: t('Account number')
                })
              )
            )
          );
          break;
        case 'cheque':
          toRender = projectBankAccount.length > 0 ? _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 4 },
              _react2.default.createElement(
                'b',
                null,
                t('Transferred to')
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 12 },
              _react2.default.createElement(
                _AppForm2.default.Validate,
                {
                  hideMessage: true,
                  validateLabel: t('Transferred to'),
                  ref: this.validation.transferredToBankID,
                  onChange: this.handleInputChange
                },
                _react2.default.createElement(_semanticUiReact.Form.Select, {
                  fluid: true,
                  label: '',
                  name: 'transferredToBankID',
                  options: projectBankAccount,
                  placeholder: t('Select {{title}}', { title: t('Account') }),
                  selectOnBlur: false,
                  value: data.transferredToBankID
                })
              )
            )
          ) : null;
          break;
        case 'credit_card':
          toRender = _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 4 },
              _react2.default.createElement(
                'b',
                null,
                t('Card Number')
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 8 },
              _react2.default.createElement(
                _semanticUiReact.Header,
                { as: 'h3' },
                'XXXX XXXX XXXX'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 4 },
              _react2.default.createElement(_AppForm2.default.Input, {
                type: 'number',
                hideMessage: true,
                name: 'creditCardLastFourDigits',
                validateLabel: t('Last four digits of credit card'),
                value: data.creditCardLastFourDigits,
                onChange: this.handleInputChange,
                ref: this.validation.creditCardLastFourDigits
              })
            )
          );
          break;
        default:
          break;
      }
      return toRender;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state2 = this.state,
          bookingData = _state2.bookingData,
          data = _state2.data;
      var t = this.props.t;

      var project = bookingData.project;
      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { mobile: 15, tablet: 15, computer: 15, className: 'payment-card' },
          _react2.default.createElement(
            _AppForm2.default,
            {
              onSubmit: this.handleSave
            },
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { verticalAlign: 'middle' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', width: 4 },
                _react2.default.createElement(
                  'b',
                  null,
                  t('Payment Method')
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', width: 7 },
                _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    hideMessage: true,
                    validation: [_webValidations.required],
                    validateLabel: t('Payment Method'),
                    ref: this.validation.paymentMethodTypeID,
                    onChange: this.handleInputChange
                  },
                  _react2.default.createElement(_semanticUiReact.Form.Select, {
                    fluid: true,
                    label: '',
                    name: 'paymentMethodTypeID',
                    options: this.paymentTypes(),
                    placeholder: t('Payment Method'),
                    selectOnBlur: false,
                    value: data.paymentMethodTypeID,
                    disabled: isPRS
                  })
                )
              ),
              data.paymentMethodTypeID !== 'online_payment' && _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', width: 5 },
                _react2.default.createElement(_UploadModal2.default, {
                  trigger: _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                      'a',
                      null,
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'upload' }),
                      t('Attachment'),
                      ' '
                    ),
                    this.state.picturesUploadedCount > 0 ? _react2.default.createElement(
                      _semanticUiReact.Label,
                      { color: 'blue', circular: true, size: 'tiny' },
                      this.state.picturesUploadedCount
                    ) : null
                  ),
                  ref: function ref(_ref2) {
                    _this2.uploadModal = _ref2;
                  },
                  header: 'pictures',
                  loading: this.state.loading,
                  onConfirm: function onConfirm(e, file) {
                    _this2.uploadPictures(e, file);
                  },
                  onClose: this.handleUploadModalClose,
                  primary: false,
                  content: function content(opt) {
                    return _react2.default.createElement(_Form2.default, {
                      fileType: 'attachment',
                      loading: _this2.state.loading,
                      onSubmit: opt.onConfirm
                    });
                  }
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { verticalAlign: 'middle' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', width: 4 },
                _react2.default.createElement(
                  'b',
                  null,
                  t('Amount')
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', width: 12 },
                _react2.default.createElement(_AppForm2.default.Input, {
                  showThousandSeparator: true,
                  hideMessage: true,
                  name: 'amountCents',
                  validateLabel: t('Amount'),
                  value: data.amountCents,
                  onChange: this.handleInputChange,
                  ref: this.validation.amountCents,
                  validation: [_webValidations.required, {
                    validate: _webValidations.numericRange,
                    option: {
                      min: 0.1
                    }
                  }]
                })
              )
            ),
            this.renderConditionalFieldsBasedOnPaymentMethod(),
            data.paymentMethodTypeID !== 'online_payment' ? _react2.default.createElement(
              _semanticUiReact.Grid,
              { verticalAlign: 'middle' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', width: 4 },
                _react2.default.createElement(
                  'b',
                  null,
                  t('Reference')
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', width: 12 },
                _react2.default.createElement(_AppForm2.default.Input, {
                  hideMessage: true,
                  name: 'reference',
                  value: data.reference,
                  onChange: this.handleInputChange,
                  ref: this.validation.reference,
                  validation: project && project.paymentFieldsRequired ? [_webValidations.required] : null,
                  validateLabel: t('Reference')
                })
              )
            ) : null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { verticalAlign: 'middle' },
              data.paymentMethodTypeID !== 'online_payment' ? _react2.default.createElement(_semanticUiReact.Grid.Column, { textAlign: 'left', only: 'tablet computer', tablet: 6, computer: 7 }) : _react2.default.createElement(_semanticUiReact.Grid.Column, { textAlign: 'left', only: 'computer', computer: 4 }),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', mobile: 16, tablet: 5, computer: 5 },
                _react2.default.createElement(_semanticUiReact.Button, {
                  onClick: function onClick(e) {
                    e.preventDefault();
                    _this2.handleResetInputChange('BookingFeePayment');
                  },
                  fluid: true,
                  basic: true,
                  content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation })
                })
              ),
              data.paymentMethodTypeID !== 'online_payment' ? _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', mobile: 16, tablet: 5, computer: 4 },
                _react2.default.createElement(_semanticUiReact.Button, {
                  fluid: true,
                  color: 'blue',
                  onClick: this.handleSave,
                  content: t('Save', { ns: _translation.TRANSLATION_FILES.translation })
                })
              ) : _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', mobile: 16, tablet: 11, computer: 7 },
                _react2.default.createElement(_semanticUiReact.Button, {
                  fluid: true,
                  color: 'blue',
                  onClick: this.handleSendRequestPayment,
                  content: t('Send Request Payment')
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(_PaymentRequest2.default, {
                  open: this.state.openPaymentRequestModal,
                  onClose: function onClose(e) {
                    return _this2.handleCloseModal(e);
                  },
                  onConfirm: function onConfirm(e) {
                    return _this2.handleSave(e);
                  }
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(_NotifyAddPurchaserEmail2.default, {
                  open: this.state.openNotifyAddPurchaserEmailModal,
                  onClose: function onClose(e) {
                    return _this2.handleCloseModal(e);
                  },
                  onAddEmail: function onAddEmail(e) {
                    return _this2.handleOnAddEmail(e);
                  },
                  isMobile: this.state.isMobile
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Form;
}(_react.Component);

Form.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      onlinePaymentEnabled: _propTypes2.default.bool,
      settings: _propTypes2.default.shape({
        virtualAccountIsEnabled: _propTypes2.default.bool
      })
    })
  }),
  checkChanges: _propTypes2.default.func,
  bookingData: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  onCreate: _propTypes2.default.func,
  projectBankAccount: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  resetChanges: _propTypes2.default.func
};
Form.contextTypes = {
  store: _propTypes2.default.object
};
Form.defaultBookingFeePayment = {
  bookingID: '',
  creditCardLastFourDigits: '',
  paymentMethodTypeID: isPRS ? 'cheque' : '',
  paymentMethodType: {
    name: ''
  },
  cancelledReason: '',
  amountCents: '',
  paymentPictures: [],
  reference: '',
  status: '',
  transferredToBankID: '',
  transferredFromBank: '',
  transferredFromAccountNumber: '',
  transferredToVABank: '',
  transferredToVAAccountNumber: ''
};

Form.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig,
    auth: state.auth
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getPropsToState = function (props) {
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    var isTablet = windowWidth >= 768 && windowWidth < 992;
    var data = Object.assign({}, Form.defaultBookingFeePayment, props.data);
    var bookingData = Object.assign({}, _booking2.default, props.bookingData);
    var projectBankAccount = _this3.transformProjectBankAccountData(props.projectBankAccount);
    var vaBankName = '';
    var vaAccountNumber = '';
    if (bookingData && bookingData.projectUnit && bookingData.projectUnit.projectUnitCustomFields && bookingData.projectUnit.projectUnitCustomFields.length > 0) {
      var pucfs = bookingData.projectUnit.projectUnitCustomFields;
      vaBankName = pucfs.some(function (pucf) {
        return pucf.projectUnitCustomFieldSettingID === _virtualAccount.VA_BANK_NAME;
      }) ? pucfs.find(function (pucf) {
        return pucf.projectUnitCustomFieldSettingID === _virtualAccount.VA_BANK_NAME;
      }).value : '';
      vaAccountNumber = pucfs.some(function (pucf) {
        return pucf.projectUnitCustomFieldSettingID === _virtualAccount.VA_ACCOUNT_NUMBER;
      }) ? pucfs.find(function (pucf) {
        return pucf.projectUnitCustomFieldSettingID === _virtualAccount.VA_ACCOUNT_NUMBER;
      }).value : '';
    }
    return {
      data: data,
      bookingData: bookingData,
      isMobile: isMobile,
      isTablet: isTablet,
      projectBankAccount: projectBankAccount,
      vaBankName: vaBankName,
      vaAccountNumber: vaAccountNumber
    };
  };

  this.handleInputChange = function (event, _ref3) {
    var name = _ref3.name,
        value = _ref3.value;
    var _state3 = _this3.state,
        data = _state3.data,
        bookingData = _state3.bookingData,
        vaAccountNumber = _state3.vaAccountNumber,
        vaBankName = _state3.vaBankName;

    if (name === 'paymentMethodTypeID' && value === 'online_payment' && bookingData && bookingData.bookingCustomer && bookingData.bookingCustomer.email === '') {
      _this3.setState({ openNotifyAddPurchaserEmailModal: true });
      return;
    }
    // If bank_transfer & only got one option in the bank dropdown, have it selected automatically
    if (name === 'paymentMethodTypeID' && value === 'bank_transfer') {
      var projectBankAccount = _this3.state.projectBankAccount;

      if (projectBankAccount && projectBankAccount.length === 1) {
        data.transferredToBankID = projectBankAccount[0].value;
      }
    }
    if (_this3.props.checkChanges) _this3.props.checkChanges('isBookingFeePaymentChanged');
    if (name === 'transferredToVAAccountNumber') {
      data.transferredToVABank = vaBankName;
      data.transferredToVAAccountNumber = vaAccountNumber;
    } else {
      data[name] = value;
    }
    _this3.setState({ data: data });
  };

  this.handleCloseModal = function (e) {
    e.preventDefault();
    var _state4 = _this3.state,
        openPaymentRequestModal = _state4.openPaymentRequestModal,
        openNotifyAddPurchaserEmailModal = _state4.openNotifyAddPurchaserEmailModal;

    if (openPaymentRequestModal) {
      _this3.setState({ openPaymentRequestModal: false });
    }
    if (openNotifyAddPurchaserEmailModal) {
      _this3.setState({ openNotifyAddPurchaserEmailModal: false });
    }
  };

  this.handleOnAddEmail = function (e) {
    e.preventDefault();
    var store = _this3.context.store;
    var bookingData = _this3.state.bookingData;

    _this3.setState({ openNotifyAddPurchaserEmailModal: false });
    if (bookingData) {
      store.dispatch((0, _reactRouterRedux.push)('/bookings/' + bookingData.id + '/?section=purchaser'));
    }
  };

  this.handleResetInputChange = function () {
    var sectionName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'BookingFeePayment';
    var oriData = _this3.state.oriData;

    var data = (0, _inputChanges.resetDataChanges)(oriData, Form.defaultBookingFeePayment);
    _this3.setState({ data: data }, function () {
      if (_this3.props.resetChanges) _this3.props.resetChanges(sectionName);
    });
  };

  this.handleResize = function () {
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    var isTablet = windowWidth >= 768 && windowWidth < 992;
    if (isMobile !== _this3.state.isMobile) {
      _this3.setState({ isMobile: isMobile });
    }
    if (isTablet !== _this3.state.isTablet) {
      _this3.setState({ isTablet: isTablet });
    }
  };

  this.handleSave = function (event) {
    event.preventDefault();
    var store = _this3.context.store;
    var _state5 = _this3.state,
        bookingData = _state5.bookingData,
        data = _state5.data,
        openPaymentRequestModal = _state5.openPaymentRequestModal,
        picturesUploaded = _state5.picturesUploaded,
        picturesUploadedCount = _state5.picturesUploadedCount;

    if (openPaymentRequestModal) {
      _this3.setState({ openPaymentRequestModal: false });
    }
    if (data.creditCardLastFourDigits && data.paymentMethodTypeID !== 'credit_card') {
      data.creditCardLastFourDigits = '';
    }
    if (data.paymentMethodTypeID !== 'virtual_account') {
      data.transferredToVABankName = '';
      data.transferredToVAAccountNumber = '';
    }
    // handleSendRequestPayment
    return _AppForm2.default.validate(_this3.validation, data).then(function (validations) {
      var nValidations = validations;
      var project = bookingData.project;
      if (project && project.paymentFieldsRequired && data.paymentMethodTypeID !== 'online_payment' || isPRS && data.paymentMethodTypeID === 'cheque' && picturesUploadedCount < 1) {
        nValidations.push({
          isValid: picturesUploadedCount > 0,
          key: '',
          message: 'File attachment is required'
        });
      }
      if ((0, _validations.validateForm)(store, nValidations)) return;

      var newAmountCents = data.amountCents;
      if (newAmountCents[newAmountCents.length - 1] === '.') {
        newAmountCents = newAmountCents.slice(0, -1);
      }
      _this3.props.onCreate({
        data: _extends({}, data, {
          amountCents: (0, _centsFloat.floatToCents)(newAmountCents)
        }),
        picturesUploaded: picturesUploaded,
        picturesUploadedCount: picturesUploadedCount
      });
    });
  };

  this.handleSendRequestPayment = function (e) {
    e.preventDefault();
    _this3.setState({ openPaymentRequestModal: true });
  };

  this.handleUploadModalClose = function () {
    return _this3.uploadModal.close();
  };

  this.transformProjectBankAccountData = function (projectBankAccount) {
    if (!projectBankAccount) return [];
    var activeBankAccount = projectBankAccount.filter(function (e) {
      return e.isActive;
    });
    return activeBankAccount.map(function (e) {
      return {
        value: e.id,
        text: e.bank + ' (' + e.accountNumber + ')'
      };
    });
  };

  this.transformUnitVAData = function () {
    var _state6 = _this3.state,
        vaAccountNumber = _state6.vaAccountNumber,
        vaBankName = _state6.vaBankName;
    var t = _this3.props.t;

    var vaOptions = [{
      value: '-',
      text: t('Not available')
    }];
    if (vaBankName && vaAccountNumber) {
      vaOptions = [{
        value: vaAccountNumber,
        text: vaBankName + ' (' + vaAccountNumber + ')'
      }];
    }
    return vaOptions;
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Form.mapStateToProps)(Form));

/***/ }),
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _types = __webpack_require__(145);

var _AttachmentModal = __webpack_require__(585);

var _AttachmentModal2 = _interopRequireDefault(_AttachmentModal);

var _Item = __webpack_require__(1050);

var _Item2 = _interopRequireDefault(_Item);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

var _groups = __webpack_require__(194);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _initialiseProps.call(_this);

    var state = List.getPropsToState(props);

    _this.state = _extends({
      attachmentModalState: false,
      attachmentModalData: {},
      genericErrMsg: props.t('An error occurred, please refresh page'),
      loading: false
    }, state);
    return _this;
  }

  _createClass(List, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'handleError',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(store, msg, errorObj) {
        var isBugsnag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(false);

              case 2:
                _context.next = 4;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: msg }));

              case 4:
                if (isBugsnag) Bugsnag.notifyException(errorObj);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleError(_x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return handleError;
    }()
  }, {
    key: 'canDeletePaymentAttachment',
    value: function canDeletePaymentAttachment() {
      var auth = this.props.auth;

      if (!auth || !auth.groups || !Array.isArray(auth.groups)) return false;

      var allowedGroupIDs = [_groups.GROUP_ID_DEVELOPER_HEADQUARTERS, _groups.GROUP_ID_DEVELOPER_BRANCH_LEADER, _groups.GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR, _groups.GROUP_ID_DEVELOPER_BRANCH_LEADER_SUPERVISOR_II, _groups.GROUP_ID_DEVELOPER_AGENT_LEADER];

      return auth.groups.some(function (group) {
        return allowedGroupIDs.includes(group.id);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          data = _state.data,
          attachmentModalState = _state.attachmentModalState,
          attachmentModalData = _state.attachmentModalData;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_AttachmentModal2.default, {
          modalState: attachmentModalState,
          data: attachmentModalData,
          onClose: this.handleCloseAttachment,
          onDelete: this.canDeletePaymentAttachment() ? this.handleDeleteAttachment : null
        }),
        data.bookingFeePayments.map(function (value, index) {
          return _react2.default.createElement(
            _semanticUiReact.Grid,
            { centered: true, key: index },
            _react2.default.createElement(_Item2.default, {
              auth: _this3.props.auth,
              bookingData: _this3.props.data,
              data: value,
              hideCancel: _this3.props.hideCancel,
              projectBankAccount: data.project.projectBankAccount,
              projectCurrencies: data.project.projectCurrency,
              openAttachment: _this3.handleOpenAttachment,
              onCancelTransaction: _this3.props.onCancelTransaction,
              onUpdated: _this3.props.onUpdated,
              token: _this3.props.token
            })
          );
        })
      );
    }
  }]);

  return List;
}(_react.Component);

List.propTypes = {
  auth: _types.StateAuth,
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  hideCancel: _propTypes2.default.bool,
  onCancelTransaction: _propTypes2.default.func,
  onUpdated: _propTypes2.default.func,
  projectBankAccount: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  token: _propTypes2.default.string,
  t: _propTypes2.default.func
};
List.contextTypes = {
  router: _propTypes2.default.object,
  store: _propTypes2.default.object
};

List.getPropsToState = function (props) {
  var data = Object.assign({}, props.data);
  data.bookingFeePayments = data.bookingFeePayments.filter(function (e) {
    return e.status !== 'deduction';
  });
  var projectCurrencies = data.project.projectCurrency;
  return {
    data: data,
    projectCurrencies: projectCurrencies
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleCloseAttachment = function () {
    _this4.setState({
      attachmentModalState: false
    });
  };

  this.handleOpenAttachment = function (data) {
    _this4.setState({
      attachmentModalState: true,
      attachmentModalData: data
    });
  };

  this.handleDeleteAttachment = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id, successCallback) {
      var genericErrMsg, _context2, store, router, t, response;

      return regeneratorRuntime.wrap(function _callee2$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              genericErrMsg = _this4.state.genericErrMsg;
              _context2 = _this4.context, store = _context2.store, router = _context2.router;
              t = _this4.props.t;
              _context3.prev = 3;
              _context3.next = 6;
              return _this4.setLoading(true);

            case 6:
              _context3.next = 8;
              return (0, _fetchM.serverRequestDelete)('/bookings/' + router.params.id + '/pictures/' + id + '/', store, _this4.props.token);

            case 8:
              response = _context3.sent;

              if (!response.error) {
                _context3.next = 12;
                break;
              }

              _this4.handleError(store, response.message);
              return _context3.abrupt('return');

            case 12:
              if (!_this4.props.onUpdated) {
                _context3.next = 15;
                break;
              }

              _context3.next = 15;
              return _this4.props.onUpdated();

            case 15:
              _context3.next = 17;
              return _this4.setLoading(false);

            case 17:
              successCallback(id);
              store.dispatch((0, _flash.flashSuccessMessage)({
                header: t('Delete Success'),
                message: t('Picture successfully deleted')
              }));
              _context3.next = 24;
              break;

            case 21:
              _context3.prev = 21;
              _context3.t0 = _context3['catch'](3);

              _this4.handleError(store, genericErrMsg, _context3.t0, true);

            case 24:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee2, _this4, [[3, 21]]);
    }));

    return function (_x6, _x7) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.translation)(List);

/***/ }),
/* 2254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _Form = __webpack_require__(2252);

var _Form2 = _interopRequireDefault(_Form);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var New = function (_Component) {
  _inherits(New, _Component);

  function New(props) {
    _classCallCheck(this, New);

    var _this = _possibleConstructorReturn(this, (New.__proto__ || Object.getPrototypeOf(New)).call(this, props));

    _initialiseProps.call(_this);

    var state = New.getPropsToState(props);

    _this.state = _extends({
      genericErrMsg: props.t('An error occurred, please refresh page'),
      loading: false
    }, state);
    return _this;
  }

  _createClass(New, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = New.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'handleError',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(store, msg, errorObj) {
        var isBugsnag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(false);

              case 2:
                _context.next = 4;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: msg }));

              case 4:
                if (isBugsnag) Bugsnag.notifyException(errorObj);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleError(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return handleError;
    }()
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var projectBankAccount = this.state.projectBankAccount;
      var t = this.props.t;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
          this.state.loading && _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading')
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { centered: true },
          _react2.default.createElement(_Form2.default, {
            bookingData: this.props.bookingData,
            checkChanges: this.props.checkChanges,
            onCreate: this.handleCreatePayment,
            projectBankAccount: projectBankAccount,
            resetChanges: this.handleResetChange
          })
        )
      );
    }
  }]);

  return New;
}(_react.Component);

New.propTypes = {
  checkChanges: _propTypes2.default.func,
  onUpdated: _propTypes2.default.func,
  projectBankAccount: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  resetChanges: _propTypes2.default.func,
  token: _propTypes2.default.string,
  bookingData: _propTypes2.default.oneOfType([_propTypes2.default.object])
};
New.contextTypes = {
  router: _propTypes2.default.object,
  store: _propTypes2.default.object
};

New.getPropsToState = function (props) {
  var projectBankAccount = props.projectBankAccount;
  return {
    projectBankAccount: projectBankAccount
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleCreatePayment = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(value) {
      var paymentData, picturesUploaded, picturesUploadedCount, genericErrMsg, _context2, store, router, t, response, bfpQuery, res, picQuery, message, _message;

      return regeneratorRuntime.wrap(function _callee2$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              paymentData = value.data, picturesUploaded = value.picturesUploaded, picturesUploadedCount = value.picturesUploadedCount;
              genericErrMsg = _this3.state.genericErrMsg;
              _context2 = _this3.context, store = _context2.store, router = _context2.router;
              t = _this3.props.t;

              if (!(paymentData.paymentMethodTypeID === 'credit_card' && (!value.data.creditCardLastFourDigits || value.data.creditCardLastFourDigits && value.data.creditCardLastFourDigits.length !== 4))) {
                _context3.next = 7;
                break;
              }

              store.dispatch((0, _flash.flashErrorMessage)({ message: t('Kindly fill in the last 4 digits of your Credit Card') }));
              return _context3.abrupt('return');

            case 7:
              _context3.next = 9;
              return _this3.setLoading(true);

            case 9:
              response = void 0;
              bfpQuery = {
                pendingAttachments: picturesUploadedCount > 0
              };
              _context3.prev = 11;
              _context3.next = 14;
              return (0, _fetchM.serverRequestPost)('/bookings/' + router.params.id + '/booking_fee_payments/?' + _qs2.default.stringify(bfpQuery), store, _this3.props.token, paymentData);

            case 14:
              response = _context3.sent;
              _context3.next = 23;
              break;

            case 17:
              _context3.prev = 17;
              _context3.t0 = _context3['catch'](11);
              _context3.next = 21;
              return _this3.setLoading(false);

            case 21:
              _this3.handleError(store, genericErrMsg, _context3.t0, true);
              return _context3.abrupt('return');

            case 23:
              if (!response.error) {
                _context3.next = 29;
                break;
              }

              _context3.next = 26;
              return _this3.setLoading(false);

            case 26:
              _this3.handleError(store, response.message);
              _context3.next = 72;
              break;

            case 29:
              if (!(picturesUploadedCount > 0)) {
                _context3.next = 67;
                break;
              }

              res = void 0;
              picQuery = {
                FPID: response.data.id,
                isCreatingBFP: true
              };
              _context3.prev = 32;
              _context3.next = 35;
              return store.dispatch((0, _fetchM.fetchM)('/bookings/' + router.params.id + '/pictures/?' + _qs2.default.stringify(picQuery), {
                credentials: 'include',
                method: 'POST',
                headers: {
                  'X-Csrf-Token': _this3.props.token
                },
                body: picturesUploaded
              }));

            case 35:
              res = _context3.sent;
              _context3.next = 52;
              break;

            case 38:
              _context3.prev = 38;
              _context3.t1 = _context3['catch'](32);
              _context3.next = 42;
              return _this3.setLoading(false);

            case 42:
              if (!(_context3.t1.res && _context3.t1.res.status >= 400 && _context3.t1.res.status < 500)) {
                _context3.next = 48;
                break;
              }

              _context3.next = 45;
              return _context3.t1.res.text();

            case 45:
              message = _context3.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
              return _context3.abrupt('return');

            case 48:
              Bugsnag.notifyException(_context3.t1);
              _context3.next = 51;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

            case 51:
              return _context3.abrupt('return');

            case 52:
              _context3.next = 54;
              return _this3.setLoading(false);

            case 54:
              if (res.ok) {
                _context3.next = 62;
                break;
              }

              _context3.next = 57;
              return res.text();

            case 57:
              _message = _context3.sent;
              _context3.next = 60;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

            case 60:
              _context3.next = 65;
              break;

            case 62:
              _this3.props.onUpdated();
              if (_this3.props.resetChanges) _this3.props.resetChanges('BookingFeePayment');
              store.dispatch((0, _flash.flashSuccessMessage)({
                header: t('Create Success'),
                message: t('Payment successfully created')
              }));

            case 65:
              _context3.next = 72;
              break;

            case 67:
              _context3.next = 69;
              return _this3.setLoading(false);

            case 69:
              _this3.props.onUpdated();
              if (_this3.props.resetChanges) _this3.props.resetChanges('BookingFeePayment');
              if (paymentData.paymentMethodTypeID === 'online_payment') {
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Payment Request Success'),
                  message: t('An email notification and SMS with the payment request link is successfully sent to Purchaser. The link will expire in 24 hours.')
                }));
              } else {
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Create Success'),
                  message: t('Payment successfully created')
                }));
              }

            case 72:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee2, _this3, [[11, 17], [32, 38]]);
    }));

    return function (_x6) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.handleResetChange = function (sectionName) {
    if (_this3.props.resetChanges) _this3.props.resetChanges(sectionName);
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.translation)(New);

/***/ }),
/* 2255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TotalAmountModal = function (_Component) {
  _inherits(TotalAmountModal, _Component);

  function TotalAmountModal(props) {
    _classCallCheck(this, TotalAmountModal);

    var _this = _possibleConstructorReturn(this, (TotalAmountModal.__proto__ || Object.getPrototypeOf(TotalAmountModal)).call(this, props));

    _initialiseProps.call(_this);

    var state = TotalAmountModal.getPropsToState(props);
    _this.state = _extends({}, state);
    return _this;
  }

  _createClass(TotalAmountModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = TotalAmountModal.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          centered: true,
          open: this.state.open,
          onClose: this.handleOnClose,
          closeIcon: 'close',
          size: 'small'
        },
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { centered: true },
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _reactI18next.Trans,
              {
                ns: _translation.TRANSLATION_FILES.screens,
                i18nKey: 'booking_fee_description' // Explicit key to avoid index matching bugs
                , components: { bold: _react2.default.createElement('strong', null) }
              },
              _react2.default.createElement(
                'bold',
                null,
                'Total amount of booking fee'
              ),
              ' is the amount that a Purchaser needs to pay to reserve a unit.'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            _react2.default.createElement(
              _reactI18next.Trans,
              {
                ns: _translation.TRANSLATION_FILES.screens,
                i18nKey: 'new_payment_description' // Explicit key to avoid index matching bugs
                , components: { bold: _react2.default.createElement('strong', null) }
              },
              _react2.default.createElement(
                'bold',
                null,
                'New Payment'
              ),
              ' button is to create a payment transaction. MHub allows multiple payment transactions.'
            )
          )
        )
      );
    }
  }]);

  return TotalAmountModal;
}(_react.Component);

TotalAmountModal.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func
};

TotalAmountModal.getPropsToState = function (props) {
  var open = props.open;
  return {
    open: open
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleOnClose = function () {
    _this2.props.onClose();
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(TotalAmountModal);

/***/ }),
/* 2256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _bobForms = __webpack_require__(989);

var _templates = __webpack_require__(380);

var _flash = __webpack_require__(5);

var _addressSettings = __webpack_require__(152);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _vietnam = __webpack_require__(40);

var _url = __webpack_require__(19);

var _BookingActivities = __webpack_require__(1005);

var _BookingActivities2 = _interopRequireDefault(_BookingActivities);

var _BookingSectionTab = __webpack_require__(558);

var _BookingSectionTab2 = _interopRequireDefault(_BookingSectionTab);

var _BookingTitle = __webpack_require__(260);

var _BookingTitle2 = _interopRequireDefault(_BookingTitle);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _booking = __webpack_require__(129);

var _booking2 = _interopRequireDefault(_booking);

var _bookingStatuses = __webpack_require__(128);

var _translation = __webpack_require__(4);

var _FormSharingModal = __webpack_require__(1076);

var _FormSharingModal2 = _interopRequireDefault(_FormSharingModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
/* eslint no-nested-ternary: 0 */

// actions

// utils

// components

// structs


var isPRS = _config2.default.get('prs');

var Activities = function (_Component) {
  _inherits(Activities, _Component);

  function Activities(props) {
    _classCallCheck(this, Activities);

    var _this = _possibleConstructorReturn(this, (Activities.__proto__ || Object.getPrototypeOf(Activities)).call(this, props));

    _initialiseProps.call(_this);

    var state = Activities.getPropsToState(props);
    state.limit = 0;
    state.offset = 0;
    state.currentPage = parseInt(state.query.page, 10) || 1;
    state.count = 0;
    state.printTemplates = [];
    _this.state = _extends({}, state, {
      docxPrintTemplates: []
    });
    return _this;
  }

  _createClass(Activities, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;

      store.dispatch((0, _templates.fetchTemplates)('print', true));
      store.dispatch((0, _bobForms.fetchBobForms)(true));
      store.dispatch((0, _addressSettings.fetchAddressSettings)());
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = this.props.location.query;

      this.getBookingActivities(query);
      if (this.state.data && this.state.data.id) {
        this.fetchPrintTypes();
        this.getBookingPaymentPlan(this.state.data.id);
        this.fetchDocxTemplates(this.state.data);
      }
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var query = nextProps.location.query;
      var _state = this.state,
          activitiesData = _state.activitiesData,
          data = _state.data,
          bookingPaymentPlan = _state.bookingPaymentPlan,
          sectionTabs = _state.sectionTabs;

      var state = Activities.getPropsToState(nextProps);
      var isDataSame = JSON.stringify(data) === JSON.stringify(state.data);

      if (isDataSame) {
        state.bookingPaymentPlan = bookingPaymentPlan;
        state.sectionTabs = sectionTabs;
      }

      if (activitiesData) {
        state.activitiesData = activitiesData;
      }
      this.setState(_extends({}, state), function () {
        if (!activitiesData) {
          _this2.getBookingActivities(query);
        }
        if (!isDataSame && state.data.id) {
          _this2.fetchPrintTypes();
          _this2.getBookingPaymentPlan(state.data.id);
          _this2.fetchDocxTemplates(state.data);
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'getBookingActivities',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var store, t, query, queryString, res, message, activitiesData, count, limit, offset;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                queryString = '';
                res = null;

                if (_qs2.default.stringify(query)) {
                  queryString = '?' + _qs2.default.stringify(query);
                }
                _context.prev = 9;
                _context.next = 12;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.props.routeParamsID + '/activities/' + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context.sent;
                _context.next = 26;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](9);
                _context.next = 19;
                return this.setLoading(false);

              case 19:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 24;
                  break;
                }

                _context.next = 22;
                return _context.t0.res.text();

              case 22:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 26:
                if (res.ok) {
                  _context.next = 32;
                  break;
                }

                _context.next = 29;
                return this.setLoading(false);

              case 29:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                _context.next = 42;
                break;

              case 32:
                _context.next = 34;
                return res.json();

              case 34:
                activitiesData = _context.sent;
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 40;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset,
                  activitiesData: activitiesData
                });

              case 40:
                _context.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 15]]);
      }));

      function getBookingActivities(_x3) {
        return _ref.apply(this, arguments);
      }

      return getBookingActivities;
    }()
  }, {
    key: 'fetchDocxTemplates',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(data) {
        var store, _props, t, auth, res, message, docxPrintTemplates, tempTemplates, statusFieldMap, field;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                _props = this.props, t = _props.t, auth = _props.auth;
                res = void 0;
                _context2.prev = 3;
                _context2.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/docxtemplates/projects/' + data.project.id + '/templates/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 6:
                res = _context2.sent;
                _context2.next = 16;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](3);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 14;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 14:
                this.setState({ docxPrintTemplates: [] });
                return _context2.abrupt('return');

              case 16:
                if (res.ok) {
                  _context2.next = 25;
                  break;
                }

                _context2.next = 19;
                return res.text();

              case 19:
                message = _context2.sent;
                _context2.next = 22;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 22:
                this.setState({ docxPrintTemplates: [] });
                _context2.next = 31;
                break;

              case 25:
                _context2.next = 27;
                return res.json();

              case 27:
                docxPrintTemplates = _context2.sent;
                tempTemplates = [];

                if (docxPrintTemplates && docxPrintTemplates.length > 0) {
                  statusFieldMap = {
                    reserved: 'isEnabledOnReserved',
                    booked: 'isEnabledOnBooked',
                    cancelled_developer: 'isEnabledOnCancelled',
                    cancelled_availability: 'isEnabledOnCancelled',
                    sold: 'isEnabledOnSold',
                    sold_spa_signed: 'isEnabledOnSold'
                  };
                  field = statusFieldMap[data.statusID];

                  tempTemplates = docxPrintTemplates.filter(function (template) {
                    return template.isEnabled && field && template[field] && Array.isArray(template.visibleToBusinessUnits) && template.visibleToBusinessUnits.includes(auth.companyBranch.id);
                  }).map(function (template) {
                    return {
                      value: template.id,
                      text: template.name.replace('.docx', ''),
                      type: 'docx'
                    };
                  });
                }
                // always set state so templates from a previous booking are cleared when the
                // current project has none (MS-6015), without resetting on unrelated props changes (MS-6448)
                this.setState({ docxPrintTemplates: tempTemplates });

              case 31:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 9]]);
      }));

      function fetchDocxTemplates(_x4) {
        return _ref2.apply(this, arguments);
      }

      return fetchDocxTemplates;
    }()
  }, {
    key: 'replaceQuery',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(query) {
        var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var store, queryNew;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                queryNew = query;

                if (resetPage) queryNew.page = 1;
                _context3.next = 7;
                return this.getBookingActivities(query);

              case 7:
                store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + this.props.routeParamsID + '/activities/?' + (0, _url.encodeSearch)(queryNew)));
                _context3.next = 10;
                return this.setLoading(false);

              case 10:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function replaceQuery(_x5) {
        return _ref3.apply(this, arguments);
      }

      return replaceQuery;
    }()
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters) {
        return true;
      }
      if (this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'sendEmail',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(body) {
        var store, _props2, t, token, data, res, message;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _props2 = this.props, t = _props2.t, token = _props2.token;
                data = this.state.data;
                res = void 0;
                _context4.prev = 6;
                _context4.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + data.id + '/customers/' + data.bookingCustomer.customerID + '/send_email/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': token
                  },
                  body: JSON.stringify(body)
                }));

              case 9:
                res = _context4.sent;
                _context4.next = 20;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4['catch'](6);

                Bugsnag.notifyException(_context4.t0);
                _context4.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context4.next = 19;
                return this.setLoading(false);

              case 19:
                return _context4.abrupt('return');

              case 20:
                if (res.ok) {
                  _context4.next = 28;
                  break;
                }

                _context4.next = 23;
                return res.text();

              case 23:
                message = _context4.sent;
                _context4.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context4.next = 30;
                break;

              case 28:
                _context4.next = 30;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Share Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Successfully generate and send email to primary purchaser', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 30:
                _context4.next = 32;
                return this.setLoading(false);

              case 32:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[6, 12]]);
      }));

      function sendEmail(_x8) {
        return _ref4.apply(this, arguments);
      }

      return sendEmail;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state2 = this.state,
          activitiesData = _state2.activitiesData,
          data = _state2.data,
          loading = _state2.loading,
          isMobile = _state2.isMobile,
          tabID = _state2.tabID,
          sectionTabs = _state2.sectionTabs,
          printTemplates = _state2.printTemplates,
          docxPrintTemplates = _state2.docxPrintTemplates,
          isPrinting = _state2.isPrinting;
      var t = this.props.t;

      var printTmplOnly = printTemplates ? printTemplates.filter(function (_ref5) {
        var value = _ref5.value;
        return value !== 'customer_identities';
      }) : [];
      var combinedPrintTemplates = [].concat(_toConsumableArray(docxPrintTemplates), _toConsumableArray(printTemplates));

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Booking Overview'),
          rightNav: this.checkAllowPrint(data && data) ? _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(
              'div',
              { className: 'printButton' },
              data.project.printPDF && printTmplOnly.length === 1 ? _react2.default.createElement(
                _reactRouter.Link,
                {
                  as: 'a',
                  className: 'ui medium compact primary button icon',
                  disabled: loading,
                  onClick: this.handlePrint,
                  target: '_blank',
                  to: _config2.default.get('bookApiURL') + '/bookings/' + (data ? data.id : '') + '/template/' + btoa(printTemplates[0].value) + '/print/?pdf=true'
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'file outline pdf', fitted: isMobile }),
                _react2.default.createElement(
                  'small',
                  null,
                  isMobile ? '' : ' PDF'
                )
              ) : data.project.printPDF && printTmplOnly.length > 1 && _react2.default.createElement(
                _semanticUiReact.Dropdown,
                {
                  pointing: 'top right',
                  button: true,
                  compact: true,
                  labeled: !isMobile,
                  icon: 'file outline pdf',
                  text: isMobile ? '' : 'PDF',
                  className: 'ui medium compact primary button icon print_dropdown',
                  style: {
                    marginRight: '10px',
                    height: '30px',
                    verticalAlign: 'middle'
                  }
                },
                _react2.default.createElement(
                  _semanticUiReact.Dropdown.Menu,
                  null,
                  printTmplOnly.map(function (_ref6) {
                    var text = _ref6.text,
                        value = _ref6.value,
                        type = _ref6.type;
                    return _react2.default.createElement(
                      _semanticUiReact.Dropdown.Item,
                      {
                        key: value + '_' + text,
                        name: 'printType',
                        value: value,
                        onClick: function onClick(e, form) {
                          return _this5.handlePrintForm(e, form, true, type);
                        }
                      },
                      text
                    );
                  })
                )
              ),

              // if no templates & IC
              combinedPrintTemplates.length === 1 ? function () {
                var template = combinedPrintTemplates[0];
                var isDocx = template.type === 'docx';
                var showLoading = isDocx && isPrinting;
                return _react2.default.createElement(
                  _reactRouter.Link,
                  {
                    as: 'a',
                    className: 'ui medium compact primary button icon ' + (showLoading ? 'disabled' : ''),
                    disabled: showLoading,
                    onClick: function onClick(e) {
                      e.preventDefault();
                      if (showLoading) return; // Prevent clicking while loading
                      _this5.handlePrintForm(e, { value: template.value }, false, template.type);
                    },
                    target: '_blank',
                    to: !isDocx ? _this5.getPrintLink(data, template) : '#'
                  },
                  showLoading ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'spinner', loading: true, fitted: isMobile }) : _react2.default.createElement(_semanticUiReact.Icon, { name: 'print', fitted: isMobile }),
                  _react2.default.createElement(
                    'small',
                    null,
                    isMobile ? '' : ' ' + (showLoading ? t('Printing...') : t('Print'))
                  )
                );
              }() : _react2.default.createElement(
                _semanticUiReact.Dropdown,
                {
                  pointing: 'top right',
                  button: true,
                  labeled: !isMobile,
                  icon: 'print',
                  text: isMobile ? '' : t('Print'),
                  className: 'ui medium compact primary button icon print_dropdown',
                  loading: isPrinting,
                  disabled: isPrinting,
                  style: {
                    marginRight: '10px',
                    height: '30px',
                    verticalAlign: 'middle'
                  }
                },
                _react2.default.createElement(
                  _semanticUiReact.Dropdown.Menu,
                  null,
                  combinedPrintTemplates.map(function (_ref7) {
                    var text = _ref7.text,
                        value = _ref7.value,
                        type = _ref7.type;
                    return _react2.default.createElement(
                      _semanticUiReact.Dropdown.Item,
                      {
                        key: value + '_' + text,
                        name: 'printType',
                        value: value,
                        onClick: function onClick(e, form) {
                          return _this5.handlePrintForm(e, form, false, type);
                        }
                      },
                      text
                    );
                  })
                )
              ),
              _react2.default.createElement(_FormSharingModal2.default, {
                open: this.state.showShareEmailModal,
                onClose: this.handleOnCloseShareEmail,
                onProceed: this.handleProceedShareEmail,
                printTemplates: printTmplOnly
              })
            )
          ) : null,
          bottomNode: _react2.default.createElement(_BookingSectionTab2.default, {
            loading: this.state.loading,
            isMobile: isMobile,
            isSticky: true,
            onTabChange: this.handleTabChange,
            tabs: sectionTabs,
            tabID: tabID
          })
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { paddingBottom: '0' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_BookingSectionTab2.default, {
                loading: loading,
                isMobile: isMobile,
                onTabChange: this.handleTabChange,
                tabs: sectionTabs,
                tabID: tabID
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              _react2.default.createElement(_BookingTitle2.default, { isMobile: isMobile, data: data })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(_SearchFilter2.default, {
                isLoading: this.state.loading,
                onChange: this.handleOnChange,
                onClose: this.handleClearFilter,
                search: this.state.search,
                placeholder: t('Search'),
                setAdvanceFilter: function setAdvanceFilter() {},
                leftNav: _react2.default.createElement(_PageNav2.default, {
                  currentPage: this.state.currentPage,
                  count: this.state.count,
                  limit: this.state.limit,
                  offset: this.state.offset,
                  dataSize: this.state.activitiesData.length,
                  loading: this.state.loading,
                  onChange: this.handleChangePage
                }),
                rightNav: _react2.default.createElement(_SortButton2.default, {
                  floated: 'right',
                  loading: this.state.loading,
                  items: this.sortItems.map(function (item) {
                    return _extends({}, item, {
                      text: t(item.text, { ns: _translation.TRANSLATION_FILES.translation })
                    });
                  }),
                  onSort: this.handleSortData
                })
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, textAlign: 'center' },
              _react2.default.createElement(
                _semanticUiReact.Segment,
                null,
                _react2.default.createElement(_BookingActivities2.default, {
                  data: activitiesData || [],
                  hasAccess: this.hasAccess(),
                  loading: this.state.loading
                })
              ),
              _react2.default.createElement(_PageNav2.default, {
                currentPage: this.state.currentPage,
                count: this.state.count,
                limit: this.state.limit,
                offset: this.state.offset,
                dataSize: this.state.activitiesData.length,
                loading: this.state.loading,
                onChange: this.handleChangePage,
                upward: true
              })
            )
          )
        )
      );
    }
  }]);

  return Activities;
}(_react.Component);

Activities.contextTypes = {
  store: _propTypes2.default.object
};
Activities.propTypes = {
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      settings: _propTypes2.default.shape({
        bookingHideLoanTracker: _propTypes2.default.bool
      })
    })
  }),
  routeParamsID: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  bobForms: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  templates: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      print: _propTypes2.default.array
    })
  }),
  t: _propTypes2.default.func
};

Activities.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig,
    templates: state.templates,
    bobForms: state.bobForms
  };
};

Activities.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var windowWidth = window.innerWidth;
  var activitiesData = [];
  var data = Object.assign({}, _booking2.default, props.data);
  var isMobile = windowWidth < 768;
  var loading = props.loading;
  var search = query.search || '';
  var hideLoanTracker = props.appConfig && props.appConfig.data && props.appConfig.data.settings && props.appConfig.data.settings.bookingHideLoanTracker;
  var tabID = 6;
  var showShareEmailModal = false;
  var isMalaysia = props.auth && props.auth.company && props.auth.company.countryCode.toUpperCase() === 'MY';
  // CPI-976: Vietnam's E-Sign is hidden on the Purchaser tab; the description should not mention it.
  var sectionTabs = [{ id: 1, title: 'Info', description: 'Status, Pricing & Payment' }, { id: 2, title: 'Purchaser', description: (0, _vietnam.isVietnamCompany)(props.auth) ? 'Details & Eligibility' : 'Details, E-Sign & Eligibility' }, { id: 3, title: 'Tracker', description: 'Loan & SPA/LA Tracker', disabled: hideLoanTracker }];
  sectionTabs.push.apply(sectionTabs, _toConsumableArray(!isMalaysia ? [{
    id: 4,
    title: 'Payment Plan',
    description: 'Pending Selection',
    disabled: data.project && !data.project.paymentPlanFlow
  }] : []).concat([{ id: 5, title: 'Documents', description: 'Document Sharing' }, { id: 6, title: 'Logs', description: 'Activity Logs', page: 'activities/' }]));
  // CPI-974 (AC16): Vietnam has no MHub Buyer App, and the buyerProfileID arm means the
  // project flag alone would still show the tab on a booking that was linked earlier.
  if (!(0, _vietnam.isVietnamCompany)(props.auth) && (data.buyerProfileID || data.project.linkBuyerApp && !_bookingStatuses.CANCELLED_BOOKING_STATUSES.some(function (s) {
    return data.statusID === s.value;
  }))) {
    sectionTabs.push({ id: 7, title: 'Buyer App', description: 'Status & Progress' });
  }
  return {
    activitiesData: activitiesData,
    data: data,
    isMobile: isMobile,
    loading: loading,
    query: query,
    search: search,
    tabID: tabID,
    sectionTabs: sectionTabs,
    showShareEmailModal: showShareEmailModal
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.getBookingPaymentPlan = function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(bookingID) {
      var store, t, res, message, _message, bookingPaymentPlan, sectionTabs;

      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this6.setLoading(true);

            case 2:
              store = _this6.context.store;
              t = _this6.props.t;
              res = void 0;
              _context5.prev = 5;
              _context5.next = 8;
              return store.dispatch((0, _fetchM.fetchM)('/bookings/' + bookingID + '/payment_plan/', {
                credentials: 'include',
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }));

            case 8:
              res = _context5.sent;
              _context5.next = 24;
              break;

            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5['catch'](5);

              if (!(_context5.t0.res && _context5.t0.res.status >= 399 && _context5.t0.res.status < 500)) {
                _context5.next = 18;
                break;
              }

              _context5.next = 16;
              return _context5.t0.res.text();

            case 16:
              message = _context5.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

            case 18:
              _context5.next = 20;
              return _this6.setLoading(false);

            case 20:
              Bugsnag.notifyException(_context5.t0);
              _context5.next = 23;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

            case 23:
              return _context5.abrupt('return');

            case 24:
              if (res.ok) {
                _context5.next = 32;
                break;
              }

              _context5.next = 27;
              return res.text();

            case 27:
              _message = _context5.sent;
              _context5.next = 30;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

            case 30:
              _context5.next = 37;
              break;

            case 32:
              _context5.next = 34;
              return res.json();

            case 34:
              bookingPaymentPlan = _context5.sent;

              // mutate payment plan tab's description
              sectionTabs = _lodash2.default.map(_this6.state.sectionTabs, function (st) {
                var nst = _extends({}, st);
                if (st.id === 4) nst.description = _this6.generatePaymentPlanTabDescription(bookingPaymentPlan);
                return nst;
              });

              _this6.setState({ bookingPaymentPlan: bookingPaymentPlan, sectionTabs: sectionTabs });

            case 37:
              _context5.next = 39;
              return _this6.setLoading(false);

            case 39:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this6, [[5, 11]]);
    }));

    return function (_x9) {
      return _ref8.apply(this, arguments);
    };
  }();

  this.checkICIsImage = function (customer) {
    var isImage = customer.icFrontDocumentID !== '' || customer.icBackDocumentID !== '';
    if (customer.icFrontDocumentID !== '' && customer.icFrontDocument && customer.icFrontDocument.name) {
      // NOTE: this checking will not work if filename don't hav extension
      if (customer.icFrontDocument.name.toLowerCase().includes('.pdf')) isImage = false;
    }
    if (customer.icBackDocumentID !== '' && customer.icBackDocument && customer.icBackDocument.name) {
      // NOTE: this checking will not work if filename don't hav extension
      if (customer.icBackDocument.name.toLowerCase().includes('.pdf')) isImage = false;
    }
    return isImage;
  };

  this.checkIfBookingStatusAllowedToViewForm = function (formAccessibility, booking) {
    if (booking.statusID === 'expired') {
      return true;
    }
    switch (booking.statusID) {
      case 'reserved':
        return formAccessibility && formAccessibility.isEnabledOnReserved;
      case 'booked':
        return formAccessibility && formAccessibility.isEnabledOnBooked;
      case 'cancelled_developer':
      case 'cancelled_availability':
        return formAccessibility && formAccessibility.isEnabledOnCancelled;
      case 'sold_spa_signed':
        return formAccessibility && formAccessibility.isEnabledOnSold;
      default:
        return false;
    }
  };

  this.checkIfCompanyBranchAllowedToViewForm = function (formAccessibility) {
    var auth = _this6.props.auth;
    // empty company branch IDs means accessible to all

    if (formAccessibility && (!formAccessibility.companyBranchIDs || formAccessibility.companyBranchIDs.length === 0)) {
      return true;
    }
    if (formAccessibility && formAccessibility.companyBranchIDs && auth.companyBranch && auth.companyBranch.id && formAccessibility.companyBranchIDs.includes(auth.companyBranch.id)) {
      return true;
    }
    return false;
  };

  this.checkIfFormAccessibleToViewForm = function (currentPFA, booking) {
    var data = _this6.state.data;

    var formAccessibilities = data && data.project && data.project.projectFormAccessibilities ? data.project.projectFormAccessibilities : [];
    var pfaIdx = formAccessibilities.findIndex(function (fa) {
      return fa.templateID === currentPFA.templateID;
    });
    if (pfaIdx !== -1) {
      var selectedPfa = formAccessibilities[pfaIdx];
      var isCompanyBranchAllowedToView = _this6.checkIfCompanyBranchAllowedToViewForm(selectedPfa);
      var isBookingStatusAllowedToView = _this6.checkIfBookingStatusAllowedToViewForm(selectedPfa, booking);
      return isCompanyBranchAllowedToView && isBookingStatusAllowedToView;
    }
    return false;
  };

  this.generatePaymentPlanTabDescription = function (bookingPaymentPlan) {
    if (bookingPaymentPlan && !_lodash2.default.isEmpty(bookingPaymentPlan.id)) {
      var isEdited = _lodash2.default.some(bookingPaymentPlan.bookingPaymentPlanDetails, function (bppd) {
        return bppd.customized;
      });
      return '' + bookingPaymentPlan.code + (isEdited ? ' (edited)' : '');
    }
    return 'Pending Selection';
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var loadingType = arguments[1];
    return new Promise(function (res) {
      if (loadingType === 'validatingTIN') {
        _this6.setState({ validatingTin: loading }, res);
      } else {
        _this6.setState({ loading: loading }, res);
      }
    });
  };

  this.fetchPrintTypes = function () {
    var _props3 = _this6.props,
        templates = _props3.templates,
        bobForms = _props3.bobForms,
        t = _props3.t;
    var data = _this6.state.data;

    var output = [];
    if (data && data.project && data.project.projectFormAccessibilities && templates && templates.data && templates.data.print) {
      data.project.projectFormAccessibilities.forEach(function (pfa) {
        var isAllowedToView = _this6.checkIfFormAccessibleToViewForm(pfa, data);
        if (isAllowedToView) {
          var selectedTemplate = templates.data.print.find(function (t) {
            return t.id === pfa.templateID;
          });
          if (selectedTemplate && selectedTemplate.name && selectedTemplate.id) {
            output.push({ value: selectedTemplate.id, text: selectedTemplate.name });
          }
        }
      });
    }
    if (data && data.project && data.project.bobFormIDs && bobForms && bobForms.data) {
      data.project.bobFormIDs.forEach(function (f) {
        bobForms.data.forEach(function (t) {
          if (f === t.id) {
            output.push({
              value: f,
              text: t.title,
              type: 'BOB'
            });
          }
        });
      });
    }

    // add IC options if customer has IC images uploaded
    if (data && data.bookingCustomers && data.bookingCustomers.length > 0) {
      if (data.bookingCustomers.some(function (bc) {
        return _this6.checkICIsImage(bc.customer);
      })) {
        output.push({
          value: 'customer_identities',
          text: t('Purchasers’ IC')
        });
      }
    }

    _this6.setState({ printTemplates: output });
  };

  this.getPrintLink = function (data, form) {
    if (form.value === 'customer_identities') {
      return _config2.default.get('bookApiURL') + '/bookings/' + (data ? data.id : '') + '/identities/';
    }
    return _config2.default.get('bookApiURL') + '/bookings/' + (data ? data.id : '') + '/template/' + btoa(form.value) + '/print/';
  };

  this.checkAllowPrint = function (data) {
    var _props$auth = _this6.props.auth,
        isBranchLeader = _props$auth.isBranchLeader,
        isHeadquarters = _props$auth.isHeadquarters;

    var isCancelledStatus = data.statusID === 'cancelled_developer' || data.statusID === 'cancelled_availability';

    if (data.project.projectFormAccessibilities && data.project.projectFormAccessibilities.length > 0 && data.statusID || _this6.state.docxPrintTemplates && _this6.state.docxPrintTemplates.length && data.statusID) {
      if (data.project.hidePrintAgentStaff) {
        // If HidePrintAgentStaff is ticked && booking is under Reserved OR Cancelled status && isBranchLeader or HQ then allow print
        if ((data.statusID === 'reserved' || isCancelledStatus) && (isBranchLeader || isHeadquarters)) {
          return true;
        }
        // If HidePrintAgentStaff is ticked && booking is under Booked or Sold status then allow print for all
        if (data.statusID === 'booked' || data.statusID === 'sold_spa_signed') {
          return true;
        }
      } else {
        // If HidePrintAgent is not ticked and not PRS server, then allow print
        if (!isPRS) return true;
        // If HidePrint is not ticked, is PRS server && statusID is booked OR sold, then allow print
        if (data.project.projectFormAccessibilities && data.project.projectFormAccessibilities.length > 0 && (data.statusID && data.statusID === 'booked' || data.statusID && data.statusID === 'sold_spa_signed' || isCancelledStatus || _this6.hasAccess()) || _this6.state.docxPrintTemplates && _this6.state.docxPrintTemplates.length > 0 && (data.statusID && data.statusID === 'booked' || data.statusID && data.statusID === 'sold_spa_signed' || isCancelledStatus || _this6.hasAccess())) {
          return true;
        }
      }
    }
    return false;
  };

  this.handlePrintForm = function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(e, form, isPDF) {
      var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var data, query, bobQuery;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              data = _this6.state.data;

              if (!(form && form.value)) {
                _context6.next = 25;
                break;
              }

              query = isPDF ? '?pdf=true' : '';

              if (!(type === 'BOB')) {
                _context6.next = 7;
                break;
              }

              bobQuery = isPDF ? '?formID=' + form.value + '&pdf=true' : '?formID=' + form.value;

              window.open(_config2.default.get('bookApiURL') + '/bookings/' + (data ? data.id : '') + '/bob/' + bobQuery, '_blank');
              return _context6.abrupt('return');

            case 7:
              if (!(form.value === 'customer_identities')) {
                _context6.next = 10;
                break;
              }

              window.open(_config2.default.get('bookApiURL') + '/bookings/' + (data ? data.id : '') + '/identities/' + query, '_blank');
              return _context6.abrupt('return');

            case 10:
              if (!(type === 'docx')) {
                _context6.next = 24;
                break;
              }

              _this6.setState({ isPrinting: true });
              _context6.prev = 12;
              _context6.next = 15;
              return _this6.handlePrintDocxTemplate(form.value);

            case 15:
              _context6.next = 20;
              break;

            case 17:
              _context6.prev = 17;
              _context6.t0 = _context6['catch'](12);

              console.error('An error occurred during DOCX generation.', _context6.t0);

            case 20:
              _context6.prev = 20;

              _this6.setState({ isPrinting: false });
              return _context6.finish(20);

            case 23:
              return _context6.abrupt('return');

            case 24:
              window.open(_config2.default.get('bookApiURL') + '/bookings/' + (data ? data.id : '') + '/template/' + btoa(form.value) + '/print/' + query, '_blank');

            case 25:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this6, [[12, 17, 20, 23]]);
    }));

    return function (_x11, _x12, _x13) {
      return _ref9.apply(this, arguments);
    };
  }();

  this.handlePrintDocxTemplate = function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(form) {
      var data, store, res, message, blob, url, downloadLink, now, formattedDate, filename;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              data = _this6.state.data;
              store = _this6.context.store;
              // await this.setState({ loading: true });

              res = void 0;
              _context7.prev = 3;
              _context7.next = 6;
              return store.dispatch((0, _fetchM.fetchM)('/docxtemplates/templates/' + form + '/print/?bookingID=' + data.id, {
                credentials: 'include',
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }));

            case 6:
              res = _context7.sent;
              _context7.next = 20;
              break;

            case 9:
              _context7.prev = 9;
              _context7.t0 = _context7['catch'](3);

              // await this.setState({ loading: false });

              Bugsnag.notifyException(_context7.t0);

              if (!(_context7.t0.res && _context7.t0.res.status >= 400 && _context7.t0.res.status < 500)) {
                _context7.next = 18;
                break;
              }

              _context7.next = 15;
              return _context7.t0.res.text();

            case 15:
              message = _context7.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
              // return;
              throw _context7.t0;

            case 18:

              store.dispatch((0, _flash.flashErrorMessage)(_context7.t0));
              // return;
              throw _context7.t0;

            case 20:
              _context7.next = 22;
              return res.blob();

            case 22:
              blob = _context7.sent;


              // Create a temporary URL for the Blob
              url = window.URL.createObjectURL(blob);

              // Open the PDF in a new tab for preview

              window.open(url, '_blank');

              // Create a temporary link element to trigger the download
              downloadLink = document.createElement('a');

              downloadLink.href = url;

              // Set the filename for the downloaded file
              // Manually format the date components in local time
              now = (0, _momentTimezone2.default)().toDate();
              formattedDate = now.getFullYear() + String(now.getMonth() + 1).padStart(2, '0') + String(now.getDate()).padStart(2, '0') + String(now.getHours()).padStart(2, '0') + String(now.getMinutes()).padStart(2, '0') + String(now.getSeconds()).padStart(2, '0');
              filename = 'Booking-' + data.code + '-' + formattedDate + '.pdf';

              downloadLink.download = filename;

              // Trigger the download in the background
              document.body.appendChild(downloadLink);
              downloadLink.click();

              // Clean up by removing the temporary link and revoking the object URL
              document.body.removeChild(downloadLink);
              window.URL.revokeObjectURL(url);
              // await this.setState({ loading: false });

            case 35:
            case 'end':
              return _context7.stop();
          }
        }
      }, _callee7, _this6, [[3, 9]]);
    }));

    return function (_x15) {
      return _ref10.apply(this, arguments);
    };
  }();

  this.handlePrint = function () {
    _auth2.default.currentSession();
  };

  this.handleResize = function () {
    var state = {};
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    if (isMobile !== _this6.state.isMobile) {
      state.isMobile = isMobile;
      _this6.setState(_extends({}, state));
    }
  };

  this.handleTabChange = function (tabData) {
    if (!tabData) return;
    var tabID = tabData.id;
    var store = _this6.context.store;

    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    var tab = 'info';
    switch (tabID) {
      case 1:
        tab = 'info';
        break;
      case 2:
        tab = 'purchaser';
        break;
      case 3:
        tab = 'tracker';
        break;
      case 4:
        tab = 'payment_plan';
        break;
      case 5:
        tab = 'documents';
        break;
      case 6:
        tab = 'logs';
        break;
      case 7:
        tab = 'buyer';
        break;
      default:
        tab = 'info';
        break;
    }
    query.section = tab;
    delete query.page;
    _this6.setState({ tabID: tabID }, function () {
      if (tab === 'logs') {
        _this6.getBookingActivities(query);
      } else if (tabData.page) {
        delete query.section;
        store.dispatch((0, _reactRouterRedux.push)('/bookings/' + _this6.state.data.id + '/' + tabData.page + '?' + (0, _url.encodeSearch)(query)));
      } else {
        store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + _this6.state.data.id + '/?' + (0, _url.encodeSearch)(query)));
      }
    });
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.page = currentPage;
    _this6.setState({
      currentPage: currentPage
    });
    _this6.replaceQuery(query);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this6.replaceQuery(query);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    if (hasQuery) {
      _this6.replaceQuery(query, true);
    } else {
      _this6.setState({ search: '' });
    }
  };

  this.handleOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query[queryName] = value;
    _this6.replaceQuery(query, true);
  };

  this.handleOnOpenShareEmail = function (e) {
    e.preventDefault();
    _this6.setState({ showShareEmailModal: true });
  };

  this.handleOnCloseShareEmail = function (e) {
    e.preventDefault();
    _this6.setState({ showShareEmailModal: false });
  };

  this.handleProceedShareEmail = function (e, data) {
    e.preventDefault();
    _this6.sendEmail(data);
  };

  this.sortItems = [{
    text: 'Date Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'booking_activity.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Date Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'booking_activity.created_at',
    sortDirection: 'desc'
  }];
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Activities.mapStateToProps)(Activities));

/***/ }),
/* 2257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _checkChanges = __webpack_require__(61);

var _url = __webpack_require__(19);

var _promptMessages = __webpack_require__(43);

var _List = __webpack_require__(2262);

var _List2 = _interopRequireDefault(_List);

var _Loan = __webpack_require__(2263);

var _Loan2 = _interopRequireDefault(_Loan);

var _Payment = __webpack_require__(2277);

var _Payment2 = _interopRequireDefault(_Payment);

var _LPPSA = __webpack_require__(2261);

var _LPPSA2 = _interopRequireDefault(_LPPSA);

var _New = __webpack_require__(2267);

var _New2 = _interopRequireDefault(_New);

var _Overview = __webpack_require__(2276);

var _Overview2 = _interopRequireDefault(_Overview);

var _ManageOld = __webpack_require__(2266);

var _ManageOld2 = _interopRequireDefault(_ManageOld);

var _Activities = __webpack_require__(2256);

var _Activities2 = _interopRequireDefault(_Activities);

var _CreditCheck = __webpack_require__(2258);

var _CreditCheck2 = _interopRequireDefault(_CreditCheck);

var _Manage = __webpack_require__(2264);

var _Manage2 = _interopRequireDefault(_Manage);

var _HIMSBookingSync = __webpack_require__(2260);

var _HIMSBookingSync2 = _interopRequireDefault(_HIMSBookingSync);

var _customEdit = __webpack_require__(2280);

var _customEdit2 = _interopRequireDefault(_customEdit);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _UnitProgress = __webpack_require__(2278);

var _UnitProgress2 = _interopRequireDefault(_UnitProgress);

var _countries = __webpack_require__(60);

var _sharedMedia = __webpack_require__(2587);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import Overview from './OverviewOld';


var Bookings = function (_Component) {
  _inherits(Bookings, _Component);

  function Bookings(props) {
    _classCallCheck(this, Bookings);

    var _this = _possibleConstructorReturn(this, (Bookings.__proto__ || Object.getPrototypeOf(Bookings)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      token: null,
      loading: true,
      data: null,
      unitTiers: [],
      bookingPP: [],
      bookingFP: [],
      opportunity: undefined,
      documentData: undefined
    };
    return _this;
  }

  _createClass(Bookings, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.location.pathname.includes('credit_check/') && this.props.location.pathname.includes('customers/')) {
        this.fetchCustomer();
      } else if (this.props.location.pathname.includes('/new/') || this.props.params.id) {
        this.fetchBooking();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var pathname = nextProps.location.pathname;

      if (pathname.includes('/credit_check/' && pathname.includes('customers/')) || nextProps.params.customerID) {
        this.fetchCustomer();
      } else if (pathname.includes('/new/') || nextProps.params.id) {
        this.fetchBooking();
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchprojectBookingCustomFields',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(projectID) {
        var store, res, message, _message, projectBookingCustomFields;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + projectID + '/booking_custom_fields/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 21;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                if (!(_context.t0.res && _context.t0.res.status >= 399 && _context.t0.res.status < 500)) {
                  _context.next = 17;
                  break;
                }

                _context.next = 15;
                return _context.t0.res.text();

              case 15:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 17:
                _context.next = 19;
                return this.setLoading(false);

              case 19:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));

              case 21:
                if (res.ok) {
                  _context.next = 29;
                  break;
                }

                _context.next = 24;
                return res.text();

              case 24:
                _message = _context.sent;
                _context.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 27:
                _context.next = 34;
                break;

              case 29:
                _context.next = 31;
                return res.json();

              case 31:
                projectBookingCustomFields = _context.sent;
                _context.next = 34;
                return this.setComponentState({
                  projectBookingCustomFields: projectBookingCustomFields
                });

              case 34:
                _context.next = 36;
                return this.setLoading(false);

              case 36:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchprojectBookingCustomFields(_x3) {
        return _ref.apply(this, arguments);
      }

      return fetchprojectBookingCustomFields;
    }()
  }, {
    key: 'fetchBooking',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, auth, query, url, res, message, _message2, token, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                auth = this.props.auth;
                query = (0, _url.decodeSearch)(this.props.location.search);
                url = '/bookings/';

                if (this.props.params.id) {
                  url += this.props.params.id + '/';
                }
                if (this.props.location.pathname.includes('/new/')) {
                  query.token = 'true';
                  query.limit = 1;
                }
                res = void 0;
                _context2.prev = 9;
                _context2.next = 12;
                return store.dispatch((0, _fetchM.fetchM)(url + '?' + (0, _url.encodeSearch)(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context2.sent;
                _context2.next = 26;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](9);

                if (!(_context2.t0.res && _context2.t0.res.status >= 399 && _context2.t0.res.status < 500)) {
                  _context2.next = 22;
                  break;
                }

                _context2.next = 20;
                return _context2.t0.res.text();

              case 20:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 22:
                _context2.next = 24;
                return this.setLoading(false);

              case 24:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));

              case 26:
                if (res.ok) {
                  _context2.next = 34;
                  break;
                }

                _context2.next = 29;
                return res.text();

              case 29:
                _message2 = _context2.sent;
                _context2.next = 32;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message2 }));

              case 32:
                _context2.next = 55;
                break;

              case 34:
                token = res.headers.get('X-Csrf-Token');
                data = null;

                if (!this.props.params.id) {
                  _context2.next = 53;
                  break;
                }

                _context2.next = 39;
                return res.json();

              case 39:
                data = _context2.sent;
                _context2.next = 42;
                return this.fetchprojectBookingCustomFields(data.project.id);

              case 42:
                _context2.next = 44;
                return this.fetchUnitTierPricing(data);

              case 44:
                if (!(auth.isAdminBasic || auth.isSuperAdmin || auth.isAdmin || auth.isDeveloperSupervisor || auth.isDeveloperSalesManager || auth.isDeveloperSalesAdmin || auth.isHeadquarters)) {
                  _context2.next = 47;
                  break;
                }

                _context2.next = 47;
                return Promise.all([this.fetchBookingPP(data.id), this.fetchBookingFP(data.id)]);

              case 47:
                if (!((0, _countries.isCountryVietnam)(auth.company && auth.company.countryCode) && data.leadOpportunityID)) {
                  _context2.next = 50;
                  break;
                }

                _context2.next = 50;
                return this.fetchOpportunity(data.leadOpportunityID);

              case 50:
                if (!(0, _countries.isCountryVietnam)(auth.company && auth.company.countryCode)) {
                  _context2.next = 53;
                  break;
                }

                _context2.next = 53;
                return this.fetchDocument(data);

              case 53:
                _context2.next = 55;
                return this.setComponentState({
                  token: token,
                  data: data
                });

              case 55:
                _context2.next = 57;
                return this.setLoading(false);

              case 57:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[9, 15]]);
      }));

      function fetchBooking() {
        return _ref2.apply(this, arguments);
      }

      return fetchBooking;
    }()
  }, {
    key: 'fetchBookingPP',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(bookingID) {
        var store, res, message, bookingPP;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                store = this.context.store;
                res = [];
                _context3.next = 4;
                return this.setLoading(true);

              case 4:
                _context3.prev = 4;
                _context3.next = 7;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/bookings/' + bookingID + '/available_package_pricings/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context3.sent;
                _context3.next = 23;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](4);
                _context3.next = 14;
                return this.setLoading(false);

              case 14:
                Bugsnag.notifyException(_context3.t0);

                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 21;
                  break;
                }

                _context3.next = 18;
                return _context3.t0.res.text();

              case 18:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context3.abrupt('return');

              case 23:
                _context3.next = 25;
                return this.setLoading(false);

              case 25:
                _context3.next = 27;
                return res.json();

              case 27:
                bookingPP = _context3.sent;
                _context3.next = 30;
                return this.setComponentState({ bookingPP: bookingPP });

              case 30:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 10]]);
      }));

      function fetchBookingPP(_x4) {
        return _ref3.apply(this, arguments);
      }

      return fetchBookingPP;
    }()
  }, {
    key: 'fetchBookingFP',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(bookingID) {
        var store, res, message, bookingFP;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                store = this.context.store;
                res = [];
                _context4.next = 4;
                return this.setLoading(true);

              case 4:
                _context4.prev = 4;
                _context4.next = 7;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/bookings/' + bookingID + '/fee_packages/available/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context4.sent;
                _context4.next = 23;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](4);
                _context4.next = 14;
                return this.setLoading(false);

              case 14:
                Bugsnag.notifyException(_context4.t0);

                if (!(_context4.t0.res && _context4.t0.res.status >= 400 && _context4.t0.res.status < 500)) {
                  _context4.next = 21;
                  break;
                }

                _context4.next = 18;
                return _context4.t0.res.text();

              case 18:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context4.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context4.abrupt('return');

              case 23:
                _context4.next = 25;
                return this.setLoading(false);

              case 25:
                _context4.next = 27;
                return res.json();

              case 27:
                bookingFP = _context4.sent;
                _context4.next = 30;
                return this.setComponentState({ bookingFP: bookingFP });

              case 30:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 10]]);
      }));

      function fetchBookingFP(_x5) {
        return _ref4.apply(this, arguments);
      }

      return fetchBookingFP;
    }()
  }, {
    key: 'fetchCustomer',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var store, res, message, _message3, token, data;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context5.prev = 4;
                _context5.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.params.customerID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context5.sent;
                _context5.next = 23;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](4);

                if (!(_context5.t0.res && _context5.t0.res.status >= 399 && _context5.t0.res.status < 500)) {
                  _context5.next = 17;
                  break;
                }

                _context5.next = 15;
                return _context5.t0.res.text();

              case 15:
                message = _context5.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 17:
                _context5.next = 19;
                return this.setLoading(false);

              case 19:
                Bugsnag.notifyException(_context5.t0);
                _context5.next = 22;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 22:
                return _context5.abrupt('return');

              case 23:
                if (res.ok) {
                  _context5.next = 31;
                  break;
                }

                _context5.next = 26;
                return res.text();

              case 26:
                _message3 = _context5.sent;
                _context5.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message3 }));

              case 29:
                _context5.next = 37;
                break;

              case 31:
                token = res.headers.get('X-Csrf-Token');
                _context5.next = 34;
                return res.json();

              case 34:
                data = _context5.sent;
                _context5.next = 37;
                return this.setComponentState({
                  token: token,
                  data: data
                });

              case 37:
                _context5.next = 39;
                return this.setLoading(false);

              case 39:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[4, 10]]);
      }));

      function fetchCustomer() {
        return _ref5.apply(this, arguments);
      }

      return fetchCustomer;
    }()
  }, {
    key: 'fetchUnitTierPricing',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(data) {
        var projectID, projectUnitID, store, res, message, unitTiers;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                projectID = data.projectID, projectUnitID = data.projectUnitID;
                _context6.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                res = '';
                _context6.prev = 5;
                _context6.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + projectID + '/units/' + projectUnitID + '/pricings/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context6.sent;
                _context6.next = 24;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6['catch'](5);
                _context6.next = 15;
                return this.setLoading(false);

              case 15:
                if (!(_context6.t0.res && _context6.t0.res.status >= 400 && _context6.t0.res.status < 500)) {
                  _context6.next = 21;
                  break;
                }

                _context6.next = 18;
                return _context6.t0.res.text();

              case 18:
                message = _context6.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context6.abrupt('return');

              case 21:
                Bugsnag.notifyException(_context6.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context6.abrupt('return');

              case 24:
                _context6.next = 26;
                return res.json();

              case 26:
                unitTiers = _context6.sent;
                _context6.next = 29;
                return this.setComponentState({ unitTiers: unitTiers });

              case 29:
                _context6.next = 31;
                return this.setLoading(false);

              case 31:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[5, 11]]);
      }));

      function fetchUnitTierPricing(_x6) {
        return _ref6.apply(this, arguments);
      }

      return fetchUnitTierPricing;
    }()
    // CPI-974 (E): GET /opportunity/{id}/, read-only - only used to detect/display the linked CRM
    // record (canShowVNCancel, srCode); the cancel action itself never writes to it.

  }, {
    key: 'fetchOpportunity',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(opportunityID) {
        var store, res, opportunity;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                store = this.context.store;

                if (opportunityID) {
                  _context7.next = 3;
                  break;
                }

                return _context7.abrupt('return');

              case 3:
                _context7.prev = 3;
                _context7.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/opportunity/' + opportunityID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  ignoreNotFound: true,
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 6:
                res = _context7.sent;

                if (!(res && res.ok)) {
                  _context7.next = 13;
                  break;
                }

                _context7.next = 10;
                return res.json();

              case 10:
                opportunity = _context7.sent;
                _context7.next = 13;
                return this.setComponentState({
                  opportunity: opportunity
                });

              case 13:
                _context7.next = 18;
                break;

              case 15:
                _context7.prev = 15;
                _context7.t0 = _context7['catch'](3);

                Bugsnag.notifyException(_context7.t0);

              case 18:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[3, 15]]);
      }));

      function fetchOpportunity(_x7) {
        return _ref7.apply(this, arguments);
      }

      return fetchOpportunity;
    }()
    // Sales Overview cancel action: writes only to the booking (pending_cancellation + the reason),
    // never to the CRM opportunity - Sales and Booking cancellation are deliberately decoupled.

  }, {
    key: 'fetchDocument',

    // CPI-1249 (A20/A21): one document set per sale - filed against the CRM opportunity when the
    // booking came from one, and against the booking itself when it did not.
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var booking = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        var store, data, _resolveSharedMediaPa, parentType, parentID, res, documentData;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                store = this.context.store;
                data = booking || this.state.data;
                _resolveSharedMediaPa = (0, _sharedMedia.resolveSharedMediaParent)(data, this.props.params.id), parentType = _resolveSharedMediaPa.parentType, parentID = _resolveSharedMediaPa.parentID;

                // A blank parent_id would return every active shared media in the database. Never ask.

                if (parentID) {
                  _context8.next = 5;
                  break;
                }

                return _context8.abrupt('return');

              case 5:
                _context8.prev = 5;
                _context8.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/shared_medias/?parent_type=' + parentType + '&parent_id=' + parentID, {
                  method: 'GET',
                  credentials: 'include',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context8.sent;

                if (!res.ok) {
                  _context8.next = 15;
                  break;
                }

                _context8.next = 12;
                return res.json();

              case 12:
                documentData = _context8.sent;
                _context8.next = 15;
                return this.setComponentState({ documentData: documentData || [] });

              case 15:
                _context8.next = 20;
                break;

              case 17:
                _context8.prev = 17;
                _context8.t0 = _context8['catch'](5);

                Bugsnag.notifyException(_context8.t0);

              case 20:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[5, 17]]);
      }));

      function fetchDocument() {
        return _ref8.apply(this, arguments);
      }

      return fetchDocument;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this4 = this;

      var childProp = {
        token: this.state.token,
        loading: this.state.loading,
        fetchNewBooking: this.handleFetchNewBooking
      };
      if (this.props.params.id) {
        childProp.data = this.state.data;
        childProp.projectBookingCustomFields = this.state.projectBookingCustomFields;
        childProp.unitTiers = this.state.unitTiers;
        childProp.routeParamsID = this.props.params.id || '';
        childProp.bookingPP = this.state.bookingPP || [];
        childProp.bookingFP = this.state.bookingFP || [];
        childProp.opportunity = this.state.opportunity;
        var auth = this.props.auth;

        if ((0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode)) {
          var parent = (0, _sharedMedia.resolveSharedMediaParent)(this.state.data, this.props.params.id);
          childProp.documentData = this.state.documentData;
          childProp.fetchDocument = function () {
            return _this4.fetchDocument();
          };
          childProp.parentType = parent.parentType;
          childProp.parentID = parent.parentID;
          childProp.onRequestBookingCancellation = this.handleRequestBookingCancellation;
        }
      }
      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, childProp);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Bookings;
}(_react.Component);

Bookings.propTypes = {
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    }),
    isDeveloperSupervisor: _propTypes2.default.bool,
    isDeveloperSalesManager: _propTypes2.default.bool,
    isDeveloperSalesAdmin: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isAdmin: _propTypes2.default.bool
  }),
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    customerID: _propTypes2.default.string
  }),
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  })
};
Bookings.contextTypes = {
  store: _propTypes2.default.object
};

Bookings.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

Bookings.List = _List2.default;
Bookings.Loan = _Loan2.default;
Bookings.Payment = _Payment2.default;
Bookings.LPPSA = _LPPSA2.default;
Bookings.New = (0, _checkChanges.checkChanges)(_New2.default, { message: _promptMessages.NEW_BOOKING_PROMPT });
Bookings.Overview = (0, _checkChanges.checkChanges)(_Overview2.default);
Bookings.ManageBookings = _Manage2.default;
Bookings.Manage = _ManageOld2.default;
Bookings.Activities = _Activities2.default;
Bookings.CreditCheck = (0, _checkChanges.checkChanges)(_CreditCheck2.default);
Bookings.HIMSBookingSync = _HIMSBookingSync2.default;
Bookings.UnitProgress = _UnitProgress2.default;
Bookings.CustomEdit = _customEdit2.default;

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.allowedPath = function (props) {
    var pathname = props.location.pathname;

    if (pathname.includes('/manage/')) {
      return false;
    }
    return true;
  };

  this.handleRequestBookingCancellation = function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
      var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var cancellationType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      var store, _state, data, token, res, errorText;

      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              store = _this5.context.store;
              _state = _this5.state, data = _state.data, token = _state.token;

              if (!(!data || !data.id)) {
                _context9.next = 4;
                break;
              }

              return _context9.abrupt('return');

            case 4:
              _context9.prev = 4;
              _context9.next = 7;
              return _this5.setLoading(true);

            case 7:
              _context9.next = 9;
              return store.dispatch((0, _fetchM.fetchM)('/bookings/' + data.id + '/cancellation_request/', {
                method: 'PUT',
                credentials: 'include',
                headers: {
                  'Content-Type': 'application/json',
                  'X-CSRF-Token': token
                },
                body: JSON.stringify({
                  srCancellationReason: reason || '-',
                  srCancellationType: cancellationType
                })
              }));

            case 9:
              res = _context9.sent;

              if (!res.ok) {
                _context9.next = 15;
                break;
              }

              _context9.next = 13;
              return _this5.fetchBooking();

            case 13:
              _context9.next = 19;
              break;

            case 15:
              _context9.next = 17;
              return res.text();

            case 17:
              errorText = _context9.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: errorText }));

            case 19:
              _context9.next = 24;
              break;

            case 21:
              _context9.prev = 21;
              _context9.t0 = _context9['catch'](4);

              Bugsnag.notifyException(_context9.t0);

            case 24:
              _context9.prev = 24;
              _context9.next = 27;
              return _this5.setLoading(false);

            case 27:
              return _context9.finish(24);

            case 28:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this5, [[4, 21, 24, 28]]);
    }));

    return function () {
      return _ref9.apply(this, arguments);
    };
  }();

  this.handleFetchNewBooking = function (callBack) {
    return new Promise(function (res) {
      _this5.fetchBooking().then(function () {
        res();
        if (callBack) callBack();
      });
    });
  };
};

exports.default = (0, _reactRedux.connect)(Bookings.mapStateToProps)(Bookings);

/***/ }),
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _reactRedux = __webpack_require__(9);

var _NewCreditCheck = __webpack_require__(1055);

var _NewCreditCheck2 = _interopRequireDefault(_NewCreditCheck);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // import React, { Component } from 'react';


var CreditCheck = function (_Component) {
  _inherits(CreditCheck, _Component);

  function CreditCheck(props) {
    _classCallCheck(this, CreditCheck);

    var _this = _possibleConstructorReturn(this, (CreditCheck.__proto__ || Object.getPrototypeOf(CreditCheck)).call(this, props));

    _initialiseProps.call(_this);

    var state = CreditCheck.getPropsToState(props);
    _this.state = _extends({}, state, {
      booking: [],
      data: [],
      hasChanges: false
    });
    return _this;
  }

  _createClass(CreditCheck, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchBooking();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = CreditCheck.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this2.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'fetchBooking',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var store, url, res, message, json, newBooking;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(false);

              case 2:
                store = this.context.store;
                url = '/bookings/';

                if (this.props.params.id) {
                  url += this.props.params.id + '/';
                }
                res = void 0;
                _context.prev = 6;
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchM)(url, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context.sent;
                _context.next = 26;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                if (!(_context.t0.res && _context.t0.res.status >= 399 && _context.t0.res.status < 500)) {
                  _context.next = 19;
                  break;
                }

                _context.next = 17;
                return _context.t0.res.text();

              case 17:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 19:
                _context.next = 21;
                return this.setLoading(false);

              case 21:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                _context.next = 25;
                return this.setLoading(false);

              case 25:
                return _context.abrupt('return');

              case 26:
                _context.next = 28;
                return res.json();

              case 28:
                json = _context.sent;

                if (json) {
                  newBooking = Object.assign({}, json || {});

                  this.setState({ booking: newBooking }, function () {
                    return _this3.fetchCustomer();
                  });
                }
                _context.next = 32;
                return this.setLoading(false);

              case 32:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));

      function fetchBooking() {
        return _ref.apply(this, arguments);
      }

      return fetchBooking;
    }()
  }, {
    key: 'fetchCustomer',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, res, json, newData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context2.prev = 4;
                _context2.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.state.booking.customerID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context2.sent;
                _context2.next = 18;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](4);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context2.next = 17;
                return this.setLoading(false);

              case 17:
                return _context2.abrupt('return');

              case 18:
                _context2.next = 20;
                return res.json();

              case 20:
                json = _context2.sent;

                if (json) {
                  newData = Object.assign({}, json || {});

                  this.setState({ data: newData });
                }
                _context2.next = 24;
                return this.setLoading(false);

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10]]);
      }));

      function fetchCustomer() {
        return _ref2.apply(this, arguments);
      }

      return fetchCustomer;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          booking = _state.booking,
          data = _state.data;
      var location = this.props.location;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              booking.length !== 0 && data.length !== 0 ? _react2.default.createElement(_NewCreditCheck2.default, {
                newHeader: 'CUSTOMER ASSESSMENT',
                auth: this.props.auth,
                bookingID: booking.id,
                data: data,
                pathCheck: this.pathCheck(this.props),
                loading: this.state.loading,
                setLoading: this.setLoading,
                customerID: data.id || '',
                onChange: this.handleOnCheck,
                icFrontDocumentID: data.icFrontDocumentID || '',
                icFrontDocument: data.icFrontDocument || null,
                icBackDocumentID: data.icBackDocumentID || '',
                icBackDocument: data.icBackDocument || null,
                incomeID: data.incomeID || '',
                income: data.income || null,
                customerCreditReport: data.customerCreditReport || null,
                customerCreditReports: data.customerCreditReports || [],
                customerDetail: data.customerDetail || null,
                refetch: this.handleRefetch,
                identityTypeID: data.identityTypeID || 0,
                identity: data.identity || '',
                location: location
              }) : null
            )
          )
        )
      );
    }
  }]);

  return CreditCheck;
}(_react.Component);

CreditCheck.contextTypes = {
  store: _propTypes2.default.object
};
CreditCheck.propTypes = {
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  onCheck: _propTypes2.default.func
};

CreditCheck.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

CreditCheck.getPropsToState = function (props) {
  var loading = props.loading;
  return {
    loading: loading
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this4.setState({ loading: loading }, res);
    });
  };

  this.handleOnCheck = function () {
    var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (_this4.props.onCheck) {
      _this4.props.onCheck(hasChanges);
    }
  };

  this.handleRefetch = function () {
    var store = _this4.context.store;

    store.dispatch((0, _reactRouterRedux.push)('/bookings/' + _this4.props.params.id + '/credit_check/'));
  };

  this.pathCheck = function (props) {
    var pathname = props.location.pathname;

    if (pathname.includes('/bookings/')) {
      return true;
    }
    return false;
  };
};

exports.default = (0, _reactRedux.connect)(CreditCheck.mapStateToProps)(CreditCheck);

/***/ }),
/* 2259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _CRM_IDENTITY_VALUE_F;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _webValidations = __webpack_require__(23);

var _bookQuery = __webpack_require__(990);

var _addressSettings = __webpack_require__(152);

var _appConfig = __webpack_require__(379);

var _customOptions = __webpack_require__(312);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _PhoneInput = __webpack_require__(104);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

var _InputBirthdate = __webpack_require__(220);

var _InputBirthdate2 = _interopRequireDefault(_InputBirthdate);

var _CountdownAdvance = __webpack_require__(559);

var _CountdownAdvance2 = _interopRequireDefault(_CountdownAdvance);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _SearchStaff = __webpack_require__(388);

var _SearchStaff2 = _interopRequireDefault(_SearchStaff);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _intlCallCodes = __webpack_require__(116);

var _intlCallCodes2 = _interopRequireDefault(_intlCallCodes);

var _states = __webpack_require__(144);

var _states2 = _interopRequireDefault(_states);

var _race = __webpack_require__(324);

var _maritalStatus = __webpack_require__(320);

var _relationshipType = __webpack_require__(1046);

var _gender = __webpack_require__(319);

var _bumi = __webpack_require__(318);

var _countries = __webpack_require__(60);

var _customerTitles = __webpack_require__(390);

var _customerTitles2 = _interopRequireDefault(_customerTitles);

var _firstTimeBuyer = __webpack_require__(1043);

var _firstTimeBuyer2 = _interopRequireDefault(_firstTimeBuyer);

var _defaultBookingFields = __webpack_require__(391);

var _translation = __webpack_require__(4);

var _regex = __webpack_require__(143);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _routes = __webpack_require__(403);

var _dateFromIC = __webpack_require__(593);

var _dateFromIC2 = _interopRequireDefault(_dateFromIC);

var _amount = __webpack_require__(87);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _BookingSwapUnit = __webpack_require__(2512);

var _BookingSwapUnit2 = _interopRequireDefault(_BookingSwapUnit);

var _unitHold = __webpack_require__(1095);

var _Input = __webpack_require__(1003);

var _Input2 = _interopRequireDefault(_Input);

var _TinFieldInput = __webpack_require__(192);

var _TinFieldInput2 = _interopRequireDefault(_TinFieldInput);

var _BookingSteppers = __webpack_require__(557);

var _BookingSteppers2 = _interopRequireDefault(_BookingSteppers);

var _SearchHimsDistricts = __webpack_require__(568);

var _SearchHimsDistricts2 = _interopRequireDefault(_SearchHimsDistricts);

var _SearchHimsPostcodes = __webpack_require__(569);

var _SearchHimsPostcodes2 = _interopRequireDefault(_SearchHimsPostcodes);

var _bookQuery2 = __webpack_require__(2572);

var _storage = __webpack_require__(44);

var _phone = __webpack_require__(146);

var _companies = __webpack_require__(88);

var _intlFlagCodes = __webpack_require__(141);

var _intlFlagCodes2 = _interopRequireDefault(_intlFlagCodes);

var _phoneValidationPresets = __webpack_require__(996);

var _identityPresets = __webpack_require__(995);

var _identityTypes = __webpack_require__(174);

var _translation2 = __webpack_require__(64);

var _financeSource = __webpack_require__(402);

var _vietnam = __webpack_require__(40);

var _preSalesLaunch = __webpack_require__(269);

var _vietnamPricing = __webpack_require__(197);

var _crmIdentityMedia = __webpack_require__(2577);

var _currencyMinor = __webpack_require__(326);

var _autofillTypes = __webpack_require__(1038);

var _srRoleAccess = __webpack_require__(196);

var _tin = __webpack_require__(155);

var _defaultIdentityTypeOpts = __webpack_require__(154);

var _gift_blue = __webpack_require__(1597);

var _gift_blue2 = _interopRequireDefault(_gift_blue);

var _RegexDropdownPicker = __webpack_require__(387);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint-disable react/sort-comp */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/jsx-no-target-blank */


var isPRS = _config2.default.get('prs');
var isPackagePricingRequired = _config2.default.get('isPackagePricingRequired');

// CPI-977 S4/S6: the VN price panel is dong-only, matching the CRM payment tab's formatter.
var VN_CURRENCY_CODE = 'VND';

var renderPackagePricingDescription = function renderPackagePricingDescription(description) {
  if (!description) {
    return '';
  }
  if (!description.includes('\n')) {
    return description;
  }
  return description.split('\n').map(function (line, idx) {
    return _react2.default.createElement(
      'span',
      { key: idx },
      line,
      _react2.default.createElement('br', null)
    );
  });
};

// CPI-974 (D23): CRM identity_type -> Showroom identityTypeID. The CRM's 3 (Enterprise
// Registration Number) is Showroom's 4; an unmapped type leaves the field blank.
var CRM_IDENTITY_TYPE_MAP = {
  1: _defaultIdentityTypeOpts.IDENTITY_TYPE_NRIC, // CCCD
  2: _defaultIdentityTypeOpts.IDENTITY_TYPE_PASSPORT, // Passport
  3: _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN // Enterprise Registration Number / Certificate
};

var CRM_IDENTITY_VALUE_FIELD = (_CRM_IDENTITY_VALUE_F = {}, _defineProperty(_CRM_IDENTITY_VALUE_F, _defaultIdentityTypeOpts.IDENTITY_TYPE_NRIC, 'cccd'), _defineProperty(_CRM_IDENTITY_VALUE_F, _defaultIdentityTypeOpts.IDENTITY_TYPE_PASSPORT, 'passport'), _defineProperty(_CRM_IDENTITY_VALUE_F, _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN, 'other_identity'), _CRM_IDENTITY_VALUE_F);

var CRM_OPPORTUNITY_APPROVED = 'approved';

var BookingForm = function (_Component) {
  _inherits(BookingForm, _Component);

  function BookingForm(props) {
    _classCallCheck(this, BookingForm);

    var _this = _possibleConstructorReturn(this, (BookingForm.__proto__ || Object.getPrototypeOf(BookingForm)).call(this, props));

    _initialiseProps.call(_this);

    _this.identityInputRef = _react2.default.createRef();
    var state = BookingForm.getPropsToState(props);
    _this.state = _extends({
      identityLock: false,
      mobileLock: false,
      isLaunchMode: false,
      reservedTimeoutExpireAt: null,
      modalReservationIsOpen: false,
      allowCustomBookingStatus: false,
      allowStaffEditBookingSPAValue: false,
      allowAgentEditBookingSPAValue: false,
      allowAgentAutofillPurchaserDetails: false,
      showCountdown: true,
      showSwapUnit: false,
      showLaunchModeMulti: false,
      launchModeMultiErr: '',
      heldUnit: null, // CPI-1377: the unit named by the one-unit refusal
      bookingSubmitted: false, // CPI-1377: a saved reservation owns its unit, leaving never releases it
      manualSwap: false,
      projectBranchOwnerID: 0,
      projectUnitSwapError: false,
      showNoAutofill: false,
      fetchDataErrorMessage: '',
      showPurchaserExtraFields: false,
      bookingCustomFields: [],
      projectUnitPricings: [],
      defaultBumiProjectPricingID: '',
      defaultProjectPricingID: '',
      pricingTiers: [],
      packagePricings: [],
      feePackages: [],
      paymentMethods: [],
      searchUsersData: [],
      searchUserValue: '',
      projectAllowLinkBuyerApp: false,
      autofillOptions: [],
      isPreviewing: false,
      project: null,
      financeSourceOpts: (0, _vietnam.paymentMethodOpts)(props.auth),
      // flag to enable/disable tin searched using the lhdn api
      tinFound: false,
      screenWidth: window.innerWidth,
      isDisableBaseSellingPriceSelection: false,
      // CPI-974 (A): Booking ID (CRM sr_code) lookup; srOpportunity stays null outside Vietnam.
      srCode: '',
      srSearching: false,
      srOpportunity: null,
      srError: '',
      // CPI-1435: the CRM booking's agent could not become Agent Assigned (none, or no agency).
      vnAgentError: '',
      // The project a rejected Booking ID actually belongs to, so the notice can name it.
      srErrorProjectName: '',
      srIdentityTypeUnmapped: false,
      srRelatedBookingCustomers: [],
      // The identity the opportunity supplied, kept so a CCCD the agent types over it can be
      // recognised as a deliberate swap to a different buyer rather than an incidental edit.
      srOriginalIdentity: '',
      // The CRM answer for a swapped-in buyer: null before any lookup, then 'searching', 'found'
      // (with vnCRMCustomer) or 'not_found'.
      vnCRMLookup: null,
      vnCRMCustomer: null,
      // The CCCD whose "not in the CRM" answer already emptied the purchaser fields, so typing
      // on does not wipe what the agent is filling in.
      vnCRMClearedFor: '',
      // CPI-977 D-C4/D-C5: server-priced totals per scheme, and whether the last preview failed.
      vnLivePackageTotals: {},
      vnPreviewFailed: false
    }, state);
    _this.srCodeQueryConsumed = false;
    _this.validation = {
      emergencyContactMobilePrefix: (0, _react.createRef)(),
      emergencyContactMobile: (0, _react.createRef)(),
      identity: (0, _react.createRef)(),
      taxIdentificationNo: (0, _react.createRef)(),
      country: (0, _react.createRef)(),
      prsID: (0, _react.createRef)(),
      title: (0, _react.createRef)(),
      name: (0, _react.createRef)(),
      preferredName: (0, _react.createRef)(),
      email: (0, _react.createRef)(),
      mobilePrefix: (0, _react.createRef)(),
      mobile: (0, _react.createRef)(),
      phone: (0, _react.createRef)(),
      spaValue: (0, _react.createRef)(),
      unitPackagePricingID: (0, _react.createRef)(),
      paymentMethodID: (0, _react.createRef)(),
      firstTimeBuyer: (0, _react.createRef)(),
      srpLoan: (0, _react.createRef)(),
      raceOther: (0, _react.createRef)(),
      himsKodDaerah: (0, _react.createRef)(),
      himsKodPoskod: (0, _react.createRef)(),
      sstRegistrationNo: (0, _react.createRef)(),
      citizenship: (0, _react.createRef)()
    };

    // add validateRef for all enabled address settings
    var enabledAddressSettings = props.addressSettings.data.filter(function (as) {
      return as.enabled;
    });
    if (enabledAddressSettings && enabledAddressSettings.length > 0) {
      enabledAddressSettings.forEach(function (as) {
        var key = _lodash2.default.camelCase(as.columnName);
        _this.validation[key] = (0, _react.createRef)();
      });
    }
    return _this;
  }

  _createClass(BookingForm, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;

      store.dispatch((0, _addressSettings.fetchAddressSettings)());
      store.dispatch((0, _identityPresets.fetchIdentityPresets)());
      store.dispatch((0, _phoneValidationPresets.fetchPhoneValidationPresets)());
      store.dispatch((0, _appConfig.fetchAppConfig)());
      store.dispatch((0, _customOptions.fetchCustomOptions)());
    }
  }, {
    key: 'componentDidMount',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // CPI-1377: leaving the Reserve screen inside the app while holding an unsaved unit asks first,
                // then releases the hold. Refresh and tab close are not covered on purpose: the hold and its
                // timer carry on until it runs out.
                if (this.props.registerLeaveGuard) this.props.registerLeaveGuard(this.buildLeaveGuard());

                if (!(this.state.crmOpportunityID && this.state.projectUnitID && this.state.projectID)) {
                  _context.next = 10;
                  break;
                }

                _context.next = 4;
                return this.setLoading('isFetching', true);

              case 4:
                _context.next = 6;
                return this.getProjectUnit(this.state.projectID, this.state.projectUnitID, true, true);

              case 6:
                _context.next = 8;
                return this.getVNMarketplaceOpportunity();

              case 8:
                _context.next = 24;
                break;

              case 10:
                if (!this.state.opportunityID) {
                  _context.next = 15;
                  break;
                }

                _context.next = 13;
                return this.getOpportunity(this.state.opportunityID);

              case 13:
                _context.next = 24;
                break;

              case 15:
                if (!(this.state.projectUnitID && this.state.projectID)) {
                  _context.next = 22;
                  break;
                }

                _context.next = 18;
                return this.setLoading('isFetching', true);

              case 18:
                _context.next = 20;
                return this.getProjectUnit(this.state.projectID, this.state.projectUnitID, true, true);

              case 20:
                _context.next = 24;
                break;

              case 22:
                store = this.context.store;

                store.dispatch((0, _reactRouterRedux.replace)('/bookings/'));

              case 24:
                this.autofillFromBookQuery(this.props.bookQuery.data);
                this.consumeSRCodeQuery();
                window.addEventListener('resize', this.handleResize);

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var _state = this.state,
          identityTypeOpts = _state.identityTypeOpts,
          identityPresets = _state.identityPresets,
          isCRMEnabled = _state.isCRMEnabled,
          phoneValidationPresets = _state.phoneValidationPresets;

      var newIdentityTypeOpts = [].concat(_toConsumableArray(identityTypeOpts));
      var newIdentityPresets = [].concat(_toConsumableArray(identityPresets));
      var newPhoneValidationPresets = [].concat(_toConsumableArray(phoneValidationPresets));
      var newIsCRMEnabled = isCRMEnabled;
      if (nextProps.identityPresets !== this.props.identityPresets) {
        var auth = this.props.auth;
        newIdentityTypeOpts = (0, _identityTypes.getIdentityTypeOpts)(auth, nextProps.identityPresets.data);
        newIdentityPresets = nextProps.identityPresets.data;
      }
      if (nextProps.appConfig !== this.props.appConfig) {
        newIsCRMEnabled = nextProps.appConfig && nextProps.appConfig.data && nextProps.appConfig.data.leadV2IsEnabled;
      }
      if (nextProps.phoneValidationPresets !== this.props.phoneValidationPresets) {
        newPhoneValidationPresets = nextProps.phoneValidationPresets.data;
      }
      this.setState({
        identityTypeOpts: newIdentityTypeOpts,
        identityPresets: newIdentityPresets,
        isCRMEnabled: newIsCRMEnabled,
        phoneValidationPresets: newPhoneValidationPresets
      }, function () {
        return _this2.consumeSRCodeQuery(nextProps);
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.setTimer) {
        clearTimeout(this.setTimer);
      }
      window.removeEventListener('resize', this.handleResize);
      if (this.props.registerLeaveGuard) this.props.registerLeaveGuard(null);
    }
    // buildLeaveGuard is what checkChanges asks before an in-app navigation leaves this screen.

  }, {
    key: 'buildLeaveGuard',
    value: function buildLeaveGuard() {
      var _this3 = this;

      return {
        // showCountdown turns false when the timer runs out, just before the screen leaves by itself
        shouldBlock: function shouldBlock() {
          return !_this3.holdReleasedOnLeave && _this3.state.showCountdown !== false && (0, _unitHold.shouldReleaseHoldOnLeave)(_this3.state);
        },
        header: function header() {
          return _this3.props.t('Release unit', { ns: _translation.TRANSLATION_FILES.translation });
        },
        message: function message() {
          return _this3.props.t('Leave and release unit {{reference}}? Unsaved changes will be lost.', {
            reference: _this3.state.projectUnitDetails && _this3.state.projectUnitDetails.reference || '',
            ns: _translation.TRANSLATION_FILES.translation
          });
        },
        onConfirm: function onConfirm() {
          return _this3.releaseHoldOnLeave();
        }
      };
    }
    // releaseHoldOnLeave is the leave guard's confirm step: release this unit's hold, then let the
    // navigation go ahead. keepalive lets the request finish after the screen is gone, and a failed
    // release is no reason to keep the agent here: the hold still runs out on its own.

  }, {
    key: 'releaseHoldOnLeave',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.holdReleasedOnLeave = true;
                store = this.context.store;
                _context2.prev = 2;
                _context2.next = 5;
                return store.dispatch((0, _fetchM.fetchM)((0, _unitHold.preReservedURL)(_config2.default.get('bookApiURL'), this.state.projectID, this.state.projectUnitID, { clear: true }), {
                  credentials: 'include',
                  method: 'GET',
                  keepalive: true,
                  ignoreForbidden: true,
                  ignoreNotFound: true,
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                _context2.next = 9;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](2);

              case 9:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 7]]);
      }));

      function releaseHoldOnLeave() {
        return _ref2.apply(this, arguments);
      }

      return releaseHoldOnLeave;
    }()
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this4 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this4.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading(name) {
      var _this5 = this;

      var loading = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var loaders = this.state.loaders;
      var _state2 = this.state,
          identityLock = _state2.identityLock,
          mobileLock = _state2.mobileLock;

      var searchByID = name === 'searchingID';
      var searchByMobile = name === 'searchingIDByMobile';
      if (searchByID || searchByMobile) {
        if (loading) {
          if (searchByID) identityLock = true;
          if (searchByMobile) mobileLock = true;
        } else {
          if (searchByID) identityLock = false;
          if (searchByMobile) mobileLock = false;
        }
      }
      loaders[name] = loading;
      return new Promise(function (res) {
        _this5.setState({ loaders: loaders, identityLock: identityLock, mobileLock: mobileLock }, res);
      });
    }
  }, {
    key: 'getOpportunity',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(opportunityID) {
        var _this6 = this;

        var opportunity, store, _state3, booking, identityType, identity, projectID, projectUnitID, customer;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.fetchData('/leads/opportunity/' + opportunityID + '/', 'isFetching');

              case 2:
                opportunity = _context3.sent;

                if (!(!opportunity || opportunity && opportunity.booking_id)) {
                  _context3.next = 6;
                  break;
                }

                if (this.state.projectUnitID && this.state.projectID) {
                  this.getProjectUnit(this.state.projectID, this.state.projectUnitID);
                  this.getProjectCustomFields(this.state.projectID);
                } else {
                  store = this.context.store;

                  store.dispatch((0, _reactRouterRedux.replace)('/bookings/'));
                }
                return _context3.abrupt('return');

              case 6:
                _state3 = this.state, booking = _state3.booking, identityType = _state3.identityType, identity = _state3.identity;
                projectID = opportunity.data.project_id;
                projectUnitID = opportunity.data.unit_id;
                customer = void 0;

                if (opportunity.data.primary_customer && opportunity.data.primary_customer.customer) {
                  customer = opportunity.data.primary_customer.customer;
                }
                if (customer) {
                  booking = Object.assign(booking, customer.customerDetail);
                  booking.leadCustomerID = opportunity.data.primary_customer_id;
                  booking.race = this.getRace(customer.customerDetail.race);
                  booking.raceOther = booking.race === 'Others' ? customer.customerDetail.race : '';
                  if (customer.identity) {
                    identity = customer.identity.trim();
                    booking.identity = identity;
                  }
                  if (customer.identityTypeID) {
                    identityType = customer.identityTypeID;
                    booking.identityTypeID = identityType;
                  }
                  booking.birthdate = this.getBirthDate(customer.customerDetail.birthdate, identityType === 1 ? identity : '');
                  booking.customerSpecification = customer.specifications;
                  if (customer.icFrontDocument && customer.icFrontDocument.key) {
                    booking.leadICFrontURL = customer.icFrontDocument.key;
                  }
                  if (customer.icBackDocument && customer.icBackDocument.key) {
                    booking.leadICBackURL = customer.icBackDocument.key;
                  }
                  booking.maritalStatus = this.getMaritalStatus(customer.customerDetail.maritalStatus);
                }
                this.setState({
                  projectID: projectID,
                  projectUnitID: projectUnitID,
                  booking: booking,
                  identityType: identityType,
                  identity: identity
                }, function () {
                  _this6.getProjectUnit(projectID, projectUnitID);
                  _this6.getProjectCustomFields(projectID, opportunity.data.primary_customer);
                });

              case 13:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getOpportunity(_x3) {
        return _ref3.apply(this, arguments);
      }

      return getOpportunity;
    }()
    // CPI-1357: book-api creates this URL only after it has validated the agent, project, unit and
    // CRM opportunity. The browser still treats query text as untrusted: populate the VN form only
    // after the opportunity detail has the exact Booking ID that travelled with it.

  }, {
    key: 'getVNMarketplaceOpportunity',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var store, _state4, crmBookingID, crmOpportunityID, projectID, detailRes, opportunity;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                store = this.context.store;
                _state4 = this.state, crmBookingID = _state4.crmBookingID, crmOpportunityID = _state4.crmOpportunityID, projectID = _state4.projectID;
                _context4.next = 4;
                return this.setComponentState({
                  srSearching: true,
                  srError: '',
                  srErrorProjectName: '',
                  srOpportunity: null,
                  srIdentityTypeUnmapped: false,
                  srRelatedBookingCustomers: []
                });

              case 4:
                _context4.prev = 4;
                _context4.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/opportunity/' + crmOpportunityID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                detailRes = _context4.sent;

                if (!(!detailRes || !detailRes.ok)) {
                  _context4.next = 12;
                  break;
                }

                _context4.next = 11;
                return this.setComponentState({ srError: 'not_found' });

              case 11:
                return _context4.abrupt('return');

              case 12:
                _context4.next = 14;
                return detailRes.json();

              case 14:
                opportunity = _context4.sent;

                if (!(String(opportunity && opportunity.sr_code || '').trim() !== crmBookingID.trim())) {
                  _context4.next = 19;
                  break;
                }

                _context4.next = 18;
                return this.setComponentState({ srError: 'not_found' });

              case 18:
                return _context4.abrupt('return');

              case 19:
                if (!(opportunity.sr_status !== CRM_OPPORTUNITY_APPROVED)) {
                  _context4.next = 23;
                  break;
                }

                _context4.next = 22;
                return this.setComponentState({ srError: 'not_approved' });

              case 22:
                return _context4.abrupt('return');

              case 23:
                if (!(projectID && opportunity.project_id && String(opportunity.project_id) !== String(projectID))) {
                  _context4.next = 27;
                  break;
                }

                _context4.next = 26;
                return this.setComponentState({
                  srError: 'wrong_project',
                  srErrorProjectName: opportunity.project_name || ''
                });

              case 26:
                return _context4.abrupt('return');

              case 27:
                this.applyOpportunityToForm(opportunity);
                _context4.next = 35;
                break;

              case 30:
                _context4.prev = 30;
                _context4.t0 = _context4['catch'](4);

                Bugsnag.notifyException(_context4.t0);
                _context4.next = 35;
                return this.setComponentState({ srError: 'not_found' });

              case 35:
                _context4.prev = 35;
                _context4.next = 38;
                return this.setComponentState({ srSearching: false });

              case 38:
                return _context4.finish(35);

              case 39:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 30, 35, 39]]);
      }));

      function getVNMarketplaceOpportunity() {
        return _ref4.apply(this, arguments);
      }

      return getVNMarketplaceOpportunity;
    }()
    // CPI-974 (A): Booking ID (CRM sr_code) lookup, Vietnam only - the form is read-only until an
    // APPROVED opportunity has been pulled in.

    // CPI-977 S1: Save is disabled until a package is chosen (always in Vietnam, else the project switch).


    // A CRM-to-chart handoff supplies the Booking ID in the URL. Once the authenticated session is
    // ready, remove that one-time value. Vietnam then invokes the normal lookup and approval path.


    // CPI-1248: blank the citizenship the last opportunity supplied. Every path that drops the
    // opportunity goes through here, so a foreigner read off a mistyped Booking ID cannot survive
    // into the local purchaser the user looks up next - and neither can a stale 'local'.

  }, {
    key: 'searchOpportunityBySRCode',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var store, code, listRes, listData, opportunities, match, detailRes, opportunity;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                store = this.context.store;
                code = (this.state.srCode || '').trim();

                if (!(!code || this.state.srSearching)) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt('return');

              case 4:
                _context5.next = 6;
                return this.setComponentState(this.clearCRMCitizenship({
                  srSearching: true,
                  srError: '',
                  srErrorProjectName: '',
                  srOpportunity: null,
                  srIdentityTypeUnmapped: false,
                  srRelatedBookingCustomers: []
                }));

              case 6:
                _context5.prev = 6;
                _context5.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/opportunity/?' + _qs2.default.stringify({ sr_code: code, limit: 30 }), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                listRes = _context5.sent;

                if (!(!listRes || !listRes.ok)) {
                  _context5.next = 14;
                  break;
                }

                _context5.next = 13;
                return this.setComponentState({ srError: 'not_found' });

              case 13:
                return _context5.abrupt('return');

              case 14:
                _context5.next = 16;
                return listRes.json();

              case 16:
                listData = _context5.sent;
                opportunities = listData && listData.opportunities || [];
                match = opportunities.find(function (o) {
                  return String(o.sr_code || '').trim().toUpperCase() === code.toUpperCase();
                });

                if (!(!match || !match.id)) {
                  _context5.next = 23;
                  break;
                }

                _context5.next = 22;
                return this.setComponentState({ srError: 'not_found' });

              case 22:
                return _context5.abrupt('return');

              case 23:
                if (!(match.sr_status !== CRM_OPPORTUNITY_APPROVED)) {
                  _context5.next = 27;
                  break;
                }

                _context5.next = 26;
                return this.setComponentState({ srError: 'not_approved' });

              case 26:
                return _context5.abrupt('return');

              case 27:
                if (!(this.state.projectID && match.project_id && match.project_id !== this.state.projectID)) {
                  _context5.next = 31;
                  break;
                }

                _context5.next = 30;
                return this.setComponentState({
                  srError: 'wrong_project',
                  srErrorProjectName: match.project_name || ''
                });

              case 30:
                return _context5.abrupt('return');

              case 31:
                _context5.next = 33;
                return store.dispatch((0, _fetchM.fetchM)('/opportunity/' + match.id + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 33:
                detailRes = _context5.sent;

                if (!(!detailRes || !detailRes.ok)) {
                  _context5.next = 38;
                  break;
                }

                _context5.next = 37;
                return this.setComponentState({ srError: 'not_found' });

              case 37:
                return _context5.abrupt('return');

              case 38:
                _context5.next = 40;
                return detailRes.json();

              case 40:
                opportunity = _context5.sent;

                if (!(!opportunity || opportunity.sr_status !== CRM_OPPORTUNITY_APPROVED)) {
                  _context5.next = 45;
                  break;
                }

                _context5.next = 44;
                return this.setComponentState({ srError: 'not_approved' });

              case 44:
                return _context5.abrupt('return');

              case 45:
                this.applyOpportunityToForm(opportunity);
                _context5.next = 53;
                break;

              case 48:
                _context5.prev = 48;
                _context5.t0 = _context5['catch'](6);

                Bugsnag.notifyException(_context5.t0);
                _context5.next = 53;
                return this.setComponentState({ srError: 'not_found' });

              case 53:
                _context5.prev = 53;
                _context5.next = 56;
                return this.setComponentState({ srSearching: false });

              case 56:
                return _context5.finish(53);

              case 57:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[6, 48, 53, 57]]);
      }));

      function searchOpportunityBySRCode() {
        return _ref5.apply(this, arguments);
      }

      return searchOpportunityBySRCode;
    }()

    // A contact that Showroom's own sync wrote to the CRM carries the number in `nric` and no
    // identity_type. Infer the type from whichever value field is present, so such a contact
    // (or any other typeless one) still maps instead of arriving as a blank identity.


    // CPI-1435: Agent Assigned (Created By) is the CRM booking's agent. Resolve its Cognito username
    // to the Showroom user and agency and fill the locked field; book-api enforces the same agent on
    // Create and refuses "Invalid assigned agent" when there is none. Only the roles that see the field.


    // The CRM contact field a Showroom identity type is stored in for Vietnam. Mirrors book-api's
    // own Vietnam mapping, which is what wrote the contact. '' means this type has no CRM field.


    // The CRM only accepts a Vietnam CCCD once it passes the same shared rule rendered below the
    // input. Keep this small lookup gate separate from form validation: a purchaser can be found
    // before the agent completes their other booking fields.


    // The agent reserved the unit under their own name and has now typed the real buyer's CCCD over
    // it. Ask the CRM who that is, so the form can be filled from the CRM rather than retyped. Only
    // reachable once an approved Booking ID has unlocked the form.


    // The CRM has nobody with this CCCD, so the details still on screen are the previous person's -
    // usually the agent, who opened the opportunity. Empty them, or a name the agent never changed
    // is saved against the new buyer's identity. The CCCD itself stays: they just typed it.
    //
    // Cleared once per CCCD. Each keystroke re-runs the lookup, and without this guard a second
    // not_found would wipe the details the agent had already started filling in.


    // Fill the purchaser from the CRM customer the lookup found. The agent asks for this explicitly,
    // so a wrong CCCD never silently overwrites what they typed.

  }, {
    key: 'getProjectCustomFields',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(projectID, leadCustomer) {
        var skipLoader = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        var project, projectCustomFields, _state5, booking, bookingCustomFields, leadData;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.fetchData('/projects/' + projectID + '/', skipLoader ? '' : 'isFetching');

              case 2:
                project = _context6.sent;

                if (project) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt('return');

              case 5:
                projectCustomFields = project.data.projectBookingCustomFields || [];
                _state5 = this.state, booking = _state5.booking, bookingCustomFields = _state5.bookingCustomFields;
                leadData = void 0;
                // autofill lead custom fields

                if (leadCustomer && leadCustomer.emergency_contacts) {
                  leadData = leadCustomer.emergency_contacts;
                }
                if (projectCustomFields) {
                  projectCustomFields.forEach(function (data) {
                    var value = data.defaultValue;
                    // autofill lead custom fields
                    if (leadData) {
                      switch (data.name) {
                        case 'name_emergency_contact_person_':
                          value = leadData.name;
                          break;
                        case 'nric_no_emergency_contact_person_':
                          value = leadData.nric || leadData.identity_no;
                          break;
                        case 'telephone_emergency_contact_person_':
                          value = leadData.mobile_prefix + leadData.mobile;
                          break;
                        case 'email_emergency_contact_person_':
                          value = leadData.email;
                          break;
                        case 'relationship_emergency_contact_person_':
                          value = leadData.relation;
                          break;
                        default:
                          if (leadData[data.name]) {
                            value = leadData[data.name];
                          }
                          break;
                      }
                    }
                    if (value !== '') {
                      if (data.type === 'dropdown' && data.projectBookingCustomFieldOptions) {
                        var optionItem = data.projectBookingCustomFieldOptions.find(function (d) {
                          return d.value === value;
                        });
                        if (optionItem) {
                          var customField = {
                            name: data.name,
                            value: value,
                            projectBookingCustomFieldID: data.id,
                            projectBookingCustomFieldOptionID: optionItem.id
                          };
                          bookingCustomFields.push(customField);
                          booking[data.name] = value;
                        }
                      }
                      if (data.type === 'dropdown_multi' && data.projectBookingCustomFieldOptions) {
                        value = data.defaultValue.split(',');
                        var optionItems = [];
                        data.projectBookingCustomFieldOptions.forEach(function (o) {
                          value.forEach(function (v) {
                            if (v === o.value) optionItems.push(o.id);
                          });
                        });
                        if (optionItems) {
                          var _customField = {
                            name: data.name,
                            value: value.join(),
                            projectBookingCustomFieldID: data.id,
                            projectBookingCustomFieldOptionIDs: optionItems
                          };
                          bookingCustomFields.push(_customField);
                          booking[data.name] = value.join();
                        }
                      }
                      if (data.type === 'input') {
                        var _customField2 = {
                          name: data.name,
                          value: value,
                          projectBookingCustomFieldID: data.id
                        };
                        bookingCustomFields.push(_customField2);
                        booking[data.name] = value;
                      }
                    }
                  });
                }
                _context6.next = 12;
                return this.setComponentState({
                  projectCustomFields: projectCustomFields,
                  bookingCustomFields: bookingCustomFields,
                  booking: booking,
                  project: project.data
                });

              case 12:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getProjectCustomFields(_x4, _x5) {
        return _ref6.apply(this, arguments);
      }

      return getProjectCustomFields;
    }()
  }, {
    key: 'getProjectUnit',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(projectID, projectUnitID) {
        var _this7 = this;

        var skipLoader = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var firstLoad = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        var projectUnit, user, modalReservationIsOpen, store, _props, t, financeSources, _state6, booking, leadCustomer, pud, isLaunchMode, projectAllowLinkBuyerApp, unitPackagePricings, packagePricings, bumiProjectPackagePricingID, projectPackagePricingID, pricing, _pricing, unitPackageFees, noneText, feePackages, opportunities, opportunity, unitOpp, paymentOptions;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.fetchData('/projects/' + projectID + '/units/' + projectUnitID + '/?showAppliedPPBookingTotalPrice=true', skipLoader ? '' : 'isFetching');

              case 2:
                projectUnit = _context8.sent;
                user = this.props.auth;
                modalReservationIsOpen = false;

                if (projectUnit) {
                  _context8.next = 7;
                  break;
                }

                return _context8.abrupt('return');

              case 7:
                if (!(0, _preSalesLaunch.reservationBlocked)(user, projectUnit.data.project)) {
                  _context8.next = 11;
                  break;
                }

                store = this.context.store;

                store.dispatch((0, _reactRouterRedux.replace)('/forbidden/'));
                return _context8.abrupt('return');

              case 11:
                _props = this.props, t = _props.t, financeSources = _props.financeSources;
                _state6 = this.state, booking = _state6.booking, leadCustomer = _state6.leadCustomer;
                pud = this.state.projectUnitDetails;
                isLaunchMode = projectUnit.data.project.isLaunchMode;
                projectAllowLinkBuyerApp = projectUnit.data.project.linkBuyerApp;

                booking.projectID = projectUnit.data.projectID;
                booking.projectUnitID = projectUnit.data.id;
                booking.spaValue = (0, _amount.spaFullNumber)(projectUnit.data).toString();
                booking.nettSellingPrice = (0, _amount.spaFullNumber)(projectUnit.data).toString(); // TODO Remove (deprecated tier pricing)
                booking.pricingTier = (0, _amount.spaFullNumber)(projectUnit.data).toString();
                booking.statusID = projectUnit.data.project.defaultCustomBookingStatusID;
                pud.spaValue = (0, _amount.spaFullNumber)(projectUnit.data).toString();
                pud.spaTimes = projectUnit.spaTimes;
                pud.projectName = projectUnit.data.project.name;
                pud.reference = projectUnit.data.reference;
                pud.statusID = projectUnit.data.statusID;
                pud.unitStatus = projectUnit.data.status.name;
                pud.isBumi = projectUnit.data.isBumi;
                pud.loanTrackerDirectShow = projectUnit.data.project.loanTrackerDirectShow;
                pud.bookingUnitLimit = projectUnit.data.project.bookingUnitLimit;
                pud.maOwnerCompanyBranchID = projectUnit.data.project.maOwnerCompanyBranchID;
                pud.reservedCount = projectUnit.data.projectUnitBookingSummary.reservedCount;
                pud.autofillFromUrl = projectUnit.data.project.autofillFromUrl;
                pud.externalAutofillUrl = projectUnit.data.project.externalAutofillUrl;
                pud.defaultBumiProjectPricingID = projectUnit.data.project.defaultBumiProjectPricingID;
                pud.defaultProjectPricingID = projectUnit.data.project.defaultProjectPricingID;
                pud.projectUnitPricings = projectUnit.data.projectUnitPricings;
                // package pricing
                pud.projectUnitPackagePricings = projectUnit.data.projectUnitPackagePricings;
                pud.projectUnitPackageFees = projectUnit.data.projectUnitPackageFees;
                pud.defaultProjectPackagePricingID = projectUnit.data.project.defaultProjectPackagePricingID;
                pud.defaultBumiProjectPackagePricingID = projectUnit.data.project.defaultBumiProjectPackagePricingID;
                booking.tierPricingName = '';
                booking.tierPricingDescription = '';
                pud.isDisableBaseSellingPriceSelection = projectUnit.data.project.disableBaseSellingPriceSelection;
                // Setup package pricings
                unitPackagePricings = pud.projectUnitPackagePricings || [];
                // CPI-977 (PO, 14 Sep): a Vietnam reservation always needs a named package, so the
                // "Base Selling Price" entry is not offered there at all - the dropdown starts empty.

                packagePricings = (0, _vietnam.isVietnamCompany)(this.props.auth) ? [] : [{
                  value: (0, _amount.spaFullNumber)(projectUnit.data).toString(),
                  description: (0, _amount.spaFullNumber)(projectUnit.data).toString(),
                  text: t('Base Selling Price'),
                  disabled: isPackagePricingRequired && unitPackagePricings && unitPackagePricings.length > 0 || pud.isDisableBaseSellingPriceSelection,
                  content: _react2.default.createElement(
                    _semanticUiReact.Header,
                    { className: 'ddPricingTierItem' },
                    _react2.default.createElement(
                      'div',
                      { className: 'name' },
                      t('Base Selling Price')
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'value' },
                      _react2.default.createElement(_LoanAmount2.default, { precise: false, format: '0,000,000.00', amount: (0, _amount.spaFullNumber)(projectUnit.data).toString(), prefix: _react2.default.createElement(_CurrencySymbol2.default, null) })
                    )
                  )
                }];

                if (unitPackagePricings) {
                  unitPackagePricings.forEach(function (d) {
                    var newItem = {
                      value: d.id,
                      description: d.totalPrice.toString(),
                      disabled: false,
                      text: d.customName,
                      content: _react2.default.createElement(
                        _semanticUiReact.Header,
                        { className: 'ddPricingTierItem' },
                        _react2.default.createElement(
                          'div',
                          { className: 'name' },
                          d.customName
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'value' },
                          _react2.default.createElement(_LoanAmount2.default, { precise: false, format: '0,000,000.00', amount: d.totalPrice.toString(), prefix: _react2.default.createElement(_CurrencySymbol2.default, null) })
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Header.Subheader,
                          null,
                          d.customDescription
                        )
                      )
                    };
                    if (d.projectPackagePricing && d.projectPackagePricing.id) {
                      var pppDescription = d.projectPackagePricing.description;
                      if (pppDescription.includes('\n')) {
                        pppDescription = pppDescription.split('\n').map(function (pppd, idx) {
                          return _react2.default.createElement(
                            'span',
                            { key: idx },
                            pppd,
                            _react2.default.createElement('br', null)
                          );
                        });
                      }

                      newItem.text = d.projectPackagePricing.name;
                      newItem.value = d.id;
                      newItem.disabled = false;
                      newItem.content = _react2.default.createElement(
                        _semanticUiReact.Header,
                        { className: 'ddPricingTierItem' },
                        _react2.default.createElement(
                          'div',
                          { className: 'name' },
                          d.projectPackagePricing.name
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'value' },
                          _react2.default.createElement(_LoanAmount2.default, { precise: false, format: '0,000,000.00', amount: d.totalPrice.toString(), prefix: _react2.default.createElement(_CurrencySymbol2.default, null) })
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Header.Subheader,
                          null,
                          pppDescription
                        )
                      );
                    }
                    packagePricings.push(newItem);
                  });
                }
                // default package pricing
                bumiProjectPackagePricingID = pud.defaultBumiProjectPackagePricingID;
                projectPackagePricingID = pud.defaultProjectPackagePricingID;

                if (pud.projectUnitPackagePricings) {
                  if (pud.isBumi && bumiProjectPackagePricingID !== '') {
                    pricing = pud.projectUnitPackagePricings.find(function (d) {
                      return d.projectPackagePricing.id === bumiProjectPackagePricingID;
                    });

                    if (pricing && pricing.totalPrice) {
                      booking.spaValue = (0, _amount.amountToFixed)(pricing.totalPrice, projectUnit.spaTimes).toString();
                      booking.unitPackagePricingID = pricing.id;
                    }
                  } else if (!pud.isBumi && projectPackagePricingID !== '') {
                    _pricing = pud.projectUnitPackagePricings.find(function (d) {
                      return d.projectPackagePricing.id === projectPackagePricingID;
                    });

                    if (_pricing && _pricing.totalPrice) {
                      booking.spaValue = (0, _amount.amountToFixed)(_pricing.totalPrice, projectUnit.spaTimes).toString();
                      booking.unitPackagePricingID = _pricing.id;
                    }
                  }
                }

                // Setup additional fee packages
                unitPackageFees = pud.projectUnitPackageFees || [];
                noneText = t('None', { ns: _translation.TRANSLATION_FILES.constants });
                feePackages = [{
                  value: '',
                  description: '0',
                  text: noneText,
                  content: _react2.default.createElement(
                    _semanticUiReact.Header,
                    { className: 'ddPricingTierItem' },
                    _react2.default.createElement(
                      'div',
                      { className: 'name' },
                      noneText
                    )
                  )
                }];

                if (unitPackageFees) {
                  unitPackageFees.forEach(function (d) {
                    var newItem = {
                      value: d.id,
                      description: d.totalPrice.toString()
                    };
                    if (d.projectFeePackage && d.projectFeePackage.id) {
                      var pppDescription = d.projectFeePackage.description;
                      if (pppDescription.includes('\n')) {
                        pppDescription = pppDescription.split('\n').map(function (pppd, idx) {
                          return _react2.default.createElement(
                            'span',
                            { key: idx },
                            pppd,
                            _react2.default.createElement('br', null)
                          );
                        });
                      }

                      newItem.text = d.projectFeePackage.name;
                      newItem.content = _react2.default.createElement(
                        _semanticUiReact.Header,
                        { className: 'ddPricingTierItem' },
                        _react2.default.createElement(
                          'div',
                          { className: 'name' },
                          d.projectFeePackage.name
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'value' },
                          _react2.default.createElement(_LoanAmount2.default, { precise: false, format: '0,000,000.00', amount: d.totalPrice.toString(), prefix: _react2.default.createElement(_CurrencySymbol2.default, null) })
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Header.Subheader,
                          null,
                          pppDescription
                        )
                      );
                    }
                    if (newItem.content) {
                      feePackages.push(newItem);
                    }
                  });
                }

                if (user && user.affiliate && user.affiliate.companyBranch && user.affiliate.companyBranch.reservationLimit !== 0 && projectUnit.data.companyBranchBookingReserveCount >= user.affiliate.companyBranch.reservationLimit) {
                  modalReservationIsOpen = true;
                }
                // relink a correct lead opportunity
                booking.origin = '';
                booking.originID = '';
                if (booking.leadCustomerID) {
                  if (leadCustomer && leadCustomer.opportunities && leadCustomer.opportunities.length > 0) {
                    // get list of opportunities that are not linked to booking yet
                    opportunities = leadCustomer.opportunities.filter(function (o) {
                      return o.project_id === projectID && (!o.booking_id || o.booking_id === '');
                    });

                    if (opportunities && opportunities.length > 0) {
                      opportunity = void 0;

                      // find opportunity for current unit

                      unitOpp = opportunities.find(function (o) {
                        return o.unit_id === projectUnitID;
                      });

                      if (unitOpp) {
                        opportunity = unitOpp;
                      } else {
                        // get first opp with empty unit
                        opportunity = opportunities.find(function (o) {
                          return !o.unit_id || o.unit_id === '';
                        });
                      }
                      if (opportunity) {
                        booking.origin = 'lead';
                        booking.originID = opportunity.id;
                      }
                    }
                  }
                }

                paymentOptions = [];

                if (projectUnit.data.project && projectUnit.data.project.sourceOfFinanceOptions && projectUnit.data.project.sourceOfFinanceOptions.length > 0) {
                  projectUnit.data.project.sourceOfFinanceOptions.forEach(function (f) {
                    paymentOptions.push({ text: (0, _financeSource.getFinanceSourceLabel)(f, financeSources.data), value: f });
                  });
                }
                _context8.next = 63;
                return this.setComponentState({
                  // pricingTiers,
                  packagePricings: packagePricings,
                  feePackages: feePackages,
                  projectUnitDetails: pud,
                  booking: booking,
                  modalReservationIsOpen: modalReservationIsOpen,
                  allowCustomBookingStatus: projectUnit.data.project.allowCustomBookingStatus,
                  allowStaffEditBookingSPAValue: projectUnit.data.project.allowStaffEditBookingSPAValue,
                  allowAgentEditBookingSPAValue: projectUnit.data.project.allowAgentEditBookingSPAValue,
                  allowAgentAutofillPurchaserDetails: projectUnit.data.project.allowAgentAutofillPurchaserDetails,
                  isLaunchMode: isLaunchMode,
                  paymentMethods: paymentOptions,
                  projectAllowLinkBuyerApp: projectAllowLinkBuyerApp,
                  projectBranchOwnerID: projectUnit.data.project.maOwnerCompanyBranchID,
                  showPurchaserExtraFields: projectUnit.data.project.showPurchaserExtraFields,
                  // CPI-977 requirement 1: a Vietnamese reservation always needs a package; the project switch
                  // stays the rule everywhere else (it failed UAT because no VN project had it on).
                  isRequirePricingSelection: (0, _vietnam.isVietnamCompany)(this.props.auth) || projectUnit.data.project.requirePricingSelectDuringReserve,
                  isDisableBaseSellingPriceSelection: projectUnit.data.project.disableBaseSellingPriceSelection,
                  project: projectUnit.data.project
                }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                  var pUnit, _store;

                  return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          pUnit = projectUnit.data;

                          if (pUnit.projectUnitBookingSummary.reservedCount >= pUnit.project.bookingUnitLimit || pUnit.statusID === 'booked' || pUnit.statusID === 'delist' && !_this7.checkBookableDelistedUnit(pUnit.project)) {
                            _store = _this7.context.store;

                            _store.dispatch((0, _reactRouterRedux.replace)('/bookings/'));
                          }
                          // cooldown check
                          _context7.next = 4;
                          return _this7.fetchPreReservationCooldown(skipLoader);

                        case 4:
                          if (!projectUnit.data.project.isLaunchMode) {
                            _context7.next = 7;
                            break;
                          }

                          _context7.next = 7;
                          return _this7.fetchPreReservation(false, skipLoader);

                        case 7:
                          if (!(firstLoad && !_this7.state.showSwapUnit)) {
                            _context7.next = 10;
                            break;
                          }

                          _context7.next = 10;
                          return Promise.all([_this7.getProjectCustomFields(_this7.state.projectID, false, true), _this7.getProjectFinanceSourceOpts(_this7.state.projectID)]);

                        case 10:
                          if (!(firstLoad || skipLoader)) {
                            _context7.next = 13;
                            break;
                          }

                          _context7.next = 13;
                          return _this7.setLoading('isFetching', false);

                        case 13:
                        case 'end':
                          return _context7.stop();
                      }
                    }
                  }, _callee7, _this7);
                })));

              case 63:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function getProjectUnit(_x7, _x8) {
        return _ref7.apply(this, arguments);
      }

      return getProjectUnit;
    }()
  }, {
    key: 'getPackagePricingCalculation',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var store, t, _state7, projectUnitDetails, booking, res, ppID, basePriceID, _basePriceID, _basePriceID2, vnWaiver, message, json;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                _state7 = this.state, projectUnitDetails = _state7.projectUnitDetails, booking = _state7.booking;
                _context9.next = 5;
                return this.setLoading('isFetching', true);

              case 5:
                res = null;
                ppID = booking.unitPackagePricingID;

                if (ppID !== '') {
                  if (ppID === projectUnitDetails.spaValue) {
                    basePriceID = Number(projectUnitDetails.spaValue);

                    ppID = basePriceID.toFixed(0);
                  }
                  if (ppID !== projectUnitDetails.spaValue && ppID !== booking.unitPackagePricingID) {
                    _basePriceID = Number(projectUnitDetails.spaValue);

                    ppID = _basePriceID.toFixed(0);
                  }
                } else {
                  _basePriceID2 = Number(projectUnitDetails.spaValue);

                  ppID = _basePriceID2.toFixed(0);
                }
                vnWaiver = (0, _vietnam.isVietnamCompany)(this.props.auth) && booking.waiveBankGuarantee ? '&waiveBankGuarantee=true' : '';
                _context9.prev = 9;
                _context9.next = 12;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + this.state.projectID + '/units/' + this.state.projectUnitID + '/cal_package_pricing/' + ppID + '/?selling=' + this.state.booking.spaValue + vnWaiver, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context9.sent;
                _context9.next = 33;
                break;

              case 15:
                _context9.prev = 15;
                _context9.t0 = _context9['catch'](9);

                if (!(_context9.t0.res && _context9.t0.res.status >= 400 && _context9.t0.res.status < 500)) {
                  _context9.next = 27;
                  break;
                }

                _context9.next = 20;
                return _context9.t0.res.text();

              case 20:
                message = _context9.sent;

                // CPI-977 D-C5: a refused preview must leave the panel saying so, not quote a stored total
                this.markVNPreviewFailed();

                if (!(0, _vietnam.isVietnamCompany)(this.props.auth)) {
                  _context9.next = 25;
                  break;
                }

                _context9.next = 25;
                return this.setLoading('isFetching', false);

              case 25:
                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context9.abrupt('return', null);

              case 27:
                _context9.next = 29;
                return this.setLoading('isFetching', false);

              case 29:
                this.markVNPreviewFailed();
                Bugsnag.notifyException(_context9.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context9.abrupt('return', null);

              case 33:
                _context9.next = 35;
                return this.setLoading('isFetching', false);

              case 35:
                _context9.next = 37;
                return res.json();

              case 37:
                json = _context9.sent;

                if (json) {
                  this.setState({ newPPI: json });
                  this.applyVNLivePackageTotal(json);
                }
                return _context9.abrupt('return', null);

              case 40:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[9, 15]]);
      }));

      function getPackagePricingCalculation() {
        return _ref9.apply(this, arguments);
      }

      return getPackagePricingCalculation;
    }()
  }, {
    key: 'getFeePackageBreakdown',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var store, booking, res, ppID, message, json;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                store = this.context.store;
                booking = this.state.booking;
                _context10.next = 4;
                return this.setLoading('isFetching', true);

              case 4:
                res = null;
                ppID = booking.unitPackageFeeID;

                if (ppID === '') {
                  ppID = 'none';
                }
                _context10.prev = 7;
                _context10.next = 10;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + this.state.projectID + '/units/' + this.state.projectUnitID + '/cal_package_fee/' + ppID + '/?spa=' + this.state.booking.spaValue + '&nett=' + this.state.booking.nettSellingPrice, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 10:
                res = _context10.sent;
                _context10.next = 26;
                break;

              case 13:
                _context10.prev = 13;
                _context10.t0 = _context10['catch'](7);

                if (!(_context10.t0.res && _context10.t0.res.status >= 400 && _context10.t0.res.status < 500)) {
                  _context10.next = 21;
                  break;
                }

                _context10.next = 18;
                return _context10.t0.res.text();

              case 18:
                message = _context10.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context10.abrupt('return', null);

              case 21:
                _context10.next = 23;
                return this.setLoading('isFetching', false);

              case 23:
                Bugsnag.notifyException(_context10.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context10.abrupt('return', null);

              case 26:
                _context10.next = 28;
                return this.setLoading('isFetching', false);

              case 28:
                _context10.next = 30;
                return res.json();

              case 30:
                json = _context10.sent;

                if (json) {
                  this.setState({ newBFP: json });
                }
                return _context10.abrupt('return', null);

              case 33:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[7, 13]]);
      }));

      function getFeePackageBreakdown() {
        return _ref10.apply(this, arguments);
      }

      return getFeePackageBreakdown;
    }()
  }, {
    key: 'getProjectFinanceSourceOpts',
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(projectID) {
        var store, res, message, json;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                store = this.context.store;
                res = null;
                _context11.prev = 2;
                _context11.next = 5;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + projectID + '/finance_source_opts/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                res = _context11.sent;
                _context11.next = 19;
                break;

              case 8:
                _context11.prev = 8;
                _context11.t0 = _context11['catch'](2);

                if (!(_context11.t0.res && _context11.t0.res.status >= 400 && _context11.t0.res.status < 500)) {
                  _context11.next = 16;
                  break;
                }

                _context11.next = 13;
                return _context11.t0.res.text();

              case 13:
                message = _context11.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context11.abrupt('return', null);

              case 16:
                Bugsnag.notifyException(_context11.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context11.abrupt('return', null);

              case 19:
                _context11.next = 21;
                return res.json();

              case 21:
                json = _context11.sent;

                if (!json) {
                  _context11.next = 25;
                  break;
                }

                _context11.next = 25;
                return this.setComponentState({ financeSourceOpts: json });

              case 25:
                return _context11.abrupt('return', null);

              case 26:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this, [[2, 8]]);
      }));

      function getProjectFinanceSourceOpts(_x11) {
        return _ref11.apply(this, arguments);
      }

      return getProjectFinanceSourceOpts;
    }()
  }, {
    key: 'getSFAutofill',
    value: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(id) {
        var sfAutofill, booking, sfa, validations, newState;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.fetchData('/bookings/sf/autofill/?id=' + id, 'isFetching', true, {}, false);

              case 2:
                sfAutofill = _context12.sent;

                if (!(sfAutofill && sfAutofill.data)) {
                  _context12.next = 47;
                  break;
                }

                booking = this.state.booking;
                sfa = sfAutofill.data;

                if (sfa.bumi) booking.bumi = sfa.bumi;
                if (sfa.email) booking.email = sfa.email;
                if (sfa.gender) booking.gender = sfa.gender;
                if (sfa.identity) booking.identity = sfa.identity;
                if (sfa.identityType) booking.identityTypeID = parseInt(sfa.identityType, 10);
                if (sfa.jobTitle) booking.jobTitle = sfa.jobTitle;
                if (sfa.maritalStatus) booking.maritalStatus = sfa.maritalStatus;
                if (sfa.mobile) booking.mobile = sfa.mobile;
                if (sfa.mobilePrefix) booking.mobilePrefix = sfa.mobilePrefix;
                if (sfa.monthlyIncome) booking.monthlyIncome = !isNaN(sfa.monthlyIncome) ? sfa.monthlyIncome.toString() : sfa.monthlyIncome;
                if (sfa.name) booking.name = sfa.name;
                if (sfa.nationality) booking.nationality = sfa.nationality;
                if (sfa.phone) booking.phone = sfa.phone;
                if (sfa.phonePrefix) booking.phonePrefix = sfa.phonePrefix;
                if (sfa.preferredName) booking.preferredName = sfa.preferredName;
                if (sfa.race) booking.race = sfa.race;
                if (sfa.title) booking.title = sfa.title;
                if (sfa.address1) booking.address1 = sfa.address1;
                if (sfa.address2) booking.address2 = sfa.address2;
                if (sfa.city) booking.address6 = sfa.city;
                if (sfa.postcode) booking.address5 = sfa.postcode;
                if (sfa.state) booking.address7 = sfa.state;
                if (sfa.country) booking.country = sfa.country;
                if (sfa.birthdate) booking.birthdate = sfa.birthdate;
                if (sfa.emergencyContactRelation) booking.emergencyContactRelation = sfa.emergencyContactRelation;
                if (sfa.emergencyContactName) booking.emergencyContactName = sfa.emergencyContactName;
                if (sfa.emergencyContactMobilePrefix) booking.emergencyContactMobilePrefix = sfa.emergencyContactMobilePrefix;
                if (sfa.emergencyContactMobile) booking.emergencyContactMobile = sfa.emergencyContactMobile;
                if (sfa.emergencyContactIdentity) booking.emergencyContactIdentity = sfa.emergencyContactIdentity;
                if (sfa.emergencyContactEmail) booking.emergencyContactEmail = sfa.emergencyContactEmail;
                if (sfa.occupation) {
                  booking.jobTitle = sfa.occupation;
                } else if (sfa.jobTitle) {
                  booking.jobTitle = sfa.jobTitle;
                }
                _context12.next = 39;
                return this.setComponentState({ booking: booking });

              case 39:
                _context12.next = 41;
                return _AppForm2.default.validate(this.validation, booking);

              case 41:
                validations = _context12.sent;
                newState = {
                  errMessages: validations.filter(function (v) {
                    return !v.isValid;
                  })
                };

                if (sfa.identity) newState.identity = sfa.identity;
                if (sfa.identityType) newState.identityType = parseInt(sfa.identityType, 10);
                _context12.next = 47;
                return this.setComponentState(newState);

              case 47:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getSFAutofill(_x12) {
        return _ref12.apply(this, arguments);
      }

      return getSFAutofill;
    }()
  }, {
    key: 'searchAutofillCustomer',
    value: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(searchValue, searchType) {
        var _this8 = this;

        var customerID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var identityPresetID = arguments[3];

        var _state8, loaders, projectUnitDetails, projectID, projectUnitID, t, existingCustomerData, externalCustomerData, leadCustomerData, searchingBy, query, headers, crmEnabledSearchTypes, invalidVNCCCD, crmSearchField, preset, mapping, crmQuery, _ref14, existingCustomer, externalCustomer, leadCustomer, autofillOptions, replacedByField, customerIsExisting, isValidPhonePrefix, message, externalCustomerExists, showNoAutofill;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _state8 = this.state, loaders = _state8.loaders, projectUnitDetails = _state8.projectUnitDetails, projectID = _state8.projectID, projectUnitID = _state8.projectUnitID;
                t = this.props.t;

                if (this.hasAutofillAccess()) {
                  _context13.next = 4;
                  break;
                }

                return _context13.abrupt('return');

              case 4:
                existingCustomerData = void 0;
                externalCustomerData = void 0;
                leadCustomerData = void 0;
                searchingBy = 'searchingID';

                if (searchType === _autofillTypes.AUTOFILL_MSISDN) searchingBy = 'searchingIDByMobile';

                query = {
                  search: searchValue,
                  identityTypeID: this.getAutofillIdentityTypeID(searchType),
                  projectBranchOwnerID: projectUnitDetails.maOwnerCompanyBranchID
                };

                if (searchType === _autofillTypes.AUTOFILL_PRESET) query.presetID = identityPresetID;

                // search existing internal default
                _context13.next = 13;
                return this.fetchData('/customers/?' + _qs2.default.stringify(query), searchingBy);

              case 13:
                existingCustomerData = _context13.sent;

                if (!customerID) {
                  _context13.next = 18;
                  break;
                }

                _context13.next = 17;
                return this.fetchData('/customers/?customerID=' + customerID + '&projectBranchOwnerID=' + projectUnitDetails.maOwnerCompanyBranchID, searchingBy);

              case 17:
                existingCustomerData = _context13.sent;

              case 18:
                if (!isPRS) {
                  _context13.next = 22;
                  break;
                }

                _context13.next = 21;
                return this.fetchData('/search/prs/?search=' + searchValue + '&prsID=' + this.state.prsID + '&projectID=' + projectID + '&projectUnitID=' + projectUnitID, searchingBy, true, {}, false);

              case 21:
                existingCustomerData = _context13.sent;

              case 22:
                if (!(!isPRS && projectUnitDetails.autofillFromUrl && projectUnitDetails.externalAutofillUrl.trim() !== '')) {
                  _context13.next = 27;
                  break;
                }

                headers = {
                  'x-mhub-registration-code': ""
                };
                _context13.next = 26;
                return this.fetchData(projectUnitDetails.externalAutofillUrl + '/customers/search/identity_type/' + this.getAutofillIdentityTypeID(searchType) + '/identity/' + searchValue + '/', searchingBy, false, headers);

              case 26:
                externalCustomerData = _context13.sent;

              case 27:

                // search existing crm
                crmEnabledSearchTypes = [_autofillTypes.AUTOFILL_NRIC, _autofillTypes.AUTOFILL_PASSPORT, _autofillTypes.AUTOFILL_MSISDN, _autofillTypes.AUTOFILL_PRESET];
                invalidVNCCCD = (0, _vietnam.isVietnamCompany)(this.props.auth) && searchType === _autofillTypes.AUTOFILL_NRIC && !this.isValidVNCCCD(searchValue);

                if (!(!isPRS && crmEnabledSearchTypes.includes(searchType) && this.state.isCRMEnabled && !invalidVNCCCD)) {
                  _context13.next = 37;
                  break;
                }

                crmSearchField = searchType;

                if (searchType === _autofillTypes.AUTOFILL_PRESET) {
                  preset = this.state.identityPresets.find(function (p) {
                    return p.id === identityPresetID;
                  });

                  if (preset && preset.label) {
                    mapping = _autofillTypes.CRM_SEARCH_FIELD_MAPPINGS.find(function (map) {
                      return map.label === preset.label;
                    });

                    crmSearchField = mapping ? mapping.searchField : searchType;
                  }
                }
                crmQuery = {
                  search: searchValue,
                  searchField: crmSearchField
                };

                if (searchType === _autofillTypes.AUTOFILL_PRESET) {
                  crmQuery.presetID = identityPresetID;
                }
                _context13.next = 36;
                return this.fetchData('/leads/customers/search/?' + _qs2.default.stringify(crmQuery), searchingBy);

              case 36:
                leadCustomerData = _context13.sent;

              case 37:
                if (!(!existingCustomerData && !externalCustomerData && !leadCustomerData)) {
                  _context13.next = 41;
                  break;
                }

                _context13.next = 40;
                return this.setComponentState({ showNoAutofill: true });

              case 40:
                return _context13.abrupt('return');

              case 41:
                _ref14 = {}, existingCustomer = _ref14.existingCustomer, externalCustomer = _ref14.externalCustomer, leadCustomer = _ref14.leadCustomer;
                autofillOptions = [];
                replacedByField = searchType === _autofillTypes.AUTOFILL_MSISDN ? 'msisdn' : 'identity';

                // if existing customer exists

                customerIsExisting = existingCustomerData && existingCustomerData.data && existingCustomerData.data.length > 0;

                if (!customerIsExisting) {
                  _context13.next = 56;
                  break;
                }

                existingCustomer = Object.assign({}, existingCustomerData.data[0]);
                delete existingCustomer.customerDetail.createdAt;
                delete existingCustomer.customerDetail.updatedAt;

                if (!isPRS) {
                  _context13.next = 55;
                  break;
                }

                isValidPhonePrefix = _intlCallCodes2.default.find(function (d) {
                  return d.value === existingCustomer.customerDetail.mobilePrefix;
                });

                if (isValidPhonePrefix) {
                  _context13.next = 55;
                  break;
                }

                message = _react2.default.createElement(
                  'span',
                  null,
                  'Mobile prefix is invalid! Please inform the customer to update it in ',
                  _react2.default.createElement(
                    'a',
                    { href: 'http://www.pr1ma.my', target: '_blank' },
                    'PRS system (www.pr1ma.my).'
                  )
                );

                this.setState({ fetchDataErrorMessage: message, showNoAutofill: true });
                return _context13.abrupt('return');

              case 55:
                autofillOptions.push({
                  key: 'existing',
                  text: t('Previous entry'),
                  onClick: function onClick(e) {
                    e.preventDefault();
                    _this8.replaceWithAutofill('existing', replacedByField);
                  }
                });

              case 56:

                // if external customer exists
                externalCustomerExists = externalCustomerData && externalCustomerData.data;

                if (externalCustomerExists) {
                  externalCustomer = Object.assign({}, externalCustomerData.data);
                  delete externalCustomer.id;
                  delete externalCustomer.customerDetailID;
                  delete externalCustomer.customerDetail.id;
                  delete externalCustomer.customerDetail.customerID;
                  delete externalCustomer.customerDetail.createdAt;
                  delete externalCustomer.customerDetail.updatedAt;
                  autofillOptions.push({
                    key: 'external',
                    text: t('Customer self registration'),
                    onClick: function onClick(e) {
                      e.preventDefault();
                      _this8.replaceWithAutofill('external', replacedByField);
                    }
                  });
                }

                if (leadCustomerData && leadCustomerData.data && leadCustomerData.data.length > 0) {
                  leadCustomer = Object.assign({}, leadCustomerData.data[0]);
                  autofillOptions.push({
                    key: 'lead',
                    text: 'CRM',
                    onClick: function onClick(e) {
                      e.preventDefault();
                      _this8.replaceWithAutofill('lead', replacedByField);
                    }
                  });
                }

                showNoAutofill = autofillOptions.length < 1;

                loaders.searchingID = false;
                this.setState({
                  existingCustomer: existingCustomer,
                  externalCustomer: externalCustomer,
                  leadCustomer: leadCustomer,
                  autofillOptions: autofillOptions,
                  loaders: loaders,
                  showNoAutofill: showNoAutofill
                }, function () {
                  if (isPRS && customerIsExisting) _this8.replaceWithAutofill('existing', replacedByField);
                });

              case 62:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function searchAutofillCustomer(_x13, _x14) {
        return _ref13.apply(this, arguments);
      }

      return searchAutofillCustomer;
    }()
    // autofill booking from from url query (book_xxx) data

  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var admin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var dhq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var dbl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var internal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      var auth = this.props.auth;
      if (dbl && this.props.auth.isBranchLeader) {
        return true;
      }
      if (dhq && this.props.auth.isHeadquarters) {
        return true;
      }
      if (admin && this.props.auth.isSuperAdmin) {
        return true;
      }
      if (internal && auth && auth.companyBranch && !auth.companyBranch.isExternal) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasAccessIsExternalAgent',
    value: function hasAccessIsExternalAgent() {
      var auth = this.props.auth;
      if (auth && auth.companyBranch && auth.companyBranch.isExternal) {
        return true;
      }
      return false;
    }
  }, {
    key: 'hasUnitSwapAccess',
    value: function hasUnitSwapAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var auth = this.props.auth;

      if (auth.isHeadquarters || auth.isSuperAdmin) {
        return true;
      }
      if (auth.isBranchLeader && this.state.projectBranchOwnerID === auth.companyBranch.id) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasTierPricingAccess',
    value: function hasTierPricingAccess() {
      var auth = this.props.auth;

      if (auth.isSuperAdmin || auth.isHeadquarters) {
        return true;
      }
      if (auth && auth.companyBranch && !auth.companyBranch.isExternal && this.state.allowStaffEditBookingSPAValue) {
        return true;
      }
      if (auth && auth.companyBranch && auth.companyBranch.isExternal && this.state.allowAgentEditBookingSPAValue) {
        return true;
      }
      return false;
    }
  }, {
    key: 'hasPackagePricingAccess',
    value: function hasPackagePricingAccess() {
      var auth = this.props.auth;

      if (auth.isSuperAdmin || auth.isHeadquarters) {
        return true;
      }
      if (auth && auth.companyBranch && !auth.companyBranch.isExternal && this.state.allowStaffEditBookingSPAValue) {
        return true;
      }
      if (auth && auth.companyBranch && auth.companyBranch.isExternal && this.state.allowAgentEditBookingSPAValue) {
        return true;
      }
      return false;
    }
  }, {
    key: 'hasAutofillAccess',
    value: function hasAutofillAccess() {
      var auth = this.props.auth;
      // CPI-974 (D6/A7): no customer-search autofill in Vietnam; both trigger sites short-circuit.

      if ((0, _vietnam.isVietnamCompany)(auth)) {
        return false;
      }
      if (auth && auth.companyBranch && auth.companyBranch.isExternal) {
        return this.state.allowAgentAutofillPurchaserDetails;
      }
      return true;
    }
    // CPI-974 (S1): only the SA / HQ family may change the Source of finance in Vietnam.

  }, {
    key: 'hasSourceOfFinanceEditAccess',
    value: function hasSourceOfFinanceEditAccess() {
      return (0, _vietnam.hasVietnamElevatedAccess)(this.props.auth);
    }
  }, {
    key: 'hasSPAValueAccess',
    value: function hasSPAValueAccess() {
      var auth = this.props.auth;
      if (this.props.auth.isSuperAdmin || this.props.auth.isHeadquarters) {
        return true;
      }
      if (auth && auth.companyBranch && !auth.companyBranch.isExternal && this.state.allowStaffEditBookingSPAValue) {
        return true;
      }
      return false;
    }
  }, {
    key: 'isLoading',
    value: function isLoading() {
      var _this9 = this;

      for (var _len = arguments.length, names = Array(_len), _key = 0; _key < _len; _key++) {
        names[_key] = arguments[_key];
      }

      return names.some(function (name) {
        return _this9.state.loaders[name];
      });
    }
  }, {
    key: 'fetchData',
    value: function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(fetchPath, loaderName) {
        var includeCredentials = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var extraHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var showError = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
        var store, t, res, extraRequest, message, data, json;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;

                if (!(loaderName !== '')) {
                  _context14.next = 5;
                  break;
                }

                _context14.next = 5;
                return this.setLoading(loaderName, true);

              case 5:
                res = null;
                extraRequest = {};

                if (includeCredentials) {
                  extraRequest = {
                    credentials: 'include'
                  };
                }
                _context14.prev = 8;
                _context14.next = 11;
                return store.dispatch((0, _fetchM.fetchM)(fetchPath, _extends({}, extraRequest, {
                  method: 'GET',
                  headers: _extends({
                    'Content-Type': 'application/json'
                  }, extraHeaders)
                })));

              case 11:
                res = _context14.sent;
                _context14.next = 32;
                break;

              case 14:
                _context14.prev = 14;
                _context14.t0 = _context14['catch'](8);

                if (!(_context14.t0.res && _context14.t0.res.status >= 400 && _context14.t0.res.status < 500)) {
                  _context14.next = 26;
                  break;
                }

                _context14.next = 19;
                return _context14.t0.res.text();

              case 19:
                message = _context14.sent;

                if (showError) store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                if (!showError) this.setComponentState({ fetchDataErrorMessage: message });

                if (!(loaderName !== '')) {
                  _context14.next = 25;
                  break;
                }

                _context14.next = 25;
                return this.setLoading(loaderName, false);

              case 25:
                return _context14.abrupt('return', null);

              case 26:
                if (!(loaderName !== '')) {
                  _context14.next = 29;
                  break;
                }

                _context14.next = 29;
                return this.setLoading(loaderName, false);

              case 29:
                Bugsnag.notifyException(_context14.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context14.abrupt('return', null);

              case 32:
                if (res.ok) {
                  _context14.next = 39;
                  break;
                }

                if (!(loaderName !== '')) {
                  _context14.next = 36;
                  break;
                }

                _context14.next = 36;
                return this.setLoading(loaderName, false);

              case 36:
                Bugsnag.notifyException(new Error('Server error during booking: ' + res.status));
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context14.abrupt('return', null);

              case 39:
                if (!(loaderName !== '')) {
                  _context14.next = 42;
                  break;
                }

                _context14.next = 42;
                return this.setLoading(loaderName, false);

              case 42:
                data = {};
                _context14.next = 45;
                return res.json();

              case 45:
                json = _context14.sent;

                if (json) {
                  data.data = json;
                }
                return _context14.abrupt('return', data);

              case 48:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this, [[8, 14]]);
      }));

      function fetchData(_x22, _x23) {
        return _ref15.apply(this, arguments);
      }

      return fetchData;
    }()
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      var _this10 = this;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true }, function () {
          if (_this10.props.onChange) {
            _this10.props.onChange(true);
          }
        });
      }
    }
  }, {
    key: 'handleResetCheck',
    value: function handleResetCheck(callback) {
      var _this11 = this;

      this.setState({ hasChanges: false }, function () {
        if (_this11.props.onChange) {
          _this11.props.onChange(false, callback);
        }
      });
    }
  }, {
    key: 'validateTIN',
    value: function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15(tinInput) {
        var _state9, identityType, identity, idType, query, store, res, errorMessage, _errorMessage;

        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _state9 = this.state, identityType = _state9.identityType, identity = _state9.identity;

                if (!(!tinInput || !identityType || !identity)) {
                  _context15.next = 3;
                  break;
                }

                return _context15.abrupt('return');

              case 3:
                idType = (0, _identityTypes.getIdentityTypeOpts)().find(function (i) {
                  return i.value === identityType;
                }).tin_code;
                query = Object.assign({
                  tin: tinInput,
                  idType: idType,
                  idValue: identity
                });
                store = this.context.store;
                _context15.prev = 6;
                _context15.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/tin/validate/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token,
                    'X-Origin': this.state.origin
                  }
                }));

              case 9:
                res = _context15.sent;

                if (!(res && res.ok)) {
                  _context15.next = 14;
                  break;
                }

                this.setState({
                  tinError: false,
                  tinFound: true,
                  tinMessage: null
                });
                _context15.next = 19;
                break;

              case 14:
                _context15.next = 16;
                return res.text();

              case 16:
                errorMessage = _context15.sent;

                this.setState({
                  tinError: true,
                  tinFound: false,
                  tinMessage: errorMessage
                });
                return _context15.abrupt('return');

              case 19:
                _context15.next = 28;
                break;

              case 21:
                _context15.prev = 21;
                _context15.t0 = _context15['catch'](6);

                if (!_context15.t0.res) {
                  _context15.next = 28;
                  break;
                }

                _context15.next = 26;
                return _context15.t0.res.text();

              case 26:
                _errorMessage = _context15.sent;

                this.setState({
                  tinError: true,
                  tinFound: false,
                  tinMessage: _errorMessage
                });

              case 28:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this, [[6, 21]]);
      }));

      function validateTIN(_x27) {
        return _ref16.apply(this, arguments);
      }

      return validateTIN;
    }()
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }

    // CPI-1248 (part 1): may the purchasers on this form reserve the unit they picked? A Vietnamese
    // unit flagged isBumi is the "Local unit", and one declared foreigner anywhere on the booking -
    // the primary purchaser or any joint purchaser the CRM opportunity brought with it - is enough
    // to refuse it. False for every non-Vietnamese session, and for a purchaser whose citizenship
    // the CRM never captured. book-api enforces the same rule on the write.
    //
    // The percentage quota on the project's Foreign Purchase Control threshold (CPI-1220) is the
    // OTHER half of CPI-1248 and is NOT decided here - see README.

  }, {
    key: 'submitBooking',
    value: function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var _this12 = this;

        var store, _props2, t, auth, _state10, booking, projectUnitDetails, projectCustomFields, bookingCustomFields, srRelatedBookingCustomers, isIndonesia, isVietnam, bcf, trimmedIdentity, taxTinValidationStatus, prsExists, prspcf, prsCustomField, validations, errMessages, customer, bookingCustomer, postBooking, header, errMessagesWithIdentityType, queryParams, source, res, message, mType, defaultBookingStatus;

        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                store = this.context.store;
                _props2 = this.props, t = _props2.t, auth = _props2.auth;
                _state10 = this.state, booking = _state10.booking, projectUnitDetails = _state10.projectUnitDetails, projectCustomFields = _state10.projectCustomFields, bookingCustomFields = _state10.bookingCustomFields, srRelatedBookingCustomers = _state10.srRelatedBookingCustomers;
                isIndonesia = auth.company && auth.company.countryCode.toUpperCase() === 'ID';
                // CPI-976: no TIN field in Vietnam, so the BRN "Invalid TIN" precondition must not apply.

                isVietnam = (0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode);
                bcf = bookingCustomFields.filter(function (bbcf) {
                  return _defaultBookingFields.DEFAULT_BOOKING_FIELD_LIST.every(function (pf) {
                    return bbcf.name !== pf.name;
                  });
                });
                trimmedIdentity = this.state.identity ? this.state.identity.trim() : '';
                taxTinValidationStatus = this.state.tinError === false ? 'success' : 'failed';

                if (!(!isIndonesia && !isVietnam && this.state.identityType !== 2 && taxTinValidationStatus !== 'success' && (this.state.identityType === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN || this.state.project.requireValidTinAtBookingCreation) && !this.state.isForeignCompany)) {
                  _context16.next = 11;
                  break;
                }

                store.dispatch((0, _flash.flashMessage)({
                  header: 'Invalid TIN',
                  message: 'Tax Identification Number is invalid',
                  icon: 'warning sign',
                  type: 'error',
                  autoHideDuration: 5000
                }));
                return _context16.abrupt('return');

              case 11:
                // prsID
                prsExists = false;

                bookingCustomFields.forEach(function (cf, idx) {
                  if (cf.name === 'no_rujukan_pr1ma') {
                    prsExists = true;
                    if (_this12.state.prsID) {
                      bcf[idx].value = _this12.state.prsID;
                    }
                  }
                });
                if (!prsExists && projectCustomFields) {
                  prspcf = projectCustomFields.find(function (p) {
                    return p.name === 'no_rujukan_pr1ma';
                  });

                  if (prspcf) {
                    prsCustomField = {
                      name: 'no_rujukan_pr1ma',
                      value: this.state.prsID ? this.state.prsID : prspcf.value,
                      projectBookingCustomFieldID: prspcf.id
                    };

                    bcf.push(prsCustomField);
                  }
                }
                // Check if Selling Price is not empty
                if (booking.spaValue === null || booking.spaValue === '') {
                  booking.spaValue = '0';
                  this.setState({ booking: booking });
                }
                if (booking.identity === '' || booking.customerID === null) {
                  booking.identity = trimmedIdentity;
                }
                // CPI-974 (A3): a locked VN form also skips validate(), which would flag fields it disabled.

                if (!(isVietnam && !this.state.srOpportunity)) {
                  _context16.next = 19;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({
                  message: this.state.srError === 'not_approved' ? t('Booking has not been approved') : t('No existing details found') + '.'
                }));
                return _context16.abrupt('return');

              case 19:
                if (!this.vnLocalUnitForeignerBlocked()) {
                  _context16.next = 22;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({
                  header: t('Warning', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t(_vietnam.VN_LOCAL_UNIT_FOREIGNER_MESSAGE, { ns: _translation.TRANSLATION_FILES.translation }),
                  autoHideDuration: 5000,
                  icon: 'warning sign'
                }));
                return _context16.abrupt('return');

              case 22:
                _context16.next = 24;
                return _AppForm2.default.validate(this.validation, booking);

              case 24:
                validations = _context16.sent;
                errMessages = validations.filter(function (v) {
                  return !v.isValid;
                });
                customer = {
                  identity: trimmedIdentity,
                  identityTypeID: !(0, _isNumber.isNumeric)(this.state.identityType) ? 6 : this.state.identityType,
                  identityPresetID: this.state.identityPresetID,
                  identityPresetLabel: this.state.identityPresetLabel,
                  identityPresetRegex: this.state.identityPresetRegex,
                  specifications: booking.customerSpecification,
                  externalID: booking.externalCustomerID,
                  taxIdentificationNo: booking.taxIdentificationNo,
                  taxTinValidationStatus: taxTinValidationStatus,
                  isForeignCompany: booking.isForeignCompany
                };
                bookingCustomer = {
                  address1: booking.address1,
                  address2: booking.address2,
                  address3: booking.address3,
                  address4: booking.address4,
                  address5: booking.address5,
                  address6: booking.address6,
                  address7: booking.address7,
                  address8: booking.address8,
                  address9: booking.address9,
                  address10: booking.address10,
                  country: booking.country,
                  email: booking.email,
                  mobile: booking.mobile,
                  mobilePrefix: booking.mobilePrefix,
                  name: booking.name,
                  phone: booking.phone,
                  phonePrefix: booking.phonePrefix,
                  preferredName: booking.preferredName,
                  title: this.state.hideTitle ? 'Not Applicable' : booking.title,
                  customerID: booking.customerID,
                  jobTitle: booking.jobTitle,
                  monthlyIncome: parseFloat(booking.monthlyIncome),
                  nationality: booking.nationality,
                  birthdate: booking.birthdate,
                  gender: booking.gender,
                  race: booking.race.toUpperCase() === 'Others'.toUpperCase() ? booking.raceOther : booking.race,
                  bumi: booking.bumi,
                  maritalStatus: booking.maritalStatus,
                  emergencyContactName: booking.emergencyContactName,
                  emergencyContactRelation: booking.emergencyContactRelation,
                  emergencyContactMobilePrefix: booking.emergencyContactMobilePrefix,
                  emergencyContactMobile: booking.emergencyContactMobile,
                  emergencyContactEmail: booking.emergencyContactEmail,
                  emergencyContactIdentity: booking.emergencyContactIdentity,
                  customer: customer,
                  leadCustomerID: booking.leadCustomerID,
                  leadICFrontURL: booking.leadICFrontURL,
                  leadICBackURL: booking.leadICBackURL,
                  externalID: booking.externalCustomerID,
                  himsKodPoskod: booking.himsKodPoskod,
                  himsKodBandar: booking.himsKodBandar,
                  himsKodDaerah: booking.himsKodDaerah,
                  himsKodNegeri: booking.himsKodNegeri,
                  himsKodNegara: booking.himsKodNegara,
                  sstRegistrationNo: booking.sstRegistrationNo
                };
                // CPI-1248: the primary purchaser's citizenship, which this payload used to drop - the
                // Purchaser tab (CPI-976 M4) has always sent it, so a reservation created here read back as
                // an undeclared purchaser. Vietnam only; the key is not added to a MY/ID payload at all.

                if (isVietnam) {
                  bookingCustomer.citizenship = booking.citizenship || '';
                }
                // CPI-974 (D18): post every CRM purchaser, primary first; always empty off Vietnam.
                postBooking = {
                  bookingCustomFields: bcf,
                  bookingCustomers: [bookingCustomer].concat(_toConsumableArray(this.state.srRelatedBookingCustomers)),
                  customerID: booking.customerID,
                  paymentMethodID: booking.paymentMethodID,
                  projectID: booking.projectID,
                  projectUnitID: booking.projectUnitID,
                  spaValue: parseInt(booking.spaValue, 10),
                  nettSellingPrice: parseFloat(booking.nettSellingPrice), // TODO Remove (deprecated tier pricing)
                  statusID: booking.statusID,
                  tierPricingName: booking.tierPricingName,
                  tierPricingDescription: booking.tierPricingDescription,
                  unitPackagePricingID: booking.unitPackagePricingID,
                  unitPackageFeeID: booking.unitPackageFeeID,
                  linkBuyerApp: booking.linkBuyerApp,
                  origin: booking.origin,
                  originID: booking.originID,
                  firstTimeBuyer: this.state.hideFirstTimeBuyer ? 'no' : booking.firstTimeBuyer,
                  externalID: booking.externalID
                };
                // clear unitPackagePricingID if base selling price selected

                if (projectUnitDetails.spaValue === booking.unitPackagePricingID) postBooking.unitPackagePricingID = '';
                if ((0, _vietnam.isVietnamCompany)(this.props.auth)) {
                  postBooking.waiveBankGuarantee = !!booking.waiveBankGuarantee;
                }
                postBooking = (0, _amount.fullToAmount)(postBooking, booking.spaValue);
                if (booking.maUserAffiliateCompanyBranchShortName && booking.maUserAffiliateCompanyBranchID && booking.maUserAffiliateCompanyID && booking.maUserAffiliateID && booking.maCreatedByPreferredName && booking.maUserID) {
                  // eslint-disable-next-line max-len
                  postBooking.maUserAffiliateCompanyBranchShortName = booking.maUserAffiliateCompanyBranchShortName;
                  postBooking.maUserAffiliateCompanyBranchID = booking.maUserAffiliateCompanyBranchID;
                  postBooking.maUserAffiliateCompanyID = booking.maUserAffiliateCompanyID;
                  postBooking.maUserAffiliateID = booking.maUserAffiliateID;
                  postBooking.maCreatedByName = booking.maCreatedByName;
                  postBooking.maCreatedByEmail = booking.maCreatedByEmail;
                  postBooking.maCreatedByPreferredName = booking.maCreatedByPreferredName;
                  postBooking.maUserID = booking.maUserID;
                }

                // set origin if booking is from lead
                if (this.state.opportunityID) {
                  postBooking.origin = 'lead';
                  // postBooking.originID = this.state.opportunityID;
                  postBooking.leadOpportunityID = this.state.opportunityID;
                }

                _context16.next = 37;
                return this.setComponentState({
                  errMessages: errMessages
                });

              case 37:
                header = t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation });

                if (isPRS) header = _react2.default.createElement(
                  'span',
                  null,
                  'Please fix form errors or inform the customer to update their details in ',
                  _react2.default.createElement(
                    'a',
                    { href: 'http://www.pr1ma.my', target: '_blank' },
                    'PRS system (www.pr1ma.my)'
                  )
                );

                if (customer.identityTypeID) {
                  _context16.next = 44;
                  break;
                }

                errMessagesWithIdentityType = Object.assign([], errMessages);

                errMessagesWithIdentityType.unshift({
                  isValid: false,
                  key: '',
                  message: t('Please select Identity Type')
                });
                store.dispatch((0, _flash.flashErrorMessage)({ header: header, list: errMessagesWithIdentityType.map(function (l) {
                    return l.message;
                  }) }));
                return _context16.abrupt('return');

              case 44:
                if (!(errMessages.length > 0)) {
                  _context16.next = 47;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: header, list: errMessages.map(function (l) {
                    return l.message;
                  }) }));
                return _context16.abrupt('return');

              case 47:
                if (!(!isVietnam && this.isUnderagePurchaser(bookingCustomer.birthdate))) {
                  _context16.next = 50;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ message: this.getMinimumPurchaserAgeMessage() }));
                return _context16.abrupt('return');

              case 50:
                if (!(!isVietnam && this.isUnderageNRICPurchaser(customer.identityTypeID, trimmedIdentity))) {
                  _context16.next = 53;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ message: this.getMinimumPurchaserAgeMessage() }));
                return _context16.abrupt('return');

              case 53:
                queryParams = new URLSearchParams(window.location.search);
                source = queryParams.get('source');
                res = void 0;
                _context16.prev = 56;
                _context16.next = 59;
                return this.form.submit('/bookings/' + (source ? '?source=' + source : ''), {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token,
                    'X-Origin': this.state.origin // client vendor source
                  },
                  body: JSON.stringify(postBooking)
                });

              case 59:
                res = _context16.sent;
                _context16.next = 102;
                break;

              case 62:
                _context16.prev = 62;
                _context16.t0 = _context16['catch'](56);

                if (!(_context16.t0.res && _context16.t0.res.status >= 400 && _context16.t0.res.status < 500)) {
                  _context16.next = 99;
                  break;
                }

                _context16.next = 67;
                return _context16.t0.res.text();

              case 67:
                message = _context16.sent;
                _context16.next = 70;
                return _context16.t0.res.headers.get('M-Type');

              case 70:
                mType = _context16.sent;

                if (!(mType === 'error_user_cooldown')) {
                  _context16.next = 74;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Booking Cooldown'), message: message, autoHideDuration: 5000, icon: 'wait' }));
                return _context16.abrupt('return');

              case 74:
                if (!(mType === 'error_bap_user_cooldown')) {
                  _context16.next = 79;
                  break;
                }

                defaultBookingStatus = this.state.project && this.state.project.defaultCustomBookingStatusID;
                _context16.next = 78;
                return store.dispatch((0, _flash.flashErrorMessage)({ header: defaultBookingStatus === 'reserved' ? 'Reservation Abuse Prevention' : 'Booking Abuse Prevention', message: message, autoHideDuration: 5000, icon: 'wait' }));

              case 78:
                return _context16.abrupt('return');

              case 79:
                if (!(mType === 'error_unit_unavailable')) {
                  _context16.next = 82;
                  break;
                }

                _context16.next = 82;
                return this.setComponentState({ showSwapUnit: true });

              case 82:
                if (!(mType === 'error_sr_status_not_approved')) {
                  _context16.next = 85;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({
                  header: t('Warning', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: message || t('Booking has not been approved'),
                  autoHideDuration: 5000,
                  icon: 'warning sign'
                }));
                return _context16.abrupt('return');

              case 85:
                if (!(mType === 'error_vn_local_unit_foreigner')) {
                  _context16.next = 88;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({
                  header: t('Warning', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: message || t(_vietnam.VN_LOCAL_UNIT_FOREIGNER_MESSAGE, { ns: _translation.TRANSLATION_FILES.translation }),
                  autoHideDuration: 5000,
                  icon: 'warning sign'
                }));
                return _context16.abrupt('return');

              case 88:
                if (!(mType === 'error_vn_foreign_threshold_exceeded')) {
                  _context16.next = 91;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({
                  header: t('Warning', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: message || t(_vietnam.VN_FOREIGN_THRESHOLD_MESSAGE, { ns: _translation.TRANSLATION_FILES.translation }),
                  autoHideDuration: 5000,
                  icon: 'warning sign'
                }));
                return _context16.abrupt('return');

              case 91:
                if (!(_context16.t0.res.status === 412)) {
                  _context16.next = 94;
                  break;
                }

                store.dispatch((0, _flash.flashMessage)({
                  header: t('Warning', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: message,
                  icon: 'warning sign',
                  type: 'warning',
                  autoHideDuration: 5000
                }));
                return _context16.abrupt('return');

              case 94:
                if (!message.includes('SPA')) {
                  _context16.next = 97;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Selling Price requires positive amount', { ns: _translation.TRANSLATION_FILES.translation }) }));
                return _context16.abrupt('return');

              case 97:
                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context16.abrupt('return');

              case 99:
                Bugsnag.notifyException(_context16.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context16.abrupt('return');

              case 102:
                _context16.next = 104;
                return this.setComponentState({
                  booking: Object.assign({}, BookingForm.defaultValues),
                  bookingSubmitted: true
                }, function () {
                  _this12.handleResetCheck(function (noChanges) {
                    if (noChanges) {
                      // The API checks the deferred rules without blocking reservation creation. Only
                      // contacts needing correction interrupt the configured next step with purchaser review.
                      var reviewRelatedPurchasers = isVietnam && res.purchasersIsolated && res.relatedPurchasersRequireReview === true;
                      var nextURL = reviewRelatedPurchasers ? '/bookings/' + res.id + '/?section=purchaser&reviewPurchasers=1' : (0, _routes.bookingFlow)(res, 0);
                      var _message = 'Unit is only considered successfully booked when checked and updated by admin';
                      if (booking.statusID === 'booked') {
                        _message = 'Unit is successfully booked';
                      }
                      store.dispatch((0, _reactRouterRedux.push)(nextURL));
                      store.dispatch((0, _flash.flashSuccessMessage)({
                        header: t('Unit {{reference}} is reserved', { reference: projectUnitDetails.reference, ns: _translation.TRANSLATION_FILES.translation }) + '.',
                        message: t(_message, { ns: _translation.TRANSLATION_FILES.translation }) + '.'
                      }));
                      store.dispatch((0, _bookQuery.clearBookQuery)()); // clear book query cache
                    }
                  });
                });

              case 104:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this, [[56, 62]]);
      }));

      function submitBooking() {
        return _ref17.apply(this, arguments);
      }

      return submitBooking;
    }()
  }, {
    key: 'handleGoBackToHeldUnit',

    // "Go back to A40.07": the held unit's page, where its Reserve screen can be reopened.
    value: function handleGoBackToHeldUnit() {
      var store = this.context.store;
      var _state11 = this.state,
          heldUnit = _state11.heldUnit,
          projectID = _state11.projectID;

      this.setState({ showLaunchModeMulti: false });
      store.dispatch((0, _reactRouterRedux.push)((0, _unitHold.heldUnitPagePath)(projectID, heldUnit.heldUnitID)));
    }
    // "Release A40.07 and continue": release the other hold, then take this unit's hold again.

  }, {
    key: 'handleReleaseHeldUnitAndContinue',
    value: function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var store, t, _state12, heldUnit, projectID, message;

        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                _state12 = this.state, heldUnit = _state12.heldUnit, projectID = _state12.projectID;
                _context17.next = 5;
                return this.setComponentState({ showLaunchModeMulti: false });

              case 5:
                _context17.next = 7;
                return this.setLoading('isFetching', true);

              case 7:
                _context17.prev = 7;
                _context17.next = 10;
                return store.dispatch((0, _fetchM.fetchM)((0, _unitHold.preReservedURL)(_config2.default.get('bookApiURL'), projectID, heldUnit.heldUnitID, { clear: true }), {
                  credentials: 'include',
                  method: 'GET',
                  ignoreForbidden: true,
                  ignoreNotFound: true,
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 10:
                _context17.next = 28;
                break;

              case 12:
                _context17.prev = 12;
                _context17.t0 = _context17['catch'](7);
                _context17.next = 16;
                return this.setLoading('isFetching', false);

              case 16:
                if (!(_context17.t0.res && _context17.t0.res.status >= 400 && _context17.t0.res.status < 500)) {
                  _context17.next = 22;
                  break;
                }

                _context17.next = 19;
                return _context17.t0.res.text();

              case 19:
                _context17.t1 = _context17.sent;
                _context17.next = 23;
                break;

              case 22:
                _context17.t1 = t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.';

              case 23:
                message = _context17.t1;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                _context17.next = 27;
                return this.setComponentState({ showLaunchModeMulti: true });

              case 27:
                return _context17.abrupt('return');

              case 28:
                _context17.next = 30;
                return this.setComponentState({ heldUnit: null, launchModeMultiErr: '' });

              case 30:
                _context17.next = 32;
                return this.fetchPreReservation(false);

              case 32:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this, [[7, 12]]);
      }));

      function handleReleaseHeldUnitAndContinue() {
        return _ref18.apply(this, arguments);
      }

      return handleReleaseHeldUnitAndContinue;
    }()
  }, {
    key: 'fetchPreReservation',
    value: function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var _this13 = this;

        var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var skipLoader = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var query, store, t, res, message, mType, defaultBookingStatus, json;
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                query = {};

                if (clear) {
                  query.clear = 'true';
                }
                store = this.context.store;
                t = this.props.t;

                if (skipLoader) {
                  _context18.next = 7;
                  break;
                }

                _context18.next = 7;
                return this.setLoading('isFetching', true);

              case 7:
                res = null;
                _context18.prev = 8;
                _context18.next = 11;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + this.state.projectID + '/units/' + this.state.projectUnitID + '/pre_reserved/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 11:
                res = _context18.sent;
                _context18.next = 52;
                break;

              case 14:
                _context18.prev = 14;
                _context18.t0 = _context18['catch'](8);

                if (!(_context18.t0.res && _context18.t0.res.status >= 400 && _context18.t0.res.status < 500)) {
                  _context18.next = 46;
                  break;
                }

                _context18.next = 19;
                return _context18.t0.res.text();

              case 19:
                message = _context18.sent;
                _context18.next = 22;
                return _context18.t0.res.headers.get('M-Type');

              case 22:
                mType = _context18.sent;

                if (!(mType === _unitHold.UNIT_HELD_M_TYPE)) {
                  _context18.next = 30;
                  break;
                }

                if (skipLoader) {
                  _context18.next = 27;
                  break;
                }

                _context18.next = 27;
                return this.setLoading('isFetching', false);

              case 27:
                _context18.next = 29;
                return this.setComponentState({
                  showLaunchModeMulti: true,
                  launchModeMultiErr: message,
                  heldUnit: (0, _unitHold.parseUnitHeldRefusal)(message, _context18.t0.res.headers)
                });

              case 29:
                return _context18.abrupt('return', null);

              case 30:
                if (!(mType === 'error_launch_mode_timeout')) {
                  _context18.next = 36;
                  break;
                }

                if (skipLoader) {
                  _context18.next = 34;
                  break;
                }

                _context18.next = 34;
                return this.setLoading('isFetching', false);

              case 34:
                _context18.next = 36;
                return this.setComponentState({ showSwapUnit: true });

              case 36:
                if (mType === 'error_launch_mode_locked') {
                  store.dispatch((0, _reactRouterRedux.push)('/projects/' + this.state.projectID + '/units/' + this.state.projectUnitID + '/'));
                }

                if (!(mType === 'error_bap_user_cooldown')) {
                  _context18.next = 44;
                  break;
                }

                defaultBookingStatus = this.state.project && this.state.project.defaultCustomBookingStatusID;
                _context18.next = 41;
                return store.dispatch((0, _reactRouterRedux.push)('/projects/' + this.state.projectID + '/units/'));

              case 41:
                _context18.next = 43;
                return store.dispatch((0, _flash.flashErrorMessage)({ header: defaultBookingStatus === 'reserved' ? 'Reservation Abuse Prevention' : 'Booking Abuse Prevention', message: message, autoHideDuration: 10000, icon: 'wait' }));

              case 43:
                return _context18.abrupt('return', null);

              case 44:
                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context18.abrupt('return', null);

              case 46:
                if (skipLoader) {
                  _context18.next = 49;
                  break;
                }

                _context18.next = 49;
                return this.setLoading('isFetching', false);

              case 49:
                Bugsnag.notifyException(_context18.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context18.abrupt('return', null);

              case 52:
                if (skipLoader) {
                  _context18.next = 55;
                  break;
                }

                _context18.next = 55;
                return this.setLoading('isFetching', false);

              case 55:
                _context18.next = 57;
                return res.json();

              case 57:
                json = _context18.sent;

                if (!json) {
                  _context18.next = 61;
                  break;
                }

                _context18.next = 61;
                return this.setComponentState({ reservedTimeoutExpireAt: json.reservedTimeoutExpireAt });

              case 61:
                if (clear) {
                  this.handleResetCheck(function () {
                    if (_this13.props.location.action === 'PUSH') {
                      store.dispatch((0, _reactRouterRedux.goBack)());
                    } else {
                      store.dispatch((0, _reactRouterRedux.replace)('/projects/' + _this13.state.projectID + '/units/' + _this13.state.projectUnitID + '/'));
                    }
                  });
                }
                return _context18.abrupt('return', null);

              case 63:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, this, [[8, 14]]);
      }));

      function fetchPreReservation() {
        return _ref19.apply(this, arguments);
      }

      return fetchPreReservation;
    }()
  }, {
    key: 'fetchPreReservationCooldown',
    value: function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        var skipLoader = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var store, t, message, mType;
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;

                if (skipLoader) {
                  _context19.next = 5;
                  break;
                }

                _context19.next = 5;
                return this.setLoading('isFetching', true);

              case 5:
                _context19.prev = 5;
                _context19.next = 8;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + this.state.projectID + '/units/' + this.state.projectUnitID + '/pre_reserved_cooldown/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                _context19.next = 33;
                break;

              case 10:
                _context19.prev = 10;
                _context19.t0 = _context19['catch'](5);

                if (!(_context19.t0.res && _context19.t0.res.status >= 400 && _context19.t0.res.status < 500)) {
                  _context19.next = 27;
                  break;
                }

                _context19.next = 15;
                return _context19.t0.res.text();

              case 15:
                message = _context19.sent;
                _context19.next = 18;
                return _context19.t0.res.headers.get('M-Type');

              case 18:
                mType = _context19.sent;

                if (!(mType === 'error_user_cooldown')) {
                  _context19.next = 25;
                  break;
                }

                _context19.next = 22;
                return store.dispatch((0, _reactRouterRedux.push)('/projects/' + this.state.projectID + '/units/' + this.state.projectUnitID + '/'));

              case 22:
                _context19.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ header: t('Booking Cooldown'), message: message, autoHideDuration: 10000, icon: 'wait' }));

              case 24:
                return _context19.abrupt('return');

              case 25:
                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context19.abrupt('return');

              case 27:
                if (skipLoader) {
                  _context19.next = 30;
                  break;
                }

                _context19.next = 30;
                return this.setLoading('isFetching', false);

              case 30:
                Bugsnag.notifyException(_context19.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context19.abrupt('return');

              case 33:
                if (skipLoader) {
                  _context19.next = 36;
                  break;
                }

                _context19.next = 36;
                return this.setLoading('isFetching', false);

              case 36:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, this, [[5, 10]]);
      }));

      function fetchPreReservationCooldown() {
        return _ref20.apply(this, arguments);
      }

      return fetchPreReservationCooldown;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var store = this.context.store;
      var pathname = this.props.location.pathname;

      var queryNew = query;
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));
    }
  }, {
    key: 'renderCustomField',
    value: function renderCustomField(t, data, idx) {
      var _this14 = this;

      if (data.isDefault) {
        if (data.name === 'emergencyContactMobile') {
          var emergencyContactValidation = [{
            validate: _webValidations.phoneNumber,
            option: this.state.booking.emergencyContactMobilePrefix === 'other' ? {} : {
              isMobile: true,
              phonePrefix: this.state.booking.emergencyContactMobilePrefix,
              validRegex: (0, _phone.getPhoneValidRegex)(this.state.phoneValidationPresets, this.state.booking.emergencyContactMobilePrefix, 'mobile')
            }
          }];
          if (this.isCustomFieldRequiredAtStatus(data) && !data.isDisabled) {
            emergencyContactValidation.push(_webValidations.required);
          }
          return _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { key: idx, width: 16 },
            _react2.default.createElement(
              _semanticUiReact.Form.Group,
              { widths: 'equal' },
              _react2.default.createElement(
                _AppForm2.default.Validate,
                {
                  ref: this.validation.emergencyContactMobilePrefix,
                  onChange: this.handleSelectChange,
                  validateLabel: t('{{label}} Prefix', { label: data.label })
                },
                _react2.default.createElement(_semanticUiReact.Form.Select, {
                  disabled: this.isVNFormLocked(),
                  label: t('{{label}} Prefix', { label: data.label, ns: _translation.TRANSLATION_FILES.models.customer }),
                  name: 'emergencyContactMobilePrefix',
                  onChange: this.handleSelectChange,
                  options: this.toUppercaseOptions(_intlCallCodes2.default),
                  search: true,
                  selectOnBlur: false,
                  value: this.state.booking.emergencyContactMobilePrefix
                })
              ),
              _react2.default.createElement(_PhoneInput2.default, {
                autoComplete: 'off',
                disabled: this.isVNFormLocked(),
                label: '' + data.label + (this.isCustomFieldRequiredAtStatus(data) ? '*' : ''),
                name: 'emergencyContactMobile',
                onChange: this.handleInputChange,
                placeholder: data.label,
                prefix: this.state.booking.emergencyContactMobilePrefix,
                ref: this.validation.emergencyContactMobile,
                type: 'tel',
                validation: emergencyContactValidation,
                value: this.state.booking.emergencyContactMobile,
                validateLabel: data.label
              })
            )
          );
        }
        if (data.name === 'birthdate') {
          return _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { key: idx, mobile: 16, tablet: 8, computer: 8 },
            _react2.default.createElement(
              _semanticUiReact.Form.Group,
              { widths: 'equal' },
              _react2.default.createElement(_InputBirthdate2.default, {
                date: this.state.booking.birthdate,
                onSelectDay: this.handleBirthdateSelect,
                label: '' + data.label + (this.isCustomFieldRequiredAtStatus(data) ? '*' : ''),
                disabled: this.state.identityType === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN || this.isVNFormLocked()
              })
            )
          );
        }
        if (data.name === 'race') {
          var raceOptions = _race.RACE.map(function (o) {
            return _extends({}, o, {
              text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants })
            });
          });
          return _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { key: idx, mobile: 16, tablet: 8, computer: 8 },
            _react2.default.createElement(
              _semanticUiReact.Form.Group,
              { widths: 'equal' },
              _react2.default.createElement(
                _AppForm2.default.Validate,
                {
                  validation: this.isCustomFieldRequiredAtStatus(data) && !data.isDisabled ? [_webValidations.required] : null,
                  ref: this.validation.race,
                  onChange: function onChange(e, d) {
                    return _this14.handleCustomSelectChange(e, d, data.id, raceOptions);
                  },
                  validateLabel: data.label
                },
                _react2.default.createElement(_semanticUiReact.Form.Select, {
                  disabled: this.isVNFormLocked(),
                  name: 'race',
                  fluid: true,
                  options: this.toUppercaseOptions(raceOptions),
                  placeholder: data.label,
                  label: '' + data.label + (this.isCustomFieldRequiredAtStatus(data) ? '*' : ''),
                  search: true,
                  selectOnBlur: false,
                  value: this.state.booking.race
                })
              ),
              _react2.default.createElement(_AppForm2.default.Input, {
                autoComplete: 'off',
                disabled: this.state.booking.race.toUpperCase() !== 'Others'.toUpperCase() || this.isVNFormLocked(),
                fluid: true,
                name: 'raceOther',
                onChange: this.handleInputChange,
                placeholder: t('Fill in your Race'),
                label: (0, _translation2.translateModels)(t, 'raceOther', 'booking'),
                ref: this.validation.raceOther,
                validateLabel: (0, _translation2.translateModels)(t, 'raceOther', 'booking'),
                validation: this.state.booking.race.toUpperCase() === 'Others'.toUpperCase() ? [_webValidations.required] : null
              })
            )
          );
        }
      }
      if (data.type === 'input') {
        return _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { key: idx, mobile: 16, tablet: 8, computer: 8 },
          _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal' },
            _react2.default.createElement(_AppForm2.default.Input, {
              disabled: data.isDisabled || this.isVNFormLocked() || isPRS && data.name === 'no_rujukan_pr1ma',
              autoComplete: 'off',
              label: '' + data.label + (this.isCustomFieldRequiredAtStatus(data) ? '*' : ''),
              name: data.name,
              onChange: function onChange(e) {
                return _this14.handleCustomInputChange(e, data.id, data.isDefault);
              },
              placeholder: data.placeholder,
              ref: this.validation[data.name],
              validation: this.isCustomFieldRequiredAtStatus(data) && !data.isDisabled && !(isPRS && data.name === 'no_rujukan_pr1ma') ? [_webValidations.required, {
                validate: function validate(value) {
                  return (0, _RegexDropdownPicker.checkRegex)(value, data);
                }
              }] : [{
                validate: function validate(value) {
                  return (0, _RegexDropdownPicker.checkRegex)(value, data);
                }
              }],
              value: this.state.booking[data.name],
              validateLabel: data.label
            })
          )
        );
      }
      if (data.type === 'textarea') {
        return _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { key: idx, mobile: 16, tablet: 8, computer: 8 },
          _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal' },
            _react2.default.createElement(
              _AppForm2.default.Validate,
              {
                validation: this.isCustomFieldRequiredAtStatus(data) && !data.isDisabled ? [_webValidations.required] : null,
                ref: this.validation[data.name],
                onChange: function onChange(e) {
                  return _this14.handleCustomInputChange(e, data.id, data.isDefault);
                },
                validateLabel: data.label
              },
              _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                disabled: data.isDisabled || this.isVNFormLocked(),
                autoComplete: 'off',
                label: '' + data.label + (this.isCustomFieldRequiredAtStatus(data) ? '*' : ''),
                name: data.name,
                placeholder: data.placeholder,
                ref: this.validation[data.name],
                value: this.state.booking[data.name],
                style: { minHeight: '6em', height: '6em' }
              })
            )
          )
        );
      }
      if (data.type === 'dropdown' || data.type === 'dropdown_multi') {
        var renderLabel = function renderLabel(label) {
          return {
            content: label.text,
            circular: true
          };
        };
        var customFieldOptions = [];
        if (data.projectBookingCustomFieldOptions && data.projectBookingCustomFieldOptions.length > 0) {
          data.projectBookingCustomFieldOptions.sort(function (a, b) {
            return a.position - b.position;
          }).forEach(function (d) {
            customFieldOptions.push({ text: d.title, value: d.value, id: d.id });
          });
        }
        if (data.isDefault) {
          switch (data.name) {
            case 'nationality':
              customFieldOptions = _countries.SELECT_NATIONALITY;
              break;
            case 'gender':
              customFieldOptions = _gender.GENDER.map(function (o) {
                return _extends({}, o, {
                  text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants })
                });
              });
              break;
            case 'bumi':
              customFieldOptions = _bumi.BUMI.map(function (o) {
                return _extends({}, o, {
                  text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants })
                });
              });
              break;
            case 'maritalStatus':
              customFieldOptions = _maritalStatus.MARITAL_STATUS.map(function (o) {
                return _extends({}, o, {
                  text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants })
                });
              });
              break;
            default:
              break;
          }
        }
        var value = this.state.booking[data.name];
        if (data.type === 'dropdown_multi') {
          if (this.state.booking[data.name] && value !== '') {
            value = value.split(',');
          } else {
            value = [];
          }
        }
        return _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { key: idx, mobile: 16, tablet: 8, computer: 8 },
          _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal' },
            _react2.default.createElement(
              _AppForm2.default.Validate,
              {
                key: idx,
                validation: this.isCustomFieldRequiredAtStatus(data) && !data.isDisabled ? [_webValidations.required] : null,
                ref: this.validation[data.name],
                onChange: function onChange(e, d) {
                  return _this14.handleCustomSelectChange(e, d, data.id, customFieldOptions);
                },
                validateLabel: data.label
              },
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                disabled: data.isDisabled || this.isVNFormLocked(),
                className: 'custom_dropdown',
                label: '' + data.label + (this.isCustomFieldRequiredAtStatus(data) ? '*' : ''),
                name: data.name,
                options: this.toUppercaseOptions(customFieldOptions),
                placeholder: data.placeholder,
                search: true,
                selectOnBlur: false,
                value: value,
                multiple: data.type === 'dropdown_multi',
                renderLabel: renderLabel,
                clearable: true
              })
            )
          )
        );
      }
      return '';
    }
    // CPI-974 (D5): the Booking ID search takes the Identity Type row's position. Vietnam only.


    // What the CRM said about the buyer the agent swapped in.

  }, {
    key: 'renderCustomFields',
    value: function renderCustomFields(t, fields, isDefault) {
      var _this15 = this;

      var auth = this.props.auth;

      var customFields = fields;
      if (isDefault && customFields && customFields.length < 1) {
        customFields = _defaultBookingFields.EXTRA_PURCHASER_CUSTOM_FIELDS;
      }
      // CPI-976: Vietnam has no race / bumi / SST Registration No. default purchaser fields.
      if (isDefault && customFields && (0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode)) {
        customFields = customFields.filter(function (f) {
          return !['race', 'bumi', 'sstRegistrationNo'].includes(f.name);
        });
      }
      if (customFields && customFields.length > 0) {
        return _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            customFields.filter(function (f) {
              return _defaultBookingFields.PURCHASER_CUSTOM_FIELDS.some(function (pf) {
                return f.name !== pf.name && !f.isHidden;
              });
            }).sort(function (a, b) {
              return a.position - b.position;
            }).map(function (data, idx) {
              return _this15.renderCustomField(t, data, idx);
            })
          )
        );
      }
      return '';
    }
  }, {
    key: 'hasAccessNettSellingPrice',
    value: function hasAccessNettSellingPrice(project) {
      var auth = this.props.auth;

      if (auth.isSuperAdmin || auth.isHeadquarters) {
        return true;
      }
      if (project && project.accessBULNettSellingPrice && auth.isBranchLeader) {
        return true;
      }
      if (project && project.accessStaffNettSellingPrice && auth && auth.companyBranch) {
        return true;
      }
      return false;
    }
    // CPI-977 (PO, 14 Sep): shown on every Vietnam reservation, whether or not the package
    // carries a BGW discount line - the tick is recorded on the booking, no discount is implied.

    // CPI-977 S4: one number, the deposit to collect; book-api computes it from the package's rate.
    // Not mounted since 14 Sep (PO: hide the grey box for now) - kept for when the deposit comes back.

    // CPI-977 (PO mock-up, 2 Sep): the Vietnam booking summary sits inline under Booking Details
    // and follows the package, the waiver and the fee package live - one card, no preview button.
    // Every number is the server's own preview (newPPI / newBFP), the same ones the price panel uses.

    // "Edit Package" on the summary takes the agent back to the Pricing Package dropdown above.

  }, {
    key: 'render',
    value: function render() {
      var _this16 = this;

      var _props3 = this.props,
          auth = _props3.auth,
          appConfig = _props3.appConfig,
          t = _props3.t;
      var _state13 = this.state,
          isLaunchMode = _state13.isLaunchMode,
          paymentMethods = _state13.paymentMethods,
          projectUnitDetails = _state13.projectUnitDetails,
          projectAllowLinkBuyerApp = _state13.projectAllowLinkBuyerApp,
          reservedTimeoutExpireAt = _state13.reservedTimeoutExpireAt,
          searchUserValue = _state13.searchUserValue,
          showCountdown = _state13.showCountdown,
          showPurchaserExtraFields = _state13.showPurchaserExtraFields,
          showLaunchModeMulti = _state13.showLaunchModeMulti,
          launchModeMultiErr = _state13.launchModeMultiErr,
          heldUnit = _state13.heldUnit,
          isPreviewing = _state13.isPreviewing,
          project = _state13.project,
          projectCustomFields = _state13.projectCustomFields,
          screenWidth = _state13.screenWidth;
      var user = auth.user;

      var packagePricings = this.vnApplyLivePackageTotals(this.filterPackingPricing(this.state.packagePricings));
      var defaultBookingStatus = this.state.project && this.state.project.defaultCustomBookingStatusID;
      var feePackages = this.filterFeePackages(this.state.feePackages);
      var showAutofill = this.hasAutofillAccess();
      var paymentMethodOptions = this.state.booking.linkBuyerApp ? paymentMethods.filter(function (m) {
        return m.value === 'referred_banker' || m.value === 'own_banker';
      }) : paymentMethods;
      // add validateRef for all custom fields
      if (projectCustomFields && projectCustomFields.length > 0) {
        projectCustomFields.filter(function (f) {
          return _defaultBookingFields.PURCHASER_CUSTOM_FIELDS.some(function (pf) {
            return f.name !== pf.name && !f.isHidden;
          });
        }).forEach(function (pcf) {
          _this16.validation[pcf.name] = (0, _react.createRef)();
        });
      }
      var himsIsEnabled = appConfig && appConfig.data && appConfig.data.himsIsEnabled && project && project.himsIsEnabled;
      var enabledAddressSettings = this.props.addressSettings.data.filter(function (as) {
        return as.enabled;
      });
      var isBCustomerMalaysia = this.state.booking.country.toUpperCase() === 'MY';
      var isMalaysia = auth.company && auth.company.countryCode.toUpperCase() === 'MY';
      var isIndonesia = auth.company && auth.company.countryCode.toUpperCase() === 'ID';
      var isVietnam = auth.company && auth.company.countryCode.toUpperCase() === 'VN';
      var hideLabel = isIndonesia || this.state.isForeignCompany;
      var inputs = enabledAddressSettings.map(function (as, idx) {
        var key = _lodash2.default.camelCase(as.columnName);
        var addressLabel = as.label.toLowerCase();
        var isRequired = as.required;
        var errMessage = null;
        var validations = [{
          validate: _webValidations.stringLength,
          option: {
            max: 256
          }
        }];

        // When company is Vietnam: apply country-dependent logic for state field
        if (isVietnam && addressLabel === 'state') {
          if (isBCustomerMalaysia) {
            // Malaysia selected: keep as "State", required
            isRequired = true;
          } else {
            // Non-Malaysia selected: change to "City/Province", optional
            addressLabel = 'cityOrProvince';
            isRequired = false;
          }
        } else if (isVietnam && addressLabel === 'city' && !isBCustomerMalaysia) {
          addressLabel = 'ward';
          isRequired = false;
        } else if (isVietnam && addressLabel === 'postcode' && !isBCustomerMalaysia) {
          addressLabel = 'postalCode';
          isRequired = false;
        }
        if (isRequired) {
          validations.push(_webValidations.required);
        }
        if (!himsIsEnabled && isBCustomerMalaysia && as.label.toLowerCase() === 'postcode') {
          validations.push({
            validate: _webValidations.matchRegex,
            option: {
              validRegex: _regex.REGEX_POSTCODE_MY
            }
          });
          errMessage = 'Invalid MY postcode format';
        }

        var label = '' + (0, _translation2.translateModels)(t, addressLabel, 'booking') + (isRequired ? '*' : '');

        if (!isPRS && isBCustomerMalaysia && as.label.toLowerCase() === 'state') {
          return _react2.default.createElement(
            _AppForm2.default.Validate,
            {
              key: idx,
              validation: isRequired ? [_webValidations.required] : null,
              ref: _this16.validation[key],
              onChange: _this16.handleSelectChange,
              validateLabel: as.label.toLowerCase() === 'state' ? (0, _translation2.translateModels)(t, 'state', 'booking') : as.label
            },
            _react2.default.createElement(_semanticUiReact.Form.Select, {
              name: key,
              disabled: _this16.isVNFormLocked(),
              fluid: true,
              options: _this16.toUppercaseOptions(_states2.default),
              placeholder: t('Select {{title}}', { title: label.toLowerCase() }),
              label: label,
              search: true,
              selectOnBlur: false,
              value: _this16.state.booking[key]
            })
          );
        }

        if (himsIsEnabled && isBCustomerMalaysia && as.label.toLowerCase() === 'postcode') {
          return _react2.default.createElement(_SearchHimsPostcodes2.default, {
            validateRef: _this16.validation.himsKodPoskod,
            name: 'himsKodPoskod',
            onSelect: _this16.handleSelectHimsPostcode,
            state: _this16.state.booking.address7,
            value: _this16.state.booking.himsKodPoskod
          });
        }

        return _react2.default.createElement(_AppForm2.default.Input, {
          key: idx,
          autoComplete: 'off',
          disabled: _this16.isVNFormLocked(),
          name: key,
          onChange: _this16.handleInputChange,
          placeholder: label,
          label: label,
          ref: _this16.validation[key],
          validation: validations,
          value: _this16.state.booking[key],
          validateLabel: label,
          message: errMessage
        });
      });
      inputs.push(_react2.default.createElement(
        _AppForm2.default.Validate,
        {
          key: 'inputs_country',
          validation: [_webValidations.required],
          ref: this.validation.country,
          onChange: function onChange(e, data) {
            // Reset state input field
            if (!isPRS) {
              var as = enabledAddressSettings.find(function (a) {
                return a.label.toLowerCase() === 'state';
              });
              if (as) {
                var key = _lodash2.default.camelCase(as.columnName);
                var booking = _this16.state.booking;

                if (booking[key]) {
                  booking[key] = '';
                  _this16.setState({ booking: booking });
                }
              }
            }
            _this16.handleSelectChange(e, data);
          },
          validateLabel: (0, _translation2.translateModels)(t, 'country', 'booking')
        },
        _react2.default.createElement(_semanticUiReact.Form.Select, {
          autoComplete: 'off',
          disabled: this.isVNFormLocked(),
          fluid: true,
          label: (0, _translation2.translateModels)(t, 'country', 'booking') + '*',
          name: 'country',
          options: this.toUppercaseOptions(_countries.SELECT_COUNTRIES),
          placeholder: t('Select {{title}}', { title: (0, _translation2.translateModels)(t, 'country', 'booking') }) + '*',
          search: true,
          selectOnBlur: false,
          value: this.state.booking.country
        })
      ));
      // CPI-1248: Citizenship on the reservation form, Vietnam only. Both VN rules - the Local unit
      // restriction and the foreign control threshold - are decided on this value at create time,
      // and nothing re-runs them afterwards, so it has to be confirmed before Save and Continue
      // rather than inherited invisibly from the CRM. The Booking ID lookup still prefills it; the
      // user can correct it, and a blank one can no longer be submitted. `nationality` is a separate
      // field and is never a substitute for this declaration.
      if (isVietnam) {
        inputs.push(_react2.default.createElement(
          _AppForm2.default.Validate,
          {
            key: 'inputs_citizenship',
            validation: [_webValidations.required],
            ref: this.validation.citizenship,
            onChange: this.handleSelectChange,
            validateLabel: t('Citizenship')
          },
          _react2.default.createElement(_semanticUiReact.Form.Select, {
            autoComplete: 'off',
            disabled: this.isVNFormLocked(),
            fluid: true,
            label: t('Citizenship') + '*',
            name: 'citizenship',
            options: this.toUppercaseOptions([{ text: t('Local'), value: _vietnam.CITIZENSHIP_LOCAL }, { text: t('Foreigner'), value: _vietnam.CITIZENSHIP_FOREIGNER }]),
            placeholder: t('Select {{title}}', { title: t('Citizenship') }) + '*',
            selectOnBlur: false,
            value: this.state.booking.citizenship
          })
        ));
      }
      var constructIdentityTypeDropdown = function constructIdentityTypeDropdown() {
        return isPRS ? _react2.default.createElement(_AppForm2.default.Input, {
          loading: _this16.state.loaders.searchingID,
          autoComplete: 'off',
          name: 'prsID',
          onChange: _this16.handlePRSIDChange,
          placeholder: t('PRS ID') + '*',
          ref: _this16.validation.prsID,
          readOnly: _this16.state.identityLock,
          validation: [_webValidations.required, {
            validate: _webValidations.stringLength,
            option: {
              min: 13
            }
          }],
          value: _this16.state.prsID,
          validateLabel: t('PRS ID')
        }) : _react2.default.createElement(_semanticUiReact.Dropdown, {
          disabled: _this16.state.identityLock || _this16.state.loaders.searchingID || _this16.state.booking.linkBuyerApp || _this16.isVNFormLocked(),
          fluid: true,
          name: 'identityType',
          onChange: _this16.handleIDTypeChange,
          options: _this16.toUppercaseOptions(_this16.state.identityTypeOpts),
          placeholder: t('Select {{title}}', { title: t('Identity Type') }) + '*',
          selection: true,
          selectOnBlur: false,
          value: _this16.state.identityType
        });
      };
      var constructIdentityInput = function constructIdentityInput() {
        return _react2.default.createElement(_Input2.default, {
          className: 'ui input\n          ' + (_this16.isLoading('searchingID') || _this16.state.vnCRMLookup === 'searching' ? 'loading circle notched icon ' : '') + '\n          ' + (_this16.hasResetIdentityIcon() ? 'icon ' : '') + '\n          ' + (_this16.state.identityError ? ' error' : ''),
          label: _this16.getIdentityInputLabel(hideLabel),
          disabled: _this16.state.identityType === '' || _this16.state.loaders.searchingID || _this16.isVNFormLocked(),
          name: 'identity',
          placeholder: '' + t(_this16.getIdentityPlaceholder(isIndonesia)),
          readOnly: _this16.state.identityLock,
          inputRef: _this16.identityInputRef,
          type: _this16.state.identityType === 1 ? 'tel' : 'text',
          value: _this16.state.identity,
          icon: _this16.hasResetIdentityIcon() ? _react2.default.createElement(_semanticUiReact.Icon, {
            link: true,
            name: 'x',
            onClick: _this16.handleResetAutofill,
            title: t('Clear Form')
          }) : _this16.isLoading('searchingID') || _this16.state.vnCRMLookup === 'searching' ? _react2.default.createElement(_semanticUiReact.Icon, { loading: true, name: 'circle notch' }) : null,
          validation: [_webValidations.required, {
            validate: _webValidations.identity,
            option: _this16.identityValidation()
          }],
          ref: _this16.validation.identity,
          onChange: _this16.handleIdentityChange,
          validateLabel: t(isPRS ? 'NRIC Number' : 'Identity'),
          onError: function onError(identityError) {
            _this16.setState({ identityError: identityError });
          }
        });
      };
      var constructTinInput = function constructTinInput() {
        var mustValidTinForMY = !isIndonesia && _this16.state.identityType !== 2 && (_this16.state.identityType === 4 || _this16.state.project && _this16.state.project.requireValidTinAtBookingCreation);

        var tinValidation = [];
        if (isIndonesia) {
          tinValidation = [{
            validate: _webValidations.matchRegex,
            option: {
              validRegex: _regex.REGEX_NPWP_ID
            }
          }];
        } else {
          tinValidation = mustValidTinForMY && !_this16.state.isForeignCompany ? [_webValidations.required, {
            validate: _webValidations.matchRegex,
            option: { validRegex: _regex.REGEX_TIN_VALID }
          }] : [{
            validate: _webValidations.matchRegex,
            option: { validRegex: _regex.REGEX_TIN_VALID }
          }];
        }

        return _react2.default.createElement(_TinFieldInput2.default, {
          isIndonesia: isIndonesia,
          value: _this16.state.taxIdentificationNo,
          errMessage: _this16.state.tinMessage,
          isLoading: _this16.isLoading('validatingTIN'),
          tinError: isMalaysia && _this16.state.tinError,
          required: isMalaysia && mustValidTinForMY && !_this16.state.isForeignCompany,
          validation: tinValidation,
          ref: _this16.validation.taxIdentificationNo,
          onChange: _this16.handleTinInput,
          identityType: _this16.state.identityType,
          identityValue: _this16.state.identity
          // readOnly={isMalaysia && this.state.tinFound}
          , unitID: _this16.state.projectUnitID
        });
      };
      var isForeignCompanyCheckbox = function isForeignCompanyCheckbox() {
        return _react2.default.createElement(
          'div',
          { style: { display: 'flex', justifyContent: 'start', marginTop: '1em' } },
          _react2.default.createElement(_semanticUiReact.Checkbox, {
            label: t('Foreign Company', { ns: _translation.TRANSLATION_FILES.screens }),
            onChange: function onChange(e, d) {
              var setStateTin = d.checked ? _tin.FOREIGN_BUYER_GENERIC_TIN : '';
              _this16.setState(function (prevState) {
                return {
                  booking: _extends({}, prevState.booking, {
                    taxIdentificationNo: setStateTin,
                    isForeignCompany: d.checked
                  }),
                  taxIdentificationNo: setStateTin,
                  isForeignCompany: d.checked
                };
              }, function () {
                _this16.handleTinInput({ target: { value: d.checked ? setStateTin : '', tinFound: false } });
              });
            },
            checked: _this16.state.isForeignCompany
          })
        );
      };
      var isMobile = screenWidth <= 767;
      var isTablet = screenWidth > 767 && screenWidth <= 991;
      var isComputer = screenWidth > 991;
      var constructResponsiveIdentityTinInputs = function constructResponsiveIdentityTinInputs() {
        return _react2.default.createElement(
          _react2.default.Fragment,
          null,
          isMobile && _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 1, centered: true },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { style: { marginBottom: _this16.getIdentityInputLabel(hideLabel) ? '1rem' : '1.5rem' } },
              constructIdentityTypeDropdown(),
              isMalaysia && _this16.state.identityType === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && isForeignCompanyCheckbox()
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', style: { marginBottom: '1rem' } },
              constructIdentityInput()
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              (isMalaysia || isIndonesia) && constructTinInput()
            )
          ),
          isTablet && _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 3, centered: true },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { style: { marginTop: _this16.getIdentityInputLabel(hideLabel) ? '2.2rem' : '1.9rem' } },
              constructIdentityTypeDropdown(),
              isMalaysia && _this16.state.identityType === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && isForeignCompanyCheckbox()
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', style: { marginTop: _this16.getIdentityInputLabel(hideLabel) ? '0.1rem' : '1.9rem' } },
              constructIdentityInput()
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { style: { marginTop: _this16.getIdentityInputLabel(hideLabel) ? '1.3rem' : '0rem' } },
              (isMalaysia || isIndonesia) && constructTinInput()
            )
          ),
          isComputer && _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 3, centered: true },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { style: { marginTop: '1.9rem' } },
              constructIdentityTypeDropdown(),
              isMalaysia && _this16.state.identityType === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && isForeignCompanyCheckbox()
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', style: { marginTop: _this16.getIdentityInputLabel(hideLabel) ? '0.1rem' : '1.9rem' } },
              constructIdentityInput()
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              (isMalaysia || isIndonesia) && constructTinInput()
            )
          )
        );
      };

      return _react2.default.createElement(
        _AppForm2.default,
        {
          error: this.state.errMessages.length > 0,
          onSubmit: this.handleSubmit,
          ref: function ref(_ref21) {
            _this16.form = _ref21;
          }
        },
        _react2.default.createElement(_BookingSwapUnit2.default, {
          open: this.state.showSwapUnit,
          onClose: this.handleCancelChange,
          onConfirm: this.handleConfirmChange,
          projectUnitClear: this.handleProjectUnitClear,
          projectUnitSelect: this.handleProjectUnitSelect,
          projectUnitselectedValue: this.state.selectedProjectUnit,
          projectID: this.state.projectID,
          hasAccess: this.hasUnitSwapAccess(),
          error: this.state.projectUnitSwapError || false,
          manualSwap: this.state.manualSwap
        }),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          { open: this.state.modalReservationIsOpen, basic: true, size: 'small', closeOnDimmerClick: false, closeOnDocumentClick: false },
          _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: t('Reservation Limit Exceeded') }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              'p',
              null,
              t('Your business unit has reached it\'s reservation limit of {{limit}}. Please contact {{company}}', {
                limit: user && user.affiliate && user.affiliate.companyBranch ? user.affiliate.companyBranch.reservationLimit : 0,
                company: user && user.affiliate && user.affiliate.company ? user.affiliate.company.name : ''
              }) + '.'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                color: 'green',
                inverted: true,
                onClick: this.handleModalReservationClose
              },
              t('Okay', { ns: _translation.TRANSLATION_FILES.translation })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          { size: 'small', open: showLaunchModeMulti, onClose: this.handleCloseLaunchModeMultiModal },
          _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: t('Error', { ns: _translation.TRANSLATION_FILES.translation }) }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Modal.Description,
              null,
              launchModeMultiErr
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            heldUnit && heldUnit.heldUnitID ? _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(_semanticUiReact.Button, {
                onClick: function onClick(e) {
                  e.preventDefault();_this16.handleGoBackToHeldUnit();
                },
                content: t('Go back to {{reference}}', { reference: heldUnit.heldUnitReference, ns: _translation.TRANSLATION_FILES.translation })
              }),
              _react2.default.createElement(_semanticUiReact.Button, {
                color: 'green',
                onClick: function onClick(e) {
                  e.preventDefault();_this16.handleReleaseHeldUnitAndContinue();
                },
                content: t('Release {{reference}} and continue', { reference: heldUnit.heldUnitReference, ns: _translation.TRANSLATION_FILES.translation })
              })
            ) : _react2.default.createElement(_semanticUiReact.Button, {
              onClick: this.handleCloseLaunchModeMultiModal,
              content: t('Close', { ns: _translation.TRANSLATION_FILES.translation })
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              isLaunchMode && reservedTimeoutExpireAt && _react2.default.createElement(
                _semanticUiReact.Message,
                { size: 'mini', style: { textAlign: 'center', fontWeight: 'bold' } },
                showCountdown ? _react2.default.createElement(
                  'span',
                  null,
                  t('Time remaining'),
                  '\xA0',
                  _react2.default.createElement(_CountdownAdvance2.default, {
                    targetDate: (0, _momentTimezone2.default)(reservedTimeoutExpireAt).toDate(),
                    timeSeparator: ' ',
                    onFinished: this.handleCountdownFinish,
                    format: this.getCountdownFormat(projectUnitDetails.reservedTimeoutExpireAt),
                    leadingZero: true
                  }),
                  '\xA0',
                  _react2.default.createElement(
                    'button',
                    {
                      className: 'a-button-blue',
                      onClick: function onClick(e) {
                        e.preventDefault();
                        _this16.handleClearTimer();
                      }
                    },
                    _react2.default.createElement(
                      'u',
                      null,
                      t('Cancel and release unit')
                    )
                  )
                ) : t('Unit now available for all'),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'small',
                  null,
                  'You will be redirected to the unit selection page once the countdown ends.',
                  this.hasAccessIsExternalAgent() && project.bapIsEnabled ? _react2.default.createElement('br', null) : '',
                  this.hasAccessIsExternalAgent() && project.bapIsEnabled ? 'Abuse prevention has been turned on. You may lock this unit for a maximum of ' + project.bapMaxAttempts + ' attempts within ' + project.bapWindowMinutes + ' mins. Failure to complete a ' + (defaultBookingStatus === 'reserved' ? 'reservation' : 'booking') + ' will result in a ' + (project.bapIsProjectMode ? 'project-wide' : '') + ' ban for ' + project.bapCooldownMinutes + ' mins.' : ''
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { padded: true },
                _react2.default.createElement(
                  _semanticUiReact.Dimmer,
                  { style: { zIndex: 20 }, active: this.isLoading('isFetching'), inverted: true },
                  _react2.default.createElement(
                    _semanticUiReact.Loader,
                    { inline: 'centered' },
                    t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                  )
                ),
                projectUnitDetails.reference && projectUnitDetails.projectName ? _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Header,
                    { textAlign: 'center' },
                    t(isVietnam ? 'Unit selection for' : 'Booking for'),
                    ' ',
                    _react2.default.createElement('br', { className: 'large-hide small-hide tablet-hide' }),
                    _react2.default.createElement(
                      'button',
                      {
                        className: 'a-button-blue',
                        onClick: function onClick(e) {
                          e.preventDefault();
                          _this16.handleShowSwapUnit();
                        }
                      },
                      projectUnitDetails.reference
                    ),
                    ', ',
                    projectUnitDetails.projectName,
                    projectUnitDetails.isBumi && _react2.default.createElement(
                      _semanticUiReact.Label,
                      { size: 'mini' },
                      (0, _vietnam.unitQuotaChipLabel)(auth, t)
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Header.Subheader,
                      null,
                      _react2.default.createElement(
                        'button',
                        {
                          className: 'a-button-blue',
                          onClick: function onClick(e) {
                            e.preventDefault();
                            _this16.handleShowSwapUnit();
                          }
                        },
                        t('Change Unit')
                      )
                    )
                  ),
                  _react2.default.createElement(_semanticUiReact.Divider, null)
                ) : '',
                project && (project.paymentFlow || project.loanTrackerDirectShow) ? _react2.default.createElement(_BookingSteppers2.default, {
                  totalSteps: project.paymentFlow && project.loanTrackerDirectShow ? 3 : 2,
                  lastStepLabel: t(project.paymentFlow && !project.loanTrackerDirectShow ? 'Payment' : 'Mortgage')
                }) : _react2.default.createElement(
                  _semanticUiReact.Header,
                  { textAlign: 'center', size: 'small', style: { marginTop: '1rem' } },
                  t('Purchaser')
                ),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  null,
                  isVietnam && this.renderBookingIDSearch(),
                  constructResponsiveIdentityTinInputs(),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { centered: true },
                    projectAllowLinkBuyerApp && _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16 },
                      _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                        style: { margin: '1rem 0' },
                        label: _react2.default.createElement(
                          'label',
                          { htmlFor: 'linkBuyerApp' },
                          (0, _translation2.translateModels)(t, 'linkBuyerApp', 'booking'),
                          _react2.default.createElement(
                            _semanticUiReact.Popup,
                            {
                              wide: 'very',
                              hoverable: true,
                              trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'blue' })
                            },
                            t('Buyer can perform Credit Check, Loan Selection, and keep track of their booking on Buyer App. More info on', { ns: _translation.TRANSLATION_FILES.screens }),
                            ' ',
                            _react2.default.createElement(
                              'a',
                              { href: 'https://apps.mhub.my/buyer/', target: '_blank', rel: 'noopener noreferrer' },
                              'https://apps.mhub.my/buyer/'
                            )
                          )
                        ),
                        name: 'linkBuyerApp',
                        checked: this.state.booking.linkBuyerApp,
                        onChange: this.handleLinkBuyerAppCheck
                      })
                    ),
                    isVietnam && this.renderBookingIDNotices(),
                    showAutofill && this.state.showNoAutofill && _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16 },
                      _react2.default.createElement(
                        _semanticUiReact.Segment,
                        { secondary: true },
                        _react2.default.createElement(
                          'b',
                          null,
                          isPRS ? this.state.fetchDataErrorMessage : t('No existing details found') + '.'
                        )
                      )
                    ),
                    showAutofill && !isPRS && this.state.autofillOptions && this.state.autofillOptions.length > 0 && _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16 },
                      _react2.default.createElement(
                        _semanticUiReact.Segment,
                        { secondary: true },
                        _react2.default.createElement(
                          'b',
                          null,
                          t('Customer details found'),
                          '. \xA0'
                        ),
                        _react2.default.createElement('br', { className: 'large-hide small-hide' }),
                        this.state.autofillOptions && this.state.autofillOptions.length > 0 && _react2.default.createElement(
                          _semanticUiReact.Dropdown,
                          {
                            trigger: _react2.default.createElement(
                              'button',
                              {
                                className: 'a-button-blue',
                                onClick: function onClick(e) {
                                  return e.preventDefault();
                                }
                              },
                              t('Autofill')
                            )
                            /* options={this.state.autofillOptions} */
                          },
                          _react2.default.createElement(
                            _semanticUiReact.Dropdown.Menu,
                            null,
                            _react2.default.createElement(_semanticUiReact.Dropdown.Header, { content: t('Autofill from') }),
                            this.state.autofillOptions.map(function (item) {
                              return _react2.default.createElement(_semanticUiReact.Dropdown.Item, item);
                            })
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16 },
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal' },
                        this.state.hideTitle ? null : _react2.default.createElement(
                          _AppForm2.default.Validate,
                          {
                            validation: [_webValidations.required],
                            ref: this.validation.title,
                            onChange: this.handleSelectChange,
                            validateLabel: (0, _translation2.translateModels)(t, 'title', 'booking')
                          },
                          _react2.default.createElement(_semanticUiReact.Form.Select, {
                            disabled: this.isVNFormLocked(),
                            label: (0, _translation2.translateModels)(t, 'title', 'booking') + '*',
                            name: 'title',
                            onChange: this.handleSelectChange,
                            options: this.toUppercaseOptions(_customerTitles2.default),
                            placeholder: t('Select {{title}}', { title: (0, _translation2.translateModels)(t, 'title', 'booking') }) + '*',
                            search: true,
                            selectOnBlur: false,
                            value: this.state.booking.title
                          })
                        ),
                        _react2.default.createElement(_AppForm2.default.Input, {
                          autoComplete: 'off',
                          disabled: this.isVNFormLocked(),
                          label: t(this.state.identityType === 4 ? 'Company Name' : 'Full Name') + '*',
                          name: 'name',
                          onChange: this.handleInputChange,
                          placeholder: t(this.state.identityType === 4 ? 'Company Name' : 'Full Name') + '*',
                          ref: this.validation.name,
                          validation: [_webValidations.required].concat(_toConsumableArray((0, _vietnam.vnFullNameValidations)(auth, this.state.identityType, t))),
                          value: this.state.booking.name,
                          validateLabel: t(this.state.identityType === 4 ? 'Company Name' : 'Full Name')
                        }),
                        _react2.default.createElement(_AppForm2.default.Input, {
                          autoComplete: 'off',
                          disabled: this.isVNFormLocked(),
                          label: t(this.state.identityType === 4 ? 'Contact Person' : 'Preferred Name') + '*',
                          name: 'preferredName',
                          onChange: this.handleInputChange,
                          placeholder: t(this.state.identityType === 4 ? 'Contact Person' : 'Preferred Name') + '*',
                          ref: this.validation.preferredName,
                          validation: this.state.identityType === 4 ? [_webValidations.required].concat(_toConsumableArray((0, _vietnam.vnPreferredNameValidations)(auth, t))) : [_webValidations.required, {
                            validate: _webValidations.stringLength,
                            option: {
                              max: 15
                            }
                          }].concat(_toConsumableArray((0, _vietnam.vnPreferredNameValidations)(auth, t))),
                          value: this.state.booking.preferredName,
                          validateLabel: t(this.state.identityType === 4 ? 'Contact Person' : 'Preferred Name')
                        }),
                        _react2.default.createElement(_AppForm2.default.Input, {
                          autoComplete: 'off',
                          disabled: this.isVNFormLocked(),
                          label: '' + (0, _translation2.translateModels)(t, 'email', 'booking') + (this.checkIsEmailRequired() ? '*' : ''),
                          name: 'email',
                          type: 'email',
                          onChange: this.handleInputChange,
                          placeholder: (0, _translation2.translateModels)(t, 'email', 'booking'),
                          validation: this.getEmailValidation(),
                          validateLabel: (0, _translation2.translateModels)(t, 'email', 'booking'),
                          ref: this.validation.email,
                          value: this.state.booking.email
                        })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal' },
                        _react2.default.createElement(
                          _AppForm2.default.Validate,
                          {
                            validation: [_webValidations.required],
                            ref: this.validation.mobilePrefix,
                            onChange: this.handleSelectChange,
                            validateLabel: (0, _translation2.translateModels)(t, 'mobilePrefix', 'booking')
                          },
                          _react2.default.createElement(_semanticUiReact.Form.Select, {
                            label: (0, _translation2.translateModels)(t, 'mobilePrefix', 'booking') + '*',
                            name: 'mobilePrefix',
                            disabled: this.state.mobileLock || this.isVNFormLocked(),
                            onChange: this.handleSelectChange,
                            options: this.toUppercaseOptions(_intlCallCodes2.default),
                            search: true,
                            selectOnBlur: false,
                            value: this.state.booking.mobilePrefix
                          })
                        ),
                        _react2.default.createElement(_PhoneInput2.default, {
                          className: 'ui fluid\n                            ' + this.state.booking.mobilePrefix + '\n                            ' + (this.isLoading('searchingIDByMobile') ? 'loading icon ' : '') + '\n                            ' + (this.hasResetMobileIcon() ? 'icon ' : '') + 'input\n                          ',
                          autoComplete: 'off',
                          icon: this.getPhoneInputIcon(),
                          iconPosition: 'right',
                          label: this.state.booking.mobilePrefix === '60' ? t('Mobile') + '* (e.g. 196756118)' : t('Mobile') + '*',
                          name: 'mobile',
                          onChange: this.handleInputChange,
                          placeholder: this.state.booking.mobilePrefix === '60' ? t('Mobile') + '* (e.g. 196756118)' : t('Mobile') + '*',
                          disabled: this.isVNFormLocked(),
                          prefix: this.state.booking.mobilePrefix,
                          readOnly: this.state.mobileLock,
                          ref: this.validation.mobile,
                          type: 'tel',
                          validation: [_webValidations.required, {
                            validate: _webValidations.phoneNumber,
                            option: this.state.booking.mobilePrefix === 'other' ? {} : {
                              isMobile: true,
                              phonePrefix: this.state.booking.mobilePrefix,
                              validRegex: (0, _phone.getPhoneValidRegex)(this.state.phoneValidationPresets, this.state.booking.mobilePrefix, 'mobile')
                            }
                          }],
                          value: this.state.booking.mobile,
                          validateLabel: t('Mobile')
                        })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal' },
                        _react2.default.createElement(_semanticUiReact.Form.Select, {
                          disabled: this.isVNFormLocked(),
                          label: t('House/Office Phone prefix'),
                          name: 'phonePrefix',
                          onChange: this.handleSelectChange,
                          options: this.toUppercaseOptions(_intlCallCodes2.default),
                          search: true,
                          selectOnBlur: false,
                          value: this.state.booking.phonePrefix
                        }),
                        _react2.default.createElement(_PhoneInput2.default, {
                          autoComplete: 'off',
                          disabled: this.isVNFormLocked(),
                          label: this.state.booking.phonePrefix === '60' ? t('House/Office Phone') + ' (e.g. 378317749)' : t('House/Office Phone'),
                          name: 'phone',
                          onChange: this.handleInputChange,
                          placeholder: this.state.booking.phonePrefix === '60' ? t('Phone') + ' (e.g. 378317749)' : t('Phone'),
                          prefix: this.state.booking.phonePrefix,
                          type: 'tel',
                          ref: !isPRS && this.validation.phone,
                          validation: isPRS ? null : [{
                            validate: _webValidations.phoneNumber,
                            option: this.state.booking.phonePrefix === 'other' ? {} : {
                              phonePrefix: this.state.booking.phonePrefix,
                              validRegex: (0, _phone.getPhoneValidRegex)(this.state.phoneValidationPresets, this.state.booking.phonePrefix, 'phone')
                            }
                          }],
                          value: this.state.booking.phone,
                          validateLabel: t('House/Office Phone')
                        })
                      ),

                      // https://stackoverflow.com/questions/49491452/map-an-array-by-every-two-elements
                      _lodash2.default.chunk(inputs, 2).map(function (p, idx) {
                        return _react2.default.createElement(
                          _semanticUiReact.Form.Group,
                          { widths: 'equal', key: 'group_' + idx },
                          p
                        );
                      }),
                      himsIsEnabled && isBCustomerMalaysia ? _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal' },
                        _react2.default.createElement(_SearchHimsDistricts2.default, {
                          validateRef: this.validation.himsKodDaerah,
                          name: 'himsKodDaerah',
                          onSelect: this.handleSelectHimsDistrict,
                          state: this.state.booking.address7,
                          value: this.state.booking.himsKodDaerah
                        }),
                        _react2.default.createElement('span', { style: { flex: '1 1 auto', width: '100%' } })
                      ) : null
                    )
                  ),
                  showPurchaserExtraFields && this.renderCustomFields(t, this.state.projectCustomFields.filter(function (c) {
                    return c.isDefault;
                  }), true),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16 },
                      _react2.default.createElement(_semanticUiReact.Divider, null),
                      _react2.default.createElement(
                        _semanticUiReact.Header,
                        { textAlign: 'center', size: 'small' },
                        t('Booking Details')
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal' },
                        _react2.default.createElement(_AppForm2.default.Input, {
                          disabled: !this.hasSPAValueAccess() || this.isVNFormLocked(),
                          fluid: true,
                          label: (0, _translation2.translateModels)(t, 'spaValue', 'booking'),
                          name: 'spaValue',
                          onChange: this.hasSPAValueAccess() ? this.handleInputChange : function () {},
                          placeholder: (0, _translation2.translateModels)(t, 'spaValue', 'booking') + '*',
                          ref: this.validation.spaValue,
                          type: 'number',
                          step: '.01',
                          pattern: '[0-9]*',
                          validation: [_webValidations.required],
                          value: this.state.booking.spaValue,
                          validateLabel: (0, _translation2.translateModels)(t, 'spaValue', 'booking')
                        }),
                        _react2.default.createElement(
                          _AppForm2.default.Validate,
                          {
                            validation: isPackagePricingRequired || this.state.isRequirePricingSelection ? [_webValidations.required] : null,
                            ref: this.validation.unitPackagePricingID,
                            onChange: this.hasPackagePricingAccess() ? this.handleSelectChange : function () {},
                            validateLabel: t('Pricing Package')
                          },
                          _react2.default.createElement(_semanticUiReact.Form.Select, {
                            disabled: !this.hasPackagePricingAccess() || this.isVNFormLocked(),
                            className: 'ddPricingTierDropdown',
                            label: '' + t('Pricing Package') + (isPackagePricingRequired || this.state.isRequirePricingSelection ? '*' : ''),
                            name: 'unitPackagePricingID',
                            options: packagePricings,
                            placeholder: t('Select {{title}}', { title: t('Pricing Package') }),
                            search: true,
                            selectOnBlur: false,
                            value: this.state.booking.unitPackagePricingID

                          }),
                          this.isSaveBlockedByPricingPackage() && _react2.default.createElement(
                            _AppForm2.default.Helper,
                            { type: 'error' },
                            t('Pricing Package is required')
                          )
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal' },
                        _react2.default.createElement(
                          _AppForm2.default.Validate,
                          {
                            validation: [_webValidations.required],
                            ref: this.validation.paymentMethodID,
                            onChange: this.handleSelectChange,
                            validateLabel: (0, _translation2.translateModels)(t, 'paymentMethodID', 'booking')
                          },
                          _react2.default.createElement(_semanticUiReact.Form.Select, {
                            fluid: true,
                            disabled: isVietnam && !this.hasSourceOfFinanceEditAccess() || this.isVNFormLocked(),
                            label: (0, _translation2.translateModels)(t, 'paymentMethodID', 'booking') + '*',
                            name: 'paymentMethodID',
                            options: paymentMethodOptions.map(function (o) {
                              return _extends({}, o, {
                                text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants, defaultValue: o.text })
                              });
                            }),
                            placeholder: t('Select {{title}}', { title: (0, _translation2.translateModels)(t, 'paymentMethodID', 'booking') + '*' }),
                            selectOnBlur: false,
                            value: this.state.booking.paymentMethodID
                          }),
                          this.state.booking.paymentMethodID === 'referred_banker' && this.hasAccessIsExternalAgent() && project && project.hlbCampaignIsEnabled && _react2.default.createElement(
                            'div',
                            { className: 'hlb-eligible-banner', style: { marginTop: '0.5em' } },
                            _react2.default.createElement('img', { src: _gift_blue2.default, width: 20, alt: 'gift' }),
                            _react2.default.createElement(
                              'span',
                              null,
                              _react2.default.createElement(
                                'strong',
                                null,
                                'MHub Rewards: '
                              ),
                              'Get RM10 when you choose Hong Leong Bank as your panel banker.'
                            )
                          )
                        ),

                        // CPI-977 mock-up: in Vietnam the waiver tick sits directly under the
                        // Additional Fee Package dropdown, inside the same column.
                        isVietnam ? _react2.default.createElement(
                          _semanticUiReact.Form.Field,
                          null,
                          this.renderFeePackageSelect(t, feePackages),
                          this.renderVNBankGuaranteeWaiver(t)
                        ) : this.renderFeePackageSelect(t, feePackages)
                      ),
                      this.state.hideFirstTimeBuyer ? null : _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: '2' },
                        _react2.default.createElement(
                          _AppForm2.default.Validate,
                          {
                            validation: [_webValidations.required],
                            ref: this.validation.firstTimeBuyer,
                            onChange: this.handleSelectChange,
                            validateLabel: (0, _translation2.translateModels)(t, 'firstTimeBuyer', 'booking')
                          },
                          _react2.default.createElement(_semanticUiReact.Form.Select, {
                            disabled: this.isVNFormLocked(),
                            label: (0, _translation2.translateModels)(t, 'firstTimeBuyer', 'booking') + '?*',
                            name: 'firstTimeBuyer',
                            options: _firstTimeBuyer2.default.map(function (l) {
                              return _extends({}, l, {
                                text: t(l.text, { ns: _translation.TRANSLATION_FILES.constants })
                              });
                            }),
                            placeholder: (0, _translation2.translateModels)(t, 'firstTimeBuyer', 'booking') + '?',
                            selectOnBlur: false,
                            value: this.state.booking.firstTimeBuyer
                          })
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal' },
                        _react2.default.createElement(_semanticUiReact.Form.Select, {
                          disabled: !this.state.allowCustomBookingStatus || this.isVNFormLocked(),
                          fluid: true,
                          label: (0, _translation2.translateModels)(t, 'statusID', 'booking') + '*',
                          name: 'statusID',
                          onChange: function onChange(e, data) {
                            if (_this16.state.allowCustomBookingStatus) {
                              _this16.handleSelectChange(e, data);
                            }
                          },
                          options: this.newBookingStatutes.map(function (s) {
                            return _extends({}, s, {
                              text: t(s.text, { ns: _translation.TRANSLATION_FILES.constants })
                            });
                          }),
                          placeholder: t('Select {{title}}', { title: (0, _translation2.translateModels)(t, 'statusID', 'booking') + '*' }),
                          selectOnBlur: false,
                          value: this.state.booking.statusID
                        }),
                        _react2.default.createElement(_AppForm2.default.Input, {
                          disabled: true,
                          fluid: true,
                          label: t('Project Name') + '*',
                          name: 'projectName',
                          placeholder: t('Project Name') + '*',
                          value: projectUnitDetails.projectName
                        }),
                        _react2.default.createElement(_AppForm2.default.Input, {
                          disabled: true,
                          fluid: true,
                          label: t('Unit Number') + '*',
                          name: 'reference',
                          placeholder: t('Unit Number') + '*',
                          value: projectUnitDetails.reference
                        }),
                        _react2.default.createElement(_AppForm2.default.Input, {
                          disabled: true,
                          fluid: true,
                          label: t('Unit Status') + '*',
                          name: 'unitStatus',
                          placeholder: t('Unit Status') + '*',
                          value: projectUnitDetails.unitStatus
                        })
                      ),
                      this.hasAccess(false, true, true, false, false) && _react2.default.createElement(
                        _semanticUiReact.Grid,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Row,
                          { style: { paddingBottom: '0.5em' } },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { mobile: 16, tablet: 8, computer: 8 },
                            _react2.default.createElement(
                              'b',
                              null,
                              (0, _vietnam.createdByLabel)(this.props.auth, t, t('Created By'))
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Row,
                          { style: { padding: 0 } },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { mobile: 16, tablet: 8, computer: 8 },
                            _react2.default.createElement(_SearchStaff2.default, {
                              disabled: this.isVNFormLocked() || (0, _vietnam.agentAssignedLocked)(this.props.auth),
                              onClear: this.handleUserClear,
                              onSelect: this.handleUserSelect,
                              selectedValue: this.getSelectedCreatorValue(),
                              searchAll: true,
                              onFetch: this.handleUserfetch,
                              value: searchUserValue,
                              placeholder: (0, _vietnam.createdByLabel)(this.props.auth, t, t('Created By'))
                            }),
                            this.state.vnAgentError && _react2.default.createElement(
                              'div',
                              { style: { color: '#db2828', marginTop: '0.5em' } },
                              this.state.vnAgentError
                            )
                          )
                        )
                      ),
                      this.renderCustomFields(t, this.state.projectCustomFields.filter(function (c) {
                        return !c.isDefault;
                      }), false)
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16, textAlign: 'center', className: 'button-group' },
                      _react2.default.createElement(
                        'div',
                        { className: 'tablet-hide mobile-hide', style: { display: 'flex', flexDirection: 'row', justifyContent: 'center' } },
                        !isVietnam && _react2.default.createElement(_semanticUiReact.Button, {
                          style: { maxWidth: '25%' },
                          content: t('Preview Price Breakdown'),
                          icon: 'eye',
                          labelPosition: 'left',
                          primary: true,
                          type: 'button',
                          onClick: this.handleCheckIsPreview,
                          className: this.state.booking.statusID !== 'reserved' ? 'notReserved' : 'previewBtn'
                        }),
                        _react2.default.createElement(
                          _semanticUiReact.Button,
                          {
                            style: { maxWidth: '25%' },
                            disabled: this.isLoading('isFetching') || (isPRS ? this.state.autofillOptions && this.state.autofillOptions.length < 1 : false) || this.state.validatingTin || this.isSaveBlockedByPricingPackage(),
                            loading: this.isLoading('isFetching'),
                            positive: true,
                            className: this.state.booking.statusID !== 'reserved' ? 'notReserved' : 'saveBtn'
                          },
                          t('Save and Continue'),
                          this.state.booking.statusID === 'reserved' ? _react2.default.createElement('br', null) : '',
                          this.state.booking.statusID === 'reserved' ? _react2.default.createElement(
                            'small',
                            null,
                            t('Pending Confirmation')
                          ) : ''
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        { className: 'small-hide large-hide' },
                        !isVietnam && _react2.default.createElement(_semanticUiReact.Button, {
                          content: t('Preview Price Breakdown'),
                          icon: 'eye',
                          labelPosition: 'left',
                          primary: true,
                          type: 'button',
                          onClick: this.handleCheckIsPreview,
                          className: this.state.booking.statusID !== 'reserved' ? 'notReserved' : 'previewBtn'
                        }),
                        _react2.default.createElement(
                          _semanticUiReact.Button,
                          {
                            disabled: this.isLoading('isFetching') || (isPRS ? this.state.autofillOptions && this.state.autofillOptions.length < 1 : false) || this.state.validatingTin || this.isSaveBlockedByPricingPackage(),
                            loading: this.isLoading('isFetching'),
                            positive: true,
                            className: this.state.booking.statusID !== 'reserved' ? 'notReserved' : 'saveBtn'
                          },
                          t('Save and Continue'),
                          this.state.booking.statusID === 'reserved' ? _react2.default.createElement('br', null) : '',
                          this.state.booking.statusID === 'reserved' ? _react2.default.createElement(
                            'small',
                            null,
                            t('Pending Confirmation')
                          ) : ''
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16, textAlign: 'center', style: { marginTop: '0.5em' } },
                      _react2.default.createElement(
                        'p',
                        null,
                        projectUnitDetails.bookingUnitLimit > 1 && projectUnitDetails.reservedCount > 0 ? t('Unit is currently reserved, but project setup allows for multiple reservation pending confirmation.') : ''
                      )
                    )
                  )
                )
              ),
              isPreviewing && !isVietnam && this.renderBookingSummary()
            )
          )
        )
      );
    }
  }]);

  return BookingForm;
}(_react.Component);

BookingForm.propTypes = {
  // onSubmit: PropTypes.func.isRequired,
  token: _propTypes2.default.string,
  auth: _propTypes2.default.shape({
    id: _propTypes2.default.number,
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    allowEditUnitPrice: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    }),
    companyBranch: _propTypes2.default.shape({
      isExternal: _propTypes2.default.bool
    })
  }),
  bookQuery: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  onChange: _propTypes2.default.func,
  registerLeaveGuard: _propTypes2.default.func,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string,
    hash: _propTypes2.default.string
  }),
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      leadV2IsEnabled: _propTypes2.default.bool,
      externalServiceIsEnabled: _propTypes2.default.bool,
      externalServiceAutofillIsEnabled: _propTypes2.default.bool,
      apieServiceIsEnabled: _propTypes2.default.bool,
      himsIsEnabled: _propTypes2.default.bool,
      settings: _propTypes2.default.shape({
        bookingHideFirstTimeBuyer: _propTypes2.default.bool,
        uppercasePurchaserInfoIsEnabled: _propTypes2.default.bool
      })
    })
  }),
  addressSettings: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  financeSources: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  identityPresets: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  phoneValidationPresets: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  customOptions: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  t: _propTypes2.default.func
};

BookingForm.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig,
    bookQuery: state.bookQuery,
    addressSettings: state.addressSettings,
    financeSources: state.financeSources,
    identityPresets: state.identityPresets,
    phoneValidationPresets: state.phoneValidationPresets,
    customOptions: state.customOptions
  };
};

BookingForm.contextTypes = {
  store: _propTypes2.default.object
};
BookingForm.defaultValues = {
  address1: '',
  address2: '',
  address3: '',
  address4: '',
  address5: '',
  address6: '',
  address7: '',
  address8: '',
  address9: '',
  address10: '',
  country: 'my',
  customerDetailID: null,
  customerID: null,
  email: '',
  identity: '',
  identityTypeID: null,
  identityPresetID: '',
  identityPresetLabel: '',
  identityPresetRegex: '',
  taxIdentificationNo: '',
  prsID: '',
  mobile: '',
  mobilePrefix: '60',
  name: '',
  paymentMethodID: 'referred_banker',
  phone: '',
  phonePrefix: '60',
  preferredName: '',
  projectID: null,
  projectUnitID: null,
  spaValue: '',
  spaDecimal: '',
  spaFull: '',
  spaTimes: '',
  nettSellingPrice: '', // TODO Remove (deprecated tier pricing)
  statusID: 'reserved',
  title: '',
  jobTitle: '',
  monthlyIncome: '',
  nationality: '',
  // CPI-1248: 'local' | 'foreigner', blank until the CRM declares one. Posted for Vietnam only.
  citizenship: '',
  gender: '',
  race: '',
  raceOther: '',
  bumi: 'Not Applicable',
  maritalStatus: '',
  pricingTier: '',
  tierPricingName: '',
  tierPricingDescription: '',
  customerSpecification: [],
  maUserID: 0,
  maCreatedByName: '',
  maCreatedByEmail: '',
  maCreatedByPreferredName: '',
  unitPackagePricingID: '',
  waiveBankGuarantee: false,
  linkBuyerApp: false,
  leadCustomerID: '',
  leadICFrontURL: '',
  leadICBackURL: '',
  origin: '',
  originID: '',
  emergencyContactName: '',
  emergencyContactRelation: '',
  emergencyContactMobilePrefix: '60',
  emergencyContactMobile: '',
  emergencyContactEmail: '',
  emergencyContactIdentity: '',
  sstRegistrationNo: '',
  firstTimeBuyer: '',
  // hims fields
  himsKodPoskod: '',
  himsKodBandar: '',
  himsKodDaerah: '',
  himsKodNegeri: '',
  himsKodNegara: '',
  isRequirePricingSelection: false,
  isDisableBaseSellingPriceSelection: false,
  isForeignCompany: false
};

BookingForm.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var booking = Object.assign({}, BookingForm.defaultValues);
  var auth = props.auth;
  var defaultCountryPhoneCode = '60';
  var defaultCountryAddressCode = 'my';
  if (auth && (0, _companies.isForeignCompany)(auth.company)) {
    var idx = _intlFlagCodes2.default.findIndex(function (f) {
      return f.countryCode === auth.company.countryCode;
    });
    if (idx !== -1) {
      defaultCountryPhoneCode = _intlFlagCodes2.default[idx].value;
      defaultCountryAddressCode = _intlFlagCodes2.default[idx].countryCode;
      booking.mobilePrefix = defaultCountryPhoneCode;
      booking.phonePrefix = defaultCountryPhoneCode;
      booking.emergencyContactMobilePrefix = defaultCountryPhoneCode;
      booking.country = defaultCountryAddressCode;
    }
  }
  booking.maCreatedByPreferredName = auth ? auth.preferredName : '';
  booking.maUserID = auth ? auth.id : 0;
  booking.taxIdentificationNo = '';
  var errMessages = [];
  var tinMessage = null;
  var existingCustomer = {};
  var externalCustomer = {};
  var leadCustomer = {};
  var identity = '';
  // CPI-974 (D6/A7): a VN reservation normally starts from the Booking ID search. CPI-1357
  // additionally accepts the paired, authenticated Marketplace handoff after the event. Do not
  // accept an opportunityID by itself: the detail response must match this exact Booking ID.
  var isVNMarketplaceBookingContext = (0, _vietnam.isVietnamCompany)(auth) && query.source === 'lead' && typeof query.opportunityID === 'string' && query.opportunityID !== '' && typeof query.bookingID === 'string' && query.bookingID !== '';
  var crmOpportunityID = isVNMarketplaceBookingContext ? query.opportunityID : '';
  var crmBookingID = isVNMarketplaceBookingContext ? query.bookingID : '';
  var opportunityID = (0, _vietnam.isVietnamCompany)(auth) ? '' : query.opportunityID || '';
  var identityType = isPRS || opportunityID ? 1 : '';
  var prsID = '';
  var loaders = {
    searchingID: false,
    searchingIDByMobile: false,
    isFetching: false,
    validatingTIN: false
  };
  var projectID = query.projectID || '';
  var projectUnitDetails = {
    projectName: '',
    unitStatus: '',
    reference: '',
    statusID: '',
    isBumi: '',
    bookingUnitLimit: 0,
    reservedCount: 0,
    maOwnerCompanyBranchID: 0
  };
  var projectUnitID = query.unitID || '';
  var identityError = false;
  var tinError = null;
  var selectedProjectUnit = {
    key: '',
    title: ''
  };
  var projectCustomFields = [];
  var origin = query.origin || document.referrer;
  var globalSettings = {};
  var storeGlobalSettings = (0, _storage.getItem)(_config2.default.get('appName') + '.globalSettings');
  if (storeGlobalSettings) {
    try {
      globalSettings = JSON.parse(storeGlobalSettings).data || [];
    } catch (e) {
      Bugsnag.notifyException(e);
    }
  }
  var isCRMEnabled = props.appConfig && props.appConfig.data && props.appConfig.data.leadV2IsEnabled;
  // Keep only a scalar URL value. A nested qs value must never reach the CRM lookup.
  var srCode = typeof query.srCode === 'string' ? query.srCode : '';
  var hasSRCodeQuery = Object.prototype.hasOwnProperty.call(query, 'srCode');

  var identityPresets = props.identityPresets.data;
  var identityTypeOpts = (0, _identityTypes.getIdentityTypeOpts)(props.auth, identityPresets);
  var phoneValidationPresets = props.phoneValidationPresets.data;

  var hideTitle = false;
  var customOptions = props.customOptions.data;
  if (customOptions.length > 0) {
    var hideTitleOpt = customOptions.find(function (o) {
      return o.name === 'hide_purchaser_title';
    });
    if (hideTitleOpt) {
      hideTitle = hideTitleOpt.value === 'true';
    }
  }
  if (hideTitle) {
    booking.title = 'Not Applicable';
  }
  var hideFirstTimeBuyer = props.appConfig && props.appConfig.data && props.appConfig.data.settings && props.appConfig.data.settings.bookingHideFirstTimeBuyer;
  if (hideFirstTimeBuyer) {
    booking.firstTimeBuyer = 'no';
  }

  return {
    booking: booking,
    errMessages: errMessages,
    tinMessage: tinMessage,
    existingCustomer: existingCustomer,
    externalCustomer: externalCustomer,
    leadCustomer: leadCustomer,
    identity: identity,
    identityType: identityType,
    identityPresetID: '',
    identityPresetLabel: '',
    identityPresetRegex: '',
    taxIdentificationNo: '',
    prsID: prsID,
    loaders: loaders,
    projectID: projectID,
    projectUnitDetails: projectUnitDetails,
    projectUnitID: projectUnitID,
    identityError: identityError,
    tinError: tinError,
    hasChanges: false,
    selectedProjectUnit: selectedProjectUnit,
    projectCustomFields: projectCustomFields,
    origin: origin,
    opportunityID: opportunityID,
    crmOpportunityID: crmOpportunityID,
    crmBookingID: crmBookingID,
    globalSettings: globalSettings,
    identityTypeOpts: identityTypeOpts,
    identityPresets: identityPresets,
    phoneValidationPresets: phoneValidationPresets,
    defaultCountryPhoneCode: defaultCountryPhoneCode,
    defaultCountryAddressCode: defaultCountryAddressCode,
    isCRMEnabled: isCRMEnabled,
    hideTitle: hideTitle,
    hideFirstTimeBuyer: hideFirstTimeBuyer,
    isForeignCompany: false,
    srCode: srCode,
    hasSRCodeQuery: hasSRCodeQuery
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this17 = this;

  this.handleResize = function () {
    _this17.setState({ screenWidth: window.innerWidth });
  };

  this.getIdentityPlaceholder = function (isIndonesia) {
    if (isPRS) return 'NRIC Number';
    if (_this17.state.identityType === '') {
      return 'Select Identity Type first';
    }
    switch (_this17.state.identityType) {
      case 2:
        return 'Passport Number';
      case 4:
        return isIndonesia ? 'e.g. 1234567890123' : 'e.g. 202401012345';
      default:
        return 'Identity Number';
    }
  };

  this.getIdentityInputLabel = function (isHidden) {
    switch (_this17.state.identityType) {
      case 4:
        return isHidden ? null : 'Enter 12-digit Company Registration Number';
      default:
        return null;
    }
  };

  this.getCountdownFormat = function (reservedTimeoutExpireAt) {
    var minutesLeft = _momentTimezone2.default.duration((0, _momentTimezone2.default)(reservedTimeoutExpireAt).diff((0, _momentTimezone2.default)())).asMinutes();
    return {
      hour: minutesLeft > 60 ? 'HH' : '',
      minute: 'MM',
      second: 'SS'
    };
  };

  this.getSelectedCreatorValue = function () {
    var booking = _this17.state.booking;

    var SelectedCreatorValue = {
      key: booking.maUserID.toString() || 0,
      title: booking.maCreatedByPreferredName || '',
      price: ''
    };
    return SelectedCreatorValue;
  };

  this.getRace = function (race) {
    if (race) {
      var presetRace = _race.RACE.find(function (d) {
        return d.value.toLowerCase() === race.toLowerCase();
      });
      if (!presetRace) {
        return 'Others';
      }
      return presetRace.value;
    }
    return '';
  };

  this.getBirthDate = function (birthDate, nric) {
    if (nric !== '' && nric.length === 12) {
      var dfIC = (0, _dateFromIC2.default)(nric.substring(0, 6));
      if (dfIC) {
        var mBirthdate = _momentTimezone2.default.tz(dfIC, _config2.default.get('tzName'));
        if (mBirthdate.isValid()) {
          return mBirthdate.format('YYYY-MM-DD').toString();
        }
      }
    }
    var date = new Date(birthDate);
    if (date !== 'Invalid Date' && !isNaN(date)) {
      return birthDate;
    }
    return '';
  };

  this.getMaritalStatus = function (maritalStatus) {
    if (maritalStatus) {
      var preset = _maritalStatus.MARITAL_STATUS.find(function (d) {
        return d.value.toLowerCase() === maritalStatus.toLowerCase();
      });
      if (preset) {
        return preset.value;
      }
    }
    return '';
  };

  this.getAutofillIdentityTypeName = function (typeID) {
    if (!(0, _isNumber.isNumeric)(typeID)) return _autofillTypes.AUTOFILL_PRESET;
    if (typeID > 0 && typeID <= 6) {
      var idx = _autofillTypes.AUTOFILL_IDENTITY_TYPES.findIndex(function (a) {
        return a.id === typeID;
      });
      if (idx > -1) return _autofillTypes.AUTOFILL_IDENTITY_TYPES[idx].name;
    }
    return _autofillTypes.AUTOFILL_NRIC;
  };

  this.getAutofillIdentityTypeID = function (typeName) {
    if (typeName !== '') {
      var idx = _autofillTypes.AUTOFILL_IDENTITY_TYPES.findIndex(function (a) {
        return a.name === typeName;
      });
      if (idx > -1) return _autofillTypes.AUTOFILL_IDENTITY_TYPES[idx].id;
    }
    return 1;
  };

  this.getPhoneInputIcon = function () {
    var t = _this17.props.t;
    var loaders = _this17.state.loaders;

    if (loaders.searchingIDByMobile) {
      return _react2.default.createElement(_semanticUiReact.Icon, { loading: true, name: 'spinner' });
    }
    if (_this17.hasResetMobileIcon()) {
      return _react2.default.createElement(_semanticUiReact.Icon, {
        link: true,
        name: 'x',
        onClick: _this17.handleResetAutofill,
        title: t('Clear Form')
      });
    }
    return null;
  };

  this.isVNFormLocked = function () {
    return (0, _vietnam.isVietnamCompany)(_this17.props.auth) && !_this17.state.srOpportunity;
  };

  this.isSaveBlockedByPricingPackage = function () {
    return (0, _vietnamPricing.isPricingPackageMissing)(_this17.state.isRequirePricingSelection, _this17.state.booking.unitPackagePricingID, _this17.state.projectUnitDetails && _this17.state.projectUnitDetails.spaValue);
  };

  this.consumeSRCodeQuery = function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this17.props;

    if (_this17.srCodeQueryConsumed || !_this17.state.hasSRCodeQuery) return;
    var auth = props.auth,
        location = props.location;

    if (!auth || !auth.id) return;

    _this17.srCodeQueryConsumed = true;
    var query = (0, _url.decodeSearch)(location.search);
    var code = _this17.state.srCode;
    delete query.srCode;
    var nextSearch = (0, _url.encodeSearch)(query);
    var nextLocation = '' + location.pathname + (nextSearch ? '?' + nextSearch : '') + (location.hash || window.location.hash || '');
    var store = _this17.context.store;


    _this17.setState({ hasSRCodeQuery: false }, function () {
      store.dispatch((0, _reactRouterRedux.replace)(nextLocation));
      if ((0, _vietnam.isVietnamCompany)(auth) && code.trim()) _this17.searchOpportunityBySRCode();
    });
  };

  this.handleSRCodeChange = function (e) {
    _this17.setState({ srCode: e.target.value, srError: '' });
  };

  this.handleSRCodeKeyPress = function (e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      _this17.searchOpportunityBySRCode();
    }
  };

  this.clearCRMCitizenship = function (nextState) {
    var booking = _this17.state.booking;

    booking.citizenship = '';
    return Object.assign({ booking: booking }, nextState);
  };

  this.getCRMContact = function (customer) {
    if (!customer) return null;
    if (customer.contact) return customer.contact;
    if (customer.contacts && customer.contacts.length > 0) return customer.contacts[0];
    return null;
  };

  this.getShowroomIdentityType = function (contact) {
    var mapped = CRM_IDENTITY_TYPE_MAP[parseInt(contact.identity_type, 10)];
    if (mapped) return mapped;
    var has = function has(field) {
      return String(contact[field] || '').trim() !== '';
    };
    if (has('cccd') || has('nric')) return _defaultIdentityTypeOpts.IDENTITY_TYPE_NRIC;
    if (has('passport')) return _defaultIdentityTypeOpts.IDENTITY_TYPE_PASSPORT;
    if (has('other_identity')) return _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN;
    return 0;
  };

  this.getCRMIdentity = function (contact, identityTypeID) {
    var field = CRM_IDENTITY_VALUE_FIELD[identityTypeID];
    if (!field) return '';
    var value = String(contact[field] || '').trim();
    // `nric` is where Showroom's sync used to put a CCCD; read it when `cccd` is blank.
    if (value === '' && field === 'cccd') return String(contact.nric || '').trim();
    return value;
  };

  this.getCRMOptionValue = function (options, value) {
    if (!value) return '';
    var normalise = function normalise(v) {
      return String(v).trim().toLowerCase().replace(/\.$/, '');
    };
    var wanted = normalise(value);
    var match = options.find(function (o) {
      return normalise(o.value) === wanted;
    });
    return match ? match.value : '';
  };

  this.getCRMMobilePrefix = function (countryCode) {
    var match = _intlFlagCodes2.default.find(function (f) {
      return f.countryCode === String(countryCode || '').toLowerCase();
    });
    return match ? match.value : '';
  };

  this.mapCRMContactToBookingFields = function (contact) {
    var identityTypeID = _this17.getShowroomIdentityType(contact);
    var identity = _this17.getCRMIdentity(contact, identityTypeID);
    var mobilePrefix = _this17.getCRMMobilePrefix(contact.mobile_country_code);
    var emergency = contact.emergency_contacts && contact.emergency_contacts[0] || null;
    var fields = {
      title: _this17.getCRMOptionValue(_customerTitles2.default, contact.title),
      name: contact.name || '',
      preferredName: contact.preferred_name || '',
      email: contact.email || '',
      gender: _this17.getCRMOptionValue(_gender.GENDER, contact.gender),
      // CPI-977: same treatment as mobile. The CRM sends no phone prefix, so the form's current
      // one (the company default unless changed) is what book-api will validate it against.
      phone: (0, _vietnam.crmContactMobile)(contact.phone, _this17.state.booking.phonePrefix),
      identity: identity,
      identityTypeID: identityTypeID || null,
      birthdate: _this17.getBirthDate(contact.date_of_birth, ''),
      maritalStatus: _this17.getMaritalStatus(contact.marital_status),
      nationality: String(contact.nationality_country_code || '').toLowerCase(),
      // CPI-1248: the CRM's declared citizenship, explicit field first and the legacy address_4
      // only when it holds one of the two values. Blank for a customer who never declared one.
      citizenship: (0, _vietnam.crmContactCitizenship)(contact),
      // CPI-977: national number only - the CRM sometimes hands back the full msisdn here, and
      // a related purchaser posts it untouched (no input to correct it in).
      mobile: (0, _vietnam.crmContactMobile)(contact.mobile, mobilePrefix),
      address1: contact.address_1 || '',
      address2: contact.address_2 || '',
      address5: contact.postcode || '',
      address6: contact.city || '',
      address7: contact.state || '',
      jobTitle: contact.occupation || '',
      monthlyIncome: contact.monthly_income || '',
      leadICFrontURL: (0, _crmIdentityMedia.crmIdentityMediaReference)(contact.ic_front),
      leadICBackURL: (0, _crmIdentityMedia.crmIdentityMediaReference)(contact.ic_back)
    };
    var countryCode = String(contact.country_code || '').toLowerCase();
    if (countryCode) fields.country = countryCode;
    if (mobilePrefix) fields.mobilePrefix = mobilePrefix;
    if (emergency) {
      fields.emergencyContactName = emergency.name || '';
      fields.emergencyContactRelation = emergency.relation || '';
      fields.emergencyContactEmail = emergency.email || '';
      fields.emergencyContactIdentity = emergency.nric || '';
      var emergencyPrefix = emergency.mobile_prefix || _this17.getCRMMobilePrefix(emergency.mobile_country_code);
      if (emergencyPrefix) fields.emergencyContactMobilePrefix = emergencyPrefix;
      // CPI-977: book-api runs the same preset regex on the emergency mobile ("Invalid Emergency
      // Contact Number"), so a full msisdn here fails a related purchaser just like `mobile`.
      fields.emergencyContactMobile = (0, _vietnam.crmContactMobile)(emergency.mobile, emergencyPrefix || _this17.state.booking.emergencyContactMobilePrefix);
    }
    return fields;
  };

  this.buildRelatedBookingCustomers = function (opportunity) {
    var primaryID = opportunity.primary_customer_id || opportunity.primary_customer && opportunity.primary_customer.id;
    var customers = (opportunity.customers || []).filter(function (c) {
      return c && c.id !== primaryID;
    });
    return customers.map(function (customer) {
      var contact = _this17.getCRMContact(customer);
      if (!contact) return null;
      var fields = _this17.mapCRMContactToBookingFields(contact);
      // CRM allows a blank Preferred Name; Book requires one for each purchaser.
      if ((0, _vietnam.isVietnamCompany)(_this17.props.auth) && !fields.preferredName.trim()) {
        fields.preferredName = fields.name;
      }
      return _extends({}, fields, {
        // CPI-1291: the CRM's income is a string, bookingCustomers.monthlyIncome is a float64.
        // Read from the contact, not from fields, so a numeric 0 survives mapping's `|| ''`.
        monthlyIncome: (0, _vietnam.crmMonthlyIncome)(contact.monthly_income),
        // Related purchaser's relationship to the primary purchaser, from the CRM contact; matched
        // to RELATIONSHIP_TYPE (book-api rejects anything else). Blank when the CRM has none.
        relationshipType: _this17.getCRMOptionValue(_relationshipType.RELATIONSHIP_TYPE, contact.relationship_type),
        customer: {
          identity: fields.identity,
          identityTypeID: fields.identityTypeID || 6
        },
        leadCustomerID: customer.id
      });
    }).filter(Boolean);
  };

  this.applyOpportunityToForm = function (opportunity) {
    var contact = _this17.getCRMContact(opportunity.primary_customer);
    var booking = _this17.state.booking;

    var nextState = {
      srOpportunity: opportunity,
      srCode: opportunity.sr_code || _this17.state.srCode,
      srError: '',
      vnAgentError: '',
      opportunityID: opportunity.id,
      srRelatedBookingCustomers: _this17.buildRelatedBookingCustomers(opportunity)
    };
    if (contact) {
      var fields = _this17.mapCRMContactToBookingFields(contact);
      Object.assign(booking, fields);
      booking.origin = 'lead';
      booking.originID = opportunity.id;
      booking.leadCustomerID = opportunity.primary_customer_id || '';
      nextState.booking = booking;
      nextState.identity = fields.identity;
      nextState.identityType = fields.identityTypeID || '';
      nextState.srIdentityTypeUnmapped = !fields.identityTypeID;
      nextState.srOriginalIdentity = fields.identity || '';
    }
    nextState.vnCRMLookup = null;
    nextState.vnCRMCustomer = null;
    nextState.vnCRMClearedFor = '';
    _this17.setState(nextState, function () {
      _this17.handleCheckChanges();
      _this17.applyCRMAgentToForm(opportunity);
    });
  };

  this.applyCRMAgentToForm = function () {
    var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(opportunity) {
      var store, t, showInvalid, query, staffs, res, agent, booking;
      return regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              if (!(!(0, _vietnam.agentAssignedLocked)(_this17.props.auth) || !_this17.hasAccess(false, true, true, false, false))) {
                _context20.next = 2;
                break;
              }

              return _context20.abrupt('return');

            case 2:
              if (!(_this17.state.srOpportunity !== opportunity)) {
                _context20.next = 4;
                break;
              }

              return _context20.abrupt('return');

            case 4:
              // Never show the logged-in user or a previous booking's agent while (or if) the lookup fails:
              // the field is locked, so it may only ever hold this CRM booking's agent.
              _this17.handleUserClear();
              store = _this17.context.store;
              t = _this17.props.t;

              showInvalid = function showInvalid() {
                if (_this17.state.srOpportunity !== opportunity) return;
                _this17.setState({
                  vnAgentError: t('Invalid assigned agent. Please assign a valid agent to this booking in the CRM first.', { ns: _translation.TRANSLATION_FILES.screens })
                });
              };

              query = (0, _vietnam.crmAgentLookupQuery)(opportunity && opportunity.assigned_to);

              if (query) {
                _context20.next = 12;
                break;
              }

              showInvalid();
              return _context20.abrupt('return');

            case 12:
              staffs = void 0;
              _context20.prev = 13;
              _context20.next = 16;
              return store.dispatch((0, _fetchM.fetchM)('/search/staffs/?' + query, {
                credentials: 'include',
                method: 'GET',
                headers: { 'Content-Type': 'application/json' },
                ignoreForbidden: true,
                ignoreNotFound: true
              }));

            case 16:
              res = _context20.sent;
              _context20.t1 = res && res.ok;

              if (!_context20.t1) {
                _context20.next = 22;
                break;
              }

              _context20.next = 21;
              return res.json();

            case 21:
              _context20.t1 = _context20.sent;

            case 22:
              _context20.t0 = _context20.t1;

              if (_context20.t0) {
                _context20.next = 25;
                break;
              }

              _context20.t0 = [];

            case 25:
              staffs = _context20.t0;
              _context20.next = 32;
              break;

            case 28:
              _context20.prev = 28;
              _context20.t2 = _context20['catch'](13);

              // the lookup itself failed: leave the field to book-api's own check on Create
              Bugsnag.notifyException(_context20.t2);
              return _context20.abrupt('return');

            case 32:
              agent = staffs.find(_vietnam.isCompleteSaleAgent);

              if (agent) {
                _context20.next = 36;
                break;
              }

              showInvalid();
              return _context20.abrupt('return');

            case 36:
              if (!(_this17.state.srOpportunity !== opportunity)) {
                _context20.next = 38;
                break;
              }

              return _context20.abrupt('return');

            case 38:
              booking = _this17.state.booking;

              booking.maCreatedByName = agent.name;
              booking.maCreatedByEmail = agent.email;
              booking.maCreatedByPreferredName = agent.preferredName;
              booking.maUserAffiliateCompanyBranchShortName = agent.companyBranchShortName;
              booking.maUserAffiliateCompanyBranchID = agent.companyBranchID;
              booking.maUserAffiliateCompanyID = agent.companyID;
              booking.maUserAffiliateID = agent.affiliateID;
              booking.maUserID = agent.id;
              _this17.setState({ booking: booking, vnAgentError: '' });

            case 48:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, _this17, [[13, 28]]);
    }));

    return function (_x32) {
      return _ref22.apply(this, arguments);
    };
  }();

  this.handleResetSRSearch = function () {
    _this17.setState(_this17.clearCRMCitizenship({
      srCode: '',
      srOpportunity: null,
      srError: '',
      vnAgentError: '',
      srSearching: false,
      srIdentityTypeUnmapped: false,
      srRelatedBookingCustomers: [],
      srOriginalIdentity: '',
      vnCRMLookup: null,
      vnCRMCustomer: null,
      vnCRMClearedFor: '',
      opportunityID: ''
    }));
  };

  this.vnCRMSearchField = function (identityTypeID) {
    switch (identityTypeID) {
      case 1:
        return 'cccd';
      case 2:
        return 'passport';
      case 4:
        return 'other_identity';
      default:
        return '';
    }
  };

  this.isValidVNCCCD = function (identity) {
    var validation = (0, _vietnam.vnIdentityValidation)(_this17.props.auth, 1, _this17.props.t);
    return Boolean(validation && typeof identity === 'string' && validation.validRegex.test(identity));
  };

  this.searchVNCRMPurchaser = function () {
    var _ref23 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(identity, identityTypeID) {
      var searchField, res, match, contact;
      return regeneratorRuntime.wrap(function _callee21$(_context21) {
        while (1) {
          switch (_context21.prev = _context21.next) {
            case 0:
              searchField = _this17.vnCRMSearchField(identityTypeID);

              if (!(!searchField || !identity)) {
                _context21.next = 5;
                break;
              }

              _context21.next = 4;
              return _this17.setComponentState({ vnCRMLookup: null, vnCRMCustomer: null });

            case 4:
              return _context21.abrupt('return');

            case 5:
              if (!(identityTypeID === 1 && !_this17.isValidVNCCCD(identity))) {
                _context21.next = 10;
                break;
              }

              if (!(_this17.state.identity === identity && _this17.state.identityType === identityTypeID)) {
                _context21.next = 9;
                break;
              }

              _context21.next = 9;
              return _this17.setComponentState({ vnCRMLookup: null, vnCRMCustomer: null });

            case 9:
              return _context21.abrupt('return');

            case 10:
              if (!(_this17.state.identity !== identity || _this17.state.identityType !== identityTypeID)) {
                _context21.next = 12;
                break;
              }

              return _context21.abrupt('return');

            case 12:
              _context21.next = 14;
              return _this17.setComponentState({ vnCRMLookup: 'searching', vnCRMCustomer: null });

            case 14:
              _context21.next = 16;
              return _this17.fetchData('/leads/customers/search/?' + _qs2.default.stringify({ search: identity, searchField: searchField }), '', true, {}, false);

            case 16:
              res = _context21.sent;

              if (!(_this17.state.identity !== identity || _this17.state.identityType !== identityTypeID || identityTypeID === 1 && !_this17.isValidVNCCCD(identity))) {
                _context21.next = 19;
                break;
              }

              return _context21.abrupt('return');

            case 19:
              if (!(res === null)) {
                _context21.next = 23;
                break;
              }

              _context21.next = 22;
              return _this17.setComponentState({ vnCRMLookup: null, vnCRMCustomer: null });

            case 22:
              return _context21.abrupt('return');

            case 23:
              match = res.data && res.data.length > 0 ? res.data[0] : null;
              contact = match ? _this17.getCRMContact(match) : null;

              if (contact) {
                _context21.next = 30;
                break;
              }

              _context21.next = 28;
              return _this17.setComponentState({ vnCRMLookup: 'not_found', vnCRMCustomer: null });

            case 28:
              _this17.clearPurchaserForNewBuyer(identity);
              return _context21.abrupt('return');

            case 30:
              _context21.next = 32;
              return _this17.setComponentState({ vnCRMLookup: 'found', vnCRMCustomer: match });

            case 32:
            case 'end':
              return _context21.stop();
          }
        }
      }, _callee21, _this17);
    }));

    return function (_x33, _x34) {
      return _ref23.apply(this, arguments);
    };
  }();

  this.clearPurchaserForNewBuyer = function (identity) {
    if (_this17.state.vnCRMClearedFor === identity) {
      return;
    }
    var _state14 = _this17.state,
        defaultCountryPhoneCode = _state14.defaultCountryPhoneCode,
        defaultCountryAddressCode = _state14.defaultCountryAddressCode;

    var booking = Object.assign(_this17.state.booking, {
      title: _this17.state.hideTitle ? 'Not Applicable' : '',
      name: '',
      preferredName: '',
      email: '',
      mobile: '',
      mobilePrefix: defaultCountryPhoneCode,
      phone: '',
      phonePrefix: defaultCountryPhoneCode,
      address1: '',
      address2: '',
      address5: '',
      address6: '',
      address7: '',
      country: defaultCountryAddressCode,
      birthdate: '',
      gender: '',
      maritalStatus: '',
      nationality: '',
      jobTitle: '',
      monthlyIncome: '',
      // The reservation owns its purchaser, so nothing here may keep pointing at the CRM record
      // or the Showroom row the previous person came from.
      customerID: null,
      customerDetailID: null,
      leadCustomerID: '',
      leadICFrontURL: '',
      leadICBackURL: ''
    });
    _this17.setState(_this17.clearCRMCitizenship({
      booking: booking,
      vnCRMClearedFor: identity
    }), function () {
      _this17.handleCheckChanges();
    });
  };

  this.applyVNCRMPurchaser = function () {
    var _state15 = _this17.state,
        vnCRMCustomer = _state15.vnCRMCustomer,
        booking = _state15.booking;

    var contact = vnCRMCustomer ? _this17.getCRMContact(vnCRMCustomer) : null;
    if (!contact) {
      return;
    }
    var fields = _this17.mapCRMContactToBookingFields(contact);
    Object.assign(booking, fields);
    // mapCRMContactToBookingFields carries the contact's details and nothing else, so without this
    // the ids the opportunity left behind survive: customerID and customerDetailID still name the
    // agent's Showroom rows and leadCustomerID still names their CRM customer, and the submit
    // sends all three. This purchaser is a different person, and the reservation owns them
    // privately, so none of those may follow. Same reset the not-found path does.
    Object.assign(booking, {
      customerID: null,
      customerDetailID: null,
      leadCustomerID: ''
    });
    _this17.setState({
      booking: booking,
      identity: fields.identity,
      identityType: fields.identityTypeID || _this17.state.identityType,
      vnCRMLookup: 'applied'
    }, function () {
      _this17.handleCheckChanges();
    });
  };

  this.checkBookableDelistedUnit = function (project) {
    var user = _this17.props.auth;
    if (project && project.rduIsEnabled && project.rduAccessGroupIDs) {
      if (user.isAdminBasic || user.isAdmin) return true;

      var uGroupIDs = [].concat(_toConsumableArray(user.groups.map(function (obj) {
        return obj.id;
      })));
      var uSrRoleIDs = (0, _srRoleAccess.matchGroupIDToSrRoleID)(uGroupIDs, user.companyBranch.isExternal);
      return (0, _srRoleAccess.hasAnyRequiredRoleIDs)(project.rduAccessGroupIDs, uSrRoleIDs);
    }
    return false;
  };

  this.autofillCustomFields = function () {
    var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(leadCustomerData) {
      var _state16, booking, projectCustomFields, bookingCustomFields, leadData;

      return regeneratorRuntime.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              _state16 = _this17.state, booking = _state16.booking, projectCustomFields = _state16.projectCustomFields, bookingCustomFields = _state16.bookingCustomFields;
              leadData = void 0;
              // autofill lead custom fields

              if (leadCustomerData && leadCustomerData.emergency_contacts && leadCustomerData.emergency_contacts.length > 0) {
                leadData = leadCustomerData.emergency_contacts[0];
              }
              if (projectCustomFields) {
                projectCustomFields.filter(function (p) {
                  return !p.isDefault;
                }).forEach(function (data) {
                  var value = data.defaultValue;

                  // get current value
                  var existsID = bookingCustomFields.findIndex(function (d) {
                    return d.name === data.name;
                  });
                  if (existsID > -1) {
                    value = bookingCustomFields[existsID].value;
                  }

                  // autofill lead custom fields
                  if (leadData) {
                    switch (data.name) {
                      case 'name_emergency_contact_person_':
                        value = leadData.name;
                        break;
                      case 'nric_no_emergency_contact_person_':
                        value = leadData.nric || leadData.identity_no;
                        break;
                      case 'telephone_emergency_contact_person_':
                        value = leadData.mobile_prefix + leadData.mobile;
                        break;
                      case 'email_emergency_contact_person_':
                        value = leadData.email;
                        break;
                      case 'relationship_emergency_contact_person_':
                        value = leadData.relation;
                        break;
                      default:
                        if (leadData[data.name]) {
                          value = leadData[data.name];
                        }
                        break;
                    }
                  }
                  if (value !== '') {
                    if (data.type === 'dropdown' && data.projectBookingCustomFieldOptions) {
                      var optionItem = data.projectBookingCustomFieldOptions.find(function (d) {
                        return d.value === value;
                      });
                      if (optionItem) {
                        var customField = {
                          name: data.name,
                          value: value,
                          projectBookingCustomFieldID: data.id,
                          projectBookingCustomFieldOptionID: optionItem.id
                        };
                        if (existsID === -1) {
                          bookingCustomFields.push(customField);
                        } else {
                          bookingCustomFields[existsID] = customField;
                        }
                        booking[data.name] = value;
                      }
                    }
                    if (data.type === 'dropdown_multi' && data.projectBookingCustomFieldOptions) {
                      value = data.defaultValue.split(',');
                      var optionItems = [];
                      data.projectBookingCustomFieldOptions.forEach(function (o) {
                        value.forEach(function (v) {
                          if (v === o.value) optionItems.push(o.id);
                        });
                      });
                      if (optionItems) {
                        var _customField3 = {
                          name: data.name,
                          value: value.join(),
                          projectBookingCustomFieldID: data.id,
                          projectBookingCustomFieldOptionIDs: optionItems
                        };
                        if (existsID === -1) {
                          bookingCustomFields.push(_customField3);
                        } else {
                          bookingCustomFields[existsID] = _customField3;
                        }
                        booking[data.name] = value.join();
                      }
                    }
                    if (data.type === 'input') {
                      var _customField4 = {
                        name: data.name,
                        value: value,
                        projectBookingCustomFieldID: data.id
                      };
                      if (existsID === -1) {
                        bookingCustomFields.push(_customField4);
                      } else {
                        bookingCustomFields[existsID] = _customField4;
                      }
                      booking[data.name] = value;
                    }
                  } else {
                    if (existsID > -1) {
                      bookingCustomFields.splice(existsID, 1);
                    }
                    booking[data.name] = '';
                  }
                });
              }
              _context22.next = 6;
              return _this17.setComponentState({ booking: booking, bookingCustomFields: bookingCustomFields });

            case 6:
            case 'end':
              return _context22.stop();
          }
        }
      }, _callee22, _this17);
    }));

    return function (_x35) {
      return _ref24.apply(this, arguments);
    };
  }();

  this.autofillFromBookQuery = function () {
    var _ref25 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
      var bookQuery = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      var queryFill, _queryFill$bookingCus, identity, identityTypeID, identityPresetID, booking, qbc, qb, validations;

      return regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              if (!(bookQuery.length < 1)) {
                _context23.next = 2;
                break;
              }

              return _context23.abrupt('return');

            case 2:
              queryFill = (0, _bookQuery2.bookQueryToBooking)(bookQuery);
              _queryFill$bookingCus = queryFill.bookingCustomer, identity = _queryFill$bookingCus.identity, identityTypeID = _queryFill$bookingCus.identityTypeID, identityPresetID = _queryFill$bookingCus.identityPresetID;
              // search autofill existing internal customer if customerID provided

              if (!queryFill.customerID) {
                _context23.next = 7;
                break;
              }

              _context23.next = 7;
              return _this17.searchAutofillCustomer(identity, _this17.getAutofillIdentityTypeName(identityTypeID), queryFill.customerID);

            case 7:
              if (!(queryFill.hasBooking || queryFill.hasBookingCustomer)) {
                _context23.next = 30;
                break;
              }

              booking = _this17.state.booking;
              qbc = queryFill.bookingCustomer;
              qb = queryFill.booking;

              if (identity) booking.identity = identity;
              if (identityTypeID) booking.identityTypeID = identityTypeID;
              if (qbc.name) booking.name = qbc.name;
              if (qbc.email) booking.email = qbc.email;
              if (qbc.mobile) booking.mobile = qbc.mobile;
              if (qbc.mobilePrefix) booking.mobilePrefix = qbc.mobilePrefix;
              if (qb.externalID) booking.externalID = qb.externalID;
              if (qb.externalLeadID) booking.externalLeadID = qb.externalLeadID;
              if (qb.externalCustomerID) booking.externalCustomerID = qb.externalCustomerID;
              _context23.next = 22;
              return _this17.setComponentState({ booking: booking });

            case 22:
              _context23.next = 24;
              return _AppForm2.default.validate(_this17.validation, booking);

            case 24:
              validations = _context23.sent;
              _context23.next = 27;
              return _this17.setComponentState(function (prevState) {
                return {
                  errMessages: validations.filter(function (v) {
                    return !v.isValid;
                  }),
                  // identity: identity || prevState.identity,
                  identityType: identityTypeID || prevState.identityType
                };
              });

            case 27:
              if (!(_this17.props.appConfig.data.externalServiceAutofillIsEnabled && qb.externalID !== '')) {
                _context23.next = 30;
                break;
              }

              _context23.next = 30;
              return _this17.getSFAutofill(qb.externalID);

            case 30:
              if (!(identity !== '' && identityTypeID > 0 && !queryFill.customerID)) {
                _context23.next = 33;
                break;
              }

              _context23.next = 33;
              return _this17.searchAutofillCustomer(identity, _this17.getAutofillIdentityTypeName(identityTypeID), '', identityPresetID);

            case 33:
            case 'end':
              return _context23.stop();
          }
        }
      }, _callee23, _this17);
    }));

    return function () {
      return _ref25.apply(this, arguments);
    };
  }();

  this.formatAutofill = function (booking) {
    var purchaserInputFields = ['name', 'preferredName', 'jobTitle', 'emergencyContactName', 'emergencyContactRelation', 'emergencyContactIdentity', 'identity', 'taxIdentificationNo'];
    var addressSettings = _this17.props.addressSettings;

    var enabledAddressSettings = addressSettings.data.filter(function (as) {
      return as.enabled;
    });
    enabledAddressSettings.forEach(function (as) {
      var key = _lodash2.default.camelCase(as.columnName);
      var label = as.label.toLowerCase();
      if (label !== 'postcode' && label !== 'state') {
        purchaserInputFields.push(key);
      }
    });
    var formattedBooking = _extends({}, booking);
    purchaserInputFields.forEach(function (pf) {
      if (formattedBooking[pf]) {
        formattedBooking[pf] = _this17.toUppercaseFormat(formattedBooking[pf]);
      }
    });
    return formattedBooking;
  };

  this.replaceWithAutofill = function () {
    var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(type) {
      var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'identity';

      var _state17, externalCustomer, existingCustomer, leadCustomer, projectUnitDetails, projectID, projectUnitID, identityPresets, auth, isMalaysia, isIndonesia, booking, price, eccd, customer, opportunities, opportunity, unitOpp, isMsisdnField, matched, validations;

      return regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              _state17 = _this17.state, externalCustomer = _state17.externalCustomer, existingCustomer = _state17.existingCustomer, leadCustomer = _state17.leadCustomer, projectUnitDetails = _state17.projectUnitDetails, projectID = _state17.projectID, projectUnitID = _state17.projectUnitID, identityPresets = _state17.identityPresets;
              auth = _this17.props.auth;
              isMalaysia = auth.company && auth.company.countryCode.toUpperCase() === 'MY';
              isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';
              booking = _this17.state.booking;

              if (type === 'existing') {
                booking = Object.assign(_this17.state.booking, existingCustomer.customerDetail);
                booking.race = _this17.getRace(existingCustomer.customerDetail.race);
                booking.raceOther = booking.race === 'Others' ? existingCustomer.customerDetail.race : '';
                booking.customerDetailID = existingCustomer.customerDetailID;
                booking.customerID = existingCustomer.id;
                booking.identity = existingCustomer.identity.trim();
                booking.identityTypeID = existingCustomer.identityTypeID;
                booking.identityPresetID = existingCustomer.identityPresetID;
                booking.identityPresetLabel = existingCustomer.identityPresetLabel;
                booking.identityPresetRegex = existingCustomer.identityPresetRegex;
                // fix taxIdentification overwritten with empty value when autofilling form with existing data
                if (existingCustomer.taxIdentificationNo) {
                  booking.taxIdentificationNo = existingCustomer.taxIdentificationNo;
                }
                booking.birthdate = _this17.getBirthDate(existingCustomer.customerDetail.birthdate, _this17.state.identityType === 1 ? _this17.state.identity : '');
                booking.customerSpecification = existingCustomer.specifications;
                // force reset package pricing
                if (booking.unitPackagePricingID !== '' && booking.bumi !== 'Bumiputera' && projectUnitDetails.projectUnitPackagePricings) {
                  price = projectUnitDetails.projectUnitPackagePricings.find(function (d) {
                    return d.id === booking.unitPackagePricingID;
                  });

                  if (price && price.projectPackagePricing && price.projectPackagePricing.bumiPurchaserOnly) {
                    booking.spaValue = (0, _amount.amountToFixed)(parseFloat(projectUnitDetails.spaValue), projectUnitDetails.spaTimes);
                    booking.unitPackagePricingID = '';
                  }
                }
                booking.maritalStatus = _this17.getMaritalStatus(existingCustomer.customerDetail.maritalStatus);

                // clear lead data if replaced with internal
                if (booking.leadCustomerID !== '') {
                  booking.leadCustomerID = '';
                }
                if (booking.leadICFrontURL !== '') {
                  booking.leadICFrontURL = '';
                }
                if (booking.leadICBackURL !== '') {
                  booking.leadICBackURL = '';
                }
                if (booking.origin === 'lead') {
                  booking.origin = '';
                  booking.originID = '';
                }
              }
              if (type === 'external') {
                eccd = Object.assign({}, externalCustomer.customerDetail);

                booking.address1 = eccd.address1 ? eccd.address1 : '';
                booking.address2 = eccd.address2 ? eccd.address2 : '';
                booking.address5 = eccd.postcode ? eccd.postcode : '';
                booking.address6 = eccd.city ? eccd.city : '';
                booking.address7 = eccd.state ? eccd.state : '';
                booking.country = eccd.country ? eccd.country : '';
                booking.email = eccd.email ? eccd.email : '';
                booking.mobile = eccd.mobile ? eccd.mobile : '';
                booking.mobilePrefix = eccd.mobilePrefix ? eccd.mobilePrefix : '';
                booking.name = eccd.name ? eccd.name : '';
                booking.phonePrefix = eccd.phonePrefix ? eccd.phonePrefix : '';
                booking.preferredName = eccd.preferredName ? eccd.preferredName : '';
                booking.title = eccd.title ? eccd.title : '';
                booking.identity = externalCustomer.identity.trim();
                booking.identityTypeID = externalCustomer.identityTypeID;
                booking.taxIdentificationNo = existingCustomer.taxIdentificationNo;
                // clear lead data if replaced with external
                if (booking.leadCustomerID !== '') {
                  booking.leadCustomerID = '';
                }
                if (booking.leadICFrontURL !== '') {
                  booking.leadICFrontURL = '';
                }
                if (booking.leadICBackURL !== '') {
                  booking.leadICBackURL = '';
                }
                if (booking.origin === 'lead') {
                  booking.origin = '';
                  booking.originID = '';
                }
              }
              if (type === 'lead') {
                customer = leadCustomer.customer;

                booking = Object.assign(_this17.state.booking, customer.customerDetail);
                booking.leadCustomerID = leadCustomer.id;
                booking.race = _this17.getRace(customer.customerDetail.race);
                booking.raceOther = booking.race === 'Others' ? customer.customerDetail.race : '';
                booking.identity = customer.identity.trim();
                booking.identityTypeID = customer.identityTypeID;
                booking.identityPresetID = customer.identityPresetID;
                booking.identityPresetLabel = customer.identityPresetLabel;
                booking.identityPresetRegex = customer.identityPresetRegex;
                if (isMalaysia) {
                  booking.taxIdentificationNo = leadCustomer.contacts[0].tin || '';
                } else if (isIndonesia) {
                  booking.taxIdentificationNo = leadCustomer.contacts[0].npwp || '';
                }
                booking.birthdate = _this17.getBirthDate(customer.customerDetail.birthdate, _this17.state.identityType === 1 ? _this17.state.identity : '');
                booking.customerSpecification = customer.specifications;
                booking.jobTitle = leadCustomer.details && leadCustomer.details.occupation ? leadCustomer.details.occupation : '';
                booking.address1 = leadCustomer.details && leadCustomer.details.address_1 ? leadCustomer.details.address_1 : '';
                booking.address2 = leadCustomer.details && leadCustomer.details.address_2 ? leadCustomer.details.address_2 : '';
                if (customer.icFrontDocument && customer.icFrontDocument.key) {
                  booking.leadICFrontURL = customer.icFrontDocument.key;
                }
                if (customer.icBackDocument && customer.icBackDocument.key) {
                  booking.leadICBackURL = customer.icBackDocument.key;
                }
                booking.maritalStatus = _this17.getMaritalStatus(customer.customerDetail.maritalStatus);

                // relink a correct lead opportunity
                booking.origin = '';
                booking.originID = '';
                if (leadCustomer && leadCustomer.opportunities && leadCustomer.opportunities.length > 0) {
                  // get list of opportunities that are not linked to booking yet
                  opportunities = leadCustomer.opportunities.filter(function (o) {
                    return o.project_id === projectID && (!o.booking_id || o.booking_id === '');
                  });

                  if (opportunities && opportunities.length > 0) {
                    opportunity = void 0;

                    // find opportunity for current unit

                    unitOpp = opportunities.find(function (o) {
                      return o.unit_id === projectUnitID;
                    });

                    if (unitOpp) {
                      opportunity = unitOpp;
                    } else {
                      // get first opp with empty unit
                      opportunity = opportunities.find(function (o) {
                        return !o.unit_id || o.unit_id === '';
                      });
                    }
                    if (opportunity) {
                      booking.origin = 'lead';
                      booking.originID = opportunity.id;
                    }
                  }
                }
              }
              _context24.next = 10;
              return _this17.setComponentState({ booking: _this17.formatAutofill(booking) });

            case 10:
              if (!(type === 'lead')) {
                _context24.next = 13;
                break;
              }

              _context24.next = 13;
              return _this17.autofillCustomFields(leadCustomer.details);

            case 13:
              isMsisdnField = field === 'msisdn';

              if (isMsisdnField && booking.identityTypeID === 6) {
                if (isIndonesia && leadCustomer.details.ktp) {
                  booking.identityPresetLabel = 'Kartu Tanda Penduduk';
                }
                matched = identityPresets.find(function (i) {
                  return i.label === booking.identityPresetLabel;
                });

                if (matched) {
                  booking.identityType = matched.id;
                  booking.identityPresetID = matched.id;
                  booking.identityPresetLabel = matched.label;
                  booking.identityPresetRegex = matched.regex;
                }
              }
              _context24.next = 17;
              return _AppForm2.default.validate(_this17.validation, booking);

            case 17:
              validations = _context24.sent;
              _context24.next = 20;
              return _this17.setComponentState(function (prevState) {
                return {
                  errMessages: validations.filter(function (v) {
                    return !v.isValid;
                  }),
                  identityLock: field === 'identity',
                  mobileLock: isMsisdnField,
                  identity: !prevState.identity || isMsisdnField ? booking.identity : prevState.identity,
                  identityType: !prevState.identityType || isMsisdnField ? booking.identityType : prevState.identityType,
                  identityPresetID: !prevState.identityPresetID || isMsisdnField ? booking.identityPresetID : prevState.identityPresetID,
                  identityPresetLabel: !prevState.identityPresetLabel || isMsisdnField ? booking.identityPresetLabel : prevState.identityPresetLabel,
                  identityPresetRegex: !prevState.identityPresetRegex || isMsisdnField ? booking.identityPresetRegex : prevState.identityPresetRegex,
                  taxIdentificationNo: !prevState.taxIdentificationNo || isMsisdnField ? booking.taxIdentificationNo : prevState.taxIdentificationNo
                };
              });

            case 20:
            case 'end':
              return _context24.stop();
          }
        }
      }, _callee24, _this17);
    }));

    return function (_x37) {
      return _ref26.apply(this, arguments);
    };
  }();

  this.getMinimumPurchaserAgeMessage = function () {
    return _this17.props.t('Booking cannot be created. Purchaser must be at least 18 years old.');
  };

  this.isUnderagePurchaser = function (birthdate) {
    if (!birthdate || birthdate === '') return false;

    var mBirthdate = (0, _momentTimezone2.default)(birthdate, 'YYYY-MM-DD', true).tz(_config2.default.get('tzName'), true);
    if (!mBirthdate.isValid()) return false;

    var age = _momentTimezone2.default.tz(_config2.default.get('tzName')).diff(mBirthdate, 'years');
    return age < 18;
  };

  this.isUnderageNRICPurchaser = function (identityTypeID, identity) {
    if (identityTypeID !== _defaultIdentityTypeOpts.IDENTITY_TYPE_NRIC) return false;

    var dfIC = (0, _dateFromIC2.default)((identity || '').substring(0, 6));
    if (!dfIC) return false;

    var mBirthdate = _momentTimezone2.default.tz(dfIC, _config2.default.get('tzName'));
    if (!mBirthdate.isValid()) return false;

    return _momentTimezone2.default.tz(_config2.default.get('tzName')).diff(mBirthdate, 'years') < 18;
  };

  this.handleIdentityChange = function (e) {
    var _state18 = _this17.state,
        booking = _state18.booking,
        loaders = _state18.loaders,
        identityType = _state18.identityType,
        identityPresetID = _state18.identityPresetID;

    var autofillEnabled = _this17.hasAutofillAccess();
    var identity = _this17.toUppercaseFormat(e.target.value);
    // CPI-974 (PO comment, 6 Sep): identity type 1 is the Malaysian NRIC here but the
    // Vietnamese CCCD there, and a CCCD is also 12 digits - so the NRIC birthdate parser
    // and the autofill search it shares a trigger with would overwrite the birthdate and
    // the purchaser that came from the CRM. Neither runs for a Vietnamese company.
    var isVietnam = (0, _vietnam.isVietnamCompany)(_this17.props.auth);
    if (!isVietnam && identityType === 1 && identity.length === 12) {
      var dfIC = (0, _dateFromIC2.default)(identity.substring(0, 6));
      if (dfIC) {
        var mBirthdate = _momentTimezone2.default.tz(dfIC, _config2.default.get('tzName'));
        if (mBirthdate.isValid()) {
          booking.birthdate = mBirthdate.format('YYYY-MM-DD').toString();
        }
      }
    }
    if ((0, _isNumber.isNumeric)(identity) || identity === '') {
      if (identity.length !== 12) {
        booking.customerDetailID = null;
        booking.customerID = null;
      } else if (!isVietnam && _this17.state.identityType === 1 && identity.length === 12) {
        if (autofillEnabled && (!isPRS || isPRS && _this17.state.prsID && _this17.state.prsID.length === 13)) {
          loaders.searchingID = true;
        }
      }
    }
    _this17.setState({
      identity: identity,
      autofillOptions: [],
      booking: booking,
      loaders: loaders,
      showNoAutofill: false
    }, function () {
      if (!isVietnam && _this17.state.identityType === 1 && identity.length === 12 && loaders.searchingID) {
        if (_this17.identityInputRef.current) {
          _this17.identityInputRef.current.blur();
        }
        _this17.searchAutofillCustomer(identity, _this17.getAutofillIdentityTypeName(_this17.state.identityType));
      }
      // Vietnam: the agent is swapping the agent's own details out for the real buyer's. Only once
      // an approved Booking ID has filled the form, and only for an identity that differs from the
      // one the opportunity supplied, so simply reviewing the agent's own CCCD searches nothing.
      if (isVietnam && _this17.state.srOpportunity) {
        clearTimeout(_this17.vnCRMTimer);
        // Any change to the identity invalidates the answer already on screen, and it must go
        // before the debounce rather than when the next answer lands. Otherwise the previous
        // person's "Use this customer" button stays pressable for 800ms against a CCCD that is no
        // longer theirs - and typing back to the identity the opportunity supplied takes the
        // branch below, which schedules nothing, so the stale notice would never clear at all.
        var willSearch = Boolean(identity) && identity !== _this17.state.srOriginalIdentity && (identityType !== 1 || _this17.isValidVNCCCD(identity));
        if (_this17.state.vnCRMLookup || _this17.state.vnCRMCustomer || willSearch) {
          // 'searching' is set when the wait STARTS, not when the request goes out, so a pasted
          // CCCD shows the spinner at once instead of sitting still for the debounce and looking
          // like nothing happened.
          _this17.setState({ vnCRMLookup: willSearch ? 'searching' : null, vnCRMCustomer: null });
        }
        if (willSearch) {
          _this17.vnCRMTimer = setTimeout(function () {
            _this17.searchVNCRMPurchaser(identity, identityType);
          }, 800);
        }
      }
      // CPI-974 (A7): gated on the country, not hasAutofillAccess() - MY agency branches keep this.
      if (!isVietnam && (_this17.state.identityType !== 1 && _this17.state.identityType !== 4 && identity.length > 1 || _this17.state.identityType === 4 && identity.length >= 8)) {
        clearTimeout(_this17.setTimer);
        _this17.setTimer = setTimeout(function () {
          if (_this17.state.identityLock && _this17.state.autofillOptions && _this17.state.autofillOptions.length > 0) {
            _this17.setState({ identity: booking.identity });
          } else {
            _this17.searchAutofillCustomer(identity, _this17.getAutofillIdentityTypeName(_this17.state.identityType), '', identityPresetID);
          }
        }, 1000);
      }
      _this17.handleCheckChanges();
    });
  };

  this.handleIDTypeChange = function (e, _ref27) {
    var value = _ref27.value;
    var auth = _this17.props.auth;

    var isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    var _state19 = _this17.state,
        booking = _state19.booking,
        identity = _state19.identity,
        identityPresets = _state19.identityPresets;

    if ((0, _vietnam.isVietnamCompany)(auth)) {
      clearTimeout(_this17.vnCRMTimer);
    }
    // CPI-977: keep booking.identityTypeID in step with the dropdown. The CRM Booking ID
    // lookup pre-fills it (e.g. 4 for an Enterprise contact) and nothing else rewrote it
    // until submit, so render-time checks against it went stale after a type change.
    booking.identityTypeID = !(0, _isNumber.isNumeric)(value) ? 6 : value;
    if (value === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN) {
      booking.title = 'Not Applicable';
      booking.nationality = 'Not Applicable';
      booking.gender = 'Not Applicable';
      booking.race = 'Not Applicable';
      booking.bumi = 'Not Applicable';
      booking.maritalStatus = 'Not Applicable';
      booking.birthdate = '';
    }
    if (identity.length === 0) {
      booking.customerDetailID = null;
      booking.customerID = null;
    }
    var newPresetID = '';
    var newPresetLabel = '';
    var newPresetRegex = '';
    if (value === 6 || !(0, _isNumber.isNumeric)(value)) {
      if (identityPresets && identityPresets.length > 0) {
        var idx = identityPresets.findIndex(function (i) {
          return i.id === value;
        });
        if (idx !== -1) {
          newPresetID = identityPresets[idx].id;
          newPresetLabel = identityPresets[idx].label;
          newPresetRegex = identityPresets[idx].regex;
        }
      }
    }
    if (isMalaysia) {
      booking.isForeignCompany = false;
      booking.taxIdentificationNo = (0, _tin.getAutoFillTin)(value, _this17.state.isForeignCompany);
    }
    _this17.setState(_extends({
      isForeignCompany: booking.isForeignCompany,
      taxIdentificationNo: booking.taxIdentificationNo,
      booking: booking,
      identityType: value,
      identityPresetID: newPresetID,
      identityPresetLabel: newPresetLabel,
      identityPresetRegex: newPresetRegex,
      autofillOptions: [],
      showNoAutofill: false,
      tinError: false,
      tinFound: false,
      tinMessage: null
    }, (0, _vietnam.isVietnamCompany)(auth) ? { vnCRMLookup: null, vnCRMCustomer: null } : {}), function () {
      if (_this17.validation.identity && _this17.validation.identity.current && identity !== '') {
        _this17.validation.identity.current.validate(identity);
      }
      if (_this17.validation.preferredName && _this17.validation.preferredName.current && booking.preferredName !== '') {
        _this17.validation.preferredName.current.validate(booking.preferredName);
      }
      // CPI-1319: the VN no-digits rule on Full Name depends on the identity type.
      if (_this17.validation.name && _this17.validation.name.current && booking.name !== '') {
        _this17.validation.name.current.validate(booking.name);
      }
      if (booking.taxIdentificationNo !== '') {
        _this17.handleTinInput({ target: { value: booking.taxIdentificationNo } });
      }
      if ((0, _vietnam.isVietnamCompany)(_this17.props.auth)) {
        _this17.handleCheckChanges();
        return;
      }
      if (value === 1 && identity.length === 12) {
        if (!_this17.isLoading('searchingID')) {
          _this17.searchAutofillCustomer(identity, _this17.getAutofillIdentityTypeName(value));
        }
      } else if (value !== 1 && identity.length > 0) {
        clearTimeout(_this17.setTimer);
        _this17.setTimer = setTimeout(function () {
          if (_this17.state.identityLock && _this17.state.autofillOptions && _this17.state.autofillOptions.length > 0) {
            _this17.setState({ identity: booking.identity });
          } else {
            _this17.searchAutofillCustomer(identity, _this17.getAutofillIdentityTypeName(_this17.state.identityType), '', _this17.state.identityPresetID);
          }
        }, 1000);
      }
      _this17.handleCheckChanges();
    });
  };

  this.handlePRSIDChange = function (e) {
    var booking = _this17.state.booking;

    var value = e.target.value;
    booking.prsID = value;
    if (value.length > 13) return;
    _this17.setState({ prsID: value, booking: booking }, function () {
      _this17.handleCheckChanges();
      if (value.length === 13 && _this17.state.identity.length === 12) {
        _this17.searchAutofillCustomer(_this17.state.identity, _autofillTypes.AUTOFILL_PRS);
      }
    });
  };

  this.handleSelectChange = function (event, data) {
    if (isPRS && !(data.name === 'firstTimeBuyer' || data.name === 'paymentMethodID' || data.name === 'unitPackagePricingID')) return;
    var _state20 = _this17.state,
        booking = _state20.booking,
        packagePricings = _state20.packagePricings,
        projectUnitDetails = _state20.projectUnitDetails,
        isCRMEnabled = _state20.isCRMEnabled,
        isPreviewing = _state20.isPreviewing;
    // booking package pricing

    if (data.name === 'unitPackagePricingID') {
      var price = packagePricings.find(function (d) {
        return d.value === data.value;
      });
      if (price) {
        booking.spaValue = (0, _amount.amountToFixed)(parseFloat(price.description), projectUnitDetails.spaTimes);
        _this17.validation.spaValue.current.validate(booking.spaValue);
      }
      booking.nettSellingPrice = projectUnitDetails.spaValue;
      if (isPreviewing) {
        _this17.setState({ isPreviewing: false });
      }
    }
    booking[data.name] = data.value;
    // booking package pricing bumi customer
    if (data.name === 'bumi' && data.value !== 'Bumiputera' && projectUnitDetails.projectUnitPackagePricings) {
      var _price = projectUnitDetails.projectUnitPackagePricings.find(function (d) {
        return d.id === booking.unitPackagePricingID;
      });
      if (_price && _price.projectPackagePricing && _price.projectPackagePricing.bumiPurchaserOnly) {
        booking.spaValue = (0, _amount.amountToFixed)(parseFloat(projectUnitDetails.spaValue), projectUnitDetails.spaTimes);
        booking.unitPackagePricingID = '';
      }
    }
    _this17.setState({ booking: booking }, function () {
      if ((0, _vietnam.isVietnamCompany)(_this17.props.auth)) {
        // The inline booking summary follows the package and the fee package live.
        if (data.name === 'unitPackagePricingID') {
          _this17.getPackagePricingCalculation();
          if (booking.unitPackageFeeID) {
            _this17.getFeePackageBreakdown();
          }
        }
        if (data.name === 'unitPackageFeeID') {
          _this17.getFeePackageBreakdown();
        }
      }
      if (data.name === 'mobilePrefix') {
        _this17.validation.mobile.current.validate(booking.mobile);
        if (isCRMEnabled && booking.mobile !== '') {
          var msisdn = data.value + booking.mobile;
          clearTimeout(_this17.setTimer);
          _this17.setTimer = setTimeout(function () {
            if (!_this17.state.mobileLock && (!_this17.state.autofillOptions || _this17.state.autofillOptions.length === 0)) {
              _this17.searchAutofillCustomer(msisdn, _autofillTypes.AUTOFILL_MSISDN);
            }
          }, 1000);
        }
      }
      if (data.name === 'phonePrefix') {
        _this17.validation.phone.current.validate(booking.phone);
      }
      _this17.handleCheckChanges();
    });
  };

  this.handleInputChange = function (event) {
    if (isPRS && event.target.name !== 'spaValue') return;
    var _state21 = _this17.state,
        booking = _state21.booking,
        isCRMEnabled = _state21.isCRMEnabled,
        isPreviewing = _state21.isPreviewing;

    if (event.target.name === 'spaValue') {
      booking.unitPackagePricingID = '';
      booking.nettSellingPrice = event.target.value; // TODO Remove (deprecated tier pricing)
      booking.tierPricingName = 'Custom';
      booking.tierPricingDescription = 'Custom Value: ' + event.target.value;
      if (isPreviewing) {
        _this17.setState({ isPreviewing: false });
      }
    }
    booking[event.target.name] = event.target.name.toLowerCase().includes('email') ? event.target.value : _this17.toUppercaseFormat(event.target.value);
    var hasMobileChanges = event && event.target && event.target.name === 'mobile';
    _this17.setState({ booking: booking }, function () {
      if (isCRMEnabled && hasMobileChanges && booking.mobilePrefix !== '' && booking.mobile !== '') {
        var msisdn = booking.mobilePrefix + booking.mobile;
        clearTimeout(_this17.setTimer);
        _this17.setTimer = setTimeout(function () {
          if (!_this17.state.mobileLock && (!_this17.state.autofillOptions || _this17.state.autofillOptions.length === 0)) {
            _this17.searchAutofillCustomer(msisdn, _autofillTypes.AUTOFILL_MSISDN);
          }
        }, 1000);
      }
      _this17.handleCheckChanges();
    });
  };

  this.handleLinkBuyerAppCheck = function () {
    var booking = _this17.state.booking;
    var identityType = _this17.state.identityType;

    booking.linkBuyerApp = !booking.linkBuyerApp;
    if (booking.linkBuyerApp) {
      identityType = 1;
      booking.paymentMethodID = 'referred_banker';
    }
    _this17.setState({ booking: booking, identityType: identityType }, function () {
      _this17.handleCheckChanges();
    });
  };

  this.handleCustomSelectChange = function (e, data, fieldID, customFieldOptions) {
    var _state22 = _this17.state,
        booking = _state22.booking,
        bookingCustomFields = _state22.bookingCustomFields;

    var customField = {
      name: data.name,
      value: data.value,
      projectBookingCustomFieldID: fieldID
    };
    booking[data.name] = data.value;
    if (Array.isArray(data.value)) {
      // dropdown_multi
      var values = [];
      customFieldOptions.forEach(function (cfo) {
        data.value.forEach(function (v) {
          if (v === cfo.value) values.push(cfo.id);
        });
      });
      customField.projectBookingCustomFieldOptionIDs = values;
      customField.projectBookingCustomFieldOptionID = '';
      customField.value = data.value.join();
      booking[data.name] = data.value.join();
    } else {
      // Handle cleared/empty value
      if (data.value === '' || data.value === null || data.value === undefined) {
        customField.projectBookingCustomFieldOptionID = '';
        customField.value = '';
        booking[data.name] = '';
      } else {
        var selectedOption = customFieldOptions.find(function (d) {
          return d.value === data.value;
        });
        customField.projectBookingCustomFieldOptionID = selectedOption ? selectedOption.id : '';
      }
    }
    var existsID = bookingCustomFields.findIndex(function (d) {
      return d.name === data.name;
    });
    if (existsID === -1) {
      bookingCustomFields.push(customField);
    } else {
      bookingCustomFields[existsID] = customField;
    }
    _this17.setState({ booking: booking, bookingCustomFields: bookingCustomFields }, function () {
      _this17.handleCheckChanges();
    });
  };

  this.handleCustomInputChange = function (event, fieldID, isDefaultField) {
    var _state23 = _this17.state,
        booking = _state23.booking,
        bookingCustomFields = _state23.bookingCustomFields;

    var customField = {
      name: event.target.name,
      value: event.target.value,
      projectBookingCustomFieldID: fieldID
    };
    var existsID = bookingCustomFields.findIndex(function (d) {
      return d.name === event.target.name;
    });
    if (existsID === -1) {
      bookingCustomFields.push(customField);
    } else {
      bookingCustomFields[existsID] = customField;
    }
    booking[event.target.name] = event.target.value;
    if (isDefaultField && !event.target.name.toLowerCase().includes('email')) {
      booking[event.target.name] = _this17.toUppercaseFormat(event.target.value);
    }
    _this17.setState({ booking: booking, bookingCustomFields: bookingCustomFields }, function () {
      _this17.handleCheckChanges();
    });
  };

  this.handleTinInput = function (e) {
    var _state24 = _this17.state,
        booking = _state24.booking,
        tinMessage = _state24.tinMessage,
        identityType = _state24.identityType;
    var auth = _this17.props.auth;

    var isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';

    if (isIndonesia) {
      booking.taxIdentificationNo = e.target.value;
      _this17.setState({
        booking: booking,
        taxIdentificationNo: e.target.value,
        tinError: null,
        tinMessage: null
      }, function () {
        _this17.handleCheckChanges();
      });
      return;
    }

    var tinInput = _this17.toUppercaseFormat(e.target.value);
    var tinFound = e.target.tinFound;
    var isAlphanumeric = /^[a-zA-Z0-9]*$/.test(tinInput);

    if (tinInput === '') {
      booking.taxIdentificationNo = '';
      _this17.setState({ taxIdentificationNo: '', booking: booking, tinFound: tinFound, tinError: false });
      return;
    }
    if (isAlphanumeric) {
      booking.taxIdentificationNo = tinInput;
      _this17.setState({ taxIdentificationNo: tinInput, booking: booking, tinFound: tinFound, tinError: tinFound === false, tinMessage: tinFound ? null : tinMessage }, function () {
        _this17.handleCheckChanges();
      });
      if (tinFound) {
        return;
      }

      var matched = _regex.REGEX_TIN_VALID.test(tinInput);
      var genericTin = (0, _tin.getGenericTinByIdTypeAndTinNo)(identityType, tinInput, _this17.state.isForeignCompany);
      _this17.setLoading('validatingTIN', true).then(function () {
        if (_this17.debounceTimeout) {
          clearTimeout(_this17.debounceTimeout);
        }

        _this17.debounceTimeout = setTimeout(function () {
          if (matched) {
            if (tinInput === _tin.GOVERNMENT_GENERIC_TIN) {
              var isForeign = !(0, _tin.isForeignIdType)(_this17.state.identityType, _this17.state.isForeignCompany);
              _this17.setState({
                tinError: !isForeign,
                tinFound: !isForeign,
                tinMessage: !isForeign ? _tin.GENERIC_TIN_UNMATCHED_ERROR_MSG : null }, function () {
                _this17.setLoading('validatingTIN', false);
              });
            } else if (_tin.GENERIC_TIN_VALUES.includes(tinInput)) {
              _this17.setState({
                tinError: !(0, _tin.isGenericTinFound)(genericTin),
                tinFound: (0, _tin.isGenericTinFound)(genericTin),
                tinMessage: !(0, _tin.isGenericTinFound)(genericTin) ? _tin.GENERIC_TIN_UNMATCHED_ERROR_MSG : null }, function () {
                _this17.setLoading('validatingTIN', false);
              });
            } else {
              _this17.validateTIN(tinInput).finally(function () {
                _this17.setLoading('validatingTIN', false);
              });
            }
          } else {
            _this17.setState({ tinError: true }, function () {
              _this17.setLoading('validatingTIN', false);
            });
          }
        }, 3000);
      });
    }
  };

  this.hasResetIdentityIcon = function () {
    if (!_this17.state.opportunityID && !_this17.isLoading('searchingID') && _this17.state.identity !== '' && _this17.state.identityLock) {
      return true;
    }
    return false;
  };

  this.hasResetMobileIcon = function (mobile) {
    if (!_this17.state.opportunityID && !_this17.isLoading('searchingIDByMobile') && mobile !== '' && _this17.state.mobileLock) {
      return true;
    }
    return false;
  };

  this.handleResetAutofill = function () {
    var _state25 = _this17.state,
        defaultCountryPhoneCode = _state25.defaultCountryPhoneCode,
        defaultCountryAddressCode = _state25.defaultCountryAddressCode;

    var booking = Object.assign(_this17.state.booking, {
      address1: '',
      address2: '',
      address3: '',
      address4: '',
      address5: '',
      address6: '',
      address7: '',
      address8: '',
      address9: '',
      address10: '',
      country: defaultCountryAddressCode,
      customerDetailID: null,
      customerID: null,
      email: '',
      identity: '',
      identityTypeID: null,
      identityPresetID: '',
      identityPresetLabel: '',
      identityPresetRegex: '',
      prsID: '',
      mobile: '',
      mobilePrefix: defaultCountryPhoneCode,
      name: '',
      phone: '',
      phonePrefix: defaultCountryPhoneCode,
      preferredName: '',
      title: _this17.state.hideTitle ? 'Not Applicable' : '',
      jobTitle: '',
      monthlyIncome: '',
      nationality: '',
      gender: '',
      race: '',
      raceOther: '',
      bumi: 'Not Applicable',
      maritalStatus: '',
      birthdate: '',
      customerSpecification: [],
      firstTimeBuyer: _this17.state.hideFirstTimeBuyer ? 'no' : '',
      taxIdentificationNo: ''
    });
    _this17.setState({
      booking: booking,
      autofillOptions: [],
      existingCustomer: {},
      externalCustomer: {},
      leadCustomer: {},
      identity: '',
      identityLock: false,
      mobileLock: false,
      prsID: ''
    }, function () {
      if (_this17.identityInputRef.current) {
        _this17.identityInputRef.current.focus();
      }
    });
  };

  this.handleModalReservationClose = function () {
    var store = _this17.context.store;

    _this17.setState({ modalReservationIsOpen: false }, function () {
      store.dispatch((0, _reactRouterRedux.push)('/projects/' + _this17.state.projectID + '/units/' + _this17.state.projectUnitID + '/'));
    });
  };

  this.handleCountdownFinish = function () {
    var store = _this17.context.store;

    _this17.setState({ showCountdown: false }, function () {
      _this17.handleResetCheck(function () {
        store.dispatch((0, _reactRouterRedux.replace)('/projects/' + _this17.state.projectID + '/units/'));
      });
    });
  };

  this.vnLocalUnitForeignerBlocked = function () {
    var _state26 = _this17.state,
        booking = _state26.booking,
        projectUnitDetails = _state26.projectUnitDetails,
        srRelatedBookingCustomers = _state26.srRelatedBookingCustomers;

    return (0, _vietnam.blocksVietnamLocalUnit)(_this17.props.auth, projectUnitDetails, [booking].concat(_toConsumableArray(srRelatedBookingCustomers || [])));
  };

  this.handleSubmit = function (event) {
    event.preventDefault();
    _this17.submitBooking();
  };

  this.handleShowSwapUnit = function () {
    _this17.setState({ showSwapUnit: true, manualSwap: true });
  };

  this.handleCancelChange = function (e) {
    var store = _this17.context.store;

    e.preventDefault();
    if (_this17.state.manualSwap) {
      _this17.setState({
        showSwapUnit: false
      });
      return;
    }
    store.dispatch((0, _reactRouterRedux.push)('/projects/' + _this17.state.projectID + '/units/'));
  };

  this.handleConfirmChange = function (e) {
    e.preventDefault();
    _this17.setState({
      showSwapUnit: false
    });
  };

  this.handleProjectUnitClear = function () {
    _this17.setState({ selectedProjectUnit: {
        key: '',
        title: ''
      } });
  };

  this.handleProjectUnitSelect = function (value) {
    var query = (0, _url.decodeSearch)(_this17.props.location.search);
    var projectUnitID = _this17.state.projectUnitID;
    var selectedProjectUnit = _this17.state.selectedProjectUnit;
    var projectUnitSwapError = _this17.state.projectUnitSwapError;
    if (value.hrefLang !== 'new') {
      projectUnitSwapError = true;
      selectedProjectUnit = {
        key: '',
        title: ''
      };
    } else {
      projectUnitSwapError = false;
      selectedProjectUnit = value;
      projectUnitID = value.key;
      query.unitID = value.key;
      _this17.replaceQuery(query);
      _this17.getProjectUnit(_this17.state.projectID, value.key);
    }
    _this17.setState({
      selectedProjectUnit: selectedProjectUnit,
      projectUnitSwapError: projectUnitSwapError,
      projectUnitID: projectUnitID
    });
  };

  this.handleBirthdateSelect = function (day) {
    var booking = _this17.state.booking;

    booking.birthdate = day;
    _this17.setState({ booking: booking });
  };

  this.handleClearTimer = function () {
    _this17.fetchPreReservation(true);
  };

  this.handleUserClear = function () {
    var booking = _this17.state.booking;

    booking.maCreatedByName = '';
    booking.maCreatedByEmail = '';
    booking.maCreatedByPreferredName = '';
    booking.maUserID = 0;
    booking.maUserAffiliateCompanyBranchShortName = '';
    booking.maUserAffiliateCompanyBranchID = 0;
    booking.maUserAffiliateCompanyID = 0;
    booking.maUserAffiliateID = 0;
    _this17.setState({ booking: booking, searchUserValue: '' });
  };

  this.handleUserSelect = function (value) {
    var _state27 = _this17.state,
        booking = _state27.booking,
        searchUsersData = _state27.searchUsersData;

    var selectedUser = searchUsersData.find(function (d) {
      return d.email === value.description;
    });
    if (selectedUser && selectedUser.name !== '' && selectedUser.preferredName !== '' && selectedUser.companyBranchShortName !== '' && selectedUser.companyBranchID > 0 && selectedUser.companyID > 0 && selectedUser.affiliateID > 0 && selectedUser.id > 0) {
      booking.maCreatedByName = selectedUser.name;
      booking.maCreatedByEmail = selectedUser.email;
      booking.maCreatedByPreferredName = selectedUser.preferredName;
      booking.maUserAffiliateCompanyBranchShortName = selectedUser.companyBranchShortName;
      booking.maUserAffiliateCompanyBranchID = selectedUser.companyBranchID;
      booking.maUserAffiliateCompanyID = selectedUser.companyID;
      booking.maUserAffiliateID = selectedUser.affiliateID;
      booking.maUserID = selectedUser.id;
      _this17.setState({ booking: booking });
    }
  };

  this.handleUserfetch = function (data, searchUserValue) {
    _this17.setState({ searchUsersData: data, searchUserValue: searchUserValue });
  };

  this.handleCloseLaunchModeMultiModal = function (e) {
    var store = _this17.context.store;

    if (e) e.preventDefault();
    store.dispatch((0, _reactRouterRedux.goBack)());
  };

  this.handleSelectHimsDistrict = function (himsCity) {
    var booking = _this17.state.booking;

    booking.himsKodDaerah = himsCity ? himsCity.value : '';

    _this17.setState({ booking: booking }, function () {
      _this17.handleCheckChanges();
    });
  };

  this.handleSelectHimsPostcode = function (himsPostcode) {
    var booking = _this17.state.booking;
    var addressSettings = _this17.props.addressSettings;


    booking.himsKodPoskod = himsPostcode ? himsPostcode.value : '';
    booking.himsKodBandar = himsPostcode ? himsPostcode.kod_bandar_id : '';
    booking.himsKodNegeri = himsPostcode ? himsPostcode.kod_negeri_id : '';

    // update postcode, city and state as well based on the HIMS postcode
    var enabledAddressSettings = addressSettings.data.filter(function (as) {
      return as.enabled;
    });
    var addressFields = enabledAddressSettings.reduce(function (acc, as) {
      var labelKey = as.label.toLowerCase();
      return _extends({}, acc, labelKey === 'postcode' && { postcode: as }, labelKey === 'city' && { city: as }, labelKey === 'state' && { state: as });
    }, {});
    if (addressFields.postcode && addressFields.postcode.columnName !== '') {
      var key = _lodash2.default.camelCase(addressFields.postcode.columnName);
      booking[key] = himsPostcode ? himsPostcode.text : '';
    }

    if (addressFields.city && addressFields.city.columnName !== '') {
      var _key2 = _lodash2.default.camelCase(addressFields.city.columnName);
      booking[_key2] = himsPostcode ? himsPostcode.bandar : '';
    }

    if (addressFields.state && addressFields.state.columnName !== '') {
      var himsState = himsPostcode ? himsPostcode.kod_negeri_id : '';
      var srState = _states2.default.find(function (s) {
        return s.kod_negeri_id === himsState;
      });
      var _key3 = _lodash2.default.camelCase(addressFields.state.columnName);
      booking[_key3] = srState ? srState.value : '';
    }

    _this17.setState({ booking: booking }, function () {
      _this17.handleCheckChanges();
    });
  };

  this.validateIdentityType = function () {
    var identityType = _this17.state.identityType;

    switch (identityType) {
      case 1:
        return 'ic_number';
      case 2:
        return 'passport';
      case 3:
        return 'military_police';
      case 5:
        return 'id_number';
      default:
        return 'other';
    }
  };

  this.filterPackingPricing = function (packagePricings) {
    var _state28 = _this17.state,
        booking = _state28.booking,
        projectUnitDetails = _state28.projectUnitDetails;

    var newPackagePricings = packagePricings;
    var pricings = projectUnitDetails.projectUnitPackagePricings;
    if (pricings) {
      packagePricings.forEach(function (pt, idx) {
        var price = pricings.find(function (t) {
          return t.id === pt.value;
        });
        if (price) {
          // expired schedule
          var sStart = price.projectPackagePricing.scheduleStartAt;
          var sEnd = price.projectPackagePricing.scheduleEndAt;
          if (sStart && (0, _momentTimezone2.default)(sStart).unix() > (0, _momentTimezone2.default)().unix() || sEnd && (0, _momentTimezone2.default)(sEnd).unix() < (0, _momentTimezone2.default)().unix()) {
            newPackagePricings[idx].disabled = true;
          } else if (price && price.projectPackagePricing && price.projectPackagePricing.bumiPurchaserOnly) {
            // booking package pricing primary bumi customer
            if (booking.bumi === 'Bumiputera') {
              newPackagePricings[idx].disabled = false;
            } else {
              newPackagePricings[idx].disabled = true;
            }
          }
        }
      });
    }
    return newPackagePricings;
  };

  this.filterFeePackages = function (feePackages) {
    var projectUnitDetails = _this17.state.projectUnitDetails;

    var newFeePackages = feePackages;
    var unitFeePackages = projectUnitDetails.projectUnitPackageFees;
    if (unitFeePackages) {
      feePackages.forEach(function (pt, idx) {
        var pp = unitFeePackages.find(function (t) {
          return t.id === pt.value;
        });
        if (pp) {
          // expired schedule
          var sStart = pp.projectFeePackage.scheduleStartAt;
          var sEnd = pp.projectFeePackage.scheduleEndAt;
          if (sStart && (0, _momentTimezone2.default)(sStart).unix() > (0, _momentTimezone2.default)().unix() || sEnd && (0, _momentTimezone2.default)(sEnd).unix() < (0, _momentTimezone2.default)().unix()) {
            newFeePackages[idx].disabled = true;
          }
        }
      });
    }
    return newFeePackages;
  };

  this.getIdentityType = function () {
    var _props4 = _this17.props,
        t = _props4.t,
        auth = _props4.auth;
    var _state29 = _this17.state,
        identityPresets = _state29.identityPresets,
        identityType = _state29.identityType,
        identityPresetID = _state29.identityPresetID,
        identityPresetLabel = _state29.identityPresetLabel;

    var isVietnam = (0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode);
    if (isPRS) return t('NRIC Number') + ' :';
    if (identityType === '') {
      return t('Identity Number') + ' :';
    }
    if ((identityType > 4 || typeof identityType === 'string') && identityPresets && identityPresets.length > 0) {
      var idx = identityPresets.findIndex(function (i) {
        return i.id === identityPresetID;
      });
      if (idx !== -1) {
        return identityPresets[idx].label;
      } else if (identityPresetLabel) {
        return identityPresetLabel;
      }
      return t('ID Number') + ' :';
    }
    switch (identityType) {
      case 2:
        return t('Passport Number') + ' :';
      case 4:
        return t(isVietnam ? 'Enterprise Registration Certificate' : 'Company Registration Number') + ' :';
      default:
        return t('Identity Number') + ' :';
    }
  };

  this.identityValidation = function () {
    var _props5 = _this17.props,
        auth = _props5.auth,
        t = _props5.t;
    var _state30 = _this17.state,
        identityType = _state30.identityType,
        identityPresetRegex = _state30.identityPresetRegex;

    if (identityType === 6 || !(0, _isNumber.isNumeric)(identityType)) {
      return {
        validRegex: identityPresetRegex
      };
    }
    // CPI-974: a Vietnamese CCCD is checked against the CCCD rule, not the Malaysian IC one,
    // and carries the CRM's wording. null outside Vietnam and for every other identity type,
    // so the return below is unchanged.
    var vn = (0, _vietnam.vnIdentityValidation)(auth, identityType, t);
    if (vn) {
      return vn;
    }
    return {
      countryCode: 'MY',
      identityType: _this17.validateIdentityType()
    };
  };

  this.newBookingStatutes = [{ text: 'Reserved', value: 'reserved', name: 'reserved' }, { text: 'Booked', value: 'booked', name: 'booked' }];

  this.isCustomFieldRequiredAtStatus = function (field) {
    // Only applies to booking custom fields
    if (!field.isRequired) {
      return false;
    }

    // For DEFAULT fields (purchaser fields), always use isRequired directly
    // Status-based logic only applies to custom booking fields
    if (field.isDefault) {
      return field.isRequired;
    }

    var currentStatus = _this17.state.booking.statusID || 'reserved';
    var requiredAtStatus = field.requiredAtStatus || 'reserved';

    // Define status hierarchy: reserved < booked < sold_spa_signed
    var statusHierarchy = {
      'reserved': 1,
      'booked': 2,
      'sold_spa_signed': 3
    };

    var currentLevel = statusHierarchy[currentStatus];
    var requiredLevel = statusHierarchy[requiredAtStatus];

    if (!currentLevel || !requiredLevel) {
      return false;
    }

    return currentLevel >= requiredLevel;
  };

  this.renderBookingIDSearch = function () {
    var t = _this17.props.t;
    var _state31 = _this17.state,
        srCode = _state31.srCode,
        srSearching = _state31.srSearching,
        srOpportunity = _state31.srOpportunity;

    return _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { centered: true },
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 16 },
        _react2.default.createElement(
          _semanticUiReact.Form.Group,
          null,
          _react2.default.createElement(_semanticUiReact.Form.Input, {
            width: 12,
            autoComplete: 'off',
            label: t('Booking ID', { ns: _translation.TRANSLATION_FILES.translation }) + '*',
            name: 'srCode',
            value: srCode,
            onChange: _this17.handleSRCodeChange,
            onKeyPress: _this17.handleSRCodeKeyPress,
            placeholder: t('Booking ID', { ns: _translation.TRANSLATION_FILES.translation }),
            disabled: !!srOpportunity
          }),
          _react2.default.createElement(
            _semanticUiReact.Form.Field,
            { width: 4, style: { display: 'flex', alignItems: 'flex-end' } },
            srOpportunity ? _react2.default.createElement(_semanticUiReact.Button, {
              type: 'button',
              basic: true,
              onClick: function onClick(e) {
                e.preventDefault();_this17.handleResetSRSearch();
              },
              content: t('Clear Form')
            }) : _react2.default.createElement(_semanticUiReact.Button, {
              type: 'button',
              primary: true,
              loading: srSearching,
              disabled: srSearching || !srCode.trim(),
              onClick: function onClick(e) {
                e.preventDefault();_this17.searchOpportunityBySRCode();
              },
              content: t('Search')
            })
          )
        )
      )
    );
  };

  this.renderBookingIDNotices = function () {
    var t = _this17.props.t;
    var _state32 = _this17.state,
        srError = _state32.srError,
        srErrorProjectName = _state32.srErrorProjectName,
        srIdentityTypeUnmapped = _state32.srIdentityTypeUnmapped,
        srRelatedBookingCustomers = _state32.srRelatedBookingCustomers;

    return _react2.default.createElement(
      _react2.default.Fragment,
      null,
      srError && _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 16 },
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { secondary: true },
          _react2.default.createElement(
            'b',
            null,
            srError === 'not_approved' ? t('Booking has not been approved') : srError === 'wrong_project' ? t('This Booking ID belongs to a different project{{project}}. Use a Booking ID for this project, or reserve a unit in the project it was created for.', {
              project: srErrorProjectName ? ' (' + srErrorProjectName + ')' : ''
            }) : t('No existing details found') + '.'
          )
        )
      ),
      srIdentityTypeUnmapped && _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 16 },
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { secondary: true },
          _react2.default.createElement(
            'b',
            null,
            t('Identity type could not be matched, please select it manually'),
            '.'
          )
        )
      ),
      _this17.renderVNCRMPurchaserNotice()
    );
  };

  this.renderVNCRMPurchaserNotice = function () {
    var t = _this17.props.t;
    var _state33 = _this17.state,
        vnCRMLookup = _state33.vnCRMLookup,
        vnCRMCustomer = _state33.vnCRMCustomer;

    if (!vnCRMLookup || vnCRMLookup === 'searching') {
      return null;
    }
    if (vnCRMLookup === 'found') {
      var contact = _this17.getCRMContact(vnCRMCustomer) || {};
      return _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 16 },
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { secondary: true },
          _react2.default.createElement(
            'b',
            null,
            t('Found in CRM'),
            ': ',
            contact.name || ''
          ),
          _react2.default.createElement(_semanticUiReact.Button, {
            type: 'button',
            primary: true,
            size: 'small',
            style: { marginLeft: '1em' },
            onClick: function onClick(e) {
              e.preventDefault();_this17.applyVNCRMPurchaser();
            },
            content: t('Use this customer')
          })
        )
      );
    }
    if (vnCRMLookup === 'not_found') {
      return _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 16 },
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { secondary: true },
          _react2.default.createElement(
            'b',
            null,
            t('Not found in CRM. Fill in the details and a new customer will be created in the CRM when you save'),
            '.'
          )
        )
      );
    }
    return null;
  };

  this.customFormulaTypeConverter = function (customPrice) {
    var projectUnitDetails = _this17.state.projectUnitDetails;

    if (customPrice && projectUnitDetails.spaValue) {
      var valueDiff = customPrice - projectUnitDetails.spaValue;
      if (valueDiff > 0) {
        return 'add_custom_formula';
      } else if (valueDiff < 0) {
        return 'deduct_custom_formula';
      }
    }
    return null;
  };

  this.renderFormulaChangePrefix = function (type) {
    switch (type) {
      case 'deduct_from_list_price':
      case 'deduct_from_spa_price':
      case 'deduct_from_sub_total':
      case 'deduct_custom_formula':
        return _react2.default.createElement(_semanticUiReact.Icon, { color: 'red', size: 'small', name: 'minus' });
      case 'add_from_list_price':
      case 'add_from_spa_price':
      case 'add_from_sub_total':
      case 'add_custom_formula':
        return _react2.default.createElement(_semanticUiReact.Icon, { color: 'green', size: 'small', name: 'plus' });
      default:
        break;
    }
    return '';
  };

  this.renderFormulaChangeClass = function (type) {
    switch (type) {
      case 'deduct_from_list_price':
      case 'deduct_from_spa_price':
      case 'deduct_from_sub_total':
      case 'deduct_custom_formula':
        return 'text_deduct';
      case 'add_from_list_price':
      case 'add_from_spa_price':
      case 'add_from_sub_total':
      case 'add_custom_formula':
        return 'text_add';
      default:
        break;
    }
    return '';
  };

  this.vnStoredPackageTotal = function (packagePricingID) {
    var projectUnitDetails = _this17.state.projectUnitDetails;

    var pricings = projectUnitDetails && projectUnitDetails.projectUnitPackagePricings || [];
    var pricing = pricings.find(function (d) {
      return d.id === packagePricingID;
    });
    return pricing && pricing.totalPrice !== undefined && pricing.totalPrice !== null ? pricing.totalPrice : null;
  };

  this.applyVNLivePackageTotal = function (preview) {
    if (!(0, _vietnam.isVietnamCompany)(_this17.props.auth)) {
      return;
    }
    var total = (0, _vietnamPricing.livePackageTotal)(preview);
    var _state34 = _this17.state,
        booking = _state34.booking,
        projectUnitDetails = _state34.projectUnitDetails,
        vnLivePackageTotals = _state34.vnLivePackageTotals;

    var packagePricingID = booking.unitPackagePricingID;
    if (total === null || !packagePricingID || packagePricingID === projectUnitDetails.spaValue) {
      _this17.setState({ vnPreviewFailed: false });
      return;
    }
    var spaValue = (0, _amount.amountToFixed)(total, projectUnitDetails.spaTimes);
    var spaValueChanged = String(booking.spaValue) !== String(spaValue);
    booking.spaValue = spaValue;
    _this17.setState({
      booking: booking,
      vnPreviewFailed: false,
      vnLivePackageTotals: _extends({}, vnLivePackageTotals, _defineProperty({}, packagePricingID, total))
    }, function () {
      if (_this17.validation.spaValue.current) {
        _this17.validation.spaValue.current.validate(booking.spaValue);
      }
      if (spaValueChanged) {
        _this17.handleCheckChanges();
      }
    });
  };

  this.markVNPreviewFailed = function () {
    if (!(0, _vietnam.isVietnamCompany)(_this17.props.auth)) {
      return;
    }
    var _state35 = _this17.state,
        booking = _state35.booking,
        projectUnitDetails = _state35.projectUnitDetails,
        vnLivePackageTotals = _state35.vnLivePackageTotals;

    var packagePricingID = booking.unitPackagePricingID;
    var nextTotals = _extends({}, vnLivePackageTotals);
    delete nextTotals[packagePricingID];
    var storedTotal = _this17.vnStoredPackageTotal(packagePricingID);
    if (storedTotal !== null) {
      booking.spaValue = (0, _amount.amountToFixed)(storedTotal, projectUnitDetails.spaTimes);
    }
    _this17.setState({ booking: booking, vnPreviewFailed: true, vnLivePackageTotals: nextTotals });
  };

  this.vnApplyLivePackageTotals = function (options) {
    if (!(0, _vietnam.isVietnamCompany)(_this17.props.auth)) {
      return options;
    }
    var _state36 = _this17.state,
        vnLivePackageTotals = _state36.vnLivePackageTotals,
        projectUnitDetails = _state36.projectUnitDetails;

    if (!vnLivePackageTotals || Object.keys(vnLivePackageTotals).length === 0) {
      return options;
    }
    var pricings = projectUnitDetails && projectUnitDetails.projectUnitPackagePricings || [];
    return options.map(function (option) {
      var live = (0, _vietnamPricing.liveTotalFor)(vnLivePackageTotals, option.value);
      var pricing = live === null ? null : pricings.find(function (d) {
        return d.id === option.value;
      });
      if (!pricing) {
        return option;
      }
      var ppp = pricing.projectPackagePricing;
      var hasProjectPackage = !!(ppp && ppp.id);
      var name = hasProjectPackage ? ppp.name : pricing.customName;
      var description = hasProjectPackage ? ppp.description : pricing.customDescription;
      var amount = live.toString();
      return _extends({}, option, {
        description: amount,
        content: _react2.default.createElement(
          _semanticUiReact.Header,
          { className: 'ddPricingTierItem' },
          _react2.default.createElement(
            'div',
            { className: 'name' },
            name
          ),
          _react2.default.createElement(
            'div',
            { className: 'value' },
            _react2.default.createElement(_LoanAmount2.default, { precise: false, format: '0,000,000.00', amount: amount, prefix: _react2.default.createElement(_CurrencySymbol2.default, null) })
          ),
          _react2.default.createElement(
            _semanticUiReact.Header.Subheader,
            null,
            renderPackagePricingDescription(description)
          )
        )
      });
    });
  };

  this.handleWaiveBankGuaranteeChange = function (event, data) {
    var booking = _this17.state.booking;

    booking.waiveBankGuarantee = !!data.checked;
    // Every recorded total was priced with the tick as it stood, so clear them (D-C4).
    _this17.setState({ booking: booking, isPreviewing: false, vnLivePackageTotals: {} }, function () {
      _this17.handleCheckChanges();
      _this17.getPackagePricingCalculation();
    });
  };

  this.renderFeePackageSelect = function (t, feePackages) {
    return _react2.default.createElement(_semanticUiReact.Form.Select, {
      disabled: !_this17.hasPackagePricingAccess() || _this17.isVNFormLocked(),
      className: 'ddPricingTierDropdown',
      label: (0, _translation2.translateModels)(t, 'unitPackageFeeID', 'booking'),
      name: 'unitPackageFeeID',
      options: feePackages,
      placeholder: t('Select {{title}}', { title: (0, _translation2.translateModels)(t, 'unitPackageFeeID', 'booking') }),
      search: true,
      selectOnBlur: false,
      value: _this17.state.booking.unitPackageFeeID,
      onChange: _this17.hasPackagePricingAccess() ? _this17.handleSelectChange : function () {}
    });
  };

  this.renderVNBankGuaranteeWaiver = function (t) {
    if (!(0, _vietnam.isVietnamCompany)(_this17.props.auth)) {
      return null;
    }
    return _react2.default.createElement(
      'div',
      { className: 'vnWaiveBankGuarantee', style: { marginTop: '0.75em' } },
      _react2.default.createElement(_semanticUiReact.Checkbox, {
        name: 'waiveBankGuarantee',
        label: t('Waive Bank Guarantee'),
        checked: !!_this17.state.booking.waiveBankGuarantee,
        onChange: _this17.handleWaiveBankGuaranteeChange,
        disabled: !_this17.hasPackagePricingAccess() || _this17.isVNFormLocked()
      })
    );
  };

  this.renderVNPricePanel = function (t) {
    if (!(0, _vietnam.isVietnamCompany)(_this17.props.auth)) {
      return null;
    }
    var _state37 = _this17.state,
        booking = _state37.booking,
        project = _state37.project,
        newPPI = _state37.newPPI,
        vnPreviewFailed = _state37.vnPreviewFailed;

    var figure = (0, _vietnamPricing.vnPricePanelFigure)({
      preview: newPPI,
      previewFailed: vnPreviewFailed,
      storedTotal: booking.spaValue
    });
    var deposit = (0, _vietnamPricing.depositToCollect)({
      preview: figure.isLive ? newPPI : null,
      flatAmount: project && project.defaultBookingFeeAmount || 0
    });
    return _react2.default.createElement(
      _semanticUiReact.Segment,
      { secondary: true, className: 'vnPricePanel' },
      _react2.default.createElement(
        _semanticUiReact.Grid,
        { columns: 2, verticalAlign: 'middle' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            t('Nett Price')
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right' },
            _react2.default.createElement(
              'strong',
              null,
              (0, _currencyMinor.formatMajorAmount)(figure.amount, VN_CURRENCY_CODE)
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            t('Deposit to collect')
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right' },
            _react2.default.createElement(
              'strong',
              null,
              (0, _currencyMinor.formatMajorAmount)(deposit.amount, VN_CURRENCY_CODE)
            )
          )
        )
      ),
      figure.showStoredNotice && _react2.default.createElement(
        'p',
        { className: 'text-subtitle vnStoredTotalNotice' },
        t(_vietnamPricing.VN_STORED_TOTAL_NOTICE)
      ),
      _react2.default.createElement(
        'p',
        { className: 'text-subtitle' },
        t('Amounts exclude VAT')
      )
    );
  };

  this.vnSummaryLines = function (packagePricing) {
    var calculations = packagePricing && packagePricing.calculations || [];
    return calculations.filter(function (c) {
      return c && !c.isSubTotal;
    });
  };

  this.vnSignedAmount = function (calculationType, amount) {
    var value = Math.abs(Number(amount) || 0);
    var type = String(calculationType || '');
    var isDeduct = type.includes('deduct');
    var isAdd = !isDeduct && type.includes('add');
    var sign = '';
    if (isDeduct) sign = '- ';
    if (isAdd) sign = '+ ';
    var className = '';
    if (isDeduct) className = 'text_deduct';
    if (isAdd) className = 'text_add';
    return _react2.default.createElement(
      'span',
      { className: className },
      sign,
      (0, _currencyMinor.formatMajorAmount)(value, VN_CURRENCY_CODE)
    );
  };

  this.focusVNPricingPackageField = function () {
    var field = document.querySelector('.ddPricingTierDropdown');
    if (!field) {
      return;
    }
    field.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var input = field.querySelector('input.search');
    if (input) {
      input.focus();
    }
  };

  this.renderVNBookingSummary = function (t) {
    if (!(0, _vietnam.isVietnamCompany)(_this17.props.auth)) {
      return null;
    }
    var _state38 = _this17.state,
        booking = _state38.booking,
        projectUnitDetails = _state38.projectUnitDetails,
        identity = _state38.identity,
        newPPI = _state38.newPPI,
        newBFP = _state38.newBFP;

    var unitDetails = projectUnitDetails || {};
    var unitPackagePricings = unitDetails.projectUnitPackagePricings || [];
    var selectedUnitPackagePricing = unitPackagePricings.find(function (d) {
      return d.id === booking.unitPackagePricingID;
    }) || null;
    var packagePricing = newPPI && newPPI.packagePricing || null;
    var lines = selectedUnitPackagePricing ? _this17.vnSummaryLines(packagePricing) : [];
    var total = selectedUnitPackagePricing ? (0, _vietnamPricing.livePackageTotal)(newPPI) : null;
    var unitFeePackages = unitDetails.projectUnitPackageFees || [];
    var selectedUnitFeePackage = unitFeePackages.find(function (d) {
      return d.id === booking.unitPackageFeeID;
    }) || null;
    var feePackage = selectedUnitFeePackage && newBFP && newBFP.packageFee ? newBFP.packageFee : null;
    var feeItems = feePackage && feePackage.items || [];
    var canEditPackage = _this17.hasPackagePricingAccess() && !_this17.isVNFormLocked();
    return _react2.default.createElement(
      _semanticUiReact.Segment,
      { padded: true, className: 'bookingSummaryContainer vnBookingSummary' },
      _react2.default.createElement(
        'div',
        { className: 'bookingSummary' },
        _react2.default.createElement(
          _semanticUiReact.Header,
          { as: 'h4' },
          t('Booking Summary')
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', className: 'personalInfo' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'small',
                null,
                t('Purchaser Full Name')
              ),
              _react2.default.createElement('br', null),
              booking.name || '-'
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'small',
                null,
                _this17.getIdentityType()
              ),
              _react2.default.createElement('br', null),
              identity || '-'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'small',
                null,
                t('Project')
              ),
              _react2.default.createElement('br', null),
              unitDetails.projectName || '-'
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'small',
                null,
                t('Unit')
              ),
              _react2.default.createElement('br', null),
              unitDetails.reference || '-'
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { secondary: true, size: 'small', className: 'vnSummaryPackageBar' },
          _react2.default.createElement(
            'b',
            null,
            t('Pricing Package') + ': '
          ),
          _react2.default.createElement(
            'i',
            null,
            selectedUnitPackagePricing ? selectedUnitPackagePricing.projectPackagePricing.name : '-'
          ),
          canEditPackage && _react2.default.createElement(_semanticUiReact.Label, {
            as: 'button',
            type: 'button',
            size: 'small',
            className: 'textButton',
            content: t('Edit Package'),
            onClick: _this17.focusVNPricingPackageField,
            style: { float: 'right' }
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', className: 'vnSummaryLines' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'b',
                null,
                t('Unit Selling Price')
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              _react2.default.createElement(
                'b',
                null,
                (0, _currencyMinor.formatMajorAmount)(unitDetails.spaValue, VN_CURRENCY_CODE)
              )
            )
          ),
          lines.map(function (line, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { key: line.id || idx },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  line.name
                ),
                line.description ? _react2.default.createElement(
                  'span',
                  null,
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    'small',
                    null,
                    line.description
                  )
                ) : null
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right' },
                _this17.vnSignedAmount(line.calculationType, line.valueChange)
              )
            );
          }),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'b',
                null,
                t('Total Selling Price')
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              _react2.default.createElement(
                'b',
                null,
                (0, _currencyMinor.formatMajorAmount)(total !== null ? total : booking.spaValue, VN_CURRENCY_CODE)
              )
            )
          ),
          feePackage && _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'b',
                null,
                t('Additional Package')
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'small',
                null,
                selectedUnitFeePackage.projectFeePackage.name
              ),
              feeItems.map(function (item, idx) {
                return _react2.default.createElement(
                  'span',
                  { key: item.id || idx },
                  _react2.default.createElement('br', null),
                  _react2.default.createElement(
                    'small',
                    null,
                    item.description ? item.name + ' - ' + item.description : item.name
                  )
                );
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              _this17.vnSignedAmount('add', feePackage.totalPrice)
            )
          )
        )
      )
    );
  };

  this.handleCheckIsPreview = function () {
    if (!_this17.state.isPreviewing) {
      Promise.all([_this17.getPackagePricingCalculation(), _this17.getFeePackageBreakdown()]).then(function () {
        _this17.setState({ isPreviewing: true });
      });
    } else {
      _this17.setState({ isPreviewing: false });
    }
  };

  this.renderBookingSummary = function () {
    var t = _this17.props.t;
    var _state39 = _this17.state,
        booking = _state39.booking,
        projectUnitDetails = _state39.projectUnitDetails,
        identity = _state39.identity,
        newPPI = _state39.newPPI,
        newBFP = _state39.newBFP,
        globalSettings = _state39.globalSettings,
        project = _state39.project;

    var unitPackagePricings = projectUnitDetails ? projectUnitDetails.projectUnitPackagePricings : [];
    var selectedUnitPackagePricing = unitPackagePricings ? unitPackagePricings.find(function (data) {
      return data.id === booking.unitPackagePricingID;
    }) : null;

    var listCalculations = newPPI.packagePricing && newPPI.packagePricing.calculations && newPPI.packagePricing.calculations.length > 0 ? newPPI.packagePricing.calculations.filter(function (ppc) {
      return ppc.category === 'list_price';
    }) : [];
    var spaCalculations = newPPI.packagePricing && newPPI.packagePricing.calculations && newPPI.packagePricing.calculations.length > 0 ? newPPI.packagePricing.calculations.filter(function (ppc) {
      return ppc.category === 'spa_price';
    }) : [];

    var unitFeePackages = projectUnitDetails ? projectUnitDetails.projectUnitPackageFees : [];
    var selectedUnitFeePackage = unitFeePackages ? unitFeePackages.find(function (data) {
      return data.id === booking.unitPackageFeeID;
    }) : null;
    return _react2.default.createElement(
      _semanticUiReact.Segment,
      { padded: true, className: 'bookingSummaryContainer' },
      _react2.default.createElement(
        _semanticUiReact.Button,
        { icon: true, type: 'button', onClick: _this17.handleCheckIsPreview, floated: 'right', style: { padding: '0', background: 'none' } },
        _react2.default.createElement(_semanticUiReact.Icon, { name: 'close' })
      ),
      _react2.default.createElement(
        'div',
        { className: 'bookingSummary' },
        _react2.default.createElement(
          _semanticUiReact.Header,
          { textAlign: 'center' },
          t('Booking Summary')
        ),
        _react2.default.createElement(_semanticUiReact.Divider, null),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', className: 'personalInfo' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'b',
                null,
                t('Purchaser Full Name') + ' :'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              booking.name || '-'
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'b',
                null,
                _this17.getIdentityType()
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              identity || '-'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'b',
                null,
                t('Project') + ' :'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              projectUnitDetails.projectName ? projectUnitDetails.projectName : '-'
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'b',
                null,
                t('Unit') + ' :'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              projectUnitDetails.reference ? projectUnitDetails.reference : '-'
            )
          )
        ),
        _react2.default.createElement(_semanticUiReact.Divider, null),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8 },
              _react2.default.createElement(
                'b',
                null,
                t('Pricing Package') + ' : ' + (selectedUnitPackagePricing ? selectedUnitPackagePricing.projectPackagePricing.name : t('Base Selling Price'))
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'small',
                null,
                selectedUnitPackagePricing ? selectedUnitPackagePricing.projectPackagePricing.description : ''
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'b',
                null,
                globalSettings && globalSettings.unitSellingPrice ? globalSettings.unitSellingPrice : t('Unit Selling Price')
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              _react2.default.createElement(
                'b',
                null,
                _react2.default.createElement(_LoanAmount2.default, {
                  format: '0,000,000.00',
                  amount: projectUnitDetails.spaValue,
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                })
              )
            )
          ),
          selectedUnitPackagePricing && selectedUnitPackagePricing.isCustomPrice ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'b',
                null,
                selectedUnitPackagePricing.customName
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'small',
                null,
                selectedUnitPackagePricing.customDescription
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              _react2.default.createElement(_LoanAmount2.default, {
                format: '0,000,000.00',
                amount: selectedUnitPackagePricing.totalPrice ? selectedUnitPackagePricing.totalPrice.toFixed(2) : '0.00',
                prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
              })
            )
          ) : null,
          listCalculations.map(function (data, idx) {
            var customFormulaType = _this17.customFormulaTypeConverter(newPPI.packagePricing.totalPrice || 0);
            return _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { key: idx },
              data.isSubTotal ? _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  t('Sub Total')
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  data.name
                ),
                _react2.default.createElement('br', null),
                ' ',
                _react2.default.createElement(
                  'small',
                  null,
                  data.description
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right' },
                _react2.default.createElement(_LoanAmount2.default, {
                  format: '0,000,000.00',
                  amount: data.newValue ? data.newValue.toFixed(2) : '0.00',
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                }),
                _react2.default.createElement('br', null),
                !data.isSubTotal && _react2.default.createElement(
                  'small',
                  null,
                  _this17.renderFormulaChangePrefix(data.calculationType === 'custom_formula' ? customFormulaType : data.calculationType)
                ),
                !data.isSubTotal && _react2.default.createElement(
                  'small',
                  {
                    className: '\n                              div_inline_block\n                              ' + _this17.renderFormulaChangeClass(data.calculationType === 'custom_formula' ? customFormulaType : data.calculationType) + '\n                            '
                  },
                  _react2.default.createElement(_LoanAmount2.default, {
                    format: '0,000,000.00',
                    amount: data.valueChange ? data.valueChange.toFixed(2) : '0.00',
                    prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                  }),
                  _react2.default.createElement('br', null)
                )
              )
            );
          }),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'b',
                null,
                selectedUnitPackagePricing ? 'Total Selling Price SPA' : t(booking.unitPackagePricingID === projectUnitDetails.spaValue ? 'Total Selling Price SPA' : 'Selling Price SPA')
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              _react2.default.createElement(
                'b',
                null,
                _react2.default.createElement(_LoanAmount2.default, {
                  format: '0,000,000.00',
                  amount: newPPI.packagePricing ? newPPI.packagePricing.spaPrice.toFixed(2) : booking.spaValue,
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                })
              )
            )
          ),
          spaCalculations.map(function (data, idx) {
            var customFormulaType = _this17.customFormulaTypeConverter(newPPI.packagePricing.totalPrice || 0);
            return _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { key: idx },
              data.isSubTotal ? _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  t('Sub Total')
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  data.name
                ),
                _react2.default.createElement('br', null),
                ' ',
                _react2.default.createElement(
                  'small',
                  null,
                  data.description
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right' },
                _react2.default.createElement(_LoanAmount2.default, {
                  format: '0,000,000.00',
                  amount: data.newValue ? data.newValue.toFixed(2) : '0.00',
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                }),
                _react2.default.createElement('br', null),
                !data.isSubTotal && _react2.default.createElement(
                  'small',
                  null,
                  _this17.renderFormulaChangePrefix(data.calculationType === 'custom_formula' ? customFormulaType : data.calculationType)
                ),
                !data.isSubTotal && _react2.default.createElement(
                  'small',
                  {
                    className: '\n                              div_inline_block\n                              ' + _this17.renderFormulaChangeClass(data.calculationType === 'custom_formula' ? customFormulaType : data.calculationType) + '\n                            '
                  },
                  _react2.default.createElement(_LoanAmount2.default, {
                    format: '0,000,000.00',
                    amount: data.valueChange ? data.valueChange.toFixed(2) : '0.00',
                    prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                  }),
                  _react2.default.createElement('br', null)
                )
              )
            );
          }),
          _this17.hasAccessNettSellingPrice(project) ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'b',
                null,
                t('Nett Selling Price')
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              _react2.default.createElement(
                'b',
                null,
                _react2.default.createElement(_LoanAmount2.default, {
                  format: '0,000,000.00',
                  amount: newPPI.packagePricing ? newPPI.packagePricing.totalPrice.toFixed(2) : newPPI.nettSellingPrice,
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                })
              )
            )
          ) : ''
        ),
        selectedUnitFeePackage && newBFP && newBFP.packageFee && _react2.default.createElement(_semanticUiReact.Divider, null),
        selectedUnitFeePackage && newBFP && newBFP.packageFee ? _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8 },
              _react2.default.createElement(
                'b',
                null,
                'Additional Fee Package : ',
                selectedUnitFeePackage ? selectedUnitFeePackage.projectFeePackage.name : 'Base Selling Price'
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'small',
                null,
                selectedUnitFeePackage ? selectedUnitFeePackage.projectFeePackage.description : ''
              )
            )
          ),
          newBFP.packageFee.items.map(function (data, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { key: idx },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  'b',
                  null,
                  data.name
                ),
                _react2.default.createElement('br', null),
                ' ',
                _react2.default.createElement(
                  'small',
                  null,
                  data.description
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right' },
                _react2.default.createElement(_LoanAmount2.default, {
                  format: '0,000,000.00',
                  amount: data.valueChange ? data.valueChange.toFixed(2) : '0.00',
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                }),
                _react2.default.createElement('br', null),
                _react2.default.createElement(
                  'small',
                  null,
                  _react2.default.createElement(_semanticUiReact.Icon, { color: 'green', size: 'small', name: 'plus' })
                ),
                _react2.default.createElement(
                  'small',
                  { className: 'div_inline_block text_add' },
                  _react2.default.createElement(_LoanAmount2.default, {
                    format: '0,000,000.00',
                    amount: data.valueChange ? data.valueChange.toFixed(2) : '0.00',
                    prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                  }),
                  _react2.default.createElement('br', null)
                )
              )
            );
          }),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                'b',
                null,
                'Total Additional Fee'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              _react2.default.createElement(
                'b',
                null,
                _react2.default.createElement(_LoanAmount2.default, {
                  format: '0,000,000.00',
                  amount: newBFP.packageFee ? newBFP.packageFee.totalPrice.toFixed(2) : 0,
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                })
              )
            )
          )
        ) : null
      )
    );
  };

  this.checkIsEmailRequired = function () {
    var projectCustomFields = _this17.state.projectCustomFields;
    var auth = _this17.props.auth;
    // CPI-976: purchaser email always mandatory for Vietnam (mirrors Overview/Purchaser.jsx).

    if ((0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode)) return true;
    if (projectCustomFields && projectCustomFields.length > 0 && projectCustomFields.filter(function (p) {
      return p.name === 'email';
    }).length > 0) {
      return projectCustomFields.find(function (p) {
        return p.name === 'email';
      }).isRequired;
    }
    return false;
  };

  this.getEmailValidation = function () {
    var emailValidation = [_webValidations.email];
    if (_this17.checkIsEmailRequired()) {
      emailValidation.push(_webValidations.required);
    }
    return emailValidation;
  };

  this.toUppercaseFormat = function (val) {
    var appConfig = _this17.props.appConfig;

    var uppercasePurchaserInfoIsEnabled = appConfig && appConfig.data && appConfig.data.settings && appConfig.data.settings.uppercasePurchaserInfoIsEnabled;
    return uppercasePurchaserInfoIsEnabled && val && typeof val === 'string' ? val.toUpperCase() : val;
  };

  this.toUppercaseOptions = function (opts) {
    return opts.map(function (opt) {
      return _extends({}, opt, {
        text: _this17.toUppercaseFormat(opt.text)
      });
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.booking, _translation.TRANSLATION_FILES.models.bookingPackagePricing]), { withRef: true })((0, _reactRedux.connect)(BookingForm.mapStateToProps)(BookingForm));

/***/ }),
/* 2260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _semanticUiReact = __webpack_require__(2);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _HIMSBookingsList = __webpack_require__(2149);

var _HIMSBookingsList2 = _interopRequireDefault(_HIMSBookingsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HIMSBookingSync = function (_Component) {
  _inherits(HIMSBookingSync, _Component);

  function HIMSBookingSync(props) {
    _classCallCheck(this, HIMSBookingSync);

    var _this = _possibleConstructorReturn(this, (HIMSBookingSync.__proto__ || Object.getPrototypeOf(HIMSBookingSync)).call(this, props));

    _this.handleOnLoading = function (loading) {
      _this.setState({ loading: loading });
    };

    _this.state = {
      loading: true
    };
    return _this;
  }

  _createClass(HIMSBookingSync, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: 'HIMS Booking sync'
        }),
        _react2.default.createElement(_HIMSBookingsList2.default, {
          onLoading: this.handleOnLoading
        })
      );
    }
  }]);

  return HIMSBookingSync;
}(_react.Component);

HIMSBookingSync.contextTypes = {
  store: _propTypes2.default.object
};
HIMSBookingSync.propTypes = {
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  })
};
exports.default = (0, _reactRouter.withRouter)(HIMSBookingSync);

/***/ }),
/* 2261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _LPPSAChecker = __webpack_require__(562);

var _LPPSAChecker2 = _interopRequireDefault(_LPPSAChecker);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _routes = __webpack_require__(403);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isPRS = _config2.default.get('prs');

var LPPSA = function (_Component) {
  _inherits(LPPSA, _Component);

  function LPPSA(props) {
    _classCallCheck(this, LPPSA);

    var _this = _possibleConstructorReturn(this, (LPPSA.__proto__ || Object.getPrototypeOf(LPPSA)).call(this, props));

    _initialiseProps.call(_this);

    var state = LPPSA.getPropsToState(props);
    _this.state = _extends({}, state);
    _this.validation = {};
    return _this;
  }

  _createClass(LPPSA, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = LPPSA.getPropsToState(nextProps);
      // don't allow state to override data if oriData is same
      if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
        state.data = this.state.data;
      }
      this.setState(_extends({}, state));
    }
  }, {
    key: 'updateForm',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(customerData) {
        var data, store, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = customerData;

                delete data.lppsaResult;
                delete data.customerDetail;
                _context.next = 5;
                return this.setLoading(true);

              case 5:
                store = this.context.store;
                _context.prev = 6;
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.state.data.id + '/customer/' + data.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(data)
                }));

              case 9:
                _context.next = 24;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](6);
                _context.next = 15;
                return this.setLoading(false);

              case 15:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context.abrupt('return');

              case 24:
                _context.next = 26;
                return this.setLoading(false);

              case 26:
                store.dispatch((0, _reactRouterRedux.push)((0, _routes.bookingFlow)(this.state.data, 1)));

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 11]]);
      }));

      function updateForm(_x) {
        return _ref.apply(this, arguments);
      }

      return updateForm;
    }()
  }, {
    key: 'render',
    value: function render() {
      var data = this.state.data;

      var projectUnit = data.projectUnit;
      var project = data.project;
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              'Loading'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, textAlign: 'center' },
              _react2.default.createElement(
                _semanticUiReact.Header,
                { as: 'h4', textAlign: 'center' },
                'Booking for ',
                _react2.default.createElement('br', { className: 'large-hide small-hide tablet-hide' }),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/projects/' + (project && project.id) + '/units/' + (projectUnit && projectUnit.id) + '/' },
                  projectUnit && projectUnit.reference
                ),
                ', ',
                project && project.name,
                ' ',
                projectUnit && projectUnit.isBumi && _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'mini' },
                  'Bumi'
                )
              ),
              _react2.default.createElement(_LPPSAChecker2.default, {
                newHeader: 'CUSTOMER ASSESSMENT',
                bookingID: data.id,
                data: data.customer || {},
                token: this.props.token,
                type: 'booking',
                loading: this.state.loading,
                onChange: this.handleOnChange
              }),
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  positive: true,
                  size: 'large',
                  onClick: this.handleOnSave,
                  style: { margin: '1em 0 0.5em' }
                },
                'Save and Continue'
              ),
              !isPRS && _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: (0, _routes.bookingFlow)(data, 1) },
                  'Skip this step'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return LPPSA;
}(_react.Component);

LPPSA.contextTypes = {
  store: _propTypes2.default.object
};
LPPSA.propTypes = {
  token: _propTypes2.default.string,
  fetchNewBooking: _propTypes2.default.func,
  loading: _propTypes2.default.bool
};
LPPSA.defaultData = {
  id: '',
  customer: {
    id: '',
    lppsaResultStatusID: '',
    lppsaResultID: '',
    lppsaResult: {
      name: '',
      key: ''
    }
  }
};

LPPSA.mapStateToProps = function () {
  return {};
};

LPPSA.getPropsToState = function (props) {
  var loading = props.loading;
  var data = Object.assign({}, LPPSA.defaultData, props.data);
  return {
    loading: loading,
    data: data,
    oriData: (0, _clone2.default)(data)
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this2.setState({ loading: loading }, res);
    });
  };

  this.handleOnSave = function (e) {
    e.preventDefault();
    var data = _this2.state.data;

    _this2.updateForm(data.customer);
  };

  this.handleOnChange = function (customerData) {
    var data = _this2.state.data;

    data.customer = Object.assign({}, data.customer, customerData);
    _this2.setState({ data: data });
  };
};

exports.default = (0, _reactRedux.connect)(LPPSA.mapStateToProps)(LPPSA);

/***/ }),
/* 2262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _semanticUiReact = __webpack_require__(2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(13);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _UCBookingsList = __webpack_require__(2210);

var _UCBookingsList2 = _interopRequireDefault(_UCBookingsList);

var _translation = __webpack_require__(4);

var _vietnam = __webpack_require__(40);

var _navigations = __webpack_require__(1052);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_momentTimezone2.default.locale('en-gb');

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _initialiseProps.call(_this);

    var state = List.getPropsToState();
    _this.state = _extends({}, state);
    return _this;
  }

  _createClass(List, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isBranchLeader || this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          auth = _props.auth,
          location = _props.location;
      var pathname = location.pathname;

      var links = (0, _navigations.routes)(auth.company.countryCode).map(function (l) {
        return _extends({}, l, {
          text: t(l.text)
        });
      });
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: link.text,
              content: link.text,
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this2.handleMenu(e, link);
              }
            });
          }),
          rightNav: this.hasAccess() || this.canBulkEditCustomField() ? _react2.default.createElement(
            _semanticUiReact.Dropdown,
            { item: true, text: t('Manage') },
            _react2.default.createElement(
              _semanticUiReact.Dropdown.Menu,
              null,
              this.hasAccess() && _react2.default.createElement(
                _semanticUiReact.Dropdown.Item,
                { onClick: this.handleManageClick, value: 'manage/' },
                t('Manage Pending Status')
              ),
              this.hasAccess() && this.himsIsEnabled() && _react2.default.createElement(
                _semanticUiReact.Dropdown.Item,
                { onClick: this.handleManageClick, value: 'hims/' },
                'HIMS Booking Sync'
              ),
              this.canBulkEditCustomField() && _react2.default.createElement(
                _semanticUiReact.Dropdown.Item,
                { onClick: this.handleManageClick, value: 'customEdit/' },
                t('Bulk Edit Custom Fields')
              )
            )
          ) : null
        }),
        _react2.default.createElement(_UCBookingsList2.default, {
          onLoading: this.handleOnLoading
        })
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};
List.propTypes = {
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isAdmin: _propTypes2.default.bool,
    isDeveloperSupervisor: _propTypes2.default.bool,
    isDeveloperSalesManager: _propTypes2.default.bool,
    isDeveloperSalesAdmin: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      himsIsEnabled: _propTypes2.default.bool
    })
  }),
  t: _propTypes2.default.func
};

List.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

List.getPropsToState = function () {
  var loading = true;
  var menuIsTab = window.innerWidth <= 590;
  return {
    loading: loading,
    menuIsTab: menuIsTab
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleOnLoading = function (loading) {
    _this3.setState({ loading: loading });
  };

  this.himsIsEnabled = function () {
    var appConfig = _this3.props.appConfig;

    return appConfig && appConfig.data && appConfig.data.himsIsEnabled;
  };

  this.canBulkEditCustomField = function () {
    var auth = _this3.props.auth;

    return (0, _vietnam.showsBulkEditCustomFields)(auth) && (auth.isHeadquarters || auth.isAdmin || auth.isDeveloperSupervisor || auth.isDeveloperSalesManager || auth.isDeveloperSalesAdmin);
  };

  this.handleManageClick = function (e, data) {
    e.preventDefault();
    var store = _this3.context.store;

    store.dispatch((0, _reactRouterRedux.push)('/bookings/' + data.value));
  };

  this.handleMenu = function (e, _ref) {
    var value = _ref.value;
    var store = _this3.context.store;

    store.dispatch((0, _reactRouterRedux.replace)(value));
  };

  this.handleResize = function () {
    var state = {};
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this3.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    _this3.setState(_extends({}, state));
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)((0, _reactRedux.connect)(List.mapStateToProps)(List));

/***/ }),
/* 2263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _reactRouter = __webpack_require__(18);

var _LoanTracker = __webpack_require__(1057);

var _LoanTracker2 = _interopRequireDefault(_LoanTracker);

var _BookingSteppers = __webpack_require__(557);

var _BookingSteppers2 = _interopRequireDefault(_BookingSteppers);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _prompt = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var isPRS = _config2.default.get('prs');

var Loan = function (_Component) {
  _inherits(Loan, _Component);

  function Loan(props) {
    _classCallCheck(this, Loan);

    var _this = _possibleConstructorReturn(this, (Loan.__proto__ || Object.getPrototypeOf(Loan)).call(this, props));

    _initialiseProps.call(_this);

    var state = Loan.getPropsToState(props);
    _this.state = _extends({}, state, {
      allBankCases: [],
      systemData: [],
      hasDropCase: false,
      isMortgageRequired: false
    });
    return _this;
  }

  _createClass(Loan, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!isPRS) {
        this.fetchSystemSettings();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Loan.getPropsToState(nextProps);
      // don't allow state to override data if oriData is same
      if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
        state.data = this.state.data;
      }
      if (JSON.stringify(this.state.data) !== JSON.stringify(state.data)) {
        var data = state.data;
        if (data) {
          if (isPRS) {
            this.handleFetchAllBankCases(data);
          } else {
            this.checkIsMortgageRequired(this.state.systemData, data);
          }
        }
      }
      this.setState(_extends({}, state));
    }
  }, {
    key: 'checkBeforeLeave',
    value: function checkBeforeLeave() {
      var _this2 = this;

      var hasBankCases = this.state.allBankCases && this.state.allBankCases.length > 0;

      this.context.router.setRouteLeaveHook(this.props.route, function (nextLocation) {
        if (_this2.state.isMortgageRequired && !hasBankCases && _this2.state.data && (_this2.state.data.paymentMethodID === 'own_banker' || _this2.state.data.paymentMethodID === 'referred_banker')) {
          var store = _this2.context.store;

          var callback = function callback() {
            _this2.setState({ isMortgageRequired: false }, function () {
              store.dispatch((0, _prompt.promptChangesLeave)(nextLocation));
            });
          };
          var header = 'Add Banker';
          var message = 'Mortgage step is compulsory, your booking will be auto released. Do you still want to leave?';
          store.dispatch((0, _prompt.promptChangesMessage)({ header: header, callback: callback, message: message }));
          return false;
        }
        return true;
      });
    }
  }, {
    key: 'fetchSystemSettings',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var store, res, message, systemData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setState({ loading: true });

              case 2:
                store = this.context.store;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/settings/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context.next = 17;
                return this.setState({ loading: false });

              case 17:
                return _context.abrupt('return');

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 31;
                break;

              case 26:
                _context.next = 28;
                return res.json();

              case 28:
                systemData = _context.sent;
                _context.next = 31;
                return this.setState({
                  systemData: systemData
                }, function () {
                  return _this3.checkIsMortgageRequired(systemData, _this3.state.data);
                });

              case 31:
                _context.next = 33;
                return this.setState({ loading: false });

              case 33:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchSystemSettings() {
        return _ref.apply(this, arguments);
      }

      return fetchSystemSettings;
    }()
  }, {
    key: 'generateBankerBookingForm',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(bookingId) {
        var store, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _context2.prev = 3;
                _context2.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + bookingId + '/print_banker/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 6:
                store.dispatch((0, _flash.flashSuccessMessage)({ message: 'Booking form has been shared with the banker(s).' }));
                setTimeout(function () {
                  window.location.reload();
                }, 500);
                _context2.next = 20;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](3);

                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 15;
                return _context2.t0.res.text();

              case 15:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                _context2.next = 20;
                break;

              case 19:
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred while sharing the form.' }));

              case 20:
                _context2.prev = 20;
                _context2.next = 23;
                return this.setLoading(false);

              case 23:
                return _context2.finish(20);

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 10, 20, 24]]);
      }));

      function generateBankerBookingForm(_x) {
        return _ref2.apply(this, arguments);
      }

      return generateBankerBookingForm;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          allBankCases = _state.allBankCases,
          data = _state.data,
          hasDropCase = _state.hasDropCase,
          isMortgageRequired = _state.isMortgageRequired;

      var projectUnit = data.projectUnit;
      var project = data.project;
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              'Loading'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, textAlign: 'center' },
              _react2.default.createElement(
                _semanticUiReact.Header,
                { as: 'h4', textAlign: 'center', style: { marginTop: '1em' } },
                'Booking for ',
                _react2.default.createElement('br', { className: 'large-hide small-hide tablet-hide' }),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/projects/' + (project && project.id) + '/units/' + (projectUnit && projectUnit.id) + '/' },
                  projectUnit && projectUnit.reference
                ),
                ', ',
                project && project.name,
                ' ',
                projectUnit && projectUnit.isBumi && _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'mini' },
                  'Bumi'
                )
              ),
              project && (project.paymentFlow || project.loanTrackerDirectShow) ? _react2.default.createElement(_BookingSteppers2.default, {
                step: project.paymentFlow ? 3 : 2,
                totalSteps: project.paymentFlow && project.loanTrackerDirectShow ? 3 : 2,
                lastStepLabel: project.paymentFlow && !project.loanTrackerDirectShow ? 'Payment' : 'Mortgage'
              }) : '',
              _react2.default.createElement(
                _semanticUiReact.Header,
                { className: 'new_title', as: 'h4', attached: 'top' },
                'LOAN TRACKER'
              ),
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { style: { marginBottom: '1em' }, attached: true },
                _react2.default.createElement(
                  'p',
                  null,
                  'Help purchasers kickstart the loan application process in 3 easy steps.'
                ),
                _react2.default.createElement(_LoanTracker2.default, {
                  auth: this.props.auth,
                  allBankCases: allBankCases,
                  bookingID: data.id,
                  bookingStatusID: data.statusID,
                  bookingSPAValue: data.spaValue,
                  bankerSelectionTabs: data.project && data.project.bankerSelectionTabs ? data.project.bankerSelectionTabs : [],
                  hasDropCase: hasDropCase,
                  isCashBuyer: data.paymentMethodID === 'cash',
                  isNotAuthorizedToInviteBanker: this.checkIsNotAuthorizedToInviteBanker(),
                  loanTrackerLeadID: data.loanTrackerLeadID,
                  loanTrackerLeadDropID: data.loanTrackerLeadDropID,
                  loanTrackerLeadCode: data.loanTrackerLeadCode,
                  loanTrackerLeadConsentPinExpiresAt: data.loanTrackerLeadConsentPinExpiresAt,
                  loanTrackerLeadConsentPinCount: data.loanTrackerLeadConsentPinCount,
                  token: this.props.token,
                  consentTypeID: data.project ? data.project.loanTrackerProjectConsentTypeID : null,
                  leadBankersLimit: data.project ? data.project.loanTrackerProjectLeadBankersLimit : 0,
                  preferredName: data.bookingCustomer ? data.bookingCustomer.preferredName : null,
                  mobilePrefix: data.bookingCustomer ? data.bookingCustomer.mobilePrefix : null,
                  mobile: data.bookingCustomer ? data.bookingCustomer.mobile : null,
                  projectID: data.projectID,
                  projectAssignBankCasesStatus: data.project ? data.project.autoAssignBankerStatus : '',
                  projectCurrencies: data.project ? data.project.projectCurrency : '',
                  bankCases: data.bankCases,
                  leadStatus: data.leadStatus,
                  leadCreatedAt: data.leadCreatedAt,
                  bankerOnCheck: this.checkBanker,
                  setLoading: this.setLoading,
                  location: this.props.location,
                  onBankerAssignmentSuccess: this.handleBankerAssignmentSuccess,
                  project: data.project
                })
              ),
              !isPRS ? _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  as: _reactRouter.Link,
                  color: 'green',
                  disabled: isMortgageRequired && allBankCases.length < 1 && (data.paymentMethodID === 'own_banker' || data.paymentMethodID === 'referred_banker'),
                  to: '/bookings/' + data.id + '/'
                },
                'Complete the booking'
              ) : _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/bookings/' + data.id + '/' },
                  'Skip to booking'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Loan;
}(_react.Component);

Loan.contextTypes = {
  store: _propTypes2.default.object,
  router: _propTypes2.default.object
};
Loan.propTypes = {
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  route: _propTypes2.default.shape({}),
  token: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }).isRequired
};
Loan.defaultData = {
  bankCases: []
};

Loan.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

Loan.getPropsToState = function (props) {
  var loading = props.loading;
  var data = Object.assign({}, Loan.defaultData, props.data);
  if (!data.bankCases) {
    data.bankCases = [];
  }
  return {
    loading: loading,
    data: data,
    oriData: (0, _clone2.default)(data)
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this4.setState({ loading: loading }, res);
    });
  };

  this.getAllBankCases = function (bankCases, bankCaseDrops) {
    var hasDropCase = false;
    var safeBankCases = Array.isArray(bankCases) ? bankCases : [];
    var safeBankCaseDrops = Array.isArray(bankCaseDrops) ? bankCaseDrops : [];
    var bankerIDs = new Set(safeBankCases.map(function (bc) {
      return bc.bankerID;
    }));
    var allCases = safeBankCaseDrops.length > 0 ? [].concat(_toConsumableArray(safeBankCases), _toConsumableArray(safeBankCaseDrops.filter(function (bcd) {
      if (!bankerIDs.has(bcd.bankerID)) {
        hasDropCase = true;
        return true;
      }
      return false;
    }))) : [].concat(_toConsumableArray(safeBankCases));

    _this4.setState({ allBankCases: allCases, hasDropCase: hasDropCase }, function () {
      return _this4.checkBeforeLeave();
    });
  };

  this.checkIsMortgageRequired = function (systemData, data) {
    var isMRequired = false;
    if (systemData && data) {
      var project = data.project;

      var systemARenabled = systemData && systemData.arBookingExpIsEnabled;
      var systemTimerSet = systemData && systemData.arBookingExpMoreThanMinutes !== '' && systemData.arBookingExpMoreThanMinutes !== '0';
      var systemMortgageRequired = systemData.arBookingExpMortgageEnabled;

      var projectARenabled = project && project.arBookingExpIsEnabled;
      var projectMortgageRequired = project && project.arBookingExpMoreThanMinutes !== '' && project.arBookingExpMoreThanMinutes !== '0' && project.arBookingExpMortgageEnabled;

      if (systemARenabled) {
        if (systemTimerSet && systemMortgageRequired) {
          isMRequired = true;
        } else if (!systemTimerSet && projectARenabled && projectMortgageRequired) {
          isMRequired = true;
        } else {
          isMRequired = false;
        }
      } else {
        isMRequired = false;
      }

      _this4.setState({ isMortgageRequired: isMRequired }, function () {
        return _this4.handleFetchAllBankCases(data);
      });
    }
  };

  this.checkIsNotAuthorizedToInviteBanker = function () {
    var auth = _this4.props.auth;
    var data = _this4.state.data;
    // Not allowed to invite and role is not HQ nor Super Admin

    if (data && data.project && !data.project.allowAgentSalesTeamBankerInvitation && auth && !auth.isHeadquarters && !auth.isSuperAdmin) {
      return true;
    }
    return false;
  };

  this.handleFetchAllBankCases = function (data) {
    if (data.loanTrackerLeadID > 0 && data.project && data.project.autoAssignBankerStatus !== '' && data.project.autoAssignBankerStatus === 'booked' && data.statusID === 'reserved') {
      _this4.fetchBankCaseDrops(data);
    } else {
      _this4.getAllBankCases(data.bankCases);
    }
  };

  this.fetchBankCaseDrops = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(booking) {
      var store, res, message, _message, data;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this4.setLoading(true);

            case 2:
              store = _this4.context.store;
              res = void 0;
              _context3.prev = 4;
              _context3.next = 7;
              return store.dispatch((0, _fetchM.fetchM)('/bookings/' + booking.id + '/loan_trackers/bank_cases/drop/', {
                credentials: 'include',
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Csrf-Token': _this4.props.token
                }
              }));

            case 7:
              res = _context3.sent;
              _context3.next = 23;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3['catch'](4);
              _context3.next = 14;
              return _this4.setLoading(false);

            case 14:
              if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                _context3.next = 20;
                break;
              }

              _context3.next = 17;
              return _context3.t0.res.text();

            case 17:
              message = _context3.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
              return _context3.abrupt('return');

            case 20:
              Bugsnag.notifyException(_context3.t0);
              store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
              return _context3.abrupt('return');

            case 23:
              if (res.ok) {
                _context3.next = 31;
                break;
              }

              _context3.next = 26;
              return res.text();

            case 26:
              _message = _context3.sent;
              _context3.next = 29;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

            case 29:
              _context3.next = 35;
              break;

            case 31:
              _context3.next = 33;
              return res.json();

            case 33:
              data = _context3.sent;

              if (data && data.length > 0) {
                _this4.getAllBankCases(booking.bankCases, data);
              } else {
                _this4.getAllBankCases(booking.bankCases);
              }

            case 35:
              _context3.next = 37;
              return _this4.setLoading(false);

            case 37:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this4, [[4, 10]]);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  this.refreshBankingData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    var data, store, res, updatedData;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            data = _this4.state.data;

            if (!(data && data.id)) {
              _context4.next = 18;
              break;
            }

            _context4.prev = 2;
            _context4.next = 5;
            return _this4.setLoading(true);

          case 5:
            store = _this4.context.store;
            _context4.next = 8;
            return store.dispatch((0, _fetchM.fetchM)('/bookings/' + data.id + '/', {
              credentials: 'include',
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'X-Csrf-Token': _this4.props.token
              }
            }));

          case 8:
            res = _context4.sent;

            if (!res.ok) {
              _context4.next = 14;
              break;
            }

            _context4.next = 12;
            return res.json();

          case 12:
            updatedData = _context4.sent;

            _this4.setState({
              data: updatedData,
              oriData: (0, _clone2.default)(updatedData)
            }, function () {
              _this4.handleFetchAllBankCases(updatedData);
            });

          case 14:
            _context4.prev = 14;
            _context4.next = 17;
            return _this4.setLoading(false);

          case 17:
            return _context4.finish(14);

          case 18:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this4, [[2,, 14, 18]]);
  }));
  this.handleBankerAssignmentSuccess = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
    var data;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            data = _this4.state.data;
            _context5.next = 3;
            return _this4.refreshBankingData();

          case 3:
            if (data && data.project && data.project.autoShareFormToBanker) {
              _this4.generateBankerBookingForm(data.id);
            }

          case 4:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, _this4);
  }));
};

exports.default = (0, _reactRedux.connect)(Loan.mapStateToProps)(Loan);

/***/ }),
/* 2264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _Filters = __webpack_require__(86);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _url = __webpack_require__(19);

var _isbase = __webpack_require__(157);

var _isbase2 = _interopRequireDefault(_isbase);

var _storage = __webpack_require__(44);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _isNumber = __webpack_require__(30);

var _vietnam = __webpack_require__(40);

var _PendingUnits = __webpack_require__(2265);

var _PendingUnits2 = _interopRequireDefault(_PendingUnits);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var tabs = [{ id: 1, name: 'pending_approval', text: 'Pending Approval' }, { id: 2, name: 'pending_cancellation', text: 'Pending Cancellation' }];

var Manage = function (_Component) {
  _inherits(Manage, _Component);

  function Manage(props) {
    _classCallCheck(this, Manage);

    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));

    _initialiseProps.call(_this);

    var state = Manage.getPropsToState(props);
    state.data = [];
    _this.state = _extends({}, state, {
      autoReload: false,
      count: 0,
      currentTabID: 1,
      data: [],
      limit: 0,
      loading: true,
      offset: 0,
      cuCount: 0,
      cuLimit: 0,
      cuOffset: 0,
      cuData: []
    });
    var query = (0, _url.decodeSearch)(props.location.search);
    if (query.projectFilter && query.projectFilter.length > 0) {
      _this.state.advanceFilter = true;
    }
    return _this;
  }

  _createClass(Manage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      this.fetchProjectUnitBookings(query);
      // CPI-1226: the Pending Cancellation count used to arrive only on a tab click, so both badges
      // read 0 on first paint. Fetch tab 2's first page silently as well, for Vietnam only.
      if ((0, _vietnam.vnPreloadsPendingCancellationCount)(this.props.auth)) {
        this.fetchPendingCancellationUnits(_extends({}, query, { page: 1 }), true);
      }
      var localAutoReloadValue = (0, _storage.getItem)(_config2.default.get('appName') + '.bookingManageAutoReload');
      if (localAutoReloadValue === 'true') {
        this.state.autoReload = true;
        this.setRefreshDataTimeout();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Manage.getPropsToState(nextProps);
      var query = (0, _url.decodeSearch)(nextProps.location.search);
      if (this.state.currentTabID === 1 && this.state.limit < 0) {
        this.fetchProjectUnitBookings(query);
        state.loading = this.state.loading;
      }
      if (this.state.currentTabID === 2 && this.state.cuLimit < 0) {
        this.fetchPendingCancellationUnits(query);
        state.loading = this.state.loading;
      }
      state.token = this.state.token;
      state.cuToken = this.state.cuToken;
      if (query.projectFilter && query.projectFilter.length > 0) {
        state.advanceFilter = true;
      }
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      if (this.setTimer) {
        clearTimeout(this.setTimer);
      }
      if (this.timeoutRefresh) {
        clearTimeout(this.timeoutRefresh);
      }
    }
  }, {
    key: 'setLoadingSearch',
    value: function setLoadingSearch() {
      var _this2 = this;

      var loadingSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loadingSearch: loadingSearch }, res);
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'setBookings',
    value: function setBookings() {
      var _this4 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this4.setState({
          data: data || []
        }, res);
      });
    }
  }, {
    key: 'setPCBookings',
    value: function setPCBookings() {
      var _this5 = this;

      var cuData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this5.setState({
          cuData: cuData || []
        }, res);
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this6 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this6.setState(state, res);
      });
    }
  }, {
    key: 'fetchProjectUnitBookings',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var silentLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var store, t, query, res, url, queryString, message, token, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (silentLoad) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber.isNumeric)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                res = void 0;
                _context.prev = 8;
                url = '/manage/project_units/';
                queryString = '';

                if (_qs2.default.stringify(query)) {
                  queryString = '?' + _qs2.default.stringify(query);
                }
                _context.next = 14;
                return store.dispatch((0, _fetchM.fetchM)('' + url + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 14:
                res = _context.sent;
                _context.next = 25;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](8);

                Bugsnag.notifyException(_context.t0);
                _context.next = 22;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 22:
                _context.next = 24;
                return this.setLoading(false);

              case 24:
                return _context.abrupt('return');

              case 25:
                if (res.ok) {
                  _context.next = 33;
                  break;
                }

                _context.next = 28;
                return res.text();

              case 28:
                message = _context.sent;
                _context.next = 31;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 31:
                _context.next = 44;
                break;

              case 33:
                token = res.headers.get('X-Csrf-Token');
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 39;
                return res.json();

              case 39:
                data = _context.sent;
                _context.next = 42;
                return this.setBookings(data);

              case 42:
                _context.next = 44;
                return this.setComponentState({
                  token: token,
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 44:
                if (silentLoad) {
                  _context.next = 47;
                  break;
                }

                _context.next = 47;
                return this.setLoading(false);

              case 47:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 17]]);
      }));

      function fetchProjectUnitBookings(_x6) {
        return _ref.apply(this, arguments);
      }

      return fetchProjectUnitBookings;
    }()
  }, {
    key: 'fetchPendingCancellationUnits',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(q) {
        var silentLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var store, t, query, res, url, queryString, message, cuToken, cuCount, cuLimit, cuOffset, cuData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (silentLoad) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber.isNumeric)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                res = void 0;
                _context2.prev = 8;
                url = '/manage/pending_cancellation_units/';
                queryString = '';

                if (_qs2.default.stringify(query)) {
                  queryString = '?' + _qs2.default.stringify(query);
                }
                _context2.next = 14;
                return store.dispatch((0, _fetchM.fetchM)('' + url + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 14:
                res = _context2.sent;
                _context2.next = 25;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2['catch'](8);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 22;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 22:
                _context2.next = 24;
                return this.setLoading(false);

              case 24:
                return _context2.abrupt('return');

              case 25:
                if (res.ok) {
                  _context2.next = 33;
                  break;
                }

                _context2.next = 28;
                return res.text();

              case 28:
                message = _context2.sent;
                _context2.next = 31;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 31:
                _context2.next = 45;
                break;

              case 33:
                cuToken = res.headers.get('X-Csrf-Token');
                cuCount = parseInt(res.headers.get('M-Data-count'), 10);
                cuLimit = parseInt(res.headers.get('M-Data-limit'), 10);
                cuOffset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context2.next = 39;
                return res.json();

              case 39:
                cuData = _context2.sent;

                if (cuData && cuData.length > 0) {
                  cuData.sort(function (a, b) {
                    if (a.bookings && a.bookings.length > 0 && b.bookings && b.bookings.length > 0) {
                      if ((0, _momentTimezone2.default)(a.bookings[0].pendingCancellation).unix() < (0, _momentTimezone2.default)(b.bookings[0].pendingCancellation).unix()) {
                        return 1;
                      }
                      if ((0, _momentTimezone2.default)(a.bookings[0].pendingCancellation).unix() > (0, _momentTimezone2.default)(b.bookings[0].pendingCancellation).unix()) {
                        return -1;
                      }
                    }
                    return 0;
                  });
                }
                _context2.next = 43;
                return this.setPCBookings(cuData);

              case 43:
                _context2.next = 45;
                return this.setComponentState({
                  cuToken: cuToken,
                  cuCount: cuCount,
                  cuLimit: cuLimit,
                  cuOffset: cuOffset
                });

              case 45:
                if (silentLoad) {
                  _context2.next = 48;
                  break;
                }

                _context2.next = 48;
                return this.setLoading(false);

              case 48:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 17]]);
      }));

      function fetchPendingCancellationUnits(_x8) {
        return _ref2.apply(this, arguments);
      }

      return fetchPendingCancellationUnits;
    }()
  }, {
    key: 'hasStaffAccess',
    value: function hasStaffAccess() {
      if (this.props.auth.isBranchLeader) {
        return false;
      }
      return true;
    }
  }, {
    key: 'searchProjects',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(value) {
        var _this7 = this;

        var store, t, res, message, json, findProjectResults, noResultsMessage;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                _context3.next = 4;
                return this.setLoadingSearch(true);

              case 4:
                res = null;
                _context3.prev = 5;
                _context3.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/search/projects/?limit=3&search=' + value, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context3.sent;
                _context3.next = 22;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](5);

                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 18;
                  break;
                }

                _context3.next = 16;
                return _context3.t0.res.text();

              case 16:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 18:
                _context3.next = 20;
                return this.setLoadingSearch(false);

              case 20:
                Bugsnag.notifyException(_context3.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 22:
                if (res.ok) {
                  _context3.next = 28;
                  break;
                }

                _context3.next = 25;
                return this.setLoadingSearch(false);

              case 25:
                throw new Error('Not OK');

              case 28:
                _context3.next = 30;
                return this.setLoadingSearch(false);

              case 30:
                _context3.next = 32;
                return res.json();

              case 32:
                json = _context3.sent;

                if (json) {
                  findProjectResults = json.map(function (obj) {
                    var newResults = {};
                    newResults.key = obj.id;
                    newResults.title = obj.shortName;
                    newResults.description = obj.state;
                    if (obj.pictureKey !== '') {
                      newResults.image = (0, _url.AWSUrl)(_this7.props.appConfig, obj.pictureKey + '010.jpg');
                    } else {
                      newResults.image = '/assets/images/placeholder_x100.jpg';
                    }
                    return newResults;
                  });

                  this.setState({ findProjectResults: findProjectResults });
                } else {
                  noResultsMessage = t('No results found', { ns: _translation.TRANSLATION_FILES.translation });

                  this.setState({ noResultsMessage: noResultsMessage });
                }

              case 34:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 11]]);
      }));

      function searchProjects(_x10) {
        return _ref3.apply(this, arguments);
      }

      return searchProjects;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      store.dispatch((0, _reactRouterRedux.replace)('/bookings/manage/?' + (0, _url.encodeSearch)(query)));
      this.fetchProjectUnitBookings(query);
      this.fetchPendingCancellationUnits(query);
    }
  }, {
    key: 'pushQuery',
    value: function pushQuery(query) {
      var store = this.context.store;
      var currentTabID = this.state.currentTabID;

      store.dispatch((0, _reactRouterRedux.replace)('/bookings/manage/?' + (0, _url.encodeSearch)(query)));
      currentTabID === 1 ? this.fetchProjectUnitBookings(query) : this.fetchPendingCancellationUnits(query);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var t = this.props.t;
      var _state = this.state,
          count = _state.count,
          cuCount = _state.cuCount,
          cuCurrentPage = _state.cuCurrentPage,
          cuData = _state.cuData,
          cuLimit = _state.cuLimit,
          currentPage = _state.currentPage,
          cuOffset = _state.cuOffset,
          currentTabID = _state.currentTabID,
          data = _state.data,
          limit = _state.limit,
          loading = _state.loading,
          offset = _state.offset,
          token = _state.token;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: count === 0 && cuCount === 0 ? t('Manage', { ns: _translation.TRANSLATION_FILES.screens }) : _react2.default.createElement(
            'span',
            null,
            t('Manage', { ns: _translation.TRANSLATION_FILES.screens }),
            ' \xA0',
            _react2.default.createElement(
              _semanticUiReact.Label,
              { color: 'blue' },
              count + cuCount
            )
          )
        }),
        this.renderMenuTool(),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', className: 'booking-list' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'tab-menu manage-booking-tab' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Menu,
                {
                  attached: 'top',
                  tabular: true
                },
                tabs.map(function (tab, key) {
                  return _react2.default.createElement(
                    _semanticUiReact.Menu.Item,
                    {
                      key: key,
                      value: tab.id,
                      onClick: _this8.handleChangeTab,
                      active: currentTabID === tab.id
                    },
                    _react2.default.createElement(
                      'span',
                      null,
                      t(tab.text, { ns: _translation.TRANSLATION_FILES.constants }).toUpperCase(),
                      '\xA0',
                      _react2.default.createElement(
                        _semanticUiReact.Label,
                        { color: 'blue' },
                        tab.id === 1 ? count : cuCount
                      )
                    )
                  );
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(_PendingUnits2.default, {
                auth: this.props.auth,
                data: currentTabID === 1 ? data : cuData,
                loading: loading,
                token: token,
                fetchProjectUnitBookings: currentTabID === 1 ? function (q) {
                  return _this8.fetchProjectUnitBookings(q);
                } : function (q) {
                  return _this8.fetchPendingCancellationUnits(q);
                },
                pendingCancelUnitsTab: currentTabID !== 1
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              currentTabID === 1 ? _react2.default.createElement(_PageNav2.default, {
                currentPage: currentPage,
                count: count,
                limit: limit,
                offset: offset,
                dataSize: data.length,
                loading: loading,
                onChange: this.handleChangePage
              }) : _react2.default.createElement(_PageNav2.default, {
                currentPage: cuCurrentPage,
                count: cuCount,
                limit: cuLimit,
                offset: cuOffset,
                dataSize: cuData.length,
                loading: loading,
                onChange: this.handleChangePage
              })
            )
          )
        )
      );
    }
  }]);

  return Manage;
}(_react.Component);

Manage.contextTypes = {
  store: _propTypes2.default.object
};
Manage.propTypes = {
  appConfig: _propTypes2.default.shape({}),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  t: _propTypes2.default.func
};

Manage.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

Manage.getPropsToState = function (props) {
  var token = '';
  var cuToken = '';
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var cuCurrentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var advanceFilter = false;
  var projectFilter = (0, _isbase2.default)(query.projectFilter) && _qs2.default.parse(atob(query.projectFilter)).name || '';
  return {
    token: token,
    cuToken: cuToken,
    currentPage: currentPage,
    cuCurrentPage: cuCurrentPage,
    search: search,
    advanceFilter: advanceFilter,
    projectFilter: projectFilter,
    loadingSearch: false,
    findProjectResults: [],
    noResultsMessage: 'Loading...'
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this9 = this;

  this.setRefreshDataTimeout = function () {
    if (_this9.timeoutRefresh) {
      clearTimeout(_this9.timeoutRefresh);
    }
    _this9.timeoutRefresh = setTimeout(function () {
      _this9.handleRefreshData();
      _this9.setRefreshDataTimeout();
    }, 30000); // 30 seconds auto refresh time
  };

  this.handleChangePage = function (page) {
    var currentTabID = _this9.state.currentTabID;

    var query = (0, _url.decodeSearch)(_this9.props.location.search);
    query.page = page;
    if (currentTabID === 1) {
      _this9.setState({
        currentPage: page
      });
    } else {
      _this9.setState({
        cuCurrentPage: page
      });
    }
    _this9.pushQuery(query);
  };

  this.handleChangeTab = function (e, _ref4) {
    var value = _ref4.value;

    e.preventDefault();
    _this9.setState({
      currentTabID: value
    }, function () {
      _this9.handleChangePage(1);
    });
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this9.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this9.replaceQuery(query, true);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this9.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    _this9.setState({
      search: ''
    }, function () {
      if (hasQuery) {
        _this9.replaceQuery(query, true);
      }
    });
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this9.props.location.search);
    query[queryName] = value;
    _this9.replaceQuery(query, true);
  };

  this.handleSetAdvanceFilter = function (advanceFilter) {
    _this9.setState({
      advanceFilter: advanceFilter
    });
  };

  this.handleSearchProject = function (value) {
    var t = _this9.props.t;

    clearTimeout(_this9.setTimer);
    // always reset results to null before finding
    var findProjectResults = [];
    var noResultsMessage = t('Loading...', { ns: _translation.TRANSLATION_FILES.translation });
    _this9.setState({ findProjectResults: findProjectResults, noResultsMessage: noResultsMessage, projectFilter: value }, function () {
      if (value !== '') {
        _this9.setTimer = setTimeout(function () {
          _this9.searchProjects(value);
        }, 500);
      }
    });
  };

  this.handleSelectProject = function (project, queryName) {
    var query = (0, _url.decodeSearch)(_this9.props.location.search);
    var internalQuery = {};
    internalQuery.id = project.key;
    internalQuery.name = project.title;
    query[queryName] = btoa(_qs2.default.stringify(internalQuery));
    _this9.replaceQuery(query, true);
  };

  this.handleRefreshData = function () {
    var store = _this9.context.store;

    var query = (0, _url.decodeSearch)(_this9.props.location.search);
    query.page = 1;
    _this9.fetchProjectUnitBookings(query);
    _this9.fetchPendingCancellationUnits(query);
    store.dispatch((0, _reactRouterRedux.replace)('/bookings/manage/?' + (0, _url.encodeSearch)(query)));
  };

  this.handleAutoReload = function () {
    var autoReload = !_this9.state.autoReload;
    _this9.setState({ autoReload: autoReload }, function () {
      (0, _storage.setItem)(_config2.default.get('appName') + '.bookingManageAutoReload', autoReload ? 'true' : 'false');
      // if autoReload is disabled when there is an ongoing timeout then..
      // ..clear the timeout also.
      if (autoReload) {
        _this9.handleRefreshData();
        _this9.setRefreshDataTimeout();
      } else {
        if (_this9.timeout) {
          clearTimeout(_this9.timeout);
        }
        if (_this9.timeoutRefresh) {
          clearTimeout(_this9.timeoutRefresh);
        }
      }
    });
  };

  this.sortItems = [{
    text: 'Oldest Reserved Unit',
    icon: 'sort alphabet ascending',
    sortColumn: 'project_unit.latest_reserved_at',
    sortDirection: 'asc'
  }, {
    text: 'Latest Reserved Unit',
    icon: 'sort alphabet descending',
    sortColumn: 'project_unit.latest_reserved_at',
    sortDirection: 'desc'
  }];

  this.generateRowStyle = function (array) {
    var newArray = array;
    var i = 1;
    var hasMultiple = i !== array.length;
    array.forEach(function (booking, idx) {
      if (!hasMultiple && i === array.length) newArray[idx].className = 'start end';
      if (hasMultiple && i === array.length - (array.length - 1)) newArray[idx].className = 'start';
      if (hasMultiple && i === array.length) newArray[idx].className = 'end';
      i += 1;
    });
    return newArray;
  };

  this.renderMenuTool = function () {
    var t = _this9.props.t;
    var _state2 = _this9.state,
        advanceFilter = _state2.advanceFilter,
        autoReload = _state2.autoReload,
        count = _state2.count,
        cuCount = _state2.cuCount,
        cuCurrentPage = _state2.cuCurrentPage,
        cuData = _state2.cuData,
        cuLimit = _state2.cuLimit,
        cuOffset = _state2.cuOffset,
        currentPage = _state2.currentPage,
        currentTabID = _state2.currentTabID,
        data = _state2.data,
        findProjectResults = _state2.findProjectResults,
        limit = _state2.limit,
        loading = _state2.loading,
        loadingSearch = _state2.loadingSearch,
        noResultsMessage = _state2.noResultsMessage,
        offset = _state2.offset,
        projectFilter = _state2.projectFilter,
        search = _state2.search;

    var query = (0, _url.decodeSearch)(_this9.props.location.search);
    return _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { className: 'toolbar' },
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _SearchFilter2.default,
                {
                  advanceFilter: advanceFilter,
                  isLoading: loading,
                  onChange: _this9.handleFilterOnChange,
                  onClose: _this9.handleClearFilter,
                  search: search,
                  setAdvanceFilter: _this9.handleSetAdvanceFilter,
                  placeholder: t('Search...', { ns: _translation.TRANSLATION_FILES.translation }),
                  leftNav: currentTabID === 1 ? _react2.default.createElement(_PageNav2.default, {
                    currentPage: currentPage,
                    count: count,
                    limit: limit,
                    offset: offset,
                    dataSize: data.length,
                    loading: loading,
                    onChange: _this9.handleChangePage
                  }) : _react2.default.createElement(_PageNav2.default, {
                    currentPage: cuCurrentPage,
                    count: cuCount,
                    limit: cuLimit,
                    offset: cuOffset,
                    dataSize: cuData.length,
                    loading: loading,
                    onChange: _this9.handleChangePage
                  }),
                  rightNav: _react2.default.createElement(_SortButton2.default, {
                    floated: 'right',
                    loading: loading,
                    items: _this9.sortItems.map(function (item) {
                      return _extends({}, item, {
                        text: t(item.text, { ns: _translation.TRANSLATION_FILES.translation })
                      });
                    }),
                    onSort: _this9.handleSortData
                  })
                },
                _react2.default.createElement(_Filters.SearchList, {
                  filterName: 'projectFilter',
                  icon: 'find',
                  isActive: query.projectFilter && query.projectFilter.length > 0 || false,
                  loading: loadingSearch,
                  noResultsMessage: noResultsMessage,
                  onChange: _this9.handleSearchProject,
                  onClose: _this9.handleClearFilter,
                  onSelect: _this9.handleSelectProject,
                  placeholder: t('Find Project', { ns: _translation.TRANSLATION_FILES.screens }),
                  results: findProjectResults,
                  value: projectFilter
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'app--listdata' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement('br', { className: 'large-hide' }),
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { style: { zIndex: 20 }, active: loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'center', width: 16 },
                    _react2.default.createElement(_semanticUiReact.Button, {
                      onClick: _this9.handleAutoReload,
                      compact: true,
                      size: 'tiny',
                      icon: autoReload ? { name: 'toggle on', color: 'green' } : { name: 'toggle off', color: 'red' },
                      content: t('Auto Refresh', { ns: _translation.TRANSLATION_FILES.screens }) + ' ' + (autoReload ? t('On', { ns: _translation.TRANSLATION_FILES.screens }) : t('Off', { ns: _translation.TRANSLATION_FILES.screens }))
                    }),
                    _react2.default.createElement(_semanticUiReact.Button, {
                      color: 'blue',
                      onClick: _this9.handleRefreshData,
                      compact: true,
                      size: 'tiny',
                      icon: 'refresh',
                      content: t('Refresh Now', { ns: _translation.TRANSLATION_FILES.screens })
                    })
                  )
                )
              )
            )
          )
        )
      )
    );
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRouter.withRouter)((0, _reactRedux.connect)(Manage.mapStateToProps)(Manage)));

/***/ }),
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _lodash = __webpack_require__(36);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(13);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _BookingNote = __webpack_require__(313);

var _BookingFeePaymentList = __webpack_require__(1006);

var _BookingFeePaymentList2 = _interopRequireDefault(_BookingFeePaymentList);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _paymentStatuses = __webpack_require__(321);

var _paymentStatuses2 = _interopRequireDefault(_paymentStatuses);

var _SearchStaff = __webpack_require__(388);

var _SearchStaff2 = _interopRequireDefault(_SearchStaff);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _url = __webpack_require__(19);

var _centsFloat = __webpack_require__(175);

var _amount = __webpack_require__(87);

var _valueToText = __webpack_require__(98);

var _valueToText2 = _interopRequireDefault(_valueToText);

var _index = __webpack_require__(145);

var _AttachmentModal = __webpack_require__(585);

var _AttachmentModal2 = _interopRequireDefault(_AttachmentModal);

var _OpportunityCancelModal = __webpack_require__(262);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
/* eslint-disable react/jsx-no-target-blank */

// actions

// components

// utils

// types

// modal


var PendingUnits = function (_Component) {
  _inherits(PendingUnits, _Component);

  function PendingUnits(props) {
    _classCallCheck(this, PendingUnits);

    var _this = _possibleConstructorReturn(this, (PendingUnits.__proto__ || Object.getPrototypeOf(PendingUnits)).call(this, props));

    _initialiseProps.call(_this);

    var state = PendingUnits.getPropsToState(props);
    _this.state = _extends({}, state, {
      attachmentModalState: false,
      attachmentModalData: {},
      bookingPaymentData: '',
      bookingPaymentToken: '',
      customerData: [],
      isDuplicate: false
    });
    return _this;
  }

  _createClass(PendingUnits, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = PendingUnits.getPropsToState(nextProps);
      if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
        state.data = this.state.data;
      }
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, res);
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'fetchPrimaryBookingCustomer',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var t, store, res, json, newCustData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                _context.prev = 3;
                _context.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.state.bookingPaymentData.customerID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 6:
                res = _context.sent;
                _context.next = 17;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](3);

                Bugsnag.notifyException(_context.t0);
                _context.next = 14;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 14:
                _context.next = 16;
                return this.setLoading(false);

              case 16:
                return _context.abrupt('return');

              case 17:
                _context.next = 19;
                return res.json();

              case 19:
                json = _context.sent;

                if (json) {
                  newCustData = Object.assign({}, json || {});

                  this.setState({ customerData: newCustData });
                }
                _context.next = 23;
                return this.setLoading(false);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 9]]);
      }));

      function fetchPrimaryBookingCustomer() {
        return _ref.apply(this, arguments);
      }

      return fetchPrimaryBookingCustomer;
    }()
  }, {
    key: 'fetchBookingPayment',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(bookingID) {
        var t, store, res, message, _message, bookingPaymentToken, bookingPaymentData;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                _context2.prev = 5;
                _context2.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + bookingID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context2.sent;
                _context2.next = 22;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](5);

                if (!(_context2.t0.res && _context2.t0.res.status >= 399 && _context2.t0.res.status < 500)) {
                  _context2.next = 18;
                  break;
                }

                _context2.next = 16;
                return _context2.t0.res.text();

              case 16:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 18:
                _context2.next = 20;
                return this.setLoading(false);

              case 20:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 22:
                if (res.ok) {
                  _context2.next = 30;
                  break;
                }

                _context2.next = 25;
                return res.text();

              case 25:
                _message = _context2.sent;
                _context2.next = 28;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 28:
                _context2.next = 41;
                break;

              case 30:
                bookingPaymentToken = res.headers.get('X-Csrf-Token');
                _context2.next = 33;
                return res.json();

              case 33:
                bookingPaymentData = _context2.sent;
                _context2.next = 36;
                return this.setComponentState({
                  bookingPaymentToken: bookingPaymentToken,
                  bookingPaymentData: bookingPaymentData
                });

              case 36:
                if (!this.isChequeDuplicated(bookingPaymentData)) {
                  _context2.next = 39;
                  break;
                }

                _context2.next = 39;
                return this.setComponentState({
                  isDuplicate: true
                });

              case 39:
                _context2.next = 41;
                return this.fetchPrimaryBookingCustomer();

              case 41:
                _context2.next = 43;
                return this.setLoading(false);

              case 43:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 11]]);
      }));

      function fetchBookingPayment(_x3) {
        return _ref2.apply(this, arguments);
      }

      return fetchBookingPayment;
    }()
  }, {
    key: 'putBooking',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(bookingData, unitID, bookingID, type) {
        var _this4 = this;

        var silentLoad = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        var store, t, res, message, respondData, query, modal, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;

                if (silentLoad) {
                  _context3.next = 5;
                  break;
                }

                _context3.next = 5;
                return this.setLoading(true);

              case 5:
                res = '';
                _context3.prev = 6;
                _context3.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/manage/project_units/' + unitID + '/bookings/' + bookingID + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(bookingData)
                }));

              case 9:
                res = _context3.sent;
                _context3.next = 23;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](6);

                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 20;
                  break;
                }

                _context3.next = 17;
                return _context3.t0.res.text();

              case 17:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 20:
                Bugsnag.notifyException(_context3.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
                return _context3.abrupt('return');

              case 23:
                _context3.next = 25;
                return res.json();

              case 25:
                respondData = _context3.sent;
                query = (0, _url.decodeSearch)(this.props.location.search);
                modal = Object.assign({}, this.state.modal);

                if (this.state.data) {
                  data = this.state.data;

                  data.map(function (unit, idx) {
                    if (unit.id === modal.unitID) {
                      // Hide all cancelled bookings by same units
                      if (modal.type === 'approve') {
                        unit.bookings.map(function (booking, idxb) {
                          var updatedBooking = booking;
                          if (booking.id === modal.bookingID) {
                            updatedBooking.approve = true;
                          } else {
                            updatedBooking.decline = true;
                          }
                          data[idx].bookings[idxb] = updatedBooking;
                          return null;
                        });
                      }
                      if (modal.type === 'decline') {
                        unit.bookings.map(function (booking, idxb) {
                          if (booking.id === modal.bookingID) {
                            var updatedBooking = booking;
                            updatedBooking.decline = true;
                            data[idx].bookings[idxb] = updatedBooking;
                          }
                          return null;
                        });
                      }
                    }
                    return null;
                  });
                  this.setState({ data: data }, function () {
                    modal.unitID = '';
                    modal.bookingID = '';
                    _this4.setState({ modal: modal });
                  });
                }
                _context3.next = 31;
                return this.setLoading(false);

              case 31:
                store.dispatch((0, _flash.flashMessage)({
                  header: type === 'approve' ? t('Booking Confirmed', { ns: _translation.TRANSLATION_FILES.translation }) : t('Resevation Cancelled', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: type === 'approve' ? t('Booking {{code}} successfully confirmed', { code: respondData.code, ns: _translation.TRANSLATION_FILES.translation }) : t('Resevation {{code}} has been declined', { code: respondData.code, ns: _translation.TRANSLATION_FILES.translation }),
                  icon: type === 'approve' ? 'checkmark' : 'x',
                  type: 'success',
                  autoHideDuration: 5000
                }));
                if (this.state.autoReload) {
                  this.timeout = setTimeout(function () {
                    query.page = 1;
                    _this4.fetchProjectUnitBookings(query, true);
                    store.dispatch((0, _reactRouterRedux.replace)('/bookings/manage/?' + (0, _url.encodeSearch)(query)));
                  }, 4000);
                }

              case 33:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 12]]);
      }));

      function putBooking(_x4, _x5, _x6, _x7) {
        return _ref3.apply(this, arguments);
      }

      return putBooking;
    }()
  }, {
    key: 'updateBookingPayment',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(bookingPaymentData) {
        var _this5 = this;

        var xid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.data.id;

        var query, payData, t, store, res, message, respData, _state, data, paymentModal;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setLoading(true);

              case 2:
                query = (0, _url.decodeSearch)(this.props.location.search);
                payData = bookingPaymentData;

                payData.paymentAmount = parseFloat(payData.paymentAmount);
                t = this.props.t;
                store = this.context.store;
                res = '';
                _context4.prev = 8;
                _context4.next = 11;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + xid + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.bookingPaymentToken
                  },
                  body: JSON.stringify(bookingPaymentData)
                }));

              case 11:
                res = _context4.sent;
                _context4.next = 27;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4['catch'](8);
                _context4.next = 18;
                return this.setLoading(false);

              case 18:
                if (!(_context4.t0.res && _context4.t0.res.status >= 400 && _context4.t0.res.status < 500)) {
                  _context4.next = 24;
                  break;
                }

                _context4.next = 21;
                return _context4.t0.res.text();

              case 21:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context4.abrupt('return');

              case 24:
                Bugsnag.notifyException(_context4.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
                return _context4.abrupt('return');

              case 27:
                _context4.next = 29;
                return res.json();

              case 29:
                respData = _context4.sent;

                if (this.state.data) {
                  _state = this.state, data = _state.data, paymentModal = _state.paymentModal;

                  data.map(function (unit, idx) {
                    if (unit.id === paymentModal.unitID) {
                      unit.bookings.map(function (booking, idxb) {
                        var updatedBooking = booking;
                        if (booking.id === paymentModal.bookingID) {
                          updatedBooking.paymentStatus.name = respData.paymentStatusID.split(' ').map(function (w) {
                            return w[0].toUpperCase() + w.substr(1).toLowerCase();
                          }).join(' ');
                          updatedBooking.paymentStatus.id = respData.paymentStatusID;
                          updatedBooking.paymentStatusID = respData.paymentStatusID;
                        }
                        data[idx].bookings[idxb] = updatedBooking;
                        return null;
                      });
                    }
                    return null;
                  });
                  paymentModal.unitID = '';
                  paymentModal.bookingID = '';
                  paymentModal.isOpen = false;
                  this.setState({
                    data: data,
                    paymentModal: paymentModal,
                    bookingPaymentData: ''
                  }, function () {
                    if (_this5.state.autoReload) {
                      _this5.setRefreshDataTimeout();
                    }
                  });
                }
                _context4.next = 33;
                return this.setLoading(false);

              case 33:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Booking {{code}} successfully updated.', { code: respData.code, ns: _translation.TRANSLATION_FILES.translation }) }));
                this.props.fetchProjectUnitBookings(query);

              case 35:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[8, 14]]);
      }));

      function updateBookingPayment(_x9) {
        return _ref4.apply(this, arguments);
      }

      return updateBookingPayment;
    }()
  }, {
    key: 'hasStaffAccess',
    value: function hasStaffAccess() {
      if (this.props.auth.isBranchLeader) {
        return false;
      }
      return true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props = this.props,
          auth = _props.auth,
          pendingCancelUnitsTab = _props.pendingCancelUnitsTab,
          t = _props.t;

      var countryCode = auth && auth.company && auth.company.countryCode;
      var showCancellationReason = pendingCancelUnitsTab && countryCode === 'vn';
      var _state2 = this.state,
          bookingPaymentData = _state2.bookingPaymentData,
          bookingPaymentToken = _state2.bookingPaymentToken,
          customerData = _state2.customerData,
          isDuplicate = _state2.isDuplicate,
          modal = _state2.modal,
          paymentModal = _state2.paymentModal,
          attachmentModalData = _state2.attachmentModalData,
          attachmentModalState = _state2.attachmentModalState;


      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_AttachmentModal2.default, {
          modalState: attachmentModalState,
          data: attachmentModalData,
          onClose: this.handleCloseAttachment
        }),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          { closeOnDimmerClick: false, closeOnDocumentClick: false, open: paymentModal.isOpen, size: 'large' },
          _react2.default.createElement(_semanticUiReact.Header, { content: bookingPaymentData !== '' ? '' + (bookingPaymentData.bookingCustomer.title && t(bookingPaymentData.bookingCustomer.title, { ns: _translation.TRANSLATION_FILES.constants }) + ' ') + t('bookingTitle', { ns: _translation.TRANSLATION_FILES.translation, name: bookingPaymentData.bookingCustomer.preferredName }) : t('Manage Booking', { ns: _translation.TRANSLATION_FILES.translation }) }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            bookingPaymentData !== '' ? _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { active: this.props.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { style: { padding: '0.5em 0em' } },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 16, computer: 16 },
                  _react2.default.createElement(
                    _semanticUiReact.Divider,
                    { horizontal: true },
                    t('Management', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { verticalAlign: 'middle' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'left', width: 6 },
                      _react2.default.createElement(
                        'b',
                        null,
                        t('Assigned staff', { ns: _translation.TRANSLATION_FILES.screens })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 10 },
                      _react2.default.createElement(_SearchStaff2.default, {
                        onClear: this.handleStaffClear,
                        onSelect: this.handleStaffSelect,
                        selectedValue: this.getSelectedStaffValue()
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { verticalAlign: 'top' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'left', width: 6 },
                      _react2.default.createElement(
                        'b',
                        null,
                        t('Notes', { ns: _translation.TRANSLATION_FILES.screens })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 10 },
                      _react2.default.createElement(_BookingNote.NoteEditor, {
                        bookingNote: _extends({}, _index.BookingNoteDefault),
                        hideCustomOptions: true,
                        onUpdate: this.handlePaymentNotesChange,
                        auth: this.props.auth,
                        settings: this.props.appConfig && this.props.appConfig.data && this.props.appConfig.data.settings
                      })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { style: { padding: '0.5em 0em' } },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 16, computer: 16 },
                  _react2.default.createElement(
                    _semanticUiReact.Divider,
                    { horizontal: true },
                    t('Payment', { ns: _translation.TRANSLATION_FILES.screens })
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 8, computer: 8 },
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { verticalAlign: 'middle' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'left', width: 8 },
                      _react2.default.createElement(
                        'b',
                        null,
                        t('Amount', { ns: _translation.TRANSLATION_FILES.screens })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'right', width: 8 },
                      _react2.default.createElement(_semanticUiReact.Form.Input, {
                        fluid: true,
                        name: 'paymentAmount',
                        onChange: this.handlePaymentChange,
                        type: 'tel',
                        placeholder: t('Amount', { ns: _translation.TRANSLATION_FILES.screens }),
                        value: bookingPaymentData.paymentAmount
                      })
                    )
                  ),
                  _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { verticalAlign: 'middle' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'left', width: 8 },
                      _react2.default.createElement(
                        'b',
                        null,
                        t('Outstanding', { ns: _translation.TRANSLATION_FILES.screens })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'right', width: 8 },
                      bookingPaymentData.paymentAmount ? _react2.default.createElement(_LoanAmount2.default, {
                        format: '0,000,000.00',
                        amount: bookingPaymentData.paymentAmount - (0, _centsFloat.centsToFloat)(bookingPaymentData.paymentPaidCents),
                        prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                      }) : '-'
                    )
                  ),
                  _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { verticalAlign: 'middle' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'left', width: 8 },
                      _react2.default.createElement(
                        'b',
                        null,
                        t('Payments Made', { ns: _translation.TRANSLATION_FILES.screens })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'right', width: 8 },
                      _react2.default.createElement(_LoanAmount2.default, {
                        format: '0,000,000.00',
                        amount: (0, _centsFloat.centsToFloat)(bookingPaymentData.paymentPaidCents),
                        prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                      })
                    )
                  ),
                  _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' }, className: 'large-hide small-hide tablet-hide' })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 8, computer: 8 },
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { verticalAlign: 'middle' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'left', width: 8 },
                      _react2.default.createElement(
                        'b',
                        null,
                        t('Status', { ns: _translation.TRANSLATION_FILES.screens })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'right', width: 8 },
                      (0, _valueToText2.default)(_paymentStatuses2.default, bookingPaymentData.paymentStatusID)
                    )
                  ),
                  _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { verticalAlign: 'middle' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'left', width: 8 },
                      _react2.default.createElement(
                        'b',
                        null,
                        t('Notes', { ns: _translation.TRANSLATION_FILES.screens })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'right', width: 8 },
                      _react2.default.createElement(_semanticUiReact.Form.Input, {
                        fluid: true,
                        name: 'paymentNotes',
                        onChange: this.handlePaymentChange,
                        placeholder: t('Notes', { ns: _translation.TRANSLATION_FILES.screens }),
                        value: bookingPaymentData.paymentNotes
                      })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 16, computer: 16 },
                  _react2.default.createElement(_BookingFeePaymentList2.default, {
                    bookingID: bookingPaymentData.id,
                    data: bookingPaymentData.bookingFeePayments || [],
                    listOnly: true,
                    isSubModal: true,
                    token: bookingPaymentToken || ''
                  })
                )
              ),
              isDuplicate ? _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 16, computer: 16 },
                  _react2.default.createElement(
                    _semanticUiReact.Container,
                    { style: { border: '2px solid red', textAlign: 'center', padding: '5px' } },
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { style: { backgroundColor: 'transparent', color: 'red' } },
                      'Warning: Cheque reference number duplication detected. ',
                      _react2.default.createElement('br', null),
                      'Please verify manually before approving/declining this reservation'
                    )
                  )
                )
              ) : null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { style: { padding: '0.5em 0em' } },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 16, computer: 16 },
                  _react2.default.createElement(
                    _semanticUiReact.Divider,
                    { horizontal: true },
                    t('Purchaser Info', { ns: _translation.TRANSLATION_FILES.translation })
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 16, computer: 16 },
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { centered: true },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 2, tablet: 2, computer: 2, textAlign: 'left' },
                        _react2.default.createElement(
                          'b',
                          null,
                          t('Name', { ns: _translation.TRANSLATION_FILES.translation }),
                          ':'
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 8, tablet: 8, computer: 8, textAlign: 'left' },
                        bookingPaymentData.bookingCustomer.name
                      )
                    ),
                    customerData && (customerData.icFrontDocumentID !== '' || customerData.icBackDocumentID !== '') ? _react2.default.createElement(
                      'div',
                      { style: { width: '100%' } },
                      _react2.default.createElement(
                        _semanticUiReact.Grid,
                        { centered: true },
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { mobile: 10, tablet: 10, computer: 10, textAlign: 'left' },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('IC Preview', { ns: _translation.TRANSLATION_FILES.translation }),
                              ':'
                            )
                          )
                        )
                      ),
                      customerData.icFrontDocument || customerData.icBackDocument ? _react2.default.createElement(
                        _semanticUiReact.Grid,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { mobile: 16, tablet: 16, computer: 16 },
                            _react2.default.createElement(
                              _semanticUiReact.Grid,
                              { centered: true },
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Row,
                                { style: { paddingTop: 0, marginBottom: '3rem' } },
                                customerData.icFrontDocument && customerData.icFrontDocument.name !== '' ? _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { mobile: 5, tablet: 5, computer: 5, style: { marginTop: 'auto', marginBottom: 'auto' } },
                                  customerData.icFrontDocument.name.toLowerCase().includes('.pdf') ? _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', style: { color: '#4183C4' } }),
                                    _react2.default.createElement(
                                      'strong',
                                      null,
                                      _react2.default.createElement(
                                        'a',
                                        {
                                          href: (0, _url.AWSUrl)(this.props.appConfig, customerData.icFrontDocument.key),
                                          target: '_blank'
                                        },
                                        customerData.icFrontDocument.name
                                      )
                                    )
                                  ) : _react2.default.createElement(_LoadImage2.default, {
                                    centered: true,
                                    picture: customerData.icFrontDocument,
                                    pictureSize: 70
                                  })
                                ) : _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { mobile: 5, tablet: 5, computer: 5, style: { marginTop: 'auto', marginBottom: 'auto' } },
                                  _react2.default.createElement(
                                    'p',
                                    null,
                                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'exclamation circle', style: { color: '#4183C4' } }),
                                    t('IC Front is not uploaded', { ns: _translation.TRANSLATION_FILES.translation })
                                  )
                                ),
                                customerData.icBackDocument && customerData.icBackDocument.name !== '' ? _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { mobile: 5, tablet: 5, computer: 5, style: { marginTop: 'auto', marginBottom: 'auto' } },
                                  customerData.icBackDocument.name.toLowerCase().includes('.pdf') ? _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', style: { color: '#4183C4' } }),
                                    _react2.default.createElement(
                                      'strong',
                                      null,
                                      _react2.default.createElement(
                                        'a',
                                        {
                                          href: (0, _url.AWSUrl)(this.props.appConfig, customerData.icBackDocument.key),
                                          target: '_blank'
                                        },
                                        customerData.icBackDocument.name
                                      )
                                    )
                                  ) : _react2.default.createElement(_LoadImage2.default, {
                                    centered: true,
                                    picture: customerData.icBackDocument,
                                    pictureSize: 70
                                  })
                                ) : _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { mobile: 5, tablet: 5, computer: 5, style: { marginTop: 'auto', marginBottom: 'auto' } },
                                  _react2.default.createElement(
                                    'p',
                                    null,
                                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'exclamation circle', style: { color: '#4183C4' } }),
                                    t('IC Back is not uploaded', { ns: _translation.TRANSLATION_FILES.translation })
                                  )
                                )
                              )
                            )
                          )
                        )
                      ) : null
                    ) : null
                  )
                )
              )
            ) : _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(
              _semanticUiReact.Button,
              { onClick: this.handleClosePaymentModal, color: 'red' },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'x' }),
              ' ',
              t('Cancel', { ns: _translation.TRANSLATION_FILES.screens })
            ),
            _react2.default.createElement(
              _semanticUiReact.Button,
              { onClick: this.handleSavePaymentModal, color: 'green' },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'check' }),
              ' ',
              t('Save', { ns: _translation.TRANSLATION_FILES.translation })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          { closeOnDimmerClick: false, open: modal.isOpen, size: 'small', className: 'booking-status-note' },
          _react2.default.createElement(_semanticUiReact.Header, { icon: modal.headerIcon, content: modal.header }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              'h4',
              null,
              modal.message
            ),
            _react2.default.createElement(
              'b',
              null,
              t('Notes', { ns: _translation.TRANSLATION_FILES.screens }),
              '* (',
              t('required', { ns: _translation.TRANSLATION_FILES.translation }),
              ')'
            ),
            _react2.default.createElement(_BookingNote.NoteEditor, {
              bookingNote: _extends({}, _index.BookingNoteDefault),
              hideCustomOptions: true,
              onUpdate: this.handleNotesChange,
              auth: this.props.auth,
              settings: this.props.appConfig && this.props.appConfig.data && this.props.appConfig.data.settings
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            !pendingCancelUnitsTab && modal.type === 'decline' && _react2.default.createElement(_semanticUiReact.Checkbox, {
              label: t('Cancel all pending loan applications', { ns: _translation.TRANSLATION_FILES.translation }),
              checked: !pendingCancelUnitsTab && modal.isCancelPending,
              onChange: this.handleCheckboxChange
            }),
            _react2.default.createElement(
              _semanticUiReact.Button,
              { onClick: this.handleCloseModal },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove' }),
              ' ',
              t('Cancel', { ns: _translation.TRANSLATION_FILES.screens })
            ),
            _react2.default.createElement(_semanticUiReact.Button, {
              onClick: this.handleConfirm,
              color: 'green',
              icon: 'checkmark',
              content: modal.actionButtonText === 'Approve' ? t('Approve', { ns: _translation.TRANSLATION_FILES.screens }) : t('Decline', { ns: _translation.TRANSLATION_FILES.screens })
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'app--listdata app--mblr' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'app--mblc' },
              _react2.default.createElement('br', { className: 'large-hide' }),
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { style: { zIndex: 20 }, active: this.props.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              this.state.data.length > 0 ? _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 2, className: 'equal height' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'manage-booking-list-row' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { className: 'manage-booking-list-col', width: 16 },
                    _react2.default.createElement(
                      _semanticUiReact.Table,
                      { celled: true, className: 'manage-bookings' },
                      this.state.data.length > 0 ? _react2.default.createElement(
                        _semanticUiReact.Table.Header,
                        { className: 'mobile-hide' },
                        _react2.default.createElement(
                          _semanticUiReact.Table.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            t('Booking', { ns: _translation.TRANSLATION_FILES.screens })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            t('Purchaser', { ns: _translation.TRANSLATION_FILES.constants })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { textAlign: 'right' },
                            t(auth.company.countryCode === 'vn' ? 'List Price' : 'SPA', { ns: _translation.TRANSLATION_FILES.constants }),
                            ' (',
                            _react2.default.createElement(_CurrencySymbol2.default, null),
                            ')'
                          ),
                          showCancellationReason && _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            t('Cancellation reason', { ns: _translation.TRANSLATION_FILES.translation })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { textAlign: 'center' },
                            t('Assigned', { ns: _translation.TRANSLATION_FILES.translation })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { textAlign: 'center' },
                            t('Created', { ns: _translation.TRANSLATION_FILES.screens })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { textAlign: 'center' },
                            t('Manage', { ns: _translation.TRANSLATION_FILES.screens }),
                            ' ',
                            pendingCancelUnitsTab ? t('Cancellation', { ns: _translation.TRANSLATION_FILES.screens }) : t('Booking', { ns: _translation.TRANSLATION_FILES.screens })
                          )
                        )
                      ) : null,
                      _react2.default.createElement(
                        _semanticUiReact.Table.Body,
                        null,
                        this.state.data.map(function (unitdata) {
                          return unitdata.bookings ? _this6.generateRowStyle(unitdata.bookings).map(function (data, idx) {
                            return _react2.default.createElement(
                              _semanticUiReact.Table.Row,
                              {
                                key: idx,
                                id: data.id,
                                className: data.className,
                                positive: data.approve,
                                negative: data.decline
                              },
                              data.approve || data.decline ? _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { collapsing: true },
                                data.approve ? _react2.default.createElement(
                                  'span',
                                  { className: 'large-hide small-hide tablet-hide', style: { float: 'right' } },
                                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'check' }),
                                  ' ',
                                  t('Approved', { ns: _translation.TRANSLATION_FILES.screens })
                                ) : '',
                                data.decline ? _react2.default.createElement(
                                  'span',
                                  { className: 'large-hide small-hide tablet-hide', style: { float: 'right' } },
                                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'cancel' }),
                                  ' ',
                                  t('Cancelled', { ns: _translation.TRANSLATION_FILES.screens })
                                ) : '',
                                _react2.default.createElement(
                                  _reactRouter.Link,
                                  { to: '/bookings/' + data.id + '/' },
                                  unitdata.reference,
                                  ', ',
                                  _react2.default.createElement('br', { className: 'large-hide' }),
                                  unitdata.project.shortName,
                                  ', ',
                                  _react2.default.createElement('br', null),
                                  _react2.default.createElement(
                                    'small',
                                    null,
                                    data.code
                                  )
                                )
                              ) : _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { collapsing: true },
                                _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  {
                                    className: 'large-hide small-hide tablet-hide',
                                    floated: 'right',
                                    compact: true,
                                    size: 'mini',
                                    negative: true,
                                    onClick: function onClick(e) {
                                      e.preventDefault();
                                      _this6.handleOpenModal(unitdata.id, data.id, data.newBookingNoteEncoded, 'Decline', 'remove', _react2.default.createElement(
                                        'span',
                                        null,
                                        t(pendingCancelUnitsTab ? 'Decline Cancellation' : 'Decline Reservation', { ns: _translation.TRANSLATION_FILES.translation }),
                                        '?',
                                        _react2.default.createElement('br', null),
                                        ' ',
                                        unitdata.reference,
                                        ', ',
                                        unitdata.project.shortName
                                      ), _react2.default.createElement(
                                        'span',
                                        null,
                                        t('{{name}}\'s {{type}} ({{code}}) will {{status}}be cancelled.', {
                                          name: data.bookingCustomer.name,
                                          type: pendingCancelUnitsTab ? t('booking', { ns: _translation.TRANSLATION_FILES.translation }) : t('reservation', { ns: _translation.TRANSLATION_FILES.translation }),
                                          code: data.code,
                                          status: pendingCancelUnitsTab ? t('not ', { ns: _translation.TRANSLATION_FILES.translation }) : '',
                                          ns: _translation.TRANSLATION_FILES.translation
                                        })
                                      ), 'decline', data.updatedAt);
                                    }
                                  },
                                  t('Decline', { ns: _translation.TRANSLATION_FILES.screens })
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  {
                                    className: 'large-hide small-hide tablet-hide',
                                    floated: 'right',
                                    compact: true,
                                    size: 'mini',
                                    color: 'green',
                                    onClick: function onClick(e) {
                                      e.preventDefault();
                                      _this6.handleOpenModal(unitdata.id, data.id, data.newBookingNoteEncoded, 'Approve', 'checkmark', _react2.default.createElement(
                                        'span',
                                        null,
                                        t(pendingCancelUnitsTab ? 'Approve Cancellation' : 'Approve Booking', { ns: _translation.TRANSLATION_FILES.translation }),
                                        '?',
                                        _react2.default.createElement('br', null),
                                        ' ',
                                        unitdata.reference,
                                        ', ',
                                        unitdata.project.shortName
                                      ), _react2.default.createElement(
                                        'span',
                                        null,
                                        t('Approve {{name}}\'s {{type}} ({{code}})', {
                                          name: data.bookingCustomer.name,
                                          type: pendingCancelUnitsTab ? t('cancellation', { ns: _translation.TRANSLATION_FILES.translation }) : t('reservation', { ns: _translation.TRANSLATION_FILES.translation }),
                                          code: data.code,
                                          ns: _translation.TRANSLATION_FILES.translation
                                        }),
                                        unitdata.projectUnitBookingSummary && unitdata.projectUnitBookingSummary.reservedCount > 1 && _react2.default.createElement('br', null),
                                        !pendingCancelUnitsTab && unitdata.projectUnitBookingSummary && unitdata.projectUnitBookingSummary.reservedCount > 1 && t('All other reservations for this unit will be set to unsuccessful reservation.', { ns: _translation.TRANSLATION_FILES.translation })
                                      ), 'approve', data.updatedAt);
                                    }
                                  },
                                  t('Approve', { ns: _translation.TRANSLATION_FILES.screens })
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  {
                                    className: 'large-hide small-hide tablet-hide',
                                    floated: 'right',
                                    compact: true,
                                    size: 'mini',
                                    icon: true,
                                    onClick: function onClick() {
                                      return _this6.handleOpenPaymentModal(data.id, unitdata.id);
                                    }
                                  },
                                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'pencil' })
                                ),
                                _react2.default.createElement(
                                  _reactRouter.Link,
                                  { to: '/bookings/' + data.id + '/' },
                                  unitdata.reference,
                                  ', ',
                                  _react2.default.createElement('br', { className: 'large-hide' }),
                                  unitdata.project.shortName,
                                  ', ',
                                  _react2.default.createElement('br', null),
                                  _react2.default.createElement(
                                    'small',
                                    null,
                                    data.code
                                  )
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { className: 'mobile-hide' },
                                _react2.default.createElement(
                                  'span',
                                  { className: 'mobile-hide' },
                                  _react2.default.createElement(
                                    _reactRouter.Link,
                                    { to: '/bookings/' + data.id + '/' },
                                    data.bookingCustomer.name
                                  )
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { collapsing: true, className: 'mobile-hide', textAlign: 'right' },
                                _react2.default.createElement(
                                  'div',
                                  { className: 'mobile-hide' },
                                  _react2.default.createElement(
                                    'small',
                                    null,
                                    t(data.paymentStatus.name, { ns: _translation.TRANSLATION_FILES.constants })
                                  ),
                                  data.paymentPictures && data.paymentPictures.length > 0 ? _react2.default.createElement(
                                    'span',
                                    null,
                                    '\xA0\xA0'
                                  ) : '',
                                  data.paymentPictures && data.paymentPictures.length > 0 ? _react2.default.createElement(
                                    _semanticUiReact.Button,
                                    {
                                      onClick: function onClick(e) {
                                        e.preventDefault();
                                        _this6.handleOpenAttachment(data);
                                      },
                                      icon: true,
                                      compact: true,
                                      size: 'mini',
                                      color: 'vk',
                                      title: t('View Attachments', { ns: _translation.TRANSLATION_FILES.translation })
                                    },
                                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'attach' }),
                                    ' ',
                                    data.paymentPictures.length
                                  ) : '',
                                  _react2.default.createElement('br', null),
                                  _react2.default.createElement(_LoanAmount2.default, {
                                    format: '0,000,000.00',
                                    amount: (0, _amount.spaFullNumber)(data) || data.spaValue,
                                    prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                                  })
                                )
                              ),
                              showCancellationReason && _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { className: 'mobile-hide' },
                                (0, _OpportunityCancelModal.cancellationCategoryLabel)(data.srCancellationType) ? '' + t((0, _OpportunityCancelModal.cancellationCategoryLabel)(data.srCancellationType), { ns: _translation.TRANSLATION_FILES.translation }) : '-'
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { collapsing: true, textAlign: 'right' },
                                _react2.default.createElement(
                                  'span',
                                  { style: { float: 'left' }, className: 'large-hide small-hide tablet-hide' },
                                  _react2.default.createElement(
                                    _reactRouter.Link,
                                    { to: '/bookings/' + data.id + '/' },
                                    data.bookingCustomer.name
                                  )
                                ),
                                _react2.default.createElement(
                                  'small',
                                  { className: 'large-hide small-hide tablet-hide' },
                                  _react2.default.createElement(
                                    'i',
                                    null,
                                    data.assignedMaPreferredName ? 'Assigned: ' + data.assignedMaPreferredName : _react2.default.createElement(
                                      'span',
                                      null,
                                      '\xA0'
                                    )
                                  )
                                ),
                                _react2.default.createElement(
                                  'span',
                                  { className: 'mobile-hide', style: { float: 'left' } },
                                  _react2.default.createElement(
                                    'small',
                                    null,
                                    data.assignedMaPreferredName ? data.assignedMaPreferredName : _react2.default.createElement(
                                      _semanticUiReact.Button,
                                      {
                                        className: 'mobile-hide',
                                        size: 'mini',
                                        disabled: data.approve || data.decline,
                                        onClick: function onClick() {
                                          return _this6.handleOpenPaymentModal(data.id, unitdata.id);
                                        }
                                      },
                                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'add user' }),
                                      ' ',
                                      t('Assign', { ns: _translation.TRANSLATION_FILES.translation })
                                    )
                                  )
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { collapsing: true, textAlign: 'right' },
                                _react2.default.createElement(
                                  'small',
                                  null,
                                  _react2.default.createElement(
                                    'span',
                                    { style: { float: 'left' }, className: 'large-hide small-hide tablet-hide' },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      'SPA: '
                                    ),
                                    _react2.default.createElement(_LoanAmount2.default, {
                                      format: '0,000,000.00',
                                      amount: (0, _amount.spaFullNumber)(data) || data.spaValue,
                                      prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                                    }),
                                    '\xA0',
                                    data.paymentPictures && data.paymentPictures.length > 0 ? _react2.default.createElement(
                                      'button',
                                      {
                                        className: 'a-button-blue',
                                        onClick: function onClick(e) {
                                          e.preventDefault();
                                          _this6.handleOpenAttachment(data);
                                        },
                                        title: t('View Attachments', { ns: _translation.TRANSLATION_FILES.translation })
                                      },
                                      '(',
                                      t(data.paymentStatus.name, { ns: _translation.TRANSLATION_FILES.constants }),
                                      ' ',
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'attach' }),
                                        data.paymentPictures.length,
                                        ')'
                                      )
                                    ) : '(' + t(data.paymentStatus.name, { ns: _translation.TRANSLATION_FILES.constants }) + ')'
                                  )
                                ),
                                _react2.default.createElement(
                                  'i',
                                  null,
                                  _react2.default.createElement(
                                    'small',
                                    null,
                                    _react2.default.createElement(
                                      'span',
                                      null,
                                      t('by', { ns: _translation.TRANSLATION_FILES.translation }),
                                      ' '
                                    ),
                                    _this6.hasStaffAccess() ? _react2.default.createElement(
                                      _reactRouter.Link,
                                      { to: '/users/' + data.maUserAffiliateID + '/' },
                                      data.maCreatedByPreferredName
                                    ) : data.maCreatedByPreferredName,
                                    _react2.default.createElement(
                                      'span',
                                      { className: 'large-hide small-hide tablet-hide' },
                                      ','
                                    ),
                                    _react2.default.createElement('br', { className: 'mobile-hide' }),
                                    _react2.default.createElement(_Timestamp2.default, {
                                      timestamp: data.createdAt,
                                      precise: true
                                    })
                                  )
                                )
                              ),
                              data.approve || data.decline ? _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                {
                                  collapsing: true,
                                  className: 'mobile-hide',
                                  textAlign: 'center'
                                },
                                data.approve ? _react2.default.createElement(
                                  'span',
                                  null,
                                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'check' }),
                                  ' ',
                                  t('Approved', { ns: _translation.TRANSLATION_FILES.constants })
                                ) : '',
                                data.decline ? _react2.default.createElement(
                                  'span',
                                  null,
                                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'cancel' }),
                                  ' ',
                                  t('Cancelled', { ns: _translation.TRANSLATION_FILES.constants })
                                ) : ''
                              ) : _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { collapsing: true, className: 'mobile-hide' },
                                _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  {
                                    className: 'mobile-hide',
                                    size: 'mini',
                                    icon: true,
                                    onClick: function onClick() {
                                      return _this6.handleOpenPaymentModal(data.id, unitdata.id);
                                    }
                                  },
                                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'pencil' })
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  {
                                    className: 'mobile-hide',
                                    size: 'mini',
                                    color: 'green',
                                    onClick: function onClick(e) {
                                      e.preventDefault();
                                      _this6.handleOpenModal(unitdata.id, data.id, data.newBookingNoteEncoded, 'Approve', 'checkmark', _react2.default.createElement(
                                        'span',
                                        null,
                                        t(pendingCancelUnitsTab ? 'Approve Cancellation' : 'Approve Booking', { ns: _translation.TRANSLATION_FILES.translation }),
                                        '?',
                                        _react2.default.createElement('br', null),
                                        ' ',
                                        unitdata.reference,
                                        ', ',
                                        unitdata.project.shortName
                                      ), _react2.default.createElement(
                                        'span',
                                        null,
                                        t('Approve {{name}}\'s {{type}} ({{code}})', {
                                          name: data.bookingCustomer.name,
                                          type: pendingCancelUnitsTab ? t('cancellation', { ns: _translation.TRANSLATION_FILES.translation }) : t('reservation', { ns: _translation.TRANSLATION_FILES.translation }),
                                          code: data.code,
                                          ns: _translation.TRANSLATION_FILES.translation
                                        }),
                                        unitdata.projectUnitBookingSummary && unitdata.projectUnitBookingSummary.reservedCount > 1 && _react2.default.createElement('br', null),
                                        !pendingCancelUnitsTab && unitdata.projectUnitBookingSummary && unitdata.projectUnitBookingSummary.reservedCount > 1 && t('All other reservations for this unit will be set to unsuccessful reservation.', { ns: _translation.TRANSLATION_FILES.translation })
                                      ), 'approve', data.updatedAt);
                                    }
                                  },
                                  t('Approve', { ns: _translation.TRANSLATION_FILES.screens })
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  {
                                    className: 'mobile-hide',
                                    size: 'mini',
                                    negative: true,
                                    onClick: function onClick(e) {
                                      e.preventDefault();
                                      _this6.handleOpenModal(unitdata.id, data.id, data.newBookingNoteEncoded, 'Decline', 'remove', _react2.default.createElement(
                                        'span',
                                        null,
                                        t(pendingCancelUnitsTab ? 'Decline Cancellation' : 'Decline Reservation', { ns: _translation.TRANSLATION_FILES.translation }),
                                        '?',
                                        _react2.default.createElement('br', null),
                                        ' ',
                                        unitdata.reference,
                                        ', ',
                                        unitdata.project.shortName
                                      ), _react2.default.createElement(
                                        'span',
                                        null,
                                        t('{{name}}\'s {{type}} ({{code}}) will {{status}}be cancelled.', {
                                          name: data.bookingCustomer.name,
                                          type: pendingCancelUnitsTab ? t('booking', { ns: _translation.TRANSLATION_FILES.translation }) : t('reservation', { ns: _translation.TRANSLATION_FILES.translation }),
                                          code: data.code,
                                          status: pendingCancelUnitsTab ? t('not ', { ns: _translation.TRANSLATION_FILES.translation }) : '',
                                          ns: _translation.TRANSLATION_FILES.translation
                                        })
                                      ), 'decline', data.updatedAt);
                                    }
                                  },
                                  t('Decline', { ns: _translation.TRANSLATION_FILES.screens })
                                )
                              )
                            );
                          }) : null;
                        })
                      )
                    )
                  )
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Item,
                      { style: {} },
                      _react2.default.createElement(
                        _semanticUiReact.Item.Content,
                        null,
                        !this.props.loading ? _react2.default.createElement(
                          _semanticUiReact.Segment,
                          { textAlign: 'center' },
                          _react2.default.createElement(
                            'p',
                            null,
                            t('No pending bookings found.', { ns: _translation.TRANSLATION_FILES.translation })
                          )
                        ) : ''
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return PendingUnits;
}(_react.Component);

PendingUnits.contextTypes = {
  store: _propTypes2.default.object
};
PendingUnits.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      settings: _propTypes2.default.shape({
        notesExternalPlaceholder: _propTypes2.default.string
      })
    })
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    code: _propTypes2.default.string
  })),
  loading: _propTypes2.default.bool,
  token: _propTypes2.default.string,
  fetchProjectUnitBookings: _propTypes2.default.func,
  pendingCancelUnitsTab: _propTypes2.default.bool,
  t: _propTypes2.default.func
};

PendingUnits.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

PendingUnits.getPropsToState = function (props) {
  var data = props.data;
  var loading = props.loading;
  // const modal = props.modal;
  var modal = {
    isOpen: false,
    header: '',
    headerIcon: 'warning sign',
    message: '',
    actionButtonText: 'Yes',
    unitID: '',
    bookingID: '',
    notes: '',
    isCancelPending: true,
    updatedAt: ''
  };
  var paymentModal = {
    isOpen: false,
    bookingID: '',
    unitID: ''
  };
  return {
    data: data,
    loading: loading,
    modal: modal,
    oriData: (0, _lodash.clone)(data),
    paymentModal: paymentModal,
    noResultsMessage: 'Loading...'
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.getSelectedStaffValue = function () {
    var bookingPaymentData = _this7.state.bookingPaymentData;

    var selectedStaffValue = {
      key: bookingPaymentData.assignedMaUserID.toString() || 0,
      title: bookingPaymentData.assignedMaName || '',
      price: bookingPaymentData.assignedMaPreferredName || ''
    };
    return selectedStaffValue;
  };

  this.isChequeDuplicated = function (data) {
    var bookingFeePayments = data.bookingFeePayments;

    return Array.isArray(bookingFeePayments) && bookingFeePayments.length > 0 && bookingFeePayments.some(function (bfp) {
      return bfp.isChequeDuplicate && ['cancelled', 'deduction'].every(function (s) {
        return bfp.status !== s;
      });
    });
  };

  this.handleCloseModal = function () {
    var modal = Object.assign({}, _this7.state.modal);
    modal.isOpen = false;
    modal.notes = '';
    modal.updatedAt = '';
    _this7.setState({ modal: modal });
  };

  this.handleOpenModal = function (unitID, bookingID, notes, actionButtonText, headerIcon, header, message, type, updatedAt) {
    var modal = Object.assign({}, _this7.state.modal);
    modal.unitID = unitID;
    modal.bookingID = bookingID;
    modal.notes = notes;
    modal.isOpen = true;
    modal.header = header;
    modal.message = message;
    modal.headerIcon = headerIcon;
    modal.actionButtonText = actionButtonText;
    modal.isCancelPending = false;
    modal.updatedAt = updatedAt;
    if (type === 'approve') {
      modal.type = 'approve';
      _this7.setState({ modal: modal });
    } else if (type === 'decline') {
      modal.isCancelPending = true;
      modal.type = 'decline';
      _this7.setState({ modal: modal });
    }
  };

  this.handleConfirm = function () {
    var _props2 = _this7.props,
        pendingCancelUnitsTab = _props2.pendingCancelUnitsTab,
        t = _props2.t;

    var modal = Object.assign({}, _this7.state.modal);
    if (!modal.notes) {
      var store = _this7.context.store;

      store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Notes required', { ns: _translation.TRANSLATION_FILES.translation }) }));
      return;
    }
    modal.isOpen = false;
    var statusID = void 0;
    var isCancelPending = false;
    var declinedPendingCancellationAt = null;
    if (modal.type === 'approve') {
      // statusID = 'booked';
      // eslint-disable-next-line no-unused-expressions
      pendingCancelUnitsTab ? statusID = 'cancelled_developer' : statusID = 'booked';
    }
    if (modal.type === 'decline') {
      if (pendingCancelUnitsTab) {
        declinedPendingCancellationAt = (0, _momentTimezone2.default)().toDate();
      } else {
        statusID = 'cancelled_developer';
        if (modal.isCancelPending) {
          isCancelPending = true;
        }
      }
    }
    var bookingData = {
      declinedPendingCancellationAt: declinedPendingCancellationAt,
      statusID: statusID,
      isCancelPending: isCancelPending,
      newBookingNoteEncoded: modal.notes,
      updatedAt: modal.updatedAt
    };
    _this7.setState({ modal: modal }, function () {
      _this7.putBooking(bookingData, modal.unitID, modal.bookingID, modal.type, false);
    });
  };

  this.handleOpenPaymentModal = function (bookingID, unitID) {
    var paymentModal = {
      isOpen: true,
      bookingID: bookingID,
      unitID: unitID
    };
    _this7.setState({ paymentModal: paymentModal }, function () {
      _this7.fetchBookingPayment(bookingID);
    });
    if (_this7.timeoutRefresh) {
      clearTimeout(_this7.timeoutRefresh);
    }
  };

  this.handleSavePaymentModal = function () {
    var _state3 = _this7.state,
        bookingPaymentData = _state3.bookingPaymentData,
        paymentModal = _state3.paymentModal;

    _this7.updateBookingPayment(bookingPaymentData, paymentModal.bookingID);
  };

  this.handleClosePaymentModal = function () {
    var bookingPaymentData = '';
    var paymentModal = {
      isOpen: false,
      bookingID: '',
      unitID: ''
    };
    _this7.setState({ paymentModal: paymentModal, bookingPaymentData: bookingPaymentData, isDuplicate: false }, function () {
      if (_this7.state.autoReload) {
        _this7.setRefreshDataTimeout();
      }
    });
  };

  this.handlePaymentChange = function (event, value) {
    var bookingPaymentData = _this7.state.bookingPaymentData;

    bookingPaymentData[value.name] = value.value;
    _this7.setState({ bookingPaymentData: bookingPaymentData });
  };

  this.handlePaymentNotesChange = function (bnEncoded) {
    var bookingPaymentData = _this7.state.bookingPaymentData;

    bookingPaymentData.newBookingNoteEncoded = bnEncoded;
    _this7.setState({ bookingPaymentData: bookingPaymentData });
  };

  this.handleStaffClear = function () {
    var bookingPaymentData = _this7.state.bookingPaymentData;

    bookingPaymentData.assignedMaName = '';
    bookingPaymentData.assignedMaPreferredName = '';
    bookingPaymentData.assignedMaUserID = 0;
    _this7.setState({ bookingPaymentData: bookingPaymentData });
  };

  this.handleStaffSelect = function (value) {
    var bookingPaymentData = _this7.state.bookingPaymentData;

    bookingPaymentData.assignedMaName = value.title;
    bookingPaymentData.assignedMaPreferredName = value.price;
    bookingPaymentData.assignedMaUserID = value.key;
    _this7.setState({ bookingPaymentData: bookingPaymentData });
  };

  this.handleNotesChange = function (value) {
    var modal = _this7.state.modal;

    modal.notes = value;
    _this7.setState({ modal: modal });
  };

  this.handleCheckboxChange = function (event, _ref5) {
    var checked = _ref5.checked;
    var modal = _this7.state.modal;

    modal.isCancelPending = checked;
    _this7.setState({ modal: modal });
  };

  this.handleOpenAttachment = function (data) {
    var d = {};
    d.paymentPictures = data.paymentPictures;
    d.bookingID = data.id;
    _this7.setState({
      attachmentModalState: true,
      attachmentModalData: d
    });
  };

  this.handleCloseAttachment = function () {
    _this7.setState({
      attachmentModalState: false
    });
  };

  this.generateRowStyle = function (array) {
    var newArray = array;
    var i = 1;
    var hasMultiple = i !== array.length;
    array.forEach(function (booking, idx) {
      if (!hasMultiple && i === array.length) newArray[idx].className = 'start end';
      if (hasMultiple && i === array.length - (array.length - 1)) newArray[idx].className = 'start';
      if (hasMultiple && i === array.length) newArray[idx].className = 'end';
      i += 1;
    });
    return newArray;
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRouter.withRouter)((0, _reactRedux.connect)(PendingUnits.mapStateToProps)(PendingUnits)));

/***/ }),
/* 2266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _semanticUiReact = __webpack_require__(2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactRouter = __webpack_require__(18);

var _flash = __webpack_require__(5);

var _url = __webpack_require__(19);

var _isbase = __webpack_require__(157);

var _isbase2 = _interopRequireDefault(_isbase);

var _prompt = __webpack_require__(66);

var _Filters = __webpack_require__(86);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _SearchStaff = __webpack_require__(388);

var _SearchStaff2 = _interopRequireDefault(_SearchStaff);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _BookingFeePaymentList = __webpack_require__(1006);

var _BookingFeePaymentList2 = _interopRequireDefault(_BookingFeePaymentList);

var _fetchM = __webpack_require__(6);

var _isNumber = __webpack_require__(30);

var _storage = __webpack_require__(44);

var _centsFloat = __webpack_require__(175);

var _amount = __webpack_require__(87);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _paymentStatuses = __webpack_require__(321);

var _paymentStatuses2 = _interopRequireDefault(_paymentStatuses);

var _promptMessages = __webpack_require__(43);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _valueToText = __webpack_require__(98);

var _valueToText2 = _interopRequireDefault(_valueToText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/jsx-no-target-blank */


_momentTimezone2.default.locale('en-gb');

var ManageOld = function (_Component) {
  _inherits(ManageOld, _Component);

  function ManageOld(props) {
    _classCallCheck(this, ManageOld);

    var _this = _possibleConstructorReturn(this, (ManageOld.__proto__ || Object.getPrototypeOf(ManageOld)).call(this, props));

    _initialiseProps.call(_this);

    var state = Manage.getPropsToState(props);
    state.data = [];
    _this.state = _extends({
      loading: true,
      bookingPaymentToken: '',
      bookingPaymentData: '',
      showLarge: false,
      selectedPicture: null,
      slideshow: false,
      count: 0,
      limit: 10,
      offset: 0
    }, state, {
      autoReload: false,
      customerData: [],
      isDuplicate: false
    });
    var query = (0, _url.decodeSearch)(props.location.search);
    if (query.projectFilter && query.projectFilter.length > 0) {
      _this.state.advanceFilter = true;
    }
    return _this;
  }

  _createClass(ManageOld, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      this.fetchProjectUnitBookings(query);
      var localAutoReloadValue = (0, _storage.getItem)(_config2.default.get('appName') + '.bookingManageAutoReload');
      if (localAutoReloadValue === 'true') {
        this.state.autoReload = true;
        this.setRefreshDataTimeout();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Manage.getPropsToState(nextProps);
      var query = (0, _url.decodeSearch)(nextProps.location.search);
      if (this.state.limit < 0) {
        this.fetchProjectUnitBookings(query);
        state.loading = this.state.loading;
      }
      state.token = this.state.token;
      if (query.projectFilter && query.projectFilter.length > 0) {
        state.advanceFilter = true;
      }
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      if (this.setTimer) {
        clearTimeout(this.setTimer);
      }
      if (this.timeoutRefresh) {
        clearTimeout(this.timeoutRefresh);
      }
    }
  }, {
    key: 'setLoadingSearch',
    value: function setLoadingSearch() {
      var _this2 = this;

      var loadingSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loadingSearch: loadingSearch }, res);
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'setBookings',
    value: function setBookings() {
      var _this4 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this4.setState({
          data: data || []
        }, res);
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this5 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this5.setState(state, res);
      });
    }
  }, {
    key: 'fetchPrimaryBookingCustomer',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, json, newCustData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                res = void 0;
                _context.prev = 2;
                _context.next = 5;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.state.bookingPaymentData.customerID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                res = _context.sent;
                _context.next = 16;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](2);

                Bugsnag.notifyException(_context.t0);
                _context.next = 13;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 13:
                _context.next = 15;
                return this.setLoading(false);

              case 15:
                return _context.abrupt('return');

              case 16:
                _context.next = 18;
                return res.json();

              case 18:
                json = _context.sent;

                if (json) {
                  newCustData = Object.assign({}, json || {});

                  this.setState({ customerData: newCustData });
                }
                _context.next = 22;
                return this.setLoading(false);

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));

      function fetchPrimaryBookingCustomer() {
        return _ref.apply(this, arguments);
      }

      return fetchPrimaryBookingCustomer;
    }()
  }, {
    key: 'fetchProjectUnitBookings',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(q) {
        var silentLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var store, query, res, url, queryString, message, token, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (silentLoad) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber.isNumeric)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                res = void 0;
                _context2.prev = 7;
                url = '/manage/project_units/';
                queryString = '';

                if (_qs2.default.stringify(query)) {
                  queryString = '?' + _qs2.default.stringify(query);
                }
                _context2.next = 13;
                return store.dispatch((0, _fetchM.fetchM)('' + url + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 13:
                res = _context2.sent;
                _context2.next = 24;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t0 = _context2['catch'](7);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 21;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 21:
                _context2.next = 23;
                return this.setLoading(false);

              case 23:
                return _context2.abrupt('return');

              case 24:
                if (res.ok) {
                  _context2.next = 32;
                  break;
                }

                _context2.next = 27;
                return res.text();

              case 27:
                message = _context2.sent;
                _context2.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 30:
                _context2.next = 43;
                break;

              case 32:
                token = res.headers.get('X-Csrf-Token');
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context2.next = 38;
                return res.json();

              case 38:
                data = _context2.sent;
                _context2.next = 41;
                return this.setBookings(data);

              case 41:
                _context2.next = 43;
                return this.setComponentState({
                  token: token,
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 43:
                _context2.next = 45;
                return this.setLoading(false);

              case 45:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 16]]);
      }));

      function fetchProjectUnitBookings(_x5) {
        return _ref2.apply(this, arguments);
      }

      return fetchProjectUnitBookings;
    }()
  }, {
    key: 'putBoooking',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(bookingData, unitID, bookingID, type) {
        var _this6 = this;

        var silentLoad = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
        var store, res, message, respondData, query, modal, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                store = this.context.store;

                if (silentLoad) {
                  _context3.next = 4;
                  break;
                }

                _context3.next = 4;
                return this.setLoading(true);

              case 4:
                res = '';
                _context3.prev = 5;
                _context3.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/manage/project_units/' + unitID + '/bookings/' + bookingID + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(bookingData)
                }));

              case 8:
                res = _context3.sent;
                _context3.next = 22;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](5);

                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 19;
                  break;
                }

                _context3.next = 16;
                return _context3.t0.res.text();

              case 16:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 19:
                Bugsnag.notifyException(_context3.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context3.abrupt('return');

              case 22:
                _context3.next = 24;
                return res.json();

              case 24:
                respondData = _context3.sent;
                query = (0, _url.decodeSearch)(this.props.location.search);
                modal = Object.assign({}, this.state.modal);

                if (this.state.data) {
                  data = this.state.data;

                  data.map(function (unit, idx) {
                    if (unit.id === modal.unitID) {
                      // Hide all cancelled bookings by same units
                      if (modal.type === 'approve') {
                        unit.bookings.map(function (booking, idxb) {
                          var updatedBooking = booking;
                          if (booking.id === modal.bookingID) {
                            updatedBooking.approve = true;
                          } else {
                            updatedBooking.decline = true;
                          }
                          data[idx].bookings[idxb] = updatedBooking;
                          return null;
                        });
                      }
                      if (modal.type === 'decline') {
                        unit.bookings.map(function (booking, idxb) {
                          if (booking.id === modal.bookingID) {
                            var updatedBooking = booking;
                            updatedBooking.decline = true;
                            data[idx].bookings[idxb] = updatedBooking;
                          }
                          return null;
                        });
                      }
                    }
                    return null;
                  });
                  this.setState({ data: data }, function () {
                    modal.unitID = '';
                    modal.bookingID = '';
                    _this6.setState({ modal: modal });
                  });
                }
                _context3.next = 30;
                return this.setLoading(false);

              case 30:
                store.dispatch((0, _flash.flashMessage)({
                  header: type === 'approve' ? 'Booking Confirmed' : 'Resevation Cancelled',
                  message: type === 'approve' ? 'Booking ' + respondData.code + ' successfully confirmed' : 'Resevation ' + respondData.code + ' has been declined',
                  icon: type === 'approve' ? 'checkmark' : 'x',
                  type: 'success',
                  autoHideDuration: 5000
                }));
                if (this.state.autoReload) {
                  this.timeout = setTimeout(function () {
                    query.page = 1;
                    _this6.fetchProjectUnitBookings(query, true);
                    store.dispatch((0, _reactRouterRedux.replace)('/bookings/manage/?' + (0, _url.encodeSearch)(query)));
                  }, 4000);
                }

              case 32:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 11]]);
      }));

      function putBoooking(_x7, _x8, _x9, _x10) {
        return _ref3.apply(this, arguments);
      }

      return putBoooking;
    }()
  }, {
    key: 'fetchBookingPayment',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(bookingID) {
        var store, res, message, _message, bookingPaymentToken, bookingPaymentData;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context4.prev = 4;
                _context4.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + bookingID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context4.sent;
                _context4.next = 21;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](4);

                if (!(_context4.t0.res && _context4.t0.res.status >= 399 && _context4.t0.res.status < 500)) {
                  _context4.next = 17;
                  break;
                }

                _context4.next = 15;
                return _context4.t0.res.text();

              case 15:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 17:
                _context4.next = 19;
                return this.setLoading(false);

              case 19:
                Bugsnag.notifyException(_context4.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));

              case 21:
                if (res.ok) {
                  _context4.next = 29;
                  break;
                }

                _context4.next = 24;
                return res.text();

              case 24:
                _message = _context4.sent;
                _context4.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 27:
                _context4.next = 40;
                break;

              case 29:
                bookingPaymentToken = res.headers.get('X-Csrf-Token');
                _context4.next = 32;
                return res.json();

              case 32:
                bookingPaymentData = _context4.sent;
                _context4.next = 35;
                return this.setComponentState({
                  bookingPaymentToken: bookingPaymentToken,
                  bookingPaymentData: bookingPaymentData
                });

              case 35:
                if (!this.isChequeDuplicated(bookingPaymentData)) {
                  _context4.next = 38;
                  break;
                }

                _context4.next = 38;
                return this.setComponentState({
                  isDuplicate: true
                });

              case 38:
                _context4.next = 40;
                return this.fetchPrimaryBookingCustomer();

              case 40:
                _context4.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 10]]);
      }));

      function fetchBookingPayment(_x12) {
        return _ref4.apply(this, arguments);
      }

      return fetchBookingPayment;
    }()
  }, {
    key: 'updateBookingPayment',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(bookingPaymentData) {
        var _this7 = this;

        var xid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.data.id;

        var query, payData, store, res, message, respData, _state, data, paymentModal;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.setLoading(true);

              case 2:
                query = (0, _url.decodeSearch)(this.props.location.search);
                payData = bookingPaymentData;

                payData.paymentAmount = parseFloat(payData.paymentAmount);
                store = this.context.store;
                res = '';
                _context5.prev = 7;
                _context5.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + xid + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.bookingPaymentToken
                  },
                  body: JSON.stringify(bookingPaymentData)
                }));

              case 10:
                res = _context5.sent;
                _context5.next = 26;
                break;

              case 13:
                _context5.prev = 13;
                _context5.t0 = _context5['catch'](7);
                _context5.next = 17;
                return this.setLoading(false);

              case 17:
                if (!(_context5.t0.res && _context5.t0.res.status >= 400 && _context5.t0.res.status < 500)) {
                  _context5.next = 23;
                  break;
                }

                _context5.next = 20;
                return _context5.t0.res.text();

              case 20:
                message = _context5.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context5.abrupt('return');

              case 23:
                Bugsnag.notifyException(_context5.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context5.abrupt('return');

              case 26:
                _context5.next = 28;
                return res.json();

              case 28:
                respData = _context5.sent;

                if (this.state.data) {
                  _state = this.state, data = _state.data, paymentModal = _state.paymentModal;

                  data.map(function (unit, idx) {
                    if (unit.id === paymentModal.unitID) {
                      unit.bookings.map(function (booking, idxb) {
                        var updatedBooking = booking;
                        if (booking.id === paymentModal.bookingID) {
                          updatedBooking.paymentStatus.name = respData.paymentStatusID.split(' ').map(function (w) {
                            return w[0].toUpperCase() + w.substr(1).toLowerCase();
                          }).join(' ');
                          updatedBooking.paymentStatus.id = respData.paymentStatusID;
                          updatedBooking.paymentStatusID = respData.paymentStatusID;
                        }
                        data[idx].bookings[idxb] = updatedBooking;
                        return null;
                      });
                    }
                    return null;
                  });
                  paymentModal.unitID = '';
                  paymentModal.bookingID = '';
                  paymentModal.isOpen = false;
                  this.setState({
                    data: data,
                    paymentModal: paymentModal,
                    bookingPaymentData: ''
                  }, function () {
                    if (_this7.state.autoReload) {
                      _this7.setRefreshDataTimeout();
                    }
                  });
                }
                _context5.next = 32;
                return this.setLoading(false);

              case 32:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Update Success', message: 'Booking ' + respData.code + ' successfully updated.' }));
                this.fetchProjectUnitBookings(query);

              case 34:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[7, 13]]);
      }));

      function updateBookingPayment(_x13) {
        return _ref5.apply(this, arguments);
      }

      return updateBookingPayment;
    }()
  }, {
    key: 'hasStaffAccess',
    value: function hasStaffAccess() {
      if (this.props.auth.isBranchLeader) {
        return false;
      }
      return true;
    }
  }, {
    key: 'searchProjects',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(value) {
        var _this8 = this;

        var store, res, message, json, findProjectResults, noResultsMessage;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                store = this.context.store;
                _context6.next = 3;
                return this.setLoadingSearch(true);

              case 3:
                res = null;
                _context6.prev = 4;
                _context6.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/search/projects/?limit=3&search=' + value, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context6.sent;
                _context6.next = 21;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6['catch'](4);

                if (!(_context6.t0.res && _context6.t0.res.status >= 400 && _context6.t0.res.status < 500)) {
                  _context6.next = 17;
                  break;
                }

                _context6.next = 15;
                return _context6.t0.res.text();

              case 15:
                message = _context6.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 17:
                _context6.next = 19;
                return this.setLoadingSearch(false);

              case 19:
                Bugsnag.notifyException(_context6.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));

              case 21:
                if (res.ok) {
                  _context6.next = 27;
                  break;
                }

                _context6.next = 24;
                return this.setLoadingSearch(false);

              case 24:
                throw new Error('Not OK');

              case 27:
                _context6.next = 29;
                return this.setLoadingSearch(false);

              case 29:
                _context6.next = 31;
                return res.json();

              case 31:
                json = _context6.sent;

                if (json) {
                  findProjectResults = json.map(function (obj) {
                    var newResults = {};
                    newResults.key = obj.id;
                    newResults.title = obj.shortName;
                    newResults.description = obj.state;
                    if (obj.pictureKey !== '') {
                      newResults.image = (0, _url.AWSUrl)(_this8.props.appConfig, obj.pictureKey + '010.jpg');
                    } else {
                      newResults.image = '/assets/images/placeholder_x100.jpg';
                    }
                    return newResults;
                  });

                  this.setState({ findProjectResults: findProjectResults });
                } else {
                  noResultsMessage = 'No results found.';

                  this.setState({ noResultsMessage: noResultsMessage });
                }

              case 33:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[4, 10]]);
      }));

      function searchProjects(_x15) {
        return _ref6.apply(this, arguments);
      }

      return searchProjects;
    }()
  }, {
    key: 'checkDisabled',
    value: function checkDisabled() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';
      var _state2 = this.state,
          bookingPaymentData = _state2.bookingPaymentData,
          selectedPicture = _state2.selectedPicture;

      if (bookingPaymentData.paymentPictures && bookingPaymentData.paymentPictures.length > 0 && selectedPicture) {
        var index = bookingPaymentData.paymentPictures.indexOf(selectedPicture);
        if (direction === 'left') {
          return index - 1 >= 0;
        }
        return index + 1 < bookingPaymentData.paymentPictures.length;
      }
      return false;
    }
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      store.dispatch((0, _reactRouterRedux.replace)('/bookings/manage/?' + (0, _url.encodeSearch)(query)));
      this.fetchProjectUnitBookings(query);
    }
  }, {
    key: 'pushQuery',
    value: function pushQuery(query) {
      var store = this.context.store;

      store.dispatch((0, _reactRouterRedux.replace)('/bookings/manage/?' + (0, _url.encodeSearch)(query)));
      this.fetchProjectUnitBookings(query);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this9 = this;

      var query = (0, _url.decodeSearch)(this.props.location.search);
      var _state3 = this.state,
          modal = _state3.modal,
          paymentModal = _state3.paymentModal,
          bookingPaymentData = _state3.bookingPaymentData,
          bookingPaymentToken = _state3.bookingPaymentToken,
          customerData = _state3.customerData,
          isDuplicate = _state3.isDuplicate;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(
          _semanticUiReact.Modal,
          { closeOnDimmerClick: false, closeOnDocumentClick: false, open: paymentModal.isOpen, size: 'large' },
          _react2.default.createElement(_semanticUiReact.Header, { content: bookingPaymentData !== '' ? '' + (bookingPaymentData.bookingCustomer.title && bookingPaymentData.bookingCustomer.title + ' ') + bookingPaymentData.bookingCustomer.preferredName + '\'s Booking' : 'Manage Booking' }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            bookingPaymentData !== '' ? _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { active: this.state.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  'Loading'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { style: { padding: '0.5em 0em' } },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 16, computer: 16 },
                  _react2.default.createElement(
                    _semanticUiReact.Divider,
                    { horizontal: true },
                    'Management'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { verticalAlign: 'middle' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'left', width: 6 },
                      _react2.default.createElement(
                        'b',
                        null,
                        'Assigned Staff'
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 10 },
                      _react2.default.createElement(_SearchStaff2.default, {
                        onClear: this.handleStaffClear,
                        onSelect: this.handleStaffSelect,
                        selectedValue: this.getSelectedStaffValue()
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { verticalAlign: 'top' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'left', width: 6 },
                      _react2.default.createElement(
                        'b',
                        null,
                        'Notes'
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 10 },
                      _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                        name: 'remarkInternal',
                        onChange: this.handlePaymentChange,
                        value: bookingPaymentData.remarkInternal,
                        style: {
                          padding: '.78571429em 1em',
                          border: '1px solid rgba(34,36,38,.15)',
                          borderRadius: '.28571429rem',
                          width: '100%'
                        }
                      })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { style: { padding: '0.5em 0em' } },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 16, computer: 16 },
                  _react2.default.createElement(
                    _semanticUiReact.Divider,
                    { horizontal: true },
                    'Payment'
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 8, computer: 8 },
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { verticalAlign: 'middle' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'left', width: 8 },
                      _react2.default.createElement(
                        'b',
                        null,
                        'Amount'
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'right', width: 8 },
                      _react2.default.createElement(_semanticUiReact.Form.Input, {
                        fluid: true,
                        name: 'paymentAmount',
                        onChange: this.handlePaymentChange,
                        type: 'tel',
                        placeholder: 'Amount',
                        value: bookingPaymentData.paymentAmount
                      })
                    )
                  ),
                  _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { verticalAlign: 'middle' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'left', width: 8 },
                      _react2.default.createElement(
                        'b',
                        null,
                        'Outstanding'
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'right', width: 8 },
                      bookingPaymentData.paymentAmount ? _react2.default.createElement(_LoanAmount2.default, {
                        format: '0,000,000.00',
                        amount: bookingPaymentData.paymentAmount - (0, _centsFloat.centsToFloat)(bookingPaymentData.paymentPaidCents),
                        prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                      }) : '-'
                    )
                  ),
                  _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { verticalAlign: 'middle' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'left', width: 8 },
                      _react2.default.createElement(
                        'b',
                        null,
                        'Payments Made'
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'right', width: 8 },
                      _react2.default.createElement(_LoanAmount2.default, {
                        format: '0,000,000.00',
                        amount: (0, _centsFloat.centsToFloat)(bookingPaymentData.paymentPaidCents),
                        prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                      })
                    )
                  ),
                  _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' }, className: 'large-hide small-hide tablet-hide' })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 8, computer: 8 },
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { verticalAlign: 'middle' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'left', width: 8 },
                      _react2.default.createElement(
                        'b',
                        null,
                        'Status'
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'right', width: 8 },
                      (0, _valueToText2.default)(_paymentStatuses2.default, bookingPaymentData.paymentStatusID)
                    )
                  ),
                  _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { verticalAlign: 'middle' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'left', width: 8 },
                      _react2.default.createElement(
                        'b',
                        null,
                        'Notes'
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'right', width: 8 },
                      _react2.default.createElement(_semanticUiReact.Form.Input, {
                        fluid: true,
                        name: 'paymentNotes',
                        onChange: this.handlePaymentChange,
                        placeholder: 'Notes',
                        value: bookingPaymentData.paymentNotes
                      })
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 16, computer: 16 },
                  _react2.default.createElement(_BookingFeePaymentList2.default, {
                    bookingID: bookingPaymentData.id,
                    data: bookingPaymentData.bookingFeePayments || [],
                    listOnly: true,
                    isSubModal: true,
                    token: bookingPaymentToken || ''
                  })
                )
              ),
              isDuplicate ? _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 16, computer: 16 },
                  _react2.default.createElement(
                    _semanticUiReact.Container,
                    { style: { border: '2px solid red', textAlign: 'center', padding: '5px' } },
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { style: { backgroundColor: 'transparent', color: 'red' } },
                      'Warning: Cheque reference number duplication detected. ',
                      _react2.default.createElement('br', null),
                      'Please verify manually before approving/declining this reservation'
                    )
                  )
                )
              ) : null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { style: { padding: '0.5em 0em' } },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 16, computer: 16 },
                  _react2.default.createElement(
                    _semanticUiReact.Divider,
                    { horizontal: true },
                    'Purchaser Info'
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 16, computer: 16 },
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { centered: true },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 2, tablet: 2, computer: 2, textAlign: 'left' },
                        _react2.default.createElement(
                          'b',
                          null,
                          'Name:'
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 8, tablet: 8, computer: 8, textAlign: 'left' },
                        bookingPaymentData.bookingCustomer.name
                      )
                    ),
                    customerData && (customerData.icFrontDocumentID !== '' || customerData.icBackDocumentID !== '') ? _react2.default.createElement(
                      'div',
                      { style: { width: '100%' } },
                      _react2.default.createElement(
                        _semanticUiReact.Grid,
                        { centered: true },
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { mobile: 10, tablet: 10, computer: 10, textAlign: 'left' },
                            _react2.default.createElement(
                              'b',
                              null,
                              'IC Preview:'
                            )
                          )
                        )
                      ),
                      customerData.icFrontDocument || customerData.icBackDocument ? _react2.default.createElement(
                        _semanticUiReact.Grid,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { mobile: 16, tablet: 16, computer: 16 },
                            _react2.default.createElement(
                              _semanticUiReact.Grid,
                              { centered: true },
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Row,
                                { style: { paddingTop: 0, marginBottom: '3rem' } },
                                customerData.icFrontDocument && customerData.icFrontDocument.name !== '' ? _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { mobile: 5, tablet: 5, computer: 5, style: { marginTop: 'auto', marginBottom: 'auto' } },
                                  customerData.icFrontDocument.name.toLowerCase().includes('.pdf') ? _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', style: { color: '#4183C4' } }),
                                    _react2.default.createElement(
                                      'strong',
                                      null,
                                      _react2.default.createElement(
                                        'a',
                                        {
                                          href: (0, _url.AWSUrl)(this.props.appConfig, customerData.icFrontDocument.key),
                                          target: '_blank'
                                        },
                                        customerData.icFrontDocument.name
                                      )
                                    )
                                  ) : _react2.default.createElement(_LoadImage2.default, {
                                    centered: true,
                                    picture: customerData.icFrontDocument,
                                    pictureSize: 70
                                  })
                                ) : _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { mobile: 5, tablet: 5, computer: 5, style: { marginTop: 'auto', marginBottom: 'auto' } },
                                  _react2.default.createElement(
                                    'p',
                                    null,
                                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'exclamation circle', style: { color: '#4183C4' } }),
                                    'IC Front is not uploaded'
                                  )
                                ),
                                customerData.icBackDocument && customerData.icBackDocument.name !== '' ? _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { mobile: 5, tablet: 5, computer: 5, style: { marginTop: 'auto', marginBottom: 'auto' } },
                                  customerData.icBackDocument.name.toLowerCase().includes('.pdf') ? _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', style: { color: '#4183C4' } }),
                                    _react2.default.createElement(
                                      'strong',
                                      null,
                                      _react2.default.createElement(
                                        'a',
                                        {
                                          href: (0, _url.AWSUrl)(this.props.appConfig, customerData.icBackDocument.key),
                                          target: '_blank'
                                        },
                                        customerData.icBackDocument.name
                                      )
                                    )
                                  ) : _react2.default.createElement(_LoadImage2.default, {
                                    centered: true,
                                    picture: customerData.icBackDocument,
                                    pictureSize: 70
                                  })
                                ) : _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { mobile: 5, tablet: 5, computer: 5, style: { marginTop: 'auto', marginBottom: 'auto' } },
                                  _react2.default.createElement(
                                    'p',
                                    null,
                                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'exclamation circle', style: { color: '#4183C4' } }),
                                    'IC Back is not uploaded'
                                  )
                                )
                              )
                            )
                          )
                        )
                      ) : null
                    ) : null
                  )
                )
              )
            ) : _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              'Loading'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(
              _semanticUiReact.Button,
              { onClick: this.handleClosePaymentModal, color: 'red' },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'x' }),
              ' Cancel'
            ),
            _react2.default.createElement(
              _semanticUiReact.Button,
              { onClick: this.handleSavePaymentModal, color: 'green' },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'check' }),
              ' Save'
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          { closeOnDimmerClick: false, open: modal.isOpen, basic: true, size: 'small', className: 'booking-status-note' },
          _react2.default.createElement(_semanticUiReact.Header, { icon: modal.headerIcon, content: modal.header }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              'h4',
              null,
              modal.message
            ),
            _react2.default.createElement(
              'p',
              null,
              modal.notes === '' ? 'Add' : 'Update',
              ' Notes* (required)'
            ),
            _react2.default.createElement(
              _semanticUiReact.Form,
              null,
              _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                name: 'remarkInternal',
                placeholder: 'Notes*',
                value: modal.notes,
                onChange: this.handleNotesChange
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            modal.type === 'decline' && _react2.default.createElement(_semanticUiReact.Checkbox, {
              label: 'Cancel all pending loan applications',
              checked: modal.isCancelPending,
              onChange: this.handleCheckboxChange
            }),
            _react2.default.createElement(
              _semanticUiReact.Button,
              { onClick: this.handleCloseModal, basic: true, color: 'red', inverted: true },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove' }),
              ' No'
            ),
            _react2.default.createElement(_semanticUiReact.Button, {
              onClick: this.handleConfirm,
              color: 'green',
              inverted: true,
              icon: 'checkmark',
              content: modal.actionButtonText
            })
          )
        ),
        _react2.default.createElement(_NavBar2.default, {
          header: this.state.count === 0 ? 'Manage' : _react2.default.createElement(
            'span',
            null,
            'Manage \xA0',
            _react2.default.createElement(
              _semanticUiReact.Label,
              { color: 'blue' },
              this.state.count
            )
          )
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _SearchFilter2.default,
                {
                  advanceFilter: this.state.advanceFilter,
                  isLoading: this.state.loading,
                  onChange: this.handleFilterOnChange,
                  onClose: this.handleClearFilter,
                  search: this.state.search,
                  setAdvanceFilter: this.handleSetAdvanceFilter,
                  placeholder: 'Search...',
                  leftNav: _react2.default.createElement(_PageNav2.default, {
                    currentPage: this.state.currentPage,
                    count: this.state.count,
                    limit: this.state.limit,
                    offset: this.state.offset,
                    dataSize: this.state.data.length,
                    loading: this.state.loading,
                    onChange: this.handleChangePage
                  }),
                  rightNav: _react2.default.createElement(_SortButton2.default, {
                    floated: 'right',
                    loading: this.state.loading,
                    items: this.sortItems,
                    onSort: this.handleSortData
                  })
                },
                _react2.default.createElement(_Filters.SearchList, {
                  filterName: 'projectFilter',
                  icon: 'find',
                  isActive: query.projectFilter && query.projectFilter.length > 0 || false,
                  loading: this.state.loadingSearch,
                  noResultsMessage: this.state.noResultsMessage,
                  onChange: this.handleSearchProject,
                  onClose: this.handleClearFilter,
                  onSelect: this.handleSelectProject,
                  placeholder: 'Find Project',
                  results: this.state.findProjectResults,
                  value: this.state.projectFilter
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'app--listdata' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement('br', { className: 'large-hide' }),
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  'Loading'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'center', width: 16 },
                    _react2.default.createElement(_semanticUiReact.Button, {
                      onClick: this.handleAutoReload,
                      compact: true,
                      size: 'tiny',
                      icon: this.state.autoReload ? { name: 'toggle on', color: 'green' } : { name: 'toggle off', color: 'red' },
                      content: 'Auto Refresh ' + (this.state.autoReload ? 'On' : 'Off')
                    }),
                    _react2.default.createElement(_semanticUiReact.Button, {
                      color: 'blue',
                      onClick: this.handleRefreshData,
                      compact: true,
                      size: 'tiny',
                      icon: 'refresh',
                      content: 'Refresh Now'
                    })
                  )
                )
              ),
              this.state.data.length > 0 ? _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 2, className: 'equal height' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    _react2.default.createElement(
                      _semanticUiReact.Table,
                      { celled: true, className: 'manage-bookings' },
                      this.state.data.length > 0 ? _react2.default.createElement(
                        _semanticUiReact.Table.Header,
                        { className: 'mobile-hide' },
                        _react2.default.createElement(
                          _semanticUiReact.Table.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            'Booking'
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            'Purchaser'
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { textAlign: 'right' },
                            'SPA (',
                            _react2.default.createElement(_CurrencySymbol2.default, null),
                            ')'
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { textAlign: 'center' },
                            'Assigned'
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { textAlign: 'center' },
                            'Created'
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { textAlign: 'center' },
                            'Manage Booking'
                          )
                        )
                      ) : null,
                      _react2.default.createElement(
                        _semanticUiReact.Table.Body,
                        null,
                        this.state.data.map(function (unitdata) {
                          return unitdata.bookings ? _this9.generateRowStyle(unitdata.bookings).map(function (data, idx) {
                            return _react2.default.createElement(
                              _semanticUiReact.Table.Row,
                              {
                                key: idx,
                                id: data.id,
                                className: data.className,
                                positive: data.approve,
                                negative: data.decline
                              },
                              data.approve || data.decline ? _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { collapsing: true },
                                data.approve ? _react2.default.createElement(
                                  'span',
                                  { className: 'large-hide small-hide tablet-hide', style: { float: 'right' } },
                                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'check' }),
                                  ' Approved'
                                ) : '',
                                data.decline ? _react2.default.createElement(
                                  'span',
                                  { className: 'large-hide small-hide tablet-hide', style: { float: 'right' } },
                                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'cancel' }),
                                  ' Cancelled'
                                ) : '',
                                _react2.default.createElement(
                                  _reactRouter.Link,
                                  { to: '/bookings/' + data.id + '/' },
                                  unitdata.reference,
                                  ', ',
                                  _react2.default.createElement('br', { className: 'large-hide' }),
                                  unitdata.project.shortName,
                                  ', ',
                                  _react2.default.createElement('br', null),
                                  _react2.default.createElement(
                                    'small',
                                    null,
                                    data.code
                                  )
                                )
                              ) : _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { collapsing: true },
                                _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  {
                                    className: 'large-hide small-hide tablet-hide',
                                    floated: 'right',
                                    compact: true,
                                    size: 'mini',
                                    negative: true,
                                    onClick: function onClick(e) {
                                      e.preventDefault();
                                      _this9.handleOpenModal(unitdata.id, data.id, data.remarkInternal, 'Decline', 'remove', _react2.default.createElement(
                                        'span',
                                        null,
                                        'Decline Reservation?',
                                        _react2.default.createElement('br', null),
                                        ' ',
                                        unitdata.reference,
                                        ', ',
                                        unitdata.project.shortName
                                      ), _react2.default.createElement(
                                        'span',
                                        null,
                                        data.bookingCustomer.name,
                                        '\'s ',
                                        'reservation (',
                                        data.code,
                                        ') will be cancelled.'
                                      ), 'decline');
                                    }
                                  },
                                  'Decline'
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  {
                                    className: 'large-hide small-hide tablet-hide',
                                    floated: 'right',
                                    compact: true,
                                    size: 'mini',
                                    color: 'green',
                                    onClick: function onClick(e) {
                                      e.preventDefault();
                                      _this9.handleOpenModal(unitdata.id, data.id, data.remarkInternal, 'Approve', 'checkmark', _react2.default.createElement(
                                        'span',
                                        null,
                                        'Approve Booking?',
                                        _react2.default.createElement('br', null),
                                        ' ',
                                        unitdata.reference,
                                        ', ',
                                        unitdata.project.shortName
                                      ), _react2.default.createElement(
                                        'span',
                                        null,
                                        'Approve ',
                                        data.bookingCustomer.name,
                                        '\'s ',
                                        'reservation (',
                                        data.code,
                                        ').',
                                        unitdata.projectUnitBookingSummary && unitdata.projectUnitBookingSummary.reservedCount > 1 && _react2.default.createElement('br', null),
                                        unitdata.projectUnitBookingSummary && unitdata.projectUnitBookingSummary.reservedCount > 1 && 'All other reservations for this unit  will be set to unsuccessful reservation.'
                                      ), 'approve');
                                    }
                                  },
                                  'Approve'
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  {
                                    className: 'large-hide small-hide tablet-hide',
                                    floated: 'right',
                                    compact: true,
                                    size: 'mini',
                                    icon: true,
                                    onClick: function onClick() {
                                      return _this9.handleOpenPaymentModal(data.id, unitdata.id);
                                    }
                                  },
                                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'pencil' })
                                ),
                                _react2.default.createElement(
                                  _reactRouter.Link,
                                  { to: '/bookings/' + data.id + '/' },
                                  unitdata.reference,
                                  ', ',
                                  _react2.default.createElement('br', { className: 'large-hide' }),
                                  unitdata.project.shortName,
                                  ', ',
                                  _react2.default.createElement('br', null),
                                  _react2.default.createElement(
                                    'small',
                                    null,
                                    data.code
                                  )
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { className: 'mobile-hide' },
                                _react2.default.createElement(
                                  'span',
                                  { className: 'mobile-hide' },
                                  _react2.default.createElement(
                                    _reactRouter.Link,
                                    { to: '/bookings/' + data.id + '/' },
                                    data.bookingCustomer.name
                                  )
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { collapsing: true, className: 'mobile-hide', textAlign: 'right' },
                                _react2.default.createElement(
                                  'div',
                                  { className: 'mobile-hide' },
                                  _react2.default.createElement(
                                    'small',
                                    null,
                                    data.paymentStatus.name
                                  ),
                                  _react2.default.createElement('br', null),
                                  _react2.default.createElement(_LoanAmount2.default, {
                                    format: '0,000,000.00',
                                    amount: (0, _amount.spaFullNumber)(data) || data.spaValue,
                                    prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                                  })
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { collapsing: true, textAlign: 'right' },
                                _react2.default.createElement(
                                  'span',
                                  { style: { float: 'left' }, className: 'large-hide small-hide tablet-hide' },
                                  _react2.default.createElement(
                                    _reactRouter.Link,
                                    { to: '/bookings/' + data.id + '/' },
                                    data.bookingCustomer.name
                                  )
                                ),
                                _react2.default.createElement(
                                  'small',
                                  { className: 'large-hide small-hide tablet-hide' },
                                  _react2.default.createElement(
                                    'i',
                                    null,
                                    data.assignedMaPreferredName ? 'Assigned: ' + data.assignedMaPreferredName : _react2.default.createElement(
                                      'span',
                                      null,
                                      '\xA0'
                                    )
                                  )
                                ),
                                _react2.default.createElement(
                                  'span',
                                  { className: 'mobile-hide', style: { float: 'left' } },
                                  _react2.default.createElement(
                                    'small',
                                    null,
                                    data.assignedMaPreferredName ? data.assignedMaPreferredName : _react2.default.createElement(
                                      _semanticUiReact.Button,
                                      {
                                        className: 'mobile-hide',
                                        size: 'mini',
                                        disabled: data.approve || data.decline,
                                        onClick: function onClick() {
                                          return _this9.handleOpenPaymentModal(data.id, unitdata.id);
                                        }
                                      },
                                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'add user' }),
                                      ' Assign'
                                    )
                                  )
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { collapsing: true, textAlign: 'right' },
                                _react2.default.createElement(
                                  'small',
                                  null,
                                  _react2.default.createElement(
                                    'span',
                                    { style: { float: 'left' }, className: 'large-hide small-hide tablet-hide' },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      'SPA: '
                                    ),
                                    _react2.default.createElement(_LoanAmount2.default, {
                                      format: '0,000,000.00',
                                      amount: (0, _amount.spaFullNumber)(data) || data.spaValue,
                                      prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                                    }),
                                    ' (',
                                    data.paymentStatus.name,
                                    ')'
                                  )
                                ),
                                _react2.default.createElement(
                                  'i',
                                  null,
                                  _react2.default.createElement(
                                    'small',
                                    null,
                                    _react2.default.createElement(
                                      'span',
                                      null,
                                      'by '
                                    ),
                                    _this9.hasStaffAccess() ? _react2.default.createElement(
                                      _reactRouter.Link,
                                      { to: '/users/' + data.maUserAffiliateID + '/' },
                                      data.maCreatedByPreferredName
                                    ) : data.maCreatedByPreferredName,
                                    _react2.default.createElement(
                                      'span',
                                      { className: 'large-hide small-hide tablet-hide' },
                                      ','
                                    ),
                                    _react2.default.createElement('br', { className: 'mobile-hide' }),
                                    _react2.default.createElement(_Timestamp2.default, {
                                      timestamp: data.createdAt,
                                      precise: true
                                    })
                                  )
                                )
                              ),
                              data.approve || data.decline ? _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                {
                                  collapsing: true,
                                  className: 'mobile-hide',
                                  textAlign: 'center'
                                },
                                data.approve ? _react2.default.createElement(
                                  'span',
                                  null,
                                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'check' }),
                                  ' Approved'
                                ) : '',
                                data.decline ? _react2.default.createElement(
                                  'span',
                                  null,
                                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'cancel' }),
                                  ' Cancelled'
                                ) : ''
                              ) : _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { collapsing: true, className: 'mobile-hide' },
                                _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  {
                                    className: 'mobile-hide',
                                    size: 'mini',
                                    icon: true,
                                    onClick: function onClick() {
                                      return _this9.handleOpenPaymentModal(data.id, unitdata.id);
                                    }
                                  },
                                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'pencil' })
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  {
                                    className: 'mobile-hide',
                                    size: 'mini',
                                    color: 'green',
                                    onClick: function onClick(e) {
                                      e.preventDefault();
                                      _this9.handleOpenModal(unitdata.id, data.id, data.remarkInternal, 'Approve', 'checkmark', _react2.default.createElement(
                                        'span',
                                        null,
                                        'Approve Booking?',
                                        _react2.default.createElement('br', null),
                                        ' ',
                                        unitdata.reference,
                                        ', ',
                                        unitdata.project.shortName
                                      ), _react2.default.createElement(
                                        'span',
                                        null,
                                        'Approve ',
                                        data.bookingCustomer.name,
                                        '\'s ',
                                        'reservation (',
                                        data.code,
                                        ').',
                                        unitdata.projectUnitBookingSummary && unitdata.projectUnitBookingSummary.reservedCount > 1 && _react2.default.createElement('br', null),
                                        unitdata.projectUnitBookingSummary && unitdata.projectUnitBookingSummary.reservedCount > 1 && 'All other reservations for this unit  will be set to unsuccessful reservation.'
                                      ), 'approve');
                                    }
                                  },
                                  'Approve'
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  {
                                    className: 'mobile-hide',
                                    size: 'mini',
                                    negative: true,
                                    onClick: function onClick(e) {
                                      e.preventDefault();
                                      _this9.handleOpenModal(unitdata.id, data.id, data.remarkInternal, 'Decline', 'remove', _react2.default.createElement(
                                        'span',
                                        null,
                                        'Decline Reservation?',
                                        _react2.default.createElement('br', null),
                                        ' ',
                                        unitdata.reference,
                                        ', ',
                                        unitdata.project.shortName
                                      ), _react2.default.createElement(
                                        'span',
                                        null,
                                        data.bookingCustomer.name,
                                        '\'s ',
                                        'reservation (',
                                        data.code,
                                        ') will be cancelled.'
                                      ), 'decline');
                                    }
                                  },
                                  'Decline'
                                )
                              )
                            );
                          }) : null;
                        })
                      )
                    )
                  )
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Item,
                      { style: {} },
                      _react2.default.createElement(
                        _semanticUiReact.Item.Content,
                        null,
                        !this.state.loading ? _react2.default.createElement(
                          _semanticUiReact.Segment,
                          { textAlign: 'center' },
                          _react2.default.createElement(
                            'p',
                            null,
                            'No pending bookings found.'
                          )
                        ) : ''
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              _react2.default.createElement(_PageNav2.default, {
                currentPage: this.state.currentPage,
                count: this.state.count,
                limit: this.state.limit,
                offset: this.state.offset,
                dataSize: this.state.data.length,
                loading: this.state.loading,
                onChange: this.handleChangePage
              })
            )
          )
        )
      );
    }
  }]);

  return ManageOld;
}(_react.Component);

ManageOld.contextTypes = {
  store: _propTypes2.default.object
};
ManageOld.propTypes = {
  appConfig: _propTypes2.default.shape({}),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool
  })
};

ManageOld.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

ManageOld.getPropsToState = function (props) {
  var token = '';
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var advanceFilter = false;
  var projectFilter = (0, _isbase2.default)(query.projectFilter) && _qs2.default.parse(atob(query.projectFilter)).name || '';
  var modal = {
    isOpen: false,
    header: '',
    headerIcon: 'warning sign',
    message: '',
    actionButtonText: 'Yes',
    unitID: '',
    bookingID: '',
    notes: '',
    isCancelPending: true
  };
  var paymentModal = {
    isOpen: false,
    bookingID: '',
    unitID: ''
  };
  return {
    token: token,
    modal: modal,
    paymentModal: paymentModal,
    currentPage: currentPage,
    search: search,
    advanceFilter: advanceFilter,
    projectFilter: projectFilter,
    loadingSearch: false,
    findProjectResults: [],
    noResultsMessage: 'Loading...'
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this10 = this;

  this.getSelectedStaffValue = function () {
    var bookingPaymentData = _this10.state.bookingPaymentData;

    var selectedStaffValue = {
      key: bookingPaymentData.assignedMaUserID.toString() || 0,
      title: bookingPaymentData.assignedMaName || '',
      price: bookingPaymentData.assignedMaPreferredName || ''
    };
    return selectedStaffValue;
  };

  this.setRefreshDataTimeout = function () {
    if (_this10.timeoutRefresh) {
      clearTimeout(_this10.timeoutRefresh);
    }
    _this10.timeoutRefresh = setTimeout(function () {
      _this10.handleRefreshData();
      _this10.setRefreshDataTimeout();
    }, 30000); // 30 seconds auto refresh time
  };

  this.isChequeDuplicated = function (data) {
    var bookingFeePayments = data.bookingFeePayments;

    return Array.isArray(bookingFeePayments) && bookingFeePayments.length > 0 && bookingFeePayments.some(function (bfp) {
      return bfp.isChequeDuplicate && ['cancelled', 'deduction'].every(function (s) {
        return bfp.status !== s;
      });
    });
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this10.props.location.search);
    query.page = currentPage;
    _this10.setState({
      currentPage: currentPage
    });
    _this10.pushQuery(query);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this10.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this10.replaceQuery(query, true);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this10.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    _this10.setState({
      search: ''
    }, function () {
      if (hasQuery) {
        _this10.replaceQuery(query, true);
      }
    });
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this10.props.location.search);
    query[queryName] = value;
    _this10.replaceQuery(query, true);
  };

  this.handleSetAdvanceFilter = function (advanceFilter) {
    _this10.setState({
      advanceFilter: advanceFilter
    });
  };

  this.handleCloseModal = function () {
    var modal = Object.assign({}, _this10.state.modal);
    modal.isOpen = false;
    modal.notes = '';
    _this10.setState({ modal: modal });
  };

  this.handleOpenModal = function (unitID, bookingID, notes, actionButtonText, headerIcon, header, message, type) {
    var modal = Object.assign({}, _this10.state.modal);
    modal.unitID = unitID;
    modal.bookingID = bookingID;
    modal.notes = notes;
    modal.isOpen = true;
    modal.header = header;
    modal.message = message;
    modal.headerIcon = headerIcon;
    modal.actionButtonText = actionButtonText;
    modal.isCancelPending = false;
    if (type === 'approve') {
      modal.type = 'approve';
      _this10.setState({ modal: modal });
    } else if (type === 'decline') {
      modal.isCancelPending = true;
      modal.type = 'decline';
      _this10.setState({ modal: modal });
    }
  };

  this.handleConfirm = function () {
    var modal = Object.assign({}, _this10.state.modal);
    if (modal.notes === '') {
      var store = _this10.context.store;

      store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', message: 'Notes required' }));
      return;
    }
    modal.isOpen = false;
    var statusID = void 0;
    var isCancelPending = false;
    if (modal.type === 'approve') {
      statusID = 'booked';
    }
    if (modal.type === 'decline') {
      statusID = 'cancelled_developer';
      if (modal.isCancelPending) {
        isCancelPending = true;
      }
    }
    var bookingData = {
      statusID: statusID,
      remarkInternal: modal.notes,
      isCancelPending: isCancelPending
    };
    _this10.setState({ modal: modal }, function () {
      _this10.putBoooking(bookingData, modal.unitID, modal.bookingID, modal.type, true);
    });
  };

  this.handleSearchProject = function (value) {
    clearTimeout(_this10.setTimer);
    // always reset results to null before finding
    var findProjectResults = [];
    var noResultsMessage = 'Loading...';
    _this10.setState({ findProjectResults: findProjectResults, noResultsMessage: noResultsMessage, projectFilter: value }, function () {
      if (value !== '') {
        _this10.setTimer = setTimeout(function () {
          _this10.searchProjects(value);
        }, 500);
      }
    });
  };

  this.handleSelectProject = function (project, queryName) {
    var query = (0, _url.decodeSearch)(_this10.props.location.search);
    var internalQuery = {};
    internalQuery.id = project.key;
    internalQuery.name = project.title;
    query[queryName] = btoa(_qs2.default.stringify(internalQuery));
    _this10.replaceQuery(query, true);
  };

  this.handleRefreshData = function () {
    var store = _this10.context.store;

    var query = (0, _url.decodeSearch)(_this10.props.location.search);
    query.page = 1;
    _this10.fetchProjectUnitBookings(query);
    store.dispatch((0, _reactRouterRedux.replace)('/bookings/manage/?' + (0, _url.encodeSearch)(query)));
  };

  this.handleAutoReload = function () {
    var autoReload = !_this10.state.autoReload;
    _this10.setState({ autoReload: autoReload }, function () {
      (0, _storage.setItem)(_config2.default.get('appName') + '.bookingManageAutoReload', autoReload ? 'true' : 'false');
      // if autoReload is disabled when there is an ongoing timeout then..
      // ..clear the timeout also.
      if (autoReload) {
        _this10.handleRefreshData();
        _this10.setRefreshDataTimeout();
      } else {
        if (_this10.timeout) {
          clearTimeout(_this10.timeout);
        }
        if (_this10.timeoutRefresh) {
          clearTimeout(_this10.timeoutRefresh);
        }
      }
    });
  };

  this.handleOpenPaymentModal = function (bookingID, unitID) {
    var paymentModal = {
      isOpen: true,
      bookingID: bookingID,
      unitID: unitID
    };
    _this10.setState({ paymentModal: paymentModal }, function () {
      _this10.fetchBookingPayment(bookingID);
    });
    if (_this10.timeoutRefresh) {
      clearTimeout(_this10.timeoutRefresh);
    }
  };

  this.handleSavePaymentModal = function () {
    var _state4 = _this10.state,
        bookingPaymentData = _state4.bookingPaymentData,
        paymentModal = _state4.paymentModal;

    _this10.updateBookingPayment(bookingPaymentData, paymentModal.bookingID);
  };

  this.handleClosePaymentModal = function () {
    var bookingPaymentData = '';
    var paymentModal = {
      isOpen: false,
      bookingID: '',
      unitID: ''
    };
    _this10.setState({ paymentModal: paymentModal, bookingPaymentData: bookingPaymentData, isDuplicate: false }, function () {
      if (_this10.state.autoReload) {
        _this10.setRefreshDataTimeout();
      }
    });
  };

  this.handlePaymentChange = function (event, value) {
    var bookingPaymentData = _this10.state.bookingPaymentData;

    bookingPaymentData[value.name] = value.value;
    _this10.setState({ bookingPaymentData: bookingPaymentData });
  };

  this.handlePaymentAmountChange = function (event, value) {
    if ((0, _isNumber.isNumeric)(value.value) || value.value === '') {
      var bookingPaymentData = _this10.state.bookingPaymentData;

      bookingPaymentData[value.name] = value.value;
      _this10.setState({ bookingPaymentData: bookingPaymentData });
    }
  };

  this.handleStaffClear = function () {
    var bookingPaymentData = _this10.state.bookingPaymentData;

    bookingPaymentData.assignedMaName = '';
    bookingPaymentData.assignedMaPreferredName = '';
    bookingPaymentData.assignedMaUserID = 0;
    _this10.setState({ bookingPaymentData: bookingPaymentData });
  };

  this.handleStaffSelect = function (value) {
    var bookingPaymentData = _this10.state.bookingPaymentData;

    bookingPaymentData.assignedMaName = value.title;
    bookingPaymentData.assignedMaPreferredName = value.price;
    bookingPaymentData.assignedMaUserID = value.key;
    _this10.setState({ bookingPaymentData: bookingPaymentData });
  };

  this.handleNotesChange = function (event, _ref7) {
    var value = _ref7.value;
    var modal = _this10.state.modal;

    modal.notes = value;
    _this10.setState({ modal: modal });
  };

  this.handleCheckboxChange = function (event, _ref8) {
    var checked = _ref8.checked;
    var modal = _this10.state.modal;

    modal.isCancelPending = checked;
    _this10.setState({ modal: modal });
  };

  this.handleCheckBeforeClose = function () {
    if (_this10.form.state.uploads.length > 0) {
      var callback = function callback() {
        _this10.uploadModal.close();
      };
      var store = _this10.context.store;

      store.dispatch((0, _prompt.promptChangesMessage)({ message: _promptMessages.UPLOAD_PICTURE_PROMPT, callback: callback }));
      return true;
    }
    return false;
  };

  this.handleCloseLarge = function (e) {
    e.preventDefault();
    _this10.setState({
      showLarge: false,
      selectedPicture: null,
      slideshow: false
    });
  };

  this.handleViewLargeSlide = function (e, data) {
    e.preventDefault();
    _this10.setState({
      selectedPicture: data,
      showLarge: true,
      slideshow: true
    });
  };

  this.handleSlidePicture = function (e) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
    var _state5 = _this10.state,
        bookingPaymentData = _state5.bookingPaymentData,
        selectedPicture = _state5.selectedPicture;

    var index = bookingPaymentData.paymentPictures.indexOf(selectedPicture);
    var nextIndex = direction === 'left' ? index - 1 : index + 1;
    _this10.setState({
      selectedPicture: bookingPaymentData.paymentPictures[nextIndex]
    });
  };

  this.sortItems = [{
    text: 'Oldest Reserved Unit',
    icon: 'sort alphabet ascending',
    sortColumn: 'project_unit.latest_reserved_at',
    sortDirection: 'asc'
  }, {
    text: 'Latest Reserved Unit',
    icon: 'sort alphabet descending',
    sortColumn: 'project_unit.latest_reserved_at',
    sortDirection: 'desc'
  }];

  this.generateRowStyle = function (array) {
    var newArray = array;
    var i = 1;
    var hasMultiple = i !== array.length;
    array.forEach(function (booking, idx) {
      if (!hasMultiple && i === array.length) newArray[idx].className = 'start end';
      if (hasMultiple && i === array.length - (array.length - 1)) newArray[idx].className = 'start';
      if (hasMultiple && i === array.length) newArray[idx].className = 'end';
      i += 1;
    });
    return newArray;
  };
};

exports.default = (0, _reactRedux.connect)(ManageOld.mapStateToProps)(ManageOld);

/***/ }),
/* 2267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _translation = __webpack_require__(4);

var _Form = __webpack_require__(2259);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var New = function (_Component) {
  _inherits(New, _Component);

  function New() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, New);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = New.__proto__ || Object.getPrototypeOf(New)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    }, _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments[1];

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges, callback);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(New, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('New')
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this2.form = _ref2;
          },
          onSubmit: function onSubmit(validations, project) {
            _this2.submit(validations, project);
          },
          onChange: this.handleOnCheck,
          registerLeaveGuard: this.props.registerLeaveGuard,
          location: this.props.location,
          loading: this.props.loading,
          token: this.props.token
        })
      );
    }
  }]);

  return New;
}(_react.Component);

New.propTypes = {
  token: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    hash: _propTypes2.default.string
  }),
  loading: _propTypes2.default.bool,
  onCheck: _propTypes2.default.func,
  registerLeaveGuard: _propTypes2.default.func
};
New.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.constants)(New);

/***/ }),
/* 2268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _BookingTitle = __webpack_require__(260);

var _BookingTitle2 = _interopRequireDefault(_BookingTitle);

var _url = __webpack_require__(19);

var _booking = __webpack_require__(129);

var _booking2 = _interopRequireDefault(_booking);

var _BuyerBooking = __webpack_require__(2289);

var _BuyerBooking2 = _interopRequireDefault(_BuyerBooking);

var _bookingStatuses = __webpack_require__(128);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */


// components

// structs


_momentTimezone2.default.locale('en-gb');

var Buyer = function (_Component) {
  _inherits(Buyer, _Component);

  function Buyer(props) {
    _classCallCheck(this, Buyer);

    var _this = _possibleConstructorReturn(this, (Buyer.__proto__ || Object.getPrototypeOf(Buyer)).call(this, props));

    _initialiseProps.call(_this);

    var state = Buyer.getPropsToState(props);
    _this.state = _extends({}, state, {
      bookingStatusModal: false,
      bbfLoading: false
    });
    _this.validation = {};
    _this.loanBox = null;
    return _this;
  }

  _createClass(Buyer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var state = Buyer.getPropsToState(nextProps);
      // don't allow state to override data if oriData is same
      if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
        state.data = this.state.data;
      }
      this.setState(_extends({}, state), function () {
        var store = _this2.context.store;
        var data = _this2.state.data;

        if (data && data.id && !data.buyerProfileID && (!data.project.linkBuyerApp || _bookingStatuses.CANCELLED_BOOKING_STATUSES.some(function (s) {
          return data.statusID === s.value;
        }))) {
          var query = (0, _url.decodeSearch)(_this2.props.location.search);
          query.section = 'info';
          store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + data.id + '/?' + (0, _url.encodeSearch)(query)));
        }
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var isMobile = this.props.isMobile;
      var _state = this.state,
          data = _state.data,
          loading = _state.loading;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        { className: 'no_margin' },
        _react2.default.createElement(_BookingTitle2.default, { isMobile: isMobile, data: data }),
        _react2.default.createElement(_BuyerBooking2.default, {
          token: this.props.token,
          bookingID: data.id,
          setLoading: this.setLoading,
          loading: loading,
          location: this.props.location,
          booking: data,
          isMobile: isMobile
        })
      );
    }
  }]);

  return Buyer;
}(_react.Component);

Buyer.contextTypes = {
  store: _propTypes2.default.object
};
Buyer.propTypes = {
  token: _propTypes2.default.string,
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    creditCheckAccess: _propTypes2.default.bool,
    allowEditUnitPrice: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  onCheck: _propTypes2.default.func,
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      noeticIsEnabled: _propTypes2.default.bool,
      lawyerIsEnabled: _propTypes2.default.bool
    })
  }),
  fetchNewBooking: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }).isRequired
};

Buyer.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

Buyer.getPropsToState = function (props) {
  var loading = props.loading;
  var data = Object.assign({}, _booking2.default, props.data);
  if (!data.bankCases) {
    data.bankCases = [];
  }
  return {
    data: data,
    oriData: (0, _clone2.default)(data),
    loading: loading
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this4.setState({ loading: loading }, res);
    });
  };
};

exports.default = (0, _reactRedux.connect)(Buyer.mapStateToProps)(Buyer);

/***/ }),
/* 2269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _BookingTitle = __webpack_require__(260);

var _BookingTitle2 = _interopRequireDefault(_BookingTitle);

var _booking = __webpack_require__(129);

var _booking2 = _interopRequireDefault(_booking);

var _SecureDocumentsSharing = __webpack_require__(2505);

var _SecureDocumentsSharing2 = _interopRequireDefault(_SecureDocumentsSharing);

var _fetchM = __webpack_require__(6);

var _apiEndpoints = __webpack_require__(140);

var endpoints = _interopRequireWildcard(_apiEndpoints);

var _flash = __webpack_require__(5);

var _lawyerCaseStatuses = __webpack_require__(142);

var _translation = __webpack_require__(4);

var _countries = __webpack_require__(60);

var _Document = __webpack_require__(1058);

var _Document2 = _interopRequireDefault(_Document);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _bookingCurrentIdentityDocuments = __webpack_require__(2275);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Documents = function (_Component) {
  _inherits(Documents, _Component);

  // CPI-1249: one predicate for the whole file; elsewhere the SecureDocuments widget is untouched.
  function Documents(props) {
    _classCallCheck(this, Documents);

    var _this = _possibleConstructorReturn(this, (Documents.__proto__ || Object.getPrototypeOf(Documents)).call(this, props));

    _initialiseProps.call(_this);

    var state = Documents.getPropsToState(props);
    _this.state = _extends({}, state, {
      loading: false,
      loaded: false,
      cases: {
        SPA: [],
        LA: []
      },
      activeCase: {
        SPA: null,
        LA: null
      },
      nextToken: {
        SPA: null,
        LA: null
      },
      lawyerLoading: {
        SPA: null,
        LA: null
      },
      lawyersIDList: [],
      lawyersList: [],
      assignedLawyers: [],
      assignedLawyerCasesID: [],
      // CPI-1249 / CPI-976: the wet-sign uploader is kept, collapsed, below the table.
      showWetSignUpload: false,
      currentIdentities: {},
      currentIdentityLoading: Documents.isVietnam(props) && !!state.data.purchasersIsolated
    });
    _this.currentIdentityLoad = 0;
    _this.mounted = false;
    return _this;
  }

  _createClass(Documents, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      if (Documents.isVietnam(this.props)) this.fetchCurrentIdentities(this.state.data);
      if (!Documents.isVietnam(this.props)) {
        this.fetchAllLawyerCasesDetails();
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var state = Documents.getPropsToState(nextProps);
      // don't allow state to override data if oriData is same
      var isOriDataSame = JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData);
      if (isOriDataSame) {
        state.data = this.state.data;
      }
      if (!isOriDataSame && Documents.isVietnam(nextProps)) {
        state.currentIdentities = {};
        state.currentIdentityLoading = !!state.data.purchasersIsolated;
      }
      this.setState(_extends({}, state), function () {
        if (!isOriDataSame && Documents.isVietnam(nextProps)) {
          _this2.fetchCurrentIdentities(_this2.state.data);
        }
        if (!isOriDataSame && !Documents.isVietnam(nextProps)) {
          _this2.fetchAllLawyerCasesDetails();
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      this.currentIdentityLoad += 1;
    }
  }, {
    key: "getLawyers",
    value: function getLawyers() {
      var _state = this.state,
          activeCase = _state.activeCase,
          lawyersList = _state.lawyersList;

      var activeLawyers = [];
      var activeCasesIDs = [];
      if (activeCase && lawyersList && lawyersList.length > 0) {
        activeLawyers = lawyersList.reduce(function (result, lawyer) {
          if (!lawyer) {
            return result;
          }
          if (activeCase.SPA && activeCase.SPA.lawyer_id === lawyer.id) {
            result.push({
              value: lawyer.id,
              label: lawyer.name,
              caption: 'SPA Lawyer'
            });
          }
          if (activeCase.LA && activeCase.LA.lawyer_id === lawyer.id) {
            result.push({
              value: lawyer.id,
              label: lawyer.name,
              caption: 'LA Lawyer'
            });
          }
          return result;
        }, []);
      }

      activeCase && activeCase.SPA ? activeCasesIDs.push(activeCase.SPA.id) : '';
      activeCase && activeCase.LA ? activeCasesIDs.push(activeCase.LA.id) : '';

      this.setState({ assignedLawyers: activeLawyers, assignedLawyerCasesID: activeCasesIDs });
    }
  }, {
    key: "fetchLawyer",
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var lawyerID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var store, t, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (lawyerID) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", null);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.LAWYER(lawyerID), null, 'get', {
                  'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
                }));

              case 8:
                res = _context.sent;
                return _context.abrupt("return", res);

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                return _context.abrupt("return", null);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 12]]);
      }));

      function fetchLawyer() {
        return _ref.apply(this, arguments);
      }

      return fetchLawyer;
    }()
  }, {
    key: "renderVietnam",


    // CPI-1249: Vietnam's Documents tab is the shared-media table with CPI-976's wet-sign uploader
    // kept below it - the only place a `signed_sales_form_wet` document can be produced.
    value: function renderVietnam() {
      var _state2 = this.state,
          data = _state2.data,
          showWetSignUpload = _state2.showWetSignUpload,
          assignedBankers = _state2.assignedBankers,
          assignedBankCasesCode = _state2.assignedBankCasesCode,
          assignedLawyers = _state2.assignedLawyers,
          assignedLawyerCasesID = _state2.assignedLawyerCasesID,
          currentIdentities = _state2.currentIdentities,
          currentIdentityLoading = _state2.currentIdentityLoading;
      var _props = this.props,
          t = _props.t,
          auth = _props.auth,
          location = _props.location,
          loading = _props.loading,
          documentData = _props.documentData,
          fetchDocument = _props.fetchDocument,
          parentType = _props.parentType,
          parentID = _props.parentID,
          token = _props.token,
          opportunity = _props.opportunity;

      var currentIdentityMode = (0, _bookingCurrentIdentityDocuments.bookingUsesCurrentIdentityDocuments)(data);
      var currentIdentityDocuments = (0, _bookingCurrentIdentityDocuments.getCurrentBookingIdentityDocuments)(data, currentIdentities, currentIdentityLoading, _config2.default.get('bookApiURL'));
      return _react2.default.createElement(
        _semanticUiReact.Container,
        { className: "no_margin" },
        _react2.default.createElement(_BookingTitle2.default, { isMobile: this.props.isMobile, data: data }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: "centered" },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { attached: true },
                _react2.default.createElement(_Document2.default, {
                  auth: auth,
                  location: location,
                  loading: loading,
                  documentData: documentData,
                  fetchDocument: fetchDocument,
                  parentType: parentType,
                  parentID: parentID,
                  id: parentID,
                  mediaToken: token,
                  opportunity: opportunity,
                  currentIdentityMode: currentIdentityMode,
                  currentIdentityDocuments: currentIdentityDocuments,
                  currentIdentityBookingID: data.id
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  basic: true,
                  fluid: true,
                  onClick: this.handleToggleWetSignUpload,
                  "aria-expanded": showWetSignUpload
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: showWetSignUpload ? 'chevron up' : 'chevron down' }),
                t('Signed Sales Form (Wet Sign)', { ns: _translation.TRANSLATION_FILES.screens })
              ),
              showWetSignUpload && data && _react2.default.createElement(
                _semanticUiReact.Segment,
                { attached: true },
                _react2.default.createElement(_SecureDocumentsSharing2.default, {
                  bookingID: data.id,
                  assignedBankers: assignedBankers,
                  assignedBankCasesCode: assignedBankCasesCode,
                  assignedLawyers: assignedLawyers,
                  assignedLawyerCasesID: assignedLawyerCasesID,
                  loanTrackerLeadCode: data.loanTrackerLeadCode,
                  isVietnam: true
                })
              )
            )
          )
        )
      );
    }
  }, {
    key: "render",
    value: function render() {
      var _state3 = this.state,
          assignedBankers = _state3.assignedBankers,
          assignedBankCasesCode = _state3.assignedBankCasesCode,
          assignedLawyers = _state3.assignedLawyers,
          assignedLawyerCasesID = _state3.assignedLawyerCasesID,
          data = _state3.data;
      var _props2 = this.props,
          t = _props2.t,
          auth = _props2.auth;

      if (Documents.isVietnam(this.props)) {
        return this.renderVietnam();
      }
      return _react2.default.createElement(
        _semanticUiReact.Container,
        { className: "no_margin" },
        _react2.default.createElement(_BookingTitle2.default, { isMobile: this.props.isMobile, data: data }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: "centered" },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Header,
                {
                  className: "new_title",
                  as: "h5",
                  textAlign: "center",
                  attached: "top"
                },
                t('Document Sharing').toUpperCase()
              ),
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { attached: true },
                data && _react2.default.createElement(_SecureDocumentsSharing2.default, {
                  bookingID: data.id,
                  assignedBankers: assignedBankers,
                  assignedBankCasesCode: assignedBankCasesCode,
                  assignedLawyers: assignedLawyers,
                  assignedLawyerCasesID: assignedLawyerCasesID,
                  loanTrackerLeadCode: data.loanTrackerLeadCode,
                  isVietnam: (0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode)
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Documents;
}(_react.Component);

Documents.contextTypes = {
  store: _propTypes2.default.object
};
Documents.propTypes = {
  token: _propTypes2.default.string,
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    creditCheckAccess: _propTypes2.default.bool,
    allowEditUnitPrice: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  onCheck: _propTypes2.default.func,
  // CPI-1249: the Vietnam branch renders the shared-media table, fed by Bookings.jsx.
  documentData: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  fetchDocument: _propTypes2.default.func,
  parentType: _propTypes2.default.string,
  parentID: _propTypes2.default.string,
  opportunity: _propTypes2.default.object,
  loading: _propTypes2.default.bool,
  t: _propTypes2.default.func,
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      noeticIsEnabled: _propTypes2.default.bool,
      lawyerIsEnabled: _propTypes2.default.bool
    })
  }),
  fetchNewBooking: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }).isRequired
};

Documents.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

Documents.isVietnam = function (props) {
  return (0, _countries.isCountryVietnam)(props && props.auth && props.auth.company && props.auth.company.countryCode);
};

Documents.getPropsToState = function (props) {
  var data = Object.assign({}, _booking2.default, props.data);
  data.isCancelPending = true;

  var activeBankCodes = [];
  var activeBankers = [];
  if (!Documents.isVietnam(props) && data && data.bankCases && data.bankCases.length > 0) {
    for (var i = 0; i < data.bankCases.length; i += 1) {
      var bankCase = data.bankCases[i];
      if (bankCase.status.startsWith('new') || bankCase.status.startsWith('pending') || bankCase.status.startsWith('approved') || bankCase.status.startsWith('success')) {
        activeBankCodes = activeBankCodes.concat(bankCase.code);
        if (bankCase.banker && bankCase.banker.user && bankCase.banker.user.awsUsername !== '' && bankCase.bank) {
          activeBankers = activeBankers.concat({
            value: bankCase.banker.user.awsUsername,
            label: bankCase.banker.preferredName || bankCase.banker.name,
            caption: bankCase.bank.name || 'Banker'
          });
        }
      }
    }
  }

  return {
    data: data,
    oriData: (0, _clone2.default)(data),
    assignedBankers: activeBankers,
    assignedBankCasesCode: activeBankCodes
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.setComponentState = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new Promise(function (res) {
      return _this3.setState(state, function () {
        return res(state);
      });
    });
  };

  this.setCases = function (type) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var token = arguments[2];
    var loadMore = arguments[3];
    return new Promise(function (res) {
      var _state4 = _this3.state,
          cases = _state4.cases,
          activeCase = _state4.activeCase,
          nextToken = _state4.nextToken,
          lawyersIDList = _state4.lawyersIDList;

      var newData = data || [];
      newData.forEach(function (_data) {
        var isExist = lawyersIDList.find(function (id) {
          return id === _data.lawyer_id;
        });
        if (!isExist) {
          lawyersIDList.push(_data.lawyer_id);
        }
      });
      var newCases = loadMore ? activeCase[type].concat(newData) : newData;
      var currentCase = newCases.find(function (d) {
        return d.status !== _lawyerCaseStatuses.DEVELOPER_CANCELLED;
      });
      if (!activeCase) {
        currentCase = _this3.state.activeCase[type];
      }
      cases[type] = newCases;
      activeCase[type] = currentCase;
      nextToken[type] = token;
      _this3.setState({ cases: cases, activeCase: activeCase, nextToken: nextToken, lawyersIDList: lawyersIDList }, function () {
        return res(newCases);
      });
    });
  };

  this.setLoading = function () {
    var newLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var type = arguments[1];
    return new Promise(function (res) {
      var lawyerLoading = _this3.state.lawyerLoading;

      if (type != null) {
        lawyerLoading[type] = newLoading;
      } else {
        lawyerLoading.SPA = newLoading;
        lawyerLoading.LA = newLoading;
      }
      _this3.setState({ lawyerLoading: lawyerLoading }, function () {
        return res(newLoading);
      });
    });
  };

  this.fetchCurrentIdentities = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(booking) {
      var load, store, customers, options, entries, currentIdentities;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              load = _this3.currentIdentityLoad + 1;

              _this3.currentIdentityLoad = load;
              store = _this3.context.store;
              customers = booking && booking.purchasersIsolated && booking.id ? booking.bookingCustomers || [] : [];

              if (!(customers.length === 0)) {
                _context3.next = 7;
                break;
              }

              if (_this3.mounted && load === _this3.currentIdentityLoad) {
                _this3.setState({ currentIdentities: {}, currentIdentityLoading: false });
              }
              return _context3.abrupt("return");

            case 7:

              _this3.setState({ currentIdentities: {}, currentIdentityLoading: true });
              options = { credentials: 'include', method: 'GET', ignoreNotFound: true, ignoreForbidden: true };
              _context3.next = 11;
              return Promise.all(customers.map(function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(bookingCustomer) {
                  var customerID, res;
                  return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          customerID = bookingCustomer && bookingCustomer.customerID;

                          if (customerID) {
                            _context2.next = 3;
                            break;
                          }

                          return _context2.abrupt("return", null);

                        case 3:
                          _context2.prev = 3;
                          _context2.next = 6;
                          return store.dispatch((0, _fetchM.fetchM)("/bookings/" + booking.id + "/customers/" + customerID + "/crm_identity/?metadata=1", options));

                        case 6:
                          res = _context2.sent;

                          if (!(!res || !res.ok)) {
                            _context2.next = 9;
                            break;
                          }

                          return _context2.abrupt("return", [customerID, { status: 'error' }]);

                        case 9:
                          _context2.t0 = customerID;
                          _context2.next = 12;
                          return res.json();

                        case 12:
                          _context2.t1 = _context2.sent;
                          return _context2.abrupt("return", [_context2.t0, _context2.t1]);

                        case 16:
                          _context2.prev = 16;
                          _context2.t2 = _context2["catch"](3);
                          return _context2.abrupt("return", [customerID, { status: 'error' }]);

                        case 19:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this3, [[3, 16]]);
                }));

                return function (_x6) {
                  return _ref3.apply(this, arguments);
                };
              }()));

            case 11:
              entries = _context3.sent;

              if (!(!_this3.mounted || load !== _this3.currentIdentityLoad || String(_this3.state.data.id) !== String(booking.id))) {
                _context3.next = 14;
                break;
              }

              return _context3.abrupt("return");

            case 14:
              currentIdentities = entries.filter(Boolean).reduce(function (result, entry) {
                result[entry[0]] = entry[1];
                return result;
              }, {});

              _this3.setState({ currentIdentities: currentIdentities, currentIdentityLoading: false });

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, _this3);
    }));

    return function (_x5) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.fetchAllLawyerCasesDetails = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    var _state5, data, lawyersIDList, promiseArr, promiseArrLawyer, promiseResultArray;

    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _state5 = _this3.state, data = _state5.data, lawyersIDList = _state5.lawyersIDList;

            if (!(data && data.id)) {
              _context4.next = 12;
              break;
            }

            promiseArr = [_this3.fetchLawyerCases('SPA', null, data.id), _this3.fetchLawyerCases('LA', null, data.id)];

            if (!(promiseArr.length > 0)) {
              _context4.next = 12;
              break;
            }

            _context4.next = 6;
            return Promise.all(promiseArr);

          case 6:
            promiseArrLawyer = [];

            lawyersIDList.forEach(function (id) {
              promiseArrLawyer.push(_this3.fetchLawyer(id));
            });
            _context4.next = 10;
            return Promise.all(promiseArrLawyer);

          case 10:
            promiseResultArray = _context4.sent;

            _this3.setState({ lawyersList: promiseResultArray }, _this3.getLawyers);

          case 12:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, _this3);
  }));

  this.fetchLawyerCases = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(type, nextToken) {
      var bookingID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this3.state.data.bookingID;
      var activeCase, store, t, query, res;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this3.setLoading(true, type);

            case 2:
              if (nextToken) {
                _context5.next = 7;
                break;
              }

              activeCase = _this3.state.activeCase;

              activeCase[type] = null;
              _context5.next = 7;
              return _this3.setComponentState({ activeCase: activeCase });

            case 7:
              store = _this3.context.store;
              t = _this3.props.t;
              query = {
                limit: 10,
                type: type
              };

              if (nextToken) {
                query.next_token = nextToken;
              }
              res = void 0;
              _context5.prev = 12;
              _context5.next = 15;
              return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.BOOKING_CASES(bookingID) + "/?" + _qs2.default.stringify(query), null, 'get', {
                'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
              }));

            case 15:
              res = _context5.sent;
              _context5.next = 26;
              break;

            case 18:
              _context5.prev = 18;
              _context5.t0 = _context5["catch"](12);

              Bugsnag.notifyException(_context5.t0);
              _context5.next = 23;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

            case 23:
              _context5.next = 25;
              return _this3.setLoading(false, type);

            case 25:
              return _context5.abrupt("return");

            case 26:
              if (!res) {
                _context5.next = 29;
                break;
              }

              _context5.next = 29;
              return _this3.setCases(type, res.items, res.next_token, !!nextToken);

            case 29:
              _context5.next = 31;
              return _this3.setLoading(false, type);

            case 31:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, _this3, [[12, 18]]);
    }));

    return function (_x7, _x8) {
      return _ref5.apply(this, arguments);
    };
  }();

  this.handleToggleWetSignUpload = function (e) {
    if (e && e.preventDefault) e.preventDefault();
    _this3.setState(function (prevState) {
      return { showWetSignUpload: !prevState.showWetSignUpload };
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Documents.mapStateToProps)(Documents));

/***/ }),
/* 2270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(13);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _webValidations = __webpack_require__(23);

var _securedocumentsSdkJs = __webpack_require__(885);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _cancellationReasons = __webpack_require__(991);

var _secureDocumentsClient = __webpack_require__(2080);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _BookingAttachment = __webpack_require__(2090);

var _BookingAttachment2 = _interopRequireDefault(_BookingAttachment);

var _BookingPricingPackage = __webpack_require__(2102);

var _BookingPricingPackage2 = _interopRequireDefault(_BookingPricingPackage);

var _BookingFeePackage = __webpack_require__(2092);

var _BookingFeePackage2 = _interopRequireDefault(_BookingFeePackage);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _EditableBox = __webpack_require__(153);

var _EditableBox2 = _interopRequireDefault(_EditableBox);

var _ESigningModal = __webpack_require__(571);

var _ESigningModal2 = _interopRequireDefault(_ESigningModal);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _MarkdownText = __webpack_require__(193);

var _MarkdownText2 = _interopRequireDefault(_MarkdownText);

var _SearchStaff = __webpack_require__(388);

var _SearchStaff2 = _interopRequireDefault(_SearchStaff);

var _SpecificationTable = __webpack_require__(127);

var _SpecificationTable2 = _interopRequireDefault(_SpecificationTable);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _CalendarDatePicker = __webpack_require__(1010);

var _CalendarDatePicker2 = _interopRequireDefault(_CalendarDatePicker);

var _EditPackageModal = __webpack_require__(2134);

var _EditPackageModal2 = _interopRequireDefault(_EditPackageModal);

var _PackagingPricingModal = __webpack_require__(2165);

var _PackagingPricingModal2 = _interopRequireDefault(_PackagingPricingModal);

var _CustomiseFormulaModal = __webpack_require__(2126);

var _CustomiseFormulaModal2 = _interopRequireDefault(_CustomiseFormulaModal);

var _CustomFieldForm = __webpack_require__(1015);

var _CustomFieldForm2 = _interopRequireDefault(_CustomFieldForm);

var _EditFeePackageModal = __webpack_require__(2133);

var _EditFeePackageModal2 = _interopRequireDefault(_EditFeePackageModal);

var _CustomiseFeePackageFormulaModal = __webpack_require__(2125);

var _CustomiseFeePackageFormulaModal2 = _interopRequireDefault(_CustomiseFeePackageFormulaModal);

var _HimsErrorLog = __webpack_require__(1022);

var _HimsErrorLog2 = _interopRequireDefault(_HimsErrorLog);

var _BookingNote = __webpack_require__(313);

var _BookingNote2 = _interopRequireDefault(_BookingNote);

var _bookingStatuses = __webpack_require__(128);

var _bookingStatuses2 = _interopRequireDefault(_bookingStatuses);

var _noeticStatuses = __webpack_require__(2227);

var _noeticStatuses2 = _interopRequireDefault(_noeticStatuses);

var _ifcaStatuses = __webpack_require__(2224);

var _ifcaStatuses2 = _interopRequireDefault(_ifcaStatuses);

var _insoftStatuses = __webpack_require__(2225);

var _insoftStatuses2 = _interopRequireDefault(_insoftStatuses);

var _firstTimeBuyer = __webpack_require__(1043);

var _firstTimeBuyer2 = _interopRequireDefault(_firstTimeBuyer);

var _jdeStatuses = __webpack_require__(2226);

var _jdeStatuses2 = _interopRequireDefault(_jdeStatuses);

var _srpLoan = __webpack_require__(2231);

var _srpLoan2 = _interopRequireDefault(_srpLoan);

var _defaultBookingFields = __webpack_require__(391);

var _translation = __webpack_require__(4);

var _srRoleAccess = __webpack_require__(196);

var _BookingPayment = __webpack_require__(1051);

var _BookingPayment2 = _interopRequireDefault(_BookingPayment);

var _BookingStatusNotes = __webpack_require__(398);

var _BookingStatusNotes2 = _interopRequireDefault(_BookingStatusNotes);

var _BookingChangeUnit = __webpack_require__(2511);

var _BookingChangeUnit2 = _interopRequireDefault(_BookingChangeUnit);

var _TinInvalidModal = __webpack_require__(2531);

var _TinInvalidModal2 = _interopRequireDefault(_TinInvalidModal);

var _DateTimeForm = __webpack_require__(2515);

var _DateTimeForm2 = _interopRequireDefault(_DateTimeForm);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _ModalNotice = __webpack_require__(588);

var _ModalNotice2 = _interopRequireDefault(_ModalNotice);

var _booking = __webpack_require__(129);

var _booking2 = _interopRequireDefault(_booking);

var _amount = __webpack_require__(87);

var _isNumber = __webpack_require__(30);

var _translation2 = __webpack_require__(64);

var _storage = __webpack_require__(44);

var _changeUnitsAccesses = __webpack_require__(1041);

var _strings = __webpack_require__(118);

var _price = __webpack_require__(2583);

var _countries = __webpack_require__(60);

var _vietnam = __webpack_require__(40);

var _preSalesLaunch = __webpack_require__(269);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-confusing-arrow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/sort-comp */
/* eslint-disable array-callback-return */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */

// actions


// components

// constants

// containers

// modals

// structs

// utils


_momentTimezone2.default.locale('en-gb');
var isPRS = _config2.default.get('prs');
var inputDateFormat = 'DD/MM/YYYY';

var RenderDivider = function RenderDivider() {
  return _react2.default.createElement(_semanticUiReact.Divider, { className: 'compact' });
};
var RenderHiddenDivider = function RenderHiddenDivider() {
  return _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, className: 'compact' });
};

var Info = function (_Component) {
  _inherits(Info, _Component);

  function Info(props) {
    _classCallCheck(this, Info);

    var _this = _possibleConstructorReturn(this, (Info.__proto__ || Object.getPrototypeOf(Info)).call(this, props));

    _initialiseProps.call(_this);

    var state = Info.getPropsToState(props);
    var cancellationReasons = props.cancellationReasons ? [].concat(props.cancellationReasons.data) : [];
    _this.state = _extends({}, state, {
      cancellationReasons: cancellationReasons,
      bookingChanges: false,
      isBookingPaymentChanged: false,
      isBookingFeePaymentChanged: false,
      editingBooking: false,
      editingPayment: false,
      bookingStatusModal: false,
      showLarge: false,
      selectedPicture: null,
      slideshow: false,
      showCustomFields: false,
      showSignModal: false,
      showDateTimeModal: false,
      showEditPackageModal: false,
      showCustomiseFormulaModal: false,
      bookingCustomFields: [],
      searchUsersData: [],
      searchUserValue: '',
      isSalesPersonSignature: false,
      documentToken: null,
      uploadModalState: false,
      mpUserLoading: false,
      mpUserDetails: {},
      approvedDatePickerVisible: false,
      cancelledDatePickerVisible: false,
      soldDatePickVisible: false,
      spaSigningDatePickerVisible: false,
      spaStampingDatePickerVisible: false,
      minCancelledDate: null,
      minSoldDate: null,
      validationSvcErrorModalOpen: false,
      validationSvcErrorModalContent: '',
      externalSvcErrorModalOpen: false,
      apieSvcErrorModalOpen: false,
      botSvcErrorModalOpen: false,
      botResyncModalOpen: false,
      himsSvcErrorModalOpen: false,
      showChangeUnit: false,
      loadingProject: false,
      projectOpts: [],
      changeUnitID: '',
      loadingUnit: false,
      unitOpts: [],
      bookingChangeUnitModal: false,
      bookingNotesModuleExpand: false,
      tinInvalidModal: false,
      newBookingStatus: '',
      isUnitChange: false,
      pendingChangeUnitData: null
    });
    _this.validation = {
      spaAmount: (0, _react.createRef)(),
      nettSellingPrice: (0, _react.createRef)(),
      tierPricingName: (0, _react.createRef)(),
      tierPricingDescription: (0, _react.createRef)()
    };
    _this.customFieldValidation = {};
    _this.customFieldFormRef = (0, _react.createRef)();
    _this.loanBox = null;
    _this.refBookingNote = null;
    return _this;
  }

  _createClass(Info, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;

      store.dispatch((0, _cancellationReasons.fetchCancellationReasons)(false));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var state = Info.getPropsToState(nextProps);

      var cancellationReasons = nextProps.cancellationReasons ? [].concat(nextProps.cancellationReasons.data) : this.state.cancellationReasons;
      // don't allow state to override data if oriData is same
      if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
        state.data = this.state.data;
        state.changeProjectID = this.state.changeProjectID;
      }
      if (state.data.bookingCustomFields) {
        // setup existing custom fields values in data state
        state.data.bookingCustomFields.forEach(function (d) {
          state.data[_this2.bcfPRefix(d.projectBookingCustomField.name)] = d.value;
          state.data[_this2.bcfPRefix(d.projectBookingCustomField.name) + 'ID'] = d.id;
          if (d.projectBookingCustomField.type === 'dropdown' || d.projectBookingCustomField.type === 'dropdown_multi') {
            state.data[_this2.bcfPRefix(d.projectBookingCustomField.name) + 'OptionID'] = d.projectBookingCustomFieldOptionID;
            state.data[_this2.bcfPRefix(d.projectBookingCustomField.name) + 'OptionIDs'] = d.projectBookingCustomFieldOptionIDs;
          } else {
            state.data[_this2.bcfPRefix(d.projectBookingCustomField.name) + 'OptionID'] = '';
            state.data[_this2.bcfPRefix(d.projectBookingCustomField.name) + 'OptionIDs'] = [];
          }
        });
      }
      if (state.projectBookingCustomFields) {
        // setup new custom fields blank values in data state
        state.projectBookingCustomFields.forEach(function (d) {
          if (!state.data[_this2.bcfPRefix(d.name)]) {
            if (!state.data[_this2.bcfPRefix(d.name) + 'ID']) {
              state.data[_this2.bcfPRefix(d.name)] = d.defaultValue;
            }
            if (d.type === 'dropdown' || d.type === 'dropdown_multi') {
              state.data[_this2.bcfPRefix(d.name) + 'OptionID'] = '';
              state.data[_this2.bcfPRefix(d.name) + 'OptionIDs'] = [];
            }
          }
        });
      }
      // force close booking status modal and editing form
      if (nextProps.refreshPage) {
        state.bookingStatusModal = false;
        state.editingBooking = false;
        state.isUnitChange = false;
      }

      this.setState(_extends({}, state, { cancellationReasons: cancellationReasons }));
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
    // need to bind this to allow LoanTracker to setLoading

  }, {
    key: 'setMPUserLoading',
    value: function setMPUserLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ mpUserLoading: loading }, function () {
          res(loading);
        });
      });
    }
    // CPI-974 (S18): statuses the project blocks until the booking-fee payment is approved.

    // CPI-977 (PO, 14 Sep): on a Vietnamese Sales Overview the Payment section is the CRM
    // opportunity's payment screen (VNPayment.jsx), not the Showroom deposit rail; the deposit to
    // collect and the approved-fee rows that used to sit above the rail are gone (PO, 9 Sep).
    // Malaysia keeps BookingPayment untouched.

    // CPI-976: the project may require the sales form signed before Booked. UX guard only.

    // Signature evidence: Vietnam is wet-sign only; other countries also accept primary purchaser e-sign.

  }, {
    key: 'getDocumentToken',
    value: function getDocumentToken(callback) {
      var _this5 = this;

      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.state.data.id + '/attachments/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      }).then(function (res) {
        var documentToken = res.headers.get('X-Csrf-Token');
        _this5.setState({
          documentToken: documentToken
        }, function () {
          if (callback) {
            callback();
          }
        });
      });
    }
  }, {
    key: 'resyncBotApi',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, t, res, botErrorHeader, message, botBookingUpdatesData, newData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setBotSyncing(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.state.data.id + '/resync_bot/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 25;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);
                _context.next = 15;
                return this.setBotSyncing(false);

              case 15:
                botErrorHeader = 'Re-sync failed';

                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 22;
                  break;
                }

                _context.next = 19;
                return _context.t0.res.text();

              case 19:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ header: botErrorHeader, message: 'Bot re-sync failed. ' + message }));
                return _context.abrupt('return');

              case 22:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ header: botErrorHeader, message: t('An error occurred. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context.abrupt('return');

              case 25:
                _context.next = 27;
                return res.json();

              case 27:
                botBookingUpdatesData = _context.sent;
                newData = _extends({}, this.state.data);

                newData.botServiceID = botBookingUpdatesData.id;
                newData.botServiceStatus = botBookingUpdatesData.statusID;
                newData.botServiceUpdatedAt = botBookingUpdatesData.updatedAt;
                newData.botServiceErrors = botBookingUpdatesData.errorLogs;
                this.setState({
                  data: newData,
                  oriData: newData
                });
                _context.next = 36;
                return this.setBotSyncing(false);

              case 36:
                store.dispatch((0, _flash.flashSuccessMessage)({ message: 'Bot re-sync successfully triggered' }));

              case 37:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function resyncBotApi() {
        return _ref.apply(this, arguments);
      }

      return resyncBotApi;
    }()
  }, {
    key: 'resendFRHBooking',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var xid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.data.id;
        var store, t, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                _context2.prev = 4;
                _context2.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + xid + '/frh_resend/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 7:
                _context2.next = 22;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](4);
                _context2.next = 13;
                return this.setLoading(false);

              case 13:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 16;
                return _context2.t0.res.text();

              case 16:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 19:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context2.abrupt('return');

              case 22:
                _context2.next = 24;
                return this.setLoading(false);

              case 24:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Resend Success', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 25:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 9]]);
      }));

      function resendFRHBooking() {
        return _ref2.apply(this, arguments);
      }

      return resendFRHBooking;
    }()
  }, {
    key: 'resendJDEBooking',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var xid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.data.id;
        var store, t, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                _context3.prev = 4;
                _context3.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + xid + '/jde_resend/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 7:
                _context3.next = 22;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](4);
                _context3.next = 13;
                return this.setLoading(false);

              case 13:
                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 19;
                  break;
                }

                _context3.next = 16;
                return _context3.t0.res.text();

              case 16:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 19:
                Bugsnag.notifyException(_context3.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context3.abrupt('return');

              case 22:
                _context3.next = 24;
                return this.setLoading(false);

              case 24:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Resend Success', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 25:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 9]]);
      }));

      function resendJDEBooking() {
        return _ref3.apply(this, arguments);
      }

      return resendJDEBooking;
    }()
  }, {
    key: 'resendBooking',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var xid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.data.id;
        var store, t, message;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                _context4.prev = 4;
                _context4.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + xid + '/es_resend/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 7:
                _context4.next = 22;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](4);
                _context4.next = 13;
                return this.setLoading(false);

              case 13:
                if (!(_context4.t0.res && _context4.t0.res.status >= 400 && _context4.t0.res.status < 500)) {
                  _context4.next = 19;
                  break;
                }

                _context4.next = 16;
                return _context4.t0.res.text();

              case 16:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context4.abrupt('return');

              case 19:
                Bugsnag.notifyException(_context4.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context4.abrupt('return');

              case 22:
                _context4.next = 24;
                return this.setLoading(false);

              case 24:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Resend Success', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 25:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 9]]);
      }));

      function resendBooking() {
        return _ref4.apply(this, arguments);
      }

      return resendBooking;
    }()
  }, {
    key: 'deleteAttachment',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(fileID) {
        var store, data, t, message;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                store = this.context.store;
                data = this.state.data;
                t = this.props.t;
                _context5.next = 5;
                return this.setLoading(true);

              case 5:
                _context5.prev = 5;
                _context5.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + data.id + '/attachments/' + fileID + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'X-Csrf-Token': this.state.documentToken
                  }
                }));

              case 8:
                _context5.next = 22;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](5);
                _context5.next = 14;
                return this.setLoading(false);

              case 14:
                Bugsnag.notifyException(_context5.t0);

                if (!(_context5.t0.res.status >= 400 && _context5.t0.res.status < 500)) {
                  _context5.next = 21;
                  break;
                }

                _context5.next = 18;
                return _context5.t0.res.text();

              case 18:
                message = _context5.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context5.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context5.t0));

              case 22:
                _context5.next = 24;
                return this.props.fetchNewBooking();

              case 24:
                _context5.next = 26;
                return this.setLoading(false);

              case 26:
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Attachment(s) successfully deleted', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 27:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[5, 10]]);
      }));

      function deleteAttachment(_x6) {
        return _ref5.apply(this, arguments);
      }

      return deleteAttachment;
    }()
  }, {
    key: 'updateBooking',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(booking) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'update';
        var xid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.state.data.id;
        var store, t, b, customFieldValidation, validations, errMessages, res, message, data;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                b = booking;

                if (!(type === 'update')) {
                  _context6.next = 18;
                  break;
                }

                // read the custom field refs from CustomFieldForm directly — the
                // onChange-passed copy is empty until the user edits a custom field,
                // which let required fields through untouched
                customFieldValidation = this.customFieldFormRef.current && this.customFieldFormRef.current.validation || this.customFieldValidation;
                _context6.next = 9;
                return _AppForm2.default.validate(_extends({}, this.validation, customFieldValidation), this.state.data);

              case 9:
                validations = _context6.sent;
                errMessages = validations.filter(function (v) {
                  return !v.isValid;
                });
                _context6.next = 13;
                return this.setComponentState({
                  errMessages: errMessages
                });

              case 13:
                if (!(errMessages.length > 0)) {
                  _context6.next = 18;
                  break;
                }

                _context6.next = 16;
                return this.setLoading(false);

              case 16:
                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errMessages.map(function (l) {
                    return l.message;
                  }) }));
                return _context6.abrupt('return');

              case 18:
                if (b.statusID === 'reserved' || b.statusID === 'booked') {
                  b.isCancelPending = false;
                  b.isUserCooldown = false;
                }
                res = '';
                _context6.prev = 20;
                _context6.next = 23;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + xid + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(b)
                }));

              case 23:
                res = _context6.sent;
                _context6.next = 39;
                break;

              case 26:
                _context6.prev = 26;
                _context6.t0 = _context6['catch'](20);
                _context6.next = 30;
                return this.setLoading(false);

              case 30:
                if (!(_context6.t0.res && _context6.t0.res.status >= 400 && _context6.t0.res.status < 500)) {
                  _context6.next = 36;
                  break;
                }

                _context6.next = 33;
                return _context6.t0.res.text();

              case 33:
                message = _context6.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context6.abrupt('return');

              case 36:
                Bugsnag.notifyException(_context6.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context6.abrupt('return');

              case 39:
                _context6.next = 41;
                return res.json();

              case 41:
                data = _context6.sent;

                if (!(data.statusID === 'booked' && data.project && data.project.autoShareFormToBanker && data.bankCases && data.bankCases.length > 0 && data.pdfLastSentAt === null)) {
                  _context6.next = 51;
                  break;
                }

                _context6.prev = 43;
                _context6.next = 46;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + xid + '/print_banker/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 46:
                _context6.next = 51;
                break;

              case 48:
                _context6.prev = 48;
                _context6.t1 = _context6['catch'](43);

                Bugsnag.notifyException(_context6.t1);

              case 51:
                _context6.next = 53;
                return this.setLoading(false);

              case 53:
                _context6.next = 55;
                return this.setComponentState({
                  editingPayment: type === 'payment' ? false : this.state.editingPayment,
                  editingBooking: type !== 'payment' ? false : this.state.editingBooking
                });

              case 55:
                if (type === 'primary') {
                  store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + this.state.data.id + '/'));
                  store.dispatch((0, _flash.flashSuccessMessage)({
                    header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                    message: t('Primary purchaser has been successfully updated.', { ns: _translation.TRANSLATION_FILES.translation })
                  }));
                } else {
                  this.handleResetCheck(type === 'payment' ? 'paymentChanges' : 'bookingChanges');
                  store.dispatch((0, _reactRouterRedux.push)('/bookings/' + xid + '/'));
                  store.dispatch((0, _flash.flashSuccessMessage)({
                    header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                    message: t('Booking {{code}} successfully updated', { code: data.code, ns: _translation.TRANSLATION_FILES.translation })
                  }));
                  this.callRefreshBookingNote();
                }

              case 56:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[20, 26], [43, 48]]);
      }));

      function updateBooking(_x7) {
        return _ref6.apply(this, arguments);
      }

      return updateBooking;
    }()
  }, {
    key: 'updateBookingPP',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(selectedPackagePricingItem) {
        var store, oriData, t, newData, res, message, json;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                oriData = this.state.oriData;
                t = this.props.t;
                newData = Object.assign({}, oriData || {});
                res = '';
                _context7.prev = 7;
                _context7.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + oriData.id + '/package_pricing/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(selectedPackagePricingItem)
                }));

              case 10:
                res = _context7.sent;
                _context7.next = 26;
                break;

              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7['catch'](7);
                _context7.next = 17;
                return this.setLoading(false);

              case 17:
                if (!(_context7.t0.res && _context7.t0.res.status >= 400 && _context7.t0.res.status < 500)) {
                  _context7.next = 23;
                  break;
                }

                _context7.next = 20;
                return _context7.t0.res.text();

              case 20:
                message = _context7.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context7.abrupt('return');

              case 23:
                Bugsnag.notifyException(_context7.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context7.abrupt('return');

              case 26:
                _context7.next = 28;
                return res.json();

              case 28:
                json = _context7.sent;

                newData.packagePricing = json.packagePricing;
                newData.packagePricingID = json.packagePricingID;
                newData.spaDecimal = json.spaDecimal;
                newData.spaValue = json.spaValue;
                newData.spaTimes = json.spaTimes;
                newData.spaFull = json.spaFull;
                newData.spaAmount = (0, _amount.spaFullNumber)(newData) || newData.spaValue;
                this.setState({
                  data: newData,
                  oriData: newData
                });
                _context7.next = 39;
                return this.setLoading(false);

              case 39:
                store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + this.state.data.id + '/'));
                _context7.next = 42;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Pricing Package'),
                  message: t('Pricing package successfully updated', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 42:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[7, 13]]);
      }));

      function updateBookingPP(_x10) {
        return _ref7.apply(this, arguments);
      }

      return updateBookingPP;
    }()
  }, {
    key: 'updateBookingPPFormulas',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(calcs) {
        var store, oriData, t, newData, res, newCalcs, message, json;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                oriData = this.state.oriData;
                t = this.props.t;
                newData = Object.assign({}, oriData || {});
                res = '';
                newCalcs = calcs.map(function (c) {
                  return _extends({}, c, {
                    formulaValue: c.formulaValue.toString()
                  });
                });
                _context8.prev = 8;
                _context8.next = 11;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + oriData.id + '/formulas/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(newCalcs)
                }));

              case 11:
                res = _context8.sent;
                _context8.next = 27;
                break;

              case 14:
                _context8.prev = 14;
                _context8.t0 = _context8['catch'](8);
                _context8.next = 18;
                return this.setLoading(false);

              case 18:
                if (!(_context8.t0.res && _context8.t0.res.status >= 400 && _context8.t0.res.status < 500)) {
                  _context8.next = 24;
                  break;
                }

                _context8.next = 21;
                return _context8.t0.res.text();

              case 21:
                message = _context8.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context8.abrupt('return');

              case 24:
                Bugsnag.notifyException(_context8.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context8.abrupt('return');

              case 27:
                _context8.next = 29;
                return res.json();

              case 29:
                json = _context8.sent;

                newData.packagePricing.calculations = json.packagePricing.calculations;
                newData.spaDecimal = json.spaDecimal;
                newData.spaValue = json.spaValue;
                newData.spaTimes = json.spaTimes;
                newData.spaFull = json.spaFull;
                newData.spaAmount = (0, _amount.spaFullNumber)(newData) || newData.spaValue;
                this.setState({
                  data: newData,
                  oriData: newData
                });
                _context8.next = 39;
                return this.setLoading(false);

              case 39:
                store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + this.state.data.id + '/'));
                _context8.next = 42;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Pricing Package'),
                  message: t('Pricing package successfully updated', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 42:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[8, 14]]);
      }));

      function updateBookingPPFormulas(_x11) {
        return _ref8.apply(this, arguments);
      }

      return updateBookingPPFormulas;
    }()
  }, {
    key: 'updateBookingFP',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(selectedFeePackage) {
        var store, oriData, newData, res, message, json;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                oriData = this.state.oriData;
                newData = Object.assign({}, oriData || {});
                res = '';
                _context9.prev = 6;
                _context9.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + oriData.id + '/fee_packages/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(selectedFeePackage)
                }));

              case 9:
                res = _context9.sent;
                _context9.next = 25;
                break;

              case 12:
                _context9.prev = 12;
                _context9.t0 = _context9['catch'](6);
                _context9.next = 16;
                return this.setLoading(false);

              case 16:
                if (!(_context9.t0.res && _context9.t0.res.status >= 400 && _context9.t0.res.status < 500)) {
                  _context9.next = 22;
                  break;
                }

                _context9.next = 19;
                return _context9.t0.res.text();

              case 19:
                message = _context9.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context9.abrupt('return');

              case 22:
                Bugsnag.notifyException(_context9.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context9.abrupt('return');

              case 25:
                _context9.next = 27;
                return res.json();

              case 27:
                json = _context9.sent;

                newData.packageFee = json.packageFee;
                newData.packageFeeID = json.packageFeeID;
                this.setState({
                  data: newData,
                  oriData: newData
                });
                _context9.next = 33;
                return this.setLoading(false);

              case 33:
                store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + this.state.data.id + '/'));
                _context9.next = 36;
                return store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Additonal Fee Package', message: 'Additonal fee package successfully updated' }));

              case 36:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[6, 12]]);
      }));

      function updateBookingFP(_x12) {
        return _ref9.apply(this, arguments);
      }

      return updateBookingFP;
    }()
  }, {
    key: 'updateBookingFPFormulas',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(calcs) {
        var store, oriData, newData, res, message, json;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                oriData = this.state.oriData;
                newData = Object.assign({}, oriData || {});
                res = '';
                _context10.prev = 6;
                _context10.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + oriData.id + '/fee_packages/formulas/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(calcs)
                }));

              case 9:
                res = _context10.sent;
                _context10.next = 25;
                break;

              case 12:
                _context10.prev = 12;
                _context10.t0 = _context10['catch'](6);
                _context10.next = 16;
                return this.setLoading(false);

              case 16:
                if (!(_context10.t0.res && _context10.t0.res.status >= 400 && _context10.t0.res.status < 500)) {
                  _context10.next = 22;
                  break;
                }

                _context10.next = 19;
                return _context10.t0.res.text();

              case 19:
                message = _context10.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context10.abrupt('return');

              case 22:
                Bugsnag.notifyException(_context10.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context10.abrupt('return');

              case 25:
                _context10.next = 27;
                return res.json();

              case 27:
                json = _context10.sent;

                newData.packageFee.items = json.packageFee.items;
                this.setState({
                  data: newData,
                  oriData: newData
                });
                _context10.next = 32;
                return this.setLoading(false);

              case 32:
                store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + this.state.data.id + '/'));
                _context10.next = 35;
                return store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Additional Fee Package', message: 'Additional fee package successfully updated' }));

              case 35:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[6, 12]]);
      }));

      function updateBookingFPFormulas(_x13) {
        return _ref10.apply(this, arguments);
      }

      return updateBookingFPFormulas;
    }()
  }, {
    key: 'updateSalesPersonSignature',
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(salesPersonSignature) {
        var store, oriData, t, newData, res, message, json;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                oriData = this.state.oriData;
                t = this.props.t;
                newData = Object.assign({}, oriData || {});

                newData.salesPersonSignature = salesPersonSignature;
                newData.isCancelPending = false;
                newData.isUserCooldown = false;
                newData = this.setPricePerSqm(newData);
                res = '';
                _context11.prev = 11;
                _context11.next = 14;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + oriData.id + '/signature/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(newData)
                }));

              case 14:
                res = _context11.sent;
                _context11.next = 30;
                break;

              case 17:
                _context11.prev = 17;
                _context11.t0 = _context11['catch'](11);
                _context11.next = 21;
                return this.setLoading(false);

              case 21:
                if (!(_context11.t0.res && _context11.t0.res.status >= 400 && _context11.t0.res.status < 500)) {
                  _context11.next = 27;
                  break;
                }

                _context11.next = 24;
                return _context11.t0.res.text();

              case 24:
                message = _context11.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context11.abrupt('return');

              case 27:
                Bugsnag.notifyException(_context11.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context11.abrupt('return');

              case 30:
                _context11.next = 32;
                return res.json();

              case 32:
                json = _context11.sent;

                newData.salesPersonSignAt = json.salesPersonSignAt;
                this.setState({
                  showSignModal: false,
                  isSalesPersonSignature: false,
                  data: newData
                });
                _context11.next = 37;
                return this.setLoading(false);

              case 37:
                _context11.next = 39;
                return this.signatureModal.handleOnCancel();

              case 39:
                _context11.next = 41;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Sign Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Sales Person {{name}} has signed', { name: oriData.maCreatedByPreferredName, ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 41:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this, [[11, 17]]);
      }));

      function updateSalesPersonSignature(_x14) {
        return _ref11.apply(this, arguments);
      }

      return updateSalesPersonSignature;
    }()
  }, {
    key: 'uploadAttachments',
    value: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(body) {
        var data, store, t, message;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                data = this.state.data;
                store = this.context.store;
                t = this.props.t;
                _context12.next = 5;
                return this.setLoading(true);

              case 5:
                _context12.prev = 5;
                _context12.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + data.id + '/attachments/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'X-Csrf-Token': this.state.documentToken
                  },
                  body: body
                }));

              case 8:
                _context12.next = 23;
                break;

              case 10:
                _context12.prev = 10;
                _context12.t0 = _context12['catch'](5);
                _context12.next = 14;
                return this.setLoading(false);

              case 14:
                Bugsnag.notifyException(_context12.t0);

                if (!(_context12.t0.res && _context12.t0.res.status >= 400 && _context12.t0.res.status < 500)) {
                  _context12.next = 21;
                  break;
                }

                _context12.next = 18;
                return _context12.t0.res.text();

              case 18:
                message = _context12.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context12.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context12.abrupt('return');

              case 23:
                _context12.next = 25;
                return this.props.fetchNewBooking();

              case 25:
                _context12.next = 27;
                return this.setLoading(false);

              case 27:
                this.setState({ uploadModalState: false });
                this.bookingAttachment.uploadModal.close();
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Upload Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Attachment(s) successfully uploaded', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 30:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this, [[5, 10]]);
      }));

      function uploadAttachments(_x15) {
        return _ref12.apply(this, arguments);
      }

      return uploadAttachments;
    }()
  }, {
    key: 'submitNoetic',
    value: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var xid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.data.id;
        var store, t, message;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                _context13.prev = 4;
                _context13.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + xid + '/noetic/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 7:
                _context13.next = 22;
                break;

              case 9:
                _context13.prev = 9;
                _context13.t0 = _context13['catch'](4);
                _context13.next = 13;
                return this.setLoading(false);

              case 13:
                if (!(_context13.t0.res && _context13.t0.res.status >= 400 && _context13.t0.res.status < 500)) {
                  _context13.next = 19;
                  break;
                }

                _context13.next = 16;
                return _context13.t0.res.text();

              case 16:
                message = _context13.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context13.abrupt('return');

              case 19:
                Bugsnag.notifyException(_context13.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context13.abrupt('return');

              case 22:
                _context13.next = 24;
                return this.setLoading(false);

              case 24:
                store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + this.state.data.id + '/'));
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Success', { ns: _translation.TRANSLATION_FILES.constants }),
                  message: t('Booking has been added to the {{name}} synchronizing queue', { name: 'noetic', ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 26:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this, [[4, 9]]);
      }));

      function submitNoetic() {
        return _ref13.apply(this, arguments);
      }

      return submitNoetic;
    }()
  }, {
    key: 'submitIFCA',
    value: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var xid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.data.id;
        var store, t, message;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                _context14.prev = 4;
                _context14.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + xid + '/ifca/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 7:
                _context14.next = 22;
                break;

              case 9:
                _context14.prev = 9;
                _context14.t0 = _context14['catch'](4);
                _context14.next = 13;
                return this.setLoading(false);

              case 13:
                if (!(_context14.t0.res && _context14.t0.res.status >= 400 && _context14.t0.res.status < 500)) {
                  _context14.next = 19;
                  break;
                }

                _context14.next = 16;
                return _context14.t0.res.text();

              case 16:
                message = _context14.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context14.abrupt('return');

              case 19:
                Bugsnag.notifyException(_context14.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context14.abrupt('return');

              case 22:
                _context14.next = 24;
                return this.setLoading(false);

              case 24:
                store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + this.state.data.id + '/'));
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Success', { ns: _translation.TRANSLATION_FILES.constants }),
                  message: t('Booking has been added to the {{name}} synchronizing queue', { name: 'IFCA', ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 26:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this, [[4, 9]]);
      }));

      function submitIFCA() {
        return _ref14.apply(this, arguments);
      }

      return submitIFCA;
    }()
  }, {
    key: 'submitInsoft',
    value: function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var xid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.data.id;
        var store, t, message;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                _context15.prev = 4;
                _context15.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + xid + '/insoft/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 7:
                _context15.next = 22;
                break;

              case 9:
                _context15.prev = 9;
                _context15.t0 = _context15['catch'](4);
                _context15.next = 13;
                return this.setLoading(false);

              case 13:
                if (!(_context15.t0.res && _context15.t0.res.status >= 400 && _context15.t0.res.status < 500)) {
                  _context15.next = 19;
                  break;
                }

                _context15.next = 16;
                return _context15.t0.res.text();

              case 16:
                message = _context15.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context15.abrupt('return');

              case 19:
                Bugsnag.notifyException(_context15.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context15.abrupt('return');

              case 22:
                _context15.next = 24;
                return this.setLoading(false);

              case 24:
                store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + this.state.data.id + '/'));
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Success', { ns: _translation.TRANSLATION_FILES.constants }),
                  message: t('Booking has been added to the {{name}} synchronizing queue', { name: 'Insoft', ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 26:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this, [[4, 9]]);
      }));

      function submitInsoft() {
        return _ref15.apply(this, arguments);
      }

      return submitInsoft;
    }()
  }, {
    key: 'fetchProjects',
    value: function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        var t, store, query, res, message, _message, data, projectOpts;

        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                _context16.next = 4;
                return this.setLoadingProject(true);

              case 4:
                query = {
                  limit: 0,
                  showAsOptions: true,
                  fromChangeUnit: true,
                  projectStatus: ['published']
                };
                res = void 0;
                _context16.prev = 6;
                _context16.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/projects/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context16.sent;
                _context16.next = 24;
                break;

              case 12:
                _context16.prev = 12;
                _context16.t0 = _context16['catch'](6);

                if (!(_context16.t0.res && _context16.t0.res.status >= 399 && _context16.t0.res.status < 500)) {
                  _context16.next = 19;
                  break;
                }

                _context16.next = 17;
                return _context16.t0.res.text();

              case 17:
                message = _context16.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 19:
                _context16.next = 21;
                return this.setLoadingProject(false);

              case 21:
                Bugsnag.notifyException(_context16.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context16.abrupt('return');

              case 24:
                if (res.ok) {
                  _context16.next = 32;
                  break;
                }

                _context16.next = 27;
                return res.text();

              case 27:
                _message = _context16.sent;
                _context16.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 30:
                _context16.next = 39;
                break;

              case 32:
                _context16.next = 34;
                return res.json();

              case 34:
                data = _context16.sent;
                projectOpts = this.state.projectOpts;

                if (data && data.length > 0) {
                  projectOpts = data.map(function (d) {
                    return { value: d.id, text: d.name };
                  });
                }

                _context16.next = 39;
                return this.setComponentState({ projectOpts: projectOpts });

              case 39:
                _context16.next = 41;
                return this.setLoadingProject(false);

              case 41:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this, [[6, 12]]);
      }));

      function fetchProjects() {
        return _ref16.apply(this, arguments);
      }

      return fetchProjects;
    }()
  }, {
    key: 'fetchUnits',
    value: function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        var t, oriData, store, query, res, message, _message2, data, unitOpts;

        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (this.state.changeProjectID) {
                  _context17.next = 2;
                  break;
                }

                return _context17.abrupt('return');

              case 2:
                t = this.props.t;
                oriData = this.state.oriData;
                store = this.context.store;
                _context17.next = 7;
                return this.setLoadingUnit(true);

              case 7:
                query = {
                  limit: 0,
                  showAsOptions: true,
                  unitStatus: 'new',
                  showDelist: this.checkAllowChangeUnit() && oriData.project.cuDelistOnHoldIsEnabled
                };
                res = void 0;
                _context17.prev = 9;
                _context17.next = 12;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.state.changeProjectID + '/units/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context17.sent;
                _context17.next = 27;
                break;

              case 15:
                _context17.prev = 15;
                _context17.t0 = _context17['catch'](9);

                if (!(_context17.t0.res && _context17.t0.res.status >= 399 && _context17.t0.res.status < 500)) {
                  _context17.next = 22;
                  break;
                }

                _context17.next = 20;
                return _context17.t0.res.text();

              case 20:
                message = _context17.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 22:
                _context17.next = 24;
                return this.setLoadingUnit(false);

              case 24:
                Bugsnag.notifyException(_context17.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context17.abrupt('return');

              case 27:
                if (res.ok) {
                  _context17.next = 35;
                  break;
                }

                _context17.next = 30;
                return res.text();

              case 30:
                _message2 = _context17.sent;
                _context17.next = 33;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message2 }));

              case 33:
                _context17.next = 42;
                break;

              case 35:
                _context17.next = 37;
                return res.json();

              case 37:
                data = _context17.sent;
                unitOpts = this.state.unitOpts;

                if (data && data.length > 0) {
                  unitOpts = data.map(function (d) {
                    return { value: d.id, text: d.reference + ' ' + (d.statusID === 'delist' ? '- ' + t('delisted') : '') + ' ' + (d.statusID === 'delist' && d.delistOnHold ? t('(on hold)') : '') };
                  });
                }

                _context17.next = 42;
                return this.setComponentState({ unitOpts: unitOpts });

              case 42:
                _context17.next = 44;
                return this.setLoadingUnit(false);

              case 44:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this, [[9, 15]]);
      }));

      function fetchUnits() {
        return _ref17.apply(this, arguments);
      }

      return fetchUnits;
    }()
  }, {
    key: 'fetchJDELogs',
    value: function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        var store, t, res, message, _message3, data;

        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context18.prev = 5;
                _context18.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.state.data.id + '/jde_logs/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context18.sent;
                _context18.next = 24;
                break;

              case 11:
                _context18.prev = 11;
                _context18.t0 = _context18['catch'](5);
                _context18.next = 15;
                return this.setLoading(false);

              case 15:
                if (!(_context18.t0.res && _context18.t0.res.status >= 400 && _context18.t0.res.status < 500)) {
                  _context18.next = 21;
                  break;
                }

                _context18.next = 18;
                return _context18.t0.res.text();

              case 18:
                message = _context18.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context18.abrupt('return');

              case 21:
                Bugsnag.notifyException(_context18.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context18.abrupt('return');

              case 24:
                if (res.ok) {
                  _context18.next = 34;
                  break;
                }

                _context18.next = 27;
                return this.setLoading(false);

              case 27:
                _context18.next = 29;
                return res.text();

              case 29:
                _message3 = _context18.sent;
                _context18.next = 32;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message3 }));

              case 32:
                _context18.next = 41;
                break;

              case 34:
                _context18.next = 36;
                return res.json();

              case 36:
                data = _context18.sent;
                _context18.next = 39;
                return this.setComponentState({
                  validationSvcErrorModalContent: data
                });

              case 39:
                _context18.next = 41;
                return this.setLoading(false);

              case 41:
              case 'end':
                return _context18.stop();
            }
          }
        }, _callee18, this, [[5, 11]]);
      }));

      function fetchJDELogs() {
        return _ref18.apply(this, arguments);
      }

      return fetchJDELogs;
    }()
  }, {
    key: 'submitChangeUnit',
    value: function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(value) {
        var attachmentsUploaded, attachmentsUploadedCount, _state, changeProjectID, changeUnitID, oriData, pendingChangeUnitData, data;

        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                attachmentsUploaded = value.attachmentsUploaded, attachmentsUploadedCount = value.attachmentsUploadedCount;
                _state = this.state, changeProjectID = _state.changeProjectID, changeUnitID = _state.changeUnitID, oriData = _state.oriData;

                if (!(!changeProjectID || !changeUnitID)) {
                  _context19.next = 4;
                  break;
                }

                return _context19.abrupt('return');

              case 4:

                // Store pending change unit data without calling API yet
                pendingChangeUnitData = {
                  projectID: changeProjectID,
                  projectUnitID: changeUnitID,
                  cuFollowPrevBookingDateIsEnabled: oriData.project.cuFollowPrevBookingDateIsEnabled && oriData.cuFollowPrevBookingDateIsEnabled,
                  attachmentsUploaded: attachmentsUploaded,
                  attachmentsUploadedCount: attachmentsUploadedCount
                };

                // Show cancellation modal immediately

                data = this.state.data;

                data.statusID = 'cancelled_developer';
                _context19.next = 9;
                return this.setComponentState({
                  data: data,
                  editingBooking: false,
                  bookingStatusModal: true,
                  isUnitChange: true,
                  pendingChangeUnitData: pendingChangeUnitData
                });

              case 9:
              case 'end':
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function submitChangeUnit(_x19) {
        return _ref19.apply(this, arguments);
      }

      return submitChangeUnit;
    }()
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var admin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var dhq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var dbl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var internal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      var auth = this.props.auth;
      if (dbl && this.props.auth.isBranchLeader) {
        return true;
      }
      if (dhq && this.props.auth.isHeadquarters) {
        return true;
      }
      if (admin && this.props.auth.isSuperAdmin) {
        return true;
      }
      if (internal && auth && auth.companyBranch && !auth.companyBranch.isExternal) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasAccessNettSellingPrice',
    value: function hasAccessNettSellingPrice(project) {
      var auth = this.props.auth;
      if (this.props.auth.isSuperAdmin || this.props.auth.isHeadquarters) {
        return true;
      }
      if (project && project.accessBULNettSellingPrice && this.props.auth.isBranchLeader) {
        return true;
      }
      if (project && project.accessStaffNettSellingPrice && auth && auth.companyBranch) {
        return true;
      }
      return false;
    }
    // CPI-1212: Source of Finance is read-only for a base external agent unless the project allows
    // it. Vietnam only; the rule itself is canEditSourceOfFinance in src/utils/vietnam.js.

  }, {
    key: 'showAgentCuButton',
    value: function showAgentCuButton(statusID) {
      var auth = this.props.auth;
      var data = this.state.data;

      if ((0, _vietnam.vnChangeUnitBlocked)(auth, data)) return false;
      // Pre-Sales Launch: change unit creates a new booking, so a role blocked from reserving is blocked here too.
      if ((0, _preSalesLaunch.reservationBlocked)(auth, data && data.project)) return false;
      if (auth.companyBranch.isExternal) {
        if (data.project.cuAllowExternalReserved && statusID === 'reserved' && !data.project.allowAgentManageBooking) {
          return true;
        }
        if (data.project.cuAllowExternalBooked && statusID === 'booked') {
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'hasEditBookingAccess',
    value: function hasEditBookingAccess(maUserID, statusID) {
      var auth = this.props.auth;
      var data = this.state.data;

      if (data.project.allowAgentManageBooking && auth.companyBranch.isExternal && statusID === 'reserved') {
        if (auth.isExternalAgentLeader) {
          return true;
        } else if (maUserID === auth.id) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: 'hasBookingNoteReadAccess',
    value: function hasBookingNoteReadAccess(project) {
      var user = this.props.auth;
      if (user.isAdminBasic || user.isAdmin) return true;
      if (project && project.bnReadAccessGroupIDs) {
        var uGroupIDs = [].concat(_toConsumableArray(user.groups.map(function (obj) {
          return obj.id;
        })));
        var uSrRoleIDs = (0, _srRoleAccess.matchGroupIDToSrRoleID)(uGroupIDs, user.companyBranch.isExternal);
        return (0, _srRoleAccess.hasAnyRequiredRoleIDs)(project.bnReadAccessGroupIDs, uSrRoleIDs);
      }
      return false;
    }
  }, {
    key: 'hasBookingNoteWriteAccess',
    value: function hasBookingNoteWriteAccess(project) {
      var user = this.props.auth;
      if (user.isAdminBasic || user.isAdmin) return true;
      if (project && project.bnWriteAccessGroupIDs) {
        var uGroupIDs = [].concat(_toConsumableArray(user.groups.map(function (obj) {
          return obj.id;
        })));
        var uSrRoleIDs = (0, _srRoleAccess.matchGroupIDToSrRoleID)(uGroupIDs, user.companyBranch.isExternal);
        return (0, _srRoleAccess.hasAnyRequiredRoleIDs)(project.bnWriteAccessGroupIDs, uSrRoleIDs);
      }
      return false;
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'checkDisabled',
    value: function checkDisabled() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';
      var _state2 = this.state,
          data = _state2.data,
          selectedPicture = _state2.selectedPicture;

      if (data.paymentPictures.length > 0 && selectedPicture) {
        var index = data.paymentPictures.indexOf(selectedPicture);
        if (direction === 'left') {
          return index - 1 >= 0;
        }
        return index + 1 < data.paymentPictures.length;
      }
      return false;
    }
  }, {
    key: 'showNoetic',
    value: function showNoetic() {
      if (this.props.appConfig.data.noeticIsEnabled) {
        return true;
      }
      return false;
    }
  }, {
    key: 'showIFCA',
    value: function showIFCA() {
      if (this.props.appConfig.data.ifcaIsEnabled) {
        return true;
      }
      return false;
    }
  }, {
    key: 'showInsoft',
    value: function showInsoft() {
      if (this.props.appConfig.data.insoftIsEnabled) {
        return true;
      }
      return false;
    }
  }, {
    key: 'showRagic',
    value: function showRagic() {
      if (this.props.appConfig.data.ragicIsEnabled) {
        return true;
      }
      return false;
    }
  }, {
    key: 'showExternalService',
    value: function showExternalService() {
      if (this.props.appConfig.data.externalServiceIsEnabled) {
        return true;
      }
      return false;
    }
  }, {
    key: 'showAPIEService',
    value: function showAPIEService() {
      if (this.props.appConfig.data.apieServiceIsEnabled) {
        return true;
      }
      return false;
    }
  }, {
    key: 'showBotService',
    value: function showBotService() {
      var oriData = this.state.oriData;

      return oriData && oriData.project && oriData.project.isBotEnabled;
    }
  }, {
    key: 'renderCustomFields',
    value: function renderCustomFields(isEditing) {
      var minItems = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var offsetFrom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var _state3 = this.state,
          data = _state3.data,
          projectBookingCustomFields = _state3.projectBookingCustomFields;
      var auth = this.props.auth;
      // combine both fields from booking and project to order them together

      var combineCustomFields = [];
      if (data && data.bookingCustomFields) {
        data.bookingCustomFields.map(function (d) {
          var newD = d.projectBookingCustomField;
          newD.projectBookingCustomFieldOptions = d.projectBookingCustomFieldOptions;
          combineCustomFields.push(d.projectBookingCustomField);
        });
      }
      if (projectBookingCustomFields) projectBookingCustomFields.map(function (d) {
        return combineCustomFields.push(d);
      });
      combineCustomFields = [].concat(_toConsumableArray(new Map(combineCustomFields.map(function (item) {
        return [item.id, item];
      })).values()));
      // push deleted fields to the end of array as it is still shown if there is a previous value.
      combineCustomFields.forEach(function (d, idx) {
        if (d.isDeleted) combineCustomFields[idx].position += 999;
      });
      if (data) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_CustomFieldForm2.default, {
            ref: this.customFieldFormRef,
            componentData: data,
            customFieldSettings: projectBookingCustomFields,
            countryCode: auth && auth.company ? auth.company.countryCode : '',
            isEditing: isEditing,
            isBookingCustomField: true,
            onCustomInputChange: this.handleCustomInputChange,
            onCustomSelectChange: this.handleCustomSelectChange,
            minItems: minItems,
            offsetFrom: offsetFrom
          })
        );
      }
      return '';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _state4 = this.state,
          bookingPP = _state4.bookingPP,
          bookingFP = _state4.bookingFP,
          bookingStatusModal = _state4.bookingStatusModal,
          bookingChangeUnitModal = _state4.bookingChangeUnitModal,
          newBookingStatus = _state4.newBookingStatus,
          tinInvalidModal = _state4.tinInvalidModal,
          bookingNotesModuleExpand = _state4.bookingNotesModuleExpand,
          data = _state4.data,
          editingBooking = _state4.editingBooking,
          oriData = _state4.oriData,
          projectBookingCustomFields = _state4.projectBookingCustomFields,
          projectCurrencies = _state4.projectCurrencies,
          searchUserValue = _state4.searchUserValue,
          showDateTimeModal = _state4.showDateTimeModal,
          uploadModalState = _state4.uploadModalState,
          mpUserDetails = _state4.mpUserDetails,
          mpUserLoading = _state4.mpUserLoading,
          validationSvcErrorModalOpen = _state4.validationSvcErrorModalOpen,
          externalSvcErrorModalOpen = _state4.externalSvcErrorModalOpen,
          apieSvcErrorModalOpen = _state4.apieSvcErrorModalOpen,
          botSvcErrorModalOpen = _state4.botSvcErrorModalOpen,
          himsSvcErrorModalOpen = _state4.himsSvcErrorModalOpen,
          globalSettings = _state4.globalSettings,
          cancellationReasons = _state4.cancellationReasons,
          showChangeUnit = _state4.showChangeUnit,
          changeProjectID = _state4.changeProjectID,
          changeUnitID = _state4.changeUnitID,
          isUnitChange = _state4.isUnitChange;
      var _props = this.props,
          appConfig = _props.appConfig,
          routeParamsID = _props.routeParamsID,
          t = _props.t;

      var hideFirstTimeBuyer = appConfig && appConfig.data && appConfig.data.settings && appConfig.data.settings.bookingHideFirstTimeBuyer;
      var allowEditingApprovedDate = this.hasAccess(false, false, true, false, false);
      var allowEditingCancelledDate = allowEditingApprovedDate && appConfig && appConfig.data && appConfig.data.settings && !appConfig.data.settings.disableCancelledDateEditing;
      var allowEditingSoldDate = allowEditingApprovedDate && appConfig && appConfig.data && appConfig.data.settings && !appConfig.data.settings.disableSoldDateEditing;
      var allowEditingSPADates = this.hasAccess(false, false, true, false, false);

      var packagePricingsModals = [{
        name: 'showEditPackageModal',
        title: (oriData && oriData.packagePricing && oriData.packagePricing.id ? 'Edit' : 'Add') + ' pricing package',
        content: function content(_ref20) {
          var open = _ref20.open,
              onClose = _ref20.onClose;
          return _react2.default.createElement(_EditPackageModal2.default, {
            onSubmit: function onSubmit(pp) {
              return _this6.updateBookingPP(pp).then(function () {
                return onClose();
              });
            },
            open: open,
            onClose: onClose,
            selectedPackagePricing: oriData && oriData.packagePricing && oriData.packagePricing.projectPackagePricingID || 'base_selling_price',
            selectedCustomPPName: oriData && oriData.packagePricing && oriData.packagePricing.isCustomPrice && oriData.packagePricing.customName,
            auth: _this6.props.auth,
            packagePricings: bookingPP,
            isMobile: _this6.props.isMobile,
            bookingData: oriData,
            projectID: _this6.state.data.projectID
          });
        }
      }, {
        name: 'showCustomiseFormulaModal',
        title: 'Customise formula(s)',
        content: function content(_ref21) {
          var open = _ref21.open,
              onClose = _ref21.onClose;
          return _react2.default.createElement(_CustomiseFormulaModal2.default, {
            onSubmit: function onSubmit(calcs) {
              return _this6.updateBookingPPFormulas(calcs);
            },
            open: open,
            onClose: onClose,
            auth: _this6.props.auth,
            isMobile: _this6.props.isMobile,
            packagePricings: bookingPP,
            selectedPackagePricing: oriData && oriData.packagePricing && oriData.packagePricing.projectPackagePricingID,
            bookingData: oriData,
            serviceCompanyID: _this6.props.auth.company.service_company_id,
            globalSettings: globalSettings
          });
        }
      }, {
        name: 'showEditFeePackageModal',
        title: (oriData && oriData.packageFee && oriData.packageFee.id ? 'Edit' : 'Add') + ' additional fee package',
        content: function content(_ref22) {
          var open = _ref22.open,
              onClose = _ref22.onClose;
          return _react2.default.createElement(_EditFeePackageModal2.default, {
            onSubmit: function onSubmit(pp) {
              return _this6.updateBookingFP(pp);
            },
            open: open,
            onClose: onClose,
            selectedFeePackage: oriData && oriData.packageFee && oriData.packageFee.projectFeePackageID,
            auth: _this6.props.auth,
            feePackages: bookingFP,
            isMobile: _this6.props.isMobile,
            bookingData: oriData,
            t: _this6.props.t
          });
        }
      }, {
        name: 'showCustomiseFeePackageFormulaModal',
        title: 'Customise fee formula(s)',
        content: function content(_ref23) {
          var open = _ref23.open,
              onClose = _ref23.onClose;
          return _react2.default.createElement(_CustomiseFeePackageFormulaModal2.default, {
            onSubmit: function onSubmit(calcs) {
              return _this6.updateBookingFPFormulas(calcs);
            },
            open: open,
            onClose: onClose,
            auth: _this6.props.auth,
            isMobile: _this6.props.isMobile,
            selectedFeePackage: oriData && oriData.packageFee && oriData.packageFee.projectFeePackageID,
            bookingData: oriData,
            serviceCompanyID: _this6.props.auth.company.service_company_id
          });
        }
      }];
      return _react2.default.createElement(
        _semanticUiReact.Container,
        { className: 'no_margin' },
        isPRS ? _react2.default.createElement(_ModalNotice2.default, {
          open: validationSvcErrorModalOpen,
          onClose: this.handleCloseValidationSvcErrModal,
          headerNode: 'JDE ' + t('Logs'),
          content: this.renderJDELogs(oriData)
        }) : '',
        this.showExternalService() ? _react2.default.createElement(_ModalNotice2.default, {
          open: externalSvcErrorModalOpen,
          onClose: function onClose() {
            return _this6.handleToggleExternalSvcErrModal(false);
          },
          headerNode: 'External ' + t('Error Logs'),
          content: oriData.externalServiceError ? this.renderSvcErrorList(oriData.externalServiceError) : ''
        }) : '',
        this.showAPIEService() ? _react2.default.createElement(_ModalNotice2.default, {
          open: apieSvcErrorModalOpen,
          onClose: function onClose() {
            return _this6.handleToggleAPIESvcErrModal(false);
          },
          headerNode: 'APIE ' + t('Error Logs'),
          content: oriData.apieServiceError ? this.renderSvcErrorList(oriData.apieServiceError) : ''
        }) : '',
        this.showBotService() ? _react2.default.createElement(_ModalNotice2.default, {
          open: botSvcErrorModalOpen,
          onClose: function onClose() {
            return _this6.handleToggleBotSvcErrModal(false);
          },
          headerNode: 'Bot Error Logs',
          content: oriData.botServiceErrors && oriData.botServiceErrors.length > 0 ? this.renderBotSvcError(oriData.botServiceErrors) : ''
        }) : '',
        this.showHimsService() ? _react2.default.createElement(_ModalNotice2.default, {
          open: himsSvcErrorModalOpen,
          onClose: function onClose() {
            return _this6.handleToggleHimsSvcErrModal(false);
          },
          headerNode: 'HIMS Error Logs',
          content: oriData.himsServiceErrors && oriData.himsServiceErrors.length > 0 ? _react2.default.createElement(_HimsErrorLog2.default, {
            httpStatus: oriData.himsServiceHttpStatus,
            response: oriData.himsServiceResponse,
            action: oriData.himsServiceAction,
            errors: oriData.himsServiceErrors
          }) : ''
        }) : '',
        _react2.default.createElement(_DateTimeForm2.default, {
          headerNode: t('Booking Created Date', { ns: _translation.TRANSLATION_FILES.translation }),
          descriptionNode: data.code,
          label: t('Booking Created Date', { ns: _translation.TRANSLATION_FILES.translation }),
          placeholder: t('Click to set date', { ns: _translation.TRANSLATION_FILES.translation }),
          data: (0, _momentTimezone2.default)(oriData.createdAt),
          onClose: this.handleCancelCreatedAt,
          onConfirm: this.handleSaveCreatedAt,
          open: showDateTimeModal
        }),
        _react2.default.createElement(_ESigningModal2.default, {
          ref: function ref(_ref24) {
            _this6.signatureModal = _ref24;
          },
          loading: this.state.loading,
          open: this.state.showSignModal,
          saveButton: _react2.default.createElement(_semanticUiReact.Button, { onClick: this.saveSignature, disabled: this.state.loading, positive: true, color: 'green', content: t('Save', { ns: _translation.TRANSLATION_FILES.translation }) }),
          cancelButton: _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleOnCancel, disabled: this.state.loading, basic: true, color: 'grey', content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }) })
        }),
        _react2.default.createElement(_BookingStatusNotes2.default, {
          onNotesChange: this.handleNotesChange,
          onCheckboxChange: this.handleNotesCheckboxChange,
          statusID: data.statusID,
          isCancelPending: data.isCancelPending,
          isUserCooldown: data.isUserCooldown,
          isUnitChange: isUnitChange,
          isDelistOnHold: data.projectUnit ? data.projectUnit.delistOnHold : false,
          onClose: this.handleCancelBookingStatus,
          onConfirm: this.handleConfirmBookingStatus,
          open: bookingStatusModal,
          data: data
        }),
        this.renderBotResyncModal(),
        _react2.default.createElement(_BookingChangeUnit2.default, {
          onClose: this.handleCancelChangeUnit,
          onConfirm: this.handleConfirmChangeUnit,
          open: bookingChangeUnitModal,
          data: oriData,
          changeProjectID: changeProjectID,
          changeSelectedProject: this.state.projectOpts.find(function (o) {
            return o.value === changeProjectID;
          }),
          changeSelectedUnit: this.state.unitOpts.find(function (o) {
            return o.value === changeUnitID;
          })
        }),
        _react2.default.createElement(_TinInvalidModal2.default, {
          newBookingStatus: newBookingStatus,
          onClose: this.handleCancelTinInvalidModal,
          onConfirm: this.handleConfirmBookingStatus,
          open: tinInvalidModal
        }),
        _react2.default.createElement(_ViewLarge2.default, {
          open: this.state.showLarge,
          onClose: this.handleCloseLarge,
          picture: this.state.selectedPicture,
          onSlide: this.handleSlidePicture,
          disabledLeft: !this.checkDisabled('left'),
          disabledRight: !this.checkDisabled('right'),
          slideshow: this.state.slideshow
        }),
        packagePricingsModals.map(function (ppm) {
          return _react2.default.createElement(_PackagingPricingModal2.default, {
            key: ppm.name,
            modalState: _this6.state[ppm.name],
            header: t(ppm.title),
            loading: _this6.state.loading,
            onClose: function onClose() {
              return _this6.toggleActiveStates(ppm.name, false);
            },
            content: ppm.content || null
          });
        }),
        this.renderSoldCasePrompt(),
        this.renderChangeUnitPrompt(),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 10 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, className: 'compact' }),
              _react2.default.createElement(_EditableBox2.default, {
                newHeader: t((0, _countries.isCountryVietnam)(this.props.auth.company.countryCode) ? 'Sales' : 'Booking').toUpperCase(),
                editable: this.hasAccess(false, true, true, true, true) || this.hasEditBookingAccess(data.maUserID, data.statusID) || this.showAgentCuButton(data.statusID),
                isEditing: this.state.editingBooking,
                loading: this.state.loading,
                buttonNode: this.showAgentCuButton(data.statusID) ? function () {
                  return _react2.default.createElement(_semanticUiReact.Label, {
                    as: 'button',
                    attached: 'top right',
                    style: {
                      right: '0',
                      top: '0.4em',
                      cursor: showChangeUnit ? 'default' : 'pointer',
                      opacity: showChangeUnit ? 0.5 : 1
                    },
                    content: _this6.props.isMobile ? 'C. Unit' : 'Change Unit',
                    icon: 'sign-in',
                    className: editingBooking ? '' : 'editable-button-new',
                    onClick: showChangeUnit ? null : _this6.handleShowChangeUnit
                  });
                } : null,
                onEdit: this.handleEditBooking,
                onClick: this.handleUpdateBooking,
                onCancel: this.handleResetBooking,
                content: function content(_ref25) {
                  var isEditing = _ref25.isEditing,
                      onConfirm = _ref25.onConfirm;
                  return _react2.default.createElement(
                    _semanticUiReact.Grid,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: _this6.canRenderNotesAndAPISection() ? 9 : 16, computer: _this6.canRenderNotesAndAPISection() ? 11 : 16 },
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Row,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { mobile: 16, tablet: 16, computer: 8 },
                              _react2.default.createElement(
                                _semanticUiReact.Grid,
                                null,
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Row,
                                  { stretched: true, centered: true },
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { width: 16 },
                                    _react2.default.createElement(_semanticUiReact.Dimmer, { style: { zIndex: 10 }, active: isEditing, inverted: true }),
                                    _react2.default.createElement(
                                      _semanticUiReact.Header,
                                      { as: 'h2', textAlign: (0, _vietnam.isVietnamCompany)(_this6.props.auth) ? 'left' : 'center', style: { marginTop: 0 } },
                                      data.code,
                                      _react2.default.createElement(
                                        _semanticUiReact.Header.Subheader,
                                        _extends({}, _this6.getDataAttributes('bookingcreatedat', (0, _momentTimezone2.default)(data.createdAt).format('YYYYMMDD hh:mm:ss'), 'booking'), _this6.getDataAttributes('bookingupdatedat', (0, _momentTimezone2.default)(data.updatedAt).format('YYYYMMDD hh:mm:ss'), 'booking'), _this6.getDataAttributes('bookingreservedat', (0, _momentTimezone2.default)(data.createdAt).format('YYYYMMDD hh:mm:ss'), 'booking')),
                                        _react2.default.createElement(
                                          'i',
                                          null,
                                          _react2.default.createElement(_Timestamp2.default, { format: 'MMMM Do YYYY, h:mm a', timestamp: data.createdAt }),
                                          _this6.hasAccess(false, true, false, false, false) && _react2.default.createElement(
                                            'button',
                                            {
                                              className: 'a-button-blue',
                                              onClick: _this6.handleOpenCreatedAt
                                            },
                                            _react2.default.createElement(_semanticUiReact.Icon, { name: 'edit', size: 'small', fitted: true, style: { marginLeft: '0.5rem' } })
                                          ),
                                          _react2.default.createElement('br', null),
                                          _react2.default.createElement(
                                            'small',
                                            null,
                                            _react2.default.createElement(
                                              'span',
                                              _extends({}, _this6.getDataAttributes('salespersonname', oriData.maCreatedByName, 'salesperson'), _this6.getDataAttributes('salespersonagency', _this6.props.maUserAffiliateCompanyBranchName, 'salesperson')),
                                              (0, _vietnam.createdByLabel)(_this6.props.auth, t, (0, _translation2.translateModels)(t, 'maCreatedByPreferredName', 'booking')).toLowerCase(),
                                              '\xA0'
                                            ),
                                            data.origin === 'marketplace' && _this6.hasMPDetailsAccess() ? _react2.default.createElement(
                                              _semanticUiReact.Popup,
                                              {
                                                on: 'click',
                                                trigger: _react2.default.createElement(
                                                  'a',
                                                  null,
                                                  oriData.maCreatedByPreferredName
                                                ),
                                                onOpen: function onOpen() {
                                                  _this6.fetchMarketplaceUserDetails(oriData.maUserID);
                                                },
                                                size: 'mini',
                                                inverted: true,
                                                position: 'bottom right',
                                                disabled: true,
                                                flowing: true
                                              },
                                              mpUserLoading ? _react2.default.createElement(
                                                _semanticUiReact.Loader,
                                                { active: true, inline: 'centered' },
                                                t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                                              ) : _react2.default.createElement(
                                                'span',
                                                { style: { fontSize: '15px' } },
                                                _react2.default.createElement(
                                                  'div',
                                                  null,
                                                  (0, _translation2.translateModels)(t, 'fullName', 'mpUserDetails') + ': ' + mpUserDetails.fullName
                                                ),
                                                _react2.default.createElement(
                                                  'div',
                                                  null,
                                                  (0, _translation2.translateModels)(t, 'email', 'mpUserDetails') + ': ' + mpUserDetails.email
                                                ),
                                                _react2.default.createElement(
                                                  'div',
                                                  null,
                                                  (0, _translation2.translateModels)(t, 'mobile', 'mpUserDetails') + ': ' + mpUserDetails.mobilePrefix + mpUserDetails.mobile
                                                ),
                                                mpUserDetails.agencyName ? _react2.default.createElement(
                                                  'div',
                                                  null,
                                                  (0, _translation2.translateModels)(t, 'agencyName', 'mpUserDetails') + ': ' + mpUserDetails.agencyName
                                                ) : null,
                                                mpUserDetails.registrationNumber ? _react2.default.createElement(
                                                  'div',
                                                  null,
                                                  (0, _translation2.translateModels)(t, 'registrationNumber', 'mpUserDetails') + ': ' + mpUserDetails.registrationNumber
                                                ) : null
                                              )
                                            ) : _this6.hasAccess(false, true, true, false, false) ? _react2.default.createElement(
                                              _reactRouter.Link,
                                              { to: '/users/' + oriData.maUserAffiliateID + '/' },
                                              oriData.maCreatedByPreferredName
                                            ) : oriData.maCreatedByPreferredName,
                                            data && data.origin && data.origin.includes('marketplace' || 'marketplace_') ? _react2.default.createElement(
                                              _semanticUiReact.Label,
                                              { size: 'mini', style: { marginLeft: '0.5em', backgroundColor: '#e6fff2', color: '#008040' } },
                                              data.origin.includes('') ? t(data.origin.includes('marketplace_') ? 'Showroom Buyer' : 'Marketplace Buyer') : null
                                            ) : null
                                          )
                                        )
                                      )
                                    )
                                  ),
                                  !(0, _countries.isCountryVietnam)(_this6.props.auth.company.countryCode) && _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { mobile: 16, tablet: 8, computer: 16 },
                                    _react2.default.createElement(_semanticUiReact.Dimmer, { style: { zIndex: 10 }, active: isEditing, inverted: true }),
                                    data && data.salesPersonSignAt ? _react2.default.createElement(
                                      'span',
                                      null,
                                      t('Signed on'),
                                      '\xA0',
                                      _react2.default.createElement(_Timestamp2.default, {
                                        timestamp: data.salesPersonSignAt
                                      }),
                                      '\xA0',
                                      _react2.default.createElement(
                                        'button',
                                        { onClick: function onClick(e) {
                                            return _this6.handleSalesSign(e);
                                          }, className: 'a-button-blue' },
                                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'edit' })
                                      )
                                    ) : _react2.default.createElement(
                                      'span',
                                      null,
                                      _react2.default.createElement(
                                        'button',
                                        { onClick: function onClick(e) {
                                            return _this6.handleSalesSign(e);
                                          }, className: 'a-button-blue' },
                                        t('Sales Person E-Sign')
                                      )
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { width: 16, style: { marginTop: '1em' } },
                                    showChangeUnit ? _react2.default.createElement(
                                      _semanticUiReact.Grid,
                                      { stackable: true },
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Row,
                                        null,
                                        _react2.default.createElement(
                                          _semanticUiReact.Grid.Column,
                                          { width: 16 },
                                          _react2.default.createElement(_semanticUiReact.Dropdown, {
                                            disabled: !(_this6.checkAllowChangeUnit() && oriData.project.cuOtherProjectIsEnabled) || _this6.state.loading || _this6.state.loadingProject,
                                            fluid: true,
                                            loading: _this6.state.loadingProject,
                                            name: 'changeProjectID',
                                            onChange: _this6.handleSelectChangeProject,
                                            options: _this6.state.projectOpts,
                                            placeholder: t('Find Project'),
                                            search: true,
                                            selection: true,
                                            value: changeProjectID
                                          })
                                        )
                                      ),
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Row,
                                        null,
                                        _react2.default.createElement(
                                          _semanticUiReact.Grid.Column,
                                          { width: 16 },
                                          _react2.default.createElement(_semanticUiReact.Dropdown, {
                                            disabled: !_this6.checkAllowChangeUnit() || _this6.state.loading || _this6.state.loadingUnit || _this6.state.loadingProject || !_this6.state.changeProjectID,
                                            fluid: true,
                                            loading: _this6.state.loadingUnit,
                                            name: 'changeUnitID',
                                            onChange: _this6.handleSelectChangeUnit,
                                            options: _this6.state.unitOpts,
                                            placeholder: t('Find Unit'),
                                            search: true,
                                            selection: true,
                                            value: changeUnitID
                                          })
                                        )
                                      ),
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Row,
                                        null,
                                        _react2.default.createElement(
                                          _semanticUiReact.Grid.Column,
                                          { mobile: 16, tablet: 8, computer: 8 },
                                          _react2.default.createElement(_semanticUiReact.Button, {
                                            fluid: true,
                                            size: 'small',
                                            icon: 'remove',
                                            content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }),
                                            onClick: _this6.handleHideChangeUnit,
                                            disabled: _this6.state.loading
                                          })
                                        ),
                                        _react2.default.createElement(
                                          _semanticUiReact.Grid.Column,
                                          { mobile: 16, tablet: 8, computer: 8 },
                                          _react2.default.createElement(_semanticUiReact.Button, {
                                            fluid: true,
                                            size: 'small',
                                            color: 'blue',
                                            icon: 'save',
                                            content: t('Change'),
                                            onClick: _this6.handleShowConfirmChangeUnit,
                                            disabled: !changeUnitID || _this6.state.loading
                                          })
                                        )
                                      )
                                    ) : isEditing && _this6.hasChangeUnitAccess(oriData) && _react2.default.createElement(
                                      _semanticUiReact.Button,
                                      {
                                        fluid: true,
                                        size: 'small',
                                        color: 'blue',
                                        disabled: !_this6.checkAllowChangeUnit(),
                                        onClick: _this6.handleShowChangeUnit
                                      },
                                      t('Change Unit')
                                    )
                                  )
                                ),
                                _react2.default.createElement(RenderHiddenDivider, null)
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid,
                                null,
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Row,
                                  { className: 'no-top-padding' },
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    null,
                                    _react2.default.createElement(_semanticUiReact.Dimmer, { style: { zIndex: 9 }, active: isEditing, inverted: true }),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid,
                                      { verticalAlign: 'middle' },
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { textAlign: 'left', width: 6 },
                                        _react2.default.createElement(
                                          'b',
                                          null,
                                          t('Status')
                                        )
                                      ),
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { textAlign: 'right', width: 10 },
                                        _this6.hasAccess(_this6.checkStaffHasStatusAccess(), true, true, true, false) ? _react2.default.createElement(_semanticUiReact.Form.Select, {
                                          disabled: _this6.isBookingStatusDisabled(data),
                                          fluid: true,
                                          name: 'statusID',
                                          onChange: _this6.handleBookingStatusChange,
                                          options: _this6.getBookingStatuses().map(function (s) {
                                            return _extends({}, s, {
                                              text: t(s.text, { ns: _translation.TRANSLATION_FILES.constants })
                                            });
                                          }),
                                          placeholder: t('Select {{title}}', { title: (0, _translation2.translateModels)(t, 'statusID', 'booking') }),
                                          selectOnBlur: false,
                                          value: data.statusID
                                        }) : oriData.bookingStatus ? t(oriData.bookingStatus.name, { ns: _translation.TRANSLATION_FILES.constants }) : '-'
                                      ),
                                      _this6.isBookingStatusUpdateBlocked(data) ? _this6.renderStatusDisabledTextWithCC() : null,
                                      _this6.renderSignatureRequiredText()
                                    ),
                                    _react2.default.createElement(RenderDivider, null),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid,
                                      null,
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { textAlign: 'left', width: 8 },
                                        _react2.default.createElement(
                                          'b',
                                          null,
                                          t('Unit')
                                        )
                                      ),
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        _extends({ textAlign: 'right', width: 8 }, _this6.getDataAttributes('unitreference', data.projectUnit ? data.projectUnit.reference : '', 'unit')),
                                        data.projectUnit ? _react2.default.createElement(
                                          'div',
                                          null,
                                          _react2.default.createElement(
                                            _reactRouter.Link,
                                            { to: '/projects/' + data.projectID + '/units/' + data.projectUnitID + '/' },
                                            data.projectUnit.reference
                                          ),
                                          '\xA0',
                                          data.projectUnit.isBumi && _react2.default.createElement(
                                            _semanticUiReact.Label,
                                            { size: 'mini' },
                                            (0, _vietnam.unitQuotaChipLabel)(_this6.props.auth, t)
                                          )
                                        ) : '-'
                                      )
                                    ),
                                    _react2.default.createElement(RenderDivider, null),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid,
                                      null,
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { textAlign: 'left', width: 8 },
                                        _react2.default.createElement(
                                          'b',
                                          null,
                                          t('Layout')
                                        )
                                      ),
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { textAlign: 'right', width: 8 },
                                        data.projectUnit ? _react2.default.createElement(
                                          _reactRouter.Link,
                                          { to: '/projects/' + data.projectID + '/layouts/' + data.projectUnit.projectUnitLayoutID + '/' },
                                          data.projectUnit.projectUnitLayout.name
                                        ) : '-'
                                      )
                                    ),
                                    _react2.default.createElement(RenderDivider, null),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid,
                                      null,
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { textAlign: 'left', width: 6 },
                                        _react2.default.createElement(
                                          'b',
                                          null,
                                          t('Project')
                                        )
                                      ),
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        _extends({ textAlign: 'right', width: 10 }, _this6.getDataAttributes('projectname', data.project ? data.project.name : '', 'project')),
                                        data.project ? _react2.default.createElement(
                                          _reactRouter.Link,
                                          { to: '/projects/' + data.projectID + '/' },
                                          data.project.name
                                        ) : '-'
                                      )
                                    )
                                  )
                                )
                              ),
                              _react2.default.createElement(_semanticUiReact.Divider, { className: 'small-hide large-hide compact' })
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { mobile: 16, tablet: 16, computer: 8 },
                              _react2.default.createElement(
                                _semanticUiReact.Form,
                                { onSubmit: onConfirm },
                                isEditing && _this6.hasAccess(false, true, true, false, false) && _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  { verticalAlign: 'middle' },
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _vietnam.createdByLabel)(_this6.props.auth, t, (0, _translation2.translateModels)(t, 'maCreatedByPreferredName', 'booking'))
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { width: 10 },
                                    _react2.default.createElement(_SearchStaff2.default, {
                                      onClear: _this6.handleUserClear,
                                      onSelect: _this6.handleUserSelect,
                                      selectedValue: _this6.getSelectedCreatorValue(),
                                      searchAll: true,
                                      onFetch: _this6.handleUserfetch,
                                      value: searchUserValue,
                                      placeholder: t('Find User') + '...'
                                    })
                                  )
                                ),
                                isEditing && _this6.hasAccess(false, true, true, false, false) && _react2.default.createElement(RenderDivider, null),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  { verticalAlign: 'middle' },
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'assignedMaName', 'booking')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { width: 10 },
                                    isEditing && _this6.hasAccess() ? _react2.default.createElement(_SearchStaff2.default, {
                                      onClear: _this6.handleStaffClear,
                                      onSelect: _this6.handleStaffSelect,
                                      selectedValue: _this6.getSelectedStaffValue(),
                                      auth: _this6.props.auth
                                    }) : _react2.default.createElement(
                                      'div',
                                      { style: { textAlign: 'right' } },
                                      oriData.assignedMaUserID > 0 ? oriData.assignedMaName + ' (' + oriData.assignedMaPreferredName + ')' : '-'
                                    )
                                  )
                                ),
                                _react2.default.createElement(RenderDivider, null),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  { verticalAlign: 'middle' },
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'paymentMethodID', 'booking')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing && _this6.hasAccessSourceOfFinance() ? _react2.default.createElement(_semanticUiReact.Form.Select, {
                                      fluid: true,
                                      name: 'paymentMethodID',
                                      options: (data.financeSourceOpts ? data.financeSourceOpts : (0, _vietnam.paymentMethodOpts)(_this6.props.auth)).map(function (opt) {
                                        return _extends({}, opt, {
                                          text: t(opt.text, { ns: _translation.TRANSLATION_FILES.constants, defaultValue: opt.text })
                                        });
                                      }),
                                      onChange: _this6.handleBookingChange,
                                      placeholder: t('Select {{title}}', { title: (0, _translation2.translateModels)(t, 'paymentMethodID', 'booking') }),
                                      selectOnBlur: false,
                                      value: data.paymentMethodID
                                    }) : oriData.paymentMethod && oriData.paymentMethod.name ? t(oriData.paymentMethod.name, { ns: _translation.TRANSLATION_FILES.constants }) : '-'
                                  )
                                ),
                                _react2.default.createElement(RenderDivider, null),
                                (0, _vietnam.isVietnamCompany)(_this6.props.auth) && _react2.default.createElement(
                                  _react2.default.Fragment,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    { verticalAlign: 'middle' },
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 6 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        (0, _translation2.translateModels)(t, 'waiveBankGuarantee', 'booking')
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'right', width: 10 },
                                      oriData.waiveBankGuarantee ? t('Yes') : t('No')
                                    )
                                  ),
                                  _react2.default.createElement(RenderDivider, null)
                                ),
                                hideFirstTimeBuyer ? '' : _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'firstTimeBuyer', 'booking')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(_semanticUiReact.Form.Select, {
                                      fluid: true,
                                      name: 'firstTimeBuyer',
                                      options: _firstTimeBuyer2.default.map(function (l) {
                                        return _extends({}, l, {
                                          text: t(l.text, { ns: _translation.TRANSLATION_FILES.constants })
                                        });
                                      }),
                                      onChange: _this6.handleBookingChange,
                                      placeholder: (0, _translation2.translateModels)(t, 'firstTimeBuyer', 'booking') + '?',
                                      selectOnBlur: false,
                                      value: data.firstTimeBuyer
                                    }) : data.firstTimeBuyer ? (0, _translation2.getConstantsLabel)(t, _firstTimeBuyer2.default, data.firstTimeBuyer) : '-'
                                  )
                                ),
                                hideFirstTimeBuyer ? '' : _react2.default.createElement(RenderDivider, null),
                                _this6.canRenderFirstTimeBuyer(data) ? _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: isEditing ? 6 : 8 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'srpLoan', 'booking')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: isEditing ? 10 : 8 },
                                    isEditing ? _react2.default.createElement(_semanticUiReact.Form.Select, {
                                      fluid: true,
                                      name: 'srpLoan',
                                      options: _srpLoan2.default.map(function (l) {
                                        return _extends({}, l, {
                                          text: t(l.text, { ns: _translation.TRANSLATION_FILES.constants })
                                        });
                                      }),
                                      onChange: _this6.handleBookingChange,
                                      placeholder: (0, _translation2.translateModels)(t, 'srpLoan', 'booking') + '?',
                                      selectOnBlur: false,
                                      value: data.srpLoan
                                    }) : data.srpLoan ? (0, _translation2.getConstantsLabel)(t, _srpLoan2.default, data.srpLoan) : '-'
                                  )
                                ) : '',
                                _this6.canRenderFirstTimeBuyer(data) ? _react2.default.createElement(RenderDivider, null) : '',
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  { verticalAlign: 'middle' },
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      globalSettings && globalSettings.sellingPrice ? globalSettings.sellingPrice : t('Selling Price')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing && _this6.props.auth.allowEditUnitPrice && _this6.hasAccess(false, true, true, true, true) ? _react2.default.createElement(_AppForm2.default.Input, {
                                      validateLabel: t('Selling Price'),
                                      placeholder: t('Selling Price'),
                                      name: 'spaAmount',
                                      type: 'number',
                                      step: '.01',
                                      value: data.spaAmount,
                                      onChange: _this6.handleBookingAmountChange,
                                      ref: _this6.validation.spaAmount,
                                      validation: [_webValidations.required],
                                      disabled: _this6.disablePricingEditAfterSold(data)
                                    }) : oriData.spaValue ? _react2.default.createElement(_LoanAmount2.default, {
                                      projectCurrencies: projectCurrencies,
                                      format: '0,000,000.00',
                                      amount: oriData.spaAmount,
                                      prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                                    }) : '-'
                                  )
                                ),
                                isEditing && _this6.props.auth.allowEditUnitPrice && _this6.hasAccess(false, true, true, true, true) ? _react2.default.createElement(
                                  'div',
                                  null,
                                  _react2.default.createElement(RenderDivider, null),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    { verticalAlign: 'middle' },
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 6 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        globalSettings && globalSettings.nettSellingPrice ? globalSettings.nettSellingPrice : (0, _translation2.translateModels)(t, 'nettSellingPrice', 'booking')
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'right', width: 10 },
                                      _react2.default.createElement(_AppForm2.default.Input, {
                                        validateLabel: (0, _translation2.translateModels)(t, 'nettSellingPrice', 'booking'),
                                        placeholder: (0, _translation2.translateModels)(t, 'nettSellingPrice', 'booking'),
                                        name: 'nettSellingPrice',
                                        type: 'number',
                                        value: data.nettSellingPrice,
                                        onChange: _this6.handleBookingAmountChange,
                                        ref: _this6.validation.nettSellingPrice,
                                        validation: [_webValidations.required, {
                                          validate: _webValidations.numericRange,
                                          option: {
                                            min: 1,
                                            max: 100000000000
                                          }
                                        }],
                                        min: '1',
                                        step: '0.01',
                                        disabled: _this6.disablePricingEditAfterSold(data)
                                      })
                                    )
                                  )
                                ) : '',
                                isEditing && _this6.showDiscountPricing(oriData) && _this6.props.auth.allowEditUnitPrice && _this6.hasAccess(false, true, true, true, true) ? _react2.default.createElement(RenderDivider, null) : '',
                                isEditing && _this6.showDiscountPricing(oriData) && _this6.props.auth.allowEditUnitPrice && _this6.hasAccess(false, true, true, true, true) ? _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  { verticalAlign: 'middle' },
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      t('Discount Pricing')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    _react2.default.createElement(_semanticUiReact.Form.Select, {
                                      className: 'ddPricingTierDropdown',
                                      name: 'pricingTier',
                                      options: _this6.optionsTierPricings(),
                                      placeholder: t('Select {{title}}', { title: t('Discount Pricing') }),
                                      search: true,
                                      selectOnBlur: false,
                                      value: _this6.getTierPricingValue(),
                                      onChange: _this6.handleTierPricingChange
                                    })
                                  )
                                ) : '',
                                oriData.tierPricingName && _react2.default.createElement(RenderDivider, null),
                                oriData.tierPricingName && _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  { verticalAlign: 'middle' },
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      t('Pricing Name')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing && _this6.hasAccess(false, true, true, true, true) ? _react2.default.createElement(_AppForm2.default.Input, {
                                      validateLabel: t('Pricing Name'),
                                      placeholder: t('Pricing Name'),
                                      name: 'tierPricingName',
                                      value: data.tierPricingName,
                                      onChange: _this6.handleBookingChange,
                                      ref: _this6.validation.tierPricingName,
                                      disabled: true
                                    }) : oriData.spaValue ? _react2.default.createElement(_semanticUiReact.Popup, {
                                      trigger: _react2.default.createElement(
                                        'div',
                                        { className: 'priceName link' },
                                        oriData.tierPricingName
                                      ),
                                      content: oriData.tierPricingDescription,
                                      size: 'mini',
                                      inverted: true,
                                      position: 'bottom right',
                                      disabled: true
                                    }) : '-'
                                  )
                                ),
                                isEditing && oriData.tierPricingName ? _react2.default.createElement(RenderDivider, null) : '',
                                isEditing && oriData.tierPricingName ? _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  { verticalAlign: 'middle' },
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      { style: { color: '#999' } },
                                      t('Pricing Description')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    _react2.default.createElement(_AppForm2.default.Input, {
                                      validateLabel: t('Pricing Description'),
                                      placeholder: t('Pricing Description'),
                                      name: 'tierPricingDescription',
                                      value: data.tierPricingDescription,
                                      onChange: _this6.handleBookingChange,
                                      ref: _this6.validation.tierPricingDescription,
                                      disabled: true
                                    })
                                  )
                                ) : '',
                                _react2.default.createElement(RenderDivider, null),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  { verticalAlign: 'middle' },
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      t('Price'),
                                      ' per ',
                                      _this6.checkSizeSuffix()
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { width: 10 },
                                    _react2.default.createElement(
                                      'div',
                                      { style: { textAlign: 'right' } },
                                      data.projectUnit && data.projectUnit.size > 0 ? _react2.default.createElement(_LoanAmount2.default, {
                                        projectCurrencies: projectCurrencies,
                                        format: '0,000,000.00',
                                        amount: (data.spaAmount / data.projectUnit.size).toFixed(2),
                                        prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                                      }) : '-'
                                    )
                                  )
                                ),
                                _this6.showHimsService() && _react2.default.createElement(RenderDivider, null),
                                _this6.showHimsService() && _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  { verticalAlign: 'middle' },
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      'HIMS ',
                                      t('Price'),
                                      ' per ',
                                      t('sqm')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { width: 10 },
                                    isEditing && _this6.hasAccess() ? _react2.default.createElement(_semanticUiReact.Form.Input, {
                                      fluid: true,
                                      placeholder: 'HIMS ' + t('Price') + ' per ' + t('sqm'),
                                      value: data.pricePerSqm,
                                      name: 'pricePerSqm',
                                      min: '1',
                                      step: '0.01',
                                      type: 'number',
                                      onChange: _this6.handleBookingChange,
                                      icon: _react2.default.createElement(_semanticUiReact.Icon, {
                                        link: true,
                                        name: 'sync alternate',
                                        onClick: _this6.handleResetPricePerSqm
                                      })
                                    }) : _react2.default.createElement(
                                      'div',
                                      { style: { textAlign: 'right' } },
                                      data.pricePerSqm > 0 ? _react2.default.createElement(_LoanAmount2.default, {
                                        projectCurrencies: projectCurrencies,
                                        format: '0,000,000.00',
                                        amount: data.pricePerSqm,
                                        prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                                      }) : '-'
                                    )
                                  )
                                ),
                                isEditing && _this6.hasAccess(false, true, true, true, true) && oriData.remarkInternal && _react2.default.createElement(RenderDivider, null),
                                oriData.remarkInternal && isEditing ? _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  { verticalAlign: 'top' },
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'remarkInternal', 'booking')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    _react2.default.createElement(
                                      _MarkdownText2.default,
                                      null,
                                      oriData.remarkInternal || '-'
                                    )
                                  )
                                ) : null,
                                _react2.default.createElement(RenderDivider, null),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  { verticalAlign: 'middle' },
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'approvedAt', 'booking')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing && allowEditingApprovedDate ? _react2.default.createElement(_semanticUiReact.Form.Input, {
                                      fluid: true,
                                      placeholder: t('Click to set approved at date'),
                                      value: data.approvedAt ? (0, _momentTimezone2.default)(data.approvedAt).format(inputDateFormat) : '',
                                      readOnly: true,
                                      onFocus: function onFocus() {
                                        return _this6.handleOnVisible('approvedAt');
                                      },
                                      icon: 'calendar'
                                    }) : null,
                                    isEditing && !allowEditingApprovedDate || !isEditing ? data.approvedAt ? _react2.default.createElement(_Timestamp2.default, {
                                      format: 'DD MMM YYYY',
                                      timestamp: (0, _momentTimezone2.default)(data.approvedAt).format()
                                    }) : '-' : null
                                  )
                                ),
                                isEditing && allowEditingApprovedDate ? _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { width: 16 },
                                    _react2.default.createElement(_CalendarDatePicker2.default, {
                                      closeableCompact: false,
                                      minDate: data.createdAt ? (0, _momentTimezone2.default)(data.createdAt).startOf('day').toDate() : null,
                                      maxDate: (0, _momentTimezone2.default)().toDate(),
                                      noPadding: true,
                                      name: 'approvedAt',
                                      value: data.approvedAt ? (0, _momentTimezone2.default)(data.approvedAt).toDate() : null,
                                      onChange: function onChange(value, visible) {
                                        return _this6.handleBookingDateChanges(value, visible, 'approvedAt');
                                      },
                                      visible: _this6.state.approvedDatePickerVisible
                                    })
                                  )
                                ) : null,
                                data.statusID === 'sold_spa_signed' ? _react2.default.createElement(RenderDivider, null) : null,
                                data.statusID === 'sold_spa_signed' ? _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  { verticalAlign: 'middle' },
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'lastSoldAt', 'booking')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing && allowEditingSoldDate ? _react2.default.createElement(_semanticUiReact.Form.Input, {
                                      fluid: true,
                                      placeholder: t('Click to set last sold at date'),
                                      value: data.lastSoldAt ? (0, _momentTimezone2.default)(data.lastSoldAt).format(inputDateFormat) : '',
                                      readOnly: true,
                                      onFocus: function onFocus() {
                                        return _this6.handleOnVisible('lastSoldAt');
                                      },
                                      icon: 'calendar'
                                    }) : null,
                                    isEditing && !allowEditingSoldDate || !isEditing ? data.lastSoldAt ? _react2.default.createElement(_Timestamp2.default, {
                                      format: 'DD MMM YYYY',
                                      timestamp: (0, _momentTimezone2.default)(data.lastSoldAt).format()
                                    }) : '-' : null
                                  )
                                ) : null,
                                data.statusID === 'sold_spa_signed' && isEditing && allowEditingSoldDate ? _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { width: 16 },
                                    _react2.default.createElement(_CalendarDatePicker2.default, {
                                      closeableCompact: false,
                                      minDate: _this6.state.minSoldDate,
                                      maxDate: (0, _momentTimezone2.default)().toDate(),
                                      noPadding: true,
                                      name: 'lastSoldAt',
                                      value: data.lastSoldAt ? (0, _momentTimezone2.default)(data.lastSoldAt).toDate() : null,
                                      onChange: function onChange(value, visible) {
                                        return _this6.handleBookingDateChanges(value, visible, 'lastSoldAt');
                                      },
                                      visible: _this6.state.soldDatePickVisible
                                    })
                                  )
                                ) : null,
                                data.statusID === 'sold_spa_signed' ? _react2.default.createElement(
                                  'div',
                                  null,
                                  _react2.default.createElement(RenderDivider, null),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    { verticalAlign: 'middle' },
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 6 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        (0, _translation2.translateModels)(t, 'spaSigningDate', 'booking')
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'right', width: 10 },
                                      allowEditingSPADates && isEditing ? _react2.default.createElement(_semanticUiReact.Form.Input, {
                                        fluid: true,
                                        placeholder: t('Click to set SPA signing date'),
                                        value: data.spaSigningDate ? (0, _momentTimezone2.default)(data.spaSigningDate).format(inputDateFormat) : '',
                                        readOnly: true,
                                        onFocus: function onFocus() {
                                          return _this6.handleOnVisible('spaSigningDate');
                                        },
                                        icon: 'calendar'
                                      }) : data.spaSigningDate ? _react2.default.createElement(_Timestamp2.default, {
                                        format: 'DD MMM YYYY',
                                        timestamp: data.spaSigningDate
                                      }) : '-'
                                    )
                                  )
                                ) : null,
                                isEditing && allowEditingSPADates && data.statusID === 'sold_spa_signed' ? _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { width: 16 },
                                    _react2.default.createElement(_CalendarDatePicker2.default, {
                                      closeableCompact: false,
                                      minDate: _this6.state.minSoldDate,
                                      maxDate: (0, _momentTimezone2.default)().toDate(),
                                      noPadding: true,
                                      name: 'spaSigningDate',
                                      value: data.spaSigningDate ? (0, _momentTimezone2.default)(data.spaSigningDate).toDate() : null,
                                      onChange: function onChange(value, visible) {
                                        return _this6.handleBookingDateChanges(value, visible, 'spaSigningDate');
                                      },
                                      visible: _this6.state.spaSigningDatePickerVisible
                                    })
                                  )
                                ) : null,
                                data.statusID === 'sold_spa_signed' ? _react2.default.createElement(
                                  'div',
                                  null,
                                  _react2.default.createElement(RenderDivider, null),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    { verticalAlign: 'middle' },
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 6 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        (0, _translation2.translateModels)(t, 'spaStampingDate', 'booking')
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'right', width: 10 },
                                      allowEditingSPADates && isEditing ? _react2.default.createElement(_semanticUiReact.Form.Input, {
                                        fluid: true,
                                        placeholder: t('Click to set SPA stamping date'),
                                        value: data.spaStampingDate ? (0, _momentTimezone2.default)(data.spaStampingDate).format(inputDateFormat) : '',
                                        readOnly: true,
                                        onFocus: function onFocus() {
                                          return _this6.handleOnVisible('spaStampingDate');
                                        },
                                        icon: 'calendar'
                                      }) : data.spaStampingDate ? _react2.default.createElement(_Timestamp2.default, {
                                        format: 'DD MMM YYYY',
                                        timestamp: data.spaStampingDate
                                      }) : '-'
                                    )
                                  )
                                ) : null,
                                isEditing && allowEditingSPADates && data.statusID === 'sold_spa_signed' ? _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { width: 16 },
                                    _react2.default.createElement(_CalendarDatePicker2.default, {
                                      closeableCompact: false,
                                      minDate: _this6.state.minSoldDate,
                                      maxDate: (0, _momentTimezone2.default)().toDate(),
                                      noPadding: true,
                                      name: 'spaStampingDate',
                                      value: data.spaStampingDate ? (0, _momentTimezone2.default)(data.spaStampingDate).toDate() : null,
                                      onChange: function onChange(value, visible) {
                                        return _this6.handleBookingDateChanges(value, visible, 'spaStampingDate');
                                      },
                                      visible: _this6.state.spaStampingDatePickerVisible
                                    })
                                  )
                                ) : null,
                                data.statusID === 'cancelled_developer' ? _react2.default.createElement(RenderDivider, null) : null,
                                data.statusID === 'cancelled_developer' ? _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  { verticalAlign: 'middle' },
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'cancelledAt', 'booking')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing && allowEditingCancelledDate ? _react2.default.createElement(_semanticUiReact.Form.Input, {
                                      fluid: true,
                                      placeholder: t('Click to set cancelled date'),
                                      value: data.cancelledAt ? (0, _momentTimezone2.default)(data.cancelledAt).format(inputDateFormat) : '',
                                      readOnly: true,
                                      onFocus: function onFocus() {
                                        return _this6.handleOnVisible('cancelledAt');
                                      },
                                      icon: 'calendar'
                                    }) : null,
                                    isEditing && !allowEditingCancelledDate || !isEditing ? data.cancelledAt ? _react2.default.createElement(_Timestamp2.default, {
                                      format: 'DD MMM YYYY',
                                      timestamp: (0, _momentTimezone2.default)(data.cancelledAt).format()
                                    }) : '-' : null
                                  )
                                ) : null,
                                data.statusID === 'cancelled_developer' && isEditing && allowEditingCancelledDate ? _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { width: 16 },
                                    _react2.default.createElement(_CalendarDatePicker2.default, {
                                      closeableCompact: false,
                                      minDate: _this6.state.minCancelledDate,
                                      maxDate: (0, _momentTimezone2.default)().toDate(),
                                      noPadding: true,
                                      name: 'cancelledAt',
                                      value: data.cancelledAt ? (0, _momentTimezone2.default)(data.cancelledAt).toDate() : null,
                                      onChange: function onChange(value, visible) {
                                        return _this6.handleBookingDateChanges(value, visible, 'cancelledAt');
                                      },
                                      visible: _this6.state.cancelledDatePickerVisible
                                    })
                                  )
                                ) : null,
                                data.statusID === 'cancelled_developer' && data.cancellationReasonID !== '' && cancellationReasons.some(function (x) {
                                  return x.id === data.cancellationReasonID;
                                }) ? _react2.default.createElement(
                                  'div',
                                  null,
                                  _react2.default.createElement(RenderDivider, null),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    { verticalAlign: 'middle' },
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 6 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        (0, _translation2.translateModels)(t, 'cancellationReasonID', 'booking')
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'right', width: 10 },
                                      isEditing ? _react2.default.createElement(_semanticUiReact.Form.Select, {
                                        fluid: true,
                                        name: 'cancellationReasonID',
                                        options: cancellationReasons.map(function (d) {
                                          return {
                                            text: d.name,
                                            value: d.id
                                          };
                                        }),
                                        onChange: _this6.handleBookingChange,
                                        selectOnBlur: false,
                                        value: data.cancellationReasonID
                                      }) : cancellationReasons.find(function (x) {
                                        return x.id === data.cancellationReasonID;
                                      }).name
                                    )
                                  )
                                ) : null,
                                data.selectedBankCaseID && data.selectedBankCaseID !== 0 || data.bankName || isEditing && _this6.canEditConversionDetails() ? _react2.default.createElement(
                                  'div',
                                  null,
                                  _react2.default.createElement(RenderDivider, null),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    { verticalAlign: 'middle' },
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 6 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        t('Successful Loan')
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'right', width: 10 },
                                      isEditing && _this6.canEditConversionDetails() ? _react2.default.createElement(_semanticUiReact.Form.Input, {
                                        name: 'bankName',
                                        value: data.bankName,
                                        onChange: _this6.handleBookingChange,
                                        placeholder: t('Enter bank name')
                                      }) : _this6.getSelectedBank()
                                    )
                                  )
                                ) : null,
                                data.bankerName || isEditing && _this6.canEditConversionDetails() ? _react2.default.createElement(
                                  'div',
                                  null,
                                  _react2.default.createElement(RenderDivider, null),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    { verticalAlign: 'middle' },
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 6 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        (0, _translation2.translateModels)(t, 'bankerName', 'booking')
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'right', width: 10 },
                                      isEditing && _this6.canEditConversionDetails() ? _react2.default.createElement(_semanticUiReact.Form.Input, {
                                        name: 'bankerName',
                                        value: data.bankerName,
                                        onChange: _this6.handleBookingChange,
                                        placeholder: t('Enter banker name')
                                      }) : data.bankerName
                                    )
                                  )
                                ) : null,
                                data.loanAmount > 0 || isEditing && _this6.canEditConversionDetails() ? _react2.default.createElement(
                                  'div',
                                  null,
                                  _react2.default.createElement(RenderDivider, null),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    { verticalAlign: 'middle' },
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 6 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        t('Loan Margin')
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'right', width: 10 },
                                      isEditing && _this6.canEditConversionDetails() ? _react2.default.createElement(_semanticUiReact.Form.Select, {
                                        fluid: true,
                                        search: true,
                                        name: 'loanMargin',
                                        options: _this6.getPercentageOptions(),
                                        placeholder: '0%',
                                        selectOnBlur: false,
                                        value: data.loanAmount > 0 && data.spaValue > 0 ? Math.ceil(data.loanAmount / data.spaValue * 100) : 0,
                                        onChange: _this6.handleLoanMarginChange
                                      }) : data.loanAmount > 0 && data.spaValue > 0 ? Math.ceil(data.loanAmount / data.spaValue * 100) + '%' : '0%'
                                    )
                                  )
                                ) : null,
                                data.loanAmount > 0 || isEditing && _this6.canEditConversionDetails() ? _react2.default.createElement(
                                  'div',
                                  null,
                                  _react2.default.createElement(RenderDivider, null),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    { verticalAlign: 'middle' },
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 6 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        t('Loan Amount')
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'right', width: 10 },
                                      isEditing && _this6.canEditConversionDetails() ? _react2.default.createElement(_AppForm2.default.Input, {
                                        name: 'loanAmount',
                                        type: 'number',
                                        min: '0',
                                        value: data.loanAmount || 0,
                                        onChange: _this6.handleLoanAmountChange,
                                        step: '1'
                                      }) : _react2.default.createElement(_LoanAmount2.default, {
                                        projectCurrencies: data.project && data.project.projectCurrency ? data.project.projectCurrency : [],
                                        format: '0,000,000.00',
                                        amount: data.loanAmount || 0,
                                        prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                                      })
                                    )
                                  )
                                ) : null
                              )
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Row,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { width: 16 },
                              projectBookingCustomFields && projectBookingCustomFields.length > 0 ? _react2.default.createElement(
                                _AppForm2.default,
                                { onSubmit: _this6.handleUpdateBooking },
                                _this6.renderCustomFields(isEditing)
                              ) : '',
                              _react2.default.createElement(_semanticUiReact.Divider, { className: 'computer-hide hidden compact' })
                            )
                          )
                        )
                      ),
                      /* APIs Section For Expanded Mode */
                      _this6.canRenderNotesAndAPISection() && bookingNotesModuleExpand ? _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 7, computer: 5 },
                        _this6.renderAPISection(t, oriData, isEditing)
                      ) : '',
                      /* Second / Right Parent Section (Notes & APIs) */
                      _this6.canRenderNotesAndAPISection() ? _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { id: 'bn_grid_col_div', className: bookingNotesModuleExpand ? 'bn-section-expanded' : '', mobile: 16, tablet: bookingNotesModuleExpand ? 16 : 7, computer: bookingNotesModuleExpand ? 16 : 5 },
                        /* Booking Notes */
                        _this6.hasBookingNoteReadAccess(data.project) ? _react2.default.createElement(_BookingNote2.default, {
                          bookingID: data.id === routeParamsID ? routeParamsID : '',
                          defaultPrivacy: data && data.project && data.project.bnDefaultPrivacy || '',
                          hasEditAccess: _this6.hasBookingNoteWriteAccess(data.project),
                          isDisabled: _this6.state.editingBooking,
                          setRef: _this6.setRefBookingNote,
                          token: _this6.props.token,
                          onExpand: _this6.handleBookingNotesExpand,
                          showExpand: !_this6.props.isMobile
                        }) : '',
                        /* APIs */
                        !bookingNotesModuleExpand ? _this6.renderAPISection(t, oriData, isEditing) : ''
                      ) : ''
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 16 },
                        _react2.default.createElement(_BookingPricingPackage2.default, {
                          availablePP: bookingPP,
                          data: oriData,
                          isEditing: isEditing,
                          onCheckRecalculate: _this6.handleRecalculatePackagePricing,
                          auth: _this6.props.auth,
                          globalSettings: globalSettings,
                          openModal: _this6.toggleActiveStates
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 16 },
                        _react2.default.createElement(_BookingFeePackage2.default, {
                          availablePackages: bookingFP,
                          data: oriData,
                          isEditing: isEditing,
                          onCheckRecalculate: _this6.handleRecalculatePackagePricing,
                          auth: _this6.props.auth,
                          openModal: _this6.toggleActiveStates
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 16 },
                        _react2.default.createElement(_SpecificationTable2.default, {
                          headerNode: t('Booking Specifications'),
                          editable: true,
                          type: 'bookings',
                          isEditing: isEditing,
                          hideButton: true,
                          data: data.specifications,
                          loading: _this6.state.loading,
                          onChange: _this6.handleBookingSpecificationChange
                        })
                      )
                    )
                  );
                }
              })
            )
          ),
          !this.showVNPaymentSection() && _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_BookingPayment2.default, {
                disabled: editingBooking,
                fetchNewBooking: this.props.fetchNewBooking,
                token: this.props.token,
                checkChanges: this.handleCheckChanges,
                resetChanges: this.handleResetCheck,
                updateBookingPayment: this.handleUpdatePayment,
                data: data,
                defaultBookingFeeAmount: data.project.defaultBookingFeeAmount
              })
            )
          ),
          data.bookingAttachments && data.bookingAttachments.length > 0 ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_BookingAttachment2.default, {
                onRef: function onRef(ref) {
                  _this6.bookingAttachment = ref;
                },
                data: data,
                onSubmit: function onSubmit(file) {
                  return _this6.getDocumentToken(function () {
                    return _this6.uploadAttachments(file);
                  });
                },
                onDelete: function onDelete(fileID) {
                  return _this6.getDocumentToken(function () {
                    return _this6.deleteAttachment(fileID);
                  });
                },
                isMobile: this.props.isMobile,
                uploadModalState: uploadModalState,
                loading: this.state.loading
              })
            )
          ) : ''
        )
      );
    }
  }]);

  return Info;
}(_react.Component);

Info.contextTypes = {
  store: _propTypes2.default.object
};
Info.propTypes = {
  token: _propTypes2.default.string,
  auth: _propTypes2.default.shape({
    isAdminBasic: _propTypes2.default.bool,
    isDeveloper: _propTypes2.default.bool,
    isDeveloperStaff: _propTypes2.default.bool,
    isBranchLeader: _propTypes2.default.bool,
    isBranchLeaderSupervisor: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isExternalAgentLeader: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    creditCheckAccess: _propTypes2.default.bool,
    allowEditUnitPrice: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool,
    companyBranch: _propTypes2.default.shape({
      isExternal: _propTypes2.default.bool
    }),
    company: _propTypes2.default.shape({
      service_company_id: _propTypes2.default.string,
      countryCode: _propTypes2.default.string
    })
  }),
  routeParamsID: _propTypes2.default.string,
  onCheck: _propTypes2.default.func,
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      noeticIsEnabled: _propTypes2.default.bool,
      lawyerIsEnabled: _propTypes2.default.bool,
      ifcaIsEnabled: _propTypes2.default.bool,
      insoftIsEnabled: _propTypes2.default.bool,
      ragicIsEnabled: _propTypes2.default.bool,
      creditControlIsEnabled: _propTypes2.default.bool,
      externalServiceIsEnabled: _propTypes2.default.bool,
      apieServiceIsEnabled: _propTypes2.default.bool,
      advelsoftIsEnabled: _propTypes2.default.bool,
      himsIsEnabled: _propTypes2.default.bool,
      isUem: _propTypes2.default.bool,
      settings: _propTypes2.default.shape({
        allowStaffEditBookingStatus: _propTypes2.default.bool,
        allowStaffEditBookingStatusCancel: _propTypes2.default.bool,
        bookingHideFirstTimeBuyer: _propTypes2.default.bool,
        disableSoldDateEditing: _propTypes2.default.bool,
        disableCancelledDateEditing: _propTypes2.default.bool
      })
    })
  }),
  fetchNewBooking: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  maUserAffiliateCompanyBranchName: _propTypes2.default.string,
  cancellationReasons: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  t: _propTypes2.default.func,
  refreshPage: _propTypes2.default.bool
};

Info.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig,
    cancellationReasons: state.cancellationReasons
  };
};

Info.defaultCustomerModal = {
  isOpen: false,
  header: '',
  headerIcon: 'warning sign',
  message: '',
  customerID: '',
  bookingCustomerID: '',
  bookingID: '',
  customerName: '',
  type: ''
};

Info.getPropsToState = function (props) {
  var loading = props.loading;
  var data = Object.assign({}, _booking2.default, props.data);
  var bookingPP = props.bookingPP;
  var bookingFP = props.bookingFP;
  var projectBookingCustomFields = props.projectBookingCustomFields || [];
  data.spaAmount = (0, _amount.spaFullNumber)(data) || data.spaValue; // decimal amount
  data.isCancelPending = true;
  data.isUserCooldown = true;
  if (!data.bankCases) {
    data.bankCases = [];
  } else if (data.bankCases && data.bankCases.length > 0) {
    var soldCases = data.bankCases.filter(function (bankCase) {
      return bankCase.status === 'success_li_issued';
    });
    if (soldCases && soldCases.length > 0) {
      data.selectedBankCaseID = soldCases[0].id;
      data.bankName = soldCases[0].bank.name;
      data.bankerName = soldCases[0].banker.preferredName;
      data.loanAmount = parseInt(soldCases[0].loanAmount, 10);
    }
  }
  if (data.pricePerSqm === 0) {
    if (data.systemPricePerSqm > 0) {
      data.pricePerSqm = data.systemPricePerSqm;
    } else {
      data.pricePerSqm = (0, _price.calculatePricePerSqm)(data.spaAmount, data.project, data.projectUnit);
    }
  }
  var errMessages = [];
  var modal = Object.assign({}, Info.defaultCustomerModal);
  var projectCurrencies = data.project.projectCurrency;
  var unitTiers = props.unitTiers || [];
  var globalSettings = {};
  var storeGlobalSettings = (0, _storage.getItem)(_config2.default.get('appName') + '.globalSettings');
  if (storeGlobalSettings) {
    try {
      globalSettings = JSON.parse(storeGlobalSettings).data || [];
    } catch (e) {
      Bugsnag.notifyException(e);
    }
  }
  if (globalSettings && globalSettings.defaultHoldDelistUnit && data.projectUnit) {
    data.projectUnit.delistOnHold = globalSettings.defaultHoldDelistUnit;
  }
  data.cuFollowPrevBookingDateIsEnabled = data.project.cuDefaultFollowPrevBookingDateIsEnabled;
  data.cuAttachmentsRequired = data.project.cuAttachmentsRequired;
  var changeProjectID = data.projectID || '';
  return {
    data: data,
    projectBookingCustomFields: projectBookingCustomFields,
    oriData: (0, _clone2.default)(data),
    loading: loading,
    errMessages: errMessages,
    modal: modal,
    projectCurrencies: projectCurrencies,
    uploadModalState: false,
    unitTiers: unitTiers,
    globalSettings: globalSettings,
    bookingPP: bookingPP,
    bookingFP: bookingFP,
    isBotSyncing: false,
    isHimsSyncing: false,
    changeProjectID: changeProjectID
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this7.setState({ loading: loading }, res);
    });
  };

  this.setBotSyncing = function () {
    var syncing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this7.setState({ isBotSyncing: syncing }, res);
    });
  };

  this.setHimsSyncing = function () {
    var syncing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this7.setState({ isHimsSyncing: syncing }, res);
    });
  };

  this.getColorText = function (status) {
    switch (status) {
      case 'new':
        return '#3DA0E4';
      case 'pending':
      case 'in_progress':
        return '#969CA4';
      case 'success':
        return '#24A476';
      case 'failed':
        return '#FF796E';
      default:
        return '#566573';
    }
  };

  this.setLoadingProject = function () {
    var loadingProject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this7.setState({ loadingProject: loadingProject }, res);
    });
  };

  this.setLoadingUnit = function () {
    var loadingUnit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this7.setState({ loadingUnit: loadingUnit }, res);
    });
  };

  this.setRefBookingNote = function (ref) {
    _this7.refBookingNote = ref;
  };

  this.getPaymentApprovedRequiredStatusIDs = function () {
    var oriData = _this7.state.oriData;

    var project = oriData && oriData.project || {};
    return project.paymentApprovedRequiredStatusIDs || [];
  };

  this.hasApprovedBookingPayment = function () {
    var data = _this7.state.data;

    var payments = data && data.bookingFeePayments || [];
    var relevant = payments.filter(function (p) {
      return p.status !== 'cancelled' && p.status !== 'deduction';
    });
    return relevant.length > 0 && relevant.every(function (p) {
      return p.status === 'paid';
    });
  };

  this.showVNPaymentSection = function () {
    return (0, _vietnam.isVietnamCompany)(_this7.props.auth);
  };

  this.isBookingStatusBlockedByPayment = function (statusID) {
    if (!statusID) return false;
    if (!_this7.getPaymentApprovedRequiredStatusIDs().includes(statusID)) return false;
    return !_this7.hasApprovedBookingPayment();
  };

  this.getBlockedBookingStatusLabels = function (statusIDs) {
    var t = _this7.props.t;

    return statusIDs.map(function (value) {
      var status = _bookingStatuses2.default.find(function (s) {
        return s.value === value;
      });
      return status ? t(status.text, { ns: _translation.TRANSLATION_FILES.constants }) : value;
    }).join(', ');
  };

  this.isSignatureRequiredForBooked = function () {
    var oriData = _this7.state.oriData;

    var project = oriData && oriData.project || {};
    return !!project.signatureRequiredForBooked;
  };

  this.hasPurchaserSignatureEvidence = function () {
    var data = _this7.state.data;
    var auth = _this7.props.auth;

    if (!data) return false;
    if (data.wetSignedAt) return true;
    if ((0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode)) return false;
    var bookingCustomers = data.bookingCustomers || [];
    // CPI-976 (M3): identify the primary purchaser on bookingCustomerID the way the server's gate
    // does; customerID is not re-synced when the primary is switched, so it is only a fallback.
    var primary = data.bookingCustomerID ? bookingCustomers.find(function (bc) {
      return bc.id === data.bookingCustomerID;
    }) : null;
    if (!primary) primary = bookingCustomers.find(function (bc) {
      return bc.customerID === data.customerID;
    });
    return !!(primary && primary.signAt);
  };

  this.isBookingStatusBlockedBySignature = function (statusID) {
    var oriData = _this7.state.oriData;

    if (statusID !== 'booked') return false;
    if (oriData && oriData.statusID === 'booked') return false;
    if (!_this7.isSignatureRequiredForBooked()) return false;
    return !_this7.hasPurchaserSignatureEvidence();
  };

  this.getBookingStatuses = function () {
    var auth = _this7.props.auth;
    var data = _this7.props.appConfig.data;

    var statuses = _bookingStatuses2.default;
    if (!(isPRS && auth.isSuperAdmin)) {
      statuses = statuses.map(function (t) {
        var status = t;
        // disabled expired if is not prs
        if (status.value === 'expired') {
          status.disabled = true;
        }
        return status;
      });
    }
    if (auth && auth.isDeveloperStaff && data && data.settings && !data.settings.allowStaffEditBookingStatusCancel) {
      statuses = statuses.map(function (t) {
        var status = t;
        // disabled cancel status
        if (status.value === 'cancelled_developer') {
          status.disabled = true;
        }
        return status;
      });
    }
    // Disabled: no place to enter a payment on a Vietnamese Sales Overview since CPI-974; re-enable when the payment section returns.
    // // CPI-974 item 18: block the project's marked statuses; new objects, the constant is shared.
    // const paymentApprovedRequiredStatusIDs = this.getPaymentApprovedRequiredStatusIDs();
    // if (paymentApprovedRequiredStatusIDs.length > 0 && !this.hasApprovedBookingPayment()) {
    //   statuses = statuses.map(s => (
    //     paymentApprovedRequiredStatusIDs.includes(s.value) ? { ...s, disabled: true } : s
    //   ));
    // }
    // CPI-976: disable Booked while the project requires a purchaser signature and none is on file.
    if (_this7.isBookingStatusBlockedBySignature('booked')) {
      statuses = statuses.map(function (s) {
        return s.value === 'booked' ? _extends({}, s, { disabled: true }) : s;
      });
    }
    return statuses;
  };

  this.getDataAttributes = function (daname, davalue, datarget) {
    var _ref26;

    var newDavalue = davalue;
    if (newDavalue === '') newDavalue = 'NULL';
    if (newDavalue === 'Not Applicable') newDavalue = 'N/A';
    var datasetName = 'data-bot-' + daname;
    return _ref26 = {}, _defineProperty(_ref26, datasetName, newDavalue), _defineProperty(_ref26, 'data-bot-target', datarget), _ref26;
  };

  this.getSelectedStaffValue = function () {
    var data = _this7.state.data;

    var selectedStaffValue = {
      key: data.assignedMaUserID.toString() || 0,
      title: data.assignedMaName || '',
      price: data.assignedMaPreferredName || ''
    };
    return selectedStaffValue;
  };

  this.getSelectedCreatorValue = function () {
    var data = _this7.state.data;

    var SelectedCreatorValue = {
      key: data.maUserID.toString() || 0,
      title: data.maCreatedByPreferredName || '',
      price: ''
    };
    return SelectedCreatorValue;
  };

  this.getSelectedBank = function () {
    var data = _this7.state.data;

    var selectedBank = '';
    if (data.selectedBankCaseID && data.selectedBankCaseID !== 0) {
      var idx = data.bankCases.findIndex(function (bc) {
        return bc.id === data.selectedBankCaseID;
      });
      selectedBank = data.bankCases[idx].bank.name;
    } else {
      selectedBank = data.bankName;
    }
    return selectedBank;
  };

  this.getSuccessBankCase = function (data) {
    if (data.bankCases.length > 0) {
      var soldCase = data.bankCases.find(function (bankCase) {
        return bankCase.status === 'success_li_issued';
      });
      if (soldCase) {
        return soldCase;
      }
    }
    return null;
  };

  this.canEditConversionDetails = function () {
    var data = _this7.state.data;
    var auth = _this7.props.auth;
    // Check if the project has the toggle enabled

    if (!data.project || !data.project.allowEditConversionDetailsIsEnabled) {
      return false;
    }
    // Check if user is HQ or Supervisor
    return auth.isHeadquarters || auth.isBranchLeaderSupervisor;
  };

  this.getPercentageOptions = function () {
    var options = [];
    for (var i = 100; i >= 0; i -= 1) {
      options = [].concat(_toConsumableArray(options), [{
        key: i,
        value: i,
        text: i + '%'
      }]);
    }
    return options;
  };

  this.handleLoanMarginChange = function (e, d) {
    var data = _this7.state.data;

    if (d.name === 'loanMargin') {
      var loanMargin = _lodash2.default.toNumber(d.value);
      data.loanAmount = Math.floor(loanMargin / 100 * data.spaValue);
      _this7.setState({ data: data }, function () {
        _this7.handleCheckChanges('bookingChanges');
      });
    }
  };

  this.handleLoanAmountChange = function (e, d) {
    var data = _this7.state.data;

    if (d.name === 'loanAmount') {
      var amount = 0;
      if (d.value !== '') {
        amount = parseInt(d.value, 10);
      }
      data.loanAmount = amount;
      _this7.setState({ data: data }, function () {
        _this7.handleCheckChanges('bookingChanges');
      });
    }
  };

  this.disablePricingEditAfterSold = function (data) {
    return data && data.statusID === 'sold_spa_signed' && data.project && !data.project.allowPricingEditAfterSold;
  };

  this.syncToHimsAPI = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
    var store, t, errorHeader, message;
    return regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) {
        switch (_context20.prev = _context20.next) {
          case 0:
            _context20.next = 2;
            return _this7.setHimsSyncing(true);

          case 2:
            store = _this7.context.store;
            t = _this7.props.t;
            _context20.prev = 4;
            _context20.next = 7;
            return store.dispatch((0, _fetchM.fetchM)('/bookings/' + _this7.state.data.id + '/hims/sync/', {
              credentials: 'include',
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                'X-Csrf-Token': _this7.props.token
              }
            }));

          case 7:
            _context20.next = 23;
            break;

          case 9:
            _context20.prev = 9;
            _context20.t0 = _context20['catch'](4);
            _context20.next = 13;
            return _this7.setHimsSyncing(false);

          case 13:
            errorHeader = 'Sync failed';

            if (!(_context20.t0.res && _context20.t0.res.status >= 400 && _context20.t0.res.status < 500)) {
              _context20.next = 20;
              break;
            }

            _context20.next = 17;
            return _context20.t0.res.text();

          case 17:
            message = _context20.sent;

            store.dispatch((0, _flash.flashErrorMessage)({ header: errorHeader, message: 'HIMS sync failed. ' + message }));
            return _context20.abrupt('return');

          case 20:
            Bugsnag.notifyException(_context20.t0);
            store.dispatch((0, _flash.flashErrorMessage)({ header: errorHeader, message: t('An error occurred. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
            return _context20.abrupt('return');

          case 23:
            _context20.next = 25;
            return _this7.setHimsSyncing(false);

          case 25:
            store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + _this7.state.data.id + '/'));
            store.dispatch((0, _flash.flashSuccessMessage)({ message: 'HIMS sync successfully triggered' }));

          case 27:
          case 'end':
            return _context20.stop();
        }
      }
    }, _callee20, _this7, [[4, 9]]);
  }));
  this.resyncHimsAPI = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
    var store, t, res, errorHeader, message, newBookingData;
    return regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) {
        switch (_context21.prev = _context21.next) {
          case 0:
            _context21.next = 2;
            return _this7.setHimsSyncing(true);

          case 2:
            store = _this7.context.store;
            t = _this7.props.t;
            res = void 0;
            _context21.prev = 5;
            _context21.next = 8;
            return store.dispatch((0, _fetchM.fetchM)('/bookings/' + _this7.state.data.id + '/hims/sync/retry/', {
              credentials: 'include',
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                'X-Csrf-Token': _this7.props.token
              }
            }));

          case 8:
            res = _context21.sent;
            _context21.next = 25;
            break;

          case 11:
            _context21.prev = 11;
            _context21.t0 = _context21['catch'](5);
            _context21.next = 15;
            return _this7.setHimsSyncing(false);

          case 15:
            errorHeader = 'Re-sync failed';

            if (!(_context21.t0.res && _context21.t0.res.status >= 400 && _context21.t0.res.status < 500)) {
              _context21.next = 22;
              break;
            }

            _context21.next = 19;
            return _context21.t0.res.text();

          case 19:
            message = _context21.sent;

            store.dispatch((0, _flash.flashErrorMessage)({ header: errorHeader, message: 'HIMS re-sync failed. ' + message }));
            return _context21.abrupt('return');

          case 22:
            Bugsnag.notifyException(_context21.t0);
            store.dispatch((0, _flash.flashErrorMessage)({ header: errorHeader, message: t('An error occurred. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
            return _context21.abrupt('return');

          case 25:
            _context21.next = 27;
            return _this7.setHimsSyncing(false);

          case 27:
            store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + _this7.state.data.id + '/'));

            _context21.next = 30;
            return res.json();

          case 30:
            newBookingData = _context21.sent;

            if (!(newBookingData.himsServiceErrors && newBookingData.himsServiceErrors.length > 0)) {
              _context21.next = 34;
              break;
            }

            store.dispatch((0, _flash.flashErrorMessage)({ header: 'Sync failed', message: 'HIMS sync failed. Please check the error logs.' }));
            return _context21.abrupt('return');

          case 34:
            store.dispatch((0, _flash.flashSuccessMessage)({ message: 'HIMS re-sync successfully triggered' }));

          case 35:
          case 'end':
            return _context21.stop();
        }
      }
    }, _callee21, _this7, [[5, 11]]);
  }));

  this.getTierPricingValue = function () {
    var data = _this7.state.data;

    var priceTierData = _this7.optionsTierPricings().find(function (d) {
      return d.description === data.nettSellingPrice.toString();
    });
    if (priceTierData) return priceTierData.value;
    return data.spaAmount;
  };

  this.setPricePerSqm = function (b) {
    var data = b;
    if (data.systemPricePerSqm === 0) {
      data.systemPricePerSqm = (0, _price.calculatePricePerSqm)(data.spaAmount, data.project, data.projectUnit);
    }
    // if same with system, reset to 0
    if (data.pricePerSqm === data.systemPricePerSqm) {
      data.pricePerSqm = 0;
    }
    // reset system to 0
    data.systemPricePerSqm = 0;
    data.pricePerSqm = parseFloat(data.pricePerSqm);
    return data;
  };

  this.handleUploadSecureDocuments = function () {
    var _ref29 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(bookingID, uploadFiles, uploadCount) {
      var documentType, uploadPath, files, missingFilesCount, i, file, uploadSingleFile, firstAttempt, retryFiles, secondAttempt, secondAttemptFailedCount, total, failed, uploaded;
      return regeneratorRuntime.wrap(function _callee22$(_context22) {
        while (1) {
          switch (_context22.prev = _context22.next) {
            case 0:
              if (!(!uploadFiles || !uploadCount || uploadCount < 1)) {
                _context22.next = 2;
                break;
              }

              return _context22.abrupt('return', {
                total: 0,
                uploaded: 0,
                failed: 0
              });

            case 2:
              documentType = 'other_documents';
              uploadPath = 'showroom/bookings/' + bookingID;
              files = [];
              missingFilesCount = 0;


              for (i = 0; i < uploadCount; i += 1) {
                file = uploadFiles.get('files_' + i);

                if (file && file.name) {
                  files.push(file);
                } else {
                  missingFilesCount += 1;
                }
              }

              uploadSingleFile = function uploadSingleFile(file) {
                return _secureDocumentsClient.sdsClient.uploadDocument({
                  path: _securedocumentsSdkJs.utilities.buildFolderDocumentPath(uploadPath, file.name),
                  content: file,
                  documentType: documentType
                });
              };

              // First attempt


              _context22.next = 10;
              return Promise.allSettled(files.map(function (file) {
                return uploadSingleFile(file);
              }));

            case 10:
              firstAttempt = _context22.sent;
              retryFiles = files.filter(function (file, index) {
                return firstAttempt[index].status === 'rejected' && file;
              });

              // Retry failed uploads once for transient network/storage failures

              _context22.next = 14;
              return Promise.allSettled(retryFiles.map(function (file) {
                return uploadSingleFile(file);
              }));

            case 14:
              secondAttempt = _context22.sent;
              secondAttemptFailedCount = secondAttempt.filter(function (res) {
                return res.status === 'rejected';
              }).length;
              total = uploadCount;
              failed = missingFilesCount + secondAttemptFailedCount;
              uploaded = Math.max(total - failed, 0);
              return _context22.abrupt('return', {
                total: total,
                uploaded: uploaded,
                failed: failed
              });

            case 20:
            case 'end':
              return _context22.stop();
          }
        }
      }, _callee22, _this7);
    }));

    return function (_x33, _x34, _x35) {
      return _ref29.apply(this, arguments);
    };
  }();

  this.callRefreshBookingNote = function () {
    if (_this7.refBookingNote) {
      _this7.refBookingNote.handleForceRefresh(true);
    }
  };

  this.fetchMarketplaceUserDetails = function () {
    var _ref30 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23(userID) {
      var store, t, url, response;
      return regeneratorRuntime.wrap(function _callee23$(_context23) {
        while (1) {
          switch (_context23.prev = _context23.next) {
            case 0:
              store = _this7.context.store;
              t = _this7.props.t;
              url = '/marketplace/staffs/' + userID + '/';
              _context23.prev = 3;
              _context23.next = 6;
              return _this7.setMPUserLoading(true);

            case 6:
              _context23.next = 8;
              return (0, _fetchM.serverRequestGet)(url, store);

            case 8:
              response = _context23.sent;

              if (!response.error) {
                _context23.next = 13;
                break;
              }

              _context23.next = 12;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: response.message }));

            case 12:
              return _context23.abrupt('return');

            case 13:
              _context23.next = 15;
              return _this7.setState({ mpUserDetails: response.data });

            case 15:
              _context23.next = 17;
              return _this7.setMPUserLoading(false);

            case 17:
              _context23.next = 26;
              break;

            case 19:
              _context23.prev = 19;
              _context23.t0 = _context23['catch'](3);

              Bugsnag.notifyException(_context23.t0);
              _context23.next = 24;
              return _this7.setMPUserLoading(false);

            case 24:
              _context23.next = 26;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

            case 26:
            case 'end':
              return _context23.stop();
          }
        }
      }, _callee23, _this7, [[3, 19]]);
    }));

    return function (_x36) {
      return _ref30.apply(this, arguments);
    };
  }();

  this.toggleActiveStates = function (name, s) {
    return _this7.setState(function (prev) {
      return _defineProperty({}, name, s !== undefined ? s : !prev[name]);
    });
  };

  this.bcfPRefix = function (v) {
    return 'bcf_' + v;
  };

  this.isCustomFieldRequiredAtStatus = function (field, statusID) {
    // Only applies to booking custom fields
    if (!field.isRequired) {
      return false;
    }

    // For DEFAULT fields (purchaser fields), always use isRequired directly
    // Status-based logic only applies to custom booking fields
    if (field.isDefault) {
      return field.isRequired;
    }

    var currentStatus = statusID || 'reserved';
    var requiredAtStatus = field.requiredAtStatus || 'reserved';

    // Define status hierarchy: reserved < booked < sold_spa_signed
    var statusHierarchy = {
      'reserved': 1,
      'booked': 2,
      'sold_spa_signed': 3
    };

    var currentLevel = statusHierarchy[currentStatus];
    var requiredLevel = statusHierarchy[requiredAtStatus];

    if (!currentLevel || !requiredLevel) {
      return false;
    }

    return currentLevel >= requiredLevel;
  };

  this.hasMPDetailsAccess = function () {
    var auth = _this7.props.auth;

    return auth.isHeadquarters || auth.isBranchLeaderSupervisor;
  };

  this.hasAccessChangeUnit = function () {
    var auth = _this7.props.auth;
    var oriData = _this7.state.oriData;

    var cuRoleAccesses = oriData && oriData.project && oriData.project.cuRoleAccesses ? oriData.project.cuRoleAccesses : [];
    if (auth.isAdmin || auth.isHeadquarters || auth.isBranchLeader) return true;
    if (cuRoleAccesses.includes(_changeUnitsAccesses.CU_STAFF_ACCESS) && auth.isDeveloperStaff) return true;
    if (cuRoleAccesses.includes(_changeUnitsAccesses.CU_EXTERNAL_STAFF_ACCESS) && auth.isDeveloper && auth.companyBranch && auth.companyBranch.isExternal) {
      if (oriData.project.cuAllowExternalReserved && oriData.statusID === 'reserved') {
        return true;
      }
      if (oriData.project.cuAllowExternalBooked && oriData.statusID === 'booked') {
        return true;
      }
    }
    return false;
  };

  this.hasAccessSourceOfFinance = function () {
    var auth = _this7.props.auth;
    var data = _this7.state.data;

    if (!(0, _vietnam.isVietnamCompany)(auth)) return true;
    if (_this7.hasAccess(false, true, true, true, true)) return true;
    return (0, _vietnam.canEditSourceOfFinance)(auth, data && data.project);
  };

  this.handleOnCheck = function (callback) {
    if (_this7.props.onCheck) {
      var hasChanges = _this7.state.bookingChanges || _this7.state.paymentChanges || _this7.state.isBookingPaymentChanged || _this7.state.isBookingFeePaymentChanged;
      _this7.props.onCheck(hasChanges, callback);
    }
  };

  this.handleCheckChanges = function (value, callback) {
    var state = _this7.state;
    if (state[value] === false) {
      state[value] = true;
      _this7.setState(_defineProperty({}, value, state[value]), function () {
        _this7.handleOnCheck(callback);
      });
    }
  };

  this.handleResetCheck = function (value, callback) {
    var state = _this7.state;
    if (state[value] === true) {
      state[value] = false;
      _this7.setState(_defineProperty({}, value, state[value]), function () {
        _this7.handleOnCheck(callback);
      });
    }
  };

  this.handleResetPricePerSqm = function () {
    var data = _this7.state.data;

    if (data.systemPricePerSqm > 0) {
      data.pricePerSqm = data.systemPricePerSqm;
    } else {
      data.pricePerSqm = (0, _price.calculatePricePerSqm)(data.spaAmount, data.project, data.projectUnit);
    }
    _this7.setState({ data: data }, function () {
      _this7.handleCheckChanges('bookingChanges');
    });
  };

  this.handleBookingChange = function (event, value) {
    var data = _this7.state.data;

    data[value.name] = value.value;
    _this7.setState({ data: data }, function () {
      _this7.handleCheckChanges('bookingChanges');
    });
  };

  this.handleTierPricingChange = function (e, v) {
    var _state5 = _this7.state,
        data = _state5.data,
        unitTiers = _state5.unitTiers;

    var priceTier = _this7.optionsTierPricings().find(function (d) {
      return d.value === v.value;
    });
    if (priceTier) {
      data.spaAmount = (0, _amount.amountToFixed)(parseFloat(priceTier.description), data.projectUnit.spaTimes);
      data.nettSellingPrice = priceTier.description;
      if (unitTiers) {
        var priceTierData = unitTiers.find(function (d) {
          return d.projectPricingID === priceTier.value;
        });
        if (priceTierData && priceTierData.projectPricing) {
          data.tierPricingName = priceTierData.projectPricing.name;
          data.tierPricingDescription = priceTierData.projectPricing.description;
        } else {
          data.tierPricingName = 'Base';
          data.tierPricingDescription = 'Base Selling Price: ' + v.value;
        }
      }
    }
    _this7.setState({ data: data }, function () {
      _this7.handleCheckChanges('bookingChanges');
    });
  };

  this.handleBookingSpecificationChange = function (specifications) {
    var data = _this7.state.data;

    data.specifications = specifications;
    _this7.setState({ data: data }, function () {
      _this7.handleCheckChanges('bookingChanges');
    });
  };

  this.handleBookingAmountChange = function (event, value) {
    if ((0, _isNumber.isNumeric)(value.value) || value.value === '') {
      var data = _this7.state.data;

      data[value.name] = value.value;
      _this7.setState({ data: data }, function () {
        _this7.handleCheckChanges('bookingChanges');
      });
    }
  };

  this.handleUpdateBooking = function () {
    var _state6 = _this7.state,
        data = _state6.data,
        oriData = _state6.oriData,
        projectBookingCustomFields = _state6.projectBookingCustomFields;

    _this7.setState({
      approvedDatePickerVisible: false,
      cancelledDatePickerVisible: false,
      soldDatePickVisible: false,
      spaSigningDatePickerVisible: false,
      spaStampingDatePickerVisible: false
    });
    if (data.maUserID === 0) {
      data.maCreatedByName = oriData.maCreatedByName;
      data.maCreatedByEmail = oriData.maCreatedByEmail;
      data.maCreatedByPreferredName = oriData.maCreatedByPreferredName;
      data.maUserAffiliateCompanyBranchShortName = oriData.maUserAffiliateCompanyBranchShortName;
      data.maUserAffiliateCompanyBranchID = oriData.maUserAffiliateCompanyBranchID;
      data.maUserAffiliateCompanyID = oriData.maUserAffiliateCompanyID;
      data.maUserAffiliateID = oriData.maUserAffiliateID;
      data.maUserID = oriData.maUserID;
      _this7.setState({ data: data });
    }
    var bookingCustomFields = [];
    if (data.bookingCustomFields) {
      data.bookingCustomFields.forEach(function (d) {
        var customField = {
          id: d.id,
          value: data[_this7.bcfPRefix(d.projectBookingCustomField.name)],
          projectBookingCustomFieldID: d.projectBookingCustomFieldID,
          projectBookingCustomFieldOptionID: data[_this7.bcfPRefix(d.projectBookingCustomField.name) + 'OptionID'],
          projectBookingCustomFieldOptionIDs: data[_this7.bcfPRefix(d.projectBookingCustomField.name) + 'OptionIDs']
        };
        bookingCustomFields.push(customField);
      });
    }
    if (projectBookingCustomFields) {
      projectBookingCustomFields.filter(function (bcf) {
        return _defaultBookingFields.DEFAULT_BOOKING_FIELD_LIST.every(function (pf) {
          return bcf.name !== pf.name;
        });
      }).forEach(function (d) {
        var exists = -1;
        if (data.bookingCustomFields) exists = data.bookingCustomFields.findIndex(function (bcfData) {
          return bcfData.projectBookingCustomField.id === d.id;
        });
        if (exists === -1) {
          var customField = {
            value: data[_this7.bcfPRefix(d.name)],
            projectBookingCustomFieldID: d.id,
            projectBookingCustomFieldOptionID: data[_this7.bcfPRefix(d.name) + 'OptionID'],
            projectBookingCustomFieldOptionIDs: data[_this7.bcfPRefix(d.name) + 'OptionIDs']
          };
          bookingCustomFields.push(customField);
        }
      });
    }
    var newData = _this7.setPricePerSqm(data);
    var booking = {
      bookingCustomFields: bookingCustomFields,
      paymentMethodID: data.paymentMethodID,
      spaValue: parseInt(data.spaAmount, 10),
      nettSellingPrice: parseFloat(data.nettSellingPrice),
      newBookingNoteEncoded: data.newBookingNoteEncoded,
      remarkInternal: data.remarkInternal,
      assignedMaName: data.assignedMaName,
      assignedMaPreferredName: data.assignedMaPreferredName,
      assignedMaUserID: data.assignedMaUserID,
      tierPricingName: data.tierPricingName,
      tierPricingDescription: data.tierPricingDescription,
      maCreatedByName: data.maCreatedByName,
      maCreatedByEmail: data.maCreatedByEmail,
      maCreatedByPreferredName: data.maCreatedByPreferredName,
      maUserAffiliateCompanyBranchShortName: data.maUserAffiliateCompanyBranchShortName,
      maUserAffiliateCompanyBranchID: data.maUserAffiliateCompanyBranchID,
      maUserAffiliateCompanyID: data.maUserAffiliateCompanyID,
      maUserAffiliateID: data.maUserAffiliateID,
      maUserID: data.maUserID,
      specifications: data.specifications,
      forceRecalculatePackagePricing: data.forceRecalculatePackagePricing,
      srpLoan: data.srpLoan,
      firstTimeBuyer: data.firstTimeBuyer,
      approvedAt: data.approvedAt,
      cancelledAt: data.cancelledAt,
      lastSoldAt: data.lastSoldAt,
      spaSigningDate: data.spaSigningDate,
      spaStampingDate: data.spaStampingDate,
      cancellationReasonID: data.cancellationReasonID,
      pricePerSqm: newData.pricePerSqm,
      updatedAt: data.updatedAt,
      bankName: data.bankName,
      bankerName: data.bankerName,
      loanAmount: parseInt(data.loanAmount, 10) || 0
    };
    booking = (0, _amount.fullToAmount)(booking, data.spaAmount); // decimal amount
    if (booking.paymentMethodID !== oriData.paymentMethodID || booking.spaAmount !== oriData.spaAmount || booking.tierPricingName !== oriData.tierPricingName || booking.tierPricingDescription !== oriData.tierPricingDescription || booking.nettSellingPrice !== oriData.nettSellingPrice || booking.remarkInternal !== oriData.remarkInternal || booking.assignedMaName !== oriData.assignedMaName || booking.assignedMaPreferredName !== oriData.assignedMaPreferredName || booking.assignedMaUserID !== oriData.assignedMaUserID || booking.maCreatedByPreferredName !== oriData.maCreatedByPreferredName || booking.maUserAffiliateCompanyBranchShortName !== oriData.maUserAffiliateCompanyBranchShortName || booking.maUserAffiliateCompanyBranchID !== oriData.maUserAffiliateCompanyBranchID || booking.maUserAffiliateCompanyID !== oriData.maUserAffiliateCompanyID || booking.maUserAffiliateID !== oriData.maUserAffiliateID || booking.maUserID !== oriData.maUserID || booking.bankName !== oriData.bankName || booking.bankerName !== oriData.bankerName || booking.loanAmount !== oriData.loanAmount || booking.approvedAt !== oriData.approvedAt || booking.cancelledAt !== oriData.cancelledAt || booking.lastSoldAt !== oriData.lastSoldAt || booking.spaSigningDate !== oriData.spaSigningDate || booking.spaStampingDate !== oriData.spaStampingDate || booking.cancellationReasonID !== oriData.cancellationReasonID || !_this7.checkJSONStringifyMatch(booking.specifications, oriData.specifications) || _this7.checkCustomFieldsChanged(data.bookingCustomFields, projectBookingCustomFields, data)) {
      _this7.updateBooking(booking, 'update');
    } else {
      _this7.setState({ editingBooking: false });
    }
  };

  this.handleEditBooking = function () {
    _this7.setState({ editingBooking: true, showCustomFields: true });
  };

  this.handleResetBooking = function () {
    var _state7 = _this7.state,
        data = _state7.data,
        oriData = _state7.oriData;

    var editingBooking = false;
    var showChangeUnit = false;
    data.spaAmount = oriData.spaAmount;
    data.spaValue = oriData.spaValue;
    data.spaDecimal = oriData.spaDecimal;
    data.spaFull = oriData.spaFull;
    data.spaTimes = oriData.spaTimes;
    data.nettSellingPrice = parseInt(oriData.nettSellingPrice, 10);
    data.paymentMethodID = oriData.paymentMethodID;
    data.statusID = oriData.statusID;
    data.cancellationReasonID = oriData.cancellationReasonID;
    data.pricePerSqm = oriData.pricePerSqm;
    data.approvedAt = oriData.approvedAt;
    data.cancelledAt = oriData.cancelledAt;
    data.lastSoldAt = oriData.lastSoldAt;
    data.spaSigningDate = oriData.spaSigningDate;
    data.spaStampingDate = oriData.spaStampingDate;
    data.bankName = oriData.bankName;
    data.bankerName = oriData.bankerName;
    data.loanAmount = oriData.loanAmount;
    _this7.setState({ data: data, editingBooking: editingBooking, showChangeUnit: showChangeUnit }, function () {
      _this7.handleResetCheck('bookingChanges');
    });
  };

  this.handleUpdatePayment = function (payment) {
    _this7.updateBooking(payment, 'payment');
  };

  this.handleSalesSign = function (e) {
    e.preventDefault();
    _this7.setState({ isSalesPersonSignature: true, showSignModal: true });
  };

  this.handleOnCancel = function (e) {
    e.preventDefault();
    _this7.signatureModal.handleOnCancel();
    _this7.setState({
      isSalesPersonSignature: false,
      showSignModal: false
    });
  };

  this.isBookingStatusDisabled = function () {
    var bookingData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var statusID = bookingData.statusID,
        project = bookingData.project;

    var auth = _this7.props.auth;
    var data = _this7.props.appConfig.data;

    return !auth.isSuperAdmin && statusID === 'expired' || data.creditControlIsEnabled && !project.creditControlIsUnlinked && statusID === 'sold_spa_signed';
  };

  this.isBookingStatusUpdateBlocked = function () {
    var bookingData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var statusID = bookingData.statusID,
        project = bookingData.project;
    var data = _this7.props.appConfig.data;

    return data.creditControlIsEnabled && !project.creditControlIsUnlinked && statusID === 'sold_spa_signed';
  };

  this.saveSignature = function () {
    var _ref32 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(event) {
      var store, t, salesPersonSignature;
      return regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              event.preventDefault();
              store = _this7.context.store;
              t = _this7.props.t;

              if (!_this7.signatureModal.isEmpty()) {
                _context24.next = 6;
                break;
              }

              store.dispatch((0, _flash.flashErrorMessage)({ header: t('Error', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Please sign the consent', { ns: _translation.TRANSLATION_FILES.translation }) }));
              return _context24.abrupt('return');

            case 6:
              salesPersonSignature = _this7.signatureModal.signData().replace(/^data:image\/(png|jpg);base64,/, '');

              _this7.updateSalesPersonSignature(salesPersonSignature);

            case 8:
            case 'end':
              return _context24.stop();
          }
        }
      }, _callee24, _this7);
    }));

    return function (_x39) {
      return _ref32.apply(this, arguments);
    };
  }();

  this.handleStaffClear = function () {
    var data = _this7.state.data;

    data.assignedMaName = '';
    data.assignedMaPreferredName = '';
    data.assignedMaUserID = 0;
    _this7.setState({ data: data }, function () {
      _this7.handleCheckChanges('bookingChanges');
    });
  };

  this.handleStaffSelect = function (value) {
    var data = _this7.state.data;

    data.assignedMaName = value.title;
    data.assignedMaPreferredName = value.price;
    data.assignedMaUserID = value.key;
    _this7.setState({ data: data }, function () {
      _this7.handleCheckChanges('bookingChanges');
    });
  };

  this.handleUserClear = function () {
    var data = _this7.state.data;

    data.maCreatedByPreferredName = '';
    data.maCreatedByName = '';
    data.maCreatedByEmail = '';
    data.maUserID = 0;
    data.maUserAffiliateCompanyBranchShortName = '';
    data.maUserAffiliateCompanyBranchID = 0;
    data.maUserAffiliateCompanyID = 0;
    data.maUserAffiliateID = 0;
    _this7.setState({ data: data, searchUserValue: '' }, function () {
      _this7.handleCheckChanges('bookingChanges');
    });
  };

  this.handleUserSelect = function (value) {
    var _state8 = _this7.state,
        data = _state8.data,
        searchUsersData = _state8.searchUsersData;

    var selectedUser = searchUsersData.find(function (d) {
      return d.email === value.description;
    });
    if (selectedUser && selectedUser.name !== '' && selectedUser.preferredName !== '' && selectedUser.companyBranchShortName !== '' && selectedUser.companyBranchID > 0 && selectedUser.companyID > 0 && selectedUser.affiliateID > 0 && selectedUser.id > 0) {
      data.maCreatedByName = selectedUser.name;
      data.maCreatedByEmail = selectedUser.email;
      data.maCreatedByPreferredName = selectedUser.preferredName;
      data.maUserAffiliateCompanyBranchShortName = selectedUser.companyBranchShortName;
      data.maUserAffiliateCompanyBranchID = selectedUser.companyBranchID;
      data.maUserAffiliateCompanyID = selectedUser.companyID;
      data.maUserAffiliateID = selectedUser.affiliateID;
      data.maUserID = selectedUser.id;
      _this7.setState({ data: data }, function () {
        _this7.handleCheckChanges('bookingChanges');
      });
    }
  };

  this.handleUserfetch = function (data, searchUserValue) {
    _this7.setState({ searchUsersData: data, searchUserValue: searchUserValue });
  };

  this.handleBookingStatusChange = function (event, value) {
    var _state9 = _this7.state,
        data = _state9.data,
        oriData = _state9.oriData,
        projectBookingCustomFields = _state9.projectBookingCustomFields;
    var t = _this7.props.t;

    var newStatusID = value.value;

    if (projectBookingCustomFields && projectBookingCustomFields.length > 0) {
      var missingFields = [];

      projectBookingCustomFields.forEach(function (field) {
        // Status-based validation only applies to custom fields
        if (field.isDefault) {
          return;
        }

        if (_this7.isCustomFieldRequiredAtStatus(field, newStatusID)) {
          var fieldValue = data[_this7.bcfPRefix(field.name)];
          if (!fieldValue || fieldValue === '' || Array.isArray(fieldValue) && fieldValue.length === 0) {
            missingFields.push(field.label);
          }
        }
      });

      if (missingFields.length > 0) {
        var store = _this7.context.store;

        var fieldList = missingFields.join(', ');
        store.dispatch((0, _flash.flashErrorMessage)({
          header: t('Required Fields Missing', { ns: _translation.TRANSLATION_FILES.translation }),
          message: t('Please fill in all required fields before changing status: {{fields}}', { fields: fieldList, ns: _translation.TRANSLATION_FILES.translation })
        }));
        return;
      }
    }

    // Disabled: no place to enter a payment on a Vietnamese Sales Overview since CPI-974; re-enable when the payment section returns.
    // // CPI-974 item 18: refuse the transition; the API's UpdateBooking is the authoritative reject.
    // if (this.isBookingStatusBlockedByPayment(value.value)) {
    //   const { store } = this.context;
    //   store.dispatch(flashErrorMessage({
    //     message: t('Payment must be approved before changing the status to {{statuses}}', {
    //       statuses: this.getBlockedBookingStatusLabels([value.value]),
    //       ns: TRANSLATION_FILES.translation,
    //     }),
    //   }));
    //   return;
    // }
    // CPI-976: refuse Booked while the signature is missing; evaluated after the payment gate.
    if (_this7.isBookingStatusBlockedBySignature(value.value)) {
      var _store = _this7.context.store;

      _store.dispatch((0, _flash.flashErrorMessage)({
        message: t('The purchaser must sign the sales form before the status can change to Booked', { ns: _translation.TRANSLATION_FILES.translation })
      }));
      return;
    }
    var _oriData$project = oriData.project,
        requireValidTinAtBookingAndSold = _oriData$project.requireValidTinAtBookingAndSold,
        requireValidTinAtSold = _oriData$project.requireValidTinAtSold,
        tinSettingBookingStartAt = _oriData$project.tinSettingBookingStartAt;

    var shouldCheckAllCustomersTIN = (newStatusID === 'sold_spa_signed' && (requireValidTinAtBookingAndSold || requireValidTinAtSold) || newStatusID === 'booked' && requireValidTinAtBookingAndSold) && (tinSettingBookingStartAt === null || new Date(data.createdAt) >= new Date(tinSettingBookingStartAt));
    if (shouldCheckAllCustomersTIN) {
      // skip passport purchaser
      var allTINValidated = data.bookingCustomers.every(function (bc) {
        return bc.customer.identityTypeID === 2 || bc.customer.taxTinValidationStatus === 'success';
      });
      if (!allTINValidated) {
        // show warning
        var newBookingStatusText = _bookingStatuses2.default.find(function (status) {
          return status.value === newStatusID;
        }).text || '';
        _this7.setState({ data: data, tinInvalidModal: true, newBookingStatus: newBookingStatusText });
        return;
      }
    }

    data[value.name] = value.value;
    if (data[value.name] !== oriData[value.name]) {
      _this7.setState({ data: data, bookingStatusModal: true });
    }
  };

  this.handleNotesChange = function (bnEncoded) {
    var data = _this7.state.data;

    data.newBookingNoteEncoded = bnEncoded;
    data.remarkInternal = '';
    _this7.setState({ data: data });
  };

  this.handleNotesCheckboxChange = function (e, _ref33) {
    var name = _ref33.name,
        checked = _ref33.checked;
    var data = _this7.state.data;

    if (name === 'delistOnHold') {
      data.projectUnit[name] = checked;
    } else {
      data[name] = checked;
    }

    _this7.setState({ data: data });
  };

  this.handleConfirmBookingStatus = function () {
    var _ref34 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee25(e, d) {
      var _state10, data, pendingChangeUnitData, isUnitChange, store, t, b, res, message, newBooking, uploadResult, booking;

      return regeneratorRuntime.wrap(function _callee25$(_context25) {
        while (1) {
          switch (_context25.prev = _context25.next) {
            case 0:
              _state10 = _this7.state, data = _state10.data, pendingChangeUnitData = _state10.pendingChangeUnitData, isUnitChange = _state10.isUnitChange;
              store = _this7.context.store;
              t = _this7.props.t;

              // If this is a unit change, execute the change unit API first

              if (!(isUnitChange && pendingChangeUnitData)) {
                _context25.next = 43;
                break;
              }

              if (!_this7.unitChangeInFlight) {
                _context25.next = 6;
                break;
              }

              return _context25.abrupt('return');

            case 6:
              _this7.unitChangeInFlight = true;
              _context25.next = 9;
              return _this7.setLoading(true);

            case 9:
              b = {
                projectID: pendingChangeUnitData.projectID,
                projectUnitID: pendingChangeUnitData.projectUnitID,
                cuFollowPrevBookingDateIsEnabled: pendingChangeUnitData.cuFollowPrevBookingDateIsEnabled
              };
              res = '';
              _context25.prev = 11;
              _context25.next = 14;
              return store.dispatch((0, _fetchM.fetchM)('/bookings/' + _this7.state.data.id + '/unit/', {
                credentials: 'include',
                method: 'PUT',
                // CPI-1347: a refused change-unit is a business rule, not a page permission; show the
                // server's message in the catch below instead of leaving the booking for /forbidden/.
                ignoreForbidden: true,
                headers: {
                  'Content-Type': 'application/json',
                  'X-Csrf-Token': _this7.props.token
                },
                body: JSON.stringify(b)
              }));

            case 14:
              res = _context25.sent;
              _context25.next = 31;
              break;

            case 17:
              _context25.prev = 17;
              _context25.t0 = _context25['catch'](11);

              _this7.unitChangeInFlight = false;
              _context25.next = 22;
              return _this7.setLoading(false);

            case 22:
              if (!(_context25.t0.res && _context25.t0.res.status >= 400 && _context25.t0.res.status < 500)) {
                _context25.next = 28;
                break;
              }

              _context25.next = 25;
              return _context25.t0.res.text();

            case 25:
              message = _context25.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
              return _context25.abrupt('return');

            case 28:
              Bugsnag.notifyException(_context25.t0);
              store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
              return _context25.abrupt('return');

            case 31:
              _context25.next = 33;
              return res.json();

            case 33:
              newBooking = _context25.sent;


              // Upload attachments if any
              uploadResult = {
                total: 0,
                uploaded: 0,
                failed: 0
              };

              if (!(_config2.default.get('server') !== 'development' && pendingChangeUnitData.attachmentsUploadedCount > 0)) {
                _context25.next = 39;
                break;
              }

              _context25.next = 38;
              return _this7.handleUploadSecureDocuments(newBooking.id, pendingChangeUnitData.attachmentsUploaded, pendingChangeUnitData.attachmentsUploadedCount);

            case 38:
              uploadResult = _context25.sent;

            case 39:

              // Store new booking ID for cancellation
              data.newID = newBooking.id;

              _context25.next = 42;
              return _this7.setLoading(false);

            case 42:

              store.dispatch((0, _flash.flashSuccessMessage)({
                header: t('Unit Change Success', { ns: _translation.TRANSLATION_FILES.translation }),
                message: t('Booking {{code}} successfully created via Unit Change', { code: newBooking.code, ns: _translation.TRANSLATION_FILES.translation })
              }));

              // TODO: do we need to display this message?
              // if (uploadResult.total > 0 && uploadResult.failed > 0) {
              //   store.dispatch(flashErrorMessage({
              //     header: t('Attachment Upload Incomplete', { ns: TRANSLATION_FILES.translation }),
              //     message: t('{{uploaded}}/{{total}} attachment(s) uploaded. Please retry upload for failed file(s).', {
              //       uploaded: uploadResult.uploaded,
              //       total: uploadResult.total,
              //       ns: TRANSLATION_FILES.translation,
              //     }),
              //   }));
              // }

            case 43:

              // Continue with original booking status update
              booking = data;

              booking[d.name] = d.name;
              if (data.statusID === 'sold_spa_signed' || data.statusID === 'cancelled_developer') {
                booking.isCancelPending = data.isCancelPending;
                booking.isUserCooldown = data.isUserCooldown;
              }
              booking = _this7.setPricePerSqm(booking);
              _this7.setState({ bookingStatusModal: false, isUnitChange: false, pendingChangeUnitData: null }, function () {
                _this7.unitChangeInFlight = false;
                _this7.updateBooking(booking, 'update');
              });
              _this7.callRefreshBookingNote();

            case 49:
            case 'end':
              return _context25.stop();
          }
        }
      }, _callee25, _this7, [[11, 17]]);
    }));

    return function (_x40, _x41) {
      return _ref34.apply(this, arguments);
    };
  }();

  this.handleCancelBookingStatus = function () {
    var _state11 = _this7.state,
        data = _state11.data,
        oriData = _state11.oriData;

    data.statusID = oriData.statusID;
    data.newBookingNoteEncoded = '';
    _this7.setState({
      data: data,
      bookingStatusModal: false,
      isUnitChange: false,
      pendingChangeUnitData: null
    });
  };

  this.handleCancelTinInvalidModal = function (e) {
    e.preventDefault();
    _this7.setState({ tinInvalidModal: false });
  };

  this.getMinCancelledDate = function (data) {
    // Return the minimum date for cancelledAt to be sold date if it exist
    if (data.lastSoldAt) {
      return (0, _momentTimezone2.default)(data.lastSoldAt).startOf('day').toDate();
      // Else return the minimum date for cancelledAt to be approved date if it exist
    } else if (data.approvedAt) {
      return (0, _momentTimezone2.default)(data.approvedAt).startOf('day').toDate();
      // Else return the minimum date for cancelledAt to be created date if it exist
    } else if (data.createdAt) {
      return (0, _momentTimezone2.default)(data.createdAt).startOf('day').toDate();
    }
    return null;
  };

  this.getMinSoldDate = function (data) {
    return data.createdAt ? (0, _momentTimezone2.default)(data.createdAt).startOf('day').toDate() : null;
  };

  this.handleOnVisible = function (field) {
    var data = _this7.state.data;

    var updatedState = _extends({}, _this7.state);

    // Set visibility for date pickers
    if (field === 'approvedAt') {
      updatedState.approvedDatePickerVisible = true;
      updatedState.minSoldDate = _this7.getMinSoldDate(data);
      updatedState.minCancelledDate = _this7.getMinCancelledDate(data);
    } else if (field === 'cancelledAt') {
      updatedState.cancelledDatePickerVisible = true;
      updatedState.minCancelledDate = _this7.getMinCancelledDate(data);
    } else if (field === 'lastSoldAt') {
      updatedState.soldDatePickVisible = true;
      updatedState.minSoldDate = _this7.getMinSoldDate(data);
      updatedState.minCancelledDate = _this7.getMinCancelledDate(data);
    } else if (field === 'spaSigningDate') {
      updatedState.spaSigningDatePickerVisible = true;
      updatedState.minSoldDate = _this7.getMinSoldDate(data);
      updatedState.minCancelledDate = _this7.getMinCancelledDate(data);
    } else if (field === 'spaStampingDate') {
      updatedState.spaStampingDatePickerVisible = true;
      updatedState.minSoldDate = _this7.getMinSoldDate(data);
      updatedState.minCancelledDate = _this7.getMinCancelledDate(data);
    }

    _this7.setState(updatedState);
  };

  this.handleOnClear = function (field) {
    var data = _this7.state.data;

    data[field] = null;
    _this7.setState({ data: data });
  };

  this.handleBookingDateChanges = function (value, visible, field) {
    var data = _this7.state.data;

    data[field] = value;
    var updatedState = _extends({}, _this7.state);

    if (field === 'approvedAt') {
      updatedState.approvedDatePickerVisible = visible;
      updatedState.minSoldDate = value || _this7.getMinSoldDate(data);
    } else if (field === 'cancelledAt') {
      updatedState.cancelledDatePickerVisible = visible;
      updatedState.minCancelledDate = _this7.getMinCancelledDate(data);
    } else if (field === 'lastSoldAt') {
      updatedState.soldDatePickVisible = visible;
      updatedState.minSoldDate = _this7.getMinSoldDate(data);
    } else if (field === 'spaSigningDate') {
      updatedState.spaSigningDatePickerVisible = visible;
      updatedState.minSoldDate = _this7.getMinSoldDate(data);
    } else if (field === 'spaStampingDate') {
      updatedState.spaStampingDatePickerVisible = visible;
      updatedState.minSoldDate = _this7.getMinSoldDate(data);
    }

    _this7.setState(updatedState);
  };

  this.valueToText = function (array, value) {
    var element = array.find(function (a) {
      return a.value === value;
    });
    if (element && element.text) {
      return element.text;
    }
    return '';
  };

  this.handleCloseLarge = function (e) {
    e.preventDefault();
    _this7.setState({
      showLarge: false,
      selectedPicture: null,
      slideshow: false
    });
  };

  this.handleSlidePicture = function (e) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
    var _state12 = _this7.state,
        data = _state12.data,
        selectedPicture = _state12.selectedPicture;

    var index = data.paymentPictures.indexOf(selectedPicture);
    var nextIndex = direction === 'left' ? index - 1 : index + 1;
    _this7.setState({
      selectedPicture: data.paymentPictures[nextIndex]
    });
  };

  this.handleEditPPModalSubmit = function (selectedPackagePricingItem, name) {
    return _this7.setState(_defineProperty({}, name, selectedPackagePricingItem));
  };

  this.checkAllowChangeUnit = function () {
    var oriData = _this7.state.oriData;

    return oriData && oriData.project && oriData.project.cuIsEnabled && _this7.hasAccessChangeUnit();
  };

  this.checkJSONStringifyMatch = function (dataA, dataB) {
    var match = false;
    try {
      if (JSON.stringify(dataA) === JSON.stringify(dataB)) match = true;
    } catch (e) {
      Bugsnag(e);
    }
    return match;
  };

  this.checkCustomFieldsChanged = function (bookingCustomFields, projectBookingCustomFields, data) {
    var found = false;
    if (bookingCustomFields) {
      bookingCustomFields.forEach(function (d) {
        if (d.value !== data[d.projectBookingCustomField.name]) found = true;
      });
    }
    if (projectBookingCustomFields) {
      projectBookingCustomFields.forEach(function (d) {
        var exists = -1;
        if (bookingCustomFields) exists = bookingCustomFields.findIndex(function (bcfData) {
          return bcfData.projectBookingCustomFieldID === d.id;
        });
        if (exists === -1) found = true;
      });
    }
    return found;
  };

  this.checkStaffHasStatusAccess = function () {
    var auth = _this7.props.auth;
    var data = _this7.props.appConfig.data;

    if (auth && auth.isDeveloperStaff && data && data.settings && data.settings.allowStaffEditBookingStatus) return true;
    return false;
  };

  this.handleSaveCreatedAt = function (e, createdAt) {
    _this7.setState({ showDateTimeModal: false }, function () {
      var oriData = _this7.state.oriData;

      var booking = {};
      booking.id = oriData.id;
      booking.createdAt = createdAt;
      _this7.updateBooking(booking, 'update');
    });
  };

  this.handleCancelCreatedAt = function (e) {
    e.preventDefault();
    _this7.setState({ showDateTimeModal: false });
  };

  this.handleOpenCreatedAt = function (e) {
    e.preventDefault();
    _this7.setState({ showDateTimeModal: true });
  };

  this.handleToggleCustomFields = function (e) {
    e.preventDefault();
    _this7.setState({ showCustomFields: !_this7.state.showCustomFields });
  };

  this.handleCustomSelectChange = function (e, d, customFieldOptions, cValidation) {
    var data = _this7.state.data;

    if (Array.isArray(d.value)) {
      var ids = [];
      var values = [];
      customFieldOptions.forEach(function (cfo) {
        d.value.forEach(function (v) {
          if (v === cfo.value) {
            ids.push(cfo.id);
            values.push(cfo.value);
          }
        });
      });
      data[d.name + 'OptionIDs'] = ids;
      data[d.name + 'OptionID'] = '';
      data[d.name] = values.join(',');
    } else {
      data[d.name] = d.value;
      var selectedOption = customFieldOptions.find(function (cfoData) {
        return cfoData.value === d.value;
      });
      data[d.name + 'OptionID'] = selectedOption ? selectedOption.id : '';
      data[d.name + 'OptionIDs'] = [];
    }
    _this7.customFieldValidation = cValidation;
    _this7.setState({ data: data }, function () {
      _this7.handleCheckChanges('bookingChanges');
    });
  };

  this.handleCustomInputChange = function (e, cValidation) {
    var data = _this7.state.data;

    data[e.target.name] = e.target.value;
    _this7.customFieldValidation = cValidation;
    _this7.setState({ data: data }, function () {
      _this7.handleCheckChanges('bookingChanges');
    });
  };

  this.handleSubmitNoetic = function (e) {
    e.preventDefault();
    _this7.submitNoetic();
  };

  this.handleSubmitIFCA = function (e) {
    e.preventDefault();
    _this7.submitIFCA();
  };

  this.handleSubmitInsoft = function (e) {
    e.preventDefault();
    _this7.submitInsoft();
  };

  this.handleRecalculatePackagePricing = function (b) {
    var data = _this7.state.data;

    data.forceRecalculatePackagePricing = b;
    _this7.setState({ data: data });
  };

  this.handleCloseValidationSvcErrModal = function (e) {
    e.preventDefault();
    _this7.setState({ validationSvcErrorModalOpen: false });
  };

  this.handleOpenValidationSvcErrModal = function () {
    var _ref35 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee26(e) {
      return regeneratorRuntime.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              e.preventDefault();
              _context26.next = 3;
              return _this7.fetchJDELogs();

            case 3:
              _context26.next = 5;
              return _this7.setComponentState({ validationSvcErrorModalOpen: true });

            case 5:
            case 'end':
              return _context26.stop();
          }
        }
      }, _callee26, _this7);
    }));

    return function (_x43) {
      return _ref35.apply(this, arguments);
    };
  }();

  this.handleToggleExternalSvcErrModal = function () {
    var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    _this7.setState({ externalSvcErrorModalOpen: toggle });
  };

  this.handleToggleAPIESvcErrModal = function () {
    var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    _this7.setState({ apieSvcErrorModalOpen: toggle });
  };

  this.handleToggleBotSvcErrModal = function () {
    var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    _this7.setState({ botSvcErrorModalOpen: toggle });
  };

  this.handleToggleBotResyncModal = function () {
    var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    _this7.setState({ botResyncModalOpen: toggle });
  };

  this.handleResyncToBotApi = function () {
    _this7.handleToggleBotResyncModal(false);
    _this7.resyncBotApi();
  };

  this.handleBotResync = function () {
    var oriData = _this7.state.oriData;

    if (oriData && oriData.botServiceStatus === 'failed') {
      _this7.handleResyncToBotApi();
    } else {
      _this7.handleToggleBotResyncModal(true);
    }
  };

  this.renderBotResyncModal = function () {
    var t = _this7.props.t;

    return _react2.default.createElement(
      _semanticUiReact.Modal,
      {
        className: 'booking-status-note',
        closeOnDimmerClick: false,
        onClose: function onClose() {
          return _this7.handleToggleBotResyncModal(false);
        },
        open: _this7.state.botResyncModalOpen,
        size: 'tiny'
      },
      _react2.default.createElement(_semanticUiReact.Header, { content: 'Are you sure you want to re-sync?' }),
      _react2.default.createElement(
        _semanticUiReact.Modal.Content,
        null,
        _react2.default.createElement(
          _semanticUiReact.Modal.Description,
          null,
          'Re-syncing a booking may cause duplicates if there is a pending job running.'
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Modal.Actions,
        null,
        _react2.default.createElement(_semanticUiReact.Button, { negative: true, onClick: function onClick() {
            return _this7.handleToggleBotResyncModal(false);
          }, content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }) }),
        _react2.default.createElement(_semanticUiReact.Button, { positive: true, onClick: _this7.handleResyncToBotApi, content: 'Re-sync' })
      )
    );
  };

  this.checkAndRenderBotResyncButton = function () {
    var _state13 = _this7.state,
        oriData = _state13.oriData,
        isBotSyncing = _state13.isBotSyncing;

    if (oriData && oriData.botServiceStatus !== '' && oriData.botServiceStatus !== 'success') {
      return _react2.default.createElement(
        'div',
        { className: 'bot-button-div' },
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          _semanticUiReact.Button,
          {
            className: 'api-action-button ' + (isBotSyncing ? 'bot-syncing-button' : 'bot-resync-button'),
            disabled: isBotSyncing,
            size: 'small',
            onClick: isBotSyncing ? null : _this7.handleBotResync,
            compact: true
          },
          isBotSyncing ? _react2.default.createElement(
            'div',
            { className: 'bot-syncing-div' },
            _react2.default.createElement('div', { className: 'bot-loader' }),
            _react2.default.createElement(
              'span',
              null,
              ' Syncing...'
            )
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'redo' }),
            ' Resync'
          )
        )
      );
    }
    return null;
  };

  this.handleToggleHimsSvcErrModal = function () {
    var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    _this7.setState({ himsSvcErrorModalOpen: toggle });
  };

  this.handleResyncToHimsApi = function () {
    var oriData = _this7.state.oriData;

    // force to start a new sync

    if (oriData.himsHasChanges) {
      _this7.syncToHimsAPI();
      return;
    }

    if (oriData.himsServiceStatus === 'failed') {
      _this7.resyncHimsAPI();
      return;
    }
    _this7.syncToHimsAPI();
  };

  this.checkAndRenderHimsResyncButton = function () {
    var _state14 = _this7.state,
        oriData = _state14.oriData,
        isHimsSyncing = _state14.isHimsSyncing;

    if (!oriData) {
      return null;
    }

    var isActiveBooking = oriData.statusID === 'booked' || oriData.statusID === 'sold_spa_signed';
    if (!oriData.himsServiceID && !isActiveBooking) {
      return null;
    }

    var hasHimsFields = oriData.himsDeveloperCode !== '' && oriData.himsProjectDevelopmentID !== '' && oriData.himsUnitComponentID !== '' && oriData.himsUnitNumber !== '';
    if (!hasHimsFields) {
      return null;
    }

    if (oriData.himsServiceID && !(oriData.himsHasChanges || oriData.himsServiceStatus === 'failed')) {
      return null;
    }

    return _react2.default.createElement(
      'div',
      { className: 'bot-button-div' },
      _react2.default.createElement('br', null),
      _react2.default.createElement(
        _semanticUiReact.Button,
        {
          className: isHimsSyncing ? 'bot-syncing-button' : 'bot-resync-button',
          disabled: isHimsSyncing,
          size: 'small',
          onClick: isHimsSyncing ? null : _this7.handleResyncToHimsApi,
          compact: true
        },
        isHimsSyncing ? _react2.default.createElement(
          'div',
          { className: 'bot-syncing-div' },
          _react2.default.createElement('div', { className: 'bot-loader' }),
          _react2.default.createElement(
            'span',
            null,
            ' Syncing...'
          )
        ) : _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'redo' }),
          ' ',
          oriData.himsServiceID ? 'Re-sync' : 'Sync to HIMS'
        )
      )
    );
  };

  this.showNoeticButton = function (oriData) {
    if ((oriData.statusID === 'booked' || oriData.statusID === 'sold_spa_signed') && _this7.hasAccess(false, true, true, true, false)) {
      return true;
    }
    return false;
  };

  this.showIFCAButton = function (oriData) {
    if (oriData.statusID === 'sold_spa_signed' && _this7.hasAccess(false, true, true, true, false)) {
      return true;
    }
    return false;
  };

  this.showInsoftButton = function (oriData) {
    if (oriData.statusID === 'sold_spa_signed' && _this7.hasAccess(false, true, true, true, false)) {
      return true;
    }
    return false;
  };

  this.showExternalResendButton = function (oriData) {
    if (oriData.externalServiceStatus !== 'Success' && _this7.props.appConfig.data.externalServiceIsEnabled && (_this7.hasAccess(false, true, true, false, false) || _this7.props.appConfig.data.isUem) && !_this7.props.appConfig.data.advelsoftIsEnabled) {
      return true;
    }
    return false;
  };

  this.showDiscountPricing = function (oriData) {
    if (oriData.tierPricingName !== 'Base' && oriData.tierPricingName !== '') {
      return true;
    }
    return false;
  };

  this.showHimsService = function () {
    var appConfig = _this7.props.appConfig;
    var oriData = _this7.state.oriData;

    return appConfig && appConfig.data && appConfig.data.himsIsEnabled && oriData && oriData.project && oriData.project.himsIsEnabled;
  };

  this.hasChangeUnitAccess = function (oriData) {
    return !oriData.newID && !(0, _vietnam.vnChangeUnitBlocked)(_this7.props.auth, oriData) && !(0, _preSalesLaunch.reservationBlocked)(_this7.props.auth, oriData.project) && (oriData.statusID === 'reserved' || oriData.statusID === 'booked') && (_this7.hasAccess(false, true, true, true, false) || _this7.checkAllowChangeUnit());
  };

  this.handleShowChangeUnit = function () {
    var oriData = _this7.state.oriData;

    _this7.setState({
      showChangeUnit: true,
      changeProjectID: oriData.projectID || '',
      changeUnitID: ''
    }, function () {
      if (_this7.state.projectOpts.length <= 0) {
        if (_this7.checkAllowChangeUnit() && oriData.project.cuOtherProjectIsEnabled) _this7.fetchProjects();else {
          var projectOpts = _this7.state.projectOpts;

          projectOpts = [{ value: oriData.project.id, text: oriData.project.name }];
          _this7.setComponentState({ projectOpts: projectOpts });
        }
      }
      if (_this7.state.changeProjectID && _this7.checkAllowChangeUnit()) {
        _this7.fetchUnits();
      }
    });
  };

  this.handleHideChangeUnit = function () {
    _this7.setState({ showChangeUnit: false });
  };

  this.handleSelectChangeProject = function (e, _ref36) {
    var value = _ref36.value;

    _this7.setState({
      changeProjectID: value,
      changeUnitID: ''
    }, function () {
      _this7.fetchUnits();
    });
  };

  this.handleSelectChangeUnit = function (e, _ref37) {
    var value = _ref37.value;

    _this7.setState({ changeUnitID: value });
  };

  this.handleShowConfirmChangeUnit = function () {
    _this7.setState({
      bookingChangeUnitModal: true,
      showChangeUnit: false
    });
  };

  this.handleCancelChangeUnit = function () {
    _this7.setState({ bookingChangeUnitModal: false });
  };

  this.handleConfirmChangeUnit = function (value) {
    _this7.setState({ bookingChangeUnitModal: false }, function () {
      _this7.submitChangeUnit(value);
    });
  };

  this.handleBookingNotesExpand = function () {
    var expand = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    _this7.setState({ bookingNotesModuleExpand: expand }, function () {
      if (expand) {
        var bnColDiv = document.getElementById('bn_grid_col_div');
        if (bnColDiv) {
          bnColDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }
    });
  };

  this.optionsTierPricings = function () {
    var t = _this7.props.t;

    var tiers = _this7.state.unitTiers || [];
    // Setup pricingTiers
    var pricingTiers = [{
      value: _this7.state.data.projectUnit ? (0, _amount.spaFullNumber)(_this7.state.data.projectUnit).toString() : '',
      description: _this7.state.data.projectUnit ? (0, _amount.spaFullNumber)(_this7.state.data.projectUnit).toString() : '',
      text: t('Base Selling Price'),
      content: _react2.default.createElement(
        _semanticUiReact.Header,
        { className: 'ddPricingTierItem' },
        _react2.default.createElement(
          'div',
          { className: 'name' },
          t('Base Selling Price')
        ),
        _react2.default.createElement(
          'div',
          { className: 'value' },
          _react2.default.createElement(_CurrencySymbol2.default, null),
          _this7.state.data.projectUnit ? (0, _amount.spaFullNumber)(_this7.state.data.projectUnit).toString() : ''
        )
      )
    }];
    if (tiers) {
      tiers.sort(function (a, b) {
        return a.position - b.position;
      }).forEach(function (d) {
        var newItem = {
          description: d.totalPrice.toString()
        };
        if (d.projectPricing) {
          newItem.text = d.projectPricing.name;
          newItem.value = d.projectPricing.id;
          newItem.content = _react2.default.createElement(
            _semanticUiReact.Header,
            { className: 'ddPricingTierItem' },
            _react2.default.createElement(
              'div',
              { className: 'name' },
              d.projectPricing.name
            ),
            _react2.default.createElement(
              'div',
              { className: 'value' },
              _react2.default.createElement(_CurrencySymbol2.default, null),
              d.totalPrice.toString()
            ),
            _react2.default.createElement(
              _semanticUiReact.Header.Subheader,
              null,
              d.projectPricing.description
            )
          );
        }
        pricingTiers.push(newItem);
      });
    }
    // filter expired
    var newPricingTiers = pricingTiers;
    var tier = void 0;
    pricingTiers.forEach(function (pt, idx) {
      if (tiers) tier = tiers.find(function (tt) {
        return tt.totalPrice.toString() === pt.description;
      });
      if (tier) {
        var sStart = tier.projectPricing.scheduleStartAt;
        var sEnd = tier.projectPricing.scheduleEndAt;
        if (sStart && (0, _momentTimezone2.default)(sStart).unix() > (0, _momentTimezone2.default)().unix() || sEnd && (0, _momentTimezone2.default)(sEnd).unix() < (0, _momentTimezone2.default)().unix()) {
          if (!pt.disabled) {
            newPricingTiers[idx].disabled = true;
          }
        }
      }
    });
    return newPricingTiers;
  };

  this.checkSizeSuffix = function () {
    var t = _this7.props.t;
    var data = _this7.state.data;

    var suffix = data.project && data.project.sizeSuffix;
    switch (suffix) {
      case 'square_metres':
        return (0, _vietnam.isVietnamCompany)(_this7.props.auth) ? ' m²' : ' ' + t('sqm', { ns: _translation.TRANSLATION_FILES.screens });
      case 'square_feet':
        return ' ' + t('sqft', { ns: _translation.TRANSLATION_FILES.screens });
      default:
        return '';
    }
  };

  this.canRenderFirstTimeBuyer = function (data) {
    return data.spaAmount <= 500000 && data.firstTimeBuyer === 'yes' && data.srpLoan !== '';
  };

  this.canRenderNotesAndAPISection = function () {
    var onlyAPI = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var data = _this7.state.data;

    return isPRS || _this7.showNoetic() || _this7.showIFCA() || _this7.showInsoft() || _this7.showRagic() || _this7.showExternalService() || _this7.showBotService() || _this7.showAPIEService() || _this7.showHimsService() || !onlyAPI && data && data.project && _this7.hasBookingNoteReadAccess(data.project);
  };

  this.renderStatusDisabledTextWithCC = function () {
    var t = _this7.props.t;

    return _this7.hasAccess(_this7.checkStaffHasStatusAccess(), true, true, true, false) && _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { textAlign: 'right', width: 16 },
      _react2.default.createElement(
        'b',
        null,
        t('Status update is disabled due to credit control'),
        '.'
      )
    );
  };

  this.renderPaymentApprovalRequiredText = function () {
    var t = _this7.props.t;

    var paymentApprovedRequiredStatusIDs = _this7.getPaymentApprovedRequiredStatusIDs();
    if (paymentApprovedRequiredStatusIDs.length === 0 || _this7.hasApprovedBookingPayment()) return null;
    var statuses = _this7.getBlockedBookingStatusLabels(paymentApprovedRequiredStatusIDs);
    return _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { textAlign: 'right', width: 16 },
      _react2.default.createElement(
        'b',
        null,
        t('Payment must be approved before changing the status to {{statuses}}', { statuses: statuses, ns: _translation.TRANSLATION_FILES.translation }),
        '.'
      )
    );
  };

  this.renderSignatureRequiredText = function () {
    var t = _this7.props.t;

    if (!_this7.isBookingStatusBlockedBySignature('booked')) return null;
    return _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { textAlign: 'right', width: 16 },
      _react2.default.createElement(
        'b',
        null,
        t('The purchaser must sign the sales form before the status can change to Booked', { ns: _translation.TRANSLATION_FILES.translation }),
        '.'
      )
    );
  };

  this.renderJDELogs = function (oriData) {
    var data = _this7.state.validationSvcErrorModalContent;
    if (data) {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h4',
            null,
            'JDE API Buyer Response:'
          ),
          _react2.default.createElement(
            'div',
            null,
            data.buyerResponseRaw
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(
              'small',
              null,
              'Request Sent At: ',
              data.buyerRequestSentAt
            )
          )
        ),
        _react2.default.createElement('br', null),
        _react2.default.createElement('hr', null),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h4',
            null,
            'JDE API Property Response:'
          ),
          _react2.default.createElement(
            'div',
            null,
            data.propertyResponseRaw
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(
              'small',
              null,
              'Request Sent At: ',
              data.propertyRequestSentAt
            )
          )
        )
      );
    }
    return oriData.validationServiceErrorMessage;
  };

  this.renderSvcErrorList = function (data) {
    var dataToArray = data.split(',').map(function (item) {
      return item.trim();
    });
    var errorItems = dataToArray.reverse().map(function (d) {
      return _react2.default.createElement(
        _semanticUiReact.List.Item,
        { key: d },
        d
      );
    });
    return _react2.default.createElement(
      _semanticUiReact.List,
      null,
      errorItems
    );
  };

  this.renderBotSvcError = function (data) {
    var errorItems = data.reverse().map(function (d) {
      return _react2.default.createElement(
        _semanticUiReact.List.Item,
        { key: d },
        d
      );
    });
    return _react2.default.createElement(
      _semanticUiReact.List,
      null,
      errorItems
    );
  };

  this.renderSoldCasePrompt = function () {
    var access = _this7.hasAccess(false, true, true, true, true);
    var oriData = _this7.state.oriData;
    var t = _this7.props.t;

    var soldCases = oriData.bankCases.filter(function (bankCase) {
      return bankCase.status === 'success_li_issued';
    });
    if (access && oriData.statusID !== 'sold_spa_signed' && oriData.statusID !== 'expired' && oriData.statusID !== 'cancelled_developer' && oriData.statusID !== 'cancelled_availability' && soldCases.length > 0) {
      var bankerName = soldCases[0].banker.preferredName;
      var bankName = soldCases[0].bank.name;
      return _react2.default.createElement(
        _semanticUiReact.Message,
        { warning: true, style: { margin: '1em 0' } },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation.TRANSLATION_FILES.screens },
              _react2.default.createElement(
                'strong',
                null,
                { bankerName: bankerName }
              ),
              ' from ',
              _react2.default.createElement(
                'strong',
                null,
                { bankName: bankName }
              ),
              ' has updated Loan Status to ',
              _react2.default.createElement(
                'strong',
                null,
                'LO Signed'
              ),
              '.'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 4, textAlign: 'right' },
            _react2.default.createElement(_semanticUiReact.Button, {
              size: 'small',
              positive: true,
              onClick: function onClick(e) {
                return _this7.handleBookingStatusChange(e, { name: 'statusID', value: 'sold_spa_signed' });
              },
              content: t('Mark Sold')
            })
          )
        )
      );
    }
    return null;
  };

  this.renderChangeUnitPrompt = function () {
    var t = _this7.props.t;

    var access = _this7.hasAccess(false, true, true, true, false) || _this7.checkAllowChangeUnit();
    var oriData = _this7.state.oriData;

    var isActiveBooking = oriData.statusID === 'reserved' || oriData.statusID === 'booked';
    if (access && isActiveBooking && oriData.newID) {
      return _react2.default.createElement(
        _semanticUiReact.Message,
        { warning: true, style: { margin: '1em 0' } },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _reactI18next.Trans,
              { ns: _translation.TRANSLATION_FILES.screens },
              'A new ',
              _react2.default.createElement(
                _reactRouter.Link,
                { to: '/bookings/' + oriData.newID + '/', target: '_blank' },
                'booking'
              ),
              ' is created via ',
              _react2.default.createElement(
                'strong',
                null,
                'Unit Change'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 4, textAlign: 'right' },
            _react2.default.createElement(_semanticUiReact.Button, {
              size: 'small',
              negative: true,
              onClick: function onClick(e) {
                return _this7.handleBookingStatusChange(e, { name: 'statusID', value: 'cancelled_developer' });
              },
              content: t('Mark Cancelled')
            })
          )
        )
      );
    }
    return null;
  };

  this.renderAPISection = function (t, oriData, isEditing) {
    return _this7.canRenderNotesAndAPISection(true) ? _react2.default.createElement(
      _semanticUiReact.Grid,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { mobile: 16, tablet: 16, computer: 16, className: 'mobile-half-left-padding' },
          _react2.default.createElement(_semanticUiReact.Dimmer, { style: { zIndex: 10 }, active: isEditing, inverted: true }),
          _this7.showNoetic() && _react2.default.createElement(
            _semanticUiReact.Message,
            { style: { marginTop: '0.35em', padding: '0.5em 1em', textAlign: 'left' } },
            _react2.default.createElement(
              'b',
              null,
              (0, _translation2.translateModels)(t, 'noeticStatusID', 'booking') + ':'
            ),
            ' ',
            _react2.default.createElement(
              'small',
              null,
              oriData.noeticStatusID ? (0, _translation2.getConstantsLabel)(t, _noeticStatuses2.default, oriData.noeticStatusID) : 'N/A'
            ),
            _react2.default.createElement('br', null),
            oriData.noeticStatusID === 'none' || oriData.noeticStatusID === 'failed' ? _this7.showNoeticButton(oriData) && _react2.default.createElement(
              _semanticUiReact.Button,
              { fluid: true, size: 'small', className: 'api-action-button', onClick: _this7.handleSubmitNoetic },
              t(oriData.noeticStatusID === 'none' ? 'Send to {{name}}' : 'Retry send to {{name}}', { name: 'Noetic' })
            ) : oriData.noeticSalesID !== '' && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'b',
                null,
                (0, _translation2.translateModels)(t, 'noeticStatusID', 'booking') + ':',
                ' '
              ),
              ' ',
              oriData.noeticSalesID
            )
          ),
          _this7.showIFCA() && _react2.default.createElement(
            _semanticUiReact.Message,
            { style: { marginTop: '0.35em', padding: '0.5em 1em', textAlign: 'left' } },
            _react2.default.createElement(
              'b',
              null,
              (0, _translation2.translateModels)(t, 'ifcaStatusID', 'booking') + ':'
            ),
            ' ',
            _react2.default.createElement(
              'small',
              null,
              oriData.ifcaStatusID ? (0, _translation2.getConstantsLabel)(t, _ifcaStatuses2.default, oriData.ifcaStatusID) : 'N/A'
            ),
            _react2.default.createElement('br', null),
            oriData.ifcaStatusID === 'none' || oriData.ifcaStatusID === 'failed' ? _this7.showIFCAButton(oriData) && _react2.default.createElement(
              _semanticUiReact.Button,
              { fluid: true, size: 'small', className: 'api-action-button', onClick: _this7.handleSubmitIFCA },
              t(oriData.ifcaStatusID === 'none' ? 'Send to {{name}}' : 'Retry send to {{name}}', { name: 'IFCA' })
            ) : oriData.ifcaReferenceID !== '' && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'b',
                null,
                (0, _translation2.translateModels)(t, 'ifcaReferenceID', 'booking') + ':',
                ' '
              ),
              ' ',
              oriData.ifcaReferenceID
            )
          ),
          _this7.showInsoft() && _react2.default.createElement(
            _semanticUiReact.Message,
            { style: { marginTop: '0.35em', padding: '0.5em 1em', textAlign: 'left' } },
            _react2.default.createElement(
              'b',
              null,
              (0, _translation2.translateModels)(t, 'insoftStatusID', 'booking') + ':'
            ),
            ' ',
            _react2.default.createElement(
              'small',
              null,
              oriData.insoftStatusID ? (0, _translation2.getConstantsLabel)(t, _insoftStatuses2.default, oriData.insoftStatusID) : 'N/A'
            ),
            _react2.default.createElement('br', null),
            oriData.insoftStatusID === 'none' || oriData.insoftStatusID === 'failed' ? _this7.showInsoftButton(oriData) && _react2.default.createElement(
              _semanticUiReact.Button,
              { fluid: true, size: 'small', className: 'api-action-button', onClick: _this7.handleSubmitInsoft },
              t(oriData.insoftStatusID === 'none' ? 'Send to {{name}}' : 'Retry send to {{name}}', { name: 'Insoft' })
            ) : oriData.insoftReferenceID !== '' && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'b',
                null,
                (0, _translation2.translateModels)(t, 'insoftReferenceID', 'booking') + ':',
                ' '
              ),
              ' ',
              oriData.insoftReferenceID
            )
          ),
          _this7.showRagic() && _react2.default.createElement(
            _semanticUiReact.Message,
            { style: { marginTop: '0.35em', padding: '0.5em 1em', textAlign: 'left' } },
            _react2.default.createElement(
              'b',
              null,
              'Ragic Status'
            ),
            ' ',
            _react2.default.createElement(
              'small',
              null,
              oriData.ragicStatus ? oriData.ragicStatus : 'n/a'
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Ragic Opportunity ID: '
              ),
              ' ',
              _react2.default.createElement(
                'small',
                null,
                oriData.ragicOpportunityID || 'n/a'
              )
            ),
            _react2.default.createElement('br', null),
            oriData.ragicServiceError && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Ragic Errors: '
              ),
              ' ',
              _react2.default.createElement(
                'small',
                null,
                oriData.ragicServiceError || 'No errors.'
              )
            )
          ),
          _this7.showExternalService() && _react2.default.createElement(
            _semanticUiReact.Message,
            { style: { marginTop: '0.35em', padding: '0.5em 1em', textAlign: 'left' } },
            _react2.default.createElement(
              'b',
              null,
              _this7.props.appConfig.data.advelsoftIsEnabled ? 'Advelsoft Status:' : 'External Status:'
            ),
            ' ',
            _react2.default.createElement(
              'small',
              null,
              oriData.externalServiceStatus || 'Pending'
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'b',
                null,
                'ID: '
              ),
              ' ',
              _react2.default.createElement(
                'small',
                null,
                oriData.externalID || 'N/A'
              )
            ),
            _react2.default.createElement('br', null),
            !_this7.props.appConfig.data.advelsoftIsEnabled && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'b',
                null,
                'Lead ID: '
              ),
              ' ',
              _react2.default.createElement(
                'small',
                null,
                oriData.externalLeadID || 'N/A'
              )
            ),
            oriData.externalServiceError && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'b',
                null,
                t('Error Logs') + ':',
                ' '
              ),
              _react2.default.createElement(
                _semanticUiReact.Label,
                { as: 'button', size: 'small', compact: true, onClick: function onClick() {
                    return _this7.handleToggleExternalSvcErrModal(true);
                  } },
                'View'
              )
            ),
            _this7.showExternalResendButton(oriData) && _react2.default.createElement(
              'div',
              { className: 'resend' },
              _react2.default.createElement(
                _semanticUiReact.Label,
                { as: 'button', size: 'small', compact: true, onClick: function onClick() {
                    return _this7.resendBooking();
                  } },
                _this7.props.appConfig.data.isUem ? 'Resend' : 'Resync'
              )
            ),
            _this7.props.appConfig.data.advelsoftIsEnabled && oriData.externalServiceStatus !== 'Success' && (oriData.statusID === 'booked' || oriData.statusID === 'sold_spa_signed') && _react2.default.createElement(
              'div',
              { className: 'resend' },
              _react2.default.createElement(
                _semanticUiReact.Label,
                { as: 'button', size: 'small', compact: true, onClick: function onClick() {
                    return _this7.resendFRHBooking();
                  } },
                'Resend'
              )
            )
          ),
          isPRS && _react2.default.createElement(
            _semanticUiReact.Message,
            { style: { marginTop: '0.35em', padding: '0.5em 1em', textAlign: 'left' } },
            _react2.default.createElement(
              'b',
              null,
              (0, _translation2.translateModels)(t, 'validationServiceStatus', 'booking') + ':'
            ),
            ' ',
            _react2.default.createElement(
              'small',
              null,
              oriData.validationServiceStatus ? (0, _translation2.getConstantsLabel)(t, _jdeStatuses2.default, oriData.validationServiceStatus) : 'N/A'
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'b',
                null,
                'ID: '
              ),
              ' ',
              _react2.default.createElement(
                'small',
                null,
                oriData.validationServiceReferenceID
              )
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'b',
                null,
                t('Logs') + ':',
                ' '
              ),
              _react2.default.createElement(
                _semanticUiReact.Label,
                { as: 'button', size: 'small', compact: true, onClick: _this7.handleOpenValidationSvcErrModal },
                'View'
              ),
              _this7.hasAccess(false, true, true, false, false) ? _react2.default.createElement(
                'span',
                null,
                '- ',
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  { color: 'grey', as: 'button', size: 'small', compact: true, onClick: function onClick() {
                      return _this7.resendJDEBooking();
                    } },
                  'Manual Update'
                )
              ) : ''
            )
          ),
          _this7.showBotService() && _react2.default.createElement(
            _semanticUiReact.Message,
            { style: { marginTop: '0.35em', padding: '0.5em 1em', textAlign: 'left' } },
            _react2.default.createElement(
              'b',
              null,
              'BOT Sync Status:'
            ),
            ' ',
            _react2.default.createElement(
              'small',
              { style: { fontWeight: 'bold', color: _this7.getColorText(oriData.botServiceStatus) } },
              (0, _strings.titleCase)(oriData.botServiceStatus) || 'N/A'
            ),
            _this7.checkAndRenderBotResyncButton(),
            oriData.botServiceID && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'b',
                null,
                'ID: '
              ),
              ' ',
              _react2.default.createElement(
                'small',
                null,
                oriData.botServiceID
              )
            ),
            oriData.botServiceErrors && oriData.botServiceErrors.length > 0 && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'b',
                null,
                'Error Logs: '
              ),
              _react2.default.createElement(
                _semanticUiReact.Label,
                { as: 'button', size: 'small', compact: true, onClick: function onClick() {
                    return _this7.handleToggleBotSvcErrModal(true);
                  } },
                'View'
              )
            ),
            oriData.botServiceUpdatedAt && _react2.default.createElement(
              'span',
              { style: { color: 'gray' } },
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'small',
                null,
                'Updated as of ',
                _react2.default.createElement(_Timestamp2.default, { format: 'MMMM Do, YYYY, h:mm:ss a', timestamp: oriData.botServiceUpdatedAt }),
                ' '
              )
            )
          ),
          _this7.showAPIEService() && _react2.default.createElement(
            _semanticUiReact.Message,
            { style: { marginTop: '0.35em', padding: '0.5em 1em', textAlign: 'left' } },
            _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement(
                'b',
                null,
                'APIE ' + t('Error Logs') + ':',
                ' '
              ),
              oriData.apieServiceError && _react2.default.createElement(
                _semanticUiReact.Label,
                { as: 'button', size: 'small', compact: true, onClick: function onClick() {
                    return _this7.handleToggleAPIESvcErrModal(true);
                  } },
                'View'
              )
            )
          ),
          _this7.showHimsService() && _react2.default.createElement(
            _semanticUiReact.Message,
            { style: { marginTop: '0.35em', padding: '0.5em 1em', textAlign: 'left' } },
            _react2.default.createElement(
              'b',
              null,
              'HIMS Sync Status:'
            ),
            ' ',
            _react2.default.createElement(
              'small',
              { style: { fontWeight: 'bold', color: _this7.getColorText(!oriData.himsServiceID || oriData.himsHasChanges ? '' : oriData.himsServiceStatus) } },
              !oriData.himsServiceID || oriData.himsHasChanges ? 'Pending Sync' : (0, _strings.titleCase)((0, _strings.symbolToSpace)(oriData.himsServiceStatus)) || 'Pending Sync'
            ),
            _this7.checkAndRenderHimsResyncButton(),
            oriData.himsServiceID && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'b',
                null,
                'ID: '
              ),
              ' ',
              _react2.default.createElement(
                'small',
                null,
                oriData.himsServiceID
              )
            ),
            oriData.himsServiceErrors && oriData.himsServiceErrors.length > 0 && _react2.default.createElement(
              'span',
              null,
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'b',
                null,
                'Error Logs: '
              ),
              _react2.default.createElement(
                _semanticUiReact.Label,
                { as: 'button', size: 'small', compact: true, onClick: function onClick() {
                    return _this7.handleToggleHimsSvcErrModal(true);
                  } },
                'View'
              )
            ),
            oriData.himsServiceUpdatedAt && _react2.default.createElement(
              'span',
              { style: { color: 'gray' } },
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'small',
                null,
                'Updated as of ',
                _react2.default.createElement(_Timestamp2.default, { format: 'MMMM Do, YYYY, h:mm:ss a', timestamp: oriData.himsServiceUpdatedAt }),
                ' '
              )
            )
          )
        )
      )
    ) : '';
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.booking, _translation.TRANSLATION_FILES.models.mpUserDetails]))((0, _reactRedux.connect)(Info.mapStateToProps)(Info));

/***/ }),
/* 2271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactRouter = __webpack_require__(18);

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _prompt = __webpack_require__(66);

var _templates = __webpack_require__(380);

var _promptMessages = __webpack_require__(43);

var _translation = __webpack_require__(4);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _AutoReleaseTimer = __webpack_require__(2103);

var _AutoReleaseTimer2 = _interopRequireDefault(_AutoReleaseTimer);

var _BookingSectionTab = __webpack_require__(558);

var _BookingSectionTab2 = _interopRequireDefault(_BookingSectionTab);

var _Info = __webpack_require__(2270);

var _Info2 = _interopRequireDefault(_Info);

var _Purchaser = __webpack_require__(2273);

var _Purchaser2 = _interopRequireDefault(_Purchaser);

var _Documents = __webpack_require__(2269);

var _Documents2 = _interopRequireDefault(_Documents);

var _Tracker = __webpack_require__(2274);

var _Tracker2 = _interopRequireDefault(_Tracker);

var _Buyer = __webpack_require__(2268);

var _Buyer2 = _interopRequireDefault(_Buyer);

var _PaymentPlan = __webpack_require__(2272);

var _PaymentPlan2 = _interopRequireDefault(_PaymentPlan);

var _booking = __webpack_require__(129);

var _booking2 = _interopRequireDefault(_booking);

var _url = __webpack_require__(19);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _bookingStatuses = __webpack_require__(128);

var _FormSharingModal = __webpack_require__(1076);

var _FormSharingModal2 = _interopRequireDefault(_FormSharingModal);

var _OpportunityCancelModal = __webpack_require__(262);

var _OpportunityCancelModal2 = _interopRequireDefault(_OpportunityCancelModal);

var _countries = __webpack_require__(60);

var _vietnam = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */

// actions

// import { fetchBobForms } from '../../../actions/bobForms';

// constants

// components

// sections

// structs

// utils


var isPRS = _config2.default.get('prs');

var Overview = function (_Component) {
  _inherits(Overview, _Component);

  function Overview(props) {
    _classCallCheck(this, Overview);

    var _this = _possibleConstructorReturn(this, (Overview.__proto__ || Object.getPrototypeOf(Overview)).call(this, props));

    _initialiseProps.call(_this);

    var state = Overview.getPropsToState(props);
    _this.state = _extends({}, state, {
      printTemplates: [],
      projectToken: '',
      systemData: [],
      isAutoReleaseTimerEnabled: false,
      isAgingARTimerEnabled: false,
      showShareEmailModal: false,
      project: [],
      allBankCases: [],
      hasDropCase: false,
      maUserAffiliateCompanyBranchName: '',
      docxPrintTemplates: [],
      isPrinting: false,
      showCancelModal: false
    });
    return _this;
  }

  _createClass(Overview, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;

      store.dispatch((0, _templates.fetchTemplates)('print', true));
      // store.dispatch(fetchBobForms(true));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!isPRS) {
        this.fetchSystemSettings();
      }
      if (this.state.data && this.state.data.id) {
        this.fetchPrintTypes();
        this.getBookingPaymentPlan(this.state.data.id);
        this.fetchDocxTemplates(this.state.data);
      }
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var state = Overview.getPropsToState(nextProps);
      var isOriDataSame = JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData);
      var isDataSame = JSON.stringify(this.state.data) === JSON.stringify(state.data);

      if (isOriDataSame) {
        state.data = this.state.data;
        state.bookingPaymentPlan = this.state.bookingPaymentPlan;
        state.sectionTabs = this.state.sectionTabs;
      }

      if (!isDataSame) {
        this.handleFetchAllBankCases(state.data);
        if (this.state.data.maUserAffiliateCompanyBranchID !== state.data.maUserAffiliateCompanyBranchID) {
          this.fetchMaUserAffiliateCompanyBranch(state.data.maUserAffiliateCompanyBranchID);
        }
      }

      this.setState(_extends({}, state), function () {
        if (!isOriDataSame && state.data.id) {
          _this2.fetchPrintTypes();
          _this2.getBookingPaymentPlan(state.data.id);
          _this2.fetchDocxTemplates(state.data);
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
    // CPI-974 (E): the Sales Overview cancel action. Vietnam only, SA / HQ family only, and only
    // when the booking has a CRM opportunity behind it.

    // The cancel action no longer writes to the opportunity, so "already requested/cancelled" is
    // read off the booking itself rather than opportunity.sr_status; shares book-api's own
    // pending-cancellation predicate so a decline (which only stamps declinedPendingCancellationAt,
    // not clear pendingCancellation) re-enables the button the same way the Sales list treats it.

  }, {
    key: 'fetchDocxTemplates',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(data) {
        var store, _props, t, auth, res, message, docxPrintTemplates, tempTemplates, statusFieldMap, field;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                _props = this.props, t = _props.t, auth = _props.auth;
                res = void 0;
                _context.prev = 3;
                _context.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/docxtemplates/projects/' + data.project.id + '/templates/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 6:
                res = _context.sent;
                _context.next = 16;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](3);

                Bugsnag.notifyException(_context.t0);
                _context.next = 14;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 14:
                this.setState({ docxPrintTemplates: [] });
                return _context.abrupt('return');

              case 16:
                if (res.ok) {
                  _context.next = 25;
                  break;
                }

                _context.next = 19;
                return res.text();

              case 19:
                message = _context.sent;
                _context.next = 22;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 22:
                this.setState({ docxPrintTemplates: [] });
                _context.next = 31;
                break;

              case 25:
                _context.next = 27;
                return res.json();

              case 27:
                docxPrintTemplates = _context.sent;
                tempTemplates = [];

                if (docxPrintTemplates && docxPrintTemplates.length > 0) {
                  statusFieldMap = {
                    reserved: 'isEnabledOnReserved',
                    booked: 'isEnabledOnBooked',
                    cancelled_developer: 'isEnabledOnCancelled',
                    cancelled_availability: 'isEnabledOnCancelled',
                    sold: 'isEnabledOnSold',
                    sold_spa_signed: 'isEnabledOnSold'
                  };
                  field = statusFieldMap[data.statusID];

                  tempTemplates = docxPrintTemplates.filter(function (template) {
                    return template.isEnabled && field && template[field] && Array.isArray(template.visibleToBusinessUnits) && template.visibleToBusinessUnits.includes(auth.companyBranch.id);
                  }).map(function (template) {
                    return {
                      value: template.id,
                      text: template.name.replace('.docx', ''),
                      type: 'docx'
                    };
                  });
                }
                // always set state so templates from a previous booking are cleared when the
                // current project has none (MS-6015), without resetting on unrelated props changes (MS-6448)
                this.setState({ docxPrintTemplates: tempTemplates });

              case 31:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 9]]);
      }));

      function fetchDocxTemplates(_x) {
        return _ref.apply(this, arguments);
      }

      return fetchDocxTemplates;
    }()
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var admin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var dhq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var dbl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var internal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      var auth = this.props.auth;
      if (dbl && this.props.auth.isBranchLeader) {
        return true;
      }
      if (dhq && this.props.auth.isHeadquarters) {
        return true;
      }
      if (admin && this.props.auth.isSuperAdmin) {
        return true;
      }
      if (internal && auth && auth.companyBranch && !auth.companyBranch.isExternal) {
        return true;
      }
      return check;
    }
  }, {
    key: 'fetchProject',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(projectID) {
        var store, t, res, message, projectToken, project;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setState({ loading: true });

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context2.prev = 5;
                _context2.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + projectID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context2.sent;
                _context2.next = 19;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](5);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context2.next = 18;
                return this.setState({ loading: false });

              case 18:
                return _context2.abrupt('return');

              case 19:
                if (res.ok) {
                  _context2.next = 27;
                  break;
                }

                _context2.next = 22;
                return res.text();

              case 22:
                message = _context2.sent;
                _context2.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context2.next = 38;
                break;

              case 27:
                projectToken = res.headers.get('X-Csrf-Token');
                _context2.next = 30;
                return res.json();

              case 30:
                project = _context2.sent;
                _context2.next = 33;
                return this.setState({
                  projectToken: projectToken,
                  project: project
                });

              case 33:
                if (isPRS) {
                  _context2.next = 38;
                  break;
                }

                _context2.next = 36;
                return this.checkAutoReleaseTimer();

              case 36:
                _context2.next = 38;
                return this.checkAgingArEnabled();

              case 38:
                _context2.next = 40;
                return this.setState({ loading: false });

              case 40:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 11]]);
      }));

      function fetchProject(_x7) {
        return _ref2.apply(this, arguments);
      }

      return fetchProject;
    }()
  }, {
    key: 'fetchSystemSettings',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this3 = this;

        var store, t, res, message, systemData;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setState({ loading: true });

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context3.prev = 5;
                _context3.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/settings/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context3.sent;
                _context3.next = 19;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](5);

                Bugsnag.notifyException(_context3.t0);
                _context3.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context3.next = 18;
                return this.setState({ loading: false });

              case 18:
                return _context3.abrupt('return');

              case 19:
                if (res.ok) {
                  _context3.next = 27;
                  break;
                }

                _context3.next = 22;
                return res.text();

              case 22:
                message = _context3.sent;
                _context3.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context3.next = 32;
                break;

              case 27:
                _context3.next = 29;
                return res.json();

              case 29:
                systemData = _context3.sent;
                _context3.next = 32;
                return this.setState({
                  systemData: systemData
                });

              case 32:
                _context3.next = 34;
                return this.setState({ loading: false }, function () {
                  if (_this3.state.data && _this3.state.data.project) {
                    _this3.handleFetchAllBankCases(_this3.state.data);
                  }
                });

              case 34:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 11]]);
      }));

      function fetchSystemSettings() {
        return _ref3.apply(this, arguments);
      }

      return fetchSystemSettings;
    }()
  }, {
    key: 'fetchMaUserAffiliateCompanyBranch',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(branchID) {
        var store, t, res, message, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setState({ loading: true });

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context4.prev = 5;
                _context4.next = 8;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/company_branches/' + branchID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context4.sent;
                _context4.next = 19;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](5);

                Bugsnag.notifyException(_context4.t0);
                _context4.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context4.next = 18;
                return this.setLoading(false);

              case 18:
                return _context4.abrupt('return');

              case 19:
                if (res.ok) {
                  _context4.next = 27;
                  break;
                }

                _context4.next = 22;
                return res.text();

              case 22:
                message = _context4.sent;
                _context4.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context4.next = 33;
                break;

              case 27:
                _context4.next = 29;
                return res.json();

              case 29:
                data = _context4.sent;

                if (!data.name) {
                  _context4.next = 33;
                  break;
                }

                _context4.next = 33;
                return this.setState({ maUserAffiliateCompanyBranchName: data.name });

              case 33:
                _context4.next = 35;
                return this.setState({ loading: true });

              case 35:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 11]]);
      }));

      function fetchMaUserAffiliateCompanyBranch(_x8) {
        return _ref4.apply(this, arguments);
      }

      return fetchMaUserAffiliateCompanyBranch;
    }()
  }, {
    key: 'sendEmail',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(body) {
        var store, _props2, t, token, data, res, message;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _props2 = this.props, t = _props2.t, token = _props2.token;
                data = this.state.data;
                res = void 0;
                _context5.prev = 6;
                _context5.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + data.id + '/customers/' + data.bookingCustomer.customerID + '/send_email/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': token
                  },
                  body: JSON.stringify(body)
                }));

              case 9:
                res = _context5.sent;
                _context5.next = 20;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5['catch'](6);

                Bugsnag.notifyException(_context5.t0);
                _context5.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context5.next = 19;
                return this.setLoading(false);

              case 19:
                return _context5.abrupt('return');

              case 20:
                if (res.ok) {
                  _context5.next = 28;
                  break;
                }

                _context5.next = 23;
                return res.text();

              case 23:
                message = _context5.sent;
                _context5.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context5.next = 30;
                break;

              case 28:
                _context5.next = 30;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Share Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Successfully generate and send email to primary purchaser', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 30:
                _context5.next = 32;
                return this.setLoading(false);

              case 32:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[6, 12]]);
      }));

      function sendEmail(_x9) {
        return _ref5.apply(this, arguments);
      }

      return sendEmail;
    }()
  }, {
    key: 'updateProject',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(project, link) {
        var store, t, res, projectData;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                _context6.next = 4;
                return this.setState({ loading: true });

              case 4:
                res = void 0;
                _context6.prev = 5;
                _context6.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + project.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.projectToken
                  },
                  body: JSON.stringify(project)
                }));

              case 8:
                res = _context6.sent;
                _context6.next = 15;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6['catch'](5);

                Bugsnag.notifyException(_context6.t0);
                store.dispatch((0, _flash.flashErrorMessage)(t('An error occured', { ns: _translation.TRANSLATION_FILES.translation })));

              case 15:
                _context6.next = 17;
                return res.json();

              case 17:
                projectData = _context6.sent;
                _context6.next = 20;
                return this.setState({ project: projectData, loading: false }, function () {
                  window.open(link, '_blank');
                });

              case 20:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[5, 11]]);
      }));

      function updateProject(_x10, _x11) {
        return _ref6.apply(this, arguments);
      }

      return updateProject;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          allBankCases = _state.allBankCases,
          data = _state.data,
          hasDropCase = _state.hasDropCase,
          loading = _state.loading,
          isMobile = _state.isMobile,
          printTemplates = _state.printTemplates,
          tabID = _state.tabID,
          sectionTabs = _state.sectionTabs,
          maUserAffiliateCompanyBranchName = _state.maUserAffiliateCompanyBranchName,
          refreshPage = _state.refreshPage,
          docxPrintTemplates = _state.docxPrintTemplates;
      var _props3 = this.props,
          t = _props3.t,
          auth = _props3.auth;

      var printTmplOnly = printTemplates ? printTemplates.filter(function (_ref7) {
        var value = _ref7.value;
        return value !== 'customer_identities';
      }) : [];
      var combinedPrintTemplates = [].concat(_toConsumableArray(docxPrintTemplates), _toConsumableArray(printTemplates));
      var combinedPrintTmplOnly = combinedPrintTemplates ? combinedPrintTemplates.filter(function (_ref8) {
        var value = _ref8.value;
        return value !== 'customer_identities';
      }) : [];
      var sectionProps = _extends({}, this.props, { combinedPrintTmplOnly: combinedPrintTmplOnly, isMobile: isMobile, maUserAffiliateCompanyBranchName: maUserAffiliateCompanyBranchName, refreshPage: refreshPage });
      var isPrinting = this.state.isPrinting;


      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t((0, _countries.isCountryVietnam)(auth.company.countryCode) ? 'Sales Overview' : 'Booking Overview', { ns: _translation.TRANSLATION_FILES.translation }),
          rightNav: this.checkAllowPrint(data && data) || this.canShowVNCancel() ? _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(
              'div',
              { className: 'printButton' },
              this.checkAllowPrint(data && data) && _react2.default.createElement(
                _react2.default.Fragment,
                null,
                data.project.printPDF && printTmplOnly.length === 1 ? _react2.default.createElement(
                  _reactRouter.Link,
                  {
                    as: 'a',
                    className: 'ui medium compact primary button icon',
                    disabled: loading,
                    onClick: this.handlePrint,
                    target: '_blank',
                    to: _config2.default.get('bookApiURL') + '/bookings/' + (data ? data.id : '') + '/template/' + btoa(printTemplates[0].value) + '/print/?pdf=true'
                  },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'file outline pdf', fitted: isMobile }),
                  _react2.default.createElement(
                    'small',
                    null,
                    isMobile ? '' : ' PDF'
                  )
                ) : data.project.printPDF && printTmplOnly.length > 1 && _react2.default.createElement(
                  _semanticUiReact.Dropdown,
                  {
                    pointing: 'top right',
                    button: true,
                    compact: true,
                    labeled: !isMobile,
                    icon: 'file outline pdf',
                    text: isMobile ? '' : 'PDF',
                    className: 'ui medium compact primary button icon print_dropdown',
                    style: {
                      marginRight: '10px',
                      height: '30px',
                      verticalAlign: 'middle'
                    }
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Dropdown.Menu,
                    null,
                    printTmplOnly.map(function (_ref9) {
                      var text = _ref9.text,
                          value = _ref9.value,
                          type = _ref9.type;
                      return _react2.default.createElement(
                        _semanticUiReact.Dropdown.Item,
                        {
                          key: value + '_' + text,
                          name: 'printType',
                          value: value,
                          onClick: function onClick(e, form) {
                            return _this4.handlePrintForm(e, form, true, type);
                          }
                        },
                        text
                      );
                    })
                  )
                ),
                combinedPrintTemplates.length === 1 ? function () {
                  var template = combinedPrintTemplates[0];
                  var isDocx = template.type === 'docx';
                  var showLoading = isDocx && isPrinting;
                  return _react2.default.createElement(
                    _reactRouter.Link,
                    {
                      as: 'a',
                      className: 'ui medium compact primary button icon ' + (showLoading ? 'disabled' : ''),
                      disabled: showLoading,
                      onClick: function onClick(e) {
                        e.preventDefault();
                        if (showLoading) return; // Prevent clicking while loading
                        _this4.handlePrintForm(e, { value: template.value }, false, template.type);
                      },
                      target: '_blank',
                      to: !isDocx ? _this4.getPrintLink(data, template) : '#'
                    },
                    showLoading ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'spinner', loading: true, fitted: isMobile }) : _react2.default.createElement(_semanticUiReact.Icon, { name: 'print', fitted: isMobile }),
                    _react2.default.createElement(
                      'small',
                      null,
                      isMobile ? '' : ' ' + (showLoading ? t('Printing...') : t('Print'))
                    )
                  );
                }() : _react2.default.createElement(
                  _semanticUiReact.Dropdown,
                  {
                    pointing: 'top right',
                    button: true,
                    labeled: !isMobile,
                    icon: 'print',
                    text: isMobile ? '' : t('Print'),
                    className: 'ui medium compact primary button icon print_dropdown',
                    loading: isPrinting,
                    disabled: isPrinting,
                    style: {
                      marginRight: '10px',
                      height: '30px',
                      verticalAlign: 'middle'
                    }
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Dropdown.Menu,
                    null,
                    combinedPrintTemplates.map(function (_ref10) {
                      var text = _ref10.text,
                          value = _ref10.value,
                          type = _ref10.type;
                      return _react2.default.createElement(
                        _semanticUiReact.Dropdown.Item,
                        {
                          key: value + '_' + text,
                          name: 'printType',
                          value: value,
                          onClick: function onClick(e, form) {
                            return _this4.handlePrintForm(e, form, false, type);
                          }
                        },
                        text
                      );
                    })
                  )
                ),
                data.project.allowSendFormsEmail && combinedPrintTemplates.length > 0 && _react2.default.createElement(_semanticUiReact.Popup, {
                  content: t('Primary purchaser\'s email address is required'),
                  disabled: !!(data.bookingCustomer && data.bookingCustomer.email),
                  trigger: _react2.default.createElement(
                    'div',
                    { style: { display: 'inline-block' } },
                    _react2.default.createElement(
                      _semanticUiReact.Button,
                      {
                        className: 'ui medium compact primary button icon',
                        icon: true,
                        labelPosition: isMobile ? '' : 'left',
                        disabled: data.bookingCustomer && !data.bookingCustomer.email,
                        onClick: this.handleOnOpenShareEmail,
                        style: { height: '30px', verticalAlign: 'middle', fontSize: '12px' }
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'share square', fitted: isMobile }),
                      isMobile ? '' : t('Share')
                    )
                  )
                }),
                _react2.default.createElement(_FormSharingModal2.default, {
                  open: this.state.showShareEmailModal,
                  onClose: this.handleOnCloseShareEmail,
                  onProceed: this.handleProceedShareEmail,
                  printTemplates: combinedPrintTemplates
                })
              ),
              this.renderCancelAction()
            )
          ) : null,
          bottomNode: _react2.default.createElement(_BookingSectionTab2.default, {
            loading: this.state.loading,
            isMobile: isMobile,
            isSticky: true,
            onTabChange: this.handleTabChange,
            tabs: sectionTabs,
            tabID: tabID
          })
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_BookingSectionTab2.default, {
                    loading: this.state.loading,
                    isMobile: isMobile,
                    onTabChange: this.handleTabChange,
                    tabs: sectionTabs,
                    tabID: tabID
                  }),
                  this.renderAutoRelease(),
                  !isPRS && this.checkIfAgingBannerIsVisible() && this.renderAgingAutoRelease()
                )
              )
            ),
            tabID === 1 && _react2.default.createElement(_Info2.default, sectionProps),
            tabID === 2 && _react2.default.createElement(_Purchaser2.default, sectionProps),
            tabID === 3 && _react2.default.createElement(_Tracker2.default, _extends({}, sectionProps, { allBankCases: allBankCases, hasDropCase: hasDropCase })),
            tabID === 4 && _react2.default.createElement(_PaymentPlan2.default, _extends({}, sectionProps, { refetchBookingPaymentPlan: this.getBookingPaymentPlan })),
            tabID === 5 && _react2.default.createElement(_Documents2.default, sectionProps),
            tabID === 7 && _react2.default.createElement(_Buyer2.default, sectionProps)
          )
        ),
        this.renderCancelModal()
      );
    }
  }]);

  return Overview;
}(_react.Component);

Overview.contextTypes = {
  store: _propTypes2.default.object
};
Overview.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      noeticIsEnabled: _propTypes2.default.bool,
      lawyerIsEnabled: _propTypes2.default.bool,
      settings: _propTypes2.default.shape({
        bookingHideLoanTracker: _propTypes2.default.bool
      })
    })
  }),
  auth: _propTypes2.default.shape({
    companyBranch: _propTypes2.default.shape({
      id: _propTypes2.default.number
    }),
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    }),
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    creditCheckAccess: _propTypes2.default.bool,
    allowEditUnitPrice: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool
  }),
  routeParamsID: _propTypes2.default.string,
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  bobForms: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  templates: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      print: _propTypes2.default.array
    })
  }),
  fetchNewBooking: _propTypes2.default.func,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func,
  checkHasChanges: _propTypes2.default.func,
  token: _propTypes2.default.string,
  t: _propTypes2.default.func,
  // CPI-974 (E): supplied by containers/Bookings/Bookings.jsx, undefined off Vietnam.
  opportunity: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  onRequestBookingCancellation: _propTypes2.default.func
};

Overview.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig,
    bobForms: state.bobForms,
    templates: state.templates
  };
};

Overview.getPropsToState = function (props) {
  var windowWidth = window.innerWidth;
  var query = (0, _url.decodeSearch)(props.location.search);
  var isMobile = windowWidth < 768;
  var loading = props.loading;
  var hideLoanTracker = props.appConfig && props.appConfig.data && props.appConfig.data.settings && props.appConfig.data.settings.bookingHideLoanTracker;
  var data = Object.assign({}, _booking2.default, props.data);
  var isMalaysia = props.auth && props.auth.company && props.auth.company.countryCode.toUpperCase() === 'MY';
  var tabID = 1;
  switch (query.section) {
    case 'info':
      tabID = 1;
      break;
    case 'purchaser':
      tabID = 2;
      break;
    case 'tracker':
      tabID = 3;
      break;
    case 'payment_plan':
      tabID = 4;
      break;
    case 'documents':
      tabID = 5;
      break;
    case 'logs':
      tabID = 6;
      break;
    case 'buyer':
      tabID = 7;
      break;
    default:
      tabID = 1;
      break;
  }
  // CPI-974 (AC16): with the tab gone, ?section=buyer would still have rendered the panel.
  if (tabID === 7 && (0, _vietnam.isVietnamCompany)(props.auth)) {
    tabID = 1;
  }
  // CPI-976: Vietnam's E-Sign is hidden on the Purchaser tab; the description should not mention it.
  var sectionTabs = [{ id: 1, title: 'Info', description: 'Status, Pricing & Payment' }, { id: 2, title: 'Purchaser', description: (0, _vietnam.isVietnamCompany)(props.auth) ? 'Details & Eligibility' : 'Details, E-Sign & Eligibility' }, { id: 3, title: 'Tracker', description: 'Loan & SPA/LA Tracker', disabled: hideLoanTracker }];
  sectionTabs.push.apply(sectionTabs, _toConsumableArray(!isMalaysia ? [{
    id: 4,
    title: 'Payment Plan',
    description: 'Pending Selection',
    disabled: data.project && !data.project.paymentPlanFlow
  }] : []).concat([{ id: 5, title: 'Documents', description: 'Document Sharing' }, { id: 6, title: 'Logs', description: 'Activity Logs', page: 'activities/' }]));
  // CPI-974 (AC16): Vietnam has no MHub Buyer App, and the buyerProfileID arm means the
  // project flag alone would still show the tab on a booking that was linked earlier.
  if (!(0, _vietnam.isVietnamCompany)(props.auth) && (data.buyerProfileID || data.project.linkBuyerApp && !_bookingStatuses.CANCELLED_BOOKING_STATUSES.some(function (s) {
    return data.statusID === s.value;
  }))) {
    sectionTabs.push({ id: 7, title: 'Buyer App', description: 'Status & Progress' });
  }
  return {
    data: data,
    isMobile: isMobile,
    loading: loading,
    oriData: (0, _clone2.default)(data),
    tabID: tabID,
    sectionTabs: sectionTabs,
    refreshPage: false
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.checkAllowPrint = function (data) {
    var _props$auth = _this5.props.auth,
        isBranchLeader = _props$auth.isBranchLeader,
        isHeadquarters = _props$auth.isHeadquarters;

    var isCancelledStatus = data.statusID === 'cancelled_developer' || data.statusID === 'cancelled_availability';

    if (data.project.projectFormAccessibilities && data.project.projectFormAccessibilities.length > 0 && data.statusID || _this5.state.docxPrintTemplates && _this5.state.docxPrintTemplates.length && data.statusID) {
      if (data.project.hidePrintAgentStaff) {
        // If HidePrintAgentStaff is ticked && booking is under Reserved OR Cancelled status && isBranchLeader or HQ then allow print
        if ((data.statusID === 'reserved' || isCancelledStatus) && (isBranchLeader || isHeadquarters)) {
          return true;
        }
        // If HidePrintAgentStaff is ticked && booking is under Booked or Sold status then allow print for all
        if (data.statusID === 'booked' || data.statusID === 'sold_spa_signed') {
          return true;
        }
      } else {
        // If HidePrintAgent is not ticked and not PRS server, then allow print
        if (!isPRS) return true;
        // If HidePrint is not ticked, is PRS server && statusID is booked OR sold, then allow print
        if (data.project.projectFormAccessibilities && data.project.projectFormAccessibilities.length > 0 && (data.statusID && data.statusID === 'booked' || data.statusID && data.statusID === 'sold_spa_signed' || isCancelledStatus || _this5.hasAccess()) || _this5.state.docxPrintTemplates && _this5.state.docxPrintTemplates.length > 0 && (data.statusID && data.statusID === 'booked' || data.statusID && data.statusID === 'sold_spa_signed' || isCancelledStatus || _this5.hasAccess())) {
          return true;
        }
      }
    }
    return false;
  };

  this.canShowVNCancel = function () {
    var _props4 = _this5.props,
        auth = _props4.auth,
        opportunity = _props4.opportunity;

    return (0, _countries.isCountryVietnam)(auth.company.countryCode) && (0, _vietnam.hasVietnamElevatedAccess)(auth) && !!(opportunity && opportunity.id);
  };

  this.isVNCancelInProgress = function () {
    var data = _this5.state.data;

    if (!data) return false;
    if (_bookingStatuses.CANCELLED_BOOKING_STATUSES.some(function (s) {
      return data.statusID === s.value;
    })) return true;
    return (0, _bookingStatuses.isBookingPendingCancellation)(data);
  };

  this.handleOpenCancelModal = function () {
    _this5.setState({ showCancelModal: true });
  };

  this.handleCloseCancelModal = function () {
    _this5.setState({ showCancelModal: false });
  };

  this.renderCancelAction = function () {
    if (!_this5.canShowVNCancel()) return null;
    var t = _this5.props.t;
    var isMobile = _this5.state.isMobile;

    var inProgress = _this5.isVNCancelInProgress();
    var button = _react2.default.createElement(
      _semanticUiReact.Button,
      {
        className: 'ui medium compact button icon',
        icon: true,
        labelPosition: isMobile ? '' : 'left',
        disabled: inProgress,
        onClick: _this5.handleOpenCancelModal,
        style: { height: '30px', verticalAlign: 'middle', fontSize: '12px' }
      },
      _react2.default.createElement(_semanticUiReact.Icon, { name: 'times circle outline', color: inProgress ? 'grey' : 'red', fitted: isMobile }),
      isMobile ? '' : t('Cancel Booking', { ns: _translation.TRANSLATION_FILES.translation })
    );
    if (!inProgress) return button;
    return _react2.default.createElement(_semanticUiReact.Popup, {
      content: t('A cancellation request is already in progress', { ns: _translation.TRANSLATION_FILES.translation }),
      trigger: _react2.default.createElement(
        'div',
        { style: { display: 'inline-block' } },
        button
      )
    });
  };

  this.renderCancelModal = function () {
    if (!_this5.canShowVNCancel()) return null;
    var _props5 = _this5.props,
        opportunity = _props5.opportunity,
        onRequestBookingCancellation = _props5.onRequestBookingCancellation;

    return _react2.default.createElement(_OpportunityCancelModal2.default, {
      open: _this5.state.showCancelModal,
      srCode: opportunity.sr_code,
      onClose: _this5.handleCloseCancelModal,
      onSubmit: function onSubmit(status, reason, cancellationType) {
        return onRequestBookingCancellation(reason, cancellationType);
      }
    });
  };

  this.checkICIsImage = function (customer) {
    var isImage = customer.icFrontDocumentID !== '' || customer.icBackDocumentID !== '';
    if (customer.icFrontDocumentID !== '' && customer.icFrontDocument && customer.icFrontDocument.name) {
      // NOTE: this checking will not work if filename don't hav extension
      if (customer.icFrontDocument.name.toLowerCase().includes('.pdf')) isImage = false;
    }
    if (customer.icBackDocumentID !== '' && customer.icBackDocument && customer.icBackDocument.name) {
      // NOTE: this checking will not work if filename don't hav extension
      if (customer.icBackDocument.name.toLowerCase().includes('.pdf')) isImage = false;
    }
    return isImage;
  };

  this.checkIfCompanyBranchAllowedToViewForm = function (formAccessibility) {
    var auth = _this5.props.auth;
    // empty company branch IDs means accessible to all

    if (formAccessibility && (!formAccessibility.companyBranchIDs || formAccessibility.companyBranchIDs.length === 0)) {
      return true;
    }
    if (formAccessibility && formAccessibility.companyBranchIDs && auth.companyBranch && auth.companyBranch.id && formAccessibility.companyBranchIDs.includes(auth.companyBranch.id)) {
      return true;
    }
    return false;
  };

  this.checkIfBookingStatusAllowedToViewForm = function (formAccessibility, booking) {
    if (booking.statusID === 'expired') {
      return true;
    }
    switch (booking.statusID) {
      case 'reserved':
        return formAccessibility && formAccessibility.isEnabledOnReserved;
      case 'booked':
        return formAccessibility && formAccessibility.isEnabledOnBooked;
      case 'cancelled_developer':
      case 'cancelled_availability':
        return formAccessibility && (formAccessibility.isEnabledOnCancelled === undefined || formAccessibility.isEnabledOnCancelled);
      case 'sold_spa_signed':
        return formAccessibility && formAccessibility.isEnabledOnSold;
      default:
        return false;
    }
  };

  this.checkIfFormAccessibleToViewForm = function (currentPFA, booking) {
    var data = _this5.state.data;

    var formAccessibilities = data && data.project && data.project.projectFormAccessibilities ? data.project.projectFormAccessibilities : [];
    var pfaIdx = formAccessibilities.findIndex(function (fa) {
      return fa.templateID === currentPFA.templateID;
    });
    if (pfaIdx !== -1) {
      var selectedPfa = formAccessibilities[pfaIdx];
      var isCompanyBranchAllowedToView = _this5.checkIfCompanyBranchAllowedToViewForm(selectedPfa);
      var isBookingStatusAllowedToView = _this5.checkIfBookingStatusAllowedToViewForm(selectedPfa, booking);
      return isCompanyBranchAllowedToView && isBookingStatusAllowedToView;
    }
    return false;
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var loadingType = arguments[1];
    return new Promise(function (res) {
      if (loadingType === 'validatingTIN') {
        _this5.setState({ validatingTin: loading }, res);
      } else {
        _this5.setState({ loading: loading }, res);
      }
    });
  };

  this.fetchPrintTypes = function () {
    var _props6 = _this5.props,
        templates = _props6.templates,
        t = _props6.t;
    var data = _this5.state.data;

    var output = [];
    if (data && data.project && data.project.projectFormAccessibilities && templates && templates.data && templates.data.print) {
      data.project.projectFormAccessibilities.forEach(function (pfa) {
        var isAllowedToView = _this5.checkIfFormAccessibleToViewForm(pfa, data);
        if (isAllowedToView) {
          var selectedTemplate = templates.data.print.find(function (pt) {
            return pt.id === pfa.templateID;
          });
          if (selectedTemplate && selectedTemplate.name && selectedTemplate.id) {
            output.push({ value: selectedTemplate.id, text: selectedTemplate.name });
          }
        }
      });
    }
    // if (data
    //   && data.project
    //   && data.project.bobFormIDs
    //   && bobForms
    //   && bobForms.data
    // ) {
    //   data.project.bobFormIDs.forEach((pbf) => {
    //     bobForms.data.forEach((bf) => {
    //       if (pbf === bf.id) {
    //         output.push({
    //           value: pbf,
    //           text: bf.title,
    //           type: 'BOB',
    //         });
    //       }
    //     });
    //   });
    // }

    // add IC options if customer has IC images uploaded
    if (data && data.bookingCustomers && data.bookingCustomers.length > 0) {
      if (data.bookingCustomers.some(function (bc) {
        return _this5.checkICIsImage(bc.customer);
      })) {
        output.push({
          value: 'customer_identities',
          text: t('Purchasers’ IC')
        });
      }
    }

    _this5.setState({ printTemplates: output });
  };

  this.checkAutoReleaseTimer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
    var _state2, allBankCases, data, systemData, project, primaryBookingCustomer, systemTimer, projectTimer, hasFrontIC, hasBackIC, hasPaid, hasMortgageAdded, isBankerSourceOfFinance, allPurchasersHasUploadedIC, sysARPaymentEnabled, sysARNricEnabled, sysARAllNricEnabled, sysARMortgageEnabled, projARPaymentEnabled, projARNricEnabled, projARAllNricEnabled, projARMortgageEnabled, sysConditionFulfilledPayment, sysConditionFulfilledNric, sysConditionFulfilledMortgage, projConditionFulfilledPayment, projConditionFulfilledNric, projConditionFulfilledMortgage;

    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _state2 = _this5.state, allBankCases = _state2.allBankCases, data = _state2.data, systemData = _state2.systemData, project = _state2.project;
            // if booking is reserved & system's AR is turned on

            if (!(data && data.statusID === 'reserved' && systemData && project && systemData.arBookingExpIsEnabled)) {
              _context7.next = 50;
              break;
            }

            primaryBookingCustomer = data.bookingCustomers && data.bookingCustomers.find(function (bc) {
              return bc.customerID === data.customerID;
            }) || data.bookingCustomer;
            systemTimer = systemData.arBookingExpMoreThanMinutes !== '' && systemData.arBookingExpMoreThanMinutes !== '0';
            projectTimer = project.arBookingExpMoreThanMinutes !== '' && project.arBookingExpMoreThanMinutes !== '0';
            hasFrontIC = primaryBookingCustomer && primaryBookingCustomer.customer && primaryBookingCustomer.customer.icFrontDocumentID;
            hasBackIC = primaryBookingCustomer && primaryBookingCustomer.customer && primaryBookingCustomer.customer.icBackDocumentID;
            hasPaid = data.paymentStatusID && data.paymentStatusID === 'paid';
            hasMortgageAdded = allBankCases && allBankCases.length > 0;
            isBankerSourceOfFinance = data.paymentMethodID === 'own_banker' || data.paymentMethodID === 'referred_banker';
            allPurchasersHasUploadedIC = data.bookingCustomers && data.bookingCustomers.length > 0 && data.bookingCustomers.filter(function (c) {
              return !c.customer.icFrontDocumentID || !c.customer.icBackDocumentID;
            }).length === 0;

            if (!(systemTimer || projectTimer)) {
              _context7.next = 50;
              break;
            }

            sysARPaymentEnabled = systemData.arBookingExpUnpaidIsEnabled;
            sysARNricEnabled = systemData.arBookingExpNricPicIsEnabled;
            sysARAllNricEnabled = systemData.arBookingExpAllNricPicsIsEnabled;
            sysARMortgageEnabled = systemData.arBookingExpMortgageEnabled && isBankerSourceOfFinance;
            projARPaymentEnabled = project.arBookingExpUnpaidIsEnabled;
            projARNricEnabled = project.arBookingExpNricPicIsEnabled;
            projARAllNricEnabled = project.arBookingExpAllNricPicsIsEnabled;
            projARMortgageEnabled = project.arBookingExpMortgageEnabled && isBankerSourceOfFinance;

            // if either one of the system's requirements is enabled

            if (!(sysARPaymentEnabled || sysARNricEnabled || sysARAllNricEnabled || sysARMortgageEnabled)) {
              _context7.next = 30;
              break;
            }

            // Payment enabled & payment condition fulfilled
            sysConditionFulfilledPayment = sysARPaymentEnabled && hasPaid;
            // IC enabled & IC condition fulfilled

            sysConditionFulfilledNric = sysARNricEnabled && hasBackIC && hasFrontIC;
            // Additional Purchasers IC enabled & all IC condition fulfilled

            if (sysARAllNricEnabled) {
              sysConditionFulfilledNric = allPurchasersHasUploadedIC;
            }
            // All IC enabled & All IC condition fulfilled
            // Mortgage enabled & mortgage condition fulfilled
            sysConditionFulfilledMortgage = sysARMortgageEnabled && hasMortgageAdded;

            if (!(
            // all enabled and all conditions fulfilled
            sysConditionFulfilledPayment && sysConditionFulfilledNric && sysARMortgageEnabled ||
            // IC & mortgage enabled & both conditions fulfilled, payment disabled
            !sysARPaymentEnabled && sysConditionFulfilledNric && sysConditionFulfilledMortgage ||
            // Payment & mortgage enabled & both conditions fulfilled, NRIC disabled
            sysConditionFulfilledPayment && !sysARNricEnabled && sysConditionFulfilledMortgage ||
            // Payment & IC enabled & both conditions fulfilled, mortgage disabled
            sysConditionFulfilledPayment && sysConditionFulfilledNric && !sysARMortgageEnabled ||
            // Mortgage enabled & mortgage condition fulfilled, payment & nric disabled
            !sysARPaymentEnabled && !sysARNricEnabled && sysConditionFulfilledMortgage ||
            // IC enabled & IC condition fulfilled, payment & mortgage disabled
            !sysARPaymentEnabled && sysConditionFulfilledNric && !sysARMortgageEnabled ||
            // Payment enabled & payment condition fulfilled, nric & mortgage disabled
            sysConditionFulfilledPayment && !sysARNricEnabled && !sysARMortgageEnabled)) {
              _context7.next = 28;
              break;
            }

            _this5.setState({ isAutoReleaseTimerEnabled: false });
            return _context7.abrupt('return');

          case 28:
            _context7.next = 48;
            break;

          case 30:
            if (!(project.arBookingExpIsEnabled && (projARPaymentEnabled || projARNricEnabled || projARAllNricEnabled || projARMortgageEnabled))) {
              _context7.next = 40;
              break;
            }

            // Payment enabled & payment condition fulfilled
            projConditionFulfilledPayment = projARPaymentEnabled && hasPaid;
            // IC enabled & IC condition fulfilled

            projConditionFulfilledNric = projARNricEnabled && hasBackIC && hasFrontIC;
            // Additional Purchasers IC enabled & all IC condition fulfilled

            if (projARAllNricEnabled) {
              projConditionFulfilledNric = allPurchasersHasUploadedIC;
            }
            // Mortgage enabled & mortgage condition fulfilled
            projConditionFulfilledMortgage = projARMortgageEnabled && hasMortgageAdded;

            if (!(
            // all enabled and all conditions fulfilled
            projConditionFulfilledPayment && projConditionFulfilledNric && projARMortgageEnabled ||
            // IC & mortgage enabled & both conditions fulfilled, payment disabled
            !projARPaymentEnabled && projConditionFulfilledNric && projConditionFulfilledMortgage ||
            // Payment & mortgage enabled & both conditions fulfilled, NRIC disabled
            projConditionFulfilledPayment && !projARNricEnabled && projConditionFulfilledMortgage ||
            // Payment & IC enabled & both conditions fulfilled, mortgage disabled
            projConditionFulfilledPayment && projConditionFulfilledNric && !projARMortgageEnabled ||
            // Mortgage enabled & mortgage condition fulfilled, payment & nric disabled
            !projARPaymentEnabled && !projARNricEnabled && projConditionFulfilledMortgage ||
            // IC enabled & IC condition fulfilled, payment & mortgage disabled
            !projARPaymentEnabled && projConditionFulfilledNric && !projARMortgageEnabled ||
            // Payment enabled & payment condition fulfilled, nric & mortgage disabled
            projConditionFulfilledPayment && !projARNricEnabled && !projARMortgageEnabled)) {
              _context7.next = 38;
              break;
            }

            _this5.setState({ isAutoReleaseTimerEnabled: false });
            return _context7.abrupt('return');

          case 38:
            _context7.next = 48;
            break;

          case 40:
            if (project.arBookingExpIsEnabled) {
              _context7.next = 45;
              break;
            }

            _this5.setState({ isAutoReleaseTimerEnabled: false });
            return _context7.abrupt('return');

          case 45:
            if (!(!sysARPaymentEnabled && !sysARNricEnabled && !sysARAllNricEnabled && !sysARMortgageEnabled && !projARPaymentEnabled && !projARNricEnabled && !projARAllNricEnabled && !projARMortgageEnabled)) {
              _context7.next = 48;
              break;
            }

            _this5.setState({ isAutoReleaseTimerEnabled: false });
            return _context7.abrupt('return');

          case 48:
            _this5.setState({ isAutoReleaseTimerEnabled: true });
            return _context7.abrupt('return');

          case 50:
            _this5.setState({ isAutoReleaseTimerEnabled: false });

          case 51:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, _this5);
  }));
  this.checkAgingArEnabled = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
    var _state3, data, systemData, project, requirementStatusCategories, systemTimer, projectTimer, sysReleaseBookedBookingIsEnabled, sysReleaseReservedBookingIsEnabled, projReleaseBookedBookingIsEnabled, projReleaseReservedBookingIsEnabled;

    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _state3 = _this5.state, data = _state3.data, systemData = _state3.systemData, project = _state3.project;
            requirementStatusCategories = ['reserved', 'booked'];
            // booking not fall under reserved or booked

            if (requirementStatusCategories.includes(data.statusID)) {
              _context8.next = 5;
              break;
            }

            _this5.setState({ isAgingARTimerEnabled: false });
            return _context8.abrupt('return');

          case 5:
            if (!(data && systemData && project && systemData.arBookingExpIsEnabled)) {
              _context8.next = 35;
              break;
            }

            systemTimer = systemData.arAgingBookingExpMoreThanMinutes !== '' && systemData.arAgingBookingExpMoreThanMinutes !== '0';
            projectTimer = project.arAgingBookingExpMoreThanMinutes !== '' && project.arAgingBookingExpMoreThanMinutes !== '0';

            if (!(systemTimer || projectTimer)) {
              _context8.next = 35;
              break;
            }

            sysReleaseBookedBookingIsEnabled = systemData.arAgingBookingExpBookedIsEnabled;
            sysReleaseReservedBookingIsEnabled = systemData.arAgingBookingExpReservedIsEnabled;
            projReleaseBookedBookingIsEnabled = project.arAgingBookingExpBookedIsEnabled;
            projReleaseReservedBookingIsEnabled = project.arAgingBookingExpReservedIsEnabled;

            // if either one of the system's requirements is enabled

            if (!(sysReleaseBookedBookingIsEnabled || sysReleaseReservedBookingIsEnabled)) {
              _context8.next = 19;
              break;
            }

            if (!(data.statusID === 'booked' && !sysReleaseBookedBookingIsEnabled ||
            // booking is reserved, system no release reserved
            data.statusID === 'reserved' && !sysReleaseReservedBookingIsEnabled)) {
              _context8.next = 17;
              break;
            }

            _this5.setState({ isAgingARTimerEnabled: false });
            return _context8.abrupt('return');

          case 17:
            _context8.next = 33;
            break;

          case 19:
            if (!(project.arBookingExpIsEnabled && (projReleaseBookedBookingIsEnabled || projReleaseReservedBookingIsEnabled))) {
              _context8.next = 25;
              break;
            }

            if (!(data.statusID === 'booked' && !projReleaseBookedBookingIsEnabled ||
            // booking is reserved, system no release reserved
            data.statusID === 'reserved' && !projReleaseReservedBookingIsEnabled)) {
              _context8.next = 23;
              break;
            }

            _this5.setState({ isAgingARTimerEnabled: false });
            return _context8.abrupt('return');

          case 23:
            _context8.next = 33;
            break;

          case 25:
            if (project.arBookingExpIsEnabled) {
              _context8.next = 30;
              break;
            }

            _this5.setState({ isAgingARTimerEnabled: false });
            return _context8.abrupt('return');

          case 30:
            if (!(!sysReleaseBookedBookingIsEnabled && !sysReleaseReservedBookingIsEnabled && !projReleaseBookedBookingIsEnabled && !projReleaseReservedBookingIsEnabled)) {
              _context8.next = 33;
              break;
            }

            _this5.setState({ isAgingARTimerEnabled: false });
            return _context8.abrupt('return');

          case 33:
            _this5.setState({ isAgingARTimerEnabled: true });
            return _context8.abrupt('return');

          case 35:
            _this5.setState({ isAgingARTimerEnabled: false });

          case 36:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, _this5);
  }));

  this.getAllBankCases = function (bankCases, bankCaseDrops) {
    var hasDropCase = false;
    var allCases = [];
    if (bankCases) {
      var bankerIDs = new Set(bankCases.map(function (bc) {
        return bc.bankerID;
      }));
      allCases = bankCaseDrops ? [].concat(_toConsumableArray(bankCases), _toConsumableArray(bankCaseDrops.filter(function (bcd) {
        if (!bankerIDs.has(bcd.bankerID)) {
          hasDropCase = true;
          return true;
        }
      }))) : [].concat(_toConsumableArray(bankCases));
    } else if (bankCaseDrops) {
      allCases = [].concat(_toConsumableArray(bankCaseDrops));
      hasDropCase = true;
    }

    _this5.setState({ allBankCases: allCases, hasDropCase: hasDropCase }, function () {
      if (_this5.state.data && _this5.state.data.projectID) {
        _this5.fetchProject(_this5.state.data.projectID);
      }
    });
  };

  this.getCountdownText = function () {
    var _state4 = _this5.state,
        systemData = _state4.systemData,
        project = _state4.project,
        data = _state4.data;
    var t = _this5.props.t;

    var text = '';
    var translatedAnd = ' ' + t('and', { ns: _translation.TRANSLATION_FILES.translation }) + ' ';
    var nricText = t('upload Primary Purchaser(s) IC copy');
    var allNricText = t('upload All Purchasers IC copy');
    var paymentText = t('make Booking fee payment');
    var mortgageText = t('add Banker(s)');
    var isBankerSourceOfFinance = data.paymentMethodID === 'own_banker' || data.paymentMethodID === 'referred_banker';
    var systemArExpMortgageEnabled = systemData && systemData.arBookingExpMortgageEnabled && isBankerSourceOfFinance;
    var projectArExpMortgageEnabled = project && project.arBookingExpMortgageEnabled && isBankerSourceOfFinance;

    // system AR is turned on
    if (systemData && systemData.arBookingExpIsEnabled) {
      // at least 1 of the requirements is turned on
      if (systemData.arBookingExpNricPicIsEnabled || systemData.arBookingExpAllNricPicsIsEnabled || systemData.arBookingExpUnpaidIsEnabled || systemArExpMortgageEnabled) {
        var systemExpNricIsEnabled = systemData.arBookingExpAllNricPicsIsEnabled || systemData.arBookingExpNricPicIsEnabled;
        var systemNricText = nricText;
        if (systemData.arBookingExpAllNricPicsIsEnabled) {
          systemNricText = allNricText;
        }
        // all requirements are turned on
        if (systemExpNricIsEnabled && systemData.arBookingExpUnpaidIsEnabled && systemArExpMortgageEnabled) {
          text = text.concat(systemNricText, ', ', paymentText, translatedAnd, mortgageText);
          // payment & mortgage are turned on
        } else if (!systemExpNricIsEnabled && systemData.arBookingExpUnpaidIsEnabled && systemArExpMortgageEnabled) {
          text = text.concat(paymentText, translatedAnd, mortgageText);
          // nric & mortgage are turned on
        } else if (systemExpNricIsEnabled && !systemData.arBookingExpUnpaidIsEnabled && systemArExpMortgageEnabled) {
          text = text.concat(systemNricText, translatedAnd, mortgageText);
          // nric & payment are turned on
        } else if (systemExpNricIsEnabled && systemData.arBookingExpUnpaidIsEnabled && !systemArExpMortgageEnabled) {
          text = text.concat(systemNricText, translatedAnd, paymentText);
          // mortgage is turned on
        } else if (!systemExpNricIsEnabled && !systemData.arBookingExpUnpaidIsEnabled && systemArExpMortgageEnabled) {
          text = mortgageText;
          // payment is turned on
        } else if (!systemExpNricIsEnabled && systemData.arBookingExpUnpaidIsEnabled && !systemArExpMortgageEnabled) {
          text = paymentText;
          // nric is turned on
        } else if (systemExpNricIsEnabled && !systemData.arBookingExpUnpaidIsEnabled && !systemArExpMortgageEnabled) {
          text = systemNricText;
        }
        // project AR is on & 1 of the requirements is turned on
      } else if (project && project.arBookingExpIsEnabled && (project.arBookingExpNricPicIsEnabled || project.arBookingExpAllNricPicsIsEnabled || project.arBookingExpUnpaidIsEnabled || projectArExpMortgageEnabled)) {
        var projectExpNricIsEnabled = project.arBookingExpAllNricPicsIsEnabled || project.arBookingExpNricPicIsEnabled;
        var projectNricText = nricText;
        if (project.arBookingExpAllNricPicsIsEnabled) {
          projectNricText = allNricText;
        }
        // all requirements are turned on
        if (projectExpNricIsEnabled && project.arBookingExpUnpaidIsEnabled && projectArExpMortgageEnabled) {
          text = text.concat(projectNricText, ', ', paymentText, translatedAnd, mortgageText);
          // payment & mortgage are turned on
        } else if (!projectExpNricIsEnabled && project.arBookingExpUnpaidIsEnabled && projectArExpMortgageEnabled) {
          text = text.concat(paymentText, translatedAnd, mortgageText);
          // nric & mortgage are turned on
        } else if (projectExpNricIsEnabled && !project.arBookingExpUnpaidIsEnabled && projectArExpMortgageEnabled) {
          text = text.concat(projectNricText, translatedAnd, mortgageText);
          // nric & payment are turned on
        } else if (projectExpNricIsEnabled && project.arBookingExpUnpaidIsEnabled && !projectArExpMortgageEnabled) {
          text = text.concat(projectNricText, translatedAnd, paymentText);
          // mortgage is turned on
        } else if (!projectExpNricIsEnabled && !project.arBookingExpUnpaidIsEnabled && projectArExpMortgageEnabled) {
          text = mortgageText;
          // payment is turned on
        } else if (!projectExpNricIsEnabled && project.arBookingExpUnpaidIsEnabled && !projectArExpMortgageEnabled) {
          text = paymentText;
          // nric is turned on
        } else if (projectExpNricIsEnabled && !project.arBookingExpUnpaidIsEnabled && !projectArExpMortgageEnabled) {
          text = projectNricText;
        }
      }
    }

    return '' + t('Please {{text}} as required in this time frame. If not, your reservation will be auto-released.', { text: text });
  };

  this.getAgingCountdownText = function () {
    var _state5 = _this5.state,
        systemData = _state5.systemData,
        project = _state5.project,
        data = _state5.data;

    var text = '';
    var t = _this5.props.t;


    var bookedText = t('Sold or Cancelled');
    var reservedText = t('Booked, Sold or Cancelled');

    var sysReleaseBookedBookingIsEnabled = systemData.arAgingBookingExpBookedIsEnabled;
    var sysReleaseReservedBookingIsEnabled = systemData.arAgingBookingExpReservedIsEnabled;

    var projReleaseBookedBookingIsEnabled = project.arAgingBookingExpBookedIsEnabled;
    var projReleaseReservedBookingIsEnabled = project.arAgingBookingExpReservedIsEnabled;

    var arAgingStatusesID = ['booked', 'reserved'];

    // system AR is turned on
    if (systemData && systemData.arBookingExpIsEnabled) {
      // at least 1 of the requirements is turned on
      if (sysReleaseBookedBookingIsEnabled || sysReleaseReservedBookingIsEnabled) {
        if (sysReleaseBookedBookingIsEnabled && sysReleaseReservedBookingIsEnabled && arAgingStatusesID.includes(data.statusID)) {
          text = bookedText;
        } else if (sysReleaseBookedBookingIsEnabled && data.statusID === 'booked') {
          text = bookedText;
        } else if (sysReleaseReservedBookingIsEnabled && data.statusID === 'reserved') {
          text = reservedText;
        }
        // project AR is on & 1 of the requirements is turned on
      } else if (project && project.arBookingExpIsEnabled && (projReleaseBookedBookingIsEnabled || projReleaseReservedBookingIsEnabled)) {
        if (projReleaseBookedBookingIsEnabled && projReleaseReservedBookingIsEnabled && arAgingStatusesID.includes(data.statusID)) {
          text = bookedText;
        } else if (projReleaseBookedBookingIsEnabled && data.statusID === 'booked') {
          text = bookedText;
        } else if (projReleaseReservedBookingIsEnabled && data.statusID === 'reserved') {
          text = reservedText;
        }
      }
    }

    return '' + t('This reservation is not converted to {{text}} yet. Convert your reservation within the time limit or it will be auto-released.', { text: text });
  };

  this.getBookingPaymentPlan = function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(bookingID) {
      var store, t, res, message, _message, bookingPaymentPlan, sectionTabs;

      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _this5.setState({ loading: true });
              store = _this5.context.store;
              t = _this5.props.t;
              res = void 0;
              _context9.prev = 4;
              _context9.next = 7;
              return store.dispatch((0, _fetchM.fetchM)('/bookings/' + bookingID + '/payment_plan/', {
                credentials: 'include',
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }));

            case 7:
              res = _context9.sent;
              _context9.next = 22;
              break;

            case 10:
              _context9.prev = 10;
              _context9.t0 = _context9['catch'](4);

              if (!(_context9.t0.res && _context9.t0.res.status >= 399 && _context9.t0.res.status < 500)) {
                _context9.next = 17;
                break;
              }

              _context9.next = 15;
              return _context9.t0.res.text();

            case 15:
              message = _context9.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

            case 17:
              _this5.setState({ loading: false });
              Bugsnag.notifyException(_context9.t0);
              _context9.next = 21;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

            case 21:
              return _context9.abrupt('return');

            case 22:
              if (res.ok) {
                _context9.next = 30;
                break;
              }

              _context9.next = 25;
              return res.text();

            case 25:
              _message = _context9.sent;
              _context9.next = 28;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

            case 28:
              _context9.next = 35;
              break;

            case 30:
              _context9.next = 32;
              return res.json();

            case 32:
              bookingPaymentPlan = _context9.sent;

              // mutate payment plan tab's description
              sectionTabs = _lodash2.default.map(_this5.state.sectionTabs, function (st) {
                var nst = _extends({}, st);
                if (st.id === 4) nst.description = _this5.generatePaymentPlanTabDescription(bookingPaymentPlan);
                return nst;
              });

              _this5.setState({ bookingPaymentPlan: bookingPaymentPlan, sectionTabs: sectionTabs });

            case 35:
              _this5.setState({ loading: false });

            case 36:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this5, [[4, 10]]);
    }));

    return function (_x13) {
      return _ref13.apply(this, arguments);
    };
  }();

  this.fetchBankCaseDrops = function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(booking) {
      var store, t, res, message, _message2, data;

      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return _this5.setState({ loading: true });

            case 2:
              store = _this5.context.store;
              t = _this5.props.t;
              res = void 0;
              _context10.prev = 5;
              _context10.next = 8;
              return store.dispatch((0, _fetchM.fetchM)('/bookings/' + booking.id + '/loan_trackers/bank_cases/drop/', {
                credentials: 'include',
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Csrf-Token': _this5.props.token
                }
              }));

            case 8:
              res = _context10.sent;
              _context10.next = 24;
              break;

            case 11:
              _context10.prev = 11;
              _context10.t0 = _context10['catch'](5);
              _context10.next = 15;
              return _this5.setState({ loading: false });

            case 15:
              if (!(_context10.t0.res && _context10.t0.res.status >= 400 && _context10.t0.res.status < 500)) {
                _context10.next = 21;
                break;
              }

              _context10.next = 18;
              return _context10.t0.res.text();

            case 18:
              message = _context10.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
              return _context10.abrupt('return');

            case 21:
              Bugsnag.notifyException(_context10.t0);
              store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
              return _context10.abrupt('return');

            case 24:
              if (res.ok) {
                _context10.next = 32;
                break;
              }

              _context10.next = 27;
              return res.text();

            case 27:
              _message2 = _context10.sent;
              _context10.next = 30;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: _message2 }));

            case 30:
              _context10.next = 36;
              break;

            case 32:
              _context10.next = 34;
              return res.json();

            case 34:
              data = _context10.sent;

              if (data && data.length > 0) {
                _this5.getAllBankCases(booking.bankCases, data);
              } else {
                _this5.getAllBankCases(booking.bankCases);
              }

            case 36:
              _context10.next = 38;
              return _this5.setState({ loading: false });

            case 38:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this5, [[5, 11]]);
    }));

    return function (_x14) {
      return _ref14.apply(this, arguments);
    };
  }();

  this.handleFetchAllBankCases = function (data) {
    if (data.loanTrackerLeadID > 0 && data.project && data.project.autoAssignBankerStatus !== '' && data.project.autoAssignBankerStatus === 'booked' && data.statusID === 'reserved') {
      _this5.fetchBankCaseDrops(data);
    } else {
      _this5.getAllBankCases(data.bankCases);
    }
  };

  this.handlePrint = function () {
    _auth2.default.currentSession();
  };

  this.handlePrintForm = function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(e, form, isPDF) {
      var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var data, query, bobQuery;
      return regeneratorRuntime.wrap(function _callee11$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              data = _this5.state.data;

              if (!(form && form.value)) {
                _context11.next = 25;
                break;
              }

              query = isPDF ? '?pdf=true' : '';

              if (!(type === 'BOB')) {
                _context11.next = 7;
                break;
              }

              bobQuery = isPDF ? '?formID=' + form.value + '&pdf=true' : '?formID=' + form.value;

              window.open(_config2.default.get('bookApiURL') + '/bookings/' + (data ? data.id : '') + '/bob/' + bobQuery, '_blank');
              return _context11.abrupt('return');

            case 7:
              if (!(form.value === 'customer_identities')) {
                _context11.next = 10;
                break;
              }

              window.open(_config2.default.get('bookApiURL') + '/bookings/' + (data ? data.id : '') + '/identities/' + query, '_blank');
              return _context11.abrupt('return');

            case 10:
              if (!(type === 'docx')) {
                _context11.next = 24;
                break;
              }

              _this5.setState({ isPrinting: true });
              _context11.prev = 12;
              _context11.next = 15;
              return _this5.handlePrintDocxTemplate(form.value);

            case 15:
              _context11.next = 20;
              break;

            case 17:
              _context11.prev = 17;
              _context11.t0 = _context11['catch'](12);

              console.error('An error occurred during DOCX generation.', _context11.t0);

            case 20:
              _context11.prev = 20;

              _this5.setState({ isPrinting: false });
              return _context11.finish(20);

            case 23:
              return _context11.abrupt('return');

            case 24:
              window.open(_config2.default.get('bookApiURL') + '/bookings/' + (data ? data.id : '') + '/template/' + btoa(form.value) + '/print/' + query, '_blank');

            case 25:
            case 'end':
              return _context11.stop();
          }
        }
      }, _callee11, _this5, [[12, 17, 20, 23]]);
    }));

    return function (_x15, _x16, _x17) {
      return _ref15.apply(this, arguments);
    };
  }();

  this.handlePrintDocxTemplate = function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(form) {
      var data, store, templateName, docxPrintTemplates, template, res, message, blob, url, downloadLink, contentDisposition, filename, filenameMatch;
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              data = _this5.state.data;
              store = _this5.context.store;
              templateName = 'template';
              docxPrintTemplates = _this5.state.docxPrintTemplates;
              template = docxPrintTemplates.find(function (t) {
                return t.value === form;
              });

              if (template) {
                templateName = template.text.replace(/[^a-zA-Z0-9_-]/g, '_');
              }

              res = void 0;
              _context12.prev = 7;
              _context12.next = 10;
              return store.dispatch((0, _fetchM.fetchM)('/docxtemplates/templates/' + form + '/print/?bookingID=' + data.id, {
                credentials: 'include',
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }));

            case 10:
              res = _context12.sent;
              _context12.next = 24;
              break;

            case 13:
              _context12.prev = 13;
              _context12.t0 = _context12['catch'](7);

              Bugsnag.notifyException(_context12.t0);

              if (!(_context12.t0.res && _context12.t0.res.status >= 400 && _context12.t0.res.status < 500)) {
                _context12.next = 22;
                break;
              }

              _context12.next = 19;
              return _context12.t0.res.text();

            case 19:
              message = _context12.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
              throw _context12.t0;

            case 22:
              store.dispatch((0, _flash.flashErrorMessage)(_context12.t0));
              throw _context12.t0;

            case 24:
              _context12.next = 26;
              return res.blob();

            case 26:
              blob = _context12.sent;
              url = window.URL.createObjectURL(blob);

              window.open(url, '_blank');
              downloadLink = document.createElement('a');

              downloadLink.href = url;

              contentDisposition = res.headers.get('Content-Disposition');
              filename = data.id + '_' + templateName + '.pdf';


              if (contentDisposition) {
                filenameMatch = contentDisposition.match(/filename\*=UTF-8''([^;,\n\r]+)/);

                if (!filenameMatch) {
                  filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
                }
                if (!filenameMatch) {
                  filenameMatch = contentDisposition.match(/filename=([^;,\n\r]+)/);
                }
                if (filenameMatch && filenameMatch[1]) {
                  filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''));
                }
              }
              downloadLink.download = filename;
              document.body.appendChild(downloadLink);
              downloadLink.click();
              document.body.removeChild(downloadLink);
              window.URL.revokeObjectURL(url);

            case 39:
            case 'end':
              return _context12.stop();
          }
        }
      }, _callee12, _this5, [[7, 13]]);
    }));

    return function (_x19) {
      return _ref16.apply(this, arguments);
    };
  }();

  this.getPrintLink = function (data, form) {
    if (form.value === 'customer_identities') {
      return _config2.default.get('bookApiURL') + '/bookings/' + (data ? data.id : '') + '/identities/';
    }
    return _config2.default.get('bookApiURL') + '/bookings/' + (data ? data.id : '') + '/template/' + btoa(form.value) + '/print/';
  };

  this.generatePaymentPlanTabDescription = function (bookingPaymentPlan) {
    if (bookingPaymentPlan && !_lodash2.default.isEmpty(bookingPaymentPlan.id)) {
      var isEdited = _lodash2.default.some(bookingPaymentPlan.bookingPaymentPlanDetails, function (bppd) {
        return bppd.customized;
      });
      return '' + bookingPaymentPlan.code + (isEdited ? ' (edited)' : '');
    }
    return 'Pending Selection';
  };

  this.handleResize = function () {
    var state = {};
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    if (isMobile !== _this5.state.isMobile) {
      state.isMobile = isMobile;
      _this5.setState(_extends({}, state));
    }
  };

  this.handleCountdownFinish = function () {
    var store = _this5.context.store;

    var location = _this5.props.location;
    store.dispatch((0, _reactRouterRedux.replace)(location.pathname + location.search));
    _this5.setState({ refreshPage: true });
  };

  this.handleOnOpenShareEmail = function (e) {
    e.preventDefault();
    _this5.setState({ showShareEmailModal: true });
  };

  this.handleOnCloseShareEmail = function (e) {
    e.preventDefault();
    _this5.setState({ showShareEmailModal: false });
  };

  this.handleProceedShareEmail = function (e, data) {
    e.preventDefault();
    _this5.sendEmail(data);
  };

  this.handleTabChange = function (tabData) {
    if (!tabData) return;
    var tabID = tabData.id;
    var store = _this5.context.store;

    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    var tab = 'info';
    switch (tabID) {
      case 1:
        tab = 'info';
        break;
      case 2:
        tab = 'purchaser';
        break;
      case 3:
        tab = 'tracker';
        break;
      case 4:
        tab = 'payment_plan';
        break;
      case 5:
        tab = 'documents';
        break;
      case 6:
        tab = 'logs';
        break;
      case 7:
        tab = 'buyer';
        break;
      default:
        tab = 'info';
        break;
    }
    query.section = tab;
    _this5.setState({
      tabID: _this5.props.checkHasChanges() ? _this5.state.tabID : tabID
    });
    if (tabData.page) {
      store.dispatch((0, _reactRouterRedux.push)('/bookings/' + _this5.state.data.id + '/' + tabData.page));
    } else {
      var callback = function callback() {
        if (_this5.props.checkHasChanges()) {
          _this5.props.onCheck(false, _this5.setState({ tabID: tabID }));
        }
        if (tabData.isSticky) {
          // Scrolltop
          window.scrollTo(0, 150);
        }
        store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + _this5.state.data.id + '/?' + (0, _url.encodeSearch)(query)));
      };
      if (_this5.props.checkHasChanges()) {
        store.dispatch((0, _prompt.promptChangesMessage)({ message: _promptMessages.DEFAULT_PROMPT, callback: callback }));
      } else {
        callback();
      }
    }
  };

  this.checkIfAgingBannerIsVisible = function () {
    var _state6 = _this5.state,
        isAutoReleaseTimerEnabled = _state6.isAutoReleaseTimerEnabled,
        project = _state6.project,
        systemData = _state6.systemData;

    var systemTimer = systemData && systemData.arBookingExpMoreThanMinutes !== '' && systemData.arBookingExpMoreThanMinutes !== '0';
    if (systemTimer && Number(systemData.arBookingExpMoreThanMinutes) === Number(systemData.arAgingBookingExpMoreThanMinutes)) return true;
    if (!systemTimer && Number(project.arBookingExpMoreThanMinutes) === Number(project.arAgingBookingExpMoreThanMinutes)) return true;
    return !isAutoReleaseTimerEnabled;
  };

  this.renderAutoRelease = function () {
    var _state7 = _this5.state,
        data = _state7.data,
        isAutoReleaseTimerEnabled = _state7.isAutoReleaseTimerEnabled,
        project = _state7.project,
        systemData = _state7.systemData;
    var t = _this5.props.t;

    var systemTimer = systemData && systemData.arBookingExpMoreThanMinutes !== '' && systemData.arBookingExpMoreThanMinutes !== '0';

    // checking for AR start based on arBookingStartDate
    var afterProjectSettingDate = (0, _momentTimezone2.default)(project.arBookingStartDate).diff((0, _momentTimezone2.default)(data.createdAt)) <= 0;
    var enabledForBookingStartDate = !project.arBookingAllUnderReserved && project.arBookingStartDate && afterProjectSettingDate;

    if (isPRS) {
      return _react2.default.createElement(_AutoReleaseTimer2.default, {
        data: data,
        countdownSeconds: 3660,
        countdownText: t('Please fill in all the details or upload Purchaser(s) IC copy as required in this time frame. If not, your reservation will auto-released in 1 hour.'),
        handleCountdownFinish: _this5.handleCountdownFinish
      });
    }
    if (isAutoReleaseTimerEnabled && (project.arBookingAllUnderReserved || enabledForBookingStartDate)) {
      return _react2.default.createElement(_AutoReleaseTimer2.default, {
        data: data,
        countdownSeconds: systemTimer ? Number(systemData.arBookingExpMoreThanMinutes) * 60 : Number(project.arBookingExpMoreThanMinutes) * 60,
        countdownText: _this5.getCountdownText(),
        handleCountdownFinish: _this5.handleCountdownFinish
      });
    }
    return null;
  };

  this.renderAgingAutoRelease = function () {
    var _state8 = _this5.state,
        data = _state8.data,
        isAgingARTimerEnabled = _state8.isAgingARTimerEnabled,
        project = _state8.project,
        systemData = _state8.systemData;

    var systemTimer = systemData && systemData.arAgingBookingExpMoreThanMinutes !== '' && systemData.arAgingBookingExpMoreThanMinutes !== '0';

    // checking for AR start based on arBookingStartDate
    var afterProjectSettingDate = (0, _momentTimezone2.default)(project.arBookingStartDate).diff((0, _momentTimezone2.default)(data.createdAt)) <= 0;
    var enabledForBookingStartDate = !project.arBookingAllUnderReserved && project.arBookingStartDate && afterProjectSettingDate;

    if (isAgingARTimerEnabled && (project.arBookingAllUnderReserved || enabledForBookingStartDate)) {
      return _react2.default.createElement(_AutoReleaseTimer2.default, {
        data: data,
        countdownSeconds: systemTimer ? Number(systemData.arAgingBookingExpMoreThanMinutes) * 60 : Number(project.arAgingBookingExpMoreThanMinutes) * 60,
        countdownText: _this5.getAgingCountdownText(),
        handleCountdownFinish: _this5.handleCountdownFinish
      });
    }
    return null;
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Overview.mapStateToProps)(Overview));

/***/ }),
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _BookingTitle = __webpack_require__(260);

var _BookingTitle2 = _interopRequireDefault(_BookingTitle);

var _booking = __webpack_require__(129);

var _booking2 = _interopRequireDefault(_booking);

var _PaymentPlan = __webpack_require__(2167);

var _amount = __webpack_require__(87);

var _amount2 = _interopRequireDefault(_amount);

var _decimal2 = __webpack_require__(1089);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _arrowUp = __webpack_require__(1595);

var _arrowUp2 = _interopRequireDefault(_arrowUp);

var _arrowDown = __webpack_require__(1594);

var _arrowDown2 = _interopRequireDefault(_arrowDown);

var _companies = __webpack_require__(88);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */
/* eslint-disable arrow-parens */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint jsx-a11y/no-static-element-interactions: 0 */


_momentTimezone2.default.locale('en-gb');

// NOTE: all the amount in this Payment Plan is not being rounded nearest.
// The responsibility of this component is just displaying what is returned from API

var PaymentPlan = function (_Component) {
  _inherits(PaymentPlan, _Component);

  function PaymentPlan(props) {
    _classCallCheck(this, PaymentPlan);

    var _this = _possibleConstructorReturn(this, (PaymentPlan.__proto__ || Object.getPrototypeOf(PaymentPlan)).call(this, props));

    _initialiseProps.call(_this);

    var state = PaymentPlan.getPropsToState(props);
    _this.state = _extends({}, state, {
      isOpenPaymentPlanModal: false,
      isDownpaymentAccordionActive: true,
      isInstalmentAccordionActive: true,
      bookingPaymentPlan: {}
    });
    _this.validation = {};
    _this.loanBox = null;
    return _this;
  }

  _createClass(PaymentPlan, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.state.data && this.state.data.id) {
        this.getBookingPaymentPlan(this.state.data.id);
      }
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var state = PaymentPlan.getPropsToState(nextProps);
      // don't allow state to override data if oriData is same
      var stateIsSame = JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData);
      if (stateIsSame) {
        state.data = this.state.data;
      }

      this.setState(_extends({}, state), function () {
        if (!stateIsSame && state.data.id) {
          _this2.getBookingPaymentPlan(state.data.id);
        }
      });
    }

    // categorized cps by detail type downpayment > instalment > development_stage
    // then sort by sequence no

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          isMobile = _props.isMobile,
          auth = _props.auth,
          t = _props.t;
      var _state = this.state,
          loading = _state.loading,
          data = _state.data,
          bookingPaymentPlan = _state.bookingPaymentPlan;

      var bookingPaymentPlanDetails = bookingPaymentPlan ? bookingPaymentPlan.bookingPaymentPlanDetails : [];
      var cpss = bookingPaymentPlan ? bookingPaymentPlan.contractPaymentSchedules : [];
      var isValidBookingStatus = this.handleCheckIsValidBookingStatus(data.statusID);
      var isMalaysiaCompany = !(0, _companies.isForeignCompany)(auth.company);

      var currency = data.project.projectCurrency;
      var spaPrice = Number((0, _amount.spaFullNumber)(data));
      var depositAmount = parseFloat(data.paymentAmount);

      // downpayment
      var cpsDownpayments = this.getCpsByDetailType(cpss);
      var cpsTotalDownpayments = this.calculateTotalContractPaymentScheduleAmount(cpsDownpayments);

      // instalment
      var cpsInstalments = this.getCpsByDetailType(cpss, 'instalment');
      var cpsTotalInstalments = this.calculateTotalContractPaymentScheduleAmount(cpsInstalments);
      var bookingPaymentPlanDetailInstalment = _lodash2.default.find(bookingPaymentPlanDetails, function (psd) {
        return psd.detailType === 'instalment';
      });
      // total instalment = spaPrice - deposit - total downpayment
      var totalInstalmentAmount = (0, _decimal2.decimalSub)((0, _decimal2.decimalSub)(spaPrice, depositAmount), cpsTotalDownpayments);
      var instalmentPerMonth = bookingPaymentPlanDetailInstalment ? (0, _decimal2.decimalDiv)(totalInstalmentAmount, bookingPaymentPlanDetailInstalment.detailInstalmentCount) : totalInstalmentAmount;

      var noContent = _lodash2.default.isEmpty(cpsDownpayments) && _lodash2.default.isEmpty(cpsInstalments);

      var accordionOptions = [{
        id: 'paymentPlanInformation',
        isTogglable: false,
        title: t('Payment plan information'),
        content: this.renderSubtitle('paymentPlan', [{
          sellingPrice: t('Selling Price'),
          sellingPriceValue: this.renderAmountWithCurrency(spaPrice, currency),
          paymentPlanName: t('Payment Plan'),
          paymentPlanNameValue: bookingPaymentPlan ? bookingPaymentPlan.code : ''
        }, {
          depositAmount: t('Deposit Amount'),
          depositAmountValue: this.renderAmountWithCurrency(depositAmount, currency)
        }])
      }];

      if (!_lodash2.default.isEmpty(cpsDownpayments)) {
        accordionOptions.push({
          id: 'downpaymentInformation',
          name: 'isDownpaymentAccordionActive',
          isTogglable: true,
          title: t('Downpayment'),
          subtitle: this.renderSubtitle('downpayment', [{
            totalDownpaymentAmount: t('Total downpayment'),
            totalDownpaymentAmountValue: this.renderAmountWithCurrency(cpsTotalDownpayments, currency),
            downpaymentCount: t('Number of downpayments'),
            downpaymentCountValue: _lodash2.default.size(cpsDownpayments) || 0
          }]),
          content: this.renderTable({
            headers: ['Downpayment name', 'Value', 'Billing date'],
            rows: _lodash2.default.map(cpsDownpayments, function (d) {
              return {
                id: d.id,
                name: _this3.findDownpaymentName(d.bookingPaymentPlanDetailID, bookingPaymentPlan.bookingPaymentPlanDetails),
                billingAt: d.transactionDate,
                value: _this3.getTransactionAmount(d)
              };
            })
          })
        });
      }

      if (!_lodash2.default.isEmpty(cpsInstalments)) {
        accordionOptions.push({
          id: 'instalmentInformation',
          name: 'isInstalmentAccordionActive',
          isTogglable: true,
          title: t('Instalment'),
          subtitle: this.renderSubtitle('instalment', [{
            totalInstalment: t('Total instalment'),
            totalInstalmentValue: this.renderAmountWithCurrency(cpsTotalInstalments, currency),
            instalmentCount: t('Number of instalments'),
            instalmentCountValue: _lodash2.default.size(cpsInstalments) || 0
          }, {
            instalmentPerMonth: t('Average instalment per month'),
            instalmentPerMonthValue: this.renderAmountWithCurrency(instalmentPerMonth, currency),
            nextBillingDate: t('Next billing date'),
            nextBillingDateValue: (0, _momentTimezone2.default)(cpsInstalments[0].transactionDate).format('DD/MM/YYYY')
          }, {
            lastInstalment: t('Last instalment'),
            lastInstalmentValue: this.renderAmountWithCurrency(this.getTransactionAmount(cpsInstalments[_lodash2.default.size(cpsInstalments) - 1]), currency)
          }]),
          content: this.renderTable({
            headers: ['Downpayment name', 'Value', 'Billing date'],
            rows: _lodash2.default.map(cpsInstalments, function (d, idx) {
              return {
                id: d.id,
                name: t('Instalment') + ' ' + (idx + 1),
                billingAt: d.transactionDate,
                value: _this3.getTransactionAmount(d)
              };
            })
          })
        });
      }

      return _react2.default.createElement(
        _semanticUiReact.Container,
        { className: 'paymentPlan' },
        this.renderModals(loading),
        _react2.default.createElement(_BookingTitle2.default, { isMobile: isMobile, data: data }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, style: isMobile ? { padding: '0' } : {} },
              _react2.default.createElement(
                'div',
                null,
                this.renderHeader(isMobile, noContent || isMalaysiaCompany || !isValidBookingStatus),
                _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { attached: true },
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 16 },
                        bookingPaymentPlan && bookingPaymentPlan.id !== '' ? accordionOptions.map(function (item) {
                          return _this3.renderAccordion(item);
                        }) : this.renderEmptyNode(isMalaysiaCompany, isValidBookingStatus)
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return PaymentPlan;
}(_react.Component);

PaymentPlan.contextTypes = {
  store: _propTypes2.default.object
};
PaymentPlan.propTypes = {
  token: _propTypes2.default.string,
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    creditCheckAccess: _propTypes2.default.bool,
    allowEditUnitPrice: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool,
    company: _propTypes2.default.shape()
  }),
  onCheck: _propTypes2.default.func,
  checkHasChanges: _propTypes2.default.func,
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      leadV2IsEnabled: _propTypes2.default.bool
    })
  }),
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  fetchNewBooking: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  refetchBookingPaymentPlan: _propTypes2.default.func,
  t: _propTypes2.default.func
};

PaymentPlan.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

PaymentPlan.getPropsToState = function (props) {
  var loading = props.loading;
  var data = Object.assign({}, _booking2.default, props.data);
  return {
    data: data,
    loading: loading,
    oriData: (0, _clone2.default)(data)
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this4.setState({ loading: loading }, res);
    });
  };

  this.getCpsByDetailType = function () {
    var cpss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'downpayment';
    return _lodash2.default.filter(cpss, function (cps) {
      var bookingPaymentPlan = _this4.state.bookingPaymentPlan;

      var bppds = bookingPaymentPlan ? bookingPaymentPlan.bookingPaymentPlanDetails : [];
      var psds = _lodash2.default.filter(bppds, function (psd) {
        return psd.id === cps.bookingPaymentPlanDetailID;
      });
      return _lodash2.default.isEmpty(psds) ? false : psds[0].detailType === type;
    });
  };

  this.getTransactionAmount = function (cps) {
    return _this4.amountToNumber(cps.transactionAmountDecimal, cps.transactionAmountFlat, cps.transactionAmountFull, cps.transactionAmountTimes);
  };

  this.getBookingPaymentPlan = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(bookingID) {
      var store, res, message, _message, data, cpss, contractPaymentSchedules;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this4.setLoading(true);

            case 2:
              store = _this4.context.store;
              res = void 0;
              _context.prev = 4;
              _context.next = 7;
              return store.dispatch((0, _fetchM.fetchM)('/bookings/' + bookingID + '/payment_plan/', {
                credentials: 'include',
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }));

            case 7:
              res = _context.sent;
              _context.next = 25;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](4);

              if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                _context.next = 19;
                break;
              }

              _context.next = 15;
              return _context.t0.res.text();

            case 15:
              message = _context.sent;
              _context.next = 18;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

            case 18:
              return _context.abrupt('return');

            case 19:
              _context.next = 21;
              return _this4.setLoading(false);

            case 21:
              Bugsnag.notifyException(_context.t0);
              _context.next = 24;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

            case 24:
              return _context.abrupt('return');

            case 25:
              if (res.ok) {
                _context.next = 33;
                break;
              }

              _context.next = 28;
              return res.text();

            case 28:
              _message = _context.sent;
              _context.next = 31;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

            case 31:
              _context.next = 39;
              break;

            case 33:
              _context.next = 35;
              return res.json();

            case 35:
              data = _context.sent;
              cpss = data ? data.contractPaymentSchedules : [];
              contractPaymentSchedules = _this4.sortContractPaymentSchedule(_this4.mapCpssWithBppdName(cpss, data));

              _this4.setState({
                bookingPaymentPlan: _extends({}, data, {
                  contractPaymentSchedules: contractPaymentSchedules
                })
              });

            case 39:
              _context.next = 41;
              return _this4.setLoading(false);

            case 41:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this4, [[4, 10]]);
    }));

    return function (_x4) {
      return _ref.apply(this, arguments);
    };
  }();

  this.getDownpaymentName = function (bpp, bppdID, cpsName) {
    var currBppd = _lodash2.default.find(bpp.bookingPaymentPlanDetails, function (bppd) {
      return bppd.id === bppdID;
    });
    if (!currBppd) return '';
    var edited = !_lodash2.default.isEmpty(cpsName) && cpsName !== currBppd.downpaymentName;
    return edited ? cpsName : currBppd.downpaymentName;
  };

  this.mapCpssWithBppdName = function () {
    var cpss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var bpp = arguments[1];
    return _lodash2.default.map(cpss, function (cps) {
      return _extends({}, cps, {
        name: _this4.getDownpaymentName(bpp, cps.bookingPaymentPlanDetailID, cps.name)
      });
    }) || [];
  };

  this.createBookingPaymentPlan = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(bookingPaymentPlan, bID) {
      var store, res, message, _message2;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this4.setLoading(true);

            case 2:
              store = _this4.context.store;
              res = void 0;
              _context2.prev = 4;
              _context2.next = 7;
              return store.dispatch((0, _fetchM.fetchM)('/bookings/' + bID + '/payment_plan/', {
                credentials: 'include',
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Csrf-Token': _this4.props.token
                },
                body: JSON.stringify(bookingPaymentPlan)
              }));

            case 7:
              res = _context2.sent;
              _context2.next = 25;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](4);

              if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                _context2.next = 19;
                break;
              }

              _context2.next = 15;
              return _context2.t0.res.text();

            case 15:
              message = _context2.sent;
              _context2.next = 18;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

            case 18:
              return _context2.abrupt('return');

            case 19:
              _context2.next = 21;
              return _this4.setLoading(false);

            case 21:
              Bugsnag.notifyException(_context2.t0);
              _context2.next = 24;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

            case 24:
              return _context2.abrupt('return');

            case 25:
              if (res.ok) {
                _context2.next = 33;
                break;
              }

              _context2.next = 28;
              return res.text();

            case 28:
              _message2 = _context2.sent;
              _context2.next = 31;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: _message2 }));

            case 31:
              _context2.next = 37;
              break;

            case 33:
              _context2.next = 35;
              return res.json();

            case 35:
              _context2.next = 37;
              return store.dispatch((0, _flash.flashSuccessMessage)({ message: 'Booking payment plan has been created successfully' }));

            case 37:
              _context2.next = 39;
              return _this4.setLoading(false);

            case 39:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this4, [[4, 10]]);
    }));

    return function (_x6, _x7) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.updateBookingPaymentPlan = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(bookingPaymentPlan, bID) {
      var store, res, message, _message3;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this4.setLoading(true);

            case 2:
              store = _this4.context.store;
              res = void 0;
              _context3.prev = 4;
              _context3.next = 7;
              return store.dispatch((0, _fetchM.fetchM)('/bookings/' + bID + '/payment_plan/', {
                credentials: 'include',
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Csrf-Token': _this4.props.token
                },
                body: JSON.stringify(bookingPaymentPlan)
              }));

            case 7:
              res = _context3.sent;
              _context3.next = 25;
              break;

            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3['catch'](4);

              if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                _context3.next = 19;
                break;
              }

              _context3.next = 15;
              return _context3.t0.res.text();

            case 15:
              message = _context3.sent;
              _context3.next = 18;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

            case 18:
              return _context3.abrupt('return');

            case 19:
              _context3.next = 21;
              return _this4.setLoading(false);

            case 21:
              Bugsnag.notifyException(_context3.t0);
              _context3.next = 24;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

            case 24:
              return _context3.abrupt('return');

            case 25:
              if (res.ok) {
                _context3.next = 33;
                break;
              }

              _context3.next = 28;
              return res.text();

            case 28:
              _message3 = _context3.sent;
              _context3.next = 31;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: _message3 }));

            case 31:
              _context3.next = 37;
              break;

            case 33:
              _context3.next = 35;
              return res.json();

            case 35:
              _context3.next = 37;
              return store.dispatch((0, _flash.flashSuccessMessage)({ message: 'Booking payment plan has been updated successfully' }));

            case 37:
              _context3.next = 39;
              return _this4.setLoading(false);

            case 39:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this4, [[4, 10]]);
    }));

    return function (_x8, _x9) {
      return _ref3.apply(this, arguments);
    };
  }();

  this.hasAccess = function () {
    var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var admin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    var dhq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var dbl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
    var internal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

    var auth = _this4.props.auth;
    if (dbl && _this4.props.auth.isBranchLeader) {
      return true;
    }
    if (dhq && _this4.props.auth.isHeadquarters) {
      return true;
    }
    if (admin && _this4.props.auth.isSuperAdmin) {
      return true;
    }
    if (internal && auth && auth.companyBranch && !auth.companyBranch.isExternal) {
      return true;
    }
    return check;
  };

  this.handleResize = function () {
    var state = {};
    var windowWidth = window.innerWidth;
    var widthIsLessThan1200 = windowWidth < 1200;
    if (widthIsLessThan1200 !== _this4.state.widthIsLessThan1200) {
      state.widthIsLessThan1200 = widthIsLessThan1200;
    }
    var keys = Object.keys(state);
    if (keys.length > 0) {
      _this4.setState(_extends({}, state));
    }
  };

  this.handleSetState = function (state) {
    return _this4.setState(function (prev) {
      return _extends({}, prev, state);
    });
  };

  this.handleToggle = function (name) {
    return _this4.handleSetState(_defineProperty({}, name, !_this4.state[name]));
  };

  this.checkIsOddNumber = function (number) {
    return number % 2 === 1;
  };

  this.amountToNumber = function (_decimal, _flat, _full, _times) {
    var times = _times || 100;
    var amountStr = (0, _amount2.default)(_decimal, _flat, _full, _times);
    return parseFloat(amountStr).toFixed(times.toString().length - 1);
  };

  this.calculateTotalContractPaymentScheduleAmount = function () {
    var cpss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return cpss.reduce(function (acc, curr) {
      var transactionAmountDecimal = curr.transactionAmountDecimal,
          transactionAmountFlat = curr.transactionAmountFlat,
          transactionAmountFull = curr.transactionAmountFull,
          transactionAmountTimes = curr.transactionAmountTimes;

      var fixAmount = Number(_this4.amountToNumber(transactionAmountDecimal, transactionAmountFlat, transactionAmountFull, transactionAmountTimes));
      return (0, _decimal2.decimalSum)(acc, fixAmount);
    }, 0);
  };

  this.sortContractPaymentScheduleBySeqNo = function () {
    var cpss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    return _lodash2.default.sortBy(cpss, 'sequenceNo');
  };

  this.sortContractPaymentSchedule = function () {
    var cpss = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var cpssDownpayment = _this4.sortContractPaymentScheduleBySeqNo(_lodash2.default.filter(cpss, function (cps) {
      return cps.detailType === 'downpayment';
    }));
    var cpssInstalment = _this4.sortContractPaymentScheduleBySeqNo(_lodash2.default.filter(cpss, function (cps) {
      return cps.detailType === 'instalment';
    }));
    var cpssDevelopmentStage = _this4.sortContractPaymentScheduleBySeqNo(_lodash2.default.filter(cpss, function (cps) {
      return cps.detailType === 'development_stage';
    }));
    return [].concat(_toConsumableArray(cpssDownpayment), _toConsumableArray(cpssInstalment), _toConsumableArray(cpssDevelopmentStage));
  };

  this.handleModalClose = function () {
    return _this4.handleSetState({
      isOpenPaymentPlanModal: false,
      isDownpaymentAccordionActive: true,
      isInstalmentAccordionActive: true
    });
  };

  this.handleCheckIsValidBookingStatus = function (statusID) {
    return _lodash2.default.some(['reserved', 'booked', 'sold_spa_signed'], function (s) {
      return statusID === s;
    });
  };

  this.handleSubmit = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(formBpp, bookingID) {
      var bookingPaymentPlan;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              bookingPaymentPlan = _this4.state.bookingPaymentPlan;

              if (!(bookingPaymentPlan.id === formBpp.id)) {
                _context4.next = 6;
                break;
              }

              _context4.next = 4;
              return _this4.updateBookingPaymentPlan(formBpp, bookingID);

            case 4:
              _context4.next = 8;
              break;

            case 6:
              _context4.next = 8;
              return _this4.createBookingPaymentPlan(formBpp, bookingID);

            case 8:
              _context4.next = 10;
              return _this4.getBookingPaymentPlan(bookingID);

            case 10:
              _context4.next = 12;
              return _this4.props.refetchBookingPaymentPlan(bookingID);

            case 12:
              _this4.handleModalClose();

            case 13:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }));

    return function (_x18, _x19) {
      return _ref4.apply(this, arguments);
    };
  }();

  this.findDownpaymentName = function (detailID) {
    var bppds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var curr = _lodash2.default.find(bppds, function (bppd) {
      return bppd.id === detailID;
    });
    return curr ? curr.downpaymentName : '';
  };

  this.renderAmountWithCurrency = function (amount, currency) {
    return _react2.default.createElement(_LoanAmount2.default, {
      projectCurrencies: currency,
      format: '0,000,000.00',
      amount: amount ? Number(amount).toFixed(2) : '0.00',
      prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
    });
  };

  this.renderAccordionToggle = function (isActive) {
    return _react2.default.createElement('img', {
      className: 'verticalAlign-mid',
      src: isActive ? _arrowUp2.default : _arrowDown2.default,
      alt: isActive ? 'collapse' : 'expand'
    });
  };

  this.renderModals = function (isLoading) {
    var _state2 = _this4.state,
        oriData = _state2.oriData,
        isOpenPaymentPlanModal = _state2.isOpenPaymentPlanModal,
        bookingPaymentPlan = _state2.bookingPaymentPlan;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_PaymentPlan.PaymentPlanModal, {
        open: isOpenPaymentPlanModal,
        loading: isLoading,
        bookingData: oriData,
        onClose: function onClose() {
          return _this4.handleModalClose();
        },
        bookingPaymentPlan: bookingPaymentPlan,
        contractPaymentSchedules: bookingPaymentPlan && bookingPaymentPlan.contractPaymentSchedules ? bookingPaymentPlan.contractPaymentSchedules : [],
        isEdit: bookingPaymentPlan && bookingPaymentPlan.id !== '' // is edit based on selectedPaymentPlan
        , onSubmit: _this4.handleSubmit,
        token: _this4.props.token
      })
    );
  };

  this.renderEmptyNode = function (isMalaysiaCompany, isValidBookingStatus) {
    var t = _this4.props.t;

    return _react2.default.createElement(
      _semanticUiReact.Grid,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        { className: 'emptyNodeRow' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 16, textAlign: 'center' },
          _react2.default.createElement(
            'div',
            { className: 'mb-8' },
            t('No payment plan added yet')
          ),
          _react2.default.createElement(
            _semanticUiReact.Label,
            {
              as: 'button',
              size: 'small',
              className: 'textButton',
              disabled: isMalaysiaCompany || !isValidBookingStatus,
              onClick: function onClick(event) {
                event.preventDefault();
                _this4.handleToggle('isOpenPaymentPlanModal');
              }
            },
            t('Click here to add')
          )
        )
      )
    );
  };

  this.renderHeader = function (isMobile, disabledEdit) {
    var t = _this4.props.t;

    return _react2.default.createElement(
      _semanticUiReact.Header,
      { className: 'new_title', as: 'h5', attached: 'top', textAlign: 'center' },
      _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { textAlign: isMobile ? 'left' : 'center' },
          t('Payment Plan').toUpperCase(),
          _react2.default.createElement(
            'div',
            { style: { position: 'absolute', right: '1em', top: '1em' } },
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                disabled: disabledEdit,
                onClick: function onClick() {
                  return _this4.handleToggle('isOpenPaymentPlanModal');
                },
                className: 'a-button-gray'
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'edit', fitted: true, style: { marginRight: '0.5rem' } }),
              t('Edit', { ns: _translation.TRANSLATION_FILES.translation })
            )
          )
        )
      )
    );
  };

  this.renderAccordion = function (_ref5) {
    var name = _ref5.name,
        title = _ref5.title,
        subtitle = _ref5.subtitle,
        content = _ref5.content,
        isTogglable = _ref5.isTogglable,
        id = _ref5.id;
    return _react2.default.createElement(
      _semanticUiReact.Accordion,
      { fluid: true, className: 'boxShadowAccordion', key: id },
      _react2.default.createElement(
        _semanticUiReact.Accordion.Title,
        _extends({
          active: isTogglable ? _this4.state[name] : true
        }, isTogglable && { onClick: function onClick() {
            return _this4.handleToggle(name);
          } }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 12 },
              _react2.default.createElement(
                'p',
                { className: 'text-header' },
                title
              )
            ),
            isTogglable && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 4 },
              _this4.renderAccordionToggle(isTogglable ? _this4.state[name] : true)
            )
          ),
          subtitle && _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 1 },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              subtitle
            )
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Accordion.Content,
        { active: isTogglable ? _this4.state[name] : true },
        content
      )
    );
  };

  this.renderTable = function (_ref6) {
    var _ref6$headers = _ref6.headers,
        headers = _ref6$headers === undefined ? [] : _ref6$headers,
        _ref6$rows = _ref6.rows,
        rows = _ref6$rows === undefined ? [] : _ref6$rows;
    var t = _this4.props.t;

    return _react2.default.createElement(
      _semanticUiReact.Table,
      { unstackable: true },
      _react2.default.createElement(
        _semanticUiReact.Table.Header,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Row,
          null,
          headers.map(function (h) {
            return _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { key: h },
              t(h)
            );
          })
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Body,
        null,
        rows.map(function (row) {
          return _react2.default.createElement(
            _semanticUiReact.Table.Row,
            { key: row.id },
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              { width: 4 },
              row.name || '-'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              { width: 4 },
              _this4.renderAmountWithCurrency(row.value) || '-'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              { width: 8 },
              (0, _momentTimezone2.default)(row.billingAt).format('DD/MM/YYYY') || '-'
            )
          );
        })
      )
    );
  };

  this.renderSubtitle = function (name) {
    var items = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    return _react2.default.createElement(
      _semanticUiReact.Grid,
      { className: 'mt-4' },
      items.map(function (item, index) {
        return _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { key: 'row_' + name + '_' + index },
          Object.keys(item).map(function (key, idx) {
            var isOddIndex = _this4.checkIsOddNumber(idx);
            var className = isOddIndex ? 'text-body' : 'text-title';
            return _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 8, tablet: 4, largeScreen: 4, computer: 4, key: key },
              _react2.default.createElement(
                'span',
                { className: className },
                item[key]
              )
            );
          })
        );
      })
    );
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(PaymentPlan.mapStateToProps)(PaymentPlan));

/***/ }),
/* 2273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRequiredIdentityLabel = exports.getIDSnapshotColumnWidth = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _webValidations = __webpack_require__(23);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _i18n = __webpack_require__(401);

var _i18n2 = _interopRequireDefault(_i18n);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _prompt = __webpack_require__(66);

var _addressSettings = __webpack_require__(152);

var _customOptions = __webpack_require__(312);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _BookingCreditCheck = __webpack_require__(2091);

var _BookingCreditCheck2 = _interopRequireDefault(_BookingCreditCheck);

var _BookingTitle = __webpack_require__(260);

var _BookingTitle2 = _interopRequireDefault(_BookingTitle);

var _ESigningModal = __webpack_require__(571);

var _ESigningModal2 = _interopRequireDefault(_ESigningModal);

var _TinFieldInput = __webpack_require__(192);

var _TinFieldInput2 = _interopRequireDefault(_TinFieldInput);

var _InputBirthdate = __webpack_require__(220);

var _InputBirthdate2 = _interopRequireDefault(_InputBirthdate);

var _LPPSAChecker = __webpack_require__(562);

var _LPPSAChecker2 = _interopRequireDefault(_LPPSAChecker);

var _Phone = __webpack_require__(126);

var _Phone2 = _interopRequireDefault(_Phone);

var _PhoneInput = __webpack_require__(104);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _SearchHimsDistricts = __webpack_require__(568);

var _SearchHimsDistricts2 = _interopRequireDefault(_SearchHimsDistricts);

var _SearchHimsPostcodes = __webpack_require__(569);

var _SearchHimsPostcodes2 = _interopRequireDefault(_SearchHimsPostcodes);

var _customerTitles = __webpack_require__(390);

var _customerTitles2 = _interopRequireDefault(_customerTitles);

var _intlCallCodes = __webpack_require__(116);

var _intlCallCodes2 = _interopRequireDefault(_intlCallCodes);

var _states = __webpack_require__(144);

var _states2 = _interopRequireDefault(_states);

var _promptMessages = __webpack_require__(43);

var _maritalStatus = __webpack_require__(320);

var _relationshipType = __webpack_require__(1046);

var _race = __webpack_require__(324);

var _gender = __webpack_require__(319);

var _bumi = __webpack_require__(318);

var _countries = __webpack_require__(60);

var _defaultBookingFields = __webpack_require__(391);

var _translation = __webpack_require__(4);

var _regex = __webpack_require__(143);

var _UploadForm = __webpack_require__(394);

var _UploadForm2 = _interopRequireDefault(_UploadForm);

var _BookingStatusNotes = __webpack_require__(398);

var _BookingStatusNotes2 = _interopRequireDefault(_BookingStatusNotes);

var _ShareESign = __webpack_require__(2529);

var _ShareESign2 = _interopRequireDefault(_ShareESign);

var _booking = __webpack_require__(129);

var _booking2 = _interopRequireDefault(_booking);

var _booking_customer = __webpack_require__(1085);

var _booking_customer2 = _interopRequireDefault(_booking_customer);

var _dateFromIC = __webpack_require__(593);

var _dateFromIC2 = _interopRequireDefault(_dateFromIC);

var _url = __webpack_require__(19);

var _countries2 = __webpack_require__(591);

var _isNumber = __webpack_require__(30);

var _phone = __webpack_require__(146);

var _companies = __webpack_require__(88);

var _intlFlagCodes = __webpack_require__(141);

var _intlFlagCodes2 = _interopRequireDefault(_intlFlagCodes);

var _identityTypes = __webpack_require__(174);

var _vietnam = __webpack_require__(40);

var _translation2 = __webpack_require__(64);

var _autofillTypes = __webpack_require__(1038);

var _tin = __webpack_require__(155);

var _defaultIdentityTypeOpts = __webpack_require__(154);

var _RegexDropdownPicker = __webpack_require__(387);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */

// actions

// components

// constants

// containers

// modals

// structs

// utils


var isPRS = _config2.default.get('prs');
// CPI-976: "Country of Citizen (Others by default)" - the value book-api and the CRM already use.
var CITIZEN_COUNTRY_OTHERS = 'OTHERS';
// A Vietnamese isolated purchaser's identity picture ends up on their CRM Customer, which only
// takes images.
var VN_IDENTITY_ACCEPT = 'image/jpeg, image/png';

// The ID snapshot and E-Signature cards share one row. When E-Signature is hidden (Vietnam uses
// wet-sign only), the snapshot card takes the whole row instead of leaving half of it empty.
var getIDSnapshotColumnWidth = exports.getIDSnapshotColumnWidth = function getIDSnapshotColumnWidth(showsESignature, isNarrow) {
  return showsESignature && !isNarrow ? 8 : 16;
};

var getRequiredIdentityLabel = exports.getRequiredIdentityLabel = function getRequiredIdentityLabel(isVietnam, identityType, t) {
  return isVietnam && identityType === _defaultIdentityTypeOpts.IDENTITY_TYPE_NRIC ? 'CCCD' : t(identityType === 4 ? isVietnam ? 'Enterprise Registration Certificate' : 'Company Registration Number' : 'Identity');
};

var Purchaser = function (_Component) {
  _inherits(Purchaser, _Component);

  function Purchaser(props) {
    _classCallCheck(this, Purchaser);

    var _this = _possibleConstructorReturn(this, (Purchaser.__proto__ || Object.getPrototypeOf(Purchaser)).call(this, props));

    _initialiseProps.call(_this);

    var state = Purchaser.getPropsToState(props);
    var bookingCustomerDefaultData = _booking_customer2.default;
    var auth = props.auth;
    _this.identityInputRef = _react2.default.createRef();

    if (auth && (0, _companies.isForeignCompany)(auth.company)) {
      var idx = _intlFlagCodes2.default.findIndex(function (f) {
        return f.countryCode === auth.company.countryCode;
      });
      if (idx !== -1) {
        var defaultCountryPhoneCode = _intlFlagCodes2.default[idx].value;
        bookingCustomerDefaultData.mobilePrefix = defaultCountryPhoneCode;
        bookingCustomerDefaultData.phonePrefix = defaultCountryPhoneCode;
        bookingCustomerDefaultData.emergencyContactMobilePrefix = defaultCountryPhoneCode;
        bookingCustomerDefaultData.country = _intlFlagCodes2.default[idx].countryCode;
      }
    }

    if (state.hideTitle) {
      _booking_customer2.default.title = 'Not Applicable';
      bookingCustomerDefaultData.title = 'Not Applicable';
    }

    _this.state = _extends({}, state, {
      isEditingCustomer: 0,
      editingCustomer: Object.assign({}, _booking_customer2.default),
      customerAdd: Object.assign({}, _booking_customer2.default),
      customerAddArea: false,
      customerAddChanges: false,
      customerChanges: false,
      customerICChanges: false,
      addCustomerICChanges: false,
      documentToken: null,
      icFront: null,
      icBack: null,
      icFrontAddCustomer: null,
      icBackAddCustomer: null,
      identity: '',
      identityType: isPRS ? 1 : '',
      identityPresetID: '',
      identityPresetLabel: '',
      identityPresetRegex: '',
      prsID: '',
      editingBooking: false,
      editingPayment: false,
      identityLock: false,
      mobileLock: false,
      bookingStatusModal: false,
      showNoAutofill: false,
      fetchDataErrorMessage: '',
      showCustomFields: false,
      showSignModal: false,
      showShareESignModal: false,
      existingLeadCustomer: null,
      isIOS: null,
      bookingCustomerDefaultData: bookingCustomerDefaultData,
      shareESignData: null,
      isRenew: false,
      reviewedDeferredPurchaserIDs: [],
      taxIdentificationNo: '',
      taxTinValidationStatus: '', // currently not used
      tinEditFound: false,
      tinAddFound: false,
      screenWidth: window.innerWidth,
      showSoldConfirmation: false,
      // CPI-1332: per purchaser customer ID, book-api's answer on their CRM identity, with the
      // object URLs of the CRM pictures loaded for it (images.front / images.back).
      crmIdentities: {}
    });
    _this.validation = {
      title: (0, _react.createRef)(),
      name: (0, _react.createRef)(),
      preferredName: (0, _react.createRef)(),
      email: (0, _react.createRef)(),
      mobilePrefix: (0, _react.createRef)(),
      mobile: (0, _react.createRef)(),
      phone: (0, _react.createRef)(),
      country: (0, _react.createRef)(),
      taxIdentificationNo: (0, _react.createRef)(),
      prsID: (0, _react.createRef)(),
      identityType: (0, _react.createRef)(),
      identity: (0, _react.createRef)(),
      emergencyContactMobilePrefix: (0, _react.createRef)(),
      emergencyContactMobile: (0, _react.createRef)(),
      emergencyContactEmail: (0, _react.createRef)(),
      raceOther: (0, _react.createRef)(),
      himsKodDaerah: (0, _react.createRef)(),
      himsKodPoskod: (0, _react.createRef)(),
      address8: (0, _react.createRef)(),
      address9: (0, _react.createRef)()
    };
    // add validateRef for all enabled address settings
    var enabledAddressSettings = props.addressSettings.data.filter(function (as) {
      return as.enabled;
    });
    if (enabledAddressSettings && enabledAddressSettings.length > 0) {
      enabledAddressSettings.forEach(function (as) {
        var key = _lodash2.default.camelCase(as.columnName);
        _this.validation[key] = (0, _react.createRef)();
      });
    }
    _this.loanBox = null;
    return _this;
  }

  _createClass(Purchaser, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;

      store.dispatch((0, _addressSettings.fetchAddressSettings)());
      store.dispatch((0, _customOptions.fetchCustomOptions)());
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Set moment locale based on current language
      var languageMap = {
        en: 'en-gb',
        vi: 'vi',
        id: 'id'
      };
      _momentTimezone2.default.locale(languageMap[_i18n2.default.language] || 'en-gb');
      this.getOpportunity();
      this.fetchCRMIdentities();
      window.addEventListener('resize', this.handleResize, false);
      this.checkIOS();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var state = Purchaser.getPropsToState(nextProps);
      var stateIsSame = JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData);
      if (stateIsSame) {
        state.data = this.state.data;
        state.tinErrorAdd = this.state.tinErrorAdd;
        state.tinErrorEdit = this.state.tinErrorEdit;
        state.tinMessage = this.state.tinMessage;
      }
      var tinEditFound = !!(nextProps.data && nextProps.data.customer && nextProps.data.customer.taxIdentificationNo);
      this.setState(_extends({}, state, { tinEditFound: tinEditFound }), function () {
        if (!stateIsSame) {
          _this2.getOpportunity();
          _this2.fetchCRMIdentities();
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // Sync moment locale when language changes
      if (prevProps && prevProps.i18n && prevProps.i18n.language !== this.props.i18n.language) {
        var languageMap = {
          en: 'en-gb',
          vi: 'vi',
          id: 'id'
        };
        _momentTimezone2.default.locale(languageMap[this.props.i18n.language] || 'en-gb');
        // Force re-render of children to update moment-based month names
        this.forceUpdate();
      }
      if (prevState && prevState.editingCustomer !== this.state.editingCustomer) {
        this.updateTinFieldState();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.setTimer) {
        clearTimeout(this.setTimer);
      }
      window.removeEventListener('resize', this.handleResize);
      this.crmIdentityLoad = -1;
      this.revokeCRMIdentityImages(this.state.crmIdentities);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
    // need to bind this to allow LoanTracker to setLoading

  }, {
    key: 'setSearchingID',
    value: function setSearchingID() {
      var _this4 = this;

      var searching = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var searchingType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'searchingID';
      var _state = this.state,
          identityLock = _state.identityLock,
          mobileLock = _state.mobileLock;

      var searchByID = searchingType === 'searchingID';
      var searchByMobile = searchingType === 'searchingIDByMobile';
      if (searching) {
        if (searchByID) identityLock = true;
        if (searchByMobile) mobileLock = true;
      } else {
        if (searchByID) identityLock = false;
        if (searchByMobile) mobileLock = false;
      }
      return new Promise(function (res) {
        _this4.setState({
          searchingID: searchByID ? searching : _this4.state.searchingID,
          searchingIDByMobile: searchByMobile ? searching : _this4.state.searchingIDByMobile,
          identityLock: identityLock,
          mobileLock: mobileLock }, res);
      });
    }
    // How many images a purchaser's identity document has, and what to call it on screen.
    // Vietnam: a CCCD has a front and a back; a passport or an Enterprise Registration Certificate
    // is one image, stored in the front slot. Everywhere else the card is what it always was: NRIC,
    // front and back, with the MyKad samples.

  }, {
    key: 'getDocumentToken',
    value: function getDocumentToken(editingCustomer, callback) {
      var _this5 = this;

      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/bookings/' + editingCustomer.bookingID + '/customers/' + editingCustomer.customerID + '/documents/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      }).then(function (res) {
        var documentToken = res.headers.get('X-Csrf-Token');
        _this5.setState({
          documentToken: documentToken
        }, function () {
          if (callback) {
            callback();
          }
        });
      });
    }
  }, {
    key: 'getOpportunity',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this6 = this;

        var _props$data, data, opportunity, _opportunity$data, customerIDs, primaryCustomer, existingLeadCustomer, purchasers, availableCustomers, leadCustomers, leadCus;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props$data = this.props.data, data = _props$data === undefined ? {} : _props$data;

                if (!(data && data.origin && data.origin !== 'lead' || data && data.origin && data.originID === '' || !(data && data.originID))) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                _context.next = 5;
                return this.fetchData('/leads/opportunity/' + data.originID + '/', 'isFetching');

              case 5:
                opportunity = _context.sent;

                if (opportunity) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return');

              case 8:
                _opportunity$data = opportunity.data, customerIDs = _opportunity$data.customer_ids, primaryCustomer = _opportunity$data.primary_customer;
                existingLeadCustomer = void 0;

                if (!(data.bookingCustomers && data.bookingCustomers.length > 0)) {
                  _context.next = 20;
                  break;
                }

                purchasers = [];

                if (primaryCustomer && primaryCustomer.purchasers && primaryCustomer.purchasers.length > 0) {
                  purchasers = primaryCustomer.purchasers.filter(function (c) {
                    return !data.bookingCustomers.some(function (bc) {
                      return bc.customer.identity === c.identity;
                    });
                  });

                  if (purchasers.length > 0) {
                    existingLeadCustomer = purchasers[0];
                  }
                }

                if (!(customerIDs && customerIDs.length > 0)) {
                  _context.next = 20;
                  break;
                }

                availableCustomers = customerIDs.filter(function (c) {
                  return !data.bookingCustomers.some(function (bc) {
                    return bc.leadCustomerID === c;
                  });
                });

                if (!(availableCustomers.length > 0)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 18;
                return Promise.all(availableCustomers.map(function (id) {
                  return _this6.fetchData('/leads/customers/' + id + '/', 'isFetching');
                }));

              case 18:
                leadCustomers = _context.sent;

                if (leadCustomers.length > 0) {
                  leadCustomers = leadCustomers.filter(function (c) {
                    return c && c.data;
                  }).map(function (c) {
                    return c.data;
                  });

                  if (purchasers.length > 0) {
                    leadCus = leadCustomers.find(function (c) {
                      return purchasers.some(function (p) {
                        return c.identity === p.identity;
                      });
                    });

                    if (leadCus) {
                      existingLeadCustomer = leadCus.customer;
                      existingLeadCustomer.leadCustomerID = leadCus.id;
                    }
                  } else {
                    existingLeadCustomer = leadCustomers[0].customer;
                    existingLeadCustomer.leadCustomerID = leadCustomers[0].id;
                  }
                }

              case 20:
                this.setState({ existingLeadCustomer: existingLeadCustomer });

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getOpportunity() {
        return _ref.apply(this, arguments);
      }

      return getOpportunity;
    }()
  }, {
    key: 'updateBooking',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(booking) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'update';
        var xid = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.state.data.id;
        var store, t, validations, errMessages, res, message, data, query;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;

                if (!(type === 'update')) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 7;
                return _AppForm2.default.validate(this.validation, this.state.data);

              case 7:
                validations = _context2.sent;
                errMessages = validations.filter(function (v) {
                  return !v.isValid;
                });
                _context2.next = 11;
                return this.setComponentState({
                  errMessages: errMessages
                });

              case 11:
                if (!(errMessages.length > 0)) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 14;
                return this.setLoading(false);

              case 14:
                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errMessages.map(function (l) {
                    return l.message;
                  }) }));
                return _context2.abrupt('return');

              case 16:
                res = '';
                _context2.prev = 17;
                _context2.next = 20;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + xid + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(booking)
                }));

              case 20:
                res = _context2.sent;
                _context2.next = 36;
                break;

              case 23:
                _context2.prev = 23;
                _context2.t0 = _context2['catch'](17);
                _context2.next = 27;
                return this.setLoading(false);

              case 27:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 33;
                  break;
                }

                _context2.next = 30;
                return _context2.t0.res.text();

              case 30:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 33:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context2.abrupt('return');

              case 36:
                _context2.next = 38;
                return res.json();

              case 38:
                data = _context2.sent;
                query = (0, _url.decodeSearch)(this.props.location.search);
                _context2.next = 42;
                return this.setLoading(false);

              case 42:
                _context2.next = 44;
                return this.setComponentState({
                  editingPayment: type === 'payment' ? false : this.state.editingPayment,
                  editingBooking: type !== 'payment' ? false : this.state.editingBooking
                });

              case 44:
                if (type === 'primary') {
                  store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + this.state.data.id + '/?' + (0, _url.encodeSearch)(query)));
                  store.dispatch((0, _flash.flashSuccessMessage)({
                    header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                    message: t('Primary purchaser has been successfully updated.', { ns: _translation.TRANSLATION_FILES.translation })
                  }));
                } else {
                  this.handleResetCheck(type === 'payment' ? 'paymentChanges' : 'bookingChanges');
                  store.dispatch((0, _reactRouterRedux.push)('/bookings/' + xid + '/?' + (0, _url.encodeSearch)(query)));
                  store.dispatch((0, _flash.flashSuccessMessage)({
                    header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                    message: t('Booking {{code}} successfully updated', { code: data.code, ns: _translation.TRANSLATION_FILES.translation })
                  }));
                }

              case 45:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[17, 23]]);
      }));

      function updateBooking(_x4) {
        return _ref2.apply(this, arguments);
      }

      return updateBooking;
    }()
  }, {
    key: 'fetchData',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(fetchPath, loaderName) {
        var includeCredentials = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
        var extraHeaders = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var showError = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
        var store, t, res, extraRequest, message, data, json;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                _context3.next = 4;
                return this.setSearchingID(true, loaderName);

              case 4:
                res = null;
                extraRequest = {};

                if (includeCredentials) {
                  extraRequest = {
                    credentials: 'include'
                  };
                }
                _context3.prev = 7;
                _context3.next = 10;
                return store.dispatch((0, _fetchM.fetchM)(fetchPath, _extends({}, extraRequest, {
                  method: 'GET',
                  headers: _extends({
                    'Content-Type': 'application/json'
                  }, extraHeaders)
                })));

              case 10:
                res = _context3.sent;
                _context3.next = 29;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3['catch'](7);

                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 24;
                  break;
                }

                _context3.next = 18;
                return _context3.t0.res.text();

              case 18:
                message = _context3.sent;

                if (showError) store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                if (!showError) this.setComponentState({ fetchDataErrorMessage: message });
                _context3.next = 23;
                return this.setSearchingID(false, loaderName);

              case 23:
                return _context3.abrupt('return', null);

              case 24:
                _context3.next = 26;
                return this.setSearchingID(false, loaderName);

              case 26:
                Bugsnag.notifyException(_context3.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context3.abrupt('return', null);

              case 29:
                if (res.ok) {
                  _context3.next = 35;
                  break;
                }

                _context3.next = 32;
                return this.setSearchingID(false, loaderName);

              case 32:
                Bugsnag.notifyException(new Error('Server error during booking: ' + res.status));
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context3.abrupt('return', null);

              case 35:
                _context3.next = 37;
                return this.setSearchingID(false, loaderName);

              case 37:
                data = {};
                _context3.next = 40;
                return res.json();

              case 40:
                json = _context3.sent;

                if (json) {
                  data.data = json;
                }
                return _context3.abrupt('return', data);

              case 43:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[7, 13]]);
      }));

      function fetchData(_x7, _x8) {
        return _ref3.apply(this, arguments);
      }

      return fetchData;
    }()
  }, {
    key: 'searchAutofillCustomer',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(searchValue, searchType) {
        var _this7 = this;

        var identityPresetID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

        var data, t, existingCustomerData, externalCustomerData, leadCustomerData, searchingBy, query, headers, crmIsVietnam, crmEnabledSearchTypes, crmSearchField, preset, mapping, crmQuery, _ref5, existingCustomer, externalCustomer, leadCustomer, autofillOptions, replacedByField, customerIsExisting, isValidPhonePrefix, message, externalCustomerExists, showNoAutofill;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = this.state.data;
                t = this.props.t;
                existingCustomerData = void 0;
                externalCustomerData = void 0;
                leadCustomerData = void 0;
                searchingBy = 'searchingID';

                if (searchType === _autofillTypes.AUTOFILL_MSISDN) searchingBy = 'searchingIDByMobile';

                if (!isPRS) {
                  _context4.next = 13;
                  break;
                }

                _context4.next = 10;
                return this.fetchData('/search/prs/?search=' + searchValue + '&prsID=' + this.state.prsID + '&projectID=' + data.projectID + '&projectUnitID=' + data.projectUnitID, searchingBy, true, {}, false);

              case 10:
                existingCustomerData = _context4.sent;
                _context4.next = 18;
                break;

              case 13:
                query = {
                  search: searchValue,
                  identityTypeID: this.getAutofillIdentityTypeID(searchType),
                  projectBranchOwnerID: data.project.maOwnerCompanyBranchID
                };

                if (searchType === _autofillTypes.AUTOFILL_PRESET) query.presetID = identityPresetID;

                _context4.next = 17;
                return this.fetchData('/customers/?' + _qs2.default.stringify(query), searchingBy);

              case 17:
                existingCustomerData = _context4.sent;

              case 18:
                if (!data.project.autofillFromUrl) {
                  _context4.next = 23;
                  break;
                }

                headers = {
                  'x-mhub-registration-code': ""
                };
                _context4.next = 22;
                return this.fetchData(data.project.externalAutofillUrl + '/customers/search/identity_type/' + this.getAutofillIdentityTypeID(searchType) + '/identity/' + searchValue + '/', searchingBy, false, headers);

              case 22:
                externalCustomerData = _context4.sent;

              case 23:

                // search crm
                crmIsVietnam = (0, _countries.isCountryVietnam)(this.props.auth && this.props.auth.company && this.props.auth.company.countryCode);
                crmEnabledSearchTypes = [_autofillTypes.AUTOFILL_NRIC, _autofillTypes.AUTOFILL_PASSPORT, _autofillTypes.AUTOFILL_MSISDN, _autofillTypes.AUTOFILL_PRESET];

                if (crmIsVietnam) {
                  crmEnabledSearchTypes.push(_autofillTypes.AUTOFILL_COMPANY);
                }

                if (!(crmEnabledSearchTypes.includes(searchType) && this.state.isCRMEnabled)) {
                  _context4.next = 34;
                  break;
                }

                // A Vietnamese identity is stored in the CRM as cccd / passport / other_identity, never nric:
                // searching by the Malaysian field name found nobody and every Vietnamese buyer read as new.
                crmSearchField = (0, _vietnam.vnCRMSearchField)(searchType, crmIsVietnam);

                if (searchType === _autofillTypes.AUTOFILL_PRESET) {
                  preset = this.state.identityPresets.find(function (p) {
                    return p.id === identityPresetID;
                  });

                  if (preset && preset.label) {
                    mapping = _autofillTypes.CRM_SEARCH_FIELD_MAPPINGS.find(function (map) {
                      return map.label === preset.label;
                    });

                    crmSearchField = mapping ? mapping.searchField : searchType;
                  }
                }
                crmQuery = {
                  search: searchValue,
                  searchField: crmSearchField
                };

                if (searchType === _autofillTypes.AUTOFILL_PRESET) {
                  crmQuery.presetID = identityPresetID;
                }
                _context4.next = 33;
                return this.fetchData('/leads/customers/search/?' + _qs2.default.stringify(crmQuery), searchingBy);

              case 33:
                leadCustomerData = _context4.sent;

              case 34:
                if (!(!existingCustomerData && !externalCustomerData && !leadCustomerData)) {
                  _context4.next = 37;
                  break;
                }

                this.setState({ showNoAutofill: true });
                return _context4.abrupt('return');

              case 37:
                _ref5 = {}, existingCustomer = _ref5.existingCustomer, externalCustomer = _ref5.externalCustomer, leadCustomer = _ref5.leadCustomer;
                autofillOptions = [];
                replacedByField = searchType === _autofillTypes.AUTOFILL_MSISDN ? 'msisdn' : 'identity';

                // if existing customer exists

                customerIsExisting = existingCustomerData && existingCustomerData.data && existingCustomerData.data.length > 0;

                if (!customerIsExisting) {
                  _context4.next = 52;
                  break;
                }

                existingCustomer = Object.assign({}, existingCustomerData.data[0]);
                delete existingCustomer.customerDetail.createdAt;
                delete existingCustomer.customerDetail.updatedAt;

                if (!isPRS) {
                  _context4.next = 51;
                  break;
                }

                isValidPhonePrefix = _intlCallCodes2.default.find(function (d) {
                  return d.value === existingCustomer.customerDetail.mobilePrefix;
                });

                if (isValidPhonePrefix) {
                  _context4.next = 51;
                  break;
                }

                message = _react2.default.createElement(
                  'span',
                  null,
                  'Mobile prefix is invalid! Please inform the customer to update it in ',
                  _react2.default.createElement(
                    'a',
                    { href: 'http://www.pr1ma.my', target: '_blank' },
                    'PRS system (www.pr1ma.my).'
                  )
                );

                this.setState({ fetchDataErrorMessage: message, showNoAutofill: true });
                return _context4.abrupt('return');

              case 51:
                autofillOptions.push({
                  key: 'existing',
                  text: t('Previous entry'),
                  onClick: function onClick(e) {
                    e.preventDefault();
                    _this7.replaceWithAutofill('existing', replacedByField);
                  }
                });

              case 52:

                // if external customer exists
                externalCustomerExists = externalCustomerData && externalCustomerData.data;

                if (externalCustomerExists) {
                  externalCustomer = Object.assign({}, externalCustomerData.data);
                  delete externalCustomer.id;
                  delete externalCustomer.customerDetailID;
                  delete externalCustomer.customerDetail.id;
                  delete externalCustomer.customerDetail.customerID;
                  delete externalCustomer.customerDetail.createdAt;
                  delete externalCustomer.customerDetail.updatedAt;
                }

                if (leadCustomerData && leadCustomerData.data && leadCustomerData.data.length > 0) {
                  leadCustomer = Object.assign({}, leadCustomerData.data[0]);
                  autofillOptions.push({
                    key: 'lead',
                    text: 'CRM',
                    onClick: function onClick(e) {
                      e.preventDefault();
                      _this7.replaceWithAutofill('lead', replacedByField);
                    }
                  });
                }

                showNoAutofill = autofillOptions.length < 1;

                this.setState({
                  existingCustomer: existingCustomer,
                  externalCustomer: externalCustomer,
                  leadCustomer: leadCustomer,
                  autofillOptions: autofillOptions,
                  showNoAutofill: showNoAutofill
                }, function () {
                  if (isPRS && customerIsExisting) _this7.replaceWithAutofill('existing', replacedByField);
                });

              case 57:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function searchAutofillCustomer(_x12, _x13) {
        return _ref4.apply(this, arguments);
      }

      return searchAutofillCustomer;
    }()
  }, {
    key: 'removeCustomer',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(customerID, bookingID) {
        var _this8 = this;

        var silentLoad = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var store, t, message, modal;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;

                if (silentLoad) {
                  _context5.next = 5;
                  break;
                }

                _context5.next = 5;
                return this.setLoading(true);

              case 5:
                _context5.prev = 5;
                _context5.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + bookingID + '/customers/' + customerID + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 8:
                _context5.next = 23;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](5);
                _context5.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context5.t0.res && _context5.t0.res.status >= 400 && _context5.t0.res.status < 500)) {
                  _context5.next = 20;
                  break;
                }

                _context5.next = 17;
                return _context5.t0.res.text();

              case 17:
                message = _context5.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context5.abrupt('return');

              case 20:
                Bugsnag.notifyException(_context5.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context5.abrupt('return');

              case 23:
                modal = Object.assign({}, this.state.modal);

                modal.unitID = '';
                modal.customerID = '';
                this.setState({ modal: modal }, function () {
                  var query = (0, _url.decodeSearch)(_this8.props.location.search);
                  store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + _this8.state.data.id + '/?' + (0, _url.encodeSearch)(query)));
                });
                _context5.next = 29;
                return this.setLoading(false);

              case 29:
                store.dispatch((0, _flash.flashMessage)({
                  header: t('Purchaser Removed', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Purchaser {{name}} was successfully removed', { name: modal.customerName, ns: _translation.TRANSLATION_FILES.translation }) + '.',
                  icon: 'x',
                  type: 'success',
                  autoHideDuration: 5000
                }));

              case 30:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[5, 10]]);
      }));

      function removeCustomer(_x15, _x16) {
        return _ref6.apply(this, arguments);
      }

      return removeCustomer;
    }()
    // Returns null once the upload is saved, or the error message it showed when it was not.

  }, {
    key: 'uploadDocument',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(body, bookingCustomer) {
        var documentToken, t, store, message;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.setLoading(true);

              case 2:
                documentToken = this.state.documentToken;
                t = this.props.t;
                store = this.context.store;
                _context6.prev = 5;
                _context6.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + bookingCustomer.bookingID + '/customers/' + bookingCustomer.customerID + '/documents/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    // Let browser decide Content-Type
                    'X-Csrf-Token': documentToken
                  },
                  body: body
                }));

              case 8:
                // CPI-1332: a linked purchaser's upload replaced their CRM Customer's pictures; show those.
                this.fetchCRMIdentities();
                return _context6.abrupt('return', null);

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6['catch'](5);
                _context6.next = 16;
                return this.setLoading(false);

              case 16:
                Bugsnag.notifyException(_context6.t0);
                _context6.t2 = _context6.t0.res && _context6.t0.res.status >= 400 && _context6.t0.res.status < 500;

                if (!_context6.t2) {
                  _context6.next = 22;
                  break;
                }

                _context6.next = 21;
                return _context6.t0.res.text();

              case 21:
                _context6.t2 = _context6.sent;

              case 22:
                _context6.t1 = _context6.t2;

                if (_context6.t1) {
                  _context6.next = 25;
                  break;
                }

                _context6.t1 = t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.';

              case 25:
                message = _context6.t1;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context6.abrupt('return', message);

              case 28:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[5, 12]]);
      }));

      function uploadDocument(_x18, _x19) {
        return _ref7.apply(this, arguments);
      }

      return uploadDocument;
    }()
  }, {
    key: 'updateBookingCustomer',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var _this9 = this;

        var _props, t, auth, isIndonesia, isVietnam, bookingCustomer, validations, errMessages, store, res, message, data;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _props = this.props, t = _props.t, auth = _props.auth;
                _context8.next = 3;
                return this.setLoading(true);

              case 3:
                isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';
                // CPI-976: no TIN field in Vietnam, so the BRN "Invalid TIN" precondition must not apply.

                isVietnam = (0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode);
                bookingCustomer = this.state.editingCustomer;

                bookingCustomer.monthlyIncome = parseFloat(bookingCustomer.monthlyIncome);
                bookingCustomer.race = bookingCustomer.race.toUpperCase() === 'Others'.toUpperCase() ? bookingCustomer.raceOther : bookingCustomer.race;
                bookingCustomer.taxIdentificationNo = bookingCustomer.customer.taxIdentificationNo;
                bookingCustomer.isForeignCompany = bookingCustomer.customer.isForeignCompany;
                // CPI-976 (M4): send the citizenship the screen shows, or a legacy row round-trips ''. VN only.
                if (isVietnam) {
                  bookingCustomer.citizenship = this.getCitizenship(bookingCustomer);
                }
                _context8.next = 13;
                return _AppForm2.default.validate(this.validation, bookingCustomer);

              case 13:
                validations = _context8.sent;
                errMessages = validations.filter(function (v) {
                  return !v.isValid;
                });
                store = this.context.store;
                _context8.next = 18;
                return this.setComponentState({
                  errMessages: errMessages
                });

              case 18:
                if (!(errMessages.length > 0)) {
                  _context8.next = 23;
                  break;
                }

                _context8.next = 21;
                return this.setLoading(false);

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errMessages.map(function (l) {
                    return l.message;
                  }) }));
                return _context8.abrupt('return');

              case 23:
                if (!(!isVietnam && this.isUnderagePurchaser(bookingCustomer.birthdate))) {
                  _context8.next = 28;
                  break;
                }

                _context8.next = 26;
                return this.setLoading(false);

              case 26:
                store.dispatch((0, _flash.flashErrorMessage)({ message: this.getMinimumPurchaserAgeMessage() }));
                return _context8.abrupt('return');

              case 28:
                if (!(!isVietnam && this.isUnderageNRICPurchaser(bookingCustomer.customer.identityTypeID, bookingCustomer.customer.identity))) {
                  _context8.next = 33;
                  break;
                }

                _context8.next = 31;
                return this.setLoading(false);

              case 31:
                store.dispatch((0, _flash.flashErrorMessage)({ message: this.getMinimumPurchaserAgeMessage() }));
                return _context8.abrupt('return');

              case 33:
                bookingCustomer.customer.taxIdentificationNo = bookingCustomer.taxIdentificationNo;
                bookingCustomer.customer.isForeignCompany = bookingCustomer.isForeignCompany;
                bookingCustomer.customer.taxTinValidationStatus = this.state.tinErrorEdit === false ? 'success' : 'failed';

                if (!(!isIndonesia && !isVietnam && bookingCustomer.customer.taxTinValidationStatus !== 'success' && bookingCustomer.customer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && !bookingCustomer.customer.isForeignCompany)) {
                  _context8.next = 41;
                  break;
                }

                _context8.next = 39;
                return this.setLoading(false);

              case 39:
                store.dispatch((0, _flash.flashMessage)({
                  header: 'Invalid TIN',
                  message: 'Tax Identification Number is invalid',
                  icon: 'warning sign',
                  type: 'error',
                  autoHideDuration: 5000
                }));
                return _context8.abrupt('return');

              case 41:
                res = '';
                _context8.prev = 42;
                _context8.next = 45;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + bookingCustomer.bookingID + '/customers/' + bookingCustomer.customerID + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(bookingCustomer)
                }));

              case 45:
                res = _context8.sent;
                _context8.next = 61;
                break;

              case 48:
                _context8.prev = 48;
                _context8.t0 = _context8['catch'](42);
                _context8.next = 52;
                return this.setLoading(false);

              case 52:
                if (!(_context8.t0.res && _context8.t0.res.status >= 400 && _context8.t0.res.status < 500)) {
                  _context8.next = 58;
                  break;
                }

                _context8.next = 55;
                return _context8.t0.res.text();

              case 55:
                message = _context8.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context8.abrupt('return');

              case 58:
                Bugsnag.notifyException(_context8.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context8.abrupt('return');

              case 61:
                _context8.next = 63;
                return res.json();

              case 63:
                data = _context8.sent;

                if (!this.state.customerICChanges) {
                  _context8.next = 69;
                  break;
                }

                _context8.next = 67;
                return this.getDocumentToken(bookingCustomer, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
                  var formData, query, previousQuery, navigate;
                  return regeneratorRuntime.wrap(function _callee7$(_context7) {
                    while (1) {
                      switch (_context7.prev = _context7.next) {
                        case 0:
                          _context7.next = 2;
                          return _this9.handleCreateFormData();

                        case 2:
                          formData = _context7.sent;
                          _context7.next = 5;
                          return _this9.uploadDocument(formData, bookingCustomer);

                        case 5:
                          if (!_context7.sent) {
                            _context7.next = 7;
                            break;
                          }

                          return _context7.abrupt('return');

                        case 7:
                          _context7.next = 9;
                          return _this9.setLoading(false);

                        case 9:
                          if (!_this9.icFrontUpload) {
                            _context7.next = 12;
                            break;
                          }

                          _context7.next = 12;
                          return _this9.icFrontUpload.resetFiles();

                        case 12:
                          if (!_this9.icBackUpload) {
                            _context7.next = 15;
                            break;
                          }

                          _context7.next = 15;
                          return _this9.icBackUpload.resetFiles();

                        case 15:
                          _context7.next = 17;
                          return _this9.setComponentState({
                            isEditingCustomer: 0,
                            icFront: null,
                            icBack: null
                          });

                        case 17:
                          _this9.handleResetCheck('customerICChanges', function () {
                            if (_this9.state.customerChanges) {
                              _this9.handleResetCheck('customerChanges', function () {
                                _this9.handleOnCheck();
                              });
                            } else {
                              _this9.handleOnCheck();
                            }
                          });
                          query = _this9.queryAfterDeferredPurchaserSave(bookingCustomer);
                          previousQuery = (0, _url.decodeSearch)(_this9.props.location.search);
                          // Keep review saves on one history entry, including intermediate purchasers.

                          navigate = isVietnam && _this9.state.data.purchasersIsolated && previousQuery.reviewPurchasers === '1' ? _reactRouterRedux.replace : _reactRouterRedux.push;

                          store.dispatch(navigate('/bookings/' + _this9.state.data.id + '/?' + (0, _url.encodeSearch)(query)));
                          if (data !== null) {
                            store.dispatch((0, _flash.flashSuccessMessage)({
                              header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                              message: t('Booking Customer {{name}} has been successfully updated', { name: data.preferredName, ns: _translation.TRANSLATION_FILES.translation }) + '.'
                            }));
                          } else {
                            store.dispatch((0, _flash.flashSuccessMessage)({
                              header: t('Upload Success', { ns: _translation.TRANSLATION_FILES.translation }),
                              message: t('Booking Customer {{name}}\'s IC photos has been successfully uploaded', { name: data.preferredName, ns: _translation.TRANSLATION_FILES.translation }) + '.'
                            }));
                          }

                        case 23:
                        case 'end':
                          return _context7.stop();
                      }
                    }
                  }, _callee7, _this9);
                })));

              case 67:
                _context8.next = 74;
                break;

              case 69:
                _context8.next = 71;
                return this.setLoading(false);

              case 71:
                _context8.next = 73;
                return this.setComponentState({
                  isEditingCustomer: 0
                });

              case 73:
                this.handleResetCheck('customerChanges', function () {
                  var query = _this9.queryAfterDeferredPurchaserSave(bookingCustomer);
                  store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + _this9.state.data.id + '/?' + (0, _url.encodeSearch)(query)));
                  store.dispatch((0, _flash.flashSuccessMessage)({
                    header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                    message: t('Booking Customer {{name}} has been successfully updated', { name: data.preferredName, ns: _translation.TRANSLATION_FILES.translation }) + '.'
                  }));
                });

              case 74:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[42, 48]]);
      }));

      function updateBookingCustomer() {
        return _ref8.apply(this, arguments);
      }

      return updateBookingCustomer;
    }()
  }, {
    key: 'updateBookingCustomerSignature',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(bookingID, customerID, signature) {
        var bookingCustomer, store, t, res, message, data, query;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.setLoading(true);

              case 2:
                bookingCustomer = {};

                bookingCustomer.signature = signature;
                store = this.context.store;
                t = this.props.t;
                res = '';
                _context9.prev = 7;
                _context9.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + bookingID + '/customers/' + customerID + '/signature/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(bookingCustomer)
                }));

              case 10:
                res = _context9.sent;
                _context9.next = 26;
                break;

              case 13:
                _context9.prev = 13;
                _context9.t0 = _context9['catch'](7);
                _context9.next = 17;
                return this.setLoading(false);

              case 17:
                if (!(_context9.t0.res && _context9.t0.res.status >= 400 && _context9.t0.res.status < 500)) {
                  _context9.next = 23;
                  break;
                }

                _context9.next = 20;
                return _context9.t0.res.text();

              case 20:
                message = _context9.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context9.abrupt('return');

              case 23:
                Bugsnag.notifyException(_context9.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context9.abrupt('return');

              case 26:
                _context9.next = 28;
                return res.json();

              case 28:
                data = _context9.sent;

                this.setState({
                  showSignModal: false,
                  editingCustomer: Object.assign({}, this.state.bookingCustomerDefaultData)
                });
                _context9.next = 32;
                return this.setLoading(false);

              case 32:
                _context9.next = 34;
                return this.signatureModal.handleOnCancel();

              case 34:
                query = (0, _url.decodeSearch)(this.props.location.search);
                _context9.next = 37;
                return store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + this.state.data.id + '/?' + (0, _url.encodeSearch)(query)));

              case 37:
                _context9.next = 39;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Sign Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Customer {{name}} has been sign the booking form', { name: data.preferredName, ns: _translation.TRANSLATION_FILES.translation }) + '.'
                }));

              case 39:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[7, 13]]);
      }));

      function updateBookingCustomerSignature(_x20, _x21, _x22) {
        return _ref10.apply(this, arguments);
      }

      return updateBookingCustomerSignature;
    }()
  }, {
    key: 'submitCustomer',
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var _this10 = this;

        var store, _props2, t, auth, _state2, customerAdd, identityType, trimmedIdentity, isIndonesia, isVietnam, requiredIdentityLabel, validations, errMessages, postCustomer, header, body, customerAddGrid, res, message, data;

        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _props2 = this.props, t = _props2.t, auth = _props2.auth;
                _state2 = this.state, customerAdd = _state2.customerAdd, identityType = _state2.identityType;
                trimmedIdentity = this.state.identity ? this.state.identity.trim() : '';
                isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';
                isVietnam = (0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode);
                requiredIdentityLabel = getRequiredIdentityLabel(isVietnam, identityType, t);

                // Validate the same identity that is sent, including after autofill or reset.

                customerAdd.identity = trimmedIdentity;
                customerAdd.customer.taxTinValidationStatus = this.state.tinErrorAdd === false ? 'success' : 'failed';

                if (!(!isIndonesia && !isVietnam && customerAdd.customer.taxTinValidationStatus !== 'success' && this.state.identityType === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && !customerAdd.customer.isForeignCompany)) {
                  _context12.next = 16;
                  break;
                }

                _context12.next = 14;
                return this.setLoading(false);

              case 14:
                store.dispatch((0, _flash.flashMessage)({
                  header: 'Invalid TIN',
                  message: 'Tax Identification Number is invalid',
                  icon: 'warning sign',
                  type: 'error',
                  autoHideDuration: 5000
                }));
                return _context12.abrupt('return');

              case 16:
                customerAdd.taxIdentificationNo = customerAdd.customer.taxIdentificationNo;
                _context12.next = 19;
                return _AppForm2.default.validate(this.validation, _extends({}, customerAdd, { identityType: identityType }));

              case 19:
                validations = _context12.sent;
                errMessages = validations.filter(function (v) {
                  return !v.isValid;
                });
                // Custom preset IDs are strings and must still map to API identity type 6.
                // Validate the selection before that mapping, independently of mounted form refs.

                if ((!identityType || typeof identityType === 'string' && identityType.trim() === '') && !errMessages.some(function (error) {
                  return error.key === 'identityType';
                })) {
                  errMessages.unshift({
                    isValid: false,
                    key: 'identityType',
                    message: t('Please select Identity Type')
                  });
                }
                if (!trimmedIdentity && !errMessages.some(function (error) {
                  return error.key === 'identity';
                })) {
                  errMessages.push({
                    isValid: false,
                    key: 'identity',
                    message: requiredIdentityLabel + ' ' + t('is required', { ns: _translation.TRANSLATION_FILES.translation })
                  });
                }
                postCustomer = {
                  address1: customerAdd.address1,
                  address2: customerAdd.address2,
                  address3: customerAdd.address3,
                  address4: customerAdd.address4,
                  address5: customerAdd.address5,
                  address6: customerAdd.address6,
                  address7: customerAdd.address7,
                  address8: customerAdd.address8,
                  address9: customerAdd.address9,
                  address10: customerAdd.address10,
                  himsKodPoskod: customerAdd.himsKodPoskod,
                  himsKodBandar: customerAdd.himsKodBandar,
                  himsKodDaerah: customerAdd.himsKodDaerah,
                  himsKodNegeri: customerAdd.himsKodNegeri,
                  himsKodNegara: customerAdd.himsKodNegara,
                  country: customerAdd.country,
                  email: customerAdd.email,
                  mobile: customerAdd.mobile,
                  mobilePrefix: customerAdd.mobilePrefix,
                  name: customerAdd.name,
                  phone: customerAdd.phone,
                  phonePrefix: customerAdd.phonePrefix,
                  preferredName: customerAdd.preferredName,
                  title: this.state.hideTitle ? 'Not Applicable' : customerAdd.title,
                  customerID: customerAdd.customerID,
                  jobTitle: customerAdd.jobTitle,
                  monthlyIncome: parseFloat(customerAdd.monthlyIncome),
                  nationality: customerAdd.nationality,
                  // CPI-976 (M4): post the resolved 'local' | 'foreigner'; not sent outside Vietnam.
                  citizenship: isVietnam ? this.getCitizenship(customerAdd) : '',
                  birthdate: customerAdd.birthdate,
                  gender: customerAdd.gender,
                  race: customerAdd.race.toUpperCase() === 'Others'.toUpperCase() ? customerAdd.raceOther : customerAdd.race,
                  bumi: customerAdd.bumi,
                  maritalStatus: customerAdd.maritalStatus,
                  // Related purchaser's relationship to the primary purchaser (VN only; see renderRelationshipTypeSelect).
                  relationshipType: isVietnam ? this.getRelationshipType(customerAdd) : '',
                  emergencyContactName: customerAdd.emergencyContactName,
                  emergencyContactRelation: customerAdd.emergencyContactRelation,
                  emergencyContactMobile: customerAdd.emergencyContactMobile,
                  emergencyContactMobilePrefix: customerAdd.emergencyContactMobilePrefix,
                  emergencyContactEmail: customerAdd.emergencyContactEmail,
                  emergencyContactIdentity: customerAdd.emergencyContactIdentity,
                  customer: {
                    identity: trimmedIdentity,
                    identityTypeID: !(0, _isNumber.isNumeric)(identityType) ? 6 : identityType,
                    identityPresetID: this.state.identityPresetID,
                    identityPresetLabel: this.state.identityPresetLabel,
                    identityPresetRegex: this.state.identityPresetRegex,
                    specifications: customerAdd.specifications,
                    taxIdentificationNo: customerAdd.customer.taxIdentificationNo,
                    taxTinValidationStatus: customerAdd.customer.taxTinValidationStatus,
                    isForeignCompany: customerAdd.customer.isForeignCompany
                  },
                  leadCustomerID: customerAdd.leadCustomerID,
                  leadICFrontURL: customerAdd.leadICFrontURL,
                  leadICBackURL: customerAdd.leadICBackURL
                };
                // Diagnostic: submit-time state when title/identity are blank (orphan-customer investigation).

                if (!postCustomer.title || !postCustomer.customer.identity) {
                  Bugsnag.notifyException(new Error('submitCustomer: blank title/identity at submit time'), 'Purchaser diagnostic', {
                    diagnostic: {
                      bookingID: this.state.data && this.state.data.id,
                      title: postCustomer.title,
                      identity: postCustomer.customer.identity,
                      identityTypeID: postCustomer.customer.identityTypeID,
                      leadCustomerID: postCustomer.leadCustomerID,
                      identityLock: this.state.identityLock,
                      mobileLock: this.state.mobileLock,
                      hideTitle: this.state.hideTitle,
                      errMessages: JSON.stringify(errMessages.map(function (m) {
                        return m.message;
                      })),
                      willBeBlocked: errMessages.length > 0
                    }
                  });
                }
                _context12.next = 27;
                return this.setComponentState({
                  errMessages: errMessages
                });

              case 27:
                if (!(errMessages.length > 0)) {
                  _context12.next = 37;
                  break;
                }

                header = t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation });

                if (isPRS && !this.state.addCustomerICChanges) header = _react2.default.createElement(
                  'span',
                  null,
                  'Please fix form errors or inform the customer to update their details in ',
                  _react2.default.createElement(
                    'a',
                    { href: 'http://www.pr1ma.my', target: '_blank' },
                    'PRS system (www.pr1ma.my)'
                  )
                );
                _context12.next = 32;
                return this.setLoading(false);

              case 32:
                store.dispatch((0, _flash.flashMessage)({
                  header: header,
                  list: errMessages.map(function (l) {
                    return l.message;
                  }),
                  icon: 'warning sign',
                  type: 'error',
                  autoHideDuration: 5000
                }));
                // Scroll
                body = document.getElementsByTagName('body')[0];
                customerAddGrid = document.getElementsByClassName('customer add');

                if (customerAddGrid.length > 0) {
                  window.scrollTo(0, body.scrollHeight - customerAddGrid[0].scrollHeight - 190);
                }
                return _context12.abrupt('return');

              case 37:
                if (!(!isVietnam && this.isUnderagePurchaser(postCustomer.birthdate))) {
                  _context12.next = 42;
                  break;
                }

                _context12.next = 40;
                return this.setLoading(false);

              case 40:
                store.dispatch((0, _flash.flashErrorMessage)({ message: this.getMinimumPurchaserAgeMessage() }));
                return _context12.abrupt('return');

              case 42:
                if (!(!isVietnam && this.isUnderageNRICPurchaser(postCustomer.customer.identityTypeID, trimmedIdentity))) {
                  _context12.next = 47;
                  break;
                }

                _context12.next = 45;
                return this.setLoading(false);

              case 45:
                store.dispatch((0, _flash.flashErrorMessage)({ message: this.getMinimumPurchaserAgeMessage() }));
                return _context12.abrupt('return');

              case 47:
                res = void 0;
                _context12.prev = 48;
                _context12.next = 51;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.state.data.id + '/customers/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(postCustomer)
                }));

              case 51:
                res = _context12.sent;
                _context12.next = 67;
                break;

              case 54:
                _context12.prev = 54;
                _context12.t0 = _context12['catch'](48);
                _context12.next = 58;
                return this.setLoading(false);

              case 58:
                if (!(_context12.t0.res && _context12.t0.res.status >= 400 && _context12.t0.res.status < 500)) {
                  _context12.next = 64;
                  break;
                }

                _context12.next = 61;
                return _context12.t0.res.text();

              case 61:
                message = _context12.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context12.abrupt('return');

              case 64:
                Bugsnag.notifyException(_context12.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context12.abrupt('return');

              case 67:
                _context12.next = 69;
                return res.json();

              case 69:
                data = _context12.sent;

                if (!this.state.addCustomerICChanges) {
                  _context12.next = 75;
                  break;
                }

                _context12.next = 73;
                return this.getDocumentToken(data, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
                  var formData, uploadError, query;
                  return regeneratorRuntime.wrap(function _callee10$(_context10) {
                    while (1) {
                      switch (_context10.prev = _context10.next) {
                        case 0:
                          _context10.next = 2;
                          return _this10.handleCreateFormData(true);

                        case 2:
                          formData = _context10.sent;
                          _context10.next = 5;
                          return _this10.uploadDocument(formData, data);

                        case 5:
                          uploadError = _context10.sent;
                          _context10.next = 8;
                          return _this10.setLoading(false);

                        case 8:
                          _context10.next = 10;
                          return _this10.resetCustomerAddDocumentState();

                        case 10:
                          _context10.next = 12;
                          return _this10.setComponentState({
                            customerAdd: Object.assign({}, _this10.state.bookingCustomerDefaultData),
                            customerAddArea: false,
                            autofillOptions: [],
                            identity: '',
                            identityType: '',
                            identityLock: false,
                            mobileLock: false,
                            prsID: '',
                            isEditingCustomer: 0,
                            existingCustomer: {},
                            taxIdentificationNo: ''
                          });

                        case 12:
                          _this10.handleResetCheck('addCustomerICChanges', function () {
                            if (_this10.state.customerAddChanges) {
                              _this10.handleResetCheck('customerAddChanges', function () {
                                _this10.handleOnCheck();
                              });
                            } else {
                              _this10.handleOnCheck();
                            }
                          });
                          query = (0, _url.decodeSearch)(_this10.props.location.search);

                          store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + _this10.state.data.id + '/?' + (0, _url.encodeSearch)(query)));
                          // CPI-1426: the purchaser is added either way, so the form still closes (submitting it
                          // again would add them twice), but a refused picture is shown again after navigating
                          // cleared it, rather than a success message.

                          if (!uploadError) {
                            _context10.next = 18;
                            break;
                          }

                          store.dispatch((0, _flash.flashErrorMessage)({ message: uploadError }));
                          return _context10.abrupt('return');

                        case 18:
                          store.dispatch((0, _flash.flashMessage)({
                            header: t('Purchaser Added', { ns: _translation.TRANSLATION_FILES.translation }),
                            message: t('Purchaser {{name}} was successfully added', { name: customerAdd.name, ns: _translation.TRANSLATION_FILES.translation }) + '.',
                            icon: 'check',
                            type: 'success',
                            autoHideDuration: 5000
                          }));

                        case 19:
                        case 'end':
                          return _context10.stop();
                      }
                    }
                  }, _callee10, _this10);
                })));

              case 73:
                _context12.next = 82;
                break;

              case 75:
                _context12.next = 77;
                return this.resetCustomerAddDocumentState();

              case 77:
                _context12.next = 79;
                return this.setComponentState({
                  customerAdd: Object.assign({}, this.state.bookingCustomerDefaultData),
                  customerAddArea: false,
                  autofillOptions: [],
                  identity: '',
                  identityType: '',
                  identityLock: false,
                  mobileLock: false,
                  existingCustomer: {},
                  taxIdentificationNo: ''
                });

              case 79:
                _context12.next = 81;
                return this.setLoading(false);

              case 81:
                this.handleResetCheck('customerAddChanges', _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
                  var query;
                  return regeneratorRuntime.wrap(function _callee11$(_context11) {
                    while (1) {
                      switch (_context11.prev = _context11.next) {
                        case 0:
                          query = (0, _url.decodeSearch)(_this10.props.location.search);
                          _context11.next = 3;
                          return store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + _this10.state.data.id + '/?' + (0, _url.encodeSearch)(query)));

                        case 3:
                          _context11.next = 5;
                          return store.dispatch((0, _flash.flashMessage)({
                            header: t('Purchaser Added', { ns: _translation.TRANSLATION_FILES.translation }),
                            message: t('Purchaser {{name}} was successfully added', { name: customerAdd.name, ns: _translation.TRANSLATION_FILES.translation }) + '.',
                            icon: 'check',
                            type: 'success',
                            autoHideDuration: 5000
                          }));

                        case 5:
                        case 'end':
                          return _context11.stop();
                      }
                    }
                  }, _callee11, _this10);
                })));

              case 82:
                if (this.props.checkHasChanges()) {
                  this.props.onCheck(false);
                }

              case 83:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this, [[48, 54]]);
      }));

      function submitCustomer() {
        return _ref11.apply(this, arguments);
      }

      return submitCustomer;
    }()
  }, {
    key: 'updateLPPSA',
    value: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(customerData) {
        var t, data, store, message;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                t = this.props.t;
                data = customerData;

                delete data.lppsaResult;
                delete data.customerDetail;
                _context13.next = 6;
                return this.setLoading(true);

              case 6:
                store = this.context.store;
                _context13.prev = 7;
                _context13.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.state.data.id + '/customer/' + data.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(data)
                }));

              case 10:
                _context13.next = 25;
                break;

              case 12:
                _context13.prev = 12;
                _context13.t0 = _context13['catch'](7);
                _context13.next = 16;
                return this.setLoading(false);

              case 16:
                if (!(_context13.t0.res && _context13.t0.res.status >= 400 && _context13.t0.res.status < 500)) {
                  _context13.next = 22;
                  break;
                }

                _context13.next = 19;
                return _context13.t0.res.text();

              case 19:
                message = _context13.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context13.abrupt('return');

              case 22:
                Bugsnag.notifyException(_context13.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context13.abrupt('return');

              case 25:
                _context13.next = 27;
                return this.setLoading(false);

              case 27:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this, [[7, 12]]);
      }));

      function updateLPPSA(_x23) {
        return _ref14.apply(this, arguments);
      }

      return updateLPPSA;
    }()
  }, {
    key: 'fetchGenerateESignToken',
    value: function () {
      var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(body) {
        var store, _props3, t, token, _state3, editingCustomer, isRenew, res, message, data;

        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _props3 = this.props, t = _props3.t, token = _props3.token;
                _state3 = this.state, editingCustomer = _state3.editingCustomer, isRenew = _state3.isRenew;
                res = void 0;
                _context14.prev = 6;
                _context14.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + editingCustomer.bookingID + '/customers/' + editingCustomer.customerID + '/signature_tokens/' + (isRenew ? 'new/' : ''), {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': token
                  },
                  body: JSON.stringify(body)
                }));

              case 9:
                res = _context14.sent;
                _context14.next = 20;
                break;

              case 12:
                _context14.prev = 12;
                _context14.t0 = _context14['catch'](6);

                Bugsnag.notifyException(_context14.t0);
                _context14.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context14.next = 19;
                return this.setLoading(false);

              case 19:
                return _context14.abrupt('return');

              case 20:
                if (res.ok) {
                  _context14.next = 28;
                  break;
                }

                _context14.next = 23;
                return res.text();

              case 23:
                message = _context14.sent;
                _context14.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context14.next = 32;
                break;

              case 28:
                _context14.next = 30;
                return res.json();

              case 30:
                data = _context14.sent;

                this.setState({ shareESignData: data });

              case 32:
                _context14.next = 34;
                return this.setLoading(false);

              case 34:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this, [[6, 12]]);
      }));

      function fetchGenerateESignToken(_x24) {
        return _ref15.apply(this, arguments);
      }

      return fetchGenerateESignToken;
    }()
  }, {
    key: 'fetchExistingESignToken',
    value: function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var editingCustomer, store, t, res, message, data;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this.setLoading(true);

              case 2:
                editingCustomer = this.state.editingCustomer;
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context15.prev = 6;
                _context15.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + editingCustomer.bookingID + '/customers/' + editingCustomer.customerID + '/signature_tokens/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context15.sent;
                _context15.next = 20;
                break;

              case 12:
                _context15.prev = 12;
                _context15.t0 = _context15['catch'](6);

                Bugsnag.notifyException(_context15.t0);
                _context15.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context15.next = 19;
                return this.setLoading(false);

              case 19:
                return _context15.abrupt('return');

              case 20:
                if (res.ok) {
                  _context15.next = 28;
                  break;
                }

                _context15.next = 23;
                return res.text();

              case 23:
                message = _context15.sent;
                _context15.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context15.next = 32;
                break;

              case 28:
                _context15.next = 30;
                return res.json();

              case 30:
                data = _context15.sent;

                this.setState({ shareESignData: data });

              case 32:
                _context15.next = 34;
                return this.setLoading(false);

              case 34:
              case 'end':
                return _context15.stop();
            }
          }
        }, _callee15, this, [[6, 12]]);
      }));

      function fetchExistingESignToken() {
        return _ref16.apply(this, arguments);
      }

      return fetchExistingESignToken;
    }()
  }, {
    key: 'sendESignToken',
    value: function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(type) {
        var store, _props4, t, token, _state4, editingCustomer, shareESignData, res, message;

        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _props4 = this.props, t = _props4.t, token = _props4.token;
                _state4 = this.state, editingCustomer = _state4.editingCustomer, shareESignData = _state4.shareESignData;
                res = void 0;
                _context16.prev = 6;
                _context16.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + editingCustomer.bookingID + '/customers/' + editingCustomer.customerID + '/signature_tokens/' + shareESignData.id + '/?type=' + type, {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': token
                  }
                }));

              case 9:
                res = _context16.sent;
                _context16.next = 20;
                break;

              case 12:
                _context16.prev = 12;
                _context16.t0 = _context16['catch'](6);

                Bugsnag.notifyException(_context16.t0);
                _context16.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context16.next = 19;
                return this.setLoading(false);

              case 19:
                return _context16.abrupt('return');

              case 20:
                if (res.ok) {
                  _context16.next = 28;
                  break;
                }

                _context16.next = 23;
                return res.text();

              case 23:
                message = _context16.sent;
                _context16.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context16.next = 29;
                break;

              case 28:
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Send Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  // CPI-976: the email channel (Vietnam) gets its own wording; SMS keeps the URL-and-PIN text.
                  message: type === 'email' ? t('The e-signing invitation has been emailed to the purchaser', { ns: _translation.TRANSLATION_FILES.translation }) : t('The URL and PIN have been sent to the purchaser', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 29:
                _context16.next = 31;
                return this.setLoading(false);

              case 31:
              case 'end':
                return _context16.stop();
            }
          }
        }, _callee16, this, [[6, 12]]);
      }));

      function sendESignToken(_x25) {
        return _ref17.apply(this, arguments);
      }

      return sendESignToken;
    }()
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var admin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var dhq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var dbl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var internal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      var auth = this.props.auth;
      if (dbl && this.props.auth.isBranchLeader) {
        return true;
      }
      if (dhq && this.props.auth.isHeadquarters) {
        return true;
      }
      if (admin && this.props.auth.isSuperAdmin) {
        return true;
      }
      if (internal && auth && auth.companyBranch && !auth.companyBranch.isExternal) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasCustomerManageAccess',
    value: function hasCustomerManageAccess(allowAgentManageBookingCustomer, bookingStatus) {
      var auth = this.props.auth;
      if (auth.companyBranch.isExternal && !allowAgentManageBookingCustomer) {
        return false;
      }
      if (auth.companyBranch.isExternal && allowAgentManageBookingCustomer && bookingStatus !== 'reserved') {
        return false;
      }
      return true;
    }
    // CPI-976: Vietnam E-Sign is held back after the client demo; wet-sign upload is the only route.

  }, {
    key: 'hasPurchaserSignPadAccess',
    value: function hasPurchaserSignPadAccess(allowAgentManageBookingCustomer, bookingStatus) {
      var auth = this.props.auth;

      if ((0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode)) {
        return false;
      }
      return this.hasCustomerManageAccess(allowAgentManageBookingCustomer, bookingStatus);
    }
  }, {
    key: 'hasChangePrimaryPurchaserAccess',
    value: function hasChangePrimaryPurchaserAccess(allowAgentChangePrimaryPurchaser, bookingStatus) {
      var auth = this.props.auth;
      if (auth && auth.companyBranch && auth.companyBranch.isExternal && allowAgentChangePrimaryPurchaser && bookingStatus === 'reserved') {
        return true;
      }
      return false;
    }
  }, {
    key: 'hasShareESignAccess',
    value: function hasShareESignAccess() {
      var data = this.state.data;
      var auth = this.props.auth;

      if ((0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode)) {
        return false;
      }
      if (data.project && data.project.shareESignIsEnabled) {
        if (auth.companyBranch.isExternal && !data.project.allowAgentShareESign) {
          return false;
        }
        if (auth.companyBranch.isExternal && data.project.allowAgentShareESign && data.statusID !== 'reserved') {
          return false;
        }
        return true;
      }
      return false;
    }
  }, {
    key: 'validateTIN',
    value: function () {
      var _ref18 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(tinInput, identityTypeID, identity, tinErrField, customerID, bookingID, target) {
        var idType, query, store, res, _setState, _setState2, errorMessage, _setState3, _setState4, _errorMessage, _setState5, _setState6;

        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (!(!tinInput || !identityTypeID || !identity)) {
                  _context17.next = 2;
                  break;
                }

                return _context17.abrupt('return');

              case 2:
                idType = (0, _identityTypes.getIdentityTypeOpts)().find(function (i) {
                  return i.value === identityTypeID;
                }).tin_code;
                query = Object.assign({
                  tin: tinInput,
                  idType: idType,
                  idValue: identity,
                  customerID: customerID,
                  bookingID: bookingID
                });
                store = this.context.store;
                _context17.prev = 5;
                _context17.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/tin/validate/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token,
                    'X-Origin': this.state.origin
                  }
                }));

              case 8:
                res = _context17.sent;

                if (!(res && res.ok)) {
                  _context17.next = 13;
                  break;
                }

                if (target === 'customerAdd') {
                  this.setState((_setState = {}, _defineProperty(_setState, tinErrField, false), _defineProperty(_setState, 'tinAddFound', true), _defineProperty(_setState, 'tinMessage', null), _setState));
                } else if (target === 'editingCustomer') {
                  this.setState((_setState2 = {}, _defineProperty(_setState2, tinErrField, false), _defineProperty(_setState2, 'tinEditFound', true), _defineProperty(_setState2, 'tinMessage', null), _setState2));
                }
                _context17.next = 18;
                break;

              case 13:
                _context17.next = 15;
                return res.text();

              case 15:
                errorMessage = _context17.sent;

                if (target === 'customerAdd') {
                  this.setState((_setState3 = {}, _defineProperty(_setState3, tinErrField, true), _defineProperty(_setState3, 'tinAddFound', false), _defineProperty(_setState3, 'tinMessage', errorMessage), _setState3));
                } else if (target === 'editingCustomer') {
                  this.setState((_setState4 = {}, _defineProperty(_setState4, tinErrField, true), _defineProperty(_setState4, 'tinEditFound', false), _defineProperty(_setState4, 'tinMessage', errorMessage), _setState4));
                }
                return _context17.abrupt('return');

              case 18:
                _context17.next = 27;
                break;

              case 20:
                _context17.prev = 20;
                _context17.t0 = _context17['catch'](5);

                if (!_context17.t0.res) {
                  _context17.next = 27;
                  break;
                }

                _context17.next = 25;
                return _context17.t0.res.text();

              case 25:
                _errorMessage = _context17.sent;

                if (target === 'customerAdd') {
                  this.setState((_setState5 = {}, _defineProperty(_setState5, tinErrField, true), _defineProperty(_setState5, 'tinAddFound', false), _defineProperty(_setState5, 'tinMessage', _errorMessage), _setState5));
                } else if (target === 'editingCustomer') {
                  this.setState((_setState6 = {}, _defineProperty(_setState6, tinErrField, true), _defineProperty(_setState6, 'tinEditFound', false), _defineProperty(_setState6, 'tinMessage', _errorMessage), _setState6));
                }

              case 27:
              case 'end':
                return _context17.stop();
            }
          }
        }, _callee17, this, [[5, 20]]);
      }));

      function validateTIN(_x31, _x32, _x33, _x34, _x35, _x36, _x37) {
        return _ref18.apply(this, arguments);
      }

      return validateTIN;
    }()
    // CPI-1332: in a Vietnamese isolated-purchaser booking, book-api says per purchaser whether they
    // are linked to a CRM Customer. A linked purchaser shows that customer's current identity
    // pictures; an unlinked one keeps Showroom's own. While the answer is pending, or when it failed,
    // no picture is shown, so an older Showroom picture never stands in for the current one.

    // CPI-1426: in a Vietnamese isolated-purchaser booking every identity upload must be an image,
    // linked or not, and also while the link is still unknown. A linked purchaser's replaces the CRM
    // Customer's picture (book-api refuses a PDF); an unlinked one's is copied there later, which
    // skips a PDF.

    // The picture an edit form starts from.

  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
    // CPI-976: Citizenship (Vietnam only), stored on the booking customer as 'local' | 'foreigner';
    // "Country of Citizen" reuses `nationality`. A row predating the column derives it from that.

    // target = 'editingCustomer' (primary / related purchaser edit form) or 'customerAdd' (add form)

    // Relationship type of a related purchaser to the primary purchaser (Vietnam only). Stored on
    // the booking customer as relationshipType, prefilled from the CRM related customer's
    // `relationship_type`; the value set is RELATIONSHIP_TYPE (matched case-insensitively).

    // Rendered inside the Citizenship row (renderCitizenshipInputs), beside Citizenship. Vietnam only.
    // target = 'editingCustomer' (related purchaser edit form) or 'customerAdd' (add form; always a related purchaser)

  }, {
    key: 'renderDefaultField',
    value: function renderDefaultField(field, idx, isEditing, customer, customerIdx, isAddCustomer) {
      var _this11 = this;

      var data = field;
      var t = this.props.t;

      var isRestricted = !isAddCustomer && this.isBULeaderRestrictedEdit(this.state.data);
      // MS-6495 use data.label instead of data.name cause purchaser fields labels can be customized in project settings
      var formLabel = '' + t(data.label, { ns: _translation.TRANSLATION_FILES.models.customer });
      if (data.name === 'emergencyContactMobile') {
        var emergencyContactValidation = [{
          validate: _webValidations.phoneNumber,
          option: customer.emergencyContactMobilePrefix === 'other' ? {} : {
            isMobile: true,
            phonePrefix: customer.emergencyContactMobilePrefix,
            validRegex: (0, _phone.getPhoneValidRegex)(this.state.phoneValidationPresets, customer.emergencyContactMobilePrefix, 'mobile')
          }
        }];
        if (data.isRequired && !data.isDisabled && !isRestricted) {
          emergencyContactValidation.push(_webValidations.required);
        }
        return _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { key: idx, width: 16 },
          isEditing ? _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal' },
            _react2.default.createElement(
              _AppForm2.default.Validate,
              {
                ref: this.validation.emergencyContactMobilePrefix,
                onChange: isAddCustomer ? this.handleCustomerAddSelectChange : this.handleCustomerSelectChange,
                validateLabel: t('{{label}} Prefix', { label: data.label })
              },
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                disabled: isRestricted,
                label: t('{{label}} Prefix', { label: data.label }),
                name: 'emergencyContactMobilePrefix',
                onChange: isAddCustomer ? this.handleCustomerAddSelectChange : this.handleCustomerSelectChange,
                options: this.toUppercaseOptions(_intlCallCodes2.default),
                search: true,
                selectOnBlur: false,
                value: customer.emergencyContactMobilePrefix,
                noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
              })
            ),
            _react2.default.createElement(_PhoneInput2.default, {
              disabled: isRestricted,
              autoComplete: 'off',
              label: '' + formLabel + (data.isRequired ? '*' : ''),
              name: 'emergencyContactMobile',
              onChange: isAddCustomer ? this.handleCustomerAddInputChange : this.handleCustomerInputChange,
              placeholder: formLabel,
              prefix: customer.emergencyContactMobilePrefix,
              ref: this.validation.emergencyContactMobile,
              type: 'tel',
              validation: emergencyContactValidation,
              value: customer.emergencyContactMobile,
              validateLabel: data.label
            })
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'left', width: 6 },
                  _react2.default.createElement(
                    'b',
                    null,
                    formLabel
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'right', width: 10 },
                  _react2.default.createElement(_Phone2.default, {
                    mobilePrefix: customer.emergencyContactMobilePrefix,
                    mobile: customer.emergencyContactMobile
                  })
                )
              )
            ),
            _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } })
          )
        );
      }
      if (data.name === 'birthdate') {
        return _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { key: idx, mobile: 16, tablet: 8, computer: 8 },
          isEditing ? _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal' },
            _react2.default.createElement(_InputBirthdate2.default, {
              date: customer.birthdate,
              onSelectDay: isAddCustomer ? this.handleBirthdateSelectAdd : this.handleBirthdateSelectEdit,
              label: '' + formLabel + (data.isRequired ? '*' : ''),
              disabled: isRestricted || isPRS || customer.identityTypeID === 4
            })
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { stretched: true },
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'left', width: 6 },
                  _react2.default.createElement(
                    'b',
                    null,
                    formLabel
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  _extends({ textAlign: 'right', width: 10 }, this.getDataAttributes(customerIdx, 'birthdate', customer.birthdate)),
                  customer.birthdate || '-'
                )
              )
            ),
            _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } })
          )
        );
      }
      if (data.name === 'race') {
        var raceOptions = _race.RACE.map(function (o) {
          return _extends({}, o, {
            text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants })
          });
        });
        var optionText = customer[data.name];
        var option = raceOptions.find(function (d) {
          return d.value === customer[data.name];
        });
        if (option) {
          optionText = option.text;
        }
        return _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { key: idx, mobile: 16, tablet: 8, computer: 8 },
          isEditing ? _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal' },
            _react2.default.createElement(
              _AppForm2.default.Validate,
              {
                validation: data.isRequired && !data.isDisabled && !isRestricted ? [_webValidations.required] : null,
                ref: this.validation.race,
                onChange: function onChange(e, d) {
                  return isAddCustomer ? _this11.handleCustomerAddSelectChange(e, d, raceOptions) : _this11.handleCustomerSelectChange(e, d, raceOptions);
                },
                validateLabel: data.label
              },
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                disabled: isRestricted,
                name: 'race',
                fluid: true,
                options: this.toUppercaseOptions(raceOptions),
                placeholder: data.label,
                label: '' + formLabel + (data.isRequired ? '*' : ''),
                search: true,
                selectOnBlur: false,
                value: customer[data.name],
                noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
              })
            ),
            _react2.default.createElement(_AppForm2.default.Input, {
              autoComplete: 'off',
              disabled: isRestricted || customer[data.name].toUpperCase() !== 'Others'.toUpperCase(),
              fluid: true,
              name: 'raceOther',
              onChange: isAddCustomer ? this.handleCustomerAddInputChange : this.handleCustomerInputChange,
              placeholder: t('Fill in your Race'),
              label: (0, _translation2.translateModels)(t, 'raceOther', 'booking'),
              value: customer.raceOther,
              validateLabel: (0, _translation2.translateModels)(t, 'raceOther', 'booking'),
              ref: this.validation.raceOther,
              validation: customer[data.name].toUpperCase() === 'Others'.toUpperCase() && !isRestricted ? [_webValidations.required] : null
            })
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { stretched: true },
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'left', width: 6 },
                  _react2.default.createElement(
                    'b',
                    null,
                    formLabel
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  _extends({ textAlign: 'right', width: 10 }, this.checkAddDataAttributeBCF(data.name) && this.getDataAttributes(customerIdx, data.name.toLowerCase(), this.valueToText(raceOptions, customer[data.name]))),
                  _react2.default.createElement(
                    'div',
                    null,
                    this.toUppercaseFormat(optionText || '-')
                  )
                )
              )
            ),
            _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } })
          )
        );
      }
      if (data.type === 'input') {
        return isEditing ? _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { key: idx, mobile: 16, tablet: 8, computer: 8 },
          _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal' },
            _react2.default.createElement(_AppForm2.default.Input, {
              disabled: isRestricted || data.isDisabled,
              autoComplete: 'off',
              label: '' + formLabel + (data.isRequired ? '*' : ''),
              name: data.name,
              onChange: isAddCustomer ? this.handleCustomerAddInputChange : this.handleCustomerInputChange,
              placeholder: data.placeholder,
              ref: this.validation[data.name],
              validation: data.isRequired && !data.isDisabled && !isRestricted ? [_webValidations.required, {
                validate: function validate(value) {
                  return (0, _RegexDropdownPicker.checkRegex)(value, data);
                }
              }] : [{
                validate: function validate(value) {
                  return (0, _RegexDropdownPicker.checkRegex)(value, data);
                }
              }],
              value: customer[data.name],
              validateLabel: data.label
            })
          )
        ) : _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { key: idx, mobile: 16, tablet: 8, computer: 8 },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { stretched: true },
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'left', width: 6 },
                  _react2.default.createElement(
                    'b',
                    null,
                    formLabel
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'right', width: 10, className: 'word_break_word' },
                  data.name !== 'emergencyContactEmail' ? this.toUppercaseFormat(customer[data.name]) : customer[data.name] || '-'
                )
              )
            ),
            _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } })
          )
        );
      }
      if (data.type === 'textarea') {
        return _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { key: idx, mobile: 16, tablet: 8, computer: 8 },
          isEditing ? _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal' },
            _react2.default.createElement(
              _AppForm2.default.Validate,
              {
                validation: data.isRequired && !data.isDisabled && !isRestricted ? [_webValidations.required] : null,
                ref: this.validation[data.name],
                onChange: isAddCustomer ? this.handleCustomerAddInputChange : this.handleCustomerInputChange,
                validateLabel: data.label
              },
              _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                disabled: isRestricted || data.isDisabled,
                autoComplete: 'off',
                label: '' + formLabel + (data.isRequired ? '*' : ''),
                name: data.name,
                placeholder: data.placeholder,
                ref: this.validation[data.name],
                value: customer[data.name],
                style: { minHeight: '6em', height: '6em' }
              })
            )
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { stretched: true },
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'left', width: 6 },
                  _react2.default.createElement(
                    'b',
                    null,
                    formLabel
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'right', width: 10, className: 'word_break_word' },
                  this.toUppercaseFormat(customer[data.name] || '-')
                )
              )
            ),
            _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } })
          )
        );
      }
      if (data.type === 'dropdown' || data.type === 'dropdown_multi') {
        var renderLabel = function renderLabel(label) {
          return {
            content: label.text,
            circular: true
          };
        };
        var fieldOptions = [];
        if (field && field.projectBookingCustomFieldOptions) {
          field.projectBookingCustomFieldOptions.forEach(function (d) {
            fieldOptions.push({ text: d.title, value: d.value, id: d.id });
          });
        }
        if (data.isDefault) {
          switch (data.name) {
            case 'nationality':
              fieldOptions = _countries.SELECT_NATIONALITY;
              break;
            case 'gender':
              fieldOptions = _gender.GENDER.map(function (o) {
                return _extends({}, o, {
                  text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants })
                });
              });
              break;
            case 'bumi':
              fieldOptions = _bumi.BUMI.map(function (o) {
                return _extends({}, o, {
                  text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants })
                });
              });
              break;
            case 'maritalStatus':
              fieldOptions = _maritalStatus.MARITAL_STATUS.map(function (o) {
                return _extends({}, o, {
                  text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants })
                });
              });
              break;
            default:
              break;
          }
        }
        var _optionText = '';
        var value = customer[data.name];
        if (data.type === 'dropdown_multi') {
          if (customer[data.name]) {
            var selectedOptions = fieldOptions.filter(function (o) {
              var match = false;
              customer[data.name].split(',').forEach(function (v) {
                if (v === o.value) match = true;
              });
              return match;
            });
            _optionText = selectedOptions.map(function (v, key) {
              return _react2.default.createElement(
                _semanticUiReact.Label,
                { key: key, circular: true, size: 'small' },
                v.text
              );
            });
          }
          if (customer[data.name] && value !== '') {
            value = value.split(',');
          } else {
            value = [];
          }
        } else if (data.type === 'dropdown') {
          var _option = fieldOptions.find(function (d) {
            return d.value === customer[data.name];
          });
          if (_option) {
            _optionText = _option.text;
          }
        }
        return _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { key: idx, mobile: 16, tablet: 8, computer: 8 },
          isEditing ? _react2.default.createElement(
            _semanticUiReact.Form.Group,
            { widths: 'equal' },
            _react2.default.createElement(
              _AppForm2.default.Validate,
              {
                key: idx,
                validation: data.isRequired && !data.isDisabled && !isRestricted ? [_webValidations.required] : null,
                ref: this.validation[data.name],
                onChange: function onChange(e, d) {
                  return isAddCustomer ? _this11.handleCustomerAddSelectChange(e, d, fieldOptions) : _this11.handleCustomerSelectChange(e, d, fieldOptions);
                },
                validateLabel: data.label
              },
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                disabled: isRestricted || data.isDisabled,
                label: '' + formLabel + (data.isRequired ? '*' : ''),
                name: data.name,
                options: this.toUppercaseOptions(fieldOptions),
                placeholder: data.placeholder,
                search: true,
                selectOnBlur: false,
                value: value,
                multiple: data.type === 'dropdown_multi',
                renderLabel: renderLabel,
                noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
              })
            )
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { stretched: true },
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'left', width: 6 },
                  _react2.default.createElement(
                    'b',
                    null,
                    formLabel
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  _extends({ textAlign: 'right', width: 10, className: 'word_break_word' }, this.checkAddDataAttributeBCF(data.name) && this.getDataAttributes(customerIdx, data.name.toLowerCase(), this.valueToText(fieldOptions, value))),
                  _react2.default.createElement(
                    'div',
                    null,
                    this.toUppercaseFormat(_optionText || '-')
                  )
                )
              )
            ),
            _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } })
          )
        );
      }
      return '';
    }
  }, {
    key: 'renderDefaultFields',
    value: function renderDefaultFields(isEditing, customer, customerIdx) {
      var _this12 = this;

      var isAddCustomer = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var projectBookingCustomFields = this.state.projectBookingCustomFields;
      var auth = this.props.auth;

      var isVietnam = (0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode);
      var defaultFields = _defaultBookingFields.EXTRA_PURCHASER_CUSTOM_FIELDS;
      if (projectBookingCustomFields && projectBookingCustomFields.length > 0 && projectBookingCustomFields.filter(function (c) {
        return c.isDefault;
      }).length > 0) {
        defaultFields = projectBookingCustomFields.filter(function (c) {
          return c.isDefault;
        });
      }
      if (isVietnam) {
        // CPI-976: no SST / race / bumi for Vietnam; Nationality is replaced by the Citizenship pair.
        defaultFields = defaultFields.filter(function (c) {
          return !['race', 'bumi', 'sstRegistrationNo', 'nationality'].includes(c.name);
        });
      }
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          defaultFields.filter(function (bcf) {
            return _defaultBookingFields.PURCHASER_CUSTOM_FIELDS.some(function (pf) {
              return bcf.name !== pf.name && !bcf.isHidden;
            });
          }).sort(function (a, b) {
            return a.position - b.position;
          }).map(function (d, idx) {
            return _this12.renderDefaultField(d, idx, isEditing, customer, customerIdx, isAddCustomer);
          })
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this13 = this;

      var _props5 = this.props,
          isMobile = _props5.isMobile,
          addressSettings = _props5.addressSettings,
          t = _props5.t,
          appConfig = _props5.appConfig,
          combinedPrintTmplOnly = _props5.combinedPrintTmplOnly,
          auth = _props5.auth;

      var enabledAddressSettings = addressSettings.data.filter(function (as) {
        return as.enabled;
      });
      var _state5 = this.state,
          bookingStatusModal = _state5.bookingStatusModal,
          customerAddArea = _state5.customerAddArea,
          data = _state5.data,
          editingCustomer = _state5.editingCustomer,
          isEditingCustomer = _state5.isEditingCustomer,
          isIOS = _state5.isIOS,
          modal = _state5.modal,
          widthIsLessThan1200 = _state5.widthIsLessThan1200,
          projectBookingCustomFields = _state5.projectBookingCustomFields,
          shareESignData = _state5.shareESignData,
          screenWidth = _state5.screenWidth;

      var isIndonesia = auth.company.countryCode.toUpperCase() === 'ID';
      var isMalaysia = auth && auth.company.countryCode.toUpperCase() === 'MY';
      var isVietnam = (0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode);
      // CPI-1262 (7 Sep) hid the purchaser ID snapshot for Vietnam: the card was Malaysian in shape,
      // NRIC front and back with MyKad sample images. CPI-1332 item 1 (20 Sep) asks for it back, so a
      // buyer typed in on the swap flow can have their identity document attached. It returns in the
      // Vietnamese shape - two sides for a CCCD, one image for a passport or an Enterprise
      // Registration Certificate, no MyKad samples - and MY/ID keep exactly what they had. Stored
      // documents and purchaser identity fields are unchanged either way.
      var showsIDSnapshot = true;
      var editShape = this.idDocumentShape(editingCustomer.customer && editingCustomer.customer.identityTypeID || editingCustomer.identityTypeID);
      var addShape = this.idDocumentShape(this.state.identityType);
      // Vietnam's current launch uses wet-sign only, so the E-Sign card remains hidden.
      var showsESignature = !isVietnam;
      var signatureColumnWidth = showsIDSnapshot ? widthIsLessThan1200 ? 16 : 8 : 16;
      var isNewMalaysia = this.state.customerAdd.country.toUpperCase() === 'MY';
      var isEditMalaysia = editingCustomer.country.toUpperCase() === 'MY';
      var hideLabel = isIndonesia || this.state.customerAdd.customer.isForeignCompany;
      var requiredIdentityLabel = getRequiredIdentityLabel(isVietnam, this.state.identityType, t);
      var identityInputLabel = !hideLabel && isVietnam && this.state.identityType === _defaultIdentityTypeOpts.IDENTITY_TYPE_NRIC ? requiredIdentityLabel + ' *' : this.getIdentityInputLabel(hideLabel);
      // add validateRef for all custom fields
      if (projectBookingCustomFields && projectBookingCustomFields.length > 0) {
        projectBookingCustomFields.filter(function (bcf) {
          return _defaultBookingFields.PURCHASER_CUSTOM_FIELDS.some(function (pf) {
            return bcf.name !== pf.name && bcf.isDefault && !bcf.isHidden;
          });
        }).forEach(function (pcf) {
          _this13.validation[pcf.name] = (0, _react.createRef)();
        });
      }
      var constructIdentityTypeDropdown = function constructIdentityTypeDropdown() {
        return isPRS ? _react2.default.createElement(_AppForm2.default.Input, {
          loading: _this13.state.searchingID,
          autoComplete: 'off',
          name: 'prsID',
          onChange: _this13.handlePRSIDChange,
          placeholder: t('PRS ID') + '*',
          ref: _this13.validation.prsID,
          readOnly: _this13.state.identityLock,
          validation: [_webValidations.required, {
            validate: _webValidations.stringLength,
            option: {
              min: 13
            }
          }],
          value: _this13.state.prsID,
          validateLabel: t('PRS ID') + '*'
        }) : _react2.default.createElement(
          _AppForm2.default.Validate,
          {
            onChange: _this13.handleIDTypeChange,
            validation: [_webValidations.required],
            ref: _this13.validation.identityType,
            validateLabel: t('Identity Type')
          },
          _react2.default.createElement(_semanticUiReact.Dropdown, {
            disabled: _this13.state.identityLock,
            fluid: true,
            name: 'identityType',
            options: _this13.toUppercaseOptions(_this13.state.identityTypeOpts).map(function (o) {
              return _extends({}, o, {
                text: t(o.text, { ns: _translation.TRANSLATION_FILES.screens })
              });
            }),
            placeholder: t('Select {{title}}', { title: t('Identity Type') }) + '*',
            selection: true,
            selectOnBlur: false,
            value: _this13.state.identityType
          })
        );
      };
      var constructIdentityInput = function constructIdentityInput() {
        return _react2.default.createElement(_AppForm2.default.Input, {
          className: 'ui input\n            ' + (_this13.state.searchingID ? 'loading circle notched icon ' : '') + '\n            ' + (_this13.hasResetIdentityIcon() ? 'icon ' : '') + '\n            ' + (_this13.state.identityError ? ' error' : ''),
          label: identityInputLabel,
          disabled: _this13.state.identityType === '',
          name: 'identity',
          onChange: _this13.handleIdentityChange,
          placeholder: _this13.getIdentityPlaceholder(isIndonesia),
          readOnly: _this13.state.identityLock,
          inputRef: _this13.identityInputRef,
          type: 'text',
          value: _this13.state.identity,
          icon: _this13.hasResetIdentityIcon() ? _react2.default.createElement(_semanticUiReact.Icon, {
            link: true,
            name: 'x',
            onClick: _this13.handleResetAutofill,
            title: t('Clear Form')
          }) : _this13.state.searchingID ? _react2.default.createElement(_semanticUiReact.Icon, { loading: true, name: 'circle notch' }) : null,
          validation: [_webValidations.required, {
            validate: _webValidations.identity,
            option: _this13.identityValidation()
          }],
          validateRef: _this13.validation.identity,
          validateLabel: requiredIdentityLabel,
          onError: function onError(identityError) {
            _this13.setState({ identityError: identityError });
          }
        });
      };
      var isForeignCompanyCheckbox = function isForeignCompanyCheckbox(currentAction) {
        return _react2.default.createElement(
          'div',
          { style: { display: 'flex', justifyContent: 'start', marginTop: '1em' } },
          _react2.default.createElement(_semanticUiReact.Checkbox, {
            label: 'Foreign company',
            onChange: function onChange(e, d) {
              _this13.setState(function (prevState) {
                return _defineProperty({}, currentAction, _extends({}, prevState[currentAction], {
                  customer: _extends({}, prevState[currentAction].customer, {
                    taxIdentificationNo: d.checked ? _tin.FOREIGN_BUYER_GENERIC_TIN : '',
                    isForeignCompany: d.checked
                  })
                }));
              }, function () {
                _this13.handleTinInput({ target: { value: d.checked ? _this13.state[currentAction].customer.taxIdentificationNo : '', tinAddFound: false, tinEditFound: false } }, currentAction);
              });
            },
            checked: _this13.state[currentAction].customer.isForeignCompany
          })
        );
      };
      var isMobileView = screenWidth <= 767;
      var isTabletView = screenWidth > 767 && screenWidth <= 991;
      var isComputerView = screenWidth > 991;
      var constructResponsiveIdentityTinInputs = function constructResponsiveIdentityTinInputs() {
        var constructTinInput = function constructTinInput() {
          var mustValidTinForMY = isMalaysia && _this13.state.identityType !== 2 && (_this13.state.identityType === 4 || data.project && data.project.requireValidTinAtBookingCreation);
          var tinValidation = [];
          if (isIndonesia) {
            tinValidation = [{
              validate: _webValidations.matchRegex,
              option: {
                validRegex: _regex.REGEX_NPWP_ID
              }
            }];
          } else {
            tinValidation = mustValidTinForMY && !_this13.state.customerAdd.customer.isForeignCompany ? [_webValidations.required, {
              validate: _webValidations.matchRegex,
              option: { validRegex: _regex.REGEX_TIN_VALID }
            }] : [{
              validate: _webValidations.matchRegex,
              option: { validRegex: _regex.REGEX_TIN_VALID }
            }];
          }

          return _react2.default.createElement(_TinFieldInput2.default, {
            isIndonesia: isIndonesia,
            value: _this13.state.customerAdd.customer.taxIdentificationNo,
            errMessage: _this13.state.tinMessage,
            isLoading: _this13.state.validatingTin,
            tinError: isMalaysia && _this13.state.tinErrorAdd,
            required: isMalaysia && mustValidTinForMY && !_this13.state.customerAdd.customer.isForeignCompany,
            validation: tinValidation,
            ref: _this13.validation.taxIdentificationNo,
            onChange: function onChange(e) {
              return _this13.handleTinInput(e, 'customerAdd');
            },
            identityType: _this13.state.identityType,
            identityValue: _this13.state.identity
            // readOnly={this.state.tinAddFound}
            , unitID: data.projectUnitID,
            bookingID: data.id
          });
        };

        return _react2.default.createElement(
          _react2.default.Fragment,
          null,
          isMobileView && _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 1, centered: true },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { style: { marginBottom: identityInputLabel ? '1rem' : '1.5rem' } },
              constructIdentityTypeDropdown(),
              isMalaysia && _this13.state.identityType === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && isForeignCompanyCheckbox('customerAdd')
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', style: { marginBottom: '1rem' } },
              constructIdentityInput()
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              (isMalaysia || isIndonesia) && constructTinInput()
            )
          ),
          isTabletView && _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 3, centered: true },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { style: { marginTop: identityInputLabel ? '2.2rem' : '1.9rem' } },
              constructIdentityTypeDropdown(),
              isMalaysia && _this13.state.identityType === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && isForeignCompanyCheckbox('customerAdd')
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', style: { marginTop: identityInputLabel ? '0.1rem' : '1.9rem' } },
              constructIdentityInput()
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { style: { marginTop: identityInputLabel ? '1.3rem' : '0rem' } },
              (isMalaysia || isIndonesia) && constructTinInput()
            )
          ),
          isComputerView && _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 3, centered: true },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { style: { marginTop: '1.9rem' } },
              constructIdentityTypeDropdown(),
              isMalaysia && _this13.state.identityType === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && isForeignCompanyCheckbox('customerAdd')
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', style: { marginTop: identityInputLabel ? '0.1rem' : '1.9rem' } },
              constructIdentityInput()
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              (isMalaysia || isIndonesia) && constructTinInput()
            )
          )
        );
      };

      var himsIsEnabled = appConfig && appConfig.data && appConfig.data.himsIsEnabled && data && data.project && data.project.himsIsEnabled;
      var reviewPurchasers = isVietnam && data.purchasersIsolated && (0, _url.decodeSearch)(this.props.location.search).reviewPurchasers === '1';

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_ESigningModal2.default, {
          ref: function ref(_ref20) {
            _this13.signatureModal = _ref20;
          },
          loading: this.state.loading,
          open: this.state.showSignModal,
          saveButton: _react2.default.createElement(_semanticUiReact.Button, { onClick: function onClick(event) {
              return _this13.saveSignature(event, editingCustomer);
            }, disabled: this.state.loading, positive: true, color: 'green', content: t('Save', { ns: _translation.TRANSLATION_FILES.translation }) }),
          cancelButton: _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleOnCancel, disabled: this.state.loading, basic: true, color: 'grey', content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }) })
        }),
        _react2.default.createElement(_ShareESign2.default, {
          data: shareESignData,
          bookingData: data,
          loading: this.state.loading,
          customerData: editingCustomer,
          open: showsESignature && this.state.showShareESignModal,
          isMobile: isMobile,
          onClose: this.handleOnCloseShareESign,
          onProceed: this.handleProceedShareESign,
          onRenew: this.handleRenewESign,
          onSend: this.handleSendESignToken,
          printTemplates: combinedPrintTmplOnly,
          isVietnam: isVietnam
        }),
        _react2.default.createElement(_BookingStatusNotes2.default, {
          onNotesChange: this.handleNotesChange,
          onCheckboxChange: this.handleCheckboxChange,
          statusID: data.statusID,
          notes: data.remarkInternal,
          isCancelPending: data.isCancelPending,
          onClose: this.handleCancelBookingStatus,
          onConfirm: this.handleConfirmBookingStatus,
          open: bookingStatusModal
        }),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          { closeOnDimmerClick: false, open: this.state.showSoldConfirmation, basic: true, size: 'small' },
          _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: t('Confirm Update', { ns: _translation.TRANSLATION_FILES.translation }) }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              'h4',
              null,
              t('Check if any printed forms, receipts, or invoices have the old buyer\'s details instead of the new one.')
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(
              _semanticUiReact.Button,
              { onClick: this.handleCancelSoldUpdate, basic: true, color: 'grey', inverted: true },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove' }),
              ' ',
              t('Cancel', { ns: _translation.TRANSLATION_FILES.translation })
            ),
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                onClick: this.handleConfirmSoldUpdate,
                color: 'blue',
                inverted: true
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' }),
              ' ',
              t('Confirm', { ns: _translation.TRANSLATION_FILES.translation })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          { closeOnDimmerClick: false, open: modal.isOpen, basic: true, size: 'small' },
          _react2.default.createElement(_semanticUiReact.Header, { icon: modal.headerIcon, content: modal.header }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              'h4',
              null,
              modal.message
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(
              _semanticUiReact.Button,
              { onClick: this.handleCloseModal, basic: true, color: 'red', inverted: true },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove' }),
              ' ',
              t('No', { ns: _translation.TRANSLATION_FILES.constants })
            ),
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                onClick: this.handleConfirm,
                color: 'green',
                inverted: true
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' }),
              ' ',
              t('Yes', { ns: _translation.TRANSLATION_FILES.constants })
            )
          )
        ),
        _react2.default.createElement(_BookingTitle2.default, { isMobile: isMobile, data: data }),
        reviewPurchasers && _react2.default.createElement(
          _semanticUiReact.Message,
          { warning: true, icon: true },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'warning sign' }),
          _react2.default.createElement(
            _semanticUiReact.Message.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Message.Header,
              null,
              t('Review related purchasers')
            ),
            t('The unit has been reserved. Edit and save every related purchaser with invalid or missing details before continuing.')
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, style: isMobile ? { padding: '0' } : {} },
              _react2.default.createElement(
                'div',
                null,
                data.bookingCustomers && data.bookingCustomers.length > 0 ? data.bookingCustomers.sort(this.sortPrimaryCustomer).map(function (customerData, idx) {
                  var customerDropdownOptions = _this13.customerDropdownOptions(customerData, data, idx);
                  var mustValidTinEdit = isMalaysia && editingCustomer.customer.identityTypeID !== 2 && (editingCustomer.customer.identityTypeID === 4 || data.project && data.project.requireValidTinAtBookingCreation);
                  var tinValidation = [];
                  if (isIndonesia) {
                    tinValidation = [{
                      validate: _webValidations.matchRegex,
                      option: { validRegex: _regex.REGEX_NPWP_ID } // Regex for Indonesian NPWP
                    }];
                  } else if (isMalaysia) {
                    tinValidation = mustValidTinEdit && !editingCustomer.customer.isForeignCompany ? [_webValidations.required, { validate: _webValidations.matchRegex, option: { validRegex: _regex.REGEX_TIN_VALID } }] : [{ validate: _webValidations.matchRegex, option: { validRegex: _regex.REGEX_TIN_VALID } }];
                  }
                  return _react2.default.createElement(
                    'div',
                    { key: idx, id: customerData.id },
                    customerData.customerID !== data.customerID && _react2.default.createElement('div', null),
                    _react2.default.createElement(
                      _semanticUiReact.Header,
                      { className: 'new_title', as: 'h5', attached: 'top', textAlign: 'center' },
                      _react2.default.createElement(
                        _semanticUiReact.Grid,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { textAlign: isMobile ? 'left' : 'center' },
                          customerData.customerID === data.customerID ? data.bookingCustomers && data.bookingCustomers.length > 1 ? _react2.default.createElement(
                            'b',
                            null,
                            t('Primary Purchaser').toUpperCase(),
                            ' ',
                            _react2.default.createElement(_semanticUiReact.Icon, { disabled: true, name: 'star' })
                          ) : t('Purchaser').toUpperCase() : t('Purchaser').toUpperCase() + ' ' + (idx + 1),
                          _react2.default.createElement(
                            'div',
                            { style: { position: 'absolute', right: '1em', top: '1em' } },
                            _this13.hasCustomerManageAccess(data.project.allowAgentManageBookingCustomer, data.statusID) ? _this13.checkUnitIsSold(data) && !_this13.hasAccess() && !_this13.isBULeader() ? '' : isEditingCustomer === customerData.customerID ? _react2.default.createElement(
                              'button',
                              {
                                className: 'a-button-gray',
                                onClick: _this13.handleCancelEditCustomer
                              },
                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'x', fitted: true, style: { marginRight: '0.5rem' } })
                            ) : customerData.customerID === data.customerID ? !isPRS && _react2.default.createElement(_semanticUiReact.Popup, {
                              trigger: _react2.default.createElement(
                                'div',
                                { style: { display: 'inline-block' } },
                                _react2.default.createElement(
                                  'button',
                                  {
                                    disabled: _this13.disableEditAfterSold(data) || isEditingCustomer !== 0 || customerAddArea,
                                    className: 'a-button-gray ' + ((_this13.disableEditAfterSold(data) || isEditingCustomer !== 0 || customerAddArea) && 'disabled'),
                                    onClick: function onClick() {
                                      _this13.handleEditCustomer(customerData);
                                    }
                                  },
                                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'edit', fitted: true, style: { marginRight: '0.5rem' } }),
                                  t('Edit', { ns: _translation.TRANSLATION_FILES.translation })
                                )
                              ),
                              disabled: !_this13.disableEditAfterSold(data),
                              content: t('Purchaser details are locked because the booking has been marked as Sold', { ns: _translation.TRANSLATION_FILES.translation })
                            }) : _react2.default.createElement(_semanticUiReact.Dropdown, {
                              disabled: _this13.disableEditAfterSold(data) || isEditingCustomer !== 0 || customerAddArea,
                              selectOnBlur: false,
                              trigger: _react2.default.createElement(_semanticUiReact.Icon, { size: 'large', color: 'grey', name: 'ellipsis horizontal' }),
                              icon: null,
                              pointing: 'top right',
                              options: customerDropdownOptions
                            }) : ''
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Segment,
                      { attached: true },
                      _react2.default.createElement(
                        _semanticUiReact.Grid,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Row,
                          null,
                          isEditingCustomer || customerAddArea ? _react2.default.createElement(_semanticUiReact.Dimmer, {
                            style: { zIndex: 5, opacity: '0.75' },
                            active: isEditingCustomer !== customerData.customerID,
                            inverted: true
                          }) : null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { width: 16 },
                            isEditingCustomer === customerData.customerID ? _react2.default.createElement(
                              _semanticUiReact.Grid,
                              null,
                              showsIDSnapshot && _react2.default.createElement(
                                _semanticUiReact.Grid.Row,
                                null,
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    null,
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Row,
                                      null,
                                      !_this13.isBULeaderRestrictedEdit(data) ? _react2.default.createElement(
                                        _react2.default.Fragment,
                                        null,
                                        _react2.default.createElement(
                                          _semanticUiReact.Grid.Column,
                                          { mobile: 16, tablet: editShape.sides === 2 ? 8 : 16, computer: editShape.sides === 2 ? 8 : 16, textAlign: 'center' },
                                          _react2.default.createElement(_UploadForm2.default, _extends({
                                            isCompress: true,
                                            title: 'Front',
                                            ref: function ref(_ref21) {
                                              _this13.icFrontUpload = _ref21;
                                            },
                                            setLoading: _this13.setLoading,
                                            loading: _this13.state.loading,
                                            sampleURL: editShape.sample ? '/assets/images/samples/ic_front.svg' : '',
                                            tags: ['IC Front'],
                                            bucketName: _this13.getMPBucketName()
                                          }, _this13.identityPictureProps(editingCustomer, 'front'), {
                                            onChange: function onChange(ic) {
                                              return _this13.handleGetIC(ic, 'Front', 'customerICChanges');
                                            }
                                          }))
                                        ),
                                        editShape.sides === 2 && _react2.default.createElement(
                                          _semanticUiReact.Grid.Column,
                                          { mobile: 16, tablet: 8, computer: 8, textAlign: 'center' },
                                          _react2.default.createElement(_UploadForm2.default, _extends({
                                            isCompress: true,
                                            title: 'Back',
                                            ref: function ref(_ref22) {
                                              _this13.icBackUpload = _ref22;
                                            },
                                            setLoading: _this13.setLoading,
                                            loading: _this13.state.loading,
                                            sampleURL: editShape.sample ? '/assets/images/samples/ic_back.svg' : '',
                                            tags: ['IC Back'],
                                            bucketName: _this13.getMPBucketName()
                                          }, _this13.identityPictureProps(editingCustomer, 'back'), {
                                            onChange: function onChange(ic) {
                                              return _this13.handleGetIC(ic, 'Back', 'customerICChanges');
                                            }
                                          }))
                                        )
                                      ) : _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { mobile: 16, tablet: 16, computer: 16, textAlign: 'center' },
                                        _react2.default.createElement(
                                          'div',
                                          { style: { padding: '2em', color: '#999' } },
                                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', size: 'large' }),
                                          _react2.default.createElement(
                                            'p',
                                            null,
                                            t('IC upload is locked for SOLD bookings')
                                          )
                                        )
                                      )
                                    )
                                  )
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Row,
                                null,
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  null,
                                  _react2.default.createElement(
                                    _AppForm2.default,
                                    {
                                      error: _this13.state.errMessages.length > 0,
                                      onSubmit: _this13.handleSubmitCustomer,
                                      ref: function ref(_ref23) {
                                        _this13.form = _ref23;
                                      },
                                      id: 'edit_purchaser_form'
                                    },
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Row,
                                      null,
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { mobile: 16, tablet: 10, computer: editingCustomer.clientID ? 16 : 8 },
                                        _react2.default.createElement(
                                          _semanticUiReact.Form.Group,
                                          { widths: 'equal' },
                                          _react2.default.createElement(_AppForm2.default.Input, {
                                            disabled: true,
                                            name: 'identityTypeID',
                                            autoComplete: 'off',
                                            label: _this13.getIdentityTypeText(customerData.customer.identityTypeID, customerData.customer.identityPresetID, customerData.customer.identityPresetLabel),
                                            value: customerData.customer.identity
                                          }),
                                          editingCustomer.clientID ? _react2.default.createElement(_AppForm2.default.Input, {
                                            disabled: true,
                                            autoComplete: 'off',
                                            label: (0, _translation2.translateModels)(t, 'clientID', 'booking'),
                                            name: 'clientID',
                                            onChange: _this13.handleCustomerInputChange,
                                            placeholder: (0, _translation2.translateModels)(t, 'clientID', 'booking'),
                                            value: editingCustomer.clientID
                                          }) : null,
                                          (isMalaysia || isIndonesia) && _react2.default.createElement(_TinFieldInput2.default, {
                                            disabled: _this13.isBULeaderRestrictedEdit(data),
                                            isIndonesia: isIndonesia
                                            // readOnly={isMalaysia && this.state.tinEditFound}
                                            , value: editingCustomer.customer.taxIdentificationNo,
                                            errMessage: _this13.state.tinMessage,
                                            isLoading: _this13.state.validatingTin,
                                            tinError: isMalaysia && _this13.state.tinErrorEdit,
                                            required: isMalaysia && mustValidTinEdit && !editingCustomer.customer.isForeignCompany,
                                            validation: tinValidation,
                                            ref: _this13.validation.taxIdentificationNo,
                                            onChange: function onChange(e) {
                                              return _this13.handleTinInput(e, 'editingCustomer');
                                            },
                                            identityType: editingCustomer.customer.identityTypeID,
                                            identityValue: editingCustomer.customer.identity,
                                            unitID: data.projectUnitID,
                                            bookingID: data.id
                                          })
                                        )
                                      )
                                    ),
                                    isMalaysia && editingCustomer.customer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && _react2.default.createElement(
                                      _semanticUiReact.Grid.Row,
                                      { style: { marginBottom: '1em' } },
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        null,
                                        isForeignCompanyCheckbox('editingCustomer')
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Row,
                                      null,
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { width: 16 },
                                        _react2.default.createElement(
                                          _semanticUiReact.Form.Group,
                                          { widths: 'equal' },
                                          _this13.state.hideTitle ? null : _react2.default.createElement(
                                            _AppForm2.default.Validate,
                                            {
                                              validation: [_webValidations.required],
                                              ref: _this13.validation.title,
                                              onChange: _this13.handleCustomerSelectChange,
                                              validateLabel: (0, _translation2.translateModels)(t, 'title', 'booking')
                                            },
                                            _react2.default.createElement(_semanticUiReact.Form.Select, {
                                              disabled: _this13.isBULeaderRestrictedEdit(data),
                                              label: (0, _translation2.translateModels)(t, 'title', 'booking') + '*',
                                              name: 'title',
                                              onChange: _this13.handleCustomerSelectChange,
                                              options: _this13.toUppercaseOptions(_customerTitles2.default).map(function (o) {
                                                return _extends({}, o, {
                                                  text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants })
                                                });
                                              }),
                                              placeholder: t('Select {{title}}', { title: (0, _translation2.translateModels)(t, 'title', 'booking') }) + '*',
                                              search: true,
                                              selectOnBlur: false,
                                              noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }),
                                              value: editingCustomer.title
                                            })
                                          ),
                                          _react2.default.createElement(_AppForm2.default.Input, {
                                            disabled: _this13.isBULeaderRestrictedEdit(data),
                                            autoComplete: 'off',
                                            label: t(editingCustomer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? 'Company Name' : 'Full Name') + '*',
                                            name: 'name',
                                            onChange: _this13.handleCustomerInputChange,
                                            placeholder: t(editingCustomer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? 'Company Name' : 'Full Name') + '*',
                                            ref: _this13.validation.name,
                                            validation: [_webValidations.required].concat(_toConsumableArray((0, _vietnam.vnFullNameValidations)(auth, editingCustomer.identityTypeID, t))),
                                            value: editingCustomer.name,
                                            validateLabel: t(editingCustomer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? 'Company Name' : 'Full Name')
                                          }),
                                          _react2.default.createElement(_AppForm2.default.Input, {
                                            disabled: _this13.isBULeaderRestrictedEdit(data),
                                            autoComplete: 'off',
                                            label: t(editingCustomer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? 'Contact Person' : 'Preferred Name') + '*',
                                            name: 'preferredName',
                                            onChange: _this13.handleCustomerInputChange,
                                            placeholder: t(editingCustomer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? 'Contact Person' : 'Preferred Name') + '*',
                                            ref: _this13.validation.preferredName,
                                            validation: editingCustomer.identityTypeID === 4 ? [_webValidations.required].concat(_toConsumableArray((0, _vietnam.vnPreferredNameValidations)(auth, t))) : [_webValidations.required, {
                                              validate: _webValidations.stringLength,
                                              option: {
                                                max: 15
                                              }
                                            }].concat(_toConsumableArray((0, _vietnam.vnPreferredNameValidations)(auth, t))),
                                            value: editingCustomer.preferredName,
                                            validateLabel: t(editingCustomer.identityTypeID === 4 ? 'Contact Person' : 'Preferred Name')
                                          }),
                                          _react2.default.createElement(_AppForm2.default.Input, {
                                            autoComplete: 'off',
                                            label: '' + (0, _translation2.translateModels)(t, 'email', 'booking') + (_this13.checkIsEmailRequired() ? '*' : ''),
                                            name: 'email',
                                            type: 'email',
                                            onChange: _this13.handleCustomerInputChange,
                                            placeholder: (0, _translation2.translateModels)(t, 'email', 'booking'),
                                            value: editingCustomer.email,
                                            ref: _this13.validation.email,
                                            validation: _this13.getEmailValidation(),
                                            validateLabel: (0, _translation2.translateModels)(t, 'email', 'booking')
                                          })
                                        ),
                                        _react2.default.createElement(
                                          _semanticUiReact.Form.Group,
                                          { widths: 'equal' },
                                          _react2.default.createElement(
                                            _AppForm2.default.Validate,
                                            {
                                              validation: [_webValidations.required],
                                              ref: _this13.validation.mobilePrefix,
                                              onChange: _this13.handleCustomerSelectChange,
                                              validateLabel: (0, _translation2.translateModels)(t, 'mobilePrefix', 'booking')
                                            },
                                            _react2.default.createElement(_semanticUiReact.Form.Select, {
                                              label: (0, _translation2.translateModels)(t, 'mobilePrefix', 'booking') + '*',
                                              name: 'mobilePrefix',
                                              disabled: data.origin && data.origin.includes('marketplace_') && editingCustomer.originCustomerID !== '',
                                              onChange: _this13.handleCustomerSelectChange,
                                              options: _this13.toUppercaseOptions(_intlCallCodes2.default),
                                              search: true,
                                              selectOnBlur: false,
                                              noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }),
                                              value: editingCustomer.mobilePrefix
                                            })
                                          ),
                                          _react2.default.createElement(_PhoneInput2.default, {
                                            autoComplete: 'off',
                                            label: t('Mobile') + '*',
                                            name: 'mobile',
                                            disabled: data.origin && data.origin.includes('marketplace_') && editingCustomer.originCustomerID !== '',
                                            onChange: _this13.handleCustomerInputChange,
                                            placeholder: 'e.g. 196756118',
                                            prefix: editingCustomer.mobilePrefix,
                                            ref: _this13.validation.mobile,
                                            type: 'tel',
                                            validation: [_webValidations.required, {
                                              validate: _webValidations.phoneNumber,
                                              option: editingCustomer.mobilePrefix === 'other' ? {} : {
                                                isMobile: true,
                                                phonePrefix: editingCustomer.mobilePrefix,
                                                validRegex: (0, _phone.getPhoneValidRegex)(_this13.state.phoneValidationPresets, editingCustomer.mobilePrefix, 'mobile')
                                              }
                                            }],
                                            value: editingCustomer.mobile,
                                            validateLabel: t('Mobile')
                                          })
                                        ),
                                        _react2.default.createElement(
                                          _semanticUiReact.Form.Group,
                                          { widths: 'equal' },
                                          _react2.default.createElement(_semanticUiReact.Form.Select, {
                                            label: t('House/Office Phone prefix'),
                                            name: 'phonePrefix',
                                            onChange: _this13.handleCustomerSelectChange,
                                            options: _this13.toUppercaseOptions(_intlCallCodes2.default),
                                            search: true,
                                            selectOnBlur: false,
                                            noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }),
                                            value: editingCustomer.phonePrefix
                                          }),
                                          _react2.default.createElement(_PhoneInput2.default, {
                                            autoComplete: 'off',
                                            label: t('House/Office Phone'),
                                            name: 'phone',
                                            onChange: _this13.handleCustomerInputChange,
                                            placeholder: 'e.g. 378317749',
                                            prefix: editingCustomer.phonePrefix,
                                            ref: _this13.validation.phone,
                                            type: 'tel',
                                            value: editingCustomer.phone,
                                            validation: [{
                                              validate: _webValidations.phoneNumber,
                                              option: editingCustomer.phonePrefix === 'other' ? {} : {
                                                phonePrefix: editingCustomer.phonePrefix,
                                                validRegex: (0, _phone.getPhoneValidRegex)(_this13.state.phoneValidationPresets, editingCustomer.phonePrefix, 'phone')
                                              }
                                            }],
                                            validateLabel: t('House/Office Phone')
                                          })
                                        ),
                                        _this13.renderCitizenshipInputs('editingCustomer'),

                                        // https://stackoverflow.com/questions/49491452/map-an-array-by-every-two-elements
                                        _lodash2.default.chunk(enabledAddressSettings.map(function (as, iidx) {
                                          var key = _lodash2.default.camelCase(as.columnName);
                                          var addressLabel = as.label.toLowerCase();
                                          var isRequired = as.required;
                                          var errMessage = null;
                                          var validations = [{
                                            validate: _webValidations.stringLength,
                                            option: {
                                              max: 256
                                            }
                                          }];

                                          // Determine behavior based on selected country in the form
                                          var selectedCountry = (editingCustomer.country || '').toUpperCase();
                                          var isSelectedCountryMalaysia = selectedCountry === 'MY';

                                          // When company is Vietnam: apply country-dependent logic for state field
                                          if (isVietnam && addressLabel === 'state') {
                                            if (isSelectedCountryMalaysia) {
                                              // Malaysia selected: keep as "State", required
                                              isRequired = true;
                                            } else {
                                              // Non-Malaysia selected: change to "City/Province", optional
                                              addressLabel = 'cityOrProvince';
                                              isRequired = false;
                                            }
                                          } else if (isVietnam && addressLabel === 'city' && !isSelectedCountryMalaysia) {
                                            addressLabel = 'ward';
                                            isRequired = false;
                                          } else if (isVietnam && addressLabel === 'postcode' && !isSelectedCountryMalaysia) {
                                            addressLabel = 'postalCode';
                                            isRequired = false;
                                          }

                                          if (isRequired) {
                                            validations.push(_webValidations.required);
                                          }
                                          if (!himsIsEnabled && isSelectedCountryMalaysia && as.label.toLowerCase() === 'postcode') {
                                            validations.push({
                                              validate: _webValidations.matchRegex,
                                              option: {
                                                validRegex: _regex.REGEX_POSTCODE_MY
                                              }
                                            });
                                            errMessage = 'Invalid MY postcode format';
                                          }

                                          var label = '' + (0, _translation2.translateModels)(t, addressLabel, 'booking') + (isRequired ? '*' : '');

                                          if (!isPRS && isSelectedCountryMalaysia && as.label.toLowerCase() === 'state') {
                                            return _react2.default.createElement(
                                              _AppForm2.default.Validate,
                                              {
                                                key: iidx,
                                                validation: isRequired ? [_webValidations.required] : null,
                                                ref: _this13.validation[key],
                                                onChange: _this13.handleCustomerSelectChange,
                                                validateLabel: as.label.toLowerCase() === 'state' ? (0, _translation2.translateModels)(t, 'state', 'booking') : as.label
                                              },
                                              _react2.default.createElement(_semanticUiReact.Form.Select, {
                                                name: key,
                                                fluid: true,
                                                options: _this13.toUppercaseOptions(_states2.default),
                                                placeholder: t('Select {{title}}', { title: label.toLowerCase() }),
                                                label: label,
                                                search: true,
                                                selectOnBlur: false,
                                                noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }),
                                                value: editingCustomer[key]
                                              })
                                            );
                                          }

                                          if (himsIsEnabled && isSelectedCountryMalaysia && as.label.toLowerCase() === 'postcode') {
                                            return _react2.default.createElement(_SearchHimsPostcodes2.default, {
                                              key: iidx,
                                              validateRef: _this13.validation.himsKodPoskod,
                                              name: 'himsKodPoskod',
                                              onSelect: _this13.handleCustomerSelectHimsPostcode,
                                              state: editingCustomer.address7,
                                              value: editingCustomer.himsKodPoskod
                                            });
                                          }

                                          return _react2.default.createElement(_AppForm2.default.Input, {
                                            key: iidx,
                                            autoComplete: 'off',
                                            name: key,
                                            onChange: _this13.handleCustomerInputChange,
                                            placeholder: label,
                                            label: label,
                                            ref: _this13.validation[key],
                                            validation: validations,
                                            value: editingCustomer[key],
                                            validateLabel: as.label,
                                            message: errMessage
                                          });
                                        }).concat([_react2.default.createElement(
                                          _AppForm2.default.Validate,
                                          {
                                            key: 'country',
                                            validation: [_webValidations.required],
                                            ref: _this13.validation.country,
                                            onChange: function onChange(e, countryData) {
                                              // Reset state input field
                                              if (!isPRS) {
                                                var as = enabledAddressSettings.find(function (a) {
                                                  return a.label.toLowerCase() === 'state';
                                                });
                                                if (as) {
                                                  var key = _lodash2.default.camelCase(as.columnName);
                                                  if (editingCustomer[key]) {
                                                    editingCustomer[key] = '';
                                                    _this13.setState({ editingCustomer: editingCustomer });
                                                  }
                                                }
                                              }
                                              _this13.handleCustomerSelectChange(e, countryData);
                                            },
                                            validateLabel: (0, _translation2.translateModels)(t, 'country', 'booking')
                                          },
                                          _react2.default.createElement(_semanticUiReact.Form.Select, {
                                            disabled: _this13.isBULeaderRestrictedEdit(data),
                                            autoComplete: 'off',
                                            fluid: true,
                                            label: (0, _translation2.translateModels)(t, 'country', 'booking') + '*',
                                            name: 'country',
                                            options: _this13.toUppercaseOptions(_countries.SELECT_COUNTRIES),
                                            placeholder: t('Select {{title}}', { title: (0, _translation2.translateModels)(t, 'country', 'booking') }) + '*',
                                            search: true,
                                            selectOnBlur: false,
                                            noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }),
                                            value: editingCustomer.country
                                          })
                                        )]), 2).map(function (p, iidx) {
                                          return _react2.default.createElement(
                                            _semanticUiReact.Form.Group,
                                            { widths: 'equal', key: 'group_' + iidx },
                                            p
                                          );
                                        }),
                                        himsIsEnabled && isEditMalaysia ? _react2.default.createElement(
                                          _semanticUiReact.Form.Group,
                                          { widths: 'equal' },
                                          _react2.default.createElement(_SearchHimsDistricts2.default, {
                                            validateRef: _this13.validation.himsKodDaerah,
                                            name: 'himsKodDaerah',
                                            onSelect: _this13.handleCustomerSelectHimsDistrict,
                                            state: editingCustomer.address7,
                                            value: editingCustomer.himsKodDaerah
                                          }),
                                          _react2.default.createElement('span', { style: { flex: '1 1 auto', width: '100%' } })
                                        ) : null,
                                        _react2.default.createElement('br', null),
                                        _this13.renderDefaultFields(true, editingCustomer, idx)
                                      )
                                    )
                                  )
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Row,
                                null,
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    null,
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Row,
                                      null,
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { width: 16, textAlign: 'center' },
                                        _react2.default.createElement(
                                          _semanticUiReact.Button,
                                          {
                                            type: 'button',
                                            onClick: function onClick(e) {
                                              e.preventDefault();
                                              if (_this13.icFrontUpload) _this13.icFrontUpload.resetFiles();
                                              if (_this13.icBackUpload) _this13.icBackUpload.resetFiles();
                                              _this13.setState({
                                                icFront: null,
                                                icBack: null,
                                                errMessages: [],
                                                isEditingCustomer: 0,
                                                editingCustomer: Object.assign({}, _this13.state.bookingCustomerDefaultData)
                                              }, function () {
                                                _this13.handleResetCheck('customerChanges');
                                              });
                                            }
                                          },
                                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove' }),
                                          ' ',
                                          t('Cancel', { ns: _translation.TRANSLATION_FILES.translation })
                                        ),
                                        _react2.default.createElement(
                                          _semanticUiReact.Button,
                                          {
                                            color: 'blue',
                                            disabled: _this13.state.validatingTin,
                                            onClick: function onClick(e) {
                                              return _this13.form.handleSubmit(e);
                                            }
                                          },
                                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'save' }),
                                          ' ',
                                          t('Update', { ns: _translation.TRANSLATION_FILES.translation })
                                        )
                                      )
                                    )
                                  )
                                )
                              )
                            ) : _react2.default.createElement(
                              _semanticUiReact.Grid,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Row,
                                null,
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { mobile: 16, tablet: 16, computer: 6 },
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    null,
                                    showsIDSnapshot && _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: getIDSnapshotColumnWidth(showsESignature, widthIsLessThan1200), style: !widthIsLessThan1200 && showsESignature ? { paddingRight: '0.2em' } : { paddingBottom: '0.5em' } },
                                      // check if is IOS and conditional rendering  ( NRIC snapshot )
                                      !isIOS ? _react2.default.createElement(
                                        _semanticUiReact.Container,
                                        { className: 'nric-signature-container' },
                                        customerData && (_this13.identityDocumentComplete(customerData, isVietnam) || !!customerData.buyerProfileID && !!customerData.buyerICFront && !!customerData.buyerICBack) ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', style: { color: 'green', float: 'right', fontSize: '1.5em', margin: '0.1em' } }) : null,
                                        _react2.default.createElement(
                                          _semanticUiReact.Grid,
                                          { style: { justifyContent: 'center', paddingTop: '0.5em' } },
                                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'id card outline' }),
                                          _react2.default.createElement(
                                            _semanticUiReact.Header,
                                            { className: 'icSignStyle', as: 'h4' },
                                            t('{{name}} Snapshot', { name: isVietnam ? _this13.idDocumentShape(customerData.customer.identityTypeID).label : customerData.customer.identityTypeID === 1 ? t('NRIC') : 'ID' })
                                          )
                                        ),
                                        _react2.default.createElement(
                                          _semanticUiReact.Grid,
                                          { style: { justifyContent: 'center', paddingTop: '0.8em' } },
                                          _react2.default.createElement(
                                            'div',
                                            null,
                                            customerData && !!customerData.buyerProfileID && !!customerData.buyerICFront && !!customerData.buyerICBack && _react2.default.createElement(
                                              _semanticUiReact.Label,
                                              { size: 'mini', as: 'a', color: 'blue', onClick: function onClick(e) {
                                                  return _this13.handleOpenHTML(e, customerData, true);
                                                } },
                                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'print' }),
                                              t('Buyer App')
                                            ),
                                            _this13.hasCustomerManageAccess(data.project.allowAgentManageBookingCustomer, data.statusID) && customerData && customerData.customer && (customerData.customer.icFrontDocumentID !== '' || customerData.customer.icBackDocumentID !== '') && (_this13.checkICIsImage(customerData.customer) ? _react2.default.createElement(
                                              _semanticUiReact.Label,
                                              { size: 'mini', as: 'a', color: 'blue', onClick: function onClick(e) {
                                                  return _this13.handleOpenHTML(e, customerData);
                                                } },
                                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'print' }),
                                              t('Print')
                                            ) : _react2.default.createElement(
                                              'div',
                                              { style: { display: 'inline-block' } },
                                              customerData.customer.icFrontDocument && customerData.customer.icFrontDocument.key ? _react2.default.createElement(
                                                _semanticUiReact.Label,
                                                {
                                                  size: 'mini',
                                                  as: 'a',
                                                  color: 'blue',
                                                  href: _config2.default.get('bookApiURL') + '/customers/' + customerData.customer.id + '/documents/' + customerData.customer.icFrontDocument.id + '/view/',
                                                  target: '_blank'
                                                },
                                                t('View Front')
                                              ) : null,
                                              customerData.customer.icBackDocument && customerData.customer.icBackDocument.key ? _react2.default.createElement(
                                                _semanticUiReact.Label,
                                                {
                                                  size: 'mini',
                                                  as: 'a',
                                                  color: 'blue',
                                                  href: _config2.default.get('bookApiURL') + '/customers/' + customerData.customer.id + '/documents/' + customerData.customer.icBackDocument.id + '/view/',
                                                  target: '_blank'
                                                },
                                                t('View Back')
                                              ) : null
                                            )),
                                            customerData && _this13.crmIdentityOf(customerData.customerID).failed && _react2.default.createElement(
                                              'p',
                                              { style: { color: '#9f3a38', margin: '0.3em 0' } },
                                              t('The current CRM identity pictures could not be loaded. Reload the page to try again.')
                                            ),
                                            _this13.hasCustomerManageAccess(data.project.allowAgentManageBookingCustomer, data.statusID) && _react2.default.createElement(_semanticUiReact.Popup, {
                                              trigger: _react2.default.createElement(
                                                _semanticUiReact.Label,
                                                {
                                                  size: 'mini',
                                                  as: 'a',
                                                  color: 'blue',
                                                  onClick: function onClick() {
                                                    if (!_this13.disableEditAfterSold(data)) {
                                                      _this13.handleEditCustomer(customerData);
                                                    }
                                                  },
                                                  style: customerData && _this13.identityDocumentComplete(customerData, isVietnam) ? {
                                                    marginLeft: '0.3em'
                                                  } : null
                                                },
                                                customerData && _this13.identityDocumentComplete(customerData, isVietnam) ? _react2.default.createElement(
                                                  'div',
                                                  null,
                                                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'pencil' }),
                                                  ' ',
                                                  t('Edit', { ns: _translation.TRANSLATION_FILES.translation })
                                                ) : t('Upload', { ns: _translation.TRANSLATION_FILES.translation }) + ' ' + (isVietnam ? _this13.idDocumentShape(customerData.customer.identityTypeID).label : t(customerData.customer.identityTypeID === 1 ? 'IC' : 'Identification'))
                                              ),
                                              disabled: !_this13.disableEditAfterSold(data),
                                              content: t('Purchaser details are locked because the booking has been marked as Sold', { ns: _translation.TRANSLATION_FILES.translation })
                                            })
                                          )
                                        )
                                      ) : _react2.default.createElement(
                                        _semanticUiReact.Container,
                                        { className: 'nric-signature-container' },
                                        customerData && (_this13.identityDocumentComplete(customerData, isVietnam) || !!customerData.buyerProfileID && !!customerData.buyerICFront && !!customerData.buyerICBack) ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', style: { color: 'green', float: 'right', fontSize: '1.5em', margin: '0.1em' } }) : null,
                                        _react2.default.createElement(
                                          _semanticUiReact.Grid,
                                          { style: { justifyContent: 'center', paddingTop: '0.5em', margin: '0' } },
                                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'id card outline' }),
                                          _react2.default.createElement(
                                            _semanticUiReact.Header,
                                            { className: 'icSignStyle', as: 'h4' },
                                            t('{{name}} Snapshot', { name: isVietnam ? _this13.idDocumentShape(customerData.customer.identityTypeID).label : t('NRIC') })
                                          )
                                        ),
                                        _react2.default.createElement(
                                          _semanticUiReact.Grid,
                                          { style: { justifyContent: 'center', paddingTop: '0.8em', marginTop: '0' } },
                                          _react2.default.createElement(
                                            'div',
                                            null,
                                            customerData && !!customerData.buyerProfileID && !!customerData.buyerICFront && !!customerData.buyerICBack && _react2.default.createElement(
                                              _semanticUiReact.Label,
                                              { size: 'mini', as: 'a', color: 'blue', onClick: function onClick(e) {
                                                  return _this13.handleOpenHTML(e, customerData, true);
                                                } },
                                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'print' }),
                                              t('Buyer App')
                                            ),
                                            _this13.hasCustomerManageAccess(data.project.allowAgentManageBookingCustomer, data.statusID) && customerData && customerData.customer && (customerData.customer.icFrontDocumentID !== '' || customerData.customer.icBackDocumentID !== '') && (_this13.checkICIsImage(customerData.customer) ? _react2.default.createElement(
                                              _semanticUiReact.Label,
                                              { size: 'mini', as: 'a', color: 'blue', onClick: function onClick(e) {
                                                  return _this13.handleOpenHTML(e, customerData);
                                                } },
                                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'print' }),
                                              t('Print')
                                            ) : _react2.default.createElement(
                                              'div',
                                              { style: { display: 'inline-block' } },
                                              customerData.customer.icFrontDocument && customerData.customer.icFrontDocument.key ? _react2.default.createElement(
                                                _semanticUiReact.Label,
                                                {
                                                  size: 'mini',
                                                  as: 'a',
                                                  color: 'blue',
                                                  href: _config2.default.get('bookApiURL') + '/customers/' + customerData.customer.id + '/documents/' + customerData.customer.icFrontDocument.id + '/view/',
                                                  target: '_blank'
                                                },
                                                t('View Front')
                                              ) : null,
                                              customerData.customer.icBackDocument && customerData.customer.icBackDocument.key ? _react2.default.createElement(
                                                _semanticUiReact.Label,
                                                {
                                                  size: 'mini',
                                                  as: 'a',
                                                  color: 'blue',
                                                  href: _config2.default.get('bookApiURL') + '/customers/' + customerData.customer.id + '/documents/' + customerData.customer.icBackDocument.id + '/view/',
                                                  target: '_blank'
                                                },
                                                t('View Back')
                                              ) : null
                                            )),
                                            customerData && _this13.crmIdentityOf(customerData.customerID).failed && _react2.default.createElement(
                                              'p',
                                              { style: { color: '#9f3a38', margin: '0.3em 0' } },
                                              t('The current CRM identity pictures could not be loaded. Reload the page to try again.')
                                            ),
                                            _this13.hasCustomerManageAccess(data.project.allowAgentManageBookingCustomer, data.statusID) && _react2.default.createElement(_semanticUiReact.Popup, {
                                              trigger: _react2.default.createElement(
                                                _semanticUiReact.Label,
                                                {
                                                  size: 'mini',
                                                  as: 'a',
                                                  color: 'blue',
                                                  onClick: function onClick() {
                                                    if (!_this13.disableEditAfterSold(data)) {
                                                      _this13.handleEditCustomer(customerData);
                                                    }
                                                  },
                                                  disabled: _this13.disableEditAfterSold(data),
                                                  style: customerData && _this13.identityDocumentComplete(customerData, isVietnam) ? {
                                                    marginLeft: '0.3em'
                                                  } : null
                                                },
                                                customerData && _this13.identityDocumentComplete(customerData, isVietnam) ? _react2.default.createElement(
                                                  'div',
                                                  null,
                                                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'pencil' }),
                                                  ' ',
                                                  t('Edit', { ns: _translation.TRANSLATION_FILES.translation })
                                                ) : t('Upload', { ns: _translation.TRANSLATION_FILES.translation }) + ' ' + (isVietnam ? _this13.idDocumentShape(customerData.customer.identityTypeID).label : t(customerData.customer.identityTypeID === 1 ? 'IC' : 'Identification'))
                                              ),
                                              disabled: !_this13.disableEditAfterSold(data),
                                              content: t('Purchaser details are locked because the booking has been marked as Sold', { ns: _translation.TRANSLATION_FILES.translation })
                                            })
                                          )
                                        )
                                      )
                                      // check if is ios and conditional rendering ( NRIC snapshot )

                                    ),
                                    showsESignature && (
                                    // check if is IOS and conditional rendering ( E-Signature )
                                    !isIOS ? _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'right', width: signatureColumnWidth, style: !widthIsLessThan1200 ? { paddingLeft: showsIDSnapshot ? '0.2em' : '1rem' } : { paddingTop: 0 } },
                                      _react2.default.createElement(
                                        _semanticUiReact.Container,
                                        { className: 'nric-signature-container e-signature-container' },
                                        customerData && customerData.signAt ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', style: { color: 'green', float: 'right', fontSize: '1.5em', margin: '0.1em' } }) : null,
                                        _react2.default.createElement(
                                          _semanticUiReact.Grid,
                                          { style: { justifyContent: 'center', paddingTop: '0.5em' } },
                                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'pencil' }),
                                          _react2.default.createElement(
                                            _semanticUiReact.Header,
                                            { className: 'icSignStyle', as: 'h4' },
                                            t('E-Signature'),
                                            _this13.renderSignPadUnavailableTooltip()
                                          )
                                        ),
                                        _react2.default.createElement(
                                          _semanticUiReact.Grid,
                                          { style: { justifyContent: 'center', paddingTop: '0.8em' } },
                                          customerData && customerData.signAt ? _react2.default.createElement(
                                            'div',
                                            { style: { display: 'flex', marginTop: '0.2em' } },
                                            'Signed on\xA0',
                                            _react2.default.createElement(_Timestamp2.default, {
                                              timestamp: customerData.signAt
                                            }),
                                            '\xA0',
                                            _this13.hasPurchaserSignPadAccess(data.project.allowAgentManageBookingCustomer, data.statusID) && _react2.default.createElement(
                                              'button',
                                              { onClick: function onClick(e) {
                                                  return _this13.handleShowSign(e, customerData);
                                                }, className: 'a-button-blue', style: { marginLeft: '0.2em' } },
                                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'edit' })
                                            ),
                                            _this13.hasShareESignAccess() && _react2.default.createElement(
                                              'button',
                                              { disabled: _this13.state.loading, onClick: function onClick(e) {
                                                  return _this13.handleShowShareESign(e, customerData);
                                                }, className: 'a-button-blue', style: { marginLeft: '0.2em' } },
                                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'share square' })
                                            )
                                          ) : _react2.default.createElement(
                                            'div',
                                            { className: 'e-signature-actions' },
                                            _this13.hasPurchaserSignPadAccess(data.project.allowAgentManageBookingCustomer, data.statusID) ? _react2.default.createElement(
                                              _semanticUiReact.Label,
                                              {
                                                size: 'mini',
                                                as: 'a',
                                                color: 'blue',
                                                onClick: function onClick(e) {
                                                  return _this13.handleShowSign(e, customerData);
                                                }
                                              },
                                              t('Sign')
                                            ) : null,
                                            _this13.hasShareESignAccess() && _react2.default.createElement(
                                              _semanticUiReact.Label,
                                              {
                                                size: 'mini',
                                                as: 'a',
                                                color: 'blue',
                                                onClick: function onClick(e) {
                                                  return _this13.handleShowShareESign(e, customerData);
                                                },
                                                disabled: _this13.state.loading
                                              },
                                              t('Share')
                                            )
                                          )
                                        )
                                      )
                                    ) : _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'right', width: signatureColumnWidth, style: !widthIsLessThan1200 ? { paddingLeft: showsIDSnapshot ? '0.2em' : '1rem' } : { paddingTop: 0 } },
                                      _react2.default.createElement(
                                        _semanticUiReact.Container,
                                        { className: 'nric-signature-container e-signature-container' },
                                        customerData && customerData.signAt ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', style: { color: 'green', float: 'right', fontSize: '1.5em', margin: '0.1em' } }) : null,
                                        _react2.default.createElement(
                                          _semanticUiReact.Grid,
                                          { style: { justifyContent: 'center', paddingTop: '0.5em', margin: '0' } },
                                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'pencil' }),
                                          _react2.default.createElement(
                                            _semanticUiReact.Header,
                                            { className: 'icSignStyle', as: 'h4' },
                                            t('E-Signature'),
                                            _this13.renderSignPadUnavailableTooltip()
                                          )
                                        ),
                                        _react2.default.createElement(
                                          _semanticUiReact.Grid,
                                          { style: { justifyContent: 'center', paddingTop: '0.8em', marginTop: '0' } },
                                          customerData && customerData.signAt ? _react2.default.createElement(
                                            'div',
                                            { style: { display: 'flex', marginTop: '0.2em' } },
                                            'Signed on\xA0',
                                            _react2.default.createElement(_Timestamp2.default, {
                                              timestamp: customerData.signAt
                                            }),
                                            '\xA0',
                                            _this13.hasPurchaserSignPadAccess(data.project.allowAgentManageBookingCustomer, data.statusID) && _react2.default.createElement(
                                              'button',
                                              { onClick: function onClick(e) {
                                                  return _this13.handleShowSign(e, customerData);
                                                }, className: 'a-button-blue', style: { marginLeft: '0.2em' } },
                                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'edit' })
                                            ),
                                            _this13.hasShareESignAccess() && _react2.default.createElement(
                                              'button',
                                              { disabled: _this13.state.loading, onClick: function onClick(e) {
                                                  return _this13.handleShowShareESign(e, customerData);
                                                }, className: 'a-button-blue', style: { marginLeft: '0.2em' } },
                                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'share square' })
                                            )
                                          ) : _react2.default.createElement(
                                            'div',
                                            { className: 'e-signature-actions' },
                                            _this13.hasPurchaserSignPadAccess(data.project.allowAgentManageBookingCustomer, data.statusID) ? _react2.default.createElement(
                                              _semanticUiReact.Label,
                                              {
                                                size: 'mini',
                                                as: 'a',
                                                color: 'blue',
                                                onClick: function onClick(e) {
                                                  return _this13.handleShowSign(e, customerData);
                                                }
                                              },
                                              t('Sign')
                                            ) : null,
                                            _this13.hasShareESignAccess() && _react2.default.createElement(
                                              _semanticUiReact.Label,
                                              {
                                                size: 'mini',
                                                as: 'a',
                                                color: 'blue',
                                                onClick: function onClick(e) {
                                                  return _this13.handleShowShareESign(e, customerData);
                                                },
                                                disabled: _this13.state.loading
                                              },
                                              t('Share')
                                            )
                                          )
                                        )
                                      )
                                    )
                                    // check if is IOS and conditional rendering ( E-Signature )
                                    )
                                  ),
                                  (showsIDSnapshot || showsESignature) && _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    { style: showsIDSnapshot || showsESignature ? null : { marginTop: '1.0em' } },
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      _extends({ textAlign: 'left', width: 8 }, _this13.getDataAttributes(idx, 'identitytype', _this13.getIdentityTypeText(customerData.customer.identityTypeID, customerData.customer.identityPresetID, customerData.customer.identityLabel))),
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        _this13.getIdentityTypeText(customerData.customer.identityTypeID, customerData.customer.identityPresetID, customerData.customer.identityPresetLabel)
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      _extends({}, _this13.getDataAttributes(idx, 'identity', customerData.customer.identity), { textAlign: 'right', width: 8 }),
                                      customerData.customer.identity
                                    )
                                  ),
                                  _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                                  isMalaysia && customerData.customer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && _react2.default.createElement(
                                    _react2.default.Fragment,
                                    null,
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid,
                                      null,
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { textAlign: 'left', width: 8 },
                                        _react2.default.createElement(
                                          'b',
                                          null,
                                          t('Foreign Company', { ns: _translation.TRANSLATION_FILES.screens })
                                        )
                                      ),
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        _extends({}, _this13.getDataAttributes(idx, 'isForeignCompany', customerData.customer.isForeignCompany), { textAlign: 'right', width: 8 }),
                                        t(customerData.customer.isForeignCompany ? 'Yes' : 'No')
                                      )
                                    ),
                                    _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } })
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    null,
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 6 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        isMalaysia && 'Tax Identification Number (TIN)',
                                        isIndonesia && 'Nomor Pokok Wajib Pajak (NPWP)'
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      _extends({ textAlign: 'right', width: 10 }, _this13.getDataAttributes(idx, 'taxIdentificationNo', customerData.customer.taxIdentificationNo)),
                                      _react2.default.createElement(
                                        'span',
                                        { style: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center' } },
                                        customerData && customerData.customer && customerData.customer.taxIdentificationNo ? isMalaysia ? _react2.default.createElement(
                                          'div',
                                          null,
                                          _react2.default.createElement(_semanticUiReact.Icon, {
                                            name: customerData.customer.taxTinValidationStatus === 'success' ? 'check circle' : 'remove circle',
                                            color: customerData.customer.taxTinValidationStatus === 'success' ? 'green' : 'red',
                                            style: { marginLeft: '0.5em' }
                                          }),
                                          customerData.customer.taxIdentificationNo
                                        ) : _react2.default.createElement(
                                          'div',
                                          null,
                                          customerData.customer.taxIdentificationNo
                                        ) : '-'
                                      )
                                    )
                                  ),
                                  customerData.clientID && _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                                  customerData.clientID && _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    null,
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 8 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        (0, _translation2.translateModels)(t, 'clientID', 'booking')
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'right', width: 8 },
                                      customerData.clientID
                                    )
                                  ),
                                  _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    null,
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 8 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        t(customerData.customer.identityTypeID === 4 ? 'Company Name' : 'Name')
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      _extends({ textAlign: 'right', width: 8, className: 'word_break_word' }, _this13.getDataAttributes(idx, 'title', customerData.title), _this13.getDataAttributes(idx, 'name', customerData.name)),
                                      _this13.toUppercaseFormat(customerData ? (customerData.title === 'Not Applicable' ? '' : t(customerData.title, { ns: _translation.TRANSLATION_FILES.constants })) + ' ' + customerData.name : '-')
                                    )
                                  ),
                                  _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    null,
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 8 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        t(customerData.customer.identityTypeID === 4 ? 'Contact Person' : 'Preferred Name')
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'right', width: 8, className: 'word_break_word' },
                                      _this13.toUppercaseFormat(customerData ? customerData.preferredName : '-')
                                    )
                                  ),
                                  _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    null,
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 8 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        (0, _translation2.translateModels)(t, 'email', 'booking')
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      _extends({ textAlign: 'right', width: 8, className: 'word_break_all' }, _this13.getDataAttributes(idx, 'email', customerData.email.toLowerCase())),
                                      customerData ? customerData.email.toLowerCase() : '-'
                                    )
                                  ),
                                  _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    null,
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 8 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        t('Mobile')
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      _extends({ textAlign: 'right', width: 8 }, _this13.getDataAttributes(idx, 'mobile', customerData.mobile && customerData.mobilePrefix ? '' + customerData.mobilePrefix + customerData.mobile : '')),
                                      customerData && customerData.mobile ? _react2.default.createElement(_Phone2.default, {
                                        mobilePrefix: customerData.mobilePrefix,
                                        mobile: customerData.mobile
                                      }) : ''
                                    )
                                  ),
                                  _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    null,
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 8 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        t('Phone')
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      _extends({ textAlign: 'right', width: 8 }, _this13.getDataAttributes(idx, 'phone', customerData.phone && customerData.phonePrefix ? '' + customerData.phonePrefix + customerData.phone : '')),
                                      customerData && customerData.phone ? _react2.default.createElement(_Phone2.default, {
                                        mobilePrefix: customerData.phonePrefix,
                                        mobile: customerData.phone
                                      }) : '-'
                                    )
                                  ),
                                  _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' }, className: 'large-hide small-hide' })
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { mobile: 16, tablet: 16, computer: 10 },
                                  _lodash2.default.flatMap(enabledAddressSettings.map(function (as, asixd) {
                                    var key = _lodash2.default.camelCase(as.columnName);
                                    var addressLabel = as.label.toLowerCase();
                                    if (!as.required && (!customerData || !(customerData && customerData[key]))) {
                                      return null;
                                    }

                                    var dattr = as.columnName.replace('_', 'line');
                                    var value = customerData[key];
                                    if (isMalaysia) {
                                      switch (as.columnName) {
                                        case 'address_5':
                                          addressLabel = 'postcode';
                                          dattr = 'postcode';
                                          break;
                                        case 'address_6':
                                          addressLabel = 'city';
                                          dattr = 'city';
                                          break;
                                        case 'address_7':
                                          addressLabel = 'state';
                                          dattr = 'state';
                                          value = _this13.valueToText(_states2.default, customerData[key], true).toString().toUpperCase();
                                          break;
                                        default:
                                          break;
                                      }
                                    }

                                    // for Skyworld Vietnam, we update the label name for state/city/postcode to province/ward/postalCode
                                    if (isVietnam && addressLabel === 'state') {
                                      addressLabel = 'cityOrProvince';
                                      dattr = 'province';
                                    } else if (isVietnam && addressLabel === 'city') {
                                      addressLabel = 'ward';
                                      dattr = 'ward';
                                    } else if (isVietnam && addressLabel === 'postcode') {
                                      addressLabel = 'postalCode';
                                      dattr = 'postalCode';
                                    }

                                    return _react2.default.createElement(
                                      _semanticUiReact.Grid,
                                      { key: asixd },
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { mobile: 8, tablet: 6, computer: 5, textAlign: 'left' },
                                        _react2.default.createElement(
                                          'b',
                                          null,
                                          (0, _translation2.translateModels)(t, addressLabel, 'booking')
                                        )
                                      ),
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        _extends({ textAlign: 'right', width: 11, className: 'word_break_word' }, _this13.getDataAttributes(idx, dattr, value)),
                                        _this13.toUppercaseFormat(customerData ? value : '-')
                                      )
                                    );
                                  }).filter(function (p) {
                                    return !!p;
                                  }), function (value, iidx) {
                                    return [value, _react2.default.createElement(_semanticUiReact.Divider, { key: 'divider_' + iidx, style: { margin: '0.5em 0' } })];
                                  }),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { mobile: 16, tablet: 8, computer: 8 },
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid,
                                      null,
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { textAlign: 'left', width: 8 },
                                        _react2.default.createElement(
                                          'b',
                                          null,
                                          (0, _translation2.translateModels)(t, 'country', 'booking')
                                        )
                                      ),
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        _extends({ textAlign: 'right', width: 8 }, _this13.getDataAttributes(idx, 'country', (0, _countries2.getCountryName)(customerData.country))),
                                        _this13.toUppercaseFormat((0, _countries2.getCountryName)(customerData ? customerData.country : null))
                                      )
                                    ),
                                    _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } })
                                  ),
                                  _this13.renderCitizenshipView(customerData, idx),
                                  _this13.renderRelationshipTypeView(customerData, idx),
                                  _this13.renderDefaultFields(false, customerData, idx)
                                )
                              ),
                              _this13.props.auth.creditCheckAccess ? _react2.default.createElement(
                                _semanticUiReact.Grid.Row,
                                { style: { paddingTop: '0' } },
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { mobile: 16 },
                                  _react2.default.createElement(_semanticUiReact.Divider, { style: { marginTop: '0' } }),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    null,
                                    _react2.default.createElement(_BookingCreditCheck2.default, {
                                      auth: _this13.props.auth,
                                      customerData: customerData,
                                      data: data
                                    })
                                  )
                                )
                              ) : null,
                              isPRS && data.paymentMethodID === 'government_loan' ? _react2.default.createElement(
                                _semanticUiReact.Grid.Row,
                                { style: { paddingTop: '0' } },
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { mobile: 16 },
                                  _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                                  _react2.default.createElement(_LPPSAChecker2.default, {
                                    bookingID: data.id,
                                    data: customerData.customer,
                                    token: _this13.props.token,
                                    type: 'booking',
                                    loading: _this13.state.loading,
                                    onChange: function onChange(lppsaData) {
                                      return _this13.handleOnChangeLPPSA(lppsaData, idx);
                                    }
                                  })
                                )
                              ) : ''
                            )
                          )
                        )
                      )
                    )
                  );
                }) : null,
                this.hasCustomerManageAccess(data.project.allowAgentManageBookingCustomer, data.statusID) && !this.state.customerAddArea && isEditingCustomer < 1 ? this.checkUnitIsSold(data) && !this.hasAccess() ? '' : _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { style: { marginTop: '2em' } },
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 16, textAlign: 'center' },
                        _react2.default.createElement(_semanticUiReact.Popup, {
                          trigger: _react2.default.createElement(
                            'div',
                            { style: { display: 'inline-block' } },
                            _react2.default.createElement(
                              _semanticUiReact.Button,
                              {
                                onClick: this.handleOpenCustomerAddArea,
                                size: 'large',
                                disabled: this.disableEditAfterSold(data)
                              },
                              t('Add Purchaser')
                            )
                          ),
                          disabled: !this.disableEditAfterSold(data),
                          content: t('Purchaser details are locked because the booking has been marked as Sold', { ns: _translation.TRANSLATION_FILES.translation })
                        })
                      )
                    )
                  )
                ) : ''
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            this.state.customerAddArea ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, className: 'customer add' },
              _react2.default.createElement(
                _semanticUiReact.Header,
                { className: 'new_title', as: 'h5', attached: 'top', textAlign: 'center' },
                t('Add Purchaser').toUpperCase(),
                ' ',
                data.bookingCustomers && data.bookingCustomers.length + 1
              ),
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { attached: true },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      null,
                      _react2.default.createElement(
                        _AppForm2.default,
                        {
                          error: this.state.errMessages.length > 0,
                          onSubmit: this.handleSubmit,
                          ref: function ref(_ref24) {
                            _this13.form = _ref24;
                          },
                          id: 'add_purchaser_form'
                        },
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Row,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { width: 16 },
                              _react2.default.createElement('br', null),
                              _react2.default.createElement(
                                _semanticUiReact.Grid,
                                null,
                                constructResponsiveIdentityTinInputs(),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Row,
                                  { centered: true },
                                  this.state.showNoAutofill && _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { width: 16 },
                                    _react2.default.createElement(
                                      _semanticUiReact.Segment,
                                      { secondary: true },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        isPRS ? this.state.fetchDataErrorMessage : isVietnam ? t('No existing details found') + '. ' + t('A new customer will be created in the CRM when you save') + '.' : t('No existing details found') + '.'
                                      )
                                    )
                                  ),
                                  !isPRS && this.state.autofillOptions && this.state.autofillOptions.length > 0 && _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { width: 16 },
                                    _react2.default.createElement(
                                      _semanticUiReact.Segment,
                                      { secondary: true },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        t('Customer details found'),
                                        '. \xA0'
                                      ),
                                      _react2.default.createElement('br', { className: 'large-hide small-hide' }),
                                      this.state.autofillOptions && this.state.autofillOptions.length > 0 && _react2.default.createElement(
                                        _semanticUiReact.Dropdown,
                                        {
                                          trigger: _react2.default.createElement(
                                            'button',
                                            {
                                              className: 'a-button-blue',
                                              onClick: function onClick(e) {
                                                return e.preventDefault();
                                              }
                                            },
                                            t('Autofill')
                                          ),
                                          options: this.state.autofillOptions
                                        },
                                        _react2.default.createElement(
                                          _semanticUiReact.Dropdown.Menu,
                                          null,
                                          _react2.default.createElement(_semanticUiReact.Dropdown.Header, { content: t('Autofill from') }),
                                          this.state.autofillOptions.map(function (item) {
                                            return _react2.default.createElement(_semanticUiReact.Dropdown.Item, item);
                                          })
                                        )
                                      )
                                    )
                                  )
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Row,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { width: 16 },
                                    _react2.default.createElement(
                                      _semanticUiReact.Form.Group,
                                      { widths: 'equal' },
                                      this.state.hideTitle ? null : _react2.default.createElement(
                                        _AppForm2.default.Validate,
                                        {
                                          validation: [_webValidations.required],
                                          ref: this.validation.title,
                                          onChange: this.handleCustomerAddSelectChange,
                                          validateLabel: (0, _translation2.translateModels)(t, 'title', 'booking')
                                        },
                                        _react2.default.createElement(_semanticUiReact.Form.Select, {
                                          label: (0, _translation2.translateModels)(t, 'title', 'booking') + '*',
                                          name: 'title',
                                          options: this.toUppercaseOptions(_customerTitles2.default).map(function (o) {
                                            return _extends({}, o, {
                                              text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants })
                                            });
                                          }),
                                          placeholder: t('Select {{title}}', { title: (0, _translation2.translateModels)(t, 'title', 'booking') }) + '*',
                                          search: true,
                                          selectOnBlur: false,
                                          noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }),
                                          value: this.state.customerAdd.title
                                        })
                                      ),
                                      _react2.default.createElement(_AppForm2.default.Input, {
                                        autoComplete: 'off',
                                        label: t(this.state.identityType === 4 ? 'Company Name' : 'Full Name') + '*',
                                        name: 'name',
                                        onChange: this.handleCustomerAddInputChange,
                                        placeholder: t(this.state.identityType === 4 ? 'Company Name' : 'Full Name') + '*',
                                        ref: this.validation.name,
                                        validation: [_webValidations.required].concat(_toConsumableArray((0, _vietnam.vnFullNameValidations)(auth, this.state.identityType, t))),
                                        value: this.state.customerAdd.name,
                                        validateLabel: t(this.state.identityType === 4 ? 'Company Name' : 'Full Name')
                                      }),
                                      _react2.default.createElement(_AppForm2.default.Input, {
                                        autoComplete: 'off',
                                        label: t(this.state.identityType === 4 ? 'Contact Person' : 'Preferred Name') + '*',
                                        name: 'preferredName',
                                        onChange: this.handleCustomerAddInputChange,
                                        placeholder: t(this.state.identityType === 4 ? 'Contact Person' : 'Preferred Name') + '*',
                                        ref: this.validation.preferredName,
                                        validation: this.state.identityType === 4 ? [_webValidations.required].concat(_toConsumableArray((0, _vietnam.vnPreferredNameValidations)(auth, t))) : [_webValidations.required, {
                                          validate: _webValidations.stringLength,
                                          option: {
                                            max: 15
                                          }
                                        }].concat(_toConsumableArray((0, _vietnam.vnPreferredNameValidations)(auth, t))),
                                        value: this.state.customerAdd.preferredName,
                                        validateLabel: t(this.state.identityType === 4 ? 'Contact Person' : 'Preferred Name')
                                      }),
                                      _react2.default.createElement(_AppForm2.default.Input, {
                                        autoComplete: 'off',
                                        label: '' + (0, _translation2.translateModels)(t, 'email', 'booking') + (this.checkIsEmailRequired() ? '*' : ''),
                                        name: 'email',
                                        type: 'email',
                                        onChange: this.handleCustomerAddInputChange,
                                        placeholder: (0, _translation2.translateModels)(t, 'email', 'booking'),
                                        validation: this.getEmailValidation(),
                                        validateLabel: (0, _translation2.translateModels)(t, 'email', 'booking'),
                                        ref: this.validation.email,
                                        value: this.state.customerAdd.email
                                      })
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Form.Group,
                                      { widths: 'equal' },
                                      _react2.default.createElement(
                                        _AppForm2.default.Validate,
                                        {
                                          validation: [_webValidations.required],
                                          ref: this.validation.mobilePrefix,
                                          onChange: this.handleCustomerAddSelectChange,
                                          validateLabel: (0, _translation2.translateModels)(t, 'mobilePrefix', 'booking')
                                        },
                                        _react2.default.createElement(_semanticUiReact.Form.Select, {
                                          label: (0, _translation2.translateModels)(t, 'mobilePrefix', 'booking') + '*',
                                          name: 'mobilePrefix',
                                          disabled: this.state.mobileLock,
                                          onChange: this.handleCustomerAddSelectChange,
                                          options: this.toUppercaseOptions(_intlCallCodes2.default),
                                          search: true,
                                          selectOnBlur: false,
                                          noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }),
                                          value: this.state.customerAdd.mobilePrefix
                                        })
                                      ),
                                      _react2.default.createElement(_PhoneInput2.default, {
                                        className: 'ui fluid\n                                            ' + this.state.customerAdd.mobilePrefix + '\n                                            ' + (this.state.searchingIDByMobile ? 'loading icon' : '') + '\n                                            ' + (this.hasResetMobileIcon(this.state.customerAdd.mobile) ? 'icon ' : '') + 'input\n                                          ',
                                        autoComplete: 'off',
                                        icon: this.getPhoneInputIcon(this.state.customerAdd.mobile),
                                        iconPosition: 'right',
                                        label: t('Mobile') + '*',
                                        name: 'mobile',
                                        onChange: this.handleCustomerAddInputChange,
                                        placeholder: 'e.g. 196756118',
                                        prefix: this.state.customerAdd.mobilePrefix,
                                        readOnly: this.state.mobileLock,
                                        ref: this.validation.mobile,
                                        type: 'tel',
                                        validation: [_webValidations.required, {
                                          validate: _webValidations.phoneNumber,
                                          option: this.state.customerAdd.mobilePrefix === 'other' ? {} : {
                                            isMobile: true,
                                            phonePrefix: this.state.customerAdd.mobilePrefix,
                                            validRegex: (0, _phone.getPhoneValidRegex)(this.state.phoneValidationPresets, this.state.customerAdd.mobilePrefix, 'mobile')
                                          }
                                        }],
                                        value: this.state.customerAdd.mobile,
                                        validateLabel: t('Mobile')
                                      }),
                                      _react2.default.createElement(_semanticUiReact.Form.Select, {
                                        label: t('House/Office Phone prefix'),
                                        name: 'phonePrefix',
                                        onChange: this.handleCustomerAddSelectChange,
                                        options: this.toUppercaseOptions(_intlCallCodes2.default),
                                        search: true,
                                        selectOnBlur: false,
                                        noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }),
                                        value: this.state.customerAdd.phonePrefix
                                      }),
                                      _react2.default.createElement(_PhoneInput2.default, {
                                        autoComplete: 'off',
                                        label: t('House/Office Phone'),
                                        name: 'phone',
                                        onChange: this.handleCustomerAddInputChange,
                                        placeholder: 'e.g. 378317749',
                                        prefix: this.state.customerAdd.phonePrefix,
                                        ref: this.validation.phone,
                                        type: 'tel',
                                        value: this.state.customerAdd.phone,
                                        validation: [{
                                          validate: _webValidations.phoneNumber,
                                          option: this.state.customerAdd.phonePrefix === 'other' ? {} : {
                                            phonePrefix: this.state.customerAdd.phonePrefix,
                                            validRegex: (0, _phone.getPhoneValidRegex)(this.state.phoneValidationPresets, this.state.customerAdd.phonePrefix, 'phone')
                                          }
                                        }],
                                        validateLabel: t('House/Office Phone')
                                      })
                                    ),
                                    this.renderCitizenshipInputs('customerAdd'),

                                    // https://stackoverflow.com/questions/49491452/map-an-array-by-every-two-elements
                                    _lodash2.default.chunk(enabledAddressSettings.map(function (as, iidx) {
                                      var key = _lodash2.default.camelCase(as.columnName);
                                      var addressLabel = as.label.toLowerCase();
                                      var isRequired = as.required;
                                      var errMessage = null;
                                      var validations = [{
                                        validate: _webValidations.stringLength,
                                        option: {
                                          max: 256
                                        }
                                      }];

                                      // Determine behavior based on selected country in the form
                                      var selectedCountry = (_this13.state.customerAdd.country || '').toUpperCase();
                                      var isSelectedCountryMalaysia = selectedCountry === 'MY';

                                      // When company is Vietnam: apply country-dependent logic for state field
                                      if (isVietnam && addressLabel === 'state') {
                                        if (isSelectedCountryMalaysia) {
                                          // Malaysia selected: keep as "State", required
                                          isRequired = true;
                                        } else {
                                          // Non-Malaysia selected: change to "City/Province", optional
                                          addressLabel = 'cityOrProvince';
                                          isRequired = false;
                                        }
                                      } else if (isVietnam && addressLabel === 'city' && !isSelectedCountryMalaysia) {
                                        addressLabel = 'ward';
                                        isRequired = false;
                                      } else if (isVietnam && addressLabel === 'postcode' && !isSelectedCountryMalaysia) {
                                        addressLabel = 'postalCode';
                                        isRequired = false;
                                      }

                                      if (isRequired) {
                                        validations.push(_webValidations.required);
                                      }
                                      if (!himsIsEnabled && isSelectedCountryMalaysia && as.label.toLowerCase() === 'postcode') {
                                        validations.push({
                                          validate: _webValidations.matchRegex,
                                          option: {
                                            validRegex: _regex.REGEX_POSTCODE_MY
                                          }
                                        });
                                        errMessage = 'Invalid MY postcode format';
                                      }

                                      var label = '' + (0, _translation2.translateModels)(t, addressLabel, 'booking') + (isRequired ? '*' : '');

                                      if (!isPRS && isSelectedCountryMalaysia && as.label.toLowerCase() === 'state') {
                                        return _react2.default.createElement(
                                          _AppForm2.default.Validate,
                                          {
                                            key: iidx,
                                            validation: isRequired ? [_webValidations.required] : null,
                                            ref: _this13.validation[key],
                                            onChange: _this13.handleCustomerAddSelectChange,
                                            validateLabel: as.label.toLowerCase() === 'state' ? (0, _translation2.translateModels)(t, 'state', 'booking') : as.label
                                          },
                                          _react2.default.createElement(_semanticUiReact.Form.Select, {
                                            name: key,
                                            fluid: true,
                                            options: _this13.toUppercaseOptions(_states2.default),
                                            placeholder: t('Select {{title}}', { title: label.toLowerCase() }),
                                            label: label,
                                            search: true,
                                            selectOnBlur: false,
                                            noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }),
                                            value: _this13.state.customerAdd[key]
                                          })
                                        );
                                      }

                                      if (himsIsEnabled && isSelectedCountryMalaysia && as.label.toLowerCase() === 'postcode') {
                                        return _react2.default.createElement(_SearchHimsPostcodes2.default, {
                                          key: iidx,
                                          validateRef: _this13.validation.himsKodPoskod,
                                          name: 'himsKodPoskod',
                                          onSelect: _this13.handleCustomerAddSelectHimsPostcode,
                                          state: _this13.state.customerAdd.address7,
                                          value: _this13.state.customerAdd.himsKodPoskod
                                        });
                                      }

                                      return _react2.default.createElement(_AppForm2.default.Input, {
                                        key: iidx,
                                        autoComplete: 'off',
                                        name: key,
                                        onChange: _this13.handleCustomerAddInputChange,
                                        placeholder: label,
                                        label: label,
                                        ref: _this13.validation[key],
                                        validation: validations,
                                        value: _this13.state.customerAdd[key],
                                        validateLabel: addressLabel,
                                        message: errMessage
                                      });
                                    }).concat([_react2.default.createElement(
                                      _AppForm2.default.Validate,
                                      {
                                        validation: [_webValidations.required],
                                        ref: this.validation.country,
                                        onChange: function onChange(e, stateData) {
                                          // Reset state input field
                                          if (!isPRS) {
                                            var as = enabledAddressSettings.find(function (a) {
                                              return a.label.toLowerCase() === 'state';
                                            });
                                            if (as) {
                                              var key = _lodash2.default.camelCase(as.columnName);
                                              var customerAdd = _this13.state.customerAdd;

                                              if (customerAdd[key]) {
                                                customerAdd[key] = '';
                                                _this13.setState({ customerAdd: customerAdd });
                                              }
                                            }
                                          }
                                          _this13.handleCustomerAddSelectChange(e, stateData);
                                        },
                                        validateLabel: (0, _translation2.translateModels)(t, 'country', 'booking')
                                      },
                                      _react2.default.createElement(_semanticUiReact.Form.Select, {
                                        autoComplete: 'off',
                                        fluid: true,
                                        label: (0, _translation2.translateModels)(t, 'country', 'booking') + '*',
                                        name: 'country',
                                        options: this.toUppercaseOptions(_countries.SELECT_COUNTRIES),
                                        placeholder: t('Select {{title}}', { title: (0, _translation2.translateModels)(t, 'country', 'booking') }) + '*',
                                        search: true,
                                        noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }),
                                        selectOnBlur: false,
                                        value: this.state.customerAdd.country
                                      })
                                    )]), 2).map(function (p, iidx) {
                                      return _react2.default.createElement(
                                        _semanticUiReact.Form.Group,
                                        { widths: 'equal', key: 'new_group_' + iidx },
                                        p
                                      );
                                    }),
                                    himsIsEnabled && isNewMalaysia ? _react2.default.createElement(
                                      _semanticUiReact.Form.Group,
                                      { widths: 'equal' },
                                      _react2.default.createElement(_SearchHimsDistricts2.default, {
                                        validateRef: this.validation.himsKodDaerah,
                                        name: 'himsKodDaerah',
                                        onSelect: this.handleCustomerAddSelectHimsDistrict,
                                        state: this.state.customerAdd.address7,
                                        value: this.state.customerAdd.himsKodDaerah
                                      }),
                                      _react2.default.createElement('span', { style: { flex: '1 1 auto', width: '100%' } })
                                    ) : null,
                                    !isPRS && _react2.default.createElement(
                                      'div',
                                      { style: { textAlign: 'center' } },
                                      _react2.default.createElement(
                                        'button',
                                        {
                                          className: 'a-button-blue',
                                          onClick: this.handleCopyAddressFromPrimaryPurchaser
                                        },
                                        t('Copy Address from Primary Purchaser')
                                      )
                                    ),
                                    _react2.default.createElement('br', null),
                                    this.renderDefaultFields(true, this.state.customerAdd, 0, true)
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid,
                        null,
                        showsIDSnapshot && _react2.default.createElement(
                          _semanticUiReact.Grid.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { mobile: 16, tablet: addShape.sides === 2 ? 8 : 16, computer: addShape.sides === 2 ? 8 : 16, textAlign: 'center' },
                            _react2.default.createElement(_UploadForm2.default, _extends({
                              isCompress: true,
                              title: 'Front',
                              ref: function ref(_ref25) {
                                _this13.icFrontUploadAddCustomer = _ref25;
                              },
                              setLoading: this.setLoading,
                              loading: this.state.loading,
                              sampleURL: addShape.sample ? '/assets/images/samples/ic_front.svg' : '',
                              tags: ['IC Front'],
                              picture: this.state.customerAdd.customer && this.state.customerAdd.customer.icFrontDocumentID && this.state.customerAdd.customer.icFrontDocumentID.length > 0 ? this.state.customerAdd.customer.icFrontDocument : null
                            }, this.identityAcceptProps(), {
                              onChange: function onChange(ic) {
                                return _this13.handleGetIC(ic, 'FrontAddCustomer', 'addCustomerICChanges');
                              }
                            }))
                          ),
                          addShape.sides === 2 && _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { width: 16, tablet: 8, computer: 8, textAlign: 'center' },
                            _react2.default.createElement(_UploadForm2.default, _extends({
                              isCompress: true,
                              title: 'Back',
                              ref: function ref(_ref26) {
                                _this13.icBackUploadAddCustomer = _ref26;
                              },
                              setLoading: this.setLoading,
                              loading: this.state.loading,
                              sampleURL: addShape.sample ? '/assets/images/samples/ic_back.svg' : '',
                              tags: ['IC Back'],
                              picture: this.state.customerAdd.customer && this.state.customerAdd.customer.icBackDocumentID && this.state.customerAdd.customer.icBackDocumentID.length > 0 ? this.state.customerAdd.customer.icBackDocument : null
                            }, this.identityAcceptProps(), {
                              onChange: function onChange(ic) {
                                return _this13.handleGetIC(ic, 'BackAddCustomer', 'addCustomerICChanges');
                              }
                            }))
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { width: 16, textAlign: 'center' },
                            _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleCloseCustomerAddArea, content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }) }),
                            _react2.default.createElement(_semanticUiReact.Button, {
                              disabled: this.state.loading || this.state.validatingTin,
                              loading: this.state.loading,
                              primary: true,
                              content: t('Add Purchaser'),
                              onClick: function onClick(e) {
                                return _this13.form.handleSubmit(e);
                              }
                            }),
                            _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5rem' }, hidden: true })
                          )
                        )
                      )
                    )
                  )
                )
              )
            ) : ''
          )
        )
      );
    }
  }]);

  return Purchaser;
}(_react.Component);

Purchaser.contextTypes = {
  store: _propTypes2.default.object
};
Purchaser.propTypes = {
  token: _propTypes2.default.string,
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isBranchLeaderSupervisor: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    creditCheckAccess: _propTypes2.default.bool,
    allowEditUnitPrice: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  onCheck: _propTypes2.default.func,
  checkHasChanges: _propTypes2.default.func,
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      leadV2IsEnabled: _propTypes2.default.bool,
      himsIsEnabled: _propTypes2.default.bool,
      settings: _propTypes2.default.shape({
        uppercasePurchaserInfoIsEnabled: _propTypes2.default.bool
      })
    })
  }),
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  fetchNewBooking: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  addressSettings: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  customOptions: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  combinedPrintTmplOnly: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  location: _propTypes2.default.shape({
    search: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};

Purchaser.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig,
    addressSettings: state.addressSettings,
    identityPresets: state.identityPresets,
    phoneValidationPresets: state.phoneValidationPresets,
    customOptions: state.customOptions
  };
};

Purchaser.defaultCustomerModal = {
  isOpen: false,
  header: '',
  headerIcon: 'warning sign',
  message: '',
  customerID: '',
  bookingCustomerID: '',
  bookingID: '',
  customerName: '',
  type: ''
};

Purchaser.getPropsToState = function (props) {
  var loading = props.loading;
  var data = Object.assign({}, _booking2.default, props.data);
  var projectBookingCustomFields = props.projectBookingCustomFields || [];
  data.isCancelPending = true;
  if (!data.bankCases) {
    data.bankCases = [];
  }
  var errMessages = [];
  var tinMessage = null;
  var modal = Object.assign({}, Purchaser.defaultCustomerModal);
  var searchingID = false;
  var searchingIDByMobile = false;
  var autofillOptions = [];
  var existingCustomer = {};
  var externalCustomer = {};
  var leadCustomer = {};
  var identityError = false;
  var tinErrorAdd = null;
  var tinErrorEdit = null;
  var windowWidth = window.innerWidth;
  var widthIsLessThan1200 = windowWidth < 1200;
  var isCRMEnabled = props.appConfig && props.appConfig.data && props.appConfig.data.leadV2IsEnabled;

  var identityPresets = props.identityPresets.data;
  var identityTypeOpts = (0, _identityTypes.getIdentityTypeOpts)(props.auth, identityPresets);
  var phoneValidationPresets = props.phoneValidationPresets.data;

  var hideTitle = false;
  var customOptions = props.customOptions.data;
  if (customOptions.length > 0) {
    var hideTitleOpt = customOptions.find(function (o) {
      return o.name === 'hide_purchaser_title';
    });
    if (hideTitleOpt) {
      hideTitle = hideTitleOpt.value === 'true';
    }
  }

  return {
    data: data,
    oriData: (0, _clone2.default)(data),
    loading: loading,
    errMessages: errMessages,
    tinMessage: tinMessage,
    modal: modal,
    searchingID: searchingID,
    searchingIDByMobile: searchingIDByMobile,
    autofillOptions: autofillOptions,
    existingCustomer: existingCustomer,
    externalCustomer: externalCustomer,
    leadCustomer: leadCustomer,
    identityError: identityError,
    tinErrorAdd: tinErrorAdd,
    tinErrorEdit: tinErrorEdit,
    widthIsLessThan1200: widthIsLessThan1200,
    identityPresets: identityPresets,
    identityTypeOpts: identityTypeOpts,
    phoneValidationPresets: phoneValidationPresets,
    projectBookingCustomFields: projectBookingCustomFields,
    isCRMEnabled: isCRMEnabled,
    hideTitle: hideTitle
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this14 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var loadingType = arguments[1];
    return new Promise(function (res) {
      if (loadingType === 'validatingTIN') {
        _this14.setState({ validatingTin: loading }, res);
      } else {
        _this14.setState({ loading: loading }, res);
      }
    });
  };

  this.getMPBucketName = function () {
    var _props$data2 = _this14.props.data,
        data = _props$data2 === undefined ? {} : _props$data2;

    var bucketName = _config2.default.get('mpBucket');
    return data.origin.includes('marketplace') ? bucketName : null;
  };

  this.getIdentityPlaceholder = function (isIndonesia) {
    var _state6 = _this14.state,
        identityType = _state6.identityType,
        identityPresetLabel = _state6.identityPresetLabel;
    var t = _this14.props.t;

    if (identityType === '') {
      return t('Select Identity Type first');
    }
    if (typeof identityType === 'string') {
      var identityTypeOpts = _this14.state.identityTypeOpts;

      var idx = identityTypeOpts.findIndex(function (i) {
        return i.value === identityType;
      });
      if (idx !== -1) {
        return t('{{identity}} number', { identity: identityTypeOpts[idx].text });
      }
    }
    switch (identityType) {
      case 2:
        return t('Passport Number');
      case 4:
        return isIndonesia ? 'e.g. 1234567890123' : 'e.g. 202401012345';
      case 6:
        return t('{{identity}} number', { identity: identityPresetLabel });
      default:
        return t('Identity Number');
    }
  };

  this.getIdentityInputLabel = function (isHidden) {
    switch (_this14.state.identityType) {
      case 4:
        return isHidden ? null : 'Enter 12-digit Company Registration Number';
      default:
        return null;
    }
  };

  this.getIdentityTypeText = function (identityTypeID, presetID, presetLabel) {
    var identityPresets = _this14.state.identityPresets;
    var _props6 = _this14.props,
        auth = _props6.auth,
        t = _props6.t;

    var isVietnam = auth && auth.company && auth.company.countryCode.toUpperCase() === 'VN';
    if (identityTypeID > 4 || typeof identityTypeID === 'string') {
      if (identityPresets && identityPresets.length > 0) {
        var idx = identityPresets.findIndex(function (i) {
          return i.id === presetID;
        });
        if (idx !== -1) {
          return identityPresets[idx].label;
        } else if (presetLabel) {
          return presetLabel;
        }
      }
      return t('ID Number');
    }
    switch (identityTypeID) {
      case 1:
        return isVietnam ? 'CCCD' : 'MyKad (NRIC)';
      case 2:
        return t('Passport Number');
      case 3:
        return t('Military / Police');
      case 4:
        return isVietnam ? t('Enterprise Registration Certificate') : t('Company Registration Number');
      default:
        return '';
    }
  };

  this.idDocumentShape = function (identityTypeID) {
    var _props7 = _this14.props,
        auth = _props7.auth,
        t = _props7.t;

    if (!(0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode)) {
      return { label: t('NRIC'), sides: 2, sample: true };
    }
    return {
      label: _this14.getIdentityTypeText(identityTypeID) || t('ID'),
      sides: (0, _vietnam.idDocumentSides)(identityTypeID, true),
      sample: false
    };
  };

  this.getPrimaryBookingCustomer = function (data) {
    if (data.bookingCustomers && data.bookingCustomers.length > 0) {
      var primaryCustomer = data.bookingCustomers.find(function (f) {
        return f.customerID === data.customerID;
      });
      if (primaryCustomer) {
        return primaryCustomer;
      }
    }
    return {};
  };

  this.getRace = function (race) {
    if (race) {
      var preset = _race.RACE.find(function (d) {
        return d.value.toLowerCase() === race.toLowerCase();
      });
      if (!preset) {
        return 'Others';
      }
      return preset.value;
    }
    return '';
  };

  this.getBirthDate = function (birthDate, nric) {
    if (nric !== '' && nric.length === 12) {
      var dfIC = (0, _dateFromIC2.default)(nric.substring(0, 6));
      if (dfIC) {
        var mBirthdate = _momentTimezone2.default.tz(dfIC, _config2.default.get('tzName'));
        if (mBirthdate.isValid()) {
          return mBirthdate.format('YYYY-MM-DD').toString();
        }
      }
    }
    var date = new Date(birthDate);
    if (date !== 'Invalid Date' && !isNaN(date)) {
      return birthDate;
    }
    return '';
  };

  this.getMinimumPurchaserAgeMessage = function () {
    return _this14.props.t('Booking cannot be created. Purchaser must be at least 18 years old.');
  };

  this.isUnderagePurchaser = function (birthdate) {
    if (!birthdate || birthdate === '') return false;

    var mBirthdate = (0, _momentTimezone2.default)(birthdate, 'YYYY-MM-DD', true).tz(_config2.default.get('tzName'), true);
    if (!mBirthdate.isValid()) return false;

    var age = _momentTimezone2.default.tz(_config2.default.get('tzName')).diff(mBirthdate, 'years');
    return age < 18;
  };

  this.isUnderageNRICPurchaser = function (identityTypeID, identity) {
    if (identityTypeID !== _defaultIdentityTypeOpts.IDENTITY_TYPE_NRIC) return false;

    var dfIC = (0, _dateFromIC2.default)((identity || '').substring(0, 6));
    if (!dfIC) return false;

    var mBirthdate = _momentTimezone2.default.tz(dfIC, _config2.default.get('tzName'));
    if (!mBirthdate.isValid()) return false;

    return _momentTimezone2.default.tz(_config2.default.get('tzName')).diff(mBirthdate, 'years') < 18;
  };

  this.getMaritalStatus = function (maritalStatus) {
    if (maritalStatus) {
      var preset = _maritalStatus.MARITAL_STATUS.find(function (d) {
        return d.value.toLowerCase() === maritalStatus.toLowerCase();
      });
      if (preset) {
        return preset.value;
      }
    }
    return '';
  };

  this.getAutofillIdentityTypeName = function (typeID) {
    if (!(0, _isNumber.isNumeric)(typeID)) return _autofillTypes.AUTOFILL_PRESET;
    if (typeID > 0 && typeID <= 6) {
      var idx = _autofillTypes.AUTOFILL_IDENTITY_TYPES.findIndex(function (a) {
        return a.id === typeID;
      });
      if (idx > -1) return _autofillTypes.AUTOFILL_IDENTITY_TYPES[idx].name;
    }
    return _autofillTypes.AUTOFILL_NRIC;
  };

  this.getAutofillIdentityTypeID = function (typeName) {
    if (typeName !== '') {
      var idx = _autofillTypes.AUTOFILL_IDENTITY_TYPES.findIndex(function (a) {
        return a.name === typeName;
      });
      if (idx > -1) return _autofillTypes.AUTOFILL_IDENTITY_TYPES[idx].id;
    }
    return 1;
  };

  this.getPhoneInputIcon = function (mobile) {
    var t = _this14.props.t;

    if (_this14.state.searchingIDByMobile) {
      return _react2.default.createElement(_semanticUiReact.Icon, { loading: true, name: 'spinner' });
    }
    if (_this14.hasResetMobileIcon(mobile)) {
      return _react2.default.createElement(_semanticUiReact.Icon, {
        link: true,
        name: 'x',
        onClick: _this14.handleResetAutofill,
        title: t('Clear Form')
      });
    }
    return null;
  };

  this.getEmailValidation = function () {
    var emailValidation = [_webValidations.email];
    if (_this14.checkIsEmailRequired()) {
      emailValidation.push(_webValidations.required);
    }
    return emailValidation;
  };

  this.getDataAttributes = function (purchaserIdx, daname, davalue) {
    var _ref27;

    var newDavalue = davalue;
    if (newDavalue === '') newDavalue = 'NULL';
    if (newDavalue === 'Not Applicable') newDavalue = 'N/A';
    var purchaserDatasetName = 'data-bot-purchaser' + (purchaserIdx + 1) + daname;
    return _ref27 = {}, _defineProperty(_ref27, purchaserDatasetName, newDavalue), _defineProperty(_ref27, 'data-bot-target', 'purchasers'), _ref27;
  };

  this.checkIOS = function () {
    if (['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) || navigator.userAgent.includes('Mac')) {
      _this14.setState({
        isIOS: true
      });
    } else {
      _this14.setState({
        isIOS: false
      });
    }
  };

  this.renderSignPadUnavailableTooltip = function () {
    var _props8 = _this14.props,
        t = _props8.t,
        auth = _props8.auth;

    if (!(0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode)) return null;
    return _react2.default.createElement(_semanticUiReact.Popup, {
      content: t('Sign on paper and upload it in the Documents tab', { ns: _translation.TRANSLATION_FILES.translation }),
      position: 'top center',
      trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', style: { cursor: 'help', marginLeft: '0.35em' } })
    });
  };

  this.handleOnCheck = function (callback) {
    if (_this14.props.onCheck) {
      var hasChanges = _this14.state.customerChanges || _this14.state.customerAddChanges || _this14.state.customerICChanges || _this14.state.addCustomerICChanges;
      _this14.props.onCheck(hasChanges, callback);
    }
  };

  this.handleCheckChanges = function (value, callback) {
    var state = _this14.state;
    if (state[value] === false) {
      state[value] = true;
      _this14.setState(_defineProperty({}, value, state[value]), function () {
        _this14.handleOnCheck(callback);
      });
    }
  };

  this.handleResetCheck = function (value, callback) {
    var state = _this14.state;
    if (state[value] === true) {
      state[value] = false;
      _this14.setState(_defineProperty({}, value, state[value]), function () {
        _this14.handleOnCheck(callback);
      });
    }
  };

  this.handleResize = function () {
    var state = {};
    var windowWidth = window.innerWidth;
    var widthIsLessThan1200 = windowWidth < 1200;
    if (widthIsLessThan1200 !== _this14.state.widthIsLessThan1200) {
      state.widthIsLessThan1200 = widthIsLessThan1200;
    }
    var keys = Object.keys(state);
    if (keys.length > 0) {
      _this14.setState(_extends({}, state));
    }
    _this14.setState({ screenWidth: window.innerWidth });
  };

  this.handleGetIC = function (ic) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Front';
    var changes = arguments[2];

    // UploadForm.resetFiles emits its empty upload object through onChange. Store it as null so a
    // reset cannot be mistaken for an add-purchaser document or mark that form as changed. Keep
    // the established edit-purchaser behavior for MY/ID controls.
    var isAddCustomerDocument = direction === 'FrontAddCustomer' || direction === 'BackAddCustomer';
    var upload = isAddCustomerDocument && (!ic || !ic.file) ? null : ic;
    _this14.setState(_defineProperty({}, 'ic' + direction, upload), function () {
      if (!isAddCustomerDocument || upload) _this14.handleCheckChanges(changes);
    });
  };

  this.resetCustomerAddDocumentState = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
    return regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.next = 2;
            return _this14.setComponentState({
              icFrontAddCustomer: null,
              icBackAddCustomer: null
            });

          case 2:
            if (_this14.icFrontUploadAddCustomer) _this14.icFrontUploadAddCustomer.resetFiles();
            if (_this14.icBackUploadAddCustomer) _this14.icBackUploadAddCustomer.resetFiles();

          case 4:
          case 'end':
            return _context18.stop();
        }
      }
    }, _callee18, _this14);
  }));

  this.handleCreateFormData = function () {
    var addCustomer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var formData = new FormData();
    var _state7 = _this14.state,
        icFront = _state7.icFront,
        icBack = _state7.icBack,
        icFrontAddCustomer = _state7.icFrontAddCustomer,
        icBackAddCustomer = _state7.icBackAddCustomer,
        editingCustomer = _state7.editingCustomer;
    var auth = _this14.props.auth;

    var isVietnam = (0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode);
    var identityTypeID = addCustomer ? _this14.state.identityType : editingCustomer.customer && editingCustomer.customer.identityTypeID || editingCustomer.identityTypeID;
    // A one-image document has no back. The back control unmounts when the agent switches from
    // CCCD to a passport, but a file picked before the switch is still in state; it must not be
    // sent as "IC Back" against a passport.
    var uploads = (0, _vietnam.idDocumentUploads)(addCustomer ? icFrontAddCustomer : icFront, addCustomer ? icBackAddCustomer : icBack, (0, _vietnam.idDocumentSides)(identityTypeID, isVietnam));
    uploads.forEach(function (_ref29) {
      var index = _ref29.index,
          upload = _ref29.upload;

      formData.append('files_' + index, upload.file);
      formData.append('tags_' + index, upload.tags);
      formData.append('names_' + index, upload.name);
      formData.append('degrees_' + index, upload.degree);
      formData.append('mark_' + index, true);
    });
    return formData;
  };

  this.handleUpdatePrimaryCustomer = function (newCustomerID, newBookingCustomerID) {
    var booking = {
      customerID: newCustomerID,
      bookingcustomerID: newBookingCustomerID
    };
    _this14.updateBooking(booking, 'primary');
  };

  this.handleShowSign = function (e, data) {
    e.preventDefault();
    var auth = _this14.props.auth;

    if ((0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode)) return;
    var editingCustomer = Object.assign({}, _this14.state.bookingCustomerDefaultData, data);
    _this14.setState({ showSignModal: true, showShareESignModal: false, editingCustomer: editingCustomer });
  };

  this.handleProceedShareESign = function (e, data) {
    e.preventDefault();
    _this14.fetchGenerateESignToken(data);
  };

  this.handleRenewESign = function (e) {
    _this14.setState({ shareESignData: null, isRenew: true }, function () {
      _this14.handleShowShareESign(e, _this14.state.editingCustomer);
    });
  };

  this.handleShowShareESign = function (e, customer) {
    e.persist();
    if (!_this14.hasShareESignAccess()) return;
    var _state8 = _this14.state,
        data = _state8.data,
        isRenew = _state8.isRenew;

    var editingCustomer = Object.assign({}, _this14.state.bookingCustomerDefaultData, customer);
    var hasFormStep = data.project && data.project.shareESignAllowPreviewForm;
    _this14.setState({ showShareESignModal: true, editingCustomer: editingCustomer }, function () {
      if (!isRenew && hasFormStep) {
        // hide form dropdown if token exists
        _this14.fetchExistingESignToken();
      }
      if (!hasFormStep) {
        _this14.fetchGenerateESignToken({
          printTemplateIDs: [],
          docxTemplateIDs: [],
          allowSendFormsEmail: false
        });
      }
    });
  };

  this.handleSendESignToken = function (e, type) {
    e.preventDefault();
    _this14.sendESignToken(type);
  };

  this.handleOnCloseShareESign = function (e) {
    e.preventDefault();
    _this14.setState({ showShareESignModal: false, shareESignData: null, isRenew: false });
  };

  this.handleOnCancel = function (e) {
    e.preventDefault();
    _this14.signatureModal.handleOnCancel();
    _this14.setState({
      editingCustomer: Object.assign({}, _this14.state.bookingCustomerDefaultData),
      showSignModal: false
    });
  };

  this.handleOpenModal = function (customerName, customerID, bookingCustomerID, bookingID, headerIcon, header, message, type) {
    var modal = Object.assign({}, _this14.state.modal);
    modal.customerID = customerID;
    modal.bookingCustomerID = bookingCustomerID;
    modal.bookingID = bookingID;
    modal.isOpen = true;
    modal.header = header;
    modal.message = message;
    modal.headerIcon = headerIcon;
    modal.customerName = customerName;
    modal.type = type;
    _this14.setState({ modal: modal });
  };

  this.handleCloseModal = function () {
    var modal = Purchaser.defaultCustomerModal;
    modal.isOpen = false;
    _this14.setState({ modal: modal });
  };

  this.handleConfirm = function () {
    var modal = Object.assign({}, _this14.state.modal);
    modal.isOpen = false;
    _this14.setState({ modal: modal }, function () {
      if (modal.type === 'remove') {
        _this14.removeCustomer(modal.customerID, modal.bookingID);
      } else if (modal.type === 'primary') {
        _this14.handleUpdatePrimaryCustomer(modal.customerID, modal.bookingCustomerID);
      }
    });
  };

  this.handleIdentityChange = function (e) {
    var identity = _this14.toUppercaseFormat(e.target.value);
    var searchingID = _this14.state.searchingID;
    var _state9 = _this14.state,
        customerAdd = _state9.customerAdd,
        identityType = _state9.identityType,
        identityPresetID = _state9.identityPresetID;

    if (identityType === 1 && identity.length === 12) {
      var dfIC = (0, _dateFromIC2.default)(identity.substring(0, 6));
      if (dfIC) {
        var mBirthdate = _momentTimezone2.default.tz(dfIC, _config2.default.get('tzName'));
        if (mBirthdate.isValid()) {
          customerAdd.birthdate = mBirthdate.format('YYYY-MM-DD').toString();
        }
      }
    }
    if ((0, _isNumber.isNumeric)(identity) || identity === '') {
      if (identity.length !== 12) {
        customerAdd.customerDetailID = null;
        customerAdd.customerID = null;
      } else if (_this14.state.identityType === 1 && identity.length === 12) {
        if (!isPRS || isPRS && _this14.state.prsID && _this14.state.prsID.length === 13) {
          searchingID = true;
        }
      }
    }
    _this14.setState({ identity: identity, customerAdd: customerAdd, autofillOptions: [], searchingID: searchingID }, function () {
      if (_this14.state.identityType === 1 && identity.length === 12 && _this14.state.searchingID) {
        if (_this14.identityInputRef.current) {
          _this14.identityInputRef.current.blur();
        }
        _this14.searchAutofillCustomer(identity, _this14.getAutofillIdentityTypeName(_this14.state.identityType));
      }
      if (_this14.state.identityType !== 1 && identity.length > 0) {
        clearTimeout(_this14.setTimer);
        _this14.setTimer = setTimeout(function () {
          if (_this14.state.identityLock && _this14.state.autofillOptions && _this14.state.autofillOptions.length > 0) {
            _this14.setState({ identity: customerAdd.identity });
          } else {
            _this14.searchAutofillCustomer(identity, _this14.getAutofillIdentityTypeName(_this14.state.identityType), identityPresetID);
          }
        }, 1000);
      }
      _this14.handleCheckChanges('customerAddChanges');
    });
  };

  this.handlePRSIDChange = function (e) {
    var customerAdd = _this14.state.customerAdd;

    var value = e.target.value;
    customerAdd.prsID = value;
    if (value.length > 13) return;
    _this14.setState({ prsID: value, customerAdd: customerAdd }, function () {
      _this14.handleCheckChanges();
      if (value.length === 13 && _this14.state.identity.length === 12) {
        _this14.searchAutofillCustomer(_this14.state.identity, _autofillTypes.AUTOFILL_PRS);
      }
    });
  };

  this.handleIDTypeChange = function (e, _ref30) {
    var value = _ref30.value;
    var auth = _this14.props.auth;

    var isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    var identity = _this14.state.identity;
    var _state10 = _this14.state,
        customerAdd = _state10.customerAdd,
        identityPresets = _state10.identityPresets;
    // Switching from CCCD to a one-image type unmounts the back upload but leaves its file in
    // state. Clear it here as well, so the control and the state agree.

    if ((0, _vietnam.idDocumentSides)(value, (0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode)) === 1 && _this14.state.icBackAddCustomer) {
      _this14.setState({ icBackAddCustomer: null });
      if (_this14.icBackUploadAddCustomer) _this14.icBackUploadAddCustomer.resetFiles();
    }
    if (value === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN) {
      customerAdd.title = 'Not Applicable';
      customerAdd.nationality = 'Not Applicable';
      customerAdd.gender = 'Not Applicable';
      customerAdd.race = 'Not Applicable';
      customerAdd.bumi = 'Not Applicable';
      customerAdd.maritalStatus = 'Not Applicable';
      customerAdd.birthdate = '';
    }
    if (_this14.state.identity.length === 0) {
      customerAdd.customerDetailID = null;
      customerAdd.customerID = null;
    }
    var newPresetID = '';
    var newPresetLabel = '';
    var newPresetRegex = '';
    if (value === 6 || !(0, _isNumber.isNumeric)(value)) {
      if (identityPresets && identityPresets.length > 0) {
        var idx = identityPresets.findIndex(function (i) {
          return i.id === value;
        });
        if (idx !== -1) {
          newPresetID = identityPresets[idx].id;
          newPresetLabel = identityPresets[idx].label;
          newPresetRegex = identityPresets[idx].regex;
        }
      }
    }
    if (isMalaysia) {
      customerAdd.customer.isForeignCompany = false;
      customerAdd.customer.taxIdentificationNo = (0, _tin.getAutoFillTin)(value, customerAdd.customer.isForeignCompany);
    }
    _this14.setState({
      customerAdd: customerAdd,
      identity: identity,
      identityType: value,
      identityPresetID: newPresetID,
      identityPresetLabel: newPresetLabel,
      identityPresetRegex: newPresetRegex,
      autofillOptions: [],
      showNoAutofill: false,
      tinAddError: false,
      tinAddFound: false,
      tinMessage: null
    }, function () {
      if (_this14.validation.identity && _this14.validation.identity.current && identity !== '') {
        _this14.validation.identity.current.validate(identity);
      }
      if (_this14.validation.preferredName && _this14.validation.preferredName.current && customerAdd.preferredName !== '') {
        _this14.validation.preferredName.current.validate(customerAdd.preferredName);
      }
      // CPI-1319: the VN no-digits rule on Full Name depends on the identity type.
      if (_this14.validation.name && _this14.validation.name.current && customerAdd.name !== '') {
        _this14.validation.name.current.validate(customerAdd.name);
      }
      if (value === 1 && identity.length === 12) {
        if (!_this14.state.searchingID) {
          _this14.searchAutofillCustomer(_this14.state.identity, _this14.getAutofillIdentityTypeName(_this14.state.identityType));
        }
      } else if (value !== 1 && identity.length > 0) {
        clearTimeout(_this14.setTimer);
        _this14.setTimer = setTimeout(function () {
          if (_this14.state.identityLock && _this14.state.autofillOptions && _this14.state.autofillOptions.length > 0) {
            var existingCustomer = _this14.state.existingCustomer;

            _this14.setState({ identity: existingCustomer.identity });
          } else {
            _this14.searchAutofillCustomer(identity, _this14.getAutofillIdentityTypeName(_this14.state.identityType), _this14.state.newPresetID);
          }
        }, 1000);
      }
      _this14.handleCheckChanges('customerAddChanges');
    });
  };

  this.handleCustomerAddSelectChange = function (event, data) {
    if (isPRS) return;
    var _state11 = _this14.state,
        customerAdd = _state11.customerAdd,
        isCRMEnabled = _state11.isCRMEnabled;

    customerAdd[data.name] = data.value;
    _this14.setState({ customerAdd: customerAdd }, function () {
      if (data.name === 'mobilePrefix') {
        _this14.validation.mobile.current.validate(customerAdd.mobile);
        if (isCRMEnabled && customerAdd.mobile !== '') {
          var msisdn = data.value + customerAdd.mobile;
          clearTimeout(_this14.setTimer);
          _this14.setTimer = setTimeout(function () {
            if (!_this14.state.mobileLock && (!_this14.state.autofillOptions || _this14.state.autofillOptions.length === 0)) {
              _this14.searchAutofillCustomer(msisdn, _autofillTypes.AUTOFILL_MSISDN);
            }
          }, 1000);
        }
      }
      if (data.name === 'phonePrefix') {
        _this14.validation.phone.current.validate(customerAdd.phone);
      }
      _this14.handleCheckChanges('customerAddChanges');
    });
  };

  this.handleCustomerAddSelectHimsDistrict = function (himsDistrict) {
    var customerAdd = _this14.state.customerAdd;

    customerAdd.himsKodDaerah = himsDistrict ? himsDistrict.value : '';

    _this14.setState({ customerAdd: customerAdd }, function () {
      _this14.handleCheckChanges('customerAddChanges');
    });
  };

  this.handleCustomerAddSelectHimsPostcode = function (himsPostcode) {
    var customerAdd = _this14.state.customerAdd;
    var addressSettings = _this14.props.addressSettings;


    customerAdd.himsKodPoskod = himsPostcode ? himsPostcode.value : '';
    customerAdd.himsKodBandar = himsPostcode ? himsPostcode.kod_bandar_id : '';
    customerAdd.himsKodNegeri = himsPostcode ? himsPostcode.kod_negeri_id : '';

    // update postcode, city and state as well based on the HIMS postcode
    var enabledAddressSettings = addressSettings.data.filter(function (as) {
      return as.enabled;
    });
    var addressFields = enabledAddressSettings.reduce(function (acc, as) {
      var labelKey = as.label.toLowerCase();
      return _extends({}, acc, labelKey === 'postcode' && { postcode: as }, labelKey === 'city' && { city: as }, labelKey === 'state' && { state: as });
    }, {});

    if (addressFields.postcode && addressFields.postcode.columnName !== '') {
      var key = _lodash2.default.camelCase(addressFields.postcode.columnName);
      customerAdd[key] = himsPostcode ? himsPostcode.text : '';
    }

    if (addressFields.city && addressFields.city.columnName !== '') {
      var _key = _lodash2.default.camelCase(addressFields.city.columnName);
      customerAdd[_key] = himsPostcode ? himsPostcode.bandar : '';
    }

    if (addressFields.state && addressFields.state.columnName !== '') {
      var _key2 = _lodash2.default.camelCase(addressFields.state.columnName);
      var himsState = himsPostcode ? himsPostcode.kod_negeri_id : '';
      var srState = _states2.default.find(function (s) {
        return s.kod_negeri_id === himsState;
      });
      customerAdd[_key2] = srState ? srState.value : '';
    }

    _this14.setState({ customerAdd: customerAdd }, function () {
      _this14.handleCheckChanges('customerAddChanges');
    });
  };

  this.handleCustomerAddInputChange = function (event) {
    if (isPRS) return;
    var _state12 = _this14.state,
        customerAdd = _state12.customerAdd,
        isCRMEnabled = _state12.isCRMEnabled;

    customerAdd[event.target.name] = event.target.name.toLowerCase().includes('email') ? event.target.value : _this14.toUppercaseFormat(event.target.value);
    var hasMobileChanges = event && event.target && event.target.name === 'mobile';
    _this14.setState({ customerAdd: customerAdd }, function () {
      if (isCRMEnabled && hasMobileChanges && customerAdd.mobilePrefix !== '' && customerAdd.mobile !== '') {
        var msisdn = customerAdd.mobilePrefix + customerAdd.mobile;
        clearTimeout(_this14.setTimer);
        _this14.setTimer = setTimeout(function () {
          if (!_this14.state.mobileLock && (!_this14.state.autofillOptions || _this14.state.autofillOptions.length === 0)) {
            _this14.searchAutofillCustomer(msisdn, _autofillTypes.AUTOFILL_MSISDN);
          }
        }, 1000);
      }
      _this14.handleCheckChanges('customerAddChanges');
    });
  };

  this.handleCloseCustomerAddArea = function () {
    var _ref31 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(e) {
      return regeneratorRuntime.wrap(function _callee19$(_context19) {
        while (1) {
          switch (_context19.prev = _context19.next) {
            case 0:
              e.preventDefault();
              _context19.next = 3;
              return _this14.resetCustomerAddDocumentState();

            case 3:
              _context19.next = 5;
              return _this14.setComponentState({
                customerAdd: Object.assign({}, _this14.state.bookingCustomerDefaultData),
                customerAddArea: false,
                customerAddChanges: false,
                addCustomerICChanges: false,
                autofillOptions: [],
                identity: '',
                identityType: isPRS ? 1 : '',
                identityLock: false,
                mobileLock: false,
                existingCustomer: {}
              });

            case 5:
              _this14.handleOnCheck();

            case 6:
            case 'end':
              return _context19.stop();
          }
        }
      }, _callee19, _this14);
    }));

    return function (_x42) {
      return _ref31.apply(this, arguments);
    };
  }();

  this.handleOpenCustomerAddArea = function () {
    var _ref32 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(e) {
      var existingLeadCustomer, _state13, customerAdd, identityType, identity;

      return regeneratorRuntime.wrap(function _callee20$(_context20) {
        while (1) {
          switch (_context20.prev = _context20.next) {
            case 0:
              e.preventDefault();
              _context20.next = 3;
              return _this14.resetCustomerAddDocumentState();

            case 3:
              _this14.handleResetCheck('addCustomerICChanges');
              existingLeadCustomer = _this14.state.existingLeadCustomer;
              _state13 = _this14.state, customerAdd = _state13.customerAdd, identityType = _state13.identityType, identity = _state13.identity;

              if (existingLeadCustomer) {
                if (existingLeadCustomer.identity) {
                  identity = existingLeadCustomer.identity.trim();
                }
                if (existingLeadCustomer.identityTypeID) {
                  identityType = existingLeadCustomer.identityTypeID;
                }
                // autofill lead opportunity 2nd purchaser
                customerAdd = Object.assign(customerAdd, existingLeadCustomer.customerDetail);
                customerAdd.leadCustomerID = existingLeadCustomer.leadCustomerID;
                customerAdd.race = _this14.getRace(existingLeadCustomer.customerDetail.race);
                customerAdd.raceOther = customerAdd.race === 'Others' ? existingLeadCustomer.customerDetail.race : '';
                customerAdd.customerDetailID = existingLeadCustomer.customerDetailID;
                customerAdd.customerID = existingLeadCustomer.id;
                customerAdd.identity = existingLeadCustomer.identity.trim();
                customerAdd.identityTypeID = existingLeadCustomer.identityTypeID;
                customerAdd.birthdate = _this14.getBirthDate(existingLeadCustomer.customerDetail.birthdate, identityType === 1 ? identity : '');
                customerAdd.customerSpecification = existingLeadCustomer.specifications;
                if (existingLeadCustomer.icFrontDocument && existingLeadCustomer.icFrontDocument.key) {
                  customerAdd.leadICFrontURL = existingLeadCustomer.icFrontDocument.key;
                }
                if (existingLeadCustomer.icBackDocument && existingLeadCustomer.icBackDocument.key) {
                  customerAdd.leadICBackURL = existingLeadCustomer.icBackDocument.key;
                }
                customerAdd.maritalStatus = _this14.getMaritalStatus(existingLeadCustomer.customerDetail.maritalStatus);
              }
              _this14.setState({
                identityType: identityType,
                identity: identity,
                customerAdd: customerAdd,
                customerAddArea: true
              }, function () {
                // Scroll
                var body = document.getElementsByTagName('body')[0];
                var customerAddGrid = document.getElementsByClassName('customer add');
                if (customerAddGrid.length > 0) {
                  window.scrollTo(0, body.scrollHeight - customerAddGrid[0].scrollHeight - 190);
                }
              });

            case 8:
            case 'end':
              return _context20.stop();
          }
        }
      }, _callee20, _this14);
    }));

    return function (_x43) {
      return _ref32.apply(this, arguments);
    };
  }();

  this.handleEditCustomer = function (data) {
    var editingCustomer = Object.assign({}, _this14.state.bookingCustomerDefaultData, data);
    editingCustomer.race = _this14.getRace(data.race);
    editingCustomer.raceOther = editingCustomer.race === 'Others' ? data.race : '';
    editingCustomer.maritalStatus = _this14.getMaritalStatus(editingCustomer.maritalStatus);
    editingCustomer.identityTypeID = data.customer.identityTypeID;
    editingCustomer.himsKodPoskod = editingCustomer.himsKodPoskod || editingCustomer.postcode;
    _this14.setState({
      isEditingCustomer: data.customerID,
      editingCustomer: editingCustomer,
      customerAddArea: false
    });
  };

  this.handleCustomerSelectChange = function (event, data) {
    if (isPRS) return;
    var editingCustomer = _this14.state.editingCustomer;

    editingCustomer[data.name] = data.value;
    _this14.setState({ editingCustomer: editingCustomer }, function () {
      if (data.name === 'mobilePrefix') {
        _this14.validation.mobile.current.validate(editingCustomer.mobile);
      }
      if (data.name === 'phonePrefix') {
        _this14.validation.phone.current.validate(editingCustomer.phone);
      }
      // CPI-1319: the VN no-digits rule on Full Name depends on the identity type.
      if (data.name === 'identityTypeID') {
        if (_this14.validation.name && _this14.validation.name.current && editingCustomer.name) {
          _this14.validation.name.current.validate(editingCustomer.name);
        }
        if (_this14.validation.preferredName && _this14.validation.preferredName.current && editingCustomer.preferredName) {
          _this14.validation.preferredName.current.validate(editingCustomer.preferredName);
        }
      }
      _this14.handleCheckChanges('customerChanges');
    });
  };

  this.handleCustomerSelectHimsDistrict = function (himsDistrict) {
    var editingCustomer = _this14.state.editingCustomer;

    editingCustomer.himsKodDaerah = himsDistrict ? himsDistrict.value : '';

    _this14.setState({ editingCustomer: editingCustomer }, function () {
      _this14.handleCheckChanges('customerChanges');
    });
  };

  this.handleCustomerSelectHimsPostcode = function (himsPostcode) {
    var editingCustomer = _this14.state.editingCustomer;
    var addressSettings = _this14.props.addressSettings;


    editingCustomer.himsKodPoskod = himsPostcode ? himsPostcode.value : '';
    editingCustomer.himsKodBandar = himsPostcode ? himsPostcode.kod_bandar_id : '';
    editingCustomer.himsKodNegeri = himsPostcode ? himsPostcode.kod_negeri_id : '';

    // update postcode, city and state as well based on the HIMS postcode
    var enabledAddressSettings = addressSettings.data.filter(function (as) {
      return as.enabled;
    });
    var addressFields = enabledAddressSettings.reduce(function (acc, as) {
      var labelKey = as.label.toLowerCase();
      return _extends({}, acc, labelKey === 'postcode' && { postcode: as }, labelKey === 'city' && { city: as }, labelKey === 'state' && { state: as });
    }, {});
    if (addressFields.postcode && addressFields.postcode.columnName !== '') {
      var key = _lodash2.default.camelCase(addressFields.postcode.columnName);
      editingCustomer[key] = himsPostcode ? himsPostcode.value : '';
    }

    if (addressFields.city && addressFields.city.columnName !== '') {
      var _key3 = _lodash2.default.camelCase(addressFields.city.columnName);
      editingCustomer[_key3] = himsPostcode ? himsPostcode.bandar : '';
    }

    if (addressFields.state && addressFields.state.columnName !== '') {
      var himsState = himsPostcode ? himsPostcode.kod_negeri_id : '';
      var srState = _states2.default.find(function (s) {
        return s.kod_negeri_id === himsState;
      });
      var _key4 = _lodash2.default.camelCase(addressFields.state.columnName);
      editingCustomer[_key4] = srState ? srState.value : '';
    }

    _this14.setState({ editingCustomer: editingCustomer }, function () {
      _this14.handleCheckChanges('customerChanges');
    });
  };

  this.handleCustomerInputChange = function (event) {
    if (isPRS) return;
    var editingCustomer = _this14.state.editingCustomer;

    editingCustomer[event.target.name] = event.target.name.toLowerCase().includes('email') ? event.target.value : _this14.toUppercaseFormat(event.target.value);
    _this14.setState({ editingCustomer: editingCustomer }, function () {
      _this14.handleCheckChanges('customerChanges');
    });
  };

  this.handleTinInput = function (e, target) {
    var customerObj = (0, _clone2.default)(_this14.state[target]);
    var auth = _this14.props.auth;

    var isIndonesia = auth && auth.company.countryCode.toUpperCase() === 'ID';

    if (isIndonesia) {
      customerObj.customer.taxIdentificationNo = e.target.value;
      _this14.setState(_defineProperty({}, target, customerObj), function () {
        _this14.handleCheckChanges(target === 'customerAdd' ? 'customerAddChanges' : 'customerChanges');
      });
      return;
    }

    var tinInput = _this14.toUppercaseFormat(e.target.value);
    var tinFound = e.target.tinFound;
    var isAlphanumeric = /^[a-zA-Z0-9]*$/.test(tinInput);
    var tinErrField = target === 'customerAdd' ? 'tinErrorAdd' : 'tinErrorEdit';
    var tinFoundField = target === 'customerAdd' ? 'tinAddFound' : 'tinEditFound';

    if (tinInput === '') {
      var _this14$setState5;

      customerObj.customer.taxIdentificationNo = '';
      _this14.setState((_this14$setState5 = {}, _defineProperty(_this14$setState5, target, customerObj), _defineProperty(_this14$setState5, tinErrField, false), _defineProperty(_this14$setState5, tinFoundField, false), _defineProperty(_this14$setState5, 'tinMessage', null), _this14$setState5));
      return;
    }

    if (isAlphanumeric) {
      var _this14$setState6;

      customerObj.customer.taxIdentificationNo = tinInput;
      _this14.setState((_this14$setState6 = {}, _defineProperty(_this14$setState6, target, customerObj), _defineProperty(_this14$setState6, tinErrField, tinFound === false), _defineProperty(_this14$setState6, tinFoundField, tinFound), _defineProperty(_this14$setState6, 'tinMessage', tinFound ? null : _this14.state.tinMessage), _this14$setState6), function () {
        _this14.handleCheckChanges(target === 'customerAdd' ? 'customerAddChanges' : 'customerChanges');
      });

      if (tinFound) {
        var _this14$setState7;

        _this14.setState((_this14$setState7 = {}, _defineProperty(_this14$setState7, tinErrField, false), _defineProperty(_this14$setState7, tinFoundField, true), _defineProperty(_this14$setState7, 'tinMessage', null), _this14$setState7));
        return;
      }

      var matched = _regex.REGEX_TIN_VALID.test(tinInput);
      var customerID = target === 'editingCustomer' ? customerObj.customer.id : null;
      var bookingID = _this14.state.data.id;
      var identityTypeID = target === 'customerAdd' ? _this14.state.identityType : customerObj.customer.identityTypeID;
      var identityValue = target === 'customerAdd' ? _this14.state.identity : customerObj.customer.identity;
      var isForeignCompanyValue = customerObj.customer.isForeignCompany;
      var genericTin = (0, _tin.getGenericTinByIdTypeAndTinNo)(identityTypeID, tinInput, isForeignCompanyValue);

      _this14.setLoading(true, 'validatingTIN');
      if (_this14.debounceTimeout) clearTimeout(_this14.debounceTimeout);

      _this14.debounceTimeout = setTimeout(function () {
        if (matched) {
          if (tinInput === _tin.GOVERNMENT_GENERIC_TIN) {
            var _this14$setState8;

            var isForeign = !(0, _tin.isForeignIdType)(identityTypeID, identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && isForeignCompanyValue);
            _this14.setState((_this14$setState8 = {}, _defineProperty(_this14$setState8, tinErrField, !isForeign), _defineProperty(_this14$setState8, 'tinAddFound', target === 'customerAdd' ? !isForeign : null), _defineProperty(_this14$setState8, 'tinEditFound', target === 'editingCustomer' ? !isForeign : null), _defineProperty(_this14$setState8, 'tinMessage', !isForeign ? _tin.GENERIC_TIN_UNMATCHED_ERROR_MSG : null), _this14$setState8), function () {
              _this14.setLoading(false, 'validatingTIN');
            });
          } else if (_tin.GENERIC_TIN_VALUES.includes(tinInput)) {
            var _this14$setState9;

            _this14.setState((_this14$setState9 = {}, _defineProperty(_this14$setState9, tinErrField, !(0, _tin.isGenericTinFound)(genericTin)), _defineProperty(_this14$setState9, 'tinAddFound', target === 'customerAdd' ? (0, _tin.isGenericTinFound)(genericTin) : null), _defineProperty(_this14$setState9, 'tinEditFound', target === 'editingCustomer' ? (0, _tin.isGenericTinFound)(genericTin) : null), _defineProperty(_this14$setState9, 'tinMessage', !(0, _tin.isGenericTinFound)(genericTin) ? _tin.GENERIC_TIN_UNMATCHED_ERROR_MSG : null), _this14$setState9), function () {
              _this14.setLoading(false, 'validatingTIN');
            });
          } else {
            _this14.validateTIN(tinInput, identityTypeID, identityValue, tinErrField, customerID, bookingID, target).finally(function () {
              _this14.setLoading(false, 'validatingTIN');
            });
          }
        } else {
          _this14.setState(_defineProperty({}, tinErrField, true), function () {
            _this14.setLoading(false, 'validatingTIN');
          });
        }
      }, 3000);
    }
  };

  this.handleSubmitCustomer = function (event) {
    event.preventDefault();
    var data = _this14.state.data;

    if (_this14.isBULeaderRestrictedEdit(data)) {
      _this14.setState({ showSoldConfirmation: true });
    } else {
      _this14.updateBookingCustomer();
    }
  };

  this.handleConfirmSoldUpdate = function () {
    _this14.setState({ showSoldConfirmation: false }, function () {
      _this14.updateBookingCustomer();
    });
  };

  this.handleCancelSoldUpdate = function () {
    _this14.setState({ showSoldConfirmation: false });
  };

  this.handleSubmit = function (e) {
    e.preventDefault();
    _this14.submitCustomer();
  };

  this.hasResetIdentityIcon = function () {
    if (!_this14.state.searchingID && _this14.state.identity !== '' && _this14.state.identityLock) {
      return true;
    }
    return false;
  };

  this.hasResetMobileIcon = function (mobile) {
    if (!_this14.state.searchingIDByMobile && mobile !== '' && _this14.state.mobileLock) {
      return true;
    }
    return false;
  };

  this.handleResetAutofill = function () {
    var customerAdd = Object.assign({}, _this14.state.bookingCustomerDefaultData);
    customerAdd.customer.taxIdentificationNo = '';
    customerAdd.customerDetailID = null;
    customerAdd.customerID = null;
    _this14.setState({
      customerAdd: customerAdd,
      autofillOptions: [],
      existingCustomer: {},
      externalCustomer: {},
      leadCustomer: {},
      identity: '',
      identityLock: false,
      mobileLock: false,
      prsID: ''
    }, function () {
      if (_this14.identityInputRef.current) {
        _this14.identityInputRef.current.focus();
      }
    });
  };

  this.handleBookingStatusChange = function (event, value) {
    var _state14 = _this14.state,
        data = _state14.data,
        oriData = _state14.oriData;

    data[value.name] = value.value;
    if (data[value.name] !== oriData[value.name]) {
      _this14.setState({ data: data, bookingStatusModal: true });
    }
  };

  this.handleNotesChange = function (bnEncoded) {
    var data = _this14.state.data;

    data.newBookingNoteEncoded = bnEncoded;
    data.remarkInternal = '';
    _this14.setState({ data: data });
  };

  this.handleCheckboxChange = function (event, _ref33) {
    var checked = _ref33.checked;
    var data = _this14.state.data;

    data.isCancelPending = checked;
    _this14.setState({ data: data });
  };

  this.handleConfirmBookingStatus = function () {
    var data = _this14.state.data;

    var booking = {
      statusID: data.statusID,
      newBookingNoteEncoded: data.newBookingNoteEncoded
    };
    if (data.statusID === 'sold_spa_signed' || data.statusID === 'cancelled_developer') {
      booking.isCancelPending = data.isCancelPending;
    }
    _this14.setState({ bookingStatusModal: false }, function () {
      _this14.updateBooking(booking, 'update');
    });
  };

  this.handleCancelBookingStatus = function () {
    var _state15 = _this14.state,
        data = _state15.data,
        oriData = _state15.oriData;

    data.statusID = oriData.statusID;
    data.remarkInternal = oriData.remarkInternal;
    _this14.setState({ data: data, bookingStatusModal: false });
  };

  this.handleBirthdateSelectAdd = function (day) {
    var customerAdd = _this14.state.customerAdd;

    customerAdd.birthdate = day;
    _this14.setState({ customerAdd: customerAdd }, function () {
      _this14.handleCheckChanges('customerAddChanges');
    });
  };

  this.handleBirthdateSelectEdit = function (day) {
    var editingCustomer = _this14.state.editingCustomer;

    editingCustomer.birthdate = day;
    _this14.setState({ editingCustomer: editingCustomer }, function () {
      _this14.handleCheckChanges('customerChanges');
    });
  };

  this.handleOpenHTML = function (e, data) {
    var isBuyer = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var customer = data.customer;

    e.preventDefault();
    if (isBuyer || customer && (customer.icFrontDocumentID || customer.icBackDocumentID)) {
      var url = _config2.default.get('bookApiURL') + '/bookings/' + data.bookingID + '/customers/' + customer.id + '/identity/';
      if (isBuyer) {
        url += '?isBuyer=true';
      }
      window.open(url, 'identity-' + customer.id, '');
    }
  };

  this.crmIdentityApplies = function () {
    var auth = _this14.props.auth;
    var data = _this14.state.data;

    return (0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode) && !!data && !!data.purchasersIsolated;
  };

  this.crmIdentityOf = function (customerID) {
    if (!_this14.crmIdentityApplies()) return { source: 'local' };
    var info = _this14.state.crmIdentities[customerID];
    if (!info || info.status === 'error') return { source: 'pending', failed: !!info };
    return { source: info.status === 'shared' ? 'shared' : 'local', info: info };
  };

  this.revokeCRMIdentityImages = function (crmIdentities) {
    Object.values(crmIdentities).forEach(function (info) {
      return Object.values(info && info.images || {}).forEach(function (url) {
        return URL.revokeObjectURL(url);
      });
    });
  };

  this.fetchCRMIdentities = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
    var load, data, store, customers, options, answers, crmIdentities;
    return regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) {
        switch (_context23.prev = _context23.next) {
          case 0:
            _this14.crmIdentityLoad = (_this14.crmIdentityLoad || 0) + 1;
            load = _this14.crmIdentityLoad;
            data = _this14.state.data;
            store = _this14.context.store;
            customers = _this14.crmIdentityApplies() && data.id ? data.bookingCustomers || [] : [];

            if (!(customers.length === 0 && _lodash2.default.isEmpty(_this14.state.crmIdentities))) {
              _context23.next = 7;
              break;
            }

            return _context23.abrupt('return');

          case 7:
            // ignoreNotFound / ignoreForbidden: a failed lookup is shown on the card, not by leaving the page.
            options = { credentials: 'include', method: 'GET', ignoreNotFound: true, ignoreForbidden: true };
            _context23.next = 10;
            return Promise.all(customers.map(function () {
              var _ref35 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22(_ref36) {
                var customerID = _ref36.customerID;
                var path, res, info, sides;
                return regeneratorRuntime.wrap(function _callee22$(_context22) {
                  while (1) {
                    switch (_context22.prev = _context22.next) {
                      case 0:
                        path = '/bookings/' + data.id + '/customers/' + customerID + '/crm_identity/';
                        _context22.prev = 1;
                        _context22.next = 4;
                        return store.dispatch((0, _fetchM.fetchM)(path, options));

                      case 4:
                        res = _context22.sent;
                        _context22.t0 = _extends;
                        _context22.t1 = {};
                        _context22.next = 9;
                        return res.json();

                      case 9:
                        _context22.t2 = _context22.sent;
                        _context22.t3 = { images: {} };
                        info = (0, _context22.t0)(_context22.t1, _context22.t2, _context22.t3);
                        sides = ['front', 'back'].filter(function (side) {
                          return info.status === 'shared' && info[side] && info[side].available;
                        });
                        _context22.next = 15;
                        return Promise.all(sides.map(function () {
                          var _ref37 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(side) {
                            var image;
                            return regeneratorRuntime.wrap(function _callee21$(_context21) {
                              while (1) {
                                switch (_context21.prev = _context21.next) {
                                  case 0:
                                    _context21.next = 2;
                                    return store.dispatch((0, _fetchM.fetchM)('' + path + side + '/?v=' + encodeURIComponent(info[side].version || ''), _extends({}, options, { cache: 'no-store' })));

                                  case 2:
                                    image = _context21.sent;

                                    if (image.ok) {
                                      _context21.next = 5;
                                      break;
                                    }

                                    throw new Error('CRM identity ' + side + ' could not be loaded');

                                  case 5:
                                    _context21.t0 = URL;
                                    _context21.next = 8;
                                    return image.blob();

                                  case 8:
                                    _context21.t1 = _context21.sent;
                                    info.images[side] = _context21.t0.createObjectURL.call(_context21.t0, _context21.t1);

                                  case 10:
                                  case 'end':
                                    return _context21.stop();
                                }
                              }
                            }, _callee21, _this14);
                          }));

                          return function (_x46) {
                            return _ref37.apply(this, arguments);
                          };
                        }()));

                      case 15:
                        return _context22.abrupt('return', [customerID, info]);

                      case 18:
                        _context22.prev = 18;
                        _context22.t4 = _context22['catch'](1);
                        return _context22.abrupt('return', [customerID, { status: 'error' }]);

                      case 21:
                      case 'end':
                        return _context22.stop();
                    }
                  }
                }, _callee22, _this14, [[1, 18]]);
              }));

              return function (_x45) {
                return _ref35.apply(this, arguments);
              };
            }()));

          case 10:
            answers = _context23.sent;
            crmIdentities = _lodash2.default.fromPairs(answers);

            if (!(load !== _this14.crmIdentityLoad)) {
              _context23.next = 15;
              break;
            }

            _this14.revokeCRMIdentityImages(crmIdentities);
            return _context23.abrupt('return');

          case 15:
            _this14.revokeCRMIdentityImages(_this14.state.crmIdentities);
            _context23.next = 18;
            return _this14.setComponentState({ crmIdentities: crmIdentities });

          case 18:
          case 'end':
            return _context23.stop();
        }
      }
    }, _callee23, _this14);
  }));

  this.identityAcceptProps = function () {
    return _this14.crmIdentityApplies() ? { accept: VN_IDENTITY_ACCEPT } : {};
  };

  this.identityPictureProps = function (bookingCustomer, side) {
    var customer = bookingCustomer.customer;

    var _crmIdentityOf = _this14.crmIdentityOf(bookingCustomer.customerID),
        source = _crmIdentityOf.source,
        info = _crmIdentityOf.info;

    if (source === 'shared') {
      var src = info.images[side] || '';
      return _extends({ picture: src ? { name: info[side].name || '' } : null, pictureSrc: src }, _this14.identityAcceptProps());
    }
    var documentID = source === 'local' && customer && (side === 'front' ? customer.icFrontDocumentID : customer.icBackDocumentID);
    return _extends({
      picture: documentID && documentID.length > 0 ? customer[side === 'front' ? 'icFrontDocument' : 'icBackDocument'] : null
    }, _this14.identityAcceptProps());
  };

  this.identityDocumentComplete = function (bookingCustomer, isVietnam) {
    var _crmIdentityOf2 = _this14.crmIdentityOf(bookingCustomer.customerID),
        source = _crmIdentityOf2.source,
        info = _crmIdentityOf2.info;

    if (source === 'shared') {
      return !!info.images.front && ((0, _vietnam.idDocumentSides)(bookingCustomer.customer.identityTypeID, isVietnam) === 1 || !!info.images.back);
    }
    return source === 'local' && (0, _vietnam.idDocumentComplete)(bookingCustomer.customer, isVietnam);
  };

  this.handleOnChangeLPPSA = function (customerData) {
    var idx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var data = _this14.state.data;

    data.bookingCustomers[idx].customer = customerData;
    _this14.setState({ data: data }, function () {
      _this14.updateLPPSA(customerData);
    });
  };

  this.handleCancelEditCustomer = function (e) {
    e.preventDefault();
    var store = _this14.context.store;

    var callback = function callback() {
      _this14.setState({
        errMessages: [],
        isEditingCustomer: 0,
        editingCustomer: Object.assign({}, _this14.state.bookingCustomerDefaultData)
      }, function () {
        _this14.handleResetCheck('customerChanges');
      });
    };
    if (_this14.props.checkHasChanges()) {
      store.dispatch((0, _prompt.promptChangesMessage)({ message: _promptMessages.CANCEL_PROMPT, samePage: true, callback: callback }));
    } else {
      callback();
    }
  };

  this.handleCopyAddressFromPrimaryPurchaser = function (e) {
    e.preventDefault();
    var _state16 = _this14.state,
        data = _state16.data,
        customerAdd = _state16.customerAdd;

    var primaryCustomer = _this14.getPrimaryBookingCustomer(data);
    customerAdd.address1 = primaryCustomer.address1;
    customerAdd.address2 = primaryCustomer.address2;
    customerAdd.address3 = primaryCustomer.address3;
    customerAdd.address4 = primaryCustomer.address4;
    customerAdd.address5 = primaryCustomer.address5;
    customerAdd.address6 = primaryCustomer.address6;
    customerAdd.address7 = primaryCustomer.address7;
    customerAdd.address8 = primaryCustomer.address8;
    customerAdd.address9 = primaryCustomer.address9;
    customerAdd.address10 = primaryCustomer.address10;
    customerAdd.country = primaryCustomer.country;

    // copy hims field as well
    customerAdd.himsKodPoskod = primaryCustomer.himsKodPoskod;
    customerAdd.himsKodBandar = primaryCustomer.himsKodBandar;
    customerAdd.himsKodDaerah = primaryCustomer.himsKodDaerah;
    customerAdd.himsKodNegeri = primaryCustomer.himsKodNegeri;
    customerAdd.himsKodNegara = primaryCustomer.himsKodNegara;

    _this14.setState({ customerAdd: customerAdd });
  };

  this.saveSignature = function () {
    var _ref38 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24(event, customerData) {
      var store, t, bookingCustomer, signature;
      return regeneratorRuntime.wrap(function _callee24$(_context24) {
        while (1) {
          switch (_context24.prev = _context24.next) {
            case 0:
              event.preventDefault();
              store = _this14.context.store;
              t = _this14.props.t;

              if (!_this14.signatureModal.isEmpty()) {
                _context24.next = 6;
                break;
              }

              store.dispatch((0, _flash.flashErrorMessage)({ header: t('Error', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Please sign the consent', { ns: _translation.TRANSLATION_FILES.translation }) }));
              return _context24.abrupt('return');

            case 6:
              bookingCustomer = Object.assign({}, _this14.state.bookingCustomerDefaultData, customerData);
              signature = _this14.signatureModal.signData().replace(/^data:image\/(png|jpg);base64,/, '');

              _this14.updateBookingCustomerSignature(bookingCustomer.bookingID, bookingCustomer.customerID, signature);

            case 9:
            case 'end':
              return _context24.stop();
          }
        }
      }, _callee24, _this14);
    }));

    return function (_x48, _x49) {
      return _ref38.apply(this, arguments);
    };
  }();

  this.sortPrimaryCustomer = function (x, y) {
    if (x.customerID === _this14.state.data.customerID) return -1;
    if (y.customerID === _this14.state.data.customerID) return 1;
    return 0;
  };

  this.formatAutofill = function (customer) {
    var purchaserInputFields = ['name', 'preferredName', 'jobTitle', 'emergencyContactName', 'emergencyContactRelation', 'emergencyContactIdentity', 'identity', 'taxIdentificationNo'];
    var addressSettings = _this14.props.addressSettings;

    var enabledAddressSettings = addressSettings.data.filter(function (as) {
      return as.enabled;
    });
    enabledAddressSettings.forEach(function (as) {
      var key = _lodash2.default.camelCase(as.columnName);
      var label = as.label.toLowerCase();
      if (label !== 'postcode' && label !== 'state') {
        purchaserInputFields.push(key);
      }
    });
    var formattedCustomer = _extends({}, customer);
    purchaserInputFields.forEach(function (pf) {
      if (formattedCustomer[pf]) {
        formattedCustomer[pf] = _this14.toUppercaseFormat(formattedCustomer[pf]);
      }
    });
    return formattedCustomer;
  };

  this.replaceWithAutofill = function (type) {
    var field = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'identity';
    var _state17 = _this14.state,
        externalCustomer = _state17.externalCustomer,
        existingCustomer = _state17.existingCustomer,
        leadCustomer = _state17.leadCustomer,
        identityPresets = _state17.identityPresets;
    var auth = _this14.props.auth;

    var customerAdd = _this14.state.customerAdd;
    var isMalaysia = auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    var isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';
    if (type === 'existing') {
      customerAdd = Object.assign(_this14.state.customerAdd, existingCustomer.customerDetail);
      customerAdd.race = _this14.getRace(existingCustomer.customerDetail.race);
      customerAdd.raceOther = customerAdd.race === 'Others' ? existingCustomer.customerDetail.race : '';
      customerAdd.customerDetailID = existingCustomer.customerDetailID;
      customerAdd.customerID = existingCustomer.id;
      customerAdd.identity = existingCustomer.identity.trim();
      customerAdd.identityTypeID = existingCustomer.identityTypeID;
      customerAdd.identityPresetID = existingCustomer.identityPresetID;
      customerAdd.identityPresetLabel = existingCustomer.identityPresetLabel;
      customerAdd.identityPresetRegex = existingCustomer.identityPresetRegex;
      if (existingCustomer.taxIdentificationNo) {
        customerAdd.customer.taxIdentificationNo = existingCustomer.taxIdentificationNo;
      }
      customerAdd.birthdate = _this14.getBirthDate(existingCustomer.customerDetail.birthdate, _this14.state.identityType === 1 ? _this14.state.identity : '');
      customerAdd.customerSpecification = existingCustomer.specifications;
      customerAdd.maritalStatus = _this14.getMaritalStatus(existingCustomer.customerDetail.maritalStatus);
    }
    if (type === 'external') {
      customerAdd = Object.assign(_this14.state.customerAdd, externalCustomer.customerDetail);
      customerAdd.identity = externalCustomer.identity.trim();
      customerAdd.identityTypeID = externalCustomer.identityTypeID;
    }
    if (type === 'lead') {
      var customer = leadCustomer.customer;
      customerAdd = Object.assign(_this14.state.customerAdd, customer.customerDetail);
      customerAdd.leadCustomerID = leadCustomer.id;
      customerAdd.race = _this14.getRace(customer.customerDetail.race);
      customerAdd.raceOther = customerAdd.race === 'Others' ? customer.customerDetail.race : '';
      customerAdd.identity = customer.identity.trim();
      customerAdd.identityTypeID = customer.identityTypeID;
      customerAdd.identityPresetID = _this14.state.identityPresetID;
      customerAdd.identityPresetLabel = _this14.state.identityPresetLabel;
      customerAdd.identityPresetRegex = _this14.state.identityPresetRegex;
      if (isMalaysia) {
        customerAdd.customer.taxIdentificationNo = leadCustomer.contacts[0].tin || '';
      } else if (isIndonesia) {
        customerAdd.customer.taxIdentificationNo = leadCustomer.contacts[0].npwp || '';
        if (leadCustomer.details.ktp) {
          var matched = identityPresets.find(function (i) {
            return i.label === 'Kartu Tanda Penduduk';
          });
          if (matched) {
            customerAdd.identityTypeID = matched.id;
            customerAdd.identityPresetID = matched.id;
            customerAdd.identityPresetLabel = matched.label;
            customerAdd.identityPresetRegex = matched.regex;
          }
        }
      }
      customerAdd.birthdate = _this14.getBirthDate(customer.customerDetail.birthdate, _this14.state.identityType === 1 ? _this14.state.identity : '');
      customerAdd.customerSpecification = customer.specifications;
      customerAdd.jobTitle = leadCustomer.details && leadCustomer.details.occupation ? leadCustomer.details.occupation : '';
      customerAdd.address1 = leadCustomer.details && leadCustomer.details.address_1 ? leadCustomer.details.address_1 : '';
      customerAdd.address2 = leadCustomer.details && leadCustomer.details.address_2 ? leadCustomer.details.address_2 : '';
      customerAdd.maritalStatus = _this14.getMaritalStatus(customer.customerDetail.maritalStatus);
      if (customer.icFrontDocument && customer.icFrontDocument.key) {
        customerAdd.leadICFrontURL = customer.icFrontDocument.key;
      }
      if (customer.icBackDocument && customer.icBackDocument.key) {
        customerAdd.leadICBackURL = customer.icBackDocument.key;
      }
    }
    customerAdd.taxIdentificationNo = customerAdd.customer.taxIdentificationNo;
    _this14.setState({
      customerAdd: _this14.formatAutofill(customerAdd),
      identity: customerAdd.identity,
      identityType: customerAdd.identityTypeID,
      identityPresetID: customerAdd.identityPresetID,
      identityPresetLabel: customerAdd.identityPresetLabel,
      identityPresetRegex: customerAdd.identityPresetRegex,
      taxIdentificationNo: customerAdd.customer.taxIdentificationNo
    }, function () {
      // The identity type rule reads `identityType`, but the autofilled customer only carries
      // `identityTypeID`. Without this the rule saw nothing, painted "Identity Type is required"
      // on a field that was locked a moment later, and nothing ever cleared it. Same shape as
      // submitCustomer, which validates `{ ...customerAdd, identityType }`.
      _AppForm2.default.validate(_this14.validation, _extends({}, customerAdd, { identityType: customerAdd.identityTypeID })).then(function (validations) {
        _this14.setState({
          errMessages: validations.filter(function (v) {
            return !v.isValid;
          }),
          identityLock: field === 'identity',
          mobileLock: field === 'msisdn'
        });
      });
    });
  };

  this.checkUnitIsSold = function (data) {
    return data && data.statusID === 'sold_spa_signed';
  };

  this.isBULeader = function () {
    var auth = _this14.props.auth;

    return auth.isBranchLeaderSupervisor || auth.isBranchLeaderSupervisorII || auth.isBranchLeader;
  };

  this.isBULeaderRestrictedEdit = function (data) {
    return _this14.checkUnitIsSold(data) && _this14.isBULeader() && !_this14.hasAccess(false, true, true, false, false);
  };

  this.disableEditAfterSold = function (data) {
    if (_this14.checkUnitIsSold(data) && data.project && !data.project.allowPurchaserEditAfterSold) {
      if (_this14.hasAccess() || _this14.isBULeader()) {
        return false;
      }
      return true;
    }
    return false;
  };

  this.checkICIsImage = function (customer) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    var isImage = true;
    if ((!type || type === 'front') && customer.icFrontDocumentID !== '') {
      if (customer.icFrontDocument && customer.icFrontDocument.name) {
        // NOTE: this checking will not work if filename don't hav extension
        if (customer.icFrontDocument.name.toLowerCase().includes('.pdf')) isImage = false;
      }
    }
    if ((!type || type === 'back') && customer.icBackDocumentID !== '') {
      if (customer.icBackDocument && customer.icBackDocument.name) {
        // NOTE: this checking will not work if filename don't hav extension
        if (customer.icBackDocument.name.toLowerCase().includes('.pdf')) isImage = false;
      }
    }
    return isImage;
  };

  this.customerDropdownOptions = function (customerData, data, idx) {
    var t = _this14.props.t;

    var customerDropdownOptions = [];
    if (customerData.customerID !== data.customerID && (_this14.hasAccess() || _this14.hasChangePrimaryPurchaserAccess(data.project.allowAgentChangePrimaryPurchaser, data.statusID))) {
      customerDropdownOptions.push({
        key: 'primary',
        icon: 'star',
        text: t('Make Primary'),
        onClick: function onClick() {
          _this14.handleOpenModal(customerData.name, customerData.customerID, customerData.id, data.id, 'star', t('Change Primary Purchaser') + '?', t('{{name}} will be set as primary purchaser', { name: customerData.name }) + '.', 'primary');
        }
      });
    }
    if (!isPRS) customerDropdownOptions.push({ key: 'edit', icon: 'edit', text: t('Edit', { ns: _translation.TRANSLATION_FILES.translation }), onClick: function onClick() {
        _this14.handleEditCustomer(customerData);
      } });
    if (customerData.customerID !== data.customerID) {
      customerDropdownOptions.push({
        key: 'remove',
        icon: 'x',
        text: t('Remove'),
        onClick: function onClick() {
          _this14.handleOpenModal(customerData.name, customerData.customerID, customerData.id, data.id, 'remove', t('Remove Purchaser') + ' ' + (idx + 1) + '?', t('Purchaser {{name}} will be removed', { name: customerData.name }) + '.', 'remove');
        }
      });
    }
    return customerDropdownOptions;
  };

  this.valueToText = function (array, value) {
    var returnRaw = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var element = array.find(function (a) {
      return a.value === value;
    });
    if (element && element.text) {
      return element.text;
    }
    if (returnRaw) return value;
    return '';
  };

  this.validateIdentityType = function () {
    var identityType = _this14.state.identityType;

    switch (identityType) {
      case 1:
        return 'ic_number';
      case 2:
        return 'passport';
      case 3:
        return 'military_police';
      case 5:
        return 'id_number';
      default:
        return 'other';
    }
  };

  this.identityValidation = function () {
    var _props9 = _this14.props,
        auth = _props9.auth,
        t = _props9.t;
    var _state18 = _this14.state,
        identityType = _state18.identityType,
        identityPresetRegex = _state18.identityPresetRegex;

    if (identityType === 6 || !(0, _isNumber.isNumeric)(identityType)) {
      return {
        validRegex: identityPresetRegex
      };
    }
    // CPI-974: the shared CCCD rule, now the CRM's 12-digit one, with the CRM's wording. It
    // replaces the structured pattern CPI-149 wrote here in March.
    var vn = (0, _vietnam.vnIdentityValidation)(auth, identityType, t);
    if (vn) {
      return vn;
    }
    return {
      countryCode: 'MY',
      identityType: _this14.validateIdentityType()
    };
  };

  this.checkAddDataAttributeBCF = function (name) {
    var bdfNames = ['nationality', 'birthdate', 'gender', 'maritalStatus', 'race'];
    if (bdfNames.includes(name)) {
      return true;
    }
    return false;
  };

  this.checkIsEmailRequired = function () {
    var projectBookingCustomFields = _this14.state.projectBookingCustomFields;
    var auth = _this14.props.auth;
    // CPI-976: the purchaser's email is always mandatory for Vietnam (G3-D6); MY/ID unchanged.

    if ((0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode)) return true;
    if (projectBookingCustomFields && projectBookingCustomFields.length > 0 && projectBookingCustomFields.filter(function (p) {
      return p.name === 'email';
    }).length > 0) {
      return projectBookingCustomFields.find(function (p) {
        return p.name === 'email';
      }).isRequired;
    }
    return false;
  };

  this.getCitizenship = function (customer) {
    if (!customer) return '';
    var stored = String(customer.citizenship || '').toLowerCase();
    if (stored === 'local' || stored === 'foreigner') return stored;
    var nationality = String(customer.nationality || '').toLowerCase();
    if (nationality === 'vn') return 'local';
    if (nationality && nationality !== 'not applicable') return 'foreigner';
    return '';
  };

  this.getCitizenshipOptions = function () {
    var t = _this14.props.t;

    return [{ text: t('Local'), value: 'local' }, { text: t('Foreigner'), value: 'foreigner' }];
  };

  this.getCountryOfCitizenOptions = function () {
    var t = _this14.props.t;

    return [].concat(_toConsumableArray(_countries.SELECT_COUNTRIES.filter(function (c) {
      return c.value !== 'vn';
    })), [{ text: t('Others'), value: CITIZEN_COUNTRY_OTHERS }]);
  };

  this.getCountryOfCitizenText = function (customer) {
    var t = _this14.props.t;

    var nationality = customer && customer.nationality;
    if (!nationality) return '';
    if (String(nationality).toUpperCase() === CITIZEN_COUNTRY_OTHERS) return t('Others');
    return (0, _countries2.getCountryName)(String(nationality).toLowerCase()) || nationality;
  };

  this.handleCitizenshipChange = function (target, e, _ref39) {
    var value = _ref39.value;

    if (isPRS) return;
    var customer = _this14.state[target];
    customer.citizenship = value;
    if (value === 'local') {
      customer.nationality = 'vn';
    } else if (value === 'foreigner') {
      var nationality = String(customer.nationality || '').toLowerCase();
      if (!nationality || nationality === 'vn' || nationality === 'not applicable') {
        customer.nationality = CITIZEN_COUNTRY_OTHERS; // "Others by default"
      }
    }
    _this14.setState(_defineProperty({}, target, customer), function () {
      _this14.handleCheckChanges(target === 'customerAdd' ? 'customerAddChanges' : 'customerChanges');
    });
  };

  this.handleCountryOfCitizenChange = function (target, e, _ref40) {
    var value = _ref40.value;

    if (isPRS) return;
    var customer = _this14.state[target];
    customer.nationality = value;
    _this14.setState(_defineProperty({}, target, customer), function () {
      _this14.handleCheckChanges(target === 'customerAdd' ? 'customerAddChanges' : 'customerChanges');
    });
  };

  this.renderCitizenshipInputs = function (target) {
    var _props10 = _this14.props,
        t = _props10.t,
        auth = _props10.auth;

    if (!(0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode)) return null;
    var customer = _this14.state[target];
    var citizenship = _this14.getCitizenship(customer);
    var disabled = target === 'editingCustomer' && _this14.isBULeaderRestrictedEdit(_this14.state.data);
    // Related purchaser only: Citizenship | [Country of Citizen] | Relationship Type; else a spacer keeps Citizenship half-width.
    var relationshipTypeSelect = _this14.renderRelationshipTypeSelect(target);
    return _react2.default.createElement(
      _semanticUiReact.Form.Group,
      { widths: 'equal' },
      _react2.default.createElement(_semanticUiReact.Form.Select, {
        disabled: disabled,
        label: t('Citizenship'),
        name: 'citizenship',
        onChange: function onChange(e, d) {
          return _this14.handleCitizenshipChange(target, e, d);
        },
        options: _this14.toUppercaseOptions(_this14.getCitizenshipOptions()),
        placeholder: t('Select {{title}}', { title: t('Citizenship') }),
        selectOnBlur: false,
        value: citizenship
      }),
      citizenship === 'foreigner' && _react2.default.createElement(_semanticUiReact.Form.Select, {
        disabled: disabled,
        label: t('Country of Citizen'),
        name: 'nationality',
        onChange: function onChange(e, d) {
          return _this14.handleCountryOfCitizenChange(target, e, d);
        },
        options: _this14.toUppercaseOptions(_this14.getCountryOfCitizenOptions()),
        placeholder: t('Select {{title}}', { title: t('Country of Citizen') }),
        search: true,
        selectOnBlur: false,
        noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }),
        value: customer.nationality || ''
      }),
      relationshipTypeSelect || citizenship !== 'foreigner' && _react2.default.createElement('span', { style: { flex: '1 1 auto', width: '100%' } })
    );
  };

  this.getRelationshipType = function (customer) {
    if (!customer || !customer.relationshipType) return '';
    var stored = String(customer.relationshipType).trim().toLowerCase();
    var preset = _relationshipType.RELATIONSHIP_TYPE.find(function (o) {
      return o.value.toLowerCase() === stored;
    });
    return preset ? preset.value : '';
  };

  this.getRelationshipTypeOptions = function () {
    var t = _this14.props.t;

    return _relationshipType.RELATIONSHIP_TYPE.map(function (o) {
      return _extends({}, o, { text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants }) });
    });
  };

  this.isRelatedPurchaser = function (customer) {
    var data = _this14.state.data;

    return !!(customer && data && customer.customerID && customer.customerID !== data.customerID);
  };

  this.queryAfterDeferredPurchaserSave = function (customer) {
    var query = (0, _url.decodeSearch)(_this14.props.location.search);
    var _state19 = _this14.state,
        data = _state19.data,
        reviewedDeferredPurchaserIDs = _state19.reviewedDeferredPurchaserIDs;
    var auth = _this14.props.auth;

    if (!(0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode) || query.reviewPurchasers !== '1' || !data.purchasersIsolated || !_this14.isRelatedPurchaser(customer)) {
      return query;
    }

    // A successful PUT is evidence that this purchaser passed the normal edit-form validation.
    // Keep the reminder while another related purchaser still needs the same validated save.
    var reviewed = [].concat(_toConsumableArray(new Set([].concat(_toConsumableArray(reviewedDeferredPurchaserIDs), [customer.customerID]))));
    var relatedPurchasers = (data.bookingCustomers || []).filter(function (c) {
      return _this14.isRelatedPurchaser(c);
    });
    _this14.setState({ reviewedDeferredPurchaserIDs: reviewed });
    if (relatedPurchasers.length > 0 && relatedPurchasers.every(function (c) {
      return reviewed.includes(c.customerID);
    })) {
      delete query.reviewPurchasers;
    }
    return query;
  };

  this.handleRelationshipTypeChange = function (target, e, _ref41) {
    var value = _ref41.value;

    if (isPRS) return;
    var customer = _this14.state[target];
    customer.relationshipType = value;
    _this14.setState(_defineProperty({}, target, customer), function () {
      _this14.handleCheckChanges(target === 'customerAdd' ? 'customerAddChanges' : 'customerChanges');
    });
  };

  this.renderRelationshipTypeSelect = function (target) {
    var _props11 = _this14.props,
        t = _props11.t,
        auth = _props11.auth;

    if (!(0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode)) return null;
    var customer = _this14.state[target];
    if (target === 'editingCustomer' && !_this14.isRelatedPurchaser(customer)) return null;
    var disabled = target === 'editingCustomer' && _this14.isBULeaderRestrictedEdit(_this14.state.data);
    return _react2.default.createElement(_semanticUiReact.Form.Select, {
      disabled: disabled,
      label: t('Relationship Type'),
      name: 'relationshipType',
      onChange: function onChange(e, d) {
        return _this14.handleRelationshipTypeChange(target, e, d);
      },
      options: _this14.toUppercaseOptions(_this14.getRelationshipTypeOptions()),
      placeholder: t('Select {{title}}', { title: t('Relationship Type') }),
      selectOnBlur: false,
      value: _this14.getRelationshipType(customer)
    });
  };

  this.renderRelationshipTypeView = function (customerData, idx) {
    var _props12 = _this14.props,
        t = _props12.t,
        auth = _props12.auth;

    if (!(0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode)) return null;
    if (!_this14.isRelatedPurchaser(customerData)) return null;
    var relationshipType = _this14.getRelationshipType(customerData);
    var option = _this14.getRelationshipTypeOptions().find(function (o) {
      return o.value === relationshipType;
    });
    return _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { mobile: 16, tablet: 8, computer: 8 },
      _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { textAlign: 'left', width: 8 },
          _react2.default.createElement(
            'b',
            null,
            t('Relationship Type')
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          _extends({ textAlign: 'right', width: 8 }, _this14.getDataAttributes(idx, 'relationshiptype', relationshipType)),
          _this14.toUppercaseFormat(option ? option.text : '-')
        )
      ),
      _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } })
    );
  };

  this.renderCitizenshipView = function (customerData, idx) {
    var _props13 = _this14.props,
        t = _props13.t,
        auth = _props13.auth;

    if (!(0, _countries.isCountryVietnam)(auth && auth.company && auth.company.countryCode)) return null;
    var citizenship = _this14.getCitizenship(customerData);
    var isForeigner = citizenship === 'foreigner';
    var country = _this14.getCountryOfCitizenText(customerData);
    var citizenshipText = '-';
    if (citizenship === 'local') {
      citizenshipText = t('Local');
    } else if (isForeigner) {
      citizenshipText = t('Foreigner', { country: country || 'N/A', ns: _translation.TRANSLATION_FILES.translation });
    }
    return _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      { mobile: 16, tablet: 8, computer: 8 },
      _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { textAlign: 'left', width: 8 },
          _react2.default.createElement(
            'b',
            null,
            t('Citizenship')
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          _extends({ textAlign: 'right', width: 8 }, _this14.getDataAttributes(idx, 'citizenship', citizenship)),
          _this14.toUppercaseFormat(citizenshipText)
        )
      ),
      _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
      isForeigner && _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'left', width: 8 },
            _react2.default.createElement(
              'b',
              null,
              t('Country of Citizen')
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            _extends({ textAlign: 'right', width: 8 }, _this14.getDataAttributes(idx, 'nationality', country)),
            _this14.toUppercaseFormat(country || '-')
          )
        ),
        _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } })
      )
    );
  };

  this.updateTinFieldState = function () {
    var editingCustomer = _this14.state.editingCustomer;

    var disableTinField = false;
    var tinErrorEdit = true;
    if (editingCustomer && editingCustomer.customer && editingCustomer.customer.taxTinValidationStatus === 'success') {
      disableTinField = true;
      tinErrorEdit = false;
    }
    if (_this14.state.disableTinField !== disableTinField || _this14.state.tinErrorEdit !== tinErrorEdit) {
      _this14.setState({
        disableTinField: disableTinField,
        tinErrorEdit: tinErrorEdit
      });
    }
  };

  this.checkIfCompanyBranchAllowedToViewForm = function (formAccessibility) {
    var auth = _this14.props.auth;
    // empty company branch IDs means accessible to all

    if (formAccessibility && (!formAccessibility.companyBranchIDs || formAccessibility.companyBranchIDs.length === 0)) {
      return true;
    }
    if (formAccessibility && formAccessibility.companyBranchIDs && auth.companyBranch && auth.companyBranch.id && formAccessibility.companyBranchIDs.includes(auth.companyBranch.id)) {
      return true;
    }
    return false;
  };

  this.checkIfBookingStatusAllowedToViewForm = function (formAccessibility, booking) {
    if (booking.statusID === 'expired') {
      return true;
    }
    switch (booking.statusID) {
      case 'reserved':
        return formAccessibility && formAccessibility.isEnabledOnReserved;
      case 'booked':
        return formAccessibility && formAccessibility.isEnabledOnBooked;
      case 'cancelled_developer':
      case 'cancelled_availability':
        return formAccessibility && formAccessibility.isEnabledOnCancelled;
      case 'sold_spa_signed':
        return formAccessibility && formAccessibility.isEnabledOnSold;
      default:
        return false;
    }
  };

  this.checkIfFormAccessibleToViewForm = function (currentPFA, booking) {
    var data = _this14.state.data;

    var formAccessibilities = data && data.project && data.project.projectFormAccessibilities ? data.project.projectFormAccessibilities : [];
    var pfaIdx = formAccessibilities.findIndex(function (fa) {
      return fa.templateID === currentPFA.templateID;
    });
    if (pfaIdx !== -1) {
      var selectedPfa = formAccessibilities[pfaIdx];
      var isCompanyBranchAllowedToView = _this14.checkIfCompanyBranchAllowedToViewForm(selectedPfa);
      var isBookingStatusAllowedToView = _this14.checkIfBookingStatusAllowedToViewForm(selectedPfa, booking);
      return isCompanyBranchAllowedToView && isBookingStatusAllowedToView;
    }
    return false;
  };

  this.toUppercaseFormat = function (val) {
    var appConfig = _this14.props.appConfig;

    var uppercasePurchaserInfoIsEnabled = appConfig && appConfig.data && appConfig.data.settings && appConfig.data.settings.uppercasePurchaserInfoIsEnabled;
    return uppercasePurchaserInfoIsEnabled && val && typeof val === 'string' ? val.toUpperCase() : val;
  };

  this.toUppercaseOptions = function (opts) {
    return opts.map(function (opt) {
      return _extends({}, opt, {
        text: _this14.toUppercaseFormat(opt.text)
      });
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.booking, _translation.TRANSLATION_FILES.models.customer]))((0, _reactRedux.connect)(Purchaser.mapStateToProps)(Purchaser));

/***/ }),
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _BookingTitle = __webpack_require__(260);

var _BookingTitle2 = _interopRequireDefault(_BookingTitle);

var _LeadActivity = __webpack_require__(2107);

var _LeadActivity2 = _interopRequireDefault(_LeadActivity);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _Cases = __webpack_require__(2337);

var _Cases2 = _interopRequireDefault(_Cases);

var _LoanTracker = __webpack_require__(1057);

var _LoanTracker2 = _interopRequireDefault(_LoanTracker);

var _BookingStatusNotes = __webpack_require__(398);

var _BookingStatusNotes2 = _interopRequireDefault(_BookingStatusNotes);

var _booking = __webpack_require__(129);

var _booking2 = _interopRequireDefault(_booking);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */

// actions

// components

// containers

// modals

// structs

// constants


_momentTimezone2.default.locale('en-gb');

var Tracker = function (_Component) {
  _inherits(Tracker, _Component);

  function Tracker(props) {
    _classCallCheck(this, Tracker);

    var _this = _possibleConstructorReturn(this, (Tracker.__proto__ || Object.getPrototypeOf(Tracker)).call(this, props));

    _initialiseProps.call(_this);

    var state = Tracker.getPropsToState(props);
    _this.state = _extends({}, state, {
      bookingStatusModal: false,
      bbfLoading: false
    });
    _this.validation = {};
    _this.loanBox = null;
    return _this;
  }

  _createClass(Tracker, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Tracker.getPropsToState(nextProps);
      var _state = this.state,
          allBankCases = _state.allBankCases,
          hasDropCase = _state.hasDropCase;
      // don't allow state to override data if oriData is same

      if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
        state.data = this.state.data;
      }
      if (JSON.stringify(this.state.allBankCases) !== JSON.stringify(state.allBankCases)) {
        allBankCases = state.allBankCases || [];
      }
      if (this.state.hasDropCase !== state.hasDropCase) {
        hasDropCase = state.hasDropCase;
      }

      this.setState(_extends({ allBankCases: allBankCases, hasDropCase: hasDropCase }, state));
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'generateBankerBookingForm',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var xid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.state.data.id;
        var store, t, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setComponentState({
                  bbfLoading: true
                });

              case 2:
                store = this.context.store;
                t = this.props.t;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + xid + '/print_banker/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 7:
                _context.next = 22;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](4);
                _context.next = 13;
                return this.setComponentState({
                  bbfLoading: false
                });

              case 13:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 19;
                  break;
                }

                _context.next = 16;
                return _context.t0.res.text();

              case 16:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 19:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context.abrupt('return');

              case 22:
                _context.next = 24;
                return this.setComponentState({
                  bbfLoading: false
                });

              case 24:
                store.dispatch((0, _reactRouterRedux.replace)('/bookings/' + this.state.data.id + '/?section=tracker'));
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Success', { ns: _translation.TRANSLATION_FILES.constants }),
                  message: t('Booking form has been generated and shared to banker(s)', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 9]]);
      }));

      function generateBankerBookingForm() {
        return _ref.apply(this, arguments);
      }

      return generateBankerBookingForm;
    }()
  }, {
    key: 'updateBooking',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(booking) {
        var store, t, xid, validations, errMessages, res, message, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                xid = this.state.data.id;
                _context2.next = 7;
                return _AppForm2.default.validate(this.validation, this.state.data);

              case 7:
                validations = _context2.sent;
                errMessages = validations.filter(function (v) {
                  return !v.isValid;
                });
                _context2.next = 11;
                return this.setComponentState({
                  errMessages: errMessages
                });

              case 11:
                if (!(errMessages.length > 0)) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 14;
                return this.setLoading(false);

              case 14:
                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errMessages.map(function (l) {
                    return l.message;
                  }) }));
                return _context2.abrupt('return');

              case 16:
                res = '';
                _context2.prev = 17;
                _context2.next = 20;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + xid + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(booking)
                }));

              case 20:
                res = _context2.sent;
                _context2.next = 36;
                break;

              case 23:
                _context2.prev = 23;
                _context2.t0 = _context2['catch'](17);
                _context2.next = 27;
                return this.setLoading(false);

              case 27:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 33;
                  break;
                }

                _context2.next = 30;
                return _context2.t0.res.text();

              case 30:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 33:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context2.abrupt('return');

              case 36:
                _context2.next = 38;
                return res.json();

              case 38:
                data = _context2.sent;
                _context2.next = 41;
                return this.setLoading(false);

              case 41:
                this.handleResetCheck('bookingChanges');
                store.dispatch((0, _reactRouterRedux.push)('/bookings/' + xid + '/'));
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Booking {{code}} successfully updated', { code: data.code, ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 44:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[17, 23]]);
      }));

      function updateBooking(_x3) {
        return _ref2.apply(this, arguments);
      }

      return updateBooking;
    }()
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var admin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var dhq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var dbl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var internal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      var auth = this.props.auth;
      if (dbl && this.props.auth.isBranchLeader) {
        return true;
      }
      if (dhq && this.props.auth.isHeadquarters) {
        return true;
      }
      if (admin && this.props.auth.isSuperAdmin) {
        return true;
      }
      if (internal && auth && auth.companyBranch && !auth.companyBranch.isExternal) {
        return true;
      }
      return check;
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          allBankCases = _state2.allBankCases,
          bbfLoading = _state2.bbfLoading,
          bookingStatusModal = _state2.bookingStatusModal,
          data = _state2.data,
          hasDropCase = _state2.hasDropCase,
          oriData = _state2.oriData;
      var t = this.props.t;

      var primaryCustomer = this.getPrimaryBookingCustomer(data);
      var successBankCase = this.getSuccessBankCase(data);
      return _react2.default.createElement(
        _semanticUiReact.Container,
        { className: 'no_margin' },
        _react2.default.createElement(_BookingStatusNotes2.default, {
          isCancelPending: data.isCancelPending,
          notes: data.remarkInternal,
          onCheckboxChange: this.handleCheckboxChange,
          onClose: this.handleCancelBookingStatus,
          onConfirm: this.handleConfirmBookingStatus,
          onNotesChange: this.handleNotesChange,
          open: bookingStatusModal,
          statusID: data.statusID,
          data: data
        }),
        _react2.default.createElement(_BookingTitle2.default, { isMobile: this.props.isMobile, data: data }),
        this.renderSoldCasePrompt(),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, textAlign: 'center' },
              _react2.default.createElement(
                _semanticUiReact.Header,
                { className: 'new_title', as: 'h5', attached: 'top' },
                t('Loan').toUpperCase()
              ),
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { attached: true },
                !data.buyerProfileID ? _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Divider,
                    { horizontal: true, id: 'loanBox' },
                    data.loanTrackerLeadCode && !_config2.default.get('mhubLoader') ? _react2.default.createElement(
                      'a',
                      {
                        href: _config2.default.get('loanTrackerURL') + '/deals/' + data.loanTrackerLeadCode + '/',
                        rel: 'noopener noreferrer',
                        target: _config2.default.get('server') === 'staging' ? '_self' : '_blank'
                      },
                      t('Refer To Mortgage Banker'),
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'linkify' })
                    ) : t('Refer To Mortgage Banker')
                  ),
                  oriData.statusID === 'sold_spa_signed' || oriData.statusID === 'cancelled_developer' || oriData.statusID === 'cancelled_availability' ? null : _react2.default.createElement(
                    'p',
                    null,
                    t('Help purchasers kickstart the loan application process in 3 easy steps'),
                    '.'
                  ),
                  data.loanTrackerLeadCode !== '' && data.bankCases.length > 0 ? _react2.default.createElement(
                    _semanticUiReact.Button,
                    {
                      compact: true,
                      icon: true,
                      onClick: this.handleGenerateBankerBookingForm,
                      size: 'small',
                      disabled: data.pdfFileKey !== '' && !((0, _momentTimezone2.default)(data.updatedAt) > (0, _momentTimezone2.default)(data.pdfLastSentAt)) || data.project.printType === ''
                    },
                    t(bbfLoading ? 'Generating Banker(s) Booking Form' : 'Share Booking Form to Banker(s)'),
                    ' ',
                    _react2.default.createElement(_semanticUiReact.Icon, { loading: bbfLoading, name: bbfLoading ? 'spinner' : 'external share' })
                  ) : '',
                  data.loanTrackerLeadCode !== '' && data.bankCases.length > 0 && data.pdfFileKey !== '' ? _react2.default.createElement(
                    'div',
                    { style: { marginBottom: '1.6em' } },
                    _react2.default.createElement(
                      'small',
                      null,
                      t('Last shared at'),
                      ' ',
                      _react2.default.createElement(_Timestamp2.default, { format: 'MMMM Do YYYY, h:mm a', timestamp: data.pdfLastSentAt })
                    )
                  ) : _react2.default.createElement('div', { style: { minHeight: '1.8em' } }),
                  _react2.default.createElement(_LoanTracker2.default, {
                    auth: this.props.auth,
                    project: data.project,
                    allBankCases: allBankCases,
                    bankCases: data.bankCases,
                    bankerSelectionTabs: data.project && data.project.bankerSelectionTabs ? data.project.bankerSelectionTabs : [],
                    bookingID: data.id,
                    bookingStatusID: oriData.statusID,
                    bookingSPAValue: data.spaValue,
                    consentTypeID: data.project ? data.project.loanTrackerProjectConsentTypeID : null,
                    disabled: oriData.statusID === 'sold_spa_signed' || oriData.statusID === 'cancelled_developer' || oriData.statusID === 'expired' || oriData.statusID === 'cancelled_availability',
                    hasDropCase: hasDropCase,
                    hasSuccessBankCase: successBankCase !== null,
                    isCashBuyer: data.paymentMethodID === 'cash',
                    isNotAuthorizedToInviteBanker: this.checkIsNotAuthorizedToInviteBanker(),
                    leadBankersLimit: data.project ? data.project.loanTrackerProjectLeadBankersLimit : 0,
                    leadStatus: data.leadStatus,
                    loanTrackerLeadCode: data.loanTrackerLeadCode,
                    loanTrackerLeadConsentPinCount: data.loanTrackerLeadConsentPinCount,
                    loanTrackerLeadConsentPinExpiresAt: data.loanTrackerLeadConsentPinExpiresAt,
                    loanTrackerLeadDropID: data.loanTrackerLeadDropID,
                    loanTrackerLeadID: data.loanTrackerLeadID,
                    location: this.props.location,
                    mobile: primaryCustomer ? primaryCustomer.mobile : null,
                    mobilePrefix: primaryCustomer ? primaryCustomer.mobilePrefix : null,
                    preferredName: primaryCustomer ? primaryCustomer.preferredName : null,
                    projectAssignBankCasesStatus: data.project ? data.project.autoAssignBankerStatus : '',
                    projectCurrencies: data.project ? data.project.projectCurrency : '',
                    projectID: data.projectID,
                    setLoading: this.setLoading,
                    token: this.props.token,
                    onBankerAssignmentSuccess: this.handleBankerAssignmentSuccess
                  })
                ) : null,
                _react2.default.createElement(_LeadActivity2.default, {
                  data: data.leadActivities,
                  bankCases: data.bankCases,
                  leadCode: data.loanTrackerLeadCode,
                  bookingID: data.id,
                  token: this.props.token,
                  fetchNewBooking: this.props.fetchNewBooking
                })
              )
            )
          ),
          this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled && _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, textAlign: 'center' },
              _react2.default.createElement(_Cases2.default, {
                bookingID: data.id,
                data: data,
                disabled: this.state.loading,
                loanTrackerProjectID: data.project ? data.project.loanTrackerProjectID : 0,
                purchasers: data.bookingCustomers,
                primaryPurchaser: primaryCustomer,
                setLoading: this.setLoading,
                successBankCase: successBankCase,
                isProjectHimsEnabled: data.project ? data.project.himsIsEnabled : false,
                token: this.props.token
              })
            )
          )
        )
      );
    }
  }]);

  return Tracker;
}(_react.Component);

Tracker.contextTypes = {
  store: _propTypes2.default.object
};
Tracker.propTypes = {
  token: _propTypes2.default.string,
  allBankCases: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  auth: _propTypes2.default.shape({
    companyBranch: _propTypes2.default.object,
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    creditCheckAccess: _propTypes2.default.bool,
    allowEditUnitPrice: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool
  }),
  onCheck: _propTypes2.default.func,
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      noeticIsEnabled: _propTypes2.default.bool,
      lawyerIsEnabled: _propTypes2.default.bool
    })
  }),
  fetchNewBooking: _propTypes2.default.func,
  hasDropCase: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }).isRequired,
  t: _propTypes2.default.func
};

Tracker.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

Tracker.getPropsToState = function (props) {
  var loading = props.loading;
  var data = Object.assign({}, _booking2.default, props.data);
  var allBankCases = [].concat(props.allBankCases);
  var hasDropCase = props.hasDropCase;
  data.isCancelPending = true;
  if (!data.bankCases) {
    data.bankCases = [];
  } else if (data.bankCases && data.bankCases.length > 0) {
    var soldCases = data.bankCases.filter(function (bankCase) {
      return bankCase.status === 'success_li_issued';
    });
    if (soldCases && soldCases.length > 0) {
      data.selectedBankCaseID = soldCases[0].id;
      data.bankName = soldCases[0].bank.name;
      data.bankerName = soldCases[0].banker.preferredName;
      data.loanAmount = parseInt(soldCases[0].loanAmount, 10);
    }
  }
  return {
    allBankCases: allBankCases,
    data: data,
    oriData: (0, _clone2.default)(data),
    hasDropCase: hasDropCase,
    loading: loading
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this3.setState({ loading: loading }, res);
    });
  };

  this.getPrimaryBookingCustomer = function (data) {
    if (data.bookingCustomers && data.bookingCustomers.length > 0) {
      var primaryCustomer = data.bookingCustomers.find(function (f) {
        return f.customerID === data.customerID;
      });
      if (primaryCustomer) {
        return primaryCustomer;
      }
    }
    return {};
  };

  this.getSuccessBankCase = function (data) {
    if (data.bankCases.length > 0) {
      var soldCase = data.bankCases.find(function (bankCase) {
        return bankCase.status === 'success_li_issued';
      });
      if (soldCase) {
        return soldCase;
      }
    }
    return null;
  };

  this.checkIsNotAuthorizedToInviteBanker = function () {
    var auth = _this3.props.auth;
    var data = _this3.state.data;
    // Not allowed to invite and role is not HQ nor Super Admin

    if (data && data.project && !data.project.allowAgentSalesTeamBankerInvitation && auth && !auth.isHeadquarters && !auth.isSuperAdmin) {
      return true;
    }
    return false;
  };

  this.bcfPRefix = function (v) {
    return 'bcf_' + v;
  };

  this.isCustomFieldRequiredAtStatus = function (field, statusID) {
    // Only applies to booking custom fields
    if (!field.isRequired) {
      return false;
    }

    // Status-based logic only applies to custom booking fields
    if (field.isDefault) {
      return field.isRequired;
    }

    // For CUSTOM booking fields: apply status-based logic
    var currentStatus = statusID || 'reserved';
    var requiredAtStatus = field.requiredAtStatus || 'reserved';

    // Define status hierarchy: reserved < booked < sold_spa_signed
    var statusHierarchy = {
      'reserved': 1,
      'booked': 2,
      'sold_spa_signed': 3
    };

    var currentLevel = statusHierarchy[currentStatus];
    var requiredLevel = statusHierarchy[requiredAtStatus];

    if (!currentLevel || !requiredLevel) {
      return false;
    }

    return currentLevel >= requiredLevel;
  };

  this.handleBookingStatusChange = function (event, value) {
    var _state3 = _this3.state,
        data = _state3.data,
        oriData = _state3.oriData;
    var t = _this3.props.t;

    var newStatusID = value.value;
    var projectBookingCustomFields = _this3.props.projectBookingCustomFields || [];

    if (projectBookingCustomFields && projectBookingCustomFields.length > 0) {
      var missingFields = [];

      projectBookingCustomFields.forEach(function (field) {
        // Status-based validation only applies to custom fields
        if (field.isDefault) {
          return;
        }

        if (_this3.isCustomFieldRequiredAtStatus(field, newStatusID)) {
          var fieldValue = data[_this3.bcfPRefix(field.name)];
          if (!fieldValue || fieldValue === '' || Array.isArray(fieldValue) && fieldValue.length === 0) {
            missingFields.push(field.label);
          }
        }
      });

      if (missingFields.length > 0) {
        var store = _this3.context.store;

        var fieldList = missingFields.join(', ');
        store.dispatch((0, _flash.flashErrorMessage)({
          header: t('Required Fields Missing', { ns: _translation.TRANSLATION_FILES.translation }),
          message: t('Please fill in all required fields before changing status: {{fields}}', { fields: fieldList, ns: _translation.TRANSLATION_FILES.translation })
        }));
        return;
      }
    }

    data[value.name] = value.value;
    if (data[value.name] !== oriData[value.name]) {
      _this3.setState({ data: data, bookingStatusModal: true });
    }
  };

  this.handleCancelBookingStatus = function () {
    var _state4 = _this3.state,
        data = _state4.data,
        oriData = _state4.oriData;

    data.statusID = oriData.statusID;
    data.remarkInternal = oriData.remarkInternal;
    _this3.setState({ data: data, bookingStatusModal: false });
  };

  this.handleCheckboxChange = function (event, _ref3) {
    var checked = _ref3.checked;
    var data = _this3.state.data;

    data.isCancelPending = checked;
    _this3.setState({ data: data });
  };

  this.handleConfirmBookingStatus = function () {
    var data = _this3.state.data;

    var booking = {
      statusID: data.statusID,
      newBookingNoteEncoded: data.newBookingNoteEncoded,
      selectedBankCaseID: data.selectedBankCaseID,
      bankName: data.bankName,
      bankerName: data.bankerName,
      loanAmount: data.loanAmount
    };
    if (data.statusID === 'sold_spa_signed' || data.statusID === 'cancelled_developer') {
      booking.isCancelPending = data.isCancelPending;
    }
    _this3.setState({ bookingStatusModal: false }, function () {
      _this3.updateBooking(booking, 'update');
    });
  };

  this.handleGenerateBankerBookingForm = function (e) {
    e.preventDefault();
    _this3.generateBankerBookingForm();
  };

  this.handleNotesChange = function (bnEncoded) {
    var data = _this3.state.data;

    data.newBookingNoteEncoded = bnEncoded;
    data.remarkInternal = '';
    _this3.setState({ data: data });
  };

  this.handleResetCheck = function (value, callback) {
    var state = _this3.state;
    if (state[value] === true) {
      state[value] = false;
      _this3.setState(_defineProperty({}, value, state[value]), function () {
        _this3.handleOnCheck(callback);
      });
    }
  };

  this.renderSoldCasePrompt = function () {
    var access = _this3.hasAccess(false, true, true, true, true);
    var oriData = _this3.state.oriData;
    var t = _this3.props.t;

    var soldCases = oriData.bankCases.filter(function (bankCase) {
      return bankCase.status === 'success_li_issued';
    });
    if (access && oriData.statusID !== 'sold_spa_signed' && oriData.statusID !== 'expired' && oriData.statusID !== 'cancelled_developer' && oriData.statusID !== 'cancelled_availability' && soldCases.length > 0) {
      var bankerName = soldCases[0].banker.preferredName;
      var bankName = soldCases[0].bank.name;
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Message,
              { warning: true },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 'equal', verticalAlign: 'middle' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 9, tablet: 12, computer: 12 },
                  _react2.default.createElement(
                    _reactI18next.Trans,
                    { ns: _translation.TRANSLATION_FILES.screens },
                    _react2.default.createElement(
                      'strong',
                      null,
                      { bankerName: bankerName }
                    ),
                    ' from ',
                    _react2.default.createElement(
                      'strong',
                      null,
                      { bankName: bankName }
                    ),
                    ' has updated Loan Status to ',
                    _react2.default.createElement(
                      'strong',
                      null,
                      'LO Signed'
                    ),
                    '.'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 7, tablet: 4, computer: 4, textAlign: 'right' },
                  _react2.default.createElement(_semanticUiReact.Button, {
                    size: 'small',
                    positive: true,
                    onClick: function onClick(e) {
                      return _this3.handleBookingStatusChange(e, { name: 'statusID', value: 'sold_spa_signed' });
                    },
                    content: t('Mark Sold')
                  })
                )
              )
            )
          )
        )
      );
    }
    return null;
  };

  this.refreshBankingData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var data, store, res, updatedData;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            data = _this3.state.data;

            if (!(data && data.id)) {
              _context3.next = 18;
              break;
            }

            _context3.prev = 2;
            _context3.next = 5;
            return _this3.setLoading(true);

          case 5:
            store = _this3.context.store;
            _context3.next = 8;
            return store.dispatch((0, _fetchM.fetchM)('/bookings/' + data.id + '/', {
              credentials: 'include',
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
                'X-Csrf-Token': _this3.props.token
              }
            }));

          case 8:
            res = _context3.sent;

            if (!res.ok) {
              _context3.next = 14;
              break;
            }

            _context3.next = 12;
            return res.json();

          case 12:
            updatedData = _context3.sent;

            _this3.setState({
              data: updatedData,
              oriData: (0, _clone2.default)(updatedData)
            });

          case 14:
            _context3.prev = 14;
            _context3.next = 17;
            return _this3.setLoading(false);

          case 17:
            return _context3.finish(14);

          case 18:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this3, [[2,, 14, 18]]);
  }));
  this.handleBankerAssignmentSuccess = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
    var data;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            data = _this3.state.data;

            if (!_this3.props.fetchNewBooking) {
              _context4.next = 4;
              break;
            }

            _context4.next = 4;
            return _this3.props.fetchNewBooking();

          case 4:
            if (data && data.project && data.project.autoShareFormToBanker) {
              _this3.generateBankerBookingForm(_this3.state.data.id);
            }

          case 5:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, _this3);
  }));
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Tracker.mapStateToProps)(Tracker));

/***/ }),
/* 2275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bookingUsesCurrentIdentityDocuments = exports.getCurrentBookingIdentityDocuments = undefined;

var _vietnam = __webpack_require__(40);

var identityLabel = function identityLabel(identityTypeID, side) {
  if (Number(identityTypeID) === 1) return side === 'front' ? 'CCCD Front' : 'CCCD Back';
  if (Number(identityTypeID) === 2) return 'Passport';
  if (Number(identityTypeID) === 4) return 'Enterprise Registration';
  return 'Identity Front';
};

var purchaserName = function purchaserName() {
  var bookingCustomer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var customer = bookingCustomer.customer || {};
  return bookingCustomer.preferredName || bookingCustomer.name || customer.preferredName || customer.name || customer.fullName || 'Purchaser';
};

var sidesFor = function sidesFor(bookingCustomer) {
  var customer = bookingCustomer.customer || {};
  return (0, _vietnam.idDocumentSides)(customer.identityTypeID, true) === 2 ? ['front', 'back'] : ['front'];
};

var unavailable = function unavailable(bookingCustomer, side, pending) {
  var customer = bookingCustomer.customer || {};
  var label = identityLabel(customer.identityTypeID, side);
  return {
    id: 'booking-current-' + bookingCustomer.customerID + '-' + side + '-' + (pending ? 'loading' : 'unavailable'),
    currentIdentityDocument: true,
    currentIdentityUnavailable: !pending,
    currentIdentityPending: pending,
    customerID: bookingCustomer.customerID,
    fileName: label + ' \u2014 ' + (pending ? 'loading' : 'unavailable'),
    fileType: 'identity',
    purchaserName: purchaserName(bookingCustomer),
    currentIdentityLabel: label
  };
};

var localDocument = function localDocument(bookingCustomer, side, bookApiURL) {
  var customer = bookingCustomer.customer || {};
  var document = side === 'front' ? customer.icFrontDocument : customer.icBackDocument;
  var documentID = side === 'front' ? customer.icFrontDocumentID : customer.icBackDocumentID;
  var label = identityLabel(customer.identityTypeID, side);
  if (!document || !document.key || document.id == null || String(document.id) !== String(documentID)) {
    return unavailable(bookingCustomer, side, false);
  }
  return {
    id: 'booking-current-' + bookingCustomer.customerID + '-' + side,
    currentIdentityDocument: true,
    customerID: bookingCustomer.customerID,
    identityURL: bookApiURL + '/customers/' + encodeURIComponent(customer.id) + '/documents/' + encodeURIComponent(document.id) + '/view/',
    fileName: document.name || label,
    fileType: 'identity',
    fileSizeBytes: document.size,
    createdAt: document.createdAt,
    purchaserName: purchaserName(bookingCustomer),
    currentIdentityLabel: label
  };
};

var sharedDocument = function sharedDocument(booking, bookingCustomer, side, info, bookApiURL) {
  var customer = bookingCustomer.customer || {};
  var metadata = info[side];
  var label = identityLabel(customer.identityTypeID, side);
  if (!metadata || !metadata.available || !metadata.version) {
    return unavailable(bookingCustomer, side, false);
  }
  var path = '/bookings/' + encodeURIComponent(booking.id) + '/customers/' + encodeURIComponent(bookingCustomer.customerID) + '/crm_identity/' + side + '/?v=' + encodeURIComponent(metadata.version);
  return {
    id: 'booking-current-' + bookingCustomer.customerID + '-' + side + '-' + metadata.version,
    currentIdentityDocument: true,
    customerID: bookingCustomer.customerID,
    identityURL: '' + bookApiURL + path,
    fileName: metadata.name || label,
    fileType: 'identity',
    fileSizeBytes: metadata.fileSizeBytes,
    createdAt: metadata.createdAt,
    uploaderName: metadata.uploaderName,
    purchaserName: purchaserName(bookingCustomer),
    currentIdentityLabel: label
  };
};

// Bookings Documents follows the Purchaser tab: a CRM-linked purchaser uses the versioned
// crm_identity endpoints; an unlinked purchaser uses its current local document pointer.
var getCurrentBookingIdentityDocuments = exports.getCurrentBookingIdentityDocuments = function getCurrentBookingIdentityDocuments(booking, identities, loading, bookApiURL) {
  if (!booking || !Array.isArray(booking.bookingCustomers)) return [];
  return booking.bookingCustomers.reduce(function (rows, bookingCustomer) {
    if (!bookingCustomer || !bookingCustomer.customerID || !bookingCustomer.customer) return rows;
    var info = identities && identities[bookingCustomer.customerID];
    sidesFor(bookingCustomer).forEach(function (side) {
      if (!booking.purchasersIsolated) rows.push(localDocument(bookingCustomer, side, bookApiURL));else if (!info && loading) rows.push(unavailable(bookingCustomer, side, true));else if (info && info.status === 'shared') rows.push(sharedDocument(booking, bookingCustomer, side, info, bookApiURL));else if (info && info.status !== 'error') rows.push(localDocument(bookingCustomer, side, bookApiURL));else rows.push(unavailable(bookingCustomer, side, false));
    });
    return rows;
  }, []);
};

var bookingUsesCurrentIdentityDocuments = exports.bookingUsesCurrentIdentityDocuments = function bookingUsesCurrentIdentityDocuments(booking) {
  return !!booking;
};

/***/ }),
/* 2276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Overview = __webpack_require__(2271);

var _Overview2 = _interopRequireDefault(_Overview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Overview2.default;

/***/ }),
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _BookingPayment = __webpack_require__(1051);

var _BookingPayment2 = _interopRequireDefault(_BookingPayment);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _routes = __webpack_require__(403);

var _BookingSteppers = __webpack_require__(557);

var _BookingSteppers2 = _interopRequireDefault(_BookingSteppers);

var _prompt = __webpack_require__(66);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isPRS = _config2.default.get('prs');

var Payment = function (_Component) {
  _inherits(Payment, _Component);

  function Payment(props) {
    _classCallCheck(this, Payment);

    var _this = _possibleConstructorReturn(this, (Payment.__proto__ || Object.getPrototypeOf(Payment)).call(this, props));

    _initialiseProps.call(_this);

    var state = Payment.getPropsToState(props);
    _this.state = _extends({}, state, {
      systemData: [],
      isPaymentRequired: false
    });
    _this.validation = {};
    return _this;
  }

  _createClass(Payment, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!isPRS) {
        this.fetchSystemSettings();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Payment.getPropsToState(nextProps);
      // don't allow state to override data if oriData is same
      if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
        state.data = this.state.data;
      }
      if (JSON.stringify(this.state.data) !== JSON.stringify(state.data) && !isPRS) {
        var data = state.data;
        if (data) {
          this.checkIsPaymentRequired(this.state.systemData, data);
        }
      }
      this.setState(_extends({}, state));
    }
  }, {
    key: 'checkBeforeLeave',
    value: function checkBeforeLeave() {
      var _this2 = this;

      var isUnpaid = this.state.data && this.state.data.paymentStatusID && this.state.data.paymentStatusID === 'unpaid';

      this.context.router.setRouteLeaveHook(this.props.route, function (nextLocation) {
        if (_this2.state.isPaymentRequired && isUnpaid) {
          var store = _this2.context.store;

          var callback = function callback() {
            _this2.setState({ isPaymentRequired: false }, function () {
              if (_this2.state.data && _this2.state.data.project && _this2.state.data.project.loanTrackerDirectShow && nextLocation.pathname.includes(_this2.state.data.id) && !nextLocation.pathname.includes('loan')) {
                var redirectLocation = nextLocation;
                redirectLocation.pathname = nextLocation.pathname + 'loan/';
                store.dispatch((0, _prompt.promptChangesLeave)(redirectLocation));
              } else {
                store.dispatch((0, _prompt.promptChangesLeave)(nextLocation));
              }
            });
          };
          var header = 'Add Payment';
          var message = 'Payment step is compulsory, your booking will be auto released. Do you still want to leave?';
          store.dispatch((0, _prompt.promptChangesMessage)({ header: header, callback: callback, message: message }));
          return false;
        }
        return true;
      });
    }
  }, {
    key: 'fetchSystemSettings',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var store, res, message, systemData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setState({ loading: true });

              case 2:
                store = this.context.store;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/settings/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context.next = 17;
                return this.setState({ loading: false });

              case 17:
                return _context.abrupt('return');

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 31;
                break;

              case 26:
                _context.next = 28;
                return res.json();

              case 28:
                systemData = _context.sent;
                _context.next = 31;
                return this.setState({
                  systemData: systemData
                }, function () {
                  return _this3.checkIsPaymentRequired(systemData, _this3.state.data);
                });

              case 31:
                _context.next = 33;
                return this.setState({ loading: false });

              case 33:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchSystemSettings() {
        return _ref.apply(this, arguments);
      }

      return fetchSystemSettings;
    }()
  }, {
    key: 'updateBooking',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(booking) {
        var xid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state.data.id;
        var store, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _context2.prev = 3;
                _context2.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + xid + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(booking)
                }));

              case 6:
                _context2.next = 21;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](3);
                _context2.next = 12;
                return this.setLoading(false);

              case 12:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 18;
                  break;
                }

                _context2.next = 15;
                return _context2.t0.res.text();

              case 15:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 18:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context2.abrupt('return');

              case 21:
                this.props.fetchNewBooking();
                _context2.next = 24;
                return this.setLoading(false);

              case 24:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Update Success', message: 'Booking payment successfully updated.' }));

              case 25:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 8]]);
      }));

      function updateBooking(_x) {
        return _ref2.apply(this, arguments);
      }

      return updateBooking;
    }()
  }, {
    key: 'render',
    value: function render() {
      var data = this.state.data;

      var projectUnit = data.projectUnit;
      var project = data.project;
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              'Loading'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, textAlign: 'center' },
              _react2.default.createElement(
                _semanticUiReact.Header,
                { as: 'h4', textAlign: 'center', style: { marginTop: '1em' } },
                'Booking for ',
                _react2.default.createElement('br', { className: 'large-hide small-hide tablet-hide' }),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/projects/' + (project && project.id) + '/units/' + (projectUnit && projectUnit.id) + '/' },
                  projectUnit && projectUnit.reference
                ),
                ', ',
                project && project.name,
                ' ',
                projectUnit && projectUnit.isBumi && _react2.default.createElement(
                  _semanticUiReact.Label,
                  { size: 'mini' },
                  'Bumi'
                )
              ),
              project && (project.paymentFlow || project.loanTrackerDirectShow) ? _react2.default.createElement(_BookingSteppers2.default, {
                step: 2,
                totalSteps: project.paymentFlow && project.loanTrackerDirectShow ? 3 : 2,
                lastStepLabel: project.paymentFlow && !project.loanTrackerDirectShow ? 'Payment' : 'Mortgage'
              }) : '',
              data.paymentStatusID !== 'paid' && isPRS && _react2.default.createElement(
                _semanticUiReact.Message,
                { warning: true },
                'Please fill in all payment details including cheque/bank draft proof of attachment. If information is incomplete, your reservation will be auto-released in 10 minutes.'
              ),
              _react2.default.createElement(_BookingPayment2.default, {
                token: this.props.token,
                fetchNewBooking: this.props.fetchNewBooking,
                updateBookingPayment: this.handleUpdatePayment,
                data: data || {},
                defaultBookingFeeAmount: project && project.defaultBookingFeeAmount
              }),
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  positive: true,
                  size: 'large',
                  onClick: this.handleOnSave,
                  style: { marginBottom: '0.5em', marginTop: '1em' },
                  disabled: isPRS && data.paymentStatusID !== 'paid' || false
                },
                'Save and Continue'
              ),
              !isPRS && this.state.isPaymentRequired && data.paymentStatusID === 'paid' ? '' : _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: (0, _routes.bookingFlow)(data, 2) },
                  'Skip this step'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Payment;
}(_react.Component);

Payment.contextTypes = {
  store: _propTypes2.default.object,
  router: _propTypes2.default.object
};
Payment.propTypes = {
  route: _propTypes2.default.shape({}),
  token: _propTypes2.default.string,
  fetchNewBooking: _propTypes2.default.func
};
Payment.defaultData = {
  id: '',
  bookingFeePayments: [],
  paymentStatusID: ''
};

Payment.mapStateToProps = function () {
  return {};
};

Payment.getPropsToState = function (props) {
  var loading = props.loading;
  var data = Object.assign({}, Payment.defaultData, props.data);
  return {
    loading: loading,
    data: data,
    oriData: (0, _clone2.default)(data)
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this4.setState({ loading: loading }, res);
    });
  };

  this.checkIsPaymentRequired = function (systemData, data) {
    var isPRequired = false;
    if (systemData && data) {
      var project = data.project;

      var systemARenabled = systemData && systemData.arBookingExpIsEnabled;
      var systemTimerSet = systemData && systemData.arBookingExpMoreThanMinutes !== '' && systemData.arBookingExpMoreThanMinutes !== '0';
      var systemPaymentRequired = systemData.arBookingExpUnpaidIsEnabled;

      var projectARenabled = project && project.arBookingExpIsEnabled;
      var projectPaymentRequired = project && project.arBookingExpMoreThanMinutes !== '' && project.arBookingExpMoreThanMinutes !== '0' && project.arBookingExpUnpaidIsEnabled;

      if (systemARenabled) {
        if (systemTimerSet && systemPaymentRequired) {
          isPRequired = true;
        } else if (!systemTimerSet && projectARenabled && projectPaymentRequired) {
          isPRequired = true;
        } else {
          isPRequired = false;
        }
      } else {
        isPRequired = false;
      }

      _this4.setState({ isPaymentRequired: isPRequired }, function () {
        return _this4.checkBeforeLeave();
      });
    }
  };

  this.handleUpdatePayment = function (payment) {
    _this4.updateBooking(payment);
  };

  this.handleOnSave = function (e) {
    e.preventDefault();
    var store = _this4.context.store;
    var data = _this4.state.data;

    store.dispatch((0, _reactRouterRedux.push)((0, _routes.bookingFlow)(data, 2)));
  };
};

exports.default = (0, _reactRedux.connect)(Payment.mapStateToProps)(Payment);

/***/ }),
/* 2278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(13);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _semanticUiReact = __webpack_require__(2);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

var _navigations = __webpack_require__(1052);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _UCBookingSelectListMultiple = __webpack_require__(578);

var _UCBookingSelectList = __webpack_require__(577);

var _lawyerCaseStatuses = __webpack_require__(142);

var _url = __webpack_require__(19);

var _UCSearchIn = __webpack_require__(579);

var _UCSearchIn2 = _interopRequireDefault(_UCSearchIn);

var _bankCaseStatuses = __webpack_require__(264);

var _bankCaseStatuses2 = _interopRequireDefault(_bankCaseStatuses);

var _UCBookingDatePicker = __webpack_require__(576);

var _UCBookingDatePicker2 = _interopRequireDefault(_UCBookingDatePicker);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _UCBStatusFlag = __webpack_require__(389);

var _UCBStatusFlag2 = _interopRequireDefault(_UCBStatusFlag);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _flash = __webpack_require__(5);

var _download = __webpack_require__(361);

var _download2 = _interopRequireDefault(_download);

var _sort = __webpack_require__(765);

var _sort2 = _interopRequireDefault(_sort);

var _UCSortButton = __webpack_require__(580);

var _UCSortButton2 = _interopRequireDefault(_UCSortButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var allFilterNames = ['search', 'bookingStatusMulti', 'dateRange', 'dateFrom', 'dateTo', 'approvedDateRange', 'approvedDateFrom', 'approvedDateTo', 'filteredProjects', 'loanStatus', 'spaLawyerStatus', 'laLawyerStatus'];

var UnitProgress = function (_Component) {
  _inherits(UnitProgress, _Component);

  function UnitProgress(props) {
    _classCallCheck(this, UnitProgress);

    var _this = _possibleConstructorReturn(this, (UnitProgress.__proto__ || Object.getPrototypeOf(UnitProgress)).call(this, props));

    _initialiseProps.call(_this);

    var state = UnitProgress.getPropsToState(props);
    _this.state = _extends({
      loading: true,
      activeAccordionIndex: -1,
      count: 0,
      filteredProjects: [],
      isComputer: window.innerWidth > 992,
      isMobile: window.innerWidth <= 590,
      isTablet: window.innerWidth > 590 && window.innerWidth <= 992,
      limit: 0,
      loadingProjectSearch: false,
      offset: 0,
      projectOpts: [],
      unitProgress: []
    }, state);
    return _this;
  }

  _createClass(UnitProgress, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
      this.fetchProjects();
      this.fetchUnitProgress((0, _url.decodeSearch)(this.props.location.search));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = UnitProgress.getPropsToState(nextProps);
      this.setState(state);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'handleAccordionClick',
    value: function handleAccordionClick(e, valIndex) {
      var index = valIndex.index;

      this.setState(function (prevState) {
        return {
          activeAccordionIndex: prevState.activeAccordionIndex === index ? -1 : index
        };
      });
    }
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var fetch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var store = this.context.store;
      var _props$location = this.props.location,
          pathname = _props$location.pathname,
          search = _props$location.search;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      var bookingStatus = (0, _url.decodeSearch)(search).bookingStatus;
      var bookingStatusMulti = (0, _url.decodeSearch)(search).bookingStatusMulti;
      var loanStatus = (0, _url.decodeSearch)(search).loanStatus;
      var spaLawyerStatus = (0, _url.decodeSearch)(search).spaLawyerStatus;
      var laLawyerStatus = (0, _url.decodeSearch)(search).laLawyerStatus;
      if (query.bookingStatus && !bookingStatus || query.bookingStatusMulti && !bookingStatusMulti || query.loanStatus && !loanStatus || query.spaLawyerStatus && !spaLawyerStatus || query.laLawyerStatus && !laLawyerStatus) {
        queryNew.page = 1;
      }
      if (fetch) {
        this.fetchUnitProgress(queryNew);
      }
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));
    }
  }, {
    key: 'exportURL',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(fileType) {
        var primary = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var detailed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        var location, _state, filteredProjects, projectFilter, url;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                location = this.props.location;
                _state = this.state, filteredProjects = _state.filteredProjects, projectFilter = _state.projectFilter;
                url = _config2.default.get('bookApiURL') + '/reports/bookings/';

                if (location && location.search) {
                  url += '' + location.search;
                }
                if (filteredProjects && filteredProjects.length > 0) {
                  url += '&projectFilter=' + projectFilter;
                }
                if (primary) {
                  url += '&primaryOnly=true';
                }
                url += '&fileType=' + fileType;
                if (detailed) {
                  url += '&detailed=true';
                }
                return _context.abrupt('return', url);

              case 9:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function exportURL(_x3) {
        return _ref.apply(this, arguments);
      }

      return exportURL;
    }()
  }, {
    key: 'fetchProjects',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, t, query, res, message, _message, data, projectOpts;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({
                  limit: 0,
                  showAsOptions: false
                });

                this.setState({ loadingProjectSearch: true });
                res = void 0;
                _context2.prev = 5;
                _context2.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context2.sent;
                _context2.next = 21;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](5);

                if (!(_context2.t0.res && _context2.t0.res.status >= 399 && _context2.t0.res.status < 500)) {
                  _context2.next = 18;
                  break;
                }

                _context2.next = 16;
                return _context2.t0.res.text();

              case 16:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 18:
                this.setState({ loadingProjectSearch: false });
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context2.abrupt('return');

              case 21:
                if (res.ok) {
                  _context2.next = 29;
                  break;
                }

                _context2.next = 24;
                return res.text();

              case 24:
                _message = _context2.sent;
                _context2.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 27:
                _context2.next = 35;
                break;

              case 29:
                _context2.next = 31;
                return res.json();

              case 31:
                data = _context2.sent;
                projectOpts = [];

                if (data && data.length > 0) {
                  projectOpts = data.map(function (d) {
                    return { value: d.id, text: d.name };
                  });
                }
                this.setState({ projectOpts: projectOpts });

              case 35:
                this.setState({ loadingProjectSearch: false });

              case 36:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 11]]);
      }));

      function fetchProjects() {
        return _ref2.apply(this, arguments);
      }

      return fetchProjects;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          auth = _props.auth,
          t = _props.t,
          location = _props.location;
      var _state2 = this.state,
          loading = _state2.loading,
          unitProgress = _state2.unitProgress,
          menuIsTab = _state2.menuIsTab,
          isComputer = _state2.isComputer;
      var pathname = location.pathname;

      var links = (0, _navigations.routes)(auth.company.countryCode).map(function (l) {
        return _extends({}, l, {
          text: t(l.text)
        });
      });
      var exportItems = [{
        text: 'Excel',
        icon: 'download',
        onClick: function () {
          var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
            var store, exportQuery, res, message, blob, contentDisposition, filename, filenameMatch, url, downloadLink;
            return regeneratorRuntime.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    store = _this2.context.store;
                    exportQuery = (0, _url.decodeSearch)(location.search);

                    exportQuery.page = 'all';
                    _this2.setState({ loading: true });
                    _context3.prev = 4;
                    _context3.next = 7;
                    return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/bookings/export/unit_progress/?' + (0, _url.encodeSearch)(exportQuery), {
                      credentials: 'include',
                      method: 'GET',
                      headers: {
                        'Content-Type': 'application/json'
                      }
                    }));

                  case 7:
                    res = _context3.sent;

                    if (res.ok) {
                      _context3.next = 15;
                      break;
                    }

                    _context3.next = 11;
                    return res.text();

                  case 11:
                    message = _context3.sent;
                    _context3.next = 14;
                    return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

                  case 14:
                    return _context3.abrupt('return');

                  case 15:
                    _context3.next = 17;
                    return res.blob();

                  case 17:
                    blob = _context3.sent;
                    contentDisposition = res.headers.get('Content-Disposition');
                    filename = 'MHub_Unit_Progress.xlsx';


                    if (contentDisposition) {
                      filenameMatch = contentDisposition.match(/filename\*=UTF-8''([^;,\n\r]+)/);

                      if (!filenameMatch) {
                        filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
                      }
                      if (!filenameMatch) {
                        filenameMatch = contentDisposition.match(/filename=([^;,\n\r]+)/);
                      }
                      if (filenameMatch && filenameMatch[1]) {
                        filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''));
                      }
                    }

                    url = window.URL.createObjectURL(blob);
                    downloadLink = document.createElement('a');

                    downloadLink.href = url;
                    downloadLink.download = filename;
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    downloadLink.remove();
                    window.URL.revokeObjectURL(url);
                    _context3.next = 35;
                    break;

                  case 31:
                    _context3.prev = 31;
                    _context3.t0 = _context3['catch'](4);
                    _context3.next = 35;
                    return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

                  case 35:
                    _context3.prev = 35;

                    _this2.setState({ loading: false });
                    return _context3.finish(35);

                  case 38:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _callee3, _this2, [[4, 31, 35, 38]]);
          }));

          return function onClick() {
            return _ref3.apply(this, arguments);
          };
        }()
      }];
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: link.text,
              content: link.text,
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this2.handleMenu(e, link);
              }
            });
          })
          // rightNav={this.hasAccess() ? (
          //   <Dropdown item text={t('Manage')}>
          //     <Dropdown.Menu>
          //       <Dropdown.Item onClick={this.handleManageClick} value="manage/">{t('Manage Pending Status')}</Dropdown.Item>
          //       {this.himsIsEnabled() && <Dropdown.Item onClick={this.handleManageClick} value="hims/">HIMS Booking Sync</Dropdown.Item>}
          //     </Dropdown.Menu>
          //   </Dropdown>
          //   ) : null
          // }
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', className: 'booking-list' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              this.renderMenuTool()
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                {
                  inverted: true, style: { zIndex: 20 },
                  active: loading && unitProgress.length > 0
                },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { mobile: 10, tablet: 6, computer: 6, verticalAlign: 'middle' },
                    _react2.default.createElement(
                      _semanticUiReact.Header,
                      { as: 'h3' },
                      t('Latest Unit Progress', { ns: _translation.TRANSLATION_FILES.translation })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { mobile: 6, tablet: 10, computer: 10 },
                    _react2.default.createElement(
                      'div',
                      { style: { display: 'flex', justifyContent: 'end', alignItems: 'center' } },
                      exportItems.length > 0 && _react2.default.createElement(_semanticUiReact.Popup, {
                        size: 'tiny',
                        style: { backgroundColor: '#596975' },
                        basic: true,
                        inverted: true,
                        disabled: !isComputer,
                        content: t('Download', { ns: _translation.TRANSLATION_FILES.translation }),
                        position: 'bottom center',
                        trigger: _react2.default.createElement(
                          'div',
                          null,
                          _react2.default.createElement(_UCSortButton2.default, {
                            floated: 'right',
                            icon: _react2.default.createElement(
                              'div',
                              {
                                style: {
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  borderRadius: '50%',
                                  padding: '11px',
                                  transition: 'background-color 0.2s ease',
                                  cursor: 'pointer'
                                },
                                onMouseEnter: function onMouseEnter(e) {
                                  return e.currentTarget.style.backgroundColor = '#f4f5f7';
                                },
                                onMouseLeave: function onMouseLeave(e) {
                                  return e.currentTarget.style.backgroundColor = 'transparent';
                                }
                              },
                              _react2.default.createElement('img', { src: _download2.default, width: 20, alt: 'download' })
                            ),
                            loading: loading,
                            items: exportItems
                          })
                        )
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    _react2.default.createElement(
                      'div',
                      { style: { overflowX: 'auto' } },
                      _react2.default.createElement(
                        _semanticUiReact.Table,
                        { className: 'uc-table uc-booking-list-table', basic: 'very', sortable: true },
                        this.renderTableHeaders(),
                        _react2.default.createElement(
                          _semanticUiReact.Table.Body,
                          null,
                          unitProgress.length > 0 ? unitProgress.map(this.renderTableRow) : _react2.default.createElement(
                            _semanticUiReact.Table.Row,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              { colSpan: 10, textAlign: 'center' },
                              loading ? _react2.default.createElement(
                                _semanticUiReact.Loader,
                                { active: true, inline: 'centered' },
                                t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                              ) : _react2.default.createElement(
                                'p',
                                null,
                                t('No unit progress found', { ns: _translation.TRANSLATION_FILES.translation }),
                                '.'
                              )
                            )
                          )
                        )
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              _react2.default.createElement(_PageNav2.default, {
                upward: true,
                currentPage: this.state.currentPage,
                count: this.state.count,
                limit: this.state.limit,
                offset: this.state.offset,
                dataSize: unitProgress.length,
                loading: loading,
                onChange: this.handleChangePage
                // noScrollTop={this.props.noScrollTop}
              })
            )
          )
        )
      );
    }
  }]);

  return UnitProgress;
}(_react.Component);

UnitProgress.propTypes = {
  auth: _propTypes2.default.shape({
    isDeveloperSupervisor: _propTypes2.default.bool,
    isDeveloperSalesManager: _propTypes2.default.bool,
    isDeveloperSalesAdmin: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isAdmin: _propTypes2.default.bool
  }),
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
UnitProgress.contextTypes = {
  store: _propTypes2.default.object
};

UnitProgress.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

UnitProgress.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var menuIsTab = window.innerWidth <= 590;
  var currentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var dateRange = query.dateRange || '';
  var dateFrom = query.dateFrom || '';
  var dateTo = query.dateTo || '';
  var approvedDateRange = query.approvedDateRange || '';
  var approvedDateFrom = query.approvedDateFrom || '';
  var approvedDateTo = query.approvedDateTo || '';
  var loanStatus = query.loanStatus || [];
  var spaLawyerStatus = query.spaLawyerStatus || '';
  var laLawyerStatus = query.laLawyerStatus || '';
  var filteredProjects = [];
  if (query.projectFilter) {
    try {
      var decoded = atob(query.projectFilter);
      filteredProjects = decoded ? decoded.split(',').filter(Boolean) : [];
    } catch (e) {
      filteredProjects = [];
    }
  }
  return {
    menuIsTab: menuIsTab,
    currentPage: currentPage,
    search: search,
    dateRange: dateRange,
    dateFrom: dateFrom,
    dateTo: dateTo,
    approvedDateRange: approvedDateRange,
    approvedDateFrom: approvedDateFrom,
    approvedDateTo: approvedDateTo,
    loanStatus: loanStatus,
    spaLawyerStatus: spaLawyerStatus,
    laLawyerStatus: laLawyerStatus,
    filteredProjects: filteredProjects
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getAllFilterNames = function () {
    var removeBookingStatus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (removeBookingStatus) return allFilterNames.filter(function (fn) {
      return fn !== 'bookingStatusMulti';
    });
    return allFilterNames;
  };

  this.getRowClassName = function (statusID) {
    if (statusID === 'cancelled_availability') {
      return 'row-colors booking_row_cancelled_availability';
    }
    if (statusID === 'cancelled_developer' || statusID === _lawyerCaseStatuses.DEVELOPER_CANCELLED) {
      return 'row-colors booking_row_cancelled_developer';
    }
    return 'row-colors';
  };

  this.setLoading = function (loading) {
    _this3.setState({ loading: loading });
  };

  this.handleResize = function () {
    var state = {};
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this3.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    _this3.setState(_extends({}, state));
  };

  this.handleMenu = function (e, _ref4) {
    var value = _ref4.value;
    var store = _this3.context.store;

    store.dispatch((0, _reactRouterRedux.replace)(value));
  };

  this.handleFilterProjects = function (e, _ref5) {
    var name = _ref5.name,
        value = _ref5.value;

    // eslint-disable-next-line no-nested-ternary
    var filteredProjects = Array.isArray(value) ? value : value ? [value] : [];
    _this3.setState({ filteredProjects: filteredProjects }, function () {
      var query = (0, _url.decodeSearch)(_this3.props.location.search);
      if (filteredProjects.length > 0) {
        query[name] = btoa(filteredProjects.join(','));
      } else {
        delete query[name];
      }
      _this3.replaceQuery(query, true);
    });
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this3.props.location.search);
    query.page = currentPage;
    _this3.setState({ currentPage: currentPage }, function () {
      _this3.replaceQuery(query);
    });
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this3.props.location.search);
    query[queryName] = value;
    if (queryName === 'search') {
      delete query.searchIn;
    }
    if (queryName === 'loanStatus') {
      delete query.sortColumn;
      delete query.sortDirection;
    }
    // Most filter changes should fetch immediately; only custom ranges wait for both dates.
    var refetch = true;
    if (queryName === 'dateRange' && query.dateRange === 'custom' && (!query.dateFrom || !query.dateTo)) {
      refetch = false;
    }
    if (queryName === 'approvedDateRange' && query.approvedDateRange === 'custom' && (!query.approvedDateFrom || !query.approvedDateTo)) {
      refetch = false;
    }
    _this3.replaceQuery(query, true, refetch);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var clearSearch = false;
    var query = (0, _url.decodeSearch)(_this3.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (filter === 'search') {
        clearSearch = true;
      }
      if (filter === 'loanStatus') {
        delete query.sortColumn;
        delete query.sortDirection;
      }
      if (filter === 'filteredProjects') {
        delete query.projectCode;
        delete query.projectFilter;
        hasQuery = true;
        _this3.setState({
          filteredProjects: [],
          isChanging: false
        });
      }
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
        _this3.setState({ isChanging: false });
      }
    });
    var cb = function cb() {
      if (hasQuery) {
        _this3.replaceQuery(query, true);
      }
    };
    if (clearSearch) {
      delete query.searchIn;
      _this3.setState({ search: '' }, function () {
        cb();
      });
    } else {
      cb();
    }
  };

  this.handleSetDateRange = function (name, from, to) {
    var query = (0, _url.decodeSearch)(_this3.props.location.search);
    switch (name) {
      case 'dateRange':
        query.dateFrom = from;
        query.dateTo = to;
        break;
      case 'approvedDateRange':
        query.approvedDateFrom = from;
        query.approvedDateTo = to;
        break;
      default:
        break;
    }
    _this3.replaceQuery(query, true);
  };

  this.handleReplaceStatus = function () {
    var status = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    var query = (0, _url.decodeSearch)(_this3.props.location.search);
    if (status !== '') {
      query.bookingStatus = status;
    } else {
      delete query.bookingStatus;
    }
    _this3.replaceQuery(query);
  };

  this.fetchUnitProgress = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(query) {
      var store, res, unitProgress;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              store = _this3.context.store;

              _this3.setLoading(true);
              _context4.prev = 2;
              _context4.next = 5;
              return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/bookings/unit_progress/?' + (0, _url.encodeSearch)(query), {
                credentials: 'include',
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }));

            case 5:
              res = _context4.sent;

              if (!res.ok) {
                _context4.next = 11;
                break;
              }

              _context4.next = 9;
              return res.json();

            case 9:
              unitProgress = _context4.sent;

              _this3.setState({ unitProgress: unitProgress });

            case 11:
              _context4.next = 15;
              break;

            case 13:
              _context4.prev = 13;
              _context4.t0 = _context4['catch'](2);

            case 15:
              _context4.prev = 15;

              _this3.setLoading(false);
              return _context4.finish(15);

            case 18:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this3, [[2, 13, 15, 18]]);
    }));

    return function (_x8) {
      return _ref6.apply(this, arguments);
    };
  }();

  this.renderStatusDateFilter = function () {
    var t = _this3.props.t;
    var _state3 = _this3.state,
        bookingStatus = _state3.bookingStatus,
        loading = _state3.loading,
        isMobile = _state3.isMobile;

    var filter = '';
    var filterFrom = '';
    var filterTo = '';
    var headerText = '';
    switch (bookingStatus) {
      case 'cancelled_developer':
        filter = 'cancelledDateRange';
        filterFrom = 'cancelledDateFrom';
        filterTo = 'cancelledDateTo';
        headerText = 'Cancelled Date Range';
        break;
      case 'expired':
        filter = 'expiredDateRange';
        filterFrom = 'expiredDateFrom';
        filterTo = 'expiredDateTo';
        headerText = 'Expired Date Range';
        break;
      case 'booked':
        filter = 'bookedDateRange';
        filterFrom = 'bookedDateFrom';
        filterTo = 'bookedDateTo';
        headerText = 'Booked Date Range';
        break;
      case 'sold_spa_signed':
        filter = 'soldDateRange';
        filterFrom = 'soldDateFrom';
        filterTo = 'soldDateTo';
        headerText = 'Sold Date Range';
        break;
      default:
        break;
    }
    return filter && _react2.default.createElement(
      _semanticUiReact.Grid.Column,
      {
        className: 'filter tight-column',
        mobile: 16,
        tablet: 5,
        computer: 5,
        style: { paddingBottom: isMobile ? '1rem' : '0rem' }
      },
      _react2.default.createElement(_UCBookingDatePicker2.default, {
        filterName: filter,
        filterNameFrom: filterFrom,
        filterNameTo: filterTo,
        headerText: t(headerText, { ns: _translation.TRANSLATION_FILES.screens }),
        placeholder: t('Select ' + headerText, { ns: _translation.TRANSLATION_FILES.screens }),
        dateFrom: _this3.state[filterFrom],
        dateTo: _this3.state[filterTo],
        onChange: _this3.handleFilterOnChange,
        onClose: _this3.handleClearFilter,
        onResetRange: _this3.handleClearFilter,
        onSetRange: function onSetRange(from, to) {
          return _this3.handleSetDateRange(filter, from, to);
        },
        value: _this3.state[filter],
        disabled: loading,
        label: t(headerText, { ns: _translation.TRANSLATION_FILES.screens })
      })
    );
  };

  this.renderDefaultClearFilter = function () {
    var _state4 = _this3.state,
        isMobile = _state4.isMobile,
        search = _state4.search;
    var t = _this3.props.t;

    return (_this3.getAllFilterNames(false).some(function (filterName) {
      return _this3.state[filterName] && _this3.state[filterName].length > 0;
    }) || search.length > 0) && _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { style: { paddingBottom: '0rem', paddingTop: isMobile ? '0rem' : '1rem' } },
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        {
          verticalAlign: 'middle'
        },
        _react2.default.createElement(_semanticUiReact.Button, {
          className: 'uc-clear-button',
          content: t('Clear all', { ns: _translation.TRANSLATION_FILES.translation }),
          onClick: function onClick() {
            return _this3.handleClearFilter.apply(_this3, _toConsumableArray(_this3.getAllFilterNames(false)));
          }
        })
      )
    );
  };

  this.renderAccordionDefaultView = function () {
    var t = _this3.props.t;
    var _state5 = _this3.state,
        loading = _state5.loading,
        loadingProjectSearch = _state5.loadingProjectSearch,
        activeAccordionIndex = _state5.activeAccordionIndex,
        isTablet = _state5.isTablet,
        isMobile = _state5.isMobile;


    return _react2.default.createElement(
      _semanticUiReact.Accordion,
      { fluid: true, className: 'uc-accordion shadow-border', style: { paddingBottom: !isMobile && activeAccordionIndex !== 0 ? '1.5rem' : '0.5rem' } },
      _react2.default.createElement(
        _semanticUiReact.Accordion.Title,
        {
          style: { paddingBottom: '1rem' },
          active: activeAccordionIndex === 0,
          index: 0
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 'equal', style: { paddingBottom: activeAccordionIndex === 0 ? '1rem' : '0rem' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'tight-column',
                tablet: 5,
                computer: 5
              },
              _react2.default.createElement(_UCSearchIn2.default, {
                isLoading: loading,
                onChange: _this3.handleFilterOnChange,
                onClear: _this3.handleClearFilter,
                search: _this3.state.search,
                label: t('Keywords', { ns: _translation.TRANSLATION_FILES.screens }),
                isFullSize: true
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter tight-column',
                tablet: 5,
                computer: 5
              },
              _react2.default.createElement(
                'div',
                { className: 'field' },
                _react2.default.createElement(
                  'label',
                  {
                    className: 'ui',
                    htmlFor: 'projectFilter',
                    style: { fontWeight: 'bold', margin: '0 0 0.28571429rem 0', fontSize: '.92857143em', display: 'block' }
                  },
                  t('Projects', { ns: _translation.TRANSLATION_FILES.screens })
                ),
                _react2.default.createElement(_semanticUiReact.Dropdown, {
                  fluid: true,
                  search: true,
                  selection: true,
                  floating: true,
                  disabled: loading || loadingProjectSearch,
                  loading: loadingProjectSearch,
                  multiple: true,
                  name: 'projectFilter',
                  onChange: _this3.handleFilterProjects,
                  options: _this3.state.projectOpts,
                  placeholder: t('Find Project'),
                  value: _this3.state.filteredProjects,
                  noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter tight-column',
                tablet: 5,
                computer: 5
              },
              _react2.default.createElement(_UCBookingSelectListMultiple.BookingSelectListMultiple, {
                filterName: 'loanStatus',
                onChange: _this3.handleFilterOnChange,
                onClose: _this3.handleClearFilter,
                options: _bankCaseStatuses2.default.map(function (_ref7) {
                  var value = _ref7.value,
                      text = _ref7.text;
                  return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                }),
                placeholder: t('Loan Status'),
                value: _this3.state.loanStatus,
                disabled: loading,
                label: t('Loan Status', { ns: _translation.TRANSLATION_FILES.screens })
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 1, style: { paddingLeft: isTablet ? '0rem' : '0.7rem' }, textAlign: 'left' },
              _react2.default.createElement(_semanticUiReact.Popup, {
                size: 'tiny',
                style: { backgroundColor: '#596975' },
                basic: true,
                inverted: true,
                content: activeAccordionIndex === 0 ? t('Collapse', { ns: _translation.TRANSLATION_FILES.translation }) : t('Expand', { ns: _translation.TRANSLATION_FILES.translation }),
                position: 'bottom center',
                trigger: _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    icon: true,
                    circular: true,
                    onClick: function onClick(e) {
                      return _this3.handleAccordionClick(e, { index: activeAccordionIndex === 0 ? -1 : 0 });
                    },
                    className: 'uc-accordion-toggle-btn ' + (activeAccordionIndex === 0 ? 'rotated' : '')
                  },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron down' })
                )
              })
            )
          ),
          activeAccordionIndex !== 0 && _this3.renderDefaultClearFilter()
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Transition,
        { visible: activeAccordionIndex === 0, animation: 'slide down', duration: 200 },
        _react2.default.createElement(
          _semanticUiReact.Accordion.Content,
          { active: activeAccordionIndex === 0, style: { paddingBottom: '2rem' } },
          _react2.default.createElement(
            _semanticUiReact.Grid
            // className="filters booking"
            ,
            { textAlign: 'left',
              verticalAlign: 'middle'
            },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter tight-column',
                tablet: 5,
                computer: 5
              },
              _react2.default.createElement(_UCBookingSelectList.BookingSelectList, {
                filterName: 'spaLawyerStatus',
                onChange: _this3.handleFilterOnChange,
                onClose: _this3.handleClearFilter,
                options: (0, _lawyerCaseStatuses.getLawyerCaseStatuses)(_lawyerCaseStatuses.TYPE_CASE_SPA).map(function (_ref8) {
                  var value = _ref8.value,
                      text = _ref8.text;
                  return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                }),
                placeholder: t('Case Type'),
                value: _this3.state.spaLawyerStatus,
                disabled: loading,
                label: t('SPA Status', { ns: _translation.TRANSLATION_FILES.screens })
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter tight-column',
                tablet: 5,
                computer: 5
              },
              _react2.default.createElement(_UCBookingSelectList.BookingSelectList, {
                filterName: 'laLawyerStatus',
                onChange: _this3.handleFilterOnChange,
                onClose: _this3.handleClearFilter,
                options: (0, _lawyerCaseStatuses.getLawyerCaseStatuses)(_lawyerCaseStatuses.TYPE_CASE_LA).map(function (_ref9) {
                  var value = _ref9.value,
                      text = _ref9.text;
                  return { value: value, text: t(text, { ns: _translation.TRANSLATION_FILES.constants }) };
                }),
                placeholder: t('Case Type'),
                value: _this3.state.laLawyerStatus,
                disabled: loading,
                label: t('LA Status', { ns: _translation.TRANSLATION_FILES.screens })
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                className: 'filter tight-column',
                tablet: 5,
                computer: 5
              },
              _react2.default.createElement(_UCBookingDatePicker2.default, {
                filterName: 'dateRange',
                filterNameFrom: 'dateFrom',
                filterNameTo: 'dateTo',
                headerText: t('Created Date Range'),
                placeholder: t('Select Created Date Range'),
                dateFrom: _this3.state.dateFrom,
                dateTo: _this3.state.dateTo,
                onChange: _this3.handleFilterOnChange,
                onClose: _this3.handleClearFilter,
                onResetRange: _this3.handleClearFilter,
                onSetRange: function onSetRange(from, to) {
                  return _this3.handleSetDateRange('dateRange', from, to);
                },
                value: _this3.state.dateRange,
                disabled: loading,
                label: t('Created Date Range')
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { style: { paddingBottom: '0rem' } },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                {
                  className: 'filter tight-column',
                  tablet: 5,
                  computer: 5
                },
                _react2.default.createElement(_UCBookingDatePicker2.default, {
                  filterName: 'approvedDateRange',
                  filterNameFrom: 'approvedDateFrom',
                  filterNameTo: 'approvedDateTo',
                  headerText: t('Approved Date Range'),
                  placeholder: t('Select Approved Date Range'),
                  dateFrom: _this3.state.approvedDateFrom,
                  dateTo: _this3.state.approvedDateTo,
                  onChange: _this3.handleFilterOnChange,
                  onClose: _this3.handleClearFilter,
                  onResetRange: _this3.handleClearFilter,
                  onSetRange: function onSetRange(from, to) {
                    return _this3.handleSetDateRange('approvedDateRange', from, to);
                  },
                  value: _this3.state.approvedDateRange,
                  disabled: loading,
                  label: t('Approved Date Range')
                })
              )
            ),
            _this3.renderDefaultClearFilter()
          )
        )
      )
    );
  };

  this.renderMenuTool = function () {
    return _react2.default.createElement(
      _semanticUiReact.Grid,
      { columns: 'equal' },
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        null,
        _this3.renderAccordionDefaultView()
      )
    );
  };

  this.renderTableHeaders = function () {
    var t = _this3.props.t;

    return _react2.default.createElement(
      _semanticUiReact.Table.Header,
      { className: 'mobile-hide' },
      _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          t('Unit')
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          t('Customer')
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          { className: 'mobile-hide' },
          t('Status')
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          t('Created')
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          t('Approved')
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          t('Loan')
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          t('SPA')
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.HeaderCell,
          null,
          t('LA')
        )
      )
    );
  };

  this.renderTableRow = function (data, idx) {
    var _state6 = _this3.state,
        isMobile = _state6.isMobile,
        isComputer = _state6.isComputer;
    var t = _this3.props.t;

    var _ref10 = function () {
      if (!data.bankCasesStatuses || data.bankCasesStatuses.length === 0) return { bankCaseStatusTag: null, bankCaseUpdatedAt: null, bankCaseLastRemark: null };

      var bankStatus = _bankCaseStatuses2.default.find(function (e) {
        return e.value === data.bankCasesStatuses[0].status;
      });
      return bankStatus ? {
        bankCaseStatusTag: _react2.default.createElement(_UCBStatusFlag2.default, { text: t(data.bankCasesStatuses[0].statusName, { ns: _translation.TRANSLATION_FILES.constants }), value: bankStatus.color }),
        bankCaseUpdatedAt: data.bankCasesStatuses[0].updatedAt,
        bankCaseLastRemark: data.bankCasesStatuses[0].lastRemark
      } : { bankCaseStatusTag: null, bankCaseUpdatedAt: null, bankCaseLastRemark: null };
    }(),
        bankCaseStatusTag = _ref10.bankCaseStatusTag,
        bankCaseUpdatedAt = _ref10.bankCaseUpdatedAt,
        bankCaseLastRemark = _ref10.bankCaseLastRemark;

    var bookingStatusTag = _react2.default.createElement(_UCBStatusFlag2.default, { text: t(data.bookingStatus.name, { ns: _translation.TRANSLATION_FILES.constants }), value: data.bookingStatus.id });
    var spaLawyer = data.spaLawyer || null;
    var laLawyer = data.laLawyer || null;

    var _ref11 = function () {
      if (!spaLawyer) return { spaLawyerCaseStatusTag: null, spaLawyerCaseUpdatedAt: null, spaLawyerCaseLastRemark: null };

      var spaLawyerStatus = _lawyerCaseStatuses.LAWYER_ALL_STATUSES.find(function (s) {
        return s.value === spaLawyer.status;
      });
      return spaLawyerStatus ? {
        spaLawyerCaseStatusTag: _react2.default.createElement(_UCBStatusFlag2.default, { text: t(spaLawyer.statusName, { ns: _translation.TRANSLATION_FILES.constants }), value: spaLawyerStatus.color }),
        spaLawyerCaseUpdatedAt: spaLawyer.updatedAt,
        spaLawyerCaseLastRemark: spaLawyer.lastRemark
      } : { spaLawyerCaseStatusTag: null, spaLawyerCaseUpdatedAt: null, spaLawyerCaseLastRemark: null };
    }(),
        spaLawyerCaseStatusTag = _ref11.spaLawyerCaseStatusTag,
        spaLawyerCaseUpdatedAt = _ref11.spaLawyerCaseUpdatedAt,
        spaLawyerCaseLastRemark = _ref11.spaLawyerCaseLastRemark;

    var _ref12 = function () {
      if (!laLawyer) return { laLawyerCaseStatusTag: null, laLawyerCaseUpdatedAt: null, laLawyerCaseLastRemark: null };
      var laLawyerStatus = _lawyerCaseStatuses.LAWYER_ALL_STATUSES.find(function (s) {
        return s.value === laLawyer.status;
      });
      return laLawyerStatus ? {
        laLawyerCaseStatusTag: _react2.default.createElement(_UCBStatusFlag2.default, { text: t(laLawyer.statusName, { ns: _translation.TRANSLATION_FILES.constants }), value: laLawyerStatus.color }),
        laLawyerCaseUpdatedAt: laLawyer.updatedAt,
        laLawyerCaseLastRemark: laLawyer.lastRemark
      } : { laLawyerCaseStatusTag: null, laLawyerCaseUpdatedAt: null, laLawyerCaseLastRemark: null };
    }(),
        laLawyerCaseStatusTag = _ref12.laLawyerCaseStatusTag,
        laLawyerCaseUpdatedAt = _ref12.laLawyerCaseUpdatedAt,
        laLawyerCaseLastRemark = _ref12.laLawyerCaseLastRemark;

    return _react2.default.createElement(
      _semanticUiReact.Table.Row,
      {
        key: idx,
        className: _this3.getRowClassName(data.status),
        onClick: isMobile ? function () {
          return _this3.context.router.push('/bookings/' + data.booking_id + '/');
        } : null
      },
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        null,
        _react2.default.createElement(
          'div',
          { className: 'mobile-hide' },
          _react2.default.createElement(
            _reactRouter.Link,
            { style: { fontSize: 14 }, title: data.code, to: '/bookings/' + data.id + '/' },
            data.projectUnit.reference
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'span',
            { className: 'uc-table-cell-subtitle1' },
            data.project.name
          )
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { className: 'mobile-hide' },
        _react2.default.createElement(
          'span',
          null,
          data.bookingCustomer && data.bookingCustomer.name
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { style: { marginTop: '0.45em' } },
        bookingStatusTag
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { verticalAlign: 'middle' },
        _react2.default.createElement(
          'span',
          { className: 'mobile-hide' },
          _react2.default.createElement(_Timestamp2.default, {
            timestamp: data.createdAt,
            format: 'DD/M/YYYY'
          })
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { verticalAlign: 'middle' },
        _react2.default.createElement(
          'span',
          { className: 'mobile-hide' },
          data.approvedAt ? _react2.default.createElement(_Timestamp2.default, {
            timestamp: data.approvedAt,
            format: 'DD/M/YYYY'
          }) : '-'
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        null,
        bankCaseStatusTag || bankCaseUpdatedAt || bankCaseLastRemark ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            null,
            bankCaseStatusTag
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(_Timestamp2.default, {
            timestamp: bankCaseUpdatedAt,
            format: 'DD/M/YYYY'
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'span',
            { style: { fontStyle: 'italic' } },
            bankCaseLastRemark
          )
        ) : t('No data', { ns: _translation.TRANSLATION_FILES.translation })
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        null,
        spaLawyer ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            null,
            spaLawyerCaseStatusTag
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(_Timestamp2.default, {
            timestamp: spaLawyerCaseUpdatedAt,
            format: 'DD/M/YYYY'
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'span',
            { style: { fontStyle: 'italic' } },
            spaLawyerCaseLastRemark
          )
        ) : t('No data', { ns: _translation.TRANSLATION_FILES.translation })
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        null,
        laLawyer ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'span',
            null,
            laLawyerCaseStatusTag
          ),
          _react2.default.createElement('br', null),
          _react2.default.createElement(_Timestamp2.default, {
            timestamp: laLawyerCaseUpdatedAt,
            format: 'DD/M/YYYY'
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement(
            'span',
            { style: { fontStyle: 'italic' } },
            laLawyerCaseLastRemark
          )
        ) : t('No data', { ns: _translation.TRANSLATION_FILES.translation })
      )
    );
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRouter.withRouter)((0, _reactRedux.connect)(UnitProgress.mapStateToProps)(UnitProgress)));

/***/ }),
/* 2279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _prompt = __webpack_require__(66);

var _promptMessages = __webpack_require__(43);

var _checkChanges = __webpack_require__(61);

var _valueToText = __webpack_require__(98);

var _valueToText2 = _interopRequireDefault(_valueToText);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var STEPS = ['Field', 'Bookings', 'Value', 'Review & confirm'];

var BOOKINGS_PAGE_SIZE = 20;

var HISTORY_PAGE_SIZE = 10;

var HISTORY_STATUSES = [{ text: 'Processing', value: 'new' }, { text: 'Completed', value: 'completed' }, { text: 'Partially completed', value: 'partial' }, { text: 'Failed', value: 'failed' }];

var CUSTOM_FIELD_TYPE_LABELS = {
  dropdown: 'Dropdown Single',
  dropdown_multi: 'Dropdown Multiple'
};

var CustomEdit = function (_Component) {
  _inherits(CustomEdit, _Component);

  function CustomEdit(props) {
    _classCallCheck(this, CustomEdit);

    var _this = _possibleConstructorReturn(this, (CustomEdit.__proto__ || Object.getPrototypeOf(CustomEdit)).call(this, props));

    _this.handleBackClick = function () {
      _this.setState({ selectedProjectID: null, customFields: [], fieldSearch: '' });
      if (_this.props.onCheck) {
        _this.props.onCheck(false);
      }
    };

    _this.handleChangeFieldClick = function () {
      _this.setState({
        selectedField: null,
        bookings: [],
        currentStep: 0,
        selectedValueOptionID: null,
        selectedValueOptionIDs: []
      });
    };

    _this.handleEditClick = function () {
      if (_this.state.historyOngoing) return;
      _this.setState({ modalOpen: true, currentStep: 0 });
    };

    _this.handleFieldClick = function (field) {
      _this.setState({
        selectedField: field,
        currentStep: 1,
        selectedBookingIDs: [],
        selectedValueOptionID: null,
        selectedValueOptionIDs: []
      }, function () {
        _this.fetchProjectBookings(1);
      });
    };

    _this.handleFieldSearchChange = function (e, _ref) {
      var value = _ref.value;

      _this.setState({ fieldSearch: value });
    };

    _this.handleFooterBackClick = function () {
      var _this$state = _this.state,
          currentStep = _this$state.currentStep,
          selectedProjectID = _this$state.selectedProjectID;

      if (currentStep === 3) {
        _this.setState({ currentStep: 2 });
      } else if (currentStep === 2) {
        _this.setState({ currentStep: 1 });
      } else if (currentStep === 1) {
        _this.handleChangeFieldClick();
      } else if (currentStep === 0 && selectedProjectID) {
        _this.handleBackClick();
      }
    };

    _this.handleCheckBeforeClose = function () {
      if (_this.state.selectedProjectID) {
        var t = _this.props.t;
        var store = _this.context.store;

        var callback = function callback() {
          return _this.closeModal();
        };
        store.dispatch((0, _prompt.promptChangesMessage)({
          message: t(_promptMessages.DEFAULT_PROMPT, { ns: _translation.TRANSLATION_FILES.translation }),
          callback: callback
        }));
        return true;
      }
      return false;
    };

    _this.handleModalClose = function () {
      if (!_this.handleCheckBeforeClose()) {
        _this.closeModal();
      }
    };

    _this.handleNextClick = function () {
      var currentStep = _this.state.currentStep;

      if (currentStep === 1) {
        _this.setState({ currentStep: 2 });
      } else if (currentStep === 2) {
        _this.setState({ currentStep: 3, confirmChecked: false });
      }
    };

    _this.handleConfirmCheckChange = function (e, _ref2) {
      var checked = _ref2.checked;

      _this.setState({ confirmChecked: checked });
    };

    _this.handleConfirmSubmitClick = function () {
      _this.submitBulkEdit();
    };

    _this.handlePageChange = function (currentPage) {
      _this.setState({ bookingsPage: currentPage }, function () {
        _this.fetchProjectBookings(currentPage);
      });
    };

    _this.handleFailedCodesOpen = function (item) {
      _this.setState({ failedCodesItem: item });
    };

    _this.handleFailedCodesClose = function () {
      _this.setState({ failedCodesItem: null });
    };

    _this.handleHistoryPageChange = function (currentPage) {
      _this.setState({ historyPage: currentPage }, function () {
        _this.fetchHistory(currentPage);
      });
    };

    _this.progressToPercent = function (item) {
      var percent = 0;
      if (item.progress && item.progress.includes('/')) {
        var data = item.progress.split('/');
        var percentFor = parseInt(data[0], 10);
        var percentOf = parseInt(data[1], 10);
        if (percentOf > 0) {
          percent = Math.floor(percentFor / percentOf * 100);
        }
      }
      return percent;
    };

    _this.handleProjectChange = function (e, _ref3) {
      var value = _ref3.value;

      _this.setState({ selectedProjectID: value, customFields: [] }, function () {
        if (value) {
          _this.fetchCustomFields(value);
        }
      });
      if (_this.props.onCheck) {
        _this.props.onCheck(!!value);
      }
    };

    _this.handleSelectAllChange = function (e, _ref4) {
      var checked = _ref4.checked;
      var _this$state2 = _this.state,
          bookings = _this$state2.bookings,
          selectedBookingIDs = _this$state2.selectedBookingIDs;

      var pageIDs = bookings.map(function (booking) {
        return booking.id;
      });
      _this.setState({
        selectedBookingIDs: checked ? Array.from(new Set([].concat(_toConsumableArray(selectedBookingIDs), _toConsumableArray(pageIDs)))) : selectedBookingIDs.filter(function (id) {
          return !pageIDs.includes(id);
        })
      });
    };

    _this.handleSelectBookingChange = function (bookingID) {
      var selectedBookingIDs = _this.state.selectedBookingIDs;

      var isSelected = selectedBookingIDs.includes(bookingID);
      _this.setState({
        selectedBookingIDs: isSelected ? selectedBookingIDs.filter(function (id) {
          return id !== bookingID;
        }) : [].concat(_toConsumableArray(selectedBookingIDs), [bookingID])
      });
    };

    _this.handleValueOptionClick = function (optionID) {
      _this.setState({ selectedValueOptionID: optionID });
    };

    _this.handleValueOptionToggle = function (optionID) {
      var selectedValueOptionIDs = _this.state.selectedValueOptionIDs;

      var isSelected = selectedValueOptionIDs.includes(optionID);
      _this.setState({
        selectedValueOptionIDs: isSelected ? selectedValueOptionIDs.filter(function (id) {
          return id !== optionID;
        }) : [].concat(_toConsumableArray(selectedValueOptionIDs), [optionID])
      });
    };

    _this.state = {
      loading: true,
      projects: [],
      selectedProjectID: null,
      modalOpen: false,
      failedCodesItem: null,
      currentStep: 0,
      customFields: [],
      customFieldsLoading: false,
      fieldSearch: '',
      selectedField: null,
      bookings: [],
      bookingsLoading: false,
      bookingsPage: 1,
      bookingsCount: 0,
      bookingsLimit: 0,
      bookingsOffset: 0,
      selectedBookingIDs: [],
      selectedValueOptionID: null,
      selectedValueOptionIDs: [],
      bookingsInfoCache: {},
      confirmChecked: false,
      submitting: false,
      token: null,
      historyData: [],
      historyLoading: true,
      historyPage: 1,
      historyCount: 0,
      historyLimit: 0,
      historyOffset: 0,
      historyOngoing: false
    };
    return _this;
  }

  _createClass(CustomEdit, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.fetchProjects();
      this.fetchHistory(1);
      this.historyTicker = setInterval(function () {
        if (_this2.state.historyOngoing) {
          _this2.fetchHistory(_this2.state.historyPage, true);
        }
      }, 5000);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.historyTicker) {
        clearInterval(this.historyTicker);
      }
    }
  }, {
    key: 'getFieldValueDisplay',
    value: function getFieldValueDisplay(bookingCustomFields) {
      var selectedField = this.state.selectedField;

      var bcf = (bookingCustomFields || []).find(function (f) {
        return f.projectBookingCustomFieldID === selectedField.id;
      });
      if (!bcf) return '—';
      if (selectedField.type === 'dropdown_multi') {
        var optionIDs = bcf.projectBookingCustomFieldOptionIDs || [];
        var titles = (bcf.projectBookingCustomFieldOptions || []).filter(function (o) {
          return optionIDs.includes(o.id);
        }).map(function (o) {
          return o.title;
        });
        return titles.length > 0 ? titles.join(', ') : '—';
      }
      var option = (bcf.projectBookingCustomFieldOptions || []).find(function (o) {
        return o.id === bcf.projectBookingCustomFieldOptionID;
      });
      return option && option.title || bcf.value || '—';
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      this.setState({
        modalOpen: false,
        currentStep: 0,
        selectedProjectID: null,
        customFields: [],
        fieldSearch: '',
        selectedField: null,
        bookings: [],
        bookingsPage: 1,
        bookingsCount: 0,
        bookingsLimit: 0,
        bookingsOffset: 0,
        selectedBookingIDs: [],
        selectedValueOptionID: null,
        selectedValueOptionIDs: [],
        bookingsInfoCache: {},
        confirmChecked: false,
        submitting: false
      });
      if (this.props.onCheck) {
        this.props.onCheck(false);
      }
    }
  }, {
    key: 'fetchCustomFields',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(projectID) {
        var store, t, res, message, dropdownTypes, allFields, customFields;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.setState({ customFieldsLoading: true });
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + projectID + '/booking_custom_fields/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 16;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);
                _context.next = 14;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 14:
                this.setState({ customFieldsLoading: false });
                return _context.abrupt('return');

              case 16:
                if (res.ok) {
                  _context.next = 24;
                  break;
                }

                _context.next = 19;
                return res.text();

              case 19:
                message = _context.sent;
                _context.next = 22;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 22:
                this.setState({ customFieldsLoading: false });
                return _context.abrupt('return');

              case 24:
                dropdownTypes = ['dropdown', 'dropdown_multi'];
                _context.next = 27;
                return res.json();

              case 27:
                _context.t1 = _context.sent;

                if (_context.t1) {
                  _context.next = 30;
                  break;
                }

                _context.t1 = [];

              case 30:
                allFields = _context.t1;
                customFields = allFields.filter(function (field) {
                  return dropdownTypes.includes(field.type) && !field.isDefault;
                });

                this.setState({ customFields: customFields, customFieldsLoading: false });

              case 33:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchCustomFields(_x) {
        return _ref5.apply(this, arguments);
      }

      return fetchCustomFields;
    }()
  }, {
    key: 'fetchProjectBookings',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var store, t, selectedProjectID, query, res, message, count, limit, offset, token, bookingsList, bookings, bookingsInfoCache;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.setState({ bookingsLoading: true, bookings: [] });
                store = this.context.store;
                t = this.props.t;
                selectedProjectID = this.state.selectedProjectID;
                query = {
                  projectFilter: btoa(selectedProjectID),
                  includeCustomFields: true,
                  limit: BOOKINGS_PAGE_SIZE,
                  page: page
                };
                res = void 0;
                _context2.prev = 6;
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context2.sent;
                _context2.next = 18;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);
                _context2.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                this.setState({ bookingsLoading: false });
                return _context2.abrupt('return');

              case 18:
                if (res.ok) {
                  _context2.next = 26;
                  break;
                }

                _context2.next = 21;
                return res.text();

              case 21:
                message = _context2.sent;
                _context2.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                this.setState({ bookingsLoading: false });
                return _context2.abrupt('return');

              case 26:
                count = parseInt(res.headers.get('M-Data-count'), 10) || 0;
                limit = parseInt(res.headers.get('M-Data-limit'), 10) || 0;
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                token = res.headers.get('X-Csrf-Token');
                _context2.next = 32;
                return res.json();

              case 32:
                _context2.t1 = _context2.sent;

                if (_context2.t1) {
                  _context2.next = 35;
                  break;
                }

                _context2.t1 = [];

              case 35:
                bookingsList = _context2.t1;
                bookings = bookingsList.map(function (booking) {
                  return {
                    id: booking.id,
                    bookingCode: booking.code || '—',
                    unitReference: booking.projectUnit && booking.projectUnit.reference || '—',
                    customerName: booking.bookingCustomer && booking.bookingCustomer.name || '—',
                    statusName: booking.bookingStatus && booking.bookingStatus.name || '—',
                    fieldValue: _this3.getFieldValueDisplay(booking.bookingCustomFields)
                  };
                });
                bookingsInfoCache = _extends({}, this.state.bookingsInfoCache);

                bookings.forEach(function (booking) {
                  bookingsInfoCache[booking.id] = booking;
                });
                this.setState({
                  bookings: bookings,
                  bookingsLoading: false,
                  bookingsCount: count,
                  bookingsLimit: limit,
                  bookingsOffset: offset,
                  bookingsInfoCache: bookingsInfoCache,
                  token: token
                });

              case 40:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 12]]);
      }));

      function fetchProjectBookings() {
        return _ref6.apply(this, arguments);
      }

      return fetchProjectBookings;
    }()
  }, {
    key: 'submitBulkEdit',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _this4 = this;

        var store, t, _state, selectedProjectID, selectedField, selectedBookingIDs, selectedValueOptionID, selectedValueOptionIDs, token, isMulti, body, res, message;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.setState({ submitting: true });
                store = this.context.store;
                t = this.props.t;
                _state = this.state, selectedProjectID = _state.selectedProjectID, selectedField = _state.selectedField, selectedBookingIDs = _state.selectedBookingIDs, selectedValueOptionID = _state.selectedValueOptionID, selectedValueOptionIDs = _state.selectedValueOptionIDs, token = _state.token;
                isMulti = selectedField.type === 'dropdown_multi';
                body = {
                  projectID: selectedProjectID,
                  projectBookingCustomFieldID: selectedField.id,
                  bookingIDs: selectedBookingIDs,
                  projectBookingCustomFieldOptionID: isMulti ? '' : selectedValueOptionID,
                  projectBookingCustomFieldOptionIDs: isMulti ? selectedValueOptionIDs : []
                };
                res = void 0;
                _context3.prev = 7;
                _context3.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/custom_fields/bulk/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': token
                  },
                  body: JSON.stringify(body)
                }));

              case 10:
                res = _context3.sent;
                _context3.next = 19;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3['catch'](7);
                _context3.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                this.setState({ submitting: false });
                return _context3.abrupt('return');

              case 19:
                if (res.ok) {
                  _context3.next = 27;
                  break;
                }

                _context3.next = 22;
                return res.text();

              case 22:
                message = _context3.sent;
                _context3.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                this.setState({ submitting: false });
                return _context3.abrupt('return');

              case 27:
                this.setState({ submitting: false }, function () {
                  store.dispatch((0, _flash.flashSuccessMessage)({ message: t('Bulk edit has been queued', { ns: _translation.TRANSLATION_FILES.screens }) }));
                  _this4.closeModal();
                  _this4.setState({ historyPage: 1 }, function () {
                    _this4.fetchHistory(1);
                  });
                });

              case 28:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[7, 13]]);
      }));

      function submitBulkEdit() {
        return _ref7.apply(this, arguments);
      }

      return submitBulkEdit;
    }()
  }, {
    key: 'fetchProjects',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var store, t, query, res, message, projects;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.setState({ loading: true });
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({
                  limit: 0,
                  showAsOptions: true
                });
                res = void 0;
                _context4.prev = 5;
                _context4.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context4.sent;
                _context4.next = 17;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](5);
                _context4.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 15:
                this.setState({ loading: false });
                return _context4.abrupt('return');

              case 17:
                if (res.ok) {
                  _context4.next = 25;
                  break;
                }

                _context4.next = 20;
                return res.text();

              case 20:
                message = _context4.sent;
                _context4.next = 23;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 23:
                this.setState({ loading: false });
                return _context4.abrupt('return');

              case 25:
                _context4.next = 27;
                return res.json();

              case 27:
                _context4.t1 = _context4.sent;

                if (_context4.t1) {
                  _context4.next = 30;
                  break;
                }

                _context4.t1 = [];

              case 30:
                projects = _context4.t1;

                this.setState({ projects: projects, loading: false });

              case 32:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 11]]);
      }));

      function fetchProjects() {
        return _ref8.apply(this, arguments);
      }

      return fetchProjects;
    }()
  }, {
    key: 'fetchHistory',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
        var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var store, t, query, res, message, count, limit, offset, historyData, historyOngoing;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (!silent) this.setState({ historyLoading: true });
                store = this.context.store;
                t = this.props.t;
                query = { page: page, limit: HISTORY_PAGE_SIZE };
                res = void 0;
                _context5.prev = 5;
                _context5.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/custom_fields/bulk/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context5.sent;
                _context5.next = 18;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5['catch'](5);

                if (silent) {
                  _context5.next = 17;
                  break;
                }

                _context5.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                this.setState({ historyLoading: false });

              case 17:
                return _context5.abrupt('return');

              case 18:
                if (res.ok) {
                  _context5.next = 27;
                  break;
                }

                if (silent) {
                  _context5.next = 26;
                  break;
                }

                _context5.next = 22;
                return res.text();

              case 22:
                message = _context5.sent;
                _context5.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                this.setState({ historyLoading: false });

              case 26:
                return _context5.abrupt('return');

              case 27:
                count = parseInt(res.headers.get('M-Data-count'), 10) || 0;
                limit = parseInt(res.headers.get('M-Data-limit'), 10) || 0;
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context5.next = 32;
                return res.json();

              case 32:
                _context5.t1 = _context5.sent;

                if (_context5.t1) {
                  _context5.next = 35;
                  break;
                }

                _context5.t1 = [];

              case 35:
                historyData = _context5.t1;
                historyOngoing = historyData.some(function (item) {
                  return item.statusID === 'new';
                });

                this.setState({
                  historyData: historyData,
                  historyLoading: false,
                  historyCount: count,
                  historyLimit: limit,
                  historyOffset: offset,
                  historyOngoing: historyOngoing
                });

              case 38:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[5, 11]]);
      }));

      function fetchHistory() {
        return _ref9.apply(this, arguments);
      }

      return fetchHistory;
    }()
  }, {
    key: 'renderFieldSelect',
    value: function renderFieldSelect() {
      var _this5 = this;

      var _state2 = this.state,
          customFields = _state2.customFields,
          customFieldsLoading = _state2.customFieldsLoading,
          fieldSearch = _state2.fieldSearch,
          projects = _state2.projects,
          selectedProjectID = _state2.selectedProjectID;
      var t = this.props.t;

      var selectedProject = (projects || []).find(function (project) {
        return project.id === selectedProjectID;
      });
      var filteredFields = (customFields || []).filter(function (field) {
        return (field.label || field.name || '').toLowerCase().includes(fieldSearch.toLowerCase());
      });
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        selectedProject && _react2.default.createElement(
          'p',
          null,
          t('Project', { ns: _translation.TRANSLATION_FILES.screens }),
          ': ',
          _react2.default.createElement(
            'strong',
            null,
            selectedProject.name
          )
        ),
        _react2.default.createElement(_semanticUiReact.Input, {
          fluid: true,
          icon: 'search',
          iconPosition: 'left',
          placeholder: t('Search custom fields', { ns: _translation.TRANSLATION_FILES.screens }),
          value: fieldSearch,
          loading: customFieldsLoading,
          onChange: this.handleFieldSearchChange
        }),
        _react2.default.createElement(
          _semanticUiReact.List,
          {
            divided: true,
            selection: true,
            style: { marginTop: '1em', maxHeight: '18em', overflowY: 'auto' }
          },
          filteredFields.length === 0 ? _react2.default.createElement(
            'p',
            null,
            t('No custom field with dropdown found', { ns: _translation.TRANSLATION_FILES.screens })
          ) : filteredFields.map(function (field) {
            return _react2.default.createElement(
              _semanticUiReact.List.Item,
              { key: field.id, onClick: function onClick() {
                  return _this5.handleFieldClick(field);
                } },
              _react2.default.createElement(
                _semanticUiReact.List.Content,
                { floated: 'right' },
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  null,
                  CUSTOM_FIELD_TYPE_LABELS[field.type] ? t(CUSTOM_FIELD_TYPE_LABELS[field.type], { ns: _translation.TRANSLATION_FILES.constants }) : field.type
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Content,
                null,
                field.label
              )
            );
          })
        )
      );
    }
  }, {
    key: 'renderBookingsList',
    value: function renderBookingsList() {
      var _this6 = this;

      var _state3 = this.state,
          selectedField = _state3.selectedField,
          bookings = _state3.bookings,
          bookingsLoading = _state3.bookingsLoading,
          bookingsPage = _state3.bookingsPage,
          bookingsCount = _state3.bookingsCount,
          bookingsLimit = _state3.bookingsLimit,
          bookingsOffset = _state3.bookingsOffset,
          selectedBookingIDs = _state3.selectedBookingIDs;
      var t = this.props.t;

      var allSelected = bookings.length > 0 && bookings.every(function (b) {
        return selectedBookingIDs.includes(b.id);
      });
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'div',
          {
            style: {
              background: '#e9f7f1', padding: '0.75em 1em', borderRadius: 4, marginBottom: '1em'
            }
          },
          t('Editing', { ns: _translation.TRANSLATION_FILES.screens }),
          ' ',
          _react2.default.createElement(
            'strong',
            null,
            selectedField.label
          ),
          ' \u2014',
          ' ',
          _react2.default.createElement(
            'a',
            { role: 'button', tabIndex: 0, onClick: this.handleChangeFieldClick },
            t('change field', { ns: _translation.TRANSLATION_FILES.screens })
          )
        ),
        bookingsLoading && _react2.default.createElement(_semanticUiReact.Loader, { active: true, inline: 'centered' }),
        !bookingsLoading && bookings.length === 0 && _react2.default.createElement(
          'p',
          null,
          t('No bookings found', { ns: _translation.TRANSLATION_FILES.screens })
        ),
        !bookingsLoading && bookings.length > 0 && _react2.default.createElement(
          _react2.default.Fragment,
          null,
          _react2.default.createElement(
            'div',
            { className: 'bulk-edit-desktop-table' },
            _react2.default.createElement(
              _semanticUiReact.Table,
              { celled: true, selectable: true },
              _react2.default.createElement(
                _semanticUiReact.Table.Header,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    { collapsing: true },
                    _react2.default.createElement(_semanticUiReact.Checkbox, { checked: allSelected, onChange: this.handleSelectAllChange })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    t('Code', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    t('Unit', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    t('Customer', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    t('Status', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    selectedField.label
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Body,
                null,
                bookings.map(function (booking) {
                  return _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    { key: booking.id },
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      { collapsing: true },
                      _react2.default.createElement(_semanticUiReact.Checkbox, {
                        checked: selectedBookingIDs.includes(booking.id),
                        onChange: function onChange() {
                          return _this6.handleSelectBookingChange(booking.id);
                        }
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      booking.bookingCode
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      booking.unitReference
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      booking.customerName
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      t(booking.statusName, { ns: _translation.TRANSLATION_FILES.constants })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      booking.fieldValue
                    )
                  );
                })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bulk-edit-mobile-list' },
            bookings.map(function (booking) {
              return _react2.default.createElement(
                'div',
                { className: 'bulk-edit-mobile-card', key: booking.id },
                _react2.default.createElement(
                  'div',
                  { className: 'bulk-edit-mobile-card-header' },
                  _react2.default.createElement(_semanticUiReact.Checkbox, {
                    checked: selectedBookingIDs.includes(booking.id),
                    onChange: function onChange() {
                      return _this6.handleSelectBookingChange(booking.id);
                    }
                  }),
                  _react2.default.createElement(
                    'strong',
                    null,
                    booking.bookingCode
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'bulk-edit-mobile-card-row' },
                  _react2.default.createElement(
                    'span',
                    null,
                    t('Unit', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    booking.unitReference
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'bulk-edit-mobile-card-row' },
                  _react2.default.createElement(
                    'span',
                    null,
                    t('Customer', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    booking.customerName
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'bulk-edit-mobile-card-row' },
                  _react2.default.createElement(
                    'span',
                    null,
                    t('Status', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    t(booking.statusName, { ns: _translation.TRANSLATION_FILES.constants })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'bulk-edit-mobile-card-row' },
                  _react2.default.createElement(
                    'span',
                    null,
                    selectedField.label
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    booking.fieldValue
                  )
                )
              );
            })
          ),
          _react2.default.createElement(_PageNav2.default, {
            currentPage: bookingsPage,
            count: bookingsCount,
            limit: bookingsLimit,
            offset: bookingsOffset,
            dataSize: bookings.length,
            loading: bookingsLoading,
            onChange: this.handlePageChange
          })
        )
      );
    }
  }, {
    key: 'renderValueSelect',
    value: function renderValueSelect() {
      var _this7 = this;

      var _state4 = this.state,
          selectedField = _state4.selectedField,
          selectedBookingIDs = _state4.selectedBookingIDs,
          selectedValueOptionID = _state4.selectedValueOptionID,
          selectedValueOptionIDs = _state4.selectedValueOptionIDs;
      var t = this.props.t;

      var fieldOptions = selectedField.projectBookingCustomFieldOptions || [];
      var isMulti = selectedField.type === 'dropdown_multi';
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'div',
          {
            style: {
              background: '#e9f7f1', padding: '0.75em 1em', borderRadius: 4, marginBottom: '1em'
            }
          },
          t('Editing', { ns: _translation.TRANSLATION_FILES.screens }),
          ' ',
          _react2.default.createElement(
            'strong',
            null,
            selectedField.label
          ),
          ' \u2014',
          ' ',
          _react2.default.createElement(
            'a',
            { role: 'button', tabIndex: 0, onClick: this.handleChangeFieldClick },
            t('change field', { ns: _translation.TRANSLATION_FILES.screens })
          )
        ),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            _reactI18next.Trans,
            {
              ns: _translation.TRANSLATION_FILES.screens,
              i18nKey: 'Setting <strong>{{field}}</strong> for <strong>{{count}}</strong> selected {{bookingLabel}}.',
              values: {
                field: selectedField.label,
                count: selectedBookingIDs.length,
                bookingLabel: selectedBookingIDs.length === 1 ? 'booking' : 'bookings'
              }
            },
            'Setting <strong>{{field}}</strong> for <strong>{{count}}</strong> selected {{bookingLabel}}.'
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Label,
          { style: { marginBottom: '0.5em' } },
          t('New Value', { ns: _translation.TRANSLATION_FILES.screens })
        ),
        _react2.default.createElement(
          'div',
          { style: { display: 'flex', gap: '0.75em', flexWrap: 'wrap' } },
          fieldOptions.map(function (option) {
            var isSelected = isMulti ? selectedValueOptionIDs.includes(option.id) : selectedValueOptionID === option.id;
            return _react2.default.createElement(
              _semanticUiReact.Button,
              {
                key: option.id,
                basic: !isSelected,
                color: isSelected ? 'green' : undefined,
                onClick: function onClick() {
                  return isMulti ? _this7.handleValueOptionToggle(option.id) : _this7.handleValueOptionClick(option.id);
                }
              },
              option.title
            );
          })
        )
      );
    }
  }, {
    key: 'renderReviewConfirm',
    value: function renderReviewConfirm() {
      var _state5 = this.state,
          selectedField = _state5.selectedField,
          selectedBookingIDs = _state5.selectedBookingIDs,
          selectedValueOptionID = _state5.selectedValueOptionID,
          selectedValueOptionIDs = _state5.selectedValueOptionIDs,
          bookingsInfoCache = _state5.bookingsInfoCache,
          confirmChecked = _state5.confirmChecked;
      var t = this.props.t;

      var isMulti = selectedField.type === 'dropdown_multi';
      var fieldOptions = selectedField.projectBookingCustomFieldOptions || [];
      var newValueLabel = isMulti ? fieldOptions.filter(function (o) {
        return selectedValueOptionIDs.includes(o.id);
      }).map(function (o) {
        return o.title;
      }).join(', ') : (fieldOptions.find(function (o) {
        return o.id === selectedValueOptionID;
      }) || {}).title || '—';
      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            _reactI18next.Trans,
            {
              ns: _translation.TRANSLATION_FILES.screens,
              i18nKey: 'You are about to set <strong>{{field}}</strong> = "{{value}}" for <strong>{{count}}</strong> selected {{bookingLabel}}.',
              values: {
                field: selectedField.label,
                value: newValueLabel,
                count: selectedBookingIDs.length,
                bookingLabel: selectedBookingIDs.length === 1 ? 'booking' : 'bookings'
              }
            },
            'You are about to set <strong>{{field}}</strong> = "{{value}}" for <strong>{{count}}</strong> selected {{bookingLabel}}.'
          )
        ),
        _react2.default.createElement(
          'div',
          { style: { maxHeight: '16em', overflowY: 'auto' } },
          _react2.default.createElement(
            'div',
            { className: 'bulk-edit-desktop-table' },
            _react2.default.createElement(
              _semanticUiReact.Table,
              { celled: true },
              _react2.default.createElement(
                _semanticUiReact.Table.Header,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    t('Code', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    t('Unit', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    t('Customer', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    t('Current', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.HeaderCell,
                    null,
                    t('New', { ns: _translation.TRANSLATION_FILES.screens })
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.Body,
                null,
                selectedBookingIDs.map(function (id) {
                  var info = bookingsInfoCache[id] || {};
                  return _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    { key: id },
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      info.bookingCode || '—'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      info.unitReference || '—'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      info.customerName || '—'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      _react2.default.createElement(
                        's',
                        null,
                        info.fieldValue || '—'
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Label,
                        { color: 'green' },
                        newValueLabel
                      )
                    )
                  );
                })
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'bulk-edit-mobile-list' },
            selectedBookingIDs.map(function (id) {
              var info = bookingsInfoCache[id] || {};
              return _react2.default.createElement(
                'div',
                { className: 'bulk-edit-mobile-card', key: id },
                _react2.default.createElement(
                  'div',
                  { className: 'bulk-edit-mobile-card-header' },
                  _react2.default.createElement(
                    'strong',
                    null,
                    info.bookingCode || '—'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Label,
                    { color: 'green' },
                    newValueLabel
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'bulk-edit-mobile-card-row' },
                  _react2.default.createElement(
                    'span',
                    null,
                    t('Unit', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    info.unitReference || '—'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'bulk-edit-mobile-card-row' },
                  _react2.default.createElement(
                    'span',
                    null,
                    t('Customer', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    info.customerName || '—'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: 'bulk-edit-mobile-card-row' },
                  _react2.default.createElement(
                    'span',
                    null,
                    t('Current', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    _react2.default.createElement(
                      's',
                      null,
                      info.fieldValue || '—'
                    )
                  )
                )
              );
            })
          )
        ),
        _react2.default.createElement(_semanticUiReact.Checkbox, {
          checked: confirmChecked,
          onChange: this.handleConfirmCheckChange,
          label: t('I understand this change applies to all eligible bookings shown above and will be recorded in the Bulk Edit History log.', { ns: _translation.TRANSLATION_FILES.screens }),
          style: { marginTop: '1em' }
        })
      );
    }
  }, {
    key: 'renderHistoryProgress',
    value: function renderHistoryProgress(item) {
      var t = this.props.t;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _semanticUiReact.Progress,
          {
            size: 'small',
            percent: this.progressToPercent(item),
            progress: true,
            color: item.statusID === 'new' ? 'blue' : null,
            success: item.statusID === 'completed',
            warning: item.statusID === 'partial',
            error: item.statusID === 'failed',
            active: item.statusID === 'new'
          },
          t((0, _valueToText2.default)(HISTORY_STATUSES, item.statusID), { ns: _translation.TRANSLATION_FILES.screens }),
          item.progress ? ' (' + item.progress + ')' : ''
        ),
        this.renderFailedCodesLink(item)
      );
    }
  }, {
    key: 'renderFailedCodesLink',
    value: function renderFailedCodesLink(item) {
      var _this8 = this;

      var t = this.props.t;

      var failedCodes = item.failedBookingCodes || [];
      if (failedCodes.length === 0) return null;
      return _react2.default.createElement(
        'a',
        {
          className: 'bulk-edit-history-failed-codes',
          role: 'button',
          tabIndex: 0,
          onClick: function onClick() {
            return _this8.handleFailedCodesOpen(item);
          },
          onKeyPress: function onKeyPress() {
            return _this8.handleFailedCodesOpen(item);
          }
        },
        t('View {{count}} failed bookings', { count: failedCodes.length, ns: _translation.TRANSLATION_FILES.screens })
      );
    }
  }, {
    key: 'renderFailedCodesModal',
    value: function renderFailedCodesModal() {
      var t = this.props.t;
      var failedCodesItem = this.state.failedCodesItem;

      var failedCodes = failedCodesItem && failedCodesItem.failedBookingCodes || [];
      return _react2.default.createElement(
        _semanticUiReact.Modal,
        { open: !!failedCodesItem, onClose: this.handleFailedCodesClose, size: 'tiny', closeIcon: true },
        _react2.default.createElement(
          _semanticUiReact.Modal.Header,
          null,
          t('Failed bookings', { ns: _translation.TRANSLATION_FILES.screens }),
          failedCodesItem && failedCodesItem.fieldLabel ? ' \xB7 ' + failedCodesItem.fieldLabel : ''
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            'p',
            null,
            t('These bookings could not be updated.', { ns: _translation.TRANSLATION_FILES.screens })
          ),
          _react2.default.createElement(
            'div',
            { className: 'bulk-edit-failed-codes-list' },
            _react2.default.createElement(
              _semanticUiReact.List,
              { divided: true, relaxed: true },
              failedCodes.map(function (code, index) {
                return _react2.default.createElement(
                  _semanticUiReact.List.Item,
                  { key: code + '-' + index },
                  code
                );
              })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { primary: true, content: t('Close', { ns: _translation.TRANSLATION_FILES.translation }), onClick: this.handleFailedCodesClose })
        )
      );
    }
  }, {
    key: 'renderHistoryTable',
    value: function renderHistoryTable() {
      var _this9 = this;

      var _state6 = this.state,
          historyData = _state6.historyData,
          historyLoading = _state6.historyLoading,
          historyPage = _state6.historyPage,
          historyCount = _state6.historyCount,
          historyLimit = _state6.historyLimit,
          historyOffset = _state6.historyOffset;
      var t = this.props.t;

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          { inverted: true, active: historyLoading },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bulk-edit-history-desktop' },
          _react2.default.createElement(
            _semanticUiReact.Table,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Header,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  null,
                  t('Created By', { ns: _translation.TRANSLATION_FILES.screens })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  null,
                  t('Project', { ns: _translation.TRANSLATION_FILES.screens })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  null,
                  t('Custom Field', { ns: _translation.TRANSLATION_FILES.screens })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  null,
                  t('Created At', { ns: _translation.TRANSLATION_FILES.screens })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  null,
                  t('Progress', { ns: _translation.TRANSLATION_FILES.screens })
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Body,
              null,
              historyData && historyData.length > 0 ? historyData.map(function (item) {
                return _react2.default.createElement(
                  _semanticUiReact.Table.Row,
                  { key: item.id },
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    item.userName || '—'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    item.projectName || '—'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    null,
                    item.fieldLabel || '—'
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    { collapsing: true },
                    (0, _momentTimezone2.default)(item.createdAt).format('MMMM Do YYYY, h:mm a')
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Cell,
                    { width: 4 },
                    _this9.renderHistoryProgress(item)
                  )
                );
              }) : _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { colSpan: 5, textAlign: 'center' },
                  t('No bulk edit history found', { ns: _translation.TRANSLATION_FILES.screens }),
                  '.'
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Footer,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Table.HeaderCell,
                  { colSpan: 5, textAlign: 'center' },
                  _react2.default.createElement(_PageNav2.default, {
                    currentPage: historyPage,
                    count: historyCount,
                    limit: historyLimit,
                    offset: historyOffset,
                    dataSize: historyData && historyData.length || 0,
                    loading: historyLoading,
                    onChange: this.handleHistoryPageChange
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'bulk-edit-history-mobile' },
          historyData && historyData.length > 0 ? historyData.map(function (item) {
            return _react2.default.createElement(
              'div',
              { className: 'bulk-edit-history-card', key: item.id },
              _react2.default.createElement(
                'div',
                { className: 'bulk-edit-history-card-row' },
                _react2.default.createElement(
                  'span',
                  null,
                  t('Created By', { ns: _translation.TRANSLATION_FILES.screens })
                ),
                _react2.default.createElement(
                  'strong',
                  null,
                  item.userName || '—'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'bulk-edit-history-card-row' },
                _react2.default.createElement(
                  'span',
                  null,
                  t('Project', { ns: _translation.TRANSLATION_FILES.screens })
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  item.projectName || '—'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'bulk-edit-history-card-row' },
                _react2.default.createElement(
                  'span',
                  null,
                  t('Custom Field', { ns: _translation.TRANSLATION_FILES.screens })
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  item.fieldLabel || '—'
                )
              ),
              _react2.default.createElement(
                'div',
                { className: 'bulk-edit-history-card-row' },
                _react2.default.createElement(
                  'span',
                  null,
                  t('Created At', { ns: _translation.TRANSLATION_FILES.screens })
                ),
                _react2.default.createElement(
                  'span',
                  null,
                  (0, _momentTimezone2.default)(item.createdAt).format('MMMM Do YYYY, h:mm a')
                )
              ),
              _this9.renderHistoryProgress(item)
            );
          }) : _react2.default.createElement(
            'p',
            null,
            t('No bulk edit history found', { ns: _translation.TRANSLATION_FILES.screens }),
            '.'
          ),
          _react2.default.createElement(_PageNav2.default, {
            currentPage: historyPage,
            count: historyCount,
            limit: historyLimit,
            offset: historyOffset,
            dataSize: historyData && historyData.length || 0,
            loading: historyLoading,
            onChange: this.handleHistoryPageChange
          })
        )
      );
    }
  }, {
    key: 'renderModalContent',
    value: function renderModalContent() {
      var _state7 = this.state,
          selectedProjectID = _state7.selectedProjectID,
          projects = _state7.projects,
          selectedField = _state7.selectedField,
          currentStep = _state7.currentStep;
      var t = this.props.t;

      var options = (projects || []).map(function (project) {
        return {
          key: project.id,
          value: project.id,
          text: project.name
        };
      });
      if (!selectedProjectID) {
        return _react2.default.createElement(_semanticUiReact.Dropdown, {
          placeholder: t('Select Project', { ns: _translation.TRANSLATION_FILES.screens }),
          fluid: true,
          selection: true,
          search: true,
          options: options,
          value: selectedProjectID,
          onChange: this.handleProjectChange
        });
      }
      if (!selectedField) {
        return this.renderFieldSelect();
      }
      if (currentStep === 3) {
        return this.renderReviewConfirm();
      }
      if (currentStep === 2) {
        return this.renderValueSelect();
      }
      return this.renderBookingsList();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state8 = this.state,
          modalOpen = _state8.modalOpen,
          currentStep = _state8.currentStep,
          selectedProjectID = _state8.selectedProjectID,
          selectedBookingIDs = _state8.selectedBookingIDs,
          selectedField = _state8.selectedField,
          selectedValueOptionID = _state8.selectedValueOptionID,
          selectedValueOptionIDs = _state8.selectedValueOptionIDs,
          confirmChecked = _state8.confirmChecked,
          submitting = _state8.submitting,
          historyOngoing = _state8.historyOngoing;
      var t = this.props.t;

      var nextDisabled = true;
      if (selectedProjectID) {
        if (currentStep === 1) {
          nextDisabled = selectedBookingIDs.length === 0;
        } else if (currentStep === 2) {
          nextDisabled = selectedField.type === 'dropdown_multi' ? selectedValueOptionIDs.length === 0 : !selectedValueOptionID;
        }
      }
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Bulk Edit Custom Fields', { ns: _translation.TRANSLATION_FILES.screens }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Button,
            {
              primary: true,
              disabled: historyOngoing,
              title: historyOngoing ? t('A bulk edit is currently in progress', { ns: _translation.TRANSLATION_FILES.screens }) : undefined,
              onClick: this.handleEditClick
            },
            t('Begin Bulk Edit', { ns: _translation.TRANSLATION_FILES.screens })
          )
        }),
        this.renderHistoryTable(),
        this.renderFailedCodesModal(),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          { className: 'bulk-edit-modal', open: modalOpen, onClose: this.handleModalClose, size: 'large', closeIcon: true },
          _react2.default.createElement(
            _semanticUiReact.Modal.Header,
            null,
            t('Bulk Edit Custom Fields', { ns: _translation.TRANSLATION_FILES.screens })
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              'div',
              { style: { marginBottom: '1em' } },
              STEPS.map(function (step, index) {
                return _react2.default.createElement(
                  _semanticUiReact.Label,
                  {
                    key: step,
                    circular: true,
                    color: index === currentStep ? 'green' : undefined,
                    style: { marginRight: '0.5em' }
                  },
                  index + 1,
                  ' \xB7 ',
                  t(step, { ns: _translation.TRANSLATION_FILES.screens })
                );
              })
            ),
            this.renderModalContent()
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            (currentStep > 0 || selectedProjectID) && _react2.default.createElement(
              _semanticUiReact.Button,
              { floated: 'left', onClick: this.handleFooterBackClick },
              t('Back', { ns: _translation.TRANSLATION_FILES.translation })
            ),
            currentStep === 3 ? _react2.default.createElement(
              _react2.default.Fragment,
              null,
              _react2.default.createElement(
                _semanticUiReact.Button,
                { onClick: this.handleModalClose },
                t('Cancel', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  color: 'teal',
                  disabled: !confirmChecked,
                  loading: submitting,
                  onClick: this.handleConfirmSubmitClick
                },
                t('Confirm & Apply', { ns: _translation.TRANSLATION_FILES.screens })
              )
            ) : _react2.default.createElement(
              _semanticUiReact.Button,
              { primary: true, disabled: nextDisabled, onClick: this.handleNextClick },
              t('Next', { ns: _translation.TRANSLATION_FILES.screens })
            )
          )
        )
      );
    }
  }]);

  return CustomEdit;
}(_react.Component);

CustomEdit.propTypes = {
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
CustomEdit.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _checkChanges.checkChanges)(CustomEdit));

/***/ }),
/* 2280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CustomEdit = __webpack_require__(2279);

var _CustomEdit2 = _interopRequireDefault(_CustomEdit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CustomEdit2.default;

/***/ }),
/* 2281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Bookings = __webpack_require__(2257);

var _Bookings2 = _interopRequireDefault(_Bookings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Bookings2.default;

/***/ }),
/* 2282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _semanticUiReact = __webpack_require__(2);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _BusinessUnitActivities = __webpack_require__(1009);

var _BusinessUnitActivities2 = _interopRequireDefault(_BusinessUnitActivities);

var _translation = __webpack_require__(4);

var _navigations = __webpack_require__(1053);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


var Activities = function (_Component) {
  _inherits(Activities, _Component);

  function Activities(props) {
    _classCallCheck(this, Activities);

    var _this = _possibleConstructorReturn(this, (Activities.__proto__ || Object.getPrototypeOf(Activities)).call(this, props));

    _initialiseProps.call(_this);

    var state = Activities.getPropsToState(props);
    state.limit = 0;
    state.offset = 0;
    state.currentPage = parseInt(state.query.page, 10) || 1;
    state.count = 0;
    _this.state = state;
    return _this;
  }

  _createClass(Activities, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
      var query = this.props.location.query;

      this.getBusinessUnitActivities(query);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var query = nextProps.location.query;

      var state = Activities.getPropsToState(nextProps);
      if (this.state.activitiesData) {
        state.activitiesData = this.state.activitiesData;
      }
      this.setState(_extends({}, state), function () {
        if (!_this2.state.activitiesData) {
          _this2.getBusinessUnitActivities(query);
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'getBusinessUnitActivities',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var store, t, query, queryString, res, message, activitiesData, count, limit, offset;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                queryString = '';
                res = null;

                if (_qs2.default.stringify(query)) {
                  queryString = '?' + _qs2.default.stringify(query);
                }
                _context.prev = 9;
                _context.next = 12;
                return store.dispatch((0, _fetchM.fetchM)('/company_branches/' + this.props.routeParams.id + '/activities/' + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context.sent;
                _context.next = 26;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](9);
                _context.next = 19;
                return this.setLoading(false);

              case 19:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 24;
                  break;
                }

                _context.next = 22;
                return _context.t0.res.text();

              case 22:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 26:
                if (res.ok) {
                  _context.next = 32;
                  break;
                }

                _context.next = 29;
                return this.setLoading(false);

              case 29:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                _context.next = 42;
                break;

              case 32:
                _context.next = 34;
                return res.json();

              case 34:
                activitiesData = _context.sent;
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 40;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset,
                  activitiesData: activitiesData
                });

              case 40:
                _context.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 15]]);
      }));

      function getBusinessUnitActivities(_x3) {
        return _ref.apply(this, arguments);
      }

      return getBusinessUnitActivities;
    }()
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters) {
        return true;
      }
      if (this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'replaceQuery',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(query) {
        var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var store, queryNew;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                queryNew = query;

                if (resetPage) queryNew.page = 1;
                _context2.next = 7;
                return this.getBusinessUnitActivities(query);

              case 7:
                store.dispatch((0, _reactRouterRedux.replace)('/business_units/' + this.props.routeParams.id + '/activities/?' + (0, _url.encodeSearch)(queryNew)));
                _context2.next = 10;
                return this.setLoading(false);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function replaceQuery(_x5) {
        return _ref2.apply(this, arguments);
      }

      return replaceQuery;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var pathname = this.props.location.pathname;
      var activitiesData = this.state.activitiesData;
      var t = this.props.t;

      var links = (0, _navigations.routes)(this.props.routeParams.id).map(function (l) {
        return _extends({}, l, {
          text: t(l.text)
        });
      });
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: link.text,
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this5.handleMenu(e, link);
              }
            });
          })
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(_SearchFilter2.default, {
                isLoading: this.state.loading,
                onChange: this.handleOnChange,
                onClose: this.handleClearFilter,
                search: this.state.search,
                placeholder: t('Search'),
                setAdvanceFilter: function setAdvanceFilter() {},
                leftNav: _react2.default.createElement(_PageNav2.default, {
                  currentPage: this.state.currentPage,
                  count: this.state.count,
                  limit: this.state.limit,
                  offset: this.state.offset,
                  dataSize: this.state.activitiesData.length,
                  loading: this.state.loading,
                  onChange: this.handleChangePage
                }),
                rightNav: _react2.default.createElement(_SortButton2.default, {
                  floated: 'right',
                  loading: this.state.loading,
                  items: this.sortItems,
                  onSort: this.handleSortData
                })
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, textAlign: 'center' },
              _react2.default.createElement(_semanticUiReact.Divider, { horizontal: true }),
              _react2.default.createElement(
                _semanticUiReact.Segment,
                null,
                _react2.default.createElement(_BusinessUnitActivities2.default, {
                  data: activitiesData || [],
                  hasAccess: this.hasAccess(),
                  loading: this.state.loading
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Activities;
}(_react.Component);

Activities.contextTypes = {
  store: _propTypes2.default.object
};
Activities.propTypes = {
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool
  }),
  routeParams: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};

Activities.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

Activities.getPropsToState = function (props) {
  var loading = props.loading;
  var data = props.data || [];
  var query = (0, _url.decodeSearch)(props.location.search);
  var search = query.search || '';
  var activitiesData = [];
  var menuIsTab = window.innerWidth <= 590;
  return {
    data: data,
    loading: loading,
    query: query,
    search: search,
    activitiesData: activitiesData,
    menuIsTab: menuIsTab
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.handleResize = function () {
    var state = {};
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this6.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    var unitLayoutResize = window.innerWidth < 768;
    if (unitLayoutResize !== _this6.state.unitLayoutResize) {
      state.unitLayoutResize = unitLayoutResize;
    }
    var galleryIsTab = window.innerWidth > 425;
    if (galleryIsTab !== _this6.state.galleryIsTab) {
      state.galleryIsTab = galleryIsTab;
    }
    var locationResize = window.innerWidth <= 375;
    if (locationResize !== _this6.state.locationResize) {
      state.locationResize = locationResize;
    }
    _this6.setState(_extends({}, state));
  };

  this.handleMenu = function (e, _ref3) {
    var value = _ref3.value;
    var store = _this6.context.store;

    if (value.includes(_config2.default.get('bookApiURL'))) {
      e.preventDefault();
      var winObj = window.open(value, '_blank');
      winObj.opener = null;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(value));
    }
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.page = currentPage;
    _this6.setState({
      currentPage: currentPage
    });
    _this6.replaceQuery(query);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this6.replaceQuery(query);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    if (hasQuery) {
      _this6.replaceQuery(query, true);
    } else {
      _this6.setState({ search: '' });
    }
  };

  this.handleOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query[queryName] = value;
    _this6.replaceQuery(query, true);
  };

  this.sortItems = [{
    text: 'Date Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'business_unit_activity.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Date Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'business_unit_activity.created_at',
    sortDirection: 'desc'
  }];
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Activities.mapStateToProps)(Activities));

/***/ }),
/* 2283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _List = __webpack_require__(2285);

var _List2 = _interopRequireDefault(_List);

var _Overview = __webpack_require__(2287);

var _Overview2 = _interopRequireDefault(_Overview);

var _New = __webpack_require__(2286);

var _New2 = _interopRequireDefault(_New);

var _Activities = __webpack_require__(2282);

var _Activities2 = _interopRequireDefault(_Activities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BusinessUnits = function (_Component) {
  _inherits(BusinessUnits, _Component);

  function BusinessUnits() {
    _classCallCheck(this, BusinessUnits);

    return _possibleConstructorReturn(this, (BusinessUnits.__proto__ || Object.getPrototypeOf(BusinessUnits)).apply(this, arguments));
  }

  _createClass(BusinessUnits, [{
    key: 'renderChild',
    value: function renderChild() {
      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return BusinessUnits;
}(_react.Component);

BusinessUnits.propTypes = {
  children: _propTypes2.default.node
};
BusinessUnits.contextTypes = {
  store: _propTypes2.default.object
};
BusinessUnits.List = _List2.default;
BusinessUnits.Overview = _Overview2.default;
BusinessUnits.Activities = _Activities2.default;
BusinessUnits.New = _New2.default;
exports.default = BusinessUnits;

/***/ }),
/* 2284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _reactI18next = __webpack_require__(3);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _states = __webpack_require__(144);

var _states2 = _interopRequireDefault(_states);

var _countries = __webpack_require__(60);

var _reservationLimit = __webpack_require__(1047);

var _reservationLimit2 = _interopRequireDefault(_reservationLimit);

var _phone = __webpack_require__(146);

var _phone2 = _interopRequireDefault(_phone);

var _intlCallCodes = __webpack_require__(116);

var _intlCallCodes2 = _interopRequireDefault(_intlCallCodes);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _ListItem = __webpack_require__(261);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _PhoneInput = __webpack_require__(104);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

var _ProjectsList = __webpack_require__(400);

var _ProjectsList2 = _interopRequireDefault(_ProjectsList);

var _businessUnitStatusFilter = __webpack_require__(582);

var _businessUnitStatusFilter2 = _interopRequireDefault(_businessUnitStatusFilter);

var _companies = __webpack_require__(88);

var _intlFlagCodes = __webpack_require__(141);

var _intlFlagCodes2 = _interopRequireDefault(_intlFlagCodes);

var _TinFieldInput = __webpack_require__(192);

var _TinFieldInput2 = _interopRequireDefault(_TinFieldInput);

var _regex = __webpack_require__(143);

var _identityTypes = __webpack_require__(174);

var _translation = __webpack_require__(4);

var _translation2 = __webpack_require__(64);

var _tin = __webpack_require__(155);

var _defaultIdentityTypeOpts = __webpack_require__(154);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BusinessUnitForm = function (_Component) {
  _inherits(BusinessUnitForm, _Component);

  function BusinessUnitForm(props) {
    _classCallCheck(this, BusinessUnitForm);

    var _this = _possibleConstructorReturn(this, (BusinessUnitForm.__proto__ || Object.getPrototypeOf(BusinessUnitForm)).call(this, props));

    _initialiseProps.call(_this);

    var businessUnit = (0, _clone2.default)(BusinessUnitForm.defaultBusinessUnit);
    businessUnit.user = (0, _clone2.default)(BusinessUnitForm.defaultUser);
    var tinError = null;
    var auth = props.auth;

    if (auth && (0, _companies.isForeignCompany)(auth.company)) {
      var idx = _intlFlagCodes2.default.findIndex(function (f) {
        return f.countryCode === auth.company.countryCode;
      });
      if (idx !== -1) {
        businessUnit.phonePrefix = _intlFlagCodes2.default[idx].value;
        businessUnit.country = _intlFlagCodes2.default[idx].countryCode;
      }
    }
    _this.state = {
      businessUnit: businessUnit,
      errMessages: [],
      tinMessage: null,
      showAddProject: false,
      tinError: tinError,
      tinEnabled: true,
      tinRequired: false
    };
    _this.validation = {
      name: (0, _react.createRef)(),
      shortName: (0, _react.createRef)(),
      department: (0, _react.createRef)(),
      taxIdentificationNo: (0, _react.createRef)(),
      registrationNumber: (0, _react.createRef)(),
      referenceCode: (0, _react.createRef)(),
      email: (0, _react.createRef)(),
      phonePrefix: (0, _react.createRef)(),
      phone: (0, _react.createRef)(),
      address1: (0, _react.createRef)(),
      address2: (0, _react.createRef)(),
      postcode: (0, _react.createRef)(),
      city: (0, _react.createRef)(),
      state: (0, _react.createRef)(),
      country: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(BusinessUnitForm, [{
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'validateTIN',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tinInput) {
        var registrationNumber, idType, query, store, res, errorMessage, _errorMessage;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                registrationNumber = this.state.businessUnit.registrationNumber;

                if (!(!tinInput || !registrationNumber)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                idType = (0, _identityTypes.getIdentityTypeOpts)().find(function (i) {
                  return i.value === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN;
                }).tin_code;
                query = Object.assign({
                  tin: tinInput,
                  idType: idType,
                  idValue: registrationNumber
                });
                store = this.context.store;
                _context.prev = 6;
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/tin/validate/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token,
                    'X-Origin': this.state.origin
                  }
                }));

              case 9:
                res = _context.sent;

                if (!(res && res.ok)) {
                  _context.next = 14;
                  break;
                }

                this.setState({
                  tinError: false,
                  tinMessage: null
                });
                _context.next = 19;
                break;

              case 14:
                _context.next = 16;
                return res.text();

              case 16:
                errorMessage = _context.sent;

                this.setState({
                  tinError: true,
                  tinMessage: errorMessage
                });
                return _context.abrupt('return');

              case 19:
                _context.next = 28;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context['catch'](6);

                if (!_context.t0.res) {
                  _context.next = 28;
                  break;
                }

                _context.next = 26;
                return _context.t0.res.text();

              case 26:
                _errorMessage = _context.sent;

                this.setState({
                  tinError: true,
                  tinMessage: _errorMessage
                });

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 21]]);
      }));

      function validateTIN(_x) {
        return _ref.apply(this, arguments);
      }

      return validateTIN;
    }()
  }, {
    key: 'fetchBusinessUnit',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context2.prev = 4;
                _context2.next = 7;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/company_branches/' + this.props.routeParams.id + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context2.sent;
                _context2.next = 18;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](4);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context2.next = 17;
                return this.setLoading(false);

              case 17:
                return _context2.abrupt('return');

              case 18:
                if (res.ok) {
                  _context2.next = 26;
                  break;
                }

                _context2.next = 21;
                return res.text();

              case 21:
                message = _context2.sent;
                _context2.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context2.next = 33;
                break;

              case 26:
                token = res.headers.get('X-Csrf-Token');
                _context2.next = 29;
                return res.json();

              case 29:
                data = _context2.sent;
                _context2.next = 32;
                return this.setComponentState({
                  token: token,
                  data: data
                });

              case 32:
                this.setState({
                  oriData: (0, _clone2.default)(data)
                });

              case 33:
                _context2.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10]]);
      }));

      function fetchBusinessUnit() {
        return _ref2.apply(this, arguments);
      }

      return fetchBusinessUnit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          auth = _props.auth;
      var businessUnit = this.state.businessUnit;

      var tinContent = businessUnit.taxIdentificationNo || this.state.tinRequired;
      var isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';

      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref3) {
            _this2.form = _ref3;
          }
        },
        _react2.default.createElement(_ProjectsList2.default, {
          open: this.state.showAddProject,
          onClose: this.handleCloseAddProject,
          onConfirm: this.handleAddProject,
          onCheck: function onCheck(project) {
            return project.loanTrackerProjectID < 1;
          },
          selected: businessUnit ? businessUnit.branchProjects : []
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Business Unit Name') + '*',
                  validateLabel: t('Name'),
                  name: 'name',
                  value: businessUnit.name,
                  onChange: this.handleInputChange,
                  ref: this.validation.name,
                  validation: [_webValidations.required]
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Business Unit Short Name') + '*',
                  validateLabel: t('Short name'),
                  name: 'shortName',
                  value: businessUnit.shortName,
                  onChange: this.handleInputChange,
                  ref: this.validation.shortName,
                  validation: [_webValidations.required]
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal', style: { alignItems: 'center' } },
                _react2.default.createElement(_semanticUiReact.Form.Select, {
                  autoComplete: 'off',
                  label: t('Reservation Limit'),
                  fluid: true,
                  name: 'reservationLimit',
                  options: _reservationLimit2.default.map(function (option) {
                    return _extends({}, option, {
                      text: option.text === 'Unlimited' ? t('Unlimited', { ns: _translation.TRANSLATION_FILES.constants }) : option.text
                    });
                  }),
                  placeholder: (0, _translation2.translateModels)(t, 'Select Limit', 'businessUnit'),
                  search: true,
                  selectOnBlur: false,
                  value: businessUnit.reservationLimit,
                  onChange: this.handleInputChange
                }),
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: t('Agency'),
                  name: 'isExternal',
                  checked: businessUnit.isExternal,
                  onChange: this.handleCheckBoxChange
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: (0, _translation2.translateModels)(t, 'department', 'businessUnit'),
                  validateLabel: (0, _translation2.translateModels)(t, 'department', 'businessUnit'),
                  name: 'department',
                  value: businessUnit.department,
                  onChange: this.handleInputChange,
                  ref: this.validation.department
                }),
                _react2.default.createElement(_semanticUiReact.Form.Field, null)
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  null,
                  _react2.default.createElement(_AppForm2.default.Input, {
                    label: (0, _translation2.translateModels)(t, 'registrationNumber', 'businessUnit'),
                    validateLabel: (0, _translation2.translateModels)(t, 'registrationNumber', 'businessUnit'),
                    name: 'registrationNumber',
                    required: tinContent,
                    validation: tinContent ? [_webValidations.required, {
                      validate: _webValidations.identity,
                      option: {
                        countryCode: 'MY',
                        identityType: 'other'
                      }
                    }] : [{
                      validate: _webValidations.identity,
                      option: {
                        countryCode: 'MY',
                        identityType: 'other'
                      }
                    }],
                    value: businessUnit.registrationNumber,
                    onChange: this.handleInputChange,
                    ref: this.validation.registrationNumber
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  null,
                  _react2.default.createElement(_TinFieldInput2.default, {
                    isIndonesia: isIndonesia,
                    value: businessUnit.taxIdentificationNo,
                    errMessage: this.state.tinMessage,
                    isLoading: this.state.validatingTin,
                    tinError: !isIndonesia && this.state.tinError,
                    required: !isIndonesia && this.state.tinRequired,
                    disabled: !this.state.tinEnabled,
                    ref: this.validation.taxIdentificationNo,
                    onChange: this.handleTinInput,
                    validation: !isIndonesia && this.state.tinRequired ? [_webValidations.required, {
                      validate: _webValidations.matchRegex,
                      option: {
                        validRegex: _regex.REGEX_TIN_VALID
                      }
                    }] : [{
                      validate: _webValidations.matchRegex,
                      option: {
                        validRegex: isIndonesia ? _regex.REGEX_NPWP_ID : _regex.REGEX_TIN_VALID
                      }
                    }],
                    identityType: _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN,
                    identityValue: businessUnit.registrationNumber
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  autoComplete: 'off',
                  label: (0, _translation2.translateModels)(t, 'referenceCode', 'businessUnit'),
                  name: 'referenceCode',
                  onChange: this.handleInputChange,
                  value: businessUnit.referenceCode,
                  ref: this.validation.referenceCode
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: t('Email'),
                  validateLabel: t('Email'),
                  name: 'email',
                  value: businessUnit.email,
                  onChange: this.handleInputChange,
                  ref: this.validation.email
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    validation: [_webValidations.required],
                    ref: this.validation.phonePrefix,
                    onChange: this.handleInputChange,
                    validateLabel: t('Phone prefix')
                  },
                  _react2.default.createElement(_semanticUiReact.Form.Select, {
                    label: t('Phone prefix'),
                    name: 'phonePrefix',
                    value: businessUnit.phonePrefix,
                    search: true,
                    options: _intlCallCodes2.default
                  })
                ),
                _react2.default.createElement(_PhoneInput2.default, {
                  label: t('Phone'),
                  validateLabel: t('Phone'),
                  type: 'tel',
                  name: 'phone',
                  value: businessUnit.phone,
                  onChange: this.handleInputChange,
                  prefix: businessUnit.phonePrefix,
                  ref: this.validation.phone,
                  validation: [_phone2.default]
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  autoComplete: 'off',
                  label: t('Address') + ' 1*',
                  name: 'address1',
                  onChange: this.handleInputChange,
                  placeholder: t('Address') + ' 1*',
                  ref: this.validation.address1,
                  validation: [_webValidations.required, {
                    validate: _webValidations.stringLength,
                    option: {
                      max: 256
                    }
                  }],
                  value: businessUnit.address1,
                  validateLabel: t('Address') + ' 1'
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  autoComplete: 'off',
                  label: t('Address') + ' 2',
                  name: 'address2',
                  onChange: this.handleInputChange,
                  placeholder: t('Address') + ' 2',
                  value: businessUnit.address2,
                  ref: this.validation.address2,
                  validation: [{
                    validate: _webValidations.stringLength,
                    option: {
                      max: 256
                    }
                  }],
                  validateLabel: t('Address') + ' 2'
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  autoComplete: 'off',
                  label: t('Postcode') + '*',
                  name: 'postcode',
                  onChange: this.handleInputChange,
                  placeholder: t('Postcode') + '*',
                  value: businessUnit.postcode,
                  ref: this.validation.postcode,
                  validation: [_webValidations.required],
                  validateLabel: t('Postcode')
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  autoComplete: 'off',
                  label: t('City') + '*',
                  name: 'city',
                  onChange: this.handleInputChange,
                  placeholder: t('City') + '*',
                  value: businessUnit.city,
                  ref: this.validation.city,
                  validation: [_webValidations.required],
                  validateLabel: t('City')
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                businessUnit.country.toUpperCase() === 'my'.toUpperCase() ? _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    validation: [_webValidations.required],
                    ref: this.validation.state,
                    onChange: this.handleInputChange,
                    validateLabel: t('State')
                  },
                  _react2.default.createElement(_semanticUiReact.Form.Select, {
                    fluid: true,
                    label: t('State') + '*',
                    name: 'state',
                    options: _states2.default,
                    placeholder: t('Select State') + '*',
                    search: true,
                    selectOnBlur: false,
                    value: businessUnit.state
                  })
                ) : _react2.default.createElement(_AppForm2.default.Input, {
                  autoComplete: 'off',
                  fluid: true,
                  label: t('State') + '*',
                  name: 'state',
                  onChange: this.handleInputChange,
                  placeholder: t('State') + '*',
                  ref: this.validation.state,
                  validation: [_webValidations.required],
                  value: businessUnit.state,
                  validateLabel: t('State')
                }),
                _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    validation: [_webValidations.required],
                    ref: this.validation.country,
                    onChange: function onChange(e, data) {
                      // Reset state input field
                      businessUnit.state = '';
                      _this2.setState({ businessUnit: businessUnit });
                      _this2.handleInputChange(e, data);
                    },
                    validateLabel: t('Country')
                  },
                  _react2.default.createElement(_semanticUiReact.Form.Select, {
                    autoComplete: 'off',
                    fluid: true,
                    label: t('Country') + '*',
                    name: 'country',
                    options: _countries.SELECT_COUNTRIES,
                    placeholder: t('Select Country') + '*',
                    search: true,
                    selectOnBlur: false,
                    value: businessUnit.country
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  autoComplete: 'off',
                  label: (0, _translation2.translateModels)(t, 'gps', 'businessUnit'),
                  name: 'gps',
                  onChange: this.handleInputChange,
                  placeholder: (0, _translation2.translateModels)(t, 'gps', 'businessUnit')
                }),
                _react2.default.createElement(_semanticUiReact.Form.Select, {
                  autoComplete: 'off',
                  label: t('Access'),
                  name: 'statusID',
                  options: _businessUnitStatusFilter2.default.map(function (status) {
                    return _extends({}, status, {
                      text: t(status.text)
                    });
                  }),
                  placeholder: t('Select Access'),
                  selectOnBlur: false,
                  value: businessUnit.statusID,
                  onChange: this.handleInputChange
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                null,
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: t('View all projects'),
                  name: 'viewAllProjects',
                  checked: businessUnit.viewAllProjects,
                  onChange: this.handleOnCheck
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                null,
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: t('View archived projects'),
                  name: 'viewArchivedProjects',
                  checked: businessUnit.viewArchivedProjects,
                  onChange: this.handleOnCheck,
                  disabled: !businessUnit.viewAllProjects
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                null,
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: t('View draft projects'),
                  name: 'viewDraftProjects',
                  checked: businessUnit.viewDraftProjects,
                  onChange: this.handleOnCheck,
                  disabled: !businessUnit.viewAllProjects
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                null,
                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                  label: t('View ready projects'),
                  name: 'viewReadyProjects',
                  checked: businessUnit.viewReadyProjects,
                  onChange: this.handleOnCheck,
                  disabled: !businessUnit.viewAllProjects
                })
              )
            )
          ),
          businessUnit && !businessUnit.viewAllProjects ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                'Projects'
              ),
              businessUnit.projects && businessUnit.projects.length > 0 ? _react2.default.createElement(
                _semanticUiReact.Table,
                { unstackable: true },
                _react2.default.createElement(
                  _semanticUiReact.Table.Body,
                  null,
                  businessUnit.projects.map(function (project, idx) {
                    return _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      { key: idx },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(_ListItem2.default, {
                          item: project,
                          header: function header(item) {
                            return item.name;
                          },
                          subheader: function subheader(item) {
                            return item.status.name;
                          },
                          rightComponent: _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(_semanticUiReact.Button, {
                              type: 'button',
                              compact: true,
                              negative: true,
                              size: 'mini',
                              icon: 'remove',
                              onClick: function onClick() {
                                return _this2.handleRemoveProject(idx);
                              }
                            })
                          )
                        })
                      )
                    );
                  })
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Segment,
                { textAlign: 'center' },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  'Loading'
                ) : 'No Business Unit found.'
              )
            )
          ) : null,
          businessUnit && !businessUnit.viewAllProjects ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              _react2.default.createElement(_semanticUiReact.Button, {
                content: 'Add project',
                onClick: this.handleShowAddProject
              })
            )
          ) : null
        )
      );
    }
  }]);

  return BusinessUnitForm;
}(_react.Component);

BusinessUnitForm.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  routeParams: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  t: _propTypes2.default.func
};
BusinessUnitForm.contextTypes = {
  store: _propTypes2.default.object
};
BusinessUnitForm.defaultBusinessUnit = {
  registrationNumber: '',
  taxIdentificationNo: '',
  taxTinValidationStatus: 'failed',
  name: '',
  shortName: '',
  email: '',
  phonePrefix: '60',
  phone: '',
  department: '',
  address1: '',
  address2: '',
  city: '',
  postcode: '',
  state: '',
  country: 'my',
  gps: '',
  viewAllProjects: true,
  viewArchivedProjects: true,
  viewDraftProjects: true,
  viewReadyProjects: true,
  branchProjects: [],
  reservationLimit: '0',
  statusID: 'active'
};
BusinessUnitForm.defaultUser = {
  id: null,
  groups: []
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var loadingType = arguments[1];
    return new Promise(function (res) {
      if (loadingType === 'validatingTIN') {
        _this3.setState({ validatingTin: loading }, res);
      }
    });
  };

  this.handleSubmit = function (event) {
    event.preventDefault();
    var businessUnit = _this3.state.businessUnit;

    return _AppForm2.default.validate(_this3.validation, businessUnit).then(function (validations) {
      _this3.setState({
        errMessages: validations.filter(function (v) {
          return !v.isValid;
        })
      });

      businessUnit.taxTinValidationStatus = _this3.state.tinError === false ? 'success' : 'failed';

      if (_this3.state.errMessages.length === 0 && _this3.state.tinRequired && businessUnit.taxTinValidationStatus !== 'success') {
        var store = _this3.context.store;

        if (businessUnit.taxTinValidationStatus !== 'success') {
          store.dispatch((0, _flash.flashMessage)({
            header: 'Invalid TIN',
            message: 'Tax Identification Number is invalid',
            icon: 'warning sign',
            type: 'error',
            autoHideDuration: 5000
          }));
          return;
        }
      }
      _this3.props.onSubmit(validations, businessUnit);
    });
  };

  this.handleInputChange = function (event, data) {
    var businessUnit = _this3.state.businessUnit;

    businessUnit[data.name] = data.value;
    _this3.setState({ businessUnit: businessUnit }, function () {
      // Validate TIN again on registrationNumber change.
      if (data.name === 'registrationNumber') {
        if (businessUnit.taxIdentificationNo !== '') {
          _this3.handleTinInput({ target: { value: businessUnit.taxIdentificationNo } });
        }
      }
      _this3.handleCheckChanges();
    });
  };

  this.handleTinInput = function (e) {
    var auth = _this3.props.auth;
    var businessUnit = _this3.state.businessUnit;

    var isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';

    if (isIndonesia) {
      _this3.state.businessUnit.taxIdentificationNo = e.target.value;
      _this3.setState({ taxIdentificationNo: e.target.value, businessUnit: businessUnit, tinError: false });
      return;
    }

    var tinInput = e.target.value;
    var isAlphanumeric = /^[a-zA-Z0-9]*$/.test(tinInput);

    if (tinInput === '') {
      _this3.state.businessUnit.taxIdentificationNo = '';
      _this3.setState({ taxIdentificationNo: '', businessUnit: businessUnit, tinError: false });
      return;
    }

    if (isAlphanumeric) {
      businessUnit.taxIdentificationNo = tinInput;
      _this3.setState({ businessUnit: businessUnit, tinError: true }, function () {
        _this3.handleCheckChanges();
      });
      // 1~2 letter followed by numeric with length 9 - 11
      var matched = _regex.REGEX_TIN_VALID.test(tinInput);
      var genericTin = (0, _tin.getGenericTinByIdTypeAndTinNo)(_defaultIdentityTypeOpts.IDENTITY_TYPE_BRN, tinInput);
      _this3.setLoading(true, 'validatingTIN').then(function () {
        if (_this3.debounceTimeout) {
          clearTimeout(_this3.debounceTimeout);
        }

        _this3.debounceTimeout = setTimeout(function () {
          if (matched) {
            if (tinInput === _tin.GOVERNMENT_GENERIC_TIN) {
              _this3.setState({
                tinError: false,
                // tinFound: true,
                tinMessage: null }, function () {
                _this3.setState({ validatingTin: false });
              });
            } else if (_tin.GENERIC_TIN_VALUES.includes(tinInput)) {
              _this3.setState({
                tinError: !(0, _tin.isGenericTinFound)(genericTin),
                // tinFound: isGenericTinFound(genericTin),
                tinMessage: !(0, _tin.isGenericTinFound)(genericTin) ? _tin.GENERIC_TIN_UNMATCHED_ERROR_MSG : null }, function () {
                _this3.setState({ validatingTin: false });
              });
            } else {
              _this3.validateTIN(tinInput).finally(function () {
                _this3.setState({ validatingTin: false });
              });
            }
          } else {
            _this3.setState({ tinError: true }, function () {
              _this3.setState({ validatingTin: false });
            });
          }
        }, 3000);
      });
    }
  };

  this.handleCheckBoxChange = function (event, d) {
    var businessUnit = _this3.state.businessUnit;

    businessUnit[d.name] = !businessUnit[d.name];
    _this3.setState({ businessUnit: businessUnit });
  };

  this.handleRemoveProject = function (index) {
    if (_this3.state.edit) {
      var businessUnit = _this3.state.businessUnit;

      businessUnit.projects.splice(index, 1);
      _this3.setState({ businessUnit: businessUnit });
    }
  };

  this.handleAddProject = function (e, projects) {
    e.preventDefault();
    var businessUnit = _this3.state.businessUnit;

    businessUnit.projects = projects;
    _this3.setState({
      businessUnit: businessUnit,
      showAddProject: false
    });
  };

  this.handleShowAddProject = function (e) {
    e.preventDefault();
    _this3.setState({
      showAddProject: true
    });
  };

  this.handleCloseAddProject = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this3.setState({
      showAddProject: false
    });
  };

  this.handleCheckBoxChange = function (event, d) {
    var businessUnit = _this3.state.businessUnit;

    businessUnit[d.name] = !businessUnit[d.name];
    if (d.name === 'isExternal') {
      businessUnit.viewArchivedProjects = !businessUnit.isExternal;
      businessUnit.viewDraftProjects = !businessUnit.isExternal;
      businessUnit.viewReadyProjects = !businessUnit.isExternal;
    }
    _this3.setState({ businessUnit: businessUnit });
  };

  this.handleOnCheck = function (event, value) {
    var businessUnit = _this3.state.businessUnit;

    businessUnit[value.name] = !businessUnit[value.name];
    if (value.name === 'viewAllProjects' && !businessUnit.viewAllProjects) {
      businessUnit.viewArchivedProjects = !businessUnit.isExternal;
      businessUnit.viewDraftProjects = !businessUnit.isExternal;
      businessUnit.viewReadyProjects = !businessUnit.isExternal;
    }
    _this3.setState({ businessUnit: businessUnit });
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.businessUnit]), { withRef: true })(BusinessUnitForm);

/***/ }),
/* 2285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _reactRedux = __webpack_require__(9);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _Filters = __webpack_require__(86);

var _businessUnitStatusFilter = __webpack_require__(582);

var _businessUnitStatusFilter2 = _interopRequireDefault(_businessUnitStatusFilter);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BusinessUnitList = function (_Component) {
  _inherits(BusinessUnitList, _Component);

  function BusinessUnitList(props) {
    _classCallCheck(this, BusinessUnitList);

    var _this = _possibleConstructorReturn(this, (BusinessUnitList.__proto__ || Object.getPrototypeOf(BusinessUnitList)).call(this, props));

    _initialiseProps.call(_this);

    var query = (0, _url.decodeSearch)(props.location.search);
    var search = query.search || '';
    var statusFilter = query.statusFilter || '';
    _this.state = {
      data: [],
      count: 0,
      limit: 0,
      offset: 0,
      currentPage: parseInt(query.page, 10) || 1,
      search: search,
      advanceFilter: false,
      statusFilter: statusFilter,
      token: null,
      loading: true,
      isMobile: window.innerWidth < 768
    };
    if (query.statusFilter && query.statusFilter.length > 0) {
      _this.state.advanceFilter = true;
    }
    return _this;
  }

  _createClass(BusinessUnitList, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      window.addEventListener('resize', this.handleResize);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var store = this.context.store;
      var query = this.props.location.query;

      if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
        delete query.page;
      }
      if (!this.hasAccess()) {
        store.dispatch((0, _reactRouterRedux.replace)('/forbidden/'));
        return;
      }
      window.addEventListener('resize', this.handleResize, false);
      store.dispatch((0, _reactRouterRedux.replace)('/business_units/?' + _qs2.default.stringify(query)));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var query = nextProps.location.query;

      this.fetchBusinessUnits(query);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setBusinessUnits',
    value: function setBusinessUnits() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var limit = arguments[1];

      return new Promise(function (res) {
        _this2.setState({
          data: data ? data.slice(0, limit) : []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'getAccessStatus',
    value: function getAccessStatus(value) {
      var t = this.props.t;

      var status = _businessUnitStatusFilter2.default.find(function (s) {
        return s.value === value;
      });
      if (status) {
        return t(status.text, { ns: _translation.TRANSLATION_FILES.constants });
      }
      return '';
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'fetchBusinessUnits',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var store, t, query, res, message, token, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;

                if (!('statusFilter' in q)) {
                  q.statusFilter = 'active';
                }
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                res = void 0;
                _context.prev = 8;
                _context.next = 11;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/company_branches/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 11:
                res = _context.sent;
                _context.next = 22;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](8);

                Bugsnag.notifyException(_context.t0);
                _context.next = 19;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 19:
                _context.next = 21;
                return this.setLoading(false);

              case 21:
                return _context.abrupt('return');

              case 22:
                if (res.ok) {
                  _context.next = 30;
                  break;
                }

                _context.next = 25;
                return res.text();

              case 25:
                message = _context.sent;
                _context.next = 28;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 28:
                _context.next = 41;
                break;

              case 30:
                token = res.headers.get('X-Csrf-Token');
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 36;
                return res.json();

              case 36:
                data = _context.sent;
                _context.next = 39;
                return this.setBusinessUnits(data, limit);

              case 39:
                _context.next = 41;
                return this.setComponentState({
                  token: token,
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 41:
                _context.next = 43;
                return this.setLoading(false);

              case 43:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 14]]);
      }));

      function fetchBusinessUnits(_x5) {
        return _ref.apply(this, arguments);
      }

      return fetchBusinessUnits;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var store = this.context.store;

      store.dispatch((0, _reactRouterRedux.push)('/business_units/?' + (0, _url.encodeSearch)(query)));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var store = this.context.store;
      var isMobile = this.state.isMobile;
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('List'),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              primary: true,
              icon: 'add',
              content: t('Business Unit'),
              disabled: this.state.loading,
              onClick: function onClick() {
                return store.dispatch((0, _reactRouterRedux.push)('/business_units/new/'));
              }
            })
          )
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _SearchFilter2.default,
                {
                  advanceFilter: this.state.advanceFilter,
                  isLoading: this.state.loading,
                  onChange: this.handleOnChange,
                  onClose: this.handleClearFilter,
                  search: this.state.search,
                  setAdvanceFilter: this.handleSetAdvanceFilter,
                  leftNav: _react2.default.createElement(_PageNav2.default, {
                    currentPage: this.state.currentPage,
                    count: this.state.count,
                    limit: this.state.limit,
                    offset: this.state.offset,
                    dataSize: this.state.data.length,
                    loading: this.state.loading,
                    onChange: this.handleChangePage
                  }),
                  rightNav: _react2.default.createElement(_SortButton2.default, {
                    loading: this.state.loading,
                    items: this.sortItems,
                    onSort: this.handleSortData
                  })
                },
                _react2.default.createElement(_Filters.SelectList, {
                  filterName: 'statusFilter',
                  headerText: null,
                  onChange: this.handleOnChange,
                  onClose: this.handleClearFilter,
                  options: _businessUnitStatusFilter2.default.map(function (s) {
                    return _extends({}, s, {
                      text: t(s.text, { ns: _translation.TRANSLATION_FILES.constants })
                    });
                  }),
                  placeholder: t('Select Status'),
                  value: this.state.statusFilter
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                {
                  inverted: true,
                  active: this.state.loading && this.state.data.length > 0
                },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table,
                {
                  celled: true,
                  selectable: true,
                  compact: true,
                  className: 'app--tablelist'
                },
                _react2.default.createElement(
                  _semanticUiReact.Table.Header,
                  { className: 'mobile-hide' },
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Name')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Short Name')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      { textAlign: isMobile ? 'left' : 'center' },
                      t('Agency')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      { textAlign: isMobile ? 'left' : 'center' },
                      t('Reservation Limit')
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Body,
                  null,
                  this.state.data.length > 0 ? this.state.data.map(function (data, idx) {
                    return _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      {
                        key: idx,
                        title: t('View Business Unit'),
                        onClick: function onClick() {
                          return store.dispatch((0, _reactRouterRedux.push)('/business_units/' + data.id + '/'));
                        }
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'id card outline', className: 'computer-hide' }),
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { to: '/business_units/' + data.id + '/' },
                          _react2.default.createElement(
                            'b',
                            null,
                            data.name
                          ),
                          '\xA0',
                          _react2.default.createElement(_semanticUiReact.Icon, { style: { float: 'right' }, name: 'chevron right', className: 'computer-hide' })
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Label,
                          { size: 'mini', style: { marginLeft: '0.5em' } },
                          _this5.getAccessStatus(data.statusID)
                        ),
                        _this5.props.auth.companyBranch && _this5.props.auth.companyBranch.id === data.id ? _react2.default.createElement(
                          _semanticUiReact.Label,
                          { size: 'mini', pointing: 'left' },
                          t('Your branch')
                        ) : ''
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'user', className: 'computer-hide' }),
                        data.shortName
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { textAlign: isMobile ? 'left' : 'center' },
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'home', className: 'computer-hide' }),
                        _react2.default.createElement(_semanticUiReact.Label, { size: 'mini', color: data.isExternal ? 'teal' : 'grey', content: t(data.isExternal ? 'Agency' : 'Non-Agency') })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { textAlign: isMobile ? 'left' : 'center' },
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'building', className: 'computer-hide' }),
                        ' ',
                        data.reservationLimit
                      )
                    );
                  }) : _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      { colSpan: '4', textAlign: 'center' },
                      this.state.loading ? _react2.default.createElement(
                        _semanticUiReact.Loader,
                        { active: true, inline: 'centered' },
                        t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                      ) : _react2.default.createElement(
                        'p',
                        null,
                        t('No business units found')
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Footer,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      { colSpan: '4', textAlign: 'center' },
                      _react2.default.createElement(_PageNav2.default, {
                        upward: true,
                        currentPage: this.state.currentPage,
                        count: this.state.count,
                        limit: this.state.limit,
                        offset: this.state.offset,
                        dataSize: this.state.data.length,
                        loading: this.state.loading,
                        onChange: this.handleChangePage
                      })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return BusinessUnitList;
}(_react.Component);

BusinessUnitList.contextTypes = {
  store: _propTypes2.default.object
};
BusinessUnitList.propTypes = {
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    companyBranch: _propTypes2.default.shape({
      id: _propTypes2.default.number
    })
  })
};

BusinessUnitList.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.page = currentPage;
    _this6.setState({
      currentPage: currentPage
    });
    _this6.replaceQuery(query);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this6.replaceQuery(query);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      delete query[filter];
      if (filter === "search") {
        _this6.setState({
          search: ''
        });
      }
      if (filter === "statusFilter") {
        _this6.setState({
          statusFilter: ''
        });
      }
    });
    _this6.replaceQuery(query);
  };

  this.handleOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query[queryName] = value;
    if (queryName === "search") {
      _this6.setState({
        search: value
      });
    }
    if (queryName === "statusFilter") {
      _this6.setState({
        statusFilter: value
      });
    }
    _this6.replaceQuery(query);
  };

  this.handleSetAdvanceFilter = function (advanceFilter) {
    _this6.setState({
      advanceFilter: advanceFilter
    });
  };

  this.handleResize = function () {
    var state = {};
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    if (isMobile !== _this6.state.isMobile) {
      state.isMobile = isMobile;
      _this6.setState(_extends({}, state));
    }
  };

  this.sortItems = [{
    text: 'Newest',
    icon: 'sort numeric descending',
    sortColumn: 'company_branch.created_at',
    sortDirection: 'desc'
  }, {
    text: 'Oldest',
    icon: 'sort numeric ascending',
    sortColumn: 'company_branch.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Name Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'company_branch.name',
    sortDirection: 'asc'
  }, {
    text: 'Name Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'company_branch.name',
    sortDirection: 'desc'
  }];
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(BusinessUnitList.mapStateToProps)(BusinessUnitList));

/***/ }),
/* 2286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(2284);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var New = function (_Component) {
  _inherits(New, _Component);

  function New(props) {
    _classCallCheck(this, New);

    var _this = _possibleConstructorReturn(this, (New.__proto__ || Object.getPrototypeOf(New)).call(this, props));

    _this.handleSubmit = function (event) {
      event.preventDefault();
      var store = _this.context.store;

      _this.form.handleSubmit(event).catch(function (err) {
        Bugsnag.notifyException(err);
        store.dispatch((0, _flash.flashErrorMessage)(err));
      });
    };

    _this.state = {
      token: null
    };
    return _this;
  }

  _createClass(New, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getToken();
    }
  }, {
    key: 'getToken',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, token;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                res = void 0;
                _context.prev = 2;
                _context.next = 5;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/company_branches/?token', {
                  credentials: 'include',
                  method: 'GET'
                }));

              case 5:
                res = _context.sent;
                _context.next = 14;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](2);

                Bugsnag.notifyException(_context.t0);
                _context.next = 13;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 13:
                return _context.abrupt('return');

              case 14:
                if (res.ok) {
                  _context.next = 22;
                  break;
                }

                _context.next = 17;
                return res.text();

              case 17:
                message = _context.sent;
                _context.next = 20;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 20:
                _context.next = 24;
                break;

              case 22:
                token = res.headers.get('X-Csrf-Token');

                this.setState({
                  token: token
                });

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));

      function getToken() {
        return _ref.apply(this, arguments);
      }

      return getToken;
    }()
  }, {
    key: 'submit',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(validations, businessUnitData) {
        var store, businessUnit, errors, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                businessUnit = Object.assign({}, businessUnitData);
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context2.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context2.abrupt('return');

              case 6:
                businessUnit.reservationLimit = parseInt(businessUnitData.reservationLimit, 10);
                _context2.prev = 7;
                _context2.next = 10;
                return this.form.submit(_config2.default.get('bookApiURL') + '/company_branches/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(businessUnit)
                });

              case 10:
                _context2.next = 22;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](7);

                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 20;
                  break;
                }

                _context2.next = 17;
                return _context2.t0.res.text();

              case 17:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 20:
                store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));
                return _context2.abrupt('return');

              case 22:
                store.dispatch((0, _reactRouterRedux.push)('/business_units/'));
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Create Success', message: businessUnit.name + ' successfully created' }));

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 12]]);
      }));

      function submit(_x, _x2) {
        return _ref2.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('New'),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Create'),
              onClick: this.handleSubmit
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref3) {
            _this2.form = _ref3;
          },
          onSubmit: function onSubmit(validations, businessUnit) {
            _this2.submit(validations, businessUnit);
          },
          location: this.props.location,
          auth: this.props.auth,
          loading: this.props.loading
        })
      );
    }
  }]);

  return New;
}(_react.Component);

New.propTypes = {
  location: _propTypes2.default.shape({
    hash: _propTypes2.default.string
  }),
  loading: _propTypes2.default.bool,
  auth: _propTypes2.default.shape({
    companyBranch: _propTypes2.default.shape({
      id: _propTypes2.default.number
    }),
    isHeadquarters: _propTypes2.default.bool
  }),
  t: _propTypes2.default.func
};
New.contextTypes = {
  store: _propTypes2.default.object
};

New.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces)))((0, _reactRedux.connect)(New.mapStateToProps)(New));

/***/ }),
/* 2287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _webValidations = __webpack_require__(23);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _states = __webpack_require__(144);

var _states2 = _interopRequireDefault(_states);

var _countries = __webpack_require__(60);

var _reservationLimit = __webpack_require__(1047);

var _reservationLimit2 = _interopRequireDefault(_reservationLimit);

var _intlCallCodes = __webpack_require__(116);

var _intlCallCodes2 = _interopRequireDefault(_intlCallCodes);

var _businessUnitStatusFilter = __webpack_require__(582);

var _businessUnitStatusFilter2 = _interopRequireDefault(_businessUnitStatusFilter);

var _countries2 = __webpack_require__(591);

var _phone = __webpack_require__(146);

var _phone2 = _interopRequireDefault(_phone);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _EditableBox = __webpack_require__(153);

var _EditableBox2 = _interopRequireDefault(_EditableBox);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _Phone = __webpack_require__(126);

var _Phone2 = _interopRequireDefault(_Phone);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _PhoneInput = __webpack_require__(104);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

var _ProjectsList = __webpack_require__(400);

var _ProjectsList2 = _interopRequireDefault(_ProjectsList);

var _ListItem = __webpack_require__(261);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _ChangeBranchToExternal = __webpack_require__(2513);

var _ChangeBranchToExternal2 = _interopRequireDefault(_ChangeBranchToExternal);

var _AddBranchLogo = __webpack_require__(2506);

var _AddBranchLogo2 = _interopRequireDefault(_AddBranchLogo);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _TinFieldInput = __webpack_require__(192);

var _TinFieldInput2 = _interopRequireDefault(_TinFieldInput);

var _regex = __webpack_require__(143);

var _identityTypes = __webpack_require__(174);

var _translation = __webpack_require__(4);

var _translation2 = __webpack_require__(64);

var _tin = __webpack_require__(155);

var _defaultIdentityTypeOpts = __webpack_require__(154);

var _navigations = __webpack_require__(1053);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


var styles = {
  divider: { margin: '0.5em 0' },
  logo: { paddingLeft: '1rem', paddingBottom: '2rem' },
  buttons: { paddingLeft: '0' }
};

var Overview = function (_Component) {
  _inherits(Overview, _Component);

  function Overview(props) {
    _classCallCheck(this, Overview);

    var _this = _possibleConstructorReturn(this, (Overview.__proto__ || Object.getPrototypeOf(Overview)).call(this, props));

    _initialiseProps.call(_this);

    var tinError = null;
    _this.state = {
      token: null,
      loading: true,
      edit: false,
      data: null,
      oriData: null,
      branches: [],
      errMessages: [],
      tinMessage: null,
      showAddProject: false,
      showConfirmBranch: false,
      showAddCompanyLogo: false,
      showAddREALicenseLogo: false,
      confirmBranchModalType: {
        isProjectOwner: false,
        isHigherAccess: false
      },
      tinError: tinError,
      tinRequired: false,
      tinEnabled: true
    };
    _this.validation = {
      name: (0, _react.createRef)(),
      shortName: (0, _react.createRef)(),
      department: (0, _react.createRef)(),
      registrationNumber: (0, _react.createRef)(),
      taxIdentificationNo: (0, _react.createRef)(),
      referenceCode: (0, _react.createRef)(),
      email: (0, _react.createRef)(),
      phonePrefix: (0, _react.createRef)(),
      website: (0, _react.createRef)(),
      bankAccountName: (0, _react.createRef)(),
      bankAccountNumber: (0, _react.createRef)(),
      bankName: (0, _react.createRef)(),
      citSSTRegisterationNumbery: (0, _react.createRef)(),
      address1: (0, _react.createRef)(),
      address2: (0, _react.createRef)(),
      postcode: (0, _react.createRef)(),
      city: (0, _react.createRef)(),
      gps: (0, _react.createRef)(),
      country: (0, _react.createRef)(),
      invoiceTemplateNote: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(Overview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var store = this.context.store;


      this.fetchBusinessUnit().catch(function (err) {
        Bugsnag.notifyException(err);
        store.dispatch((0, _flash.flashErrorMessage)(err));
      });
      this.fetchUnitAllocatedCount();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.data !== this.state.data) {
        this.updateTinFieldState();
      }
    }
  }, {
    key: 'getAccessStatus',
    value: function getAccessStatus(value) {
      var status = _businessUnitStatusFilter2.default.find(function (s) {
        return s.value === value;
      });
      if (status) {
        return status.text;
      }
      return '';
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'getBranchLogoToken',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, token, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                res = void 0;
                token = void 0;
                _context.prev = 3;
                _context.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/company_branches/logos/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 6:
                res = _context.sent;
                _context.next = 15;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](3);

                Bugsnag.notifyException(_context.t0);
                _context.next = 14;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 14:
                return _context.abrupt('return', null);

              case 15:
                if (res.ok) {
                  _context.next = 23;
                  break;
                }

                _context.next = 18;
                return res.text();

              case 18:
                message = _context.sent;
                _context.next = 21;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 21:
                _context.next = 24;
                break;

              case 23:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

              case 24:
                return _context.abrupt('return', token);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 9]]);
      }));

      function getBranchLogoToken() {
        return _ref.apply(this, arguments);
      }

      return getBranchLogoToken;
    }()
  }, {
    key: 'validateTIN',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(tinInput) {
        var data, idType, query, store, res, errorMessage, _errorMessage;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                data = this.state.data;

                if (!(!tinInput || !data.registrationNumber)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:
                idType = (0, _identityTypes.getIdentityTypeOpts)().find(function (i) {
                  return i.value === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN;
                }).tin_code;
                query = Object.assign({
                  tin: tinInput,
                  idType: idType,
                  idValue: data.registrationNumber
                });
                store = this.context.store;
                _context2.prev = 6;
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/tin/validate/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token,
                    'X-Origin': this.state.origin
                  }
                }));

              case 9:
                res = _context2.sent;

                if (!(res && res.ok)) {
                  _context2.next = 14;
                  break;
                }

                this.setState({
                  tinError: false,
                  tinMessage: null
                });
                _context2.next = 19;
                break;

              case 14:
                _context2.next = 16;
                return res.text();

              case 16:
                errorMessage = _context2.sent;

                this.setState({
                  tinError: true,
                  tinMessage: errorMessage
                });
                return _context2.abrupt('return');

              case 19:
                _context2.next = 28;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2['catch'](6);

                if (!_context2.t0.res) {
                  _context2.next = 28;
                  break;
                }

                _context2.next = 26;
                return _context2.t0.res.text();

              case 26:
                _errorMessage = _context2.sent;

                this.setState({
                  tinError: true,
                  tinMessage: _errorMessage
                });

              case 28:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 21]]);
      }));

      function validateTIN(_x2) {
        return _ref2.apply(this, arguments);
      }

      return validateTIN;
    }()
  }, {
    key: 'updateBusinessUnit',
    value: function updateBusinessUnit(data) {
      var _this3 = this;

      return _AppForm2.default.validate(this.validation, data).then(function (validations) {
        _this3.setState({
          errMessages: validations.filter(function (v) {
            return !v.isValid;
          })
        });

        var updatedData = _extends({}, data, {
          taxTinValidationStatus: _this3.state.tinError === false ? 'success' : 'failed'
        });

        if (_this3.state.errMessages.length === 0 && _this3.state.tinRequired && updatedData.taxTinValidationStatus !== 'success') {
          var store = _this3.context.store;

          store.dispatch((0, _flash.flashMessage)({
            header: 'Invalid TIN',
            message: 'Tax Identification Number is invalid',
            icon: 'warning sign',
            type: 'error',
            autoHideDuration: 5000
          }));
          return;
        }
        _this3.putBusinessUnit(validations, updatedData).catch(function (err) {
          Bugsnag.notifyException(err);
        });
      });
    }
  }, {
    key: 'fetchBusinessUnit',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var t, store, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                _context3.prev = 5;
                _context3.next = 8;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/company_branches/' + this.props.routeParams.id + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context3.sent;
                _context3.next = 19;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](5);

                Bugsnag.notifyException(_context3.t0);
                _context3.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context3.next = 18;
                return this.setLoading(false);

              case 18:
                return _context3.abrupt('return');

              case 19:
                if (res.ok) {
                  _context3.next = 27;
                  break;
                }

                _context3.next = 22;
                return res.text();

              case 22:
                message = _context3.sent;
                _context3.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context3.next = 35;
                break;

              case 27:
                token = res.headers.get('X-Csrf-Token');
                _context3.next = 30;
                return res.json();

              case 30:
                data = _context3.sent;

                data.oriIsExternal = (0, _clone2.default)(data.isExternal);
                // handle token.. etc
                _context3.next = 34;
                return this.setComponentState({
                  token: token,
                  data: data
                });

              case 34:
                this.setState({
                  oriData: (0, _clone2.default)(data)
                });

              case 35:
                _context3.next = 37;
                return this.setLoading(false);

              case 37:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 11]]);
      }));

      function fetchBusinessUnit() {
        return _ref3.apply(this, arguments);
      }

      return fetchBusinessUnit;
    }()
  }, {
    key: 'fetchUnitAllocatedCount',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var store, res, message, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context4.prev = 4;
                _context4.next = 7;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/company_branches/' + this.props.routeParams.id + '/total_unitAllocated/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context4.sent;
                _context4.next = 18;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](4);

                Bugsnag.notifyException(_context4.t0);
                _context4.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 15:
                _context4.next = 17;
                return this.setLoading(false);

              case 17:
                return _context4.abrupt('return');

              case 18:
                if (res.ok) {
                  _context4.next = 26;
                  break;
                }

                _context4.next = 21;
                return res.text();

              case 21:
                message = _context4.sent;
                _context4.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context4.next = 30;
                break;

              case 26:
                _context4.next = 28;
                return res.json();

              case 28:
                data = _context4.sent;

                if (data) {
                  this.setState({ totalUnitAllocated: data });
                }

              case 30:
                _context4.next = 32;
                return this.setLoading(false);

              case 32:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 10]]);
      }));

      function fetchUnitAllocatedCount() {
        return _ref4.apply(this, arguments);
      }

      return fetchUnitAllocatedCount;
    }()
  }, {
    key: 'putBusinessUnit',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(validations, companyBranchData) {
        var store, t, companyBranch, errors, res, message, data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                companyBranch = Object.assign({}, companyBranchData);
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context5.next = 8;
                  break;
                }

                this.setState({ edit: true });
                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context5.abrupt('return');

              case 8:
                companyBranch.reservationLimit = parseInt(companyBranchData.reservationLimit, 10);
                res = void 0;
                _context5.prev = 10;
                _context5.next = 13;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/company_branches/' + this.props.routeParams.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(companyBranch)
                }));

              case 13:
                res = _context5.sent;
                _context5.next = 27;
                break;

              case 16:
                _context5.prev = 16;
                _context5.t0 = _context5['catch'](10);

                Bugsnag.notifyException(_context5.t0);

                if (!(_context5.t0.res && _context5.t0.res.status >= 400 && _context5.t0.res.status < 500)) {
                  _context5.next = 25;
                  break;
                }

                _context5.next = 22;
                return _context5.t0.res.text();

              case 22:
                message = _context5.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context5.abrupt('return');

              case 25:
                store.dispatch((0, _flash.flashErrorMessage)(_context5.t0));
                return _context5.abrupt('return');

              case 27:
                _context5.next = 29;
                return res.json();

              case 29:
                data = _context5.sent;

                this.setState({ edit: false });
                this.fetchBusinessUnit();
                this.fetchUnitAllocatedCount();
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: '' + t('{{name}} successfully updated', { ns: _translation.TRANSLATION_FILES.translation, name: data.name }) }));

              case 34:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[10, 16]]);
      }));

      function putBusinessUnit(_x3, _x4) {
        return _ref5.apply(this, arguments);
      }

      return putBusinessUnit;
    }()
  }, {
    key: 'stateComponent',
    value: function stateComponent() {
      var state = void 0;
      if (this.state.data.country.toUpperCase() === 'my'.toUpperCase()) {
        state = _react2.default.createElement(
          _AppForm2.default.Validate,
          {
            validation: [_webValidations.required],
            ref: this.validation.state,
            onChange: this.handleOnChange,
            validateLabel: 'State'
          },
          _react2.default.createElement(_semanticUiReact.Form.Select, {
            fluid: true,
            name: 'state',
            options: _states2.default,
            placeholder: 'Select state*',
            search: true,
            selectOnBlur: false,
            value: this.state.data.state
          })
        );
      } else {
        state = _react2.default.createElement(_AppForm2.default.Input, {
          autoComplete: 'off',
          fluid: true,
          name: 'state',
          onChange: this.handleOnChange,
          placeholder: 'State*',
          ref: this.validation.state,
          validation: [_webValidations.required],
          value: this.state.data.state,
          validateLabel: 'State'
        });
      }
      return state;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          t = _props.t,
          auth = _props.auth;
      var data = this.state.data;

      var links = (0, _navigations.routes)(this.props.routeParams.id);
      var pathname = this.props.location.pathname;

      var tinContent = data && data.taxIdentificationNo || this.state.tinRequired;
      var isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_ChangeBranchToExternal2.default, {
          open: this.state.showConfirmBranch,
          onClose: this.handleCancelChange,
          onConfirm: this.handleConfirmChange,
          branchShortName: this.state.data ? this.state.data.shortName : '',
          modalType: this.state.confirmBranchModalType
        }),
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: t(link.text),
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this4.handleMenu(e, link);
              }
            });
          })
        }),
        _react2.default.createElement(_ProjectsList2.default, {
          open: this.state.showAddProject,
          onClose: this.handleCloseAddProject,
          onConfirm: this.handleAddProject,
          onCheck: function onCheck(project) {
            return project.loanTrackerProjectID < 1;
          },
          selected: data ? data.projects : [],
          companyBranchID: data && data.id || 0
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { active: this.state.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Business Unit Information')
              ),
              data ? _react2.default.createElement(_EditableBox2.default, {
                editable: true,
                isEditing: this.state.edit,
                loading: this.state.loading,
                onEdit: this.handleEditBusinessUnit,
                onClick: this.handleUpdateBusinessUnit,
                onCancel: this.handleResetChanges,
                content: function content(_ref6) {
                  var _React$createElement;

                  var isEditing = _ref6.isEditing,
                      onConfirm = _ref6.onConfirm;
                  return _react2.default.createElement(
                    _semanticUiReact.Grid,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(_semanticUiReact.Dimmer, { active: _this4.state.isEditing, inverted: true }),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 16, computer: 16 },
                        _this4.state.oriData ? _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Row,
                            { stretched: true },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { width: 16 },
                              _react2.default.createElement(
                                _semanticUiReact.Header,
                                { as: 'h2', textAlign: 'center' },
                                _this4.state.oriData.shortName,
                                _this4.props.auth.companyBranch && _this4.props.auth.companyBranch.id === _this4.state.oriData.id ? _react2.default.createElement(
                                  _semanticUiReact.Label,
                                  { size: 'small', pointing: 'left' },
                                  t('Your branch', { ns: _translation.TRANSLATION_FILES.screens })
                                ) : '',
                                _this4.state.oriData.companyBranch ? _react2.default.createElement(
                                  _semanticUiReact.Header.Subheader,
                                  null,
                                  _react2.default.createElement(
                                    'i',
                                    null,
                                    _this4.state.oriData.companyBranch.name
                                  )
                                ) : null,
                                _react2.default.createElement(
                                  _semanticUiReact.Header.Subheader,
                                  null,
                                  _react2.default.createElement(
                                    'i',
                                    null,
                                    _react2.default.createElement(_Timestamp2.default, { format: 'MMMM Do YYYY, h:mm a', timestamp: _this4.state.oriData.createdAt })
                                  )
                                )
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { width: 16 },
                              _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, className: 'tablet-hide' })
                            )
                          )
                        ) : null,
                        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, className: 'large-hide small-hide' })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 8, computer: 8 },
                        _react2.default.createElement(
                          _AppForm2.default,
                          {
                            onSubmit: onConfirm,
                            error: _this4.state.errMessages.length > 0,
                            ref: function ref(_ref7) {
                              _this4.form = _ref7;
                            }
                          },
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'name', 'businessUnit'),
                                '*'
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                name: 'name',
                                onChange: _this4.handleOnChange,
                                placeholder: (0, _translation2.translateModels)(t, 'name', 'businessUnit'),
                                value: data.name,
                                ref: _this4.validation.name,
                                validateLabel: (0, _translation2.translateModels)(t, 'name', 'businessUnit'),
                                validation: [_webValidations.required]
                              }) : data.name
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'shortName', 'businessUnit'),
                                '*'
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                name: 'shortName',
                                onChange: _this4.handleOnChange,
                                placeholder: (0, _translation2.translateModels)(t, 'shortName', 'businessUnit'),
                                value: data.shortName,
                                ref: _this4.validation.shortName,
                                validation: [_webValidations.required],
                                validateLabel: (0, _translation2.translateModels)(t, 'shortName', 'businessUnit')
                              }) : data.shortName
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'department', 'businessUnit')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                name: 'department',
                                onChange: _this4.handleOnChange,
                                placeholder: (0, _translation2.translateModels)(t, 'department', 'businessUnit'),
                                value: data.department,
                                ref: _this4.validation.department
                              }) : data.department
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'registrationNumber', 'businessUnit')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                name: 'registrationNumber',
                                validateLabel: (0, _translation2.translateModels)(t, 'registrationNumber', 'businessUnit'),
                                required: tinContent,
                                onChange: _this4.handleOnChange,
                                placeholder: (0, _translation2.translateModels)(t, 'registrationNumber', 'businessUnit'),
                                value: data.registrationNumber,
                                validation: tinContent ? [_webValidations.required, {
                                  validate: _webValidations.identity,
                                  option: {
                                    countryCode: 'MY',
                                    identityType: 'other'
                                  }
                                }] : [{
                                  validate: _webValidations.identity,
                                  option: {
                                    countryCode: 'MY',
                                    identityType: 'other'
                                  }
                                }],
                                ref: _this4.validation.registrationNumber
                              }) : data.registrationNumber
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { mobile: 16, tablet: 8, computer: 8 },
                            isEditing ? _react2.default.createElement(
                              _semanticUiReact.Grid,
                              { verticalAlign: 'middle' },
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'left', width: 8 },
                                _react2.default.createElement(
                                  'b',
                                  null,
                                  isIndonesia ? 'NPWP' : 'Tax Identification Number'
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'right', width: 8 },
                                _react2.default.createElement(_TinFieldInput2.default, (_React$createElement = {
                                  hideLabel: true,
                                  isIndonesia: isIndonesia,
                                  value: data.taxIdentificationNo,
                                  errMessage: _this4.state.tinMessage,
                                  isLoading: _this4.state.validatingTin,
                                  tinError: !isIndonesia && _this4.state.tinError,
                                  required: !isIndonesia && _this4.state.tinRequired,
                                  disabled: !_this4.state.tinEnabled,
                                  validation: !isIndonesia && _this4.state.tinRequired ? [_webValidations.required, {
                                    validate: _webValidations.matchRegex,
                                    option: {
                                      validRegex: _regex.REGEX_TIN_VALID
                                    }
                                  }] : [{
                                    validate: _webValidations.matchRegex,
                                    option: {
                                      validRegex: isIndonesia ? _regex.REGEX_NPWP_ID : _regex.REGEX_TIN_VALID
                                    }
                                  }],
                                  ref: _this4.validation.taxIdentificationNo,
                                  identityType: _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN,
                                  identityValue: data.registrationNumber,
                                  onChange: _this4.handleTinInput
                                }, _defineProperty(_React$createElement, 'identityType', 4), _defineProperty(_React$createElement, 'identityValue', data.registrationNumber), _React$createElement))
                              )
                            ) : _react2.default.createElement(
                              _semanticUiReact.Grid,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'left', width: 6 },
                                _react2.default.createElement(
                                  'b',
                                  null,
                                  isIndonesia ? 'NPWP' : 'Tax Identification Number'
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'right', width: 10 },
                                _react2.default.createElement(
                                  'span',
                                  { style: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center' } },
                                  data && data.taxIdentificationNo ? _react2.default.createElement(
                                    'div',
                                    null,
                                    _react2.default.createElement(_semanticUiReact.Icon, {
                                      name: data.taxTinValidationStatus === 'success' ? 'check circle' : 'remove circle',
                                      color: data.taxTinValidationStatus === 'success' ? 'green' : 'red',
                                      style: { marginLeft: '0.5em' }
                                    }),
                                    _react2.default.createElement(
                                      'i',
                                      null,
                                      data.taxIdentificationNo
                                    )
                                  ) : '-'
                                )
                              )
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'referenceCode', 'businessUnit')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                name: 'referenceCode',
                                onChange: _this4.handleOnChange,
                                placeholder: (0, _translation2.translateModels)(t, 'referenceCode', 'businessUnit'),
                                value: data.referenceCode,
                                ref: _this4.validation.referenceCode
                              }) : data.referenceCode
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Email')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                name: 'email',
                                onChange: _this4.handleOnChange,
                                type: 'email',
                                placeholder: t('Email'),
                                value: data.email,
                                ref: _this4.validation.email,
                                validateLabel: t('Email')
                              }) : _react2.default.createElement(
                                'a',
                                { href: 'mailto:' + data.email },
                                data.email
                              )
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 4 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Phone')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 12 },
                              isEditing ? _react2.default.createElement(
                                _semanticUiReact.Grid,
                                { className: 'compact' },
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { width: 16 },
                                  _react2.default.createElement(
                                    _AppForm2.default.Validate,
                                    {
                                      validation: data.phone !== '' ? [_webValidations.required] : null,
                                      ref: _this4.validation.phonePrefix,
                                      onChange: _this4.handleOnChange,
                                      validateLabel: t('Phone prefix')
                                    },
                                    _react2.default.createElement(_semanticUiReact.Form.Select, {
                                      name: 'phonePrefix',
                                      value: data.phonePrefix,
                                      search: true,
                                      options: _intlCallCodes2.default,
                                      noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                                    })
                                  )
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { width: 16 },
                                  _react2.default.createElement(_PhoneInput2.default, {
                                    fluid: true,
                                    name: 'phone',
                                    onChange: _this4.handleOnChange,
                                    prefix: data.phonePrefix,
                                    type: 'tel',
                                    placeholder: t('Phone Number'),
                                    value: data.phone,
                                    validation: [_phone2.default]
                                  })
                                )
                              ) : _react2.default.createElement(_Phone2.default, {
                                mobilePrefix: data.phonePrefix,
                                mobile: data.phone
                              })
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Website')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                name: 'website',
                                onChange: _this4.handleDetailOnChange,
                                placeholder: t('Website'),
                                value: data.companyBranchDetail.website,
                                ref: _this4.validation.website
                              }) : data.companyBranchDetail.website
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'bankAccountName', 'businessUnit')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                name: 'bankAccountName',
                                onChange: _this4.handleDetailOnChange,
                                placeholder: (0, _translation2.translateModels)(t, 'bankAccountName', 'businessUnit'),
                                value: data.companyBranchDetail.bankAccountName,
                                ref: _this4.validation.bankAccountName
                              }) : data.companyBranchDetail.bankAccountName
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'bankAccountNumber', 'businessUnit')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                name: 'bankAccountNumber',
                                onChange: _this4.handleDetailOnChange,
                                placeholder: (0, _translation2.translateModels)(t, 'bankAccountNumber', 'businessUnit'),
                                value: data.companyBranchDetail.bankAccountNumber,
                                ref: _this4.validation.bankAccountNumber
                              }) : data.companyBranchDetail.bankAccountNumber
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'bankName', 'businessUnit')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                name: 'bankName',
                                onChange: _this4.handleDetailOnChange,
                                placeholder: (0, _translation2.translateModels)(t, 'bankName', 'businessUnit'),
                                value: data.companyBranchDetail.bankName,
                                ref: _this4.validation.bankName
                              }) : data.companyBranchDetail.bankName
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'SSTRegisterationNumber', 'businessUnit')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                name: 'SSTRegisterationNumber',
                                onChange: _this4.handleDetailOnChange,
                                placeholder: (0, _translation2.translateModels)(t, 'SSTRegisterationNumber', 'businessUnit'),
                                value: data.companyBranchDetail.SSTRegisterationNumber,
                                ref: _this4.validation.SSTRegisterationNumber
                              }) : data.companyBranchDetail.SSTRegisterationNumber
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 4 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Projects')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 12 },
                              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                label: t('View all projects'),
                                name: 'viewAllProjects',
                                checked: data.viewAllProjects,
                                onChange: _this4.handleOnCheck,
                                disabled: !isEditing
                              })
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 16, style: { paddingTop: '0' } },
                              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                label: t('View archived projects'),
                                name: 'viewArchivedProjects',
                                checked: data.viewArchivedProjects,
                                onChange: _this4.handleOnCheck,
                                disabled: !isEditing || !data.viewAllProjects
                              })
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 16, style: { paddingTop: '0' } },
                              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                label: t('View draft projects'),
                                name: 'viewDraftProjects',
                                checked: data.viewDraftProjects,
                                onChange: _this4.handleOnCheck,
                                disabled: !isEditing || !data.viewAllProjects
                              })
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 16, style: { paddingTop: '0' } },
                              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                label: t('View ready projects'),
                                name: 'viewReadyProjects',
                                checked: data.viewReadyProjects,
                                onChange: _this4.handleOnCheck,
                                disabled: !isEditing || !data.viewAllProjects
                              })
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Agency')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                label: t('Agency'),
                                name: 'isExternal',
                                disabled: !_this4.props.auth.isSuperAdmin && data.oriIsExternal,
                                checked: data.isExternal,
                                onChange: _this4.handleCheckBoxChange
                              }) : data.isExternal ? t('Yes') : t('No')
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider, className: 'large-hide small-hide tablet-hide' })
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 8, computer: 8 },
                        _react2.default.createElement(
                          _AppForm2.default,
                          {
                            onSubmit: onConfirm,
                            error: _this4.state.errMessages.length > 0,
                            ref: function ref(_ref10) {
                              _this4.form = _ref10;
                            }
                          },
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'reservationLimit', 'businessUnit')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_semanticUiReact.Form.Select, {
                                autoComplete: 'off',
                                fluid: true,
                                name: 'reservationLimit',
                                options: _reservationLimit2.default.map(function (option) {
                                  return _extends({}, option, {
                                    text: option.text === 'Unlimited' ? t('Unlimited', { ns: _translation.TRANSLATION_FILES.constants }) : option.text
                                  });
                                }),
                                placeholder: (0, _translation2.translateModels)(t, 'Select Limit', 'businessUnit'),
                                search: true,
                                selectOnBlur: false,
                                value: data.reservationLimit >= 0 ? '' + data.reservationLimit : '',
                                onChange: _this4.handleOnChange,
                                noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                              }) : data.reservationLimit === 0 ? t('Unlimited', { ns: _translation.TRANSLATION_FILES.constants }) : data.reservationLimit
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Access')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_semanticUiReact.Form.Select, {
                                autoComplete: 'off',
                                fluid: true,
                                name: 'statusID',
                                options: _businessUnitStatusFilter2.default.map(function (status) {
                                  return _extends({}, status, {
                                    text: t(status.text)
                                  });
                                }),
                                placeholder: t('Select Access'),
                                selectOnBlur: false,
                                value: data.statusID,
                                onChange: _this4.handleOnChange
                              }) : t(_this4.getAccessStatus(data.statusID))
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            null,
                            !isEditing ? _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 4 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Address'),
                                ' 1'
                              )
                            ) : null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: isEditing ? 'left' : 'right', width: isEditing ? 16 : 12 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                autoComplete: 'off',
                                label: t('Address') + ' 1*',
                                name: 'address1',
                                onChange: _this4.handleOnChange,
                                placeholder: t('Address') + ' 1*',
                                ref: _this4.validation.address1,
                                validation: [_webValidations.required, {
                                  validate: _webValidations.stringLength,
                                  option: {
                                    max: 256
                                  }
                                }],
                                value: data.address1,
                                validateLabel: t('Address') + ' 1'
                              }) : data.address1
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            null,
                            !isEditing ? _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 4 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Address'),
                                ' 2'
                              )
                            ) : null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: isEditing ? 'left' : 'right', width: isEditing ? 16 : 12 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                autoComplete: 'off',
                                label: t('Address') + ' 2',
                                name: 'address2',
                                onChange: _this4.handleOnChange,
                                placeholder: t('Address') + ' 2',
                                ref: _this4.validation.address2,
                                value: data.address2,
                                validateLabel: t('Address') + ' 2',
                                validation: [{
                                  validate: _webValidations.stringLength,
                                  option: {
                                    max: 256
                                  }
                                }]
                              }) : data.address2
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Postcode'),
                                '*'
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                autoComplete: 'off',
                                name: 'postcode',
                                onChange: _this4.handleOnChange,
                                placeholder: t('Postcode') + '*',
                                value: data.postcode,
                                type: 'tel',
                                ref: _this4.validation.postcode,
                                validation: [_webValidations.required],
                                validateLabel: t('Postcode')
                              }) : data.postcode
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('City'),
                                '*'
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                autoComplete: 'off',
                                name: 'city',
                                onChange: _this4.handleOnChange,
                                placeholder: t('City') + '*',
                                value: data.city,
                                ref: _this4.validation.city,
                                validation: [_webValidations.required],
                                validateLabel: t('City')
                              }) : data.city
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('State'),
                                '*'
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _this4.stateComponent() : data.state
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Country'),
                                '*'
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(
                                _AppForm2.default.Validate,
                                {
                                  validation: [_webValidations.required],
                                  ref: _this4.validation.country,
                                  onChange: function onChange(e, d) {
                                    // Reset state input field
                                    data.state = '';
                                    _this4.setState({ data: data });
                                    _this4.handleOnChange(e, d);
                                  },
                                  validateLabel: t('Country')
                                },
                                _react2.default.createElement(_semanticUiReact.Form.Select, {
                                  autoComplete: 'off',
                                  fluid: true,
                                  name: 'country',
                                  options: _countries.SELECT_COUNTRIES,
                                  placeholder: t('Select Country') + '*',
                                  search: true,
                                  selectOnBlur: false,
                                  value: data.country,
                                  noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                                })
                              ) : (0, _countries2.getCountryName)(data.country)
                            )
                          ),
                          data.gps ? _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                            _react2.default.createElement(
                              _semanticUiReact.Grid,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'left', width: 8 },
                                _react2.default.createElement(
                                  'b',
                                  null,
                                  t('GPS Coordinates'),
                                  '*'
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'right', width: 8 },
                                isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                  autoComplete: 'off',
                                  name: 'gps',
                                  onChange: _this4.handleOnChange,
                                  placeholder: t('GPS Coordinates') + '*',
                                  value: data.gps,
                                  ref: _this4.validation.gps,
                                  validation: [_webValidations.required],
                                  validateLabel: t('GPS Coordinates') + '*'
                                }) : data.gps
                              )
                            )
                          ) : null,
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Company logo')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Row,
                              { style: styles.logo },
                              data.companyBranchDetail.companyLogo && data.companyBranchDetail.companyLogo.key ? _react2.default.createElement(
                                _semanticUiReact.Segment,
                                null,
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { mobile: 16 },
                                  _react2.default.createElement(_LoadImage2.default, {
                                    picture: data.companyBranchDetail.companyLogo,
                                    pictureSize: 50,
                                    extension: 'png'
                                  })
                                )
                              ) : null,
                              isEditing ? _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { mobile: 16, style: styles.buttons },
                                _react2.default.createElement(_semanticUiReact.Button, {
                                  onClick: _this4.handleShowAddCompanyLogo,
                                  disabled: _this4.state.loading,
                                  primary: true,
                                  icon: 'add',
                                  content: data.companyBranchDetail.companyLogoID ? t('Replace', { ns: _translation.TRANSLATION_FILES.screens }) : t('Add', { ns: _translation.TRANSLATION_FILES.screens })
                                }),
                                data.companyBranchDetail.companyLogoID ? _react2.default.createElement(_semanticUiReact.Button, {
                                  onClick: _this4.handleRemoveCompanyLogo,
                                  disabled: _this4.state.loading,
                                  negative: true,
                                  primary: true,
                                  icon: 'remove',
                                  content: t('Remove', { ns: _translation.TRANSLATION_FILES.screens })
                                }) : null
                              ) : null
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'reaLicenseLogo', 'businessUnit')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Row,
                              { style: styles.logo },
                              data.companyBranchDetail.REALicenseLogo && data.companyBranchDetail.REALicenseLogo.key ? _react2.default.createElement(
                                _semanticUiReact.Segment,
                                null,
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { mobile: 16 },
                                  _react2.default.createElement(_LoadImage2.default, {
                                    picture: data.companyBranchDetail.REALicenseLogo,
                                    pictureSize: 50,
                                    extension: 'png'
                                  })
                                )
                              ) : null,
                              isEditing ? _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { mobile: 16, style: styles.buttons },
                                _react2.default.createElement(_semanticUiReact.Button, {
                                  onClick: _this4.handleShowAddREALicenseLogo,
                                  disabled: _this4.state.loading,
                                  primary: true,
                                  icon: 'add',
                                  content: data.companyBranchDetail.REALicenseLogoID ? t('Replace', { ns: _translation.TRANSLATION_FILES.screens }) : t('Add', { ns: _translation.TRANSLATION_FILES.screens })
                                }),
                                data.companyBranchDetail.REALicenseLogoID ? _react2.default.createElement(_semanticUiReact.Button, {
                                  onClick: _this4.handleRemoveREALicenseLogo,
                                  disabled: _this4.state.loading,
                                  negative: true,
                                  primary: true,
                                  icon: 'remove',
                                  content: t('Remove', { ns: _translation.TRANSLATION_FILES.screens })
                                }) : null
                              ) : null
                            )
                          ),
                          _react2.default.createElement(_AddBranchLogo2.default, {
                            ref: function ref(_ref8) {
                              _this4.logoModal = _ref8;
                            },
                            open: _this4.state.showAddCompanyLogo,
                            onClose: _this4.handleCloseAddCompanyLogo,
                            onConfirm: _this4.handleAddCompanyLogo,
                            onUpload: _this4.handleUploadLogo,
                            onCheck: _this4.handleCheckCompanyLogo
                          }),
                          _react2.default.createElement(_AddBranchLogo2.default, {
                            ref: function ref(_ref9) {
                              _this4.logoModal = _ref9;
                            },
                            open: _this4.state.showAddREALicenseLogo,
                            onClose: _this4.handleCloseAddREALicenseLogo,
                            onConfirm: _this4.handleAddREALicenseLogo,
                            onUpload: _this4.handleUploadLogo,
                            onCheck: _this4.handleCheckREALicenseLogo
                          }),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            null,
                            !isEditing ? _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'invoiceTemplateNote', 'businessUnit')
                              )
                            ) : null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: isEditing ? 'left' : 'right', width: isEditing ? 16 : 8 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                name: 'invoiceTemplateNote',
                                label: (0, _translation2.translateModels)(t, 'invoiceTemplateNote', 'businessUnit'),
                                onChange: _this4.handleDetailOnChange,
                                placeholder: (0, _translation2.translateModels)(t, 'For e.g. Please email to address@email.com upon payment', 'businessUnit'),
                                value: data.companyBranchDetail.invoiceTemplateNote,
                                ref: _this4.validation.invoiceTemplateNote
                              }) : data.companyBranchDetail.invoiceTemplateNote
                            )
                          )
                        )
                      )
                    )
                  );
                }
              }) : ''
            )
          ),
          data && !data.viewAllProjects ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Projects', { ns: _translation.TRANSLATION_FILES.screens })
              ),
              data.projects && data.projects.length > 0 ? _react2.default.createElement(
                _semanticUiReact.Table,
                { unstackable: true },
                _react2.default.createElement(
                  _semanticUiReact.Table.Body,
                  null,
                  data.projects.map(function (project, idx) {
                    return _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      { key: idx },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(_ListItem2.default, {
                          item: project,
                          totalCountUnitAllocated: _this4.state.totalUnitAllocated ? _this4.state.totalUnitAllocated.find(function (unit) {
                            return unit.projectID === project.id;
                          }) : null,
                          header: function header(item) {
                            if (_this4.checkProjectOwner(project)) {
                              return _react2.default.createElement(
                                'span',
                                null,
                                item.name,
                                ' ',
                                _react2.default.createElement(_semanticUiReact.Icon, { name: 'lock', fitted: true }),
                                _react2.default.createElement(
                                  'i',
                                  null,
                                  ' ',
                                  _react2.default.createElement(
                                    'small',
                                    null,
                                    t('Owner', { ns: _translation.TRANSLATION_FILES.translation })
                                  )
                                )
                              );
                            }
                            return item.name;
                          },
                          subheader: function subheader(item) {
                            return t(item.status.name, { ns: _translation.TRANSLATION_FILES.constants });
                          },
                          rightComponent: _this4.state.edit ? _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(_semanticUiReact.Button, {
                              type: 'button',
                              compact: true,
                              negative: true,
                              size: 'mini',
                              icon: 'remove',
                              onClick: function onClick() {
                                return _this4.handleRemoveProject(idx);
                              },
                              disabled: !_this4.state.edit || _this4.checkProjectOwner(project)
                            })
                          ) : null
                        })
                      )
                    );
                  })
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Segment,
                { textAlign: 'center' },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  'Loading'
                ) : t('No projects found', { ns: _translation.TRANSLATION_FILES.screens })
              )
            )
          ) : null,
          data && !data.viewAllProjects && this.state.edit ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              _react2.default.createElement(_semanticUiReact.Button, {
                content: t('Add project', { ns: _translation.TRANSLATION_FILES.screens }),
                onClick: this.handleShowAddProject
              })
            )
          ) : null
        )
      );
    }
  }]);

  return Overview;
}(_react.Component);

Overview.contextTypes = {
  store: _propTypes2.default.object
};
Overview.propTypes = {
  routeParams: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    companyBranch: _propTypes2.default.shape({
      id: _propTypes2.default.number
    }),
    isSuperAdmin: _propTypes2.default.bool
  }),
  t: _propTypes2.default.func
};

Overview.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.getCoverPicture = function (pictures) {
    if (pictures && pictures.length > 0 && pictures.some(function (pp) {
      return pp.isCover === true;
    })) {
      return pictures.find(function (pp) {
        return pp.isCover === true;
      }).picture;
    }
    return null;
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var loadingType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return new Promise(function (res) {
      if (loadingType === 'validatingTIN') {
        _this5.setState({ validatingTin: loading }, res);
      } else {
        _this5.setState({ loading: loading }, res);
      }
    });
  };

  this.updateTinFieldState = function () {
    var data = _this5.state.data;

    var tinError = true;
    if (data && data.taxTinValidationStatus === 'success') {
      tinError = false;
    }
    if (_this5.state.tinError !== tinError) {
      _this5.setState({ tinError: tinError });
    }
  };

  this.handleTinInput = function (e) {
    var auth = _this5.props.auth;
    var data = _this5.state.data;

    var isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';

    if (isIndonesia) {
      data.taxIdentificationNo = e.target.value;
      _this5.setState({ data: data, tinError: false });
      return;
    }

    var tinInput = e.target.value;
    var isAlphanumeric = /^[a-zA-Z0-9]*$/.test(tinInput);

    if (isAlphanumeric) {
      data.taxIdentificationNo = tinInput;
      _this5.setState({ data: data, tinError: true });

      if (tinInput === '') {
        var updatedData = _extends({}, data, {
          taxIdentificationNo: ''
        });

        _this5.setState({ data: updatedData, tinError: false });
        return;
      }

      if (isAlphanumeric) {
        data.taxIdentificationNo = tinInput;
        _this5.setState({ data: data, tinError: true });

        // 1~2 letter followed by numeric with length 9 - 11
        var matched = _regex.REGEX_TIN_VALID.test(tinInput);
        var genericTin = (0, _tin.getGenericTinByIdTypeAndTinNo)(_defaultIdentityTypeOpts.IDENTITY_TYPE_BRN, tinInput);
        _this5.setLoading(true, 'validatingTIN').then(function () {
          if (_this5.debounceTimeout) {
            clearTimeout(_this5.debounceTimeout);
          }
          _this5.debounceTimeout = setTimeout(function () {
            if (matched) {
              if (tinInput === _tin.GOVERNMENT_GENERIC_TIN) {
                _this5.setState({
                  tinError: false,
                  // tinFound: true,
                  tinMessage: null }, function () {
                  _this5.setLoading(false, 'validatingTIN');
                });
              } else if (_tin.GENERIC_TIN_VALUES.includes(tinInput)) {
                _this5.setState({
                  tinError: !(0, _tin.isGenericTinFound)(genericTin),
                  // tinFound: isGenericTinFound(genericTin),
                  tinMessage: !(0, _tin.isGenericTinFound)(genericTin) ? _tin.GENERIC_TIN_UNMATCHED_ERROR_MSG : null }, function () {
                  _this5.setLoading(false, 'validatingTIN');
                });
              } else {
                _this5.validateTIN(tinInput).finally(function () {
                  _this5.setLoading(false, 'validatingTIN');
                });
              }
            } else {
              _this5.setState({ tinError: true }, function () {
                _this5.setLoading(false, 'validatingTIN');
              });
            }
          }, 3000);
        });
      }
    }
  };

  this.handleOnChange = function (event, value) {
    var data = _this5.state.data;

    data[value.name] = value.value;
    _this5.setState({ data: data }, function () {
      // Validate TIN again on registrationNumber change.
      if (value.name === 'registrationNumber') {
        if (data.taxIdentificationNo !== '') {
          _this5.handleTinInput({ target: { value: data.taxIdentificationNo } });
        }
      }
    });
  };

  this.handleDetailOnChange = function (event, value) {
    var data = _this5.state.data;

    data.companyBranchDetail[value.name] = value.value;
    _this5.setState({ data: data });
  };

  this.handleOnCheck = function (event, value) {
    var data = _this5.state.data;

    data[value.name] = !data[value.name];
    if (value.name === 'viewAllProjects' && !data.viewAllProjects) {
      data.viewArchivedProjects = !data.isExternal;
      data.viewDraftProjects = !data.isExternal;
      data.viewReadyProjects = !data.isExternal;
    }
    _this5.setState({ data: data });
  };

  this.handleUserOnChange = function (event, value) {
    var data = _this5.state.data;

    data.user[value.name] = value.value;
    _this5.setState({ data: data });
  };

  this.handleCheckBoxChange = function (event, d) {
    var data = _this5.state.data;

    data[d.name] = !data[d.name];
    if (d.name === 'isExternal') {
      data.viewArchivedProjects = !data.isExternal;
      data.viewDraftProjects = !data.isExternal;
      data.viewReadyProjects = !data.isExternal;
    }
    _this5.setState({ data: data });
  };

  this.handleEditBusinessUnit = function () {
    _this5.setState({ edit: true });
  };

  this.handleUpdateBusinessUnit = function () {
    var _state = _this5.state,
        data = _state.data,
        oriData = _state.oriData;

    var hasProjectOwnership = data.projects.find(function (p) {
      return p.maOwnerCompanyBranchID === data.id;
    });
    var confirmBranchModalType = {
      isProjectOwner: false,
      isHigherAccess: false
    };
    if (oriData.isExternal === false && data.isExternal === true && hasProjectOwnership) {
      confirmBranchModalType.isProjectOwner = true;
      confirmBranchModalType.isHigherAccess = true;
      _this5.setState({ showConfirmBranch: true, confirmBranchModalType: confirmBranchModalType });
      return;
    }
    if (oriData.isExternal === false && data.isExternal === true && !hasProjectOwnership) {
      confirmBranchModalType.isProjectOwner = false;
      confirmBranchModalType.isHigherAccess = true;
      _this5.setState({ showConfirmBranch: true, confirmBranchModalType: confirmBranchModalType });
      return;
    }
    _this5.updateBusinessUnit(data);
  };

  this.handleCancelChange = function (e) {
    e.preventDefault();
    _this5.setState({
      showConfirmBranch: false
    });
  };

  this.handleConfirmChange = function (e) {
    e.preventDefault();
    _this5.setState({
      showConfirmBranch: false
    }, function () {
      var data = _this5.state.data;

      _this5.updateBusinessUnit(data);
    });
  };

  this.handleResetChanges = function () {
    var oriData = _this5.state.oriData;

    _this5.setState({
      data: (0, _clone2.default)(oriData),
      edit: false
    });
  };

  this.handleShowAddCompanyLogo = function (e) {
    e.preventDefault();
    _this5.setState({
      showAddCompanyLogo: true
    });
  };

  this.handleShowAddREALicenseLogo = function (e) {
    e.preventDefault();
    _this5.setState({
      showAddREALicenseLogo: true
    });
  };

  this.handleCloseAddCompanyLogo = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this5.setState({
      showAddCompanyLogo: false
    });
  };

  this.handleCloseAddREALicenseLogo = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this5.setState({
      showAddREALicenseLogo: false
    });
  };

  this.handleAddCompanyLogo = function (e, selectedLogo, name) {
    e.preventDefault();
    var data = _this5.state.data;

    data.companyBranchDetail.companyLogoID = selectedLogo.id;
    data.companyBranchDetail.companyLogo = selectedLogo;
    _this5.setState({ data: data });
  };

  this.handleAddREALicenseLogo = function (e, selectedLogo, name) {
    e.preventDefault();
    var data = _this5.state.data;

    data.companyBranchDetail.REALicenseLogoID = selectedLogo.id;
    data.companyBranchDetail.REALicenseLogo = selectedLogo;
    _this5.setState({ data: data });
  };

  this.handleUploadLogo = function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(body) {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return _this5.getBranchLogoToken();

            case 2:
              _context6.t0 = _context6.sent;
              _context6.t1 = {
                'X-Csrf-Token': _context6.t0
              };
              _context6.t2 = body;
              _context6.t3 = {
                credentials: 'include',
                method: 'POST',
                headers: _context6.t1,
                body: _context6.t2
              };
              return _context6.abrupt('return', {
                url: '/company_branches/logos/',
                options: _context6.t3
              });

            case 7:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this5);
    }));

    return function (_x7) {
      return _ref11.apply(this, arguments);
    };
  }();

  this.handleRemoveCompanyLogo = function (e) {
    e.preventDefault();
    var data = _this5.state.data;

    data.companyBranchDetail.companyLogoID = '';
    data.companyBranchDetail.companyLogo = null;
    _this5.setState({ data: data });
  };

  this.handleRemoveREALicenseLogo = function (e) {
    e.preventDefault();
    var data = _this5.state.data;

    data.companyBranchDetail.REALicenseLogoID = '';
    data.companyBranchDetail.REALicenseLogo = null;
    _this5.setState({ data: data });
  };

  this.handleCheckCompanyLogo = function (logo) {
    var data = _this5.state.data;

    return data.companyBranchDetail.companyLogoID === logo.id;
  };

  this.handleCheckREALicenseLogo = function (logo) {
    var data = _this5.state.data;

    return data.companyBranchDetail.REALicenseLogoID === logo.id;
  };

  this.handleMenu = function (e, _ref12) {
    var value = _ref12.value;
    var store = _this5.context.store;

    if (value.includes(_config2.default.get('bookApiURL'))) {
      e.preventDefault();
      var winObj = window.open(value, '_blank');
      winObj.opener = null;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(value));
    }
  };

  this.handleRemoveProject = function (index) {
    if (_this5.state.edit) {
      var data = _this5.state.data;

      data.projects.splice(index, 1);
      _this5.setState({ data: data });
    }
  };

  this.handleAddProject = function (e, projects) {
    e.preventDefault();
    var data = _this5.state.data;

    data.projects = projects;
    _this5.setState({
      data: data,
      showAddProject: false
    });
  };

  this.handleShowAddProject = function (e) {
    e.preventDefault();
    _this5.setState({
      showAddProject: true
    });
  };

  this.handleCloseAddProject = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this5.setState({
      showAddProject: false
    });
  };

  this.checkProjectOwner = function (project) {
    if (project.maOwnerCompanyBranchID === _this5.state.data.id || 0) {
      return true;
    }
    return false;
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.businessUnit]))((0, _reactRedux.connect)(Overview.mapStateToProps)(Overview));

/***/ }),
/* 2288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _BusinessUnits = __webpack_require__(2283);

var _BusinessUnits2 = _interopRequireDefault(_BusinessUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _BusinessUnits2.default;

/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _Countdown = __webpack_require__(1012);

var _Countdown2 = _interopRequireDefault(_Countdown);

var _BuyerCheckResult = __webpack_require__(2111);

var _BuyerCheckResult2 = _interopRequireDefault(_BuyerCheckResult);

var _BuyerLoanCard = __webpack_require__(2112);

var _BuyerLoanCard2 = _interopRequireDefault(_BuyerLoanCard);

var _BankersList = __webpack_require__(397);

var _BankersList2 = _interopRequireDefault(_BankersList);

var _InviteBankerForm = __webpack_require__(587);

var _InviteBankerForm2 = _interopRequireDefault(_InviteBankerForm);

var _UpdateCaseStatus = __webpack_require__(1080);

var _UpdateCaseStatus2 = _interopRequireDefault(_UpdateCaseStatus);

var _BookingStatusNotes = __webpack_require__(398);

var _BookingStatusNotes2 = _interopRequireDefault(_BookingStatusNotes);

var _buyerBookingStatuses = __webpack_require__(2217);

var _buyerBookingStatuses2 = _interopRequireDefault(_buyerBookingStatuses);

var _booking = __webpack_require__(129);

var _booking2 = _interopRequireDefault(_booking);

var _url = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import BuyerBankerChat from '../modals/BuyerBankerChat';

// structs


var BuyerBooking = function (_Component) {
  _inherits(BuyerBooking, _Component);

  function BuyerBooking(props) {
    _classCallCheck(this, BuyerBooking);

    var _this = _possibleConstructorReturn(this, (BuyerBooking.__proto__ || Object.getPrototypeOf(BuyerBooking)).call(this, props));

    _initialiseProps.call(_this);

    var state = BuyerBooking.getPropsToState(props);
    _this.state = _extends({}, state, {
      data: null,
      resendable: false,
      resendModal: false,
      showAddBanker: false,
      selectedBankID: 0,
      showInviteBanker: false,
      showUpdateBankCase: false,
      bookingStatusModal: false,
      selectedBankCase: null,
      updateStatus: ''
      // showBankerChat: false,
      // selectedLoan: null,
    });
    _this.countdown = null;
    return _this;
  }

  _createClass(BuyerBooking, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var booking = this.props.booking;

      if (booking && booking.buyerProfileID) {
        this.fetchBuyerBooking();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var state = BuyerBooking.getPropsToState(nextProps);
      var booking = nextProps.booking,
          bookingID = nextProps.bookingID;

      var needFetch = bookingID !== this.props.bookingID && booking && booking.buyerProfileID;
      this.setState(_extends({}, state), function () {
        if (needFetch) {
          _this2.fetchBuyerBooking(bookingID);
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.countdown) {
        this.countdown.clearTimer();
      }
    }
  }, {
    key: 'fetchBuyerBooking',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var xid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.bookingID;

        var store, res, message, _message, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + xid + '/buyer/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 21;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                if (!(_context.t0.res && _context.t0.res.status >= 399 && _context.t0.res.status < 500)) {
                  _context.next = 17;
                  break;
                }

                _context.next = 15;
                return _context.t0.res.text();

              case 15:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 17:
                _context.next = 19;
                return this.setLoading(false);

              case 19:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));

              case 21:
                if (res.ok) {
                  _context.next = 29;
                  break;
                }

                _context.next = 24;
                return res.text();

              case 24:
                _message = _context.sent;
                _context.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 27:
                _context.next = 36;
                break;

              case 29:
                _context.next = 31;
                return res.json();

              case 31:
                data = _context.sent;
                _context.next = 34;
                return this.setComponentState({ data: data });

              case 34:
                _context.next = 36;
                return this.setTimer(data);

              case 36:
                _context.next = 38;
                return this.setLoading(false);

              case 38:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchBuyerBooking() {
        return _ref.apply(this, arguments);
      }

      return fetchBuyerBooking;
    }()
  }, {
    key: 'resendSMS',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, res, message, _message2, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context2.prev = 4;
                _context2.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.props.bookingID + '/buyer/notify/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 7:
                res = _context2.sent;
                _context2.next = 23;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](4);
                _context2.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 20;
                  break;
                }

                _context2.next = 17;
                return _context2.t0.res.text();

              case 17:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 20:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context2.abrupt('return');

              case 23:
                if (res.ok) {
                  _context2.next = 31;
                  break;
                }

                _context2.next = 26;
                return res.text();

              case 26:
                _message2 = _context2.sent;
                _context2.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message2 }));

              case 29:
                _context2.next = 38;
                break;

              case 31:
                _context2.next = 33;
                return res.json();

              case 33:
                data = _context2.sent;
                _context2.next = 36;
                return this.setComponentState({ data: data });

              case 36:
                _context2.next = 38;
                return this.setTimer(data);

              case 38:
                _context2.next = 40;
                return this.setLoading(false);

              case 40:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10]]);
      }));

      function resendSMS() {
        return _ref2.apply(this, arguments);
      }

      return resendSMS;
    }()
  }, {
    key: 'addBanker',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(banker) {
        var store, res, message, _message3, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context3.prev = 4;
                _context3.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.props.bookingID + '/buyer/banker/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(banker)
                }));

              case 7:
                res = _context3.sent;
                _context3.next = 23;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](4);
                _context3.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 20;
                  break;
                }

                _context3.next = 17;
                return _context3.t0.res.text();

              case 17:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 20:
                Bugsnag.notifyException(_context3.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context3.abrupt('return');

              case 23:
                if (res.ok) {
                  _context3.next = 31;
                  break;
                }

                _context3.next = 26;
                return res.text();

              case 26:
                _message3 = _context3.sent;
                _context3.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message3 }));

              case 29:
                _context3.next = 36;
                break;

              case 31:
                _context3.next = 33;
                return res.json();

              case 33:
                data = _context3.sent;
                _context3.next = 36;
                return this.setComponentState({ data: data });

              case 36:
                _context3.next = 38;
                return this.setLoading(false);

              case 38:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Assign Success', message: 'Banker ' + banker.name + ' is successfully assigned.' }));

              case 39:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 10]]);
      }));

      function addBanker(_x2) {
        return _ref3.apply(this, arguments);
      }

      return addBanker;
    }()
  }, {
    key: 'updateBankCase',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var statusNote = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var loanAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0';

        var store, _state, selectedBankCase, updateStatus, body, message;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _state = this.state, selectedBankCase = _state.selectedBankCase, updateStatus = _state.updateStatus;
                body = Object.assign(selectedBankCase, {
                  loanAmount: loanAmount.toString(),
                  status: updateStatus,
                  statusNote: statusNote
                });
                _context4.prev = 5;
                _context4.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.props.bookingID + '/loan_trackers/bank_cases/' + selectedBankCase.code + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(body)
                }));

              case 8:
                _context4.next = 25;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](5);
                _context4.next = 14;
                return this.setLoading(false);

              case 14:
                _context4.next = 16;
                return this.setComponentState({
                  selectedBankCase: null,
                  updateStatus: ''
                });

              case 16:
                if (!(_context4.t0.res && _context4.t0.res.status >= 400 && _context4.t0.res.status < 500)) {
                  _context4.next = 22;
                  break;
                }

                _context4.next = 19;
                return _context4.t0.res.text();

              case 19:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context4.abrupt('return');

              case 22:
                Bugsnag.notifyException(_context4.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context4.abrupt('return');

              case 25:
                _context4.next = 27;
                return this.setLoading(false);

              case 27:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Update Success', message: selectedBankCase.bank.shortName + '\'s case is successfully updated.' }));
                _context4.next = 30;
                return this.setComponentState({
                  selectedBankCase: null,
                  updateStatus: ''
                });

              case 30:
                _context4.next = 32;
                return this.fetchBuyerBooking();

              case 32:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 10]]);
      }));

      function updateBankCase() {
        return _ref4.apply(this, arguments);
      }

      return updateBankCase;
    }()
  }, {
    key: 'nudgeBankCase',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(bankCase) {
        var store, res, message, _message4;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context5.prev = 4;
                _context5.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.props.bookingID + '/loan_trackers/bank_cases/' + bankCase.code + '/nudge/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 7:
                res = _context5.sent;
                _context5.next = 23;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](4);
                _context5.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context5.t0.res && _context5.t0.res.status >= 400 && _context5.t0.res.status < 500)) {
                  _context5.next = 20;
                  break;
                }

                _context5.next = 17;
                return _context5.t0.res.text();

              case 17:
                message = _context5.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context5.abrupt('return');

              case 20:
                Bugsnag.notifyException(_context5.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context5.abrupt('return');

              case 23:
                if (res.ok) {
                  _context5.next = 31;
                  break;
                }

                _context5.next = 26;
                return res.text();

              case 26:
                _message4 = _context5.sent;
                _context5.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message4 }));

              case 29:
                _context5.next = 32;
                break;

              case 31:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Nudge Success', message: bankCase.bank.shortName + '\'s case is successfully nudged.' }));

              case 32:
                _context5.next = 34;
                return this.setLoading(false);

              case 34:
                _context5.next = 36;
                return this.fetchBuyerBooking();

              case 36:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[4, 10]]);
      }));

      function nudgeBankCase(_x5) {
        return _ref5.apply(this, arguments);
      }

      return nudgeBankCase;
    }()
  }, {
    key: 'updateBooking',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(booking) {
        var xid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.bookingID;
        var store, res, message, data, query;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = '';
                _context6.prev = 4;
                _context6.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + xid + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(booking)
                }));

              case 7:
                res = _context6.sent;
                _context6.next = 23;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6['catch'](4);
                _context6.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context6.t0.res && _context6.t0.res.status >= 400 && _context6.t0.res.status < 500)) {
                  _context6.next = 20;
                  break;
                }

                _context6.next = 17;
                return _context6.t0.res.text();

              case 17:
                message = _context6.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context6.abrupt('return');

              case 20:
                Bugsnag.notifyException(_context6.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context6.abrupt('return');

              case 23:
                _context6.next = 25;
                return res.json();

              case 25:
                data = _context6.sent;
                _context6.next = 28;
                return this.setLoading(false);

              case 28:
                query = (0, _url.decodeSearch)(this.props.location.search);

                store.dispatch((0, _reactRouterRedux.push)('/bookings/' + data.id + '/?' + (0, _url.encodeSearch)(query)));
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Cancellation Success', message: 'Booking ' + data.code + ' successfully cancelled.' }));
                this.fetchBuyerBooking();

              case 32:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[4, 10]]);
      }));

      function updateBooking(_x6) {
        return _ref6.apply(this, arguments);
      }

      return updateBooking;
    }()
  }, {
    key: 'linkExistingBooking',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var xid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props.bookingID;
        var store, res, message, data, query;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = '';
                _context7.prev = 4;
                _context7.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + xid + '/buyer/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 7:
                res = _context7.sent;
                _context7.next = 23;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7['catch'](4);
                _context7.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context7.t0.res && _context7.t0.res.status >= 400 && _context7.t0.res.status < 500)) {
                  _context7.next = 20;
                  break;
                }

                _context7.next = 17;
                return _context7.t0.res.text();

              case 17:
                message = _context7.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context7.abrupt('return');

              case 20:
                Bugsnag.notifyException(_context7.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context7.abrupt('return');

              case 23:
                _context7.next = 25;
                return res.json();

              case 25:
                data = _context7.sent;
                _context7.next = 28;
                return this.setLoading(false);

              case 28:
                query = (0, _url.decodeSearch)(this.props.location.search);

                store.dispatch((0, _reactRouterRedux.push)('/bookings/' + data.id + '/?' + (0, _url.encodeSearch)(query)));
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Booking linked successfully', message: 'Booking ' + data.code + ' is now linked to MHub Buyer app.' }));
                this.fetchBuyerBooking();

              case 32:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[4, 10]]);
      }));

      function linkExistingBooking() {
        return _ref7.apply(this, arguments);
      }

      return linkExistingBooking;
    }()
    // handleShowBankerChat = (e, selectedLoan) => {
    //   e.preventDefault();
    //   this.setState({
    //     showBankerChat: true,
    //     selectedLoan,
    //   });
    // }
    // handleCloseBankerChat = (e) => {
    //   if (e) { e.preventDefault(); }
    //   this.setState({
    //     showBankerChat: false,
    //     selectedLoan: null,
    //   });
    // }

  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          booking = _state2.booking,
          data = _state2.data,
          resendModal = _state2.resendModal,
          bookingStatusModal = _state2.bookingStatusModal,
          loading = _state2.loading;

      if (!booking.buyerProfileID) {
        return _react2.default.createElement(
          _semanticUiReact.Segment,
          { style: { marginTop: '3rem' }, textAlign: 'center' },
          _react2.default.createElement(
            _semanticUiReact.Header,
            {
              textAlign: 'center',
              as: 'h4'
            },
            _react2.default.createElement(
              _semanticUiReact.Header.Content,
              null,
              'Link Booking to MHub Buyer App'
            ),
            _react2.default.createElement(
              _semanticUiReact.Header.Subheader,
              null,
              'Buyer can perform Credit Check, Loan Selection, and keep track of their booking on Buyer App. More info on ',
              _react2.default.createElement(
                'a',
                { href: 'https://apps.mhub.my/buyer/', target: '_blank' },
                'https://apps.mhub.my/buyer/'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              style: { marginTop: '1rem' },
              primary: true,
              onClick: this.handleLinkBooking,
              loading: loading,
              disabled: loading
            },
            'Link Booking'
          )
        );
      }
      if (!data) {
        return _react2.default.createElement(
          _semanticUiReact.Grid,
          { className: 'buyer' },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: true, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              'Loading'
            )
          )
        );
      }
      var statuses = this.generateSteps(data);
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { className: 'buyer' },
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            basic: true,
            open: resendModal,
            onClose: this.handleCloseResendModal,
            size: 'small'
          },
          _react2.default.createElement(_semanticUiReact.Header, { icon: 'send', content: 'Are you sure you want to resend?' }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(_semanticUiReact.Button, { negative: true, onClick: this.handleCloseResendModal, icon: 'cancel', content: 'Cancel' }),
            _react2.default.createElement(_semanticUiReact.Button, { positive: true, onClick: this.handleConfirmResendModal, icon: 'checkmark', content: 'Yes' })
          )
        ),
        _react2.default.createElement(_BookingStatusNotes2.default, {
          onNotesChange: this.handleNotesChange,
          onCheckboxChange: this.handleCheckboxChange,
          statusID: booking.statusID,
          notes: booking.remarkInternal,
          isCancelPending: booking.isCancelPending,
          onClose: this.handleCancelBookingStatus,
          onConfirm: this.handleConfirmBookingStatus,
          open: bookingStatusModal,
          data: booking
        }),
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          { style: { zIndex: 20 }, active: this.props.loading, inverted: true },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            'Loading'
          )
        ),
        statuses.map(this.renderStep)
      );
    }
  }]);

  return BuyerBooking;
}(_react.Component);

BuyerBooking.contextTypes = {
  store: _propTypes2.default.object
};
BuyerBooking.propTypes = {
  token: _propTypes2.default.string,
  bookingID: _propTypes2.default.string,
  setLoading: _propTypes2.default.func.isRequired,
  loading: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  booking: _propTypes2.default.shape({}),
  bankCaseStates: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  location: _propTypes2.default.shape({
    search: _propTypes2.default.string
  }).isRequired
};

BuyerBooking.mapStateToProps = function (state) {
  return {
    bankCaseStates: state.bankCaseStates
  };
};

BuyerBooking.getPropsToState = function (props) {
  var loading = props.loading;
  var booking = Object.assign({}, _booking2.default, props.booking);
  var projectCurrencies = booking.project.projectCurrency;
  return {
    loading: loading,
    booking: booking,
    projectCurrencies: projectCurrencies
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (_this3.props.setLoading) {
      return _this3.props.setLoading(loading);
    }
    return Promise.resolve();
  };

  this.setComponentState = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new Promise(function (res) {
      _this3.setState(state, function () {
        res(state);
      });
    });
  };

  this.getPrimaryPurchaser = function (list, id) {
    if (list.length > 0) {
      return list.find(function (l) {
        return l.id === id;
      });
    }
    return null;
  };

  this.setTimer = function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.state.data;

    if (_this3.countdown) {
      var timeout = _this3.calculateTimeout(data);
      if (timeout > 0) {
        _this3.countdown.startTimer(timeout);
      } else {
        _this3.countdown.stopTimer();
      }
    }
  };

  this.handleBookingStatusChange = function (event, _ref8) {
    var name = _ref8.name,
        value = _ref8.value;
    var booking = _this3.state.booking;

    booking[name] = value;
    _this3.setState({ booking: booking, bookingStatusModal: true });
  };

  this.handleNotesChange = function (event, _ref9) {
    var name = _ref9.name,
        value = _ref9.value;
    var booking = _this3.state.booking;

    booking[name] = value;
    _this3.setState({ booking: booking });
  };

  this.handleCheckboxChange = function (event, _ref10) {
    var checked = _ref10.checked;
    var booking = _this3.state.booking;

    booking.isCancelPending = checked;
    _this3.setState({ booking: booking });
  };

  this.handleConfirmBookingStatus = function () {
    var booking = _this3.state.booking;

    var newBooking = {
      statusID: booking.statusID,
      remarkInternal: booking.remarkInternal
    };
    if (booking.statusID === 'sold_spa_signed' || booking.statusID === 'cancelled_developer') {
      newBooking.isCancelPending = booking.isCancelPending;
    }
    _this3.setState({ bookingStatusModal: false }, function () {
      return _this3.updateBooking(newBooking);
    });
  };

  this.handleCancelBookingStatus = function () {
    var booking = Object.assign({}, _booking2.default, _this3.props.booking);
    _this3.setState({ booking: booking, bookingStatusModal: false });
  };

  this.handleShowResendModal = function () {
    var resendModal = _this3.state.resendModal;

    if (!resendModal) {
      _this3.setState({ resendModal: true });
    }
  };

  this.handleCloseResendModal = function () {
    var resendModal = _this3.state.resendModal;

    if (resendModal) {
      _this3.setState({ resendModal: false });
    }
  };

  this.handleConfirmResendModal = function () {
    var resendModal = _this3.state.resendModal;

    if (resendModal) {
      _this3.setState({ resendModal: false }, function () {
        return _this3.resendSMS();
      });
    }
  };

  this.handleShowAddBanker = function (e, _ref11) {
    var loan = _ref11.loan;

    e.preventDefault();
    _this3.setState({
      showAddBanker: true,
      selectedBankID: parseInt(loan.bank_id, 10)
    });
  };

  this.handleCloseAddBanker = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this3.setState({
      showAddBanker: false
    });
  };

  this.handleAddBanker = function (e, bankers) {
    e.preventDefault();
    _this3.setState({ showAddBanker: false }, function () {
      return _this3.addBanker(bankers[0]);
    });
  };

  this.handleShowInviteBanker = function (e) {
    e.preventDefault();
    _this3.setState({
      showInviteBanker: true
    });
  };

  this.handleCloseInviteBanker = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this3.setState({
      showInviteBanker: false
    });
  };

  this.handleInviteBanker = function (e, validations, banker) {
    e.preventDefault();
    var errors = validations.filter(function (v) {
      return !v.isValid;
    });
    if (errors.length > 0) {
      var store = _this3.context.store;

      store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errors.map(function (l) {
          return l.message;
        }) }));
      return;
    }
    _this3.setState({ showInviteBanker: false, showAddBanker: false }, function () {
      _this3.addBanker(banker);
    });
  };

  this.handleShowUpdateBankCase = function (e, selectedBankCase) {
    var updateStatus = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

    e.preventDefault();
    _this3.setState({
      showUpdateBankCase: true,
      selectedBankCase: selectedBankCase,
      updateStatus: updateStatus
    });
  };

  this.handleCloseUpdateBankCase = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this3.setState({
      showUpdateBankCase: false,
      selectedBankCase: null,
      updateStatus: ''
    });
  };

  this.handleUpdateBankCase = function (e) {
    var statusNote = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var loanAmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';

    _this3.setState({
      showUpdateBankCase: false
    }, function () {
      _this3.updateBankCase(statusNote, loanAmount);
    });
  };

  this.handleNudge = function (e, data) {
    _this3.nudgeBankCase(data);
  };

  this.handleLinkBooking = function () {
    return _this3.linkExistingBooking();
  };

  this.checkBanks = function (bank) {
    var selectedBankID = _this3.state.selectedBankID;

    return bank.id !== selectedBankID;
  };

  this.checkBankers = function (banker, bankers) {
    var index = bankers.findIndex(function (i) {
      return i.id === banker.id;
    });
    if (index > -1) {
      return false;
    }
    var data = _this3.state.data;

    if (data.loansList && data.loansList.items && data.loansList.items.length > 0) {
      var bankerIDs = data.loansList.items.filter(function (l) {
        return parseInt(l.loan.bank_id, 10) === _this3.state.selectedBankID;
      }).map(function (l) {
        return l.banker_id;
      });
      return bankerIDs.some(function (b) {
        return b === banker.id;
      });
    }
    return false;
  };

  this.checkSelectedBankers = function (banker) {
    var data = _this3.state.data;

    if (data.loansList && data.loansList.items && data.loansList.items.length > 0) {
      var bankerIDs = data.loansList.items.filter(function (l) {
        return parseInt(l.loan.bank_id, 10) === _this3.state.selectedBankID;
      }).map(function (l) {
        return l.banker_id;
      });
      return bankerIDs.some(function (b) {
        return b === banker.id;
      });
    }
    return false;
  };

  this.generateSteps = function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.state.data;
    var status = data.status,
        statusLogs = data.status_logs;

    var steps = _buyerBookingStatuses2.default.slice(0, 4);
    if (statusLogs && statusLogs.length > 0) {
      var cancelledStatuses = [_buyerBookingStatuses.BUYER_BOOKING_STATUS_CANCEL_REQUESTED_OPTION, _buyerBookingStatuses.BUYER_BOOKING_STATUS_CANCELLED_OPTION, _buyerBookingStatuses.BUYER_BOOKING_STATUS_EXPIRED_OPTION];
      if (cancelledStatuses.some(function (s) {
        return s.value === status;
      })) {
        steps = statusLogs.map(function (l) {
          return _buyerBookingStatuses2.default.find(function (s) {
            return s.value === l.n;
          });
        });
      }
    }
    return steps;
  };

  this.calculateTimeout = function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.state.data;
    var sms_sent_at = data.sms_sent_at;

    // get last sent at

    var lastSentAt = (0, _momentTimezone2.default)(sms_sent_at[sms_sent_at.length - 1]);

    // get minutes
    var minute = 1;
    var resendCount = sms_sent_at.length % 7;
    if (resendCount > 1) {
      minute = parseInt(Math.pow(2, resendCount - 1), 10);
      if (minute >= 60) {
        minute = 60;
      }
    }
    var duration = _momentTimezone2.default.duration(minute, 'minutes');

    var now = (0, _momentTimezone2.default)();
    var nextResendAt = lastSentAt.add(minute, 'm');
    if (nextResendAt.isAfter(now)) {
      // calculate remaining time
      var seconds = _momentTimezone2.default.duration(nextResendAt.diff(now, 'seconds'));
      return duration.subtract(seconds).asSeconds();
    }

    return 0;
  };

  this.renderCountdownMessage = function (time) {
    if (time > 0) {
      var duration = _momentTimezone2.default.duration(time, 'seconds');
      var minutes = duration.minutes();
      var seconds = duration.seconds();
      if (minutes > 0) {
        return ' (' + minutes + ' m ' + seconds + ' s)';
      }
      return ' (' + seconds + ' s)';
    }
    return null;
  };

  this.renderSentAt = function (sentAt, index, arr) {
    var _state3 = _this3.state,
        data = _state3.data,
        resendable = _state3.resendable;
    var status = data.status,
        message = data.sms_new_message,
        purchaser_id = data.purchaser_id,
        purchasers = data.purchasers;

    var primaryPurchaser = _this3.getPrimaryPurchaser(purchasers, purchaser_id);
    var renderButton = index === arr.length - 1 && (status === 'draft' || status === 'new');
    return _react2.default.createElement(
      'div',
      { key: index },
      _react2.default.createElement(_Timestamp2.default, {
        timestamp: sentAt,
        format: 'DD MMM YYYY, hh:mm a'
      }),
      index === 0 ? _react2.default.createElement(
        'p',
        null,
        'Booking Confirmation Request has been sent to Purchaser ',
        _react2.default.createElement(
          'strong',
          null,
          primaryPurchaser.name
        ),
        ' at ',
        _react2.default.createElement(
          'strong',
          null,
          '+',
          primaryPurchaser.mobile_prefix,
          primaryPurchaser.mobile
        ),
        '.'
      ) : null,
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'strong',
          null,
          'SMS: '
        ),
        message
      ),
      renderButton ? _react2.default.createElement(
        _semanticUiReact.Button,
        {
          primary: true,
          onClick: _this3.handleShowResendModal,
          disabled: !resendable
        },
        'Resend',
        _react2.default.createElement(_Countdown2.default, {
          ref: function ref(_ref12) {
            _this3.countdown = _ref12;
          },
          message: _this3.renderCountdownMessage,
          onStart: function onStart() {
            _this3.setState({ resendable: false });
          },
          onComplete: function onComplete() {
            _this3.setState({ resendable: true });
          }
        })
      ) : null
    );
  };

  this.renderCreditCheckStep = function (timestamp, name) {
    var isMobile = _this3.props.isMobile;
    var _state4 = _this3.state,
        data = _state4.data,
        projectCurrencies = _state4.projectCurrencies;
    var check = data.check;

    return _react2.default.createElement(
      'div',
      null,
      timestamp ? _react2.default.createElement(_Timestamp2.default, {
        timestamp: timestamp,
        format: 'DD MMM YYYY, hh:mm a'
      }) : null,
      check ? _react2.default.createElement(
        'p',
        null,
        'Purchaser ',
        _react2.default.createElement(
          'strong',
          null,
          name
        ),
        ' completed ',
        _react2.default.createElement(
          'strong',
          null,
          'Buyer Eligibility Screening Test (BEST)'
        ),
        '.'
      ) : _react2.default.createElement(
        'p',
        null,
        'Pending ',
        _react2.default.createElement(
          'strong',
          null,
          'Buyer Eligibility Screening Test (BEST)'
        ),
        ' from Purchaser ',
        _react2.default.createElement(
          'strong',
          null,
          name
        ),
        '.'
      ),
      check ? _react2.default.createElement(_BuyerCheckResult2.default, {
        data: check,
        isMobile: isMobile,
        projectCurrencies: projectCurrencies
      }) : null
    );
  };

  this.renderLoanApplicationsStep = function (timestamp, name, code) {
    var isSold = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var _props = _this3.props,
        booking = _props.booking,
        bankCaseStates = _props.bankCaseStates,
        loading = _props.loading;
    var _state5 = _this3.state,
        data = _state5.data,
        projectCurrencies = _state5.projectCurrencies,
        showAddBanker = _state5.showAddBanker,
        selectedBankID = _state5.selectedBankID,
        showInviteBanker = _state5.showInviteBanker,
        showUpdateBankCase = _state5.showUpdateBankCase,
        selectedBankCase = _state5.selectedBankCase,
        updateStatus = _state5.updateStatus;
    var loansList = data.loansList;

    return _react2.default.createElement(
      'div',
      null,
      _react2.default.createElement(_BankersList2.default, {
        open: showAddBanker,
        onClose: _this3.handleCloseAddBanker,
        onConfirm: _this3.handleAddBanker,
        projectID: booking.projectID,
        bankID: selectedBankID,
        bankerOnCheck: _this3.checkBankers,
        bankerOnCheckSelected: _this3.checkSelectedBankers,
        limit: 1,
        extraNode: _react2.default.createElement(_semanticUiReact.Button, {
          floated: 'left',
          onClick: _this3.handleShowInviteBanker,
          content: 'Invite'
        })
      }),
      _react2.default.createElement(_InviteBankerForm2.default, {
        ref: function ref(_ref13) {
          _this3.form = _ref13;
        },
        open: showInviteBanker,
        onClose: _this3.handleCloseInviteBanker,
        onConfirm: _this3.handleInviteBanker,
        bankOnCheck: _this3.checkBanks
      }),
      _react2.default.createElement(_UpdateCaseStatus2.default, {
        open: showUpdateBankCase,
        onClose: _this3.handleCloseUpdateBankCase,
        onConfirm: _this3.handleUpdateBankCase,
        bankerName: selectedBankCase ? selectedBankCase.banker.name : '',
        statusName: bankCaseStates && updateStatus.length > 0 ? bankCaseStates.data.find(function (s) {
          return s.state === updateStatus;
        }).shortName : updateStatus,
        loanAmount: selectedBankCase ? selectedBankCase.loanAmount : '0',
        spaValue: booking.spaValue
      }),
      timestamp ? _react2.default.createElement(_Timestamp2.default, {
        timestamp: timestamp,
        format: 'DD MMM YYYY, hh:mm a'
      }) : null,
      _react2.default.createElement(
        'p',
        null,
        'Purchaser ',
        _react2.default.createElement(
          'strong',
          null,
          name
        ),
        ' has submitted the loan applications for booking ',
        code,
        '.'
      ),
      loansList && loansList.items && loansList.items.length > 0 ? _react2.default.createElement(
        _semanticUiReact.Grid,
        { columns: 3, doubling: true, stackable: true },
        _lodash2.default.uniqBy(loansList.items, 'loan_id').map(function (l, idx) {
          var loans = loansList.items.filter(function (la) {
            return la.loan_id === l.loan_id;
          });
          var bankCases = data.bankCases && data.bankCases.length > 0 ? data.bankCases.filter(function (b) {
            return b.bankID === parseInt(l.loan.bank_id, 10);
          }) : [];
          return _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { key: idx },
            _react2.default.createElement(_BuyerLoanCard2.default, {
              loans: loans,
              bankCases: bankCases,
              projectCurrencies: projectCurrencies,
              onAssign: _this3.handleShowAddBanker,
              onUpdateStatus: _this3.handleShowUpdateBankCase
              // onMessage={this.handleShowBankerChat}
              , onNudge: _this3.handleNudge,
              isSold: isSold,
              disabled: loading
            })
          );
        })
      ) : null
    );
  };

  this.renderSoldStep = function (timestamp) {
    return _react2.default.createElement(
      'div',
      null,
      timestamp ? _react2.default.createElement(_Timestamp2.default, {
        timestamp: timestamp,
        format: 'DD MMM YYYY, hh:mm a'
      }) : null,
      _react2.default.createElement(
        _semanticUiReact.Segment,
        { className: 'sold' },
        'Unit is marked as Sold'
      )
    );
  };

  this.renderRequestCancelledAt = function (timestamp, name, code) {
    var renderButton = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return _react2.default.createElement(
      'div',
      null,
      timestamp ? _react2.default.createElement(_Timestamp2.default, {
        timestamp: timestamp,
        format: 'DD MMM YYYY, hh:mm a'
      }) : null,
      _react2.default.createElement(
        'p',
        null,
        'Purchaser ',
        _react2.default.createElement(
          'strong',
          null,
          name
        ),
        ' requested to cancel booking ',
        code,
        '.'
      ),
      renderButton ? _react2.default.createElement(
        _semanticUiReact.Button,
        {
          color: 'red',
          onClick: function onClick(e) {
            return _this3.handleBookingStatusChange(e, { name: 'statusID', value: 'cancelled_developer' });
          },
          disabled: _this3.state.loading
        },
        'Cancel & Release Unit'
      ) : null
    );
  };

  this.renderStepContent = function (statusOpt, index, statuses, activeIndex) {
    if (index > activeIndex) {
      return [];
    }
    var data = _this3.state.data;
    var sms_sent_at = data.sms_sent_at,
        loansList = data.loansList,
        statusLogs = data.status_logs,
        code = data.code,
        purchasers = data.purchasers,
        purchaser_id = data.purchaser_id,
        unit = data.unit;

    var primaryPurchaser = _this3.getPrimaryPurchaser(purchasers, purchaser_id);
    var list = [];
    var updatedAt = null;
    var requestCancelledAt = null;
    if (statusLogs && statusLogs.length > 0) {
      if (statusLogs.some(function (l) {
        return l.n === statusOpt.value;
      })) {
        updatedAt = statusLogs.find(function (l) {
          return l.n === statusOpt.value;
        }).at;
      }
      if (statusLogs.some(function (l) {
        return l.n === _buyerBookingStatuses.BUYER_BOOKING_STATUS_CANCEL_REQUESTED_OPTION.value;
      })) {
        requestCancelledAt = statusLogs.find(function (l) {
          return l.n === _buyerBookingStatuses.BUYER_BOOKING_STATUS_CANCEL_REQUESTED_OPTION.value;
        }).at;
      }
    }
    switch (statusOpt.value) {
      case _buyerBookingStatuses.BUYER_BOOKING_STATUS_NEW_OPTION.value:
        list = sms_sent_at.map(_this3.renderSentAt);
        break;
      case _buyerBookingStatuses.BUYER_BOOKING_STATUS_CHECK_LINKED_OPTION.value:
        list.push(_this3.renderCreditCheckStep(updatedAt, primaryPurchaser.name));
        break;
      case _buyerBookingStatuses.BUYER_BOOKING_STATUS_LOAN_SUBMITTED_OPTION.value:
        if (loansList && loansList.items && loansList.items.length > 0) {
          list.push(_this3.renderLoanApplicationsStep(updatedAt, primaryPurchaser.name, code, activeIndex > index));
        }
        break;
      case _buyerBookingStatuses.BUYER_BOOKING_STATUS_SOLD_OPTION.value:
        list.push(_this3.renderSoldStep(updatedAt));
        break;
      case _buyerBookingStatuses.BUYER_BOOKING_STATUS_CANCEL_REQUESTED_OPTION.value:
        list.push(_this3.renderRequestCancelledAt(requestCancelledAt, primaryPurchaser.name, code, true));
        break;
      case _buyerBookingStatuses.BUYER_BOOKING_STATUS_CANCELLED_OPTION.value:
        if (requestCancelledAt) {
          list.push(_this3.renderRequestCancelledAt(requestCancelledAt, primaryPurchaser.name, code, false));
        }
        list.push(_react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_Timestamp2.default, {
            timestamp: updatedAt,
            format: 'DD MMM YYYY, hh:mm a'
          }),
          _react2.default.createElement(
            _semanticUiReact.Segment,
            { className: 'cancelled' },
            'Booking ',
            code,
            ' is cancelled.'
          )
        ));
        break;
      case _buyerBookingStatuses.BUYER_BOOKING_STATUS_EXPIRED_OPTION.value:
        list.push(_react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_Timestamp2.default, {
            timestamp: updatedAt,
            format: 'DD MMM YYYY, hh:mm a'
          }),
          _react2.default.createElement(
            _semanticUiReact.Segment,
            { className: 'cancelled' },
            'Booking ',
            code,
            ' has expired, and the reserved unit ',
            unit.reference,
            ' has been released.'
          )
        ));
        break;
      default:
        break;
    }
    return list;
  };

  this.renderStep = function (statusOpt, index, statuses) {
    var data = _this3.state.data;
    var status = data.status;

    if (status === _buyerBookingStatuses.BUYER_BOOKING_STATUS_DRAFT_OPTION.value) {
      status = _buyerBookingStatuses.BUYER_BOOKING_STATUS_NEW_OPTION.value;
    }
    var classNames = ['buyer-section'];
    var activeIndex = index;
    if (statusOpt.value === status) {
      classNames.push('active');
    } else {
      activeIndex = statuses.findIndex(function (s) {
        return s.value === status;
      });
    }
    if (activeIndex > index || statusOpt === _buyerBookingStatuses.BUYER_BOOKING_STATUS_CANCELLED_OPTION || statusOpt === _buyerBookingStatuses.BUYER_BOOKING_STATUS_EXPIRED_OPTION) {
      classNames.push('done');
    }
    var renderBorder = index < statuses.length - 1;

    var list = _this3.renderStepContent(statusOpt, index, statuses, activeIndex);
    if (list.length < 1) {
      classNames.push('expand');
    }
    return _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { key: index, className: classNames.join(' ') },
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        {
          className: 'buyer-title',
          mobile: 1,
          tablet: 3,
          computer: 3,
          textAlign: 'right'
        },
        statusOpt.text
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        {
          className: 'buyer-title',
          mobile: 15,
          tablet: 13,
          computer: 13
        },
        statusOpt.text
      ),
      list.length > 0 || renderBorder ? _react2.default.createElement(_semanticUiReact.Grid.Column, {
        mobile: 1,
        tablet: 3,
        computer: 3,
        className: 'buyer-border'
      }) : null,
      list.length > 0 ? _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        {
          mobile: 15,
          tablet: 13,
          computer: 13,
          className: 'buyer-item-list'
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 1 },
          list.map(function (l, li) {
            return _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                key: li,
                className: 'buyer-item'
              },
              l
            );
          })
        )
      ) : null
    );
  };
};

exports.default = (0, _reactRedux.connect)(BuyerBooking.mapStateToProps)(BuyerBooking);

/***/ }),
/* 2290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _checkChanges = __webpack_require__(61);

var _promptMessages = __webpack_require__(43);

var _translation = __webpack_require__(4);

var _List = __webpack_require__(2292);

var _List2 = _interopRequireDefault(_List);

var _New = __webpack_require__(2293);

var _New2 = _interopRequireDefault(_New);

var _Edit = __webpack_require__(2291);

var _Edit2 = _interopRequireDefault(_Edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CancellationReasons = function (_Component) {
  _inherits(CancellationReasons, _Component);

  function CancellationReasons(props) {
    _classCallCheck(this, CancellationReasons);

    var _this = _possibleConstructorReturn(this, (CancellationReasons.__proto__ || Object.getPrototypeOf(CancellationReasons)).call(this, props));

    _this.state = {
      token: null,
      loading: true,
      data: null
    };
    return _this;
  }

  _createClass(CancellationReasons, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.params.cancellationReasonID) {
        this.fetchCancellationReason();
      } else if (this.props.location.pathname.includes('/new/')) {
        this.fetchCancellationReasons();
      } else {
        this.setLoading(false);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var pathname = nextProps.location.pathname;

      if (nextProps.params.cancellationReasonID) {
        if (pathname !== this.props.location.pathname) {
          this.fetchCancellationReason();
        }
      } else if (pathname.includes('/new/')) {
        this.fetchCancellationReasons();
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchCancellationReason',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var t, store, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/cancellation_reasons/' + this.props.params.cancellationReasonID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 19;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context.next = 33;
                break;

              case 27:
                token = res.headers.get('X-Csrf-Token');
                _context.next = 30;
                return res.json();

              case 30:
                data = _context.sent;
                _context.next = 33;
                return this.setComponentState({
                  token: token,
                  data: data
                });

              case 33:
                _context.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchCancellationReason() {
        return _ref.apply(this, arguments);
      }

      return fetchCancellationReason;
    }()
  }, {
    key: 'fetchCancellationReasons',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var t, store, query, res, message, token;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                query = Object.assign({
                  page: 1
                }, q);
                res = void 0;
                _context2.prev = 6;
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/cancellation_reasons/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context2.sent;
                _context2.next = 20;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context2.next = 19;
                return this.setLoading(false);

              case 19:
                return _context2.abrupt('return');

              case 20:
                if (res.ok) {
                  _context2.next = 28;
                  break;
                }

                _context2.next = 23;
                return res.text();

              case 23:
                message = _context2.sent;
                _context2.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context2.next = 31;
                break;

              case 28:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context2.next = 31;
                return this.setComponentState({
                  token: token
                });

              case 31:
                _context2.next = 33;
                return this.setLoading(false);

              case 33:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 12]]);
      }));

      function fetchCancellationReasons() {
        return _ref2.apply(this, arguments);
      }

      return fetchCancellationReasons;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this4 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this4.state.token,
          loading: _this4.state.loading,
          data: _this4.state.data,
          cancellationReasonID: _this4.props.params.cancellationReasonID
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return CancellationReasons;
}(_react.Component);

CancellationReasons.propTypes = {
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object
  }),
  t: _propTypes2.default.func,
  params: _propTypes2.default.shape({
    cancellationReasonID: _propTypes2.default.string
  })
};
CancellationReasons.contextTypes = {
  store: _propTypes2.default.object
};
CancellationReasons.List = _List2.default;
CancellationReasons.New = (0, _checkChanges.checkChanges)(_New2.default, { message: _promptMessages.NEW_MAPPING_PROMPT });
CancellationReasons.Edit = (0, _checkChanges.checkChanges)(_Edit2.default);


var TranslatedCancellationReasons = (0, _reactI18next.withTranslation)(_translation.namespaces)(CancellationReasons);
TranslatedCancellationReasons.List = CancellationReasons.List;
TranslatedCancellationReasons.New = CancellationReasons.New;
TranslatedCancellationReasons.Edit = CancellationReasons.Edit;
exports.default = TranslatedCancellationReasons;

/***/ }),
/* 2291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _translation = __webpack_require__(4);

var _Form = __webpack_require__(1054);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Edit = function (_Component) {
  _inherits(Edit, _Component);

  function Edit(props) {
    _classCallCheck(this, Edit);

    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(Edit, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, preset) {
        var _this2 = this;

        var store, t, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.form.submit('/cancellation_reasons/' + this.props.cancellationReasonID + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(preset)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false);
                });
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully updated', { ns: _translation.TRANSLATION_FILES.translation, name: res.name }) }));

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Edit {{name}}', { ns: _translation.TRANSLATION_FILES.translation, name: this.props.data ? this.props.data.name : t('preset', { ns: _translation.TRANSLATION_FILES.translation }) }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Update', { ns: _translation.TRANSLATION_FILES.translation }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, preset) {
            _this3.submit(validations, preset);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading,
          preset: this.props.data
        })
      );
    }
  }]);

  return Edit;
}(_react.Component);

Edit.propTypes = {
  cancellationReasonID: _propTypes2.default.string,
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
Edit.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(Edit);

/***/ }),
/* 2292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _MappingPresetList = __webpack_require__(563);

var _MappingPresetList2 = _interopRequireDefault(_MappingPresetList);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    var state = List.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(List, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Cancellation Reason Settings')
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', columns: 'equal', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Cancellation Reason Presets')
              ),
              _react2.default.createElement(_MappingPresetList2.default, {
                loading: this.state.loading,
                type: 'cancellation_reasons'
              })
            )
          )
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  return {
    loading: loading
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(List);

/***/ }),
/* 2293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _translation = __webpack_require__(4);

var _Form = __webpack_require__(1054);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var New = function (_Component) {
  _inherits(New, _Component);

  function New(props) {
    _classCallCheck(this, New);

    var _this = _possibleConstructorReturn(this, (New.__proto__ || Object.getPrototypeOf(New)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments[1];

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges, callback);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(New, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, preset) {
        var _this2 = this;

        var store, t, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.form.submit('/cancellation_reasons/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(preset)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false, function (noChanges) {
                    if (noChanges) {
                      store.dispatch((0, _reactRouterRedux.goBack)());
                      store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Create Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully created', { ns: _translation.TRANSLATION_FILES.translation, name: res.name }) }));
                    }
                  });
                });

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('New preset', { ns: _translation.TRANSLATION_FILES.translation }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Create', { ns: _translation.TRANSLATION_FILES.screens }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, preset) {
            _this3.submit(validations, preset);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading
        })
      );
    }
  }]);

  return New;
}(_react.Component);

New.propTypes = {
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
New.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(New);

/***/ }),
/* 2294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CancellationReasons = __webpack_require__(2290);

var _CancellationReasons2 = _interopRequireDefault(_CancellationReasons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CancellationReasons2.default;

/***/ }),
/* 2295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _validations = __webpack_require__(897);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _CurrencySettings = __webpack_require__(2296);

var _CurrencySettings2 = _interopRequireDefault(_CurrencySettings);

var _currencySetting = __webpack_require__(553);

var _companies = __webpack_require__(88);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CompanyCurrencies = function (_Component) {
  _inherits(CompanyCurrencies, _Component);

  function CompanyCurrencies(props) {
    _classCallCheck(this, CompanyCurrencies);

    var _this = _possibleConstructorReturn(this, (CompanyCurrencies.__proto__ || Object.getPrototypeOf(CompanyCurrencies)).call(this, props));

    _initialiseProps.call(_this);

    var state = CompanyCurrencies.getPropsToState(props);
    _this.state = _extends({
      loading: true,
      data: [],
      token: null,
      preview: false,
      hasChanges: false,
      errMessages: []
    }, state);
    _this.validation = {
      billionsSeparator: (0, _react.createRef)(),
      millionsSeparator: (0, _react.createRef)(),
      thousandsSeparator: (0, _react.createRef)(),
      decimalSeparator: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(CompanyCurrencies, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchCompanyCurrencies(this.props.auth.company.id);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = CompanyCurrencies.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setCompanyCurrencies',
    value: function setCompanyCurrencies() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this2.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchCompanyCurrencies',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(companyId) {
        var store, t, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                _context.prev = 4;
                _context.next = 7;
                return (0, _fetchM.serverRequestGet)('/company/' + companyId + '/currency/', store);

              case 7:
                response = _context.sent;
                _context.next = 10;
                return this.setLoading(false);

              case 10:
                if (!response.error) {
                  _context.next = 14;
                  break;
                }

                _context.next = 13;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: response.message }));

              case 13:
                return _context.abrupt('return');

              case 14:
                _context.next = 16;
                return this.setCompanyCurrencies(response.data);

              case 16:
                _context.next = 18;
                return this.setComponentState({
                  token: response.token
                });

              case 18:
                _context.next = 27;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 25;
                return this.setLoading(false);

              case 25:
                _context.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 20]]);
      }));

      function fetchCompanyCurrencies(_x4) {
        return _ref.apply(this, arguments);
      }

      return fetchCompanyCurrencies;
    }()
  }, {
    key: 'submitCurrencySetting',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, _props, auth, t, _state, currencySetting, currencySettingToken, validations, errMessages, res, message, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _props = this.props, auth = _props.auth, t = _props.t;
                _state = this.state, currencySetting = _state.currencySetting, currencySettingToken = _state.currencySettingToken;
                _context2.next = 7;
                return _AppForm2.default.validate(this.validation, currencySetting);

              case 7:
                validations = _context2.sent;
                errMessages = validations.filter(function (v) {
                  return !v.isValid;
                });
                _context2.next = 11;
                return this.setComponentState({
                  errMessages: errMessages
                });

              case 11:
                if (!(errMessages.length > 0)) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 14;
                return this.setLoading(false);

              case 14:
                store.dispatch((0, _flash.flashMessage)({
                  header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }),
                  list: errMessages.map(function (l) {
                    return l.message;
                  }),
                  icon: 'warning sign',
                  type: 'error',
                  autoHideDuration: 5000
                }));
                return _context2.abrupt('return');

              case 16:
                res = void 0;
                _context2.prev = 17;
                _context2.next = 20;
                return store.dispatch((0, _fetchM.fetchM)('/company/' + auth.company.id + '/currency_setting/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': currencySettingToken
                  },
                  body: JSON.stringify(currencySetting)
                }));

              case 20:
                res = _context2.sent;
                _context2.next = 36;
                break;

              case 23:
                _context2.prev = 23;
                _context2.t0 = _context2['catch'](17);
                _context2.next = 27;
                return this.setLoading(false);

              case 27:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 33;
                  break;
                }

                _context2.next = 30;
                return _context2.t0.res.text();

              case 30:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 33:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));
                return _context2.abrupt('return');

              case 36:
                _context2.next = 38;
                return res.json();

              case 38:
                data = _context2.sent;

                this.setState({
                  currencySetting: data,
                  hasChanges: false,
                  loading: false
                });
                store.dispatch((0, _currencySetting.fetchCurrencySetting)());
                store.dispatch((0, _flash.flashMessage)({
                  header: t('Update success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Currency setting successfully updated', { ns: _translation.TRANSLATION_FILES.translation }) + '.',
                  icon: 'check',
                  type: 'success',
                  autoHideDuration: 5000
                }));

              case 42:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[17, 23]]);
      }));

      function submitCurrencySetting() {
        return _ref2.apply(this, arguments);
      }

      return submitCurrencySetting;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props2 = this.props,
          auth = _props2.auth,
          t = _props2.t;
      var _state2 = this.state,
          currencySetting = _state2.currencySetting,
          hasChanges = _state2.hasChanges;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Currency Settings'),
          rightNav: (0, _companies.isForeignCompany)(auth.company) && _react2.default.createElement(_semanticUiReact.Button, {
            color: 'green',
            content: t('Save', { ns: _translation.TRANSLATION_FILES.translation }),
            disabled: this.state.loading || !hasChanges,
            onClick: function onClick(e) {
              return _this5.form.handleSubmit(e);
            }
          })
        }),
        _react2.default.createElement(_CurrencySettings2.default, {
          data: this.state.data,
          loading: this.state.loading,
          token: this.state.token
        }),
        (0, _companies.isForeignCompany)(auth.company) && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _semanticUiReact.Divider,
            { style: { marginTop: '4em' }, horizontal: true },
            t('Currency Separator')
          ),
          _react2.default.createElement(
            _AppForm2.default,
            {
              error: this.state.errMessages.length > 0,
              onSubmit: this.handleSubmit,
              ref: function ref(_ref3) {
                _this5.form = _ref3;
              }
            },
            _react2.default.createElement(
              _semanticUiReact.Form.Group,
              { widths: 4 },
              _react2.default.createElement(_AppForm2.default.Input, {
                label: t('Billions Separator'),
                name: 'billionsSeparator',
                value: currencySetting.billionsSeparator,
                validation: [_validations.required, {
                  validate: _validations.stringLength,
                  option: {
                    equal: 1
                  }
                }],
                ref: this.validation.billionsSeparator,
                onChange: this.handleInputChanges
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                label: t('Millions Separator'),
                name: 'millionsSeparator',
                value: currencySetting.millionsSeparator,
                validation: [_validations.required, {
                  validate: _validations.stringLength,
                  option: {
                    equal: 1
                  }
                }],
                ref: this.validation.millionsSeparator,
                onChange: this.handleInputChanges
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                label: t('Thousands Separator'),
                name: 'thousandsSeparator',
                value: currencySetting.thousandsSeparator,
                validation: [_validations.required, {
                  validate: _validations.stringLength,
                  option: {
                    equal: 1
                  }
                }],
                ref: this.validation.thousandsSeparator,
                onChange: this.handleInputChanges
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                label: t('Decimal Separator'),
                name: 'decimalSeparator',
                value: currencySetting.decimalSeparator,
                validation: [_validations.required, {
                  validate: _validations.stringLength,
                  option: {
                    equal: 1
                  }
                }],
                ref: this.validation.decimalSeparator,
                onChange: this.handleInputChanges
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Segment,
            null,
            _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
              label: t('Show cent value'),
              checked: currencySetting.displayDecimal,
              name: 'displayDecimal',
              onChange: this.handleCheckBoxChanges
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { style: { textAlign: 'center' } },
              _react2.default.createElement(_semanticUiReact.Button, {
                content: t('Preview', { ns: _translation.TRANSLATION_FILES.translation }),
                disabled: this.state.loading || this.state.preview,
                onClick: function onClick() {
                  return _this5.setState({ preview: true });
                }
              })
            )
          )
        ),
        this.state.preview && _react2.default.createElement(
          _semanticUiReact.Segment,
          null,
          _react2.default.createElement(
            'h4',
            null,
            t('Preview', { ns: _translation.TRANSLATION_FILES.translation })
          ),
          '1 ',
          currencySetting.billionsSeparator,
          ' 0 0 0 ',
          currencySetting.millionsSeparator,
          ' 0 0 0 ',
          currencySetting.thousandsSeparator,
          ' 0 0 0 ',
          currencySetting.displayDecimal ? currencySetting.decimalSeparator + ' 0 0' : ''
        )
      );
    }
  }]);

  return CompanyCurrencies;
}(_react.Component);

CompanyCurrencies.propTypes = {
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.object
  }),
  currencySetting: _propTypes2.default.shape({
    data: _propTypes2.default.object
  })
};
CompanyCurrencies.defaultCurrencySetting = {
  id: '',
  isAbbreviationEnabled: false,
  displayDecimal: true,
  abbreviationDecimalPoints: 2,
  decimalSeparator: '.',
  thousandsSeparator: ',',
  millionsSeparator: ',',
  billionsSeparator: ','
};
CompanyCurrencies.contextTypes = {
  store: _propTypes2.default.object
};

CompanyCurrencies.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig,
    currencySetting: state.currencySetting
  };
};

CompanyCurrencies.getPropsToState = function (props) {
  var currencySetting = props.currencySetting.data && props.currencySetting.data.id ? props.currencySetting.data : CompanyCurrencies.defaultCurrencySetting;
  var currencySettingToken = props.currencySetting.token;
  return {
    currencySetting: currencySetting,
    currencySettingToken: currencySettingToken
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.handleInputChanges = function (_e, _ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    var currencySetting = _this6.state.currencySetting;

    currencySetting[name] = value;
    _this6.setState({ currencySetting: currencySetting, hasChanges: true });
  };

  this.handleCheckBoxChanges = function (_e, _ref5) {
    var name = _ref5.name;
    var currencySetting = _this6.state.currencySetting;

    currencySetting[name] = !currencySetting[name];
    _this6.setState({ currencySetting: currencySetting, hasChanges: true });
  };

  this.handleSubmit = function (e) {
    e.preventDefault();
    _this6.submitCurrencySetting();
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(CompanyCurrencies.mapStateToProps)(CompanyCurrencies));

/***/ }),
/* 2296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _Currencies = __webpack_require__(1013);

var _Currencies2 = _interopRequireDefault(_Currencies);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _validations = __webpack_require__(271);

var _companies = __webpack_require__(88);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CurrencySettings = function (_Component) {
  _inherits(CurrencySettings, _Component);

  function CurrencySettings(props) {
    _classCallCheck(this, CurrencySettings);

    var _this = _possibleConstructorReturn(this, (CurrencySettings.__proto__ || Object.getPrototypeOf(CurrencySettings)).call(this, props));
    // TODO: test on other company to see if it loads other company currencies


    _initialiseProps.call(_this);

    var state = CurrencySettings.getPropsToState(props);
    _this.state = _extends({}, state, {
      genericErrMsg: props.t('An error occurred, please refresh page')
    });
    return _this;
  }

  _createClass(CurrencySettings, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = CurrencySettings.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'getCompanyDefaultCurrency',
    value: function getCompanyDefaultCurrency() {
      var _props$auth$company$c = this.props.auth.company.companyCurrency,
          companyCurrency = _props$auth$company$c === undefined ? [] : _props$auth$company$c;

      var currency = companyCurrency.find(function (c) {
        return c.isDefault;
      }) || {};
      return currency.code || '';
    }
  }, {
    key: 'handleAdd',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, _ref2) {
        var value = _ref2.value;

        var _state, data, genericErrMsg, store, response;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _state = this.state, data = _state.data, genericErrMsg = _state.genericErrMsg;
                store = this.context.store;

                if (!(0, _validations.validateForm)(store, validations)) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                _context.next = 6;
                return this.setLoading(true);

              case 6:
                _context.prev = 6;
                _context.next = 9;
                return (0, _fetchM.serverRequestPost)('/company/' + this.state.auth.company.id + '/currency/', store, this.props.token, value);

              case 9:
                response = _context.sent;

                if (!response.error) {
                  _context.next = 13;
                  break;
                }

                this.handleError(store, response.message);
                return _context.abrupt('return');

              case 13:
                data.push(response.data);
                this.setState({ data: data });
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](6);

                this.handleError(store, genericErrMsg, _context.t0, true);

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 19]]);
      }));

      function handleAdd(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return handleAdd;
    }()
  }, {
    key: 'handleError',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(store, msg, errorObj) {
        var isBugsnag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(false);

              case 2:
                _context2.next = 4;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: msg }));

              case 4:
                if (isBugsnag) Bugsnag.notifyException(errorObj);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleError(_x3, _x4, _x5) {
        return _ref3.apply(this, arguments);
      }

      return handleError;
    }()
  }, {
    key: 'handleSave',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(validations, _ref5) {
        var value = _ref5.value;

        var _state2, data, genericErrMsg, store, i, response;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _state2 = this.state, data = _state2.data, genericErrMsg = _state2.genericErrMsg;
                store = this.context.store;

                if (!(0, _validations.validateForm)(store, validations)) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt('return');

              case 4:
                _context3.next = 6;
                return this.setLoading(true);

              case 6:
                i = data.findIndex(function (val) {
                  return val.code === value.code && val.id === value.id;
                });

                if (!(i === -1)) {
                  _context3.next = 10;
                  break;
                }

                this.handleError(store, genericErrMsg);
                return _context3.abrupt('return');

              case 10:

                // only allow update conversion rate
                data[i].conversionRatePoint = value.conversionRatePoint;

                _context3.prev = 11;
                _context3.next = 14;
                return (0, _fetchM.serverRequestPut)('/company/' + this.state.auth.company.id + '/currency/' + value.id + '/', store, this.props.token, { conversionRatePoint: value.conversionRatePoint });

              case 14:
                response = _context3.sent;

                if (!response.error) {
                  _context3.next = 19;
                  break;
                }

                _context3.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: response.message }));

              case 18:
                return _context3.abrupt('return');

              case 19:
                this.setState({ data: data });
                _context3.next = 22;
                return this.setLoading(false);

              case 22:
                _context3.next = 27;
                break;

              case 24:
                _context3.prev = 24;
                _context3.t0 = _context3['catch'](11);

                this.handleError(store, genericErrMsg, _context3.t0, true);

              case 27:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[11, 24]]);
      }));

      function handleSave(_x7, _x8) {
        return _ref4.apply(this, arguments);
      }

      return handleSave;
    }()
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var auth = this.props.auth;

      return _react2.default.createElement(_Currencies2.default, {
        companyDefaultCurrency: this.getCompanyDefaultCurrency(),
        isForeignCompany: auth && (0, _companies.isForeignCompany)(auth.company),
        data: this.state.data || [],
        loading: this.state.loading,
        onDefaultAdd: function onDefaultAdd(v, d) {
          _this3.handleAdd(v, d);
        },
        onDefaultDelete: function onDefaultDelete(e, d) {
          _this3.handleDelete(e, d);
        },
        onDefaultSave: function onDefaultSave(v, d) {
          _this3.handleSave(v, d);
        }
      });
    }
  }]);

  return CurrencySettings;
}(_react.Component);

CurrencySettings.propTypes = {
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.object
  }),
  data: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  loading: _propTypes2.default.bool,
  token: _propTypes2.default.string
};
CurrencySettings.contextTypes = {
  store: _propTypes2.default.object
};

CurrencySettings.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

CurrencySettings.getPropsToState = function (props) {
  var loading = props.loading;
  var auth = props.auth;
  var data = props.data || [];
  return {
    auth: auth,
    data: data,
    loading: loading
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleDelete = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e, _ref7) {
      var value = _ref7.value;

      var _state3, data, genericErrMsg, store, indexToBeDeleted, response;

      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this4.setLoading(true);

            case 2:
              _state3 = _this4.state, data = _state3.data, genericErrMsg = _state3.genericErrMsg;
              store = _this4.context.store;
              indexToBeDeleted = data.findIndex(function (val) {
                return val.code === value.code;
              });

              if (!(indexToBeDeleted === -1)) {
                _context4.next = 8;
                break;
              }

              _this4.handleError(store, genericErrMsg);
              return _context4.abrupt('return');

            case 8:
              _context4.prev = 8;
              _context4.next = 11;
              return (0, _fetchM.serverRequestDelete)('/company/' + _this4.state.auth.company.id + '/currency/' + value.id + '/', store, _this4.props.token);

            case 11:
              response = _context4.sent;

              if (!response.error) {
                _context4.next = 15;
                break;
              }

              _this4.handleError(store, response.message);
              return _context4.abrupt('return');

            case 15:
              data.splice(indexToBeDeleted, 1);
              _this4.setState({ data: data });
              _context4.next = 19;
              return _this4.setLoading(false);

            case 19:
              _context4.next = 24;
              break;

            case 21:
              _context4.prev = 21;
              _context4.t0 = _context4['catch'](8);

              _this4.handleError(store, genericErrMsg, _context4.t0, true);

            case 24:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4, [[8, 21]]);
    }));

    return function (_x10, _x11) {
      return _ref6.apply(this, arguments);
    };
  }();
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.translation)((0, _reactRedux.connect)(CurrencySettings.mapStateToProps)(CurrencySettings));

/***/ }),
/* 2297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CompanyCurrencies = __webpack_require__(2295);

var _CompanyCurrencies2 = _interopRequireDefault(_CompanyCurrencies);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CompanyCurrencies2.default;

/***/ }),
/* 2298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _List = __webpack_require__(2300);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CompanyDocuments = function (_Component) {
  _inherits(CompanyDocuments, _Component);

  function CompanyDocuments(props) {
    _classCallCheck(this, CompanyDocuments);

    var _this = _possibleConstructorReturn(this, (CompanyDocuments.__proto__ || Object.getPrototypeOf(CompanyDocuments)).call(this, props));

    _this.state = {
      token: null,
      count: 0,
      limit: 0,
      offset: 0,
      loading: true,
      data: []
    };
    return _this;
  }

  _createClass(CompanyDocuments, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = this.props.location.query;

      if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
        delete query.page;
      }
      this.fetchCompanyDocuments(query);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var query = nextProps.location.query;

      this.fetchCompanyDocuments(query);
    }
  }, {
    key: 'setCompanyDocuments',
    value: function setCompanyDocuments() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this2.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchCompanyDocuments',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var store, query, res, message, token, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                res = void 0;
                _context.prev = 6;
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/company_documents/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context.sent;
                _context.next = 20;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                Bugsnag.notifyException(_context.t0);
                _context.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 17:
                _context.next = 19;
                return this.setLoading(false);

              case 19:
                return _context.abrupt('return');

              case 20:
                if (res.ok) {
                  _context.next = 28;
                  break;
                }

                _context.next = 23;
                return res.text();

              case 23:
                message = _context.sent;
                _context.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context.next = 40;
                break;

              case 28:
                token = res.headers.get('X-Csrf-Token');
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 34;
                return res.json();

              case 34:
                data = _context.sent;
                _context.next = 37;
                return this.setCompanyDocuments(data);

              case 37:
                if (this.state.data.length < 1 && query.page > 1) {
                  query.page = 1;
                  store.dispatch((0, _reactRouterRedux.replace)('/company_documents/?' + _qs2.default.stringify(query)));
                }
                // handle token.. etc
                _context.next = 40;
                return this.setComponentState({
                  token: token,
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 40:
                _context.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));

      function fetchCompanyDocuments(_x4) {
        return _ref.apply(this, arguments);
      }

      return fetchCompanyDocuments;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this5 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this5.state.token,
          count: _this5.state.count,
          limit: _this5.state.limit,
          offset: _this5.state.offset,
          loading: _this5.state.loading,
          data: _this5.state.data
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return CompanyDocuments;
}(_react.Component);

CompanyDocuments.propTypes = {
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object
  })
};
CompanyDocuments.contextTypes = {
  store: _propTypes2.default.object
};
CompanyDocuments.List = _List2.default;
exports.default = CompanyDocuments;

/***/ }),
/* 2299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _fetchM = __webpack_require__(6);

var _fileSize = __webpack_require__(85);

var _fileSize2 = _interopRequireDefault(_fileSize);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UploadCompanyDocumentForm = function (_Component) {
  _inherits(UploadCompanyDocumentForm, _Component);

  function UploadCompanyDocumentForm(props) {
    _classCallCheck(this, UploadCompanyDocumentForm);

    var _this = _possibleConstructorReturn(this, (UploadCompanyDocumentForm.__proto__ || Object.getPrototypeOf(UploadCompanyDocumentForm)).call(this, props));

    _this.setLoading = function () {
      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return new Promise(function (res) {
        _this.setState({ loading: loading }, function () {
          return res(loading);
        });
      });
    };

    _this.reset = function (cb) {
      return _this.setState({ upload: null }, cb);
    };

    _this.handleSubmit = function (event) {
      event.preventDefault();
      var upload = _this.state.upload;

      if (upload && upload.file) {
        var formData = new FormData(_this.form);
        formData.append('file', upload.file);
        var onSubmit = _this.props.onSubmit;

        if (onSubmit) {
          onSubmit(event, formData);
        }
      }
    };

    _this.handleOnChange = function () {
      var files = Array.prototype.slice.call(_this.uploadFiles.files);
      _this.uploadFiles.value = null;
      if (window.FileReader) {
        files.forEach(function (file) {
          var reader = new FileReader();
          reader.onloadend = function () {
            var upload = {
              file: file,
              name: file.name,
              src: reader.result
            };
            _this.setState({ upload: upload }, function () {
              _this.handleCheckChanges();
            });
          };
          reader.readAsDataURL(file);
        });
      }
    };

    _this.handleRemove = function (event) {
      event.preventDefault();
      _this.setState({ upload: null });
    };

    _this.handleAddFile = function (event) {
      event.preventDefault();
      _this.uploadFiles.click();
    };

    var oriUpload = props.file ? Object.assign({}, props.file) : null;
    _this.state = {
      loading: false,
      oriUpload: oriUpload,
      upload: null,
      hasChanges: false
    };
    return _this;
  }

  _createClass(UploadCompanyDocumentForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.file !== nextProps.file) {
        var oriUpload = nextProps.file ? Object.assign({}, nextProps.file) : this.state.oriUpload;
        this.setState({ oriUpload: oriUpload });
      }
    }
  }, {
    key: 'submit',
    value: function submit(url) {
      var _this2 = this;

      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var store = this.context.store;

      return this.setLoading(true).then(function () {
        return store.dispatch((0, _fetchM.fetchM)(url, opts));
      }).then(function (res) {
        return res.json();
      }).then(function (result) {
        return _this2.setLoading(false).then(function () {
          return result;
        });
      }).catch(function (err) {
        return _this2.setLoading(false).then(function () {
          return Promise.reject(err);
        });
      });
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      var _this3 = this;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true }, function () {
          if (_this3.props.onChange) {
            _this3.props.onChange(true);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        'form',
        {
          encType: 'multipart/form-data',
          onSubmit: this.handleSubmit,
          name: 'uploadCompanyDocuments',
          ref: function ref(_ref2) {
            _this4.form = _ref2;
          }
        },
        _react2.default.createElement('input', {
          ref: function ref(_ref) {
            _this4.uploadFiles = _ref;
          },
          type: 'file',
          onChange: this.handleOnChange,
          accept: 'application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          style: { display: 'none' }
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 'equal' },
            _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'computer' }),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { verticalAlign: 'middle', columns: 'equal' },
                this.state.upload ? null : _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Button, {
                    fluid: true,
                    compact: true,
                    primary: true,
                    icon: 'add',
                    content: t('Select File', { ns: _translation.TRANSLATION_FILES.screens }),
                    onClick: this.handleAddFile,
                    disabled: this.state.loading
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Button, {
                    fluid: true,
                    compact: true,
                    type: 'submit',
                    positive: true,
                    content: t('Upload', { ns: _translation.TRANSLATION_FILES.translation }), icon: 'cloud upload',
                    loading: this.state.loading,
                    disabled: !(this.state.upload && this.state.upload.file) || this.state.loading
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { stackable: true, doubling: true, columns: 1 },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              t('Uploading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          this.state.oriUpload && this.state.oriUpload.key ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Header,
              null,
              t('Current:', { ns: _translation.TRANSLATION_FILES.translation })
            ),
            _react2.default.createElement(
              _semanticUiReact.Segment.Group,
              { horizontal: true },
              _react2.default.createElement(
                _semanticUiReact.Segment,
                null,
                this.state.oriUpload.name
              ),
              _react2.default.createElement(
                _semanticUiReact.Segment,
                null,
                (0, _fileSize2.default)(this.state.oriUpload.size)
              )
            )
          ) : null,
          this.state.upload ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Header,
              null,
              t('Selected file:', { ns: _translation.TRANSLATION_FILES.translation })
            ),
            _react2.default.createElement(
              _semanticUiReact.Segment.Group,
              { horizontal: true },
              _react2.default.createElement(
                _semanticUiReact.Segment,
                null,
                this.state.upload.name
              ),
              _react2.default.createElement(
                _semanticUiReact.Segment,
                null,
                (0, _fileSize2.default)(this.state.upload.file.size)
              )
            )
          ) : null,
          this.state.upload ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { stackable: true, columns: 'equal' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(_semanticUiReact.Button, {
                  fluid: true,
                  compact: true,
                  primary: true,
                  icon: 'add',
                  content: t('Replace', { ns: _translation.TRANSLATION_FILES.screens }),
                  onClick: this.handleAddFile,
                  disabled: this.state.loading
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(_semanticUiReact.Button, {
                  type: 'button',
                  fluid: true,
                  compact: true,
                  icon: 'delete',
                  content: t('Remove', { ns: _translation.TRANSLATION_FILES.screens }),
                  negative: true,
                  disabled: this.state.loading,
                  onClick: function onClick(e) {
                    return _this4.handleRemove(e);
                  }
                })
              )
            )
          ) : null
        )
      );
    }
  }]);

  return UploadCompanyDocumentForm;
}(_react.Component);

UploadCompanyDocumentForm.propTypes = {
  onSubmit: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  t: _propTypes2.default.func,
  file: _propTypes2.default.shape({
    name: _propTypes2.default.string,
    size: _propTypes2.default.number
  })
};
UploadCompanyDocumentForm.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(UploadCompanyDocumentForm);

/***/ }),
/* 2300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _prompt = __webpack_require__(66);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _fileSize = __webpack_require__(85);

var _fileSize2 = _interopRequireDefault(_fileSize);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _promptMessages = __webpack_require__(43);

var _translation = __webpack_require__(4);

var _Form = __webpack_require__(2299);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import PageNav from '../../components/PageNav';


var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _initialiseProps.call(_this);

    var state = List.getPropsToState(props);
    _this.state = _extends({}, state, {
      selectedFile: null,
      showDelete: false,
      showUpload: false
    });
    return _this;
  }

  _createClass(List, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var store = this.context.store;

      store.dispatch((0, _reactRouterRedux.replace)('/settings/company_documents/?' + (0, _url.encodeSearch)(query)));
    }
  }, {
    key: 'deleteCompanyDocument',
    value: function deleteCompanyDocument() {
      var _this2 = this;

      var store = this.context.store;
      var selectedFile = this.state.selectedFile;
      var t = this.props.t;

      this.getToken(selectedFile.id, function (token) {
        store.dispatch((0, _fetchM.fetchM)('/company_documents/' + selectedFile.id + '/', {
          credentials: 'include',
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'X-Csrf-Token': token
          }
        })).then(function () {
          _this2.setState({
            selectedFile: null,
            loading: false
          });
          _this2.handleChangePage();
          store.dispatch((0, _flash.flashSuccessMessage)({
            header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }),
            message: t('Company Document ({{name}}) successfully deleted', { name: selectedFile.name, ns: _translation.TRANSLATION_FILES.translation })
          }));
        }).catch(function (err) {
          store.dispatch((0, _flash.flashErrorMessage)(err));
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Company Documents')
        }),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            open: this.state.showDelete,
            onClose: this.handleCancelDelete
          },
          _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: t('Confirm delete') + '?' }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Modal.Description,
              null,
              _react2.default.createElement(_semanticUiReact.Header, {
                as: 'h3',
                content: t('Are you sure to delete this file') + '?',
                subheader: this.state.selectedFile ? this.state.selectedFile.name : ''
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(_semanticUiReact.Button, { basic: true, negative: true, onClick: this.handleCancelDelete, icon: 'cancel', content: t('No', { ns: _translation.TRANSLATION_FILES.constants }), inverted: true }),
            _react2.default.createElement(_semanticUiReact.Button, { basic: true, positive: true, onClick: this.handleConfirmDelete, icon: 'trash', content: t('Yes', { ns: _translation.TRANSLATION_FILES.constants }), inverted: true })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            className: 'upload-modal',
            open: this.state.showUpload,
            onClose: function onClose(e) {
              return _this3.handleCloseUpload(e, false);
            },
            closeIcon: 'close'
          },
          _react2.default.createElement(_semanticUiReact.Header, { icon: 'cloud upload', content: t('Upload file for {{name}}', { name: this.state.selectedFile ? this.state.selectedFile.name : '', ns: _translation.TRANSLATION_FILES.screens }) }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(_Form2.default, {
              ref: function ref(_ref) {
                _this3.form = _ref;
              },
              file: this.state.selectedFile,
              onSubmit: this.uploadCompanyDocument
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 20 },
            active: this.state.loading && this.state.data.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            striped: true, unstackable: true,
            selectable: true
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Name')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Size')
              ),
              _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null)
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            this.state.data.length > 0 ? this.state.data.map(function (file, key) {
              return _react2.default.createElement(
                _semanticUiReact.Table.Row,
                { key: key },
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { width: 6 },
                  file.key ? _react2.default.createElement(
                    'a',
                    {
                      href: _config2.default.get('bookApiURL') + '/company_documents/' + file.id + '/view/' + file.key.substring(file.key.lastIndexOf('/') + 1),
                      target: '_blank',
                      rel: 'noopener noreferrer'
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'file outline' }),
                    file.name
                  ) : _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'file outline' }),
                    file.name
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { collapsing: true },
                  file.size ? (0, _fileSize2.default)(file.size) : '-'
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { collapsing: true, textAlign: 'right' },
                  file.key ? _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_semanticUiReact.Button, {
                      compact: true,
                      primary: true,
                      icon: 'edit',
                      disabled: _this3.state.loading,
                      onClick: function onClick(e) {
                        return _this3.handleUpload(e, file);
                      }
                    }),
                    _react2.default.createElement(_semanticUiReact.Button, {
                      compact: true,
                      negative: true,
                      icon: 'delete',
                      disabled: _this3.state.loading,
                      onClick: function onClick(e) {
                        return _this3.handleDelete(e, file);
                      }
                    })
                  ) : _react2.default.createElement(_semanticUiReact.Button, {
                    disabled: _this3.state.loading,
                    primary: true,
                    icon: 'cloud upload',
                    labelPosition: 'left',
                    content: t('Upload', { ns: _translation.TRANSLATION_FILES.translation }),
                    onClick: function onClick(e) {
                      return _this3.handleUpload(e, file);
                    }
                  })
                )
              );
            }) : _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 4, textAlign: 'center' },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  'Loading'
                ) : t('No company documents found') + '.'
              )
            )
          )
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};
List.propTypes = {
  t: _propTypes2.default.func,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  })
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  var count = props.count;
  var limit = props.limit;
  var offset = props.offset;
  var data = props.data || [];
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  return {
    data: data,
    loading: loading,
    count: count,
    limit: limit,
    offset: offset,
    currentPage: currentPage
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.getToken = function (id, callback) {
    var store = _this4.context.store;

    store.dispatch((0, _fetchM.fetchM)('/company_documents/' + id + '/', {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })).catch(function (err) {
      store.dispatch((0, _flash.flashErrorMessage)(err));
    }).then(function (res) {
      var token = res.headers.get('X-Csrf-Token');
      if (callback) {
        callback(token);
      }
    });
  };

  this.handleChangePage = function (page) {
    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
      query.page = 1;
    }
    var currentPage = parseInt(page || query.page, 10);
    query.page = currentPage;
    _this4.setState({ currentPage: currentPage });
    _this4.replaceQuery(query);
  };

  this.handleCancelDelete = function (e) {
    e.preventDefault();
    _this4.setState({
      showDelete: false,
      selectedFile: null
    });
  };

  this.handleDelete = function (e, selectedFile) {
    e.preventDefault();
    _this4.setState({
      selectedFile: selectedFile,
      showDelete: true
    });
  };

  this.handleConfirmDelete = function (e) {
    e.preventDefault();
    _this4.setState({
      showDelete: false,
      loading: true
    }, function () {
      _this4.deleteCompanyDocument();
    });
  };

  this.uploadCompanyDocument = function (e, body) {
    e.preventDefault();
    var selectedFile = _this4.state.selectedFile;
    var store = _this4.context.store;
    var t = _this4.props.t;

    _this4.getToken(selectedFile.id, function (token) {
      _this4.form.submit('/company_documents/' + selectedFile.id + '/', {
        credentials: 'include',
        method: 'PUT',
        headers: {
          // Let browser decide Content-Type
          'X-Csrf-Token': token
        },
        body: body
      }).then(function () {
        _this4.handleCloseUpload(e, true);
        _this4.handleChangePage();
        store.dispatch((0, _flash.flashSuccessMessage)({
          header: t('Upload Success', { ns: _translation.TRANSLATION_FILES.translation }),
          message: t('Company Document ({{name}}) successfully uploaded', { name: selectedFile.name, ns: _translation.TRANSLATION_FILES.translation })
        }));
      }).catch(function (err) {
        if (err.res && err.res.status >= 400 && err.res.status < 500) {
          var message = err.res.text();
          store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
          return;
        }
        store.dispatch((0, _flash.flashErrorMessage)(err));
      });
    });
  };

  this.handleCheckBeforeClose = function () {
    var t = _this4.props.t;

    if (_this4.form.state.upload && _this4.form.state.upload.file) {
      var callback = function callback() {
        _this4.handleCloseUpload(null, true);
        _this4.handleChangePage();
      };
      var store = _this4.context.store;

      store.dispatch((0, _prompt.promptChangesMessage)({ message: t(_promptMessages.UPLOAD_DOCUMENT_PROMPT, { ns: _translation.TRANSLATION_FILES.translation }), callback: callback }));
      return true;
    }
    return false;
  };

  this.handleCloseUpload = function (e) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (e) e.preventDefault();
    var showUpload = false;
    var selectedFile = null;
    if (!force) {
      showUpload = _this4.handleCheckBeforeClose();
      selectedFile = _this4.state.selectedFile;
    }
    _this4.setState({
      showUpload: showUpload,
      selectedFile: selectedFile
    });
  };

  this.handleUpload = function (e, selectedFile) {
    e.preventDefault();
    _this4.setState({
      selectedFile: selectedFile,
      showUpload: true
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(List);

/***/ }),
/* 2301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CompanyDocuments = __webpack_require__(2298);

var _CompanyDocuments2 = _interopRequireDefault(_CompanyDocuments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CompanyDocuments2.default;

/***/ }),
/* 2302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IncomeForm = function (_Component) {
  _inherits(IncomeForm, _Component);

  function IncomeForm(props) {
    _classCallCheck(this, IncomeForm);

    var _this = _possibleConstructorReturn(this, (IncomeForm.__proto__ || Object.getPrototypeOf(IncomeForm)).call(this, props));

    _initialiseProps.call(_this);

    var state = IncomeForm.getPropsToState(props);
    _this.state = _extends({}, state, {
      errMessages: []
    });
    _this.validation = {
      currentLoanAmount: (0, _react.createRef)(),
      netIncome: (0, _react.createRef)(),
      basicIncome: (0, _react.createRef)(),
      fixAllowance: (0, _react.createRef)(),
      deduction: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(IncomeForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = IncomeForm.getPropsToState(nextProps);
      if (JSON.stringify(state.oriIncome) === JSON.stringify(this.state.oriIncome)) {
        state.income = this.state.income;
      }
      this.setState(state);
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        var income = this.state.income;

        this.props.onChange(income);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var income = this.state.income;

      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref) {
            _this2.form = _ref;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 1, textAlign: 'center', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                mobile: 16,
                tablet: this.props.isEditing ? 6 : 11,
                computer: this.props.isEditing ? 5 : 9
              },
              _react2.default.createElement(_AppForm2.default.Input, {
                label: _react2.default.createElement(_semanticUiReact.Header, {
                  as: 'h5',
                  style: { marginBottom: '0.5em' },
                  textAlign: 'left',
                  content: 'Housing Loan Amount',
                  subheader: 'Current Housing Loan Amount'
                }),
                validateLabel: 'Housing Loan Amount',
                type: 'number',
                step: '0.01',
                name: 'currentLoanAmount',
                value: income.currentLoanAmount,
                onChange: this.handleInputChange,
                ref: this.validation.currentLoanAmount
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                mobile: 16,
                tablet: this.props.isEditing ? 10 : 16,
                computer: this.props.isEditing ? 10 : 16
              },
              !this.props.isEditing ? _react2.default.createElement(
                'h3',
                {
                  style: {
                    color: '#FFF79A',
                    textAlign: 'left',
                    textTransform: 'uppercase'
                  }
                },
                'Choose one'
              ) : null,
              _react2.default.createElement(
                _semanticUiReact.Menu,
                { fluid: true, widths: 2 },
                this.tabs.map(function (tab, idx) {
                  return _react2.default.createElement(
                    _semanticUiReact.Menu.Item,
                    {
                      key: idx,
                      name: tab.name,
                      onClick: function onClick() {
                        return _this2.handleChangeTab(tab.isSimple);
                      },
                      active: income.isSimple === tab.isSimple
                    },
                    _react2.default.createElement(_semanticUiReact.Header, {
                      content: tab.text,
                      subheader: tab.description
                    })
                  );
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            income.isSimple ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                mobile: 16,
                tablet: this.props.isEditing ? 6 : 11,
                computer: this.props.isEditing ? 5 : 9
              },
              _react2.default.createElement(_AppForm2.default.Input, {
                label: 'Net Monthly Income',
                type: 'number',
                step: '0.01',
                name: 'netIncome',
                value: income.netIncome,
                validation: income.isSimple ? [{
                  validate: _webValidations.numericRange,
                  option: {
                    min: 1,
                    message: 'Net Monthly Income is required'
                  }
                }] : null,
                onChange: this.handleInputChange,
                ref: this.validation.netIncome
              })
            ) : null,
            !income.isSimple ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              {
                mobile: 16,
                tablet: this.props.isEditing ? 6 : 11,
                computer: this.props.isEditing ? 5 : 9
              },
              _react2.default.createElement(_AppForm2.default.Input, {
                label: _react2.default.createElement(_semanticUiReact.Header, {
                  as: 'h5',
                  style: { marginBottom: '0.5em' },
                  textAlign: 'left',
                  content: 'Basic Monthly Income',
                  subheader: 'Monthly Basic Salary, Monthly Recurring Commission before any deduction'
                }),
                validateLabel: 'Basic Monthly Income',
                type: 'number',
                step: '0.01',
                name: 'basicIncome',
                value: income.basicIncome,
                onChange: this.handleInputChange,
                validation: !income.isSimple ? [{
                  validate: _webValidations.numericRange,
                  option: {
                    min: 1,
                    message: 'Basic Monthly Income is required'
                  }
                }] : null,
                ref: this.validation.basicIncome
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                label: _react2.default.createElement(_semanticUiReact.Header, {
                  as: 'h5',
                  style: { marginBottom: '0.5em' },
                  textAlign: 'left',
                  content: 'Fix Monthly Allowance',
                  subheader: 'Recurring fixed travel allowance, meal allowance, yearly contractual bonus/12months'
                }),
                validateLabel: 'Fix Monthly Allowance',
                type: 'number',
                step: '0.01',
                name: 'fixAllowance',
                value: income.fixAllowance,
                onChange: this.handleInputChange,
                ref: this.validation.fixAllowance
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                label: 'Gross Monthly Income',
                type: 'number',
                step: '0.01',
                name: 'grossIncome',
                value: income.grossIncome,
                disabled: true,
                readOnly: true
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                label: _react2.default.createElement(_semanticUiReact.Header, {
                  as: 'h5',
                  style: { marginBottom: '0.5em' },
                  textAlign: 'left',
                  content: 'Monthly Income deduction',
                  subheader: 'EPF, SOSCO, PCB, CP38'
                }),
                validateLabel: 'Monthly Income deduction',
                type: 'number',
                step: '0.01',
                name: 'deduction',
                value: income.deduction,
                onChange: this.handleInputChange,
                ref: this.validation.deduction
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                label: 'Net Monthly Income',
                type: 'number',
                step: '0.01',
                name: 'netIncome',
                value: income.netIncome,
                disabled: true,
                readOnly: true
              })
            ) : null
          )
        )
      );
    }
  }]);

  return IncomeForm;
}(_react.Component);

IncomeForm.propTypes = {
  income: _propTypes2.default.shape({
    isSimple: _propTypes2.default.bool
  }),
  onChange: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func.isRequired,
  isEditing: _propTypes2.default.bool
};
IncomeForm.defaultValues = {
  isSimple: true,
  basicIncome: 0,
  fixAllowance: 0,
  grossIncome: 0,
  deduction: 0,
  netIncome: 0,
  currentLoanAmount: 0
};

IncomeForm.getPropsToState = function (props) {
  var income = Object.assign({}, IncomeForm.defaultValues, props.income || {});
  return {
    income: income,
    oriIncome: (0, _clone2.default)(income)
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleSubmit = function () {
    var income = _this3.state.income;

    if (income.isSimple) {
      income.basicIncome = 0;
      income.deduction = 0;
      income.fixAllowance = 0;
      income.grossIncome = 0;
    }
    _AppForm2.default.validate(_this3.validation, income).then(function (validations) {
      _this3.setState({
        errMessages: validations.filter(function (v) {
          return !v.isValid;
        })
      });
      _this3.props.onSubmit(validations, income);
    });
  };

  this.handleInputChange = function (event, data) {
    var income = _this3.state.income;

    income[data.name] = _lodash2.default.toNumber(data.value);
    if (!income.isSimple) {
      income.grossIncome = _lodash2.default.toNumber(income.basicIncome) + _lodash2.default.toNumber(income.fixAllowance);
      income.netIncome = _lodash2.default.toNumber(income.grossIncome) - _lodash2.default.toNumber(income.deduction);
    }
    _this3.setState({ income: income }, function () {
      _this3.handleCheckChanges();
    });
  };

  this.tabs = [{ name: 'isSimple', text: 'Monthly Net Income', description: 'Basic calculation', isSimple: true }, { name: 'isAdvance', text: 'Detailed Income', description: 'For more accurate calculation', isSimple: false }];

  this.handleChangeTab = function () {
    var isSimple = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var income = _this3.state.income;

    income.isSimple = isSimple;
    _this3.setState({ income: income });
  };
};

exports.default = IncomeForm;

/***/ }),
/* 2303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoanInfo = function (_Component) {
  _inherits(LoanInfo, _Component);

  function LoanInfo(props) {
    _classCallCheck(this, LoanInfo);

    var _this = _possibleConstructorReturn(this, (LoanInfo.__proto__ || Object.getPrototypeOf(LoanInfo)).call(this, props));

    _initialiseProps.call(_this);

    var state = LoanInfo.getPropsToState(props);
    _this.state = _extends({}, state, {
      displayedPercentage: '',
      errMessages: [],
      loanPercentage: 0
    });
    return _this;
  }

  _createClass(LoanInfo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.pathCheck ? this.getDefaultLoanAmount() : null;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = LoanInfo.getPropsToState(nextProps);
      if (JSON.stringify(this.state.oriCreditCheckReportData) === JSON.stringify(state.oriCreditCheckReportData)) {
        state.creditCheckReportData = this.state.creditCheckReportData;
      }
      this.setState({ state: state });
    }
  }, {
    key: 'getDefaultLoanAmount',
    value: function getDefaultLoanAmount() {
      var bookingCustomerData = this.props.bookingCustomerData;
      var creditCheckReportData = this.state.creditCheckReportData;

      var newCreditCheckReportData = Object.assign({}, creditCheckReportData);
      newCreditCheckReportData.currentLoanAmount = _lodash2.default.toNumber((bookingCustomerData.spaValue * 0.9).toFixed(2));
      this.setState({ creditCheckReportData: newCreditCheckReportData, displayPercentage: '90%' });
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        var creditCheckReportData = this.state.creditCheckReportData;

        this.props.onChange(creditCheckReportData);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var bookingCustomerData = this.props.bookingCustomerData;
      var _state = this.state,
          displayPercentage = _state.displayPercentage,
          creditCheckReportData = _state.creditCheckReportData,
          loanPercentage = _state.loanPercentage;

      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref) {
            _this2.loanInfo = _ref;
          }
        },
        this.props.pathCheck ? _react2.default.createElement(
          _semanticUiReact.Container,
          {
            style: {
              border: '1px solid rgba(164, 179, 193, 1)',
              padding: '0.7rem 2rem',
              borderRadius: '0.25rem',
              background: 'rgba(231, 236, 241, 1)'
            }
          },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(_semanticUiReact.Label, { content: 'Loan Amount', style: { background: 'transparent', color: 'black' } }),
                _react2.default.createElement(
                  'div',
                  { style: { fontSize: '1.7rem', fontWeight: 'bold', margin: '0.5rem' } },
                  _react2.default.createElement(_LoanAmount2.default, {
                    format: '0,000,000.00',
                    amount: _lodash2.default.toNumber(creditCheckReportData.currentLoanAmount),
                    prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'loanInfoContainer' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Header, {
                    as: 'h5',
                    style: { marginBottom: '0.5em' },
                    textAlign: 'left',
                    content: 'Selling Price'
                  }),
                  _react2.default.createElement(
                    'div',
                    { className: 'spaValueContainer' },
                    _react2.default.createElement(_LoanAmount2.default, {
                      format: '0,000,000.00',
                      amount: bookingCustomerData.spaValue,
                      prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                    })
                  ),
                  _react2.default.createElement(_semanticUiReact.Header, {
                    as: 'h5',
                    style: { marginBottom: '0.5em' },
                    textAlign: 'left',
                    content: 'Loan Percentage'
                  }),
                  _react2.default.createElement(_semanticUiReact.Dropdown, {
                    fluid: true,
                    placeholder: 'Loan Percentage',
                    selection: true,
                    options: this.percentageOptions,
                    onChange: this.handleDropdownChange,
                    trigger: loanPercentage === 0 && creditCheckReportData.currentLoanAmount !== 0 ? displayPercentage : null
                  })
                )
              )
            )
          )
        ) : _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              _react2.default.createElement(_semanticUiReact.Header, {
                as: 'h5',
                style: { marginBottom: '0.5em' },
                textAlign: 'left',
                content: 'Loan Amount'
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                type: 'number',
                step: '0.01',
                name: 'currentLoanAmount',
                value: _lodash2.default.toNumber(creditCheckReportData.currentLoanAmount),
                onChange: this.handleInputChange
              })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: this.props.pathCheck ? { marginTop: '3rem' } : null },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              _react2.default.createElement(_semanticUiReact.Header, {
                as: 'h5',
                style: { marginBottom: '0.5em' },
                textAlign: 'left',
                content: 'Monthly Commitment'
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                type: 'number',
                step: '0.01',
                name: 'monthlyCommitment',
                value: creditCheckReportData.monthlyCommitment,
                onChange: this.handleInputChange
              })
            )
          )
        )
      );
    }
  }]);

  return LoanInfo;
}(_react.Component);

LoanInfo.propTypes = {
  bookingCustomerData: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object]),
  creditCheckReportData: _propTypes2.default.shape({
    currentLoanAmount: _propTypes2.default.number,
    monthlyCommitment: _propTypes2.default.number
  }),
  onChange: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func.isRequired,
  pathCheck: _propTypes2.default.bool
};
LoanInfo.defaultCustomerCreditReportsData = {
  currentLoanAmount: 0,
  monthlyCommitment: 0
};
LoanInfo.contextType = {
  store: _propTypes2.default.object
};

LoanInfo.getPropsToState = function (props) {
  var creditCheckReportData = Object.assign({}, props.creditCheckReportData || {});
  var bookingCustomerData = Object.assign({}, props.bookingCustomerData || {});
  return {
    creditCheckReportData: creditCheckReportData,
    oriCreditCheckReportData: (0, _clone2.default)(creditCheckReportData),
    bookingCustomerData: bookingCustomerData
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.percentageOptions = [{
    text: '95%',
    value: '0.95'
  }, {
    text: '90%',
    value: '0.90'
  }, {
    text: '85%',
    value: '0.85'
  }, {
    text: '80%',
    value: '0.80'
  }, {
    text: '75%',
    value: '0.75'
  }, {
    text: '70%',
    value: '0.70'
  }, {
    text: '65%',
    value: '0.65'
  }, {
    text: '60%',
    value: '0.60'
  }, {
    text: '55%',
    value: '0.55'
  }, {
    text: '50%',
    value: '0.50'
  }, {
    text: '45%',
    value: '0.45'
  }, {
    text: '40%',
    value: '0.40'
  }, {
    text: '35%',
    value: '0.35'
  }, {
    text: '30%',
    value: '0.30'
  }, {
    text: '25%',
    value: '0.25'
  }, {
    text: '20%',
    value: '0.20'
  }, {
    text: '15%',
    value: '0.15'
  }, {
    text: '10%',
    value: '0.10'
  }, {
    text: '5%',
    value: '0.5'
  }];

  this.handleDropdownChange = function (e, _ref2) {
    var value = _ref2.value;
    var creditCheckReportData = _this3.state.creditCheckReportData;

    e.preventDefault();
    var newCreditCheckReportData = Object.assign({}, creditCheckReportData);
    newCreditCheckReportData.currentLoanAmount = _lodash2.default.toNumber((_this3.props.bookingCustomerData.spaValue * value).toFixed(2));
    _this3.setState({ loanPercentage: value, creditCheckReportData: newCreditCheckReportData }, function () {
      _this3.handleCheckChanges();
    });
  };

  this.handleFlashError = function () {
    var store = _this3.context.store;

    store.dispatch((0, _flash.flashErrorMessage)('Please tick the checkbox to generate ctos report'));
  };

  this.handleInputChange = function (e, data) {
    e.preventDefault();
    var creditCheckReportData = _this3.state.creditCheckReportData;

    creditCheckReportData[data.name] = _lodash2.default.toNumber(data.value);
    _this3.setState({ creditCheckReportData: creditCheckReportData }, function () {
      _this3.handleCheckChanges();
    });
  };

  this.handleSubmit = function () {
    var creditCheckReportData = _this3.state.creditCheckReportData;

    _this3.props.onSubmit(creditCheckReportData);
  };
};

exports.default = LoanInfo;

/***/ }),
/* 2304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

var _semanticUiReact = __webpack_require__(2);

var _reactRedux = __webpack_require__(9);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _reactRouterRedux = __webpack_require__(13);

var _reactRouter = __webpack_require__(18);

var _flash = __webpack_require__(5);

var _url = __webpack_require__(19);

var _storage = __webpack_require__(44);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _CreditCheckManageButton = __webpack_require__(2119);

var _CreditCheckManageButton2 = _interopRequireDefault(_CreditCheckManageButton);

var _ctosStatus = __webpack_require__(2220);

var _ctosStatus2 = _interopRequireDefault(_ctosStatus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_momentTimezone2.default.locale('en-gb');

var Manage = function (_Component) {
  _inherits(Manage, _Component);

  function Manage(props) {
    _classCallCheck(this, Manage);

    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));

    _initialiseProps.call(_this);

    var state = Manage.getPropsToState(props);
    state.data = [];
    _this.state = _extends({}, state, {
      ccrCreatorBUs: [],
      ccrProjects: [],
      companyAppCredit: [],
      companyApp: [],
      creditSubscription: {
        amount: 0
      }
    });
    return _this;
  }

  _createClass(Manage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = this.getQuery();
      this.fetchCreditReports(query);
      this.getCredit();
      var localAutoReloadValue = (0, _storage.getItem)(_config2.default.get('appName') + '.creditCheckManageAutoReload');
      if (localAutoReloadValue === 'true') {
        this.state.autoReload = true;
        this.setRefreshDataTimeout();
      }
      if (this.props.auth && this.props.auth.companyBranch) {
        this.getBUCreditsSubscription(this.props.auth.companyBranch);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Manage.getPropsToState(nextProps);
      state.token = this.state.token;
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      if (this.timeoutRefresh) {
        clearTimeout(this.timeoutRefresh);
      }
    }
  }, {
    key: 'getQuery',
    value: function getQuery() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _url.decodeSearch)(this.props.location.search);

      return {
        businessUnit: query.businessUnit,
        page: this.state.currentPage,
        project: query.project,
        limit: this.state.limit,
        search: this.state.search,
        sortColumn: query.sortColumn,
        sortDirection: query.sortDirection,
        status: query.status
      };
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, res);
      });
    }
  }, {
    key: 'setData',
    value: function setData() {
      var _this4 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this4.setState({
          data: data || []
        }, res);
      });
    }
  }, {
    key: 'getCredit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, _message, companyAppCredit;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                _context.next = 3;
                return this.setLoading(true);

              case 3:
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/company/credit/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 22;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);
                _context.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 17;
                return _context.t0.res.text();

              case 17:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 20:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 22:
                if (res.ok) {
                  _context.next = 30;
                  break;
                }

                _context.next = 25;
                return res.text();

              case 25:
                _message = _context.sent;
                _context.next = 28;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 28:
                _context.next = 36;
                break;

              case 30:
                _context.next = 32;
                return res.json();

              case 32:
                companyAppCredit = _context.sent;

                if (!(companyAppCredit !== null)) {
                  _context.next = 36;
                  break;
                }

                _context.next = 36;
                return this.setComponentState({ companyAppCredit: companyAppCredit, companyApp: companyAppCredit.companyApp });

              case 36:
                _context.next = 38;
                return this.setLoading(false);

              case 38:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function getCredit() {
        return _ref.apply(this, arguments);
      }

      return getCredit;
    }()
  }, {
    key: 'fetchCreditReports',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(query) {
        var silentLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        var store, res, url, queryString, message, token, count, limit, offset, hasLess, ccr, ccrCreatorBUs, ccrProjects, result, hasMore, i, _i;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (silentLoad) {
                  _context2.next = 3;
                  break;
                }

                _context2.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                res = void 0;
                _context2.prev = 5;
                url = '/manage/credit_checks/';
                queryString = '';

                if (_qs2.default.stringify(query)) {
                  queryString = '?' + _qs2.default.stringify(query);
                }
                _context2.next = 11;
                return store.dispatch((0, _fetchM.fetchM)('' + url + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 11:
                res = _context2.sent;
                _context2.next = 22;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](5);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 19;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 19:
                _context2.next = 21;
                return this.setLoading(false);

              case 21:
                return _context2.abrupt('return');

              case 22:
                if (res.ok) {
                  _context2.next = 30;
                  break;
                }

                _context2.next = 25;
                return res.text();

              case 25:
                message = _context2.sent;
                _context2.next = 28;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 28:
                _context2.next = 45;
                break;

              case 30:
                token = res.headers.get('X-Csrf-Token');
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                hasLess = offset !== 0;
                ccr = [];
                ccrCreatorBUs = [{ text: 'All', value: 'All' }];
                ccrProjects = [{ text: 'All', value: 'All' }];
                _context2.next = 40;
                return res.json();

              case 40:
                result = _context2.sent;
                hasMore = void 0;

                if (result) {
                  if (result.businessUnits && result.businessUnits.length > 0) {
                    for (i = 0; i < result.businessUnits.length; i += 1) {
                      ccrCreatorBUs = ccrCreatorBUs.concat({
                        text: result.businessUnits[i],
                        value: result.businessUnits[i]
                      });
                    }
                  }
                  if (result.projects && result.projects.length > 0) {
                    for (_i = 0; _i < result.projects.length; _i += 1) {
                      ccrProjects = ccrProjects.concat({
                        text: result.projects[_i],
                        value: result.projects[_i]
                      });
                    }
                  }
                  ccr = result.customerCreditReports ? result.customerCreditReports : [];
                  hasMore = result.customerCreditReports && result.customerCreditReports.length === limit ? result.customerCreditReports.length !== count : false;
                } else {
                  hasMore = false;
                }
                _context2.next = 45;
                return this.setComponentState({
                  token: token,
                  count: count,
                  limit: limit,
                  offset: offset,
                  data: ccr,
                  hasMore: hasMore,
                  hasLess: hasLess,
                  ccrCreatorBUs: ccrCreatorBUs,
                  ccrProjects: ccrProjects
                });

              case 45:
                _context2.next = 47;
                return this.setLoading(false);

              case 47:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 14]]);
      }));

      function fetchCreditReports(_x5) {
        return _ref2.apply(this, arguments);
      }

      return fetchCreditReports;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      store.dispatch((0, _reactRouterRedux.replace)('/customers/manage/credit_checks/?' + (0, _url.encodeSearch)(query)));
      this.fetchCreditReports(query, true);
    }
  }, {
    key: 'pushQuery',
    value: function pushQuery() {
      var query = this.getQuery();
      var store = this.context.store;

      store.dispatch((0, _reactRouterRedux.replace)('/customers/manage/credit_checks/?' + (0, _url.encodeSearch)(query)));
      this.fetchCreditReports(query);
    }
  }, {
    key: 'renderPurchaser',
    value: function renderPurchaser(data) {
      var _props$auth = this.props.auth,
          auth = _props$auth === undefined ? {} : _props$auth;

      var isAgent = auth.companyBranch ? auth.companyBranch.isExternal && auth.isDeveloper : false;
      if (!isAgent) {
        return _react2.default.createElement(
          _reactRouter.Link,
          { to: '/customers/' + data.customerID + '/' },
          data.customer && data.customer.customerDetail && data.customer.customerDetail !== null && data.customer.customerDetail.name
        );
      }
      if (data.booking && data.booking.id) {
        return _react2.default.createElement(
          _reactRouter.Link,
          { to: '/bookings/' + data.booking.id + '/' },
          data.customer && data.customer.customerDetail && data.customer.customerDetail !== null && data.customer.customerDetail.name
        );
      }

      return _react2.default.createElement(
        'span',
        null,
        data.customer && data.customer.customerDetail && data.customer.customerDetail !== null && data.customer.customerDetail.name
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props$auth2 = this.props.auth,
          auth = _props$auth2 === undefined ? {} : _props$auth2;
      var _state = this.state,
          creditSubscription = _state.creditSubscription,
          companyAppCredit = _state.companyAppCredit;

      var isAgent = auth.companyBranch ? auth.companyBranch.isExternal && auth.isDeveloper : false;
      var isHQDeveloper = auth.isHeadquarters;
      var query = (0, _url.decodeSearch)(this.props.location.search);
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: this.state.count === 0 ? 'Manage' : _react2.default.createElement(
            'span',
            null,
            'Manage \xA0',
            _react2.default.createElement(
              _semanticUiReact.Label,
              { color: 'blue' },
              this.state.count
            )
          ),
          rightNav: isHQDeveloper ? _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              as: _reactRouter.Link,
              primary: true,
              content: 'Settings',
              disabled: this.state.loading,
              to: '/customers/manage/credit_checks/settings/'
            })
          ) : null
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { className: 'manage credit-check' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                {
                  active: this.state.loading && this.state.data && this.state.data.length > 0,
                  inverted: true
                },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  'Loading'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { className: 'dark credit-check', color: 'grey', inverted: true, secondary: true, textAlign: 'center' },
                _react2.default.createElement(
                  _semanticUiReact.Divider,
                  { horizontal: true, inverted: true },
                  'Manage'
                ),
                !isAgent ? _react2.default.createElement(_semanticUiReact.Button, {
                  as: _reactRouter.Link,
                  disabled: this.state.loading,
                  size: 'small',
                  color: 'blue',
                  content: 'Generate New Credit Check',
                  to: '/customers/new/'
                }) : null,
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Header.Content,
                    { className: 'previous-credit-check' },
                    _react2.default.createElement(
                      'p',
                      { style: { fontSize: '.9em', margin: '0 0 .3em' } },
                      'Credits'
                    ),
                    _react2.default.createElement(
                      'p',
                      {
                        className: this.creditColor(creditSubscription.amount)
                      },
                      'MYR\xA0',
                      creditSubscription.amount
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { only: 'computer' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 3 },
                      _react2.default.createElement(_PageNav2.default, {
                        color: 'white',
                        currentPage: this.state.currentPage,
                        count: this.state.count,
                        limit: this.state.limit,
                        hasMore: this.state.hasMore,
                        hasLess: this.state.hasLess,
                        loading: this.state.loading,
                        onChange: this.handleChangePage
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 3 },
                      _react2.default.createElement(_SearchFilter2.default, {
                        isLoading: this.state.loading,
                        onChange: this.handleFilterOnChange,
                        onClose: this.handleClearFilter,
                        search: this.state.search,
                        placeholder: 'Search'
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 3 },
                      _react2.default.createElement(_semanticUiReact.Dropdown, {
                        name: 'project',
                        placeholder: 'Project',
                        fluid: true,
                        search: true,
                        selection: true,
                        onChange: this.handleOnDropdownChange,
                        options: this.state.ccrProjects,
                        value: query.project
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 3 },
                      _react2.default.createElement(_semanticUiReact.Dropdown, {
                        name: 'businessUnit',
                        placeholder: 'Business unit',
                        fluid: true,
                        search: true,
                        selection: true,
                        onChange: this.handleOnDropdownChange,
                        options: this.state.ccrCreatorBUs,
                        value: query.businessUnit
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 3 },
                      _react2.default.createElement(_semanticUiReact.Dropdown, {
                        name: 'status',
                        placeholder: 'Status',
                        fluid: true,
                        search: true,
                        selection: true,
                        onChange: this.handleOnDropdownChange,
                        options: _ctosStatus2.default,
                        value: query.status
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 1 },
                      _react2.default.createElement(_SortButton2.default, {
                        floated: 'right',
                        loading: this.state.loading,
                        items: this.sortItems,
                        onSort: this.handleSortData
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { only: 'tablet' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 3 },
                      _react2.default.createElement(_PageNav2.default, {
                        color: 'white',
                        currentPage: this.state.currentPage,
                        count: this.state.count,
                        limit: this.state.limit,
                        hasMore: this.state.hasMore,
                        hasLess: this.state.hasLess,
                        loading: this.state.loading,
                        onChange: this.handleChangePage
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 11 },
                      _react2.default.createElement(_SearchFilter2.default, {
                        isLoading: this.state.loading,
                        onChange: this.handleFilterOnChange,
                        onClose: this.handleClearFilter,
                        search: this.state.search,
                        placeholder: 'Search'
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 2 },
                      _react2.default.createElement(_SortButton2.default, {
                        floated: 'right',
                        loading: this.state.loading,
                        items: this.sortItems,
                        onSort: this.handleSortData
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { only: 'tablet', columns: 3 },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      null,
                      _react2.default.createElement(_semanticUiReact.Dropdown, {
                        name: 'project',
                        placeholder: 'Project',
                        fluid: true,
                        search: true,
                        selection: true,
                        onChange: this.handleOnDropdownChange,
                        options: this.state.ccrProjects,
                        value: query.project
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      null,
                      _react2.default.createElement(_semanticUiReact.Dropdown, {
                        name: 'businessUnit',
                        placeholder: 'Business unit',
                        fluid: true,
                        search: true,
                        selection: true,
                        onChange: this.handleOnDropdownChange,
                        options: this.state.ccrCreatorBUs,
                        value: query.businessUnit
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      null,
                      _react2.default.createElement(_semanticUiReact.Dropdown, {
                        name: 'status',
                        placeholder: 'Status',
                        fluid: true,
                        search: true,
                        selection: true,
                        onChange: this.handleOnDropdownChange,
                        options: _ctosStatus2.default,
                        value: query.status
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { only: 'mobile', columns: 2 },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'left' },
                      _react2.default.createElement(_PageNav2.default, {
                        color: 'white',
                        currentPage: this.state.currentPage,
                        count: this.state.count,
                        limit: this.state.limit,
                        hasMore: this.state.hasMore,
                        hasLess: this.state.hasLess,
                        loading: this.state.loading,
                        onChange: this.handleChangePage
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      null,
                      _react2.default.createElement(_SortButton2.default, {
                        floated: 'right',
                        loading: this.state.loading,
                        items: this.sortItems,
                        onSort: this.handleSortData
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { only: 'mobile' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      null,
                      _react2.default.createElement(_SearchFilter2.default, {
                        isLoading: this.state.loading,
                        onChange: this.handleFilterOnChange,
                        onClose: this.handleClearFilter,
                        search: this.state.search,
                        placeholder: 'Search'
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { only: 'mobile' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      null,
                      _react2.default.createElement(_semanticUiReact.Dropdown, {
                        name: 'project',
                        placeholder: 'Project',
                        fluid: true,
                        search: true,
                        selection: true,
                        onChange: this.handleOnDropdownChange,
                        options: this.state.ccrProjects,
                        value: query.project
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { only: 'mobile' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      null,
                      _react2.default.createElement(_semanticUiReact.Dropdown, {
                        name: 'businessUnit',
                        placeholder: 'Business unit',
                        fluid: true,
                        search: true,
                        selection: true,
                        onChange: this.handleOnDropdownChange,
                        options: this.state.ccrCreatorBUs,
                        value: query.businessUnit
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { only: 'mobile' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      null,
                      _react2.default.createElement(_semanticUiReact.Dropdown, {
                        name: 'status',
                        placeholder: 'Status',
                        fluid: true,
                        search: true,
                        selection: true,
                        onChange: this.handleOnDropdownChange,
                        options: _ctosStatus2.default,
                        value: query.status
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'center', width: 16 },
                      _react2.default.createElement(_semanticUiReact.Button, {
                        onClick: this.handleAutoReload,
                        compact: true,
                        size: 'tiny',
                        icon: this.state.autoReload ? { name: 'toggle on', color: 'green' } : { name: 'toggle off', color: 'red' },
                        content: 'Auto Refresh ' + (this.state.autoReload ? 'On' : 'Off')
                      }),
                      _react2.default.createElement(_semanticUiReact.Button, {
                        color: 'blue',
                        onClick: this.handleRefreshData,
                        compact: true,
                        size: 'tiny',
                        icon: 'refresh',
                        content: 'Refresh Now'
                      })
                    )
                  )
                ),
                this.state.data && this.state.data.length > 0 ? _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { columns: 2, className: 'equal height' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16 },
                      _react2.default.createElement(
                        _semanticUiReact.Table,
                        { singleLine: false, columns: 16, unstackable: true, celled: true, className: 'dark' },
                        _react2.default.createElement(
                          _semanticUiReact.Table.Header,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Table.Row,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              null,
                              'Purchaser'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              { className: 'mobile-hide', textAlign: 'center' },
                              'Project'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              { className: 'mobile-hide', textAlign: 'center' },
                              'Business unit'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              { className: 'mobile-hide', textAlign: 'center' },
                              'Requested by'
                            ),
                            !isAgent ? _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              { className: 'mobile-hide', textAlign: 'center' },
                              'Purchased by'
                            ) : null,
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              { textAlign: 'center' },
                              'CTOS Score'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              { textAlign: 'center' },
                              'DSR Score'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              { className: 'mobile-hide', textAlign: 'center' },
                              'Date'
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Table.Body,
                          null,
                          this.state.data.map(function (data, idx) {
                            return _react2.default.createElement(
                              _semanticUiReact.Table.Row,
                              {
                                key: idx,
                                id: data.id,
                                positive: data.approve,
                                negative: data.decline
                              },
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _this5.renderPurchaser(data)
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { textAlign: 'center' },
                                data.projectName !== '' ? data.projectName : _react2.default.createElement(_semanticUiReact.Icon, { color: 'grey', name: 'minus' })
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { textAlign: 'center' },
                                data.maUserAffiliateCompanyBranchName !== '' ? data.maUserAffiliateCompanyBranchName : _react2.default.createElement(_semanticUiReact.Icon, { color: 'grey', name: 'minus' })
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { className: 'mobile-hide', textAlign: 'center' },
                                data.maUserSubmittedByPreferredName !== '' ? data.maUserSubmittedByPreferredName : _react2.default.createElement(_semanticUiReact.Icon, { color: 'grey', name: 'minus' })
                              ),
                              !isAgent ? _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { className: 'mobile-hide', textAlign: 'center' },
                                data.maUserPurchasedByPreferredName !== '' ? data.maUserPurchasedByPreferredName : _react2.default.createElement(_semanticUiReact.Icon, { color: 'grey', name: 'minus' })
                              ) : null,
                              data.mCtosXMLStatusID === 'dsr_generated' ? _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { textAlign: 'center', collapsing: true },
                                data.ctosScore
                              ) : null,
                              data.mCtosXMLStatusID === 'dsr_generated' ? _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { textAlign: 'center', collapsing: true },
                                data.mCtosXMLStatusID === 'dsr_generated' ? data.dsr + ' %' : ''
                              ) : _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { colSpan: '2', textAlign: 'center' },
                                _react2.default.createElement(_CreditCheckManageButton2.default, {
                                  data: data,
                                  index: idx,
                                  fetchCreditReports: _this5.fetchCreditReports,
                                  getQuery: _this5.getQuery((0, _url.decodeSearch)(_this5.props.location.search))
                                  // companyApp={companyApp}
                                  , companyAppCredit: companyAppCredit,
                                  handleOpenModal: _this5.handleOpenModal,
                                  isAgent: isAgent,
                                  creditsAmount: creditSubscription && creditSubscription.amount !== '' ? Number(creditSubscription.amount) : 0
                                })
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { className: 'mobile-hide', textAlign: 'center' },
                                data.createdAt !== '' ? (0, _momentTimezone2.default)(data.createdAt).format('DD/MM/YY') : _react2.default.createElement(_semanticUiReact.Icon, { color: 'grey', name: 'minus' })
                              )
                            );
                          })
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { textAlign: 'center', width: 16 },
                      _react2.default.createElement(_PageNav2.default, {
                        color: 'white',
                        currentPage: this.state.currentPage,
                        count: this.state.count,
                        limit: this.state.limit,
                        hasMore: this.state.hasMore,
                        hasLess: this.state.hasLess,
                        loading: this.state.loading,
                        onChange: this.handleChangePage
                      })
                    )
                  )
                ) : _react2.default.createElement(
                  _semanticUiReact.Grid,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Item,
                        { style: {} },
                        _react2.default.createElement(
                          _semanticUiReact.Item.Content,
                          null,
                          !this.state.loading ? _react2.default.createElement(
                            _semanticUiReact.Segment,
                            { textAlign: 'center' },
                            _react2.default.createElement(
                              'p',
                              null,
                              'No pending Credit checks found.'
                            )
                          ) : ''
                        )
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Manage;
}(_react.Component);

Manage.contextTypes = {
  store: _propTypes2.default.object
};

Manage.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig,
    auth: state.auth
  };
};

Manage.propTypes = {
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    companyBranch: _propTypes2.default.shape({
      shortName: _propTypes2.default.string,
      isExternal: _propTypes2.default.bool
    }),
    isDeveloper: _propTypes2.default.bool
  })
};

Manage.getPropsToState = function (props) {
  var loading = true;
  var count = 0;
  var limit = 10;
  var offset = 0;
  var token = '';
  var hasMore = false;
  var hasLess = false;
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var reportToken = '';
  return {
    loading: loading,
    token: token,
    count: count,
    limit: limit,
    offset: offset,
    hasMore: hasMore,
    hasLess: hasLess,
    currentPage: currentPage,
    search: search,
    reportToken: reportToken,
    noResultsMessage: 'Loading...',
    autoReload: false
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.getBUCreditsSubscription = function (companyBranch) {
    var store = _this6.context.store;

    var id = companyBranch && companyBranch.service_company_branch_id;
    _auth2.default.currentSession().then(function (result) {
      var creditsSubscriptionToken = result.getIdToken().getJwtToken();
      if (_config2.default.get('server') === 'development') {
        creditsSubscriptionToken = _config2.default.get('subsAuth');
      }
      fetch(_config2.default.get('subscriptionApiEndpoint'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: creditsSubscriptionToken
        },
        body: JSON.stringify({
          query: '\n            query {\n              getSubscription(\n                id: "' + id + '",\n              ) { ' + _this6.getCreditsSubscriptionFragment() + ' }\n            }\n          '
        })
      }).then(function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(res) {
          var _ref4, data, message;

          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (!res.ok) {
                    _context3.next = 8;
                    break;
                  }

                  _context3.next = 3;
                  return res.json();

                case 3:
                  _ref4 = _context3.sent;
                  data = _ref4.data;

                  if (data && data.getSubscription) {
                    _this6.setState({
                      creditSubscription: _extends({}, data.getSubscription)
                    });
                  }
                  _context3.next = 10;
                  break;

                case 8:
                  message = 'Failed to retrieve subscription data';

                  store.dispatch((0, _flash.flashErrorMessage)(message));

                case 10:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this6);
        }));

        return function (_x8) {
          return _ref3.apply(this, arguments);
        };
      }());
    }).catch(function (err) {
      return store.dispatch((0, _flash.flashErrorMessage)(err));
    });
  };

  this.getCreditsSubscriptionFragment = function () {
    return '\n      id\n      company_id\n      company_branch_id\n      amount\n      currency_code\n      created_at\n      created_by\n      updated_at\n      updated_by\n    ';
  };

  this.setRefreshDataTimeout = function () {
    if (_this6.timeoutRefresh) {
      clearTimeout(_this6.timeoutRefresh);
    }
    _this6.timeoutRefresh = setTimeout(function () {
      _this6.handleRefreshData();
      _this6.setRefreshDataTimeout();
    }, 30000); // 30 seconds auto refresh time
  };

  this.handleAutoReload = function () {
    var autoReload = !_this6.state.autoReload;
    _this6.setState({ autoReload: autoReload }, function () {
      (0, _storage.setItem)(_config2.default.get('appName') + '.creditCheckManageAutoReload', autoReload ? 'true' : 'false');
      // if autoReload is disabled when there is an ongoing timeout then..
      // ..clear the timeout also.
      if (autoReload) {
        _this6.handleRefreshData();
        _this6.setRefreshDataTimeout();
      } else {
        if (_this6.timeout) {
          clearTimeout(_this6.timeout);
        }
        if (_this6.timeoutRefresh) {
          clearTimeout(_this6.timeoutRefresh);
        }
      }
    });
  };

  this.handleRefreshData = function () {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    _this6.fetchCreditReports(query);
    _this6.getCredit();
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.page = currentPage;
    _this6.setState({
      currentPage: currentPage
    }, function () {
      _this6.pushQuery();
    });
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = _this6.getQuery();
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this6.replaceQuery(query, true);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    if (hasQuery) {
      _this6.replaceQuery(query, true);
    }
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query[queryName] = value;
    _this6.replaceQuery(query, true);
  };

  this.sortItems = [{
    text: 'Oldest Credit report',
    icon: 'sort alphabet ascending',
    sortColumn: 'created_at',
    sortDirection: 'asc'
  }, {
    text: 'Latest Credit report',
    icon: 'sort alphabet descending',
    sortColumn: 'created_at',
    sortDirection: 'desc'
  }, {
    text: 'Name Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'name',
    sortDirection: 'asc'
  }, {
    text: 'Name Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'name',
    sortDirection: 'desc'
  }];

  this.creditColor = function (credit) {
    var color = void 0;
    if (credit > 0) {
      if (credit <= 100) {
        color = 'mid';
      }
    } else {
      color = 'zero';
    }
    return color;
  };

  this.handleOnDropdownChange = function (e, data) {
    e.preventDefault();
    var name = data.name,
        value = data.value;

    var query = _this6.getQuery();

    query[name] = value;
    if (value === 'All') {
      query[name] = '';
    }

    _this6.replaceQuery(query, true);
  };
};

exports.default = (0, _reactRedux.connect)(Manage.mapStateToProps)(Manage);

/***/ }),
/* 2305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRedux = __webpack_require__(9);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _ManageSettingsModal = __webpack_require__(2306);

var _ManageSettingsModal2 = _interopRequireDefault(_ManageSettingsModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManageSettings = function (_Component) {
  _inherits(ManageSettings, _Component);

  function ManageSettings(props) {
    _classCallCheck(this, ManageSettings);

    var _this = _possibleConstructorReturn(this, (ManageSettings.__proto__ || Object.getPrototypeOf(ManageSettings)).call(this, props));

    _initialiseProps.call(_this);

    var state = ManageSettings.getPropsToState(props);
    _this.state = _extends({}, state, {
      companyAppCredit: [],
      companyApp: [],
      errMessages: [],
      hasChanges: false,
      hasHQApprovalChanges: false,
      loading: false,
      openModal: false,
      token: ''
    });
    return _this;
  }

  _createClass(ManageSettings, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchCompanyApp();
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, res);
      });
    }
  }, {
    key: 'fetchCompanyApp',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, _message, companyApp, token;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                _context.next = 3;
                return this.setLoading(true);

              case 3:
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/company/company_app/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 22;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);
                _context.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 17;
                return _context.t0.res.text();

              case 17:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 20:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 22:
                if (res.ok) {
                  _context.next = 30;
                  break;
                }

                _context.next = 25;
                return res.text();

              case 25:
                _message = _context.sent;
                _context.next = 28;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 28:
                _context.next = 35;
                break;

              case 30:
                _context.next = 32;
                return res.json();

              case 32:
                companyApp = _context.sent;
                token = res.headers.get('X-Csrf-Token');

                if (companyApp !== null) {
                  this.setComponentState({ companyApp: companyApp, token: token });
                }

              case 35:
                _context.next = 37;
                return this.setLoading(false);

              case 37:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchCompanyApp() {
        return _ref.apply(this, arguments);
      }

      return fetchCompanyApp;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          companyApp = _state.companyApp,
          hasChanges = _state.hasChanges,
          hasHQApprovalChanges = _state.hasHQApprovalChanges,
          loading = _state.loading;

      return _react2.default.createElement(
        'div',
        null,
        companyApp ? _react2.default.createElement(
          _AppForm2.default,
          {
            onSubmit: hasHQApprovalChanges ? this.handleShowModal : this.handleSave,
            error: this.state.errMessages.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Container,
            null,
            _react2.default.createElement(_NavBar2.default, {
              header: 'Credit Check Settings',
              rightNav: _react2.default.createElement(
                _semanticUiReact.Menu.Item,
                { fitted: true },
                _react2.default.createElement(_semanticUiReact.Button, {
                  primary: true,
                  content: 'Save',
                  disabled: loading || !hasChanges,
                  onClick: hasHQApprovalChanges ? this.handleShowModal : this.handleSave
                })
              )
            }),
            _react2.default.createElement(
              _semanticUiReact.Divider,
              {
                horizontal: true
              },
              'Credit Check Settings'
            ),
            _react2.default.createElement(
              _semanticUiReact.Segment,
              null,
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: 'All Credit Check by internal staff must be approved by HQ before score generated',
                name: 'requiredHQApproval',
                checked: companyApp.requiredHQApproval ? companyApp.requiredHQApproval : false,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: 'All BU leaders (Supervisor, Sales Manager, and Sales Admin) to download Credit Check detailed report',
                name: 'allowBranchLeaderDownload',
                checked: companyApp.allowBranchLeaderDownload ? companyApp.allowBranchLeaderDownload : false,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: 'All Agents to download Credit Check detailed report',
                name: 'allowAgentDownload',
                checked: companyApp.allowAgentDownload ? companyApp.allowAgentDownload : false,
                onChange: this.handleCheckBoxChange
              }),
              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                label: 'All Staff to download Credit Check detailed report',
                name: 'allowStaffDownload',
                checked: companyApp.allowStaffDownload ? companyApp.allowStaffDownload : false,
                onChange: this.handleCheckBoxChange
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_ManageSettingsModal2.default, {
                    open: this.state.openModal,
                    onSave: this.handleSave
                  })
                )
              )
            )
          )
        ) : null
      );
    }
  }]);

  return ManageSettings;
}(_react.Component);

ManageSettings.contextTypes = {
  store: _propTypes2.default.object
};

ManageSettings.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig,
    auth: state.auth
  };
};

ManageSettings.propTypes = {
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    companyBranch: _propTypes2.default.shape({
      shortName: _propTypes2.default.string
    }),
    isDeveloper: _propTypes2.default.bool
  })
};

ManageSettings.getPropsToState = function (props) {
  var loading = false;
  return {
    loading: loading
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleCheckBoxChange = function (event, data) {
    var name = data.name;
    var companyApp = _this4.state.companyApp;
    var hasHQApprovalChanges = _this4.state.hasHQApprovalChanges;

    companyApp[name] = !companyApp[name];
    if (name === 'requiredHQApproval') {
      hasHQApprovalChanges = true;
    }
    _this4.setState({ companyApp: companyApp, hasChanges: true, hasHQApprovalChanges: hasHQApprovalChanges });
  };

  this.handleSave = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var store, message;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            store = _this4.context.store;
            _context2.prev = 1;
            _context2.next = 4;
            return store.dispatch((0, _fetchM.fetchM)('/company/company_app/', {
              credentials: 'include',
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                'X-Csrf-Token': _this4.state.token
              },
              body: JSON.stringify(_this4.state.companyApp)
            }));

          case 4:
            _context2.next = 18;
            break;

          case 6:
            _context2.prev = 6;
            _context2.t0 = _context2['catch'](1);
            _context2.next = 10;
            return _this4.setLoading(false);

          case 10:
            if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
              _context2.next = 16;
              break;
            }

            _context2.next = 13;
            return _context2.t0.res.text();

          case 13:
            message = _context2.sent;

            store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
            return _context2.abrupt('return');

          case 16:
            store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));
            return _context2.abrupt('return');

          case 18:
            _context2.next = 20;
            return _this4.setLoading(false);

          case 20:
            _this4.setState({ openModal: false, hasHQApprovalChanges: false });
            store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Update success', message: 'Credit Check Settings is updated' }));

          case 22:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this4, [[1, 6]]);
  }));

  this.handleShowModal = function () {
    _this4.setState({ openModal: true });
  };
};

exports.default = (0, _reactRedux.connect)(ManageSettings.mapStateToProps)(ManageSettings);

/***/ }),
/* 2306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ManageSettingsModal = function (_Component) {
  _inherits(ManageSettingsModal, _Component);

  function ManageSettingsModal(props) {
    _classCallCheck(this, ManageSettingsModal);

    var _this = _possibleConstructorReturn(this, (ManageSettingsModal.__proto__ || Object.getPrototypeOf(ManageSettingsModal)).call(this, props));

    _initialiseProps.call(_this);

    var state = ManageSettingsModal.getPropsToState(props);
    _this.state = _extends({}, state);
    return _this;
  }

  _createClass(ManageSettingsModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = ManageSettingsModal.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'close',
    value: function close(callback) {
      this.setState({
        open: false
      }, function () {
        if (callback) {
          callback();
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          basic: true,
          open: this.state.open,
          onClose: this.handleOnClose,
          closeIcon: 'close',
          size: 'small'
        },
        _react2.default.createElement(
          _semanticUiReact.Header,
          null,
          _react2.default.createElement('img', { alt: 'e-signing', src: '/assets/images/icons/credit_check.svg' }),
          ' Credit Check Settings'
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'Take note that all your pending UNAPPROVED credit check will NOT be automatically approved'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              basic: true,
              color: 'red',
              inverted: true,
              onClick: this.handleOnClose
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove' }),
            ' Cancel'
          ),
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              color: 'green',
              inverted: true,
              onClick: this.handleSave
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' }),
            ' Save'
          )
        )
      );
    }
  }]);

  return ManageSettingsModal;
}(_react.Component);

ManageSettingsModal.propTypes = {
  open: _propTypes2.default.bool,
  onSave: _propTypes2.default.func
};

ManageSettingsModal.getPropsToState = function (props) {
  var open = props.open;
  return {
    open: open
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleOnClose = function () {
    _this2.close();
  };

  this.handleSave = function () {
    _this2.props.onSave();
  };
};

exports.default = ManageSettingsModal;

/***/ }),
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

var _semanticUiReact = __webpack_require__(2);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _reactRouterRedux = __webpack_require__(13);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _Identity = __webpack_require__(315);

var _Identity2 = _interopRequireDefault(_Identity);

var _FormGroup = __webpack_require__(2148);

var _FormGroup2 = _interopRequireDefault(_FormGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultipleEntity = function (_Component) {
  _inherits(MultipleEntity, _Component);

  function MultipleEntity(props) {
    _classCallCheck(this, MultipleEntity);

    var _this = _possibleConstructorReturn(this, (MultipleEntity.__proto__ || Object.getPrototypeOf(MultipleEntity)).call(this, props));

    _initialiseProps.call(_this);

    var state = MultipleEntity.getPropsToState(props);
    _this.state = _extends({}, state, {
      token: null,
      data: [],
      selectedEntity: null
    });
    return _this;
  }

  _createClass(MultipleEntity, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var store = this.context.store;

      this.setLoading(true).then(function () {
        var promises = [_this2.fetchCreditReport()];
        return Promise.all(promises).catch(function (err) {
          Bugsnag.notifyException(err);
          store.dispatch((0, _flash.flashErrorMessage)(err));
        });
      }).then(function () {
        return _this2.setLoading(false);
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = MultipleEntity.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this3.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchCreditReport',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                res = void 0;
                _context.prev = 2;
                _context.next = 5;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/customers/' + this.props.params.id + '/credit_reports/' + this.props.params.creditCheckID + '/multiple_entities/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                res = _context.sent;
                _context.next = 14;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](2);

                Bugsnag.notifyException(_context.t0);
                _context.next = 13;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 13:
                return _context.abrupt('return');

              case 14:
                if (res.ok) {
                  _context.next = 22;
                  break;
                }

                _context.next = 17;
                return res.text();

              case 17:
                message = _context.sent;
                _context.next = 20;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 20:
                _context.next = 28;
                break;

              case 22:
                token = res.headers.get('X-Csrf-Token');
                _context.next = 25;
                return res.json();

              case 25:
                data = _context.sent;
                _context.next = 28;
                return this.setComponentState({
                  token: token,
                  data: data,
                  oriData: (0, _clone2.default)(data)
                });

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));

      function fetchCreditReport() {
        return _ref.apply(this, arguments);
      }

      return fetchCreditReport;
    }()
  }, {
    key: 'submitable',
    value: function submitable() {
      return this.state.selectedEntity;
    }
  }, {
    key: 'handleOnClick',
    value: function handleOnClick(event, value) {
      event.preventDefault();
      var selectedEntity = value;
      this.setState({
        selectedEntity: selectedEntity
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state = this.state,
          loading = _state.loading,
          customer = _state.customer,
          data = _state.data,
          selectedEntity = _state.selectedEntity;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: data !== undefined && data.length > 0 ? _react2.default.createElement(
            'span',
            null,
            'Multiple records \xA0',
            _react2.default.createElement(
              _semanticUiReact.Label,
              { color: 'blue' },
              data.length
            )
          ) : 'Multiple records'
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { className: 'manage credit-check' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                {
                  active: loading && data && data.length > 0,
                  inverted: true
                },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  'Loading'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { className: 'dark credit-check', style: { background: '#383f44', padding: 0 }, inverted: true, secondary: true, textAlign: 'center' },
                customer.customerCreditReport.multiEntityKey !== '' ? _react2.default.createElement(
                  'p',
                  null,
                  customer.customerCreditReport.name + '\'s report is selected.'
                ) : _react2.default.createElement(
                  'form',
                  { className: 'DSRMultipleRecords', onSubmit: this.handleSubmit },
                  _react2.default.createElement(
                    'div',
                    { className: 'status-content' },
                    _react2.default.createElement(
                      'div',
                      { className: 'title' },
                      _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'h1',
                          null,
                          'Multiple records'
                        )
                      ),
                      _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          { className: 'date' },
                          'Submitted: ',
                          _react2.default.createElement(_Timestamp2.default, { timestamp: customer.customerCreditReport.createdAt })
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'content' },
                    _react2.default.createElement(
                      'h5',
                      null,
                      'Oops ...'
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Bank Negara / CTOS has ',
                      data !== undefined && data.length > 0 ? data.length : '...',
                      ' ',
                      _react2.default.createElement(
                        'span',
                        { style: { whiteSpace: 'nowrap' } },
                        'records for'
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      customer.customerDetail.name
                    ),
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Please select one to proceed.'
                    ),
                    _react2.default.createElement(
                      'table',
                      null,
                      _react2.default.createElement(
                        'thead',
                        null,
                        _react2.default.createElement(
                          'tr',
                          null,
                          _react2.default.createElement('th', null),
                          _react2.default.createElement(
                            'th',
                            null,
                            'Name'
                          ),
                          _react2.default.createElement(
                            'th',
                            null,
                            'Ic'
                          ),
                          _react2.default.createElement(
                            'th',
                            null,
                            'Nationality'
                          ),
                          _react2.default.createElement(
                            'th',
                            null,
                            'Dob'
                          )
                        )
                      ),
                      _react2.default.createElement(
                        'tbody',
                        null,
                        !loading && data && data.map(function (details, idx) {
                          return _react2.default.createElement(
                            'tr',
                            {
                              onClick: function onClick(e) {
                                return _this5.handleOnClick(e, details.entityKey);
                              },
                              className: selectedEntity === details.entityKey ? 'selected' : null,
                              key: idx
                            },
                            _react2.default.createElement(
                              'td',
                              null,
                              _react2.default.createElement(
                                'div',
                                { className: 'tag' },
                                _react2.default.createElement(
                                  _FormGroup2.default,
                                  null,
                                  _react2.default.createElement('input', {
                                    id: 'select-' + details.entityKey,
                                    type: 'radio',
                                    value: details.entityKey,
                                    name: 'selectedEntity',
                                    checked: selectedEntity === details.entityKey,
                                    onChange: _this5.handleOnChange
                                  }),
                                  _react2.default.createElement(
                                    'label',
                                    {
                                      htmlFor: 'select-' + details.entityKey
                                    },
                                    '\xA0'
                                  )
                                ),
                                _react2.default.createElement(
                                  'span',
                                  null,
                                  idx + 1
                                )
                              )
                            ),
                            _react2.default.createElement(
                              'td',
                              null,
                              details.idNo1 && _react2.default.createElement(
                                'div',
                                {
                                  style: {
                                    whiteSpace: 'nowrap',
                                    marginBottom: '0.5em'
                                  }
                                },
                                'NEW:',
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(_Identity2.default, { type: 1, identity: details.idNo1 })
                              ),
                              details.idNo2 && _react2.default.createElement(
                                'div',
                                {
                                  style: {
                                    whiteSpace: 'nowrap'
                                  }
                                },
                                'OLD:',
                                _react2.default.createElement('br', null),
                                details.idNo2
                              )
                            ),
                            _react2.default.createElement(
                              'td',
                              null,
                              details.name
                            ),
                            _react2.default.createElement(
                              'td',
                              null,
                              details.nationality
                            ),
                            _react2.default.createElement(
                              'td',
                              null,
                              details.birthDate
                            )
                          );
                        })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'mobile-center' },
                    _react2.default.createElement(
                      _semanticUiReact.Button,
                      {
                        loading: loading,
                        disabled: !this.submitable()
                      },
                      'Confirm Selection'
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return MultipleEntity;
}(_react.Component);

MultipleEntity.contextTypes = {
  store: _propTypes2.default.object
};
MultipleEntity.propTypes = {
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    creditCheckID: _propTypes2.default.string
  })
};
MultipleEntity.defaultCustomerData = {
  id: '',
  customerDetailID: '',
  identityTypeID: '',
  identity: '',
  icFrontDocumentID: '',
  icFrontDocument: null,
  icBackDocumentID: '',
  icBackDocument: null,
  incomeID: '',
  customerCreditReport: null,
  customerCreditReports: [],
  runCreditCheck: false
};
MultipleEntity.defaultCustomerCreditReport = {
  id: '',
  multiEntityKey: '',
  createdAt: '',
  updatedAt: ''
};

MultipleEntity.getPropsToState = function (props) {
  var loading = props.loading;
  var customer = Object.assign({}, MultipleEntity.defaultCustomerData, props.data || {});
  if (!customer.customerDetailID) {
    customer.customerDetail = Object.assign({}, MultipleEntity.defaultCustomerDetailData);
  }
  if (!customer.customerCreditReportID) {
    customer.customerCreditReport = Object.assign({}, MultipleEntity.defaultCustomerCreditReport);
  }
  return {
    customer: customer,
    oriData: (0, _clone2.default)(customer),
    loading: loading
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.handleOnChange = function (event) {
    _this6.setState(_defineProperty({}, event.target.name, event.target.value));
  };

  this.handleSubmit = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(event) {
      var store, _state2, customer, selectedEntity, token, creditReport, res, jwtToken, message, d;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              event.preventDefault();
              _context2.next = 3;
              return _this6.setLoading(true);

            case 3:
              store = _this6.context.store;
              _state2 = _this6.state, customer = _state2.customer, selectedEntity = _state2.selectedEntity, token = _state2.token;
              creditReport = customer.customerCreditReport;

              creditReport.multiEntityKey = selectedEntity;

              res = void 0;
              _context2.prev = 8;
              _context2.next = 11;
              return _auth2.default.currentSession();

            case 11:
              jwtToken = _context2.sent.getAccessToken().getJwtToken();
              _context2.next = 14;
              return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/customers/' + _this6.props.params.id + '/credit_reports/' + _this6.props.params.creditCheckID + '/multiple_entities/confirm_entity/', {
                credentials: 'include',
                method: 'PUT',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Csrf-Token': token,
                  'X-JWT-Token': jwtToken
                },
                body: JSON.stringify(creditReport)
              }));

            case 14:
              res = _context2.sent;
              _context2.next = 30;
              break;

            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2['catch'](8);
              _context2.next = 21;
              return _this6.setLoading(false);

            case 21:
              Bugsnag.notifyException(_context2.t0);

              if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                _context2.next = 28;
                break;
              }

              _context2.next = 25;
              return _context2.t0.res.text();

            case 25:
              message = _context2.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
              return _context2.abrupt('return');

            case 28:
              store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));
              return _context2.abrupt('return');

            case 30:
              _context2.next = 32;
              return res.json();

            case 32:
              d = _context2.sent;

              customer.customerCreditReport = d;
              _context2.next = 36;
              return _this6.setComponentState({
                customer: customer
              });

            case 36:
              _context2.next = 38;
              return _this6.setLoading(false);

            case 38:
              store.dispatch((0, _reactRouterRedux.push)('/customers/manage/credit_checks/'));
              store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Entity selected', message: customer.customerCreditReport.name + '\'s report is pending.' }));

            case 40:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this6, [[8, 17]]);
    }));

    return function (_x3) {
      return _ref2.apply(this, arguments);
    };
  }();
};

exports.default = MultipleEntity;

/***/ }),
/* 2308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _UploadForm = __webpack_require__(394);

var _UploadForm2 = _interopRequireDefault(_UploadForm);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewIncomeForm = function (_Component) {
  _inherits(NewIncomeForm, _Component);

  function NewIncomeForm(props) {
    _classCallCheck(this, NewIncomeForm);

    var _this = _possibleConstructorReturn(this, (NewIncomeForm.__proto__ || Object.getPrototypeOf(NewIncomeForm)).call(this, props));

    _initialiseProps.call(_this);

    var state = NewIncomeForm.getPropsToState(props);
    _this.state = _extends({}, state, {
      documentChanges: false,
      errMessages: []
    });
    _this.validation = {
      basicIncome: (0, _react.createRef)(),
      fixAllowance: (0, _react.createRef)(),
      deduction: (0, _react.createRef)(),
      bYearlyIncome: (0, _react.createRef)(),
      otherYearlyIncome: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(NewIncomeForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchCustomerIncome();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = NewIncomeForm.getPropsToState(nextProps);
      if (JSON.stringify(state.oriIncome) === JSON.stringify(this.state.oriIncome)) {
        state.income = this.state.income;
      }
      this.setState(state);
    }
  }, {
    key: 'getDocumentToken',
    value: function getDocumentToken(callback) {
      var _this2 = this;

      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.customerID + '/documents/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      }).then(function (res) {
        var documentToken = res.headers.get('X-Csrf-Token');
        _this2.setState({
          documentToken: documentToken
        }, function () {
          if (callback) {
            callback();
          }
        });
      });
    }
  }, {
    key: 'fetchCustomerIncome',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, json, newIncome;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                res = '';
                _context.prev = 2;
                _context.next = 5;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.customerID + '/income/' + this.props.data.income.id + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                res = _context.sent;
                _context.next = 19;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](2);

                if (!(_context.t0.res && _context.t0.res.status >= 399 && _context.t0.res.status < 500)) {
                  _context.next = 15;
                  break;
                }

                _context.next = 13;
                return _context.t0.res.text();

              case 13:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 15:
                // await this.setLoading(false);
                Bugsnag.notifyException(_context.t0);
                _context.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 18:
                return _context.abrupt('return');

              case 19:
                _context.next = 21;
                return res.json();

              case 21:
                json = _context.sent;

                if (json) {
                  newIncome = Object.assign({}, json || {});

                  this.setState({ income: newIncome });
                }

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));

      function fetchCustomerIncome() {
        return _ref.apply(this, arguments);
      }

      return fetchCustomerIncome;
    }()
  }, {
    key: 'uploadDocument',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(body) {
        var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'employed';

        var _this3 = this;

        var validations = arguments[2];
        var income = arguments[3];
        var store, documentChanges, res, message, json, newIncome;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                documentChanges = this.state.documentChanges;
                res = '';
                _context2.prev = 3;
                _context2.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.customerID + '/income/documents/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    // Let browser decide Content-Type
                    // 'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.documentToken
                  },
                  body: body
                }));

              case 6:
                res = _context2.sent;
                _context2.next = 20;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](3);

                Bugsnag.notifyException(_context2.t0);

                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 18;
                  break;
                }

                _context2.next = 15;
                return _context2.t0.res.text();

              case 15:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 18:
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context2.abrupt('return');

              case 20:
                _context2.next = 22;
                return res.json();

              case 22:
                json = _context2.sent;

                if (json) {
                  newIncome = Object.assign({}, income || {});

                  newIncome.id = json.id;
                  if (json.epfStatementDocumentID !== '') {
                    newIncome.epfStatementDocumentID = json.epfStatementDocumentID;
                    newIncome.epfStatementDocument = json.epfStatementDocument;
                  }
                  if (json.bankStatementDocumentID !== '') {
                    newIncome.bankStatementDocumentID = json.bankStatementDocumentID;
                    newIncome.bankStatementDocument = json.bankStatementDocument;
                  }
                  if (json.payslipDocumentID !== '') {
                    newIncome.payslipDocumentID = json.payslipDocumentID;
                    newIncome.payslipDocument = json.payslipDocument;
                  }
                  if (json.bFormDocumentID !== '') {
                    newIncome.bFormDocumentID = json.bFormDocumentID;
                    newIncome.bFormDocument = json.bFormDocument;
                  }
                  this.setState({ income: newIncome }, function () {
                    _this3.props.onSubmit(validations, newIncome, documentChanges);
                  });
                }

                if (!(key === 'employed')) {
                  _context2.next = 27;
                  break;
                }

                _context2.next = 27;
                return this.employedFormUpload.resetFiles();

              case 27:
                if (!(key === 'selfEmployed')) {
                  _context2.next = 30;
                  break;
                }

                _context2.next = 30;
                return this.bFormUpload.resetFiles();

              case 30:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 9]]);
      }));

      function uploadDocument(_x) {
        return _ref2.apply(this, arguments);
      }

      return uploadDocument;
    }()
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        var income = this.state.income;

        this.props.onChange(income);
      }
    }
  }, {
    key: 'handleCheckNetIncome',
    value: function handleCheckNetIncome() {
      var _this4 = this;

      var income = this.state.income;

      if (income.isEmployed) {
        var grossIncome = _lodash2.default.toNumber(_lodash2.default.toNumber(income.basicIncome) + _lodash2.default.toNumber(income.fixAllowance)).toFixed(2);
        income.grossIncome = _lodash2.default.toNumber(grossIncome);
        var netIncome = _lodash2.default.toNumber(_lodash2.default.toNumber(income.grossIncome) - _lodash2.default.toNumber(income.deduction)).toFixed(2);
        income.netIncome = _lodash2.default.toNumber(netIncome);
      }
      if (!income.isEmployed) {
        var totalYearlyIncome = _lodash2.default.toNumber(income.bYearlyIncome) + _lodash2.default.toNumber(income.otherYearlyIncome);
        var totalMonthlyIncome = _lodash2.default.toNumber(totalYearlyIncome) / 12;
        var roughIncome = _lodash2.default.toNumber(totalMonthlyIncome).toFixed(2);
        income.netIncome = _lodash2.default.toNumber(roughIncome);
      }
      this.setState({ income: income }, function () {
        _this4.handleCheckChanges();
      });
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var data = this.props.data;
      var income = this.state.income;

      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref7) {
            _this5.form = _ref7;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 1, textAlign: 'center', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { computer: 8, tablet: 10, mobile: 16 },
              _react2.default.createElement(
                'div',
                { className: 'menuTab' },
                _react2.default.createElement(
                  _semanticUiReact.Menu,
                  { fluid: true, widths: 2 },
                  this.tabs.map(function (tab, idx) {
                    return _react2.default.createElement(
                      _semanticUiReact.Menu.Item,
                      {
                        key: idx,
                        name: tab.name,
                        onClick: function onClick() {
                          return _this5.handleChangeTab(tab.isEmployed);
                        },
                        active: income.isEmployed === tab.isEmployed
                      },
                      tab.text
                    );
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { centered: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            income.isEmployed ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { computer: 7, tablet: 9, mobile: 16, textAlign: 'right' },
              _react2.default.createElement(_AppForm2.default.Input, {
                label: _react2.default.createElement(_semanticUiReact.Header, {
                  as: 'h5',
                  style: { marginBottom: '0.5em' },
                  textAlign: 'left',
                  content: 'Basic Monthly Income',
                  subheader: 'Monthly Basic Salary, Monthly Recurring Commission before any deduction'
                }),
                validateLabel: 'Basic Monthly Income',
                type: 'number',
                step: '0.01',
                name: 'basicIncome',
                value: income.basicIncome,
                onChange: this.handleInputChange,
                validation: income.isEmployed ? [{
                  validate: _webValidations.numericRange,
                  option: {
                    min: 1,
                    message: 'Basic Monthly Income is required'
                  }
                }] : null,
                ref: this.validation.basicIncome
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                label: _react2.default.createElement(_semanticUiReact.Header, {
                  as: 'h5',
                  style: { marginBottom: '0.5em' },
                  textAlign: 'left',
                  content: 'Fix Monthly Allowance',
                  subheader: 'Recurring fixed travel allowance, meal allowance, yearly contractual bonus/12months'
                }),
                validateLabel: 'Fix Monthly Allowance',
                type: 'number',
                step: '0.01',
                name: 'fixAllowance',
                value: income.fixAllowance,
                onChange: this.handleInputChange,
                ref: this.validation.fixAllowance
              }),
              _react2.default.createElement(_semanticUiReact.Header, {
                as: 'h5',
                style: { marginBottom: '0.5em' },
                textAlign: 'left',
                content: 'Gross Monthly Income'
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                type: 'number',
                step: '0.01',
                name: 'grossIncome',
                value: income.grossIncome,
                disabled: true,
                readOnly: true
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                label: _react2.default.createElement(_semanticUiReact.Header, {
                  as: 'h5',
                  style: { marginBottom: '0.5em' },
                  textAlign: 'left',
                  content: 'Monthly Income deduction',
                  subheader: 'EPF, SOSCO, PCB, CP38'
                }),
                validateLabel: 'Monthly Income deduction',
                type: 'number',
                step: '0.01',
                name: 'deduction',
                value: income.deduction,
                onChange: this.handleInputChange,
                ref: this.validation.deduction
              }),
              _react2.default.createElement(_semanticUiReact.Header, {
                as: 'h5',
                style: { marginBottom: '0.5em' },
                textAlign: 'left',
                content: 'Net Monthly Income'
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                type: 'number',
                step: '0.01',
                name: 'netIncome',
                value: income.netIncome,
                validation: income.isEmployed ? [{
                  validate: _webValidations.numericRange,
                  option: {
                    min: 1,
                    message: 'Net Monthly Income is required'
                  }
                }] : null,
                disabled: true,
                readOnly: true
              }),
              _react2.default.createElement(_semanticUiReact.Header, {
                as: 'h3',
                content: 'Upload Documents',
                textAlign: 'left',
                style: { marginTop: '2em', marginBottom: '0.5em' }
              }),
              _react2.default.createElement(_UploadForm2.default, {
                title: 'FinancialForm',
                labelContent: 'Latest EPF Statement',
                ref: function ref(_ref3) {
                  _this5.employedFormUpload = _ref3;
                },
                loading: this.props.loading,
                tags: ['Financial EPF'],
                picture: data.epfStatementDocumentID && data.epfStatementDocumentID.length > 0 ? data.epfStatementDocument : null,
                onChange: function onChange(form) {
                  return _this5.handleGetForm(form, 'epfStatementDocument');
                }
              }),
              _react2.default.createElement(_UploadForm2.default, {
                title: 'FinancialForm',
                labelContent: 'Latest 3 months payslip',
                ref: function ref(_ref4) {
                  _this5.employedFormUpload = _ref4;
                },
                loading: this.props.loading,
                tags: ['Financial Payslip'],
                picture: data.payslipDocumentID && data.payslipDocumentID.length > 0 ? data.payslipDocument : null,
                onChange: function onChange(form) {
                  return _this5.handleGetForm(form, 'payslipDocument');
                },
                style: { height: '4rem !important' }
              }),
              _react2.default.createElement(_UploadForm2.default, {
                title: 'FinancialForm',
                labelContent: 'Latest 3 months bank statement',
                ref: function ref(_ref5) {
                  _this5.employedFormUpload = _ref5;
                },
                loading: this.props.loading,
                tags: ['Financial BankStatement'],
                picture: data.bankStatementDocumentID && data.bankStatementDocumentID.length > 0 ? data.bankStatementDocument : null,
                onChange: function onChange(form) {
                  return _this5.handleGetForm(form, 'bankStatementDocument');
                }
              })
            ) : null,
            !income.isEmployed ? _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { computer: 7, tablet: 9, mobile: 16, textAlign: 'right' },
              _react2.default.createElement(_AppForm2.default.Input, {
                label: _react2.default.createElement(_semanticUiReact.Header, {
                  as: 'h5',
                  style: { marginBottom: '0.5em' },
                  textAlign: 'left',
                  content: 'Latest B Form Yearly Income'
                }),
                validateLabel: 'Latest B Form Yearly Income',
                type: 'number',
                step: '0.01',
                name: 'bYearlyIncome',
                value: income.bYearlyIncome,
                onChange: this.handleInputChange,
                validation: !income.isEmployed ? [{
                  validate: _webValidations.numericRange,
                  option: {
                    min: 1,
                    message: 'B Form Yearly Income is required'
                  }
                }] : null,
                ref: this.validation.bYearlyIncome
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                label: _react2.default.createElement(_semanticUiReact.Header, {
                  as: 'h5',
                  style: { marginBottom: '0.5em' },
                  textAlign: 'left',
                  content: 'Other Yearly Income'
                }),
                validateLabel: 'Other Yearly Income',
                type: 'number',
                step: '0.01',
                name: 'otherYearlyIncome',
                value: income.otherYearlyIncome,
                onChange: this.handleInputChange,
                ref: this.validation.otherYearlyIncome
              }),
              _react2.default.createElement(_semanticUiReact.Header, {
                as: 'h5',
                style: { marginBottom: '0.5em' },
                textAlign: 'left',
                content: 'Total'
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                type: 'number',
                step: '0.01',
                name: 'netIncome',
                value: income.netIncome,
                validation: !income.isEmployed ? [{
                  validate: _webValidations.numericRange,
                  option: {
                    min: 1,
                    message: 'Total is required'
                  }
                }] : null,
                disabled: true,
                readOnly: true
              }),
              _react2.default.createElement(_semanticUiReact.Header, {
                as: 'h3',
                content: 'Upload Documents',
                textAlign: 'left',
                style: { marginTop: '2em', marginBottom: '0.5em' }
              }),
              _react2.default.createElement(_UploadForm2.default, {
                title: 'FinancialForm',
                labelContent: 'B Form',
                ref: function ref(_ref6) {
                  _this5.bFormUpload = _ref6;
                },
                loading: this.props.loading,
                tags: ['Financial BForm'],
                picture: data.bFormDocumentID && data.bFormDocumentID.length > 0 ? data.bFormDocument : null,
                onChange: function onChange(form) {
                  return _this5.handleGetForm(form, 'bFormDocument');
                }
              })
            ) : null
          )
        )
      );
    }
  }]);

  return NewIncomeForm;
}(_react.Component);

NewIncomeForm.propTypes = {
  customerID: _propTypes2.default.string,
  data: _propTypes2.default.shape({
    epfStatementDocumentID: _propTypes2.default.string,
    epfStatementDocument: _propTypes2.default.shape({
      key: _propTypes2.default.string,
      tags: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }),
    payslipDocumentID: _propTypes2.default.string,
    payslipDocument: _propTypes2.default.shape({
      key: _propTypes2.default.string,
      tags: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }),
    bankStatementDocumentID: _propTypes2.default.string,
    bankStatementDocument: _propTypes2.default.shape({
      key: _propTypes2.default.string,
      tags: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }),
    bFormDocumentID: _propTypes2.default.string,
    bFormDocument: _propTypes2.default.shape({
      key: _propTypes2.default.string,
      tags: _propTypes2.default.arrayOf(_propTypes2.default.string)
    })
  }),
  income: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    isEmployed: _propTypes2.default.bool,
    basicIncome: _propTypes2.default.number,
    fixAllowance: _propTypes2.default.number,
    grossIncome: _propTypes2.default.number,
    deduction: _propTypes2.default.number,
    netIncome: _propTypes2.default.number,
    bYearlyIncome: _propTypes2.default.number,
    otherYearlyIncome: _propTypes2.default.number,
    currentLoanAmount: _propTypes2.default.number
  }),
  onChange: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func.isRequired,
  loading: _propTypes2.default.bool
};
NewIncomeForm.contextTypes = {
  store: _propTypes2.default.object
};
NewIncomeForm.defaultValues = {
  bankStatementDocumentID: '',
  bankStatementDocument: null,
  basicIncome: 0,
  bFormDocumentID: '',
  bFormDocument: null,
  bYearlyIncome: 0,
  currentLoanAmount: 0,
  epfStatementDocumentID: '',
  epfStatementDocument: null,
  deduction: 0,
  fixAllowance: 0,
  grossIncome: 0,
  id: '',
  isEmployed: true,
  netIncome: 0,
  otherYearlyIncome: 0,
  payslipDocumentID: '',
  payslipDocument: null
};

NewIncomeForm.getPropsToState = function (props) {
  var income = Object.assign({}, NewIncomeForm.defaultValues, props.income || {});
  return {
    income: income,
    oriIncome: Object.assign({}, income)
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.handleChangeTab = function () {
    var isEmployed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var income = _this6.state.income;

    income.isEmployed = isEmployed;
    _this6.setState({ income: income }, _this6.handleCheckNetIncome);
  };

  this.handleCreateFormData = function (type) {
    var income = _this6.state.income;

    var formData = null;
    if (type === 'employed') {
      if (income.epfStatementDocument || income.payslipDocument || income.bankStatementDocument) {
        formData = _this6.employedFormUpload.getFormData();

        if (income.epfStatementDocument) {
          formData.append('files_0', income.epfStatementDocument.file);
          formData.append('tags_0', income.epfStatementDocument.tags);
          formData.append('names_0', income.epfStatementDocument.name);
          formData.append('degrees_0', income.epfStatementDocument.degree);
        }
        if (income.payslipDocument) {
          formData.append('files_1', income.payslipDocument.file);
          formData.append('tags_1', income.payslipDocument.tags);
          formData.append('names_1', income.payslipDocument.name);
          formData.append('degrees_1', income.payslipDocument.degree);
        }
        if (income.bankStatementDocument) {
          formData.append('files_2', income.bankStatementDocument.file);
          formData.append('tags_2', income.bankStatementDocument.tags);
          formData.append('names_2', income.bankStatementDocument.name);
          formData.append('degrees_2', income.bankStatementDocument.degree);
        }
      }
    } else if (type === 'selfEmployed') {
      if (income.bFormDocument) {
        formData = _this6.bFormUpload.getFormData();
        formData.append('files_0', income.bFormDocument.file);
        formData.append('tags_0', income.bFormDocument.tags);
        formData.append('names_0', income.bFormDocument.name);
        formData.append('degrees_0', income.bFormDocument.degree);
      }
    }
    return formData;
  };

  this.handleGetForm = function (form) {
    var formName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'epfStatementDocument';
    var income = _this6.state.income;

    income[formName] = form;
    _this6.setState({ income: income, documentChanges: true }, function () {
      _this6.handleCheckChanges();
    });
  };

  this.handleInputChange = function (event, data) {
    var income = _this6.state.income;

    income[data.name] = _lodash2.default.toNumber(data.value);
    _this6.handleCheckNetIncome();
  };

  this.handleSubmit = function () {
    var _state = _this6.state,
        income = _state.income,
        documentChanges = _state.documentChanges;

    if (income.isEmployed) {
      income.bYearlyIncome = 0;
      income.otherYearlyIncome = 0;
      income.bFormDocumentID = '';
      income.bFormDocument = null;
    }
    if (!income.isEmployed) {
      income.basicIncome = 0;
      income.fixAllowance = 0;
      income.grossIncome = 0;
      income.deduction = 0;
      income.epfStatementDocumentID = '';
      income.epfStatementDocument = null;
      income.payslipDocumentID = '';
      income.payslipDocument = null;
      income.bankStatementDocumentID = '';
      income.bankStatementDocument = null;
    }
    _AppForm2.default.validate(_this6.validation, income).then(function (validations) {
      _this6.setState({
        errMessages: validations.filter(function (v) {
          return !v.isValid;
        })
      });
      if (documentChanges) {
        _this6.submitAllIncome(validations, income);
      } else {
        _this6.props.onSubmit(validations, income, documentChanges);
      }
    });
  };

  this.submitAllIncome = function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(validations, income) {
      var store;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              store = _this6.context.store;
              _context3.prev = 1;
              _context3.next = 4;
              return _this6.getDocumentToken(function () {
                if (income.isEmployed) {
                  var employedForm = _this6.handleCreateFormData('employed');
                  _this6.uploadDocument(employedForm, 'employedForm', validations, income);
                } else {
                  var selfEmployedForm = _this6.handleCreateFormData('selfEmployed');
                  _this6.uploadDocument(selfEmployedForm, 'selfEmployed', validations, income);
                }
              });

            case 4:
              _context3.next = 9;
              break;

            case 6:
              _context3.prev = 6;
              _context3.t0 = _context3['catch'](1);

              store.dispatch((0, _flash.flashErrorMessage)(_context3.t0));

            case 9:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this6, [[1, 6]]);
    }));

    return function (_x5, _x6) {
      return _ref8.apply(this, arguments);
    };
  }();

  this.tabs = [{ name: 'isEmployed', text: 'Employed', isEmployed: true }, { name: 'SelfEmployed', text: 'Self Employed', isEmployed: false }];
};

exports.default = NewIncomeForm;

/***/ }),
/* 2309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewUpdateIncomeForm = function (_Component) {
  _inherits(NewUpdateIncomeForm, _Component);

  function NewUpdateIncomeForm(props) {
    _classCallCheck(this, NewUpdateIncomeForm);

    var _this = _possibleConstructorReturn(this, (NewUpdateIncomeForm.__proto__ || Object.getPrototypeOf(NewUpdateIncomeForm)).call(this, props));

    _initialiseProps.call(_this);

    var state = NewUpdateIncomeForm.getPropsToState(props);
    _this.state = _extends({}, state, {
      errMessages: []
    });
    _this.validation = {
      basicIncome: (0, _react.createRef)(),
      fixAllowance: (0, _react.createRef)(),
      deduction: (0, _react.createRef)(),
      bYearlyIncome: (0, _react.createRef)(),
      otherYearlyIncome: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(NewUpdateIncomeForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchCustomerIncome();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = NewUpdateIncomeForm.getPropsToState(nextProps);
      if (JSON.stringify(state.oriIncome) === JSON.stringify(this.state.oriIncome)) {
        state.income = this.state.income;
      }
      this.setState(state);
    }
  }, {
    key: 'fetchCustomerIncome',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, json, newIncome;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                res = '';
                _context.prev = 2;
                _context.next = 5;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.customerID + '/income/' + this.props.data.income.id + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                res = _context.sent;
                _context.next = 19;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](2);

                if (!(_context.t0.res && _context.t0.res.status >= 399 && _context.t0.res.status < 500)) {
                  _context.next = 15;
                  break;
                }

                _context.next = 13;
                return _context.t0.res.text();

              case 13:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 15:
                // await this.setLoading(false);
                Bugsnag.notifyException(_context.t0);
                _context.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 18:
                return _context.abrupt('return');

              case 19:
                _context.next = 21;
                return res.json();

              case 21:
                json = _context.sent;

                if (json) {
                  newIncome = Object.assign({}, json || {});

                  this.setState({ income: newIncome });
                }

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));

      function fetchCustomerIncome() {
        return _ref.apply(this, arguments);
      }

      return fetchCustomerIncome;
    }()
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        var income = this.state.income;

        this.props.onChange(income);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var income = this.state.income;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { centered: true },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          income.isEmployed ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 7, tablet: 9, mobile: 16, textAlign: 'right' },
            _react2.default.createElement(_AppForm2.default.Input, {
              label: _react2.default.createElement(_semanticUiReact.Header, {
                as: 'h5',
                style: { marginBottom: '0.5em' },
                textAlign: 'left',
                content: 'Basic Monthly Income',
                subheader: 'Monthly Basic Salary, Monthly Recurring Commission before any deduction'
              }),
              validateLabel: 'Basic Monthly Income',
              type: 'number',
              step: '0.01',
              name: 'basicIncome',
              value: income.basicIncome,
              onChange: this.handleInputChange,
              validation: income.isEmployed ? [{
                validate: _webValidations.numericRange,
                option: {
                  min: 1,
                  message: 'Basic Monthly Income is required'
                }
              }] : null,
              ref: this.validation.basicIncome
            }),
            _react2.default.createElement(_AppForm2.default.Input, {
              label: _react2.default.createElement(_semanticUiReact.Header, {
                as: 'h5',
                style: { marginBottom: '0.5em' },
                textAlign: 'left',
                content: 'Fix Monthly Allowance',
                subheader: 'Recurring fixed travel allowance, meal allowance, yearly contractual bonus/12months'
              }),
              validateLabel: 'Fix Monthly Allowance',
              type: 'number',
              step: '0.01',
              name: 'fixAllowance',
              value: income.fixAllowance,
              onChange: this.handleInputChange,
              ref: this.validation.fixAllowance
            }),
            _react2.default.createElement(_semanticUiReact.Header, {
              as: 'h5',
              style: { marginBottom: '0.5em' },
              textAlign: 'left',
              content: 'Gross Monthly Income'
            }),
            _react2.default.createElement(_AppForm2.default.Input, {
              type: 'number',
              step: '0.01',
              name: 'grossIncome',
              value: income.grossIncome,
              disabled: true,
              readOnly: true
            }),
            _react2.default.createElement(_AppForm2.default.Input, {
              label: _react2.default.createElement(_semanticUiReact.Header, {
                as: 'h5',
                style: { marginBottom: '0.5em' },
                textAlign: 'left',
                content: 'Monthly Income deduction',
                subheader: 'EPF, SOSCO, PCB, CP38'
              }),
              validateLabel: 'Monthly Income deduction',
              type: 'number',
              step: '0.01',
              name: 'deduction',
              value: income.deduction,
              onChange: this.handleInputChange,
              ref: this.validation.deduction
            }),
            _react2.default.createElement(_semanticUiReact.Header, {
              as: 'h5',
              style: { marginBottom: '0.5em' },
              textAlign: 'left',
              content: 'Net Monthly Income'
            }),
            _react2.default.createElement(_AppForm2.default.Input, {
              type: 'number',
              step: '0.01',
              name: 'netIncome',
              value: income.netIncome,
              validation: income.isEmployed ? [{
                validate: _webValidations.numericRange,
                option: {
                  min: 1,
                  message: 'Net Monthly Income is required'
                }
              }] : null,
              disabled: true,
              readOnly: true
            })
          ) : null,
          !income.isEmployed ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 7, tablet: 9, mobile: 16, textAlign: 'right' },
            _react2.default.createElement(_AppForm2.default.Input, {
              label: _react2.default.createElement(_semanticUiReact.Header, {
                as: 'h5',
                style: { marginBottom: '0.5em' },
                textAlign: 'left',
                content: 'Latest B Form Yearly Income'
              }),
              validateLabel: 'Latest B Form Yearly Income',
              type: 'number',
              step: '0.01',
              name: 'bYearlyIncome',
              value: income.bYearlyIncome,
              onChange: this.handleInputChange,
              validation: !income.isEmployed ? [{
                validate: _webValidations.numericRange,
                option: {
                  min: 1,
                  message: 'B Form Yearly Income is required'
                }
              }] : null,
              ref: this.validation.bYearlyIncome
            }),
            _react2.default.createElement(_AppForm2.default.Input, {
              label: _react2.default.createElement(_semanticUiReact.Header, {
                as: 'h5',
                style: { marginBottom: '0.5em' },
                textAlign: 'left',
                content: 'Other Yearly Income'
              }),
              validateLabel: 'Other Yearly Income',
              type: 'number',
              step: '0.01',
              name: 'otherYearlyIncome',
              value: income.otherYearlyIncome,
              onChange: this.handleInputChange,
              ref: this.validation.otherYearlyIncome
            }),
            _react2.default.createElement(_semanticUiReact.Header, {
              as: 'h5',
              style: { marginBottom: '0.5em' },
              textAlign: 'left',
              content: 'Total'
            }),
            _react2.default.createElement(_AppForm2.default.Input, {
              type: 'number',
              step: '0.01',
              name: 'netIncome',
              value: income.netIncome,
              validation: !income.isEmployed ? [{
                validate: _webValidations.numericRange,
                option: {
                  min: 1,
                  message: 'Total is required'
                }
              }] : null,
              disabled: true,
              readOnly: true
            })
          ) : null
        )
      );
    }
  }]);

  return NewUpdateIncomeForm;
}(_react.Component);

NewUpdateIncomeForm.propTypes = {
  customerID: _propTypes2.default.string,
  data: _propTypes2.default.shape({
    epfStatementDocumentID: _propTypes2.default.string,
    epfStatementDocument: _propTypes2.default.shape({
      key: _propTypes2.default.string,
      tags: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }),
    payslipDocumentID: _propTypes2.default.string,
    payslipDocument: _propTypes2.default.shape({
      key: _propTypes2.default.string,
      tags: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }),
    bankStatementDocumentID: _propTypes2.default.string,
    bankStatementDocument: _propTypes2.default.shape({
      key: _propTypes2.default.string,
      tags: _propTypes2.default.arrayOf(_propTypes2.default.string)
    }),
    bFormDocumentID: _propTypes2.default.string,
    bFormDocument: _propTypes2.default.shape({
      key: _propTypes2.default.string,
      tags: _propTypes2.default.arrayOf(_propTypes2.default.string)
    })
  }),
  income: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    isEmployed: _propTypes2.default.bool,
    basicIncome: _propTypes2.default.number,
    fixAllowance: _propTypes2.default.number,
    grossIncome: _propTypes2.default.number,
    deduction: _propTypes2.default.number,
    netIncome: _propTypes2.default.number,
    bYearlyIncome: _propTypes2.default.number,
    otherYearlyIncome: _propTypes2.default.number,
    currentLoanAmount: _propTypes2.default.number
  }),
  onChange: _propTypes2.default.func,
  loading: _propTypes2.default.bool
};
NewUpdateIncomeForm.contextTypes = {
  store: _propTypes2.default.object
};
NewUpdateIncomeForm.defaultValues = {
  bankStatementDocumentID: '',
  bankStatementDocument: null,
  basicIncome: 0,
  bFormDocumentID: '',
  bFormDocument: null,
  bYearlyIncome: 0,
  currentLoanAmount: 0,
  epfStatementDocumentID: '',
  epfStatementDocument: null,
  deduction: 0,
  fixAllowance: 0,
  grossIncome: 0,
  id: '',
  isEmployed: true,
  netIncome: 0,
  otherYearlyIncome: 0,
  payslipDocumentID: '',
  payslipDocument: null
};

NewUpdateIncomeForm.getPropsToState = function (props) {
  var income = Object.assign({}, NewUpdateIncomeForm.defaultValues, props.income || {});
  return {
    income: income,
    oriIncome: Object.assign({}, income)
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleInputChange = function (event, data) {
    var income = _this2.state.income;

    income[data.name] = _lodash2.default.toNumber(data.value);
    if (income.isEmployed) {
      var grossIncome = _lodash2.default.toNumber(_lodash2.default.toNumber(income.basicIncome) + _lodash2.default.toNumber(income.fixAllowance)).toFixed(2);
      income.grossIncome = _lodash2.default.toNumber(grossIncome);
      var netIncome = _lodash2.default.toNumber(_lodash2.default.toNumber(income.grossIncome) - _lodash2.default.toNumber(income.deduction)).toFixed(2);
      income.netIncome = _lodash2.default.toNumber(netIncome);
    }
    if (!income.isEmployed) {
      var totalYearlyIncome = _lodash2.default.toNumber(income.bYearlyIncome) + _lodash2.default.toNumber(income.otherYearlyIncome);
      var totalMonthlyIncome = _lodash2.default.toNumber(totalYearlyIncome) / 12;
      var roughIncome = _lodash2.default.toNumber(totalMonthlyIncome).toFixed(2);
      income.netIncome = _lodash2.default.toNumber(roughIncome);
    }
    _this2.setState({ income: income }, function () {
      _this2.handleCheckChanges();
    });
  };
};

exports.default = NewUpdateIncomeForm;

/***/ }),
/* 2310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _PhoneInput = __webpack_require__(104);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

var _intlFlagCodes = __webpack_require__(141);

var _intlFlagCodes2 = _interopRequireDefault(_intlFlagCodes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PersonalInfo = function (_Component) {
  _inherits(PersonalInfo, _Component);

  function PersonalInfo(props) {
    _classCallCheck(this, PersonalInfo);

    var _this = _possibleConstructorReturn(this, (PersonalInfo.__proto__ || Object.getPrototypeOf(PersonalInfo)).call(this, props));

    _initialiseProps.call(_this);

    var state = PersonalInfo.getPropsToState(props);
    _this.state = _extends({}, state, {
      loading: false,
      errMessages: [],
      hasChanges: false
    });
    _this.validation = {
      name: (0, _react.createRef)(),
      mobile: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(PersonalInfo, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = PersonalInfo.getPropsToState(nextProps);
      if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
        state.editingCustomer = this.state.editingCustomer;
      }
      if (state !== this.state) {
        this.setState({ state: state });
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this2.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'setloading',
    value: function setloading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.infoForm.submit(url, opts);
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      var data = this.state.data;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true });
      }
      if (this.props.onChange) {
        this.props.onChange(data);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          data = _state.data,
          editingCustomer = _state.editingCustomer;

      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref3) {
            _this4.infoForm = _ref3;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { centered: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { computer: 7, tablet: 9, mobile: 16, textAlign: 'right' },
              _react2.default.createElement(_semanticUiReact.Label, {
                style: { float: 'left', background: 'transparent', color: 'black' },
                content: data.identityTypeID === 4 ? 'Company Name' : 'Full Name'
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                autoComplete: 'off',
                name: 'name',
                onChange: this.handleChange,
                placeholder: data.identityTypeID === 4 ? 'Company Name' : 'Full Name',
                ref: this.validation.name,
                validation: [_webValidations.required],
                value: editingCustomer.name,
                validateLabel: data.identityTypeID === 4 ? 'Company Name' : 'Full Name'
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { computer: 7, tablet: 9, mobile: 16 },
              _react2.default.createElement(_semanticUiReact.Label, {
                style: { float: 'left', background: 'transparent', color: 'black' },
                content: 'NRIC'
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                disabled: true,
                name: 'identity',
                placeholder: 'eg: 890909-05-1234',
                value: data.identity
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { paddingBottom: '0' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { computer: 7, tablet: 9, mobile: 16 },
              _react2.default.createElement(_semanticUiReact.Label, {
                style: { float: 'left', background: 'transparent', color: 'black' },
                content: 'Phone'
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { paddingTop: '0' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { computer: 2, tablet: 3, mobile: 7, style: { paddingRight: '0' } },
              _react2.default.createElement(
                _AppForm2.default.Validate,
                {
                  validation: [_webValidations.required],
                  onChange: this.handleChange,
                  validationLabel: 'Mobile prefix'
                },
                _react2.default.createElement(
                  _semanticUiReact.Dropdown,
                  {
                    fluid: true,
                    value: editingCustomer.mobilePrefix,
                    selectOnBlur: false,
                    trigger: _react2.default.createElement(
                      'p',
                      { style: { margin: 0, display: 'inline-block', width: '70%', textAlign: 'center', paddingLeft: '0.2rem' } },
                      _react2.default.createElement(_semanticUiReact.Flag, { name: _intlFlagCodes2.default.find(function (_ref) {
                          var v = _ref.value;
                          return v === editingCustomer.mobilePrefix;
                        }).countryCode, style: { paddingRight: '1.5rem' } }),
                      '(',
                      editingCustomer.mobilePrefix,
                      ')'
                    ),
                    style: { padding: '0.6em', border: '1px solid rgba(34,36,38,.15)', borderBottomLeftRadius: '0.3rem', borderTopLeftRadius: '0.3rem', marginTop: '0.28571429rem' }
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Dropdown.Menu,
                    { style: { overflowY: 'scroll', height: '10rem' } },
                    _intlFlagCodes2.default.map(function (_ref2) {
                      var value = _ref2.value,
                          text = _ref2.text,
                          countryCode = _ref2.countryCode;
                      return _react2.default.createElement(
                        _semanticUiReact.Dropdown.Item,
                        {
                          name: 'mobilePrefix',
                          key: value + '_' + text,
                          value: value,
                          onClick: _this4.handleChange
                        },
                        _react2.default.createElement(_semanticUiReact.Flag, { name: countryCode }),
                        ' ',
                        text
                      );
                    })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { computer: 5, tablet: 6, mobile: 9, style: { paddingLeft: '0' }, textAlign: 'right' },
              _react2.default.createElement(_PhoneInput2.default, {
                autoComplete: 'off',
                name: 'mobile',
                onChange: this.handleChange,
                placeholder: editingCustomer.mobilePrefix === '60' ? 'Mobile* (e.g. 196756118)' : 'Mobile*',
                ref: this.validation.mobile,
                type: 'tel',
                validation: [_webValidations.required, {
                  validate: _webValidations.phoneNumber,
                  option: editingCustomer.mobilePrefix === 'other' ? {} : {
                    isMobile: true,
                    phonePrefix: editingCustomer.mobilePrefix
                  }
                }],
                value: editingCustomer.mobile,
                validateLabel: 'Mobile'
              })
            )
          )
        )
      );
    }
  }]);

  return PersonalInfo;
}(_react.Component);

PersonalInfo.propTypes = {
  onChange: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func.isRequired
};
PersonalInfo.defaultCustomerData = {
  id: '',
  customerDetailID: '',
  identityTypeID: '',
  identity: '',
  icFrontDocumentID: '',
  icFrontDocument: null,
  icBackDocumentID: '',
  icBackDocument: null,
  incomeID: '',
  customerCreditReports: [],
  customerCreditReport: null,
  runCreditCheck: false
};
PersonalInfo.defaultCustomerDetailData = {
  title: '',
  name: '',
  preferredName: '',
  email: '',
  mobilePrefix: '',
  mobile: '',
  phonePrefix: '',
  phone: '',
  address1: '',
  address2: '',
  city: '',
  postcode: '',
  state: '',
  country: ''
};
PersonalInfo.defaultValues = {
  identityTypeID: null,
  identity: '',
  name: '',
  mobilePrefix: '60',
  mobile: '',
  phonePrefix: '60',
  phone: ''
};

PersonalInfo.getPropsToState = function (props) {
  var data = Object.assign({}, PersonalInfo.defaultCustomerData, props.data || {});
  if (!data.customerDetailID) {
    data.customerDetail = Object.assign({}, PersonalInfo.defaultCustomerDetailData);
  }
  var dataEditingCustomer = {
    identityTypeID: data.identityTypeID,
    identity: data.identity,
    name: data.customerDetail.name,
    mobilePrefix: data.customerDetail.mobilePrefix,
    mobile: data.customerDetail.mobile,
    phonePrefix: data.customerDetail.phonePrefix,
    phone: data.customerDetail.phone
  };
  var editingCustomer = Object.assign({}, PersonalInfo.defaultValues, dataEditingCustomer);
  return {
    data: data,
    oriData: (0, _clone2.default)(data),
    editingCustomer: editingCustomer
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.handleChange = function (event, value) {
    var _state2 = _this5.state,
        editingCustomer = _state2.editingCustomer,
        data = _state2.data;

    if (value.name === 'name') {
      data.customerDetail[value.name] = value.value;
    }
    editingCustomer[value.name] = value.value;
    _this5.setState({ editingCustomer: editingCustomer, data: data }, function () {
      if (value.name === 'mobilePrefix') {
        _this5.validation.mobile.current.validate(editingCustomer.mobile);
      }
      data.customerDetail[value.name] = value.value;
      _this5.handleCheckChanges();
    });
  };

  this.handleSubmit = function () {
    var data = _this5.state.data;

    _AppForm2.default.validate(_this5.validation, data.customerDetail).then(function (validations) {
      _this5.setState({
        errMessages: validations.filter(function (v) {
          return !v.isValid;
        })
      });
      _this5.props.onSubmit(validations, data);
    });
  };
};

exports.default = PersonalInfo;

/***/ }),
/* 2311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UpdateLoanInfo = function (_Component) {
  _inherits(UpdateLoanInfo, _Component);

  function UpdateLoanInfo(props) {
    _classCallCheck(this, UpdateLoanInfo);

    var _this = _possibleConstructorReturn(this, (UpdateLoanInfo.__proto__ || Object.getPrototypeOf(UpdateLoanInfo)).call(this, props));

    _initialiseProps.call(_this);

    var state = UpdateLoanInfo.getPropsToState(props);
    _this.state = _extends({}, state, {
      displayedPercentage: '',
      errMessages: [],
      loanPercentage: 0
    });
    return _this;
  }

  _createClass(UpdateLoanInfo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.pathCheck ? this.getDefaultLoanAmount() : null;
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = UpdateLoanInfo.getPropsToState(nextProps);
      if (JSON.stringify(this.state.oriCreditCheckReportData) === JSON.stringify(state.oriCreditCheckReportData)) {
        state.creditCheckReportData = this.state.creditCheckReportData;
      }
      this.setState({ state: state });
    }
  }, {
    key: 'getDefaultLoanAmount',
    value: function getDefaultLoanAmount() {
      var bookingCustomerData = this.props.bookingCustomerData;
      var creditCheckReportData = this.state.creditCheckReportData;

      var newCreditCheckReportData = Object.assign({}, creditCheckReportData);
      newCreditCheckReportData.currentLoanAmount = _lodash2.default.toNumber((bookingCustomerData.spaValue * 0.9).toFixed(2));
      this.setState({ creditCheckReportData: newCreditCheckReportData, displayPercentage: '90%' });
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        var creditCheckReportData = this.state.creditCheckReportData;

        this.props.onChange(creditCheckReportData);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var bookingCustomerData = this.props.bookingCustomerData;
      var _state = this.state,
          displayPercentage = _state.displayPercentage,
          creditCheckReportData = _state.creditCheckReportData,
          loanPercentage = _state.loanPercentage;

      return _react2.default.createElement(
        'div',
        null,
        this.props.pathCheck ? _react2.default.createElement(
          _semanticUiReact.Container,
          {
            style: {
              border: '1px solid rgba(164, 179, 193, 1)',
              padding: '0.7rem 2rem',
              borderRadius: '0.25rem',
              background: 'rgba(231, 236, 241, 1)'
            }
          },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(_semanticUiReact.Label, { content: 'Loan Amount', style: { background: 'transparent', color: 'black' } }),
                _react2.default.createElement(
                  'div',
                  { style: { fontSize: '1.7rem', fontWeight: 'bold', margin: '0.5rem' } },
                  _react2.default.createElement(_LoanAmount2.default, {
                    format: '0,000,000.00',
                    amount: _lodash2.default.toNumber(creditCheckReportData.currentLoanAmount),
                    prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                  })
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { className: 'loanInfoContainer' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Header, {
                    as: 'h5',
                    style: { marginBottom: '0.5em' },
                    textAlign: 'left',
                    content: 'Selling Price'
                  }),
                  _react2.default.createElement(
                    'div',
                    { className: 'spaValueContainer' },
                    _react2.default.createElement(_LoanAmount2.default, {
                      format: '0,000,000.00',
                      amount: bookingCustomerData.spaValue,
                      prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                    })
                  ),
                  _react2.default.createElement(_semanticUiReact.Header, {
                    as: 'h5',
                    style: { marginBottom: '0.5em' },
                    textAlign: 'left',
                    content: 'Loan Percentage'
                  }),
                  _react2.default.createElement(_semanticUiReact.Dropdown, {
                    fluid: true,
                    placeholder: 'Loan Percentage',
                    selection: true,
                    options: this.percentageOptions,
                    onChange: this.handleDropdownChange,
                    trigger: loanPercentage === 0 && creditCheckReportData.currentLoanAmount !== 0 ? displayPercentage : null
                  })
                )
              )
            )
          )
        ) : _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right' },
              _react2.default.createElement(_semanticUiReact.Header, {
                as: 'h5',
                style: { marginBottom: '0.5em' },
                textAlign: 'left',
                content: 'Loan Amount'
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                type: 'number',
                step: '0.01',
                name: 'currentLoanAmount',
                value: _lodash2.default.toNumber(creditCheckReportData.currentLoanAmount),
                onChange: this.handleInputChange
              })
            )
          )
        )
      );
    }
  }]);

  return UpdateLoanInfo;
}(_react.Component);

UpdateLoanInfo.propTypes = {
  bookingCustomerData: _propTypes2.default.shape({
    spaValue: _propTypes2.default.number
  }),
  creditCheckReportData: _propTypes2.default.shape({
    currentLoanAmount: _propTypes2.default.number,
    monthlyCommitment: _propTypes2.default.number
  }),
  onChange: _propTypes2.default.func,
  pathCheck: _propTypes2.default.bool
};
UpdateLoanInfo.defaultCustomerCreditReportsData = {
  currentLoanAmount: 0,
  monthlyCommitment: 0
};
UpdateLoanInfo.contextType = {
  store: _propTypes2.default.object
};

UpdateLoanInfo.getPropsToState = function (props) {
  var creditCheckReportData = Object.assign({}, props.creditCheckReportData || {});
  return {
    creditCheckReportData: creditCheckReportData,
    oriCreditCheckReportData: (0, _clone2.default)(creditCheckReportData)
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.percentageOptions = [{
    text: '95%',
    value: '0.95'
  }, {
    text: '90%',
    value: '0.90'
  }, {
    text: '85%',
    value: '0.85'
  }, {
    text: '80%',
    value: '0.80'
  }, {
    text: '75%',
    value: '0.75'
  }, {
    text: '70%',
    value: '0.70'
  }, {
    text: '65%',
    value: '0.65'
  }, {
    text: '60%',
    value: '0.60'
  }, {
    text: '55%',
    value: '0.55'
  }, {
    text: '50%',
    value: '0.50'
  }, {
    text: '45%',
    value: '0.45'
  }, {
    text: '40%',
    value: '0.40'
  }, {
    text: '35%',
    value: '0.35'
  }, {
    text: '30%',
    value: '0.30'
  }, {
    text: '25%',
    value: '0.25'
  }, {
    text: '20%',
    value: '0.20'
  }, {
    text: '15%',
    value: '0.15'
  }, {
    text: '10%',
    value: '0.10'
  }, {
    text: '5%',
    value: '0.5'
  }];

  this.handleDropdownChange = function (e, _ref) {
    var value = _ref.value;
    var creditCheckReportData = _this2.state.creditCheckReportData;

    e.preventDefault();
    var newCreditCheckReportData = Object.assign({}, creditCheckReportData);
    newCreditCheckReportData.currentLoanAmount = _lodash2.default.toNumber((_this2.props.bookingCustomerData.spaValue * value).toFixed(2));
    _this2.setState({ loanPercentage: value, creditCheckReportData: newCreditCheckReportData }, function () {
      _this2.handleCheckChanges();
    });
  };

  this.handleFlashError = function () {
    var store = _this2.context.store;

    store.dispatch((0, _flash.flashErrorMessage)('Please tick the checkbox to generate ctos report'));
  };

  this.handleInputChange = function (e, data) {
    e.preventDefault();
    var creditCheckReportData = _this2.state.creditCheckReportData;

    creditCheckReportData[data.name] = _lodash2.default.toNumber(data.value);
    _this2.setState({ creditCheckReportData: creditCheckReportData }, function () {
      _this2.handleCheckChanges();
    });
  };
};

exports.default = UpdateLoanInfo;

/***/ }),
/* 2312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _SpecificationTable = __webpack_require__(127);

var _SpecificationTable2 = _interopRequireDefault(_SpecificationTable);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomOptions = function (_Component) {
  _inherits(CustomOptions, _Component);

  function CustomOptions(props) {
    _classCallCheck(this, CustomOptions);

    var _this = _possibleConstructorReturn(this, (CustomOptions.__proto__ || Object.getPrototypeOf(CustomOptions)).call(this, props));

    _this.handleOnChange = function (data) {
      _this.setState({ data: data });
    };

    _this.handleOnSave = function (e) {
      e.preventDefault();
      if (JSON.stringify(_this.state.data) !== JSON.stringify(_this.state.oriData)) {
        _this.updateCustomOptions();
      } else {
        _this.setState({
          isEditing: false
        });
      }
    };

    _this.handleOnEdit = function (e) {
      e.preventDefault();
      _this.setState({ isEditing: true });
    };

    _this.handleMenu = function (e, _ref) {
      var value = _ref.value;
      var store = _this.context.store;

      store.dispatch((0, _reactRouterRedux.replace)(value));
    };

    _this.handleResize = function () {
      var state = {};
      var topMenuIsTab = window.innerWidth <= 590;
      if (topMenuIsTab !== _this.state.topMenuIsTab) {
        state.topMenuIsTab = topMenuIsTab;
      }
      _this.setState(_extends({}, state));
    };

    _this.state = {
      token: null,
      loading: true,
      data: null,
      oriData: null,
      isEditing: false,
      topMenuIsTab: window.innerWidth <= 590
    };
    return _this;
  }

  _createClass(CustomOptions, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchCustomOptions();
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchCustomOptions',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var t, store, res, message, data, token;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/custom_options/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 19;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context.next = 33;
                break;

              case 27:
                _context.next = 29;
                return res.json();

              case 29:
                data = _context.sent;
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context.next = 33;
                return this.setComponentState({
                  token: token,
                  data: data,
                  oriData: data
                });

              case 33:
                _context.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchCustomOptions() {
        return _ref2.apply(this, arguments);
      }

      return fetchCustomOptions;
    }()
  }, {
    key: 'updateCustomOptions',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var t, store, data, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                data = this.state.data || [];

                data = data.filter(function (d) {
                  return d.name !== '';
                });
                _context2.prev = 6;
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/custom_options/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(data)
                }));

              case 9:
                _context2.next = 24;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](6);
                _context2.next = 15;
                return this.setLoading(false);

              case 15:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 21;
                  break;
                }

                _context2.next = 18;
                return _context2.t0.res.text();

              case 18:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 21:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
                return _context2.abrupt('return');

              case 24:
                _context2.next = 26;
                return this.setComponentState({
                  isEditing: false
                });

              case 26:
                _context2.next = 28;
                return this.setLoading(false);

              case 28:
                this.fetchCustomOptions();
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Custom options successfully updated.', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 30:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 11]]);
      }));

      function updateCustomOptions() {
        return _ref3.apply(this, arguments);
      }

      return updateCustomOptions;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          data = _state.data,
          isEditing = _state.isEditing,
          loading = _state.loading;
      var pathname = this.props.location.pathname;
      var t = this.props.t;

      var links = [{ text: 'System Settings', value: '/settings/system_settings/' }, { text: 'Custom Options', value: '/settings/custom_options/' }];
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.topMenuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: t(link.text, { ns: _translation.TRANSLATION_FILES.screens }),
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this4.handleMenu(e, link);
              }
            });
          }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            isEditing ? _react2.default.createElement(_semanticUiReact.Button, {
              color: 'green',
              content: t('Save', { ns: _translation.TRANSLATION_FILES.translation }),
              disabled: this.state.loading,
              onClick: this.handleOnSave
            }) : _react2.default.createElement(_semanticUiReact.Button, {
              icon: 'edit',
              content: t('Edit', { ns: _translation.TRANSLATION_FILES.translation }),
              disabled: this.state.loading,
              onClick: this.handleOnEdit
            })
          )
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                {
                  inverted: true,
                  active: this.state.loading
                },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(_SpecificationTable2.default, {
                type: 'customOptions',
                editable: true,
                isEditing: isEditing,
                hideButton: true,
                notFoundNode: _react2.default.createElement(
                  'p',
                  null,
                  t('No options.', { ns: _translation.TRANSLATION_FILES.translation })
                ),
                placeholderName: t('Enter option name', { ns: _translation.TRANSLATION_FILES.translation }),
                placeholderDescription: t('Enter option value', { ns: _translation.TRANSLATION_FILES.translation }),
                headerNode: t('Custom Options', { ns: _translation.TRANSLATION_FILES.screens }),
                data: data,
                onChange: this.handleOnChange,
                loading: loading
              })
            )
          )
        )
      );
    }
  }]);

  return CustomOptions;
}(_react.Component);

CustomOptions.contextTypes = {
  store: _propTypes2.default.object
};
CustomOptions.propTypes = {
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(CustomOptions);

/***/ }),
/* 2313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CustomOptions = __webpack_require__(2312);

var _CustomOptions2 = _interopRequireDefault(_CustomOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CustomOptions2.default;

/***/ }),
/* 2314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

var _semanticUiReact = __webpack_require__(2);

var _queryString = __webpack_require__(684);

var _queryString2 = _interopRequireDefault(_queryString);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactRouter = __webpack_require__(18);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Identity = __webpack_require__(315);

var _Identity2 = _interopRequireDefault(_Identity);

var _NewCreditCheck = __webpack_require__(1055);

var _NewCreditCheck2 = _interopRequireDefault(_NewCreditCheck);

var _NewCreditCheckSplash = __webpack_require__(2160);

var _NewCreditCheckSplash2 = _interopRequireDefault(_NewCreditCheckSplash);

var _InsufficientCreditCheck = __webpack_require__(1077);

var _InsufficientCreditCheck2 = _interopRequireDefault(_InsufficientCreditCheck);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/jsx-no-target-blank */
/* eslint no-nested-ternary: 0, react/no-unused-prop-types: 0 */


var CreditCheck = function (_Component) {
  _inherits(CreditCheck, _Component);

  function CreditCheck(props) {
    _classCallCheck(this, CreditCheck);

    var _this = _possibleConstructorReturn(this, (CreditCheck.__proto__ || Object.getPrototypeOf(CreditCheck)).call(this, props));

    _initialiseProps.call(_this);

    var state = CreditCheck.getPropsToState(props);
    _this.state = _extends({}, state, {
      hasChanges: false,
      runCreditCheck: false,
      openInsufficientCreditModal: false,
      creditSubscription: {
        amount: 0
      }
    });
    return _this;
  }

  _createClass(CreditCheck, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (location.search !== '') {
        var values = _queryString2.default.parse(this.props.location.search);
        if (values.runCreditCheck === 'true') {
          this.fetchBookingCustomer();
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = CreditCheck.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this2.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'fetchBookingCustomer',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, json, newData;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = '';
                _context.prev = 4;

                if (!this.props.location.pathname.includes('bookings/')) {
                  _context.next = 11;
                  break;
                }

                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.params.customerID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 14;
                break;

              case 11:
                _context.next = 13;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.props.params.id + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 13:
                res = _context.sent;

              case 14:
                _context.next = 24;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 21;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 21:
                _context.next = 23;
                return this.setLoading(false);

              case 23:
                return _context.abrupt('return');

              case 24:
                _context.next = 26;
                return res.json();

              case 26:
                json = _context.sent;

                if (json) {
                  newData = Object.assign({}, json || {});

                  this.setState({ data: newData, runCreditCheck: true });
                }
                _context.next = 30;
                return this.setLoading(false);

              case 30:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 16]]);
      }));

      function fetchBookingCustomer() {
        return _ref.apply(this, arguments);
      }

      return fetchBookingCustomer;
    }()
  }, {
    key: 'fetchValue',
    value: function fetchValue() {
      var values = '';
      if (location.search !== '') {
        values = _queryString2.default.parse(this.props.location.search);
        if (values.runCreditCheck === 'true' && !this.state.runCreditCheck) {
          this.setState({ runCreditCheck: true });
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _state = this.state,
          data = _state.data,
          openInsufficientCreditModal = _state.openInsufficientCreditModal;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_InsufficientCreditCheck2.default, {
          open: openInsufficientCreditModal,
          onClose: function onClose(e) {
            return _this3.handleCloseInsufficientCreditModal(e);
          }
        }),
        _react2.default.createElement(_NavBar2.default, {
          header: 'Credit Check',
          rightNav: this.hasAccess() && !this.pathCheck(this.props) && _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              as: _reactRouter.Link,
              to: '/customers/manage/credit_checks/',
              disabled: this.state.loading,
              primary: true,
              icon: 'setting',
              content: 'Manage'
            })
          )
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'mobile-no-padding' },
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { active: this.state.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  'Loading'
                )
              ),
              !this.state.runCreditCheck && this.pathCheck(this.props) ? _react2.default.createElement(
                'div',
                { className: 'outerDiv' },
                _react2.default.createElement(
                  _semanticUiReact.Divider,
                  { horizontal: true },
                  'Credit Check'
                ),
                _react2.default.createElement(
                  _semanticUiReact.Container,
                  { className: 'outerContainer', textAlign: 'center' },
                  _react2.default.createElement(_semanticUiReact.Header, {
                    as: 'h2',
                    style: {
                      marginBottom: '2em',
                      color: 'rgba(0, 35, 59, 1)'
                    },
                    content: data.customerDetail.name,
                    subheader: _react2.default.createElement(
                      _semanticUiReact.Header.Subheader,
                      { style: { color: 'rgba(0, 35, 59, 1)', fontWeight: 'bold' } },
                      _react2.default.createElement(
                        'p',
                        { style: { marginBottom: '0' } },
                        data.customerDetail.preferredName || 'Customer'
                      ),
                      _react2.default.createElement(_Identity2.default, {
                        type: data.identityTypeID,
                        identity: data.identity || 'XXXXXXXXXXXX',
                        style: { color: 'black' }
                      })
                    )
                  }),
                  _react2.default.createElement(
                    _semanticUiReact.Header,
                    {
                      as: 'h3',
                      style: { margin: '1em 0', color: 'rgba(89, 105, 117, 1)' }
                    },
                    'Credit Check helps purchasers to know their loan eligibility.',
                    _react2.default.createElement(
                      _semanticUiReact.Header.Subheader,
                      { style: { marginTop: '0.25em', color: 'rgba(89, 105, 117, 1)' } },
                      'Follow these simple steps to get purchaser\u2019s CTOS and DSR (Debt Service Ratio) score.'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: 'new-credit-check' },
                    _react2.default.createElement(
                      _semanticUiReact.Container,
                      { style: { border: '1px solid rgb(217, 218, 220)', padding: '3rem', borderRadius: '0.25rem', backgroundColor: 'rgba(229, 244, 245, 1)', marginTop: '2em' }, textAlign: 'center' },
                      _react2.default.createElement(_NewCreditCheckSplash2.default, {
                        actionNode: _react2.default.createElement(
                          _semanticUiReact.Grid.Row,
                          { textAlign: 'center' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            {
                              mobile: 16,
                              tablet: 6,
                              computer: data.customerCreditReportID ? 5 : 4
                            },
                            _react2.default.createElement(
                              'div',
                              { className: 'runCreditCheckButton', style: { marginTop: '1rem' } },
                              _react2.default.createElement(
                                _semanticUiReact.Button,
                                {
                                  fluid: true,
                                  positive: true,
                                  onClick: this.handleCheckAvailableCredits,
                                  disabled: this.state.loading
                                },
                                data.customerCreditReportID ? 'Begin Credit Check' : 'Run Credit Check'
                              )
                            )
                          )
                        )
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Header,
                    {
                      as: 'h4',
                      style: { color: '#596975', marginTop: '3rem' }
                    },
                    'To top-up credits, please contact',
                    _react2.default.createElement('br', null),
                    _react2.default.createElement(
                      'a',
                      {
                        className: 'consentLink',
                        href: 'mailto:support@mhub.my'
                      },
                      'support@mhub.my'
                    )
                  )
                )
              ) : null,
              this.state.runCreditCheck && this.pathCheck(this.props) ? _react2.default.createElement(_NewCreditCheck2.default, {
                auth: this.props.auth,
                bookingID: this.props.params.id,
                data: this.state.data,
                pathCheck: this.pathCheck(this.props),
                loading: this.state.loading,
                setLoading: this.setLoading,
                customerID: data.id || '',
                onChange: this.handleOnCheck,
                icFrontDocumentID: data.icFrontDocumentID || '',
                icFrontDocument: data.icFrontDocument || null,
                icBackDocumentID: data.icBackDocumentID || '',
                icBackDocument: data.icBackDocument || null,
                incomeID: data.incomeID || '',
                income: data.income || null,
                customerCreditReport: data.customerCreditReport || null,
                customerCreditReports: data.customerCreditReports || [],
                customerDetail: data.customerDetail || null,
                refetch: this.handleRefetch,
                identityTypeID: data.identityTypeID || 0,
                identity: data.identity || '',
                location: location
              }) : null,
              !this.pathCheck(this.props) && data.id !== '' ? _react2.default.createElement(_NewCreditCheck2.default, {
                auth: this.props.auth,
                bookingID: this.props.params.id,
                data: this.state.data,
                pathCheck: this.pathCheck(this.props),
                loading: this.state.loading,
                setLoading: this.setLoading,
                customerID: data.id || '',
                onChange: this.handleOnCheck,
                icFrontDocumentID: data.icFrontDocumentID || '',
                icFrontDocument: data.icFrontDocument || null,
                icBackDocumentID: data.icBackDocumentID || '',
                icBackDocument: data.icBackDocument || null,
                incomeID: data.incomeID || '',
                income: data.income || null,
                customerCreditReport: data.customerCreditReport || null,
                customerCreditReports: data.customerCreditReports || [],
                customerDetail: data.customerDetail || null,
                refetch: this.handleRefetch,
                identityTypeID: data.identityTypeID || 0,
                identity: data.identity || '',
                location: location
              }) : null
            )
          )
        )
      );
    }
  }]);

  return CreditCheck;
}(_react.Component);

CreditCheck.contextTypes = {
  store: _propTypes2.default.object
};
CreditCheck.propTypes = {
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    customerID: _propTypes2.default.string
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    companyBranch: _propTypes2.default.shape({
      service_company_branch_id: _propTypes2.default.string
    })
  }),
  onCheck: _propTypes2.default.func
};

CreditCheck.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

CreditCheck.defaultCustomerData = {
  id: '',
  customerDetailID: '',
  identityTypeID: '',
  identity: '',
  icFrontDocumentID: '',
  icFrontDocument: null,
  icBackDocumentID: '',
  icBackDocument: null,
  incomeID: '',
  customerCreditReports: [],
  customerCreditReport: null,
  runCreditCheck: false
};
CreditCheck.defaultCustomerDetailData = {
  title: '',
  name: '',
  preferredName: '',
  email: '',
  mobilePrefix: '',
  mobile: '',
  phonePrefix: '',
  phone: '',
  address1: '',
  address2: '',
  city: '',
  postcode: '',
  state: '',
  country: ''
};

CreditCheck.getPropsToState = function (props) {
  var loading = props.loading;
  var data = Object.assign({}, CreditCheck.defaultCustomerData, props.data || {});
  var errMessages = [];
  if (!data.customerDetailID) {
    data.customerDetail = Object.assign({}, CreditCheck.defaultCustomerDetailData);
  }
  return {
    data: data,
    errMessages: errMessages,
    oriData: (0, _clone2.default)(data),
    loading: loading
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this4.setState({ loading: loading }, res);
    });
  };

  this.getCreditsSubscriptionFragment = function () {
    return '\n    id\n    company_id\n    company_branch_id\n    amount\n    currency_code\n    created_at\n    created_by\n    updated_at\n    updated_by\n  ';
  };

  this.handleChange = function (event, value) {
    var data = _this4.state.data;

    data[value.name] = value.value;
  };

  this.handleOnCheck = function () {
    var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (_this4.props.onCheck) {
      _this4.props.onCheck(hasChanges);
    }
  };

  this.handleCheckAvailableCredits = function () {
    var companyBranch = _this4.props.auth.companyBranch;

    _this4.setState({ loading: true });
    var availableCredit = 0;

    var store = _this4.context.store;

    var id = companyBranch && companyBranch.service_company_branch_id;
    _auth2.default.currentSession().then(function (result) {
      var creditsSubscriptionToken = result.getIdToken().getJwtToken();
      if (_config2.default.get('server') === 'development') {
        creditsSubscriptionToken = _config2.default.get('subsAuth');
      }
      fetch(_config2.default.get('subscriptionApiEndpoint'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: creditsSubscriptionToken
        },
        body: JSON.stringify({
          query: '\n            query {\n              getSubscription(\n                id: "' + id + '",\n              ) { ' + _this4.getCreditsSubscriptionFragment() + ' }\n            }\n          '
        })
      }).then(function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {
          var _ref3, data, message;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (!res.ok) {
                    _context2.next = 8;
                    break;
                  }

                  _context2.next = 3;
                  return res.json();

                case 3:
                  _ref3 = _context2.sent;
                  data = _ref3.data;

                  if (data && data.getSubscription) {
                    availableCredit = data.getSubscription.amount;
                    _this4.setState({
                      creditSubscription: _extends({}, data.getSubscription)
                    });

                    if (availableCredit < 10) {
                      _this4.setState({ openInsufficientCreditModal: true });
                    } else {
                      _this4.runCreditCheck();
                    }
                  }
                  _context2.next = 10;
                  break;

                case 8:
                  message = 'Failed to retrieve subscription data';

                  store.dispatch((0, _flash.flashErrorMessage)(message));

                case 10:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this4);
        }));

        return function (_x5) {
          return _ref2.apply(this, arguments);
        };
      }());
    }).catch(function (err) {
      return store.dispatch((0, _flash.flashErrorMessage)(err));
    });
    _this4.setState({ loading: false });
  };

  this.handleCloseInsufficientCreditModal = function (e) {
    e.preventDefault();
    _this4.setState({ openInsufficientCreditModal: false });
  };

  this.handleRefetch = function () {
    var store = _this4.context.store;

    if (_this4.pathCheck(_this4.props)) {
      store.dispatch((0, _reactRouterRedux.push)('/bookings/' + _this4.props.params.id + '/customers/' + _this4.state.data.id + '/credit_check/'));
    } else {
      store.dispatch((0, _reactRouterRedux.push)('/customers/' + _this4.state.data.id + '/credit_check/'));
    }
  };

  this.pathCheck = function (props) {
    var pathname = props.location.pathname;

    if (pathname.includes('/bookings/')) {
      return true;
    }
    return false;
  };

  this.runCreditCheck = function () {
    _this4.setState({ runCreditCheck: true });
  };
};

exports.default = (0, _reactRedux.connect)(CreditCheck.mapStateToProps)(CreditCheck);

/***/ }),
/* 2315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _appConfig = __webpack_require__(379);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _checkChanges = __webpack_require__(61);

var _promptMessages = __webpack_require__(43);

var _List = __webpack_require__(2318);

var _List2 = _interopRequireDefault(_List);

var _Overview = __webpack_require__(2321);

var _Overview2 = _interopRequireDefault(_Overview);

var _CreditCheck = __webpack_require__(2314);

var _CreditCheck2 = _interopRequireDefault(_CreditCheck);

var _Manage = __webpack_require__(2304);

var _Manage2 = _interopRequireDefault(_Manage);

var _ManageSettings = __webpack_require__(2305);

var _ManageSettings2 = _interopRequireDefault(_ManageSettings);

var _MultipleEntity = __webpack_require__(2307);

var _MultipleEntity2 = _interopRequireDefault(_MultipleEntity);

var _EditIncome = __webpack_require__(2316);

var _EditIncome2 = _interopRequireDefault(_EditIncome);

var _NewEditIncome = __webpack_require__(2320);

var _NewEditIncome2 = _interopRequireDefault(_NewEditIncome);

var _New = __webpack_require__(2319);

var _New2 = _interopRequireDefault(_New);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Customers = function (_Component) {
  _inherits(Customers, _Component);

  function Customers(props) {
    _classCallCheck(this, Customers);

    var _this = _possibleConstructorReturn(this, (Customers.__proto__ || Object.getPrototypeOf(Customers)).call(this, props));

    _this.state = {
      token: null,
      count: 0,
      limit: 0,
      offset: 0,
      loading: true,
      data: []
    };
    return _this;
  }

  _createClass(Customers, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _this2 = this;

      var store = this.context.store;

      store.dispatch((0, _appConfig.fetchAppConfig)()).then(function () {
        if (!_this2.props.auth.isSuperAdmin && !_this2.props.auth.isHeadquarters && !_this2.props.auth.isBranchLeader && !_this2.hasAccessDE()) {
          store.dispatch((0, _reactRouterRedux.replace)('/forbidden/'));
        }
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = this.props.location.query;

      this.fetchCustomers(query);
      if (!this.props.params.id) {
        if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
          delete query.page;
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _nextProps$location = nextProps.location,
          pathname = _nextProps$location.pathname,
          query = _nextProps$location.query;

      if (!pathname.includes('/new/')) {
        if (!this.state.loading) {
          this.fetchCustomers(query);
        }
      }
    }
  }, {
    key: 'setCustomers',
    value: function setCustomers() {
      var _this3 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this3.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this4 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this4.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this5 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this5.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'hasAccessDE',
    value: function hasAccessDE() {
      var _props = this.props,
          auth = _props.auth,
          appConfig = _props.appConfig;

      if (auth && auth.companyBranch && !auth.companyBranch.isExternal && appConfig && appConfig.data && appConfig.data.customerOwnedByDeveloperExecutive) {
        return true;
      }
      return false;
    }
  }, {
    key: 'fetchCustomers',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var store, query, res, url, queryString, message, token, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = Object.assign({}, q);

                if (!this.props.params.id) {
                  if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                    query.page = 1;
                  }
                }
                res = void 0;
                _context.prev = 6;
                url = '/customers/';

                if (this.props.params.id) {
                  url += this.props.params.id + '/';
                } else {
                  query.showBookingCount = true;
                }
                queryString = '';

                if (_qs2.default.stringify(query)) {
                  queryString = '?' + _qs2.default.stringify(query);
                }
                _context.next = 13;
                return store.dispatch((0, _fetchM.fetchM)('' + url + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 13:
                res = _context.sent;
                _context.next = 24;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](6);

                Bugsnag.notifyException(_context.t0);
                _context.next = 21;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 21:
                _context.next = 23;
                return this.setLoading(false);

              case 23:
                return _context.abrupt('return');

              case 24:
                if (res.ok) {
                  _context.next = 32;
                  break;
                }

                _context.next = 27;
                return res.text();

              case 27:
                message = _context.sent;
                _context.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 30:
                _context.next = 44;
                break;

              case 32:
                token = res.headers.get('X-Csrf-Token');
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 38;
                return res.json();

              case 38:
                data = _context.sent;
                _context.next = 41;
                return this.setComponentState({
                  token: token,
                  count: count,
                  limit: limit,
                  offset: offset,
                  data: data
                });

              case 41:
                if (this.props.params.id) {
                  _context.next = 44;
                  break;
                }

                _context.next = 44;
                return this.setCustomers(data);

              case 44:
                _context.next = 46;
                return this.setLoading(false);

              case 46:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 16]]);
      }));

      function fetchCustomers(_x4) {
        return _ref.apply(this, arguments);
      }

      return fetchCustomers;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this6 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this6.state.token,
          count: _this6.state.count,
          limit: _this6.state.limit,
          offset: _this6.state.offset,
          loading: _this6.state.loading,
          data: _this6.state.data
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Customers;
}(_react.Component);

Customers.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      customerOwnedByDeveloperExecutive: _propTypes2.default.bool
    })
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isDeveloper: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool
  }),
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object
  })
};
Customers.contextTypes = {
  store: _propTypes2.default.object
};

Customers.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig,
    auth: state.auth
  };
};

Customers.List = _List2.default;
Customers.Overview = (0, _checkChanges.checkChanges)(_Overview2.default);
Customers.CreditCheck = (0, _checkChanges.checkChanges)(_CreditCheck2.default);
Customers.ManageCreditCheck = (0, _checkChanges.checkChanges)(_Manage2.default);
Customers.ManageCreditCheckSettings = (0, _checkChanges.checkChanges)(_ManageSettings2.default);
Customers.MultipleEntity = (0, _checkChanges.checkChanges)(_MultipleEntity2.default);
Customers.EditIncome = (0, _checkChanges.checkChanges)(_EditIncome2.default);
Customers.NewEditIncome = (0, _checkChanges.checkChanges)(_NewEditIncome2.default);
Customers.New = (0, _checkChanges.checkChanges)(_New2.default, { message: _promptMessages.NEW_CUSTOMER_PROMPT });
exports.default = (0, _reactRedux.connect)(Customers.mapStateToProps)(Customers);

/***/ }),
/* 2316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _reactRouterRedux = __webpack_require__(13);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _Identity = __webpack_require__(315);

var _Identity2 = _interopRequireDefault(_Identity);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _IncomeForm = __webpack_require__(2302);

var _IncomeForm2 = _interopRequireDefault(_IncomeForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditIncome = function (_Component) {
  _inherits(EditIncome, _Component);

  function EditIncome(props) {
    _classCallCheck(this, EditIncome);

    var _this = _possibleConstructorReturn(this, (EditIncome.__proto__ || Object.getPrototypeOf(EditIncome)).call(this, props));

    _this.state = {
      loading: true,
      token: null,
      data: null,
      oriData: null,
      errMessages: []
    };
    _this.validation = {};
    return _this;
  }

  _createClass(EditIncome, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchIncome();
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, res);
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'fetchIncome',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                res = void 0;
                _context.prev = 2;
                _context.next = 5;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/customers/' + this.props.routeParams.id + '/income/' + this.props.routeParams.incomeID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                res = _context.sent;
                _context.next = 14;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](2);

                Bugsnag.notifyException(_context.t0);
                _context.next = 13;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 13:
                return _context.abrupt('return');

              case 14:
                if (res.ok) {
                  _context.next = 22;
                  break;
                }

                _context.next = 17;
                return res.text();

              case 17:
                message = _context.sent;
                _context.next = 20;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 20:
                _context.next = 28;
                break;

              case 22:
                token = res.headers.get('X-Csrf-Token');
                _context.next = 25;
                return res.json();

              case 25:
                data = _context.sent;
                _context.next = 28;
                return this.setComponentState({
                  token: token,
                  data: data,
                  oriData: (0, _clone2.default)(data)
                });

              case 28:
                _context.next = 30;
                return this.setLoading(false);

              case 30:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));

      function fetchIncome() {
        return _ref.apply(this, arguments);
      }

      return fetchIncome;
    }()
  }, {
    key: 'updateIncome',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(validations, income) {
        var store, errors, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                event.preventDefault();
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context2.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context2.abrupt('return');

              case 6:
                _context2.next = 8;
                return this.setLoading(true);

              case 8:
                _context2.prev = 8;
                _context2.next = 11;
                return this.form.submit(_config2.default.get('bookApiURL') + '/customers/' + this.props.routeParams.id + '/income/' + this.props.routeParams.incomeID + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(income)
                });

              case 11:
                _context2.next = 25;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](8);
                _context2.next = 17;
                return this.setLoading(false);

              case 17:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 23;
                  break;
                }

                _context2.next = 20;
                return _context2.t0.res.text();

              case 20:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 23:
                store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));
                return _context2.abrupt('return');

              case 25:
                _context2.next = 27;
                return this.setLoading(false);

              case 27:
                store.dispatch((0, _reactRouterRedux.push)('/customers/' + this.props.routeParams.id + '/'));
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Update Successs', message: 'Customer income has been successfully updated' }));

              case 29:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 13]]);
      }));

      function updateIncome(_x3, _x4) {
        return _ref2.apply(this, arguments);
      }

      return updateIncome;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var data = this.state.data;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: 'Income'
        }),
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { className: 'dark credit-check', color: 'grey', inverted: true, secondary: true, textAlign: 'center' },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { textAlign: 'center' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Divider,
                  { horizontal: true, inverted: true },
                  'Update Income'
                ),
                data && data.customer && data.customer.customerDetail ? _react2.default.createElement(_semanticUiReact.Header, {
                  as: 'h1',
                  textAlign: 'center',
                  style: { marginBottom: '1em' },
                  content: data.customer.customerDetail.preferredName || 'Customer',
                  subheader: _react2.default.createElement(
                    _semanticUiReact.Header.Subheader,
                    null,
                    _react2.default.createElement(
                      'p',
                      { style: { marginBottom: '0' } },
                      data.customer.customerDetail.name
                    ),
                    _react2.default.createElement(_Identity2.default, {
                      type: data.customer.identityTypeID,
                      identity: data.customer.identity || 'XXXXXXXXXXXX'
                    })
                  )
                }) : null,
                _react2.default.createElement(
                  _semanticUiReact.Dimmer,
                  { active: this.state.loading, inverted: true },
                  _react2.default.createElement(
                    _semanticUiReact.Loader,
                    { inline: 'centered' },
                    'Loading'
                  )
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                data ? _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_IncomeForm2.default, {
                    ref: function ref(_ref3) {
                      _this4.form = _ref3;
                    },
                    onSubmit: function onSubmit(validations, d) {
                      _this4.updateIncome(validations, d);
                    },
                    income: data,
                    onChange: this.handleIncomeChange,
                    isEditing: true
                  }),
                  _react2.default.createElement(
                    _semanticUiReact.Button,
                    {
                      size: 'large',
                      color: 'green',
                      type: 'submit',
                      disabled: this.state.loading,
                      style: {
                        marginTop: '2em',
                        marginBottom: '1.5em'
                      },
                      onClick: function onClick() {
                        _this4.form.handleSubmit(event);
                      }
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'save' }),
                    ' Update'
                  )
                ) : _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  !this.state.loading ? _react2.default.createElement(
                    'p',
                    null,
                    'No income found.'
                  ) : ''
                )
              )
            )
          )
        )
      );
    }
  }]);

  return EditIncome;
}(_react.Component);

EditIncome.contextTypes = {
  store: _propTypes2.default.object
};
EditIncome.propTypes = {
  routeParams: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    incomeID: _propTypes2.default.string
  })
};
exports.default = EditIncome;

/***/ }),
/* 2317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _reactI18next = __webpack_require__(3);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _PhoneInput = __webpack_require__(104);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

var _InputBirthdate = __webpack_require__(220);

var _InputBirthdate2 = _interopRequireDefault(_InputBirthdate);

var _countries = __webpack_require__(60);

var _intlCallCodes = __webpack_require__(116);

var _intlCallCodes2 = _interopRequireDefault(_intlCallCodes);

var _customerTitles = __webpack_require__(390);

var _customerTitles2 = _interopRequireDefault(_customerTitles);

var _TinFieldInput = __webpack_require__(192);

var _TinFieldInput2 = _interopRequireDefault(_TinFieldInput);

var _states = __webpack_require__(144);

var _states2 = _interopRequireDefault(_states);

var _race = __webpack_require__(324);

var _bumi = __webpack_require__(318);

var _gender = __webpack_require__(319);

var _maritalStatus = __webpack_require__(320);

var _regex = __webpack_require__(143);

var _vietnam = __webpack_require__(40);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _dateFromIC = __webpack_require__(593);

var _dateFromIC2 = _interopRequireDefault(_dateFromIC);

var _storage = __webpack_require__(44);

var _phone = __webpack_require__(146);

var _companies = __webpack_require__(88);

var _intlFlagCodes = __webpack_require__(141);

var _intlFlagCodes2 = _interopRequireDefault(_intlFlagCodes);

var _identityTypes = __webpack_require__(174);

var _translation = __webpack_require__(4);

var _translation2 = __webpack_require__(64);

var _tin = __webpack_require__(155);

var _defaultIdentityTypeOpts = __webpack_require__(154);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerForm = function (_Component) {
  _inherits(CustomerForm, _Component);

  function CustomerForm(props) {
    _classCallCheck(this, CustomerForm);

    var _this = _possibleConstructorReturn(this, (CustomerForm.__proto__ || Object.getPrototypeOf(CustomerForm)).call(this, props));

    _initialiseProps.call(_this);

    var customer = (0, _clone2.default)(CustomerForm.defaultValues);

    var identityPresets = {};
    var storeIdentityPresets = (0, _storage.getItem)(_config2.default.get('appName') + '.identityPresets');
    if (storeIdentityPresets) {
      try {
        identityPresets = JSON.parse(storeIdentityPresets).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }
    var tinError = null;
    var auth = props.auth;
    var identityTypeOpts = (0, _identityTypes.getIdentityTypeOpts)(auth, identityPresets);

    if (auth && (0, _companies.isForeignCompany)(auth.company)) {
      // Prefix & Country
      var idx = _intlFlagCodes2.default.findIndex(function (f) {
        return f.countryCode === auth.company.countryCode;
      });
      if (idx !== -1) {
        var defaultCountryPhoneCode = _intlFlagCodes2.default[idx].value;
        customer.mobilePrefix = defaultCountryPhoneCode;
        customer.phonePrefix = defaultCountryPhoneCode;
        customer.emergencyContactMobilePrefix = defaultCountryPhoneCode;
        customer.country = _intlFlagCodes2.default[idx].countryCode;
      }
    }

    var phoneValidationPresets = {};
    var storePhoneValidationPresets = (0, _storage.getItem)(_config2.default.get('appName') + '.phoneValidationPresets');
    if (storePhoneValidationPresets) {
      try {
        phoneValidationPresets = JSON.parse(storePhoneValidationPresets).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }

    _this.validation = {
      country: (0, _react.createRef)(),
      identity: (0, _react.createRef)(),
      title: (0, _react.createRef)(),
      name: (0, _react.createRef)(),
      preferredName: (0, _react.createRef)(),
      email: (0, _react.createRef)(),
      mobilePrefix: (0, _react.createRef)(),
      mobile: (0, _react.createRef)(),
      phone: (0, _react.createRef)(),
      monthlyIncome: (0, _react.createRef)(),
      raceOther: (0, _react.createRef)(),
      emergencyContactMobilePrefix: (0, _react.createRef)(),
      emergencyContactMobile: (0, _react.createRef)(),
      emergencyContactEmail: (0, _react.createRef)(),
      taxIdentificationNo: (0, _react.createRef)()
    };

    // add validateRef for all enabled address settings
    var enabledAddressSettings = props.addressSettings.data.filter(function (as) {
      return as.enabled;
    });
    if (enabledAddressSettings && enabledAddressSettings.length > 0) {
      enabledAddressSettings.forEach(function (as) {
        var key = _lodash2.default.camelCase(as.columnName);
        _this.validation[key] = (0, _react.createRef)();
      });
    }

    var hideTitle = false;
    var customOptions = props.customOptions.data;
    if (customOptions.length > 0) {
      var hideTitleOpt = customOptions.find(function (o) {
        return o.name === 'hide_purchaser_title';
      });
      if (hideTitleOpt) {
        hideTitle = hideTitleOpt.value === 'true';
      }
    }
    if (hideTitle) {
      customer.title = 'Not Applicable';
    }

    _this.state = {
      customer: customer,
      errMessages: [],
      tinMessage: null,
      identityTypeOpts: identityTypeOpts,
      phoneValidationPresets: phoneValidationPresets,
      hideTitle: hideTitle,
      tinError: tinError,
      // flag to enable/disable tin searched using the lhdn api
      tinFound: false
    };
    return _this;
  }

  _createClass(CustomerForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var customer = this.state.customer;


      var hideTitle = false;
      var customOptions = nextProps.customOptions.data;
      if (customOptions.length > 0) {
        var hideTitleOpt = customOptions.find(function (o) {
          return o.name === 'hide_purchaser_title';
        });
        if (hideTitleOpt) {
          hideTitle = hideTitleOpt.value === 'true';
        }
      }
      if (hideTitle) {
        customer.title = 'Not Applicable';
      }
      this.setState({
        customer: customer,
        hideTitle: hideTitle
      });
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'validateTIN',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tinInput) {
        var _state$customer, identityTypeID, identity, idType, query, store, res, errorMessage, _errorMessage;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _state$customer = this.state.customer, identityTypeID = _state$customer.identityTypeID, identity = _state$customer.identity;

                if (!(!tinInput || !identityTypeID || !identity)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                idType = (0, _identityTypes.getIdentityTypeOpts)().find(function (i) {
                  return i.value === identityTypeID;
                }).tin_code;
                query = Object.assign({
                  tin: tinInput,
                  idType: idType,
                  idValue: identity
                });
                store = this.context.store;
                _context.prev = 6;
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/tin/validate/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Origin': this.state.origin
                  }
                }));

              case 9:
                res = _context.sent;

                if (!(res && res.ok)) {
                  _context.next = 14;
                  break;
                }

                this.setState({
                  tinError: false,
                  tinFound: true,
                  tinMessage: null
                });
                _context.next = 19;
                break;

              case 14:
                _context.next = 16;
                return res.text();

              case 16:
                errorMessage = _context.sent;

                this.setState({
                  tinError: true,
                  tinFound: false,
                  tinMessage: errorMessage
                });
                return _context.abrupt('return');

              case 19:
                _context.next = 28;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context['catch'](6);

                if (!_context.t0.res) {
                  _context.next = 28;
                  break;
                }

                _context.next = 26;
                return _context.t0.res.text();

              case 26:
                _errorMessage = _context.sent;

                this.setState({
                  tinError: true,
                  tinFound: false,
                  tinMessage: _errorMessage
                });

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 21]]);
      }));

      function validateTIN(_x2) {
        return _ref.apply(this, arguments);
      }

      return validateTIN;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var customer = this.state.customer;
      var _props = this.props,
          addressSettings = _props.addressSettings,
          auth = _props.auth,
          t = _props.t;

      var enabledAddressSettings = addressSettings.data.filter(function (as) {
        return as.enabled;
      });
      var isMalaysia = auth && auth.company.countryCode.toUpperCase() === 'MY';
      var isIndonesia = auth && auth.company.countryCode.toUpperCase() === 'ID';
      var isVietnam = auth && auth.company.countryCode.toUpperCase() === 'VN';
      var isMalaysiaAddress = customer.country.toUpperCase() === 'MY';
      var mustValidTin = customer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN;

      var tinValidation = [];
      if (isIndonesia) {
        tinValidation = [{
          validate: _webValidations.matchRegex,
          option: { validRegex: _regex.REGEX_NPWP_ID }
        }];
      } else if (isMalaysia) {
        // For Malaysia, validation is optional unless tinRequired is true
        var tinRules = [{
          validate: _webValidations.matchRegex,
          option: { validRegex: _regex.REGEX_TIN_VALID }
        }];
        if (this.state.tinRequired) {
          tinRules.unshift(_webValidations.required);
        }
        tinValidation = tinRules;
      }

      var inputs = enabledAddressSettings.map(function (as, idx) {
        var key = _lodash2.default.camelCase(as.columnName);
        var addressLabel = as.label.toLowerCase();
        var isRequired = as.required;
        var validations = [{
          validate: _webValidations.stringLength,
          option: {
            max: 256
          }
        }];

        // When company is Vietnam: apply country-dependent logic for state field
        if (isVietnam && addressLabel === 'state') {
          if (isMalaysiaAddress) {
            // Malaysia selected: keep as "State", required
            isRequired = true;
          } else {
            // Non-Malaysia selected: change to "City/Province", optional
            addressLabel = 'cityOrProvince';
            isRequired = false;
          }
        } else if (isVietnam && addressLabel === 'city' && !isMalaysiaAddress) {
          addressLabel = 'ward';
          isRequired = false;
        } else if (isVietnam && addressLabel === 'postcode' && !isMalaysiaAddress) {
          addressLabel = 'postalCode';
          isRequired = false;
        }

        if (isRequired) {
          validations.push(_webValidations.required);
        }
        var label = '' + (0, _translation2.translateModels)(t, addressLabel, 'project') + (isRequired ? '*' : '');

        if (isMalaysiaAddress && as.label.toLowerCase() === 'state') {
          return _react2.default.createElement(
            _AppForm2.default.Validate,
            {
              key: idx,
              validation: isRequired ? [_webValidations.required] : null,
              ref: _this2.validation[key],
              onChange: _this2.handleChange,
              validateLabel: addressLabel
            },
            _react2.default.createElement(_semanticUiReact.Form.Select, {
              name: key,
              fluid: true,
              options: _states2.default,
              placeholder: t('Select', { ns: _translation.TRANSLATION_FILES.translation }) + ' ' + label.toLowerCase(),
              label: label,
              search: true,
              selectOnBlur: false,
              value: customer[key]
            })
          );
        }

        return _react2.default.createElement(_AppForm2.default.Input, {
          key: idx,
          autoComplete: 'off',
          name: key,
          onChange: _this2.handleChange,
          placeholder: label,
          label: label,
          ref: _this2.validation[key],
          validation: validations,
          value: customer[key],
          validateLabel: addressLabel
        });
      });
      inputs.push(_react2.default.createElement(_semanticUiReact.Form.Select, {
        key: 'inputs_region',
        label: (0, _translation2.translateModels)(t, 'region', 'project'),
        name: 'region',
        placeholder: t('Select {{title}}', { title: (0, _translation2.translateModels)(t, 'region', 'project') }),
        search: true,
        fluid: true,
        onChange: this.handleChange,
        value: customer.region,
        options: [],
        noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
      }), _react2.default.createElement(
        _AppForm2.default.Validate,
        {
          key: 'inputs_country',
          validation: [_webValidations.required],
          ref: this.validation.country,
          onChange: function onChange(e, stateData) {
            // Reset state input field
            var as = enabledAddressSettings.find(function (a) {
              return a.label.toLowerCase() === 'state';
            });
            if (as) {
              var key = _lodash2.default.camelCase(as.columnName);
              if (customer[key]) {
                customer[key] = '';
                _this2.setState({ customer: customer });
              }
            }
            _this2.handleChange(e, stateData);
          },
          validateLabel: (0, _translation2.translateModels)(t, 'country', 'customer')
        },
        _react2.default.createElement(_semanticUiReact.Form.Select, {
          autoComplete: 'off',
          fluid: true,
          name: 'country',
          options: _countries.SELECT_COUNTRIES,
          placeholder: t('Select Country') + '*',
          label: (0, _translation2.translateModels)(t, 'country', 'customer') + '*',
          search: true,
          selectOnBlur: false,
          value: customer.country,
          noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
        })
      ));
      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref2) {
            _this2.form = _ref2;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  null,
                  _react2.default.createElement(_semanticUiReact.Form.Select, {
                    fluid: true,
                    onChange: this.handleChange,
                    label: (0, _translation2.translateModels)(t, 'identityTypeID', 'customer') + '*',
                    placeholder: (0, _translation2.translateModels)(t, 'identityTypeID', 'customer') + '*',
                    name: 'identityTypeID',
                    options: this.state.identityTypeOpts.map(function (i) {
                      return _extends({}, i, {
                        text: t(i.text, { ns: _translation.TRANSLATION_FILES.screens })
                      });
                    }),
                    selection: true,
                    selectOnBlur: false,
                    value: customer.identityTypeID,
                    noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  null,
                  _react2.default.createElement(_AppForm2.default.Input, {
                    name: 'identity',
                    disabled: customer.identityTypeID === ''
                    // temporary remove validation
                    // validation={[required, {
                    //   validate: ValidateIdentity,
                    //   option: this.identityValidation(),
                    // }]}
                    , ref: this.validation.identity,
                    onChange: this.handleChange,
                    validateLabel: (0, _translation2.translateModels)(t, 'identity', 'customer'),
                    placeholder: this.getIdentityPlaceholder(customer.identityTypeID, customer.identityPresetLabel),
                    label: this.getIdentityPlaceholder(customer.identityTypeID, customer.identityPresetLabel),
                    type: 'text',
                    value: customer.identity
                  })
                ),
                (isMalaysia || isIndonesia) && _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  null,
                  _react2.default.createElement(_TinFieldInput2.default, {
                    isIndonesia: isIndonesia,
                    value: customer.taxIdentificationNo,
                    errMessage: this.state.tinMessage,
                    isLoading: this.state.validatingTin,
                    tinError: isMalaysia && this.state.tinError,
                    required: isMalaysia && mustValidTin && !customer.isForeignCompany,
                    ref: this.validation.taxIdentificationNo,
                    onChange: this.handleTinInput,
                    validation: tinValidation
                    // readOnly={isMalaysia && this.state.tinFound}
                    , identityType: customer.identityTypeID,
                    identityValue: customer.identity
                  })
                )
              ),
              isMalaysia && customer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && _react2.default.createElement(
                _semanticUiReact.Form.Group,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  null,
                  _react2.default.createElement(
                    'div',
                    { style: { display: 'flex', justifyContent: 'start' } },
                    _react2.default.createElement(_semanticUiReact.Checkbox, {
                      label: t('Foreign Company', { ns: _translation.TRANSLATION_FILES.screens }),
                      onChange: function onChange(e, d) {
                        var setStateTin = d.checked ? _tin.FOREIGN_BUYER_GENERIC_TIN : '';
                        _this2.setState(function (prevState) {
                          return {
                            customer: _extends({}, prevState.customer, {
                              taxIdentificationNo: setStateTin,
                              isForeignCompany: d.checked
                            })
                          };
                        }, function () {
                          _this2.handleTinInput({ target: { value: d.checked ? _this2.state.customer.taxIdentificationNo : '', tinFound: false } });
                        });
                      },
                      checked: this.state.customer.isForeignCompany
                    })
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                this.state.hideTitle ? null : _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    validation: [_webValidations.required],
                    ref: this.validation.title,
                    onChange: this.handleChange,
                    validateLabel: (0, _translation2.translateModels)(t, 'title', 'customer')
                  },
                  _react2.default.createElement(_semanticUiReact.Form.Select, {
                    name: 'title',
                    onChange: this.handleChange,
                    options: _customerTitles2.default.map(function (i) {
                      return _extends({}, i, {
                        text: t(i.text, { ns: _translation.TRANSLATION_FILES.constants })
                      });
                    }),
                    label: t('Select Title') + '*',
                    placeholder: t('Select Title') + '*',
                    search: true,
                    selectOnBlur: false,
                    value: customer.title,
                    noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                  })
                ),
                _react2.default.createElement(_AppForm2.default.Input, {
                  autoComplete: 'off',
                  name: 'name',
                  onChange: this.handleChange,
                  placeholder: t(customer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? 'Company Name' : 'Full Name') + '*',
                  label: t(customer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? 'Company Name' : 'Full Name') + '*',
                  ref: this.validation.name,
                  validation: [_webValidations.required].concat(_toConsumableArray((0, _vietnam.vnFullNameValidations)(auth, customer.identityTypeID, t))),
                  value: customer.name,
                  validateLabel: t(customer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? 'Company Name' : 'Full Name')
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  autoComplete: 'off',
                  name: 'preferredName',
                  onChange: this.handleChange,
                  placeholder: t(customer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? 'Contact Person' : 'Preferred Name') + '*',
                  label: t(customer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? 'Contact Person' : 'Preferred Name') + '*',
                  ref: this.validation.preferredName,
                  validation: customer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? [_webValidations.required].concat(_toConsumableArray((0, _vietnam.vnPreferredNameValidations)(auth, t))) : [_webValidations.required, {
                    validate: _webValidations.stringLength,
                    option: {
                      max: 15
                    }
                  }].concat(_toConsumableArray((0, _vietnam.vnPreferredNameValidations)(auth, t))),
                  value: customer.preferredName,
                  validateLabel: t(customer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? 'Contact Person' : 'Preferred Name')
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  autoComplete: 'off',
                  name: 'email',
                  onChange: this.handleChange,
                  placeholder: (0, _translation2.translateModels)(t, 'email', 'customer'),
                  label: (0, _translation2.translateModels)(t, 'email', 'customer'),
                  validation: [_webValidations.email],
                  ref: this.validation.email,
                  value: customer.email,
                  validateLabel: (0, _translation2.translateModels)(t, 'email', 'customer')
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    validation: [_webValidations.required],
                    ref: this.validation.mobilePrefix,
                    onChange: this.handleChange,
                    validateLabel: (0, _translation2.translateModels)(t, 'mobilePrefix', 'customer')
                  },
                  _react2.default.createElement(_semanticUiReact.Form.Select, {
                    name: 'mobilePrefix',
                    onChange: this.handleChange,
                    options: _intlCallCodes2.default,
                    label: (0, _translation2.translateModels)(t, 'mobilePrefix', 'customer'),
                    search: true,
                    selectOnBlur: false,
                    value: customer.mobilePrefix,
                    noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                  })
                ),
                _react2.default.createElement(_PhoneInput2.default, {
                  autoComplete: 'off',
                  name: 'mobile',
                  onChange: this.handleChange,
                  label: customer.mobilePrefix === '60' ? (0, _translation2.translateModels)(t, 'mobile', 'customer') + '* (e.g. 196756118)' : (0, _translation2.translateModels)(t, 'mobile', 'customer') + '*',
                  placeholder: customer.mobilePrefix === '60' ? (0, _translation2.translateModels)(t, 'mobile', 'customer') + '* (e.g. 196756118)' : (0, _translation2.translateModels)(t, 'mobile', 'customer') + '*',
                  prefix: customer.mobilePrefix,
                  ref: this.validation.mobile,
                  type: 'tel',
                  validation: [_webValidations.required, {
                    validate: _webValidations.phoneNumber,
                    option: customer.mobilePrefix === 'other' ? {} : {
                      isMobile: true,
                      phonePrefix: customer.mobilePrefix,
                      validRegex: (0, _phone.getPhoneValidRegex)(this.state.phoneValidationPresets, customer.mobilePrefix, 'mobile')
                    }
                  }],
                  value: customer.mobile,
                  validateLabel: (0, _translation2.translateModels)(t, 'mobile', 'customer')
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_semanticUiReact.Form.Select, {
                  name: 'phonePrefix',
                  onChange: this.handleChange,
                  options: _intlCallCodes2.default,
                  label: (0, _translation2.translateModels)(t, 'phonePrefix', 'customer'),
                  search: true,
                  selectOnBlur: false,
                  value: customer.phonePrefix,
                  noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                }),
                _react2.default.createElement(_PhoneInput2.default, {
                  autoComplete: 'off',
                  name: 'phone',
                  onChange: this.handleChange,
                  placeholder: customer.phonePrefix === '60' ? (0, _translation2.translateModels)(t, 'phone', 'customer') + ' (e.g. 196756118)' : t('House/Office Phone'),
                  label: customer.phonePrefix === '60' ? (0, _translation2.translateModels)(t, 'phone', 'customer') + ' (e.g. 196756118)' : t('House/Office Phone'),
                  prefix: customer.phonePrefix,
                  ref: this.validation.phone,
                  type: 'tel',
                  value: customer.phone,
                  validation: [{
                    validate: _webValidations.phoneNumber,
                    option: customer.phonePrefix === 'other' ? {} : {
                      phonePrefix: customer.phonePrefix,
                      validRegex: (0, _phone.getPhoneValidRegex)(this.state.phoneValidationPresets, customer.phonePrefix, 'phone')
                    }
                  }],
                  validateLabel: t('House/Office Phone')
                })
              ),

              // group 2 inputs into one Form.Group
              // https://stackoverflow.com/questions/49491452/map-an-array-by-every-two-elements
              _lodash2.default.chunk(inputs, 2).map(function (p, idx) {
                return _react2.default.createElement(
                  _semanticUiReact.Form.Group,
                  { widths: 'equal', key: 'group_' + idx },
                  p
                );
              }),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  autoComplete: 'off',
                  name: 'jobTitle',
                  onChange: this.handleChange,
                  placeholder: (0, _translation2.translateModels)(t, 'jobTitle', 'customer'),
                  label: (0, _translation2.translateModels)(t, 'jobTitle', 'customer'),
                  value: customer.jobTitle
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  type: 'number',
                  autoComplete: 'off',
                  name: 'monthlyIncome',
                  onChange: this.handleChange,
                  placeholder: (0, _translation2.translateModels)(t, 'monthlyIncome', 'customer'),
                  label: (0, _translation2.translateModels)(t, 'monthlyIncome', 'customer'),
                  ref: this.validation.monthlyIncome,
                  validation: [{
                    validate: _webValidations.numericRange,
                    option: {
                      min: 0
                    }
                  }],
                  value: customer.monthlyIncome,
                  validateLabel: (0, _translation2.translateModels)(t, 'monthlyIncome', 'customer')
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_semanticUiReact.Form.Select, {
                  name: 'nationality',
                  onChange: this.handleChange,
                  options: _countries.SELECT_NATIONALITY,
                  label: (0, _translation2.translateModels)(t, 'nationality', 'customer'),
                  placeholder: (0, _translation2.translateModels)(t, 'nationality', 'customer'),
                  search: true,
                  selectOnBlur: false,
                  selection: true,
                  value: customer.nationality,
                  noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                }),
                _react2.default.createElement(_InputBirthdate2.default, {
                  date: customer.birthdate,
                  onSelectDay: this.handleBirthdateSelect,
                  label: (0, _translation2.translateModels)(t, 'birthdate', 'customer'),
                  disabled: customer.identityTypeID === 4
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_semanticUiReact.Form.Select, {
                  name: 'gender',
                  onChange: this.handleChange,
                  options: _gender.GENDER.map(function (o) {
                    return _extends({}, o, {
                      text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants })
                    });
                  }),
                  label: (0, _translation2.translateModels)(t, 'gender', 'customer'),
                  placeholder: t('Select Gender'),
                  search: true,
                  selectOnBlur: false,
                  selection: true,
                  value: customer.gender,
                  noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                }),
                _react2.default.createElement(_semanticUiReact.Form.Select, {
                  name: 'maritalStatus',
                  onChange: this.handleChange,
                  options: _maritalStatus.MARITAL_STATUS.map(function (o) {
                    return _extends({}, o, {
                      text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants })
                    });
                  }),
                  label: (0, _translation2.translateModels)(t, 'maritalStatus', 'customer'),
                  placeholder: t('Select Marital Status'),
                  search: true,
                  selectOnBlur: false,
                  selection: true,
                  value: customer.maritalStatus,
                  noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  autoComplete: 'off',
                  name: 'emergencyContactName',
                  onChange: this.handleChange,
                  placeholder: (0, _translation2.translateModels)(t, 'emergencyContactName', 'customer'),
                  label: (0, _translation2.translateModels)(t, 'emergencyContactName', 'customer'),
                  value: customer.emergencyContactName
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  autoComplete: 'off',
                  name: 'emergencyContactRelation',
                  onChange: this.handleChange,
                  placeholder: (0, _translation2.translateModels)(t, 'emergencyContactRelation', 'customer'),
                  label: (0, _translation2.translateModels)(t, 'emergencyContactRelation', 'customer'),
                  value: customer.emergencyContactRelation
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    ref: this.validation.emergencyContactMobilePrefix,
                    onChange: this.handleChange,
                    validateLabel: (0, _translation2.translateModels)(t, 'emergencyContactMobilePrefix', 'customer')
                  },
                  _react2.default.createElement(_semanticUiReact.Form.Select, {
                    label: (0, _translation2.translateModels)(t, 'emergencyContactMobilePrefix', 'customer'),
                    name: 'emergencyContactMobilePrefix',
                    onChange: this.handleChange,
                    options: _intlCallCodes2.default,
                    search: true,
                    selectOnBlur: false,
                    value: customer.emergencyContactMobilePrefix,
                    noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                  })
                ),
                _react2.default.createElement(_PhoneInput2.default, {
                  autoComplete: 'off',
                  label: (0, _translation2.translateModels)(t, 'emergencyContactMobile', 'customer'),
                  name: 'emergencyContactMobile',
                  onChange: this.handleChange,
                  placeholder: (0, _translation2.translateModels)(t, 'emergencyContactMobile', 'customer'),
                  prefix: customer.emergencyContactMobilePrefix,
                  ref: this.validation.emergencyContactMobile,
                  type: 'tel',
                  validation: [{
                    validate: _webValidations.phoneNumber,
                    option: customer.emergencyContactMobilePrefix === 'other' ? {} : {
                      isMobile: true,
                      phonePrefix: customer.emergencyContactMobilePrefix,
                      validRegex: (0, _phone.getPhoneValidRegex)(this.state.phoneValidationPresets, customer.emergencyContactMobilePrefix, 'mobile')
                    }
                  }],
                  value: customer.emergencyContactMobile,
                  validateLabel: (0, _translation2.translateModels)(t, 'emergencyContactMobile', 'customer')
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  autoComplete: 'off',
                  label: (0, _translation2.translateModels)(t, 'emergencyContactEmail', 'customer'),
                  name: 'emergencyContactEmail',
                  type: 'email',
                  onChange: this.handleChange,
                  placeholder: (0, _translation2.translateModels)(t, 'emergencyContactEmail', 'customer'),
                  validation: [_webValidations.email],
                  ref: this.validation.emergencyContactEmail,
                  value: customer.emergencyContactEmail
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  autoComplete: 'off',
                  name: 'emergencyContactIdentity',
                  onChange: this.handleChange,
                  placeholder: (0, _translation2.translateModels)(t, 'emergencyContactIdentity', 'customer'),
                  label: (0, _translation2.translateModels)(t, 'emergencyContactIdentity', 'customer'),
                  value: customer.emergencyContactIdentity
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                  label: (0, _translation2.translateModels)(t, 'internalRemark', 'customer'),
                  placeholder: (0, _translation2.translateModels)(t, 'internalRemark', 'customer'),
                  name: 'internalRemark',
                  value: customer.internalRemark,
                  onChange: this.handleChange
                })
              )
            )
          )
        )
      );
    }
  }]);

  return CustomerForm;
}(_react.Component);

CustomerForm.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    company: _propTypes2.default.object
  }),
  addressSettings: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  customOptions: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  t: _propTypes2.default.func
};
CustomerForm.contextTypes = {
  store: _propTypes2.default.object
};
CustomerForm.defaultValues = {
  identityTypeID: '',
  identity: '',
  identityPresetID: '',
  identityPresetLabel: '',
  identityPresetRegex: '',
  taxIdentificationNo: '',
  taxTinValidationStatus: '',
  title: '',
  name: '',
  preferredName: '',
  email: '',
  mobilePrefix: '60',
  mobile: '',
  phonePrefix: '60',
  phone: '',
  address1: '',
  address2: '',
  address3: '',
  address4: '',
  address5: '',
  address6: '',
  address7: '',
  address8: '',
  address9: '',
  address10: '',
  country: 'my',
  internalRemark: '',
  jobTitle: '',
  monthlyIncome: '',
  nationality: '',
  gender: '',
  race: '',
  raceOther: '',
  bumi: 'Not Applicable',
  maritalStatus: '',
  emergencyContactName: '',
  emergencyContactRelation: '',
  emergencyContactMobilePrefix: '60',
  emergencyContactMobile: '',
  emergencyContactEmail: '',
  emergencyContactIdentity: '',
  isForeignCompany: false
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var loadingType = arguments[1];
    return new Promise(function (res) {
      if (loadingType === 'validatingTIN') {
        _this3.setState({ validatingTin: loading }, res);
      }
    });
  };

  this.getIdentityPlaceholder = function (identityTypeID, identityLabel) {
    var t = _this3.props.t;

    if (identityTypeID === '') {
      return t('Select Identity Type first') + '*';
    }
    if (typeof identityTypeID === 'string') {
      var identityTypeOpts = _this3.state.identityTypeOpts;

      var idx = identityTypeOpts.findIndex(function (i) {
        return i.value === identityTypeID;
      });
      if (idx !== -1) {
        return t('{{identity}} number', { identity: identityTypeOpts[idx].text }) + '*';
      }
    }
    switch (identityTypeID) {
      case 2:
        return t('Passport Number') + '*';
      case 4:
        return t('Company Registration Number') + '*';
      case 6:
        return t('{{identity}} number', { identity: identityLabel }) + '*';
      default:
        return t('Identity Number') + '*';
    }
  };

  this.handleSubmit = function (event) {
    event.preventDefault();
    var _state = _this3.state,
        customer = _state.customer,
        identityTypeOpts = _state.identityTypeOpts;

    return _AppForm2.default.validate(_this3.validation, customer).then(function (validations) {
      _this3.setState({
        errMessages: validations.filter(function (v) {
          return !v.isValid;
        })
      });

      if (customer.identityTypeID && typeof customer.identityTypeID === 'string') {
        var idx = -1;
        if (identityTypeOpts && identityTypeOpts.length > 0) {
          idx = identityTypeOpts.findIndex(function (i) {
            return i.value === customer.identityTypeID;
          });
        }
        if (idx !== -1) {
          customer.identityTypeID = 6;
          customer.identityPresetID = identityTypeOpts[idx].value;
          customer.identityPresetLabel = identityTypeOpts[idx].text;
          customer.identityPresetRegex = identityTypeOpts[idx]['data-regex'];
        }
      }
      var store = _this3.context.store;

      customer.taxTinValidationStatus = _this3.state.tinError === false ? 'success' : 'failed';
      if (customer.taxTinValidationStatus !== 'success' && customer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && !customer.isForeignCompany) {
        store.dispatch((0, _flash.flashMessage)({
          header: 'Invalid TIN',
          message: 'Tax Identification Number is invalid',
          icon: 'warning sign',
          type: 'error',
          autoHideDuration: 5000
        }));
        return;
      }

      var customerDetail = {
        title: _this3.state.hideTitle ? 'Not Applicable' : customer.title,
        name: customer.name,
        preferredName: customer.preferredName,
        email: customer.email,
        mobilePrefix: customer.mobilePrefix,
        mobile: customer.mobile,
        phonePrefix: customer.phonePrefix,
        phone: customer.phone,
        address1: customer.address1,
        address2: customer.address2,
        address3: customer.address3,
        address4: customer.address4,
        address5: customer.address5,
        address6: customer.address6,
        address7: customer.address7,
        address8: customer.address8,
        address9: customer.address9,
        address10: customer.address10,
        country: customer.country,
        jobTitle: customer.jobTitle,
        monthlyIncome: parseFloat(customer.monthlyIncome),
        nationality: customer.nationality,
        birthdate: customer.birthdate,
        gender: customer.gender,
        race: customer.race.toUpperCase() === 'Others'.toUpperCase() ? customer.raceOther : customer.race,
        bumi: customer.bumi,
        maritalStatus: customer.maritalStatus,
        emergencyContactName: customer.emergencyContactName,
        emergencyContactRelation: customer.emergencyContactRelation,
        emergencyContactMobilePrefix: customer.emergencyContactMobilePrefix,
        emergencyContactMobile: customer.emergencyContactMobile,
        emergencyContactEmail: customer.emergencyContactEmail,
        emergencyContactIdentity: customer.emergencyContactIdentity
      };
      var postCustomer = {
        customerDetail: customerDetail,
        identityTypeID: customer.identityTypeID,
        identity: customer.identity,
        identityPresetID: customer.identityPresetID,
        identityPresetLabel: customer.identityPresetLabel,
        identityPresetRegex: customer.identityPresetRegex,
        taxIdentificationNo: customer.taxIdentificationNo,
        taxTinValidationStatus: customer.taxTinValidationStatus,
        internalRemark: customer.internalRemark,
        isForeignCompany: customer.isForeignCompany
      };
      _this3.props.onSubmit(validations, postCustomer);
    });
  };

  this.handleChange = function (event, value) {
    var auth = _this3.props.auth;

    var isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    var customer = _this3.state.customer;

    customer[value.name] = value.value;
    if (value.name === 'race' && customer.race.toUpperCase() !== 'Others'.toUpperCase()) {
      customer.raceOther = '';
    }
    if (value.name === 'identity' && customer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_NRIC && value.value.length === 12) {
      var dfIC = (0, _dateFromIC2.default)(value.value.substring(0, 6));
      if (dfIC) {
        var mBirthdate = _momentTimezone2.default.tz(dfIC, _config2.default.get('tzName'));
        if (mBirthdate.isValid()) {
          customer.birthdate = mBirthdate.format('YYYY-MM-DD').toString();
        }
      }
    }
    if (value.name === 'identityTypeID' && value.value === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN) {
      customer.title = 'Not Applicable';
      customer.nationality = 'Not Applicable';
      customer.gender = 'Not Applicable';
      customer.race = 'Not Applicable';
      customer.bumi = 'Not Applicable';
      customer.maritalStatus = 'Not Applicable';
      customer.birthdate = '';
    } else if (value.name === 'identityTypeID' && value.value !== _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && customer.title === 'Not Applicable') {
      customer.title = _this3.state.hideTitle ? 'Not Applicable' : '';
      customer.nationality = '';
      customer.gender = '';
      customer.race = '';
      customer.bumi = 'Not Applicable';
      customer.maritalStatus = '';
    }
    if (isMalaysia) {
      if (value.name === 'identityTypeID') {
        customer.isForeignCompany = false;
        customer.taxIdentificationNo = (0, _tin.getAutoFillTin)(customer.identityTypeID, customer.isForeignCompany);
      }
    }
    _this3.setState({ customer: customer, tinMessage: null, tinError: false, tinFound: false }, function () {
      // Validate value again on identityTypeID change
      if (value.name === 'identityTypeID') {
        // Validate identity
        if (_this3.validation.identity && _this3.validation.identity.current && customer.identity !== '') {
          _this3.validation.identity.current.validate(customer.identity);
        }

        // Validate pref name | contact persion
        if (_this3.validation.preferredName && _this3.validation.preferredName.current && customer.preferredName !== '') {
          _this3.validation.preferredName.current.validate(customer.preferredName);
        }
        // CPI-1319: the VN no-digits rule on Full Name depends on the identity type.
        if (_this3.validation.name && _this3.validation.name.current && customer.name !== '') {
          _this3.validation.name.current.validate(customer.name);
        }
        if (customer.taxIdentificationNo !== '') {
          _this3.handleTinInput({ target: { value: customer.taxIdentificationNo } });
        }
      }
      if (value.name === 'identity' && customer.taxIdentificationNo !== '') {
        _this3.handleTinInput({ target: { value: customer.taxIdentificationNo } });
      }
      // Validate mobile on prefix change
      if (_this3.validation.mobile && _this3.validation.mobile.current && value.name === 'mobilePrefix') {
        _this3.validation.mobile.current.validate(customer.mobile);
      }
      // Validate phone on prefix change
      if (_this3.validation.phone && _this3.validation.phone.current && value.name === 'phonePrefix') {
        _this3.validation.phone.current.validate(customer.phone);
      }
      _this3.handleCheckChanges();
    });
  };

  this.handleBirthdateSelect = function (day) {
    var customer = _this3.state.customer;

    customer.birthdate = day;
    _this3.setState({ customer: customer });
  };

  this.handleTinInput = function (e) {
    var customer = _this3.state.customer;
    var auth = _this3.props.auth;

    var isIndonesia = auth && auth.company && auth.company.countryCode && auth.company.countryCode.toUpperCase() === 'ID';
    if (isIndonesia) {
      customer.taxIdentificationNo = e.target.value;
      _this3.setState({ customer: customer }, function () {
        _this3.handleCheckChanges();
      });
      return;
    }

    var tinInput = e.target.value.toUpperCase();
    var tinFound = e.target.tinFound;
    var isAlphanumeric = /^[a-zA-Z0-9]*$/.test(tinInput);

    if (tinInput === '') {
      customer.taxIdentificationNo = '';
      _this3.setState({ customer: customer, tinFound: false, tinError: false, tinMessage: null });
      return;
    }

    if (isAlphanumeric) {
      customer.taxIdentificationNo = tinInput;
      _this3.setState({ customer: customer, tinFound: tinFound, tinError: tinFound === false, tinMessage: _this3.state.tinMessage }, function () {
        _this3.handleCheckChanges();
      });
      if (tinFound) {
        return;
      }
      // 1~2 letter followed by numeric with length 9 - 11
      var matched = _regex.REGEX_TIN_VALID.test(tinInput);
      var genericTin = (0, _tin.getGenericTinByIdTypeAndTinNo)(customer.identityTypeID, tinInput, customer.isForeignCompany);
      _this3.setLoading(true, 'validatingTIN').then(function () {
        if (_this3.debounceTimeout) {
          clearTimeout(_this3.debounceTimeout);
        }
        _this3.debounceTimeout = setTimeout(function () {
          if (matched) {
            if (tinInput === _tin.GOVERNMENT_GENERIC_TIN) {
              var isForeign = !(0, _tin.isForeignIdType)(customer.identityTypeID, customer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && customer.isForeignCompany);
              _this3.setState({
                tinError: !isForeign,
                tinFound: !isForeign,
                tinMessage: !isForeign ? _tin.GENERIC_TIN_UNMATCHED_ERROR_MSG : null }, function () {
                _this3.setLoading(false, 'validatingTIN');
              });
            } else if (_tin.GENERIC_TIN_VALUES.includes(tinInput)) {
              _this3.setState({
                tinError: !(0, _tin.isGenericTinFound)(genericTin),
                tinFound: (0, _tin.isGenericTinFound)(genericTin),
                tinMessage: !(0, _tin.isGenericTinFound)(genericTin) ? _tin.GENERIC_TIN_UNMATCHED_ERROR_MSG : null }, function () {
                _this3.setLoading(false, 'validatingTIN');
              });
            } else {
              _this3.validateTIN(tinInput).finally(function () {
                _this3.setLoading(false, 'validatingTIN');
              });
            }
          } else {
            _this3.setState({ tinError: true }, function () {
              _this3.setLoading(false, 'validatingTIN');
            });
          }
        }, 3000);
      });
    }
  };

  this.validateIdentityType = function () {
    var identityType = _this3.state.customer.identityTypeID;
    switch (identityType) {
      case 1:
        return 'ic_number';
      case 2:
        return 'passport';
      case 3:
        return 'military_police';
      case 5:
        return 'id_number';
      default:
        return 'other';
    }
  };

  this.identityValidation = function () {
    var _state2 = _this3.state,
        customer = _state2.customer,
        identityTypeOpts = _state2.identityTypeOpts;

    if (customer.identityTypeID === 6 || typeof customer.identityTypeID === 'string') {
      var idx = identityTypeOpts.findIndex(function (i) {
        return i.value === customer.identityTypeID;
      });
      var regex = '';
      if (idx !== -1) {
        regex = identityTypeOpts[idx]['data-regex'];
      }
      return {
        validRegex: regex
      };
    }
    return {
      countryCode: 'MY',
      identityType: _this3.validateIdentityType()
    };
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.customer, _translation.TRANSLATION_FILES.models.project]), { withRef: true })(CustomerForm);

/***/ }),
/* 2318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _reactRouter = __webpack_require__(18);

var _url = __webpack_require__(19);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _translation = __webpack_require__(4);

var _Filters = __webpack_require__(86);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomerList = function (_Component) {
  _inherits(CustomerList, _Component);

  function CustomerList(props) {
    _classCallCheck(this, CustomerList);

    var _this = _possibleConstructorReturn(this, (CustomerList.__proto__ || Object.getPrototypeOf(CustomerList)).call(this, props));

    _initialiseProps.call(_this);

    var state = CustomerList.getPropsToState(props);
    _this.state = _extends({}, state, {
      branches: [],
      businessUnitFilter: false
    });
    return _this;
  }

  _createClass(CustomerList, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (this.props.auth.isSuperAdmin || this.props.auth.isHeadquarters) {
        this.fetchBranches(false);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var state = CustomerList.getPropsToState(nextProps);
      this.setState(_extends({}, state), function () {
        var query = nextProps.location.query;

        if (query.projectBranchOwnerID && query.projectBranchOwnerID.length > 0) {
          _this2.setState({
            advanceFilter: true
          });
        }
      });
    }
  }, {
    key: 'setCustomers',
    value: function setCustomers() {
      var _this3 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this3.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this4 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this4.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this5 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this5.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchBranches',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var store, t, res, message, branches;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (silent) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context.prev = 6;
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/search/company_branches/?page=all&isExternal=false', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context.sent;
                _context.next = 21;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                Bugsnag.notifyException(_context.t0);
                _context.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                if (silent) {
                  _context.next = 20;
                  break;
                }

                _context.next = 20;
                return this.setLoading(false);

              case 20:
                return _context.abrupt('return');

              case 21:
                if (res.ok) {
                  _context.next = 29;
                  break;
                }

                _context.next = 24;
                return res.text();

              case 24:
                message = _context.sent;
                _context.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 27:
                _context.next = 34;
                break;

              case 29:
                _context.next = 31;
                return res.json();

              case 31:
                branches = _context.sent;
                _context.next = 34;
                return this.setComponentState({
                  branches: branches ? branches.map(function (ul) {
                    var branch = { id: ul.id, text: ul.shortName, name: ul.shortName, value: ul.id.toString(), description: ul.isExternal ? 'Agency' : '' };
                    return branch;
                  }) : []
                });

              case 34:
                if (silent) {
                  _context.next = 37;
                  break;
                }

                _context.next = 37;
                return this.setLoading(false);

              case 37:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));

      function fetchBranches() {
        return _ref.apply(this, arguments);
      }

      return fetchBranches;
    }()
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      store.dispatch((0, _reactRouterRedux.replace)('/customers/?' + (0, _url.encodeSearch)(query)));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var branches = this.state.branches;
      var store = this.context.store;
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Customers'),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              primary: true,
              icon: 'add',
              content: t('Customer'),
              disabled: this.state.loading,
              onClick: function onClick() {
                return store.dispatch((0, _reactRouterRedux.push)('/customers/new/'));
              }
            })
          )
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _SearchFilter2.default,
                {
                  advanceFilter: this.state.advanceFilter,
                  isLoading: this.state.loading,
                  onChange: this.handleFilterOnChange,
                  onClose: this.handleClearFilter,
                  search: this.state.search,
                  setAdvanceFilter: this.handleSetAdvanceFilter,
                  leftNav: _react2.default.createElement(_PageNav2.default, {
                    currentPage: this.state.currentPage,
                    count: this.state.count,
                    limit: this.state.limit,
                    offset: this.state.offset,
                    dataSize: this.state.data.length,
                    loading: this.state.loading,
                    onChange: this.handleChangePage
                  }),
                  rightNav: _react2.default.createElement(_SortButton2.default, {
                    floated: 'right',
                    loading: this.state.loading,
                    items: this.sortItems,
                    onSort: this.handleSortData
                  })
                },
                this.hasAccess() && _react2.default.createElement(_Filters.SelectList, {
                  filterName: 'projectBranchOwnerID',
                  headerText: null,
                  onChange: this.handleFilterOnChange,
                  onClose: this.handleClearFilter,
                  options: this.state.branches,
                  placeholder: t('Select Business Unit'),
                  value: this.state.projectBranchOwnerID,
                  hasSearch: true,
                  onFocus: this.state.businessUnitFilter
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { paddingTop: '0px' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                {
                  inverted: true, style: { zIndex: 20 },
                  active: this.state.loading && this.state.data.length > 0
                },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table,
                {
                  celled: true,
                  compact: true
                },
                _react2.default.createElement(
                  _semanticUiReact.Table.Header,
                  { className: 'mobile-hide' },
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      { width: '4' },
                      t('Name')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Mobile')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Email')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Created Date')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Created By')
                    ),
                    this.hasAccess() && _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Business Unit')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Total Bookings')
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Body,
                  null,
                  this.state.data.length > 0 ? this.state.data.filter(function (data) {
                    return data.customerDetail.name !== '';
                  }).map(function (data, idx) {
                    return _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      {
                        key: idx
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { width: '4' },
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { to: '/customers/' + data.id + '/' },
                          data.customerDetail.title === 'Not Applicable' ? '' : t(data.customerDetail.title, { ns: _translation.TRANSLATION_FILES.constants }),
                          ' ',
                          data.customerDetail.name
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        '+',
                        data.customerDetail.mobilePrefix,
                        data.customerDetail.mobile
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { textAlign: data.customerDetail.email.length > 0 ? 'left' : 'center' },
                        data.customerDetail.email.length > 0 ? data.customerDetail.email : _react2.default.createElement(
                          'span',
                          null,
                          '-'
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(_Timestamp2.default, { format: 'DD/MM/YY hh:mm a', timestamp: data.createdAt })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _this6.hasAccess(_this6.props.auth.isBranchLeader) && data.maUserAffiliateID > 0 && (_this6.props.auth.isBranchLeader ? data.maUserAffiliateName : _react2.default.createElement(
                          _reactRouter.Link,
                          { to: '/users/' + data.maUserAffiliateID + '/' },
                          data.maUserAffiliateName
                        ))
                      ),
                      _this6.hasAccess() && _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { to: '/business_units/' + data.maOwnerCompanyBranchID + '/' },
                          _this6.getBranchShortName(data.maOwnerCompanyBranchID, branches)
                        )
                      ),
                      _react2.default.createElement(_semanticUiReact.Table.Cell, { textAlign: 'center', content: data.totalBooking })
                    );
                  }) : _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      { colSpan: '7', textAlign: 'center' },
                      this.state.loading ? _react2.default.createElement(
                        _semanticUiReact.Loader,
                        { active: true, inline: 'centered' },
                        t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                      ) : _react2.default.createElement(
                        'p',
                        null,
                        t('No customer found'),
                        '.'
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              _react2.default.createElement(_PageNav2.default, {
                upward: true,
                currentPage: this.state.currentPage,
                count: this.state.count,
                limit: this.state.limit,
                offset: this.state.offset,
                dataSize: this.state.data.length,
                loading: this.state.loading,
                onChange: this.handleChangePage
              })
            )
          )
        )
      );
    }
  }]);

  return CustomerList;
}(_react.Component);

CustomerList.contextTypes = {
  store: _propTypes2.default.object
};
CustomerList.propTypes = {
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isDeveloper: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool
  }),
  t: _propTypes2.default.func
};

CustomerList.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

CustomerList.getPropsToState = function (props) {
  var loading = props.loading;
  var data = props.data || [];
  var count = props.count;
  var limit = props.limit || 10;
  var offset = props.offset || 0;
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var advanceFilter = false;
  var projectBranchOwnerID = query.projectBranchOwnerID || '';
  var showBookingCount = query.showBookingCount || true;

  return {
    data: data,
    loading: loading,
    count: count,
    limit: limit,
    offset: offset,
    search: search,
    advanceFilter: advanceFilter,
    currentPage: currentPage,
    projectBranchOwnerID: projectBranchOwnerID,
    showBookingCount: showBookingCount
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.getBranchShortName = function (id, arr) {
    var valueName = arr.find(function (vn) {
      return vn.id === id;
    });
    if (valueName && valueName.name) {
      return valueName.name;
    }
    return '';
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this7.props.location.search);
    query.page = currentPage;
    _this7.setState({
      currentPage: currentPage
    });
    _this7.replaceQuery(query);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this7.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this7.replaceQuery(query, true);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this7.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    _this7.setState({
      search: ''
    }, function () {
      if (hasQuery) {
        _this7.replaceQuery(query, true);
      }
    });
  };

  this.handleFilterOnChange = function (value, queryName) {
    var _this7$setState;

    var query = (0, _url.decodeSearch)(_this7.props.location.search);
    query[queryName] = value;
    _this7.setState((_this7$setState = {}, _defineProperty(_this7$setState, queryName, value), _defineProperty(_this7$setState, 'businessUnitFilter', false), _this7$setState));
    _this7.replaceQuery(query, true);
  };

  this.handleSetAdvanceFilter = function (advanceFilter) {
    _this7.setState({
      advanceFilter: advanceFilter
    });
  };

  this.sortItems = [{
    text: 'Date Created Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'customer_detail.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Date Created Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'customer_detail.created_at',
    sortDirection: 'desc'
  }, {
    text: 'Name Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'customer_detail.name',
    sortDirection: 'asc'
  }, {
    text: 'Name Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'customer_detail.name',
    sortDirection: 'desc'
  }];
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(CustomerList.mapStateToProps)(CustomerList));

/***/ }),
/* 2319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _flash = __webpack_require__(5);

var _addressSettings = __webpack_require__(152);

var _customOptions = __webpack_require__(312);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(2317);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var New = function (_Component) {
  _inherits(New, _Component);

  function New(props) {
    _classCallCheck(this, New);

    var _this = _possibleConstructorReturn(this, (New.__proto__ || Object.getPrototypeOf(New)).call(this, props));

    _this.handleSubmit = function (event) {
      event.preventDefault();
      var store = _this.context.store;

      _this.form.handleSubmit(event).catch(function (err) {
        Bugsnag.notifyException(err);
        store.dispatch((0, _flash.flashErrorMessage)(err));
      });
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments[1];

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges, callback);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(New, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;

      store.dispatch((0, _addressSettings.fetchAddressSettings)());
      store.dispatch((0, _customOptions.fetchCustomOptions)());
    }
  }, {
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, customer) {
        var _this2 = this;

        var store, t, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.form.submit(_config2.default.get('bookApiURL') + '/customers/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(customer)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false, function (noChanges) {
                    if (noChanges) {
                      store.dispatch((0, _reactRouterRedux.replace)('/customers/' + res.id + '/'));
                      store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Create Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully created', { ns: _translation.TRANSLATION_FILES.translation, name: customer.customerDetail.name }) }));
                    }
                  });
                });

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('New', { ns: _translation.TRANSLATION_FILES.screens }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Create', { ns: _translation.TRANSLATION_FILES.screens }),
              onClick: this.handleSubmit
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, customer) {
            _this3.submit(validations, customer);
          },
          onChange: this.handleOnChange,
          location: this.props.location,
          auth: this.props.auth,
          addressSettings: this.props.addressSettings,
          customOptions: this.props.customOptions,
          loading: this.props.loading
        })
      );
    }
  }]);

  return New;
}(_react.Component);

New.propTypes = {
  token: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    hash: _propTypes2.default.string
  }),
  loading: _propTypes2.default.bool,
  auth: _propTypes2.default.shape({
    companyBranch: _propTypes2.default.shape({
      id: _propTypes2.default.number
    }),
    isHeadquarters: _propTypes2.default.bool
  }),
  addressSettings: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  customOptions: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
New.contextTypes = {
  store: _propTypes2.default.object
};

New.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    addressSettings: state.addressSettings,
    customOptions: state.customOptions
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(New.mapStateToProps)(New));

/***/ }),
/* 2320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRouter = __webpack_require__(18);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _NewUpdateIncomeForm = __webpack_require__(2309);

var _NewUpdateIncomeForm2 = _interopRequireDefault(_NewUpdateIncomeForm);

var _UploadForm = __webpack_require__(394);

var _UploadForm2 = _interopRequireDefault(_UploadForm);

var _UpdateLoanInfo = __webpack_require__(2311);

var _UpdateLoanInfo2 = _interopRequireDefault(_UpdateLoanInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewEditIncome = function (_Component) {
  _inherits(NewEditIncome, _Component);

  function NewEditIncome(props) {
    var _this2 = this;

    _classCallCheck(this, NewEditIncome);

    var _this = _possibleConstructorReturn(this, (NewEditIncome.__proto__ || Object.getPrototypeOf(NewEditIncome)).call(this, props));

    _this.checkStringify = function (source, target) {
      return JSON.stringify(source) === JSON.stringify(target);
    };

    _this.checkUpdateDisabled = function () {
      var income = _this.state.income;

      var hasIncome = income && (income.netIncome !== '' || income.netIncome > 0 || !income.isEmployed && (income.basicIncome !== '' || income.basicIncome > 0));
      if (!hasIncome) {
        return true;
      }
      return false;
    };

    _this.fetchBooking = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var store, res, message, json, newBooking;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.setLoading(true);

            case 2:
              store = _this.context.store;
              res = '';
              _context.prev = 4;
              _context.next = 7;
              return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/bookings/' + _this.props.routeParams.id + '/', {
                credentials: 'include',
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }));

            case 7:
              res = _context.sent;
              _context.next = 21;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](4);

              if (!(_context.t0.res && _context.t0.res.status >= 399 && _context.t0.res.status < 500)) {
                _context.next = 17;
                break;
              }

              _context.next = 15;
              return _context.t0.res.text();

            case 15:
              message = _context.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

            case 17:
              _context.next = 19;
              return _this.setLoading(false);

            case 19:
              Bugsnag.notifyException(_context.t0);
              store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));

            case 21:
              _context.next = 23;
              return res.json();

            case 23:
              json = _context.sent;

              if (json) {
                newBooking = Object.assign({}, json || {});

                _this.setState({ booking: newBooking });
              }
              _context.next = 27;
              return _this.setLoading(false);

            case 27:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2, [[4, 10]]);
    }));
    _this.handleSubmitIncome = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var store, _this$state, creditCheckReportData, income;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              store = _this.context.store;
              _this$state = _this.state, creditCheckReportData = _this$state.creditCheckReportData, income = _this$state.income;

              if (income.isEmployed) {
                income.bYearlyIncome = 0;
                income.otherYearlyIncome = 0;
                income.bFormDocumentID = '';
                income.bFormDocument = null;
              }
              if (!income.isEmployed) {
                income.basicIncome = 0;
                income.fixAllowance = 0;
                income.grossIncome = 0;
                income.deduction = 0;
                income.epfStatementDocumentID = '';
                income.epfStatementDocument = null;
                income.payslipDocumentID = '';
                income.payslipDocument = null;
                income.bankStatementDocumentID = '';
                income.bankStatementDocument = null;
              }

              if (!(income.netIncome <= 0)) {
                _context2.next = 8;
                break;
              }

              _context2.next = 7;
              return store.dispatch((0, _flash.flashErrorMessage)({ header: 'Net Income must be more than 0' }));

            case 7:
              return _context2.abrupt('return');

            case 8:
              income.currentLoanAmount = creditCheckReportData.currentLoanAmount;
              _context2.next = 11;
              return _this.setState({ income: income }, function () {
                return _this.updateIncome(income);
              });

            case 11:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    _this.handleCancel = function (e) {
      e.preventDefault();
      var store = _this.context.store;

      store.dispatch((0, _reactRouterRedux.goBack)());
    };

    _this.handleChangeTab = function () {
      var isEmployed = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var income = _this.state.income;

      var newIncome = Object.assign({}, income);
      newIncome.isEmployed = isEmployed;
      if (newIncome.isEmployed) {
        var grossIncome = _lodash2.default.toNumber(_lodash2.default.toNumber(newIncome.basicIncome) + _lodash2.default.toNumber(newIncome.fixAllowance)).toFixed(2);
        newIncome.grossIncome = _lodash2.default.toNumber(grossIncome);
        var netIncome = _lodash2.default.toNumber(_lodash2.default.toNumber(newIncome.grossIncome) - _lodash2.default.toNumber(newIncome.deduction)).toFixed(2);
        newIncome.netIncome = _lodash2.default.toNumber(netIncome);
      }
      if (!newIncome.isEmployed) {
        var totalYearlyIncome = _lodash2.default.toNumber(newIncome.bYearlyIncome) + _lodash2.default.toNumber(newIncome.otherYearlyIncome);
        var totalMonthlyIncome = _lodash2.default.toNumber(totalYearlyIncome) / 12;
        var roughIncome = _lodash2.default.toNumber(totalMonthlyIncome).toFixed(2);
        newIncome.netIncome = _lodash2.default.toNumber(roughIncome);
      }
      _this.handleIncomeChange(newIncome);
    };

    _this.handleCreateFormData = function (type) {
      var income = _this.state.income;

      var formData = null;
      if (type === 'employed') {
        if (income.epfStatementDocument || income.payslipDocument || income.bankStatementDocument) {
          formData = _this.employedFormUpload.getFormData();

          if (income.epfStatementDocument) {
            formData.append('files_0', income.epfStatementDocument.file);
            formData.append('tags_0', income.epfStatementDocument.tags);
            formData.append('names_0', income.epfStatementDocument.name);
            formData.append('degrees_0', income.epfStatementDocument.degree);
          }
          if (income.payslipDocument) {
            formData.append('files_1', income.payslipDocument.file);
            formData.append('tags_1', income.payslipDocument.tags);
            formData.append('names_1', income.payslipDocument.name);
            formData.append('degrees_1', income.payslipDocument.degree);
          }
          if (income.bankStatementDocument) {
            formData.append('files_2', income.bankStatementDocument.file);
            formData.append('tags_2', income.bankStatementDocument.tags);
            formData.append('names_2', income.bankStatementDocument.name);
            formData.append('degrees_2', income.bankStatementDocument.degree);
          }
        }
      } else if (type === 'selfEmployed') {
        if (income.bFormDocument) {
          formData = _this.bFormUpload.getFormData();
          formData.append('files_0', income.bFormDocument.file);
          formData.append('tags_0', income.bFormDocument.tags);
          formData.append('names_0', income.bFormDocument.name);
          formData.append('degrees_0', income.bFormDocument.degree);
        }
      }
      return formData;
    };

    _this.handleGetForm = function (form) {
      var formName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'epfStatementDocument';
      var income = _this.state.income;

      income[formName] = form;
      _this.setState({ income: income, changedForm: true });
    };

    _this.handleIncomeChange = function (income) {
      _this.setState({ income: income });
    };

    _this.handleLoanChange = function (creditCheckReportData) {
      _this.setState({ creditCheckReportData: creditCheckReportData });
    };

    _this.handleClickNext = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _this$state2, changedForm, income, newEmployedForm, newSelfEmployedForm;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _this$state2 = _this.state, changedForm = _this$state2.changedForm, income = _this$state2.income;

              if (!(income && (income.netIncome !== '' || income.netIncome > 0 || !income.isEmployed && (income.basicIncome !== '' || income.basicIncome > 0)))) {
                _context3.next = 5;
                break;
              }

              if (changedForm) {
                if (income.isEmployed) {
                  newEmployedForm = _this.handleCreateFormData('employed');

                  _this.setState({ employedForm: newEmployedForm });
                } else {
                  newSelfEmployedForm = _this.handleCreateFormData('selfEmployed');

                  _this.setState({ selfEmployedForm: newSelfEmployedForm });
                }
              }
              _context3.next = 5;
              return _this.setState({ nextStep: true });

            case 5:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));

    _this.handlePreviousStep = function (e) {
      e.preventDefault();
      _this.setState({ nextStep: false });
    };

    _this.handleUpdate = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _this.handleUpdateIncome();

            case 1:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this2);
    }));

    _this.handleUpdateIncome = function () {
      var _this$state3 = _this.state,
          changedForm = _this$state3.changedForm,
          income = _this$state3.income,
          employedForm = _this$state3.employedForm,
          selfEmployedForm = _this$state3.selfEmployedForm;

      if (income && (income.netIncome !== '' || income.netIncome > 0 || !income.isEmployed && (income.basicIncome !== '' || income.basicIncome > 0))) {
        if (changedForm) {
          _this.getDocumentToken(function () {
            if (income.isEmployed) {
              if (employedForm !== null) {
                _this.uploadDocument(employedForm, 'employedForm');
              } else {
                _this.handleSubmitIncome();
              }
            } else {
              if (selfEmployedForm !== null) {
                _this.uploadDocument(selfEmployedForm, 'selfEmployed');
              } else {
                _this.handleSubmitIncome();
              }
            }
          });
        } else {
          _this.getIncomeToken(function () {
            _this.handleSubmitIncome();
          });
        }
      }
    };

    _this.tabs = [{ name: 'isEmployed', text: 'Employed', isEmployed: true }, { name: 'SelfEmployed', text: 'Self Employed', isEmployed: false }];

    _this.checkNextDisabled = function () {
      var _this$state4 = _this.state,
          income = _this$state4.income,
          nextStep = _this$state4.nextStep;

      if (!nextStep) {
        if (income.netIncome <= 0) {
          return true;
        }
      }
      return false;
    };

    _this.state = {
      booking: null,
      customerID: '',
      data: null,
      errMessages: [],
      income: null,
      loading: true,
      oriIncome: null,
      pathCheck: false,
      token: null,
      incomeToken: null,
      documentToken: null,
      changedForm: false,
      employedForm: null,
      selfEmployedForm: null,
      nextStep: false,
      creditCheckReportData: []
    };
    _this.validation = {};
    return _this;
  }

  _createClass(NewEditIncome, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.handlePathCheck();
    }
  }, {
    key: 'getDocumentToken',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(callback) {
        var _this3 = this;

        var store;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                store = this.context.store;

                store.dispatch((0, _fetchM.fetchM)('/customers/' + this.state.customerID + '/documents/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                })).catch(function (err) {
                  store.dispatch((0, _flash.flashErrorMessage)(err));
                }).then(function (res) {
                  var documentToken = res.headers.get('X-Csrf-Token');
                  _this3.setState({
                    documentToken: documentToken
                  }, function () {
                    if (callback) {
                      callback();
                    }
                  });
                });

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getDocumentToken(_x3) {
        return _ref5.apply(this, arguments);
      }

      return getDocumentToken;
    }()
  }, {
    key: 'getIncomeToken',
    value: function getIncomeToken(callback) {
      var _this4 = this;

      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/customers/' + this.state.customerID + '/income/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      }).then(function (res) {
        var incomeToken = res.headers.get('X-Csrf-Token');
        _this4.setState({
          incomeToken: incomeToken
        }, function () {
          if (callback) {
            callback();
          }
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this5 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this5.setState(state, res);
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this6 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this6.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'fetchCustomer',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var store, res, json, newData;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                store = this.context.store;
                res = void 0;
                _context6.prev = 2;
                _context6.next = 5;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/customers/' + this.state.customerID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                res = _context6.sent;
                _context6.next = 16;
                break;

              case 8:
                _context6.prev = 8;
                _context6.t0 = _context6['catch'](2);

                Bugsnag.notifyException(_context6.t0);
                _context6.next = 13;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 13:
                _context6.next = 15;
                return this.setLoading(false);

              case 15:
                return _context6.abrupt('return');

              case 16:
                _context6.next = 18;
                return res.json();

              case 18:
                json = _context6.sent;

                if (json) {
                  newData = Object.assign({}, json || {});

                  this.setState({ data: newData });
                }
                _context6.next = 22;
                return this.setLoading(false);

              case 22:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[2, 8]]);
      }));

      function fetchCustomer() {
        return _ref6.apply(this, arguments);
      }

      return fetchCustomer;
    }()
  }, {
    key: 'fetchCustomerCreditReport',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var store, res, message, json, newCreditCheckReport;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                store = this.context.store;
                res = void 0;
                _context7.prev = 2;
                _context7.next = 5;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.state.customerID + '/credit_reports/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                res = _context7.sent;
                _context7.next = 20;
                break;

              case 8:
                _context7.prev = 8;
                _context7.t0 = _context7['catch'](2);
                _context7.next = 12;
                return this.setLoading(false);

              case 12:
                if (!(_context7.t0.res && _context7.t0.res.status >= 400 && _context7.t0.res.status < 500)) {
                  _context7.next = 18;
                  break;
                }

                _context7.next = 15;
                return _context7.t0.res.text();

              case 15:
                message = _context7.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context7.abrupt('return');

              case 18:
                store.dispatch((0, _flash.flashErrorMessage)(_context7.t0));
                return _context7.abrupt('return');

              case 20:
                _context7.next = 22;
                return res.json();

              case 22:
                json = _context7.sent;

                if (json) {
                  newCreditCheckReport = Object.assign({}, json[0] || {});

                  this.setState({ creditCheckReportData: newCreditCheckReport });
                }
                _context7.next = 26;
                return this.setLoading(false);

              case 26:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[2, 8]]);
      }));

      function fetchCustomerCreditReport() {
        return _ref7.apply(this, arguments);
      }

      return fetchCustomerCreditReport;
    }()
  }, {
    key: 'fetchIncome',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var store, res, message, token, income;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                store = this.context.store;
                res = void 0;
                _context8.prev = 2;
                _context8.next = 5;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/customers/' + this.state.customerID + '/income/' + this.props.routeParams.incomeID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                res = _context8.sent;
                _context8.next = 14;
                break;

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8['catch'](2);

                Bugsnag.notifyException(_context8.t0);
                _context8.next = 13;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 13:
                return _context8.abrupt('return');

              case 14:
                if (res.ok) {
                  _context8.next = 22;
                  break;
                }

                _context8.next = 17;
                return res.text();

              case 17:
                message = _context8.sent;
                _context8.next = 20;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 20:
                _context8.next = 28;
                break;

              case 22:
                token = res.headers.get('X-Csrf-Token');
                _context8.next = 25;
                return res.json();

              case 25:
                income = _context8.sent;
                _context8.next = 28;
                return this.setComponentState({
                  token: token,
                  income: income,
                  oriIncome: (0, _clone2.default)(income)
                });

              case 28:
                _context8.next = 30;
                return this.setLoading(false);

              case 30:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[2, 8]]);
      }));

      function fetchIncome() {
        return _ref8.apply(this, arguments);
      }

      return fetchIncome;
    }()
  }, {
    key: 'updateIncome',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(income) {
        var store, _state, customerID, pathCheck, token, res, message;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                store = this.context.store;
                _state = this.state, customerID = _state.customerID, pathCheck = _state.pathCheck, token = _state.token;
                res = void 0;
                _context9.next = 5;
                return this.setLoading(true);

              case 5:
                _context9.prev = 5;
                _context9.next = 8;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/customers/' + customerID + '/income/' + income.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': token
                  },
                  body: JSON.stringify(income)
                }));

              case 8:
                res = _context9.sent;
                _context9.next = 23;
                break;

              case 11:
                _context9.prev = 11;
                _context9.t0 = _context9['catch'](5);
                _context9.next = 15;
                return this.setLoading(false);

              case 15:
                if (!(_context9.t0.res && _context9.t0.res.status >= 400 && _context9.t0.res.status < 500)) {
                  _context9.next = 21;
                  break;
                }

                _context9.next = 18;
                return _context9.t0.res.text();

              case 18:
                message = _context9.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context9.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context9.t0));
                return _context9.abrupt('return');

              case 23:
                _context9.next = 25;
                return this.setLoading(false);

              case 25:
                if (pathCheck) {
                  store.dispatch((0, _reactRouterRedux.push)('/bookings/' + this.props.routeParams.id + '/'));
                } else {
                  store.dispatch((0, _reactRouterRedux.push)('/customers/' + this.state.customerID + '/'));
                }
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Update Successs', message: 'Customer income has been successfully updated' }));

              case 27:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[5, 11]]);
      }));

      function updateIncome(_x6) {
        return _ref9.apply(this, arguments);
      }

      return updateIncome;
    }()
  }, {
    key: 'uploadDocument',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(body) {
        var _this7 = this;

        var key = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'employedForm';
        var store, income, res, message, json, newIncome;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                income = this.state.income;
                res = void 0;
                _context10.next = 7;
                return this.setLoading(true);

              case 7:
                _context10.prev = 7;
                _context10.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + this.state.customerID + '/income/' + income.id + '/documents/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    // Let browser decide Content-Type
                    'X-Csrf-Token': this.state.documentToken
                  },
                  body: body
                }));

              case 10:
                res = _context10.sent;
                _context10.next = 26;
                break;

              case 13:
                _context10.prev = 13;
                _context10.t0 = _context10['catch'](7);
                _context10.next = 17;
                return this.setLoading(false);

              case 17:
                Bugsnag.notifyException(_context10.t0);

                if (!(_context10.t0.res && _context10.t0.res.status >= 400 && _context10.t0.res.status < 500)) {
                  _context10.next = 24;
                  break;
                }

                _context10.next = 21;
                return _context10.t0.res.text();

              case 21:
                message = _context10.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context10.abrupt('return');

              case 24:
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context10.abrupt('return');

              case 26:
                _context10.next = 28;
                return res.json();

              case 28:
                json = _context10.sent;

                if (json) {
                  newIncome = Object.assign({}, income || {});

                  newIncome.id = json.id;
                  if (json.epfStatementDocumentID !== '') {
                    newIncome.epfStatementDocumentID = json.epfStatementDocumentID;
                    newIncome.epfStatementDocument = json.epfStatementDocument;
                  }
                  if (json.bankStatementDocumentID !== '') {
                    newIncome.bankStatementDocumentID = json.bankStatementDocumentID;
                    newIncome.bankStatementDocument = json.bankStatementDocument;
                  }
                  if (json.payslipDocumentID !== '') {
                    newIncome.payslipDocumentID = json.payslipDocumentID;
                    newIncome.payslipDocument = json.payslipDocument;
                  }
                  if (json.bFormDocumentID !== '') {
                    newIncome.bFormDocumentID = json.bFormDocumentID;
                    newIncome.bFormDocument = json.bFormDocument;
                  }
                  this.setState({ income: newIncome, changedForm: false }, function () {
                    _this7.getIncomeToken(function () {
                      _this7.handleSubmitIncome();
                    });
                  });
                }
                _context10.next = 32;
                return this.setLoading(false);

              case 32:
                if (!(key === 'employed')) {
                  _context10.next = 35;
                  break;
                }

                _context10.next = 35;
                return this.employedFormUpload.resetFiles();

              case 35:
                if (!(key === 'selfEmployed')) {
                  _context10.next = 38;
                  break;
                }

                _context10.next = 38;
                return this.bFormUpload.resetFiles();

              case 38:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[7, 13]]);
      }));

      function uploadDocument(_x7) {
        return _ref10.apply(this, arguments);
      }

      return uploadDocument;
    }()
  }, {
    key: 'handlePathCheck',
    value: function handlePathCheck() {
      var _this8 = this;

      if (this.props.location.pathname.includes('/bookings/')) {
        this.setState({ customerID: this.props.routeParams.customerID, pathCheck: true }, function () {
          _this8.fetchBooking();
          _this8.fetchCustomer();
          _this8.fetchCustomerCreditReport();
          _this8.fetchIncome();
        });
      } else {
        this.setState({ customerID: this.props.routeParams.id }, function () {
          _this8.fetchCustomer();
          _this8.fetchCustomerCreditReport();
          _this8.fetchIncome();
        });
      }
    }
  }, {
    key: 'handleError',
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(store, msg, errorObj) {
        var isBugsnag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.setLoading(false);

              case 2:
                _context11.next = 4;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: msg }));

              case 4:
                if (isBugsnag) Bugsnag.notifyException(errorObj);

              case 5:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function handleError(_x9, _x10, _x11) {
        return _ref11.apply(this, arguments);
      }

      return handleError;
    }()
  }, {
    key: 'renderStepContent',
    value: function renderStepContent() {
      var _this9 = this;

      var _state2 = this.state,
          data = _state2.data,
          customerID = _state2.customerID,
          income = _state2.income,
          nextStep = _state2.nextStep;

      if (nextStep) {
        return _react2.default.createElement(
          _semanticUiReact.Grid,
          { centered: true, columns: 12 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { computer: 8, tablet: 10, mobile: 16 },
              _react2.default.createElement(_UpdateLoanInfo2.default, {
                loading: this.state.loading,
                data: data,
                onChange: this.handleLoanChange,
                bookingCustomerData: this.state.booking,
                creditCheckReportData: this.state.creditCheckReportData,
                pathCheck: this.state.pathCheck
              })
            )
          )
        );
      }
      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { centered: true },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { computer: 8, tablet: 10, mobile: 16 },
                _react2.default.createElement(_semanticUiReact.Header, { as: 'h2', content: 'I am', textAlign: 'left' })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { columns: 1, textAlign: 'center', stackable: true, doubling: true },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { computer: 8, tablet: 10, mobile: 16 },
                      _react2.default.createElement(
                        'div',
                        { className: 'menuTab' },
                        _react2.default.createElement(
                          _semanticUiReact.Menu,
                          { fluid: true, widths: 2 },
                          this.tabs.map(function (tab, idx) {
                            return _react2.default.createElement(
                              _semanticUiReact.Menu.Item,
                              {
                                key: idx,
                                name: tab.name,
                                onClick: function onClick() {
                                  return _this9.handleChangeTab(tab.isEmployed);
                                },
                                active: income.isEmployed === tab.isEmployed
                              },
                              tab.text
                            );
                          })
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(_NewUpdateIncomeForm2.default, {
                  loading: this.state.loading,
                  customerID: customerID,
                  income: income,
                  data: data,
                  onChange: this.handleIncomeChange
                }),
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { centered: true },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    income.isEmployed ? _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { computer: 7, tablet: 9, mobile: 16, textAlign: 'right' },
                      _react2.default.createElement(_semanticUiReact.Header, {
                        as: 'h3',
                        content: 'Upload Documents',
                        textAlign: 'left',
                        style: { marginTop: '2em', marginBottom: '0.5em' }
                      }),
                      _react2.default.createElement(_UploadForm2.default, {
                        title: 'FinancialForm',
                        labelContent: 'Latest EPF Statement',
                        ref: function ref(_ref12) {
                          _this9.employedFormUpload = _ref12;
                        },
                        loading: this.state.loading,
                        tags: ['Financial EPF'],
                        picture: data.epfStatementDocumentID && data.epfStatementDocumentID.length > 0 ? data.epfStatementDocument : null,
                        onChange: function onChange(form) {
                          return _this9.handleGetForm(form, 'epfStatementDocument');
                        }
                      }),
                      _react2.default.createElement(_UploadForm2.default, {
                        title: 'FinancialForm',
                        labelContent: 'Latest 3 months payslip',
                        ref: function ref(_ref13) {
                          _this9.employedFormUpload = _ref13;
                        },
                        loading: this.state.loading,
                        tags: ['Financial Payslip'],
                        picture: data.payslipDocumentID && data.payslipDocumentID.length > 0 ? data.payslipDocument : null,
                        onChange: function onChange(form) {
                          return _this9.handleGetForm(form, 'payslipDocument');
                        },
                        style: { height: '4rem !important' }
                      }),
                      _react2.default.createElement(_UploadForm2.default, {
                        title: 'FinancialForm',
                        labelContent: 'Latest 3 months bank statement',
                        ref: function ref(_ref14) {
                          _this9.employedFormUpload = _ref14;
                        },
                        loading: this.state.loading,
                        tags: ['Financial BankStatement'],
                        picture: data.bankStatementDocumentID && data.bankStatementDocumentID.length > 0 ? data.bankStatementDocument : null,
                        onChange: function onChange(form) {
                          return _this9.handleGetForm(form, 'bankStatementDocument');
                        }
                      })
                    ) : null,
                    !income.isEmployed ? _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { computer: 7, tablet: 9, mobile: 16, textAlign: 'right' },
                      _react2.default.createElement(_semanticUiReact.Header, {
                        as: 'h3',
                        content: 'Upload Documents',
                        textAlign: 'left',
                        style: { marginTop: '2em', marginBottom: '0.5em' }
                      }),
                      _react2.default.createElement(_UploadForm2.default, {
                        title: 'FinancialForm',
                        labelContent: 'B Form',
                        ref: function ref(_ref15) {
                          _this9.bFormUpload = _ref15;
                        },
                        loading: this.state.loading,
                        tags: ['Financial BForm'],
                        picture: data.bFormDocumentID && data.bFormDocumentID.length > 0 ? data.bFormDocument : null,
                        onChange: function onChange(form) {
                          return _this9.handleGetForm(form, 'bFormDocument');
                        }
                      })
                    ) : null
                  )
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'renderStep',
    value: function renderStep() {
      var nextStep = this.state.nextStep;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { centered: true },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { style: { paddingBottom: '0px' } },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 4, tablet: 5, mobile: 8 },
            _react2.default.createElement(
              _semanticUiReact.Header,
              { textAlign: 'left' },
              !nextStep ? 'Financial Info' : 'Loan Info'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 4, tablet: 5, mobile: 8 },
            _react2.default.createElement(
              'p',
              { style: { textAlign: 'right' } },
              !nextStep ? '4 of 5' : '5 of 5'
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 8, tablet: 10, mobile: 16 },
            !nextStep ? _react2.default.createElement(
              'div',
              { className: 'progressBar' },
              _react2.default.createElement(_semanticUiReact.Progress, {
                percent: 80,
                size: 'tiny'
              })
            ) : _react2.default.createElement(
              'div',
              { className: 'progressBar' },
              _react2.default.createElement(_semanticUiReact.Progress, {
                percent: 100,
                size: 'tiny'
              })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          this.renderStepContent()
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              'div',
              { className: 'buttonBorder' },
              _react2.default.createElement(_semanticUiReact.Container, { style: { borderTop: '1px solid rgb(217, 218, 220)', padding: '0.5rem', borderRadius: '0.25rem' } })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { style: { padding: 0 } },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { computer: 8, tablet: 10, mobile: 16 },
            _react2.default.createElement(
              'div',
              { className: 'nextButton' },
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  fluid: true,
                  onClick: !nextStep ? this.handleClickNext : this.handleUpdate,
                  disabled: this.state.loading || this.checkNextDisabled()
                },
                !nextStep ? 'Next' : 'Update'
              )
            ),
            nextStep ? _react2.default.createElement(
              'div',
              { className: 'backButton' },
              _react2.default.createElement(_semanticUiReact.Button, {
                onClick: this.handlePreviousStep,
                disabled: this.state.loading,
                content: '< Back'
              })
            ) : _react2.default.createElement(
              'div',
              { className: 'backButton' },
              _react2.default.createElement(_semanticUiReact.Button, {
                floated: 'left',
                onClick: this.handleCancel,
                disabled: this.state.loading,
                content: '< Cancel'
              })
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _state3 = this.state,
          data = _state3.data,
          booking = _state3.booking,
          income = _state3.income,
          pathCheck = _state3.pathCheck;

      return data !== null && income !== null ? _react2.default.createElement(
        'div',
        null,
        booking && pathCheck && _react2.default.createElement(
          _semanticUiReact.Header,
          { as: 'h4', textAlign: 'center' },
          'Booking for ',
          _react2.default.createElement('br', { className: 'large-hide small-hide tablet-hide' }),
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/projects/' + (booking.project && booking.project.id) + '/units/' + (booking.projectUnit && booking.projectUnit.id) + '/' },
            booking.projectUnit && booking.projectUnit.reference
          ),
          ', ',
          booking.project && booking.project.name,
          ' ',
          booking.projectUnit && booking.projectUnit.isBumi && _react2.default.createElement(
            _semanticUiReact.Label,
            { size: 'mini' },
            'Bumi'
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Divider,
          {
            horizontal: true,
            style: { color: 'rgba(112, 112, 112, 1)' }
          },
          pathCheck ? 'Customer Assessment' : 'Credit Check'
        ),
        _react2.default.createElement(
          _semanticUiReact.Container,
          { style: { border: '1px solid rgb(217, 218, 220)', padding: '3rem', borderRadius: '0.25rem' } },
          this.renderStep()
        )
      ) : null;
    }
  }]);

  return NewEditIncome;
}(_react.Component);

NewEditIncome.contextTypes = {
  store: _propTypes2.default.object
};
NewEditIncome.propTypes = {
  routeParams: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    customerID: _propTypes2.default.string,
    incomeID: _propTypes2.default.string
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string,
    hash: _propTypes2.default.string
  })
};
exports.default = NewEditIncome;

/***/ }),
/* 2321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

var _semanticUiReact = __webpack_require__(2);

var _i18next = __webpack_require__(94);

var _i18next2 = _interopRequireDefault(_i18next);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactRouter = __webpack_require__(18);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _reactI18next = __webpack_require__(3);

var _webValidations = __webpack_require__(23);

var _InsufficientCreditCheck = __webpack_require__(1077);

var _InsufficientCreditCheck2 = _interopRequireDefault(_InsufficientCreditCheck);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _addressSettings = __webpack_require__(152);

var _customOptions = __webpack_require__(312);

var _countries = __webpack_require__(591);

var _displayTime = __webpack_require__(156);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _TinFieldInput = __webpack_require__(192);

var _TinFieldInput2 = _interopRequireDefault(_TinFieldInput);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _EditableBox = __webpack_require__(153);

var _EditableBox2 = _interopRequireDefault(_EditableBox);

var _Phone = __webpack_require__(126);

var _Phone2 = _interopRequireDefault(_Phone);

var _PhoneInput = __webpack_require__(104);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

var _Identity = __webpack_require__(315);

var _Identity2 = _interopRequireDefault(_Identity);

var _CreditCheckScores = __webpack_require__(2122);

var _CreditCheckScores2 = _interopRequireDefault(_CreditCheckScores);

var _CreditCheckSplash = __webpack_require__(2123);

var _CreditCheckSplash2 = _interopRequireDefault(_CreditCheckSplash);

var _LPPSAChecker = __webpack_require__(562);

var _LPPSAChecker2 = _interopRequireDefault(_LPPSAChecker);

var _SearchBranch = __webpack_require__(1031);

var _SearchBranch2 = _interopRequireDefault(_SearchBranch);

var _CustomerBookings = __webpack_require__(2124);

var _CustomerBookings2 = _interopRequireDefault(_CustomerBookings);

var _MarkdownText = __webpack_require__(193);

var _MarkdownText2 = _interopRequireDefault(_MarkdownText);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _InputBirthdate = __webpack_require__(220);

var _InputBirthdate2 = _interopRequireDefault(_InputBirthdate);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _intlCallCodes = __webpack_require__(116);

var _intlCallCodes2 = _interopRequireDefault(_intlCallCodes);

var _states = __webpack_require__(144);

var _states2 = _interopRequireDefault(_states);

var _countries2 = __webpack_require__(60);

var _race = __webpack_require__(324);

var _bumi = __webpack_require__(318);

var _gender = __webpack_require__(319);

var _maritalStatus = __webpack_require__(320);

var _customerTitles = __webpack_require__(390);

var _customerTitles2 = _interopRequireDefault(_customerTitles);

var _regex = __webpack_require__(143);

var _phone = __webpack_require__(146);

var _identityTypes = __webpack_require__(174);

var _vietnam = __webpack_require__(40);

var _companies = __webpack_require__(88);

var _intlFlagCodes = __webpack_require__(141);

var _intlFlagCodes2 = _interopRequireDefault(_intlFlagCodes);

var _defaultIdentityTypeOpts = __webpack_require__(154);

var _defaultIdentityTypeOpts2 = _interopRequireDefault(_defaultIdentityTypeOpts);

var _translation = __webpack_require__(4);

var _translation2 = __webpack_require__(64);

var _tin = __webpack_require__(155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


var isPRS = _config2.default.get('prs');
var styles = {
  divider: { margin: '0.5em 0' }
};

var Overview = function (_Component) {
  _inherits(Overview, _Component);

  function Overview(props) {
    _classCallCheck(this, Overview);

    var _this = _possibleConstructorReturn(this, (Overview.__proto__ || Object.getPrototypeOf(Overview)).call(this, props));

    _initialiseProps.call(_this);

    var state = Overview.getPropsToState(props);
    _this.state = _extends({}, state, {
      companyApp: [],
      creditSubscription: {
        amount: 0
      },
      errMessages: [],
      tinMessage: null,
      edit: false,
      hasChanges: false,
      openInsufficientCreditModal: false
    });
    _this.validation = {
      preferredName: (0, _react.createRef)(),
      mobile: (0, _react.createRef)(),
      phone: (0, _react.createRef)(),
      identity: (0, _react.createRef)(),
      taxIdentificationNo: (0, _react.createRef)(),
      title: (0, _react.createRef)(),
      name: (0, _react.createRef)(),
      email: (0, _react.createRef)(),
      mobilePrefix: (0, _react.createRef)(),
      monthlyIncome: (0, _react.createRef)(),
      country: (0, _react.createRef)(),
      raceOther: (0, _react.createRef)(),
      emergencyContactMobilePrefix: (0, _react.createRef)(),
      emergencyContactMobile: (0, _react.createRef)(),
      emergencyContactEmail: (0, _react.createRef)()
    };

    // add validateRef for all enabled address settings
    var enabledAddressSettings = props.addressSettings.data.filter(function (as) {
      return as.enabled;
    });
    if (enabledAddressSettings && enabledAddressSettings.length > 0) {
      enabledAddressSettings.forEach(function (as) {
        var key = _lodash2.default.camelCase(as.columnName);
        _this.validation[key] = (0, _react.createRef)();
      });
    }
    return _this;
  }

  _createClass(Overview, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;

      store.dispatch((0, _addressSettings.fetchAddressSettings)());
      store.dispatch((0, _customOptions.fetchCustomOptions)());
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Overview.getPropsToState(nextProps);
      var tinFoundOnInitialize = false;
      var identityPresets = nextProps.identityPresets.data || [];
      state.identityTypeOpts = (0, _identityTypes.getIdentityTypeOpts)(nextProps.auth, identityPresets);
      if (JSON.stringify(this.state.oriData) === JSON.stringify(state.oriData)) {
        state.editingCustomer = this.state.editingCustomer;
      }
      if (state && state.data && state.data.customerCreditReportID && this.props.auth && (this.props.auth.isBranchLeader || this.props.auth.isDeveloperStaff || this.props.auth.isExternalAgentLeader || this.props.auth.isExternalAgent || this.props.auth.isExternalAgencyAdmin)) {
        this.fetchCompanyApp();
      }
      if (state && state.editingCustomer && state.editingCustomer.taxIdentificationNo && state.editingCustomer.taxTinValidationStatus === 'success') {
        tinFoundOnInitialize = true;
      }
      this.setState(_extends({}, state, { tinFound: tinFoundOnInitialize }));
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (prevState.editingCustomer !== this.state.editingCustomer) {
        this.updateTinFieldState();
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this2.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'getIdentityTypeText',
    value: function getIdentityTypeText(identityID) {
      var identityTypeOpts = this.state.identityTypeOpts;
      var auth = this.props.auth;

      var isVietnam = auth && auth.company && auth.company.countryCode.toUpperCase() === 'VN';

      if (identityID === 1 && isVietnam) {
        return 'CCCD';
      }
      if (identityTypeOpts && identityTypeOpts.length > 0) {
        var idx = identityTypeOpts.findIndex(function (i) {
          return i.value === identityID;
        });
        if (idx !== -1) {
          return identityTypeOpts[idx].text;
        }
      }
      return '';
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      var _this3 = this;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true }, function () {
          _this3.handleOnCheck(true);
        });
      }
    }
  }, {
    key: 'handleResetCheck',
    value: function handleResetCheck() {
      var _this4 = this;

      if (this.state.hasChanges) {
        this.setState({ hasChanges: false }, function () {
          _this4.handleOnCheck(false);
        });
      }
    }
  }, {
    key: 'fetchCompanyApp',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, _message, companyApp;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                _context.next = 3;
                return this.setLoading(true);

              case 3:
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/company/company_app/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 22;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);
                _context.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 17;
                return _context.t0.res.text();

              case 17:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 20:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 22:
                if (res.ok) {
                  _context.next = 30;
                  break;
                }

                _context.next = 25;
                return res.text();

              case 25:
                _message = _context.sent;
                _context.next = 28;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 28:
                _context.next = 34;
                break;

              case 30:
                _context.next = 32;
                return res.json();

              case 32:
                companyApp = _context.sent;

                if (companyApp !== null) {
                  this.setState({ companyApp: companyApp });
                }

              case 34:
                _context.next = 36;
                return this.setLoading(false);

              case 36:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchCompanyApp() {
        return _ref.apply(this, arguments);
      }

      return fetchCompanyApp;
    }()
  }, {
    key: 'putCustomer',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this5 = this;

        var store, _props, auth, t, _state, data, editingCustomer, identityTypeOpts, isIndonesia, validations, errMessages, idx, customerDetail, postCustomer, res, message, errorText, respondData;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                _props = this.props, auth = _props.auth, t = _props.t;
                _state = this.state, data = _state.data, editingCustomer = _state.editingCustomer, identityTypeOpts = _state.identityTypeOpts;
                isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';
                _context2.prev = 4;
                _context2.next = 7;
                return _AppForm2.default.validate(this.validation, editingCustomer);

              case 7:
                validations = _context2.sent;
                errMessages = validations.filter(function (v) {
                  return !v.isValid;
                });
                _context2.next = 11;
                return this.setComponentState({
                  errMessages: errMessages
                });

              case 11:
                if (!(errMessages.length > 0)) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 14;
                return this.setComponentState({ edit: true });

              case 14:
                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errMessages.map(function (l) {
                    return l.message;
                  }) }));
                return _context2.abrupt('return');

              case 16:
                _context2.next = 25;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2['catch'](4);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 23;
                return this.setComponentState({ edit: true });

              case 23:
                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Form validation failed. Please check your input and try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
                return _context2.abrupt('return');

              case 25:
                if (!(editingCustomer.maOwnerCompanyBranchShortName === '' || editingCustomer.maOwnerCompanyBranchID === 0 || editingCustomer.maOwnerCompanyBranchID === '' || !editingCustomer.maOwnerCompanyBranchID)) {
                  _context2.next = 28;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Customer\'s Business Unit Owner is required', { ns: _translation.TRANSLATION_FILES.translation }) }));
                return _context2.abrupt('return');

              case 28:
                if (editingCustomer.identityTypeID && typeof editingCustomer.identityTypeID === 'string') {
                  idx = -1;

                  if (identityTypeOpts && identityTypeOpts.length > 0) {
                    idx = identityTypeOpts.findIndex(function (i) {
                      return i.value === editingCustomer.identityTypeID;
                    });
                  }
                  if (idx !== -1) {
                    editingCustomer.identityTypeID = 6;
                    editingCustomer.identityPresetID = identityTypeOpts[idx].value;
                    editingCustomer.identityPresetLabel = identityTypeOpts[idx].text;
                    editingCustomer.identityPresetRegex = identityTypeOpts[idx]['data-regex'];
                  }
                }
                editingCustomer.taxTinValidationStatus = this.state.tinError === false ? 'success' : 'failed';

                if (!(!isIndonesia && editingCustomer.taxTinValidationStatus !== 'success' && editingCustomer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && !editingCustomer.isForeignCompany)) {
                  _context2.next = 33;
                  break;
                }

                store.dispatch((0, _flash.flashMessage)({
                  header: t('Invalid TIN', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Tax Identification Number is invalid', { ns: _translation.TRANSLATION_FILES.translation }),
                  icon: 'warning sign',
                  type: 'error',
                  autoHideDuration: 5000
                }));
                return _context2.abrupt('return');

              case 33:
                _context2.next = 35;
                return this.setLoading(true);

              case 35:
                customerDetail = {
                  title: this.state.hideTitle ? 'Not Applicable' : editingCustomer.title,
                  name: editingCustomer.name,
                  preferredName: editingCustomer.preferredName,
                  email: editingCustomer.email,
                  mobilePrefix: editingCustomer.mobilePrefix,
                  mobile: editingCustomer.mobile,
                  phonePrefix: editingCustomer.phonePrefix,
                  phone: editingCustomer.phone,
                  address1: editingCustomer.address1,
                  address2: editingCustomer.address2,
                  address3: editingCustomer.address3,
                  address4: editingCustomer.address4,
                  address5: editingCustomer.address5,
                  address6: editingCustomer.address6,
                  address7: editingCustomer.address7,
                  address8: editingCustomer.address8,
                  address9: editingCustomer.address9,
                  address10: editingCustomer.address10,
                  country: editingCustomer.country,
                  jobTitle: editingCustomer.jobTitle,
                  monthlyIncome: parseFloat(editingCustomer.monthlyIncome),
                  nationality: editingCustomer.nationality,
                  birthdate: editingCustomer.birthdate,
                  gender: editingCustomer.gender,
                  race: editingCustomer.race.toUpperCase() === 'Others'.toUpperCase() ? editingCustomer.raceOther : editingCustomer.race,
                  bumi: editingCustomer.bumi,
                  maritalStatus: editingCustomer.maritalStatus,
                  occupation: editingCustomer.occupation,
                  emergencyContactName: editingCustomer.emergencyContactName,
                  emergencyContactRelation: editingCustomer.emergencyContactRelation,
                  emergencyContactMobilePrefix: editingCustomer.emergencyContactMobilePrefix,
                  emergencyContactMobile: editingCustomer.emergencyContactMobile,
                  emergencyContactEmail: editingCustomer.emergencyContactEmail,
                  emergencyContactIdentity: editingCustomer.emergencyContactIdentity
                };
                postCustomer = {
                  customerDetail: customerDetail,
                  customerDetailID: data.customerDetailID,
                  id: data.id,
                  identityTypeID: editingCustomer.identityTypeID,
                  identity: editingCustomer.identity,
                  identityPresetID: editingCustomer.identityPresetID,
                  identityPresetLabel: editingCustomer.identityPresetLabel,
                  identityPresetRegex: editingCustomer.identityPresetRegex,
                  taxIdentificationNo: editingCustomer.taxIdentificationNo,
                  taxTinValidationStatus: editingCustomer.taxTinValidationStatus,
                  maOwnerCompanyBranchShortName: editingCustomer.maOwnerCompanyBranchShortName,
                  maOwnerCompanyBranchID: editingCustomer.maOwnerCompanyBranchID,
                  internalRemark: editingCustomer.internalRemark,
                  lppsaResultID: data.lppsaResultID,
                  lppsaResultStatusID: data.lppsaResultStatusID,
                  isForeignCompany: editingCustomer.isForeignCompany
                };
                res = '';
                _context2.prev = 38;
                _context2.next = 41;
                return store.dispatch((0, _fetchM.fetchM)('/customers/' + data.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(postCustomer)
                }));

              case 41:
                res = _context2.sent;
                _context2.next = 57;
                break;

              case 44:
                _context2.prev = 44;
                _context2.t1 = _context2['catch'](38);
                _context2.next = 48;
                return this.setLoading(false);

              case 48:
                Bugsnag.notifyException(_context2.t1);

                if (!(_context2.t1.res && _context2.t1.res.status >= 400 && _context2.t1.res.status < 500)) {
                  _context2.next = 55;
                  break;
                }

                _context2.next = 52;
                return _context2.t1.res.text();

              case 52:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 55:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
                return _context2.abrupt('return');

              case 57:
                if (!(!res || !res.ok)) {
                  _context2.next = 71;
                  break;
                }

                _context2.next = 60;
                return this.setLoading(false);

              case 60:
                _context2.prev = 60;
                _context2.next = 63;
                return res.text();

              case 63:
                errorText = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: errorText || t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
                _context2.next = 70;
                break;

              case 67:
                _context2.prev = 67;
                _context2.t2 = _context2['catch'](60);

                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 70:
                return _context2.abrupt('return');

              case 71:
                respondData = void 0;
                _context2.prev = 72;
                _context2.next = 75;
                return res.json();

              case 75:
                respondData = _context2.sent;
                _context2.next = 85;
                break;

              case 78:
                _context2.prev = 78;
                _context2.t3 = _context2['catch'](72);
                _context2.next = 82;
                return this.setLoading(false);

              case 82:
                Bugsnag.notifyException(_context2.t3);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error processing the response. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
                return _context2.abrupt('return');

              case 85:
                _context2.next = 87;
                return this.setComponentState({
                  loading: false,
                  edit: false
                }, function () {
                  _this5.handleResetCheck();
                });

              case 87:
                store.dispatch((0, _reactRouterRedux.push)('/customers/' + data.id + '/'));
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Customer {{name}} has been successfully updated', { ns: _translation.TRANSLATION_FILES.translation, name: respondData.customerDetail.name }) }));

              case 89:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 18], [38, 44], [60, 67], [72, 78]]);
      }));

      function putCustomer() {
        return _ref2.apply(this, arguments);
      }

      return putCustomer;
    }()
  }, {
    key: 'validateTIN',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(tinInput) {
        var _state2, editingCustomer, data, idType, query, store, res, errorMessage, _errorMessage;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _state2 = this.state, editingCustomer = _state2.editingCustomer, data = _state2.data;

                if (!(!tinInput || !editingCustomer.identityTypeID || !editingCustomer.identity)) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt('return');

              case 3:
                idType = (0, _identityTypes.getIdentityTypeOpts)().find(function (i) {
                  return i.value === editingCustomer.identityTypeID;
                }).tin_code;
                query = Object.assign({
                  tin: tinInput,
                  idType: idType,
                  idValue: editingCustomer.identity,
                  customerID: data.id
                });
                store = this.context.store;
                _context3.prev = 6;
                _context3.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/tin/validate/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token,
                    'X-Origin': this.state.origin
                  }
                }));

              case 9:
                res = _context3.sent;

                if (!(res && res.ok)) {
                  _context3.next = 14;
                  break;
                }

                this.setState({
                  tinError: false,
                  tinFound: true,
                  tinMessage: null
                });
                _context3.next = 19;
                break;

              case 14:
                _context3.next = 16;
                return res.text();

              case 16:
                errorMessage = _context3.sent;

                this.setState({
                  tinError: true,
                  tinFound: false,
                  tinMessage: errorMessage
                });
                return _context3.abrupt('return');

              case 19:
                _context3.next = 28;
                break;

              case 21:
                _context3.prev = 21;
                _context3.t0 = _context3['catch'](6);

                if (!_context3.t0.res) {
                  _context3.next = 28;
                  break;
                }

                _context3.next = 26;
                return _context3.t0.res.text();

              case 26:
                _errorMessage = _context3.sent;

                this.setState({
                  tinError: true,
                  tinFound: false,
                  tinMessage: _errorMessage
                });

              case 28:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 21]]);
      }));

      function validateTIN(_x3) {
        return _ref3.apply(this, arguments);
      }

      return validateTIN;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var _props2 = this.props,
          addressSettings = _props2.addressSettings,
          auth = _props2.auth,
          t = _props2.t;
      var _state3 = this.state,
          data = _state3.data,
          companyApp = _state3.companyApp,
          editingCustomer = _state3.editingCustomer,
          openInsufficientCreditModal = _state3.openInsufficientCreditModal;
      var store = this.context.store;

      var isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
      var isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';
      var isVietnam = auth && auth.company && auth.company.countryCode.toUpperCase() === 'VN';
      // CPI-1319: Vietnam-only no-digits rule on Full Name ([] elsewhere and for a company name).
      var vnFullNameRules = (0, _vietnam.vnFullNameValidations)(auth, editingCustomer.identityTypeID, t);
      var isMalaysiaAddress = editingCustomer.country.toUpperCase() === 'MY';
      var enabledAddressSettings = addressSettings.data.filter(function (as) {
        return as.enabled;
      });
      var mustValidTin = editingCustomer.identityTypeID === 4;

      var tinValidation = [];
      if (isIndonesia) {
        tinValidation = [{
          validate: _webValidations.matchRegex,
          option: { validRegex: _regex.REGEX_NPWP_ID }
        }];
      } else if (isMalaysia) {
        tinValidation = [{ validate: _webValidations.matchRegex,
          option: { validRegex: _regex.REGEX_TIN_VALID }
        }];
      }
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_InsufficientCreditCheck2.default, {
          open: openInsufficientCreditModal,
          onClose: function onClose(e) {
            return _this6.handleCloseInsufficientCreditModal(e);
          }
        }),
        _react2.default.createElement(_NavBar2.default, {
          header: t('Overview')
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { active: this.state.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Customer Information')
              ),
              _react2.default.createElement(_EditableBox2.default, {
                editable: true,
                isEditing: this.state.edit,
                loading: this.state.loading,
                onEdit: this.handleEditCustomer,
                onClick: this.handleUpdateCustomer,
                onCancel: this.handleResetCustomer,
                content: function content(_ref4) {
                  var isEditing = _ref4.isEditing,
                      onConfirm = _ref4.onConfirm;
                  return _react2.default.createElement(
                    _semanticUiReact.Grid,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(_semanticUiReact.Dimmer, { active: _this6.state.isEditing, inverted: true }),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 16, computer: 16 },
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Row,
                            { stretched: true },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { width: 16 },
                              _react2.default.createElement(
                                _semanticUiReact.Header,
                                { as: 'h2', textAlign: 'center' },
                                data.customerDetail.title === 'Not Applicable' ? '' : t(data.customerDetail.title, { ns: _translation.TRANSLATION_FILES.constants }),
                                ' ',
                                data.customerDetail.name,
                                _react2.default.createElement(
                                  _semanticUiReact.Header.Subheader,
                                  null,
                                  _react2.default.createElement(
                                    'i',
                                    null,
                                    (0, _displayTime.displayMoment)(data.createdAt, auth && auth.company && auth.company.countryCode).locale(_i18next2.default.language).format('MMMM Do YYYY, h:mm a')
                                  )
                                )
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { width: 16 },
                              _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, className: 'tablet-hide' })
                            )
                          )
                        ),
                        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, className: 'large-hide small-hide' })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 16, computer: 16 },
                        _react2.default.createElement(
                          _AppForm2.default,
                          {
                            error: _this6.state.errMessages.length > 0,
                            onSubmit: onConfirm,
                            ref: function ref(_ref5) {
                              _this6.form = _ref5;
                            }
                          },
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Row,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { mobile: 16, tablet: 8, computer: 8 },
                                isEditing && _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 8 },
                                    _react2.default.createElement(_semanticUiReact.Form.Select, {
                                      fluid: true,
                                      onChange: _this6.handleChange,
                                      placeholder: (0, _translation2.translateModels)(t, 'identityTypeID', 'customer') + '*',
                                      name: 'identityTypeID',
                                      options: _this6.state.identityTypeOpts.map(function (i) {
                                        return _extends({}, i, { text: t(i.text, { ns: _translation.TRANSLATION_FILES.screens }) });
                                      }),
                                      selection: true,
                                      selectOnBlur: false,
                                      value: editingCustomer.identityTypeID
                                    }),
                                    isMalaysia && editingCustomer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && _react2.default.createElement(
                                      _semanticUiReact.Form.Field,
                                      null,
                                      _react2.default.createElement(
                                        'div',
                                        { style: { display: 'flex', justifyContent: 'start' } },
                                        _react2.default.createElement(_semanticUiReact.Checkbox, {
                                          label: t('Foreign Company', { ns: _translation.TRANSLATION_FILES.screens }),
                                          onChange: function onChange(e, d) {
                                            var setStateTin = d.checked ? _tin.FOREIGN_BUYER_GENERIC_TIN : '';
                                            _this6.setState(function (prevState) {
                                              return {
                                                editingCustomer: _extends({}, prevState.editingCustomer, {
                                                  taxIdentificationNo: setStateTin,
                                                  isForeignCompany: d.checked
                                                })
                                              };
                                            }, function () {
                                              _this6.handleTinInput({ target: { value: d.checked ? _this6.state.editingCustomer.taxIdentificationNo : '', tinFound: false } });
                                            });
                                          },
                                          checked: _this6.state.editingCustomer.isForeignCompany
                                        })
                                      )
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 8 },
                                    _react2.default.createElement(_AppForm2.default.Input, {
                                      name: 'identity',
                                      disabled: _this6.state.editingCustomer.identityTypeID === '',
                                      validation: [_webValidations.required, {
                                        validate: _webValidations.identity,
                                        option: _this6.identityValidation()
                                      }],
                                      ref: _this6.validation.identity,
                                      onChange: _this6.handleChange,
                                      validateLabel: (0, _translation2.translateModels)(t, 'identity', 'customer'),
                                      placeholder: (0, _translation2.translateModels)(t, 'identity', 'customer') + '*',
                                      type: 'text',
                                      value: editingCustomer.identity
                                    })
                                  )
                                ),
                                isEditing && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                                isEditing && !_this6.state.hideTitle ? _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'title', 'customer'),
                                      isEditing && '*'
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    _react2.default.createElement(
                                      _AppForm2.default.Validate,
                                      {
                                        validation: [_webValidations.required],
                                        ref: _this6.validation.title,
                                        onChange: _this6.handleChange,
                                        validateLabel: (0, _translation2.translateModels)(t, 'title', 'customer')
                                      },
                                      _react2.default.createElement(_semanticUiReact.Form.Select, {
                                        name: 'title',
                                        onChange: _this6.handleChange,
                                        options: _customerTitles2.default.map(function (i) {
                                          return _extends({}, i, { text: t(i.text, { ns: _translation.TRANSLATION_FILES.constants }) });
                                        }),
                                        placeholder: t('Select Title') + '*',
                                        search: true,
                                        selectOnBlur: false,
                                        value: editingCustomer.title
                                      })
                                    )
                                  )
                                ) : null,
                                isEditing ? _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }) : null,
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      t(editingCustomer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? 'Company Name' : 'Full Name'),
                                      isEditing && '*'
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                      autoComplete: 'off',
                                      name: 'name',
                                      onChange: _this6.handleChange,
                                      placeholder: t(editingCustomer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? 'Company Name' : 'Full Name') + '*',
                                      ref: _this6.validation.name,
                                      validation: [_webValidations.required].concat(_toConsumableArray(vnFullNameRules)),
                                      value: editingCustomer.name,
                                      validateLabel: t(editingCustomer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? 'Company Name' : 'Full Name')
                                    }) : _react2.default.createElement(
                                      'i',
                                      null,
                                      data.customerDetail.name
                                    )
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                                isMalaysia && (isEditing ? editingCustomer.identityTypeID : data.identityTypeID) === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && _react2.default.createElement(
                                  _react2.default.Fragment,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    null,
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 6 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        t('Foreign Company', { ns: _translation.TRANSLATION_FILES.screens })
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'right', width: 10 },
                                      _react2.default.createElement(
                                        'i',
                                        null,
                                        t(data.isForeignCompany ? 'Yes' : 'No')
                                      )
                                    )
                                  ),
                                  _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider })
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      t(editingCustomer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? 'Contact Person' : 'Preferred Name'),
                                      isEditing && '*'
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                      autoComplete: 'off',
                                      name: 'preferredName',
                                      onChange: _this6.handleChange,
                                      placeholder: t(editingCustomer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? 'Contact Person' : 'Preferred Name') + '*',
                                      ref: _this6.validation.preferredName,
                                      validation: editingCustomer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? [_webValidations.required].concat(_toConsumableArray((0, _vietnam.vnPreferredNameValidations)(auth, t))) : [_webValidations.required, {
                                        validate: _webValidations.stringLength,
                                        option: {
                                          max: 15
                                        }
                                      }].concat(_toConsumableArray((0, _vietnam.vnPreferredNameValidations)(auth, t))),
                                      value: editingCustomer.preferredName,
                                      validateLabel: t(editingCustomer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN ? 'Contact Person' : 'Preferred Name')
                                    }) : _react2.default.createElement(
                                      'i',
                                      null,
                                      data.customerDetail.preferredName
                                    )
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'email', 'customer')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                      autoComplete: 'off',
                                      name: 'email',
                                      onChange: _this6.handleChange,
                                      placeholder: (0, _translation2.translateModels)(t, 'email', 'customer'),
                                      validation: [_webValidations.email],
                                      ref: _this6.validation.email,
                                      value: _this6.state.editingCustomer.email,
                                      validateLabel: (0, _translation2.translateModels)(t, 'email', 'customer')
                                    }) : _react2.default.createElement(
                                      'a',
                                      { href: 'mailto:' + data.customerDetail.email },
                                      data.customerDetail.email
                                    )
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'mobile', 'customer'),
                                      isEditing && '*'
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(
                                      _semanticUiReact.Grid,
                                      { className: 'compact' },
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { width: 16 },
                                        _react2.default.createElement(
                                          _AppForm2.default.Validate,
                                          {
                                            validation: [_webValidations.required],
                                            ref: _this6.validation.mobilePrefix,
                                            onChange: _this6.handleChange,
                                            validateLabel: (0, _translation2.translateModels)(t, 'mobilePrefix', 'customer')
                                          },
                                          _react2.default.createElement(_semanticUiReact.Form.Select, {
                                            name: 'mobilePrefix',
                                            onChange: _this6.handleChange,
                                            options: _intlCallCodes2.default,
                                            search: true,
                                            selectOnBlur: false,
                                            value: editingCustomer.mobilePrefix
                                          })
                                        )
                                      ),
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { width: 16 },
                                        _react2.default.createElement(_PhoneInput2.default, {
                                          autoComplete: 'off',
                                          name: 'mobile',
                                          onChange: _this6.handleChange,
                                          placeholder: editingCustomer.mobilePrefix === '60' ? (0, _translation2.translateModels)(t, 'mobile', 'customer') + '* (e.g. 196756118)' : (0, _translation2.translateModels)(t, 'mobile', 'customer') + '*',
                                          prefix: editingCustomer.mobilePrefix,
                                          ref: _this6.validation.mobile,
                                          type: 'tel',
                                          validation: [_webValidations.required, {
                                            validate: _webValidations.phoneNumber,
                                            option: editingCustomer.mobilePrefix === 'other' ? {} : {
                                              isMobile: true,
                                              phonePrefix: editingCustomer.mobilePrefix,
                                              validRegex: (0, _phone.getPhoneValidRegex)(_this6.state.phoneValidationPresets, editingCustomer.mobilePrefix, 'mobile')
                                            }
                                          }],
                                          value: editingCustomer.mobile,
                                          validateLabel: (0, _translation2.translateModels)(t, 'mobile', 'customer')
                                        })
                                      )
                                    ) : _react2.default.createElement(_Phone2.default, {
                                      mobilePrefix: data.customerDetail.mobilePrefix,
                                      mobile: data.customerDetail.mobile
                                    })
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      t('House/Office Phone')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(
                                      _semanticUiReact.Grid,
                                      { className: 'compact' },
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { width: 16 },
                                        _react2.default.createElement(_semanticUiReact.Form.Select, {
                                          name: 'phonePrefix',
                                          onChange: _this6.handleChange,
                                          options: _intlCallCodes2.default,
                                          search: true,
                                          selectOnBlur: false,
                                          value: editingCustomer.phonePrefix
                                        })
                                      ),
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { width: 16 },
                                        _react2.default.createElement(_PhoneInput2.default, {
                                          autoComplete: 'off',
                                          name: 'phone',
                                          onChange: _this6.handleChange,
                                          placeholder: editingCustomer.phonePrefix === '60' ? (0, _translation2.translateModels)(t, 'phone', 'customer') + ' (e.g. 196756118)' : t('House/Office Phone'),
                                          prefix: editingCustomer.phonePrefix,
                                          ref: _this6.validation.phone,
                                          type: 'tel',
                                          value: editingCustomer.phone,
                                          validation: [{
                                            validate: _webValidations.phoneNumber,
                                            option: editingCustomer.phonePrefix === 'other' ? {} : {
                                              phonePrefix: editingCustomer.phonePrefix,
                                              validRegex: (0, _phone.getPhoneValidRegex)(_this6.state.phoneValidationPresets, editingCustomer.phonePrefix, 'phone')
                                            }
                                          }],
                                          validateLabel: t('House/Office Phone')
                                        })
                                      )
                                    ) : _react2.default.createElement(_Phone2.default, {
                                      mobilePrefix: data.customerDetail.phonePrefix,
                                      mobile: data.customerDetail.phone
                                    })
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'jobTitle', 'customer')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                      autoComplete: 'off',
                                      name: 'jobTitle',
                                      onChange: _this6.handleChange,
                                      placeholder: (0, _translation2.translateModels)(t, 'jobTitle', 'customer'),
                                      value: editingCustomer.jobTitle
                                    }) : _react2.default.createElement(
                                      'i',
                                      null,
                                      data.customerDetail.jobTitle
                                    )
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'monthlyIncome', 'customer')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                      type: 'number',
                                      autoComplete: 'off',
                                      name: 'monthlyIncome',
                                      onChange: _this6.handleChange,
                                      placeholder: (0, _translation2.translateModels)(t, 'monthlyIncome', 'customer'),
                                      ref: _this6.validation.monthlyIncome,
                                      validation: [{
                                        validate: _webValidations.numericRange,
                                        option: {
                                          min: 0
                                        }
                                      }],
                                      value: editingCustomer.monthlyIncome,
                                      validateLabel: (0, _translation2.translateModels)(t, 'monthlyIncome', 'customer')
                                    }) : _react2.default.createElement(
                                      'i',
                                      null,
                                      _react2.default.createElement(_LoanAmount2.default, {
                                        format: '0,000,000',
                                        amount: data.customerDetail.monthlyIncome,
                                        prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                                      })
                                    )
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                                !isEditing && _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 7 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      _this6.getIdentityTypeText(data.identityTypeID)
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 9 },
                                    _react2.default.createElement(
                                      'i',
                                      null,
                                      _react2.default.createElement(_Identity2.default, {
                                        type: data.identityTypeID,
                                        identity: data.identity
                                      })
                                    )
                                  )
                                ),
                                !isEditing && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                                _this6.hasAccess() && _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'internalRemark', 'customer')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                                      name: 'internalRemark',
                                      value: editingCustomer.internalRemark,
                                      onChange: _this6.handleChange
                                    }) : _react2.default.createElement(
                                      _MarkdownText2.default,
                                      null,
                                      data.internalRemark || '-'
                                    )
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                                _this6.hasAccess() ? _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'maOwnerCompanyBranchShortName', 'customer'),
                                      isEditing && '*'
                                    )
                                  ),
                                  isEditing ? _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { width: 10 },
                                    _react2.default.createElement(_SearchBranch2.default, {
                                      onClear: _this6.handleBranchClear,
                                      onSelect: _this6.handleBranchSelect,
                                      selectedValue: _this6.getSelectedBranchValue()
                                    })
                                  ) : _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    data.maOwnerCompanyBranchShortName ? data.maOwnerCompanyBranchShortName : '-'
                                  )
                                ) : '',
                                _this6.hasAccess() && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider })
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { mobile: 16, tablet: 8, computer: 8 },
                                isEditing && (isMalaysia || isIndonesia) && _react2.default.createElement(
                                  'div',
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    null,
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 6 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        isMalaysia && 'Tax Identification Number (TIN)',
                                        isIndonesia && 'Nomor Pokok Wajib Pajak (NPWP)'
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'right', width: 10 },
                                      _react2.default.createElement(_TinFieldInput2.default, {
                                        isIndonesia: isIndonesia,
                                        value: editingCustomer.taxIdentificationNo,
                                        errMessage: _this6.state.tinMessage,
                                        style: { width: '100%', marginBottom: '1em' },
                                        isLoading: _this6.state.validatingTin,
                                        tinError: isMalaysia && _this6.state.tinError,
                                        ref: _this6.validation.taxIdentificationNo,
                                        onChange: _this6.handleTinInput,
                                        hideLabel: true,
                                        required: !isIndonesia && mustValidTin && !editingCustomer.isForeignCompany,
                                        validation: tinValidation
                                        // readOnly={this.state.tinFound}
                                        , identityType: editingCustomer.identityTypeID,
                                        identityValue: editingCustomer.identity
                                      })
                                    )
                                  ),
                                  _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider })
                                ),
                                _lodash2.default.flatMap(enabledAddressSettings.map(function (as, idx) {
                                  var key = _lodash2.default.camelCase(as.columnName);
                                  var addressLabel = as.label.toLowerCase();
                                  var isRequired = as.required;
                                  var validations = [{
                                    validate: _webValidations.stringLength,
                                    option: {
                                      max: 256
                                    }
                                  }];

                                  // When company is Vietnam: apply country-dependent logic for state field
                                  if (isVietnam && addressLabel === 'state') {
                                    if (isMalaysiaAddress) {
                                      // Malaysia selected: keep as "State", required
                                      isRequired = true;
                                    } else {
                                      // Non-Malaysia selected: change to "City/Province", optional
                                      addressLabel = 'cityOrProvince';
                                      isRequired = false;
                                    }
                                  } else if (isVietnam && addressLabel === 'city' && !isMalaysiaAddress) {
                                    addressLabel = 'ward';
                                    isRequired = false;
                                  } else if (isVietnam && addressLabel === 'postcode' && !isMalaysiaAddress) {
                                    addressLabel = 'postalCode';
                                    isRequired = false;
                                  }

                                  if (isRequired) {
                                    validations.push(_webValidations.required);
                                  }

                                  var label = '' + (0, _translation2.translateModels)(_this6.props.t, addressLabel, 'project') + (isRequired && isEditing ? '*' : '');
                                  return _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    { key: idx },
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 6 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        label
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'right', width: 10 },
                                      isEditing ? isMalaysiaAddress && as.label.toLowerCase() === 'state' ? _react2.default.createElement(
                                        _AppForm2.default.Validate,
                                        {
                                          validation: isRequired ? [_webValidations.required] : null,
                                          ref: _this6.validation[key],
                                          onChange: _this6.handleChange,
                                          validateLabel: as.label
                                        },
                                        _react2.default.createElement(_semanticUiReact.Form.Select, {
                                          name: key,
                                          fluid: true,
                                          options: _states2.default,
                                          onChange: _this6.handleChange,
                                          placeholder: t('Select', { ns: _translation.TRANSLATION_FILES.translation }) + ' ' + label.toLowerCase(),
                                          search: true,
                                          selectOnBlur: false,
                                          value: editingCustomer[key]
                                        })
                                      ) : _react2.default.createElement(_AppForm2.default.Input, {
                                        autoComplete: 'off',
                                        name: key,
                                        onChange: _this6.handleChange,
                                        placeholder: label,
                                        ref: _this6.validation[key],
                                        validation: validations,
                                        value: editingCustomer[key],
                                        validateLabel: as.label
                                      }) : _react2.default.createElement(
                                        'i',
                                        null,
                                        isMalaysiaAddress && as.label.toLowerCase() === 'state' ? _this6.valueToText(_states2.default, data.customerDetail[key]) : data.customerDetail[key] ? data.customerDetail[key] : '-'
                                      )
                                    )
                                  );
                                }), function (value, idx) {
                                  return [value, _react2.default.createElement(_semanticUiReact.Divider, { key: 'divider_' + idx, style: styles.divider })];
                                }),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'region', 'project')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(
                                      _AppForm2.default.Validate,
                                      {
                                        // validation={[required]}
                                        ref: _this6.validation.region,
                                        onChange: function onChange(e, stateData) {
                                          // Reset state input field
                                          var as = enabledAddressSettings.find(function (a) {
                                            return a.label.toLowerCase() === 'state';
                                          });
                                          if (as) {
                                            var key = _lodash2.default.camelCase(as.columnName);
                                            if (editingCustomer[key]) {
                                              editingCustomer[key] = '';
                                              _this6.setState({ editingCustomer: editingCustomer });
                                            }
                                          }
                                          _this6.handleChange(e, stateData);
                                        },
                                        validateLabel: (0, _translation2.translateModels)(t, 'region', 'project')
                                      },
                                      _react2.default.createElement(_semanticUiReact.Form.Select, {
                                        autoComplete: 'off',
                                        fluid: true,
                                        name: 'region',
                                        options: [],
                                        placeholder: 'Select ' + (0, _translation2.translateModels)(t, 'region', 'project'),
                                        search: true,
                                        selectOnBlur: false,
                                        value: editingCustomer.region
                                      })
                                    ) : data.customerDetail ? data.customerDetail.region : '-'
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'country', 'customer'),
                                      isEditing && '*'
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(
                                      _AppForm2.default.Validate,
                                      {
                                        validation: [_webValidations.required],
                                        ref: _this6.validation.country,
                                        onChange: function onChange(e, stateData) {
                                          // Reset state input field
                                          var as = enabledAddressSettings.find(function (a) {
                                            return a.label.toLowerCase() === 'state';
                                          });
                                          if (as) {
                                            var key = _lodash2.default.camelCase(as.columnName);
                                            if (editingCustomer[key]) {
                                              editingCustomer[key] = '';
                                              _this6.setState({ editingCustomer: editingCustomer });
                                            }
                                          }
                                          _this6.handleChange(e, stateData);
                                        },
                                        validateLabel: (0, _translation2.translateModels)(t, 'country', 'customer')
                                      },
                                      _react2.default.createElement(_semanticUiReact.Form.Select, {
                                        autoComplete: 'off',
                                        fluid: true,
                                        name: 'country',
                                        options: _countries2.SELECT_COUNTRIES,
                                        placeholder: t('Select Country') + '*',
                                        search: true,
                                        selectOnBlur: false,
                                        value: editingCustomer.country
                                      })
                                    ) : (0, _countries.getCountryName)(data.customerDetail ? data.customerDetail.country : null)
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'nationality', 'customer')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(_semanticUiReact.Form.Select, {
                                      name: 'nationality',
                                      onChange: _this6.handleChange,
                                      options: _countries2.SELECT_NATIONALITY,
                                      placeholder: (0, _translation2.translateModels)(t, 'nationality', 'customer'),
                                      search: true,
                                      selectOnBlur: false,
                                      selection: true,
                                      value: editingCustomer.nationality
                                    }) : data.customerDetail ? _this6.valueToText(_countries2.SELECT_NATIONALITY, data.customerDetail.nationality) : '-'
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                                !isEditing && (isMalaysia || isIndonesia) && _react2.default.createElement(
                                  'div',
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    null,
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      { textAlign: 'left', width: 6 },
                                      _react2.default.createElement(
                                        'b',
                                        null,
                                        isMalaysia && 'Tax Identification Number (TIN)',
                                        isIndonesia && 'Nomor Pokok Wajib Pajak (NPWP)'
                                      )
                                    ),
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Column,
                                      {
                                        textAlign: 'right',
                                        width: 10
                                      },
                                      _react2.default.createElement(
                                        'span',
                                        { style: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center' } },
                                        data.taxIdentificationNo ? _react2.default.createElement(
                                          'div',
                                          null,
                                          isMalaysia && _react2.default.createElement(_semanticUiReact.Icon, {
                                            name: data.taxTinValidationStatus === 'success' ? 'check circle' : 'remove circle',
                                            color: data.taxTinValidationStatus === 'success' ? 'green' : 'red',
                                            style: { marginLeft: '0.5em' }
                                          }),
                                          data.taxIdentificationNo
                                        ) : '-'
                                      )
                                    )
                                  ),
                                  _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider })
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'birthdate', 'customer')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(_InputBirthdate2.default, {
                                      date: editingCustomer.birthdate,
                                      onSelectDay: function onSelectDay(day) {
                                        editingCustomer.birthdate = day;
                                        _this6.setState({ editingCustomer: editingCustomer });
                                      }
                                    }) : data.customerDetail ? data.customerDetail.birthdate : '-'
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'gender', 'customer')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(_semanticUiReact.Form.Select, {
                                      name: 'gender',
                                      onChange: _this6.handleChange,
                                      options: _gender.GENDER.map(function (o) {
                                        return _extends({}, o, {
                                          text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants })
                                        });
                                      }),
                                      placeholder: t('Select Gender'),
                                      search: true,
                                      selectOnBlur: false,
                                      selection: true,
                                      value: editingCustomer.gender
                                    }) : data.customerDetail ? t(_this6.valueToText(_gender.GENDER, data.customerDetail.gender), { ns: _translation.TRANSLATION_FILES.constants }) : '-'
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'maritalStatus', 'customer')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(_semanticUiReact.Form.Select, {
                                      name: 'maritalStatus',
                                      onChange: _this6.handleChange,
                                      options: _maritalStatus.MARITAL_STATUS.map(function (o) {
                                        return _extends({}, o, {
                                          text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants })
                                        });
                                      }),
                                      placeholder: t('Select Marital Status'),
                                      search: true,
                                      selectOnBlur: false,
                                      selection: true,
                                      value: editingCustomer.maritalStatus
                                    }) : data.customerDetail ? t(_this6.valueToText(_maritalStatus.MARITAL_STATUS, data.customerDetail.maritalStatus), { ns: _translation.TRANSLATION_FILES.constants }) : '-'
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider })
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Row,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { mobile: 16, tablet: 8, computer: 8 },
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'emergencyContactName', 'customer')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                      autoComplete: 'off',
                                      name: 'emergencyContactName',
                                      onChange: _this6.handleChange,
                                      placeholder: (0, _translation2.translateModels)(t, 'emergencyContactName', 'customer'),
                                      value: editingCustomer.emergencyContactName
                                    }) : data.customerDetail ? data.customerDetail.emergencyContactName : '-'
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'emergencyContactRelation', 'customer')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                      autoComplete: 'off',
                                      name: 'emergencyContactRelation',
                                      onChange: _this6.handleChange,
                                      placeholder: (0, _translation2.translateModels)(t, 'emergencyContactRelation', 'customer'),
                                      value: editingCustomer.emergencyContactRelation
                                    }) : data.customerDetail ? data.customerDetail.emergencyContactRelation : '-'
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'emergencyContactMobile', 'customer')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(
                                      'div',
                                      null,
                                      _react2.default.createElement(
                                        _AppForm2.default.Validate,
                                        {
                                          ref: _this6.validation.emergencyContactMobilePrefix,
                                          onChange: _this6.handleChange,
                                          validateLabel: (0, _translation2.translateModels)(t, 'emergencyContactMobilePrefix', 'customer')
                                        },
                                        _react2.default.createElement(_semanticUiReact.Form.Select, {
                                          name: 'emergencyContactMobilePrefix',
                                          onChange: _this6.handleChange,
                                          options: _intlCallCodes2.default,
                                          search: true,
                                          selectOnBlur: false,
                                          value: editingCustomer.emergencyContactMobilePrefix
                                        })
                                      ),
                                      _react2.default.createElement(_PhoneInput2.default, {
                                        autoComplete: 'off',
                                        name: 'emergencyContactMobile',
                                        onChange: _this6.handleChange,
                                        placeholder: (0, _translation2.translateModels)(t, 'emergencyContactMobile', 'customer'),
                                        prefix: editingCustomer.emergencyContactMobilePrefix,
                                        ref: _this6.validation.emergencyContactMobile,
                                        type: 'tel',
                                        validation: [{
                                          validate: _webValidations.phoneNumber,
                                          option: editingCustomer.emergencyContactMobilePrefix === 'other' ? {} : {
                                            isMobile: true,
                                            phonePrefix: editingCustomer.emergencyContactMobilePrefix,
                                            validRegex: (0, _phone.getPhoneValidRegex)(_this6.state.phoneValidationPresets, editingCustomer.emergencyContactMobilePrefix, 'mobile')
                                          }
                                        }],
                                        value: editingCustomer.emergencyContactMobile,
                                        validateLabel: (0, _translation2.translateModels)(t, 'emergencyContactMobile', 'customer')
                                      })
                                    ) : data.customerDetail ? _react2.default.createElement(_Phone2.default, {
                                      mobilePrefix: data.customerDetail.emergencyContactMobilePrefix,
                                      mobile: data.customerDetail.emergencyContactMobile
                                    }) : '-'
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider, className: 'large-hide small-hide tablet-hide' })
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { mobile: 16, tablet: 8, computer: 8 },
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'emergencyContactEmail', 'customer')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                      autoComplete: 'off',
                                      name: 'emergencyContactEmail',
                                      type: 'email',
                                      onChange: _this6.handleChange,
                                      placeholder: (0, _translation2.translateModels)(t, 'emergencyContactEmail', 'customer'),
                                      validation: [_webValidations.email],
                                      ref: _this6.validation.emergencyContactEmail,
                                      value: editingCustomer.emergencyContactEmail
                                    }) : data.customerDetail ? data.customerDetail.emergencyContactEmail : '-'
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'left', width: 6 },
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      (0, _translation2.translateModels)(t, 'emergencyContactIdentity', 'customer')
                                    )
                                  ),
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { textAlign: 'right', width: 10 },
                                    isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                      autoComplete: 'off',
                                      name: 'emergencyContactIdentity',
                                      onChange: _this6.handleChange,
                                      placeholder: (0, _translation2.translateModels)(t, 'emergencyContactIdentity', 'customer'),
                                      value: editingCustomer.emergencyContactIdentity
                                    }) : data.customerDetail ? data.customerDetail.emergencyContactIdentity : '-'
                                  )
                                ),
                                _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider, className: 'large-hide small-hide tablet-hide' })
                              )
                            )
                          )
                        )
                      )
                    )
                  );
                }
              })
            )
          ),
          data.identityTypeID === 1 && this.props.auth.creditCheckAccess && _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { className: 'dark credit-check', color: 'grey', inverted: true, secondary: true, textAlign: 'center' },
                _react2.default.createElement(
                  _semanticUiReact.Divider,
                  { horizontal: true, inverted: true },
                  'Credit Check'
                ),
                data.customerCreditReportID ? _react2.default.createElement(_CreditCheckScores2.default, _extends({}, data.customerCreditReport, {
                  editClick: function editClick() {
                    store.dispatch((0, _reactRouterRedux.push)('/customers/' + data.id + '/income/' + data.income.id + '/'));
                  },
                  auth: this.props.auth,
                  allowBranchLeaderDownload: companyApp ? companyApp.allowBranchLeaderDownload : false,
                  allowAgentDownload: companyApp ? companyApp.allowAgentDownload : false,
                  allowStaffDownload: companyApp ? companyApp.allowStaffDownload : false,
                  openHTML: this.handleOpenHTML,
                  netIncome: data.income && data.income.netIncome
                })) : null,
                _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { color: 'black', inverted: true, secondary: true, style: { marginTop: '2em' } },
                  _react2.default.createElement(
                    _semanticUiReact.Header,
                    {
                      as: 'h3',
                      style: { margin: '1.5em 0' }
                    },
                    'Help purchasers know their loan eligibility in 4 easy steps',
                    _react2.default.createElement(
                      _semanticUiReact.Header.Subheader,
                      { style: { marginTop: '0.25em' } },
                      'Advice purchasers based on their credit score'
                    )
                  ),
                  _react2.default.createElement(_CreditCheckSplash2.default, {
                    actionNode: _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      { textAlign: 'center' },
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        {
                          mobile: 16,
                          tablet: 6,
                          computer: data.customerCreditReportID ? 5 : 4
                        },
                        _react2.default.createElement(
                          _semanticUiReact.Button,
                          {
                            as: _reactRouter.Link,
                            fluid: true,
                            positive: true,
                            disabled: this.state.loading,
                            onClick: this.handleCheckAvailableCredits
                          },
                          _react2.default.createElement(
                            'i',
                            { className: 'icon' },
                            _react2.default.createElement('img', { src: '/assets/images/icons/credit_check_small.svg', alt: '' })
                          ),
                          data.customerCreditReportID ? 'Generate New Credit Check' : 'Run Credit Check'
                        )
                      )
                    )
                  })
                )
              )
            )
          ),
          isPRS && data.identityTypeID === 1 ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { paddingTop: '0' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 16 },
              _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
              _react2.default.createElement(_LPPSAChecker2.default, {
                data: data,
                token: this.props.token,
                type: 'customer',
                loading: this.state.loading,
                onChange: this.handleOnChangeLPPSA
              })
            )
          ) : '',
          this.hasAccess() && _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Customer Bookings')
              ),
              _react2.default.createElement(_CustomerBookings2.default, {
                params: this.props.params,
                location: this.props.location
              })
            )
          )
        )
      );
    }
  }]);

  return Overview;
}(_react.Component);

Overview.contextTypes = {
  store: _propTypes2.default.object
};
Overview.propTypes = {
  token: _propTypes2.default.string,
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isDeveloperStaff: _propTypes2.default.bool,
    isExternalAgentLeader: _propTypes2.default.bool,
    isExternalAgent: _propTypes2.default.bool,
    isExternalAgencyAdmin: _propTypes2.default.bool,
    creditCheckAccess: _propTypes2.default.bool,
    companyBranch: _propTypes2.default.shape({
      service_company_branch_id: _propTypes2.default.string
    }),
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  addressSettings: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  customOptions: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  onCheck: _propTypes2.default.func,
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};

Overview.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    addressSettings: state.addressSettings,
    identityPresets: state.identityPresets,
    phoneValidationPresets: state.phoneValidationPresets,
    customOptions: state.customOptions
  };
};

Overview.defaultCustomerData = {
  id: '',
  customerID: '',
  customerDetailID: '',
  identityTypeID: '',
  identity: '',
  internalRemark: '',
  lppsaResult: {
    name: '',
    key: ''
  },
  lppsaResultID: '',
  lppsaResultStatusID: ''
};
Overview.defaultCustomerDetailData = {
  title: '',
  name: '',
  preferredName: '',
  email: '',
  mobilePrefix: '',
  mobile: '',
  phonePrefix: '',
  phone: '',
  address1: '',
  address2: '',
  address3: '',
  address4: '',
  address5: '',
  address6: '',
  address7: '',
  address8: '',
  address9: '',
  address10: '',
  country: '',
  jobTitle: '',
  monthlyIncome: '',
  nationality: '',
  birthdate: '',
  gender: '',
  race: '',
  bumi: '',
  maritalStatus: '',
  occupation: '',
  emergencyContactName: '',
  emergencyContactRelation: '',
  emergencyContactMobilePrefix: '60',
  emergencyContactMobile: '',
  emergencyContactEmail: '',
  emergencyContactIdentity: ''
};
Overview.defaultValues = {
  identityTypeID: null,
  identity: '',
  identityPresetID: '',
  identityPresetLabel: '',
  identityPresetRegex: '',
  taxIdentificationNo: '',
  taxTinValidationStatus: 'failed',
  title: '',
  name: '',
  preferredName: '',
  email: '',
  mobilePrefix: '60',
  mobile: '',
  phonePrefix: '60',
  phone: '',
  address1: '',
  address2: '',
  address3: '',
  address4: '',
  address5: '',
  address6: '',
  address7: '',
  address8: '',
  address9: '',
  address10: '',
  country: '',
  jobTitle: '',
  monthlyIncome: '',
  nationality: '',
  birthdate: '',
  gender: '',
  race: '',
  raceOther: '',
  bumi: '',
  maritalStatus: '',
  occupation: '',
  emergencyContactName: '',
  emergencyContactRelation: '',
  emergencyContactMobilePrefix: '60',
  emergencyContactMobile: '',
  emergencyContactEmail: '',
  emergencyContactIdentity: '',
  isForeignCompany: false,
  maOwnerCompanyBranchID: 0,
  maOwnerCompanyBranchShortName: ''
};

Overview.getPropsToState = function (props) {
  var loading = props.loading;
  var data = Object.assign({}, Overview.defaultCustomerData, props.data || {});

  var hideTitle = false;
  var customOptions = props.customOptions.data;
  if (customOptions.length > 0) {
    var hideTitleOpt = customOptions.find(function (o) {
      return o.name === 'hide_purchaser_title';
    });
    if (hideTitleOpt) {
      hideTitle = hideTitleOpt.value === 'true';
    }
  }
  if (hideTitle) {
    Overview.defaultCustomerDetailData.title = 'Not Applicable';
    Overview.defaultValues.title = 'Not Applicable';
  }

  var defaultCountryPhoneCode = '60';
  var defaultCountryAddressCode = 'my';
  var auth = props.auth;
  if (auth && (0, _companies.isForeignCompany)(auth.company)) {
    var idx = _intlFlagCodes2.default.findIndex(function (f) {
      return f.countryCode === auth.company.countryCode;
    });
    if (idx !== -1) {
      defaultCountryPhoneCode = _intlFlagCodes2.default[idx].value;
      defaultCountryAddressCode = _intlFlagCodes2.default[idx].countryCode;
    }
  }
  if (!data.customerDetailID) {
    data.customerDetail = Object.assign({}, Overview.defaultCustomerDetailData);
    data.customerDetail.emergencyContactMobilePrefix = defaultCountryPhoneCode;
    data.customerDetail.country = defaultCountryAddressCode;
  }
  var dataEditingCustomer = {
    identityTypeID: data.identityTypeID,
    identity: data.identity,
    identityPresetID: data.identityPresetID,
    identityPresetLabel: data.identityPresetLabel,
    identityPresetRegex: data.identityPresetRegex,
    taxIdentificationNo: data.taxIdentificationNo,
    taxTinValidationStatus: data.taxTinValidationStatus,
    title: hideTitle ? 'Not Applicable' : data.customerDetail.title,
    name: data.customerDetail.name,
    preferredName: data.customerDetail.preferredName,
    email: data.customerDetail.email,
    mobilePrefix: data.customerDetail.mobilePrefix,
    mobile: data.customerDetail.mobile,
    phonePrefix: data.customerDetail.phonePrefix,
    phone: data.customerDetail.phone,
    address1: data.customerDetail.address1,
    address2: data.customerDetail.address2,
    address3: data.customerDetail.address3,
    address4: data.customerDetail.address4,
    address5: data.customerDetail.address5,
    address6: data.customerDetail.address6,
    address7: data.customerDetail.address7,
    address8: data.customerDetail.address8,
    address9: data.customerDetail.address9,
    address10: data.customerDetail.address10,
    country: data.customerDetail.country,
    jobTitle: data.customerDetail.jobTitle,
    monthlyIncome: data.customerDetail.monthlyIncome,
    nationality: data.customerDetail.nationality,
    birthdate: data.customerDetail.birthdate,
    gender: data.customerDetail.gender,
    race: data.customerDetail.race,
    bumi: data.customerDetail.bumi,
    maritalStatus: data.customerDetail.maritalStatus,
    occupation: data.customerDetail.occupation,
    internalRemark: data.internalRemark,
    maOwnerCompanyBranchShortName: data.maOwnerCompanyBranchShortName,
    maOwnerCompanyBranchID: data.maOwnerCompanyBranchID,
    emergencyContactName: data.customerDetail.emergencyContactName,
    emergencyContactRelation: data.customerDetail.emergencyContactRelation,
    emergencyContactMobilePrefix: data.customerDetail.emergencyContactMobilePrefix,
    emergencyContactMobile: data.customerDetail.emergencyContactMobile,
    emergencyContactEmail: data.customerDetail.emergencyContactEmail,
    emergencyContactIdentity: data.customerDetail.emergencyContactIdentity,
    isForeignCompany: data.isForeignCompany
  };
  var isPresetRace = _race.RACE.find(function (d) {
    return d.value === data.customerDetail.race;
  });
  if (!isPresetRace && data.customerDetail.race !== '') {
    dataEditingCustomer.race = 'Others';
    dataEditingCustomer.raceOther = data.customerDetail.race;
  }
  Overview.defaultValues.mobilePrefix = defaultCountryPhoneCode;
  Overview.defaultValues.phonePrefix = defaultCountryPhoneCode;
  Overview.defaultValues.emergencyContactMobilePrefix = defaultCountryPhoneCode;
  Overview.defaultValues.country = defaultCountryAddressCode;
  var editingCustomer = Object.assign({}, Overview.defaultValues, dataEditingCustomer);

  var identityPresets = props.identityPresets.data;
  var identityTypeOpts = _defaultIdentityTypeOpts2.default;
  var phoneValidationPresets = props.phoneValidationPresets.data;

  if (props.auth && (0, _companies.isForeignCompany)(props.auth.company)) {
    // remove NRIC or Military/Police identities if editing customer's identity is not these types
    var defaultFilters = [1, 3];
    if (editingCustomer && (editingCustomer.identityTypeID === 1 || editingCustomer.identityTypeID === 3)) {
      defaultFilters = defaultFilters.filter(function (f) {
        return f !== editingCustomer.identityTypeID;
      });
    }
    identityTypeOpts = identityTypeOpts.filter(function (o) {
      return !defaultFilters.includes(o.value);
    });
    // check for new identity presets
    if (identityPresets && identityPresets.length > 0) {
      var newPresetOptions = identityPresets.map(function (i) {
        return {
          text: i.label,
          value: i.id === editingCustomer.identityPresetID ? 6 : i.id,
          'data-regex': i.regex
        };
      });
      // Remove duplicates by checking if value already exists in identityTypeOpts
      var uniquePresetOptions = newPresetOptions.filter(function (newOpt) {
        return !identityTypeOpts.some(function (existingOpt) {
          return existingOpt.value === newOpt.value;
        });
      });
      identityTypeOpts = [].concat(_toConsumableArray(identityTypeOpts), _toConsumableArray(uniquePresetOptions));
    }
    // check if existing customer's identity is deleted identity preset
    if (editingCustomer && editingCustomer.identityTypeID > 4) {
      var _idx = identityPresets.findIndex(function (i) {
        return i.id === editingCustomer.identityPresetID;
      });
      if (_idx === -1) {
        // Check if this identity type doesn't already exist before adding
        var existingIdentityType = identityTypeOpts.find(function (opt) {
          return opt.value === editingCustomer.identityTypeID;
        });
        if (!existingIdentityType) {
          identityTypeOpts.unshift({ text: editingCustomer.identityPresetLabel ? editingCustomer.identityPresetLabel : 'ID Number', value: editingCustomer.identityTypeID, 'data-regex': editingCustomer.identityPresetRegex ? editingCustomer.identityPresetRegex : '' });
        }
      }
    }
  }

  // flag to enable/disable tin searched using the lhdn api
  var tinFound = false;

  return {
    data: data,
    oriData: (0, _clone2.default)(data),
    loading: loading,
    editingCustomer: editingCustomer,
    identityTypeOpts: identityTypeOpts,
    phoneValidationPresets: phoneValidationPresets,
    hideTitle: hideTitle,
    tinFound: tinFound
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.getCreditsSubscriptionFragment = function () {
    return '\n  id\n  company_id\n  company_branch_id\n  amount\n  currency_code\n  created_at\n  created_by\n  updated_at\n  updated_by\n';
  };

  this.getSelectedBranchValue = function () {
    var editingCustomer = _this7.state.editingCustomer;

    var selectedBranchValue = {
      key: editingCustomer.maOwnerCompanyBranchID.toString() || 0,
      title: editingCustomer.maOwnerCompanyBranchShortName || ''
    };
    return selectedBranchValue;
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var loadingType = arguments[1];
    return new Promise(function (res) {
      if (loadingType === 'validatingTIN') {
        _this7.setState({ validatingTin: loading }, res);
      } else {
        _this7.setState({ loading: loading }, res);
      }
    });
  };

  this.updateTinFieldState = function () {
    var editingCustomer = _this7.state.editingCustomer;

    var tinError = true;
    if (editingCustomer && editingCustomer.taxTinValidationStatus === 'success') {
      tinError = false;
    }
    if (_this7.state.tinError !== tinError) {
      _this7.setState({ tinError: tinError });
    }
  };

  this.handleOnCheck = function () {
    var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (_this7.props.onCheck) {
      _this7.props.onCheck(hasChanges);
    }
  };

  this.handleCheckAvailableCredits = function () {
    _this7.setLoading(true);
    var companyBranch = _this7.props.auth.companyBranch;

    var availableCredit = 0;

    var store = _this7.context.store;

    var id = companyBranch && companyBranch.service_company_branch_id;
    _auth2.default.currentSession().then(function (result) {
      var creditsSubscriptionToken = result.getIdToken().getJwtToken();
      if (_config2.default.get('server') === 'development') {
        creditsSubscriptionToken = _config2.default.get('subsAuth');
      }
      fetch(_config2.default.get('subscriptionApiEndpoint'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: creditsSubscriptionToken
        },
        body: JSON.stringify({
          query: '\n            query {\n              getSubscription(\n                id: "' + id + '",\n              ) { ' + _this7.getCreditsSubscriptionFragment() + ' }\n            }\n          '
        })
      }).then(function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(res) {
          var _ref7, data, message;

          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!res.ok) {
                    _context4.next = 8;
                    break;
                  }

                  _context4.next = 3;
                  return res.json();

                case 3:
                  _ref7 = _context4.sent;
                  data = _ref7.data;

                  if (data && data.getSubscription) {
                    availableCredit = data.getSubscription.amount;
                    _this7.setState({
                      creditSubscription: _extends({}, data.getSubscription)
                    });

                    if (availableCredit < 10) {
                      _this7.setState({ openInsufficientCreditModal: true });
                    } else {
                      window.location.href = '/customers/' + _this7.state.data.id + '/credit_check/#new';
                    }
                  }
                  _context4.next = 10;
                  break;

                case 8:
                  message = 'Failed to retrieve subscription data';

                  store.dispatch((0, _flash.flashErrorMessage)(message));

                case 10:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, _this7);
        }));

        return function (_x6) {
          return _ref6.apply(this, arguments);
        };
      }());
    }).catch(function (err) {
      return store.dispatch((0, _flash.flashErrorMessage)(err));
    });
    _this7.setLoading(false);
  };

  this.handleCloseInsufficientCreditModal = function (e) {
    e.preventDefault();
    _this7.setState({ openInsufficientCreditModal: false });
  };

  this.handleChange = function (event, value) {
    var _state4 = _this7.state,
        editingCustomer = _state4.editingCustomer,
        data = _state4.data;
    var auth = _this7.props.auth;

    var isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
    // Change real time state of display title and name
    if (value.name === 'title' || value.name === 'name') {
      data.customerDetail[value.name] = value.value;
    }
    editingCustomer[value.name] = value.value;
    if (isMalaysia) {
      if (value.name === 'identityTypeID') {
        editingCustomer.isForeignCompany = false;
        editingCustomer.taxIdentificationNo = (0, _tin.getAutoFillTin)(editingCustomer.identityTypeID, editingCustomer.isForeignCompany);
      }
    }
    _this7.setState({ editingCustomer: editingCustomer, data: data, tinMessage: null, tinError: false, tinFound: false }, function () {
      // Validate identity again on identityTypeID change
      if (value.name === 'identityTypeID') {
        _AppForm2.default.validate(_this7.validation, _this7.state.editingCustomer).then(function (validations) {
          _this7.setState({
            errMessages: validations.filter(function (v) {
              return !v.isValid;
            })
          });
        });

        // Validate pref name | contact persion
        if (_this7.validation.preferredName && _this7.validation.preferredName.current && editingCustomer.preferredName !== '') {
          _this7.validation.preferredName.current.validate(editingCustomer.preferredName);
        }
        // CPI-1319: the VN no-digits rule on Full Name depends on the identity type.
        if (_this7.validation.name && _this7.validation.name.current && editingCustomer.name !== '') {
          _this7.validation.name.current.validate(editingCustomer.name);
        }
        if (editingCustomer.taxIdentificationNo !== '') {
          _this7.handleTinInput({ target: { value: editingCustomer.taxIdentificationNo } });
        }
      }
      if (value.name === 'identity' && editingCustomer.taxIdentificationNo !== '') {
        _this7.handleTinInput({ target: { value: editingCustomer.taxIdentificationNo } });
      }
      if (value.name === 'mobilePrefix') {
        _this7.validation.mobile.current.validate(editingCustomer.mobile);
      }
      if (value.name === 'phonePrefix') {
        _this7.validation.phone.current.validate(editingCustomer.phone);
      }
      _this7.handleCheckChanges();
    });
  };

  this.handleUpdateCustomer = function () {
    _this7.putCustomer();
  };

  this.handleEditCustomer = function () {
    _this7.setState({ edit: true });
  };

  this.handleResetCustomer = function () {
    var oriData = _this7.state.oriData;

    _this7.setState({
      edit: false,
      data: (0, _clone2.default)(oriData)
    }, function () {
      _this7.handleResetCheck();
    });
  };

  this.handleOpenHTML = function (event) {
    event.preventDefault();
    var data = _this7.state.data;

    if (data.customerCreditReport && data.customerCreditReport.mCtosHTMLRequestID !== '') {
      var url = _config2.default.get('bookApiURL') + '/customers/' + data.id + '/credit_reports/' + data.customerCreditReport.id + '/response/' + data.customerCreditReport.mCtosHTMLRequestID + '/';
      window.open(url, 'credit-report-' + data.customerCreditReport.mCtosHTMLRequestID, '');
    }
  };

  this.handleBranchClear = function () {
    var editingCustomer = _this7.state.editingCustomer;

    editingCustomer.maOwnerCompanyBranchShortName = '';
    editingCustomer.maOwnerCompanyBranchID = 0;
    _this7.setState({ editingCustomer: editingCustomer }, function () {
      _this7.handleCheckChanges();
    });
  };

  this.handleBranchSelect = function (value) {
    var editingCustomer = _this7.state.editingCustomer;

    editingCustomer.maOwnerCompanyBranchShortName = value.title;
    editingCustomer.maOwnerCompanyBranchID = value.key;
    _this7.setState({ editingCustomer: editingCustomer }, function () {
      _this7.handleCheckChanges();
    });
  };

  this.handleOnChangeLPPSA = function (data) {
    _this7.setState({ data: data }, function () {
      _this7.putCustomer();
    });
  };

  this.valueToText = function (array, value) {
    var element = array.find(function (a) {
      return a.value === value;
    });
    if (element && element.text) {
      return element.text;
    }
    return '';
  };

  this.validateIdentityType = function () {
    var auth = _this7.props.auth;

    var identityType = _this7.state.editingCustomer.identityTypeID;
    var isVietnam = auth && auth.company && auth.company.countryCode.toUpperCase() === 'VN';
    switch (identityType) {
      case 1:
        return isVietnam ? 'vn_cccd' : 'ic_number';
      case 2:
        return 'passport';
      case 3:
        return 'military_police';
      case 5:
        return 'id_number';
      default:
        return 'other';
    }
  };

  this.identityValidation = function () {
    var _state5 = _this7.state,
        editingCustomer = _state5.editingCustomer,
        identityTypeOpts = _state5.identityTypeOpts;
    var _props3 = _this7.props,
        auth = _props3.auth,
        t = _props3.t;

    var isVietnam = auth && auth.company && auth.company.countryCode.toUpperCase() === 'VN';

    // If identityTypeID is not set, return a safe default validation that won't crash
    if (!editingCustomer.identityTypeID || editingCustomer.identityTypeID === '' || editingCustomer.identityTypeID === null) {
      return {
        countryCode: isVietnam ? 'VN' : 'MY',
        identityType: isVietnam ? 'vn_cccd' : 'ic_number'
      };
    }

    if (editingCustomer.identityTypeID === 6 || typeof editingCustomer.identityTypeID === 'string') {
      var idx = identityTypeOpts.findIndex(function (i) {
        return i.value === editingCustomer.identityTypeID;
      });
      var regex = '';
      if (idx !== -1) {
        regex = identityTypeOpts[idx]['data-regex'];
      }
      return {
        validRegex: regex
      };
    }
    // CPI-974: the shared CCCD rule and the CRM's wording, the same pair the booking form and
    // the Purchaser tab read. Non-null on exactly the case validateIdentityType() calls
    // 'vn_cccd' - a Vietnamese company and identity type 1 - so the return below is unchanged.
    var vn = (0, _vietnam.vnIdentityValidation)(auth, editingCustomer.identityTypeID, t);
    if (vn) {
      return vn;
    }

    // For identity types like passport (2), military police (3), etc. that may not have specific validation rules,
    // return a permissive regex validation instead of using validateIdentityType()
    var identityType = _this7.validateIdentityType();
    if (identityType === 'passport' || identityType === 'military_police' || identityType === 'other') {
      return {
        validRegex: '.*' // Accept any non-empty string for these types
      };
    }

    return {
      countryCode: isVietnam ? 'VN' : 'MY',
      identityType: identityType
    };
  };

  this.handleTinInput = function (e) {
    var _state6 = _this7.state,
        editingCustomer = _state6.editingCustomer,
        tinMessage = _state6.tinMessage;
    var auth = _this7.props.auth;

    var isIndonesia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'ID';

    if (isIndonesia) {
      editingCustomer.taxIdentificationNo = e.target.value;
      _this7.setState({
        editingCustomer: editingCustomer,
        taxIdentificationNo: e.target.value,
        tinError: null,
        tinMessage: null
      }, function () {
        _this7.handleCheckChanges();
      });
      return;
    }

    var tinInput = e.target.value;
    var tinFound = e.target.tinFound;
    var isAlphanumeric = /^[a-zA-Z0-9]*$/.test(tinInput);

    if (tinInput === '') {
      editingCustomer.taxIdentificationNo = '';
      _this7.setState({ taxIdentificationNo: '', editingCustomer: editingCustomer, tinFound: tinFound, tinError: false, tinMessage: null });
      return;
    }

    if (isAlphanumeric) {
      editingCustomer.taxIdentificationNo = tinInput;
      _this7.setState({ taxIdentificationNo: tinInput, editingCustomer: editingCustomer, tinFound: tinFound, tinError: tinFound === false, tinMessage: tinFound ? null : tinMessage }, function () {
        _this7.handleCheckChanges();
      });

      if (tinFound) {
        return;
      }
      // 1~2 letter followed by numeric with length 9 - 11
      var matched = _regex.REGEX_TIN_VALID.test(tinInput);
      var genericTin = (0, _tin.getGenericTinByIdTypeAndTinNo)(editingCustomer.identityTypeID, tinInput, editingCustomer.isForeignCompany);
      _this7.setLoading(true, 'validatingTIN').then(function () {
        if (_this7.debounceTimeout) {
          clearTimeout(_this7.debounceTimeout);
        }

        _this7.debounceTimeout = setTimeout(function () {
          if (matched) {
            if (tinInput === _tin.GOVERNMENT_GENERIC_TIN) {
              var isForeign = !(0, _tin.isForeignIdType)(editingCustomer.identityTypeID, editingCustomer.identityTypeID === _defaultIdentityTypeOpts.IDENTITY_TYPE_BRN && editingCustomer.isForeignCompany);
              _this7.setState({
                tinError: !isForeign,
                tinFound: !isForeign,
                tinMessage: !isForeign ? _tin.GENERIC_TIN_UNMATCHED_ERROR_MSG : null }, function () {
                _this7.setLoading(false, 'validatingTIN');
              });
            } else if (_tin.GENERIC_TIN_VALUES.includes(tinInput)) {
              _this7.setState({
                tinError: !(0, _tin.isGenericTinFound)(genericTin),
                tinFound: (0, _tin.isGenericTinFound)(genericTin),
                tinMessage: !(0, _tin.isGenericTinFound)(genericTin) ? _tin.GENERIC_TIN_UNMATCHED_ERROR_MSG : null }, function () {
                _this7.setLoading(false, 'validatingTIN');
              });
            } else {
              _this7.validateTIN(tinInput).finally(function () {
                _this7.setLoading(false, 'validatingTIN');
              });
            }
          } else {
            _this7.setState({ tinError: true }, function () {
              _this7.setLoading(false, 'validatingTIN');
            });
          }
        }, 3000);
      });
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.customer, _translation.TRANSLATION_FILES.models.project]))((0, _reactRedux.connect)(Overview.mapStateToProps)(Overview));

/***/ }),
/* 2322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Customers = __webpack_require__(2315);

var _Customers2 = _interopRequireDefault(_Customers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Customers2.default;

/***/ }),
/* 2323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _checkChanges = __webpack_require__(61);

var _Edit = __webpack_require__(2324);

var _Edit2 = _interopRequireDefault(_Edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Document = function (_Component) {
  _inherits(Document, _Component);

  function Document(props) {
    _classCallCheck(this, Document);

    var _this = _possibleConstructorReturn(this, (Document.__proto__ || Object.getPrototypeOf(Document)).call(this, props));

    _this.state = {
      token: null,
      loading: true,
      data: null
    };
    return _this;
  }

  _createClass(Document, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchDocument();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var id = nextProps.params.id;

      if (id !== this.props.params.id) {
        this.fetchDocument();
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchDocument',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, data, token;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/documents/' + this.props.params.id + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                return _context.abrupt('return');

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 32;
                break;

              case 26:
                _context.next = 28;
                return res.json();

              case 28:
                data = _context.sent;

                // handle token.. etc
                token = res.headers.get('X-Csrf-Token');
                _context.next = 32;
                return this.setComponentState({
                  data: data,
                  token: token
                });

              case 32:
                _context.next = 34;
                return this.setLoading(false);

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchDocument() {
        return _ref.apply(this, arguments);
      }

      return fetchDocument;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this4 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this4.state.token,
          loading: _this4.state.loading,
          data: _this4.state.data,
          id: _this4.props.params.id
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Document;
}(_react.Component);

Document.propTypes = {
  children: _propTypes2.default.node,
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string
  })
};
Document.contextTypes = {
  store: _propTypes2.default.object
};
Document.Edit = (0, _checkChanges.checkChanges)(_Edit2.default);
exports.default = Document;

/***/ }),
/* 2324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(2325);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditUnit = function (_Component) {
  _inherits(EditUnit, _Component);

  function EditUnit(props) {
    _classCallCheck(this, EditUnit);

    var _this = _possibleConstructorReturn(this, (EditUnit.__proto__ || Object.getPrototypeOf(EditUnit)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(EditUnit, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, file) {
        var _this2 = this;

        var store, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 5;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 5:
                res = void 0;
                _context.prev = 6;
                _context.next = 9;
                return this.form.submit('/documents/' + this.props.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(file)
                });

              case 9:
                res = _context.sent;
                _context.next = 22;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 17;
                return _context.t0.res.text();

              case 17:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 20:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 22:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false);
                });
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Update Success', message: res.name + ' successfully updated' }));

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: 'Edit ' + (this.props.data ? this.props.data.name : 'document'),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: 'Save',
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, unit) {
            _this3.submit(validations, unit);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading,
          file: this.props.data
        })
      );
    }
  }]);

  return EditUnit;
}(_react.Component);

EditUnit.propTypes = {
  token: _propTypes2.default.string,
  id: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func
};
EditUnit.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = EditUnit;

/***/ }),
/* 2325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  eslint no-param-reassign: ["error", { "props": false }]*/

var DocumentForm = function (_Component) {
  _inherits(DocumentForm, _Component);

  function DocumentForm(props) {
    _classCallCheck(this, DocumentForm);

    var _this = _possibleConstructorReturn(this, (DocumentForm.__proto__ || Object.getPrototypeOf(DocumentForm)).call(this, props));

    _initialiseProps.call(_this);

    var file = Object.assign({}, DocumentForm.defaultValues, props.file || {});
    _this.state = {
      file: file,
      oriFile: (0, _clone2.default)(file),
      options: file.tags ? file.tags.map(function (value, idx) {
        var d = { key: idx, text: value, value: value };
        return d;
      }) : [],
      errMessages: []
    };
    _this.validation = {
      name: (0, _react.createRef)(),
      tags: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(DocumentForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var file = Object.assign({}, DocumentForm.defaultValues, this.state.file);
      var oriFile = this.state.oriFile;
      if (JSON.stringify(this.props.file) !== JSON.stringify(nextProps.file)) {
        file = Object.assign(file, nextProps.file);
        oriFile = (0, _clone2.default)(file);
      }
      this.setState({
        file: file,
        oriFile: oriFile,
        options: file.tags ? file.tags.map(function (value, idx) {
          var d = { key: idx, text: value, value: value };
          return d;
        }) : []
      });
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref) {
            _this2.form = _ref;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_AppForm2.default.Input, {
                label: 'Name',
                name: 'name',
                value: this.state.file.name,
                onChange: this.handleInputChange,
                ref: this.validation.name,
                validation: [_webValidations.required]
              }),
              _react2.default.createElement(
                _AppForm2.default.Validate,
                {
                  ref: this.validation.tags,
                  onChange: this.handleInputChange
                },
                _react2.default.createElement(_semanticUiReact.Form.Select, {
                  label: 'Tags',
                  name: 'tags',
                  fluid: true,
                  placeholder: 'Add tags',
                  noResultsMessage: 'Add tags',
                  search: true,
                  selection: true,
                  multiple: true,
                  allowAdditions: true,
                  options: this.state.options,
                  value: this.state.file.tags || [],
                  onAddItem: this.handleAddition
                })
              )
            )
          )
        )
      );
    }
  }]);

  return DocumentForm;
}(_react.Component);

DocumentForm.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  file: _propTypes2.default.shape({
    name: _propTypes2.default.string
  })
};
DocumentForm.contextTypes = {
  store: _propTypes2.default.object
};
DocumentForm.defaultValues = {
  name: '',
  tags: []
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleSubmit = function (event) {
    event.preventDefault();
    var file = _this3.state.file;

    _AppForm2.default.validate(_this3.validation, file).then(function (validations) {
      _this3.props.onSubmit(validations, file);
    });
  };

  this.handleInputChange = function (event, data) {
    var file = _this3.state.file;

    file[data.name] = data.value;
    _this3.setState({ file: file }, function () {
      _this3.handleCheckChanges();
    });
  };

  this.handleAddition = function (e, _ref2) {
    var value = _ref2.value;

    _this3.setState({
      options: [{ text: value, value: value }].concat(_toConsumableArray(_this3.state.options))
    });
  };
};

exports.default = DocumentForm;

/***/ }),
/* 2326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Document = __webpack_require__(2323);

var _Document2 = _interopRequireDefault(_Document);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Document2.default;

/***/ }),
/* 2327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _List = __webpack_require__(2328);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Documents = function (_Component) {
  _inherits(Documents, _Component);

  function Documents(props) {
    _classCallCheck(this, Documents);

    var _this = _possibleConstructorReturn(this, (Documents.__proto__ || Object.getPrototypeOf(Documents)).call(this, props));

    _this.state = {
      token: null,
      count: 0,
      limit: 0,
      offset: 0,
      loading: true,
      data: []
    };
    return _this;
  }

  _createClass(Documents, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = this.props.location.query;

      if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
        delete query.page;
      }
      this.fetchDocuments(query);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var query = nextProps.location.query;

      this.fetchDocuments(query);
    }
  }, {
    key: 'setDocuments',
    value: function setDocuments() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this2.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchDocuments',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var store, query, res, message, token, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                res = void 0;
                _context.prev = 6;
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/documents/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context.sent;
                _context.next = 20;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                Bugsnag.notifyException(_context.t0);
                _context.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 17:
                _context.next = 19;
                return this.setLoading(false);

              case 19:
                return _context.abrupt('return');

              case 20:
                if (res.ok) {
                  _context.next = 28;
                  break;
                }

                _context.next = 23;
                return res.text();

              case 23:
                message = _context.sent;
                _context.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context.next = 40;
                break;

              case 28:
                token = res.headers.get('X-Csrf-Token');
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 34;
                return res.json();

              case 34:
                data = _context.sent;
                _context.next = 37;
                return this.setDocuments(data);

              case 37:
                if (this.state.data.length < 1 && query.page > 1) {
                  query.page = 1;
                  store.dispatch((0, _reactRouterRedux.replace)('/media/documents/?' + _qs2.default.stringify(query)));
                }
                // handle token.. etc
                _context.next = 40;
                return this.setComponentState({
                  token: token,
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 40:
                _context.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));

      function fetchDocuments(_x4) {
        return _ref.apply(this, arguments);
      }

      return fetchDocuments;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this5 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this5.state.token,
          count: _this5.state.count,
          limit: _this5.state.limit,
          offset: _this5.state.offset,
          loading: _this5.state.loading,
          data: _this5.state.data
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Documents;
}(_react.Component);

Documents.propTypes = {
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object
  })
};
Documents.contextTypes = {
  store: _propTypes2.default.object
};
Documents.List = _List2.default;
exports.default = Documents;

/***/ }),
/* 2328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _prompt = __webpack_require__(66);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _fileSize = __webpack_require__(85);

var _fileSize2 = _interopRequireDefault(_fileSize);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _UploadModal = __webpack_require__(92);

var _UploadModal2 = _interopRequireDefault(_UploadModal);

var _promptMessages = __webpack_require__(43);

var _translation = __webpack_require__(4);

var _Form = __webpack_require__(1056);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _initialiseProps.call(_this);

    var state = List.getPropsToState(props);
    _this.state = _extends({}, state, {
      selectedFile: null,
      showDelete: false
    });
    return _this;
  }

  _createClass(List, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'getToken',
    value: function getToken(id, callback) {
      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/documents/' + id + '/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      }).then(function (res) {
        var token = res.headers.get('X-Csrf-Token');
        if (callback) {
          callback(token);
        }
      });
    }
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var store = this.context.store;

      store.dispatch((0, _reactRouterRedux.replace)('/media/documents/?' + (0, _url.encodeSearch)(query)));
    }
  }, {
    key: 'deleteDocument',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(token) {
        var t, store, res, message, _message;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                _context.prev = 3;
                _context.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/documents/' + this.state.selectedFile.id + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': token
                  }
                }));

              case 6:
                res = _context.sent;
                _context.next = 21;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](3);
                _context.next = 13;
                return this.setState({ selectedFile: null, loading: false });

              case 13:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 19;
                  break;
                }

                _context.next = 16;
                return _context.t0.res.text();

              case 16:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 19:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 21:
                this.setState({
                  selectedFile: null,
                  loading: false
                });

                if (res.ok) {
                  _context.next = 30;
                  break;
                }

                _context.next = 25;
                return res.text();

              case 25:
                _message = _context.sent;
                _context.next = 28;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 28:
                _context.next = 32;
                break;

              case 30:
                this.handleChangePage();
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Document successfully deleted', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 32:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 9]]);
      }));

      function deleteDocument(_x) {
        return _ref.apply(this, arguments);
      }

      return deleteDocument;
    }()
  }, {
    key: 'uploadDocument',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e, body) {
        var t, store, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                t = this.props.t;

                e.preventDefault();
                store = this.context.store;
                _context2.prev = 3;
                _context2.next = 6;
                return this.form.submit('/documents/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    // Let browser decide Content-Type
                    'X-Csrf-Token': this.props.token
                  },
                  body: body
                });

              case 6:
                _context2.next = 18;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](3);

                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 13;
                return _context2.t0.res.text();

              case 13:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 16:
                store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));
                return _context2.abrupt('return');

              case 18:
                this.uploadModal.close();
                this.handleChangePage();
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Upload Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Documents(s) successfully uploaded', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 8]]);
      }));

      function uploadDocument(_x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return uploadDocument;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Documents'),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_UploadModal2.default, {
              ref: function ref(_ref5) {
                _this2.uploadModal = _ref5;
              },
              loading: this.state.loading,
              onConfirm: function onConfirm(e, data) {
                _this2.uploadDocument(e, data);
              },
              onClose: this.handleCheckBeforeClose,
              content: function content(_ref3) {
                var onConfirm = _ref3.onConfirm;
                return _react2.default.createElement(_Form2.default, {
                  ref: function ref(_ref4) {
                    _this2.form = _ref4;
                  },
                  onSubmit: onConfirm
                });
              }
            })
          )
        }),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            open: this.state.showDelete,
            onClose: this.handleCancelDelete
          },
          _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: t('Confirm delete') + '?' }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Modal.Description,
              null,
              _react2.default.createElement(_semanticUiReact.Header, {
                as: 'h3',
                content: t('Are you sure to delete this file') + '?',
                subheader: this.state.selectedFile ? this.state.selectedFile.name : ''
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(_semanticUiReact.Button, { basic: true, negative: true, onClick: this.handleCancelDelete, icon: 'cancel', content: t('No'), inverted: true }),
            _react2.default.createElement(_semanticUiReact.Button, { basic: true, positive: true, onClick: this.handleConfirmDelete, icon: 'trash', content: t('Yes'), inverted: true })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 20 },
            active: this.state.loading && this.state.data.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            striped: true, unstackable: true,
            selectable: true
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 4, textAlign: 'right' },
                _react2.default.createElement(_PageNav2.default, {
                  currentPage: this.state.currentPage,
                  count: this.state.count,
                  limit: this.state.limit,
                  offset: this.state.offset,
                  dataSize: this.state.data.length,
                  loading: this.state.loading,
                  onChange: this.handleChangePage
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Name')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Size')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Tags')
              ),
              _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null)
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            this.state.data.length > 0 ? this.state.data.map(function (file, key) {
              return _react2.default.createElement(
                _semanticUiReact.Table.Row,
                { key: key },
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { width: 6 },
                  _react2.default.createElement(
                    'a',
                    {
                      href: _config2.default.get('bookApiURL') + '/documents/' + file.id + '/view/' + encodeURIComponent(file.name) + '.pdf',
                      target: '_blank',
                      rel: 'noopener noreferrer'
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'file pdf outline' }),
                    file.name
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { collapsing: true },
                  (0, _fileSize2.default)(file.size)
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Label.Group,
                    { size: 'tiny' },
                    file.tags && file.tags.length > 0 ? file.tags.map(function (tag, idx) {
                      return _react2.default.createElement(
                        _semanticUiReact.Label,
                        { key: idx, as: 'a' },
                        tag
                      );
                    }) : _react2.default.createElement(
                      'p',
                      null,
                      t('No tags set')
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { collapsing: true, textAlign: 'right' },
                  _react2.default.createElement(_semanticUiReact.Button, {
                    as: _reactRouter.Link,
                    size: 'tiny',
                    compact: true,
                    primary: true,
                    icon: 'edit',
                    disabled: _this2.state.loading,
                    to: '/media/documents/' + file.id + '/'
                  }),
                  _react2.default.createElement(_semanticUiReact.Button, {
                    size: 'tiny',
                    compact: true,
                    negative: true,
                    icon: 'delete',
                    disabled: _this2.state.loading,
                    onClick: function onClick(e) {
                      return _this2.handleDelete(e, file);
                    }
                  })
                )
              );
            }) : _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 4, textAlign: 'center' },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  'Loading'
                ) : t('No documents found')
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Footer,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 4, textAlign: 'right' },
                _react2.default.createElement(_PageNav2.default, {
                  upward: true,
                  currentPage: this.state.currentPage,
                  count: this.state.count,
                  limit: this.state.limit,
                  offset: this.state.offset,
                  dataSize: this.state.data.length,
                  loading: this.state.loading,
                  onChange: this.handleChangePage
                })
              )
            )
          )
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};
List.propTypes = {
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  token: _propTypes2.default.string,
  t: _propTypes2.default.func
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  var count = props.count;
  var limit = props.limit;
  var offset = props.offset;
  var data = props.data || [];
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  return {
    data: data,
    loading: loading,
    count: count,
    limit: limit,
    offset: offset,
    currentPage: currentPage
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleChangePage = function (page) {
    var query = (0, _url.decodeSearch)(_this3.props.location.search);
    if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
      query.page = 1;
    }
    var currentPage = parseInt(page || query.page, 10);
    query.page = currentPage;
    _this3.setState({ currentPage: currentPage });
    _this3.replaceQuery(query);
  };

  this.handleCancelDelete = function (e) {
    e.preventDefault();
    _this3.setState({
      showDelete: false,
      selectedFile: null
    });
  };

  this.handleDelete = function (e, selectedFile) {
    e.preventDefault();
    _this3.setState({
      selectedFile: selectedFile,
      showDelete: true
    });
  };

  this.handleConfirmDelete = function (e) {
    e.preventDefault();
    _this3.setState({
      showDelete: false,
      loading: true
    }, function () {
      _this3.getToken(_this3.state.selectedFile.id, function (token) {
        _this3.deleteDocument(token);
      });
    });
  };

  this.handleCheckBeforeClose = function () {
    var t = _this3.props.t;

    if (_this3.form.state.uploads.length > 0) {
      var callback = function callback() {
        _this3.uploadModal.close();
        _this3.handleChangePage();
      };
      var store = _this3.context.store;

      store.dispatch((0, _prompt.promptChangesMessage)({ message: t(_promptMessages.UPLOAD_DOCUMENT_PROMPT, { ns: _translation.TRANSLATION_FILES.translation }), callback: callback }));
      return true;
    }
    return false;
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(List);

/***/ }),
/* 2329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Documents = __webpack_require__(2327);

var _Documents2 = _interopRequireDefault(_Documents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Documents2.default;

/***/ }),
/* 2330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Forbidden = function (_Component) {
  _inherits(Forbidden, _Component);

  function Forbidden() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Forbidden);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Forbidden.__proto__ || Object.getPrototypeOf(Forbidden)).call.apply(_ref, [this].concat(args))), _this), _this.handleAction = function (e) {
      e.preventDefault();
      window.location.href = _config2.default.get('startURL');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Forbidden, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementById('preloader-container').classList.remove('app-loading');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          open: true,
          basic: true,
          size: 'small'
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: 'Forbidden' }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            'h3',
            null,
            'Oops! Looks like you do not have access.'
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(
            _semanticUiReact.Button,
            { color: 'green', onClick: this.handleAction, inverted: true },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'home' }),
            ' Return home safely'
          )
        )
      );
    }
  }]);

  return Forbidden;
}(_react.Component);

Forbidden.contextTypes = {
  store: _propTypes2.default.object
};

exports.default = Forbidden;

/***/ }),
/* 2331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouterRedux = __webpack_require__(13);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Salesforce = __webpack_require__(2332);

var _Salesforce2 = _interopRequireDefault(_Salesforce);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Projects = function (_Component) {
  _inherits(Projects, _Component);

  function Projects() {
    _classCallCheck(this, Projects);

    return _possibleConstructorReturn(this, (Projects.__proto__ || Object.getPrototypeOf(Projects)).apply(this, arguments));
  }

  _createClass(Projects, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var store = this.context.store;
      var children = this.props.children;

      if (!children) {
        store.dispatch((0, _reactRouterRedux.replace)('/'));
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);

  return Projects;
}(_react.Component);

Projects.propTypes = {
  children: _propTypes2.default.node
};
Projects.contextTypes = {
  store: _propTypes2.default.object
};
Projects.Salesforce = _Salesforce2.default;
exports.default = Projects;

/***/ }),
/* 2332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _semanticUiReact = __webpack_require__(2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _reactRouter = __webpack_require__(18);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _url = __webpack_require__(19);

var _isbase = __webpack_require__(157);

var _isbase2 = _interopRequireDefault(_isbase);

var _Filters = __webpack_require__(86);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _ModalNotice = __webpack_require__(588);

var _ModalNotice2 = _interopRequireDefault(_ModalNotice);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Salesforce = function (_Component) {
  _inherits(Salesforce, _Component);

  function Salesforce(props) {
    _classCallCheck(this, Salesforce);

    var _this = _possibleConstructorReturn(this, (Salesforce.__proto__ || Object.getPrototypeOf(Salesforce)).call(this, props));

    _initialiseProps.call(_this);

    var state = Salesforce.getPropsToState(props);
    state.data = [];
    _this.state = _extends({
      loading: true,
      count: 0,
      limit: 10,
      offset: 0,
      token: '',
      externalSvcErrorModalOpen: false,
      externalSvcError: '',
      sentBookingIDs: []
    }, state);
    var query = (0, _url.decodeSearch)(props.location.search);
    if (query.projectFilter && query.projectFilter.length > 0) {
      _this.state.advanceFilter = true;
    }
    return _this;
  }

  _createClass(Salesforce, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      this.fetchBookings(query);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Salesforce.getPropsToState(nextProps);
      var query = (0, _url.decodeSearch)(nextProps.location.search);
      if (this.state.limit < 0) {
        this.fetchBookings(query);
        state.loading = this.state.loading;
      }
      state.token = this.state.token;
      if (query.projectFilter && query.projectFilter.length > 0) {
        state.advanceFilter = true;
      }
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoadingSearch',
    value: function setLoadingSearch() {
      var _this3 = this;

      var loadingSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loadingSearch: loadingSearch }, res);
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'setBookings',
    value: function setBookings() {
      var _this5 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this5.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'fetchBookings',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var store, query, res, message, _message, count, limit, offset, token, data, newData, que;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = Object.assign(q, this.props.where || {});
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/sf/list/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 23;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                if (!(_context.t0.res && _context.t0.res.status >= 399 && _context.t0.res.status < 500)) {
                  _context.next = 18;
                  break;
                }

                _context.next = 16;
                return _context.t0.res.text();

              case 16:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 18:
                _context.next = 20;
                return this.setLoading(false);

              case 20:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context.abrupt('return');

              case 23:
                if (res.ok) {
                  _context.next = 31;
                  break;
                }

                _context.next = 26;
                return res.text();

              case 26:
                _message = _context.sent;
                _context.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 29:
                _context.next = 50;
                break;

              case 31:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                token = res.headers.get('X-CSRF-Token');
                _context.next = 37;
                return res.json();

              case 37:
                data = _context.sent;
                newData = [];

                if (data) {
                  newData = data;
                  data.forEach(function (d, idx) {
                    newData[idx].send = false;
                  });
                }
                _context.next = 42;
                return this.setBookings(newData);

              case 42:
                if (!(this.state.data.length < 1 && query.page > 1)) {
                  _context.next = 48;
                  break;
                }

                que = (0, _url.decodeSearch)(this.props.location.search);

                que.page = 1;
                this.replaceQuery(que);
                _context.next = 50;
                break;

              case 48:
                _context.next = 50;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset,
                  token: token
                });

              case 50:
                _context.next = 52;
                return this.setLoading(false);

              case 52:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchBookings() {
        return _ref.apply(this, arguments);
      }

      return fetchBookings;
    }()
  }, {
    key: 'searchProjects',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(value) {
        var _this6 = this;

        var store, res, message, json, findProjectResults, noResultsMessage;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                _context2.next = 3;
                return this.setLoadingSearch(true);

              case 3:
                res = null;
                _context2.prev = 4;
                _context2.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/search/projects/?limit=3&search=' + value, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context2.sent;
                _context2.next = 21;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](4);

                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 15;
                return _context2.t0.res.text();

              case 15:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 17:
                _context2.next = 19;
                return this.setLoadingSearch(false);

              case 19:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));

              case 21:
                if (res.ok) {
                  _context2.next = 27;
                  break;
                }

                _context2.next = 24;
                return this.setLoadingSearch(false);

              case 24:
                throw new Error('Not OK');

              case 27:
                _context2.next = 29;
                return this.setLoadingSearch(false);

              case 29:
                _context2.next = 31;
                return res.json();

              case 31:
                json = _context2.sent;

                if (json) {
                  findProjectResults = json.map(function (obj) {
                    var newResults = {};
                    newResults.key = obj.id;
                    newResults.title = obj.shortName;
                    newResults.description = obj.state;
                    if (obj.pictureKey !== '') {
                      newResults.image = (0, _url.AWSUrl)(_this6.props.appConfig, obj.pictureKey + '010.jpg');
                    } else {
                      newResults.image = '/assets/images/placeholder_x100.jpg';
                    }
                    return newResults;
                  });

                  this.setState({ findProjectResults: findProjectResults });
                } else {
                  noResultsMessage = 'No results found.';

                  this.setState({ noResultsMessage: noResultsMessage });
                }

              case 33:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10]]);
      }));

      function searchProjects(_x6) {
        return _ref2.apply(this, arguments);
      }

      return searchProjects;
    }()
  }, {
    key: 'resyncBooking',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(xid) {
        var store, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _context3.prev = 3;
                _context3.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/sf/list/' + xid + '/es_resend/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  }
                }));

              case 6:
                _context3.next = 21;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](3);
                _context3.next = 12;
                return this.setLoading(false);

              case 12:
                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 18;
                  break;
                }

                _context3.next = 15;
                return _context3.t0.res.text();

              case 15:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 18:
                Bugsnag.notifyException(_context3.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context3.abrupt('return');

              case 21:
                _context3.next = 23;
                return this.setLoading(false);

              case 23:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Success', message: 'Selected booking has been resync' }));

              case 24:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 8]]);
      }));

      function resyncBooking(_x7) {
        return _ref3.apply(this, arguments);
      }

      return resyncBooking;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      store.dispatch((0, _reactRouterRedux.replace)('/integrations/sf/?' + (0, _url.encodeSearch)(query)));
      this.fetchBookings(query);
    }
  }, {
    key: 'pushQuery',
    value: function pushQuery(query) {
      var store = this.context.store;

      store.dispatch((0, _reactRouterRedux.replace)('/integrations/sf/?' + (0, _url.encodeSearch)(query)));
      this.fetchBookings(query);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var query = (0, _url.decodeSearch)(this.props.location.search);
      var _state = this.state,
          data = _state.data,
          loading = _state.loading,
          externalSvcErrorModalOpen = _state.externalSvcErrorModalOpen,
          externalSvcError = _state.externalSvcError;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_ModalNotice2.default, {
          open: externalSvcErrorModalOpen,
          onClose: function onClose() {
            return _this7.handleToggleExternalSvcErrModal(false);
          },
          headerNode: 'Error Logs',
          content: externalSvcError
        }),
        _react2.default.createElement(_NavBar2.default, {
          header: 'Salesforce Sync'
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { padding: '0' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              _react2.default.createElement(
                'b',
                null,
                'Pending and Failed Bookings'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _SearchFilter2.default,
                {
                  advanceFilter: this.state.advanceFilter,
                  isLoading: this.state.loading,
                  onChange: this.handleFilterOnChange,
                  onClose: this.handleClearFilter,
                  search: this.state.search,
                  setAdvanceFilter: this.handleSetAdvanceFilter,
                  placeholder: 'Search...',
                  leftNav: _react2.default.createElement(_PageNav2.default, {
                    currentPage: this.state.currentPage,
                    count: this.state.count,
                    limit: this.state.limit,
                    offset: this.state.offset,
                    dataSize: this.state.data.length,
                    loading: this.state.loading,
                    onChange: this.handleChangePage
                  }),
                  rightNav: _react2.default.createElement(_SortButton2.default, {
                    floated: 'right',
                    loading: this.state.loading,
                    items: this.sortItems,
                    onSort: this.handleSortData
                  })
                },
                _react2.default.createElement(_Filters.SearchList, {
                  filterName: 'projectFilter',
                  icon: 'find',
                  isActive: query.projectFilter && query.projectFilter.length > 0 || false,
                  loading: this.state.loadingSearch,
                  noResultsMessage: this.state.noResultsMessage,
                  onChange: this.handleSearchProject,
                  onClose: this.handleClearFilter,
                  onSelect: this.handleSelectProject,
                  placeholder: 'Find Project',
                  results: this.state.findProjectResults,
                  value: this.state.projectFilter
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement('br', { className: 'large-hide' }),
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  'Loading'
                )
              ),
              data.length > 0 ? _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 2, className: 'equal height' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    _react2.default.createElement(
                      'div',
                      { style: { overflowX: 'auto' } },
                      _react2.default.createElement(
                        _semanticUiReact.Table,
                        {
                          compact: true,
                          unstackable: true,
                          selectable: true
                        },
                        _react2.default.createElement(
                          _semanticUiReact.Table.Header,
                          { className: 'mobile-hide' },
                          _react2.default.createElement(
                            _semanticUiReact.Table.Row,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              null,
                              'Created Date'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              null,
                              'Booking'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              null,
                              'Unit, Project'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              null,
                              'Purchaser'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              null,
                              'Status'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              { textAlign: 'center' },
                              'Salesforce'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.HeaderCell,
                              { textAlign: 'center' },
                              'Sync-SF'
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Table.Body,
                          null,
                          data.map(function (d, idx) {
                            return _react2.default.createElement(
                              _semanticUiReact.Table.Row,
                              {
                                key: idx
                              },
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _react2.default.createElement(_Timestamp2.default, {
                                  timestamp: d.createdAt,
                                  format: 'DD/M/YYYY'
                                })
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _react2.default.createElement(
                                  _reactRouter.Link,
                                  { to: '/bookings/' + d.id + '/' },
                                  d.code
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _react2.default.createElement(
                                  _reactRouter.Link,
                                  { title: d.code, to: '/bookings/' + d.id + '/' },
                                  d.projectUnit.reference,
                                  ', ',
                                  d.project.shortName
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _react2.default.createElement(
                                  _reactRouter.Link,
                                  { title: d.code, to: '/bookings/' + d.id + '/' },
                                  d.bookingCustomer && d.bookingCustomer.name
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                null,
                                _react2.default.createElement(
                                  _reactRouter.Link,
                                  { title: d.code, to: '/bookings/' + d.id + '/' },
                                  d.bookingStatus && d.bookingStatus.name
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { collapsing: true, textAlign: 'center' },
                                _react2.default.createElement(
                                  'span',
                                  { style: { textTransform: 'capitalize' } },
                                  d.externalServiceStatus || 'Pending'
                                ),
                                d.externalServiceError && _react2.default.createElement(
                                  'span',
                                  null,
                                  '\xA0\xA0',
                                  _react2.default.createElement(
                                    _semanticUiReact.Label,
                                    { as: 'button', size: 'small', compact: true, onClick: function onClick() {
                                        return _this7.handleToggleExternalSvcErrModal(true, d);
                                      } },
                                    'View Error'
                                  )
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Table.Cell,
                                { collapsing: true, textAlign: 'center' },
                                _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  { color: 'green', compact: true, disabled: _this7.isSentBooking(d.id), onClick: function onClick(e) {
                                      return _this7.handleSendBooking(e, d.id);
                                    } },
                                  d.externalServiceStatus ? 'Resync' : 'Sync'
                                )
                              )
                            );
                          })
                        )
                      )
                    )
                  )
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Item,
                      { style: {} },
                      _react2.default.createElement(
                        _semanticUiReact.Item.Content,
                        null,
                        !loading ? _react2.default.createElement(
                          _semanticUiReact.Segment,
                          { textAlign: 'center' },
                          _react2.default.createElement(
                            'p',
                            null,
                            'No bookings found.'
                          )
                        ) : ''
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Salesforce;
}(_react.Component);

Salesforce.contextTypes = {
  appConfig: _propTypes2.default.shape({}),
  store: _propTypes2.default.object
};
Salesforce.propTypes = {
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  })
};

Salesforce.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig
  };
};

Salesforce.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var advanceFilter = false;
  var projectFilter = (0, _isbase2.default)(query.projectFilter) && _qs2.default.parse(atob(query.projectFilter)).name || '';
  return {
    currentPage: currentPage,
    search: search,
    advanceFilter: advanceFilter,
    projectFilter: projectFilter,
    loadingSearch: false,
    findProjectResults: [],
    noResultsMessage: 'Loading...'
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this8 = this;

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    query.page = currentPage;
    _this8.setState({
      currentPage: currentPage
    });
    _this8.pushQuery(query);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this8.replaceQuery(query, true);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    _this8.setState({
      search: ''
    }, function () {
      if (hasQuery) {
        _this8.replaceQuery(query, true);
      }
    });
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    query[queryName] = value;
    _this8.replaceQuery(query, true);
  };

  this.handleSetAdvanceFilter = function (advanceFilter) {
    _this8.setState({
      advanceFilter: advanceFilter
    });
  };

  this.handleSearchProject = function (value) {
    clearTimeout(_this8.setTimer);
    // always reset results to null before finding
    var findProjectResults = [];
    var noResultsMessage = 'Loading...';
    _this8.setState({ findProjectResults: findProjectResults, noResultsMessage: noResultsMessage, projectFilter: value }, function () {
      if (value !== '') {
        _this8.setTimer = setTimeout(function () {
          _this8.searchProjects(value);
        }, 500);
      }
    });
  };

  this.handleSelectProject = function (project, queryName) {
    var query = (0, _url.decodeSearch)(_this8.props.location.search);
    var internalQuery = {};
    internalQuery.id = project.key;
    internalQuery.name = project.title;
    query[queryName] = btoa(_qs2.default.stringify(internalQuery));
    _this8.replaceQuery(query, true);
  };

  this.handleSendBooking = function (e, xid) {
    e.preventDefault();
    _this8.setState({
      sentBookingIDs: [].concat(_toConsumableArray(_this8.state.sentBookingIDs), [xid])
    }, function () {
      _this8.resyncBooking(xid);
    });
  };

  this.handleToggleExternalSvcErrModal = function () {
    var toggle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var data = arguments[1];

    _this8.setState({
      externalSvcErrorModalOpen: toggle,
      externalSvcError: data ? data.externalServiceError : ''
    });
  };

  this.isSentBooking = function (xid) {
    return _this8.state.sentBookingIDs.indexOf(xid) > -1;
  };

  this.sortItems = [{
    text: 'Oldest Booking First',
    icon: 'sort alphabet ascending',
    sortColumn: 'booking.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Latest Booking First',
    icon: 'sort alphabet descending',
    sortColumn: 'booking.created_at',
    sortDirection: 'desc'
  }];
};

exports.default = (0, _reactRedux.connect)(Salesforce.mapStateToProps)(Salesforce);

/***/ }),
/* 2333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Integrations = __webpack_require__(2331);

var _Integrations2 = _interopRequireDefault(_Integrations);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Integrations2.default;

/***/ }),
/* 2334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppointmentCard = function AppointmentCard(_ref) {
  var timestamp = _ref.timestamp;

  var date = (0, _momentTimezone2.default)(timestamp);
  return _react2.default.createElement(
    _semanticUiReact.Segment,
    { textAlign: 'center', className: 'AppointmentCard' },
    _react2.default.createElement(
      'p',
      { className: 'year' },
      date.format('YYYY')
    ),
    _react2.default.createElement(
      'div',
      { className: 'dayMonth' },
      _react2.default.createElement(
        'p',
        { className: 'day' },
        date.format('DD')
      ),
      _react2.default.createElement(
        'p',
        { className: 'month' },
        date.format('MMMM')
      )
    ),
    _react2.default.createElement(
      'p',
      { className: 'time' },
      date.format('hh:mm a')
    )
  );
};

AppointmentCard.propTypes = {
  timestamp: _propTypes2.default.string
};

exports.default = AppointmentCard;

/***/ }),
/* 2335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _translation = __webpack_require__(4);

var _InputBirthdate = __webpack_require__(220);

var _InputBirthdate2 = _interopRequireDefault(_InputBirthdate);

var _ModalConfirm = __webpack_require__(399);

var _ModalConfirm2 = _interopRequireDefault(_ModalConfirm);

var _lawyerCaseStatuses = __webpack_require__(142);

var _translation2 = __webpack_require__(64);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var CaseAssignmentModal = function (_Component) {
  _inherits(CaseAssignmentModal, _Component);

  function CaseAssignmentModal(props) {
    _classCallCheck(this, CaseAssignmentModal);

    var _this = _possibleConstructorReturn(this, (CaseAssignmentModal.__proto__ || Object.getPrototypeOf(CaseAssignmentModal)).call(this, props));

    _this.setCaseDetails = function (data) {
      var newCaseStatuses = [].concat(_toConsumableArray(_this.state.caseStatuses));
      var newCurrentCase = _extends({}, data);
      var status = null;
      if (data) {
        if (data.type === _lawyerCaseStatuses.TYPE_CASE_SPA) newCaseStatuses = _lawyerCaseStatuses.LAWYER_SPA_STATUSES;
        if (data.type === _lawyerCaseStatuses.TYPE_CASE_LA) newCaseStatuses = _lawyerCaseStatuses.LAWYER_LA_STATUSES;
        status = newCaseStatuses.find(function (s) {
          return s.value === data.status;
        });
      }
      // store previous spa_date for comparison in API
      if (newCurrentCase && newCurrentCase.extra_data) {
        newCurrentCase.extra_data.previous_spa_date = newCurrentCase.extra_data.spa_date;
      }
      _this.setState({
        caseStatuses: newCaseStatuses,
        currentStatus: status,
        currentCase: newCurrentCase
      });
    };

    _this.handleOnDateChange = function (day, name) {
      var newCurrentCase = _extends({}, _this.state.currentCase);
      if (newCurrentCase && newCurrentCase.extra_data) {
        newCurrentCase.extra_data[name] = day;
      } else {
        newCurrentCase.extra_data = _defineProperty({}, name, day);
      }
      _this.setState({ currentCase: newCurrentCase });
    };

    _this.handleOnInputChange = function (e, _ref) {
      var name = _ref.name,
          value = _ref.value;

      var newCurrentCase = _extends({}, _this.state.currentCase);
      if (newCurrentCase && newCurrentCase.extra_data) {
        newCurrentCase.extra_data[name] = value;
      } else {
        newCurrentCase.extra_data = _defineProperty({}, name, value);
      }

      _this.setState({ currentCase: newCurrentCase });
    };

    _this.renderSpaSignedContent = function () {
      var _this$props = _this.props,
          selectedStatus = _this$props.selectedStatus,
          t = _this$props.t,
          loading = _this$props.loading,
          isProjectHimsEnabled = _this$props.isProjectHimsEnabled;
      var _this$state = _this.state,
          caseStatuses = _this$state.caseStatuses,
          currentCase = _this$state.currentCase;

      var now = (0, _momentTimezone2.default)().toDate();
      var toMonth = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
      var fromMonth = new Date(2015, 0, 1);
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            'Are you sure you want to change the status to ',
            selectedStatus ? (0, _translation2.getConstantsLabel)(t, caseStatuses, selectedStatus) : '',
            '?'
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            'Please fill in the details'
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'lawyer-title-pb-row' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            'SPA Date',
            isProjectHimsEnabled ? '*' : ''
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'lawyer-input-pt-row' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(_InputBirthdate2.default, {
              date: currentCase && currentCase.extra_data && currentCase.extra_data.spa_date ? (0, _momentTimezone2.default)(currentCase.extra_data.spa_date).format('YYYY-MM-DD') : '',
              disabled: loading,
              disabledDays: { before: fromMonth, after: toMonth },
              format: null,
              fromMonth: fromMonth,
              monthLogic: null,
              onSelectDay: function onSelectDay(d) {
                return _this.handleOnDateChange(d, 'spa_date');
              },
              showMonth: currentCase && currentCase.extra_data && currentCase.extra_data.spa_date ? null : now,
              toMonth: toMonth
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'lawyer-title-pt-row lawyer-title-pb-row' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            'SPA Stamped Date'
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'lawyer-input-pt-row' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(_InputBirthdate2.default, {
              date: currentCase && currentCase.extra_data && currentCase.extra_data.spa_stamped_date ? (0, _momentTimezone2.default)(currentCase.extra_data.spa_stamped_date).format('YYYY-MM-DD') : '',
              disabled: loading,
              disabledDays: { before: fromMonth, after: toMonth },
              format: null,
              fromMonth: fromMonth,
              monthLogic: null,
              onSelectDay: function onSelectDay(d) {
                return _this.handleOnDateChange(d, 'spa_stamped_date');
              },
              showMonth: currentCase && currentCase.extra_data && currentCase.extra_data.spa_stamped_date ? null : now,
              toMonth: toMonth
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'lawyer-title-pt-row' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Form,
              { className: 'lawyer-confirmation-form-input' },
              _react2.default.createElement(_semanticUiReact.Form.Input, {
                fluid: true,
                name: 'spa_solicitor_ref_no',
                label: 'SPA Solicitor Reference No',
                value: currentCase && currentCase.extra_data ? currentCase.extra_data.spa_solicitor_ref_no : '',
                onChange: _this.handleOnInputChange
              })
            )
          )
        )
      );
    };

    _this.state = {
      caseStatuses: [],
      currentCase: null,
      currentStatus: null,
      spaDate: null,
      spaSolicitorRefNo: '',
      spaStampedDate: null
    };
    return _this;
  }

  _createClass(CaseAssignmentModal, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.data) {
        this.setCaseDetails(this.props.data);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
        this.setCaseDetails(nextProps.data);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          open = _props.open,
          onClose = _props.onClose,
          onUpdate = _props.onUpdate,
          selectedStatus = _props.selectedStatus,
          t = _props.t;
      var _state = this.state,
          currentCase = _state.currentCase,
          currentStatus = _state.currentStatus,
          caseStatuses = _state.caseStatuses;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_ModalConfirm2.default, {
          open: open && selectedStatus !== _lawyerCaseStatuses.SPA_SIGNED,
          onClose: onClose,
          onConfirm: function onConfirm(e) {
            return onUpdate(e, currentStatus ? currentStatus.value : null, currentCase);
          },
          headerNode: _react2.default.createElement(
            'span',
            null,
            t('Confirm ' + (selectedStatus === _lawyerCaseStatuses.DEVELOPER_CANCELLED ? 'cancel' : 'update')),
            '?'
          ),
          content: _react2.default.createElement(
            _reactI18next.Trans,
            { ns: _translation.TRANSLATION_FILES.screens },
            selectedStatus === _lawyerCaseStatuses.DEVELOPER_CANCELLED && _react2.default.createElement(
              'p',
              null,
              'Are you sure you want to cancel the assignment of ',
              _react2.default.createElement(
                'strong',
                null,
                { lawyerName: currentCase.lawyer ? currentCase.lawyer.name : '' }
              ),
              ' from this case?'
            ),
            selectedStatus !== _lawyerCaseStatuses.SPA_SIGNED && selectedStatus !== _lawyerCaseStatuses.DEVELOPER_CANCELLED && _react2.default.createElement(
              'p',
              null,
              'Are you sure you want to change the status from ',
              _react2.default.createElement(
                'strong',
                null,
                { currentStatus: currentStatus ? t(currentStatus.text, { ns: _translation.TRANSLATION_FILES.constants }) : '' }
              ),
              ' to ',
              _react2.default.createElement(
                'strong',
                null,
                { newStatus: selectedStatus ? (0, _translation2.getConstantsLabel)(t, caseStatuses, selectedStatus) : '' }
              ),
              '?'
            )
          )
        }),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            open: open && selectedStatus === _lawyerCaseStatuses.SPA_SIGNED,
            onClose: onClose,
            size: 'tiny'
          },
          _react2.default.createElement(_semanticUiReact.Header, { icon: 'file text outline', content: 'Change status to ' + (selectedStatus ? (0, _translation2.getConstantsLabel)(t, caseStatuses, selectedStatus) : '') }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Modal.Description,
              null,
              this.renderSpaSignedContent()
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(
              'span',
              null,
              'All fields marked with an * are required'
            ),
            _react2.default.createElement(_semanticUiReact.Button, { negative: true, onClick: onClose, icon: 'cancel', content: t('No', { ns: _translation.TRANSLATION_FILES.translation }) }),
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              onClick: function onClick(e) {
                return onUpdate(e, currentStatus ? currentStatus.value : null, currentCase);
              },
              icon: 'checkmark',
              content: t('Yes', { ns: _translation.TRANSLATION_FILES.translation }),
              'data-bot-target': 'confirm'
            })
          )
        )
      );
    }
  }]);

  return CaseAssignmentModal;
}(_react.Component);

CaseAssignmentModal.contextTypes = {
  store: _propTypes2.default.object
};
CaseAssignmentModal.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  loading: _propTypes2.default.bool,
  isProjectHimsEnabled: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onUpdate: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  selectedStatus: _propTypes2.default.string,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(CaseAssignmentModal);

/***/ }),
/* 2336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _lawyerCaseStatuses = __webpack_require__(142);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CaseStatusMilestone = function (_Component) {
  _inherits(CaseStatusMilestone, _Component);

  function CaseStatusMilestone() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, CaseStatusMilestone);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CaseStatusMilestone.__proto__ || Object.getPrototypeOf(CaseStatusMilestone)).call.apply(_ref, [this].concat(args))), _this), _this.getClassName = function (item, idx, currentIndex) {
      var classNames = ['status'];
      if (idx <= currentIndex) {
        classNames.push('active');
      }
      if (_this.checkCurrent(item, idx, currentIndex)) {
        classNames.push('current');
      }
      return classNames.join(' ');
    }, _this.getCurrentIndex = function () {
      var _this$props = _this.props,
          status = _this$props.status,
          type = _this$props.type;

      if (type === _lawyerCaseStatuses.TYPE_CASE_SPA) {
        return _lawyerCaseStatuses.LAWYER_SPA_STATUS_MILESTONES.findIndex(function (s) {
          return status === _lawyerCaseStatuses.SPA_SIGNED_PENDING ? s.value === _lawyerCaseStatuses.PENDING_APPOINTMENT : s.value === status;
        });
      }
      return _lawyerCaseStatuses.LAWYER_LA_STATUS_MILESTONES.findIndex(function (s) {
        return s.value === status;
      });
    }, _this.checkCurrent = function (item, idx, currentIndex) {
      var defaultCheck = idx === currentIndex;
      var type = _this.props.type;

      var extraCheck = item.value !== _lawyerCaseStatuses.SOLD;
      if (type === _lawyerCaseStatuses.TYPE_CASE_LA) {
        extraCheck = item.value !== _lawyerCaseStatuses.ADVICE_BANK;
      }
      return defaultCheck && extraCheck;
    }, _this.renderDate = function (idx) {
      var _this$props2 = _this.props,
          type = _this$props2.type,
          createdAt = _this$props2.createdAt,
          statusUpdatedAt = _this$props2.statusUpdatedAt;

      var dateFormat = 'DD-MM-YYYY, hh:mm a';
      if (idx === 0) {
        return _react2.default.createElement(
          'p',
          { className: 'date' },
          (0, _momentTimezone2.default)(createdAt).format(dateFormat)
        );
      }
      var dateIndex = idx - (type === _lawyerCaseStatuses.TYPE_CASE_SPA ? 0 : 1);
      if (dateIndex >= 0 && statusUpdatedAt && statusUpdatedAt.length > dateIndex) {
        return _react2.default.createElement(
          'p',
          { className: 'date' },
          (0, _momentTimezone2.default)(statusUpdatedAt[dateIndex]).format(dateFormat)
        );
      }
      return null;
    }, _this.renderStatus = function (item, idx, currentIndex) {
      var t = _this.props.t;

      var dateComponent = _this.renderDate(idx);
      return _react2.default.createElement(
        'div',
        { key: idx, className: _this.getClassName(item, idx, currentIndex) },
        _react2.default.createElement(
          'div',
          { className: 'box ' + (dateComponent !== null ? 'between' : '') },
          _react2.default.createElement(
            'p',
            null,
            t(item.text)
          ),
          dateComponent
        ),
        _react2.default.createElement('div', { className: 'dot' })
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(CaseStatusMilestone, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var type = this.props.type;

      var currentIndex = this.getCurrentIndex();
      var statuses = type === _lawyerCaseStatuses.TYPE_CASE_LA ? _lawyerCaseStatuses.LAWYER_LA_STATUS_MILESTONES : _lawyerCaseStatuses.LAWYER_SPA_STATUS_MILESTONES;
      return _react2.default.createElement(
        _semanticUiReact.Segment,
        { basic: true, className: 'CaseStatusMilestone ' + type },
        statuses.map(function (item, idx) {
          return _this2.renderStatus(item, idx, currentIndex);
        })
      );
    }
  }]);

  return CaseStatusMilestone;
}(_react.Component);

CaseStatusMilestone.propTypes = {
  type: _propTypes2.default.string,
  status: _propTypes2.default.string,
  createdAt: _propTypes2.default.string.isRequired,
  statusUpdatedAt: _propTypes2.default.arrayOf(_propTypes2.default.string)
};
CaseStatusMilestone.defaultProps = {
  type: _lawyerCaseStatuses.TYPE_CASE_SPA,
  status: _lawyerCaseStatuses.PENDING_APPOINTMENT,
  statusUpdatedAt: []
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.constants)(CaseStatusMilestone);

/***/ }),
/* 2337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cases = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactIframe = __webpack_require__(1412);

var _reactIframe2 = _interopRequireDefault(_reactIframe);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _spaDocLink = __webpack_require__(2341);

var _url = __webpack_require__(19);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _amount = __webpack_require__(87);

var _apiEndpoints = __webpack_require__(140);

var endpoints = _interopRequireWildcard(_apiEndpoints);

var _lawyerCaseStatuses = __webpack_require__(142);

var _propertyCategories = __webpack_require__(323);

var _translation = __webpack_require__(4);

var _AppointmentCard = __webpack_require__(2334);

var _AppointmentCard2 = _interopRequireDefault(_AppointmentCard);

var _LawyerDetail = __webpack_require__(2338);

var _LawyerDetail2 = _interopRequireDefault(_LawyerDetail);

var _SecondaryLawyerDetail = __webpack_require__(2339);

var _SecondaryLawyerDetail2 = _interopRequireDefault(_SecondaryLawyerDetail);

var _PanelLawyersList = __webpack_require__(2526);

var _PanelLawyersList2 = _interopRequireDefault(_PanelLawyersList);

var _AssignSecondaryLawyer = __webpack_require__(2509);

var _AssignSecondaryLawyer2 = _interopRequireDefault(_AssignSecondaryLawyer);

var _CaseStatusMilestone = __webpack_require__(2336);

var _CaseStatusMilestone2 = _interopRequireDefault(_CaseStatusMilestone);

var _LawyerAppointment = __webpack_require__(2517);

var _LawyerAppointment2 = _interopRequireDefault(_LawyerAppointment);

var _SpaCaseDetail = __webpack_require__(2340);

var _SpaCaseDetail2 = _interopRequireDefault(_SpaCaseDetail);

var _CaseAssignmentModal = __webpack_require__(2335);

var _CaseAssignmentModal2 = _interopRequireDefault(_CaseAssignmentModal);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// lawyerAPI replies 4XX with { error_message } (e.g. "City is required"),
// show that instead of the generic error
var lawyerAPIErrorMessage = function lawyerAPIErrorMessage(e, fallback) {
  var res = e && e.response;
  var isValidationStatus = res && res.status >= 400 && res.status < 500 && ![401, 403].includes(res.status);
  if (isValidationStatus && res.data && res.data.error_message) {
    return res.data.error_message;
  }
  return fallback;
};

// How long one Cloone /sales/create round-trip may take before it is abandoned and reported. A
// stalled request must not serialise every later case's link behind it (Codex round 1 on #3794).
var SPA_LINK_TIMEOUT_MS = 15000;

// Named export for tests; the default export below is the wrapped one the app uses.

var Cases = exports.Cases = function (_Component) {
  _inherits(Cases, _Component);

  function Cases(props) {
    var _this2 = this;

    _classCallCheck(this, Cases);

    var _this = _possibleConstructorReturn(this, (Cases.__proto__ || Object.getPrototypeOf(Cases)).call(this, props));

    _this.getMessageList = function () {
      var _this$props = _this.props,
          data = _this$props.data,
          primaryPurchaser = _this$props.primaryPurchaser,
          t = _this$props.t;

      var list = [];
      var allowLawyerAssignWithoutIC = data && data.project && data.project.allowLawyerAssignWithoutIC || false;
      if (!allowLawyerAssignWithoutIC && primaryPurchaser.customer && !(primaryPurchaser.customer.icFrontDocumentID && primaryPurchaser.customer.icFrontDocumentID)) {
        list.push(_react2.default.createElement(
          _semanticUiReact.Message.Item,
          { key: '2' },
          t('Upload purchaser\'s IC')
        ));
      }
      if (data.project && data.project.propertyCategory && data.project.propertyCategory.category !== _propertyCategories.PROPERTY_CATEGORY_LANDED && data.projectUnit && !data.projectUnit.streetNumberOrLevel) {
        list.push(_react2.default.createElement(
          _semanticUiReact.Message.Item,
          { key: '4' },
          t('Have a completed unit information (Level is required)')
        ));
      }
      return list;
    };

    _this.getOppositeType = function (assignType) {
      return assignType === _lawyerCaseStatuses.TYPE_CASE_SPA ? _lawyerCaseStatuses.TYPE_CASE_LA : _lawyerCaseStatuses.TYPE_CASE_SPA;
    };

    _this.setLoading = function () {
      var newLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var type = arguments[1];
      return new Promise(function (res) {
        var loading = _this.state.loading;

        if (type != null) {
          loading[type] = newLoading;
        } else {
          loading.SPA = newLoading;
          loading.LA = newLoading;
        }
        _this.setState({ loading: loading }, function () {
          return res(newLoading);
        });
      });
    };

    _this.setExternalLoading = function () {
      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var setLoading = _this.props.setLoading;

      if (setLoading) {
        setLoading(loading);
      }
    };

    _this.setComponentState = function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return new Promise(function (res) {
        return _this.setState(state, function () {
          return res(state);
        });
      });
    };

    _this.setCases = function (type) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var token = arguments[2];
      var loadMore = arguments[3];
      return new Promise(function (res) {
        var _this$state = _this.state,
            cases = _this$state.cases,
            activeCase = _this$state.activeCase,
            nextToken = _this$state.nextToken,
            lawyersIDList = _this$state.lawyersIDList;

        var newData = data || [];
        newData.forEach(function (_data) {
          var isExist = lawyersIDList.find(function (id) {
            return id === _data.lawyer_id;
          });
          if (!isExist) {
            lawyersIDList.push(_data.lawyer_id);
          }
        });
        var newCases = loadMore ? activeCase[type].concat(newData) : newData;
        var currentCase = newCases.find(function (d) {
          return d.status !== _lawyerCaseStatuses.DEVELOPER_CANCELLED;
        });
        if (!activeCase) {
          currentCase = _this.state.activeCase[type];
        }
        if (type === _lawyerCaseStatuses.TYPE_CASE_SPA && currentCase) {
          // use default type from settings
          currentCase.extra_data = _extends({}, currentCase.extra_data, {
            repType: _this.props.data && _this.props.data.project && _this.props.data.project.himsDefaultSpaLawyerRepID
          });
        }
        cases[type] = newCases;
        activeCase[type] = currentCase;
        nextToken[type] = token;
        _this.setState({ cases: cases, activeCase: activeCase, nextToken: nextToken, lawyersIDList: lawyersIDList }, function () {
          return res(newCases);
        });
      });
    };

    _this.getOppositeLawyerRepType = function (currentType) {
      return currentType === _lawyerCaseStatuses.REP_TYPE_DEVELOPER ? _lawyerCaseStatuses.REP_TYPE_PURCHASER : _lawyerCaseStatuses.REP_TYPE_DEVELOPER;
    };

    _this.handleUpdateSecondaryLawyer = function (e, validations, data) {
      e.preventDefault();
      _this.updateSecondaryLawyer(data, 'update', validations);
    };

    _this.fetchAllLawyerCasesDetails = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var bookingID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var lawyersIDList, promiseArr, promiseArrLawyer, promiseResultArray;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                lawyersIDList = _this.state.lawyersIDList;
                promiseArr = [_this.fetchLawyerCases('SPA', null, bookingID), _this.fetchLawyerCases('LA', null, bookingID)];

                if (!(promiseArr.length > 0)) {
                  _context.next = 13;
                  break;
                }

                _context.next = 5;
                return Promise.all(promiseArr);

              case 5:
                promiseArrLawyer = [];

                lawyersIDList.forEach(function (id) {
                  promiseArrLawyer.push(_this.fetchLawyer(id));
                });
                _context.next = 9;
                return Promise.all(promiseArrLawyer);

              case 9:
                promiseResultArray = _context.sent;

                _this.setState({ lawyersList: promiseResultArray });
                _this.fetchSPALink();
                _this.fetchSecondaryLawyers();

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function () {
        return _ref.apply(this, arguments);
      };
    }();

    _this.fetchLawyerCases = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(type, nextToken) {
        var bookingID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _this.props.bookingID;
        var activeCase, t, store, query, res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this.setLoading(true, type);

              case 2:
                if (nextToken) {
                  _context2.next = 7;
                  break;
                }

                activeCase = _this.state.activeCase;

                activeCase[type] = null;
                _context2.next = 7;
                return _this.setComponentState({ activeCase: activeCase });

              case 7:
                t = _this.props.t;
                store = _this.context.store;
                query = {
                  limit: 10,
                  type: type
                };

                if (nextToken) {
                  query.next_token = nextToken;
                }
                res = void 0;
                _context2.prev = 12;
                _context2.next = 15;
                return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.BOOKING_CASES(bookingID) + '/?' + _qs2.default.stringify(query), null, 'get', {
                  'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
                }));

              case 15:
                res = _context2.sent;
                _context2.next = 26;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2['catch'](12);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 23;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 23:
                _context2.next = 25;
                return _this.setLoading(false, type);

              case 25:
                return _context2.abrupt('return');

              case 26:
                if (!res) {
                  _context2.next = 29;
                  break;
                }

                _context2.next = 29;
                return _this.setCases(type, res.items, res.next_token, !!nextToken);

              case 29:
                _context2.next = 31;
                return _this.setLoading(false, type);

              case 31:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[12, 18]]);
      }));

      return function (_x6, _x7) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.assignLawyer = function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(sub, body) {
        var type, activeCase, store, t, bookingID, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                type = body.type;
                activeCase = _this.state.activeCase;
                store = _this.context.store;
                t = _this.props.t;
                bookingID = _this.props.bookingID;

                if (!activeCase[type]) {
                  _context3.next = 9;
                  break;
                }

                _context3.next = 8;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('Booking can only has 1 active lawyer', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 8:
                return _context3.abrupt('return');

              case 9:
                _context3.next = 11;
                return _this.setExternalLoading(true);

              case 11:
                res = void 0;
                _context3.prev = 12;
                _context3.next = 15;
                return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.LAWYER_CASES(sub.lawyer_id), body, 'post', {
                  'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
                }));

              case 15:
                res = _context3.sent;
                _context3.next = 30;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t0 = _context3['catch'](12);

                Bugsnag.notifyException(_context3.t0);
                _context3.next = 23;
                return _this.setExternalLoading(false);

              case 23:
                if (!(_context3.t0.response && _context3.t0.response.status === 409)) {
                  _context3.next = 27;
                  break;
                }

                _context3.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('{{caseType}} is already assigned with a Lawyer', { caseType: body.type, ns: _translation.TRANSLATION_FILES.translation }) }));

              case 26:
                return _context3.abrupt('return');

              case 27:
                _context3.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: lawyerAPIErrorMessage(_context3.t0, t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation })) }));

              case 29:
                return _context3.abrupt('return');

              case 30:
                _context3.next = 32;
                return _this.setComponentState({
                  assignSameLawyer: false
                });

              case 32:
                _context3.next = 34;
                return _this.setExternalLoading(false);

              case 34:
                if (!res) {
                  _context3.next = 41;
                  break;
                }

                _this.fetchAllLawyerCasesDetails(bookingID); // fetch newly assigned lawyer details
                activeCase[type] = res;
                _context3.next = 39;
                return _this.setComponentState({ activeCase: activeCase });

              case 39:
                _context3.next = 41;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Assign success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Successfully assign case to lawyer {{name}}', { name: sub.lawyer_name, ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 41:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[12, 18]]);
      }));

      return function (_x9, _x10) {
        return _ref3.apply(this, arguments);
      };
    }();

    _this.updateLawyerCase = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(caseData) {
        var _this$props2, t, isProjectHimsEnabled, store, res, status, message, data, activeCase;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this.setExternalLoading(true);

              case 2:
                _this$props2 = _this.props, t = _this$props2.t, isProjectHimsEnabled = _this$props2.isProjectHimsEnabled;
                store = _this.context.store;
                res = void 0;

                if (!(caseData && caseData.caseStatus === _lawyerCaseStatuses.SPA_SIGNED && !caseData.spaDate && isProjectHimsEnabled)) {
                  _context4.next = 11;
                  break;
                }

                _context4.next = 8;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'SPA Date is required' }));

              case 8:
                _context4.next = 10;
                return _this.setExternalLoading(false);

              case 10:
                return _context4.abrupt('return');

              case 11:
                _context4.prev = 11;
                _context4.next = 14;
                return store.dispatch((0, _fetchM.fetchM)('/lawyers/' + caseData.lawyerID + '/cases/' + caseData.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(caseData)
                }));

              case 14:
                res = _context4.sent;
                _context4.next = 41;
                break;

              case 17:
                _context4.prev = 17;
                _context4.t0 = _context4['catch'](11);
                _context4.next = 21;
                return _this.setExternalLoading(false);

              case 21:
                // fetchM already handles auth, not-found and session statuses,
                // only surface validation-type errors
                status = _context4.t0.res ? _context4.t0.res.status : 0;

                if (!(status >= 400 && status < 500 && ![401, 403, 404, 428].includes(status))) {
                  _context4.next = 37;
                  break;
                }

                message = '';
                _context4.prev = 24;
                _context4.next = 27;
                return _context4.t0.res.text();

              case 27:
                message = _context4.sent;
                _context4.next = 33;
                break;

              case 30:
                _context4.prev = 30;
                _context4.t1 = _context4['catch'](24);

                message = '';

              case 33:
                if (!message) {
                  _context4.next = 37;
                  break;
                }

                _context4.next = 36;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 36:
                return _context4.abrupt('return');

              case 37:
                Bugsnag.notifyException(_context4.t0);
                _context4.next = 40;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 40:
                return _context4.abrupt('return');

              case 41:
                if (!res) {
                  _context4.next = 52;
                  break;
                }

                _context4.next = 44;
                return res.json();

              case 44:
                data = _context4.sent;
                activeCase = _this.state.activeCase;

                if (caseData.type === _lawyerCaseStatuses.TYPE_CASE_SPA) {
                  data.extra_data = _extends({}, data.extra_data, {
                    repType: caseData.repType || activeCase[caseData.type].extra_data.repType
                  });
                }
                activeCase[caseData.type] = caseData.caseStatus === _lawyerCaseStatuses.DEVELOPER_CANCELLED ? null : Object.assign({}, data, {
                  lawyer: activeCase[caseData.type] && activeCase[caseData.type].lawyer ? activeCase[caseData.type].lawyer : null
                });
                _context4.next = 50;
                return _this.setComponentState({ activeCase: activeCase, selectedStatus: null, currentCase: null });

              case 50:
                _context4.next = 52;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Status successfully updated', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 52:
                _context4.next = 54;
                return _this.setExternalLoading(false);

              case 54:

                if (!_this.state.activeCase[caseData.type]) {
                  _this.fetchLawyerCases(caseData.type);
                }

              case 55:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2, [[11, 17], [24, 30]]);
      }));

      return function (_x11) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.updateCaseAppointment = function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(body) {
        var activeCase, t, currentCase, store, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this.setLoading(true, _lawyerCaseStatuses.TYPE_CASE_SPA);

              case 2:
                _context5.next = 4;
                return _this.setExternalLoading(true);

              case 4:
                activeCase = _this.state.activeCase;
                t = _this.props.t;
                currentCase = activeCase.SPA;
                store = _this.context.store;
                res = void 0;
                _context5.prev = 9;
                _context5.next = 12;
                return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.LAWYER_CASE_DETAILS(currentCase.lawyer_id, currentCase.id), body, 'put', {
                  'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
                }));

              case 12:
                res = _context5.sent;
                _context5.next = 25;
                break;

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5['catch'](9);

                Bugsnag.notifyException(_context5.t0);
                _context5.next = 20;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: lawyerAPIErrorMessage(_context5.t0, t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation })) }));

              case 20:
                _context5.next = 22;
                return _this.setLoading(false, _lawyerCaseStatuses.TYPE_CASE_SPA);

              case 22:
                _context5.next = 24;
                return _this.setExternalLoading(false);

              case 24:
                return _context5.abrupt('return');

              case 25:
                if (!res) {
                  _context5.next = 31;
                  break;
                }

                activeCase.SPA = res;
                _context5.next = 29;
                return _this.setComponentState({ activeCase: activeCase, showLawyerAppointment: false });

              case 29:
                _context5.next = 31;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Appointment successfully updated', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 31:
                _context5.next = 33;
                return _this.setLoading(false, _lawyerCaseStatuses.TYPE_CASE_SPA);

              case 33:
                _context5.next = 35;
                return _this.setExternalLoading(false);

              case 35:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this2, [[9, 15]]);
      }));

      return function (_x12) {
        return _ref5.apply(this, arguments);
      };
    }();

    _this.generateDocumentKey = function () {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (key) {
        if (key.includes('.jpg')) {
          return (0, _url.AWSUrl)(_this.props.appConfig, '' + key);
        }
        return (0, _url.AWSUrl)(_this.props.appConfig, key + '100.jpg');
      }
      return 'none';
    };

    _this.generateBookingData = function () {
      var caseType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _lawyerCaseStatuses.TYPE_CASE_SPA;
      var _this$props3 = _this.props,
          data = _this$props3.data,
          primaryPurchaser = _this$props3.primaryPurchaser,
          purchasers = _this$props3.purchasers,
          successBankCase = _this$props3.successBankCase;
      var companyDocuments = _this.state.companyDocuments;

      var casePurchasers = [];
      var property = {
        project_code: data.projectID,
        project_name: data.project.name,
        project_short_name: data.project.shortName,
        project_type: data.project.propertyCategory.category,
        block: data.projectUnit.zoneOrBlock,
        level: data.projectUnit.streetNumberOrLevel,
        unit: data.projectUnit,
        unit_no: data.projectUnit.reference,
        unit_type: data.projectUnit.projectUnitLayout.name,
        size: data.projectUnit.size + ' ' + (data.project.sizeSuffix === 'square_feet' ? 'sqft' : 'sqm'),
        selling_price: parseFloat((0, _amount.spaFullNumber)(data.projectUnit)),
        phone_prefix: data.project.phonePrefix,
        phone: data.project.phone,
        address1: data.project.address1,
        address2: data.project.address2,
        address3: data.project.address3,
        address4: data.project.address4,
        postcode: data.project.address5,
        city: data.project.address6,
        state: data.project.address7,
        country: data.project.country,
        project_pictures: []
      };
      if (data.project.projectPictures && "" && "ap-southeast-1") {
        data.project.projectPictures.forEach(function (pp) {
          property.project_pictures.push({
            id: pp.pictureID,
            picture: 'https://s3-' + "ap-southeast-1" + '.amazonaws.com/' + "" + '/' + pp.picture.key + '070.jpg',
            isCover: pp.isCover,
            type: pp.type
          });
        });
      }
      var booking = {
        payment_amount: data.paymentAmount,
        financial_type: data.paymentMethodID,
        bank_name: successBankCase ? successBankCase.bank.name : '',
        banker_name: successBankCase ? successBankCase.banker.name : '',
        banker_mobile: successBankCase && successBankCase.banker && successBankCase.banker.mobile ? '+' + (successBankCase.banker.mobilePrefix === 'other' ? '' : successBankCase.banker.mobilePrefix) + successBankCase.banker.mobile : '',
        selling_price: parseFloat((0, _amount.spaFullNumber)(data)),
        loan_amount: successBankCase && successBankCase.loanAmount > 0 ? parseInt(successBankCase.loanAmount, 10) : 0
      };

      if (purchasers.length > 0) {
        purchasers.forEach(function (p) {
          var mobile = void 0;
          if (p.mobile) {
            mobile = '+' + (p.mobilePrefix === 'other' ? '' : p.mobilePrefix) + p.mobile;
          }
          var phone = void 0;
          if (p.phone) {
            phone = '+' + (p.phonePrefix === 'other' ? '' : p.phonePrefix) + p.phone;
          }
          var identityType = 'ic_number';
          switch (p.customer && p.customer.identityTypeID) {
            case 2:
              identityType = 'passport';
              break;
            case 3:
              identityType = 'military_police';
              break;
            case 4:
              identityType = 'company_reg_number';
              break;
            case 5:
              identityType = 'id_number';
              break;
            default:
              identityType = 'ic_number';
              break;
          }
          var nricFront = _this.generateDocumentKey(p.customer && p.customer.icFrontDocument && p.customer.icFrontDocument.key);
          var nricBack = _this.generateDocumentKey(p.customer && p.customer.icBackDocument && p.customer.icBackDocument.key);

          var purchaser = {
            id: p.customerID,
            address_1: p.address1,
            address_2: p.address2,
            postcode: p.address5,
            city: p.address6,
            state: p.address7,
            country: p.country,
            email: p.email,
            gender: p.gender,
            identity_no: p.customer && p.customer.identity,
            identity_type: identityType,
            marital_status: p.maritalStatus,
            mobile: mobile,
            name: p.name,
            nationality: p.nationality,
            nric_back: nricBack,
            nric_front: nricFront,
            occupation: p.jobTitle,
            phone: phone,
            race: p.race
          };
          casePurchasers.push(purchaser);
        });
      }

      var mobile = void 0;
      if (primaryPurchaser.mobile) {
        mobile = '+' + (primaryPurchaser.mobilePrefix === 'other' ? '' : primaryPurchaser.mobilePrefix) + primaryPurchaser.mobile;
      }
      var phone = void 0;
      if (primaryPurchaser.phone) {
        phone = '+' + (primaryPurchaser.phonePrefix === 'other' ? '' : primaryPurchaser.phonePrefix) + primaryPurchaser.phone;
      }
      var identityType = 'ic_number';
      switch (primaryPurchaser.customer && primaryPurchaser.customer.identityTypeID) {
        case 2:
          identityType = 'passport';
          break;
        case 3:
          identityType = 'military_police';
          break;
        case 4:
          identityType = 'company_reg_number';
          break;
        case 5:
          identityType = 'id_number';
          break;
        default:
          identityType = 'ic_number';
          break;
      }
      var nricFront = _this.generateDocumentKey(primaryPurchaser.customer && primaryPurchaser.customer.icFrontDocument && primaryPurchaser.customer.icFrontDocument.key);
      var nricBack = _this.generateDocumentKey(primaryPurchaser.customer && primaryPurchaser.customer.icBackDocument && primaryPurchaser.customer.icBackDocument.key);

      var purchaser = {
        id: primaryPurchaser.customerID,
        address_1: primaryPurchaser.address1,
        address_2: primaryPurchaser.address2,
        postcode: primaryPurchaser.address5,
        city: primaryPurchaser.address6,
        state: primaryPurchaser.address7,
        country: primaryPurchaser.country,
        email: primaryPurchaser.email,
        gender: primaryPurchaser.gender,
        identity_no: primaryPurchaser.customer && primaryPurchaser.customer.identity,
        identity_type: identityType,
        marital_status: primaryPurchaser.maritalStatus,
        mobile: mobile,
        name: primaryPurchaser.name,
        nationality: primaryPurchaser.nationality,
        nric_back: nricBack,
        nric_front: nricFront,
        occupation: primaryPurchaser.jobTitle,
        phone: phone,
        race: primaryPurchaser.race
      };

      var documents = {
        nric_front: nricFront,
        nric_back: nricBack
      };
      if (companyDocuments.length > 0) {
        companyDocuments.forEach(function (file) {
          var key = file.id;
          switch (key) {
            case 'm_a':
              key = 'memorandum';
              break;
            case 'resolution':
              key = 'company_resolution';
              break;
            default:
              key = file.id;
          }
          documents[key] = (0, _url.AWSUrl)(_this.props.appConfig, file.key);
        });
      }
      var caseData = {
        type: caseType,
        company_id: _this.props.appConfig && _this.props.appConfig.data ? _this.props.appConfig.data.companyID : 0,
        project_id: _this.props.loanTrackerProjectID,
        project_unit_id: data.projectUnit.id,
        booking_id: _this.props.bookingID,
        purchaser_id: primaryPurchaser.customerID,
        property: property,
        booking: booking,
        purchasers: casePurchasers,
        purchaser: purchaser,
        documents: documents
      };
      return caseData;
    };

    _this.handleLoadMore = function (type) {
      var bookingID = _this.props.bookingID;
      var nextToken = _this.state.nextToken;

      if (bookingID) {
        _this.fetchLawyerCases(type, nextToken);
      }
    };

    _this.handleShowAssignSecondaryLawyer = function (e) {
      if (e) {
        e.preventDefault();
      }
      _this.setState({
        showAssignSecondaryLawyer: true,
        assignType: _lawyerCaseStatuses.TYPE_CASE_SPA
      });
    };

    _this.handleCloseAssignSecondaryLawyer = function (e) {
      if (e) {
        e.preventDefault();
      }
      _this.setState({
        showAssignSecondaryLawyer: false
      });
    };

    _this.handleCreateSecondaryLawyer = function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(e, validations, newLawyer) {
        var store, t, errors, res, message, activeSecondaryLawyer;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                store = _this.context.store;
                t = _this.props.t;

                if (e) {
                  e.preventDefault();
                }
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context6.next = 7;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context6.abrupt('return');

              case 7:
                _this.setState({
                  showAssignSecondaryLawyer: false
                });
                _context6.next = 10;
                return _this.setLoading(true, _lawyerCaseStatuses.TYPE_CASE_SPA);

              case 10:
                _context6.next = 12;
                return _this.setExternalLoading(true);

              case 12:
                res = void 0;
                _context6.prev = 13;
                _context6.next = 16;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + _this.props.bookingID + '/lawyers/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': _this.props.token
                  },
                  body: JSON.stringify(newLawyer)
                }));

              case 16:
                res = _context6.sent;
                _context6.next = 32;
                break;

              case 19:
                _context6.prev = 19;
                _context6.t0 = _context6['catch'](13);
                _context6.next = 23;
                return _this.setLoading(false);

              case 23:
                if (!(_context6.t0.res && _context6.t0.res.status >= 400 && _context6.t0.res.status < 500)) {
                  _context6.next = 29;
                  break;
                }

                _context6.next = 26;
                return _context6.t0.res.text();

              case 26:
                message = _context6.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context6.abrupt('return');

              case 29:
                Bugsnag.notifyException(_context6.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context6.abrupt('return');

              case 32:
                _context6.next = 34;
                return _this.setLoading(false, _lawyerCaseStatuses.TYPE_CASE_SPA);

              case 34:
                _context6.next = 36;
                return _this.setExternalLoading(false);

              case 36:
                _context6.next = 38;
                return res.json();

              case 38:
                activeSecondaryLawyer = _context6.sent;
                _context6.next = 41;
                return _this.setComponentState({ activeSecondaryLawyer: activeSecondaryLawyer });

              case 41:
                _context6.next = 43;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Assign 2nd Lawyer Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Lawyer {{name}} is successfully added', { name: activeSecondaryLawyer.name, ns: _translation.TRANSLATION_FILES.translation }) + '.'
                }));

              case 43:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this2, [[13, 19]]);
      }));

      return function (_x15, _x16, _x17) {
        return _ref6.apply(this, arguments);
      };
    }();

    _this.handleEditSecondaryLawyer = function () {
      var activeSecondaryLawyer = _this.state.activeSecondaryLawyer;

      _this.setState({
        showAssignSecondaryLawyer: true,
        editingSecondaryLawyer: activeSecondaryLawyer
      });
    };

    _this.handleRemoveSecondaryLawyer = function () {
      var activeSecondaryLawyer = _this.state.activeSecondaryLawyer;

      var req = activeSecondaryLawyer;
      req.status = _lawyerCaseStatuses.LAWYER_STATUS_CANCELLED;
      _this.updateSecondaryLawyer(req, 'remove');
    };

    _this.handleUpdateRepType = function (type) {
      var activeSecondaryLawyer = _this.state.activeSecondaryLawyer;
      // update active booking lawyer's reptype

      if (activeSecondaryLawyer && activeSecondaryLawyer.repType === type) {
        var req = activeSecondaryLawyer;
        req.repType = _this.getOppositeLawyerRepType(type);
        _this.updateSecondaryLawyer(req, 'updateRepType');
      }
    };

    _this.updateSecondaryLawyer = function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(lawyerData) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'update';
        var validations = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

        var store, _this$props4, data, t, activeCase, errors, res, _message, activeSecondaryLawyer, message;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                store = _this.context.store;
                _this$props4 = _this.props, data = _this$props4.data, t = _this$props4.t;
                activeCase = _this.state.activeCase;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context7.next = 7;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context7.abrupt('return');

              case 7:
                _this.setState({
                  showAssignSecondaryLawyer: false
                });
                _context7.next = 10;
                return _this.setLoading(true, _lawyerCaseStatuses.TYPE_CASE_SPA);

              case 10:
                _context7.next = 12;
                return _this.setExternalLoading(true);

              case 12:
                res = void 0;
                _context7.prev = 13;
                _context7.next = 16;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + _this.props.bookingID + '/lawyers/' + lawyerData.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': _this.props.token
                  },
                  body: JSON.stringify(lawyerData)
                }));

              case 16:
                res = _context7.sent;
                _context7.next = 32;
                break;

              case 19:
                _context7.prev = 19;
                _context7.t0 = _context7['catch'](13);
                _context7.next = 23;
                return _this.setLoading(false);

              case 23:
                if (!(_context7.t0.res && _context7.t0.res.status >= 400 && _context7.t0.res.status < 500)) {
                  _context7.next = 29;
                  break;
                }

                _context7.next = 26;
                return _context7.t0.res.text();

              case 26:
                _message = _context7.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));
                return _context7.abrupt('return');

              case 29:
                Bugsnag.notifyException(_context7.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context7.abrupt('return');

              case 32:
                _context7.next = 34;
                return _this.setLoading(false, _lawyerCaseStatuses.TYPE_CASE_SPA);

              case 34:
                _context7.next = 36;
                return _this.setExternalLoading(false);

              case 36:
                _context7.next = 38;
                return res.json();

              case 38:
                activeSecondaryLawyer = _context7.sent;

                if (!((type === 'updateRepType' || type === 'update') && activeCase[_lawyerCaseStatuses.TYPE_CASE_SPA])) {
                  _context7.next = 43;
                  break;
                }

                activeCase[_lawyerCaseStatuses.TYPE_CASE_SPA].extra_data = _extends({}, activeCase[_lawyerCaseStatuses.TYPE_CASE_SPA].extra_data, {
                  repType: _this.getOppositeLawyerRepType(activeSecondaryLawyer.repType)
                });
                _context7.next = 43;
                return _this.setComponentState({ activeCase: activeCase });

              case 43:
                message = 'Updated';

                if (type === 'remove') {
                  message = 'Delete Success';
                  activeSecondaryLawyer = {};
                }
                _context7.next = 47;
                return _this.setComponentState({ activeSecondaryLawyer: activeSecondaryLawyer });

              case 47:
                _context7.next = 49;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t(message, { ns: _translation.TRANSLATION_FILES.translation })
                  // message: `${t('Lawyer {{name}} is successfully deleted', { name: newLawyer.name, ns: TRANSLATION_FILES.translation })}.`,
                }));

              case 49:
                if (!(type === 'remove')) {
                  _context7.next = 55;
                  break;
                }

                if (!(activeCase[_lawyerCaseStatuses.TYPE_CASE_SPA] && data && data.project)) {
                  _context7.next = 54;
                  break;
                }

                // set to default value from settings if there's no active 2nd lawyer
                activeCase[_lawyerCaseStatuses.TYPE_CASE_SPA].extra_data = _extends({}, activeCase[_lawyerCaseStatuses.TYPE_CASE_SPA].extra_data, {
                  repType: data.project.himsDefaultSpaLawyerRepID
                });
                _context7.next = 54;
                return _this.setComponentState({ activeCase: activeCase });

              case 54:
                _this.fetchSecondaryLawyers();

              case 55:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this2, [[13, 19]]);
      }));

      return function (_x18) {
        return _ref7.apply(this, arguments);
      };
    }();

    _this.handleShowAssignLawyer = function (e, assignType) {
      if (e) {
        e.preventDefault();
      }
      _this.setState({
        showAssignLawyer: true,
        assignType: assignType
      });
    };

    _this.handleCloseAssignLawyer = function (e) {
      if (e) {
        e.preventDefault();
      }
      _this.setState({
        showAssignLawyer: false
      });
    };

    _this.handleAssignLawyer = function (e, selected) {
      if (e) {
        e.preventDefault();
      }
      _this.setState({ showAssignLawyer: false }, function () {
        var _this$state2 = _this.state,
            assignType = _this$state2.assignType,
            assignSameLawyer = _this$state2.assignSameLawyer;

        var caseData = _this.generateBookingData(assignType);
        _this.assignLawyer(selected, caseData);
        if (assignSameLawyer) {
          var otherCaseData = _this.generateBookingData(_this.getOppositeType(assignType));
          _this.assignLawyer(selected, otherCaseData);
        }
      });
    };

    _this.handleShowModalConfirm = function (e, value, currentCase) {
      if (e) {
        e.preventDefault();
      }
      _this.setState({
        currentCase: currentCase,
        showModalConfirm: true,
        selectedStatus: value
      });
    };

    _this.handleCloseModalConfirm = function (e) {
      if (e) {
        e.preventDefault();
      }
      _this.setState({
        showModalConfirm: false,
        selectedStatus: null
      });
    };

    _this.handleShowLawyerAppointment = function (e) {
      if (e) {
        e.preventDefault();
      }
      _this.setState({
        showLawyerAppointment: true
      });
    };

    _this.handleCloseLawyerAppointment = function (e) {
      if (e) {
        e.preventDefault();
      }
      _this.setState({
        showLawyerAppointment: false
      });
    };

    _this.handleUpdateLawyerAppointment = function (e, appointment) {
      if (e) {
        e.preventDefault();
      }
      if (!_this.canUpdateAppointment()) {
        var store = _this.context.store;
        var t = _this.props.t;

        store.dispatch((0, _flash.flashErrorMessage)({ message: t('Appointment cannot be updated', { ns: _translation.TRANSLATION_FILES.translation }) }));
        return;
      }

      _this.updateCaseAppointment(appointment);
    };

    _this.handleUpdateSpaCaseDetails = function (e, d) {
      if (d) {
        var bookingID = _this.props.bookingID;
        var activeCase = _this.state.activeCase;

        var caseData = {
          id: activeCase[_lawyerCaseStatuses.TYPE_CASE_SPA].id,
          lawyerID: activeCase[_lawyerCaseStatuses.TYPE_CASE_SPA].lawyer_id,
          bookingID: bookingID,
          caseStatus: activeCase[_lawyerCaseStatuses.TYPE_CASE_SPA].status,
          previousSpaDate: d.spa_date ? (0, _momentTimezone2.default)(d.previous_spa_date).toDate() : null,
          spaDate: d.spa_date ? (0, _momentTimezone2.default)(d.spa_date).toDate() : null,
          spaStampedDate: d.spa_stamped_date ? (0, _momentTimezone2.default)(d.spa_stamped_date).toDate() : null,
          spaSolicitorRefNo: d.spa_solicitor_ref_no,
          type: _lawyerCaseStatuses.TYPE_CASE_SPA,
          bypassUpdateCheck: true
        };
        if (d.repType) {
          caseData.repType = d.repType;
        }
        _this.updateLawyerCase(caseData);
        // update active booking lawyer's reptype
        _this.handleUpdateRepType(d.repType);
      }
    };

    _this.handleUpdateLawyerCase = function (e, previousStatus, caseUpdate) {
      if (e) {
        e.preventDefault();
      }
      var bookingID = _this.props.bookingID;
      var selectedStatus = _this.state.selectedStatus;


      _this.setState({ showModalConfirm: false }, function () {
        var caseData = {
          id: caseUpdate.id,
          lawyerID: caseUpdate.lawyer_id,
          bookingID: bookingID,
          caseStatus: selectedStatus,
          previousCaseStatus: previousStatus || (caseUpdate.type === _lawyerCaseStatuses.TYPE_CASE_SPA ? _lawyerCaseStatuses.PENDING_APPOINTMENT : _lawyerCaseStatuses.NEW),
          spaDate: caseUpdate && caseUpdate.extra_data && caseUpdate.extra_data.spa_date ? (0, _momentTimezone2.default)(caseUpdate.extra_data.spa_date).toDate() : null,
          previousSpaDate: caseUpdate && caseUpdate.extra_data && caseUpdate.extra_data.previous_spa_date ? (0, _momentTimezone2.default)(caseUpdate.extra_data.previous_spa_date).toDate() : null,
          spaStampedDate: caseUpdate && caseUpdate.extra_data && caseUpdate.extra_data.spa_stamped_date ? (0, _momentTimezone2.default)(caseUpdate.extra_data.spa_stamped_date).toDate() : null,
          spaSolicitorRefNo: caseUpdate && caseUpdate.extra_data ? caseUpdate.extra_data.spa_solicitor_ref_no : '',
          type: caseUpdate.type
        };
        _this.updateLawyerCase(caseData);
      });
    };

    _this.checkDisableLawyer = function (sub) {
      var _this$state3 = _this.state,
          cases = _this$state3.cases,
          assignType = _this$state3.assignType;

      return cases[assignType].some(function (c) {
        return c.lawyer_id === sub.lawyer_id;
      });
    };

    _this.canUpdateAppointment = function () {
      var activeCase = _this.state.activeCase;

      if (activeCase && activeCase.SPA) {
        var status = activeCase.SPA.status;

        return status === _lawyerCaseStatuses.PENDING_APPOINTMENT || status === _lawyerCaseStatuses.SPA_SIGNED_PENDING;
      }
      return false;
    };

    _this.handleCount = function (lawyer, type) {
      var _this$state4 = _this.state,
          activeCase = _this$state4.activeCase,
          doneCount = _this$state4.doneCount;

      if (activeCase[type]) {
        if (lawyer.id === activeCase[type].lawyer_id) {
          activeCase[type].lawyer = lawyer;
        }
      }
      doneCount[type] += 1;
      _this.setState({
        activeCase: activeCase,
        doneCount: doneCount
      });
    };

    _this.hasAccess = function () {
      var auth = _this.props.auth;

      return auth.isHeadquarters || auth.isSuperAdmin;
    };

    _this.handleCheckChange = function (e, _ref8) {
      var checked = _ref8.checked;

      _this.setState({
        assignSameLawyer: checked
      });
    };

    _this.hasUpdateLASPAAccess = function () {
      var auth = _this.props.auth;

      return auth.isHeadquarters || auth.isAdminBasic || auth.isBranchLeader;
    };

    _this.isLawyerUpdateDisabled = function (status, type) {
      var loading = _this.state.loading;

      return loading[type] || _this.props.disabled || status === _lawyerCaseStatuses.DEVELOPER_RECEIVED || status === _lawyerCaseStatuses.FIRST_DISBURSEMENT;
    };

    _this.isLawyerAssignDisabled = function (type) {
      return _this.state.loading[type] || _this.props.disabled || _this.props.data.statusID === 'cancelled_developer' || _this.props.data.statusID === 'expired' || _this.props.auth.isExternalAgent;
    };

    _this.renderAppointment = function (appointment) {
      var loading = _this.state.loading;
      var t = _this.props.t;

      if (appointment) {
        var dateTime = appointment.date_time;

        return _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 3, doubling: true },
          dateTime ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(_AppointmentCard2.default, { timestamp: dateTime })
          ) : Array(3).fill(3).map(function (d, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { key: idx },
              _react2.default.createElement(_AppointmentCard2.default, { timestamp: appointment['slot_' + (idx + 1)] })
            );
          })
        );
      }
      return _react2.default.createElement(
        _semanticUiReact.Segment,
        { basic: true, padded: true },
        _react2.default.createElement(
          _semanticUiReact.Button,
          {
            primary: true,
            onClick: _this.handleShowLawyerAppointment,
            disabled: loading.SPA || _this.props.disabled
          },
          t('Schedule')
        )
      );
    };

    _this.renderCurrentSecondarySpaLawyer = function (type) {
      var _this$state5 = _this.state,
          activeSecondaryLawyer = _this$state5.activeSecondaryLawyer,
          activeCase = _this$state5.activeCase;

      if (activeSecondaryLawyer && activeSecondaryLawyer.id) {
        return _react2.default.createElement(_SecondaryLawyerDetail2.default, {
          data: activeSecondaryLawyer,
          lawyerID: activeSecondaryLawyer.id,
          onDelete: _this.handleRemoveSecondaryLawyer,
          onEdit: _this.handleEditSecondaryLawyer
        });
      }
      return activeCase[type] && _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 16, textAlign: 'center' },
        _react2.default.createElement(_semanticUiReact.Button, {
          primary: true,
          onClick: _this.handleShowAssignSecondaryLawyer,
          icon: 'add user',
          labelPosition: 'left',
          content: _react2.default.createElement(
            'div',
            null,
            'Assign 2nd lawyer',
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              'small',
              null,
              'For HIMS e-SPA'
            )
          )
        })
      );
    };

    _this.renderCurrentCase = function (type) {
      var _this$state6 = _this.state,
          activeCase = _this$state6.activeCase,
          activeSecondaryLawyer = _this$state6.activeSecondaryLawyer,
          lawyersList = _this$state6.lawyersList;
      var _this$props5 = _this.props,
          t = _this$props5.t,
          auth = _this$props5.auth,
          isProjectHimsEnabled = _this$props5.isProjectHimsEnabled;

      var company = auth && auth.company ? auth.company : null;
      var currentCase = activeCase[type];
      if (currentCase) {
        var appointment = currentCase.appointment,
            status = currentCase.status,
            createdAt = currentCase.created_at,
            statusUpdatedAt = currentCase.status_updated_at;

        var canUpdateAppointment = appointment && _this.canUpdateAppointment();
        return _react2.default.createElement(
          _semanticUiReact.Grid,
          { stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, textAlign: 'left' },
              _react2.default.createElement(_CaseStatusMilestone2.default, {
                type: type,
                status: status,
                createdAt: createdAt,
                statusUpdatedAt: statusUpdatedAt
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 16, tablet: 8, computer: 8 },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { verticalAlign: 'middle' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'left', width: 4 },
                  _react2.default.createElement(
                    _semanticUiReact.Header,
                    null,
                    t('Status'),
                    ':'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'right', width: 12 },
                  _react2.default.createElement(_semanticUiReact.Dropdown, {
                    fluid: true,
                    disabled: _this.isLawyerUpdateDisabled(status, type),
                    name: 'status',
                    onChange: function onChange(e, _ref9) {
                      var value = _ref9.value;
                      return _this.handleShowModalConfirm(e, value, currentCase);
                    },
                    options: (type === _lawyerCaseStatuses.TYPE_CASE_SPA ? (0, _lawyerCaseStatuses.getLawyerSPACaseStatuses)(status, company, _this.hasUpdateLASPAAccess()) : (0, _lawyerCaseStatuses.getLawyerLACaseStatuses)(status, company, _this.hasUpdateLASPAAccess())).map(function (opt) {
                      return _extends({}, opt, {
                        text: t(opt.text, { ns: _translation.TRANSLATION_FILES.constants })
                      });
                    }),
                    placeholder: t('Select {{title}}', { title: t('Status') }),
                    selection: true,
                    selectOnBlur: false,
                    value: status
                  })
                )
              )
            )
          ),
          type === _lawyerCaseStatuses.TYPE_CASE_LA ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 16, tablet: 8, computer: 8 },
              _react2.default.createElement(_LawyerDetail2.default, {
                data: lawyersList.find(function (lawyer) {
                  return lawyer.id === currentCase.lawyer_id;
                }),
                basic: true,
                lawyerID: currentCase.lawyer_id,
                canFetch: true,
                onDone: function onDone(lawyer) {
                  return _this.handleCount(lawyer, type);
                }
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 16, tablet: 8, computer: 8 },
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { className: 'RemarksCard' },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'left', width: 16 },
                    _react2.default.createElement(
                      _semanticUiReact.Header,
                      null,
                      t('Remarks')
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'left', width: 16 },
                    _this.renderRemarksComponent(currentCase)
                  )
                )
              )
            )
          ) : null,
          type === _lawyerCaseStatuses.TYPE_CASE_SPA ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 16, tablet: 8, computer: 8 },
              _react2.default.createElement(_SpaCaseDetail2.default, {
                basic: true,
                data: currentCase && currentCase.extra_data ? currentCase.extra_data : null,
                loading: _this.state.loading.SPA,
                onUpdate: _this.handleUpdateSpaCaseDetails,
                isProjectHimsEnabled: isProjectHimsEnabled,
                hasActiveSecondaryLawyer: activeSecondaryLawyer && activeSecondaryLawyer.id
              }),
              _react2.default.createElement(_LawyerDetail2.default, {
                data: lawyersList.find(function (lawyer) {
                  return lawyer.id === currentCase.lawyer_id;
                }),
                basic: true,
                lawyerID: currentCase.lawyer_id,
                canFetch: true,
                onDone: function onDone(lawyer) {
                  return _this.handleCount(lawyer, type);
                }
              }),
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { basic: true, className: 'LawyerCaseAppointment' },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'left', width: canUpdateAppointment ? 12 : 16 },
                    _react2.default.createElement(
                      _semanticUiReact.Header,
                      null,
                      t('Appointments')
                    )
                  ),
                  canUpdateAppointment ? _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'right', width: 4 },
                    _react2.default.createElement(_semanticUiReact.Button, {
                      primary: true,
                      onClick: _this.handleShowLawyerAppointment,
                      icon: 'edit'
                    })
                  ) : null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16, textAlign: appointment ? 'left' : 'center' },
                    _this.renderAppointment(appointment)
                  )
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 16, tablet: 8, computer: 8 },
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { className: 'RemarksCard' },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'left', width: 16 },
                    _react2.default.createElement(
                      _semanticUiReact.Header,
                      null,
                      t('Remarks')
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'left', width: 16 },
                    _this.renderRemarksComponent(currentCase)
                  )
                )
              )
            )
          ) : null
        );
      }
      return _react2.default.createElement(_semanticUiReact.Button, {
        primary: true,
        onClick: function onClick(e) {
          return _this.handleShowAssignLawyer(e, type);
        },
        icon: 'add user',
        content: t('Assign lawyer'),
        disabled: _this.isLawyerAssignDisabled(type)
      });
    };

    _this.renderRemarksComponent = function (c) {
      var lawyersList = _this.state.lawyersList;

      var lawyerInfo = lawyersList.find(function (lawyer) {
        return lawyer.id === c.lawyer_id;
      });
      var q = {
        caseid: c.id,
        mailsubject: c.type + ' Case',
        senderorg: _this.props.auth.company.shortName,
        projname: c.property.project_name,
        unitno: c.property.unit_no
      };
      if (lawyerInfo) {
        q.recname = lawyerInfo.name;
        q.recmail = lawyerInfo.email;
        var query = Object.assign({}, q);
        var remarksURL = _config2.default.get('remarksURL') + '/?' + _qs2.default.stringify(query);
        return _react2.default.createElement(
          'div',
          { className: 'RemarksContainer' },
          _react2.default.createElement(_reactIframe2.default, { className: 'Remarks', url: remarksURL })
        );
      }
      return _react2.default.createElement(
        _semanticUiReact.Segment,
        { basic: true, padded: true },
        _react2.default.createElement(_semanticUiReact.Loader, { active: true, inline: 'centered' })
      );
    };

    _this.renderCasesByType = function (type) {
      var _this$state7 = _this.state,
          bookingLawyers = _this$state7.bookingLawyers,
          nextToken = _this$state7.nextToken,
          cases = _this$state7.cases,
          activeCase = _this$state7.activeCase,
          doneCount = _this$state7.doneCount,
          lawyersList = _this$state7.lawyersList,
          spaDocLink = _this$state7.spaDocLink,
          spaDocLinkCaseID = _this$state7.spaDocLinkCaseID;
      // Only a link fetched FOR the active SPA case is ever shown (see spaLinkForCase).

      var spaLinkToShow = (0, _spaDocLink.spaLinkForCase)(activeCase.SPA, spaDocLink, spaDocLinkCaseID);
      var _this$props6 = _this.props,
          isProjectHimsEnabled = _this$props6.isProjectHimsEnabled,
          t = _this$props6.t;

      var currentCase = activeCase[type];
      return _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { width: 16, className: 'section ' + type },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 3 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(_semanticUiReact.Grid.Column, { tablet: 4, computer: 3 }),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 16, tablet: 8, computer: 10 },
              _react2.default.createElement(
                _semanticUiReact.Header,
                null,
                t('{{caseType}} Tracker', { caseType: type, ns: _translation.TRANSLATION_FILES.screens })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 16, tablet: 4, computer: 3 },
              currentCase === activeCase.SPA && spaLinkToShow && _react2.default.createElement(_semanticUiReact.Button, {
                className: 'DownloadSPA',
                onClick: function onClick() {
                  return window.open(spaLinkToShow, '_blank');
                },
                content: t('Download SPA'),
                size: 'small'
              })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 2, stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _this.renderCurrentCase(type)
          ),
          cases[type].filter(function (d) {
            return d.status === _lawyerCaseStatuses.DEVELOPER_CANCELLED;
          }).map(function (item, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { key: item.id || idx },
              _react2.default.createElement(_LawyerDetail2.default, {
                cancelled: true,
                data: lawyersList.find(function (lawyer) {
                  return lawyer.id === item.lawyer_id;
                }),
                lawyerID: item.lawyer_id,
                canFetch: idx === 0 && !activeCase[type] || doneCount[type] === idx + 1,
                onDone: function onDone(lawyer) {
                  return _this.handleCount(lawyer, type);
                }
              })
            );
          }),
          nextToken[type] && cases[type].length > 0 ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16, textAlign: 'center' },
            _react2.default.createElement(_semanticUiReact.Button, {
              color: 'teal',
              onClick: function onClick() {
                return _this.handleLoadMore(type);
              },
              content: t('Load more')
            })
          ) : null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            isProjectHimsEnabled && type === _lawyerCaseStatuses.TYPE_CASE_SPA && _this.renderCurrentSecondarySpaLawyer(type)
          ),
          isProjectHimsEnabled && type === _lawyerCaseStatuses.TYPE_CASE_SPA && bookingLawyers && bookingLawyers.filter(function (d) {
            return d.status === _lawyerCaseStatuses.LAWYER_STATUS_CANCELLED;
          }).map(function (item, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { key: item.id || idx },
              _react2.default.createElement(_SecondaryLawyerDetail2.default, {
                cancelled: true,
                data: item,
                lawyerID: item.id
              })
            );
          })
        )
      );
    };

    _this.renderContent = function (list) {
      var loading = _this.state.loading;
      var t = _this.props.t;

      if (loading.SPA && loading.LA) {
        return _react2.default.createElement(
          _semanticUiReact.Loader,
          { inline: 'centered', active: true },
          t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
        );
      }
      if (list.length > 0) {
        return _react2.default.createElement(
          _semanticUiReact.Message,
          {
            warning: true
          },
          _react2.default.createElement(
            _semanticUiReact.Message.Header,
            null,
            t('To assign lawyer, you need to'),
            ':'
          ),
          _react2.default.createElement(
            _semanticUiReact.Message.List,
            null,
            list
          )
        );
      }
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { stackable: true, stretched: true },
        _this.renderCasesByType(_lawyerCaseStatuses.TYPE_CASE_SPA),
        _this.renderCasesByType(_lawyerCaseStatuses.TYPE_CASE_LA)
      );
    };

    _this.renderExtra = function (selected) {
      var _this$state8 = _this.state,
          assignType = _this$state8.assignType,
          activeCase = _this$state8.activeCase,
          cases = _this$state8.cases;
      var t = _this.props.t;

      if (selected) {
        var oppositeType = assignType === _lawyerCaseStatuses.TYPE_CASE_SPA ? _lawyerCaseStatuses.TYPE_CASE_LA : _lawyerCaseStatuses.TYPE_CASE_SPA;
        var isCancelled = cases && cases[oppositeType] && cases[oppositeType].some(function (s) {
          return s.lawyer_id === selected.lawyer_id;
        });
        if (activeCase && !activeCase[oppositeType] && !isCancelled) {
          return _react2.default.createElement(_semanticUiReact.Checkbox, {
            label: t('This lawyer is also my {{caseType}} Lawyer', { caseType: oppositeType, ns: _translation.TRANSLATION_FILES.screens }),
            onChange: _this.handleCheckChange
          });
        }
      }
      return null;
    };

    _this.state = {
      cases: {
        SPA: [],
        LA: []
      },
      nextToken: {
        SPA: null,
        LA: null
      },
      activeCase: {
        SPA: null,
        LA: null
      },
      loading: {
        SPA: null,
        LA: null
      },
      lawyersIDList: [],
      lawyersList: [],
      currentCase: null,
      assignType: 'SPA',
      bookingLawyers: [],
      activeSecondaryLawyer: {},
      showAssignLawyer: false,
      showAssignSecondaryLawyer: false,
      showModalConfirm: false,
      showLawyerAppointment: false,
      doneCount: {
        SPA: 0,
        LA: 0
      },
      companyDocuments: [],
      assignSameLawyer: false,
      spaDocLink: null,
      spaDocLinkCaseID: null
    };
    return _this;
  }

  _createClass(Cases, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchCompanyDocuments();
      if (this.props.bookingID) {
        this.fetchAllLawyerCasesDetails(this.props.bookingID);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var bookingID = nextProps.bookingID;

      if (bookingID !== this.props.bookingID) {
        this.fetchAllLawyerCasesDetails(bookingID);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.unmounted = true;
      this.abortSpaLink('unmount');
    }
  }, {
    key: 'abortSpaLink',

    // One request in flight; a call that arrives meanwhile is COALESCED into one more run after it
    // (not dropped -- the booking or the assignment may have changed underneath) and the request it
    // supersedes is ABORTED, so a stalled answer for the previous case never holds up the next one.
    // A response is applied only if the SPA case it was requested for is still the active one.
    value: function abortSpaLink(reason) {
      if (this.spaLinkAbort) {
        this.spaLinkAbortReason = reason;
        this.spaLinkAbort.abort();
      }
    }
  }, {
    key: 'fetchSPALink',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (!this.unmounted) {
                  _context8.next = 2;
                  break;
                }

                return _context8.abrupt('return');

              case 2:
                if (!this.spaLinkInFlight) {
                  _context8.next = 6;
                  break;
                }

                this.spaLinkQueued = true;
                this.abortSpaLink('superseded');
                return _context8.abrupt('return');

              case 6:
                this.spaLinkInFlight = true;
                _context8.prev = 7;

              case 8:
                this.spaLinkQueued = false;
                // eslint-disable-next-line no-await-in-loop
                _context8.next = 11;
                return this.requestSPALink();

              case 11:
                if (this.spaLinkQueued && !this.unmounted) {
                  _context8.next = 8;
                  break;
                }

              case 12:
                _context8.prev = 12;

                this.spaLinkInFlight = false;
                return _context8.finish(12);

              case 15:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[7,, 12, 15]]);
      }));

      function fetchSPALink() {
        return _ref10.apply(this, arguments);
      }

      return fetchSPALink;
    }()
  }, {
    key: 'requestSPALink',
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _this3 = this;

        var Aborter, controller, timer, activeCase, currentCase, requestedCaseID, body, res, link, latest, stillCurrent, aborted, reason;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                Aborter = typeof window !== 'undefined' ? window.AbortController : null;
                controller = Aborter ? new Aborter() : null;

                this.spaLinkAbort = controller;
                this.spaLinkAbortReason = null;
                timer = controller ? setTimeout(function () {
                  return _this3.abortSpaLink('timeout');
                }, SPA_LINK_TIMEOUT_MS) : null;
                _context9.prev = 5;

                // Everything, payload construction included, sits inside the guard: a case without a
                // purchaser is reported once, not thrown past the coalescing loop with queued work lost.
                activeCase = this.state.activeCase;
                currentCase = activeCase[_lawyerCaseStatuses.TYPE_CASE_SPA];
                requestedCaseID = currentCase ? currentCase.id : null;

                if (requestedCaseID !== this.spaLinkCaseID) {
                  // The link on screen belongs to another case (or to none): clear it on the transition,
                  // so case A's download link is never shown for case B when B has no link or fails.
                  this.spaLinkCaseID = requestedCaseID;
                  if (this.state.spaDocLink && !this.unmounted) {
                    this.setState({ spaDocLink: null, spaDocLinkCaseID: null });
                  }
                }

                if (currentCase) {
                  _context9.next = 12;
                  break;
                }

                return _context9.abrupt('return');

              case 12:
                body = {
                  project_mhub_id: currentCase.project_id,
                  project_name: currentCase.project_name,
                  unit_mhub_id: currentCase.project_unit_id,
                  unit_unit_no: currentCase.unit_no,
                  purchaser_mhub_id: currentCase.purchaser_id,
                  purchaser_nric: currentCase.purchaser.identity_no,
                  purchaser_name: currentCase.purchaser.name,
                  purchaser_mobile_no: currentCase.purchaser.mobile,
                  sales_mhub_id: currentCase.id,
                  sales_lawyer_id: currentCase.lawyer_id,
                  extra_data: currentCase.extra_data
                };
                _context9.next = 15;
                return fetch(_config2.default.get('clooneURL') + '/sales/create', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(body),
                  signal: controller ? controller.signal : undefined
                });

              case 15:
                res = _context9.sent;
                _context9.next = 18;
                return (0, _spaDocLink.readSpaDocLink)(res);

              case 18:
                link = _context9.sent;
                latest = this.state.activeCase[_lawyerCaseStatuses.TYPE_CASE_SPA];
                stillCurrent = latest && latest.id === requestedCaseID;

                if (link && stillCurrent && !this.unmounted) {
                  this.setState({ spaDocLink: link, spaDocLinkCaseID: requestedCaseID });
                }
                _context9.next = 31;
                break;

              case 24:
                _context9.prev = 24;
                _context9.t0 = _context9['catch'](5);

                // Only an ABORT is judged by the abort reason. Any other failure -- a case without a
                // purchaser, a bad answer -- is reported even if a supersede happened to land meanwhile.
                aborted = _context9.t0 && _context9.t0.name === 'AbortError';
                reason = aborted ? this.spaLinkAbortReason : null;

                if (!(reason === 'superseded' || reason === 'unmount')) {
                  _context9.next = 30;
                  break;
                }

                return _context9.abrupt('return');

              case 30:
                Bugsnag.notifyException(reason === 'timeout' ? new Error('Cloone sales/create timed out after ' + SPA_LINK_TIMEOUT_MS + 'ms') : _context9.t0);

              case 31:
                _context9.prev = 31;

                if (timer) clearTimeout(timer);
                if (this.spaLinkAbort === controller) this.spaLinkAbort = null;
                return _context9.finish(31);

              case 35:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[5, 24, 31, 35]]);
      }));

      function requestSPALink() {
        return _ref11.apply(this, arguments);
      }

      return requestSPALink;
    }()
  }, {
    key: 'fetchLawyer',
    value: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var lawyerID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var store, t, res;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                if (lawyerID) {
                  _context10.next = 2;
                  break;
                }

                return _context10.abrupt('return', null);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context10.prev = 5;
                _context10.next = 8;
                return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.LAWYER(lawyerID), null, 'get', {
                  'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
                }));

              case 8:
                res = _context10.sent;
                return _context10.abrupt('return', res);

              case 12:
                _context10.prev = 12;
                _context10.t0 = _context10['catch'](5);

                Bugsnag.notifyException(_context10.t0);
                _context10.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                return _context10.abrupt('return', null);

              case 18:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[5, 12]]);
      }));

      function fetchLawyer() {
        return _ref12.apply(this, arguments);
      }

      return fetchLawyer;
    }()
  }, {
    key: 'fetchCompanyDocuments',
    value: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(q) {
        var store, t, query, res, message, companyDocuments;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({
                  page: 1
                }, q);
                res = void 0;
                _context11.prev = 6;
                _context11.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/company_documents/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context11.sent;
                _context11.next = 20;
                break;

              case 12:
                _context11.prev = 12;
                _context11.t0 = _context11['catch'](6);

                Bugsnag.notifyException(_context11.t0);
                _context11.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context11.next = 19;
                return this.setLoading(false);

              case 19:
                return _context11.abrupt('return');

              case 20:
                if (res.ok) {
                  _context11.next = 28;
                  break;
                }

                _context11.next = 23;
                return res.text();

              case 23:
                message = _context11.sent;
                _context11.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context11.next = 33;
                break;

              case 28:
                _context11.next = 30;
                return res.json();

              case 30:
                companyDocuments = _context11.sent;
                _context11.next = 33;
                return this.setComponentState({
                  companyDocuments: companyDocuments
                });

              case 33:
                _context11.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this, [[6, 12]]);
      }));

      function fetchCompanyDocuments(_x22) {
        return _ref13.apply(this, arguments);
      }

      return fetchCompanyDocuments;
    }()
  }, {
    key: 'fetchSecondaryLawyers',
    value: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var store, t, activeCase, res, message, bookingLawyers, activeSecondaryLawyer;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                activeCase = this.state.activeCase;
                res = void 0;
                _context12.prev = 6;
                _context12.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.props.bookingID + '/lawyers/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context12.sent;
                _context12.next = 20;
                break;

              case 12:
                _context12.prev = 12;
                _context12.t0 = _context12['catch'](6);

                Bugsnag.notifyException(_context12.t0);
                _context12.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context12.next = 19;
                return this.setLoading(false);

              case 19:
                return _context12.abrupt('return');

              case 20:
                if (res.ok) {
                  _context12.next = 28;
                  break;
                }

                _context12.next = 23;
                return res.text();

              case 23:
                message = _context12.sent;
                _context12.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context12.next = 35;
                break;

              case 28:
                _context12.next = 30;
                return res.json();

              case 30:
                bookingLawyers = _context12.sent;
                activeSecondaryLawyer = bookingLawyers && bookingLawyers.find(function (bl) {
                  return bl.status === _lawyerCaseStatuses.LAWYER_STATUS_ACTIVE;
                });


                if (activeSecondaryLawyer && activeCase[_lawyerCaseStatuses.TYPE_CASE_SPA]) {
                  activeCase[_lawyerCaseStatuses.TYPE_CASE_SPA].extra_data = _extends({}, activeCase[_lawyerCaseStatuses.TYPE_CASE_SPA].extra_data, {
                    repType: this.getOppositeLawyerRepType(activeSecondaryLawyer.repType)
                  });
                }
                _context12.next = 35;
                return this.setComponentState({
                  bookingLawyers: bookingLawyers,
                  activeSecondaryLawyer: activeSecondaryLawyer,
                  activeCase: activeCase
                });

              case 35:
                _context12.next = 37;
                return this.setLoading(false);

              case 37:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this, [[6, 12]]);
      }));

      function fetchSecondaryLawyers() {
        return _ref14.apply(this, arguments);
      }

      return fetchSecondaryLawyers;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          t = _props.t,
          isProjectHimsEnabled = _props.isProjectHimsEnabled;
      var _state = this.state,
          loading = _state.loading,
          selectedStatus = _state.selectedStatus,
          activeCase = _state.activeCase,
          currentCase = _state.currentCase,
          assignType = _state.assignType;

      var messageList = this.getMessageList();

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { stackable: true, stretched: true, className: 'LawyerCases' },
        _react2.default.createElement(_PanelLawyersList2.default, {
          company: this.props.auth.company,
          open: this.state.showAssignLawyer,
          onClose: this.handleCloseAssignLawyer,
          onConfirm: this.handleAssignLawyer,
          selected: this.state.cases[assignType],
          loanTrackerProjectID: this.props.loanTrackerProjectID,
          projectName: data ? data.name : '',
          loading: loading.SPA || loading.LA,
          setLoading: this.setLoading,
          extraNode: this.renderExtra
        }),
        _react2.default.createElement(_AssignSecondaryLawyer2.default, {
          onClose: this.handleCloseAssignSecondaryLawyer,
          onCreate: this.handleCreateSecondaryLawyer,
          onUpdate: this.handleUpdateSecondaryLawyer,
          open: this.state.showAssignSecondaryLawyer,
          repType: this.getOppositeLawyerRepType(data.project.himsDefaultSpaLawyerRepID),
          data: this.state.editingSecondaryLawyer
        }),
        _react2.default.createElement(_LawyerAppointment2.default, {
          appointment: activeCase.SPA ? activeCase.SPA.appointment : null,
          open: this.state.showLawyerAppointment,
          onClose: this.handleCloseLawyerAppointment,
          onConfirm: this.handleUpdateLawyerAppointment,
          loading: loading.SPA
        }),
        _react2.default.createElement(_CaseAssignmentModal2.default, {
          data: currentCase,
          loading: currentCase && currentCase.type ? loading[currentCase.type] : false,
          onClose: this.handleCloseModalConfirm,
          onUpdate: this.handleUpdateLawyerCase,
          open: this.state.showModalConfirm,
          selectedStatus: selectedStatus,
          isProjectHimsEnabled: isProjectHimsEnabled
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 16 },
          _react2.default.createElement(
            _semanticUiReact.Header,
            { className: 'new_title', as: 'h5', attached: 'top' },
            t('Lawyer').toUpperCase()
          ),
          _react2.default.createElement(
            _semanticUiReact.Segment,
            { attached: true, secondary: messageList.length > 0 },
            this.renderContent(messageList)
          )
        )
      );
    }
  }]);

  return Cases;
}(_react.Component);

Cases.contextTypes = {
  store: _propTypes2.default.object
};
Cases.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      companyID: _propTypes2.default.int
    })
  }),
  token: _propTypes2.default.string,
  data: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    statusID: _propTypes2.default.string,
    project: _propTypes2.default.shape({
      himsDefaultSpaLawyerRepID: _propTypes2.default.string
    })
  }).isRequired,
  primaryPurchaser: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }).isRequired,
  purchasers: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  successBankCase: _propTypes2.default.shape({
    bank: _propTypes2.default.shape({
      name: _propTypes2.default.string
    })
  }),
  disabled: _propTypes2.default.bool,
  isProjectHimsEnabled: _propTypes2.default.bool,
  bookingID: _propTypes2.default.string,
  loanTrackerProjectID: _propTypes2.default.number,
  setLoading: _propTypes2.default.func.isRequired,
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isBranchLeader: _propTypes2.default.bool,
    company: _propTypes2.default.object,
    isExternalAgent: _propTypes2.default.bool
  }),
  t: _propTypes2.default.func
};

Cases.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

Cases.defaultProps = {
  successBankCase: null,
  disabled: false
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Cases.mapStateToProps)(Cases));

/***/ }),
/* 2338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _apiEndpoints = __webpack_require__(140);

var endpoints = _interopRequireWildcard(_apiEndpoints);

var _Phone = __webpack_require__(126);

var _Phone2 = _interopRequireDefault(_Phone);

var _ic_preferred_green = __webpack_require__(504);

var _ic_preferred_green2 = _interopRequireDefault(_ic_preferred_green);

var _translation = __webpack_require__(4);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LawyerDetails = function (_Component) {
  _inherits(LawyerDetails, _Component);

  function LawyerDetails(props) {
    _classCallCheck(this, LawyerDetails);

    var _this = _possibleConstructorReturn(this, (LawyerDetails.__proto__ || Object.getPrototypeOf(LawyerDetails)).call(this, props));

    _this.state = {
      loading: true
    };
    return _this;
  }

  _createClass(LawyerDetails, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // if (this.props.canFetch && this.props.lawyerID) {
      //   this.fetchLawyer();
      // }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {}
    // const { canFetch, lawyerID, lawyer } = nextProps;
    // console.log('lawyer', lawyer);
    // if (
    //   (canFetch && canFetch !== this.props.canFetch) ||
    //   lawyerID !== this.props.lawyerID
    // ) {
    //   this.fetchLawyer(lawyerID);
    // }

    // setLoading = (loading = false) => new Promise(res => this.setState({ loading }, () => res(loading)))
    // setLawyer = data => new Promise(res => this.setState({ data }, () => res(data)))
    // fetchLawyer = async (lawyerID = this.props.lawyerID) => {
    //   await this.setLoading(true);
    //   const { store } = this.context;
    //   let res;
    //   try {
    //     res = await store.dispatch(fetchAPI('lawyerAPI', endpoints.LAWYER(lawyerID), null, 'get', {
    //       'X-Api-Token': process.env.LAWYER_API_TOKEN,
    //     }));
    //   } catch (e) {
    //     Bugsnag.notifyException(e);
    //     await store.dispatch(flashErrorMessage({ message: 'An error occurred, please refresh page' }));
    //     await this.setLoading(false);
    //     return;
    //   }

    //   if (res) {
    //     await this.setLawyer(res);
    //   }

    //   await this.setLoading(false);

    //   const { onDone } = this.props;
    //   if (onDone) {
    //     onDone(res);
    //   }
    // }

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          cancelled = _props.cancelled,
          verified = _props.verified,
          basic = _props.basic,
          data = _props.data,
          t = _props.t;

      return _react2.default.createElement(
        _semanticUiReact.Segment,
        { className: 'LawyerDetails', tertiary: cancelled, basic: basic },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'left', width: 16 },
            _react2.default.createElement(
              _semanticUiReact.Header,
              { color: cancelled ? 'red' : null },
              t((cancelled ? 'Cancelled' : 'Assigned') + ' Lawyer')
            )
          )
        ),
        data ? _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'left', width: 6 },
            t('Name')
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right', width: 10 },
            _react2.default.createElement(
              'div',
              { style: { display: 'inline-flex', alignItems: 'center' } },
              data.name,
              verified || data.verified ? _react2.default.createElement(_semanticUiReact.Image, { src: _ic_preferred_green2.default, height: '15', style: { marginLeft: '0.5em' } }) : null
            )
          )
        ) : _react2.default.createElement(
          _semanticUiReact.Segment,
          { basic: true, padded: true },
          _react2.default.createElement(_semanticUiReact.Loader, { active: true, inline: 'centered' })
        ),
        data ? _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'left', width: 6 },
            t('Law Firm')
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right', width: 10 },
            data.firm
          )
        ) : null,
        data ? _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'left', width: 6 },
            t('Email')
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right', width: 10 },
            data.email
          )
        ) : null,
        data ? _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'left', width: 6 },
            t('Contact No')
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right', width: 10 },
            _react2.default.createElement(_Phone2.default, {
              mobilePrefix: data.mobile_prefix,
              mobile: data.mobile
            })
          )
        ) : null
      );
    }
  }]);

  return LawyerDetails;
}(_react.Component);

LawyerDetails.contextTypes = {
  store: _propTypes2.default.object
};
LawyerDetails.propTypes = {
  basic: _propTypes2.default.bool,
  cancelled: _propTypes2.default.bool,
  lawyerID: _propTypes2.default.string,
  verified: _propTypes2.default.bool,
  canFetch: _propTypes2.default.bool,
  onDone: _propTypes2.default.func,
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  t: _propTypes2.default.func
};
LawyerDetails.defaultProps = {
  basic: false,
  cancelled: false,
  canFetch: false
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(LawyerDetails);

/***/ }),
/* 2339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _Phone = __webpack_require__(126);

var _Phone2 = _interopRequireDefault(_Phone);

var _translation = __webpack_require__(4);

var _lawyerCaseStatuses = __webpack_require__(142);

var _ModalConfirm = __webpack_require__(399);

var _ModalConfirm2 = _interopRequireDefault(_ModalConfirm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SecondaryLawyerDetail = function (_Component) {
  _inherits(SecondaryLawyerDetail, _Component);

  function SecondaryLawyerDetail(props) {
    _classCallCheck(this, SecondaryLawyerDetail);

    var _this = _possibleConstructorReturn(this, (SecondaryLawyerDetail.__proto__ || Object.getPrototypeOf(SecondaryLawyerDetail)).call(this, props));

    _this.handleOnEdit = function (e) {
      e.preventDefault();
      if (_this.props.onEdit) {
        _this.props.onEdit();
      }
    };

    _this.handleOnDelete = function (e) {
      e.preventDefault();
      if (_this.props.onDelete) {
        _this.props.onDelete();
      }
    };

    _this.handleShowModalConfirmDelete = function (e) {
      if (e) {
        e.preventDefault();
      }
      _this.setState({
        showModalConfirmDelete: true
      });
    };

    _this.handleCloseModalConfirmDelete = function (e) {
      if (e) {
        e.preventDefault();
      }
      _this.setState({
        showModalConfirmDelete: false
      });
    };

    _this.renderCurrent = function () {
      var _this$props = _this.props,
          data = _this$props.data,
          t = _this$props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { stackable: true },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { mobile: 16, tablet: 8, computer: 8 },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 6 },
              t('Name')
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 10 },
              _react2.default.createElement(
                'div',
                { style: { display: 'inline-flex', alignItems: 'center' } },
                data.name
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 6 },
              t('Law Firm')
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 10 },
              data.lawFirmName
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 6 },
              t('Contact No')
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 10 },
              _react2.default.createElement(_Phone2.default, {
                mobilePrefix: data.mobilePrefix,
                mobile: data.mobile
              })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { mobile: 16, tablet: 8, computer: 8 },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 6 },
              t('Address 1')
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 10 },
              _react2.default.createElement(
                'div',
                { style: { display: 'inline-flex', alignItems: 'center' } },
                data.address1
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 6 },
              t('Address 2')
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 10 },
              data.address2 || '-'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 6 },
              t('Address 3')
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 10 },
              data.address3 || '-'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 6 },
              t('Postcode')
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 10 },
              data.postcode
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 6 },
              t('City')
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 10 },
              data.city
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 6 },
              t('State')
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 10 },
              data.state
            )
          )
        )
      );
    };

    _this.renderCancelled = function () {
      var _this$props2 = _this.props,
          data = _this$props2.data,
          t = _this$props2.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 16 },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 6 },
              t('Name')
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 10 },
              _react2.default.createElement(
                'div',
                { style: { display: 'inline-flex', alignItems: 'center' } },
                data.name
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 6 },
              t('Law Firm')
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 10 },
              data.lawFirmName
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 6 },
              t('Contact No')
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'right', width: 10 },
              _react2.default.createElement(_Phone2.default, {
                mobilePrefix: data.mobilePrefix,
                mobile: data.mobile
              })
            )
          )
        )
      );
    };

    _this.state = {
      loading: true,
      showModalConfirmDelete: false
    };
    return _this;
  }

  _createClass(SecondaryLawyerDetail, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          cancelled = _props.cancelled,
          data = _props.data,
          t = _props.t;

      return _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { style: { textAlign: 'left' } },
        _react2.default.createElement(_ModalConfirm2.default, {
          open: this.state.showModalConfirmDelete,
          onClose: this.handleCloseModalConfirmDelete,
          onConfirm: this.handleOnDelete,
          headerNode: t('Delete lawyer') + '?',
          content: t('Are you sure you want to delete this lawyer? This action will not be reversible') + '.'
        }),
        !cancelled && _react2.default.createElement(_semanticUiReact.Divider, null),
        !cancelled && _react2.default.createElement(
          _semanticUiReact.Header,
          null,
          t('Additional SPA Lawyer')
        ),
        !cancelled && _react2.default.createElement(
          'p',
          null,
          'Only for HIMS e-SPA purpose'
        ),
        data.id ? _react2.default.createElement(
          _semanticUiReact.Segment,
          { className: 'SecondLawyerDetails', tertiary: cancelled },
          !cancelled && _react2.default.createElement(
            _semanticUiReact.Grid,
            { style: { marginBottom: '10px' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { verticalAlign: 'middle', style: { paddingBottom: 0 } },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', width: 6 },
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  null,
                  'Details'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'right', width: 10 },
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    basic: true,
                    className: 'delete-spa-button',
                    onClick: this.handleShowModalConfirmDelete,
                    size: 'small'
                  },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'delete' }),
                  'Delete'
                ),
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  {
                    basic: true,
                    className: 'edit-spa-button',
                    onClick: this.handleOnEdit,
                    size: 'small'
                  },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'pencil' }),
                  'Edit'
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { verticalAlign: 'middle' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 8 },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { verticalAlign: 'middle' },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 6, textAlign: 'left' },
                      t('Lawyer represents (e-SPA)')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 10, textAlign: 'right' },
                      _react2.default.createElement(
                        'div',
                        { style: { display: 'inline-flex', alignItems: 'center' } },
                        _lawyerCaseStatuses.SPA_LAWYER_REP_OPTIONS.find(function (opt) {
                          return opt.value === data.repType;
                        }).text
                      )
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left', width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Header,
                { color: cancelled ? 'red' : null },
                t((cancelled ? 'Cancelled' : 'Assigned') + ' Lawyer')
              )
            )
          ),
          cancelled ? this.renderCancelled() : this.renderCurrent()
        ) : _react2.default.createElement(
          _semanticUiReact.Segment,
          { basic: true, padded: true },
          _react2.default.createElement(_semanticUiReact.Loader, { active: true, inline: 'centered' })
        )
      );
    }
  }]);

  return SecondaryLawyerDetail;
}(_react.Component);

SecondaryLawyerDetail.contextTypes = {
  store: _propTypes2.default.object
};
SecondaryLawyerDetail.propTypes = {
  cancelled: _propTypes2.default.bool,
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  t: _propTypes2.default.func,
  onEdit: _propTypes2.default.func,
  onDelete: _propTypes2.default.func
};
SecondaryLawyerDetail.defaultProps = {
  basic: false,
  cancelled: false
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(SecondaryLawyerDetail);

/***/ }),
/* 2340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _translation = __webpack_require__(4);

var _lawyerCaseStatuses = __webpack_require__(142);

var _InputBirthdate = __webpack_require__(220);

var _InputBirthdate2 = _interopRequireDefault(_InputBirthdate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var SpaCaseDetail = function (_Component) {
  _inherits(SpaCaseDetail, _Component);

  function SpaCaseDetail(props) {
    _classCallCheck(this, SpaCaseDetail);

    var _this = _possibleConstructorReturn(this, (SpaCaseDetail.__proto__ || Object.getPrototypeOf(SpaCaseDetail)).call(this, props));

    _this.setCaseData = function (d) {
      if (d) {
        var newCaseData = {
          previous_spa_date: d.spa_date ? (0, _momentTimezone2.default)(d.spa_date) : null,
          spa_date: d.spa_date ? (0, _momentTimezone2.default)(d.spa_date) : null,
          spa_stamped_date: d.spa_stamped_date ? (0, _momentTimezone2.default)(d.spa_stamped_date) : null,
          spa_solicitor_ref_no: d.spa_solicitor_ref_no,
          repType: d.repType
        };
        _this.setState({ caseData: newCaseData });
      }
    };

    _this.handleOnDateChange = function (day, fieldname) {
      var newCaseData = _extends({}, _this.state.caseData);
      if (newCaseData) {
        newCaseData[fieldname] = day;
      } else {
        newCaseData = _defineProperty({}, fieldname, day);
      }
      _this.setState({ caseData: newCaseData });
    };

    _this.handleOnInputChange = function (e, _ref) {
      var name = _ref.name,
          value = _ref.value;

      var newCaseData = _extends({}, _this.state.caseData);
      if (newCaseData) {
        newCaseData[name] = value;
      } else {
        newCaseData = _defineProperty({}, name, value);
      }
      _this.setState({ caseData: newCaseData });
    };

    _this.state = {
      caseData: null,
      openModal: false
    };
    return _this;
  }

  _createClass(SpaCaseDetail, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.data) {
        this.setCaseData(this.props.data);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
        this.setCaseData(nextProps.data);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          basic = _props.basic,
          data = _props.data,
          onUpdate = _props.onUpdate,
          loading = _props.loading,
          hasActiveSecondaryLawyer = _props.hasActiveSecondaryLawyer,
          isProjectHimsEnabled = _props.isProjectHimsEnabled,
          t = _props.t;
      var _state = this.state,
          caseData = _state.caseData,
          openModal = _state.openModal;

      var now = (0, _momentTimezone2.default)().toDate();
      var toMonth = new Date(now.getFullYear() + 1, now.getMonth(), now.getDate());
      var fromMonth = new Date(2015, 0, 1);
      return _react2.default.createElement(
        _semanticUiReact.Segment,
        { className: 'LawyerDetails', basic: basic },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'left', width: 6 },
            _react2.default.createElement(
              _semanticUiReact.Header,
              null,
              'Details'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right', width: 10 },
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                basic: true,
                className: 'edit-spa-button',
                onClick: function onClick() {
                  return _this2.setState({ openModal: true });
                },
                size: 'small'
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'pencil' }),
              'Edit'
            )
          )
        ),
        !loading ? _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'left', width: 6 },
            'SPA Date'
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right', width: 10 },
            data && data.spa_date ? (0, _momentTimezone2.default)(data.spa_date).format('DD-MM-YYYY') : '-'
          )
        ) : _react2.default.createElement(
          _semanticUiReact.Segment,
          { basic: true, padded: true },
          _react2.default.createElement(_semanticUiReact.Loader, { active: true, inline: 'centered' })
        ),
        !loading ? _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'left', width: 6 },
            'SPA Stamped Date'
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right', width: 10 },
            data && data.spa_stamped_date ? (0, _momentTimezone2.default)(data.spa_stamped_date).format('DD-MM-YYYY') : '-'
          )
        ) : null,
        !loading ? _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'left', width: 6 },
            'SPA Solicitor Reference No.'
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { className: data && data.spa_solicitor_ref_no && data.spa_solicitor_ref_no.length > 30 && 'lawyer-wrap-text', textAlign: 'right', width: 10 },
            data && data.spa_solicitor_ref_no ? data.spa_solicitor_ref_no : '-'
          )
        ) : null,
        !loading && isProjectHimsEnabled ? _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'left', width: 6 },
            t('Representation type')
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'right', width: 10 },
            (data && data.repType ? _lawyerCaseStatuses.SPA_LAWYER_REP_OPTIONS.find(function (opt) {
              return opt.value === data.repType;
            }).text : '-') || '-'
          )
        ) : null,
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            open: openModal,
            onClose: function onClose() {
              return _this2.setState({ openModal: false });
            },
            size: 'mini'
          },
          _react2.default.createElement(_semanticUiReact.Header, { icon: 'file text outline', content: 'Edit Details' }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Modal.Description,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'lawyer-title-pb-row' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    'SPA Date*'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'lawyer-input-pt-row' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_InputBirthdate2.default, {
                      date: caseData && caseData.spa_date ? caseData.spa_date.format('YYYY-MM-DD') : '',
                      disabled: loading,
                      disabledDays: { before: fromMonth, after: toMonth },
                      format: null,
                      fromMonth: fromMonth,
                      monthLogic: null,
                      onSelectDay: function onSelectDay(d) {
                        return _this2.handleOnDateChange(d, 'spa_date');
                      },
                      showMonth: caseData && caseData.spa_date ? null : now,
                      toMonth: toMonth
                    })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'lawyer-title-pt-row lawyer-title-pb-row' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    'SPA Stamped Date'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'lawyer-input-pt-row' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_InputBirthdate2.default, {
                      date: caseData && caseData.spa_stamped_date ? caseData.spa_stamped_date.format('YYYY-MM-DD') : '',
                      disabled: loading,
                      disabledDays: { before: fromMonth, after: toMonth },
                      format: null,
                      fromMonth: fromMonth,
                      monthLogic: null,
                      onSelectDay: function onSelectDay(d) {
                        return _this2.handleOnDateChange(d, 'spa_stamped_date');
                      },
                      showMonth: caseData && caseData.spa_stamped_date ? null : now,
                      toMonth: toMonth
                    })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'lawyer-title-pt-row' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Form,
                      { className: 'lawyer-confirmation-form-input' },
                      _react2.default.createElement(_semanticUiReact.Form.Input, {
                        fluid: true,
                        name: 'spa_solicitor_ref_no',
                        label: 'SPA Solicitor Reference No',
                        value: caseData ? caseData.spa_solicitor_ref_no : '',
                        onChange: this.handleOnInputChange
                      })
                    )
                  )
                ),
                isProjectHimsEnabled && _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'lawyer-title-pt-row' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Form,
                      { className: 'lawyer-confirmation-form-input' },
                      _react2.default.createElement(_semanticUiReact.Form.Select, {
                        label: 'Lawyer represents (in e-SPA)*',
                        name: 'repType',
                        validateLabel: 'Lawyer represents (in e-SPA)',
                        options: _lawyerCaseStatuses.SPA_LAWYER_REP_OPTIONS,
                        value: caseData ? caseData.repType : '',
                        onChange: this.handleOnInputChange,
                        disabled: !hasActiveSecondaryLawyer
                      })
                    )
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(_semanticUiReact.Button, { negative: true, onClick: function onClick() {
                return _this2.setState({ openModal: false });
              }, icon: 'cancel', content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }) }),
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              onClick: function onClick(e) {
                _this2.setState({ openModal: false });
                onUpdate(e, caseData);
              },
              icon: 'checkmark',
              content: t('Save', { ns: _translation.TRANSLATION_FILES.translation })
            })
          )
        )
      );
    }
  }]);

  return SpaCaseDetail;
}(_react.Component);

SpaCaseDetail.contextTypes = {
  store: _propTypes2.default.object
};
SpaCaseDetail.propTypes = {
  basic: _propTypes2.default.bool,
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  loading: _propTypes2.default.bool,
  onUpdate: _propTypes2.default.func,
  isProjectHimsEnabled: _propTypes2.default.bool,
  hasActiveSecondaryLawyer: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
SpaCaseDetail.defaultProps = {
  basic: false,
  canFetch: false
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(SpaCaseDetail);

/***/ }),
/* 2341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @param {Response|undefined} res  the fetch Response, or undefined when the fetch itself threw
 * @returns {Promise<string|null>}  the SPA doc link, or null when there is none to show
 * @throws {SpaDocLinkError}        on a non-2xx answer or an unparseable body -- so the caller
 *                                  can notify Bugsnag once instead of leaking a rejection
 */
var readSpaDocLink = exports.readSpaDocLink = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
    var text, data;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (res) {
              _context.next = 2;
              break;
            }

            return _context.abrupt('return', null);

          case 2:
            text = '';
            _context.prev = 3;
            _context.next = 6;
            return res.text();

          case 6:
            text = _context.sent;
            _context.next = 14;
            break;

          case 9:
            _context.prev = 9;
            _context.t0 = _context['catch'](3);

            if (!(_context.t0 && _context.t0.name === 'AbortError')) {
              _context.next = 13;
              break;
            }

            throw _context.t0;

          case 13:
            throw new SpaDocLinkError(res.status, 'body read failed: ' + (_context.t0 && _context.t0.message || _context.t0));

          case 14:
            if (res.ok) {
              _context.next = 16;
              break;
            }

            throw new SpaDocLinkError(res.status, text);

          case 16:
            if (text) {
              _context.next = 18;
              break;
            }

            return _context.abrupt('return', null);

          case 18:
            data = void 0;
            _context.prev = 19;

            data = JSON.parse(text);
            _context.next = 26;
            break;

          case 23:
            _context.prev = 23;
            _context.t1 = _context['catch'](19);
            throw new SpaDocLinkError(res.status, text);

          case 26:
            return _context.abrupt('return', data && typeof data.spa_doc_link === 'string' && data.spa_doc_link || null);

          case 27:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[3, 9], [19, 23]]);
  }));

  return function readSpaDocLink(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * The link to SHOW for the active SPA case: only a link fetched for that very case. State can
 * hold case A's link for a moment after the case list has already switched to B (the list is
 * published before the link request for B goes out), so the render gates on ownership rather
 * than trusting whatever link is in state.
 */


function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// The SPA document link comes back from Cloone's `POST /sales/create`, which book-web calls from
// the browser on every load of the Lawyer tab (Cases.jsx fetchSPALink). Cloone answers that call
// with a 500 and an EMPTY body when it does not like the case -- the 2026-09-17 QA pass on
// book-dev hit it six times across three page loads -- and `res.json()` on an empty body throws
// OUTSIDE the try/catch that guards the fetch, so every one of those became an uncaught promise
// rejection in the page and no Bugsnag report. Reading the response is now one guarded step.

var SpaDocLinkError = exports.SpaDocLinkError = function (_Error) {
  _inherits(SpaDocLinkError, _Error);

  function SpaDocLinkError(status, body) {
    _classCallCheck(this, SpaDocLinkError);

    var _this = _possibleConstructorReturn(this, (SpaDocLinkError.__proto__ || Object.getPrototypeOf(SpaDocLinkError)).call(this, 'Cloone sales/create answered ' + status + (body ? ': ' + body.slice(0, 120) : '')));

    _this.name = 'SpaDocLinkError';
    _this.status = status;
    return _this;
  }

  return SpaDocLinkError;
}(Error);

var spaLinkForCase = exports.spaLinkForCase = function spaLinkForCase(spaCase, link, ownerCaseID) {
  return spaCase && link && ownerCaseID === spaCase.id ? link : null;
};

/***/ }),
/* 2342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _fetchM = __webpack_require__(6);

var _Countdown = __webpack_require__(1012);

var _Countdown2 = _interopRequireDefault(_Countdown);

var _Phone = __webpack_require__(126);

var _Phone2 = _interopRequireDefault(_Phone);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConsentPin = function (_Component) {
  _inherits(ConsentPin, _Component);

  function ConsentPin(props) {
    _classCallCheck(this, ConsentPin);

    var _this = _possibleConstructorReturn(this, (ConsentPin.__proto__ || Object.getPrototypeOf(ConsentPin)).call(this, props));

    _this.setLoading = function () {
      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.setLoading) {
        return _this.props.setLoading(loading);
      }
      return Promise.resolve();
    };

    _this.startTimer = function (timeAt) {
      var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var time = 30 * count;
      var update = (0, _momentTimezone2.default)(timeAt);
      var seconds = (0, _momentTimezone2.default)().diff(update, 'seconds');
      if (seconds <= time) {
        time -= seconds;
      } else {
        time = 0;
      }
      _this.countdown.startTimer(time);
    };

    _this.countdownMessage = function (time) {
      var data = _this.state.data || {};
      var t = _this.props.t;

      if (data.pinExpiresAt && (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(data.pinExpiresAt))) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            { className: 'message' },
            t('PIN expired'),
            '.\xA0',
            _react2.default.createElement(
              'a',
              {
                href: '',
                onClick: _this.handleCreateDrop
              },
              t('Request new PIN now'),
              '.'
            )
          )
        );
      } else if (time >= 0) {
        var message = 'in {{time}} seconds';
        if (time === 1) {
          message = 'in {{time}} second';
        }
        if (time < 1) {
          message = 'now';
        }
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            { className: 'message', style: { textAlign: 'center', margin: '0.5em' } },
            t('Trouble receiving PIN?'),
            ' ',
            time < 1 ? _react2.default.createElement(
              'a',
              {
                href: '',
                onClick: _this.handleCreateDrop
              },
              t('Request new PIN now')
            ) : t('Request new PIN ' + message, { time: time }),
            '.'
          )
        );
      }
      return null;
    };

    _this.handleCreateDrop = function (event) {
      event.preventDefault();
      _this.fetchNewPin();
    };

    _this.handleSetPinRequestable = function (pr) {
      _this.setState({ pinRequestable: pr }, function () {
        _this.props.onPinRequestableChange(pr);
      });
    };

    _this.handleSubmit = function (event) {
      event.preventDefault();
      var data = {
        consentPin: _this.state.consentPin,
        agreedToTerms: _this.state.agreedToTerms
      };
      _this.fetchNewPin(data);
    };

    _this.state = {
      mobilePrefix: 'XXX',
      mobile: 'XXXXXXX',
      pinRequestable: true,
      token: null,
      data: null,
      message: null,
      consentPin: '',
      agreedToTerms: false
    };
    return _this;
  }

  _createClass(ConsentPin, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getDropLead();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.countdown.stopTimer();
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'getDropLead',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _state, data, pinRequestable;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                _context.next = 4;
                return this.fetchDropLead();

              case 4:
                _state = this.state, data = _state.data, pinRequestable = _state.pinRequestable;

                if (data.developerProject && data.developerProject.consentTypeID === 2 && data.updatedAt && pinRequestable) {
                  this.startTimer(data.updatedAt, data.consentPinCount);
                }
                _context.next = 8;
                return this.setLoading(false);

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getDropLead() {
        return _ref.apply(this, arguments);
      }

      return getDropLead;
    }()
  }, {
    key: 'fetchDropLead',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, t, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context2.prev = 3;
                _context2.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.props.bookingID + '/loan_trackers/draft/', {
                  credentials: 'include'
                }));

              case 6:
                res = _context2.sent;
                _context2.next = 15;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](3);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 14;
                return this.setComponentState({
                  message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation })
                });

              case 14:
                return _context2.abrupt('return', false);

              case 15:
                if (res.ok) {
                  _context2.next = 22;
                  break;
                }

                _context2.next = 18;
                return res.text();

              case 18:
                message = _context2.sent;
                _context2.next = 21;
                return this.setComponentState({
                  message: message
                });

              case 21:
                return _context2.abrupt('return', false);

              case 22:
                token = res.headers.get('X-Csrf-Token');
                _context2.next = 25;
                return res.json();

              case 25:
                data = _context2.sent;
                _context2.next = 28;
                return this.setComponentState({
                  token: token,
                  data: data,
                  message: null
                });

              case 28:
                return _context2.abrupt('return', true);

              case 29:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 9]]);
      }));

      function fetchDropLead() {
        return _ref2.apply(this, arguments);
      }

      return fetchDropLead;
    }()
  }, {
    key: 'fetchNewPin',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var dataResp;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                _context3.next = 4;
                return this.props.getStarted(data);

              case 4:
                dataResp = _context3.sent;

                if (!(dataResp && dataResp.id > 0)) {
                  _context3.next = 7;
                  break;
                }

                return _context3.abrupt('return');

              case 7:
                _context3.next = 9;
                return this.getDropLead();

              case 9:
                _context3.next = 11;
                return this.setLoading(false);

              case 11:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetchNewPin() {
        return _ref3.apply(this, arguments);
      }

      return fetchNewPin;
    }()
  }, {
    key: 'submitable',
    value: function submitable(type) {
      switch (type) {
        case 'drop':
          return !this.state.pinRequestable;
        case 'create':
          return this.state.agreedToTerms && this.state.consentPin;
        default:
          return false;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          mobile = _props.mobile,
          mobilePrefix = _props.mobilePrefix,
          t = _props.t;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'center aligned sixteen wide column' },
            this.props.isError ? _react2.default.createElement(_semanticUiReact.Message, {
              error: true,
              onDismiss: function onDismiss() {
                _this3.props.onErrDismiss();
              },
              content: this.props.errMessage
            }) : null
          )
        ),
        _react2.default.createElement(
          'form',
          { className: 'ui form', onSubmit: this.handleSubmit },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { className: 'consent-pin-message' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Label,
                  null,
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'check circle', color: 'green' }),
                  t('Consent PIN has been sent to your buyer\'s mobile number'),
                  '\xA0',
                  _react2.default.createElement(_Phone2.default, {
                    mobilePrefix: mobilePrefix || 'XXX',
                    mobile: mobile || 'XXXXXXX'
                  }),
                  '. ',
                  t('Please enter the PIN they shared to you'),
                  '.'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'ui fluid input' },
            _react2.default.createElement('input', {
              style: {
                maxWidth: '20em',
                margin: 'auto'
              },
              type: 'tel',
              name: 'consentPin',
              placeholder: t('6 digit PIN'),
              onChange: function onChange(e) {
                _this3.setState({ consentPin: e.target.value });
              },
              ref: function ref(_ref4) {
                _this3.consentPin = _ref4;
              }
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'ui checkbox' },
            _react2.default.createElement('input', {
              type: 'checkbox',
              name: 'agreedToTerms',
              id: 'agreedToTerms',
              onChange: function onChange(e) {
                _this3.setState({ agreedToTerms: e.target.checked });
              },
              ref: function ref(_ref5) {
                _this3.agreedToTerms = _ref5;
              },
              checked: this.state.agreedToTerms
            }),
            _react2.default.createElement(
              'div',
              { className: 'helper' },
              _react2.default.createElement(_Countdown2.default, {
                ref: function ref(_ref6) {
                  _this3.countdown = _ref6;
                },
                message: this.countdownMessage,
                onStart: function onStart() {
                  return _this3.handleSetPinRequestable(false);
                },
                onComplete: function onComplete() {
                  return _this3.handleSetPinRequestable(true);
                }
              })
            ),
            _react2.default.createElement(
              'label',
              { className: 'terms', htmlFor: 'agreedToTerms' },
              _react2.default.createElement(
                _reactI18next.Trans,
                { ns: _translation.TRANSLATION_FILES.screens },
                'I agree to the terms and conditions set out in the\xA0',
                _react2.default.createElement(
                  'a',
                  {
                    href: 'https://mhub.my/policies/trial_service_agreement/',
                    target: '_blank',
                    rel: 'noopener noreferrer'
                  },
                  'Agreement for Affiliates'
                ),
                '\xA0for Loan Referrals'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'consent-actions' },
            _react2.default.createElement(_semanticUiReact.Button, {
              className: 'cancel',
              content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }),
              onClick: function onClick() {
                return _this3.props.onClose();
              }
            }),
            _react2.default.createElement(_semanticUiReact.Button, {
              className: 'done',
              content: t('Done'),
              color: 'blue',
              disabled: !this.submitable('create')
            })
          )
        )
      );
    }
  }]);

  return ConsentPin;
}(_react.Component);

ConsentPin.contextTypes = {
  store: _propTypes2.default.object
};
ConsentPin.propTypes = {
  errMessage: _propTypes2.default.string,
  getStarted: _propTypes2.default.func.isRequired,
  isError: _propTypes2.default.bool,
  mobile: _propTypes2.default.string,
  mobilePrefix: _propTypes2.default.string,
  onClose: _propTypes2.default.func,
  onErrDismiss: _propTypes2.default.func.isRequired,
  onPinRequestableChange: _propTypes2.default.func,
  setLoading: _propTypes2.default.func.isRequired
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(ConsentPin);

/***/ }),
/* 2343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

var _ConsentPin = __webpack_require__(2342);

var _ConsentPin2 = _interopRequireDefault(_ConsentPin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GetStarted = function (_Component) {
  _inherits(GetStarted, _Component);

  function GetStarted(props) {
    _classCallCheck(this, GetStarted);

    var _this = _possibleConstructorReturn(this, (GetStarted.__proto__ || Object.getPrototypeOf(GetStarted)).call(this, props));

    _this.setLoading = function () {
      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.setLoading) {
        return _this.props.setLoading(loading);
      }
      return Promise.resolve();
    };

    _this.state = {
      isError: false,
      errMessage: null,
      id: props.id,
      leadDropID: props.leadDropID,
      code: props.code,
      updatedAt: props.updatedAt,
      pinExpiresAt: props.pinExpiresAt,
      consentPinCount: props.consentPinCount,
      openConsentPinModal: false,
      pinRequestable: true,
      consentTypeID: null
    };
    _this.hasSentConsent = false;
    return _this;
  }

  _createClass(GetStarted, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(props) {
      var _this2 = this;

      this.setState({
        id: props.id,
        leadDropID: props.leadDropID,
        code: props.code,
        updatedAt: props.updatedAt,
        pinExpiresAt: props.pinExpiresAt,
        consentPinCount: props.consentPinCount,
        consentTypeID: props.consentTypeID
      }, function () {
        if (!_this2.hasSentConsent && !_this2.hasStatus('lead-dropped') && _this2.state.consentTypeID === '1') {
          _this2.getStarted({
            agreedToTerms: true
          });
        }
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'getStarted',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var oldBody = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var t, res, errMessage, store, body, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.hasSentConsent = true;
                _context.next = 3;
                return this.setLoading(true);

              case 3:
                t = this.props.t;
                res = void 0;
                errMessage = t('An error occurred. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.';
                store = this.context.store;
                body = Object.assign(oldBody, {
                  bankCases: this.props.bankCases || []
                });
                _context.prev = 8;
                _context.next = 11;
                return store.dispatch((0, _fetchM.fetchM)('/bookings/' + this.props.bookingID + '/loan_trackers/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(body)
                }));

              case 11:
                res = _context.sent;
                _context.next = 28;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context['catch'](8);
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 24;
                  break;
                }

                _context.next = 21;
                return _context.t0.res.text();

              case 21:
                errMessage = _context.sent;
                _context.next = 25;
                break;

              case 24:
                Bugsnag.notifyException(_context.t0);

              case 25:
                _context.next = 27;
                return this.setComponentState({
                  isError: true,
                  errMessage: errMessage.trim()
                });

              case 27:
                return _context.abrupt('return', null);

              case 28:
                _context.next = 30;
                return this.setLoading(false);

              case 30:
                if (!(!res && !res.ok)) {
                  _context.next = 34;
                  break;
                }

                _context.next = 33;
                return this.setComponentState({
                  isError: true,
                  errMessage: errMessage
                });

              case 33:
                return _context.abrupt('return', null);

              case 34:
                _context.next = 36;
                return this.setComponentState({
                  isError: false,
                  errMessage: null,
                  openConsentPinModal: this.state.consentTypeID !== '1'
                });

              case 36:
                _context.next = 38;
                return res.json();

              case 38:
                data = _context.sent;

                if (this.props.onSubmit) {
                  this.props.onSubmit(data);
                }
                return _context.abrupt('return', data);

              case 41:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[8, 14]]);
      }));

      function getStarted() {
        return _ref.apply(this, arguments);
      }

      return getStarted;
    }()
  }, {
    key: 'hasStatus',
    value: function hasStatus(status) {
      switch (status) {
        case 'lead-dropped':
          return this.state.id < 1 && this.state.leadDropID > 0;
        case 'lead-added':
          return this.state.id > 0;
        default:
          return false;
      }
    }
  }, {
    key: 'renderLeadDrop',
    value: function renderLeadDrop(openConsentPinModal) {
      var _this4 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        'div',
        null,
        this.hasStatus('lead-dropped') ? _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            closeIcon: true,
            open: openConsentPinModal,
            onClose: function onClose() {
              return _this4.setComponentState({ openConsentPinModal: false });
            },
            size: 'tiny'
          },
          _react2.default.createElement(_semanticUiReact.Header, { content: t('Refer to bankers') }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(_ConsentPin2.default, {
              bookingID: this.props.bookingID,
              errMessage: this.state.errMessage,
              isError: this.state.isError,
              leadDropID: this.props.leadDropID,
              getStarted: function getStarted(data) {
                return _this4.getStarted(data);
              },
              setLoading: this.setLoading,
              mobilePrefix: this.props.mobilePrefix,
              mobile: this.props.mobile,
              onClose: function onClose() {
                return _this4.setComponentState({ openConsentPinModal: false });
              },
              onErrDismiss: function onErrDismiss() {
                return _this4.setState({ isError: false });
              },
              onPinRequestableChange: function onPinRequestableChange(pr) {
                return _this4.setComponentState({ pinRequestable: pr });
              }
            })
          )
        ) : ''
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'center aligned sixteen wide column' },
          this.hasStatus('lead-added') ? null : this.renderLeadDrop(this.state.openConsentPinModal),
          !this.hasStatus('lead-added') ? _react2.default.createElement(_semanticUiReact.Button, {
            positive: true,
            content: t(this.state.consentTypeID === '1' ? 'Get Started' : 'Send SMS Consent Pin to Purchaser'),
            onClick: function onClick(e) {
              e.preventDefault();
              if (_this5.state.pinRequestable) {
                _this5.getStarted({
                  agreedToTerms: true
                });
              } else {
                _this5.setState({ openConsentPinModal: _this5.state.consentTypeID !== '1' });
              }
            }
          }) : null
        )
      );
    }
  }]);

  return GetStarted;
}(_react.Component);

GetStarted.contextTypes = {
  store: _propTypes2.default.object
};
GetStarted.propTypes = {
  id: _propTypes2.default.number,
  leadDropID: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  code: _propTypes2.default.string,
  updatedAt: _propTypes2.default.string,
  pinExpiresAt: _propTypes2.default.string,
  consentPinCount: _propTypes2.default.number,
  bookingID: _propTypes2.default.string,
  token: _propTypes2.default.string,
  onSubmit: _propTypes2.default.func,
  bankCases: _propTypes2.default.arrayOf(_propTypes2.default.object),
  setLoading: _propTypes2.default.func.isRequired,
  mobilePrefix: _propTypes2.default.string,
  mobile: _propTypes2.default.string,
  consentTypeID: _propTypes2.default.string
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(GetStarted);

/***/ }),
/* 2344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _translation = __webpack_require__(4);

var _Form = __webpack_require__(2345);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditLogo = function (_Component) {
  _inherits(EditLogo, _Component);

  function EditLogo(props) {
    _classCallCheck(this, EditLogo);

    var _this = _possibleConstructorReturn(this, (EditLogo.__proto__ || Object.getPrototypeOf(EditLogo)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.getWrappedInstance().handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(EditLogo, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, file) {
        var _this2 = this;

        var store, errors, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 5;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 5:
                _context.prev = 5;
                _context.next = 8;
                return this.form.getWrappedInstance().submit('/logos/' + this.props.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(file)
                });

              case 8:
                _context.next = 20;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](5);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 18;
                  break;
                }

                _context.next = 15;
                return _context.t0.res.text();

              case 15:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 18:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 20:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false);
                });
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Update Success', message: 'Logo successfully updated' }));

              case 22:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 10]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Edit logo'),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Save', { ns: _translation.TRANSLATION_FILES.translation }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, unit) {
            _this3.submit(validations, unit);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading,
          logo: this.props.data
        })
      );
    }
  }]);

  return EditLogo;
}(_react.Component);

EditLogo.propTypes = {
  token: _propTypes2.default.string,
  id: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
EditLogo.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(EditLogo);

/***/ }),
/* 2345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogoForm = function (_Component) {
  _inherits(LogoForm, _Component);

  function LogoForm(props) {
    _classCallCheck(this, LogoForm);

    var _this = _possibleConstructorReturn(this, (LogoForm.__proto__ || Object.getPrototypeOf(LogoForm)).call(this, props));

    _initialiseProps.call(_this);

    var logo = Object.assign({}, LogoForm.defaultValues, props.logo || {});
    _this.state = {
      logo: logo,
      oriLogo: (0, _clone2.default)(logo),
      errMessages: []
    };
    _this.validation = {
      label: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(LogoForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var logo = Object.assign({}, LogoForm.defaultValues, this.state.logo);
      var oriLogo = this.state.oriLogo;
      if (JSON.stringify(this.props.logo) !== JSON.stringify(nextProps.logo)) {
        logo = Object.assign(logo, nextProps.logo);
        oriLogo = (0, _clone2.default)(logo);
      }
      this.setState({
        logo: logo,
        oriLogo: oriLogo
      });
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref) {
            _this2.form = _ref;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              _react2.default.createElement(_LoadImage2.default, {
                wrapped: true,
                picture: this.state.logo,
                pictureSize: 100,
                extension: 'png'
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_AppForm2.default.Input, {
                label: 'Label',
                type: 'text',
                name: 'label',
                value: this.state.logo.label,
                onChange: this.handleInputChange,
                ref: this.validation.label
              })
            )
          )
        )
      );
    }
  }]);

  return LogoForm;
}(_react.Component);

LogoForm.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  logo: _propTypes2.default.shape({
    key: _propTypes2.default.string
  })
};
LogoForm.contextTypes = {
  store: _propTypes2.default.object
};
LogoForm.defaultValues = {
  label: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleSubmit = function (event) {
    event.preventDefault();
    var logo = _this3.state.logo;

    logo.label = logo.label.trim();
    _AppForm2.default.validate(_this3.validation, logo).then(function (validations) {
      _this3.props.onSubmit(validations, logo);
    });
  };

  this.handleInputChange = function (event, _ref2) {
    var name = _ref2.name,
        value = _ref2.value;
    var logo = _this3.state.logo;

    var newValue = value;
    if (name === 'label') {
      newValue = value.replace(/[\\~#%&*{}/:<>?|"]/, '');
    }
    logo[name] = newValue;
    _this3.setState({ logo: logo }, function () {
      _this3.handleCheckChanges();
    });
  };
};

exports.default = (0, _reactRedux.connect)(LogoForm.mapStateToProps, null, null, { withRef: true })(LogoForm);

/***/ }),
/* 2346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _checkChanges = __webpack_require__(61);

var _Edit = __webpack_require__(2344);

var _Edit2 = _interopRequireDefault(_Edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Logo = function (_Component) {
  _inherits(Logo, _Component);

  function Logo(props) {
    _classCallCheck(this, Logo);

    var _this = _possibleConstructorReturn(this, (Logo.__proto__ || Object.getPrototypeOf(Logo)).call(this, props));

    _this.state = {
      token: null,
      loading: true,
      data: null
    };
    return _this;
  }

  _createClass(Logo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchLogo();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var id = nextProps.params.id;

      if (id !== this.props.params.id) {
        this.fetchLogo();
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchLogo',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, data, token;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/logos/' + this.props.params.id + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                return _context.abrupt('return');

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 32;
                break;

              case 26:
                _context.next = 28;
                return res.json();

              case 28:
                data = _context.sent;

                // handle token.. etc
                token = res.headers.get('X-Csrf-Token');
                _context.next = 32;
                return this.setComponentState({
                  data: data,
                  token: token
                });

              case 32:
                _context.next = 34;
                return this.setLoading(false);

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchLogo() {
        return _ref.apply(this, arguments);
      }

      return fetchLogo;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this4 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this4.state.token,
          loading: _this4.state.loading,
          data: _this4.state.data,
          id: _this4.props.params.id
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Logo;
}(_react.Component);

Logo.propTypes = {
  children: _propTypes2.default.node,
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string
  })
};
Logo.contextTypes = {
  store: _propTypes2.default.object
};
Logo.Edit = (0, _checkChanges.checkChanges)(_Edit2.default);
exports.default = Logo;

/***/ }),
/* 2347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Logo = __webpack_require__(2346);

var _Logo2 = _interopRequireDefault(_Logo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Logo2.default;

/***/ }),
/* 2348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _prompt = __webpack_require__(66);

var _LogoList = __webpack_require__(1024);

var _LogoList2 = _interopRequireDefault(_LogoList);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _UploadModal = __webpack_require__(92);

var _UploadModal2 = _interopRequireDefault(_UploadModal);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _RemoveLogo = __webpack_require__(2528);

var _RemoveLogo2 = _interopRequireDefault(_RemoveLogo);

var _promptMessages = __webpack_require__(43);

var _translation = __webpack_require__(4);

var _Form = __webpack_require__(586);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _initialiseProps.call(_this);

    var state = List.getPropsToState(props);
    _this.state = _extends({}, state, {
      selectedLogo: null,
      showLarge: false,
      showDelete: false,
      logos: []
    });
    _this.logoList = null;
    return _this;
  }

  _createClass(List, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'getToken',
    value: function getToken(id, callback) {
      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/logos/' + id + '/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      }).then(function (res) {
        var token = res.headers.get('X-Csrf-Token');
        if (callback) {
          callback(token);
        }
      });
    }
  }, {
    key: 'handleRefetch',
    value: function handleRefetch() {
      this.logoList.getWrappedInstance().handleRefetch();
    }
  }, {
    key: 'uploadLogo',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e, body) {
        var t, store, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                t = this.props.t;
                store = this.context.store;
                _context.prev = 3;
                _context.next = 6;
                return this.form.getWrappedInstance().submit('/logos/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    // Let browser decide Content-Type
                    'X-Csrf-Token': this.props.token
                  },
                  body: body
                });

              case 6:
                _context.next = 18;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](3);

                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 16;
                  break;
                }

                _context.next = 13;
                return _context.t0.res.text();

              case 13:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 16:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 18:
                this.uploadModal.close();
                this.handleRefetch();
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Upload Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Logo(s) successfully uploaded', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 8]]);
      }));

      function uploadLogo(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return uploadLogo;
    }()
  }, {
    key: 'deleteLogos',
    value: function deleteLogos() {
      var _this2 = this;

      var t = this.props.t;
      var store = this.context.store;

      this.getToken(this.state.selectedLogo.id, function (token) {
        store.dispatch((0, _fetchM.fetchM)('/logos/' + _this2.state.selectedLogo.id + '/', {
          credentials: 'include',
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'X-Csrf-Token': token
          }
        })).then(function () {
          _this2.setState({
            selectedLogo: null,
            loading: false
          });
          _this2.handleRefetch();
          store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Logo successfully deleted', { ns: _translation.TRANSLATION_FILES.translation }) }));
        }).catch(function (err) {
          store.dispatch((0, _flash.flashErrorMessage)(err));
        });
      });
    }
  }, {
    key: 'checkDisabled',
    value: function checkDisabled() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';
      var _state = this.state,
          logos = _state.logos,
          selectedLogo = _state.selectedLogo;

      if (selectedLogo) {
        var index = logos.indexOf(selectedLogo);
        if (direction === 'left') {
          return index - 1 >= 0;
        }
        return index + 1 < logos.length;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Logos'),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_UploadModal2.default, {
              ref: function ref(_ref4) {
                _this3.uploadModal = _ref4;
              },
              header: 'Logos',
              loading: this.state.loading,
              onConfirm: function onConfirm(e, data) {
                _this3.uploadLogo(e, data);
              },
              onClose: this.handleCheckBeforeClose,
              content: function content(_ref2) {
                var onConfirm = _ref2.onConfirm;
                return _react2.default.createElement(_Form2.default, {
                  ref: function ref(_ref3) {
                    _this3.form = _ref3;
                  },
                  onSubmit: onConfirm
                });
              }
            })
          )
        }),
        _react2.default.createElement(_ViewLarge2.default, {
          open: this.state.showLarge,
          onClose: this.handleCloseLarge,
          picture: this.state.selectedLogo,
          onSlide: this.handleSlideLogo,
          disabledLeft: !this.checkDisabled('left'),
          disabledRight: !this.checkDisabled('right'),
          slideshow: this.state.showLarge,
          pictureSize: 100,
          extension: 'png'
        }),
        _react2.default.createElement(_RemoveLogo2.default, {
          open: this.state.showDelete,
          onClose: this.handleCancelDelete,
          onConfirm: this.handleConfirmDelete,
          picture: this.state.selectedLogo,
          pictureSize: 50,
          extension: 'png'
        }),
        _react2.default.createElement(_LogoList2.default, {
          ref: function ref(_ref6) {
            _this3.logoList = _ref6;
          },
          toggleable: true,
          onChange: this.handleGetLogos,
          onViewLarge: this.handleViewLarge,
          onRemove: this.handleDelete,
          buttonNode: function buttonNode(_ref5) {
            var isMobile = _ref5.isMobile,
                view = _ref5.view,
                loading = _ref5.loading,
                logo = _ref5.logo;
            return view === 'list' ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_semanticUiReact.Button, {
                as: _reactRouter.Link,
                size: 'tiny',
                compact: true,
                primary: true,
                icon: 'edit',
                content: t('Edit', { ns: _translation.TRANSLATION_FILES.translation }),
                disabled: loading,
                to: '/media/logos/' + logo.id + '/'
              }),
              _react2.default.createElement(_semanticUiReact.Button, {
                size: 'tiny',
                compact: true,
                negative: true,
                icon: 'remove',
                content: isMobile ? null : t('Remove'),
                disabled: loading,
                onClick: function onClick(e) {
                  return _this3.handleDelete(e, logo);
                }
              })
            ) : _react2.default.createElement(_semanticUiReact.Button, {
              as: _reactRouter.Link,
              compact: true, size: 'small',
              attached: 'bottom',
              primary: true,
              icon: 'edit',
              content: t('Edit', { ns: _translation.TRANSLATION_FILES.translation }),
              disabled: loading,
              to: '/media/logos/' + logo.id + '/'
            });
          }
        })
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};
List.propTypes = {
  token: _propTypes2.default.string,
  t: _propTypes2.default.func
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  return {
    loading: loading
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleCloseLarge = function (e) {
    e.preventDefault();
    _this4.setState({
      showLarge: false,
      selectedLogo: null
    });
  };

  this.handleViewLarge = function (e, selectedLogo) {
    e.preventDefault();
    _this4.setState({
      selectedLogo: selectedLogo,
      showLarge: true
    });
  };

  this.handleCancelDelete = function (e) {
    e.preventDefault();
    _this4.setState({
      showDelete: false,
      selectedLogo: null
    });
  };

  this.handleDelete = function (e, selectedLogo) {
    e.preventDefault();
    _this4.setState({
      selectedLogo: selectedLogo,
      showDelete: true
    });
  };

  this.handleConfirmDelete = function (e) {
    e.preventDefault();
    _this4.setState({
      showDelete: false
    }, function () {
      _this4.deleteLogos();
    });
  };

  this.handleCheckBeforeClose = function () {
    var t = _this4.props.t;

    if (_this4.form.getWrappedInstance().state.uploads.length > 0) {
      var callback = function callback() {
        _this4.uploadModal.close();
        _this4.handleRefetch();
      };
      var store = _this4.context.store;

      store.dispatch((0, _prompt.promptChangesMessage)({ message: t(_promptMessages.UPLOAD_LOGO_PROMPT), callback: callback }));
      return true;
    }
    return false;
  };

  this.handleGetLogos = function (logos) {
    _this4.setState({ logos: logos });
  };

  this.handleSlideLogo = function (e) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
    var _state2 = _this4.state,
        logos = _state2.logos,
        selectedLogo = _state2.selectedLogo;

    var index = logos.indexOf(selectedLogo);
    var nextIndex = direction === 'left' ? index - 1 : index + 1;
    _this4.setState({
      selectedLogo: logos[nextIndex]
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(List);

/***/ }),
/* 2349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _List = __webpack_require__(2348);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Logos = function (_Component) {
  _inherits(Logos, _Component);

  function Logos(props) {
    _classCallCheck(this, Logos);

    var _this = _possibleConstructorReturn(this, (Logos.__proto__ || Object.getPrototypeOf(Logos)).call(this, props));

    _this.state = {
      token: null,
      loading: true
    };
    return _this;
  }

  _createClass(Logos, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchLogos();
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchLogos',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, token;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/logos/?page=1', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                return _context.abrupt('return');

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 29;
                break;

              case 26:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context.next = 29;
                return this.setComponentState({
                  token: token
                });

              case 29:
                _context.next = 31;
                return this.setLoading(false);

              case 31:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchLogos() {
        return _ref.apply(this, arguments);
      }

      return fetchLogos;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this4 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this4.state.token,
          loading: _this4.state.loading
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Logos;
}(_react.Component);

Logos.propTypes = {
  children: _propTypes2.default.node
};
Logos.contextTypes = {
  store: _propTypes2.default.object
};
Logos.List = _List2.default;
exports.default = Logos;

/***/ }),
/* 2350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Logos = __webpack_require__(2349);

var _Logos2 = _interopRequireDefault(_Logos);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Logos2.default;

/***/ }),
/* 2351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _reactRouter = __webpack_require__(18);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _BookDash = __webpack_require__(573);

var _BookDash2 = _interopRequireDefault(_BookDash);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prefer-stateless-function: 0 */


var Dash = function (_Component) {
  _inherits(Dash, _Component);

  function Dash() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dash);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dash.__proto__ || Object.getPrototypeOf(Dash)).call.apply(_ref, [this].concat(args))), _this), _this.modules = [{
      name: 'Logos',
      description: 'Logo for projects',
      type: 'pictures',
      route: '/media/logos/',
      icon: 'logo',
      enabled: true,
      isBranchLeader: false,
      isDeveloper: false,
      isSiteplan: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }, {
      name: 'Pictures',
      description: 'Gallery for Site plan, Unit layout & Map',
      type: 'pictures',
      route: '/media/pictures/',
      icon: 'picture',
      enabled: true,
      isBranchLeader: false,
      isDeveloper: false,
      isSiteplan: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }, {
      name: 'Documents',
      description: 'Brochures & Forms',
      type: 'documents',
      route: '/media/documents/',
      icon: 'folder open',
      enabled: true,
      isBranchLeader: false,
      isDeveloper: false,
      isSiteplan: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }, {
      name: 'Videos',
      description: 'Videos from external websites',
      type: 'documents',
      route: '/media/videos/',
      icon: 'folder open',
      enabled: true,
      isBranchLeader: false,
      isDeveloper: false,
      isSiteplan: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dash, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Media', { ns: 'screens' })
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { doubling: true, columns: 4, className: 'dash_grid' },
          this.modules.filter(function (module) {
            if (_this2.props.auth.isSuperAdmin) {
              return module.isSuperAdmin;
            }
            if (_this2.props.auth.isHeadquarters) {
              return module.isHeadquarters;
            }
            if (_this2.props.auth.isDeveloper) {
              return module.isDeveloper;
            }
            return true;
          }).map(function (module, idx) {
            if (module.type) {
              return _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { key: idx },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: module.route },
                  _react2.default.createElement(
                    _semanticUiReact.Header,
                    { textAlign: 'center', as: 'h3' },
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(_BookDash2.default, {
                        type: module.type,
                        width: '6em',
                        height: '6em',
                        backfill: '#F8F8F8',
                        iconfill: '#00233B'
                      })
                    ),
                    t(module.name).toUpperCase(),
                    _react2.default.createElement(
                      _semanticUiReact.Header.Subheader,
                      null,
                      t(module.description)
                    )
                  )
                )
              );
            }
            return null;
          })
        )
      );
    }
  }]);

  return Dash;
}(_react.Component);

Dash.contextTypes = {
  store: _propTypes2.default.object
};
Dash.propTypes = {
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    isDeveloper: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool
  }),
  t: _propTypes2.default.func
};
Dash.defaultProps = {
  auth: {
    isAdminBasic: false
  }
};

Dash.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

Dash.contextTypes = {
  store: _propTypes2.default.object
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Dash.mapStateToProps)(Dash));

/***/ }),
/* 2352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dash = __webpack_require__(2351);

var _Dash2 = _interopRequireDefault(_Dash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Projects = function (_Component) {
  _inherits(Projects, _Component);

  function Projects() {
    _classCallCheck(this, Projects);

    return _possibleConstructorReturn(this, (Projects.__proto__ || Object.getPrototypeOf(Projects)).apply(this, arguments));
  }

  _createClass(Projects, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);

  return Projects;
}(_react.Component);

Projects.propTypes = {
  children: _propTypes2.default.node
};
Projects.contextTypes = {
  store: _propTypes2.default.object
};
Projects.Dash = _Dash2.default;
exports.default = Projects;

/***/ }),
/* 2353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Media = __webpack_require__(2352);

var _Media2 = _interopRequireDefault(_Media);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Media2.default;

/***/ }),
/* 2354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotFound = function (_Component) {
  _inherits(NotFound, _Component);

  function NotFound() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NotFound);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotFound.__proto__ || Object.getPrototypeOf(NotFound)).call.apply(_ref, [this].concat(args))), _this), _this.handleAction = function (e) {
      e.preventDefault();
      var store = _this.context.store;

      store.dispatch((0, _reactRouterRedux.replace)('/'));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotFound, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      document.getElementById('preloader-container').classList.remove('app-loading');
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          open: true,
          basic: true,
          size: 'small'
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: 'Not Found' }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            'h3',
            null,
            'Oops! The page you requested was not found!'
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(
            _semanticUiReact.Button,
            { color: 'green', onClick: this.handleAction, inverted: true },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'home' }),
            ' Return home safely'
          )
        )
      );
    }
  }]);

  return NotFound;
}(_react.Component);

NotFound.contextTypes = {
  store: _propTypes2.default.object
};

exports.default = NotFound;

/***/ }),
/* 2355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _url = __webpack_require__(19);

var _fileSize = __webpack_require__(85);

var _fileSize2 = _interopRequireDefault(_fileSize);

var _valueToText = __webpack_require__(98);

var _valueToText2 = _interopRequireDefault(_valueToText);

var _vietnam = __webpack_require__(40);

var _vnBookingExport = __webpack_require__(1096);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// CPI-1281: Booking Exports. The Bookings list is served by the CRM in pages behind a short-lived
// cursor, so a download cannot be streamed from one request. This page queues an export carrying
// the filters the user arrived with; book-api's cron builds the workbook and the row flips to
// completed with a download link. Vietnam only.
var POLL_MS = 3000;
var STATUSES = [{ text: 'Generating', value: 'new' }, { text: 'Completed', value: 'completed' }, { text: 'Failed', value: 'failed' }];

var Exports = function (_Component) {
  _inherits(Exports, _Component);

  function Exports(props) {
    _classCallCheck(this, Exports);

    var _this = _possibleConstructorReturn(this, (Exports.__proto__ || Object.getPrototypeOf(Exports)).call(this, props));

    _initialiseProps.call(_this);

    var query = (0, _url.decodeSearch)(props.location.search);
    _this.state = {
      loading: true,
      generating: false,
      token: '',
      data: [],
      count: 0,
      limit: 0,
      offset: 0,
      currentPage: parseInt(query.page, 10) || 1,
      filters: (0, _vnBookingExport.exportFiltersFromQuery)(query)
    };
    return _this;
  }

  _createClass(Exports, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.mounted = true;
      var store = this.context.store;

      if (!(0, _vietnam.isVietnamCompany)(this.props.auth)) {
        store.dispatch((0, _reactRouterRedux.replace)('/opportunities/'));
        return;
      }
      this.fetchExports();
      this.ticker = setInterval(function () {
        if (_this2.state.generating && _this2.state.currentPage === 1) {
          _this2.fetchExports(true);
        }
      }, POLL_MS);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      if (nextProps.location.search !== this.props.location.search) {
        var query = (0, _url.decodeSearch)(nextProps.location.search);
        this.setState({
          currentPage: parseInt(query.page, 10) || 1,
          filters: (0, _vnBookingExport.exportFiltersFromQuery)(query)
        }, function () {
          return _this3.fetchExports();
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
      if (this.ticker) clearInterval(this.ticker);
    }
  }, {
    key: 'setStateSafe',
    value: function setStateSafe(state) {
      var _this4 = this;

      return new Promise(function (res) {
        if (!_this4.mounted) {
          res();return;
        }
        _this4.setState(state, res);
      });
    }
  }, {
    key: 'fetchExports',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var silent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var store, t, res, message, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;

                if (silent) {
                  _context.next = 5;
                  break;
                }

                _context.next = 5;
                return this.setStateSafe({ loading: true });

              case 5:
                res = void 0;
                _context.prev = 6;
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/opportunity/export/?' + _qs2.default.stringify({ page: this.state.currentPage }), {
                  credentials: 'include',
                  method: 'GET',
                  headers: { 'Content-Type': 'application/json' }
                }));

              case 9:
                res = _context.sent;
                _context.next = 19;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                _context.next = 18;
                return this.setStateSafe({ loading: false });

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                _context.next = 26;
                return this.setStateSafe({ loading: false });

              case 26:
                return _context.abrupt('return');

              case 27:
                _context.next = 29;
                return res.json();

              case 29:
                data = _context.sent;
                _context.next = 32;
                return this.setStateSafe({
                  loading: false,
                  token: res.headers.get('X-Csrf-Token') || this.state.token,
                  count: parseInt(res.headers.get('M-Data-count'), 10) || 0,
                  limit: parseInt(res.headers.get('M-Data-limit'), 10) || 0,
                  offset: parseInt(res.headers.get('M-Data-offset'), 10) || 0,
                  data: data || [],
                  generating: (data || []).some(function (row) {
                    return row.statusID === 'new';
                  })
                });

              case 32:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));

      function fetchExports() {
        return _ref.apply(this, arguments);
      }

      return fetchExports;
    }()
  }, {
    key: 'renderFilters',
    value: function renderFilters(filters) {
      var t = this.props.t;

      var parts = (0, _vnBookingExport.exportFiltersSummary)(filters, t, { ns: _translation.TRANSLATION_FILES.constants });
      return parts.map(function (part) {
        return _react2.default.createElement(
          _semanticUiReact.Label,
          { key: part.key, basic: true, size: 'small', style: { marginBottom: '0.25em' } },
          part.label ? part.label : part.value,
          part.label ? _react2.default.createElement(
            _semanticUiReact.Label.Detail,
            null,
            part.value
          ) : null
        );
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;
      var _state = this.state,
          loading = _state.loading,
          generating = _state.generating,
          data = _state.data,
          count = _state.count,
          limit = _state.limit,
          offset = _state.offset,
          currentPage = _state.currentPage,
          filters = _state.filters;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Booking Exports'),
          leftNav: _react2.default.createElement(_semanticUiReact.Button, { basic: true, icon: 'arrow left', content: t('Bookings'), onClick: this.handleBack })
        }),
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          { inverted: true, active: loading },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Message,
          { info: true, size: 'small' },
          _react2.default.createElement(
            _semanticUiReact.Message.Content,
            null,
            _react2.default.createElement(
              'p',
              { style: { marginBottom: '0.5em' } },
              t('The export runs in the background and appears below once it is ready'),
              '.'
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'b',
                null,
                t('Filters'),
                ':'
              ),
              ' ',
              this.renderFilters(filters)
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          { stackable: true, selectable: true },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 4 },
                _react2.default.createElement(
                  'h3',
                  null,
                  t('Booking Exports')
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 3, textAlign: 'right' },
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  { primary: true, onClick: this.handleGenerate, disabled: generating || loading, 'data-bot-target': 'generate-export' },
                  generating ? _react2.default.createElement(_semanticUiReact.Icon, { loading: true, name: 'spinner' }) : _react2.default.createElement(_semanticUiReact.Icon, { name: 'download' }),
                  generating ? t('Generating') : t('Generate Export')
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { className: 'mobile-hide' },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Name')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Filters')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Requested by')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { textAlign: 'right' },
                t('Rows')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Size')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Date')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Status')
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            data.length > 0 ? data.map(this.renderRow) : _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 7, textAlign: 'center' },
                t('No exports found'),
                '.'
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Footer,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 7, textAlign: 'center' },
                _react2.default.createElement(_PageNav2.default, {
                  upward: true,
                  currentPage: currentPage,
                  count: count,
                  limit: limit,
                  offset: offset,
                  dataSize: data.length,
                  loading: loading,
                  onChange: this.handleChangePage
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Exports;
}(_react.Component);

Exports.contextTypes = {
  store: _propTypes2.default.object
};
Exports.propTypes = {
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.shape({ countryCode: _propTypes2.default.string })
  }),
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    search: _propTypes2.default.string
  }).isRequired,
  t: _propTypes2.default.func
};

Exports.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.handleGenerate = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(e) {
      var store, t, message;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              e.preventDefault();
              store = _this5.context.store;
              t = _this5.props.t;
              _context2.next = 5;
              return _this5.setStateSafe({ loading: true });

            case 5:
              _context2.prev = 5;
              _context2.next = 8;
              return store.dispatch((0, _fetchM.fetchM)('/opportunity/export/?' + _qs2.default.stringify(_this5.state.filters), {
                credentials: 'include',
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Csrf-Token': _this5.state.token
                }
              }));

            case 8:
              _context2.next = 23;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2['catch'](5);
              _context2.next = 14;
              return _this5.setStateSafe({ loading: false });

            case 14:
              if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                _context2.next = 20;
                break;
              }

              _context2.next = 17;
              return _context2.t0.res.text();

            case 17:
              message = _context2.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
              return _context2.abrupt('return');

            case 20:
              Bugsnag.notifyException(_context2.t0);
              store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
              return _context2.abrupt('return');

            case 23:
              store.dispatch((0, _flash.flashSuccessMessage)({
                header: t('Generating Export'),
                message: t('Export has been added to the queue') + '.'
              }));

              if (!(_this5.state.currentPage !== 1)) {
                _context2.next = 27;
                break;
              }

              _this5.handleChangePage(1);
              return _context2.abrupt('return');

            case 27:
              _this5.fetchExports();

            case 28:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this5, [[5, 10]]);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  this.handleChangePage = function (currentPage) {
    var store = _this5.context.store;

    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    query.page = currentPage;
    store.dispatch((0, _reactRouterRedux.replace)(_this5.props.location.pathname + '?' + (0, _url.encodeSearch)(query)));
  };

  this.handleBack = function (e) {
    e.preventDefault();
    var store = _this5.context.store;

    var search = _qs2.default.stringify(_this5.state.filters);
    store.dispatch((0, _reactRouterRedux.push)(search ? '/opportunities/?' + search : '/opportunities/'));
  };

  this.renderRow = function (file) {
    var t = _this5.props.t;

    var completed = file.statusID === 'completed';
    return _react2.default.createElement(
      _semanticUiReact.Table.Row,
      { key: file.id },
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { width: 5 },
        completed ? _react2.default.createElement(
          'a',
          {
            href: _config2.default.get('bookApiURL') + '/opportunity/export/' + file.id + '/' + file.name,
            target: '_blank',
            rel: 'noopener noreferrer'
          },
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'download' }),
            ' ',
            file.name
          )
        ) : _react2.default.createElement(
          'span',
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel outline' }),
          ' ',
          file.name
        ),
        file.statusID === 'failed' && file.errorMessage ? _react2.default.createElement(
          'div',
          { style: { color: '#9f3a38', fontSize: '0.9em', marginTop: '0.25em' } },
          file.errorMessage
        ) : null
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        null,
        _this5.renderFilters(file.filters)
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true },
        file.requestedByName || '-'
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true, textAlign: 'right' },
        completed ? file.rowCount : '-'
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true },
        file.size ? (0, _fileSize2.default)(file.size) : '-'
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { collapsing: true },
        _react2.default.createElement(_Timestamp2.default, { format: 'DD/M/YYYY HH:mm', timestamp: file.createdAt })
      ),
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { width: 3 },
        _react2.default.createElement(
          _semanticUiReact.Progress,
          {
            size: 'small',
            percent: completed ? 100 : (0, _vnBookingExport.progressPercent)(file.progress),
            progress: true,
            color: file.statusID === 'new' ? 'blue' : null,
            success: completed,
            error: file.statusID === 'failed',
            active: file.statusID === 'new'
          },
          t((0, _valueToText2.default)(STATUSES, file.statusID), { ns: _translation.TRANSLATION_FILES.constants })
        )
      )
    );
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Exports.mapStateToProps)(Exports));

/***/ }),
/* 2356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(13);

var _moment = __webpack_require__(12);

var _moment2 = _interopRequireDefault(_moment);

var _semanticUiReact = __webpack_require__(2);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _translation = __webpack_require__(4);

var _OpportunityList = __webpack_require__(2163);

var _OpportunityList2 = _interopRequireDefault(_OpportunityList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_moment2.default.locale('en-gb');

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _this.handleOnLoading = function (loading) {
      _this.setState({ loading: loading });
    };

    _this.himsIsEnabled = function () {
      var appConfig = _this.props.appConfig;

      return appConfig && appConfig.data && appConfig.data.himsIsEnabled;
    };

    _this.handleManageClick = function (e, data) {
      e.preventDefault();
      var store = _this.context.store;

      store.dispatch((0, _reactRouterRedux.push)('/opportunities/' + data.value));
    };

    _this.state = {
      loading: true
    };
    return _this;
  }

  _createClass(List, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          auth = _props.auth;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Bookings'),
          rightNav: auth.isHeadquarters || auth.isAdminBasic ? _react2.default.createElement(
            _semanticUiReact.Dropdown,
            { item: true, text: t('Manage') },
            _react2.default.createElement(
              _semanticUiReact.Dropdown.Menu,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dropdown.Item,
                {
                  onClick: this.handleManageClick,
                  value: 'manage_refunds/'
                },
                t('Manage Refunds')
              )
            )
          ) : null
        }),
        _react2.default.createElement(_OpportunityList2.default, {
          onLoading: this.handleOnLoading
        })
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};
List.propTypes = {
  auth: _propTypes2.default.shape({
    isDeveloperSupervisor: _propTypes2.default.bool,
    isDeveloperSalesManager: _propTypes2.default.bool,
    isDeveloperSalesAdmin: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isAdmin: _propTypes2.default.bool
  }),
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      himsIsEnabled: _propTypes2.default.bool
    })
  }),
  t: _propTypes2.default.func
};

List.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)((0, _reactRedux.connect)(List.mapStateToProps)(List));

/***/ }),
/* 2357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _translation = __webpack_require__(4);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _fetchM = __webpack_require__(6);

var _url = __webpack_require__(19);

var _isbase = __webpack_require__(157);

var _isbase2 = _interopRequireDefault(_isbase);

var _storage = __webpack_require__(44);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _UnitReservationRefunds = __webpack_require__(2358);

var _UnitReservationRefunds2 = _interopRequireDefault(_UnitReservationRefunds);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var tabs = [{ id: 1, name: 'pending', text: 'Pending' }, { id: 2, name: 'approved', text: 'Completed' }, { id: 3, name: 'declined', text: 'Declined' }];

var Manage = function (_Component) {
  _inherits(Manage, _Component);

  function Manage(props) {
    _classCallCheck(this, Manage);

    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));

    _initialiseProps.call(_this);

    var localAutoReloadValue = (0, _storage.getItem)(_config2.default.get('appName') + '.bookingManageAutoReload');
    var isAutoReloadOn = localAutoReloadValue === 'true';
    var state = Manage.getPropsToState(props);
    var query = (0, _url.decodeSearch)(props.location.search);
    var hasProjectFilter = !!(query.projectFilter && query.projectFilter.length > 0);
    _this.state = _extends({}, state, {
      advanceFilter: hasProjectFilter,
      autoReload: isAutoReloadOn,
      count: 0,
      currentTabID: 1,
      data: [],
      limit: 0,
      loading: true,
      offset: 0,
      pendingCount: 0,
      approvedCount: 0,
      declinedCount: 0
    });
    _this._isMounted = false;
    return _this;
  }

  _createClass(Manage, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
      this.fetchHeaderCounts();
      if (this.state.autoReload) {
        this.setRefreshDataTimeout();
      }
    }
    // eslint-disable-next-line react/no-deprecated

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.location.search !== this.props.location.search || nextProps.loading !== this.props.loading) {
        var state = Manage.getPropsToState(nextProps);
        var query = (0, _url.decodeSearch)(nextProps.location.search);
        var activeTab = tabs.find(function (t) {
          return t.name === query.status;
        });

        state.currentTabID = activeTab ? activeTab.id : 1;
        state.loading = nextProps.loading;

        this.setState(_extends({}, state));
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
      if (this.timeout) {
        clearTimeout(this.timeout);
      }
      if (this.setTimer) {
        clearTimeout(this.setTimer);
      }
      if (this.timeoutRefresh) {
        clearTimeout(this.timeoutRefresh);
      }
    }
  }, {
    key: 'setLoadingSearch',
    value: function setLoadingSearch() {
      var _this2 = this;

      var loadingSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loadingSearch: loadingSearch }, res);
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this4 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this4.setState(state, res);
      });
    }
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(q) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;
      var currentTabID = this.state.currentTabID;


      var activeTab = tabs.find(function (t) {
        return t.id === currentTabID;
      });

      var query = _extends({}, q, {
        page: resetPage ? 1 : q.page || 1,
        status: activeTab ? activeTab.name : 'pending'
      });

      store.dispatch((0, _reactRouterRedux.replace)('/opportunities/manage_refunds/?' + (0, _url.encodeSearch)(query)));
      this.props.fetchRefunds(query);
    }
  }, {
    key: 'pushQuery',
    value: function pushQuery(q) {
      var store = this.context.store;
      var currentTabID = this.state.currentTabID;

      var activeTab = tabs.find(function (t) {
        return t.id === currentTabID;
      });

      var query = _extends({}, q, {
        status: activeTab ? activeTab.name : 'pending'
      });

      store.dispatch((0, _reactRouterRedux.replace)('/opportunities/manage_refunds/?' + (0, _url.encodeSearch)(query)));
      this.props.fetchRefunds(query);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _state = this.state,
          currentPage = _state.currentPage,
          currentTabID = _state.currentTabID,
          pendingCount = _state.pendingCount,
          approvedCount = _state.approvedCount,
          declinedCount = _state.declinedCount;

      var totalCount = pendingCount + approvedCount + declinedCount;
      var _props = this.props,
          refundData = _props.refundData,
          refundCount = _props.refundCount,
          refundLimit = _props.refundLimit,
          refundOffset = _props.refundOffset,
          refundToken = _props.refundToken,
          loading = _props.loading,
          t = _props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default
        // Simplify header: if no data, just show 'Manage', otherwise show total
        , { header: !totalCount ? t('Manage') : _react2.default.createElement(
            'span',
            null,
            t('Manage'),
            ' \xA0',
            _react2.default.createElement(
              _semanticUiReact.Label,
              { color: 'blue' },
              totalCount
            )
          )
        }),
        this.renderMenuTool(),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', className: 'booking-list' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'tab-menu manage-booking-tab' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Menu,
                { attached: 'top', tabular: true },
                tabs.map(function (tab) {
                  var countToDisplay = 0;
                  if (tab.id === 1) countToDisplay = pendingCount;
                  if (tab.id === 2) countToDisplay = approvedCount;
                  if (tab.id === 3) countToDisplay = declinedCount;
                  return _react2.default.createElement(
                    _semanticUiReact.Menu.Item,
                    {
                      key: tab.id,
                      value: tab.id,
                      onClick: _this5.handleChangeTab,
                      active: currentTabID === tab.id
                    },
                    _react2.default.createElement(
                      'span',
                      null,
                      t(tab.text),
                      '\xA0',
                      _react2.default.createElement(
                        _semanticUiReact.Label,
                        { color: 'blue' },
                        countToDisplay || 0
                      )
                    )
                  );
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(_UnitReservationRefunds2.default, {
                auth: this.props.auth,
                data: refundData || [],
                loading: loading,
                refundToken: refundToken,
                fetchRefund: this.props.fetchRefunds,
                onUpdateOpportunity: this.props.onUpdateOpportunity,
                fetchHeaderCounts: this.fetchHeaderCounts,
                pendingCancelUnitsTab: currentTabID !== 1
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              _react2.default.createElement(_PageNav2.default, {
                currentPage: currentPage,
                count: refundCount,
                limit: refundLimit,
                offset: refundOffset,
                dataSize: (refundData || []).length,
                loading: loading,
                onChange: this.handleChangePage
              })
            )
          )
        )
      );
    }
  }]);

  return Manage;
}(_react.Component);

Manage.contextTypes = {
  store: _propTypes2.default.object
};
Manage.propTypes = {
  appConfig: _propTypes2.default.shape({}),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  loading: _propTypes2.default.bool
};

Manage.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

Manage.getPropsToState = function (props) {
  var token = '';
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var advanceFilter = false;
  var projectFilter = (0, _isbase2.default)(query.projectFilter) && _qs2.default.parse(atob(query.projectFilter)).name || '';
  return {
    token: token,
    currentPage: currentPage,
    search: search,
    advanceFilter: advanceFilter,
    projectFilter: projectFilter,
    loadingSearch: false,
    findProjectResults: [],
    noResultsMessage: 'Loading...'
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.setRefreshDataTimeout = function () {
    if (_this6.timeoutRefresh) {
      clearTimeout(_this6.timeoutRefresh);
    }
    _this6.timeoutRefresh = setTimeout(function () {
      _this6.handleRefreshData();
      _this6.setRefreshDataTimeout();
    }, 30000); // 30 seconds auto refresh time
  };

  this.handleChangePage = function (page) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.page = page;

    _this6.setState({ currentPage: page });

    _this6.pushQuery(query);
  };

  this.handleChangeTab = function (e, _ref) {
    var value = _ref.value;

    e.preventDefault();
    _this6.setState({
      currentTabID: value
    }, function () {
      _this6.handleChangePage(1);
    });
  };

  this.fetchHeaderCounts = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var search = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var store, statuses, searchQuery, requests, responses, getHeaderCount, p, a, d;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store = _this6.context.store;
              statuses = ['pending', 'approved', 'declined'];
              searchQuery = search ? '&' + _qs2.default.stringify({ search: search }) : '';
              _context.prev = 3;
              requests = statuses.map(function (status) {
                return store.dispatch((0, _fetchM.fetchM)('/unit_reservation_refunds/?status=' + status + searchQuery, {
                  method: 'GET',
                  credentials: 'include',
                  headers: { 'Content-Type': 'application/json' }
                }));
              });
              _context.next = 7;
              return Promise.all(requests);

            case 7:
              responses = _context.sent;

              if (_this6._isMounted) {
                _context.next = 10;
                break;
              }

              return _context.abrupt('return');

            case 10:
              getHeaderCount = function getHeaderCount(res) {
                if (res && res.ok) {
                  var count = res.headers.get('m-data-count');
                  return count ? parseInt(count, 10) : 0;
                }
                return 0;
              };

              p = getHeaderCount(responses[0]);
              a = getHeaderCount(responses[1]);
              d = getHeaderCount(responses[2]);


              _this6.setState({
                pendingCount: p,
                approvedCount: a,
                declinedCount: d
              });
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context['catch'](3);

              if (_this6._isMounted) {
                // eslint-disable-next-line no-console
                console.error('Header count fetch failed', _context.t0);
              }

            case 20:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this6, [[3, 17]]);
    }));

    return function () {
      return _ref2.apply(this, arguments);
    };
  }();

  this.handleExportData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var store, query, res, errorText, blob, disposition, filename, url, a;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            store = _this6.context.store;
            query = (0, _url.decodeSearch)(_this6.props.location.search);
            _context2.prev = 2;
            _context2.next = 5;
            return _this6.setLoading(true);

          case 5:
            _context2.next = 7;
            return store.dispatch((0, _fetchM.fetchM)('/unit_reservation_refunds/export/?' + (0, _url.encodeSearch)(query), {
              method: 'GET',
              credentials: 'include'
            }));

          case 7:
            res = _context2.sent;

            if (res.ok) {
              _context2.next = 14;
              break;
            }

            _context2.next = 11;
            return res.text();

          case 11:
            errorText = _context2.sent;


            store.dispatch((0, _flash.flashErrorMessage)({
              message: errorText || 'Export failed (' + res.status + ')'
            }));

            return _context2.abrupt('return');

          case 14:
            _context2.next = 16;
            return res.blob();

          case 16:
            blob = _context2.sent;
            disposition = res.headers.get('Content-Disposition');
            filename = 'download.csv';


            if (disposition && disposition.includes('filename=')) {
              filename = disposition.split('filename=')[1].replace(/"/g, '');
            }

            url = window.URL.createObjectURL(blob);
            a = document.createElement('a');

            a.href = url;
            a.download = filename;

            document.body.appendChild(a);
            a.click();
            a.remove();
            window.URL.revokeObjectURL(url);
            _context2.next = 34;
            break;

          case 30:
            _context2.prev = 30;
            _context2.t0 = _context2['catch'](2);

            // eslint-disable-next-line no-console
            console.error('Header count fetch failed', _context2.t0);
            store.dispatch((0, _flash.flashErrorMessage)({
              message: _context2.t0 || 'Export failed'
            }));

          case 34:
            _context2.prev = 34;
            _context2.next = 37;
            return _this6.setLoading(false);

          case 37:
            return _context2.finish(34);

          case 38:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this6, [[2, 30, 34, 38]]);
  }));

  this.handleRefreshData = function () {
    var store = _this6.context.store;

    var query = (0, _url.decodeSearch)(_this6.props.location.search);

    query.page = 1;

    var statusMap = { 1: 'pending', 2: 'approved', 3: 'declined' };
    query.status = statusMap[_this6.state.currentTabID] || 'pending';

    _this6.props.fetchRefunds(query);
    _this6.fetchHeaderCounts(query.search || '');
    store.dispatch((0, _reactRouterRedux.replace)('/opportunities/manage_refunds/?' + (0, _url.encodeSearch)(query)));
  };

  this.handleAutoReload = function () {
    var autoReload = !_this6.state.autoReload;
    _this6.setState({ autoReload: autoReload }, function () {
      (0, _storage.setItem)(_config2.default.get('appName') + '.bookingManageAutoReload', autoReload ? 'true' : 'false');
      // if autoReload is disabled when there is an ongoing timeout then..
      // ..clear the timeout also.
      if (autoReload) {
        _this6.handleRefreshData();
        _this6.setRefreshDataTimeout();
      } else {
        if (_this6.timeout) {
          clearTimeout(_this6.timeout);
        }
        if (_this6.timeoutRefresh) {
          clearTimeout(_this6.timeoutRefresh);
        }
      }
    });
  };

  this.renderMenuTool = function () {
    var autoReload = _this6.state.autoReload;
    var _props2 = _this6.props,
        loading = _props2.loading,
        t = _props2.t;

    return _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { className: 'toolbar' },
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'app--listdata' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement('br', { className: 'large-hide' }),
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { style: { zIndex: 20 }, active: loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'center', width: 16 },
                    _react2.default.createElement(_semanticUiReact.Button, {
                      onClick: _this6.handleAutoReload,
                      compact: true,
                      size: 'tiny',
                      icon: autoReload ? { name: 'toggle on', color: 'green' } : { name: 'toggle off', color: 'red' },
                      content: t('Auto Refresh') + ' ' + (autoReload ? t('On') : t('Off'))
                    }),
                    _react2.default.createElement(_semanticUiReact.Button, {
                      color: 'blue',
                      onClick: _this6.handleRefreshData,
                      compact: true,
                      size: 'tiny',
                      icon: 'refresh',
                      content: t('Refresh Now')
                    }),
                    _react2.default.createElement(_semanticUiReact.Button, {
                      color: 'blue',
                      onClick: _this6.handleExportData,
                      compact: true,
                      size: 'tiny',
                      icon: 'download',
                      content: t('Export')
                    })
                  )
                )
              )
            )
          )
        )
      )
    );
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRouter.withRouter)((0, _reactRedux.connect)(Manage.mapStateToProps)(Manage)));

/***/ }),
/* 2358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _translation = __webpack_require__(4);

var _url = __webpack_require__(19);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _currencyMinor = __webpack_require__(326);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// components

// utils


var UnitReservationRefunds = function (_Component) {
  _inherits(UnitReservationRefunds, _Component);

  function UnitReservationRefunds(props) {
    _classCallCheck(this, UnitReservationRefunds);

    var _this = _possibleConstructorReturn(this, (UnitReservationRefunds.__proto__ || Object.getPrototypeOf(UnitReservationRefunds)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = _extends({}, UnitReservationRefunds.getPropsToState(props), {
      isConfirmOpen: false,
      confirmType: null,
      selectedRefund: null,
      isSubmitting: false
    });
    _this._isMounted = false;
    return _this;
  }

  _createClass(UnitReservationRefunds, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._isMounted = true;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._isMounted = false;
    }
    // eslint-disable-next-line react/no-deprecated

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.data !== this.props.data || nextProps.loading !== this.props.loading) {
        this.setState(UnitReservationRefunds.getPropsToState(nextProps));
      }
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          t = _props.t,
          loading = _props.loading;
      var _state = this.state,
          isConfirmOpen = _state.isConfirmOpen,
          confirmType = _state.confirmType,
          isSubmitting = _state.isSubmitting,
          selectedRefund = _state.selectedRefund;

      var isApprove = confirmType === 'approved';
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'app--listdata app--mblr' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'app--mblc' },
              _react2.default.createElement('br', { className: 'large-hide' }),
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { style: { zIndex: 20 }, active: this.props.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              this.state.data.length > 0 ? _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 2, className: 'equal height' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'manage-booking-list-row' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { className: 'manage-booking-list-col', width: 16 },
                    _react2.default.createElement(
                      _semanticUiReact.Table,
                      { celled: true, className: 'manage-bookings' },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Header,
                        { className: 'mobile-hide' },
                        _react2.default.createElement(
                          _semanticUiReact.Table.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { width: 4 },
                            t('Booking', { ns: _translation.TRANSLATION_FILES.screens })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { width: 3 },
                            t('Amount', { ns: _translation.TRANSLATION_FILES.screens })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { width: 3 },
                            t('Reason', { ns: _translation.TRANSLATION_FILES.screens })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { width: 3 },
                            t('Bank Info', { ns: _translation.TRANSLATION_FILES.screens })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { textAlign: 'center', collapsing: true },
                            t('Action', { ns: _translation.TRANSLATION_FILES.screens })
                          )
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Body,
                        null,
                        this.state.data.map(function (refund, idx) {
                          return _react2.default.createElement(
                            _semanticUiReact.Table.Row,
                            { key: refund.id || idx },
                            _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              null,
                              _react2.default.createElement(
                                'div',
                                { style: { lineHeight: '1.2' } },
                                _react2.default.createElement(
                                  'a',
                                  { href: '/opportunities/' + refund.opportunityID + '/', style: { color: '#4183c4', fontWeight: 'bold' } },
                                  refund.projectName
                                ),
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(
                                  'span',
                                  null,
                                  refund.purchaserName
                                )
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              { textAlign: 'left' },
                              _react2.default.createElement(_LoanAmount2.default, {
                                format: '0,000.00',
                                amount: (0, _currencyMinor.minorToMajor)(refund.amountMinor, refund.currencyCode)
                              })
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              null,
                              refund.reason || '-'
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              null,
                              _react2.default.createElement(
                                'div',
                                { style: { lineHeight: '1.3' } },
                                _react2.default.createElement(
                                  'b',
                                  null,
                                  refund.bankAccountName
                                ),
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(
                                  'span',
                                  { style: { fontFamily: 'monospace' } },
                                  refund.bankAccountNumber
                                ),
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(
                                  'small',
                                  { style: { color: 'grey' } },
                                  refund.bankName
                                )
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              { collapsing: true, textAlign: 'right' },
                              refund.status === 'pending' ? _react2.default.createElement(
                                _react2.default.Fragment,
                                null,
                                _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  {
                                    className: 'mobile-hide',
                                    floated: 'right',
                                    compact: true,
                                    size: 'mini',
                                    negative: true,
                                    onClick: function onClick(e) {
                                      return _this3.handleOpenConfirm(e, 'declined', refund);
                                    }
                                  },
                                  t('Decline', { ns: _translation.TRANSLATION_FILES.screens })
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  {
                                    className: 'mobile-hide',
                                    floated: 'right',
                                    compact: true,
                                    size: 'mini',
                                    color: 'green',
                                    onClick: function onClick(e) {
                                      return _this3.handleOpenConfirm(e, 'approved', refund);
                                    }
                                  },
                                  t('Complete', { ns: _translation.TRANSLATION_FILES.screens })
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  {
                                    className: 'large-hide small-hide tablet-hide',
                                    floated: 'right',
                                    compact: true,
                                    size: 'mini',
                                    negative: true,
                                    onClick: function onClick(e) {
                                      return _this3.handleOpenConfirm(e, 'declined', refund);
                                    }
                                  },
                                  t('Decline', { ns: _translation.TRANSLATION_FILES.screens })
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  {
                                    className: 'large-hide small-hide tablet-hide',
                                    floated: 'right',
                                    compact: true,
                                    size: 'mini',
                                    color: 'green',
                                    onClick: function onClick(e) {
                                      return _this3.handleOpenConfirm(e, 'approved', refund);
                                    }
                                  },
                                  t('Complete', { ns: _translation.TRANSLATION_FILES.screens })
                                )
                              ) :
                              /* Show status label if already processed */
                              _react2.default.createElement(
                                'div',
                                { style: { textAlign: 'center' } },
                                _react2.default.createElement(
                                  _semanticUiReact.Label,
                                  { color: refund.status === 'approved' ? 'green' : 'red', basic: true, size: 'mini' },
                                  refund.status === 'approved' ? t('Completed', { ns: _translation.TRANSLATION_FILES.screens }) : t('Declined', { ns: _translation.TRANSLATION_FILES.screens })
                                )
                              )
                            )
                          );
                        })
                      )
                    )
                  )
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Item,
                      { style: {} },
                      _react2.default.createElement(
                        _semanticUiReact.Item.Content,
                        null,
                        !this.props.loading ? _react2.default.createElement(
                          _semanticUiReact.Segment,
                          { textAlign: 'center' },
                          _react2.default.createElement(
                            'p',
                            null,
                            t('No pending bookings found.', { ns: _translation.TRANSLATION_FILES.translation })
                          )
                        ) : ''
                      )
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            open: isConfirmOpen,
            onClose: this.handleCloseConfirm,
            size: isApprove ? 'mini' : 'tiny',
            closeIcon: true
          },
          _react2.default.createElement(
            _semanticUiReact.Modal.Header,
            null,
            isApprove ? t('Approve refund request', { ns: _translation.TRANSLATION_FILES.translation }) : t('Reject refund request', { ns: _translation.TRANSLATION_FILES.translation })
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            isApprove ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'p',
                { className: 'confirm-approve-text' },
                t('Are you sure you want to approve this refund?', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(
                'p',
                { className: 'approve-info-text', style: { color: '#555555', fontSize: '0.9rem' } },
                t('Once approved, refunds will be processed for all received payments.', { ns: _translation.TRANSLATION_FILES.translation })
              )
            ) : _react2.default.createElement(
              'div',
              { className: 'reject-refund-wrapper' },
              _react2.default.createElement(
                'p',
                { className: 'confirm-reject-text' },
                t('Are you sure you want to reject this refund request?', { ns: _translation.TRANSLATION_FILES.screens })
              ),
              _react2.default.createElement(
                'div',
                { style: { marginTop: '1rem' } },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', className: 'info-icon', style: { color: '#0288D1', marginRight: '6px' } }),
                _react2.default.createElement(
                  'span',
                  { className: 'reject-info-text', style: { color: '#555555', fontSize: '0.9rem' } },
                  t('A notification will be sent to the agent and buyer upon confirmation.', { ns: _translation.TRANSLATION_FILES.translation })
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(
              _semanticUiReact.Button,
              { basic: true, onClick: this.handleCloseConfirm },
              t('Cancel', { ns: _translation.TRANSLATION_FILES.translation })
            ),
            _react2.default.createElement(
              _semanticUiReact.Button,
              { color: 'teal', onClick: this.handleConfirmAction, loading: isSubmitting, disabled: loading || isSubmitting },
              t('Confirm', { ns: _translation.TRANSLATION_FILES.translation })
            )
          )
        )
      );
    }
  }]);

  return UnitReservationRefunds;
}(_react.Component);

UnitReservationRefunds.contextTypes = {
  store: _propTypes2.default.object
};
UnitReservationRefunds.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      settings: _propTypes2.default.shape({
        notesExternalPlaceholder: _propTypes2.default.string
      })
    })
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  loading: _propTypes2.default.bool,
  refundToken: _propTypes2.default.string,
  fetchRefund: _propTypes2.default.func,
  fetchHeaderCounts: _propTypes2.default.func,
  onUpdateOpportunity: _propTypes2.default.func,
  pendingCancelUnitsTab: _propTypes2.default.bool
};

UnitReservationRefunds.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

UnitReservationRefunds.getPropsToState = function (props) {
  return {
    data: props.data || [],
    loading: props.loading || false
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleOpenConfirm = function (e, type, refund) {
    e.stopPropagation();
    _this4.setState({
      isConfirmOpen: true,
      confirmType: type,
      selectedRefund: refund
    });
  };

  this.handleCloseConfirm = function () {
    _this4.setState({ isConfirmOpen: false, confirmType: null });
  };

  this.handleConfirmAction = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _props2, refundToken, t, fetchRefund, fetchHeaderCounts, onUpdateOpportunity, _state2, confirmType, selectedRefund, store, url, action, response, opportunityStatus, query;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _props2 = _this4.props, refundToken = _props2.refundToken, t = _props2.t, fetchRefund = _props2.fetchRefund, fetchHeaderCounts = _props2.fetchHeaderCounts, onUpdateOpportunity = _props2.onUpdateOpportunity;
            _state2 = _this4.state, confirmType = _state2.confirmType, selectedRefund = _state2.selectedRefund;
            store = _this4.context.store;

            if (selectedRefund) {
              _context.next = 5;
              break;
            }

            return _context.abrupt('return');

          case 5:
            url = '/unit_reservation_refunds/' + selectedRefund.id + '/status/';

            _this4.setState({ isSubmitting: true });

            _context.prev = 7;
            action = (0, _fetchM.fetchM)(url, {
              method: 'PUT',
              credentials: 'include',
              headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': refundToken
              },
              body: JSON.stringify({
                status: confirmType,
                rejectionReason: '-',
                amountMinorRefunded: confirmType === 'approved' ? selectedRefund ? selectedRefund.amountMinor : 0 : 0
              })
            });
            _context.next = 11;
            return store.dispatch(action);

          case 11:
            response = _context.sent;


            if (response && response.ok) {
              // Update local state immediately to show the new status
              _this4.setState(function (prevState) {
                return {
                  data: prevState.data.map(function (refund) {
                    return refund.id === selectedRefund.id ? _extends({}, refund, { status: confirmType }) : refund;
                  })
                };
              });

              store.dispatch((0, _flash.flashSuccessMessage)({
                header: t('Success', { ns: _translation.TRANSLATION_FILES.constants }),
                message: t('Refund status updated successfully', { ns: _translation.TRANSLATION_FILES.translation })
              }));

              // Update opportunity status based on refund decision
              if (onUpdateOpportunity) {
                opportunityStatus = confirmType === 'approved' ? 'refunded' : 'refund_declined';

                onUpdateOpportunity(opportunityStatus, '', selectedRefund.opportunityID);
              }

              query = (0, _url.decodeSearch)(_this4.props.location.search);

              if (fetchRefund) {
                fetchRefund(query);
              }
              if (fetchHeaderCounts) {
                fetchHeaderCounts(query.search || '');
              }

              _this4.handleCloseConfirm();
            }
            _context.next = 18;
            break;

          case 15:
            _context.prev = 15;
            _context.t0 = _context['catch'](7);

            store.dispatch((0, _flash.flashErrorMessage)({
              header: t('Error', { ns: _translation.TRANSLATION_FILES.constants }),
              message: t('Error updating refund status', { ns: _translation.TRANSLATION_FILES.translation })
            }));

          case 18:
            _context.prev = 18;

            if (_this4._isMounted) {
              _this4.setState({ isSubmitting: false });
            }
            return _context.finish(18);

          case 21:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this4, [[7, 15, 18, 21]]);
  }));
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRouter.withRouter)(UnitReservationRefunds));

/***/ }),
/* 2359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Manage = __webpack_require__(2357);

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Manage).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(9);

var _List = __webpack_require__(2356);

var _List2 = _interopRequireDefault(_List);

var _Exports = __webpack_require__(2355);

var _Exports2 = _interopRequireDefault(_Exports);

var _ManageRefunds = __webpack_require__(2359);

var _ManageRefunds2 = _interopRequireDefault(_ManageRefunds);

var _Overview = __webpack_require__(2365);

var _Overview2 = _interopRequireDefault(_Overview);

var _checkChanges = __webpack_require__(61);

var _url = __webpack_require__(19);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Opportunities = function (_Component) {
  _inherits(Opportunities, _Component);

  function Opportunities(props) {
    _classCallCheck(this, Opportunities);

    var _this = _possibleConstructorReturn(this, (Opportunities.__proto__ || Object.getPrototypeOf(Opportunities)).call(this, props));

    _this.state = {
      token: null,
      loading: 0,
      data: {},
      refundToken: '',
      paymentData: null
    };
    return _this;
  }

  _createClass(Opportunities, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      var auth = this.props.auth;

      var query = (0, _url.decodeSearch)(this.props.location.search);
      if (this.props.params.id) {
        this.fetchBooking();
        this.fetchPaymentDetails(this.props.params.id);

        // Check if we are already on the payment section
        if (query.section === 'payment') {
          this.fetchPaymentDetails();
        }

        if (query.section === 'documents') {
          this.fetchDocument();
        }
      }
      if (auth.isHeadquarters || auth.isAdminBasic) {
        this.fetchRefunds(_extends({}, query, { status: 'pending' }));
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.params.id && nextProps.params.id !== this.props.params.id) {
        this.setState({ paymentData: null });
        this.fetchBooking(nextProps.params.id);
        this.fetchPaymentDetails(nextProps.params.id);
      }

      var oldQuery = (0, _url.decodeSearch)(this.props.location.search);
      var nextQuery = (0, _url.decodeSearch)(nextProps.location.search);

      if (nextQuery.section === 'documents' && oldQuery.section !== 'documents') {
        this.fetchDocument();
      }

      if (nextQuery.section === 'payment' && oldQuery.section !== 'payment') {
        this.fetchPaymentDetails();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        if (!_this2.mounted) {
          res(state);return;
        }
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var on = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        if (!_this3.mounted) {
          res();return;
        }
        _this3.setState(function (prev) {
          return {
            loading: on ? prev.loading + 1 : Math.max(0, prev.loading - 1)
          };
        }, res);
      });
    }
  }, {
    key: 'fetchBooking',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var store, bookingId, res, data, token;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                bookingId = id || this.props.params.id;

                if (!(!bookingId || bookingId === 'undefined')) {
                  _context.next = 4;
                  break;
                }

                return _context.abrupt('return');

              case 4:
                _context.prev = 4;
                _context.next = 7;
                return this.setLoading(true);

              case 7:
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/opportunity/' + bookingId + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context.sent;

                if (!(res && res.ok)) {
                  _context.next = 17;
                  break;
                }

                _context.next = 13;
                return res.json();

              case 13:
                data = _context.sent;
                token = res.headers.get('X-Csrf-Token');
                _context.next = 17;
                return this.setComponentState({ data: data, token: token });

              case 17:
                _context.next = 22;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);

              case 22:
                _context.prev = 22;
                _context.next = 25;
                return this.setLoading(false);

              case 25:
                return _context.finish(22);

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 19, 22, 26]]);
      }));

      function fetchBooking(_x3) {
        return _ref.apply(this, arguments);
      }

      return fetchBooking;
    }()
  }, {
    key: 'fetchPaymentDetails',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(nextId) {
        var store, bookingId, res, token1, paymentData, res2, token2, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                bookingId = nextId || this.props.params.id;

                if (bookingId) {
                  _context2.next = 4;
                  break;
                }

                return _context2.abrupt('return');

              case 4:
                _context2.prev = 4;
                _context2.next = 7;
                return this.setLoading(true);

              case 7:
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/unit_reservation_tokens/opportunity/' + bookingId + '/', {
                  method: 'GET',
                  credentials: 'include',
                  ignoreNotFound: true,
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context2.sent;

                if (!res.ok) {
                  _context2.next = 23;
                  break;
                }

                token1 = res.headers.get('X-Csrf-Token');
                _context2.next = 14;
                return res.json();

              case 14:
                paymentData = _context2.sent;


                if (this.mounted) {
                  this.setState({ unitReservationToken: token1, paymentData: paymentData });
                }

                if (!(paymentData && paymentData.id)) {
                  _context2.next = 21;
                  break;
                }

                _context2.next = 19;
                return store.dispatch((0, _fetchM.fetchM)('/unit_reservation_tokens/' + paymentData.id + '/', {
                  method: 'GET',
                  credentials: 'include',
                  ignoreNotFound: true,
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 19:
                res2 = _context2.sent;


                if (res2.ok) {
                  token2 = res2.headers.get('X-Csrf-Token');

                  if (this.mounted) {
                    this.setState({ TokenPaymentCSRF: token2 });
                  }
                }

              case 21:
                _context2.next = 31;
                break;

              case 23:
                if (!(res.status === 404)) {
                  _context2.next = 27;
                  break;
                }

                if (this.mounted) {
                  this.setState({ paymentData: null, TokenPaymentCSRF: null });
                }
                _context2.next = 31;
                break;

              case 27:
                _context2.next = 29;
                return res.text();

              case 29:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 31:
                _context2.next = 35;
                break;

              case 33:
                _context2.prev = 33;
                _context2.t0 = _context2['catch'](4);

              case 35:
                _context2.prev = 35;
                _context2.next = 38;
                return this.setLoading(false);

              case 38:
                return _context2.finish(35);

              case 39:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 33, 35, 39]]);
      }));

      function fetchPaymentDetails(_x4) {
        return _ref2.apply(this, arguments);
      }

      return fetchPaymentDetails;
    }()
  }, {
    key: 'fetchDocument',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var store, bookingId, res, documentData;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                store = this.context.store;
                bookingId = this.props.params.id;

                if (bookingId) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt('return');

              case 4:
                _context3.prev = 4;
                _context3.next = 7;
                return this.setLoading(true);

              case 7:
                _context3.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/shared_medias/?parent_type=opportunity&parent_id=' + bookingId, {
                  method: 'GET',
                  credentials: 'include',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context3.sent;

                if (!res.ok) {
                  _context3.next = 15;
                  break;
                }

                _context3.next = 13;
                return res.json();

              case 13:
                documentData = _context3.sent;

                if (this.mounted) {
                  this.setState({ documentData: documentData });
                }

              case 15:
                _context3.next = 20;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t0 = _context3['catch'](4);

                store.dispatch((0, _flash.flashErrorMessage)('Error fetching document infomation'));

              case 20:
                _context3.prev = 20;
                _context3.next = 23;
                return this.setLoading(false);

              case 23:
                return _context3.finish(20);

              case 24:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 17, 20, 24]]);
      }));

      function fetchDocument() {
        return _ref3.apply(this, arguments);
      }

      return fetchDocument;
    }()
  }, {
    key: 'handleManageOpportunity',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(status) {
        var reason = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var opportunityId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var cancellationType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
        var undoCancellation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

        var store, bookingId, token, res, bodyPayload, _res, errorText;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                store = this.context.store;
                bookingId = opportunityId || this.props.params.id;
                token = this.state.token;

                if (!(opportunityId && opportunityId !== this.props.params.id)) {
                  _context4.next = 14;
                  break;
                }

                _context4.prev = 4;
                _context4.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/opportunity/' + opportunityId + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context4.sent;

                if (res && res.ok) {
                  token = res.headers.get('X-Csrf-Token');
                }
                _context4.next = 14;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](4);

                console.error('Failed to fetch CSRF token for opportunity:', _context4.t0);

              case 14:
                bodyPayload = {
                  sr_status: status
                };

                if (status === 'pending_cancellation') {
                  bodyPayload.sr_cancellation_reason = reason || '-';
                  bodyPayload.sr_cancellation_at = new Date().toISOString();
                  // CPI-1226: the scenario picked, 'buyer' or 'error'; omitted when absent, never sent empty.
                  if (cancellationType) bodyPayload.sr_cancellation_type = cancellationType;
                } else if (undoCancellation) {
                  bodyPayload.sr_cancellation_reason = '';
                  bodyPayload.sr_cancellation_type = '';
                }
                _context4.prev = 16;
                _context4.next = 19;
                return this.setLoading(true);

              case 19:
                _context4.next = 21;
                return store.dispatch((0, _fetchM.fetchM)('/opportunity/' + bookingId + '/manage/', {
                  method: 'PUT',
                  credentials: 'include',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': token
                  },
                  body: JSON.stringify(bodyPayload)
                }));

              case 21:
                _res = _context4.sent;

                if (!_res.ok) {
                  _context4.next = 28;
                  break;
                }

                if (!this.props.params.id) {
                  _context4.next = 26;
                  break;
                }

                _context4.next = 26;
                return this.fetchBooking();

              case 26:
                _context4.next = 32;
                break;

              case 28:
                _context4.next = 30;
                return _res.text();

              case 30:
                errorText = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: errorText }));

              case 32:
                _context4.next = 37;
                break;

              case 34:
                _context4.prev = 34;
                _context4.t1 = _context4['catch'](16);

                Bugsnag.notifyException(_context4.t1);

              case 37:
                _context4.prev = 37;
                _context4.next = 40;
                return this.setLoading(false);

              case 40:
                return _context4.finish(37);

              case 41:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 11], [16, 34, 37, 41]]);
      }));

      function handleManageOpportunity(_x5) {
        return _ref4.apply(this, arguments);
      }

      return handleManageOpportunity;
    }()
  }, {
    key: 'fetchRefunds',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(q) {
        var silentLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var store, query, queryString, res, refundData, nextToken;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (silentLoad) {
                  _context5.next = 3;
                  break;
                }

                _context5.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;

                // 1. EDIT: Ensure 'pending' is the default if no status is provided

                query = Object.assign({ status: 'pending' }, q);


                if (!query.page || query.page <= 0) query.page = 1;

                _context5.prev = 6;
                queryString = _qs2.default.stringify(query) ? '?' + _qs2.default.stringify(query) : '';
                _context5.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/unit_reservation_refunds/' + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: _extends({
                    'Content-Type': 'application/json'
                  }, this.state.refundToken ? { 'X-Csrf-Token': this.state.refundToken } : {})
                }));

              case 10:
                res = _context5.sent;

                if (!res.ok) {
                  _context5.next = 17;
                  break;
                }

                _context5.next = 14;
                return res.json();

              case 14:
                refundData = _context5.sent;
                nextToken = res.headers.get('X-Csrf-Token');


                if (this.mounted) {
                  this.setState({
                    refundData: refundData || [],
                    refundToken: nextToken || this.state.refundToken,
                    refundCount: parseInt(res.headers.get('M-Data-count'), 10) || 0,
                    refundLimit: parseInt(res.headers.get('M-Data-limit'), 10) || 0,
                    refundOffset: parseInt(res.headers.get('M-Data-offset'), 10) || 0
                  });
                }

              case 17:
                _context5.next = 22;
                break;

              case 19:
                _context5.prev = 19;
                _context5.t0 = _context5['catch'](6);

                Bugsnag.notifyException(_context5.t0);

              case 22:
                _context5.prev = 22;

                if (silentLoad) {
                  _context5.next = 26;
                  break;
                }

                _context5.next = 26;
                return this.setLoading(false);

              case 26:
                return _context5.finish(22);

              case 27:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[6, 19, 22, 27]]);
      }));

      function fetchRefunds(_x10) {
        return _ref5.apply(this, arguments);
      }

      return fetchRefunds;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this4 = this;

      var childProp = {
        token: this.state.token,
        TokenPaymentCSRF: this.state.TokenPaymentCSRF,
        unitReservationToken: this.state.unitReservationToken,
        refundToken: this.state.refundToken,
        loading: this.state.loading > 0,
        paymentData: this.state.paymentData,
        documentData: this.state.documentData,
        refundData: this.state.refundData,
        refundCount: this.state.refundCount,
        refundLimit: this.state.refundLimit,
        refundOffset: this.state.refundOffset,
        data: this.state.data,
        fetchBooking: function fetchBooking() {
          return _this4.fetchBooking();
        },
        fetchPaymentDetails: function fetchPaymentDetails() {
          return _this4.fetchPaymentDetails();
        },
        fetchDocument: function fetchDocument() {
          return _this4.fetchDocument();
        },
        onUpdateOpportunity: function onUpdateOpportunity(status, reason, targetId, cancellationType, undoCancellation) {
          return _this4.handleManageOpportunity(status, reason, targetId, cancellationType, undoCancellation);
        },
        fetchRefunds: function fetchRefunds(q) {
          return _this4.fetchRefunds(q);
        }
      };
      if (this.props.params && this.props.params.id) {
        childProp.data = this.state.data;
        childProp.routeParamsID = this.props.params.id || '';
      }
      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, childProp);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Opportunities;
}(_react.Component);

Opportunities.propTypes = {
  auth: _propTypes2.default.shape({
    isDeveloperSupervisor: _propTypes2.default.bool,
    isDeveloperSalesManager: _propTypes2.default.bool,
    isDeveloperSalesAdmin: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isAdmin: _propTypes2.default.bool
  }),
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  })
};
Opportunities.contextTypes = {
  store: _propTypes2.default.object
};

Opportunities.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

Opportunities.List = _List2.default;
Opportunities.ManageRefunds = _ManageRefunds2.default;
Opportunities.Exports = _Exports2.default;
Opportunities.Overview = (0, _checkChanges.checkChanges)(_Overview2.default);
exports.default = (0, _reactRedux.connect)(Opportunities.mapStateToProps)(Opportunities);

/***/ }),
/* 2361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchActivityLogs = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var fetchActivityLogs = exports.fetchActivityLogs = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(opportunityId) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$page = _ref2.page,
        page = _ref2$page === undefined ? 1 : _ref2$page,
        _ref2$perPage = _ref2.perPage,
        perPage = _ref2$perPage === undefined ? 20 : _ref2$perPage;

    var url, params, session, token, res, message;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = new URL(_config2.default.get('logApiURL') + '/api/v1/activity-logs');
            params = { entity_type: 'opportunity', entity_id: opportunityId, per_page: perPage, page: page };

            url.search = new URLSearchParams(params).toString();

            _context.next = 5;
            return _auth2.default.currentSession();

          case 5:
            session = _context.sent;
            token = session.getIdToken().getJwtToken();
            _context.next = 9;
            return fetch(url, {
              headers: { Authorization: 'Bearer ' + token },
              mode: 'cors'
            });

          case 9:
            res = _context.sent;

            if (res.ok) {
              _context.next = 16;
              break;
            }

            _context.next = 13;
            return res.text();

          case 13:
            message = _context.sent;

            Bugsnag.notify('Failed to GET ' + url + ': ' + message);
            throw new Error(message || 'Failed to fetch activity logs');

          case 16:
            return _context.abrupt('return', res.json());

          case 17:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function fetchActivityLogs(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _translation = __webpack_require__(4);

var _TimelineLog = __webpack_require__(1059);

var _TimelineLog2 = _interopRequireDefault(_TimelineLog);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var DEFAULT_PAGINATION = {
  current_page: 1,
  per_page: 20,
  total_count: 0,
  total_pages: 1,
  has_next: false,
  has_prev: false
};

var ActivityLog = function (_Component) {
  _inherits(ActivityLog, _Component);

  function ActivityLog(props) {
    _classCallCheck(this, ActivityLog);

    var _this = _possibleConstructorReturn(this, (ActivityLog.__proto__ || Object.getPrototypeOf(ActivityLog)).call(this, props));

    _this.loadLogs = function (opportunityId) {
      var pageNumber = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      _this.setState({ loading: true, current_page: pageNumber });

      fetchActivityLogs(opportunityId, { page: pageNumber, perPage: 20 }).then(function (res) {
        if (_this.mounted) {
          _this.setState({
            logs: res.activity_logs || [],
            pagination: res.pagination || DEFAULT_PAGINATION,
            loading: false
          });
        }
      }).catch(function (err) {
        console.error('Error fetching logs:', err);
        if (_this.mounted) {
          _this.setState({
            loading: false,
            logs: [],
            pagination: DEFAULT_PAGINATION
          });
        }
      });
    };

    _this.handlePageChange = function (targetPageNumber) {
      var id = _this.props.id;
      var loading = _this.state.loading;


      if (loading) return;

      _this.loadLogs(id, targetPageNumber);
    };

    _this.state = {
      logs: [],
      loading: false,
      current_page: 1,
      pagination: DEFAULT_PAGINATION
    };
    return _this;
  }

  _createClass(ActivityLog, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      var id = this.props.id;


      if (id) {
        this.loadLogs(id);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props = this.props,
          id = _props.id,
          tabID = _props.tabID;

      var idJustLoaded = !prevProps.id && id;
      var userSwitchedToThisTab = prevProps.tabID !== tabID && tabID === 6;

      if ((idJustLoaded || userSwitchedToThisTab) && id) {
        this.loadLogs(id);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          logs = _state.logs,
          _state$pagination = _state.pagination,
          pagination = _state$pagination === undefined ? DEFAULT_PAGINATION : _state$pagination,
          loading = _state.loading,
          current_page = _state.current_page;


      var logsToRender = Array.isArray(logs) && logs.length > 0 ? logs : [];

      var limit = pagination == null ? 20 : pagination.per_page;
      var offset = ((current_page || 1) - 1) * limit;
      var dataSize = logsToRender.length;
      var count = pagination == null ? 0 : pagination.total_count;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(_TimelineLog2.default, { activityLog: logsToRender, isFullWidth: true }),
            _react2.default.createElement(_PageNav2.default, {
              loading: loading,
              currentPage: current_page,
              count: count,
              limit: limit,
              offset: offset,
              dataSize: dataSize,
              isCursorPagination: false,
              onChange: this.handlePageChange
            })
          )
        )
      );
    }
  }]);

  return ActivityLog;
}(_react.Component);

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(ActivityLog);

/***/ }),
/* 2362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _documentType = __webpack_require__(1042);

var _documentType2 = _interopRequireDefault(_documentType);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UploadSharedMedia = function (_Component) {
  _inherits(UploadSharedMedia, _Component);

  function UploadSharedMedia(props) {
    _classCallCheck(this, UploadSharedMedia);

    var _this = _possibleConstructorReturn(this, (UploadSharedMedia.__proto__ || Object.getPrototypeOf(UploadSharedMedia)).call(this, props));

    _this.getIconName = function (fileName) {
      var ext = fileName.split('.').pop().toLowerCase();

      if (['jpg', 'jpeg', 'png', 'webp', 'gif', 'bmp', 'tif', 'tiff'].includes(ext)) {
        return 'file image outline';
      }

      if (['doc', 'docx', 'rtf', 'odt'].includes(ext)) {
        return 'file word outline';
      }

      if (['xls', 'xlsx', 'csv', 'ods'].includes(ext)) {
        return 'file excel outline';
      }

      if (['ppt', 'pptx'].includes(ext)) {
        return 'file powerpoint outline';
      }

      if (ext === 'txt') {
        return 'file text outline';
      }

      if (ext === 'pdf') {
        return 'file pdf outline';
      }

      return 'file alternate outline';
    };

    _this.handleSubmit = function (event) {
      event.preventDefault();
      if (_this.state.uploads.length > 0) {
        // Package files and names together for the parent component to process
        var payload = _this.state.uploads.map(function (upload, idx) {
          return {
            file: upload.file,
            fileName: _this.state.names[idx] || upload.file.name,
            fileType: _this.state.types[idx]
          };
        });

        if (_this.props.onSubmit) {
          _this.props.onSubmit(event, { files: payload });
        }
      }
    };

    _this.handleOnChange = function () {
      var files = Array.prototype.slice.call(_this.uploadFiles.files);
      _this.uploadFiles.value = null;

      files.forEach(function (file) {
        var lastDot = file.name.lastIndexOf('.');
        var cleanName = lastDot > 0 ? file.name.substring(0, lastDot) : file.name;

        _this.setState(function (prev) {
          return {
            uploads: [].concat(_toConsumableArray(prev.uploads), [{ file: file, name: file.name }]),
            names: [].concat(_toConsumableArray(prev.names), [cleanName]),
            types: [].concat(_toConsumableArray(prev.types), ['other_documents'])
          };
        }, function () {
          _this.handleCheckChanges();
        });
      });
    };

    _this.handleRemove = function (event, idx) {
      event.preventDefault();
      _this.setState(function (prev) {
        return {
          uploads: prev.uploads.filter(function (_, i) {
            return i !== idx;
          }),
          names: prev.names.filter(function (_, i) {
            return i !== idx;
          }),
          types: prev.types.filter(function (_, i) {
            return i !== idx;
          })
        };
      });
    };

    _this.handleInputChange = function (e, _ref, idx) {
      var value = _ref.value;

      _this.setState(function (prev) {
        var names = [].concat(_toConsumableArray(prev.names));
        names[idx] = value;
        return { names: names };
      });
    };

    _this.handleTypeChange = function (e, _ref2, idx) {
      var value = _ref2.value;

      _this.setState(function (prev) {
        var types = [].concat(_toConsumableArray(prev.types));
        types[idx] = value;
        return { types: types };
      });
    };

    _this.state = {
      loading: false,
      uploads: [],
      names: [],
      types: [],
      hasChanges: false
    };
    return _this;
  }

  _createClass(UploadSharedMedia, [{
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          return res(loading);
        });
      });
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      var _this3 = this;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true }, function () {
          if (_this3.props.onChange) _this3.props.onChange(true);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          uploads = _state.uploads,
          names = _state.names,
          loading = _state.loading;
      var t = this.props.t;

      var translatedOptions = _documentType2.default.map(function (option) {
        return _extends({}, option, {
          text: t(option.text, { ns: _translation.TRANSLATION_FILES.translation })
        });
      });
      return _react2.default.createElement(
        'form',
        {
          encType: 'multipart/form-data',
          onSubmit: this.handleSubmit,
          ref: function ref(_ref4) {
            _this4.form = _ref4;
          }
        },
        _react2.default.createElement('input', {
          ref: function ref(_ref3) {
            _this4.uploadFiles = _ref3;
          },
          type: 'file',
          onChange: this.handleOnChange,
          accept: '.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.rtf,.odt,.ods,.txt,.csv,.jpg,.jpeg,.png,.webp,.gif,.bmp,.tif,.tiff',
          multiple: true,
          style: { display: 'none' }
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 'equal' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_semanticUiReact.Button, {
                fluid: true,
                compact: true,
                primary: true,
                type: 'button',
                icon: 'add',
                content: t('Select Files', { ns: _translation.TRANSLATION_FILES.translation }),
                onClick: function onClick() {
                  return _this4.uploadFiles.click();
                },
                disabled: loading
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_semanticUiReact.Button, {
                fluid: true,
                compact: true,
                type: 'submit',
                positive: true,
                content: t('Upload All', { ns: _translation.TRANSLATION_FILES.translation }),
                icon: 'cloud upload',
                loading: loading,
                disabled: uploads.length < 1 || loading
              })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { stackable: true, columns: 1, style: { marginTop: '1em' } },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { active: loading, inverted: true, style: { zIndex: 20 } },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              null,
              'Preparing Uploads'
            )
          ),
          uploads.map(function (upload, idx) {
            return _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { key: idx },
              _react2.default.createElement(
                _semanticUiReact.Segment,
                { padded: true, secondary: true },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 1 },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: _this4.getIconName(upload.file.name), size: 'large' })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 7 },
                    _react2.default.createElement(_semanticUiReact.Input, {
                      placeholder: 'Display Name',
                      fluid: true,
                      value: names[idx],
                      onChange: function onChange(e, data) {
                        return _this4.handleInputChange(e, data, idx);
                      }
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 6 },
                    _react2.default.createElement(_semanticUiReact.Select, {
                      placeholder: 'Select Type',
                      fluid: true,
                      selection: true,
                      options: translatedOptions,
                      value: _this4.state.types[idx],
                      onChange: function onChange(e, data) {
                        return _this4.handleTypeChange(e, data, idx);
                      }
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 2 },
                    _react2.default.createElement(_semanticUiReact.Button, {
                      type: 'button',
                      icon: 'delete',
                      fluid: true,
                      compact: true,
                      color: 'red',
                      negative: true,
                      onClick: function onClick(e) {
                        return _this4.handleRemove(e, idx);
                      }
                    })
                  )
                )
              )
            );
          })
        )
      );
    }
  }]);

  return UploadSharedMedia;
}(_react.Component);

UploadSharedMedia.propTypes = {
  onSubmit: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  t: _propTypes2.default.func
};
UploadSharedMedia.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(UploadSharedMedia);

/***/ }),
/* 2363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _translation = __webpack_require__(4);

var _SharedNote = __webpack_require__(1032);

var _SharedNote2 = _interopRequireDefault(_SharedNote);

var _sourceOfFinanceStatuses = __webpack_require__(584);

var _booking = __webpack_require__(129);

var _booking2 = _interopRequireDefault(_booking);

var _UCBGridDivider = __webpack_require__(574);

var _UCBGridDivider2 = _interopRequireDefault(_UCBGridDivider);

var _AttachmentItem = __webpack_require__(1004);

var _AttachmentItem2 = _interopRequireDefault(_AttachmentItem);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Info = function (_Component) {
  _inherits(Info, _Component);

  _createClass(Info, null, [{
    key: 'getDerivedStateFromProps',

    // eslint-disable-next-line react/no-unused-prop-types
    value: function getDerivedStateFromProps(props) {
      return Info.getPropsToState(props);
    }
  }]);

  function Info(props) {
    _classCallCheck(this, Info);

    var _this = _possibleConstructorReturn(this, (Info.__proto__ || Object.getPrototypeOf(Info)).call(this, props));

    _initialiseProps.call(_this);

    var state = Info.getPropsToState(props);
    _this.state = _extends({}, state, {
      formAttachments: [],
      formAttachmentsLoading: false,
      formAttachmentsError: null
    });
    _this.refOpportunityNote = null;
    return _this;
  }

  _createClass(Info, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      this.fetchFormAttachments();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var prevID = prevProps.routeParamsID;
      var currID = this.props.routeParamsID;
      if (currID && currID !== prevID) {
        this.fetchFormAttachments();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          routeParamsID = _props.routeParamsID;
      var _state = this.state,
          data = _state.data,
          formAttachments = _state.formAttachments,
          formAttachmentsLoading = _state.formAttachmentsLoading,
          formAttachmentsError = _state.formAttachmentsError;

      var sourceOfFinanceStatus = data.sr_source_of_finance && _sourceOfFinanceStatuses.SOURCE_OF_FINANCE_STATUS_MAP[data.sr_source_of_finance] ? t(_sourceOfFinanceStatuses.SOURCE_OF_FINANCE_STATUS_MAP[data.sr_source_of_finance].text, { ns: _translation.TRANSLATION_FILES.constants }) : 'N/A';
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 10 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 12 },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'uc-grid-title-row' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    t('Booking Details', { ns: _translation.TRANSLATION_FILES.screens })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'uc-grid-detail-row' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 3 },
                    t('Booking ID', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 5 },
                    _react2.default.createElement(
                      'span',
                      null,
                      data.sr_code || '-'
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 3 },
                    t('Source of Finance', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 5 },
                    _react2.default.createElement(
                      'span',
                      null,
                      sourceOfFinanceStatus
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'uc-grid-detail-row' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 3 },
                    t('Project', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 13 },
                    _react2.default.createElement(
                      'span',
                      null,
                      data.project_name
                    )
                  )
                ),
                _react2.default.createElement(_UCBGridDivider2.default, null),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'uc-grid-detail-row' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 3 },
                    t('Assigned Agent', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 5 },
                    _react2.default.createElement(
                      'span',
                      null,
                      data.assign_to_name || 'N/A'
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 3 },
                    t('Agency', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 5 },
                    _react2.default.createElement(
                      'span',
                      null,
                      data.assign_to_agency_name || 'N/A'
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'uc-grid-detail-row' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 3 },
                    t('Agent Contact', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 5 },
                    _react2.default.createElement(
                      'span',
                      null,
                      data.assign_to_mobile_prefix,
                      ' ',
                      data.assign_to_mobile || 'N/A'
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 3 },
                    t('Agent Email', { ns: _translation.TRANSLATION_FILES.screens })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 5 },
                    _react2.default.createElement(
                      'span',
                      null,
                      data.assign_to_email || 'N/A'
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 4 },
              _react2.default.createElement(_SharedNote2.default, {
                parentType: 'opportunity',
                parentID: routeParamsID || data.id || ''
                // defaultPrivacy={(data && data.project && data.project.bnDefaultPrivacy) || ''}
                , hasEditAccess: true
                // isDisabled={this.state.editingBooking}
                , setRef: this.setRefOpportunityNote
                // token={this.props.token}
                // onExpand={this.handleBookingNotesExpand}
                // showExpand={!this.props.isMobile}
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'uc-grid-title-row' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    t('Attachments', { ns: _translation.TRANSLATION_FILES.screens })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    formAttachmentsLoading ? _react2.default.createElement(_semanticUiReact.Loader, { active: true, inline: 'centered', size: 'small' }) : formAttachmentsError ? _react2.default.createElement(
                      'span',
                      { style: { color: '#db2828' } },
                      t('Failed to load attachments', { ns: _translation.TRANSLATION_FILES.screens })
                    ) : formAttachments.length === 0 ? _react2.default.createElement(
                      'span',
                      { className: 'attachment-empty-text' },
                      t('No attachments found', { ns: _translation.TRANSLATION_FILES.screens })
                    ) : _react2.default.createElement(
                      'div',
                      { className: 'attachment-list' },
                      formAttachments.map(function (att) {
                        return _react2.default.createElement(_AttachmentItem2.default, {
                          key: att.id,
                          fileName: att.fileName || t('Attachment', { ns: _translation.TRANSLATION_FILES.screens }),
                          downloadUrl: _this2.getAttachmentUrl(att.id, att.fileName)
                        });
                      })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Info;
}(_react.Component);

Info.contextTypes = {
  store: _propTypes2.default.object
};
Info.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  loading: _propTypes2.default.bool,
  routeParamsID: _propTypes2.default.string,
  t: _propTypes2.default.func
};

Info.mapStateToProps = function (state) {
  return {
    auth: state.auth
    // appConfig: state.appConfig,
    // cancellationReasons: state.cancellationReasons,
  };
};

Info.getPropsToState = function (props) {
  var loading = props.loading;

  var rawData = props.data;
  if (Array.isArray(rawData)) {
    rawData = rawData[0];
  }
  var data = Object.assign({}, _booking2.default, rawData);

  return {
    data: data,
    loading: loading
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.mounted = false;
  this.fetchFormAttachments = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var store, id, res, attachments, normalizedAttachments;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            store = _this3.context.store;
            id = _this3.props.routeParamsID || _this3.state.data && _this3.state.data.id;

            if (!(!id || !store)) {
              _context.next = 5;
              break;
            }

            if (_this3.mounted) _this3.setState({ formAttachmentsLoading: false });
            return _context.abrupt('return');

          case 5:

            _this3.setState({ formAttachmentsLoading: true, formAttachments: [], formAttachmentsError: null });
            _context.prev = 6;
            _context.next = 9;
            return store.dispatch((0, _fetchM.fetchM)('/shared_medias/?parent_type=opportunity&parent_id=' + id + '&file_type=opportunity_form', {
              method: 'GET',
              credentials: 'include',
              headers: { 'Content-Type': 'application/json' }
            }));

          case 9:
            res = _context.sent;
            _context.next = 12;
            return res.json();

          case 12:
            attachments = _context.sent;

            if (_this3.mounted) {
              if (!res.ok) {
                _this3.setState({ formAttachments: [], formAttachmentsError: true });
              } else {
                normalizedAttachments = Array.isArray(attachments) ? attachments : [];

                _this3.setState({
                  formAttachments: normalizedAttachments,
                  formAttachmentsError: attachments !== null && !Array.isArray(attachments) ? true : null
                });
              }
            }
            _context.next = 19;
            break;

          case 16:
            _context.prev = 16;
            _context.t0 = _context['catch'](6);

            if (_this3.mounted) {
              _this3.setState({ formAttachments: [], formAttachmentsError: true });
            }

          case 19:
            _context.prev = 19;

            if (_this3.mounted) {
              _this3.setState({ formAttachmentsLoading: false });
            }
            return _context.finish(19);

          case 22:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this3, [[6, 16, 19, 22]]);
  }));

  this.getAttachmentUrl = function (id, fileName) {
    if (!fileName) {
      return null;
    }
    var bookApiURL = _config2.default.get('bookApiURL');
    var encodedFileName = encodeURIComponent(fileName);
    return bookApiURL + '/shared_medias/' + id + '/file/' + encodedFileName + '?dl=true';
  };

  this.setRefOpportunityNote = function (ref) {
    _this3.refOpportunityNote = ref;
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Info.mapStateToProps)(Info));

/***/ }),
/* 2364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

var _UCTimeline = __webpack_require__(2213);

var _UCTimeline2 = _interopRequireDefault(_UCTimeline);

var _BankCases = __webpack_require__(2162);

var _BankCases2 = _interopRequireDefault(_BankCases);

var _fetchM = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ACTIVITY_LIMIT = 10;

// Temporarily hidden by product decision. The code is kept in place — flip to
// `true` to re-enable the loan activity timeline.
var SHOW_LOAN_TIMELINE = false;

var stripHtml = function stripHtml(html) {
  if (!html) return '';
  return html.replace(/<[^>]*>/g, '');
};

var getActivityTitle = function getActivityTitle(type) {
  switch (type) {
    case 'new':
      return 'Lead Created';
    case 'update':
      return 'Updated';
    case 'update_pending':
      return 'Moved to Pending';
    case 'nudge':
      return 'Nudge';
    case 'closed':
      return 'Closed';
    case 'closed_reject':
      return 'Closed — Rejected';
    case 'closed_success':
      return 'Closed — Success';
    case 'message':
      return 'Remark';
    case 'reassign':
      return 'Banker Reassigned';
    default:
      return type || 'Activity';
  }
};

var Loan = function (_Component) {
  _inherits(Loan, _Component);

  function Loan(props) {
    var _this2 = this;

    _classCallCheck(this, Loan);

    var _this = _possibleConstructorReturn(this, (Loan.__proto__ || Object.getPrototypeOf(Loan)).call(this, props));

    _this.fetchLoanLead = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var store, res, lead;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = _this.context.store;

                if (!(!id || !store)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:

                if (_this.mounted) _this.setState({ loadingLead: true, leadNotFound: false });

                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/opportunity/' + id + '/loan_tracker/', {
                  credentials: 'include',
                  method: 'GET',
                  ignoreNotFound: true,
                  headers: { 'Content-Type': 'application/json' }
                }));

              case 7:
                res = _context.sent;

                if (_this.mounted) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return');

              case 10:
                if (!res.ok) {
                  _context.next = 17;
                  break;
                }

                _context.next = 13;
                return res.json();

              case 13:
                lead = _context.sent;

                _this.setState({
                  loanLead: lead,
                  bankCases: lead.bankCases || []
                });
                _context.next = 18;
                break;

              case 17:
                if (res.status === 404) {
                  _this.setState({ loanLead: null, bankCases: [], leadNotFound: true });
                }

              case 18:
                _context.next = 22;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context['catch'](4);

              case 22:
                _context.prev = 22;

                if (_this.mounted) _this.setState({ loadingLead: false });
                return _context.finish(22);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[4, 20, 22, 25]]);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.fetchActivityLogs = function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id, offset) {
        var reset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var store, res, activityLogToken, items, total, nextOffset;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = _this.context.store;

                if (!(!id || !store)) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt('return');

              case 3:

                if (_this.mounted) _this.setState({ loadingLogs: true });

                _context2.prev = 4;
                _context2.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/opportunity/' + id + '/loan_tracker/activity_logs/?limit=' + ACTIVITY_LIMIT + '&offset=' + offset, {
                  credentials: 'include',
                  method: 'GET',
                  ignoreNotFound: true,
                  headers: { 'Content-Type': 'application/json' }
                }));

              case 7:
                res = _context2.sent;

                if (_this.mounted) {
                  _context2.next = 10;
                  break;
                }

                return _context2.abrupt('return');

              case 10:
                activityLogToken = res.headers.get('X-Csrf-Token');

                if (activityLogToken) {
                  _this.setState({ activityLogToken: activityLogToken });
                }

                if (!res.ok) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 15;
                return res.json();

              case 15:
                items = _context2.sent;
                total = parseInt(res.headers.get('M-Data-count'), 10) || 0;
                nextOffset = offset + (items ? items.length : 0);

                _this.setState(function (prevState) {
                  return {
                    activityLogs: reset || offset === 0 ? items || [] : [].concat(_toConsumableArray(prevState.activityLogs), _toConsumableArray(items || [])),
                    offset: nextOffset,
                    hasMore: nextOffset < total
                  };
                });

              case 19:
                _context2.next = 23;
                break;

              case 21:
                _context2.prev = 21;
                _context2.t0 = _context2['catch'](4);

              case 23:
                _context2.prev = 23;

                if (_this.mounted) _this.setState({ loadingLogs: false });
                return _context2.finish(23);

              case 26:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[4, 21, 23, 26]]);
      }));

      return function (_x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }();

    _this.handleLoadMore = function () {
      var id = _this.props.id;
      var _this$state = _this.state,
          offset = _this$state.offset,
          loadingLogs = _this$state.loadingLogs;

      if (loadingLogs || !id) return;
      _this.fetchActivityLogs(id, offset);
    };

    _this.state = {
      loanLead: null,
      bankCases: [],
      loadingLead: false,
      leadNotFound: false,
      activityLogs: [],
      loadingLogs: false,
      hasMore: false,
      offset: 0
    };
    return _this;
  }

  _createClass(Loan, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      var id = this.props.id;

      if (id) {
        this.fetchLoanLead(id);
        if (SHOW_LOAN_TIMELINE) this.fetchActivityLogs(id, 0);
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var id = this.props.id;

      if (id && id !== prevProps.id) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          loanLead: null,
          bankCases: [],
          activityLogs: [],
          offset: 0,
          hasMore: false,
          leadNotFound: false
        });
        this.fetchLoanLead(id);
        if (SHOW_LOAN_TIMELINE) this.fetchActivityLogs(id, 0, true);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          t = _props.t,
          id = _props.id;
      var _state = this.state,
          bankCases = _state.bankCases,
          loanLead = _state.loanLead,
          activityLogs = _state.activityLogs,
          loadingLead = _state.loadingLead,
          loadingLogs = _state.loadingLogs,
          hasMore = _state.hasMore,
          leadNotFound = _state.leadNotFound,
          activityLogToken = _state.activityLogToken;


      var projectCurrencies = loanLead && loanLead.company && loanLead.company.currencyCode || '';

      var timelineData = activityLogs.map(function (item) {
        return {
          id: item.id,
          title: t(getActivityTitle(item.type), { ns: _translation.TRANSLATION_FILES.translation }),
          description: stripHtml(item.message),
          date: item.createdAt
        };
      });

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: SHOW_LOAN_TIMELINE ? 12 : 16 },
            _react2.default.createElement(
              'h3',
              null,
              t('Loan applied', { ns: _translation.TRANSLATION_FILES.translation })
            ),
            loadingLead && _react2.default.createElement(_semanticUiReact.Loader, { active: true, inline: 'centered' }),
            !loadingLead && leadNotFound && _react2.default.createElement(_semanticUiReact.Message, { info: true, content: t('Loan has not been applied for this booking', { ns: _translation.TRANSLATION_FILES.translation }) }),
            !loadingLead && !leadNotFound && _react2.default.createElement(_BankCases2.default, {
              bankCases: bankCases,
              projectCurrencies: projectCurrencies,
              leadLoanAmount: loanLead ? Number(loanLead.loanAmount) : undefined,
              opportunityID: id
            })
          ),
          SHOW_LOAN_TIMELINE && _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 4 },
            !loadingLead && _react2.default.createElement(_UCTimeline2.default, {
              data: timelineData,
              hasMore: hasMore,
              onLoadMore: this.handleLoadMore,
              loading: loadingLogs,
              title: t('Loan Timeline', { ns: _translation.TRANSLATION_FILES.translation }),
              loadMoreLabel: t('Load more', { ns: _translation.TRANSLATION_FILES.screens }),
              bankCases: bankCases,
              opportunityID: id,
              token: activityLogToken,
              fetchActivityLogs: function fetchActivityLogs() {
                return _this3.fetchActivityLogs(id, 0, true);
              },
              hideAddRemark: leadNotFound
            })
          )
        )
      );
    }
  }]);

  return Loan;
}(_react.Component);

Loan.contextTypes = {
  store: _propTypes2.default.object
};
Loan.propTypes = {
  id: _propTypes2.default.string,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(Loan);

/***/ }),
/* 2365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _prompt = __webpack_require__(66);

var _promptMessages = __webpack_require__(43);

var _translation = __webpack_require__(4);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Info = __webpack_require__(2363);

var _Info2 = _interopRequireDefault(_Info);

var _Purchaser = __webpack_require__(2367);

var _Purchaser2 = _interopRequireDefault(_Purchaser);

var _Payment = __webpack_require__(2366);

var _Payment2 = _interopRequireDefault(_Payment);

var _Document = __webpack_require__(1058);

var _Document2 = _interopRequireDefault(_Document);

var _opportunityStatuses = __webpack_require__(195);

var _ActivityLog = __webpack_require__(2361);

var _ActivityLog2 = _interopRequireDefault(_ActivityLog);

var _url = __webpack_require__(19);

var _UCSectionTab = __webpack_require__(2212);

var _UCSectionTab2 = _interopRequireDefault(_UCSectionTab);

var _OpportunityOverviewDetail = __webpack_require__(2164);

var _OpportunityOverviewDetail2 = _interopRequireDefault(_OpportunityOverviewDetail);

var _Loan = __webpack_require__(2364);

var _Loan2 = _interopRequireDefault(_Loan);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */

// actions

// import { fetchBobForms } from '../../../actions/bobForms';
// constants

// components

// sections
// utils

// utils


var Overview = function (_Component) {
  _inherits(Overview, _Component);

  function Overview(props) {
    _classCallCheck(this, Overview);

    var _this = _possibleConstructorReturn(this, (Overview.__proto__ || Object.getPrototypeOf(Overview)).call(this, props));

    _initialiseProps.call(_this);

    var state = Overview.getPropsToState(props);
    _this.state = _extends({}, state, {
      printTemplates: [],
      projectToken: '',
      systemData: [],
      isAutoReleaseTimerEnabled: false,
      isAgingARTimerEnabled: false,
      showShareEmailModal: false,
      project: [],
      allBankCases: [],
      hasDropCase: false,
      maUserAffiliateCompanyBranchName: '',
      docxPrintTemplates: [],
      isPrinting: false
    });
    return _this;
  }

  _createClass(Overview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.data !== this.props.data || prevProps.loading !== this.props.loading || prevProps.paymentData !== this.props.paymentData || prevProps.documentData !== this.props.documentData || prevProps.location.search !== this.props.location.search) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState(Overview.getPropsToState(this.props));
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var admin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var dhq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var dbl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var internal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      var auth = this.props.auth;
      if (dbl && this.props.auth.isBranchLeader) {
        return true;
      }
      if (dhq && this.props.auth.isHeadquarters) {
        return true;
      }
      if (admin && this.props.auth.isSuperAdmin) {
        return true;
      }
      if (internal && auth && auth.companyBranch && !auth.companyBranch.isExternal) {
        return true;
      }
      return check;
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          data = _state.data,
          loading = _state.loading,
          documentData = _state.documentData,
          isMobile = _state.isMobile,
          printTemplates = _state.printTemplates,
          tabID = _state.tabID,
          sectionTabs = _state.sectionTabs,
          maUserAffiliateCompanyBranchName = _state.maUserAffiliateCompanyBranchName,
          refreshPage = _state.refreshPage,
          docxPrintTemplates = _state.docxPrintTemplates;

      var paymentData = this.props.paymentData;
      var t = this.props.t;

      var combinedPrintTemplates = [].concat(_toConsumableArray(docxPrintTemplates), _toConsumableArray(printTemplates));
      var combinedPrintTmplOnly = combinedPrintTemplates ? combinedPrintTemplates.filter(function (_ref) {
        var value = _ref.value;
        return value !== 'customer_identities';
      }) : [];
      var sectionProps = _extends({}, this.props, { id: this.state.data.id || this.props.routeParamsID, token: this.props.token, mediaToken: this.props.token || this.props.auth && this.props.auth.token, combinedPrintTmplOnly: combinedPrintTmplOnly, isMobile: isMobile, paymentData: paymentData, documentData: documentData, loading: loading, maUserAffiliateCompanyBranchName: maUserAffiliateCompanyBranchName, refreshPage: refreshPage, opportunity: data });

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Booking Overview')
          // rightNav={this.checkAllowPrint(data && data) ? (
          //   <Menu.Item fitted>
          //     <div className="printButton">
          //     </div>
          //   </Menu.Item>
          // ) : null}
          , bottomNode: _react2.default.createElement(_UCSectionTab2.default, {
            loading: this.state.loading,
            isMobile: isMobile,
            isSticky: true,
            onTabChange: this.handleTabChange,
            tabs: sectionTabs,
            tabID: tabID
          })
        }),
        data && data.id ? _react2.default.createElement(_OpportunityOverviewDetail2.default, { data: data, paymentData: this.props.paymentData, refundData: this.props.refundData, refundToken: this.props.refundToken, fetchRefunds: this.props.fetchRefunds, onUpdateOpportunity: this.props.onUpdateOpportunity, fetchBooking: this.props.fetchBooking, loading: this.state.loading }) : _react2.default.createElement(
          'div',
          { className: 'ui placeholder segment' },
          'Loading or Accessing Data...'
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_UCSectionTab2.default, {
                    loading: this.state.loading,
                    isMobile: isMobile,
                    onTabChange: this.handleTabChange,
                    tabs: sectionTabs,
                    tabID: tabID
                  })
                )
              )
            ),
            _react2.default.createElement('div', { className: 'uc-tab-page-spacer' }),
            tabID === 1 && _react2.default.createElement(_Info2.default, sectionProps),
            tabID === 2 && _react2.default.createElement(_Purchaser2.default, sectionProps),
            tabID === 3 && _react2.default.createElement(_Payment2.default, _extends({}, sectionProps, { fetchBooking: this.props.fetchBooking, onUpdateOpportunity: this.props.onUpdateOpportunity })),
            tabID === 4 && _react2.default.createElement(_Loan2.default, sectionProps),
            tabID === 5 && _react2.default.createElement(_Document2.default, sectionProps),
            tabID === 6 && _react2.default.createElement(_ActivityLog2.default, sectionProps)
          )
        )
      );
    }
  }]);

  return Overview;
}(_react.Component);

Overview.contextTypes = {
  store: _propTypes2.default.object
};
Overview.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      noeticIsEnabled: _propTypes2.default.bool,
      lawyerIsEnabled: _propTypes2.default.bool,
      settings: _propTypes2.default.shape({
        bookingHideLoanTracker: _propTypes2.default.bool
      })
    })
  }),
  auth: _propTypes2.default.shape({
    companyBranch: _propTypes2.default.shape({
      id: _propTypes2.default.number
    }),
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    creditCheckAccess: _propTypes2.default.bool,
    allowEditUnitPrice: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool,
    token: _propTypes2.default.string
  }),
  routeParamsID: _propTypes2.default.string,
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  bobForms: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  templates: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      print: _propTypes2.default.array
    })
  }),
  fetchNewBooking: _propTypes2.default.func,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func,
  checkHasChanges: _propTypes2.default.func,
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  paymentData: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  documentData: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
  })),
  fetchBooking: _propTypes2.default.func,
  fetchPaymentDetails: _propTypes2.default.func,
  fetchDocument: _propTypes2.default.func,
  onUpdateOpportunity: _propTypes2.default.func,
  t: _propTypes2.default.func
};

Overview.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig,
    bobForms: state.bobForms,
    templates: state.templates
  };
};

Overview.getPropsToState = function (props) {
  var windowWidth = window.innerWidth;
  var query = (0, _url.decodeSearch)(props.location.search);
  var isMobile = windowWidth < 768;
  var loading = props.loading;
  var data = _extends({}, props.data || {});
  var paymentData = props.paymentData;
  var documentData = props.documentData;
  var tabID = 1;
  if (!data.id && props.routeParamsID) {
    data.id = props.routeParamsID;
  }
  switch (query.section) {
    case 'info':
      tabID = 1;
      break;
    case 'purchaser':
      tabID = 2;
      break;
    case 'payment':
      tabID = 3;
      break;
    case 'loan':
      tabID = 4;
      break;
    case 'documents':
      tabID = 5;
      break;
    case 'logs':
      tabID = 6;
      break;
    default:
      tabID = 1;
      break;
  }
  // TODO: enable this when sr_source_of_finance is reliably populated
  // const isLoanTabLocked = !data.sr_source_of_finance || !data.sr_source_of_finance.toLowerCase().includes('loan');
  var PAYMENT_DOT_STATUSES = [_opportunityStatuses.OPPORTUNITY_STATUS.PAYMENT_MADE, _opportunityStatuses.OPPORTUNITY_STATUS.PARTIALLY_PAID_UNVERIFIED, _opportunityStatuses.OPPORTUNITY_STATUS.PAID_UNVERIFIED, _opportunityStatuses.OPPORTUNITY_STATUS.PAID_VERIFIED, _opportunityStatuses.OPPORTUNITY_STATUS.PENDING_REFUND, _opportunityStatuses.OPPORTUNITY_STATUS.PENDING_CANCELLATION, _opportunityStatuses.OPPORTUNITY_STATUS.VERIFICATION_REJECTED];
  var showPaymentDot = data && PAYMENT_DOT_STATUSES.includes(data.sr_status);
  var sectionTabs = [{ id: 1, title: 'Info', description: 'Status, Pricing & Payment' }, { id: 2, title: 'Purchaser', description: 'Details, E-Sign & Eligibility' }, { id: 3, title: 'Payment', description: 'Payment', showDot: showPaymentDot }, { id: 4, title: 'Loan', description: 'Loan' /* TODO: uncomment when enabling: , isLocked: isLoanTabLocked */ }, { id: 5, title: 'Document', description: 'Document Sharing' }, { id: 6, title: 'Activity Log', description: 'Activity Logs' }];
  return {
    data: data,
    isMobile: isMobile,
    loading: loading,
    paymentData: paymentData,
    documentData: documentData,
    oriData: (0, _clone2.default)(data),
    tabID: tabID,
    sectionTabs: sectionTabs,
    refreshPage: false,
    docxPrintTemplates: []
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var loadingType = arguments[1];
    return new Promise(function (res) {
      if (loadingType === 'validatingTIN') {
        _this2.setState({ validatingTin: loading }, res);
      } else {
        _this2.setState({ loading: loading }, res);
      }
    });
  };

  this.handleResize = function () {
    var state = {};
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    if (isMobile !== _this2.state.isMobile) {
      state.isMobile = isMobile;
      _this2.setState(_extends({}, state));
    }
  };

  this.handleTabChange = function (tabData) {
    if (!tabData || tabData.isLocked) {
      return;
    }
    var tabID = tabData.id;
    var store = _this2.context.store;

    var query = (0, _url.decodeSearch)(_this2.props.location.search);
    var tab = 'info';
    var bookingId = _this2.state.data.id || _this2.props.routeParamsID;
    switch (tabID) {
      case 1:
        tab = 'info';
        break;
      case 2:
        tab = 'purchaser';
        break;
      case 3:
        tab = 'payment';
        break;
      case 4:
        tab = 'loan';
        break;
      case 5:
        tab = 'documents';
        break;
      case 6:
        tab = 'logs';
        break;
      default:
        tab = 'info';
        break;
    }
    query.section = tab;

    _this2.setState({
      tabID: _this2.props.checkHasChanges() ? _this2.state.tabID : tabID
    });
    if (tabData.page) {
      store.dispatch((0, _reactRouterRedux.push)('/opportunities/' + bookingId + '/' + tabData.page));
    } else {
      var callback = function callback() {
        if (_this2.props.checkHasChanges()) {
          _this2.props.onCheck(false, function () {
            return _this2.setState({ tabID: tabID });
          });
        }
        if (tabData.isSticky) {
          // Scrolltop
          window.scrollTo(0, 150);
        }
        store.dispatch((0, _reactRouterRedux.replace)('/opportunities/' + bookingId + '/?' + (0, _url.encodeSearch)(query)));
      };
      if (_this2.props.checkHasChanges()) {
        store.dispatch((0, _prompt.promptChangesMessage)({ message: _promptMessages.DEFAULT_PROMPT, callback: callback }));
      } else {
        callback();
      }
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Overview.mapStateToProps)(Overview));

/***/ }),
/* 2366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Payment = exports.fetchActivityLogs = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var fetchActivityLogs = exports.fetchActivityLogs = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(opportunityId) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref2$page = _ref2.page,
        page = _ref2$page === undefined ? 1 : _ref2$page,
        _ref2$perPage = _ref2.perPage,
        perPage = _ref2$perPage === undefined ? 20 : _ref2$perPage;

    var url, params, session, token, res, message;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            url = new URL(_config2.default.get('logApiURL') + '/api/v1/activity-logs');
            params = { entity_type: 'opportunity', entity_id: opportunityId, per_page: perPage, page: page, event_type: 'unit_reservation_token_payment_status_change' };

            url.search = new URLSearchParams(params).toString();

            _context.next = 5;
            return _auth2.default.currentSession();

          case 5:
            session = _context.sent;
            token = session.getIdToken().getJwtToken();
            _context.next = 9;
            return fetch(url, {
              headers: { Authorization: 'Bearer ' + token },
              mode: 'cors'
            });

          case 9:
            res = _context.sent;

            if (res.ok) {
              _context.next = 16;
              break;
            }

            _context.next = 13;
            return res.text();

          case 13:
            message = _context.sent;

            Bugsnag.notify('Failed to GET ' + url + ': ' + message);
            throw new Error(message || 'Failed to fetch activity logs');

          case 16:
            return _context.abrupt('return', res.json());

          case 17:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function fetchActivityLogs(_x) {
    return _ref.apply(this, arguments);
  };
}();

// Named export for lifecycle tests; the default export below is the wrapped one the app uses.


var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _semanticUiReact = __webpack_require__(2);

var _moment = __webpack_require__(12);

var _moment2 = _interopRequireDefault(_moment);

var _reactI18next = __webpack_require__(3);

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TimelineLog = __webpack_require__(1059);

var _TimelineLog2 = _interopRequireDefault(_TimelineLog);

var _translation = __webpack_require__(4);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _document_yellow = __webpack_require__(3529);

var _document_yellow2 = _interopRequireDefault(_document_yellow);

var _document_green = __webpack_require__(3527);

var _document_green2 = _interopRequireDefault(_document_green);

var _document_red = __webpack_require__(3528);

var _document_red2 = _interopRequireDefault(_document_red);

var _AttachmentItem = __webpack_require__(1004);

var _AttachmentItem2 = _interopRequireDefault(_AttachmentItem);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _currencyMinor = __webpack_require__(326);

var _opportunityStatuses = __webpack_require__(195);

var _refundRefetch = __webpack_require__(1025);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable max-len, jsx-a11y/no-static-element-interactions, no-nested-ternary */


var PAYMENT_DEFAULT = {
  payments: [],
  currencyCode: 'VND',
  amountMinorPaid: 0
};

// Temporarily hidden: the payment timeline reads token-payment status-change
// logs from log-api, which now excludes `ur_token_payments` from the feed, so
// the timeline renders empty. Keeping the code in place — flip to `true` to
// re-enable once those events are surfaced again.
var SHOW_PAYMENT_TIMELINE = false;

var Payment = exports.Payment = function (_Component) {
  _inherits(Payment, _Component);

  function Payment(props) {
    var _this2 = this;

    _classCallCheck(this, Payment);

    var _this = _possibleConstructorReturn(this, (Payment.__proto__ || Object.getPrototypeOf(Payment)).call(this, props));

    _this.getStatusLabel = function (tx) {
      var t = _this.props.t;


      if (tx.status === 'completed') return t('Paid');
      if (tx.status === 'failed') return t('FAILED');

      // Handle Pending states
      if (tx.method === 'online') {
        return t('Pending completion');
      }

      return t('Confirm Amount');
    };

    _this.getPaymentStatusLabel = function (status) {
      var t = _this.props.t;

      if (status === 'paid_verified') return t('Verified');
      if (status === 'verification_rejected') return t('Rejected');
      return t('Pending verification');
    };

    _this.getRefundData = function () {
      var store = _this.context.store;
      var paymentData = _this.props.paymentData;

      if (!paymentData || !paymentData.opportunityID) return;

      var url = '/unit_reservation_refunds/opportunity/' + paymentData.opportunityID + '/';
      _this.refundRequestVersion = (_this.refundRequestVersion || 0) + 1;
      var requestVersion = _this.refundRequestVersion;
      var isCurrent = function isCurrent() {
        return _this.mounted && requestVersion === _this.refundRequestVersion;
      };

      var action = (0, _fetchM.fetchM)(url, {
        credentials: 'include',
        method: 'GET',
        ignoreNotFound: true,
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (store) {
        store.dispatch(action).then(function (response) {
          if (response && response.ok) {
            return response.json();
          }
          throw new Error('Network response was not ok');
        }).then(function (data) {
          if (data && isCurrent()) {
            _this.setState({ refundRecord: data });
          }
        }).catch(function () {
          if (isCurrent()) {
            _this.setState({ refundRecord: null });
          }
        });
      }
    };

    _this.getViewLink = function (id, fileName) {
      var viewUrl = _config2.default.get('bookApiURL') + '/shared_medias/' + id + '/file/' + encodeURIComponent(fileName);
      return viewUrl;
    };

    _this.getMetadataValue = function (metadata, key) {
      if (!metadata || !metadata.length) return null;
      var item = metadata.find(function (m) {
        return m.key === key;
      });
      return item && item.value ? item.value : null;
    };

    _this.clearRefundRecord = function () {
      // Also invalidates any in-flight read so a late response cannot repopulate the card.
      _this.refundRequestVersion = (_this.refundRequestVersion || 0) + 1;
      if (_this.state.refundRecord != null) _this.setState({ refundRecord: null });
    };

    _this.handleCardClick = function (index) {
      _this.setState(function (prevState) {
        return {
          activeIndex: prevState.activeIndex === index ? -1 : index
        };
      });
    };

    _this.handleApprove = function (id) {
      _this.updatePaymentStatus(id, 'completed');
    };

    _this.handlePartial = function (id, paymentAmount, tokenAmount, alreadyPaid, code) {
      _this.setState({
        partialModalOpen: true,
        partialPaymentID: id,
        partialOriginalAmount: paymentAmount,
        partialTokenAmount: tokenAmount,
        partialAlreadyPaid: alreadyPaid,
        partialCurrencyCode: code,
        partialAmount: String((0, _currencyMinor.minorToMajor)(paymentAmount, code)),
        partialError: null
      });
    };

    _this.handlePartialCancel = function () {
      _this.setState({ partialModalOpen: false, partialPaymentID: null, partialAmount: '', partialError: null });
    };

    _this.handlePartialAmountChange = function (e) {
      _this.setState({ partialAmount: e.target.value, partialError: null });
    };

    _this.submitPartialPayment = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var t, _this$state, partialPaymentID, partialAmount, partialOriginalAmount, partialTokenAmount, partialAlreadyPaid, partialCurrencyCode, outstanding, rawMajor, parsedMinor;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              t = _this.props.t;
              _this$state = _this.state, partialPaymentID = _this$state.partialPaymentID, partialAmount = _this$state.partialAmount, partialOriginalAmount = _this$state.partialOriginalAmount, partialTokenAmount = _this$state.partialTokenAmount, partialAlreadyPaid = _this$state.partialAlreadyPaid, partialCurrencyCode = _this$state.partialCurrencyCode;
              outstanding = partialTokenAmount - partialAlreadyPaid;
              rawMajor = Number(partialAmount);

              if (!(!partialAmount || isNaN(rawMajor) || rawMajor <= 0)) {
                _context2.next = 7;
                break;
              }

              _this.setState({ partialError: t('Amount must be a positive number') });
              return _context2.abrupt('return');

            case 7:
              parsedMinor = (0, _currencyMinor.majorToMinor)(rawMajor, partialCurrencyCode);

              if (!(parsedMinor > outstanding)) {
                _context2.next = 11;
                break;
              }

              _this.setState({ partialError: t('Amount cannot exceed the outstanding balance') });
              return _context2.abrupt('return');

            case 11:
              if (!(parsedMinor === partialOriginalAmount)) {
                _context2.next = 14;
                break;
              }

              _this.setState({ partialError: t('Amount cannot be equal to the submitted payment amount') });
              return _context2.abrupt('return');

            case 14:

              _this.setState({ partialLoading: true, partialError: null });
              _context2.prev = 15;
              _context2.next = 18;
              return _this.updatePaymentStatus(partialPaymentID, 'completed', parsedMinor);

            case 18:
              _this.setState({ partialModalOpen: false, partialPaymentID: null, partialAmount: '', partialLoading: false });
              _context2.next = 24;
              break;

            case 21:
              _context2.prev = 21;
              _context2.t0 = _context2['catch'](15);

              _this.setState({ partialLoading: false, partialError: t('Error updating payment status', { ns: _translation.TRANSLATION_FILES.translation }) });

            case 24:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[15, 21]]);
    }));

    _this.updatePaymentStatus = function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(paymentID, nextStatus, amountMinor) {
        var store, _this$props, paymentData, TokenPaymentCSRF, t, url, body;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                store = _this.context.store;
                _this$props = _this.props, paymentData = _this$props.paymentData, TokenPaymentCSRF = _this$props.TokenPaymentCSRF, t = _this$props.t;

                if (!(!paymentData || !paymentData.id)) {
                  _context3.next = 4;
                  break;
                }

                return _context3.abrupt('return');

              case 4:
                url = '/unit_reservation_tokens/' + paymentData.id + '/payments/' + paymentID + '/manage/';
                body = { status: nextStatus };

                if (amountMinor !== undefined) body.amountMinor = amountMinor;
                _context3.prev = 7;
                _context3.next = 10;
                return store.dispatch((0, _fetchM.fetchM)(url, {
                  method: 'PUT',
                  credentials: 'include',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': TokenPaymentCSRF
                  },
                  body: JSON.stringify(body)
                }));

              case 10:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Success', { ns: _translation.TRANSLATION_FILES.constants }), message: t('Status updated') }));
                if (_this.props.fetchPaymentDetails) _this.props.fetchPaymentDetails();
                if (_this.props.fetchBooking) _this.props.fetchBooking();
                _context3.next = 20;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3['catch'](7);

                store.dispatch((0, _flash.flashErrorMessage)({
                  header: t('Error', { ns: _translation.TRANSLATION_FILES.constants }),
                  message: t('Error updating payment status', { ns: _translation.TRANSLATION_FILES.translation })
                }));

                if (!(amountMinor !== undefined)) {
                  _context3.next = 20;
                  break;
                }

                throw _context3.t0;

              case 20:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this2, [[7, 15]]);
      }));

      return function (_x3, _x4, _x5) {
        return _ref4.apply(this, arguments);
      };
    }();

    _this.handleStatusUpdate = function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(nextStatus) {
        var store, _this$props2, paymentData, TokenPaymentCSRF, t, tokenID, url;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                store = _this.context.store;
                _this$props2 = _this.props, paymentData = _this$props2.paymentData, TokenPaymentCSRF = _this$props2.TokenPaymentCSRF, t = _this$props2.t;

                if (!(!paymentData || !paymentData.id)) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt('return');

              case 4:
                tokenID = paymentData.id;
                url = '/unit_reservation_tokens/' + tokenID + '/manage/';
                _context4.prev = 6;
                _context4.next = 9;
                return store.dispatch((0, _fetchM.fetchM)(url, {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': TokenPaymentCSRF
                  },
                  body: JSON.stringify({ status: nextStatus })
                }));

              case 9:
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Success', { ns: _translation.TRANSLATION_FILES.constants }),
                  message: t('Status_Payment_Changed_Success')
                }));
                if (_this.props.fetchPaymentDetails) {
                  _this.props.fetchPaymentDetails();
                }
                if (_this.props.fetchBooking) _this.props.fetchBooking();
                _context4.next = 17;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t0 = _context4['catch'](6);

                store.dispatch((0, _flash.flashErrorMessage)({
                  header: t('Upload Failed'),
                  message: t('Status changed failed')
                }));

              case 17:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this2, [[6, 14]]);
      }));

      return function (_x6) {
        return _ref5.apply(this, arguments);
      };
    }();

    _this.handleRejection = function (nextStatus) {
      var onUpdateOpportunity = _this.props.onUpdateOpportunity;

      if (onUpdateOpportunity) {
        onUpdateOpportunity(nextStatus);
      }
    };

    _this.fetchReceiptAttachments = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var store, paymentData, opportunityID, res, medias, map, payments, buyerMediaIDs, buyerMap;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              store = _this.context.store;
              paymentData = _this.props.paymentData;
              opportunityID = paymentData && paymentData.opportunityID;

              // Reset maps and mark loading to avoid stale data when switching opportunities or
              // when there is no opportunityID (e.g. navigating away).

              if (_this.mounted) _this.setState({ receiptsMap: {}, buyerAttachmentsMap: {}, buyerAttachmentsLoading: true });

              if (opportunityID) {
                _context6.next = 7;
                break;
              }

              if (_this.mounted) _this.setState({ buyerAttachmentsLoading: false });
              return _context6.abrupt('return');

            case 7:
              _context6.prev = 7;
              _context6.next = 10;
              return store.dispatch((0, _fetchM.fetchM)('/shared_medias/?parent_type=opportunity&parent_id=' + opportunityID + '&file_type=token_payment_receipt', { method: 'GET', credentials: 'include', headers: { 'Content-Type': 'application/json' } }));

            case 10:
              res = _context6.sent;

              if (!(res && res.ok)) {
                _context6.next = 18;
                break;
              }

              _context6.next = 14;
              return res.json();

            case 14:
              medias = _context6.sent;
              map = {};

              (medias || []).forEach(function (m) {
                // filename: receipt_token_payment_{paymentID}.pdf
                var match = m.fileName && m.fileName.match(/^receipt_token_payment_(.+)\.pdf$/);
                if (match) map[match[1]] = m.id;
              });
              if (_this.mounted) _this.setState({ receiptsMap: map });

            case 18:

              // Fetch filenames for buyer-uploaded receipt proofs.
              payments = paymentData && paymentData.payments || [];
              buyerMediaIDs = [].concat(_toConsumableArray(new Set(payments.map(function (p) {
                return p.receiptMediaID;
              }).filter(Boolean))));

              if (!(buyerMediaIDs.length > 0)) {
                _context6.next = 25;
                break;
              }

              buyerMap = {};
              _context6.next = 24;
              return Promise.all(buyerMediaIDs.map(function () {
                var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(mediaID) {
                  var r, media;
                  return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.prev = 0;
                          _context5.next = 3;
                          return store.dispatch((0, _fetchM.fetchM)('/shared_medias/' + mediaID + '/', { method: 'GET', credentials: 'include', headers: { 'Content-Type': 'application/json' } }));

                        case 3:
                          r = _context5.sent;

                          if (!(r && r.ok)) {
                            _context5.next = 9;
                            break;
                          }

                          _context5.next = 7;
                          return r.json();

                        case 7:
                          media = _context5.sent;

                          if (media && media.fileName) buyerMap[mediaID] = media.fileName;

                        case 9:
                          _context5.next = 13;
                          break;

                        case 11:
                          _context5.prev = 11;
                          _context5.t0 = _context5['catch'](0);

                        case 13:
                        case 'end':
                          return _context5.stop();
                      }
                    }
                  }, _callee5, _this2, [[0, 11]]);
                }));

                return function (_x7) {
                  return _ref7.apply(this, arguments);
                };
              }() /* non-critical */));

            case 24:
              if (_this.mounted) _this.setState({ buyerAttachmentsMap: buyerMap });

            case 25:
              _context6.next = 29;
              break;

            case 27:
              _context6.prev = 27;
              _context6.t0 = _context6['catch'](7);

            case 29:
              _context6.prev = 29;

              if (_this.mounted) _this.setState({ buyerAttachmentsLoading: false });
              return _context6.finish(29);

            case 32:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this2, [[7, 27, 29, 32]]);
    }));

    _this.loadInitialTimeline = function () {
      var paymentData = _this.props.paymentData;

      var opportunityId = paymentData && paymentData.opportunityID;

      if (!opportunityId) {
        _this.setState({ timelineLogs: [], timelinePage: 1, timelineHasMore: false });
        return;
      }

      _this.setState({ timelineLoading: true, timelinePage: 1 }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var data, logsList, filtered, pagination, hasMore;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                _context7.next = 3;
                return fetchActivityLogs(opportunityId, { page: 1, perPage: 10 });

              case 3:
                data = _context7.sent;

                if (_this.mounted) {
                  _context7.next = 6;
                  break;
                }

                return _context7.abrupt('return');

              case 6:
                logsList = data.activity_logs || [];
                filtered = logsList.filter(function (log) {
                  return log.source_table === 'ur_token_payments' || log.source_table === 'unit_resv_tokens';
                });
                pagination = data.pagination || {};
                hasMore = pagination.has_next || false;


                _this.setState({
                  timelineLogs: filtered,
                  timelineHasMore: hasMore,
                  timelineLoading: false
                });
                _context7.next = 16;
                break;

              case 13:
                _context7.prev = 13;
                _context7.t0 = _context7['catch'](0);

                if (_this.mounted) _this.setState({ timelineLoading: false });

              case 16:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this2, [[0, 13]]);
      })));
    };

    _this.loadMoreTimeline = function () {
      var paymentData = _this.props.paymentData;

      var opportunityId = paymentData && paymentData.opportunityID;
      var _this$state2 = _this.state,
          timelinePage = _this$state2.timelinePage,
          timelineLoading = _this$state2.timelineLoading,
          timelineHasMore = _this$state2.timelineHasMore;


      if (!opportunityId || timelineLoading || !timelineHasMore) return;

      var nextPage = timelinePage + 1;
      _this.setState({ timelineLoading: true }, _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var data, logsList, filtered, pagination, hasMore;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return fetchActivityLogs(opportunityId, { page: nextPage, perPage: 10 });

              case 3:
                data = _context8.sent;

                if (_this.mounted) {
                  _context8.next = 6;
                  break;
                }

                return _context8.abrupt('return');

              case 6:
                logsList = data.activity_logs || [];
                filtered = logsList.filter(function (log) {
                  return log.source_table === 'ur_token_payments' || log.source_table === 'unit_resv_tokens';
                });
                pagination = data.pagination || {};
                hasMore = pagination.has_next || false;


                _this.setState(function (prevState) {
                  return {
                    timelineLogs: [].concat(_toConsumableArray(prevState.timelineLogs), _toConsumableArray(filtered)),
                    timelinePage: nextPage,
                    timelineHasMore: hasMore,
                    timelineLoading: false
                  };
                });
                _context8.next = 16;
                break;

              case 13:
                _context8.prev = 13;
                _context8.t0 = _context8['catch'](0);

                if (_this.mounted) _this.setState({ timelineLoading: false });

              case 16:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this2, [[0, 13]]);
      })));
    };

    _this.isUserHqOrBranchLeaders = function () {
      var auth = _this.props.auth;

      return auth && (auth.isHeadquarters || auth.isBranchLeader || auth.isBranchLeaderSupervisor || auth.isBranchLeaderSupervisorII);
    };

    _this.showConfirm = function (status) {
      _this.setState({ confirmOpen: true, pendingStatus: status });
    };

    _this.handleCancel = function () {
      return _this.setState({ confirmOpen: false, pendingStatus: null });
    };

    _this.handleConfirm = function () {
      var pendingStatus = _this.state.pendingStatus;


      if (pendingStatus === 'verification_rejected') {
        _this.handleRejection('verification_rejected');
      } else {
        _this.handleStatusUpdate(pendingStatus);
      }

      _this.setState({ confirmOpen: false, pendingStatus: null });
    };

    _this.formatCurrency = function (amountMinor) {
      var code = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'VND';
      return (0, _currencyMinor.formatMinorAmount)(amountMinor, code);
    };

    _this.handleCopyMetadataValue = function (e, value) {
      e.stopPropagation();
      var store = _this.context.store;
      var t = _this.props.t;


      var textArea = document.createElement('textarea');
      textArea.value = String(value || '');
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('Copy');
      textArea.remove();

      store.dispatch((0, _flash.flashSuccessMessage)({
        header: t('Copy Success', { ns: _translation.TRANSLATION_FILES.translation }),
        message: t('Successfully copied to your clipboard', { ns: _translation.TRANSLATION_FILES.translation })
      }));
    };

    _this.renderPaymentMethodPills = function (metadata) {
      var t = _this.props.t;

      var pm = _this.getMetadataValue(metadata, 'payment_method');
      if (!pm) return null;
      var v = pm.toLowerCase();
      var pills = [];
      if (v.includes('-credit-card')) pills.push({ text: t('Credit Card'), color: 'green' });
      if (v.includes('atm-card')) pills.push({ text: t('ATM Card'), color: 'blue' });
      return pills.map(function (p) {
        return _react2.default.createElement(
          _semanticUiReact.Label,
          { key: p.text, size: 'mini', color: p.color },
          p.text
        );
      });
    };

    _this.renderMetadataField = function (label, value) {
      var copyable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var truncate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var t = _this.props.t;

      var MAX_LEN = 18;
      var canCopy = copyable && !!value;
      var isLong = truncate && !!value && value.length > MAX_LEN;
      var displayValue = isLong ? value.slice(0, MAX_LEN) + '\u2026' : value;
      return _react2.default.createElement(
        'div',
        { className: 'div-text-holder', key: label },
        _react2.default.createElement(
          'div',
          { className: 'div-text' },
          t(label)
        ),
        isLong || canCopy ? _react2.default.createElement(
          'div',
          { className: 'div-value metadata-value-truncate' },
          _react2.default.createElement(
            'span',
            { title: value },
            displayValue || 'N/A'
          ),
          canCopy && _react2.default.createElement(
            _semanticUiReact.Button,
            {
              icon: true,
              type: 'button',
              className: 'metadata-copy-btn',
              'aria-label': t('Copy'),
              title: t('Copy'),
              onClick: function onClick(e) {
                return _this.handleCopyMetadataValue(e, value);
              }
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'copy outline' })
          )
        ) : _react2.default.createElement(
          'div',
          { className: 'div-value' },
          value || 'N/A'
        )
      );
    };

    _this.state = {
      activeIndex: -1,
      confirmOpen: false,
      isAccountInfoOpen: false,
      pendingStatus: null,
      receiptsMap: {}, // { [paymentID]: sharedMediaID } for auto-generated receipts
      buyerAttachmentsMap: {}, // { [mediaID]: fileName } for buyer-uploaded receipt proofs
      buyerAttachmentsLoading: false, // true while buyer attachment filenames are being fetched
      partialModalOpen: false,
      partialPaymentID: null,
      partialOriginalAmount: 0,
      partialTokenAmount: 0,
      partialAlreadyPaid: 0,
      partialCurrencyCode: null,
      partialAmount: '',
      partialLoading: false,
      partialError: null,
      timelineLogs: [],
      timelinePage: 1,
      timelineHasMore: false,
      timelineLoading: false
    };
    return _this;
  }

  _createClass(Payment, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      var _props = this.props,
          auth = _props.auth,
          paymentData = _props.paymentData,
          opportunity = _props.opportunity;

      var hasPermission = auth && (auth.isDeveloperSupervisor || auth.isDeveloperSalesManager || auth.isDeveloperSalesAdmin || auth.isHeadquarters || auth.isAdminBasic);

      // Check if opportunityID exists before calling
      if (paymentData && paymentData.opportunityID) {
        if (SHOW_PAYMENT_TIMELINE) this.loadInitialTimeline();
        // The refund record is only read for an sr_status that can carry one; otherwise 404.
        if (hasPermission && (0, _refundRefetch.opportunityCanHaveRefund)(opportunity)) {
          this.getRefundData();
        }
      }
      this.fetchReceiptAttachments();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var _props2 = this.props,
          auth = _props2.auth,
          paymentData = _props2.paymentData,
          opportunity = _props2.opportunity;


      var prevId = prevProps.paymentData && prevProps.paymentData.opportunityID;
      var currentId = paymentData && paymentData.opportunityID;

      if (!currentId) {
        // Navigation nulls paymentData before the next booking loads, and the next booking may have
        // no token at all. The previous booking's record must not be rendered against it.
        this.clearRefundRecord();
        return;
      }

      if (currentId !== prevId || prevProps.paymentData !== paymentData) {
        this.fetchReceiptAttachments();
        if (SHOW_PAYMENT_TIMELINE) this.loadInitialTimeline();
      }

      var hasPermission = auth && (auth.isDeveloperSupervisor || auth.isDeveloperSalesManager || auth.isDeveloperSalesAdmin || auth.isHeadquarters || auth.isAdminBasic);
      if (!hasPermission || !(0, _refundRefetch.opportunityCanHaveRefund)(opportunity)) {
        // Payment stays mounted across a booking switch, so a record read for the previous booking
        // must not survive into one that cannot have a refund (or that this user may not read).
        this.clearRefundRecord();
        return;
      }

      // The refund record is re-read only when the reservation token's own fields changed, or the
      // opportunity moved between refund states (approve / decline), not because the parent handed
      // down a fresh object (CPI-1388). Outside the refund states the GET is a guaranteed 404.
      var prevSRStatus = prevProps.opportunity && prevProps.opportunity.sr_status;
      if ((0, _refundRefetch.shouldRefetchRefund)(prevProps.paymentData, paymentData, _refundRefetch.refundKeyOfPayment) || prevSRStatus !== opportunity.sr_status) {
        this.getRefundData();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
    }

    // Fetch auto-generated receipts (file_type=token_payment_receipt) for the opportunity
    // and build a map of paymentID -> sharedMediaID using the filename convention
    // receipt_token_payment_{paymentID}.pdf.


    // CPI-977: promoted to utils/numbers/currencyMinor.js so the tabs cannot drift. Output unchanged.

  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props3 = this.props,
          loading = _props3.loading,
          t = _props3.t,
          data = _props3.data,
          paymentData = _props3.paymentData;
      var _state = this.state,
          activeIndex = _state.activeIndex,
          receiptsMap = _state.receiptsMap,
          buyerAttachmentsMap = _state.buyerAttachmentsMap,
          buyerAttachmentsLoading = _state.buyerAttachmentsLoading,
          timelineLogs = _state.timelineLogs,
          timelineHasMore = _state.timelineHasMore,
          timelineLoading = _state.timelineLoading;

      if (loading) return _react2.default.createElement(_semanticUiReact.Loader, { active: true, inline: 'centered', style: { marginTop: '2rem' } });

      var _ref10 = paymentData || {},
          _ref10$payments = _ref10.payments,
          payments = _ref10$payments === undefined ? PAYMENT_DEFAULT.payments : _ref10$payments,
          _ref10$currencyCode = _ref10.currencyCode,
          currencyCode = _ref10$currencyCode === undefined ? PAYMENT_DEFAULT.currencyCode : _ref10$currencyCode,
          _ref10$amountMinorPai = _ref10.amountMinorPaid,
          amountMinorPaid = _ref10$amountMinorPai === undefined ? PAYMENT_DEFAULT.amountMinorPaid : _ref10$amountMinorPai,
          _ref10$amountMinor = _ref10.amountMinor,
          amountMinor = _ref10$amountMinor === undefined ? PAYMENT_DEFAULT.amountMinor : _ref10$amountMinor,
          _ref10$status = _ref10.status,
          status = _ref10$status === undefined ? PAYMENT_DEFAULT.status : _ref10$status;
      // CPI-1226: cancelled_error is as terminal as `cancelled`, so both lists below carry it too.


      var RESTRICTED_DROPDOWN_STATUSES = [_opportunityStatuses.OPPORTUNITY_STATUS.PENDING_CANCELLATION, _opportunityStatuses.OPPORTUNITY_STATUS.PENDING_REFUND, _opportunityStatuses.OPPORTUNITY_STATUS.REFUNDED, _opportunityStatuses.OPPORTUNITY_STATUS.REFUND_DECLINED, _opportunityStatuses.OPPORTUNITY_STATUS.CANCELLED, _opportunityStatuses.OPPORTUNITY_STATUS.CANCELLED_ERROR, _opportunityStatuses.OPPORTUNITY_STATUS.EXPIRED];
      var DISPLAY_STATUS_MAP = [_opportunityStatuses.OPPORTUNITY_STATUS.PENDING_CANCELLATION, _opportunityStatuses.OPPORTUNITY_STATUS.PENDING_REFUND, _opportunityStatuses.OPPORTUNITY_STATUS.REFUNDED, _opportunityStatuses.OPPORTUNITY_STATUS.REFUND_DECLINED, _opportunityStatuses.OPPORTUNITY_STATUS.CANCELLED, _opportunityStatuses.OPPORTUNITY_STATUS.CANCELLED_ERROR, _opportunityStatuses.OPPORTUNITY_STATUS.PAID_VERIFIED, _opportunityStatuses.OPPORTUNITY_STATUS.APPROVED];
      var srStatus = data && data.sr_status;
      var hasBeenDenied = srStatus === 'verification_rejected' || data && data.sr_verify_rejected_at != null;
      var paymentsSafe = payments || [];
      var outstandingMinor = amountMinor - amountMinorPaid;
      var refundRecord = this.state.refundRecord;

      var summaryLabelColor = 'orange';
      var summaryLabelText = t('Pending Payment');
      if (status === 'paid_verified') {
        summaryLabelColor = 'teal';
        summaryLabelText = t('FULLY PAID');
      } else if (status === 'paid_unverified') {
        summaryLabelColor = 'green';
        summaryLabelText = t('FULLY PAID');
      } else if (status === 'partially_paid') {
        summaryLabelColor = 'blue';
        summaryLabelText = t('PARTIALLY PAID');
      }
      var sortedPayments = [].concat(_toConsumableArray(paymentsSafe)).sort(function (a, b) {
        return (0, _moment2.default)(b.paidAt).valueOf() - (0, _moment2.default)(a.paidAt).valueOf();
      });
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { stackable: true },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 11 },
          _react2.default.createElement(
            'div',
            { className: 'payment-header' },
            _react2.default.createElement(
              _semanticUiReact.Header,
              { as: 'h3' },
              t('Payments made'),
              ' (',
              paymentsSafe.length,
              ')',
              srStatus === 'refunded' && _react2.default.createElement(
                _semanticUiReact.Label,
                { basic: true, size: 'small', className: 'refund-status-label' },
                t('REFUNDED', { ns: _translation.TRANSLATION_FILES.translation })
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              this.isUserHqOrBranchLeaders() && srStatus === 'paid_unverified' && _react2.default.createElement(
                _semanticUiReact.Dropdown,
                {
                  inline: true,
                  className: 'payment-status-dropdown',
                  trigger: _react2.default.createElement(
                    'span',
                    { className: 'status-wrapper' },
                    _react2.default.createElement('img', {
                      src: srStatus === 'paid_verified' ? _document_green2.default : _document_yellow2.default,
                      alt: srStatus === 'paid_verified' ? 'verified' : 'pending'
                    }),
                    _react2.default.createElement(
                      'span',
                      null,
                      this.getPaymentStatusLabel(srStatus)
                    )
                  )
                },
                _react2.default.createElement(
                  _semanticUiReact.Dropdown.Menu,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Dropdown.Item,
                    { disabled: paymentsSafe.length === 0, onClick: function onClick() {
                        return _this3.showConfirm('paid_verified');
                      } },
                    _react2.default.createElement(
                      'div',
                      { className: 'status-wrapper' },
                      _react2.default.createElement('img', { src: _document_green2.default, alt: 'Verified' }),
                      _react2.default.createElement(
                        'span',
                        null,
                        t('Verified')
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Dropdown.Item,
                    { disabled: paymentsSafe.length === 0, onClick: function onClick() {
                        return _this3.showConfirm('verification_rejected');
                      } },
                    _react2.default.createElement(
                      'div',
                      { className: 'status-wrapper' },
                      _react2.default.createElement('img', { src: _document_red2.default, alt: 'Rejected' }),
                      _react2.default.createElement(
                        'span',
                        null,
                        t('Rejected')
                      )
                    )
                  )
                )
              ),
              this.isUserHqOrBranchLeaders() && srStatus === 'verification_rejected' && amountMinorPaid >= amountMinor && _react2.default.createElement(_semanticUiReact.Button, { color: 'teal', icon: 'check', onClick: function onClick() {
                  return _this3.showConfirm('paid_verified');
                }, content: t('Mark as verified'), className: 'btn-verify-link' }),
              srStatus !== 'paid_verified' && hasBeenDenied && status !== 'paid_verified' && _react2.default.createElement(
                'span',
                { className: 'status-wrapper' },
                _react2.default.createElement('img', {
                  src: _document_red2.default,
                  alt: 'Rejected'
                }),
                _react2.default.createElement(
                  'span',
                  null,
                  t('Rejected')
                )
              ),
              status === 'paid_verified' && DISPLAY_STATUS_MAP.includes(srStatus) && _react2.default.createElement(
                'span',
                { className: 'status-wrapper' },
                _react2.default.createElement('img', {
                  src: _document_green2.default,
                  alt: 'Verified'
                }),
                _react2.default.createElement(
                  'span',
                  null,
                  t('Verified')
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'payment-display' },
            sortedPayments.map(function (tx, index) {
              var showConfirmDropdown = tx.method !== 'online' && tx.status !== 'completed' && !RESTRICTED_DROPDOWN_STATUSES.includes(srStatus);
              var isOpen = activeIndex === index;
              return _react2.default.createElement(
                _semanticUiReact.Segment,
                { key: tx.id || index, clearing: true, style: { padding: '0' } },
                _react2.default.createElement(
                  'div',
                  {
                    onClick: function onClick() {
                      return _this3.handleCardClick(index);
                    },
                    role: 'button',
                    tabIndex: 0,
                    onKeyDown: function onKeyDown(e) {
                      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleCardClick(index);
                      }
                    },
                    className: 'div-payment-card-display'
                  },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(_semanticUiReact.Icon, { name: isOpen ? 'chevron down' : 'chevron right' }),
                    _react2.default.createElement(
                      'span',
                      { className: 'currency-payment-format' },
                      _this3.formatCurrency(tx.amountMinor, currencyCode)
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'payment-method' },
                      t(tx.method)
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    null,
                    tx.status !== 'pending' && _react2.default.createElement(
                      _semanticUiReact.Label,
                      {
                        basic: true,
                        color: function () {
                          if (tx.status === 'completed') return 'teal';
                          if (tx.status === 'failed') return 'red';
                          return 'orange';
                        }(),
                        horizontal: true
                      },
                      _this3.getStatusLabel(tx)
                    ),
                    showConfirmDropdown && _react2.default.createElement(
                      _semanticUiReact.Dropdown,
                      {
                        inline: true,
                        pointing: 'top right',
                        className: 'payment-card-dropdown',
                        trigger: _react2.default.createElement(
                          'span',
                          { className: 'payment-card-dropdown-hover-text' },
                          _react2.default.createElement(
                            'span',
                            null,
                            t('Confirm Amount')
                          ),
                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'dropdown', style: { margin: 0 } })
                        )
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Dropdown.Menu,
                        null,
                        _react2.default.createElement(_semanticUiReact.Dropdown.Item, {
                          icon: 'check',
                          text: t('Full'),
                          disabled: tx.status === 'completed',
                          onClick: function onClick() {
                            return _this3.handleApprove(tx.id);
                          }
                        }),
                        _react2.default.createElement(_semanticUiReact.Dropdown.Item, {
                          icon: 'pencil',
                          text: t('Partial'),
                          disabled: tx.status === 'completed' || tx.status === 'failed',
                          onClick: function onClick() {
                            return _this3.handlePartial(tx.id, tx.amountMinor, amountMinor, tx.status === 'completed' ? amountMinorPaid - tx.amountMinor : amountMinorPaid, currencyCode);
                          }
                        })
                      )
                    )
                  )
                ),
                isOpen && _react2.default.createElement(
                  'div',
                  {
                    className: 'payment-card-open'
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'payment-open-title' },
                    t('Transaction details'),
                    ' '
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    { columns: 2, stackable: true },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 8 },
                        _react2.default.createElement(
                          'div',
                          { className: 'div-text-holder' },
                          _react2.default.createElement(
                            'div',
                            { className: 'div-text' },
                            t('Paid by')
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'div-value' },
                            tx.paidByBuyerName || 'N/A'
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'div-text-holder' },
                          _react2.default.createElement(
                            'div',
                            { className: 'div-text' },
                            t('Payment Method')
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'div-value', style: { display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '0.4rem' } },
                            tx.method ? t(tx.method) : 'N/A',
                            _this3.renderPaymentMethodPills(tx.metadata)
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'div-text-holder' },
                          _react2.default.createElement(
                            'div',
                            { className: 'div-text' },
                            t('Payment received')
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'div-value' },
                            _this3.formatCurrency(tx.amountMinor, currencyCode)
                          )
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 8 },
                        _react2.default.createElement(
                          'div',
                          { className: 'div-text-holder' },
                          _react2.default.createElement(
                            'div',
                            { className: 'div-text' },
                            t('Payment received at')
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'div-value' },
                            tx.paidAt ? _react2.default.createElement(_Timestamp2.default, { format: 'DD MMM YYYY, hh:mm A', timestamp: tx.paidAt }) : 'N/A'
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'div-text-holder' },
                          _react2.default.createElement(
                            'div',
                            { className: 'div-text' },
                            t('Reference')
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'div-value' },
                            tx.referenceNumber || 'N/A'
                          )
                        ),
                        tx.receiptMediaID && _react2.default.createElement(
                          'div',
                          { className: 'div-text-holder' },
                          _react2.default.createElement(
                            'div',
                            { className: 'div-text' },
                            t('Attachment')
                          ),
                          _react2.default.createElement(
                            'div',
                            { className: 'attachment-inline-wrapper' },
                            buyerAttachmentsLoading ? _react2.default.createElement(_semanticUiReact.Loader, { active: true, inline: true, size: 'tiny' }) : buyerAttachmentsMap[tx.receiptMediaID] ? _react2.default.createElement(_AttachmentItem2.default, {
                              small: true,
                              fileName: buyerAttachmentsMap[tx.receiptMediaID],
                              downloadUrl: _this3.getViewLink(tx.receiptMediaID, buyerAttachmentsMap[tx.receiptMediaID])
                            }) : _react2.default.createElement(
                              'span',
                              null,
                              t('Attachment unavailable')
                            )
                          )
                        )
                      )
                    )
                  ),
                  receiptsMap[tx.id] && _react2.default.createElement(
                    'div',
                    { className: 'div-text-holder div-text-holder--align-top' },
                    _react2.default.createElement(
                      'div',
                      { className: 'div-text' },
                      t('Official receipt')
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'attachment-inline-wrapper' },
                      _react2.default.createElement(
                        'div',
                        { className: 'attachment-list' },
                        _react2.default.createElement(_AttachmentItem2.default, {
                          small: true,
                          fileName: 'receipt_token_payment_' + tx.id + '.pdf',
                          downloadUrl: _this3.getViewLink(receiptsMap[tx.id], 'receipt_token_payment_' + tx.id + '.pdf')
                        })
                      )
                    )
                  ),
                  tx.method === 'online' && function () {
                    var meta = tx.metadata || [];
                    var transactionCode = _this3.getMetadataValue(meta, 'transaction_code');
                    var tokenCode = _this3.getMetadataValue(meta, 'token_code');
                    var bankReferCode = _this3.getMetadataValue(meta, 'bank_refer_code');
                    var paymentMethod = _this3.getMetadataValue(meta, 'payment_method');
                    var orderCode = _this3.getMetadataValue(meta, 'order_code');
                    var orderDescription = _this3.getMetadataValue(meta, 'order_description');
                    var allFields = [tokenCode && { label: 'Token Code', value: tokenCode, copyable: true }, transactionCode && { label: 'Transaction Code', value: transactionCode, copyable: true }, bankReferCode && { label: 'Bank Reference Code', value: bankReferCode, copyable: true }, paymentMethod && { label: 'Payment Method Code', value: paymentMethod, truncate: false }, { label: 'Order Code', value: orderCode, copyable: true }, { label: 'Order Description', value: orderDescription, truncate: false }].filter(Boolean);
                    var leftFields = allFields.filter(function (_, i) {
                      return i % 2 === 0;
                    });
                    var rightFields = allFields.filter(function (_, i) {
                      return i % 2 === 1;
                    });
                    return _react2.default.createElement(
                      'div',
                      { className: 'payment-metadata-segment' },
                      _react2.default.createElement(
                        _semanticUiReact.Grid,
                        { columns: 2, stackable: true },
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { width: 8 },
                            leftFields.map(function (f) {
                              return _this3.renderMetadataField(f.label, f.value, f.copyable, f.truncate);
                            })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { width: 8 },
                            rightFields.map(function (f) {
                              return _this3.renderMetadataField(f.label, f.value, f.copyable, f.truncate);
                            })
                          )
                        )
                      )
                    );
                  }()
                )
              );
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 5 },
          _react2.default.createElement(
            _semanticUiReact.Segment,
            { raised: true },
            _react2.default.createElement(
              'div',
              { className: 'div-summary-container' },
              _react2.default.createElement(
                _semanticUiReact.Header,
                { as: 'h4', style: { margin: 0 } },
                t('Summary')
              ),
              paymentsSafe.length > 0 && _react2.default.createElement(
                _semanticUiReact.Label,
                {
                  basic: true,
                  size: 'mini',
                  color: summaryLabelColor
                },
                summaryLabelText
              )
            ),
            _react2.default.createElement(_semanticUiReact.Divider, null),
            _react2.default.createElement(
              _semanticUiReact.List,
              { verticalAlign: 'middle' },
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                _react2.default.createElement(
                  _semanticUiReact.List.Content,
                  { floated: 'right' },
                  this.formatCurrency(amountMinor, currencyCode)
                ),
                _react2.default.createElement(
                  _semanticUiReact.List.Content,
                  null,
                  t('Total Booking Fee')
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.List.Item,
                null,
                _react2.default.createElement(
                  _semanticUiReact.List.Content,
                  { floated: 'right' },
                  this.formatCurrency(amountMinorPaid, currencyCode)
                ),
                _react2.default.createElement(
                  _semanticUiReact.List.Content,
                  null,
                  t('Payments made')
                )
              )
            ),
            _react2.default.createElement(_semanticUiReact.Divider, null),
            _react2.default.createElement(
              'div',
              { className: 'div-currency-container' },
              _react2.default.createElement(
                'span',
                null,
                t('Outstanding')
              ),
              _react2.default.createElement(
                'span',
                null,
                this.formatCurrency(outstandingMinor, currencyCode)
              )
            )
          ),
          refundRecord && _react2.default.createElement(
            'div',
            { className: 'refund-container' },
            _react2.default.createElement(
              _semanticUiReact.Segment,
              {
                onClick: function onClick() {
                  return _this3.setState({ isAccountInfoOpen: !_this3.state.isAccountInfoOpen });
                },
                className: 'refund-card ' + (this.state.isAccountInfoOpen ? 'is-open' : '')
              },
              _react2.default.createElement(
                'span',
                { className: 'refund-title-text' },
                t('Refund account information')
              ),
              _react2.default.createElement(_semanticUiReact.Icon, { name: this.state.isAccountInfoOpen ? 'chevron up' : 'chevron down' })
            ),
            this.state.isAccountInfoOpen && _react2.default.createElement(
              _semanticUiReact.Segment,
              {
                className: 'refund-card-open'
              },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 2 },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'refund-row' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 6, className: 'label' },
                    t('Bank')
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 10, textAlign: 'right', className: 'value' },
                    refundRecord.bankName || 'N/A'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'refund-row' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 6, className: 'label' },
                    t('Beneficiary name')
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 10, textAlign: 'right', className: 'value' },
                    refundRecord.bankAccountName || 'N/A'
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'refund-row' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 8, className: 'label' },
                    t('Beneficiary acc no.')
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 8, textAlign: 'right', className: 'value' },
                    refundRecord.bankAccountNumber || 'N/A'
                  )
                )
              )
            )
          ),
          SHOW_PAYMENT_TIMELINE && _react2.default.createElement(
            _react2.default.Fragment,
            null,
            _react2.default.createElement(
              _semanticUiReact.Header,
              { as: 'h4' },
              t('Timeline')
            ),
            _react2.default.createElement(
              'div',
              { className: 'payment-timeline', style: { marginTop: '0.5rem' } },
              _react2.default.createElement(_TimelineLog2.default, {
                activityLog: timelineLogs,
                hasMore: timelineHasMore,
                isLoadingMore: timelineLoading,
                onLoadMore: this.loadMoreTimeline
              })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            open: this.state.partialModalOpen,
            size: 'small',
            onClose: this.handlePartialCancel,
            closeOnDimmerClick: !this.state.partialLoading,
            closeOnEscape: !this.state.partialLoading,
            style: {
              padding: '1.5rem 1.5rem 0.5rem 1.5rem',
              borderTop: 'none',
              boxShadow: 'none'
            }
          },
          _react2.default.createElement(
            'h2',
            { style: { fontSize: '1.25rem', fontWeight: 'bold', margin: '0 0 1rem 0', color: '#000' } },
            t('Partial payment received')
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              'p',
              { style: { color: '#444', marginBottom: '1.5rem', lineHeight: '1.4' } },
              _react2.default.createElement(_reactI18next.Trans, { i18nKey: 'partial_payment_instruction', components: [_react2.default.createElement('strong', null)], t: t })
            ),
            _react2.default.createElement(
              'div',
              { style: { marginBottom: '1rem' } },
              _react2.default.createElement(
                'div',
                { style: { fontSize: '0.85rem', color: '#888', marginBottom: '0.25rem' } },
                t('SUBMITTED AMOUNT')
              ),
              _react2.default.createElement(
                'div',
                { style: { fontSize: '1.4rem', fontWeight: 'bold' } },
                this.formatCurrency(this.state.partialOriginalAmount, this.state.partialCurrencyCode)
              )
            ),
            _react2.default.createElement(
              'div',
              { style: { marginBottom: '1rem' } },
              _react2.default.createElement(
                'label',
                { htmlFor: 'partial-amount-input', style: { fontSize: '0.85rem', fontWeight: 'bold', display: 'block', marginBottom: '0.4rem' } },
                t('TOTAL RECEIVED TO DATE'),
                ' ',
                _react2.default.createElement(
                  'span',
                  { style: { color: 'red' } },
                  '*'
                )
              ),
              _react2.default.createElement(_semanticUiReact.Input, {
                id: 'partial-amount-input',
                fluid: true,
                type: 'text',
                inputMode: 'decimal',
                pattern: '[0-9]*\\\\.?[0-9]*',
                value: this.state.partialAmount,
                onChange: this.handlePartialAmountChange,
                label: this.state.partialCurrencyCode,
                placeholder: '0'
              }),
              this.state.partialError && _react2.default.createElement(
                'p',
                { style: { color: 'red', marginTop: '0.4rem', fontSize: '0.85rem' } },
                this.state.partialError
              )
            ),
            function () {
              var code = _this3.state.partialCurrencyCode;
              var rawMajor = Number(_this3.state.partialAmount);
              var inputMinor = !isNaN(rawMajor) && rawMajor > 0 ? (0, _currencyMinor.majorToMinor)(rawMajor, code) : null;
              var previewOutstandingMinor = inputMinor !== null ? _this3.state.partialTokenAmount - _this3.state.partialAlreadyPaid - inputMinor : null;
              return _react2.default.createElement(
                'div',
                { style: { border: '1px solid #e0e0e0', borderRadius: '4px', overflow: 'hidden', marginTop: '0.5rem' } },
                _react2.default.createElement(
                  'div',
                  { style: { display: 'flex', justifyContent: 'space-between', padding: '0.6rem 0.8rem', borderBottom: '1px solid #e0e0e0', color: '#444' } },
                  _react2.default.createElement(
                    'span',
                    null,
                    t('Booking fee')
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    _this3.formatCurrency(_this3.state.partialTokenAmount, code)
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { style: { display: 'flex', justifyContent: 'space-between', padding: '0.6rem 0.8rem', borderBottom: '1px solid #e0e0e0', color: '#444' } },
                  _react2.default.createElement(
                    'span',
                    null,
                    t('Confirmed paid amount')
                  ),
                  _react2.default.createElement(
                    'span',
                    null,
                    inputMinor !== null ? _this3.formatCurrency(inputMinor, code) : '—'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { style: { display: 'flex', justifyContent: 'space-between', padding: '0.6rem 0.8rem', fontWeight: 'bold' } },
                  _react2.default.createElement(
                    'span',
                    null,
                    t('Remaining Outstanding')
                  ),
                  _react2.default.createElement(
                    'span',
                    { style: { color: previewOutstandingMinor !== null && previewOutstandingMinor > 0 ? '#e07b00' : 'inherit' } },
                    previewOutstandingMinor !== null ? _this3.formatCurrency(previewOutstandingMinor, code) : '—'
                  )
                )
              );
            }()
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(
              _semanticUiReact.Button,
              { basic: true, onClick: this.handlePartialCancel, disabled: this.state.partialLoading },
              t('Cancel')
            ),
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                basic: true,
                onClick: this.submitPartialPayment,
                loading: this.state.partialLoading,
                disabled: this.state.partialLoading
              },
              t('Request Outstanding')
            )
          )
        ),
        _react2.default.createElement(_semanticUiReact.Confirm, {
          open: this.state.confirmOpen,
          header: this.state.pendingStatus === 'paid_verified' ? t('Verify Payment') : t('Reject Payment'),
          content: t('Are you sure you want to change the status of this booking?'),
          onCancel: this.handleCancel,
          onConfirm: this.handleConfirm,
          cancelButton: t('cancel'),
          confirmButton: t('Confirm update'),
          size: 'mini'
        })
      );
    }
  }]);

  return Payment;
}(_react.Component);

Payment.contextTypes = {
  store: _propTypes2.default.object
};
Payment.propTypes = {
  loading: _propTypes2.default.bool,
  TokenPaymentCSRF: _propTypes2.default.string,
  onUpdateOpportunity: _propTypes2.default.func,
  // The refund record is read only when this opportunity's sr_status can carry one.
  opportunity: _propTypes2.default.shape({ sr_status: _propTypes2.default.string }),
  paymentData: _propTypes2.default.shape({
    currencyCode: _propTypes2.default.string,
    amountMinorPaid: _propTypes2.default.number,
    amountMinor: _propTypes2.default.number,
    status: _propTypes2.default.string,
    id: _propTypes2.default.string,
    payments: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
      amountMinor: _propTypes2.default.number,
      method: _propTypes2.default.string,
      status: _propTypes2.default.string,
      paidAt: _propTypes2.default.string,
      createdAt: _propTypes2.default.string,
      notes: _propTypes2.default.string,
      paidByBuyerName: _propTypes2.default.string,
      metadata: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        key: _propTypes2.default.string,
        label: _propTypes2.default.string,
        value: _propTypes2.default.string
      }))
    }))
  }),
  t: _propTypes2.default.func.isRequired,
  fetchBooking: _propTypes2.default.func,
  fetchPaymentDetails: _propTypes2.default.func,
  auth: _propTypes2.default.shape({
    isDeveloperSupervisor: _propTypes2.default.bool,
    isDeveloperSalesManager: _propTypes2.default.bool,
    isDeveloperSalesAdmin: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isAdmin: _propTypes2.default.bool,
    isBranchLeader: _propTypes2.default.bool,
    isBranchLeaderSupervisor: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool
  }),
  data: _propTypes2.default.shape({
    sr_status: _propTypes2.default.string,
    sr_verify_rejected_at: _propTypes2.default.string
  })
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(Payment);

/***/ }),
/* 2367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = __webpack_require__(2);

var _translation = __webpack_require__(4);

var _UCBGridDivider = __webpack_require__(574);

var _UCBGridDivider2 = _interopRequireDefault(_UCBGridDivider);

var _PurchaserSection = __webpack_require__(2368);

var _PurchaserSection2 = _interopRequireDefault(_PurchaserSection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var Purchaser = function (_Component) {
  _inherits(Purchaser, _Component);

  _createClass(Purchaser, null, [{
    key: 'getDerivedStateFromProps',
    value: function getDerivedStateFromProps(props) {
      return Purchaser.getPropsToState(props);
    }
  }]);

  function Purchaser(props) {
    _classCallCheck(this, Purchaser);

    var _this = _possibleConstructorReturn(this, (Purchaser.__proto__ || Object.getPrototypeOf(Purchaser)).call(this, props));

    _this.state = Purchaser.getPropsToState(props);
    return _this;
  }

  _createClass(Purchaser, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          token = _props.token;
      var _state = this.state,
          data = _state.data,
          loading = _state.loading;

      var primaryCustomer = _lodash2.default.get(data, 'primary_customer', null);
      var secondaryCustomers = _lodash2.default.get(data, 'customers', []);
      var hasSecondary = secondaryCustomers.length > 0;
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 10 }, active: loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'uc-grid-title-row' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    t('Purchaser Details', { ns: _translation.TRANSLATION_FILES.screens })
                  )
                ),
                _react2.default.createElement(_PurchaserSection2.default, {
                  customerId: _lodash2.default.get(data, 'primary_customer_id'),
                  contact: _lodash2.default.get(primaryCustomer, 'contact', {}),
                  token: token,
                  label: hasSecondary ? t('Primary Purchaser', { ns: _translation.TRANSLATION_FILES.screens }) : null
                }),
                secondaryCustomers.map(function (customer, index) {
                  return _react2.default.createElement(
                    _react2.default.Fragment,
                    { key: customer.id || index },
                    _react2.default.createElement(_UCBGridDivider2.default, null),
                    _react2.default.createElement(_PurchaserSection2.default, {
                      customerId: customer.id,
                      contact: customer.contact || {},
                      token: token,
                      label: t('Purchaser', { ns: _translation.TRANSLATION_FILES.screens }) + ' ' + (index + 2)
                    })
                  );
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Purchaser;
}(_react.Component);

Purchaser.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.array]),
  loading: _propTypes2.default.bool,
  t: _propTypes2.default.func,
  token: _propTypes2.default.string
};

Purchaser.getPropsToState = function (props) {
  var data = props.data;
  if (Array.isArray(data)) {
    data = data[0];
  }
  return { data: data, loading: props.loading };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(Purchaser);

/***/ }),
/* 2368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _moment = __webpack_require__(12);

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _translation = __webpack_require__(4);

var _fetchM = __webpack_require__(6);

var _UCBGridDivider = __webpack_require__(574);

var _UCBGridDivider2 = _interopRequireDefault(_UCBGridDivider);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _countries = __webpack_require__(60);

var _countries2 = _interopRequireDefault(_countries);

var _intlFlagCodes = __webpack_require__(141);

var _intlFlagCodes2 = _interopRequireDefault(_intlFlagCodes);

var _vietnam = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len, react/forbid-prop-types, camelcase, prefer-template, jsx-a11y/no-static-element-interactions, react/sort-comp */


var PurchaserSection = function (_Component) {
  _inherits(PurchaserSection, _Component);

  function PurchaserSection(props) {
    var _this2 = this;

    _classCallCheck(this, PurchaserSection);

    var _this = _possibleConstructorReturn(this, (PurchaserSection.__proto__ || Object.getPrototypeOf(PurchaserSection)).call(this, props));

    _this.handleFetchImages = function () {
      var _this$props$contact = _this.props.contact,
          contact = _this$props$contact === undefined ? {} : _this$props$contact;
      // These links are supplied by Book API after it has checked access to the opportunity.
      // Do not rebuild the old customer-only URL here: it lacks the opportunity scope.

      _this.fetchIdentityImage('front', contact.ic_front_link);
      _this.fetchIdentityImage('back', contact.ic_back_link);
    };

    _this.resetIdentityImage = function (image) {
      var _nextState;

      var fetching = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var stateKey = image === 'front' ? 'icFrontBlob' : 'icBackBlob';
      var flagKey = image === 'front' ? 'fetchingFront' : 'fetchingBack';
      var previousURL = _this.state[stateKey];
      if (previousURL) URL.revokeObjectURL(previousURL);
      var nextState = (_nextState = {}, _defineProperty(_nextState, stateKey, null), _defineProperty(_nextState, stateKey + 'Raw', null), _defineProperty(_nextState, flagKey, fetching), _nextState);
      if (_this.state.selectedSrc === previousURL) {
        nextState.showLarge = false;
        nextState.selectedSrc = null;
      }
      _this.setState(nextState);
    };

    _this.fetchIdentityImage = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(image, imageURL) {
        var token, store, stateKey, flagKey, requestVersion, blob, _this$setState, url, _this$setState2, _this$setState3;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                token = _this.props.token;
                store = _this.context.store;
                stateKey = image === 'front' ? 'icFrontBlob' : 'icBackBlob';
                flagKey = image === 'front' ? 'fetchingFront' : 'fetchingBack';
                requestVersion = _this.imageRequestVersions[image] + 1;

                _this.imageRequestVersions[image] = requestVersion;

                if (!(!token || !imageURL)) {
                  _context.next = 9;
                  break;
                }

                _this.resetIdentityImage(image);
                return _context.abrupt('return');

              case 9:

                _this.resetIdentityImage(image, true);
                _context.prev = 10;
                _context.next = 13;
                return (0, _fetchM.serverRequestGetBlob)(imageURL, store);

              case 13:
                blob = _context.sent;

                if (_this.mounted && _this.imageRequestVersions[image] === requestVersion) {
                  if (blob) {
                    url = URL.createObjectURL(blob);

                    _this.setState((_this$setState = {}, _defineProperty(_this$setState, stateKey, url), _defineProperty(_this$setState, stateKey + 'Raw', blob), _this$setState));
                  } else {
                    _this.setState((_this$setState2 = {}, _defineProperty(_this$setState2, stateKey, null), _defineProperty(_this$setState2, stateKey + 'Raw', null), _this$setState2));
                  }
                }
                _context.next = 20;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](10);

                if (_this.mounted && _this.imageRequestVersions[image] === requestVersion) {
                  _this.setState((_this$setState3 = {}, _defineProperty(_this$setState3, stateKey, null), _defineProperty(_this$setState3, stateKey + 'Raw', null), _this$setState3));
                }

              case 20:
                _context.prev = 20;

                if (_this.mounted && _this.imageRequestVersions[image] === requestVersion) {
                  _this.setState(_defineProperty({}, flagKey, false));
                }
                return _context.finish(20);

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[10, 17, 20, 23]]);
      }));

      return function (_x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleViewImage = function (src, label) {
      _this.setState({ showLarge: true, selectedSrc: src, selectedLabel: label });
    };

    _this.handleCloseLarge = function () {
      _this.setState({ showLarge: false, selectedSrc: null });
    };

    _this.getDownloadExtension = function (blob) {
      var mimeType = (blob && blob.type || '').toLowerCase().split(';')[0].trim();
      var mimeTypeToExtension = {
        'image/jpeg': 'jpg',
        'image/jpg': 'jpg',
        'image/png': 'png',
        'image/gif': 'gif',
        'image/webp': 'webp',
        'image/bmp': 'bmp',
        'image/tiff': 'tiff',
        'application/pdf': 'pdf'
      };
      return mimeTypeToExtension[mimeType] || 'jpg';
    };

    _this.handleDownloadAll = function () {
      var _this$state = _this.state,
          icFrontBlob = _this$state.icFrontBlob,
          icFrontBlobRaw = _this$state.icFrontBlobRaw,
          icBackBlob = _this$state.icBackBlob,
          icBackBlobRaw = _this$state.icBackBlobRaw;

      var files = [{ url: icFrontBlob, blob: icFrontBlobRaw, name: 'CCCD_Front' }, { url: icBackBlob, blob: icBackBlobRaw, name: 'CCCD_Back' }];
      files.forEach(function (file) {
        if (file.url && file.blob) {
          var extension = _this.getDownloadExtension(file.blob);
          var link = document.createElement('a');
          link.href = file.url;
          link.download = file.name + '.' + extension;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      });
    };

    _this.mounted = false;
    _this.imageRequestVersions = { front: 0, back: 0 };
    _this.state = {
      icFrontBlob: null,
      icBackBlob: null,
      icFrontBlobRaw: null,
      icBackBlobRaw: null,
      fetchingFront: false,
      fetchingBack: false,
      showLarge: false,
      selectedSrc: null,
      selectedLabel: ''
    };
    return _this;
  }

  _createClass(PurchaserSection, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.mounted = true;
      this.handleFetchImages();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var customerChanged = this.props.customerId !== prevProps.customerId;
      var tokenChanged = this.props.token !== prevProps.token;
      var currentContact = this.props.contact || {};
      var previousContact = prevProps.contact || {};
      var imageLinksChanged = currentContact.ic_front_link !== previousContact.ic_front_link || currentContact.ic_back_link !== previousContact.ic_back_link;
      if (customerChanged || tokenChanged || imageLinksChanged) {
        this.handleFetchImages();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.mounted = false;
      if (this.state.icFrontBlob) URL.revokeObjectURL(this.state.icFrontBlob);
      if (this.state.icBackBlob) URL.revokeObjectURL(this.state.icBackBlob);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          t = _props.t,
          _props$contact = _props.contact,
          contact = _props$contact === undefined ? {} : _props$contact,
          label = _props.label;
      var _contact$name = contact.name,
          name = _contact$name === undefined ? 'N/A' : _contact$name,
          _contact$preferred_na = contact.preferred_name,
          preferred_name = _contact$preferred_na === undefined ? '' : _contact$preferred_na,
          _contact$title = contact.title,
          title = _contact$title === undefined ? 'N/A' : _contact$title,
          _contact$gender = contact.gender,
          gender = _contact$gender === undefined ? 'N/A' : _contact$gender,
          _contact$date_of_birt = contact.date_of_birth,
          date_of_birth = _contact$date_of_birt === undefined ? 'N/A' : _contact$date_of_birt,
          _contact$nationality_ = contact.nationality_country_code,
          nationality_country_code = _contact$nationality_ === undefined ? 'N/A' : _contact$nationality_,
          _contact$mobile = contact.mobile,
          mobile = _contact$mobile === undefined ? '' : _contact$mobile,
          _contact$mobile_count = contact.mobile_country_code,
          mobile_country_code = _contact$mobile_count === undefined ? '' : _contact$mobile_count,
          _contact$email = contact.email,
          email = _contact$email === undefined ? 'N/A' : _contact$email,
          _contact$address_ = contact.address_1,
          address_1 = _contact$address_ === undefined ? 'N/A' : _contact$address_,
          _contact$address_2 = contact.address_2,
          address_2 = _contact$address_2 === undefined ? 'N/A' : _contact$address_2,
          _contact$city = contact.city,
          ward = _contact$city === undefined ? 'N/A' : _contact$city,
          _contact$postcode = contact.postcode,
          postcode = _contact$postcode === undefined ? 'N/A' : _contact$postcode,
          _contact$state = contact.state,
          state = _contact$state === undefined ? 'N/A' : _contact$state,
          _contact$country_code = contact.country_code,
          country_code = _contact$country_code === undefined ? '' : _contact$country_code,
          _contact$cccd = contact.cccd,
          cccd = _contact$cccd === undefined ? '' : _contact$cccd,
          _contact$passport = contact.passport,
          passport = _contact$passport === undefined ? '' : _contact$passport,
          _contact$identity_typ = contact.identity_type,
          identity_type = _contact$identity_typ === undefined ? '' : _contact$identity_typ,
          _contact$other_identi = contact.other_identity,
          other_identity = _contact$other_identi === undefined ? '' : _contact$other_identi,
          _contact$marital_stat = contact.marital_status,
          marital_status = _contact$marital_stat === undefined ? 'N/A' : _contact$marital_stat;

      var identityLabel = void 0;
      var identityValue = void 0;
      switch (identity_type) {
        case '1':
          identityLabel = t('CCCD', { ns: _translation.TRANSLATION_FILES.screens });
          identityValue = cccd || 'N/A';
          break;
        case '2':
          identityLabel = t('Passport', { ns: _translation.TRANSLATION_FILES.screens });
          identityValue = passport || 'N/A';
          break;
        case '3':
          identityLabel = t('Enterprise Registration Number', { ns: _translation.TRANSLATION_FILES.screens });
          identityValue = other_identity || 'N/A';
          break;
        default:
          identityLabel = 'N/A';
          identityValue = 'N/A';
          break;
      }
      var formattedDate = date_of_birth && date_of_birth !== 'N/A' ? (0, _moment2.default)(date_of_birth).format('DD/MM/YYYY') : 'N/A';
      var country = _countries2.default.find(function (item) {
        return item.countryCode === (country_code || '').toLowerCase();
      }) || {};
      var nationality = _countries2.default.find(function (item) {
        return item.countryCode === (nationality_country_code || '').toLowerCase();
      }) || {};
      // CPI-1248: show the citizenship the CRM actually declared. This row used to be derived purely
      // from nationality, which made it disagree with the two Vietnam rules - both read the
      // declaration, not the passport. A Vietnamese-national purchaser declared `foreigner` read as
      // Local here while the rules refused them, and an undeclared purchaser with a foreign
      // nationality read as Foreigner while the quota did not count them at all. Nationality stays
      // as the fallback for rows that predate the field, which is what Sales > Purchaser already does.
      var declaredCitizenship = (0, _vietnam.crmContactCitizenship)(contact);
      var isForeigner = declaredCitizenship ? declaredCitizenship === _vietnam.CITIZENSHIP_FOREIGNER : nationality.countryCode !== 'vn';
      var citizenship = isForeigner ? t('Foreigner', { ns: _translation.TRANSLATION_FILES.translation, country: nationality.name || 'N/A' }) : t('Local', { ns: _translation.TRANSLATION_FILES.translation });
      var countryMatch = _intlFlagCodes2.default.find(function (item) {
        return item.countryCode === (mobile_country_code || '').toLowerCase();
      }) || {};
      var mobilePrefix = countryMatch && countryMatch.value ? '+' + countryMatch.value : '';

      return _react2.default.createElement(
        _react2.default.Fragment,
        null,
        label && _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'uc-grid-title-row' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            label
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'uc-grid-detail-row' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 3 },
            identityLabel
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 5 },
            identityValue
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 3 },
            _react2.default.createElement(
              'span',
              null,
              t('Title', { ns: _translation.TRANSLATION_FILES.screens })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 5 },
            _react2.default.createElement(
              'span',
              null,
              t(title, { ns: _translation.TRANSLATION_FILES.screens })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'uc-grid-detail-row' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 3 },
            _react2.default.createElement(
              'span',
              null,
              t('Full Name', { ns: _translation.TRANSLATION_FILES.screens })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 5 },
            _react2.default.createElement(
              'span',
              null,
              name,
              preferred_name ? ' (' + preferred_name + ')' : ''
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 3 },
            _react2.default.createElement(
              'span',
              null,
              t('Gender', { ns: _translation.TRANSLATION_FILES.screens })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 5 },
            _react2.default.createElement(
              'span',
              { style: { textTransform: 'capitalize' } },
              t(gender.toLowerCase(), { ns: _translation.TRANSLATION_FILES.screens })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'uc-grid-detail-row' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 3 },
            _react2.default.createElement(
              'span',
              null,
              t('Date of birth', { ns: _translation.TRANSLATION_FILES.screens })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 5 },
            _react2.default.createElement(
              'span',
              null,
              formattedDate
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 3 },
            _react2.default.createElement(
              'span',
              null,
              t('Nationality', { ns: _translation.TRANSLATION_FILES.screens })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 5 },
            _react2.default.createElement(
              'span',
              null,
              nationality.name || 'N/A'
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'uc-grid-detail-row' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 3 },
            _react2.default.createElement(
              'span',
              null,
              t('Mobile no.', { ns: _translation.TRANSLATION_FILES.screens })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 5 },
            _react2.default.createElement(
              'span',
              null,
              mobilePrefix,
              ' ',
              mobile
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 3 },
            _react2.default.createElement(
              'span',
              null,
              t('Email', { ns: _translation.TRANSLATION_FILES.screens })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 5 },
            _react2.default.createElement(
              'span',
              null,
              email
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'uc-grid-detail-row' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 3 },
            _react2.default.createElement(
              'span',
              null,
              t('Marital Status', { ns: _translation.TRANSLATION_FILES.screens })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 5 },
            _react2.default.createElement(
              'span',
              { style: { textTransform: 'capitalize' } },
              t(marital_status.toLowerCase(), { ns: _translation.TRANSLATION_FILES.screens })
            )
          )
        ),
        _react2.default.createElement(_UCBGridDivider2.default, null),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'uc-grid-detail-row' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 3 },
            _react2.default.createElement(
              'span',
              null,
              t('Address Line 1 (House No, Street)', { ns: _translation.TRANSLATION_FILES.screens })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 5 },
            _react2.default.createElement(
              'span',
              null,
              address_1
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 3 },
            _react2.default.createElement(
              'span',
              null,
              t('Address Line 2 (Street)', { ns: _translation.TRANSLATION_FILES.screens })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 5 },
            _react2.default.createElement(
              'span',
              null,
              address_2
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'uc-grid-detail-row' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 3 },
            _react2.default.createElement(
              'span',
              null,
              t('Citizenship', { ns: _translation.TRANSLATION_FILES.screens })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 5 },
            _react2.default.createElement(
              'span',
              null,
              citizenship
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 3 },
            _react2.default.createElement(
              'span',
              null,
              t('Postal Code', { ns: _translation.TRANSLATION_FILES.screens })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 5 },
            _react2.default.createElement(
              'span',
              null,
              postcode
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'uc-grid-detail-row' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 3 },
            _react2.default.createElement(
              'span',
              null,
              t('Ward', { ns: _translation.TRANSLATION_FILES.screens })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 5 },
            _react2.default.createElement(
              'span',
              null,
              ward
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 3 },
            _react2.default.createElement(
              'span',
              null,
              t('City / Province', { ns: _translation.TRANSLATION_FILES.screens })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 5 },
            _react2.default.createElement(
              'span',
              null,
              state
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'uc-grid-detail-row' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 3 },
            _react2.default.createElement(
              'span',
              null,
              t('Country', { ns: _translation.TRANSLATION_FILES.screens })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 5 },
            _react2.default.createElement(
              'span',
              null,
              country.name || 'N/A'
            )
          )
        ),
        _react2.default.createElement(_UCBGridDivider2.default, null),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { className: 'uc-grid-detail-row' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16 },
            _react2.default.createElement(
              'div',
              { className: 'cccd-download-button-container' },
              _react2.default.createElement(
                'span',
                null,
                t('Identity Snapshot', { ns: _translation.TRANSLATION_FILES.screens })
              ),
              (this.state.icFrontBlob || this.state.icBackBlob) && _react2.default.createElement(
                _semanticUiReact.Button,
                { className: 'cccd-download-button', onClick: this.handleDownloadAll },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'download' }),
                t('Download All', { ns: _translation.TRANSLATION_FILES.screens })
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 8 },
            _react2.default.createElement(
              'div',
              { className: 'cccd-image-container ' + (!this.state.icFrontBlob ? 'is-empty' : ''), onClick: function onClick() {
                  return _this3.state.icFrontBlob && _this3.handleViewImage(_this3.state.icFrontBlob, t('CCCD Front'));
                } },
              _react2.default.createElement(_LoadImage2.default, { loading: this.state.fetchingFront, src: this.state.icFrontBlob, size: 'medium' })
            )
          ),
          identity_type === '1' && _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 8 },
            _react2.default.createElement(
              'div',
              { className: 'cccd-image-container ' + (!this.state.icBackBlob ? 'is-empty' : ''), onClick: function onClick() {
                  return _this3.state.icBackBlob && _this3.handleViewImage(_this3.state.icBackBlob, t('CCCD Back'));
                } },
              _react2.default.createElement(_LoadImage2.default, { loading: this.state.fetchingBack, src: this.state.icBackBlob, size: 'medium' })
            )
          )
        ),
        _react2.default.createElement(_ViewLarge2.default, {
          open: this.state.showLarge,
          onClose: this.handleCloseLarge,
          src: this.state.selectedSrc,
          picture: { label: this.state.selectedLabel }
        })
      );
    }
  }]);

  return PurchaserSection;
}(_react.Component);

PurchaserSection.propTypes = {
  contact: _propTypes2.default.object,
  customerId: _propTypes2.default.string,
  token: _propTypes2.default.string,
  label: _propTypes2.default.string,
  t: _propTypes2.default.func
};
PurchaserSection.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(PurchaserSection);

/***/ }),
/* 2369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var SNAPSHOT_MEDIA_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'pdf', 'webp', 'gif', 'bmp', 'tif', 'tiff']);

var EXPECTED_SIDES = {
  '1': [{ side: 'front', label: 'CCCD Front' }, { side: 'back', label: 'CCCD Back' }],
  '2': [{ side: 'front', label: 'Passport' }],
  '3': [{ side: 'front', label: 'Enterprise Registration' }]
};

var nonBlank = function nonBlank(value) {
  return value != null && String(value).trim() !== '';
};

var toID = function toID(value) {
  return nonBlank(value) ? String(value) : '';
};

var purchaserName = function purchaserName() {
  var customer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var contact = customer.contact || {};
  return contact.preferred_name || contact.name || customer.preferred_name || customer.name || 'Purchaser';
};

var safeFileName = function safeFileName(media, label) {
  var candidate = media && (media.name || media.label);
  if (!nonBlank(candidate)) return label;
  var basename = String(candidate).split(/[\\/]/).pop().trim();
  return basename || label;
};

var snapshotIsReady = exports.snapshotIsReady = function snapshotIsReady(opportunity) {
  return !!(opportunity && nonBlank(opportunity.snapshot_frozen_at));
};

var expectedSnapshotPurchaserIDs = exports.expectedSnapshotPurchaserIDs = function expectedSnapshotPurchaserIDs() {
  var opportunity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var ids = [opportunity.primary_customer_id, opportunity.primary_customer && opportunity.primary_customer.id].concat(Array.isArray(opportunity.customer_ids) ? opportunity.customer_ids : []).filter(nonBlank).map(toID);
  return Array.from(new Set(ids));
};

var expectedCustomers = function expectedCustomers() {
  var opportunity = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var customers = [];
  if (opportunity.primary_customer) customers.push(opportunity.primary_customer);
  if (Array.isArray(opportunity.customers)) customers.push.apply(customers, _toConsumableArray(opportunity.customers));
  var byID = new Map();
  customers.forEach(function (customer) {
    if (customer && nonBlank(customer.id)) byID.set(toID(customer.id), customer);
  });
  return byID;
};

var isScopedSnapshotMediaURL = exports.isScopedSnapshotMediaURL = function isScopedSnapshotMediaURL(link, opportunityID, customerID, snapshotContactID, side, apiOrigin) {
  if (!nonBlank(link) || !nonBlank(opportunityID) || !nonBlank(customerID) || !nonBlank(snapshotContactID)) return false;
  try {
    // Links arrive from Book API. Reject a foreign absolute or protocol-relative URL instead of
    // treating it as an authenticated snapshot-media link merely because its path looks familiar.
    if (String(link).startsWith('//')) return false;
    var baseOrigin = apiOrigin || window.location.origin;
    var parsed = new URL(link, baseOrigin);
    var approvedOrigin = new URL(baseOrigin, window.location.origin).origin;
    if (parsed.origin !== approvedOrigin) return false;
    var segments = parsed.pathname.split('/').filter(Boolean).map(decodeURIComponent);
    return segments.length === 4 && segments[0] === 'opportunity' && segments[1] === 'customer_id_' + side && segments[2] === toID(customerID) && parsed.searchParams.get('opportunity_id') === toID(opportunityID) && parsed.searchParams.get('contact_id') === toID(snapshotContactID);
  } catch (e) {
    return false;
  }
};

var extensionOfPath = function extensionOfPath(value) {
  if (!nonBlank(value)) return '';
  var basename = String(value).split(/[?#]/)[0].split(/[\\/]/).pop() || '';
  var match = /\.([a-z0-9]+)$/i.exec(basename);
  return match ? match[1].toLowerCase() : '';
};

var mediaExtension = function mediaExtension(media) {
  if (!media) return '';
  var explicit = nonBlank(media.extension) ? String(media.extension).toLowerCase().replace(/^\./, '') : '';
  var candidates = [explicit, extensionOfPath(media.name), extensionOfPath(media.key)];
  return candidates.find(function (candidate) {
    return SNAPSHOT_MEDIA_EXTENSIONS.has(candidate);
  }) || '';
};

var unavailableRow = function unavailableRow(_ref) {
  var customerID = _ref.customerID,
      name = _ref.name,
      label = _ref.label,
      role = _ref.role;
  return {
    id: 'snapshot-' + customerID + '-' + role + '-unavailable',
    customerID: customerID,
    snapshotDocument: true,
    snapshotUnavailable: true,
    fileName: label + ' \u2014 unavailable',
    fileType: 'identity',
    purchaserName: name,
    snapshotLabel: label
  };
};

var snapshotRow = function snapshotRow(_ref2) {
  var opportunity = _ref2.opportunity,
      customerID = _ref2.customerID,
      customer = _ref2.customer,
      ref = _ref2.ref,
      side = _ref2.side,
      label = _ref2.label,
      apiOrigin = _ref2.apiOrigin;

  var contact = customer.contact || {};
  var media = contact['ic_' + side];
  var link = contact['ic_' + side + '_link'];
  var extension = mediaExtension(media);
  var row = {
    customerID: customerID,
    name: purchaserName(customer),
    label: label,
    role: side
  };
  if (!extension || !isScopedSnapshotMediaURL(link, opportunity.id, customerID, ref.snapshot_contact_id, side, apiOrigin)) {
    return unavailableRow(row);
  }
  return {
    id: 'snapshot-' + customerID + '-' + side,
    customerID: customerID,
    snapshotDocument: true,
    snapshotURL: link,
    snapshotExtension: extension,
    fileName: safeFileName(media, label),
    fileType: 'identity',
    purchaserName: row.name,
    snapshotLabel: label
  };
};

// Snapshot readiness is authoritative. Once frozen, this deliberately emits an unavailable row
// for incomplete refs or a failed snapshot hydration instead of reading the live CRM customer.
var getSnapshotIdentityDocuments = exports.getSnapshotIdentityDocuments = function getSnapshotIdentityDocuments(opportunity, apiOrigin) {
  if (!snapshotIsReady(opportunity)) return [];
  var purchasers = expectedSnapshotPurchaserIDs(opportunity);
  var refsByCustomerID = new Map((opportunity.snapshot_contacts || []).filter(function (ref) {
    return ref && nonBlank(ref.customer_id);
  }).map(function (ref) {
    return [toID(ref.customer_id), ref];
  }));
  var customersByID = expectedCustomers(opportunity);

  return purchasers.reduce(function (rows, customerID) {
    var ref = refsByCustomerID.get(customerID);
    var customer = customersByID.get(customerID);
    var contact = customer && customer.contact;
    var name = purchaserName(customer);
    var snapshotContactID = ref && toID(ref.snapshot_contact_id);
    var hydratedFromSnapshot = !!(snapshotContactID && contact && toID(contact.id) === snapshotContactID);
    var sides = hydratedFromSnapshot ? EXPECTED_SIDES[String(contact.identity_type)] : null;

    if (!sides) {
      rows.push(unavailableRow({ customerID: customerID, name: name, label: 'Identity Snapshot', role: 'identity' }));
      return rows;
    }
    sides.forEach(function (_ref3) {
      var side = _ref3.side,
          label = _ref3.label;
      return rows.push(snapshotRow({ opportunity: opportunity, customerID: customerID, customer: customer, ref: ref, side: side, label: label, apiOrigin: apiOrigin }));
    });
    return rows;
  }, []);
};

// Only the Book API's old generated mirror name is hidden after a frozen snapshot exists.
// A user-uploaded identity document remains visible, including when it has no sourceApp field.
var isGeneratedIdentityMirror = exports.isGeneratedIdentityMirror = function isGeneratedIdentityMirror() {
  var document = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (document.fileType !== 'identity' || !nonBlank(document.fileName)) return false;
  var sourceApp = document.sourceApp || document.source_app;
  if (sourceApp && !['mhub-book-api', 'mhub-lead-integrations', 'mhub-marketplace-api'].includes(sourceApp)) return false;
  return (/^identity_[12]_[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}_[0-9a-f]{1,8}\.(?:jpe?g|png|pdf)$/i.test(document.fileName)
  );
};

var detectSnapshotMediaType = exports.detectSnapshotMediaType = function detectSnapshotMediaType(bytes) {
  var value = bytes instanceof Uint8Array ? bytes : new Uint8Array(bytes || []);
  if (value.length >= 3 && value[0] === 0xFF && value[1] === 0xD8 && value[2] === 0xFF) {
    return { mimeType: 'image/jpeg', extension: 'jpg', previewable: true };
  }
  if (value.length >= 8 && value[0] === 0x89 && value[1] === 0x50 && value[2] === 0x4E && value[3] === 0x47 && value[4] === 0x0D && value[5] === 0x0A && value[6] === 0x1A && value[7] === 0x0A) {
    return { mimeType: 'image/png', extension: 'png', previewable: true };
  }
  if (value.length >= 5 && value[0] === 0x25 && value[1] === 0x50 && value[2] === 0x44 && value[3] === 0x46 && value[4] === 0x2D) {
    return { mimeType: 'application/pdf', extension: 'pdf', previewable: false, pdf: true };
  }
  return null;
};

var snapshotFileName = exports.snapshotFileName = function snapshotFileName(fileName, extension) {
  var basename = String(fileName || 'Identity Snapshot').split(/[\\/]/).pop() || 'Identity Snapshot';
  var stem = basename.replace(/\.[^.]+$/, '') || 'Identity Snapshot';
  return stem + '.' + extension;
};

var snapshotDownloadOnlyExtension = exports.snapshotDownloadOnlyExtension = function snapshotDownloadOnlyExtension(extension) {
  return SNAPSHOT_MEDIA_EXTENSIONS.has(extension) ? extension : '';
};

/***/ }),
/* 2370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _bookingFeePaymentStatuses = __webpack_require__(1039);

var _bookingFeePaymentStatuses2 = _interopRequireDefault(_bookingFeePaymentStatuses);

var _centsFloat = __webpack_require__(175);

var _valueToText = __webpack_require__(98);

var _valueToText2 = _interopRequireDefault(_valueToText);

var _vietnam = __webpack_require__(40);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /* eslint-disable react/forbid-prop-types */

// import Timestamp from '../../components/Timestamp';

var OfflinePaymentItem = function OfflinePaymentItem(_ref) {
  var approvePayment = _ref.approvePayment,
      auth = _ref.auth,
      handleModalOpen = _ref.handleModalOpen,
      item = _ref.item,
      rejectPayment = _ref.rejectPayment,
      handleOpenAttachment = _ref.handleOpenAttachment,
      currentFilter = _ref.currentFilter,
      isTablet = _ref.isTablet,
      t = _ref.t;

  if (!item.booking) return null;
  var isVATab = currentFilter === 'virtual_account';
  // CPI-974 (D3): Vietnam relabels the deposit statuses; vnDepositStatusLabel is null for MY/ID.
  var statusLabel = (0, _vietnam.vnDepositStatusLabel)(auth, t, item.status) || t((0, _valueToText2.default)(_bookingFeePaymentStatuses2.default, item.status));
  return _react2.default.createElement(
    _semanticUiReact.Table.Row,
    {
      positive: item.status === 'paid',
      negative: item.status === 'rejected'
    },
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { width: 3 },
      item.status === 'pending_verification' ? _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _semanticUiReact.Button,
          {
            className: 'large-hide small-hide tablet-hide',
            floated: 'right',
            color: 'green',
            onClick: function onClick(e) {
              return approvePayment(e, item.id);
            },
            size: 'mini',
            compact: true
          },
          t('Approve')
        ),
        _react2.default.createElement(
          _semanticUiReact.Button,
          {
            className: 'large-hide small-hide tablet-hide',
            floated: 'right',
            color: 'red',
            onClick: function onClick(e) {
              return rejectPayment(e, item.id);
            },
            size: 'mini',
            compact: true
          },
          t('Reject')
        )
      ) : null,
      _react2.default.createElement(
        'a',
        {
          rel: 'noopener noreferrer',
          target: '_blank',
          href: '/bookings/' + item.booking.id + '/'
        },
        item.booking.projectUnit.reference,
        ', ',
        _react2.default.createElement('br', { className: 'large-hide' }),
        item.booking.project.name,
        ', ',
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          'small',
          null,
          item.booking.code
        )
      )
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      null,
      item.booking.customer.customerDetail.name
    ),
    isVATab && _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { className: 'large-hide small-hide tablet-hide' },
      item.transferredToVABank + ' - ' + item.transferredToVAAccountNumber
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { collapsing: true },
      _react2.default.createElement(
        'span',
        { className: 'large-hide small-hide tablet-hide', style: { float: 'right' } },
        statusLabel
      ),
      _react2.default.createElement(_LoanAmount2.default, {
        format: '0,000,000.00',
        amount: (0, _centsFloat.centsToFloat)(item.amountCents),
        prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
      }),
      item.paymentPictures && item.paymentPictures.length > 0 ? _react2.default.createElement(
        'span',
        null,
        '\xA0',
        _react2.default.createElement(
          'button',
          {
            className: 'a-button-blue large-hide small-hide tablet-hide',
            onClick: function onClick(e) {
              return handleOpenAttachment(e, item);
            },
            title: 'View Attachments'
          },
          '(',
          _react2.default.createElement(
            'b',
            null,
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'attach' }),
            item.paymentPictures.length,
            ')'
          )
        )
      ) : ''
    ),
    isVATab && _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { className: 'mobile-hide', textAlign: 'right' },
      item.transferredToVABank + ' - ' + item.transferredToVAAccountNumber
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      {
        className: 'mobile-hide',
        style: { textTransform: 'capitalize' },
        collapsing: !(isVATab || isTablet),
        textAlign: 'right'
      },
      statusLabel,
      item.paymentPictures && item.paymentPictures.length > 0 ? _react2.default.createElement(
        'span',
        null,
        '\xA0',
        _react2.default.createElement(
          _semanticUiReact.Button,
          {
            className: 'mobile-hide',
            onClick: function onClick(e) {
              return handleOpenAttachment(e, item);
            },
            compact: true,
            size: 'mini',
            color: 'vk',
            title: 'View Attachments'
          },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'attach' }),
          ' ',
          item.paymentPictures.length
        )
      ) : ''
    ),
    _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { collapsing: !isTablet, width: 2, textAlign: 'right' },
      item.status === 'pending_verification' ? _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(
          _semanticUiReact.Button,
          { className: 'mobile-hide', color: 'green', onClick: function onClick(e) {
              return handleModalOpen(e, 'approve', item.id, item.booking);
            } },
          t('Approve')
        ),
        _react2.default.createElement(
          _semanticUiReact.Button,
          { className: 'mobile-hide', style: isTablet ? { marginTop: '10px' } : null, color: 'red', onClick: function onClick(e) {
              return handleModalOpen(e, 'reject', item.id, item.booking);
            } },
          t('Reject')
        )
      ) : null
    )
  );
};

OfflinePaymentItem.propTypes = {
  auth: _propTypes2.default.object,
  item: _propTypes2.default.object,
  approvePayment: _propTypes2.default.func,
  rejectPayment: _propTypes2.default.func,
  handleModalOpen: _propTypes2.default.func,
  handleOpenAttachment: _propTypes2.default.func,
  currentFilter: _propTypes2.default.string,
  isTablet: _propTypes2.default.bool,
  t: _propTypes2.default.func
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces)))(OfflinePaymentItem);

/***/ }),
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _reactRouterRedux = __webpack_require__(13);

var _lodash = __webpack_require__(36);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _reactI18next = __webpack_require__(3);

var _OfflinePaymentItem = __webpack_require__(2370);

var _OfflinePaymentItem2 = _interopRequireDefault(_OfflinePaymentItem);

var _AttachmentModal = __webpack_require__(585);

var _AttachmentModal2 = _interopRequireDefault(_AttachmentModal);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _url = __webpack_require__(19);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var FILTERS = [{ value: 'all', text: 'All', isShow: true }, { value: 'bank_transfer', text: 'Bank Transfer', isShow: true }, { value: 'virtual_account', text: 'Virtual Account', isShow: true }, { value: 'cheque', text: 'Cheque', isShow: true }, { value: 'cash', text: 'Cash', isShow: true }, { value: 'credit_card', text: 'Credit Card', isShow: true }, { value: 'others', text: 'Others', isShow: true }];

var OfflinePayments = function (_Component) {
  _inherits(OfflinePayments, _Component);

  function OfflinePayments(props) {
    _classCallCheck(this, OfflinePayments);

    var _this = _possibleConstructorReturn(this, (OfflinePayments.__proto__ || Object.getPrototypeOf(OfflinePayments)).call(this, props));

    _initialiseProps.call(_this);

    var state = OfflinePayments.getPropsToState(props);
    _this.state = _extends({
      count: 0,
      data: [],
      genericErrMsg: 'An error occurred, please refresh page',
      limit: 10,
      loading: true,
      modal: {
        isOpen: false,
        type: '',
        bookingData: {},
        paymentID: ''
      },
      attachmentModalState: false,
      attachmentModalData: {},
      offset: 0,
      token: ''
    }, state);
    return _this;
  }

  _createClass(OfflinePayments, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _state = this.state,
          currentFilter = _state.currentFilter,
          filters = _state.filters;

      var oriQuery = (0, _url.decodeSearch)(this.props.location.search);
      var query = (0, _url.decodeSearch)(this.props.location.search);
      if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
        delete query.page;
      }
      if (!query.filter) {
        query.filter = currentFilter;
      } else if (query.filter && !filters.some(function (t) {
        return t.value === query.filters;
      })) {
        query.filter = currentFilter;
      }
      if (!(0, _lodash.isEqual)(oriQuery, query)) this.replaceQuery(query);
      this.fetchBookingFeePayments(query);
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = OfflinePayments.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, res);
      });
    }
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _context = this.context,
          store = _context.store,
          router = _context.router;
      var pathname = router.location.pathname;

      var newQueryParams = Object.assign({}, query);
      if (resetPage) {
        newQueryParams.page = 1;
      }
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(newQueryParams)));
      this.fetchBookingFeePayments(newQueryParams);
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'fetchBookingFeePayments',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var store, genericErrMsg, query, queryString, response, count, data, limit, offset, token;
        return regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                genericErrMsg = this.state.genericErrMsg;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                if (query.filter === 'all') delete query.filter;
                queryString = '';

                if (_qs2.default.stringify(query)) {
                  queryString = '?' + _qs2.default.stringify(query);
                }
                _context2.next = 9;
                return this.setLoading(true);

              case 9:
                _context2.prev = 9;
                _context2.next = 12;
                return (0, _fetchM.serverRequestGet)('/manage/booking_fee_payments/' + queryString, store);

              case 12:
                response = _context2.sent;
                count = response.count, data = response.data, limit = response.limit, offset = response.offset, token = response.token;
                _context2.next = 16;
                return this.setLoading(false);

              case 16:
                this.setState({
                  count: count, data: data, limit: limit, offset: offset, token: token
                });
                _context2.next = 22;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t0 = _context2['catch'](9);

                this.handleError(store, genericErrMsg, _context2.t0, true);

              case 22:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee, this, [[9, 19]]);
      }));

      function fetchBookingFeePayments(_x4) {
        return _ref.apply(this, arguments);
      }

      return fetchBookingFeePayments;
    }()
  }, {
    key: 'handleError',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(store, msg, errorObj) {
        var isBugsnag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        return regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(false);

              case 2:
                _context3.next = 4;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: msg }));

              case 4:
                if (isBugsnag) Bugsnag.notifyException(errorObj);

              case 5:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleError(_x5, _x6, _x7) {
        return _ref2.apply(this, arguments);
      }

      return handleError;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var t = this.props.t;
      var _state2 = this.state,
          _state2$count = _state2.count,
          count = _state2$count === undefined ? 0 : _state2$count,
          currentFilter = _state2.currentFilter,
          currentPageNum = _state2.currentPageNum,
          filters = _state2.filters,
          _state2$limit = _state2.limit,
          limit = _state2$limit === undefined ? 10 : _state2$limit,
          loading = _state2.loading,
          modal = _state2.modal,
          attachmentModalData = _state2.attachmentModalData,
          attachmentModalState = _state2.attachmentModalState,
          _state2$offset = _state2.offset,
          offset = _state2$offset === undefined ? 1 : _state2$offset,
          search = _state2.search,
          isTablet = _state2.isTablet;
      var _state$data = this.state.data,
          data = _state$data === undefined ? [] : _state$data;

      if (!data) data = [];
      var isVATab = currentFilter === 'virtual_account';
      var exportItems = [{
        text: 'CSV',
        href: this.getExportURL('csv'),
        icon: 'download'
      }, {
        text: 'Excel',
        href: this.getExportURL('excel'),
        icon: 'download'
      }];
      var sortItems = [{
        text: 'Latest Payment',
        icon: 'sort alphabet ascending',
        sortColumn: 'booking_fee_payment.created_at',
        sortDirection: 'desc'
      }, {
        text: 'Oldest Payment',
        icon: 'sort alphabet descending',
        sortColumn: 'booking_fee_payment.created_at',
        sortDirection: 'asc'
      }, {
        text: 'Customer Name Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'booking__customer__customer_detail.name',
        sortDirection: 'asc'
      }, {
        text: 'Customer Name Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'booking__customer__customer_detail.name',
        sortDirection: 'desc'
      }];
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            basic: true,
            open: modal.isOpen,
            onClose: this.handleModalOnClose
          },
          _react2.default.createElement(_semanticUiReact.Header, { icon: modal.type === 'approve' ? 'check' : 'x', content: modal.type === 'approve' ? t('Approve Payment') : t('Reject Payment') }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Modal.Description,
              null,
              modal.type === 'approve' && _react2.default.createElement(
                'p',
                null,
                t('Confirm Approve payment for'),
                '\xA0',
                modal.bookingData.projectUnit.reference,
                ', ',
                _react2.default.createElement('br', { className: 'large-hide' }),
                modal.bookingData.project.name,
                ', ',
                _react2.default.createElement(
                  'small',
                  null,
                  modal.bookingData.code
                ),
                '?'
              ),
              modal.type === 'reject' && _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  t('Confirm Reject payment for'),
                  '\xA0',
                  modal.bookingData.projectUnit.reference,
                  ', ',
                  _react2.default.createElement('br', { className: 'large-hide' }),
                  modal.bookingData.project.name,
                  ', ',
                  _react2.default.createElement(
                    'small',
                    null,
                    modal.bookingData.code
                  ),
                  '?'
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleModalOnClose, icon: 'cancel', content: 'No' }),
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: modal.type === 'approve',
              negative: modal.type === 'reject',
              onClick: function onClick(e) {
                if (modal.type === 'approve') {
                  _this4.approvePayment(e, modal.paymentID);
                }
                if (modal.type === 'reject') {
                  _this4.rejectPayment(e, modal.paymentID);
                }
              },
              icon: 'checkmark',
              content: modal.type === 'approve' ? t('Approve') : t('Reject')
            })
          )
        ),
        _react2.default.createElement(_AttachmentModal2.default, {
          modalState: attachmentModalState,
          data: attachmentModalData,
          onClose: this.handleCloseAttachment
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Menu,
                {
                  stackable: true,
                  secondary: true,
                  color: 'blue'
                },
                filters.map(function (filter, key) {
                  return _react2.default.createElement(
                    _semanticUiReact.Menu.Item,
                    {
                      key: key,
                      name: filter.value,
                      onClick: _this4.handleChangeFilter,
                      active: currentFilter === filter.value,
                      style: { margin: '0 2px' }
                    },
                    t(filter.text).toUpperCase()
                  );
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_SearchFilter2.default, {
                isLoading: loading,
                onChange: this.handleFilterOnChange,
                onClose: this.handleClearFilter,
                search: search,
                placeholder: t('Search Purchaser, Project Name, IC'),
                leftNav: _react2.default.createElement(_PageNav2.default, {
                  currentPage: currentPageNum,
                  count: count || 0,
                  limit: limit || 10,
                  offset: offset || 0,
                  dataSize: data.length || 0,
                  loading: loading,
                  onChange: this.handleChangePage
                }),
                rightNav: count > 0 && !loading ? _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { style: isVATab ? { marginTop: '-2.2em' } : null },
                  _react2.default.createElement(
                    _semanticUiReact.Header,
                    { as: 'h4', textAlign: 'right' },
                    this.getCountDisplay(count, currentPageNum, limit, offset)
                  ),
                  isVATab && _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'right' },
                    _react2.default.createElement(_SortButton2.default, {
                      floated: 'right',
                      loading: loading,
                      items: sortItems,
                      onSort: this.handleSortData
                    }),
                    _react2.default.createElement(_SortButton2.default, {
                      floated: 'right',
                      icon: 'download',
                      loading: loading,
                      items: exportItems
                    })
                  )
                ) : _react2.default.createElement('span', null)
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'app--listdata' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { style: { zIndex: 20 }, active: loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              data && data.length > 0 ? _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 2, className: 'equal height' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    _react2.default.createElement(
                      _semanticUiReact.Table,
                      { celled: true, collapsing: true },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Header,
                        { className: 'mobile-hide' },
                        _react2.default.createElement(
                          _semanticUiReact.Table.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            t('Booking')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            t('Purchaser')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            t('Amount')
                          ),
                          isVATab && _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { textAlign: 'right' },
                            t('Virtual Account')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { textAlign: 'right' },
                            t('Status')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { textAlign: 'center' },
                            t('Manage')
                          )
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Body,
                        null,
                        data.map(function (item, index) {
                          return _react2.default.createElement(_OfflinePaymentItem2.default, {
                            key: index,
                            auth: _this4.props.auth,
                            item: item,
                            approvePayment: _this4.approvePayment,
                            rejectPayment: _this4.rejectPayment,
                            handleModalOpen: _this4.handleModalOpen,
                            handleOpenAttachment: _this4.handleOpenAttachment,
                            currentFilter: currentFilter,
                            isTablet: isTablet
                          });
                        })
                      )
                    )
                  )
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Segment,
                { textAlign: 'center' },
                _react2.default.createElement(
                  'p',
                  null,
                  t('No payments found'),
                  '.'
                )
              )
            )
          )
        )
      );
    }
  }]);

  return OfflinePayments;
}(_react.Component);

OfflinePayments.contextTypes = {
  store: _propTypes2.default.object,
  router: _propTypes2.default.object
};
OfflinePayments.propTypes = {
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.object,
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool
  }),
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};

OfflinePayments.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var filters = FILTERS.filter(function (e) {
    return e.isShow;
  });
  var currentFilter = filters.some(function (t) {
    return t.value === query.filter;
  }) ? query.filter : filters[0].value;
  var currentPageNum = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  var windowWidth = window.innerWidth;
  var isTablet = windowWidth >= 768 && windowWidth < 992;
  return {
    currentFilter: currentFilter,
    currentPageNum: currentPageNum,
    filters: filters,
    search: search,
    isTablet: isTablet
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.approvePayment = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(e, paymentID) {
      var modal, data;
      return regeneratorRuntime.wrap(function _callee3$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              e.preventDefault();
              modal = {
                isOpen: false,
                type: '',
                bookingData: {},
                paymentID: ''
              };
              _context4.next = 4;
              return _this5.setComponentState({ modal: modal });

            case 4:
              data = {
                approvedName: _this5.props.auth.preferredName,
                approvedUserID: _this5.props.auth.id,
                approvedAt: (0, _momentTimezone2.default)().toDate(),
                status: 'paid'
              };
              _context4.next = 7;
              return _this5.updateBookingFeePayment(data, paymentID);

            case 7:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee3, _this5);
    }));

    return function (_x9, _x10) {
      return _ref3.apply(this, arguments);
    };
  }();

  this.rejectPayment = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e, paymentID) {
      var modal, data;
      return regeneratorRuntime.wrap(function _callee4$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              e.preventDefault();
              modal = {
                isOpen: false,
                type: '',
                bookingData: {},
                paymentID: ''
              };
              _context5.next = 4;
              return _this5.setComponentState({ modal: modal });

            case 4:
              data = {
                rejectedName: _this5.props.auth.preferredName,
                rejectedUserID: _this5.props.auth.id,
                rejectedAt: (0, _momentTimezone2.default)().toDate(),
                status: 'rejected'
              };
              _context5.next = 7;
              return _this5.updateBookingFeePayment(data, paymentID);

            case 7:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee4, _this5);
    }));

    return function (_x11, _x12) {
      return _ref4.apply(this, arguments);
    };
  }();

  this.getCountDisplay = function (count, currentPageNum, limit, offset) {
    var fromCount = offset || 1;
    var toCount = currentPageNum * limit;
    var totalCount = count || 0;
    if (totalCount < toCount) toCount = totalCount;

    return fromCount + '-' + toCount + ' of ' + totalCount;
  };

  this.handleChangeFilter = function (e, _ref5) {
    var name = _ref5.name;

    var currentFilter = name;
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    _this5.setState({
      currentFilter: currentFilter,
      data: [],
      offset: 0,
      count: 0,
      limit: 3,
      currentPageNum: 1
    }, function () {
      _this5.replaceQuery({
        filter: currentFilter,
        search: query.search || null
      }, true);
    });
  };

  this.handleChangePage = function (currentPageNum) {
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    query.page = currentPageNum;
    _this5.setState({
      currentPageNum: currentPageNum
    });
    _this5.replaceQuery(query);
  };

  this.handleResize = function () {
    var windowWidth = window.innerWidth;
    var isTablet = windowWidth >= 768 && windowWidth < 992;
    if (isTablet !== _this5.state.isTablet) {
      _this5.setState({ isTablet: isTablet });
    }
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this5.replaceQuery(query, true);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    _this5.setState({
      search: ''
    }, function () {
      if (hasQuery) {
        _this5.replaceQuery(query, true);
      }
    });
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    query[queryName] = value;
    _this5.replaceQuery(query, true);
  };

  this.handleModalOnClose = function (e) {
    e.preventDefault();
    var modal = {
      isOpen: false,
      type: '',
      bookingData: {},
      paymentID: ''
    };
    _this5.setState({ modal: modal });
  };

  this.handleModalOpen = function (e, type, paymentID, bookingData) {
    e.preventDefault();
    var modal = {
      isOpen: true,
      type: type,
      bookingData: bookingData,
      paymentID: paymentID
    };
    _this5.setState({ modal: modal });
  };

  this.handleOpenAttachment = function (e, data) {
    e.preventDefault();
    var d = {};
    d.paymentPictures = data.paymentPictures;
    d.bookingID = data.bookingID;
    _this5.setState({
      attachmentModalState: true,
      attachmentModalData: d
    });
  };

  this.handleCloseAttachment = function () {
    _this5.setState({
      attachmentModalState: false
    });
  };

  this.updateBookingFeePayment = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var dataToUpdate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var paymentID = arguments[1];

      var _state3, data, genericErrMsg, token, store, response, i;

      return regeneratorRuntime.wrap(function _callee5$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _state3 = _this5.state, data = _state3.data, genericErrMsg = _state3.genericErrMsg, token = _state3.token;
              store = _this5.context.store;
              _context6.prev = 2;
              _context6.next = 5;
              return _this5.setLoading(true);

            case 5:
              _context6.next = 7;
              return (0, _fetchM.serverRequestPut)('/manage/booking_fee_payments/' + paymentID + '/', store, token, dataToUpdate);

            case 7:
              response = _context6.sent;
              _context6.next = 10;
              return _this5.setLoading(false);

            case 10:
              if (!response.error) {
                _context6.next = 14;
                break;
              }

              _context6.next = 13;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: response.message }));

            case 13:
              return _context6.abrupt('return');

            case 14:
              i = data.findIndex(function (val) {
                return val.id === paymentID;
              });

              if (!(i === -1)) {
                _context6.next = 18;
                break;
              }

              _this5.handleError(store, genericErrMsg);
              return _context6.abrupt('return');

            case 18:
              data[i] = Object.assign(data[i], dataToUpdate);
              _this5.setState({ data: data });

              _context6.next = 22;
              return store.dispatch((0, _flash.flashSuccessMessage)({ message: 'Payment updated.' }));

            case 22:
              _context6.next = 27;
              break;

            case 24:
              _context6.prev = 24;
              _context6.t0 = _context6['catch'](2);

              _this5.handleError(store, genericErrMsg, _context6.t0, true);

            case 27:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee5, _this5, [[2, 24]]);
    }));

    return function () {
      return _ref6.apply(this, arguments);
    };
  }();

  this.getExportURL = function (type) {
    var query = Object.assign({}, (0, _url.decodeSearch)(_this5.props.location.search));
    query.fileType = type;
    if (query.filter === 'all') delete query.filter;
    return _config2.default.get('bookApiURL') + '/manage/booking_fee_payments/export/?' + _qs2.default.stringify(query);
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces)))(OfflinePayments);

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _semanticUiReact = __webpack_require__(2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactRouter = __webpack_require__(18);

var _flash = __webpack_require__(5);

var _url = __webpack_require__(19);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _fetchM = __webpack_require__(6);

var _isNumber = __webpack_require__(30);

var _centsFloat = __webpack_require__(175);

var _storage = __webpack_require__(44);

var _valueToText = __webpack_require__(98);

var _valueToText2 = _interopRequireDefault(_valueToText);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_momentTimezone2.default.locale('en-gb');

var OnlinePayments = function (_Component) {
  _inherits(OnlinePayments, _Component);

  function OnlinePayments(props) {
    _classCallCheck(this, OnlinePayments);

    var _this = _possibleConstructorReturn(this, (OnlinePayments.__proto__ || Object.getPrototypeOf(OnlinePayments)).call(this, props));

    _initialiseProps.call(_this);

    var state = OnlinePayments.getPropsToState(props);
    state.data = [];
    _this.state = _extends({
      loading: true,
      count: 0,
      limit: 10,
      offset: 0
    }, state, {
      autoReload: false,
      modal: {
        isOpen: false,
        type: '',
        bookingData: {},
        paymentID: ''
      }
    });
    var query = (0, _url.decodeSearch)(props.location.search);
    if (query.projectFilter && query.projectFilter.length > 0) {
      _this.state.advanceFilter = true;
    }
    return _this;
  }

  _createClass(OnlinePayments, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      this.fetchPayments(query);
      var localAutoReloadValue = (0, _storage.getItem)(_config2.default.get('appName') + '.paymentsAutoReload');
      if (localAutoReloadValue === 'true') {
        this.state.autoReload = true;
        this.setRefreshDataTimeout();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = OnlinePayments.getPropsToState(nextProps);
      var query = (0, _url.decodeSearch)(nextProps.location.search);
      if (this.state.limit < 0) {
        this.fetchPayments(query);
        state.loading = this.state.loading;
      }
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.timeoutRefresh) {
        clearTimeout(this.timeoutRefresh);
      }
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'setPayments',
    value: function setPayments() {
      var _this3 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this3.setState({
          data: data || []
        }, res);
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this4 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this4.setState(state, res);
      });
    }
  }, {
    key: 'getPaymentStatus',
    value: function getPaymentStatus(data) {
      var onlinePaymentURL = '';
      if (data.requestStatus === 'payment_submitted' || data.requestStatus === 'payment_completed') {
        onlinePaymentURL = data.responsePaymentURL;
      }
      if (onlinePaymentURL !== '') {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'a',
            { href: data.responsePaymentURL, rel: 'noopener noreferrer', target: '_blank' },
            (0, _valueToText2.default)(this.ONLINE_PAYMENT_STATUS, data.requestStatus)
          ),
          _react2.default.createElement('br', null)
        );
      }
      return _react2.default.createElement(
        'div',
        null,
        (0, _valueToText2.default)(this.ONLINE_PAYMENT_STATUS, data.requestStatus),
        _react2.default.createElement('br', null)
      );
    }
  }, {
    key: 'fetchPayments',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var silentLoad = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var store, query, res, url, queryString, message, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (silentLoad) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber.isNumeric)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                res = void 0;
                _context.prev = 7;
                url = '/manage/payments/';
                queryString = '';

                if (_qs2.default.stringify(query)) {
                  queryString = '?' + _qs2.default.stringify(query);
                }
                _context.next = 13;
                return store.dispatch((0, _fetchM.fetchM)('' + url + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 13:
                res = _context.sent;
                _context.next = 24;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](7);

                Bugsnag.notifyException(_context.t0);
                _context.next = 21;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 21:
                _context.next = 23;
                return this.setLoading(false);

              case 23:
                return _context.abrupt('return');

              case 24:
                if (res.ok) {
                  _context.next = 32;
                  break;
                }

                _context.next = 27;
                return res.text();

              case 27:
                message = _context.sent;
                _context.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 30:
                _context.next = 42;
                break;

              case 32:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 37;
                return res.json();

              case 37:
                data = _context.sent;
                _context.next = 40;
                return this.setPayments(data);

              case 40:
                _context.next = 42;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 42:
                _context.next = 44;
                return this.setLoading(false);

              case 44:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 16]]);
      }));

      function fetchPayments(_x4) {
        return _ref.apply(this, arguments);
      }

      return fetchPayments;
    }()
  }, {
    key: 'approvePayment',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(err, paymentID) {
        var store, modal, query, res, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                err.preventDefault();
                _context2.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                modal = {
                  isOpen: false,
                  type: '',
                  bookingData: {},
                  paymentID: ''
                };
                _context2.next = 7;
                return this.setComponentState({ modal: modal });

              case 7:
                query = (0, _url.decodeSearch)(this.props.location.search);
                res = void 0;
                _context2.prev = 9;
                _context2.next = 12;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/manage/payments/' + paymentID + '/approve/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context2.sent;
                _context2.next = 24;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2['catch'](9);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 20;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 20:
                _context2.next = 22;
                return this.setLoading(false);

              case 22:
                this.fetchPayments(query);
                return _context2.abrupt('return');

              case 24:
                if (res.ok) {
                  _context2.next = 30;
                  break;
                }

                _context2.next = 27;
                return res.text();

              case 27:
                message = _context2.sent;
                _context2.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 30:
                _context2.next = 32;
                return store.dispatch((0, _flash.flashMessage)({
                  header: 'Payment Approved',
                  message: 'MHub Pay request was successfully approved',
                  icon: 'checkmark',
                  type: 'success',
                  autoHideDuration: 5000
                }));

              case 32:
                _context2.next = 34;
                return this.setLoading(false);

              case 34:
                this.fetchPayments(query);

              case 35:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[9, 15]]);
      }));

      function approvePayment(_x6, _x7) {
        return _ref2.apply(this, arguments);
      }

      return approvePayment;
    }()
  }, {
    key: 'rejectPayment',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(err, paymentID) {
        var store, modal, query, res, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                err.preventDefault();
                _context3.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                modal = {
                  isOpen: false,
                  type: '',
                  bookingData: {},
                  paymentID: ''
                };
                _context3.next = 7;
                return this.setComponentState({ modal: modal });

              case 7:
                query = (0, _url.decodeSearch)(this.props.location.search);
                res = void 0;
                _context3.prev = 9;
                _context3.next = 12;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/manage/payments/' + paymentID + '/reject/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context3.sent;
                _context3.next = 23;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3['catch'](9);

                Bugsnag.notifyException(_context3.t0);
                _context3.next = 20;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 20:
                _context3.next = 22;
                return this.setLoading(false);

              case 22:
                return _context3.abrupt('return');

              case 23:
                if (res.ok) {
                  _context3.next = 29;
                  break;
                }

                _context3.next = 26;
                return res.text();

              case 26:
                message = _context3.sent;
                _context3.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 29:
                _context3.next = 31;
                return store.dispatch((0, _flash.flashMessage)({
                  header: 'Payment Rejected',
                  message: 'MHub Pay request was successfully rejected',
                  icon: 'x',
                  type: 'success',
                  autoHideDuration: 5000
                }));

              case 31:
                _context3.next = 33;
                return this.setLoading(false);

              case 33:
                this.fetchPayments(query);

              case 34:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[9, 15]]);
      }));

      function rejectPayment(_x8, _x9) {
        return _ref3.apply(this, arguments);
      }

      return rejectPayment;
    }()
  }, {
    key: 'hasStaffAccess',
    value: function hasStaffAccess() {
      if (this.props.auth.isBranchLeader) {
        return false;
      }
      return true;
    }
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      store.dispatch((0, _reactRouterRedux.replace)('/payments/?' + (0, _url.encodeSearch)(query)));
      this.fetchPayments(query);
    }
  }, {
    key: 'pushQuery',
    value: function pushQuery(query) {
      var store = this.context.store;

      store.dispatch((0, _reactRouterRedux.replace)('/payments/?' + (0, _url.encodeSearch)(query)));
      this.fetchPayments(query);
    }
  }, {
    key: 'hasExportAccess',
    value: function hasExportAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasUserAccess',
    value: function hasUserAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var modal = this.state.modal;

      var exportItems = [{
        text: 'Excel',
        icon: 'download',
        href: _config2.default.get('bookApiURL') + '/manage/payments/export/online/'
      }];
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            basic: true,
            open: modal.isOpen,
            onClose: this.handleModalOnClose
          },
          _react2.default.createElement(_semanticUiReact.Header, { icon: modal.type === 'approve' ? 'check' : 'x', content: modal.type === 'approve' ? 'Approve Payment' : 'Reject Payment' }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Modal.Description,
              null,
              modal.type === 'approve' && _react2.default.createElement(
                'p',
                null,
                'Confirm Approve payment for\xA0',
                modal.bookingData.projectUnit.reference,
                ', ',
                _react2.default.createElement('br', { className: 'large-hide' }),
                modal.bookingData.project.name,
                ', ',
                _react2.default.createElement(
                  'small',
                  null,
                  modal.bookingData.code
                ),
                '?'
              ),
              modal.type === 'reject' && _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'Confirm Reject payment for\xA0',
                  modal.bookingData.projectUnit.reference,
                  ', ',
                  _react2.default.createElement('br', { className: 'large-hide' }),
                  modal.bookingData.project.name,
                  ', ',
                  _react2.default.createElement(
                    'small',
                    null,
                    modal.bookingData.code
                  ),
                  '?'
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleModalOnClose, icon: 'cancel', content: 'No' }),
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: modal.type === 'approve',
              negative: modal.type === 'reject',
              onClick: function onClick(e) {
                if (modal.type === 'approve') {
                  _this5.approvePayment(e, modal.paymentID);
                }
                if (modal.type === 'reject') {
                  _this5.rejectPayment(e, modal.paymentID);
                }
              },
              icon: 'checkmark',
              content: modal.type === 'approve' ? 'Approve' : 'Reject'
            })
          )
        ),
        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_SearchFilter2.default, {
                isLoading: this.state.loading,
                onChange: this.handleFilterOnChange,
                onClose: this.handleClearFilter,
                search: this.state.search,
                placeholder: 'Search Purchaser...',
                leftNav: _react2.default.createElement(_PageNav2.default, {
                  currentPage: this.state.currentPage,
                  count: this.state.count,
                  limit: this.state.limit,
                  offset: this.state.offset,
                  dataSize: this.state.data.length,
                  loading: this.state.loading,
                  onChange: this.handleChangePage
                }),
                rightNav: _react2.default.createElement(
                  'div',
                  null,
                  this.hasExportAccess() && _react2.default.createElement(_SortButton2.default, {
                    icon: 'download',
                    loading: this.state.loading,
                    items: exportItems
                  }),
                  _react2.default.createElement(_SortButton2.default, {
                    loading: this.state.loading,
                    items: this.sortItems,
                    onSort: this.handleSortData
                  })
                )
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'app--listdata' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement('br', { className: 'large-hide' }),
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  'Loading'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { textAlign: 'center', width: 16 },
                    _react2.default.createElement(_semanticUiReact.Button, {
                      onClick: this.handleAutoReload,
                      compact: true,
                      size: 'tiny',
                      icon: this.state.autoReload ? { name: 'toggle on', color: 'green' } : { name: 'toggle off', color: 'red' },
                      content: 'Auto Refresh ' + (this.state.autoReload ? 'On' : 'Off')
                    }),
                    _react2.default.createElement(_semanticUiReact.Button, {
                      color: 'blue',
                      onClick: this.handleRefreshData,
                      compact: true,
                      size: 'tiny',
                      icon: 'refresh',
                      content: 'Refresh Now'
                    })
                  )
                )
              ),
              this.state.data && this.state.data.length > 0 ? _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 2, className: 'equal height' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    _react2.default.createElement(
                      _semanticUiReact.Table,
                      { celled: true, collapsing: true, className: 'online-payments' },
                      this.state.data.length > 0 ? _react2.default.createElement(
                        _semanticUiReact.Table.Header,
                        { className: 'mobile-hide' },
                        _react2.default.createElement(
                          _semanticUiReact.Table.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            'Booking'
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            'Purchaser'
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            'Amount'
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { textAlign: 'right' },
                            'Requester'
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { textAlign: 'right' },
                            'Status'
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            { textAlign: 'center' },
                            'Manage'
                          )
                        )
                      ) : null,
                      _react2.default.createElement(
                        _semanticUiReact.Table.Body,
                        null,
                        this.state.data && this.state.data.length > 0 ? this.state.data.map(function (data, idx) {
                          return _react2.default.createElement(
                            _semanticUiReact.Table.Row,
                            {
                              key: idx,
                              id: data.id,
                              positive: data.requestStatus === 'payment_completed',
                              negative: data.requestStatus === 'payment_failed' || data.requestStatus === 'rejected',
                              className: _this5.getRowClassName(data.requestStatus)
                            },
                            _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              { collapsing: true },
                              _react2.default.createElement(
                                _reactRouter.Link,
                                { to: '/bookings/' + data.booking.id + '/', style: { whiteSpace: 'normal' } },
                                data.requestStatus === 'new' ? _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  {
                                    className: 'large-hide small-hide tablet-hide',
                                    floated: 'right',
                                    color: 'green',
                                    onClick: function onClick(e) {
                                      return _this5.approvePayment(e, data.id);
                                    },
                                    size: 'mini',
                                    compact: true
                                  },
                                  'Approve'
                                ) : null,
                                data.requestStatus === 'new' ? _react2.default.createElement(
                                  _semanticUiReact.Button,
                                  {
                                    className: 'large-hide small-hide tablet-hide',
                                    floated: 'right',
                                    color: 'red',
                                    onClick: function onClick(e) {
                                      return _this5.rejectPayment(e, data.id);
                                    },
                                    size: 'mini',
                                    compact: true
                                  },
                                  'Reject'
                                ) : null,
                                data.booking.projectUnit.reference,
                                ', ',
                                _react2.default.createElement('br', { className: 'large-hide' }),
                                data.booking.project.name,
                                ', ',
                                _react2.default.createElement('br', null),
                                _react2.default.createElement(
                                  'small',
                                  null,
                                  data.booking.code
                                )
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              { collapsing: true, className: 'mobile-hide' },
                              data.customerName
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              { collapsing: true, className: 'mobile-hide' },
                              _react2.default.createElement(_LoanAmount2.default, {
                                format: '0,000,000.00',
                                amount: (0, _centsFloat.centsToFloat)(data.amountCents),
                                prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                              })
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              { collapsing: true, textAlign: 'right' },
                              _react2.default.createElement(
                                'span',
                                { className: 'large-hide small-hide tablet-hide', style: { float: 'left' } },
                                data.customerName
                              ),
                              _react2.default.createElement(
                                'i',
                                null,
                                _react2.default.createElement(
                                  'small',
                                  null,
                                  _react2.default.createElement(
                                    'span',
                                    null,
                                    'by '
                                  ),
                                  _this5.hasUserAccess() ? _react2.default.createElement(
                                    _reactRouter.Link,
                                    { to: '/users/' + data.requestedAffID + '/' },
                                    data.requestedName
                                  ) : data.requestedName,
                                  _react2.default.createElement(
                                    'span',
                                    { className: 'large-hide small-hide tablet-hide' },
                                    ',\xA0'
                                  ),
                                  _react2.default.createElement('br', { className: 'mobile-hide' }),
                                  _react2.default.createElement(_Timestamp2.default, {
                                    timestamp: data.createdAt,
                                    precise: true
                                  })
                                )
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              { collapsing: true, textAlign: 'right' },
                              _react2.default.createElement(
                                'span',
                                { className: 'large-hide small-hide tablet-hide', style: { float: 'left' } },
                                _react2.default.createElement(_LoanAmount2.default, {
                                  format: '0,000,000.00',
                                  amount: (0, _centsFloat.centsToFloat)(data.amountCents),
                                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                                })
                              ),
                              _this5.getPaymentStatus(data)
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              { collapsing: true, textAlign: 'right' },
                              data.requestStatus === 'new' ? _react2.default.createElement(
                                _semanticUiReact.Button,
                                { className: 'mobile-hide', color: 'green', onClick: function onClick(e) {
                                    return _this5.handleModalOpen(e, 'approve', data.id, data.booking);
                                  } },
                                'Approve'
                              ) : null,
                              data.requestStatus === 'new' ? _react2.default.createElement(
                                _semanticUiReact.Button,
                                { className: 'mobile-hide', color: 'red', onClick: function onClick(e) {
                                    return _this5.handleModalOpen(e, 'reject', data.id, data.booking);
                                  } },
                                'Reject'
                              ) : null,
                              data.approvedName !== '' ? _react2.default.createElement(
                                'span',
                                null,
                                'Approved by\xA0',
                                _this5.hasUserAccess() ? _react2.default.createElement(
                                  _reactRouter.Link,
                                  { to: '/users/' + data.approvedAffID + '/' },
                                  data.approvedName
                                ) : data.approvedName
                              ) : null,
                              data.requestStatus === 'rejected' ? 'Rejected' : null
                            )
                          );
                        }) : null
                      )
                    )
                  )
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Item,
                      { style: {} },
                      _react2.default.createElement(
                        _semanticUiReact.Item.Content,
                        null,
                        !this.state.loading ? _react2.default.createElement(
                          _semanticUiReact.Segment,
                          { textAlign: 'center' },
                          _react2.default.createElement(
                            'p',
                            null,
                            'No payments found.'
                          )
                        ) : ''
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return OnlinePayments;
}(_react.Component);

OnlinePayments.contextTypes = {
  store: _propTypes2.default.object
};
OnlinePayments.propTypes = {
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool
  })
};

OnlinePayments.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

OnlinePayments.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var search = query.search || '';
  return {
    currentPage: currentPage,
    search: search
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.setRefreshDataTimeout = function () {
    if (_this6.timeoutRefresh) {
      clearTimeout(_this6.timeoutRefresh);
    }
    _this6.timeoutRefresh = setTimeout(function () {
      _this6.handleRefreshData();
      _this6.setRefreshDataTimeout();
    }, 30000); // 30 seconds auto refresh time
  };

  this.getRowClassName = function (status) {
    if (status === 'payment_expired') {
      return 'row-colors payment_expired';
    }
    return '';
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.page = currentPage;
    _this6.setState({
      currentPage: currentPage
    });
    _this6.pushQuery(query);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this6.replaceQuery(query, true);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    _this6.setState({
      search: ''
    }, function () {
      if (hasQuery) {
        _this6.replaceQuery(query, true);
      }
    });
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query[queryName] = value;
    _this6.replaceQuery(query, true);
  };

  this.handleRefreshData = function () {
    var store = _this6.context.store;

    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.page = 1;
    _this6.fetchPayments(query);
    store.dispatch((0, _reactRouterRedux.replace)('/payments/?' + (0, _url.encodeSearch)(query)));
  };

  this.handleAutoReload = function () {
    var autoReload = !_this6.state.autoReload;
    _this6.setState({ autoReload: autoReload }, function () {
      (0, _storage.setItem)(_config2.default.get('appName') + '.paymentsAutoReload', autoReload ? 'true' : 'false');
      // if autoReload is disabled when there is an ongoing timeout then..
      // ..clear the timeout also.
      if (autoReload) {
        _this6.handleRefreshData();
        _this6.setRefreshDataTimeout();
      } else if (_this6.timeoutRefresh) {
        clearTimeout(_this6.timeoutRefresh);
      }
    });
  };

  this.sortItems = [{
    text: 'Latest Payment',
    icon: 'sort alphabet ascending',
    sortColumn: 'project_unit.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Oldest Payment',
    icon: 'sort alphabet descending',
    sortColumn: 'project_unit.created_at',
    sortDirection: 'desc'
  }, {
    text: 'Customer Name Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'project_unit.customer_name',
    sortDirection: 'asc'
  }, {
    text: 'Customer Name Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'project_unit.customer_name',
    sortDirection: 'desc'
  }];
  this.ONLINE_PAYMENT_STATUS = [{ text: 'New Request', value: 'new' }, { text: 'Approved', value: 'approved' }, { text: 'Rejected', value: 'rejected' }, { text: 'Payment Requested', value: 'payment_submitted' }, { text: 'Payment Failed', value: 'payment_failed' }, { text: 'Paid', value: 'payment_completed' }, { text: 'Expired', value: 'payment_expired' }];

  this.handleModalOnClose = function (e) {
    e.preventDefault();
    var modal = {
      isOpen: false,
      type: '',
      bookingData: {},
      paymentID: ''
    };
    _this6.setState({ modal: modal });
  };

  this.handleModalOpen = function (e, type, paymentID, bookingData) {
    e.preventDefault();
    var modal = {
      isOpen: true,
      type: type,
      bookingData: bookingData,
      paymentID: paymentID
    };
    _this6.setState({ modal: modal });
  };
};

exports.default = (0, _reactRedux.connect)(OnlinePayments.mapStateToProps)(OnlinePayments);

/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _semanticUiReact = __webpack_require__(2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _OnlinePayments = __webpack_require__(2372);

var _OnlinePayments2 = _interopRequireDefault(_OnlinePayments);

var _OfflinePayments = __webpack_require__(2371);

var _OfflinePayments2 = _interopRequireDefault(_OfflinePayments);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _url = __webpack_require__(19);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Payments = function (_Component) {
  _inherits(Payments, _Component);

  function Payments(props) {
    _classCallCheck(this, Payments);

    var _this = _possibleConstructorReturn(this, (Payments.__proto__ || Object.getPrototypeOf(Payments)).call(this, props));

    _initialiseProps.call(_this);

    var state = Payments.getPropsToState(props);
    state.data = [];
    _this.state = _extends({
      loading: true,
      modal: {
        isOpen: false,
        type: '',
        bookingData: {},
        paymentID: ''
      }
    }, state);
    return _this;
  }

  _createClass(Payments, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Payments.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, res);
      });
    }
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var store = this.context.store;
      var pathname = this.props.location.pathname;

      var queryNew = query;
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;
      var _state = this.state,
          currentTab = _state.currentTab,
          tabs = _state.tabs;
      var _props$appConfig$data = this.props.appConfig.data.onlinePaymentEnabled,
          onlinePaymentEnabled = _props$appConfig$data === undefined ? false : _props$appConfig$data;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Payments')
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'tab-menu' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Menu,
                {
                  attached: 'top',
                  tabular: true
                },
                tabs.map(function (tab, key) {
                  return _react2.default.createElement(
                    _semanticUiReact.Menu.Item,
                    {
                      key: key,
                      name: tab.value,
                      onClick: _this3.handleChangeTab,
                      active: currentTab === tab.value
                    },
                    t(tab.text).toUpperCase()
                  );
                })
              )
            )
          ),
          currentTab === 'payment' ? _react2.default.createElement(_OfflinePayments2.default, {
            location: this.props.location,
            auth: this.props.auth
          }) : null,
          currentTab === 'online_payment' && onlinePaymentEnabled ? _react2.default.createElement(_OnlinePayments2.default, {
            location: this.props.location,
            auth: this.props.auth
          }) : null
        )
      );
    }
  }]);

  return Payments;
}(_react.Component);

Payments.contextTypes = {
  store: _propTypes2.default.object
};
Payments.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      onlinePaymentEnabled: _propTypes2.default.bool
    })
  }),
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool
  }),
  t: _propTypes2.default.func
};

Payments.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig,
    auth: state.auth
  };
};

Payments.getPropsToState = function (props) {
  var _props$appConfig$data2 = props.appConfig.data.onlinePaymentEnabled,
      onlinePaymentEnabled = _props$appConfig$data2 === undefined ? false : _props$appConfig$data2;

  var TABS = [{ value: 'payment', text: 'Payment', isShow: true }, { value: 'online_payment', text: 'MHub Pay', isShow: onlinePaymentEnabled }];
  var query = (0, _url.decodeSearch)(props.location.search);
  var tabs = TABS.filter(function (e) {
    return e.isShow;
  });
  var currentTab = tabs.some(function (t) {
    return t.value === query.tab;
  }) ? query.tab : tabs[0].value;

  return {
    currentTab: currentTab,
    tabs: tabs
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleChangeTab = function (e, _ref) {
    var name = _ref.name;

    var currentTab = name;
    _this4.replaceQuery({
      tab: currentTab
    }, true);
    _this4.setState({
      currentTab: currentTab,
      data: [],
      offset: 0,
      count: 0,
      limit: 0
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces)))((0, _reactRedux.connect)(Payments.mapStateToProps)(Payments));

/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Payments = __webpack_require__(2373);

var _Payments2 = _interopRequireDefault(_Payments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Payments2.default;

/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _translation = __webpack_require__(4);

var _Form = __webpack_require__(2376);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditPicture = function (_Component) {
  _inherits(EditPicture, _Component);

  function EditPicture(props) {
    _classCallCheck(this, EditPicture);

    var _this = _possibleConstructorReturn(this, (EditPicture.__proto__ || Object.getPrototypeOf(EditPicture)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.getWrappedInstance().handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(EditPicture, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, file) {
        var _this2 = this;

        var t, store, errors, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                _context.prev = 6;
                _context.next = 9;
                return this.form.getWrappedInstance().submit('/pictures/' + this.props.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(file)
                });

              case 9:
                _context.next = 21;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](6);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 19;
                  break;
                }

                _context.next = 16;
                return _context.t0.res.text();

              case 16:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 19:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 21:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false);
                });
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Picture successfully updated', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 11]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Edit picture'),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Save', { ns: _translation.TRANSLATION_FILES.translation }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, unit) {
            _this3.submit(validations, unit);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading,
          picture: this.props.data
        })
      );
    }
  }]);

  return EditPicture;
}(_react.Component);

EditPicture.propTypes = {
  token: _propTypes2.default.string,
  id: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
EditPicture.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(EditPicture);

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _pictureTypes = __webpack_require__(392);

var _pictureTypes2 = _interopRequireDefault(_pictureTypes);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PictureForm = function (_Component) {
  _inherits(PictureForm, _Component);

  function PictureForm(props) {
    _classCallCheck(this, PictureForm);

    var _this = _possibleConstructorReturn(this, (PictureForm.__proto__ || Object.getPrototypeOf(PictureForm)).call(this, props));

    _initialiseProps.call(_this);

    var picture = Object.assign({}, PictureForm.defaultValues, props.picture || {});
    var tags = props.tags ? [].concat(props.tags).map(function (t) {
      return {
        text: t.name,
        value: t.name
      };
    }) : [];
    var options = _lodash2.default.unionBy(tags, _this.getTagOptions(picture.tags), 'value');
    _this.state = {
      picture: picture,
      oriPicture: (0, _clone2.default)(picture),
      options: options,
      errMessages: []
    };
    _this.validation = {
      label: (0, _react.createRef)(),
      type: (0, _react.createRef)(),
      tags: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(PictureForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var picture = Object.assign({}, PictureForm.defaultValues, this.state.picture);
      var oriPicture = this.state.oriPicture;
      if (JSON.stringify(this.props.picture) !== JSON.stringify(nextProps.picture)) {
        picture = Object.assign(picture, nextProps.picture);
        oriPicture = (0, _clone2.default)(picture);
      }
      var tags = nextProps.tags ? [].concat(nextProps.tags).map(function (t) {
        return {
          text: t.name,
          value: t.name
        };
      }) : [];
      var options = _lodash2.default.unionBy(tags, this.getTagOptions(picture.tags), 'value');
      this.setState({
        picture: picture,
        oriPicture: oriPicture,
        options: options
      });
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref) {
            _this2.form = _ref;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              _react2.default.createElement(_LoadImage2.default, {
                wrapped: true,
                picture: this.state.picture,
                pictureSize: 100
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_AppForm2.default.Input, {
                label: t('Label'),
                type: 'text',
                name: 'label',
                value: this.state.picture.label,
                onChange: this.handleInputChange,
                ref: this.validation.label
              }),
              _react2.default.createElement(
                _AppForm2.default.Validate,
                {
                  validation: [_webValidations.required],
                  ref: this.validation.type,
                  onChange: this.handleInputChange
                },
                _react2.default.createElement(_semanticUiReact.Form.Select, {
                  label: t('Type'),
                  name: 'type',
                  options: _pictureTypes2.default.map(function (status) {
                    return _extends({}, status, {
                      text: t(status.text, { ns: _translation.TRANSLATION_FILES.screens })
                    });
                  }),
                  placeholder: t('Type'),
                  search: true,
                  selection: true,
                  fluid: true,
                  value: this.state.picture.type
                })
              ),
              _react2.default.createElement(
                _AppForm2.default.Validate,
                {
                  ref: this.validation.tags,
                  onChange: this.handleInputChange
                },
                _react2.default.createElement(_semanticUiReact.Form.Select, {
                  label: t('Tags'),
                  name: 'tags',
                  fluid: true,
                  placeholder: t('Add tags'),
                  noResultsMessage: t('Add tags'),
                  search: true,
                  selection: true,
                  multiple: true,
                  allowAdditions: true,
                  options: this.state.options,
                  value: this.state.picture.tags || [],
                  onAddItem: this.handleAddition
                })
              )
            )
          )
        )
      );
    }
  }]);

  return PictureForm;
}(_react.Component);

PictureForm.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  picture: _propTypes2.default.shape({
    type: _propTypes2.default.string
  }),
  tags: _propTypes2.default.arrayOf(_propTypes2.default.object),
  t: _propTypes2.default.func
};
PictureForm.contextTypes = {
  store: _propTypes2.default.object
};
PictureForm.defaultValues = {
  label: '',
  type: 'general',
  tags: []
};

PictureForm.mapStateToProps = function (state) {
  return {
    tags: state.tags.data.picture
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getTagOptions = function (tags) {
    if (tags && tags.length > 0) {
      return tags.map(function (value) {
        return {
          text: value,
          value: value
        };
      });
    }
    return [];
  };

  this.handleSubmit = function (event) {
    event.preventDefault();
    var picture = _this3.state.picture;

    picture.label = picture.label.trim();
    _AppForm2.default.validate(_this3.validation, picture).then(function (validations) {
      _this3.props.onSubmit(validations, picture);
    });
  };

  this.handleInputChange = function (event, _ref2) {
    var name = _ref2.name,
        value = _ref2.value;
    var picture = _this3.state.picture;

    var newValue = value;
    if (name === 'label') {
      newValue = value.replace(/[\\~#%&*{}/:<>?|"]/, '');
    }
    picture[name] = newValue;
    _this3.setState({ picture: picture }, function () {
      _this3.handleCheckChanges();
    });
  };

  this.handleAddition = function (e, _ref3) {
    var value = _ref3.value;
    var options = _this3.state.options;

    if (!options.some(function (o) {
      return o.value === value;
    })) {
      _this3.setState({
        options: [{ text: value, value: value }].concat(_toConsumableArray(options))
      });
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })((0, _reactRedux.connect)(PictureForm.mapStateToProps, null, null, { withRef: true })(PictureForm));

/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _checkChanges = __webpack_require__(61);

var _Edit = __webpack_require__(2375);

var _Edit2 = _interopRequireDefault(_Edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Picture = function (_Component) {
  _inherits(Picture, _Component);

  function Picture(props) {
    _classCallCheck(this, Picture);

    var _this = _possibleConstructorReturn(this, (Picture.__proto__ || Object.getPrototypeOf(Picture)).call(this, props));

    _this.state = {
      token: null,
      loading: true,
      data: null
    };
    return _this;
  }

  _createClass(Picture, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchPicture();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var id = nextProps.params.id;

      if (id !== this.props.params.id) {
        this.fetchPicture();
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchPicture',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, data, token;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/pictures/' + this.props.params.id + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                return _context.abrupt('return');

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 32;
                break;

              case 26:
                _context.next = 28;
                return res.json();

              case 28:
                data = _context.sent;

                // handle token.. etc
                token = res.headers.get('X-Csrf-Token');
                _context.next = 32;
                return this.setComponentState({
                  data: data,
                  token: token
                });

              case 32:
                _context.next = 34;
                return this.setLoading(false);

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchPicture() {
        return _ref.apply(this, arguments);
      }

      return fetchPicture;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this4 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this4.state.token,
          loading: _this4.state.loading,
          data: _this4.state.data,
          id: _this4.props.params.id
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Picture;
}(_react.Component);

Picture.propTypes = {
  children: _propTypes2.default.node,
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string
  })
};
Picture.contextTypes = {
  store: _propTypes2.default.object
};
Picture.Edit = (0, _checkChanges.checkChanges)(_Edit2.default);
exports.default = Picture;

/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Picture = __webpack_require__(2377);

var _Picture2 = _interopRequireDefault(_Picture);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Picture2.default;

/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _prompt = __webpack_require__(66);

var _PictureList = __webpack_require__(386);

var _PictureList2 = _interopRequireDefault(_PictureList);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _UploadModal = __webpack_require__(92);

var _UploadModal2 = _interopRequireDefault(_UploadModal);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _RemovePicture = __webpack_require__(590);

var _RemovePicture2 = _interopRequireDefault(_RemovePicture);

var _promptMessages = __webpack_require__(43);

var _translation = __webpack_require__(4);

var _Form = __webpack_require__(1060);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _initialiseProps.call(_this);

    var state = List.getPropsToState(props);
    _this.state = _extends({}, state, {
      selectedPicture: null,
      showLarge: false,
      showDelete: false,
      pictures: []
    });
    _this.pictureList = null;
    return _this;
  }

  _createClass(List, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'getToken',
    value: function getToken(id, callback) {
      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/pictures/' + id + '/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      }).then(function (res) {
        var token = res.headers.get('X-Csrf-Token');
        if (callback) {
          callback(token);
        }
      });
    }
  }, {
    key: 'handleRefetch',
    value: function handleRefetch() {
      if (this.pictureList) {
        this.pictureList.getWrappedInstance().handleRefetch();
      }
    }
  }, {
    key: 'uploadPicture',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e, body) {
        var t, store, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                t = this.props.t;
                store = this.context.store;
                _context.prev = 3;
                _context.next = 6;
                return this.form.getWrappedInstance().submit('/pictures/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    // Let browser decide Content-Type
                    'X-Csrf-Token': this.props.token
                  },
                  body: body
                });

              case 6:
                _context.next = 18;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](3);

                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 16;
                  break;
                }

                _context.next = 13;
                return _context.t0.res.text();

              case 13:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 16:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 18:
                this.uploadModal.close();
                this.handleRefetch();
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Upload Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Pictures(s) successfully uploaded', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 21:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 8]]);
      }));

      function uploadPicture(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return uploadPicture;
    }()
  }, {
    key: 'deletePicture',
    value: function deletePicture() {
      var _this2 = this;

      var t = this.props.t;
      var store = this.context.store;

      this.getToken(this.state.selectedPicture.id, function (token) {
        store.dispatch((0, _fetchM.fetchM)('/pictures/' + _this2.state.selectedPicture.id + '/', {
          credentials: 'include',
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'X-Csrf-Token': token
          }
        })).then(function () {
          _this2.setState({
            selectedPicture: null,
            loading: false
          });
          _this2.handleRefetch();
          store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Picture successfully deleted', { ns: _translation.TRANSLATION_FILES.translation }) }));
        }).catch(function (err) {
          store.dispatch((0, _flash.flashErrorMessage)(err));
        });
      });
    }
  }, {
    key: 'updatePicture',
    value: function updatePicture() {
      var _this3 = this;

      var t = this.props.t;
      var store = this.context.store;

      this.getToken(this.state.selectedPicture.id, function (token) {
        store.dispatch((0, _fetchM.fetchM)('/pictures/' + _this3.state.selectedPicture.id + '/', {
          credentials: 'include',
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'X-Csrf-Token': token
          },
          body: JSON.stringify(_this3.state.selectedPicture)
        })).then(function () {
          _this3.setState({
            selectedPicture: null,
            options: [],
            loading: false
          });
          _this3.handleRefetch();
          store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Picture successfully updated', { ns: _translation.TRANSLATION_FILES.translation }) }));
        }).catch(function (err) {
          store.dispatch((0, _flash.flashErrorMessage)(err));
        });
      });
    }
  }, {
    key: 'checkDisabled',
    value: function checkDisabled() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';
      var _state = this.state,
          pictures = _state.pictures,
          selectedPicture = _state.selectedPicture;

      if (selectedPicture) {
        var index = pictures.indexOf(selectedPicture);
        if (direction === 'left') {
          return index - 1 >= 0;
        }
        return index + 1 < pictures.length;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Pictures'),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_UploadModal2.default, {
              ref: function ref(_ref4) {
                _this4.uploadModal = _ref4;
              },
              header: 'Pictures',
              loading: this.state.loading,
              onConfirm: function onConfirm(e, data) {
                _this4.uploadPicture(e, data);
              },
              onClose: this.handleCheckBeforeClose,
              content: function content(_ref2) {
                var onConfirm = _ref2.onConfirm;
                return _react2.default.createElement(_Form2.default, {
                  ref: function ref(_ref3) {
                    _this4.form = _ref3;
                  },
                  onSubmit: onConfirm
                });
              }
            })
          )
        }),
        _react2.default.createElement(_ViewLarge2.default, {
          open: this.state.showLarge,
          onClose: this.handleCloseLarge,
          picture: this.state.selectedPicture,
          onSlide: this.handleSlidePicture,
          disabledLeft: !this.checkDisabled('left'),
          disabledRight: !this.checkDisabled('right'),
          slideshow: this.state.showLarge
        }),
        _react2.default.createElement(_RemovePicture2.default, {
          type: 'delete',
          open: this.state.showDelete,
          onClose: this.handleCancelDelete,
          onConfirm: this.handleConfirmDelete,
          picture: this.state.selectedPicture
        }),
        _react2.default.createElement(_PictureList2.default, {
          ref: function ref(_ref6) {
            _this4.pictureList = _ref6;
          },
          toggleable: true,
          onChange: this.handleGetPictures,
          onViewLarge: this.handleViewLarge,
          onRemove: this.handleDelete,
          buttonNode: function buttonNode(_ref5) {
            var isMobile = _ref5.isMobile,
                view = _ref5.view,
                loading = _ref5.loading,
                picture = _ref5.picture;
            return view === 'list' ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_semanticUiReact.Button, {
                as: _reactRouter.Link,
                size: 'tiny',
                compact: true,
                primary: true,
                icon: 'edit',
                content: t('Edit', { ns: _translation.TRANSLATION_FILES.translation }),
                disabled: loading,
                to: '/media/pictures/' + picture.id + '/'
              }),
              _react2.default.createElement(_semanticUiReact.Button, {
                size: 'tiny',
                compact: true,
                negative: true,
                icon: 'remove',
                content: isMobile ? null : t('Remove'),
                disabled: loading,
                onClick: function onClick(e) {
                  return _this4.handleDelete(e, picture);
                }
              })
            ) : _react2.default.createElement(_semanticUiReact.Button, {
              as: _reactRouter.Link,
              compact: true, size: 'small',
              attached: 'bottom',
              primary: true,
              icon: 'edit',
              content: t('Edit', { ns: _translation.TRANSLATION_FILES.translation }),
              disabled: loading,
              to: '/media/pictures/' + picture.id + '/'
            });
          }
        })
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};
List.propTypes = {
  token: _propTypes2.default.string,
  t: _propTypes2.default.func
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  return {
    loading: loading
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.handleCloseLarge = function (e) {
    e.preventDefault();
    _this5.setState({
      showLarge: false,
      selectedPicture: null
    });
  };

  this.handleViewLarge = function (e, selectedPicture) {
    e.preventDefault();
    _this5.setState({
      selectedPicture: selectedPicture,
      showLarge: true
    });
  };

  this.handleCancelDelete = function (e) {
    e.preventDefault();
    _this5.setState({
      showDelete: false,
      selectedPicture: null
    });
  };

  this.handleDelete = function (e, selectedPicture) {
    e.preventDefault();
    _this5.setState({
      selectedPicture: selectedPicture,
      showDelete: true
    });
  };

  this.handleConfirmDelete = function (e) {
    e.preventDefault();
    _this5.setState({
      showDelete: false
    }, function () {
      _this5.deletePicture();
    });
  };

  this.handleCheckBeforeClose = function () {
    var t = _this5.props.t;

    if (_this5.form.getWrappedInstance().state.uploads.length > 0) {
      var callback = function callback() {
        _this5.uploadModal.close();
        _this5.handleRefetch();
      };
      var store = _this5.context.store;

      store.dispatch((0, _prompt.promptChangesMessage)({ message: t(_promptMessages.UPLOAD_PICTURE_PROMPT, { ns: _translation.TRANSLATION_FILES.translation }), callback: callback }));
      return true;
    }
    return false;
  };

  this.handleGetPictures = function (pictures) {
    _this5.setState({ pictures: pictures });
  };

  this.handleSlidePicture = function (e) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
    var _state2 = _this5.state,
        pictures = _state2.pictures,
        selectedPicture = _state2.selectedPicture;

    var index = pictures.indexOf(selectedPicture);
    var nextIndex = direction === 'left' ? index - 1 : index + 1;
    _this5.setState({
      selectedPicture: pictures[nextIndex]
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(List);

/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _List = __webpack_require__(2379);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pictures = function (_Component) {
  _inherits(Pictures, _Component);

  function Pictures(props) {
    _classCallCheck(this, Pictures);

    var _this = _possibleConstructorReturn(this, (Pictures.__proto__ || Object.getPrototypeOf(Pictures)).call(this, props));

    _this.state = {
      token: null,
      loading: true
    };
    return _this;
  }

  _createClass(Pictures, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchPictures();
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchPictures',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, token;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/pictures/?page=1', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                return _context.abrupt('return');

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 29;
                break;

              case 26:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context.next = 29;
                return this.setComponentState({
                  token: token
                });

              case 29:
                _context.next = 31;
                return this.setLoading(false);

              case 31:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchPictures() {
        return _ref.apply(this, arguments);
      }

      return fetchPictures;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this4 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this4.state.token,
          loading: _this4.state.loading
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Pictures;
}(_react.Component);

Pictures.propTypes = {
  children: _propTypes2.default.node
};
Pictures.contextTypes = {
  store: _propTypes2.default.object
};
Pictures.List = _List2.default;
exports.default = Pictures;

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Pictures = __webpack_require__(2380);

var _Pictures2 = _interopRequireDefault(_Pictures);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Pictures2.default;

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _BankerItem = __webpack_require__(556);

var _BankerItem2 = _interopRequireDefault(_BankerItem);

var _BankersList = __webpack_require__(397);

var _BankersList2 = _interopRequireDefault(_BankersList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _initialiseProps.call(_this);

    var state = List.getPropsToState(props);
    _this.state = _extends({}, state, {
      currentFocus: null,
      edit: false,
      hasChanges: false
    });
    return _this;
  }

  _createClass(List, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      if (JSON.stringify(state.oriData) === JSON.stringify(this.state.oriData)) {
        state.data = this.state.data;
      }
      this.setState(state);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this2.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'updatePreferredBankers',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var data, store, t, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = this.state.data;
                store = this.context.store;
                t = this.props.t;
                _context.prev = 3;
                _context.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/bankers/preferred/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(data)
                }));

              case 6:
                _context.next = 19;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](3);

                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 16;
                  break;
                }

                _context.next = 13;
                return _context.t0.res.text();

              case 13:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 16:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: 'translation' }) }));
                return _context.abrupt('return');

              case 19:
                if (!this.props.fetch) {
                  _context.next = 22;
                  break;
                }

                _context.next = 22;
                return this.props.fetch();

              case 22:
                _context.next = 24;
                return this.setComponentState({ hasChanges: false }, function () {
                  _this3.handleOnCheck(false);
                });

              case 24:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: 'translation' }), message: t('Preferred bankers successfully updated.', { ns: 'translation' }) }));

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 8]]);
      }));

      function updatePreferredBankers() {
        return _ref.apply(this, arguments);
      }

      return updatePreferredBankers;
    }()
  }, {
    key: 'handleHasChange',
    value: function handleHasChange() {
      var _this4 = this;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true }, function () {
          _this4.handleOnCheck(true);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Preferred Bankers', { ns: 'translation' }),
          rightNav: _react2.default.createElement(_semanticUiReact.Button, {
            primary: !this.state.edit,
            positive: this.state.edit,
            content: this.state.edit ? t('Save', { ns: 'translation' }) : t('Edit', { ns: 'translation' }),
            onClick: this.handleEdit,
            disabled: this.state.edit && !this.state.hasChanges
          })
        }),
        _react2.default.createElement(_BankersList2.default, {
          open: this.state.showAddBanker,
          onClose: this.handleCloseAddBanker,
          onConfirm: this.handleAddBanker,
          limit: 10,
          selected: this.state.data,
          only: 'banker'
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', columns: 1 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Dimmer,
              {
                inverted: true, style: { zIndex: 20 },
                active: this.state.loading && this.state.data.length > 0
              },
              _react2.default.createElement(
                _semanticUiReact.Loader,
                { inline: 'centered' },
                t('Loading', { ns: 'translation' })
              )
            ),
            this.state.data.length > 0 ? _react2.default.createElement(
              _semanticUiReact.Table,
              { unstackable: true },
              _react2.default.createElement(
                _semanticUiReact.Table.Body,
                null,
                this.state.data.map(function (banker, idx) {
                  return _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    {
                      key: idx,
                      positive: _this5.state.currentFocus === banker
                    },
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      null,
                      _react2.default.createElement(_BankerItem2.default, {
                        showSummary: true,
                        banker: banker,
                        onClick: _this5.handleOnSelect,
                        disabled: !_this5.state.edit,
                        leftComponent: _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { columns: 'equal', centered: true, verticalAlign: 'middle' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { style: { color: '#bbbbbb' } },
                            idx + 1
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Button.Group,
                              {
                                className: _this5.state.edit ? null : 'hidden',
                                vertical: true, size: 'mini'
                              },
                              _react2.default.createElement(_semanticUiReact.Button, {
                                compact: true,
                                icon: 'caret up',
                                onClick: function onClick() {
                                  return _this5.handleChangePosition(idx, banker, 'up');
                                },
                                disabled: !_this5.state.edit || idx === 0
                              }),
                              _react2.default.createElement(_semanticUiReact.Button, {
                                compact: true,
                                icon: 'caret down',
                                onClick: function onClick() {
                                  return _this5.handleChangePosition(idx, banker, 'down');
                                },
                                disabled: !_this5.state.edit || idx >= _this5.state.data.length - 1
                              })
                            )
                          )
                        ),
                        rightComponent: _react2.default.createElement(
                          'div',
                          { className: _this5.state.edit ? null : 'hidden' },
                          _react2.default.createElement(_semanticUiReact.Button, {
                            compact: true,
                            negative: true,
                            size: 'mini',
                            icon: 'remove',
                            onClick: function onClick() {
                              return _this5.handleRemoveBanker(idx);
                            },
                            disabled: !_this5.state.edit
                          })
                        )
                      })
                    )
                  );
                })
              )
            ) : _react2.default.createElement(
              _semanticUiReact.Segment,
              { textAlign: 'center' },
              this.state.loading ? _react2.default.createElement(
                _semanticUiReact.Loader,
                { active: true, inline: 'centered' },
                t('Loading', { ns: 'translation' })
              ) : t('No preferred banker found.', { ns: 'translation' })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { textAlign: 'center' },
            _react2.default.createElement(_semanticUiReact.Button, {
              negative: this.state.edit,
              content: this.state.edit ? t('Cancel', { ns: 'screens' }) : t('Add Banker', { ns: 'screens' }),
              onClick: this.state.edit ? this.handleCancelEdit : this.handleShowAddBanker
            })
          )
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};
List.propTypes = {
  token: _propTypes2.default.string,
  data: _propTypes2.default.arrayOf(_propTypes2.default.object),
  fetch: _propTypes2.default.func,
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func.isRequired
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  var count = props.count;
  var data = [].concat(props.data);
  return {
    data: data,
    oriData: (0, _clone2.default)(data),
    loading: loading,
    count: count
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.handleEdit = function () {
    _this6.setState({ edit: !_this6.state.edit }, function () {
      if (!_this6.state.edit) {
        _this6.updatePreferredBankers();
      }
    });
  };

  this.handleCancelEdit = function () {
    _this6.setState({
      edit: false,
      data: (0, _clone2.default)(_this6.state.oriData)
    }, function () {
      _this6.handleOnCheck(false);
    });
  };

  this.handleOnSelect = function (e, currentFocus) {
    if (_this6.state.currentFocus !== currentFocus) {
      _this6.setState({ currentFocus: currentFocus });
    }
  };

  this.handleShowAddBanker = function (e) {
    e.preventDefault();
    _this6.setState({
      showAddBanker: true
    });
  };

  this.handleCloseAddBanker = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this6.setState({
      showAddBanker: false
    });
  };

  this.handleAddBanker = function (e, data) {
    e.preventDefault();
    _this6.setState({
      data: data,
      showAddBanker: false
    }, function () {
      _this6.updatePreferredBankers();
    });
  };

  this.handleChangePosition = function (index, banker) {
    var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'up';

    if (_this6.state.edit) {
      var data = _this6.state.data;

      if (direction === 'up') {
        if (index > 0) {
          data.splice(index, 1);
          data.splice(index - 1, 0, banker);
        }
      } else if (direction === 'down') {
        if (index < data.length) {
          data.splice(index, 1);
          data.splice(index + 1, 0, banker);
        }
      }
      _this6.setState({ data: data }, function () {
        _this6.handleHasChange();
      });
    }
  };

  this.handleRemoveBanker = function (index) {
    if (_this6.state.edit) {
      var data = _this6.state.data;

      data.splice(index, 1);
      _this6.setState({ data: data }, function () {
        _this6.handleHasChange();
      });
    }
  };

  this.handleOnCheck = function () {
    var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var callback = arguments[1];

    if (_this6.props.onCheck) {
      _this6.props.onCheck(hasChanges, callback);
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)()(List);

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _checkChanges = __webpack_require__(61);

var _promptMessages = __webpack_require__(43);

var _List = __webpack_require__(2382);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectSpecifications = function (_Component) {
  _inherits(ProjectSpecifications, _Component);

  function ProjectSpecifications(props) {
    _classCallCheck(this, ProjectSpecifications);

    var _this = _possibleConstructorReturn(this, (ProjectSpecifications.__proto__ || Object.getPrototypeOf(ProjectSpecifications)).call(this, props));

    _this.state = {
      token: null,
      loading: true,
      data: [],
      count: 0
    };
    return _this;
  }

  _createClass(ProjectSpecifications, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchPreferredBankers();
    }
  }, {
    key: 'setBankers',
    value: function setBankers() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this2.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchPreferredBankers',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, token, count, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/bankers/preferred/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                return _context.abrupt('return');

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 35;
                break;

              case 26:
                token = res.headers.get('X-Csrf-Token');
                count = parseInt(res.headers.get('M-Data-count'), 10);
                _context.next = 30;
                return res.json();

              case 30:
                data = _context.sent;
                _context.next = 33;
                return this.setBankers(data);

              case 33:
                _context.next = 35;
                return this.setComponentState({
                  token: token,
                  count: count
                });

              case 35:
                _context.next = 37;
                return this.setLoading(false);

              case 37:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchPreferredBankers() {
        return _ref.apply(this, arguments);
      }

      return fetchPreferredBankers;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this5 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this5.state.token,
          loading: _this5.state.loading,
          data: _this5.state.data,
          count: _this5.state.count,
          fetch: function fetch() {
            _this5.fetchPreferredBankers();
          }
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return ProjectSpecifications;
}(_react.Component);

ProjectSpecifications.propTypes = {
  children: _propTypes2.default.node
};
ProjectSpecifications.contextTypes = {
  store: _propTypes2.default.object
};
ProjectSpecifications.List = (0, _checkChanges.checkChanges)(_List2.default, { message: _promptMessages.PREFERRED_BANKERS_PROMPT });
exports.default = ProjectSpecifications;

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _PreferredBankers = __webpack_require__(2383);

var _PreferredBankers2 = _interopRequireDefault(_PreferredBankers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PreferredBankers2.default;

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _storage = __webpack_require__(44);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _globalSettings = __webpack_require__(993);

var _translation = __webpack_require__(4);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var PriceNaming = function (_Component) {
  _inherits(PriceNaming, _Component);

  function PriceNaming(props) {
    _classCallCheck(this, PriceNaming);

    var _this = _possibleConstructorReturn(this, (PriceNaming.__proto__ || Object.getPrototypeOf(PriceNaming)).call(this, props));

    _this.checkSaveDisabled = function () {
      var _this$state = _this.state,
          data = _this$state.data,
          oriData = _this$state.oriData;

      if (JSON.stringify(data) !== JSON.stringify(oriData)) {
        return false;
      }
      return true;
    };

    _this.handleSave = function (e) {
      if (e) e.preventDefault();
      var data = _this.state.data;

      _AppForm2.default.validate(_this.validation, data).then(function (validations) {
        _this.setState({
          errMessages: validations.filter(function (v) {
            return !v.isValid;
          })
        });
        _this.updateSystemSettings(validations, data);
      });
    };

    _this.handleResize = function () {
      var state = {};
      var topMenuIsTab = window.innerWidth <= 590;
      if (topMenuIsTab !== _this.state.topMenuIsTab) {
        state.topMenuIsTab = topMenuIsTab;
      }
      var menuIsTab = window.innerWidth >= 991;
      if (menuIsTab !== _this.state.menuIsTab) {
        state.menuIsTab = menuIsTab;
      }
      var menuIsVertical = window.innerWidth >= 991;
      if (menuIsVertical !== _this.state.menuIsVertical) {
        state.menuIsVertical = menuIsVertical;
      }
      _this.setState(_extends({}, state));
    };

    _this.handleInputChange = function (e) {
      var _e$target = e.target,
          name = _e$target.name,
          value = _e$target.value;

      _this.setState(function (s) {
        return {
          data: _extends({}, s.data, _defineProperty({}, name, value))
        };
      });
    };

    var globalSettings = {};
    var storeGloablSettings = (0, _storage.getItem)(_config2.default.get('appName') + '.globalSettings');
    if (storeGloablSettings) {
      try {
        globalSettings = JSON.parse(storeGloablSettings).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }

    _this.state = {
      loading: false,
      token: null,
      data: globalSettings,
      oriData: []
    };
    _this.validation = {
      sellingPrice: (0, _react.createRef)(),
      unitSellingPrice: (0, _react.createRef)(),
      nettSellingPrice: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(PriceNaming, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var store = this.context.store;

      store.dispatch((0, _globalSettings.fetchGlobalSettings)(true));
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'updateSystemSettings',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, data) {
        var t, store, stateData, errors, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                stateData = data;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 10;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                this.setLoading(false);
                return _context.abrupt('return');

              case 10:
                _context.prev = 10;
                _context.next = 13;
                return store.dispatch((0, _fetchM.fetchM)('/settings/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(stateData)
                }));

              case 13:
                _context.next = 28;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](10);
                _context.next = 19;
                return this.setLoading(false);

              case 19:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 25;
                  break;
                }

                _context.next = 22;
                return _context.t0.res.text();

              case 22:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 25:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
                return _context.abrupt('return');

              case 28:
                _context.next = 30;
                return this.setLoading(false);

              case 30:
                store.dispatch((0, _globalSettings.fetchGlobalSettings)(true));
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('System settings successfully updated.', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 32:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[10, 15]]);
      }));

      function updateSystemSettings(_x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return updateSystemSettings;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _state = this.state,
          loading = _state.loading,
          data = _state.data;
      var t = this.props.t;

      var fields = [{
        name: 'unitSellingPrice',
        value: data.unitSellingPrice,
        label: 'List Price'
      }, {
        name: 'sellingPrice',
        value: data.sellingPrice,
        label: 'SPA Value'
      }, {
        name: 'nettSellingPrice',
        value: data.nettSellingPrice,
        label: 'Nett Selling Price'
      }];
      return _react2.default.createElement(
        _semanticUiReact.Container,
        { className: 'priceNaming' },
        _react2.default.createElement(_NavBar2.default, {
          header: t('Price', { ns: _translation.TRANSLATION_FILES.screens }),
          rightNav: _react2.default.createElement(_semanticUiReact.Button, {
            color: 'green',
            content: t('Save', { ns: _translation.TRANSLATION_FILES.translation }),
            disabled: this.state.loading || this.checkSaveDisabled(),
            onClick: this.handleSave
          })
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', columns: 'equal', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { style: { zIndex: 20 }, active: loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Price Naming', { ns: _translation.TRANSLATION_FILES.screens })
              ),
              fields.map(function (f) {
                return _react2.default.createElement(
                  'section',
                  { className: 'inputBox', key: f.name },
                  _react2.default.createElement(_AppForm2.default.Input, {
                    label: t(f.label, { ns: _translation.TRANSLATION_FILES.translation }) + ':',
                    name: f.name,
                    value: f.value,
                    onChange: _this4.handleInputChange,
                    ref: _this4.validation[f.name]
                  })
                );
              })
            )
          )
        )
      );
    }
  }]);

  return PriceNaming;
}(_react.Component);

PriceNaming.contextTypes = {
  store: _propTypes2.default.object
};
PriceNaming.propTypes = {
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(PriceNaming);

/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _PriceNaming = __webpack_require__(2385);

var _PriceNaming2 = _interopRequireDefault(_PriceNaming);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PriceNaming2.default;

/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Overview = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _semanticUiReact = __webpack_require__(2);

var _reactRedux = __webpack_require__(9);

var _webValidations = __webpack_require__(23);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _isEqual = __webpack_require__(3096);

var _isEqual2 = _interopRequireDefault(_isEqual);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

var _i18next = __webpack_require__(94);

var _i18next2 = _interopRequireDefault(_i18next);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _refreshUserCache = __webpack_require__(1093);

var _languageOptions = __webpack_require__(1092);

var _displayLanguage = __webpack_require__(594);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _intlCallCodes = __webpack_require__(116);

var _intlCallCodes2 = _interopRequireDefault(_intlCallCodes);

var _languages = __webpack_require__(1044);

var _languages2 = _interopRequireDefault(_languages);

var _translation = __webpack_require__(4);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _EditableBox = __webpack_require__(153);

var _EditableBox2 = _interopRequireDefault(_EditableBox);

var _Phone = __webpack_require__(126);

var _Phone2 = _interopRequireDefault(_Phone);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _PhoneInput = __webpack_require__(104);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

var _valueToText = __webpack_require__(98);

var _valueToText2 = _interopRequireDefault(_valueToText);

var _languagePreference = __webpack_require__(325);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var pendingProfileWrite = null;
var profileWriteUnconfirmed = false;
var pendingProfileIsAudit = false;
var pendingPasswordChange = null;
var profileStatusListeners = new Set();
var notifyProfileStatus = function notifyProfileStatus(fields, userID) {
  return profileStatusListeners.forEach(function (listener) {
    return listener({ fields: fields, userID: userID });
  });
};

function profileHasChanges(data, oriData) {
  // Language metadata is not an independently edited profile field.
  var fields = Object.keys(_extends({}, data, oriData)).filter(function (key) {
    return key !== 'currentLanguageCode' && key !== 'currentLanguageSetAt';
  });
  return fields.some(function (key) {
    return !(0, _isEqual2.default)(data[key], (oriData || {})[key]);
  });
}

var Overview = exports.Overview = function (_Component) {
  _inherits(Overview, _Component);

  function Overview(props) {
    var _this2 = this;

    _classCallCheck(this, Overview);

    var _this = _possibleConstructorReturn(this, (Overview.__proto__ || Object.getPrototypeOf(Overview)).call(this, props));

    _this.handleExplicitLanguageChange = function (lng) {
      _this.explicitLanguageRevision = (_this.explicitLanguageRevision || 0) + 1;
      _this.languageSavePending = false;
      _this.explicitDisplayLanguage = lng;
      _this.handleI18nChange(lng, true);
    };

    _this.handleI18nChange = function (lng) {
      var explicit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!explicit && _this.explicitDisplayLanguage && lng !== _this.explicitDisplayLanguage) return;
      // A delayed startup read must not replace an unsaved form selection.
      if (!explicit && _this.state.data && _this.state.oriData && _this.state.data.language !== _this.state.oriData.language) return;
      _this.observedDisplayLanguage = lng;
      if (_this.state.data && (explicit || _this.state.data.language !== lng)) {
        _this.setState(function (prevState) {
          return {
            data: _extends({}, prevState.data, {
              language: lng,
              currentLanguageCode: lng
            }),
            oriData: prevState.oriData ? _extends({}, prevState.oriData, {
              language: lng,
              currentLanguageCode: lng
            }) : prevState.oriData
          };
        }, function () {
          var _this$state = _this.state,
              data = _this$state.data,
              oriData = _this$state.oriData;

          if (profileHasChanges(data, oriData)) _this.handleCheckChanges();else _this.handleResetCheck();
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges);
      }
    };

    _this.handleOnChange = function (event, value) {
      var data = _this.state.data;

      data[value.name] = value.value;
      if (value.name === 'language') {
        data.currentLanguageCode = value.value;
        data.currentLanguageSetAt = new Date().toISOString();
      }
      _this.setState({ data: data }, function () {
        _this.handleCheckChanges();
      });
    };

    _this.handleCheckBoxChange = function (event, value) {
      var data = _this.state.data;

      data[value.name] = !data[value.name];
      _this.setState({ data: data }, function () {
        _this.handleCheckChanges();
      });
    };

    _this.handleEditProfile = function () {
      _this.setState({ edit: true });
    };

    _this.handleEditPassword = function () {
      _this.setState({ editPassword: true });
    };

    _this.handleUpdateProfile = function (event) {
      var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (_this.profileSaveInFlight) {
        return Promise.resolve();
      }

      var data = _this.state.data;

      return _AppForm2.default.validate(_this.validation, data).then(function (validations) {
        _this.setState({
          errMessages: validations.filter(function (v) {
            return !v.isValid;
          })
        });
        return _this.putProfile(validations, _this.state.data, silent).catch(function (err) {
          Bugsnag.notifyException(err);
          if (silent) throw err;
        });
      });
    };

    _this.handleOnChangePassword = function (event, value) {
      var passwords = _this.state.passwords;

      passwords[value.name] = value.value;

      _this.setState({ passwords: passwords }, function () {
        _this.handleCheckChanges();
      });
    };

    _this.handleChangePassword = function () {
      var passwords = _this.state.passwords;

      return _AppForm2.default.validate(_this.passwordValidation, passwords).then(function (passwordValidation) {
        _this.setState({
          errMessages: passwordValidation.filter(function (v) {
            return !v.isValid;
          })
        });
        return _this.changePassword(passwordValidation, passwords);
      });
    };

    _this.handleResetChanges = function () {
      if (_this.profileSaveInFlight) return;
      _this.languageSavePending = false;
      _this.explicitLanguageRevision = (_this.explicitLanguageRevision || 0) + 1;
      var oriData = _this.state.oriData;

      _this.setState({
        data: (0, _clone2.default)(oriData),
        edit: false
      }, function () {
        _this.handleResetCheck();
      });
    };

    _this.handleResetPasswordChanges = function () {
      _this.setState({
        editPassword: false,
        passwordSaveWarning: null,
        passwords: {
          current: '',
          new: '',
          confirm: ''
        }
      }, function () {
        _this.handleResetCheck();
      });
    };

    _this.changePassword = function (validations, passwords) {
      var store = _this.context.store;
      var t = _this.props.t;

      if (_this.profileSaveInFlight || pendingProfileWrite || pendingPasswordChange) {
        store.dispatch((0, _flash.flashErrorMessage)({ message: t('Wait for the pending profile or password request to finish before saving again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
        return Promise.resolve();
      }
      var errors = validations.filter(function (v) {
        return !v.isValid;
      });
      if (errors.length > 0) {
        _this.setState({ editPassword: true });
        store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
            return l.message;
          }) }));
        return Promise.resolve();
      }
      _this.setState({ passwordSaving: true, passwordSaveWarning: null, auditSaveWarning: null });
      var timer = void 0;
      var expired = false;
      var operation = Promise.resolve().then(function () {
        return _auth2.default.currentUserPoolUser();
      }).then(function (user) {
        return _auth2.default.changePassword(user, passwords.current, passwords.new);
      }).then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.profileMounted !== false) {
                  _this.setState({ editPassword: false, passwordSaveWarning: null, passwords: { current: '', new: '', confirm: '' } });
                }
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Your password successfully updated', { ns: _translation.TRANSLATION_FILES.translation }) }));
                // Audit only: Cognito has already confirmed the password change.
                _context.prev = 2;
                _context.next = 5;
                return _this.boundedProfileWrite({
                  credentials: 'include',
                  method: 'PUT',
                  headers: { 'Content-Type': 'application/json', 'X-Csrf-Token': _this.state.token },
                  body: JSON.stringify({ updatePassword: 'changed' })
                }, true);

              case 5:
                _context.next = 13;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](2);

                Bugsnag.notifyException(_context.t0);
                message = t('Password changed; the activity record could not be confirmed. Do not repeat the password change.', { ns: _translation.TRANSLATION_FILES.translation });

                if (_this.profileMounted !== false) _this.setState({ auditSaveWarning: message });
                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2, [[2, 7]]);
      })));
      pendingPasswordChange = operation;
      var settled = function settled(error) {
        if (expired && error) {
          Bugsnag.notifyException(error);
          store.dispatch((0, _flash.flashErrorMessage)(error));
        }
        if (pendingPasswordChange === operation) pendingPasswordChange = null;
        if (_this.profileMounted !== false) _this.setState({ passwordSaveWarning: null });
      };
      operation.then(function () {
        return settled(null);
      }, settled);
      return Promise.race([operation, new Promise(function (resolve, reject) {
        timer = setTimeout(function () {
          expired = true;
          reject(Object.assign(new Error(t('Password change is still unconfirmed. Wait for the pending request to finish before retrying.', { ns: _translation.TRANSLATION_FILES.translation })), { code: 'PASSWORD_SAVE_UNCONFIRMED' }));
        }, 10000);
      })]).catch(function (err) {
        Bugsnag.notifyException(err);
        if (_this.profileMounted !== false && err.code === 'PASSWORD_SAVE_UNCONFIRMED') _this.setState({ passwordSaveWarning: err.message });
        store.dispatch((0, _flash.flashErrorMessage)(err));
      }).finally(function () {
        clearTimeout(timer);
        if (_this.profileMounted !== false) _this.setState({ passwordSaving: false });
      });
    };

    _this.equalPassword = function (value, opts) {
      (0, _webValidations.assertString)(value);
      var validity = (0, _webValidations.createValidity)(opts.key);
      var passwords = _this.state.passwords;
      var t = _this.props.t;

      if (value !== '' && value !== passwords.new) {
        validity.isValid = false;
        validity.message = t('Confirm password does not match new password', { ns: _translation.TRANSLATION_FILES.translation });
      }
      return validity;
    };

    _this.state = {
      token: null,
      loading: true,
      edit: false,
      editPassword: false,
      data: null,
      oriData: null,
      errMessages: [],
      hasChanges: false,
      passwords: {
        current: '',
        new: '',
        confirm: ''
      }
    };
    _this.validation = {
      name: (0, _react.createRef)(),
      preferredName: (0, _react.createRef)(),
      mobilePrefix: (0, _react.createRef)(),
      mobile: (0, _react.createRef)()
    };
    _this.passwordValidation = {
      current: (0, _react.createRef)(),
      new: (0, _react.createRef)(),
      confirm: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(Overview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      this.profileMounted = true;
      this.updatePendingStatus = function () {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            fields = _ref2.fields,
            userID = _ref2.userID;

        if (fields && userID === (_this3.props.auth || {}).id) _this3.acceptProfileFields(fields);
        var profileSaveWarning = profileWriteUnconfirmed && !pendingProfileIsAudit ? _this3.props.t('Profile save is still unconfirmed. Your edits are preserved. Wait for the connection to recover before retrying.', { ns: _translation.TRANSLATION_FILES.translation }) : null;
        _this3.setState({ profileSaveWarning: profileSaveWarning });
      };
      profileStatusListeners.add(this.updatePendingStatus);
      this.updatePendingStatus();
      var store = this.context.store;


      this.fetchProfile().catch(function (err) {
        Bugsnag.notifyException(err);
        store.dispatch((0, _flash.flashErrorMessage)(err));
      });
      _i18next2.default.on('languageChanged', this.handleI18nChange);
      _i18next2.default.on('explicitLanguageSelected', this.handleExplicitLanguageChange);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.profileMounted = false;
      profileStatusListeners.delete(this.updatePendingStatus);
      _i18next2.default.off('languageChanged', this.handleI18nChange);
      _i18next2.default.off('explicitLanguageSelected', this.handleExplicitLanguageChange);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this4 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this4.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this5 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this5.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      var _this6 = this;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true }, function () {
          _this6.handleOnCheck(true);
        });
      }
    }
  }, {
    key: 'handleResetCheck',
    value: function handleResetCheck() {
      var _this7 = this;

      if (this.state.hasChanges) {
        this.setState({ hasChanges: false }, function () {
          _this7.handleOnCheck(false);
        });
      }
    }
  }, {
    key: 'handleChangeLanguage',
    value: function handleChangeLanguage(currentLanguage) {
      var displayI18n = this.props.i18n;

      if (currentLanguage !== '') {
        this.explicitDisplayLanguage = currentLanguage;
        (0, _displayLanguage.changeDisplayLanguage)(displayI18n, currentLanguage);
      }
    }
  }, {
    key: 'fetchProfile',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this8 = this;

        var store, t, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context2.prev = 5;
                _context2.next = 8;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('apiURL') + '/profile/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context2.sent;
                _context2.next = 19;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](5);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context2.next = 18;
                return this.setLoading(false);

              case 18:
                return _context2.abrupt('return');

              case 19:
                if (res.ok) {
                  _context2.next = 27;
                  break;
                }

                _context2.next = 22;
                return res.text();

              case 22:
                message = _context2.sent;
                _context2.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context2.next = 39;
                break;

              case 27:
                token = res.headers.get('X-Csrf-Token');
                _context2.next = 30;
                return res.json();

              case 30:
                data = _context2.sent;

                Object.assign(data, this.pendingAcceptedFields || {});
                this.pendingAcceptedFields = null;
                data.currentPassword = '';
                data.updatePassword = '';
                data.comfirmPassword = '';
                // A language event can arrive while the profile request is still loading.
                if (this.observedDisplayLanguage) {
                  data.language = this.observedDisplayLanguage;
                  data.currentLanguageCode = this.observedDisplayLanguage;
                }
                // handle token.. etc
                _context2.next = 39;
                return this.setComponentState({
                  token: token,
                  data: data,
                  oriData: (0, _clone2.default)(data)
                }, function () {
                  _this8.handleResetCheck();
                });

              case 39:
                _context2.next = 41;
                return this.setLoading(false);

              case 41:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 11]]);
      }));

      function fetchProfile() {
        return _ref3.apply(this, arguments);
      }

      return fetchProfile;
    }()
  }, {
    key: 'putProfile',
    value: function putProfile(validations, staff) {
      var _this9 = this;

      var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (this.profileSaveInFlight) return Promise.resolve();
      if (pendingPasswordChange && !silent) {
        this.context.store.dispatch((0, _flash.flashErrorMessage)({ message: this.props.t('Wait for the pending profile or password request to finish before saving again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
        return Promise.resolve();
      }
      this.profileSaveInFlight = true;
      this.setState({ profileSaving: true, profileSaveWarning: null, languageSaveWarning: null });
      this.profileSavePromise = this.persistProfile(validations, staff, silent).finally(function () {
        _this9.profileSaveInFlight = false;
        _this9.setState({ profileSaving: false });
      });
      return this.profileSavePromise;
    }
  }, {
    key: 'boundedProfileWrite',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(options) {
        var _this10 = this;

        var audit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var unknown, timer, expired, operation, userID, settled;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                unknown = function unknown() {
                  return Object.assign(new Error(_this10.props.t('Profile save is still unconfirmed. Your edits are preserved. Wait for the connection to recover before retrying.', { ns: _translation.TRANSLATION_FILES.translation })), { code: 'PROFILE_SAVE_UNCONFIRMED' });
                };

                if (!pendingProfileWrite) {
                  _context4.next = 3;
                  break;
                }

                throw unknown();

              case 3:
                timer = void 0;
                expired = false;
                operation = Promise.resolve().then(function () {
                  return _this10.context.store.dispatch((0, _fetchM.fetchM)(_config2.default.get('apiURL') + '/profile/', options));
                }).then(function (response) {
                  return response.json();
                }, function () {
                  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(error) {
                    var message;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                      while (1) {
                        switch (_context3.prev = _context3.next) {
                          case 0:
                            if (!(error.res && error.res.status >= 400 && error.res.status < 500)) {
                              _context3.next = 5;
                              break;
                            }

                            _context3.next = 3;
                            return error.res.text();

                          case 3:
                            message = _context3.sent;
                            throw new Error(message || error.message);

                          case 5:
                            throw error;

                          case 6:
                          case 'end':
                            return _context3.stop();
                        }
                      }
                    }, _callee3, _this10);
                  }));

                  return function (_x10) {
                    return _ref5.apply(this, arguments);
                  };
                }());

                pendingProfileWrite = operation;
                pendingProfileIsAudit = audit;
                userID = (this.props.auth || {}).id;

                settled = function settled(error) {
                  if (pendingProfileWrite === operation) pendingProfileWrite = null;
                  profileWriteUnconfirmed = false;
                  var fields = expired && !error ? JSON.parse(options.body) : null;
                  if (fields) delete fields.updatePassword;
                  notifyProfileStatus(fields, userID);
                  if (fields && _this10.profileMounted !== false && !profileStatusListeners.has(_this10.updatePendingStatus)) {
                    _this10.acceptProfileFields(fields);
                  }
                  if (expired) {
                    if (!error) (0, _refreshUserCache.refreshUserCache)().catch(function (err) {
                      return Bugsnag.notifyException(err);
                    });
                    // Reconcile the accepted baseline only; never replace entered form values.
                    if (!audit && _this10.profileMounted !== false) {
                      _this10.setState({ profileSaveWarning: error ? error.message : null });
                    }
                  }
                };

                operation.then(function () {
                  return settled(null);
                }, settled);
                _context4.prev = 11;
                _context4.next = 14;
                return Promise.race([operation, new Promise(function (resolve, reject) {
                  timer = setTimeout(function () {
                    expired = true;
                    profileWriteUnconfirmed = true;
                    notifyProfileStatus();
                    reject(unknown());
                  }, 5000);
                })]);

              case 14:
                return _context4.abrupt('return', _context4.sent);

              case 15:
                _context4.prev = 15;
                clearTimeout(timer);return _context4.finish(15);

              case 18:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[11,, 15, 18]]);
      }));

      function boundedProfileWrite(_x8) {
        return _ref4.apply(this, arguments);
      }

      return boundedProfileWrite;
    }()
  }, {
    key: 'acceptProfileFields',
    value: function acceptProfileFields(fields) {
      var _this11 = this;

      if (!this.state.oriData || !this.state.data) {
        this.pendingAcceptedFields = _extends({}, this.pendingAcceptedFields, fields);
        return;
      }
      this.setState(function (previous) {
        var oriData = _extends({}, previous.oriData, fields);
        var hasChanges = profileHasChanges(previous.data, oriData);
        return { oriData: oriData, hasChanges: hasChanges, edit: previous.edit || hasChanges };
      }, function () {
        return _this11.handleOnCheck(_this11.state.hasChanges);
      });
    }
  }, {
    key: 'persistProfile',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(validations, staff) {
        var _this12 = this;

        var silent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var store, t, errors, languageChanged, res, profileFields, refreshUser, languageFailed, savedLanguage, selectionRevision, data;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context5.next = 7;
                  break;
                }

                this.setState({ edit: true });
                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context5.abrupt('return');

              case 7:
                languageChanged = this.languageSavePending || staff.language !== this.state.oriData.language;
                res = void 0;
                profileFields = void 0;
                refreshUser = false;
                languageFailed = false;
                _context5.prev = 12;

                if (!languageChanged) {
                  _context5.next = 34;
                  break;
                }

                this.languageSavePending = true;
                this.handleChangeLanguage(staff.language);
                savedLanguage = staff.language;
                selectionRevision = this.explicitLanguageRevision || 0;
                _context5.prev = 18;
                _context5.next = 21;
                return (0, _languagePreference.saveLanguagePreference)(savedLanguage);

              case 21:
                // Refresh once after the profile attempt, even if that unrelated PUT fails.
                refreshUser = true;
                this.languageSavePending = false;
                // Advance only the saved baseline, preserving edits made during the request.
                if (selectionRevision === (this.explicitLanguageRevision || 0)) {
                  this.setState({
                    oriData: _extends({}, this.state.oriData, {
                      language: savedLanguage,
                      currentLanguageCode: savedLanguage
                    })
                  });
                }
                _context5.next = 31;
                break;

              case 26:
                _context5.prev = 26;
                _context5.t0 = _context5['catch'](18);

                languageFailed = true;
                if (_context5.t0.code === 'LANGUAGE_SAVE_UNCONFIRMED') this.setState({ languageSaveWarning: t('Language save is still unconfirmed. This tab keeps your selection. Wait for the connection to recover before retrying.', { ns: _translation.TRANSLATION_FILES.translation }) });
                if (!_context5.t0.blocked) Bugsnag.notifyException(_context5.t0);

              case 31:
                _context5.prev = 31;
                this.languageSavePending = false;return _context5.finish(31);

              case 34:
                // The form may have changed while the preference write was pending.
                profileFields = Object.keys(this.state.data).reduce(function (changed, key) {
                  return !(0, _isEqual2.default)(_this12.state.data[key], _this12.state.oriData[key]) ? _extends({}, changed, _defineProperty({}, key, _this12.state.data[key])) : changed;
                }, {});
                delete profileFields.updatePassword;
                delete profileFields.currentPassword;
                delete profileFields.confirmPassword;
                delete profileFields.comfirmPassword;
                delete profileFields.language;
                delete profileFields.currentLanguageCode;
                delete profileFields.currentLanguageSetAt;
                _context5.next = 44;
                return this.boundedProfileWrite({
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(profileFields)
                });

              case 44:
                res = _context5.sent;

                refreshUser = true;
                _context5.next = 56;
                break;

              case 48:
                _context5.prev = 48;
                _context5.t1 = _context5['catch'](12);

                Bugsnag.notifyException(_context5.t1);
                if (_context5.t1.code === 'PROFILE_SAVE_UNCONFIRMED') this.setState({ profileSaveWarning: _context5.t1.message });
                if (!silent) store.dispatch((0, _flash.flashErrorMessage)(_context5.t1));

                if (!silent) {
                  _context5.next = 55;
                  break;
                }

                throw _context5.t1;

              case 55:
                return _context5.abrupt('return');

              case 56:
                _context5.prev = 56;

                if (!refreshUser) {
                  _context5.next = 66;
                  break;
                }

                _context5.prev = 58;
                _context5.next = 61;
                return (0, _refreshUserCache.refreshUserCache)();

              case 61:
                _context5.next = 66;
                break;

              case 63:
                _context5.prev = 63;
                _context5.t2 = _context5['catch'](58);
                Bugsnag.notifyException(_context5.t2);

              case 66:
                return _context5.finish(56);

              case 67:
                data = res;

                this.setState(function (previous) {
                  var oriData = _extends({}, previous.oriData, profileFields);
                  var hasChanges = profileHasChanges(previous.data, oriData);
                  return { oriData: oriData, hasChanges: hasChanges, edit: hasChanges };
                }, function () {
                  _this12.handleOnCheck(_this12.state.hasChanges);
                  // Unrelated profile edits must not change this presentation tab's language.
                  if (!silent && languageFailed) store.dispatch((0, _flash.flashErrorMessage)({ message: t('Profile saved; language could not be saved. Please retry the language selection.', { ns: _translation.TRANSLATION_FILES.translation }) }));
                  if (!silent && !languageFailed) store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully updated', { name: data.name, ns: _translation.TRANSLATION_FILES.translation }) }));
                });

              case 69:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[12, 48, 56, 67], [18, 26, 31, 34], [58, 63]]);
      }));

      function persistProfile(_x11, _x12) {
        return _ref6.apply(this, arguments);
      }

      return persistProfile;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this13 = this;

      var _props = this.props,
          auth = _props.auth,
          t = _props.t;
      var _state = this.state,
          data = _state.data,
          passwords = _state.passwords,
          editPassword = _state.editPassword;

      var saving = this.state.loading || this.state.profileSaving || this.state.passwordSaving;
      var profileLanguageOptions = (0, _languageOptions.languageOptions)(_languages2.default, auth && auth.company && auth.company.activeLanguageCodes, data && data.language).map(function (l) {
        return _extends({}, l, { text: t(l.text, { ns: _translation.TRANSLATION_FILES.constants }) });
      });

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Overview')
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              this.state.auditSaveWarning && _react2.default.createElement(
                'p',
                { role: 'alert' },
                this.state.auditSaveWarning
              ),
              this.state.passwordSaveWarning && _react2.default.createElement(
                'p',
                { role: 'alert' },
                this.state.passwordSaveWarning
              ),
              this.state.languageSaveWarning && _react2.default.createElement(
                'p',
                { role: 'alert' },
                this.state.languageSaveWarning
              ),
              this.state.profileSaveWarning && _react2.default.createElement(
                'p',
                { role: 'alert' },
                this.state.profileSaveWarning
              ),
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { active: saving, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Profile Information')
              ),
              data ? _react2.default.createElement(_EditableBox2.default, {
                editable: true,
                isEditing: this.state.edit,
                loading: saving,
                onEdit: this.handleEditProfile,
                onClick: this.handleUpdateProfile,
                onCancel: this.handleResetChanges,
                content: function content(_ref7) {
                  var isEditing = _ref7.isEditing,
                      onConfirm = _ref7.onConfirm;
                  return _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 16, computer: 4 },
                      _this13.state.oriData ? _react2.default.createElement(
                        _semanticUiReact.Grid,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Row,
                          { stretched: true },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { width: 16 },
                            _react2.default.createElement(
                              _semanticUiReact.Header,
                              { as: 'h2', textAlign: 'center' },
                              _this13.state.oriData.preferredName,
                              _react2.default.createElement(
                                _semanticUiReact.Header.Subheader,
                                null,
                                _react2.default.createElement(
                                  'i',
                                  null,
                                  _react2.default.createElement(_Timestamp2.default, { format: 'MMMM Do YYYY, h:mm a', timestamp: _this13.state.oriData.createdAt })
                                )
                              )
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { width: 16 },
                            _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, className: 'tablet-hide' })
                          )
                        )
                      ) : null,
                      _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, className: 'large-hide small-hide' })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 8, computer: 6 },
                      _react2.default.createElement(
                        _AppForm2.default,
                        {
                          onSubmit: onConfirm,
                          error: _this13.state.errMessages.length > 0,
                          ref: function ref(_ref8) {
                            _this13.form = _ref8;
                          }
                        },
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { verticalAlign: 'middle' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 8 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Name')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 8 },
                            isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                              fluid: true,
                              name: 'name',
                              onChange: _this13.handleOnChange,
                              placeholder: t('Name'),
                              value: data.name,
                              ref: _this13.validation.name,
                              validateLabel: t('Name'),
                              validation: [_webValidations.required]
                            }) : data.name
                          )
                        ),
                        _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { verticalAlign: 'middle' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 8 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Preferred name')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 8 },
                            isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                              fluid: true,
                              name: 'preferredName',
                              onChange: _this13.handleOnChange,
                              placeholder: t('Preferred name'),
                              value: data.preferredName,
                              ref: _this13.validation.preferredName,
                              validation: [_webValidations.required],
                              validateLabel: t('Preferred name')
                            }) : data.preferredName
                          )
                        ),
                        _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { verticalAlign: 'middle' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 8 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Email')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 8 },
                            _react2.default.createElement(
                              'a',
                              { href: 'mailto:' + data.email },
                              data.email
                            )
                          )
                        ),
                        _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 8, computer: 6 },
                      _react2.default.createElement(
                        _AppForm2.default,
                        {
                          onSubmit: onConfirm,
                          error: _this13.state.errMessages.length > 0,
                          ref: function ref(_ref9) {
                            _this13.form = _ref9;
                          }
                        },
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { verticalAlign: 'middle' },
                          isEditing ? _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 8 },
                            _react2.default.createElement(
                              _AppForm2.default.Validate,
                              {
                                validation: [_webValidations.required],
                                ref: _this13.validation.mobilePrefix,
                                onChange: _this13.handleOnChange
                              },
                              _react2.default.createElement(_semanticUiReact.Form.Select, {
                                label: t('Mobile prefix'),
                                fluid: true,
                                search: true,
                                name: 'mobilePrefix',
                                options: _intlCallCodes2.default,
                                selectOnBlur: false,
                                value: data.mobilePrefix,
                                noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                              })
                            )
                          ) : _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: isEditing ? 4 : 8 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Mobile')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: isEditing ? 'left' : 'right', width: 8 },
                            isEditing ? _react2.default.createElement(_PhoneInput2.default, {
                              fluid: true,
                              label: t('Mobile'),
                              name: 'mobile',
                              onChange: _this13.handleOnChange,
                              type: 'tel',
                              placeholder: 'mobile',
                              prefix: data.mobilePrefix,
                              value: data.mobile,
                              validation: [_webValidations.required],
                              validateLabel: t('Mobile'),
                              ref: _this13.validation.mobile
                            }) : _react2.default.createElement(_Phone2.default, {
                              mobilePrefix: data.mobilePrefix,
                              mobile: data.mobile
                            })
                          )
                        ),
                        _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { verticalAlign: 'middle' },
                          isEditing ? _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 8 },
                            _react2.default.createElement(_semanticUiReact.Form.Select, {
                              label: t('Phone prefix'),
                              fluid: true,
                              search: true,
                              name: 'officeTelPrefix',
                              onChange: _this13.handleOnChange,
                              options: _intlCallCodes2.default,
                              selectOnBlur: false,
                              value: data.officeTelPrefix,
                              noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                            })
                          ) : _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: isEditing ? 4 : 8 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Phone')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: isEditing ? 'left' : 'right', width: 8 },
                            isEditing ? _react2.default.createElement(_PhoneInput2.default, {
                              fluid: true,
                              label: t('Phone'),
                              name: 'officeTel',
                              onChange: _this13.handleOnChange,
                              type: 'tel',
                              placeholder: t('Phone Number'),
                              prefix: data.officeTelPrefix,
                              value: data.officeTel
                            }) : _react2.default.createElement(_Phone2.default, {
                              mobilePrefix: data.officeTelPrefix,
                              mobile: data.officeTel
                            })
                          )
                        ),
                        _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { verticalAlign: 'middle' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 8 },
                            isEditing ? _react2.default.createElement(_semanticUiReact.Form.Select, {
                              label: t('Default language'),
                              fluid: true,
                              search: true,
                              name: 'language',
                              onChange: _this13.handleOnChange,
                              options: profileLanguageOptions,
                              selectOnBlur: false,
                              value: data.language,
                              noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                            }) : _react2.default.createElement(
                              'b',
                              null,
                              t('Default language')
                            )
                          ),
                          !isEditing && _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 8 },
                            t((0, _valueToText2.default)(_languages2.default, data.language), {
                              ns: _translation.TRANSLATION_FILES.constants
                            })
                          )
                        ),
                        !auth.isADFS && (!editPassword ? _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { verticalAlign: 'middle' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { width: '16', textAlign: 'right' },
                            _react2.default.createElement(
                              _semanticUiReact.Button,
                              {
                                type: 'button',
                                onClick: _this13.handleEditPassword,
                                disabled: _this13.state.loading || isEditing
                              },
                              t('Change password')
                            )
                          )
                        ) : null)
                      )
                    )
                  );
                }
              }) : _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                t('No staff found')
              ),
              data && editPassword ? _react2.default.createElement(_EditableBox2.default, {
                editable: true,
                isEditing: true,
                loading: saving,
                onClick: this.handleChangePassword,
                onCancel: this.handleResetPasswordChanges,
                content: function content(_ref10) {
                  var onConfirm = _ref10.onConfirm;
                  return _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16 },
                      _react2.default.createElement(
                        _AppForm2.default,
                        {
                          onSubmit: onConfirm,
                          error: _this13.state.errMessages.length > 0,
                          ref: function ref(_ref11) {
                            _this13.form = _ref11;
                          }
                        },
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { verticalAlign: 'middle' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 8 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Password update'),
                              ':'
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { width: 8 },
                            _react2.default.createElement(_AppForm2.default.Input, {
                              label: t('Current'),
                              fluid: true,
                              name: 'current',
                              type: 'password',
                              value: passwords.current,
                              validateLabel: t('Current password'),
                              validation: [_webValidations.required],
                              ref: _this13.passwordValidation.current,
                              onChange: _this13.handleOnChangePassword
                            }),
                            _react2.default.createElement(_AppForm2.default.Input, {
                              label: t('New', { ns: _translation.TRANSLATION_FILES.constants }),
                              fluid: true,
                              name: 'new',
                              type: 'password',
                              validateLabel: t('Update password'),
                              validation: [_webValidations.required],
                              value: passwords.new,
                              ref: _this13.passwordValidation.new,
                              onChange: _this13.handleOnChangePassword
                            }),
                            _react2.default.createElement(_AppForm2.default.Input, {
                              label: t('Re-type new'),
                              fluid: true,
                              name: 'confirm',
                              type: 'password',
                              value: passwords.confirm,
                              validateLabel: t('Confirm password'),
                              validation: [_webValidations.required, _this13.equalPassword],
                              ref: _this13.passwordValidation.confirm,
                              onChange: _this13.handleOnChangePassword
                            })
                          )
                        )
                      )
                    )
                  );
                }
              }) : null
            )
          )
        )
      );
    }
  }]);

  return Overview;
}(_react.Component);

Overview.propTypes = {
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func.isRequired,
  i18n: _propTypes2.default.shape({ changeLanguage: _propTypes2.default.func }),
  auth: _propTypes2.default.shape({
    id: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    isADFS: _propTypes2.default.bool,
    company: _propTypes2.default.shape({ activeLanguageCodes: _propTypes2.default.arrayOf(_propTypes2.default.string) })
  })
};
Overview.contextTypes = {
  store: _propTypes2.default.object
};

Overview.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Overview.mapStateToProps)(Overview));

/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _checkChanges = __webpack_require__(61);

var _Overview = __webpack_require__(2387);

var _Overview2 = _interopRequireDefault(_Overview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Profile = function (_Component) {
  _inherits(Profile, _Component);

  function Profile() {
    _classCallCheck(this, Profile);

    return _possibleConstructorReturn(this, (Profile.__proto__ || Object.getPrototypeOf(Profile)).apply(this, arguments));
  }

  _createClass(Profile, [{
    key: 'renderChild',
    value: function renderChild() {
      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Profile;
}(_react.Component);

Profile.propTypes = {
  children: _propTypes2.default.node
};
Profile.contextTypes = {
  store: _propTypes2.default.object
};
Profile.Overview = (0, _checkChanges.checkChanges)(_Overview2.default);
exports.default = Profile;

/***/ }),
/* 2389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Profile = __webpack_require__(2388);

var _Profile2 = _interopRequireDefault(_Profile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Profile2.default;

/***/ }),
/* 2390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(13);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _addressSettings = __webpack_require__(152);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _ProjectActivities = __webpack_require__(1027);

var _ProjectActivities2 = _interopRequireDefault(_ProjectActivities);

var _translation = __webpack_require__(4);

var _navigations = __webpack_require__(117);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


var Activities = function (_Component) {
  _inherits(Activities, _Component);

  function Activities(props) {
    _classCallCheck(this, Activities);

    var _this = _possibleConstructorReturn(this, (Activities.__proto__ || Object.getPrototypeOf(Activities)).call(this, props));

    _initialiseProps.call(_this);

    var state = Activities.getPropsToState(props);
    state.limit = 0;
    state.offset = 0;
    state.currentPage = parseInt(state.query.page, 10) || 1;
    state.count = 0;
    _this.state = state;
    return _this;
  }

  _createClass(Activities, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;

      store.dispatch((0, _addressSettings.fetchAddressSettings)());
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
      var query = this.props.location.query;

      this.getProjectActivities(query);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var query = nextProps.location.query;

      var state = Activities.getPropsToState(nextProps);
      if (this.state.activitiesData) {
        state.activitiesData = this.state.activitiesData;
      }
      this.setState(_extends({}, state), function () {
        if (!_this2.state.activitiesData) {
          _this2.getProjectActivities(query);
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'getProjectActivities',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var store, t, query, queryString, res, message, activitiesData, count, limit, offset;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                queryString = '';
                res = null;

                if (_qs2.default.stringify(query)) {
                  queryString = '?' + _qs2.default.stringify(query);
                }
                _context.prev = 9;
                _context.next = 12;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/activities/' + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context.sent;
                _context.next = 26;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](9);
                _context.next = 19;
                return this.setLoading(false);

              case 19:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 24;
                  break;
                }

                _context.next = 22;
                return _context.t0.res.text();

              case 22:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 26:
                if (res.ok) {
                  _context.next = 32;
                  break;
                }

                _context.next = 29;
                return this.setLoading(false);

              case 29:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                _context.next = 42;
                break;

              case 32:
                _context.next = 34;
                return res.json();

              case 34:
                activitiesData = _context.sent;
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 40;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset,
                  activitiesData: activitiesData
                });

              case 40:
                _context.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 15]]);
      }));

      function getProjectActivities(_x3) {
        return _ref.apply(this, arguments);
      }

      return getProjectActivities;
    }()
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters) {
        return true;
      }
      if (this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'replaceQuery',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(query) {
        var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var store, queryNew;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                queryNew = query;

                if (resetPage) queryNew.page = 1;
                _context2.next = 7;
                return this.getProjectActivities(query);

              case 7:
                store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.id + '/activities/?' + (0, _url.encodeSearch)(queryNew)));
                _context2.next = 10;
                return this.setLoading(false);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function replaceQuery(_x5) {
        return _ref2.apply(this, arguments);
      }

      return replaceQuery;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var pathname = this.props.location.pathname;
      var _state = this.state,
          activitiesData = _state.activitiesData,
          data = _state.data;
      var t = this.props.t;

      var links = (0, _navigations.routes)(this.props.id, data, this.hasAccess(), false, this.props.auth).map(function (l) {
        return _extends({}, l, {
          text: t(l.text)
        });
      });
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: link.text,
              content: link.text,
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this5.handleMenu(e, link);
              }
            });
          })
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(_SearchFilter2.default, {
                isLoading: this.state.loading,
                onChange: this.handleOnChange,
                onClose: this.handleClearFilter,
                search: this.state.search,
                placeholder: t('Search'),
                setAdvanceFilter: function setAdvanceFilter() {},
                leftNav: _react2.default.createElement(_PageNav2.default, {
                  currentPage: this.state.currentPage,
                  count: this.state.count,
                  limit: this.state.limit,
                  offset: this.state.offset,
                  dataSize: this.state.activitiesData.length,
                  loading: this.state.loading,
                  onChange: this.handleChangePage
                }),
                rightNav: _react2.default.createElement(_SortButton2.default, {
                  floated: 'right',
                  loading: this.state.loading,
                  items: this.sortItems,
                  onSort: this.handleSortData
                })
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, textAlign: 'center' },
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/projects/' + this.props.id + '/' },
                  _react2.default.createElement(
                    'small',
                    null,
                    this.state.data.project ? this.state.data.project.name : ''
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Segment,
                null,
                _react2.default.createElement(_ProjectActivities2.default, {
                  data: activitiesData || [],
                  hasAccess: this.hasAccess(),
                  loading: this.state.loading
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Activities;
}(_react.Component);

Activities.contextTypes = {
  store: _propTypes2.default.object
};
Activities.propTypes = {
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool
  }),
  id: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  })
};

Activities.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

Activities.getPropsToState = function (props) {
  var loading = props.loading;
  var data = props.data || [];
  var query = (0, _url.decodeSearch)(props.location.search);
  var search = query.search || '';
  var activitiesData = [];
  var menuIsTab = window.innerWidth <= 590;
  return {
    data: data,
    loading: loading,
    query: query,
    search: search,
    activitiesData: activitiesData,
    menuIsTab: menuIsTab
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.handleResize = function () {
    var state = {};
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this6.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    var unitLayoutResize = window.innerWidth < 768;
    if (unitLayoutResize !== _this6.state.unitLayoutResize) {
      state.unitLayoutResize = unitLayoutResize;
    }
    var galleryIsTab = window.innerWidth > 425;
    if (galleryIsTab !== _this6.state.galleryIsTab) {
      state.galleryIsTab = galleryIsTab;
    }
    var locationResize = window.innerWidth <= 375;
    if (locationResize !== _this6.state.locationResize) {
      state.locationResize = locationResize;
    }
    _this6.setState(_extends({}, state));
  };

  this.handleMenu = function (e, _ref3) {
    var value = _ref3.value;
    var store = _this6.context.store;

    if (value.includes(_config2.default.get('bookApiURL')) || value.includes(_config2.default.get('salesChartURL'))) {
      e.preventDefault();
      var winObj = window.open(value, '_blank');
      winObj.opener = null;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(value));
    }
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.page = currentPage;
    _this6.setState({
      currentPage: currentPage
    });
    _this6.replaceQuery(query);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this6.replaceQuery(query);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    if (hasQuery) {
      _this6.replaceQuery(query, true);
    } else {
      _this6.setState({ search: '' });
    }
  };

  this.handleOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query[queryName] = value;
    _this6.replaceQuery(query, true);
  };

  this.sortItems = [{
    text: 'Date Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'project_activity.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Date Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'project_activity.created_at',
    sortDirection: 'desc'
  }];
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Activities.mapStateToProps)(Activities));

/***/ }),
/* 2391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _fileSize = __webpack_require__(85);

var _fileSize2 = _interopRequireDefault(_fileSize);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _AddDocument = __webpack_require__(1073);

var _AddDocument2 = _interopRequireDefault(_AddDocument);

var _navigations = __webpack_require__(117);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _initialiseProps.call(_this);

    var state = List.getPropsToState(props);
    _this.state = _extends({}, state, {
      options: [],
      selectedFile: null,
      showRemove: false,
      showAddDocument: false,
      loading: false,
      project: []
    });
    return _this;
  }

  _createClass(List, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
      this.fetchProject();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'fetchProject',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, t, res, message, project;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 19;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context.next = 32;
                break;

              case 27:
                _context.next = 29;
                return res.json();

              case 29:
                project = _context.sent;
                _context.next = 32;
                return this.setState({
                  project: project
                });

              case 32:
                _context.next = 34;
                return this.setLoading(false);

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchProject() {
        return _ref.apply(this, arguments);
      }

      return fetchProject;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var store = this.context.store;

      store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.id + '/documents/?' + (0, _url.encodeSearch)(query)));
    }
  }, {
    key: 'addDocument',
    value: function addDocument() {
      var _this2 = this;

      var store = this.context.store;
      var t = this.props.t;

      store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/documents/' + this.state.selectedFile.id + '/', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.documentToken
        }
      })).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      }).then(function () {
        _this2.handleChangePage();
        store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Add Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Document successfully added to project', { ns: _translation.TRANSLATION_FILES.translation }) }));
      });
    }
  }, {
    key: 'removeDocument',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, t, res, message, _message;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context2.prev = 3;
                _context2.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/documents/' + this.state.selectedFile.id + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.documentToken
                  }
                }));

              case 6:
                res = _context2.sent;
                _context2.next = 21;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](3);
                _context2.next = 13;
                return this.setState({ selectedFile: null, loading: false });

              case 13:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 16;
                return _context2.t0.res.text();

              case 16:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 19:
                store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));
                return _context2.abrupt('return');

              case 21:
                this.setState({
                  selectedFile: null,
                  loading: false
                });

                if (res.ok) {
                  _context2.next = 30;
                  break;
                }

                _context2.next = 25;
                return res.text();

              case 25:
                _message = _context2.sent;
                _context2.next = 28;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 28:
                _context2.next = 32;
                break;

              case 30:
                this.handleChangePage();
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Remove Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Document successfully deleted', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 32:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 9]]);
      }));

      function removeDocument() {
        return _ref2.apply(this, arguments);
      }

      return removeDocument;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          auth = _props.auth,
          id = _props.id,
          location = _props.location,
          t = _props.t;
      var pathname = location.pathname;

      var companyServiceID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
      var isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
      var links = (0, _navigations.editRoutes)(id, this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled, isMalaysia, companyServiceID).map(function (l) {
        return _extends({}, l, {
          text: t(l.text, { ns: l.text === 'Edit' ? _translation.TRANSLATION_FILES.translation : _translation.TRANSLATION_FILES.screens })
        });
      });
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: link.text,
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this3.handleMenu(e, link);
              }
            });
          }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              onClick: this.handleShowAddDocument,
              disabled: this.state.loading,
              primary: true,
              icon: 'add',
              content: t('Add', { ns: _translation.TRANSLATION_FILES.screens })
            })
          )
        }),
        _react2.default.createElement(_AddDocument2.default, {
          open: this.state.showAddDocument,
          onClose: this.handleCloseAddDocument,
          onConfirm: this.handleAddDocument,
          onUpload: this.handleUpload,
          onCheck: this.handleCheck
        }),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            open: this.state.showRemove,
            onClose: this.handleCancelRemove
          },
          _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: t('Confirm remove?', { ns: _translation.TRANSLATION_FILES.translation }) }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Modal.Description,
              null,
              _react2.default.createElement(_semanticUiReact.Header, {
                as: 'h3',
                content: t('Are you sure to remove this file?', { ns: _translation.TRANSLATION_FILES.translation }),
                subheader: this.state.selectedFile ? this.state.selectedFile.name : ''
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(_semanticUiReact.Button, { basic: true, negative: true, onClick: this.handleCancelRemove, icon: 'cancel', content: t('No', { ns: _translation.TRANSLATION_FILES.screens }), inverted: true }),
            _react2.default.createElement(_semanticUiReact.Button, { basic: true, positive: true, onClick: this.handleConfirmRemove, icon: 'remove', content: t('Yes', { ns: _translation.TRANSLATION_FILES.screens }), inverted: true })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          {
            inverted: true, style: { zIndex: 20 },
            active: this.state.loading && this.state.documents.length > 0
          },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table,
          {
            striped: true, unstackable: true,
            color: 'blue',
            selectable: true
          },
          _react2.default.createElement(
            _semanticUiReact.Table.Header,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 4, textAlign: 'right' },
                _react2.default.createElement(_PageNav2.default, {
                  currentPage: this.state.currentPage,
                  count: this.state.count,
                  limit: this.state.limit,
                  offset: this.state.offset,
                  dataSize: this.state.documents.length,
                  loading: this.state.loading,
                  onChange: this.handleChangePage
                })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Name', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Size', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                null,
                t('Tags', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null)
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Body,
            null,
            this.state.documents.length > 0 ? this.state.documents.map(function (file, key) {
              return _react2.default.createElement(
                _semanticUiReact.Table.Row,
                { key: key },
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { width: 6 },
                  _react2.default.createElement(
                    'a',
                    {
                      href: _config2.default.get('bookApiURL') + '/documents/' + file.id + '/view/' + encodeURIComponent(file.name) + '.pdf',
                      target: '_blank',
                      rel: 'noopener noreferrer'
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'file pdf outline' }),
                    file.name
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { collapsing: true },
                  (0, _fileSize2.default)(file.size)
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Label.Group,
                    { size: 'tiny' },
                    file.tags && file.tags.length > 0 ? file.tags.map(function (t, idx) {
                      return _react2.default.createElement(
                        _semanticUiReact.Label,
                        { key: idx, as: 'a' },
                        t
                      );
                    }) : _react2.default.createElement(
                      'p',
                      null,
                      t('No tags set', { ns: _translation.TRANSLATION_FILES.translation })
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  { collapsing: true, textAlign: 'right' },
                  _react2.default.createElement(_semanticUiReact.Button, {
                    size: 'tiny',
                    compact: true,
                    negative: true,
                    icon: 'remove',
                    disabled: _this3.state.loading,
                    onClick: function onClick(e) {
                      return _this3.handleRemove(e, file);
                    }
                  })
                )
              );
            }) : _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.Cell,
                { colSpan: 4, textAlign: 'center' },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                ) : t('No documents found.', { ns: _translation.TRANSLATION_FILES.translation })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Footer,
            { fullWidth: true },
            _react2.default.createElement(
              _semanticUiReact.Table.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Table.HeaderCell,
                { colSpan: 4, textAlign: 'right' },
                _react2.default.createElement(_PageNav2.default, {
                  currentPage: this.state.currentPage,
                  count: this.state.count,
                  limit: this.state.limit,
                  offset: this.state.offset,
                  dataSize: this.state.documents.length,
                  loading: this.state.loading,
                  onChange: this.handleChangePage
                })
              )
            )
          )
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};
List.propTypes = {
  documentToken: _propTypes2.default.string,
  id: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      lawyerIsEnabled: _propTypes2.default.bool
    })
  }),
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.object
  }),
  t: _propTypes2.default.func.isRequired
};

List.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  var count = props.count;
  var limit = props.limit;
  var offset = props.offset;
  var documents = props.documents || [];
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var menuIsTab = window.innerWidth <= 590;
  return {
    documents: documents,
    loading: loading,
    count: count,
    limit: limit,
    offset: offset,
    currentPage: currentPage,
    menuIsTab: menuIsTab
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this4.setState({ loading: loading }, res);
    });
  };

  this.handleResize = function () {
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this4.state.menuIsTab) {
      _this4.setState({ menuIsTab: menuIsTab });
    }
  };

  this.handleChangePage = function (page) {
    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
      query.page = 1;
    }
    var currentPage = parseInt(page || query.page, 10);
    query.page = currentPage;
    _this4.setState({ currentPage: currentPage });
    _this4.replaceQuery(query);
  };

  this.handleCancelRemove = function (e) {
    e.preventDefault();
    _this4.setState({
      showRemove: false,
      selectedFile: null
    });
  };

  this.handleRemove = function (e, selectedFile) {
    e.preventDefault();
    _this4.setState({
      selectedFile: selectedFile
    }, function () {
      _this4.setState({
        showRemove: true
      });
    });
  };

  this.handleConfirmRemove = function (e) {
    var store = _this4.context.store;
    var _state = _this4.state,
        project = _state.project,
        documents = _state.documents;

    e.preventDefault();
    _this4.setState({
      showRemove: false
    }, function () {
      if (project && (project.marketplaceIsPublish || project.marketplaceBuyerIsPublish) && documents.length === 1) {
        return store.dispatch((0, _flash.flashMessage)({
          header: 'Error',
          message: 'Document is required to launch project to Marketplace',
          icon: 'warning sign',
          type: 'error'
        }));
      }
      return _this4.removeDocument();
    });
  };

  this.handleUpload = function (body) {
    return {
      url: '/projects/' + _this4.props.id + '/documents/',
      options: {
        credentials: 'include',
        method: 'POST',
        headers: {
          // Let browser decide Content-Type
          'X-Csrf-Token': _this4.props.documentToken
        },
        body: body
      }
    };
  };

  this.handleShowAddDocument = function (e) {
    e.preventDefault();
    _this4.setState({
      showAddDocument: true
    });
  };

  this.handleCloseAddDocument = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this4.handleChangePage();
    _this4.setState({
      showAddDocument: false
    });
  };

  this.handleAddDocument = function (e, selectedFile) {
    e.preventDefault();
    _this4.setState({
      showAddDocument: false,
      selectedFile: selectedFile
    }, function () {
      _this4.addDocument();
    });
  };

  this.handleCheck = function (data) {
    if (data.projects && data.projects.length > 0) {
      return data.projects.some(function (p) {
        return p.id === _this4.props.id;
      });
    }
    return false;
  };

  this.handleMenu = function (e, _ref3) {
    var value = _ref3.value;
    var store = _this4.context.store;

    if (value.includes(_config2.default.get('developerURL'))) {
      e.preventDefault();
      window.location.href = value;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(value));
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(List.mapStateToProps)(List));

/***/ }),
/* 2392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _flash = __webpack_require__(5);

var _addressSettings = __webpack_require__(152);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1067);

var _Form2 = _interopRequireDefault(_Form);

var _navigations = __webpack_require__(117);

var _financeSources = __webpack_require__(992);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Edit = function (_Component) {
  _inherits(Edit, _Component);

  function Edit(props) {
    _classCallCheck(this, Edit);

    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));

    _initialiseProps.call(_this);

    var menuIsTab = window.innerWidth <= 630;
    _this.state = {
      menuIsTab: menuIsTab,
      hasChanges: false
    };
    return _this;
  }

  _createClass(Edit, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;

      store.dispatch((0, _addressSettings.fetchAddressSettings)());
      store.dispatch((0, _financeSources.fetchFinanceSources)());
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, data) {
        var _this2 = this;

        var store, t, project, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                project = data;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 7;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }).filter(function (m, idx, arr) {
                    return arr.indexOf(m) === idx;
                  }) }));
                return _context.abrupt('return');

              case 7:
                if (!(project.maOwnerCompanyBranchShortName === '' && project.maOwnerCompanyBranchID === 0)) {
                  _context.next = 10;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({
                  header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Project\'s Business Unit Owner is required', { ns: _translation.TRANSLATION_FILES.translation })
                }));
                return _context.abrupt('return');

              case 10:
                project.externalAutofillUrl = project.externalAutofillUrl.trim();
                if (project.autofillFromUrl && project.externalAutofillUrl.trim() === '') {
                  project.autofillFromUrl = false;
                }
                res = void 0;
                _context.prev = 13;
                _context.next = 16;
                return this.form.getWrappedInstance().getWrappedInstance().submit('/projects/' + this.props.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(project)
                });

              case 16:
                res = _context.sent;
                _context.next = 29;
                break;

              case 19:
                _context.prev = 19;
                _context.t0 = _context['catch'](13);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 27;
                  break;
                }

                _context.next = 24;
                return _context.t0.res.text();

              case 24:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 27:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 29:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false, function () {
                    store.dispatch((0, _reactRouterRedux.push)('/projects/' + _this2.props.id + '/edit/' + _this2.props.location.hash));
                  });
                });
                if (!this.props.data.marketplaceIsPublish && res.marketplaceIsPublish) {
                  store.dispatch((0, _flash.flashSuccessMessage)({
                    header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                    message: t('{{name}} is successfully launched to Marketplace', { name: res.name, ns: _translation.TRANSLATION_FILES.translation })
                  }));
                } else if (this.props.data.marketplaceIsPublish && !res.marketplaceIsPublish) {
                  store.dispatch((0, _flash.flashSuccessMessage)({
                    header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                    message: t('{{name}} is successfully removed from Marketplace', { name: res.name, ns: _translation.TRANSLATION_FILES.translation })
                  }));
                } else if (!this.props.data.marketplaceBuyerIsPublish && res.marketplaceBuyerIsPublish) {
                  store.dispatch((0, _flash.flashSuccessMessage)({
                    header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                    message: t('{{name}} is successfully launched to Showroom for Buyers', { name: res.name, ns: _translation.TRANSLATION_FILES.translation })
                  }));
                } else if (this.props.data.marketplaceBuyerIsPublish && !res.marketplaceBuyerIsPublish) {
                  store.dispatch((0, _flash.flashSuccessMessage)({
                    header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                    message: t('{{name}} is successfully removed from Showroom for Buyers', { name: res.name, ns: _translation.TRANSLATION_FILES.translation })
                  }));
                } else {
                  store.dispatch((0, _flash.flashSuccessMessage)({
                    header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                    message: t('{{name}} successfully updated', { name: res.name, ns: _translation.TRANSLATION_FILES.translation })
                  }));
                }

              case 31:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[13, 19]]);
      }));

      function submit(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          auth = _props.auth,
          id = _props.id,
          loading = _props.loading,
          location = _props.location,
          t = _props.t;
      var pathname = location.pathname;

      var companyServiceID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
      var isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
      var links = (0, _navigations.editRoutes)(id, this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled, isMalaysia, companyServiceID).map(function (l) {
        return _extends({}, l, {
          text: t(l.text, { ns: l.text === 'Edit' ? _translation.TRANSLATION_FILES.translation : _translation.TRANSLATION_FILES.screens })
        });
      });
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              disabled: loading,
              key: key,
              name: link.text,
              content: link.text,
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this3.handleMenu(e, link);
              }
            });
          }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Save', { ns: _translation.TRANSLATION_FILES.translation }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges || this.props.loading
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, project) {
            _this3.submit(validations, project);
          },
          onChange: this.handleOnChange,
          project: this.props.data,
          panelBankers: this.props.panelBankers,
          loading: this.props.loading,
          auth: this.props.auth,
          token: this.props.token,
          newFetch: this.props.newFetch
        })
      );
    }
  }]);

  return Edit;
}(_react.Component);

Edit.propTypes = {
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    company: _propTypes2.default.object
  }),
  token: _propTypes2.default.string,
  id: _propTypes2.default.string,
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  panelBankers: _propTypes2.default.arrayOf(_propTypes2.default.object),
  location: _propTypes2.default.shape({
    hash: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  loading: _propTypes2.default.bool,
  onCheck: _propTypes2.default.func,
  newFetch: _propTypes2.default.func,
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      lawyerIsEnabled: _propTypes2.default.bool
    })
  }),
  t: _propTypes2.default.func
};
Edit.contextTypes = {
  store: _propTypes2.default.object
};

Edit.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleResize = function () {
    var menuIsTab = window.innerWidth <= 630;
    if (menuIsTab !== _this4.state.menuIsTab) {
      _this4.setState({ menuIsTab: menuIsTab });
    }
  };

  this.handleSubmit = function (event) {
    _this4.form.getWrappedInstance().getWrappedInstance().handleCheckIfPublish(event);
  };

  this.handleMenu = function (e, _ref3) {
    var value = _ref3.value;
    var store = _this4.context.store;

    if (value.includes(_config2.default.get('developerURL'))) {
      e.preventDefault();
      window.location.href = value;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(value));
    }
  };

  this.handleOnChange = function (hasChanges) {
    if (hasChanges !== _this4.state.hasChanges) {
      _this4.setState({ hasChanges: hasChanges }, function () {
        _this4.handleOnCheck(hasChanges);
      });
    }
  };

  this.handleOnCheck = function () {
    var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var callback = arguments[1];

    if (_this4.props.onCheck) {
      _this4.props.onCheck(hasChanges, callback);
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Edit.mapStateToProps)(Edit));

/***/ }),
/* 2393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _AddLogo = __webpack_require__(2507);

var _AddLogo2 = _interopRequireDefault(_AddLogo);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _navigations = __webpack_require__(117);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var Logo = function (_Component) {
  _inherits(Logo, _Component);

  function Logo(props) {
    _classCallCheck(this, Logo);

    var _this = _possibleConstructorReturn(this, (Logo.__proto__ || Object.getPrototypeOf(Logo)).call(this, props));

    _initialiseProps.call(_this);

    var menuIsTab = window.innerWidth <= 630;
    var state = Logo.getPropsToState(props);
    _this.state = _extends({}, state, {
      menuIsTab: menuIsTab,
      loading: false,
      hasChanges: false,
      showAddLogo: false
    });
    return _this;
  }

  _createClass(Logo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Logo.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'getLogoToken',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var t, store, res, token, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                token = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/logos/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 16;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 15:
                return _context.abrupt('return', null);

              case 16:
                if (res.ok) {
                  _context.next = 24;
                  break;
                }

                _context.next = 19;
                return res.text();

              case 19:
                message = _context.sent;
                _context.next = 22;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 22:
                _context.next = 25;
                break;

              case 24:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

              case 25:
                return _context.abrupt('return', token);

              case 26:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function getLogoToken() {
        return _ref.apply(this, arguments);
      }

      return getLogoToken;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          auth = _props.auth,
          t = _props.t;
      var _state = this.state,
          project = _state.project,
          loading = _state.loading;
      var _location = location,
          pathname = _location.pathname;

      var companyServiceID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
      var isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
      var links = (0, _navigations.editRoutes)(this.props.id, this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled, isMalaysia, companyServiceID).map(function (l) {
        return _extends({}, l, {
          text: t(l.text, { ns: l.text === 'Edit' ? _translation.TRANSLATION_FILES.translation : _translation.TRANSLATION_FILES.screens })
        });
      });
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: link.text,
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this3.handleMenu(e, link);
              }
            });
          })
        }),
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          { style: { zIndex: 1 }, active: loading, inverted: true },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Divider,
          { horizontal: true },
          'Logo'
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', centered: true, verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            project && project.logo && project.logo.key ? _react2.default.createElement(
              _semanticUiReact.Segment,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { mobile: 16 },
                _react2.default.createElement(_LoadImage2.default, {
                  picture: project.logo,
                  pictureSize: 50,
                  extension: 'png'
                })
              )
            ) : null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 16 },
              _react2.default.createElement(_semanticUiReact.Button, {
                onClick: this.handleShowAddLogo,
                primary: true,
                icon: 'add',
                content: project && project.logoID ? t('Replace', { ns: _translation.TRANSLATION_FILES.screens }) : t('Add', { ns: _translation.TRANSLATION_FILES.screens })
              }),
              project && project.logoID ? _react2.default.createElement(_semanticUiReact.Button, {
                onClick: this.handleRemoveLogo,
                disabled: loading,
                negative: true,
                primary: true,
                icon: 'remove',
                content: t('Remove', { ns: _translation.TRANSLATION_FILES.screens })
              }) : null
            )
          )
        ),
        _react2.default.createElement(_AddLogo2.default, {
          ref: function ref(_ref2) {
            _this3.logoModal = _ref2;
          },
          open: this.state.showAddLogo,
          onClose: this.handleCloseAddLogo,
          onConfirm: this.handleAddLogo,
          onUpload: this.handleUploadLogo,
          onCheck: this.handleCheckLogo,
          isLoading: loading
        })
      );
    }
  }]);

  return Logo;
}(_react.Component);

Logo.contextTypes = {
  store: _propTypes2.default.object
};
Logo.propTypes = {
  id: _propTypes2.default.string,
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  location: _propTypes2.default.shape({
    hash: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  newFetch: _propTypes2.default.func,
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      lawyerIsEnabled: _propTypes2.default.bool
    })
  }),
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.object
  })
};

Logo.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

Logo.getPropsToState = function (props) {
  var project = props.data;
  return {
    project: project
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleOnSubmit = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var t, store, _state2, project, hasChanges, res, message, msg;

    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            t = _this4.props.t;
            store = _this4.context.store;
            _state2 = _this4.state, project = _state2.project, hasChanges = _state2.hasChanges;
            res = void 0;
            _context2.next = 6;
            return _this4.setLoading(true);

          case 6:
            if (!hasChanges) {
              _context2.next = 30;
              break;
            }

            _context2.prev = 7;
            _context2.next = 10;
            return store.dispatch((0, _fetchM.fetchM)('/projects/' + _this4.props.id + '/', {
              credentials: 'include',
              method: 'PUT',
              headers: {
                'Content-Type': 'application/json',
                'X-Csrf-Token': _this4.props.token
              },
              body: JSON.stringify(project)
            }));

          case 10:
            res = _context2.sent;
            _context2.next = 26;
            break;

          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2['catch'](7);
            _context2.next = 17;
            return _this4.setLoading(false);

          case 17:
            if (!(_context2.t0 && _context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
              _context2.next = 24;
              break;
            }

            _context2.next = 20;
            return _context2.t0.res.text();

          case 20:
            message = _context2.sent;

            store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
            _context2.next = 25;
            break;

          case 24:
            store.dispatch((0, _flash.flashErrorMessage)({ message: _context2.t0.message }));

          case 25:
            return _context2.abrupt('return');

          case 26:
            _context2.next = 28;
            return _this4.setLoading(false);

          case 28:
            _this4.setState({ hasChanges: false }, function () {
              store.dispatch((0, _reactRouterRedux.push)('/projects/' + _this4.props.id + '/logo/'));
            });
            if (res) {
              msg = t('Logo has been updated successfully', { ns: _translation.TRANSLATION_FILES.translation });

              if (!project.logoID && !project.logo) {
                msg = t('Logo has been removed successfully', { ns: _translation.TRANSLATION_FILES.translation });
              }
              store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: msg }));
            }

          case 30:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, _this4, [[7, 13]]);
  }));

  this.handleResize = function () {
    var menuIsTab = window.innerWidth <= 630;
    if (menuIsTab !== _this4.state.menuIsTab) {
      _this4.setState({ menuIsTab: menuIsTab });
    }
  };

  this.handleMenu = function (e, _ref4) {
    var value = _ref4.value;
    var store = _this4.context.store;

    if (value.includes(_config2.default.get('developerURL'))) {
      e.preventDefault();
      window.location.href = value;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(value));
    }
  };

  this.handleAddLogo = function (e, selectedLogo) {
    e.preventDefault();
    var project = _this4.state.project;

    project.logoID = selectedLogo.id;
    project.logo = selectedLogo;
    _this4.setState({ project: project, hasChanges: true }, function () {
      _this4.handleOnSubmit();
    });
  };

  this.handleUploadLogo = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(body) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this4.getLogoToken();

            case 2:
              _context3.t0 = _context3.sent;
              _context3.t1 = {
                'X-Csrf-Token': _context3.t0
              };
              _context3.t2 = body;
              _context3.t3 = {
                credentials: 'include',
                method: 'POST',
                headers: _context3.t1,
                body: _context3.t2
              };
              return _context3.abrupt('return', {
                url: '/logos/',
                options: _context3.t3
              });

            case 7:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this4);
    }));

    return function (_x2) {
      return _ref5.apply(this, arguments);
    };
  }();

  this.handleShowAddLogo = function (e) {
    e.preventDefault();
    _this4.setState({ showAddLogo: true });
  };

  this.handleCheckLogo = function (logo) {
    var project = _this4.state.project;

    return project.logoID === logo.id;
  };

  this.handleCloseAddLogo = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e) {
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              e.preventDefault();
              _this4.setState({ showAddLogo: false });

            case 2:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this4);
    }));

    return function (_x3) {
      return _ref6.apply(this, arguments);
    };
  }();

  this.handleRemoveLogo = function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(e) {
      var project;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              e.preventDefault();
              project = _this4.state.project;

              project.logoID = '';
              project.logo = null;
              _this4.setState({ project: project, hasChanges: true }, function () {
                _this4.handleOnSubmit();
              });

            case 5:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this4);
    }));

    return function (_x4) {
      return _ref7.apply(this, arguments);
    };
  }();
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Logo.mapStateToProps)(Logo));

/***/ }),
/* 2394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _reactRouterRedux = __webpack_require__(13);

var _webValidations = __webpack_require__(23);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _amount = __webpack_require__(87);

var _url = __webpack_require__(19);

var _MultiUnitCheck = __webpack_require__(2521);

var _MultiUnitCheck2 = _interopRequireDefault(_MultiUnitCheck);

var _MultiUnitEdit = __webpack_require__(2522);

var _MultiUnitEdit2 = _interopRequireDefault(_MultiUnitEdit);

var _MultiUnitAllocate = __webpack_require__(2520);

var _MultiUnitAllocate2 = _interopRequireDefault(_MultiUnitAllocate);

var _MultiUnitFormErrors = __webpack_require__(2523);

var _MultiUnitFormErrors2 = _interopRequireDefault(_MultiUnitFormErrors);

var _MultiUnitSpecification = __webpack_require__(2524);

var _MultiUnitSpecification2 = _interopRequireDefault(_MultiUnitSpecification);

var _MultiUnitPackagePricing = __webpack_require__(1079);

var _MultiUnitPackagePricing2 = _interopRequireDefault(_MultiUnitPackagePricing);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _SearchMultiUnits = __webpack_require__(2159);

var _SearchMultiUnits2 = _interopRequireDefault(_SearchMultiUnits);

var _SelectBank = __webpack_require__(218);

var _SelectBank2 = _interopRequireDefault(_SelectBank);

var _Filters = __webpack_require__(86);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _unitStatuses = __webpack_require__(266);

var _virtualAccount = __webpack_require__(393);

var _vietnam = __webpack_require__(40);

var _storage = __webpack_require__(44);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-nested-ternary */


var ALL_AGENCIES_VALUE = '__all_agencies__';

var MultiEdit = function (_Component) {
  _inherits(MultiEdit, _Component);

  function MultiEdit(props) {
    _classCallCheck(this, MultiEdit);

    var _this = _possibleConstructorReturn(this, (MultiEdit.__proto__ || Object.getPrototypeOf(MultiEdit)).call(this, props));

    _initialiseProps.call(_this);

    var state = MultiEdit.getPropsToState(props);
    var shiftSelect = { start: null, end: null };
    var checkFunctionData = { a: null, b: null, c: null };
    _this.state = _extends({}, state, {
      count: 0,
      checkFunctionData: checkFunctionData,
      checkFunctionName: '',
      checkModalIsOpen: false,
      editModalIsOpen: false,
      formErrorModalIsOpen: false,
      isOver: false,
      navHeight: 0,
      isSelectedAll: false,
      limit: 0,
      loading: true,
      offset: 0,
      oriRowsData: [],
      packagePricings: [],
      priceModalIsOpen: false,
      priceModalRow: {},
      rowsData: [],
      shiftSelect: shiftSelect,
      sortColumn: null,
      sortDirection: null,
      specModalIsOpen: false,
      specModalRow: {},
      tableWidth: 0,
      unitLayouts: [],
      visibleColumns: ['isBumi', 'streetNumberOrLevel', 'zoneOrBlock', 'streetOrFacing', 'vaBankName', 'vaAccountNumber'],
      companyBranches: [],
      allocateModalIsOpen: false,
      clearAllocationsConfirmIsOpen: false,
      isSectionDisabled: false,
      unitCustomFieldSettings: []
    });
    _this.validation = {};
    return _this;
  }

  _createClass(MultiEdit, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var q = (0, _url.decodeSearch)(this.props.location.search);
      var tableTopScrollBar = document.getElementById('tableTopScrollBar');
      var tableBottomScrollBar = document.getElementById('tableBottomScrollBar');
      if (!q.limit || !(0, _isNumber2.default)(q.limit) || q.limit <= 0 ||
      // CPI-1230 (Q1): 300 is accepted for a Vietnamese company only; any other value falls to 50.
      !(0, _vietnam.isAllowedUnitPageLimit)(this.props.auth, q.limit)) {
        q.limit = 50;
      }
      this.fetchLayouts();
      this.fetchLevels();
      this.fetchUnitCustomFieldSettings();
      this.replaceQuery(q);
      tableTopScrollBar.addEventListener('scroll', this.onTableScrollBarTop, false);
      tableBottomScrollBar.addEventListener('scroll', this.onTableScrollBarBottom, false);
      window.addEventListener('scroll', this.onScroll, false);
      window.addEventListener('resize', this.onResize, false);
      window.scrollTo(0, 0);
      this.setTableWidth();
      this.fetchPackagePricings();
      this.fetchCompanyBranches();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = MultiEdit.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.inputScrollbarTimer) {
        clearTimeout(this.inputScrollbarTimer);
      }
      var tableTopScrollBar = document.getElementById('tableTopScrollBar');
      var tableBottomScrollBar = document.getElementById('tableBottomScrollBar');
      tableTopScrollBar.removeEventListener('scroll', this.onTableScrollBarTop, false);
      tableBottomScrollBar.removeEventListener('scroll', this.onTableScrollBarBottom, false);
      window.removeEventListener('scroll', this.onScroll, false);
      window.removeEventListener('resize', this.onResize, false);
      window.scrollTo(0, 0);
    }
    // The toolbar wraps onto more than one line on narrow screens, so the pinned top scroll bar
    // sits below the toolbar's measured height rather than a fixed one.

  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'getSelectedRowsData',
    value: function getSelectedRowsData() {
      return this.state.rowsData.filter(function (d) {
        return d.isSelected;
      });
    }
  }, {
    key: 'fetchPackagePricings',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var t, store, res, message, json, packagePricings;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                _context.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + this.props.params.id + '/package_pricings/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 19;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context.next = 33;
                break;

              case 27:
                _context.next = 29;
                return res.json();

              case 29:
                json = _context.sent;
                packagePricings = json;
                _context.next = 33;
                return this.setComponentState({
                  packagePricings: packagePricings
                });

              case 33:
                _context.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchPackagePricings() {
        return _ref.apply(this, arguments);
      }

      return fetchPackagePricings;
    }()
  }, {
    key: 'fetchCompanyBranches',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var t, store, res, message, json, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                _context2.prev = 3;
                _context2.next = 6;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + this.props.params.id + '/accessible_company_branches/?isExternal=true', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 6:
                res = _context2.sent;
                _context2.next = 15;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](3);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 14;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 14:
                return _context2.abrupt('return');

              case 15:
                if (res.ok) {
                  _context2.next = 23;
                  break;
                }

                _context2.next = 18;
                return res.text();

              case 18:
                message = _context2.sent;
                _context2.next = 21;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 21:
                _context2.next = 31;
                break;

              case 23:
                _context2.next = 25;
                return res.json();

              case 25:
                json = _context2.sent;

                if (!json) {
                  _context2.next = 31;
                  break;
                }

                data = json.map(function (obj) {
                  var newResults = {};
                  newResults.text = obj.name;
                  newResults.value = obj.id;
                  return newResults;
                });

                this.fetchedCompanyBranches = data;
                _context2.next = 31;
                return this.setComponentState({
                  companyBranches: data
                });

              case 31:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 9]]);
      }));

      function fetchCompanyBranches() {
        return _ref2.apply(this, arguments);
      }

      return fetchCompanyBranches;
    }()
  }, {
    key: 'fetchLayouts',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var t, store, res, message, json, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                t = this.props.t;
                _context3.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                res = void 0;
                _context3.prev = 5;
                _context3.next = 8;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/search/project_unit_layouts/?projectID=' + this.props.params.id, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context3.sent;
                _context3.next = 19;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](5);

                Bugsnag.notifyException(_context3.t0);
                _context3.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context3.next = 18;
                return this.setLoading(false);

              case 18:
                return _context3.abrupt('return');

              case 19:
                if (res.ok) {
                  _context3.next = 27;
                  break;
                }

                _context3.next = 22;
                return res.text();

              case 22:
                message = _context3.sent;
                _context3.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context3.next = 35;
                break;

              case 27:
                _context3.next = 29;
                return res.json();

              case 29:
                json = _context3.sent;

                if (!json) {
                  _context3.next = 35;
                  break;
                }

                data = json.map(function (obj, idx) {
                  var newResults = {};
                  newResults.key = idx;
                  newResults.value = obj.id;
                  newResults.text = obj.name;
                  return newResults;
                });

                this.fetchedUnitLayouts = data;
                _context3.next = 35;
                return this.setComponentState({
                  unitLayouts: data
                });

              case 35:
                _context3.next = 37;
                return this.setLoading(false);

              case 37:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 11]]);
      }));

      function fetchLayouts() {
        return _ref3.apply(this, arguments);
      }

      return fetchLayouts;
    }()
  }, {
    key: 'fetchLevels',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var t, store, res, message, json;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                t = this.props.t;
                _context4.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                res = void 0;
                _context4.prev = 5;
                _context4.next = 8;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + this.props.params.id + '/units/levels/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context4.sent;
                _context4.next = 19;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](5);

                Bugsnag.notifyException(_context4.t0);
                _context4.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context4.next = 18;
                return this.setLoading(false);

              case 18:
                return _context4.abrupt('return');

              case 19:
                if (res.ok) {
                  _context4.next = 27;
                  break;
                }

                _context4.next = 22;
                return res.text();

              case 22:
                message = _context4.sent;
                _context4.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context4.next = 31;
                break;

              case 27:
                _context4.next = 29;
                return res.json();

              case 29:
                json = _context4.sent;

                if (json) {
                  // the endpoint scans into []string, so a unit with no level arrives as ''
                  // rather than null, and would otherwise show up as a blank dropdown entry
                  this.fetchedUnitLevels = json.filter(function (val) {
                    return val !== '';
                  }).map(function (val, idx) {
                    var newResults = {};
                    newResults.key = idx;
                    newResults.value = val;
                    newResults.text = val;
                    return newResults;
                  });
                }

              case 31:
                _context4.next = 33;
                return this.setLoading(false);

              case 33:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 11]]);
      }));

      function fetchLevels() {
        return _ref4.apply(this, arguments);
      }

      return fetchLevels;
    }()
  }, {
    key: 'fetchUnitCustomFieldSettings',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var t, store, res, message, unitCustomFieldSettingsData;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                t = this.props.t;
                _context5.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                res = void 0;
                _context5.prev = 5;
                _context5.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/settings/unit_custom_fields/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context5.sent;
                _context5.next = 22;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5['catch'](5);
                _context5.next = 15;
                return this.setLoading(false);

              case 15:
                if (!(_context5.t0.res && _context5.t0.res.status >= 400 && _context5.t0.res.status < 500)) {
                  _context5.next = 20;
                  break;
                }

                _context5.next = 18;
                return _context5.t0.res.text();

              case 18:
                message = _context5.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 20:
                Bugsnag.notifyException(_context5.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 22:
                if (res.ok) {
                  _context5.next = 28;
                  break;
                }

                _context5.next = 25;
                return this.setLoading(false);

              case 25:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
                _context5.next = 35;
                break;

              case 28:
                _context5.next = 30;
                return res.json();

              case 30:
                unitCustomFieldSettingsData = _context5.sent;
                _context5.next = 33;
                return this.setComponentState({
                  unitCustomFieldSettings: unitCustomFieldSettingsData
                });

              case 33:
                _context5.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[5, 11]]);
      }));

      function fetchUnitCustomFieldSettings() {
        return _ref5.apply(this, arguments);
      }

      return fetchUnitCustomFieldSettings;
    }()
  }, {
    key: 'fetchUnits',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(q) {
        var store, query, res, t, message, count, limit, offset, token, json, data, i;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = Object.assign({}, q);

                if (!query.limit || !(0, _isNumber2.default)(query.limit) || query.limit <= 0 || !(0, _vietnam.isAllowedUnitPageLimit)(this.props.auth, query.limit)) {
                  query.limit = 50;
                }
                res = void 0;
                _context6.prev = 6;
                _context6.next = 9;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + this.props.params.id + '/units/bulk/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context6.sent;
                _context6.next = 21;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6['catch'](6);

                Bugsnag.notifyException(_context6.t0);
                t = this.props.t;
                _context6.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 18:
                _context6.next = 20;
                return this.setLoading(false);

              case 20:
                return _context6.abrupt('return');

              case 21:
                if (res.ok) {
                  _context6.next = 29;
                  break;
                }

                _context6.next = 24;
                return res.text();

              case 24:
                message = _context6.sent;
                _context6.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 27:
                _context6.next = 40;
                break;

              case 29:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                token = res.headers.get('X-Csrf-Token');
                _context6.next = 35;
                return res.json();

              case 35:
                json = _context6.sent;
                data = json;

                if (data) {
                  i = 1;

                  data.forEach(function (d, idx) {
                    data[idx].isSelected = false;
                    data[idx].rowID = i;
                    data[idx].size = data[idx].size.toString();
                    data[idx].spaValue = data[idx].spaValue.toString();
                    data[idx].position = data[idx].position.toString();
                    data[idx].spaAmount = (0, _amount.spaFullNumber)(data[idx]) || data[idx].spaValue; // decimal amount
                    // virtual account
                    if (d.projectUnitCustomFields) {
                      var vaBankName = data[idx].projectUnitCustomFields.find(function (pucf) {
                        return pucf.projectUnitCustomFieldSettingID === _virtualAccount.VA_BANK_NAME;
                      });
                      var vaAccountNo = data[idx].projectUnitCustomFields.find(function (pucf) {
                        return pucf.projectUnitCustomFieldSettingID === _virtualAccount.VA_ACCOUNT_NUMBER;
                      });
                      data[idx].vaBankName = vaBankName ? vaBankName.value : '';
                      data[idx].vaAccountNumber = vaAccountNo ? vaAccountNo.value : '';
                    }
                    data[idx].errors = {
                      reference: '',
                      size: '',
                      spaAmount: '',
                      position: ''
                    };
                    i += 1;
                  });
                  this.setState({ isSectionDisabled: false });
                } else {
                  data = [];
                  this.setState({ filterUnitLevel: [], isSectionDisabled: true });
                }
                _context6.next = 40;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset,
                  token: token,
                  oriRowsData: (0, _clone2.default)(data),
                  rowsData: data
                });

              case 40:
                _context6.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[6, 12]]);
      }));

      function fetchUnits(_x3) {
        return _ref6.apply(this, arguments);
      }

      return fetchUnits;
    }()
  }, {
    key: 'updateUnits',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _this4 = this;

        var store, t, query, _state, oriRowsData, rowsData, unitCustomFieldSettings, newRowsData, hasErrors, message;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, (0, _url.decodeSearch)(this.props.location.search));
                _state = this.state, oriRowsData = _state.oriRowsData, rowsData = _state.rowsData, unitCustomFieldSettings = _state.unitCustomFieldSettings;
                newRowsData = [];
                hasErrors = rowsData.find(function (d) {
                  return d.errors.reference !== '' || d.errors.size !== '' || d.errors.spaAmount !== '' || d.errors.position !== '';
                });

                if (!hasErrors) {
                  _context7.next = 13;
                  break;
                }

                _context7.next = 11;
                return this.setLoading(false);

              case 11:
                this.setState({ formErrorModalIsOpen: true });
                return _context7.abrupt('return');

              case 13:
                if (!query.limit || !(0, _isNumber2.default)(query.limit) || query.limit <= 0 || !(0, _vietnam.isAllowedUnitPageLimit)(this.props.auth, query.limit)) {
                  query.limit = 50;
                }
                rowsData.forEach(function (d) {
                  var oriRow = oriRowsData.find(function (r) {
                    return r.rowID === d.rowID;
                  });
                  var row = d;
                  delete row.isSelected;
                  delete oriRow.isSelected;
                  try {
                    if (JSON.stringify(row) !== JSON.stringify(oriRow)) {
                      newRowsData.push(row);
                    }
                  } catch (e) {
                    Bugsnag.notifyException(e);
                  }
                });
                newRowsData.forEach(function (d, idx) {
                  newRowsData[idx].size = parseFloat(newRowsData[idx].size);
                  newRowsData[idx].spaValue = parseInt(newRowsData[idx].spaAmount, 10);
                  newRowsData[idx].position = parseInt(newRowsData[idx].position, 10);
                  if (d.projectUnitPackagePricings) {
                    newRowsData[idx].projectUnitPackagePricings = d.projectUnitPackagePricings.map(function (p) {
                      return Object.assign(p, {
                        totalPrice: parseFloat(p.totalPrice) // decimal amount
                      });
                    });
                  }

                  var customFields = [];
                  if (d.projectUnitCustomFields) {
                    d.projectUnitCustomFields.forEach(function (p) {
                      if (_virtualAccount.VA_UNIT_FIELDS.includes(p.projectUnitCustomFieldSettingID)) {
                        p.value = _this4.setVAFieldValue(p.projectUnitCustomFieldSettingID, newRowsData[idx]);
                      }
                      customFields.push(p);
                    });
                  }
                  if (unitCustomFieldSettings) {
                    unitCustomFieldSettings.forEach(function (u) {
                      var exists = -1;
                      if (d.projectUnitCustomFields) exists = d.projectUnitCustomFields.findIndex(function (ucfData) {
                        return ucfData.projectUnitCustomFieldSettingID === u.id;
                      });
                      if (exists === -1) {
                        if (_virtualAccount.VA_UNIT_FIELDS.includes(u.id)) {
                          var customField = {
                            value: _this4.setVAFieldValue(u.id, newRowsData[idx]),
                            projectUnitCustomFieldSettingID: u.id,
                            projectUnitCustomFieldSetting: u
                          };
                          customFields.push(customField);
                        }
                      }
                    });
                  }
                  newRowsData[idx].projectUnitCustomFields = customFields;

                  newRowsData[idx] = (0, _amount.fullToAmount)(newRowsData[idx], newRowsData[idx].spaAmount); // decimal amount
                });

                if (!(newRowsData.length === 0)) {
                  _context7.next = 21;
                  break;
                }

                _context7.next = 19;
                return this.setLoading(false);

              case 19:
                store.dispatch((0, _flash.flashErrorMessage)({ header: t('No Units To Update', { ns: _translation.TRANSLATION_FILES.translation }), message: t('No changes found.', { ns: _translation.TRANSLATION_FILES.translation }) }));
                return _context7.abrupt('return');

              case 21:
                _context7.prev = 21;
                _context7.next = 24;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + this.props.params.id + '/units/bulk/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(newRowsData)
                }));

              case 24:
                _context7.next = 39;
                break;

              case 26:
                _context7.prev = 26;
                _context7.t0 = _context7['catch'](21);
                _context7.next = 30;
                return this.setLoading(false);

              case 30:
                if (!(_context7.t0.res && _context7.t0.res.status >= 400 && _context7.t0.res.status < 500)) {
                  _context7.next = 36;
                  break;
                }

                _context7.next = 33;
                return _context7.t0.res.text();

              case 33:
                message = _context7.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context7.abrupt('return');

              case 36:
                Bugsnag.notifyException(_context7.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context7.abrupt('return');

              case 39:
                _context7.next = 41;
                return this.setLoading(false);

              case 41:
                _context7.next = 43;
                return this.replaceQuery(query, false, true);

              case 43:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{count}} Units successfully updated.', { count: newRowsData.length, ns: _translation.TRANSLATION_FILES.translation }) }));

              case 44:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[21, 26]]);
      }));

      function updateUnits() {
        return _ref7.apply(this, arguments);
      }

      return updateUnits;
    }()
    // CPI-288: release every agency from ALL Available units of the project. Deliberately not the
    // row-diff PUT updateUnits() sends - the set is not client-enumerable, so the server owns it.

  }, {
    key: 'clearAllAllocations',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var store, t, query, res, message, releasedCount, json;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, (0, _url.decodeSearch)(this.props.location.search));
                res = void 0;
                _context8.prev = 6;
                _context8.next = 9;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + this.props.params.id + '/units/release_allocations/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify({})
                }));

              case 9:
                res = _context8.sent;
                _context8.next = 25;
                break;

              case 12:
                _context8.prev = 12;
                _context8.t0 = _context8['catch'](6);
                _context8.next = 16;
                return this.setLoading(false);

              case 16:
                if (!(_context8.t0.res && _context8.t0.res.status >= 400 && _context8.t0.res.status < 500)) {
                  _context8.next = 22;
                  break;
                }

                _context8.next = 19;
                return _context8.t0.res.text();

              case 19:
                message = _context8.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context8.abrupt('return');

              case 22:
                Bugsnag.notifyException(_context8.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context8.abrupt('return');

              case 25:
                releasedCount = 0;
                _context8.prev = 26;
                _context8.next = 29;
                return res.json();

              case 29:
                json = _context8.sent;

                if (json && typeof json.released_count === 'number') {
                  releasedCount = json.released_count;
                }
                _context8.next = 36;
                break;

              case 33:
                _context8.prev = 33;
                _context8.t1 = _context8['catch'](26);

                Bugsnag.notifyException(_context8.t1);

              case 36:
                _context8.next = 38;
                return this.setLoading(false);

              case 38:
                _context8.next = 40;
                return this.replaceQuery(query, false, true);

              case 40:
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Allocations Cleared', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Agency allocations were cleared for {{count}} Available units.', { count: releasedCount, ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 41:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[6, 12], [26, 33]]);
      }));

      function clearAllAllocations() {
        return _ref8.apply(this, arguments);
      }

      return clearAllAllocations;
    }()
  }, {
    key: 'replaceQuery',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(query) {
        var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var resetChanges = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var store, pathname, queryNew;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                store = this.context.store;
                pathname = this.props.location.pathname;
                queryNew = query;

                if (resetPage) {
                  queryNew.page = 1;
                }
                this.setState({ isSelectedAll: false, sortColumn: null, sortDirection: null });
                _context9.next = 7;
                return this.fetchUnits(queryNew);

              case 7:
                if (resetChanges) {
                  this.handleOnCheck(false);
                }
                store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(queryNew)));

              case 9:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function replaceQuery(_x4) {
        return _ref9.apply(this, arguments);
      }

      return replaceQuery;
    }()
  }, {
    key: 'cellCheckSorted',
    value: function cellCheckSorted(column) {
      var _state2 = this.state,
          sortColumn = _state2.sortColumn,
          sortDirection = _state2.sortDirection;

      if (column === sortColumn) {
        return sortDirection === 'asc' ? 'ascending' : 'descending';
      }
      return null;
    }
    // Options loaded from the API. They are held here rather than inside the getters
    // below, which rebuild their array on every read so the "All ..." labels pick up a
    // language change — anything pushed into that array would be thrown away with it.

  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props$auth = this.props.auth,
          allowEditUnitDetails = _props$auth.allowEditUnitDetails,
          allowEditUnitPrice = _props$auth.allowEditUnitPrice,
          company = _props$auth.company;
      var t = this.props.t;
      var _state3 = this.state,
          checkModalIsOpen = _state3.checkModalIsOpen,
          editModalIsOpen = _state3.editModalIsOpen,
          formErrorModalIsOpen = _state3.formErrorModalIsOpen,
          priceModalIsOpen = _state3.priceModalIsOpen,
          rowsData = _state3.rowsData,
          specModalIsOpen = _state3.specModalIsOpen,
          companyBranches = _state3.companyBranches,
          allocateModalIsOpen = _state3.allocateModalIsOpen,
          clearAllocationsConfirmIsOpen = _state3.clearAllocationsConfirmIsOpen,
          globalSettings = _state3.globalSettings;

      var projectAgencyAllocationSetting = this.props.project && this.props.project.agencyAllocationAllocateAll;
      // MS-6522: the project's own setting, else the global one, read the same way in every country.
      // On "Allocate to all" an unallocated unit reads as "All Agencies" below; on "Allocate to none"
      // it reads as allocated to nobody, and the developer assigns an agency explicitly.
      var agencyAllocationAllocateAll = typeof projectAgencyAllocationSetting === 'boolean' ? projectAgencyAllocationSetting : Boolean(globalSettings.agencyAllocationAllocateAll);
      var getFilteredPackage = this.state.packagePricings ? this.filterPackingPricing(this.state.packagePricings).filter(function (data) {
        return data.disabled !== true;
      }) : null;
      var isMalaysia = this.props.auth && this.props.auth.company && this.props.auth.company.countryCode && this.props.auth.company.countryCode.toUpperCase() === 'MY';
      // CPI-288: HQ & Sales Admin only, in every country. Shipped Vietnam-only and later opened to
      // Malaysia and Indonesia together with the server gate. The role test is the same
      // "HQ or Sales Admin" family hasVietnamElevatedAccess encodes; not ANDed with
      // allowEditUnitDetails, as the server's gate tests the role only.
      var canClearAllocations = (0, _vietnam.hasVietnamElevatedAccess)(this.props.auth);
      if (rowsData.length > 0) {
        rowsData.forEach(function (column) {
          _this5.validation['reference' + column.rowID] = (0, _react.createRef)();
          _this5.validation['size' + column.rowID] = (0, _react.createRef)();
          _this5.validation['position' + column.rowID] = (0, _react.createRef)();
          _this5.validation['spaAmount' + column.rowID] = (0, _react.createRef)();
        });
      }
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          { style: { paddingTop: '0.5em' } },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Menu,
              {
                fluid: true, secondary: true,
                style: { margin: 'auto 2em', paddingBottom: '0.5em' }
              },
              _react2.default.createElement(_semanticUiReact.Menu.Item, {
                link: true,
                href: '/',
                icon: 'left chevron',
                onClick: this.handleGoBack
              }),
              _react2.default.createElement(_semanticUiReact.Menu.Item, { header: true, content: this.props.t('Edit Units', { ns: _translation.TRANSLATION_FILES.translation }) })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { style: { margin: 'auto 1em' } },
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { active: this.state.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inverted: true, className: 'multi-edit-loading' },
                  this.props.t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(_MultiUnitEdit2.default, {
                onClose: this.handleCloseEditModal,
                onDeselectUnit: this.handleOnDeselectUnit,
                onSave: this.handleModalSave,
                open: editModalIsOpen,
                projectUnitLayouts: this.state.unitLayouts,
                packagePricings: getFilteredPackage || [],
                selectedRowsData: this.getSelectedRowsData(),
                allowEditUnitPrice: allowEditUnitPrice,
                allowEditUnitDetails: allowEditUnitDetails,
                sellingPriceCustomName: globalSettings && globalSettings.sellingPrice,
                vaIsEnabled: this.hasVAEnabled(),
                countryCode: company ? company.countryCode : ''
              }),
              _react2.default.createElement(_MultiUnitPackagePricing2.default, {
                onChange: this.handlePricingOnChange,
                onDone: this.handlePricingOnDone,
                open: priceModalIsOpen,
                unit: this.state.priceModalRow,
                packagePricings: getFilteredPackage || []
              }),
              _react2.default.createElement(_MultiUnitSpecification2.default, {
                onChange: this.handleSpecificationsOnChange,
                onDone: this.handleSpecificationsOnDone,
                open: specModalIsOpen,
                unit: this.state.specModalRow
              }),
              _react2.default.createElement(_MultiUnitCheck2.default, {
                onCancel: this.handleCancelCheckModal,
                onConfirm: this.handleConfirmCheckModal,
                open: checkModalIsOpen
              }),
              _react2.default.createElement(_MultiUnitFormErrors2.default, {
                onClose: this.handleCloseFormErrorModal,
                open: formErrorModalIsOpen,
                data: rowsData
              }),
              _react2.default.createElement(_MultiUnitAllocate2.default, {
                onClose: this.handleCloseAllocate,
                onDeselectUnit: this.handleOnDeselectUnit,
                onSave: this.handleModalSave,
                open: allocateModalIsOpen,
                businessUnit: companyBranches,
                selectedRowsData: this.getSelectedRowsData().filter(function (row) {
                  return !_this5.isAgencyAllocationLocked(row.statusID);
                }),
                lockedRowsData: this.getSelectedRowsData().filter(function (row) {
                  return _this5.isAgencyAllocationLocked(row.statusID);
                }),
                allowEditUnitDetails: allowEditUnitDetails,
                agencyAllocationAllocateAll: agencyAllocationAllocateAll
              }),
              canClearAllocations && _react2.default.createElement(_semanticUiReact.Confirm, {
                open: clearAllocationsConfirmIsOpen,
                header: t('Clear all agency allocations?', { ns: _translation.TRANSLATION_FILES.translation }),
                content: t('This clears every agency from ALL Available units in this project. Reserved, booked and sold units keep their agencies. This cannot be undone.', { ns: _translation.TRANSLATION_FILES.translation }),
                cancelButton: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }),
                confirmButton: t('Release all', { ns: _translation.TRANSLATION_FILES.translation }),
                onCancel: this.handleCancelClearAllocations,
                onConfirm: this.handleConfirmClearAllocations
              }),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { style: { paddingBottom: '0', paddingTop: '0' } },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  {
                    id: 'multi-edit-nav',
                    className: 'multi-edit-nav ' + (this.state.isOver ? 'fixed' : '')
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Menu,
                    { stackable: true },
                    _react2.default.createElement(
                      _semanticUiReact.Dropdown,
                      { item: true, text: this.props.t('Columns', { ns: _translation.TRANSLATION_FILES.translation }), simple: true, basic: true },
                      _react2.default.createElement(
                        _semanticUiReact.Dropdown.Menu,
                        null,
                        isMalaysia && _react2.default.createElement(
                          _semanticUiReact.Dropdown.Item,
                          {
                            name: 'isBumi',
                            onClick: this.handleVisibleCheckboxChange
                          },
                          _react2.default.createElement(_semanticUiReact.Checkbox, {
                            checked: this.checkIfColumnVisible('isBumi'),
                            label: this.props.t('Bumiputra', { ns: _translation.TRANSLATION_FILES.translation }),
                            style: { margin: 'auto 1em' },
                            toggle: true
                          })
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Dropdown.Item,
                          {
                            name: 'streetNumberOrLevel',
                            onClick: this.handleVisibleCheckboxChange
                          },
                          _react2.default.createElement(_semanticUiReact.Checkbox, {
                            checked: this.checkIfColumnVisible('streetNumberOrLevel'),
                            label: this.props.t('Level/Street Number', { ns: _translation.TRANSLATION_FILES.translation }),
                            style: { margin: 'auto 1em' },
                            toggle: true
                          })
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Dropdown.Item,
                          {
                            name: 'zoneOrBlock',
                            onClick: this.handleVisibleCheckboxChange
                          },
                          _react2.default.createElement(_semanticUiReact.Checkbox, {
                            checked: this.checkIfColumnVisible('zoneOrBlock'),
                            label: this.props.t('Block/Zone', { ns: _translation.TRANSLATION_FILES.translation }),
                            style: { margin: 'auto 1em' },
                            toggle: true
                          })
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Dropdown.Item,
                          {
                            name: 'streetOrFacing',
                            onClick: this.handleVisibleCheckboxChange
                          },
                          _react2.default.createElement(_semanticUiReact.Checkbox, {
                            checked: this.checkIfColumnVisible('streetOrFacing'),
                            label: this.props.t('Facing/Street', { ns: _translation.TRANSLATION_FILES.translation }),
                            style: { margin: 'auto 1em' },
                            toggle: true
                          })
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Dropdown.Item,
                          {
                            name: 'position',
                            onClick: this.handleVisibleCheckboxChange
                          },
                          _react2.default.createElement(_semanticUiReact.Checkbox, {
                            checked: this.checkIfColumnVisible('position'),
                            label: this.props.t('Position'),
                            style: { margin: 'auto 1em' },
                            toggle: true
                          })
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Dropdown.Item,
                          {
                            name: 'address',
                            onClick: this.handleVisibleCheckboxChange
                          },
                          _react2.default.createElement(_semanticUiReact.Checkbox, {
                            checked: this.checkIfColumnVisible('address'),
                            label: this.props.t('Address'),
                            style: { margin: 'auto 1em' },
                            toggle: true
                          })
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Dropdown.Item,
                          {
                            name: 'remarkExternal',
                            onClick: this.handleVisibleCheckboxChange
                          },
                          _react2.default.createElement(_semanticUiReact.Checkbox, {
                            checked: this.checkIfColumnVisible('remarkExternal'),
                            label: this.props.t('Public Notes', { ns: _translation.TRANSLATION_FILES.translation }),
                            style: { margin: 'auto 1em' },
                            toggle: true
                          })
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Dropdown.Item,
                          {
                            name: 'remarkInternal',
                            onClick: this.handleVisibleCheckboxChange
                          },
                          _react2.default.createElement(_semanticUiReact.Checkbox, {
                            checked: this.checkIfColumnVisible('remarkInternal'),
                            label: this.props.t('Internal Notes', { ns: _translation.TRANSLATION_FILES.translation }),
                            style: { margin: 'auto 1em' },
                            toggle: true
                          })
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Dropdown.Item,
                          {
                            name: 'packagePricings',
                            onClick: this.handleVisibleCheckboxChange
                          },
                          _react2.default.createElement(_semanticUiReact.Checkbox, {
                            checked: this.checkIfColumnVisible('packagePricings'),
                            label: this.props.t('Pricing Package'),
                            style: { margin: 'auto 1em' },
                            toggle: true
                          })
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Dropdown.Item,
                          {
                            name: 'specifications',
                            onClick: this.handleVisibleCheckboxChange
                          },
                          _react2.default.createElement(_semanticUiReact.Checkbox, {
                            checked: this.checkIfColumnVisible('specifications'),
                            label: this.props.t('Specification', { ns: _translation.TRANSLATION_FILES.translation }),
                            style: { margin: 'auto 1em' },
                            toggle: true
                          })
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Dropdown.Item,
                          {
                            name: 'agency',
                            onClick: this.handleVisibleCheckboxChange
                          },
                          _react2.default.createElement(_semanticUiReact.Checkbox, {
                            checked: this.checkIfColumnVisible('agency'),
                            label: this.props.t('Agency'),
                            style: { margin: 'auto 1em' },
                            toggle: true
                          })
                        ),
                        this.hasVAEnabled() && _react2.default.createElement(
                          _semanticUiReact.Dropdown.Item,
                          {
                            name: 'vaBankName',
                            onClick: this.handleVisibleCheckboxChange
                          },
                          _react2.default.createElement(_semanticUiReact.Checkbox, {
                            checked: this.checkIfColumnVisible('vaBankName'),
                            label: this.props.t('VA Bank Name', { ns: _translation.TRANSLATION_FILES.translation }),
                            style: { margin: 'auto 1em' },
                            toggle: true
                          })
                        ),
                        this.hasVAEnabled() && _react2.default.createElement(
                          _semanticUiReact.Dropdown.Item,
                          {
                            name: 'vaAccountNumber',
                            onClick: this.handleVisibleCheckboxChange
                          },
                          _react2.default.createElement(_semanticUiReact.Checkbox, {
                            checked: this.checkIfColumnVisible('vaAccountNumber'),
                            label: this.props.t('VA Account Number', { ns: _translation.TRANSLATION_FILES.translation }),
                            style: { margin: 'auto 1em' },
                            toggle: true
                          })
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Menu.Item,
                      { className: 'no-menu-right-border' },
                      _react2.default.createElement(_semanticUiReact.Dropdown, {
                        fluid: true,
                        onChange: function onChange(e, data) {
                          _this5.handleTriggerCheck('handleChangeLimit', e, data);
                        },
                        options: this.getPageLimits(),
                        selection: true,
                        selectOnBlur: false,
                        className: 'filterContainer',
                        value: this.state.pageLimit
                      }),
                      _react2.default.createElement(
                        'div',
                        { className: 'filterContainer' },
                        _react2.default.createElement(_Filters.BookingSelectListMultiple, {
                          filterName: 'filterUnitLevel',
                          onChange: this.handleFilterOnChange,
                          options: this.SEARCH_UNITLEVEL,
                          placeholder: this.props.t('Select Level', { ns: _translation.TRANSLATION_FILES.translation }),
                          value: this.state.filterUnitLevel || [],
                          disabled: this.state.isSectionDisabled,
                          selectedText: this.props.t('level selected', { ns: _translation.TRANSLATION_FILES.translation })
                        })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'filterContainer' },
                        _react2.default.createElement(_Filters.BookingSelectListMultiple, {
                          filterName: 'filterUnitLayoutID',
                          onChange: this.handleFilterOnChange,
                          options: this.SEARCH_UNITLAYOUTS,
                          placeholder: this.props.t('Select Type', { ns: _translation.TRANSLATION_FILES.translation }),
                          value: this.state.filterUnitLayoutID || [],
                          selectedText: this.props.t('type selected', { ns: _translation.TRANSLATION_FILES.translation })
                        })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'filterContainer' },
                        _react2.default.createElement(_Filters.BookingSelectListMultiple, {
                          filterName: 'companyBranchID',
                          onChange: this.handleFilterOnChange,
                          options: this.SEARCH_COMPANY_BRANCH.map(function (x) {
                            return {
                              value: x.value.toString(),
                              text: x.text
                            };
                          }),
                          placeholder: this.props.t('Select Agency'),
                          value: this.state.companyBranchID || [],
                          selectedText: this.props.t('agency selected', { ns: _translation.TRANSLATION_FILES.translation })
                        })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'filterContainer' },
                        _react2.default.createElement(_Filters.BookingSelectListMultiple, {
                          filterName: 'statusID',
                          onChange: this.handleFilterOnChange,
                          options: this.SEARCH_STATUSES.map(function (x) {
                            return _extends({}, x, {
                              text: t(x.text, { ns: _translation.TRANSLATION_FILES.constants })
                            });
                          }),
                          placeholder: t('Select Status'),
                          value: this.state.statusID || [],
                          selectedText: t('status selected', { ns: _translation.TRANSLATION_FILES.translation })
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Menu.Menu,
                      { position: 'right', className: 'right-menu' },
                      _react2.default.createElement(
                        _semanticUiReact.Menu.Item,
                        null,
                        canClearAllocations && _react2.default.createElement(
                          'div',
                          { className: 'filterContainer' },
                          _react2.default.createElement(
                            _semanticUiReact.Button,
                            {
                              negative: true,
                              onClick: this.handleClearAllocations,
                              type: 'button'
                            },
                            _react2.default.createElement(_semanticUiReact.Icon, { name: 'unlock' }),
                            t('Release all', { ns: _translation.TRANSLATION_FILES.translation })
                          )
                        ),
                        _react2.default.createElement(
                          'div',
                          { className: 'filterContainer' },
                          _react2.default.createElement(
                            _semanticUiReact.Button,
                            {
                              positive: true,
                              onClick: this.handleManageAllocate,
                              type: 'button',
                              disabled: !this.checkIfAnySelected()
                            },
                            _react2.default.createElement(_semanticUiReact.Icon, { name: 'sitemap' }),
                            this.props.t('Allocate', { ns: _translation.TRANSLATION_FILES.translation })
                          )
                        ),
                        _react2.default.createElement(_SearchMultiUnits2.default, {
                          searchOnSubmit: function searchOnSubmit(search) {
                            return _this5.handleTriggerCheck('handleSearchOnSubmit', search);
                          },
                          searchValue: this.state.search,
                          multiFilter: true
                        })
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { style: { padding: '1em 0.5em 0em 0.5em' } },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 16, tablet: 8, computer: 8, verticalAlign: 'middle' },
                  this.getCountSummaryText()
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  {
                    mobile: 16,
                    tablet: 8,
                    computer: 8,
                    textAlign: 'right',
                    verticalAlign: 'middle',
                    className: 'multi-edit-actions'
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Button,
                    {
                      primary: true,
                      icon: true,
                      disabled: !this.checkIfAnySelected(),
                      onClick: this.handleEditRow,
                      type: 'button',
                      style: { marginRight: '1em' }
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'pencil' }),
                    '\xA0',
                    this.props.t('Edit')
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Button,
                    {
                      disabled: !this.checkIfAnySelected(),
                      icon: true,
                      onClick: this.handleResetRow,
                      primary: true,
                      type: 'button',
                      style: { marginRight: '1em' }
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'undo' }),
                    '\xA0',
                    this.props.t('Reset', { ns: _translation.TRANSLATION_FILES.translation })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Button,
                    {
                      positive: true,
                      icon: true,
                      floated: 'right',
                      type: 'button',
                      onClick: this.handleUpdateUnits
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'save' }),
                    '\xA0',
                    this.props.t('Update', { ns: _translation.TRANSLATION_FILES.translation })
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 16 },
                  _react2.default.createElement(
                    'div',
                    {
                      className: 'multi-edit-top-scoll-bar ' + (this.state.isOver ? 'fixed' : ''),
                      id: 'tableTopScrollBar',
                      style: this.state.isOver && this.state.navHeight ? { top: this.state.navHeight } : undefined
                    },
                    _react2.default.createElement('div', { style: { width: this.state.tableWidth, height: '1px' } })
                  ),
                  _react2.default.createElement(
                    'div',
                    { style: { overflowX: 'scroll' }, id: 'tableBottomScrollBar' },
                    _react2.default.createElement(
                      _semanticUiReact.Table,
                      {
                        celled: true,
                        className: 'multi-edit-table',
                        compact: true,
                        sortable: true,
                        structured: true,
                        unstackable: true,
                        id: 'multi-edit-table'
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Header,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Table.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            {
                              onClick: function onClick(e) {
                                if (rowsData.length > 0) _this5.handleCheckboxSelectAll(e);
                              }
                            },
                            _react2.default.createElement(_semanticUiReact.Checkbox, {
                              checked: this.state.isSelectedAll,
                              disabled: rowsData.length < 1
                            })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            {
                              sorted: this.cellCheckSorted('reference'),
                              onClick: function onClick() {
                                return _this5.handleCellSort('reference');
                              }
                            },
                            this.props.t('Unit Reference', { ns: _translation.TRANSLATION_FILES.translation })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            {
                              sorted: this.cellCheckSorted('projectUnitLayoutID'),
                              onClick: function onClick() {
                                return _this5.handleCellSort('projectUnitLayoutID');
                              }
                            },
                            this.props.t('Layout Type')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            {
                              sorted: this.cellCheckSorted('statusID'),
                              onClick: function onClick() {
                                return _this5.handleCellSort('statusID');
                              }
                            },
                            this.props.t('Status')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            {
                              sorted: this.cellCheckSorted('size'),
                              onClick: function onClick() {
                                return _this5.handleCellSort('size');
                              }
                            },
                            this.props.t('Size')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            {
                              sorted: this.cellCheckSorted('spaAmount'),
                              onClick: function onClick() {
                                return _this5.handleCellSort('spaAmount');
                              }
                            },
                            globalSettings && globalSettings.sellingPrice ? globalSettings.sellingPrice : this.props.t('Selling Price')
                          ),
                          isMalaysia && this.checkIfColumnVisible('isBumi') && _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            {
                              sorted: this.cellCheckSorted('isBumi'),
                              onClick: function onClick() {
                                return _this5.handleCellSort('isBumi');
                              }
                            },
                            this.props.t('Bumiputra', { ns: _translation.TRANSLATION_FILES.translation })
                          ),
                          this.checkIfColumnVisible('streetNumberOrLevel') && _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            {
                              sorted: this.cellCheckSorted('streetNumberOrLevel'),
                              onClick: function onClick() {
                                return _this5.handleCellSort('streetNumberOrLevel');
                              }
                            },
                            this.props.t('Level/Street Number', { ns: _translation.TRANSLATION_FILES.translation })
                          ),
                          this.checkIfColumnVisible('zoneOrBlock') && _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            {
                              sorted: this.cellCheckSorted('zoneOrBlock'),
                              onClick: function onClick() {
                                return _this5.handleCellSort('zoneOrBlock');
                              }
                            },
                            this.props.t('Block/Zone', { ns: _translation.TRANSLATION_FILES.translation })
                          ),
                          this.checkIfColumnVisible('streetOrFacing') && _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            {
                              sorted: this.cellCheckSorted('streetOrFacing'),
                              onClick: function onClick() {
                                return _this5.handleCellSort('streetOrFacing');
                              }
                            },
                            this.props.t('Facing/Street', { ns: _translation.TRANSLATION_FILES.translation })
                          ),
                          this.checkIfColumnVisible('position') && _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            {
                              sorted: this.cellCheckSorted('position'),
                              onClick: function onClick() {
                                return _this5.handleCellSort('position');
                              }
                            },
                            this.props.t('Position')
                          ),
                          this.checkIfColumnVisible('address') && _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            this.props.t('Address')
                          ),
                          this.checkIfColumnVisible('remarkExternal') && _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            this.props.t('Public Notes', { ns: _translation.TRANSLATION_FILES.translation })
                          ),
                          this.checkIfColumnVisible('remarkInternal') && _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            this.props.t('Internal Notes', { ns: _translation.TRANSLATION_FILES.translation })
                          ),
                          this.checkIfColumnVisible('packagePricings') && _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            this.props.t('Pricing Package')
                          ),
                          this.checkIfColumnVisible('specifications') && _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            this.props.t('Specification', { ns: _translation.TRANSLATION_FILES.translation })
                          ),
                          this.checkIfColumnVisible('agency') && _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            this.props.t('Agency')
                          ),
                          this.hasVAEnabled() && this.checkIfColumnVisible('vaBankName') && _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            this.props.t('VA Bank Name', { ns: _translation.TRANSLATION_FILES.translation })
                          ),
                          this.hasVAEnabled() && this.checkIfColumnVisible('vaAccountNumber') && _react2.default.createElement(
                            _semanticUiReact.Table.HeaderCell,
                            null,
                            this.props.t('VA Account Number', { ns: _translation.TRANSLATION_FILES.translation })
                          )
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Body,
                        null,
                        rowsData.map.length > 0 ? rowsData.map(function (column, idx) {
                          return _react2.default.createElement(
                            _semanticUiReact.Table.Row,
                            {
                              key: idx,
                              active: column.isSelected,
                              className: _this5.getRowClassName(column.isSelected, column.rowID)
                            },
                            _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              { onClick: function onClick(e) {
                                  return _this5.handleCheckboxClick(e, column.rowID);
                                }, className: 'clickable' },
                              _react2.default.createElement(_semanticUiReact.Checkbox, {
                                checked: column.isSelected,
                                name: 'isSelected'
                              })
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Grid,
                                null,
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Row,
                                  { style: { padding: '0' } },
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { width: column.errors.reference !== '' ? '11' : '12' },
                                    _react2.default.createElement(
                                      _AppForm2.default.Validate,
                                      {
                                        hideMessage: true,
                                        onChange: function onChange(e, data) {
                                          return _this5.handleInputChange(e, data, column.rowID);
                                        },
                                        onError: function onError(hasError, msg) {
                                          return _this5.handleOnError(hasError, msg, 'reference', column.rowID);
                                        },
                                        ref: _this5.validation['reference' + column.rowID],
                                        validateLabel: 'Unit Reference',
                                        validation: [_webValidations.required]
                                      },
                                      _react2.default.createElement(
                                        _semanticUiReact.Input,
                                        {
                                          action: true,
                                          className: 'reference',
                                          fluid: true,
                                          name: 'reference',
                                          onChange: function onChange(e, data) {
                                            return _this5.handleInputChange(e, data, column.rowID);
                                          },
                                          ref: function ref(_ref10) {
                                            _this5['reference' + column.rowID] = _ref10;
                                          },
                                          value: column.reference,
                                          disabled: !allowEditUnitDetails
                                        },
                                        _react2.default.createElement('input', null),
                                        _react2.default.createElement(
                                          'a',
                                          {
                                            href: '/projects/' + column.projectID + '/units/' + column.id + '/',
                                            rel: 'noopener noreferrer',
                                            target: '_blank'
                                          },
                                          _react2.default.createElement(_semanticUiReact.Button, {
                                            color: 'teal',
                                            icon: _react2.default.createElement(_semanticUiReact.Icon, { name: 'external', fitted: true })
                                          })
                                        )
                                      )
                                    )
                                  ),
                                  column.errors.reference !== '' ? _react2.default.createElement(
                                    _semanticUiReact.Grid.Column,
                                    { width: '1', verticalAlign: 'middle' },
                                    _react2.default.createElement(_semanticUiReact.Popup, {
                                      content: column.errors.reference,
                                      inverted: true,
                                      size: 'mini',
                                      trigger: _react2.default.createElement(_semanticUiReact.Icon, {
                                        color: 'red',
                                        fitted: true,
                                        name: 'warning sign',
                                        style: { marginLeft: '1em' }
                                      })
                                    })
                                  ) : ''
                                )
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              null,
                              _react2.default.createElement(_semanticUiReact.Dropdown, {
                                style: { width: '12em' },
                                name: 'projectUnitLayoutID',
                                fluid: true,
                                onChange: function onChange(e, data) {
                                  return _this5.handleInputChange(e, data, column.rowID);
                                },
                                options: _this5.state.unitLayouts,
                                selection: true,
                                selectOnBlur: false,
                                value: column.projectUnitLayoutID,
                                disabled: !allowEditUnitDetails
                              })
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              null,
                              _react2.default.createElement(_semanticUiReact.Dropdown, {
                                fluid: true,
                                name: 'statusID',
                                disabled: _this5.checkRestrictedStatusID(column.statusID) || !allowEditUnitDetails,
                                onChange: function onChange(e, data) {
                                  return !_this5.checkRestrictedStatusID(column.statusID) && _this5.handleInputChange(e, data, column.rowID);
                                },
                                options: (_this5.checkRestrictedStatusID(column.statusID) ? _unitStatuses.UNIT_STATUSES_HQ_ALL : _unitStatuses.UNIT_STATUSES_EXTERNAL_ALL).map(function (x) {
                                  return _extends({}, x, {
                                    text: t(x.text, { ns: _translation.TRANSLATION_FILES.constants })
                                  });
                                }),
                                selection: true,
                                selectOnBlur: false,
                                value: column.statusID
                              })
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              null,
                              _react2.default.createElement(
                                _AppForm2.default.Validate,
                                {
                                  hideMessage: true,
                                  onChange: function onChange(e, data) {
                                    return _this5.handleInputChange(e, data, column.rowID);
                                  },
                                  onError: function onError(hasError, msg) {
                                    return _this5.handleOnError(hasError, msg, 'size', column.rowID);
                                  },
                                  ref: _this5.validation['size' + column.rowID],
                                  style: { display: 'inline' },
                                  validateLabel: 'Size',
                                  validation: [_webValidations.required, {
                                    validate: _webValidations.numericRange,
                                    option: {
                                      min: 0,
                                      max: 2147483647
                                    }
                                  }]
                                },
                                _react2.default.createElement(
                                  _semanticUiReact.Input,
                                  {
                                    className: 'size',
                                    name: 'size',
                                    labelPosition: column.errors.size !== '' ? 'right' : null,
                                    ref: function ref(_ref11) {
                                      _this5['size' + column.rowID] = _ref11;
                                    },
                                    type: 'number',
                                    min: '0',
                                    step: '0.0001',
                                    value: column.size,
                                    disabled: !allowEditUnitDetails
                                  },
                                  _react2.default.createElement('input', null),
                                  column.errors.size !== '' ? _react2.default.createElement(
                                    _semanticUiReact.Label,
                                    null,
                                    _react2.default.createElement(_semanticUiReact.Popup, {
                                      content: column.errors.size,
                                      inverted: true,
                                      size: 'mini',
                                      trigger: _react2.default.createElement(_semanticUiReact.Icon, {
                                        color: 'red',
                                        fitted: true,
                                        name: 'warning sign',
                                        style: { marginLeft: '0.5em' }
                                      })
                                    })
                                  ) : false
                                )
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              null,
                              _react2.default.createElement(
                                _AppForm2.default.Validate,
                                {
                                  hideMessage: true,
                                  onChange: function onChange(e, data) {
                                    return _this5.handleInputChange(e, data, column.rowID);
                                  },
                                  onError: function onError(hasError, msg) {
                                    return _this5.handleOnError(hasError, msg, 'spaAmount', column.rowID);
                                  },
                                  ref: _this5.validation['spaAmount' + column.rowID],
                                  style: { display: 'inline' },
                                  validateLabel: 'Selling Price',
                                  validation: [_webValidations.required, {
                                    validate: _webValidations.numericRange,
                                    option: {
                                      min: 1,
                                      max: 2147483647
                                    }
                                  }]
                                },
                                _react2.default.createElement(
                                  _semanticUiReact.Input,
                                  {
                                    className: 'spaAmount',
                                    disabled: _this5.checkRestrictedStatusID(column.statusID) || !allowEditUnitPrice,
                                    name: 'spaAmount',
                                    labelPosition: column.errors.spaAmount !== '' ? 'right' : null,
                                    ref: function ref(_ref12) {
                                      _this5['spaAmount' + column.rowID] = _ref12;
                                    },
                                    type: 'number',
                                    step: '.01',
                                    value: column.spaAmount
                                  },
                                  _react2.default.createElement('input', null),
                                  column.errors.spaAmount !== '' ? _react2.default.createElement(
                                    _semanticUiReact.Label,
                                    null,
                                    _react2.default.createElement(_semanticUiReact.Popup, {
                                      content: column.errors.spaAmount,
                                      inverted: true,
                                      size: 'mini',
                                      trigger: _react2.default.createElement(_semanticUiReact.Icon, {
                                        color: 'red',
                                        fitted: true,
                                        name: 'warning sign',
                                        style: { marginLeft: '0.5em' }
                                      })
                                    })
                                  ) : false
                                )
                              )
                            ),
                            isMalaysia && _this5.checkIfColumnVisible('isBumi') && _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              { textAlign: 'center' },
                              _react2.default.createElement(_semanticUiReact.Checkbox, {
                                checked: column.isBumi,
                                name: 'isBumi',
                                onChange: function onChange(e, data) {
                                  return _this5.handleCheckboxChange(e, data, column.rowID);
                                },
                                disabled: !allowEditUnitDetails
                              })
                            ),
                            _this5.checkIfColumnVisible('streetNumberOrLevel') && _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              null,
                              _react2.default.createElement(_semanticUiReact.Input, {
                                className: 'streetNumberOrLevel',
                                name: 'streetNumberOrLevel',
                                onChange: function onChange(e, data) {
                                  return _this5.handleInputChange(e, data, column.rowID);
                                },
                                value: column.streetNumberOrLevel,
                                disabled: !allowEditUnitDetails
                              })
                            ),
                            _this5.checkIfColumnVisible('zoneOrBlock') && _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              null,
                              _react2.default.createElement(_semanticUiReact.Input, {
                                className: 'zoneOrBlock',
                                name: 'zoneOrBlock',
                                onChange: function onChange(e, data) {
                                  return _this5.handleInputChange(e, data, column.rowID);
                                },
                                value: column.zoneOrBlock,
                                disabled: !allowEditUnitDetails
                              })
                            ),
                            _this5.checkIfColumnVisible('streetOrFacing') && _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              null,
                              _react2.default.createElement(_semanticUiReact.Input, {
                                className: 'streetOrFacing',
                                name: 'streetOrFacing',
                                onChange: function onChange(e, data) {
                                  return _this5.handleInputChange(e, data, column.rowID);
                                },
                                value: column.streetOrFacing,
                                disabled: !allowEditUnitDetails
                              })
                            ),
                            _this5.checkIfColumnVisible('position') && _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              null,
                              _react2.default.createElement(
                                _AppForm2.default.Validate,
                                {
                                  hideMessage: true,
                                  onChange: function onChange(e, data) {
                                    return _this5.handleInputChange(e, data, column.rowID);
                                  },
                                  onError: function onError(hasError, msg) {
                                    return _this5.handleOnError(hasError, msg, 'position', column.rowID);
                                  },
                                  ref: _this5.validation['position' + column.rowID],
                                  validateLabel: 'Position',
                                  validation: [_webValidations.required, {
                                    validate: _webValidations.numericRange,
                                    option: {
                                      min: 0
                                    }
                                  }]
                                },
                                _react2.default.createElement(
                                  _semanticUiReact.Input,
                                  {
                                    className: 'position',
                                    name: 'position',
                                    labelPosition: column.errors.position !== '' ? 'right' : null,
                                    ref: function ref(_ref13) {
                                      _this5['position' + column.rowID] = _ref13;
                                    },
                                    type: 'number',
                                    value: column.position,
                                    disabled: !allowEditUnitDetails
                                  },
                                  _react2.default.createElement('input', null),
                                  column.errors.position !== '' ? _react2.default.createElement(
                                    _semanticUiReact.Label,
                                    null,
                                    _react2.default.createElement(_semanticUiReact.Popup, {
                                      content: column.errors.position,
                                      inverted: true,
                                      size: 'mini',
                                      trigger: _react2.default.createElement(_semanticUiReact.Icon, {
                                        color: 'red',
                                        fitted: true,
                                        name: 'warning sign',
                                        style: { marginLeft: '0.5em' }
                                      })
                                    })
                                  ) : false
                                )
                              )
                            ),
                            _this5.checkIfColumnVisible('address') && _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              null,
                              _react2.default.createElement('textarea', {
                                className: 'semantic-textbox',
                                name: 'address',
                                onChange: function onChange(e) {
                                  return _this5.handleTextAreaChange(e, column.rowID);
                                },
                                style: { minHeight: '4em' },
                                value: column.address,
                                disabled: !allowEditUnitDetails
                              })
                            ),
                            _this5.checkIfColumnVisible('remarkExternal') && _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              null,
                              _react2.default.createElement('textarea', {
                                className: 'semantic-textbox',
                                name: 'remarkExternal',
                                onChange: function onChange(e) {
                                  return _this5.handleTextAreaChange(e, column.rowID);
                                },
                                style: { minHeight: '4em' },
                                value: column.remarkExternal,
                                disabled: !allowEditUnitDetails
                              })
                            ),
                            _this5.checkIfColumnVisible('remarkInternal') && _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              null,
                              _react2.default.createElement('textarea', {
                                className: 'semantic-textbox',
                                name: 'remarkInternal',
                                onChange: function onChange(e) {
                                  return _this5.handleTextAreaChange(e, column.rowID);
                                },
                                style: { minHeight: '4em' },
                                value: column.remarkInternal,
                                disabled: !allowEditUnitDetails
                              })
                            ),
                            _this5.checkIfColumnVisible('packagePricings') && _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              { singleLine: true },
                              allowEditUnitPrice ? _react2.default.createElement(
                                _semanticUiReact.Button,
                                {
                                  onClick: function onClick(e) {
                                    return _this5.handleManagePricing(e, column);
                                  },
                                  primary: true,
                                  size: 'small'
                                },
                                (column.projectUnitPackagePricings && column.projectUnitPackagePricings.length) > 0 ? _this5.props.t('Edit') : _this5.props.t('Add')
                              ) : null,
                              column.projectUnitPackagePricings ? column.projectUnitPackagePricings.map(function (price, idxs) {
                                if (price.totalPrice) {
                                  return _react2.default.createElement(
                                    'span',
                                    { key: idxs },
                                    idxs > 0 && ' | ',
                                    _react2.default.createElement(
                                      'b',
                                      null,
                                      price.projectPackagePricing && price.projectPackagePricing.name ? price.projectPackagePricing.name : price.customName || '',
                                      ':'
                                    ),
                                    '\xA0',
                                    _react2.default.createElement(_LoanAmount2.default, {
                                      format: '0,000,000.00',
                                      amount: price.totalPrice ? price.totalPrice : '',
                                      precise: false
                                    })
                                  );
                                }
                                return '';
                              }) : null
                            ),
                            _this5.checkIfColumnVisible('specifications') && _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              { singleLine: true },
                              allowEditUnitDetails ? _react2.default.createElement(
                                _semanticUiReact.Button,
                                {
                                  onClick: function onClick(e) {
                                    return _this5.handleManageSpecifications(e, column);
                                  },
                                  primary: true,
                                  size: 'small'
                                },
                                (column.specifications && column.specifications.length) > 0 ? _this5.props.t('Edit') : _this5.props.t('Add')
                              ) : null,
                              column.specifications ? column.specifications.map(function (spec, idxs) {
                                return _react2.default.createElement(
                                  'span',
                                  { key: idxs },
                                  idxs > 0 && ' | ',
                                  _react2.default.createElement(
                                    'b',
                                    null,
                                    spec.name,
                                    ':'
                                  ),
                                  ' ',
                                  spec.value
                                );
                              }) : null
                            ),
                            _this5.checkIfColumnVisible('agency') && _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              null,
                              _react2.default.createElement(_semanticUiReact.Dropdown, {
                                style: { width: '20em' },
                                name: 'companyBranchAllocationIDs',
                                onChange: function onChange(e, data) {
                                  return _this5.handleInputChange(e, data, column.rowID);
                                },
                                placeholder: _this5.props.t('Select Agency'),
                                fluid: true,
                                multiple: true,
                                search: true,
                                selection: true,
                                selectOnBlur: false,
                                renderLabel: _this5.renderAgencyLabel,
                                options: _this5.getAgencyAllocationOptions(column, companyBranches, agencyAllocationAllocateAll),
                                value: _this5.getAgencyAllocationValue(column, agencyAllocationAllocateAll),
                                disabled: !allowEditUnitDetails || _this5.isAgencyAllocationLocked(column.statusID)
                              })
                            ),
                            _this5.hasVAEnabled() && _this5.checkIfColumnVisible('vaBankName') && _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              null,
                              _react2.default.createElement(_SelectBank2.default, {
                                style: { width: '20em' },
                                country: company ? company.countryCode : '',
                                name: 'vaBankName',
                                placeholder: _this5.props.t('Select Bank'),
                                onChange: function onChange(e, data) {
                                  return _this5.handleInputChange(e, data, column.rowID);
                                },
                                value: column.vaBankName,
                                disabled: !allowEditUnitDetails
                              })
                            ),
                            _this5.hasVAEnabled() && _this5.checkIfColumnVisible('vaAccountNumber') && _react2.default.createElement(
                              _semanticUiReact.Table.Cell,
                              null,
                              _react2.default.createElement(_semanticUiReact.Input, {
                                className: 'vaAccountNumber',
                                name: 'vaAccountNumber',
                                onChange: function onChange(e, data) {
                                  return _this5.handleInputChange(e, data, column.rowID);
                                },
                                value: column.vaAccountNumber,
                                disabled: !allowEditUnitDetails
                              })
                            )
                          );
                        }) : null
                      )
                    )
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { style: { padding: '0em 0.5em' } },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  this.getCountSummaryText()
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { style: { textAlign: 'center' } },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(
                    'div',
                    { style: { marginRight: '1em' } },
                    _react2.default.createElement(_PageNav2.default, {
                      count: this.state.count,
                      currentPage: this.state.currentPage,
                      dataSize: rowsData.length,
                      limit: this.state.limit,
                      loading: this.state.loading,
                      offset: this.state.offset,
                      onChange: function onChange(page) {
                        return _this5.handleTriggerCheck('handleChangePage', page);
                      }
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }, {
    key: 'SEARCH_STATUSES',
    get: function get() {
      return this.getSearchStatuses();
    }
  }, {
    key: 'SEARCH_COMPANY_BRANCH',
    get: function get() {
      return this.getSearchCompanyBranch();
    }
  }, {
    key: 'SEARCH_UNITLAYOUTS',
    get: function get() {
      return this.getSearchUnitLayouts();
    }
  }, {
    key: 'SEARCH_UNITLEVEL',
    get: function get() {
      return this.getSearchUnitLevel();
    }
  }]);

  return MultiEdit;
}(_react.Component);

MultiEdit.propTypes = {
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func,
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  project: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    name: _propTypes2.default.string,
    agencyAllocationAllocateAll: _propTypes2.default.bool,
    projectCurrency: _propTypes2.default.oneOfType([_propTypes2.default.array])
  }),
  auth: _propTypes2.default.shape({
    onSave: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool,
    allowEditUnitPrice: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isDeveloperSalesAdmin: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      settings: _propTypes2.default.shape({
        virtualAccountIsEnabled: _propTypes2.default.bool
      })
    })
  }),
  t: _propTypes2.default.func
};
MultiEdit.contextTypes = {
  store: _propTypes2.default.object
};

MultiEdit.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

MultiEdit.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var page = parseInt(query.page, 10) || 1;
  var pageLimit = query.limit || '50';
  var search = query.search || '';
  var statusID = query.statusID || [];
  var companyBranchID = query.companyBranchID || [];
  var filterUnitLayoutID = query.filterUnitLayoutID || [];
  var filterUnitLevel = query.filterUnitLevel || [];
  var globalSettings = {};
  var storeGloablSettings = (0, _storage.getItem)(_config2.default.get('appName') + '.globalSettings');
  if (storeGloablSettings) {
    try {
      globalSettings = JSON.parse(storeGloablSettings).data || [];
    } catch (e) {
      Bugsnag.notifyException(e);
    }
  }

  return {
    currentPage: currentPage,
    page: page,
    pageLimit: pageLimit,
    search: search,
    statusID: statusID,
    companyBranchID: companyBranchID,
    filterUnitLayoutID: filterUnitLayoutID,
    filterUnitLevel: filterUnitLevel,
    globalSettings: globalSettings
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.onResize = function () {
    var tableWidth = document.getElementById('multi-edit-table').getBoundingClientRect().width - 15;
    if (tableWidth !== _this6.state.tableWidth) {
      _this6.setState({ tableWidth: tableWidth });
    }
    _this6.setNavHeight();
  };

  this.onScroll = function () {
    var offsetY = window.pageYOffset;
    var isOver = offsetY > 220;
    if (isOver !== _this6.state.isOver) {
      _this6.setState({ isOver: isOver });
    }
    _this6.setNavHeight();
  };

  this.setNavHeight = function () {
    var nav = document.getElementById('multi-edit-nav');
    var navHeight = nav ? nav.getBoundingClientRect().height : 0;
    if (navHeight !== _this6.state.navHeight) {
      _this6.setState({ navHeight: navHeight });
    }
  };

  this.onTableScrollBarTop = function () {
    var scrollLeft = document.getElementById('tableTopScrollBar').scrollLeft;
    document.getElementById('tableBottomScrollBar').scrollLeft = scrollLeft;
  };

  this.onTableScrollBarBottom = function () {
    var scrollLeft = document.getElementById('tableBottomScrollBar').scrollLeft;
    document.getElementById('tableTopScrollBar').scrollLeft = scrollLeft;
  };

  this.setTableWidth = function () {
    var tableWidth = document.getElementById('multi-edit-table').getBoundingClientRect().width - 15;
    _this6.setState({ tableWidth: tableWidth });
  };

  this.getCountSummaryText = function () {
    var _state4 = _this6.state,
        rowsData = _state4.rowsData,
        count = _state4.count,
        limit = _state4.limit,
        currentPage = _state4.currentPage,
        statusID = _state4.statusID,
        search = _state4.search;

    var selectedLength = rowsData.filter(function (d) {
      return d.isSelected;
    }).length;
    var totalPages = Math.ceil(count / limit);
    var startUnit = currentPage * limit - limit + 1;
    var isAllStatusID = statusID && statusID.includes('all');

    var endUnit = currentPage * limit;
    if (currentPage === totalPages) {
      endUnit = count;
    }
    return _react2.default.createElement(
      'span',
      null,
      _this6.props.t('Showing', { ns: _translation.TRANSLATION_FILES.translation }),
      ' ',
      rowsData.length > 0 ? startUnit + '-' + endUnit : '0',
      ' ',
      _this6.props.t('of', { ns: _translation.TRANSLATION_FILES.translation }),
      ' ',
      count,
      ' ',
      search !== '' ? _react2.default.createElement(
        'span',
        null,
        _this6.props.t('results for', { ns: _translation.TRANSLATION_FILES.translation }),
        ' ',
        _react2.default.createElement(
          'b',
          null,
          search
        )
      ) : _this6.props.t('units', { ns: _translation.TRANSLATION_FILES.translation }),
      !isAllStatusID ? ' ' + _this6.props.t('from') + ' ' + _this6.getValueName(statusID, _this6.SEARCH_STATUSES) : '',
      selectedLength > 0 ? _react2.default.createElement(
        'span',
        null,
        ', ',
        _react2.default.createElement(
          'b',
          null,
          selectedLength,
          ' ',
          _this6.props.t('selected', { ns: _translation.TRANSLATION_FILES.translation })
        )
      ) : '',
      !isAllStatusID || search !== '' ? _react2.default.createElement(
        'span',
        null,
        '\xA0|\xA0',
        _react2.default.createElement(
          'button',
          {
            className: 'a-button-blue',
            onClick: function onClick(e) {
              return _this6.handleTriggerCheck('handleClearFilter', e);
            }
          },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove', fitted: true }),
          ' ',
          _this6.props.t('Clear Filter', { ns: _translation.TRANSLATION_FILES.translation })
        )
      ) : ''
    );
  };

  this.getFormatedSPAValue = function (oldValue, newValue, type) {
    if (type === 'increase') {
      return Math.round(oldValue + newValue / 100 * oldValue);
    }
    if (type === 'deduct') {
      return Math.round(oldValue - newValue / 100 * oldValue);
    }
    return newValue;
  };

  this.getRowClassName = function (isSelected, rowID) {
    if (_this6.checkIfRowError(rowID)) return 'red';
    if (!isSelected && !_this6.checkIfRowError(rowID) && _this6.checkIfRowChanged(rowID)) return 'green';
    return '';
  };

  this.getValueName = function (value, arr) {
    var valueName = arr.filter(function (vn) {
      return value.some(function (v) {
        return v === vn.value;
      });
    }).map(function (x) {
      return x.text;
    });
    if (valueName) {
      return valueName.join(', ');
    }
    return '';
  };

  this.setVAFieldValue = function (id, data) {
    if (id === _virtualAccount.VA_BANK_NAME) {
      return data.vaBankName;
    }
    if (id === _virtualAccount.VA_ACCOUNT_NUMBER) {
      return data.vaAccountNumber;
    }
    return '';
  };

  this.filterPackingPricing = function (packages) {
    var packagePricings = _this6.state.packagePricings;

    var newPackagePricings = packages;
    if (packagePricings) {
      packages.forEach(function (pt, idx) {
        // expired schedule
        var sStart = pt.scheduleStartAt;
        var sEnd = pt.scheduleEndAt;
        if (sStart && (0, _momentTimezone2.default)(sStart).unix() > (0, _momentTimezone2.default)().unix() || sEnd && (0, _momentTimezone2.default)(sEnd).unix() < (0, _momentTimezone2.default)().unix()) {
          newPackagePricings[idx].disabled = true;
        }
      });
    }
    return newPackagePricings;
  };

  this.getValueDropdown = function (array, value) {
    var element = array.find(function (a) {
      return a.value == value;
    });
    if (element && element.text) {
      return element.value;
    }
    return '';
  };

  this.getAgencyAllocationOptions = function (column, companyBranches, agencyAllocationAllocateAll) {
    var allocationIDs = column.companyBranchAllocationIDs || [];
    if (agencyAllocationAllocateAll && allocationIDs.length === 0) {
      return [{ text: _this6.props.t('All Agencies', { ns: _translation.TRANSLATION_FILES.translation }), value: ALL_AGENCIES_VALUE }].concat(_toConsumableArray(companyBranches));
    }
    return companyBranches;
  };

  this.renderAgencyLabel = function (item) {
    return { content: item.text, active: false };
  };

  this.getAgencyAllocationValue = function (column, agencyAllocationAllocateAll) {
    var allocationIDs = column.companyBranchAllocationIDs || [];
    return agencyAllocationAllocateAll && allocationIDs.length === 0 ? [ALL_AGENCIES_VALUE] : allocationIDs;
  };

  this.handleInputChange = function (event, data, rowID) {
    var _state5 = _this6.state,
        rowsData = _state5.rowsData,
        oriRowsData = _state5.oriRowsData;

    if (data.name === 'reference' || data.name === 'size' || data.name === 'spaAmount' || data.name === 'position') {
      _this6.validation['' + data.name + rowID].current.validate(data.value);
    }
    var index = rowsData.findIndex(function (r) {
      return r.rowID === rowID;
    });
    var nextValue = data.name === 'companyBranchAllocationIDs' && Array.isArray(data.value) ? data.value.filter(function (agencyID) {
      return agencyID !== ALL_AGENCIES_VALUE;
    }) : data.value;
    var originalValue = oriRowsData[index][data.name];
    rowsData[index][data.name] = data.name === 'companyBranchAllocationIDs' && Array.isArray(nextValue) && nextValue.length === 0 && (!originalValue || originalValue.length === 0) ? originalValue : nextValue;
    _this6.setState({ rowsData: rowsData, sortColumn: null, sortDirection: null }, function () {
      _this6.handleOnCheck(true);
      if (data.name === 'reference' || data.name === 'size' || data.name === 'spaAmount' || data.name === 'position') {
        _this6.inputScrollbarTimer = setTimeout(function () {
          var tableWidth = document.getElementById('multi-edit-table').getBoundingClientRect().width;
          if (tableWidth !== _this6.state.tableWidth) {
            _this6.setState({ tableWidth: tableWidth });
          }
        }, 500);
      }
    });
  };

  this.handleTextAreaChange = function (event, rowID) {
    var rowsData = _this6.state.rowsData;

    var index = rowsData.findIndex(function (r) {
      return r.rowID === rowID;
    });
    rowsData[index][event.target.name] = event.target.value;
    _this6.setState({ rowsData: rowsData, sortColumn: null, sortDirection: null }, function () {
      _this6.handleOnCheck(true);
    });
  };

  this.handleCheckboxChange = function (event, data, rowID) {
    var rowsData = _this6.state.rowsData;

    var index = rowsData.findIndex(function (r) {
      return r.rowID === rowID;
    });
    rowsData[index][data.name] = !rowsData[index][data.name];
    _this6.setState({ rowsData: rowsData, sortColumn: null, sortDirection: null }, function () {
      _this6.handleOnCheck(true);
    });
  };

  this.handleCheckboxClick = function (event, rowID) {
    var _state6 = _this6.state,
        shiftSelect = _state6.shiftSelect,
        rowsData = _state6.rowsData;

    var index = rowsData.findIndex(function (r) {
      return r.rowID === rowID;
    });
    if (event.shiftKey) {
      if (rowsData[shiftSelect.start].isSelected !== rowsData[index].isSelected) {
        shiftSelect.end = null;
      }
      if (shiftSelect.start === null) {
        shiftSelect.start = index;
      }
      if (shiftSelect.start !== index) {
        if (shiftSelect.start > index) {
          rowsData.forEach(function (d, idx) {
            if (idx >= index && idx <= shiftSelect.start) {
              rowsData[idx].isSelected = rowsData[shiftSelect.start].isSelected;
            }
            if (shiftSelect.end && idx >= shiftSelect.end && idx <= index) {
              rowsData[idx].isSelected = !rowsData[shiftSelect.start].isSelected;
            }
          });
        }
        if (shiftSelect.start < index) {
          rowsData.forEach(function (d, idx) {
            if (idx >= shiftSelect.start && idx <= index) {
              rowsData[idx].isSelected = rowsData[shiftSelect.start].isSelected;
            }
            if (shiftSelect.end && idx >= index && idx <= shiftSelect.end) {
              rowsData[idx].isSelected = !rowsData[shiftSelect.start].isSelected;
            }
          });
        }
        shiftSelect.end = index;
      } else {
        rowsData[index].isSelected = !rowsData[index].isSelected;
      }
    } else {
      rowsData[index].isSelected = !rowsData[index].isSelected;
      shiftSelect.start = index;
      shiftSelect.end = null;
    }
    _this6.setState({ shiftSelect: shiftSelect, rowsData: rowsData, isSelectedAll: false });
  };

  this.handleCheckboxSelectAll = function () {
    var _state7 = _this6.state,
        shiftSelect = _state7.shiftSelect,
        rowsData = _state7.rowsData;

    var isSelectedAll = !_this6.state.isSelectedAll;
    shiftSelect.start = null;
    shiftSelect.end = null;
    rowsData.forEach(function (d, idx) {
      rowsData[idx].isSelected = !_this6.state.isSelectedAll;
    });
    _this6.setState({ shiftSelect: shiftSelect, rowsData: rowsData, isSelectedAll: isSelectedAll });
  };

  this.handleManageSpecifications = function (e, row) {
    e.preventDefault();
    _this6.setState({ specModalIsOpen: true, specModalRow: row });
  };

  this.handleSpecificationsOnDone = function () {
    _this6.setState({ specModalIsOpen: false, specModalRow: {} });
  };

  this.handleSpecificationsOnChange = function (data) {
    var _state8 = _this6.state,
        rowsData = _state8.rowsData,
        specModalRow = _state8.specModalRow;

    if (specModalRow) {
      var index = rowsData.findIndex(function (r) {
        return r.rowID === specModalRow.rowID;
      });
      rowsData[index].specifications = data;
    }
    _this6.setState({ rowsData: rowsData }, function () {
      _this6.handleOnCheck(true);
      _this6.inputScrollbarTimer = setTimeout(function () {
        var tableWidth = document.getElementById('multi-edit-table').getBoundingClientRect().width;
        if (tableWidth !== _this6.state.tableWidth) {
          _this6.setState({ tableWidth: tableWidth });
        }
      }, 500);
    });
  };

  this.handleManageAllocate = function () {
    _this6.setState({ allocateModalIsOpen: true });
  };

  this.handleClearAllocations = function (e) {
    e.preventDefault();
    _this6.setState({ clearAllocationsConfirmIsOpen: true });
  };

  this.handleCancelClearAllocations = function () {
    _this6.setState({ clearAllocationsConfirmIsOpen: false });
  };

  this.handleConfirmClearAllocations = function () {
    _this6.setState({ clearAllocationsConfirmIsOpen: false }, function () {
      _this6.clearAllAllocations();
    });
  };

  this.handleManagePricing = function (e, row) {
    e.preventDefault();
    _this6.setState({ priceModalIsOpen: true, priceModalRow: row });
  };

  this.handlePricingOnDone = function () {
    _this6.setState({ priceModalIsOpen: false, priceModalRow: {} });
  };

  this.handlePricingOnChange = function (data) {
    var _state9 = _this6.state,
        rowsData = _state9.rowsData,
        priceModalRow = _state9.priceModalRow;

    if (priceModalRow) {
      var index = rowsData.findIndex(function (r) {
        return r.rowID === priceModalRow.rowID;
      });
      rowsData[index].projectUnitPackagePricings = data;
    }
    _this6.setState({ rowsData: rowsData }, function () {
      _this6.handleOnCheck(true);
      _this6.inputScrollbarTimer = setTimeout(function () {
        var tableWidth = document.getElementById('multi-edit-table').getBoundingClientRect().width;
        if (tableWidth !== _this6.state.tableWidth) {
          _this6.setState({ tableWidth: tableWidth });
        }
      }, 500);
    });
  };

  this.handleVisibleCheckboxChange = function (event, data) {
    var visibleColumns = _this6.state.visibleColumns;

    if (_this6.checkIfColumnVisible(data.name)) {
      visibleColumns.splice(visibleColumns.findIndex(function (d) {
        return d === data.name;
      }), 1);
    } else {
      visibleColumns.push(data.name);
    }
    _this6.setState({ visibleColumns: visibleColumns }, function () {
      var tableWidth = document.getElementById('multi-edit-table').getBoundingClientRect().width;
      if (tableWidth !== _this6.state.tableWidth) {
        _this6.setState({ tableWidth: tableWidth });
      }
    });
  };

  this.handleCellSort = function (column) {
    var _state10 = _this6.state,
        rowsData = _state10.rowsData,
        oriRowsData = _state10.oriRowsData,
        sortColumn = _state10.sortColumn,
        sortDirection = _state10.sortDirection;

    var direction = 'asc';
    if (column === sortColumn) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc';
    }
    var sortedArray = rowsData;
    var oriSortedArray = oriRowsData;
    if (direction === 'asc') {
      sortedArray = rowsData.sort(function (a, b) {
        if (a[column] < b[column]) return -1;
        if (a[column] > b[column]) return 1;
        return 0;
      });
      oriSortedArray = oriRowsData.sort(function (a, b) {
        if (a[column] < b[column]) return -1;
        if (a[column] > b[column]) return 1;
        return 0;
      });
    }
    if (direction === 'desc') {
      sortedArray = rowsData.sort(function (a, b) {
        if (b[column] < a[column]) return -1;
        if (b[column] > a[column]) return 1;
        return 0;
      });
      oriSortedArray = oriRowsData.sort(function (a, b) {
        if (b[column] < a[column]) return -1;
        if (b[column] > a[column]) return 1;
        return 0;
      });
    }
    _this6.setState({
      rowsData: sortedArray,
      oriRowsData: oriSortedArray,
      sortColumn: column,
      sortDirection: direction
    });
  };

  this.sortArray = function (array, column) {
    var sortedArray = array.sort(function (a, b) {
      if (a[column] < b[column]) return -1;
      if (a[column] > b[column]) return 1;
      return 0;
    });
    return sortedArray;
  };

  this.checkIfAnySelected = function () {
    var rowsData = _this6.state.rowsData;

    var selected = rowsData.find(function (d) {
      return d.isSelected;
    });
    if (selected) return true;
    return false;
  };

  this.checkIfColumnVisible = function (column) {
    var found = _this6.state.visibleColumns.find(function (d) {
      return d === column;
    });
    if (found) return true;
    return false;
  };

  this.checkRestrictedStatusID = function (statusID) {
    if (statusID === 'reserved' || statusID === 'booked' || statusID === 'sold_spa_signed') {
      return true;
    }
    return false;
  };

  this.isAgencyAllocationLocked = function (statusID) {
    return (0, _vietnam.isVietnamCompany)(_this6.props.auth) && _this6.checkRestrictedStatusID(statusID);
  };

  this.updateRowsData = function (rowsData, field, value) {
    var newRowsData = rowsData;
    rowsData.filter(function (d) {
      return d.isSelected;
    }).forEach(function (data) {
      var index = rowsData.findIndex(function (r) {
        return r.rowID === data.rowID;
      });
      var statusID = newRowsData[index].statusID;
      if ((field === 'statusID' || field === 'spaAmount') && (statusID === 'new' || statusID === 'developer_reserved' || statusID === 'developer_booked' || statusID === 'developer_sold' || statusID === 'delist')) {
        if (field === 'statusID') {
          newRowsData[index][field] = value;
        }
        if (field === 'spaAmount') {
          newRowsData[index][field] = _this6.getFormatedSPAValue(parseFloat(newRowsData[index][field]), parseFloat(value.value), value.type);
        }
      } else if (field === 'companyBranchAllocationIDs') {
        if (!_this6.isAgencyAllocationLocked(statusID)) {
          newRowsData[index][field] = value;
        }
      } else if (field !== 'statusID' && field !== 'spaAmount') {
        newRowsData[index][field] = value;
      }
    });
    return newRowsData;
  };

  this.handleChangeLimit = function (e, data) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.limit = data.value;
    _this6.setState({ pageLimit: data.value }, function () {
      _this6.replaceQuery(query, true);
    });
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.page = currentPage;
    _this6.setState({ currentPage: currentPage }, function () {
      _this6.replaceQuery(query);
    });
  };

  this.handleClearFilter = function (e) {
    e.preventDefault();
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    var _state11 = _this6.state,
        search = _state11.search,
        statusID = _state11.statusID;

    if (search !== '') {
      delete query.search;
    }
    if (statusID) {
      delete query.statusID;
    }
    _this6.replaceQuery(query, true);
  };

  this.handleSearchOnSubmit = function (search) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.search = search;
    if (search === '') {
      delete query.search;
    }
    if (search !== _this6.state.search || _this6.state.search !== '') {
      _this6.setState({ search: search }, function () {
        _this6.replaceQuery(query, true);
      });
    }
  };

  this.handleTriggerCheck = function (checkFunctionName) {
    var a = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var b = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var c = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var _state12 = _this6.state,
        rowsData = _state12.rowsData,
        oriRowsData = _state12.oriRowsData;

    var match = false;
    var checkModalIsOpen = true;
    try {
      match = JSON.stringify(rowsData) === JSON.stringify(oriRowsData);
    } catch (e) {
      Bugsnag.notifyException(e);
    }
    if (match) checkModalIsOpen = false;
    var checkFunctionData = { a: a, b: b, c: c };
    _this6.setState({ checkModalIsOpen: checkModalIsOpen, checkFunctionData: checkFunctionData, checkFunctionName: checkFunctionName }, function () {
      if (match) _this6.handleConfirmCheckModal();
    });
  };

  this.handleConfirmCheckModal = function () {
    var _state13 = _this6.state,
        checkFunctionData = _state13.checkFunctionData,
        checkFunctionName = _state13.checkFunctionName;

    switch (checkFunctionName) {
      case 'handleChangeLimit':
        _this6.handleChangeLimit(checkFunctionData.a, checkFunctionData.b);
        break;
      case 'handleChangePage':
        _this6.handleChangePage(checkFunctionData.a);
        break;
      case 'handleClearFilter':
        _this6.handleClearFilter(checkFunctionData.a);
        break;
      case 'handleSearchOnSubmit':
        _this6.handleSearchOnSubmit(checkFunctionData.a);
        break;
      default:
        break;
    }
    checkFunctionData.a = null;
    checkFunctionData.b = null;
    checkFunctionData.c = null;
    _this6.setState({ checkModalIsOpen: false, checkFunctionData: checkFunctionData, checkFunctionName: '' });
  };

  this.handleFilterOnChange = function (arrValue, queryName) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query[queryName] = arrValue;
    if (arrValue.includes('all')) {
      delete query[queryName];
    }
    _this6.setState(_defineProperty({}, queryName, arrValue));
    _this6.replaceQuery(query, false);
  };

  this.handleCancelCheckModal = function () {
    var checkFunctionData = { a: null, b: null, c: null };
    _this6.setState({ checkModalIsOpen: false, checkFunctionData: checkFunctionData, checkFunctionName: '' });
  };

  this.handleEditRow = function () {
    _this6.setState({ editModalIsOpen: true });
  };

  this.handleModalSave = function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(closeModal, selectedEditField, fieldValue) {
      var visibleColumns, _state14, editModalIsOpen, allocateModalIsOpen, rowsData, isSelectedAll;

      return regeneratorRuntime.wrap(function _callee10$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              visibleColumns = _this6.state.visibleColumns;
              _state14 = _this6.state, editModalIsOpen = _state14.editModalIsOpen, allocateModalIsOpen = _state14.allocateModalIsOpen, rowsData = _state14.rowsData, isSelectedAll = _state14.isSelectedAll;

              if (selectedEditField !== '' && fieldValue !== '') {
                rowsData = _this6.updateRowsData(rowsData, selectedEditField, fieldValue);
              }
              if (closeModal) {
                editModalIsOpen = false;
                allocateModalIsOpen = false;
                isSelectedAll = false;
                rowsData.forEach(function (d, idx) {
                  if (d.isSelected) {
                    rowsData[idx].isSelected = false;
                  }
                });
              }
              if (selectedEditField === 'specifications' && !_this6.checkIfColumnVisible('specifications')) {
                visibleColumns.push('specifications');
              }
              if (selectedEditField === 'packagePricings' && !_this6.checkIfColumnVisible('packagePricings')) {
                visibleColumns.push('packagePricings');
              }
              _this6.setState({ editModalIsOpen: editModalIsOpen, allocateModalIsOpen: allocateModalIsOpen, isSelectedAll: isSelectedAll, rowsData: rowsData, visibleColumns: visibleColumns });

            case 7:
            case 'end':
              return _context10.stop();
          }
        }
      }, _callee10, _this6);
    }));

    return function (_x10, _x11, _x12) {
      return _ref14.apply(this, arguments);
    };
  }();

  this.handleCloseEditModal = function () {
    _this6.setState({ editModalIsOpen: false });
  };

  this.handleCloseAllocate = function () {
    _this6.setState({ allocateModalIsOpen: false });
  };

  this.handleCloseFormErrorModal = function () {
    _this6.setState({ formErrorModalIsOpen: false });
  };

  this.handleOnDeselectUnit = function (e, rowID) {
    var rowsData = _this6.state.rowsData;

    var index = rowsData.findIndex(function (r) {
      return r.rowID === rowID;
    });
    rowsData[index].isSelected = false;
    _this6.setState({ rowsData: rowsData, isSelectedAll: false });
  };

  this.checkIfRowChanged = function (rowID) {
    var _state15 = _this6.state,
        rowsData = _state15.rowsData,
        oriRowsData = _state15.oriRowsData;

    var row = Object.assign({}, rowsData[rowsData.findIndex(function (r) {
      return r.rowID === rowID;
    })]);
    var oriRow = Object.assign({}, oriRowsData[oriRowsData.findIndex(function (r) {
      return r.rowID === rowID;
    })]);
    delete row.isSelected;
    delete oriRow.isSelected;
    try {
      if (JSON.stringify(row) !== JSON.stringify(oriRow)) return true;
    } catch (e) {
      Bugsnag.notifyException(e);
    }
    return false;
  };

  this.checkIfRowError = function (rowID) {
    var rowsData = _this6.state.rowsData;

    var d = Object.assign({}, rowsData[rowsData.findIndex(function (r) {
      return r.rowID === rowID;
    })]);
    if (d.errors.reference !== '' || d.errors.size !== '' || d.errors.spaAmount !== '' || d.errors.position !== '') {
      return true;
    }
    return false;
  };

  this.handleResetRow = function () {
    var _state16 = _this6.state,
        rowsData = _state16.rowsData,
        oriRowsData = _state16.oriRowsData;

    rowsData.forEach(function (d, idx) {
      if (d.isSelected) {
        var oriRow = oriRowsData.find(function (r) {
          return r.rowID === d.rowID;
        });
        rowsData[idx].isSelected = false;
        rowsData[idx].projectUnitLayoutID = oriRow.projectUnitLayoutID;
        rowsData[idx].reference = oriRow.reference;
        rowsData[idx].statusID = oriRow.statusID;
        rowsData[idx].size = oriRow.size;
        rowsData[idx].spaAmount = oriRow.spaAmount;
        rowsData[idx].isBumi = oriRow.isBumi;
        rowsData[idx].address = oriRow.address;
        rowsData[idx].position = oriRow.position;
        rowsData[idx].zoneOrBlock = oriRow.zoneOrBlock;
        rowsData[idx].streetNumberOrLevel = oriRow.streetNumberOrLevel;
        rowsData[idx].streetOrFacing = oriRow.streetOrFacing;
        rowsData[idx].remarkExternal = oriRow.remarkExternal;
        rowsData[idx].remarkInternal = oriRow.remarkInternal;
        rowsData[idx].projectUnitPackagePricings = oriRow.projectUnitPackagePricings;
        rowsData[idx].specifications = oriRow.specifications;
        rowsData[idx].errors = oriRow.errors;
        rowsData[idx].vaBankName = oriRow.vaBankName;
        rowsData[idx].vaAccountNumber = oriRow.vaAccountNumber;
      }
    });
    _this6.setState({
      rowsData: rowsData,
      isSelectedAll: false,
      sortColumn: null,
      sortDirection: null
    }, function () {
      var tableWidth = document.getElementById('multi-edit-table').getBoundingClientRect().width;
      if (tableWidth !== _this6.state.tableWidth) {
        _this6.setState({ tableWidth: tableWidth });
      }
    });
  };

  this.handleGoBack = function (e) {
    e.preventDefault();
    var store = _this6.context.store;

    store.dispatch((0, _reactRouterRedux.goBack)());
  };

  this.handleOnError = function (hasError, errorMessage, inputName, rowID) {
    var rowsData = _this6.state.rowsData;

    var index = rowsData.findIndex(function (r) {
      return r.rowID === rowID;
    });
    if (hasError) {
      rowsData[index].errors[inputName] = errorMessage;
    } else {
      rowsData[index].errors[inputName] = '';
    }
    _this6.setState({ rowsData: rowsData });
  };

  this.handleOnCheck = function () {
    var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var callback = arguments[1];
    var _state17 = _this6.state,
        rowsData = _state17.rowsData,
        oriRowsData = _state17.oriRowsData;

    var match = false;
    try {
      match = JSON.stringify(rowsData) === JSON.stringify(oriRowsData);
    } catch (e) {
      Bugsnag.notifyException(e);
    }
    if (_this6.props.onCheck) {
      if (match) {
        _this6.props.onCheck(false, callback);
        return;
      }
      _this6.props.onCheck(hasChanges, callback);
    }
  };

  this.handleUpdateUnits = function (e) {
    e.preventDefault();
    _this6.updateUnits();
  };

  this.hasVAEnabled = function () {
    var appConfig = _this6.props.appConfig;

    return appConfig && appConfig.data && appConfig.data.settings && appConfig.data.settings.virtualAccountIsEnabled;
  };

  this.PAGE_LIMITS = [{ text: '25', value: '25' }, { text: '50', value: '50' }, { text: '100', value: '100' }, { text: '150', value: '150' }];

  this.getPageLimits = function () {
    return (0, _vietnam.unitPageLimitOpts)(_this6.props.auth, _this6.PAGE_LIMITS);
  };

  this.getSearchStatuses = function () {
    return [{ text: _this6.props.t('All Status', { ns: _translation.TRANSLATION_FILES.translation }), value: 'all' }].concat(_toConsumableArray(_unitStatuses.UNIT_STATUSES_HQ_BASIC));
  };

  this.fetchedCompanyBranches = [];
  this.fetchedUnitLayouts = [];
  this.fetchedUnitLevels = [];

  this.getSearchCompanyBranch = function () {
    return [{ text: _this6.props.t('All Agency', { ns: _translation.TRANSLATION_FILES.translation }), value: 'all' }].concat(_toConsumableArray(_this6.fetchedCompanyBranches));
  };

  this.getSearchUnitLayouts = function () {
    return [{ text: _this6.props.t('All Type', { ns: _translation.TRANSLATION_FILES.translation }), value: 'all' }].concat(_toConsumableArray(_this6.fetchedUnitLayouts));
  };

  this.getSearchUnitLevel = function () {
    return [{ text: _this6.props.t('All Level', { ns: _translation.TRANSLATION_FILES.translation }), value: 'all' }].concat(_toConsumableArray(_this6.fetchedUnitLevels));
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(MultiEdit.mapStateToProps)(MultiEdit));

/***/ }),
/* 2395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _checkChanges = __webpack_require__(61);

var _Edit = __webpack_require__(2394);

var _Edit2 = _interopRequireDefault(_Edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Project = function (_Component) {
  _inherits(Project, _Component);

  function Project() {
    _classCallCheck(this, Project);

    return _possibleConstructorReturn(this, (Project.__proto__ || Object.getPrototypeOf(Project)).apply(this, arguments));
  }

  _createClass(Project, [{
    key: 'renderChild',
    value: function renderChild() {
      var _this2 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          params: _this2.props.params,
          location: _this2.props.location
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Project;
}(_react.Component);

Project.propTypes = {
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object
  })
};
Project.contextTypes = {
  store: _propTypes2.default.object
};
Project.Edit = (0, _checkChanges.checkChanges)(_Edit2.default);
exports.default = Project;

/***/ }),
/* 2396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _MultiUnits = __webpack_require__(2395);

var _MultiUnits2 = _interopRequireDefault(_MultiUnits);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MultiUnits2.default;

/***/ }),
/* 2397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _reactRouter = __webpack_require__(18);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fileSize = __webpack_require__(85);

var _fileSize2 = _interopRequireDefault(_fileSize);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _ContentPlaceholder = __webpack_require__(1011);

var _ContentPlaceholder2 = _interopRequireDefault(_ContentPlaceholder);

var _EditableBox = __webpack_require__(153);

var _EditableBox2 = _interopRequireDefault(_EditableBox);

var _GalleryList = __webpack_require__(561);

var _GalleryList2 = _interopRequireDefault(_GalleryList);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _SpecificationTable = __webpack_require__(127);

var _SpecificationTable2 = _interopRequireDefault(_SpecificationTable);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _UnitLayoutItem = __webpack_require__(1034);

var _UnitLayoutItem2 = _interopRequireDefault(_UnitLayoutItem);

var _MarkdownText = __webpack_require__(193);

var _MarkdownText2 = _interopRequireDefault(_MarkdownText);

var _Phone = __webpack_require__(126);

var _Phone2 = _interopRequireDefault(_Phone);

var _translation = __webpack_require__(4);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _UnitsList = __webpack_require__(2532);

var _UnitsList2 = _interopRequireDefault(_UnitsList);

var _ModalConfirm = __webpack_require__(399);

var _ModalConfirm2 = _interopRequireDefault(_ModalConfirm);

var _navigations = __webpack_require__(117);

var _url = __webpack_require__(19);

var _vietnam = __webpack_require__(40);

var _preSalesLaunch = __webpack_require__(269);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_momentTimezone2.default.locale('en-gb');

var Overview = function (_Component) {
  _inherits(Overview, _Component);

  function Overview(props) {
    _classCallCheck(this, Overview);

    var _this = _possibleConstructorReturn(this, (Overview.__proto__ || Object.getPrototypeOf(Overview)).call(this, props));

    _initialiseProps.call(_this);

    var state = Overview.getPropsToState(props);
    _this.state = _extends({}, state, {
      pictures: [],
      slideshow: false,
      showLarge: false,
      selectedPicture: null,
      showBookUnit: false,
      unitLayout: null,
      hasChanges: false,
      showModalConfirm: false,
      viewLargeType: 'picture'
    });
    return _this;
  }

  _createClass(Overview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Overview.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this2.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      var _this3 = this;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true }, function () {
          _this3.handleOnCheck(true);
        });
      }
    }
  }, {
    key: 'handleResetCheck',
    value: function handleResetCheck() {
      var _this4 = this;

      if (this.state.hasChanges) {
        this.setState({ hasChanges: false }, function () {
          _this4.handleOnCheck(false);
        });
      }
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var user = this.props.auth;
      if (this.props.auth.isSuperAdmin || this.props.auth.isHeadquarters) {
        return true;
      }
      if (this.props.auth.isBranchLeaderSupervisorII && this.props.data && this.props.data.maOwnerCompanyBranchID === user.companyBranch.id) {
        return true;
      }
      return check;
    }
  }, {
    key: 'updateProject',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(project) {
        var _this5 = this;

        var store, t, res, message, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                _context.next = 4;
                return this.setComponentState({ loading: true });

              case 4:
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(project)
                }));

              case 8:
                res = _context.sent;
                _context.next = 21;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 17;
                return _context.t0.res.text();

              case 17:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 20:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));

              case 21:
                _context.next = 23;
                return res.json();

              case 23:
                data = _context.sent;
                _context.next = 26;
                return this.setComponentState({ loading: false }, function () {
                  _this5.handleResetCheck();
                });

              case 26:
                store.dispatch((0, _reactRouterRedux.push)('/projects/' + this.props.id + '/'));
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('{{name}} successfully updated', { name: data.name, ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function updateProject(_x3) {
        return _ref.apply(this, arguments);
      }

      return updateProject;
    }()
  }, {
    key: 'checkDisabled',
    value: function checkDisabled() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';
      var _state = this.state,
          pictures = _state.pictures,
          selectedPicture = _state.selectedPicture;

      if (selectedPicture) {
        var index = pictures.indexOf(selectedPicture);
        if (direction === 'left') {
          return index - 1 >= 0;
        }
        return index + 1 < pictures.length;
      }
      return false;
    }
  }, {
    key: 'duplicatesProject',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, t, res, message, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                _context2.next = 4;
                return this.setComponentState({ loading: true });

              case 4:
                res = void 0;
                _context2.prev = 5;
                _context2.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/duplicate/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 8:
                res = _context2.sent;
                _context2.next = 19;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](5);

                store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));
                _context2.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context2.next = 18;
                return this.setComponentState({ loading: false });

              case 18:
                return _context2.abrupt('return');

              case 19:
                if (res.ok) {
                  _context2.next = 29;
                  break;
                }

                _context2.next = 22;
                return res.text();

              case 22:
                message = _context2.sent;
                _context2.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context2.next = 27;
                return this.setComponentState({ loading: false });

              case 27:
                _context2.next = 33;
                break;

              case 29:
                _context2.next = 31;
                return res.json();

              case 31:
                data = _context2.sent;

                window.location.href = '/projects/' + data.id + '/';

              case 33:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 11]]);
      }));

      function duplicatesProject() {
        return _ref2.apply(this, arguments);
      }

      return duplicatesProject;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var pathname = this.props.location.pathname;
      var store = this.context.store;
      var _state2 = this.state,
          data = _state2.data,
          editData = _state2.editData;
      var t = this.props.t;
      // CPI-1292; Pre-Sales Launch: hidden for a role HQ has blocked from reserving on this project

      var canReserve = (0, _vietnam.showsLayoutReserveButton)(this.props.auth) && !(0, _preSalesLaunch.reservationBlocked)(this.props.auth, data);
      var links = (0, _navigations.routes)(this.props.id, data, this.hasAccess(), this.props.auth.isSiteplan, this.props.auth).map(function (l) {
        return _extends({}, l, {
          text: t(l.text)
        });
      });
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_ModalConfirm2.default, {
          open: this.state.showModalConfirm,
          onClose: this.handleCloseModalConfirm,
          onConfirm: this.handleDuplicatesProject,
          headerNode: t('Copy project') + '?',
          content: t('Are you sure you want to duplicate this project? This action will not be reversible') + '.'
        }),
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: link.text,
              content: link.text,
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this6.handleMenu(e, link);
              }
            });
          }),
          rightNav: this.hasAccess() ? _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  icon: true,
                  title: t('Copy project'),
                  disabled: this.state.loading,
                  onClick: function onClick(e) {
                    return _this6.handleShowModalConfirm(e);
                  }
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'copy' })
              ),
              _react2.default.createElement(_semanticUiReact.Button, {
                as: _reactRouter.Link,
                primary: true,
                content: t('Edit', { ns: _translation.TRANSLATION_FILES.translation }),
                disabled: this.state.loading,
                to: '/projects/' + this.props.id + '/edit/'
              })
            )
          ) : null
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'top', columns: 'equal', stackable: true },
          _react2.default.createElement(_ViewLarge2.default, {
            open: this.state.showLarge,
            onClose: this.handleCloseLarge,
            picture: this.state.selectedPicture,
            onSlide: this.handleSlidePicture,
            disabledLeft: !this.checkDisabled('left'),
            disabledRight: !this.checkDisabled('right'),
            slideshow: this.state.slideshow,
            type: this.state.viewLargeType
          }),
          _react2.default.createElement(_UnitsList2.default, {
            open: this.state.showBookUnit,
            onClose: this.handleCloseBookUnit,
            onConfirm: this.handleUnitClick,
            projectID: this.props.id,
            projectData: data,
            unitLayout: this.state.unitLayout
          }),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { verticalAlign: 'middle', columns: 1 },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _ContentPlaceholder2.default,
                {
                  header: true,
                  subheader: true,
                  loading: this.state.loading
                },
                _react2.default.createElement(_semanticUiReact.Header, {
                  size: 'large',
                  style: { marginBottom: '0.3em' },
                  content: data.name || t('Project'),
                  subheader: data.address6 ? data.address6 + ', ' + data.address7 : null
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Label.Group,
                { size: 'small' },
                data.isCommercial ? _react2.default.createElement(_semanticUiReact.Label, { content: t('Commercial') }) : null,
                data.isIndustrial ? _react2.default.createElement(_semanticUiReact.Label, { content: t('Industrial') }) : null,
                data.isResidential ? _react2.default.createElement(_semanticUiReact.Label, { content: t('Residential') }) : null
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { verticalAlign: 'top' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { mobile: 16, tablet: 16, computer: 8, style: { marginBottom: '1em' } },
                    this.hasAccess(this.getCoverPicture(data.projectPictures)) ? _react2.default.createElement(_LoadImage2.default, {
                      fluid: true,
                      cover: 'long',
                      centered: true,
                      loading: this.state.loading,
                      onClick: function onClick(e) {
                        return _this6.handleViewLarge(e, _this6.getCoverPicture(data.projectPictures));
                      },
                      labelNode: this.hasAccess() ? _react2.default.createElement(_semanticUiReact.Label, {
                        as: _reactRouter.Link,
                        attached: 'top right',
                        size: 'small',
                        content: t('Edit', { ns: _translation.TRANSLATION_FILES.translation }),
                        icon: 'pencil',
                        to: '/projects/' + this.props.id + '/pictures/',
                        disabled: this.state.loading
                      }) : null,
                      notFoundNode: _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          t('No cover picture found'),
                          '.'
                        ),
                        _react2.default.createElement(_semanticUiReact.Button, {
                          as: _reactRouter.Link,
                          primary: true, compact: true,
                          disabled: this.state.loading,
                          to: '/projects/' + this.props.id + '/pictures/',
                          content: t('Click here to add')
                        })
                      ),
                      picture: this.getCoverPicture(data.projectPictures),
                      pictureSize: 70
                    }) : null
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { mobile: 16, tablet: 16, computer: 8 },
                    this.hasAccess(data.specifications && data.specifications.length > 0) ? _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Dimmer,
                          { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
                          _react2.default.createElement(
                            _semanticUiReact.Loader,
                            { inline: 'centered' },
                            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                          )
                        ),
                        _react2.default.createElement(_SpecificationTable2.default, {
                          tableStyle: { marginTop: '0' },
                          type: 'projects',
                          data: editData.specifications,
                          editable: this.hasAccess(),
                          headerNode: t('Project Information'),
                          loading: this.state.loading,
                          onChange: this.handleSpecificationsChange,
                          onClick: this.handleUpdateProject,
                          onCancel: this.handleResetProject,
                          notFoundNode: _react2.default.createElement(
                            'p',
                            null,
                            t('No information set'),
                            '.'
                          ),
                          onAdd: function onAdd() {
                            return store.dispatch((0, _reactRouterRedux.push)('/projects/' + _this6.props.id + '/edit/#specifications'));
                          }
                        })
                      )
                    ) : null
                  )
                )
              )
            )
          ),
          this.hasAccess(data.overviewTitle || data.overviewSubTitle || data.overviewExtLinkUrl || data.overview) ? _react2.default.createElement(
            _semanticUiReact.Divider,
            { horizontal: true },
            t('Project Description')
          ) : null,
          this.hasAccess(data.overviewTitle || data.overviewSubTitle || data.overviewExtLinkUrl || data.overview) ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Container,
                { textAlign: 'justified' },
                _react2.default.createElement(_EditableBox2.default, {
                  hideBorder: true,
                  editable: this.hasAccess(),
                  loading: this.state.loading,
                  onClick: this.handleUpdateProject,
                  onCancel: this.handleResetProject,
                  content: function content(_ref3) {
                    var isEditing = _ref3.isEditing,
                        onConfirm = _ref3.onConfirm;
                    return isEditing ? _react2.default.createElement(
                      _semanticUiReact.Form,
                      { onSubmit: onConfirm },
                      _react2.default.createElement(_semanticUiReact.Form.Input, {
                        fluid: true,
                        label: t('Title'),
                        name: 'overviewTitle',
                        onChange: _this6.handleInputChange,
                        value: editData.overviewTitle
                      }),
                      _react2.default.createElement(_semanticUiReact.Form.Input, {
                        fluid: true,
                        label: t('Subtitle'),
                        name: 'overviewSubTitle',
                        onChange: _this6.handleInputChange,
                        value: editData.overviewSubTitle
                      }),
                      _react2.default.createElement(
                        _semanticUiReact.Segment,
                        { padded: true, style: { border: '1px solid rgba(34,36,38,0.15)', borderRadius: 8, marginBottom: '1rem' } },
                        _react2.default.createElement(
                          _semanticUiReact.Form.Field,
                          null,
                          _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(_semanticUiReact.Icon, { name: 'external alternate' }),
                            ' ',
                            t('externalLink')
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { widths: 'equal' },
                            _react2.default.createElement(_semanticUiReact.Form.Input, {
                              width: 6,
                              label: t('buttonName', { ns: _translation.TRANSLATION_FILES.screens }),
                              name: 'overviewExtLinkTitle',
                              value: editData.overviewExtLinkTitle || '',
                              onChange: _this6.handleInputChange
                            }),
                            _react2.default.createElement(_semanticUiReact.Form.Input, {
                              width: 10,
                              label: t('linkUrl', { ns: _translation.TRANSLATION_FILES.screens }),
                              name: 'overviewExtLinkUrl',
                              value: editData.overviewExtLinkUrl || '',
                              onChange: _this6.handleInputChange
                            })
                          )
                        )
                      ),
                      _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                        label: t('Description'),
                        name: 'overview',
                        value: editData.overview,
                        onChange: _this6.handleInputChange
                      })
                    ) : _react2.default.createElement(
                      _ContentPlaceholder2.default,
                      {
                        header: true,
                        subheader: true,
                        paragraphs: true,
                        loading: _this6.state.loading,
                        expandable: true
                      },
                      data.overviewTitle || data.overviewSubTitle ? _react2.default.createElement(_semanticUiReact.Header, {
                        as: 'h2',
                        content: data.overviewTitle || data.overviewSubTitle,
                        subheader: data.overviewTitle ? data.overviewSubTitle : null
                      }) : null,
                      data.overviewExtLinkUrl ? _react2.default.createElement(
                        _semanticUiReact.Button,
                        {
                          href: (0, _url.sanitizeUrl)(data.overviewExtLinkUrl),
                          target: '_blank',
                          rel: 'noopener noreferrer',
                          primary: true,
                          compact: true,
                          style: { marginBottom: '0.5rem' }
                        },
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'external alternate' }),
                        data.overviewExtLinkTitle
                      ) : null,
                      data.overview ? _react2.default.createElement(_MarkdownText2.default, { content: data.overview }) : _react2.default.createElement(
                        _semanticUiReact.Segment,
                        { textAlign: 'center' },
                        _react2.default.createElement(
                          'p',
                          null,
                          t('Description not set'),
                          '.'
                        ),
                        _react2.default.createElement(_semanticUiReact.Button, {
                          as: _reactRouter.Link,
                          primary: true, compact: true,
                          disabled: _this6.state.loading,
                          to: '/projects/' + _this6.props.id + '/edit/#overview',
                          content: t('Click here to add')
                        })
                      )
                    );
                  }
                })
              )
            )
          ) : null,
          this.hasAccess(data.unitLayouts && data.unitLayouts.length > 0) ? _react2.default.createElement(
            _semanticUiReact.Divider,
            { horizontal: true },
            t('Layouts')
          ) : null,
          this.hasAccess(data.unitLayouts && data.unitLayouts.length > 0) ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Segment.Group,
                null,
                data.unitLayouts && data.unitLayouts.length > 0 ? data.unitLayouts.map(function (unitLayout, key) {
                  return _react2.default.createElement(_UnitLayoutItem2.default, _extends({
                    key: key,
                    isMobile: _this6.state.unitLayoutResize,
                    loading: _this6.state.loading,
                    buttonNode: function buttonNode(_ref4) {
                      var loading = _ref4.loading;
                      return _react2.default.createElement(
                        _semanticUiReact.Button.Group,
                        {
                          fluid: true,
                          floated: 'right',
                          widths: 2 + (unitLayout.virtualTourURL !== '' ? 1 : 0) + (canReserve ? 1 : 0),
                          basic: true,
                          primary: true
                        },
                        unitLayout.virtualTourURL !== '' ? _react2.default.createElement(_semanticUiReact.Button, {
                          as: 'a',
                          content: t('Virtual Tour'),
                          disabled: loading,
                          href: unitLayout.virtualTourURL,
                          target: '_blank',
                          rel: 'noopener noreferrer',
                          className: 'button-reduce-spacing'
                        }) : null,
                        _react2.default.createElement(_semanticUiReact.Button, {
                          as: _reactRouter.Link,
                          content: t('View', { ns: _translation.TRANSLATION_FILES.translation }),
                          disabled: loading,
                          to: '/projects/' + _this6.props.id + '/layouts/' + unitLayout.id + '/',
                          className: 'button-reduce-spacing'
                        }),
                        canReserve ? _react2.default.createElement(_semanticUiReact.Button, {
                          content: t('Reserve'),
                          disabled: loading,
                          onClick: function onClick(e) {
                            return _this6.handleOpenBookUnit(e, unitLayout);
                          },
                          className: 'button-reduce-spacing'
                        }) : null,
                        _react2.default.createElement(_semanticUiReact.Button, {
                          content: t('Compare'),
                          disabled: loading,
                          as: _reactRouter.Link,
                          to: '/projects/' + _this6.props.id + '/layouts/compare/?layoutID=' + unitLayout.id,
                          className: 'button-reduce-spacing'
                        })
                      );
                    },
                    project: data
                  }, unitLayout));
                }) : _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { textAlign: 'center' },
                  _react2.default.createElement(
                    'p',
                    null,
                    t('No unit layouts found'),
                    '.'
                  ),
                  _react2.default.createElement(_semanticUiReact.Button, {
                    as: _reactRouter.Link,
                    primary: true, compact: true,
                    disabled: this.state.loading,
                    to: '/projects/' + this.props.id + '/layouts/',
                    content: t('Click here to add')
                  })
                )
              )
            )
          ) : null,
          this.hasAccess(data.projectPictures && data.projectPictures.length > 0 && data.projectPictures.some(function (pp) {
            return pp.picture.type !== 'map';
          })) ? _react2.default.createElement(
            _semanticUiReact.Divider,
            { horizontal: true },
            t('Gallery')
          ) : null,
          this.hasAccess(data.projectPictures && data.projectPictures.length > 0 && data.projectPictures.some(function (pp) {
            return pp.picture.type !== 'map';
          }) || data.medias && data.medias.length > 0) ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_GalleryList2.default, {
                editable: this.hasAccess(),
                pictures: [].concat(data.projectPictures || [], data.medias || []),
                projectID: this.props.id,
                loading: this.state.loading,
                excludeType: ['map'],
                tabular: this.state.galleryIsTab,
                onViewLarge: this.handleViewLargeSlide,
                onChange: this.handleGetPicture,
                addPath: '/projects/' + this.props.id + '/pictures/',
                addVideoPath: '/projects/' + this.props.id + '/videos/'
              })
            )
          ) : null,
          this.hasAccess(data.documents && data.documents.length > 0) ? _react2.default.createElement(
            _semanticUiReact.Divider,
            { horizontal: true },
            t('Documents')
          ) : null,
          this.hasAccess(data.documents && data.documents.length > 0) ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Segment.Group,
                null,
                data.documents && data.documents.length > 0 ? data.documents.map(function (file, idx) {
                  return _react2.default.createElement(
                    _semanticUiReact.Segment,
                    { key: idx },
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      {
                        columns: 'equal',
                        verticalAlign: 'middle',
                        as: 'a',
                        href: _config2.default.get('bookApiURL') + '/documents/' + file.id + '/view/' + encodeURIComponent(file.name) + '.pdf',
                        target: '_blank',
                        rel: 'noopener noreferrer'
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        null,
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'file pdf outline' }),
                        file.name,
                        _react2.default.createElement(
                          'span',
                          { className: 'mobile-hide' },
                          ' (',
                          (0, _fileSize2.default)(file.size),
                          ')'
                        ),
                        _react2.default.createElement(
                          'small',
                          { className: 'large-hide small-hide tablet-hide' },
                          _react2.default.createElement('br', null),
                          (0, _fileSize2.default)(file.size)
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { textAlign: 'right' },
                        _react2.default.createElement(
                          'small',
                          null,
                          _react2.default.createElement(_Timestamp2.default, { format: 'DD/MM/YY hh:mm a', timestamp: file.createdAt })
                        )
                      )
                    )
                  );
                }) : _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { textAlign: 'center' },
                  _react2.default.createElement(
                    'p',
                    null,
                    t('No documents found'),
                    '.'
                  ),
                  _react2.default.createElement(_semanticUiReact.Button, {
                    as: _reactRouter.Link,
                    primary: true, compact: true,
                    disabled: this.state.loading,
                    to: '/projects/' + this.props.id + '/documents/',
                    content: t('Click here to add')
                  })
                )
              )
            )
          ) : null,
          _react2.default.createElement(
            _semanticUiReact.Divider,
            { horizontal: true },
            t('Location')
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            (this.getMapPicture(data.projectPictures) || this.hasAccess()) && _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 8, stretched: true },
              _react2.default.createElement(_LoadImage2.default, {
                fluid: true,
                cover: 'long',
                centered: true,
                onClick: function onClick(e) {
                  return _this6.handleViewLarge(e, _this6.getMapPicture(data.projectPictures));
                },
                labelNode: this.hasAccess() && _react2.default.createElement(_semanticUiReact.Label, {
                  as: _reactRouter.Link,
                  attached: 'top right',
                  size: 'small',
                  content: t('Edit', { ns: _translation.TRANSLATION_FILES.translation }),
                  icon: 'pencil',
                  to: '/projects/' + this.props.id + '/pictures/',
                  disabled: this.state.loading
                }),
                notFoundNode: _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'p',
                    null,
                    t('No map found'),
                    '.'
                  ),
                  this.hasAccess() && _react2.default.createElement(_semanticUiReact.Button, {
                    as: _reactRouter.Link,
                    primary: true, compact: true,
                    disabled: this.state.loading,
                    to: '/projects/' + this.props.id + '/pictures/?tab=map',
                    content: t('Click here to add')
                  })
                ),
                picture: this.getMapPicture(data.projectPictures),
                pictureSize: 70
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { stretched: true },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 'equal', stackable: this.state.locationResize },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Header, { icon: 'map marker alternate', content: t('Address') }),
                  _react2.default.createElement(
                    _ContentPlaceholder2.default,
                    {
                      paragraphs: true,
                      loading: this.state.loading
                    },
                    _react2.default.createElement('p', {
                      dangerouslySetInnerHTML: { __html: data.fullAddressHTML }
                    })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Header, { icon: 'phone', content: t('Phone') }),
                  _react2.default.createElement(
                    _ContentPlaceholder2.default,
                    {
                      paragraphs: 1,
                      loading: this.state.loading
                    },
                    data.phone ? _react2.default.createElement(_Phone2.default, {
                      mobilePrefix: data.phonePrefix,
                      mobile: data.phone
                    }) : '-'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Overview;
}(_react.Component);

Overview.propTypes = {
  id: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isSiteplan: _propTypes2.default.bool
  }),
  data: _propTypes2.default.shape({
    projectPictures: _propTypes2.default.array,
    gps: _propTypes2.default.string,
    maOwnerCompanyBranchID: _propTypes2.default.number
  }),
  onCheck: _propTypes2.default.func,
  token: _propTypes2.default.string,
  t: _propTypes2.default.func
};
Overview.contextTypes = {
  store: _propTypes2.default.object
};

Overview.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

Overview.getPropsToState = function (props) {
  var data = props.data || {};
  var editData = JSON.parse(JSON.stringify(data));
  var loading = props.loading;
  var menuIsTab = window.innerWidth <= 590;
  var unitLayoutResize = window.innerWidth < 768;
  var galleryIsTab = window.innerWidth > 425;
  var locationResize = window.innerWidth <= 375;
  return {
    data: data,
    editData: editData,
    loading: loading,
    menuIsTab: menuIsTab,
    unitLayoutResize: unitLayoutResize,
    galleryIsTab: galleryIsTab,
    locationResize: locationResize
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.getCoverPicture = function (pictures) {
    if (pictures && pictures.length > 0 && pictures.some(function (pp) {
      return pp.isCover === true;
    })) {
      return pictures.find(function (pp) {
        return pp.isCover === true;
      }).picture;
    }
    return null;
  };

  this.getMapPicture = function (pictures) {
    if (pictures && pictures.length > 0 && pictures.some(function (pp) {
      return pp.type === 'map';
    })) {
      return pictures.find(function (pp) {
        return pp.type === 'map';
      }).picture;
    }
    return null;
  };

  this.handleOnCheck = function () {
    var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (_this7.props.onCheck) {
      _this7.props.onCheck(hasChanges);
    }
  };

  this.handleResize = function () {
    var state = {};
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this7.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    var unitLayoutResize = window.innerWidth < 768;
    if (unitLayoutResize !== _this7.state.unitLayoutResize) {
      state.unitLayoutResize = unitLayoutResize;
    }
    var galleryIsTab = window.innerWidth > 425;
    if (galleryIsTab !== _this7.state.galleryIsTab) {
      state.galleryIsTab = galleryIsTab;
    }
    var locationResize = window.innerWidth <= 375;
    if (locationResize !== _this7.state.locationResize) {
      state.locationResize = locationResize;
    }
    _this7.setState(_extends({}, state));
  };

  this.handleCloseLarge = function (e) {
    e.preventDefault();
    _this7.setState({
      showLarge: false,
      selectedPicture: null,
      slideshow: false
    });
  };

  this.handleViewLarge = function (e, data) {
    e.preventDefault();
    _this7.setState({
      selectedPicture: data,
      showLarge: true,
      slideshow: false,
      viewLargeType: 'picture'
    });
  };

  this.handleViewLargeSlide = function (e, data) {
    var viewLargeType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'picture';

    e.preventDefault();
    _this7.setState({
      selectedPicture: data,
      showLarge: true,
      slideshow: true,
      viewLargeType: viewLargeType
    });
  };

  this.handleMenu = function (e, _ref5) {
    var value = _ref5.value;
    var store = _this7.context.store;

    if (value.includes(_config2.default.get('bookApiURL')) || value.includes(_config2.default.get('salesChartURL'))) {
      e.preventDefault();
      var winObj = window.open(value, '_blank');
      winObj.opener = null;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(value));
    }
  };

  this.handleCloseBookUnit = function (e) {
    e.preventDefault();
    _this7.setState({
      showBookUnit: false,
      unitLayout: null
    });
  };

  this.handleOpenBookUnit = function (e, unitLayout) {
    e.preventDefault();
    _this7.setState({
      unitLayout: unitLayout,
      showBookUnit: true
    });
  };

  this.handleUnitClick = function (e, _ref6) {
    var unit = _ref6.unit;
    var store = _this7.context.store;

    store.dispatch((0, _reactRouterRedux.push)('/projects/' + _this7.props.id + '/units/' + unit.id + '/'));
  };

  this.handleSpecificationsChange = function (data) {
    var editData = _this7.state.editData;

    editData.specifications = data;
    _this7.setState({ editData: editData }, function () {
      _this7.handleCheckChanges();
    });
  };

  this.handleInputChange = function (event, data) {
    var editData = _this7.state.editData;

    editData[data.name] = data.value;
    _this7.setState({ editData: editData }, function () {
      _this7.handleCheckChanges();
    });
  };

  this.handleUpdateProject = function () {
    var _state3 = _this7.state,
        data = _state3.data,
        editData = _state3.editData;

    if (editData.specifications) {
      editData.specifications = editData.specifications.filter(function (d) {
        return d.name.length > 0 && d.value.length > 0;
      }).map(function (d, idx) {
        return _extends({}, d, {
          position: idx + 1
        });
      });
    }
    if (JSON.stringify(editData) !== JSON.stringify(data)) {
      _this7.updateProject(editData);
    }
    _this7.handleResetProject();
  };

  this.handleResetProject = function () {
    var editData = JSON.parse(JSON.stringify(_this7.state.data));
    _this7.setState({ editData: editData }, function () {
      _this7.handleResetCheck();
    });
  };

  this.handleGetPicture = function (pictures) {
    _this7.setState({ pictures: pictures });
  };

  this.handleSlidePicture = function (e) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
    var _state4 = _this7.state,
        pictures = _state4.pictures,
        selectedPicture = _state4.selectedPicture;

    var index = pictures.indexOf(selectedPicture);
    var nextIndex = direction === 'left' ? index - 1 : index + 1;
    _this7.setState({
      selectedPicture: pictures[nextIndex]
    });
  };

  this.handleShowModalConfirm = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this7.setState({
      showModalConfirm: true
    });
  };

  this.handleCloseModalConfirm = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this7.setState({
      showModalConfirm: false
    });
  };

  this.handleDuplicatesProject = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this7.setState({ showModalConfirm: false }, function () {
      _this7.duplicatesProject();
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Overview.mapStateToProps)(Overview));

/***/ }),
/* 2398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _reactRouterRedux = __webpack_require__(13);

var _reactRedux = __webpack_require__(9);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _SortablePackagePricing = __webpack_require__(2205);

var _SortablePackagePricing2 = _interopRequireDefault(_SortablePackagePricing);

var _navigations = __webpack_require__(117);

var _vietnam = __webpack_require__(40);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PackagePricing = function (_Component) {
  _inherits(PackagePricing, _Component);

  function PackagePricing(props) {
    _classCallCheck(this, PackagePricing);

    var _this = _possibleConstructorReturn(this, (PackagePricing.__proto__ || Object.getPrototypeOf(PackagePricing)).call(this, props));

    _initialiseProps.call(_this);

    var state = PackagePricing.getPropsToState(props);
    _this.state = _extends({}, state, {
      data: [],
      hasChanges: false,
      isEditing: false,
      token: ''
    });
    return _this;
  }

  _createClass(PackagePricing, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchProjectPackagePricings();
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = PackagePricing.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'fetchProjectPackagePricings',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/package_pricings/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                return _context.abrupt('return');

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 32;
                break;

              case 26:
                token = res.headers.get('X-Csrf-Token');
                _context.next = 29;
                return res.json();

              case 29:
                data = _context.sent;
                _context.next = 32;
                return this.setComponentState({
                  token: token,
                  data: data || []
                });

              case 32:
                _context.next = 34;
                return this.setLoading(false);

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchProjectPackagePricings() {
        return _ref.apply(this, arguments);
      }

      return fetchProjectPackagePricings;
    }()
  }, {
    key: 'updateProjectPackagePricings',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, tidyData, res, message, _message, data, hasBackgroundQueue, _message2;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                tidyData = this.tidyData(this.state.data);
                res = void 0;
                _context2.prev = 5;
                _context2.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/package_pricings/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(tidyData)
                }));

              case 8:
                res = _context2.sent;
                _context2.next = 25;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](5);
                _context2.next = 15;
                return this.setLoading(false);

              case 15:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 21;
                  break;
                }

                _context2.next = 18;
                return _context2.t0.res.text();

              case 18:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 21:
                Bugsnag.notifyException(_context2.t0);
                _context2.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 24:
                return _context2.abrupt('return');

              case 25:
                if (res.ok) {
                  _context2.next = 33;
                  break;
                }

                _context2.next = 28;
                return res.text();

              case 28:
                _message = _context2.sent;
                _context2.next = 31;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 31:
                _context2.next = 44;
                break;

              case 33:
                _context2.next = 35;
                return res.json();

              case 35:
                data = _context2.sent;
                _context2.next = 38;
                return this.setComponentState({
                  data: data || [],
                  hasChanges: false
                });

              case 38:
                this.handleOnCheck(false);
                hasBackgroundQueue = res.headers.get('X-Has-Background-Queue');
                _message2 = 'Pricing package successfully updated';

                if (hasBackgroundQueue === 'true') _message2 = 'Pricing package template successfully updated, Units are still being updated in the background, you will recevied an email upon completion.';
                _context2.next = 44;
                return store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Update Success', message: _message2, autoHideDuration: 8000 }));

              case 44:
                _context2.next = 46;
                return this.setLoading(false);

              case 46:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 11]]);
      }));

      function updateProjectPackagePricings() {
        return _ref2.apply(this, arguments);
      }

      return updateProjectPackagePricings;
    }()
  }, {
    key: 'deleteProjectPackagePricing',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id, callBack) {
        var store, res, message, _message3;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context3.prev = 4;
                _context3.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/package_pricings/' + id + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  }
                }));

              case 7:
                res = _context3.sent;
                _context3.next = 24;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](4);
                _context3.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 20;
                  break;
                }

                _context3.next = 17;
                return _context3.t0.res.text();

              case 17:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 20:
                Bugsnag.notifyException(_context3.t0);
                _context3.next = 23;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 23:
                return _context3.abrupt('return');

              case 24:
                if (res.ok) {
                  _context3.next = 32;
                  break;
                }

                _context3.next = 27;
                return res.text();

              case 27:
                _message3 = _context3.sent;
                _context3.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message3 }));

              case 30:
                _context3.next = 34;
                break;

              case 32:
                _context3.next = 34;
                return store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Delete Success', message: 'Pricing package successfully deleted' }));

              case 34:
                _context3.next = 36;
                return this.setLoading(false);

              case 36:
                if (callBack) callBack();

              case 37:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 10]]);
      }));

      function deleteProjectPackagePricing(_x2, _x3) {
        return _ref3.apply(this, arguments);
      }

      return deleteProjectPackagePricing;
    }()
  }, {
    key: 'deleteProjectPackagePricingItem',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id, itemID, callBack) {
        var store, res, message, _message4;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context4.prev = 4;
                _context4.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/package_pricings/' + id + '/items/' + itemID + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  }
                }));

              case 7:
                res = _context4.sent;
                _context4.next = 24;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](4);
                _context4.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context4.t0.res && _context4.t0.res.status >= 400 && _context4.t0.res.status < 500)) {
                  _context4.next = 20;
                  break;
                }

                _context4.next = 17;
                return _context4.t0.res.text();

              case 17:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context4.abrupt('return');

              case 20:
                Bugsnag.notifyException(_context4.t0);
                _context4.next = 23;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 23:
                return _context4.abrupt('return');

              case 24:
                if (res.ok) {
                  _context4.next = 32;
                  break;
                }

                _context4.next = 27;
                return res.text();

              case 27:
                _message4 = _context4.sent;
                _context4.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message4 }));

              case 30:
                _context4.next = 34;
                break;

              case 32:
                _context4.next = 34;
                return store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Delete Success', message: 'Pricing package successfully deleted' }));

              case 34:
                _context4.next = 36;
                return this.setLoading(false);

              case 36:
                if (callBack) callBack();

              case 37:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 10]]);
      }));

      function deleteProjectPackagePricingItem(_x4, _x5, _x6) {
        return _ref4.apply(this, arguments);
      }

      return deleteProjectPackagePricingItem;
    }()
  }, {
    key: 'updateProject',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(data) {
        var store, res, message, _message5, projectData;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context5.prev = 4;
                _context5.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.projectToken
                  },
                  body: JSON.stringify(data)
                }));

              case 7:
                res = _context5.sent;
                _context5.next = 24;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](4);
                _context5.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context5.t0.res && _context5.t0.res.status >= 400 && _context5.t0.res.status < 500)) {
                  _context5.next = 20;
                  break;
                }

                _context5.next = 17;
                return _context5.t0.res.text();

              case 17:
                message = _context5.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context5.abrupt('return');

              case 20:
                Bugsnag.notifyException(_context5.t0);
                _context5.next = 23;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 23:
                return _context5.abrupt('return');

              case 24:
                if (res.ok) {
                  _context5.next = 32;
                  break;
                }

                _context5.next = 27;
                return res.text();

              case 27:
                _message5 = _context5.sent;
                _context5.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message5 }));

              case 30:
                _context5.next = 39;
                break;

              case 32:
                _context5.next = 34;
                return res.json();

              case 34:
                projectData = _context5.sent;
                _context5.next = 37;
                return this.setComponentState({
                  projectData: projectData || this.props.data
                });

              case 37:
                _context5.next = 39;
                return store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Update Success', message: 'Default pricing package successfully updated' }));

              case 39:
                _context5.next = 41;
                return this.setLoading(false);

              case 41:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[4, 10]]);
      }));

      function updateProject(_x7) {
        return _ref5.apply(this, arguments);
      }

      return updateProject;
    }()
  }, {
    key: 'bulkManageUnitsPP',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(isAdd, id) {
        var store, res, message, _message6;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context6.prev = 4;
                _context6.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/package_pricings/' + id + '/apply_units/', {
                  credentials: 'include',
                  method: isAdd ? 'POST' : 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  }
                }));

              case 7:
                res = _context6.sent;
                _context6.next = 24;
                break;

              case 10:
                _context6.prev = 10;
                _context6.t0 = _context6['catch'](4);
                _context6.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context6.t0.res && _context6.t0.res.status >= 400 && _context6.t0.res.status < 500)) {
                  _context6.next = 20;
                  break;
                }

                _context6.next = 17;
                return _context6.t0.res.text();

              case 17:
                message = _context6.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context6.abrupt('return');

              case 20:
                Bugsnag.notifyException(_context6.t0);
                _context6.next = 23;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 23:
                return _context6.abrupt('return');

              case 24:
                if (res.ok) {
                  _context6.next = 32;
                  break;
                }

                _context6.next = 27;
                return res.text();

              case 27:
                _message6 = _context6.sent;
                _context6.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message6 }));

              case 30:
                _context6.next = 34;
                break;

              case 32:
                _context6.next = 34;
                return store.dispatch((0, _flash.flashSuccessMessage)({ header: isAdd ? 'Add Success' : 'Remove Success', message: isAdd ? 'Pricing package successfully added to all units' : 'Pricing package successfully removed from all units' }));

              case 34:
                _context6.next = 36;
                return this.setLoading(false);

              case 36:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[4, 10]]);
      }));

      function bulkManageUnitsPP(_x8, _x9) {
        return _ref6.apply(this, arguments);
      }

      return bulkManageUnitsPP;
    }()
  }, {
    key: 'bulkUpdateUnitsPP',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(id) {
        var store, res, message, _message7;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context7.prev = 4;
                _context7.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/package_pricings/' + id + '/recalculate_units/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  }
                }));

              case 7:
                res = _context7.sent;
                _context7.next = 24;
                break;

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7['catch'](4);
                _context7.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context7.t0.res && _context7.t0.res.status >= 400 && _context7.t0.res.status < 500)) {
                  _context7.next = 20;
                  break;
                }

                _context7.next = 17;
                return _context7.t0.res.text();

              case 17:
                message = _context7.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context7.abrupt('return');

              case 20:
                Bugsnag.notifyException(_context7.t0);
                _context7.next = 23;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 23:
                return _context7.abrupt('return');

              case 24:
                if (res.ok) {
                  _context7.next = 32;
                  break;
                }

                _context7.next = 27;
                return res.text();

              case 27:
                _message7 = _context7.sent;
                _context7.next = 30;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message7 }));

              case 30:
                _context7.next = 34;
                break;

              case 32:
                _context7.next = 34;
                return store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Update Success', message: 'Pricing package successfully updated in all units' }));

              case 34:
                _context7.next = 36;
                return this.setLoading(false);

              case 36:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[4, 10]]);
      }));

      function bulkUpdateUnitsPP(_x10) {
        return _ref7.apply(this, arguments);
      }

      return bulkUpdateUnitsPP;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          auth = _props.auth,
          id = _props.id,
          location = _props.location;
      var _state = this.state,
          data = _state.data,
          isEditing = _state.isEditing,
          loading = _state.loading,
          projectData = _state.projectData;
      var pathname = location.pathname;

      var companyServiceID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
      var isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
      var links = (0, _navigations.editRoutes)(id, this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled, isMalaysia, companyServiceID);
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              disabled: loading,
              key: key,
              name: link.text,
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this3.handleMenu(e, link);
              }
            });
          }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              onClick: this.handleUpdate,
              disabled: loading || isEditing || !this.state.hasChanges,
              positive: true,
              content: 'Save'
            })
          )
        }),
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          { style: { zIndex: 20 }, active: loading, inverted: true },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            'Loading'
          )
        ),
        _react2.default.createElement(_SortablePackagePricing2.default, {
          data: data,
          handleBulkManageUnits: this.handleBulkManageUnits,
          handleBulkUpdateUnits: this.handleBulkUpdateUnits,
          handleDelete: this.handleDelete,
          handleDeleteItem: this.handleDeleteItem,
          isVietnam: (0, _vietnam.isVietnamCompany)(auth),
          onChangeData: this.handleOnChange,
          onEdit: this.handleOnEdit
        }),
        _react2.default.createElement(
          _semanticUiReact.Segment,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { textAlign: 'center', className: 'row_default_pricing' },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 16 },
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  { as: 'h4', className: 'header_title' },
                  'Default Pricing Package Settings'
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 8, computer: 8, verticalAlign: 'middle' },
                      _react2.default.createElement(
                        'div',
                        { className: 'label_dropdown_pricing_package' },
                        'Default Pricing Package'
                      ),
                      _react2.default.createElement(_semanticUiReact.Dropdown, {
                        fluid: true,
                        onChange: this.handleChangeDefaultPackage,
                        options: this.getPackagePricingOptions(),
                        placeholder: 'Disabled',
                        search: true,
                        selection: true,
                        upward: true,
                        value: projectData.defaultProjectPackagePricingID,
                        name: 'defaultProjectPackagePricingID'

                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 8, computer: 8, verticalAlign: 'middle' },
                      _react2.default.createElement(
                        'div',
                        { className: 'label_dropdown_pricing_package' },
                        'Default Bumi Unit Pricing Package'
                      ),
                      _react2.default.createElement(_semanticUiReact.Dropdown, {
                        fluid: true,
                        onChange: this.handleChangeDefaultPackage,
                        options: this.getPackagePricingOptions(),
                        placeholder: 'Disabled',
                        search: true,
                        selection: true,
                        upward: true,
                        value: projectData.defaultBumiProjectPackagePricingID,
                        name: 'defaultBumiProjectPackagePricingID'
                      })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return PackagePricing;
}(_react.Component);

PackagePricing.contextTypes = {
  store: _propTypes2.default.object
};
PackagePricing.propTypes = {
  id: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  data: _propTypes2.default.shape(),
  onCheck: _propTypes2.default.func,
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      lawyerIsEnabled: _propTypes2.default.bool
    })
  }),
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.object
  })
};

PackagePricing.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

PackagePricing.getPropsToState = function (props) {
  var projectData = props.data || {};
  var projectToken = props.token || '';
  var loading = props.loading;
  var menuIsTab = window.innerWidth <= 590;
  return {
    loading: loading,
    menuIsTab: menuIsTab,
    oriProjectData: (0, _clone2.default)(projectData),
    projectData: projectData,
    projectToken: projectToken
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this4.setState({ loading: loading }, function () {
        res(loading);
      });
    });
  };

  this.getPackagePricingOptions = function () {
    var data = _this4.state.data;

    var options = [{
      text: 'Disabled',
      value: ''
    }];
    data.forEach(function (d) {
      if (d.id !== '') {
        options.push({
          disabled: !d.isEnabled || (0, _momentTimezone2.default)(d.scheduleEndAt).unix() < (0, _momentTimezone2.default)().unix() // expired package
          ,
          text: d.name,
          value: d.id
        });
      }
    });
    return options;
  };

  this.tidyData = function (datas) {
    var newDatas = [];
    datas.forEach(function (d) {
      var data = d;
      // remove timezone from date object (because API server has default timezone set)
      if (data.scheduleStartAt) data.scheduleStartAt = (0, _momentTimezone2.default)(data.scheduleStartAt).format('YYYY-MM-DDTHH:mm:ss') + 'Z';
      if (data.scheduleEndAt) data.scheduleEndAt = (0, _momentTimezone2.default)(data.scheduleEndAt).format('YYYY-MM-DDTHH:mm:ss') + 'Z';
      newDatas.push(data);
    });
    return newDatas;
  };

  this.handleChangeDefaultPackage = function (e, data) {
    var projectData = _this4.state.projectData;

    if (projectData[data.name] !== data.value) {
      projectData[data.name] = data.value;
      _this4.updateProject(projectData);
    }
  };

  this.handleResize = function () {
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this4.state.menuIsTab) {
      _this4.setState({ menuIsTab: menuIsTab });
    }
  };

  this.handleMenu = function (e, _ref8) {
    var value = _ref8.value;
    var store = _this4.context.store;

    if (value.includes(_config2.default.get('developerURL'))) {
      e.preventDefault();
      window.location.href = value;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(value));
    }
  };

  this.handleOnChange = function (data) {
    _this4.setState({ data: data, hasChanges: true }, function () {
      _this4.handleOnCheck(true);
    });
  };

  this.handleOnEdit = function (isEditing, data) {
    var hasChanges = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    _this4.setState({
      data: data,
      hasChanges: hasChanges ? true : _this4.state.hasChanges,
      isEditing: isEditing
    }, function () {
      if (hasChanges) _this4.handleOnCheck(true);
    });
  };

  this.handleOnCheck = function () {
    var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var callback = arguments[1];

    if (_this4.props.onCheck) {
      _this4.props.onCheck(hasChanges, callback);
    }
  };

  this.handleUpdate = function (e) {
    if (e) e.preventDefault();
    _this4.updateProjectPackagePricings();
  };

  this.handleDelete = function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(id, callBack) {
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return _this4.deleteProjectPackagePricing(id, callBack);

            case 2:
            case 'end':
              return _context8.stop();
          }
        }
      }, _callee8, _this4);
    }));

    return function (_x14, _x15) {
      return _ref9.apply(this, arguments);
    };
  }();

  this.handleDeleteItem = function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(id, itemID, callBack) {
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              _context9.next = 2;
              return _this4.deleteProjectPackagePricingItem(id, itemID, callBack);

            case 2:
            case 'end':
              return _context9.stop();
          }
        }
      }, _callee9, _this4);
    }));

    return function (_x16, _x17, _x18) {
      return _ref10.apply(this, arguments);
    };
  }();

  this.handleBulkManageUnits = function (isAdd, id) {
    return _this4.bulkManageUnitsPP(isAdd, id);
  };

  this.handleBulkUpdateUnits = function (id) {
    return _this4.bulkUpdateUnitsPP(id);
  };
};

exports.default = (0, _reactRedux.connect)(PackagePricing.mapStateToProps)(PackagePricing);

/***/ }),
/* 2399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRouterRedux = __webpack_require__(13);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _reactRedux = __webpack_require__(9);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _ProjectPanelBankers = __webpack_require__(2170);

var _ProjectPanelBankers2 = _interopRequireDefault(_ProjectPanelBankers);

var _navigations = __webpack_require__(117);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PanelBankers = function (_Component) {
  _inherits(PanelBankers, _Component);

  function PanelBankers(props) {
    _classCallCheck(this, PanelBankers);

    var _this = _possibleConstructorReturn(this, (PanelBankers.__proto__ || Object.getPrototypeOf(PanelBankers)).call(this, props));

    _initialiseProps.call(_this);

    var state = PanelBankers.getPropsToState(props);
    _this.state = _extends({}, state, {
      oriData: [],
      data: [],
      token: null,
      hasChanges: false,
      hasProjectChanges: false,
      hasBankerChanges: false
    });
    return _this;
  }

  _createClass(PanelBankers, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchProjectPanelBankers();
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = PanelBankers.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'fetchProjectPanelBankers',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, token, panelBankers;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/bankers/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                return _context.abrupt('return');

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 34;
                break;

              case 26:
                token = res.headers.get('X-Csrf-Token');
                _context.next = 29;
                return res.json();

              case 29:
                panelBankers = _context.sent;
                _context.next = 32;
                return this.setBankers(panelBankers);

              case 32:
                _context.next = 34;
                return this.setComponentState({
                  token: token
                });

              case 34:
                _context.next = 36;
                return this.setLoading(false);

              case 36:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchProjectPanelBankers() {
        return _ref.apply(this, arguments);
      }

      return fetchProjectPanelBankers;
    }()
  }, {
    key: 'updateProject',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this3 = this;

        var store, project, res, message, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                project = this.state.project;
                _context2.next = 4;
                return this.setLoading(true);

              case 4:
                res = void 0;
                _context2.prev = 5;
                _context2.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(project)
                }));

              case 8:
                res = _context2.sent;
                _context2.next = 23;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](5);

                Bugsnag.notifyException(_context2.t0);

                if (!(_context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 22;
                  break;
                }

                _context2.next = 17;
                return _context2.t0.res.text();

              case 17:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                _context2.next = 21;
                return this.setLoading(false);

              case 21:
                return _context2.abrupt('return');

              case 22:
                store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));

              case 23:
                _context2.next = 25;
                return res.json();

              case 25:
                data = _context2.sent;
                _context2.next = 28;
                return this.setComponentState({ hasChanges: false, hasProjectChanges: false }, function () {
                  _this3.handleResetCheck();
                });

              case 28:
                _context2.next = 30;
                return this.setLoading(false);

              case 30:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Update Success', message: data.name + ' successfully updated' }));

              case 31:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 11]]);
      }));

      function updateProject() {
        return _ref2.apply(this, arguments);
      }

      return updateProject;
    }()
  }, {
    key: 'updateProjectPanelBankers',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var store, res, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context3.prev = 4;
                _context3.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/bankers/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(this.state.data)
                }));

              case 7:
                res = _context3.sent;
                _context3.next = 18;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](4);

                Bugsnag.notifyException(_context3.t0);
                _context3.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context3.next = 17;
                return this.setLoading(false);

              case 17:
                return _context3.abrupt('return');

              case 18:
                if (res.ok) {
                  _context3.next = 26;
                  break;
                }

                _context3.next = 21;
                return res.text();

              case 21:
                message = _context3.sent;
                _context3.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context3.next = 31;
                break;

              case 26:
                _context3.next = 28;
                return this.setComponentState({ hasChanges: false, hasBankerChanges: false });

              case 28:
                this.handleOnCheck(false);
                _context3.next = 31;
                return store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Update Success', message: 'Panel bankers successfully updated' }));

              case 31:
                _context3.next = 33;
                return this.setLoading(false);

              case 33:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[4, 10]]);
      }));

      function updateProjectPanelBankers() {
        return _ref3.apply(this, arguments);
      }

      return updateProjectPanelBankers;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          auth = _props.auth,
          id = _props.id,
          location = _props.location;
      var pathname = location.pathname;
      var _state = this.state,
          data = _state.data,
          hasChanges = _state.hasChanges,
          loading = _state.loading,
          project = _state.project;

      var companyServiceID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
      var links = (0, _navigations.editRoutes)(id, this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled, companyServiceID);
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: link.text,
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this4.handleMenu(e, link);
              }
            });
          }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              onClick: this.handleUpdate,
              disabled: loading || !hasChanges,
              positive: true,
              content: 'Save'
            })
          )
        }),
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          { style: { zIndex: 20 }, active: loading, inverted: true },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            'Loading'
          )
        ),
        _react2.default.createElement(_ProjectPanelBankers2.default, {
          auth: this.props.auth,
          allowAgentSalesTeamBankerInvitation: project ? project.allowAgentSalesTeamBankerInvitation : false,
          autoShareFormToBanker: project ? project.autoShareFormToBanker : false,
          autoAssignStatus: project && project.autoAssignBankerStatus ? project.autoAssignBankerStatus : '',
          bankerSelectionTabs: project && project.bankerSelectionTabs ? project.bankerSelectionTabs : [],
          data: data,
          defaultBookingStatusID: project ? project.defaultCustomBookingStatusID : '',
          disabled: loading,
          token: this.props.token,
          projectID: this.props.id,
          onCheckboxChange: this.handleCheckboxChange,
          onChange: this.handleOnChange,
          onStatusChange: this.handleSetAutoAssignBankerStatus
        })
      );
    }
  }]);

  return PanelBankers;
}(_react.Component);

PanelBankers.contextTypes = {
  store: _propTypes2.default.object
};
PanelBankers.propTypes = {
  id: _propTypes2.default.string,
  data: _propTypes2.default.shape({
    loanTrackerProjectID: _propTypes2.default.number
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  token: _propTypes2.default.string,
  onCheck: _propTypes2.default.func,
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      lawyerIsEnabled: _propTypes2.default.bool
    })
  }),
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.object
  })
};

PanelBankers.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

PanelBankers.getPropsToState = function (props) {
  var project = props.data;
  var loading = props.loading;
  var menuIsTab = window.innerWidth <= 590;
  return {
    loading: loading,
    menuIsTab: menuIsTab,
    project: project
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.setBankers = function () {
    var oriData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    return new Promise(function (res) {
      _this5.setState({
        oriData: oriData,
        data: (0, _clone2.default)(oriData)
      }, function () {
        res(oriData);
      });
    });
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    return new Promise(function (res) {
      _this5.setState({ loading: loading }, function () {
        res(loading);
      });
    });
  };

  this.handleResize = function () {
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this5.state.menuIsTab) {
      _this5.setState({ menuIsTab: menuIsTab });
    }
  };

  this.handleMenu = function (e, _ref4) {
    var value = _ref4.value;
    var store = _this5.context.store;

    if (value.includes(_config2.default.get('developerURL'))) {
      e.preventDefault();
      window.location.href = value;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(value));
    }
  };

  this.handleOnChange = function (data) {
    _this5.setState({ data: data, hasChanges: true, hasBankerChanges: true }, function () {
      _this5.handleOnCheck(true);
    });
  };

  this.handleOnCheck = function () {
    var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var callback = arguments[1];

    if (_this5.props.onCheck) {
      _this5.props.onCheck(hasChanges, callback);
    }
  };

  this.handleSetAutoAssignBankerStatus = function (autoAssignStatus) {
    var project = _this5.state.project;

    project.autoAssignBankerStatus = autoAssignStatus;
    _this5.setState({ project: project, hasChanges: true, hasProjectChanges: true });
  };

  this.handleCheckboxChange = function (data) {
    var project = _this5.state.project;

    if (data === 'preferred_banker' || data === 'all') {
      var bankerSelectionTabs = [].concat(_toConsumableArray(project.bankerSelectionTabs));
      if (bankerSelectionTabs && bankerSelectionTabs.length > 0 && bankerSelectionTabs.includes(data)) {
        bankerSelectionTabs = bankerSelectionTabs.filter(function (option) {
          return option !== data;
        });
      } else {
        bankerSelectionTabs.push(data);
      }
      project.bankerSelectionTabs = bankerSelectionTabs;
    }
    if (data === 'allowAgentSalesTeamBankerInvitation') {
      project.allowAgentSalesTeamBankerInvitation = !project.allowAgentSalesTeamBankerInvitation;
    }
    if (data === 'autoShareFormToBanker') {
      project.autoShareFormToBanker = !project.autoShareFormToBanker;
    }
    _this5.setState({ project: project, hasChanges: true, hasProjectChanges: true });
  };

  this.handleUpdate = function (e) {
    if (e) {
      e.preventDefault();
    }
    var _state2 = _this5.state,
        hasBankerChanges = _state2.hasBankerChanges,
        hasProjectChanges = _state2.hasProjectChanges;

    if (hasBankerChanges) {
      _this5.updateProjectPanelBankers();
    }
    if (hasProjectChanges) {
      _this5.updateProject();
    }
  };
};

exports.default = (0, _reactRedux.connect)(PanelBankers.mapStateToProps)(PanelBankers);

/***/ }),
/* 2400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _index = __webpack_require__(172);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _navigations = __webpack_require__(117);

var _apiEndpoints = __webpack_require__(140);

var endpoints = _interopRequireWildcard(_apiEndpoints);

var _InviteLawyerForm = __webpack_require__(1078);

var _InviteLawyerForm2 = _interopRequireDefault(_InviteLawyerForm);

var _LawyersList = __webpack_require__(2518);

var _LawyersList2 = _interopRequireDefault(_LawyersList);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

var _LawyerItem = __webpack_require__(384);

var _LawyerItem2 = _interopRequireDefault(_LawyerItem);

var _ProjectPanelLawyers = __webpack_require__(1028);

var _ProjectPanelLawyers2 = _interopRequireDefault(_ProjectPanelLawyers);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PanelLawyers = function (_Component) {
  _inherits(PanelLawyers, _Component);

  function PanelLawyers(props) {
    _classCallCheck(this, PanelLawyers);

    var _this = _possibleConstructorReturn(this, (PanelLawyers.__proto__ || Object.getPrototypeOf(PanelLawyers)).call(this, props));

    _initialiseProps.call(_this);

    var state = PanelLawyers.getPropsToState(props);
    _this.state = _extends({}, state, {
      oriData: [],
      showInviteLawyer: false,
      showAddLawyer: false,
      showDeleteConfirm: false,
      selectedLawyer: null,
      panelLawyers: [],
      hasChanges: false,
      updateProjectLoading: false
    });
    _this.list = null;
    return _this;
  }

  _createClass(PanelLawyers, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = PanelLawyers.getPropsToState(nextProps);
      this.setState(state);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'updateProject',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this3 = this;

        var store, data, res, message, project;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                data = this.state.data;
                _context.next = 4;
                return this.setComponentState({ loading: true, updateProjectLoading: true });

              case 4:
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + data.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(data)
                }));

              case 8:
                res = _context.sent;
                _context.next = 21;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 17;
                return _context.t0.res.text();

              case 17:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 20:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));

              case 21:
                _context.next = 23;
                return res.json();

              case 23:
                project = _context.sent;
                _context.next = 26;
                return this.setComponentState({ loading: false, hasChanges: false, updateProjectLoading: false }, function () {
                  _this3.handleResetCheck();
                });

              case 26:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Update Success', message: project.name + ' successfully updated' }));

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function updateProject() {
        return _ref.apply(this, arguments);
      }

      return updateProject;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          auth = _props.auth,
          id = _props.id,
          location = _props.location,
          data = _props.data;
      var pathname = location.pathname;

      var companyServiceID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
      var isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
      var links = (0, _navigations.editRoutes)(id, true, isMalaysia, companyServiceID);
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: link.text,
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this4.handleMenu(e, link);
              }
            });
          }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              onClick: this.handleUpdate,
              disabled: this.state.loading || !this.state.hasChanges,
              positive: true,
              content: 'Save'
            })
          )
        }),
        _react2.default.createElement(
          _semanticUiReact.Dimmer,
          { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            'Loading'
          )
        ),
        _react2.default.createElement(_LawyersList2.default, {
          open: this.state.showAddLawyer,
          onClose: this.handleCloseAddLawyer,
          onItemClick: this.handleAddLawyer,
          onConfirm: this.handleAddLawyer,
          onCheck: function onCheck(lawyer) {
            return lawyer.panels && lawyer.panels.split(',').some(function (pid) {
              return pid === '' + data.loanTrackerProjectID;
            });
          },
          selected: this.state.panelLawyers,
          loanTrackerProjectID: data ? data.loanTrackerProjectID : 0
        }),
        _react2.default.createElement(_DeleteConfirm2.default, {
          open: this.state.showDeleteConfirm,
          onClose: this.handleCloseDeleteConfirm,
          onConfirm: this.handleDeleteLawyer,
          headerNode: 'Confirm remove panel lawyer?',
          content: _react2.default.createElement(
            'p',
            null,
            'Are you sure to remove ',
            _react2.default.createElement(
              'strong',
              null,
              this.state.selectedLawyer ? this.state.selectedLawyer.lawyer_name : ''
            ),
            ' from panel lawyers?'
          )
        }),
        _react2.default.createElement(_InviteLawyerForm2.default, {
          company: this.props.auth.company,
          ref: function ref(_ref2) {
            _this4.inviteForm = _ref2;
          },
          open: this.state.showInviteLawyer,
          onClose: this.handleCloseInviteLawyer,
          onConfirm: this.handleConfirmInviteLawyer,
          loanTrackerProjectID: data ? data.loanTrackerProjectID : 0,
          projectName: data ? data.name : '',
          setLoading: this.setLoading
        }),
        _react2.default.createElement(_ProjectPanelLawyers2.default, {
          ref: function ref(_ref3) {
            _this4.list = _ref3;
          },
          loading: this.state.loading,
          loanTrackerProjectID: data ? data.loanTrackerProjectID : 0,
          onChange: this.handleGetPanelLawyers,
          onStatusChange: this.handleSetAutoAssignLawyerStatus,
          onSettingsChange: this.handleSetSettingsChanges,
          onEmailsChange: this.handleSetLawyerUpdateEmails,
          project: this.state.data,
          allowLawyerAssignWithoutIC: this.state.data && this.state.data.allowLawyerAssignWithoutIC,
          updateProjectLoading: this.state.updateProjectLoading,
          panelLawyerSettings: true,
          buttonNode: _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_semanticUiReact.Button, {
              onClick: this.handleShowAddLawyer,
              disabled: this.state.loading,
              primary: true,
              content: 'Add'
            })
          ),
          emptyNode: function emptyNode(tab) {
            if (tab === 'panel') {
              return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  'No panel lawyer is added.'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  _react2.default.createElement(
                    'a',
                    { type: 'button', onClick: _this4.handleShowAddLawyer },
                    'Add Lawyer'
                  ),
                  ' as Panel Lawyer now'
                )
              );
            }
            return _react2.default.createElement(
              'p',
              null,
              'No invited lawyer found.'
            );
          },
          itemNode: function itemNode(item, idx, currentTab) {
            return _react2.default.createElement(_LawyerItem2.default, {
              item: item,
              headerNode: currentTab === 'invited' ? _react2.default.createElement(
                _semanticUiReact.Label,
                null,
                'Pending Registration'
              ) : null,
              disabled: _this4.state.loading,
              rightComponentTextAlign: 'right',
              rightComponent: currentTab === 'invited' ? _react2.default.createElement(_semanticUiReact.Button, {
                floated: 'right',
                onClick: function onClick(e) {
                  return _this4.handleResend(e, item);
                },
                primary: true,
                content: 'Resend',
                compact: true,
                disabled: _this4.state.loading || item.updated_at && (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(item.updated_at).add(_momentTimezone2.default.duration(1, 'day')))
              }) : _react2.default.createElement(_semanticUiReact.Button, {
                floated: 'right',
                onClick: function onClick(e) {
                  return _this4.handleShowDeleteConfirm(e, item);
                },
                negative: true,
                icon: 'trash',
                compact: true,
                disabled: _this4.state.loading
              })
            });
          }
        })
      );
    }
  }]);

  return PanelLawyers;
}(_react.Component);

PanelLawyers.contextTypes = {
  store: _propTypes2.default.object
};
PanelLawyers.propTypes = {
  id: _propTypes2.default.string,
  data: _propTypes2.default.shape({
    loanTrackerProjectID: _propTypes2.default.number
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func,
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.object
  })
};

PanelLawyers.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

PanelLawyers.getPropsToState = function (props) {
  var data = props.data || [];
  var loading = props.loading;
  var menuIsTab = window.innerWidth <= 590;
  return {
    data: data,
    loading: loading,
    menuIsTab: menuIsTab
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this5.setState({ loading: loading }, res);
    });
  };

  this.handleResize = function () {
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this5.state.menuIsTab) {
      _this5.setState({ menuIsTab: menuIsTab });
    }
  };

  this.handleMenu = function (e, _ref4) {
    var value = _ref4.value;
    var store = _this5.context.store;

    if (value.includes(_config2.default.get('developerURL'))) {
      e.preventDefault();
      window.location.href = value;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(value));
    }
  };

  this.handleShowInviteLawyer = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this5.setState({
      showInviteLawyer: true
    });
  };

  this.handleCloseInviteLawyer = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this5.setState({
      showInviteLawyer: false
    }, function () {
      if (_this5.inviteForm) {
        _this5.inviteForm.resetData();
      }
    });
  };

  this.handleConfirmInviteLawyer = function () {
    _this5.setState({
      showInviteLawyer: false
    }, function () {
      if (_this5.inviteForm) {
        _this5.inviteForm.resetData();
      }
      if (_this5.list) {
        _this5.list.refresh();
      }
    });
  };

  this.addPanelLawyer = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(lawyerIDs) {
      var store, data, body;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this5.setComponentState({ loading: true });

            case 2:
              store = _this5.context.store;
              data = _this5.props.data;

              if (data.loanTrackerProjectID) {
                _context2.next = 8;
                break;
              }

              _context2.next = 7;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'This project is not linked in loan tracker.' }));

            case 7:
              return _context2.abrupt('return');

            case 8:
              body = {
                lawyer_ids: lawyerIDs,
                project_name: data.name
              };
              _context2.prev = 9;
              _context2.next = 12;
              return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.PANEL_LAWYERS(data.loanTrackerProjectID), body, 'put', {
                'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
              }));

            case 12:
              _context2.next = 22;
              break;

            case 14:
              _context2.prev = 14;
              _context2.t0 = _context2['catch'](9);

              Bugsnag.notifyException(_context2.t0);
              _context2.next = 19;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

            case 19:
              _context2.next = 21;
              return _this5.setLoading(false);

            case 21:
              return _context2.abrupt('return');

            case 22:
              _context2.next = 24;
              return store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Add Success', message: 'Panel lawyer(s) successfully added.' }));

            case 24:
              _context2.next = 26;
              return _this5.setLoading(false);

            case 26:

              if (_this5.list) {
                _this5.list.refresh();
              }

            case 27:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this5, [[9, 14]]);
    }));

    return function (_x3) {
      return _ref5.apply(this, arguments);
    };
  }();

  this.removePanelLawyer = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
    var store, data, selectedLawyer;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _this5.setComponentState({ loading: true });

          case 2:
            store = _this5.context.store;
            data = _this5.props.data;

            if (data.loanTrackerProjectID) {
              _context3.next = 8;
              break;
            }

            _context3.next = 7;
            return store.dispatch((0, _flash.flashErrorMessage)({ message: 'This project is not linked in loan tracker.' }));

          case 7:
            return _context3.abrupt('return');

          case 8:
            selectedLawyer = _this5.state.selectedLawyer;
            _context3.prev = 9;
            _context3.next = 12;
            return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.PANEL_LAWYER(data.loanTrackerProjectID, selectedLawyer.lawyer_id), null, 'del', {
              'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
            }));

          case 12:
            _context3.next = 22;
            break;

          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3['catch'](9);

            Bugsnag.notifyException(_context3.t0);
            _context3.next = 19;
            return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

          case 19:
            _context3.next = 21;
            return _this5.setLoading(false);

          case 21:
            return _context3.abrupt('return');

          case 22:
            _context3.next = 24;
            return store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Remove Success', message: 'Panel lawyer successfully removed.' }));

          case 24:
            _context3.next = 26;
            return _this5.setComponentState({ selectedLawyer: null, loading: false });

          case 26:
            if (_this5.list) {
              _this5.list.refresh();
            }

          case 27:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, _this5, [[9, 14]]);
  }));

  this.resendInvitation = function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(invitation) {
      var store;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _this5.setLoading(true);

            case 2:
              store = _this5.context.store;

              if (!(invitation.updated_at && (0, _momentTimezone2.default)().isAfter((0, _momentTimezone2.default)(invitation.updated_at).add(_momentTimezone2.default.duration(1, 'day'))))) {
                _context4.next = 7;
                break;
              }

              _context4.next = 6;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'Invitation already resend. Please try again later.' }));

            case 6:
              return _context4.abrupt('return');

            case 7:
              _context4.prev = 7;
              _context4.next = 10;
              return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.LAWYER_RESEND_INVITE(invitation.id), null, 'put', {
                'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
              }));

            case 10:
              _context4.next = 20;
              break;

            case 12:
              _context4.prev = 12;
              _context4.t0 = _context4['catch'](7);

              Bugsnag.notifyException(_context4.t0);
              _context4.next = 17;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

            case 17:
              _context4.next = 19;
              return _this5.setLoading(false);

            case 19:
              return _context4.abrupt('return');

            case 20:
              _context4.next = 22;
              return store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Resend Success', message: 'Invitation successfully resend.' }));

            case 22:
              _context4.next = 24;
              return _this5.setLoading(false);

            case 24:
              if (_this5.list) {
                _this5.list.refresh();
              }

            case 25:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this5, [[7, 12]]);
    }));

    return function (_x4) {
      return _ref7.apply(this, arguments);
    };
  }();

  this.handleOnCheck = function () {
    var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var callback = arguments[1];

    if (_this5.props.onCheck) {
      _this5.props.onCheck(hasChanges, callback);
    }
  };

  this.handleShowAddLawyer = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this5.setState({
      showAddLawyer: true
    });
  };

  this.handleCloseAddLawyer = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this5.setState({
      showAddLawyer: false
    });
  };

  this.handleAddLawyer = function (e, selected) {
    if (e) {
      e.preventDefault();
    }
    _this5.setState({ showAddLawyer: false }, function () {
      _this5.addPanelLawyer(selected);
    });
  };

  this.handleShowDeleteConfirm = function (e, selectedLawyer) {
    if (e) {
      e.preventDefault();
    }
    _this5.setState({
      showDeleteConfirm: true,
      selectedLawyer: selectedLawyer
    });
  };

  this.handleCloseDeleteConfirm = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this5.setState({
      showDeleteConfirm: false,
      selectedLawyer: null
    });
  };

  this.handleDeleteLawyer = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this5.setState({ showDeleteConfirm: false }, function () {
      _this5.removePanelLawyer();
    });
  };

  this.handleGetPanelLawyers = function (panelLawyers) {
    _this5.setState({ panelLawyers: panelLawyers });
  };

  this.handleResend = function (e, item) {
    _this5.resendInvitation(item);
  };

  this.handleSetAutoAssignLawyerStatus = function (autoAssignStatus) {
    var data = _this5.state.data;

    data.autoAssignLawyerStatus = autoAssignStatus;
    _this5.setState({ data: data, hasChanges: true });
  };

  this.handleSetSettingsChanges = function (changesData) {
    var data = _this5.state.data;

    data[changesData.name] = changesData.value;
    _this5.setState({ data: data, hasChanges: true });
  };

  this.handleSetLawyerUpdateEmails = function (name, value) {
    var data = _this5.state.data;
    var store = _this5.context.store;

    data[name] = value;
    var r = new RegExp(_index.RX_EMAIL, 'i');
    if (value.some(function (v) {
      return !r.test(v);
    })) {
      store.dispatch((0, _flash.flashErrorMessage)({ message: 'Invalid email address' }));
      return;
    }
    if (data[name] && data[name].some(function (eml) {
      return value.some(function (v) {
        return eml.text === v;
      });
    })) {
      store.dispatch((0, _flash.flashErrorMessage)({ message: 'Duplicate email address' }));
      return;
    }
    _this5.setState({ data: data, hasChanges: true });
  };

  this.handleUpdate = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this5.updateProject();
  };
};

exports.default = (0, _reactRedux.connect)(PanelLawyers.mapStateToProps)(PanelLawyers);

/***/ }),
/* 2401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRouterRedux = __webpack_require__(13);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _PictureList = __webpack_require__(386);

var _PictureList2 = _interopRequireDefault(_PictureList);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _AddPicture = __webpack_require__(1075);

var _AddPicture2 = _interopRequireDefault(_AddPicture);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _RemovePicture = __webpack_require__(590);

var _RemovePicture2 = _interopRequireDefault(_RemovePicture);

var _navigations = __webpack_require__(117);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pictures = function (_Component) {
  _inherits(Pictures, _Component);

  function Pictures(props) {
    _classCallCheck(this, Pictures);

    var _this = _possibleConstructorReturn(this, (Pictures.__proto__ || Object.getPrototypeOf(Pictures)).call(this, props));

    _initialiseProps.call(_this);

    var state = Pictures.getPropsToState(props);
    _this.state = _extends({}, state, {
      pictures: [],
      showConfirm: false,
      showLarge: false,
      selectedPicture: null,
      showAddPicture: false
    });
    _this.pictureList = null;
    return _this;
  }

  _createClass(Pictures, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Pictures.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'handleRefetch',
    value: function handleRefetch() {
      this.setState({
        selectedPicture: null
      });
      if (this.pictureList) {
        this.pictureList.getWrappedInstance().handleRefetch();
      }
    }
  }, {
    key: 'updatePicture',
    value: function updatePicture() {
      var _this2 = this;

      var t = this.props.t;
      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/pictures/' + this.state.selectedPicture.id + '/', {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.pictureToken
        },
        body: JSON.stringify({ isCover: true })
      })).then(function () {
        _this2.handleRefetch();
        store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Picture successfully updated', { ns: _translation.TRANSLATION_FILES.translation }) }));
      }).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      });
    }
  }, {
    key: 'addPicture',
    value: function addPicture(type) {
      var _this3 = this;

      var t = this.props.t;
      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/pictures/' + this.state.selectedPicture.id + '/', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.pictureToken
        },
        body: JSON.stringify({ type: type })
      })).then(function () {
        _this3.pictureModal.handleRefetch();
        store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Add Picture Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Picture successfully added to project', { ns: _translation.TRANSLATION_FILES.translation }) }));
      }).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      });
    }
  }, {
    key: 'deletePicture',
    value: function deletePicture() {
      var _this4 = this;

      var t = this.props.t;
      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/pictures/' + this.state.selectedPicture.id + '/', {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.pictureToken
        }
      })).then(function () {
        _this4.handleRefetch();
        store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Remove Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Picture successfully removed', { ns: _translation.TRANSLATION_FILES.translation }) }));
      }).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      });
    }
  }, {
    key: 'checkDisabled',
    value: function checkDisabled() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';
      var _state = this.state,
          pictures = _state.pictures,
          selectedPicture = _state.selectedPicture;

      if (selectedPicture) {
        var index = pictures.indexOf(selectedPicture);
        if (direction === 'left') {
          return index - 1 >= 0;
        }
        return index + 1 < pictures.length;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var _props = this.props,
          auth = _props.auth,
          id = _props.id,
          location = _props.location,
          t = _props.t;
      var pathname = location.pathname;

      var companyServiceID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
      var isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
      var links = (0, _navigations.editRoutes)(id, this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled, isMalaysia, companyServiceID).map(function (l) {
        return _extends({}, l, {
          text: t(l.text, { ns: l.text === 'Edit' ? _translation.TRANSLATION_FILES.translation : _translation.TRANSLATION_FILES.screens })
        });
      });
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: link.text,
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this5.handleMenu(e, link);
              }
            });
          }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              onClick: this.handleShowAddPicture,
              disabled: this.state.loading,
              primary: true,
              icon: 'add',
              content: t('add', { ns: _translation.TRANSLATION_FILES.screens })
            })
          )
        }),
        _react2.default.createElement(_AddPicture2.default, {
          type: 'project',
          ref: function ref(_ref) {
            _this5.pictureModal = _ref;
          },
          open: this.state.showAddPicture,
          onClose: this.handleCloseAddPicture,
          onConfirm: this.handleAddPicture,
          onUpload: this.handleUpload,
          onCheck: this.handleCheck
        }),
        _react2.default.createElement(_ViewLarge2.default, {
          open: this.state.showLarge,
          onClose: this.handleCloseLarge,
          picture: this.state.selectedPicture,
          onSlide: this.handleSlidePicture,
          disabledLeft: !this.checkDisabled('left'),
          disabledRight: !this.checkDisabled('right'),
          slideshow: this.state.showLarge
        }),
        _react2.default.createElement(_RemovePicture2.default, {
          open: this.state.showConfirm,
          onClose: this.handleCancelRemove,
          onConfirm: this.handleConfirmRemove,
          picture: this.state.selectedPicture,
          data: this.props.data
        }),
        _react2.default.createElement(_PictureList2.default, {
          ref: function ref(_ref3) {
            _this5.pictureList = _ref3;
          },
          toggleable: true,
          projectID: this.props.id,
          onChange: this.handleGetPictures,
          onViewLarge: this.handleViewLarge,
          onRemove: this.handleRemove,
          buttonNode: function buttonNode(_ref2) {
            var isMobile = _ref2.isMobile,
                view = _ref2.view,
                loading = _ref2.loading,
                picture = _ref2.picture;

            var isCover = picture.projects.length > 0 && picture.projects[0].isCover;
            return view === 'list' ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_semanticUiReact.Button, {
                compact: true, size: 'tiny',
                primary: !isCover,
                positive: isCover,
                icon: 'checkmark',
                content: isCover ? t('Already set', { ns: _translation.TRANSLATION_FILES.translation }) : t('Set cover', { ns: _translation.TRANSLATION_FILES.translation }),
                disabled: isCover || loading,
                onClick: function onClick(e) {
                  return _this5.handleSetCover(e, picture);
                }
              }),
              _react2.default.createElement(_semanticUiReact.Button, {
                size: 'tiny',
                compact: true,
                negative: true,
                icon: 'remove',
                content: isMobile ? null : t('Remove', { ns: _translation.TRANSLATION_FILES.translation }),
                disabled: loading,
                onClick: function onClick(e) {
                  return _this5.handleRemove(e, picture);
                }
              })
            ) : _react2.default.createElement(_semanticUiReact.Button, {
              compact: true, size: 'small',
              attached: 'bottom',
              primary: !isCover,
              positive: isCover,
              icon: 'checkmark',
              content: isCover ? t('Already set', { ns: _translation.TRANSLATION_FILES.translation }) : t('Set cover', { ns: _translation.TRANSLATION_FILES.translation }),
              disabled: isCover || loading,
              onClick: function onClick(e) {
                return _this5.handleSetCover(e, picture);
              }
            });
          }
        })
      );
    }
  }]);

  return Pictures;
}(_react.Component);

Pictures.contextTypes = {
  store: _propTypes2.default.object
};
Pictures.propTypes = {
  pictureToken: _propTypes2.default.string,
  id: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      lawyerIsEnabled: _propTypes2.default.bool
    })
  }),
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.object
  }),
  t: _propTypes2.default.func
};

Pictures.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

Pictures.getPropsToState = function (props) {
  var loading = props.loading;
  var menuIsTab = window.innerWidth <= 590;
  return {
    loading: loading,
    menuIsTab: menuIsTab
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.handleResize = function () {
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this6.state.menuIsTab) {
      _this6.setState({ menuIsTab: menuIsTab });
    }
  };

  this.handleCancelRemove = function (e) {
    e.preventDefault();
    _this6.setState({
      showConfirm: false,
      selectedPicture: null
    });
  };

  this.handleRemove = function (e, selectedPicture) {
    e.preventDefault();
    _this6.setState({
      selectedPicture: selectedPicture
    }, function () {
      _this6.setState({
        showConfirm: true
      });
    });
  };

  this.handleConfirmRemove = function (e) {
    e.preventDefault();
    _this6.setState({
      showConfirm: false
    }, function () {
      _this6.deletePicture();
    });
  };

  this.handleCloseLarge = function (e) {
    e.preventDefault();
    _this6.setState({
      showLarge: false,
      selectedPicture: null
    });
  };

  this.handleViewLarge = function (e, selectedPicture) {
    e.preventDefault();
    _this6.setState({
      selectedPicture: selectedPicture,
      showLarge: true
    });
  };

  this.handleSetCover = function (e, selectedPicture) {
    e.preventDefault();
    _this6.setState({
      selectedPicture: selectedPicture
    }, function () {
      _this6.updatePicture();
    });
  };

  this.handleShowAddPicture = function (e) {
    e.preventDefault();
    _this6.setState({
      showAddPicture: true
    });
  };

  this.handleCloseAddPicture = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this6.handleRefetch();
    _this6.setState({
      showAddPicture: false
    });
  };

  this.handleAddPicture = function (e, selectedPicture, pictureType) {
    e.preventDefault();
    _this6.setState({
      selectedPicture: selectedPicture
    }, function () {
      _this6.addPicture(pictureType);
    });
  };

  this.handleUpload = function (body) {
    return {
      url: '/projects/' + _this6.props.id + '/pictures/',
      options: {
        credentials: 'include',
        method: 'POST',
        headers: {
          // Let browser decide Content-Type
          'X-Csrf-Token': _this6.props.pictureToken
        },
        body: body
      }
    };
  };

  this.handleCheck = function (data) {
    if (data.projects && data.projects.length > 0) {
      return data.projects.some(function (p) {
        return p.projectID === _this6.props.id;
      });
    }
    return false;
  };

  this.handleMenu = function (e, _ref4) {
    var value = _ref4.value;
    var store = _this6.context.store;

    if (value.includes(_config2.default.get('developerURL'))) {
      e.preventDefault();
      window.location.href = value;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(value));
    }
  };

  this.handleTypeChange = function (e, _ref5) {
    var value = _ref5.value;

    var projectPictureType = value;
    _this6.setState({ projectPictureType: projectPictureType });
  };

  this.handleGetPictures = function (pictures) {
    _this6.setState({ pictures: pictures });
  };

  this.handleSlidePicture = function (e) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
    var _state2 = _this6.state,
        pictures = _state2.pictures,
        selectedPicture = _state2.selectedPicture;

    var index = pictures.indexOf(selectedPicture);
    var nextIndex = direction === 'left' ? index - 1 : index + 1;
    _this6.setState({
      selectedPicture: pictures[nextIndex]
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Pictures.mapStateToProps)(Pictures));

/***/ }),
/* 2402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _checkChanges = __webpack_require__(61);

var _Overview = __webpack_require__(2397);

var _Overview2 = _interopRequireDefault(_Overview);

var _Edit = __webpack_require__(2392);

var _Edit2 = _interopRequireDefault(_Edit);

var _List = __webpack_require__(2401);

var _List2 = _interopRequireDefault(_List);

var _UnitLayout = __webpack_require__(2418);

var _UnitLayout2 = _interopRequireDefault(_UnitLayout);

var _UnitLayouts = __webpack_require__(2423);

var _UnitLayouts2 = _interopRequireDefault(_UnitLayouts);

var _Units = __webpack_require__(2433);

var _Units2 = _interopRequireDefault(_Units);

var _List3 = __webpack_require__(2391);

var _List4 = _interopRequireDefault(_List3);

var _Logo = __webpack_require__(2393);

var _Logo2 = _interopRequireDefault(_Logo);

var _Reports = __webpack_require__(2403);

var _Reports2 = _interopRequireDefault(_Reports);

var _Activities = __webpack_require__(2390);

var _Activities2 = _interopRequireDefault(_Activities);

var _PanelBankers = __webpack_require__(2399);

var _PanelBankers2 = _interopRequireDefault(_PanelBankers);

var _PanelLawyers = __webpack_require__(2400);

var _PanelLawyers2 = _interopRequireDefault(_PanelLawyers);

var _PackagePricing = __webpack_require__(2398);

var _PackagePricing2 = _interopRequireDefault(_PackagePricing);

var _List5 = __webpack_require__(2435);

var _List6 = _interopRequireDefault(_List5);

__webpack_require__(3502);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Project = function (_Component) {
  _inherits(Project, _Component);

  function Project(props) {
    _classCallCheck(this, Project);

    var _this = _possibleConstructorReturn(this, (Project.__proto__ || Object.getPrototypeOf(Project)).call(this, props));

    _this.newFetch = function () {
      _this.fetchProject();
    };

    _this.state = {
      token: null,
      pictureToken: null,
      mediaToken: null,
      documentToken: null,
      count: 0,
      limit: 0,
      offset: 0,
      loading: true,
      data: null,
      documents: [],
      medias: []
    };
    return _this;
  }

  _createClass(Project, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props$location = this.props.location,
          pathname = _props$location.pathname,
          query = _props$location.query;

      this.fetchProject();
      if (!pathname.includes('/edit/')) {
        if (!pathname.includes('/units/') && !pathname.includes('/layouts/')) {
          if (pathname.includes('/pictures/')) {
            this.fetchProjectPictures();
          }
          if (pathname.includes('/documents/')) {
            this.fetchProjectDocuments(query);
          }
          if (pathname.includes('/videos/')) {
            this.fetchProjectMedias(query);
          }
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _nextProps$location = nextProps.location,
          pathname = _nextProps$location.pathname,
          query = _nextProps$location.query,
          hash = _nextProps$location.hash,
          action = _nextProps$location.action;
      var id = nextProps.params.id;

      if (this.props.location.hash !== hash && action === 'REPLACE') return; // do not fetch if hashtag changed
      if (pathname.endsWith('/' + id + '/edit/') || pathname.endsWith('/' + id + '/logo/')) {
        this.fetchProject();
      } else if (pathname.endsWith('/' + id + '/documents/')) {
        this.fetchProjectDocuments(query);
      } else if (pathname.endsWith('/' + id + '/pictures/')) {
        this.fetchProjectPictures();
      } else if (pathname.endsWith('/' + id + '/videos/')) {
        this.fetchProjectMedias();
      } else if (pathname.endsWith('/' + id + '/')) {
        this.fetchProject();
      }
    }
  }, {
    key: 'setDocuments',
    value: function setDocuments() {
      var _this2 = this;

      var documents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this2.setState({
          documents: documents || []
        }, function () {
          res(documents);
        });
      });
    }
  }, {
    key: 'setMedias',
    value: function setMedias() {
      var _this3 = this;

      var medias = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this3.setState({
          medias: medias || []
        }, function () {
          res(medias);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this4 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this4.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this5 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this5.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchProject',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.params.id + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                return _context.abrupt('return');

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 32;
                break;

              case 26:
                token = res.headers.get('X-Csrf-Token');
                _context.next = 29;
                return res.json();

              case 29:
                data = _context.sent;
                _context.next = 32;
                return this.setComponentState({
                  token: token,
                  data: data
                });

              case 32:
                _context.next = 34;
                return this.setLoading(false);

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchProject() {
        return _ref.apply(this, arguments);
      }

      return fetchProject;
    }()
  }, {
    key: 'fetchProjectPictures',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, res, message, pictureToken;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context2.prev = 4;
                _context2.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.params.id + '/pictures/?page=1', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context2.sent;
                _context2.next = 18;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](4);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context2.next = 17;
                return this.setLoading(false);

              case 17:
                return _context2.abrupt('return');

              case 18:
                if (res.ok) {
                  _context2.next = 26;
                  break;
                }

                _context2.next = 21;
                return res.text();

              case 21:
                message = _context2.sent;
                _context2.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context2.next = 29;
                break;

              case 26:
                pictureToken = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context2.next = 29;
                return this.setComponentState({
                  pictureToken: pictureToken
                });

              case 29:
                _context2.next = 31;
                return this.setLoading(false);

              case 31:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10]]);
      }));

      function fetchProjectPictures() {
        return _ref2.apply(this, arguments);
      }

      return fetchProjectPictures;
    }()
  }, {
    key: 'fetchProjectDocuments',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(q) {
        var store, query, res, message, documentToken, count, limit, offset, documents;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                res = void 0;
                _context3.prev = 6;
                _context3.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.params.id + '/documents/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context3.sent;
                _context3.next = 20;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](6);

                Bugsnag.notifyException(_context3.t0);
                _context3.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 17:
                _context3.next = 19;
                return this.setLoading(false);

              case 19:
                return _context3.abrupt('return');

              case 20:
                if (res.ok) {
                  _context3.next = 28;
                  break;
                }

                _context3.next = 23;
                return res.text();

              case 23:
                message = _context3.sent;
                _context3.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context3.next = 40;
                break;

              case 28:
                documentToken = res.headers.get('X-Csrf-Token');
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context3.next = 34;
                return res.json();

              case 34:
                documents = _context3.sent;
                _context3.next = 37;
                return this.setDocuments(documents);

              case 37:
                if (this.state.documents.length < 1 && query.page > 1) {
                  query.page = 1;
                  store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.params.id + '/documents/?' + _qs2.default.stringify(query)));
                }
                // handle token.. etc
                _context3.next = 40;
                return this.setComponentState({
                  documentToken: documentToken,
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 40:
                _context3.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 12]]);
      }));

      function fetchProjectDocuments(_x5) {
        return _ref3.apply(this, arguments);
      }

      return fetchProjectDocuments;
    }()
  }, {
    key: 'fetchProjectMedias',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var store, res, message, mediaToken;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context4.prev = 4;
                _context4.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.params.id + '/medias/?page=1', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context4.sent;
                _context4.next = 18;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](4);

                Bugsnag.notifyException(_context4.t0);
                _context4.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context4.next = 17;
                return this.setLoading(false);

              case 17:
                return _context4.abrupt('return');

              case 18:
                if (res.ok) {
                  _context4.next = 26;
                  break;
                }

                _context4.next = 21;
                return res.text();

              case 21:
                message = _context4.sent;
                _context4.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context4.next = 29;
                break;

              case 26:
                mediaToken = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context4.next = 29;
                return this.setComponentState({
                  mediaToken: mediaToken
                });

              case 29:
                _context4.next = 31;
                return this.setLoading(false);

              case 31:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 10]]);
      }));

      function fetchProjectMedias() {
        return _ref4.apply(this, arguments);
      }

      return fetchProjectMedias;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this6 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this6.state.token,
          pictureToken: _this6.state.pictureToken,
          documentToken: _this6.state.documentToken,
          mediaToken: _this6.state.mediaToken,
          count: _this6.state.count,
          limit: _this6.state.limit,
          offset: _this6.state.offset,
          loading: _this6.state.loading,
          data: _this6.state.data,
          documents: _this6.state.documents,
          id: _this6.props.params.id,
          newFetch: _this6.newFetch
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Project;
}(_react.Component);

Project.propTypes = {
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    hash: _propTypes2.default.string,
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object
  })
};
Project.contextTypes = {
  store: _propTypes2.default.object
};
Project.Overview = (0, _checkChanges.checkChanges)(_Overview2.default);
Project.Edit = (0, _checkChanges.checkChanges)(_Edit2.default);
Project.PanelBankers = (0, _checkChanges.checkChanges)(_PanelBankers2.default);
Project.PanelLawyers = (0, _checkChanges.checkChanges)(_PanelLawyers2.default);
Project.PackagePricing = (0, _checkChanges.checkChanges)(_PackagePricing2.default);
Project.Pictures = _List2.default;
Project.UnitLayout = _UnitLayout2.default;
Project.UnitLayouts = _UnitLayouts2.default;
Project.Units = _Units2.default;
Project.Documents = _List4.default;
Project.Logo = _Logo2.default;
Project.Reports = _Reports2.default;
Project.Activities = _Activities2.default;
Project.Videos = _List6.default;
exports.default = Project;

/***/ }),
/* 2403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Reports = __webpack_require__(1030);

var _translation = __webpack_require__(4);

var _fetchM = __webpack_require__(6);

var _navigations = __webpack_require__(117);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_momentTimezone2.default.locale('en-gb');

var Reports = function (_Component) {
  _inherits(Reports, _Component);

  function Reports(props) {
    _classCallCheck(this, Reports);

    var _this = _possibleConstructorReturn(this, (Reports.__proto__ || Object.getPrototypeOf(Reports)).call(this, props));

    _initialiseProps.call(_this);

    var state = Reports.getPropsToState(props);
    _this.state = _extends({
      projectCurrencies: []
    }, state);
    return _this;
  }

  _createClass(Reports, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
      this.fetchProjectCurrencies(this.props.params.id);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Reports.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchProjectCurrencies',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(projectId) {
        var store, t, response;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                _context.prev = 4;
                _context.next = 7;
                return (0, _fetchM.serverRequestGet)('/projects/' + projectId + '/currency/', store);

              case 7:
                response = _context.sent;

                if (!response.error) {
                  _context.next = 12;
                  break;
                }

                _context.next = 11;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: response.message }));

              case 11:
                return _context.abrupt('return');

              case 12:
                _context.next = 14;
                return this.setLoading(false);

              case 14:
                this.setState({
                  projectCurrencies: response.data || []
                });
                _context.next = 24;
                break;

              case 17:
                _context.prev = 17;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 22;
                return this.setLoading(false);

              case 22:
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 17]]);
      }));

      function fetchProjectCurrencies(_x3) {
        return _ref.apply(this, arguments);
      }

      return fetchProjectCurrencies;
    }()
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var pathname = this.props.location.pathname;
      var _state = this.state,
          data = _state.data,
          projectCurrencies = _state.projectCurrencies;
      var t = this.props.t;

      var links = (0, _navigations.routes)(this.props.id, data, true, false, this.props.auth).map(function (l) {
        return _extends({}, l, {
          text: t(l.text)
        });
      });
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: link.text,
              content: link.text,
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this4.handleMenu(e, link);
              }
            });
          }),
          rightNav: this.hasAccess() ? _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              as: _reactRouter.Link,
              primary: true,
              content: t('Edit', { ns: _translation.TRANSLATION_FILES.translation }),
              disabled: this.state.loading,
              to: '/projects/' + this.props.id + '/edit/'
            })
          ) : null
        }),
        _react2.default.createElement(
          _semanticUiReact.Divider,
          { horizontal: true },
          _react2.default.createElement(
            _reactI18next.Trans,
            { ns: _translation.TRANSLATION_FILES.screens },
            'Project Unit Reports (',
            { name: data.name },
            ')'
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Header,
          { as: 'h3' },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'chart bar' }),
          _react2.default.createElement(
            _semanticUiReact.Header.Content,
            null,
            t('Project Unit Statuses'),
            _react2.default.createElement(
              _semanticUiReact.Header.Subheader,
              null,
              t('Units by statuses')
            )
          )
        ),
        _react2.default.createElement(_Reports.ProjectUnitsByStatus, {
          projectCurrencies: projectCurrencies,
          projectID: this.props.id,
          location: this.props.location,
          headerColor: 'blue',
          barChart: true
        }),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          _semanticUiReact.Header,
          { as: 'h3' },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'list' }),
          _react2.default.createElement(
            _semanticUiReact.Header.Content,
            null,
            t('Delist Reasons'),
            _react2.default.createElement(
              _semanticUiReact.Header.Subheader,
              null,
              t('Delisted units by reason')
            )
          )
        ),
        _react2.default.createElement(_Reports.DelistReasonsByStatus, {
          projectCurrencies: projectCurrencies,
          projectID: this.props.id,
          location: this.props.location,
          headerColor: 'blue',
          barChart: true
        }),
        _react2.default.createElement('br', null),
        _react2.default.createElement(
          _semanticUiReact.Divider,
          { horizontal: true },
          _react2.default.createElement(
            _reactI18next.Trans,
            { ns: _translation.TRANSLATION_FILES.screens },
            'Bookings Reports (',
            { name: data.name },
            ')'
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Header,
          { as: 'h3' },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'chart bar' }),
          _react2.default.createElement(
            _semanticUiReact.Header.Content,
            null,
            t('Booking Statuses'),
            _react2.default.createElement(
              _semanticUiReact.Header.Subheader,
              null,
              t('Bookings by statuses')
            )
          )
        ),
        _react2.default.createElement(_Reports.BookingsByStatus, {
          projectCurrencies: projectCurrencies,
          projectID: this.props.id,
          location: this.props.location,
          headerColor: 'blue',
          barChart: true
        }),
        _react2.default.createElement(
          _semanticUiReact.Header,
          { as: 'h3' },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'list' }),
          _react2.default.createElement(
            _semanticUiReact.Header.Content,
            null,
            t('User Bookings'),
            _react2.default.createElement(
              _semanticUiReact.Header.Subheader,
              null,
              t('Bookings by user and booking status')
            )
          )
        ),
        _react2.default.createElement(_Reports.UsersBookings, {
          projectCurrencies: projectCurrencies,
          projectID: this.props.id,
          location: this.props.location,
          headerColor: 'blue'
        }),
        _react2.default.createElement(
          _semanticUiReact.Header,
          { as: 'h3' },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'list' }),
          _react2.default.createElement(
            _semanticUiReact.Header.Content,
            null,
            t('Business Unit Bookings'),
            _react2.default.createElement(
              _semanticUiReact.Header.Subheader,
              null,
              t('Bookings by business unit and booking status')
            )
          )
        ),
        _react2.default.createElement(_Reports.BranchBookings, {
          projectCurrencies: projectCurrencies,
          projectID: this.props.id,
          location: this.props.location,
          headerColor: 'blue'
        })
      );
    }
  }]);

  return Reports;
}(_react.Component);

Reports.propTypes = {
  id: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool
  }),
  t: _propTypes2.default.func
};
Reports.contextTypes = {
  store: _propTypes2.default.object
};

Reports.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

Reports.getPropsToState = function (props) {
  var data = props.data || {};
  var loading = false;
  var menuIsTab = window.innerWidth <= 590;
  return {
    data: data,
    loading: loading,
    menuIsTab: menuIsTab
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.getValueName = function (value, arr) {
    var valueName = arr.find(function (vn) {
      return vn.value === value;
    });
    if (valueName && valueName.name) {
      return valueName.name;
    }
    return '';
  };

  this.handleMenu = function (e, _ref2) {
    var value = _ref2.value;
    var store = _this5.context.store;

    if (value.includes(_config2.default.get('bookApiURL')) || value.includes(_config2.default.get('salesChartURL'))) {
      e.preventDefault();
      var winObj = window.open(value, '_blank');
      winObj.opener = null;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(value));
    }
  };

  this.handleResize = function () {
    var state = {};
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this5.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    var unitLayoutResize = window.innerWidth < 768;
    if (unitLayoutResize !== _this5.state.unitLayoutResize) {
      state.unitLayoutResize = unitLayoutResize;
    }
    var galleryIsTab = window.innerWidth > 425;
    if (galleryIsTab !== _this5.state.galleryIsTab) {
      state.galleryIsTab = galleryIsTab;
    }
    var locationResize = window.innerWidth <= 375;
    if (locationResize !== _this5.state.locationResize) {
      state.locationResize = locationResize;
    }
    _this5.setState(_extends({}, state));
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Reports.mapStateToProps)(Reports));

/***/ }),
/* 2404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(13);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _ProjectUnitActivities = __webpack_require__(565);

var _ProjectUnitActivities2 = _interopRequireDefault(_ProjectUnitActivities);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


var Activities = function (_Component) {
  _inherits(Activities, _Component);

  function Activities(props) {
    _classCallCheck(this, Activities);

    var _this = _possibleConstructorReturn(this, (Activities.__proto__ || Object.getPrototypeOf(Activities)).call(this, props));

    _initialiseProps.call(_this);

    var state = Activities.getPropsToState(props);
    state.limit = 0;
    state.offset = 0;
    state.currentPage = parseInt(state.query.page, 10) || 1;
    state.count = 0;
    _this.state = state;
    return _this;
  }

  _createClass(Activities, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = this.props.location.query;

      this.getProjectUnitActivities(query);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var query = nextProps.location.query;

      var state = Activities.getPropsToState(nextProps);
      if (this.state.activitiesData) {
        state.activitiesData = this.state.activitiesData;
      }
      this.setState(_extends({}, state), function () {
        if (!_this2.state.activitiesData) {
          _this2.getProjectUnitActivities(query);
        }
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'getProjectUnitActivities',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var store, t, query, queryString, res, message, activitiesData, count, limit, offset;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                queryString = '';
                res = null;

                if (_qs2.default.stringify(query)) {
                  queryString = '?' + _qs2.default.stringify(query);
                }
                _context.prev = 9;
                _context.next = 12;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.routerParams.id + '/units/' + this.props.routerParams.unitID + '/activities/' + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context.sent;
                _context.next = 26;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](9);
                _context.next = 19;
                return this.setLoading(false);

              case 19:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 24;
                  break;
                }

                _context.next = 22;
                return _context.t0.res.text();

              case 22:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 26:
                if (res.ok) {
                  _context.next = 32;
                  break;
                }

                _context.next = 29;
                return this.setLoading(false);

              case 29:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                _context.next = 42;
                break;

              case 32:
                _context.next = 34;
                return res.json();

              case 34:
                activitiesData = _context.sent;
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 40;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset,
                  activitiesData: activitiesData
                });

              case 40:
                _context.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 15]]);
      }));

      function getProjectUnitActivities(_x3) {
        return _ref.apply(this, arguments);
      }

      return getProjectUnitActivities;
    }()
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters) {
        return true;
      }
      if (this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'replaceQuery',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(query) {
        var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var store, queryNew;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                queryNew = query;

                if (resetPage) queryNew.page = 1;
                _context2.next = 7;
                return this.getProjectUnitActivities(query);

              case 7:
                store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.routerParams.id + '/units/' + this.props.routerParams.unitID + '/activities/?' + (0, _url.encodeSearch)(queryNew)));
                _context2.next = 10;
                return this.setLoading(false);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function replaceQuery(_x5) {
        return _ref2.apply(this, arguments);
      }

      return replaceQuery;
    }()
  }, {
    key: 'render',
    value: function render() {
      var activitiesData = this.state.activitiesData;
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Unit Activity Logs')
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(_SearchFilter2.default, {
                isLoading: this.state.loading,
                onChange: this.handleOnChange,
                onClose: this.handleClearFilter,
                search: this.state.search,
                placeholder: t('Search'),
                setAdvanceFilter: function setAdvanceFilter() {},
                leftNav: _react2.default.createElement(_PageNav2.default, {
                  currentPage: this.state.currentPage,
                  count: this.state.count,
                  limit: this.state.limit,
                  offset: this.state.offset,
                  dataSize: this.state.activitiesData.length,
                  loading: this.state.loading,
                  onChange: this.handleChangePage
                }),
                rightNav: _react2.default.createElement(_SortButton2.default, {
                  floated: 'right',
                  loading: this.state.loading,
                  items: this.sortItems,
                  onSort: this.handleSortData
                })
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, textAlign: 'center' },
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/projects/' + this.props.routerParams.id + '/units/' + this.props.routerParams.unitID + '/' },
                  _react2.default.createElement(
                    'small',
                    null,
                    this.state.data.reference ? this.state.data.reference + ', ' : '',
                    this.state.data.project ? this.state.data.project.shortName : ''
                  )
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Segment,
                null,
                _react2.default.createElement(_ProjectUnitActivities2.default, {
                  data: activitiesData || [],
                  hasAccess: this.hasAccess(),
                  loading: this.state.loading
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Activities;
}(_react.Component);

Activities.contextTypes = {
  store: _propTypes2.default.object
};
Activities.propTypes = {
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool
  }),
  routerParams: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    unitID: _propTypes2.default.string
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  })
};

Activities.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

Activities.getPropsToState = function (props) {
  var data = props.data || [];
  var query = (0, _url.decodeSearch)(props.location.search);
  var search = query.search || '';
  var activitiesData = [];
  return {
    data: data,
    query: query,
    search: search,
    activitiesData: activitiesData
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    query.page = currentPage;
    _this5.setState({
      currentPage: currentPage
    });
    _this5.replaceQuery(query);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this5.replaceQuery(query);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    if (hasQuery) {
      _this5.replaceQuery(query, true);
    } else {
      _this5.setState({ search: '' });
    }
  };

  this.handleOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    query[queryName] = value;
    _this5.replaceQuery(query, true);
  };

  this.sortItems = [{
    text: 'Date Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'project_unit_activity.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Date Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'project_unit_activity.created_at',
    sortDirection: 'desc'
  }];
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Activities.mapStateToProps)(Activities));

/***/ }),
/* 2405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _BookingsList = __webpack_require__(2108);

var _BookingsList2 = _interopRequireDefault(_BookingsList);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Bookings = function (_Component) {
  _inherits(Bookings, _Component);

  function Bookings(props) {
    _classCallCheck(this, Bookings);

    var _this = _possibleConstructorReturn(this, (Bookings.__proto__ || Object.getPrototypeOf(Bookings)).call(this, props));

    _this.checkIsAgent = function () {
      var auth = _this.props.auth;
      if (auth && auth.companyBranch && auth.companyBranch.isExternal && auth.isDeveloper && !auth.isSuperAdmin && !auth.isHeadquarters && !auth.isBranchLeader) {
        return true;
      }
      return false;
    };

    _this.handlebookingListLength = function (length) {
      _this.setState({ bookingListLength: length });
    };

    _this.handleOnCollapseSegment = function (e, _ref) {
      var name = _ref.name,
          value = _ref.value;
      var collapseSegments = _this.state.collapseSegments;

      e.preventDefault();
      collapseSegments[name] = !value;
      _this.setState({ collapseSegments: collapseSegments });
    };

    _this.state = {
      bookingListLength: 0,
      collapseSegments: [{
        hideBookings: false
      }]
    };
    return _this;
  }

  _createClass(Bookings, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isMobile = _props.isMobile,
          t = _props.t;
      var hideBookings = this.state.collapseSegments.hideBookings;


      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16, style: isMobile ? { padding: '0' } : {} },
            this.state.bookingListLength === 0 && this.checkIsAgent() ? '' : _react2.default.createElement(
              _semanticUiReact.Header,
              {
                className: 'new_title',
                as: 'h5',
                textAlign: 'center',
                attached: 'top'
              },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16, textAlign: 'center' },
                    t('Bookings').toUpperCase()
                  ),
                  _react2.default.createElement(_semanticUiReact.Label, {
                    as: 'button',
                    attached: 'top right',
                    icon: hideBookings ? 'angle up' : 'angle down',
                    className: 'collapse-button',
                    style: {
                      position: 'absolute',
                      right: '0',
                      top: '3px',
                      marginRight: '0',
                      marginTop: '0.5em'
                    },
                    name: 'hideBookings',
                    value: hideBookings,
                    onClick: this.handleOnCollapseSegment,
                    disabled: this.props.loading
                  })
                )
              )
            ),
            !hideBookings ? _react2.default.createElement(
              _semanticUiReact.Segment,
              { attached: true },
              _react2.default.createElement(_BookingsList2.default, {
                isUnitOverview: true,
                projectUnitID: this.props.unitID,
                noScrollTop: true,
                hideBookingList: this.checkIsAgent(),
                bookingListLength: this.handlebookingListLength
              })
            ) : null
          )
        )
      );
    }
  }]);

  return Bookings;
}(_react.Component);

Bookings.contextTypes = {
  store: _propTypes2.default.object
};
Bookings.propTypes = {
  auth: _propTypes2.default.shape({
    isDeveloper: _propTypes2.default.bool,
    isSiteplan: _propTypes2.default.bool,
    isBranchLeader: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    allowEditUnitPrice: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool
  }),
  isMobile: _propTypes2.default.bool,
  loading: _propTypes2.default.bool,
  unitID: _propTypes2.default.string
};

Bookings.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)((0, _reactRedux.connect)(Bookings.mapStateToProps)(Bookings));

/***/ }),
/* 2406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1062);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditUnit = function (_Component) {
  _inherits(EditUnit, _Component);

  function EditUnit(props) {
    _classCallCheck(this, EditUnit);

    var _this = _possibleConstructorReturn(this, (EditUnit.__proto__ || Object.getPrototypeOf(EditUnit)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(EditUnit, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, unit) {
        var _this2 = this;

        var store, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 5;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 5:
                res = void 0;
                _context.prev = 6;
                _context.next = 9;
                return this.form.submit('/projects/' + this.props.id + '/units/' + this.props.unitID + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(unit)
                });

              case 9:
                res = _context.sent;
                _context.next = 22;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 17;
                return _context.t0.res.text();

              case 17:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 20:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 22:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false);
                });
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Update Success', message: res.reference + ' successfully updated' }));

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: 'Edit ' + (this.props.data ? this.props.data.reference : 'unit'),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: 'Save',
              onClick: this.handleSubmit
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          id: this.props.id,
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, unit) {
            _this3.submit(validations, unit);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading,
          unit: this.props.data
        })
      );
    }
  }]);

  return EditUnit;
}(_react.Component);

EditUnit.propTypes = {
  token: _propTypes2.default.string,
  id: _propTypes2.default.string,
  unitID: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  data: _propTypes2.default.shape({
    reference: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func
};
EditUnit.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = EditUnit;

/***/ }),
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fileSize = __webpack_require__(85);

var _fileSize2 = _interopRequireDefault(_fileSize);

var _companies = __webpack_require__(88);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _unitHold = __webpack_require__(1095);

var _unitStatuses = __webpack_require__(266);

var _translation = __webpack_require__(4);

var _propertyCategories = __webpack_require__(323);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _EditableBox = __webpack_require__(153);

var _EditableBox2 = _interopRequireDefault(_EditableBox);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _SpecificationTable = __webpack_require__(127);

var _SpecificationTable2 = _interopRequireDefault(_SpecificationTable);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _GalleryList = __webpack_require__(561);

var _GalleryList2 = _interopRequireDefault(_GalleryList);

var _MarkdownText = __webpack_require__(193);

var _MarkdownText2 = _interopRequireDefault(_MarkdownText);

var _SizeSuffix = __webpack_require__(316);

var _SizeSuffix2 = _interopRequireDefault(_SizeSuffix);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _ProjectUnitPackagePricing = __webpack_require__(566);

var _ProjectUnitPackageFee = __webpack_require__(1029);

var _ProjectUnitPricingTier = __webpack_require__(2176);

var _ProjectUnitPricingTier2 = _interopRequireDefault(_ProjectUnitPricingTier);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _amount = __webpack_require__(87);

var _url = __webpack_require__(19);

var _storage = __webpack_require__(44);

var _CustomFieldForm = __webpack_require__(1015);

var _CustomFieldForm2 = _interopRequireDefault(_CustomFieldForm);

var _PaymentPlanForm = __webpack_require__(1026);

var _PaymentPlanForm2 = _interopRequireDefault(_PaymentPlanForm);

var _MortgageCalculator = __webpack_require__(2158);

var _MortgageCalculator2 = _interopRequireDefault(_MortgageCalculator);

var _DelistReasonModal = __webpack_require__(2127);

var _DelistReasonModal2 = _interopRequireDefault(_DelistReasonModal);

var _srRoleAccess = __webpack_require__(196);

var _areaLabel = __webpack_require__(223);

var _vietnam = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */


var styles = {
  divider: { margin: '0.5em 0' }
};
var ALL_AGENCIES_VALUE = '__all_agencies__';

var Info = function (_Component) {
  _inherits(Info, _Component);

  function Info(props) {
    _classCallCheck(this, Info);

    var _this = _possibleConstructorReturn(this, (Info.__proto__ || Object.getPrototypeOf(Info)).call(this, props));

    _initialiseProps.call(_this);

    var state = Info.getPropsToState(props);
    _this.state = _extends({}, state, {
      collapseSegments: [{
        hideDocument: false,
        hideGallery: false,
        hidePricingPackage: false,
        hidePaymentSchedule: false,
        hideAdditionalFees: false,
        hideMortgageCalculator: false
      }],
      edit: false,
      editTier: false,
      pictures: [],
      unitLayouts: [],
      errMessages: [],
      showLarge: false,
      selectedPicture: null,
      hasChanges: false,
      delistReasons: [],
      showDelistModal: false,
      selectedDelistReason: ''
    });
    _this.validation = {
      reference: (0, _react.createRef)(),
      statusID: (0, _react.createRef)(),
      projectUnitLayoutID: (0, _react.createRef)(),
      size: (0, _react.createRef)(),
      landArea: (0, _react.createRef)(),
      position: (0, _react.createRef)(),
      colSpan: (0, _react.createRef)(),
      hsd: (0, _react.createRef)(),
      ptd: (0, _react.createRef)(),
      geran: (0, _react.createRef)(),
      lot: (0, _react.createRef)(),
      referenceCode: (0, _react.createRef)(),
      zoneOrBlock: (0, _react.createRef)(),
      streetNumberOrLevel: (0, _react.createRef)(),
      streetOrFacing: (0, _react.createRef)(),
      spaAmount: (0, _react.createRef)(),
      unitLayoutNew: (0, _react.createRef)(),
      view: (0, _react.createRef)(),
      vatPercentage: (0, _react.createRef)(),
      landValue: (0, _react.createRef)(),
      virtualTourURL: (0, _react.createRef)(),
      companyBranchAllocationIDs: (0, _react.createRef)()
    };
    _this.customFieldValidation = {};
    return _this;
  }

  _createClass(Info, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
      this.fetchCompanyBranches();
      this.fetchDelistReasons();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var state = Info.getPropsToState(nextProps);
      if (state.data.projectUnitCustomFields) {
        // setup existing custom fields values in data state
        state.data.projectUnitCustomFields.forEach(function (d) {
          state.data[_this2.ucfPrefix(d.projectUnitCustomFieldSetting.name)] = d.value;
          state.data[_this2.ucfPrefix(d.projectUnitCustomFieldSetting.name) + 'ID'] = d.id;
          if (d.projectUnitCustomFieldSetting.type === 'dropdown' || d.projectUnitCustomFieldSetting.type === 'dropdown_multi') {
            state.data[_this2.ucfPrefix(d.projectUnitCustomFieldSetting.name) + 'OptionID'] = d.projectUnitCustomFieldSettingOptionID;
            state.data[_this2.ucfPrefix(d.projectUnitCustomFieldSetting.name) + 'OptionIDs'] = d.projectUnitCustomFieldSettingOptionIDs;
          } else {
            state.data[_this2.ucfPrefix(d.projectUnitCustomFieldSetting.name) + 'OptionID'] = '';
            state.data[_this2.ucfPrefix(d.projectUnitCustomFieldSetting.name) + 'OptionIDs'] = [];
          }
        });
      }
      if (state.unitCustomFieldSettings) {
        // setup new custom fields blank values in data state
        state.unitCustomFieldSettings.forEach(function (d) {
          if (!state.data[_this2.ucfPrefix(d.name)]) {
            if (!state.data[_this2.ucfPrefix(d.name) + 'ID']) {
              state.data[_this2.ucfPrefix(d.name)] = d.defaultValue;
            }
            if (d.type === 'dropdown' || d.type === 'dropdown_multi') {
              state.data[_this2.ucfPrefix(d.name) + 'OptionID'] = '';
              state.data[_this2.ucfPrefix(d.name) + 'OptionIDs'] = [];
            }
          }
        });
      }
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this3.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'fetchCompanyBranches',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, t, res, message, json, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context.prev = 3;
                _context.next = 6;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + this.props.id + '/accessible_company_branches/?isExternal=true', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 6:
                res = _context.sent;
                _context.next = 15;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](3);

                Bugsnag.notifyException(_context.t0);
                _context.next = 14;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 14:
                return _context.abrupt('return');

              case 15:
                if (res.ok) {
                  _context.next = 23;
                  break;
                }

                _context.next = 18;
                return res.text();

              case 18:
                message = _context.sent;
                _context.next = 21;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 21:
                _context.next = 30;
                break;

              case 23:
                _context.next = 25;
                return res.json();

              case 25:
                json = _context.sent;

                if (!json) {
                  _context.next = 30;
                  break;
                }

                data = json.map(function (obj) {
                  var newResults = {};
                  newResults.text = obj.name;
                  newResults.value = obj.id;
                  return newResults;
                });
                _context.next = 30;
                return this.setComponentState({
                  companyBranches: data
                });

              case 30:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 9]]);
      }));

      function fetchCompanyBranches() {
        return _ref.apply(this, arguments);
      }

      return fetchCompanyBranches;
    }()
  }, {
    key: 'fetchDelistReasons',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, t, res, message, delistReasons;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context2.prev = 3;
                _context2.next = 6;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/settings/delist_reasons/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 6:
                res = _context2.sent;
                _context2.next = 14;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](3);

                Bugsnag.notifyException(_context2.t0);
                console.error('Error fetching delist reasons:', _context2.t0);
                return _context2.abrupt('return');

              case 14:
                if (res.ok) {
                  _context2.next = 21;
                  break;
                }

                _context2.next = 17;
                return res.text();

              case 17:
                message = _context2.sent;

                console.error('Error fetching delist reasons:', message);
                _context2.next = 26;
                break;

              case 21:
                _context2.next = 23;
                return res.json();

              case 23:
                delistReasons = _context2.sent;
                _context2.next = 26;
                return this.setComponentState({
                  delistReasons: delistReasons || []
                });

              case 26:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 9]]);
      }));

      function fetchDelistReasons() {
        return _ref2.apply(this, arguments);
      }

      return fetchDelistReasons;
    }()
  }, {
    key: 'fetchProjectUnitLayouts',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var store, t, res, message, unitLayouts;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context3.prev = 3;
                _context3.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/unit_layouts/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 6:
                res = _context3.sent;
                _context3.next = 15;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](3);

                Bugsnag.notifyException(_context3.t0);
                _context3.next = 14;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 14:
                return _context3.abrupt('return');

              case 15:
                if (res.ok) {
                  _context3.next = 23;
                  break;
                }

                _context3.next = 18;
                return res.text();

              case 18:
                message = _context3.sent;
                _context3.next = 21;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 21:
                _context3.next = 28;
                break;

              case 23:
                _context3.next = 25;
                return res.json();

              case 25:
                unitLayouts = _context3.sent;
                _context3.next = 28;
                return this.setComponentState({
                  unitLayouts: unitLayouts ? unitLayouts.map(function (ul) {
                    var unitLayout = { text: ul.name, name: ul.id, value: ul.id, size: ul.size };
                    return unitLayout;
                  }) : []
                });

              case 28:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 9]]);
      }));

      function fetchProjectUnitLayouts() {
        return _ref3.apply(this, arguments);
      }

      return fetchProjectUnitLayouts;
    }()
  }, {
    key: 'putUnit',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(unit) {
        var _this4 = this;

        var skipValidationCheck = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var store, t, query, validations, errors, res, message, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                query = (0, _url.decodeSearch)(this.props.location.search);

                if (skipValidationCheck) {
                  _context4.next = 12;
                  break;
                }

                _context4.next = 6;
                return _AppForm2.default.validate(_extends({}, this.validation, this.customFieldValidation), this.state.data);

              case 6:
                validations = _context4.sent;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context4.next = 12;
                  break;
                }

                this.setState({ edit: true });
                store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context4.abrupt('return');

              case 12:
                _context4.next = 14;
                return this.setComponentState({ loading: true });

              case 14:
                res = void 0;
                _context4.prev = 15;
                _context4.next = 18;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/units/' + this.props.unitID + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(unit)
                }));

              case 18:
                res = _context4.sent;
                _context4.next = 34;
                break;

              case 21:
                _context4.prev = 21;
                _context4.t0 = _context4['catch'](15);

                Bugsnag.notifyException(_context4.t0);
                _context4.next = 26;
                return this.setComponentState({ loading: false });

              case 26:
                if (!(_context4.t0.res.status >= 400 && _context4.t0.res.status < 500)) {
                  _context4.next = 32;
                  break;
                }

                _context4.next = 29;
                return _context4.t0.res.text();

              case 29:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context4.abrupt('return');

              case 32:
                store.dispatch((0, _flash.flashErrorMessage)(_context4.t0));
                return _context4.abrupt('return');

              case 34:
                _context4.next = 36;
                return res.json();

              case 36:
                data = _context4.sent;
                _context4.next = 39;
                return this.setComponentState({
                  loading: false,
                  edit: false,
                  editTier: false
                }, function () {
                  _this4.handleResetCheck();
                });

              case 39:
                this.props.newFetch();
                store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.id + '/units/' + this.props.unitID + '/?' + (0, _url.encodeSearch)(query)));
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Unit {{reference}} is successfully updated', { reference: data.reference, ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 42:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[15, 21]]);
      }));

      function putUnit(_x2) {
        return _ref4.apply(this, arguments);
      }

      return putUnit;
    }()
  }, {
    key: 'deleteUnitPricingTier',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(id) {
        var _this5 = this;

        var store, data, t, newprojectUnitPricings, item, message;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.setComponentState({ loading: true });

              case 2:
                store = this.context.store;
                data = this.state.data;
                t = this.props.t;
                newprojectUnitPricings = data.projectUnitPricings.filter(function (d) {
                  return d.id !== id;
                });
                item = data.projectUnitPricings.find(function (d) {
                  return d.id === id;
                });
                _context5.prev = 7;
                _context5.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + data.project.id + '/units/' + data.id + '/pricings/' + id + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 10:
                _context5.next = 25;
                break;

              case 12:
                _context5.prev = 12;
                _context5.t0 = _context5['catch'](7);
                _context5.next = 16;
                return this.setComponentState({ loading: false });

              case 16:
                if (!(_context5.t0.res && _context5.t0.res.status >= 400 && _context5.t0.res.status < 500)) {
                  _context5.next = 22;
                  break;
                }

                _context5.next = 19;
                return _context5.t0.res.text();

              case 19:
                message = _context5.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context5.abrupt('return');

              case 22:
                Bugsnag.notifyException(_context5.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
                return _context5.abrupt('return');

              case 25:
                _context5.next = 27;
                return this.setComponentState({ loading: false });

              case 27:
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Pricing Deleted', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('{{pricing}} was successfully removed', { pricing: item.projectPricing.name, ns: _translation.TRANSLATION_FILES.translation })
                }));
                data.projectUnitPricings = newprojectUnitPricings;
                _context5.next = 31;
                return this.setComponentState({ data: data }, function () {
                  _this5.handleCheckChanges();
                  _this5.props.newFetch();
                });

              case 31:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[7, 12]]);
      }));

      function deleteUnitPricingTier(_x4) {
        return _ref5.apply(this, arguments);
      }

      return deleteUnitPricingTier;
    }()
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      var _this6 = this;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true }, function () {
          _this6.handleOnCheck(true);
        });
      }
    }
  }, {
    key: 'handleResetCheck',
    value: function handleResetCheck() {
      var _this7 = this;

      if (this.state.hasChanges) {
        this.setState({ hasChanges: false }, function () {
          _this7.handleOnCheck(false);
        });
      }
    }
  }, {
    key: 'hasEditAccess',
    value: function hasEditAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var user = this.props.auth;
      if (this.props.auth.isSuperAdmin || this.props.auth.isHeadquarters) {
        return true;
      }
      if (this.props.auth.isBranchLeaderSupervisorII && this.props.data && this.props.data.project.maOwnerCompanyBranchID === user.companyBranch.id) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var user = this.props.auth;
      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      if (this.props.auth.isBranchLeader && this.props.data && this.props.data.project.maOwnerCompanyBranchID === user.companyBranch.id) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasAccessInternal',
    value: function hasAccessInternal() {
      var auth = this.props.auth;
      if (auth && auth.companyBranch && !auth.companyBranch.isExternal) {
        return true;
      }
      return false;
    }
  }, {
    key: 'checkDisabled',
    value: function checkDisabled() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';
      var _state = this.state,
          pictures = _state.pictures,
          selectedPicture = _state.selectedPicture;

      if (selectedPicture) {
        var index = pictures.indexOf(selectedPicture);
        if (direction === 'left') {
          return index - 1 > 0;
        }
        return index + 1 < pictures.length;
      }
      return false;
    }
    // CPI-1377: HQ (and the platform admins) can release a hold another user has on this unit.
    // book-api refuses everyone else, so the button is only shown to those roles.

  }, {
    key: 'renderCustomFields',
    value: function renderCustomFields(isEditing) {
      var _state2 = this.state,
          data = _state2.data,
          unitCustomFieldSettings = _state2.unitCustomFieldSettings;
      var _props = this.props,
          appConfig = _props.appConfig,
          auth = _props.auth;

      if (data) {
        return _react2.default.createElement(
          'div',
          null,
          isEditing && _react2.default.createElement(_semanticUiReact.Divider, null),
          _react2.default.createElement(_CustomFieldForm2.default, {
            componentData: data,
            customFieldSettings: unitCustomFieldSettings,
            countryCode: auth && auth.company ? auth.company.countryCode : '',
            isEditing: isEditing,
            isBookingCustomField: false,
            onCustomInputChange: this.handleCustomInputChange,
            onCustomSelectChange: this.handleCustomSelectChange,
            hasProjectHimsEnabled: this.hasProjectHimsEnabled(data),
            hasHimsStrataEnabled: this.hasHimsStrataEnabled(data),
            vaIsEnabled: appConfig && appConfig.data && appConfig.data.settings && appConfig.data.settings.virtualAccountIsEnabled
          })
        );
      }
      return '';
    }
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var _props2 = this.props,
          isMobile = _props2.isMobile,
          t = _props2.t,
          onToggleQuotationPreview = _props2.onToggleQuotationPreview;
      var _state3 = this.state,
          calculatedFeePackages = _state3.calculatedFeePackages,
          companyBranches = _state3.companyBranches,
          data = _state3.data,
          editData = _state3.editData,
          globalSettings = _state3.globalSettings,
          oriData = _state3.oriData,
          packagePricingCalculation = _state3.packagePricingCalculation,
          showQuotationOpts = _state3.showQuotationOpts,
          unitCustomFieldSettings = _state3.unitCustomFieldSettings;
      var _state$collapseSegmen = this.state.collapseSegments,
          hideDocument = _state$collapseSegmen.hideDocument,
          hideGallery = _state$collapseSegmen.hideGallery,
          hidePricingPackage = _state$collapseSegmen.hidePricingPackage,
          hidePaymentSchedule = _state$collapseSegmen.hidePaymentSchedule,
          hideAdditionalFees = _state$collapseSegmen.hideAdditionalFees,
          hideMortgageCalculator = _state$collapseSegmen.hideMortgageCalculator;

      var user = this.props.auth;
      var countryCode = user && user.company && user.company.countryCode;
      var isMalaysia = user && user.company && user.company.countryCode.toUpperCase() === 'MY';
      // CPI-1230: the three Vietnam gates this screen reads; all three are false outside Vietnam.
      var isVietnam = (0, _vietnam.isVietnamCompany)(user);
      var isVnAgent = (0, _vietnam.isVietnamExternalAgent)(user);
      var canEditVnPricing = (0, _vietnam.hasVietnamElevatedAccess)(user) && this.props.auth.allowEditUnitPrice;
      // MS-6522: the project's own setting, else the global one, read the same way in every country.
      // On "Allocate to all" an unallocated unit offers the "All Agencies" pseudo-option; on
      // "Allocate to none" it does not, and the developer assigns an agency explicitly.
      var projectAgencyAllocationSetting = data.project && data.project.agencyAllocationAllocateAll;
      var agencyAllocationAllocateAll = typeof projectAgencyAllocationSetting === 'boolean' ? projectAgencyAllocationSetting : Boolean(globalSettings && globalSettings.agencyAllocationAllocateAll);
      var agencyAllocationIDs = data.companyBranchAllocationIDs || [];
      var showAllAgencies = agencyAllocationAllocateAll && agencyAllocationIDs.length === 0;
      var agencyOptions = showAllAgencies ? [{ text: t('All Agencies'), value: ALL_AGENCIES_VALUE }].concat(_toConsumableArray(companyBranches || [])) : companyBranches || [];
      var agencyValue = showAllAgencies ? [ALL_AGENCIES_VALUE] : agencyAllocationIDs;
      var renderAgencyLabel = function renderAgencyLabel(item) {
        return { content: item.text, active: false };
      };
      // CPI-1372: with the project's "Disable Base Selling Price" box ticked, a Vietnamese agency
      // user gets no price rows at all (list price, selling price before / after tax) - removed,
      // not dashed. The pricing-package, fee and mortgage segments below key off spaValue, which
      // book-api zeroes for the same caller, so they fall away with it.
      var hidePrices = (0, _vietnam.hidesPricesFromAgency)(user, data.project);
      var isAgencyAllocationLocked = isVietnam && ['reserved', 'booked', 'sold_spa_signed'].includes(oriData.statusID);
      var canViewPrice = !hidePrices && this.hasAccess(!this.hasAccessInternal() && data.statusID !== 'new' ? false : this.checkBookable(data.statusID, data.project));
      var listPrice = parseFloat(data.spaAmount) || 0;
      var vatPercentage = parseFloat(data.vatPercentage) || 0;
      var vatAmount = listPrice * (vatPercentage / 100);
      var sellingPriceBeforeTax = listPrice;
      var sellingPriceAfterTax = sellingPriceBeforeTax + vatAmount;
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            this.checkLaunchModeTimeout(data, user) && _react2.default.createElement(
              _semanticUiReact.Message,
              { size: 'mini', style: { textAlign: 'center', fontWeight: 'bold' } },
              _react2.default.createElement(
                _reactI18next.Trans,
                { ns: _translation.TRANSLATION_FILES.translation },
                'Unit is currently viewed by ',
                { user: data.reservedByUserPreferredName }
              ),
              (0, _unitHold.canForceReleaseUnitHold)(user) && _react2.default.createElement(
                'span',
                null,
                '\xA0',
                _react2.default.createElement(
                  _semanticUiReact.Button,
                  { size: 'mini', compact: true, basic: true, loading: this.state.loading, onClick: this.handleForceReleaseHold },
                  t('Release hold', { ns: _translation.TRANSLATION_FILES.translation })
                )
              )
            ),
            _react2.default.createElement(_ViewLarge2.default, {
              open: this.state.showLarge,
              onClose: this.handleCloseLarge,
              picture: this.state.selectedPicture,
              onSlide: this.handleSlidePicture,
              disabledLeft: !this.checkDisabled('left'),
              disabledRight: !this.checkDisabled('right'),
              slideshow: true
            }),
            _react2.default.createElement(_EditableBox2.default, {
              newHeader: t('Unit Information').toUpperCase(),
              isCollapsible: true,
              editable: this.hasEditAccess() && (this.props.auth.allowEditUnitDetails || this.props.auth.allowEditUnitPrice),
              isEditing: this.state.edit,
              onEdit: this.handleEditUnit,
              loading: this.state.loading,
              onClick: this.handleUpdateUnit,
              onCancel: this.handleResetUnit,
              content: function content(_ref6) {
                var isEditing = _ref6.isEditing,
                    onConfirm = _ref6.onConfirm;
                return _react2.default.createElement(
                  _AppForm2.default,
                  {
                    onSubmit: onConfirm,
                    error: _this8.state.errMessages.length > 0,
                    ref: function ref(_ref7) {
                      _this8.form = _ref7;
                    }
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Dimmer,
                    { style: { zIndex: 20 }, active: _this8.state.loading, inverted: true },
                    _react2.default.createElement(
                      _semanticUiReact.Loader,
                      { inline: 'centered' },
                      t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 16, computer: 16 },
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { verticalAlign: 'middle' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Row,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { width: 16, textAlign: 'center' },
                              _react2.default.createElement(
                                _semanticUiReact.Header,
                                { as: 'h2', textAlign: 'center' },
                                data.reference,
                                data.project && data.projectUnitLayout && _react2.default.createElement(
                                  _semanticUiReact.Header.Subheader,
                                  null,
                                  data.project.name,
                                  ', ',
                                  data.projectUnitLayout.name
                                )
                              ),
                              oriData.status && _react2.default.createElement(
                                'div',
                                { style: { display: 'inline-flex' } },
                                _react2.default.createElement(_semanticUiReact.Label, {
                                  size: 'large',
                                  className: 'white-text ' + _this8.getUnitStatus(),
                                  content: t(_this8.getStatusOptions().find(function (status) {
                                    return status.value === _this8.getUnitStatus();
                                  }).text, { ns: _translation.TRANSLATION_FILES.constants })
                                }),
                                oriData.statusID === 'delist' && oriData.delistOnHold && (_this8.hasAccessInternal() || !_this8.hasSimpleViewMode(data)) && _react2.default.createElement(
                                  'p',
                                  { className: 'unit-info_description-text' },
                                  'On Hold'
                                )
                              ),
                              data.project && data.project.activeBookingsInUnits && _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                null,
                                _react2.default.createElement(_semanticUiReact.Label, {
                                  size: 'large',
                                  style: { background: 'transparent', border: '1px solid black', marginTop: '10px' },
                                  content: t('Active Bookings') + ': ' + _this8.countActiveBooking()
                                })
                              ),
                              oriData.status && _this8.hasAccess() && _unitStatuses.UNIT_STATUSES_HQ_DEVELOPER.some(function (status) {
                                return status.value === oriData.statusID;
                              }) && _react2.default.createElement(
                                'p',
                                null,
                                t('Outside MHub')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { width: 16 },
                              _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, className: 'tablet-hide' })
                            )
                          )
                        ),
                        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, className: 'large-hide small-hide' })
                      ),
                      isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 8, computer: 8 },
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Unit Number')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            _react2.default.createElement(_AppForm2.default.Input, {
                              fluid: true,
                              onChange: _this8.handleChange,
                              placeholder: t('Unit Number'),
                              name: 'reference',
                              value: data.reference,
                              ref: _this8.validation.reference,
                              validateLabel: t('Unit Number'),
                              validation: [_webValidations.required]
                            })
                          )
                        ),
                        _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider })
                      ) : null,
                      isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 8, computer: 8 },
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { verticalAlign: 'middle' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Status')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            _this8.checkStatusDropDown(data.statusID) ? _react2.default.createElement(
                              _AppForm2.default.Validate,
                              {
                                validation: [_webValidations.required],
                                validateLabel: t('Status'),
                                ref: _this8.validation.statusID,
                                onChange: _this8.handleChange
                              },
                              _react2.default.createElement(_semanticUiReact.Form.Select, {
                                name: 'statusID',
                                search: true,
                                fluid: true,
                                value: data.statusID,
                                options: _this8.statuses.map(function (s) {
                                  return _extends({}, s, {
                                    text: t(s.text, { ns: _translation.TRANSLATION_FILES.constants })
                                  });
                                }),
                                onChange: _this8.handleChange
                              })
                            ) : _react2.default.createElement(_AppForm2.default.Input, {
                              name: 'statusID',
                              disabled: true,
                              value: data.status ? data.status.name : ''
                            })
                          )
                        ),
                        _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider })
                      ) : null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 8, computer: 8 },
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { verticalAlign: 'middle' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Project')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(_AppForm2.default.Input, {
                              fluid: true,
                              name: 'projectID',
                              value: data.project ? data.project.name : '',
                              disabled: true
                            }) : _react2.default.createElement(
                              _reactRouter.Link,
                              { to: '/projects/' + _this8.props.id + '/' },
                              data.project ? data.project.name : ''
                            )
                          )
                        ),
                        _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { verticalAlign: 'middle' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Layout Type')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(
                              _AppForm2.default.Validate,
                              {
                                validation: [_webValidations.required],
                                validateLabel: t('Layout Type'),
                                ref: _this8.validation.projectUnitLayoutID,
                                onChange: _this8.handleChange
                              },
                              _react2.default.createElement(_semanticUiReact.Form.Select, {
                                name: 'projectUnitLayoutID',
                                search: true,
                                fluid: true,
                                text: data.projectUnitLayoutID ? null : t('Select layout type'),
                                value: data.projectUnitLayoutID,
                                options: _this8.state.unitLayouts,
                                disabled: _this8.state.unitLayouts.length === 0,
                                onChange: _this8.handleChange
                              })
                            ) : data.projectUnitLayout && _react2.default.createElement(
                              _reactRouter.Link,
                              {
                                to: '/projects/' + _this8.props.id + '/layouts/' + data.projectUnitLayoutID + '/'
                              },
                              data.projectUnitLayout.name
                            )
                          )
                        ),
                        isVietnam && !isVnAgent && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        isVietnam && !isVnAgent && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Unit Layout')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(_AppForm2.default.Input, {
                              fluid: true,
                              name: 'unitLayoutNew',
                              onChange: _this8.handleChange,
                              placeholder: '2PN-2WC',
                              value: data.unitLayoutNew || '',
                              ref: _this8.validation.unitLayoutNew
                            }) : _react2.default.createElement(
                              'p',
                              null,
                              data.unitLayoutNew || '-'
                            )
                          )
                        ),
                        _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              (0, _areaLabel.getAreaModelLabel)(t, countryCode)
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(_AppForm2.default.Input, {
                              fluid: true,
                              validateLabel: t('Built up Area'),
                              name: 'size',
                              onChange: _this8.handleChange,
                              type: 'number',
                              placeholder: t('Built up Area'),
                              step: '0.0001',
                              value: data.size,
                              ref: _this8.validation.size,
                              validation: [_webValidations.required, {
                                validate: _webValidations.numericRange,
                                option: {
                                  min: 1
                                }
                              }]
                            }) : _react2.default.createElement(_SizeSuffix2.default, {
                              size: data.size,
                              suffix: data.project ? data.project.sizeSuffix : null,
                              isVietnam: isVietnam
                            })
                          )
                        ),
                        _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              (0, _areaLabel.getLandAreaModelLabel)(t, countryCode)
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(_AppForm2.default.Input, {
                              fluid: true,
                              name: 'landArea',
                              onChange: _this8.handleChange,
                              type: 'number',
                              placeholder: t('Land Area'),
                              step: '0.0001',
                              value: data.landArea,
                              ref: _this8.validation.landArea
                            }) : _react2.default.createElement(_SizeSuffix2.default, {
                              size: data.landArea,
                              suffix: data.project ? data.project.sizeSuffix : null,
                              isVietnam: isVietnam
                            })
                          )
                        ),
                        isVietnam && !isVnAgent && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        isVietnam && !isVnAgent && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('View')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(_AppForm2.default.Input, {
                              fluid: true,
                              name: 'view',
                              onChange: _this8.handleChange,
                              placeholder: 'SE',
                              value: data.view || '',
                              ref: _this8.validation.view
                            }) : _react2.default.createElement(
                              'p',
                              null,
                              data.view || '-'
                            )
                          )
                        ),
                        isEditing && _this8.props.auth.allowEditUnitDetails && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { verticalAlign: 'middle' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Unit/Position')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            _react2.default.createElement(_AppForm2.default.Input, {
                              validateLabel: t('Unit/Position'),
                              name: 'position',
                              type: 'number',
                              value: data.position,
                              onChange: _this8.handleChange,
                              ref: _this8.validation.position,
                              validation: [{
                                validate: _webValidations.numericRange,
                                option: {
                                  min: 1
                                }
                              }]
                            })
                          )
                        ) : null,
                        isEditing && _this8.props.auth.allowEditUnitDetails && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { verticalAlign: 'middle' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('ColSpan')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            _react2.default.createElement(_AppForm2.default.Input, {
                              validateLabel: t('ColSpan'),
                              name: 'colSpan',
                              type: 'number',
                              value: data.colSpan,
                              onChange: _this8.handleChange,
                              ref: _this8.validation.colSpan,
                              validation: [{
                                validate: _webValidations.numericRange,
                                option: {
                                  min: 1
                                }
                              }]
                            })
                          )
                        ) : null,
                        (data.address && !isEditing || isEditing) && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        (data.address && !isEditing || isEditing) && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Address')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                              name: 'address',
                              value: data.address,
                              onChange: _this8.handleChange
                            }) : _react2.default.createElement(
                              _MarkdownText2.default,
                              null,
                              data.address || '-'
                            )
                          )
                        ),
                        isMalaysia && (isEditing || data.isBumi) && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        isMalaysia && isEditing && _this8.props.auth.allowEditUnitDetails && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Bumiputera')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            _react2.default.createElement(
                              _semanticUiReact.Form.Group,
                              null,
                              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                label: t('Bumiputera Unit'),
                                name: 'isBumi',
                                checked: _this8.state.data.isBumi,
                                onChange: _this8.handleCheckBoxChange
                              })
                            )
                          )
                        ),
                        isMalaysia && (!isEditing || isEditing && !_this8.props.auth.allowEditUnitDetails) && data.isBumi && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Bumiputera')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            t('Yes', { ns: _translation.TRANSLATION_FILES.constants })
                          )
                        ),
                        isVietnam && !isVnAgent && (isEditing || !isEditing) && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        isVietnam && !isVnAgent && isEditing && _this8.props.auth.allowEditUnitDetails && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Foreign restricted')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            _react2.default.createElement(
                              _semanticUiReact.Form.Group,
                              null,
                              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                label: t('Foreign restricted unit'),
                                name: 'isBumi',
                                checked: _this8.state.data.isBumi,
                                onChange: _this8.handleCheckBoxChange
                              })
                            )
                          )
                        ),
                        isVietnam && !isVnAgent && (!isEditing || isEditing && !_this8.props.auth.allowEditUnitDetails) && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Foreign restricted')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            data.isBumi ? t('Yes', { ns: _translation.TRANSLATION_FILES.constants }) : t('No', { ns: _translation.TRANSLATION_FILES.constants })
                          )
                        ),
                        isMalaysia && (isEditing || data.isTenanted) && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        isMalaysia && isEditing && _this8.props.auth.allowEditUnitDetails && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Tenanted')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            _react2.default.createElement(
                              _semanticUiReact.Form.Group,
                              null,
                              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                label: t('Tenanted Unit'),
                                name: 'isTenanted',
                                checked: _this8.state.data.isTenanted,
                                onChange: _this8.handleCheckBoxChange
                              })
                            )
                          )
                        ),
                        isMalaysia && (!isEditing || isEditing && !_this8.props.auth.allowEditUnitDetails) && data.isTenanted && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Tenanted')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            t('Yes', { ns: _translation.TRANSLATION_FILES.constants })
                          )
                        ),
                        isMalaysia && (isEditing || data.isMalayReserved) && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        isMalaysia && isEditing && _this8.props.auth.allowEditUnitDetails && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Malay Reserved')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            _react2.default.createElement(
                              _semanticUiReact.Form.Group,
                              null,
                              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                label: t('Malay Reserved'),
                                name: 'isMalayReserved',
                                checked: _this8.state.data.isMalayReserved,
                                onChange: _this8.handleCheckBoxChange
                              })
                            )
                          )
                        ),
                        isMalaysia && (!isEditing || isEditing && !_this8.props.auth.allowEditUnitDetails) && data.isMalayReserved && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Malay Reserved')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            t('Yes', { ns: _translation.TRANSLATION_FILES.constants })
                          )
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 8, computer: 8 },
                        !isVietnam && (data.hsd && !isEditing || isEditing) && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('HSD')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(_AppForm2.default.Input, {
                              fluid: true,
                              name: 'hsd',
                              onChange: _this8.handleChange,
                              value: data.hsd,
                              ref: _this8.validation.hsd
                            }) : _react2.default.createElement(
                              'p',
                              null,
                              data.hsd || '-'
                            )
                          )
                        ),
                        !isVietnam && (data.hsd && !isEditing || isEditing) && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        !isVietnam && (data.ptd && !isEditing || isEditing) && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('PTD')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(_AppForm2.default.Input, {
                              fluid: true,
                              name: 'ptd',
                              onChange: _this8.handleChange,
                              value: data.ptd,
                              ref: _this8.validation.ptd
                            }) : _react2.default.createElement(
                              'p',
                              null,
                              data.ptd || '-'
                            )
                          )
                        ),
                        !isVietnam && (data.ptd && !isEditing || isEditing) && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        !isVietnam && (data.geran && !isEditing || isEditing) && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Geran')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(_AppForm2.default.Input, {
                              fluid: true,
                              name: 'geran',
                              onChange: _this8.handleChange,
                              value: data.geran,
                              ref: _this8.validation.geran
                            }) : _react2.default.createElement(
                              'p',
                              null,
                              data.geran || '-'
                            )
                          )
                        ),
                        !isVietnam && (data.geran && !isEditing || isEditing) && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        !isVietnam && (data.lot && !isEditing || isEditing) && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Lot')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(_AppForm2.default.Input, {
                              fluid: true,
                              name: 'lot',
                              onChange: _this8.handleChange,
                              value: data.lot,
                              ref: _this8.validation.lot
                            }) : _react2.default.createElement(
                              'p',
                              null,
                              data.lot || '-'
                            )
                          )
                        ),
                        !isVietnam && !isVnAgent && (data.lot && !isEditing || isEditing) && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        !isVietnam && !isVnAgent && (data.referenceCode && !isEditing || isEditing) && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Reference Code')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(_AppForm2.default.Input, {
                              fluid: true,
                              name: 'referenceCode',
                              onChange: _this8.handleChange,
                              value: data.referenceCode,
                              ref: _this8.validation.referenceCode
                            }) : _react2.default.createElement(
                              'p',
                              null,
                              data.referenceCode || '-'
                            )
                          )
                        ),
                        !isVietnam && !isVnAgent && (data.referenceCode && !isEditing || isEditing) && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        (data.zoneOrBlock && !isEditing || isEditing) && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t(data.project && data.project.propertyCategory.category === _propertyCategories.PROPERTY_CATEGORY_HIGH_RISE ? 'Block' : 'Zone')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(_AppForm2.default.Input, {
                              fluid: true,
                              name: 'zoneOrBlock',
                              onChange: _this8.handleChange,
                              value: data.zoneOrBlock,
                              ref: _this8.validation.zoneOrBlock
                            }) : _react2.default.createElement(
                              'p',
                              null,
                              data.zoneOrBlock || '-'
                            )
                          )
                        ),
                        (data.zoneOrBlock && !isEditing || isEditing) && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        (data.streetNumberOrLevel && !isEditing || isEditing) && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t(data.project && data.project.propertyCategory.category === _propertyCategories.PROPERTY_CATEGORY_HIGH_RISE ? 'Level' : 'Street Number')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(_AppForm2.default.Input, {
                              fluid: true,
                              name: 'streetNumberOrLevel',
                              onChange: _this8.handleChange,
                              value: data.streetNumberOrLevel,
                              ref: _this8.validation.streetNumberOrLevel
                            }) : _react2.default.createElement(
                              'p',
                              null,
                              data.streetNumberOrLevel || '-'
                            )
                          )
                        ),
                        !isVnAgent && (data.streetNumberOrLevel && !isEditing || isEditing) && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        !isVnAgent && (data.streetOrFacing && !isEditing || isEditing) && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t(data.project && data.project.propertyCategory.category === _propertyCategories.PROPERTY_CATEGORY_HIGH_RISE ? 'Facing' : 'Street')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(_AppForm2.default.Input, {
                              fluid: true,
                              name: 'streetOrFacing',
                              onChange: _this8.handleChange,
                              value: data.streetOrFacing,
                              ref: _this8.validation.streetOrFacing
                            }) : _react2.default.createElement(
                              'p',
                              null,
                              data.streetOrFacing || '-'
                            )
                          )
                        ),
                        isVietnam && !isVnAgent && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        isVietnam && !isVnAgent && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Land Value')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && canEditVnPricing ? _react2.default.createElement(_AppForm2.default.Input, {
                              fluid: true,
                              validateLabel: t('Land Value'),
                              name: 'landValue',
                              onChange: _this8.handleChange,
                              type: 'number',
                              placeholder: t('Land Value'),
                              step: '0.01',
                              value: data.landValue,
                              ref: _this8.validation.landValue,
                              validation: [{
                                validate: _webValidations.numericRange,
                                option: {
                                  min: 0
                                }
                              }]
                            }) : data.landValue && data.project ? _react2.default.createElement(_LoanAmount2.default, {
                              projectCurrencies: data.project.projectCurrency,
                              format: '0,000,000.00',
                              amount: data.landValue,
                              prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                            }) : _react2.default.createElement(
                              'p',
                              null,
                              '-'
                            )
                          )
                        ),
                        (data.streetOrFacing && !isEditing || isEditing) && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        canViewPrice && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              isVietnam ? t('List Price') : globalSettings && globalSettings.sellingPrice ? globalSettings.sellingPrice : t('Selling Price')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && _this8.props.auth.allowEditUnitPrice ? _react2.default.createElement(_AppForm2.default.Input, {
                              validateLabel: isVietnam ? t('List Price') : globalSettings && globalSettings.sellingPrice ? globalSettings.sellingPrice : t('Selling Price'),
                              name: 'spaAmount',
                              type: 'number',
                              step: '0.01',
                              pattern: '^\\d+(?:\\.\\d{1,2})?$',
                              value: data.spaAmount,
                              onChange: _this8.handleChange,
                              ref: _this8.validation.spaAmount,
                              validation: [_webValidations.required, {
                                validate: _webValidations.numericRange,
                                option: {
                                  min: 1
                                }
                              }]
                            }) : null,
                            (!isEditing || !_this8.props.auth.allowEditUnitPrice) && (data.spaValue ? _react2.default.createElement(_LoanAmount2.default, {
                              projectCurrencies: data.project.projectCurrency,
                              format: '0,000,000.00',
                              amount: data.spaAmount,
                              prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                            }) : '-')
                          )
                        ),
                        canViewPrice && _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                        !isVnAgent && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { verticalAlign: 'middle' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 10 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Price'),
                              ' per ',
                              _this8.checkSizeSuffix()
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { width: 6 },
                            _react2.default.createElement(
                              'div',
                              { style: { textAlign: 'right' } },
                              data.size > 0 ? _react2.default.createElement(_LoanAmount2.default, {
                                projectCurrencies: data.project.projectCurrency,
                                format: '0,000,000.00',
                                amount: (data.spaAmount / data.size).toFixed(2),
                                prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                              }) : '-'
                            )
                          )
                        ),
                        isVietnam && !isVnAgent && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        isVietnam && !isVnAgent && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('VAT %')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && canEditVnPricing ? _react2.default.createElement(_AppForm2.default.Input, {
                              fluid: true,
                              validateLabel: t('VAT %'),
                              name: 'vatPercentage',
                              onChange: _this8.handleChange,
                              type: 'number',
                              placeholder: t('VAT %'),
                              step: '0.001',
                              value: data.vatPercentage,
                              ref: _this8.validation.vatPercentage,
                              validation: [{
                                validate: _webValidations.numericRange,
                                option: {
                                  min: 0,
                                  max: 100
                                }
                              }]
                            }) : _react2.default.createElement(
                              'p',
                              null,
                              data.vatPercentage ? data.vatPercentage + '%' : '-'
                            )
                          )
                        ),
                        canViewPrice && isVietnam && !isVnAgent && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        canViewPrice && isVietnam && !isVnAgent && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('VAT Amount', { ns: _translation.TRANSLATION_FILES.translation })
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            _react2.default.createElement(_LoanAmount2.default, {
                              projectCurrencies: data.project ? data.project.projectCurrency : [],
                              format: '0,000,000.00',
                              amount: vatAmount,
                              prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                            })
                          )
                        ),
                        canViewPrice && isVietnam && !isVnAgent && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        canViewPrice && isVietnam && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Selling Price (Before Tax)', { ns: _translation.TRANSLATION_FILES.translation })
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            _react2.default.createElement(_LoanAmount2.default, {
                              projectCurrencies: data.project ? data.project.projectCurrency : [],
                              format: '0,000,000.00',
                              amount: sellingPriceBeforeTax,
                              prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                            })
                          )
                        ),
                        canViewPrice && isVietnam && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        canViewPrice && isVietnam && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Selling Price (After Tax)', { ns: _translation.TRANSLATION_FILES.translation })
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            _react2.default.createElement(_LoanAmount2.default, {
                              projectCurrencies: data.project ? data.project.projectCurrency : [],
                              format: '0,000,000.00',
                              amount: sellingPriceAfterTax,
                              prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                            })
                          )
                        ),
                        data.statusID === 'delist' && data.delistReason && _react2.default.createElement(
                          _react2.default.Fragment,
                          null,
                          _react2.default.createElement(_semanticUiReact.Divider, { style: { margin: '0.5em 0' } }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 10 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Delist Reason')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { width: 6 },
                              _react2.default.createElement(
                                'div',
                                { style: { textAlign: 'right' } },
                                data.delistReason.label || t('No Reason')
                              )
                            )
                          )
                        )
                      )
                    ),
                    (data.remarkExternal || data.remarkInternal || isEditing) && _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 8, computer: 8 },
                        _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        (data.remarkExternal && !isEditing || isEditing) && _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Notes')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                              name: 'remarkExternal',
                              value: data.remarkExternal,
                              onChange: _this8.handleChange
                            }) : _react2.default.createElement(
                              _MarkdownText2.default,
                              null,
                              data.remarkExternal || '-'
                            )
                          )
                        )
                      ),
                      !isVnAgent && (data.remarkInternal || isEditing) && _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 8, computer: 8 },
                        _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Remark for internal staff')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing && _this8.props.auth.allowEditUnitDetails ? _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                              name: 'remarkInternal',
                              value: data.remarkInternal,
                              onChange: _this8.handleChange
                            }) : _react2.default.createElement(
                              _MarkdownText2.default,
                              null,
                              data.remarkInternal || '-'
                            )
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      isEditing && _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 8, computer: 8 },
                        _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Virtual Tour URL')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            _react2.default.createElement(_AppForm2.default.Input, {
                              name: 'virtualTourURL',
                              value: data.virtualTourURL,
                              placeholder: data.projectUnitLayout ? data.projectUnitLayout.virtualTourURL : '',
                              onChange: _this8.handleChange,
                              ref: _this8.validation.virtualTourURL
                            })
                          )
                        )
                      ),
                      _this8.hasAccessInternal() && _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 8, computer: 8 },
                        _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'left', width: 6 },
                            _react2.default.createElement(
                              'b',
                              null,
                              t('Agency')
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { textAlign: 'right', width: 10 },
                            isEditing ? companyBranches ? _react2.default.createElement(_semanticUiReact.Dropdown, {
                              name: 'companyBranchAllocationIDs',
                              onChange: _this8.handleChange,
                              placeholder: t('Select Agency'),
                              fluid: true,
                              multiple: true,
                              search: true,
                              selection: true,
                              selectOnBlur: false,
                              renderLabel: renderAgencyLabel,
                              options: agencyOptions,
                              value: agencyValue,
                              disabled: isAgencyAllocationLocked,
                              ref: _this8.validation.companyBranchAllocationIDs
                            }) : '' : _react2.default.createElement(
                              'p',
                              { style: { whiteSpace: 'pre-line' } },
                              data.companyBranchAllocationIDs ? _this8.valueArrayToText(companyBranches, data.companyBranchAllocationIDs) : '-'
                            )
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 16 },
                        unitCustomFieldSettings && unitCustomFieldSettings.length > 0 ? _this8.renderCustomFields(isEditing) : ''
                      )
                    )
                  )
                );
              }
            }),
            !isVietnam && data.spaValue > 0 && data.project && data.project.paymentPlanFlow ? _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }) : '',
            !isVietnam && data.spaValue > 0 && data.project && data.project.paymentPlanFlow ? _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 16, style: isMobile ? { padding: '0' } : {} },
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  {
                    className: 'new_title',
                    as: 'h5',
                    textAlign: 'center',
                    attached: 'top'
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 16, textAlign: 'center' },
                        t('Payment Schedule').toUpperCase()
                      ),
                      _react2.default.createElement(_semanticUiReact.Label, {
                        as: 'button',
                        attached: 'top right',
                        icon: hidePaymentSchedule ? 'angle up' : 'angle down',
                        className: 'collapse-button',
                        style: {
                          position: 'absolute',
                          right: '0',
                          top: '3px',
                          marginRight: '0',
                          marginTop: '0.5em'
                        },
                        name: 'hidePaymentSchedule',
                        value: hidePaymentSchedule,
                        onClick: this.handleOnCollapseSegment,
                        disabled: this.state.loading
                      })
                    )
                  )
                ),
                !hidePaymentSchedule ? _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { attached: true },
                  _react2.default.createElement(_PaymentPlanForm2.default, {
                    bookingData: {
                      projectID: oriData.projectID,
                      project: oriData.project,
                      projectUnitID: oriData.id,
                      spaValue: oriData.spaValue,
                      spaDecimal: oriData.spaDecimal,
                      spaFull: oriData.spaFull,
                      spaTimes: oriData.spaTimes,
                      statusID: 'reserved'
                    },
                    token: this.props.token
                  })
                ) : null
              )
            ) : '',
            data.spaValue > 0 ? _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }) : '',
            data.spaValue > 0 ? _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 16, style: isMobile ? { padding: '0' } : {} },
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  {
                    className: 'new_title',
                    as: 'h5',
                    textAlign: 'center',
                    attached: 'top'
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { id: 'pricing_package_div', width: 16, textAlign: 'center' },
                        t('Pricing Package').toUpperCase()
                      ),
                      _react2.default.createElement(_semanticUiReact.Label, {
                        as: 'button',
                        attached: 'top right',
                        icon: hidePricingPackage ? 'angle up' : 'angle down',
                        className: 'collapse-button',
                        style: {
                          position: 'absolute',
                          right: '0',
                          top: '3px',
                          marginRight: '0',
                          marginTop: '0.5em'
                        },
                        name: 'hidePricingPackage',
                        value: hidePricingPackage,
                        onClick: this.handleOnCollapseSegment,
                        disabled: this.state.loading
                      })
                    )
                  )
                ),
                !hidePricingPackage ? _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { attached: true },
                  _react2.default.createElement(_ProjectUnitPackagePricing.ProjectUnitPackagePricing, {
                    calculatePackagePricing: packagePricingCalculation || [],
                    data: this.getUnitPackagePricings(),
                    hasEditAccess: this.hasEditAccess() && this.props.auth.allowEditUnitPrice,
                    hasPreviewPriceAccess: this.props.hasPreviewPriceAccess,
                    hasGenerateQuotationAccess: this.props.hasGenerateQuotationAccess,
                    isBumiUnit: data.isBumi,
                    newFetch: this.props.newFetch,
                    onToggleQuotationPreview: onToggleQuotationPreview,
                    packagePricings: this.getProjectPackagePricings(),
                    projectCurrencies: data.project.projectCurrency,
                    projectDefaultBFP: data.project.defaultBookingFeeAmount,
                    projectDefaultBumiPackagePricingID: data.project.defaultBumiProjectPackagePricingID,
                    projectDefaultPackagePricingID: data.project.defaultProjectPackagePricingID,
                    projectID: data.project.id || '',
                    projectName: data.project.name,
                    projectQuatationCode: data.project.quotnProjectCode,
                    showQuotationOpts: showQuotationOpts,
                    spaValue: (0, _amount.spaFullNumber)(data) || 0,
                    token: this.props.token,
                    unitID: data.id || '',
                    unitReference: data.reference,
                    isMobile: isMobile
                  })
                ) : null
              )
            ) : '',
            data.spaValue > 0 ? _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }) : '',
            data.spaValue > 0 ? _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 16, style: isMobile ? { padding: '0' } : {} },
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  {
                    className: 'new_title',
                    as: 'h5',
                    textAlign: 'center',
                    attached: 'top'
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 16, textAlign: 'center' },
                        t('Additional Fees').toUpperCase()
                      ),
                      _react2.default.createElement(_semanticUiReact.Label, {
                        as: 'button',
                        attached: 'top right',
                        icon: hideAdditionalFees ? 'angle up' : 'angle down',
                        className: 'collapse-button',
                        style: {
                          position: 'absolute',
                          right: '0',
                          top: '3px',
                          marginRight: '0',
                          marginTop: '0.5em'
                        },
                        name: 'hideAdditionalFees',
                        value: hideAdditionalFees,
                        onClick: this.handleOnCollapseSegment,
                        disabled: this.state.loading
                      })
                    )
                  )
                ),
                !hideAdditionalFees ? _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { attached: true },
                  _react2.default.createElement(_ProjectUnitPackageFee.ProjectUnitPackageFee, {
                    data: this.getUnitPackageFees(),
                    hasEditAccess: this.hasEditAccess() && this.props.auth.allowEditUnitPrice,
                    feePackages: this.getProjectFeePackages(),
                    projectCurrencies: data.project.projectCurrency,
                    projectID: data.project.id || '',
                    spaValue: (0, _amount.spaFullNumber)(data) || 0,
                    unitID: data.id || '',
                    newFetch: this.props.newFetch,
                    token: this.props.token,
                    calculateFeePackage: calculatedFeePackages || [],
                    hasPreviewPriceAccess: this.props.hasPreviewPriceAccess
                  })
                ) : null
              )
            ) : '',
            this.hasAccess() && this.props.auth.isAdminBasic && data.spaValue > 0 ? _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }) : '',
            this.hasAccess() && this.props.auth.isAdminBasic && data.spaValue > 0 ? _react2.default.createElement(_EditableBox2.default, {
              newHeader: (t('Discount Pricing') + ' (' + t('Old') + ')').toUpperCase(),
              isCollapsible: true,
              editable: this.hasEditAccess() && this.props.auth.allowEditUnitPrice,
              isEditing: this.state.editTier,
              onEdit: this.handleEditTier,
              loading: this.state.loading,
              onClick: this.handleUpdateUnit,
              onCancel: this.handleResetTier,
              content: function content(_ref8) {
                var isEditing = _ref8.isEditing;
                return _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Dimmer,
                    { style: { zIndex: 20 }, active: _this8.state.loading, inverted: true },
                    _react2.default.createElement(
                      _semanticUiReact.Loader,
                      { inline: 'centered' },
                      t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                    )
                  ),
                  isEditing ? _react2.default.createElement(
                    _semanticUiReact.Grid,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { textAlign: 'center' },
                        _react2.default.createElement(_ProjectUnitPricingTier2.default, {
                          data: _this8.getProjectUnitTiers(),
                          projectTiers: _this8.getProjectTiers(),
                          onDelete: _this8.handleUnitPricingTierDelete,
                          onChangeData: _this8.handleUnitPricingTierChange
                        })
                      )
                    )
                  ) : _react2.default.createElement(_ProjectUnitPricingTier.ProjectUnitPricingTierView, {
                    projectCurrencies: data.project.projectCurrency,
                    tiers: _this8.getProjectUnitTiers(),
                    spaValue: (0, _amount.spaFullNumber)(data) || 0,
                    sellingPriceCustomName: globalSettings && globalSettings.sellingPrice
                  })
                );
              }
            }) : '',
            data.spaValue > 0 && this.props.auth && !(0, _companies.isForeignCompany)(this.props.auth.company) ? _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }) : '',
            data.spaValue > 0 && this.props.auth && !(0, _companies.isForeignCompany)(this.props.auth.company) ? _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 16, style: isMobile ? { padding: '0' } : {} },
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  {
                    className: 'new_title',
                    as: 'h5',
                    textAlign: 'center',
                    attached: 'top'
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Grid,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { width: 16, textAlign: 'center' },
                        'MORTGAGE CALCULATOR'
                      ),
                      _react2.default.createElement(_semanticUiReact.Label, {
                        as: 'button',
                        attached: 'top right',
                        icon: hideMortgageCalculator ? 'angle up' : 'angle down',
                        className: 'collapse-button',
                        style: {
                          position: 'absolute',
                          right: '0',
                          top: '3px',
                          marginRight: '0',
                          marginTop: '0.5em'
                        },
                        name: 'hideMortgageCalculator',
                        value: hideMortgageCalculator,
                        onClick: this.handleOnCollapseSegment,
                        disabled: this.state.loading
                      })
                    )
                  )
                ),
                !hideMortgageCalculator && this.props.auth && !(0, _companies.isForeignCompany)(this.props.auth.company) ? _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { attached: true },
                  _react2.default.createElement(_MortgageCalculator2.default, {
                    packagePricings: this.getUnitPackagePricings(),
                    projectCurrencies: data.project.projectCurrency,
                    projectID: data.project.id || '',
                    spaValue: (0, _amount.spaFullNumber)(data) || 0,
                    unitID: data.id || '',
                    token: this.props.token,
                    isMobile: isMobile,
                    unitData: data,
                    userAuth: this.props.auth
                  })
                ) : null
              )
            ) : ''
          )
        ),
        data.projectUnitLayout ? _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              this.checkUnitSpecificationAccess(editData) ? _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_SpecificationTable2.default, {
                    newHeader: t('Unit Specification').toUpperCase(),
                    isCollapsible: true,
                    type: 'units',
                    data: editData.specifications,
                    editable: this.hasEditAccess(),
                    loading: this.state.loading,
                    onChange: this.handleSpecificationsChange,
                    onClick: this.handleUpdateUnitLayout,
                    onCancel: this.handleResetUnitLayout,
                    notFoundNode: _react2.default.createElement(
                      'p',
                      null,
                      t('No specifications set'),
                      '.'
                    )
                  })
                )
              ) : null,
              data.projectUnitLayout.specifications && data.projectUnitLayout.specifications.length > 0 ? _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_SpecificationTable2.default, {
                    newHeader: t('Layout information').toUpperCase(),
                    isCollapsible: true,
                    type: 'unit_layouts',
                    data: data.projectUnitLayout.specifications,
                    loading: this.state.loading,
                    notFoundNode: _react2.default.createElement(
                      'p',
                      null,
                      t('No information set'),
                      '.'
                    )
                  })
                )
              ) : null,
              data.projectUnitLayout.documents && data.projectUnitLayout.documents.length > 0 ? _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 16, style: isMobile ? { padding: '0' } : {} },
                  _react2.default.createElement(
                    _semanticUiReact.Header,
                    {
                      className: 'new_title',
                      as: 'h5',
                      textAlign: 'center',
                      attached: 'top'
                    },
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 16, textAlign: 'center' },
                          t('Documents').toUpperCase()
                        ),
                        _react2.default.createElement(_semanticUiReact.Label, {
                          as: 'button',
                          attached: 'top right',
                          icon: hideDocument ? 'angle up' : 'angle down',
                          className: 'collapse-button',
                          style: {
                            position: 'absolute',
                            right: '0',
                            top: '3px',
                            marginRight: '0',
                            marginTop: '0.5em'
                          },
                          name: 'hideDocument',
                          value: hideDocument,
                          onClick: this.handleOnCollapseSegment,
                          disabled: this.state.loading
                        })
                      )
                    )
                  ),
                  !hideDocument ? _react2.default.createElement(
                    _semanticUiReact.Segment,
                    { attached: true },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Segment.Group,
                          null,
                          data.projectUnitLayout.documents.map(function (file, idx) {
                            return _react2.default.createElement(
                              _semanticUiReact.Segment,
                              { key: idx },
                              _react2.default.createElement(
                                _semanticUiReact.Grid,
                                {
                                  columns: 'equal',
                                  verticalAlign: 'middle',
                                  as: 'a',
                                  href: _config2.default.get('bookApiURL') + '/documents/' + file.id + '/view/' + encodeURIComponent(file.name) + '.pdf',
                                  target: '_blank',
                                  rel: 'noopener noreferrer'
                                },
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  null,
                                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'file pdf outline' }),
                                  file.name,
                                  _react2.default.createElement(
                                    'span',
                                    { className: 'mobile-hide' },
                                    ' (',
                                    (0, _fileSize2.default)(file.size),
                                    ')'
                                  ),
                                  _react2.default.createElement(
                                    'small',
                                    { className: 'large-hide small-hide tablet-hide' },
                                    _react2.default.createElement('br', null),
                                    (0, _fileSize2.default)(file.size)
                                  )
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { textAlign: 'right' },
                                  _react2.default.createElement(
                                    'small',
                                    null,
                                    _react2.default.createElement(_Timestamp2.default, { format: 'DD/MM/YY hh:mm a', timestamp: file.createdAt })
                                  )
                                )
                              )
                            );
                          })
                        )
                      )
                    )
                  ) : null
                )
              ) : null,
              data.projectUnitLayout.pictures && data.projectUnitLayout.pictures.some(function (p) {
                return p.type === 'general' || p.type === 'unit_layout';
              }) && data.projectUnitLayout.pictures.length > 0 ? _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { width: 16, style: isMobile ? { padding: '0' } : {} },
                  _react2.default.createElement(
                    _semanticUiReact.Header,
                    {
                      className: 'new_title',
                      as: 'h5',
                      textAlign: 'center',
                      attached: 'top'
                    },
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 16, textAlign: 'center' },
                          t('Gallery').toUpperCase()
                        ),
                        _react2.default.createElement(_semanticUiReact.Label, {
                          as: 'button',
                          attached: 'top right',
                          icon: hideGallery ? 'angle up' : 'angle down',
                          className: 'collapse-button',
                          style: {
                            position: 'absolute',
                            right: '0',
                            top: '3px',
                            marginRight: '0',
                            marginTop: '0.5em'
                          },
                          name: 'hideGallery',
                          value: hideGallery,
                          onClick: this.handleOnCollapseSegment,
                          disabled: this.state.loading
                        })
                      )
                    )
                  ),
                  !hideGallery ? _react2.default.createElement(
                    _semanticUiReact.Segment,
                    { attached: true },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        null,
                        _react2.default.createElement(_GalleryList2.default, {
                          pictures: [].concat(data.projectUnitLayout.pictures || [], data.projectUnitLayout.medias || []),
                          projectID: this.props.id,
                          unitLayoutID: data.projectUnitLayoutID,
                          loading: this.state.loading,
                          excludeType: ['site_plan', 'map'],
                          tabular: this.state.galleryIsTab,
                          onViewLarge: this.handleViewLarge,
                          onChange: this.handleGetPicture,
                          addPath: '/projects/' + this.props.id + '/layouts/' + data.projectUnitLayoutID + '/pictures/'
                        })
                      )
                    )
                  ) : null
                )
              ) : null
            )
          )
        ) : null,
        _react2.default.createElement(_DelistReasonModal2.default, {
          open: this.state.showDelistModal,
          onConfirm: this.handleDelistModalConfirm,
          onCancel: this.handleDelistModalCancel,
          reasons: this.state.delistReasons,
          selectedReason: this.state.selectedDelistReason,
          onReasonChange: this.handleDelistReasonChange,
          loading: this.state.loading
        })
      );
    }
  }]);

  return Info;
}(_react.Component);

Info.propTypes = {
  token: _propTypes2.default.string,
  id: _propTypes2.default.string,
  unitID: _propTypes2.default.string,
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      settings: _propTypes2.default.shape({
        allowUnitSocialShare: _propTypes2.default.bool,
        virtualAccountIsEnabled: _propTypes2.default.bool,
        himsIsEnabled: _propTypes2.default.bool
      })
    })
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isDeveloper: _propTypes2.default.bool,
    isSiteplan: _propTypes2.default.bool,
    isBranchLeader: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    allowEditUnitPrice: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool,
    company: _propTypes2.default.object
  }),
  onCheck: _propTypes2.default.func,
  data: _propTypes2.default.shape({
    project: _propTypes2.default.shape({
      maOwnerCompanyBranchID: _propTypes2.default.number
    })
  }),
  packagePricingCalculation: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  calculatedFeePackages: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  newFetch: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  t: _propTypes2.default.func,
  hasPreviewPriceAccess: _propTypes2.default.bool,
  hasGenerateQuotationAccess: _propTypes2.default.bool,
  onToggleQuotationPreview: _propTypes2.default.func,
  showQuotationOpts: _propTypes2.default.bool
};
Info.contextTypes = {
  store: _propTypes2.default.object
};

Info.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig,
    auth: state.auth
  };
};

Info.getPropsToState = function (props) {
  var data = props.data || {};
  var packagePricingCalculation = props.packagePricingCalculation || [];
  var calculatedFeePackages = props.calculatedFeePackages || [];
  var editData = JSON.parse(JSON.stringify(data));
  var loading = props.loading;
  var unitCustomFieldSettings = props.unitCustomFieldSettings || [];
  var galleryIsTab = window.innerWidth > 425;
  var showQuotationOpts = props.showQuotationOpts || false;
  data.spaAmount = (0, _amount.spaFullNumber)(data) || data.spaValue; // decimal amount
  var globalSettings = {};
  var storeGloablSettings = (0, _storage.getItem)(_config2.default.get('appName') + '.globalSettings');
  if (storeGloablSettings) {
    try {
      globalSettings = JSON.parse(storeGloablSettings).data || [];
    } catch (e) {
      Bugsnag.notifyException(e);
    }
  }
  return {
    data: data,
    packagePricingCalculation: packagePricingCalculation,
    calculatedFeePackages: calculatedFeePackages,
    editData: editData,
    galleryIsTab: galleryIsTab,
    loading: loading,
    oriData: (0, _clone2.default)(data),
    unitCustomFieldSettings: unitCustomFieldSettings,
    globalSettings: globalSettings,
    showQuotationOpts: showQuotationOpts
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this9 = this;

  this.getProjectTiers = function () {
    if (_this9.state.data.project && _this9.state.data.project.projectPricings && _this9.state.data.project.projectPricings.length > 0) {
      return _this9.state.data.project.projectPricings;
    }
    return [];
  };

  this.getProjectUnitTiers = function () {
    if (_this9.state.data.projectUnitPricings && _this9.state.data.projectUnitPricings.length > 0) {
      return _this9.state.data.projectUnitPricings;
    }
    return [];
  };

  this.getProjectPackagePricings = function () {
    if (_this9.state.data.project && _this9.state.data.project.projectPackagePricings && _this9.state.data.project.projectPackagePricings.length > 0) {
      return _this9.state.data.project.projectPackagePricings;
    }
    return [];
  };

  this.getUnitPackagePricings = function () {
    var _ref9 = _this9.state.data || {},
        _ref9$projectUnitPack = _ref9.projectUnitPackagePricings,
        projectUnitPackagePricings = _ref9$projectUnitPack === undefined ? [] : _ref9$projectUnitPack;

    if (projectUnitPackagePricings && projectUnitPackagePricings.length > 0) {
      return projectUnitPackagePricings;
    }
    return [];
  };

  this.getProjectFeePackages = function () {
    if (_this9.state.data.project && _this9.state.data.project.projectFeePackages && _this9.state.data.project.projectFeePackages.length > 0) {
      return _this9.state.data.project.projectFeePackages;
    }
    return [];
  };

  this.getUnitPackageFees = function () {
    var _ref10 = _this9.state.data || {},
        _ref10$projectUnitPac = _ref10.projectUnitPackageFees,
        projectUnitPackageFees = _ref10$projectUnitPac === undefined ? [] : _ref10$projectUnitPac;

    if (projectUnitPackageFees && projectUnitPackageFees.length > 0) {
      return projectUnitPackageFees.filter(function (p) {
        return p.projectFeePackage && p.projectFeePackage.isEnabled || p.projectFeePackage && !p.projectFeePackage.id;
      });
    }
    return [];
  };

  this.getStatusOptions = function () {
    if (_this9.hasAccess()) {
      return _unitStatuses.UNIT_STATUSES_HQ_ALL;
    }
    if (_this9.hasSimpleViewMode()) {
      return _unitStatuses.UNIT_STATUSES_SIMPLE_MODE;
    }
    return _unitStatuses.UNIT_STATUSES_DE_ALL;
  };

  this.getUnitStatus = function () {
    var oriData = _this9.state.oriData;

    if (!_this9.hasAccess() && (oriData.statusID === 'sold_spa_signed' || oriData.statusID === 'developer_sold')) {
      return 'booked';
    }
    return oriData.statusID;
  };

  this.ucfPrefix = function (v) {
    return 'ucf_' + v;
  };

  this.handleDelistReasonChange = function (value) {
    _this9.setState({ selectedDelistReason: value });
  };

  this.handleDelistModalConfirm = function () {
    var _state4 = _this9.state,
        data = _state4.data,
        selectedDelistReason = _state4.selectedDelistReason;

    // Update the unit with the delist reason

    var updatedData = _extends({}, data, {
      statusID: 'delist',
      delistReasonID: selectedDelistReason || ''
    });

    _this9.setState({
      data: updatedData,
      showDelistModal: false,
      selectedDelistReason: ''
    }, function () {
      _this9.handleUpdateUnit();
    });
  };

  this.handleDelistModalCancel = function () {
    var oriData = _this9.state.oriData;

    // Revert the status change

    _this9.setState({
      showDelistModal: false,
      selectedDelistReason: '',
      data: _extends({}, _this9.state.data, { statusID: oriData.statusID })
    }, function () {
      _this9.handleResetCheck();
    });
  };

  this.handleOnCheck = function () {
    var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (_this9.props.onCheck) {
      _this9.props.onCheck(hasChanges);
    }
  };

  this.handleResize = function () {
    var galleryIsTab = window.innerWidth > 425;
    if (galleryIsTab !== _this9.state.galleryIsTab) {
      _this9.setState({ galleryIsTab: galleryIsTab });
    }
  };

  this.handleUpdateUnit = function () {
    var _state5 = _this9.state,
        data = _state5.data,
        oriData = _state5.oriData,
        unitCustomFieldSettings = _state5.unitCustomFieldSettings;

    if (data.projectUnitPricings && data.projectUnitPricings.length > 0) {
      data.projectUnitPricings = data.projectUnitPricings.filter(function (d) {
        return d.projectPricingID !== '';
      });
    }
    var customFields = [];
    if (data.projectUnitCustomFields) {
      data.projectUnitCustomFields.forEach(function (d) {
        var customField = {
          id: d.id,
          value: data[_this9.ucfPrefix(d.projectUnitCustomFieldSetting.name)],
          projectUnitCustomFieldSettingID: d.projectUnitCustomFieldSettingID,
          projectUnitCustomFieldSetting: d.projectUnitCustomFieldSetting,
          projectUnitCustomFieldSettingOptionID: data[_this9.ucfPrefix(d.projectUnitCustomFieldSetting.name) + 'OptionID'],
          projectUnitCustomFieldSettingOptions: d.projectUnitCustomFieldSettingOptions,
          projectUnitCustomFieldSettingOptionIDs: data[_this9.ucfPrefix(d.projectUnitCustomFieldSetting.name) + 'OptionIDs']
        };
        customFields.push(customField);
      });
    }
    if (unitCustomFieldSettings) {
      unitCustomFieldSettings.forEach(function (d) {
        var exists = -1;
        if (data.projectUnitCustomFields) exists = data.projectUnitCustomFields.findIndex(function (ucfData) {
          return ucfData.projectUnitCustomFieldSetting.id === d.id;
        });
        if (exists === -1) {
          var customField = {
            value: data[_this9.ucfPrefix(d.name)],
            projectUnitCustomFieldSettingID: d.id,
            projectUnitCustomFieldSetting: d,
            projectUnitCustomFieldSettingOptionID: data[_this9.ucfPrefix(d.name) + 'OptionID'],
            projectUnitCustomFieldSettingOptions: d.projectUnitCustomFieldSettingOptions,
            projectUnitCustomFieldSettingOptionIDs: data[_this9.ucfPrefix(d.name) + 'OptionIDs']
          };
          customFields.push(customField);
        }
      });
    }
    if (JSON.stringify(data) !== JSON.stringify(oriData)) {
      var unit = Object.assign(data, _extends({
        spaValue: parseFloat(data.spaAmount), // decimal amount
        size: parseFloat(data.size),
        landArea: parseFloat(data.landArea),
        position: parseInt(data.position, 10),
        colSpan: parseInt(data.colSpan, 10)
      }, (0, _vietnam.isVietnamCompany)(_this9.props.auth) ? {
        vatPercentage: parseFloat(data.vatPercentage) || 0,
        landValue: parseFloat(data.landValue) || 0
      } : {}, (0, _vietnam.vnUnitTextValues)(data, (0, _vietnam.isVietnamCompany)(_this9.props.auth))));
      unit = (0, _amount.fullToAmount)(unit, unit.spaAmount); // decimal amount
      unit.projectUnitPricings = unit.projectUnitPricings.map(function (p) {
        var newP = p;
        newP.totalPrice = parseFloat(p.totalPrice);
        return newP;
      });
      unit.projectUnitCustomFields = customFields;
      _this9.putUnit(unit).catch(function (err) {
        Bugsnag.notifyException(err);
      });
    } else {
      _this9.setState({
        edit: false,
        editTier: false
      }, function () {
        _this9.handleResetCheck();
      });
    }
  };

  this.handleEditUnit = function () {
    _this9.fetchProjectUnitLayouts();
    _this9.setState({ edit: true });
  };

  this.handleChange = function (event, value) {
    var _state6 = _this9.state,
        data = _state6.data,
        oriData = _state6.oriData;

    var nextValue = value.name === 'companyBranchAllocationIDs' && Array.isArray(value.value) ? value.value.filter(function (agencyID) {
      return agencyID !== ALL_AGENCIES_VALUE;
    }) : value.value;
    data[value.name] = value.name === 'companyBranchAllocationIDs' && Array.isArray(nextValue) && nextValue.length === 0 && (!oriData[value.name] || oriData[value.name].length === 0) ? oriData[value.name] : nextValue;

    // Check if status is changing to 'delist'
    if (value.name === 'statusID' && value.value === 'delist' && oriData.statusID !== 'delist') {
      // Show delist reason modal
      var _newData = _extends({}, data, _defineProperty({}, value.name, value.value));
      _this9.setState({
        data: _newData,
        showDelistModal: true,
        selectedDelistReason: ''
      });
      return;
    }

    var newData = _extends({}, data);
    _this9.setState({ data: newData }, function () {
      _this9.handleCheckChanges();
    });
  };

  this.handleResetUnit = function () {
    var oriData = _this9.state.oriData;

    _this9.setState({
      data: (0, _clone2.default)(oriData),
      edit: false
    }, function () {
      _this9.handleResetCheck();
    });
  };

  this.handleSpecificationsChange = function (data) {
    var editData = _this9.state.editData;

    editData.specifications = data;
    _this9.setState({ editData: editData }, function () {
      _this9.handleCheckChanges();
    });
  };

  this.handleUpdateUnitLayout = function () {
    var _state7 = _this9.state,
        data = _state7.data,
        editData = _state7.editData;

    if (editData.specifications) {
      editData.specifications = editData.specifications.filter(function (d) {
        return d.name.length > 0 && d.value.length > 0;
      }).map(function (d, idx) {
        return _extends({}, d, {
          position: idx + 1
        });
      });
    }
    if (JSON.stringify(editData) !== JSON.stringify(data)) {
      _this9.putUnit(editData, true);
    }
    data.specifications = editData.specifications;
    _this9.setState({ data: data }, function () {
      _this9.handleResetUnitLayout();
    });
  };

  this.handleResetUnitLayout = function () {
    var editData = JSON.parse(JSON.stringify(_this9.state.data));
    _this9.setState({ editData: editData }, function () {
      _this9.handleResetCheck();
    });
  };

  this.statuses = [{ name: 'new', value: 'new', text: 'Available' }].concat(_toConsumableArray(_unitStatuses.UNIT_STATUSES_HQ_DEVELOPER), [{ name: 'delist', value: 'delist', text: 'Delist' }]);

  this.checkStatusDropDown = function (statusID) {
    return _this9.statuses.some(function (status) {
      return status.value === statusID;
    });
  };

  this.valueArrayToText = function (array, arrayValue) {
    var text = [];
    if (arrayValue && array) {
      arrayValue.forEach(function (x) {
        array.find(function (y) {
          if (y.value === x) {
            text.push(y.text);
            return y.text;
          }
          return '';
        });
      });
      return text.join('\n');
    }
    return '';
  };

  this.checkBookable = function (statusID, project) {
    var user = _this9.props.auth;
    switch (statusID) {
      case 'new':
      case 'reserved':
        return true;
      case 'delist':
        if (project && project.rduIsEnabled && project.rduAccessGroupIDs) {
          if (user.isAdminBasic || user.isAdmin) return true;

          var uGroupIDs = [].concat(_toConsumableArray(user.groups.map(function (obj) {
            return obj.id;
          })));
          var uSrRoleIDs = (0, _srRoleAccess.matchGroupIDToSrRoleID)(uGroupIDs, user.companyBranch.isExternal);
          return (0, _srRoleAccess.hasAnyRequiredRoleIDs)(project.rduAccessGroupIDs, uSrRoleIDs);
        }
        return false;
      default:
        return false;
    }
  };

  this.handleCloseLarge = function (e) {
    e.preventDefault();
    _this9.setState({
      showLarge: false,
      selectedPicture: null
    });
  };

  this.handleViewLarge = function (e, data) {
    e.preventDefault();
    _this9.setState({
      selectedPicture: data,
      showLarge: true
    });
  };

  this.handleGetPicture = function (pictures) {
    _this9.setState({ pictures: pictures });
  };

  this.handleSlidePicture = function (e) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
    var _state8 = _this9.state,
        pictures = _state8.pictures,
        selectedPicture = _state8.selectedPicture;

    var index = pictures.indexOf(selectedPicture);
    var nextIndex = direction === 'left' ? index - 1 : index + 1;
    _this9.setState({
      selectedPicture: pictures[nextIndex]
    });
  };

  this.handleCheckBoxChange = function (event, d) {
    var data = _this9.state.data;

    data[d.name] = !data[d.name];
    _this9.setState({ data: data }, function () {
      _this9.handleCheckChanges();
    });
  };

  this.checkUnitSpecificationAccess = function (data) {
    if (!_this9.hasAccess() && data.specifications && data.specifications.length < 1 || !_this9.hasAccess() && !data.specifications) {
      return false;
    }
    return true;
  };

  this.handleForceReleaseHold = function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(e) {
      var store, t, data;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              e.preventDefault();
              store = _this9.context.store;
              t = _this9.props.t;
              data = _this9.state.data;
              _context6.next = 6;
              return _this9.setComponentState({ loading: true });

            case 6:
              _context6.prev = 6;
              _context6.next = 9;
              return store.dispatch((0, _fetchM.fetchM)((0, _unitHold.preReservedURL)(_config2.default.get('bookApiURL'), _this9.props.id, _this9.props.unitID, { clear: true }), {
                credentials: 'include',
                method: 'GET',
                ignoreForbidden: true,
                headers: {
                  'Content-Type': 'application/json'
                }
              }));

            case 9:
              _context6.next = 27;
              break;

            case 11:
              _context6.prev = 11;
              _context6.t0 = _context6['catch'](6);
              _context6.next = 15;
              return _this9.setComponentState({ loading: false });

            case 15:
              if (!(_context6.t0.res && _context6.t0.res.status >= 400 && _context6.t0.res.status < 500)) {
                _context6.next = 25;
                break;
              }

              _context6.t1 = store;
              _context6.t2 = _flash.flashErrorMessage;
              _context6.next = 20;
              return _context6.t0.res.text();

            case 20:
              _context6.t3 = _context6.sent;
              _context6.t4 = {
                message: _context6.t3
              };
              _context6.t5 = (0, _context6.t2)(_context6.t4);

              _context6.t1.dispatch.call(_context6.t1, _context6.t5);

              return _context6.abrupt('return');

            case 25:
              store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again.', { ns: _translation.TRANSLATION_FILES.translation }) }));
              return _context6.abrupt('return');

            case 27:
              _context6.next = 29;
              return _this9.setComponentState({ loading: false });

            case 29:
              store.dispatch((0, _flash.flashSuccessMessage)({
                header: t('Hold released', { ns: _translation.TRANSLATION_FILES.translation }),
                message: t('Unit {{reference}} is available again', { reference: data.reference, ns: _translation.TRANSLATION_FILES.translation })
              }));
              if (_this9.props.newFetch) _this9.props.newFetch();

            case 31:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this9, [[6, 11]]);
    }));

    return function (_x10) {
      return _ref11.apply(this, arguments);
    };
  }();

  this.checkLaunchModeTimeout = function (data, user) {
    if (data.project && data.project.isLaunchMode && (0, _momentTimezone2.default)().isBefore((0, _momentTimezone2.default)(data.reservedTimeoutExpireAt)) && data.reservedByAwsUser !== user.awsUsername) {
      return true;
    }
    return false;
  };

  this.handleOnCollapseSegment = function (e, _ref12) {
    var name = _ref12.name,
        value = _ref12.value;
    var collapseSegments = _this9.state.collapseSegments;

    e.preventDefault();
    collapseSegments[name] = !value;
    _this9.setState({ collapseSegments: collapseSegments });
  };

  this.handleEditTier = function () {
    _this9.setState({ editTier: true });
  };

  this.handleUnitPricingTierChange = function (newData) {
    var data = _this9.state.data;

    data.projectUnitPricings = newData;
    _this9.setState({ data: data }, function () {
      _this9.handleCheckChanges();
    });
  };

  this.handleResetTier = function () {
    var oriData = _this9.state.oriData;

    _this9.setState({
      data: (0, _clone2.default)(oriData),
      editTier: false
    }, function () {
      _this9.handleResetCheck();
    });
  };

  this.handleUnitPricingTierDelete = function (id) {
    _this9.deleteUnitPricingTier(id);
  };

  this.hasSimpleViewMode = function () {
    var data = _this9.state.data;

    var user = _this9.props.auth;
    if (!user.isHeadquarters && !user.isSuperAdmin && !user.isBranchLeader) {
      return data && data.project && data.project.siteplanSettings && (data.project.siteplanSettings.salesChartSimpleMode || data.project.siteplanSettings.siteplanSimpleMode);
    }
    return false;
  };

  this.handleCustomSelectChange = function (e, d, customFieldOptions, cValidation) {
    var data = _this9.state.data;

    if (Array.isArray(d.value)) {
      var ids = [];
      var values = [];
      customFieldOptions.forEach(function (cfo) {
        d.value.forEach(function (v) {
          if (v === cfo.value) {
            ids.push(cfo.id);
            values.push(cfo.value);
          }
        });
      });
      data[d.name + 'OptionIDs'] = ids;
      data[d.name + 'OptionID'] = '';
      data[d.name] = values.join(',');
    } else {
      data[d.name] = d.value;
      var selectedOption = customFieldOptions.find(function (cfoData) {
        return cfoData.value === d.value;
      });
      data[d.name + 'OptionID'] = selectedOption ? selectedOption.id : '';
      data[d.name + 'OptionIDs'] = [];
    }
    _this9.customFieldValidation = cValidation;
    _this9.setState({ data: data }, function () {
      _this9.handleCheckChanges();
    });
  };

  this.handleCustomInputChange = function (e, cValidation) {
    var data = _this9.state.data;

    data[e.target.name] = e.target.value;
    _this9.customFieldValidation = cValidation;
    _this9.setState({ data: data }, function () {
      _this9.handleCheckChanges();
    });
  };

  this.hasProjectHimsEnabled = function (data) {
    var appConfig = _this9.props.appConfig;

    var companyHimsIsEnabled = appConfig && appConfig.data && appConfig.data.himsIsEnabled;
    return companyHimsIsEnabled && data.project && data.project.himsIsEnabled;
  };

  this.hasHimsStrataEnabled = function (data) {
    var auth = _this9.props.auth;

    if (data.project && data.project.himsStrataIsEnabled === 'no') {
      return false;
    }
    return !(auth.companyBranch && auth.companyBranch.isExternal && data.project && data.project.himsStrataIsEnabled === 'yes' && data.project.himsStrataIsHidden);
  };

  this.checkSizeSuffix = function () {
    var t = _this9.props.t;
    var data = _this9.state.data;

    var suffix = data.project && data.project.sizeSuffix;
    switch (suffix) {
      case 'square_metres':
        return (0, _vietnam.isVietnamCompany)(_this9.props.auth) ? ' m²' : ' ' + t('sqm', { ns: _translation.TRANSLATION_FILES.screens });
      case 'square_feet':
        return ' ' + t('sqft', { ns: _translation.TRANSLATION_FILES.screens });
      default:
        return '';
    }
  };

  this.countActiveBooking = function () {
    var data = _this9.state.data;

    var activeBookingCount = 0;
    var bookingSummary = data.projectUnitBookingSummary;
    if (bookingSummary) {
      activeBookingCount = bookingSummary.reservedCount + bookingSummary.bookedCount + bookingSummary.soldCount;
    }
    if (data.project && data.project.activeBookingsIncludeWaitlist) {
      activeBookingCount += bookingSummary.cancelledAvailabilityCount;
    }
    return activeBookingCount;
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Info.mapStateToProps)(Info));

/***/ }),
/* 2408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(36);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Lawyer = function (_Component) {
  _inherits(Lawyer, _Component);

  function Lawyer(props) {
    _classCallCheck(this, Lawyer);

    var _this = _possibleConstructorReturn(this, (Lawyer.__proto__ || Object.getPrototypeOf(Lawyer)).call(this, props));

    _initialiseProps.call(_this);

    var state = Lawyer.getPropsToState(props);
    _this.state = _extends({}, state, {
      collapseSegments: [{
        hideLawyerInfo: false
      }]
    });
    return _this;
  }

  _createClass(Lawyer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Lawyer.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          isMobile = _props.isMobile,
          loading = _props.loading;
      var data = this.state.data;
      var hideLawyerInfo = this.state.collapseSegments.hideLawyerInfo;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16, style: isMobile ? { padding: '0' } : {} },
            _react2.default.createElement(
              _semanticUiReact.Header,
              {
                className: 'new_title',
                as: 'h5',
                textAlign: 'center',
                attached: 'top'
              },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16, textAlign: 'center' },
                    'LAWYER INFO'
                  ),
                  _react2.default.createElement(_semanticUiReact.Label, {
                    as: 'button',
                    attached: 'top right',
                    icon: hideLawyerInfo ? 'angle up' : 'angle down',
                    className: 'collapse-button',
                    style: {
                      position: 'absolute',
                      right: '0',
                      top: '3px',
                      marginRight: '0',
                      marginTop: '0.5em'
                    },
                    name: 'hideLawyerInfo',
                    value: hideLawyerInfo,
                    onClick: this.handleOnCollapseSegment,
                    disabled: loading
                  })
                )
              )
            ),
            !hideLawyerInfo ? _react2.default.createElement(
              _semanticUiReact.Segment,
              { attached: true },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { verticalAlign: 'middle' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 1, textAlign: 'left' },
                    _react2.default.createElement(
                      'span',
                      { style: { fontWeight: 'bold' } },
                      'Email'
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 15, textAlign: 'left' },
                    data ? data.lawyerEmail : ''
                  )
                )
              )
            ) : null
          )
        )
      );
    }
  }]);

  return Lawyer;
}(_react.Component);

Lawyer.contextTypes = {
  store: _propTypes2.default.object
};
Lawyer.propTypes = {
  auth: _propTypes2.default.shape({
    isDeveloper: _propTypes2.default.bool,
    isSiteplan: _propTypes2.default.bool,
    isBranchLeader: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    allowEditUnitPrice: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool
  }),
  data: _propTypes2.default.shape({
    lawyerEmail: _propTypes2.default.string
  }),
  isMobile: _propTypes2.default.bool,
  loading: _propTypes2.default.bool
};

Lawyer.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

Lawyer.getPropsToState = function (props) {
  var data = props.data || {};
  return {
    data: data,
    oriData: (0, _lodash.clone)(data)
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleOnCollapseSegment = function (e, _ref) {
    var name = _ref.name,
        value = _ref.value;
    var collapseSegments = _this2.state.collapseSegments;

    e.preventDefault();
    collapseSegments[name] = !value;
    _this2.setState({ collapseSegments: collapseSegments });
  };
};

exports.default = (0, _reactRedux.connect)(Lawyer.mapStateToProps)(Lawyer);

/***/ }),
/* 2409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _reactRedux = __webpack_require__(9);

var _lodash = __webpack_require__(36);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _ProjectUnitActivities = __webpack_require__(565);

var _ProjectUnitActivities2 = _interopRequireDefault(_ProjectUnitActivities);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Logs = function (_Component) {
  _inherits(Logs, _Component);

  function Logs(props) {
    _classCallCheck(this, Logs);

    var _this = _possibleConstructorReturn(this, (Logs.__proto__ || Object.getPrototypeOf(Logs)).call(this, props));

    _initialiseProps.call(_this);

    var state = Logs.getPropsToState(props);
    _this.state = _extends({}, state, {
      collapseSegments: [{
        hideActivityLogs: false
      }]
    });
    return _this;
  }

  _createClass(Logs, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Logs.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var user = this.props.auth;
      var data = this.state.data;

      if (user && (user.isHeadquarters || user.isSuperAdmin)) {
        return true;
      }
      if (user && user.isBranchLeader && user.companyBranch && data && data.project && data.project.maOwnerCompanyBranchID === user.companyBranch.id) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasAccessInternal',
    value: function hasAccessInternal() {
      var auth = this.props.auth;
      if (auth && auth.companyBranch && !auth.companyBranch.isExternal) {
        return true;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          auth = _props.auth,
          isMobile = _props.isMobile,
          loading = _props.loading,
          t = _props.t;
      var data = this.state.data;
      var hideActivityLogs = this.state.collapseSegments.hideActivityLogs;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        auth && data && this.hasAccess(this.hasAccessInternal()) && _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { width: 16, style: isMobile ? { padding: '0' } : {} },
            _react2.default.createElement(
              _semanticUiReact.Header,
              {
                className: 'new_title',
                as: 'h5',
                textAlign: 'center',
                attached: 'top'
              },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16, textAlign: 'center' },
                    t('Activity Logs').toUpperCase()
                  ),
                  _react2.default.createElement(_semanticUiReact.Label, {
                    as: 'button',
                    attached: 'top right',
                    icon: hideActivityLogs ? 'angle up' : 'angle down',
                    className: 'collapse-button',
                    style: {
                      position: 'absolute',
                      right: '0',
                      top: '3px',
                      marginRight: '0',
                      marginTop: '0.5em'
                    },
                    name: 'hideActivityLogs',
                    value: hideActivityLogs,
                    onClick: this.handleOnCollapseSegment,
                    disabled: loading
                  })
                )
              )
            ),
            !hideActivityLogs ? _react2.default.createElement(
              _semanticUiReact.Segment,
              { attached: true },
              _react2.default.createElement(_ProjectUnitActivities2.default, {
                data: data.projectUnitActivities || [],
                hasAccess: auth.isHeadquarters || auth.isSuperAdmin,
                loading: loading
              }),
              _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { style: { textAlign: 'center' } },
                  data.projectUnitActivities ? _react2.default.createElement(_semanticUiReact.Button, {
                    as: _reactRouter.Link,
                    to: '/projects/' + data.projectID + '/units/' + data.id + '/activities/',
                    content: t('View More', { ns: _translation.TRANSLATION_FILES.translation })
                  }) : null
                )
              )
            ) : null
          )
        )
      );
    }
  }]);

  return Logs;
}(_react.Component);

Logs.contextTypes = {
  store: _propTypes2.default.object
};
Logs.propTypes = {
  auth: _propTypes2.default.shape({
    isDeveloper: _propTypes2.default.bool,
    isSiteplan: _propTypes2.default.bool,
    isBranchLeader: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    allowEditUnitPrice: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool
  }),
  data: _propTypes2.default.shape({
    project: _propTypes2.default.shape({
      maOwnerCompanyBranchID: _propTypes2.default.number
    })
  }),
  isMobile: _propTypes2.default.bool,
  loading: _propTypes2.default.bool
};

Logs.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

Logs.getPropsToState = function (props) {
  var data = props.data || {};
  return {
    data: data,
    oriData: (0, _lodash.clone)(data)
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleOnCollapseSegment = function (e, _ref) {
    var name = _ref.name,
        value = _ref.value;
    var collapseSegments = _this2.state.collapseSegments;

    e.preventDefault();
    collapseSegments[name] = !value;
    _this2.setState({ collapseSegments: collapseSegments });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Logs.mapStateToProps)(Logs));

/***/ }),
/* 2410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _semanticUiReact = __webpack_require__(2);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

var _amount = __webpack_require__(87);

var _sharing = __webpack_require__(1094);

var _url = __webpack_require__(19);

var _preSalesLaunch = __webpack_require__(269);

var _vietnam = __webpack_require__(40);

var _BookingSectionTab = __webpack_require__(558);

var _BookingSectionTab2 = _interopRequireDefault(_BookingSectionTab);

var _prompt = __webpack_require__(66);

var _promptMessages = __webpack_require__(43);

var _translation = __webpack_require__(4);

var _Bookings = __webpack_require__(2405);

var _Bookings2 = _interopRequireDefault(_Bookings);

var _Lawyer = __webpack_require__(2408);

var _Lawyer2 = _interopRequireDefault(_Lawyer);

var _Logs = __webpack_require__(2409);

var _Logs2 = _interopRequireDefault(_Logs);

var _Info = __webpack_require__(2407);

var _Info2 = _interopRequireDefault(_Info);

var _srRoleAccess = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */
/* eslint-disable max-len */


var Overview = function (_Component) {
  _inherits(Overview, _Component);

  function Overview(props) {
    _classCallCheck(this, Overview);

    var _this = _possibleConstructorReturn(this, (Overview.__proto__ || Object.getPrototypeOf(Overview)).call(this, props));

    _initialiseProps.call(_this);

    var state = Overview.getPropsToState(props);
    _this.state = _extends({}, state, {
      edit: false,
      editTier: false,
      unitLayouts: [],
      hasChanges: false,
      modalReservationIsOpen: false,
      showDeleteConfirm: false,
      showQuotationOpts: false
    });
    _this.validation = {};
    return _this;
  }

  _createClass(Overview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
      this.consumeSRCodeQuery();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Overview.getPropsToState(nextProps);
      var sameUnitRoute = this.isSameUnitRoute(nextProps);
      this.setState(function (previousState) {
        return _extends({}, state, {
          // A replace strips srCode from the address bar. Retain it only for this unit's Reserve link.
          srCode: state.hasSRCodeQuery ? state.srCode : sameUnitRoute ? previousState.srCode : '',
          hasSRCodeQuery: state.hasSRCodeQuery
        });
      }, this.consumeSRCodeQuery);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this2.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'fetchProjectUnitLayouts',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, t, res, message, unitLayouts;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context.prev = 3;
                _context.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/unit_layouts/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 6:
                res = _context.sent;
                _context.next = 15;
                break;

              case 9:
                _context.prev = 9;
                _context.t0 = _context['catch'](3);

                Bugsnag.notifyException(_context.t0);
                _context.next = 14;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 14:
                return _context.abrupt('return');

              case 15:
                if (res.ok) {
                  _context.next = 23;
                  break;
                }

                _context.next = 18;
                return res.text();

              case 18:
                message = _context.sent;
                _context.next = 21;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 21:
                _context.next = 28;
                break;

              case 23:
                _context.next = 25;
                return res.json();

              case 25:
                unitLayouts = _context.sent;
                _context.next = 28;
                return this.setComponentState({
                  unitLayouts: unitLayouts ? unitLayouts.map(function (ul) {
                    var unitLayout = { text: ul.name, name: ul.id, value: ul.id, size: ul.size };
                    return unitLayout;
                  }) : []
                });

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[3, 9]]);
      }));

      function fetchProjectUnitLayouts() {
        return _ref.apply(this, arguments);
      }

      return fetchProjectUnitLayouts;
    }()
  }, {
    key: 'putUnit',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(validations, unit) {
        var _this3 = this;

        var store, t, query, errors, res, message, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                query = (0, _url.decodeSearch)(this.props.location.search);
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context2.next = 8;
                  break;
                }

                this.setState({ edit: true });
                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context2.abrupt('return');

              case 8:
                _context2.next = 10;
                return this.setComponentState({ loading: true });

              case 10:
                res = void 0;
                _context2.prev = 11;
                _context2.next = 14;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/units/' + this.props.unitID + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(unit)
                }));

              case 14:
                res = _context2.sent;
                _context2.next = 30;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t0 = _context2['catch'](11);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 22;
                return this.setComponentState({ loading: false });

              case 22:
                if (!(_context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 28;
                  break;
                }

                _context2.next = 25;
                return _context2.t0.res.text();

              case 25:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 28:
                store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));
                return _context2.abrupt('return');

              case 30:
                _context2.next = 32;
                return res.json();

              case 32:
                data = _context2.sent;
                _context2.next = 35;
                return this.setComponentState({
                  loading: false,
                  edit: false,
                  editTier: false
                }, function () {
                  _this3.handleResetCheck();
                });

              case 35:
                this.props.newFetch();
                store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.id + '/units/' + this.props.unitID + '/?' + (0, _url.encodeSearch)(query)));
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Unit {{reference}} is successfully updated', { reference: data.reference, ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 38:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[11, 17]]);
      }));

      function putUnit(_x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return putUnit;
    }()
  }, {
    key: 'deleteUnit',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var store, data, t, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                store = this.context.store;
                data = this.state.data;
                t = this.props.t;
                _context3.next = 5;
                return this.setState({ loading: true });

              case 5:
                _context3.prev = 5;
                _context3.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/units/' + this.props.unitID + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 8:
                _context3.next = 22;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](5);
                _context3.next = 14;
                return this.setState({ loading: false });

              case 14:
                Bugsnag.notifyException(_context3.t0);

                if (!(_context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 21;
                  break;
                }

                _context3.next = 18;
                return _context3.t0.res.text();

              case 18:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context3.t0));

              case 22:
                _context3.next = 24;
                return this.setState({ loading: false });

              case 24:
                store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.id + '/'));
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Unit {{reference}} was successfully', { reference: data.reference, ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 26:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 10]]);
      }));

      function deleteUnit() {
        return _ref3.apply(this, arguments);
      }

      return deleteUnit;
    }()
  }, {
    key: 'deleteUnitPricingTier',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
        var _this4 = this;

        var store, data, t, newprojectUnitPricings, item, message;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setComponentState({ loading: true });

              case 2:
                store = this.context.store;
                data = this.state.data;
                t = this.props.t;
                newprojectUnitPricings = data.projectUnitPricings.filter(function (d) {
                  return d.id !== id;
                });
                item = data.projectUnitPricings.find(function (d) {
                  return d.id === id;
                });
                _context4.prev = 7;
                _context4.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + data.project.id + '/units/' + data.id + '/pricings/' + id + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 10:
                _context4.next = 25;
                break;

              case 12:
                _context4.prev = 12;
                _context4.t0 = _context4['catch'](7);
                _context4.next = 16;
                return this.setComponentState({ loading: false });

              case 16:
                if (!(_context4.t0.res && _context4.t0.res.status >= 400 && _context4.t0.res.status < 500)) {
                  _context4.next = 22;
                  break;
                }

                _context4.next = 19;
                return _context4.t0.res.text();

              case 19:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context4.abrupt('return');

              case 22:
                Bugsnag.notifyException(_context4.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context4.abrupt('return');

              case 25:
                _context4.next = 27;
                return this.setComponentState({ loading: false });

              case 27:
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Pricing Deleted', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('{{pricing}} was successfully removed', { pricing: item.projectPricing.name, ns: _translation.TRANSLATION_FILES.translation })
                }));
                data.projectUnitPricings = newprojectUnitPricings;
                _context4.next = 31;
                return this.setComponentState({ data: data }, function () {
                  _this4.handleCheckChanges();
                  _this4.props.newFetch();
                });

              case 31:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[7, 12]]);
      }));

      function deleteUnitPricingTier(_x4) {
        return _ref4.apply(this, arguments);
      }

      return deleteUnitPricingTier;
    }()
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      var _this5 = this;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true }, function () {
          _this5.handleOnCheck(true);
        });
      }
    }
  }, {
    key: 'handleResetCheck',
    value: function handleResetCheck() {
      var _this6 = this;

      if (this.state.hasChanges) {
        this.setState({ hasChanges: false }, function () {
          _this6.handleOnCheck(false);
        });
      }
    }
  }, {
    key: 'hasEditAccess',
    value: function hasEditAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var user = this.props.auth;
      if (this.props.auth.isSuperAdmin || this.props.auth.isHeadquarters) {
        return true;
      }
      if (this.props.auth.isBranchLeaderSupervisorII && this.props.data && this.props.data.project.maOwnerCompanyBranchID === user.companyBranch.id) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var user = this.props.auth;
      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      if (this.props.auth.isBranchLeader && this.props.data && this.props.data.project.maOwnerCompanyBranchID === user.companyBranch.id) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasAccessInternal',
    value: function hasAccessInternal() {
      var auth = this.props.auth;
      if (auth && auth.companyBranch && !auth.companyBranch.isExternal) {
        return true;
      }
      return false;
    }
    // CPI-975: an agency user's Reserve follows the unit's agency allocation, and that is decided
    // by the server. book-api refuses the unit page (403) and the reserve itself for a unit that is
    // not allocated to the agent's branch, and returns a not-allocated unit as unavailable, which
    // checkBookable already disables. The blanket Vietnam-agency disable that CPI-974 R2 put here
    // is gone: it greyed the button for units the agency IS allocated, so no agent could reserve.
    // Agency Admin (MS-3013) is a non-selling role, so its Reserve stays disabled on every unit -
    // except in Vietnam, where SkyWorld's Agency Admins reserve for their agency and the button
    // follows the same server-side allocation gate as Agent and Agent Leader. MY/ID unchanged.

  }, {
    key: 'generateBookButtonText',
    value: function generateBookButtonText(data) {
      var t = this.props.t;

      var message = 'Book';
      if (data.project && data.project.defaultCustomBookingStatusID === 'reserved') {
        message = 'Reserve';
      }
      if (this.checkUserIsCooldown(data) || this.checkUserBapBanned(data)) {
        return _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'wait' }),
          t(message)
        );
      }
      return t(message);
    }
  }, {
    key: 'checkDisableBookButton',
    value: function checkDisableBookButton(data) {
      var user = this.props.auth;
      var _state = this.state,
          edit = _state.edit,
          loading = _state.loading;

      return loading || edit || data && data.projectUnitBookingSummary && data.project && data.projectUnitBookingSummary.reservedCount >= data.project.bookingUnitLimit || !this.checkBookable(data.statusID, data.project) || this.checkLaunchModeTimeout(data, user) || this.checkUserIsCooldown(data) || this.checkUserBapBanned(data) || (0, _preSalesLaunch.reservationBlocked)(user, data && data.project) || this.checkCannotBookUnit();
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          data = _state2.data,
          oriData = _state2.oriData,
          galleryIsTab = _state2.galleryIsTab,
          isMobile = _state2.isMobile,
          sectionTabs = _state2.sectionTabs,
          tabID = _state2.tabID,
          showQuotationOpts = _state2.showQuotationOpts,
          loading = _state2.loading;

      var user = this.props.auth;
      var t = this.props.t;

      var sectionProps = _extends({}, this.props, { isMobile: isMobile, loading: loading });
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_DeleteConfirm2.default, {
          open: this.state.showDeleteConfirm,
          onClose: this.handleCancelDelete,
          onConfirm: this.handleConfirmDelete,
          name: data.reference || t('Unit')
        }),
        _react2.default.createElement(
          _semanticUiReact.Modal,
          { open: this.state.modalReservationIsOpen, basic: true, size: 'small' },
          _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: t('Reservation Limit Exceeded') }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              'p',
              null,
              t('Your business unit has reached it\'s reservation limit of {{limit}}. Please contact {{company}}', { limit: user.companyBranch.reservationLimit, company: user.company.name }),
              '.'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                color: 'green',
                inverted: true,
                onClick: this.handleModalReservationClose
              },
              t('Okay', { ns: _translation.TRANSLATION_FILES.translation })
            )
          )
        ),
        _react2.default.createElement(_NavBar2.default, {
          header: t('Overview'),
          backURL: '/projects/' + this.props.id + '/units/',
          rightNav: this.props.auth.isSiteplan ? null : _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(
              'div',
              null,
              (oriData.virtualTourURL !== '' || oriData.projectUnitLayout && oriData.projectUnitLayout.virtualTourURL !== '') && _react2.default.createElement(_semanticUiReact.Button, {
                as: 'a',
                color: 'teal',
                icon: 'street view',
                content: galleryIsTab ? t('Virtual Tour') : null,
                disabled: this.state.loading,
                href: oriData.virtualTourURL || (oriData.projectUnitLayout ? oriData.projectUnitLayout.virtualTourURL : ''),
                target: '_blank',
                rel: 'noopener noreferrer',
                size: galleryIsTab ? 'medium' : 'small'
              }),
              this.checkAllowUnitShare() ? _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  as: _reactRouter.Link,
                  icon: true,
                  color: 'green',
                  size: galleryIsTab ? 'medium' : 'small',
                  title: t('Share details to Whatsapp'),
                  className: 'whatsapp-button large-hide',
                  to: this.generateWSLink(data, user),
                  target: '_blank'
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'whatsapp' })
              ) : '',
              this.hasGenerateQuotationAccess() && _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  icon: true,
                  size: galleryIsTab ? 'medium' : 'small',
                  title: t('Print quotation'),
                  className: 'mobile-hide',
                  onClick: this.handleScrollPackagePricingIntoView
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'print' })
              ),
              this.checkAllowUnitShare() ? _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  icon: true,
                  size: galleryIsTab ? 'medium' : 'small',
                  title: t('Copy sharing details'),
                  className: 'mobile-hide',
                  onClick: this.handleCopyShareInfo
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'copy' })
              ) : '',
              this.canDelete() && this.hasEditAccess() && (this.props.auth.allowEditUnitDetails || this.props.auth.allowEditUnitPrice) && _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  color: 'red',
                  disabled: this.state.loading,
                  icon: true,
                  title: t('Delete', { ns: _translation.TRANSLATION_FILES.translation }),
                  onClick: this.handleDelete,
                  size: galleryIsTab ? 'medium' : 'small'
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'trash' })
              ),
              _react2.default.createElement(_semanticUiReact.Button, {
                as: this.checkBusinessUnitLimitReached(data, user) ? _semanticUiReact.Button : _reactRouter.Link,
                positive: true,
                content: this.generateBookButtonText(data),
                disabled: this.checkDisableBookButton(data),
                to: !this.checkBusinessUnitLimitReached(data, user) && this.getBookingFormURL(),
                onClick: this.checkBusinessUnitLimitReached(data, user) ? this.handleBookUnit : function () {},
                size: galleryIsTab ? 'medium' : 'small'
              })
            )
          ),
          bottomNode: _react2.default.createElement(_BookingSectionTab2.default, {
            loading: this.state.loading,
            isMobile: isMobile,
            isSticky: true,
            onTabChange: this.handleTabChange,
            tabs: sectionTabs,
            tabID: tabID
          })
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_BookingSectionTab2.default, {
                loading: this.state.loading,
                isMobile: isMobile,
                onTabChange: this.handleTabChange,
                tabs: sectionTabs,
                tabID: tabID
              })
            )
          ),
          tabID !== 1 ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              data ? _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  { as: 'h3', style: { marginBottom: '0' } },
                  data ? data.reference : ''
                ),
                data.project && data.projectUnitLayout && _react2.default.createElement(
                  _semanticUiReact.Header.Subheader,
                  null,
                  data.project.name,
                  ', ',
                  data.projectUnitLayout.name
                )
              ) : ''
            )
          ) : null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              tabID === 1 && _react2.default.createElement(_Info2.default, _extends({}, sectionProps, {
                hasPreviewPriceAccess: this.hasPreviewPriceAccess(),
                hasGenerateQuotationAccess: this.hasGenerateQuotationAccess(),
                onToggleQuotationPreview: this.handleOnToggleQuotationOpts,
                showQuotationOpts: showQuotationOpts
              })),
              tabID === 2 && _react2.default.createElement(_Bookings2.default, sectionProps),
              tabID === 3 && _react2.default.createElement(_Lawyer2.default, sectionProps),
              tabID === 4 && _react2.default.createElement(_Logs2.default, _extends({ hasAccess: this.hasAccess(this.hasAccessInternal()) }, sectionProps))
            )
          )
        )
      );
    }
  }]);

  return Overview;
}(_react.Component);

Overview.propTypes = {
  token: _propTypes2.default.string,
  id: _propTypes2.default.string,
  unitID: _propTypes2.default.string,
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      settings: _propTypes2.default.shape({
        allowUnitSocialShare: _propTypes2.default.bool
      })
    })
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string,
    hash: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isDeveloper: _propTypes2.default.bool,
    isSiteplan: _propTypes2.default.bool,
    isBranchLeader: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isExternalAgencyAdmin: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    }),
    companyBranch: _propTypes2.default.shape({
      isExternal: _propTypes2.default.bool
    }),
    allowEditUnitPrice: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool
  }),
  onCheck: _propTypes2.default.func,
  data: _propTypes2.default.shape({
    project: _propTypes2.default.shape({
      maOwnerCompanyBranchID: _propTypes2.default.number
    })
  }),
  packagePricingCalculation: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  newFetch: _propTypes2.default.func,
  t: _propTypes2.default.func
};
Overview.contextTypes = {
  store: _propTypes2.default.object
};

Overview.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig,
    auth: state.auth
  };
};

Overview.getPropsToState = function (props) {
  var windowWidth = window.innerWidth;
  var isMobile = windowWidth < 768;
  var query = (0, _url.decodeSearch)(props.location.search);
  var srCode = typeof query.srCode === 'string' ? query.srCode : '';
  var hasSRCodeQuery = Object.prototype.hasOwnProperty.call(query, 'srCode');
  var data = props.data || {};
  var packagePricingCalculation = props.packagePricingCalculation || [];
  var editData = JSON.parse(JSON.stringify(data));
  var loading = props.loading;
  var galleryIsTab = window.innerWidth > 425;
  data.spaAmount = (0, _amount.spaFullNumber)(data) || data.spaValue; // decimal amount
  var tabID = 1;
  switch (query.section) {
    case 'info':
      tabID = 1;
      break;
    case 'bookings':
      tabID = 2;
      break;
    case 'lawyer':
      tabID = 3;
      break;
    case 'logs':
      tabID = 4;
      break;
    default:
      tabID = 1;
      break;
  }
  var sectionTabs = [{ id: 1, title: 'Info', description: 'Unit, Pricing, Layout & Specification' }];
  if (props.auth && !props.auth.isSiteplan) {
    sectionTabs.push({ id: 2, title: 'Bookings', description: 'Booking History' });
    sectionTabs.push({ id: 4, title: 'Logs', description: 'Activity Logs' });
  }
  if (data && data.lawyerEmail) {
    sectionTabs.push({ id: 3, title: 'Lawyer', description: 'SPA Lawyer Info' });
  }
  sectionTabs.sort(function (a, b) {
    return a.id - b.id;
  });
  return {
    data: data,
    editData: editData,
    galleryIsTab: galleryIsTab,
    isMobile: isMobile,
    loading: loading,
    oriData: (0, _clone2.default)(data),
    sectionTabs: sectionTabs,
    tabID: tabID,
    packagePricingCalculation: packagePricingCalculation,
    srCode: srCode,
    hasSRCodeQuery: hasSRCodeQuery
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.handleOnCheck = function () {
    var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (_this7.props.onCheck) {
      _this7.props.onCheck(hasChanges);
    }
  };

  this.handleResize = function () {
    var galleryIsTab = window.innerWidth > 425;
    var isMobile = window.innerWidth < 768;
    if (galleryIsTab !== _this7.state.galleryIsTab || isMobile !== _this7.state.isMobile) {
      _this7.setState({
        galleryIsTab: galleryIsTab,
        isMobile: isMobile
      });
    }
  };

  this.isSameUnitRoute = function (nextProps) {
    var currentPath = _this7.props.location.pathname || '/projects/' + _this7.props.id + '/units/' + _this7.props.unitID + '/';
    var nextPath = nextProps.location.pathname || '/projects/' + nextProps.id + '/units/' + nextProps.unitID + '/';
    return _this7.props.id === nextProps.id && _this7.props.unitID === nextProps.unitID && currentPath === nextPath;
  };

  this.handleTabChange = function (tabData) {
    var data = _this7.state.data;

    if (!tabData) return;
    var tabID = tabData.id;
    var store = _this7.context.store;

    var query = (0, _url.decodeSearch)(_this7.props.location.search);
    var tab = 'info';
    switch (tabID) {
      case 1:
        tab = 'info';
        break;
      case 2:
        tab = 'bookings';
        break;
      case 3:
        tab = 'lawyer';
        break;
      case 4:
        tab = 'logs';
        break;
      default:
        tab = 'info';
        break;
    }
    query.section = tab;
    _this7.setState({
      tabID: _this7.state.hasChanges ? _this7.state.tabID : tabID
    });
    if (tabData.page) {
      store.dispatch((0, _reactRouterRedux.push)('/projects/' + data.projectID + '/units/' + data.id + '/' + tabData.page));
    } else {
      var callback = function callback() {
        if (_this7.state.hasChanges) {
          _this7.props.onCheck(false, _this7.setState({ tabID: tabID }));
        }
        if (tabData.isSticky) {
          // Scrolltop
          window.scrollTo(0, 150);
        }
        store.dispatch((0, _reactRouterRedux.replace)('/projects/' + data.projectID + '/units/' + data.id + '/?' + (0, _url.encodeSearch)(query)));
      };
      if (_this7.state.hasChanges) {
        store.dispatch((0, _prompt.promptChangesMessage)({ message: _promptMessages.DEFAULT_PROMPT, callback: callback }));
      } else {
        callback();
      }
    }
  };

  this.handleResetUnitLayout = function () {
    var editData = JSON.parse(JSON.stringify(_this7.state.data));
    _this7.setState({ editData: editData }, function () {
      _this7.handleResetCheck();
    });
  };

  this.checkBookable = function (statusID, project) {
    var user = _this7.props.auth;
    switch (statusID) {
      case 'new':
      case 'reserved':
        return true;
      case 'delist':
        if (project && project.rduIsEnabled && project.rduAccessGroupIDs) {
          if (user.isAdminBasic || user.isAdmin) return true;

          var uGroupIDs = [].concat(_toConsumableArray(user.groups.map(function (obj) {
            return obj.id;
          })));
          var uSrRoleIDs = (0, _srRoleAccess.matchGroupIDToSrRoleID)(uGroupIDs, user.companyBranch.isExternal);
          return (0, _srRoleAccess.hasAnyRequiredRoleIDs)(project.rduAccessGroupIDs, uSrRoleIDs);
        }
        return false;
      default:
        return false;
    }
  };

  this.checkCannotBookUnit = function () {
    var auth = _this7.props.auth;

    if ((0, _vietnam.isVietnamCompany)(auth)) return false;
    return !!(auth && auth.isExternalAgencyAdmin);
  };

  this.handleModalReservationClose = function () {
    _this7.setState({ modalReservationIsOpen: false });
  };

  this.handleBookUnit = function () {
    _this7.setState({ modalReservationIsOpen: true });
  };

  this.checkBusinessUnitLimitReached = function (unitData, user) {
    if (unitData && user && user.affiliate && user.affiliate.companyBranch.reservationLimit !== 0 && unitData.companyBranchBookingReserveCount >= user.affiliate.companyBranch.reservationLimit) {
      return true;
    }
    return false;
  };

  this.checkLaunchModeTimeout = function (data, user) {
    if (data.project && data.project.isLaunchMode && (0, _momentTimezone2.default)().isBefore((0, _momentTimezone2.default)(data.reservedTimeoutExpireAt)) && data.reservedByAwsUser !== user.awsUsername) {
      return true;
    }
    return false;
  };

  this.checkUserIsCooldown = function (data) {
    if (data.currentUserIsCooldown) return true;
    return false;
  };

  this.checkUserBapBanned = function (data) {
    if (data.bapUserBanned) return true;
    return false;
  };

  this.hasPreviewPriceAccess = function () {
    var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    var user = _this7.props.auth;
    var data = _this7.state.data;

    if (!user.isSuperAdmin && !user.isHeadquarters && !user.isMainHeadquarters) {
      if (user.isExternalAgent || user.isExternalAgentLeader) {
        if (data.statusID !== 'new' && data.project && data.project.bookingUnitLimit < 2) {
          return false;
        }
      } else if (data.statusID !== 'new' && data.statusID !== 'reserved' && data.statusID !== 'developer_reserved') {
        return false;
      }
    }
    return check;
  };

  this.hasGenerateQuotationAccess = function () {
    var user = _this7.props.auth;
    var data = _this7.state.data;

    if (data.project && data.project.quotnIsEnabled && data.project.quotnAccessGroupIDs) {
      if (user.isAdminBasic || user.isAdmin) return true;

      var uGroupIDs = [].concat(_toConsumableArray(user.groups.map(function (obj) {
        return obj.id;
      })));
      var uSrRoleIDs = (0, _srRoleAccess.matchGroupIDToSrRoleID)(uGroupIDs, user.companyBranch.isExternal);
      return (0, _srRoleAccess.hasAnyRequiredRoleIDs)(data.project.quotnAccessGroupIDs, uSrRoleIDs);
    }
    return false;
  };

  this.handleCancelDelete = function (e) {
    e.preventDefault();
    _this7.setState({
      showDeleteConfirm: false
    });
  };

  this.handleConfirmDelete = function (e) {
    e.preventDefault();
    _this7.setState({
      showDeleteConfirm: false
    }, function () {
      _this7.deleteUnit();
    });
  };

  this.handleDelete = function (e) {
    e.preventDefault();
    _this7.setState({
      showDeleteConfirm: true
    });
  };

  this.canDelete = function () {
    var data = _this7.state.data;

    if (data.projectUnitBookingSummary) {
      if (data.projectUnitBookingSummary.totalCount < 1) return true;
    }
    return false;
  };

  this.generateWSLink = function (data, user) {
    return 'https://wa.me/?text=' + (0, _sharing.shareUnitToWSFormat)(data, user, _this7.state.packagePricingCalculation);
  };

  this.handleCopyShareInfo = function (e) {
    e.preventDefault();
    var store = _this7.context.store;
    var data = _this7.state.data;
    var t = _this7.props.t;

    var user = _this7.props.auth;
    var copyText = (0, _sharing.shareUnitCopyFormat)(data, user, _this7.state.packagePricingCalculation);
    var textArea = document.createElement('textarea');
    textArea.value = copyText;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('Copy');
    textArea.remove();
    store.dispatch((0, _flash.flashSuccessMessage)({
      header: t('Copy Success', { ns: _translation.TRANSLATION_FILES.translation }),
      message: t('Successfully copied unit details to your clipboard', { ns: _translation.TRANSLATION_FILES.translation })
    }));
  };

  this.checkAllowUnitShare = function () {
    var data = _this7.props.appConfig.data;

    if (data && data.settings && data.settings.allowUnitSocialShare) return true;
    return false;
  };

  this.consumeSRCodeQuery = function () {
    if (!_this7.state.hasSRCodeQuery) return;
    var store = _this7.context.store;
    var location = _this7.props.location;

    var query = (0, _url.decodeSearch)(location.search);
    delete query.srCode;
    var nextSearch = (0, _url.encodeSearch)(query);
    var pathname = location.pathname || '/projects/' + _this7.props.id + '/units/' + _this7.props.unitID + '/';
    var nextLocation = '' + pathname + (nextSearch ? '?' + nextSearch : '') + (location.hash || window.location.hash || '');

    _this7.setState({ hasSRCodeQuery: false }, function () {
      return store.dispatch((0, _reactRouterRedux.replace)(nextLocation));
    });
  };

  this.getBookingFormURL = function () {
    var queryParams = new URLSearchParams(window.location.search);
    var source = queryParams.get('source');
    var opportunityID = queryParams.get('opportunityID');
    var bookingID = queryParams.get('bookingID');
    var srCode = _this7.state.srCode;


    var q = Object.assign({
      projectID: _this7.props.id,
      unitID: _this7.props.unitID
    });

    if (source) q.source = source;
    if (opportunityID) q.opportunityID = opportunityID;
    if (bookingID) q.bookingID = bookingID;
    if (srCode) q.srCode = srCode;

    return '/bookings/new/?' + _qs2.default.stringify(q);
  };

  this.handleOnToggleQuotationOpts = function (check) {
    return _this7.setState({ showQuotationOpts: check });
  };

  this.handleScrollPackagePricingIntoView = function (e) {
    e.preventDefault();
    var pricingPackageDiv = document.getElementById('pricing_package_div');
    if (pricingPackageDiv) {
      pricingPackageDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
      _this7.handleOnToggleQuotationOpts(true);
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Overview.mapStateToProps)(Overview));

/***/ }),
/* 2411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Project = function (_Component) {
  _inherits(Project, _Component);

  function Project(props) {
    var _this2 = this;

    _classCallCheck(this, Project);

    var _this = _possibleConstructorReturn(this, (Project.__proto__ || Object.getPrototypeOf(Project)).call(this, props));

    _this.newFetch = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.fetchProjectUnit();

            case 2:
              _context.next = 4;
              return _this.fetchMultiplePackagePricingCalculation();

            case 4:
              _context.next = 6;
              return _this.fetchMultiplePackageFees();

            case 6:
              _context.next = 8;
              return _this.fetchUnitCustomFieldSettings();

            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    _this.state = {
      token: null,
      loading: true,
      data: null,
      unitCustomSettingsLoading: false,
      unitCustomFieldSettings: [],
      packagePricingCalculation: [],
      calculatedFeePackages: []
    };
    return _this;
  }

  _createClass(Project, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchProjectUnit();
      this.fetchMultiplePackagePricingCalculation();
      this.fetchMultiplePackageFees();
      this.fetchUnitCustomFieldSettings();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var pathname = nextProps.location.pathname;

      if (!pathname.includes('/edit/')) {
        if (pathname !== this.props.location.pathname) {
          this.fetchProjectUnit();
        }
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'setUnitCustomSettingsLoading',
    value: function setUnitCustomSettingsLoading() {
      var _this5 = this;

      var unitCustomSettingsLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this5.setState({ unitCustomSettingsLoading: unitCustomSettingsLoading }, function () {
          res(unitCustomSettingsLoading);
        });
      });
    }
  }, {
    key: 'fetchProjectUnit',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, t, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context2.prev = 5;
                _context2.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.params.id + '/units/' + this.props.params.unitID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context2.sent;
                _context2.next = 19;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](5);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page') }));

              case 16:
                _context2.next = 18;
                return this.setLoading(false);

              case 18:
                return _context2.abrupt('return');

              case 19:
                if (res.ok) {
                  _context2.next = 27;
                  break;
                }

                _context2.next = 22;
                return res.text();

              case 22:
                message = _context2.sent;
                _context2.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context2.next = 33;
                break;

              case 27:
                token = res.headers.get('X-Csrf-Token');
                _context2.next = 30;
                return res.json();

              case 30:
                data = _context2.sent;
                _context2.next = 33;
                return this.setComponentState({
                  token: token,
                  data: data
                });

              case 33:
                _context2.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 11]]);
      }));

      function fetchProjectUnit() {
        return _ref2.apply(this, arguments);
      }

      return fetchProjectUnit;
    }()
  }, {
    key: 'fetchMultiplePackagePricingCalculation',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var store, t, res, message, json;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                res = null;
                _context3.prev = 3;
                _context3.next = 6;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + this.props.params.id + '/units/' + this.props.params.unitID + '/cal_multiple_package_pricing/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 6:
                res = _context3.sent;
                _context3.next = 20;
                break;

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3['catch'](3);

                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 14;
                return _context3.t0.res.text();

              case 14:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return', null);

              case 17:
                Bugsnag.notifyException(_context3.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again') + '.' }));
                return _context3.abrupt('return', null);

              case 20:
                _context3.next = 22;
                return res.json();

              case 22:
                json = _context3.sent;
                _context3.next = 25;
                return this.setComponentState({
                  packagePricingCalculation: json
                });

              case 25:
                return _context3.abrupt('return', null);

              case 26:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[3, 9]]);
      }));

      function fetchMultiplePackagePricingCalculation() {
        return _ref3.apply(this, arguments);
      }

      return fetchMultiplePackagePricingCalculation;
    }()
  }, {
    key: 'fetchMultiplePackageFees',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var store, res, message, json;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                store = this.context.store;
                res = null;
                _context4.prev = 2;
                _context4.next = 5;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + this.props.params.id + '/units/' + this.props.params.unitID + '/cal_multiple_package_fee/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 5:
                res = _context4.sent;
                _context4.next = 19;
                break;

              case 8:
                _context4.prev = 8;
                _context4.t0 = _context4['catch'](2);

                if (!(_context4.t0.res && _context4.t0.res.status >= 400 && _context4.t0.res.status < 500)) {
                  _context4.next = 16;
                  break;
                }

                _context4.next = 13;
                return _context4.t0.res.text();

              case 13:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context4.abrupt('return', null);

              case 16:
                Bugsnag.notifyException(_context4.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context4.abrupt('return', null);

              case 19:
                _context4.next = 21;
                return res.json();

              case 21:
                json = _context4.sent;
                _context4.next = 24;
                return this.setComponentState({
                  calculatedFeePackages: json
                });

              case 24:
                return _context4.abrupt('return', null);

              case 25:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2, 8]]);
      }));

      function fetchMultiplePackageFees() {
        return _ref4.apply(this, arguments);
      }

      return fetchMultiplePackageFees;
    }()
  }, {
    key: 'fetchUnitCustomFieldSettings',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var store, t, res, message, unitCustomFieldSettingsData;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.setUnitCustomSettingsLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context5.prev = 5;
                _context5.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/settings/unit_custom_fields/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context5.sent;
                _context5.next = 22;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5['catch'](5);
                _context5.next = 15;
                return this.setUnitCustomSettingsLoading(false);

              case 15:
                if (!(_context5.t0.res && _context5.t0.res.status >= 400 && _context5.t0.res.status < 500)) {
                  _context5.next = 20;
                  break;
                }

                _context5.next = 18;
                return _context5.t0.res.text();

              case 18:
                message = _context5.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 20:
                Bugsnag.notifyException(_context5.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again') + '.' }));

              case 22:
                if (res.ok) {
                  _context5.next = 28;
                  break;
                }

                _context5.next = 25;
                return this.setUnitCustomSettingsLoading(false);

              case 25:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again') + '.' }));
                _context5.next = 35;
                break;

              case 28:
                _context5.next = 30;
                return res.json();

              case 30:
                unitCustomFieldSettingsData = _context5.sent;
                _context5.next = 33;
                return this.setComponentState({
                  unitCustomFieldSettings: unitCustomFieldSettingsData
                });

              case 33:
                _context5.next = 35;
                return this.setUnitCustomSettingsLoading(false);

              case 35:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[5, 11]]);
      }));

      function fetchUnitCustomFieldSettings() {
        return _ref5.apply(this, arguments);
      }

      return fetchUnitCustomFieldSettings;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this6 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this6.state.token,
          loading: _this6.state.loading || _this6.state.unitCustomSettingsLoading,
          data: _this6.state.data,
          packagePricingCalculation: _this6.state.packagePricingCalculation,
          calculatedFeePackages: _this6.state.calculatedFeePackages,
          id: _this6.props.params.id,
          unitID: _this6.props.params.unitID,
          location: _this6.props.location,
          routerParams: _this6.props.params || null,
          newFetch: _this6.newFetch,
          unitCustomFieldSettings: _this6.state.unitCustomFieldSettings
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Project;
}(_react.Component);

Project.propTypes = {
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    unitID: _propTypes2.default.string
  }),
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object
  })
};
Project.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.translation)(Project);

/***/ }),
/* 2412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _fileSize = __webpack_require__(85);

var _fileSize2 = _interopRequireDefault(_fileSize);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _AddDocument = __webpack_require__(1073);

var _AddDocument2 = _interopRequireDefault(_AddDocument);

var _LayoutTitle = __webpack_require__(395);

var _LayoutTitle2 = _interopRequireDefault(_LayoutTitle);

var _navigations = __webpack_require__(396);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _initialiseProps.call(_this);

    var state = List.getPropsToState(props);
    _this.state = _extends({}, state, {
      options: [],
      selectedFile: null,
      showRemove: false,
      showAddDocument: false
    });
    return _this;
  }

  _createClass(List, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var store = this.context.store;

      store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.id + '/layouts/' + this.props.unitLayoutID + '/documents/?' + (0, _url.encodeSearch)(query)));
    }
  }, {
    key: 'addDocument',
    value: function addDocument() {
      var _this2 = this;

      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/unit_layouts/' + this.props.unitLayoutID + '/documents/' + this.state.selectedFile.id + '/', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.documentToken
        }
      })).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      }).then(function () {
        _this2.handleChangePage();
        store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Add Success', message: 'Document successfully added to unit layout' }));
      });
    }
  }, {
    key: 'removeDocument',
    value: function removeDocument() {
      var _this3 = this;

      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/unit_layouts/' + this.props.unitLayoutID + '/documents/' + this.state.selectedFile.id + '/', {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.documentToken
        }
      })).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      }).then(function () {
        _this3.setState({
          selectedFile: null,
          loading: false
        });
        _this3.handleChangePage();
        store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Remove Success', message: 'Document successfully deleted' }));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var t = this.props.t;
      var pathname = this.props.location.pathname;
      var store = this.context.store;

      var links = (0, _navigations.routes)(this.props.id, this.props.unitLayoutID, true);
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: t(link.text),
              active: pathname === link.value,
              onClick: function onClick() {
                return store.dispatch((0, _reactRouterRedux.replace)(link.value));
              }
            });
          }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              onClick: this.handleShowAddDocument,
              disabled: this.state.loading,
              primary: true,
              icon: 'add',
              content: t('Add', { ns: _translation.TRANSLATION_FILES.translation })
            })
          )
        }),
        _react2.default.createElement(_LayoutTitle2.default, { data: this.props.data }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_AddDocument2.default, {
                open: this.state.showAddDocument,
                onClose: this.handleCloseAddDocument,
                onConfirm: this.handleAddDocument,
                onUpload: this.handleUpload,
                onCheck: this.handleCheck
              }),
              _react2.default.createElement(
                _semanticUiReact.Modal,
                {
                  open: this.state.showRemove,
                  onClose: this.handleCancelRemove
                },
                _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: 'Confirm remove?' }),
                _react2.default.createElement(
                  _semanticUiReact.Modal.Content,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Modal.Description,
                    null,
                    _react2.default.createElement(_semanticUiReact.Header, {
                      as: 'h3',
                      content: 'Are you sure to remove this file?',
                      subheader: this.state.selectedFile ? this.state.selectedFile.name : ''
                    })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Modal.Actions,
                  null,
                  _react2.default.createElement(_semanticUiReact.Button, { basic: true, negative: true, onClick: this.handleCancelRemove, icon: 'cancel', content: 'No', inverted: true }),
                  _react2.default.createElement(_semanticUiReact.Button, { basic: true, positive: true, onClick: this.handleConfirmRemove, icon: 'remove', content: 'Yes', inverted: true })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                {
                  inverted: true, style: { zIndex: 20 },
                  active: this.state.loading && this.state.documents.length > 0
                },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table,
                {
                  striped: true, unstackable: true,
                  selectable: true
                },
                _react2.default.createElement(
                  _semanticUiReact.Table.Header,
                  { fullWidth: true },
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      { colSpan: 4, textAlign: 'right' },
                      _react2.default.createElement(_PageNav2.default, {
                        currentPage: this.state.currentPage,
                        count: this.state.count,
                        limit: this.state.limit,
                        offset: this.state.offset,
                        dataSize: this.state.documents.length,
                        loading: this.state.loading,
                        onChange: this.handleChangePage
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      'Name'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      'Size'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      'Tags'
                    ),
                    _react2.default.createElement(_semanticUiReact.Table.HeaderCell, null)
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Body,
                  null,
                  this.state.documents.length > 0 ? this.state.documents.map(function (file, key) {
                    return _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      { key: key },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { width: 6 },
                        _react2.default.createElement(
                          'a',
                          {
                            href: _config2.default.get('bookApiURL') + '/documents/' + file.id + '/view/' + encodeURIComponent(file.name) + '.pdf',
                            target: '_blank',
                            rel: 'noopener noreferrer'
                          },
                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'file pdf outline' }),
                          file.name
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { collapsing: true },
                        (0, _fileSize2.default)(file.size)
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Label.Group,
                          { size: 'tiny' },
                          file.tags && file.tags.length > 0 ? file.tags.map(function (tag, idx) {
                            return _react2.default.createElement(
                              _semanticUiReact.Label,
                              { key: idx, as: 'a' },
                              tag
                            );
                          }) : _react2.default.createElement(
                            'p',
                            null,
                            t('No tags set', { ns: _translation.TRANSLATION_FILES.translation })
                          )
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { collapsing: true, textAlign: 'right' },
                        _react2.default.createElement(_semanticUiReact.Button, {
                          size: 'tiny',
                          compact: true,
                          negative: true,
                          icon: 'remove',
                          disabled: _this4.state.loading,
                          onClick: function onClick(e) {
                            return _this4.handleRemove(e, file);
                          }
                        })
                      )
                    );
                  }) : _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      { colSpan: 4, textAlign: 'center' },
                      this.state.loading ? _react2.default.createElement(
                        _semanticUiReact.Loader,
                        { active: true, inline: 'centered' },
                        t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                      ) : t('No documents found.', { ns: _translation.TRANSLATION_FILES.translation })
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Footer,
                  { fullWidth: true },
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      { colSpan: 4, textAlign: 'right' },
                      _react2.default.createElement(_PageNav2.default, {
                        currentPage: this.state.currentPage,
                        count: this.state.count,
                        limit: this.state.limit,
                        offset: this.state.offset,
                        dataSize: this.state.documents.length,
                        loading: this.state.loading,
                        onChange: this.handleChangePage
                      })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};
List.propTypes = {
  documentToken: _propTypes2.default.string,
  id: _propTypes2.default.string,
  unitLayoutID: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  var count = props.count;
  var limit = props.limit;
  var offset = props.offset;
  var documents = props.documents || [];
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var menuIsTab = window.innerWidth <= 590;
  return {
    documents: documents,
    loading: loading,
    count: count,
    limit: limit,
    offset: offset,
    currentPage: currentPage,
    menuIsTab: menuIsTab
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.handleResize = function () {
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this5.state.menuIsTab) {
      _this5.setState({ menuIsTab: menuIsTab });
    }
  };

  this.handleChangePage = function (page) {
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
      query.page = 1;
    }
    var currentPage = parseInt(page || query.page, 10);
    query.page = currentPage;
    _this5.setState({ currentPage: currentPage });
    _this5.replaceQuery(query);
  };

  this.handleCancelRemove = function (e) {
    e.preventDefault();
    _this5.setState({
      showRemove: false,
      selectedFile: null
    });
  };

  this.handleRemove = function (e, selectedFile) {
    e.preventDefault();
    _this5.setState({
      selectedFile: selectedFile
    }, function () {
      _this5.setState({
        showRemove: true
      });
    });
  };

  this.handleConfirmRemove = function (e) {
    e.preventDefault();
    _this5.setState({
      showRemove: false
    }, function () {
      _this5.removeDocument();
    });
  };

  this.handleUpload = function (body) {
    return {
      url: '/projects/' + _this5.props.id + '/unit_layouts/' + _this5.props.unitLayoutID + '/documents/',
      options: {
        credentials: 'include',
        method: 'POST',
        headers: {
          // Let browser decide Content-Type
          'X-Csrf-Token': _this5.props.documentToken
        },
        body: body
      }
    };
  };

  this.handleShowAddDocument = function (e) {
    e.preventDefault();
    _this5.setState({
      showAddDocument: true
    });
  };

  this.handleCloseAddDocument = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this5.handleChangePage();
    _this5.setState({
      showAddDocument: false
    });
  };

  this.handleAddDocument = function (e, selectedFile) {
    e.preventDefault();
    _this5.setState({
      showAddDocument: false,
      selectedFile: selectedFile
    }, function () {
      _this5.addDocument();
    });
  };

  this.handleCheck = function (data) {
    if (data.unitLayouts && data.unitLayouts.length > 0) {
      return data.unitLayouts.some(function (p) {
        return p.id === _this5.props.unitLayoutID;
      });
    }
    return false;
  };

  this.handleMenu = function (e, _ref) {
    var value = _ref.value;
    var store = _this5.context.store;

    store.dispatch((0, _reactRouterRedux.replace)(value));
  };
};

exports.default = _reactI18next.withTranslation.apply(undefined, _toConsumableArray(_translation.namespaces))(List);

/***/ }),
/* 2413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1061);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */


var Edit = function (_Component) {
  _inherits(Edit, _Component);

  function Edit(props) {
    _classCallCheck(this, Edit);

    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));

    _this.getFormInstance = function () {
      var form = _this.form;
      while (form && form.getWrappedInstance) {
        form = form.getWrappedInstance();
      }
      return form;
    };

    _this.handleSubmit = function (event) {
      _this.getFormInstance().handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(Edit, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, unitLayout) {
        var _this2 = this;

        var store, t, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.getFormInstance().submit('/projects/' + this.props.id + '/unit_layouts/' + this.props.unitLayoutID + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(unitLayout)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false);
                });
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('{{name}} successfully updated', { name: res.name, ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Edit', { ns: _translation.TRANSLATION_FILES.translation }) + ' ' + (this.props.data ? this.props.data.name : t('Layout').toLowerCase()),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Save', { ns: _translation.TRANSLATION_FILES.translation }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, unitLayout) {
            _this3.submit(validations, unitLayout);
          },
          onChange: this.handleOnChange,
          projectID: this.props.id,
          location: this.props.location,
          loading: this.props.loading,
          unitLayout: this.props.data
        })
      );
    }
  }]);

  return Edit;
}(_react.Component);

Edit.propTypes = {
  token: _propTypes2.default.string,
  id: _propTypes2.default.string,
  unitLayoutID: _propTypes2.default.string,
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  location: _propTypes2.default.shape({
    hash: _propTypes2.default.string
  }),
  loading: _propTypes2.default.bool,
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
Edit.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(Edit);

/***/ }),
/* 2414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(13);

var _reactRedux = __webpack_require__(9);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fileSize = __webpack_require__(85);

var _fileSize2 = _interopRequireDefault(_fileSize);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _ContentPlaceholder = __webpack_require__(1011);

var _ContentPlaceholder2 = _interopRequireDefault(_ContentPlaceholder);

var _EditableBox = __webpack_require__(153);

var _EditableBox2 = _interopRequireDefault(_EditableBox);

var _GalleryList = __webpack_require__(561);

var _GalleryList2 = _interopRequireDefault(_GalleryList);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _ProjectUnitsList = __webpack_require__(567);

var _ProjectUnitsList2 = _interopRequireDefault(_ProjectUnitsList);

var _SpecificationTable = __webpack_require__(127);

var _SpecificationTable2 = _interopRequireDefault(_SpecificationTable);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _MarkdownText = __webpack_require__(193);

var _MarkdownText2 = _interopRequireDefault(_MarkdownText);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _LayoutTitle = __webpack_require__(395);

var _LayoutTitle2 = _interopRequireDefault(_LayoutTitle);

var _navigations = __webpack_require__(396);

var _translation = __webpack_require__(64);

var _vietnam = __webpack_require__(40);

var _unitLayout = __webpack_require__(270);

var _translation2 = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_momentTimezone2.default.locale('en-gb');

var Overview = function (_Component) {
  _inherits(Overview, _Component);

  function Overview(props) {
    _classCallCheck(this, Overview);

    var _this = _possibleConstructorReturn(this, (Overview.__proto__ || Object.getPrototypeOf(Overview)).call(this, props));

    _initialiseProps.call(_this);

    var state = Overview.getPropsToState(props);
    _this.state = _extends({}, state, {
      collapseSegments: [{
        hideGallery: false,
        hideDocument: false,
        hideUnitAvailability: false
      }],
      pictures: [],
      showLarge: false,
      selectedPicture: null,
      hasChanges: false,
      showDeleteConfirm: false,
      viewLargeType: 'picture'
    });
    return _this;
  }

  _createClass(Overview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Overview.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this2.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      var _this3 = this;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true }, function () {
          _this3.handleOnCheck(true);
        });
      }
    }
  }, {
    key: 'handleResetCheck',
    value: function handleResetCheck() {
      var _this4 = this;

      if (this.state.hasChanges) {
        this.setState({ hasChanges: false }, function () {
          _this4.handleOnCheck(false);
        });
      }
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var user = this.props.auth;
      if (this.props.auth.isSuperAdmin || this.props.auth.isHeadquarters) {
        return true;
      }
      if (this.props.auth.isBranchLeaderSupervisorII && this.state.data.project && this.state.data.project.maOwnerCompanyBranchID === user.companyBranch.id) {
        return true;
      }
      return check;
    }
  }, {
    key: 'updateUnitLayout',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(unitLayout) {
        var _this5 = this;

        var store, res, message, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                _context.next = 3;
                return this.setComponentState({ loading: true });

              case 3:
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/unit_layouts/' + this.props.unitLayoutID + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(unitLayout)
                }));

              case 7:
                res = _context.sent;
                _context.next = 20;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 19;
                  break;
                }

                _context.next = 16;
                return _context.t0.res.text();

              case 16:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 19:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));

              case 20:
                _context.next = 22;
                return res.json();

              case 22:
                data = _context.sent;
                _context.next = 25;
                return this.setComponentState({ loading: false }, function () {
                  _this5.handleResetCheck();
                });

              case 25:
                store.dispatch((0, _reactRouterRedux.push)('/projects/' + this.props.id + '/layouts/' + this.props.unitLayoutID + '/'));
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Update Success', message: data.name + ' successfully updated' }));

              case 27:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function updateUnitLayout(_x3) {
        return _ref.apply(this, arguments);
      }

      return updateUnitLayout;
    }()
  }, {
    key: 'deleteUnitLayout',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                _context2.next = 3;
                return this.setState({ loading: true });

              case 3:
                _context2.prev = 3;
                _context2.next = 6;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/unit_layouts/' + this.props.unitLayoutID + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  }
                }));

              case 6:
                _context2.next = 20;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](3);
                _context2.next = 12;
                return this.setState({ loading: false });

              case 12:
                Bugsnag.notifyException(_context2.t0);

                if (!(_context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 16;
                return _context2.t0.res.text();

              case 16:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 19:
                store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));

              case 20:
                _context2.next = 22;
                return this.setState({ loading: false });

              case 22:
                store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.id + '/'));
                store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Delete Success', message: 'Unit layout successfully deleted' }));

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 8]]);
      }));

      function deleteUnitLayout() {
        return _ref2.apply(this, arguments);
      }

      return deleteUnitLayout;
    }()
  }, {
    key: 'checkDisabled',
    value: function checkDisabled() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';
      var _state = this.state,
          pictures = _state.pictures,
          selectedPicture = _state.selectedPicture;

      if (selectedPicture) {
        var index = pictures.indexOf(selectedPicture);
        if (direction === 'left') {
          return index - 1 >= 0;
        }
        return index + 1 < pictures.length;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var t = this.props.t;
      var pathname = this.props.location.pathname;
      var store = this.context.store;
      var _state2 = this.state,
          data = _state2.data,
          editData = _state2.editData,
          isMobile = _state2.isMobile;
      var _state$collapseSegmen = this.state.collapseSegments,
          hideGallery = _state$collapseSegmen.hideGallery,
          hideDocument = _state$collapseSegmen.hideDocument,
          hideUnitAvailability = _state$collapseSegmen.hideUnitAvailability;

      var links = (0, _navigations.routes)(this.props.id, this.props.unitLayoutID, this.hasAccess());
      var isVietnam = (0, _vietnam.isVietnamCompany)(this.props.auth);
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_DeleteConfirm2.default, {
          open: this.state.showDeleteConfirm,
          onClose: this.handleCancelDelete,
          onConfirm: this.handleConfirmDelete,
          name: data.name || 'Layout'
        }),
        _react2.default.createElement(_NavBar2.default, {
          header: links.length > 1 ? null : t('Overview'),
          links: links.length > 1 && (this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: t(link.text),
              content: t(link.text),
              active: pathname === link.value,
              onClick: function onClick() {
                return store.dispatch((0, _reactRouterRedux.replace)(link.value));
              }
            });
          })),
          rightNav: this.hasAccess() ? _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(
              'div',
              null,
              this.hasAccess() && this.canDelete() && _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  color: 'red',
                  disabled: this.state.loading,
                  icon: true,
                  title: 'Delete',
                  onClick: this.handleDelete
                },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'trash' })
              ),
              this.hasAccess() && _react2.default.createElement(_semanticUiReact.Button, {
                as: _reactRouter.Link,
                primary: true,
                content: t('Edit', { ns: _translation2.TRANSLATION_FILES.translation }),
                disabled: this.state.loading,
                to: '/projects/' + this.props.id + '/layouts/' + this.props.unitLayoutID + '/edit/'
              })
            )
          ) : null
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'top', columns: 'equal' },
          _react2.default.createElement(_ViewLarge2.default, {
            open: this.state.showLarge,
            onClose: this.handleCloseLarge,
            picture: this.state.selectedPicture,
            onSlide: this.handleSlidePicture,
            disabledLeft: !this.checkDisabled('left'),
            disabledRight: !this.checkDisabled('right'),
            slideshow: true,
            type: this.state.viewLargeType
          })
        ),
        _react2.default.createElement(_LayoutTitle2.default, { data: data }),
        isVietnam && _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { marginTop: '1em' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, style: isMobile ? { padding: '0' } : {} },
              _react2.default.createElement(
                _semanticUiReact.Segment,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { columns: 'equal', doubling: true, stackable: true },
                  _unitLayout.VN_LAYOUT_FIELDS.map(function (field) {
                    return _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { key: field, textAlign: 'center' },
                      _react2.default.createElement(
                        _semanticUiReact.Header,
                        { size: 'tiny' },
                        (0, _translation.translateModels)(t, field, 'projectUnitLayout'),
                        _react2.default.createElement(
                          _semanticUiReact.Header.Subheader,
                          null,
                          (0, _unitLayout.layoutFieldDisplay)(data[field])
                        )
                      )
                    );
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { marginTop: '1em' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, style: isMobile ? { padding: '0' } : {} },
              this.hasAccess(data.overview) ? _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { verticalAlign: 'middle' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_EditableBox2.default, {
                    newHeader: (0, _translation.translateModels)(t, 'overview', 'projectUnitLayout').toUpperCase(),
                    isCollapsible: true,
                    hideBorder: true,
                    editable: this.hasAccess(),
                    loading: this.state.loading,
                    onClick: this.handleUpdateUnitLayout,
                    onCancel: this.handleResetUnitLayout,
                    content: function content(_ref3) {
                      var isEditing = _ref3.isEditing,
                          onConfirm = _ref3.onConfirm;
                      return isEditing ? _react2.default.createElement(
                        _semanticUiReact.Form,
                        { onSubmit: onConfirm },
                        _react2.default.createElement(_semanticUiReact.Form.TextArea, {
                          placeholder: (0, _translation.translateModels)(t, 'overview', 'projectUnitLayout'),
                          name: 'overview',
                          value: editData.overview,
                          onChange: _this6.handleInputChange
                        })
                      ) : _react2.default.createElement(
                        _ContentPlaceholder2.default,
                        {
                          paragraphs: true,
                          loading: _this6.state.loading
                        },
                        data.overview ? _react2.default.createElement(_MarkdownText2.default, { content: data.overview }) : _react2.default.createElement(
                          _semanticUiReact.Segment,
                          { textAlign: 'center' },
                          _react2.default.createElement(
                            'p',
                            null,
                            t('Description not set'),
                            '.'
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Button,
                            {
                              as: _reactRouter.Link,
                              primary: true, compact: true,
                              disabled: _this6.state.loading,
                              to: '/projects/' + _this6.props.id + '/layouts/' + _this6.props.unitLayoutID + '/edit/#info'
                            },
                            t('Click here to add')
                          )
                        )
                      );
                    }
                  })
                )
              ) : null
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, style: isMobile ? { padding: '0' } : {} },
              this.hasAccess(data.specifications && data.specifications.length > 0) ? _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_SpecificationTable2.default, {
                    newHeader: t('Layout Specification').toUpperCase(),
                    isCollapsible: true,
                    type: 'unit_layouts',
                    data: editData.specifications,
                    editable: this.hasAccess(),
                    loading: this.state.loading,
                    onChange: this.handleSpecificationsChange,
                    onClick: this.handleUpdateUnitLayout,
                    onCancel: this.handleResetUnitLayout,
                    notFoundNode: _react2.default.createElement(
                      'p',
                      null,
                      t('No information set'),
                      '.'
                    ),
                    onAdd: function onAdd() {
                      return store.dispatch((0, _reactRouterRedux.push)('/projects/' + _this6.props.id + '/layouts/' + _this6.props.unitLayoutID + '/edit/#specifications'));
                    }
                  })
                )
              ) : null
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, style: isMobile ? { padding: '0' } : {} },
              this.hasAccess(data.pictures && data.pictures.length > 0) || data.virtualTourURL !== '' ? _react2.default.createElement(
                _semanticUiReact.Header,
                {
                  className: 'new_title',
                  as: 'h5',
                  textAlign: 'center',
                  attached: 'top'
                },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16, textAlign: 'center' },
                      t('Gallery').toUpperCase()
                    ),
                    _react2.default.createElement(_semanticUiReact.Label, {
                      as: 'button',
                      attached: 'top right',
                      icon: hideGallery ? 'angle up' : 'angle down',
                      className: 'collapse-button',
                      style: {
                        position: 'absolute',
                        right: '0',
                        top: '3px',
                        marginRight: '0',
                        marginTop: '0.5em'
                      },
                      name: 'hideGallery',
                      value: hideGallery,
                      onClick: this.handleOnCollapseSegment,
                      disabled: this.state.loading
                    })
                  )
                )
              ) : null,
              (this.hasAccess(data.pictures && data.pictures.length > 0) || data.virtualTourURL !== '') && !hideGallery ? _react2.default.createElement(
                _semanticUiReact.Segment,
                { attached: true },
                data.virtualTourURL !== '' ? _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { style: { textAlign: 'right', paddingBottom: '1em' } },
                    _react2.default.createElement(_semanticUiReact.Button, {
                      as: 'a',
                      color: 'teal',
                      icon: 'street view',
                      content: 'Virtual Tour',
                      disabled: this.state.loading,
                      href: data.virtualTourURL,
                      target: '_blank',
                      rel: 'noopener noreferrer'
                    })
                  )
                ) : null,
                this.hasAccess(data.pictures && data.pictures.length > 0 || data.medias && data.medias.length > 0) ? _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_GalleryList2.default, {
                      editable: this.hasAccess(),
                      pictures: this.getProjectUnitLayoutPictures(),
                      projectID: this.props.id,
                      unitLayoutID: this.props.unitLayoutID,
                      loading: this.state.loading,
                      excludeType: ['site_plan', 'map'],
                      tabular: this.state.galleryIsTab,
                      onViewLarge: this.handleViewLarge,
                      onChange: this.handleGetPicture,
                      addPath: '/projects/' + this.props.id + '/layouts/' + this.props.unitLayoutID + '/pictures/',
                      addVideoPath: '/projects/' + this.props.id + '/layouts/' + this.props.unitLayoutID + '/videos/'
                    })
                  )
                ) : null
              ) : null
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, style: isMobile ? { padding: '0' } : {} },
              this.hasAccess(data.documents && data.documents.length > 0) ? _react2.default.createElement(
                _semanticUiReact.Header,
                {
                  className: 'new_title',
                  as: 'h5',
                  textAlign: 'center',
                  attached: 'top'
                },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16, textAlign: 'center' },
                      t('Documents').toUpperCase()
                    ),
                    _react2.default.createElement(_semanticUiReact.Label, {
                      as: 'button',
                      attached: 'top right',
                      icon: hideDocument ? 'angle up' : 'angle down',
                      className: 'collapse-button',
                      style: {
                        position: 'absolute',
                        right: '0',
                        top: '3px',
                        marginRight: '0',
                        marginTop: '0.5em'
                      },
                      name: 'hideDocument',
                      value: hideDocument,
                      onClick: this.handleOnCollapseSegment,
                      disabled: this.state.loading
                    })
                  )
                )
              ) : null,
              this.hasAccess(data.documents && data.documents.length > 0) && !hideDocument ? _react2.default.createElement(
                _semanticUiReact.Segment,
                { attached: true },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Segment.Group,
                      null,
                      data.documents && data.documents.length > 0 ? data.documents.map(function (file, idx) {
                        return _react2.default.createElement(
                          _semanticUiReact.Segment,
                          { key: idx },
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            {
                              columns: 'equal',
                              verticalAlign: 'middle',
                              as: 'a',
                              href: _config2.default.get('bookApiURL') + '/documents/' + file.id + '/view/' + encodeURIComponent(file.name) + '.pdf',
                              target: '_blank',
                              rel: 'noopener noreferrer'
                            },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              null,
                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'file pdf outline' }),
                              file.name,
                              _react2.default.createElement(
                                'span',
                                { className: 'mobile-hide' },
                                ' (',
                                (0, _fileSize2.default)(file.size),
                                ')'
                              ),
                              _react2.default.createElement(
                                'small',
                                { className: 'large-hide small-hide tablet-hide' },
                                _react2.default.createElement('br', null),
                                (0, _fileSize2.default)(file.size)
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right' },
                              _react2.default.createElement(
                                'small',
                                null,
                                _react2.default.createElement(_Timestamp2.default, { format: 'DD/MM/YY hh:mm a', timestamp: file.createdAt })
                              )
                            )
                          )
                        );
                      }) : _react2.default.createElement(
                        _semanticUiReact.Segment,
                        { textAlign: 'center' },
                        _react2.default.createElement(
                          'p',
                          null,
                          t('No documents found'),
                          '.'
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Button,
                          {
                            as: _reactRouter.Link,
                            primary: true, compact: true,
                            disabled: this.state.loading,
                            to: '/projects/' + this.props.id + '/layouts/' + this.props.unitLayoutID + '/documents/'
                          },
                          t('Click here to add')
                        )
                      )
                    )
                  )
                )
              ) : null
            )
          ),
          (0, _vietnam.showsLayoutUnitAvailability)(this.props.auth) && _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, style: isMobile ? { padding: '0' } : {} },
              _react2.default.createElement(
                _semanticUiReact.Header,
                {
                  className: 'new_title',
                  as: 'h5',
                  textAlign: 'center',
                  attached: 'top'
                },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { width: 16, textAlign: 'center' },
                      t('Unit Availability').toUpperCase()
                    ),
                    _react2.default.createElement(_semanticUiReact.Label, {
                      as: 'button',
                      attached: 'top right',
                      icon: hideUnitAvailability ? 'angle up' : 'angle down',
                      className: 'collapse-button',
                      style: {
                        position: 'absolute',
                        right: '0',
                        top: '3px',
                        marginRight: '0',
                        marginTop: '0.5em'
                      },
                      name: 'hideUnitAvailability',
                      value: hideUnitAvailability,
                      onClick: this.handleOnCollapseSegment,
                      disabled: this.state.loading
                    })
                  )
                )
              ),
              !hideUnitAvailability ? _react2.default.createElement(
                _semanticUiReact.Segment,
                { attached: true },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(_ProjectUnitsList2.default, {
                      toggleable: true,
                      loading: this.state.loading,
                      projectID: this.props.id,
                      project: data.project,
                      unitLayoutID: this.props.unitLayoutID,
                      unitOnClick: this.handleUnitClick,
                      hideNew: 'true',
                      addPath: '/projects/' + this.props.id + '/units/new/?unitLayoutID=' + this.props.unitLayoutID,
                      notFoundNode: _react2.default.createElement(
                        'span',
                        null,
                        _react2.default.createElement(
                          'p',
                          null,
                          'No units found.'
                        ),
                        this.hasAccess() && _react2.default.createElement(
                          _semanticUiReact.Button,
                          {
                            as: _reactRouter.Link,
                            primary: true, compact: true,
                            disabled: this.state.loading,
                            to: '/projects/' + this.props.id + '/units/new/?unitLayoutID=' + this.props.unitLayoutID
                          },
                          'Click here to add'
                        )
                      )
                    })
                  )
                )
              ) : null
            )
          )
        )
      );
    }
  }]);

  return Overview;
}(_react.Component);

Overview.propTypes = {
  id: _propTypes2.default.string,
  unitLayoutID: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool
  }),
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
Overview.contextTypes = {
  store: _propTypes2.default.object
};

Overview.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

Overview.getPropsToState = function (props) {
  var windowWidth = window.innerWidth;
  var data = props.data || {};
  var editData = JSON.parse(JSON.stringify(data));
  var loading = props.loading;
  var menuIsTab = window.innerWidth <= 590;
  var galleryIsTab = window.innerWidth > 425;
  var isMobile = windowWidth < 768;
  return {
    data: data,
    editData: editData,
    isMobile: isMobile,
    loading: loading,
    menuIsTab: menuIsTab,
    galleryIsTab: galleryIsTab
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.handleResize = function () {
    var state = _this7.state;
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this7.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    var galleryIsTab = window.innerWidth > 425;
    if (galleryIsTab !== _this7.state.galleryIsTab) {
      state.galleryIsTab = galleryIsTab;
    }
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    if (isMobile !== _this7.state.isMobile) {
      state.isMobile = isMobile;
    }
    _this7.setState(_extends({}, state));
  };

  this.handleOnCheck = function () {
    var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (_this7.props.onCheck) {
      _this7.props.onCheck(hasChanges);
    }
  };

  this.handleCloseLarge = function (e) {
    e.preventDefault();
    _this7.setState({
      showLarge: false,
      selectedPicture: null
    });
  };

  this.handleViewLarge = function (e, data) {
    var viewLargeType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'picture';

    e.preventDefault();
    _this7.setState({
      selectedPicture: data,
      showLarge: true,
      viewLargeType: viewLargeType
    });
  };

  this.handleMenu = function (e, _ref4) {
    var value = _ref4.value;
    var store = _this7.context.store;

    store.dispatch((0, _reactRouterRedux.replace)(value));
  };

  this.handleUnitClick = function (e, _ref5) {
    var unit = _ref5.unit,
        isEditing = _ref5.isEditing;
    var store = _this7.context.store;

    store.dispatch((0, _reactRouterRedux.push)('/projects/' + _this7.props.id + '/units/' + unit.id + '/' + (isEditing ? 'edit/' : '')));
  };

  this.handleSpecificationsChange = function (data) {
    var editData = _this7.state.editData;

    editData.specifications = data;
    _this7.setState({ editData: editData }, function () {
      _this7.handleCheckChanges();
    });
  };

  this.handleInputChange = function (event, data) {
    var editData = _this7.state.editData;

    editData[data.name] = data.value;
    _this7.setState({ editData: editData }, function () {
      _this7.handleCheckChanges();
    });
  };

  this.handleUpdateUnitLayout = function () {
    var _state3 = _this7.state,
        data = _state3.data,
        editData = _state3.editData;

    if (editData.specifications) {
      editData.specifications = editData.specifications.filter(function (d) {
        return d.name.length > 0 && d.value.length > 0;
      }).map(function (d, idx) {
        return _extends({}, d, {
          position: idx + 1
        });
      });
    }
    if (JSON.stringify(editData) !== JSON.stringify(data)) {
      _this7.updateUnitLayout(editData);
    }
    _this7.handleResetUnitLayout();
  };

  this.handleResetUnitLayout = function () {
    var editData = JSON.parse(JSON.stringify(_this7.state.data));
    _this7.setState({ editData: editData }, function () {
      _this7.handleResetCheck();
    });
  };

  this.handleGetPicture = function (pictures) {
    _this7.setState({ pictures: pictures });
  };

  this.handleSlidePicture = function (e) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
    var _state4 = _this7.state,
        pictures = _state4.pictures,
        selectedPicture = _state4.selectedPicture;

    var index = pictures.indexOf(selectedPicture);
    var nextIndex = direction === 'left' ? index - 1 : index + 1;
    _this7.setState({
      selectedPicture: pictures[nextIndex]
    });
  };

  this.handleCancelDelete = function (e) {
    e.preventDefault();
    _this7.setState({
      showDeleteConfirm: false
    });
  };

  this.handleConfirmDelete = function (e) {
    e.preventDefault();
    _this7.setState({
      showDeleteConfirm: false
    }, function () {
      _this7.deleteUnitLayout();
    });
  };

  this.handleDelete = function (e) {
    e.preventDefault();
    _this7.setState({
      showDeleteConfirm: true
    });
  };

  this.handleOnCollapseSegment = function (e, _ref6) {
    var name = _ref6.name,
        value = _ref6.value;
    var collapseSegments = _this7.state.collapseSegments;

    e.preventDefault();
    collapseSegments[name] = !value;
    _this7.setState({ collapseSegments: collapseSegments });
  };

  this.canDelete = function () {
    var data = _this7.state.data;

    if (data.summary && !data.summary.totalUnits) {
      return true;
    }
    return false;
  };

  this.getProjectUnitLayoutPictures = function () {
    var data = _this7.state.data;

    var newPictures = [];
    if (data.pictures != null && data.pictures.length > 0) {
      newPictures = data.pictures.map(function (p) {
        var newP = _extends({}, p);
        if (p.unitLayouts != null && p.unitLayouts.length > 0) {
          if (p.unitLayouts[0].type !== '') newP.type = p.unitLayouts[0].type;
        }
        return newP;
      });
    }
    if (data.medias != null && data.medias.length > 0) {
      newPictures = newPictures.concat(data.medias);
    }
    return newPictures;
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation2.namespaces), [_translation2.TRANSLATION_FILES.models.projectUnitLayout]))((0, _reactRedux.connect)(Overview.mapStateToProps)(Overview));

/***/ }),
/* 2415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _PictureList = __webpack_require__(386);

var _PictureList2 = _interopRequireDefault(_PictureList);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _AddPicture = __webpack_require__(1075);

var _AddPicture2 = _interopRequireDefault(_AddPicture);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _RemovePicture = __webpack_require__(590);

var _RemovePicture2 = _interopRequireDefault(_RemovePicture);

var _LayoutTitle = __webpack_require__(395);

var _LayoutTitle2 = _interopRequireDefault(_LayoutTitle);

var _navigations = __webpack_require__(396);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pictures = function (_Component) {
  _inherits(Pictures, _Component);

  function Pictures(props) {
    _classCallCheck(this, Pictures);

    var _this = _possibleConstructorReturn(this, (Pictures.__proto__ || Object.getPrototypeOf(Pictures)).call(this, props));

    _initialiseProps.call(_this);

    var state = Pictures.getPropsToState(props);
    _this.state = _extends({}, state, {
      showConfirm: false,
      showLarge: false,
      selectedPicture: null,
      showAddPicture: false,
      pictures: []
    });
    _this.pictureList = null;
    return _this;
  }

  _createClass(Pictures, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Pictures.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'handleRefetch',
    value: function handleRefetch() {
      this.pictureList.getWrappedInstance().handleRefetch();
    }
  }, {
    key: 'addPicture',
    value: function addPicture(type) {
      var _this2 = this;

      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/unit_layouts/' + this.props.unitLayoutID + '/pictures/' + this.state.selectedPicture.id + '/', {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.pictureToken
        },
        body: JSON.stringify({ type: type })
      })).then(function () {
        _this2.pictureModal.handleRefetch();
        store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Add Picture Success', message: 'Picture successfully added to unit layout' }));
      }).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      });
    }
  }, {
    key: 'deletePicture',
    value: function deletePicture() {
      var _this3 = this;

      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/unit_layouts/' + this.props.unitLayoutID + '/pictures/' + this.state.selectedPicture.id + '/', {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.pictureToken
        }
      })).then(function () {
        _this3.handleRefetch();
        store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Delete Success', message: 'Picture successfully deleted' }));
      }).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      });
    }
  }, {
    key: 'checkDisabled',
    value: function checkDisabled() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';
      var _state = this.state,
          pictures = _state.pictures,
          selectedPicture = _state.selectedPicture;

      if (selectedPicture) {
        var index = pictures.indexOf(selectedPicture);
        if (direction === 'left') {
          return index - 1 >= 0;
        }
        return index + 1 < pictures.length;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var t = this.props.t;
      var pathname = this.props.location.pathname;
      var store = this.context.store;

      var links = (0, _navigations.routes)(this.props.id, this.props.unitLayoutID, true);
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: t(link.text),
              active: pathname === link.value,
              onClick: function onClick() {
                return store.dispatch((0, _reactRouterRedux.replace)(link.value));
              }
            });
          }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              onClick: this.handleShowAddPicture,
              disabled: this.state.loading,
              primary: true,
              icon: 'add',
              content: t('Add', { ns: _translation.TRANSLATION_FILES.translation })
            })
          )
        }),
        _react2.default.createElement(_LayoutTitle2.default, { data: this.props.data }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_AddPicture2.default, {
                type: 'unit_layout',
                ref: function ref(_ref) {
                  _this4.pictureModal = _ref;
                },
                open: this.state.showAddPicture,
                onClose: this.handleCloseAddPicture,
                onConfirm: this.handleAddPicture,
                onUpload: this.handleUpload,
                onCheck: this.handleCheck
              }),
              _react2.default.createElement(_ViewLarge2.default, {
                open: this.state.showLarge,
                onClose: this.handleCloseLarge,
                picture: this.state.selectedPicture,
                onSlide: this.handleSlidePicture,
                disabledLeft: !this.checkDisabled('left'),
                disabledRight: !this.checkDisabled('right'),
                slideshow: this.state.showLarge
              }),
              _react2.default.createElement(_RemovePicture2.default, {
                open: this.state.showConfirm,
                onClose: this.handleCancelRemove,
                onConfirm: this.handleConfirmRemove,
                picture: this.state.selectedPicture,
                data: this.props.data
              }),
              _react2.default.createElement(_PictureList2.default, {
                ref: function ref(_ref3) {
                  _this4.pictureList = _ref3;
                },
                toggleable: true,
                projectID: this.props.id,
                unitLayoutID: this.props.unitLayoutID,
                onChange: this.handleGetPictures,
                onViewLarge: this.handleViewLarge,
                onRemove: this.handleRemove,
                buttonNode: function buttonNode(_ref2) {
                  var isMobile = _ref2.isMobile,
                      view = _ref2.view,
                      loading = _ref2.loading,
                      picture = _ref2.picture;
                  return view === 'list' ? _react2.default.createElement(_semanticUiReact.Button, {
                    size: 'tiny',
                    compact: true,
                    negative: true,
                    icon: 'remove',
                    content: isMobile ? null : 'Remove',
                    disabled: loading,
                    onClick: function onClick(e) {
                      return _this4.handleRemove(e, picture);
                    }
                  }) : null;
                }
              })
            )
          )
        )
      );
    }
  }]);

  return Pictures;
}(_react.Component);

Pictures.contextTypes = {
  store: _propTypes2.default.object
};
Pictures.propTypes = {
  pictureToken: _propTypes2.default.string,
  id: _propTypes2.default.string,
  unitLayoutID: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};

Pictures.getPropsToState = function (props) {
  var loading = props.loading;
  var menuIsTab = window.innerWidth <= 590;
  return {
    loading: loading,
    menuIsTab: menuIsTab
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.handleResize = function () {
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this5.state.menuIsTab) {
      _this5.setState({ menuIsTab: menuIsTab });
    }
  };

  this.handleCancelRemove = function (e) {
    e.preventDefault();
    _this5.setState({
      showConfirm: false,
      selectedPicture: null
    });
  };

  this.handleRemove = function (e, selectedPicture) {
    e.preventDefault();
    _this5.setState({
      selectedPicture: selectedPicture
    }, function () {
      _this5.setState({
        showConfirm: true
      });
    });
  };

  this.handleConfirmRemove = function (e) {
    e.preventDefault();
    _this5.setState({
      showConfirm: false
    }, function () {
      _this5.deletePicture();
    });
  };

  this.handleCloseLarge = function (e) {
    e.preventDefault();
    _this5.setState({
      showLarge: false,
      selectedPicture: null
    });
  };

  this.handleViewLarge = function (e, selectedPicture) {
    e.preventDefault();
    _this5.setState({
      selectedPicture: selectedPicture,
      showLarge: true
    });
  };

  this.handleShowAddPicture = function (e) {
    e.preventDefault();
    _this5.setState({
      showAddPicture: true
    });
  };

  this.handleCloseAddPicture = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this5.handleRefetch();
    _this5.setState({
      showAddPicture: false
    });
  };

  this.handleAddPicture = function (e, selectedPicture, pictureType) {
    e.preventDefault();
    _this5.setState({
      selectedPicture: selectedPicture
    }, function () {
      _this5.addPicture(pictureType);
    });
  };

  this.handleUpload = function (body) {
    return {
      url: '/projects/' + _this5.props.id + '/unit_layouts/' + _this5.props.unitLayoutID + '/pictures/',
      options: {
        credentials: 'include',
        method: 'POST',
        headers: {
          // Let browser decide Content-Type
          'X-Csrf-Token': _this5.props.pictureToken
        },
        body: body
      }
    };
  };

  this.handleCheck = function (data) {
    if (data.unitLayouts && data.unitLayouts.length > 0) {
      return data.unitLayouts.some(function (p) {
        return p.projectUnitLayoutID === _this5.props.unitLayoutID;
      });
    }
    return false;
  };

  this.handleMenu = function (e, _ref4) {
    var value = _ref4.value;
    var store = _this5.context.store;

    store.dispatch((0, _reactRouterRedux.replace)(value));
  };

  this.handleGetPictures = function (pictures) {
    _this5.setState({ pictures: pictures });
  };

  this.handleSlidePicture = function (e) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
    var _state2 = _this5.state,
        pictures = _state2.pictures,
        selectedPicture = _state2.selectedPicture;

    var index = pictures.indexOf(selectedPicture);
    var nextIndex = direction === 'left' ? index - 1 : index + 1;
    _this5.setState({
      selectedPicture: pictures[nextIndex]
    });
  };
};

exports.default = _reactI18next.withTranslation.apply(undefined, _toConsumableArray(_translation.namespaces))(Pictures);

/***/ }),
/* 2416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _checkChanges = __webpack_require__(61);

var _Overview = __webpack_require__(2414);

var _Overview2 = _interopRequireDefault(_Overview);

var _Edit = __webpack_require__(2413);

var _Edit2 = _interopRequireDefault(_Edit);

var _List = __webpack_require__(2415);

var _List2 = _interopRequireDefault(_List);

var _List3 = __webpack_require__(2412);

var _List4 = _interopRequireDefault(_List3);

var _List5 = __webpack_require__(2417);

var _List6 = _interopRequireDefault(_List5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitLayout = function (_Component) {
  _inherits(UnitLayout, _Component);

  function UnitLayout(props) {
    _classCallCheck(this, UnitLayout);

    var _this = _possibleConstructorReturn(this, (UnitLayout.__proto__ || Object.getPrototypeOf(UnitLayout)).call(this, props));

    _this.state = {
      token: null,
      pictureToken: null,
      documentToken: null,
      mediaToken: null,
      count: 0,
      limit: 0,
      offset: 0,
      loading: true,
      data: null,
      documents: []
    };
    return _this;
  }

  _createClass(UnitLayout, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props$location = this.props.location,
          pathname = _props$location.pathname,
          query = _props$location.query;

      this.fetchProjectUnitLayout();
      if (!pathname.includes('/edit/')) {
        if (pathname.includes('/pictures/')) {
          this.fetchProjectUnitLayoutPictures();
        }
        if (pathname.includes('/documents/')) {
          this.fetchProjectUnitLayoutDocuments(query);
        }
        if (pathname.includes('/videos/')) {
          this.fetchProjectUnitLayoutMedias(query);
        }
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _nextProps$location = nextProps.location,
          pathname = _nextProps$location.pathname,
          query = _nextProps$location.query;

      if (!pathname.includes('/edit/')) {
        if (pathname.includes('/pictures/')) {
          this.fetchProjectUnitLayoutPictures();
        } else if (pathname.includes('/documents/')) {
          this.fetchProjectUnitLayoutDocuments(query);
        } else if (pathname.includes('/videos/')) {
          this.fetchProjectUnitLayoutMedias(query);
        } else {
          this.fetchProjectUnitLayout();
        }
      }
    }
  }, {
    key: 'setDocuments',
    value: function setDocuments() {
      var _this2 = this;

      var documents = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this2.setState({
          documents: documents || []
        }, function () {
          res(documents);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchProjectUnitLayout',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.params.id + '/unit_layouts/' + this.props.params.unitLayoutID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                return _context.abrupt('return');

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 32;
                break;

              case 26:
                token = res.headers.get('X-Csrf-Token');
                _context.next = 29;
                return res.json();

              case 29:
                data = _context.sent;
                _context.next = 32;
                return this.setComponentState({
                  token: token,
                  data: data
                });

              case 32:
                _context.next = 34;
                return this.setLoading(false);

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchProjectUnitLayout() {
        return _ref.apply(this, arguments);
      }

      return fetchProjectUnitLayout;
    }()
  }, {
    key: 'fetchProjectUnitLayoutPictures',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, res, message, pictureToken;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context2.prev = 4;
                _context2.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.params.id + '/unit_layouts/' + this.props.params.unitLayoutID + '/pictures/?page=1', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context2.sent;
                _context2.next = 18;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](4);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context2.next = 17;
                return this.setLoading(false);

              case 17:
                return _context2.abrupt('return');

              case 18:
                if (res.ok) {
                  _context2.next = 26;
                  break;
                }

                _context2.next = 21;
                return res.text();

              case 21:
                message = _context2.sent;
                _context2.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context2.next = 29;
                break;

              case 26:
                pictureToken = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context2.next = 29;
                return this.setComponentState({
                  pictureToken: pictureToken
                });

              case 29:
                _context2.next = 31;
                return this.setLoading(false);

              case 31:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10]]);
      }));

      function fetchProjectUnitLayoutPictures() {
        return _ref2.apply(this, arguments);
      }

      return fetchProjectUnitLayoutPictures;
    }()
  }, {
    key: 'fetchProjectUnitLayoutDocuments',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(q) {
        var store, query, res, message, documentToken, count, limit, offset, documents;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                res = void 0;
                _context3.prev = 6;
                _context3.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.params.id + '/unit_layouts/' + this.props.params.unitLayoutID + '/documents/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context3.sent;
                _context3.next = 20;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t0 = _context3['catch'](6);

                Bugsnag.notifyException(_context3.t0);
                _context3.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 17:
                _context3.next = 19;
                return this.setLoading(false);

              case 19:
                return _context3.abrupt('return');

              case 20:
                if (res.ok) {
                  _context3.next = 28;
                  break;
                }

                _context3.next = 23;
                return res.text();

              case 23:
                message = _context3.sent;
                _context3.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context3.next = 40;
                break;

              case 28:
                documentToken = res.headers.get('X-Csrf-Token');
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context3.next = 34;
                return res.json();

              case 34:
                documents = _context3.sent;
                _context3.next = 37;
                return this.setDocuments(documents);

              case 37:
                if (this.state.documents.length < 1 && query.page > 1) {
                  query.page = 1;
                  store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.params.id + '/layouts/' + this.props.params.unitLayoutID + '/documents/?' + _qs2.default.stringify(query)));
                }
                // handle token.. etc
                _context3.next = 40;
                return this.setComponentState({
                  documentToken: documentToken,
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 40:
                _context3.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[6, 12]]);
      }));

      function fetchProjectUnitLayoutDocuments(_x4) {
        return _ref3.apply(this, arguments);
      }

      return fetchProjectUnitLayoutDocuments;
    }()
  }, {
    key: 'fetchProjectUnitLayoutMedias',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var store, res, message, mediaToken;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context4.prev = 4;
                _context4.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.params.id + '/unit_layouts/' + this.props.params.unitLayoutID + '/medias/?page=1', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context4.sent;
                _context4.next = 18;
                break;

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4['catch'](4);

                Bugsnag.notifyException(_context4.t0);
                _context4.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context4.next = 17;
                return this.setLoading(false);

              case 17:
                return _context4.abrupt('return');

              case 18:
                if (res.ok) {
                  _context4.next = 26;
                  break;
                }

                _context4.next = 21;
                return res.text();

              case 21:
                message = _context4.sent;
                _context4.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context4.next = 29;
                break;

              case 26:
                mediaToken = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context4.next = 29;
                return this.setComponentState({
                  mediaToken: mediaToken
                });

              case 29:
                _context4.next = 31;
                return this.setLoading(false);

              case 31:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 10]]);
      }));

      function fetchProjectUnitLayoutMedias() {
        return _ref4.apply(this, arguments);
      }

      return fetchProjectUnitLayoutMedias;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this5 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this5.state.token,
          pictureToken: _this5.state.pictureToken,
          documentToken: _this5.state.documentToken,
          mediaToken: _this5.state.mediaToken,
          count: _this5.state.count,
          limit: _this5.state.limit,
          offset: _this5.state.offset,
          loading: _this5.state.loading,
          data: _this5.state.data,
          documents: _this5.state.documents,
          id: _this5.props.params.id,
          unitLayoutID: _this5.props.params.unitLayoutID
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return UnitLayout;
}(_react.Component);

UnitLayout.propTypes = {
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    unitLayoutID: _propTypes2.default.string
  }),
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object
  })
};
UnitLayout.contextTypes = {
  store: _propTypes2.default.object
};
UnitLayout.Overview = (0, _checkChanges.checkChanges)(_Overview2.default);
UnitLayout.Edit = (0, _checkChanges.checkChanges)(_Edit2.default);
UnitLayout.Pictures = _List2.default;
UnitLayout.Documents = _List4.default;
UnitLayout.Videos = _List6.default;
exports.default = UnitLayout;

/***/ }),
/* 2417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _MediaList = __webpack_require__(385);

var _MediaList2 = _interopRequireDefault(_MediaList);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _AddMedia = __webpack_require__(1074);

var _AddMedia2 = _interopRequireDefault(_AddMedia);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _RemoveMedia = __webpack_require__(589);

var _RemoveMedia2 = _interopRequireDefault(_RemoveMedia);

var _LayoutTitle = __webpack_require__(395);

var _LayoutTitle2 = _interopRequireDefault(_LayoutTitle);

var _navigations = __webpack_require__(396);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Videos = function (_Component) {
  _inherits(Videos, _Component);

  function Videos(props) {
    _classCallCheck(this, Videos);

    var _this = _possibleConstructorReturn(this, (Videos.__proto__ || Object.getPrototypeOf(Videos)).call(this, props));

    _initialiseProps.call(_this);

    var state = Videos.getPropsToState(props);
    _this.state = _extends({}, state, {
      showConfirm: false,
      showLarge: false,
      selectedMedia: null,
      showAddMedia: false,
      pictures: []
    });
    _this.mediaList = null;
    return _this;
  }

  _createClass(Videos, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Videos.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'handleRefetch',
    value: function handleRefetch() {
      this.mediaList.getWrappedInstance().handleRefetch();
    }
  }, {
    key: 'deleteMedia',
    value: function deleteMedia() {
      var _this2 = this;

      var t = this.props.t;
      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/unit_layouts/' + this.props.unitLayoutID + '/medias/' + this.state.selectedMedia.id + '/', {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.mediaToken
        }
      })).then(function () {
        _this2.handleRefetch();
        store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Video successfully deleted', { ns: _translation.TRANSLATION_FILES.translation }) }));
      }).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      });
    }
  }, {
    key: 'checkDisabled',
    value: function checkDisabled() {
      var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'right';
      var _state = this.state,
          pictures = _state.pictures,
          selectedMedia = _state.selectedMedia;

      if (selectedMedia) {
        var index = pictures.indexOf(selectedMedia);
        if (direction === 'left') {
          return index - 1 >= 0;
        }
        return index + 1 < pictures.length;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;
      var pathname = this.props.location.pathname;
      var store = this.context.store;

      var links = (0, _navigations.routes)(this.props.id, this.props.unitLayoutID, true);
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: t(link.text),
              active: pathname === link.value,
              onClick: function onClick() {
                return store.dispatch((0, _reactRouterRedux.replace)(link.value));
              }
            });
          }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              onClick: this.handleShowAddMedia,
              disabled: this.state.loading,
              primary: true,
              icon: 'add',
              content: t('Add', { ns: _translation.TRANSLATION_FILES.translation })
            })
          )
        }),
        _react2.default.createElement(_LayoutTitle2.default, { data: this.props.data }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_AddMedia2.default, {
                type: 'unit_layout',
                ref: function ref(_ref) {
                  _this3.mediaModal = _ref;
                },
                open: this.state.showAddMedia,
                onClose: this.handleCloseAddMedia,
                onConfirm: this.handleAddMedia,
                onCreate: this.handleCreate,
                onCheck: this.handleCheck
              }),
              _react2.default.createElement(_ViewLarge2.default, {
                open: this.state.showLarge,
                onClose: this.handleCloseLarge,
                picture: this.state.selectedMedia,
                type: 'video'
              }),
              _react2.default.createElement(_RemoveMedia2.default, {
                open: this.state.showConfirm,
                onClose: this.handleCancelRemove,
                onConfirm: this.handleConfirmRemove,
                media: this.state.selectedMedia,
                data: this.props.data
              }),
              _react2.default.createElement(_MediaList2.default, {
                ref: function ref(_ref3) {
                  _this3.mediaList = _ref3;
                },
                toggleable: true,
                projectID: this.props.id,
                unitLayoutID: this.props.unitLayoutID,
                onChange: this.handleGetVideos,
                onViewLarge: this.handleViewLarge,
                onRemove: this.handleRemove,
                buttonNode: function buttonNode(_ref2) {
                  var isMobile = _ref2.isMobile,
                      view = _ref2.view,
                      loading = _ref2.loading,
                      item = _ref2.item;
                  return view === 'list' ? _react2.default.createElement(_semanticUiReact.Button, {
                    size: 'tiny',
                    compact: true,
                    negative: true,
                    icon: 'remove',
                    content: isMobile ? null : 'Remove',
                    disabled: loading,
                    onClick: function onClick(e) {
                      return _this3.handleRemove(e, item);
                    }
                  }) : null;
                }
              })
            )
          )
        )
      );
    }
  }]);

  return Videos;
}(_react.Component);

Videos.contextTypes = {
  store: _propTypes2.default.object
};
Videos.propTypes = {
  mediaToken: _propTypes2.default.string,
  id: _propTypes2.default.string,
  unitLayoutID: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};

Videos.getPropsToState = function (props) {
  var loading = props.loading;
  var menuIsTab = window.innerWidth <= 590;
  return {
    loading: loading,
    menuIsTab: menuIsTab
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleResize = function () {
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this4.state.menuIsTab) {
      _this4.setState({ menuIsTab: menuIsTab });
    }
  };

  this.addMedia = function () {
    var t = _this4.props.t;
    var store = _this4.context.store;

    store.dispatch((0, _fetchM.fetchM)('/projects/' + _this4.props.id + '/unit_layouts/' + _this4.props.unitLayoutID + '/medias/' + _this4.state.selectedMedia.id + '/', {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Token': _this4.props.mediaToken
      }
    })).then(function () {
      _this4.mediaModal.handleRefetch();
      store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Add Video Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Video successfully added to unit layout', { ns: _translation.TRANSLATION_FILES.translation }) }));
    }).catch(function (err) {
      store.dispatch((0, _flash.flashErrorMessage)(err));
    });
  };

  this.handleCancelRemove = function (e) {
    e.preventDefault();
    _this4.setState({
      showConfirm: false,
      selectedMedia: null
    });
  };

  this.handleRemove = function (e, selectedMedia) {
    e.preventDefault();
    _this4.setState({
      selectedMedia: selectedMedia
    }, function () {
      _this4.setState({
        showConfirm: true
      });
    });
  };

  this.handleConfirmRemove = function (e) {
    e.preventDefault();
    _this4.setState({
      showConfirm: false
    }, function () {
      _this4.deleteMedia();
    });
  };

  this.handleCloseLarge = function (e) {
    e.preventDefault();
    _this4.setState({
      showLarge: false,
      selectedMedia: null
    });
  };

  this.handleViewLarge = function (e, selectedMedia) {
    e.preventDefault();
    _this4.setState({
      selectedMedia: selectedMedia,
      showLarge: true
    });
  };

  this.handleShowAddMedia = function (e) {
    e.preventDefault();
    _this4.setState({
      showAddMedia: true
    });
  };

  this.handleCloseAddMedia = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this4.handleRefetch();
    _this4.setState({
      showAddMedia: false
    });
  };

  this.handleAddMedia = function (e, selectedMedia) {
    e.preventDefault();
    _this4.setState({
      selectedMedia: selectedMedia
    }, function () {
      _this4.addMedia();
    });
  };

  this.handleCreate = function (data) {
    return {
      url: '/projects/' + _this4.props.id + '/unit_layouts/' + _this4.props.unitLayoutID + '/medias/',
      options: {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': _this4.props.mediaToken
        },
        body: JSON.stringify(data)
      }
    };
  };

  this.handleCheck = function (data) {
    if (data.unitLayouts && data.unitLayouts.length > 0) {
      return data.unitLayouts.some(function (p) {
        return p.projectUnitLayoutID === _this4.props.unitLayoutID;
      });
    }
    return false;
  };

  this.handleMenu = function (e, _ref4) {
    var value = _ref4.value;
    var store = _this4.context.store;

    store.dispatch((0, _reactRouterRedux.replace)(value));
  };

  this.handleGetVideos = function (pictures) {
    _this4.setState({ pictures: pictures });
  };

  this.handleSlidePicture = function (e) {
    var direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'right';
    var _state2 = _this4.state,
        pictures = _state2.pictures,
        selectedMedia = _state2.selectedMedia;

    var index = pictures.indexOf(selectedMedia);
    var nextIndex = direction === 'left' ? index - 1 : index + 1;
    _this4.setState({
      selectedMedia: pictures[nextIndex]
    });
  };
};

exports.default = _reactI18next.withTranslation.apply(undefined, _toConsumableArray(_translation.namespaces))(Videos);

/***/ }),
/* 2418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _UnitLayout = __webpack_require__(2416);

var _UnitLayout2 = _interopRequireDefault(_UnitLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _UnitLayout2.default;

/***/ }),
/* 2419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _url = __webpack_require__(19);

var _translation = __webpack_require__(64);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _translation2 = __webpack_require__(4);

var _areaLabel = __webpack_require__(223);

var _countries = __webpack_require__(60);

var _unitLayout = __webpack_require__(270);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
/* eslint-disable no-nested-ternary */


var CompareLayouts = function (_Component) {
  _inherits(CompareLayouts, _Component);

  function CompareLayouts(props) {
    _classCallCheck(this, CompareLayouts);

    var _this = _possibleConstructorReturn(this, (CompareLayouts.__proto__ || Object.getPrototypeOf(CompareLayouts)).call(this, props));

    _initialiseProps.call(_this);

    var state = CompareLayouts.getPropsToState(props);
    _this.state = _extends({}, state, {
      selectedLayout: {},
      unitLowestPrice: []
    });
    return _this;
  }

  _createClass(CompareLayouts, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var layoutIdFromUrl = this.state.layoutIdFromUrl;

      var state = CompareLayouts.getPropsToState(nextProps);
      this.setState(_extends({}, state));
      this.fetchProjectUnitLowestPrice();

      // set initial selected layout unit id
      if (this.state && this.state.data && this.state.data.unitLayouts) {
        var selectedLayout = {};
        var getFilteredUnitLayouts = this.state.data.unitLayouts.filter(function (item) {
          return item.id !== layoutIdFromUrl;
        });

        getFilteredUnitLayouts.forEach(function (unit, idx) {
          if (unit.id !== layoutIdFromUrl) {
            var result = _defineProperty({}, 'selectLayout' + (idx + 2), unit.id);
            Object.assign(selectedLayout, result);
          }
        });
        this.setState({
          selectedLayout: _extends({
            selectLayout1: layoutIdFromUrl || ''
          }, selectedLayout)
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchProjectUnitLowestPrice',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, t, res, message, json;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/units/units_price/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 19;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation2.TRANSLATION_FILES.translation }) }));

              case 16:
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context.next = 31;
                break;

              case 27:
                _context.next = 29;
                return res.json();

              case 29:
                json = _context.sent;

                if (json) {
                  this.setState({ unitLowestPrice: json });
                }

              case 31:
                _context.next = 33;
                return this.setLoading(false);

              case 33:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchProjectUnitLowestPrice() {
        return _ref.apply(this, arguments);
      }

      return fetchProjectUnitLowestPrice;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          data = _state.data,
          isMobile = _state.isMobile;
      var unitLayouts = data.unitLayouts;
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, null),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 2 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            {
              centered: true,
              columns: isMobile ? 2 : unitLayouts ? unitLayouts.length >= 3 ? 3 : 2 : null,
              className: 'compare_header'
            },
            _react2.default.createElement(
              'h4',
              null,
              t('Compare Layouts')
            ),
            data && data.name ? _react2.default.createElement(
              'p',
              null,
              data.name
            ) : ''
          ),
          this.renderDropdown()
        ),
        this.renderContent()
      );
    }
  }]);

  return CompareLayouts;
}(_react.Component);

CompareLayouts.contextTypes = {
  store: _propTypes2.default.object
};
CompareLayouts.propTypes = {
  id: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool
  }),
  data: _propTypes2.default.shape({
    maOwnerCompanyBranchID: _propTypes2.default.number
  }),
  datas: _propTypes2.default.oneOfType([_propTypes2.default.array]).isRequired,
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      lawyerIsEnabled: _propTypes2.default.bool
    })
  })
};

CompareLayouts.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

CompareLayouts.getPropsToState = function (props) {
  var layoutIdFromUrl = props.router.location.query.layoutID || '';
  var loading = props.loading;
  var isMobile = window.innerWidth < 768;
  var isMediumScreen = window.innerWidth <= 990 && window.innerWidth >= 767;
  var count = props.count;
  var limit = props.limit;
  var offset = props.offset;
  var data = props.data || [];
  var datas = props.datas || [];
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var menuIsTab = window.innerWidth <= 590;
  return {
    data: data,
    datas: datas,
    isMobile: isMobile,
    loading: loading,
    count: count,
    limit: limit,
    offset: offset,
    currentPage: currentPage,
    menuIsTab: menuIsTab,
    layoutIdFromUrl: layoutIdFromUrl,
    isMediumScreen: isMediumScreen
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getOptionData = function (data) {
    if (data) {
      var DpOptions = data.map(function (unit) {
        return {
          text: unit.name,
          value: unit.id
        };
      });
      return DpOptions;
    }
    return null;
  };

  this.handleResize = function () {
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    var isMediumScreen = window.innerWidth <= 990 && window.innerWidth >= 767;
    if (isMobile !== _this3.state.isMobile) {
      _this3.setState({ isMobile: isMobile });
    }
    if (isMediumScreen !== _this3.state.isMediumScreen) {
      _this3.setState({ isMediumScreen: isMediumScreen });
    }
  };

  this.handleOnChange = function (event, _ref2) {
    var value = _ref2.value,
        name = _ref2.name;
    var selectedLayout = _this3.state.selectedLayout;

    selectedLayout[name] = value;
    _this3.setState({ selectedLayout: selectedLayout });
  };

  this.renderDropdown = function () {
    var _state2 = _this3.state,
        data = _state2.data,
        selectedLayout = _state2.selectedLayout,
        isMobile = _state2.isMobile,
        isMediumScreen = _state2.isMediumScreen;
    var t = _this3.props.t;

    var unitLayouts = data.unitLayouts;
    if (unitLayouts) {
      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        {
          centered: true,
          columns: isMobile ? 2 : unitLayouts.length >= 3 ? isMediumScreen ? 2 : 3 : 2
        },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          _react2.default.createElement(_semanticUiReact.Dropdown, {
            placeholder: t('Select {{title}}', { title: t('Layout') }),
            name: 'selectLayout1',
            fluid: true,
            selection: true,
            value: _typeof(selectedLayout.selectLayout1) === 'object' ? selectedLayout.selectLayout1.id : selectedLayout.selectLayout1,
            options: _this3.getOptionData(unitLayouts),
            onChange: function onChange(event, value) {
              return _this3.handleOnChange(event, value);
            }
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          _react2.default.createElement(_semanticUiReact.Dropdown, {
            placeholder: t('Select {{title}}', { title: t('Layout') }),
            name: 'selectLayout2',
            fluid: true,
            selection: true,
            value: _typeof(selectedLayout.selectLayout2) === 'object' ? selectedLayout.selectLayout2.id : selectedLayout.selectLayout2,
            options: _this3.getOptionData(unitLayouts),
            onChange: function onChange(event, value) {
              return _this3.handleOnChange(event, value);
            }
          })
        ),
        unitLayouts.length >= 3 && !isMobile ? _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { only: 'computer' },
          _react2.default.createElement(_semanticUiReact.Dropdown, {
            placeholder: t('Select {{title}}', { title: t('Layout') }),
            name: 'selectLayout3',
            fluid: true,
            selection: true,
            value: _typeof(selectedLayout.selectLayout3) === 'object' ? selectedLayout.selectLayout3.id : selectedLayout.selectLayout3,
            options: _this3.getOptionData(unitLayouts),
            onChange: function onChange(event, value) {
              return _this3.handleOnChange(event, value);
            }
          })
        ) : null
      );
    }
    return null;
  };

  this.renderPriceRow = function () {
    var _state3 = _this3.state,
        data = _state3.data,
        selectedLayout = _state3.selectedLayout,
        isMobile = _state3.isMobile,
        unitLowestPrice = _state3.unitLowestPrice,
        isMediumScreen = _state3.isMediumScreen;
    var t = _this3.props.t;

    var unitLayouts = data.unitLayouts;
    var selectLayout1 = selectedLayout.selectLayout1,
        selectLayout2 = selectedLayout.selectLayout2,
        selectLayout3 = selectedLayout.selectLayout3;

    var getLowestUnitPrice1 = unitLowestPrice && selectLayout1 ? unitLowestPrice.find(function (p) {
      return p.id === selectLayout1.id;
    }) : null;
    var getLowestUnitPrice2 = unitLowestPrice && selectLayout2 ? unitLowestPrice.find(function (p) {
      return p.id === selectLayout2.id;
    }) : null;
    var getLowestUnitPrice3 = unitLowestPrice && selectLayout3 ? unitLowestPrice.find(function (p) {
      return p.id === selectLayout3.id;
    }) : null;
    if (selectLayout1 && unitLowestPrice) {
      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        {
          centered: true,
          columns: isMobile ? 2 : unitLayouts.length >= 3 ? isMediumScreen ? 2 : 3 : 2,
          className: 'sizeRow'
        },
        _react2.default.createElement(
          _semanticUiReact.Divider,
          { horizontal: true },
          t('Price')
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { verticalAlign: 'middle' },
          getLowestUnitPrice1 && getLowestUnitPrice1.min_price ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              _react2.default.createElement(_LoanAmount2.default, {
                format: '0,000,000',
                amount: getLowestUnitPrice1.min_price || 0,
                prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
              })
            ),
            _react2.default.createElement(
              'small',
              null,
              t('Starting from')
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No {{title}} available', { title: t('Price').toLowerCase() })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          getLowestUnitPrice2 && getLowestUnitPrice2.min_price ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              _react2.default.createElement(_LoanAmount2.default, {
                format: '0,000,000',
                amount: getLowestUnitPrice2.min_price || 0,
                prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
              })
            ),
            _react2.default.createElement(
              'small',
              null,
              t('Starting from')
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No {{title}} available', { title: t('Price').toLowerCase() })
          )
        ),
        unitLayouts.length >= 3 && !isMobile ? _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { only: 'computer' },
          getLowestUnitPrice3 && getLowestUnitPrice3.min_price ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              _react2.default.createElement(_LoanAmount2.default, {
                format: '0,000,000',
                amount: getLowestUnitPrice3.min_price || 0,
                prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
              })
            ),
            _react2.default.createElement(
              'small',
              null,
              t('Starting from')
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No {{title}} available', { title: t('Price').toLowerCase() })
          )
        ) : null
      );
    }
    return _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      { centered: true, columns: isMobile ? 2 : 3, className: 'sizeRow' },
      _react2.default.createElement(
        _semanticUiReact.Divider,
        { horizontal: true },
        t('Price')
      )
    );
  };

  this.renderSpecRow = function () {
    var _state4 = _this3.state,
        data = _state4.data,
        selectedLayout = _state4.selectedLayout,
        isMobile = _state4.isMobile,
        isMediumScreen = _state4.isMediumScreen;
    var t = _this3.props.t;

    var unitLayouts = data.unitLayouts;
    var selectLayout1 = selectedLayout.selectLayout1,
        selectLayout2 = selectedLayout.selectLayout2,
        selectLayout3 = selectedLayout.selectLayout3;

    // check layout spec has bed field

    var checkLayout1Bed = selectLayout1 && selectLayout1.specifications ? selectLayout1.specifications.some(function (spec) {
      return spec.shortName === 'Bed';
    }) : '';
    var checkLayout2Bed = selectLayout2 && selectLayout2.specifications ? selectLayout2.specifications.some(function (spec) {
      return spec.shortName === 'Bed';
    }) : '';
    var checkLayout3Bed = selectLayout3 && selectLayout3.specifications ? selectLayout3.specifications.some(function (spec) {
      return spec.shortName === 'Bed';
    }) : '';

    // check layout spec has bath field
    var checkLayout1Bath = selectLayout1 && selectLayout1.specifications ? selectLayout1.specifications.some(function (spec) {
      return spec.shortName === 'Bath';
    }) : '';
    var checkLayout2Bath = selectLayout2 && selectLayout2.specifications ? selectLayout2.specifications.some(function (spec) {
      return spec.shortName === 'Bath';
    }) : '';
    var checkLayout3Bath = selectLayout3 && selectLayout3.specifications ? selectLayout3.specifications.some(function (spec) {
      return spec.shortName === 'Bath';
    }) : '';

    // check layout spec has car field
    var checkLayout1Car = selectLayout1 && selectLayout1.specifications ? selectLayout1.specifications.some(function (spec) {
      return spec.shortName === 'Car';
    }) : '';
    var checkLayout2Car = selectLayout2 && selectLayout2.specifications ? selectLayout2.specifications.some(function (spec) {
      return spec.shortName === 'Car';
    }) : '';
    var checkLayout3Car = selectLayout3 && selectLayout3.specifications ? selectLayout3.specifications.some(function (spec) {
      return spec.shortName === 'Car';
    }) : '';

    return _react2.default.createElement(
      _semanticUiReact.Grid.Row,
      {
        centered: true,
        columns: isMobile ? 2 : unitLayouts.length >= 3 ? isMediumScreen ? 2 : 3 : 2,
        className: 'spec_row'
      },
      _react2.default.createElement(
        _semanticUiReact.Divider,
        { horizontal: true },
        t('Specifications')
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        selectLayout1 && selectLayout1.specifications && checkLayout1Bed ? selectLayout1.specifications.map(function (spec, idx) {
          return spec.name.toLowerCase() === 'bedrooms' ? _react2.default.createElement(
            'div',
            { className: 'specColumns', key: idx },
            _react2.default.createElement(
              'h1',
              null,
              isNaN(spec.value) ? '' : _react2.default.createElement(
                'small',
                null,
                'x'
              ),
              spec.value || '0'
            ),
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'bed' }),
            _react2.default.createElement(
              'p',
              null,
              t('Bedrooms')
            ),
            _react2.default.createElement('br', null)
          ) : null;
        }) : _react2.default.createElement(
          'p',
          { className: 'noSpecAvailable' },
          t('No {{title}} available', { title: t('Bedrooms').toLowerCase() })
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        selectLayout2 && selectLayout2.specifications && checkLayout2Bed ? selectLayout2.specifications.map(function (spec, idx) {
          return spec.name.toLowerCase() === 'bedrooms' ? _react2.default.createElement(
            'div',
            { className: 'specColumns', key: idx },
            _react2.default.createElement(
              'h1',
              null,
              isNaN(spec.value) ? '' : _react2.default.createElement(
                'small',
                null,
                'x'
              ),
              spec.value || '0'
            ),
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'bed' }),
            _react2.default.createElement(
              'p',
              null,
              t('Bedrooms')
            ),
            _react2.default.createElement('br', null)
          ) : null;
        }) : _react2.default.createElement(
          'p',
          { className: 'noSpecAvailable' },
          t('No {{title}} available', { title: t('Bedrooms').toLowerCase() })
        )
      ),
      unitLayouts.length >= 3 && !isMobile ? _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { only: 'computer' },
        selectLayout3 && selectLayout3.specifications && checkLayout3Bed ? selectLayout3.specifications.map(function (spec, idx) {
          return spec.name.toLowerCase() === 'bedrooms' ? _react2.default.createElement(
            'div',
            { className: 'specColumns', key: idx },
            _react2.default.createElement(
              'h1',
              null,
              isNaN(spec.value) ? '' : _react2.default.createElement(
                'small',
                null,
                'x'
              ),
              spec.value || '0'
            ),
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'bed' }),
            _react2.default.createElement(
              'p',
              null,
              t('Bedrooms')
            ),
            _react2.default.createElement('br', null)
          ) : null;
        }) : _react2.default.createElement(
          'p',
          { className: 'noSpecAvailable' },
          t('No {{title}} available', { title: t('Bedrooms').toLowerCase() })
        )
      ) : null,
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        selectLayout1 && selectLayout1.specifications && checkLayout1Bath ? selectLayout1.specifications.map(function (spec, idx) {
          return spec.name.toLowerCase() === 'bathrooms' ? _react2.default.createElement(
            'div',
            { className: 'specColumns', key: idx },
            _react2.default.createElement(
              'h1',
              null,
              isNaN(spec.value) ? '' : _react2.default.createElement(
                'small',
                null,
                'x'
              ),
              spec.value || '0'
            ),
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'bath' }),
            _react2.default.createElement(
              'p',
              null,
              t('Bathrooms')
            ),
            _react2.default.createElement('br', null)
          ) : null;
        }) : _react2.default.createElement(
          'p',
          { className: 'noSpecAvailable' },
          t('No {{title}} available', { title: t('Bathrooms').toLowerCase() })
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        selectLayout2 && selectLayout2.specifications && checkLayout2Bath ? selectLayout2.specifications.map(function (spec, idx) {
          return spec.name.toLowerCase() === 'bathrooms' ? _react2.default.createElement(
            'div',
            { className: 'specColumns', key: idx },
            _react2.default.createElement(
              'h1',
              null,
              isNaN(spec.value) ? '' : _react2.default.createElement(
                'small',
                null,
                'x'
              ),
              spec.value || '0'
            ),
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'bath' }),
            _react2.default.createElement(
              'p',
              null,
              t('Bathrooms')
            ),
            _react2.default.createElement('br', null)
          ) : null;
        }) : _react2.default.createElement(
          'p',
          { className: 'noSpecAvailable' },
          t('No {{title}} available', { title: t('Bathrooms').toLowerCase() })
        )
      ),
      unitLayouts.length >= 3 && !isMobile ? _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { only: 'computer' },
        selectLayout3 && selectLayout3.specifications && checkLayout3Bath ? selectLayout3.specifications.map(function (spec, idx) {
          return spec.name.toLowerCase() === 'bathrooms' ? _react2.default.createElement(
            'div',
            { className: 'specColumns', key: idx },
            _react2.default.createElement(
              'h1',
              null,
              isNaN(spec.value) ? '' : _react2.default.createElement(
                'small',
                null,
                'x'
              ),
              spec.value || '0'
            ),
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'bath' }),
            _react2.default.createElement(
              'p',
              null,
              t('Bathrooms')
            ),
            _react2.default.createElement('br', null)
          ) : null;
        }) : _react2.default.createElement(
          'p',
          { className: 'noSpecAvailable' },
          t('No {{title}} available', { title: t('Bathrooms').toLowerCase() })
        )
      ) : null,
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        selectLayout1 && selectLayout1.specifications && checkLayout1Car ? selectLayout1.specifications.map(function (spec, idx) {
          return spec.name.toLowerCase() === 'parking lots' ? _react2.default.createElement(
            'div',
            { className: 'specColumns', key: idx },
            _react2.default.createElement(
              'h1',
              null,
              isNaN(spec.value) ? '' : _react2.default.createElement(
                'small',
                null,
                'x'
              ),
              spec.value || '0'
            ),
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'car' }),
            _react2.default.createElement(
              'p',
              null,
              t('Parking Lots')
            ),
            _react2.default.createElement('br', null)
          ) : null;
        }) : _react2.default.createElement(
          'p',
          { className: 'noSpecAvailable' },
          t('No {{title}} available', { title: t('Parking Lots').toLowerCase() })
        )
      ),
      _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        null,
        selectLayout2 && selectLayout2.specifications && checkLayout2Car ? selectLayout2.specifications.map(function (spec, idx) {
          return spec.name.toLowerCase() === 'parking lots' ? _react2.default.createElement(
            'div',
            { className: 'specColumns', key: idx },
            _react2.default.createElement(
              'h1',
              null,
              isNaN(spec.value) ? '' : _react2.default.createElement(
                'small',
                null,
                'x'
              ),
              spec.value || '0'
            ),
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'car' }),
            _react2.default.createElement(
              'p',
              null,
              t('Parking Lots')
            ),
            _react2.default.createElement('br', null)
          ) : null;
        }) : _react2.default.createElement(
          'p',
          { className: 'noSpecAvailable' },
          t('No {{title}} available', { title: t('Parking Lots').toLowerCase() })
        )
      ),
      unitLayouts.length >= 3 && !isMobile ? _react2.default.createElement(
        _semanticUiReact.Grid.Column,
        { only: 'computer' },
        selectLayout3 && selectLayout3.specifications && checkLayout3Car ? selectLayout3.specifications.map(function (spec, idx) {
          return spec.name.toLowerCase() === 'parking lots' ? _react2.default.createElement(
            'div',
            { className: 'specColumns', key: idx },
            _react2.default.createElement(
              'h1',
              null,
              isNaN(spec.value) ? '' : _react2.default.createElement(
                'small',
                null,
                'x'
              ),
              spec.value || '0'
            ),
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'car' }),
            _react2.default.createElement(
              'p',
              null,
              t('Parking Lots')
            ),
            _react2.default.createElement('br', null)
          ) : null;
        }) : _react2.default.createElement(
          'p',
          { className: 'noSpecAvailable' },
          t('No {{title}} available', { title: t('Parking Lots').toLowerCase() })
        )
      ) : null
    );
  };

  this.renderContent = function () {
    var _state5 = _this3.state,
        data = _state5.data,
        selectedLayout = _state5.selectedLayout,
        isMobile = _state5.isMobile,
        isMediumScreen = _state5.isMediumScreen;
    var t = _this3.props.t;

    var countryCode = _this3.props.auth && _this3.props.auth.company && _this3.props.auth.company.countryCode;
    // CPI-1208 post-fix: a Vietnamese layout is compared on NSA and NFA; the old Size / Land Area
    // pair is not shown at all. The first divider already reads "NSA - Net Saleable Area" for
    // Vietnam (getAreaModelLabel), so only the second label and the six values move.
    var isVietnam = (0, _countries.isCountryVietnam)(countryCode);
    var landAreaModelLabel = isVietnam ? (0, _translation.translateModels)(t, 'nfa', 'projectUnitLayout') : (0, _translation.translateModels)(t, 'landArea', 'projectUnitLayout');
    var landAreaEmptyTitle = isVietnam ? (0, _translation.translateModels)(t, 'nfa', 'projectUnitLayout') : t('unit land area');
    var unitLayouts = data.unitLayouts;
    Object.keys(selectedLayout).forEach(function (key) {
      unitLayouts.filter(function (unit) {
        if (unit.id === selectedLayout[key]) {
          selectedLayout[key] = unit;
          return unit;
        }
        return null;
      });
    });
    var selectLayout1 = selectedLayout.selectLayout1,
        selectLayout2 = selectedLayout.selectLayout2,
        selectLayout3 = selectedLayout.selectLayout3;

    if (unitLayouts && selectedLayout) {
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { centered: true, columns: 2, className: 'compare_content' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          {
            centered: true,
            columns: isMobile ? 2 : unitLayouts.length >= 3 ? isMediumScreen ? 2 : 3 : 2
          },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            selectLayout1 ? _react2.default.createElement(_LoadImage2.default, {
              fluid: true,
              cover: 'vertical long',
              centered: true,
              loading: _this3.state.loading,
              notFoundNode: _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  t('No cover picture found'),
                  '.'
                ),
                _react2.default.createElement(_semanticUiReact.Button, {
                  as: _reactRouter.Link,
                  primary: true, compact: true,
                  disabled: _this3.state.loading,
                  to: '/projects/' + _this3.props.id + '/layouts/' + selectLayout1.id + '/pictures/',
                  content: t('Click here to add')
                })
              ),
              picture: selectLayout1.pictures ? selectLayout1.pictures.find(function (pic) {
                if (pic.type === 'unit_layout') {
                  return pic.key;
                }
                return null;
              }) : null,
              pictureSize: 100
            }) : null
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            selectLayout2 ? _react2.default.createElement(_LoadImage2.default, {
              fluid: true,
              cover: 'vertical long',
              centered: true,
              loading: _this3.state.loading,
              notFoundNode: _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  t('No cover picture found'),
                  '.'
                ),
                _react2.default.createElement(_semanticUiReact.Button, {
                  as: _reactRouter.Link,
                  primary: true, compact: true,
                  disabled: _this3.state.loading,
                  to: '/projects/' + _this3.props.id + '/layouts/' + selectLayout2.id + '/pictures/',
                  content: t('Click here to add')
                })
              ),
              picture: selectLayout2.pictures ? selectLayout2.pictures.find(function (pic) {
                if (pic.type === 'unit_layout') {
                  return pic.key;
                }
                return null;
              }) : null,
              pictureSize: 100
            }) : null
          ),
          unitLayouts.length >= 3 && !isMobile ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { only: 'computer' },
            selectLayout3 ? _react2.default.createElement(_LoadImage2.default, {
              fluid: true,
              centered: true,
              cover: 'vertical long',
              loading: _this3.state.loading,
              notFoundNode: _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  t('No cover picture found'),
                  '.'
                ),
                _react2.default.createElement(_semanticUiReact.Button, {
                  as: _reactRouter.Link,
                  primary: true, compact: true,
                  disabled: _this3.state.loading,
                  to: '/projects/' + _this3.props.id + '/layouts/' + selectLayout3.id + '/pictures/',
                  content: t('Click here to add')
                })
              ),
              picture: selectLayout3.pictures ? selectLayout3.pictures.find(function (pic) {
                if (pic.type === 'unit_layout') {
                  return pic.key;
                }
                return null;
              }) : null,
              pictureSize: 100
            }) : null
          ) : null
        ),
        _this3.renderPriceRow(),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          {
            centered: true,
            columns: isMobile ? 2 : unitLayouts.length >= 3 ? isMediumScreen ? 2 : 3 : 2,
            className: 'sizeRow'
          },
          _react2.default.createElement(
            _semanticUiReact.Divider,
            { horizontal: true },
            (0, _areaLabel.getAreaModelLabel)(t, countryCode)
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            selectLayout1 && (0, _unitLayout.layoutAreaValue)(isVietnam, selectLayout1) ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h1',
                null,
                (0, _unitLayout.layoutAreaValue)(isVietnam, selectLayout1) || 0
              ),
              data.sizeSuffix === 'square_feet' ? _react2.default.createElement(
                'small',
                null,
                t('sqft', { ns: _translation2.TRANSLATION_FILES.screens })
              ) : data.sizeSuffix === 'square_metres' ? _react2.default.createElement(
                'small',
                null,
                isVietnam ? 'm²' : t('sqm', { ns: _translation2.TRANSLATION_FILES.screens })
              ) : ''
            ) : _react2.default.createElement(
              'p',
              { className: 'noValue' },
              t('No {{title}} available', { title: (0, _areaLabel.getAreaLabel)(t, countryCode, { lower: true }) })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            selectLayout2 && (0, _unitLayout.layoutAreaValue)(isVietnam, selectLayout2) ? _react2.default.createElement(
              'div',
              { className: 'sizeRow' },
              _react2.default.createElement(
                'h1',
                null,
                (0, _unitLayout.layoutAreaValue)(isVietnam, selectLayout2) || 0
              ),
              data.sizeSuffix === 'square_feet' ? _react2.default.createElement(
                'small',
                null,
                t('sqft', { ns: _translation2.TRANSLATION_FILES.screens })
              ) : data.sizeSuffix === 'square_metres' ? _react2.default.createElement(
                'small',
                null,
                isVietnam ? 'm²' : t('sqm', { ns: _translation2.TRANSLATION_FILES.screens })
              ) : ''
            ) : _react2.default.createElement(
              'p',
              { className: 'noValue' },
              t('No {{title}} available', { title: (0, _areaLabel.getAreaLabel)(t, countryCode, { lower: true }) })
            )
          ),
          unitLayouts.length >= 3 && !isMobile ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { only: 'computer' },
            selectLayout3 && (0, _unitLayout.layoutAreaValue)(isVietnam, selectLayout3) ? _react2.default.createElement(
              'div',
              { className: 'sizeRow' },
              _react2.default.createElement(
                'h1',
                null,
                (0, _unitLayout.layoutAreaValue)(isVietnam, selectLayout3) || 0
              ),
              data.sizeSuffix === 'square_feet' ? _react2.default.createElement(
                'small',
                null,
                t('sqft', { ns: _translation2.TRANSLATION_FILES.screens })
              ) : data.sizeSuffix === 'square_metres' ? _react2.default.createElement(
                'small',
                null,
                isVietnam ? 'm²' : t('sqm', { ns: _translation2.TRANSLATION_FILES.screens })
              ) : ''
            ) : _react2.default.createElement(
              'p',
              { className: 'noValue' },
              t('No {{title}} available', { title: (0, _areaLabel.getAreaLabel)(t, countryCode, { lower: true }) })
            )
          ) : null
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          {
            centered: true,
            columns: isMobile ? 2 : unitLayouts.length >= 3 ? isMediumScreen ? 2 : 3 : 2,
            className: 'sizeRow'
          },
          _react2.default.createElement(
            _semanticUiReact.Divider,
            { horizontal: true },
            landAreaModelLabel
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            selectLayout1 && (0, _unitLayout.layoutLandAreaValue)(isVietnam, selectLayout1) ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h1',
                null,
                (0, _unitLayout.layoutLandAreaValue)(isVietnam, selectLayout1) || 0
              ),
              data.sizeSuffix === 'square_feet' ? _react2.default.createElement(
                'small',
                null,
                t('sqft', { ns: _translation2.TRANSLATION_FILES.screens })
              ) : data.sizeSuffix === 'square_metres' ? _react2.default.createElement(
                'small',
                null,
                isVietnam ? 'm²' : t('sqm', { ns: _translation2.TRANSLATION_FILES.screens })
              ) : ''
            ) : _react2.default.createElement(
              'p',
              { className: 'noValue' },
              t('No {{title}} available', { title: landAreaEmptyTitle })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            selectLayout2 && (0, _unitLayout.layoutLandAreaValue)(isVietnam, selectLayout2) ? _react2.default.createElement(
              'div',
              { className: 'sizeRow' },
              _react2.default.createElement(
                'h1',
                null,
                (0, _unitLayout.layoutLandAreaValue)(isVietnam, selectLayout2) || 0
              ),
              data.sizeSuffix === 'square_feet' ? _react2.default.createElement(
                'small',
                null,
                t('sqft', { ns: _translation2.TRANSLATION_FILES.screens })
              ) : data.sizeSuffix === 'square_metres' ? _react2.default.createElement(
                'small',
                null,
                isVietnam ? 'm²' : t('sqm', { ns: _translation2.TRANSLATION_FILES.screens })
              ) : ''
            ) : _react2.default.createElement(
              'p',
              { className: 'noValue' },
              t('No {{title}} available', { title: landAreaEmptyTitle })
            )
          ),
          unitLayouts.length >= 3 && !isMobile ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { only: 'computer' },
            selectLayout3 && (0, _unitLayout.layoutLandAreaValue)(isVietnam, selectLayout3) ? _react2.default.createElement(
              'div',
              { className: 'sizeRow' },
              _react2.default.createElement(
                'h1',
                null,
                (0, _unitLayout.layoutLandAreaValue)(isVietnam, selectLayout3) || 0
              ),
              data.sizeSuffix === 'square_feet' ? _react2.default.createElement(
                'small',
                null,
                t('sqft', { ns: _translation2.TRANSLATION_FILES.screens })
              ) : data.sizeSuffix === 'square_metres' ? _react2.default.createElement(
                'small',
                null,
                isVietnam ? 'm²' : t('sqm', { ns: _translation2.TRANSLATION_FILES.screens })
              ) : ''
            ) : _react2.default.createElement(
              'p',
              { className: 'noValue' },
              t('No {{title}} available', { title: landAreaEmptyTitle })
            )
          ) : null
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          {
            centered: true,
            columns: isMobile ? 2 : unitLayouts.length >= 3 ? isMediumScreen ? 2 : 3 : 2
          },
          _react2.default.createElement(
            _semanticUiReact.Divider,
            { horizontal: true },
            t('Units')
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            selectLayout1 && selectLayout1.summary ? selectLayout1.summary.newUnits || selectLayout1.summary.totalUnits ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h1',
                null,
                selectLayout1.summary.newUnits || '0'
              ),
              _react2.default.createElement(
                'small',
                null,
                t('Available', { ns: _translation2.TRANSLATION_FILES.constants })
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'h1',
                { className: 'row-margin' },
                selectLayout1.summary.totalUnits || '0'
              ),
              _react2.default.createElement(
                'small',
                null,
                t('Total')
              )
            ) : _react2.default.createElement(
              'p',
              { className: 'mulitNoValue' },
              t('No {{title}} available', { title: t('Unit').toLowerCase() })
            ) : _react2.default.createElement(
              'p',
              { className: 'mulitNoValue' },
              t('No {{title}} available', { title: t('Unit').toLowerCase() })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            selectLayout2 && selectLayout2.summary ? selectLayout2.summary.newUnits || selectLayout2.summary.totalUnits ? _react2.default.createElement(
              'div',
              { className: 'sizeRow' },
              _react2.default.createElement(
                'h1',
                null,
                selectLayout2.summary.newUnits || '0'
              ),
              _react2.default.createElement(
                'small',
                null,
                t('Available', { ns: _translation2.TRANSLATION_FILES.constants })
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'h1',
                { className: 'row-margin' },
                selectLayout2.summary.totalUnits || '0'
              ),
              _react2.default.createElement(
                'small',
                null,
                t('Total')
              )
            ) : _react2.default.createElement(
              'p',
              { className: 'mulitNoValue' },
              t('No {{title}} available', { title: t('Unit').toLowerCase() })
            ) : _react2.default.createElement(
              'p',
              { className: 'mulitNoValue' },
              t('No {{title}} available', { title: t('Unit').toLowerCase() })
            )
          ),
          unitLayouts.length >= 3 && selectLayout3 && selectLayout3.summary && !isMobile ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { only: 'computer' },
            selectLayout3.summary.newUnits || selectLayout3.summary.totalUnits ? _react2.default.createElement(
              'div',
              { className: 'sizeRow' },
              _react2.default.createElement(
                'h1',
                null,
                selectLayout3.summary.newUnits || '0'
              ),
              _react2.default.createElement(
                'small',
                null,
                t('Available', { ns: _translation2.TRANSLATION_FILES.constants })
              ),
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                'h1',
                { className: 'row-margin' },
                selectLayout3.summary.totalUnits || '0'
              ),
              _react2.default.createElement(
                'small',
                null,
                t('Total')
              )
            ) : _react2.default.createElement(
              'p',
              { className: 'mulitNoValue' },
              t('No {{title}} available', { title: t('Unit').toLowerCase() })
            )
          ) : null
        ),
        _this3.renderSpecRow()
      );
    }
    return null;
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation2.namespaces), [_translation2.TRANSLATION_FILES.models.projectUnitLayout]))((0, _reactRedux.connect)(CompareLayouts.mapStateToProps)(CompareLayouts));

/***/ }),
/* 2420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRouter = __webpack_require__(18);

var _reactRouterRedux = __webpack_require__(13);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _UnitLayoutItem = __webpack_require__(1034);

var _UnitLayoutItem2 = _interopRequireDefault(_UnitLayoutItem);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _translation = __webpack_require__(4);

var _navigations = __webpack_require__(117);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _initialiseProps.call(_this);

    var state = List.getPropsToState(props);
    _this.state = _extends({}, state);
    return _this;
  }

  _createClass(List, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = (0, _url.decodeSearch)(this.props.location.search);
      if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
        query.page = 1;
      }
      if (query.tab) {
        delete query.tab;
      }
      this.replaceQuery(query);
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var _props = this.props,
          auth = _props.auth,
          data = _props.data;

      if (auth.isHeadquarters || auth.isSuperAdmin) {
        return true;
      }
      if (auth.isBranchLeaderSupervisorII && data && data.maOwnerCompanyBranchID === auth.companyBranch.id) {
        return true;
      }
      return check;
    }
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var store = this.context.store;

      store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.id + '/layouts/?' + (0, _url.encodeSearch)(query)));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props2 = this.props,
          auth = _props2.auth,
          id = _props2.id,
          location = _props2.location,
          t = _props2.t;
      var pathname = location.pathname;
      var store = this.context.store;

      var companyServiceID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
      var isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
      var links = (0, _navigations.editRoutes)(id, this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled, isMalaysia, companyServiceID).map(function (l) {
        return _extends({}, l, {
          text: t(l.text, { ns: l.text === 'Edit' ? _translation.TRANSLATION_FILES.translation : _translation.TRANSLATION_FILES.screens })
        });
      });
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: link.text,
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this2.handleMenu(e, link);
              }
            });
          }),
          rightNav: this.hasAccess() && _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              as: _reactRouter.Link,
              primary: true,
              content: t('New', { ns: _translation.TRANSLATION_FILES.constants }),
              disabled: this.state.loading,
              to: '/projects/' + id + '/layouts/new/'
            })
          )
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', columns: 'equal', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_PageNav2.default, {
                floated: 'right',
                currentPage: this.state.currentPage,
                count: this.state.count,
                limit: this.state.limit,
                offset: this.state.offset,
                dataSize: this.state.datas.length,
                loading: this.state.loading,
                onChange: this.handleChangePage
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                {
                  inverted: true, style: { zIndex: 20 },
                  active: this.state.loading && this.state.datas.length > 0
                },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Segment.Group,
                null,
                this.state.datas.length > 0 ? this.state.datas.map(function (unitLayout, key) {
                  return _react2.default.createElement(_UnitLayoutItem2.default, _extends({
                    key: key,
                    isMobile: _this2.state.unitLayoutResize,
                    loading: _this2.state.loading,
                    buttonNode: function buttonNode(_ref) {
                      var loading = _ref.loading;
                      return _react2.default.createElement(
                        _semanticUiReact.Button.Group,
                        { fluid: true, floated: 'right', widths: 2, basic: true, primary: true },
                        _react2.default.createElement(_semanticUiReact.Button, {
                          as: _reactRouter.Link,
                          content: t('View', { ns: _translation.TRANSLATION_FILES.translation }),
                          disabled: loading,
                          to: '/projects/' + id + '/layouts/' + unitLayout.id + '/'
                        }),
                        _react2.default.createElement(_semanticUiReact.Button, {
                          content: t('Edit', { ns: _translation.TRANSLATION_FILES.translation }),
                          disabled: loading,
                          onClick: function onClick() {
                            return store.dispatch((0, _reactRouterRedux.push)('/projects/' + id + '/layouts/' + unitLayout.id + '/edit/'));
                          }
                        })
                      );
                    }
                  }, unitLayout));
                }) : _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { textAlign: 'center' },
                  this.state.loading ? _react2.default.createElement(
                    _semanticUiReact.Loader,
                    { active: true, inline: 'centered' },
                    t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                  ) : _react2.default.createElement(
                    'p',
                    null,
                    t('No unit layouts found'),
                    '.'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { only: 'tablet mobile' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              _react2.default.createElement(_PageNav2.default, {
                currentPage: this.state.currentPage,
                count: this.state.count,
                limit: this.state.limit,
                offset: this.state.offset,
                dataSize: this.state.datas.length,
                loading: this.state.loading,
                onChange: this.handleChangePage
              })
            )
          )
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};
List.propTypes = {
  id: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    company: _propTypes2.default.object
  }),
  data: _propTypes2.default.shape({
    maOwnerCompanyBranchID: _propTypes2.default.number
  }),
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      lawyerIsEnabled: _propTypes2.default.bool
    })
  })
};

List.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  var count = props.count;
  var limit = props.limit;
  var offset = props.offset;
  var datas = props.datas || [];
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var menuIsTab = window.innerWidth <= 590;
  var unitLayoutResize = window.innerWidth < 768;
  return {
    datas: datas,
    loading: loading,
    count: count,
    limit: limit,
    offset: offset,
    currentPage: currentPage,
    menuIsTab: menuIsTab,
    unitLayoutResize: unitLayoutResize
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleResize = function () {
    var state = {};
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this3.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    var unitLayoutResize = window.innerWidth < 768;
    if (unitLayoutResize !== _this3.state.unitLayoutResize) {
      state.unitLayoutResize = unitLayoutResize;
    }
    _this3.setState(_extends({}, state));
  };

  this.handleChangePage = function (page) {
    var query = (0, _url.decodeSearch)(_this3.props.location.search);
    if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
      query.page = 1;
    }
    var currentPage = parseInt(page || query.page, 10);
    query.page = currentPage;
    _this3.setState({ currentPage: currentPage });
    _this3.replaceQuery(query);
  };

  this.handleMenu = function (e, _ref2) {
    var value = _ref2.value;
    var store = _this3.context.store;

    if (value.includes(_config2.default.get('developerURL'))) {
      e.preventDefault();
      window.location.href = value;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(value));
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(List.mapStateToProps)(List));

/***/ }),
/* 2421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1061);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/no-unused-prop-types */


var New = function (_Component) {
  _inherits(New, _Component);

  function New(props) {
    _classCallCheck(this, New);

    var _this = _possibleConstructorReturn(this, (New.__proto__ || Object.getPrototypeOf(New)).call(this, props));

    _this.getFormInstance = function () {
      var form = _this.form;
      while (form && form.getWrappedInstance) {
        form = form.getWrappedInstance();
      }
      return form;
    };

    _this.handleSubmit = function (event) {
      _this.getFormInstance().handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments[1];

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges, callback);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(New, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, unitLayout) {
        var _this2 = this;

        var store, t, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.getFormInstance().submit('/projects/' + this.props.id + '/unit_layouts/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(unitLayout)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false, function (noChanges) {
                    if (noChanges) {
                      store.dispatch((0, _reactRouterRedux.goBack)());
                      store.dispatch((0, _flash.flashSuccessMessage)({
                        header: t('Create Success', { ns: _translation.TRANSLATION_FILES.translation }),
                        message: t('{{name}} successfully created', { name: res.name, ns: _translation.TRANSLATION_FILES.translation })
                      }));
                    }
                  });
                });

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('New layout'),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Create', { ns: _translation.TRANSLATION_FILES.translation }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, unitLayout) {
            _this3.submit(validations, unitLayout);
          },
          onChange: this.handleOnChange,
          projectID: this.props.id,
          location: this.props.location,
          loading: this.props.loading
        })
      );
    }
  }]);

  return New;
}(_react.Component);

New.propTypes = {
  token: _propTypes2.default.string,
  id: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    hash: _propTypes2.default.string
  }),
  loading: _propTypes2.default.bool,
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
New.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(New);

/***/ }),
/* 2422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _checkChanges = __webpack_require__(61);

var _promptMessages = __webpack_require__(43);

var _List = __webpack_require__(2420);

var _List2 = _interopRequireDefault(_List);

var _New = __webpack_require__(2421);

var _New2 = _interopRequireDefault(_New);

var _Compare = __webpack_require__(2419);

var _Compare2 = _interopRequireDefault(_Compare);

__webpack_require__(3501);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitLayouts = function (_Component) {
  _inherits(UnitLayouts, _Component);

  function UnitLayouts(props) {
    _classCallCheck(this, UnitLayouts);

    var _this = _possibleConstructorReturn(this, (UnitLayouts.__proto__ || Object.getPrototypeOf(UnitLayouts)).call(this, props));

    _this.state = {
      token: null,
      count: 0,
      limit: 0,
      offset: 0,
      loading: true,
      datas: []
    };
    return _this;
  }

  _createClass(UnitLayouts, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = this.props.location.query;

      this.fetchProjectUnitLayouts(query);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _nextProps$location = nextProps.location,
          pathname = _nextProps$location.pathname,
          query = _nextProps$location.query;

      if (!pathname.includes('/new/')) {
        if (!this.state.loading) {
          this.fetchProjectUnitLayouts(query);
        }
      }
    }
  }, {
    key: 'setUnitLayouts',
    value: function setUnitLayouts() {
      var _this2 = this;

      var datas = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this2.setState({
          datas: datas || []
        }, function () {
          res(datas);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchProjectUnitLayouts',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var store, query, res, message, token, count, limit, offset, datas;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                if (query.tab) {
                  delete query.tab;
                }
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.params.id + '/unit_layouts/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 10:
                res = _context.sent;
                _context.next = 21;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                Bugsnag.notifyException(_context.t0);
                _context.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 18:
                _context.next = 20;
                return this.setLoading(false);

              case 20:
                return _context.abrupt('return');

              case 21:
                if (res.ok) {
                  _context.next = 29;
                  break;
                }

                _context.next = 24;
                return res.text();

              case 24:
                message = _context.sent;
                _context.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 27:
                _context.next = 41;
                break;

              case 29:
                token = res.headers.get('X-Csrf-Token');
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
                _context.next = 35;
                return res.json();

              case 35:
                datas = _context.sent;

                if (!datas && query.page > 1) {
                  query.page = 1;
                  store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.params.id + '/layouts/?' + _qs2.default.stringify(query)));
                }
                _context.next = 39;
                return this.setUnitLayouts(datas);

              case 39:
                _context.next = 41;
                return this.setComponentState({
                  token: token,
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 41:
                _context.next = 43;
                return this.setLoading(false);

              case 43:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function fetchProjectUnitLayouts(_x4) {
        return _ref.apply(this, arguments);
      }

      return fetchProjectUnitLayouts;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this5 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this5.state.token,
          count: _this5.state.count,
          limit: _this5.state.limit,
          offset: _this5.state.offset,
          loading: _this5.state.loading,
          datas: _this5.state.datas,
          id: _this5.props.params.id,
          data: _this5.props.data
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return UnitLayouts;
}(_react.Component);

UnitLayouts.propTypes = {
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object
  }),
  data: _propTypes2.default.shape({
    maOwnerCompanyBranchID: _propTypes2.default.number
  })
};
UnitLayouts.contextTypes = {
  store: _propTypes2.default.object
};
UnitLayouts.List = _List2.default;
UnitLayouts.New = (0, _checkChanges.checkChanges)(_New2.default, { message: _promptMessages.NEW_PROJECT_UNIT_LAYOUT_PROMPT });
UnitLayouts.Compare = _Compare2.default;
exports.default = UnitLayouts;

/***/ }),
/* 2423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _UnitLayouts = __webpack_require__(2422);

var _UnitLayouts2 = _interopRequireDefault(_UnitLayouts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _UnitLayouts2.default;

/***/ }),
/* 2424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _reactRouter = __webpack_require__(18);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_momentTimezone2.default.locale('en-gb');

var ComponentList = function (_Component) {
  _inherits(ComponentList, _Component);

  function ComponentList(props) {
    _classCallCheck(this, ComponentList);

    var _this = _possibleConstructorReturn(this, (ComponentList.__proto__ || Object.getPrototypeOf(ComponentList)).call(this, props));

    _initialiseProps.call(_this);

    var query = (0, _url.decodeSearch)(props.location.search);
    var search = query.search || '';
    var state = ComponentList.getPropsToState(props);
    var limit = 20;
    var currentPage = parseInt(query.page, 10) || 1;
    var offset = (currentPage - 1) * limit;
    _this.state = _extends({
      data: [],
      count: 0,
      loading: true,
      offset: offset,
      search: search,
      limit: limit,
      currentPage: currentPage
    }, state);
    return _this;
  }

  _createClass(ComponentList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = this.props.location.query;

      if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
        query.page = 1;
      }
      this.replaceQuery(query);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = ComponentList.getPropsToState(nextProps);
      var query = (0, _url.decodeSearch)(nextProps.location.search);
      this.getDataByPage(query.page || 1);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var store = this.context.store;
      var himsSettingID = this.state.himsSettingID;

      this.getDataByPage(query.page);
      store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.id + '/units/hims/' + (himsSettingID ? himsSettingID + '/' : '') + '?' + (0, _url.encodeSearch)(query)));
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this2 = this;

      var data = this.state.data;
      var loading = this.props.loading;

      return !loading && data.length > 0 ? data.map(function (value, index) {
        return _react2.default.createElement(
          _semanticUiReact.Table.Row,
          { key: index },
          _this2.renderMobileCell(value),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'mobile-hide' },
            _react2.default.createElement(_semanticUiReact.Popup, {
              trigger: _react2.default.createElement(
                _reactRouter.Link,
                { to: '/projects/' + _this2.props.id + '/units/hims/' + _this2.state.himsSettingID + '/components/' + value.pembangunan_id + '/' },
                value.pembangunan_id
              ),
              content: 'Click to see units',
              size: 'mini',
              position: 'right center'
            })
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'mobile-hide' },
            value.jenis_rumah
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'mobile-hide' },
            value.bil_tingkat
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'mobile-hide' },
            value.bil_unit
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'mobile-hide' },
            value.harga_minimum.toFixed(2)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'mobile-hide' },
            value.harga_maksimum.toFixed(2)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'mobile-hide' },
            value.luas_tanah.toFixed(2)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'mobile-hide' },
            value.luas_binaan.toFixed(2)
          )
        );
      }) : _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { colSpan: '100%', textAlign: 'center' },
          loading ? _react2.default.createElement(
            _semanticUiReact.Loader,
            { active: true, inline: 'centered' },
            'Loading'
          ) : _react2.default.createElement(
            'p',
            null,
            'No components found.'
          )
        )
      );
    }
  }, {
    key: 'renderTable',
    value: function renderTable() {
      var _props = this.props,
          loading = _props.loading,
          id = _props.id,
          isMobile = _props.isMobile,
          isTablet = _props.isTablet,
          himsSettings = _props.himsSettings;
      var himsSettingID = this.state.himsSettingID;

      var exportItems = [{
        text: 'Excel',
        icon: 'download',
        href: _config2.default.get('bookApiURL') + '/projects/' + id + '/hims/' + this.state.himsSettingID + '/components/export/'
      }];
      return _react2.default.createElement(
        _semanticUiReact.Table,
        {
          celled: true,
          unstackable: true,
          structured: true
        },
        _react2.default.createElement(
          _semanticUiReact.Table.Header,
          { fullWidth: true },
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { colSpan: '100%' },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 1, verticalAlign: 'middle' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_SearchFilter2.default, {
                    inTable: true,
                    searchWidth: isMobile ? 16 : isTablet ? 8 : 7,
                    leftNavWidth: isMobile || isTablet ? 16 : 4,
                    rightNavWidth: isMobile ? 16 : isTablet ? 8 : 5,
                    isLoading: loading,
                    onChange: this.handleFilterOnChange,
                    onClose: this.handleClearFilter,
                    search: this.state.search,
                    advanceFilter: this.state.advanceFilter,
                    leftNav: _react2.default.createElement(
                      _semanticUiReact.Header,
                      { style: { marginLeft: '0.5em', marginTop: '0.25em', marginBottom: '0.5em' } },
                      'List of Components'
                    ),
                    rightNav: _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(_semanticUiReact.Select, {
                        disabled: himsSettings.length === 0 || loading,
                        loading: loading,
                        onChange: this.handleOnHimsSettingChange,
                        value: himsSettingID,
                        placeholder: 'Select Project Code',
                        options: himsSettings.map(function (hs) {
                          return {
                            value: hs.id,
                            text: 'Project Code (' + hs.himsDevelopmentCode + ')'
                          };
                        })
                      }),
                      _react2.default.createElement(_SortButton2.default, {
                        loading: loading,
                        icon: 'download',
                        items: exportItems
                      })
                    )
                  })
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { className: 'mobile-hide' },
              'Pembangunan ID'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { className: 'mobile-hide' },
              'Jenis Rumah'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { className: 'mobile-hide' },
              'Bil Tingkat'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { className: 'mobile-hide' },
              'Bil Unit'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { className: 'mobile-hide' },
              'Harga Minimum'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { className: 'mobile-hide' },
              'Harga Maksimum'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { className: 'mobile-hide' },
              'Luas Tanah'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { className: 'mobile-hide' },
              'Luas Binaan'
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Body,
          null,
          this.renderBody()
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          count = _state.count,
          limit = _state.limit,
          offset = _state.offset,
          currentPage = _state.currentPage;
      var loading = this.props.loading;

      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 16, textAlign: 'center' },
          this.renderTable(),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { style: { marginTop: '3em' }, textAlign: 'center' },
            _react2.default.createElement(_PageNav2.default, {
              currentPage: currentPage,
              count: count,
              limit: limit,
              offset: offset,
              dataSize: this.state.data.length,
              loading: loading,
              onChange: this.handleChangePage
            })
          )
        )
      );
    }
  }]);

  return ComponentList;
}(_react.Component);

ComponentList.propTypes = {
  params: _propTypes2.default.shape({
    himsSettingID: _propTypes2.default.string
  }),
  id: _propTypes2.default.string,
  project: _propTypes2.default.object,
  himsSettings: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string,
    himsDevelopmentCode: _propTypes2.default.string
  })),
  data: _propTypes2.default.arrayOf(_propTypes2.default.object),
  loading: _propTypes2.default.bool,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    search: _propTypes2.default.string,
    query: _propTypes2.default.object
  }),
  isMobile: _propTypes2.default.bool,
  isTablet: _propTypes2.default.bool
};
ComponentList.contextTypes = {
  store: _propTypes2.default.object
};

ComponentList.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var count = props.data.length || 0;
  var currentPage = parseInt(query.page, 10) || 1;
  var data = props.data || [];
  var loading = props.loading;
  var himsSettingID = props.params.himsSettingID || '';
  return {
    count: count,
    currentPage: currentPage,
    loading: loading,
    himsSettingID: himsSettingID,
    oriData: (0, _clone2.default)(data)
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getDataByPage = function (page) {
    var _state2 = _this3.state,
        oriData = _state2.oriData,
        limit = _state2.limit,
        search = _state2.search;

    var data = oriData || [];
    if (search) {
      data = data.filter(function (d) {
        return d.pembangunan_id.includes(search);
      });
    }
    data = data.slice((page - 1) * limit, page * limit);
    _this3.setState({ data: data });
  };

  this.handleChangePage = function (page) {
    var limit = _this3.state.limit;

    var query = (0, _url.decodeSearch)(_this3.props.location.search);
    if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
      query.page = 1;
    }
    var currentPage = parseInt(page || query.page, 10);
    var offset = (currentPage - 1) * limit;
    query.page = currentPage;
    _this3.setState({ currentPage: currentPage, offset: offset });
    _this3.replaceQuery(query);
  };

  this.handleFilterOnChange = function (value) {
    _this3.setState({ search: value }, function () {
      _this3.getDataByPage(1);
    });
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var query = (0, _url.decodeSearch)(_this3.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      delete query[filter];
      if (filter === 'search') {
        _this3.setState({
          search: ''
        });
      }
    });
    _this3.replaceQuery(query);
  };

  this.handleMenu = function (e, _ref) {
    var value = _ref.value;
    var store = _this3.context.store;

    store.dispatch((0, _reactRouterRedux.replace)(value));
  };

  this.handleOnHimsSettingChange = function (e, d) {
    _this3.setState({ himsSettingID: d.value }, function () {
      _this3.replaceQuery(1);
    });
  };

  this.renderMobileCell = function (value) {
    var url = '/projects/' + _this3.props.id + '/units/hims/' + _this3.state.himsSettingID + '/components/' + value.pembangunan_id + '/';
    return _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { className: 'computer-hide' },
      _react2.default.createElement(
        _semanticUiReact.Grid,
        {
          columns: 'equal',
          verticalAlign: 'middle'
        },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          _react2.default.createElement(
            _reactRouter.Link,
            { to: url },
            value.pembangunan_id
          ),
          _react2.default.createElement('br', null),
          value.jenis_rumah,
          _react2.default.createElement('br', null),
          'RM ',
          value.harga_minimum.toFixed(2),
          ' - ',
          value.harga_maksimum.toFixed(2)
        ),
        _react2.default.createElement(
          _reactRouter.Link,
          { to: url },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'chevron right', style: { float: 'right', marginTop: '1em' } })
        )
      )
    );
  };
};

exports.default = (0, _reactRouter.withRouter)(ComponentList);

/***/ }),
/* 2425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _url = __webpack_require__(19);

var _ComponentList = __webpack_require__(2424);

var _ComponentList2 = _interopRequireDefault(_ComponentList);

var _UnitList = __webpack_require__(2426);

var _UnitList2 = _interopRequireDefault(_UnitList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_momentTimezone2.default.locale('en-gb');

var HIMSUnitSync = function (_Component) {
  _inherits(HIMSUnitSync, _Component);

  function HIMSUnitSync(props) {
    _classCallCheck(this, HIMSUnitSync);

    var _this = _possibleConstructorReturn(this, (HIMSUnitSync.__proto__ || Object.getPrototypeOf(HIMSUnitSync)).call(this, props));

    _initialiseProps.call(_this);

    var state = HIMSUnitSync.getPropsToState(props);
    var windowWidth = window.innerWidth;
    var isTablet = windowWidth >= 768 && windowWidth < 992;
    var isMobile = windowWidth < 768;
    var isLargeScreen = windowWidth >= 1200;
    var topMenuIsTab = windowWidth <= 590;
    _this.state = _extends({}, state, {
      isMobile: isMobile,
      isTablet: isTablet,
      isLargeScreen: isLargeScreen,
      topMenuIsTab: topMenuIsTab,
      loading: true,
      himsSettings: [],
      componentData: []
    });
    return _this;
  }

  _createClass(HIMSUnitSync, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
      var store = this.context.store;
      var query = this.props.location.query;

      if (!this.hasAccess()) {
        store.dispatch((0, _reactRouterRedux.replace)('/forbidden/'));
        return;
      }
      this.fetchHimsSettings(query);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var state = HIMSUnitSync.getPropsToState(nextProps);
      var newQuery = (0, _url.decodeSearch)(nextProps.location.search);
      var shouldFetchComponents = state.himsSettingID && nextProps.params.himsSettingID !== this.props.params.himsSettingID;
      this.setState(_extends({}, state), function () {
        if (shouldFetchComponents) {
          _this2.fetchComponents(newQuery);
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var pathname = this.props.location.pathname;
      var _props = this.props,
          id = _props.id,
          project = _props.project;
      var _state = this.state,
          himsSettings = _state.himsSettings,
          himsSettingID = _state.himsSettingID,
          componentData = _state.componentData,
          componentID = _state.componentID,
          isMobile = _state.isMobile,
          isTablet = _state.isTablet,
          isLargeScreen = _state.isLargeScreen,
          topMenuIsTab = _state.topMenuIsTab;

      var isLoading = this.props.loading || this.state.loading;
      var links = [{ text: 'List of components', value: '/projects/' + id + '/units/hims/' + himsSettingID + '/' }, !this.hideUnitsTab() && { text: 'Unit list', value: '/projects/' + id + '/units/hims/' + himsSettingID + '/components/' + (componentID ? componentID + '/' : '') }];
      var messagesList = [{
        title: 'Retrieve Component ID and Unit Information',
        description: 'Use this page to access the Component ID (Pembangunan ID) and view all associated unit information'
      }, {
        title: 'Verify Data Accuracy',
        description: 'Double-check that all details, such as unit number, unit size, and unit price, are accurate'
      }, {
        title: 'Correcting Errors',
        description: 'If you discover any discrepancies, promptly correct them in the unit settings'
      }];

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: 'HIMS unit sync',
          links: topMenuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: link.text,
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this3.handleMenu(e, link);
              }
            });
          })
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 16, textAlign: 'center' },
          _react2.default.createElement(
            'div',
            { className: 'hims_notice' },
            _react2.default.createElement(
              _semanticUiReact.Message,
              { icon: true, attached: true },
              _react2.default.createElement(
                _semanticUiReact.Icon,
                { style: { fontSize: '20px' } },
                _react2.default.createElement('img', { alt: 'info', src: '/assets/icons/info_blue.svg' })
              ),
              'Important: Ensuring Data Accuracy for Seamless Workflow with HIMS'
            ),
            _react2.default.createElement(
              _semanticUiReact.Segment,
              { attached: true },
              'To ensure a smooth workflow and prevent errors, it is crucial that all unit information is matched with the HIMS database. Follow these steps to maintain data integrity:',
              _react2.default.createElement(
                _semanticUiReact.List,
                { as: 'ol' },
                messagesList.map(function (message, mid) {
                  return _react2.default.createElement(
                    _semanticUiReact.List.Item,
                    { as: 'li', key: mid },
                    _react2.default.createElement(
                      'span',
                      { style: { color: '#00233B', fontWeight: '700' } },
                      message.title
                    ),
                    ': \xA0',
                    message.description,
                    '.'
                  );
                })
              )
            )
          ),
          this.getTabName() === 'components' && _react2.default.createElement(_ComponentList2.default, {
            id: id,
            project: project,
            himsSettings: himsSettings,
            data: componentData,
            loading: isLoading,
            isTablet: isTablet,
            isMobile: isMobile
          }),
          this.getTabName() === 'units' && _react2.default.createElement(_UnitList2.default, {
            id: id,
            himsSettingID: himsSettingID,
            componentID: componentID,
            himsSettings: himsSettings,
            componentData: componentData,
            loading: isLoading,
            isLargeScreen: isLargeScreen,
            isTablet: isTablet,
            isMobile: isMobile
          })
        )
      );
    }
  }]);

  return HIMSUnitSync;
}(_react.Component);

HIMSUnitSync.propTypes = {
  params: _propTypes2.default.shape({
    himsSettingID: _propTypes2.default.string,
    componentID: _propTypes2.default.string
  }),
  id: _propTypes2.default.string,
  project: _propTypes2.default.object,
  loading: _propTypes2.default.bool,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    search: _propTypes2.default.string,
    query: _propTypes2.default.object
  }),
  auth: _propTypes2.default.shape({
    user: _propTypes2.default.shape({
      isHeadquarters: _propTypes2.default.bool,
      isSuperAdmin: _propTypes2.default.bool,
      isBranchLeaderSupervisorII: _propTypes2.default.bool
    })
  })
};

HIMSUnitSync.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

HIMSUnitSync.contextTypes = {
  store: _propTypes2.default.object
};

HIMSUnitSync.getPropsToState = function (props) {
  var himsSettingID = props.params.himsSettingID || '';
  var componentID = props.params.componentID || '';
  return {
    himsSettingID: himsSettingID,
    componentID: componentID
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.setComponentState = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new Promise(function (res) {
      _this4.setState(state, function () {
        res(state);
      });
    });
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this4.setState({ loading: loading }, function () {
        res(loading);
      });
    });
  };

  this.getTabName = function () {
    var pathname = _this4.props.location.pathname;
    var id = _this4.props.id;
    var himsSettingID = _this4.state.himsSettingID;

    if (pathname === '/projects/' + id + '/units/hims/' || pathname === '/projects/' + id + '/units/hims/' + himsSettingID + '/') {
      return 'components';
    }
    return 'units';
  };

  this.fetchHimsSettings = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var store, id, pathname, himsSettingID, query, res, message, himsSettings, newQuery;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this4.setLoading(true);

            case 2:
              store = _this4.context.store;
              id = _this4.props.id;
              pathname = _this4.props.location.pathname;
              himsSettingID = _this4.state.himsSettingID;
              query = Object.assign({}, q);
              res = void 0;
              _context.prev = 8;
              _context.next = 11;
              return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + id + '/hims/?' + _qs2.default.stringify(query), {
                credentials: 'include',
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }));

            case 11:
              res = _context.sent;
              _context.next = 22;
              break;

            case 14:
              _context.prev = 14;
              _context.t0 = _context['catch'](8);

              Bugsnag.notifyException(_context.t0);
              _context.next = 19;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

            case 19:
              _context.next = 21;
              return _this4.setLoading(false);

            case 21:
              return _context.abrupt('return');

            case 22:
              if (res.ok) {
                _context.next = 30;
                break;
              }

              _context.next = 25;
              return res.text();

            case 25:
              message = _context.sent;
              _context.next = 28;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

            case 28:
              _context.next = 40;
              break;

            case 30:
              _context.next = 32;
              return res.json();

            case 32:
              _context.t1 = _context.sent;

              if (_context.t1) {
                _context.next = 35;
                break;
              }

              _context.t1 = [];

            case 35:
              himsSettings = _context.t1;


              if (!himsSettingID && himsSettings && himsSettings.length > 0) {
                himsSettingID = himsSettings[0].id;
              }
              _context.next = 39;
              return _this4.setComponentState({
                himsSettings: himsSettings,
                himsSettingID: himsSettingID,
                componentID: ''
              });

            case 39:
              if (himsSettingID && pathname === '/projects/' + id + '/units/hims/') {
                store.dispatch((0, _reactRouterRedux.replace)('/projects/' + id + '/units/hims/' + himsSettingID + '/'));
              }

            case 40:
              _context.next = 42;
              return _this4.setLoading(false);

            case 42:

              if (himsSettingID) {
                newQuery = (0, _url.decodeSearch)(_this4.props.location.search);

                _this4.fetchComponents(newQuery);
              }

            case 43:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this4, [[8, 14]]);
    }));

    return function () {
      return _ref.apply(this, arguments);
    };
  }();

  this.fetchComponents = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var store, id, himsSettingID, pathname, componentID, query, res, message, componentData;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this4.setLoading(true);

            case 2:
              store = _this4.context.store;
              id = _this4.props.id;
              himsSettingID = _this4.state.himsSettingID;
              pathname = _this4.props.location.pathname;
              componentID = _this4.state.componentID;
              query = Object.assign({}, q);
              res = void 0;
              _context2.prev = 9;
              _context2.next = 12;
              return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + id + '/hims/' + himsSettingID + '/components/?' + _qs2.default.stringify(query), {
                credentials: 'include',
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }));

            case 12:
              res = _context2.sent;
              _context2.next = 23;
              break;

            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2['catch'](9);

              Bugsnag.notifyException(_context2.t0);
              _context2.next = 20;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

            case 20:
              _context2.next = 22;
              return _this4.setLoading(false);

            case 22:
              return _context2.abrupt('return');

            case 23:
              if (res.ok) {
                _context2.next = 31;
                break;
              }

              _context2.next = 26;
              return res.text();

            case 26:
              message = _context2.sent;
              _context2.next = 29;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

            case 29:
              _context2.next = 41;
              break;

            case 31:
              _context2.next = 33;
              return res.json();

            case 33:
              _context2.t1 = _context2.sent;

              if (_context2.t1) {
                _context2.next = 36;
                break;
              }

              _context2.t1 = [];

            case 36:
              componentData = _context2.t1;

              if (componentData && componentData.length > 0) {
                componentID = componentData[0].pembangunan_id;
              }
              _context2.next = 40;
              return _this4.setComponentState({
                componentData: componentData,
                componentID: componentID
              });

            case 40:
              if (componentID && pathname.startsWith('/projects/' + id + '/units/hims/' + himsSettingID + '/components/')) {
                store.dispatch((0, _reactRouterRedux.replace)('/projects/' + id + '/units/hims/' + himsSettingID + '/components/' + componentID + '/'));
              }

            case 41:
              _context2.next = 43;
              return _this4.setLoading(false);

            case 43:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this4, [[9, 15]]);
    }));

    return function () {
      return _ref2.apply(this, arguments);
    };
  }();

  this.hasAccess = function () {
    var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    var user = _this4.props.auth;
    if (user.isHeadquarters || user.isSuperAdmin) {
      return true;
    }
    if (user.isBranchLeaderSupervisorII && _this4.props.project && _this4.props.project.maOwnerCompanyBranchID === user.companyBranch.id) {
      return true;
    }
    return check;
  };

  this.handleMenu = function (e, _ref3) {
    var value = _ref3.value;
    var store = _this4.context.store;

    store.dispatch((0, _reactRouterRedux.replace)(value));
  };

  this.handleResize = function () {
    var state = {};
    var windowWidth = window.innerWidth;
    var topMenuIsTab = windowWidth <= 590;
    var isMobile = windowWidth < 768;
    var isTablet = windowWidth >= 768 && windowWidth < 992;
    var isLargeScreen = windowWidth >= 1200;
    if (topMenuIsTab !== _this4.state.topMenuIsTab) {
      state.topMenuIsTab = topMenuIsTab;
    }
    if (isMobile !== _this4.state.isMobile) {
      state.isMobile = isMobile;
    }
    if (isTablet !== _this4.state.isTablet) {
      state.isTablet = isTablet;
    }
    if (isLargeScreen !== _this4.state.isLargeScreen) {
      state.isLargeScreen = isLargeScreen;
    }
    _this4.setState(_extends({}, state));
  };

  this.hideUnitsTab = function () {
    var componentID = _this4.state.componentID;

    if (componentID) {
      return false;
    }
    if (_this4.getTabName() === 'units') {
      return false;
    }
    return true;
  };
};

exports.default = (0, _reactRedux.connect)(HIMSUnitSync.mapStateToProps)(HIMSUnitSync);

/***/ }),
/* 2426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _reactRouter = __webpack_require__(18);

var _lodash = __webpack_require__(36);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _HIMSUnitSync = __webpack_require__(2516);

var _HIMSUnitSync2 = _interopRequireDefault(_HIMSUnitSync);

var _ConfirmHIMSUnitSync = __webpack_require__(2514);

var _ConfirmHIMSUnitSync2 = _interopRequireDefault(_ConfirmHIMSUnitSync);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _hims = __webpack_require__(221);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_momentTimezone2.default.locale('en-gb');

var UnitList = function (_Component) {
  _inherits(UnitList, _Component);

  function UnitList(props) {
    _classCallCheck(this, UnitList);

    var _this = _possibleConstructorReturn(this, (UnitList.__proto__ || Object.getPrototypeOf(UnitList)).call(this, props));

    _initialiseProps.call(_this);

    var state = UnitList.getPropsToState(props);
    var query = (0, _url.decodeSearch)(props.location.search);
    var search = query.search || '';
    var limit = 20;
    var currentPage = parseInt(query.page, 10) || 1;
    var offset = (currentPage - 1) * limit;
    _this.state = _extends({
      limit: limit,
      offset: offset,
      currentPage: currentPage,
      search: search,
      data: [],
      componentData: [],
      count: 0,
      loading: true,
      himsUnitsLoading: true,
      showModal: false,
      showConfirmModal: false,
      confirmHIMSUnit: '',
      confirmSRUnit: '',
      srUnits: []
    }, state);
    return _this;
  }

  _createClass(UnitList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = this.props.location.query;

      if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
        delete query.page;
      }
      this.fetchShowroomUnits();
      this.fetchUnitCustomFieldSettings();
      if (this.state.componentID) {
        this.fetchHIMSUnits(query);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var state = UnitList.getPropsToState(nextProps);
      var newQuery = (0, _url.decodeSearch)(nextProps.location.search);
      var shouldFetchHIMSUnits = !this.state.himsUnitsLoading && nextProps.params.componentID !== this.props.params.componentID && state.himsSettingID && state.componentID;
      this.setState(_extends({}, state), function () {
        if (shouldFetchHIMSUnits) {
          _this2.fetchHIMSUnits(newQuery);
        } else {
          _this2.getDataByPage(newQuery.page || 1);
        }
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'setHimsUnitsLoading',
    value: function setHimsUnitsLoading() {
      var _this5 = this;

      var himsUnitsLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this5.setState({ himsUnitsLoading: himsUnitsLoading }, function () {
          res(himsUnitsLoading);
        });
      });
    }
  }, {
    key: 'setSRUnits',
    value: function setSRUnits() {
      var _this6 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this6.setState({
          srUnits: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'fetchShowroomUnits',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, query, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = {
                  limit: 0
                };
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/units/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 19;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 16:
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context.next = 35;
                break;

              case 27:
                token = res.headers.get('X-Csrf-Token');
                _context.next = 30;
                return res.json();

              case 30:
                data = _context.sent;
                _context.next = 33;
                return this.setComponentState({ token: token });

              case 33:
                _context.next = 35;
                return this.setSRUnits(data);

              case 35:
                _context.next = 37;
                return this.setLoading(false);

              case 37:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchShowroomUnits() {
        return _ref.apply(this, arguments);
      }

      return fetchShowroomUnits;
    }()
  }, {
    key: 'fetchUnitCustomFieldSettings',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, res, message, unitCustomFieldSettingsData;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context2.prev = 4;
                _context2.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/settings/unit_custom_fields/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context2.sent;
                _context2.next = 21;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](4);
                _context2.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 19;
                  break;
                }

                _context2.next = 17;
                return _context2.t0.res.text();

              case 17:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 19:
                Bugsnag.notifyException(_context2.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));

              case 21:
                if (res.ok) {
                  _context2.next = 27;
                  break;
                }

                _context2.next = 24;
                return this.setLoading(false);

              case 24:
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                _context2.next = 34;
                break;

              case 27:
                _context2.next = 29;
                return res.json();

              case 29:
                unitCustomFieldSettingsData = _context2.sent;
                _context2.next = 32;
                return this.setComponentState({
                  unitCustomFieldSettings: unitCustomFieldSettingsData
                });

              case 32:
                _context2.next = 34;
                return this.setLoading(false);

              case 34:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10]]);
      }));

      function fetchUnitCustomFieldSettings() {
        return _ref2.apply(this, arguments);
      }

      return fetchUnitCustomFieldSettings;
    }()
  }, {
    key: 'autoSyncUnits',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var store, id, _state, himsSettingID, componentID, message, query;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                id = this.props.id;
                _state = this.state, himsSettingID = _state.himsSettingID, componentID = _state.componentID;
                _context3.prev = 5;
                _context3.next = 8;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + id + '/hims/' + himsSettingID + '/components/' + componentID + '/units/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.himsToken
                  }
                }));

              case 8:
                _context3.next = 23;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](5);
                _context3.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 20;
                  break;
                }

                _context3.next = 17;
                return _context3.t0.res.text();

              case 17:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 20:
                Bugsnag.notifyException(_context3.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context3.abrupt('return');

              case 23:
                _context3.next = 25;
                return this.setLoading(false);

              case 25:
                // refetch page
                query = (0, _url.decodeSearch)(this.props.location.search);

                this.fetchHIMSUnits(query);
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: 'Auto Sync Units Success',
                  message: 'Units successfully updated'
                }));

              case 28:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 10]]);
      }));

      function autoSyncUnits() {
        return _ref3.apply(this, arguments);
      }

      return autoSyncUnits;
    }()
  }, {
    key: 'syncUnit',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var store, unit, message, query;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                unit = this.state.syncUnitData;
                _context4.prev = 4;
                _context4.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/units/' + unit.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(unit)
                }));

              case 7:
                _context4.next = 22;
                break;

              case 9:
                _context4.prev = 9;
                _context4.t0 = _context4['catch'](4);
                _context4.next = 13;
                return this.setLoading(false);

              case 13:
                if (!(_context4.t0.res && _context4.t0.res.status >= 400 && _context4.t0.res.status < 500)) {
                  _context4.next = 19;
                  break;
                }

                _context4.next = 16;
                return _context4.t0.res.text();

              case 16:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context4.abrupt('return');

              case 19:
                Bugsnag.notifyException(_context4.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context4.abrupt('return');

              case 22:
                _context4.next = 24;
                return this.setLoading(false);

              case 24:
                if (this.state.oldUnitData) {
                  this.removeHimsFromOldUnit();
                } else {
                  // refetch page
                  query = (0, _url.decodeSearch)(this.props.location.search);

                  this.fetchShowroomUnits();
                  this.fetchHIMSUnits(query);
                  store.dispatch((0, _flash.flashSuccessMessage)({
                    header: 'Sync Unit Success',
                    message: 'Unit successfully updated'
                  }));
                }

              case 25:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[4, 9]]);
      }));

      function syncUnit() {
        return _ref4.apply(this, arguments);
      }

      return syncUnit;
    }()
  }, {
    key: 'removeHimsFromOldUnit',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var store, unit, message, query;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                unit = this.state.oldUnitData;

                if (unit.projectUnitCustomFields) {
                  unit.projectUnitCustomFields = unit.projectUnitCustomFields.map(function (p) {
                    var value = p.value;

                    if (_hims.HIMS_UNIT_FIELDS.includes(p.projectUnitCustomFieldSettingID)) {
                      value = '';
                    }
                    return _extends({}, p, {
                      value: value
                    });
                  }) || [];
                }
                _context5.prev = 5;
                _context5.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/units/' + unit.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(unit)
                }));

              case 8:
                _context5.next = 23;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](5);
                _context5.next = 14;
                return this.setLoading(false);

              case 14:
                if (!(_context5.t0.res && _context5.t0.res.status >= 400 && _context5.t0.res.status < 500)) {
                  _context5.next = 20;
                  break;
                }

                _context5.next = 17;
                return _context5.t0.res.text();

              case 17:
                message = _context5.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context5.abrupt('return');

              case 20:
                Bugsnag.notifyException(_context5.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: 'There was an error with your request. Please try again.' }));
                return _context5.abrupt('return');

              case 23:
                _context5.next = 25;
                return this.setLoading(false);

              case 25:
                // refetch page
                query = (0, _url.decodeSearch)(this.props.location.search);

                this.fetchHIMSUnits(query);
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: 'Sync Unit Success',
                  message: 'Unit successfully updated'
                }));

              case 28:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[5, 10]]);
      }));

      function removeHimsFromOldUnit() {
        return _ref5.apply(this, arguments);
      }

      return removeHimsFromOldUnit;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var store = this.context.store;
      var _state2 = this.state,
          himsSettingID = _state2.himsSettingID,
          componentID = _state2.componentID;

      store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.id + '/units/hims/' + himsSettingID + '/components/' + (componentID ? componentID + '/' : '') + '?' + (0, _url.encodeSearch)(query)));
    }
  }, {
    key: 'renderBody',
    value: function renderBody() {
      var _this7 = this;

      var _state3 = this.state,
          data = _state3.data,
          himsUnitsLoading = _state3.himsUnitsLoading,
          isMobile = _state3.isMobile,
          loading = _state3.loading;

      var isLoading = loading || himsUnitsLoading;
      return !isLoading && data.length > 0 ? data.map(function (value, idx) {
        return _react2.default.createElement(
          _semanticUiReact.Table.Row,
          { key: idx },
          _this7.renderMobileCell(value),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'mobile-hide' },
            value.no_unit
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'mobile-hide' },
            value.no_lot_pt
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'mobile-hide' },
            value.harga_jualan.toFixed(2)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'mobile-hide' },
            value.luas_tanah.toFixed(2)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { className: 'mobile-hide' },
            value.luas_binaan.toFixed(2)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { collapsing: true, className: 'mobile-hide' },
            value.harga_spjb.toFixed(2)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { collapsing: true, className: 'mobile-hide', textAlign: 'center' },
            _react2.default.createElement(
              'p',
              { style: { margin: 0 } },
              value.status_jualan === 1 ? 'Yes' : 'No'
            ),
            value.status_pembeli_pertama === 1 && _react2.default.createElement(
              _semanticUiReact.Label,
              { size: 'mini', style: { marginTop: '0.5em' }, color: 'green' },
              '1st Buyer'
            )
          ),
          value.showroomUnitID ? _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { width: 2, textAlign: 'center', onClick: function onClick(e) {
                return _this7.handleOnEditUnit(e, value);
              } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { mobile: 3, tablet: 2, computer: 2, textAlign: 'center' },
              _react2.default.createElement(_semanticUiReact.Icon, {
                name: 'edit',
                color: 'grey',
                style: { fontSize: '1em' }
              }),
              _react2.default.createElement(
                _reactRouter.Link,
                null,
                value.showroomUnit.reference
              )
            ),
            value.showroomUnit.isBumi && _react2.default.createElement(
              _semanticUiReact.Label,
              { size: 'mini', style: { marginTop: '0.5em' } },
              'Bumi'
            )
          ) : _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { colSpan: isMobile ? 1 : 2, textAlign: 'center' },
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                className: 'ui compact icon primary button',
                onClick: function onClick(e) {
                  return _this7.handleOnEditUnit(e, value);
                }
              },
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'edit' })
            )
          ),
          value.showroomUnitID ? _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { collapsing: true, className: 'mobile-hide' },
            value.showroomUnit && value.showroomUnit.projectUnitCustomFields && value.showroomUnit.projectUnitCustomFields.length > 0 && value.showroomUnit.projectUnitCustomFields.find(function (pucf) {
              return pucf.projectUnitCustomFieldSettingID === _hims.HIMS_UNIT_NUMBER;
            }).value
          ) : null
        );
      }) : _react2.default.createElement(
        _semanticUiReact.Table.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Table.Cell,
          { colSpan: '100%', textAlign: 'center' },
          isLoading ? _react2.default.createElement(
            _semanticUiReact.Loader,
            { active: true, inline: 'centered' },
            'Loading'
          ) : _react2.default.createElement(
            'p',
            null,
            'No units found.'
          )
        )
      );
    }
  }, {
    key: 'renderTable',
    value: function renderTable() {
      var _this8 = this;

      var _props = this.props,
          id = _props.id,
          componentData = _props.componentData,
          isMobile = _props.isMobile,
          isTablet = _props.isTablet,
          isLargeScreen = _props.isLargeScreen,
          himsSettings = _props.himsSettings;
      var _state4 = this.state,
          himsSettingID = _state4.himsSettingID,
          componentID = _state4.componentID,
          himsUnitsLoading = _state4.himsUnitsLoading,
          loading = _state4.loading;

      var isLoading = loading || himsUnitsLoading;
      var exportItems = [{
        text: 'Excel',
        icon: 'download',
        href: _config2.default.get('bookApiURL') + '/projects/' + id + '/hims/' + himsSettingID + '/components/' + componentID + '/units/export/'
      }];
      return _react2.default.createElement(
        _semanticUiReact.Table,
        {
          celled: true,
          unstackable: true,
          structured: true
        },
        _react2.default.createElement(
          _semanticUiReact.Table.Header,
          { fullWidth: true },
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { colSpan: '100%' },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 1, verticalAlign: 'middle' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_SearchFilter2.default, {
                    inTable: true,
                    searchWidth: isMobile ? 16 : isTablet ? 13 : 4,
                    rightNavWidth: isMobile || isTablet ? 16 : 10,
                    leftNavWidth: isMobile ? 16 : isTablet ? 3 : 2,
                    isLoading: isLoading,
                    onChange: this.handleFilterOnChange,
                    onClose: this.handleClearFilter,
                    search: this.state.search,
                    advanceFilter: this.state.advanceFilter,
                    leftNav: _react2.default.createElement(
                      _semanticUiReact.Header,
                      { style: { marginLeft: '0.5em', marginTop: '0.25em' } },
                      'Unit List'
                    ),
                    rightNav: _react2.default.createElement(
                      'div',
                      { style: isTablet ? { marginTop: '1.5em' } : {} },
                      _react2.default.createElement(_semanticUiReact.Select, {
                        disabled: himsSettings.length === 0 || isLoading,
                        loading: isLoading,
                        onChange: this.handleOnHimsSettingChange,
                        value: himsSettingID,
                        placeholder: 'Select Project Code',
                        options: himsSettings.map(function (hs) {
                          return {
                            value: hs.id,
                            text: 'Project Code (' + hs.himsDevelopmentCode + ')'
                          };
                        })
                      }),
                      _react2.default.createElement(_semanticUiReact.Select, {
                        disabled: componentData.length === 0 || isLoading || !himsSettingID,
                        loading: isLoading,
                        onChange: this.handleOnComponentChange,
                        value: componentID,
                        placeholder: 'Select Component ID',
                        options: componentData.map(function (c) {
                          return {
                            value: c.pembangunan_id,
                            text: 'Component ID (' + c.pembangunan_id + ')'
                          };
                        }),
                        style: { marginLeft: '0.5em' }
                      }),
                      _react2.default.createElement(_SortButton2.default, {
                        loading: isLoading,
                        icon: 'download',
                        items: exportItems,
                        disabled: !himsSettingID || !componentID
                      }),
                      _react2.default.createElement(
                        _semanticUiReact.Button,
                        {
                          style: _extends({}, !isTablet && (isMobile || !isLargeScreen) ? { marginTop: '0.5em' } : {}, {
                            marginRight: 0,
                            marginLeft: '0.5em'
                          }),
                          primary: true,
                          icon: isMobile,
                          disabled: !himsSettingID || !componentID || isLoading,
                          onClick: this.handleAutoSyncUnits
                        },
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'redo' }),
                        !isMobile && 'Auto Sync Units'
                      )
                    )
                  })
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { colSpan: isMobile ? 1 : 7 },
              _react2.default.createElement(
                _semanticUiReact.Header,
                { style: { marginLeft: '0.5em', marginTop: '0.25em' } },
                'HIMS'
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              {
                colSpan: isMobile ? 1 : 2,
                collapsing: true,
                width: isMobile ? 8 : 3,
                onClick: function onClick() {
                  return _this8.handleSort();
                },
                style: { background: '#E9ECF0', cursor: 'pointer' }
              },
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { style: { marginLeft: '0.5em', marginTop: '0.25em' } },
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  { style: { display: 'inline-block', marginBottom: '0' } },
                  'Showroom'
                ),
                _react2.default.createElement(_semanticUiReact.Icon, {
                  style: { float: 'right', color: '#767676' },
                  name: 'exchange',
                  rotated: 'clockwise'
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { className: 'mobile-hide' },
              'No. Unit'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { className: 'mobile-hide' },
              'No. Lot PT'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { className: 'mobile-hide' },
              'Harga Jualan (RM)'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { className: 'mobile-hide' },
              'Keluasan Tanah (MPS)'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { className: 'mobile-hide' },
              'Keluasan Binaan (MPS)'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { className: 'mobile-hide', width: 2 },
              'Harga SPJB (RM)'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { className: 'mobile-hide' },
              'Sold Status'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { className: 'mobile-hide', style: { background: '#E9ECF0' } },
              'Unit'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { className: 'mobile-hide', style: { background: '#E9ECF0' } },
              'HIMS Unit'
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Body,
          null,
          this.renderBody()
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var himsSettings = this.props.himsSettings;
      var _state5 = this.state,
          count = _state5.count,
          limit = _state5.limit,
          offset = _state5.offset,
          himsUnitsLoading = _state5.himsUnitsLoading,
          loading = _state5.loading,
          currentPage = _state5.currentPage,
          selectedUnit = _state5.selectedUnit,
          showModal = _state5.showModal,
          showConfirmModal = _state5.showConfirmModal,
          confirmHIMSUnit = _state5.confirmHIMSUnit,
          confirmSRUnit = _state5.confirmSRUnit,
          srUnits = _state5.srUnits,
          unitCustomFieldSettings = _state5.unitCustomFieldSettings,
          himsSettingID = _state5.himsSettingID;

      var isLoading = loading || himsUnitsLoading;
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        null,
        _react2.default.createElement(_HIMSUnitSync2.default, {
          open: showModal,
          himsSetting: himsSettingID && himsSettings && himsSettings.length > 0 ? himsSettings.find(function (hs) {
            return hs.id === himsSettingID;
          }) : null,
          data: selectedUnit || {},
          srUnits: srUnits,
          unitCustomFieldSettings: unitCustomFieldSettings,
          onClose: this.handleCloseModal,
          onConfirm: this.handleConfirmModal
        }),
        _react2.default.createElement(_ConfirmHIMSUnitSync2.default, {
          open: showConfirmModal,
          himsUnit: confirmHIMSUnit,
          srUnit: confirmSRUnit,
          onClose: this.handleCloseConfirmModal,
          onConfirm: this.handleSyncUnit
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { width: 16, textAlign: 'center' },
          this.renderTable(),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { style: { marginTop: '3em' }, textAlign: 'center' },
            _react2.default.createElement(_PageNav2.default, {
              currentPage: currentPage,
              count: count,
              limit: limit,
              offset: offset,
              dataSize: this.state.data.length,
              loading: isLoading,
              onChange: this.handleChangePage
            })
          )
        )
      );
    }
  }]);

  return UnitList;
}(_react.Component);

UnitList.propTypes = {
  params: _propTypes2.default.shape({
    himsSettingID: _propTypes2.default.string,
    componentID: _propTypes2.default.string
  }),
  id: _propTypes2.default.string,
  project: _propTypes2.default.object,
  loading: _propTypes2.default.bool,
  himsSettings: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string,
    himsDevelopmentCode: _propTypes2.default.string
  })),
  componentData: _propTypes2.default.array,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    search: _propTypes2.default.string,
    query: _propTypes2.default.object
  }),
  isMobile: _propTypes2.default.bool,
  isTablet: _propTypes2.default.bool,
  isLargeScreen: _propTypes2.default.bool
};
UnitList.contextTypes = {
  store: _propTypes2.default.object
};

UnitList.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var componentData = props.componentData || [];
  var himsSettingID = props.params.himsSettingID || '';
  var componentID = props.params.componentID || '';
  return {
    componentData: componentData,
    currentPage: currentPage,
    himsSettingID: himsSettingID,
    componentID: componentID
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this9 = this;

  this.getDataByPage = function (page) {
    var replaceQuery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var _state6 = _this9.state,
        oriData = _state6.oriData,
        limit = _state6.limit,
        sortDirection = _state6.sortDirection,
        search = _state6.search;

    var data = oriData || [];
    var count = data.length || 0;
    if (sortDirection) {
      data = _this9.sortByShowroomUnit();
    }
    if (search) {
      data = data.filter(function (d) {
        return d.no_unit.includes(search);
      });
      count = data.length;
    }
    var query = (0, _url.decodeSearch)(_this9.props.location.search);
    var currentPage = parseInt(page, 10);
    var offset = (currentPage - 1) * limit;
    query.page = currentPage;
    data = data.slice((page - 1) * limit, page * limit);
    _this9.setState({ data: data, currentPage: currentPage, count: count, offset: offset });
    if (replaceQuery) _this9.replaceQuery(query);
  };

  this.sortByShowroomUnit = function () {
    var _state7 = _this9.state,
        oriData = _state7.oriData,
        sortDirection = _state7.sortDirection;

    var data = [];
    var unitsWithSR = oriData.filter(function (d) {
      return d.showroomUnit;
    });
    var unitsWithoutSR = oriData.filter(function (d) {
      return !d.showroomUnit;
    });
    if (sortDirection === 'desc') {
      unitsWithSR.sort(function (a, b) {
        return b.showroomUnit.reference.localeCompare(a.showroomUnit.reference);
      });
      data = unitsWithoutSR.concat(unitsWithSR);
    } else {
      unitsWithSR.sort(function (a, b) {
        return a.showroomUnit.reference.localeCompare(b.showroomUnit.reference);
      });
      data = unitsWithSR.concat(unitsWithoutSR);
    }
    return data;
  };

  this.fetchHIMSUnits = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var id, _state8, himsSettingID, componentID, limit, store, query, res, message, token, data, count, currentPage, offset;

      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              id = _this9.props.id;
              _state8 = _this9.state, himsSettingID = _state8.himsSettingID, componentID = _state8.componentID, limit = _state8.limit;
              store = _this9.context.store;

              if (componentID) {
                _context6.next = 5;
                break;
              }

              return _context6.abrupt('return');

            case 5:
              _context6.next = 7;
              return _this9.setHimsUnitsLoading(true);

            case 7:
              query = Object.assign({}, q);
              res = void 0;
              _context6.prev = 9;
              _context6.next = 12;
              return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + id + '/hims/' + himsSettingID + '/components/' + componentID + '/units/?' + _qs2.default.stringify(query), {
                credentials: 'include',
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json'
                }
              }));

            case 12:
              res = _context6.sent;
              _context6.next = 23;
              break;

            case 15:
              _context6.prev = 15;
              _context6.t0 = _context6['catch'](9);

              Bugsnag.notifyException(_context6.t0);
              _context6.next = 20;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

            case 20:
              _context6.next = 22;
              return _this9.setHimsUnitsLoading(false);

            case 22:
              return _context6.abrupt('return');

            case 23:
              if (res.ok) {
                _context6.next = 31;
                break;
              }

              _context6.next = 26;
              return res.text();

            case 26:
              message = _context6.sent;
              _context6.next = 29;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

            case 29:
              _context6.next = 41;
              break;

            case 31:
              token = res.headers.get('X-Csrf-Token');
              _context6.next = 34;
              return res.json();

            case 34:
              data = _context6.sent;
              count = data ? data.length : 0;
              currentPage = parseInt(query.page, 10) || 1;
              offset = (currentPage - 1) * limit;
              _context6.next = 40;
              return _this9.setComponentState({
                count: count,
                offset: offset,
                oriData: (0, _lodash.clone)(data) || [],
                data: [],
                himsToken: token
              });

            case 40:
              _this9.getDataByPage(currentPage || 1, true);

            case 41:
              _context6.next = 43;
              return _this9.setHimsUnitsLoading(false);

            case 43:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this9, [[9, 15]]);
    }));

    return function () {
      return _ref6.apply(this, arguments);
    };
  }();

  this.handleChangePage = function (page) {
    var limit = _this9.state.limit;

    var query = (0, _url.decodeSearch)(_this9.props.location.search);
    if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
      query.page = 1;
    }
    var currentPage = parseInt(page || query.page, 10);
    var offset = (currentPage - 1) * limit;
    query.page = currentPage;
    _this9.setState({ currentPage: currentPage, offset: offset });
    _this9.replaceQuery(query);
  };

  this.handleFilterOnChange = function (value) {
    _this9.setState({ search: value }, function () {
      _this9.getDataByPage(1, true);
    });
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var query = (0, _url.decodeSearch)(_this9.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      delete query[filter];
      if (filter === 'search') {
        _this9.setState({
          search: ''
        });
      }
    });
    _this9.replaceQuery(query);
  };

  this.handleOnHimsSettingChange = function (e, d) {
    _this9.setState({ himsSettingID: d.value, componentID: '' }, function () {
      _this9.replaceQuery(1);
    });
  };

  this.handleOnComponentChange = function (e, d) {
    _this9.setState({ componentID: d.value }, function () {
      _this9.replaceQuery(1);
    });
  };

  this.handleMenu = function (e, _ref7) {
    var value = _ref7.value;
    var store = _this9.context.store;

    store.dispatch((0, _reactRouterRedux.replace)(value));
  };

  this.handleSort = function () {
    var sortDirection = _this9.state.sortDirection;

    var direction = sortDirection === 'asc' ? 'desc' : 'asc';
    _this9.setState({ sortDirection: direction }, function () {
      _this9.getDataByPage(1, true);
    });
  };

  this.handleOnEditUnit = function (e, value) {
    e.preventDefault();
    var selectedUnit = value;
    _this9.setState({ showModal: true, selectedUnit: selectedUnit });
  };

  this.handleCloseModal = function () {
    _this9.setState({ showModal: false });
  };

  this.checkSrUnitHasHimsData = function (unit) {
    return unit && unit.projectUnitCustomFields && unit.projectUnitCustomFields.reduce(function (count, cf) {
      if (_hims.HIMS_UNIT_MAIN_FIELDS.includes(cf.projectUnitCustomFieldSettingID) && cf.value) {
        return count + 1;
      }
      return count;
    }, 0) === _hims.HIMS_UNIT_MAIN_FIELDS.length;
  };

  this.mapSrUnitHimsData = function (unit) {
    var srUnitHimsData = {};
    if (unit) {
      srUnitHimsData.id = unit.id;
      srUnitHimsData.reference = unit.reference;
      if (unit.projectUnitCustomFields) {
        unit.projectUnitCustomFields.forEach(function (cf) {
          if (_hims.HIMS_UNIT_MAIN_FIELDS.includes(cf.projectUnitCustomFieldSettingID)) {
            srUnitHimsData[cf.projectUnitCustomFieldSettingID] = cf.value;
          }
        });
      }
    }
    return srUnitHimsData;
  };

  this.handleConfirmModal = function (e, d, oldUnit) {
    _this9.setState({
      syncUnitData: d,
      oldUnitData: oldUnit
    });
    // check if the SR unit is synced with other HIMS unit
    var _state9 = _this9.state,
        data = _state9.data,
        srUnits = _state9.srUnits;

    var currentUnit = srUnits.find(function (unit) {
      return unit.id === d.id;
    });
    var himsUnitWithSameSRID = data.find(function (hu) {
      return hu.showroomUnitID === d.id;
    });
    var currentUnitHasHims = _this9.checkSrUnitHasHimsData(currentUnit);
    if (himsUnitWithSameSRID || currentUnitHasHims) {
      _this9.setState({
        confirmHIMSUnit: _this9.mapSrUnitHimsData(himsUnitWithSameSRID ? himsUnitWithSameSRID.showroomUnit : currentUnit),
        confirmSRUnit: _this9.mapSrUnitHimsData(d)
      }, function () {
        _this9.handleShowReconfirmModal(e);
      });
    } else {
      _this9.handleSyncUnit();
    }
  };

  this.handleShowReconfirmModal = function () {
    _this9.setState({ showConfirmModal: true });
  };

  this.handleCloseConfirmModal = function () {
    _this9.setState({ showConfirmModal: false });
  };

  this.handleSyncUnit = function () {
    _this9.setState({
      showModal: false,
      showConfirmModal: false
    }, function () {
      _this9.syncUnit();
    });
  };

  this.handleAutoSyncUnits = function () {
    _this9.autoSyncUnits();
  };

  this.renderMobileCell = function (value) {
    return _react2.default.createElement(
      _semanticUiReact.Table.Cell,
      { className: 'computer-hide' },
      value.no_unit,
      _react2.default.createElement('br', null),
      value.no_lot_pt,
      _react2.default.createElement('br', null),
      'RM ',
      value.harga_jualan.toFixed(2),
      _react2.default.createElement('br', null),
      value.status_jualan === 1 ? 'SOLD' : '',
      value.status_pembeli_pertama === 1 && _react2.default.createElement(
        _semanticUiReact.Label,
        { size: 'mini', style: value.status_jualan === 1 ? { marginLeft: '0.5em' } : {}, color: 'green' },
        '1st Buyer'
      )
    );
  };
};

exports.default = (0, _reactRouter.withRouter)(UnitList);

/***/ }),
/* 2427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _url = __webpack_require__(19);

var _fileSize = __webpack_require__(85);

var _fileSize2 = _interopRequireDefault(_fileSize);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _valueToText = __webpack_require__(98);

var _valueToText2 = _interopRequireDefault(_valueToText);

var _dataImport = __webpack_require__(1088);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_momentTimezone2.default.locale('en-gb');

var Import = function (_Component) {
  _inherits(Import, _Component);

  function Import(props) {
    _classCallCheck(this, Import);

    var _this = _possibleConstructorReturn(this, (Import.__proto__ || Object.getPrototypeOf(Import)).call(this, props));

    _initialiseProps.call(_this);

    var state = Import.getPropsToState(props);
    _this.state = _extends({}, state, {
      file: null
    });
    return _this;
  }

  _createClass(Import, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Import.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'submitFile',
    value: function submitFile(body) {
      var _this4 = this;

      var t = this.props.t;

      this.setLoading(true);
      this.props.setUpdating(true);
      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/units/import/', {
        credentials: 'include',
        method: 'POST',
        headers: {
          // Let browser decide Content-Type
          'X-Csrf-Token': this.props.token
        },
        body: body
      })).then(function (res) {
        _this4.setLoading(false);
        res.text().then(function () {
          _this4.setState({ file: null }, function () {
            _this4.props.fetchImports();
            store.dispatch((0, _flash.flashMessage)({ header: t('Import Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Updating units', { ns: _translation.TRANSLATION_FILES.translation }), icon: 'checkmark', type: 'success', autoHideDuration: 10000 }));
          });
        });
      }).catch(function (err) {
        _this4.setLoading(false);
        if (err.res && err.res.status >= 400 && err.res.status < 500) {
          err.res.text().then(function (message) {
            store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
          });
          _this4.setState({ file: null });
          _this4.props.setUpdating(false);
          return;
        }
        store.dispatch((0, _flash.flashErrorMessage)(err));
      });
    }
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var store = this.context.store;

      store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.id + '/units/import/?' + (0, _url.encodeSearch)(query)));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Import units', { ns: _translation.TRANSLATION_FILES.translation })
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { textAlign: 'center' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                {
                  inverted: true, style: { zIndex: 20 },
                  active: this.state.loading
                },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                'form',
                {
                  encType: 'multipart/form-data',
                  onSubmit: this.handleSubmit,
                  ref: function ref(_ref2) {
                    _this5.form = _ref2;
                  },
                  style: { display: 'none' }
                },
                t('Select file to upload:', { ns: _translation.TRANSLATION_FILES.translation }),
                _react2.default.createElement('input', {
                  accept: '.xlsx',
                  id: 'import_upload',
                  name: 'import_upload',
                  onChange: this.handleOnChange,
                  ref: function ref(_ref) {
                    _this5.import_upload = _ref;
                  },
                  type: 'file'
                })
              ),
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel outline', size: 'massive', color: 'grey', style: { fontSize: '7em', opacity: '0.3' } }),
              _react2.default.createElement(
                _semanticUiReact.Header,
                { as: 'h2' },
                t('Bulk Import', { ns: _translation.TRANSLATION_FILES.translation }),
                _react2.default.createElement(
                  _semanticUiReact.Header.Subheader,
                  null,
                  t('Import unit listing using xlsx.', { ns: _translation.TRANSLATION_FILES.translation }),
                  _react2.default.createElement('br', null),
                  t('Download xlsx', { ns: _translation.TRANSLATION_FILES.translation }),
                  _react2.default.createElement(
                    'a',
                    {
                      href: _config2.default.get('bookApiURL') + '/projects/' + this.props.id + '/units/import_template/',
                      target: '_blank',
                      rel: 'noopener noreferrer'
                    },
                    '\xA0',
                    t('empty', { ns: _translation.TRANSLATION_FILES.translation }),
                    '\xA0'
                  ),
                  t('template or', { ns: _translation.TRANSLATION_FILES.translation }),
                  _react2.default.createElement(
                    'a',
                    {
                      href: this.props.appConfig && this.props.appConfig.data && this.props.appConfig.data.importUnitExcelExampleLink || '',
                      target: '_blank',
                      rel: 'noopener noreferrer'
                    },
                    '\xA0',
                    t('example', { ns: _translation.TRANSLATION_FILES.translation })
                  ),
                  '.'
                )
              ),
              this.state.file && this.state.file.name ? _react2.default.createElement(
                _semanticUiReact.Grid,
                { centered: true, padded: true },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { style: { padding: '0 0 0.5em' } },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { mobile: 14, tablet: 9, computer: 6, textAlign: 'left' },
                    _react2.default.createElement(
                      _semanticUiReact.Message,
                      {
                        className: 'import_file_selcted',
                        info: true,
                        onDismiss: this.handleDismiss,
                        size: 'tiny'
                      },
                      this.state.file.name
                    )
                  )
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  disabled: this.props.updating,
                  onClick: this.handleAddFile,
                  style: { marginBottom: '0.5em' }
                },
                t('Browse File', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  disabled: !this.state.file,
                  onClick: this.handleOnSubmit,
                  positive: true,
                  style: { display: 'block', margin: 'auto' }
                },
                t('Upload', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
              _react2.default.createElement(
                _semanticUiReact.Table,
                {
                  striped: true, unstackable: true,
                  selectable: true
                },
                _react2.default.createElement(
                  _semanticUiReact.Table.Header,
                  { fullWidth: true },
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      { colSpan: 3 },
                      _react2.default.createElement(
                        'h3',
                        null,
                        t('Imports History', { ns: _translation.TRANSLATION_FILES.translation })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      { colSpan: 2, textAlign: 'right' },
                      _react2.default.createElement(_PageNav2.default, {
                        currentPage: this.state.currentPage,
                        count: this.state.count,
                        limit: this.state.limit,
                        offset: this.state.offset,
                        dataSize: this.state.data.length,
                        loading: this.state.loading,
                        onChange: this.handleChangePage
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Name', { ns: _translation.TRANSLATION_FILES.constants })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Size', { ns: _translation.TRANSLATION_FILES.translation })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Imported By', { ns: _translation.TRANSLATION_FILES.translation })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Date', { ns: _translation.TRANSLATION_FILES.screens })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Status', { ns: _translation.TRANSLATION_FILES.translation })
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Body,
                  null,
                  this.state.data.length > 0 ? this.state.data.map(function (file, key) {
                    return _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      { key: key },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { width: 6 },
                        _react2.default.createElement(
                          'a',
                          {
                            href: _config2.default.get('bookApiURL') + '/data_imports/view/' + file.id + '/' + file.name,
                            target: '_blank',
                            rel: 'noopener noreferrer'
                          },
                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel outline' }),
                          file.name
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { collapsing: true },
                        (0, _fileSize2.default)(file.size)
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { collapsing: true },
                        file.userPreferredName
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { collapsing: true },
                        _react2.default.createElement(_Timestamp2.default, { format: 'MMMM Do YYYY, h:mm a', timestamp: file.createdAt })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { width: 4 },
                        _react2.default.createElement(
                          _semanticUiReact.Progress,
                          {
                            size: 'small',
                            percent: (0, _dataImport.progressToPercent)(file.updatedCount, file.totalCount),
                            progress: true,
                            color: file.statusID === 'in_progress' ? 'blue' : null,
                            success: file.statusID === 'completed',
                            active: file.statusID === 'in progress',
                            error: file.statusID === 'failed'
                          },
                          t((0, _valueToText2.default)(_dataImport.STATUSES, file.statusID), { ns: _translation.TRANSLATION_FILES.constants }),
                          file.statusID === 'failed' && file.remarks && _react2.default.createElement(_semanticUiReact.Popup, {
                            trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: '#912d2b' }),
                            content: file.remarks,
                            size: 'mini'
                          })
                        ),
                        _react2.default.createElement(_Timestamp2.default, { format: 'MMMM Do YYYY, h:mm a', timestamp: file.updatedAt })
                      )
                    );
                  }) : _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      { colSpan: 5, textAlign: 'center' },
                      t('No imports found.', { ns: _translation.TRANSLATION_FILES.translation })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Import;
}(_react.Component);

Import.propTypes = {
  token: _propTypes2.default.string,
  id: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    search: _propTypes2.default.string,
    query: _propTypes2.default.object
  }),
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      importUnitExcelTemplateLink: _propTypes2.default.string,
      importUnitExcelExampleLink: _propTypes2.default.string
    })
  }),
  fetchImports: _propTypes2.default.func,
  setUpdating: _propTypes2.default.func,
  updating: _propTypes2.default.bool,
  t: _propTypes2.default.func
};

Import.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig
  };
};

Import.contextTypes = {
  store: _propTypes2.default.object
};

Import.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var count = props.count;
  var currentPage = parseInt(query.page, 10) || 1;
  var data = props.data || [];
  var limit = props.limit;
  var loading = props.loading;
  var offset = props.offset;
  var token = props.token;
  var updating = props.updating;
  return {
    count: count,
    currentPage: currentPage,
    data: data,
    limit: limit,
    loading: loading,
    offset: offset,
    token: token,
    updating: updating
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.STATUSES = [{ text: 'Updating', value: 'in_progress' }, { text: 'Completed', value: 'completed' }, { text: 'Failed', value: 'failed' }];

  this.handleAddFile = function (e) {
    e.preventDefault();
    _this6.import_upload.click();
  };

  this.handleOnChange = function () {
    var files = Array.prototype.slice.call(_this6.import_upload.files);
    _this6.import_upload.value = null;
    if (window.FileReader) {
      files.forEach(function (file) {
        var reader = new FileReader();
        reader.onloadend = function () {
          _this6.setState({ file: file });
        };
        reader.readAsDataURL(file);
      });
    }
  };

  this.handleOnSubmit = function (e) {
    e.preventDefault();
    _this6.handleSubmit();
  };

  this.handleSubmit = function () {
    var formData = new FormData();
    formData.append('import_upload', _this6.state.file);
    _this6.submitFile(formData);
  };

  this.handleDismiss = function () {
    _this6.setState({ file: null });
  };

  this.handleChangePage = function (page) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
      query.page = 1;
    }
    var currentPage = parseInt(page || query.page, 10);
    query.page = currentPage;
    _this6.setState({ currentPage: currentPage });
    _this6.replaceQuery(query);
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Import.mapStateToProps)(Import));

/***/ }),
/* 2428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _url = __webpack_require__(19);

var _fileSize = __webpack_require__(85);

var _fileSize2 = _interopRequireDefault(_fileSize);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_momentTimezone2.default.locale('en-gb');

var ImportPricing = function (_Component) {
  _inherits(ImportPricing, _Component);

  function ImportPricing(props) {
    _classCallCheck(this, ImportPricing);

    var _this = _possibleConstructorReturn(this, (ImportPricing.__proto__ || Object.getPrototypeOf(ImportPricing)).call(this, props));

    _initialiseProps.call(_this);

    var state = ImportPricing.getPropsToState(props);
    _this.state = _extends({}, state, {
      file: null
    });
    return _this;
  }

  _createClass(ImportPricing, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = ImportPricing.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'submitFile',
    value: function submitFile(body) {
      var _this4 = this;

      var t = this.props.t;

      this.setLoading(true);
      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/units/import/package_pricings/', {
        credentials: 'include',
        method: 'POST',
        headers: {
          // Let browser decide Content-Type
          'X-Csrf-Token': this.props.token
        },
        body: body
      })).then(function (res) {
        _this4.setLoading(false);
        res.text().then(function (message) {
          var json = JSON.parse(message);
          _this4.setState({ file: null }, function () {
            _this4.props.fetchPricingImports();
            var totalCount = json.createCount + json.updateCount;
            store.dispatch((0, _flash.flashMessage)({ header: t('Import Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Pricing Packages Success', { ns: _translation.TRANSLATION_FILES.translation, totalCount: totalCount, createCount: json.createCount, updateCount: json.updateCount }), icon: 'checkmark', type: 'success', autoHideDuration: 10000 }));
          });
        });
      }).catch(function (err) {
        _this4.setLoading(false);
        if (err.res && err.res.status >= 400 && err.res.status < 500) {
          err.res.text().then(function (message) {
            store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
          });
          _this4.setState({ file: null });
          return;
        }
        store.dispatch((0, _flash.flashErrorMessage)(err));
      });
    }
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var store = this.context.store;

      store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.id + '/units/import_pricings/?' + (0, _url.encodeSearch)(query)));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Import pricings', { ns: _translation.TRANSLATION_FILES.translation })
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { textAlign: 'center' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                {
                  inverted: true, style: { zIndex: 20 },
                  active: this.state.loading
                },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                'form',
                {
                  encType: 'multipart/form-data',
                  onSubmit: this.handleSubmit,
                  ref: function ref(_ref2) {
                    _this5.form = _ref2;
                  },
                  style: { display: 'none' }
                },
                t('Select file to upload:', { ns: _translation.TRANSLATION_FILES.translation }),
                _react2.default.createElement('input', {
                  accept: '.xlsx',
                  id: 'import_upload',
                  name: 'import_upload',
                  onChange: this.handleOnChange,
                  ref: function ref(_ref) {
                    _this5.import_upload = _ref;
                  },
                  type: 'file'
                })
              ),
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel outline', size: 'massive', color: 'grey', style: { fontSize: '7em', opacity: '0.3' } }),
              _react2.default.createElement(
                _semanticUiReact.Header,
                { as: 'h2' },
                t('Import Pricing Packages', { ns: _translation.TRANSLATION_FILES.screens }),
                _react2.default.createElement(
                  _semanticUiReact.Header.Subheader,
                  null,
                  t('Import custom unit pricing packages using xlsx.', { ns: _translation.TRANSLATION_FILES.translation }),
                  _react2.default.createElement('br', null)
                )
              ),
              _react2.default.createElement(
                'b',
                null,
                t('Instructions', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(
                'div',
                { style: { textAlign: 'center' } },
                _react2.default.createElement(
                  'div',
                  { style: { display: 'inline-block', textAlign: 'left', padding: '0.5em 0 1em' } },
                  _react2.default.createElement(
                    _semanticUiReact.List,
                    { as: 'ol' },
                    _react2.default.createElement(
                      _semanticUiReact.List.Item,
                      { as: 'li' },
                      t('Export the current pricing packages excel from', { ns: _translation.TRANSLATION_FILES.translation }),
                      _react2.default.createElement(
                        'a',
                        {
                          href: _config2.default.get('bookApiURL') + '/projects/' + this.props.id + '/units/export/package_pricings/',
                          target: '_blank',
                          rel: 'noopener noreferrer'
                        },
                        '\xA0',
                        t('here', { ns: _translation.TRANSLATION_FILES.translation })
                      ),
                      '.'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.List.Item,
                      { as: 'li' },
                      t('Edit the xlsx file and make the appropriate changes.', { ns: _translation.TRANSLATION_FILES.translation })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.List.Item,
                      { as: 'li' },
                      t('Select the xlsx file and upload it back here.', { ns: _translation.TRANSLATION_FILES.translation })
                    )
                  )
                )
              ),
              this.state.file && this.state.file.name ? _react2.default.createElement(
                _semanticUiReact.Grid,
                { centered: true, padded: true },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { style: { padding: '0 0 0.5em' } },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { mobile: 14, tablet: 10, computer: 7, textAlign: 'left' },
                    _react2.default.createElement(
                      _semanticUiReact.Message,
                      {
                        className: 'import_file_selcted',
                        info: true,
                        onDismiss: this.handleDismiss,
                        size: 'tiny'
                      },
                      this.state.file.name
                    )
                  )
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  onClick: this.handleAddFile,
                  style: { marginBottom: '0.5em' }
                },
                t('Browse File', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  disabled: !this.state.file,
                  onClick: this.handleOnSubmit,
                  positive: true,
                  style: { display: 'block', margin: 'auto' }
                },
                t('Upload', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
              _react2.default.createElement(
                _semanticUiReact.Table,
                {
                  striped: true, unstackable: true,
                  selectable: true
                },
                _react2.default.createElement(
                  _semanticUiReact.Table.Header,
                  { fullWidth: true },
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      { colSpan: 2 },
                      _react2.default.createElement(
                        'h3',
                        null,
                        t('Imports History', { ns: _translation.TRANSLATION_FILES.translation })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      { colSpan: 2, textAlign: 'right' },
                      _react2.default.createElement(_PageNav2.default, {
                        currentPage: this.state.currentPage,
                        count: this.state.count,
                        limit: this.state.limit,
                        offset: this.state.offset,
                        dataSize: this.state.data.length,
                        loading: this.state.loading,
                        onChange: this.handleChangePage
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Name', { ns: _translation.TRANSLATION_FILES.constants })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Size', { ns: _translation.TRANSLATION_FILES.translation })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Imported By', { ns: _translation.TRANSLATION_FILES.translation })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Date', { ns: _translation.TRANSLATION_FILES.screens })
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Body,
                  null,
                  this.state.data.length > 0 ? this.state.data.map(function (file, key) {
                    return _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      { key: key },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { width: 7 },
                        _react2.default.createElement(
                          'a',
                          {
                            href: _config2.default.get('bookApiURL') + '/data_imports/view/' + file.id + '/' + file.name,
                            target: '_blank',
                            rel: 'noopener noreferrer'
                          },
                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel outline' }),
                          file.name
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { collapsing: true },
                        (0, _fileSize2.default)(file.size)
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { collapsing: true },
                        file.userPreferredName
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { collapsing: true },
                        _react2.default.createElement(_Timestamp2.default, { format: 'MMMM Do YYYY, h:mm a', timestamp: file.createdAt })
                      )
                    );
                  }) : _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      { colSpan: 4, textAlign: 'center' },
                      t('No imports found.', { ns: _translation.TRANSLATION_FILES.translation })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ImportPricing;
}(_react.Component);

ImportPricing.propTypes = {
  t: _propTypes2.default.func,
  token: _propTypes2.default.string,
  id: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    search: _propTypes2.default.string,
    query: _propTypes2.default.object
  }),
  fetchPricingImports: _propTypes2.default.func
};

ImportPricing.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig
  };
};

ImportPricing.contextTypes = {
  store: _propTypes2.default.object
};

ImportPricing.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var count = props.count;
  var currentPage = parseInt(query.page, 10) || 1;
  var data = props.data || [];
  var limit = props.limit;
  var loading = props.loading;
  var offset = props.offset;
  var token = props.token;
  return {
    count: count,
    currentPage: currentPage,
    data: data,
    limit: limit,
    loading: loading,
    offset: offset,
    token: token
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.handleAddFile = function (e) {
    e.preventDefault();
    _this6.import_upload.click();
  };

  this.handleOnChange = function () {
    var files = Array.prototype.slice.call(_this6.import_upload.files);
    _this6.import_upload.value = null;
    if (window.FileReader) {
      files.forEach(function (file) {
        var reader = new FileReader();
        reader.onloadend = function () {
          _this6.setState({ file: file });
        };
        reader.readAsDataURL(file);
      });
    }
  };

  this.handleOnSubmit = function (e) {
    e.preventDefault();
    _this6.handleSubmit();
  };

  this.handleSubmit = function () {
    var formData = new FormData();
    formData.append('import_upload', _this6.state.file);
    _this6.submitFile(formData);
  };

  this.handleDismiss = function () {
    _this6.setState({ file: null });
  };

  this.handleChangePage = function (page) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
      query.page = 1;
    }
    var currentPage = parseInt(page || query.page, 10);
    query.page = currentPage;
    _this6.setState({ currentPage: currentPage });
    _this6.replaceQuery(query);
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(ImportPricing.mapStateToProps)(ImportPricing));

/***/ }),
/* 2429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _reactRouterRedux = __webpack_require__(13);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _ProjectUnitsList = __webpack_require__(567);

var _ProjectUnitsList2 = _interopRequireDefault(_ProjectUnitsList);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _translation = __webpack_require__(4);

var _navigations = __webpack_require__(117);

var _vietnam = __webpack_require__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _initialiseProps.call(_this);

    var menuIsTab = window.innerWidth <= 590;
    _this.state = {
      menuIsTab: menuIsTab
    };
    return _this;
  }

  _createClass(List, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.redirectAgency(this.props);
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.redirectAgency(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var user = this.props.auth;
      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      if (this.props.auth.isBranchLeaderSupervisorII && this.props.project && this.props.project.maOwnerCompanyBranchID === user.companyBranch.id) {
        return true;
      }
      return check;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Do not mount the unit list (or start its requests) while redirecting a VN agency.
      if (!(0, _vietnam.showsProjectUnitsTab)(this.props.auth)) return null;
      var pathname = this.props.location.pathname;
      var _props = this.props,
          project = _props.project,
          auth = _props.auth,
          t = _props.t;

      var serviceCompanyID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
      var links = (0, _navigations.routes)(this.props.id, project, this.hasAccess(), this.props.auth.isSiteplan, this.props.auth).map(function (l) {
        return _extends({}, l, {
          text: t(l.text)
        });
      });
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          rightNav: this.hasAccess() ? _react2.default.createElement(
            _semanticUiReact.Dropdown,
            { item: true, text: t('Manage') },
            _react2.default.createElement(
              _semanticUiReact.Dropdown.Menu,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dropdown.Item,
                { onClick: this.handleManageClick, value: 'create/' },
                t('Create', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              this.hasAccess() && _react2.default.createElement(
                _semanticUiReact.Dropdown.Item,
                { onClick: this.handleManageClick, value: 'import/' },
                t('Import Units')
              ),
              this.hasAccess() && _react2.default.createElement(
                _semanticUiReact.Dropdown.Item,
                { onClick: this.handleManageClick, value: _config2.default.get('developerURL') && serviceCompanyID ? _config2.default.get('developerURL') + '/c/' + serviceCompanyID + '/projects/' + this.props.id + '/import/package_pricings' : 'import_pricings/' },
                t('Import Pricing Packages')
              ),
              this.hasAccess() && this.hasProjectHimsEnabled() && _react2.default.createElement(
                _semanticUiReact.Dropdown.Item,
                { onClick: this.handleManageClick, value: 'hims/' },
                t('HIMS Unit Sync')
              ),
              !this.state.menuIsTab && _react2.default.createElement(
                _semanticUiReact.Dropdown.Item,
                { onClick: this.handleManageClick, value: 'edit/' },
                t('Edit', { ns: _translation.TRANSLATION_FILES.translation })
              )
            )
          ) : null,
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: link.text,
              content: link.text,
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this2.handleMenu(e, link);
              }
            });
          })
        }),
        _react2.default.createElement(_ProjectUnitsList2.default, {
          toggleable: true,
          loading: this.props.loading,
          projectID: this.props.id,
          project: project,
          unitOnClick: this.handleUnitClick,
          hideNew: !this.hasAccess(),
          addPath: '/projects/' + this.props.id + '/units/create/'
        })
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};
List.propTypes = {
  id: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string
  }),
  project: _propTypes2.default.shape({
    projectPictures: _propTypes2.default.array,
    gps: _propTypes2.default.string,
    maOwnerCompanyBranchID: _propTypes2.default.number
  }),
  loading: _propTypes2.default.bool,
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isSiteplan: _propTypes2.default.bool,
    allowEditUnitPrice: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool,
    company: _propTypes2.default.object
  }),
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      himsIsEnabled: _propTypes2.default.bool
    })
  }),
  t: _propTypes2.default.func
};

List.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.redirectAgency = function (props) {
    if (!(0, _vietnam.showsProjectUnitsTab)(props.auth)) {
      _this3.context.store.dispatch((0, _reactRouterRedux.replace)('/projects/' + props.id + '/'));
    }
  };

  this.handleResize = function () {
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this3.state.menuIsTab) {
      _this3.setState({ menuIsTab: menuIsTab });
    }
  };

  this.handleMenu = function (e, _ref) {
    var value = _ref.value;
    var store = _this3.context.store;

    if (value.includes(_config2.default.get('bookApiURL')) || value.includes(_config2.default.get('salesChartURL'))) {
      e.preventDefault();
      var winObj = window.open(value, '_blank');
      winObj.opener = null;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(value));
    }
  };

  this.handleUnitClick = function (e, _ref2) {
    var unit = _ref2.unit;
    var store = _this3.context.store;

    store.dispatch((0, _reactRouterRedux.push)('/projects/' + _this3.props.id + '/units/' + unit.id + '/'));
  };

  this.handleManageClick = function (e, data) {
    e.preventDefault();
    var store = _this3.context.store;

    if (data.value.includes(_config2.default.get('developerURL'))) {
      window.location.href = data.value;
    } else {
      store.dispatch((0, _reactRouterRedux.push)('/projects/' + _this3.props.id + '/units/' + data.value));
    }
  };

  this.hasProjectHimsEnabled = function () {
    var _props2 = _this3.props,
        appConfig = _props2.appConfig,
        project = _props2.project;

    var companyHimsIsEnabled = appConfig && appConfig.data && appConfig.data.himsIsEnabled;
    return companyHimsIsEnabled && project && project.himsIsEnabled;
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(List.mapStateToProps)(List));

/***/ }),
/* 2430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1062);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /*  eslint no-param-reassign: ["error", { "props": false }]*/

var New = function (_Component) {
  _inherits(New, _Component);

  function New(props) {
    _classCallCheck(this, New);

    var _this = _possibleConstructorReturn(this, (New.__proto__ || Object.getPrototypeOf(New)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments[1];

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges, callback);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(New, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, unit) {
        var _this2 = this;

        var store, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 5;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 5:
                res = void 0;
                _context.prev = 6;
                _context.next = 9;
                return this.form.submit('/projects/' + this.props.id + '/units/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(unit)
                });

              case 9:
                res = _context.sent;
                _context.next = 22;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 20;
                  break;
                }

                _context.next = 17;
                return _context.t0.res.text();

              case 17:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 20:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 22:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false, function (noChanges) {
                    if (noChanges) {
                      store.dispatch((0, _reactRouterRedux.goBack)());
                      store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Create Success', message: res.reference + ' successfully created' }));
                    }
                  });
                });

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('newUnit', { ns: _translation.TRANSLATION_FILES.screens }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Create', { ns: _translation.TRANSLATION_FILES.screens }),
              onClick: this.handleSubmit
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          id: this.props.id,
          project: this.props.project,
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, unit) {
            _this3.submit(validations, unit);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading,
          location: this.props.location
        })
      );
    }
  }]);

  return New;
}(_react.Component);

New.propTypes = {
  token: _propTypes2.default.string,
  id: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object
  }),
  onCheck: _propTypes2.default.func,
  project: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
New.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(New);

/***/ }),
/* 2431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _checkChanges = __webpack_require__(61);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _promptMessages = __webpack_require__(43);

var _List = __webpack_require__(2429);

var _List2 = _interopRequireDefault(_List);

var _New = __webpack_require__(2430);

var _New2 = _interopRequireDefault(_New);

var _Import = __webpack_require__(2427);

var _Import2 = _interopRequireDefault(_Import);

var _ImportPricing = __webpack_require__(2428);

var _ImportPricing2 = _interopRequireDefault(_ImportPricing);

var _UnitsCompare = __webpack_require__(2432);

var _UnitsCompare2 = _interopRequireDefault(_UnitsCompare);

var _HIMSUnitSync = __webpack_require__(2425);

var _HIMSUnitSync2 = _interopRequireDefault(_HIMSUnitSync);

__webpack_require__(3503);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Project = function (_Component) {
  _inherits(Project, _Component);

  function Project(props) {
    _classCallCheck(this, Project);

    var _this = _possibleConstructorReturn(this, (Project.__proto__ || Object.getPrototypeOf(Project)).call(this, props));

    _this.setUpdating = function (update) {
      _this.setState({ updating: update });
    };

    _this.forceFetchImports = function () {
      _this.fetchImports();
    };

    _this.forceFetchPricingImports = function () {
      _this.fetchPricingImports();
    };

    _this.state = {
      count: 0,
      data: [],
      limit: 10,
      offset: 0,
      token: null,
      loading: true,
      updating: false
    };
    return _this;
  }

  _createClass(Project, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var query = (0, _url.decodeSearch)(this.props.location.search);
      if (this.props.location.pathname.includes('/create/')) {
        this.fetchProjectUnits();
      } else if (this.props.location.pathname.includes('/import/')) {
        this.fetchProjectUnits();
        this.fetchImports(query);
        this.ticker = setInterval(function () {
          if (_this2.state.updating) {
            _this2.fetchImports();
          }
        }, 2000);
      } else if (this.props.location.pathname.includes('/import_pricings/')) {
        this.fetchProjectUnits();
        this.fetchPricingImports(query);
      } else {
        this.setLoading(false);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var pathname = nextProps.location.pathname;

      var query = (0, _url.decodeSearch)(nextProps.location.search);
      if (pathname.includes('/create/')) {
        this.fetchProjectUnits();
      } else if (pathname.includes('/import/')) {
        this.fetchProjectUnits();
        this.fetchImports(query);
      } else if (pathname.includes('/import_pricings/')) {
        this.fetchProjectUnits();
        this.fetchPricingImports(query);
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchProjectUnits',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var store, query, res, message, token;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = Object.assign({
                  page: 1,
                  limit: 50
                }, q);
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.params.id + '/units/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 19;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 16:
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context.next = 30;
                break;

              case 27:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context.next = 30;
                return this.setComponentState({
                  token: token
                });

              case 30:
                _context.next = 32;
                return this.setLoading(false);

              case 32:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchProjectUnits() {
        return _ref.apply(this, arguments);
      }

      return fetchProjectUnits;
    }()
  }, {
    key: 'fetchImports',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(q) {
        var store, query, res, message, count, limit, offset, data, isUpdating;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                query.projectID = this.props.params.id;
                res = void 0;
                _context2.prev = 7;
                _context2.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/data_imports/units/?' + (0, _url.encodeSearch)(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 10:
                res = _context2.sent;
                _context2.next = 21;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](7);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 18:
                _context2.next = 20;
                return this.setLoading(false);

              case 20:
                return _context2.abrupt('return');

              case 21:
                if (res.ok) {
                  _context2.next = 29;
                  break;
                }

                _context2.next = 24;
                return res.text();

              case 24:
                message = _context2.sent;
                _context2.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 27:
                _context2.next = 40;
                break;

              case 29:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context2.next = 34;
                return res.json();

              case 34:
                data = _context2.sent;
                isUpdating = this.state.updating;

                if (data && data[0]) {
                  if (!isUpdating && data[0].statusID === 'in_progress') isUpdating = true;
                  if (data[0].statusID === 'completed' || data[0].statusID === 'failed') isUpdating = false;
                }
                if (this.state.data && this.state.data.length < 1 && query.page > 1) {
                  query.page = 1;
                  store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.params.id + '/units/import/?' + (0, _url.encodeSearch)(query)));
                }
                // handle token.. etc
                _context2.next = 40;
                return this.setComponentState({
                  count: count,
                  data: data,
                  limit: limit,
                  offset: offset,
                  updating: isUpdating
                });

              case 40:
                _context2.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 13]]);
      }));

      function fetchImports(_x4) {
        return _ref2.apply(this, arguments);
      }

      return fetchImports;
    }()
  }, {
    key: 'fetchPricingImports',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(q) {
        var store, query, res, message, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                query.projectID = this.props.params.id;
                res = void 0;
                _context3.prev = 7;
                _context3.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/data_imports/pricings/?' + (0, _url.encodeSearch)(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 10:
                res = _context3.sent;
                _context3.next = 21;
                break;

              case 13:
                _context3.prev = 13;
                _context3.t0 = _context3['catch'](7);

                Bugsnag.notifyException(_context3.t0);
                _context3.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 18:
                _context3.next = 20;
                return this.setLoading(false);

              case 20:
                return _context3.abrupt('return');

              case 21:
                if (res.ok) {
                  _context3.next = 29;
                  break;
                }

                _context3.next = 24;
                return res.text();

              case 24:
                message = _context3.sent;
                _context3.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 27:
                _context3.next = 38;
                break;

              case 29:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context3.next = 34;
                return res.json();

              case 34:
                data = _context3.sent;

                if (this.state.data && this.state.data.length < 1 && query.page > 1) {
                  query.page = 1;
                  store.dispatch((0, _reactRouterRedux.replace)('/projects/' + this.props.params.id + '/units/import/?' + (0, _url.encodeSearch)(query)));
                }
                // handle token.. etc
                _context3.next = 38;
                return this.setComponentState({
                  count: count,
                  data: data,
                  limit: limit,
                  offset: offset
                });

              case 38:
                _context3.next = 40;
                return this.setLoading(false);

              case 40:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[7, 13]]);
      }));

      function fetchPricingImports(_x5) {
        return _ref3.apply(this, arguments);
      }

      return fetchPricingImports;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this5 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          count: _this5.state.count,
          data: _this5.state.data,
          limit: _this5.state.limit,
          offset: _this5.state.offset,
          token: _this5.state.token,
          loading: _this5.state.loading,
          id: _this5.props.params.id,
          unitID: _this5.props.params.unitID,
          location: _this5.props.location,
          project: _this5.props.data,
          fetchImports: _this5.forceFetchImports,
          fetchPricingImports: _this5.forceFetchPricingImports,
          setUpdating: _this5.setUpdating,
          updating: _this5.state.updating
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Project;
}(_react.Component);

Project.propTypes = {
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    unitID: _propTypes2.default.string
  }),
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    search: _propTypes2.default.string,
    query: _propTypes2.default.object
  })
};
Project.contextTypes = {
  store: _propTypes2.default.object
};
Project.List = _List2.default;
Project.Import = (0, _checkChanges.checkChanges)(_Import2.default, { message: _promptMessages.NEW_IMPORT_PROMPT });
Project.ImportPricing = (0, _checkChanges.checkChanges)(_ImportPricing2.default, { message: _promptMessages.NEW_IMPORT_PROMPT });
Project.New = (0, _checkChanges.checkChanges)(_New2.default, { message: _promptMessages.NEW_PROJECT_UNIT_PROMPT });
Project.UnitsCompare = _UnitsCompare2.default;
Project.HIMSUnitSync = _HIMSUnitSync2.default;
exports.default = Project;

/***/ }),
/* 2432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _url = __webpack_require__(19);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

var _translation2 = __webpack_require__(64);

var _areaLabel = __webpack_require__(223);

var _countries = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-nested-ternary */


var UnitsCompare = function (_Component) {
  _inherits(UnitsCompare, _Component);

  function UnitsCompare(props) {
    _classCallCheck(this, UnitsCompare);

    var _this = _possibleConstructorReturn(this, (UnitsCompare.__proto__ || Object.getPrototypeOf(UnitsCompare)).call(this, props));

    _initialiseProps.call(_this);

    var state = UnitsCompare.getPropsToState(props);
    _this.state = _extends({}, state, {
      selectedUnit: {}
    });
    return _this;
  }

  _createClass(UnitsCompare, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
      this.fetchDetailedBulkProjectUnits();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = UnitsCompare.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchDetailedBulkProjectUnits',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/units/detailed/?statusID=new', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                return _context.abrupt('return');

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 30;
                break;

              case 26:
                _context.next = 28;
                return res.json();

              case 28:
                data = _context.sent;

                if (data) {
                  this.setState({ projectUnits: data });
                  this.setInitialUnitID();
                }

              case 30:
                _context.next = 32;
                return this.setLoading(false);

              case 32:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchDetailedBulkProjectUnits() {
        return _ref.apply(this, arguments);
      }

      return fetchDetailedBulkProjectUnits;
    }()
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;
      var _state = this.state,
          projectUnits = _state.projectUnits,
          isMobile = _state.isMobile;
      var project = this.props.project;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, null),
        projectUnits ? _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { columns: 2 },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              {
                centered: true,
                columns: isMobile ? 2 : projectUnits ? projectUnits.length >= 3 ? 3 : 2 : null,
                className: 'compare_header'
              },
              _react2.default.createElement(
                'h4',
                null,
                t('Compare Units', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              project ? _react2.default.createElement(
                'p',
                null,
                project.name
              ) : ''
            ),
            this.renderDropdown()
          ),
          this.renderContent()
        ) : _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { className: 'noUnitCompare' },
            _react2.default.createElement(
              'p',
              null,
              t('No unit available', { ns: _translation.TRANSLATION_FILES.translation })
            )
          )
        )
      );
    }
  }]);

  return UnitsCompare;
}(_react.Component);

UnitsCompare.contextTypes = {
  store: _propTypes2.default.object
};
UnitsCompare.propTypes = {
  id: _propTypes2.default.string,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string
  }),
  project: _propTypes2.default.shape({
    projectPictures: _propTypes2.default.array,
    gps: _propTypes2.default.string,
    maOwnerCompanyBranchID: _propTypes2.default.number
  }),
  loading: _propTypes2.default.bool,
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isSiteplan: _propTypes2.default.bool,
    allowEditUnitPrice: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool
  }),
  t: _propTypes2.default.func
};

UnitsCompare.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

UnitsCompare.getPropsToState = function (props) {
  var loading = props.loading;
  var isMobile = window.innerWidth < 768;
  var isMediumScreen = window.innerWidth <= 990 && window.innerWidth >= 767;
  var limit = props.limit;
  var query = (0, _url.decodeSearch)(props.location.search);
  return {
    isMobile: isMobile,
    isMediumScreen: isMediumScreen,
    loading: loading,
    limit: limit,
    query: query
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.setInitialUnitID = function () {
    var projectUnits = _this3.state.projectUnits;
    // set initial selected unit id

    if (_this3.state && projectUnits) {
      var selectedUnit = {};

      projectUnits.map(function (unit, idx) {
        var result = _defineProperty({}, 'selectUnit' + (idx + 1), unit.id);
        Object.assign(selectedUnit, result);
      });
      _this3.setState({
        selectedUnit: _extends({}, selectedUnit)
      });
    }
  };

  this.getOptionData = function (data) {
    if (data) {
      var DpOptions = data.map(function (unit) {
        return {
          text: unit.reference,
          value: unit.id
        };
      });
      return DpOptions;
    }
    return null;
  };

  this.handleResize = function () {
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    var isMediumScreen = window.innerWidth <= 990 && window.innerWidth >= 767;
    if (isMobile !== _this3.state.isMobile) {
      _this3.setState({ isMobile: isMobile });
    }
    if (isMediumScreen !== _this3.state.isMediumScreen) {
      _this3.setState({ isMediumScreen: isMediumScreen });
    }
  };

  this.handleOnChange = function (event, _ref2) {
    var value = _ref2.value,
        name = _ref2.name;
    var selectedUnit = _this3.state.selectedUnit;

    selectedUnit[name] = value;
    _this3.setState({ selectedUnit: selectedUnit });
  };

  this.renderDropdown = function () {
    var t = _this3.props.t;
    var _state2 = _this3.state,
        projectUnits = _state2.projectUnits,
        selectedUnit = _state2.selectedUnit,
        isMobile = _state2.isMobile;

    if (projectUnits) {
      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        {
          centered: true,
          columns: isMobile ? 2 : projectUnits.length >= 3 ? 3 : 2
        },
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          _react2.default.createElement(_semanticUiReact.Dropdown, {
            placeholder: t('Select Unit', { ns: _translation.TRANSLATION_FILES.screens }),
            name: 'selectUnit1',
            fluid: true,
            selection: true,
            value: _typeof(selectedUnit.selectUnit1) === 'object' ? selectedUnit.selectUnit1.id : selectedUnit.selectUnit1,
            options: _this3.getOptionData(projectUnits),
            onChange: function onChange(event, value) {
              return _this3.handleOnChange(event, value);
            }
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          _react2.default.createElement(_semanticUiReact.Dropdown, {
            placeholder: t('Select Unit', { ns: _translation.TRANSLATION_FILES.translation }),
            name: 'selectUnit2',
            fluid: true,
            selection: true,
            value: _typeof(selectedUnit.selectUnit2) === 'object' ? selectedUnit.selectUnit2.id : selectedUnit.selectUnit2,
            options: _this3.getOptionData(projectUnits),
            onChange: function onChange(event, value) {
              return _this3.handleOnChange(event, value);
            }
          })
        ),
        projectUnits.length >= 3 && !isMobile && _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { only: 'computer' },
          _react2.default.createElement(_semanticUiReact.Dropdown, {
            placeholder: t('Select Unit', { ns: _translation.TRANSLATION_FILES.translation }),
            name: 'selectUnit3',
            fluid: true,
            selection: true,
            value: _typeof(selectedUnit.selectUnit3) === 'object' ? selectedUnit.selectUnit3.id : selectedUnit.selectUnit3,
            options: _this3.getOptionData(projectUnits),
            onChange: function onChange(event, value) {
              return _this3.handleOnChange(event, value);
            }
          })
        )
      );
    }
    return null;
  };

  this.renderContent = function () {
    var t = _this3.props.t;
    var _state3 = _this3.state,
        projectUnits = _state3.projectUnits,
        selectedUnit = _state3.selectedUnit,
        isMobile = _state3.isMobile,
        isMediumScreen = _state3.isMediumScreen;

    Object.keys(selectedUnit).forEach(function (key) {
      projectUnits.filter(function (unit) {
        if (unit.id === selectedUnit[key]) {
          selectedUnit[key] = unit;
          return unit;
        }
        return null;
      });
    });
    var selectUnit1 = selectedUnit.selectUnit1,
        selectUnit2 = selectedUnit.selectUnit2,
        selectUnit3 = selectedUnit.selectUnit3;
    // check layout spec has bed field

    var checkLayout1Bed = selectUnit1 && selectUnit1.projectUnitLayout.specifications ? selectUnit1.projectUnitLayout.specifications.some(function (spec) {
      return spec.shortName === 'Bed';
    }) : '';
    var checkLayout2Bed = selectUnit2 && selectUnit2.projectUnitLayout.specifications ? selectUnit2.projectUnitLayout.specifications.some(function (spec) {
      return spec.shortName === 'Bed';
    }) : '';
    var checkLayout3Bed = selectUnit3 && selectUnit3.projectUnitLayout.specifications ? selectUnit3.projectUnitLayout.specifications.some(function (spec) {
      return spec.shortName === 'Bed';
    }) : '';

    // check layout spec has bath field
    var checkLayout1Bath = selectUnit1 && selectUnit1.projectUnitLayout.specifications ? selectUnit1.projectUnitLayout.specifications.some(function (spec) {
      return spec.shortName === 'Bath';
    }) : '';
    var checkLayout2Bath = selectUnit2 && selectUnit2.projectUnitLayout.specifications ? selectUnit2.projectUnitLayout.specifications.some(function (spec) {
      return spec.shortName === 'Bath';
    }) : '';
    var checkLayout3Bath = selectUnit3 && selectUnit3.projectUnitLayout.specifications ? selectUnit3.projectUnitLayout.specifications.some(function (spec) {
      return spec.shortName === 'Bath';
    }) : '';

    // check layout spec bed amount
    var checkLayout1BedAmount = selectUnit1 && selectUnit1.projectUnitLayout.specifications ? selectUnit1.projectUnitLayout.specifications.filter(function (spec) {
      return spec.shortName === 'Bed';
    }).length : '';
    var checkLayout2BedAmount = selectUnit2 && selectUnit2.projectUnitLayout.specifications ? selectUnit2.projectUnitLayout.specifications.filter(function (spec) {
      return spec.shortName === 'Bed';
    }).length : '';
    var checkLayout3BedAmount = selectUnit3 && selectUnit3.projectUnitLayout.specifications ? selectUnit3.projectUnitLayout.specifications.filter(function (spec) {
      return spec.shortName === 'Bed';
    }).length : '';

    // check layout spec bath amount
    var checkLayout1BathAmount = selectUnit1 && selectUnit1.projectUnitLayout.specifications ? selectUnit1.projectUnitLayout.specifications.filter(function (spec) {
      return spec.shortName === 'Bath';
    }).length : '';
    var checkLayout2BathAmount = selectUnit2 && selectUnit2.projectUnitLayout.specifications ? selectUnit2.projectUnitLayout.specifications.filter(function (spec) {
      return spec.shortName === 'Bath';
    }).length : '';
    var checkLayout3BathAmount = selectUnit3 && selectUnit3.projectUnitLayout.specifications ? selectUnit3.projectUnitLayout.specifications.filter(function (spec) {
      return spec.shortName === 'Bath';
    }).length : '';

    if (projectUnits && selectedUnit) {
      return _react2.default.createElement(
        _semanticUiReact.Grid,
        { centered: true, columns: 2, className: 'compare_content' },
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          {
            centered: true,
            columns: isMobile ? 2 : projectUnits.length >= 3 ? isMediumScreen ? 2 : 3 : 2
          },
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            selectUnit1 ? _react2.default.createElement(_LoadImage2.default, {
              fluid: true,
              cover: 'vertical long',
              centered: true,
              notFoundNode: _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  t('No cover picture found'),
                  '.'
                ),
                _react2.default.createElement(_semanticUiReact.Button, {
                  as: _reactRouter.Link,
                  primary: true, compact: true,
                  to: '/projects/' + _this3.props.id + '/layouts/' + selectUnit1.projectUnitLayoutID + '/pictures/',
                  content: t('Click here to add')
                })
              ),
              picture: selectUnit1.projectUnitLayout.pictures ? selectUnit1.projectUnitLayout.pictures.find(function (pic) {
                if (pic.type === 'unit_layout') {
                  return pic.key;
                }
                return null;
              }) : null,
              pictureSize: 100
            }) : null
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            selectUnit2 ? _react2.default.createElement(_LoadImage2.default, {
              fluid: true,
              cover: 'vertical long',
              centered: true,
              notFoundNode: _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  t('No cover picture found'),
                  '.'
                ),
                _react2.default.createElement(_semanticUiReact.Button, {
                  as: _reactRouter.Link,
                  primary: true, compact: true,
                  to: '/projects/' + _this3.props.id + '/layouts/' + selectUnit2.projectUnitLayoutID + '/pictures/',
                  content: t('Click here to add')
                })
              ),
              picture: selectUnit2.projectUnitLayout.pictures ? selectUnit2.projectUnitLayout.pictures.find(function (pic) {
                if (pic.type === 'unit_layout') {
                  return pic.key;
                }
                return null;
              }) : null,
              pictureSize: 100
            }) : null
          ),
          projectUnits.length >= 3 && !isMobile && _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { only: 'computer' },
            selectUnit3 ? _react2.default.createElement(_LoadImage2.default, {
              fluid: true,
              centered: true,
              cover: 'vertical long',
              notFoundNode: _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  t('No cover picture found'),
                  '.'
                ),
                _react2.default.createElement(_semanticUiReact.Button, {
                  as: _reactRouter.Link,
                  primary: true, compact: true,
                  to: '/projects/' + _this3.props.id + '/layouts/' + selectUnit3.projectUnitLayoutID + '/pictures/',
                  content: t('Click here to add')
                })
              ),
              picture: selectUnit3.projectUnitLayout.pictures ? selectUnit3.projectUnitLayout.pictures.find(function (pic) {
                if (pic.type === 'unit_layout') {
                  return pic.key;
                }
                return null;
              }) : null,
              pictureSize: 100
            }) : null
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Row,
          {
            centered: true,
            columns: isMobile ? 2 : projectUnits.length >= 3 ? isMediumScreen ? 2 : 3 : 2,
            className: 'sizeRow'
          },
          _react2.default.createElement(
            _semanticUiReact.Divider,
            { horizontal: true },
            t('Layout Specifications')
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            selectUnit1 && selectUnit1.projectUnitLayout ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h1',
                null,
                selectUnit1.projectUnitLayout.name || ''
              ),
              _react2.default.createElement(
                'small',
                null,
                t('Layout Type')
              )
            ) : _react2.default.createElement(
              'p',
              { className: 'noValue' },
              t('No layout type available', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            selectUnit2 && selectUnit2.projectUnitLayout ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'h1',
                null,
                selectUnit2.projectUnitLayout.name || ''
              ),
              _react2.default.createElement(
                'small',
                null,
                t('Layout Type')
              )
            ) : _react2.default.createElement(
              'p',
              { className: 'noValue' },
              t('No layout type available', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          projectUnits.length >= 3 && !isMobile ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { only: 'computer' },
            selectUnit3 && selectUnit3.projectUnitLayout ? _react2.default.createElement(
              'div',
              { className: 'sizeRow' },
              _react2.default.createElement(
                'h1',
                null,
                selectUnit3.projectUnitLayout.name || ''
              ),
              _react2.default.createElement(
                'small',
                null,
                t('Layout Type')
              )
            ) : _react2.default.createElement(
              'p',
              { className: 'noValue' },
              t('No layout type available', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ) : null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            selectUnit1 && selectUnit1.projectUnitLayout && selectUnit1.projectUnitLayout.specifications && checkLayout1Bed ? selectUnit1.projectUnitLayout.specifications.map(function (spec, idx) {
              return spec.name.toLowerCase() === 'bedrooms' ? _react2.default.createElement(
                'div',
                { className: 'specColumns', key: idx },
                _react2.default.createElement(
                  'h1',
                  null,
                  spec.value || '0'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('Bedroom')
                ),
                _react2.default.createElement('br', null)
              ) : null;
            }) : _react2.default.createElement(
              'p',
              { className: 'noSpecAvailable' },
              t('No bedrooms available', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            selectUnit2 && selectUnit2.projectUnitLayout && selectUnit2.projectUnitLayout.specifications && checkLayout2Bed ? selectUnit2.projectUnitLayout.specifications.map(function (spec, idx) {
              return spec.name.toLowerCase() === 'bedrooms' ? _react2.default.createElement(
                'div',
                { className: 'specColumns', key: idx },
                _react2.default.createElement(
                  'h1',
                  null,
                  spec.value || '0'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('Bedroom')
                ),
                _react2.default.createElement('br', null)
              ) : null;
            }) : _react2.default.createElement(
              'p',
              { className: 'noSpecAvailable' },
              t('No bedrooms available', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          projectUnits.length >= 3 && !isMobile ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { only: 'computer' },
            selectUnit3 && selectUnit3.projectUnitLayout && selectUnit3.projectUnitLayout.specifications && checkLayout3Bed ? selectUnit3.projectUnitLayout.specifications.map(function (spec, idx) {
              return spec.name.toLowerCase() === 'bedrooms' ? _react2.default.createElement(
                'div',
                { className: 'specColumns', key: idx },
                _react2.default.createElement(
                  'h1',
                  null,
                  spec.value || '0'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('Bedroom')
                ),
                _react2.default.createElement('br', null)
              ) : null;
            }) : _react2.default.createElement(
              'p',
              { className: 'noSpecAvailable' },
              t('No bedrooms available', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ) : null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            selectUnit1 && selectUnit1.projectUnitLayout && selectUnit1.projectUnitLayout.specifications && checkLayout1Bath ? selectUnit1.projectUnitLayout.specifications.map(function (spec, idx) {
              return spec.name.toLowerCase() === 'bathrooms' ? _react2.default.createElement(
                'div',
                { className: 'specColumns', key: idx },
                _react2.default.createElement(
                  'h1',
                  null,
                  spec.value || '0'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('Bathroom')
                ),
                _react2.default.createElement('br', null)
              ) : null;
            }) : _react2.default.createElement(
              'p',
              { className: 'noSpecAvailable' },
              t('No bathrooms available', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            selectUnit2 && selectUnit2.projectUnitLayout && selectUnit2.projectUnitLayout.specifications && checkLayout2Bath ? selectUnit2.projectUnitLayout.specifications.map(function (spec, idx) {
              return spec.name.toLowerCase() === 'bathrooms' ? _react2.default.createElement(
                'div',
                { className: 'specColumns', key: idx },
                _react2.default.createElement(
                  'h1',
                  null,
                  spec.value || '0'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('Bathroom')
                ),
                _react2.default.createElement('br', null)
              ) : null;
            }) : _react2.default.createElement(
              'p',
              { className: 'noSpecAvailable' },
              t('No bathrooms available', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          projectUnits.length >= 3 && !isMobile ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            { only: 'computer' },
            selectUnit3 && selectUnit3.projectUnitLayout && selectUnit3.projectUnitLayout.specifications && checkLayout3Bath ? selectUnit3.projectUnitLayout.specifications.map(function (spec, idx) {
              return spec.name.toLowerCase() === 'bathrooms' ? _react2.default.createElement(
                'div',
                { className: 'specColumns', key: idx },
                _react2.default.createElement(
                  'h1',
                  null,
                  spec.value || '0'
                ),
                _react2.default.createElement(
                  'p',
                  null,
                  t('Bathroom')
                ),
                _react2.default.createElement('br', null)
              ) : null;
            }) : _react2.default.createElement(
              'p',
              { className: 'noSpecAvailable' },
              t('No bathrooms available', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ) : null
        ),
        _this3.renderBasicUnitInfo(),
        _this3.renderPrice(),
        _this3.renderPricingPackage(),
        _this3.renderUnitSpec()
      );
    }
    return null;
  };

  this.renderBasicUnitInfo = function () {
    var t = _this3.props.t;
    var project = _this3.props.project;
    var _state4 = _this3.state,
        projectUnits = _state4.projectUnits,
        selectedUnit = _state4.selectedUnit,
        isMobile = _state4.isMobile,
        isMediumScreen = _state4.isMediumScreen;

    var countryCode = _this3.props.auth && _this3.props.auth.company && _this3.props.auth.company.countryCode;
    var isVietnam = (0, _countries.isCountryVietnam)(countryCode);
    var selectUnit1 = selectedUnit.selectUnit1,
        selectUnit2 = selectedUnit.selectUnit2,
        selectUnit3 = selectedUnit.selectUnit3;


    if (projectUnits && selectedUnit && project) {
      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        {
          centered: true,
          columns: isMobile ? 2 : projectUnits.length >= 3 ? isMediumScreen ? 2 : 3 : 2,
          className: 'basicInfo'
        },
        _react2.default.createElement(
          _semanticUiReact.Divider,
          { horizontal: true },
          t('Basic Unit Info', { ns: _translation.TRANSLATION_FILES.translation })
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit1 && selectUnit1.size ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              selectUnit1.size || 0,
              project.sizeSuffix === 'square_feet' ? _react2.default.createElement(
                'small',
                null,
                t('sqft', { ns: _translation.TRANSLATION_FILES.screens })
              ) : project.sizeSuffix === 'square_metres' ? _react2.default.createElement(
                'small',
                null,
                isVietnam ? 'm²' : t('sqm', { ns: _translation.TRANSLATION_FILES.screens })
              ) : ''
            ),
            _react2.default.createElement(
              'small',
              null,
              (0, _areaLabel.getAreaLabel)(t, countryCode)
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            (0, _areaLabel.getMissingAreaLabel)(t, countryCode)
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit2 && selectUnit2.size ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              selectUnit2.size || 0,
              project.sizeSuffix === 'square_feet' ? _react2.default.createElement(
                'small',
                null,
                t('sqft', { ns: _translation.TRANSLATION_FILES.screens })
              ) : project.sizeSuffix === 'square_metres' ? _react2.default.createElement(
                'small',
                null,
                isVietnam ? 'm²' : t('sqm', { ns: _translation.TRANSLATION_FILES.screens })
              ) : ''
            ),
            _react2.default.createElement(
              'small',
              null,
              (0, _areaLabel.getAreaLabel)(t, countryCode)
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            (0, _areaLabel.getMissingAreaLabel)(t, countryCode)
          )
        ),
        projectUnits.length >= 3 && !isMobile ? _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { only: 'computer' },
          selectUnit3 && selectUnit3.size ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              selectUnit3.size || 0,
              project.sizeSuffix === 'square_feet' ? _react2.default.createElement(
                'small',
                null,
                t('sqft', { ns: _translation.TRANSLATION_FILES.screens })
              ) : project.sizeSuffix === 'square_metres' ? _react2.default.createElement(
                'small',
                null,
                isVietnam ? 'm²' : t('sqm', { ns: _translation.TRANSLATION_FILES.screens })
              ) : ''
            ),
            _react2.default.createElement(
              'small',
              null,
              (0, _areaLabel.getAreaLabel)(t, countryCode)
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            (0, _areaLabel.getMissingAreaLabel)(t, countryCode)
          )
        ) : null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit1 && selectUnit1.landArea ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              selectUnit1.landArea || 0
            ),
            _react2.default.createElement(
              'small',
              null,
              t('landArea', 'projectUnitLayout')
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No land area available', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit2 && selectUnit2.landArea ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              selectUnit2.landArea || 0
            ),
            _react2.default.createElement(
              'small',
              null,
              (0, _translation2.translateModels)(t, 'landArea', 'projectUnitLayout')
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No land area available', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        projectUnits.length >= 3 && !isMobile ? _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { only: 'computer' },
          selectUnit3 && selectUnit3.landArea ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              selectUnit3.landArea || 0
            ),
            _react2.default.createElement(
              'small',
              null,
              (0, _translation2.translateModels)(t, 'landArea', 'projectUnitLayout')
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No land area available', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ) : null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit1 ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              selectUnit1.isBumi || 'No'
            ),
            _react2.default.createElement(
              'small',
              null,
              'Bumi'
            )
          ) : ''
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit2 ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              selectUnit2.isBumi || 'No'
            ),
            _react2.default.createElement(
              'small',
              null,
              'Bumi'
            )
          ) : ''
        ),
        projectUnits.length >= 3 && !isMobile ? _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { only: 'computer' },
          selectUnit3 ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              selectUnit3.isBumi || 'No'
            ),
            _react2.default.createElement(
              'small',
              null,
              'Bumi'
            )
          ) : ''
        ) : null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit1 && selectUnit1.zoneOrBlock ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              selectUnit1.zoneOrBlock || ''
            ),
            _react2.default.createElement(
              'small',
              null,
              t('Block')
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No block available', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit2 && selectUnit2.zoneOrBlock ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              selectUnit2.zoneOrBlock || ''
            ),
            _react2.default.createElement(
              'small',
              null,
              t('Block')
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No block available', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        projectUnits.length >= 3 && !isMobile ? _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { only: 'computer' },
          selectUnit3 && selectUnit3.zoneOrBlock ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              selectUnit3.zoneOrBlock || ''
            ),
            _react2.default.createElement(
              'small',
              null,
              t('Block')
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No block available', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ) : null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit1 && selectUnit1.streetNumberOrLevel ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              selectUnit1.streetNumberOrLevel || ''
            ),
            _react2.default.createElement(
              'small',
              null,
              t('Level')
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No level available', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit2 && selectUnit2.streetNumberOrLevel ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              selectUnit2.streetNumberOrLevel || ''
            ),
            _react2.default.createElement(
              'small',
              null,
              t('Level')
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No level available', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        projectUnits.length >= 3 && !isMobile ? _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { only: 'computer' },
          selectUnit3 && selectUnit3.streetNumberOrLevel ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              selectUnit3.streetNumberOrLevel || ''
            ),
            _react2.default.createElement(
              'small',
              null,
              t('Level')
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No level available', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ) : null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit1 && selectUnit1.streetOrFacing ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              selectUnit1.streetOrFacing || ''
            ),
            _react2.default.createElement(
              'small',
              null,
              t('Facing')
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No facing available', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit2 && selectUnit2.streetOrFacing ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              selectUnit2.streetOrFacing || ''
            ),
            _react2.default.createElement(
              'small',
              null,
              t('Facing')
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No facing available', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        projectUnits.length >= 3 && !isMobile ? _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { only: 'computer' },
          selectUnit3 && selectUnit3.streetOrFacing ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              selectUnit3.streetOrFacing || ''
            ),
            _react2.default.createElement(
              'small',
              null,
              t('Facing')
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No facing available', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ) : null
      );
    }
    return null;
  };

  this.renderPrice = function () {
    var t = _this3.props.t;
    var _state5 = _this3.state,
        projectUnits = _state5.projectUnits,
        selectedUnit = _state5.selectedUnit,
        isMobile = _state5.isMobile,
        isMediumScreen = _state5.isMediumScreen;
    var selectUnit1 = selectedUnit.selectUnit1,
        selectUnit2 = selectedUnit.selectUnit2,
        selectUnit3 = selectedUnit.selectUnit3;


    if (projectUnits && selectedUnit) {
      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        {
          centered: true,
          columns: isMobile ? 2 : projectUnits.length >= 3 ? isMediumScreen ? 2 : 3 : 2,
          className: 'basicInfo'
        },
        _react2.default.createElement(
          _semanticUiReact.Divider,
          { horizontal: true },
          t('Price')
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit1 && selectUnit1.spaValue ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              _react2.default.createElement(_LoanAmount2.default, {
                format: '0,000,000',
                amount: selectUnit1.spaValue.toFixed(2) || 0,
                prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
              })
            ),
            _react2.default.createElement(
              'small',
              null,
              t('Selling Price')
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No selling price available', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit2 && selectUnit2.spaValue ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              _react2.default.createElement(_LoanAmount2.default, {
                format: '0,000,000',
                amount: selectUnit2.spaValue.toFixed(2) || 0,
                prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
              })
            ),
            _react2.default.createElement(
              'small',
              null,
              t('Selling Price')
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No selling price available', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ),
        projectUnits.length >= 3 && !isMobile ? _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { only: 'computer' },
          selectUnit3 && selectUnit3.spaValue ? _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h1',
              null,
              _react2.default.createElement(_LoanAmount2.default, {
                format: '0,000,000',
                amount: selectUnit3.spaValue.toFixed(2) || 0,
                prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
              })
            ),
            _react2.default.createElement(
              'small',
              null,
              t('Selling Price')
            )
          ) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No selling price available', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ) : null
      );
    }
    return null;
  };

  this.renderPricingPackage = function () {
    var t = _this3.props.t;
    var _state6 = _this3.state,
        projectUnits = _state6.projectUnits,
        selectedUnit = _state6.selectedUnit,
        isMobile = _state6.isMobile,
        isMediumScreen = _state6.isMediumScreen;
    var selectUnit1 = selectedUnit.selectUnit1,
        selectUnit2 = selectedUnit.selectUnit2,
        selectUnit3 = selectedUnit.selectUnit3;


    if (projectUnits && selectedUnit) {
      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        {
          centered: true,
          columns: isMobile ? 2 : projectUnits.length >= 3 ? isMediumScreen ? 2 : 3 : 2,
          className: 'basicInfo',
          stretched: true
        },
        _react2.default.createElement(
          _semanticUiReact.Divider,
          { horizontal: true },
          t('Pricing Packages')
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit1 && selectUnit1.projectUnitPackagePricings ? selectUnit1.projectUnitPackagePricings.map(function (pp, i) {
            return _react2.default.createElement(
              'div',
              { key: i, className: 'ppItemBox' },
              _react2.default.createElement(
                'h1',
                null,
                _react2.default.createElement(_LoanAmount2.default, {
                  format: '0,000,000',
                  amount: pp.totalPrice.toFixed(2) || 0,
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                })
              ),
              _react2.default.createElement(
                'p',
                null,
                pp.isCustomPrice ? pp.customName : pp.projectPackagePricing.name
              ),
              pp.projectPackagePricing.packagePricingCalculations ? pp.projectPackagePricing.packagePricingCalculations.map(function (ppc, idx) {
                return _react2.default.createElement(
                  'small',
                  { key: idx, style: { display: 'block' } },
                  '- ',
                  ppc.projectPackagePricingItem.name
                );
              }) : null
            );
          }) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No pricing package available')
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit2 && selectUnit2.projectUnitPackagePricings ? selectUnit2.projectUnitPackagePricings.map(function (pp, i) {
            return _react2.default.createElement(
              'div',
              { key: i, className: 'ppItemBox' },
              _react2.default.createElement(
                'h1',
                null,
                _react2.default.createElement(_LoanAmount2.default, {
                  format: '0,000,000',
                  amount: pp.totalPrice.toFixed(2) || 0,
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                })
              ),
              _react2.default.createElement(
                'p',
                null,
                pp.isCustomPrice ? pp.customName : pp.projectPackagePricing.name
              ),
              pp.projectPackagePricing.packagePricingCalculations ? pp.projectPackagePricing.packagePricingCalculations.map(function (ppc, idx) {
                return _react2.default.createElement(
                  'small',
                  { key: idx, style: { display: 'block' } },
                  '- ',
                  ppc.projectPackagePricingItem.name
                );
              }) : null
            );
          }) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No pricing package available')
          )
        ),
        projectUnits.length >= 3 && !isMobile ? _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { only: 'computer' },
          selectUnit3 && selectUnit3.projectUnitPackagePricings ? selectUnit3.projectUnitPackagePricings.map(function (pp, i) {
            return _react2.default.createElement(
              'div',
              { key: i, className: 'ppItemBox' },
              _react2.default.createElement(
                'h1',
                null,
                _react2.default.createElement(_LoanAmount2.default, {
                  format: '0,000,000',
                  amount: pp.totalPrice.toFixed(2) || 0,
                  prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                })
              ),
              _react2.default.createElement(
                'p',
                null,
                pp.isCustomPrice ? pp.customName : pp.projectPackagePricing.name
              ),
              pp.projectPackagePricing.packagePricingCalculations ? pp.projectPackagePricing.packagePricingCalculations.map(function (ppc, idx) {
                return _react2.default.createElement(
                  'small',
                  { key: idx, style: { display: 'block' } },
                  '- ',
                  ppc.projectPackagePricingItem.name
                );
              }) : null
            );
          }) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No pricing package available')
          )
        ) : null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit1 && selectUnit1.projectUnitPackagePricings ? _react2.default.createElement(_semanticUiReact.Button, {
            content: t('View More', { ns: _translation.TRANSLATION_FILES.translation }),
            as: _reactRouter.Link,
            to: '/projects/' + _this3.props.id + '/units/' + selectUnit1.id + '/',
            primary: true,
            target: '_blank',
            className: 'viewMoreButton',
            size: 'tiny'
          }) : null
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit2 && selectUnit2.projectUnitPackagePricings ? _react2.default.createElement(_semanticUiReact.Button, {
            content: t('View More', { ns: _translation.TRANSLATION_FILES.translation }),
            as: _reactRouter.Link,
            to: '/projects/' + _this3.props.id + '/units/' + selectUnit2.id + '/',
            primary: true,
            target: '_blank',
            className: 'viewMoreButton',
            size: 'tiny'
          }) : null
        ),
        projectUnits.length >= 3 && !isMobile ? _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { only: 'computer' },
          selectUnit3 && selectUnit3.projectUnitPackagePricings ? _react2.default.createElement(_semanticUiReact.Button, {
            content: t('View More', { ns: _translation.TRANSLATION_FILES.translation }),
            as: _reactRouter.Link,
            to: '/projects/' + _this3.props.id + '/units/' + selectUnit3.id + '/',
            primary: true,
            target: '_blank',
            className: 'viewMoreButton',
            size: 'tiny'
          }) : null
        ) : null
      );
    }
    return null;
  };

  this.renderUnitSpec = function () {
    var t = _this3.props.t;
    var _state7 = _this3.state,
        projectUnits = _state7.projectUnits,
        selectedUnit = _state7.selectedUnit,
        isMobile = _state7.isMobile,
        isMediumScreen = _state7.isMediumScreen;
    var selectUnit1 = selectedUnit.selectUnit1,
        selectUnit2 = selectedUnit.selectUnit2,
        selectUnit3 = selectedUnit.selectUnit3;


    var isUnit1MultiSpec = selectUnit1 && selectUnit1.specifications ? selectUnit1.specifications.length > 1 : null;
    var isUnit2MultiSpec = selectUnit2 && selectUnit2.specifications ? selectUnit2.specifications.length > 1 : null;
    var isUnit3MultiSpec = selectUnit3 && selectUnit3.specifications ? selectUnit3.specifications.length > 1 : null;

    if (projectUnits && selectedUnit) {
      return _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        {
          centered: true,
          columns: isMobile ? 2 : projectUnits.length >= 3 ? isMediumScreen ? 2 : 3 : 2,
          className: 'basicInfo'
        },
        _react2.default.createElement(
          _semanticUiReact.Divider,
          { horizontal: true },
          t('Unit Specifications')
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit1 && selectUnit1.specifications ? selectUnit1.specifications.slice(0, 10).map(function (spec, idx) {
            return _react2.default.createElement(
              'div',
              {
                key: idx,
                className: isUnit1MultiSpec ? 'multiUnitSpec' : ''
              },
              _react2.default.createElement(
                'h1',
                null,
                spec.value
              ),
              _react2.default.createElement(
                'small',
                null,
                spec.name
              )
            );
          }) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No unit specifications available')
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          null,
          selectUnit2 && selectUnit2.specifications ? selectUnit2.specifications.slice(0, 10).map(function (spec, idx) {
            return _react2.default.createElement(
              'div',
              {
                key: idx,
                className: isUnit2MultiSpec ? 'multiUnitSpec' : ''
              },
              _react2.default.createElement(
                'h1',
                null,
                spec.value
              ),
              _react2.default.createElement(
                'small',
                null,
                spec.name
              )
            );
          }) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No unit specifications available')
          )
        ),
        projectUnits.length >= 3 && !isMobile ? _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { only: 'computer' },
          selectUnit3 && selectUnit3.specifications ? selectUnit3.specifications.slice(0, 10).map(function (spec, idx) {
            return _react2.default.createElement(
              'div',
              {
                key: idx,
                className: isUnit3MultiSpec ? 'multiUnitSpec' : ''
              },
              _react2.default.createElement(
                'h1',
                null,
                spec.value
              ),
              _react2.default.createElement(
                'small',
                null,
                spec.name
              )
            );
          }) : _react2.default.createElement(
            'p',
            { className: 'noValue' },
            t('No unit specifications available')
          )
        ) : null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { className: 'unitSpecButtonCol' },
          selectUnit1 && selectUnit1.specifications ? _react2.default.createElement(_semanticUiReact.Button, {
            content: t('View More', { ns: _translation.TRANSLATION_FILES.translation }),
            as: _reactRouter.Link,
            to: '/projects/' + _this3.props.id + '/units/' + selectUnit1.id + '/',
            primary: true,
            target: '_blank',
            className: 'viewMoreButton',
            size: 'tiny'
          }) : null
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { className: 'unitSpecButtonCol' },
          selectUnit2 && selectUnit2.specifications ? _react2.default.createElement(_semanticUiReact.Button, {
            content: t('View More', { ns: _translation.TRANSLATION_FILES.translation }),
            as: _reactRouter.Link,
            to: '/projects/' + _this3.props.id + '/units/' + selectUnit2.id + '/',
            primary: true,
            target: '_blank',
            className: 'viewMoreButton',
            size: 'tiny'
          }) : null
        ),
        projectUnits.length >= 3 && !isMobile ? _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { only: 'computer', className: 'unitSpecButtonCol' },
          selectUnit3 && selectUnit3.specifications ? _react2.default.createElement(_semanticUiReact.Button, {
            content: t('View More', { ns: _translation.TRANSLATION_FILES.translation }),
            as: _reactRouter.Link,
            to: '/projects/' + _this3.props.id + '/units/' + selectUnit3.id + '/',
            primary: true,
            target: '_blank',
            className: 'viewMoreButton',
            size: 'tiny'
          }) : null
        ) : null
      );
    }
    return null;
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.projectUnitLayout]))((0, _reactRedux.connect)(UnitsCompare.mapStateToProps)(UnitsCompare));

/***/ }),
/* 2433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Units = __webpack_require__(2431);

var _Units2 = _interopRequireDefault(_Units);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Units2.default;

/***/ }),
/* 2434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnpublishProjectModal = function (_Component) {
  _inherits(UnpublishProjectModal, _Component);

  function UnpublishProjectModal(props) {
    _classCallCheck(this, UnpublishProjectModal);

    var _this = _possibleConstructorReturn(this, (UnpublishProjectModal.__proto__ || Object.getPrototypeOf(UnpublishProjectModal)).call(this, props));

    _initialiseProps.call(_this);

    var state = UnpublishProjectModal.getPropsToState(props);
    _this.state = _extends({}, state);
    return _this;
  }

  _createClass(UnpublishProjectModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = UnpublishProjectModal.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'close',
    value: function close(callback) {
      this.setState({
        open: false
      }, function () {
        if (callback) {
          callback();
        }
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          basic: true,
          open: this.state.open,
          onClose: this.handleOnClose,
          closeIcon: 'close',
          size: 'small',
          closeOnDimmerClick: false
        },
        _react2.default.createElement(
          _semanticUiReact.Header,
          null,
          t('Unpublish Project'),
          '?'
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  'p',
                  null,
                  t('Your units on Marketplace will also be unpublished')
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              basic: true,
              color: 'red',
              inverted: true,
              onClick: this.handleOnClose
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove' }),
            ' ',
            t('Cancel', { ns: _translation.TRANSLATION_FILES.translation })
          ),
          _react2.default.createElement(
            _semanticUiReact.Button,
            {
              color: 'green',
              inverted: true,
              onClick: this.handleUpdate
            },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark' }),
            ' ',
            t('Save', { ns: _translation.TRANSLATION_FILES.translation })
          )
        )
      );
    }
  }]);

  return UnpublishProjectModal;
}(_react.Component);

UnpublishProjectModal.propTypes = {
  open: _propTypes2.default.bool,
  onConfirm: _propTypes2.default.func
};

UnpublishProjectModal.getPropsToState = function (props) {
  var open = props.open;
  return {
    open: open
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleOnClose = function () {
    _this2.close();
  };

  this.handleUpdate = function () {
    _this2.props.onConfirm();
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(UnpublishProjectModal);

/***/ }),
/* 2435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRouterRedux = __webpack_require__(13);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _MediaList = __webpack_require__(385);

var _MediaList2 = _interopRequireDefault(_MediaList);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _AddMedia = __webpack_require__(1074);

var _AddMedia2 = _interopRequireDefault(_AddMedia);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _RemoveMedia = __webpack_require__(589);

var _RemoveMedia2 = _interopRequireDefault(_RemoveMedia);

var _navigations = __webpack_require__(117);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Videos = function (_Component) {
  _inherits(Videos, _Component);

  function Videos(props) {
    _classCallCheck(this, Videos);

    var _this = _possibleConstructorReturn(this, (Videos.__proto__ || Object.getPrototypeOf(Videos)).call(this, props));

    _initialiseProps.call(_this);

    var state = Videos.getPropsToState(props);
    _this.state = _extends({}, state, {
      showConfirm: false,
      showLarge: false,
      selectedMedia: null,
      showAddMedia: false
    });
    _this.mediaList = null;
    return _this;
  }

  _createClass(Videos, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Videos.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'handleRefetch',
    value: function handleRefetch() {
      this.setState({
        selectedMedia: null
      });
      if (this.mediaList) {
        this.mediaList.getWrappedInstance().handleRefetch();
      }
    }
  }, {
    key: 'deleteMedia',
    value: function deleteMedia() {
      var _this2 = this;

      var t = this.props.t;
      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/projects/' + this.props.id + '/medias/' + this.state.selectedMedia.id + '/', {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.mediaToken
        }
      })).then(function () {
        _this2.handleRefetch();
        store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Remove Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Video successfully removed', { ns: _translation.TRANSLATION_FILES.translation }) }));
      }).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          auth = _props.auth,
          id = _props.id,
          location = _props.location,
          t = _props.t;
      var pathname = location.pathname;

      var companyServiceID = auth && auth.company && auth.company.service_company_id ? auth.company.service_company_id : '';
      var isMalaysia = auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY';
      var links = (0, _navigations.editRoutes)(id, this.props.appConfig.data && this.props.appConfig.data.lawyerIsEnabled, isMalaysia, companyServiceID).map(function (l) {
        return _extends({}, l, {
          text: t(l.text, { ns: l.text === 'Edit' ? _translation.TRANSLATION_FILES.translation : _translation.TRANSLATION_FILES.screens })
        });
      });
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: link.text,
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this3.handleMenu(e, link);
              }
            });
          }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              onClick: this.handleShowAddMedia,
              disabled: this.state.loading,
              primary: true,
              icon: 'add',
              content: t('Add', { ns: _translation.TRANSLATION_FILES.translation })
            })
          )
        }),
        _react2.default.createElement(_AddMedia2.default, {
          type: 'project',
          ref: function ref(_ref) {
            _this3.mediaModal = _ref;
          },
          open: this.state.showAddMedia,
          onClose: this.handleCloseAddMedia,
          onConfirm: this.handleAddMedia,
          onCreate: this.handleCreate,
          onCheck: this.handleCheck
        }),
        _react2.default.createElement(_ViewLarge2.default, {
          open: this.state.showLarge,
          onClose: this.handleCloseLarge,
          picture: this.state.selectedMedia,
          type: 'video'
        }),
        _react2.default.createElement(_RemoveMedia2.default, {
          open: this.state.showConfirm,
          onClose: this.handleCancelRemove,
          onConfirm: this.handleConfirmRemove,
          media: this.state.selectedMedia,
          data: this.props.data
        }),
        _react2.default.createElement(_MediaList2.default, {
          ref: function ref(_ref3) {
            _this3.mediaList = _ref3;
          },
          toggleable: true,
          projectID: this.props.id,
          onViewLarge: this.handleViewLarge,
          onRemove: this.handleRemove,
          buttonNode: function buttonNode(_ref2) {
            var isMobile = _ref2.isMobile,
                view = _ref2.view,
                loading = _ref2.loading,
                item = _ref2.item;
            return view === 'list' ? _react2.default.createElement(_semanticUiReact.Button, {
              size: 'tiny',
              compact: true,
              negative: true,
              icon: 'remove',
              content: isMobile ? null : t('Remove', { ns: _translation.TRANSLATION_FILES.translation }),
              disabled: loading,
              onClick: function onClick(e) {
                return _this3.handleRemove(e, item);
              }
            }) : null;
          }
        })
      );
    }
  }]);

  return Videos;
}(_react.Component);

Videos.contextTypes = {
  store: _propTypes2.default.object
};
Videos.propTypes = {
  mediaToken: _propTypes2.default.string,
  id: _propTypes2.default.string,
  t: _propTypes2.default.func,
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      lawyerIsEnabled: _propTypes2.default.bool
    })
  }),
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.object
  })
};

Videos.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

Videos.getPropsToState = function (props) {
  var loading = props.loading;
  var menuIsTab = window.innerWidth <= 590;
  return {
    loading: loading,
    menuIsTab: menuIsTab
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleResize = function () {
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this4.state.menuIsTab) {
      _this4.setState({ menuIsTab: menuIsTab });
    }
  };

  this.addMedia = function () {
    var t = _this4.props.t;
    var store = _this4.context.store;

    store.dispatch((0, _fetchM.fetchM)('/projects/' + _this4.props.id + '/medias/' + _this4.state.selectedMedia.id + '/', {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Csrf-Token': _this4.props.mediaToken
      }
    })).then(function () {
      _this4.mediaModal.handleRefetch();
      store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Add Video Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Video successfully added to project', { ns: _translation.TRANSLATION_FILES.translation }) }));
    }).catch(function (err) {
      store.dispatch((0, _flash.flashErrorMessage)(err));
    });
  };

  this.handleCancelRemove = function (e) {
    e.preventDefault();
    _this4.setState({
      showConfirm: false,
      selectedMedia: null
    });
  };

  this.handleRemove = function (e, selectedMedia) {
    e.preventDefault();
    _this4.setState({
      selectedMedia: selectedMedia
    }, function () {
      _this4.setState({
        showConfirm: true
      });
    });
  };

  this.handleConfirmRemove = function (e) {
    e.preventDefault();
    _this4.setState({
      showConfirm: false
    }, function () {
      _this4.deleteMedia();
    });
  };

  this.handleCloseLarge = function (e) {
    e.preventDefault();
    _this4.setState({
      showLarge: false,
      selectedMedia: null
    });
  };

  this.handleViewLarge = function (e, selectedMedia) {
    e.preventDefault();
    _this4.setState({
      selectedMedia: selectedMedia,
      showLarge: true
    });
  };

  this.handleShowAddMedia = function (e) {
    e.preventDefault();
    _this4.setState({
      showAddMedia: true
    });
  };

  this.handleCloseAddMedia = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this4.handleRefetch();
    _this4.setState({
      showAddMedia: false
    });
  };

  this.handleAddMedia = function (e, selectedMedia) {
    e.preventDefault();
    _this4.setState({
      selectedMedia: selectedMedia
    }, function () {
      _this4.addMedia();
    });
  };

  this.handleCreate = function (data) {
    return {
      url: '/projects/' + _this4.props.id + '/medias/',
      options: {
        credentials: 'include',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': _this4.props.mediaToken
        },
        body: JSON.stringify(data)
      }
    };
  };

  this.handleCheck = function (data) {
    if (data.projects && data.projects.length > 0) {
      return data.projects.some(function (p) {
        return p.projectID === _this4.props.id;
      });
    }
    return false;
  };

  this.handleMenu = function (e, _ref4) {
    var value = _ref4.value;
    var store = _this4.context.store;

    if (value.includes(_config2.default.get('developerURL'))) {
      e.preventDefault();
      window.location.href = value;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(value));
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Videos.mapStateToProps)(Videos));

/***/ }),
/* 2436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Project = __webpack_require__(2402);

var _Project2 = _interopRequireDefault(_Project);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Project2.default;

/***/ }),
/* 2437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1063);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Edit = function (_Component) {
  _inherits(Edit, _Component);

  function Edit(props) {
    _classCallCheck(this, Edit);

    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(Edit, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, preset) {
        var _this2 = this;

        var t, store, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.form.submit('/mappings/projects/' + encodeURIComponent(this.props.projectMappingID) + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(preset)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false);
                });
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully updated', { ns: _translation.TRANSLATION_FILES.translation, name: res.name }) }));

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Edit {{name}}', { ns: _translation.TRANSLATION_FILES.translation, name: this.props.data ? this.props.data.name : t('preset', { ns: _translation.TRANSLATION_FILES.translation }) }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Update', { ns: _translation.TRANSLATION_FILES.translation }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, preset) {
            _this3.submit(validations, preset);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading,
          preset: this.props.data
        })
      );
    }
  }]);

  return Edit;
}(_react.Component);

Edit.propTypes = {
  projectMappingID: _propTypes2.default.string,
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
Edit.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(Edit);

/***/ }),
/* 2438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _MappingPresetList = __webpack_require__(563);

var _MappingPresetList2 = _interopRequireDefault(_MappingPresetList);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    var state = List.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(List, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Project Mapping Settings')
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', columns: 'equal', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Mapping Presets')
              ),
              _react2.default.createElement(_MappingPresetList2.default, {
                loading: this.state.loading,
                type: 'projects'
              })
            )
          )
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  return {
    loading: loading
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(List);

/***/ }),
/* 2439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1063);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var New = function (_Component) {
  _inherits(New, _Component);

  function New(props) {
    _classCallCheck(this, New);

    var _this = _possibleConstructorReturn(this, (New.__proto__ || Object.getPrototypeOf(New)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments[1];

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges, callback);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(New, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, preset) {
        var _this2 = this;

        var t, store, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.form.submit('/mappings/projects/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(preset)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false, function (noChanges) {
                    if (noChanges) {
                      store.dispatch((0, _reactRouterRedux.goBack)());
                      store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Create Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully created', { ns: _translation.TRANSLATION_FILES.translation, name: res.name }) }));
                    }
                  });
                });

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('New preset', { ns: _translation.TRANSLATION_FILES.translation }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Create', { ns: _translation.TRANSLATION_FILES.screens }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, preset) {
            _this3.submit(validations, preset);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading
        })
      );
    }
  }]);

  return New;
}(_react.Component);

New.propTypes = {
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
New.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(New);

/***/ }),
/* 2440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _checkChanges = __webpack_require__(61);

var _promptMessages = __webpack_require__(43);

var _translation = __webpack_require__(4);

var _List = __webpack_require__(2438);

var _List2 = _interopRequireDefault(_List);

var _New = __webpack_require__(2439);

var _New2 = _interopRequireDefault(_New);

var _Edit = __webpack_require__(2437);

var _Edit2 = _interopRequireDefault(_Edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectMappings = function (_Component) {
  _inherits(ProjectMappings, _Component);

  function ProjectMappings(props) {
    _classCallCheck(this, ProjectMappings);

    var _this = _possibleConstructorReturn(this, (ProjectMappings.__proto__ || Object.getPrototypeOf(ProjectMappings)).call(this, props));

    _this.state = {
      token: null,
      loading: true,
      data: null
    };
    return _this;
  }

  _createClass(ProjectMappings, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.params.projectMappingID) {
        this.fetchProjectMapping();
      } else if (this.props.location.pathname.includes('/new/')) {
        this.fetchProjectMappings();
      } else {
        this.setLoading(false);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var pathname = nextProps.location.pathname;

      if (nextProps.params.projectMappingID) {
        if (pathname !== this.props.location.pathname) {
          this.fetchProjectMapping();
        }
      } else if (pathname.includes('/new/')) {
        this.fetchProjectMappings();
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchProjectMapping',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var t, store, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/mappings/projects/' + encodeURIComponent(this.props.params.projectMappingID) + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 19;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context.next = 33;
                break;

              case 27:
                token = res.headers.get('X-Csrf-Token');
                _context.next = 30;
                return res.json();

              case 30:
                data = _context.sent;
                _context.next = 33;
                return this.setComponentState({
                  token: token,
                  data: data
                });

              case 33:
                _context.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchProjectMapping() {
        return _ref.apply(this, arguments);
      }

      return fetchProjectMapping;
    }()
  }, {
    key: 'fetchProjectMappings',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var t, store, query, res, message, token;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                query = Object.assign({
                  page: 1
                }, q);
                res = void 0;
                _context2.prev = 6;
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/mappings/projects/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context2.sent;
                _context2.next = 20;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context2.next = 19;
                return this.setLoading(false);

              case 19:
                return _context2.abrupt('return');

              case 20:
                if (res.ok) {
                  _context2.next = 28;
                  break;
                }

                _context2.next = 23;
                return res.text();

              case 23:
                message = _context2.sent;
                _context2.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context2.next = 31;
                break;

              case 28:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context2.next = 31;
                return this.setComponentState({
                  token: token
                });

              case 31:
                _context2.next = 33;
                return this.setLoading(false);

              case 33:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 12]]);
      }));

      function fetchProjectMappings() {
        return _ref2.apply(this, arguments);
      }

      return fetchProjectMappings;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this4 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this4.state.token,
          loading: _this4.state.loading,
          data: _this4.state.data,
          projectMappingID: _this4.props.params.projectMappingID
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return ProjectMappings;
}(_react.Component);

ProjectMappings.propTypes = {
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object
  }),
  params: _propTypes2.default.shape({
    projectMappingID: _propTypes2.default.string
  })
};
ProjectMappings.contextTypes = {
  store: _propTypes2.default.object
};
ProjectMappings.List = _List2.default;
ProjectMappings.New = (0, _checkChanges.checkChanges)(_New2.default, { message: _promptMessages.NEW_MAPPING_PROMPT });
ProjectMappings.Edit = (0, _checkChanges.checkChanges)(_Edit2.default);


var TranslatedProjectMappings = (0, _reactI18next.withTranslation)(_translation.namespaces)(ProjectMappings);
TranslatedProjectMappings.List = ProjectMappings.List;
TranslatedProjectMappings.New = ProjectMappings.New;
TranslatedProjectMappings.Edit = ProjectMappings.Edit;
exports.default = TranslatedProjectMappings;

/***/ }),
/* 2441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ProjectMappings = __webpack_require__(2440);

var _ProjectMappings2 = _interopRequireDefault(_ProjectMappings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ProjectMappings2.default;

/***/ }),
/* 2442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1064);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Edit = function (_Component) {
  _inherits(Edit, _Component);

  function Edit(props) {
    _classCallCheck(this, Edit);

    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(Edit, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, preset) {
        var _this2 = this;

        var t, store, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.form.submit('/specifications/projects/' + this.props.presetID + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(preset)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false);
                });
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully updated', { ns: _translation.TRANSLATION_FILES.translation, name: res.name }) }));

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Edit {{name}}', { ns: _translation.TRANSLATION_FILES.translation, name: this.props.data ? this.props.data.name : t('preset', { ns: _translation.TRANSLATION_FILES.translation }) }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Update', { ns: _translation.TRANSLATION_FILES.translation }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, preset) {
            _this3.submit(validations, preset);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading,
          preset: this.props.data
        })
      );
    }
  }]);

  return Edit;
}(_react.Component);

Edit.propTypes = {
  presetID: _propTypes2.default.string,
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
Edit.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(Edit);

/***/ }),
/* 2443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _SpecificationPresetList = __webpack_require__(572);

var _SpecificationPresetList2 = _interopRequireDefault(_SpecificationPresetList);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    var state = List.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(List, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Projects Settings')
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', columns: 'equal', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Specification Presets')
              ),
              _react2.default.createElement(_SpecificationPresetList2.default, {
                loading: this.state.loading,
                type: 'projects'
              })
            )
          )
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  return {
    loading: loading
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(List);

/***/ }),
/* 2444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1064);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var New = function (_Component) {
  _inherits(New, _Component);

  function New(props) {
    _classCallCheck(this, New);

    var _this = _possibleConstructorReturn(this, (New.__proto__ || Object.getPrototypeOf(New)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments[1];

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges, callback);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(New, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, preset) {
        var _this2 = this;

        var t, store, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.form.submit('/specifications/projects/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(preset)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false, function (noChanges) {
                    if (noChanges) {
                      store.dispatch((0, _reactRouterRedux.goBack)());
                      store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Create Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully created', { ns: _translation.TRANSLATION_FILES.translation, name: res.name }) }));
                    }
                  });
                });

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('New preset', { ns: _translation.TRANSLATION_FILES.translation }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Create', { ns: _translation.TRANSLATION_FILES.screens }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, preset) {
            _this3.submit(validations, preset);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading
        })
      );
    }
  }]);

  return New;
}(_react.Component);

New.propTypes = {
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
New.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(New);

/***/ }),
/* 2445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _checkChanges = __webpack_require__(61);

var _promptMessages = __webpack_require__(43);

var _translation = __webpack_require__(4);

var _List = __webpack_require__(2443);

var _List2 = _interopRequireDefault(_List);

var _New = __webpack_require__(2444);

var _New2 = _interopRequireDefault(_New);

var _Edit = __webpack_require__(2442);

var _Edit2 = _interopRequireDefault(_Edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectSpecifications = function (_Component) {
  _inherits(ProjectSpecifications, _Component);

  function ProjectSpecifications(props) {
    _classCallCheck(this, ProjectSpecifications);

    var _this = _possibleConstructorReturn(this, (ProjectSpecifications.__proto__ || Object.getPrototypeOf(ProjectSpecifications)).call(this, props));

    _this.state = {
      token: null,
      loading: true,
      data: null
    };
    return _this;
  }

  _createClass(ProjectSpecifications, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.params.projectSpecificationID) {
        this.fetchProjectSpecification();
      } else if (this.props.location.pathname.includes('/new/')) {
        this.fetchProjectSpecifications();
      } else {
        this.setLoading(false);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var pathname = nextProps.location.pathname;

      if (nextProps.params.projectSpecificationID) {
        if (pathname !== this.props.location.pathname) {
          this.fetchProjectSpecification();
        }
      } else if (pathname.includes('/new/')) {
        this.fetchProjectSpecifications();
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchProjectSpecification',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var t, store, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/specifications/projects/' + this.props.params.projectSpecificationID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 19;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context.next = 33;
                break;

              case 27:
                token = res.headers.get('X-Csrf-Token');
                _context.next = 30;
                return res.json();

              case 30:
                data = _context.sent;
                _context.next = 33;
                return this.setComponentState({
                  token: token,
                  data: data
                });

              case 33:
                _context.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchProjectSpecification() {
        return _ref.apply(this, arguments);
      }

      return fetchProjectSpecification;
    }()
  }, {
    key: 'fetchProjectSpecifications',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var t, store, query, res, message, token;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                query = Object.assign({
                  page: 1
                }, q);
                res = void 0;
                _context2.prev = 6;
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/specifications/projects/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context2.sent;
                _context2.next = 20;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context2.next = 19;
                return this.setLoading(false);

              case 19:
                return _context2.abrupt('return');

              case 20:
                if (res.ok) {
                  _context2.next = 28;
                  break;
                }

                _context2.next = 23;
                return res.text();

              case 23:
                message = _context2.sent;
                _context2.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context2.next = 31;
                break;

              case 28:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context2.next = 31;
                return this.setComponentState({
                  token: token
                });

              case 31:
                _context2.next = 33;
                return this.setLoading(false);

              case 33:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 12]]);
      }));

      function fetchProjectSpecifications() {
        return _ref2.apply(this, arguments);
      }

      return fetchProjectSpecifications;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this4 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this4.state.token,
          loading: _this4.state.loading,
          data: _this4.state.data,
          presetID: _this4.props.params.projectSpecificationID
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return ProjectSpecifications;
}(_react.Component);

ProjectSpecifications.propTypes = {
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object
  }),
  params: _propTypes2.default.shape({
    projectSpecificationID: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
ProjectSpecifications.contextTypes = {
  store: _propTypes2.default.object
};
ProjectSpecifications.List = _List2.default;
ProjectSpecifications.New = (0, _checkChanges.checkChanges)(_New2.default, { message: _promptMessages.NEW_SPECIFICATION_PROMPT });
ProjectSpecifications.Edit = (0, _checkChanges.checkChanges)(_Edit2.default);


var TranslatedProjectSpecifications = (0, _reactI18next.withTranslation)(_translation.namespaces)(ProjectSpecifications);
TranslatedProjectSpecifications.List = ProjectSpecifications.List;
TranslatedProjectSpecifications.New = ProjectSpecifications.New;
TranslatedProjectSpecifications.Edit = ProjectSpecifications.Edit;
exports.default = TranslatedProjectSpecifications;

/***/ }),
/* 2446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ProjectSpecifications = __webpack_require__(2445);

var _ProjectSpecifications2 = _interopRequireDefault(_ProjectSpecifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ProjectSpecifications2.default;

/***/ }),
/* 2447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1065);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Edit = function (_Component) {
  _inherits(Edit, _Component);

  function Edit(props) {
    _classCallCheck(this, Edit);

    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(Edit, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, preset) {
        var _this2 = this;

        var store, t, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                this.context.store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.form.submit('/specifications/unit_layouts/' + this.props.presetID + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(preset)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false);
                });
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully updated', { ns: _translation.TRANSLATION_FILES.translation, name: res.name }) }));

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Edit {{name}}', { ns: _translation.TRANSLATION_FILES.translation, name: this.props.data ? this.props.data.name : t('preset', { ns: _translation.TRANSLATION_FILES.translation }) }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Update', { ns: _translation.TRANSLATION_FILES.translation }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, preset) {
            _this3.submit(validations, preset);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading,
          preset: this.props.data
        })
      );
    }
  }]);

  return Edit;
}(_react.Component);

Edit.propTypes = {
  presetID: _propTypes2.default.string,
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
Edit.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(Edit);

/***/ }),
/* 2448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _SpecificationPresetList = __webpack_require__(572);

var _SpecificationPresetList2 = _interopRequireDefault(_SpecificationPresetList);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    var state = List.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(List, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Layouts Settings')
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', columns: 'equal', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Specification Presets')
              ),
              _react2.default.createElement(_SpecificationPresetList2.default, {
                loading: this.state.loading,
                type: 'unit_layouts'
              })
            )
          )
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  return {
    loading: loading
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(List);

/***/ }),
/* 2449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _prompt = __webpack_require__(66);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1065);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var New = function (_Component) {
  _inherits(New, _Component);

  function New(props) {
    _classCallCheck(this, New);

    var _this = _possibleConstructorReturn(this, (New.__proto__ || Object.getPrototypeOf(New)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments[1];

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges, callback);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(New, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, preset) {
        var _this2 = this;

        var t, store, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.form.submit('/specifications/unit_layouts/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(preset)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false, function (noChanges) {
                    if (noChanges) {
                      store.dispatch((0, _reactRouterRedux.goBack)());
                      store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Create Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully created', { ns: _translation.TRANSLATION_FILES.translation, name: res.name }) }));
                    }
                  });
                });

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('New preset', { ns: _translation.TRANSLATION_FILES.translation }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Create', { ns: _translation.TRANSLATION_FILES.screens }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, preset) {
            _this3.submit(validations, preset);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading
        })
      );
    }
  }]);

  return New;
}(_react.Component);

New.propTypes = {
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
New.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(New);

/***/ }),
/* 2450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _checkChanges = __webpack_require__(61);

var _promptMessages = __webpack_require__(43);

var _translation = __webpack_require__(4);

var _List = __webpack_require__(2448);

var _List2 = _interopRequireDefault(_List);

var _New = __webpack_require__(2449);

var _New2 = _interopRequireDefault(_New);

var _Edit = __webpack_require__(2447);

var _Edit2 = _interopRequireDefault(_Edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectSpecifications = function (_Component) {
  _inherits(ProjectSpecifications, _Component);

  function ProjectSpecifications(props) {
    _classCallCheck(this, ProjectSpecifications);

    var _this = _possibleConstructorReturn(this, (ProjectSpecifications.__proto__ || Object.getPrototypeOf(ProjectSpecifications)).call(this, props));

    _this.state = {
      token: null,
      loading: true,
      data: null
    };
    return _this;
  }

  _createClass(ProjectSpecifications, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.params.projectUnitLayoutSpecificationID) {
        this.fetchProjectUnitLayoutSpecification();
      } else if (this.props.location.pathname.includes('/new/')) {
        this.fetchProjectUnitLayoutSpecifications();
      } else {
        this.setLoading(false);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var pathname = nextProps.location.pathname;

      if (nextProps.params.projectUnitLayoutSpecificationID) {
        if (pathname !== this.props.location.pathname) {
          this.fetchProjectUnitLayoutSpecification();
        }
      } else if (pathname.includes('/new/')) {
        this.fetchProjectUnitLayoutSpecifications();
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchProjectUnitLayoutSpecification',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var t, store, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/specifications/unit_layouts/' + this.props.params.projectUnitLayoutSpecificationID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 19;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context.next = 33;
                break;

              case 27:
                token = res.headers.get('X-Csrf-Token');
                _context.next = 30;
                return res.json();

              case 30:
                data = _context.sent;
                _context.next = 33;
                return this.setComponentState({
                  token: token,
                  data: data
                });

              case 33:
                _context.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchProjectUnitLayoutSpecification() {
        return _ref.apply(this, arguments);
      }

      return fetchProjectUnitLayoutSpecification;
    }()
  }, {
    key: 'fetchProjectUnitLayoutSpecifications',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var t, store, query, res, message, token;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                query = Object.assign({
                  page: 1
                }, q);
                res = void 0;
                _context2.prev = 6;
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/specifications/unit_layouts/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context2.sent;
                _context2.next = 20;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context2.next = 19;
                return this.setLoading(false);

              case 19:
                return _context2.abrupt('return');

              case 20:
                if (res.ok) {
                  _context2.next = 28;
                  break;
                }

                _context2.next = 23;
                return res.text();

              case 23:
                message = _context2.sent;
                _context2.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context2.next = 31;
                break;

              case 28:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context2.next = 31;
                return this.setComponentState({
                  token: token
                });

              case 31:
                _context2.next = 33;
                return this.setLoading(false);

              case 33:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 12]]);
      }));

      function fetchProjectUnitLayoutSpecifications() {
        return _ref2.apply(this, arguments);
      }

      return fetchProjectUnitLayoutSpecifications;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this4 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this4.state.token,
          loading: _this4.state.loading,
          data: _this4.state.data,
          presetID: _this4.props.params.projectUnitLayoutSpecificationID
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return ProjectSpecifications;
}(_react.Component);

ProjectSpecifications.propTypes = {
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object
  }),
  params: _propTypes2.default.shape({
    projectUnitLayoutSpecificationID: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
ProjectSpecifications.contextTypes = {
  store: _propTypes2.default.object
};
ProjectSpecifications.List = _List2.default;
ProjectSpecifications.New = (0, _checkChanges.checkChanges)(_New2.default, { message: _promptMessages.NEW_SPECIFICATION_PROMPT });
ProjectSpecifications.Edit = (0, _checkChanges.checkChanges)(_Edit2.default);


var TranslatedProjectSpecifications = (0, _reactI18next.withTranslation)(_translation.namespaces)(ProjectSpecifications);
TranslatedProjectSpecifications.List = ProjectSpecifications.List;
TranslatedProjectSpecifications.New = ProjectSpecifications.New;
TranslatedProjectSpecifications.Edit = ProjectSpecifications.Edit;
exports.default = TranslatedProjectSpecifications;

/***/ }),
/* 2451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ProjectUnitLayoutSpecifications = __webpack_require__(2450);

var _ProjectUnitLayoutSpecifications2 = _interopRequireDefault(_ProjectUnitLayoutSpecifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ProjectUnitLayoutSpecifications2.default;

/***/ }),
/* 2452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1066);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Edit = function (_Component) {
  _inherits(Edit, _Component);

  function Edit(props) {
    _classCallCheck(this, Edit);

    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(Edit, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, preset) {
        var _this2 = this;

        var t, store, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.form.submit('/specifications/units/' + this.props.presetID + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(preset)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false);
                });
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully updated', { ns: _translation.TRANSLATION_FILES.translation, name: res.name }) }));

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Edit {{name}}', { ns: _translation.TRANSLATION_FILES.translation, name: this.props.data ? this.props.data.name : 'preset' }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Update', { ns: _translation.TRANSLATION_FILES.translation }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, preset) {
            _this3.submit(validations, preset);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading,
          preset: this.props.data
        })
      );
    }
  }]);

  return Edit;
}(_react.Component);

Edit.propTypes = {
  presetID: _propTypes2.default.string,
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
Edit.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(Edit);

/***/ }),
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _SpecificationPresetList = __webpack_require__(572);

var _SpecificationPresetList2 = _interopRequireDefault(_SpecificationPresetList);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    var state = List.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(List, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Units Settings')
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', columns: 'equal', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Specification Presets')
              ),
              _react2.default.createElement(_SpecificationPresetList2.default, {
                loading: this.state.loading,
                type: 'units'
              })
            )
          )
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  return {
    loading: loading
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(List);

/***/ }),
/* 2454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _prompt = __webpack_require__(66);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1066);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var New = function (_Component) {
  _inherits(New, _Component);

  function New(props) {
    _classCallCheck(this, New);

    var _this = _possibleConstructorReturn(this, (New.__proto__ || Object.getPrototypeOf(New)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments[1];

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges, callback);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(New, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, preset) {
        var _this2 = this;

        var t, store, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.form.submit('/specifications/units/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(preset)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false, function (noChanges) {
                    if (noChanges) {
                      store.dispatch((0, _reactRouterRedux.goBack)());
                      store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Create Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully created', { ns: _translation.TRANSLATION_FILES.translation, name: res.name }) }));
                    }
                  });
                });

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('New preset', { ns: _translation.TRANSLATION_FILES.translation }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Create', { ns: _translation.TRANSLATION_FILES.screens }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, preset) {
            _this3.submit(validations, preset);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading
        })
      );
    }
  }]);

  return New;
}(_react.Component);

New.propTypes = {
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
New.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(New);

/***/ }),
/* 2455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _checkChanges = __webpack_require__(61);

var _promptMessages = __webpack_require__(43);

var _translation = __webpack_require__(4);

var _List = __webpack_require__(2453);

var _List2 = _interopRequireDefault(_List);

var _New = __webpack_require__(2454);

var _New2 = _interopRequireDefault(_New);

var _Edit = __webpack_require__(2452);

var _Edit2 = _interopRequireDefault(_Edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ProjectUnitSpecifications = function (_Component) {
  _inherits(ProjectUnitSpecifications, _Component);

  function ProjectUnitSpecifications(props) {
    _classCallCheck(this, ProjectUnitSpecifications);

    var _this = _possibleConstructorReturn(this, (ProjectUnitSpecifications.__proto__ || Object.getPrototypeOf(ProjectUnitSpecifications)).call(this, props));

    _this.state = {
      token: null,
      loading: true,
      data: null
    };
    return _this;
  }

  _createClass(ProjectUnitSpecifications, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.params.projectUnitSpecificationID) {
        this.fetchProjectUnitSpecification();
      } else if (this.props.location.pathname.includes('/new/')) {
        this.fetchProjectUnitSpecifications();
      } else {
        this.setLoading(false);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var pathname = nextProps.location.pathname;

      if (nextProps.params.projectUnitSpecificationID) {
        if (pathname !== this.props.location.pathname) {
          this.fetchProjectUnitSpecification();
        }
      } else if (pathname.includes('/new/')) {
        this.fetchProjectUnitSpecifications();
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchProjectUnitSpecification',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var t, store, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/specifications/units/' + this.props.params.projectUnitSpecificationID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 19;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context.next = 33;
                break;

              case 27:
                token = res.headers.get('X-Csrf-Token');
                _context.next = 30;
                return res.json();

              case 30:
                data = _context.sent;
                _context.next = 33;
                return this.setComponentState({
                  token: token,
                  data: data
                });

              case 33:
                _context.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchProjectUnitSpecification() {
        return _ref.apply(this, arguments);
      }

      return fetchProjectUnitSpecification;
    }()
  }, {
    key: 'fetchProjectUnitSpecifications',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var t, store, query, res, message, token;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                query = Object.assign({
                  page: 1
                }, q);
                res = void 0;
                _context2.prev = 6;
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/specifications/units/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context2.sent;
                _context2.next = 20;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context2.next = 19;
                return this.setLoading(false);

              case 19:
                return _context2.abrupt('return');

              case 20:
                if (res.ok) {
                  _context2.next = 28;
                  break;
                }

                _context2.next = 23;
                return res.text();

              case 23:
                message = _context2.sent;
                _context2.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context2.next = 31;
                break;

              case 28:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context2.next = 31;
                return this.setComponentState({
                  token: token
                });

              case 31:
                _context2.next = 33;
                return this.setLoading(false);

              case 33:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 12]]);
      }));

      function fetchProjectUnitSpecifications() {
        return _ref2.apply(this, arguments);
      }

      return fetchProjectUnitSpecifications;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this4 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this4.state.token,
          loading: _this4.state.loading,
          data: _this4.state.data,
          presetID: _this4.props.params.projectUnitSpecificationID
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return ProjectUnitSpecifications;
}(_react.Component);

ProjectUnitSpecifications.propTypes = {
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object
  }),
  params: _propTypes2.default.shape({
    projectUnitSpecificationID: _propTypes2.default.string
  })
};
ProjectUnitSpecifications.contextTypes = {
  store: _propTypes2.default.object
};
ProjectUnitSpecifications.List = _List2.default;
ProjectUnitSpecifications.New = (0, _checkChanges.checkChanges)(_New2.default, { message: _promptMessages.NEW_SPECIFICATION_PROMPT });
ProjectUnitSpecifications.Edit = (0, _checkChanges.checkChanges)(_Edit2.default);


var TranslatedProjectUnitSpecifications = (0, _reactI18next.withTranslation)(_translation.namespaces)(ProjectUnitSpecifications);
TranslatedProjectUnitSpecifications.List = ProjectUnitSpecifications.List;
TranslatedProjectUnitSpecifications.New = ProjectUnitSpecifications.New;
TranslatedProjectUnitSpecifications.Edit = ProjectUnitSpecifications.Edit;
exports.default = TranslatedProjectUnitSpecifications;

/***/ }),
/* 2456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _ProjectUnitSpecifications = __webpack_require__(2455);

var _ProjectUnitSpecifications2 = _interopRequireDefault(_ProjectUnitSpecifications);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ProjectUnitSpecifications2.default;

/***/ }),
/* 2457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _semanticUiReact = __webpack_require__(2);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _reactRouter = __webpack_require__(18);

var _url = __webpack_require__(19);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _Filters = __webpack_require__(86);

var _dateRanges = __webpack_require__(265);

var _dateRanges2 = _interopRequireDefault(_dateRanges);

var _projectStatuses = __webpack_require__(583);

var _projectStatuses2 = _interopRequireDefault(_projectStatuses);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _LoanAmount = __webpack_require__(35);

var _LoanAmount2 = _interopRequireDefault(_LoanAmount);

var _SizeSuffix = __webpack_require__(316);

var _SizeSuffix2 = _interopRequireDefault(_SizeSuffix);

var _CurrencySymbol = __webpack_require__(39);

var _CurrencySymbol2 = _interopRequireDefault(_CurrencySymbol);

var _fetchM = __webpack_require__(6);

var _projectBusinessUnits = __webpack_require__(2079);

var _flash = __webpack_require__(5);

var _states = __webpack_require__(144);

var _states2 = _interopRequireDefault(_states);

var _translation = __webpack_require__(4);

var _countries = __webpack_require__(60);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint jsx-a11y/no-static-element-interactions: 0 */


var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _initialiseProps.call(_this);

    var projectBusinessUnits = props.projectBusinessUnits ? [].concat(props.projectBusinessUnits.data) : [];
    var state = List.getPropsToState(props);
    _this.state = _extends({}, state, {
      projectBusinessUnits: projectBusinessUnits
    });
    return _this;
  }

  _createClass(List, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;

      store.dispatch((0, _projectBusinessUnits.fetchProjectBusinessUnits)(true));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var projectBusinessUnits = nextProps.projectBusinessUnits ? [].concat(nextProps.projectBusinessUnits.data) : this.state.projectBusinessUnits;
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
      var query = (0, _url.decodeSearch)(this.props.location.search);
      if (query.projectStatus && query.projectStatus.length > 0 || query.projectBusinessUnit && query.projectBusinessUnit.length > 0 || query.projectState && query.projectState.length > 0 || query.dateRange && query.dateRange.length > 0 || query.dateFrom && query.dateFrom.length > 0 || query.dateTo && query.dateTo.length > 0) {
        this.setState({
          advanceFilter: true,
          projectBusinessUnits: projectBusinessUnits
        });
      }
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchPinnedProject',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var store, t, res, token, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                token = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/project_pins/' + id + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 15:
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                return _context.abrupt('return', null);

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 27;
                break;

              case 26:
                token = res.headers.get('X-Csrf-Token');

              case 27:
                return _context.abrupt('return', token);

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchPinnedProject(_x2) {
        return _ref.apply(this, arguments);
      }

      return fetchPinnedProject;
    }()
  }, {
    key: 'pinProject',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(projectID) {
        var store, _props, t, projectPinsToken, message, query;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                _props = this.props, t = _props.t, projectPinsToken = _props.projectPinsToken;
                _context2.next = 4;
                return this.setLoading(true);

              case 4:
                _context2.prev = 4;
                _context2.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/project_pins/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': projectPinsToken
                  },
                  body: JSON.stringify({
                    projectID: projectID
                  })
                }));

              case 7:
                _context2.next = 28;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](4);

                Bugsnag.notifyException(_context2.t0);

                if (!(_context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 26;
                  break;
                }

                _context2.next = 15;
                return _context2.t0.res.text();

              case 15:
                message = _context2.sent;

                if (!(_context2.t0.res.status === 412)) {
                  _context2.next = 21;
                  break;
                }

                _context2.next = 19;
                return store.dispatch((0, _flash.flashErrorMessage)({
                  header: t('Pin limit reached', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: message
                }));

              case 19:
                _context2.next = 23;
                break;

              case 21:
                _context2.next = 23;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 23:
                _context2.next = 25;
                return this.setLoading(false);

              case 25:
                return _context2.abrupt('return');

              case 26:
                _context2.next = 28;
                return store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));

              case 28:
                _context2.next = 30;
                return this.setLoading(false);

              case 30:

                // refresh
                query = (0, _url.decodeSearch)(this.props.location.search);

                query.excludePinned = true;
                this.replaceQuery(query);

                _context2.next = 35;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Pin Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Project successfully pinned to top', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 35:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 9]]);
      }));

      function pinProject(_x3) {
        return _ref2.apply(this, arguments);
      }

      return pinProject;
    }()
  }, {
    key: 'unpinProject',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(id) {
        var store, t, pinnedData, uppID, matchedProject, uppToken, message, query;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                pinnedData = this.state.pinnedData;

                // find pinned project id

                uppID = '';
                matchedProject = pinnedData.find(function (pp) {
                  return pp.projectID === id;
                });

                if (!matchedProject) {
                  _context3.next = 9;
                  break;
                }

                uppID = matchedProject.id;
                _context3.next = 10;
                break;

              case 9:
                return _context3.abrupt('return');

              case 10:
                _context3.next = 12;
                return this.fetchPinnedProject(uppID);

              case 12:
                uppToken = _context3.sent;
                _context3.next = 15;
                return this.setLoading(true);

              case 15:
                _context3.prev = 15;
                _context3.next = 18;
                return store.dispatch((0, _fetchM.fetchM)('/project_pins/' + uppID + '/', {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': uppToken
                  }
                }));

              case 18:
                _context3.next = 34;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t0 = _context3['catch'](15);

                Bugsnag.notifyException(_context3.t0);

                if (!(_context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 32;
                  break;
                }

                _context3.next = 26;
                return _context3.t0.res.text();

              case 26:
                message = _context3.sent;
                _context3.next = 29;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 29:
                _context3.next = 31;
                return this.setLoading(false);

              case 31:
                return _context3.abrupt('return');

              case 32:
                _context3.next = 34;
                return store.dispatch((0, _flash.flashErrorMessage)(_context3.t0));

              case 34:
                _context3.next = 36;
                return this.setLoading(false);

              case 36:

                // refresh
                query = (0, _url.decodeSearch)(this.props.location.search);

                query.excludePinned = true;
                this.replaceQuery(query);

                _context3.next = 41;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Unpin Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Project successfully unpinned', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 41:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[15, 20]]);
      }));

      function unpinProject(_x4) {
        return _ref3.apply(this, arguments);
      }

      return unpinProject;
    }()
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var admin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var dhq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var dbl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      var auth = this.props.auth;
      if (admin && auth.isSuperAdmin) {
        return true;
      }
      if (dhq && auth.isHeadquarters) {
        return true;
      }
      if (dbl && auth.isBranchLeader) {
        return true;
      }
      return check;
    }
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      store.dispatch((0, _reactRouterRedux.replace)('/projects/?' + (0, _url.encodeSearch)(queryNew)));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Projects'),
          rightNav: this.hasAccess(this.props.auth.isBranchLeaderSupervisorII, true, true, false) ? _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              as: _reactRouter.Link,
              primary: true,
              icon: 'add',
              content: t('Project'),
              disabled: this.state.loading,
              to: '/projects/new/'
              // href={`${config.get('developerURL')}/c/${this.props.auth.company.service_company_id}/projects/new/`}
            })
          ) : null
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _SearchFilter2.default,
                {
                  advanceFilter: this.state.advanceFilter,
                  isLoading: this.state.loading,
                  onChange: this.handleFilterOnChange,
                  onClose: this.handleClearFilter,
                  search: this.state.search,
                  setAdvanceFilter: this.handleSetAdvanceFilter,
                  leftNav: _react2.default.createElement(_PageNav2.default, {
                    currentPage: this.state.currentPage,
                    count: this.state.count,
                    limit: this.state.limit,
                    offset: this.state.offset,
                    dataSize: this.state.data.length,
                    loading: this.state.loading,
                    onChange: this.handleChangePage
                  }),
                  rightNav: _react2.default.createElement(_SortButton2.default, {
                    floated: 'right',
                    loading: this.state.loading,
                    items: this.sortItems,
                    onSort: this.handleSortData
                  })
                },
                _react2.default.createElement(_Filters.DatePicker, {
                  filterName: 'dateRange',
                  filterNameFrom: 'dateFrom',
                  filterNameTo: 'dateTo',
                  dateFrom: this.state.dateFrom,
                  dateTo: this.state.dateTo,
                  onChange: this.handleFilterOnChange,
                  onClose: this.handleClearFilter,
                  onResetRange: this.handleClearFilter,
                  onSetRange: this.handleSetDateRange,
                  options: _dateRanges2.default.map(function (o) {
                    return _extends({}, o, {
                      text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants })
                    });
                  }),
                  value: this.state.dateRange
                }),
                this.hasAccess() ? _react2.default.createElement(_Filters.SelectListMultiple, {
                  filterName: 'projectStatus',
                  hasSearch: true,
                  headerText: t('Select Project Status'),
                  onChange: this.handleFilterOnChange,
                  onClose: this.handleClearFilter,
                  options: _projectStatuses2.default.map(function (status) {
                    return _extends({}, status, {
                      text: t(status.text, { ns: _translation.TRANSLATION_FILES.constants })
                    });
                  }),
                  placeholder: t('Select Project Status'),
                  value: this.state.projectStatus
                }) : null,
                this.hasAccess() && this.props.projectBusinessUnits && this.props.projectBusinessUnits.data && this.props.projectBusinessUnits.data[0] !== null ? _react2.default.createElement(_Filters.SelectListMultiple, {
                  filterName: 'projectBusinessUnit',
                  hasSearch: true,
                  headerText: t('Select Business Unit'),
                  onChange: this.handleFilterOnChange,
                  onClose: this.handleClearFilter,
                  options: this.props.projectBusinessUnits.data.map(function (pbu) {
                    return {
                      value: pbu.MaOwnerCompanyBranchID.toString(),
                      text: pbu.MaOwnerCompanyBranchShortName
                    };
                  }),
                  placeholder: t('Select Business Unit'),
                  value: this.state.projectBusinessUnit
                }) : null,
                this.props.auth.company.countryCode.toUpperCase() === 'MY' && _react2.default.createElement(_Filters.SelectListMultiple, {
                  filterName: 'projectState',
                  hasSearch: true,
                  headerText: t('Select State'),
                  onChange: this.handleFilterOnChange,
                  onClose: this.handleClearFilter,
                  options: _states2.default,
                  placeholder: t('Select State'),
                  value: this.state.projectState
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                {
                  inverted: true, style: { zIndex: 20 },
                  active: this.state.loading && this.state.data.length > 0
                },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              this.state.data.length > 0 ? _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 2, stackable: true, equal: true },
                this.state.data.map(function (data, idx) {
                  return _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { key: idx, as: _reactRouter.Link, to: '/projects/' + data.id + '/' },
                    _react2.default.createElement(
                      'div',
                      { className: 'card-container' },
                      _react2.default.createElement(
                        'div',
                        { className: 'image-container' },
                        _react2.default.createElement(_LoadImage2.default, {
                          inline: true,
                          centered: true,
                          loading: _this3.state.loading,
                          notFoundNode: _react2.default.createElement('img', {
                            alt: 'default',
                            src: '/assets/images/projects/default-project.svg',
                            className: 'default-img'
                          }),
                          picture: _this3.getCoverPicture(data.projectPictures),
                          pictureSize: 70
                        }),
                        _this3.hasAccess() && _react2.default.createElement(
                          _semanticUiReact.Label,
                          {
                            size: 'mini',
                            className: 'status-label',
                            style: { backgroundColor: _this3.showProjectStatusColor(data.statusID) }
                          },
                          _this3.showProjectStatus(data.statusID)
                        ),
                        _react2.default.createElement(_semanticUiReact.Popup, {
                          trigger: _react2.default.createElement(
                            'div',
                            {
                              onClick: function onClick(e) {
                                return _this3.handlePinProject(e, data);
                              },
                              disabled: _this3.state.loading,
                              role: 'button',
                              className: 'bookmark-icon'
                            },
                            _react2.default.createElement('img', {
                              alt: 'bookmark',
                              src: '/assets/icons/bookmark-' + (data.pinned ? 'active' : 'inactive') + '.svg'
                            })
                          ),
                          content: data.pinned ? t('Unpin', { ns: _translation.TRANSLATION_FILES.constants }) : t('Pin to top', { ns: _translation.TRANSLATION_FILES.constants }),
                          position: 'bottom center',
                          className: 'custom-popup'
                        })
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: 'info-container' },
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 16, className: 'name' },
                          data.name
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 16, className: 'info' },
                          data.address6 ? data.address6 + ', ' : '',
                          data.address7
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Grid,
                          { columns: 2, className: 'info' },
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Row,
                            { columns: 'equal' },
                            data.summary && _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { width: 7 },
                              _react2.default.createElement(
                                'div',
                                { className: 'item' },
                                _react2.default.createElement(
                                  'div',
                                  { className: 'icon' },
                                  _react2.default.createElement('img', {
                                    alt: 'available_units',
                                    src: '/assets/icons/properties.svg'
                                  })
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  null,
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'title' },
                                    t('Units', { ns: _translation.TRANSLATION_FILES.screens })
                                  ),
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'value' },
                                    data.summary.newUnits,
                                    data.summary.totalUnits && data.summary.newUnits > 0 ? ' / ' + data.summary.totalUnits : ''
                                  )
                                )
                              )
                            ),
                            (data.minSize > 0 || data.summary.minSize > 0 || data.maxSize > 0 || data.summary.maxSize > 0) && _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { width: 9 },
                              _react2.default.createElement(
                                'div',
                                { className: 'item' },
                                _react2.default.createElement(
                                  'div',
                                  { className: 'icon' },
                                  _react2.default.createElement('img', {
                                    alt: 'size',
                                    src: '/assets/icons/bounding_box.svg'
                                  })
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  null,
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'title' },
                                    t('Size', { ns: _translation.TRANSLATION_FILES.screens }),
                                    ' (',
                                    _this3.getSizeSuffix(data.sizeSuffix),
                                    ')'
                                  ),
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'value' },
                                    data.minSize > 0 || data.summary.minSize > 0 ? _react2.default.createElement(_SizeSuffix2.default, {
                                      size: data.manualSize ? data.minSize : data.summary.minSize
                                    }) : null,
                                    (data.minSize > 0 || data.summary.minSize > 0) && (data.maxSize > 0 || data.summary.maxSize > 0) && (data.maxSize !== data.minSize || data.summary.maxSize !== data.summary.minSize) ? ' - ' : null,
                                    (data.maxSize > 0 || data.summary.maxSize > 0) && (data.maxSize !== data.minSize || data.summary.maxSize !== data.summary.minSize) ? _react2.default.createElement(_SizeSuffix2.default, {
                                      size: data.manualSize ? data.maxSize : data.summary.maxSize
                                    }) : null
                                  )
                                )
                              )
                            ),
                            (data.minPrice > 0 || data.summary.minPrice > 0 || data.maxPrice > 0 || data.summary.maxPrice > 0) && _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { width: 16 },
                              _react2.default.createElement(
                                'div',
                                { className: 'item' },
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  null,
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'title' },
                                    t('Price', { ns: _translation.TRANSLATION_FILES.screens })
                                  ),
                                  _react2.default.createElement(
                                    'div',
                                    { className: 'value' },
                                    data.minPrice > 0 || data.summary.minPrice > 0 ? _react2.default.createElement(_LoanAmount2.default, {
                                      format: '0,0',
                                      amount: data.manualPrice ? data.minPrice : data.summary.minPrice,
                                      projectCurrencies: data.projectCurrency,
                                      prefix: _react2.default.createElement(_CurrencySymbol2.default, null)
                                    }) : null,
                                    (data.minPrice > 0 || data.summary.minPrice > 0) && (data.maxPrice > 0 || data.summary.maxPrice > 0) && (data.maxPrice !== data.minPrice || data.summary.maxPrice !== data.summary.minPrice) ? ' - ' : null,
                                    (data.maxPrice > 0 || data.summary.maxPrice > 0) && (data.maxPrice !== data.minPrice || data.summary.maxPrice !== data.summary.minPrice) ? _react2.default.createElement(_LoanAmount2.default, {
                                      format: '0,0',
                                      amount: data.manualPrice ? data.maxPrice : data.summary.maxPrice,
                                      projectCurrencies: data.projectCurrency
                                    }) : null
                                  )
                                )
                              )
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { width: 16, className: 'label-group' },
                          _react2.default.createElement(
                            _semanticUiReact.Label.Group,
                            { size: 'mini' },
                            data.isResidential ? _react2.default.createElement(
                              _semanticUiReact.Label,
                              { basic: true, as: 'a' },
                              t('Residential')
                            ) : null,
                            data.isIndustrial ? _react2.default.createElement(
                              _semanticUiReact.Label,
                              { basic: true, as: 'a' },
                              t('Industrial')
                            ) : null,
                            data.isCommercial ? _react2.default.createElement(
                              _semanticUiReact.Label,
                              { basic: true, as: 'a' },
                              t('Commercial')
                            ) : null,
                            data.maOwnerCompanyBranchShortName ? _react2.default.createElement(
                              _semanticUiReact.Label,
                              { className: 'bu-label', onClick: function onClick() {
                                  _this3.handleFilterOnChange(data.maOwnerCompanyBranchID, 'projectBusinessUnit[0]');
                                }, as: 'a' },
                              data.maOwnerCompanyBranchShortName
                            ) : null
                          )
                        )
                      )
                    )
                  );
                })
              ) : _react2.default.createElement(
                _semanticUiReact.Item,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Item.Content,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Segment,
                    { textAlign: 'center' },
                    this.state.loading ? _react2.default.createElement(
                      _semanticUiReact.Loader,
                      { active: true, inline: 'centered' },
                      t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                    ) : t('No projects found') + '.'
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              _react2.default.createElement(_PageNav2.default, {
                upward: true,
                currentPage: this.state.currentPage,
                count: this.state.count,
                limit: this.state.limit,
                offset: this.state.offset,
                dataSize: this.state.data.length,
                loading: this.state.loading,
                onChange: this.handleChangePage
              })
            )
          )
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};
List.propTypes = {
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isBranchLeader: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  projectBusinessUnits: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  t: _propTypes2.default.func,
  projectPinsToken: _propTypes2.default.string
};

List.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    projectBusinessUnits: state.projectBusinessUnits
  };
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  var count = props.count;
  var limit = props.limit || 10;
  var offset = props.offset || 0;
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var pinnedData = props.projectPins || [];
  var pinnedProjects = pinnedData.map(function (item) {
    return _extends({}, item.project, {
      pinned: true
    });
  });
  var pinnedIdSet = new Set(pinnedProjects.map(function (p) {
    return p.id;
  }));
  var unpinnedProjects = (props.data || []).map(function (item) {
    return _extends({}, item, {
      pinned: pinnedIdSet.has(item.id)
    });
  });
  var search = query.search || '';
  var advanceFilter = false;
  var dateRange = query.dateRange || '';
  var projectStatus = query.projectStatus || [];
  var projectBusinessUnit = query.projectBusinessUnit || [];
  var projectState = query.projectState || [];
  var dateFrom = query.dateFrom || '';
  var dateTo = query.dateTo || '';
  var hasFilter = projectStatus.length > 0 || projectBusinessUnit.length > 0 || projectState.length > 0 || dateRange || dateFrom || dateTo || search;
  var combinedProjects = currentPage === 1 && !hasFilter ? [].concat(_toConsumableArray(pinnedProjects), _toConsumableArray(unpinnedProjects)) : [].concat(_toConsumableArray(unpinnedProjects));
  return {
    data: combinedProjects,
    pinnedData: pinnedData,
    loading: loading,
    count: count,
    limit: limit,
    offset: offset,
    currentPage: currentPage,
    search: search,
    advanceFilter: advanceFilter,
    dateRange: dateRange,
    projectStatus: projectStatus,
    projectBusinessUnit: projectBusinessUnit,
    projectState: projectState,
    dateTo: dateTo,
    dateFrom: dateFrom
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.getCoverPicture = function (pictures) {
    if (pictures && pictures.length > 0 && pictures.some(function (pp) {
      return pp.isCover === true;
    })) {
      return pictures.find(function (pp) {
        return pp.isCover === true;
      }).picture;
    }
    return null;
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    query.page = currentPage;
    _this4.setState({
      currentPage: currentPage
    });
    _this4.replaceQuery(query);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this4.replaceQuery(query, true);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    _this4.setState({
      search: ''
    }, function () {
      if (hasQuery) {
        _this4.replaceQuery(query, true);
      }
    });
  };

  this.handleFilterOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    query[queryName] = value;
    _this4.replaceQuery(query, true);
  };

  this.handleSetDateRange = function (from, to) {
    var query = (0, _url.decodeSearch)(_this4.props.location.search);
    query.dateFrom = from;
    query.dateTo = to;
    _this4.replaceQuery(query, true);
  };

  this.handleSetAdvanceFilter = function (advanceFilter) {
    _this4.setState({
      advanceFilter: advanceFilter
    });
  };

  this.handlePinProject = function (e, project) {
    e.preventDefault();
    if (project.pinned) {
      _this4.unpinProject(project.id);
    } else {
      _this4.pinProject(project.id);
    }
  };

  this.sortItems = [{
    text: 'Name Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'project.name',
    sortDirection: 'asc'
  }, {
    text: 'Name Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'project.name',
    sortDirection: 'desc'
  }, {
    text: 'Status Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'project.status_id',
    sortDirection: 'asc'
  }, {
    text: 'Status Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'project.status_id',
    sortDirection: 'desc'
  }, {
    text: 'Owner\'s Business Unit Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'project.ma_owner_company_branch_short_name',
    sortDirection: 'asc'
  }, {
    text: 'Owner\'s Business Unit Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'project.ma_owner_company_branch_short_name',
    sortDirection: 'desc'
  }, {
    text: 'Published Date (Newest)',
    icon: 'sort alphabet ascending',
    sortColumn: 'project.published_at',
    sortDirection: 'desc'
  }, {
    text: 'Published Date (Oldest)',
    icon: 'sort alphabet descending',
    sortColumn: 'project.published_at',
    sortDirection: 'asc'
  }];

  this.showProjectStatus = function (statusID) {
    var t = _this4.props.t;

    switch (statusID) {
      case 'draft':
        return t('Draft', { ns: _translation.TRANSLATION_FILES.constants });
      case 'ready':
        return t('Ready', { ns: _translation.TRANSLATION_FILES.constants });
      case 'published':
        return t('Published', { ns: _translation.TRANSLATION_FILES.constants });
      case 'archived':
        return t('Archived', { ns: _translation.TRANSLATION_FILES.constants });
      case 'deleted':
        return t('Deleted', { ns: _translation.TRANSLATION_FILES.constants });
      default:
        return null;
    }
  };

  this.showProjectStatusColor = function (statusID) {
    switch (statusID) {
      case 'draft':
        return '#9CAAC1';
      case 'ready':
        return '#F79A3E';
      case 'published':
        return '#50B793';
      case 'archived':
        return '#E7EAED';
      case 'deleted':
        return '#FF796E';
      default:
        return null;
    }
  };

  this.getSizeSuffix = function (value) {
    var t = _this4.props.t;

    switch (value) {
      case 'square_metres':
        return (0, _countries.isCountryVietnam)(_this4.props.auth && _this4.props.auth.company && _this4.props.auth.company.countryCode) ? 'm²' : t('sqm', { ns: _translation.TRANSLATION_FILES.screens });
      case 'square_feet':
        return t('sqft', { ns: _translation.TRANSLATION_FILES.screens });
      default:
        return '';
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(List.mapStateToProps)(List));

/***/ }),
/* 2458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIframe = __webpack_require__(1412);

var _reactIframe2 = _interopRequireDefault(_reactIframe);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MarketplaceTncModal = function (_Component) {
  _inherits(MarketplaceTncModal, _Component);

  function MarketplaceTncModal(props) {
    _classCallCheck(this, MarketplaceTncModal);

    var _this = _possibleConstructorReturn(this, (MarketplaceTncModal.__proto__ || Object.getPrototypeOf(MarketplaceTncModal)).call(this, props));

    _initialiseProps.call(_this);

    var state = MarketplaceTncModal.getPropsToState(props);
    _this.state = _extends({}, state);
    return _this;
  }

  _createClass(MarketplaceTncModal, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = MarketplaceTncModal.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          centered: true,
          open: this.state.open,
          onClose: this.handleOnClose,
          closeIcon: 'close',
          size: 'small'
        },
        _react2.default.createElement(_semanticUiReact.Header, { as: 'h4', content: this.props.header, style: { background: '#F4F5F7' } }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { centered: true },
          this.props.header === t('Terms and Conditions') ? _react2.default.createElement(
            'div',
            { style: { textAlign: 'center' } },
            _react2.default.createElement(_reactIframe2.default, { width: '635px', height: '500px', frameBorder: '0', overflow: 'hidden', styles: { fontSize: "14px" }, url: 'https://blog.mhub.my/terms/marketplace' })
          ) : null
        )
      );
    }
  }]);

  return MarketplaceTncModal;
}(_react.Component);

MarketplaceTncModal.propTypes = {
  open: _propTypes2.default.bool,
  header: _propTypes2.default.string,
  onClose: _propTypes2.default.func
};

MarketplaceTncModal.getPropsToState = function (props) {
  var open = props.open;
  return {
    open: open
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleOnClose = function () {
    _this2.props.onClose();
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(MarketplaceTncModal);

/***/ }),
/* 2459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _i18next = __webpack_require__(94);

var _i18next2 = _interopRequireDefault(_i18next);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _addressSettings = __webpack_require__(152);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1067);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var New = function (_Component) {
  _inherits(New, _Component);

  function New(props) {
    _classCallCheck(this, New);

    var _this = _possibleConstructorReturn(this, (New.__proto__ || Object.getPrototypeOf(New)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.getWrappedInstance().getWrappedInstance().handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments[1];

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges, callback);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(New, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var store = this.context.store;

      if (!this.props.auth.isSuperAdmin && !this.props.auth.isHeadquarters && !this.props.auth.isBranchLeaderSupervisorII) {
        store.dispatch((0, _reactRouterRedux.replace)('/forbidden/'));
        return;
      }
      store.dispatch((0, _addressSettings.fetchAddressSettings)());
    }
  }, {
    key: 'addBankAccount',
    value: function addBankAccount(projectId, value) {
      var attr = {
        bank: value.bank,
        accountNumber: value.accountNumber,
        isActive: value.isActive

      };
      var store = this.context.store;

      return (0, _fetchM.serverRequestPost)('/projects/' + projectId + '/bank_accounts/', store, this.props.token, attr);
    }
  }, {
    key: 'addCurrency',
    value: function addCurrency(projectId, value) {
      var attr = {
        code: value.code,
        conversionRatePoint: value.conversionRatePoint,
        isDefault: value.isDefault,
        name: value.name
      };
      var store = this.context.store;

      return (0, _fetchM.serverRequestPost)('/projects/' + projectId + '/currency/', store, this.props.token, attr);
    }
  }, {
    key: 'handleError',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(store, msg, errorObj) {
        var isBugsnag = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: msg }));

              case 2:
                if (isBugsnag) Bugsnag.notifyException(errorObj);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function handleError(_x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return handleError;
    }()
  }, {
    key: 'submit',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(validations, project) {
        var _this2 = this;

        var store, errors, projectCurrency, projectBankAccount, res, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });
                projectCurrency = project.projectCurrency || [];
                projectBankAccount = project.projectBankAccount || [];

                if (!(errors.length > 0)) {
                  _context3.next = 7;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: _i18next2.default.t('Please fix form errors', { ns: 'translation' }), list: errors.map(function (l) {
                    return l.message;
                  }).filter(function (m, idx, arr) {
                    return arr.indexOf(m) === idx;
                  }) }));
                return _context3.abrupt('return');

              case 7:
                res = void 0;
                _context3.prev = 8;
                _context3.next = 11;
                return this.form.getWrappedInstance().getWrappedInstance().submit('/projects/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(project)
                });

              case 11:
                res = _context3.sent;
                _context3.next = 24;
                break;

              case 14:
                _context3.prev = 14;
                _context3.t0 = _context3['catch'](8);

                if (!(_context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 22;
                  break;
                }

                _context3.next = 19;
                return _context3.t0.res.text();

              case 19:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 22:
                store.dispatch((0, _flash.flashErrorMessage)(_context3.t0));
                return _context3.abrupt('return');

              case 24:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false, function () {
                    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(noChanges) {
                      var promiseArr, promiseResultArray, noError;
                      return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              if (!noChanges) {
                                _context2.next = 10;
                                break;
                              }

                              promiseArr = [projectCurrency.map(function (c) {
                                return _this2.addCurrency(res.id, c);
                              }), projectBankAccount.map(function (c) {
                                return _this2.addBankAccount(res.id, c);
                              })];

                              if (!(promiseArr.length > 0)) {
                                _context2.next = 8;
                                break;
                              }

                              _context2.next = 5;
                              return Promise.all(promiseArr);

                            case 5:
                              promiseResultArray = _context2.sent;
                              noError = promiseResultArray.every(function (response) {
                                return response.error === false;
                              });

                              if (!noError) {
                                _this2.handleError(store, _i18next2.default.t('An error occurred, please refresh page', { ns: 'translation' }));
                              }

                            case 8:
                              store.dispatch((0, _reactRouterRedux.push)('/projects/' + res.id + '/'));
                              store.dispatch((0, _flash.flashSuccessMessage)({ header: _i18next2.default.t('Create Success', { ns: 'translation' }), message: _i18next2.default.t('{{name}} successfully created', { ns: 'translation', name: res.name }) }));

                            case 10:
                            case 'end':
                              return _context2.stop();
                          }
                        }
                      }, _callee2, _this2);
                    }));

                    return function (_x8) {
                      return _ref3.apply(this, arguments);
                    };
                  }());
                });

              case 25:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[8, 14]]);
      }));

      function submit(_x6, _x7) {
        return _ref2.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: _i18next2.default.t('New', { ns: 'constants' }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: _i18next2.default.t('Create', { ns: 'translation' }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref4) {
            _this3.form = _ref4;
          },
          onSubmit: function onSubmit(validations, project) {
            _this3.submit(validations, project);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading,
          auth: this.props.auth
        })
      );
    }
  }]);

  return New;
}(_react.Component);

New.propTypes = {
  auth: _propTypes2.default.shape({
    isBranchLeaderSupervisorII: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool
  }),
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  onCheck: _propTypes2.default.func
};
New.contextTypes = {
  store: _propTypes2.default.object
};

New.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

exports.default = (0, _reactRedux.connect)(New.mapStateToProps)(New);

/***/ }),
/* 2460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Projects = function (_Component) {
  _inherits(Projects, _Component);

  function Projects(props) {
    _classCallCheck(this, Projects);

    var _this = _possibleConstructorReturn(this, (Projects.__proto__ || Object.getPrototypeOf(Projects)).call(this, props));

    _this.state = {
      token: null,
      count: 0,
      limit: 0,
      offset: 0,
      loading: true,
      data: [],
      projectPins: [],
      projectPinsToken: null
    };
    return _this;
  }

  _createClass(Projects, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var store = this.context.store;
      var _props$location = this.props.location,
          pathname = _props$location.pathname,
          query = _props$location.query;

      this.fetchProjects(query, true);
      if (!pathname.includes('/new/') && !pathname.includes('/new_old/')) {
        if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
          delete query.page;
        }
        store.dispatch((0, _reactRouterRedux.replace)('/projects/?' + _qs2.default.stringify(query)));
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _nextProps$location = nextProps.location,
          pathname = _nextProps$location.pathname,
          query = _nextProps$location.query;

      if (!pathname.includes('/new/') && !pathname.includes('/new_old/')) {
        if (!this.state.loading) {
          var isFirstPage = parseInt(query.page || 1, 10) === 1;
          this.fetchProjects(query, isFirstPage);
        }
      }
    }
  }, {
    key: 'setProjects',
    value: function setProjects() {
      var _this2 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this2.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setProjectPins',
    value: function setProjectPins() {
      var _this3 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this3.setState({
          projectPins: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this4 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this4.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this5 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this5.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchProjects',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q, shouldFetchPinned) {
        var store, t, query, queryKeys, hasBuFilter, hasStatusFilter, hasStateFilter, hasFilter, res, message, token, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, q);

                query.excludePinned = false;
                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                queryKeys = Object.keys(query);
                hasBuFilter = queryKeys.some(function (key) {
                  return key.startsWith('projectBusinessUnit');
                });
                hasStatusFilter = queryKeys.some(function (key) {
                  return key.startsWith('projectStatus');
                });
                hasStateFilter = queryKeys.some(function (key) {
                  return key.startsWith('projectState');
                });
                hasFilter = hasBuFilter || hasStatusFilter || hasStateFilter || query.dateRange && query.dateRange.length > 0 || query.dateFrom && query.dateFrom.length > 0 || query.dateTo && query.dateTo.length > 0 || query.search && query.search.length > 0;

                if (!hasFilter) {
                  query.excludePinned = true;
                }

                res = void 0;
                _context.prev = 14;
                _context.next = 17;
                return store.dispatch((0, _fetchM.fetchM)('/projects/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 17:
                res = _context.sent;
                _context.next = 28;
                break;

              case 20:
                _context.prev = 20;
                _context.t0 = _context['catch'](14);

                Bugsnag.notifyException(_context.t0);
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page') }));

              case 25:
                _context.next = 27;
                return this.setLoading(false);

              case 27:
                return _context.abrupt('return');

              case 28:
                if (res.ok) {
                  _context.next = 36;
                  break;
                }

                _context.next = 31;
                return res.text();

              case 31:
                message = _context.sent;
                _context.next = 34;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 34:
                _context.next = 48;
                break;

              case 36:
                token = res.headers.get('X-Csrf-Token');
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 42;
                return res.json();

              case 42:
                data = _context.sent;
                _context.next = 45;
                return this.setProjects(data);

              case 45:
                _context.next = 47;
                return this.setComponentState({
                  token: token,
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 47:
                if (shouldFetchPinned) {
                  this.fetchPinnedProjects();
                }

              case 48:
                _context.next = 50;
                return this.setLoading(false);

              case 50:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[14, 20]]);
      }));

      function fetchProjects(_x5, _x6) {
        return _ref.apply(this, arguments);
      }

      return fetchProjects;
    }()
  }, {
    key: 'fetchPinnedProjects',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, t, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context2.prev = 5;
                _context2.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/project_pins/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context2.sent;
                _context2.next = 19;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](5);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page') }));

              case 16:
                _context2.next = 18;
                return this.setLoading(false);

              case 18:
                return _context2.abrupt('return');

              case 19:
                if (res.ok) {
                  _context2.next = 27;
                  break;
                }

                _context2.next = 22;
                return res.text();

              case 22:
                message = _context2.sent;
                _context2.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context2.next = 35;
                break;

              case 27:
                token = res.headers.get('X-Csrf-Token');
                _context2.next = 30;
                return res.json();

              case 30:
                data = _context2.sent;
                _context2.next = 33;
                return this.setProjectPins(data);

              case 33:
                _context2.next = 35;
                return this.setComponentState({
                  projectPinsToken: token
                });

              case 35:
                _context2.next = 37;
                return this.setLoading(false);

              case 37:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 11]]);
      }));

      function fetchPinnedProjects() {
        return _ref2.apply(this, arguments);
      }

      return fetchPinnedProjects;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this6 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this6.state.token,
          count: _this6.state.count,
          limit: _this6.state.limit,
          offset: _this6.state.offset,
          loading: _this6.state.loading,
          data: _this6.state.data,
          projectPins: _this6.state.projectPins,
          projectPinsToken: _this6.state.projectPinsToken
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Projects;
}(_react.Component);

Projects.propTypes = {
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object
  })
};
Projects.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.translation)(Projects);

/***/ }),
/* 2461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _fetchM = __webpack_require__(6);

var _siteplanSVG = __webpack_require__(596);

var _url = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UploadImageForm = function (_Component) {
  _inherits(UploadImageForm, _Component);

  function UploadImageForm(props) {
    _classCallCheck(this, UploadImageForm);

    var _this = _possibleConstructorReturn(this, (UploadImageForm.__proto__ || Object.getPrototypeOf(UploadImageForm)).call(this, props));

    _this.getSvgDocument = function (url) {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, false);
      xhr.onload = _this.setSVG;
      xhr.send();
    };

    _this.setSVG = function (event) {
      var svgData = event.currentTarget.responseXML;
      _this.setState({ svgData: svgData });
    };

    _this.handleSubmit = function (event) {
      event.preventDefault();
      if (_this.state.uploads.length > 0) {
        var formData = new FormData(_this.form);
        formData.append('file_image', _this.state.uploads[0].file);
        if (_this.props.onSubmit) {
          _this.props.onSubmit(event, formData);
        }
      }
    };

    _this.handleOnChange = function () {
      var files = Array.prototype.slice.call(_this.uploadFile.files);
      _this.uploadFile.value = null;
      if (window.FileReader) {
        files.forEach(function (file) {
          var reader = new FileReader();
          reader.onloadend = function () {
            var uploads = _this.state.uploads;

            var name = file.name.substring(0, file.name.length - 4);
            uploads[0] = {
              file: file,
              name: name,
              src: reader.result
            };
            _this.setState({ uploads: uploads }, function () {
              _this.handleCheckChanges();
            });
          };
          reader.readAsDataURL(file);
        });
      }
    };

    _this.handleRemove = function (event) {
      event.preventDefault();
      _this.setState({ uploads: [] });
    };

    _this.handleAddFile = function (event) {
      event.preventDefault();
      _this.uploadFile.click();
    };

    _this.state = {
      loading: false,
      uploads: [],
      svgData: null
    };
    return _this;
  }

  _createClass(UploadImageForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var siteplan = this.props.siteplan;

      if (siteplan && siteplan.id && siteplan.key) {
        var url = (0, _url.siteplanUrl)(this.props.appConfig, '' + siteplan.key + (siteplan.svgUploadedAt ? '_' + (0, _momentTimezone2.default)(siteplan.svgUploadedAt).format('YYYYMMDDHHmmss') : '') + '.svg');
        this.getSvgDocument(url);
      }
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'submit',
    value: function submit(url) {
      var _this3 = this;

      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var store = this.context.store;

      return this.setLoading(true).then(function () {
        return store.dispatch((0, _fetchM.fetchM)(url, opts));
      }).then(function (res) {
        return res.json();
      }).then(function (result) {
        return _this3.setLoading(false).then(function () {
          return _this3.resetFiles();
        }).then(function () {
          return result;
        });
      }).catch(function (err) {
        return _this3.setLoading(false).then(function () {
          return _this3.resetFiles();
        }).then(function () {
          return Promise.reject(err);
        });
      });
    }
  }, {
    key: 'resetFiles',
    value: function resetFiles() {
      // temporary fix for upload modal not closing
      this.setState({
        uploads: []
      });
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      var _this4 = this;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true }, function () {
          if (_this4.props.onChange) {
            _this4.props.onChange(true);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      return _react2.default.createElement(
        'form',
        {
          encType: 'multipart/form-data',
          onSubmit: this.handleSubmit,
          name: 'uploadSvg',
          ref: function ref(_ref2) {
            _this5.form = _ref2;
          }
        },
        _react2.default.createElement('input', {
          ref: function ref(_ref) {
            _this5.uploadFile = _ref;
          },
          type: 'file',
          onChange: this.handleOnChange,
          accept: 'image/gif, image/jpeg, image/png',
          style: { display: 'none' }
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 'equal' },
            _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'computer' }),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { verticalAlign: 'middle', columns: 'equal' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Button, {
                    fluid: true,
                    compact: true,
                    primary: true,
                    icon: this.state.uploads.length < 1 && 'add',
                    content: this.state.uploads.length > 0 ? 'Replace' : 'Image',
                    onClick: this.handleAddFile,
                    disabled: this.state.loading
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Button, {
                    fluid: true,
                    compact: true,
                    type: 'submit',
                    positive: true,
                    content: 'Upload', icon: 'cloud upload',
                    loading: this.state.loading,
                    disabled: this.state.uploads.length < 1 || this.state.loading
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { stackable: true, doubling: true, columns: 1 },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { indeterminate: true, inline: 'centered' },
              'Uploading'
            )
          ),
          this.state.uploads.length > 0 ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Segment,
              null,
              this.props.siteplan && this.props.siteplan.id && this.props.siteplan.key ? _react2.default.createElement(
                'b',
                null,
                'Preview with uploaded SVG'
              ) : null,
              _react2.default.createElement('div', {
                dangerouslySetInnerHTML: {
                  __html: (0, _siteplanSVG.displaySVG)(this.state.svgData, this.state.uploads[0].src)
                }
              }),
              _react2.default.createElement(_semanticUiReact.Label, {
                as: 'a',
                corner: true,
                color: 'red',
                icon: 'delete',
                disabled: this.state.loading,
                onClick: this.handleRemove
              })
            )
          ) : null
        )
      );
    }
  }]);

  return UploadImageForm;
}(_react.Component);

UploadImageForm.propTypes = {
  appConfig: _propTypes2.default.shape({}),
  onSubmit: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  siteplan: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    key: _propTypes2.default.string
  })
};
UploadImageForm.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = UploadImageForm;

/***/ }),
/* 2462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _fetchM = __webpack_require__(6);

var _siteplanSVG = __webpack_require__(596);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UploadSiteplanForm = function (_Component) {
  _inherits(UploadSiteplanForm, _Component);

  function UploadSiteplanForm(props) {
    _classCallCheck(this, UploadSiteplanForm);

    var _this = _possibleConstructorReturn(this, (UploadSiteplanForm.__proto__ || Object.getPrototypeOf(UploadSiteplanForm)).call(this, props));

    _this.handleSubmit = function (event) {
      event.preventDefault();
      if (_this.state.uploads.filter(function (u) {
        return u !== null;
      }).length > 1) {
        var formData = new FormData(_this.form);
        _this.state.uploads.forEach(function (upload, idx) {
          formData.append('files_' + idx, upload.file);
        });
        formData.append('name', _this.state.name);
        if (_this.props.onSubmit) {
          _this.props.onSubmit(event, formData);
        }
      }
    };

    _this.handleOnChange = function (type) {
      if (_this.uploadFile[type]) {
        var files = Array.prototype.slice.call(_this.uploadFile[type].files);
        _this.uploadFile[type].value = null;
        if (window.FileReader) {
          files.forEach(function (file) {
            var reader = new FileReader();
            reader.onloadend = function () {
              var uploads = _this.state.uploads;

              var name = file.name.substring(0, file.name.length - 4);
              var src = reader.result;
              if (type === 'svg') {
                if ((0, _siteplanSVG.checkSvgFormatValid)(src)) {
                  uploads[0] = {
                    file: file,
                    name: name,
                    src: src
                  };
                } else {
                  uploads[0] = null;
                }
              } else {
                uploads[1] = {
                  file: file,
                  name: name,
                  src: src
                };
              }
              _this.setState({ uploads: uploads, name: name }, function () {
                _this.handleCheckChanges();
              });
            };
            if (type === 'svg') {
              reader.readAsText(file);
            } else {
              reader.readAsDataURL(file);
            }
          });
        }
      }
    };

    _this.handleRemove = function (event, type) {
      event.preventDefault();
      var uploads = _this.state.uploads;

      var idx = type === 'svg' ? 0 : 1;
      uploads[idx] = null;
      _this.setState({ uploads: uploads });
    };

    _this.handleAddFile = function (event, type) {
      event.preventDefault();
      if (_this.uploadFile[type]) {
        _this.uploadFile[type].click();
      }
    };

    _this.state = {
      loading: false,
      uploads: [null, null],
      name: ''
    };
    _this.uploadFile = {};
    return _this;
  }

  _createClass(UploadSiteplanForm, [{
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'submit',
    value: function submit(url) {
      var _this3 = this;

      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var store = this.context.store;

      return this.setLoading(true).then(function () {
        return store.dispatch((0, _fetchM.fetchM)(url, opts));
      }).then(function (res) {
        return res.json();
      }).then(function (result) {
        return _this3.setLoading(false).then(function () {
          return _this3.resetFiles();
        }).then(function () {
          return result;
        });
      }).catch(function (err) {
        return _this3.setLoading(false).then(function () {
          return _this3.resetFiles();
        }).then(function () {
          return Promise.reject(err);
        });
      });
    }
  }, {
    key: 'resetFiles',
    value: function resetFiles() {
      // temporary fix for upload modal not closing
      this.setState({
        uploads: [null, null]
      });
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      var _this4 = this;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true }, function () {
          if (_this4.props.onChange) {
            _this4.props.onChange(true);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var uploads = this.state.uploads;

      var svgUrl = void 0;
      var svgImgUrl = void 0;
      if (uploads.length > 0) {
        if (uploads[0] && uploads[0].src) {
          svgUrl = uploads[0].src;
        }
        if (uploads[1] && uploads[1].src) {
          svgImgUrl = uploads[1].src;
        }
      }
      return _react2.default.createElement(
        'form',
        {
          encType: 'multipart/form-data',
          onSubmit: this.handleSubmit,
          name: 'uploadSiteplan',
          ref: function ref(_ref3) {
            _this5.form = _ref3;
          }
        },
        _react2.default.createElement('input', {
          ref: function ref(_ref) {
            _this5.uploadFile.svg = _ref;
          },
          type: 'file',
          onChange: function onChange() {
            return _this5.handleOnChange('svg');
          },
          accept: 'image/svg+xml',
          style: { display: 'none' }
        }),
        _react2.default.createElement('input', {
          ref: function ref(_ref2) {
            _this5.uploadFile.image = _ref2;
          },
          type: 'file',
          onChange: function onChange() {
            return _this5.handleOnChange('image');
          },
          accept: 'image/gif, image/jpeg, image/png',
          style: { display: 'none' }
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 'equal' },
            _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'computer' }),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { verticalAlign: 'middle', columns: 'equal' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Button, {
                    fluid: true,
                    compact: true,
                    positive: true,
                    content: 'Upload', icon: 'cloud upload',
                    loading: this.state.loading,
                    onClick: this.handleSubmit,
                    disabled: uploads.filter(function (u) {
                      return u !== null;
                    }).length < 2 || this.state.loading
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { stackable: true, doubling: true, columns: 2 },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { indeterminate: true, inline: 'centered' },
              'Uploading'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            svgUrl ? _react2.default.createElement(
              _semanticUiReact.Segment,
              { secondary: true },
              _react2.default.createElement('div', {
                dangerouslySetInnerHTML: {
                  __html: (0, _siteplanSVG.displaySVG)(svgUrl)
                }
              }),
              _react2.default.createElement(_semanticUiReact.Label, {
                as: 'a',
                corner: true,
                color: 'red',
                icon: 'delete',
                disabled: this.state.loading,
                onClick: function onClick(e) {
                  return _this5.handleRemove(e, 'svg');
                }
              })
            ) : _react2.default.createElement(
              _semanticUiReact.Segment,
              { secondary: true },
              _react2.default.createElement(_semanticUiReact.Button, {
                fluid: true,
                compact: true,
                primary: true,
                icon: 'add',
                content: 'SVG',
                onClick: function onClick(e) {
                  return _this5.handleAddFile(e, 'svg');
                },
                disabled: this.state.loading
              })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            svgImgUrl ? _react2.default.createElement(
              _semanticUiReact.Segment,
              { secondary: true },
              _react2.default.createElement(_LoadImage2.default, { fluid: true, src: svgImgUrl }),
              _react2.default.createElement(_semanticUiReact.Label, {
                as: 'a',
                corner: true,
                color: 'red',
                icon: 'delete',
                disabled: this.state.loading,
                onClick: function onClick(e) {
                  return _this5.handleRemove(e, 'image');
                }
              })
            ) : _react2.default.createElement(
              _semanticUiReact.Segment,
              { secondary: true },
              _react2.default.createElement(_semanticUiReact.Button, {
                fluid: true,
                compact: true,
                primary: true,
                icon: 'add',
                content: 'Image',
                onClick: function onClick(e) {
                  return _this5.handleAddFile(e, 'image');
                },
                disabled: this.state.loading
              })
            )
          ),
          svgUrl && svgImgUrl ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Segment,
              null,
              _react2.default.createElement(
                'b',
                null,
                'Preview'
              ),
              _react2.default.createElement('div', {
                dangerouslySetInnerHTML: {
                  __html: (0, _siteplanSVG.displaySVG)(svgUrl, svgImgUrl)
                }
              })
            )
          ) : null
        )
      );
    }
  }]);

  return UploadSiteplanForm;
}(_react.Component);

UploadSiteplanForm.propTypes = {
  onSubmit: _propTypes2.default.func,
  onChange: _propTypes2.default.func
};
UploadSiteplanForm.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = UploadSiteplanForm;

/***/ }),
/* 2463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _fetchM = __webpack_require__(6);

var _siteplanSVG = __webpack_require__(596);

var _url = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UploadSvgForm = function (_Component) {
  _inherits(UploadSvgForm, _Component);

  function UploadSvgForm(props) {
    _classCallCheck(this, UploadSvgForm);

    var _this = _possibleConstructorReturn(this, (UploadSvgForm.__proto__ || Object.getPrototypeOf(UploadSvgForm)).call(this, props));

    _this.handleSubmit = function (event) {
      event.preventDefault();
      if (_this.state.uploads.length > 0) {
        var formData = new FormData(_this.form);
        formData.append('file_svg', _this.state.uploads[0].file);
        if (_this.props.onSubmit) {
          _this.props.onSubmit(event, formData);
        }
      }
    };

    _this.handleOnChange = function () {
      var files = Array.prototype.slice.call(_this.uploadFile.files);
      _this.uploadFile.value = null;
      if (window.FileReader) {
        files.forEach(function (file) {
          var reader = new FileReader();
          reader.onloadend = function () {
            var uploads = _this.state.uploads;

            var name = file.name.substring(0, file.name.length - 4);
            var src = reader.result;
            if ((0, _siteplanSVG.checkSvgFormatValid)(src)) {
              uploads[0] = {
                file: file,
                name: name,
                src: src
              };
            } else {
              uploads = [];
            }
            _this.setState({ uploads: uploads }, function () {
              _this.handleCheckChanges();
            });
          };
          reader.readAsText(file);
        });
      }
    };

    _this.handleRemove = function (event) {
      event.preventDefault();
      _this.setState({ uploads: [] });
    };

    _this.handleAddFile = function (event) {
      event.preventDefault();
      _this.uploadFile.click();
    };

    _this.state = {
      loading: false,
      uploads: []
    };
    return _this;
  }

  _createClass(UploadSvgForm, [{
    key: 'setLoading',
    value: function setLoading() {
      var _this2 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this2.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'submit',
    value: function submit(url) {
      var _this3 = this;

      var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var store = this.context.store;

      return this.setLoading(true).then(function () {
        return store.dispatch((0, _fetchM.fetchM)(url, opts));
      }).then(function (res) {
        return res.json();
      }).then(function (result) {
        return _this3.setLoading(false).then(function () {
          return _this3.resetFiles();
        }).then(function () {
          return result;
        });
      }).catch(function (err) {
        return _this3.setLoading(false).then(function () {
          return _this3.resetFiles();
        }).then(function () {
          return Promise.reject(err);
        });
      });
    }
  }, {
    key: 'resetFiles',
    value: function resetFiles() {
      // temporary fix for upload modal not closing
      this.setState({
        uploads: []
      });
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      var _this4 = this;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true }, function () {
          if (_this4.props.onChange) {
            _this4.props.onChange(true);
          }
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var siteplan = this.props.siteplan;

      var svgImgUrl = void 0;
      if (siteplan && siteplan.id && siteplan.key) {
        svgImgUrl = (0, _url.siteplanUrl)(this.props.appConfig, '' + siteplan.key + (siteplan.imageUploadedAt ? '_' + (0, _momentTimezone2.default)(siteplan.imageUploadedAt).format('YYYYMMDDHHmmss') : '') + '.jpg');
      }
      return _react2.default.createElement(
        'form',
        {
          encType: 'multipart/form-data',
          onSubmit: this.handleSubmit,
          name: 'uploadSvg',
          ref: function ref(_ref2) {
            _this5.form = _ref2;
          }
        },
        _react2.default.createElement('input', {
          ref: function ref(_ref) {
            _this5.uploadFile = _ref;
          },
          type: 'file',
          onChange: this.handleOnChange,
          accept: 'image/svg+xml',
          style: { display: 'none' }
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { columns: 'equal' },
            _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'computer' }),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { verticalAlign: 'middle', columns: 'equal' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Button, {
                    fluid: true,
                    compact: true,
                    primary: true,
                    icon: this.state.uploads.length < 1 && 'add',
                    content: this.state.uploads.length > 0 ? 'Replace' : 'SVG',
                    onClick: this.handleAddFile,
                    disabled: this.state.loading
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  null,
                  _react2.default.createElement(_semanticUiReact.Button, {
                    fluid: true,
                    compact: true,
                    type: 'submit',
                    positive: true,
                    content: 'Upload', icon: 'cloud upload',
                    loading: this.state.loading,
                    disabled: this.state.uploads.length < 1 || this.state.loading
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { stackable: true, doubling: true, columns: 1 },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { indeterminate: true, inline: 'centered' },
              'Uploading'
            )
          ),
          this.state.uploads.length > 0 ? _react2.default.createElement(
            _semanticUiReact.Grid.Column,
            null,
            _react2.default.createElement(
              _semanticUiReact.Segment,
              null,
              this.props.siteplan && this.props.siteplan.id && this.props.siteplan.key ? _react2.default.createElement(
                'b',
                null,
                'Preview with uploaded image'
              ) : null,
              _react2.default.createElement('div', {
                dangerouslySetInnerHTML: {
                  __html: (0, _siteplanSVG.displaySVG)(this.state.uploads[0].src, svgImgUrl)
                }
              }),
              _react2.default.createElement(_semanticUiReact.Label, {
                as: 'a',
                corner: true,
                color: 'red',
                icon: 'delete',
                disabled: this.state.loading,
                onClick: this.handleRemove
              })
            )
          ) : null
        )
      );
    }
  }]);

  return UploadSvgForm;
}(_react.Component);

UploadSvgForm.propTypes = {
  appConfig: _propTypes2.default.shape({}),
  onSubmit: _propTypes2.default.func,
  onChange: _propTypes2.default.func,
  siteplan: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    key: _propTypes2.default.string
  })
};
UploadSvgForm.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = UploadSvgForm;

/***/ }),
/* 2464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Projects = __webpack_require__(2460);

var _Projects2 = _interopRequireDefault(_Projects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Projects2.default;

/***/ }),
/* 2465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _reactRedux = __webpack_require__(9);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _url = __webpack_require__(19);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Reports = __webpack_require__(1030);

var _Filters = __webpack_require__(86);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _SearchIn = __webpack_require__(570);

var _SearchIn2 = _interopRequireDefault(_SearchIn);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _apiEndpoints = __webpack_require__(140);

var endpoints = _interopRequireWildcard(_apiEndpoints);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _dateRanges = __webpack_require__(265);

var _bankCaseStatuses = __webpack_require__(264);

var _translation = __webpack_require__(4);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Overview = function (_Component) {
  _inherits(Overview, _Component);

  function Overview(props) {
    _classCallCheck(this, Overview);

    var _this = _possibleConstructorReturn(this, (Overview.__proto__ || Object.getPrototypeOf(Overview)).call(this, props));

    _initialiseProps.call(_this);

    var state = Overview.getPropsToState(props);
    var query = (0, _url.decodeSearch)(props.location.search);
    _this.state = _extends({}, state, {
      projectList: [],
      lawyerList: [],
      firmList: [],
      projectLayoutList: [],
      buList: [],
      loading: true,
      currentTab: query.tab || _this.tabs(_this.props.appConfig, _this.props.auth)[0].value,
      count: 0,
      dataSize: 0,
      limit: 0,
      offset: 0,
      reportLoading: false,
      firmSelected: false,
      lawyerSelected: false
    });
    return _this;
  }

  _createClass(Overview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchProjectList();
      if (this.state.currentTab === 'project_unit') {
        if (this.state.projectID.length === 1) {
          this.fetchProjectLayoutList();
        } else {
          this.state.projectUnitLayoutID = '';
        }
      }
      this.fetchLawyerList();
      this.fetchFirmList();
      this.fetchBUList();
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Overview.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchProjectList',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, json, projectList;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/search/projects/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                return _context.abrupt('return');

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 32;
                break;

              case 26:
                _context.next = 28;
                return res.json();

              case 28:
                json = _context.sent;
                projectList = this.editImageSrc(json);
                _context.next = 32;
                return this.setComponentState({
                  projectList: projectList
                });

              case 32:
                _context.next = 34;
                return this.setLoading(false);

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchProjectList() {
        return _ref.apply(this, arguments);
      }

      return fetchProjectList;
    }()
  }, {
    key: 'fetchLawyerList',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, res, lawyerList;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context2.prev = 4;
                _context2.next = 7;
                return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.LAWYERS + '/?limit=500', null, 'get', {
                  'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
                }));

              case 7:
                res = _context2.sent;
                _context2.next = 18;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](4);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context2.next = 17;
                return this.setLoading(false);

              case 17:
                return _context2.abrupt('return');

              case 18:
                if (!res) {
                  _context2.next = 22;
                  break;
                }

                lawyerList = this.editLawyerData(res.items);
                _context2.next = 22;
                return this.setComponentState({
                  lawyerList: lawyerList
                });

              case 22:
                _context2.next = 24;
                return this.setLoading(false);

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10]]);
      }));

      function fetchLawyerList() {
        return _ref2.apply(this, arguments);
      }

      return fetchLawyerList;
    }()
  }, {
    key: 'fetchFirmList',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var store, res, company, firmList;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                company = this.props.appConfig.data.companyID;
                _context3.prev = 5;
                _context3.next = 8;
                return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.LAWYERS + '/?limit=500&firm=true&company_id=' + company, null, 'get', {
                  'X-Api-Token': "8E2483F8-512D-41F6-B012-346EE9CDA47A"
                }));

              case 8:
                res = _context3.sent;
                _context3.next = 19;
                break;

              case 11:
                _context3.prev = 11;
                _context3.t0 = _context3['catch'](5);

                Bugsnag.notifyException(_context3.t0);
                _context3.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 16:
                _context3.next = 18;
                return this.setLoading(false);

              case 18:
                return _context3.abrupt('return');

              case 19:
                if (!res) {
                  _context3.next = 23;
                  break;
                }

                firmList = this.editFirmData(res);
                _context3.next = 23;
                return this.setComponentState({
                  firmList: firmList
                });

              case 23:
                _context3.next = 25;
                return this.setLoading(false);

              case 25:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 11]]);
      }));

      function fetchFirmList() {
        return _ref3.apply(this, arguments);
      }

      return fetchFirmList;
    }()
  }, {
    key: 'fetchProjectLayoutList',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var store, projectID, res, message, jsonData, projectLayoutList;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                projectID = this.state.projectID;
                res = void 0;
                _context4.prev = 5;
                _context4.next = 8;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/search/project_unit_layouts/?projectID=' + projectID, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context4.sent;
                _context4.next = 19;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](5);

                Bugsnag.notifyException(_context4.t0);
                _context4.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 16:
                _context4.next = 18;
                return this.setLoading(false);

              case 18:
                return _context4.abrupt('return');

              case 19:
                if (res.ok) {
                  _context4.next = 27;
                  break;
                }

                _context4.next = 22;
                return res.text();

              case 22:
                message = _context4.sent;
                _context4.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context4.next = 33;
                break;

              case 27:
                _context4.next = 29;
                return res.json();

              case 29:
                jsonData = _context4.sent;
                projectLayoutList = this.editProjectLayoutData(jsonData);
                _context4.next = 33;
                return this.setComponentState({
                  projectLayoutList: projectLayoutList
                });

              case 33:
                _context4.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 11]]);
      }));

      function fetchProjectLayoutList() {
        return _ref4.apply(this, arguments);
      }

      return fetchProjectLayoutList;
    }()
  }, {
    key: 'fetchBUList',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var store, res, message, jsonData, buList;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = null;
                _context5.prev = 4;
                _context5.next = 7;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/company_branches/?page=all&getProjects=true', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context5.sent;
                _context5.next = 18;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](4);

                Bugsnag.notifyException(_context5.t0);
                _context5.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context5.next = 17;
                return this.setLoading(false);

              case 17:
                return _context5.abrupt('return');

              case 18:
                if (res.ok) {
                  _context5.next = 26;
                  break;
                }

                _context5.next = 21;
                return res.text();

              case 21:
                message = _context5.sent;
                _context5.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context5.next = 32;
                break;

              case 26:
                _context5.next = 28;
                return res.json();

              case 28:
                jsonData = _context5.sent;
                buList = this.editBUData(jsonData);
                _context5.next = 32;
                return this.setComponentState({
                  buList: buList
                });

              case 32:
                _context5.next = 34;
                return this.setLoading(false);

              case 34:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[4, 10]]);
      }));

      function fetchBUList() {
        return _ref5.apply(this, arguments);
      }

      return fetchBUList;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(q) {
      var clearSort = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var query = q;
      var store = this.context.store;
      var pathname = this.props.location.pathname;

      if (clearSort) {
        delete query.sortColumn;
        delete query.sortDirection;
      }
      var projectID = (0, _url.decodeSearch)(this.props.location.search).projectID;
      var dateRange = (0, _url.decodeSearch)(this.props.location.search).dateRange;
      var search = (0, _url.decodeSearch)(this.props.location.search).search;
      if (query.projectID && !projectID || query.dateRange && !dateRange || query.search && !search) {
        query.page = 1;
      }
      store.dispatch((0, _reactRouterRedux.replace)(pathname + '?' + (0, _url.encodeSearch)(query)));
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          banks = _props.banks,
          t = _props.t;
      var _state = this.state,
          currentTab = _state.currentTab,
          isMobile = _state.isMobile,
          isTablet = _state.isTablet,
          currentPage = _state.currentPage,
          count = _state.count,
          limit = _state.limit,
          offset = _state.offset,
          dataSize = _state.dataSize,
          reportLoading = _state.reportLoading;

      var _getCurrentTabData = this.getCurrentTabData(),
          header = _getCurrentTabData.header,
          subheader = _getCurrentTabData.subheader,
          barChart = _getCurrentTabData.barChart,
          CurrentTabComponent = _getCurrentTabData.component,
          filterNames = _getCurrentTabData.filterNames,
          tabFilterNames = _getCurrentTabData.tabFilterNames,
          exportItems = _getCurrentTabData.exportItems,
          sortItems = _getCurrentTabData.sortItems;

      var commonFilterNames = ['projectID', 'dateRange', 'dateTo', 'dateFrom', 'search'];
      var allFilterNames = [].concat(commonFilterNames, filterNames);
      var hasPage = tabFilterNames && tabFilterNames.length > 0 && tabFilterNames.some(function (filter) {
        return filter === 'page';
      });
      var hasSearch = tabFilterNames && tabFilterNames.length > 0 && tabFilterNames.some(function (filter) {
        return filter === 'search';
      });
      var exportOptions = exportItems.map(function (item) {
        return {
          text: item.text,
          icon: 'download',
          href: _this4.exportURL(item.href, allFilterNames)
        };
      });
      var hasSortsOrExports = sortItems && sortItems.length > 0 || exportOptions && exportOptions.length > 0;
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Reports', { ns: 'screens' })
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', className: 'booking-list' },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'tab-menu' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Menu,
                {
                  attached: 'top',
                  tabular: true
                },
                this.tabs(this.props.appConfig, this.props.auth).filter(function (tb) {
                  return !tb.disabled;
                }).map(function (tab, key) {
                  return _react2.default.createElement(
                    _semanticUiReact.Menu.Item,
                    {
                      key: key,
                      name: tab.name,
                      onClick: _this4.handleChangeTab,
                      active: currentTab === tab.name
                    },
                    t(tab.text).toUpperCase()
                  );
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'toolbar' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                {
                  className: 'filters',
                  columns: 'equal',
                  textAlign: 'left',
                  verticalAlign: 'middle'
                },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  !isMobile && hasPage && _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    {
                      className: 'pagination tablet-hide',
                      tablet: 4,
                      computer: 3
                    },
                    _react2.default.createElement(_PageNav2.default, {
                      currentPage: currentPage,
                      count: count,
                      limit: limit,
                      offset: offset,
                      dataSize: dataSize,
                      loading: reportLoading,
                      onChange: this.handleChangePage,
                      noScrollTop: true
                    })
                  ),
                  currentTab !== 'lawyers' && _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    {
                      className: 'filter',
                      mobile: this.checkTab(7, 8, 7, 7, 7),
                      tablet: this.checkTab(6, 8, 7, 7, 7),
                      computer: this.checkTab(4, 4, 3, 3, 3),
                      style: hasPage ? { paddingLeft: 0 } : {}
                    },
                    _react2.default.createElement(_Filters.BookingDatePicker, {
                      filterName: 'dateRange',
                      filterNameFrom: 'dateFrom',
                      filterNameTo: 'dateTo',
                      dateFrom: this.state.dateFrom,
                      dateTo: this.state.dateTo,
                      onChange: this.handleFilterOnChange,
                      onClose: this.handleClearFilter,
                      onResetRange: this.handleClearFilter,
                      onSetRange: this.handleSetDateRange,
                      value: this.state.dateRange,
                      disabled: this.state.loading,
                      options: _dateRanges.REPORT_DATE_RANGES
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    {
                      className: 'filter',
                      mobile: this.checkTab(7, 8, 7, 7, 7, 8),
                      tablet: this.checkTab(8, 7, 7, 7, 7, 5),
                      computer: this.checkTab(4, 4, 3, 3, 3, 5)
                    },
                    this.checkMultiProjectFilterTab() ? _react2.default.createElement(_Filters.BookingSelectListMultiple, {
                      filterName: 'projectID',
                      onChange: this.handleFilterOnChange,
                      onClose: this.handleClearFilter,
                      options: this.state.projectList,
                      placeholder: t('Select Project'),
                      value: this.state.projectID || [],
                      disabled: this.state.loading
                    }) : _react2.default.createElement(_Filters.BookingSelectList, {
                      filterName: 'projectID',
                      onChange: this.handleFilterOnChange,
                      options: this.state.projectList,
                      placeholder: t('Select Project'),
                      headerText: t('Project'),
                      value: this.state.projectID,
                      disabled: this.state.loading
                    })
                  ),
                  currentTab === 'lawyers' && _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    {
                      className: 'filter',
                      mobile: 8,
                      tablet: 5,
                      computer: 5
                    },
                    _react2.default.createElement(_Filters.BookingSelectListMultiple, {
                      filterName: 'lawyerID',
                      onChange: this.handleFilterOnChange,
                      onClose: this.handleClearFilter,
                      options: this.state.lawyerList,
                      placeholder: t('Select Lawyer'),
                      value: this.state.lawyerID || [],
                      disabled: this.state.loading || this.state.firmSelected
                    })
                  ),
                  currentTab === 'lawyers' && _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    {
                      className: 'filter',
                      mobile: 8,
                      tablet: 4,
                      computer: 4,
                      style: isMobile ? { paddingTop: '0.5rem' } : null
                    },
                    _react2.default.createElement(_Filters.BookingSelectListMultiple, {
                      filterName: 'firmName',
                      onChange: this.handleFilterOnChange,
                      onClose: this.handleClearFilter,
                      options: this.state.firmList,
                      placeholder: t('Select Law Firm'),
                      value: this.state.firmName || [],
                      disabled: this.state.loading || this.state.lawyerSelected
                    })
                  ),
                  currentTab === 'project_unit' && _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    {
                      className: 'filter',
                      mobile: 7,
                      tablet: 6,
                      computer: 4,
                      style: isMobile || isTablet ? {
                        paddingTop: '0.5rem',
                        paddingLeft: 0
                      } : null
                    },
                    _react2.default.createElement(_Filters.BookingSelectList, {
                      filterName: 'projectUnitLayoutID',
                      onChange: this.handleFilterOnChange,
                      options: this.state.projectLayoutList,
                      placeholder: t('Select Project Layout'),
                      headerText: t('Project Layout'),
                      value: this.state.projectUnitLayoutID,
                      disabled: this.state.loading || this.state.projectLayoutList.length < 1,
                      hasSearch: true
                    })
                  ),
                  this.hasBUFilterTab() && _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    {
                      className: 'filter',
                      mobile: this.checkTab(7, 8),
                      tablet: this.checkTab(8, 8),
                      computer: this.checkTab(8, 6),
                      style: isMobile || isTablet || currentTab === 'project_unit' ? {
                        paddingTop: '0.5rem',
                        paddingLeft: 0
                      } : null
                    },
                    _react2.default.createElement(_Filters.BookingSelectList, {
                      filterName: 'businessUnitID',
                      onChange: this.handleFilterOnChange,
                      placeholder: t('Select Business Unit'),
                      headerText: t('Business Unit'),
                      options: this.state.buList,
                      value: this.state.businessUnitID,
                      disabled: this.state.loading
                    })
                  ),
                  currentTab === 'banks' && _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    {
                      className: 'filter',
                      mobile: 7,
                      tablet: 7,
                      computer: 3,
                      style: isMobile || isTablet ? {
                        paddingTop: '0.5rem',
                        paddingLeft: 0
                      } : null
                    },
                    _react2.default.createElement(_Filters.BookingSelectListMultiple, {
                      filterName: 'bankID',
                      onChange: this.handleFilterOnChange,
                      options: banks ? banks.data.map(function (s, key) {
                        return {
                          key: key,
                          text: s.name,
                          value: s.id.toString(),
                          name: s.id.toString()
                        };
                      }) : [],
                      placeholder: t('Select Bank'),
                      headerText: t('Bank'),
                      value: this.state.bankID,
                      disabled: this.state.loading
                    })
                  ),
                  currentTab === 'banks' && _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    {
                      className: 'filter',
                      mobile: 7,
                      tablet: 7,
                      computer: 3,
                      style: isMobile || isTablet ? { paddingTop: '0.5rem' } : null
                    },
                    _react2.default.createElement(_Filters.BookingSelectList, {
                      filterName: 'statusGroup',
                      onChange: this.handleFilterOnChange,
                      options: _bankCaseStatuses.BANK_CASE_STATUS_GROUPS,
                      placeholder: t('Select Status Group'),
                      headerText: t('Status Group'),
                      value: this.state.statusGroup,
                      disabled: this.state.loading,
                      hasSearch: true
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    {
                      textAlign: 'right',
                      className: 'clear',
                      mobile: this.checkTab(2, 2, 2, 2, 2, 8),
                      tablet: 2,
                      computer: this.checkTab(1, 2, 2, 2, 4, 2)
                    },
                    allFilterNames.some(function (filterName) {
                      return _this4.state[filterName] && _this4.state[filterName].length > 0;
                    }) ?
                    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                    _react2.default.createElement(
                      'a',
                      { onClick: function onClick() {
                          return _this4.handleClearFilter.apply(_this4, _toConsumableArray(allFilterNames));
                        } },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove' }),
                      _react2.default.createElement(
                        'span',
                        { className: 'mobile-hide' },
                        t('Clear').toUpperCase()
                      )
                    ) : null
                  ),
                  (isMobile || isTablet) && hasPage && _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    {
                      mobile: 8,
                      tablet: 3,
                      style: {
                        paddingTop: '0.5rem',
                        paddingRight: '0.5rem'
                      }
                    },
                    _react2.default.createElement(_PageNav2.default, {
                      currentPage: currentPage,
                      count: count,
                      limit: limit,
                      offset: offset,
                      dataSize: dataSize,
                      loading: reportLoading,
                      onChange: this.handleChangePage,
                      noScrollTop: true
                    })
                  ),
                  hasSearch && _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    {
                      className: hasPage ? 'mobile-padding-left' : null,
                      mobile: hasPage ? 8 : 16,
                      tablet: hasPage ? 13 : 16,
                      computer: currentTab === 'banks' ? 16 : 5
                    },
                    _react2.default.createElement(_SearchIn2.default, {
                      isLoading: this.state.loading,
                      onChange: this.handleFilterOnChange,
                      onClear: this.handleClearFilter,
                      search: this.state.search,
                      placeholder: this.getSearchPlaceholder()
                    })
                  )
                )
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { className: 'app--listdata' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { className: 'booking-data' },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'header' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    {
                      mobile: hasSortsOrExports ? 10 : 16,
                      tablet: hasSortsOrExports ? 8 : 16,
                      computer: hasSortsOrExports ? 9 : 16
                    },
                    _react2.default.createElement(_semanticUiReact.Header, {
                      as: 'h2',
                      content: t(header),
                      subheader: t(subheader)
                    })
                  ),
                  hasSortsOrExports && _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { mobile: 6, tablet: 8, computer: 7, textAlign: 'right', className: 'download' },
                    exportOptions && exportOptions.length > 0 && _react2.default.createElement(
                      'div',
                      { className: 'title mobile-hide' },
                      t('Download', { ns: _translation.TRANSLATION_FILES.translation })
                    ),
                    exportOptions && exportOptions.length > 0 && _react2.default.createElement(
                      _semanticUiReact.Button.Group,
                      { basic: true, className: 'mobile-hide' },
                      exportOptions.map(function (item, idx) {
                        return _react2.default.createElement(_semanticUiReact.Button, {
                          key: idx,
                          href: item.href,
                          content: item.text
                        });
                      })
                    ),
                    sortItems && sortItems.length > 0 && _react2.default.createElement(_SortButton2.default, {
                      floated: 'right',
                      loading: this.state.loading,
                      items: sortItems,
                      onSort: this.handleSortData
                    }),
                    exportOptions && exportOptions.length > 0 && _react2.default.createElement(_SortButton2.default, {
                      className: 'tablet-hide small-hide large-hide',
                      floated: 'right',
                      icon: 'download',
                      loading: this.state.loading,
                      items: exportOptions
                    })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { width: 16 },
                    _react2.default.createElement(CurrentTabComponent, {
                      appConfig: this.props.appConfig,
                      location: this.props.location,
                      headerColor: 'blue',
                      barChart: barChart,
                      onLoading: this.handleReportLoading,
                      onPageNav: this.handleReportPageNav,
                      onFilterChange: this.handleFilterOnChange,
                      onFilterClose: this.handleClearFilter,
                      companyID: this.props.appConfig.data.companyID || 0
                    })
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Overview;
}(_react.Component);

Overview.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      companyID: _propTypes2.default.int,
      lawyerIsEnabled: _propTypes2.default.bool
    })
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  banks: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  t: _propTypes2.default.func
};
Overview.contextTypes = {
  store: _propTypes2.default.object
};

Overview.mapStateToProps = function (state) {
  return {
    banks: state.banks,
    auth: state.auth,
    appConfig: state.appConfig
  };
};

Overview.getPropsToState = function (props) {
  var windowWidth = window.innerWidth;
  var isMobile = windowWidth < 768;
  var isTablet = windowWidth >= 768 && windowWidth < 992;
  var query = (0, _url.decodeSearch)(props.location.search);
  var projectID = query.projectID || '';
  var projectUnitLayoutID = query.projectUnitLayoutID || '';
  var search = query.search || '';
  var currentPage = parseInt(query.page, 10) || 1;
  var dateRange = query.dateRange || '';
  var dateFrom = query.dateFrom ? query.dateFrom : '';
  var dateTo = query.dateTo ? query.dateTo : '';
  var status = query.status || '';
  var bankID = query.bankID ? query.bankID : [];
  var statusGroup = query.statusGroup ? query.statusGroup : '';
  var lawyerID = query.lawyerID ? query.lawyerID : [];
  var firmName = query.firmName ? query.firmName : [];
  var businessUnitID = query.businessUnitID || '';
  return {
    isMobile: isMobile,
    isTablet: isTablet,
    currentPage: currentPage,
    projectID: projectID,
    projectUnitLayoutID: projectUnitLayoutID,
    search: search,
    dateRange: dateRange,
    dateFrom: dateFrom,
    dateTo: dateTo,
    status: status,
    statusGroup: statusGroup,
    bankID: bankID,
    lawyerID: lawyerID,
    firmName: firmName,
    businessUnitID: businessUnitID
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.getCurrentTabData = function () {
    var currentTab = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this5.state.currentTab;
    return _this5.tabs(_this5.props.appConfig, _this5.props.auth).find(function (tab) {
      return currentTab === tab.value;
    });
  };

  this.getValueName = function (value, arr) {
    var valueName = arr.find(function (vn) {
      return vn.value === value;
    });
    if (valueName && valueName.text) {
      return valueName.text;
    }
    return '';
  };

  this.getSearchPlaceholder = function () {
    var currentTab = _this5.state.currentTab;

    switch (currentTab) {
      case 'user':
        return 'Search user';
      case 'business_unit':
        return 'Search branch';
      default:
        return 'Search';
    }
  };

  this.handleResize = function () {
    var state = {};
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    var isTablet = windowWidth >= 768 && windowWidth < 992;
    if (isMobile !== _this5.state.isMobile) {
      state.isMobile = isMobile;
    }
    if (isTablet !== _this5.state.isTablet) {
      state.isTablet = isTablet;
    }
    var keys = Object.keys(state);
    if (keys.length > 0) {
      _this5.setState(_extends({}, state));
    }
  };

  this.editImageSrc = function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var newData = [];
    data.forEach(function (d) {
      var editData = {};
      editData.value = d.id;
      editData.text = d.shortName;
      var editImage = {};
      editData.image = editImage;
      editData.image.avatar = true;
      if (d.pictureKey !== '') {
        editData.image.src = (0, _url.AWSUrl)(_this5.props.appConfig, d.pictureKey + '010.jpg');
      } else {
        editData.image.src = '/assets/images/placeholder_x100.jpg';
      }
      newData.push(editData);
    });
    return newData;
  };

  this.editProjectLayoutData = function (data) {
    if (data) {
      var newData = [];
      data.forEach(function (d) {
        var editData = {};
        editData.value = d.id;
        editData.text = d.name;
        newData.push(editData);
      });
      return newData;
    }
    return [];
  };

  this.editLawyerData = function (data) {
    var newData = [];
    data.forEach(function (d) {
      var editData = {};
      editData.value = d.id;
      editData.text = d.name;
      newData.push(editData);
    });
    return newData;
  };

  this.editFirmData = function (data) {
    var newData = [];
    data.forEach(function (d) {
      var editData = {};
      editData.value = d;
      editData.text = d;
      newData.push(editData);
    });
    return newData;
  };

  this.editBUData = function (data) {
    var newData = [];
    data.forEach(function (d) {
      var editData = {};
      editData.value = d.id.toString();
      editData.text = d.name;
      newData.push(editData);
    });
    return newData;
  };

  this.handleSetDateRange = function (from, to) {
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    query.dateFrom = from;
    query.dateTo = to;
    _this5.replaceQuery(query);
  };

  this.handleFilterOnChange = function (value, queryName) {
    var clearSort = false;
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    query[queryName] = value;
    if (queryName === 'statusGroup') {
      delete query.status;
      clearSort = true;
    }
    if (queryName === 'firmName') {
      _this5.setState({ firmSelected: true });
    }
    if (queryName === 'lawyerID') {
      _this5.setComponentState({ lawyerSelected: true });
    }
    if (queryName === 'projectID' && _this5.state.currentTab === 'project_unit') {
      if (value.length === 1) {
        _this5.setState({ projectLayoutList: [] }, function () {
          _this5.fetchProjectLayoutList();
          _this5.replaceQuery(query, clearSort);
        });
      } else {
        _this5.setState({ projectLayoutList: [] }, function () {
          delete query.projectUnitLayoutID;
          _this5.replaceQuery(query, clearSort);
        });
      }
    } else {
      _this5.replaceQuery(query, clearSort);
    }
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        if (filter === 'status' && query.statusGroup !== undefined) {
          delete query.statusGroup;
        }
        hasQuery = true;
      }
    });
    if (hasQuery) {
      _this5.replaceQuery(query, true);
    }
    if (_this5.state.currentTab === 'project_unit') {
      _this5.setState({
        projectLayoutList: []
      });
    }
    if (_this5.state.firmSelected || _this5.state.lawyerSelected) {
      _this5.setState({
        firmSelected: false,
        lawyerSelected: false
      });
    }
  };

  this.handleChangeTab = function (e, _ref6) {
    var name = _ref6.name,
        value = _ref6.value;

    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    var currentTab = name || value;
    query.tab = currentTab;
    if (_this5.state.currentTab !== currentTab) {
      delete query.projectID;

      var _getCurrentTabData2 = _this5.getCurrentTabData(),
          tabFilterNames = _getCurrentTabData2.tabFilterNames;

      if (tabFilterNames.length > 0) {
        tabFilterNames.forEach(function (filter) {
          delete query[filter];
        });
      }
    }
    _this5.replaceQuery(query, true);
    _this5.setState({
      currentTab: currentTab,
      count: 0,
      dataSize: 0,
      limit: 0,
      offset: 0
    });
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    query.page = currentPage;
    _this5.setState({ currentPage: currentPage }, function () {
      _this5.replaceQuery(query);
    });
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this5.replaceQuery(query);
  };

  this.handleReportLoading = function (reportLoading) {
    _this5.setState({ reportLoading: reportLoading });
  };

  this.handleReportPageNav = function (_ref7) {
    var count = _ref7.count,
        dataSize = _ref7.dataSize,
        limit = _ref7.limit,
        offset = _ref7.offset;

    _this5.setState({ count: count, dataSize: dataSize, limit: limit, offset: offset });
  };

  this.exportURL = function (url) {
    var filterNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    var q = (0, _url.decodeSearch)(_this5.props.location.search);
    if (!q.page) q.page = 1;
    var exportUrl = '' + _config2.default.get('bookApiURL') + url;
    if (filterNames.length > 0) {
      filterNames.forEach(function (filter) {
        if (filter === 'projectID' && _this5.checkMultiProjectFilterTab() && _this5.state[filter] && Array.isArray(_this5.state[filter]) && _this5.state[filter].length > 1) {
          var newValue = void 0;
          _this5.state[filter].forEach(function (v) {
            newValue += '&' + filter + '=' + v;
          });
          exportUrl += newValue;
        } else {
          exportUrl += '&' + filter + '=' + _this5.state[filter];
        }
      });
    }
    exportUrl = exportUrl + '&page=' + q.page;
    return exportUrl;
  };

  this.checkTab = function () {
    var unit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 7;
    var booking = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7;
    var user = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 7;
    var branch = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 7;
    var banks = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 7;
    var lawyers = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 7;

    switch (_this5.state.currentTab) {
      case 'project_unit':
        return unit;
      case 'booking':
        return booking;
      case 'user':
        return user;
      case 'business_unit':
        return branch;
      case 'banks':
        return banks;
      case 'lawyers':
        return lawyers;
      default:
        return unit;
    }
  };

  this.checkMultiProjectFilterTab = function () {
    switch (_this5.state.currentTab) {
      case 'project_unit':
        return true;
      case 'booking':
        return true;
      case 'user':
        return false;
      case 'business_unit':
        return false;
      case 'banks':
        return true;
      default:
        return false;
    }
  };

  this.hasBUFilterTab = function () {
    switch (_this5.state.currentTab) {
      case 'project_unit':
        return true;
      case 'booking':
        return true;
      case 'user':
        return false;
      case 'business_unit':
        return false;
      case 'banks':
        return false;
      default:
        return false;
    }
  };

  this.tabs = function (appConfig, auth) {
    return [{
      value: 'project_unit',
      name: 'project_unit',
      text: 'Project Unit',
      header: 'Project Unit Statuses',
      subheader: 'Units by statuses',
      component: _Reports.ProjectUnitsByStatus,
      filterNames: ['projectUnitLayoutID', 'businessUnitID'],
      tabFilterNames: ['projectUnitLayoutID', 'businessUnitID'],
      exportItems: [{
        text: 'CSV',
        href: '/reports/project_units/statuses/export/?fileType=csv'
      }, {
        text: 'Excel',
        href: '/reports/project_units/statuses/export/?fileType=excel'
      }],
      sortItems: [],
      barChart: true
    }, {
      value: 'booking',
      name: 'booking',
      text: 'Booking',
      header: 'Booking Statuses',
      subheader: 'Bookings by statuses',
      component: _Reports.BookingsByStatus,
      filterNames: ['businessUnitID'],
      tabFilterNames: ['businessUnitID'],
      exportItems: [{
        text: 'CSV',
        href: '/reports/bookings/statuses/export/?fileType=csv'
      }, {
        text: 'Excel',
        href: '/reports/bookings/statuses/export/?fileType=excel'
      }],
      sortItems: [],
      barChart: true
    }, {
      value: 'user',
      name: 'user',
      text: 'User',
      header: 'User Bookings',
      subheader: 'Bookings by user and booking status',
      component: _Reports.UsersBookings,
      filterNames: [],
      tabFilterNames: ['search', 'page'],
      exportItems: [{
        text: 'CSV',
        href: '/reports/users/bookings/export/?fileType=csv'
      }, {
        text: 'Excel',
        href: '/reports/users/bookings/export/?fileType=excel'
      }],
      sortItems: _Reports.UsersBookingsSortItems,
      barChart: false
    }, {
      value: 'business_unit',
      name: 'business_unit',
      text: 'Business Unit',
      header: 'Business Unit Bookings',
      subheader: 'Bookings by business unit and booking status',
      component: _Reports.BranchBookings,
      filterNames: [],
      tabFilterNames: ['search', 'page'],
      exportItems: [{
        text: 'CSV',
        href: '/reports/bookings/branch/export/?fileType=csv'
      }, {
        text: 'Excel',
        href: '/reports/bookings/branch/export/?fileType=excel'
      }],
      sortItems: _Reports.BranchBookingsSortItems,
      barChart: false
    }, {
      value: 'banks',
      name: 'banks',
      text: 'Banks',
      header: 'Summary by Banks',
      subheader: 'Booking\'s average days summary by banks',
      component: _Reports.BankAverageAging,
      filterNames: ['bankID', 'status', 'statusGroup'],
      tabFilterNames: ['bankID', 'status', 'statusGroup'],
      exportItems: [{
        text: 'CSV',
        href: '/reports/bookings/banks/export/?fileType=csv'
      }, {
        text: 'Excel',
        href: '/reports/bookings/banks/export/?fileType=excel'
      }],
      sortItems: _Reports.BankAverageAgingSortItems,
      barChart: false,
      disabled: !(auth && auth.company && auth.company.countryCode.toUpperCase() === 'MY')
    }, {
      value: 'lawyers',
      name: 'lawyers',
      text: 'Lawyers',
      header: 'Lawyers Summary',
      subheader: 'Lawyers cases count by status and type',
      component: _Reports.LawyersReports,
      filterNames: ['lawyerID', 'firmName'],
      tabFilterNames: ['lawyerID', 'firmName'],
      exportItems: [],
      sortItems: [],
      barChart: false,
      disabled: !(appConfig.data && appConfig.data.lawyerIsEnabled)
    }];
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Overview.mapStateToProps)(Overview));

/***/ }),
/* 2466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Overview = __webpack_require__(2465);

var _Overview2 = _interopRequireDefault(_Overview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Reports = function (_Component) {
  _inherits(Reports, _Component);

  function Reports() {
    _classCallCheck(this, Reports);

    return _possibleConstructorReturn(this, (Reports.__proto__ || Object.getPrototypeOf(Reports)).apply(this, arguments));
  }

  _createClass(Reports, [{
    key: 'renderChild',
    value: function renderChild() {
      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Reports;
}(_react.Component);

Reports.propTypes = {
  children: _propTypes2.default.node
};
Reports.contextTypes = {
  store: _propTypes2.default.object
};
Reports.Overview = _Overview2.default;
exports.default = Reports;

/***/ }),
/* 2467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Reports = __webpack_require__(2466);

var _Reports2 = _interopRequireDefault(_Reports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Reports2.default;

/***/ }),
/* 2468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _reactRedux = __webpack_require__(9);

var _reactRouter = __webpack_require__(18);

var _reactGa = __webpack_require__(288);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _url = __webpack_require__(19);

var _gaEvents = __webpack_require__(2580);

var _flash = __webpack_require__(5);

var _auth = __webpack_require__(552);

var _sessionWatch = __webpack_require__(2586);

var _qHelpWidget = __webpack_require__(2584);

var _i18n = __webpack_require__(401);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/forbid-prop-types: 0 */


var Root = function (_Component) {
  _inherits(Root, _Component);

  function Root() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Root);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Root.__proto__ || Object.getPrototypeOf(Root)).call.apply(_ref, [this].concat(args))), _this), _this.handleLanguageChanged = function (language) {
      (0, _qHelpWidget.setQHelpWidgetLanguage)(language);
    }, _this.handleClick = function (event) {
      if (event.target) {
        var action = (0, _gaEvents.gaClickEventAction)(event);
        if (action) {
          _reactGa2.default.event('BOOK_CLICK', {
            category: 'BOOK_CLICK',
            action: (0, _gaEvents.gaClickEventAction)(event),
            route: (0, _gaEvents.gaClickEventAction)(event),
            label: (0, _gaEvents.gaClickEventLabel)(event),
            name: (0, _gaEvents.gaClickEventLabel)(event)
          });
        }
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Root, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var store = this.props.store;

      var next = (0, _url.getQuery)().next || null;

      _momentTimezone2.default.tz.setDefault(_config2.default.get('tzName') || 'Asia/Kuala_Lumpur');

      if (_config2.default.get('server') === 'staging' || _config2.default.get('server') === 'development') {
        document.title = document.title + ' Demo';
      }
      store.dispatch((0, _auth.checkAuthenticated)(next)).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      });
      document.addEventListener('click', this.handleClick, false);
      // MS-6466: bounds the superseded-session zombie window at one interval (and ~zero on tab
      // refocus). Root lives for the app's lifetime — BookDash unmounts on navigation.
      this.stopSessionWatch = (0, _sessionWatch.startSessionWatch)({
        isAuthenticated: function isAuthenticated() {
          return store.getState().auth.isAuthenticated;
        }
      });
      // Q Help: Q's in-app chat (the widget's contact card when Q refuses or is out of reach).
      // One tag for the page, added here once and never by render; no URL for this environment,
      // no tag.
      (0, _qHelpWidget.mountQHelpWidget)({
        src: _config2.default.get('qHelpWidgetURL'),
        language: _i18n2.default.language,
        version: _config2.default.get('version')
      });
      _i18n2.default.on('languageChanged', this.handleLanguageChanged);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.removeEventListener('click', this.handleClick, false);
      _i18n2.default.off('languageChanged', this.handleLanguageChanged);
      if (this.stopSessionWatch) {
        this.stopSessionWatch();
      }
    }
    // This tab's own language only (CPI-1310: no cross-tab push); the widget watches data-lang.

  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          store = _props.store,
          history = _props.history,
          routes = _props.routes;

      return _react2.default.createElement(
        _reactRedux.Provider,
        { store: store },
        _react2.default.createElement(_reactRouter.Router, { history: history, routes: routes })
      );
    }
  }]);

  return Root;
}(_react.Component);

exports.default = Root;


Root.propTypes = {
  store: _propTypes2.default.object.isRequired,
  history: _propTypes2.default.object.isRequired,
  routes: _propTypes2.default.element.isRequired
};

/***/ }),
/* 2469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1068);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Edit = function (_Component) {
  _inherits(Edit, _Component);

  function Edit(props) {
    _classCallCheck(this, Edit);

    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(Edit, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, template) {
        var _this2 = this;

        var t, store, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.form.submit('/sms_templates/' + encodeURIComponent(this.props.smsTemplateID) + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(template)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false);
                });
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully updated', { ns: _translation.TRANSLATION_FILES.translation, name: res.name }) }));

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Edit {{name}}', { ns: _translation.TRANSLATION_FILES.translation, name: this.props.data ? this.props.data.name : t('SMS Template', { ns: _translation.TRANSLATION_FILES.translation }) }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Update', { ns: _translation.TRANSLATION_FILES.translation }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, template) {
            _this3.submit(validations, template);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading,
          template: this.props.data
        })
      );
    }
  }]);

  return Edit;
}(_react.Component);

Edit.propTypes = {
  smsTemplateID: _propTypes2.default.string,
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
Edit.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(Edit);

/***/ }),
/* 2470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _TemplateList = __webpack_require__(1033);

var _TemplateList2 = _interopRequireDefault(_TemplateList);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    var state = List.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(List, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('SMS Templates', { ns: _translation.TRANSLATION_FILES.translation })
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', columns: 'equal', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('SMS Templates', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(_TemplateList2.default, {
                loading: this.state.loading,
                type: 'sms'
              })
            )
          )
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  return {
    loading: loading
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(List);

/***/ }),
/* 2471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1068);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var New = function (_Component) {
  _inherits(New, _Component);

  function New(props) {
    _classCallCheck(this, New);

    var _this = _possibleConstructorReturn(this, (New.__proto__ || Object.getPrototypeOf(New)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments[1];

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges, callback);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(New, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(validations, preset) {
        var _this2 = this;

        var t, store, errors, res, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context2.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context2.abrupt('return');

              case 6:
                res = void 0;
                _context2.prev = 7;
                _context2.next = 10;
                return this.form.submit('/sms_templates/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(preset)
                });

              case 10:
                res = _context2.sent;
                _context2.next = 23;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](7);

                if (!(_context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 21;
                  break;
                }

                _context2.next = 18;
                return _context2.t0.res.text();

              case 18:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));
                return _context2.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false, function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(noChanges) {
                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              if (noChanges) {
                                store.dispatch((0, _reactRouterRedux.replace)('/settings/sms_templates/' + encodeURIComponent(res.id) + '/'));
                                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Create Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully created', { ns: _translation.TRANSLATION_FILES.translation, name: res.name }) }));
                              }

                            case 1:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this2);
                    }));

                    return function (_x4) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                });

              case 24:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('New SMS Template', { ns: _translation.TRANSLATION_FILES.translation }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Create', { ns: _translation.TRANSLATION_FILES.screens }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref3) {
            _this3.form = _ref3;
          },
          onSubmit: function onSubmit(validations, preset) {
            _this3.submit(validations, preset);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading
        })
      );
    }
  }]);

  return New;
}(_react.Component);

New.propTypes = {
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
New.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(New);

/***/ }),
/* 2472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _checkChanges = __webpack_require__(61);

var _promptMessages = __webpack_require__(43);

var _translation = __webpack_require__(4);

var _List = __webpack_require__(2470);

var _List2 = _interopRequireDefault(_List);

var _New = __webpack_require__(2471);

var _New2 = _interopRequireDefault(_New);

var _Edit = __webpack_require__(2469);

var _Edit2 = _interopRequireDefault(_Edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SMSTemplates = function (_Component) {
  _inherits(SMSTemplates, _Component);

  function SMSTemplates(props) {
    _classCallCheck(this, SMSTemplates);

    var _this = _possibleConstructorReturn(this, (SMSTemplates.__proto__ || Object.getPrototypeOf(SMSTemplates)).call(this, props));

    _this.state = {
      token: null,
      loading: true,
      data: null
    };
    return _this;
  }

  _createClass(SMSTemplates, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.params.smsTemplateID) {
        this.fetchSMSTemplate();
      } else if (this.props.location.pathname.includes('/new/')) {
        this.fetchSMSTemplates();
      } else {
        this.setLoading(false);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var pathname = nextProps.location.pathname;

      if (nextProps.params.smsTemplateID) {
        if (pathname !== this.props.location.pathname) {
          this.fetchSMSTemplate();
        }
      } else if (pathname.includes('/new/')) {
        this.fetchSMSTemplates();
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchSMSTemplate',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var t, store, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/sms_templates/' + encodeURIComponent(this.props.params.smsTemplateID) + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 19;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context.next = 33;
                break;

              case 27:
                token = res.headers.get('X-Csrf-Token');
                _context.next = 30;
                return res.json();

              case 30:
                data = _context.sent;
                _context.next = 33;
                return this.setComponentState({
                  token: token,
                  data: data
                });

              case 33:
                _context.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchSMSTemplate() {
        return _ref.apply(this, arguments);
      }

      return fetchSMSTemplate;
    }()
  }, {
    key: 'fetchSMSTemplates',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var t, store, query, res, message, token;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                query = Object.assign({
                  page: 1
                }, q);
                res = void 0;
                _context2.prev = 6;
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/sms_templates/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context2.sent;
                _context2.next = 20;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context2.next = 19;
                return this.setLoading(false);

              case 19:
                return _context2.abrupt('return');

              case 20:
                if (res.ok) {
                  _context2.next = 28;
                  break;
                }

                _context2.next = 23;
                return res.text();

              case 23:
                message = _context2.sent;
                _context2.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context2.next = 31;
                break;

              case 28:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context2.next = 31;
                return this.setComponentState({
                  token: token
                });

              case 31:
                _context2.next = 33;
                return this.setLoading(false);

              case 33:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 12]]);
      }));

      function fetchSMSTemplates() {
        return _ref2.apply(this, arguments);
      }

      return fetchSMSTemplates;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this4 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this4.state.token,
          loading: _this4.state.loading,
          data: _this4.state.data,
          smsTemplateID: _this4.props.params.smsTemplateID
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return SMSTemplates;
}(_react.Component);

SMSTemplates.propTypes = {
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object
  }),
  params: _propTypes2.default.shape({
    smsTemplateID: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
SMSTemplates.contextTypes = {
  store: _propTypes2.default.object
};
SMSTemplates.List = _List2.default;
SMSTemplates.New = (0, _checkChanges.checkChanges)(_New2.default, { message: _promptMessages.NEW_SPECIFICATION_PROMPT });
SMSTemplates.Edit = (0, _checkChanges.checkChanges)(_Edit2.default);


var TranslatedSMSTemplates = (0, _reactI18next.withTranslation)(_translation.namespaces)(SMSTemplates);
TranslatedSMSTemplates.List = SMSTemplates.List;
TranslatedSMSTemplates.New = SMSTemplates.New;
TranslatedSMSTemplates.Edit = SMSTemplates.Edit;
exports.default = TranslatedSMSTemplates;

/***/ }),
/* 2473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SMSTemplates = __webpack_require__(2472);

var _SMSTemplates2 = _interopRequireDefault(_SMSTemplates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SMSTemplates2.default;

/***/ }),
/* 2474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _reactRouter = __webpack_require__(18);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _BookDash = __webpack_require__(573);

var _BookDash2 = _interopRequireDefault(_BookDash);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prefer-stateless-function: 0 */


var Dash = function (_Component) {
  _inherits(Dash, _Component);

  function Dash() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Dash);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Dash.__proto__ || Object.getPrototypeOf(Dash)).call.apply(_ref, [this].concat(args))), _this), _this.modules = [{
      name: 'Company Documents',
      description: 'Company documents setup',
      type: 'documents',
      route: '/settings/company_documents/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }, {
      name: 'Projects Settings',
      description: 'Project specification setup',
      type: 'projects',
      route: '/settings/projects/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }, {
      name: 'Project Mapping Settings',
      description: 'Project mapping attribute setup',
      type: 'projects',
      route: '/settings/mappings/projects/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }, {
      name: 'Layouts Settings',
      description: 'Layouts specification setup',
      type: 'spec_layout',
      route: '/settings/layouts/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }, {
      name: 'Units Settings',
      description: 'Units specification setup',
      type: 'spec_unit',
      route: '/settings/units/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }, {
      name: 'Business Units',
      description: 'Manage business units and agency',
      type: 'business_unit',
      route: '/business_units/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }, {
      name: 'Picture Tags',
      description: 'Manage picture tags',
      type: 'pictures',
      route: '/settings/tags/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }, {
      name: 'Currency Settings',
      description: 'Manage currency',
      type: 'currencies',
      route: '/settings/currencies/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }, _this.props.auth.isAdminBasic && {
      name: 'Print Templates',
      description: 'Manage Booking Print Templates',
      type: 'documents',
      route: '/settings/print_templates/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }, _this.props.auth.isAdminBasic && {
      name: 'SMS Templates',
      description: 'Manage SMS Templates',
      type: 'documents',
      route: '/settings/sms_templates/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }, _this.props.auth.isAdminBasic && {
      name: 'Quotation Templates',
      description: 'Manage Quotation Templates',
      type: 'documents',
      route: '/settings/quotation_templates/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }, _this.props.auth.isAdminBasic && {
      name: 'Price Naming',
      description: 'Manage namings of price',
      type: 'accounting',
      route: '/settings/price_naming/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }, {
      name: 'User Mapping Settings',
      description: 'User mapping attribute setup',
      type: 'projects',
      route: '/settings/mappings/affiliates/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }, {
      name: 'Cancellation Reasons',
      description: 'Manage cancellation reasons',
      type: 'documents',
      route: '/settings/cancellation_reasons/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }, {
      name: 'System Settings',
      description: 'Manage Settings & Custom Options',
      type: 'settings',
      route: '/settings/system_settings/',
      enabled: true,
      isDeveloper: false,
      isHeadquarters: true,
      isSuperAdmin: true
    }], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Dash, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Settings')
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { doubling: true, columns: 4, className: 'dash_grid' },
          this.modules.filter(function (module) {
            if (_this2.props.auth.isSuperAdmin) {
              return module.isSuperAdmin;
            }
            if (_this2.props.auth.isHeadquarters) {
              return module.isHeadquarters;
            }
            if (_this2.props.auth.isDeveloper) {
              return module.isDeveloper;
            }
            return true;
          }).map(function (module, idx) {
            if (module.type) {
              return _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { key: idx },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: module.route },
                  _react2.default.createElement(
                    _semanticUiReact.Header,
                    { textAlign: 'center', as: 'h3' },
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(_BookDash2.default, {
                        type: module.type,
                        width: '6em',
                        height: '6em',
                        backfill: '#F8F8F8',
                        iconfill: '#00233B'
                      })
                    ),
                    t(module.name).toUpperCase(),
                    _react2.default.createElement(
                      _semanticUiReact.Header.Subheader,
                      null,
                      t(module.description)
                    )
                  )
                )
              );
            }
            return null;
          })
        )
      );
    }
  }]);

  return Dash;
}(_react.Component);

Dash.contextTypes = {
  store: _propTypes2.default.object
};
Dash.propTypes = {
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    isDeveloper: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool
  }),
  t: _propTypes2.default.func
};
Dash.defaultProps = {
  auth: {
    isAdminBasic: false
  }
};

Dash.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

Dash.contextTypes = {
  store: _propTypes2.default.object
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)((0, _reactRedux.connect)(Dash.mapStateToProps)(Dash));

/***/ }),
/* 2475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Dash = __webpack_require__(2474);

var _Dash2 = _interopRequireDefault(_Dash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Settings = function (_Component) {
  _inherits(Settings, _Component);

  function Settings() {
    _classCallCheck(this, Settings);

    return _possibleConstructorReturn(this, (Settings.__proto__ || Object.getPrototypeOf(Settings)).apply(this, arguments));
  }

  _createClass(Settings, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.props.children
      );
    }
  }]);

  return Settings;
}(_react.Component);

Settings.propTypes = {
  children: _propTypes2.default.node
};
Settings.contextTypes = {
  store: _propTypes2.default.object
};
Settings.Dash = _Dash2.default;
exports.default = Settings;

/***/ }),
/* 2476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Settings = __webpack_require__(2475);

var _Settings2 = _interopRequireDefault(_Settings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Settings2.default;

/***/ }),
/* 2477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _semanticUiReact = __webpack_require__(2);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _UserActivities = __webpack_require__(1037);

var _UserActivities2 = _interopRequireDefault(_UserActivities);

var _translation = __webpack_require__(4);

var _navigations = __webpack_require__(1069);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


var Activities = function (_Component) {
  _inherits(Activities, _Component);

  function Activities(props) {
    _classCallCheck(this, Activities);

    var _this = _possibleConstructorReturn(this, (Activities.__proto__ || Object.getPrototypeOf(Activities)).call(this, props));

    _initialiseProps.call(_this);

    var state = Activities.getPropsToState(props);
    state.limit = 0;
    state.offset = 0;
    state.currentPage = parseInt(state.query.page, 10) || 1;
    state.count = 0;
    _this.state = state;
    return _this;
  }

  _createClass(Activities, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
      var query = this.props.location.query;

      this.getUserActivities(query);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var query = nextProps.location.query;

      var state = Activities.getPropsToState(nextProps);
      if (this.state.activitiesData) {
        state.activitiesData = this.state.activitiesData;
      }
      this.setState(_extends({}, state), function () {
        if (!_this2.state.activitiesData) {
          _this2.getUserActivities(query);
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'getUserActivities',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var store, t, query, queryString, res, message, activitiesData, count, limit, offset;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                queryString = '';
                res = null;

                if (_qs2.default.stringify(query)) {
                  queryString = '?' + _qs2.default.stringify(query);
                }
                _context.prev = 9;
                _context.next = 12;
                return store.dispatch((0, _fetchM.fetchM)('/staffs/' + this.props.routeParams.id + '/activities/' + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 12:
                res = _context.sent;
                _context.next = 26;
                break;

              case 15:
                _context.prev = 15;
                _context.t0 = _context['catch'](9);
                _context.next = 19;
                return this.setLoading(false);

              case 19:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 24;
                  break;
                }

                _context.next = 22;
                return _context.t0.res.text();

              case 22:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 26:
                if (res.ok) {
                  _context.next = 32;
                  break;
                }

                _context.next = 29;
                return this.setLoading(false);

              case 29:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                _context.next = 42;
                break;

              case 32:
                _context.next = 34;
                return res.json();

              case 34:
                activitiesData = _context.sent;
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 40;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset,
                  activitiesData: activitiesData
                });

              case 40:
                _context.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[9, 15]]);
      }));

      function getUserActivities(_x3) {
        return _ref.apply(this, arguments);
      }

      return getUserActivities;
    }()
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters) {
        return true;
      }
      if (this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'replaceQuery',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(query) {
        var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var store, queryNew;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                queryNew = query;

                if (resetPage) queryNew.page = 1;
                _context2.next = 7;
                return this.getUserActivities(query);

              case 7:
                store.dispatch((0, _reactRouterRedux.replace)('/users/' + this.props.routeParams.id + '/activities/?' + (0, _url.encodeSearch)(queryNew)));
                _context2.next = 10;
                return this.setLoading(false);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function replaceQuery(_x5) {
        return _ref2.apply(this, arguments);
      }

      return replaceQuery;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this5 = this;

      var pathname = this.props.location.pathname;
      var activitiesData = this.state.activitiesData;
      var t = this.props.t;

      var links = (0, _navigations.routes)(this.props.routeParams.id).map(function (l) {
        return _extends({}, l, {
          text: t(l.text)
        });
      });
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: link.text,
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this5.handleMenu(e, link);
              }
            });
          })
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(_SearchFilter2.default, {
                isLoading: this.state.loading,
                onChange: this.handleOnChange,
                onClose: this.handleClearFilter,
                search: this.state.search,
                placeholder: t('Search'),
                setAdvanceFilter: function setAdvanceFilter() {},
                leftNav: _react2.default.createElement(_PageNav2.default, {
                  currentPage: this.state.currentPage,
                  count: this.state.count,
                  limit: this.state.limit,
                  offset: this.state.offset,
                  dataSize: this.state.activitiesData.length,
                  loading: this.state.loading,
                  onChange: this.handleChangePage
                }),
                rightNav: _react2.default.createElement(_SortButton2.default, {
                  floated: 'right',
                  loading: this.state.loading,
                  items: this.sortItems,
                  onSort: this.handleSortData
                })
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, textAlign: 'center' },
              _react2.default.createElement(_semanticUiReact.Divider, { horizontal: true }),
              _react2.default.createElement(
                _semanticUiReact.Segment,
                null,
                _react2.default.createElement(_UserActivities2.default, {
                  data: activitiesData || [],
                  hasAccess: this.hasAccess(),
                  loading: this.state.loading
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Activities;
}(_react.Component);

Activities.contextTypes = {
  store: _propTypes2.default.object
};
Activities.propTypes = {
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool
  }),
  routeParams: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};

Activities.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

Activities.getPropsToState = function (props) {
  var loading = props.loading;
  var data = props.data || [];
  var query = (0, _url.decodeSearch)(props.location.search);
  var search = query.search || '';
  var activitiesData = [];
  var menuIsTab = window.innerWidth <= 590;
  return {
    data: data,
    loading: loading,
    query: query,
    search: search,
    activitiesData: activitiesData,
    menuIsTab: menuIsTab
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.handleResize = function () {
    var state = {};
    var menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== _this6.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    var unitLayoutResize = window.innerWidth < 768;
    if (unitLayoutResize !== _this6.state.unitLayoutResize) {
      state.unitLayoutResize = unitLayoutResize;
    }
    var galleryIsTab = window.innerWidth > 425;
    if (galleryIsTab !== _this6.state.galleryIsTab) {
      state.galleryIsTab = galleryIsTab;
    }
    var locationResize = window.innerWidth <= 375;
    if (locationResize !== _this6.state.locationResize) {
      state.locationResize = locationResize;
    }
    _this6.setState(_extends({}, state));
  };

  this.handleMenu = function (e, _ref3) {
    var value = _ref3.value;
    var store = _this6.context.store;

    if (value.includes(_config2.default.get('bookApiURL')) || value.includes(_config2.default.get('salesChartURL'))) {
      e.preventDefault();
      var winObj = window.open(value, '_blank');
      winObj.opener = null;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(value));
    }
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.page = currentPage;
    _this6.setState({
      currentPage: currentPage
    });
    _this6.replaceQuery(query);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this6.replaceQuery(query);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    if (hasQuery) {
      _this6.replaceQuery(query, true);
    } else {
      _this6.setState({ search: '' });
    }
  };

  this.handleOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this6.props.location.search);
    query[queryName] = value;
    _this6.replaceQuery(query, true);
  };

  this.sortItems = [{
    text: 'Date Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'user_activity.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Date Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'user_activity.created_at',
    sortDirection: 'desc'
  }];
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Activities.mapStateToProps)(Activities));

/***/ }),
/* 2478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _reactI18next = __webpack_require__(3);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _flash = __webpack_require__(5);

var _phone = __webpack_require__(146);

var _intlCallCodes = __webpack_require__(116);

var _intlCallCodes2 = _interopRequireDefault(_intlCallCodes);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _ListItem = __webpack_require__(261);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _PhoneInput = __webpack_require__(104);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

var _Select = __webpack_require__(382);

var _Select2 = _interopRequireDefault(_Select);

var _ProjectsList = __webpack_require__(400);

var _ProjectsList2 = _interopRequireDefault(_ProjectsList);

var _SpecificationTable = __webpack_require__(127);

var _SpecificationTable2 = _interopRequireDefault(_SpecificationTable);

var _companies = __webpack_require__(88);

var _storage = __webpack_require__(44);

var _intlFlagCodes = __webpack_require__(141);

var _intlFlagCodes2 = _interopRequireDefault(_intlFlagCodes);

var _groups = __webpack_require__(194);

var _roles = __webpack_require__(1048);

var _TinFieldInput = __webpack_require__(192);

var _TinFieldInput2 = _interopRequireDefault(_TinFieldInput);

var _regex = __webpack_require__(143);

var _identityTypes = __webpack_require__(174);

var _translation = __webpack_require__(4);

var _SelectBank = __webpack_require__(218);

var _SelectBank2 = _interopRequireDefault(_SelectBank);

var _translation2 = __webpack_require__(64);

var _tin = __webpack_require__(155);

var _defaultIdentityTypeOpts = __webpack_require__(154);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StaffForm = function (_Component) {
  _inherits(StaffForm, _Component);

  function StaffForm(props) {
    _classCallCheck(this, StaffForm);

    var _this = _possibleConstructorReturn(this, (StaffForm.__proto__ || Object.getPrototypeOf(StaffForm)).call(this, props));

    _initialiseProps.call(_this);

    var staff = (0, _clone2.default)(StaffForm.defaultStaff);
    var tinError = null;
    var auth = props.auth;

    if (auth && (0, _companies.isForeignCompany)(auth.company)) {
      var idx = _intlFlagCodes2.default.findIndex(function (f) {
        return f.countryCode === auth.company.countryCode;
      });
      if (idx !== -1) {
        var defaultCountryPhoneCode = _intlFlagCodes2.default[idx].value;
        staff.mobilePrefix = defaultCountryPhoneCode;
        staff.officeTelPrefix = defaultCountryPhoneCode;
      }
    }
    staff.user = (0, _clone2.default)(StaffForm.defaultUser);
    var phoneValidationPresets = {};
    var storePhoneValidationPresets = (0, _storage.getItem)(_config2.default.get('appName') + '.phoneValidationPresets');
    if (storePhoneValidationPresets) {
      try {
        phoneValidationPresets = JSON.parse(storePhoneValidationPresets).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }

    _this.state = {
      staff: staff,
      oriStaff: (0, _clone2.default)(staff),
      errMessages: [],
      tinMessage: null,
      branches: [],
      companyBranches: [],
      selectedBranchIsExternal: false,
      showAddProject: false,
      phoneValidationPresets: phoneValidationPresets,
      tinError: tinError,
      tinEnabled: true,
      tinRequired: false,
      // flag to enable/disable tin searched using the lhdn api
      tinFound: false
    };
    _this.validation = {
      name: (0, _react.createRef)(),
      preferredName: (0, _react.createRef)(),
      email: (0, _react.createRef)(),
      mobilePrefix: (0, _react.createRef)(),
      mobile: (0, _react.createRef)(),
      officeTel: (0, _react.createRef)(),
      companyBranchID: (0, _react.createRef)(),
      role: (0, _react.createRef)(),
      identityNo: (0, _react.createRef)(),
      taxIdentificationNo: (0, _react.createRef)(),
      fullName: (0, _react.createRef)(),
      bankAccountName: (0, _react.createRef)(),
      bankAccountNumber: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(StaffForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var store = this.context.store;

      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        this.fetchCompanyBranches().catch(function (err) {
          Bugsnag.notifyException(err);
          store.dispatch((0, _flash.flashErrorMessage)(err));
        });
      }
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'validateTIN',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tinInput) {
        var identityNo, idType, query, store, res, errorMessage, _errorMessage;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                identityNo = this.state.staff.identityNo;

                if (!(!tinInput || !identityNo)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                idType = (0, _identityTypes.getIdentityTypeOpts)().find(function (i) {
                  return i.value === _defaultIdentityTypeOpts.IDENTITY_TYPE_NRIC;
                }).tin_code;
                query = Object.assign({
                  tin: tinInput,
                  idType: idType,
                  idValue: identityNo
                });
                store = this.context.store;
                _context.prev = 6;
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/tin/validate/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token,
                    'X-Origin': this.state.origin
                  }
                }));

              case 9:
                res = _context.sent;

                if (!(res && res.ok)) {
                  _context.next = 14;
                  break;
                }

                this.setState({
                  tinError: false,
                  tinFound: true,
                  tinMessage: null
                });
                _context.next = 19;
                break;

              case 14:
                _context.next = 16;
                return res.text();

              case 16:
                errorMessage = _context.sent;

                this.setState({
                  tinError: true,
                  tinFound: false,
                  tinMessage: errorMessage
                });
                return _context.abrupt('return');

              case 19:
                _context.next = 28;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context['catch'](6);

                if (!_context.t0.res) {
                  _context.next = 28;
                  break;
                }

                _context.next = 26;
                return _context.t0.res.text();

              case 26:
                _errorMessage = _context.sent;

                this.setState({
                  tinError: true,
                  tinFound: false,
                  tinMessage: _errorMessage
                });

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 21]]);
      }));

      function validateTIN(_x) {
        return _ref.apply(this, arguments);
      }

      return validateTIN;
    }()
  }, {
    key: 'fetchCompanyBranches',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, res, query, queryString, message, branches;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                res = void 0;
                query = {
                  page: 'all',
                  getProjects: true,
                  statusFilter: 'active'
                };
                queryString = _qs2.default.stringify(query);
                _context2.prev = 4;
                _context2.next = 7;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/company_branches/?' + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context2.sent;
                _context2.next = 16;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](4);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                return _context2.abrupt('return');

              case 16:
                if (res.ok) {
                  _context2.next = 24;
                  break;
                }

                _context2.next = 19;
                return res.text();

              case 19:
                message = _context2.sent;
                _context2.next = 22;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 22:
                _context2.next = 29;
                break;

              case 24:
                _context2.next = 26;
                return res.json();

              case 26:
                branches = _context2.sent;
                _context2.next = 29;
                return this.setState({
                  branches: branches ? branches.map(function (ul) {
                    var branch = { text: ul.name, name: ul.shortName, value: ul.id.toString(), description: ul.isExternal ? 'Agency' : '' };
                    return branch;
                  }) : [],
                  companyBranches: branches
                });

              case 29:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[4, 10]]);
      }));

      function fetchCompanyBranches() {
        return _ref2.apply(this, arguments);
      }

      return fetchCompanyBranches;
    }()
  }, {
    key: 'isUserType',
    value: function isUserType(groupID) {
      if (this.state.staff.user.groups) {
        return this.state.staff.user.groups.some(function (group) {
          return group.id === groupID;
        });
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;
      var staff = this.state.staff;

      var ROLES = (0, _roles.roleOptions)(this.state.selectedBranchIsExternal, this.props.auth.isBranchLeader);
      var tinContent = staff.taxIdentificationNo || this.state.tinRequired;
      var isMalaysia = this.props.auth && this.props.auth.company && this.props.auth.company.countryCode && this.props.auth.company.countryCode.toUpperCase() === 'MY';
      var isIndonesia = this.props.auth && this.props.auth.company && this.props.auth.company.countryCode && this.props.auth.company.countryCode.toUpperCase() === 'ID';
      var tinValidation = [];
      if (isIndonesia) {
        tinValidation = [{
          validate: _webValidations.matchRegex,
          option: { validRegex: _regex.REGEX_NPWP_ID }
        }];
      } else if (isMalaysia) {
        // For Malaysia, validation is optional unless tinRequired is true
        var tinRules = [{
          validate: _webValidations.matchRegex,
          option: { validRegex: _regex.REGEX_TIN_VALID }
        }];
        if (this.state.tinRequired) {
          tinRules.unshift(_webValidations.required);
        }
        tinValidation = tinRules;
      }
      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref3) {
            _this2.form = _ref3;
          }
        },
        _react2.default.createElement(_ProjectsList2.default, {
          open: this.state.showAddProject,
          onClose: this.handleCloseAddProject,
          onConfirm: this.handleAddProject,
          onCheck: function onCheck(project) {
            return project.loanTrackerProjectID < 1;
          },
          selected: staff ? staff.affiliateProjects : [],
          userBranchProjects: !this.getBranchViewAllProjects() ? this.getBranchProjects() : []
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: (0, _translation2.translateModels)(t, 'name', 'user') + '*',
                  validateLabel: (0, _translation2.translateModels)(t, 'name', 'user'),
                  name: 'name',
                  value: this.state.staff.name,
                  onChange: this.handleInputChange,
                  ref: this.validation.name,
                  validation: [_webValidations.required]
                }),
                this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin ? _react2.default.createElement(_Select2.default, {
                  validation: [_webValidations.required],
                  ref: this.validation.companyBranchID,
                  onChange: this.handleInputChange,
                  validateLabel: 'Business Unit',
                  label: t('Business Unit') + '*',
                  name: 'companyBranchID',
                  text: this.state.staff.companyBranchID ? null : t('Select business unit'),
                  value: this.state.staff.companyBranchID,
                  options: this.state.branches,
                  disabled: this.state.branches.length === 0
                }) : null
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: (0, _translation2.translateModels)(t, 'preferredName', 'user') + '*',
                  validateLabel: (0, _translation2.translateModels)(t, 'preferredName', 'user'),
                  name: 'preferredName',
                  value: this.state.staff.preferredName,
                  onChange: this.handleInputChange,
                  ref: this.validation.preferredName,
                  validation: [_webValidations.required, {
                    validate: _webValidations.stringLength,
                    option: {
                      max: 10
                    }
                  }]
                }),
                _react2.default.createElement(_Select2.default, {
                  name: 'role',
                  label: t('Access Role') + '*',
                  validateLabel: t('Access Role'),
                  validation: [_webValidations.required],
                  ref: this.validation.role,
                  value: this.getRoles(),
                  onChange: this.handleChangeRole,
                  options: ROLES.map(function (role) {
                    return _extends({}, role, {
                      text: t(role.text, { ns: _translation.TRANSLATION_FILES.constants })
                    });
                  })
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_Select2.default, {
                  validation: [_webValidations.required],
                  ref: this.validation.mobilePrefix,
                  onChange: this.handleInputChange,
                  validateLabel: (0, _translation2.translateModels)(t, 'mobilePrefix', 'user'),
                  label: (0, _translation2.translateModels)(t, 'mobilePrefix', 'user') + '*',
                  name: 'mobilePrefix',
                  value: this.state.staff.mobilePrefix,
                  options: _intlCallCodes2.default
                }),
                _react2.default.createElement(_PhoneInput2.default, {
                  label: (0, _translation2.translateModels)(t, 'mobile', 'user') + '*',
                  validateLabel: (0, _translation2.translateModels)(t, 'mobile', 'user'),
                  type: 'tel',
                  name: 'mobile',
                  value: this.state.staff.mobile,
                  onChange: this.handleInputChange,
                  prefix: this.state.staff.mobilePrefix,
                  ref: this.validation.mobile,
                  validation: [_webValidations.required, {
                    validate: _webValidations.phoneNumber,
                    option: this.state.staff.mobilePrefix === 'other' ? {} : {
                      isMobile: true,
                      phonePrefix: this.state.staff.mobilePrefix,
                      validRegex: (0, _phone.getPhoneValidRegex)(this.state.phoneValidationPresets, this.state.staff.mobilePrefix, 'mobile')
                    }
                  }]
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_semanticUiReact.Form.Select, {
                  label: (0, _translation2.translateModels)(t, 'officeTelPrefix', 'user'),
                  name: 'officeTelPrefix',
                  value: this.state.staff.officeTelPrefix,
                  onChange: this.handleInputChange,
                  search: true,
                  options: _intlCallCodes2.default,
                  noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                }),
                _react2.default.createElement(_PhoneInput2.default, {
                  label: (0, _translation2.translateModels)(t, 'officeTel', 'user'),
                  type: 'tel',
                  name: 'officeTel',
                  value: this.state.staff.officeTel,
                  onChange: this.handleInputChange,
                  prefix: this.state.staff.officeTelPrefix,
                  ref: this.validation.officeTel,
                  validation: [{
                    validate: _webValidations.phoneNumber,
                    option: this.state.staff.officeTelPrefix === 'other' ? {} : {
                      phonePrefix: this.state.staff.officeTelPrefix,
                      validRegex: (0, _phone.getPhoneValidRegex)(this.state.phoneValidationPresets, this.state.staff.officeTelPrefix, 'phone')
                    }
                  }]
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal', style: { alignItems: 'center' } },
                _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  null,
                  _react2.default.createElement(_AppForm2.default.Input, {
                    label: (0, _translation2.translateModels)(t, 'email', 'user') + '*',
                    validateLabel: (0, _translation2.translateModels)(t, 'email', 'user'),
                    name: 'email',
                    value: this.state.staff.email,
                    onChange: this.handleInputChange,
                    ref: this.validation.email,
                    validation: [_webValidations.required]
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  null,
                  this.getBranchViewAllProjects() ? t('All Projects Access (Set by Business Unit)') : _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    checked: staff.viewAllProjects,
                    label: (0, _translation2.translateModels)(t, 'viewAllProjects', 'user'),
                    name: 'viewAllProjects',
                    onChange: this.handleCheckBoxChange
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: (0, _translation2.translateModels)(t, 'fullName', 'user') + ' ' + (isMalaysia && t('(as in MyKad)')),
                  validateLabel: (0, _translation2.translateModels)(t, 'fullName', 'user'),
                  name: 'fullName',
                  value: this.state.staff.fullName,
                  onChange: this.handleInputChange,
                  ref: this.validation.fullName,
                  validation: this.state.staff.bankAccountName && this.state.staff.bankAccountNumber ? [_webValidations.required, { validate: _webValidations.matchRegex, option: { validRegex: _regex.REGEX_FULL_NAME } }] : [{ validate: _webValidations.matchRegex, option: { validRegex: _regex.REGEX_FULL_NAME } }]
                }),
                isMalaysia && _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  null,
                  _react2.default.createElement(_AppForm2.default.Input, {
                    name: 'identityNo',
                    validation: tinContent ? [_webValidations.required, {
                      validate: _webValidations.identity,
                      option: {
                        countryCode: 'MY',
                        identityType: 'ic_number'
                      }
                    }] : [{
                      validate: _webValidations.identity,
                      option: {
                        countryCode: 'MY',
                        identityType: 'ic_number'
                      }
                    }],
                    ref: this.validation.identityNo,
                    required: tinContent,
                    onChange: this.handleInputChange,
                    validateLabel: 'MyKad (NRIC)',
                    label: 'MyKad (NRIC)',
                    type: 'text',
                    value: staff.identityNo
                  })
                ),
                isIndonesia && _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  null,
                  _react2.default.createElement(_AppForm2.default.Input, {
                    name: 'identityNo',
                    validation: tinContent ? [_webValidations.required, {
                      validate: _webValidations.matchRegex,
                      option: { validRegex: /^[a-zA-Z0-9_]*$/ }
                    }] : [{
                      validate: _webValidations.matchRegex,
                      option: { validRegex: /^[a-zA-Z0-9_]*$/ }
                    }],
                    ref: this.validation.identityNo,
                    required: tinContent,
                    onChange: this.handleInputChange,
                    validateLabel: 'KTP',
                    label: 'KTP',
                    type: 'text',
                    value: staff.identityNo
                  })
                ),
                (isMalaysia || isIndonesia) && _react2.default.createElement(
                  _semanticUiReact.Form.Field,
                  null,
                  _react2.default.createElement(_TinFieldInput2.default, {
                    isIndonesia: isIndonesia,
                    value: staff.taxIdentificationNo,
                    errMessage: this.state.tinMessage,
                    isLoading: this.state.validatingTin,
                    tinError: isMalaysia && this.state.tinError,
                    required: this.state.tinRequired
                    // readOnly={isMalaysia && this.state.tinFound}
                    , ref: this.validation.taxIdentificationNo,
                    onChange: this.handleTinInput,
                    validation: tinValidation,
                    identityType: _defaultIdentityTypeOpts.IDENTITY_TYPE_NRIC,
                    identityValue: staff.identityNo
                  })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { widths: 'equal' },
                _react2.default.createElement(_SelectBank2.default, {
                  label: (0, _translation2.translateModels)(t, 'bankAccountName', 'user'),
                  country: this.props.auth && this.props.auth.company ? this.props.auth.company.countryCode : '',
                  validateLabel: (0, _translation2.translateModels)(t, 'bankAccountName', 'user'),
                  ref: this.validation.bankAccountName,
                  onChange: this.handleInputChange,
                  name: 'bankAccountName',
                  placeholder: t('Select {{title}}', { title: t('Bank') }),
                  value: this.state.staff.bankAccountName,
                  validation: this.state.staff.bankAccountNumber ? [_webValidations.required] : []
                }),
                _react2.default.createElement(_AppForm2.default.Input, {
                  label: (0, _translation2.translateModels)(t, 'bankAccountNumber', 'user'),
                  validateLabel: (0, _translation2.translateModels)(t, 'bankAccountNumber', 'user'),
                  name: 'bankAccountNumber',
                  value: this.state.staff.bankAccountNumber,
                  onChange: this.handleInputChange,
                  ref: this.validation.bankAccountNumber,
                  validation: this.state.staff.bankAccountName ? [_webValidations.required, { validate: _webValidations.matchRegex, option: { validRegex: _regex.REGEX_BANK_ACCOUNT_NUMBER } }] : [{ validate: _webValidations.matchRegex, option: { validRegex: _regex.REGEX_BANK_ACCOUNT_NUMBER } }]
                })
              ),
              this.props.auth.isSuperAdmin ? _react2.default.createElement(
                _semanticUiReact.Form.Group,
                { grouped: true },
                _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Access') }),
                _groups.devGroups.map(function (group, idx) {
                  return _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                    checked: _this2.isUserType(group.id),
                    key: idx,
                    label: group.name,
                    value: group.code,
                    name: group.code,
                    disabled: true
                  });
                })
              ) : null
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('User API')
              ),
              !this.state.loading && _react2.default.createElement(_SpecificationTable2.default, {
                type: 'affiliateMappings',
                editable: true,
                isEditing: true,
                hideButton: true,
                notFoundNode: _react2.default.createElement(
                  'p',
                  null,
                  t('No mapping set'),
                  '.'
                ),
                headerNode: t('User Mapping'),
                data: staff && staff.mappings ? staff.mappings : [],
                onChange: this.handleMappingChange,
                loading: this.state.loading
              })
            )
          ),
          staff && !staff.viewAllProjects && !this.getBranchViewAllProjects() ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Projects Access')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table,
                { unstackable: true },
                _react2.default.createElement(
                  _semanticUiReact.Table.Body,
                  null,
                  !this.getBranchViewAllProjects() && this.getBranchProjects().length > 0 ? this.getBranchProjects().map(function (project, idx) {
                    return _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      { key: idx },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(_ListItem2.default, {
                          item: project,
                          header: function header(item) {
                            return _react2.default.createElement(
                              'span',
                              null,
                              item.name,
                              ' ',
                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'eye', fitted: true }),
                              _react2.default.createElement(
                                'i',
                                null,
                                ' ',
                                _react2.default.createElement(
                                  'small',
                                  null,
                                  'Business Unit Access'
                                )
                              )
                            );
                          },
                          subheader: function subheader(item) {
                            return item.status.name;
                          }
                        })
                      )
                    );
                  }) : null,
                  staff.projects && staff.projects.length > 0 && staff.projects.map(function (project, idx) {
                    return _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      { key: idx },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(_ListItem2.default, {
                          item: project,
                          header: function header(item) {
                            return item.name;
                          },
                          subheader: function subheader(item) {
                            return item.status.name;
                          },
                          rightComponent: _react2.default.createElement(
                            'div',
                            { className: _this2.state.edit ? null : 'hidden' },
                            _react2.default.createElement(_semanticUiReact.Button, {
                              type: 'button',
                              compact: true,
                              negative: true,
                              size: 'mini',
                              icon: 'remove',
                              onClick: function onClick() {
                                return _this2.handleRemoveProject(idx);
                              },
                              disabled: !_this2.state.edit
                            })
                          )
                        })
                      )
                    );
                  })
                )
              ),
              !(staff.projects && staff.projects.length > 0 || this.getBranchProjects() && this.getBranchProjects().length > 0) && _react2.default.createElement(
                _semanticUiReact.Segment,
                { textAlign: 'center' },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  'Loading'
                ) : t('No projects access')
              )
            )
          ) : null,
          staff && !staff.viewAllProjects ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              _react2.default.createElement(_semanticUiReact.Button, {
                content: t('Add project'),
                onClick: this.handleShowAddProject
              })
            )
          ) : null
        )
      );
    }
  }]);

  return StaffForm;
}(_react.Component);

StaffForm.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  auth: _propTypes2.default.shape({
    companyBranch: _propTypes2.default.shape({
      id: _propTypes2.default.number
    }),
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isBranchLeader: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  t: _propTypes2.default.func
};
StaffForm.contextTypes = {
  store: _propTypes2.default.object
};
StaffForm.defaultStaff = {
  identityNo: '',
  taxIdentificationNo: '',
  taxTinValidationStatus: 'failed',
  name: '',
  preferredName: '',
  email: '',
  mobilePrefix: '60',
  mobile: '',
  officeTelPrefix: '60',
  officeTel: '',
  profileImageSrc: '',
  companyBranchID: '',
  viewAllProjects: false,
  affiliateProjects: [],
  userID: null,
  user: null,
  mappings: [],
  fullName: '',
  bankAccountName: '',
  bankAccountNumber: ''
};
StaffForm.defaultUser = {
  id: null,
  groups: []
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getRoles = function () {
    var rolesArr = [];
    if (_this3.state.staff.user.groups && _this3.state.staff.user.groups.length > 0) {
      _this3.state.staff.user.groups.forEach(function (g) {
        // ignore CC & analytics role in SR
        if (_groups.ignoreGroupIDs.includes(g.id)) return;
        rolesArr.push(g.id);
      });
    }
    rolesArr.sort();
    return String(rolesArr.toString());
  };

  this.getBranchProjects = function () {
    var _state = _this3.state,
        staff = _state.staff,
        companyBranches = _state.companyBranches;

    if (staff && staff.companyBranchID && companyBranches.length > 0) {
      var foundBranch = companyBranches.find(function (d) {
        return d.id.toString() === staff.companyBranchID;
      });
      if (foundBranch && foundBranch.projects && foundBranch.projects.length > 0) {
        return foundBranch.projects.filter(function (d) {
          return d.statusID !== 'deleted';
        });
      }
    }
    return [];
  };

  this.getBranchViewAllProjects = function () {
    var _state2 = _this3.state,
        staff = _state2.staff,
        companyBranches = _state2.companyBranches;

    if (staff && staff.companyBranchID) {
      var foundBranch = companyBranches.find(function (d) {
        return d.id.toString() === staff.companyBranchID;
      });
      if (foundBranch && foundBranch.viewAllProjects) {
        return true;
      }
    }
    return false;
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var loadingType = arguments[1];
    return new Promise(function (res) {
      if (loadingType === 'validatingTIN') {
        _this3.setState({ validatingTin: loading }, res);
      }
    });
  };

  this.handleChangeRole = function (e, d) {
    var staff = _this3.state.staff;

    var groupIDs = d.value.split(',');
    var groups = _groups.devGroups.filter(function (g) {
      return groupIDs.includes(g.id);
    });
    var untouchedGroups = staff.user.groups.filter(function (g) {
      return _groups.ignoreGroupIDs.includes(g.id);
    });
    if (untouchedGroups && untouchedGroups.length > 0) {
      groups = [].concat(_toConsumableArray(groups), _toConsumableArray(untouchedGroups));
    }

    staff.user.groups = groups;
    _this3.setState({ staff: staff });
  };

  this.handleSubmit = function (event) {
    event.preventDefault();
    var _props$auth = _this3.props.auth,
        isHeadquarters = _props$auth.isHeadquarters,
        isSuperAdmin = _props$auth.isSuperAdmin,
        companyBranch = _props$auth.companyBranch;
    var staff = _this3.state.staff;

    if (!isHeadquarters && !isSuperAdmin && companyBranch && companyBranch.id) {
      staff.companyBranchID = companyBranch.id.toString();
    }
    if (staff && staff.mappings) {
      staff.mappings = staff.mappings.filter(function (d) {
        return d.name.length > 0 && d.value.length > 0;
      }).map(function (d, idx) {
        return _extends({}, d, {
          position: idx + 1
        });
      });
    }
    // `role` is derived from user.groups rather than being a field on the staff
    // record, so hand the validator a synthetic value instead of polluting the
    // payload that gets POSTed.
    return _AppForm2.default.validate(_this3.validation, _extends({}, staff, { role: _this3.getRoles() })).then(function (validations) {
      _this3.setState({
        errMessages: validations.filter(function (v) {
          return !v.isValid;
        })
      });

      staff.taxTinValidationStatus = _this3.state.tinError === false ? 'success' : 'failed';

      if (_this3.state.errMessages.length === 0 && _this3.state.tinRequired && staff.taxTinValidationStatus !== 'success') {
        var store = _this3.context.store;

        if (staff.taxTinValidationStatus !== 'success') {
          store.dispatch((0, _flash.flashMessage)({
            header: 'Invalid TIN',
            message: 'Tax Identification Number is invalid',
            icon: 'warning sign',
            type: 'error',
            autoHideDuration: 5000
          }));
          return;
        }
      }

      _this3.props.onSubmit(validations, staff);
    });
  };

  this.handleInputChange = function (event, data) {
    var _state3 = _this3.state,
        companyBranches = _state3.companyBranches,
        staff = _state3.staff;

    var selectedBranchIsExternal = _this3.state.selectedBranchIsExternal;
    if (data.name === 'companyBranchID') {
      var branch = companyBranches.find(function (b) {
        return b.id.toString() === data.value;
      });
      if (branch) {
        selectedBranchIsExternal = branch.isExternal;
        staff.user.groups = [{ id: '10', code: 'DEVELOPER_EXECUTIVE' }];
      }
    }
    staff[data.name] = data.value;
    _this3.setState({ staff: staff, selectedBranchIsExternal: selectedBranchIsExternal }, function () {
      // Validate TIN again on identityNo change.
      if (data.name === 'identityNo') {
        if (staff.taxIdentificationNo !== '') {
          _this3.handleTinInput({ target: { value: staff.taxIdentificationNo } });
        }
      }
      // Re-validate phone fields when prefix changes to clear stale validation state.
      if (data.name === 'mobilePrefix' && staff.mobile !== '') {
        _this3.validation.mobile.current.validate(staff.mobile);
      }
      if (data.name === 'officeTelPrefix' && staff.officeTel !== '') {
        _this3.validation.officeTel.current.validate(staff.officeTel);
      }
      _this3.handleCheckChanges();
    });
  };

  this.handleTinInput = function (e) {
    var staff = _this3.state.staff;
    var auth = _this3.props.auth;


    var isIndonesia = auth && auth.company && auth.company.countryCode && auth.company.countryCode.toUpperCase() === 'ID';

    if (isIndonesia) {
      staff.taxIdentificationNo = e.target.value; // Don't uppercase NPWP
      _this3.setState({ staff: staff }, function () {
        _this3.handleCheckChanges();
      });
      return;
    }

    // --- Malaysian Logic ---
    var tinInput = e.target.value.toUpperCase(); // Uppercase for MY TIN
    var tinFound = e.target.tinFound;
    var isAlphanumeric = /^[a-zA-Z0-9]*$/.test(tinInput);

    if (tinInput === '') {
      staff.taxIdentificationNo = '';
      _this3.setState({ staff: staff, tinFound: false, tinError: false, tinMessage: null });
      return;
    }

    if (isAlphanumeric) {
      staff.taxIdentificationNo = tinInput;
      _this3.setState({ staff: staff, tinFound: tinFound, tinError: tinFound === false, tinMessage: tinFound ? null : _this3.state.tinMessage }, function () {
        _this3.handleCheckChanges();
      });

      if (tinFound) {
        return;
      }
      // 1~2 letter followed by numeric with length 9 - 11
      var matched = _regex.REGEX_TIN_VALID.test(tinInput);
      var genericTin = (0, _tin.getGenericTinByIdTypeAndTinNo)(_defaultIdentityTypeOpts.IDENTITY_TYPE_NRIC, tinInput);
      _this3.setLoading(true, 'validatingTIN').then(function () {
        if (_this3.debounceTimeout) {
          clearTimeout(_this3.debounceTimeout);
        }

        _this3.debounceTimeout = setTimeout(function () {
          if (matched) {
            if (tinInput === _tin.GOVERNMENT_GENERIC_TIN) {
              _this3.setState({
                tinError: false,
                tinFound: true,
                tinMessage: null }, function () {
                _this3.setLoading(false, 'validatingTIN');
              });
            } else if (_tin.GENERIC_TIN_VALUES.includes(tinInput)) {
              _this3.setState({
                tinError: !(0, _tin.isGenericTinFound)(genericTin),
                tinFound: (0, _tin.isGenericTinFound)(genericTin),
                tinMessage: !(0, _tin.isGenericTinFound)(genericTin) ? _tin.GENERIC_TIN_UNMATCHED_ERROR_MSG : null }, function () {
                _this3.setLoading(false, 'validatingTIN');
              });
            } else {
              _this3.validateTIN(tinInput).finally(function () {
                _this3.setLoading(false, 'validatingTIN');
              });
            }
          } else {
            _this3.setState({ tinError: true }, function () {
              _this3.setLoading(false, 'validatingTIN');
            });
          }
        }, 3000);
      });
    }
  };

  this.handleMappingChange = function (m) {
    var staff = _this3.state.staff;

    staff.mappings = m;
    _this3.setState({ staff: staff }, function () {
      _this3.handleCheckChanges();
    });
  };

  this.handleCheckBoxChange = function (event, d) {
    var staff = _this3.state.staff;

    staff[d.name] = !staff[d.name];
    _this3.setState({ staff: staff });
  };

  this.handleRemoveProject = function (index) {
    if (_this3.state.edit) {
      var staff = _this3.state.staff;

      staff.projects.splice(index, 1);
      _this3.setState({ staff: staff });
    }
  };

  this.handleAddProject = function (e, projects) {
    e.preventDefault();
    var staff = _this3.state.staff;

    staff.projects = projects;
    _this3.setState({
      staff: staff,
      showAddProject: false
    });
  };

  this.handleShowAddProject = function (e) {
    e.preventDefault();
    _this3.setState({
      showAddProject: true
    });
  };

  this.handleCloseAddProject = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this3.setState({
      showAddProject: false
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.user]), { withRef: true })(StaffForm);

/***/ }),
/* 2479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _url = __webpack_require__(19);

var _fileSize = __webpack_require__(85);

var _fileSize2 = _interopRequireDefault(_fileSize);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _valueToText = __webpack_require__(98);

var _valueToText2 = _interopRequireDefault(_valueToText);

var _translation = __webpack_require__(4);

var _dataImport = __webpack_require__(1088);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_momentTimezone2.default.locale('en-gb');

var Import = function (_Component) {
  _inherits(Import, _Component);

  function Import(props) {
    _classCallCheck(this, Import);

    var _this = _possibleConstructorReturn(this, (Import.__proto__ || Object.getPrototypeOf(Import)).call(this, props));

    _initialiseProps.call(_this);

    var state = Import.getPropsToState(props);
    _this.state = _extends({}, state, {
      file: null,
      count: 0,
      data: [],
      limit: 10,
      offset: 0,
      token: null,
      updating: false
    });
    return _this;
  }

  _createClass(Import, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var query = (0, _url.decodeSearch)(this.props.location.search);
      this.fetchStaffs();
      this.fetchImports(query);
      this.ticker = setInterval(function () {
        if (_this2.state.updating && _this2.state.currentPage === 1) {
          _this2.fetchImports();
        }
      }, 2000);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = Import.getPropsToState(nextProps);

      var query = (0, _url.decodeSearch)(nextProps.location.search);
      this.fetchStaffs();
      this.fetchImports(query);

      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.ticker) {
        clearInterval(this.ticker);
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchImports',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var t, store, query, res, message, count, limit, offset, data, isUpdating;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                _context.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return store.dispatch((0, _fetchM.fetchM)('/staff_imports/?' + (0, _url.encodeSearch)(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 10:
                res = _context.sent;
                _context.next = 21;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                Bugsnag.notifyException(_context.t0);
                _context.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 18:
                _context.next = 20;
                return this.setLoading(false);

              case 20:
                return _context.abrupt('return');

              case 21:
                if (res.ok) {
                  _context.next = 29;
                  break;
                }

                _context.next = 24;
                return res.text();

              case 24:
                message = _context.sent;
                _context.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 27:
                _context.next = 40;
                break;

              case 29:
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 34;
                return res.json();

              case 34:
                data = _context.sent;
                isUpdating = this.state.updating;

                if (data && data[0]) {
                  if (!isUpdating && data[0].statusID === 'in_progress') isUpdating = true;
                  if (data[0].statusID === 'completed' || data[0].statusID === 'failed') isUpdating = false;
                }
                if (this.state.data && this.state.data.length < 1 && query.page > 1) {
                  query.page = 1;
                  store.dispatch((0, _reactRouterRedux.replace)('/users/import/?' + (0, _url.encodeSearch)(query)));
                }
                // handle token.. etc
                _context.next = 40;
                return this.setComponentState({
                  count: count,
                  data: data,
                  limit: limit,
                  offset: offset,
                  updating: isUpdating
                });

              case 40:
                _context.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function fetchImports(_x3) {
        return _ref.apply(this, arguments);
      }

      return fetchImports;
    }()
  }, {
    key: 'fetchStaffs',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(q) {
        var t, store, query, res, message, token;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                t = this.props.t;
                _context2.next = 3;
                return this.setLoading(true);

              case 3:
                store = this.context.store;
                query = Object.assign({}, q);

                query.limit = 1;
                res = void 0;
                _context2.prev = 7;
                _context2.next = 10;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/staffs/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 10:
                res = _context2.sent;
                _context2.next = 21;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2['catch'](7);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 18:
                _context2.next = 20;
                return this.setLoading(false);

              case 20:
                return _context2.abrupt('return');

              case 21:
                if (res.ok) {
                  _context2.next = 29;
                  break;
                }

                _context2.next = 24;
                return res.text();

              case 24:
                message = _context2.sent;
                _context2.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 27:
                _context2.next = 32;
                break;

              case 29:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context2.next = 32;
                return this.setState({
                  token: token
                });

              case 32:
                _context2.next = 34;
                return this.setLoading(false);

              case 34:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[7, 13]]);
      }));

      function fetchStaffs(_x4) {
        return _ref2.apply(this, arguments);
      }

      return fetchStaffs;
    }()
  }, {
    key: 'submitFile',
    value: function submitFile(body) {
      var _this5 = this;

      var t = this.props.t;

      this.setLoading(true);
      this.setState({ updating: true });
      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/staffs/import/', {
        credentials: 'include',
        method: 'POST',
        headers: {
          // Let browser decide Content-Type
          'X-Csrf-Token': this.state.token
        },
        body: body
      })).then(function (res) {
        _this5.setLoading(false);
        res.text().then(function () {
          _this5.setState({ file: null }, function () {
            _this5.fetchImports();
            store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Import Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Updating staffs', { ns: _translation.TRANSLATION_FILES.translation }) }));
          });
        });
      }).catch(function (err) {
        _this5.setLoading(false);
        if (err.res && err.res.status >= 400 && err.res.status < 500) {
          err.res.text().then(function (message) {
            store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
          });
          _this5.setState({ file: null, updating: false });
          return;
        }
        store.dispatch((0, _flash.flashErrorMessage)(err));
      });
    }
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var store = this.context.store;

      store.dispatch((0, _reactRouterRedux.replace)('/users/import/?' + (0, _url.encodeSearch)(query)));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Import Users', { ns: _translation.TRANSLATION_FILES.screens })
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { textAlign: 'center' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                {
                  inverted: true, style: { zIndex: 20 },
                  active: this.state.loading
                },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                'form',
                {
                  encType: 'multipart/form-data',
                  onSubmit: this.handleSubmit,
                  ref: function ref(_ref4) {
                    _this6.form = _ref4;
                  },
                  style: { display: 'none' }
                },
                t('Select file to upload:', { ns: _translation.TRANSLATION_FILES.translation }),
                _react2.default.createElement('input', {
                  accept: '.xlsx',
                  id: 'import_upload',
                  name: 'import_upload',
                  onChange: this.handleOnChange,
                  ref: function ref(_ref3) {
                    _this6.import_upload = _ref3;
                  },
                  type: 'file'
                })
              ),
              _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel outline', size: 'massive', color: 'grey', style: { fontSize: '7em', opacity: '0.3' } }),
              _react2.default.createElement(
                _semanticUiReact.Header,
                { as: 'h2' },
                t('Bulk Import', { ns: _translation.TRANSLATION_FILES.translation }),
                _react2.default.createElement(
                  _semanticUiReact.Header.Subheader,
                  null,
                  t('Import user listing using xlsx.', { ns: _translation.TRANSLATION_FILES.translation }),
                  _react2.default.createElement('br', null),
                  t('Download xlsx', { ns: _translation.TRANSLATION_FILES.translation }),
                  _react2.default.createElement(
                    'a',
                    {
                      href: _config2.default.get('bookApiURL') + '/staffs/export_template/',
                      target: '_blank',
                      rel: 'noopener noreferrer'
                    },
                    '\xA0',
                    t('empty', { ns: _translation.TRANSLATION_FILES.translation }),
                    '\xA0'
                  ),
                  t('template or', { ns: _translation.TRANSLATION_FILES.translation }),
                  _react2.default.createElement(
                    'a',
                    {
                      href: _config2.default.get('bookApiURL') + '/staffs/export_example/',
                      target: '_blank',
                      rel: 'noopener noreferrer'
                    },
                    '\xA0',
                    t('example', { ns: _translation.TRANSLATION_FILES.translation }),
                    '\xA0'
                  ),
                  '.'
                )
              ),
              this.state.file && this.state.file.name ? _react2.default.createElement(
                _semanticUiReact.Grid,
                { centered: true, padded: true },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { style: { padding: '0 0 0.5em' } },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { mobile: 14, tablet: 9, computer: 6, textAlign: 'left' },
                    _react2.default.createElement(
                      _semanticUiReact.Message,
                      {
                        className: 'import_file_selcted',
                        info: true,
                        onDismiss: this.handleDismiss,
                        size: 'tiny'
                      },
                      this.state.file.name
                    )
                  )
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  disabled: this.state.updating,
                  onClick: this.handleAddFile,
                  style: { marginBottom: '0.5em' }
                },
                t('Browse File', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(
                _semanticUiReact.Button,
                {
                  disabled: !this.state.file || this.state.updating,
                  onClick: this.handleOnSubmit,
                  positive: true,
                  style: { display: 'block', margin: 'auto' }
                },
                t('Upload', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
              _react2.default.createElement(
                _semanticUiReact.Table,
                {
                  striped: true, unstackable: true,
                  selectable: true
                },
                _react2.default.createElement(
                  _semanticUiReact.Table.Header,
                  { fullWidth: true },
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      { colSpan: 3 },
                      _react2.default.createElement(
                        'h3',
                        null,
                        t('Imports History', { ns: _translation.TRANSLATION_FILES.translation })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      { colSpan: 2, textAlign: 'right' },
                      _react2.default.createElement(_PageNav2.default, {
                        currentPage: this.state.currentPage,
                        count: this.state.count,
                        limit: this.state.limit,
                        offset: this.state.offset,
                        dataSize: this.state.data ? this.state.data.length : 0,
                        loading: this.state.loading,
                        onChange: this.handleChangePage
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Name', { ns: _translation.TRANSLATION_FILES.constants })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Size', { ns: _translation.TRANSLATION_FILES.translation })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Imported By', { ns: _translation.TRANSLATION_FILES.translation })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Date', { ns: _translation.TRANSLATION_FILES.screens })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Status', { ns: _translation.TRANSLATION_FILES.translation })
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Body,
                  null,
                  this.state.data && this.state.data.length > 0 ? this.state.data.map(function (file, key) {
                    return _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      { key: key },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { width: 6 },
                        _react2.default.createElement(
                          'a',
                          {
                            href: _config2.default.get('bookApiURL') + '/staff_imports/view/' + file.id + '/' + file.name,
                            target: '_blank',
                            rel: 'noopener noreferrer'
                          },
                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'file excel outline' }),
                          file.name
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { collapsing: true },
                        (0, _fileSize2.default)(file.size)
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { collapsing: true },
                        file.userPreferredName
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { collapsing: true },
                        _react2.default.createElement(_Timestamp2.default, { format: 'MMMM Do YYYY, h:mm a', timestamp: file.createdAt })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { width: 4 },
                        _react2.default.createElement(
                          _semanticUiReact.Progress,
                          {
                            size: 'small',
                            percent: (0, _dataImport.progressToPercent)(file.updatedCount, file.totalCount),
                            progress: true,
                            color: file.statusID === 'in_progress' ? 'blue' : null,
                            success: file.statusID === 'completed',
                            active: file.statusID === 'in progress',
                            error: file.statusID === 'failed'
                          },
                          (0, _valueToText2.default)(_dataImport.STATUSES, file.statusID),
                          file.statusID === 'failed' && file.remarks && _react2.default.createElement(_semanticUiReact.Popup, {
                            trigger: _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: '#912d2b' }),
                            content: file.remarks,
                            size: 'mini'
                          })
                        ),
                        _react2.default.createElement(_Timestamp2.default, { format: 'MMMM Do YYYY, h:mm a', timestamp: file.updatedAt })
                      )
                    );
                  }) : _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      { colSpan: 5, textAlign: 'center' },
                      t('No imports found.', { ns: _translation.TRANSLATION_FILES.translation })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return Import;
}(_react.Component);

Import.propTypes = {
  t: _propTypes2.default.func,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    search: _propTypes2.default.string,
    query: _propTypes2.default.object
  }),
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      importStaffExcelExampleLink: _propTypes2.default.string
    })
  })
};

Import.mapStateToProps = function (state) {
  return {
    appConfig: state.appConfig
  };
};

Import.contextTypes = {
  store: _propTypes2.default.object
};

Import.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var currentPage = parseInt(query.page, 10) || 1;
  var loading = props.loading;
  return {
    currentPage: currentPage,
    loading: loading
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.handleAddFile = function (e) {
    e.preventDefault();
    _this7.import_upload.click();
  };

  this.handleOnChange = function () {
    var files = Array.prototype.slice.call(_this7.import_upload.files);
    _this7.import_upload.value = null;
    if (window.FileReader) {
      files.forEach(function (file) {
        var reader = new FileReader();
        reader.onloadend = function () {
          _this7.setState({ file: file });
        };
        reader.readAsDataURL(file);
      });
    }
  };

  this.handleOnSubmit = function (e) {
    e.preventDefault();
    _this7.handleSubmit();
  };

  this.handleSubmit = function () {
    var formData = new FormData();
    formData.append('import_upload', _this7.state.file);
    _this7.submitFile(formData);
  };

  this.handleDismiss = function () {
    _this7.setState({ file: null });
  };

  this.handleChangePage = function (page) {
    var query = (0, _url.decodeSearch)(_this7.props.location.search);
    if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
      query.page = 1;
    }
    var currentPage = parseInt(page || query.page, 10);
    query.page = currentPage;
    _this7.setState({ currentPage: currentPage });
    _this7.replaceQuery(query);
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Import.mapStateToProps)(Import));

/***/ }),
/* 2480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _semanticUiReact = __webpack_require__(2);

var _reactRouter = __webpack_require__(18);

var _reactI18next = __webpack_require__(3);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _reactRedux = __webpack_require__(9);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _Filters = __webpack_require__(86);

var _translation = __webpack_require__(4);

var _groups = __webpack_require__(194);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */
/* eslint no-nested-ternary: 0 */


var StaffList = function (_Component) {
  _inherits(StaffList, _Component);

  function StaffList(props) {
    _classCallCheck(this, StaffList);

    var _this = _possibleConstructorReturn(this, (StaffList.__proto__ || Object.getPrototypeOf(StaffList)).call(this, props));

    _initialiseProps.call(_this);

    var state = StaffList.getPropsToState(props);
    var query = (0, _url.decodeSearch)(props.location.search);
    var search = query.search || '';
    _this.state = _extends({}, state, {
      data: [],
      count: 0,
      limit: 0,
      offset: 0,
      currentPage: parseInt(query.page, 10) || 1,
      search: search,
      token: null,
      loading: true,
      branches: [],
      companyBranches: [],
      businessUnitFilter: false
    });
    return _this;
  }

  _createClass(StaffList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var store = this.context.store;
      var query = this.props.location.query;

      window.addEventListener('resize', this.handleResize, false);
      this.fetchCompanyBranches();
      if (!(0, _isNumber2.default)(query.page) || query.page <= 0) {
        delete query.page;
      }
      store.dispatch((0, _reactRouterRedux.replace)('/users/?' + _qs2.default.stringify(query)));
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var state = StaffList.getPropsToState(nextProps);
      this.setState(_extends({}, state), function () {
        var query = nextProps.location.query;

        _this2.fetchStaffs(query);
        if (query.statusID && query.statusID.length > 0 || query.roleID && query.roleID.length > 0 || query.companyBranchID && query.companyBranchID.length > 0) {
          _this2.setState({
            advanceFilter: true
          });
        }
      });
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setStaffs',
    value: function setStaffs() {
      var _this3 = this;

      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      return new Promise(function (res) {
        _this3.setState({
          data: data || []
        }, function () {
          res(data);
        });
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this4 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this4.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this5 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this5.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isBranchLeaderSupervisor || this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'hasEditBUAccess',
    value: function hasEditBUAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'fetchStaffs',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var store, t, query, res, message, token, count, limit, offset, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/staffs/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 10:
                res = _context.sent;
                _context.next = 21;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                Bugsnag.notifyException(_context.t0);
                _context.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 18:
                _context.next = 20;
                return this.setLoading(false);

              case 20:
                return _context.abrupt('return');

              case 21:
                if (res.ok) {
                  _context.next = 29;
                  break;
                }

                _context.next = 24;
                return res.text();

              case 24:
                message = _context.sent;
                _context.next = 27;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 27:
                _context.next = 40;
                break;

              case 29:
                token = res.headers.get('X-Csrf-Token');
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 35;
                return res.json();

              case 35:
                data = _context.sent;
                _context.next = 38;
                return this.setStaffs(data);

              case 38:
                _context.next = 40;
                return this.setComponentState({
                  token: token,
                  count: count,
                  limit: limit,
                  offset: offset
                });

              case 40:
                _context.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function fetchStaffs(_x6) {
        return _ref.apply(this, arguments);
      }

      return fetchStaffs;
    }()
  }, {
    key: 'fetchCompanyBranches',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, t, res, message, branches;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context2.prev = 3;
                _context2.next = 6;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/company_branches/?page=all', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 6:
                res = _context2.sent;
                _context2.next = 15;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](3);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 14;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 14:
                return _context2.abrupt('return');

              case 15:
                if (res.ok) {
                  _context2.next = 23;
                  break;
                }

                _context2.next = 18;
                return res.text();

              case 18:
                message = _context2.sent;
                _context2.next = 21;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 21:
                _context2.next = 28;
                break;

              case 23:
                _context2.next = 25;
                return res.json();

              case 25:
                branches = _context2.sent;
                _context2.next = 28;
                return this.setState({
                  branches: branches ? branches.map(function (ul) {
                    var branch = { text: ul.name, name: ul.shortName, value: ul.id.toString(), description: ul.isExternal ? 'Agency' : '' };
                    return branch;
                  }) : [],
                  companyBranches: branches
                });

              case 28:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 9]]);
      }));

      function fetchCompanyBranches() {
        return _ref2.apply(this, arguments);
      }

      return fetchCompanyBranches;
    }()
  }, {
    key: 'replaceQuery',
    value: function replaceQuery(query) {
      var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var store = this.context.store;

      var queryNew = query;
      if (resetPage) {
        queryNew.page = 1;
      }
      store.dispatch((0, _reactRouterRedux.push)('/users/?' + (0, _url.encodeSearch)(query)));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this6 = this;

      var store = this.context.store;
      var t = this.props.t;

      var query = (0, _url.decodeSearch)(this.props.location.search);
      var exportItems = [{
        text: 'Excel',
        href: _config2.default.get('bookApiURL') + '/staffs/export/?' + _qs2.default.stringify(Object.assign(query, { fileType: 'excel' }))
      }, {
        text: 'CSV',
        href: _config2.default.get('bookApiURL') + '/staffs/export/?' + _qs2.default.stringify(Object.assign(query, { fileType: 'csv' }))
      }];
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: this.state.count === 0 ? t('Users') : _react2.default.createElement(
            'span',
            null,
            t('Users'),
            ' \xA0',
            _react2.default.createElement(
              _semanticUiReact.Label,
              { size: 'large' },
              this.state.count
            )
          ),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu,
            { className: 'transparentMenu' },
            _react2.default.createElement(
              _semanticUiReact.Menu.Item,
              { fitted: true },
              _react2.default.createElement(
                _semanticUiReact.Dropdown,
                { item: true, text: t('Manage') },
                _react2.default.createElement(
                  _semanticUiReact.Dropdown.Menu,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Dropdown.Item,
                    {
                      onClick: this.handleManageClick,
                      value: 'import/'
                    },
                    t('Import Users', { ns: _translation.TRANSLATION_FILES.screens })
                  )
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Menu.Item,
              { fitted: true },
              _react2.default.createElement(_semanticUiReact.Button, {
                primary: true,
                icon: 'add',
                content: t('User', { ns: _translation.TRANSLATION_FILES.screens }),
                disabled: this.state.loading,
                onClick: function onClick() {
                  return store.dispatch((0, _reactRouterRedux.push)('/users/new/'));
                }
              })
            )
          )
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _SearchFilter2.default,
                {
                  advanceFilter: this.state.advanceFilter,
                  isLoading: this.state.loading,
                  onChange: this.handleFilterOnChange,
                  onClose: this.handleClearFilter,
                  search: this.state.search,
                  setAdvanceFilter: this.handleSetAdvanceFilter,
                  leftNav: _react2.default.createElement(_PageNav2.default, {
                    currentPage: this.state.currentPage,
                    count: this.state.count,
                    limit: this.state.limit,
                    offset: this.state.offset,
                    dataSize: this.state.data.length,
                    loading: this.state.loading,
                    onChange: this.handleChangePage
                  }),
                  rightNav: _react2.default.createElement(
                    'div',
                    null,
                    this.state.isMobile && _react2.default.createElement(_semanticUiReact.Button, {
                      color: 'teal',
                      icon: 'group',
                      onClick: function onClick() {
                        return store.dispatch((0, _reactRouterRedux.push)('/business_units/'));
                      }
                    }),
                    this.hasAccess() && _react2.default.createElement(_SortButton2.default, {
                      icon: 'download',
                      loading: this.state.loading,
                      items: exportItems
                    }),
                    _react2.default.createElement(_SortButton2.default, {
                      loading: this.state.loading,
                      items: this.sortItems,
                      onSort: this.handleSortData
                    })
                  )
                },
                _react2.default.createElement(_Filters.SelectList, {
                  filterName: 'roleID',
                  headerText: null,
                  onChange: this.handleFilterOnChange,
                  onClose: this.handleClearFilter,
                  options: this.filterRoles.map(function (r) {
                    return _extends({}, r, {
                      text: t(r.text, { ns: _translation.TRANSLATION_FILES.constants })
                    });
                  }),
                  placeholder: t('Select Access Role'),
                  value: this.state.roleID
                }),
                _react2.default.createElement(_Filters.SelectList, {
                  filterName: 'statusID',
                  headerText: null,
                  onChange: this.handleFilterOnChange,
                  onClose: this.handleClearFilter,
                  options: this.userStateses.map(function (s) {
                    return _extends({}, s, {
                      text: t(s.text, { ns: _translation.TRANSLATION_FILES.constants })
                    });
                  }),
                  placeholder: t('Select Access Status'),
                  value: this.state.statusID
                }),
                _react2.default.createElement(_Filters.SelectList, {
                  filterName: 'companyBranchID',
                  headerText: null,
                  onChange: this.handleFilterOnChange,
                  onClose: this.handleClearFilter,
                  options: this.state.branches,
                  placeholder: t('Select Business Unit'),
                  value: this.state.companyBranchID,
                  hasSearch: true,
                  onFocus: this.state.businessUnitFilter
                })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { only: 'computer tablet', textAlign: 'center', style: { paddingBottom: '0px' } },
            _react2.default.createElement(_semanticUiReact.Grid.Column, { computer: 4, tablet: 4 }),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'manage_user_bu_search_grid', computer: 4, tablet: 4 },
              _react2.default.createElement(_semanticUiReact.Button, {
                content: t('Filter by Business Unit'),
                disabled: this.state.loading,
                onClick: this.handleOpenFilterFusinessUnit
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { computer: 4, tablet: 4 },
              this.hasEditBUAccess() ? _react2.default.createElement(_semanticUiReact.Button, {
                primary: true,
                content: t('Edit Business Units'),
                disabled: this.state.loading,
                onClick: function onClick() {
                  return store.dispatch((0, _reactRouterRedux.push)('/business_units/'));
                }
              }) : ''
            ),
            _react2.default.createElement(_semanticUiReact.Grid.Column, { computer: 4, tablet: 4 })
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            { style: { paddingTop: '0px' } },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                {
                  inverted: true,
                  active: this.state.loading && this.state.data.length > 0
                },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Table,
                {
                  celled: true,
                  selectable: true,
                  compact: true,
                  className: 'app--tablelist'
                },
                _react2.default.createElement(
                  _semanticUiReact.Table.Header,
                  { className: 'mobile-hide' },
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Name')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Email')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Mobile')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Business Unit')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Access')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      null,
                      t('Status')
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Body,
                  null,
                  this.state.data.length > 0 ? this.state.data.map(function (data, idx) {
                    return _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      {
                        key: idx,
                        title: t('View User'),
                        onClick: function onClick() {
                          return store.dispatch((0, _reactRouterRedux.push)('/users/' + data.id + '/'));
                        },
                        negative: data.user && data.user.statusID !== '100'
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'user', className: 'computer-hide' }),
                        _react2.default.createElement(
                          _reactRouter.Link,
                          { to: '/users/' + data.id + '/' },
                          _react2.default.createElement(
                            'b',
                            null,
                            data.name
                          ),
                          '\xA0',
                          _react2.default.createElement(_semanticUiReact.Icon, { style: { float: 'right' }, name: 'chevron right', className: 'computer-hide' })
                        ),
                        _this6.props.auth.email === data.email ? _react2.default.createElement(
                          _semanticUiReact.Label,
                          { size: 'mini', color: 'blue' },
                          t('You')
                        ) : ''
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'mail', className: 'computer-hide' }),
                        data.email
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { collapsing: true },
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'phone', className: 'computer-hide' }),
                        data.mobilePrefix,
                        data.mobile
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'home', className: 'computer-hide' }),
                        data.companyBranch ? _react2.default.createElement(
                          'span',
                          null,
                          data.companyBranch.name,
                          '\xA0',
                          data.companyBranch.isExternal ? _react2.default.createElement(
                            _semanticUiReact.Label,
                            { size: 'mini', color: 'teal' },
                            t('Agency')
                          ) : ''
                        ) : ''
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(_semanticUiReact.Icon, { name: 'wrench', className: 'computer-hide' }),
                        data.user && data.user.groups && data.user.groups.length > 0 ? _this6.getRoleText(data) !== '' && t(_this6.getRoleText(data), { ns: _translation.TRANSLATION_FILES.constants }) : null,
                        _react2.default.createElement(
                          'span',
                          { className: 'computer-hide' },
                          '\xA0',
                          data.user ? _react2.default.createElement(
                            _semanticUiReact.Label,
                            { size: 'mini', color: data.user && data.user.statusID !== '100' ? 'red' : null },
                            _this6.getValueName(data.user.statusID, _this6.userStateses)
                          ) : ''
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        { collapsing: true },
                        _react2.default.createElement(
                          'span',
                          { className: 'mobile-hide' },
                          data.user && _this6.getValueName(data.user.statusID, _this6.userStateses)
                        )
                      )
                    );
                  }) : _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.Cell,
                      { colSpan: '6', textAlign: 'center' },
                      this.state.loading ? _react2.default.createElement(
                        _semanticUiReact.Loader,
                        { active: true, inline: 'centered' },
                        t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                      ) : _react2.default.createElement(
                        'p',
                        null,
                        t('No users found'),
                        '.'
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Table.Footer,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Table.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Table.HeaderCell,
                      { colSpan: '6', textAlign: 'center' },
                      _react2.default.createElement(_PageNav2.default, {
                        upward: true,
                        currentPage: this.state.currentPage,
                        count: this.state.count,
                        limit: this.state.limit,
                        offset: this.state.offset,
                        dataSize: this.state.data.length,
                        loading: this.state.loading,
                        onChange: this.handleChangePage
                      })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return StaffList;
}(_react.Component);

StaffList.contextTypes = {
  store: _propTypes2.default.object
};
StaffList.propTypes = {
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  }),
  auth: _propTypes2.default.shape({
    email: _propTypes2.default.string,
    isBranchLeaderSupervisor: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool
  }),
  t: _propTypes2.default.func
};

StaffList.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

StaffList.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var statusID = query.statusID || '';
  var roleID = query.roleID || '';
  var companyBranchID = query.companyBranchID || '';
  var windowWidth = window.innerWidth;
  var isMobile = windowWidth < 768;
  var returnStates = {
    statusID: statusID,
    roleID: roleID,
    companyBranchID: companyBranchID,
    isMobile: isMobile,
    advanceFilter: false
  };
  return returnStates;
};

var _initialiseProps = function _initialiseProps() {
  var _this7 = this;

  this.getRoles = function (data) {
    var rolesArr = [];
    data.user.groups.forEach(function (g) {
      // ignore CC & analytics role in SR
      if (_groups.ignoreGroupIDs.includes(g.id)) return;
      rolesArr.push(g.id);
    });
    rolesArr.sort();
    return String(rolesArr.toString());
  };

  this.getRoleText = function (data) {
    var role = _this7.roles.find(function (g) {
      return g.value === _this7.getRoles(data);
    });
    if (role && role.text) {
      return role.text;
    }
    if (role && role.value === '10') {
      if (data.companyBranch && data.companyBranch.isExternal) return 'Agent';
      return 'Staff';
    }
    return '';
  };

  this.getValueName = function (value, arr) {
    var t = _this7.props.t;

    var valueName = arr.find(function (vn) {
      return vn.value === value;
    });
    if (valueName && valueName.text) {
      return t(valueName.text, { ns: _translation.TRANSLATION_FILES.constants });
    }
    return '';
  };

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this7.props.location.search);
    query.page = currentPage;
    _this7.setState({
      currentPage: currentPage
    });
    _this7.replaceQuery(query);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this7.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this7.replaceQuery(query, true);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this7.props.location.search);
    var filterArray = [].concat(queryArray);
    var states = void 0;
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
        states = _defineProperty({}, filter, '');
      }
    });
    _this7.setState(_extends({}, states), function () {
      if (hasQuery) {
        _this7.replaceQuery(query, true);
      }
    });
  };

  this.handleFilterOnChange = function (value, queryName) {
    var _this7$setState;

    var query = (0, _url.decodeSearch)(_this7.props.location.search);
    query[queryName] = value;
    _this7.setState((_this7$setState = {}, _defineProperty(_this7$setState, queryName, value), _defineProperty(_this7$setState, 'businessUnitFilter', false), _this7$setState));
    _this7.replaceQuery(query, true);
  };

  this.handleSetAdvanceFilter = function (advanceFilter) {
    _this7.setState({
      advanceFilter: advanceFilter
    });
  };

  this.handleOpenFilterFusinessUnit = function () {
    return _this7.setState({ advanceFilter: !_this7.state.advanceFilter, businessUnitFilter: true });
  };

  this.handleResize = function () {
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 768;
    if (isMobile !== _this7.state.isMobile) {
      _this7.setState({ isMobile: isMobile });
    }
  };

  this.handleManageClick = function (e, data) {
    e.preventDefault();
    var store = _this7.context.store;

    store.dispatch((0, _reactRouterRedux.push)('/users/' + data.value));
  };

  this.sortItems = [{
    text: 'Newest',
    icon: 'sort numeric descending',
    sortColumn: 'affiliate.created_at',
    sortDirection: 'desc'
  }, {
    text: 'Oldest',
    icon: 'sort numeric ascending',
    sortColumn: 'affiliate.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Name Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'affiliate.name',
    sortDirection: 'asc'
  }, {
    text: 'Name Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'affiliate.name',
    sortDirection: 'desc'
  }];
  this.roles = [{ text: 'Headquarters', value: '10,6' }, { text: 'Supervisor', value: '10,11,12,13' }, { text: 'Sales Manager', value: '10,11,13' }, { text: 'Sales Admin', value: '10,11' }, { text: '', value: '10' }, { text: 'Agency Admin', value: '10,21' }, { text: 'Agent Leader', value: '10,17' }, { text: 'Basic Siteplan', value: '16' }];
  this.userStateses = [{ value: '100', text: 'Active' },
  // { value: '502', text: 'Delisted' },
  { value: '503', text: 'Suspended' }];
  this.filterRoles = [{ text: 'Headquarters', value: '1', disabled: !(this.props.auth.isSuperAdmin || this.props.auth.isHeadquarters) }, { text: 'Supervisor', value: '2' }, { text: 'Sales Manager', value: '3' }, { text: 'Sales Admin', value: '4' }, { text: 'Staff', value: '5' }, { text: 'Agent Leader', value: '9' }, { text: 'Agency Admin', value: '10' }, { text: 'Agent', value: '6' }, { text: 'Basic Siteplan', value: '7' }];
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(StaffList.mapStateToProps)(StaffList));

/***/ }),
/* 2481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(2478);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var New = function (_Component) {
  _inherits(New, _Component);

  function New(props) {
    _classCallCheck(this, New);

    var _this = _possibleConstructorReturn(this, (New.__proto__ || Object.getPrototypeOf(New)).call(this, props));

    _this.handleSubmit = function (event) {
      event.preventDefault();
      var store = _this.context.store;

      _this.form.handleSubmit(event).catch(function (err) {
        Bugsnag.notifyException(err);
        store.dispatch((0, _flash.flashErrorMessage)(err));
      });
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments[1];

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges, callback);
      }
    };

    _this.state = {
      token: null,
      hasChanges: false
    };
    return _this;
  }

  _createClass(New, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.getToken();
    }
  }, {
    key: 'getToken',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, token;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                res = void 0;
                _context.prev = 2;
                _context.next = 5;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/staffs/?token', {
                  credentials: 'include',
                  method: 'GET'
                }));

              case 5:
                res = _context.sent;
                _context.next = 14;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](2);

                Bugsnag.notifyException(_context.t0);
                _context.next = 13;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 13:
                return _context.abrupt('return');

              case 14:
                if (res.ok) {
                  _context.next = 22;
                  break;
                }

                _context.next = 17;
                return res.text();

              case 17:
                message = _context.sent;
                _context.next = 20;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 20:
                _context.next = 24;
                break;

              case 22:
                token = res.headers.get('X-Csrf-Token');

                this.setState({
                  token: token
                });

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 8]]);
      }));

      function getToken() {
        return _ref.apply(this, arguments);
      }

      return getToken;
    }()
  }, {
    key: 'submit',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(validations, staff) {
        var _this2 = this;

        var store, errors, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context2.next = 5;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context2.abrupt('return');

              case 5:
                _context2.prev = 5;
                _context2.next = 8;
                return this.form.submit(_config2.default.get('bookApiURL') + '/staffs/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(staff)
                });

              case 8:
                _context2.next = 20;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](5);

                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 18;
                  break;
                }

                _context2.next = 15;
                return _context2.t0.res.text();

              case 15:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 18:
                store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));
                return _context2.abrupt('return');

              case 20:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false, function (noChanges) {
                    if (noChanges) {
                      store.dispatch((0, _reactRouterRedux.push)('/users/'));
                      store.dispatch((0, _flash.flashSuccessMessage)({ header: 'Create Success', message: staff.name + ' successfully created' }));
                    }
                  });
                });

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 10]]);
      }));

      function submit(_x2, _x3) {
        return _ref2.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('New User'),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Create'),
              onClick: this.handleSubmit
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref3) {
            _this3.form = _ref3;
          },
          onSubmit: function onSubmit(validations, staff) {
            _this3.submit(validations, staff);
          },
          onChange: this.handleOnChange,
          location: this.props.location,
          auth: this.props.auth,
          loading: this.props.loading
        })
      );
    }
  }]);

  return New;
}(_react.Component);

New.propTypes = {
  location: _propTypes2.default.shape({
    hash: _propTypes2.default.string
  }),
  loading: _propTypes2.default.bool,
  auth: _propTypes2.default.shape({
    companyBranch: _propTypes2.default.shape({
      id: _propTypes2.default.number
    }),
    isHeadquarters: _propTypes2.default.bool
  }),
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
New.contextTypes = {
  store: _propTypes2.default.object
};

New.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.user]))((0, _reactRedux.connect)(New.mapStateToProps)(New));

/***/ }),
/* 2482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _webValidations = __webpack_require__(23);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _reactRouter = __webpack_require__(18);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _intlCallCodes = __webpack_require__(116);

var _intlCallCodes2 = _interopRequireDefault(_intlCallCodes);

var _groups = __webpack_require__(194);

var _roles = __webpack_require__(1048);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _EditableBox = __webpack_require__(153);

var _EditableBox2 = _interopRequireDefault(_EditableBox);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _PhoneInput = __webpack_require__(104);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

var _Select = __webpack_require__(382);

var _Select2 = _interopRequireDefault(_Select);

var _Phone = __webpack_require__(126);

var _Phone2 = _interopRequireDefault(_Phone);

var _ListItem = __webpack_require__(261);

var _ListItem2 = _interopRequireDefault(_ListItem);

var _ProjectsList = __webpack_require__(400);

var _ProjectsList2 = _interopRequireDefault(_ProjectsList);

var _DeleteConfirm = __webpack_require__(80);

var _DeleteConfirm2 = _interopRequireDefault(_DeleteConfirm);

var _MoveStaffToExternalBranch = __webpack_require__(2519);

var _MoveStaffToExternalBranch2 = _interopRequireDefault(_MoveStaffToExternalBranch);

var _SpecificationTable = __webpack_require__(127);

var _SpecificationTable2 = _interopRequireDefault(_SpecificationTable);

var _Timestamp = __webpack_require__(28);

var _Timestamp2 = _interopRequireDefault(_Timestamp);

var _displayTime = __webpack_require__(156);

var _countries = __webpack_require__(60);

var _navigations = __webpack_require__(1069);

var _phone = __webpack_require__(146);

var _storage = __webpack_require__(44);

var _staff = __webpack_require__(2589);

var _TinFieldInput = __webpack_require__(192);

var _TinFieldInput2 = _interopRequireDefault(_TinFieldInput);

var _regex = __webpack_require__(143);

var _identityTypes = __webpack_require__(174);

var _translation = __webpack_require__(4);

var _translation2 = __webpack_require__(64);

var _SelectBank = __webpack_require__(218);

var _SelectBank2 = _interopRequireDefault(_SelectBank);

var _tin = __webpack_require__(155);

var _defaultIdentityTypeOpts = __webpack_require__(154);

var _i18n = __webpack_require__(401);

var _i18n2 = _interopRequireDefault(_i18n);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-nested-ternary */


var styles = {
  divider: { margin: '0.5em 0' }
};

// These audit rows name their zone with `z`. Once a Vietnam value is converted to the viewer's
// browser zone that token resolves to an empty string, which would silently drop the zone from a
// row whose whole point is when a ban started and ends — so Vietnam spells the offset out instead.
var cooldownFormat = function cooldownFormat(countryCode) {
  return (0, _countries.isCountryVietnam)(countryCode) ? 'MMMM Do YYYY, h:mm:ss a ([UTC]Z)' : 'MMMM Do YYYY, h:mm:ss a (z)';
};

var Overview = function (_Component) {
  _inherits(Overview, _Component);

  function Overview(props) {
    _classCallCheck(this, Overview);

    var _this = _possibleConstructorReturn(this, (Overview.__proto__ || Object.getPrototypeOf(Overview)).call(this, props));

    _initialiseProps.call(_this);

    var tinError = null;

    var phoneValidationPresets = {};
    var storePhoneValidationPresets = (0, _storage.getItem)(_config2.default.get('appName') + '.phoneValidationPresets');
    if (storePhoneValidationPresets) {
      try {
        phoneValidationPresets = JSON.parse(storePhoneValidationPresets).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }

    _this.state = {
      token: null,
      loading: true,
      edit: false,
      data: null,
      oriData: null,
      branches: [],
      fullBranches: [],
      errMessages: [],
      tinMessage: null,
      hasChanges: false,
      showConfirmBranch: false,
      selectedBranchIsExternal: false,
      showAddProject: false,
      cooldownToken: null,
      cooldownBAPData: [],
      cooldownData: [],
      deleteCooldownType: '', // 'bap' or 'unit'
      deleteCooldownName: '',
      deleteCooldownID: '',
      showDeleteCooldownConfirm: false,
      phoneValidationPresets: phoneValidationPresets,
      tinError: tinError,
      tinRequired: false,
      tinEnabled: true,
      // flag to enable/disable tin searched using the lhdn api
      tinFound: false
    };
    _this.validation = {
      name: (0, _react.createRef)(),
      preferredName: (0, _react.createRef)(),
      email: (0, _react.createRef)(),
      mobilePrefix: (0, _react.createRef)(),
      mobile: (0, _react.createRef)(),
      companyBranchID: (0, _react.createRef)(),
      role: (0, _react.createRef)(),
      identityNo: (0, _react.createRef)(),
      taxIdentificationNo: (0, _react.createRef)(),
      fullName: (0, _react.createRef)(),
      bankAccountName: (0, _react.createRef)(),
      bankAccountNumber: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(Overview, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      // Set moment locale based on current language
      var languageMap = {
        en: 'en-gb',
        vi: 'vi',
        id: 'id'
      };
      _momentTimezone2.default.locale(languageMap[_i18n2.default.language] || 'en-gb');
      // Listen for language changes
      _i18n2.default.on('languageChanged', this.handleLanguageChange);

      var store = this.context.store;

      this.setLoading(true).then(function () {
        var promises = [_this2.fetchStaff()];
        if (_this2.props.auth.isHeadquarters || _this2.props.auth.isSuperAdmin) {
          promises.push(_this2.fetchCompanyBranches());
          promises.push(_this2.fetchStaffCooldowns('bap'));
          promises.push(_this2.fetchStaffCooldowns('unit'));
        }
        return Promise.all(promises).catch(function (err) {
          Bugsnag.notifyException(err);
          store.dispatch((0, _flash.flashErrorMessage)(err));
        });
      }).then(function () {
        return _this2.setLoading(false);
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      // Sync moment locale when language changes
      if (prevProps && prevProps.i18n && prevProps.i18n.language !== this.props.i18n.language) {
        var languageMap = {
          en: 'en-gb',
          vi: 'vi',
          id: 'id'
        };
        _momentTimezone2.default.locale(languageMap[this.props.i18n.language] || 'en-gb');
        this.forceUpdate();
      }
      if (prevState.data !== this.state.data) {
        this.updateTinFieldState();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Clean up language change listener
      _i18n2.default.off('languageChanged', this.handleLanguageChange);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments[1];

      return new Promise(function (res) {
        _this3.setState(state, function () {
          if (callback) {
            callback();
          }
          res(state);
        });
      });
    }
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      var _this4 = this;

      if (!this.state.hasChanges) {
        this.setState({ hasChanges: true }, function () {
          _this4.handleOnCheck(true);
        });
      }
    }
  }, {
    key: 'handleResetCheck',
    value: function handleResetCheck() {
      var _this5 = this;

      if (this.state.hasChanges) {
        this.setState({ hasChanges: false }, function () {
          _this5.handleOnCheck(false);
        });
      }
    }
  }, {
    key: 'validateTIN',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(tinInput) {
        var data, idType, query, store, res, errorMessage, _errorMessage;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = this.state.data;

                if (!(!tinInput || !data.identityNo)) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt('return');

              case 3:
                idType = (0, _identityTypes.getIdentityTypeOpts)().find(function (i) {
                  return i.value === _defaultIdentityTypeOpts.IDENTITY_TYPE_NRIC;
                }).tin_code;
                query = Object.assign({
                  tin: tinInput,
                  idType: idType,
                  idValue: data.identityNo
                });
                store = this.context.store;
                _context.prev = 6;
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/tin/validate/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token,
                    'X-Origin': this.state.origin
                  }
                }));

              case 9:
                res = _context.sent;

                if (!(res && res.ok)) {
                  _context.next = 14;
                  break;
                }

                this.setState({
                  tinError: false,
                  tinFound: true,
                  tinMessage: null
                });
                _context.next = 19;
                break;

              case 14:
                _context.next = 16;
                return res.text();

              case 16:
                errorMessage = _context.sent;

                this.setState({
                  tinError: true,
                  tinFound: false,
                  tinMessage: errorMessage
                });
                return _context.abrupt('return');

              case 19:
                _context.next = 28;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context['catch'](6);

                if (!_context.t0.res) {
                  _context.next = 28;
                  break;
                }

                _context.next = 26;
                return _context.t0.res.text();

              case 26:
                _errorMessage = _context.sent;

                this.setState({
                  tinError: true,
                  tinFound: false,
                  tinMessage: _errorMessage
                });

              case 28:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 21]]);
      }));

      function validateTIN(_x2) {
        return _ref.apply(this, arguments);
      }

      return validateTIN;
    }()
  }, {
    key: 'staffIsAgent',
    value: function staffIsAgent() {
      var staff = this.state.data;
      if (staff && staff.companyBranch && staff.companyBranch.isExternal) {
        return true;
      }
      return false;
    }
  }, {
    key: 'updateStaff',
    value: function updateStaff(data) {
      var _this6 = this;

      var t = this.props.t;

      var newData = _extends({}, data);
      if (newData && newData.mappings) {
        var m = newData.mappings.filter(function (d) {
          return d.name.length > 0 && d.value.length > 0;
        }).map(function (d, idx) {
          return _extends({}, d, {
            position: idx + 1
          });
        });
        newData.mappings = m;
      } else {
        newData.mappings = [];
      }
      // `role` is derived from user.groups rather than being a field on the staff
      // record, so hand the validator a synthetic value instead of polluting the
      // payload that gets PUT.
      return _AppForm2.default.validate(this.validation, _extends({}, newData, { role: this.getRoles() })).then(function (validations) {
        _this6.setState({
          errMessages: validations.filter(function (v) {
            return !v.isValid;
          })
        });

        var updatedData = _extends({}, newData, {
          taxTinValidationStatus: _this6.state.tinError === false ? 'success' : 'failed'
        });

        if (_this6.state.errMessages.length === 0 && _this6.state.tinRequired && updatedData.taxTinValidationStatus !== 'success') {
          var store = _this6.context.store;

          store.dispatch((0, _flash.flashMessage)({
            header: t('Invalid TIN', { ns: _translation.TRANSLATION_FILES.translation }),
            message: t('Tax Identification Number is invalid', { ns: _translation.TRANSLATION_FILES.translation }),
            icon: 'warning sign',
            type: 'error',
            autoHideDuration: 5000
          }));
          return;
        }
        _this6.putStaff(validations, updatedData).catch(function (err) {
          Bugsnag.notifyException(err);
        });
      });
    }
  }, {
    key: 'fetchStaff',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this7 = this;

        var t, store, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                _context2.prev = 3;
                _context2.next = 6;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/staffs/' + this.props.routeParams.id + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 6:
                res = _context2.sent;
                _context2.next = 15;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2['catch'](3);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 14;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 14:
                return _context2.abrupt('return');

              case 15:
                if (res.ok) {
                  _context2.next = 23;
                  break;
                }

                _context2.next = 18;
                return res.text();

              case 18:
                message = _context2.sent;
                _context2.next = 21;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 21:
                _context2.next = 32;
                break;

              case 23:
                token = res.headers.get('X-Csrf-Token');
                _context2.t1 = _staff.withUserGroups;
                _context2.next = 27;
                return res.json();

              case 27:
                _context2.t2 = _context2.sent;
                data = (0, _context2.t1)(_context2.t2);

                if (!data.access) {
                  data.access = {
                    allowEditUnitPrice: true,
                    allowEditUnitDetails: true
                  };
                }
                // handle token.. etc
                _context2.next = 32;
                return this.setComponentState({
                  token: token,
                  data: data,
                  oriData: (0, _clone2.default)(data),
                  selectedBranchIsExternal: data.companyBranch ? data.companyBranch.isExternal : false
                }, function () {
                  _this7.handleResetCheck();
                });

              case 32:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[3, 9]]);
      }));

      function fetchStaff() {
        return _ref2.apply(this, arguments);
      }

      return fetchStaff;
    }()
  }, {
    key: 'putStaff',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(validations, staff) {
        var _this8 = this;

        var t, store, errors, res, message, data;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context3.next = 7;
                  break;
                }

                this.setState({ edit: true });
                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context3.abrupt('return');

              case 7:
                _context3.next = 9;
                return this.setLoading(true);

              case 9:
                res = void 0;
                _context3.prev = 10;
                _context3.next = 13;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/staffs/' + this.props.routeParams.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(staff)
                }));

              case 13:
                res = _context3.sent;
                _context3.next = 29;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3['catch'](10);
                _context3.next = 20;
                return this.setLoading(false);

              case 20:
                Bugsnag.notifyException(_context3.t0);

                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 27;
                  break;
                }

                _context3.next = 24;
                return _context3.t0.res.text();

              case 24:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 27:
                store.dispatch((0, _flash.flashErrorMessage)(_context3.t0));
                return _context3.abrupt('return');

              case 29:
                _context3.t1 = _staff.withUserGroups;
                _context3.next = 32;
                return res.json();

              case 32:
                _context3.t2 = _context3.sent;
                data = (0, _context3.t1)(_context3.t2);
                _context3.next = 36;
                return this.setComponentState({
                  edit: false,
                  data: data,
                  loading: false,
                  oriData: (0, _clone2.default)(data)
                }, function () {
                  _this8.handleResetCheck();
                  _this8.fetchCompanyBranches();
                });

              case 36:
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully updated', { ns: _translation.TRANSLATION_FILES.translation, name: data.name }) }));

              case 37:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[10, 16]]);
      }));

      function putStaff(_x3, _x4) {
        return _ref3.apply(this, arguments);
      }

      return putStaff;
    }()
  }, {
    key: 'fetchCompanyBranches',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var t, store, res, query, queryString, message, branches;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                query = {
                  page: 'all',
                  getProjects: true,
                  statusFilter: 'active'
                };
                queryString = _qs2.default.stringify(query);
                _context4.prev = 5;
                _context4.next = 8;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/company_branches/?' + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context4.sent;
                _context4.next = 17;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](5);

                Bugsnag.notifyException(_context4.t0);
                _context4.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                return _context4.abrupt('return');

              case 17:
                if (res.ok) {
                  _context4.next = 25;
                  break;
                }

                _context4.next = 20;
                return res.text();

              case 20:
                message = _context4.sent;
                _context4.next = 23;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 23:
                _context4.next = 30;
                break;

              case 25:
                _context4.next = 27;
                return res.json();

              case 27:
                branches = _context4.sent;
                _context4.next = 30;
                return this.setState({
                  branches: branches ? branches.map(function (ul) {
                    var branch = { text: ul.name, name: ul.shortName, value: ul.id.toString(), description: ul.isExternal ? 'Agency' : '' };
                    return branch;
                  }) : [],
                  fullBranches: branches
                });

              case 30:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 11]]);
      }));

      function fetchCompanyBranches() {
        return _ref4.apply(this, arguments);
      }

      return fetchCompanyBranches;
    }()
  }, {
    key: 'fetchStaffCooldowns',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(type) {
        var t, store, res, message, token, data, _state, cooldownBAPData, cooldownData;

        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                _context5.prev = 3;
                _context5.next = 6;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/staffs/' + this.props.routeParams.id + '/cooldowns/?type=' + type, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 6:
                res = _context5.sent;
                _context5.next = 15;
                break;

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5['catch'](3);

                Bugsnag.notifyException(_context5.t0);
                _context5.next = 14;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 14:
                return _context5.abrupt('return');

              case 15:
                if (res.ok) {
                  _context5.next = 23;
                  break;
                }

                _context5.next = 18;
                return res.text();

              case 18:
                message = _context5.sent;
                _context5.next = 21;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 21:
                _context5.next = 31;
                break;

              case 23:
                token = res.headers.get('X-Csrf-Token');
                _context5.next = 26;
                return res.json();

              case 26:
                data = _context5.sent;

                // handle token.. etc
                _state = this.state, cooldownBAPData = _state.cooldownBAPData, cooldownData = _state.cooldownData;

                if (type === 'bap') {
                  cooldownBAPData = data;
                } else {
                  cooldownData = data;
                }
                _context5.next = 31;
                return this.setComponentState({
                  cooldownToken: token,
                  cooldownBAPData: cooldownBAPData,
                  cooldownData: cooldownData
                });

              case 31:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[3, 9]]);
      }));

      function fetchStaffCooldowns(_x5) {
        return _ref5.apply(this, arguments);
      }

      return fetchStaffCooldowns;
    }()
  }, {
    key: 'deleteStaffCooldowns',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this9 = this;

        var t, store, _state2, deleteCooldownType, deleteCooldownName, deleteCooldownID, res, _t, message;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                _state2 = this.state, deleteCooldownType = _state2.deleteCooldownType, deleteCooldownName = _state2.deleteCooldownName, deleteCooldownID = _state2.deleteCooldownID;

                if (deleteCooldownID || deleteCooldownName) {
                  _context6.next = 5;
                  break;
                }

                return _context6.abrupt('return');

              case 5:
                res = void 0;
                _context6.prev = 6;
                _context6.next = 9;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/staffs/' + this.props.routeParams.id + '/cooldowns/' + deleteCooldownID + '/?type=' + deleteCooldownType, {
                  credentials: 'include',
                  method: 'DELETE',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.cooldownToken
                  }
                }));

              case 9:
                res = _context6.sent;
                _context6.next = 19;
                break;

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6['catch'](6);

                Bugsnag.notifyException(_context6.t0);
                _t = this.props.t;
                _context6.next = 18;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 18:
                return _context6.abrupt('return');

              case 19:
                if (res.ok) {
                  _context6.next = 27;
                  break;
                }

                _context6.next = 22;
                return res.text();

              case 22:
                message = _context6.sent;
                _context6.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context6.next = 31;
                break;

              case 27:
                _context6.next = 29;
                return store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{type}} for {{name}} was successfully deleted.', { ns: _translation.TRANSLATION_FILES.translation, type: this.state.deleteCooldownType === 'bap' ? t('Entry', { ns: _translation.TRANSLATION_FILES.translation }) : t('Cooldown', { ns: _translation.TRANSLATION_FILES.translation }), name: deleteCooldownName }) }));

              case 29:
                _context6.next = 31;
                return this.setComponentState({
                  deleteCooldownName: '',
                  deleteCooldownID: '',
                  deleteCooldownType: ''
                }, function () {
                  _this9.fetchStaffCooldowns(deleteCooldownType);
                });

              case 31:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[6, 12]]);
      }));

      function deleteStaffCooldowns() {
        return _ref6.apply(this, arguments);
      }

      return deleteStaffCooldowns;
    }()
  }, {
    key: 'accessStatus',
    value: function accessStatus(statusID) {
      var t = this.props.t;

      var status = this.userStateses.filter(function (s) {
        return s.value === statusID;
      });
      var v = Object.assign.apply(Object, _toConsumableArray(status.map(function (s) {
        return { value: s.value, text: s.text };
      })));
      return t(v.text, { ns: _translation.TRANSLATION_FILES.constants });
    }
  }, {
    key: 'isUserType',
    value: function isUserType(groupID) {
      if (this.state.data.user.groups) {
        return this.state.data.user.groups.some(function (group) {
          return group.id === groupID;
        });
      }
      return false;
    }
  }, {
    key: 'isEditStaffHeadquarters',
    value: function isEditStaffHeadquarters() {
      if (this.state.data.user.groups) {
        return this.state.data.user.groups.some(function (group) {
          return group.code === _groups.DEVELOPER_HEADQUARTERS;
        });
      }
      return false;
    }
  }, {
    key: 'renderUserBookingCooldowns',
    value: function renderUserBookingCooldowns(data) {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Table,
        { celled: true, unstackable: true, structured: true },
        data && data.length > 0 ? _react2.default.createElement(
          _semanticUiReact.Table.Header,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              null,
              t('Unit, Project', { ns: _translation.TRANSLATION_FILES.translation })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              null,
              t('Started At', { ns: _translation.TRANSLATION_FILES.translation })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              null,
              t('Expires At', { ns: _translation.TRANSLATION_FILES.translation })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { textAlign: 'center', collapsing: true },
              _react2.default.createElement(_semanticUiReact.Icon, { fitted: true, name: 'setting' })
            )
          )
        ) : null,
        _react2.default.createElement(
          _semanticUiReact.Table.Body,
          null,
          this.renderUserBookingCooldown(data)
        )
      );
    }
  }, {
    key: 'renderUserBAPBans',
    value: function renderUserBAPBans(data) {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Table,
        { celled: true, unstackable: true, structured: true },
        data && data.length > 0 ? _react2.default.createElement(
          _semanticUiReact.Table.Header,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              null,
              t('Project / Unit', { ns: _translation.TRANSLATION_FILES.translation })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              null,
              t('Project-Wide Ban', { ns: _translation.TRANSLATION_FILES.translation })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              null,
              t('Attempts', { ns: _translation.TRANSLATION_FILES.translation })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              null,
              t('Previous Attempt At', { ns: _translation.TRANSLATION_FILES.translation })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              null,
              t('Latest Attempt At', { ns: _translation.TRANSLATION_FILES.translation })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              null,
              t('Ban Expires At', { ns: _translation.TRANSLATION_FILES.translation })
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { textAlign: 'center', collapsing: true },
              _react2.default.createElement(_semanticUiReact.Icon, { fitted: true, name: 'setting' })
            )
          )
        ) : null,
        _react2.default.createElement(
          _semanticUiReact.Table.Body,
          null,
          this.renderUserBAPBan(data)
        )
      );
    }
  }, {
    key: 'checkDisabledGroup',
    value: function checkDisabledGroup(code) {
      switch (code) {
        case _groups.COMMISSION_TRACKER_TEAM_LEADER:
        case _groups.COMMISSION_TRACKER_AGENT:
          return !this.state.selectedBranchIsExternal;
        default:
          return this.state.selectedBranchIsExternal;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this10 = this;

      var t = this.props.t;
      var _state3 = this.state,
          data = _state3.data,
          cooldownBAPData = _state3.cooldownBAPData,
          cooldownData = _state3.cooldownData,
          showDeleteCooldownConfirm = _state3.showDeleteCooldownConfirm,
          deleteCooldownName = _state3.deleteCooldownName,
          selectedBranchIsExternal = _state3.selectedBranchIsExternal;
      var auth = this.props.auth;

      var ROLES = (0, _roles.roleOptions)(selectedBranchIsExternal);
      // Nobody may change their own Access Role, so the Select below is disabled on
      // your own record. Do not require it in that case too, or a self-edit of an
      // unrelated field is blocked by a control you are not allowed to touch.
      // Guard on a truthy email as well: two missing emails compare equal, which
      // would silently disable the field on somebody else's record.
      // `data` is null until fetchStaff resolves, so guard it — render runs first.
      var isOwnRecord = !!data && !!auth && !!auth.email && auth.email === data.email;

      var links = (0, _navigations.routes)(this.props.routeParams.id);
      var pathname = this.props.location.pathname;

      var tinContent = data && data.taxIdentificationNo || this.state.tinRequired;

      var isMalaysia = this.props.auth && this.props.auth.company && this.props.auth.company.countryCode && this.props.auth.company.countryCode.toUpperCase() === 'MY';
      var isIndonesia = this.props.auth && this.props.auth.company && this.props.auth.company.countryCode && this.props.auth.company.countryCode.toUpperCase() === 'ID';

      var tinValidation = [];
      if (isIndonesia) {
        tinValidation = [{
          validate: _webValidations.matchRegex,
          option: { validRegex: _regex.REGEX_NPWP_ID }
        }];
      } else if (isMalaysia) {
        tinValidation = [{
          validate: _webValidations.matchRegex,
          option: { validRegex: _regex.REGEX_TIN_VALID }
        }];
      }
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_MoveStaffToExternalBranch2.default, {
          open: this.state.showConfirmBranch,
          onClose: this.handleCancelChange,
          onConfirm: this.handleConfirmChange,
          staffpreferredName: this.state.data ? this.state.data.preferredName : ''
        }),
        _react2.default.createElement(_DeleteConfirm2.default, {
          content: t('Are you sure you want to delete the ' + (this.state.deleteCooldownType === 'bap' ? 'entry' : 'cooldown') + ' for {{name}}?', { ns: _translation.TRANSLATION_FILES.translation, name: deleteCooldownName }),
          onClose: this.handleCancelDeleteCooldown,
          onConfirm: this.handleConfirmDeleteCooldown,
          open: showDeleteCooldownConfirm
        }),
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links,
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: t(link.text),
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this10.handleMenu(e, link);
              }
            });
          })
        }),
        _react2.default.createElement(_ProjectsList2.default, {
          open: this.state.showAddProject,
          onClose: this.handleCloseAddProject,
          onConfirm: this.handleAddProject,
          onCheck: function onCheck(project) {
            return project.loanTrackerProjectID < 1;
          },
          selected: data ? data.projects : [],
          userBranchProjects: !this.getBranchViewAllProjects() ? this.getBranchProjects() : []
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { active: this.state.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('User Information')
              ),
              data ? _react2.default.createElement(_EditableBox2.default, {
                editable: !(this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) ? !this.isEditStaffHeadquarters() : true,
                isEditing: this.state.edit,
                loading: this.state.loading,
                onEdit: this.handleEditStaff,
                onClick: this.handleUpdateStaff,
                onCancel: this.handleResetChanges,
                content: function content(_ref7) {
                  var isEditing = _ref7.isEditing,
                      onConfirm = _ref7.onConfirm;
                  return _react2.default.createElement(
                    _semanticUiReact.Grid,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(_semanticUiReact.Dimmer, { active: _this10.state.isEditing, inverted: true }),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 16, computer: 16 },
                        _this10.state.oriData ? _react2.default.createElement(
                          _semanticUiReact.Grid,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Row,
                            { stretched: true },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { width: 16 },
                              _react2.default.createElement(
                                _semanticUiReact.Header,
                                { as: 'h2', textAlign: 'center' },
                                _this10.state.oriData.preferredName,
                                _this10.props.auth.email === _this10.state.oriData.email ? _react2.default.createElement(
                                  _semanticUiReact.Label,
                                  { size: 'small', pointing: 'left' },
                                  'You'
                                ) : '',
                                _this10.state.oriData.companyBranch ? _react2.default.createElement(
                                  _semanticUiReact.Header.Subheader,
                                  null,
                                  _react2.default.createElement(
                                    'i',
                                    null,
                                    _this10.state.oriData.companyBranch.name
                                  )
                                ) : null,
                                _react2.default.createElement(
                                  _semanticUiReact.Header.Subheader,
                                  null,
                                  _react2.default.createElement(
                                    'i',
                                    null,
                                    _react2.default.createElement(_Timestamp2.default, { format: 'MMMM Do YYYY, h:mm a', timestamp: _this10.state.oriData.createdAt })
                                  )
                                )
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { width: 16 },
                              _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, className: 'tablet-hide' })
                            )
                          )
                        ) : null,
                        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, className: 'large-hide small-hide' })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 8, computer: 8 },
                        _react2.default.createElement(
                          _AppForm2.default,
                          {
                            onSubmit: onConfirm,
                            error: _this10.state.errMessages.length > 0,
                            ref: function ref(_ref8) {
                              _this10.form = _ref8;
                            }
                          },
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'name', 'user')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                name: 'name',
                                onChange: _this10.handleOnChange,
                                placeholder: (0, _translation2.translateModels)(t, 'name', 'user'),
                                value: data.name,
                                ref: _this10.validation.name,
                                validateLabel: (0, _translation2.translateModels)(t, 'name', 'user'),
                                validation: [_webValidations.required]
                              }) : data.name
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'preferredName', 'user')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                name: 'preferredName',
                                onChange: _this10.handleOnChange,
                                placeholder: (0, _translation2.translateModels)(t, 'preferredName', 'user'),
                                value: data.preferredName,
                                ref: _this10.validation.preferredName,
                                validation: [_webValidations.required],
                                validateLabel: (0, _translation2.translateModels)(t, 'preferredName', 'user')
                              }) : data.preferredName
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 4 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'mobile', 'user')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 12 },
                              isEditing ? _react2.default.createElement(
                                _semanticUiReact.Grid,
                                { className: 'compact' },
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { width: 16 },
                                  _react2.default.createElement(_Select2.default, {
                                    validation: [_webValidations.required],
                                    ref: _this10.validation.mobilePrefix,
                                    onChange: _this10.handleOnChange,
                                    name: 'mobilePrefix',
                                    options: _intlCallCodes2.default,
                                    selectOnBlur: false,
                                    value: data.mobilePrefix
                                  })
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { width: 16 },
                                  _react2.default.createElement(_PhoneInput2.default, {
                                    fluid: true,
                                    name: 'mobile',
                                    onChange: _this10.handleOnChange,
                                    type: 'tel',
                                    placeholder: t('Mobile'),
                                    prefix: data.mobilePrefix,
                                    value: data.mobile,
                                    validation: [_webValidations.required, {
                                      validate: _webValidations.phoneNumber,
                                      option: data.mobilePrefix === 'other' ? {} : {
                                        isMobile: true,
                                        phonePrefix: data.mobilePrefix,
                                        validRegex: (0, _phone.getPhoneValidRegex)(_this10.state.phoneValidationPresets, data.mobilePrefix, 'mobile')
                                      }
                                    }],
                                    validateLabel: (0, _translation2.translateModels)(t, 'mobile', 'user'),
                                    ref: _this10.validation.mobile
                                  })
                                )
                              ) : _react2.default.createElement(_Phone2.default, {
                                mobilePrefix: data.mobilePrefix,
                                mobile: data.mobile
                              })
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 4 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'officeTel', 'user')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 12 },
                              isEditing ? _react2.default.createElement(
                                _semanticUiReact.Grid,
                                { className: 'compact' },
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { width: 16 },
                                  _react2.default.createElement(_semanticUiReact.Form.Select, {
                                    fluid: true,
                                    search: true,
                                    name: 'officeTelPrefix',
                                    onChange: _this10.handleOnChange,
                                    options: _intlCallCodes2.default,
                                    selectOnBlur: false,
                                    value: data.officeTelPrefix,
                                    noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation })
                                  })
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { width: 16 },
                                  _react2.default.createElement(_PhoneInput2.default, {
                                    fluid: true,
                                    name: 'officeTel',
                                    onChange: _this10.handleOnChange,
                                    prefix: data.officeTelPrefix,
                                    type: 'tel',
                                    placeholder: (0, _translation2.translateModels)(t, 'officeTel', 'user'),
                                    value: data.officeTel,
                                    validation: [{
                                      validate: _webValidations.phoneNumber,
                                      option: data.officeTelPrefix === 'other' ? {} : {
                                        phonePrefix: data.officeTelPrefix,
                                        validRegex: (0, _phone.getPhoneValidRegex)(_this10.state.phoneValidationPresets, data.officeTelPrefix, 'phone')
                                      }
                                    }]
                                  })
                                )
                              ) : _react2.default.createElement(_Phone2.default, {
                                mobilePrefix: data.officeTelPrefix,
                                mobile: data.officeTel
                              })
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'email', 'user')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                name: 'email',
                                onChange: _this10.handleOnChange,
                                type: 'email',
                                placeholder: (0, _translation2.translateModels)(t, 'email', 'user'),
                                value: data.email,
                                ref: _this10.validation.email,
                                validation: [_webValidations.required],
                                validateLabel: (0, _translation2.translateModels)(t, 'email', 'user'),
                                disabled: !!data.user.awsUsername
                              }) : _react2.default.createElement(
                                'a',
                                { href: 'mailto:' + data.email },
                                data.email
                              )
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'userID', 'user')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8, title: 'MHub User ID (Affiliate ID: ' + data.id + ')' },
                              data.userID
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 8 },
                              _react2.default.createElement(
                                'b',
                                null,
                                (0, _translation2.translateModels)(t, 'fullName', 'user'),
                                ' ',
                                isMalaysia && t('(as in MyKad)')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 8 },
                              isEditing ? _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                name: 'fullName',
                                onChange: _this10.handleOnChange,
                                placeholder: (0, _translation2.translateModels)(t, 'fullName', 'user'),
                                value: data.fullName,
                                ref: _this10.validation.fullName,
                                validateLabel: (0, _translation2.translateModels)(t, 'fullName', 'user'),
                                validation: data.bankAccountName && data.bankAccountNumber ? [_webValidations.required, { validate: _webValidations.matchRegex, option: { validRegex: _regex.REGEX_FULL_NAME } }] : [{ validate: _webValidations.matchRegex, option: { validRegex: _regex.REGEX_FULL_NAME } }]
                              }) : data.fullName ? data.fullName : '-'
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 6 },
                              _react2.default.createElement(
                                'b',
                                null,
                                isMalaysia ? 'MyKad (NRIC)' : isIndonesia ? 'KTP' : t('Identity Number')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 10 },
                              isEditing ? isMalaysia ? _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                name: 'identityNo',
                                validateLabel: 'MyKad (NRIC)',
                                required: tinContent,
                                onChange: _this10.handleOnChange,
                                placeholder: 'MyKad (NRIC)',
                                value: data.identityNo,
                                validation: tinContent ? [_webValidations.required, {
                                  validate: _webValidations.identity,
                                  option: {
                                    countryCode: 'MY',
                                    identityType: 'ic_number'
                                  }
                                }] : [{
                                  validate: _webValidations.identity,
                                  option: {
                                    countryCode: 'MY',
                                    identityType: 'ic_number'
                                  }
                                }],
                                ref: _this10.validation.identityNo,
                                type: 'text'
                              }) : isIndonesia && _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                name: 'identityNo',
                                validateLabel: 'KTP',
                                required: tinContent,
                                onChange: _this10.handleOnChange,
                                placeholder: 'KTP',
                                value: data.identityNo,
                                validation: tinContent ? [_webValidations.required, {
                                  validate: _webValidations.matchRegex,
                                  option: { validRegex: /^[a-zA-Z0-9_]*$/ }
                                }] : [{
                                  validate: _webValidations.matchRegex,
                                  option: { validRegex: /^[a-zA-Z0-9_]*$/ }
                                }],
                                ref: _this10.validation.identityNo,
                                type: 'text'
                              }) : data.identityNo ? data.identityNo : '-'
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { mobile: 16, tablet: 8, computer: 8 },
                            isEditing && (isMalaysia || isIndonesia) ? _react2.default.createElement(
                              _semanticUiReact.Grid,
                              { verticalAlign: 'middle' },
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'left', width: 6 },
                                _react2.default.createElement(
                                  'b',
                                  null,
                                  isMalaysia && 'Tax Identification Number (TIN)',
                                  isIndonesia && 'Nomor Pokok Wajib Pajak (NPWP)'
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'right', width: 10 },
                                _react2.default.createElement(_TinFieldInput2.default, {
                                  isIndonesia: isIndonesia,
                                  hideLabel: true,
                                  value: data.taxIdentificationNo,
                                  errMessage: _this10.state.tinMessage,
                                  isLoading: _this10.state.validatingTin,
                                  tinError: isMalaysia && _this10.state.tinError,
                                  ref: _this10.validation.taxIdentificationNo,
                                  onChange: _this10.handleTinInput,
                                  required: _this10.state.tinRequired
                                  // readOnly={isMalaysia && (this.state.tinFound || !this.state.tinEnabled)}
                                  , validation: tinValidation,
                                  identityType: _defaultIdentityTypeOpts.IDENTITY_TYPE_NRIC,
                                  identityValue: data.identityNo
                                })
                              )
                            ) : _react2.default.createElement(
                              _semanticUiReact.Grid,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'left', width: 6 },
                                _react2.default.createElement(
                                  'b',
                                  null,
                                  isMalaysia && 'Tax Identification Number (TIN)',
                                  isIndonesia && 'Nomor Pokok Wajib Pajak (NPWP)'
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'right', width: 10 },
                                _react2.default.createElement(
                                  'span',
                                  { style: { display: 'flex', justifyContent: 'flex-end', alignItems: 'center' } },
                                  data && data.taxIdentificationNo ? _react2.default.createElement(
                                    'div',
                                    null,
                                    isMalaysia && _react2.default.createElement(_semanticUiReact.Icon, {
                                      name: data.taxTinValidationStatus === 'success' ? 'check circle' : 'remove circle',
                                      color: data.taxTinValidationStatus === 'success' ? 'green' : 'red',
                                      style: { marginLeft: '0.5em' }
                                    }),
                                    _react2.default.createElement(
                                      'i',
                                      null,
                                      data.taxIdentificationNo
                                    )
                                  ) : '-'
                                )
                              )
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          isEditing ? _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { mobile: 16, tablet: 8, computer: 8 },
                            _react2.default.createElement(
                              _semanticUiReact.Grid,
                              { verticalAlign: 'middle' },
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'left', width: 6 },
                                _react2.default.createElement(
                                  'b',
                                  null,
                                  (0, _translation2.translateModels)(t, 'bankAccountName', 'user')
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'right', width: 10 },
                                _react2.default.createElement(_SelectBank2.default, {
                                  country: auth && auth.company ? auth.company.countryCode : '',
                                  validateLabel: (0, _translation2.translateModels)(t, 'bankAccountName', 'user'),
                                  ref: _this10.validation.bankAccountName,
                                  onChange: _this10.handleOnChange,
                                  name: 'bankAccountName',
                                  placeholder: t('Select {{title}}', { title: t('Bank') }),
                                  value: data.bankAccountName,
                                  validation: data.bankAccountNumber ? [_webValidations.required] : []
                                })
                              )
                            )
                          ) : _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { mobile: 16, tablet: 8, computer: 8 },
                            _react2.default.createElement(
                              _semanticUiReact.Grid,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'left', width: 6 },
                                _react2.default.createElement(
                                  'b',
                                  null,
                                  (0, _translation2.translateModels)(t, 'bankAccountName', 'user')
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'right', width: 10 },
                                data.bankAccountName || '-'
                              )
                            )
                          ),
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          isEditing ? _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { mobile: 16, tablet: 8, computer: 8 },
                            _react2.default.createElement(
                              _semanticUiReact.Grid,
                              { verticalAlign: 'middle' },
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'left', width: 6 },
                                _react2.default.createElement(
                                  'b',
                                  null,
                                  (0, _translation2.translateModels)(t, 'bankAccountNumber', 'user')
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'right', width: 10 },
                                _react2.default.createElement(_AppForm2.default.Input, {
                                  fluid: true,
                                  name: 'bankAccountNumber',
                                  validateLabel: t('Bank Account Number'),
                                  onChange: _this10.handleOnChange,
                                  placeholder: 'E.g. 231466322123',
                                  value: data.bankAccountNumber,
                                  ref: _this10.validation.bankAccountNumber,
                                  type: 'text',
                                  validation: data.bankAccountName ? [_webValidations.required, { validate: _webValidations.matchRegex, option: { validRegex: _regex.REGEX_BANK_ACCOUNT_NUMBER } }] : [{ validate: _webValidations.matchRegex, option: { validRegex: _regex.REGEX_BANK_ACCOUNT_NUMBER } }]
                                })
                              )
                            )
                          ) : _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            { mobile: 16, tablet: 8, computer: 8 },
                            _react2.default.createElement(
                              _semanticUiReact.Grid,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'left', width: 6 },
                                _react2.default.createElement(
                                  'b',
                                  null,
                                  (0, _translation2.translateModels)(t, 'bankAccountNumber', 'user')
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'right', width: 10 },
                                data.bankAccountNumber || '-'
                              )
                            )
                          )
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Column,
                        { mobile: 16, tablet: 8, computer: 8 },
                        _react2.default.createElement(
                          _AppForm2.default,
                          {
                            onSubmit: onConfirm,
                            error: _this10.state.errMessages.length > 0,
                            ref: function ref(_ref9) {
                              _this10.form = _ref9;
                            }
                          },
                          (_this10.props.auth.isHeadquarters || _this10.props.auth.isSuperAdmin) && data.companyBranch ? _react2.default.createElement(
                            'div',
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid,
                              { verticalAlign: 'middle' },
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'left', width: 6 },
                                _react2.default.createElement(
                                  'b',
                                  null,
                                  t('Business Unit')
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Column,
                                { textAlign: 'right', width: 10 },
                                isEditing ? _react2.default.createElement(_Select2.default, {
                                  validation: [_webValidations.required],
                                  ref: _this10.validation.companyBranchID,
                                  onChange: _this10.handleOnChange,
                                  name: 'companyBranchID',
                                  text: data.companyBranchID ? null : t('Select business unit'),
                                  value: data.companyBranchID,
                                  options: _this10.state.branches,
                                  disabled: _this10.state.branches.length === 0
                                }) : _this10.props.auth.isSuperAdmin || _this10.props.auth.isHeadquarters ? data.companyBranch ? _react2.default.createElement(
                                  _reactRouter.Link,
                                  { to: '/business_units/' + data.companyBranchID + '/' },
                                  data.companyBranch.name,
                                  data.companyBranch.isExternal ? _react2.default.createElement(
                                    _semanticUiReact.Label,
                                    { size: 'mini', pointing: 'left', color: 'teal' },
                                    t('Agency')
                                  ) : ''
                                ) : '' : data.companyBranch ? data.companyBranch.name : ''
                              )
                            )
                          ) : null,
                          (_this10.props.auth.isHeadquarters || _this10.props.auth.isSuperAdmin) && data.companyBranch ? _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }) : null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 6 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Access Role')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 10 },
                              isEditing ? _react2.default.createElement(_Select2.default, {
                                name: 'role',
                                validation: isOwnRecord ? [] : [_webValidations.required],
                                validateLabel: t('Access Role'),
                                ref: _this10.validation.role,
                                value: _this10.getRoles(),
                                onChange: _this10.handleChangeRole,
                                options: ROLES.map(function (role) {
                                  return _extends({}, role, {
                                    text: t(role.text, { ns: _translation.TRANSLATION_FILES.constants })
                                  });
                                }),
                                disabled: isOwnRecord
                              }) : t(_this10.getRoleText(ROLES), { ns: _translation.TRANSLATION_FILES.constants })
                            )
                          )
                        ),
                        _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        _react2.default.createElement(
                          _semanticUiReact.Form,
                          {
                            onSubmit: onConfirm
                          },
                          auth && data.user && (auth.isHeadquarters || auth.isSuperAdmin || auth.isBranchLeaderSupervisor) ? _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'top' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 6 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Access')
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 10 },
                              auth.id !== data.user.id && (isEditing ? _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(_semanticUiReact.Form.Select, {
                                  fluid: true,
                                  name: 'statusID',
                                  onChange: _this10.handleUserOnChange,
                                  options: _this10.userStateses.map(function (status) {
                                    return _extends({}, status, {
                                      text: t(status.text, { ns: _translation.TRANSLATION_FILES.constants })
                                    });
                                  }),
                                  selectOnBlur: false,
                                  noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }),
                                  value: data.user.statusID
                                }),
                                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                  checked: _this10.checkAccess(data.user.statusID),
                                  label: t('Has access', { ns: _translation.TRANSLATION_FILES.constants }),
                                  name: 'hasAccess',
                                  onChange: _this10.handleUserCheckBoxChange,
                                  disabled: true
                                })
                              ) : _this10.accessStatus(data.user.statusID)),
                              data.access && (auth.isHeadquarters && auth.isMainHeadquarters || auth.isSuperAdmin) && data.user && data.user.groups && data.user.groups.some(function (g) {
                                return g.code === _groups.DEVELOPER_HEADQUARTERS || g.code === _groups.DEVELOPER_BRANCH_LEADER || g.code === _groups.DEVELOPER_BRANCH_LEADER_SUPERVISOR || g.code === _groups.DEVELOPER_BRANCH_LEADER_SUPERVISOR_II;
                              }) ? _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                  checked: data.access.allowEditUnitPrice,
                                  label: t("Allow to edit unit's price", { ns: _translation.TRANSLATION_FILES.translation }),
                                  name: 'allowEditUnitPrice',
                                  onChange: _this10.handleAccessCheckBoxChange,
                                  disabled: !isEditing
                                }),
                                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                  checked: data.access.allowEditUnitDetails,
                                  label: t("Allow to edit unit's details", { ns: _translation.TRANSLATION_FILES.translation }),
                                  name: 'allowEditUnitDetails',
                                  onChange: _this10.handleAccessCheckBoxChange,
                                  disabled: !isEditing
                                })
                              ) : null
                            )
                          ) : '',
                          isEditing && auth && data.user && auth.id !== data.user.id && (auth.isHeadquarters || auth.isSuperAdmin || auth.isBranchLeaderSupervisor) ? _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }) : null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            isEditing && (auth.isHeadquarters || auth.isMainHeadquarters || auth.isSuperAdmin) ? _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 16 },
                              _react2.default.createElement(_AppForm2.default.Input, {
                                fluid: true,
                                label: t('New Password Update'),
                                placeholder: t('Minimum 6 characters with 1 uppercase, 1 lowercase and 1 number required.'),
                                name: 'updatePassword',
                                type: 'password',
                                onChange: _this10.handleUserOnChange,
                                validation: [_webValidations.required, {
                                  validate: _webValidations.matchRegex,
                                  option: _this10.passwordValidation()
                                }]
                              })
                            ) : null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 16, style: data.user.awsUsername || !isEditing && !data.user.awsUsername ? { paddingTop: '0' } : null },
                              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                checked: data.user.passwordUpdateRequired,
                                label: t('Require password update next login'),
                                name: 'passwordUpdateRequired',
                                onChange: _this10.handleUserCheckBoxChange,
                                disabled: !isEditing || !!(data.user.awsUsername && data.user.awsUsername.includes(data.user.email))
                              })
                            )
                          )
                        ),
                        _this10.props.auth.isSuperAdmin && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        _this10.props.auth.isSuperAdmin ? _react2.default.createElement(
                          _semanticUiReact.Form,
                          {
                            onSubmit: onConfirm
                          },
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 5 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Group Access', { ns: _translation.TRANSLATION_FILES.translation })
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 11 },
                              _groups.devGroups.map(function (group, idx) {
                                return _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                  checked: _this10.isUserType(group.id),
                                  key: idx,
                                  label: t(group.name, { ns: _translation.TRANSLATION_FILES.constants }),
                                  value: group.code,
                                  name: group.code,
                                  disabled: !isEditing
                                });
                              })
                            )
                          )
                        ) : null,
                        (_this10.props.auth.isHeadquarters || _this10.props.auth.isSuperAdmin) && !selectedBranchIsExternal && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        (_this10.props.auth.isHeadquarters || _this10.props.auth.isSuperAdmin) && !selectedBranchIsExternal ? _react2.default.createElement(
                          _semanticUiReact.Form,
                          {
                            onSubmit: onConfirm
                          },
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 5 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Credit Control Access', { ns: _translation.TRANSLATION_FILES.translation })
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 11 },
                              _groups.creditControlGroups.map(function (group, idx) {
                                return _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                  checked: _this10.isUserType(group.id),
                                  key: idx,
                                  label: t(group.name, { ns: _translation.TRANSLATION_FILES.constants }),
                                  value: group.code,
                                  name: group.code,
                                  disabled: !isEditing,
                                  onChange: function onChange(e, d) {
                                    return _this10.handleGroupChange(e, d, _groups.creditControlGroups);
                                  }
                                });
                              })
                            )
                          )
                        ) : null,
                        (_this10.props.auth.isHeadquarters || _this10.props.auth.isSuperAdmin) && _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                        _this10.props.auth.isHeadquarters || _this10.props.auth.isSuperAdmin ? _react2.default.createElement(
                          _semanticUiReact.Form,
                          {
                            onSubmit: onConfirm
                          },
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            { verticalAlign: 'middle' },
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 5 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Commission Tracker Access', { ns: _translation.TRANSLATION_FILES.translation })
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 11 },
                              _groups.commissionTrackerGroups.map(function (group, idx) {
                                return _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                  checked: _this10.isUserType(group.id),
                                  key: idx,
                                  label: t(group.name, { ns: _translation.TRANSLATION_FILES.constants }),
                                  value: group.code,
                                  name: group.code,
                                  disabled: !isEditing || _this10.checkDisabledGroup(group.code),
                                  onChange: function onChange(e, d) {
                                    return _this10.handleGroupChange(e, d, _groups.commissionTrackerGroups);
                                  }
                                });
                              })
                            )
                          )
                        ) : null,
                        _react2.default.createElement(
                          _semanticUiReact.Form,
                          {
                            onSubmit: onConfirm
                          },
                          _react2.default.createElement(_semanticUiReact.Divider, { style: styles.divider }),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 4 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Projects Access', { ns: _translation.TRANSLATION_FILES.screens })
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 12 },
                              _this10.getBranchViewAllProjects() ? t('All Projects (Set by Business Unit)', { ns: _translation.TRANSLATION_FILES.screens }) : _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                checked: data.viewAllProjects,
                                label: t('View all projects', { ns: _translation.TRANSLATION_FILES.screens }),
                                name: 'viewAllProjects',
                                onChange: _this10.handleCheckBoxChange,
                                disabled: !isEditing
                              })
                            )
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Grid,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'left', width: 4 },
                              _react2.default.createElement(
                                'b',
                                null,
                                t('Analytics Access', { ns: _translation.TRANSLATION_FILES.screens })
                              )
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.Grid.Column,
                              { textAlign: 'right', width: 12 },
                              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                checked: data.user && data.user.groups && data.user.groups && data.user.groups.findIndex(function (g) {
                                  return g.id === _groups.GROUP_ID_ANALYTICS;
                                }) !== -1,
                                label: t('View analytics dashboard', { ns: _translation.TRANSLATION_FILES.screens }),
                                name: 'viewAnalyticsDashboard',
                                onChange: _this10.handleCheckBoxChange,
                                disabled: !isEditing
                              })
                            )
                          )
                        )
                      )
                    )
                  );
                }
              }) : _react2.default.createElement(
                _semanticUiReact.Grid,
                null,
                this.state.loading ? '' : t('No staff found', { ns: _translation.TRANSLATION_FILES.screens })
              )
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              !this.state.loading && _react2.default.createElement(_SpecificationTable2.default, {
                type: 'affiliateMappings',
                editable: true,
                isEditing: this.state.edit,
                hideButton: true,
                notFoundNode: _react2.default.createElement(
                  'p',
                  null,
                  t('No mapping set')
                ),
                headerNode: t('User API Mapping'),
                data: data && data.mappings ? data.mappings : [],
                onChange: this.handleMappingChange,
                loading: this.state.loading
              })
            )
          ),
          data && !data.viewAllProjects && !this.getBranchViewAllProjects() ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Projects Access')
              ),
              _react2.default.createElement(
                _semanticUiReact.Table,
                { unstackable: true },
                _react2.default.createElement(
                  _semanticUiReact.Table.Body,
                  null,
                  !this.getBranchViewAllProjects() && this.getBranchProjects().length > 0 ? this.getBranchProjects().map(function (project, idx) {
                    return _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      { key: idx },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(_ListItem2.default, {
                          item: project,
                          header: function header(item) {
                            return _react2.default.createElement(
                              'span',
                              null,
                              item.name,
                              ' ',
                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'eye', fitted: true }),
                              _react2.default.createElement(
                                'i',
                                null,
                                ' ',
                                _react2.default.createElement(
                                  'small',
                                  null,
                                  t('Business Unit Access')
                                )
                              )
                            );
                          },
                          subheader: function subheader(item) {
                            return item.status.name;
                          }
                        })
                      )
                    );
                  }) : null,
                  data.projects && data.projects.length > 0 && data.projects.map(function (project, idx) {
                    return _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      { key: idx },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(_ListItem2.default, {
                          item: project,
                          header: function header(item) {
                            return item.name;
                          },
                          subheader: function subheader(item) {
                            return item.status.name;
                          },
                          rightComponent: _react2.default.createElement(
                            'div',
                            { className: _this10.state.edit ? null : 'hidden' },
                            _react2.default.createElement(_semanticUiReact.Button, {
                              type: 'button',
                              compact: true,
                              negative: true,
                              size: 'mini',
                              icon: 'remove',
                              onClick: function onClick() {
                                return _this10.handleRemoveProject(idx);
                              },
                              disabled: !_this10.state.edit
                            })
                          )
                        })
                      )
                    );
                  })
                )
              ),
              !(data.projects && data.projects.length > 0 || this.getBranchProjects() && this.getBranchProjects().length > 0) && _react2.default.createElement(
                _semanticUiReact.Segment,
                { textAlign: 'center' },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                ) : t('No projects access', { ns: _translation.TRANSLATION_FILES.screens })
              )
            )
          ) : null,
          data && !data.viewAllProjects && !this.getBranchViewAllProjects() && this.state.edit ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'center' },
              _react2.default.createElement(_semanticUiReact.Button, {
                content: t('Add project', { ns: _translation.TRANSLATION_FILES.screens }),
                onClick: this.handleShowAddProject
              })
            )
          ) : null,
          this.staffIsAgent() ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { active: this.state.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('User Booking Cooldown', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              this.renderUserBookingCooldowns(cooldownData)
            )
          ) : '',
          this.staffIsAgent() ? _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                { active: this.state.loading, inverted: true },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('User Booking Abuse Prevention', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              this.renderUserBAPBans(cooldownBAPData)
            )
          ) : ''
        )
      );
    }
  }]);

  return Overview;
}(_react.Component);

Overview.contextTypes = {
  store: _propTypes2.default.object
};
Overview.propTypes = {
  auth: _propTypes2.default.shape({
    email: _propTypes2.default.string,
    isBranchLeaderSupervisor: _propTypes2.default.bool,
    isMainHeadquarters: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    company: _propTypes2.default.shape({
      countryCode: _propTypes2.default.string
    })
  }),
  routeParams: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};

Overview.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this11 = this;

  this.getRoles = function () {
    var rolesArr = [];
    if (_this11.state.data.user.groups && _this11.state.data.user.groups.length > 0) {
      _this11.state.data.user.groups.forEach(function (g) {
        // ignore CC & analytics role in SR
        if (_groups.ignoreGroupIDs.includes(g.id)) return;
        rolesArr.push(g.id);
      });
    }
    rolesArr.sort();
    return String(rolesArr.toString());
  };

  this.getRoleText = function (roles) {
    var role = roles.find(function (g) {
      return g.value === _this11.getRoles();
    });
    if (role && role.text) {
      return role.text;
    }
    return '';
  };

  this.getBranchProjects = function () {
    var _state4 = _this11.state,
        data = _state4.data,
        fullBranches = _state4.fullBranches;

    if (data && data.companyBranchID && fullBranches.length > 0) {
      var foundBranch = fullBranches.find(function (d) {
        return d.id.toString() === data.companyBranchID;
      });
      if (foundBranch && foundBranch.projects && foundBranch.projects.length > 0) {
        return foundBranch.projects.filter(function (d) {
          return d.statusID !== 'deleted';
        });
      }
    }
    return [];
  };

  this.getBranchViewAllProjects = function () {
    var _state5 = _this11.state,
        data = _state5.data,
        fullBranches = _state5.fullBranches;

    if (data && data.companyBranchID) {
      var foundBranch = fullBranches.find(function (d) {
        return d.id.toString() === data.companyBranchID;
      });
      if (foundBranch && foundBranch.viewAllProjects) {
        return true;
      }
    }
    return false;
  };

  this.handleLanguageChange = function () {
    var languageMap = {
      en: 'en-gb',
      vi: 'vi',
      id: 'id'
    };
    _momentTimezone2.default.locale(languageMap[_i18n2.default.language] || 'en-gb');
    _this11.forceUpdate();
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var loadingType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return new Promise(function (res) {
      if (loadingType === 'validatingTIN') {
        _this11.setState({ validatingTin: loading }, res);
      } else {
        _this11.setState({ loading: loading }, res);
      }
    });
  };

  this.updateTinFieldState = function () {
    var data = _this11.state.data;

    var tinError = true;
    if (data && data.taxTinValidationStatus === 'success') {
      tinError = false;
    }
    if (_this11.state.tinError !== tinError) {
      _this11.setState({ tinError: tinError });
    }
  };

  this.handleOnCheck = function () {
    var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (_this11.props.onCheck) {
      _this11.props.onCheck(hasChanges);
    }
  };

  this.handleTinInput = function (e) {
    var _state6 = _this11.state,
        data = _state6.data,
        tinMessage = _state6.tinMessage;

    var tinInput = e.target.value;
    var tinFound = e.target.tinFound;
    var isAlphanumeric = /^[a-zA-Z0-9]*$/.test(tinInput);

    var isIndonesia = _this11.props.auth && _this11.props.auth.company && _this11.props.auth.company.countryCode && _this11.props.auth.company.countryCode.toUpperCase() === 'ID';

    if (isIndonesia) {
      data.taxIdentificationNo = e.target.value;
      _this11.setState({ data: data }, function () {
        _this11.handleCheckChanges();
      });
      return;
    }

    if (tinInput === '') {
      data.taxIdentificationNo = '';
      _this11.setState({ data: data, tinFound: false, tinError: false, tinMessage: null });
      return;
    }

    if (isAlphanumeric) {
      data.taxIdentificationNo = tinInput;
      _this11.setState({ data: data, tinFound: tinFound, tinError: tinFound === false, tinMessage: _this11.state.tinMessage }, function () {
        _this11.handleCheckChanges();
      });

      if (tinFound) {
        return;
      }

      var matched = _regex.REGEX_TIN_VALID.test(tinInput);
      var genericTin = (0, _tin.getGenericTinByIdTypeAndTinNo)(_defaultIdentityTypeOpts.IDENTITY_TYPE_NRIC, tinInput);
      _this11.setLoading(true, 'validatingTIN').then(function () {
        if (_this11.debounceTimeout) {
          clearTimeout(_this11.debounceTimeout);
        }

        _this11.debounceTimeout = setTimeout(function () {
          if (matched) {
            if (tinInput === _tin.GOVERNMENT_GENERIC_TIN) {
              _this11.setState({
                tinError: false,
                tinFound: true,
                tinMessage: null }, function () {
                _this11.setLoading(false, 'validatingTIN');
              });
            } else if (_tin.GENERIC_TIN_VALUES.includes(tinInput)) {
              _this11.setState({
                tinError: !(0, _tin.isGenericTinFound)(genericTin),
                tinFound: (0, _tin.isGenericTinFound)(genericTin),
                tinMessage: !(0, _tin.isGenericTinFound)(genericTin) ? _tin.GENERIC_TIN_UNMATCHED_ERROR_MSG : null }, function () {
                _this11.setLoading(false, 'validatingTIN');
              });
            } else {
              _this11.validateTIN(tinInput).finally(function () {
                _this11.setLoading(false, 'validatingTIN');
              });
            }
          } else {
            _this11.setState({ tinError: true }, function () {
              _this11.setLoading(false, 'validatingTIN');
            });
          }
        }, 3000);
      });
    }
  };

  this.handleOnChange = function (event, value) {
    var _state7 = _this11.state,
        data = _state7.data,
        fullBranches = _state7.fullBranches;

    var selectedBranchIsExternal = _this11.state.selectedBranchIsExternal;
    if (value.name === 'companyBranchID') {
      var branch = fullBranches.find(function (b) {
        return b.id.toString() === value.value;
      });
      if (branch) {
        selectedBranchIsExternal = branch.isExternal;
        data.user.groups = data.user.groups.filter(function (g) {
          return g.code === _groups.DEVELOPER_EXECUTIVE;
        });
      }
    }
    data[value.name] = value.value;
    _this11.setState({ data: data, selectedBranchIsExternal: selectedBranchIsExternal }, function () {
      _this11.handleCheckChanges();
    });
  };

  this.handleUserOnChange = function (event, value) {
    var data = _this11.state.data;

    data.user[value.name] = value.value;
    _this11.setState({ data: data }, function () {
      _this11.handleCheckChanges();
    });
  };

  this.handleCheckBoxChange = function (event, value) {
    var data = _this11.state.data;

    if (value.name === 'viewAnalyticsDashboard') {
      if (value.checked) {
        if (data.user && (!data.user.groups || data.user.groups && data.user.groups.findIndex(function (g) {
          return g.id === _groups.GROUP_ID_ANALYTICS;
        }) === -1)) {
          var groups = [].concat(_toConsumableArray(data.user.groups), [{ id: _groups.GROUP_ID_ANALYTICS, code: _groups.ANALYTICS }]);
          data.user.groups = groups;
        }
      } else if (data.user && data.user.groups) {
        data.user.groups = data.user.groups.filter(function (g) {
          return g.id !== _groups.GROUP_ID_ANALYTICS;
        });
      }
    } else {
      data[value.name] = value.checked;
    }
    _this11.setState({ data: data }, function () {
      _this11.handleCheckChanges();
    });
  };

  this.handleAccessCheckBoxChange = function (event, value) {
    var data = _this11.state.data;

    data.access[value.name] = value.checked;
    _this11.setState({ data: data }, function () {
      _this11.handleCheckChanges();
    });
  };

  this.handleUserCheckBoxChange = function (event, value) {
    var data = _this11.state.data;

    data.user[value.name] = value.checked;
    _this11.setState({ data: data }, function () {
      _this11.handleCheckChanges();
    });
  };

  this.handleEditStaff = function () {
    _this11.setState({ edit: true });
  };

  this.handleUpdateStaff = function () {
    var _state8 = _this11.state,
        data = _state8.data,
        fullBranches = _state8.fullBranches;

    var newBranch = fullBranches.find(function (b) {
      return b.id === parseInt(data.companyBranchID, 10);
    });
    var hasHigherAccess = data.user.groups.find(function (g) {
      return g.code === _groups.DEVELOPER_HEADQUARTERS || g.code === _groups.DEVELOPER_BRANCH_LEADER;
    });
    if (_this11.props.auth.isHeadquarters) {
      if (!(data.companyBranch && data.companyBranch.isExternal) && newBranch && newBranch.isExternal && hasHigherAccess) {
        _this11.setState({ showConfirmBranch: true });
      } else {
        _this11.updateStaff(data);
      }
    } else {
      _this11.updateStaff(data);
    }
  };

  this.handleCancelChange = function (e) {
    e.preventDefault();
    _this11.setState({
      showConfirmBranch: false
    });
  };

  this.handleConfirmChange = function (e) {
    e.preventDefault();
    _this11.setState({
      showConfirmBranch: false
    }, function () {
      var data = _this11.state.data;

      _this11.updateStaff(data);
    });
  };

  this.handleResetChanges = function () {
    var oriData = _this11.state.oriData;

    _this11.setState({
      data: (0, _clone2.default)(oriData),
      edit: false
    }, function () {
      _this11.handleResetCheck();
    });
  };

  this.handleGroupChange = function (event, d, groupOpts) {
    var data = _this11.state.data;

    var groups = groupOpts.filter(function (g) {
      return g.code === d.value;
    });
    var group = Object.assign.apply(Object, _toConsumableArray(groups.map(function (g) {
      return { id: g.id, code: g.code };
    })));
    var index = data.user.groups.findIndex(function (g) {
      return g.id === group.id;
    });
    if (d.checked && index < 0) {
      data.user.groups.push(group);
    }
    if (!d.checked && index > -1) {
      data.user.groups.splice(index, 1);
    }
    _this11.setState({ data: data });
  };

  this.handleChangeRole = function (e, d) {
    var data = _this11.state.data;

    var groupIDs = d.value.split(',');
    var groups = _groups.devGroups.filter(function (g) {
      return groupIDs.includes(g.id);
    });

    var untouchedGroups = data.user.groups.filter(function (g) {
      return _groups.ignoreGroupIDs.includes(g.id);
    });
    if (untouchedGroups && untouchedGroups.length > 0) {
      groups = [].concat(_toConsumableArray(groups), _toConsumableArray(untouchedGroups));
    }

    data.user.groups = groups;
    _this11.setState({ data: data });
  };

  this.handleRemoveProject = function (index) {
    if (_this11.state.edit) {
      var data = _this11.state.data;

      data.projects.splice(index, 1);
      _this11.setState({ data: data });
    }
  };

  this.handleAddProject = function (e, projects) {
    e.preventDefault();
    var data = _this11.state.data;

    data.projects = projects;
    _this11.setState({
      data: data,
      showAddProject: false
    });
  };

  this.handleShowAddProject = function (e) {
    e.preventDefault();
    _this11.setState({
      showAddProject: true
    });
  };

  this.handleCloseAddProject = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this11.setState({
      showAddProject: false
    });
  };

  this.handleMappingChange = function (m) {
    var data = _this11.state.data;

    data.mappings = m;
    _this11.setState({ data: data }, function () {
      _this11.handleCheckChanges();
    });
  };

  this.handleMenu = function (e, _ref10) {
    var value = _ref10.value;
    var store = _this11.context.store;

    if (value.includes(_config2.default.get('bookApiURL')) || value.includes(_config2.default.get('salesChartURL'))) {
      e.preventDefault();
      var winObj = window.open(value, '_blank');
      winObj.opener = null;
    } else {
      store.dispatch((0, _reactRouterRedux.replace)(value));
    }
  };

  this.handleDeleteCooldownOpen = function (e, id, name, type) {
    e.preventDefault();
    _this11.setState({
      deleteCooldownType: type,
      deleteCooldownName: name,
      deleteCooldownID: id,
      showDeleteCooldownConfirm: true
    });
  };

  this.handleCancelDeleteCooldown = function (e) {
    e.preventDefault();
    _this11.setState({
      deleteCooldownName: '',
      deleteCooldownID: '',
      showDeleteCooldownConfirm: false
    });
  };

  this.handleConfirmDeleteCooldown = function (e) {
    e.preventDefault();
    _this11.setState({ showDeleteCooldownConfirm: false }, function () {
      _this11.deleteStaffCooldowns();
    });
  };

  this.checkAccess = function (statusID) {
    switch (statusID) {
      case '100':
      case '502':
        return true;
      default:
        return false;
    }
  };

  this.passwordValidation = function () {
    return {
      validRegex: '^(?=.{6,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*$'
    };
  };

  this.userStateses = [{ value: '100', text: 'Active' },
  // { value: '502', text: 'Delist' },
  { value: '503', text: 'Suspend' }];

  this.renderUserBookingCooldown = function (data) {
    var _props = _this11.props,
        t = _props.t,
        auth = _props.auth;

    var countryCode = auth && auth.company && auth.company.countryCode;
    var zoneFormat = cooldownFormat(countryCode);
    if (data && data.length > 0) {
      return data.map(function (row, idx) {
        return _react2.default.createElement(
          _semanticUiReact.Table.Row,
          { key: idx },
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/projects/' + row.projectID + '/units/' + row.projectUnitID + '/' },
              row.projectUnitReference,
              ', ',
              row.projectShortName
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            (0, _displayTime.displayMoment)(row.cooldownStartAt, countryCode).format(zoneFormat)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            (0, _displayTime.displayMoment)(row.cooldownEndAt, countryCode).format(zoneFormat)
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            _react2.default.createElement(_semanticUiReact.Button, {
              negative: true,
              type: 'button',
              size: 'small',
              icon: 'trash',
              onClick: function onClick(e) {
                return _this11.handleDeleteCooldownOpen(e, row.id, row.projectUnitReference + ', ' + row.projectShortName, 'unit');
              }
            })
          )
        );
      });
    }
    return _react2.default.createElement(
      _semanticUiReact.Table.Row,
      null,
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { colSpan: '4', textAlign: 'center' },
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { textAlign: 'center', vertical: true },
          _react2.default.createElement(
            'p',
            null,
            t('No cooldown found', { ns: _translation.TRANSLATION_FILES.translation }),
            '.'
          )
        )
      )
    );
  };

  this.renderUserBAPBan = function (data) {
    var _props2 = _this11.props,
        t = _props2.t,
        auth = _props2.auth;

    var countryCode = auth && auth.company && auth.company.countryCode;
    var zoneFormat = cooldownFormat(countryCode);
    if (data && data.length > 0) {
      return data.map(function (row, idx) {
        return _react2.default.createElement(
          _semanticUiReact.Table.Row,
          { key: idx, error: row.attemptsCount >= row.project.bapMaxAttempts || false },
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            row.isProjectMode ? _react2.default.createElement(
              _reactRouter.Link,
              { to: '/projects/' + row.projectID + '/' },
              row.projectShortName,
              ' ',
              _react2.default.createElement(
                'small',
                null,
                '(',
                row.projectUnitReference,
                ')'
              )
            ) : _react2.default.createElement(
              _reactRouter.Link,
              { to: '/projects/' + row.projectID + '/units/' + row.projectUnitID + '/' },
              row.projectShortName,
              ', ',
              row.projectUnitReference
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            { textAlign: 'center' },
            row.isProjectMode ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'checkmark', color: 'green' }) : _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', color: 'grey' })
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            row.attemptsCount
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            _react2.default.createElement(
              'small',
              null,
              (0, _displayTime.displayMoment)(row.previousAttempt, countryCode).format(zoneFormat)
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            _react2.default.createElement(
              'small',
              null,
              (0, _displayTime.displayMoment)(row.latestAttempt, countryCode).format(zoneFormat)
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            _react2.default.createElement(
              'small',
              null,
              row.attemptsCount >= row.project.bapMaxAttempts ? (0, _displayTime.displayMoment)(row.latestAttempt, countryCode).add(row.project.bapCooldownMinutes, 'minutes').format(zoneFormat) : '-'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Cell,
            null,
            _react2.default.createElement(_semanticUiReact.Button, {
              negative: true,
              type: 'button',
              size: 'small',
              icon: 'trash',
              onClick: function onClick(e) {
                return _this11.handleDeleteCooldownOpen(e, row.id, row.projectUnitReference + ', ' + row.projectShortName, 'bap');
              }
            })
          )
        );
      });
    }
    return _react2.default.createElement(
      _semanticUiReact.Table.Row,
      null,
      _react2.default.createElement(
        _semanticUiReact.Table.Cell,
        { colSpan: '4', textAlign: 'center' },
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { textAlign: 'center', vertical: true },
          _react2.default.createElement(
            'p',
            null,
            t('No entries found', { ns: _translation.TRANSLATION_FILES.translation }),
            '.'
          )
        )
      )
    );
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces), [_translation.TRANSLATION_FILES.models.user]), { withRef: true })((0, _reactRedux.connect)(Overview.mapStateToProps)(Overview));

/***/ }),
/* 2483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _checkChanges = __webpack_require__(61);

var _promptMessages = __webpack_require__(43);

var _List = __webpack_require__(2480);

var _List2 = _interopRequireDefault(_List);

var _Overview = __webpack_require__(2482);

var _Overview2 = _interopRequireDefault(_Overview);

var _Activities = __webpack_require__(2477);

var _Activities2 = _interopRequireDefault(_Activities);

var _New = __webpack_require__(2481);

var _New2 = _interopRequireDefault(_New);

var _Import = __webpack_require__(2479);

var _Import2 = _interopRequireDefault(_Import);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Staffs = function (_Component) {
  _inherits(Staffs, _Component);

  function Staffs() {
    _classCallCheck(this, Staffs);

    return _possibleConstructorReturn(this, (Staffs.__proto__ || Object.getPrototypeOf(Staffs)).apply(this, arguments));
  }

  _createClass(Staffs, [{
    key: 'renderChild',
    value: function renderChild() {
      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Staffs;
}(_react.Component);

Staffs.propTypes = {
  children: _propTypes2.default.node
};
Staffs.contextTypes = {
  store: _propTypes2.default.object
};
Staffs.List = _List2.default;
Staffs.Activities = _Activities2.default;
Staffs.Overview = (0, _checkChanges.checkChanges)(_Overview2.default);
Staffs.New = (0, _checkChanges.checkChanges)(_New2.default, { message: _promptMessages.NEW_STAFF_PROMPT });
Staffs.Import = (0, _checkChanges.checkChanges)(_Import2.default);
exports.default = Staffs;

/***/ }),
/* 2484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Staffs = __webpack_require__(2483);

var _Staffs2 = _interopRequireDefault(_Staffs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Staffs2.default;

/***/ }),
/* 2485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _url = __webpack_require__(19);

var _isNumber = __webpack_require__(30);

var _isNumber2 = _interopRequireDefault(_isNumber);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _PageNav = __webpack_require__(26);

var _PageNav2 = _interopRequireDefault(_PageNav);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _SortButton = __webpack_require__(59);

var _SortButton2 = _interopRequireDefault(_SortButton);

var _AddressSettingActivities = __webpack_require__(1002);

var _AddressSettingActivities2 = _interopRequireDefault(_AddressSettingActivities);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint no-nested-ternary: 0 */


var Activities = function (_Component) {
  _inherits(Activities, _Component);

  function Activities(props) {
    _classCallCheck(this, Activities);

    var _this = _possibleConstructorReturn(this, (Activities.__proto__ || Object.getPrototypeOf(Activities)).call(this, props));

    _initialiseProps.call(_this);

    var state = Activities.getPropsToState(props);
    state.limit = 0;
    state.offset = 0;
    state.currentPage = parseInt(state.query.page, 10) || 1;
    state.count = 0;
    _this.state = state;
    return _this;
  }

  _createClass(Activities, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var query = this.props.location.query;

      this.fetchActivities(query);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var query = nextProps.location.query;

      var state = Activities.getPropsToState(nextProps);
      if (this.state.data) {
        state.data = this.state.data;
      }
      this.setState(_extends({}, state), function () {
        if (!_this2.state.data) {
          _this2.fetchActivities(query);
        }
      });
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this3 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this3.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this4 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchActivities',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(q) {
        var store, t, query, queryString, res, queryStr, message, data, count, limit, offset;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({}, q);

                if (!query.page || !(0, _isNumber2.default)(query.page) || query.page <= 0) {
                  query.page = 1;
                }
                queryString = '';
                res = null;
                queryStr = _qs2.default.stringify(query);

                if (queryStr) {
                  queryString = '?' + queryStr;
                }
                _context.prev = 10;
                _context.next = 13;
                return store.dispatch((0, _fetchM.fetchM)('/address_settings/activities/' + queryString, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 13:
                res = _context.sent;
                _context.next = 27;
                break;

              case 16:
                _context.prev = 16;
                _context.t0 = _context['catch'](10);
                _context.next = 20;
                return this.setLoading(false);

              case 20:
                if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 25;
                  break;
                }

                _context.next = 23;
                return _context.t0.res.text();

              case 23:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                Bugsnag.notifyException(_context.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 27:
                if (res.ok) {
                  _context.next = 33;
                  break;
                }

                _context.next = 30;
                return this.setLoading(false);

              case 30:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                _context.next = 43;
                break;

              case 33:
                _context.next = 35;
                return res.json();

              case 35:
                data = _context.sent;
                count = parseInt(res.headers.get('M-Data-count'), 10);
                limit = parseInt(res.headers.get('M-Data-limit'), 10);
                offset = parseInt(res.headers.get('M-Data-offset'), 10);
                _context.next = 41;
                return this.setComponentState({
                  count: count,
                  limit: limit,
                  offset: offset,
                  data: data
                });

              case 41:
                _context.next = 43;
                return this.setLoading(false);

              case 43:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[10, 16]]);
      }));

      function fetchActivities(_x3) {
        return _ref.apply(this, arguments);
      }

      return fetchActivities;
    }()
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.props.auth.isHeadquarters) {
        return true;
      }
      if (this.props.auth.isSuperAdmin) {
        return true;
      }
      return check;
    }
  }, {
    key: 'replaceQuery',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(query) {
        var resetPage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var store, queryNew;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                queryNew = query;

                if (resetPage) queryNew.page = 1;
                _context2.next = 7;
                return this.fetchActivities(query);

              case 7:
                store.dispatch((0, _reactRouterRedux.replace)('/settings/address_settings/activities/?' + (0, _url.encodeSearch)(queryNew)));
                _context2.next = 10;
                return this.setLoading(false);

              case 10:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function replaceQuery(_x5) {
        return _ref2.apply(this, arguments);
      }

      return replaceQuery;
    }()
  }, {
    key: 'render',
    value: function render() {
      var data = this.state.data;
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Address Setting Activity Logs')
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { style: { zIndex: 20 }, active: this.state.loading, inverted: true },
            _react2.default.createElement(
              _semanticUiReact.Loader,
              { inline: 'centered' },
              t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(_SearchFilter2.default, {
                isLoading: this.state.loading,
                onChange: this.handleOnChange,
                onClose: this.handleClearFilter,
                search: this.state.search,
                placeholder: t('Search'),
                setAdvanceFilter: function setAdvanceFilter() {},
                leftNav: _react2.default.createElement(_PageNav2.default, {
                  currentPage: this.state.currentPage,
                  count: this.state.count,
                  limit: this.state.limit,
                  offset: this.state.offset,
                  dataSize: this.state.data.length,
                  loading: this.state.loading,
                  onChange: this.handleChangePage
                }),
                rightNav: _react2.default.createElement(_SortButton2.default, {
                  floated: 'right',
                  loading: this.state.loading,
                  items: this.sortItems,
                  onSort: this.handleSortData
                })
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16, textAlign: 'center' },
              _react2.default.createElement('br', null),
              _react2.default.createElement(
                _semanticUiReact.Segment,
                null,
                _react2.default.createElement(_AddressSettingActivities2.default, {
                  data: data || [],
                  hasAccess: this.hasAccess(),
                  loading: this.state.loading
                })
              )
            )
          )
        )
      );
    }
  }]);

  return Activities;
}(_react.Component);

Activities.contextTypes = {
  store: _propTypes2.default.object
};
Activities.propTypes = {
  auth: _propTypes2.default.shape({
    isHeadquarters: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string
  })
};

Activities.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

Activities.getPropsToState = function (props) {
  var query = (0, _url.decodeSearch)(props.location.search);
  var search = query.search || '';
  return {
    data: [],
    loading: true,
    query: query,
    search: search
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.handleChangePage = function (currentPage) {
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    query.page = currentPage;
    _this5.setState({
      currentPage: currentPage
    });
    _this5.replaceQuery(query);
  };

  this.handleSortData = function (sortColumn, sortDirection) {
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    _this5.replaceQuery(query);
  };

  this.handleClearFilter = function () {
    for (var _len = arguments.length, queryArray = Array(_len), _key = 0; _key < _len; _key++) {
      queryArray[_key] = arguments[_key];
    }

    var hasQuery = false;
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    var filterArray = [].concat(queryArray);
    filterArray.forEach(function (filter) {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
    });
    if (hasQuery) {
      _this5.replaceQuery(query, true);
    } else {
      _this5.setState({ search: '' });
    }
  };

  this.handleOnChange = function (value, queryName) {
    var query = (0, _url.decodeSearch)(_this5.props.location.search);
    query[queryName] = value;
    _this5.replaceQuery(query, true);
  };

  this.sortItems = [{
    text: 'Date Ascending',
    icon: 'sort alphabet ascending',
    sortColumn: 'company_address_setting_activity.created_at',
    sortDirection: 'asc'
  }, {
    text: 'Date Descending',
    icon: 'sort alphabet descending',
    sortColumn: 'company_address_setting_activity.created_at',
    sortDirection: 'desc'
  }];
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(Activities.mapStateToProps)(Activities));

/***/ }),
/* 2486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterRedux = __webpack_require__(13);

var _reactRouter = __webpack_require__(18);

var _reactRedux = __webpack_require__(9);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

__webpack_require__(452);

__webpack_require__(451);

var _webValidations = __webpack_require__(23);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _TextArea = __webpack_require__(383);

var _TextArea2 = _interopRequireDefault(_TextArea);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _AddressSettingList = __webpack_require__(2083);

var _AddressSettingList2 = _interopRequireDefault(_AddressSettingList);

var _AddressSettingActivities = __webpack_require__(1002);

var _AddressSettingActivities2 = _interopRequireDefault(_AddressSettingActivities);

var _DelistReasonsList = __webpack_require__(2128);

var _DelistReasonsList2 = _interopRequireDefault(_DelistReasonsList);

var _storage = __webpack_require__(44);

var _currencySetting = __webpack_require__(553);

var _companies = __webpack_require__(88);

var _url = __webpack_require__(19);

var _CustomField = __webpack_require__(1014);

var _CustomField2 = _interopRequireDefault(_CustomField);

var _translation = __webpack_require__(4);

var _FinanceSourceList = __webpack_require__(2146);

var _FinanceSourceList2 = _interopRequireDefault(_FinanceSourceList);

var _Filters = __webpack_require__(86);

var _appConfig = __webpack_require__(379);

var _vietnam = __webpack_require__(40);

var _displayTime = __webpack_require__(156);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var isPRS = _config2.default.get('prs');

var SystemSettings = function (_Component) {
  _inherits(SystemSettings, _Component);

  function SystemSettings(props) {
    _classCallCheck(this, SystemSettings);

    var _this = _possibleConstructorReturn(this, (SystemSettings.__proto__ || Object.getPrototypeOf(SystemSettings)).call(this, props));

    _initialiseProps.call(_this);

    var state = SystemSettings.getPropsToState(props);
    if (_this.hasAdminAccess(props)) {
      _this.tabs.push({
        name: 'cache',
        value: 'cache',
        text: 'Cache (Admin)',
        fields: []
      });
    }
    if (!isPRS) {
      _this.tabs.push({
        name: 'auto_release',
        value: 'auto_release',
        text: 'Auto-Release Settings',
        fields: []
      });
    }
    if (_this.props.auth.isAdminBasic) {
      _this.tabs.splice(1, 0, {
        name: 'sms',
        value: 'sms',
        text: 'SMS Templates',
        fields: []
      });
    }
    _this.state = _extends({}, state, {
      currentTab: _this.tabs[0].name,
      data: (0, _clone2.default)(SystemSettings.defaultData),
      oriData: (0, _clone2.default)(SystemSettings.defaultData),
      tempData: (0, _clone2.default)(SystemSettings.defaultTempData),
      errMessages: [],
      loading: true,
      token: null,
      applyArToAllProjects: false,
      applyAgingArToAllProjects: false,
      regionOptions: [],
      townshipOptions: [],
      cooldownOptions: [].concat(_toConsumableArray(_this.cooldownOptions)),
      cacheOptions: [].concat(_toConsumableArray(_this.cacheOptions)),
      previewFormat: '',
      addressSettings: [],
      oriAddressSettings: [],
      financeSources: [],
      oriFinanceSources: [],
      activitiesLoading: true,
      addressSettingActivities: [],
      currencySettingLoading: false,
      unitCustomSettingsLoading: false,
      unitCustomFieldSettings: [],
      oriUnitCustomFieldSettings: [],
      packagePricingList: [],
      projectPackagePricingID: '',
      findProjectResults: [],
      loadingProjectSearch: false,
      projectKeyword: '',
      projectID: '',
      smsTemplates: [],
      reservationTokenSettings: { priceMinor: 0, validityDurationDays: 0, limitPerOpportunity: 0, currencyCode: 'MYR' },
      oriReservationTokenSettings: { priceMinor: 0, validityDurationDays: 0, limitPerOpportunity: 0, currencyCode: 'MYR' },
      reservationTokenLoading: false
    });
    _this.validation = {
      canManagePaymentOptions: (0, _react.createRef)(),
      arBookingExpMoreThanMinutes: (0, _react.createRef)(),
      arAgingBookingExpMoreThanMinutes: (0, _react.createRef)(),
      addressFormatTemplate: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(SystemSettings, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchSystemSettings();
      this.fetchAddressSettingActivities();
      this.fetchUnitCustomFieldSettings();
      this.fetchSMSTemplates();
      if (this.canAccessReservationTokenSettings()) {
        this.fetchReservationTokenSettings();
      }
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = SystemSettings.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'setLoadingProjectSearch',
    value: function setLoadingProjectSearch() {
      var _this4 = this;

      var loadingProjectSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this4.setState({ loadingProjectSearch: loadingProjectSearch }, res);
      });
    }
  }, {
    key: 'setActivitiesLoading',
    value: function setActivitiesLoading() {
      var _this5 = this;

      var activitiesLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this5.setState({ activitiesLoading: activitiesLoading }, function () {
          res(activitiesLoading);
        });
      });
    }
  }, {
    key: 'setCurrencySettingLoading',
    value: function setCurrencySettingLoading() {
      var _this6 = this;

      var currencySettingLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this6.setState({ currencySettingLoading: currencySettingLoading }, function () {
          res(currencySettingLoading);
        });
      });
    }
  }, {
    key: 'setUnitCustomSettingsLoading',
    value: function setUnitCustomSettingsLoading() {
      var _this7 = this;

      var unitCustomSettingsLoading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this7.setState({ unitCustomSettingsLoading: unitCustomSettingsLoading }, function () {
          res(unitCustomSettingsLoading);
        });
      });
    }
  }, {
    key: 'fetchSMSTemplates',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, _props, auth, t, res, message, data, token, templates;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                _props = this.props, auth = _props.auth, t = _props.t;

                if (!auth.isAdminBasic) {
                  _context.next = 35;
                  break;
                }

                res = void 0;
                _context.prev = 6;
                _context.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/sms_templates/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context.sent;
                _context.next = 20;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context['catch'](6);

                Bugsnag.notifyException(_context.t0);
                _context.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context.next = 19;
                return this.setLoading(false);

              case 19:
                return _context.abrupt('return');

              case 20:
                if (res.ok) {
                  _context.next = 28;
                  break;
                }

                _context.next = 23;
                return res.text();

              case 23:
                message = _context.sent;
                _context.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context.next = 35;
                break;

              case 28:
                _context.next = 30;
                return res.json();

              case 30:
                data = _context.sent;
                token = res.headers.get('X-Csrf-Token');
                templates = data ? data.map(function (x) {
                  return {
                    value: x.id,
                    text: x.name
                  };
                }) : [];
                // handle token.. etc

                _context.next = 35;
                return this.setComponentState({
                  token: token,
                  smsTemplates: templates
                });

              case 35:
                _context.next = 37;
                return this.setLoading(false);

              case 37:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 12]]);
      }));

      function fetchSMSTemplates() {
        return _ref.apply(this, arguments);
      }

      return fetchSMSTemplates;
    }()
  }, {
    key: 'fetchSystemSettings',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var store, t, res, message, data, token, fltHours, _fltHours, regions, regionOptions, townships, townshipOptions, _state, cooldownOptions, cacheOptions, cdOptionExists, _cdOptionExists;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context2.prev = 5;
                _context2.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/settings/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context2.sent;
                _context2.next = 19;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2['catch'](5);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context2.next = 18;
                return this.setLoading(false);

              case 18:
                return _context2.abrupt('return');

              case 19:
                if (res.ok) {
                  _context2.next = 27;
                  break;
                }

                _context2.next = 22;
                return res.text();

              case 22:
                message = _context2.sent;
                _context2.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context2.next = 52;
                break;

              case 27:
                _context2.next = 29;
                return res.json();

              case 29:
                data = _context2.sent;
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                data.agencyAllocationAllocateAll = Boolean(data.agencyAllocationAllocateAll);
                if (data && data.arBookingExpMoreThanMinutes && data.arBookingExpMoreThanMinutes !== '' && data.arBookingExpMoreThanMinutes !== '0') {
                  fltHours = Number(data.arBookingExpMoreThanMinutes) / 60;

                  data.arBookingExpMoreThanMinutes = Math.round(fltHours * 10) / 10;
                }
                if (data && data.arAgingBookingExpMoreThanMinutes && data.arAgingBookingExpMoreThanMinutes !== '' && data.arAgingBookingExpMoreThanMinutes !== '0') {
                  _fltHours = Number(data.arAgingBookingExpMoreThanMinutes) / 60;

                  data.arAgingBookingExpMoreThanMinutes = Math.round(_fltHours * 10) / 10;
                }
                regions = data.regions ? data.regions : [];
                regionOptions = this.state.regionOptions;

                regions.forEach(function (i) {
                  return regionOptions.push({
                    value: i,
                    text: i
                  });
                });
                townships = data.townships ? data.townships : [];
                townshipOptions = this.state.townshipOptions;

                townships.forEach(function (i) {
                  return townshipOptions.push({
                    value: i,
                    text: i
                  });
                });
                _state = this.state, cooldownOptions = _state.cooldownOptions, cacheOptions = _state.cacheOptions;

                if (data.unitCooldownTimeMinutes) {
                  data.unitCooldownTimeMinutes = data.unitCooldownTimeMinutes.toString();
                  cdOptionExists = this.state.cooldownOptions.findIndex(function (co) {
                    return co.value === data.unitCooldownTimeMinutes;
                  });

                  if (cdOptionExists === -1) {
                    cooldownOptions = [{ key: data.unitCooldownTimeMinutes, text: data.unitCooldownTimeMinutes, value: data.unitCooldownTimeMinutes }].concat(_toConsumableArray(this.state.cooldownOptions));
                  }
                }
                if (data.salesChartCacheMinutes) {
                  data.salesChartCacheMinutes = data.salesChartCacheMinutes.toString();
                  _cdOptionExists = this.state.cacheOptions.findIndex(function (co) {
                    return co.value === data.salesChartCacheMinutes;
                  });

                  if (_cdOptionExists === -1) {
                    cacheOptions = [{ key: data.salesChartCacheMinutes, text: data.salesChartCacheMinutes, value: data.salesChartCacheMinutes }].concat(_toConsumableArray(this.state.cacheOptions));
                  }
                }
                if (data.leadDropSMSTemplate === '') {
                  data.leadDropSMSTemplate = 'default';
                }
                if (data.leadSuccessSMSTemplate === '') {
                  data.leadSuccessSMSTemplate = 'default';
                }
                if (data.notesExternalPlaceholder === '') {
                  data.notesExternalPlaceholder = t('Type a note...', { ns: _translation.TRANSLATION_FILES.translation });
                }
                _context2.next = 48;
                return this.setComponentState({
                  token: token,
                  data: data,
                  regionOptions: regionOptions,
                  townshipOptions: townshipOptions,
                  cooldownOptions: cooldownOptions,
                  cacheOptions: cacheOptions,
                  oriData: (0, _clone2.default)(data),
                  tempData: this.prepareTempData(data),
                  applyArToAllProjects: this.getReleaseRequirementSettings(data),
                  applyAgingArToAllProjects: this.getAgingReleaseRequirementSettings(data)
                });

              case 48:
                (0, _storage.setItem)(_config2.default.get('appName') + '.globalSettings', JSON.stringify({
                  data: data,
                  createdAt: (0, _momentTimezone2.default)().toDate(),
                  version: _config2.default.get('version')
                }));

                if (!(data && data.company && (0, _companies.isForeignCompany)(data.company))) {
                  _context2.next = 52;
                  break;
                }

                _context2.next = 52;
                return this.fetchCurrencySetting(data.company.id, data);

              case 52:
                _context2.next = 54;
                return this.setLoading(false);

              case 54:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[5, 11]]);
      }));

      function fetchSystemSettings() {
        return _ref2.apply(this, arguments);
      }

      return fetchSystemSettings;
    }()
  }, {
    key: 'updateSystemSettings',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(validations, data, addressSettings) {
        var store, t, stateData, _state2, applyArToAllProjects, applyAgingArToAllProjects, unitCustomFieldSettings, financeSources, noTimer, noAgingTimer, ucfs, hasMultiDropdown, i, defaultValue, newFinanceSources, emptyFinanceLabel, errors, addressSettingValidations, financeSourcesValidations, message;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                stateData = _extends({}, data, {
                  addressSettings: addressSettings
                });
                _state2 = this.state, applyArToAllProjects = _state2.applyArToAllProjects, applyAgingArToAllProjects = _state2.applyAgingArToAllProjects, unitCustomFieldSettings = _state2.unitCustomFieldSettings, financeSources = _state2.financeSources;
                noTimer = stateData.arBookingExpMoreThanMinutes && (Number(stateData.arBookingExpMoreThanMinutes) < 1 || stateData.arBookingExpMoreThanMinutes === '') || !stateData.arBookingExpMoreThanMinutes;
                // CPI-974 (D20): Vietnam never sees the Auto-Release criteria grid, so the same gate has to
                // cover this validation or a Vietnamese company can never save.

                if (!(!(0, _vietnam.isVietnamCompany)(this.props.auth) && applyArToAllProjects && (
                // no timer no requirements
                noTimer && !stateData.arBookingExpNricPicIsEnabled && !stateData.arBookingExpAllNricPicsIsEnabled && !stateData.arBookingExpUnpaidIsEnabled && !stateData.arBookingExpMortgageEnabled ||
                // got timer no requirements
                !noTimer && !stateData.arBookingExpNricPicIsEnabled && !stateData.arBookingExpAllNricPicsIsEnabled && !stateData.arBookingExpUnpaidIsEnabled && !stateData.arBookingExpMortgageEnabled ||
                // no timer got requirements
                noTimer && (stateData.arBookingExpNricPicIsEnabled || stateData.arBookingExpAllNricPicsIsEnabled || stateData.arBookingExpUnpaidIsEnabled || stateData.arBookingExpMortgageEnabled)))) {
                  _context3.next = 11;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({
                  message: t('Please make sure to set Auto release timer and keep at least one Auto-Release Requirement "On" if you\'d like auto-release feature to be enabled', { ns: _translation.TRANSLATION_FILES.translation }) + '.'
                }));
                this.setLoading(false);
                return _context3.abrupt('return');

              case 11:
                noAgingTimer = stateData.arAgingBookingExpMoreThanMinutes && (Number(stateData.arAgingBookingExpMoreThanMinutes) < 1 || stateData.arAgingBookingExpMoreThanMinutes === '') || !stateData.arAgingBookingExpMoreThanMinutes;

                if (!(applyAgingArToAllProjects && (
                // no timer no requirements
                noAgingTimer && !stateData.arAgingBookingExpReservedIsEnabled && !stateData.arAgingBookingExpBookedIsEnabled ||
                // got timer no requirements
                !noAgingTimer && !stateData.arAgingBookingExpReservedIsEnabled && !stateData.arAgingBookingExpBookedIsEnabled ||
                // no timer got requirements
                noAgingTimer && (stateData.arAgingBookingExpReservedIsEnabled || stateData.arAgingBookingExpBookedIsEnabled)))) {
                  _context3.next = 16;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({
                  message: 'Please make sure to set Time limit timer and keep at least one Time Limit Booking Status "On" if you\'d like auto-release time limit feature to be enabled' + '.'
                }));
                this.setLoading(false);
                return _context3.abrupt('return');

              case 16:
                if (!stateData.currencySetting) {
                  _context3.next = 26;
                  break;
                }

                stateData.currencySetting.abbreviationDecimalPoints = Number(stateData.currencySetting.abbreviationDecimalPoints);

                if (!(stateData.currencySetting.abbreviationDecimalPoints < 0)) {
                  _context3.next = 22;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ message: t('Abbreviation decimal points must be more or equals to 0', { ns: _translation.TRANSLATION_FILES.translation }) }));
                this.setLoading(false);
                return _context3.abrupt('return');

              case 22:
                if (!(stateData.currencySetting.abbreviationDecimalPoints % 1 !== 0)) {
                  _context3.next = 26;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ message: t('Abbreviation decimal points should not contains decimal points', { ns: _translation.TRANSLATION_FILES.translation }) }));
                this.setLoading(false);
                return _context3.abrupt('return');

              case 26:

                // set unit custom fields multi_dropdown default value
                ucfs = [].concat(_toConsumableArray(unitCustomFieldSettings));

                if (ucfs && ucfs.length > 0) {
                  hasMultiDropdown = ucfs.findIndex(function (ucf) {
                    return ucf.type === 'dropdown_multi';
                  });

                  if (hasMultiDropdown !== -1) {
                    i = 0;

                    while (i < ucfs.length) {
                      if (ucfs[i].type === 'dropdown_multi') {
                        defaultValue = '';

                        if (_lodash2.default.isArray(ucfs[i].defaultValue)) {
                          defaultValue = ucfs[i].defaultValue.filter(function (v) {
                            return v !== '';
                          }).join(',');
                        }
                        ucfs[i].defaultValue = defaultValue;
                      }
                      i += 1;
                    }
                  }
                }
                stateData.projectUnitCustomFieldSettings = ucfs;

                // Finance sources
                newFinanceSources = financeSources ? [].concat(_toConsumableArray(financeSources)) : [];
                emptyFinanceLabel = newFinanceSources.findIndex(function (s) {
                  return !s.label;
                });

                if (!(emptyFinanceLabel > -1)) {
                  _context3.next = 35;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ message: 'Sources of Financing\'s Label is required' }));
                this.setLoading(false);
                return _context3.abrupt('return');

              case 35:
                if (newFinanceSources.some(function (s) {
                  return s.isEnabled;
                })) {
                  _context3.next = 39;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ message: 'Source of Financing must have at least 1 enabled source' }));
                this.setLoading(false);
                return _context3.abrupt('return');

              case 39:

                if (newFinanceSources.length > 0) {
                  newFinanceSources = newFinanceSources.map(function (fs) {
                    var newFs = _extends({}, fs);
                    if (!isNaN(fs.id)) {
                      newFs.id = '';
                    }
                    return newFs;
                  });
                }

                stateData.financeSources = newFinanceSources;

                errors = validations.filter(function (v) {
                  return !v.isValid;
                });
                _context3.next = 44;
                return this.addressSettingList.validate();

              case 44:
                addressSettingValidations = _context3.sent;
                _context3.next = 47;
                return this.financeSourceList.validate();

              case 47:
                financeSourcesValidations = _context3.sent;

                errors.concat([].concat(_toConsumableArray(addressSettingValidations), _toConsumableArray(financeSourcesValidations)).filter(function (v) {
                  return !v.isValid;
                }));

                if (!(errors.length > 0)) {
                  _context3.next = 53;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                this.setLoading(false);
                return _context3.abrupt('return');

              case 53:
                if (!noTimer) {
                  stateData.arBookingExpMoreThanMinutes = Math.round(Number(stateData.arBookingExpMoreThanMinutes) * 60).toString();
                }
                if (!noAgingTimer) {
                  stateData.arAgingBookingExpMoreThanMinutes = Math.round(Number(stateData.arAgingBookingExpMoreThanMinutes) * 60).toString();
                }

                if (!(!noTimer && !noAgingTimer && Math.round(Number(stateData.arBookingExpMoreThanMinutes) * 60) > Math.round(Number(stateData.arAgingBookingExpMoreThanMinutes) * 60))) {
                  _context3.next = 59;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ message: 'Auto release timer must be less or equals to Time limit timer' }));
                this.setLoading(false);
                return _context3.abrupt('return');

              case 59:
                if (stateData.unitCooldownTimeMinutes) {
                  stateData.unitCooldownTimeMinutes = parseInt(stateData.unitCooldownTimeMinutes, 10);
                }
                if (stateData.salesChartCacheMinutes) {
                  stateData.salesChartCacheMinutes = parseInt(stateData.salesChartCacheMinutes, 10);
                }
                if (stateData.leadDropSMSTemplate === 'default') {
                  stateData.leadDropSMSTemplate = '';
                }
                if (stateData.leadSuccessSMSTemplate === 'default') {
                  stateData.leadSuccessSMSTemplate = '';
                }
                if (stateData.notesExternalPlaceholder === 'Type a note...') {
                  stateData.notesExternalPlaceholder = '';
                }
                _context3.prev = 64;
                _context3.next = 67;
                return store.dispatch((0, _fetchM.fetchM)('/settings/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(stateData)
                }));

              case 67:
                _context3.next = 83;
                break;

              case 69:
                _context3.prev = 69;
                _context3.t0 = _context3['catch'](64);
                _context3.next = 73;
                return this.setLoading(false);

              case 73:
                this.financeSourceList.fetchFinanceSources();

                if (!(_context3.t0.res && _context3.t0.res.status >= 400 && _context3.t0.res.status < 500)) {
                  _context3.next = 80;
                  break;
                }

                _context3.next = 77;
                return _context3.t0.res.text();

              case 77:
                message = _context3.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context3.abrupt('return');

              case 80:
                Bugsnag.notifyException(_context3.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context3.abrupt('return');

              case 83:
                _context3.next = 85;
                return this.setComponentState({
                  isEditing: false
                });

              case 85:
                _context3.next = 87;
                return this.setLoading(false);

              case 87:
                this.fetchSystemSettings();
                this.addressSettingList.fetchAddressSettings();
                this.financeSourceList.fetchFinanceSources();
                this.fetchAddressSettingActivities();
                this.fetchUnitCustomFieldSettings();
                store.dispatch((0, _appConfig.fetchAppConfig)());
                if ((0, _companies.isForeignCompany)(stateData.company)) {
                  store.dispatch((0, _currencySetting.fetchCurrencySetting)());
                }
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('System settings successfully updated', { ns: _translation.TRANSLATION_FILES.translation }) + '.'
                }));

              case 95:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[64, 69]]);
      }));

      function updateSystemSettings(_x7, _x8, _x9) {
        return _ref3.apply(this, arguments);
      }

      return updateSystemSettings;
    }()
  }, {
    key: 'bulkRecalculateUnitPackagePricing',
    value: function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var store, t, res, message, _message;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context4.prev = 5;
                _context4.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/settings/recalculate_unit_package_pricing/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  }
                }));

              case 8:
                res = _context4.sent;
                _context4.next = 25;
                break;

              case 11:
                _context4.prev = 11;
                _context4.t0 = _context4['catch'](5);
                _context4.next = 15;
                return this.setLoading(false);

              case 15:
                if (!(_context4.t0.res && _context4.t0.res.status >= 400 && _context4.t0.res.status < 500)) {
                  _context4.next = 21;
                  break;
                }

                _context4.next = 18;
                return _context4.t0.res.text();

              case 18:
                message = _context4.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context4.abrupt('return');

              case 21:
                Bugsnag.notifyException(_context4.t0);
                _context4.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 24:
                return _context4.abrupt('return');

              case 25:
                if (res.ok) {
                  _context4.next = 33;
                  break;
                }

                _context4.next = 28;
                return res.text();

              case 28:
                _message = _context4.sent;
                _context4.next = 31;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

              case 31:
                _context4.next = 35;
                break;

              case 33:
                _context4.next = 35;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Pricing package successfully updated in all units', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 35:
                _context4.next = 37;
                return this.setLoading(false);

              case 37:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this, [[5, 11]]);
      }));

      function bulkRecalculateUnitPackagePricing() {
        return _ref4.apply(this, arguments);
      }

      return bulkRecalculateUnitPackagePricing;
    }()
  }, {
    key: 'searchProjects',
    value: function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(value) {
        var store, t, res, message, json, findProjectResults, noResultsMessage;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                _context5.next = 4;
                return this.setLoadingProjectSearch(true);

              case 4:
                res = null;
                _context5.prev = 5;
                _context5.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/search/projects/?limit=6&search=' + value, {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context5.sent;
                _context5.next = 22;
                break;

              case 11:
                _context5.prev = 11;
                _context5.t0 = _context5['catch'](5);

                if (!(_context5.t0.res && _context5.t0.res.status >= 400 && _context5.t0.res.status < 500)) {
                  _context5.next = 18;
                  break;
                }

                _context5.next = 16;
                return _context5.t0.res.text();

              case 16:
                message = _context5.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 18:
                _context5.next = 20;
                return this.setLoadingProjectSearch(false);

              case 20:
                Bugsnag.notifyException(_context5.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 22:
                if (res.ok) {
                  _context5.next = 28;
                  break;
                }

                _context5.next = 25;
                return this.setLoadingProjectSearch(false);

              case 25:
                throw new Error('Not OK');

              case 28:
                _context5.next = 30;
                return this.setLoadingProjectSearch(false);

              case 30:
                _context5.next = 32;
                return res.json();

              case 32:
                json = _context5.sent;

                if (json) {
                  findProjectResults = json.map(function (obj) {
                    var newResults = {};
                    newResults.key = obj.id;
                    newResults.title = obj.name;
                    newResults.description = obj.shortName;
                    return newResults;
                  });

                  this.setState({ findProjectResults: findProjectResults });
                } else {
                  noResultsMessage = t('No results found', { ns: _translation.TRANSLATION_FILES.translation }) + '.';

                  this.setState({ noResultsMessage: noResultsMessage });
                }

              case 34:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this, [[5, 11]]);
      }));

      function searchProjects(_x10) {
        return _ref5.apply(this, arguments);
      }

      return searchProjects;
    }()
  }, {
    key: 'fetchPackagePricings',
    value: function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var store, t, res, message, json, packagePricingList;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context6.prev = 5;
                _context6.next = 8;
                return store.dispatch((0, _fetchM.fetchM)(_config2.default.get('bookApiURL') + '/projects/' + this.state.projectID + '/package_pricings/?sortByEnabled=true', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context6.sent;
                _context6.next = 19;
                break;

              case 11:
                _context6.prev = 11;
                _context6.t0 = _context6['catch'](5);

                Bugsnag.notifyException(_context6.t0);
                _context6.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context6.next = 18;
                return this.setLoading(false);

              case 18:
                return _context6.abrupt('return');

              case 19:
                if (res.ok) {
                  _context6.next = 27;
                  break;
                }

                _context6.next = 22;
                return res.text();

              case 22:
                message = _context6.sent;
                _context6.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context6.next = 33;
                break;

              case 27:
                _context6.next = 29;
                return res.json();

              case 29:
                json = _context6.sent;
                packagePricingList = this.editPackagePricingData(json);
                _context6.next = 33;
                return this.setComponentState({
                  packagePricingList: packagePricingList
                });

              case 33:
                _context6.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this, [[5, 11]]);
      }));

      function fetchPackagePricings() {
        return _ref6.apply(this, arguments);
      }

      return fetchPackagePricings;
    }()
  }, {
    key: 'bulkRecalculateUnitBookingPrice',
    value: function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var store, t, projectID, res, message, _message2, data, updatedCount;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                projectID = this.state.projectID;
                res = void 0;
                _context7.prev = 6;
                _context7.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/settings/recalculate_unit_booking_pricing/?projectID=' + projectID, {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  }
                }));

              case 9:
                res = _context7.sent;
                _context7.next = 26;
                break;

              case 12:
                _context7.prev = 12;
                _context7.t0 = _context7['catch'](6);
                _context7.next = 16;
                return this.setLoading(false);

              case 16:
                if (!(_context7.t0.res && _context7.t0.res.status >= 400 && _context7.t0.res.status < 500)) {
                  _context7.next = 22;
                  break;
                }

                _context7.next = 19;
                return _context7.t0.res.text();

              case 19:
                message = _context7.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context7.abrupt('return');

              case 22:
                Bugsnag.notifyException(_context7.t0);
                _context7.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 25:
                return _context7.abrupt('return');

              case 26:
                if (res.ok) {
                  _context7.next = 34;
                  break;
                }

                _context7.next = 29;
                return res.text();

              case 29:
                _message2 = _context7.sent;
                _context7.next = 32;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message2 }));

              case 32:
                _context7.next = 40;
                break;

              case 34:
                _context7.next = 36;
                return res.json();

              case 36:
                data = _context7.sent;
                updatedCount = data.updatedCount;
                _context7.next = 40;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('{{count}} active bookings successfully updated unit selling price', { count: updatedCount, ns: _translation.TRANSLATION_FILES.translation }) }));

              case 40:
                _context7.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this, [[6, 12]]);
      }));

      function bulkRecalculateUnitBookingPrice() {
        return _ref7.apply(this, arguments);
      }

      return bulkRecalculateUnitBookingPrice;
    }()
  }, {
    key: 'bulkApplyLatestBookingPackagePricing',
    value: function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var store, t, projectPackagePricingID, res, message, _message3, data, updatedCount;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                projectPackagePricingID = this.state.projectPackagePricingID;
                res = void 0;
                _context8.prev = 6;
                _context8.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/settings/apply_latest_booking_package_pricing/?projectPackagePricingID=' + projectPackagePricingID, {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  }
                }));

              case 9:
                res = _context8.sent;
                _context8.next = 26;
                break;

              case 12:
                _context8.prev = 12;
                _context8.t0 = _context8['catch'](6);
                _context8.next = 16;
                return this.setLoading(false);

              case 16:
                if (!(_context8.t0.res && _context8.t0.res.status >= 400 && _context8.t0.res.status < 500)) {
                  _context8.next = 22;
                  break;
                }

                _context8.next = 19;
                return _context8.t0.res.text();

              case 19:
                message = _context8.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context8.abrupt('return');

              case 22:
                Bugsnag.notifyException(_context8.t0);
                _context8.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 25:
                return _context8.abrupt('return');

              case 26:
                if (res.ok) {
                  _context8.next = 34;
                  break;
                }

                _context8.next = 29;
                return res.text();

              case 29:
                _message3 = _context8.sent;
                _context8.next = 32;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message3 }));

              case 32:
                _context8.next = 40;
                break;

              case 34:
                _context8.next = 36;
                return res.json();

              case 36:
                data = _context8.sent;
                updatedCount = data.updatedCount;
                _context8.next = 40;
                return store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Selected pricing package successfully updated in {{count}} active bookings', { count: updatedCount, ns: _translation.TRANSLATION_FILES.translation }) }));

              case 40:
                _context8.next = 42;
                return this.setLoading(false);

              case 42:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this, [[6, 12]]);
      }));

      function bulkApplyLatestBookingPackagePricing() {
        return _ref8.apply(this, arguments);
      }

      return bulkApplyLatestBookingPackagePricing;
    }()
  }, {
    key: 'previewAddressFormat',
    value: function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9(validations, data, addressSettings) {
        var store, t, errors, addressSettingValidations, payload, res, message, _message4, previewData;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });
                _context9.next = 7;
                return this.addressSettingList.validate();

              case 7:
                addressSettingValidations = _context9.sent;

                errors.concat(addressSettingValidations.filter(function (v) {
                  return !v.isValid;
                }));

                if (!(errors.length > 0)) {
                  _context9.next = 13;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                this.setLoading(false);
                return _context9.abrupt('return');

              case 13:
                payload = {
                  format: data.addressFormatTemplate
                };

                addressSettings.forEach(function (as) {
                  payload[_lodash2.default.camelCase(as.columnName)] = as.label;
                });

                res = void 0;
                _context9.prev = 16;
                _context9.next = 19;
                return store.dispatch((0, _fetchM.fetchM)('/settings/preview_address_format/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(payload)
                }));

              case 19:
                res = _context9.sent;
                _context9.next = 35;
                break;

              case 22:
                _context9.prev = 22;
                _context9.t0 = _context9['catch'](16);
                _context9.next = 26;
                return this.setLoading(false);

              case 26:
                if (!(_context9.t0.res && _context9.t0.res.status >= 400 && _context9.t0.res.status < 500)) {
                  _context9.next = 32;
                  break;
                }

                _context9.next = 29;
                return _context9.t0.res.text();

              case 29:
                message = _context9.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context9.abrupt('return');

              case 32:
                Bugsnag.notifyException(_context9.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context9.abrupt('return');

              case 35:
                if (res.ok) {
                  _context9.next = 43;
                  break;
                }

                _context9.next = 38;
                return res.text();

              case 38:
                _message4 = _context9.sent;
                _context9.next = 41;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: _message4 }));

              case 41:
                _context9.next = 48;
                break;

              case 43:
                _context9.next = 45;
                return res.json();

              case 45:
                previewData = _context9.sent;
                _context9.next = 48;
                return this.setComponentState({
                  previewFormat: previewData.preview
                });

              case 48:
                _context9.next = 50;
                return this.setLoading(false);

              case 50:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this, [[16, 22]]);
      }));

      function previewAddressFormat(_x11, _x12, _x13) {
        return _ref9.apply(this, arguments);
      }

      return previewAddressFormat;
    }()
  }, {
    key: 'fetchAddressSettingActivities',
    value: function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var store, t, query, res, message, addressSettingActivities;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return this.setActivitiesLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = {
                  limit: 5,
                  page: 1
                };
                res = void 0;
                _context10.prev = 6;
                _context10.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/address_settings/activities/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context10.sent;
                _context10.next = 23;
                break;

              case 12:
                _context10.prev = 12;
                _context10.t0 = _context10['catch'](6);
                _context10.next = 16;
                return this.setActivitiesLoading(false);

              case 16:
                if (!(_context10.t0.res && _context10.t0.res.status >= 400 && _context10.t0.res.status < 500)) {
                  _context10.next = 21;
                  break;
                }

                _context10.next = 19;
                return _context10.t0.res.text();

              case 19:
                message = _context10.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 21:
                Bugsnag.notifyException(_context10.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 23:
                if (res.ok) {
                  _context10.next = 29;
                  break;
                }

                _context10.next = 26;
                return this.setActivitiesLoading(false);

              case 26:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                _context10.next = 36;
                break;

              case 29:
                _context10.next = 31;
                return res.json();

              case 31:
                addressSettingActivities = _context10.sent;
                _context10.next = 34;
                return this.setComponentState({
                  addressSettingActivities: addressSettingActivities
                });

              case 34:
                _context10.next = 36;
                return this.setActivitiesLoading(false);

              case 36:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this, [[6, 12]]);
      }));

      function fetchAddressSettingActivities() {
        return _ref10.apply(this, arguments);
      }

      return fetchAddressSettingActivities;
    }()
  }, {
    key: 'fetchCurrencySetting',
    value: function () {
      var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(companyID, data) {
        var store, t, res, newData, message, currencySetting;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.setCurrencySettingLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                newData = _extends({}, data);
                _context11.prev = 6;
                _context11.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/company/' + companyID + '/currency_setting/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context11.sent;
                _context11.next = 23;
                break;

              case 12:
                _context11.prev = 12;
                _context11.t0 = _context11['catch'](6);
                _context11.next = 16;
                return this.setCurrencySettingLoading(false);

              case 16:
                if (!(_context11.t0.res && _context11.t0.res.status >= 400 && _context11.t0.res.status < 500)) {
                  _context11.next = 21;
                  break;
                }

                _context11.next = 19;
                return _context11.t0.res.text();

              case 19:
                message = _context11.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 21:
                Bugsnag.notifyException(_context11.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 23:
                if (res.ok) {
                  _context11.next = 29;
                  break;
                }

                _context11.next = 26;
                return this.setCurrencySettingLoading(false);

              case 26:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                _context11.next = 38;
                break;

              case 29:
                _context11.next = 31;
                return res.json();

              case 31:
                currencySetting = _context11.sent;

                newData.currencySetting = currencySetting;
                // set default data
                if (!currencySetting.id) {
                  newData.currencySetting.isAbbreviationEnabled = false;
                  newData.currencySetting.abbreviationDecimalPoints = 2;
                }
                _context11.next = 36;
                return this.setComponentState({
                  data: newData
                });

              case 36:
                _context11.next = 38;
                return this.setCurrencySettingLoading(false);

              case 38:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this, [[6, 12]]);
      }));

      function fetchCurrencySetting(_x14, _x15) {
        return _ref11.apply(this, arguments);
      }

      return fetchCurrencySetting;
    }()
  }, {
    key: 'fetchUnitCustomFieldSettings',
    value: function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var store, t, res, message, unitCustomFieldSettingsData;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.setUnitCustomSettingsLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context12.prev = 5;
                _context12.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/settings/unit_custom_fields/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context12.sent;
                _context12.next = 22;
                break;

              case 11:
                _context12.prev = 11;
                _context12.t0 = _context12['catch'](5);
                _context12.next = 15;
                return this.setUnitCustomSettingsLoading(false);

              case 15:
                if (!(_context12.t0.res && _context12.t0.res.status >= 400 && _context12.t0.res.status < 500)) {
                  _context12.next = 20;
                  break;
                }

                _context12.next = 18;
                return _context12.t0.res.text();

              case 18:
                message = _context12.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 20:
                Bugsnag.notifyException(_context12.t0);
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));

              case 22:
                if (res.ok) {
                  _context12.next = 28;
                  break;
                }

                _context12.next = 25;
                return this.setUnitCustomSettingsLoading(false);

              case 25:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                _context12.next = 38;
                break;

              case 28:
                _context12.next = 30;
                return res.json();

              case 30:
                _context12.t1 = _context12.sent;

                if (_context12.t1) {
                  _context12.next = 33;
                  break;
                }

                _context12.t1 = [];

              case 33:
                unitCustomFieldSettingsData = _context12.t1;
                _context12.next = 36;
                return this.setComponentState({
                  unitCustomFieldSettings: unitCustomFieldSettingsData,
                  oriUnitCustomFieldSettings: (0, _clone2.default)(unitCustomFieldSettingsData)
                });

              case 36:
                _context12.next = 38;
                return this.setUnitCustomSettingsLoading(false);

              case 38:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this, [[5, 11]]);
      }));

      function fetchUnitCustomFieldSettings() {
        return _ref12.apply(this, arguments);
      }

      return fetchUnitCustomFieldSettings;
    }()
  }, {
    key: 'checkActiveTab',
    value: function checkActiveTab(name) {
      return this.state.currentTab === name ? 'display_inline_block' : 'display_inline_block hidden';
    }
  }, {
    key: 'hasAdminAccess',
    value: function hasAdminAccess() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var auth = props.auth;

      if (auth.isAdmin || auth.isAdminBasic || auth.isSuperAdmin) {
        return true;
      }
      return false;
    }
  }, {
    key: 'fetchReservationTokenSettings',
    value: function () {
      var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var store, t, res, message, data, settings;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                this.setState({ reservationTokenLoading: true });
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context13.prev = 4;
                _context13.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/settings/reservation_token/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: { 'Content-Type': 'application/json' }
                }));

              case 7:
                res = _context13.sent;
                _context13.next = 15;
                break;

              case 10:
                _context13.prev = 10;
                _context13.t0 = _context13['catch'](4);

                this.setState({ reservationTokenLoading: false });
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));
                return _context13.abrupt('return');

              case 15:
                if (res.ok) {
                  _context13.next = 22;
                  break;
                }

                _context13.next = 18;
                return res.text();

              case 18:
                message = _context13.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                _context13.next = 27;
                break;

              case 22:
                _context13.next = 24;
                return res.json();

              case 24:
                data = _context13.sent;
                settings = {
                  priceMinor: data ? data.priceMinor || 0 : 0,
                  validityDurationDays: data ? data.validityDurationDays || 0 : 0,
                  limitPerOpportunity: data ? data.limitPerOpportunity || 0 : 0,
                  currencyCode: data ? data.currencyCode || 'MYR' : 'MYR'
                };

                this.setState({
                  reservationTokenSettings: settings,
                  oriReservationTokenSettings: _extends({}, settings),
                  token: res.headers.get('X-Csrf-Token') || this.state.token
                });

              case 27:
                this.setState({ reservationTokenLoading: false });

              case 28:
              case 'end':
                return _context13.stop();
            }
          }
        }, _callee13, this, [[4, 10]]);
      }));

      function fetchReservationTokenSettings() {
        return _ref13.apply(this, arguments);
      }

      return fetchReservationTokenSettings;
    }()
  }, {
    key: 'saveReservationTokenSettings',
    value: function () {
      var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var suppressSuccessMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var store, t, reservationTokenSettings, payload, message;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                this.setState({ reservationTokenLoading: true });
                store = this.context.store;
                t = this.props.t;
                reservationTokenSettings = this.state.reservationTokenSettings;
                payload = {
                  priceMinor: Number(reservationTokenSettings.priceMinor) || 0,
                  validityDurationDays: Number(reservationTokenSettings.validityDurationDays) || 0,
                  limitPerOpportunity: Number(reservationTokenSettings.limitPerOpportunity) || 0,
                  currencyCode: reservationTokenSettings.currencyCode || 'MYR'
                };

                if (!(payload.priceMinor < 0 || payload.validityDurationDays < 0 || payload.limitPerOpportunity < 0)) {
                  _context14.next = 9;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ message: t('Values must be 0 or greater', { ns: _translation.TRANSLATION_FILES.translation }) }));
                this.setState({ reservationTokenLoading: false });
                return _context14.abrupt('return');

              case 9:
                _context14.prev = 9;
                _context14.next = 12;
                return store.dispatch((0, _fetchM.fetchM)('/settings/reservation_token/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.state.token
                  },
                  body: JSON.stringify(payload)
                }));

              case 12:
                _context14.next = 25;
                break;

              case 14:
                _context14.prev = 14;
                _context14.t0 = _context14['catch'](9);

                this.setState({ reservationTokenLoading: false });

                if (!(_context14.t0.res && _context14.t0.res.status >= 400 && _context14.t0.res.status < 500)) {
                  _context14.next = 23;
                  break;
                }

                _context14.next = 20;
                return _context14.t0.res.text();

              case 20:
                message = _context14.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context14.abrupt('return');

              case 23:
                store.dispatch((0, _flash.flashErrorMessage)({ message: t('There was an error with your request. Please try again', { ns: _translation.TRANSLATION_FILES.translation }) + '.' }));
                return _context14.abrupt('return');

              case 25:
                this.setState({
                  reservationTokenLoading: false,
                  oriReservationTokenSettings: _extends({}, reservationTokenSettings)
                });
                if (!suppressSuccessMessage) {
                  store.dispatch((0, _flash.flashSuccessMessage)({
                    header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }),
                    message: t('Reservation token settings saved successfully', { ns: _translation.TRANSLATION_FILES.translation })
                  }));
                }

              case 27:
              case 'end':
                return _context14.stop();
            }
          }
        }, _callee14, this, [[9, 14]]);
      }));

      function saveReservationTokenSettings() {
        return _ref14.apply(this, arguments);
      }

      return saveReservationTokenSettings;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this8 = this;

      var _state3 = this.state,
          data = _state3.data,
          oriData = _state3.oriData,
          tempData = _state3.tempData,
          loading = _state3.loading,
          currencySettingLoading = _state3.currencySettingLoading,
          unitCustomFieldSettings = _state3.unitCustomFieldSettings,
          unitCustomSettingsLoading = _state3.unitCustomSettingsLoading;
      var pathname = this.props.location.pathname;
      var _props2 = this.props,
          t = _props2.t,
          i18n = _props2.i18n,
          auth = _props2.auth;

      var displayCountryCode = auth && auth.company && auth.company.countryCode;

      // Update moment locale when language changes
      var localeMap = { en: 'en-gb', vi: 'vi', id: 'id' };
      var momentLocale = localeMap[i18n.language] || 'en-gb';
      if (_momentTimezone2.default.locale() !== momentLocale) _momentTimezone2.default.locale(momentLocale);

      var links = [{ text: 'System Settings', value: '/settings/system_settings/' }, { text: 'Custom Options', value: '/settings/custom_options/' }];
      var renderLabel = function renderLabel(label) {
        return {
          content: label.text,
          icon: 'users'
        };
      };
      var smsTemplatesList = [{ text: t('Default'), value: 'default' }].concat(_toConsumableArray(this.state.smsTemplates));
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          links: this.state.topMenuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
            item: true,
            selectOnBlur: false,
            options: links.map(function (l) {
              return _extends({}, l, {
                text: t(l.text)
              });
            }),
            onChange: this.handleMenu,
            value: pathname
          }) : links.map(function (link, key) {
            return _react2.default.createElement(_semanticUiReact.Menu.Item, {
              key: key,
              name: t(link.text),
              active: pathname === link.value,
              onClick: function onClick(e) {
                return _this8.handleMenu(e, link);
              }
            });
          }),
          rightNav: _react2.default.createElement(_semanticUiReact.Button, {
            color: 'green',
            content: t('Save', { ns: _translation.TRANSLATION_FILES.translation }),
            disabled: this.state.loading || this.checkSaveDisabled(),
            onClick: this.handleSave
          })
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { width: 16 },
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { columns: 'equal', stackable: true, doubling: true },
                _react2.default.createElement(
                  _semanticUiReact.Dimmer,
                  { style: { zIndex: 20 }, active: loading, inverted: true },
                  _react2.default.createElement(
                    _semanticUiReact.Loader,
                    { inline: 'centered' },
                    t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { mobile: 16, tablet: 16, computer: 4 },
                    _react2.default.createElement(
                      _semanticUiReact.Menu,
                      {
                        fluid: true,
                        widths: !this.state.menuIsTab ? 1 : null,
                        tabular: this.state.menuIsTab,
                        vertical: this.state.menuIsVertical
                      },
                      !this.state.menuIsTab ? _react2.default.createElement(_semanticUiReact.Dropdown, {
                        item: true,
                        selectOnBlur: false,
                        options: this.tabs.filter(function (tb) {
                          return tb;
                        }).map(function (tb, k) {
                          var tab = {
                            key: k,
                            text: t(tb.text),
                            name: tb.name,
                            value: tb.value,
                            label: _this8.state.errMessages.some(function (e) {
                              return tb.fields.some(function (f) {
                                return e.key === f;
                              });
                            }) ? {
                              color: 'red',
                              content: '!'
                            } : null
                          };
                          return tab;
                        }),
                        onChange: this.handleChangeTab,
                        value: this.state.currentTab,
                        disabled: this.state.loading
                      }) : this.tabs.map(function (tab, key) {
                        if (tab) {
                          return _react2.default.createElement(
                            _semanticUiReact.Menu.Item,
                            {
                              key: key,
                              name: tab.name,
                              onClick: _this8.handleChangeTab,
                              active: _this8.state.currentTab === tab.name
                            },
                            t(tab.text),
                            _this8.state.errMessages.some(function (e) {
                              return tab.fields && tab.fields.some(function (f) {
                                return e.key === f;
                              });
                            }) ? _react2.default.createElement(_semanticUiReact.Label, { color: 'red', floating: !_this8.state.menuIsVertical, content: '!' }) : null
                          );
                        }
                        return null;
                      })
                    ),
                    _react2.default.createElement(
                      'p',
                      { style: { textAlign: 'center' } },
                      _react2.default.createElement(
                        'i',
                        null,
                        _react2.default.createElement(
                          'b',
                          null,
                          t('Settings Last Updated')
                        ),
                        _react2.default.createElement('br', null),
                        oriData.updatedAt ? _react2.default.createElement(
                          'span',
                          { title: (0, _displayTime.displayMoment)(oriData.updatedAt, displayCountryCode).format('MMMM Do YYYY, h:mm a') },
                          (0, _momentTimezone2.default)(oriData.updatedAt).fromNow()
                        ) : '',
                        oriData.updatedByUserName ? _react2.default.createElement(
                          'span',
                          null,
                          '\xA0- ',
                          _react2.default.createElement(
                            _reactRouter.Link,
                            { to: oriData.updatedByUserAffiliateID ? '/users/' + oriData.updatedByUserAffiliateID + '/' : '' },
                            oriData.updatedByUserName
                          )
                        ) : ''
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { stretched: true, className: this.checkActiveTab('access') },
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Who Can Manage Payment?')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { widths: 'equal' },
                      _react2.default.createElement(
                        _AppForm2.default.Validate,
                        {
                          ref: this.validation.canManagePaymentOptions,
                          onChange: this.handleMultiDropdownToBoolChange
                        },
                        _react2.default.createElement(_semanticUiReact.Dropdown, {
                          options: this.canManagePaymentOptions.map(function (o) {
                            return _extends({}, o, {
                              text: t(o.text, { ns: _translation.TRANSLATION_FILES.constants })
                            });
                          }),
                          fluid: true,
                          multiple: true,
                          name: 'userRoleManagePayment',
                          noResultsMessage: t('No more user roles') + '.',
                          placeholder: t('Select user roles access'),
                          renderLabel: renderLabel,
                          search: true,
                          selection: true,
                          value: tempData.userRoleManagePayment
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Booking Status')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Segment,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.List,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.List.Item,
                          null,
                          _react2.default.createElement(_semanticUiReact.List.Icon, { name: 'user circle' }),
                          _react2.default.createElement(
                            _semanticUiReact.List.Content,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.List.Description,
                              null,
                              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                label: t('Allow staff role to change booking statuses'),
                                checked: data.allowStaffEditBookingStatus,
                                name: 'allowStaffEditBookingStatus',
                                onChange: this.handleCheckBoxChange
                              })
                            ),
                            _react2.default.createElement(
                              _semanticUiReact.List.List,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.List.Item,
                                null,
                                _react2.default.createElement(_semanticUiReact.List.Icon, { name: 'user circle' }),
                                _react2.default.createElement(
                                  _semanticUiReact.List.Content,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.List.Description,
                                    null,
                                    _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                      label: t('Allow staff role to change booking status to cancelled'),
                                      checked: data.allowStaffEditBookingStatusCancel,
                                      disabled: !data.allowStaffEditBookingStatus,
                                      name: 'allowStaffEditBookingStatusCancel',
                                      onChange: this.handleCheckBoxChange
                                    })
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { stretched: true, className: this.checkActiveTab('sms') },
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('SMS Templates')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { mobile: 16, tablet: 16, computer: 16, style: { marginTop: '1em' } },
                      _react2.default.createElement(
                        'div',
                        { className: 'ui form' },
                        _react2.default.createElement(
                          _semanticUiReact.Form.Group,
                          { widths: 'equal' },
                          _react2.default.createElement(_semanticUiReact.Form.Select, {
                            label: t('Consent Pin SMS Template'),
                            options: smsTemplatesList,
                            placeholder: t('Consent Pin SMS Template'),
                            name: 'leadDropSMSTemplate',
                            search: true,
                            selection: true,
                            fluid: true,
                            value: data.leadDropSMSTemplate,
                            noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }),
                            onChange: this.handleChangeSMSTemplate
                          })
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Form.Group,
                          { widths: 'equal' },
                          _react2.default.createElement(_semanticUiReact.Form.Select, {
                            label: t('Loan Enquiry Notification SMS Template'),
                            options: smsTemplatesList,
                            placeholder: t('Loan Enquiry Notification SMS Template'),
                            name: 'leadSuccessSMSTemplate',
                            search: true,
                            selection: true,
                            fluid: true,
                            value: data.leadSuccessSMSTemplate,
                            noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }),
                            onChange: this.handleChangeSMSTemplate
                          })
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { stretched: true, className: this.checkActiveTab('features') },
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Overall Unit Reports')
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'ui form' },
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal', style: { display: 'flex', alignItems: 'center' } },
                        _react2.default.createElement(_semanticUiReact.Form.Select, {
                          label: _react2.default.createElement(
                            'div',
                            { style: { display: 'flex', alignItems: 'center' } },
                            _react2.default.createElement(
                              'span',
                              { style: { marginBottom: '0.3em' } },
                              t('Auto generate overall unit report time', { ns: _translation.TRANSLATION_FILES.translation })
                            ),
                            _react2.default.createElement(_semanticUiReact.Popup, {
                              className: 'srb',
                              content: _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(
                                  'p',
                                  null,
                                  t('Auto-generation can only be triggered once per day. If the report has already been triggered today, any changes you make will take effect the following day.', { ns: _translation.TRANSLATION_FILES.translation })
                                )
                              ),
                              on: 'click',
                              wide: true,
                              positionFixed: true,
                              style: { background: 'white', color: 'black', border: '3.5px solid #22242626', padding: '1em 1.5em' },
                              position: 'bottom center',
                              trigger: _react2.default.createElement(_semanticUiReact.Button, {
                                icon: 'question circle outline',
                                size: 'small',
                                style: {
                                  padding: '0.2em 0.3em',
                                  background: 'none',
                                  marginLeft: '0.2em',
                                  marginBottom: '0.2em',
                                  color: 'rgb(0, 151, 161)'
                                }
                              }),
                              pinned: true,
                              inverted: true,
                              onOpen: function onOpen(e) {
                                e.preventDefault();
                              },
                              onClose: function onClose(e) {
                                e.preventDefault();
                              }
                            })
                          ),
                          placeholder: t('Select auto generate overall unit report time', { ns: _translation.TRANSLATION_FILES.translation }),
                          name: 'generateOverallUnitReportTime',
                          value: data.generateOverallUnitReportTime,
                          onChange: this.handleSelectChange,
                          options: this.getAvailableTimeOptions(),
                          style: { width: '40%' }
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Sharing')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { widths: 'equal' },
                      _react2.default.createElement(
                        _semanticUiReact.Segment,
                        null,
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          label: t('Allow whatsapp and text copy sharing for project unit'),
                          checked: data.allowUnitSocialShare,
                          name: 'allowUnitSocialShare',
                          onChange: this.handleCheckBoxChange
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Unit Holding', { ns: _translation.TRANSLATION_FILES.translation })
                    ),
                    _react2.default.createElement(
                      'p',
                      { className: 'system-settings_description-text' },
                      t('Units on hold will be converted to Delisted status with an additional On Hold flag. The flag will be removed once the unit status is updated manually to Available', { ns: _translation.TRANSLATION_FILES.translation })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { widths: 'equal' },
                      _react2.default.createElement(
                        _semanticUiReact.Segment,
                        null,
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          label: t('Turn on the "Hold Unit" Feature by default for all cancellations', { ns: _translation.TRANSLATION_FILES.translation }),
                          checked: data.defaultHoldDelistUnit,
                          name: 'defaultHoldDelistUnit',
                          onChange: this.handleCheckBoxChange
                        })
                      )
                    ),
                    !currencySettingLoading && data.currencySetting && data && (0, _companies.isForeignCompany)(data.company) && _react2.default.createElement(
                      'div',
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Divider,
                        { style: { marginTop: '4em' }, horizontal: true },
                        t('Currency Abbreviation')
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Segment,
                              null,
                              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                label: t('Enable currency abbreviation (eg: 100K, 1M)'),
                                checked: data.currencySetting.isAbbreviationEnabled,
                                name: 'isAbbreviationEnabled',
                                onChange: this.handleCheckBoxChange
                              })
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Row,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Grid.Column,
                            null,
                            _react2.default.createElement(_AppForm2.default.Input, {
                              label: t('Abbreviation decimal points'),
                              name: 'abbreviationDecimalPoints',
                              value: Number(data.currencySetting.abbreviationDecimalPoints),
                              validation: [_webValidations.required, {
                                validate: _webValidations.numericRange,
                                option: {
                                  min: 0
                                }
                              }],
                              type: 'number',
                              step: '1',
                              onChange: this.handleInputChange
                            })
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Booking Management', { ns: _translation.TRANSLATION_FILES.translation })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'ui form' },
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal' },
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          label: t('Disable Sold Date selection when changing booking status to Sold', { ns: _translation.TRANSLATION_FILES.translation }),
                          checked: data.disableSoldDateSelection,
                          name: 'disableSoldDateSelection',
                          onChange: this.handleCheckBoxChange
                        })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal' },
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          label: t('Disable Sold Date to be editable in Booking Overview', { ns: _translation.TRANSLATION_FILES.translation }),
                          checked: data.disableSoldDateEditing,
                          name: 'disableSoldDateEditing',
                          onChange: this.handleCheckBoxChange
                        })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal' },
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          label: t('Disable Cancelled Date to be editable in Booking Overview', { ns: _translation.TRANSLATION_FILES.translation }),
                          checked: data.disableCancelledDateEditing,
                          name: 'disableCancelledDateEditing',
                          onChange: this.handleCheckBoxChange
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Visibility')
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'ui form' },
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal' },
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          label: t('Hide Tracker tab in Bookings'),
                          checked: data.bookingHideLoanTracker,
                          name: 'bookingHideLoanTracker',
                          onChange: this.handleCheckBoxChange
                        })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal' },
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          label: t('Hide \'First Time Buyer\' question in Bookings'),
                          checked: data.bookingHideFirstTimeBuyer,
                          name: 'bookingHideFirstTimeBuyer',
                          onChange: this.handleCheckBoxChange
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Payment')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { widths: 'equal' },
                      _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                        label: t('Enable Virtual Account for Payment'),
                        checked: data.virtualAccountIsEnabled,
                        name: 'virtualAccountIsEnabled',
                        onChange: this.handleCheckBoxChange
                      })
                    ),
                    _react2.default.createElement(
                      'p',
                      { style: { fontSize: '12px', marginLeft: '2.2em', marginTop: '5px' } },
                      t('Enabling this will add Virtual Account for each unit as one of the payment method for booking payment')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Quotation', { ns: _translation.TRANSLATION_FILES.translation })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { widths: 'equal' },
                      _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                        label: t('Enable Generate Quotation feature'),
                        checked: data.generateQuotationIsEnabled,
                        name: 'generateQuotationIsEnabled',
                        onChange: this.handleCheckBoxChange
                      })
                    ),
                    _react2.default.createElement(
                      'p',
                      { style: { fontSize: '12px', marginLeft: '2.2em', marginTop: '5px' } },
                      t('Enabling this will add Generate Quotation feature within Unit information page')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Notes')
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'ui form' },
                      _react2.default.createElement(_AppForm2.default.Input, {
                        label: t('Notes placeholder for agents', { ns: _translation.TRANSLATION_FILES.translation }),
                        name: 'notesExternalPlaceholder',
                        value: data.notesExternalPlaceholder,
                        onChange: this.handleInputChange,
                        style: { marginTop: '1em' }
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Data Formatting', { ns: _translation.TRANSLATION_FILES.translation })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'ui form' },
                      _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                        label: t('Enable Uppercase Formatting for Purchaser Information in Bookings', { ns: _translation.TRANSLATION_FILES.translation }),
                        checked: data.uppercasePurchaserInfoIsEnabled,
                        name: 'uppercasePurchaserInfoIsEnabled',
                        onChange: this.handleCheckBoxChange
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('FORM TEMPLATE', { ns: _translation.TRANSLATION_FILES.translation })
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'ui form' },
                      _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                        label: t('Enable Form Template in Projects', { ns: _translation.TRANSLATION_FILES.translation }),
                        checked: data.docxTemplaterIsEnabled,
                        name: 'docxTemplaterIsEnabled',
                        onChange: this.handleCheckBoxChange
                      }),
                      _react2.default.createElement(
                        'div',
                        { style: { marginLeft: '2em' } },
                        _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                          label: t('Enable Form Template Debugging Mode', { ns: _translation.TRANSLATION_FILES.translation }),
                          checked: data.docxTemplaterDebuggingIsEnabled,
                          name: 'docxTemplaterDebuggingIsEnabled',
                          onChange: this.handleCheckBoxChange,
                          disabled: !data.docxTemplaterIsEnabled
                        })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Print Form Visibility')
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'ui form' },
                      _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                        label: t('Allow all Business Unit to view newly added Form by default'),
                        checked: data.allowAllBusinessUnitViewNewForm,
                        name: 'allowAllBusinessUnitViewNewForm',
                        onChange: this.handleCheckBoxChange
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { stretched: true, className: this.checkActiveTab('pricing_package') },
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Pricing Package')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Segment,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Button,
                              {
                                onClick: function onClick() {
                                  return _this8.bulkRecalculateUnitPackagePricing();
                                }
                              },
                              _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh' }),
                              t('Recalculate Pricing Package In All Project Units')
                            )
                          )
                        )
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Booking')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Segment,
                            null,
                            _react2.default.createElement(
                              _semanticUiReact.Grid,
                              { verticalAlign: 'middle', className: 'booking-list' },
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Row,
                                { className: 'toolbar' },
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  { width: 16 },
                                  _react2.default.createElement(
                                    _semanticUiReact.Grid,
                                    {
                                      className: 'filters',
                                      columns: 'equal',
                                      textAlign: 'left',
                                      verticalAlign: 'middle'
                                    },
                                    _react2.default.createElement(
                                      _semanticUiReact.Grid.Row,
                                      null,
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { className: 'filter' },
                                        _react2.default.createElement(_Filters.BookingSearchList, {
                                          filterName: 'projectKeyword',
                                          icon: 'find',
                                          isActive: this.state.projectKeyword.length > 0,
                                          loading: this.state.loadingProjectSearch,
                                          noResultsMessage: this.state.noResultsMessage,
                                          onChange: this.handleSearchProject,
                                          onSelect: this.handleSelectProject,
                                          placeholder: t('Find Project'),
                                          results: this.state.findProjectResults,
                                          value: this.state.projectKeyword,
                                          disabled: this.state.loading
                                        })
                                      ),
                                      _react2.default.createElement(
                                        _semanticUiReact.Grid.Column,
                                        { className: 'filter' },
                                        _react2.default.createElement(_Filters.BookingSelectList, {
                                          filterName: 'projectPackagePricingID',
                                          onChange: this.handleSelectPackage,
                                          options: this.state.packagePricingList,
                                          placeholder: t('Select {{title}}', { title: t('Pricing Package') }),
                                          value: this.state.projectPackagePricingID,
                                          disabled: this.state.loading || this.state.packagePricingList.length < 1
                                        })
                                      )
                                    )
                                  )
                                )
                              ),
                              _react2.default.createElement(
                                _semanticUiReact.Grid.Row,
                                { columns: 'equal' },
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Button,
                                    {
                                      onClick: function onClick() {
                                        return _this8.bulkRecalculateUnitBookingPrice();
                                      },
                                      disabled: !this.state.projectID
                                    },
                                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh' }),
                                    t('Recalculate Unit Selling Price In Active Bookings')
                                  )
                                ),
                                _react2.default.createElement(
                                  _semanticUiReact.Grid.Column,
                                  null,
                                  _react2.default.createElement(
                                    _semanticUiReact.Button,
                                    {
                                      onClick: function onClick() {
                                        return _this8.bulkApplyLatestBookingPackagePricing();
                                      },
                                      disabled: !this.state.projectPackagePricingID
                                    },
                                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'refresh' }),
                                    t('Apply latest Pricing Package In Active Bookings')
                                  )
                                )
                              )
                            )
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { stretched: true, className: this.checkActiveTab('unit_field_management') },
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Column,
                      { stretched: true },
                      !unitCustomSettingsLoading ? _react2.default.createElement(
                        _semanticUiReact.Form,
                        null,
                        _react2.default.createElement(_CustomField2.default, {
                          data: unitCustomFieldSettings || [],
                          type: 'unit',
                          onChangeData: this.handleOnChangeCustomFieldData
                        })
                      ) : _react2.default.createElement(
                        _semanticUiReact.Dimmer,
                        {
                          inverted: true, style: { zIndex: 1 },
                          active: true
                        },
                        _react2.default.createElement(
                          _semanticUiReact.Loader,
                          { inline: 'centered' },
                          t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                        )
                      ),
                      _react2.default.createElement(_semanticUiReact.Divider, { horizontal: true, style: { marginTop: '2rem', marginBottom: '2rem' } }),
                      _react2.default.createElement(_DelistReasonsList2.default, {
                        isHeadquarters: this.props.auth.isHeadquarters,
                        isSuperAdmin: this.props.auth.isSuperAdmin,
                        isAdminBasic: this.props.auth.isAdminBasic
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { stretched: true, className: this.checkActiveTab('cooldown') },
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Booking Reservation Cooldown')
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      t('Booking cooldown can be enabled to prevent External Agents from re-booking the unit with a Cancelled or Expired booking for a specified amount of time'),
                      '.'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { mobile: 16, tablet: 16, computer: 16 },
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { widths: 'equal' },
                            _react2.default.createElement(
                              _semanticUiReact.Segment,
                              null,
                              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                toggle: true,
                                label: t(data.unitCooldownIsEnabled ? 'Cooldown Is On' : 'Cooldown Is Off'),
                                name: 'unitCooldownIsEnabled',
                                checked: data.unitCooldownIsEnabled,
                                onChange: this.handleCheckBoxChange
                              })
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { mobile: 16, tablet: 16, computer: 16, style: { marginTop: '1em' } },
                          _react2.default.createElement(
                            'div',
                            { className: 'ui form' },
                            _react2.default.createElement(
                              _semanticUiReact.Form.Group,
                              { widths: 'equal' },
                              _react2.default.createElement(_semanticUiReact.Form.Select, {
                                label: t('Cooldown Minutes (choose or fill in a custom amount)'),
                                options: this.state.cooldownOptions.map(function (c) {
                                  return _extends({}, c, { text: t(c.text, { ns: _translation.TRANSLATION_FILES.translation }) });
                                }),
                                placeholder: t('Cooldown Minutes'),
                                name: 'unitCooldownTimeMinutes',
                                search: true,
                                selection: true,
                                fluid: true,
                                allowAdditions: true,
                                onAddItem: this.handleAdditionCooldown,
                                noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }),
                                value: data.unitCooldownTimeMinutes || '',
                                onChange: this.handleChangeCooldown,
                                disabled: !data.unitCooldownIsEnabled
                              })
                            )
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { stretched: true, className: this.checkActiveTab('auto_release') },
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Auto-Release')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { mobile: 16, tablet: 3, computer: 3 },
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { className: 'form-label' },
                            _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Unit auto release') })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { className: 'form-mb1' },
                            _react2.default.createElement(
                              _semanticUiReact.Form.Field,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Segment,
                                null,
                                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                  toggle: true,
                                  label: t(data.arBookingExpIsEnabled ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                                  name: 'arBookingExpIsEnabled',
                                  checked: data.arBookingExpIsEnabled,
                                  onChange: this.handleCheckBoxChange
                                })
                              )
                            )
                          )
                        ),
                        _react2.default.createElement(_semanticUiReact.Grid.Column, { mobile: 16, tablet: 13, computer: 13 })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                        label: t('Apply auto release settings to all project'),
                        checked: this.state.applyArToAllProjects,
                        name: 'applyArToAllProjects',
                        onChange: this.handleRequirementSettings,
                        style: { fontWeight: 'bold' },
                        disabled: !data.arBookingExpIsEnabled
                      })
                    ),
                    _react2.default.createElement(_AppForm2.default.Input, {
                      label: t('Auto release timer (hours)'),
                      name: 'arBookingExpMoreThanMinutes',
                      value: data ? Number(data.arBookingExpMoreThanMinutes) : 0,
                      validation: [_webValidations.required, {
                        validate: _webValidations.numericRange,
                        option: {
                          min: !this.state.applyArToAllProjects ? 0 : 0.1
                        }
                      }],
                      step: '0.1',
                      onChange: this.handleInputChange,
                      ref: this.validation.arBookingExpMoreThanMinutes,
                      type: 'number',
                      disabled: !data.arBookingExpIsEnabled || !this.state.applyArToAllProjects
                    }),
                    !(0, _vietnam.isVietnamCompany)(this.props.auth) && _react2.default.createElement(
                      _semanticUiReact.Grid,
                      { style: { marginTop: '0.5em' } },
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { mobile: 16, tablet: 4, computer: 3 },
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { className: 'form-label' },
                            _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Upload buyer\'s IC', { ns: _translation.TRANSLATION_FILES.translation }) })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { className: 'form-mb1' },
                            _react2.default.createElement(
                              _semanticUiReact.Form.Field,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Segment,
                                null,
                                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                  toggle: true,
                                  label: t(data.arBookingExpNricPicIsEnabled ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                                  name: 'arBookingExpNricPicIsEnabled',
                                  checked: data.arBookingExpNricPicIsEnabled,
                                  onChange: this.handleCheckBoxChange,
                                  disabled: !data.arBookingExpIsEnabled || !this.state.applyArToAllProjects
                                })
                              )
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { mobile: 16, tablet: 4, computer: 3 },
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { className: 'form-label' },
                            _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Additional buyer\'s IC', { ns: _translation.TRANSLATION_FILES.translation }) })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { className: 'form-mb1' },
                            _react2.default.createElement(
                              _semanticUiReact.Form.Field,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Segment,
                                null,
                                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                  toggle: true,
                                  label: t(data.arBookingExpAllNricPicsIsEnabled ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                                  name: 'arBookingExpAllNricPicsIsEnabled',
                                  checked: data.arBookingExpAllNricPicsIsEnabled,
                                  onChange: this.handleCheckBoxChange,
                                  disabled: !data.arBookingExpIsEnabled || !this.state.applyArToAllProjects
                                })
                              )
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { mobile: 16, tablet: 4, computer: 3 },
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { className: 'form-label' },
                            _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Booking fee payment') })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { className: 'form-mb1' },
                            _react2.default.createElement(
                              _semanticUiReact.Form.Field,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Segment,
                                null,
                                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                  toggle: true,
                                  label: t(data.arBookingExpUnpaidIsEnabled ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                                  name: 'arBookingExpUnpaidIsEnabled',
                                  checked: data.arBookingExpUnpaidIsEnabled,
                                  onChange: this.handleCheckBoxChange,
                                  disabled: !data.arBookingExpIsEnabled || !this.state.applyArToAllProjects
                                })
                              )
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { mobile: 16, tablet: 4, computer: 3 },
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { className: 'form-label' },
                            _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Mortgage') })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { className: 'form-mb1' },
                            _react2.default.createElement(
                              _semanticUiReact.Form.Field,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Segment,
                                null,
                                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                  toggle: true,
                                  label: t(data.arBookingExpMortgageEnabled ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                                  name: 'arBookingExpMortgageEnabled',
                                  checked: data.arBookingExpMortgageEnabled,
                                  onChange: this.handleCheckBoxChange,
                                  disabled: !data.arBookingExpIsEnabled || !this.state.applyArToAllProjects
                                })
                              )
                            )
                          )
                        ),
                        _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'computer', computer: 4 })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                        label: t('Apply time limit settings to all project'),
                        checked: this.state.applyAgingArToAllProjects,
                        name: 'applyAgingArToAllProjects',
                        onChange: this.handleAgingRequirementSettings,
                        style: { fontWeight: 'bold' },
                        disabled: !data.arBookingExpIsEnabled
                      })
                    ),
                    _react2.default.createElement(_AppForm2.default.Input, {
                      label: t('Time Limit timer (hours)'),
                      name: 'arAgingBookingExpMoreThanMinutes',
                      value: data ? Number(data.arAgingBookingExpMoreThanMinutes) : 0,
                      validation: [_webValidations.required, {
                        validate: _webValidations.numericRange,
                        option: {
                          min: !this.state.applyAgingArToAllProjects ? 0 : 0.1
                        }
                      }],
                      step: '0.1',
                      onChange: this.handleInputChange,
                      ref: this.validation.arAgingBookingExpMoreThanMinutes,
                      type: 'number',
                      style: { marginTop: '1em' },
                      disabled: !data.arBookingExpIsEnabled || !this.state.applyAgingArToAllProjects
                    }),
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      { style: { marginTop: '0.5em' } },
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { mobile: 16, tablet: 4, computer: 3 },
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { className: 'form-label' },
                            _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Reserved', { ns: _translation.TRANSLATION_FILES.constants }) })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { className: 'form-mb1' },
                            _react2.default.createElement(
                              _semanticUiReact.Form.Field,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Segment,
                                null,
                                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                  toggle: true,
                                  label: t(data.arAgingBookingExpReservedIsEnabled ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                                  name: 'arAgingBookingExpReservedIsEnabled',
                                  checked: data.arAgingBookingExpReservedIsEnabled,
                                  onChange: this.handleCheckBoxChange,
                                  disabled: !data.arBookingExpIsEnabled || !this.state.applyAgingArToAllProjects
                                })
                              )
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { mobile: 16, tablet: 4, computer: 3 },
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { className: 'form-label' },
                            _react2.default.createElement(_semanticUiReact.Form.Field, { label: t('Booked', { ns: _translation.TRANSLATION_FILES.constants }) })
                          ),
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { className: 'form-mb1' },
                            _react2.default.createElement(
                              _semanticUiReact.Form.Field,
                              null,
                              _react2.default.createElement(
                                _semanticUiReact.Segment,
                                null,
                                _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                  toggle: true,
                                  label: t(data.arAgingBookingExpBookedIsEnabled ? 'On' : 'Off', { ns: _translation.TRANSLATION_FILES.translation }),
                                  name: 'arAgingBookingExpBookedIsEnabled',
                                  checked: data.arAgingBookingExpBookedIsEnabled,
                                  onChange: this.handleCheckBoxChange,
                                  disabled: !data.arBookingExpIsEnabled || !this.state.applyAgingArToAllProjects
                                })
                              )
                            )
                          )
                        ),
                        _react2.default.createElement(_semanticUiReact.Grid.Column, { only: 'tablet computer', tablet: 8, computer: 10 })
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { stretched: true, className: this.checkActiveTab('cache') },
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Storey Plan Cache')
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      t('Improves storey plan page loading time (does not affect realtime status updates)'),
                      '.'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      null,
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { mobile: 16, tablet: 16, computer: 16 },
                          _react2.default.createElement(
                            _semanticUiReact.Form.Group,
                            { widths: 'equal' },
                            _react2.default.createElement(
                              _semanticUiReact.Segment,
                              null,
                              _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                                toggle: true,
                                label: t(data.salesChartCacheIsEnabled ? 'Cache Is On' : 'Cache Is Off'),
                                name: 'salesChartCacheIsEnabled',
                                checked: data.salesChartCacheIsEnabled,
                                onChange: this.handleCheckBoxChange
                              })
                            )
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { mobile: 16, tablet: 16, computer: 16, style: { marginTop: '1em' } },
                          _react2.default.createElement(
                            'div',
                            { className: 'ui form' },
                            _react2.default.createElement(
                              _semanticUiReact.Form.Group,
                              { widths: 'equal' },
                              _react2.default.createElement(_semanticUiReact.Form.Select, {
                                label: t('Cache Minutes (choose or fill in a custom amount)'),
                                options: this.state.cacheOptions.map(function (c) {
                                  return _extends({}, c, { text: t(c.text, { ns: _translation.TRANSLATION_FILES.translation }) });
                                }),
                                placeholder: t('Cache Minutes'),
                                name: 'salesChartCacheMinutes',
                                search: true,
                                selection: true,
                                fluid: true,
                                allowAdditions: true,
                                onAddItem: this.handleAdditionCache,
                                value: data.salesChartCacheMinutes || '',
                                noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }),
                                onChange: this.handleChangeCache,
                                disabled: !data.salesChartCacheIsEnabled
                              })
                            )
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { stretched: true, className: this.checkActiveTab('project') },
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Region')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { widths: 'equal' },
                      _react2.default.createElement(_semanticUiReact.Dropdown, {
                        options: this.state.regionOptions,
                        fluid: true,
                        multiple: true,
                        name: 'regions',
                        placeholder: t('Enter / select region'),
                        search: true,
                        selection: true,
                        value: data.regions || [],
                        allowAdditions: true,
                        onAddItem: this.handleAdditionRegion,
                        onChange: function onChange(e, _ref15) {
                          var value = _ref15.value;
                          return _this8.handleRegionsChange(e, { value: value });
                        },
                        noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }) + '.'
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Township')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { widths: 'equal' },
                      _react2.default.createElement(_semanticUiReact.Dropdown, {
                        options: this.state.townshipOptions,
                        fluid: true,
                        multiple: true,
                        name: 'townships',
                        placeholder: t('Enter / select township'),
                        search: true,
                        selection: true,
                        value: data.townships || [],
                        allowAdditions: true,
                        onAddItem: this.handleAdditionTownship,
                        onChange: function onChange(e, _ref16) {
                          var value = _ref16.value;
                          return _this8.handleTownshipsChange(e, { value: value });
                        },
                        noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }) + '.'
                      })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Agency Allocation', { ns: _translation.TRANSLATION_FILES.translation })
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { widths: 'equal' },
                      _react2.default.createElement(_semanticUiReact.Form.Select, {
                        label: t('Agency Allocation Logic', { ns: _translation.TRANSLATION_FILES.translation }),
                        name: 'agencyAllocationAllocateAll',
                        options: [{ key: 'allocateToAll', text: t('Allocate to all', { ns: _translation.TRANSLATION_FILES.translation }), value: true }, { key: 'allocateToNone', text: t('Allocate to none', { ns: _translation.TRANSLATION_FILES.translation }), value: false }],
                        value: Boolean(data.agencyAllocationAllocateAll),
                        onChange: this.handleSelectChange,
                        selection: true,
                        fluid: true
                      })
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { stretched: true, className: this.checkActiveTab('address') },
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Address format')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      {
                        columns: 'equal',
                        stackable: true,
                        doubling: true,
                        verticalAlign: 'middle',
                        style: { marginBottom: 0 }
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          null,
                          _react2.default.createElement(
                            'h4',
                            null,
                            t('Format')
                          )
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { textAlign: 'right' },
                          _react2.default.createElement(_semanticUiReact.Button, {
                            content: t('Preview', { ns: _translation.TRANSLATION_FILES.translation }),
                            disabled: this.state.loading,
                            onClick: this.handlePreview
                          })
                        )
                      )
                    ),
                    _react2.default.createElement(_TextArea2.default, {
                      validation: [_webValidations.required],
                      ref: this.validation.addressFormatTemplate,
                      onChange: this.handleInputChange,
                      validateLabel: t('Address format'),
                      autoComplete: 'off',
                      name: 'addressFormatTemplate',
                      value: data ? data.addressFormatTemplate : '',
                      rows: 1,
                      style: { width: '100%', minHeight: '6em', height: '6em' }
                    }),
                    this.state.previewFormat ? _react2.default.createElement(
                      _semanticUiReact.Segment,
                      null,
                      _react2.default.createElement(
                        'h4',
                        null,
                        t('Preview', { ns: _translation.TRANSLATION_FILES.translation })
                      ),
                      _react2.default.createElement(
                        'div',
                        { style: { whiteSpace: 'break-spaces' } },
                        this.state.previewFormat
                      )
                    ) : null,
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Address settings')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Message,
                      { warning: true },
                      _react2.default.createElement(
                        _semanticUiReact.Message.Header,
                        null,
                        t('Please note').toUpperCase()
                      ),
                      _react2.default.createElement(
                        'p',
                        null,
                        t('Any changes to the labels will cause misrepresentation of data which have already been keyed in. Please proceed at your own risk.')
                      )
                    ),
                    _react2.default.createElement(_AddressSettingList2.default, {
                      ref: function ref(_ref17) {
                        _this8.addressSettingList = _ref17;
                      },
                      onOriChange: this.handleAddressSettingOriChange,
                      onChange: this.handleAddressSettingChange,
                      loading: this.state.loading
                    }),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Activity Logs')
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Segment,
                      null,
                      _react2.default.createElement(_AddressSettingActivities2.default, {
                        data: this.state.addressSettingActivities || [],
                        hasAccess: true,
                        loading: this.state.loading || this.state.activitiesLoading
                      }),
                      _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          { style: { textAlign: 'center' } },
                          this.state.addressSettingActivities ? _react2.default.createElement(_semanticUiReact.Button, {
                            as: _reactRouter.Link,
                            to: '/settings/address_settings/activities/',
                            content: t('View More', { ns: _translation.TRANSLATION_FILES.translation })
                          }) : null
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { stretched: true, className: this.checkActiveTab('source_of_financing') },
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Sources of Financing', { ns: _translation.TRANSLATION_FILES.screens })
                    ),
                    _react2.default.createElement(_FinanceSourceList2.default, {
                      ref: function ref(_ref18) {
                        _this8.financeSourceList = _ref18;
                      },
                      onOriChange: this.handleFinanceSourcesOriChange,
                      onChange: this.handleFinanceSourcesChange,
                      loading: this.state.loading,
                      isForeignCompany: (0, _companies.isForeignCompany)(data.company)
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { stretched: true, className: this.checkActiveTab('reservation_token') },
                    _react2.default.createElement(
                      _semanticUiReact.Dimmer,
                      { active: this.state.reservationTokenLoading, inverted: true },
                      _react2.default.createElement(
                        _semanticUiReact.Loader,
                        { inline: 'centered' },
                        t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Divider,
                      { horizontal: true },
                      t('Reservation Token Settings')
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: 'ui form' },
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal' },
                        _react2.default.createElement(_semanticUiReact.Form.Input, {
                          label: t('Price Minor', { ns: _translation.TRANSLATION_FILES.translation }),
                          name: 'priceMinor',
                          type: 'number',
                          step: '1',
                          value: this.state.reservationTokenSettings.priceMinor,
                          onChange: this.handleReservationTokenInputChange,
                          validation: [_webValidations.required, {
                            validate: _webValidations.numericRange,
                            option: {
                              min: 1
                            }
                          }]
                        })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal' },
                        _react2.default.createElement(_semanticUiReact.Form.Input, {
                          label: t('Validity Duration (Days)'),
                          name: 'validityDurationDays',
                          type: 'number',
                          min: '0',
                          step: '1',
                          value: this.state.reservationTokenSettings.validityDurationDays,
                          onChange: this.handleReservationTokenInputChange
                        })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal' },
                        _react2.default.createElement(_semanticUiReact.Form.Input, {
                          label: t('Limit Per Opportunity'),
                          name: 'limitPerOpportunity',
                          type: 'number',
                          min: '0',
                          step: '1',
                          value: this.state.reservationTokenSettings.limitPerOpportunity,
                          onChange: this.handleReservationTokenInputChange
                        })
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Form.Group,
                        { widths: 'equal' },
                        _react2.default.createElement(_semanticUiReact.Form.Select, {
                          label: t('Currency'),
                          name: 'currencyCode',
                          options: [{ key: 'MYR', text: 'MYR', value: 'MYR' }, { key: 'IDR', text: 'IDR', value: 'IDR' }, { key: 'VND', text: 'VND', value: 'VND' }],
                          noResultsMessage: t('No results found', { ns: _translation.TRANSLATION_FILES.translation }),
                          value: this.state.reservationTokenSettings.currencyCode,
                          onChange: function onChange(e, _ref19) {
                            var name = _ref19.name,
                                value = _ref19.value;
                            return _this8.handleReservationTokenInputChange(e, { name: name, value: value });
                          }
                        })
                      )
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);

  return SystemSettings;
}(_react.Component);

SystemSettings.contextTypes = {
  store: _propTypes2.default.object
};
SystemSettings.propTypes = {
  appConfig: _propTypes2.default.shape({
    data: _propTypes2.default.shape({
      companyID: _propTypes2.default.int,
      lawyerIsEnabled: _propTypes2.default.bool
    })
  }),
  auth: _propTypes2.default.shape({
    company: _propTypes2.default.object,
    isAdmin: _propTypes2.default.bool,
    isAdminCommunity: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool
  }),
  location: _propTypes2.default.shape({
    query: _propTypes2.default.object,
    search: _propTypes2.default.string,
    pathname: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
SystemSettings.defaultTempData = {
  userRoleManagePayment: ['hq']
};
SystemSettings.defaultData = {
  // access by role
  canManagePaymentSupervisor: false,
  canManagePaymentSalesManager: false,
  canManagePaymentSalesAdmin: false,

  // access by function
  allowStaffEditBookingStatus: true,
  allowStaffEditBookingStatusCancel: true,

  // features
  allowUnitSocialShare: true,
  disableSoldDateEditing: false,
  disableSoldDateSelection: false,
  disableCancelledDateEditing: false,

  // auto-release
  arBookingExpUnpaidIsEnabled: false,
  arBookingExpNricPicIsEnabled: false,
  arBookingExpAllNricPicsIsEnabled: false,
  arBookingExpMortgageEnabled: false,
  arBookingExpMoreThanMinutes: '0',

  // auto-release for aging bookings
  arAgingBookingExpReservedIsEnabled: false,
  arAgingBookingExpBookedIsEnabled: false,
  arAgingBookingExpMoreThanMinutes: '0',

  // cooldown
  unitCooldownIsEnabled: false,
  unitCooldownTimeMinutes: 0,

  // project
  regions: [],
  townships: [],
  agencyAllocationAllocateAll: true,

  // address
  addressFormatTemplate: '',

  // unit custom field settings
  projectUnitCustomFieldSettings: [],

  // currency settings
  currencySetting: {
    isAbbreviationEnabled: false,
    abbreviationDecimalPoints: 2
  },

  // sms templates
  leadDropSMSTemplate: 'default',
  leadSuccessSMSTemplate: 'default',

  // notes settings
  notesExternalPlaceholder: '',

  // data formatting
  uppercasePurchaserInfoIsEnabled: false,

  // docx templater setting
  docxTemplaterIsEnabled: false,

  // docx templater debugging setting
  docxTemplaterDebuggingIsEnabled: false,

  // print form visibility
  allowAllBusinessUnitViewNewForm: false
};

SystemSettings.mapStateToProps = function (state) {
  return {
    auth: state.auth,
    appConfig: state.appConfig
  };
};

SystemSettings.getPropsToState = function (props) {
  var windowWidth = window.innerWidth;
  var loadingMessage = props.t('Loading', { ns: _translation.TRANSLATION_FILES.translation }) + '...';
  var noResultsMessage = loadingMessage;
  return {
    topMenuIsTab: windowWidth <= 590,
    menuIsTab: windowWidth >= 991,
    menuIsVertical: windowWidth >= 991,
    noResultsMessage: noResultsMessage
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this9 = this;

  this.getReleaseRequirementSettings = function (data) {
    if (data) {
      if (data.arBookingExpUnpaidIsEnabled || data.arBookingExpNricPicIsEnabled || data.arBookingExpAllNricPicsIsEnabled || data.arBookingExpMortgageEnabled || data.arBookingExpMoreThanMinutes && data.arBookingExpMoreThanMinutes !== '' && data.arBookingExpMoreThanMinutes !== '0') {
        _this9.setState({ applyArToAllProjects: true });
        return true;
      }
    }
    return false;
  };

  this.getAgingReleaseRequirementSettings = function (data) {
    if (data) {
      if (data.arAgingBookingExpReservedIsEnabled || data.arAgingBookingExpBookedIsEnabled || data.arAgingBookingExpMoreThanMinutes !== '' && data.arAgingBookingExpMoreThanMinutes !== '0') {
        _this9.setState({ applyAgingArToAllProjects: true });
        return true;
      }
    }
    return false;
  };

  this.editImageSrc = function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    var newData = [];
    data.forEach(function (d) {
      var editData = {};
      editData.value = d.id;
      editData.text = d.shortName;
      var editImage = {};
      editData.image = editImage;
      editData.image.avatar = true;
      if (d.pictureKey !== '') {
        editData.image.src = (0, _url.AWSUrl)(_this9.props.appConfig, d.pictureKey + '010.jpg');
      } else {
        editData.image.src = '/assets/images/placeholder_x100.jpg';
      }
      newData.push(editData);
    });
    return newData;
  };

  this.editPackagePricingData = function (data) {
    if (data) {
      var enabledData = [];
      var disabledData = [];
      data.forEach(function (d) {
        var editData = {};
        editData.value = d.id;
        editData.text = d.name;
        if (d.isEnabled) {
          enabledData.push(editData);
        } else {
          disabledData.push(editData);
        }
      });
      var newData = [];
      if (enabledData.length > 0) {
        newData.push({ header: true, text: 'Enabled' });
        newData.push.apply(newData, enabledData);
      }
      if (disabledData.length > 0) {
        newData.push({ header: true, text: 'Disabled' });
        newData.push.apply(newData, disabledData);
      }
      return newData;
    }
    return [];
  };

  this.handleSearchProject = function (projectKeyword) {
    var t = _this9.props.t;

    clearTimeout(_this9.setTimer);
    // always reset results to null before finding
    var findProjectResults = [];
    var noResultsMessage = t('Loading', { ns: _translation.TRANSLATION_FILES.translation }) + '...';
    _this9.setState({ findProjectResults: findProjectResults, noResultsMessage: noResultsMessage, projectKeyword: projectKeyword }, function () {
      if (projectKeyword !== '') {
        _this9.setTimer = setTimeout(function () {
          _this9.searchProjects(projectKeyword);
        }, 500);
      }
    });
  };

  this.handleSelectProject = function (project) {
    _this9.setState({
      projectID: project.key,
      projectKeyword: project.title,
      projectPackagePricingID: ''
    }, function () {
      _this9.fetchPackagePricings();
    });
  };

  this.handleSelectPackage = function (projectPackagePricingID) {
    _this9.setState({ projectPackagePricingID: projectPackagePricingID });
  };

  this.checkSaveDisabled = function () {
    var _state4 = _this9.state,
        data = _state4.data,
        oriData = _state4.oriData,
        addressSettings = _state4.addressSettings,
        oriAddressSettings = _state4.oriAddressSettings,
        unitCustomFieldSettings = _state4.unitCustomFieldSettings,
        oriUnitCustomFieldSettings = _state4.oriUnitCustomFieldSettings,
        financeSources = _state4.financeSources,
        oriFinanceSources = _state4.oriFinanceSources,
        reservationTokenSettings = _state4.reservationTokenSettings,
        oriReservationTokenSettings = _state4.oriReservationTokenSettings;

    if (JSON.stringify(data) !== JSON.stringify(oriData) || JSON.stringify(addressSettings) !== JSON.stringify(oriAddressSettings) || JSON.stringify(unitCustomFieldSettings) !== JSON.stringify(oriUnitCustomFieldSettings) || JSON.stringify(financeSources) !== JSON.stringify(oriFinanceSources) || JSON.stringify(reservationTokenSettings) !== JSON.stringify(oriReservationTokenSettings)) {
      return false;
    }
    return true;
  };

  this.prepareTempData = function (data) {
    var tempData = (0, _clone2.default)(SystemSettings.defaultTempData);
    if (data.canManagePaymentSupervisor) {
      tempData.userRoleManagePayment.push('canManagePaymentSupervisor');
    }
    if (data.canManagePaymentSalesManager) {
      tempData.userRoleManagePayment.push('canManagePaymentSalesManager');
    }
    if (data.canManagePaymentSalesAdmin) {
      tempData.userRoleManagePayment.push('canManagePaymentSalesAdmin');
    }
    return tempData;
  };

  this.handleSave = function (e) {
    if (e) e.preventDefault();
    var _state5 = _this9.state,
        data = _state5.data,
        addressSettings = _state5.addressSettings,
        reservationTokenSettings = _state5.reservationTokenSettings,
        oriReservationTokenSettings = _state5.oriReservationTokenSettings;

    _AppForm2.default.validate(_this9.validation, data).then(function (validations) {
      _this9.setState({
        errMessages: validations.filter(function (v) {
          return !v.isValid;
        })
      });
      _this9.updateSystemSettings(validations, data, addressSettings);
      if (_this9.canAccessReservationTokenSettings() && JSON.stringify(reservationTokenSettings) !== JSON.stringify(oriReservationTokenSettings)) {
        _this9.saveReservationTokenSettings(true);
      }
    });
  };

  this.handleChangeTab = function (e, _ref20) {
    var name = _ref20.name,
        value = _ref20.value;

    var currentTab = name || value;
    _this9.setState({ currentTab: currentTab });
  };

  this.handleResize = function () {
    var state = {};
    var topMenuIsTab = window.innerWidth <= 590;
    if (topMenuIsTab !== _this9.state.topMenuIsTab) {
      state.topMenuIsTab = topMenuIsTab;
    }
    var menuIsTab = window.innerWidth >= 991;
    if (menuIsTab !== _this9.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    var menuIsVertical = window.innerWidth >= 991;
    if (menuIsVertical !== _this9.state.menuIsVertical) {
      state.menuIsVertical = menuIsVertical;
    }
    _this9.setState(_extends({}, state));
  };

  this.handleMenu = function (e, _ref21) {
    var value = _ref21.value;
    var store = _this9.context.store;

    store.dispatch((0, _reactRouterRedux.replace)(value));
  };

  this.handleCheckBoxChange = function (event, d) {
    var data = _this9.state.data;

    data[d.name] = !data[d.name];
    // custom value settings
    if (d.name === 'allowStaffEditBookingStatus') {
      data.allowStaffEditBookingStatusCancel = d.checked;
    }
    if (d.name === 'arBookingExpIsEnabled') {
      data.arBookingExpMoreThanMinutes = '0';
      data.arBookingExpNricPicIsEnabled = false;
      data.arBookingExpAllNricPicsIsEnabled = false;
      data.arBookingExpUnpaidIsEnabled = false;
      data.arBookingExpMortgageEnabled = false;
      data.arAgingBookingExpMoreThanMinutes = '0';
      data.arAgingBookingExpReservedIsEnabled = false;
      data.arAgingBookingExpBookedIsEnabled = false;
      _this9.setState({ applyArToAllProjects: false, applyAgingArToAllProjects: false });
    }
    if (d.name === 'isAbbreviationEnabled') {
      data.currencySetting.isAbbreviationEnabled = d.checked;
    }
    if (d.name === 'docxTemplaterIsEnabled') {
      if (!d.checked) data.docxTemplaterDebuggingIsEnabled = false;
    }
    _this9.setState({ data: data });
  };

  this.handleInputChange = function (event, _ref22) {
    var name = _ref22.name,
        value = _ref22.value;
    var data = _this9.state.data;

    data[name] = value;
    if (data[name] === 'arBookingExpMoreThanMinutes' || data[name] === 'arAgingBookingExpMoreThanMinutes') {
      if (value === '') {
        data[name] = '0';
      } else {
        data[name] = value.toString();
      }
    }
    if (name === 'abbreviationDecimalPoints') {
      data.currencySetting.abbreviationDecimalPoints = value;
    }
    _this9.setState({ data: data });
  };

  this.handleSelectChange = function (event, _ref23) {
    var name = _ref23.name,
        value = _ref23.value;
    var data = _this9.state.data;

    data[name] = value;
    _this9.setState({ data: data });
  };

  this.handleMultiDropdownToBoolChange = function (e, d) {
    var state = _this9.state;
    var value = d.value || [];
    d.options.forEach(function (o) {
      if (o.disabled && !value.includes(o.value)) value.push(o.value);
    });
    state.tempData[d.name] = value;
    state.data = (0, _clone2.default)(_extends({}, state.oriData, {
      canManagePaymentSupervisor: false,
      canManagePaymentSalesManager: false,
      canManagePaymentSalesAdmin: false
    }));
    d.options.forEach(function (o) {
      d.value.forEach(function (v) {
        if (o.value === v) {
          if (!o.disabled) state.data[v] = true;
        }
      });
    });
    _this9.setState(_extends({}, state));
  };

  this.handleOnChangeCustomFieldData = function (d) {
    _this9.setState({ unitCustomFieldSettings: d });
  };

  this.handleRequirementSettings = function (e) {
    var _state6 = _this9.state,
        data = _state6.data,
        applyArToAllProjects = _state6.applyArToAllProjects;

    e.preventDefault();

    var applyAllProjectsState = !applyArToAllProjects;

    if (!applyAllProjectsState) {
      data.arBookingExpMoreThanMinutes = '0';
      data.arBookingExpNricPicIsEnabled = false;
      data.arBookingExpAllNricPicsIsEnabled = false;
      data.arBookingExpUnpaidIsEnabled = false;
      data.arBookingExpMortgageEnabled = false;

      _this9.setState({ data: data });
    }
    _this9.setState({ applyArToAllProjects: applyAllProjectsState });
  };

  this.handleAgingRequirementSettings = function (e) {
    var _state7 = _this9.state,
        data = _state7.data,
        applyAgingArToAllProjects = _state7.applyAgingArToAllProjects;

    e.preventDefault();

    var applyAllProjectsState = !applyAgingArToAllProjects;

    if (!applyAllProjectsState) {
      data.arAgingBookingExpMoreThanMinutes = '0';
      data.arAgingBookingExpReservedIsEnabled = false;
      data.arAgingBookingExpBookedIsEnabled = false;

      _this9.setState({ data: data });
    }
    _this9.setState({ applyAgingArToAllProjects: applyAllProjectsState });
  };

  this.handleRegionsChange = function (e, _ref24) {
    var value = _ref24.value;
    var data = _this9.state.data;

    data.regions = value;
    _this9.setState({ data: data });
  };

  this.handleAdditionRegion = function (e, _ref25) {
    var value = _ref25.value;

    if (value) {
      _this9.setState({
        regionOptions: [{ text: value, value: value }].concat(_toConsumableArray(_this9.state.regionOptions))
      });
    }
  };

  this.handleTownshipsChange = function (e, _ref26) {
    var value = _ref26.value;
    var data = _this9.state.data;

    data.townships = value;
    _this9.setState({ data: data });
  };

  this.handleAdditionTownship = function (e, _ref27) {
    var value = _ref27.value;

    if (value) {
      _this9.setState({
        townshipOptions: [{ text: value, value: value }].concat(_toConsumableArray(_this9.state.townshipOptions))
      });
    }
  };

  this.handleRecalculateUnitPackagePricing = function (e) {
    e.preventDefault();
    _this9.bulkRecalculateUnitPackagePricing();
  };

  this.handleAdditionCooldown = function (e, _ref28) {
    var value = _ref28.value;

    var numberVal = value.replace(/\D/g, '').substring(0, 9);
    if (numberVal) {
      var data = _this9.state.data;
      var cooldownOptions = _this9.state.cooldownOptions;

      var exists = _this9.state.cooldownOptions.findIndex(function (co) {
        return co.value === numberVal;
      });
      if (exists === -1) {
        cooldownOptions = [{ key: numberVal, text: numberVal, value: numberVal }].concat(_toConsumableArray(_this9.state.cooldownOptions));
      }
      data.unitCooldownTimeMinutes = numberVal;
      _this9.setState({
        cooldownOptions: cooldownOptions,
        data: data
      });
    }
  };

  this.handleChangeCooldown = function (e, _ref29) {
    var value = _ref29.value;
    var data = _this9.state.data;

    data.unitCooldownTimeMinutes = value;
    _this9.setState({ data: data });
  };

  this.handleChangeSMSTemplate = function (e, _ref30) {
    var name = _ref30.name,
        value = _ref30.value;
    var data = _this9.state.data;

    data[name] = value;
    _this9.setState({ data: data });
  };

  this.handleAdditionCache = function (e, _ref31) {
    var value = _ref31.value;

    var numberVal = value.replace(/\D/g, '').substring(0, 9);
    if (numberVal) {
      var data = _this9.state.data;
      var cacheOptions = _this9.state.cacheOptions;

      var exists = _this9.state.cacheOptions.findIndex(function (co) {
        return co.value === numberVal;
      });
      if (exists === -1) {
        cacheOptions = [{ key: numberVal, text: numberVal, value: numberVal }].concat(_toConsumableArray(_this9.state.cacheOptions));
      }
      data.salesChartCacheMinutes = numberVal;
      _this9.setState({
        cacheOptions: cacheOptions,
        data: data
      });
    }
  };

  this.handleChangeCache = function (e, _ref32) {
    var value = _ref32.value;
    var data = _this9.state.data;

    data.salesChartCacheMinutes = value;
    _this9.setState({ data: data });
  };

  this.handlePreview = function (e) {
    if (e) e.preventDefault();
    var _state8 = _this9.state,
        data = _state8.data,
        addressSettings = _state8.addressSettings;

    _AppForm2.default.validate(_this9.validation, data).then(function (validations) {
      _this9.setState({
        errMessages: validations.filter(function (v) {
          return !v.isValid;
        })
      });

      _this9.previewAddressFormat(validations, data, addressSettings);
    });
  };

  this.handleAddressSettingChange = function (addressSettings) {
    _this9.setState({
      addressSettings: addressSettings
    });
  };

  this.handleAddressSettingOriChange = function (addressSettings) {
    _this9.setState({
      addressSettings: addressSettings,
      oriAddressSettings: (0, _clone2.default)(addressSettings)
    });
  };

  this.handleFinanceSourcesChange = function (financeSources) {
    _this9.setState({
      financeSources: financeSources
    });
  };

  this.handleFinanceSourcesOriChange = function (financeSources) {
    _this9.setState({
      financeSources: financeSources,
      oriFinanceSources: (0, _clone2.default)(financeSources)
    });
  };

  this.handleReservationTokenInputChange = function (e, _ref33) {
    var name = _ref33.name,
        value = _ref33.value;
    var reservationTokenSettings = _this9.state.reservationTokenSettings;

    _this9.setState({ reservationTokenSettings: _extends({}, reservationTokenSettings, _defineProperty({}, name, value)) });
  };

  this.getAvailableTimeOptions = function () {
    var t = _this9.props.t;

    var startHour = 0; // Midnight
    var endHour = 23; // 11 PM

    // Create an array listing all time in 24 hour format spaced in one hour intervals.
    return Array.from({ length: endHour - startHour + 1 }, function (e, index) {
      var hour = startHour + index;
      var isPM = hour >= 12;
      var formattedHour = hour % 12 === 0 ? 12 : hour % 12;
      var timeLabel = hour.toString().padStart(2, '0') + ':00';
      var amPmText = isPM ? t('PM', { ns: _translation.TRANSLATION_FILES.constants }) : t('AM', { ns: _translation.TRANSLATION_FILES.constants });
      return { key: hour, text: formattedHour + ':00 ' + amPmText, value: timeLabel + ':00' };
    });
  };

  this.canAccessReservationTokenSettings = function () {
    var auth = _this9.props.auth;

    return auth.isHeadquarters || auth.isAdminCommunity;
  };

  this.tabs = [{
    name: 'access',
    value: 'access',
    text: 'Access Management',
    fields: []
  }, {
    name: 'features',
    value: 'features',
    text: 'Features',
    fields: []
  }, {
    name: 'pricing_package',
    value: 'pricing_package',
    text: 'Pricing Package',
    fields: []
  }, {
    name: 'project',
    value: 'project',
    text: 'Project Settings',
    fields: []
  }, {
    name: 'cooldown',
    value: 'cooldown',
    text: 'Cooldown',
    fields: []
  }, {
    name: 'unit_field_management',
    value: 'unit_field_management',
    text: 'Unit Field Management',
    fields: []
  }, {
    name: 'address',
    value: 'address',
    text: 'Address settings',
    fields: []
  }, {
    name: 'source_of_financing',
    value: 'source_of_financing',
    text: 'Sources of Financing',
    fields: []
  }, this.canAccessReservationTokenSettings() && {
    name: 'reservation_token',
    value: 'reservation_token',
    text: 'Reservation Token',
    fields: []
  }];
  this.canManagePaymentOptions = [{
    key: 0,
    text: 'Headquarters',
    value: 'hq',
    disabled: true,
    icon: 'comment'
  }, {
    key: 1,
    text: 'Supervisors',
    value: 'canManagePaymentSupervisor',
    icon: 'users'
  }, {
    key: 2,
    text: 'Sales Managers',
    value: 'canManagePaymentSalesManager',
    icon: 'users'
  }, {
    key: 3,
    text: 'Sales Admins',
    value: 'canManagePaymentSalesAdmin',
    icon: 'users'
  }];
  this.cooldownOptions = [{ key: 'o15', text: '15 (15 Minutes)', value: '15' }, { key: 'o30', text: '30 (30 Minutes)', value: '30' }, { key: 'o60', text: '60 (1 Hour)', value: '60' }, { key: 'o180', text: '180 (3 Hours)', value: '180' }, { key: 'o360', text: '360 (6 Hours)', value: '360' }, { key: 'o720', text: '720 (12 Hours)', value: '720' }, { key: 'o1440', text: '1440 (1 Day)', value: '1440' }];
  this.cacheOptions = [{ key: 'o30', text: '30 (30 Minutes)', value: '30' }, { key: 'o60', text: '60 (1 Hour)', value: '60' }, { key: 'o120', text: '120 (2 Hours)', value: '120' }];
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(SystemSettings.mapStateToProps)(SystemSettings));

/***/ }),
/* 2487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _SystemSettings = __webpack_require__(2486);

var _SystemSettings2 = _interopRequireDefault(_SystemSettings);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SystemSettings2.default;

/***/ }),
/* 2488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1070);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Edit = function (_Component) {
  _inherits(Edit, _Component);

  function Edit(props) {
    _classCallCheck(this, Edit);

    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(Edit, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, tag) {
        var _this2 = this;

        var store, t, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.form.submit('/tags/picture/' + this.props.tagID + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(tag)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false);
                });
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully updated', { ns: _translation.TRANSLATION_FILES.translation, name: res.name }) }));

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Edit {{name}}', { ns: _translation.TRANSLATION_FILES.translation, name: this.props.data ? this.props.data.name : t('tag', { ns: _translation.TRANSLATION_FILES.translation }) }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Update', { ns: _translation.TRANSLATION_FILES.translation }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, tag) {
            _this3.submit(validations, tag);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading,
          tag: this.props.data
        })
      );
    }
  }]);

  return Edit;
}(_react.Component);

Edit.propTypes = {
  tagID: _propTypes2.default.string,
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
Edit.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(Edit);

/***/ }),
/* 2489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _TagList = __webpack_require__(2206);

var _TagList2 = _interopRequireDefault(_TagList);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    var state = List.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(List, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Tags')
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', columns: 'equal', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t('Picture Tags')
              ),
              _react2.default.createElement(_TagList2.default, {
                loading: this.state.loading
              })
            )
          )
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  return {
    loading: loading
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(List);

/***/ }),
/* 2490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1070);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var New = function (_Component) {
  _inherits(New, _Component);

  function New(props) {
    _classCallCheck(this, New);

    var _this = _possibleConstructorReturn(this, (New.__proto__ || Object.getPrototypeOf(New)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments[1];

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges, callback);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(New, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, preset) {
        var _this2 = this;

        var store, t, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                store = this.context.store;
                t = this.props.t;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.form.submit('/tags/picture/', {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(preset)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false, function (noChanges) {
                    if (noChanges) {
                      store.dispatch((0, _reactRouterRedux.goBack)());
                      store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Create Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully created', { ns: _translation.TRANSLATION_FILES.translation, name: res.name }) }));
                    }
                  });
                });

              case 24:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('New tag', { ns: _translation.TRANSLATION_FILES.translation }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Create', { ns: _translation.TRANSLATION_FILES.screens }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, preset) {
            _this3.submit(validations, preset);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading
        })
      );
    }
  }]);

  return New;
}(_react.Component);

New.propTypes = {
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
New.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(New);

/***/ }),
/* 2491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _checkChanges = __webpack_require__(61);

var _promptMessages = __webpack_require__(43);

var _translation = __webpack_require__(4);

var _List = __webpack_require__(2489);

var _List2 = _interopRequireDefault(_List);

var _New = __webpack_require__(2490);

var _New2 = _interopRequireDefault(_New);

var _Edit = __webpack_require__(2488);

var _Edit2 = _interopRequireDefault(_Edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tags = function (_Component) {
  _inherits(Tags, _Component);

  function Tags(props) {
    _classCallCheck(this, Tags);

    var _this = _possibleConstructorReturn(this, (Tags.__proto__ || Object.getPrototypeOf(Tags)).call(this, props));

    _this.state = {
      token: null,
      loading: true,
      data: null
    };
    return _this;
  }

  _createClass(Tags, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.params.tagID) {
        this.fetchTag();
      } else if (this.props.location.pathname.includes('/new/')) {
        this.fetchTags();
      } else {
        this.setLoading(false);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var pathname = nextProps.location.pathname;

      if (nextProps.params.tagID) {
        if (pathname !== this.props.location.pathname) {
          this.fetchTag();
        }
      } else if (pathname.includes('/new/')) {
        this.fetchTags();
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchTag',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, t, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/tags/picture/' + this.props.params.tagID + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 19;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context.next = 33;
                break;

              case 27:
                token = res.headers.get('X-Csrf-Token');
                _context.next = 30;
                return res.json();

              case 30:
                data = _context.sent;
                _context.next = 33;
                return this.setComponentState({
                  token: token,
                  data: data
                });

              case 33:
                _context.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchTag() {
        return _ref.apply(this, arguments);
      }

      return fetchTag;
    }()
  }, {
    key: 'fetchTags',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var store, t, query, res, message, token;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                t = this.props.t;
                query = Object.assign({
                  page: 1
                }, q);
                res = void 0;
                _context2.prev = 6;
                _context2.next = 9;
                return store.dispatch((0, _fetchM.fetchM)('/tags/picture/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 9:
                res = _context2.sent;
                _context2.next = 20;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2['catch'](6);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 17;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 17:
                _context2.next = 19;
                return this.setLoading(false);

              case 19:
                return _context2.abrupt('return');

              case 20:
                if (res.ok) {
                  _context2.next = 28;
                  break;
                }

                _context2.next = 23;
                return res.text();

              case 23:
                message = _context2.sent;
                _context2.next = 26;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 26:
                _context2.next = 31;
                break;

              case 28:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context2.next = 31;
                return this.setComponentState({
                  token: token
                });

              case 31:
                _context2.next = 33;
                return this.setLoading(false);

              case 33:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[6, 12]]);
      }));

      function fetchTags() {
        return _ref2.apply(this, arguments);
      }

      return fetchTags;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this4 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this4.state.token,
          loading: _this4.state.loading,
          data: _this4.state.data,
          tagID: _this4.props.params.tagID
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Tags;
}(_react.Component);

Tags.propTypes = {
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object
  }),
  params: _propTypes2.default.shape({
    tagID: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
Tags.contextTypes = {
  store: _propTypes2.default.object
};
Tags.List = _List2.default;
Tags.New = (0, _checkChanges.checkChanges)(_New2.default, { message: _promptMessages.NEW_SPECIFICATION_PROMPT });
Tags.Edit = (0, _checkChanges.checkChanges)(_Edit2.default);


var TranslatedTags = (0, _reactI18next.withTranslation)(_translation.namespaces)(Tags);
TranslatedTags.List = Tags.List;
TranslatedTags.New = Tags.New;
TranslatedTags.Edit = Tags.Edit;
exports.default = TranslatedTags;

/***/ }),
/* 2492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Tags = __webpack_require__(2491);

var _Tags2 = _interopRequireDefault(_Tags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Tags2.default;

/***/ }),
/* 2493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1071);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Edit = function (_Component) {
  _inherits(Edit, _Component);

  function Edit(props) {
    _classCallCheck(this, Edit);

    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(Edit, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, template) {
        var _this2 = this;

        var t, store, errors, res, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                res = void 0;
                _context.prev = 7;
                _context.next = 10;
                return this.form.submit('/templates/' + encodeURIComponent(this.props.templateID) + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(template)
                });

              case 10:
                res = _context.sent;
                _context.next = 23;
                break;

              case 13:
                _context.prev = 13;
                _context.t0 = _context['catch'](7);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return _context.t0.res.text();

              case 18:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 21:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 23:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false);
                });
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully updated', { ns: _translation.TRANSLATION_FILES.translation, name: res.name }) }));

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 13]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Edit {{name}}', { ns: _translation.TRANSLATION_FILES.translation, name: this.props.data ? this.props.data.name : t('Template', { ns: _translation.TRANSLATION_FILES.screens }) }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Update', { ns: _translation.TRANSLATION_FILES.translation }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, template) {
            _this3.submit(validations, template);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading,
          template: this.props.data
        })
      );
    }
  }]);

  return Edit;
}(_react.Component);

Edit.propTypes = {
  templateID: _propTypes2.default.string,
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
Edit.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(Edit);

/***/ }),
/* 2494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _TemplateList = __webpack_require__(1033);

var _TemplateList2 = _interopRequireDefault(_TemplateList);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    var state = List.getPropsToState(props);
    _this.state = state;
    return _this;
  }

  _createClass(List, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Templates', { ns: _translation.TRANSLATION_FILES.translation })
        }),
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { verticalAlign: 'middle', columns: 'equal', stackable: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(
                _semanticUiReact.Divider,
                { horizontal: true },
                t(this.props.type + ' Templates', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              _react2.default.createElement(_TemplateList2.default, {
                loading: this.state.loading,
                type: this.props.type
              })
            )
          )
        )
      );
    }
  }]);

  return List;
}(_react.Component);

List.propTypes = {
  type: _propTypes2.default.string,
  t: _propTypes2.default.func
};
List.contextTypes = {
  store: _propTypes2.default.object
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  return {
    loading: loading
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(List);

/***/ }),
/* 2495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _reactRouterRedux = __webpack_require__(13);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _Form = __webpack_require__(1071);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var New = function (_Component) {
  _inherits(New, _Component);

  function New(props) {
    _classCallCheck(this, New);

    var _this = _possibleConstructorReturn(this, (New.__proto__ || Object.getPrototypeOf(New)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var callback = arguments[1];

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges, callback);
      }
    };

    _this.state = {
      hasChanges: false
    };
    return _this;
  }

  _createClass(New, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(validations, preset) {
        var _this2 = this;

        var store, _props, type, t, errors, res, q, message;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                store = this.context.store;
                _props = this.props, type = _props.type, t = _props.t;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context2.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context2.abrupt('return');

              case 6:
                res = void 0;
                q = Object.assign({
                  templateType: type
                });
                _context2.prev = 8;
                _context2.next = 11;
                return this.form.submit('/templates/?' + _qs2.default.stringify(q), {
                  credentials: 'include',
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(preset)
                });

              case 11:
                res = _context2.sent;
                _context2.next = 24;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](8);

                if (!(_context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 22;
                  break;
                }

                _context2.next = 19;
                return _context2.t0.res.text();

              case 19:
                message = _context2.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 22:
                store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));
                return _context2.abrupt('return');

              case 24:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false, function () {
                    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(noChanges) {
                      var path;
                      return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              if (noChanges) {
                                path = type === 'quotation' ? 'quotation_templates' : 'print_templates';

                                store.dispatch((0, _reactRouterRedux.replace)('/settings/' + path + '/'));
                                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Create Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('{{name}} successfully created', { ns: _translation.TRANSLATION_FILES.translation, name: res.name }) }));
                              }

                            case 1:
                            case 'end':
                              return _context.stop();
                          }
                        }
                      }, _callee, _this2);
                    }));

                    return function (_x4) {
                      return _ref2.apply(this, arguments);
                    };
                  }());
                });

              case 25:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 14]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      var headerLabel = this.props.type === 'quotation' ? 'Quotation' : 'Print';
      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('New ' + headerLabel + ' Template', { ns: _translation.TRANSLATION_FILES.translation }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Create', { ns: _translation.TRANSLATION_FILES.screens }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref3) {
            _this3.form = _ref3;
          },
          onSubmit: function onSubmit(validations, preset) {
            _this3.submit(validations, preset);
          },
          onChange: this.handleOnChange,
          loading: this.props.loading,
          type: this.props.type
        })
      );
    }
  }]);

  return New;
}(_react.Component);

New.propTypes = {
  token: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  onCheck: _propTypes2.default.func,
  type: _propTypes2.default.string,
  t: _propTypes2.default.func
};
New.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(New);

/***/ }),
/* 2496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _checkChanges = __webpack_require__(61);

var _promptMessages = __webpack_require__(43);

var _translation = __webpack_require__(4);

var _List = __webpack_require__(2494);

var _List2 = _interopRequireDefault(_List);

var _New = __webpack_require__(2495);

var _New2 = _interopRequireDefault(_New);

var _Edit = __webpack_require__(2493);

var _Edit2 = _interopRequireDefault(_Edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Templates = function (_Component) {
  _inherits(Templates, _Component);

  function Templates(props) {
    _classCallCheck(this, Templates);

    var _this = _possibleConstructorReturn(this, (Templates.__proto__ || Object.getPrototypeOf(Templates)).call(this, props));

    var type = window.location.pathname.includes('quotation_templates') ? 'quotation' : 'print';
    _this.state = {
      token: null,
      loading: true,
      data: null,
      type: type
    };
    return _this;
  }

  _createClass(Templates, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.params.templateID) {
        this.fetchTemplate();
      } else if (this.props.location.pathname.includes('/new/')) {
        this.listTemplates();
      } else {
        this.setLoading(false);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var pathname = nextProps.location.pathname;

      if (nextProps.params.templateID) {
        if (pathname !== this.props.location.pathname) {
          this.fetchTemplate();
        }
      } else if (pathname.includes('/new/')) {
        this.listTemplates();
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchTemplate',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var t, store, res, message, token, data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                res = void 0;
                _context.prev = 5;
                _context.next = 8;
                return store.dispatch((0, _fetchM.fetchM)('/templates/' + encodeURIComponent(this.props.params.templateID) + '/', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 8:
                res = _context.sent;
                _context.next = 19;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](5);

                Bugsnag.notifyException(_context.t0);
                _context.next = 16;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 16:
                _context.next = 18;
                return this.setLoading(false);

              case 18:
                return _context.abrupt('return');

              case 19:
                if (res.ok) {
                  _context.next = 27;
                  break;
                }

                _context.next = 22;
                return res.text();

              case 22:
                message = _context.sent;
                _context.next = 25;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 25:
                _context.next = 33;
                break;

              case 27:
                token = res.headers.get('X-Csrf-Token');
                _context.next = 30;
                return res.json();

              case 30:
                data = _context.sent;
                _context.next = 33;
                return this.setComponentState({
                  token: token,
                  data: data
                });

              case 33:
                _context.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[5, 11]]);
      }));

      function fetchTemplate() {
        return _ref.apply(this, arguments);
      }

      return fetchTemplate;
    }()
  }, {
    key: 'listTemplates',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var q = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var t, store, type, query, res, message, token;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.setLoading(true);

              case 2:
                t = this.props.t;
                store = this.context.store;
                type = 'print';

                if (window.location.pathname.includes('quotation_templates')) type = 'quotation';
                query = Object.assign({
                  page: 1,
                  templateType: type
                }, q);
                res = void 0;
                _context2.prev = 8;
                _context2.next = 11;
                return store.dispatch((0, _fetchM.fetchM)('/templates/?' + _qs2.default.stringify(query), {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 11:
                res = _context2.sent;
                _context2.next = 22;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t0 = _context2['catch'](8);

                Bugsnag.notifyException(_context2.t0);
                _context2.next = 19;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 19:
                _context2.next = 21;
                return this.setLoading(false);

              case 21:
                return _context2.abrupt('return');

              case 22:
                if (res.ok) {
                  _context2.next = 30;
                  break;
                }

                _context2.next = 25;
                return res.text();

              case 25:
                message = _context2.sent;
                _context2.next = 28;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 28:
                _context2.next = 33;
                break;

              case 30:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context2.next = 33;
                return this.setComponentState({
                  token: token
                });

              case 33:
                _context2.next = 35;
                return this.setLoading(false);

              case 35:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[8, 14]]);
      }));

      function listTemplates() {
        return _ref2.apply(this, arguments);
      }

      return listTemplates;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this4 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this4.state.token,
          loading: _this4.state.loading,
          data: _this4.state.data,
          templateID: _this4.props.params.templateID,
          type: _this4.state.type
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Templates;
}(_react.Component);

Templates.propTypes = {
  children: _propTypes2.default.node,
  location: _propTypes2.default.shape({
    pathname: _propTypes2.default.string,
    query: _propTypes2.default.object
  }),
  params: _propTypes2.default.shape({
    templateID: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
Templates.contextTypes = {
  store: _propTypes2.default.object
};
Templates.List = _List2.default;
Templates.New = (0, _checkChanges.checkChanges)(_New2.default, { message: _promptMessages.NEW_SPECIFICATION_PROMPT });
Templates.Edit = (0, _checkChanges.checkChanges)(_Edit2.default);


var TranslatedTemplates = (0, _reactI18next.withTranslation)(_translation.namespaces)(Templates);
TranslatedTemplates.List = Templates.List;
TranslatedTemplates.New = Templates.New;
TranslatedTemplates.Edit = Templates.Edit;
exports.default = TranslatedTemplates;

/***/ }),
/* 2497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Templates = __webpack_require__(2496);

var _Templates2 = _interopRequireDefault(_Templates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Templates2.default;

/***/ }),
/* 2498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _translation = __webpack_require__(4);

var _Form = __webpack_require__(2499);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditVideo = function (_Component) {
  _inherits(EditVideo, _Component);

  function EditVideo(props) {
    _classCallCheck(this, EditVideo);

    var _this = _possibleConstructorReturn(this, (EditVideo.__proto__ || Object.getPrototypeOf(EditVideo)).call(this, props));

    _this.handleSubmit = function (event) {
      _this.form.handleSubmit(event);
    };

    _this.handleOnChange = function (hasChanges) {
      if (hasChanges !== _this.state.hasChanges) {
        _this.setState({ hasChanges: hasChanges }, function () {
          _this.handleOnCheck(hasChanges);
        });
      }
    };

    _this.handleOnCheckSupported = function (urlSupported) {
      if (urlSupported !== _this.state.urlSupported) {
        _this.setState({ urlSupported: urlSupported });
      }
    };

    _this.handleOnCheck = function () {
      var hasChanges = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.props.onCheck) {
        _this.props.onCheck(hasChanges);
      }
    };

    _this.state = {
      hasChanges: false,
      urlSupported: false
    };
    return _this;
  }

  _createClass(EditVideo, [{
    key: 'submit',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, file) {
        var _this2 = this;

        var t, store, errors, message;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                errors = validations.filter(function (v) {
                  return !v.isValid;
                });

                if (!(errors.length > 0)) {
                  _context.next = 6;
                  break;
                }

                store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                    return l.message;
                  }) }));
                return _context.abrupt('return');

              case 6:
                _context.prev = 6;
                _context.next = 9;
                return this.form.submit('/medias/' + this.props.id + '/', {
                  credentials: 'include',
                  method: 'PUT',
                  headers: {
                    'Content-Type': 'application/json',
                    'X-Csrf-Token': this.props.token
                  },
                  body: JSON.stringify(file)
                });

              case 9:
                _context.next = 21;
                break;

              case 11:
                _context.prev = 11;
                _context.t0 = _context['catch'](6);

                if (!(_context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                  _context.next = 19;
                  break;
                }

                _context.next = 16;
                return _context.t0.res.text();

              case 16:
                message = _context.sent;

                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context.abrupt('return');

              case 19:
                store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
                return _context.abrupt('return');

              case 21:
                this.setState({ hasChanges: false }, function () {
                  _this2.handleOnCheck(false);
                });
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Update Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Video successfully updated', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 23:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[6, 11]]);
      }));

      function submit(_x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return submit;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: t('Edit video', { ns: _translation.TRANSLATION_FILES.translation }),
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              content: t('Save', { ns: _translation.TRANSLATION_FILES.translation }),
              onClick: this.handleSubmit,
              disabled: !this.state.hasChanges || this.state.hasChanges && !this.state.urlSupported
            })
          )
        }),
        _react2.default.createElement(_Form2.default, {
          ref: function ref(_ref2) {
            _this3.form = _ref2;
          },
          onSubmit: function onSubmit(validations, unit) {
            _this3.submit(validations, unit);
          },
          onChange: this.handleOnChange,
          onCheckSupported: this.handleOnCheckSupported,
          loading: this.props.loading,
          media: this.props.data
        })
      );
    }
  }]);

  return EditVideo;
}(_react.Component);

EditVideo.propTypes = {
  token: _propTypes2.default.string,
  id: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
EditVideo.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(EditVideo);

/***/ }),
/* 2499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _lodash = __webpack_require__(36);

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _regex = __webpack_require__(143);

var _fetchM = __webpack_require__(6);

var _translation = __webpack_require__(4);

var _flash = __webpack_require__(5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable camelcase */


// const mediaTypes = [
//   { key: 'video', text: 'Video', value: 'video' },
// ];

var MediaForm = function (_Component) {
  _inherits(MediaForm, _Component);

  function MediaForm(props) {
    _classCallCheck(this, MediaForm);

    var _this = _possibleConstructorReturn(this, (MediaForm.__proto__ || Object.getPrototypeOf(MediaForm)).call(this, props));

    _initialiseProps.call(_this);

    var media = Object.assign({}, MediaForm.defaultValues, props.media || {});
    var oembed = null;
    if (media.data) {
      oembed = media.data;
    }
    _this.state = {
      media: media,
      oriMedia: (0, _clone2.default)(media),
      loading: false,
      errMessages: [],
      hasChanges: false,
      oembed: oembed
    };
    _this.validation = {
      url: (0, _react.createRef)()
      // type: createRef(),
    };
    return _this;
  }

  _createClass(MediaForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var media = Object.assign({}, MediaForm.defaultValues, this.state.media);
      var _state = this.state,
          oembed = _state.oembed,
          oriMedia = _state.oriMedia;

      if (JSON.stringify(this.props.media) !== JSON.stringify(nextProps.media)) {
        media = Object.assign(media, nextProps.media);
        oriMedia = (0, _clone2.default)(media);

        if (media.data) {
          oembed = media.data;
        }
      }
      this.setState({
        media: media,
        oriMedia: oriMedia,
        oembed: oembed
      });
    }
  }, {
    key: 'submit',
    value: function submit(url, opts) {
      return this.form.submit(url, opts);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;
      var _state2 = this.state,
          media = _state2.media,
          oembed = _state2.oembed;

      return _react2.default.createElement(
        _AppForm2.default,
        {
          onSubmit: this.handleSubmit,
          error: this.state.errMessages.length > 0,
          ref: function ref(_ref) {
            _this2.form = _ref;
          }
        },
        _react2.default.createElement(
          _semanticUiReact.Grid,
          { columns: 'equal', stackable: true, doubling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { textAlign: 'left' },
              _react2.default.createElement(
                'h4',
                null,
                t('Preview', { ns: _translation.TRANSLATION_FILES.translation })
              ),
              oembed && _react2.default.createElement('div', {
                style: {
                  width: '100%',
                  display: 'flex'
                },
                dangerouslySetInnerHTML: { __html: oembed.html }
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_AppForm2.default.Input, {
                validateLabel: 'URL',
                label: _react2.default.createElement(
                  'label',
                  null,
                  'URL',
                  _react2.default.createElement(
                    'small',
                    {
                      style: {
                        fontWeight: 100,
                        marginLeft: '0.5em'
                      }
                    },
                    t('Paste your YouTube or Vimeo video URL here. URLs from other platform are not supported.', { ns: _translation.TRANSLATION_FILES.translation })
                  )
                ),
                name: 'url',
                value: media.url,
                onChange: this.handleInputChange,
                ref: this.validation.url,
                validation: [_webValidations.required, {
                  validate: _webValidations.matchRegex,
                  option: {
                    validRegex: _regex.REG_URL
                  }
                }],
                disabled: this.state.loading || this.props.loading
              }),
              _react2.default.createElement(_AppForm2.default.Input, {
                label: t('Label', { ns: _translation.TRANSLATION_FILES.screens }),
                name: 'label',
                value: media.label,
                onChange: this.handleInputChange,
                disabled: this.state.loading || this.props.loading
              })
            )
          )
        )
      );
    }
  }]);

  return MediaForm;
}(_react.Component);

MediaForm.propTypes = {
  onSubmit: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  onCheckSupported: _propTypes2.default.func,
  media: _propTypes2.default.shape({
    url: _propTypes2.default.string,
    label: _propTypes2.default.string,
    data: _propTypes2.default.shape({
      thumbnail_url: _propTypes2.default.string,
      thumbnail_url_with_play_button: _propTypes2.default.string
    })
  }),
  loading: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
MediaForm.defaultProps = {
  loading: false
};
MediaForm.contextTypes = {
  store: _propTypes2.default.object
};
MediaForm.defaultValues = {
  url: '',
  type: 'video',
  label: ''
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.setComponentState = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new Promise(function (res) {
      _this3.setState(state, function () {
        res(state);
      });
    });
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      _this3.setState({ loading: loading }, function () {
        res(loading);
      });
    });
  };

  this.fetchOEmbedData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var t, store, media, validations, errors, query, res, message, _message, oembed;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            t = _this3.props.t;
            store = _this3.context.store;
            media = _this3.state.media;

            if (media.url) {
              _context.next = 5;
              break;
            }

            return _context.abrupt('return');

          case 5:
            _context.next = 7;
            return _AppForm2.default.validate(_this3.validation, media);

          case 7:
            validations = _context.sent;
            errors = validations.filter(function (v) {
              return !v.isValid;
            });

            if (!(errors.length > 0)) {
              _context.next = 11;
              break;
            }

            return _context.abrupt('return');

          case 11:
            _context.next = 13;
            return _this3.setLoading(true);

          case 13:
            query = {
              url: media.url
            };
            res = void 0;
            _context.prev = 15;
            _context.next = 18;
            return store.dispatch((0, _fetchM.fetchM)('/oembed/?' + _qs2.default.stringify(query), {
              credentials: 'include',
              method: 'GET',
              headers: {
                'Content-Type': 'application/json'
              }
            }));

          case 18:
            res = _context.sent;
            _context.next = 39;
            break;

          case 21:
            _context.prev = 21;
            _context.t0 = _context['catch'](15);

            if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
              _context.next = 32;
              break;
            }

            _context.next = 26;
            return _context.t0.res.text();

          case 26:
            message = _context.sent;

            store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
            _context.next = 30;
            return _this3.setLoading(false);

          case 30:
            _this3.handleCheckSupported(false);
            return _context.abrupt('return');

          case 32:
            Bugsnag.notifyException(_context.t0);
            _context.next = 35;
            return store.dispatch((0, _flash.flashErrorMessage)({ message: t('An error occurred, please refresh page', { ns: _translation.TRANSLATION_FILES.translation }) }));

          case 35:
            _this3.handleCheckSupported(false);
            _context.next = 38;
            return _this3.setLoading(false);

          case 38:
            return _context.abrupt('return');

          case 39:
            if (res.ok) {
              _context.next = 48;
              break;
            }

            _context.next = 42;
            return res.text();

          case 42:
            _message = _context.sent;
            _context.next = 45;
            return store.dispatch((0, _flash.flashErrorMessage)({ message: _message }));

          case 45:
            _this3.handleCheckSupported(false);
            _context.next = 55;
            break;

          case 48:
            _context.next = 50;
            return res.json();

          case 50:
            oembed = _context.sent;

            if (oembed && oembed.title) {
              media.label = oembed.title;
            }
            _context.next = 54;
            return _this3.setComponentState({ oembed: oembed, media: media });

          case 54:
            _this3.handleCheckSupported(true);

          case 55:
            _context.next = 57;
            return _this3.setLoading(false);

          case 57:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this3, [[15, 21]]);
  }));

  this.handleSubmit = function (event) {
    event.preventDefault();
    var media = _this3.state.media;

    media.label = media.label.trim();
    _AppForm2.default.validate(_this3.validation, media).then(function (validations) {
      _this3.setState({
        errMessages: validations.filter(function (v) {
          return !v.isValid;
        })
      });
      _this3.props.onSubmit(validations, media);
    });
  };

  this.checkHasChanges = function () {
    var media = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.state;
    return JSON.stringify(media) !== JSON.stringify(_this3.state.oriMedia);
  };

  this.debounceFetchOEmbed = _lodash2.default.debounce(this.fetchOEmbedData, 1000);

  this.handleInputChange = function (event, _ref3) {
    var name = _ref3.name,
        value = _ref3.value;
    var media = _this3.state.media;
    var oembed = _this3.state.oembed;

    var newValue = value;
    if (name === 'label') {
      newValue = value.replace(/[\\~#%&*{}/:<>?|"]/, '');
    }
    media[name] = newValue;
    if (name === 'url') {
      oembed = null;
    }

    var hasChanges = _this3.checkHasChanges(media);
    _this3.setState({ media: media, oembed: oembed, hasChanges: hasChanges }, function () {
      if (name === 'url') {
        _this3.handleCheckSupported(false);
        _this3.debounceFetchOEmbed(newValue);
      }
      if (_this3.props.onChange) {
        _this3.props.onChange(hasChanges);
      }
    });
  };

  this.handleCheckSupported = function () {
    var urlSupported = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var onCheckSupported = _this3.props.onCheckSupported;

    if (onCheckSupported) {
      onCheckSupported(urlSupported);
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(MediaForm);

/***/ }),
/* 2500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _checkChanges = __webpack_require__(61);

var _Edit = __webpack_require__(2498);

var _Edit2 = _interopRequireDefault(_Edit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Video = function (_Component) {
  _inherits(Video, _Component);

  function Video(props) {
    _classCallCheck(this, Video);

    var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, props));

    _this.state = {
      token: null,
      loading: true,
      data: null
    };
    return _this;
  }

  _createClass(Video, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchMedia();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var id = nextProps.params.id;

      if (id !== this.props.params.id) {
        this.fetchMedia();
      }
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchMedia',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, data, token;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/medias/' + this.props.params.id + '/?oembed=true', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                return _context.abrupt('return');

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 32;
                break;

              case 26:
                _context.next = 28;
                return res.json();

              case 28:
                data = _context.sent;

                // handle token.. etc
                token = res.headers.get('X-Csrf-Token');
                _context.next = 32;
                return this.setComponentState({
                  data: data,
                  token: token
                });

              case 32:
                _context.next = 34;
                return this.setLoading(false);

              case 34:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchMedia() {
        return _ref.apply(this, arguments);
      }

      return fetchMedia;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this4 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this4.state.token,
          loading: _this4.state.loading,
          data: _this4.state.data,
          id: _this4.props.params.id
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Video;
}(_react.Component);

Video.propTypes = {
  children: _propTypes2.default.node,
  params: _propTypes2.default.shape({
    id: _propTypes2.default.string
  })
};
Video.contextTypes = {
  store: _propTypes2.default.object
};
Video.Edit = (0, _checkChanges.checkChanges)(_Edit2.default);
exports.default = Video;

/***/ }),
/* 2501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Video = __webpack_require__(2500);

var _Video2 = _interopRequireDefault(_Video);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Video2.default;

/***/ }),
/* 2502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactRouter = __webpack_require__(18);

var _fetchM = __webpack_require__(6);

var _flash = __webpack_require__(5);

var _prompt = __webpack_require__(66);

var _MediaList = __webpack_require__(385);

var _MediaList2 = _interopRequireDefault(_MediaList);

var _NavBar = __webpack_require__(15);

var _NavBar2 = _interopRequireDefault(_NavBar);

var _UploadModal = __webpack_require__(92);

var _UploadModal2 = _interopRequireDefault(_UploadModal);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _RemoveMedia = __webpack_require__(589);

var _RemoveMedia2 = _interopRequireDefault(_RemoveMedia);

var _translation = __webpack_require__(4);

var _promptMessages = __webpack_require__(43);

var _Form = __webpack_require__(1072);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var List = function (_Component) {
  _inherits(List, _Component);

  function List(props) {
    _classCallCheck(this, List);

    var _this = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, props));

    _initialiseProps.call(_this);

    var state = List.getPropsToState(props);
    _this.state = _extends({}, state, {
      selectedMedia: null,
      showLarge: false,
      showDelete: false
    });
    _this.mediaList = null;
    return _this;
  }

  _createClass(List, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = List.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'getToken',
    value: function getToken(id, callback) {
      var store = this.context.store;

      store.dispatch((0, _fetchM.fetchM)('/medias/' + id + '/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })).catch(function (err) {
        store.dispatch((0, _flash.flashErrorMessage)(err));
      }).then(function (res) {
        var token = res.headers.get('X-Csrf-Token');
        if (callback) {
          callback(token);
        }
      });
    }
  }, {
    key: 'handleRefetch',
    value: function handleRefetch() {
      if (this.mediaList) {
        this.mediaList.getWrappedInstance().handleRefetch();
      }
    }
  }, {
    key: 'deleteMedia',
    value: function deleteMedia() {
      var _this2 = this;

      var t = this.props.t;
      var store = this.context.store;

      this.getToken(this.state.selectedMedia.id, function (token) {
        store.dispatch((0, _fetchM.fetchM)('/medias/' + _this2.state.selectedMedia.id + '/', {
          credentials: 'include',
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'X-Csrf-Token': token
          }
        })).then(function () {
          _this2.setState({
            selectedMedia: null,
            loading: false
          });
          _this2.handleRefetch();
          store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Delete Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Video successfully deleted', { ns: _translation.TRANSLATION_FILES.translation }) }));
        }).catch(function (err) {
          store.dispatch((0, _flash.flashErrorMessage)(err));
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Container,
        null,
        _react2.default.createElement(_NavBar2.default, {
          header: 'Videos',
          rightNav: _react2.default.createElement(
            _semanticUiReact.Menu.Item,
            { fitted: true },
            _react2.default.createElement(_UploadModal2.default, {
              ref: function ref(_ref2) {
                _this3.uploadModal = _ref2;
              },
              header: 'video',
              loading: this.state.loading,
              icon: null,
              btnText: t('New', { ns: _translation.TRANSLATION_FILES.constants }),
              onClose: this.handleCheckBeforeClose,
              content: function content() {
                return _react2.default.createElement(_Form2.default, {
                  ref: function ref(_ref) {
                    _this3.form = _ref;
                  },
                  onSubmit: _this3.createMedia
                });
              }
            })
          )
        }),
        _react2.default.createElement(_ViewLarge2.default, {
          open: this.state.showLarge,
          onClose: this.handleCloseLarge,
          picture: this.state.selectedMedia,
          type: 'video'
        }),
        _react2.default.createElement(_RemoveMedia2.default, {
          type: 'delete',
          open: this.state.showDelete,
          onClose: this.handleCancelDelete,
          onConfirm: this.handleConfirmDelete,
          media: this.state.selectedMedia
        }),
        _react2.default.createElement(_MediaList2.default, {
          ref: function ref(_ref4) {
            _this3.mediaList = _ref4;
          },
          toggleable: true,
          onViewLarge: this.handleViewLarge,
          onRemove: this.handleDelete,
          buttonNode: function buttonNode(_ref3) {
            var isMobile = _ref3.isMobile,
                view = _ref3.view,
                loading = _ref3.loading,
                item = _ref3.item;
            return view === 'list' ? _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_semanticUiReact.Button, {
                as: _reactRouter.Link,
                size: 'tiny',
                compact: true,
                primary: true,
                icon: 'edit',
                content: t('Edit', { ns: _translation.TRANSLATION_FILES.translation }),
                disabled: loading,
                to: '/media/videos/' + item.id + '/'
              }),
              _react2.default.createElement(_semanticUiReact.Button, {
                size: 'tiny',
                compact: true,
                negative: true,
                icon: 'remove',
                content: isMobile ? null : t('Remove', { ns: _translation.TRANSLATION_FILES.translation }),
                disabled: loading,
                onClick: function onClick(e) {
                  return _this3.handleDelete(e, item);
                }
              })
            ) : _react2.default.createElement(_semanticUiReact.Button, {
              as: _reactRouter.Link,
              compact: true, size: 'small',
              attached: 'bottom',
              primary: true,
              icon: 'edit', content: t('Edit', { ns: _translation.TRANSLATION_FILES.translation }),
              disabled: loading,
              to: '/media/videos/' + item.id + '/'
            });
          }
        })
      );
    }
  }]);

  return List;
}(_react.Component);

List.contextTypes = {
  store: _propTypes2.default.object
};
List.propTypes = {
  token: _propTypes2.default.string,
  t: _propTypes2.default.func
};

List.getPropsToState = function (props) {
  var loading = props.loading;
  return {
    loading: loading
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleCloseLarge = function (e) {
    e.preventDefault();
    _this4.setState({
      showLarge: false,
      selectedMedia: null
    });
  };

  this.handleViewLarge = function (e, selectedMedia) {
    e.preventDefault();
    _this4.setState({
      selectedMedia: selectedMedia,
      showLarge: true
    });
  };

  this.handleCancelDelete = function (e) {
    e.preventDefault();
    _this4.setState({
      showDelete: false,
      selectedMedia: null
    });
  };

  this.handleDelete = function (e, selectedMedia) {
    e.preventDefault();
    _this4.setState({
      selectedMedia: selectedMedia,
      showDelete: true
    });
  };

  this.handleConfirmDelete = function (e) {
    e.preventDefault();
    _this4.setState({
      showDelete: false
    }, function () {
      _this4.deleteMedia();
    });
  };

  this.createMedia = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(validations, media) {
      var t, store, errors, message;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              t = _this4.props.t;
              store = _this4.context.store;
              errors = validations.filter(function (v) {
                return !v.isValid;
              });

              if (!(errors.length > 0)) {
                _context.next = 6;
                break;
              }

              store.dispatch((0, _flash.flashErrorMessage)({ header: t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }), list: errors.map(function (l) {
                  return l.message;
                }) }));
              return _context.abrupt('return');

            case 6:
              _context.prev = 6;
              _context.next = 9;
              return _this4.form.submit('/medias/', {
                credentials: 'include',
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json',
                  'X-Csrf-Token': _this4.props.token
                },
                body: JSON.stringify(media)
              });

            case 9:
              _context.next = 21;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context['catch'](6);

              if (!(_context.t0.res && _context.t0.res.status >= 400 && _context.t0.res.status < 500)) {
                _context.next = 19;
                break;
              }

              _context.next = 16;
              return _context.t0.res.text();

            case 16:
              message = _context.sent;

              store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
              return _context.abrupt('return');

            case 19:
              store.dispatch((0, _flash.flashErrorMessage)(_context.t0));
              return _context.abrupt('return');

            case 21:
              _this4.uploadModal.close();
              _this4.handleRefetch();
              store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Create Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Video successfully created', { ns: _translation.TRANSLATION_FILES.translation }) }));

            case 24:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this4, [[6, 11]]);
    }));

    return function (_x, _x2) {
      return _ref5.apply(this, arguments);
    };
  }();

  this.handleCheckBeforeClose = function () {
    var t = _this4.props.t;

    if (_this4.form && _this4.form.state && _this4.form.state.hasChanges) {
      var callback = function callback() {
        _this4.uploadModal.close();
        _this4.handleRefetch();
      };
      var store = _this4.context.store;

      store.dispatch((0, _prompt.promptChangesMessage)({ message: t(_promptMessages.DEFAULT_PROMPT, { ns: _translation.TRANSLATION_FILES.translation }), callback: callback }));
      return true;
    }
    return false;
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(List);

/***/ }),
/* 2503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _List = __webpack_require__(2502);

var _List2 = _interopRequireDefault(_List);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Videos = function (_Component) {
  _inherits(Videos, _Component);

  function Videos(props) {
    _classCallCheck(this, Videos);

    var _this = _possibleConstructorReturn(this, (Videos.__proto__ || Object.getPrototypeOf(Videos)).call(this, props));

    _this.state = {
      token: null,
      loading: true
    };
    return _this;
  }

  _createClass(Videos, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.fetchVideos();
    }
  }, {
    key: 'setComponentState',
    value: function setComponentState() {
      var _this2 = this;

      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return new Promise(function (res) {
        _this2.setState(state, function () {
          res(state);
        });
      });
    }
  }, {
    key: 'setLoading',
    value: function setLoading() {
      var _this3 = this;

      var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return new Promise(function (res) {
        _this3.setState({ loading: loading }, function () {
          res(loading);
        });
      });
    }
  }, {
    key: 'fetchVideos',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var store, res, message, token;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.setLoading(true);

              case 2:
                store = this.context.store;
                res = void 0;
                _context.prev = 4;
                _context.next = 7;
                return store.dispatch((0, _fetchM.fetchM)('/medias/?page=1&type=video', {
                  credentials: 'include',
                  method: 'GET',
                  headers: {
                    'Content-Type': 'application/json'
                  }
                }));

              case 7:
                res = _context.sent;
                _context.next = 18;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context['catch'](4);

                Bugsnag.notifyException(_context.t0);
                _context.next = 15;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

              case 15:
                _context.next = 17;
                return this.setLoading(false);

              case 17:
                return _context.abrupt('return');

              case 18:
                if (res.ok) {
                  _context.next = 26;
                  break;
                }

                _context.next = 21;
                return res.text();

              case 21:
                message = _context.sent;
                _context.next = 24;
                return store.dispatch((0, _flash.flashErrorMessage)({ message: message }));

              case 24:
                _context.next = 29;
                break;

              case 26:
                token = res.headers.get('X-Csrf-Token');
                // handle token.. etc

                _context.next = 29;
                return this.setComponentState({
                  token: token
                });

              case 29:
                _context.next = 31;
                return this.setLoading(false);

              case 31:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this, [[4, 10]]);
      }));

      function fetchVideos() {
        return _ref.apply(this, arguments);
      }

      return fetchVideos;
    }()
  }, {
    key: 'renderChild',
    value: function renderChild() {
      var _this4 = this;

      return _react.Children.map(this.props.children, function (child) {
        return _react2.default.cloneElement(child, {
          token: _this4.state.token,
          loading: _this4.state.loading
        });
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        this.renderChild()
      );
    }
  }]);

  return Videos;
}(_react.Component);

Videos.propTypes = {
  children: _propTypes2.default.node
};
Videos.contextTypes = {
  store: _propTypes2.default.object
};
Videos.List = _List2.default;
exports.default = Videos;

/***/ }),
/* 2504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _Videos = __webpack_require__(2503);

var _Videos2 = _interopRequireDefault(_Videos);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Videos2.default;

/***/ }),
/* 2505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _scripts = __webpack_require__(2585);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SecureDocumentsSharing = function (_Component) {
  _inherits(SecureDocumentsSharing, _Component);

  function SecureDocumentsSharing(props) {
    _classCallCheck(this, SecureDocumentsSharing);

    var _this = _possibleConstructorReturn(this, (SecureDocumentsSharing.__proto__ || Object.getPrototypeOf(SecureDocumentsSharing)).call(this, props));

    _this.setStateAsync = function (state) {
      return new Promise(function (res) {
        _this.setState(state, res);
      });
    };

    _this.state = {
      loading: false,
      loaded: false
    };
    return _this;
  }

  _createClass(SecureDocumentsSharing, [{
    key: 'componentDidMount',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.loadScript();

              case 2:
                this.renderWidget(this.props.bookingID, this.props.assignedBankers, this.props.assignedBankCasesCode, this.props.assignedLawyers, this.props.assignedLawyerCasesID, this.props.loanTrackerLeadCode, this.props.isVietnam);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(nextProps) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (JSON.stringify(this.props) !== JSON.stringify(nextProps)) {
                  this.renderWidget(nextProps.bookingID, nextProps.assignedBankers, nextProps.assignedBankCasesCode, nextProps.assignedLawyers, nextProps.assignedLawyerCasesID, nextProps.loanTrackerLeadCode, nextProps.isVietnam);
                }

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function componentWillReceiveProps(_x) {
        return _ref2.apply(this, arguments);
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'loadScript',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var url;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = _config2.default.get('secureDocumentsSharingWidgetURL');

                if (url) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt('return');

              case 3:
                _context3.next = 5;
                return this.setStateAsync({ loading: true });

              case 5:
                _context3.prev = 5;
                _context3.next = 8;
                return (0, _scripts.loadComplete)(url);

              case 8:
                _context3.next = 16;
                break;

              case 10:
                _context3.prev = 10;
                _context3.t0 = _context3['catch'](5);

                Bugsnag.notifyException(_context3.t0);
                _context3.next = 15;
                return this.setStateAsync({ loading: false, loaded: false });

              case 15:
                return _context3.abrupt('return');

              case 16:
                _context3.next = 18;
                return this.setStateAsync({ loading: false, loaded: true });

              case 18:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this, [[5, 10]]);
      }));

      function loadScript() {
        return _ref3.apply(this, arguments);
      }

      return loadScript;
    }()
  }, {
    key: 'renderWidget',
    value: function renderWidget(bookingID, bankers, bankCasesCode, lawyers, lawyerCasesID, loanTrackerLeadCode) {
      var isVietnam = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
      var t = this.props.t;

      var paths = [];
      // CPI-976 (G3-D2): the wet-signed sales form is the Booked gate's evidence. Vietnam only.
      var vnDocumentTypes = isVietnam ? [{
        label: t('Signed Sales Form (Wet Sign)'),
        value: 'signed_sales_form_wet'
      }] : [];
      if (bookingID) {
        paths.push('showroom/bookings/' + bookingID);
        if (bankCasesCode && bankCasesCode.length > 0) {
          bankCasesCode.forEach(function (caseCode) {
            if (caseCode) {
              paths.push('banker/cases/' + caseCode);
            }
          });
        }
        if (lawyerCasesID && lawyerCasesID.length > 0) {
          lawyerCasesID.forEach(function (caseID) {
            if (caseID) {
              paths.push('lawyer/cases/' + caseID);
            }
          });
        }
        // CPI-1249: was `!== ''`, so an undefined code asked the API about a deal that cannot exist.
        if (loanTrackerLeadCode) {
          paths.push('loan-tracker/deals/' + loanTrackerLeadCode);
        }

        // CPI-1249: in Vietnam this widget keeps one job, the wet-signed form; empty off Vietnam.
        var myUploadDocumentTypes = [{
          label: 'Bank Statement',
          value: 'bank_statement'
        }, {
          label: 'CTOS Consent',
          value: 'ctos_consent'
        }, {
          label: 'Declaration Form',
          value: 'declaration_form'
        }, {
          label: 'EA Form',
          value: 'ea_form'
        }, {
          label: 'IC',
          value: 'ic'
        }, {
          label: 'Other Documents',
          value: 'other_documents'
        }, {
          label: 'Pay Slip',
          value: 'pay_slip'
        }, {
          label: 'Rebate Form',
          value: 'rebate_form'
        }, {
          label: 'Title Details',
          value: 'title_details'
        }];

        var w = new window.SecureDocumentsWidget({
          uploadDocumentTypes: isVietnam ? vnDocumentTypes : myUploadDocumentTypes,
          documentTypes: [{
            label: 'Bank Statement',
            value: 'bank_statement'
          }, {
            label: 'CTOS Consent',
            value: 'ctos_consent'
          }, {
            label: 'Declaration Form',
            value: 'declaration_form'
          }, {
            label: 'EA Form',
            value: 'ea_form'
          }, {
            label: 'Letter of Offer',
            value: 'letter_of_offer'
          }, {
            label: 'IC',
            value: 'ic'
          }, {
            label: 'Other Documents',
            value: 'other_documents'
          }, {
            label: 'Pay Slip',
            value: 'pay_slip'
          }, {
            label: 'Rebate Form',
            value: 'rebate_form'
          }, {
            label: 'Title Details',
            value: 'title_details'
          }, {
            label: 'EPF Statement',
            value: 'epf_statement'
          }, {
            label: 'Property Booking Form',
            value: 'property_booking_form'
          }, {
            label: 'Signed SPA',
            value: 'signed_spa'
          }].concat(vnDocumentTypes),
          app: 'showroom',
          path: paths,
          uploadPath: 'showroom/bookings/' + bookingID,
          data: {
            showPurchasers: false,
            showBankers: true,
            showLawyers: true,
            bankers: bankers,
            lawyers: lawyers
          },
          limit: 5
        });
        w.render(this.documentSharingWidget);
      }
    }
  }, {
    key: 'renderContent',
    value: function renderContent() {
      var _state = this.state,
          loading = _state.loading,
          loaded = _state.loaded;
      var t = this.props.t;

      if (loading) {
        return t('Loading...', { ns: _translation.TRANSLATION_FILES.translation });
      }
      if (loaded) {
        return t('Secure documents loading...', { ns: _translation.TRANSLATION_FILES.translation });
      }
      return t('Unable to load secure documents.', { ns: _translation.TRANSLATION_FILES.translation });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        {
          className: 'securedocuments-root',
          ref: function ref(_ref4) {
            _this2.documentSharingWidget = _ref4;
          }
        },
        this.renderContent()
      );
    }
  }]);

  return SecureDocumentsSharing;
}(_react.Component);

SecureDocumentsSharing.propTypes = {
  bookingID: _propTypes2.default.string.isRequired,
  assignedBankers: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  assignedBankCasesCode: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  assignedLawyers: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  assignedLawyerCasesID: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  loanTrackerLeadCode: _propTypes2.default.string,
  // CPI-976: Vietnam gets the "Signed sales form (wet sign)" document type (upload + list).
  isVietnam: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
SecureDocumentsSharing.defaultProps = {
  isVietnam: false
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(SecureDocumentsSharing);

/***/ }),
/* 2506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactI18next = __webpack_require__(3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _prompt = __webpack_require__(66);

var _BranchLogoList = __webpack_require__(2109);

var _BranchLogoList2 = _interopRequireDefault(_BranchLogoList);

var _UploadModal = __webpack_require__(92);

var _UploadModal2 = _interopRequireDefault(_UploadModal);

var _translation = __webpack_require__(4);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _promptMessages = __webpack_require__(43);

var _Form = __webpack_require__(586);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddBranchLogo = function (_Component) {
  _inherits(AddBranchLogo, _Component);

  function AddBranchLogo(props) {
    var _this2 = this;

    _classCallCheck(this, AddBranchLogo);

    var _this = _possibleConstructorReturn(this, (AddBranchLogo.__proto__ || Object.getPrototypeOf(AddBranchLogo)).call(this, props));

    _this.fixBody = function () {
      var anotherModal = document.getElementsByClassName('ui page modals');
      if (anotherModal.length > 0) {
        document.body.classList.add('dimmable', 'dimmed');
      }
    };

    _this.handleViewLarge = function (e, selectedLogo) {
      e.preventDefault();
      _this.setState({ selectedLogo: selectedLogo }, function () {
        _this.setState({
          showLarge: true
        });
      });
    };

    _this.handleCloseLarge = function (e) {
      e.preventDefault();
      _this.setState({
        showLarge: false,
        selectedLogo: null
      });
    };

    _this.handleAddBranchLogo = function (e, selectedLogo) {
      e.preventDefault();
      if (_this.props.onConfirm) {
        _this.props.onConfirm(e, selectedLogo);
      }
      _this.setState({
        selectedLogo: null
      }, function () {
        _this.fixBody();
      });
    };

    _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    };

    _this.handleOnUpload = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e, data) {
        var _ref2, url, options;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.props.onUpload) {
                  _context.next = 8;
                  break;
                }

                e.preventDefault();
                _context.next = 4;
                return _this.props.onUpload(data);

              case 4:
                _ref2 = _context.sent;
                url = _ref2.url;
                options = _ref2.options;

                if (url && options) {
                  _this.upload(url, options);
                }

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleCheckBeforeClose = function () {
      var t = _this.props.t;

      if (_this.form.getWrappedInstance().state.uploads.length > 0) {
        var callback = function callback() {
          _this.form.getWrappedInstance().resetFiles();
          _this.uploadModal.close();
          _this.handleRefetch();
        };
        var store = _this.context.store;

        store.dispatch((0, _prompt.promptChangesMessage)({ message: t(_promptMessages.UPLOAD_LOGO_PROMPT, { ns: _translation.TRANSLATION_FILES.translation }), callback: callback }));
        return true;
      }
      return false;
    };

    _this.state = {
      showLarge: false,
      selectedLogo: null
    };
    return _this;
  }

  _createClass(AddBranchLogo, [{
    key: 'handleRefetch',
    value: function handleRefetch() {
      if (this.logoList) {
        this.logoList.getWrappedInstance().handleRefetch();
      }
    }
  }, {
    key: 'checkAdded',
    value: function checkAdded(data) {
      if (this.props.onCheck) {
        return this.props.onCheck(data);
      }
      return false;
    }
  }, {
    key: 'upload',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, options) {
        var t, store, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                _context2.prev = 2;
                _context2.next = 5;
                return this.form.getWrappedInstance().submit(url, options);

              case 5:
                _context2.next = 18;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](2);

                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 12;
                return _context2.t0.res.text();

              case 12:
                message = _context2.sent;

                if (_context2.t0.res.status === 413) {
                  message = 'Uploaded image too large';
                }
                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 16:
                store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));
                return _context2.abrupt('return');

              case 18:
                this.uploadModal.close();
                this.handleRefetch();
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Upload Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Picture(s) successfully uploaded', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 7]]);
      }));

      function upload(_x3, _x4) {
        return _ref3.apply(this, arguments);
      }

      return upload;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          className: 'add-picture',
          open: this.props.open === true,
          onClose: this.handleOnClose,
          closeIcon: 'close',
          size: 'large'
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'image outline', content: t('Add logos', { ns: _translation.TRANSLATION_FILES.translation }) }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { scrolling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle', columns: 'equal' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(_ViewLarge2.default, {
                  open: this.state.showLarge,
                  onClose: this.handleCloseLarge,
                  picture: this.state.selectedLogo,
                  pictureSize: 50,
                  extension: 'png'
                }),
                _react2.default.createElement(_BranchLogoList2.default, {
                  ref: function ref(_ref8) {
                    _this3.logoList = _ref8;
                  },
                  toggleable: true,
                  onViewLarge: this.handleViewLarge,
                  onRemove: this.handleRemove,
                  buttonNode: function buttonNode(_ref4) {
                    var view = _ref4.view,
                        loading = _ref4.loading,
                        logo = _ref4.logo;
                    return _react2.default.createElement(_semanticUiReact.Button, {
                      compact: true, size: 'small',
                      primary: !_this3.checkAdded(logo),
                      positive: _this3.checkAdded(logo),
                      icon: _this3.checkAdded(logo) ? 'checkmark' : 'add',
                      content: _this3.checkAdded(logo) ? t('Added', { ns: _translation.TRANSLATION_FILES.translation }) : t('Add', { ns: _translation.TRANSLATION_FILES.translation }),
                      disabled: _this3.checkAdded(logo) || loading,
                      onClick: function onClick(e) {
                        return _this3.handleAddBranchLogo(e, logo);
                      }
                    });
                  },
                  searchRightNav: _react2.default.createElement(_UploadModal2.default, {
                    floated: 'right',
                    header: 'logos',
                    ref: function ref(_ref7) {
                      _this3.uploadModal = _ref7;
                    },
                    onConfirm: this.handleOnUpload,
                    onClose: this.handleCheckBeforeClose,
                    content: function content(_ref5) {
                      var onConfirm = _ref5.onConfirm;
                      return _react2.default.createElement(_Form2.default, {
                        ref: function ref(_ref6) {
                          _this3.form = _ref6;
                        },
                        onSubmit: onConfirm
                      });
                    }
                  })
                })
              )
            )
          )
        )
      );
    }
  }]);

  return AddBranchLogo;
}(_react.Component);

AddBranchLogo.contextTypes = {
  store: _propTypes2.default.object
};
AddBranchLogo.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  onUpload: _propTypes2.default.func,
  onCheck: _propTypes2.default.func,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)()(AddBranchLogo);

/***/ }),
/* 2507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _flash = __webpack_require__(5);

var _prompt = __webpack_require__(66);

var _LogoList = __webpack_require__(1024);

var _LogoList2 = _interopRequireDefault(_LogoList);

var _UploadModal = __webpack_require__(92);

var _UploadModal2 = _interopRequireDefault(_UploadModal);

var _ViewLarge = __webpack_require__(81);

var _ViewLarge2 = _interopRequireDefault(_ViewLarge);

var _translation = __webpack_require__(4);

var _promptMessages = __webpack_require__(43);

var _Form = __webpack_require__(586);

var _Form2 = _interopRequireDefault(_Form);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddLogo = function (_Component) {
  _inherits(AddLogo, _Component);

  function AddLogo(props) {
    var _this2 = this;

    _classCallCheck(this, AddLogo);

    var _this = _possibleConstructorReturn(this, (AddLogo.__proto__ || Object.getPrototypeOf(AddLogo)).call(this, props));

    _this.fixBody = function () {
      var anotherModal = document.getElementsByClassName('ui page modals');
      if (anotherModal.length > 0) {
        document.body.classList.add('dimmable', 'dimmed');
      }
    };

    _this.handleViewLarge = function (e, selectedLogo) {
      e.preventDefault();
      _this.setState({ selectedLogo: selectedLogo }, function () {
        _this.setState({
          showLarge: true
        });
      });
    };

    _this.handleCloseLarge = function (e) {
      e.preventDefault();
      _this.setState({
        showLarge: false,
        selectedLogo: null
      });
    };

    _this.handleAddLogo = function (e, selectedLogo) {
      e.preventDefault();
      if (_this.props.onConfirm) {
        _this.props.onConfirm(e, selectedLogo);
      }
      _this.setState({
        selectedLogo: null
      }, function () {
        _this.fixBody();
      });
    };

    _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    };

    _this.handleOnUpload = function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e, data) {
        var _ref2, url, options;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!_this.props.onUpload) {
                  _context.next = 8;
                  break;
                }

                e.preventDefault();
                _context.next = 4;
                return _this.props.onUpload(data);

              case 4:
                _ref2 = _context.sent;
                url = _ref2.url;
                options = _ref2.options;

                if (url && options) {
                  _this.upload(url, options);
                }

              case 8:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }();

    _this.handleCheckBeforeClose = function () {
      var t = _this.props.t;

      if (_this.form.getWrappedInstance().state.uploads.length > 0) {
        var callback = function callback() {
          _this.form.getWrappedInstance().resetFiles();
          _this.setState({ uploadModalState: false });
          _this.handleRefetch();
        };
        var store = _this.context.store;

        store.dispatch((0, _prompt.promptChangesMessage)({ message: t(_promptMessages.UPLOAD_LOGO_PROMPT), callback: callback }));
        return true;
      }
      return false;
    };

    _this.handleUploadModalStateChange = function (open) {
      _this.setState({ uploadModalState: open });
    };

    _this.state = {
      showLarge: false,
      selectedLogo: null
    };
    return _this;
  }

  _createClass(AddLogo, [{
    key: 'handleRefetch',
    value: function handleRefetch() {
      if (this.logoList) {
        this.logoList.getWrappedInstance().handleRefetch();
      }
    }
  }, {
    key: 'checkAdded',
    value: function checkAdded(data) {
      if (this.props.onCheck) {
        return this.props.onCheck(data);
      }
      return false;
    }
  }, {
    key: 'upload',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(url, options) {
        var t, store, message;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                t = this.props.t;
                store = this.context.store;
                _context2.prev = 2;
                _context2.next = 5;
                return this.form.getWrappedInstance().submit(url, options);

              case 5:
                _context2.next = 18;
                break;

              case 7:
                _context2.prev = 7;
                _context2.t0 = _context2['catch'](2);

                if (!(_context2.t0.res && _context2.t0.res.status >= 400 && _context2.t0.res.status < 500)) {
                  _context2.next = 16;
                  break;
                }

                _context2.next = 12;
                return _context2.t0.res.text();

              case 12:
                message = _context2.sent;

                if (_context2.t0.res.status === 413) {
                  message = 'Uploaded document/image too large';
                }
                store.dispatch((0, _flash.flashErrorMessage)({ message: message }));
                return _context2.abrupt('return');

              case 16:
                store.dispatch((0, _flash.flashErrorMessage)(_context2.t0));
                return _context2.abrupt('return');

              case 18:
                this.setState({ uploadModalState: false });
                this.handleRefetch();
                store.dispatch((0, _flash.flashSuccessMessage)({ header: t('Upload Success', { ns: _translation.TRANSLATION_FILES.translation }), message: t('Logo(s) successfully uploaded', { ns: _translation.TRANSLATION_FILES.translation }) }));

              case 21:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 7]]);
      }));

      function upload(_x3, _x4) {
        return _ref3.apply(this, arguments);
      }

      return upload;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          className: 'add-picture',
          open: this.props.open === true,
          onClose: this.handleOnClose,
          closeIcon: 'close',
          size: 'large'
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'image outline', content: t('Add logos', { ns: _translation.TRANSLATION_FILES.translation }) }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { scrolling: true },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle', columns: 'equal' },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(_ViewLarge2.default, {
                  open: this.state.showLarge,
                  onClose: this.handleCloseLarge,
                  picture: this.state.selectedLogo,
                  pictureSize: 50,
                  extension: 'png'
                }),
                _react2.default.createElement(_LogoList2.default, {
                  ref: function ref(_ref7) {
                    _this3.logoList = _ref7;
                  },
                  toggleable: true,
                  onViewLarge: this.handleViewLarge,
                  onRemove: this.handleRemove,
                  loading: this.props.isLoading,
                  buttonNode: function buttonNode(_ref4) {
                    var loading = _ref4.loading,
                        logo = _ref4.logo;
                    return _react2.default.createElement(_semanticUiReact.Button, {
                      compact: true, size: 'small',
                      primary: !_this3.checkAdded(logo),
                      positive: _this3.checkAdded(logo),
                      icon: _this3.checkAdded(logo) ? 'checkmark' : 'add',
                      content: _this3.checkAdded(logo) ? t('Added', { ns: _translation.TRANSLATION_FILES.translation }) : t('Add', { ns: _translation.TRANSLATION_FILES.translation }),
                      disabled: _this3.checkAdded(logo) || loading,
                      onClick: function onClick(e) {
                        return _this3.handleAddLogo(e, logo);
                      }
                    });
                  },
                  searchRightNav: _react2.default.createElement(_UploadModal2.default, {
                    modalState: this.state.uploadModalState,
                    floated: 'right',
                    header: 'logos',
                    onModalStateChange: this.handleUploadModalStateChange,
                    onConfirm: this.handleOnUpload,
                    onClose: this.handleCheckBeforeClose,
                    content: function content(_ref5) {
                      var onConfirm = _ref5.onConfirm;
                      return _react2.default.createElement(_Form2.default, {
                        ref: function ref(_ref6) {
                          _this3.form = _ref6;
                        },
                        onSubmit: onConfirm
                      });
                    }
                  })
                })
              )
            )
          )
        )
      );
    }
  }]);

  return AddLogo;
}(_react.Component);

AddLogo.contextTypes = {
  store: _propTypes2.default.object
};
AddLogo.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  onUpload: _propTypes2.default.func,
  onCheck: _propTypes2.default.func,
  isLoading: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)()(AddLogo);

/***/ }),
/* 2508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = __webpack_require__(3);

var _semanticUiReact = __webpack_require__(2);

var _prompt = __webpack_require__(66);

var _Form = __webpack_require__(2362);

var _Form2 = _interopRequireDefault(_Form);

var _promptMessages = __webpack_require__(43);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddSharedMedia = function (_Component) {
  _inherits(AddSharedMedia, _Component);

  function AddSharedMedia() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, AddSharedMedia);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AddSharedMedia.__proto__ || Object.getPrototypeOf(AddSharedMedia)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClose = function (e) {
      if (e && e.preventDefault) e.preventDefault();

      var _this$props = _this.props,
          t = _this$props.t,
          onClose = _this$props.onClose;
      var store = _this.context.store;


      var formInstance = _this.form && _this.form.getWrappedInstance ? _this.form.getWrappedInstance() : _this.form;

      if (formInstance && formInstance.state.uploads && formInstance.state.uploads.length > 0) {
        var callback = function callback() {
          if (onClose) onClose();
        };

        if (store) {
          store.dispatch((0, _prompt.promptChangesMessage)({
            message: t(_promptMessages.UPLOAD_DOCUMENT_PROMPT, { ns: _translation.TRANSLATION_FILES.translation }),
            callback: callback
          }));
        }
        return;
      }

      if (onClose) onClose();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(AddSharedMedia, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          open = _props.open,
          _onSubmit = _props.onSubmit;


      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          open: open,
          onClose: this.handleOnClose,
          closeIcon: true,
          size: 'small',
          closeOnDimmerClick: false
        },
        _react2.default.createElement(
          _semanticUiReact.Modal.Header,
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'file alternate outline' }),
          ' ',
          this.props.t('Add document', { ns: _translation.TRANSLATION_FILES.translation })
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(_Form2.default, {
            ref: function ref(_ref2) {
              _this2.form = _ref2;
            },
            onSubmit: function onSubmit(event, data) {
              if (_onSubmit) _onSubmit(event, data);
            }
          })
        )
      );
    }
  }]);

  return AddSharedMedia;
}(_react.Component);

AddSharedMedia.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  id: _propTypes2.default.string,
  token: _propTypes2.default.string,
  t: _propTypes2.default.func
};
AddSharedMedia.contextTypes = {
  store: _propTypes2.default.object
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(AddSharedMedia);

/***/ }),
/* 2509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _webValidations = __webpack_require__(23);

var _semanticUiReact = __webpack_require__(2);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _PhoneInput = __webpack_require__(104);

var _PhoneInput2 = _interopRequireDefault(_PhoneInput);

var _SearchHimsPostcodes = __webpack_require__(569);

var _SearchHimsPostcodes2 = _interopRequireDefault(_SearchHimsPostcodes);

var _SearchHimsDistricts = __webpack_require__(568);

var _SearchHimsDistricts2 = _interopRequireDefault(_SearchHimsDistricts);

var _intlCallCodes = __webpack_require__(116);

var _intlCallCodes2 = _interopRequireDefault(_intlCallCodes);

var _lawyerCaseStatuses = __webpack_require__(142);

var _states = __webpack_require__(144);

var _states2 = _interopRequireDefault(_states);

var _phone = __webpack_require__(146);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AssignSecondaryLawyer = function (_Component) {
  _inherits(AssignSecondaryLawyer, _Component);

  function AssignSecondaryLawyer(props) {
    _classCallCheck(this, AssignSecondaryLawyer);

    var _this = _possibleConstructorReturn(this, (AssignSecondaryLawyer.__proto__ || Object.getPrototypeOf(AssignSecondaryLawyer)).call(this, props));

    _initialiseProps.call(_this);

    var state = AssignSecondaryLawyer.getPropsToState(props);
    _this.state = _extends({}, state, {
      errMessages: []
    });
    _this.validation = {
      repType: (0, _react.createRef)(),
      name: (0, _react.createRef)(),
      lawFirmName: (0, _react.createRef)(),
      mobilePrefix: (0, _react.createRef)(),
      mobile: (0, _react.createRef)(),
      address1: (0, _react.createRef)(),
      himsKodPoskod: (0, _react.createRef)(),
      himsKodDaerah: (0, _react.createRef)(),
      city: (0, _react.createRef)(),
      state: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(AssignSecondaryLawyer, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = AssignSecondaryLawyer.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          data = _state.data,
          phoneValidationPresets = _state.phoneValidationPresets;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          className: 'booking-status-note',
          open: this.props.open === true,
          onClose: this.handleOnClose,
          size: 'large'
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'add user', content: 'Assign 2nd SPA Lawyer' }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: { paddingBottom: '1em' } },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'p',
                null,
                'Please aware that this additional lawyer is only for HIMS e-SPA usage and records. It won\'t appear in MHub Lawyer module.'
              ),
              _react2.default.createElement(
                _AppForm2.default,
                {
                  onSubmit: this.handleSubmit,
                  error: this.state.errMessages.length > 0,
                  ref: function ref(_ref) {
                    _this2.form = _ref;
                  }
                },
                _react2.default.createElement(
                  _semanticUiReact.Grid,
                  { stackable: true },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { mobile: 16, tablet: 8, computer: 8 },
                    _react2.default.createElement(_AppForm2.default.Select, {
                      label: 'Lawyer represents (in e-SPA)',
                      name: 'repType',
                      ref: this.validation.repType,
                      validation: [_webValidations.required],
                      validateLabel: 'Lawyer represents (in e-SPA)',
                      options: _lawyerCaseStatuses.SPA_LAWYER_REP_OPTIONS,
                      value: data.repType,
                      onChange: this.handleSelectChange,
                      disabled: !data.id
                    }),
                    _react2.default.createElement(_AppForm2.default.Input, {
                      autoComplete: 'off',
                      name: 'name',
                      onChange: this.handleChange,
                      placeholder: 'Lawyer Name*',
                      label: 'Lawyer Name*',
                      ref: this.validation.name,
                      validation: [_webValidations.required],
                      validateLabel: 'Lawyer Name',
                      value: data.name
                    }),
                    _react2.default.createElement(_AppForm2.default.Input, {
                      autoComplete: 'off',
                      name: 'lawFirmName',
                      onChange: this.handleChange,
                      placeholder: 'Lawyer Firm Name*',
                      label: 'Lawyer Firm Name*',
                      ref: this.validation.lawFirmName,
                      value: data.lawFirmName,
                      validation: [_webValidations.required],
                      validateLabel: 'Lawyer Firm Name'
                    }),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { widths: 'equal' },
                      _react2.default.createElement(_AppForm2.default.Select, {
                        name: 'mobilePrefix',
                        onChange: this.handleChange,
                        options: _intlCallCodes2.default,
                        label: 'Lawyer Mobile Prefix*',
                        placeholder: 'Lawyer Mobile Prefix*',
                        search: true,
                        selectOnBlur: false,
                        validation: [_webValidations.required],
                        ref: this.validation.mobilePrefix,
                        validateLabel: 'Lawyer Mobile Prefix',
                        value: data.mobilePrefix
                      }),
                      _react2.default.createElement(_PhoneInput2.default, {
                        autoComplete: 'off',
                        name: 'mobile',
                        onChange: this.handleChange,
                        label: 'Lawyer Mobile Number*',
                        placeholder: 'Lawyer Mobile Number*',
                        prefix: data.mobilePrefix,
                        ref: this.validation.mobile,
                        type: 'tel',
                        validation: [_webValidations.required, {
                          validate: _webValidations.phoneNumber,
                          option: data.mobilePrefix === 'other' ? {} : {
                            isMobile: true,
                            phonePrefix: data.mobilePrefix,
                            validRegex: (0, _phone.getPhoneValidRegex)(phoneValidationPresets, data.mobilePrefix, 'mobile')
                          }
                        }],
                        value: data.mobile,
                        validateLabel: 'Lawyer Mobile Number'
                      })
                    ),
                    _react2.default.createElement(_SearchHimsDistricts2.default, {
                      validateRef: this.validation.himsKodDaerah,
                      name: 'himsKodDaerah',
                      validation: [_webValidations.required],
                      onSelect: this.handleSelectHimsDistrict,
                      state: data.state,
                      value: data.himsKodDaerah
                    })
                  ),
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    { mobile: 16, tablet: 8, computer: 8 },
                    _react2.default.createElement(_AppForm2.default.Input, {
                      name: 'address1',
                      label: 'Address 1*',
                      placeholder: 'Address 1*',
                      onChange: this.handleChange,
                      ref: this.validation.address1,
                      validation: [_webValidations.required],
                      validateLabel: 'Address 1',
                      value: data.address1
                    }),
                    _react2.default.createElement(_AppForm2.default.Input, {
                      name: 'address2',
                      label: 'Address 2',
                      placeholder: 'Address 2',
                      value: data.address2,
                      onChange: this.handleChange
                    }),
                    _react2.default.createElement(_AppForm2.default.Input, {
                      name: 'address3',
                      label: 'Address 3',
                      placeholder: 'Address 3',
                      value: data.address3,
                      onChange: this.handleChange
                    }),
                    _react2.default.createElement(
                      _semanticUiReact.Form.Group,
                      { widths: 'equal' },
                      _react2.default.createElement(_SearchHimsPostcodes2.default, {
                        validateRef: this.validation.himsKodPoskod,
                        name: 'himsKodPoskod',
                        validation: [_webValidations.required],
                        onSelect: this.handleSelectHimsPostcode,
                        state: data.state,
                        value: data.himsKodPoskod
                      }),
                      _react2.default.createElement(_AppForm2.default.Input, {
                        name: 'city',
                        label: 'City*',
                        placeholder: 'City*',
                        ref: this.validation.city,
                        validation: [_webValidations.required],
                        validateLabel: 'City',
                        value: data.city,
                        readOnly: true
                      })
                    ),
                    _react2.default.createElement(_AppForm2.default.Select, {
                      name: 'state',
                      label: 'State*',
                      placeholder: 'State*',
                      ref: this.validation.state,
                      validation: [_webValidations.required],
                      validateLabel: 'State',
                      options: _states2.default,
                      value: data.state,
                      onChange: this.handleSelectChange
                    })
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          this.renderActionButtons()
        )
      );
    }
  }]);

  return AssignSecondaryLawyer;
}(_react.Component);

AssignSecondaryLawyer.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func.isRequired,
  onCreate: _propTypes2.default.func.isRequired,
  onUpdate: _propTypes2.default.func.isRequired
};

AssignSecondaryLawyer.mapStateToProps = function (state) {
  return {
    phoneValidationPresets: state.phoneValidationPresets
  };
};

AssignSecondaryLawyer.getPropsToState = function (props) {
  var phoneValidationPresets = props.phoneValidationPresets.data;
  var data = {
    repType: props.repType,
    name: '',
    lawFirmName: '',
    mobilePrefix: '60',
    mobile: '',
    address1: '',
    postcode: '',
    city: '',
    state: ''
  };
  if (props.data) {
    data = props.data;
  }
  return {
    data: data,
    phoneValidationPresets: phoneValidationPresets
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleSubmit = function (event) {
    event.preventDefault();
    var data = _this3.state.data;

    return _AppForm2.default.validate(_this3.validation, data).then(function (validations) {
      _this3.setState({
        errMessages: validations.filter(function (v) {
          return !v.isValid;
        })
      });
      if (data.id) {
        _this3.props.onUpdate(event, validations, data);
      } else {
        _this3.props.onCreate(event, validations, data);
      }
    });
  };

  this.handleOnClose = function (e) {
    if (_this3.props.onClose) {
      _this3.props.onClose(e);
    }
  };

  this.handleOnConfirm = function (e) {
    e.preventDefault();
    _this3.form.handleSubmit(event);
  };

  this.handleChange = function (e, d) {
    var data = _this3.state.data;

    data[d.name] = d.value;
    _this3.setState({ data: data });
  };

  this.handleSelectChange = function (e, d) {
    var data = _this3.state.data;

    data[d.name] = d.value;
    if (d.name === 'state') {
      data.postcode = '';
      data.himsKodPoskod = '';
      data.city = '';
      data.himsKodBandar = '';
      data.himsKodDaerah = '';
    }
    _this3.setState({ data: data });
  };

  this.handleSelectHimsPostcode = function (himsPostcode) {
    var data = _this3.state.data;


    data.himsKodPoskod = himsPostcode ? himsPostcode.value : '';
    data.himsKodBandar = himsPostcode ? himsPostcode.kod_bandar_id : '';
    data.himsKodNegeri = himsPostcode ? himsPostcode.kod_negeri_id : '';

    data.postcode = himsPostcode ? himsPostcode.text : '';
    data.city = himsPostcode ? himsPostcode.bandar : '';
    var himsState = himsPostcode ? himsPostcode.kod_negeri_id : '';
    var srState = _states2.default.find(function (s) {
      return s.kod_negeri_id === himsState;
    });
    data.state = srState ? srState.value : '';

    _this3.setState({ data: data });
  };

  this.handleSelectHimsDistrict = function (himsDistrict) {
    var data = _this3.state.data;

    data.himsKodDaerah = himsDistrict ? himsDistrict.value : '';

    _this3.setState({ data: data });
  };

  this.renderActionButtons = function () {
    return _react2.default.createElement(
      _semanticUiReact.Grid,
      null,
      _react2.default.createElement(
        _semanticUiReact.Grid.Row,
        null,
        _react2.default.createElement(
          _semanticUiReact.Grid.Column,
          { mobile: 16, computer: 16 },
          _react2.default.createElement(
            _semanticUiReact.Grid.Row,
            null,
            _react2.default.createElement(_semanticUiReact.Button, { negative: true, onClick: _this3.handleOnClose, icon: 'cancel', content: 'Cancel' }),
            _react2.default.createElement(_semanticUiReact.Button, {
              positive: true,
              onClick: _this3.handleOnConfirm,
              icon: 'checkmark',
              content: 'Confirm',
              'data-bot-target': 'confirm'
            })
          )
        )
      )
    );
  };
};

exports.default = (0, _reactRedux.connect)(AssignSecondaryLawyer.mapStateToProps)(AssignSecondaryLawyer);

/***/ }),
/* 2510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BankCaseStates = function (_Component) {
  _inherits(BankCaseStates, _Component);

  function BankCaseStates() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BankCaseStates);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BankCaseStates.__proto__ || Object.getPrototypeOf(BankCaseStates)).call.apply(_ref, [this].concat(args))), _this), _this.getStatusColor = function (status) {
      switch (status) {
        case 'pending_unreachable':
        case 'pending_docs':
        case 'pending_docs_submitted':
        case 'pending_reappealed':
          return '#ff9800';

        case 'new':
          return '#03a9f4';

        case 'approved_lo_issued':
          return '#03a9f4';

        case 'reject_wrong_info':
        case 'reject_bank':
        case 'reject_developer':
        case 'reject_cancelled':
        case 'reject_customer':
        case 'reject_unqualified':
        case 'reject_lo_signed_other_bank':
          return 'red';

        case 'success_li_issued':
          return '#4CAF50';

        default:
          return '#F8F9F9';
      }
    }, _this.handleOnItemClick = function (e, status) {
      if (_this.props.onClose) {
        _this.props.onClose(e, status);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BankCaseStates, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          bankCaseStates = _props.bankCaseStates,
          activeStatus = _props.activeStatus,
          t = _props.t;
      var caseStates = bankCaseStates.data;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          className: 'bankcasestatus-modal',
          closeIcon: true,
          onClose: function onClose(e) {
            return _this2.props.onClose(e, '');
          },
          open: this.props.open,
          size: 'small'
        },
        _react2.default.createElement(
          _semanticUiReact.Modal.Header,
          null,
          t('{{customerName}}\'s Loan Status', { customerName: this.props.customerName, ns: _translation.TRANSLATION_FILES.screens })
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.List,
            { divided: true },
            caseStates.map(function (cs, idx) {
              return _react2.default.createElement(
                _semanticUiReact.List.Item,
                {
                  key: idx,
                  className: 'bankcasestatus-item ' + (activeStatus === cs.state ? 'disabled-item' : ''),
                  disabled: activeStatus === cs.state,
                  onClick: function onClick(e) {
                    return _this2.handleOnItemClick(e, cs.state);
                  }
                },
                _react2.default.createElement(_semanticUiReact.List.Icon, { name: activeStatus === cs.state ? 'dot circle outline' : 'circle', style: { color: '' + _this2.getStatusColor(cs.state) } }),
                _react2.default.createElement(
                  _semanticUiReact.List.Description,
                  null,
                  t(cs.shortName, { ns: _translation.TRANSLATION_FILES.constants })
                )
              );
            })
          )
        )
      );
    }
  }]);

  return BankCaseStates;
}(_react.Component);

BankCaseStates.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  customerName: _propTypes2.default.string,
  bankCaseStates: _propTypes2.default.shape({
    data: _propTypes2.default.array
  }),
  activeStatus: _propTypes2.default.string
};

BankCaseStates.mapStateToProps = function (state) {
  return {
    bankCaseStates: state.bankCaseStates
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)((0, _reactRedux.connect)(BankCaseStates.mapStateToProps)(BankCaseStates));

/***/ }),
/* 2511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _UploadModal = __webpack_require__(92);

var _UploadModal2 = _interopRequireDefault(_UploadModal);

var _Form = __webpack_require__(267);

var _Form2 = _interopRequireDefault(_Form);

var _translation = __webpack_require__(4);

var _flash = __webpack_require__(5);

var _validations = __webpack_require__(271);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BookingChangeUnit = function (_Component) {
  _inherits(BookingChangeUnit, _Component);

  function BookingChangeUnit(props) {
    _classCallCheck(this, BookingChangeUnit);

    var _this = _possibleConstructorReturn(this, (BookingChangeUnit.__proto__ || Object.getPrototypeOf(BookingChangeUnit)).call(this, props));

    _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    };

    _this.handleOnConfirm = function (e) {
      e.preventDefault();
      var store = _this.context.store;
      var data = _this.props.data;
      var _this$state = _this.state,
          attachmentsUploaded = _this$state.attachmentsUploaded,
          attachmentsUploadedCount = _this$state.attachmentsUploadedCount;

      if (data.cuAttachmentsRequired) {
        var validations = [{
          isValid: attachmentsUploadedCount > 0,
          key: '',
          message: 'Attachment is required'
        }];

        if ((0, _validations.validateForm)(store, validations)) return;
      }
      if (_this.props.onConfirm) {
        _this.props.onConfirm({
          attachmentsUploaded: attachmentsUploaded,
          attachmentsUploadedCount: attachmentsUploadedCount
        });
      }
    };

    _this.handleCheckBoxChange = function (event, d) {
      var data = _this.props.data;

      data[d.name] = !data[d.name];
      _this.setState({ data: data }, function () {
        _this.handleCheckChanges();
      });
    };

    _this.handleUploadModalClose = function () {
      return _this.uploadModal.close();
    };

    _this.state = {
      attachmentsUploaded: {},
      attachmentsUploadedCount: 0
    };
    return _this;
  }

  _createClass(BookingChangeUnit, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.open === true && nextProps.open !== this.props.open) {
        this.setState({
          attachmentsUploaded: {},
          attachmentsUploadedCount: 0
        });
      }
    }
  }, {
    key: 'uploadAttachments',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e, body) {
        var store, t;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                e.preventDefault();
                store = this.context.store;
                t = this.props.t;

                this.setState({
                  attachmentsUploaded: body,
                  attachmentsUploadedCount: body.get('total_attached')
                });
                this.uploadModal.close();
                store.dispatch((0, _flash.flashSuccessMessage)({
                  header: t('Attached', { ns: _translation.TRANSLATION_FILES.translation }),
                  message: t('Attachment(s) attached', { ns: _translation.TRANSLATION_FILES.translation })
                }));

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function uploadAttachments(_x, _x2) {
        return _ref.apply(this, arguments);
      }

      return uploadAttachments;
    }()
  }, {
    key: 'handleCheckChanges',
    value: function handleCheckChanges() {
      if (this.props.onChange) {
        this.props.onChange(true);
      }
    }
  }, {
    key: 'hasAccess',
    value: function hasAccess() {
      var check = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var admin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var dhq = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var dbl = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var internal = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      var auth = this.props.auth;
      if (dbl && this.props.auth.isBranchLeader) {
        return true;
      }
      if (dhq && this.props.auth.isHeadquarters) {
        return true;
      }
      if (admin && this.props.auth.isSuperAdmin) {
        return true;
      }
      if (internal && auth && auth.companyBranch && !auth.companyBranch.isExternal) {
        return true;
      }
      return check;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          data = _props.data,
          changeProjectID = _props.changeProjectID,
          changeSelectedProject = _props.changeSelectedProject,
          changeSelectedUnit = _props.changeSelectedUnit;
      var attachmentsUploadedCount = this.state.attachmentsUploadedCount;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          className: 'booking-change-unit',
          open: this.props.open === true,
          onClose: this.handleOnClose,
          size: 'small'
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'file text outline', content: this.props.headerNode || t('Perform unit change') + '?' }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: { paddingBottom: '1em' } },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid,
                { stackable: true },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      'p',
                      null,
                      t('Please confirm following changes')
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'booking-change-unit-info' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      { style: { marginLeft: 0, marginRight: 0 }, stackable: true },
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          'b',
                          null,
                          t('Project')
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        { columns: 2 },
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          null,
                          data && data.project ? data.project.name : '-'
                        ),
                        data.projectID !== changeProjectID && _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          null,
                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'caret right' }),
                          changeSelectedProject ? changeSelectedProject.text : '-'
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'booking-change-unit-info' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      { style: { marginLeft: 0, marginRight: 0 }, stackable: true },
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          'b',
                          null,
                          t('Unit')
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        { columns: 2 },
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          null,
                          data && data.projectUnit ? data.projectUnit.reference : '-'
                        ),
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          null,
                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'caret right' }),
                          changeSelectedUnit ? changeSelectedUnit.text : '-'
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'booking-change-unit-info' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid,
                      { style: { marginLeft: 0, marginRight: 0 }, stackable: true },
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          'b',
                          null,
                          t('Criteria')
                        )
                      ),
                      _react2.default.createElement(
                        _semanticUiReact.Grid.Row,
                        null,
                        _react2.default.createElement(
                          _semanticUiReact.Grid.Column,
                          null,
                          _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
                            label: t("Follow previous booking's Created Date"),
                            name: 'cuFollowPrevBookingDateIsEnabled',
                            checked: data.cuFollowPrevBookingDateIsEnabled,
                            onChange: this.handleCheckBoxChange,
                            disabled: data.project.cuDisabledEditingOfFollowPrevBookingDate && !this.hasAccess(false, true, true, true, true)
                          })
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Row,
                  { className: 'booking-change-unit-info' },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Column,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      null,
                      _react2.default.createElement(
                        'b',
                        null,
                        t('Attachments'),
                        data.cuAttachmentsRequired && '*'
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.Grid.Row,
                      { style: { paddingTop: '0.8em' } },
                      _react2.default.createElement(_UploadModal2.default, {
                        trigger: _react2.default.createElement(
                          'span',
                          null,
                          _react2.default.createElement(
                            _semanticUiReact.Button,
                            { basic: true },
                            _react2.default.createElement(_semanticUiReact.Icon, { name: 'attach' }),
                            t('Select File')
                          ),
                          attachmentsUploadedCount > 0 ? _react2.default.createElement(
                            _semanticUiReact.Label,
                            { color: 'blue', circular: true, size: 'tiny' },
                            attachmentsUploadedCount
                          ) : null
                        ),
                        ref: function ref(_ref2) {
                          _this2.uploadModal = _ref2;
                        },
                        header: 'attachments',
                        loading: this.state.loading,
                        onConfirm: function onConfirm(e, file) {
                          _this2.uploadAttachments(e, file);
                        },
                        onClose: this.handleUploadModalClose,
                        primary: false,
                        content: function content(opt) {
                          return _react2.default.createElement(_Form2.default, {
                            fileType: 'attachment',
                            btnText: 'Files',
                            loading: _this2.state.loading,
                            onSubmit: opt.onConfirm
                          });
                        }
                      })
                    ),
                    'Upload jpeg, jpg, png, pdf no larger than 10MB.'
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { negative: true, onClick: this.handleOnClose, icon: 'cancel', content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }) }),
          _react2.default.createElement(_semanticUiReact.Button, {
            positive: true,
            onClick: function onClick(e) {
              return _this2.handleOnConfirm(e, data);
            },
            icon: 'checkmark',
            content: t('Confirm', { ns: _translation.TRANSLATION_FILES.translation }),
            disabled: data.cuAttachmentsRequired && attachmentsUploadedCount < 1,
            'data-bot-target': 'confirm'
          })
        )
      );
    }
  }]);

  return BookingChangeUnit;
}(_react.Component);

BookingChangeUnit.propTypes = {
  auth: _propTypes2.default.shape({
    isBranchLeader: _propTypes2.default.bool,
    isHeadquarters: _propTypes2.default.bool,
    isAdminBasic: _propTypes2.default.bool,
    isSuperAdmin: _propTypes2.default.bool,
    isBranchLeaderSupervisorII: _propTypes2.default.bool
  }),
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func.isRequired,
  onConfirm: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func,
  headerNode: _propTypes2.default.node,
  data: _propTypes2.default.shape({
    projectID: _propTypes2.default.string,
    project: _propTypes2.default.shape({
      name: _propTypes2.default.string
    }),
    projectUnitID: _propTypes2.default.string,
    projectUnit: _propTypes2.default.shape({
      reference: _propTypes2.default.string
    })
  }).isRequired,
  changeProjectID: _propTypes2.default.string,
  changeSelectedProject: _propTypes2.default.shape({
    value: _propTypes2.default.string,
    text: _propTypes2.default.string
  }),
  changeSelectedUnit: _propTypes2.default.shape({
    value: _propTypes2.default.string,
    text: _propTypes2.default.string
  }),
  t: _propTypes2.default.func
};
BookingChangeUnit.contextTypes = {
  store: _propTypes2.default.object
};

BookingChangeUnit.mapStateToProps = function (state) {
  return {
    auth: state.auth
  };
};

exports.default = (0, _reactI18next.withTranslation)([].concat(_toConsumableArray(_translation.namespaces)))((0, _reactRedux.connect)(BookingChangeUnit.mapStateToProps)(BookingChangeUnit));

/***/ }),
/* 2512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _SearchProjectUnit = __webpack_require__(2188);

var _SearchProjectUnit2 = _interopRequireDefault(_SearchProjectUnit);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BookingSwapUnit = function (_Component) {
  _inherits(BookingSwapUnit, _Component);

  function BookingSwapUnit() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, BookingSwapUnit);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BookingSwapUnit.__proto__ || Object.getPrototypeOf(BookingSwapUnit)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    }, _this.handleOnComfirm = function (e) {
      e.preventDefault();
      if (_this.props.onConfirm) {
        _this.props.onConfirm(e);
      }
    }, _this.handleProjectUnitClear = function () {
      if (_this.props.projectUnitClear) {
        _this.props.projectUnitClear();
      }
    }, _this.handleProjectUnitSelect = function (value) {
      if (_this.props.projectUnitSelect) {
        _this.props.projectUnitSelect(value);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(BookingSwapUnit, [{
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          size: 'small',
          open: this.props.open === true,
          onClose: this.handleOnClose,
          closeOnDimmerClick: false,
          closeOnEscape: false
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: this.props.manualSwap ? 'refresh' : 'warning sign', content: t(this.props.manualSwap ? 'Change Unit' : 'Selected unit has just been reserved. Kindly select another unit.') }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            this.props.error && _react2.default.createElement(
              _semanticUiReact.Message,
              null,
              _react2.default.createElement(
                _semanticUiReact.Message.Header,
                null,
                t('Unit selected is unavailable for reservation'),
                '.'
              )
            ),
            _react2.default.createElement(_SearchProjectUnit2.default, {
              onClear: this.handleProjectUnitClear,
              onSelect: this.handleProjectUnitSelect,
              selectedValue: this.props.projectUnitselectedValue,
              projectID: this.props.projectID,
              hasAccess: this.props.hasAccess
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          this.props.manualSwap ? _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleOnClose, content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }) }) : _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleOnClose, icon: 'arrow left', content: t('Back To Units List') }),
          _react2.default.createElement(_semanticUiReact.Button, { positive: true, onClick: this.handleOnComfirm, disabled: this.props.projectUnitselectedValue.key === '', icon: 'checkmark', content: t('Change Unit') })
        )
      );
    }
  }]);

  return BookingSwapUnit;
}(_react.Component);

BookingSwapUnit.contextTypes = {
  store: _propTypes2.default.object
};
BookingSwapUnit.propTypes = {
  open: _propTypes2.default.bool.isRequired,
  onClose: _propTypes2.default.func.isRequired,
  onConfirm: _propTypes2.default.func.isRequired,
  projectUnitClear: _propTypes2.default.func.isRequired,
  projectUnitSelect: _propTypes2.default.func.isRequired,
  projectUnitselectedValue: _propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    title: _propTypes2.default.string.isRequired
  }).isRequired,
  projectID: _propTypes2.default.string.isRequired,
  hasAccess: _propTypes2.default.bool.isRequired,
  error: _propTypes2.default.bool.isRequired,
  manualSwap: _propTypes2.default.bool
};
BookingSwapUnit.defaultProps = {
  manualSwap: false
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(BookingSwapUnit);

/***/ }),
/* 2513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChangeBranchToExternal = function (_Component) {
  _inherits(ChangeBranchToExternal, _Component);

  function ChangeBranchToExternal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ChangeBranchToExternal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ChangeBranchToExternal.__proto__ || Object.getPrototypeOf(ChangeBranchToExternal)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    }, _this.handleOnComfirm = function (e) {
      e.preventDefault();
      if (_this.props.onConfirm) {
        _this.props.onConfirm(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ChangeBranchToExternal, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          basic: true,
          open: this.props.open === true,
          onClose: this.handleOnClose
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: this.props.headerNode || 'Confirm set business unit as agency?' }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            this.props.modalType.isHigherAccess && _react2.default.createElement(
              'p',
              null,
              'This will downgrade all staffs in ',
              _react2.default.createElement(
                'strong',
                null,
                this.props.branchShortName || 'business unit'
              ),
              ' to agent access level.'
            ),
            this.props.modalType.isProjectOwner && _react2.default.createElement(
              'p',
              null,
              'This will remove all projects ownership from ',
              _react2.default.createElement(
                'strong',
                null,
                this.props.branchShortName || 'business unit'
              ),
              '.'
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, negative: true, onClick: this.handleOnClose, icon: 'cancel', content: 'Cancel', inverted: true }),
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, positive: true, onClick: this.handleOnComfirm, icon: 'checkmark', content: 'Confirm', inverted: true })
        )
      );
    }
  }]);

  return ChangeBranchToExternal;
}(_react.Component);

ChangeBranchToExternal.contextTypes = {
  store: _propTypes2.default.object
};
ChangeBranchToExternal.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  branchShortName: _propTypes2.default.string,
  headerNode: _propTypes2.default.node,
  modalType: _propTypes2.default.shape({
    isProjectOwner: _propTypes2.default.bool,
    isHigherAccess: _propTypes2.default.bool
  }).isRequired
};
exports.default = ChangeBranchToExternal;

/***/ }),
/* 2514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _close = __webpack_require__(298);

var _close2 = _interopRequireDefault(_close);

var _hims = __webpack_require__(221);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConfirmHIMSUnitSync = function (_Component) {
  _inherits(ConfirmHIMSUnitSync, _Component);

  function ConfirmHIMSUnitSync() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ConfirmHIMSUnitSync);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConfirmHIMSUnitSync.__proto__ || Object.getPrototypeOf(ConfirmHIMSUnitSync)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ConfirmHIMSUnitSync, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          himsUnit = _props.himsUnit,
          srUnit = _props.srUnit;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          className: 'himsModal',
          open: this.props.open === true,
          onClose: this.handleOnClose,
          size: 'tiny'
        },
        _react2.default.createElement(
          _semanticUiReact.Modal.Header,
          null,
          _react2.default.createElement(
            'div',
            { className: 'modal_header' },
            'Warning: This Showroom Unit No ' + (srUnit ? srUnit.reference : '') + ' already linked to another HIMS Unit No',
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                basic: true,
                className: 'closeButton',
                onClick: this.handleOnClose
              },
              _react2.default.createElement('img', { src: _close2.default, alt: 'close' })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: { paddingBottom: '1em' } },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                _semanticUiReact.Table,
                { celled: true, fixed: true },
                _react2.default.createElement(
                  _semanticUiReact.TableHeader,
                  null,
                  _react2.default.createElement(
                    _semanticUiReact.TableRow,
                    { textAlign: 'center' },
                    _react2.default.createElement(_semanticUiReact.TableHeaderCell, { collapsing: true }),
                    _react2.default.createElement(
                      _semanticUiReact.TableHeaderCell,
                      null,
                      'Current'
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.TableHeaderCell,
                      null,
                      'New'
                    )
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.TableBody,
                  null,
                  srUnit && himsUnit && srUnit.id !== himsUnit.id && _react2.default.createElement(
                    _semanticUiReact.TableRow,
                    { textAlign: 'center' },
                    _react2.default.createElement(
                      _semanticUiReact.TableCell,
                      { collapsing: true },
                      _react2.default.createElement(
                        'b',
                        null,
                        'Showroom Unit No'
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.TableCell,
                      null,
                      srUnit.reference
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.TableCell,
                      null,
                      himsUnit.reference
                    )
                  ),
                  srUnit && himsUnit && srUnit[_hims.HIMS_PROJECT_DEVELOPMENT_ID] !== himsUnit[_hims.HIMS_PROJECT_DEVELOPMENT_ID] && _react2.default.createElement(
                    _semanticUiReact.TableRow,
                    { textAlign: 'center' },
                    _react2.default.createElement(
                      _semanticUiReact.TableCell,
                      { collapsing: true },
                      _react2.default.createElement(
                        'b',
                        null,
                        'Project Code'
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.TableCell,
                      null,
                      srUnit[_hims.HIMS_PROJECT_DEVELOPMENT_ID]
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.TableCell,
                      null,
                      himsUnit[_hims.HIMS_PROJECT_DEVELOPMENT_ID]
                    )
                  ),
                  srUnit && himsUnit && srUnit[_hims.HIMS_COMPONENT_ID] !== himsUnit[_hims.HIMS_COMPONENT_ID] && _react2.default.createElement(
                    _semanticUiReact.TableRow,
                    { textAlign: 'center' },
                    _react2.default.createElement(
                      _semanticUiReact.TableCell,
                      { collapsing: true },
                      _react2.default.createElement(
                        'b',
                        null,
                        'Component ID'
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.TableCell,
                      null,
                      srUnit[_hims.HIMS_COMPONENT_ID]
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.TableCell,
                      null,
                      himsUnit[_hims.HIMS_COMPONENT_ID]
                    )
                  ),
                  srUnit && himsUnit && srUnit[_hims.HIMS_UNIT_NUMBER] !== himsUnit[_hims.HIMS_UNIT_NUMBER] && _react2.default.createElement(
                    _semanticUiReact.TableRow,
                    { textAlign: 'center' },
                    _react2.default.createElement(
                      _semanticUiReact.TableCell,
                      { collapsing: true },
                      _react2.default.createElement(
                        'b',
                        null,
                        'HIMS Unit No'
                      )
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.TableCell,
                      null,
                      srUnit[_hims.HIMS_UNIT_NUMBER]
                    ),
                    _react2.default.createElement(
                      _semanticUiReact.TableCell,
                      null,
                      himsUnit[_hims.HIMS_UNIT_NUMBER]
                    )
                  )
                )
              ),
              _react2.default.createElement(
                'p',
                { style: { marginBottom: '1.5em', color: '#596975' } },
                'You are trying to assign a Showroom Unit that is already linked to an existing HIMS Unit.\xA0 If you proceed, it could result in data conflicts and inconsistencies within the HIMS system.\xA0 This may lead to errors and unexpected behavior.',
                _react2.default.createElement('br', null),
                _react2.default.createElement('br', null),
                'Are you sure you want to replace it?'
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { marginTop: '1.5em', textAlign: 'right' } },
            _react2.default.createElement(_semanticUiReact.Button, { basic: true, style: { marginRight: '1em' }, onClick: this.handleOnClose, icon: 'cancel', content: 'No' }),
            _react2.default.createElement(_semanticUiReact.Button, { primary: true, onClick: this.props.onConfirm, icon: 'checkmark', content: 'Yes' })
          )
        )
      );
    }
  }]);

  return ConfirmHIMSUnitSync;
}(_react.Component);

ConfirmHIMSUnitSync.propTypes = {
  open: _propTypes2.default.bool,
  himsUnit: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    reference: _propTypes2.default.string
  }),
  srUnit: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    reference: _propTypes2.default.string
  }),
  onClose: _propTypes2.default.func.isRequired,
  onConfirm: _propTypes2.default.func.isRequired
};
exports.default = ConfirmHIMSUnitSync;

/***/ }),
/* 2515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

var _DateTimePicker = __webpack_require__(314);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // 1. Import withTranslation HOC


_momentTimezone2.default.locale('en-gb');

var inputDateFormat = 'DD/MM/YYYY, hh:mm A';

var DateTimeForm = function (_Component) {
  _inherits(DateTimeForm, _Component);

  function DateTimeForm(props) {
    _classCallCheck(this, DateTimeForm);

    var _this = _possibleConstructorReturn(this, (DateTimeForm.__proto__ || Object.getPrototypeOf(DateTimeForm)).call(this, props));

    _initialiseProps.call(_this);

    var data = props.data || '';
    _this.state = {
      data: data
    };
    return _this;
  }

  _createClass(DateTimeForm, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var data = nextProps.data || '';
      this.setState({
        data: data
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var data = this.state.data;
      var t = this.props.t;


      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          open: this.props.open,
          onClose: this.handleOnClose,
          size: 'tiny',
          closeOnDimmerClick: false
        },
        _react2.default.createElement(
          _semanticUiReact.Header,
          null,
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'calendar' }),
          _react2.default.createElement(
            _semanticUiReact.Header.Content,
            null,
            this.props.headerNode || t('Date Time', { ns: _translation.TRANSLATION_FILES.translation }),
            _react2.default.createElement(
              _semanticUiReact.Header.Subheader,
              null,
              this.props.descriptionNode ? this.props.descriptionNode : ''
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { scrolling: this.props.scrolling || false },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { centered: true },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(_semanticUiReact.Grid.Column, { mobile: 16, tablet: 16, computer: 2, className: 'small-hide tablet-hide' }),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { mobile: 16, tablet: 16, computer: 12 },
                _react2.default.createElement(
                  'div',
                  { className: 'ui form' },
                  _react2.default.createElement(
                    _semanticUiReact.Form.Group,
                    { widths: 'equal' },
                    _react2.default.createElement(_semanticUiReact.Form.Input, {
                      fluid: true,
                      label: this.props.label ? this.props.label : '',
                      placeholder: this.props.placeholder ? this.props.placeholder : '',
                      value: data ? (0, _momentTimezone2.default)(data).format(inputDateFormat) : '',
                      readOnly: true
                    })
                  ),
                  _react2.default.createElement(_DateTimePicker2.default, {
                    closeable: false,
                    noPadding: true,
                    onChange: function onChange(value) {
                      return _this2.handleOnChange(value);
                    },
                    value: data ? (0, _momentTimezone2.default)(data).toDate() : '',
                    visible: true
                  })
                )
              ),
              _react2.default.createElement(_semanticUiReact.Grid.Column, { mobile: 16, tablet: 16, computer: 2, className: 'small-hide tablet-hide' })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleOnClose, icon: 'cancel', content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }) }),
          _react2.default.createElement(_semanticUiReact.Button, { color: 'blue', onClick: this.handleOnComfirm, icon: 'save', content: t('Save', { ns: _translation.TRANSLATION_FILES.translation }) })
        )
      );
    }
  }]);

  return DateTimeForm;
}(_react.Component);

// 6. Wrap the class export with the translation HOC


DateTimeForm.propTypes = {
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]).isRequired,
  headerNode: _propTypes2.default.node,
  descriptionNode: _propTypes2.default.node,
  placeholder: _propTypes2.default.string,
  label: _propTypes2.default.string,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  scrolling: _propTypes2.default.bool,
  t: _propTypes2.default.func.isRequired // 2. Add t function to propTypes
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleOnClose = function (e) {
    if (_this3.props.onClose) {
      _this3.props.onClose(e);
    }
  };

  this.handleOnComfirm = function (e) {
    e.preventDefault();
    var data = _this3.state.data;
    // remove timezone from date object (because API server has default timezone set)

    if (data) data = (0, _momentTimezone2.default)(data).format('YYYY-MM-DDTHH:mm:ss') + 'Z';
    if (_this3.props.onConfirm) {
      _this3.props.onConfirm(e, data);
    }
  };

  this.handleOnClear = function (e) {
    e.preventDefault();
    var data = _this3.state.data;

    data = null;
    _this3.setState({ data: data });
  };

  this.handleOnChange = function (value) {
    var data = _this3.state.data;

    data = value;
    _this3.setState({ data: data });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(DateTimeForm);

/***/ }),
/* 2516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _flash = __webpack_require__(5);

var _close = __webpack_require__(298);

var _close2 = _interopRequireDefault(_close);

var _hims = __webpack_require__(221);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HIMSUnitSync = function (_Component) {
  _inherits(HIMSUnitSync, _Component);

  function HIMSUnitSync(props) {
    _classCallCheck(this, HIMSUnitSync);

    var _this = _possibleConstructorReturn(this, (HIMSUnitSync.__proto__ || Object.getPrototypeOf(HIMSUnitSync)).call(this, props));

    _initialiseProps.call(_this);

    var state = HIMSUnitSync.getPropsToState(props);
    _this.state = _extends({
      srUnitID: '',
      himsUnitNo: '',
      srUnits: []
    }, state);
    return _this;
  }

  _createClass(HIMSUnitSync, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = HIMSUnitSync.getPropsToState(nextProps);
      this.setState(_extends({}, state));
    }
  }, {
    key: 'renderHIMSTable',
    value: function renderHIMSTable() {
      var data = this.state.data;

      return _react2.default.createElement(
        _semanticUiReact.Table,
        { celled: true, fixed: true },
        _react2.default.createElement(
          _semanticUiReact.Table.Header,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            { textAlign: 'center' },
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              { colSpan: '2' },
              'HIMS Unit List'
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            { textAlign: 'center' },
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              null,
              'No. Unit'
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.HeaderCell,
              null,
              'No. Lot PT'
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Table.Body,
          null,
          _react2.default.createElement(
            _semanticUiReact.Table.Row,
            { textAlign: 'center' },
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              data.no_unit
            ),
            _react2.default.createElement(
              _semanticUiReact.Table.Cell,
              null,
              data.no_lot_pt
            )
          )
        )
      );
    }
  }, {
    key: 'renderForm',
    value: function renderForm() {
      var _this2 = this;

      var _state = this.state,
          himsUnitNo = _state.himsUnitNo,
          srUnitID = _state.srUnitID,
          srUnits = _state.srUnits;

      return _react2.default.createElement(
        'div',
        { style: { marginTop: '2em' } },
        _react2.default.createElement(
          _semanticUiReact.Header,
          { as: 'h5', attached: 'top', textAlign: 'center', style: { background: '#E9ECF0' } },
          'Showroom'
        ),
        _react2.default.createElement(
          _semanticUiReact.Segment,
          { attached: true },
          _react2.default.createElement(
            _semanticUiReact.Form,
            null,
            _react2.default.createElement(
              _semanticUiReact.Form.Group,
              { widths: 'equal' },
              _react2.default.createElement(_semanticUiReact.Form.Select, {
                fluid: true,
                search: true,
                label: 'Unit',
                name: 'unit_no',
                options: srUnits && srUnits.map(function (unit) {
                  return {
                    value: unit.id,
                    text: unit.reference,
                    icon: _this2.checkUnitHasHimsFields(unit) ? {
                      color: 'green',
                      name: 'checkmark'
                    } : null
                  };
                }),
                placeholder: 'Unit No.',
                selectOnBlur: false,
                value: srUnitID || '',
                onChange: this.handleSelectUnit
              }),
              _react2.default.createElement(_semanticUiReact.Form.Input, {
                name: 'hims_unit_no',
                label: 'HIMS Unit No.',
                value: himsUnitNo || '',
                placeholder: 'HIMS Unit No.',
                readOnly: true
              })
            )
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var data = this.state.data;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          className: 'himsModal',
          open: this.props.open === true,
          onClose: this.handleOnClose,
          size: 'tiny'
        },
        _react2.default.createElement(
          _semanticUiReact.Modal.Header,
          null,
          _react2.default.createElement(
            'div',
            { className: 'modal_header' },
            (data.showroomUnitID ? 'Edit' : 'Match') + ' Unit and Lot No.',
            _react2.default.createElement(
              _semanticUiReact.Button,
              {
                basic: true,
                className: 'closeButton',
                onClick: function onClick() {
                  return _this3.handleOnClose();
                }
              },
              _react2.default.createElement('img', { src: _close2.default, alt: 'close' })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            { style: { paddingBottom: '1em' } },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'p',
                { style: { marginBottom: '1.5em', color: '#596975' } },
                'Please ensure HIMS\u2019s No. Unit and Showroom\u2019s unit matches.'
              ),
              this.renderHIMSTable(),
              this.renderForm()
            )
          ),
          _react2.default.createElement(
            'div',
            { style: { marginTop: '1.5em', textAlign: 'right' } },
            _react2.default.createElement(_semanticUiReact.Button, {
              basic: true,
              style: { marginRight: '1em' },
              onClick: this.handleOnClose,
              content: 'Cancel'
            }),
            _react2.default.createElement(_semanticUiReact.Button, {
              primary: true,
              onClick: this.handleOnConfirm,
              content: 'Save'
            })
          )
        )
      );
    }
  }]);

  return HIMSUnitSync;
}(_react.Component);

HIMSUnitSync.contextTypes = {
  store: _propTypes2.default.object
};
HIMSUnitSync.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func.isRequired,
  onConfirm: _propTypes2.default.func.isRequired,
  himsSetting: _propTypes2.default.shape({
    himsDeveloperCode: _propTypes2.default.string,
    himsDevelopmentCode: _propTypes2.default.string
  }),
  data: _propTypes2.default.object,
  srUnits: _propTypes2.default.array,
  unitCustomFieldSettings: _propTypes2.default.array
};

HIMSUnitSync.getPropsToState = function (props) {
  var data = props.data;
  var srUnits = props.srUnits;
  var srUnitID = data.showroomUnitID;
  var himsUnitNo = data && data.showroomUnit && data.showroomUnit.projectUnitCustomFields && data.showroomUnit.projectUnitCustomFields.length > 0 && data.showroomUnit.projectUnitCustomFields.find(function (pucf) {
    return pucf.projectUnitCustomFieldSettingID === _hims.HIMS_UNIT_NUMBER;
  }).value;
  return {
    data: data,
    srUnits: srUnits,
    himsUnitNo: himsUnitNo,
    srUnitID: srUnitID
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.handleOnClose = function (e) {
    if (_this4.props.onClose) {
      _this4.props.onClose(e);
    }
  };

  this.setHIMSFieldValue = function (id) {
    var himsSetting = _this4.props.himsSetting;
    var data = _this4.state.data;

    if (id === _hims.HIMS_DEVELOPER_CODE && himsSetting) {
      return himsSetting.himsDeveloperCode;
    }
    if (id === _hims.HIMS_PROJECT_DEVELOPMENT_ID && himsSetting) {
      return himsSetting.himsDevelopmentCode;
    }
    if (id === _hims.HIMS_UNIT_NUMBER) {
      return data.no_unit;
    }
    if (id === _hims.HIMS_COMPONENT_ID) {
      return data.pembangunan_id;
    }
    if (id === _hims.HIMS_LOT_PT) {
      return data.no_lot_pt;
    }
    if (id === _hims.HIMS_LOT_POSITION) {
      var lotPosition = _hims.HIMS_LOT_POSITION_OPTIONS.find(function (lp) {
        return lp.text.toUpperCase() === data.kedudukan_lot || lp.description.toUpperCase() === data.kedudukan_lot;
      });
      return lotPosition ? lotPosition.value : '';
    }
    return '';
  };

  this.checkUnitHasHimsFields = function (unit) {
    return unit.projectUnitCustomFields && unit.projectUnitCustomFields.reduce(function (count, cf) {
      if (_hims.HIMS_UNIT_MAIN_FIELDS.includes(cf.projectUnitCustomFieldSettingID) && cf.value) {
        return count + 1;
      }
      return count;
    }, 0) === _hims.HIMS_UNIT_MAIN_FIELDS.length;
  };

  this.handleOnConfirm = function (e) {
    e.preventDefault();
    var store = _this4.context.store;
    var _state2 = _this4.state,
        srUnits = _state2.srUnits,
        srUnitID = _state2.srUnitID;
    var _props = _this4.props,
        data = _props.data,
        unitCustomFieldSettings = _props.unitCustomFieldSettings;

    if (!srUnitID) {
      store.dispatch((0, _flash.flashErrorMessage)({
        header: 'Please fix form errors',
        message: 'Unit No. required'
      }));
    } else if (_this4.props.onConfirm) {
      var unitData = srUnits.find(function (unit) {
        return unit.id === srUnitID;
      });
      var oldUnitData = srUnits.find(function (unit) {
        return unit.id === data.showroomUnitID;
      });

      // set HIMS fields
      var newUnit = (0, _clone2.default)(unitData);
      var customFields = [];
      if (newUnit.projectUnitCustomFields) {
        newUnit.projectUnitCustomFields.forEach(function (p) {
          if (_hims.HIMS_UNIT_FIELDS.includes(p.projectUnitCustomFieldSettingID)) {
            p.value = _this4.setHIMSFieldValue(p.projectUnitCustomFieldSettingID);
          }
          customFields.push(p);
        });
      }
      if (unitCustomFieldSettings) {
        unitCustomFieldSettings.forEach(function (u) {
          var exists = -1;
          if (newUnit.projectUnitCustomFields) exists = newUnit.projectUnitCustomFields.findIndex(function (ucfData) {
            return ucfData.projectUnitCustomFieldSettingID === u.id;
          });
          if (exists === -1) {
            if (_hims.HIMS_UNIT_FIELDS.includes(u.id)) {
              var customField = {
                value: _this4.setHIMSFieldValue(u.id),
                projectUnitCustomFieldSettingID: u.id,
                projectUnitCustomFieldSetting: u
              };
              customFields.push(customField);
            }
          }
        });
      }
      newUnit.projectUnitCustomFields = customFields;
      _this4.props.onConfirm(e, newUnit, oldUnitData);
    }
  };

  this.handleSelectUnit = function (e, d) {
    var data = _this4.state.data;

    _this4.setState({
      himsUnitNo: data.no_unit,
      srUnitID: d.value
    });
  };
};

exports.default = HIMSUnitSync;

/***/ }),
/* 2517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _clone = __webpack_require__(21);

var _clone2 = _interopRequireDefault(_clone);

var _rcTimePicker = __webpack_require__(3148);

var _rcTimePicker2 = _interopRequireDefault(_rcTimePicker);

__webpack_require__(3504);

var _reactI18next = __webpack_require__(3);

var _InputBirthdate = __webpack_require__(220);

var _InputBirthdate2 = _interopRequireDefault(_InputBirthdate);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */


var fromMonth = (0, _momentTimezone2.default)().toDate();
var toMonth = new Date(fromMonth.getFullYear() + 1, fromMonth.getMonth(), fromMonth.getDate());

var LawyerAppointment = function (_Component) {
  _inherits(LawyerAppointment, _Component);

  function LawyerAppointment(props) {
    _classCallCheck(this, LawyerAppointment);

    var _this = _possibleConstructorReturn(this, (LawyerAppointment.__proto__ || Object.getPrototypeOf(LawyerAppointment)).call(this, props));

    _initialiseProps.call(_this);

    var state = LawyerAppointment.getPropsToState(props);
    _this.state = _extends({}, state);
    return _this;
  }

  _createClass(LawyerAppointment, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = LawyerAppointment.getPropsToState(nextProps);
      if (state.oriAppointment !== this.state.oriAppointment) {
        this.setState(state);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          loading = _props.loading,
          t = _props.t;
      var appointment = this.state.appointment;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          open: this.props.open === true,
          onClose: this.handleOnClose,
          closeIcon: 'close'
        },
        _react2.default.createElement(_semanticUiReact.Header, {
          icon: 'calendar outline',
          content: t('Schedule appointment for Buyer and Lawyer')
        }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            appointment.date_time ? _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { textAlign: 'left', mobile: 16, tablet: 4, computer: 4 },
                _react2.default.createElement(
                  _semanticUiReact.Header,
                  { as: 'h4' },
                  t('Scheduled date')
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { mobile: 10, tablet: 8, computer: 8 },
                _react2.default.createElement(_InputBirthdate2.default, {
                  format: null,
                  date: appointment.date_time.format('YYYY-MM-DD'),
                  onSelectDay: this.handleOnDateChange,
                  disabled: loading,
                  fromMonth: fromMonth,
                  toMonth: toMonth,
                  monthLogic: this.handleMonthLogic,
                  disabledDays: {
                    before: (0, _momentTimezone2.default)().toDate()
                  }
                })
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { mobile: 6, tablet: 4, computer: 4, textAlign: 'right' },
                _react2.default.createElement(_rcTimePicker2.default, {
                  use12Hours: true,
                  showSecond: false,
                  value: appointment.date_time,
                  onChange: this.handleOnDateChange,
                  format: 'hh:mm a',
                  inputReadOnly: true,
                  disabled: loading,
                  allowEmpty: false
                })
              )
            ) : Array(3).fill(3).map(function (d, idx) {
              return _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { key: idx },
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { textAlign: 'left', mobile: 16, tablet: 4, computer: 4 },
                  _react2.default.createElement(
                    _semanticUiReact.Header,
                    { as: 'h4' },
                    t('Slot {{number}}', { number: idx + 1 })
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 10, tablet: 8, computer: 8 },
                  _react2.default.createElement(_InputBirthdate2.default, {
                    format: null,
                    date: appointment['slot_' + (idx + 1)].format('YYYY-MM-DD'),
                    onSelectDay: function onSelectDay(day) {
                      return _this2.handleOnSlotChange(day, idx + 1);
                    },
                    disabled: loading,
                    fromMonth: fromMonth,
                    toMonth: toMonth,
                    monthLogic: _this2.handleMonthLogic,
                    disabledDays: {
                      before: (0, _momentTimezone2.default)().toDate()
                    }
                  })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 6, tablet: 4, computer: 4, textAlign: 'right' },
                  _react2.default.createElement(_rcTimePicker2.default, {
                    use12Hours: true,
                    showSecond: false,
                    value: appointment['slot_' + (idx + 1)],
                    onChange: function onChange(time) {
                      return _this2.handleOnSlotChange(time, idx + 1);
                    },
                    format: 'h:mm a',
                    inputReadOnly: true,
                    disabled: loading,
                    allowEmpty: false
                  })
                )
              );
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          { style: { justifyContent: 'center' } },
          _react2.default.createElement(_semanticUiReact.Button, {
            primary: true,
            onClick: this.handleOnConfirm,
            icon: 'checkmark',
            content: t('Confirm', { ns: _translation.TRANSLATION_FILES.translation }),
            disabled: loading
          })
        )
      );
    }
  }]);

  return LawyerAppointment;
}(_react.Component);

LawyerAppointment.contextTypes = {
  store: _propTypes2.default.object
};
LawyerAppointment.propTypes = {
  appointment: _propTypes2.default.shape({
    date_time: _propTypes2.default.string,
    slot_1: _propTypes2.default.string,
    slot_2: _propTypes2.default.string,
    slot_3: _propTypes2.default.string,
    remarks: _propTypes2.default.string
  }),
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  loading: _propTypes2.default.bool
};

LawyerAppointment.getPropsToState = function (props) {
  var oriAppointment = Object.assign({
    date_time: null,
    slot_1: null,
    slot_2: null,
    slot_3: null,
    remarks: ''
  }, props.appointment);
  var appointment = (0, _clone2.default)(oriAppointment);
  var hour = 12;
  var minute = 0;
  appointment.date_time = oriAppointment.date_time ? (0, _momentTimezone2.default)(oriAppointment.date_time) : null;
  appointment.slot_1 = oriAppointment.slot_1 ? (0, _momentTimezone2.default)(oriAppointment.slot_1) : (0, _momentTimezone2.default)();
  appointment.slot_2 = oriAppointment.slot_2 ? (0, _momentTimezone2.default)(oriAppointment.slot_2) : (0, _momentTimezone2.default)().add(1, 'days').set({ 'hour': hour, 'minute': minute });
  appointment.slot_3 = oriAppointment.slot_3 ? (0, _momentTimezone2.default)(oriAppointment.slot_3) : (0, _momentTimezone2.default)().add(2, 'days').set({ 'hour': hour, 'minute': minute });
  return {
    oriAppointment: oriAppointment,
    appointment: appointment
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleOnConfirm = function (e) {
    e.preventDefault();
    var onConfirm = _this3.props.onConfirm;

    if (onConfirm) {
      var appointment = _this3.state.appointment;

      var result = {};
      if (appointment.remarks) {
        result.remarks = appointment.remarks;
      }
      if (appointment.date_time) {
        result.date_time = appointment.date_time.format();
      } else {
        result.slot_1 = appointment.slot_1.format();
        result.slot_2 = appointment.slot_2.format();
        result.slot_3 = appointment.slot_3.format();
      }
      onConfirm(e, result);
    }
  };

  this.handleOnClose = function (e) {
    if (_this3.props.onClose) {
      _this3.props.onClose(e);
    }
  };

  this.handleOnSlotChange = function (day, idx) {
    var appointment = _this3.state.appointment;

    appointment['slot_' + idx] = day;
    _this3.setState({ appointment: appointment });
  };

  this.handleOnRemarksChange = function (e, _ref) {
    var value = _ref.value;
    var appointment = _this3.state.appointment;

    appointment.remarks = value;
    _this3.setState({ appointment: appointment });
  };

  this.handleOnDateChange = function (day) {
    var appointment = _this3.state.appointment;

    appointment.date_time = day;
    _this3.setState({ appointment: appointment });
  };

  this.handleMonthLogic = function (_ref2) {
    var year = _ref2.year,
        month = _ref2.month,
        currentYear = _ref2.currentYear,
        currentMonth = _ref2.currentMonth;
    return year === currentYear && month < currentMonth;
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(LawyerAppointment);

/***/ }),
/* 2518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _flash = __webpack_require__(5);

var _fetchM = __webpack_require__(6);

var _apiEndpoints = __webpack_require__(140);

var endpoints = _interopRequireWildcard(_apiEndpoints);

var _SearchFilter = __webpack_require__(47);

var _SearchFilter2 = _interopRequireDefault(_SearchFilter);

var _LawyerItem = __webpack_require__(384);

var _LawyerItem2 = _interopRequireDefault(_LawyerItem);

var _LimitCounter = __webpack_require__(1023);

var _LimitCounter2 = _interopRequireDefault(_LimitCounter);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LawyersList = function (_Component) {
  _inherits(LawyersList, _Component);

  function LawyersList(props) {
    _classCallCheck(this, LawyersList);

    var _this = _possibleConstructorReturn(this, (LawyersList.__proto__ || Object.getPrototypeOf(LawyersList)).call(this, props));

    _initialiseProps.call(_this);

    var state = LawyersList.getPropsToState(props);
    _this.state = _extends({}, state, {
      selected: [],
      data: [],
      loading: true,
      search: '',
      from: 0,
      nextToken: '',
      hasMore: false
    });
    _this.timer = null;
    return _this;
  }

  _createClass(LawyersList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = LawyersList.getPropsToState(nextProps);
      if (nextProps.loanTrackerProjectID && nextProps.open && this.props.open !== nextProps.open) {
        this.fetchRecentAddedLawyers(nextProps.loanTrackerProjectID);
      }
      this.setState(state);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.clearTimer();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var isLimit = this.props.selectLimit && this.props.selectLimit > 0 && this.state.selected.length + this.state.oriSelected.length >= this.props.selectLimit;
      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          open: this.props.open === true,
          onClose: this.handleOnClose,
          closeIcon: 'close',
          size: 'large',
          className: 'items-list-modal'
        },
        _react2.default.createElement(_semanticUiReact.Header, {
          icon: 'add',
          content: 'Add lawyers'
        }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { verticalAlign: 'middle', columns: 1 },
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              null,
              _react2.default.createElement(_SearchFilter2.default, {
                isLoading: this.state.loading,
                onChange: this.handleOnChange,
                onClose: this.handleClearFilter,
                search: this.state.search,
                disabled: isLimit,
                searchAtKeyEnd: true
              })
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Column,
              { className: 'list' },
              _react2.default.createElement(
                _semanticUiReact.Dimmer,
                {
                  inverted: true, style: { zIndex: 20 },
                  active: this.state.loading && this.state.data.length > 0
                },
                _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { inline: 'centered' },
                  'Loading'
                )
              ),
              this.state.search === '' ? _react2.default.createElement(
                _semanticUiReact.Header,
                { as: 'h5' },
                'Recently added lawyers'
              ) : null,
              this.state.data.length > 0 ? _react2.default.createElement(
                _semanticUiReact.Table,
                { unstackable: true },
                _react2.default.createElement(
                  _semanticUiReact.Table.Body,
                  null,
                  this.state.data.map(function (lawyer, idx) {
                    var isExisted = _this2.state.oriSelected.some(function (s) {
                      return s.lawyer_id === lawyer.id;
                    });
                    var isSelected = _this2.state.selected.some(function (s) {
                      return s.id === lawyer.id;
                    });
                    return _react2.default.createElement(
                      _semanticUiReact.Table.Row,
                      {
                        key: idx,
                        positive: isExisted || isSelected,
                        active: _this2.handleOnCheck(lawyer)
                      },
                      _react2.default.createElement(
                        _semanticUiReact.Table.Cell,
                        null,
                        _react2.default.createElement(_LawyerItem2.default, {
                          item: lawyer,
                          onClick: _this2.handleOnSelect,
                          selected: isExisted || isSelected,
                          disabled: _this2.handleOnCheck(lawyer) || isExisted || isLimit,
                          checkable: _this2.state.search.length > 0,
                          rightComponentTextAlign: 'right',
                          rightComponent: _this2.state.search === '' ? _react2.default.createElement(_semanticUiReact.Button, {
                            size: 'small',
                            basic: true,
                            primary: true,
                            onClick: function onClick(e) {
                              return _this2.props.onItemClick(e, [lawyer.id]);
                            },
                            content: isExisted ? 'Added' : 'Add',
                            disabled: _this2.handleOnCheck(lawyer) || isExisted || isLimit
                          }) : null
                        })
                      )
                    );
                  })
                )
              ) : _react2.default.createElement(
                _semanticUiReact.Segment,
                { textAlign: 'center' },
                this.state.loading ? _react2.default.createElement(
                  _semanticUiReact.Loader,
                  { active: true, inline: 'centered' },
                  'Loading'
                ) : 'No lawyer found.'
              ),
              this.state.data.length > 0 && this.state.hasMore ? _react2.default.createElement(
                _semanticUiReact.Segment,
                { basic: true, textAlign: 'center' },
                _react2.default.createElement(_semanticUiReact.Button, {
                  onClick: this.handleLoadMore,
                  content: 'Load more'
                })
              ) : null
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          this.props.selectLimit && this.props.selectLimit > 0 && this.state.oriSelected.length < this.props.selectLimit ? _react2.default.createElement(_LimitCounter2.default, {
            current: this.state.selected.length,
            limit: this.props.selectLimit - this.state.oriSelected.length,
            primaryText: 'lawyers'
          }) : null,
          _react2.default.createElement(_semanticUiReact.Button, {
            primary: true,
            onClick: this.handleOnConfirm,
            icon: 'checkmark',
            content: 'Add',
            disabled: isLimit || this.state.selected.length < 1
          })
        )
      );
    }
  }]);

  return LawyersList;
}(_react.Component);

LawyersList.contextTypes = {
  store: _propTypes2.default.object
};
LawyersList.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  onCheck: _propTypes2.default.func,
  queryLimit: _propTypes2.default.number,
  selectLimit: _propTypes2.default.number,
  selected: _propTypes2.default.arrayOf(_propTypes2.default.object),
  loanTrackerProjectID: _propTypes2.default.number,
  onItemClick: _propTypes2.default.func
};
LawyersList.defaultProps = {
  queryLimit: 10,
  selectLimit: 0,
  loanTrackerProjectID: 0,
  onItemClick: function onItemClick() {}
};

LawyersList.getPropsToState = function (props) {
  var oriSelected = [].concat(props.selected);
  return {
    oriSelected: oriSelected
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.setLawyers = function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var expand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return new Promise(function (res) {
      _this3.setState(_extends({
        data: expand ? [].concat(_this3.state.data, data) : data || []
      }, state), function () {
        res.apply(undefined, [data].concat(_toConsumableArray(state)));
      });
    });
  };

  this.setLoading = function () {
    var loading = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    return new Promise(function (res) {
      return _this3.setState({ loading: loading }, function () {
        return res(loading);
      });
    });
  };

  this.setComponentState = function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return new Promise(function (res) {
      return _this3.setState(state, function () {
        return res(state);
      });
    });
  };

  this.clearTimer = function () {
    if (_this3.timer) {
      clearTimeout(_this3.timer);
    }
  };

  this.fetchRecentAddedLawyers = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var projectID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.props.loanTrackerProjectID;
      var store, query, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3.setComponentState({ loading: true, data: [] });

            case 2:
              store = _this3.context.store;

              if (projectID) {
                _context.next = 7;
                break;
              }

              _context.next = 6;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'This project is not linked in loan tracker.' }));

            case 6:
              return _context.abrupt('return');

            case 7:
              query = {
                limit: 6,
                project_id: projectID
              };
              res = void 0;
              _context.prev = 9;
              _context.next = 12;
              return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.LAWYERS + '/?' + _qs2.default.stringify(query)));

            case 12:
              res = _context.sent;
              _context.next = 23;
              break;

            case 15:
              _context.prev = 15;
              _context.t0 = _context['catch'](9);

              Bugsnag.notifyException(_context.t0);
              _context.next = 20;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

            case 20:
              _context.next = 22;
              return _this3.setLoading(false);

            case 22:
              return _context.abrupt('return');

            case 23:
              if (!res) {
                _context.next = 26;
                break;
              }

              _context.next = 26;
              return _this3.setLawyers(res.items);

            case 26:
              _context.next = 28;
              return _this3.setLoading(false);

            case 28:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3, [[9, 15]]);
    }));

    return function () {
      return _ref.apply(this, arguments);
    };
  }();

  this.fetchSearchLawyers = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var projectID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this3.props.loanTrackerProjectID;

      var store, queryLimit, query, _state, search, from, nextToken, res, state;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.setComponentState({ loading: true });

            case 2:
              store = _this3.context.store;
              queryLimit = _this3.props.queryLimit;

              if (projectID) {
                _context2.next = 8;
                break;
              }

              _context2.next = 7;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'This project is not linked in loan tracker.' }));

            case 7:
              return _context2.abrupt('return');

            case 8:
              query = {
                limit: queryLimit,
                project_id: projectID
              };
              _state = _this3.state, search = _state.search, from = _state.from, nextToken = _state.nextToken;

              if (_this3.state.search) {
                query.search = search;
                query.from = from;
              } else if (nextToken) {
                query.next_token = nextToken;
              }
              res = void 0;
              _context2.prev = 12;
              _context2.next = 15;
              return store.dispatch((0, _fetchM.fetchAPI)('lawyerAPI', endpoints.LAWYERS + '/?' + _qs2.default.stringify(query)));

            case 15:
              res = _context2.sent;
              _context2.next = 26;
              break;

            case 18:
              _context2.prev = 18;
              _context2.t0 = _context2['catch'](12);

              Bugsnag.notifyException(_context2.t0);
              _context2.next = 23;
              return store.dispatch((0, _flash.flashErrorMessage)({ message: 'An error occurred, please refresh page' }));

            case 23:
              _context2.next = 25;
              return _this3.setLoading(false);

            case 25:
              return _context2.abrupt('return');

            case 26:
              if (!res) {
                _context2.next = 30;
                break;
              }

              state = res.next_token ? {
                nextToken: res.next_token,
                hasMore: !!res.next_token,
                from: 0
              } : {
                nextToken: '',
                from: from + queryLimit,
                hasMore: res.total_hits > from + queryLimit
              };
              _context2.next = 30;
              return _this3.setLawyers(res.items, state, !!nextToken || from > 0);

            case 30:
              _context2.next = 32;
              return _this3.setLoading(false);

            case 32:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this3, [[12, 18]]);
    }));

    return function () {
      return _ref2.apply(this, arguments);
    };
  }();

  this.handleOnConfirm = function (e) {
    e.preventDefault();
    if (_this3.props.onConfirm) {
      _this3.props.onConfirm(e, _this3.state.selected.map(function (s) {
        return s.id;
      }));
    }
  };

  this.handleOnClose = function (e) {
    if (_this3.props.onClose) {
      _this3.props.onClose(e);
    }
  };

  this.handleOnSelect = function (e, lawyer) {
    var _state2 = _this3.state,
        search = _state2.search,
        selected = _state2.selected;

    if (search === '') {
      return;
    }
    var index = selected.findIndex(function (b) {
      return b.id === lawyer.id;
    });
    if (index < 0) {
      if (_this3.handleOnCheck(lawyer)) {
        return;
      }
      selected.push(lawyer);
    } else {
      selected.splice(index, 1);
    }
    _this3.setState({ selected: selected }, function () {
      if (_this3.props.onSelect) {
        _this3.props.onSelect(lawyer);
      }
    });
  };

  this.handleOnCheck = function (lawyer) {
    if (_this3.props.onCheck) {
      var selected = _this3.state.selected;

      return _this3.props.onCheck(lawyer, selected);
    }
    return false;
  };

  this.handleClearFilter = function () {
    _this3.setState({ search: '', data: [] }, function () {
      _this3.fetchRecentAddedLawyers();
    });
  };

  this.handleOnChange = function (search) {
    _this3.clearTimer();

    if (search !== _this3.state.search) {
      _this3.timer = setTimeout(function () {
        _this3.setState({ search: search, data: [], from: 0 }, function () {
          _this3.fetchSearchLawyers();
        });
      }, 500);
    }
  };

  this.handleLoadMore = function () {
    _this3.fetchSearchLawyers();
  };
};

exports.default = LawyersList;

/***/ }),
/* 2519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MoveStaffToExternalBranch = function (_Component) {
  _inherits(MoveStaffToExternalBranch, _Component);

  function MoveStaffToExternalBranch() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MoveStaffToExternalBranch);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MoveStaffToExternalBranch.__proto__ || Object.getPrototypeOf(MoveStaffToExternalBranch)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    }, _this.handleOnComfirm = function (e) {
      e.preventDefault();
      if (_this.props.onConfirm) {
        _this.props.onConfirm(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MoveStaffToExternalBranch, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          basic: true,
          open: this.props.open === true,
          onClose: this.handleOnClose
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: this.props.headerNode || 'Confirm move staff to agency?' }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            _react2.default.createElement(
              'p',
              null,
              'This action will downgrade ',
              _react2.default.createElement(
                'strong',
                null,
                this.props.staffpreferredName || 'this staff'
              ),
              ' to agent access level.'
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, negative: true, onClick: this.handleOnClose, icon: 'cancel', content: 'Cancel', inverted: true }),
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, positive: true, onClick: this.handleOnComfirm, icon: 'checkmark', content: 'Confirm', inverted: true })
        )
      );
    }
  }]);

  return MoveStaffToExternalBranch;
}(_react.Component);

MoveStaffToExternalBranch.contextTypes = {
  store: _propTypes2.default.object
};
MoveStaffToExternalBranch.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  staffpreferredName: _propTypes2.default.string,
  headerNode: _propTypes2.default.node
};
exports.default = MoveStaffToExternalBranch;

/***/ }),
/* 2520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _webValidations = __webpack_require__(23);

var _flash = __webpack_require__(5);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultiUnitAllocate = function (_Component) {
  _inherits(MultiUnitAllocate, _Component);

  function MultiUnitAllocate(props) {
    _classCallCheck(this, MultiUnitAllocate);

    var _this = _possibleConstructorReturn(this, (MultiUnitAllocate.__proto__ || Object.getPrototypeOf(MultiUnitAllocate)).call(this, props));

    _initialiseProps.call(_this);

    var errors = {
      size: '',
      spaAmount: '',
      position: '',
      allocate: ''
    };
    _this.state = {
      errors: errors,
      fieldValue: [],
      messageText: '',
      selectedEditField: '',
      showMessage: false,
      vErrMessages: [],
      clearAll: false
    };
    _this.validation = {};
    return _this;
  }

  _createClass(MultiUnitAllocate, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          messageText = _state.messageText,
          showMessage = _state.showMessage,
          clearAll = _state.clearAll;
      var _props = this.props,
          selectedRowsData = _props.selectedRowsData,
          lockedRowsData = _props.lockedRowsData,
          businessUnit = _props.businessUnit,
          t = _props.t;

      var tr = function tr(key) {
        return t(key, { ns: _translation.TRANSLATION_FILES.translation });
      };
      var clearAllOption = [{ text: tr('Clear All Allocations'), value: null }];
      var agencyOptions = clearAllOption.concat(businessUnit);
      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          closeIcon: true,
          closeOnEscape: false,
          closeOnDimmerClick: false,
          onClose: this.handleOnClose,
          open: this.props.open === true,
          size: 'tiny'
        },
        _react2.default.createElement(
          _semanticUiReact.Modal.Header,
          { style: { textAlign: 'center' } },
          tr('Allocate')
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { style: { padding: '2em 8em' } },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { verticalAlign: 'middle' },
                _react2.default.createElement(
                  'b',
                  null,
                  tr('Choose agency to allocate:')
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(_semanticUiReact.Dropdown, {
                  onChange: this.handleInputChange,
                  name: 'companyBranchAllocationIDs',
                  placeholder: tr('Select agency'),
                  fluid: true,
                  multiple: true,
                  search: true,
                  selection: true,
                  selectOnBlur: false,
                  options: clearAll ? clearAllOption : agencyOptions
                })
              )
            ),
            showMessage ? _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { style: { padding: '0.5em 0' } },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Message,
                  {
                    onDismiss: this.handleDismissMessage,
                    success: true,
                    size: 'tiny',
                    style: { margin: '0' }
                  },
                  _react2.default.createElement(
                    'b',
                    null,
                    messageText
                  )
                )
              )
            ) : '',
            lockedRowsData.length > 0 && _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              { style: { padding: '0.5em 0' } },
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Message,
                  { warning: true, size: 'tiny', style: { margin: '0' } },
                  selectedRowsData.length === 0 ? tr('None of the selected units can be allocated:') : tr('The agency will not change for these units:'),
                  ' ',
                  _react2.default.createElement(
                    'b',
                    null,
                    lockedRowsData.map(function (data) {
                      return data.reference;
                    }).join(', ')
                  ),
                  ' ',
                  tr('(Reserved, Booked or Sold units keep their agency).')
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { color: 'teal' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Label.Group,
                      { color: 'teal', size: 'mini' },
                      selectedRowsData.length > 0 ? selectedRowsData.map(function (data, idx) {
                        return _react2.default.createElement(
                          _semanticUiReact.Label,
                          {
                            as: selectedRowsData.length > 1 ? 'a' : 'div',
                            key: idx,
                            onClick: function onClick(e) {
                              return selectedRowsData.length > 1 && _this2.handleOnDeselectUnit(e, data.rowID);
                            },
                            title: selectedRowsData.length > 1 ? tr('Deselect unit') : ''
                          },
                          data.reference,
                          ' ',
                          selectedRowsData.length > 1 ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove', style: { marginRight: '0' } }) : ''
                        );
                      }) : null
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          { style: { textAlign: 'center' } },
          _react2.default.createElement(_semanticUiReact.Button, { disabled: this.checkConfirmIsDisabled(), onClick: function onClick(e) {
              return _this2.handleOnSave(e, true);
            }, content: tr('Apply & Close'), primary: true }),
          _react2.default.createElement(_semanticUiReact.Button, { disabled: this.checkConfirmIsDisabled(), onClick: function onClick(e) {
              return _this2.handleOnSave(e, false);
            }, content: tr('Apply') }),
          _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleOnClose, content: tr('Close') })
        )
      );
    }
  }]);

  return MultiUnitAllocate;
}(_react.Component);

MultiUnitAllocate.contextTypes = {
  store: _propTypes2.default.object
};
MultiUnitAllocate.propTypes = {
  onClose: _propTypes2.default.func.isRequired,
  onDeselectUnit: _propTypes2.default.func.isRequired,
  onSave: _propTypes2.default.func.isRequired,
  open: _propTypes2.default.bool.isRequired,
  businessUnit: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.number.isRequired
  })).isRequired,
  selectedRowsData: _propTypes2.default.oneOfType([_propTypes2.default.array.isRequired]).isRequired,
  allowEditUnitDetails: _propTypes2.default.bool.isRequired,
  t: _propTypes2.default.func.isRequired,
  // Selected units whose agency cannot change (Vietnam: Reserved, Booked or Sold). They are
  // listed in a warning and left out of selectedRowsData so nothing is applied to them.
  lockedRowsData: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    rowID: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    reference: _propTypes2.default.string
  }))
};
MultiUnitAllocate.defaultProps = {
  lockedRowsData: []
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.checkConfirmIsDisabled = function () {
    var _state2 = _this3.state,
        errors = _state2.errors,
        fieldValue = _state2.fieldValue;

    if (errors.allocate !== '') {
      return true;
    }
    if (_this3.props.selectedRowsData.length === 0) {
      return true;
    }
    if (!fieldValue) {
      return true;
    }
    return false;
  };

  this.handleDismissMessage = function () {
    _this3.setState({ showMessage: false });
  };

  this.handleInputChange = function (e, data) {
    var value = data.value;
    var clear = false;
    if (data.value.some(function (v) {
      return v === null;
    })) {
      // clear all allocations
      value = [];
      clear = true;
    }
    _this3.setState({
      fieldValue: value,
      selectedEditField: data.name,
      clearAll: clear
    });
  };

  this.handleOnClose = function (e) {
    e.preventDefault();
    if (_this3.props.onClose) {
      _this3.props.onClose();
    }
    _this3.setState({
      selectedEditField: '',
      fieldValue: [],
      messageText: '',
      showMessage: false,
      clearAll: false
    });
  };

  this.handleOnDeselectUnit = function (e, rowID) {
    e.preventDefault();
    var selectedRowsData = _this3.props.selectedRowsData;

    var row = selectedRowsData.find(function (r) {
      return r.rowID === rowID;
    });
    var messageText = _this3.props.t('Successfully deselected unit {{reference}}', {
      reference: row.reference, ns: _translation.TRANSLATION_FILES.translation
    });
    if (_this3.props.onDeselectUnit) {
      _this3.props.onDeselectUnit(e, rowID);
    }
    _this3.setState({ messageText: messageText, showMessage: true });
  };

  this.handleOnSave = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e, closeModal) {
      var store, _state3, selectedEditField, fieldValue, vErrMessages, showMessage, messageText;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store = _this3.context.store;

              e.preventDefault();
              _state3 = _this3.state, selectedEditField = _state3.selectedEditField, fieldValue = _state3.fieldValue, vErrMessages = _state3.vErrMessages;

              if (!(vErrMessages.length > 0)) {
                _context.next = 7;
                break;
              }

              _context.next = 6;
              return store.dispatch((0, _flash.flashErrorMessage)({
                header: _this3.props.t('Please fix form errors', { ns: _translation.TRANSLATION_FILES.translation }),
                list: vErrMessages.map(function (l) {
                  return l.message;
                })
              }));

            case 6:
              return _context.abrupt('return');

            case 7:
              showMessage = false;
              messageText = '';

              if (_this3.props.onSave) {
                _this3.props.onSave(closeModal, selectedEditField, fieldValue);
              }
              if (!closeModal && selectedEditField !== '' && fieldValue !== '') {
                messageText = _this3.props.t('Successfully allocate agency for selected units', { ns: _translation.TRANSLATION_FILES.translation });
                showMessage = true;
              }
              if (closeModal) {
                _this3.setState({ clearAll: false });
              }
              _this3.setState({
                fieldValue: '',
                selectedEditField: '',
                messageText: messageText,
                showMessage: showMessage
              });

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();

  this.handleDataChange = function (data) {
    var vErrMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    _this3.setState({ fieldValue: data, vErrMessages: vErrMessages });
  };

  this.handleOnError = function (hasError, errorMessage, inputName) {
    var errors = _this3.state.errors;

    errors[inputName] = errorMessage;
    if (hasError) {
      errors[inputName] = errorMessage;
    } else {
      errors[inputName] = '';
    }
    _this3.setState({ errors: errors });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(MultiUnitAllocate);

/***/ }),
/* 2521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultiUnitCheck = function (_Component) {
  _inherits(MultiUnitCheck, _Component);

  function MultiUnitCheck() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MultiUnitCheck);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MultiUnitCheck.__proto__ || Object.getPrototypeOf(MultiUnitCheck)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnConfirm = function (e) {
      e.preventDefault();
      if (_this.props.onConfirm) {
        _this.props.onConfirm(e);
      }
    }, _this.handleOnCancel = function (e) {
      e.preventDefault();
      if (_this.props.onCancel) {
        _this.props.onCancel(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MultiUnitCheck, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          closeOnEscape: false,
          closeOnDimmerClick: false,
          open: this.props.open === true,
          size: 'small'
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: 'Unsaved changes' }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            _react2.default.createElement(
              'p',
              null,
              'You have unsaved changes. Do you still want to ',
              _react2.default.createElement(
                'strong',
                null,
                'continue'
              ),
              '?'
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(
            _semanticUiReact.Button,
            { basic: true, inverted: true, negative: true, onClick: this.handleOnCancel },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove' }),
            ' No'
          ),
          _react2.default.createElement(
            _semanticUiReact.Button,
            { basic: true, inverted: true, positive: true, onClick: this.handleOnConfirm },
            _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove' }),
            ' Yes'
          )
        )
      );
    }
  }]);

  return MultiUnitCheck;
}(_react.Component);

MultiUnitCheck.contextTypes = {
  store: _propTypes2.default.object
};
MultiUnitCheck.propTypes = {
  onCancel: _propTypes2.default.func.isRequired,
  onConfirm: _propTypes2.default.func.isRequired,
  open: _propTypes2.default.bool
};
exports.default = MultiUnitCheck;

/***/ }),
/* 2522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _webValidations = __webpack_require__(23);

var _flash = __webpack_require__(5);

var _unitStatuses = __webpack_require__(266);

var _AppForm = __webpack_require__(20);

var _AppForm2 = _interopRequireDefault(_AppForm);

var _SpecificationTable = __webpack_require__(127);

var _SpecificationTable2 = _interopRequireDefault(_SpecificationTable);

var _SelectBank = __webpack_require__(218);

var _SelectBank2 = _interopRequireDefault(_SelectBank);

var _MultiUnitPackagePricing = __webpack_require__(1079);

var _MultiUnitPackagePricing2 = _interopRequireDefault(_MultiUnitPackagePricing);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultiUnitEdit = function (_Component) {
  _inherits(MultiUnitEdit, _Component);

  function MultiUnitEdit(props) {
    _classCallCheck(this, MultiUnitEdit);

    var _this = _possibleConstructorReturn(this, (MultiUnitEdit.__proto__ || Object.getPrototypeOf(MultiUnitEdit)).call(this, props));

    _initialiseProps.call(_this);

    var allowEditUnitPrice = props.allowEditUnitPrice,
        allowEditUnitDetails = props.allowEditUnitDetails,
        sellingPriceCustomName = props.sellingPriceCustomName,
        vaIsEnabled = props.vaIsEnabled;

    var editOptions = [];
    if (allowEditUnitDetails) {
      editOptions.push({ text: 'Layout Type', value: 'projectUnitLayoutID' }, { text: 'Status', value: 'statusID' }, { text: 'Size', value: 'size' });
    }
    if (allowEditUnitPrice) {
      editOptions.push({
        text: sellingPriceCustomName || 'Selling Price',
        value: 'spaAmount'
      });
    }
    if (allowEditUnitDetails) {
      editOptions.push({ text: 'Bumiputra', value: 'isBumi' }, { text: 'Address', value: 'address' }, { text: 'Position', value: 'position' }, { text: 'Level/Street Number', value: 'streetNumberOrLevel' }, { text: 'Block/Zone', value: 'zoneOrBlock' }, { text: 'Facing/Street', value: 'streetOrFacing' }, { text: 'Public Notes', value: 'remarkExternal' }, { text: 'Internal Notes', value: 'remarkInternal' });
    }
    if (allowEditUnitPrice) {
      editOptions.push({ text: 'Pricing Package', value: 'projectUnitPackagePricings' });
    }
    if (allowEditUnitDetails) {
      editOptions.push({ text: 'Specifications', value: 'specifications' });
    }
    if (vaIsEnabled) {
      editOptions = editOptions.concat([{ text: 'VA Bank Name', value: 'vaBankName' }, { text: 'VA Account Number', value: 'vaAccountNumber' }]);
    }
    var errors = {
      size: '',
      spaAmount: '',
      position: ''
    };
    _this.state = {
      editOptions: editOptions,
      errors: errors,
      fieldValue: '',
      messageText: '',
      selectedEditField: '',
      showMessage: false,
      spaType: 'manual',
      vErrMessages: [],
      sellingPriceCustomName: sellingPriceCustomName
    };
    _this.validation = {
      spaAmount: (0, _react.createRef)(),
      size: (0, _react.createRef)(),
      position: (0, _react.createRef)()
    };
    return _this;
  }

  _createClass(MultiUnitEdit, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var allowEditUnitPrice = nextProps.allowEditUnitPrice,
          allowEditUnitDetails = nextProps.allowEditUnitDetails,
          sellingPriceCustomName = nextProps.sellingPriceCustomName,
          vaIsEnabled = nextProps.vaIsEnabled;

      if (allowEditUnitDetails !== this.props.allowEditUnitDetails || allowEditUnitPrice !== this.props.allowEditUnitPrice || vaIsEnabled !== this.props.vaIsEnabled) {
        var editOptions = [];
        if (allowEditUnitDetails) {
          editOptions.push({ text: 'Layout Type', value: 'projectUnitLayoutID' }, { text: 'Status', value: 'statusID' }, { text: 'Size', value: 'size' });
        }
        if (allowEditUnitPrice) {
          editOptions.push({
            text: sellingPriceCustomName || 'Selling Price',
            value: 'spaAmount'
          });
        }
        if (allowEditUnitDetails) {
          editOptions.push({ text: 'Bumiputra', value: 'isBumi' }, { text: 'Address', value: 'address' }, { text: 'Position', value: 'position' }, { text: 'Level/Street Number', value: 'streetNumberOrLevel' }, { text: 'Block/Zone', value: 'zoneOrBlock' }, { text: 'Facing/Street', value: 'streetOrFacing' }, { text: 'Public Notes', value: 'remarkExternal' }, { text: 'Internal Notes', value: 'remarkInternal' });
        }
        if (allowEditUnitPrice) {
          editOptions.push({ text: 'Pricing Package', value: 'projectUnitPackagePricings' });
        }
        if (allowEditUnitDetails) {
          editOptions.push({ text: 'Specifications', value: 'specifications' });
        }
        if (vaIsEnabled) {
          editOptions = editOptions.concat([{ text: 'VA Bank Name', value: 'vaBankName' }, { text: 'VA Account Number', value: 'vaAccountNumber' }]);
        }
        this.setState({ editOptions: editOptions, sellingPriceCustomName: sellingPriceCustomName });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          errors = _state.errors,
          fieldValue = _state.fieldValue,
          messageText = _state.messageText,
          selectedEditField = _state.selectedEditField,
          showMessage = _state.showMessage,
          spaType = _state.spaType,
          editOptions = _state.editOptions,
          sellingPriceCustomName = _state.sellingPriceCustomName;
      var _props = this.props,
          countryCode = _props.countryCode,
          selectedRowsData = _props.selectedRowsData;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          closeIcon: true,
          closeOnEscape: false,
          closeOnDimmerClick: false,
          onClose: this.handleOnClose,
          open: this.props.open === true
        },
        _react2.default.createElement(
          _semanticUiReact.Modal.Header,
          null,
          'Multi Edit'
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Grid,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 3, textAlign: 'right', verticalAlign: 'middle' },
                _react2.default.createElement(
                  'b',
                  null,
                  'Choose field to edit:'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 13 },
                _react2.default.createElement(_semanticUiReact.Dropdown, {
                  placeholder: 'Select field',
                  fluid: true,
                  selection: true,
                  options: editOptions,
                  selectOnBlur: false,
                  search: true,
                  onChange: this.handleSelectedFieldChange,
                  value: selectedEditField
                })
              )
            ),
            selectedEditField !== '' && _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 3, textAlign: 'right', verticalAlign: 'middle' },
                _react2.default.createElement(
                  'b',
                  null,
                  'Set value to:'
                )
              ),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { width: 13 },
                selectedEditField === 'projectUnitLayoutID' && _react2.default.createElement(_semanticUiReact.Dropdown, {
                  placeholder: 'Select layout type',
                  fluid: true,
                  selection: true,
                  options: this.props.projectUnitLayouts,
                  selectOnBlur: false,
                  onChange: this.handleInputChange
                }),
                selectedEditField === 'statusID' && _react2.default.createElement(_semanticUiReact.Dropdown, {
                  placeholder: 'Select status',
                  fluid: true,
                  selection: true,
                  options: _unitStatuses.UNIT_STATUSES_EXTERNAL_ALL,
                  selectOnBlur: false,
                  onChange: this.handleInputChange
                }),
                selectedEditField === 'isBumi' && _react2.default.createElement(_semanticUiReact.Checkbox, {
                  label: 'Bumiputra Unit',
                  checked: fieldValue,
                  onChange: this.handleCheckboxChange
                }),
                (selectedEditField === 'size' || selectedEditField === 'position') && _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    hideMessage: true,
                    onChange: this.handleInputChange,
                    onError: function onError(hasError, msg) {
                      return _this2.handleOnError(hasError, msg, selectedEditField);
                    },
                    ref: this.validation[selectedEditField],
                    validateLabel: '' + (selectedEditField === 'size' ? 'Size' : '') + (selectedEditField === 'position' ? 'Position' : ''),
                    validation: selectedEditField === 'size' ? [_webValidations.required, {
                      validate: _webValidations.numericRange,
                      option: {
                        min: 0,
                        max: 2147483647
                      }
                    }] : [_webValidations.required, {
                      validate: _webValidations.numericRange,
                      option: {
                        min: 1,
                        max: 2147483647
                      }
                    }]
                  },
                  _react2.default.createElement(_semanticUiReact.Input, {
                    fluid: true,
                    name: selectedEditField,
                    ref: function ref(_ref) {
                      _this2[selectedEditField] = _ref;
                    },
                    type: 'number',
                    value: fieldValue,
                    min: selectedEditField === 'size' ? '0' : '1',
                    step: '0.0001'
                  })
                ),
                (selectedEditField === 'streetNumberOrLevel' || selectedEditField === 'zoneOrBlock' || selectedEditField === 'streetOrFacing' || selectedEditField === 'vaAccountNumber') && _react2.default.createElement(_semanticUiReact.Input, {
                  fluid: true,
                  value: fieldValue,
                  onChange: this.handleInputChange
                }),
                selectedEditField === 'spaAmount' && _react2.default.createElement(
                  _AppForm2.default.Validate,
                  {
                    hideMessage: true,
                    onChange: this.handleInputChange,
                    onError: function onError(hasError, msg) {
                      return _this2.handleOnError(hasError, msg, selectedEditField);
                    },
                    ref: this.validation.spaAmount,
                    validateLabel: spaType === 'manual' ? sellingPriceCustomName || 'Selling Price' : 'Price Percentage',
                    validation: [_webValidations.required, {
                      validate: _webValidations.numericRange,
                      option: {
                        min: 0,
                        max: spaType === 'manual' ? 2147483647 : 99
                      }
                    }]
                  },
                  _react2.default.createElement(
                    _semanticUiReact.Input,
                    {
                      fluid: true,
                      name: 'spaAmount',
                      labelPosition: 'right',
                      type: 'number',
                      step: '.01',
                      placeholder: this.getSPAValuePlaceholder(),
                      ref: function ref(_ref2) {
                        _this2.spaAmount = _ref2;
                      },
                      value: fieldValue
                    },
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      null,
                      this.getSPAValueLabel()
                    ),
                    _react2.default.createElement('input', null),
                    _react2.default.createElement(
                      _semanticUiReact.Label,
                      { basic: true },
                      _react2.default.createElement(_semanticUiReact.Dropdown, {
                        simple: true,
                        options: this.spaTypeOptions,
                        value: spaType,
                        selectOnBlur: false,
                        onChange: this.handleSPATypeChange
                      })
                    )
                  )
                ),
                selectedEditField === 'projectUnitPackagePricings' && _react2.default.createElement(_MultiUnitPackagePricing2.default, {
                  data: fieldValue || [],
                  onChange: this.handleDataChange,
                  packagePricings: this.props.packagePricings
                }),
                (selectedEditField === 'address' || selectedEditField === 'remarkInternal' || selectedEditField === 'remarkExternal') && _react2.default.createElement('textarea', {
                  className: 'semantic-textbox',
                  style: { minHeight: '6em', maxHeight: '40vh', width: '100%' },
                  value: fieldValue,
                  onChange: this.handleTextAreaChange
                }),
                selectedEditField === 'specifications' && _react2.default.createElement(_SpecificationTable2.default, {
                  type: 'units',
                  editable: true,
                  isEditing: true,
                  hideButton: true,
                  data: fieldValue,
                  onChange: this.handleDataChange
                }),
                selectedEditField === 'vaBankName' && _react2.default.createElement(_SelectBank2.default, {
                  country: countryCode,
                  name: 'fieldValue',
                  placeholder: 'Select bank',
                  onChange: this.handleInputChange,
                  value: fieldValue
                }),
                errors[selectedEditField] !== '' && _react2.default.createElement(
                  'small',
                  null,
                  errors[selectedEditField]
                )
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                null,
                selectedEditField === 'spaAmount' && (spaType !== 'manual' || fieldValue !== '') ? _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { textAlign: 'center', inverted: true },
                  spaType !== 'manual' ? _react2.default.createElement(
                    'center',
                    null,
                    _react2.default.createElement(
                      'small',
                      null,
                      _react2.default.createElement(
                        'b',
                        null,
                        'Formula:'
                      ),
                      '\xA0\xA0',
                      this.getSPAValueFormula()
                    )
                  ) : '',
                  _react2.default.createElement(
                    _semanticUiReact.Label.Group,
                    { color: 'blue', size: 'mini' },
                    this.getChangedSPAValues(selectedRowsData).length > 0 && fieldValue !== '' ? this.getChangedSPAValues(selectedRowsData).map(function (data, idx) {
                      return _react2.default.createElement(
                        _semanticUiReact.Label,
                        {
                          as: 'div',
                          key: idx
                        },
                        data.before,
                        _react2.default.createElement(_semanticUiReact.Icon, { style: { margin: '0 0.5em' }, name: 'arrow right' }),
                        data.after
                      );
                    }) : null
                  )
                ) : '',
                showMessage ? _react2.default.createElement(
                  _semanticUiReact.Message,
                  {
                    onDismiss: this.handleDismissMessage,
                    success: true
                  },
                  _react2.default.createElement(
                    'b',
                    null,
                    messageText
                  )
                ) : '',
                _react2.default.createElement(
                  _semanticUiReact.Segment,
                  { color: 'teal' },
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Label.Group,
                      { color: 'teal', size: 'mini' },
                      selectedRowsData.length > 0 ? selectedRowsData.map(function (data, idx) {
                        return _react2.default.createElement(
                          _semanticUiReact.Label,
                          {
                            as: selectedRowsData.length > 1 ? 'a' : 'div',
                            key: idx,
                            onClick: function onClick(e) {
                              return selectedRowsData.length > 1 && _this2.handleOnDeselectUnit(e, data.rowID);
                            },
                            title: selectedRowsData.length > 1 ? 'Deselect unit' : ''
                          },
                          data.reference,
                          ' ',
                          selectedRowsData.length > 1 ? _react2.default.createElement(_semanticUiReact.Icon, { name: 'remove', style: { marginRight: '0' } }) : ''
                        );
                      }) : null
                    )
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { disabled: this.checkConfirmIsDisabled(), onClick: function onClick(e) {
              return _this2.handleOnSave(e, true);
            }, content: 'Apply & Close', primary: true }),
          _react2.default.createElement(_semanticUiReact.Button, { disabled: this.checkConfirmIsDisabled(), onClick: function onClick(e) {
              return _this2.handleOnSave(e, false);
            }, content: 'Apply' }),
          _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleOnClose, content: 'Close' })
        )
      );
    }
  }]);

  return MultiUnitEdit;
}(_react.Component);

MultiUnitEdit.contextTypes = {
  store: _propTypes2.default.object
};
MultiUnitEdit.propTypes = {
  onClose: _propTypes2.default.func.isRequired,
  onDeselectUnit: _propTypes2.default.func.isRequired,
  onSave: _propTypes2.default.func.isRequired,
  open: _propTypes2.default.bool.isRequired,
  projectUnitLayouts: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    text: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired
  })).isRequired,
  packagePricings: _propTypes2.default.oneOfType([_propTypes2.default.array.isRequired]).isRequired,
  selectedRowsData: _propTypes2.default.oneOfType([_propTypes2.default.array.isRequired]).isRequired,
  allowEditUnitPrice: _propTypes2.default.bool.isRequired,
  allowEditUnitDetails: _propTypes2.default.bool.isRequired,
  sellingPriceCustomName: _propTypes2.default.string,
  vaIsEnabled: _propTypes2.default.bool,
  countryCode: _propTypes2.default.string
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getSPAValueLabel = function () {
    if (_this3.state.spaType === 'deduct') {
      return '- %';
    }
    if (_this3.state.spaType === 'increase') {
      return '+ %';
    }
    return '$';
  };

  this.getChangedSPAValues = function (selectedRowsData) {
    var _state2 = _this3.state,
        fieldValue = _state2.fieldValue,
        spaType = _state2.spaType;

    var groupedArray = [];
    var finalArray = [];
    selectedRowsData.filter(function (d) {
      return d.isSelected;
    }).forEach(function (d) {
      return groupedArray.push(parseFloat(d.spaAmount));
    });
    groupedArray.filter(function (item, id) {
      return groupedArray.indexOf(item) === id;
    }).forEach(function (d) {
      finalArray.push({
        before: d,
        after: _this3.getAfterSPAValue(d, fieldValue, spaType)
      });
    });
    return finalArray;
  };

  this.getSPAValueFormula = function () {
    var spaType = _this3.state.spaType;

    if (spaType === 'increase') {
      return 'round(SPA_VALUE + (PERCENT_VALUE ÷ 100) x SPA_VALUE))';
    }
    if (spaType === 'deduct') {
      return 'round(SPA_VALUE - (PERCENT_VALUE ÷ 100) x SPA_VALUE))';
    }
    return '';
  };

  this.getSPAValuePlaceholder = function () {
    if (_this3.state.spaType === 'manual') {
      return _this3.state.sellingPriceCustomName || 'Selling Price';
    }
    return 'Price Percentage';
  };

  this.getValueName = function (value, arr) {
    var valueName = arr.find(function (vn) {
      return vn.value === value;
    });
    if (valueName && valueName.text) {
      return valueName.text;
    }
    return '';
  };

  this.getAfterSPAValue = function (value, percent, type) {
    if (type === 'increase') {
      return Math.round(value + percent / 100 * value);
    }
    if (type === 'deduct') {
      return Math.round(value - percent / 100 * value);
    }
    return _this3.state.fieldValue;
  };

  this.spaTypeOptions = [{ text: 'Fixed Value', value: 'manual' }];

  this.checkConfirmIsDisabled = function () {
    var _state3 = _this3.state,
        errors = _state3.errors,
        fieldValue = _state3.fieldValue;

    if (errors.size !== '' || errors.spaAmount !== '' || errors.position !== '') {
      return true;
    }
    if (!fieldValue) {
      return true;
    }
    return false;
  };

  this.handleSPATypeChange = function (e, data) {
    _this3.setState({ spaType: data.value }, function () {
      _this3.validation.spaAmount.current.validate(_this3.state.fieldValue);
    });
  };

  this.handleCheckboxChange = function () {
    _this3.setState({ fieldValue: !_this3.state.fieldValue });
  };

  this.handleDismissMessage = function () {
    _this3.setState({ showMessage: false });
  };

  this.handleInputChange = function (e, data) {
    if (data.name === 'size' || data.name === 'spaAmount' || data.name === 'position') {
      _this3.validation[data.name].current.validate(data.value);
    }
    _this3.setState({ fieldValue: data.value });
  };

  this.handleOnClose = function (e) {
    e.preventDefault();
    if (_this3.props.onClose) {
      _this3.props.onClose();
    }
    _this3.setState({
      selectedEditField: '',
      fieldValue: '',
      messageText: '',
      showMessage: false,
      spaType: 'manual'
    });
  };

  this.handleOnDeselectUnit = function (e, rowID) {
    e.preventDefault();
    var selectedRowsData = _this3.props.selectedRowsData;

    var row = selectedRowsData.find(function (r) {
      return r.rowID === rowID;
    });
    var messageText = 'Successfully deselected unit ' + row.reference;
    if (_this3.props.onDeselectUnit) {
      _this3.props.onDeselectUnit(e, rowID);
    }
    _this3.setState({ messageText: messageText, showMessage: true });
  };

  this.handleOnSave = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e, closeModal) {
      var store, _state4, selectedEditField, fieldValue, editOptions, vErrMessages, showMessage, messageText;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              store = _this3.context.store;

              e.preventDefault();
              _state4 = _this3.state, selectedEditField = _state4.selectedEditField, fieldValue = _state4.fieldValue, editOptions = _state4.editOptions, vErrMessages = _state4.vErrMessages;

              if (!(vErrMessages.length > 0)) {
                _context.next = 7;
                break;
              }

              _context.next = 6;
              return store.dispatch((0, _flash.flashErrorMessage)({ header: 'Please fix form errors', list: vErrMessages.map(function (l) {
                  return l.message;
                }) }));

            case 6:
              return _context.abrupt('return');

            case 7:
              showMessage = false;
              messageText = '';

              if (_this3.props.onSave) {
                if (selectedEditField === 'spaAmount' && fieldValue !== '') {
                  _this3.props.onSave(closeModal, 'spaAmount', {
                    type: _this3.state.spaType,
                    value: fieldValue
                  });
                } else {
                  _this3.props.onSave(closeModal, selectedEditField, fieldValue);
                }
              }
              if (!closeModal && selectedEditField !== '' && fieldValue !== '') {
                messageText = 'Successfully set ' + _this3.getValueName(selectedEditField, editOptions).toLowerCase() + ' for selected units';
                showMessage = true;
              }
              _this3.setState({
                fieldValue: '',
                selectedEditField: '',
                messageText: messageText,
                showMessage: showMessage,
                spaType: 'manual'
              });

            case 12:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }));

    return function (_x, _x2) {
      return _ref3.apply(this, arguments);
    };
  }();

  this.handleSelectedFieldChange = function (e, data) {
    var errors = {
      size: '',
      spaAmount: '',
      position: ''
    };
    var fieldValue = '';
    if (data.value === 'isBumi') {
      fieldValue = false;
    }
    if (data.value === 'specifications') {
      fieldValue = [];
    }
    if (data.value === 'projectUnitPackagePricings') {
      fieldValue = [];
    }
    _this3.setState({ errors: errors, selectedEditField: data.value, fieldValue: fieldValue });
  };

  this.handleDataChange = function (data) {
    var vErrMessages = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    _this3.setState({ fieldValue: data, vErrMessages: vErrMessages });
  };

  this.handleTextAreaChange = function (e) {
    _this3.setState({ fieldValue: e.target.value });
  };

  this.handleOnError = function (hasError, errorMessage, inputName) {
    var errors = _this3.state.errors;

    errors[inputName] = errorMessage;
    if (hasError) {
      errors[inputName] = errorMessage;
    } else {
      errors[inputName] = '';
    }
    _this3.setState({ errors: errors });
  };
};

exports.default = MultiUnitEdit;

/***/ }),
/* 2523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultiUnitFormErrors = function (_Component) {
  _inherits(MultiUnitFormErrors, _Component);

  function MultiUnitFormErrors() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MultiUnitFormErrors);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MultiUnitFormErrors.__proto__ || Object.getPrototypeOf(MultiUnitFormErrors)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClose = function (e) {
      e.preventDefault();
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MultiUnitFormErrors, [{
    key: 'render',
    value: function render() {
      if (this.props.open) {
        return _react2.default.createElement(
          _semanticUiReact.Modal,
          {
            closeOnEscape: false,
            closeOnDimmerClick: false,
            open: true,
            size: 'small'
          },
          _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: 'Please fix form errors' }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Content,
            null,
            _react2.default.createElement(
              _semanticUiReact.Modal.Description,
              null,
              this.props.data.map.length > 0 ? this.props.data.map(function (d, idx) {
                var id = idx;
                id += 1;
                if (d.errors.reference !== '' || d.errors.size !== '' || d.errors.spaAmount !== '' || d.errors.position !== '') {
                  return _react2.default.createElement(
                    'div',
                    { key: idx },
                    _react2.default.createElement(
                      'p',
                      null,
                      _react2.default.createElement(
                        'b',
                        null,
                        'Row ',
                        id,
                        d.reference !== '' ? ' (' + d.reference + ')' : ''
                      ),
                      ' ',
                      d.errors.reference !== '' && _react2.default.createElement(
                        'small',
                        null,
                        d.errors.reference,
                        '. '
                      ),
                      d.errors.size !== '' && _react2.default.createElement(
                        'small',
                        null,
                        d.errors.size,
                        '. '
                      ),
                      d.errors.spaAmount !== '' && _react2.default.createElement(
                        'small',
                        null,
                        d.errors.spaAmount,
                        '. '
                      ),
                      d.errors.position !== '' && _react2.default.createElement(
                        'small',
                        null,
                        d.errors.position,
                        '. '
                      )
                    )
                  );
                }
                return '';
              }) : ''
            )
          ),
          _react2.default.createElement(
            _semanticUiReact.Modal.Actions,
            null,
            _react2.default.createElement(_semanticUiReact.Button, { content: 'Okay', onClick: this.handleOnClose })
          )
        );
      }
      return null;
    }
  }]);

  return MultiUnitFormErrors;
}(_react.Component);

MultiUnitFormErrors.contextTypes = {
  store: _propTypes2.default.object
};
MultiUnitFormErrors.propTypes = {
  onClose: _propTypes2.default.func.isRequired,
  open: _propTypes2.default.bool,
  data: _propTypes2.default.oneOfType([_propTypes2.default.array])
};
exports.default = MultiUnitFormErrors;

/***/ }),
/* 2524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _SpecificationTable = __webpack_require__(127);

var _SpecificationTable2 = _interopRequireDefault(_SpecificationTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MultiUnitSpecification = function (_Component) {
  _inherits(MultiUnitSpecification, _Component);

  function MultiUnitSpecification() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, MultiUnitSpecification);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MultiUnitSpecification.__proto__ || Object.getPrototypeOf(MultiUnitSpecification)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnChange = function (data) {
      if (_this.props.onChange) {
        _this.props.onChange(data);
      }
    }, _this.handleOnDone = function (e) {
      e.preventDefault();
      if (_this.props.onDone) {
        _this.props.onDone(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(MultiUnitSpecification, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          closeOnEscape: false,
          closeOnDimmerClick: false,
          open: this.props.open === true,
          size: 'small'
        },
        _react2.default.createElement(
          _semanticUiReact.Modal.Header,
          null,
          'Manage Specification for ',
          this.props.unit.reference
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            _react2.default.createElement(_SpecificationTable2.default, {
              type: 'units',
              editable: true,
              isEditing: true,
              hideButton: true,
              data: this.props.unit.specifications,
              onChange: this.handleOnChange
            })
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { primary: true, onClick: this.handleOnDone, content: 'Confirm', inverted: true })
        )
      );
    }
  }]);

  return MultiUnitSpecification;
}(_react.Component);

MultiUnitSpecification.contextTypes = {
  store: _propTypes2.default.object
};
MultiUnitSpecification.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  onDone: _propTypes2.default.func.isRequired,
  open: _propTypes2.default.bool,
  unit: _propTypes2.default.oneOfType([_propTypes2.default.object.isRequired]).isRequired
};
exports.default = MultiUnitSpecification;

/***/ }),
/* 2525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NotifyAddPurchaserEmail = function (_Component) {
  _inherits(NotifyAddPurchaserEmail, _Component);

  function NotifyAddPurchaserEmail() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NotifyAddPurchaserEmail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NotifyAddPurchaserEmail.__proto__ || Object.getPrototypeOf(NotifyAddPurchaserEmail)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClose = function (e) {
      _this.props.onClose(e);
    }, _this.handleOnAddEmail = function (e) {
      _this.props.onAddEmail(e);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NotifyAddPurchaserEmail, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          isMobile = _props.isMobile,
          t = _props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          size: isMobile ? 'small' : 'tiny',
          open: this.props.open === true,
          onClose: this.handleOnClose
        },
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { centered: true },
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 2, tablet: 2, computer: 2, textAlign: 'right', verticalAlign: 'middle' },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'green', size: 'big', inverted: true })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 14, tablet: 14, computer: 14, textAlign: 'left' },
                  t('Please fill in customer\'s email at Purchaser tab above so that your customer may receive payment link via email')
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, onClick: this.handleOnClose, content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }) }),
          _react2.default.createElement(_semanticUiReact.Button, { color: 'green', onClick: this.handleOnAddEmail, content: t('Add Email') })
        )
      );
    }
  }]);

  return NotifyAddPurchaserEmail;
}(_react.Component);

NotifyAddPurchaserEmail.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onAddEmail: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(NotifyAddPurchaserEmail);

/***/ }),
/* 2526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _LawyerItem = __webpack_require__(384);

var _LawyerItem2 = _interopRequireDefault(_LawyerItem);

var _ProjectPanelLawyers = __webpack_require__(1028);

var _ProjectPanelLawyers2 = _interopRequireDefault(_ProjectPanelLawyers);

var _translation = __webpack_require__(4);

var _InviteLawyerForm = __webpack_require__(1078);

var _InviteLawyerForm2 = _interopRequireDefault(_InviteLawyerForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PanelLawyersList = function (_Component) {
  _inherits(PanelLawyersList, _Component);

  function PanelLawyersList(props) {
    _classCallCheck(this, PanelLawyersList);

    var _this = _possibleConstructorReturn(this, (PanelLawyersList.__proto__ || Object.getPrototypeOf(PanelLawyersList)).call(this, props));

    _initialiseProps.call(_this);

    var state = PanelLawyersList.getPropsToState(props);
    _this.state = _extends({}, state, {
      selected: null,
      showInviteLawyer: false
    });
    return _this;
  }

  _createClass(PanelLawyersList, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var state = PanelLawyersList.getPropsToState(nextProps);
      this.setState(state);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          open: this.props.open === true,
          onClose: this.handleOnClose,
          closeIcon: 'close',
          size: 'large',
          className: 'items-list-modal PanelLawyers'
        },
        _react2.default.createElement(_semanticUiReact.Header, {
          icon: 'add user',
          content: t('Assign lawyer')
        }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(_InviteLawyerForm2.default, {
            company: this.props.company,
            ref: function ref(_ref) {
              _this2.inviteForm = _ref;
            },
            open: this.state.showInviteLawyer,
            onClose: this.handleCloseInviteLawyer,
            onConfirm: this.handleCloseInviteLawyer,
            loanTrackerProjectID: this.props.loanTrackerProjectID,
            projectName: this.props.projectName,
            loading: this.props.loading,
            setLoading: this.props.setLoading
          }),
          _react2.default.createElement(_ProjectPanelLawyers2.default, {
            loanTrackerProjectID: this.props.loanTrackerProjectID,
            rowNode: function rowNode(sub, idx, currentTab) {
              var isSelected = _this2.state.selected && _this2.state.selected.lawyer_id === sub.lawyer_id;
              // const isExist = this.state.oriSelected.some(s => s.lawyer_id === sub.lawyer_id);
              return _react2.default.createElement(
                _semanticUiReact.Table.Row,
                {
                  key: idx,
                  positive: isSelected,
                  active: _this2.handleOnCheck(sub)
                },
                _react2.default.createElement(
                  _semanticUiReact.Table.Cell,
                  null,
                  _react2.default.createElement(_LawyerItem2.default, {
                    item: sub,
                    headerNode: currentTab === 'invited' ? _react2.default.createElement(
                      _semanticUiReact.Label,
                      null,
                      t('Pending Registration')
                    ) : null,
                    onClick: _this2.handleOnSelect,
                    selected: isSelected,
                    disabled: _this2.handleOnCheck(sub) || currentTab === 'invited',
                    checkable: currentTab === 'panel'
                  })
                )
              );
            },
            extraNode: this.props.extraNode ? this.props.extraNode(this.state.selected) : null
          })
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          { style: { justifyContent: 'center' } },
          _react2.default.createElement(_semanticUiReact.Button, {
            primary: true,
            onClick: this.handleOnConfirm,
            icon: 'checkmark',
            content: t('Confirm', { ns: _translation.TRANSLATION_FILES.translation }),
            disabled: !this.state.selected
          })
        )
      );
    }
  }]);

  return PanelLawyersList;
}(_react.Component);

PanelLawyersList.contextTypes = {
  store: _propTypes2.default.object
};
PanelLawyersList.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  onSelect: _propTypes2.default.func,
  onCheck: _propTypes2.default.func,
  selected: _propTypes2.default.arrayOf(_propTypes2.default.object),
  loanTrackerProjectID: _propTypes2.default.number,
  projectName: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  setLoading: _propTypes2.default.func,
  extraNode: _propTypes2.default.func,
  company: _propTypes2.default.oneOfType([_propTypes2.default.object])
};
PanelLawyersList.defaultProps = {
  loanTrackerProjectID: 0
};

PanelLawyersList.getPropsToState = function (props) {
  var oriSelected = props.selected ? [].concat(props.selected) : [];
  return {
    oriSelected: oriSelected,
    company: props.company
  };
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleOnConfirm = function (e) {
    e.preventDefault();
    if (_this3.props.onConfirm) {
      _this3.props.onConfirm(e, _this3.state.selected);
    }
    _this3.setState({ selected: null });
  };

  this.handleOnClose = function (e) {
    if (_this3.props.onClose) {
      _this3.props.onClose(e);
    }
  };

  this.handleOnSelect = function (e, lawyer) {
    var selected = _this3.state.selected === lawyer ? null : lawyer;
    _this3.setState({ selected: selected }, function () {
      if (_this3.props.onSelect) {
        _this3.props.onSelect(selected);
      }
    });
  };

  this.handleOnCheck = function (lawyer) {
    if (_this3.props.onCheck) {
      var selected = _this3.state.selected;

      return _this3.props.onCheck(lawyer, selected);
    }
    return false;
  };

  this.handleShowInviteLawyer = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this3.setState({
      showInviteLawyer: true
    });
  };

  this.handleCloseInviteLawyer = function (e) {
    if (e) {
      e.preventDefault();
    }
    _this3.setState({
      showInviteLawyer: false
    }, function () {
      if (_this3.inviteForm) {
        _this3.inviteForm.resetData();
      }
    });
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(PanelLawyersList);

/***/ }),
/* 2527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaymentRequest = function (_Component) {
  _inherits(PaymentRequest, _Component);

  function PaymentRequest(props) {
    _classCallCheck(this, PaymentRequest);

    var _this = _possibleConstructorReturn(this, (PaymentRequest.__proto__ || Object.getPrototypeOf(PaymentRequest)).call(this, props));

    _initialiseProps.call(_this);

    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 521;

    _this.state = {
      isMobile: isMobile
    };
    return _this;
  }

  _createClass(PaymentRequest, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var isMobile = this.state.isMobile;
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          size: isMobile ? 'small' : 'tiny',
          open: this.props.open === true,
          onClose: this.handleOnClose
        },
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { centered: true },
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                null,
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 2, tablet: 2, computer: 2, textAlign: 'right', verticalAlign: 'middle' },
                  _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle', color: 'green', size: 'big', inverted: true })
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { mobile: 14, tablet: 14, computer: 14, textAlign: 'left' },
                  _react2.default.createElement(
                    _reactI18next.Trans,
                    { ns: _translation.TRANSLATION_FILES.screens },
                    'Payment Request link will be sent via SMS and Email to Purchaser. ',
                    _react2.default.createElement('br', null),
                    'Link will expire in 24 hours if no payment made.'
                  )
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, onClick: this.handleOnClose, content: t('Cancel', { ns: _translation.TRANSLATION_FILES.translation }) }),
          _react2.default.createElement(_semanticUiReact.Button, { color: 'green', onClick: this.handleOnConfirm, content: t('Confirm', { ns: _translation.TRANSLATION_FILES.translation }) })
        )
      );
    }
  }]);

  return PaymentRequest;
}(_react.Component);

PaymentRequest.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleOnClose = function (e) {
    _this2.props.onClose(e);
  };

  this.handleOnConfirm = function (e) {
    _this2.props.onConfirm(e);
  };

  this.handleResize = function () {
    var windowWidth = window.innerWidth;
    var isMobile = windowWidth < 521;
    if (isMobile !== _this2.state.isMobile) {
      _this2.setState({ isMobile: isMobile });
    }
  };
};

exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(PaymentRequest);

/***/ }),
/* 2528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _LoadImage = __webpack_require__(58);

var _LoadImage2 = _interopRequireDefault(_LoadImage);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RemoveLogo = function (_Component) {
  _inherits(RemoveLogo, _Component);

  function RemoveLogo() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RemoveLogo);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RemoveLogo.__proto__ || Object.getPrototypeOf(RemoveLogo)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    }, _this.handleOnComfirm = function (e) {
      e.preventDefault();
      if (_this.props.onConfirm) {
        _this.props.onConfirm(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RemoveLogo, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (JSON.stringify(this.props.picture) !== JSON.stringify(nextProps.picture) || JSON.stringify(this.props.data) !== JSON.stringify(nextProps.data) || this.props.open !== nextProps.open) {
        return true;
      }
      return false;
    }
  }, {
    key: 'renderWarning',
    value: function renderWarning() {
      var _props = this.props,
          picture = _props.picture,
          t = _props.t;

      if (picture && picture.projects) {
        var projectLength = picture.projects ? picture.projects.length : 0;
        return _react2.default.createElement(
          'h3',
          null,
          t('This {{section}} is used in {{count}} place(s).', { section: t('Logo'), count: projectLength })
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          basic: true,
          open: this.props.open === true,
          onClose: this.handleOnClose
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: t(this.props.headerNode || 'Confirm delete') + '?' }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { image: true },
          _react2.default.createElement(_LoadImage2.default, {
            wrapped: true,
            picture: this.props.picture,
            pictureSize: this.props.pictureSize,
            extension: this.props.extension
          }),
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            this.renderWarning(),
            _react2.default.createElement(
              'h3',
              null,
              t('Are you sure to delete this logo'),
              '?'
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, negative: true, onClick: this.handleOnClose, icon: 'cancel', content: t('No'), inverted: true }),
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, positive: true, onClick: this.handleOnComfirm, icon: 'trash', content: t('Yes'), inverted: true })
        )
      );
    }
  }]);

  return RemoveLogo;
}(_react.Component);

RemoveLogo.contextTypes = {
  store: _propTypes2.default.object
};
RemoveLogo.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  picture: _propTypes2.default.shape({
    key: _propTypes2.default.string
  }),
  data: _propTypes2.default.shape({
    name: _propTypes2.default.string
  }),
  headerNode: _propTypes2.default.node,
  pictureSize: _propTypes2.default.number,
  extension: _propTypes2.default.string,
  t: _propTypes2.default.func
};
RemoveLogo.defaultProps = {
  pictureSize: 30
};
exports.default = (0, _reactI18next.withTranslation)(_translation.TRANSLATION_FILES.screens)(RemoveLogo);

/***/ }),
/* 2529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

var _flash = __webpack_require__(5);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ShareESign = function (_Component) {
  _inherits(ShareESign, _Component);

  function ShareESign(props) {
    _classCallCheck(this, ShareESign);

    var _this = _possibleConstructorReturn(this, (ShareESign.__proto__ || Object.getPrototypeOf(ShareESign)).call(this, props));

    _this.getShareUrl = function () {
      var data = _this.props.data;

      var buyerURL = _config2.default.get('buyerURL');
      if (data && data.shortID && buyerURL) {
        var shareURL = buyerURL + '/en/sign/' + data.shortID;
        return shareURL;
      }
      return '';
    };

    _this.getToken = function () {
      var data = _this.props.data;

      return data && data.token;
    };

    _this.handleOnOpen = function (e) {
      e.preventDefault();
      _this.setState({ open: true });
    };

    _this.handleOnClose = function (e) {
      var open = false;
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
      _this.setState({
        open: open,
        smsSendable: true,
        emailSendable: true,
        selectedPrintForms: []
      });
    };

    _this.handleCopy = function (e, name) {
      e.preventDefault();
      var store = _this.context.store;
      var t = _this.props.t;

      var copyText = _this.getShareUrl();
      var msgTitle = 'web address';
      if (name === 'pin') {
        copyText = _this.getToken();
        msgTitle = '6-digit PIN';
      }
      var tempText = document.createElement('input');
      tempText.value = copyText;
      document.body.appendChild(tempText);
      tempText.select();
      document.execCommand('copy');
      tempText.remove();

      store.dispatch((0, _flash.flashSuccessMessage)({
        header: t('Copy Success', { ns: _translation.TRANSLATION_FILES.translation }),
        message: t('Successfully copied the {{title}} to your clipboard', { title: t(msgTitle), ns: _translation.TRANSLATION_FILES.translation })
      }));
    };

    _this.handleInputChange = function (e, _ref) {
      var value = _ref.value;

      var selectedTemplates = _this.props.printTemplates.filter(function (t) {
        return value.includes(t.value);
      });

      var selectedDocxTemplates = selectedTemplates.filter(function (t) {
        return t.type === 'docx';
      }).map(function (t) {
        return t.value;
      });

      var selectedPrintTemplates = selectedTemplates.filter(function (t) {
        return t.type !== 'docx';
      }).map(function (t) {
        return t.value;
      });

      _this.setState({
        selectedDocxTemplates: selectedDocxTemplates,
        selectedPrintTemplates: selectedPrintTemplates,
        selectedPrintForms: value
      });
    };

    _this.handleProceed = function (e) {
      var onProceed = _this.props.onProceed;
      var _this$state = _this.state,
          allowSendEmail = _this$state.allowSendEmail,
          selectedDocxTemplates = _this$state.selectedDocxTemplates,
          selectedPrintTemplates = _this$state.selectedPrintTemplates;

      var data = {
        printTemplateIDs: selectedPrintTemplates,
        docxTemplateIDs: selectedDocxTemplates,
        allowSendFormsEmail: allowSendEmail
      };
      onProceed(e, data);
    };

    _this.handleOnRenew = function (e) {
      if (_this.props.onRenew) {
        _this.props.onRenew(e);
        _this.setState({ selectedPrintForms: [] });
      }
    };

    _this.handleOnSend = function (e, type) {
      if (_this.props.onSend) {
        _this.props.onSend(e, type);
        _this.setState({ smsSendable: false });

        // set timeout to re-enable button after 1 minute
        _this.timer = setTimeout(function () {
          _this.setState({ smsSendable: true });
          // clear timeout after use
          _this.timer = null;
        }, 60000);
      }
    };

    _this.handleOnSendEmail = function (e) {
      if (_this.props.onSend) {
        _this.props.onSend(e, 'email');
        _this.setState({ emailSendable: false });

        _this.emailTimer = setTimeout(function () {
          _this.setState({ emailSendable: true });
          _this.emailTimer = null;
        }, 60000);
      }
    };

    _this.handleCheckboxChange = function (e) {
      e.preventDefault();
      _this.setState({
        allowSendEmail: !_this.state.allowSendEmail
      });
    };

    _this.timer = null;
    _this.state = {
      open: false,
      modalOpen: false,
      smsSendable: true,
      emailSendable: true,
      selectedPrintForms: [],
      allowSendEmail: false
    };
    return _this;
  }

  _createClass(ShareESign, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var open = nextProps.open,
          bookingData = nextProps.bookingData;

      var allowSendEmail = bookingData.project && bookingData.project.shareESignSendFormsEmail;
      if (open) {
        this.setState({
          open: open,
          allowSendEmail: allowSendEmail
        });
      }
    }
  }, {
    key: 'close',
    value: function close() {
      this.handleOnClose(true);
    }
    // CPI-976: preserved email channel for Vietnam. Own cooldown flag so the SMS path above stays
    // byte-identical.

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          bookingData = _props.bookingData,
          customerData = _props.customerData,
          isMobile = _props.isMobile,
          isVietnam = _props.isVietnam,
          loading = _props.loading,
          printTemplates = _props.printTemplates,
          t = _props.t,
          trigger = _props.trigger;
      var _state = this.state,
          allowSendEmail = _state.allowSendEmail,
          smsSendable = _state.smsSendable,
          emailSendable = _state.emailSendable,
          selectedPrintForms = _state.selectedPrintForms;

      var pin6Digits = this.getToken() && this.getToken().split('');
      var showFormStep = !this.getToken();
      var header = showFormStep ? 'E-signature sharing configuration' : 'Share e-signature form to Purchaser';
      var hasCustomerEmail = customerData.email !== '';
      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          className: 'share-e-sign',
          closeOnDimmerClick: false,
          size: 'tiny',
          trigger: trigger,
          open: this.state.open,
          onClose: this.handleOnCancel,
          onOpen: this.handleOnOpen

        },
        _react2.default.createElement(_semanticUiReact.Header, {
          icon: 'share square',
          content: t(header)
        }),
        loading ? _react2.default.createElement(
          'div',
          { className: 'loading-div' },
          _react2.default.createElement(
            _semanticUiReact.Loader,
            { inline: 'centered' },
            t('Loading', { ns: _translation.TRANSLATION_FILES.translation })
          )
        ) : _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          showFormStep ? _react2.default.createElement(
            'div',
            { style: { marginBottom: '40px' } },
            _react2.default.createElement(
              _semanticUiReact.Header,
              {
                as: 'h5',
                style: { margin: '0 0 5px 0' }
              },
              t('Select form to share with Purchaser'),
              _react2.default.createElement(_semanticUiReact.Popup, {
                content: t('Selecting a form from the dropdown below allows the purchaser to preview and verify its details before signing'),
                position: 'right center',
                trigger: _react2.default.createElement(_semanticUiReact.Button, {
                  icon: 'info circle',
                  style: { paddingLeft: '0.2em', background: 'none' }
                })
              })
            ),
            _react2.default.createElement(_semanticUiReact.Dropdown, {
              name: 'selectedPrintForms',
              fluid: true,
              multiple: true,
              search: true,
              selection: true,
              placeholder: t('Select form'),
              options: printTemplates,
              onChange: this.handleInputChange,
              value: selectedPrintForms,
              style: { marginBottom: '20px' }
            }),
            _react2.default.createElement(_semanticUiReact.Form.Checkbox, {
              label: _react2.default.createElement(
                'label',
                { htmlFor: 'allowSendEmail' },
                t('Automatically share the e-signed copies of the selected forms with purchaser via email'),
                !hasCustomerEmail && _react2.default.createElement(_semanticUiReact.Popup, {
                  content: t("Purchaser's email required"),
                  position: 'right center',
                  trigger: _react2.default.createElement(_semanticUiReact.Button, {
                    icon: 'info circle',
                    style: { paddingLeft: '0.2em', background: 'none' }
                  })
                })
              ),
              checked: allowSendEmail,
              onChange: this.handleCheckboxChange,
              disabled: !hasCustomerEmail
            })
          ) : _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              t('To obtain an e-signature from your purchaser, choose the method of sharing to your purchaser below'),
              ':'
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              null,
              _react2.default.createElement(
                _semanticUiReact.Grid.Row,
                { centered: true },
                customerData.mobilePrefix === '60' && _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { computer: 3, tablet: 3, mobile: 3 },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(
                      _semanticUiReact.Button,
                      {
                        primary: true,
                        circular: true,
                        icon: true,
                        size: 'large',
                        disabled: loading || !smsSendable,
                        onClick: function onClick(e) {
                          return _this2.handleOnSend(e, 'sms');
                        }
                      },
                      _react2.default.createElement(_semanticUiReact.Icon, { name: 'chat' })
                    ),
                    _react2.default.createElement(
                      'p',
                      { className: '' + (!smsSendable ? 'disabled' : '') },
                      t('SMS')
                    )
                  ),
                  !smsSendable && _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { className: 'shared-text' },
                    t('Shared')
                  )
                ),
                isVietnam && _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { computer: 3, tablet: 3, mobile: 3 },
                  _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    null,
                    _react2.default.createElement(_semanticUiReact.Popup, {
                      disabled: hasCustomerEmail,
                      content: t("Purchaser's email required"),
                      position: 'top center',
                      trigger: _react2.default.createElement(
                        'div',
                        { style: { display: 'inline-block' } },
                        _react2.default.createElement(
                          _semanticUiReact.Button,
                          {
                            primary: true,
                            circular: true,
                            icon: true,
                            size: 'large',
                            disabled: loading || !emailSendable || !hasCustomerEmail,
                            onClick: this.handleOnSendEmail
                          },
                          _react2.default.createElement(_semanticUiReact.Icon, { name: 'mail' })
                        )
                      )
                    }),
                    _react2.default.createElement(
                      'p',
                      { className: '' + (!emailSendable || !hasCustomerEmail ? 'disabled' : '') },
                      t('Email')
                    )
                  ),
                  !emailSendable && _react2.default.createElement(
                    _semanticUiReact.Grid.Row,
                    { className: 'shared-text' },
                    t('Shared')
                  )
                ),
                _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { computer: 3, tablet: 3, mobile: 3 },
                  _react2.default.createElement(
                    _semanticUiReact.Button,
                    {
                      secondary: true,
                      circular: true,
                      icon: true,
                      size: 'large',
                      disabled: loading,
                      onClick: function onClick(e) {
                        return _this2.handleCopy(e, 'url');
                      }
                    },
                    _react2.default.createElement(_semanticUiReact.Icon, { name: 'linkify' })
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    t('Copy URL')
                  )
                )
              )
            ),
            !isVietnam && _react2.default.createElement(
              'p',
              { className: 'share-note' },
              '*',
              t('Share via SMS will also include 6-digit PIN and only available for Malaysia number')
            ),
            _react2.default.createElement(_semanticUiReact.Divider, null)
          ),
          !showFormStep && bookingData.project && bookingData.project.shareESignPinIsRequired && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              t('Please share the following 6-digit PIN with your purchaser to grant them access to the e-signature form'),
              ':'
            ),
            _react2.default.createElement(
              _semanticUiReact.Grid,
              { centered: true, columns: 7, style: isMobile ? { margin: '20px 20px 0' } : { margin: '20px 65px 0' } },
              pin6Digits && pin6Digits.map(function (pin, index) {
                return _react2.default.createElement(
                  _semanticUiReact.Grid.Column,
                  { key: index, style: { padding: '0.3em' } },
                  _react2.default.createElement(
                    _semanticUiReact.Segment,
                    { textAlign: 'center', style: isMobile ? { padding: '15px 0' } : { padding: '1em 0' } },
                    _react2.default.createElement(_semanticUiReact.Header, {
                      as: 'h3',
                      content: pin
                    })
                  )
                );
              }),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { className: 'copy-pin' },
                _react2.default.createElement(_semanticUiReact.Icon, { name: 'copy outline', link: true, onClick: function onClick(e) {
                    return _this2.handleCopy(e, 'pin');
                  } })
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Segment,
              { className: 'renew' },
              _react2.default.createElement(
                _reactI18next.Trans,
                { ns: _translation.TRANSLATION_FILES.screens },
                _react2.default.createElement(
                  'p',
                  null,
                  'There are changes in the booking information? Click',
                  ' ',
                  _react2.default.createElement(
                    'button',
                    { onClick: this.handleOnRenew },
                    'here'
                  ),
                  ' ',
                  'to generate the latest link.'
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, {
            onClick: this.handleOnClose,
            content: t('Close', { ns: _translation.TRANSLATION_FILES.translation })
          }),
          showFormStep && _react2.default.createElement(_semanticUiReact.Button, {
            primary: true,
            onClick: this.handleProceed,
            content: t('Proceed', { ns: _translation.TRANSLATION_FILES.translation })
          })
        )
      );
    }
  }]);

  return ShareESign;
}(_react.Component);

ShareESign.propTypes = {
  trigger: _propTypes2.default.node,
  data: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  bookingData: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  customerData: _propTypes2.default.oneOfType([_propTypes2.default.object]),
  onClose: _propTypes2.default.func,
  loading: _propTypes2.default.bool,
  open: _propTypes2.default.bool,
  isMobile: _propTypes2.default.bool,
  onProceed: _propTypes2.default.func,
  onRenew: _propTypes2.default.func,
  onSend: _propTypes2.default.func,
  printTemplates: _propTypes2.default.oneOfType([_propTypes2.default.array]),
  // CPI-976: preserved for a future Vietnam E-Sign rollout; the Purchaser parent currently
  // hides this modal for Vietnam.
  isVietnam: _propTypes2.default.bool,
  t: _propTypes2.default.func
};
ShareESign.contextTypes = {
  store: _propTypes2.default.object
};
ShareESign.defaultProps = {
  isVietnam: false
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces, { withRef: true })(ShareESign);

/***/ }),
/* 2530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _momentTimezone = __webpack_require__(16);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _semanticUiReact = __webpack_require__(2);

var _DateTimePicker = __webpack_require__(314);

var _DateTimePicker2 = _interopRequireDefault(_DateTimePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

_momentTimezone2.default.locale('en-gb');

var inputDateFormat = 'DD/MM/YYYY, hh:mm A';

var TierPricingSchedule = function (_Component) {
  _inherits(TierPricingSchedule, _Component);

  function TierPricingSchedule(props) {
    _classCallCheck(this, TierPricingSchedule);

    var _this = _possibleConstructorReturn(this, (TierPricingSchedule.__proto__ || Object.getPrototypeOf(TierPricingSchedule)).call(this, props));

    _initialiseProps.call(_this);

    var data = Object.assign({
      scheduleStartAt: null,
      scheduleEndAt: null,
      name: ''
    }, props.data || {});
    _this.state = {
      data: data,
      visibleStart: false,
      visibleEnd: false
    };
    return _this;
  }

  _createClass(TierPricingSchedule, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var data = Object.assign({
        scheduleStartAt: null,
        scheduleEndAt: null,
        name: ''
      }, nextProps.data || {});
      this.setState({
        data: data
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          data = _state.data,
          visibleStart = _state.visibleStart,
          visibleEnd = _state.visibleEnd;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          open: this.props.open,
          onClose: this.handleOnClose,
          size: 'tiny',
          closeOnDimmerClick: false
        },
        _react2.default.createElement(
          _semanticUiReact.Header,
          { onClick: function onClick() {
              return _this2.handleHideAll();
            } },
          _react2.default.createElement(_semanticUiReact.Icon, { name: 'calendar' }),
          _react2.default.createElement(
            _semanticUiReact.Header.Content,
            null,
            this.props.headerNode || 'Schedule Pricing',
            _react2.default.createElement(
              _semanticUiReact.Header.Subheader,
              null,
              data.name && data.name
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          { scrolling: this.props.scrolling || false },
          _react2.default.createElement(
            _semanticUiReact.Grid,
            { centered: true },
            _react2.default.createElement(
              _semanticUiReact.Grid.Row,
              null,
              _react2.default.createElement(_semanticUiReact.Grid.Column, { mobile: 16, tablet: 16, computer: 2, className: 'small-hide tablet-hide', onClick: function onClick() {
                  return _this2.handleHideAll();
                } }),
              _react2.default.createElement(
                _semanticUiReact.Grid.Column,
                { mobile: 16, tablet: 16, computer: 12 },
                _react2.default.createElement(
                  'div',
                  { className: 'ui form' },
                  _react2.default.createElement(
                    _semanticUiReact.Form.Group,
                    { widths: 'equal' },
                    _react2.default.createElement(_semanticUiReact.Form.Input, {
                      fluid: true,
                      label: 'Start At',
                      placeholder: 'Click to setup',
                      value: data.scheduleStartAt ? (0, _momentTimezone2.default)(data.scheduleStartAt).format(inputDateFormat) : '',
                      readOnly: true,
                      onFocus: function onFocus() {
                        return _this2.handleOnVisible('visibleStart');
                      },
                      icon: data.scheduleStartAt ? _react2.default.createElement(_semanticUiReact.Icon, {
                        color: 'red',
                        link: true,
                        name: 'x',
                        onClick: function onClick(e) {
                          return _this2.handleOnClear(e, 'scheduleStartAt');
                        },
                        title: 'Clear'
                      }) : null
                    })
                  ),
                  _react2.default.createElement(_DateTimePicker2.default, {
                    maxDate: data.scheduleEndAt && data.scheduleEndAt,
                    noPadding: true,
                    onChange: function onChange(value, visible) {
                      return _this2.handleOnChange(value, 'scheduleStartAt', visible);
                    },
                    value: data.scheduleStartAt ? (0, _momentTimezone2.default)(data.scheduleStartAt).toDate() : '',
                    visible: visibleStart
                  }),
                  _react2.default.createElement(_semanticUiReact.Divider, null),
                  _react2.default.createElement(
                    _semanticUiReact.Form.Group,
                    { widths: 'equal' },
                    _react2.default.createElement(_semanticUiReact.Form.Input, {
                      fluid: true,
                      label: 'End At',
                      placeholder: 'Click to setup',
                      value: data.scheduleEndAt ? (0, _momentTimezone2.default)(data.scheduleEndAt).format(inputDateFormat) : '',
                      readOnly: true,
                      onFocus: function onFocus() {
                        return _this2.handleOnVisible('visibleEnd');
                      },
                      icon: data.scheduleEndAt ? _react2.default.createElement(_semanticUiReact.Icon, {
                        color: 'red',
                        link: true,
                        name: 'x',
                        onClick: function onClick(e) {
                          return _this2.handleOnClear(e, 'scheduleEndAt');
                        },
                        title: 'Clear'
                      }) : null
                    })
                  ),
                  _react2.default.createElement(_DateTimePicker2.default, {
                    minDate: data.scheduleStartAt && data.scheduleStartAt,
                    onChange: function onChange(value, visible) {
                      return _this2.handleOnChange(value, 'scheduleEndAt', visible);
                    },
                    noPadding: true,
                    value: data.scheduleEndAt ? (0, _momentTimezone2.default)(data.scheduleEndAt).toDate() : '',
                    visible: visibleEnd
                  })
                )
              ),
              _react2.default.createElement(_semanticUiReact.Grid.Column, { mobile: 16, tablet: 16, computer: 2, className: 'small-hide tablet-hide', onClick: function onClick() {
                  return _this2.handleHideAll();
                } })
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          { onClick: function onClick() {
              return _this2.handleHideAll();
            } },
          _react2.default.createElement(_semanticUiReact.Button, { onClick: this.handleOnClose, icon: 'cancel', content: 'Cancel' }),
          _react2.default.createElement(_semanticUiReact.Button, { color: 'blue', onClick: this.handleOnComfirm, icon: 'save', content: 'Save' })
        )
      );
    }
  }]);

  return TierPricingSchedule;
}(_react.Component);

TierPricingSchedule.propTypes = {
  data: _propTypes2.default.shape({
    scheduleStartAt: _propTypes2.default.string,
    scheduleEndAt: _propTypes2.default.string,
    name: _propTypes2.default.string
  }),
  headerNode: _propTypes2.default.node,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  open: _propTypes2.default.bool,
  scrolling: _propTypes2.default.bool
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.handleOnClose = function (e) {
    if (_this3.props.onClose) {
      _this3.props.onClose(e);
    }
  };

  this.handleOnComfirm = function (e) {
    e.preventDefault();
    var data = _this3.state.data;
    // remove timezone from date object (because API server has default timezone set)

    if (data.scheduleStartAt) data.scheduleStartAt = (0, _momentTimezone2.default)(data.scheduleStartAt).format('YYYY-MM-DDTHH:mm:ss') + 'Z';
    if (data.scheduleEndAt) data.scheduleEndAt = (0, _momentTimezone2.default)(data.scheduleEndAt).format('YYYY-MM-DDTHH:mm:ss') + 'Z';
    if (_this3.props.onConfirm) {
      _this3.props.onConfirm(e, data);
    }
  };

  this.handleOnVisible = function (visibleID) {
    var states = _this3.state;
    states.visibleStart = false;
    states.visibleEnd = false;
    states[visibleID] = true;
    _this3.setState(states);
  };

  this.handleOnHide = function (visibleID) {
    _this3.setState(_defineProperty({}, visibleID, false));
  };

  this.handleHideAll = function () {
    var states = _this3.state;
    states.visibleStart = false;
    states.visibleEnd = false;
    _this3.setState(states);
  };

  this.handleOnClear = function (e, visibleID) {
    var data = _this3.state.data;

    if (visibleID === 'scheduleStartAt') {
      data.scheduleStartAt = null;
    } else if (visibleID === 'scheduleEndAt') {
      data.scheduleEndAt = null;
    }
    _this3.setState(_defineProperty({ data: data }, visibleID, false));
  };

  this.handleOnChange = function (value, id, visible) {
    var _this3$setState3;

    var data = _this3.state.data;
    var _state2 = _this3.state,
        visibleStart = _state2.visibleStart,
        visibleEnd = _state2.visibleEnd;

    if (id === 'scheduleStartAt') {
      visibleStart = visible;
    } else if (id === 'scheduleEndAt') {
      visibleEnd = visible;
    }
    data[id] = value;
    _this3.setState((_this3$setState3 = { data: data }, _defineProperty(_this3$setState3, id, value), _defineProperty(_this3$setState3, 'visibleStart', visibleStart), _defineProperty(_this3$setState3, 'visibleEnd', visibleEnd), _this3$setState3));
  };
};

exports.default = TierPricingSchedule;

/***/ }),
/* 2531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _reactI18next = __webpack_require__(3);

var _translation = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TinInvalidModal = function (_Component) {
  _inherits(TinInvalidModal, _Component);

  function TinInvalidModal() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TinInvalidModal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TinInvalidModal.__proto__ || Object.getPrototypeOf(TinInvalidModal)).call.apply(_ref, [this].concat(args))), _this), _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TinInvalidModal, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      if (this.props.open !== nextProps.open) {
        return true;
      }
      return false;
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;

      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          size: 'small',
          open: this.props.open === true,
          onClose: this.handleOnClose
        },
        _react2.default.createElement(_semanticUiReact.Header, { icon: 'warning sign', content: t('Required Information') }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(
            _semanticUiReact.Modal.Description,
            null,
            _react2.default.createElement(
              'p',
              null,
              _react2.default.createElement(
                'strong',
                null,
                'Error: Purchaser\'s Tax Identification Number must be validated.'
              )
            ),
            _react2.default.createElement(
              'p',
              null,
              'Please complete and validate the purchaser\'s Tax Identification Number before changing the unit to ',
              this.props.newBookingStatus,
              ' .'
            )
          )
        ),
        _react2.default.createElement(
          _semanticUiReact.Modal.Actions,
          null,
          _react2.default.createElement(_semanticUiReact.Button, { basic: true, negative: true, onClick: this.handleOnClose, content: t('Close', { ns: _translation.TRANSLATION_FILES.translation }) })
        )
      );
    }
  }]);

  return TinInvalidModal;
}(_react.Component);

TinInvalidModal.contextTypes = {
  store: _propTypes2.default.object
};
TinInvalidModal.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  newBookingStatus: _propTypes2.default.string,
  t: _propTypes2.default.func
};
exports.default = (0, _reactI18next.withTranslation)(_translation.namespaces)(TinInvalidModal);

/***/ }),
/* 2532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _semanticUiReact = __webpack_require__(2);

var _ProjectUnitsList = __webpack_require__(567);

var _ProjectUnitsList2 = _interopRequireDefault(_ProjectUnitsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UnitsList = function (_Component) {
  _inherits(UnitsList, _Component);

  function UnitsList() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UnitsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UnitsList.__proto__ || Object.getPrototypeOf(UnitsList)).call.apply(_ref, [this].concat(args))), _this), _this.handleBook = function (e, _ref2) {
      var unit = _ref2.unit;

      e.preventDefault();
      if (_this.props.onConfirm) {
        _this.props.onConfirm(e, { unit: unit });
      }
    }, _this.handleOnClose = function (e) {
      if (_this.props.onClose) {
        _this.props.onClose(e);
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UnitsList, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _semanticUiReact.Modal,
        {
          open: this.props.open === true,
          onClose: this.handleOnClose,
          closeIcon: 'close',
          size: 'large'
        },
        _react2.default.createElement(_semanticUiReact.Header, {
          icon: 'home',
          content: (this.props.unitLayout ? this.props.unitLayout.name : 'Book') + ' units'
        }),
        _react2.default.createElement(
          _semanticUiReact.Modal.Content,
          null,
          _react2.default.createElement(_ProjectUnitsList2.default, {
            toggleable: true,
            projectID: this.props.projectID,
            project: this.props.project,
            unitLayoutID: this.props.unitLayout ? this.props.unitLayout.id : null,
            where: this.props.where,
            unitOnClick: this.handleBook
          })
        )
      );
    }
  }]);

  return UnitsList;
}(_react.Component);

UnitsList.propTypes = {
  open: _propTypes2.default.bool,
  onClose: _propTypes2.default.func,
  onConfirm: _propTypes2.default.func,
  projectID: _propTypes2.default.string,
  unitLayout: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    name: _propTypes2.default.string
  }),
  where: _propTypes2.default.shape({
    limit: _propTypes2.default.number,
    projectUnitLayoutID: _propTypes2.default.string
  }),
  project: _propTypes2.default.shape({
    siteplanSettings: _propTypes2.default.shape({
      salesChartSimpleMode: _propTypes2.default.bool,
      unitListDisableClickUnavailable: _propTypes2.default.bool
    }),
    activeBookingsInUnits: _propTypes2.default.bool
  })
};
exports.default = UnitsList;

/***/ }),
/* 2533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.googleAnalytics = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactGa = __webpack_require__(288);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var state = {
  currentPage: '',
  userID: '',
  userEmail: '',
  appVersion: _config2.default.get('version') || '',
  appId: '',
  appName: 'mhub-book-web'
};

var trackPage = function trackPage(page) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _reactGa2.default.send(_extends({
    hitType: 'pageview',
    page: page
  }, options));
  // ReactGA.event('location_change', {
  //   page,
  //   ...options,
  // });
};

var googleAnalytics = exports.googleAnalytics = function googleAnalytics(store) {
  return function (next) {
    return function (action) {
      var payload = store.getState();
      if (payload && payload.auth && payload.auth.id) state.userID = payload.auth.id;
      if (payload && payload.auth && payload.auth.email) state.userEmail = payload.auth.email;
      if (payload && payload.auth && payload.auth.company && payload.auth.company.id) state.appId = payload.auth.company.id;
      if (action.type === '@@router/LOCATION_CHANGE') {
        var nextPage = '' + action.payload.pathname + action.payload.search;
        if (!(state.currentPage === nextPage || nextPage === action.payload.pathname + '?')) {
          state.currentPage = nextPage;
          trackPage(nextPage, { user_id: state.userID });
        }
      }
      return next(action);
    };
  };
};

/***/ }),
/* 2534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startTracing = exports.EndUserSpanProcessor = exports.NavigationNameSpanProcessor = exports.routeTemplateForUrl = exports.setRouteTable = exports.OutboundPeerSpanProcessor = exports.nameClientSpanFromRoute = exports.peerServiceForUrl = exports.withExportSanitizer = exports.redactSignedUrls = exports.isSignedUrl = exports.stripQueryString = exports.buildSampler = exports.parseOtlpHeaders = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* eslint no-console: 0 */
/*
 * The OpenTelemetry SDK half of browser tracing. Never import this module statically: it pulls in
 * zone.js (which patches Promise and timers the moment it evaluates) and every instrumentation.
 * ./telemetry.js requires it only when an OTLP endpoint was configured at build time, and a build
 * without one does not contain it. See docs/OTEL.md, "Nothing loads when tracing is off".
 */


var _contextZone = __webpack_require__(1917);

var _core = __webpack_require__(65);

var _exporterTraceOtlpHttp = __webpack_require__(1943);

var _instrumentation = __webpack_require__(303);

var _api = __webpack_require__(32);

var _resources = __webpack_require__(932);

var _sdkTraceBase = __webpack_require__(538);

var _sdkTraceWeb = __webpack_require__(259);

var _autoInstrumentationsWeb = __webpack_require__(1912);

var _reactRouter = __webpack_require__(18);

var _PatternUtils = __webpack_require__(3215);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// mhub AWS-tagging `application` code for the Showroom family — see the otel-integration
// skill's tagging-alignment.md. Not a free-text product name.
var SERVICE_NAMESPACE = 'sr';
var SERVICE_NAME = 'mhub-book-web';

/**
 * Parses the `k=v,k2=v2` OTLP header syntax (percent-decoded values, e.g.
 * `authorization=Bearer%20<token>`). The browser SDK does not read
 * OTEL_EXPORTER_OTLP_HEADERS itself, so this is done by hand. A malformed
 * escape falls back to the raw value rather than throwing — one bad
 * character should not take tracing down.
 */
var parseOtlpHeaders = exports.parseOtlpHeaders = function parseOtlpHeaders(raw) {
  var headers = {};
  if (!raw) return headers;

  raw.split(',').forEach(function (pair) {
    var parts = pair.split('=');
    var key = parts[0];
    if (!key || parts.length < 2) return;
    var value = parts.slice(1).join('=').trim();
    try {
      headers[key.trim()] = decodeURIComponent(value);
    } catch (e) {
      headers[key.trim()] = value;
    }
  });
  return headers;
};

/**
 * The head sampler: ParentBased(TraceIdRatioBased(ratio)), i.e. `parentbased_traceidratio`.
 *
 * The browser starts almost every trace it is part of, so `ratio` is what decides how many of
 * them are kept. The decision travels in `traceparent`, and the Go tiers' default
 * ParentBased sampler honours it, so an unsampled click is unsampled end to end rather than
 * leaving orphaned backend halves. A ratio of 1 uses AlwaysOn: TraceIdRatioBased(1) still drops
 * the one trace id in 2^32 that lands on its upper bound.
 */
var buildSampler = exports.buildSampler = function buildSampler(ratio) {
  return new _sdkTraceBase.ParentBasedSampler({
    root: ratio >= 1 ? new _sdkTraceBase.AlwaysOnSampler() : new _sdkTraceBase.TraceIdRatioBasedSampler(ratio)
  });
};

// Both spellings of the request-URL attribute, because the two are a semconv rename mid-flight
// and this SDK line still emits the OLD one: instrumentation-fetch/-xml-http-request 0.57,
// document-load and user-interaction set "http.url", while 2.x and mhub-core-web use "url.full".
// Sanitising only `url.full` here silently does nothing — verified against a real
// headless-browser export, not read off the docs.
var URL_ATTRIBUTES = ['url.full', 'http.url'];

/**
 * Returns `raw` with its query string, fragment and any userinfo removed: origin and path only.
 *
 * Applied to every exported URL attribute, whatever the URL. A query string is caller data — the
 * purchaser search box, filters, tokens in a link — and once exported it sits in the trace
 * backend for every reader of it. The path stays, because it is what makes the span useful; span
 * names come from route templates (NavigationNameSpanProcessor, nameClientSpanFromRoute), not
 * from this attribute.
 */
var stripQueryString = exports.stripQueryString = function stripQueryString(raw) {
  if (typeof raw !== 'string') return raw;
  try {
    var url = new URL(raw);
    url.search = '';
    url.hash = '';
    url.username = '';
    url.password = '';
    return url.toString();
  } catch (e) {
    // Relative or otherwise unparseable: still cut at the first `?` or `#`.
    return raw.split(/[?#]/)[0];
  }
};

// Query parameters whose presence makes a URL itself a bearer credential, replayable until it
// expires: CloudFront signed URLs (Signature, Key-Pair-Id, Expires, Policy) and S3 SigV4
// presigned URLs (X-Amz-Signature, X-Amz-Credential, X-Amz-Security-Token, …).
var SIGNED_URL_PARAM = /^(?:Signature|Key-Pair-Id|Expires|Policy|X-Amz-.+)$/i;
var URL_IN_TEXT = /https?:\/\/[^\s"'<>]+/gi;

/** Whether `raw` carries a signed-URL credential in its query string. */
var isSignedUrl = exports.isSignedUrl = function isSignedUrl(raw) {
  try {
    var signed = false;
    new URL(raw).searchParams.forEach(function (value, key) {
      if (SIGNED_URL_PARAM.test(key)) signed = true;
    });
    return signed;
  } catch (e) {
    return false;
  }
};

/**
 * Strips the query string from every signed URL embedded in free text, leaving the rest alone.
 *
 * The URL attributes are already stripped wholesale; this is for a signed URL that turns up
 * anywhere else — an error message, a status text, an attribute a later change adds. Those are
 * not URLs we know to look for, and a credential is the one thing that must not get through.
 */
var redactSignedUrls = exports.redactSignedUrls = function redactSignedUrls(text) {
  if (typeof text !== 'string') return text;
  return text.replace(URL_IN_TEXT, function (match) {
    return isSignedUrl(match) ? stripQueryString(match) : match;
  });
};

var sanitizeAttributes = function sanitizeAttributes(attributes, isUrlAttribute) {
  if (!attributes) return;
  Object.keys(attributes).forEach(function (key) {
    var value = attributes[key];
    if (typeof value !== 'string') return;
    // eslint-disable-next-line no-param-reassign
    attributes[key] = isUrlAttribute(key) ? stripQueryString(value) : redactSignedUrls(value);
  });
};

// document-load records a `resourceFetch` span for every resource the page loaded, third-party
// scripts and fonts included. ignoreUrls cannot reach them — it is a fetch/XHR option — so they
// are dropped here instead.
var RESOURCE_FETCH = 'resourceFetch';

var pageOrigin = function pageOrigin() {
  return typeof window !== 'undefined' && window.location ? window.location.origin : null;
};

var isThirdPartyResource = function isThirdPartyResource(span, isTracedUrl) {
  if (span.name !== RESOURCE_FETCH) return false;
  var url = span.attributes['http.url'];
  if (typeof url !== 'string') return false;
  try {
    return new URL(url).origin !== pageOrigin() && !isTracedUrl(url);
  } catch (e) {
    return false;
  }
};

/**
 * Wraps an exporter so what leaves the browser is only what should:
 *
 * - every URL attribute loses its query string, fragment and userinfo (stripQueryString);
 * - a signed URL anywhere else in a string attribute, on the span or its events, loses its query
 *   string too (redactSignedUrls);
 * - document-load's `resourceFetch` spans for third-party resources are dropped.
 *
 * Applied at the exporter rather than through instrumentation-fetch's
 * applyCustomAttributesOnSpan: that hook receives the RequestInit (empty for
 * `fetch(url)`) and a FetchError that carries no URL, so a failed request would export the
 * URL anyway. Here every instrumentation and every outcome passes through one place — and it
 * runs after the span processors, which still see the full URL they resolve peers and route
 * names from.
 */
var withExportSanitizer = exports.withExportSanitizer = function withExportSanitizer(exporter) {
  var isTracedUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {
    return false;
  };
  return {
    export: function _export(spans, resultCallback) {
      var kept = spans.filter(function (span) {
        return !isThirdPartyResource(span, isTracedUrl);
      });
      kept.forEach(function (span) {
        sanitizeAttributes(span.attributes, function (key) {
          return URL_ATTRIBUTES.indexOf(key) !== -1;
        });
        (span.events || []).forEach(function (event) {
          return sanitizeAttributes(event.attributes, function () {
            return false;
          });
        });
      });
      if (kept.length === 0) {
        resultCallback({ code: _core.ExportResultCode.SUCCESS });
        return;
      }
      exporter.export(kept, resultCallback);
    },
    shutdown: function shutdown() {
      return exporter.shutdown();
    },
    forceFlush: function forceFlush() {
      return exporter.forceFlush ? exporter.forceFlush() : Promise.resolve();
    }
  };
};

/** Returns the configured downstream whose origin owns `rawUrl`. */
var peerServiceForUrl = exports.peerServiceForUrl = function peerServiceForUrl(rawUrl, downstreams) {
  try {
    var origin = new URL(rawUrl).origin;
    var downstream = downstreams.find(function (_ref) {
      var url = _ref.url;
      return url && new URL(url).origin === origin;
    });
    return downstream ? downstream.peerService : null;
  } catch (e) {
    return null;
  }
};

// The two MHub APIs this app calls. Read per call: bookApiURL is tenant-specific and arrives
// only after login.
var ownApis = function ownApis() {
  return [{ url: _config2.default.get('apiURL'), peerService: 'mhub-api' }, { url: _config2.default.get('bookApiURL'), peerService: 'mhub-book-api' }];
};

// mhub-book-api and mhub-api return their SERVER span's route template in this header.
var ROUTE_HEADER = 'x-mhub-route';
// What a route template may look like. Anything else is ignored, so even a misbehaving server
// cannot put an arbitrary string into a span name.
var ROUTE_TEMPLATE = /^\/[A-Za-z0-9_\-/:.*]{0,200}$/;

/**
 * Names an API call's CLIENT span after the route the server matched: `GET /bookings/:id/`
 * rather than the instrumentation's `HTTP GET`, with the template as `url.template`.
 *
 * The browser cannot know the route itself — it only has the URL, and deciding which of its
 * segments are ids is exactly the guess the naming rule forbids. The server does know it, so
 * it hands it back. Only our own APIs are believed, and a 404 is left alone: mhub-book-api
 * collapses those onto their mount pattern AFTER the header is written.
 */
var nameClientSpanFromRoute = exports.nameClientSpanFromRoute = function nameClientSpanFromRoute(span, url, status, route) {
  if (status === 404 || typeof route !== 'string' || !ROUTE_TEMPLATE.test(route)) return;
  if (!peerServiceForUrl(url, ownApis())) return;
  var method = span.attributes && span.attributes['http.method'];
  if (typeof method !== 'string') return;
  span.updateName(method.toUpperCase() + ' ' + route);
  span.setAttribute('url.template', route);
};

var nameFetchSpan = function nameFetchSpan(span, request, result) {
  if (!result || !result.headers || typeof result.headers.get !== 'function') return;
  nameClientSpanFromRoute(span, result.url, result.status, result.headers.get(ROUTE_HEADER));
};

var nameXhrSpan = function nameXhrSpan(span, xhr) {
  nameClientSpanFromRoute(span, xhr.responseURL, xhr.status, xhr.getResponseHeader(ROUTE_HEADER));
};

/**
 * Adds the network identity SigNoz uses to draw browser -> API edges.
 *
 * Auto-instrumentation owns these CLIENT spans, so a processor is the one central hook that
 * covers fetch and XMLHttpRequest without decorating hundreds of call sites. The URL-to-service
 * mapping is resolved when the span ends because bookApiURL is tenant-specific and arrives only
 * after login.
 */

var OutboundPeerSpanProcessor = exports.OutboundPeerSpanProcessor = function () {
  function OutboundPeerSpanProcessor() {
    _classCallCheck(this, OutboundPeerSpanProcessor);
  }

  _createClass(OutboundPeerSpanProcessor, [{
    key: 'onStart',

    /* eslint-disable class-methods-use-this */
    value: function onStart() {}
  }, {
    key: 'onEnd',
    value: function onEnd(span) {
      if (span.kind !== _api.SpanKind.CLIENT) return;
      var rawUrl = URL_ATTRIBUTES.map(function (attribute) {
        return span.attributes[attribute];
      }).find(function (value) {
        return typeof value === 'string';
      });
      var peerService = peerServiceForUrl(rawUrl, ownApis());
      if (!peerService) return;

      var url = new URL(rawUrl);
      // ReadableSpan attributes are mutable until the following BatchSpanProcessor snapshots them.
      // This is also how withExportSanitizer above strips query strings at export.
      // eslint-disable-next-line no-param-reassign
      span.attributes['peer.service'] = peerService;
      // eslint-disable-next-line no-param-reassign
      span.attributes['server.address'] = url.hostname;
      if (url.port) {
        // URL.port is empty for default ports, which semconv says to omit.
        // eslint-disable-next-line no-param-reassign
        span.attributes['server.port'] = Number(url.port);
      }
    }
  }, {
    key: 'shutdown',
    value: function shutdown() {
      return Promise.resolve();
    }
  }, {
    key: 'forceFlush',
    value: function forceFlush() {
      return Promise.resolve();
    }
    /* eslint-enable class-methods-use-this */

  }]);

  return OutboundPeerSpanProcessor;
}();

// instrumentation-user-interaction renames a click span to `Navigation: <url>` with the URL
// exactly as the app handed it to history.push — ids, query string and all.


var NAVIGATION_PREFIX = 'Navigation:';

// Full path templates of the app's registered routes; empty until setRouteTable() runs.
var routeTemplates = [];

var joinRoutePath = function joinRoutePath(parent, path) {
  if (!path) return parent;
  if (path.charAt(0) === '/') return path;
  return parent.charAt(parent.length - 1) === '/' ? '' + parent + path : parent + '/' + path;
};

var collectTemplates = function collectTemplates(routes, parent, out) {
  routes.forEach(function (route) {
    var template = joinRoutePath(parent, route.path);
    if (route.path) out.push(template);
    if (route.childRoutes) collectTemplates(route.childRoutes, template, out);
  });
  return out;
};

/**
 * Registers the react-router route table that navigation span names are resolved against.
 * A closed set of templates is what bounds the names: anything a caller types into the
 * address bar can only ever land on one of them, or on the bare fallback.
 */
var setRouteTable = exports.setRouteTable = function setRouteTable(routes) {
  routeTemplates = collectTemplates((0, _reactRouter.createRoutes)(routes), '', []).filter(function (template, i, all) {
    return all.indexOf(template) === i;
  });
};

// A literal segment beats a variable, a variable beats a splat.
var segmentRank = function segmentRank(segment) {
  if (segment.indexOf('*') !== -1) return 0;
  if (segment.indexOf(':') !== -1) return 1;
  return 2;
};

// Most specific first: decided at the first segment where two templates differ, so the answer
// never depends on the order routes are declared in.
var bySpecificity = function bySpecificity(a, b) {
  var as = a.split('/');
  var bs = b.split('/');
  for (var i = 0; i < Math.max(as.length, bs.length); i += 1) {
    var diff = segmentRank(bs[i] || '*') - segmentRank(as[i] || '*');
    if (diff !== 0) return diff;
  }
  return 0;
};

/** Returns the registered template `url`'s path matches, or null when none does. */
var routeTemplateForUrl = exports.routeTemplateForUrl = function routeTemplateForUrl(url) {
  var pathname = void 0;
  try {
    var _ref2 = new URL(url, 'http://route.invalid');

    pathname = _ref2.pathname;
  } catch (e) {
    return null;
  }
  var matches = routeTemplates.filter(function (template) {
    var match = (0, _PatternUtils.matchPattern)(template, pathname);
    return match && !match.remainingPathname;
  });
  return matches.length ? matches.sort(bySpecificity)[0] : null;
};

/**
 * Names navigation spans after the route template (`Navigation: /bookings/:id/`) instead of
 * the URL. An unmatched URL gets the bare `Navigation`, never the path the caller chose.
 */

var NavigationNameSpanProcessor = exports.NavigationNameSpanProcessor = function () {
  function NavigationNameSpanProcessor() {
    _classCallCheck(this, NavigationNameSpanProcessor);
  }

  _createClass(NavigationNameSpanProcessor, [{
    key: 'onStart',

    /* eslint-disable class-methods-use-this */
    value: function onStart() {}
  }, {
    key: 'onEnd',
    value: function onEnd(span) {
      if (span.name.indexOf(NAVIGATION_PREFIX) !== 0) return;
      var template = routeTemplateForUrl(span.name.slice(NAVIGATION_PREFIX.length).trim());
      // The ended span is still the SDK's mutable Span object until the batcher snapshots it,
      // the same window OutboundPeerSpanProcessor uses for its attributes.
      // eslint-disable-next-line no-param-reassign
      span.name = template ? NAVIGATION_PREFIX + ' ' + template : 'Navigation';
    }
  }, {
    key: 'shutdown',
    value: function shutdown() {
      return Promise.resolve();
    }
  }, {
    key: 'forceFlush',
    value: function forceFlush() {
      return Promise.resolve();
    }
    /* eslint-enable class-methods-use-this */

  }]);

  return NavigationNameSpanProcessor;
}();

/**
 * Stamps the current caller onto the trace's ROOT span at creation.
 *
 * A processor rather than per-call-site attributes because the browser's spans are created by
 * the auto-instrumentations (fetch, xhr, document-load) — there is no call site of ours to
 * decorate. onStart is the only hook that reaches them, and it runs before export, so the
 * attributes are on the span the exporter sends.
 *
 * Root span only, deliberately. SigNoz filters traces by their root span and then opens the
 * tree, so repeating identity on every child buys no query power and multiplies its storage by
 * the span count. That matters more here than it looks: a user id is high-cardinality, and it is
 * affordable as an attribute precisely because it appears once per trace.
 *
 * `getEndUser` is ./telemetry.js's accessor: the caller is recorded there at login whether or
 * not tracing is on, and read here per span.
 */


var EndUserSpanProcessor = exports.EndUserSpanProcessor = function () {
  function EndUserSpanProcessor(getEndUser) {
    _classCallCheck(this, EndUserSpanProcessor);

    this.getEndUser = getEndUser;
  }

  _createClass(EndUserSpanProcessor, [{
    key: 'onStart',
    value: function onStart(span, parentContext) {
      var endUser = this.getEndUser();
      if (!endUser) return;
      // A span with a parent already sits under a root that carries the caller. Reading the parent
      // from the context passed to onStart, rather than from the span, is what makes this work for
      // auto-instrumented spans: they are created from the active context, not by us.
      var parent = parentContext ? _api.trace.getSpanContext(parentContext) : undefined;
      if (parent && parent.spanId) return;
      span.setAttributes(endUser);
    }

    /* eslint-disable class-methods-use-this */

  }, {
    key: 'onEnd',
    value: function onEnd() {}
  }, {
    key: 'shutdown',
    value: function shutdown() {
      return Promise.resolve();
    }
  }, {
    key: 'forceFlush',
    value: function forceFlush() {
      return Promise.resolve();
    }
    /* eslint-enable class-methods-use-this */

  }]);

  return EndUserSpanProcessor;
}();

/**
 * Builds and registers the tracer provider and the instrumentations. Throws on bad
 * configuration — ./telemetry.js's initTelemetry() is what turns that into "run untraced" rather
 * than "do not start". Nothing is registered before the exporter is built, which is where a bad
 * endpoint throws.
 *
 * `propagateTraceHeaderCorsUrls` and `ignoreUrls` are ./telemetry.js's live arrays: both
 * instrumentations re-read them per request, so the tenant API registered after login is picked
 * up without re-registering anything.
 */


var startTracing = exports.startTracing = function startTracing(_ref3) {
  var endpoint = _ref3.endpoint,
      routes = _ref3.routes,
      _ref3$samplerRatio = _ref3.samplerRatio,
      samplerRatio = _ref3$samplerRatio === undefined ? 1 : _ref3$samplerRatio,
      propagateTraceHeaderCorsUrls = _ref3.propagateTraceHeaderCorsUrls,
      ignoreUrls = _ref3.ignoreUrls,
      isTracedUrl = _ref3.isTracedUrl,
      getEndUser = _ref3.getEndUser;

  var headers = parseOtlpHeaders(_config2.default.get('otelHeaders'));
  // An empty {} is still truthy, so spread it in conditionally: supplying
  // `headers` at all switches the exporter from sendBeacon to XHR, and only
  // sendBeacon survives page unload.
  var authenticated = Object.keys(headers).length > 0;

  var exporter = new _exporterTraceOtlpHttp.OTLPTraceExporter(Object.assign({ url: endpoint + '/v1/traces' }, authenticated ? { headers: headers } : {}));

  // Account-scoped environment (equals the AWS `environment` tag), NOT
  // releaseStage — that is the application environment and names resources.
  // Falls back to it only until RESOURCE_ENVIRONMENT is plumbed through in CI.
  var resourceEnvironment = _config2.default.get('otelResourceEnvironment') || _config2.default.get('releaseStage');

  var provider = new _sdkTraceWeb.WebTracerProvider({
    resource: new _resources.Resource({
      'service.name': SERVICE_NAME,
      'service.namespace': SERVICE_NAMESPACE,
      // config's `version` is "<pkg version> <build epoch ms>"; only the first token is
      // the version, and the tagging charset has no room for a space.
      'service.version': String(_config2.default.get('version') || '').split(' ')[0] || 'dev',
      'deployment.environment': resourceEnvironment,
      'deployment.environment.name': resourceEnvironment
    }),
    sampler: buildSampler(samplerRatio),
    // The caller stamp runs first so every span carries it before the batcher sees it.
    spanProcessors: [new EndUserSpanProcessor(getEndUser), new OutboundPeerSpanProcessor(), new NavigationNameSpanProcessor(), new _sdkTraceBase.BatchSpanProcessor(withExportSanitizer(exporter, isTracedUrl))]
  });

  provider.register({
    contextManager: new _contextZone.ZoneContextManager(),
    propagator: new _core.W3CTraceContextPropagator()
  });

  if (routes) setRouteTable(routes);

  (0, _instrumentation.registerInstrumentations)({
    instrumentations: [(0, _autoInstrumentationsWeb.getWebAutoInstrumentations)({
      '@opentelemetry/instrumentation-fetch': {
        propagateTraceHeaderCorsUrls: propagateTraceHeaderCorsUrls,
        ignoreUrls: ignoreUrls,
        applyCustomAttributesOnSpan: nameFetchSpan
      },
      '@opentelemetry/instrumentation-xml-http-request': {
        propagateTraceHeaderCorsUrls: propagateTraceHeaderCorsUrls,
        ignoreUrls: ignoreUrls,
        applyCustomAttributesOnSpan: nameXhrSpan
      }
    })]
  });

  console.info('[telemetry] OpenTelemetry tracing initialised', endpoint, 'sampler ratio ' + samplerRatio);
};

/***/ }),
/* 2535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.ADDRESS_SETTINGS_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.ADDRESS_SETTINGS_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: payload.data ? [].concat(payload.data) : [],
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.ADDRESS_SETTINGS_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.AFFILIATE_MAPPINGS_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.AFFILIATE_MAPPINGS_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: [].concat(payload.data),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.AFFILIATE_MAPPINGS_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: {}
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.APP_CONFIG_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.APP_CONFIG_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: payload.data
  });
}), _defineProperty(_createReducer, _actions.APP_CONFIG_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  token: null,
  id: null,
  awsUsername: null,
  email: null,
  preferredName: null,
  affiliateID: null,
  affiliate: null,
  company: null,
  compayAppCredit: null,
  companyBranch: null,
  banker: null,
  groups: [],
  isAuthenticated: false,
  isAuthenticating: false,
  isHeadquarters: false,
  isBranchLeaderSupervisorII: false,
  isBranchLeaderSupervisor: false,
  isBranchLeader: false,
  isDeveloper: false,
  isDeveloperSupervisor: false,
  isDeveloperSalesManager: false,
  isDeveloperSalesAdmin: false,
  isDeveloperStaff: false,
  isExternalAgentLeader: false,
  isExternalAgent: false,
  isExternalAgencyAdmin: false,
  isSiteplan: false,
  isSuperAdmin: false,
  isAdminBasic: false,
  isAdminCommunity: false,
  isAdmin: false,
  isMainHeadquarters: false,
  creditCheckAccess: false,
  statusText: null,
  allowEditUnitPrice: false,
  allowEditUnitDetails: false,
  isADFS: false,
  adfsProvider: '',
  announcementAddBanker: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.LOGIN_USER_REQUEST, function (state) {
  return Object.assign({}, state, {
    isAuthenticating: true,
    isADFS: false,
    adfsProvider: ''
  });
}), _defineProperty(_createReducer, _actions.LOGIN_USER_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    announcementAddBanker: payload.announcementAddBanker,
    isAuthenticating: false,
    isAuthenticated: true,
    id: payload.id,
    awsUsername: payload.awsUsername,
    email: payload.email,
    preferredName: payload.preferredName,
    affiliateID: payload.affiliateID,
    language: payload.currentLanguageCode || payload.language,
    company: payload.affiliate ? payload.affiliate.company : {},
    companyApps: payload.affiliate && payload.affiliate.company ? [].concat(payload.affiliate.company.apps) : [],
    companyBranch: payload.affiliate ? payload.affiliate.companyBranch : {},
    groups: payload.groups ? [].concat(payload.groups) : [],
    statusText: 'You have been successfully logged in.'
  });
}), _defineProperty(_createReducer, _actions.LOGIN_USER_FAILURE, function (state) {
  return Object.assign({}, state, {
    statusText: 'Authentication Error',
    isAuthenticated: false,
    isAuthenticating: false
  });
}), _defineProperty(_createReducer, _actions.LOGIN_USER_UPDATE_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    email: payload.email,
    preferredName: payload.preferredName
  });
}), _defineProperty(_createReducer, _actions.LOGOUT_USER_REQUEST, function () {
  return Object.assign({}, initialState);
}), _defineProperty(_createReducer, _actions.LOGOUT_USER_SUCCESS, function () {
  return Object.assign({}, initialState, {
    statusText: 'You have been successfully logged out.',
    isADFS: false,
    adfsProvider: ''
  });
}), _defineProperty(_createReducer, _actions.LOGOUT_USER_FAILURE, function (state) {
  return Object.assign({}, state, {
    statusText: 'Logout error'
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_HEADQUARTERS_ACCESS, function (state) {
  return Object.assign({}, state, {
    isHeadquarters: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_BRANCH_LEADER_SUPERVISOR_II_ACCESS, function (state) {
  return Object.assign({}, state, {
    isBranchLeaderSupervisorII: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_BRANCH_LEADER_SUPERVISOR_ACCESS, function (state) {
  return Object.assign({}, state, {
    isBranchLeaderSupervisor: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_BRANCH_LEADER_ACCESS, function (state) {
  return Object.assign({}, state, {
    isBranchLeader: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_DEVELOPER_ACCESS, function (state) {
  return Object.assign({}, state, {
    isDeveloper: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_DEVELOPER_SUPERVISOR, function (state) {
  return Object.assign({}, state, {
    isDeveloperSupervisor: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_DEVELOPER_SALES_MANAGER, function (state) {
  return Object.assign({}, state, {
    isDeveloperSalesManager: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_DEVELOPER_SALES_ADMIN, function (state) {
  return Object.assign({}, state, {
    isDeveloperSalesAdmin: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_DEVELOPER_STAFF, function (state) {
  return Object.assign({}, state, {
    isDeveloperStaff: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_EXTERNAL_AGENT_LEADER, function (state) {
  return Object.assign({}, state, {
    isExternalAgentLeader: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_EXTERNAL_AGENT, function (state) {
  return Object.assign({}, state, {
    isExternalAgent: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_EXTERNAL_AGENCY_ADMIN, function (state) {
  return Object.assign({}, state, {
    isExternalAgencyAdmin: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_DEVELOPER_SITEPLAN_ACCESS, function (state) {
  return Object.assign({}, state, {
    isSiteplan: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_MAIN_HEADQUARTERS_ACCESS, function (state) {
  return Object.assign({}, state, {
    isMainHeadquarters: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_SUPER_ADMIN_ACCESS, function (state) {
  return Object.assign({}, state, {
    isSuperAdmin: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_ADMIN_BASIC_ACCESS, function (state) {
  return Object.assign({}, state, {
    isAdminBasic: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_ADMIN_COMMUNITY_ACCESS, function (state) {
  return Object.assign({}, state, {
    isAdminCommunity: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_ADMIN_ACCESS, function (state) {
  return Object.assign({}, state, {
    isAdmin: true
  });
}), _defineProperty(_createReducer, _actions.APP_GIVE_CREDIT_CHECK_ACCESS, function (state) {
  return Object.assign({}, state, {
    creditCheckAccess: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_EDIT_UNIT_PRICE_ACCESS, function (state) {
  return Object.assign({}, state, {
    allowEditUnitPrice: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_GIVE_EDIT_UNIT_DETAIL_ACCESS, function (state) {
  return Object.assign({}, state, {
    allowEditUnitDetails: true
  });
}), _defineProperty(_createReducer, _actions.LOGIN_FROM_ADFS, function (state, payload) {
  return Object.assign({}, state, {
    isADFS: !!payload.provider,
    adfsProvider: payload.provider
  });
}), _defineProperty(_createReducer, 'companyCurrency', function companyCurrency(state, payload) {
  var oriState = state;
  if (payload.data) oriState.company.companyCurrency = payload.data;
  return oriState;
}), _createReducer));

/***/ }),
/* 2539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.BANK_CASE_STATES_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.BANK_CASE_STATES_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: [].concat(payload.data),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.BANK_CASE_STATES_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.BANKS_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.BANKS_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: payload.data,
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.BANKS_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.BOB_FORMS_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.BOB_FORMS_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: [].concat(payload.data),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.BOB_FORMS_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  data: []
};

exports.default = (0, _createReducer3.default)(initialState, _defineProperty({}, _actions.BOOK_QUERY_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: payload.data
  });
}));

/***/ }),
/* 2543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.CANCELLATION_REASONS_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.CANCELLATION_REASONS_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: [].concat(payload.data),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.CANCELLATION_REASONS_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: {},
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.CURRENCY_SETTINGS_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.CURRENCY_SETTINGS_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: payload.data,
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.CURRENCY_SETTINGS_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.CUSTOM_OPTIONS_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.CUSTOM_OPTIONS_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: payload.data ? [].concat(payload.data) : [],
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.CUSTOM_OPTIONS_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isFetching: false,
  isError: false,
  statusText: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.FETCH_REQUEST, function () {
  return Object.assign({}, initialState, {
    isFetching: true,
    isError: false
  });
}), _defineProperty(_createReducer, _actions.FETCH_SUCCESS, function (state) {
  return Object.assign({}, state, {
    isFetching: false
  });
}), _defineProperty(_createReducer, _actions.FETCH_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isFetching: false,
    isError: true,
    statusText: payload.statusText
  });
}), _createReducer));

/***/ }),
/* 2547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.FINANCE_SOURCES_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.FINANCE_SOURCES_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: [].concat(payload.data),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.FINANCE_SOURCES_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _reactRouterRedux = __webpack_require__(13);

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  header: null,
  message: null,
  list: [],
  icon: null,
  color: null,
  show: false,
  type: '',
  autoHideDuration: 5000
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.FLASH_MESSAGE, function (state, payload) {
  return Object.assign({}, state, {
    header: payload.header,
    message: payload.message,
    list: payload.list,
    icon: payload.icon,
    show: payload.show,
    color: payload.color,
    type: payload.type,
    autoHideDuration: payload.autoHideDuration
  });
}), _defineProperty(_createReducer, _actions.FLASH_MESSAGE_RESET, function () {
  return Object.assign({}, initialState);
}), _defineProperty(_createReducer, _reactRouterRedux.LOCATION_CHANGE, function () {
  return Object.assign({}, initialState);
}), _createReducer));

/***/ }),
/* 2549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.GLOBAL_SETTINGS_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.GLOBAL_SETTINGS_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: [].concat(payload.data),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.GLOBAL_SETTINGS_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.HIMS_DISTRICTS_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.HIMS_DISTRICTS_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: [].concat(payload.data),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.HIMS_DISTRICTS_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.HIMS_POSTCODES_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.HIMS_POSTCODES_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: [].concat(payload.data),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.HIMS_POSTCODES_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.IDENTITY_PRESETS_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.IDENTITY_PRESETS_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: [].concat(payload.data),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.IDENTITY_PRESETS_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = __webpack_require__(698);

var _reactRouterRedux = __webpack_require__(13);

var _affiliateMappings = __webpack_require__(2536);

var _affiliateMappings2 = _interopRequireDefault(_affiliateMappings);

var _addressSettings = __webpack_require__(2535);

var _addressSettings2 = _interopRequireDefault(_addressSettings);

var _appConfig = __webpack_require__(2537);

var _appConfig2 = _interopRequireDefault(_appConfig);

var _auth = __webpack_require__(2538);

var _auth2 = _interopRequireDefault(_auth);

var _banks = __webpack_require__(2540);

var _banks2 = _interopRequireDefault(_banks);

var _bankCaseStates = __webpack_require__(2539);

var _bankCaseStates2 = _interopRequireDefault(_bankCaseStates);

var _bobForms = __webpack_require__(2541);

var _bobForms2 = _interopRequireDefault(_bobForms);

var _bookQuery = __webpack_require__(2542);

var _bookQuery2 = _interopRequireDefault(_bookQuery);

var _cancellationReasons = __webpack_require__(2543);

var _cancellationReasons2 = _interopRequireDefault(_cancellationReasons);

var _currencySetting = __webpack_require__(2544);

var _currencySetting2 = _interopRequireDefault(_currencySetting);

var _customOptions = __webpack_require__(2545);

var _customOptions2 = _interopRequireDefault(_customOptions);

var _fetchM = __webpack_require__(2546);

var _fetchM2 = _interopRequireDefault(_fetchM);

var _financeSources = __webpack_require__(2547);

var _financeSources2 = _interopRequireDefault(_financeSources);

var _flash = __webpack_require__(2548);

var _flash2 = _interopRequireDefault(_flash);

var _globalSettings = __webpack_require__(2549);

var _globalSettings2 = _interopRequireDefault(_globalSettings);

var _himsDistricts = __webpack_require__(2550);

var _himsDistricts2 = _interopRequireDefault(_himsDistricts);

var _himsPostcodes = __webpack_require__(2551);

var _himsPostcodes2 = _interopRequireDefault(_himsPostcodes);

var _identityPresets = __webpack_require__(2552);

var _identityPresets2 = _interopRequireDefault(_identityPresets);

var _network = __webpack_require__(2554);

var _network2 = _interopRequireDefault(_network);

var _phoneValidationPresets = __webpack_require__(2555);

var _phoneValidationPresets2 = _interopRequireDefault(_phoneValidationPresets);

var _projectBusinessUnits = __webpack_require__(2556);

var _projectBusinessUnits2 = _interopRequireDefault(_projectBusinessUnits);

var _projectMappings = __webpack_require__(2557);

var _projectMappings2 = _interopRequireDefault(_projectMappings);

var _projectOptions = __webpack_require__(2558);

var _projectOptions2 = _interopRequireDefault(_projectOptions);

var _projectSpecifications = __webpack_require__(2559);

var _projectSpecifications2 = _interopRequireDefault(_projectSpecifications);

var _projectUnitLayoutSpecifications = __webpack_require__(2560);

var _projectUnitLayoutSpecifications2 = _interopRequireDefault(_projectUnitLayoutSpecifications);

var _projectUnitSpecifications = __webpack_require__(2561);

var _projectUnitSpecifications2 = _interopRequireDefault(_projectUnitSpecifications);

var _prompt = __webpack_require__(2562);

var _prompt2 = _interopRequireDefault(_prompt);

var _salesChartTypes = __webpack_require__(2563);

var _salesChartTypes2 = _interopRequireDefault(_salesChartTypes);

var _tags = __webpack_require__(2564);

var _tags2 = _interopRequireDefault(_tags);

var _templates = __webpack_require__(2565);

var _templates2 = _interopRequireDefault(_templates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  routing: _reactRouterRedux.routerReducer,

  affiliateMappings: _affiliateMappings2.default,
  addressSettings: _addressSettings2.default,
  appConfig: _appConfig2.default,
  auth: _auth2.default,
  banks: _banks2.default,
  bankCaseStates: _bankCaseStates2.default,
  bobForms: _bobForms2.default,
  bookQuery: _bookQuery2.default,
  cancellationReasons: _cancellationReasons2.default,
  currencySetting: _currencySetting2.default,
  customOptions: _customOptions2.default,
  fetchM: _fetchM2.default,
  financeSources: _financeSources2.default,
  flash: _flash2.default,
  globalSettings: _globalSettings2.default,
  himsDistricts: _himsDistricts2.default,
  himsPostcodes: _himsPostcodes2.default,
  identityPresets: _identityPresets2.default,
  phoneValidationPresets: _phoneValidationPresets2.default,
  network: _network2.default,
  projectBusinessUnits: _projectBusinessUnits2.default,
  projectMappings: _projectMappings2.default,
  projectOptions: _projectOptions2.default,
  projectSpecifications: _projectSpecifications2.default,
  projectUnitLayoutSpecifications: _projectUnitLayoutSpecifications2.default,
  projectUnitSpecifications: _projectUnitSpecifications2.default,
  prompt: _prompt2.default,
  salesChartTypes: _salesChartTypes2.default,
  tags: _tags2.default,
  templates: _templates2.default
});

/***/ }),
/* 2554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isOK: true,
  isNotOK: false
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.NETWORK_OK, function () {
  return {
    isOK: true,
    isNotOK: false
  };
}), _defineProperty(_createReducer, _actions.NETWORK_FAILURE, function () {
  return {
    isOK: false,
    isNotOK: true
  };
}), _createReducer));

/***/ }),
/* 2555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.PHONE_VALIDATION_PRESETS_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.PHONE_VALIDATION_PRESETS_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: [].concat(payload.data),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.PHONE_VALIDATION_PRESETS_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.PROJECT_BUSINESS_UNITS_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.PROJECT_BUSINESS_UNIT_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: [].concat(payload.data),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.PROJECT_BUSINESS_UNIT_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.PROJECT_MAPPINGS_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.PROJECT_MAPPINGS_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: [].concat(payload.data),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.PROJECT_MAPPINGS_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.PROJECT_OPTIONS_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.PROJECT_OPTIONS_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: [].concat(payload.data),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.PROJECT_OPTIONS_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.PROJECT_SPECIFICATIONS_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.PROJECT_SPECIFICATIONS_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: [].concat(payload.data),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.PROJECT_SPECIFICATIONS_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.PROJECT_UNIT_LAYOUT_SPECIFICATIONS_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.PROJECT_UNIT_LAYOUT_SPECIFICATIONS_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: [].concat(payload.data),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.PROJECT_UNIT_LAYOUT_SPECIFICATIONS_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.PROJECT_UNIT_SPECIFICATIONS_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.PROJECT_UNIT_SPECIFICATIONS_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: [].concat(payload.data),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.PROJECT_UNIT_SPECIFICATIONS_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _reactRouterRedux = __webpack_require__(13);

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  header: null,
  message: null,
  icon: null,
  show: false,
  callback: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.PROMPT_MESSAGE, function (state, payload) {
  return Object.assign({}, state, {
    header: payload.header,
    message: payload.message,
    icon: payload.icon,
    samePage: payload.samePage,
    show: payload.show,
    callback: payload.callback
  });
}), _defineProperty(_createReducer, _actions.PROMPT_MESSAGE_RESET, function () {
  return Object.assign({}, initialState);
}), _defineProperty(_createReducer, _reactRouterRedux.LOCATION_CHANGE, function () {
  return Object.assign({}, initialState);
}), _createReducer));

/***/ }),
/* 2563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: [],
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.SALES_CHART_TYPES_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.SALES_CHART_TYPES_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: [].concat(payload.data),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.SALES_CHART_TYPES_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: {},
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.TAGS_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.TAGS_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: _extends({}, state.data, _defineProperty({}, payload.type, payload.data ? [].concat(payload.data) : [])),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.TAGS_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createReducer2 = __webpack_require__(49);

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _actions = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = {
  isError: false,
  statusText: null,
  data: {},
  token: null
};

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _actions.TEMPLATES_REQUEST, function (state) {
  return Object.assign({}, state, {
    isError: false
  });
}), _defineProperty(_createReducer, _actions.TEMPLATES_SUCCESS, function (state, payload) {
  return Object.assign({}, state, {
    data: _extends({}, state.data, _defineProperty({}, payload.type, payload.data ? [].concat(payload.data) : [])),
    token: payload.token
  });
}), _defineProperty(_createReducer, _actions.TEMPLATES_FAILURE, function (state, payload) {
  return Object.assign({}, state, {
    isError: true,
    statusText: payload.message
  });
}), _createReducer));

/***/ }),
/* 2566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactRouter = __webpack_require__(18);

var _auth = __webpack_require__(2571);

var _Accounting = __webpack_require__(2234);

var _Accounting2 = _interopRequireDefault(_Accounting);

var _AccountingIFCA = __webpack_require__(2236);

var _AccountingIFCA2 = _interopRequireDefault(_AccountingIFCA);

var _AccountingInsoft = __webpack_require__(2238);

var _AccountingInsoft2 = _interopRequireDefault(_AccountingInsoft);

var _Activities = __webpack_require__(2241);

var _Activities2 = _interopRequireDefault(_Activities);

var _AddressSettingActivities = __webpack_require__(2485);

var _AddressSettingActivities2 = _interopRequireDefault(_AddressSettingActivities);

var _AffiliateMappings = __webpack_require__(2246);

var _AffiliateMappings2 = _interopRequireDefault(_AffiliateMappings);

var _AppLoading = __webpack_require__(2247);

var _AppLoading2 = _interopRequireDefault(_AppLoading);

var _BookApp = __webpack_require__(2248);

var _BookApp2 = _interopRequireDefault(_BookApp);

var _BookDash = __webpack_require__(2249);

var _BookDash2 = _interopRequireDefault(_BookDash);

var _Bookings = __webpack_require__(2281);

var _Bookings2 = _interopRequireDefault(_Bookings);

var _BusinessUnits = __webpack_require__(2288);

var _BusinessUnits2 = _interopRequireDefault(_BusinessUnits);

var _CancellationReasons = __webpack_require__(2294);

var _CancellationReasons2 = _interopRequireDefault(_CancellationReasons);

var _CompanyCurrencies = __webpack_require__(2297);

var _CompanyCurrencies2 = _interopRequireDefault(_CompanyCurrencies);

var _CompanyDocuments = __webpack_require__(2301);

var _CompanyDocuments2 = _interopRequireDefault(_CompanyDocuments);

var _Customers = __webpack_require__(2322);

var _Customers2 = _interopRequireDefault(_Customers);

var _CustomOptions = __webpack_require__(2313);

var _CustomOptions2 = _interopRequireDefault(_CustomOptions);

var _Document = __webpack_require__(2326);

var _Document2 = _interopRequireDefault(_Document);

var _Documents = __webpack_require__(2329);

var _Documents2 = _interopRequireDefault(_Documents);

var _Forbidden = __webpack_require__(2330);

var _Forbidden2 = _interopRequireDefault(_Forbidden);

var _Integrations = __webpack_require__(2333);

var _Integrations2 = _interopRequireDefault(_Integrations);

var _Logo = __webpack_require__(2347);

var _Logo2 = _interopRequireDefault(_Logo);

var _Logos = __webpack_require__(2350);

var _Logos2 = _interopRequireDefault(_Logos);

var _Media = __webpack_require__(2353);

var _Media2 = _interopRequireDefault(_Media);

var _MultiUnits = __webpack_require__(2396);

var _MultiUnits2 = _interopRequireDefault(_MultiUnits);

var _New = __webpack_require__(2459);

var _New2 = _interopRequireDefault(_New);

var _NotFound = __webpack_require__(2354);

var _NotFound2 = _interopRequireDefault(_NotFound);

var _Payments = __webpack_require__(2374);

var _Payments2 = _interopRequireDefault(_Payments);

var _Picture = __webpack_require__(2378);

var _Picture2 = _interopRequireDefault(_Picture);

var _Pictures = __webpack_require__(2381);

var _Pictures2 = _interopRequireDefault(_Pictures);

var _PreferredBankers = __webpack_require__(2384);

var _PreferredBankers2 = _interopRequireDefault(_PreferredBankers);

var _PriceNaming = __webpack_require__(2386);

var _PriceNaming2 = _interopRequireDefault(_PriceNaming);

var _Profile = __webpack_require__(2389);

var _Profile2 = _interopRequireDefault(_Profile);

var _Project = __webpack_require__(2436);

var _Project2 = _interopRequireDefault(_Project);

var _List = __webpack_require__(2457);

var _List2 = _interopRequireDefault(_List);

var _ProjectMappings = __webpack_require__(2441);

var _ProjectMappings2 = _interopRequireDefault(_ProjectMappings);

var _Projects = __webpack_require__(2464);

var _Projects2 = _interopRequireDefault(_Projects);

var _ProjectSpecifications = __webpack_require__(2446);

var _ProjectSpecifications2 = _interopRequireDefault(_ProjectSpecifications);

var _Unit = __webpack_require__(2411);

var _Unit2 = _interopRequireDefault(_Unit);

var _Activities3 = __webpack_require__(2404);

var _Activities4 = _interopRequireDefault(_Activities3);

var _Edit = __webpack_require__(2406);

var _Edit2 = _interopRequireDefault(_Edit);

var _ProjectUnitLayoutSpecifications = __webpack_require__(2451);

var _ProjectUnitLayoutSpecifications2 = _interopRequireDefault(_ProjectUnitLayoutSpecifications);

var _Overview = __webpack_require__(2410);

var _Overview2 = _interopRequireDefault(_Overview);

var _ProjectUnitSpecifications = __webpack_require__(2456);

var _ProjectUnitSpecifications2 = _interopRequireDefault(_ProjectUnitSpecifications);

var _Reports = __webpack_require__(2467);

var _Reports2 = _interopRequireDefault(_Reports);

var _Settings = __webpack_require__(2476);

var _Settings2 = _interopRequireDefault(_Settings);

var _SMSTemplates = __webpack_require__(2473);

var _SMSTemplates2 = _interopRequireDefault(_SMSTemplates);

var _Staffs = __webpack_require__(2484);

var _Staffs2 = _interopRequireDefault(_Staffs);

var _SystemSettings = __webpack_require__(2487);

var _SystemSettings2 = _interopRequireDefault(_SystemSettings);

var _Tags = __webpack_require__(2492);

var _Tags2 = _interopRequireDefault(_Tags);

var _Templates = __webpack_require__(2497);

var _Templates2 = _interopRequireDefault(_Templates);

var _Video = __webpack_require__(2501);

var _Video2 = _interopRequireDefault(_Video);

var _Videos = __webpack_require__(2504);

var _Videos2 = _interopRequireDefault(_Videos);

var _promptMessages = __webpack_require__(43);

var _checkChanges = __webpack_require__(61);

var _Opportunities = __webpack_require__(2360);

var _Opportunities2 = _interopRequireDefault(_Opportunities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createElement(
  _reactRouter.Route,
  null,
  _react2.default.createElement(_reactRouter.Route, { path: '/loading/', component: _AppLoading2.default }),
  _react2.default.createElement(_reactRouter.Route, { path: '/forbidden/', component: _Forbidden2.default }),
  _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: (0, _auth.hasAccess)(_BookApp2.default) },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _BookDash2.default }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'accounting/', component: _Accounting2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Accounting2.default })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'accounting_ifca/', component: _AccountingIFCA2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _AccountingIFCA2.default })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'accounting_insoft/', component: _AccountingInsoft2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _AccountingInsoft2.default })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'activities/', component: _Activities2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Activities2.default.Overview }),
      _react2.default.createElement(_reactRouter.Route, { path: 'bookings/', component: _Activities2.default.Overview }),
      _react2.default.createElement(_reactRouter.Route, { path: 'project_units/', component: _Activities2.default.Overview }),
      _react2.default.createElement(_reactRouter.Route, { path: 'projects/', component: _Activities2.default.Overview }),
      _react2.default.createElement(_reactRouter.Route, { path: 'exports/', component: _Activities2.default.Overview }),
      _react2.default.createElement(_reactRouter.Route, { path: 'users/', component: _Activities2.default.Overview }),
      _react2.default.createElement(_reactRouter.Route, { path: 'business_units/', component: _Activities2.default.Overview })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'bookings/', component: _Bookings2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Bookings2.default.List }),
      _react2.default.createElement(_reactRouter.Route, { path: 'unit_progress/', component: _Bookings2.default.UnitProgress }),
      _react2.default.createElement(_reactRouter.Route, { path: 'manage/', component: _Bookings2.default.ManageBookings }),
      _react2.default.createElement(_reactRouter.Route, { path: 'new/', component: _Bookings2.default.New }),
      _react2.default.createElement(_reactRouter.Route, { path: 'hims/', component: _Bookings2.default.HIMSBookingSync }),
      _react2.default.createElement(_reactRouter.Route, { path: 'customEdit/', component: _Bookings2.default.CustomEdit })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'bookings/:id/', component: _Bookings2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Bookings2.default.Overview }),
      _react2.default.createElement(_reactRouter.Route, { path: 'activities/', component: _Bookings2.default.Activities }),
      _react2.default.createElement(_reactRouter.Route, { path: 'loan/', component: _Bookings2.default.Loan }),
      _react2.default.createElement(_reactRouter.Route, { path: 'payment/', component: _Bookings2.default.Payment }),
      _react2.default.createElement(_reactRouter.Route, { path: 'lppsa/', component: _Bookings2.default.LPPSA }),
      _react2.default.createElement(_reactRouter.Route, { path: 'credit_check/', component: _Bookings2.default.CreditCheck }),
      _react2.default.createElement(_reactRouter.Route, { path: 'customers/:customerID/credit_check/', component: _Customers2.default.CreditCheck })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'opportunities/', component: (0, _auth.hasInternalAccess)(_Opportunities2.default) },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Opportunities2.default.List }),
      _react2.default.createElement(_reactRouter.Route, { path: 'manage_refunds/', component: _Opportunities2.default.ManageRefunds }),
      _react2.default.createElement(_reactRouter.Route, { path: 'exports/', component: _Opportunities2.default.Exports })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'opportunities/:id/', component: (0, _auth.hasInternalAccess)(_Opportunities2.default) },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Opportunities2.default.Overview })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'business_units/', component: _BusinessUnits2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _BusinessUnits2.default.List }),
      _react2.default.createElement(_reactRouter.Route, { path: 'new/', component: _BusinessUnits2.default.New }),
      _react2.default.createElement(_reactRouter.Route, { path: ':id/', component: _BusinessUnits2.default.Overview }),
      _react2.default.createElement(_reactRouter.Route, { path: ':id/activities/', component: _BusinessUnits2.default.Activities })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: 'customers/manage/credit_checks/', component: _Customers2.default.ManageCreditCheck }),
    _react2.default.createElement(_reactRouter.Route, { path: 'customers/manage/credit_checks/settings/', component: _Customers2.default.ManageCreditCheckSettings }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'customers/', component: _Customers2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Customers2.default.List }),
      _react2.default.createElement(_reactRouter.Route, { path: 'new/', component: _Customers2.default.New })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: 'bookings/:id/customers/:customerID/income/:incomeID/', component: _Customers2.default.NewEditIncome }),
    _react2.default.createElement(_reactRouter.Route, { path: 'customers/:id/income/:incomeID/', component: _Customers2.default.NewEditIncome }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'customers/:id/', component: _Customers2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Customers2.default.Overview }),
      _react2.default.createElement(_reactRouter.Route, { path: 'details/:detailID/', component: _Customers2.default.Edit }),
      _react2.default.createElement(_reactRouter.Route, { path: 'credit_check/', component: _Customers2.default.CreditCheck }),
      _react2.default.createElement(_reactRouter.Route, { path: 'credit_checks/:creditCheckID/multiple_entities/', component: _Customers2.default.MultipleEntity })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'integrations/', component: _Integrations2.default },
      _react2.default.createElement(_reactRouter.Route, { path: 'sf/', component: _Integrations2.default.Salesforce })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'media/', component: _Media2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Media2.default.Dash })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'media/documents/', component: _Documents2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Documents2.default.List })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'media/documents/:id/', component: _Document2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Document2.default.Edit })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'media/logos/', component: _Logos2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Logos2.default.List })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'media/logos/:id/', component: _Logo2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Logo2.default.Edit })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'media/pictures/', component: _Pictures2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Pictures2.default.List })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'media/pictures/:id/', component: _Picture2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Picture2.default.Edit })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'media/videos/', component: _Videos2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Videos2.default.List })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'media/videos/:id/', component: _Video2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Video2.default.Edit })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: 'payments/', component: (0, _auth.hasRestrictedModuleAccess)(_Payments2.default) }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'projects/', component: _Projects2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _List2.default }),
      _react2.default.createElement(_reactRouter.Route, { path: 'new/', component: (0, _checkChanges.checkChanges)(_New2.default, { message: _promptMessages.NEW_PROJECT_PROMPT }) })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'projects/:id/', component: _Project2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Project2.default.Overview }),
      _react2.default.createElement(_reactRouter.Route, { path: 'lawyers/', component: _Project2.default.PanelLawyers }),
      _react2.default.createElement(_reactRouter.Route, { path: 'bankers/', component: _Project2.default.PanelBankers }),
      _react2.default.createElement(_reactRouter.Route, { path: 'documents/', component: _Project2.default.Documents }),
      _react2.default.createElement(_reactRouter.Route, { path: 'logo/', component: _Project2.default.Logo }),
      _react2.default.createElement(_reactRouter.Route, { path: 'edit/', component: _Project2.default.Edit }),
      _react2.default.createElement(_reactRouter.Route, { path: 'package_pricings/', component: _Project2.default.PackagePricing }),
      _react2.default.createElement(_reactRouter.Route, { path: 'pictures/', component: _Project2.default.Pictures }),
      _react2.default.createElement(_reactRouter.Route, { path: 'videos/', component: _Project2.default.Videos }),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'layouts/', component: _Project2.default.UnitLayouts },
        _react2.default.createElement(_reactRouter.IndexRoute, { component: _Project2.default.UnitLayouts.List }),
        _react2.default.createElement(_reactRouter.Route, { path: 'new/', component: _Project2.default.UnitLayouts.New }),
        _react2.default.createElement(_reactRouter.Route, { path: 'compare/', component: _Project2.default.UnitLayouts.Compare })
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'layouts/:unitLayoutID/', component: _Project2.default.UnitLayout },
        _react2.default.createElement(_reactRouter.IndexRoute, { component: _Project2.default.UnitLayout.Overview }),
        _react2.default.createElement(_reactRouter.Route, { path: 'edit/', component: _Project2.default.UnitLayout.Edit }),
        _react2.default.createElement(_reactRouter.Route, { path: 'pictures/', component: _Project2.default.UnitLayout.Pictures }),
        _react2.default.createElement(_reactRouter.Route, { path: 'documents/', component: _Project2.default.UnitLayout.Documents }),
        _react2.default.createElement(_reactRouter.Route, { path: 'videos/', component: _Project2.default.UnitLayout.Videos })
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'units/', component: _Project2.default.Units },
        _react2.default.createElement(_reactRouter.IndexRoute, { component: _Project2.default.Units.List }),
        _react2.default.createElement(_reactRouter.Route, { path: 'create/', component: _Project2.default.Units.New }),
        _react2.default.createElement(_reactRouter.Route, { path: 'import/', component: _Project2.default.Units.Import }),
        _react2.default.createElement(_reactRouter.Route, { path: 'import_pricings/', component: _Project2.default.Units.ImportPricing }),
        _react2.default.createElement(_reactRouter.Route, { path: 'edit/', component: (0, _auth.hasAffiliateAccess)(_MultiUnits2.default.Edit) }),
        _react2.default.createElement(_reactRouter.Route, { path: 'compare/', component: _Project2.default.Units.UnitsCompare }),
        _react2.default.createElement(
          _reactRouter.Route,
          { path: 'hims/', component: _Project2.default.Units.HIMSUnitSync },
          _react2.default.createElement(_reactRouter.IndexRoute, { component: _Project2.default.Units.HIMSUnitSync }),
          _react2.default.createElement(_reactRouter.Route, { path: ':himsSettingID/', component: _Project2.default.Units.HIMSUnitSync }),
          _react2.default.createElement(_reactRouter.Route, { path: ':himsSettingID/components/', component: _Project2.default.Units.HIMSUnitSync }),
          _react2.default.createElement(_reactRouter.Route, { path: ':himsSettingID/components/:componentID/', component: _Project2.default.Units.HIMSUnitSync })
        )
      ),
      _react2.default.createElement(
        _reactRouter.Route,
        { path: 'units/:unitID/', component: _Unit2.default },
        _react2.default.createElement(_reactRouter.IndexRoute, { component: (0, _checkChanges.checkChanges)(_Overview2.default) }),
        _react2.default.createElement(_reactRouter.Route, { path: 'edit/', component: (0, _checkChanges.checkChanges)(_Edit2.default) }),
        _react2.default.createElement(_reactRouter.Route, { path: 'activities/', component: _Activities4.default })
      ),
      _react2.default.createElement(_reactRouter.Route, { path: 'reports/', component: _Project2.default.Reports }),
      _react2.default.createElement(_reactRouter.Route, { path: 'activities/', component: _Project2.default.Activities })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'preferred_bankers/', component: (0, _auth.hasRestrictedModuleAccess)(_PreferredBankers2.default) },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _PreferredBankers2.default.List })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'reports/', component: (0, _auth.hasRestrictedModuleAccess)(_Reports2.default) },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Reports2.default.Overview })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'settings/', component: _Settings2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Settings2.default.Dash })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'settings/company_documents/', component: _CompanyDocuments2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _CompanyDocuments2.default.List })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: 'settings/custom_options/', component: _CustomOptions2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'settings/system_settings/', component: _SystemSettings2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'settings/address_settings/activities/', component: _AddressSettingActivities2.default }),
    _react2.default.createElement(_reactRouter.Route, { path: 'settings/price_naming/', component: _PriceNaming2.default }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'settings/projects/', component: _ProjectSpecifications2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _ProjectSpecifications2.default.List }),
      _react2.default.createElement(_reactRouter.Route, { path: 'new/', component: _ProjectSpecifications2.default.New }),
      _react2.default.createElement(_reactRouter.Route, { path: ':projectSpecificationID/', component: _ProjectSpecifications2.default.Edit })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'settings/mappings/projects/', component: _ProjectMappings2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _ProjectMappings2.default.List }),
      _react2.default.createElement(_reactRouter.Route, { path: 'new/', component: _ProjectMappings2.default.New }),
      _react2.default.createElement(_reactRouter.Route, { path: ':projectMappingID/', component: _ProjectMappings2.default.Edit })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'settings/layouts/', component: _ProjectUnitLayoutSpecifications2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _ProjectUnitLayoutSpecifications2.default.List }),
      _react2.default.createElement(_reactRouter.Route, { path: 'new/', component: _ProjectUnitLayoutSpecifications2.default.New }),
      _react2.default.createElement(_reactRouter.Route, { path: ':projectUnitLayoutSpecificationID/', component: _ProjectUnitLayoutSpecifications2.default.Edit })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'settings/units/', component: _ProjectUnitSpecifications2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _ProjectUnitSpecifications2.default.List }),
      _react2.default.createElement(_reactRouter.Route, { path: 'new/', component: _ProjectUnitSpecifications2.default.New }),
      _react2.default.createElement(_reactRouter.Route, { path: ':projectUnitSpecificationID/', component: _ProjectUnitSpecifications2.default.Edit })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'settings/tags/', component: _Tags2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Tags2.default.List }),
      _react2.default.createElement(_reactRouter.Route, { path: 'new/', component: _Tags2.default.New }),
      _react2.default.createElement(_reactRouter.Route, { path: ':tagID/', component: _Tags2.default.Edit })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'settings/print_templates/', component: _Templates2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Templates2.default.List }),
      _react2.default.createElement(_reactRouter.Route, { path: 'new/', component: _Templates2.default.New }),
      _react2.default.createElement(_reactRouter.Route, { path: ':templateID/', component: _Templates2.default.Edit })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'settings/quotation_templates/', component: _Templates2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Templates2.default.List }),
      _react2.default.createElement(_reactRouter.Route, { path: 'new/', component: _Templates2.default.New }),
      _react2.default.createElement(_reactRouter.Route, { path: ':templateID/', component: _Templates2.default.Edit })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'settings/sms_templates/', component: _SMSTemplates2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _SMSTemplates2.default.List }),
      _react2.default.createElement(_reactRouter.Route, { path: 'new/', component: _SMSTemplates2.default.New }),
      _react2.default.createElement(_reactRouter.Route, { path: ':smsTemplateID/', component: _SMSTemplates2.default.Edit })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: 'settings/currencies/', component: _CompanyCurrencies2.default }),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'settings/mappings/affiliates/', component: _AffiliateMappings2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _AffiliateMappings2.default.List }),
      _react2.default.createElement(_reactRouter.Route, { path: 'new/', component: _AffiliateMappings2.default.New }),
      _react2.default.createElement(_reactRouter.Route, { path: ':affiliateMappingID/', component: _AffiliateMappings2.default.Edit })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'settings/cancellation_reasons/', component: _CancellationReasons2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _CancellationReasons2.default.List }),
      _react2.default.createElement(_reactRouter.Route, { path: 'new/', component: _CancellationReasons2.default.New }),
      _react2.default.createElement(_reactRouter.Route, { path: ':cancellationReasonID/', component: _CancellationReasons2.default.Edit })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'staff/', component: _Staffs2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Staffs2.default.List }),
      _react2.default.createElement(_reactRouter.Route, { path: 'new/', component: _Staffs2.default.New }),
      _react2.default.createElement(_reactRouter.Route, { path: ':id/', component: _Staffs2.default.Overview }),
      _react2.default.createElement(_reactRouter.Route, { path: ':id/activities/', component: _Staffs2.default.Activities })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'users/', component: _Staffs2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Staffs2.default.List }),
      _react2.default.createElement(_reactRouter.Route, { path: 'import/', component: _Staffs2.default.Import }),
      _react2.default.createElement(_reactRouter.Route, { path: 'new/', component: _Staffs2.default.New }),
      _react2.default.createElement(_reactRouter.Route, { path: ':id/', component: _Staffs2.default.Overview }),
      _react2.default.createElement(_reactRouter.Route, { path: ':id/activities/', component: _Staffs2.default.Activities })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'profile/', component: _Profile2.default },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _Profile2.default.Overview })
    ),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _NotFound2.default })
  )
);

/***/ }),
/* 2567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = configureStore;

var _redux = __webpack_require__(698);

var _reduxThunk = __webpack_require__(3224);

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reactGa = __webpack_require__(288);

var _reactGa2 = _interopRequireDefault(_reactGa);

var _reactRouterRedux = __webpack_require__(13);

var _googleAnalytics = __webpack_require__(2533);

var _reducers = __webpack_require__(2553);

var _reducers2 = _interopRequireDefault(_reducers);

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function configureStore() {
  var initialState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var history = arguments[1];

  _reactGa2.default.initialize(_config2.default.get('gaID'), { debug: false });
  var devToolsExtension = function devToolsExtension(f) {
    return f;
  };
  if (_config2.default.get('server') === 'development') {
    devToolsExtension = window.devToolsExtension ? window.devToolsExtension() : function (f) {
      return f;
    };
  }
  return (0, _redux.createStore)(_reducers2.default, initialState, (0, _redux.compose)((0, _redux.applyMiddleware)(_reduxThunk2.default, (0, _reactRouterRedux.routerMiddleware)(history)), (0, _redux.applyMiddleware)(_googleAnalytics.googleAnalytics), devToolsExtension));
}

/***/ }),
/* 2568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BookingNoteDefault = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BookingNotePropTypes = _propTypes2.default.shape({
  id: _propTypes2.default.string,
  // used only in booking
  bookingID: _propTypes2.default.string,
  // used only in opportunity
  parentType: _propTypes2.default.string,
  parentID: _propTypes2.default.string,
  note: _propTypes2.default.string,
  privacy: _propTypes2.default.string,
  muName: _propTypes2.default.string,
  muPreferredName: _propTypes2.default.string,
  muIsAgent: _propTypes2.default.bool,
  muAwsID: _propTypes2.default.string,
  muID: _propTypes2.default.number,
  muAffiliateID: _propTypes2.default.number,
  muAffiliateCompanyBranchID: _propTypes2.default.number,
  muAffiliateCompanyBranchShortName: _propTypes2.default.string,
  muCompanyID: _propTypes2.default.number,
  deletedAt: _propTypes2.default.string,
  createdAt: _propTypes2.default.string,
  updatedAt: _propTypes2.default.string
});

var BookingNoteDefault = function BookingNoteDefault() {
  return Object.assign({}, {
    id: '',
    bookingID: '',
    parentType: '',
    parentID: '',
    note: '',
    privacy: '',
    muName: '',
    muPreferredName: '',
    muIsAgent: false,
    muAwsID: '',
    muID: 0,
    muAffiliateID: 0,
    muAffiliateCompanyBranchID: 0,
    muAffiliateCompanyBranchShortName: '',
    muCompanyID: 0,
    deletedAt: '',
    createdAt: '',
    updatedAt: ''
  });
};

exports.default = BookingNotePropTypes;
exports.BookingNoteDefault = BookingNoteDefault;

/***/ }),
/* 2569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StateAuth = _propTypes2.default.shape({
  company: _propTypes2.default.shape({
    companyCurrency: _propTypes2.default.array,
    customLogoSrc: _propTypes2.default.string,
    himsIsEnabled: _propTypes2.default.bool,
    id: _propTypes2.default.number,
    name: _propTypes2.default.string,
    service_company_id: _propTypes2.default.string,
    shortName: _propTypes2.default.string
  }),
  companyApps: _propTypes2.default.array,
  companyBranch: _propTypes2.default.shape({
    id: _propTypes2.default.number,
    isExternal: _propTypes2.default.bool,
    name: _propTypes2.default.string,
    service_company_branch_id: _propTypes2.default.string,
    shortName: _propTypes2.default.string
  }),
  groups: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string,
    code: _propTypes2.default.string
  })),
  affiliateID: _propTypes2.default.number,
  allowEditUnitDetails: _propTypes2.default.bool,
  allowEditUnitPrice: _propTypes2.default.bool,
  awsUsername: _propTypes2.default.string,
  creditCheckAccess: _propTypes2.default.bool,
  email: _propTypes2.default.string,
  id: _propTypes2.default.number,
  isBranchLeader: _propTypes2.default.bool,
  isBranchLeaderSupervisor: _propTypes2.default.bool,
  isBranchLeaderSupervisorII: _propTypes2.default.bool,
  isDeveloper: _propTypes2.default.bool,
  isMainHeadquarters: _propTypes2.default.bool,
  language: _propTypes2.default.string,
  preferredName: _propTypes2.default.string,
  // sr roles
  isSuperAdmin: _propTypes2.default.bool,
  isAdminBasic: _propTypes2.default.bool,
  isAdminCommunity: _propTypes2.default.bool,
  isHeadquarters: _propTypes2.default.bool,
  isDeveloperSupervisor: _propTypes2.default.bool,
  isDeveloperSalesManager: _propTypes2.default.bool,
  isDeveloperSalesAdmin: _propTypes2.default.bool,
  isExternalAgentLeader: _propTypes2.default.bool,
  isExternalAgencyAdmin: _propTypes2.default.bool,
  isExternalAgent: _propTypes2.default.bool,
  isDeveloperStaff: _propTypes2.default.bool,
  isDeveloperSiteplan: _propTypes2.default.bool
});

exports.default = StateAuth;

/***/ }),
/* 2570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrayChunk = arrayChunk;
exports.arrayContainsRequired = arrayContainsRequired;
exports.arrayHasMatchingValues = arrayHasMatchingValues;
function arrayChunk(array, chunkSize) {
  return array.reduce(function (previous, current) {
    var chunk = void 0;
    if (previous.length === 0 || previous[previous.length - 1].length === chunkSize) {
      chunk = [];
      previous.push(chunk);
    } else {
      chunk = previous[previous.length - 1];
    }
    chunk.push(current);
    return previous;
  }, []);
}

function arrayContainsRequired(required, data) {
  return required.every(function (element) {
    return data.includes(element);
  });
}

function arrayHasMatchingValues(requiredValues, inputValues) {
  return inputValues.some(function (value) {
    return requiredValues.includes(value);
  });
}

/***/ }),
/* 2571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.hasGroupAccess = hasGroupAccess;
exports.hasAccess = hasAccess;
exports.hasAffiliateAccess = hasAffiliateAccess;
exports.hasRestrictedModuleAccess = hasRestrictedModuleAccess;
exports.hasInternalAccess = hasInternalAccess;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _reactRouterRedux = __webpack_require__(13);

var _semanticUiReact = __webpack_require__(2);

var _qs = __webpack_require__(14);

var _qs2 = _interopRequireDefault(_qs);

var _moduleAccess = __webpack_require__(595);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/forbid-prop-types: 0 */

function hasGroupAccess(comp, allowedGroups) {
  var GroupAccess = function GroupAccess(_ref) {
    var groups = _ref.groups;

    if (allowedGroups.some(function (ag) {
      return groups.some(function (g) {
        return g.code === ag;
      });
    })) {
      return comp;
    }
    return null;
  };

  GroupAccess.propTypes = {
    groups: _propTypes2.default.array
  };

  var mapStateToProps = function mapStateToProps(state) {
    return {
      groups: state.auth.groups
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps)(GroupAccess);
}

function hasAccess(Comp) {
  var Authenticated = function (_Component) {
    _inherits(Authenticated, _Component);

    function Authenticated() {
      _classCallCheck(this, Authenticated);

      return _possibleConstructorReturn(this, (Authenticated.__proto__ || Object.getPrototypeOf(Authenticated)).apply(this, arguments));
    }

    _createClass(Authenticated, [{
      key: 'componentWillMount',
      value: function componentWillMount() {
        this.checkAuth(this.props.isAuthenticated);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        this.checkAuth(nextProps.isAuthenticated);
      }
    }, {
      key: 'checkAuth',
      value: function checkAuth(isAuthenticated) {
        var store = this.context.store;

        if (!isAuthenticated) {
          var query = Object.assign({}, this.props.location.query);
          var queries = _qs2.default.stringify(query) ? '?'.concat(_qs2.default.stringify(query)) : '';
          var hash = this.props.location.hash ? this.props.location.hash : '';
          var nextBase64 = null;
          if (this.props.location.pathname.length > 0) {
            try {
              nextBase64 = btoa(this.props.location.pathname + queries + hash);
            } catch (e) {
              Bugsnag.notifyException(e);
            }
          }
          store.dispatch((0, _reactRouterRedux.replace)('/loading/?' + (nextBase64 ? 'next=' + nextBase64 : '')));
        }
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(
          _react.Suspense,
          {
            fallback: _react2.default.createElement(
              _semanticUiReact.Dimmer,
              { style: { zIndex: 20 }, active: true, inverted: true },
              _react2.default.createElement(
                _semanticUiReact.Loader,
                { inline: 'centered' },
                'Loading'
              )
            )
          },
          _react2.default.createElement(
            'div',
            null,
            this.props.isAuthenticated === true ? _react2.default.createElement(Comp, this.props) : null
          )
        );
      }
    }]);

    return Authenticated;
  }(_react.Component);

  Authenticated.propTypes = {
    isAuthenticated: _propTypes2.default.bool,
    location: _propTypes2.default.shape({
      pathname: _propTypes2.default.string,
      hash: _propTypes2.default.string,
      query: _propTypes2.default.object
    })
  };

  Authenticated.contextTypes = {
    store: _propTypes2.default.object
  };

  var mapStateToProps = function mapStateToProps(state) {
    return {
      email: state.auth.email,
      isAuthenticated: state.auth.isAuthenticated
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps)(Authenticated);
}

function hasAffiliateAccess(Comp) {
  var AffiliateAccess = function AffiliateAccess(_ref2, _ref3) {
    var store = _ref3.store;

    var allowEditUnitPrice = _ref2.allowEditUnitPrice,
        allowEditUnitDetails = _ref2.allowEditUnitDetails,
        props = _objectWithoutProperties(_ref2, ['allowEditUnitPrice', 'allowEditUnitDetails']);

    if (allowEditUnitPrice || allowEditUnitDetails) {
      return _react2.default.createElement(Comp, props);
    }
    store.dispatch((0, _reactRouterRedux.replace)('/forbidden/'));
    return null;
  };

  AffiliateAccess.propTypes = {
    allowEditUnitPrice: _propTypes2.default.bool,
    allowEditUnitDetails: _propTypes2.default.bool
  };

  AffiliateAccess.contextTypes = {
    store: _propTypes2.default.object
  };

  var mapStateToProps = function mapStateToProps(state) {
    return {
      allowEditUnitPrice: state.auth.allowEditUnitPrice,
      allowEditUnitDetails: state.auth.allowEditUnitDetails
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps)(AffiliateAccess);
}

function hasRestrictedModuleAccess(Comp) {
  var RestrictedModuleAccess = function RestrictedModuleAccess(_ref4, _ref5) {
    var store = _ref5.store;

    var auth = _ref4.auth,
        props = _objectWithoutProperties(_ref4, ['auth']);

    if (!(0, _moduleAccess.canAccessRestrictedModule)(auth)) {
      store.dispatch((0, _reactRouterRedux.replace)('/forbidden/'));
      return null;
    }
    return _react2.default.createElement(Comp, props);
  };

  RestrictedModuleAccess.propTypes = {
    auth: _propTypes2.default.object
  };

  RestrictedModuleAccess.contextTypes = {
    store: _propTypes2.default.object
  };

  var mapStateToProps = function mapStateToProps(state) {
    return {
      auth: state.auth
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps)(RestrictedModuleAccess);
}

function hasInternalAccess(Comp) {
  var InternalAccess = function InternalAccess(_ref6, _ref7) {
    var store = _ref7.store;

    var companyBranch = _ref6.companyBranch,
        props = _objectWithoutProperties(_ref6, ['companyBranch']);

    if (companyBranch && companyBranch.isExternal) {
      store.dispatch((0, _reactRouterRedux.replace)('/forbidden/'));
      return null;
    }
    return _react2.default.createElement(Comp, props);
  };

  InternalAccess.propTypes = {
    companyBranch: _propTypes2.default.shape({
      isExternal: _propTypes2.default.bool
    })
  };

  InternalAccess.contextTypes = {
    store: _propTypes2.default.object
  };

  var mapStateToProps = function mapStateToProps(state) {
    return {
      companyBranch: state.auth.companyBranch
    };
  };

  return (0, _reactRedux.connect)(mapStateToProps)(InternalAccess);
}

/***/ }),
/* 2572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bookQueryToBooking = bookQueryToBooking;

var _booking = __webpack_require__(129);

var _booking2 = _interopRequireDefault(_booking);

var _booking_customer = __webpack_require__(1085);

var _booking_customer2 = _interopRequireDefault(_booking_customer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bookQueryToBooking() {
  var bookQueries = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var bookingCustomer = Object.assign({}, _booking_customer2.default, {});
  var booking = Object.assign({}, _booking2.default, {});
  var qf = {
    booking: booking,
    bookingCustomer: bookingCustomer,
    customerID: null,
    hasBooking: false,
    hasBookingCustomer: false
  };
  if (bookQueries.length > 0) {
    bookQueries.forEach(function (bq) {
      if (!bq.name) return;
      switch (bq.name) {
        case 'book_external_id':
          qf.booking.externalID = bq.value || '';
          qf.hasBooking = true;
          break;
        case 'book_external_lead_id':
          qf.booking.externalLeadID = bq.value || '';
          qf.hasBooking = true;
          break;
        case 'book_external_customer_id':
          qf.booking.externalCustomerID = bq.value || '';
          break;
        case 'book_customer_id':
          qf.customerID = bq.value || '';
          break;
        case 'book_customer_identity':
          qf.bookingCustomer.identity = bq.value || '';
          qf.hasBookingCustomer = true;
          break;
        case 'book_customer_identity_type':
          qf.bookingCustomer.identityTypeID = parseInt(bq.value, 10) || '';
          qf.hasBookingCustomer = true;
          break;
        case 'book_name':
          qf.bookingCustomer.name = bq.value || '';
          qf.hasBookingCustomer = true;
          break;
        case 'book_mobile_prefix':
          qf.bookingCustomer.mobilePrefix = bq.value || '';
          qf.hasBookingCustomer = true;
          break;
        case 'book_mobile':
          qf.bookingCustomer.mobile = bq.value || '';
          qf.hasBookingCustomer = true;
          break;
        case 'book_email':
          qf.bookingCustomer.email = bq.value || '';
          qf.hasBookingCustomer = true;
          break;
        default:
          break;
      }
    });
  }
  return qf;
}

/***/ }),
/* 2573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.identify = identify;

var _bowser = __webpack_require__(2599);

var _bowser2 = _interopRequireDefault(_bowser);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function identify() {
  var classNames = [];

  if (_bowser2.default.samsungBrowser) {
    classNames.push('samsung-browser');
  }

  if (_bowser2.default.ios && _bowser2.default.safari) {
    classNames.push('ios-safari');
  }

  var html = document.getElementsByTagName('html')[0];

  if (classNames.length) classNames.push('on-device');
  if (html.classList) {
    classNames.forEach(function (className) {
      html.classList.add(className);
    });
  }
}

/***/ }),
/* 2574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.visibleCancellationReasons = exports.cancellationReasonIDForChoice = exports.cancellationCategoryForChoice = exports.cancellationCategoryOptionValue = exports.cancellationCategoryForReasonID = exports.cancellationCategoryForReasonName = exports.CANCELLATION_CATEGORY_ERROR = exports.CANCELLATION_CATEGORY_BUYER = undefined;

var _vietnam = __webpack_require__(40);

var CANCELLATION_CATEGORY_BUYER = exports.CANCELLATION_CATEGORY_BUYER = 'buyer'; // CPI-1226 follow-up (PO, 5 Sep): picking one of the tenant's existing cancellation reasons
// pre-selects the category. Matching is on the DISPLAYED NAME, not the id - the list is
// admin-editable per tenant, so an id is no more stable than a name. Nothing here is enforced.

var CANCELLATION_CATEGORY_ERROR = exports.CANCELLATION_CATEGORY_ERROR = 'error';

var normalise = function normalise(value) {
  return String(value == null ? '' : value).toLowerCase();
};

// "Cancelled by Developer" -> buyer and "Change of Unit" -> buyer; for the latter both words are
// required, so a "Change of Parcel" row stays unmapped.
//
// CPI-1226 post-fix (PO, 8 Sep): a developer cancellation used to pre-select "due to Error". It
// now pre-selects "due to Buyer", because Error means "this reservation should never have
// existed" - a staff mistake being tidied up - and a developer withdrawing a unit is a real
// opportunity that ended, which belongs under Closed. Nothing maps to Error by name any more;
// Error is reachable only by picking the synthesized "Cancellation due to Error" option below.
var cancellationCategoryForReasonName = exports.cancellationCategoryForReasonName = function cancellationCategoryForReasonName(reasonName) {
  var name = normalise(reasonName);
  if (!name) return '';
  if (name.includes('developer')) return CANCELLATION_CATEGORY_BUYER;
  if (name.includes('change') && name.includes('unit')) return CANCELLATION_CATEGORY_BUYER;
  return '';
};

// The form holds the reason's id, so resolve it against the list first; an unknown id maps to ''.
var cancellationCategoryForReasonID = exports.cancellationCategoryForReasonID = function cancellationCategoryForReasonID(reasons, reasonID) {
  var reason = [].concat(reasons || []).find(function (item) {
    return item && item.id === reasonID;
  });
  return reason ? cancellationCategoryForReasonName(reason.name) : '';
};

// CPI-1226 post-fix (PO, 6 Sep 09:32): "change of unit can tie it to due to buyer. by developer
// leave it as it is. so total in drop down will have 3 only. 1 existing and 2 new."
//
// The three entries a Vietnamese cancellation dropdown offers are the two CATEGORIES themselves
// plus the tenant's existing "Cancelled by Developer" row. The categories are synthesized by this
// app, NOT seeded as cancellation_reasons rows: that table is global to a deployment (id, name,
// short_name, description - no company and no country column), so a row added for Vietnam would
// appear in every Malaysian tenant's Settings > Cancellation Reasons screen, and a row inserted by
// a migration would also skip the Credit Control mirror that only the API's create path writes.
//
// A synthesized option carries its category in its own value, so picking one sets
// sr_cancellation_type directly instead of matching words in a name.
var CATEGORY_OPTION_PREFIX = 'category:';

var cancellationCategoryOptionValue = exports.cancellationCategoryOptionValue = function cancellationCategoryOptionValue(category) {
  return '' + CATEGORY_OPTION_PREFIX + category;
};

var isCategoryOption = function isCategoryOption(choice) {
  return typeof choice === 'string' && choice.indexOf(CATEGORY_OPTION_PREFIX) === 0;
};

// The category a dropdown choice means: read off a synthesized option, or looked up from the name
// of a master-list row. '' when neither, so the caller leaves the category as it was.
var cancellationCategoryForChoice = exports.cancellationCategoryForChoice = function cancellationCategoryForChoice(reasons, choice) {
  return isCategoryOption(choice) ? choice.slice(CATEGORY_OPTION_PREFIX.length) : cancellationCategoryForReasonID(reasons, choice);
};

// The master-list row a dropdown choice refers to, if any. A synthesized option refers to none, so
// nothing is sent as the reason id for it.
var cancellationReasonIDForChoice = exports.cancellationReasonIDForChoice = function cancellationReasonIDForChoice(choice) {
  return isCategoryOption(choice) ? '' : choice;
};

// Which rows of the master list the dropdown may offer. Vietnam no longer offers the legacy
// "Cancelled by Developer" row in the booking cancellation modal. The two synthesized category
// choices remain available, and the master-list rows are not used for Vietnam at all.
//
// "Change of Unit" is folded into "Cancellation due to Buyer"; its buyer mapping above stays,
// because a booking cancelled before this change still carries that reason.
//
// Outside Vietnam this is the identity, so Malaysia offers the list it always offered.
var visibleCancellationReasons = exports.visibleCancellationReasons = function visibleCancellationReasons(auth, reasons) {
  var list = [].concat(reasons || []).filter(function (reason) {
    return reason && reason.id;
  });
  if (!(0, _vietnam.isVietnamCompany)(auth)) {
    return list;
  }
  return [];
};

/***/ }),
/* 2575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// CPI-1284: book-api's storey-plan sales chart takes `?language=EN|VN` and opens in that language.
// Map this app's i18n code onto it: every Vietnamese code (`vi`, `vi-VN`, `vi_VN`) is VN, anything
// else - English, Bahasa Indonesia, unset - is EN, the chart's own default.
var chartLanguage = exports.chartLanguage = function chartLanguage(lng) {
  return String(lng || '').trim().toLowerCase().startsWith('vi') ? 'VN' : 'EN';
};

exports.default = chartLanguage;

/***/ }),
/* 2576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.dataURLToBlob = dataURLToBlob;
exports.compress = compress;
function dataURLToBlob(dataURL) {
  var BASE64_MARKER = ';base64,';
  if (dataURL.indexOf(BASE64_MARKER) === -1) {
    var _parts = dataURL.split(',');
    var _contentType = _parts[0].split(':')[1];
    var _raw = decodeURIComponent(_parts[1]);

    return new Blob([_raw], { type: _contentType });
  }
  var parts = dataURL.split(BASE64_MARKER);
  var contentType = parts[0].split(':')[1];
  var raw = window.atob(parts[1]);
  var rawLength = raw.length;
  var uInt8Array = new Uint8Array(rawLength);
  uInt8Array.forEach(function (item, key) {
    uInt8Array[key] = raw.charCodeAt(key);
  });
  return new Blob([uInt8Array], { type: contentType });
}

function compress(target) {
  return new Promise(function (res) {
    var reader = new FileReader();
    reader.readAsDataURL(target);
    reader.onloadend = function (file) {
      var image = new Image();
      image.src = file.target.result;
      image.onload = function () {
        var canvas = document.createElement('canvas');

        var width = image.width;
        var height = image.height;
        var maxWidth = 800;
        var maxHeight = 800;

        // calculate the width and height, constraining the proportions
        if (width > height) {
          if (width > maxWidth) {
            height = Math.round(height *= maxWidth / width);
            width = maxWidth;
          }
        } else if (height > maxHeight) {
          width = Math.round(width *= maxHeight / height);
          height = maxHeight;
        }

        // resize the canvas and draw the image data into it
        canvas.width = width;
        canvas.height = height;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(image, 0, 0, width, height);
        // quality = 0.6 - 0.7 (recomended), Max = 1.0 (not recomended)
        res(dataURLToBlob(canvas.toDataURL('image/jpeg', 0.6)));
      };
    };
  });
}

/***/ }),
/* 2577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// The booking API reads the portion before the first slash as the S3 bucket.
// CRM media stores bucket and key separately; older references may already be qualified.
var crmIdentityMediaReference = exports.crmIdentityMediaReference = function crmIdentityMediaReference(media) {
  if (!media || !media.key) return '';
  if (!media.bucket || media.key.startsWith(media.bucket + '/')) return media.key;
  return media.bucket + '/' + media.key.replace(/^\/+/, '');
};

/***/ }),
/* 2578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ExtendableError = exports.ExtendableError = function (_Error) {
  _inherits(ExtendableError, _Error);

  function ExtendableError(message) {
    _classCallCheck(this, ExtendableError);

    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    _this.name = _this.constructor.name;
    _this.message = message;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(_this, _this.constructor);
    } else {
      _this.stack = new Error(message).stack;
    }
    return _this;
  }

  return ExtendableError;
}(Error);

var FetchError = exports.FetchError = function (_ExtendableError) {
  _inherits(FetchError, _ExtendableError);

  function FetchError(message, res) {
    _classCallCheck(this, FetchError);

    var _this2 = _possibleConstructorReturn(this, (FetchError.__proto__ || Object.getPrototypeOf(FetchError)).call(this, message));

    _this2.res = res;
    return _this2;
  }

  return FetchError;
}(ExtendableError);

/***/ }),
/* 2579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.foreignPurchaseThresholdSubmission = exports.foreignPurchaseThresholdOrDefault = exports.validateForeignPurchaseThreshold = exports.isValidForeignPurchaseThreshold = exports.parseForeignPurchaseThreshold = exports.showsForeignPurchaseThreshold = exports.FOREIGN_PURCHASE_THRESHOLD_DEFAULT = exports.FOREIGN_PURCHASE_THRESHOLD_MAX = exports.FOREIGN_PURCHASE_THRESHOLD_MIN = undefined;

var _webValidations = __webpack_require__(23);

var _vietnam = __webpack_require__(40);

// CPI-1220 stores the VN project threshold; booking enforcement belongs to CPI-1248.
var FOREIGN_PURCHASE_THRESHOLD_MIN = exports.FOREIGN_PURCHASE_THRESHOLD_MIN = 0;
var FOREIGN_PURCHASE_THRESHOLD_MAX = exports.FOREIGN_PURCHASE_THRESHOLD_MAX = 100;
var FOREIGN_PURCHASE_THRESHOLD_DEFAULT = exports.FOREIGN_PURCHASE_THRESHOLD_DEFAULT = 0;

var showsForeignPurchaseThreshold = exports.showsForeignPurchaseThreshold = function showsForeignPurchaseThreshold(auth) {
  return (0, _vietnam.isVietnamCompany)(auth);
};

// Match the whole input so invalid text is never partially parsed.
var RX_THRESHOLD = /^(\d+\.?\d*|\.\d+)$/;

var parseForeignPurchaseThreshold = exports.parseForeignPurchaseThreshold = function parseForeignPurchaseThreshold(value) {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }
  if (typeof value !== 'string') {
    return null;
  }
  var trimmed = value.trim();
  if (!RX_THRESHOLD.test(trimmed)) {
    return null;
  }
  var parsed = Number(trimmed);
  return Number.isFinite(parsed) ? parsed : null;
};

var isValidForeignPurchaseThreshold = exports.isValidForeignPurchaseThreshold = function isValidForeignPurchaseThreshold(value) {
  var parsed = parseForeignPurchaseThreshold(value);
  return parsed !== null && parsed >= FOREIGN_PURCHASE_THRESHOLD_MIN && parsed <= FOREIGN_PURCHASE_THRESHOLD_MAX;
};

var validateForeignPurchaseThreshold = exports.validateForeignPurchaseThreshold = function validateForeignPurchaseThreshold(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var key = options.key || 'foreignPurchaseThreshold';
  var validity = (0, _webValidations.createValidity)(key);
  if (isValidForeignPurchaseThreshold(value)) {
    return validity;
  }
  var label = options.label || 'Threshold %';
  validity.isValid = false;
  validity.message = options.message || label + ' must be a number from ' + FOREIGN_PURCHASE_THRESHOLD_MIN + ' to ' + FOREIGN_PURCHASE_THRESHOLD_MAX;
  return validity;
};

var foreignPurchaseThresholdOrDefault = exports.foreignPurchaseThresholdOrDefault = function foreignPurchaseThresholdOrDefault(value) {
  return value === undefined || value === null ? FOREIGN_PURCHASE_THRESHOLD_DEFAULT : value;
};

// A rejected save must leave the input unchanged, including an empty value.
var foreignPurchaseThresholdSubmission = exports.foreignPurchaseThresholdSubmission = function foreignPurchaseThresholdSubmission(auth, value) {
  if (!showsForeignPurchaseThreshold(auth)) {
    return { omit: true };
  }
  if (!isValidForeignPurchaseThreshold(value)) {
    return { block: true };
  }
  return { value: parseForeignPurchaseThreshold(value) };
};

/***/ }),
/* 2580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gaClickEventAction = gaClickEventAction;
exports.gaClickEventLabel = gaClickEventLabel;
/* eslint-disable max-len */
function replaceAll(data, search, replacement) {
  var target = data;
  return target.replace(new RegExp(search, 'g'), replacement);
}
function trimChars(data, c) {
  var re = new RegExp('^[' + c + ']+|[' + c + ']+$', 'g');
  return data.replace(re, '');
}
function formatText(text) {
  return replaceAll(text.trim().toUpperCase(), ' ', '_');
}
function formatLocation(location) {
  var path = '';
  if (location && location.pathname) {
    var locations = location.pathname.split('/');
    if (locations.length > 1) path = locations[1].toUpperCase();
  }
  if (path) return path + '_';
  return '';
}
function getActionText(e) {
  var text = '';
  var regexAlphaNumeric = /^[a-zA-Z0-9 ]*$/;
  if (e.target.innerText) {
    if (regexAlphaNumeric.test(e.target.innerText)) return trimChars('_' + e.target.innerText, '_');
  }
  if (e.target && e.target.firstChild && e.target.firstChild.classList && e.target.firstChild.classList.value) text += '_' + e.target.firstChild.classList.value;
  if (e.target && e.target.classList && e.target.classList.value) text += '_' + e.target.classList.value;
  return trimChars(text, '_');
}
function getParentActionText(e) {
  var text = '';
  var regexAlphaNumeric = /^[a-zA-Z0-9 ]*$/;
  if (e.target.parentElement && e.target.parentElement.innerText) {
    if (regexAlphaNumeric.test(e.target.parentElement.innerText)) return trimChars('_' + e.target.parentElement.innerText, '_');
  }
  if (e.target && e.target.classList && e.target.classList.value) text += '_' + e.target.classList.value;
  if (e.target && e.target.parentElement && e.target.parentElement.classList && e.target.parentElement.classList.value) text += '_' + e.target.parentElement.classList.value;
  return trimChars(text, '_');
}
function createEventAction(e) {
  var classValue = '';
  var parentClassValue = '';
  if (e.target && e.target.classList && e.target.classList.value) classValue = e.target.classList.value;
  if (e.target && e.target.parentElement && e.target.parentElement.classList && e.target.parentElement.classList.value) parentClassValue = e.target.parentElement.classList.value;
  // booking & unit tab status
  if (parentClassValue && parentClassValue.includes('tab-status')) {
    return 'TAB_STATUS_' + formatText(parentClassValue.replace('tab-status', '').replace('center', '').replace('aligned', '').replace('column', '').replace('selected', ''));
  }
  if (classValue && classValue.includes('tab-status')) {
    return 'TAB_STATUS_' + formatText(classValue.replace('tab-status', '').replace('center', '').replace('aligned', '').replace('column', '').replace('selected', ''));
  }
  // a link
  if (e.target.tagName === 'A' && !(parentClassValue && parentClassValue.includes('button')) && !(classValue && (classValue.includes('button') || classValue.includes('top-menu') && classValue.includes('item')))) {
    if (getActionText(event)) return 'A_' + formatText(getActionText(event));
  }
  // icon
  if (e.target.tagName === 'I' && classValue.includes('icon') && !(parentClassValue && parentClassValue.includes('button'))) {
    if (formatText(classValue)) return 'ICON_' + formatText(classValue);
  }
  // input
  if (e.target.tagName.includes('INPUT') && e.target.placeholder) {
    if (formatText(e.target.placeholder)) return 'INPUT_' + formatText(e.target.placeholder);
  }
  // label
  if (e.target.tagName.includes('LABEL') && e.target.innerText) {
    if (parentClassValue && parentClassValue.includes('checkbox') && formatText(e.target.innerText)) return 'CHECKBOX_' + formatText(e.target.innerText);
    if (formatText(e.target.innerText)) return 'LABEL_' + formatText(e.target.innerText);
  }
  // dropdown
  if (parentClassValue && parentClassValue.includes('dropdown')) {
    if (getParentActionText(event)) return 'DROPDOWN_' + formatText(getParentActionText(event));
  }
  if (classValue && (classValue.includes('dropdown') || classValue.includes('item') && !classValue.includes('top-menu') && parentClassValue && parentClassValue.includes('dropdown'))) {
    if (getActionText(event)) return 'DROPDOWN_' + formatText(getActionText(event));
  }
  // item
  if (parentClassValue && parentClassValue.includes('item')) {
    if (getParentActionText(event)) return 'ITEM_' + formatText(getParentActionText(event));
  }
  if (classValue && (classValue.includes('dropdown') || classValue.includes('item') && !classValue.includes('top-menu'))) {
    if (getActionText(event)) return 'DROPDOWN_' + formatText(getActionText(event));
  }
  // image
  if (parentClassValue && parentClassValue.includes('image')) {
    if (getParentActionText(event)) return 'IMAGE_' + formatText(getParentActionText(event));
  }
  if (classValue && classValue.includes('image')) {
    if (getActionText(event)) return 'IMAGE_' + formatText(getActionText(event));
  }
  if (e.target.tagName.includes('IMG')) {
    if (getActionText(event)) return 'IMAGE_' + formatText(getActionText(event));
  }
  // button
  if (parentClassValue && parentClassValue.includes('button')) {
    if (getParentActionText(event)) return 'BUTTON_' + formatText(getParentActionText(event));
  }
  if (classValue && classValue.includes('button')) {
    if (getActionText(event)) return 'BUTTON_' + formatText(getActionText(event));
  }
  if (e.target.tagName.includes('BUTTON')) {
    if (getActionText(event)) return 'BUTTON_' + formatText(getActionText(event));
  }
  return '';
}
function gaClickEventAction(e) {
  if (createEventAction(e)) return formatLocation(window.location) + createEventAction(e);
  return null;
}
function gaClickEventLabel(e) {
  return '_X' + e.screenX + 'Y' + e.screenY + 'W' + window.screen.width + 'H' + window.screen.height;
}

/***/ }),
/* 2581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _marked = __webpack_require__(678);

var mMarked = new _marked.Marked(); /* eslint-disable import/extensions */


var renderer = new mMarked.Renderer();
renderer.paragraph = function (text) {
  var newText = text;

  var regexB = /\*\*(.*?)\*\*/g;
  newText = newText.replace(regexB, '<strong>$1</strong>');

  var regexI = /_(.*?)_/g;
  newText = newText.replace(regexI, '<em>$1</em>');

  var regexU = /\+\+(.*?)\+\+/g;
  newText = newText.replace(regexU, '<ins>$1</ins>');

  var regexS = /~~(.*?)~~/g;
  newText = newText.replace(regexS, '<del>$1</del>');

  return newText;
};
renderer.link = function (href, title, text) {
  return text;
};

mMarked.use({
  breaks: true,
  gfm: true,
  sanitize: true,
  smartypants: true,
  renderer: renderer
});

exports.default = mMarked;

/***/ }),
/* 2582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BIG_HEADER_LINE_BYTES = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; // MS-6583: name the request, and the page state that explains it, when a fetch dies at the
// network layer.
//
// A network-level rejection ("Failed to fetch") carries no URL and no cause, and the vendored
// Bugsnag v3.0.6 records no network breadcrumbs — so the one event bugsnagNetworkNoise lets
// through per window used to say nothing actionable. fetchM attaches this object to every
// fetch() rejection as `error.mhubNetwork`; the noise filter merges it into the event's
// `network` tab. Every field is best-effort (a diagnostics failure must never turn one error
// into two) and SIZES ONLY — never a header or cookie value.


exports.describeNetworkFailure = describeNetworkFailure;
exports.attachNetworkDiagnostics = attachNetworkDiagnostics;

var _bugsnagNetworkNoise = __webpack_require__(1086);

// nginx's large_client_header_buffers default. The API proxy tier answers any header line at
// or above this with a CORS-less 400, which the browser reports as exactly this error (DV-880).
var BIG_HEADER_LINE_BYTES = exports.BIG_HEADER_LINE_BYTES = 8 * 1024;

// Resource Timing start times and performance.now() come from the same clock, but a failed
// request's entry can be stamped a hair before the caller's own reading.
var START_TOLERANCE_MS = 5;

function navigationEntry(perf) {
  try {
    if (!perf || typeof perf.getEntriesByType !== 'function') return null;
    var entries = perf.getEntriesByType('navigation');
    return entries && entries[0] ? entries[0] : null;
  } catch (e) {
    return null;
  }
}

function stripQuery(url) {
  return String(url || '').replace(/[?#].*$/, '');
}

function safeNumber(fn) {
  try {
    var v = fn();
    return typeof v === 'number' && !Number.isNaN(v) ? Math.round(v) : null;
  } catch (e) {
    return null;
  }
}

// Did THIS attempt leave the page? Resource Timing keeps an entry per request the browser
// actually issued (current Chrome records failed ones too, zero-sized). Entries are keyed by
// URL, and the boot fan-out and list screens re-request the same URLs, so an entry only counts
// when it started after this attempt did. Without a start time an older entry cannot be told
// apart from this one: unknown (null), never a false "sent".
function attemptWasSent(perf, url, startedAt) {
  try {
    if (!perf || typeof perf.getEntriesByName !== 'function') return null;
    var entries = perf.getEntriesByName(String(url || '')) || [];
    if (typeof startedAt === 'number') {
      return entries.some(function (e) {
        return e && typeof e.startTime === 'number' && e.startTime >= startedAt - START_TOLERANCE_MS;
      });
    }
    return entries.length > 0 ? null : false;
  } catch (e) {
    return null;
  }
}

function describeNetworkFailure(request, win) {
  var w = win || (typeof window !== 'undefined' ? window : {});
  var doc = w.document || {};
  var nav = w.navigator || {};
  var perf = w.performance;
  var req = request || {};
  var tokenHeaderBytes = typeof req.tokenHeaderBytes === 'number' ? req.tokenHeaderBytes : 0;
  var cookieBytes = null;
  try {
    cookieBytes = typeof doc.cookie === 'string' ? doc.cookie.length : null;
  } catch (e) {
    cookieBytes = null;
  }
  var navEntry = navigationEntry(perf);
  return {
    url: stripQuery(req.url),
    method: String(req.method || 'GET').toUpperCase(),
    retry: !!req.retry,
    // Decided from the rejection's ORIGINAL message, before any catch rewrites it: fetch()
    // also rejects for invalid request options or an abort, and those are real errors that
    // must keep reaching Bugsnag untouched. This flag is what the noise filter keys on.
    networkFailure: (0, _bugsnagNetworkNoise.isNetworkFailureMessage)(req.message),
    msSincePageStart: safeNumber(function () {
      return perf.now();
    }),
    readyState: doc.readyState || null,
    // At failure time; the noise filter records the same two at notify time, and a page that
    // went hidden in between is itself a clue.
    visibilityAtFailure: doc.visibilityState || null,
    onlineAtFailure: typeof nav.onLine === 'boolean' ? nav.onLine : null,
    // Chrome boots a prerendered page in the background before the user commits to it and
    // discards it — killing its in-flight fetches — if they never do. `prerendering` is true
    // while that lasts; a non-zero activationStart says the page WAS prerendered.
    prerendering: typeof doc.prerendering === 'boolean' ? doc.prerendering : null,
    activationStart: safeNumber(function () {
      return navEntry.activationStart;
    }),
    wasSent: attemptWasSent(perf, req.url, req.startedAt),
    tokenHeaderBytes: tokenHeaderBytes,
    cookieBytes: cookieBytes,
    bigHeaderLine: Math.max(tokenHeaderBytes, cookieBytes || 0) >= BIG_HEADER_LINE_BYTES
  };
}

function attachNetworkDiagnostics(error, request, win) {
  if (!error || (typeof error === 'undefined' ? 'undefined' : _typeof(error)) !== 'object') return error;
  try {
    Object.assign(error, { mhubNetwork: describeNetworkFailure(request, win) });
  } catch (e) {
    // diagnostics are a passenger on the real error, never a second failure
  }
  return error;
}

/***/ }),
/* 2583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var calculatePricePerSqm = exports.calculatePricePerSqm = function calculatePricePerSqm(spaAmount, project, unit) {
  var pricePerSqm = 0;

  if (unit && unit.size > 0) {
    var sizeSqm = unit.size;
    if (project && project.sizeSuffix === 'square_feet') {
      sizeSqm = sizeSqm / 10.764;
    }
    pricePerSqm = (spaAmount / sizeSqm).toFixed(2);
  }

  return parseFloat(pricePerSqm);
};

/***/ }),
/* 2584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.widgetLanguage = widgetLanguage;
exports.mountQHelpWidget = mountQHelpWidget;
exports.setQHelpWidgetLanguage = setQHelpWidgetLanguage;

var _auth = __webpack_require__(70);

var _auth2 = _interopRequireDefault(_auth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // Q Help: the one in-app support widget every MHub product loads (mhub-web-turborepo,
// apps/mhub-q-help-widget). It shows Q's in-app chat. Bitrix24 is cancelled (26 October 2026)
// and there is no form fallback: a customer Q doesn't admit, or can't reach, gets the widget's
// contact card (WhatsApp, phone, email) — so Showroom no longer mounts a Bitrix form of its own.
// The widget is a prebuilt script with its own UI in a shadow root; the app only adds the tag,
// once per page, and keeps data-lang in step with its own language.

// The marker @mhub/q-help (the monorepo apps' injector) uses too, so a page never gets two tags.
var SCRIPT_ATTR = 'data-mhub-q-help-loader';
var PROJECT = 'showroom';

// Showroom's languages (src/constants/languages.js) as the widget's regional codes. The widget
// also speaks ms-MY, which Showroom does not offer.
var WIDGET_LANGUAGES = {
  en: 'en-GB',
  id: 'id-ID',
  vi: 'vi-VN'
};

// The widget code for the language the app is showing. Anything Showroom has no locale for is
// shown in English (i18n fallbackLng), so the widget follows suit. Before i18next has settled on
// a language there is nothing to pass: the widget then reads the shared cookie, then the browser,
// until the first languageChanged sets the attribute.
function widgetLanguage(language) {
  if (typeof language !== 'string' || !language) return null;
  var code = language.toLowerCase().split(/[-_]/)[0];
  return WIDGET_LANGUAGES[code] || WIDGET_LANGUAGES.en;
}

// The widget reads the session from the shared Cognito cookies. It asks the app for a fresh id
// token, once, on open or send (never while idle), when the one there is within 30 s of expiry or
// Q refused it, so the refresh is forced: currentSession() would hand back a token it still
// calls valid. refreshSession() renews it with the refresh token and writes the new cookies on
// the shared domain, as currentSession() does for every API call (fetchM). Signed out, or a
// devstack persona: it rejects, and the widget asks to refresh the page or sign in. Sign in
// reloads, so Showroom's own 401 handling sends the user to log in (ADFS included) and back.
var qHelpIdToken = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var user, signedIn, session;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return _auth2.default.currentAuthenticatedUser();

          case 2:
            user = _context.sent;
            signedIn = user && typeof user.getSignInUserSession === 'function' ? user.getSignInUserSession() : null;

            if (!(!signedIn || typeof user.refreshSession !== 'function')) {
              _context.next = 8;
              break;
            }

            _context.next = 7;
            return _auth2.default.currentSession();

          case 7:
            return _context.abrupt('return', _context.sent.getIdToken().getJwtToken());

          case 8:
            _context.next = 10;
            return new Promise(function (resolve, reject) {
              user.refreshSession(signedIn.getRefreshToken(), function (error, fresh) {
                return error ? reject(error) : resolve(fresh);
              });
            });

          case 10:
            session = _context.sent;
            return _context.abrupt('return', session.getIdToken().getJwtToken());

          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function qHelpIdToken() {
    return _ref.apply(this, arguments);
  };
}();

// Set before the tag goes in, so the widget finds it when it boots; kept on an object the widget
// already made (Root remounting under hot reload).
function setTokenProvider() {
  var help = window.MHubQHelp || {};
  help.tokenProvider = qHelpIdToken;
  window.MHubQHelp = help;
}

function findScript(doc) {
  return doc.querySelector('script[' + SCRIPT_ATTR + ']');
}

// Adds the widget's script tag once. A second call (Root remounting under hot reload) returns
// the tag already on the page. No URL configured for this environment: no tag at all.
function mountQHelpWidget(_ref2) {
  var src = _ref2.src,
      language = _ref2.language,
      version = _ref2.version;
  var doc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

  if (!src) return null;
  setTokenProvider();
  var existing = findScript(doc);
  if (existing) return existing;
  var script = doc.createElement('script');
  script.src = src;
  script.defer = true;
  script.setAttribute(SCRIPT_ATTR, '');
  script.setAttribute('data-project', PROJECT);
  var lang = widgetLanguage(language);
  if (lang) script.setAttribute('data-lang', lang);
  if (version) script.setAttribute('data-version', version);
  doc.head.appendChild(script);
  return script;
}

// Follows the app's language. The widget reads data-lang when it boots and watches the attribute
// afterwards, so updating the tag is enough whether or not it has loaded yet.
function setQHelpWidgetLanguage(language) {
  var doc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

  var script = findScript(doc);
  var lang = widgetLanguage(language);
  if (script && lang && script.getAttribute('data-lang') !== lang) {
    script.setAttribute('data-lang', lang);
  }
}

/***/ }),
/* 2585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * Load scripts `<script src="/path/to.js"></script>` into DOM.
 * Avoids duplicate script paths.
*/
var loadScript = exports.loadScript = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'text/javascript';
    var script;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            script = getScript(url);

            if (!script) {
              _context.next = 3;
              break;
            }

            return _context.abrupt('return', script);

          case 3:
            if (!document.querySelector('script[src="' + url + '"]')) {
              _context.next = 5;
              break;
            }

            return _context.abrupt('return', setScript(url, {
              loading: false,
              loaded: true
            }));

          case 5:

            setScript(url, {
              loading: true,
              loaded: false
            });

            _context.next = 8;
            return load(url, type);

          case 8:
            return _context.abrupt('return', setScript(url, {
              loading: false,
              loaded: true
            }));

          case 9:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  return function loadScript(_x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Load scripts `<script src="/path/to.js"></script>` into DOM.
 * Keep trying `loadScript` until a script is successfully loaded into DOM.
*/


var loadComplete = exports.loadComplete = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(url) {
    var _this = this;

    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'text/javascript';
    var s;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return loadScript(url, type);

          case 2:
            s = _context3.sent;

            if (!(s && s.loaded)) {
              _context3.next = 5;
              break;
            }

            return _context3.abrupt('return', s);

          case 5:
            _context3.next = 7;
            return new Promise(function (res, rej) {
              var count = 0;
              var t = setInterval(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                var ss;
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (!(count >= 100)) {
                          _context2.next = 4;
                          break;
                        }

                        clearInterval(t);
                        rej(new Error('Script load limit exceeded'));
                        return _context2.abrupt('return');

                      case 4:
                        _context2.next = 6;
                        return loadScript(url, type);

                      case 6:
                        ss = _context2.sent;

                        if (ss && ss.loaded) {
                          clearInterval(t);
                          res(ss);
                        }
                        count += 1;

                      case 9:
                      case 'end':
                        return _context2.stop();
                    }
                  }
                }, _callee2, _this);
              })), 100);
            });

          case 7:
            return _context3.abrupt('return', _context3.sent);

          case 8:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, this);
  }));

  return function loadComplete(_x4) {
    return _ref2.apply(this, arguments);
  };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var scripts = {};

function getScript(url) {
  return scripts[url];
}

function setScript(url) {
  var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  scripts[url] = _extends({ url: url }, status);
  return getScript(url);
}

function load(url, type) {
  return new Promise(function (res) {
    var s = document.createElement('script');
    s.onload = function () {
      res();
    };
    s.type = type;
    s.src = url;
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(s);
  });
}

/***/ }),
/* 2586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkSessionOnce = exports.SESSION_CHECK_TIMEOUT_MS = exports.SESSION_CHECK_INTERVAL_MS = undefined;

// One check against book-api's middleware-served endpoint. Acts ONLY on the definitive contract
// pair (401 + body match); network errors, timeouts and 5xx are ambient failures — treating them
// as takeover fabricates a "someone signed in on another device" explanation (the CRM lesson).
var checkSessionOnce = exports.checkSessionOnce = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        fetcher = _ref2.fetcher,
        onSessionLost = _ref2.onSessionLost;

    var base, doFetch, Aborter, controller, deadline, res, body;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            base = _config2.default.get('bookApiURL');

            if (base) {
              _context.next = 3;
              break;
            }

            return _context.abrupt('return');

          case 3:
            doFetch = fetcher || function (url, opts) {
              return fetch(url, opts);
            };

            Aborter = typeof window !== 'undefined' ? window.AbortController : undefined;
            controller = Aborter ? new Aborter() : null;
            deadline = controller ? setTimeout(function () {
              return controller.abort();
            }, SESSION_CHECK_TIMEOUT_MS) : null;
            res = void 0;
            _context.prev = 8;
            _context.next = 11;
            return doFetch(base + '/session/check/', {
              credentials: 'include',
              signal: controller ? controller.signal : undefined
            });

          case 11:
            res = _context.sent;
            _context.next = 17;
            break;

          case 14:
            _context.prev = 14;
            _context.t0 = _context['catch'](8);
            return _context.abrupt('return');

          case 17:
            _context.prev = 17;

            if (deadline) {
              clearTimeout(deadline);
            }
            return _context.finish(17);

          case 20:
            if (!(res.status !== 401)) {
              _context.next = 22;
              break;
            }

            return _context.abrupt('return');

          case 22:
            body = '';
            _context.prev = 23;
            _context.next = 26;
            return res.text();

          case 26:
            body = _context.sent;
            _context.next = 32;
            break;

          case 29:
            _context.prev = 29;
            _context.t1 = _context['catch'](23);
            return _context.abrupt('return');

          case 32:
            if ((0, _session.isSessionSuperseded)(res.status, body)) {
              (onSessionLost || _session.handleSessionLost)();
            }

          case 33:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this, [[8, 14, 17, 20], [23, 29]]);
  }));

  return function checkSessionOnce() {
    return _ref.apply(this, arguments);
  };
}();

// Mounted once for the app's lifetime (Root.jsx). Ticks on the interval and on tab refocus;
// skips hidden tabs (browsers throttle their timers anyway) and unauthenticated states.
// Returns the stop function.


exports.startSessionWatch = startSessionWatch;

var _config = __webpack_require__(10);

var _config2 = _interopRequireDefault(_config);

var _session = __webpack_require__(404);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } // MS-6466: the 60-second session watch. Without it, a superseded browser only learns of the
// takeover when the user next touches the API; with it, the zombie window is bounded at one
// interval — and at ~zero on tab refocus, which is exactly when a takeover should surface.
//
// Endpoint choice is DECIDED (MS-6466): Showroom polls book-api's own same-origin
// /session/check/ (its own service, no extra CORS surface), which book-api answers by asking
// user-api's /usersession/ping — the ONE verdict source both products share. book-api asks the
// ping rather than reading a table because Showroom is single-tenanted (a direct central-table
// read would need cross-account IAM per tenant). Deliberately thin regardless: if the shared
// session client (/_session/v1.js) ever ships, this file and book-api's branch retire together.


var SESSION_CHECK_INTERVAL_MS = exports.SESSION_CHECK_INTERVAL_MS = 60000;

// Each check must finish (or die) well inside one interval: fetch has no built-in timeout, and
// an app-lifetime watcher stacking hung requests against a stalled endpoint is a slow leak.
var SESSION_CHECK_TIMEOUT_MS = exports.SESSION_CHECK_TIMEOUT_MS = 15000;

// Playwright shortens the interval via addInitScript; a build-time env can't vary per test and
// would need its own webpack DefinePlugin entry in every config.
function intervalMs() {
  // eslint-disable-next-line no-underscore-dangle
  var override = typeof window !== 'undefined' && window.__MHUB_SESSION_CHECK_INTERVAL_MS__;
  return Number(override) > 0 ? Number(override) : SESSION_CHECK_INTERVAL_MS;
}function startSessionWatch() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      isAuthenticated = _ref3.isAuthenticated,
      fetcher = _ref3.fetcher,
      onSessionLost = _ref3.onSessionLost,
      doc = _ref3.doc,
      win = _ref3.win;

  var d = doc || document;
  var w = win || window;
  // One check at a time: a hung request must not stack another on the next tick — the abort
  // deadline bounds how long this gate can stay closed.
  var inFlight = false;
  var tick = function tick() {
    if (inFlight) {
      return;
    }
    if (d.visibilityState === 'hidden') {
      return;
    }
    if (isAuthenticated && !isAuthenticated()) {
      return;
    }
    inFlight = true;
    checkSessionOnce({ fetcher: fetcher, onSessionLost: onSessionLost }).finally(function () {
      inFlight = false;
    });
  };
  var onVisibility = function onVisibility() {
    if (d.visibilityState === 'visible') {
      tick();
    }
  };
  var timer = w.setInterval(tick, intervalMs());
  d.addEventListener('visibilitychange', onVisibility, false);
  return function stopSessionWatch() {
    w.clearInterval(timer);
    d.removeEventListener('visibilitychange', onVisibility, false);
  };
}

/***/ }),
/* 2587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var SHARED_MEDIA_PARENT_OPPORTUNITY = exports.SHARED_MEDIA_PARENT_OPPORTUNITY = 'opportunity';
var SHARED_MEDIA_PARENT_BOOKING = exports.SHARED_MEDIA_PARENT_BOOKING = 'booking';

// resolveSharedMediaParent decides which entity a Vietnam sale's documents hang off: the CRM
// opportunity behind the booking (CPI-1249 A20), or the booking itself when there is none (A21).
// parentID comes back empty when neither id is known - callers MUST then refuse to call
// GET /shared_medias/, because a blank parent_id returns every active row in the database.
var resolveSharedMediaParent = exports.resolveSharedMediaParent = function resolveSharedMediaParent(booking, bookingID) {
  var leadOpportunityID = booking && booking.leadOpportunityID;

  if (leadOpportunityID) {
    return {
      parentType: SHARED_MEDIA_PARENT_OPPORTUNITY,
      parentID: leadOpportunityID
    };
  }

  return {
    parentType: SHARED_MEDIA_PARENT_BOOKING,
    parentID: bookingID || booking && booking.id || ''
  };
};

exports.default = resolveSharedMediaParent;

/***/ }),
/* 2588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateSRBExpiry = exports.srbExpirySubmission = exports.validSRBExpiry = exports.currentSRBExpiry = exports.initialSRBExpiry = undefined;

var _webValidations = __webpack_require__(23);

// Saved projects keep their duration; new projects preview the launch-derived default.
var initialSRBExpiry = exports.initialSRBExpiry = function initialSRBExpiry(project) {
  if (project.id) return project.srbStoreyPlanExpiryMinutes;
  var n = typeof project.launchModeMinutes === 'string' ? Number(project.launchModeMinutes) : project.launchModeMinutes;
  return project.isLaunchMode && Number.isInteger(n) && n >= 1 ? Math.min(n, 30) : 10;
};
var currentSRBExpiry = exports.currentSRBExpiry = function currentSRBExpiry(project, edited) {
  return project.id || edited ? project.srbStoreyPlanExpiryMinutes : initialSRBExpiry(project);
};

var validSRBExpiry = exports.validSRBExpiry = function validSRBExpiry(value) {
  return (typeof value === 'number' || typeof value === 'string') && String(value).trim() !== '' && Number.isInteger(Number(value)) && Number(value) >= 1 && Number(value) <= 30;
};

var srbExpirySubmission = exports.srbExpirySubmission = function srbExpirySubmission(project, edited, canEdit) {
  if (!canEdit || !project.id && !edited) return { omit: true };
  if (!validSRBExpiry(project.srbStoreyPlanExpiryMinutes)) return { block: true };
  return { value: Number(project.srbStoreyPlanExpiryMinutes) };
};

var validateSRBExpiry = exports.validateSRBExpiry = function validateSRBExpiry(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var validity = (0, _webValidations.createValidity)(options.key || 'srbStoreyPlanExpiryMinutes');
  if (!validSRBExpiry(value)) {
    validity.isValid = false;validity.message = options.message || 'Enter a whole number from 1 to 30 minutes.';
  }
  return validity;
};

/***/ }),
/* 2589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

/**
 * mhub-api tags `User.Groups` as `json:"groups,omitempty"`, so a staff whose
 * user holds no group at all comes back from `/staffs/` with no `groups` key —
 * not an empty array. The staff screens all treat it as an array, so without
 * this the Access Role dropdown (and the Update button itself) throws on the
 * users who most need a role, and the change is silently dropped. MS-6597.
 *
 * Returns the staff unchanged unless it is missing `user.groups`, in which case
 * a shallow copy carrying an empty array is returned.
 */
// eslint-disable-next-line import/prefer-default-export
var withUserGroups = exports.withUserGroups = function withUserGroups(staff) {
  if (!staff || !staff.user || staff.user.groups) {
    return staff;
  }
  return _extends({}, staff, { user: _extends({}, staff.user, { groups: [] }) });
};

/***/ }),
/* 2590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRemainingTimeSimple = getRemainingTimeSimple;
exports.getProgressPercent = getProgressPercent;

var _moment = __webpack_require__(12);

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getRemainingTimeSimple(endDate) {
  var start = (0, _moment2.default)(); // ⏱ now
  var end = (0, _moment2.default)(endDate);

  var durationMs = Math.max(end.diff(start), 0);
  var duration = _moment2.default.duration(durationMs);

  var days = Math.floor(duration.asDays());
  var hours = duration.hours();
  var minutes = duration.minutes();
  var seconds = duration.seconds();

  var parts = [];
  if (days > 0) parts.push(days + 'd');
  if (hours > 0 || days > 0) parts.push(hours + 'h');
  if (minutes > 0 || hours > 0 || days > 0) parts.push(minutes + 'm');
  parts.push(seconds + 's');

  return parts.join(' ');
}

function getProgressPercent(createdAt, currentAt, endAt) {
  var now = (0, _moment2.default)(currentAt || Date.now());
  var start = (0, _moment2.default)(createdAt);
  var end = (0, _moment2.default)(endAt);

  if (!start.isValid() || !end.isValid()) return 0;

  var totalDuration = end.diff(start); // in ms
  var elapsed = now.diff(start); // in ms

  var percent = elapsed / totalDuration * 100;

  // Clamp between 0% and 100%
  if (percent < 0) percent = 0;
  if (percent > 100) percent = 100;

  return Math.round(percent); // Round to nearest %
}

/***/ }),
/* 2591 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2632), __esModule: true };

/***/ }),
/* 2592 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2633), __esModule: true };

/***/ }),
/* 2593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2635), __esModule: true };

/***/ }),
/* 2594 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2636), __esModule: true };

/***/ }),
/* 2595 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(2637), __esModule: true };

/***/ }),
/* 2596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(1097);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 2597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 2598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(
      uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)
    ))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),
/* 2599 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * Bowser - a browser detector
 * https://github.com/ded/bowser
 * MIT License | (c) Dustin Diaz 2015
 */

!function (root, name, definition) {
  if (typeof module != 'undefined' && module.exports) module.exports = definition()
  else if (true) __webpack_require__(3554)(name, definition)
  else root[name] = definition()
}(this, 'bowser', function () {
  /**
    * See useragents.js for examples of navigator.userAgent
    */

  var t = true

  function detect(ua) {

    function getFirstMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[1]) || '';
    }

    function getSecondMatch(regex) {
      var match = ua.match(regex);
      return (match && match.length > 1 && match[2]) || '';
    }

    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
      , likeAndroid = /like android/i.test(ua)
      , android = !likeAndroid && /android/i.test(ua)
      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
      , chromeos = /CrOS/.test(ua)
      , silk = /silk/i.test(ua)
      , sailfish = /sailfish/i.test(ua)
      , tizen = /tizen/i.test(ua)
      , webos = /(web|hpw)(o|0)s/i.test(ua)
      , windowsphone = /windows phone/i.test(ua)
      , samsungBrowser = /SamsungBrowser/i.test(ua)
      , windows = !windowsphone && /windows/i.test(ua)
      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
      , mobile = !tablet && /[^-]mobi/i.test(ua)
      , xbox = /xbox/i.test(ua)
      , result

    if (/opera/i.test(ua)) {
      //  an old Opera
      result = {
        name: 'Opera'
      , opera: t
      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
      }
    } else if (/opr\/|opios/i.test(ua)) {
      // a new Opera
      result = {
        name: 'Opera'
        , opera: t
        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/SamsungBrowser/i.test(ua)) {
      result = {
        name: 'Samsung Internet for Android'
        , samsungBrowser: t
        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/Whale/i.test(ua)) {
      result = {
        name: 'NAVER Whale browser'
        , whale: t
        , version: getFirstMatch(/(?:whale)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/MZBrowser/i.test(ua)) {
      result = {
        name: 'MZ Browser'
        , mzbrowser: t
        , version: getFirstMatch(/(?:MZBrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/coast/i.test(ua)) {
      result = {
        name: 'Opera Coast'
        , coast: t
        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/focus/i.test(ua)) {
      result = {
        name: 'Focus'
        , focus: t
        , version: getFirstMatch(/(?:focus)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/yabrowser/i.test(ua)) {
      result = {
        name: 'Yandex Browser'
      , yandexbrowser: t
      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
      }
    }
    else if (/ucbrowser/i.test(ua)) {
      result = {
          name: 'UC Browser'
        , ucbrowser: t
        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/mxios/i.test(ua)) {
      result = {
        name: 'Maxthon'
        , maxthon: t
        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/epiphany/i.test(ua)) {
      result = {
        name: 'Epiphany'
        , epiphany: t
        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/puffin/i.test(ua)) {
      result = {
        name: 'Puffin'
        , puffin: t
        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
      }
    }
    else if (/sleipnir/i.test(ua)) {
      result = {
        name: 'Sleipnir'
        , sleipnir: t
        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (/k-meleon/i.test(ua)) {
      result = {
        name: 'K-Meleon'
        , kMeleon: t
        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
      }
    }
    else if (windowsphone) {
      result = {
        name: 'Windows Phone'
      , osname: 'Windows Phone'
      , windowsphone: t
      }
      if (edgeVersion) {
        result.msedge = t
        result.version = edgeVersion
      }
      else {
        result.msie = t
        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/msie|trident/i.test(ua)) {
      result = {
        name: 'Internet Explorer'
      , msie: t
      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
      }
    } else if (chromeos) {
      result = {
        name: 'Chrome'
      , osname: 'Chrome OS'
      , chromeos: t
      , chromeBook: t
      , chrome: t
      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    } else if (/edg([ea]|ios)/i.test(ua)) {
      result = {
        name: 'Microsoft Edge'
      , msedge: t
      , version: edgeVersion
      }
    }
    else if (/vivaldi/i.test(ua)) {
      result = {
        name: 'Vivaldi'
        , vivaldi: t
        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (sailfish) {
      result = {
        name: 'Sailfish'
      , osname: 'Sailfish OS'
      , sailfish: t
      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/seamonkey\//i.test(ua)) {
      result = {
        name: 'SeaMonkey'
      , seamonkey: t
      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/firefox|iceweasel|fxios/i.test(ua)) {
      result = {
        name: 'Firefox'
      , firefox: t
      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
      }
      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
        result.firefoxos = t
        result.osname = 'Firefox OS'
      }
    }
    else if (silk) {
      result =  {
        name: 'Amazon Silk'
      , silk: t
      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/phantom/i.test(ua)) {
      result = {
        name: 'PhantomJS'
      , phantom: t
      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/slimerjs/i.test(ua)) {
      result = {
        name: 'SlimerJS'
        , slimer: t
        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
      }
    }
    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
      result = {
        name: 'BlackBerry'
      , osname: 'BlackBerry OS'
      , blackberry: t
      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
      }
    }
    else if (webos) {
      result = {
        name: 'WebOS'
      , osname: 'WebOS'
      , webos: t
      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
      };
      /touchpad\//i.test(ua) && (result.touchpad = t)
    }
    else if (/bada/i.test(ua)) {
      result = {
        name: 'Bada'
      , osname: 'Bada'
      , bada: t
      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
      };
    }
    else if (tizen) {
      result = {
        name: 'Tizen'
      , osname: 'Tizen'
      , tizen: t
      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
      };
    }
    else if (/qupzilla/i.test(ua)) {
      result = {
        name: 'QupZilla'
        , qupzilla: t
        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
      }
    }
    else if (/chromium/i.test(ua)) {
      result = {
        name: 'Chromium'
        , chromium: t
        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
      }
    }
    else if (/chrome|crios|crmo/i.test(ua)) {
      result = {
        name: 'Chrome'
        , chrome: t
        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
      }
    }
    else if (android) {
      result = {
        name: 'Android'
        , version: versionIdentifier
      }
    }
    else if (/safari|applewebkit/i.test(ua)) {
      result = {
        name: 'Safari'
      , safari: t
      }
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if (iosdevice) {
      result = {
        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
      }
      // WTF: version is not part of user agent in web apps
      if (versionIdentifier) {
        result.version = versionIdentifier
      }
    }
    else if(/googlebot/i.test(ua)) {
      result = {
        name: 'Googlebot'
      , googlebot: t
      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
      }
    }
    else {
      result = {
        name: getFirstMatch(/^(.*)\/(.*) /),
        version: getSecondMatch(/^(.*)\/(.*) /)
     };
   }

    // set webkit or gecko flag for browsers based on these engines
    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
      if (/(apple)?webkit\/537\.36/i.test(ua)) {
        result.name = result.name || "Blink"
        result.blink = t
      } else {
        result.name = result.name || "Webkit"
        result.webkit = t
      }
      if (!result.version && versionIdentifier) {
        result.version = versionIdentifier
      }
    } else if (!result.opera && /gecko\//i.test(ua)) {
      result.name = result.name || "Gecko"
      result.gecko = t
      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
    }

    // set OS flags for platforms that have multiple browsers
    if (!result.windowsphone && (android || result.silk)) {
      result.android = t
      result.osname = 'Android'
    } else if (!result.windowsphone && iosdevice) {
      result[iosdevice] = t
      result.ios = t
      result.osname = 'iOS'
    } else if (mac) {
      result.mac = t
      result.osname = 'macOS'
    } else if (xbox) {
      result.xbox = t
      result.osname = 'Xbox'
    } else if (windows) {
      result.windows = t
      result.osname = 'Windows'
    } else if (linux) {
      result.linux = t
      result.osname = 'Linux'
    }

    function getWindowsVersion (s) {
      switch (s) {
        case 'NT': return 'NT'
        case 'XP': return 'XP'
        case 'NT 5.0': return '2000'
        case 'NT 5.1': return 'XP'
        case 'NT 5.2': return '2003'
        case 'NT 6.0': return 'Vista'
        case 'NT 6.1': return '7'
        case 'NT 6.2': return '8'
        case 'NT 6.3': return '8.1'
        case 'NT 10.0': return '10'
        default: return undefined
      }
    }

    // OS version extraction
    var osVersion = '';
    if (result.windows) {
      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
    } else if (result.windowsphone) {
      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
    } else if (result.mac) {
      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (iosdevice) {
      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
      osVersion = osVersion.replace(/[_\s]/g, '.');
    } else if (android) {
      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
    } else if (result.webos) {
      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
    } else if (result.blackberry) {
      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
    } else if (result.bada) {
      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
    } else if (result.tizen) {
      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
    }
    if (osVersion) {
      result.osversion = osVersion;
    }

    // device type extraction
    var osMajorVersion = !result.windows && osVersion.split('.')[0];
    if (
         tablet
      || nexusTablet
      || iosdevice == 'ipad'
      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
      || result.silk
    ) {
      result.tablet = t
    } else if (
         mobile
      || iosdevice == 'iphone'
      || iosdevice == 'ipod'
      || android
      || nexusMobile
      || result.blackberry
      || result.webos
      || result.bada
    ) {
      result.mobile = t
    }

    // Graded Browser Support
    // http://developer.yahoo.com/yui/articles/gbs
    if (result.msedge ||
        (result.msie && result.version >= 10) ||
        (result.yandexbrowser && result.version >= 15) ||
		    (result.vivaldi && result.version >= 1.0) ||
        (result.chrome && result.version >= 20) ||
        (result.samsungBrowser && result.version >= 4) ||
        (result.whale && compareVersions([result.version, '1.0']) === 1) ||
        (result.mzbrowser && compareVersions([result.version, '6.0']) === 1) ||
        (result.focus && compareVersions([result.version, '1.0']) === 1) ||
        (result.firefox && result.version >= 20.0) ||
        (result.safari && result.version >= 6) ||
        (result.opera && result.version >= 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
        (result.blackberry && result.version >= 10.1)
        || (result.chromium && result.version >= 20)
        ) {
      result.a = t;
    }
    else if ((result.msie && result.version < 10) ||
        (result.chrome && result.version < 20) ||
        (result.firefox && result.version < 20.0) ||
        (result.safari && result.version < 6) ||
        (result.opera && result.version < 10.0) ||
        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
        || (result.chromium && result.version < 20)
        ) {
      result.c = t
    } else result.x = t

    return result
  }

  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')

  bowser.test = function (browserList) {
    for (var i = 0; i < browserList.length; ++i) {
      var browserItem = browserList[i];
      if (typeof browserItem=== 'string') {
        if (browserItem in bowser) {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Get version precisions count
   *
   * @example
   *   getVersionPrecision("1.10.3") // 3
   *
   * @param  {string} version
   * @return {number}
   */
  function getVersionPrecision(version) {
    return version.split(".").length;
  }

  /**
   * Array::map polyfill
   *
   * @param  {Array} arr
   * @param  {Function} iterator
   * @return {Array}
   */
  function map(arr, iterator) {
    var result = [], i;
    if (Array.prototype.map) {
      return Array.prototype.map.call(arr, iterator);
    }
    for (i = 0; i < arr.length; i++) {
      result.push(iterator(arr[i]));
    }
    return result;
  }

  /**
   * Calculate browser version weight
   *
   * @example
   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
   *
   * @param  {Array<String>} versions versions to compare
   * @return {Number} comparison result
   */
  function compareVersions(versions) {
    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
    var chunks = map(versions, function (version) {
      var delta = precision - getVersionPrecision(version);

      // 2) "9" -> "9.0" (for precision = 2)
      version = version + new Array(delta + 1).join(".0");

      // 3) "9.0" -> ["000000000"", "000000009"]
      return map(version.split("."), function (chunk) {
        return new Array(20 - chunk.length).join("0") + chunk;
      }).reverse();
    });

    // iterate in reverse order by reversed chunks array
    while (--precision >= 0) {
      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
      if (chunks[0][precision] > chunks[1][precision]) {
        return 1;
      }
      else if (chunks[0][precision] === chunks[1][precision]) {
        if (precision === 0) {
          // all version chunks are same
          return 0;
        }
      }
      else {
        return -1;
      }
    }
  }

  /**
   * Check if browser is unsupported
   *
   * @example
   *   bowser.isUnsupportedBrowser({
   *     msie: "10",
   *     firefox: "23",
   *     chrome: "29",
   *     safari: "5.1",
   *     opera: "16",
   *     phantom: "534"
   *   });
   *
   * @param  {Object}  minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function isUnsupportedBrowser(minVersions, strictMode, ua) {
    var _bowser = bowser;

    // make strictMode param optional with ua param usage
    if (typeof strictMode === 'string') {
      ua = strictMode;
      strictMode = void(0);
    }

    if (strictMode === void(0)) {
      strictMode = false;
    }
    if (ua) {
      _bowser = detect(ua);
    }

    var version = "" + _bowser.version;
    for (var browser in minVersions) {
      if (minVersions.hasOwnProperty(browser)) {
        if (_bowser[browser]) {
          if (typeof minVersions[browser] !== 'string') {
            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
          }

          // browser version and min supported version.
          return compareVersions([version, minVersions[browser]]) < 0;
        }
      }
    }

    return strictMode; // not found
  }

  /**
   * Check if browser is supported
   *
   * @param  {Object} minVersions map of minimal version to browser
   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
   * @param  {String}  [ua] user agent string
   * @return {Boolean}
   */
  function check(minVersions, strictMode, ua) {
    return !isUnsupportedBrowser(minVersions, strictMode, ua);
  }

  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
  bowser.compareVersions = compareVersions;
  bowser.check = check;

  /*
   * Set our detect method to the main bowser object so we can
   * reuse it to test other user agents.
   * This is needed to implement future tests.
   */
  bowser._detect = detect;

  /*
   * Set our detect public method to the main bowser object
   * This is needed to implement bowser in server side
   */
  bowser.detect = detect;
  return bowser
});


/***/ }),
/* 2600 */
/***/ (function(module, exports, __webpack_require__) {

var AuthCipher = __webpack_require__(1098)
var Buffer = __webpack_require__(42).Buffer
var MODES = __webpack_require__(601)
var StreamCipher = __webpack_require__(1102)
var Transform = __webpack_require__(198)
var aes = __webpack_require__(406)
var ebtk = __webpack_require__(435)
var inherits = __webpack_require__(41)

function Decipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._last = void 0
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Decipher, Transform)

Decipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []
  while ((chunk = this._cache.get(this._autopadding))) {
    thing = this._mode.decrypt(this, chunk)
    out.push(thing)
  }
  return Buffer.concat(out)
}

Decipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    return unpad(this._mode.decrypt(this, chunk))
  } else if (chunk) {
    throw new Error('data not multiple of block length')
  }
}

Decipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function (autoPadding) {
  var out
  if (autoPadding) {
    if (this.cache.length > 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  } else {
    if (this.cache.length >= 16) {
      out = this.cache.slice(0, 16)
      this.cache = this.cache.slice(16)
      return out
    }
  }

  return null
}

Splitter.prototype.flush = function () {
  if (this.cache.length) return this.cache
}

function unpad (last) {
  var padded = last[15]
  if (padded < 1 || padded > 16) {
    throw new Error('unable to decrypt data')
  }
  var i = -1
  while (++i < padded) {
    if (last[(i + (16 - padded))] !== padded) {
      throw new Error('unable to decrypt data')
    }
  }
  if (padded === 16) return

  return last.slice(0, 16 - padded)
}

function createDecipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv, true)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv, true)
  }

  return new Decipher(config.module, password, iv)
}

function createDecipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createDecipheriv(suite, keys.key, keys.iv)
}

exports.createDecipher = createDecipher
exports.createDecipheriv = createDecipheriv


/***/ }),
/* 2601 */
/***/ (function(module, exports, __webpack_require__) {

var MODES = __webpack_require__(601)
var AuthCipher = __webpack_require__(1098)
var Buffer = __webpack_require__(42).Buffer
var StreamCipher = __webpack_require__(1102)
var Transform = __webpack_require__(198)
var aes = __webpack_require__(406)
var ebtk = __webpack_require__(435)
var inherits = __webpack_require__(41)

function Cipher (mode, key, iv) {
  Transform.call(this)

  this._cache = new Splitter()
  this._cipher = new aes.AES(key)
  this._prev = Buffer.from(iv)
  this._mode = mode
  this._autopadding = true
}

inherits(Cipher, Transform)

Cipher.prototype._update = function (data) {
  this._cache.add(data)
  var chunk
  var thing
  var out = []

  while ((chunk = this._cache.get())) {
    thing = this._mode.encrypt(this, chunk)
    out.push(thing)
  }

  return Buffer.concat(out)
}

var PADDING = Buffer.alloc(16, 0x10)

Cipher.prototype._final = function () {
  var chunk = this._cache.flush()
  if (this._autopadding) {
    chunk = this._mode.encrypt(this, chunk)
    this._cipher.scrub()
    return chunk
  }

  if (!chunk.equals(PADDING)) {
    this._cipher.scrub()
    throw new Error('data not multiple of block length')
  }
}

Cipher.prototype.setAutoPadding = function (setTo) {
  this._autopadding = !!setTo
  return this
}

function Splitter () {
  this.cache = Buffer.allocUnsafe(0)
}

Splitter.prototype.add = function (data) {
  this.cache = Buffer.concat([this.cache, data])
}

Splitter.prototype.get = function () {
  if (this.cache.length > 15) {
    var out = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    return out
  }
  return null
}

Splitter.prototype.flush = function () {
  var len = 16 - this.cache.length
  var padBuff = Buffer.allocUnsafe(len)

  var i = -1
  while (++i < len) {
    padBuff.writeUInt8(len, i)
  }

  return Buffer.concat([this.cache, padBuff])
}

function createCipheriv (suite, password, iv) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  if (typeof password === 'string') password = Buffer.from(password)
  if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length)

  if (typeof iv === 'string') iv = Buffer.from(iv)
  if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length)

  if (config.type === 'stream') {
    return new StreamCipher(config.module, password, iv)
  } else if (config.type === 'auth') {
    return new AuthCipher(config.module, password, iv)
  }

  return new Cipher(config.module, password, iv)
}

function createCipher (suite, password) {
  var config = MODES[suite.toLowerCase()]
  if (!config) throw new TypeError('invalid suite type')

  var keys = ebtk(password, false, config.key, config.iv)
  return createCipheriv(suite, keys.key, keys.iv)
}

exports.createCipheriv = createCipheriv
exports.createCipher = createCipher


/***/ }),
/* 2602 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(42).Buffer
var ZEROES = Buffer.alloc(16, 0)

function toArray (buf) {
  return [
    buf.readUInt32BE(0),
    buf.readUInt32BE(4),
    buf.readUInt32BE(8),
    buf.readUInt32BE(12)
  ]
}

function fromArray (out) {
  var buf = Buffer.allocUnsafe(16)
  buf.writeUInt32BE(out[0] >>> 0, 0)
  buf.writeUInt32BE(out[1] >>> 0, 4)
  buf.writeUInt32BE(out[2] >>> 0, 8)
  buf.writeUInt32BE(out[3] >>> 0, 12)
  return buf
}

function GHASH (key) {
  this.h = key
  this.state = Buffer.alloc(16, 0)
  this.cache = Buffer.allocUnsafe(0)
}

// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
GHASH.prototype.ghash = function (block) {
  var i = -1
  while (++i < block.length) {
    this.state[i] ^= block[i]
  }
  this._multiply()
}

GHASH.prototype._multiply = function () {
  var Vi = toArray(this.h)
  var Zi = [0, 0, 0, 0]
  var j, xi, lsbVi
  var i = -1
  while (++i < 128) {
    xi = (this.state[~~(i / 8)] & (1 << (7 - (i % 8)))) !== 0
    if (xi) {
      // Z_i+1 = Z_i ^ V_i
      Zi[0] ^= Vi[0]
      Zi[1] ^= Vi[1]
      Zi[2] ^= Vi[2]
      Zi[3] ^= Vi[3]
    }

    // Store the value of LSB(V_i)
    lsbVi = (Vi[3] & 1) !== 0

    // V_i+1 = V_i >> 1
    for (j = 3; j > 0; j--) {
      Vi[j] = (Vi[j] >>> 1) | ((Vi[j - 1] & 1) << 31)
    }
    Vi[0] = Vi[0] >>> 1

    // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
    if (lsbVi) {
      Vi[0] = Vi[0] ^ (0xe1 << 24)
    }
  }
  this.state = fromArray(Zi)
}

GHASH.prototype.update = function (buf) {
  this.cache = Buffer.concat([this.cache, buf])
  var chunk
  while (this.cache.length >= 16) {
    chunk = this.cache.slice(0, 16)
    this.cache = this.cache.slice(16)
    this.ghash(chunk)
  }
}

GHASH.prototype.final = function (abl, bl) {
  if (this.cache.length) {
    this.ghash(Buffer.concat([this.cache, ZEROES], 16))
  }

  this.ghash(fromArray([0, abl, 0, bl]))
  return this.state
}

module.exports = GHASH


/***/ }),
/* 2603 */
/***/ (function(module, exports, __webpack_require__) {

var xor = __webpack_require__(327)

exports.encrypt = function (self, block) {
  var data = xor(block, self._prev)

  self._prev = self._cipher.encryptBlock(data)
  return self._prev
}

exports.decrypt = function (self, block) {
  var pad = self._prev

  self._prev = block
  var out = self._cipher.decryptBlock(block)

  return xor(out, pad)
}


/***/ }),
/* 2604 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(42).Buffer
var xor = __webpack_require__(327)

function encryptStart (self, data, decrypt) {
  var len = data.length
  var out = xor(data, self._cache)
  self._cache = self._cache.slice(len)
  self._prev = Buffer.concat([self._prev, decrypt ? data : out])
  return out
}

exports.encrypt = function (self, data, decrypt) {
  var out = Buffer.allocUnsafe(0)
  var len

  while (data.length) {
    if (self._cache.length === 0) {
      self._cache = self._cipher.encryptBlock(self._prev)
      self._prev = Buffer.allocUnsafe(0)
    }

    if (self._cache.length <= data.length) {
      len = self._cache.length
      out = Buffer.concat([out, encryptStart(self, data.slice(0, len), decrypt)])
      data = data.slice(len)
    } else {
      out = Buffer.concat([out, encryptStart(self, data, decrypt)])
      break
    }
  }

  return out
}


/***/ }),
/* 2605 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(42).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad
  var i = -1
  var len = 8
  var out = 0
  var bit, value
  while (++i < len) {
    pad = self._cipher.encryptBlock(self._prev)
    bit = (byteParam & (1 << (7 - i))) ? 0x80 : 0
    value = pad[0] ^ bit
    out += ((value & 0x80) >> (i % 8))
    self._prev = shiftIn(self._prev, decrypt ? bit : value)
  }
  return out
}

function shiftIn (buffer, value) {
  var len = buffer.length
  var i = -1
  var out = Buffer.allocUnsafe(buffer.length)
  buffer = Buffer.concat([buffer, Buffer.from([value])])

  while (++i < len) {
    out[i] = buffer[i] << 1 | buffer[i + 1] >> (7)
  }

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 2606 */
/***/ (function(module, exports, __webpack_require__) {

var Buffer = __webpack_require__(42).Buffer

function encryptByte (self, byteParam, decrypt) {
  var pad = self._cipher.encryptBlock(self._prev)
  var out = pad[0] ^ byteParam

  self._prev = Buffer.concat([
    self._prev.slice(1),
    Buffer.from([decrypt ? byteParam : out])
  ])

  return out
}

exports.encrypt = function (self, chunk, decrypt) {
  var len = chunk.length
  var out = Buffer.allocUnsafe(len)
  var i = -1

  while (++i < len) {
    out[i] = encryptByte(self, chunk[i], decrypt)
  }

  return out
}


/***/ }),
/* 2607 */
/***/ (function(module, exports) {

exports.encrypt = function (self, block) {
  return self._cipher.encryptBlock(block)
}

exports.decrypt = function (self, block) {
  return self._cipher.decryptBlock(block)
}


/***/ }),
/* 2608 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var xor = __webpack_require__(327)

function getBlock (self) {
  self._prev = self._cipher.encryptBlock(self._prev)
  return self._prev
}

exports.encrypt = function (self, chunk) {
  while (self._cache.length < chunk.length) {
    self._cache = Buffer.concat([self._cache, getBlock(self)])
  }

  var pad = self._cache.slice(0, chunk.length)
  self._cache = self._cache.slice(chunk.length)
  return xor(chunk, pad)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75).Buffer))

/***/ }),
/* 2609 */
/***/ (function(module, exports, __webpack_require__) {

var DES = __webpack_require__(2610)
var aes = __webpack_require__(600)
var aesModes = __webpack_require__(601)
var desModes = __webpack_require__(2611)
var ebtk = __webpack_require__(435)

function createCipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createCipheriv(suite, keys.key, keys.iv)
}

function createDecipher (suite, password) {
  suite = suite.toLowerCase()

  var keyLen, ivLen
  if (aesModes[suite]) {
    keyLen = aesModes[suite].key
    ivLen = aesModes[suite].iv
  } else if (desModes[suite]) {
    keyLen = desModes[suite].key * 8
    ivLen = desModes[suite].iv
  } else {
    throw new TypeError('invalid suite type')
  }

  var keys = ebtk(password, false, keyLen, ivLen)
  return createDecipheriv(suite, keys.key, keys.iv)
}

function createCipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createCipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite })

  throw new TypeError('invalid suite type')
}

function createDecipheriv (suite, key, iv) {
  suite = suite.toLowerCase()
  if (aesModes[suite]) return aes.createDecipheriv(suite, key, iv)
  if (desModes[suite]) return new DES({ key: key, iv: iv, mode: suite, decrypt: true })

  throw new TypeError('invalid suite type')
}

function getCiphers () {
  return Object.keys(desModes).concat(aes.getCiphers())
}

exports.createCipher = exports.Cipher = createCipher
exports.createCipheriv = exports.Cipheriv = createCipheriv
exports.createDecipher = exports.Decipher = createDecipher
exports.createDecipheriv = exports.Decipheriv = createDecipheriv
exports.listCiphers = exports.getCiphers = getCiphers


/***/ }),
/* 2610 */
/***/ (function(module, exports, __webpack_require__) {

var CipherBase = __webpack_require__(198)
var des = __webpack_require__(2842)
var inherits = __webpack_require__(41)
var Buffer = __webpack_require__(42).Buffer

var modes = {
  'des-ede3-cbc': des.CBC.instantiate(des.EDE),
  'des-ede3': des.EDE,
  'des-ede-cbc': des.CBC.instantiate(des.EDE),
  'des-ede': des.EDE,
  'des-cbc': des.CBC.instantiate(des.DES),
  'des-ecb': des.DES
}
modes.des = modes['des-cbc']
modes.des3 = modes['des-ede3-cbc']
module.exports = DES
inherits(DES, CipherBase)
function DES (opts) {
  CipherBase.call(this)
  var modeName = opts.mode.toLowerCase()
  var mode = modes[modeName]
  var type
  if (opts.decrypt) {
    type = 'decrypt'
  } else {
    type = 'encrypt'
  }
  var key = opts.key
  if (!Buffer.isBuffer(key)) {
    key = Buffer.from(key)
  }
  if (modeName === 'des-ede' || modeName === 'des-ede-cbc') {
    key = Buffer.concat([key, key.slice(0, 8)])
  }
  var iv = opts.iv
  if (!Buffer.isBuffer(iv)) {
    iv = Buffer.from(iv)
  }
  this._des = mode.create({
    key: key,
    iv: iv,
    type: type
  })
}
DES.prototype._update = function (data) {
  return Buffer.from(this._des.update(data))
}
DES.prototype._final = function () {
  return Buffer.from(this._des.final())
}


/***/ }),
/* 2611 */
/***/ (function(module, exports) {

exports['des-ecb'] = {
  key: 8,
  iv: 0
}
exports['des-cbc'] = exports.des = {
  key: 8,
  iv: 8
}
exports['des-ede3-cbc'] = exports.des3 = {
  key: 24,
  iv: 8
}
exports['des-ede3'] = {
  key: 24,
  iv: 0
}
exports['des-ede-cbc'] = {
  key: 16,
  iv: 8
}
exports['des-ede'] = {
  key: 16,
  iv: 0
}


/***/ }),
/* 2612 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1103)


/***/ }),
/* 2613 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var createHash = __webpack_require__(336)
var stream = __webpack_require__(759)
var inherits = __webpack_require__(41)
var sign = __webpack_require__(2614)
var verify = __webpack_require__(2615)

var algorithms = __webpack_require__(1103)
Object.keys(algorithms).forEach(function (key) {
  algorithms[key].id = new Buffer(algorithms[key].id, 'hex')
  algorithms[key.toLowerCase()] = algorithms[key]
})

function Sign (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hashType = data.hash
  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Sign, stream.Writable)

Sign.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Sign.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Sign.prototype.sign = function signMethod (key, enc) {
  this.end()
  var hash = this._hash.digest()
  var sig = sign(hash, key, this._hashType, this._signType, this._tag)

  return enc ? sig.toString(enc) : sig
}

function Verify (algorithm) {
  stream.Writable.call(this)

  var data = algorithms[algorithm]
  if (!data) throw new Error('Unknown message digest')

  this._hash = createHash(data.hash)
  this._tag = data.id
  this._signType = data.sign
}
inherits(Verify, stream.Writable)

Verify.prototype._write = function _write (data, _, done) {
  this._hash.update(data)
  done()
}

Verify.prototype.update = function update (data, enc) {
  if (typeof data === 'string') data = new Buffer(data, enc)

  this._hash.update(data)
  return this
}

Verify.prototype.verify = function verifyMethod (key, sig, enc) {
  if (typeof sig === 'string') sig = new Buffer(sig, enc)

  this.end()
  var hash = this._hash.digest()
  return verify(sig, hash, key, this._signType, this._tag)
}

function createSign (algorithm) {
  return new Sign(algorithm)
}

function createVerify (algorithm) {
  return new Verify(algorithm)
}

module.exports = {
  Sign: createSign,
  Verify: createVerify,
  createSign: createSign,
  createVerify: createVerify
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75).Buffer))

/***/ }),
/* 2614 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var createHmac = __webpack_require__(1152)
var crt = __webpack_require__(602)
var EC = __webpack_require__(653).ec
var BN = __webpack_require__(77)
var parseKeys = __webpack_require__(454)
var curves = __webpack_require__(1104)

function sign (hash, key, hashType, signType, tag) {
  var priv = parseKeys(key)
  if (priv.curve) {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
    return ecSign(hash, priv)
  } else if (priv.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong private key type')
    return dsaSign(hash, priv, hashType)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = priv.modulus.byteLength()
  var pad = [ 0, 1 ]
  while (hash.length + pad.length + 1 < len) pad.push(0xff)
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) pad.push(hash[i])

  var out = crt(pad, priv)
  return out
}

function ecSign (hash, priv) {
  var curveId = curves[priv.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'))

  var curve = new EC(curveId)
  var key = curve.keyFromPrivate(priv.privateKey)
  var out = key.sign(hash)

  return new Buffer(out.toDER())
}

function dsaSign (hash, priv, algo) {
  var x = priv.params.priv_key
  var p = priv.params.p
  var q = priv.params.q
  var g = priv.params.g
  var r = new BN(0)
  var k
  var H = bits2int(hash, q).mod(q)
  var s = false
  var kv = getKey(x, q, hash, algo)
  while (s === false) {
    k = makeKey(q, kv, algo)
    r = makeR(g, k, p, q)
    s = k.invm(q).imul(H.add(x.mul(r))).mod(q)
    if (s.cmpn(0) === 0) {
      s = false
      r = new BN(0)
    }
  }
  return toDER(r, s)
}

function toDER (r, s) {
  r = r.toArray()
  s = s.toArray()

  // Pad values
  if (r[0] & 0x80) r = [ 0 ].concat(r)
  if (s[0] & 0x80) s = [ 0 ].concat(s)

  var total = r.length + s.length + 4
  var res = [ 0x30, total, 0x02, r.length ]
  res = res.concat(r, [ 0x02, s.length ], s)
  return new Buffer(res)
}

function getKey (x, q, hash, algo) {
  x = new Buffer(x.toArray())
  if (x.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - x.length)
    zeros.fill(0)
    x = Buffer.concat([ zeros, x ])
  }
  var hlen = hash.length
  var hbits = bits2octets(hash, q)
  var v = new Buffer(hlen)
  v.fill(1)
  var k = new Buffer(hlen)
  k.fill(0)
  k = createHmac(algo, k).update(v).update(new Buffer([ 0 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  k = createHmac(algo, k).update(v).update(new Buffer([ 1 ])).update(x).update(hbits).digest()
  v = createHmac(algo, k).update(v).digest()
  return { k: k, v: v }
}

function bits2int (obits, q) {
  var bits = new BN(obits)
  var shift = (obits.length << 3) - q.bitLength()
  if (shift > 0) bits.ishrn(shift)
  return bits
}

function bits2octets (bits, q) {
  bits = bits2int(bits, q)
  bits = bits.mod(q)
  var out = new Buffer(bits.toArray())
  if (out.length < q.byteLength()) {
    var zeros = new Buffer(q.byteLength() - out.length)
    zeros.fill(0)
    out = Buffer.concat([ zeros, out ])
  }
  return out
}

function makeKey (q, kv, algo) {
  var t
  var k

  do {
    t = new Buffer(0)

    while (t.length * 8 < q.bitLength()) {
      kv.v = createHmac(algo, kv.k).update(kv.v).digest()
      t = Buffer.concat([ t, kv.v ])
    }

    k = bits2int(t, q)
    kv.k = createHmac(algo, kv.k).update(kv.v).update(new Buffer([ 0 ])).digest()
    kv.v = createHmac(algo, kv.k).update(kv.v).digest()
  } while (k.cmp(q) !== -1)

  return k
}

function makeR (g, k, p, q) {
  return g.toRed(BN.mont(p)).redPow(k).fromRed().mod(q)
}

module.exports = sign
module.exports.getKey = getKey
module.exports.makeKey = makeKey

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75).Buffer))

/***/ }),
/* 2615 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {// much of this based on https://github.com/indutny/self-signed/blob/gh-pages/lib/rsa.js
var BN = __webpack_require__(77)
var EC = __webpack_require__(653).ec
var parseKeys = __webpack_require__(454)
var curves = __webpack_require__(1104)

function verify (sig, hash, key, signType, tag) {
  var pub = parseKeys(key)
  if (pub.type === 'ec') {
    // rsa keys can be interpreted as ecdsa ones in openssl
    if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
    return ecVerify(sig, hash, pub)
  } else if (pub.type === 'dsa') {
    if (signType !== 'dsa') throw new Error('wrong public key type')
    return dsaVerify(sig, hash, pub)
  } else {
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type')
  }
  hash = Buffer.concat([tag, hash])
  var len = pub.modulus.byteLength()
  var pad = [ 1 ]
  var padNum = 0
  while (hash.length + pad.length + 2 < len) {
    pad.push(0xff)
    padNum++
  }
  pad.push(0x00)
  var i = -1
  while (++i < hash.length) {
    pad.push(hash[i])
  }
  pad = new Buffer(pad)
  var red = BN.mont(pub.modulus)
  sig = new BN(sig).toRed(red)

  sig = sig.redPow(new BN(pub.publicExponent))
  sig = new Buffer(sig.fromRed().toArray())
  var out = padNum < 8 ? 1 : 0
  len = Math.min(sig.length, pad.length)
  if (sig.length !== pad.length) out = 1

  i = -1
  while (++i < len) out |= sig[i] ^ pad[i]
  return out === 0
}

function ecVerify (sig, hash, pub) {
  var curveId = curves[pub.data.algorithm.curve.join('.')]
  if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'))

  var curve = new EC(curveId)
  var pubkey = pub.data.subjectPrivateKey.data

  return curve.verify(hash, sig, pubkey)
}

function dsaVerify (sig, hash, pub) {
  var p = pub.data.p
  var q = pub.data.q
  var g = pub.data.g
  var y = pub.data.pub_key
  var unpacked = parseKeys.signature.decode(sig, 'der')
  var s = unpacked.s
  var r = unpacked.r
  checkValue(s, q)
  checkValue(r, q)
  var montp = BN.mont(p)
  var w = s.invm(q)
  var v = g.toRed(montp)
    .redPow(new BN(hash).mul(w).mod(q))
    .fromRed()
    .mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed())
    .mod(p)
    .mod(q)
  return v.cmp(r) === 0
}

function checkValue (b, q) {
  if (b.cmpn(0) <= 0) throw new Error('invalid sig')
  if (b.cmp(q) >= q) throw new Error('invalid sig')
}

module.exports = verify

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75).Buffer))

/***/ }),
/* 2616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(436);

var $apply = __webpack_require__(1105);
var $call = __webpack_require__(603);
var $reflectApply = __webpack_require__(2617);

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),
/* 2617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),
/* 2618 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(1108);
} catch (err) {
  var index = __webpack_require__(1108);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2796);
__webpack_require__(2735);
__webpack_require__(2737);
__webpack_require__(2736);
__webpack_require__(2739);
__webpack_require__(2741);
__webpack_require__(2746);
__webpack_require__(2740);
__webpack_require__(2738);
__webpack_require__(2748);
__webpack_require__(2747);
__webpack_require__(2743);
__webpack_require__(2744);
__webpack_require__(2742);
__webpack_require__(2734);
__webpack_require__(2745);
__webpack_require__(2749);
__webpack_require__(2750);
__webpack_require__(2701);
__webpack_require__(2703);
__webpack_require__(2702);
__webpack_require__(2752);
__webpack_require__(2751);
__webpack_require__(2722);
__webpack_require__(2732);
__webpack_require__(2733);
__webpack_require__(2723);
__webpack_require__(2724);
__webpack_require__(2725);
__webpack_require__(2726);
__webpack_require__(2727);
__webpack_require__(2728);
__webpack_require__(2729);
__webpack_require__(2730);
__webpack_require__(2731);
__webpack_require__(2705);
__webpack_require__(2706);
__webpack_require__(2707);
__webpack_require__(2708);
__webpack_require__(2709);
__webpack_require__(2710);
__webpack_require__(2711);
__webpack_require__(2712);
__webpack_require__(2713);
__webpack_require__(2714);
__webpack_require__(2715);
__webpack_require__(2716);
__webpack_require__(2717);
__webpack_require__(2718);
__webpack_require__(2719);
__webpack_require__(2720);
__webpack_require__(2721);
__webpack_require__(2783);
__webpack_require__(2788);
__webpack_require__(2795);
__webpack_require__(2786);
__webpack_require__(2778);
__webpack_require__(2779);
__webpack_require__(2784);
__webpack_require__(2789);
__webpack_require__(2791);
__webpack_require__(2774);
__webpack_require__(2775);
__webpack_require__(2776);
__webpack_require__(2777);
__webpack_require__(2780);
__webpack_require__(2781);
__webpack_require__(2782);
__webpack_require__(2785);
__webpack_require__(2787);
__webpack_require__(2790);
__webpack_require__(2792);
__webpack_require__(2793);
__webpack_require__(2794);
__webpack_require__(2696);
__webpack_require__(2698);
__webpack_require__(2697);
__webpack_require__(2700);
__webpack_require__(2699);
__webpack_require__(2685);
__webpack_require__(2683);
__webpack_require__(2689);
__webpack_require__(2686);
__webpack_require__(2692);
__webpack_require__(2694);
__webpack_require__(2682);
__webpack_require__(2688);
__webpack_require__(2679);
__webpack_require__(2693);
__webpack_require__(2677);
__webpack_require__(2691);
__webpack_require__(2690);
__webpack_require__(2684);
__webpack_require__(2687);
__webpack_require__(2676);
__webpack_require__(2678);
__webpack_require__(2681);
__webpack_require__(2680);
__webpack_require__(2695);
__webpack_require__(641);
__webpack_require__(2767);
__webpack_require__(1149);
__webpack_require__(2772);
__webpack_require__(1150);
__webpack_require__(2768);
__webpack_require__(2769);
__webpack_require__(2770);
__webpack_require__(2771);
__webpack_require__(1148);
__webpack_require__(2704);
__webpack_require__(2773);
__webpack_require__(2808);
__webpack_require__(2809);
__webpack_require__(2797);
__webpack_require__(2798);
__webpack_require__(2803);
__webpack_require__(2806);
__webpack_require__(2807);
__webpack_require__(2801);
__webpack_require__(2804);
__webpack_require__(2802);
__webpack_require__(2805);
__webpack_require__(2799);
__webpack_require__(2800);
__webpack_require__(2753);
__webpack_require__(2754);
__webpack_require__(2755);
__webpack_require__(2756);
__webpack_require__(2757);
__webpack_require__(2760);
__webpack_require__(2758);
__webpack_require__(2759);
__webpack_require__(2761);
__webpack_require__(2762);
__webpack_require__(2763);
__webpack_require__(2764);
__webpack_require__(2766);
__webpack_require__(2765);
module.exports = __webpack_require__(78);


/***/ }),
/* 2620 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2810);
module.exports = __webpack_require__(78).Array.flatMap;


/***/ }),
/* 2621 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2811);
module.exports = __webpack_require__(78).Array.includes;


/***/ }),
/* 2622 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2812);
module.exports = __webpack_require__(78).Object.entries;


/***/ }),
/* 2623 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2813);
module.exports = __webpack_require__(78).Object.getOwnPropertyDescriptors;


/***/ }),
/* 2624 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2814);
module.exports = __webpack_require__(78).Object.values;


/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(1148);
__webpack_require__(2815);
module.exports = __webpack_require__(78).Promise['finally'];


/***/ }),
/* 2626 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2816);
module.exports = __webpack_require__(78).String.padEnd;


/***/ }),
/* 2627 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2817);
module.exports = __webpack_require__(78).String.padStart;


/***/ }),
/* 2628 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2819);
module.exports = __webpack_require__(78).String.trimRight;


/***/ }),
/* 2629 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2818);
module.exports = __webpack_require__(78).String.trimLeft;


/***/ }),
/* 2630 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2820);
module.exports = __webpack_require__(639).f('asyncIterator');


/***/ }),
/* 2631 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2663);
module.exports = __webpack_require__(176).global;


/***/ }),
/* 2632 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2656);
module.exports = __webpack_require__(176).Object.assign;


/***/ }),
/* 2633 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2657);
var $Object = __webpack_require__(176).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 2634 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2658);
var $Object = __webpack_require__(176).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 2635 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2659);
module.exports = __webpack_require__(176).Object.setPrototypeOf;


/***/ }),
/* 2636 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2662);
__webpack_require__(2660);
__webpack_require__(2664);
__webpack_require__(2665);
module.exports = __webpack_require__(176).Symbol;


/***/ }),
/* 2637 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2661);
__webpack_require__(2666);
module.exports = __webpack_require__(616).f('iterator');


/***/ }),
/* 2638 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 2639 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 2640 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(274);
var toLength = __webpack_require__(2654);
var toAbsoluteIndex = __webpack_require__(2653);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 2641 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(408);
var gOPS = __webpack_require__(608);
var pIE = __webpack_require__(409);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 2642 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(177).document;
module.exports = document && document.documentElement;


/***/ }),
/* 2643 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(1110);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 2644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(607);
var descriptor = __webpack_require__(410);
var setToStringTag = __webpack_require__(609);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(272)(IteratorPrototype, __webpack_require__(275)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 2645 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 2646 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(411)('meta');
var isObject = __webpack_require__(273);
var has = __webpack_require__(228);
var setDesc = __webpack_require__(229).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(330)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 2647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(199);
var getKeys = __webpack_require__(408);
var gOPS = __webpack_require__(608);
var pIE = __webpack_require__(409);
var toObject = __webpack_require__(613);
var IObject = __webpack_require__(1114);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(330)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 2648 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(229);
var anObject = __webpack_require__(329);
var getKeys = __webpack_require__(408);

module.exports = __webpack_require__(199) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 2649 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(274);
var gOPN = __webpack_require__(1117).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 2650 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(228);
var toObject = __webpack_require__(613);
var IE_PROTO = __webpack_require__(610)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 2651 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(273);
var anObject = __webpack_require__(329);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(1111)(Function.call, __webpack_require__(1116).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 2652 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(612);
var defined = __webpack_require__(604);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 2653 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(612);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 2654 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(612);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 2655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(2639);
var step = __webpack_require__(2645);
var Iterators = __webpack_require__(606);
var toIObject = __webpack_require__(274);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(1115)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 2656 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(227);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(2647) });


/***/ }),
/* 2657 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(227);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(607) });


/***/ }),
/* 2658 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(227);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(199), 'Object', { defineProperty: __webpack_require__(229).f });


/***/ }),
/* 2659 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(227);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(2651).set });


/***/ }),
/* 2660 */
/***/ (function(module, exports) {



/***/ }),
/* 2661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(2652)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(1115)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 2662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(177);
var has = __webpack_require__(228);
var DESCRIPTORS = __webpack_require__(199);
var $export = __webpack_require__(227);
var redefine = __webpack_require__(1119);
var META = __webpack_require__(2646).KEY;
var $fails = __webpack_require__(330);
var shared = __webpack_require__(611);
var setToStringTag = __webpack_require__(609);
var uid = __webpack_require__(411);
var wks = __webpack_require__(275);
var wksExt = __webpack_require__(616);
var wksDefine = __webpack_require__(615);
var enumKeys = __webpack_require__(2641);
var isArray = __webpack_require__(2643);
var anObject = __webpack_require__(329);
var isObject = __webpack_require__(273);
var toObject = __webpack_require__(613);
var toIObject = __webpack_require__(274);
var toPrimitive = __webpack_require__(614);
var createDesc = __webpack_require__(410);
var _create = __webpack_require__(607);
var gOPNExt = __webpack_require__(2649);
var $GOPD = __webpack_require__(1116);
var $GOPS = __webpack_require__(608);
var $DP = __webpack_require__(229);
var $keys = __webpack_require__(408);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(1117).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(409).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(407)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(272)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 2663 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-global
var $export = __webpack_require__(227);

$export($export.G, { global: __webpack_require__(177) });


/***/ }),
/* 2664 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(615)('asyncIterator');


/***/ }),
/* 2665 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(615)('observable');


/***/ }),
/* 2666 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2655);
var global = __webpack_require__(177);
var hide = __webpack_require__(272);
var Iterators = __webpack_require__(606);
var TO_STRING_TAG = __webpack_require__(275)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 2667 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(53);
var isArray = __webpack_require__(417);
var SPECIES = __webpack_require__(67)('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),
/* 2668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var fails = __webpack_require__(51);
var getTime = Date.prototype.getTime;
var $toISOString = Date.prototype.toISOString;

var lz = function (num) {
  return num > 9 ? num : '0' + num;
};

// PhantomJS / old WebKit has a broken implementations
module.exports = (fails(function () {
  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
}) || !fails(function () {
  $toISOString.call(new Date(NaN));
})) ? function toISOString() {
  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
  var d = this;
  var y = d.getUTCFullYear();
  var m = d.getUTCMilliseconds();
  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
} : $toISOString;


/***/ }),
/* 2669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(50);
var toPrimitive = __webpack_require__(201);
var NUMBER = 'number';

module.exports = function (hint) {
  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
  return toPrimitive(anObject(this), hint != NUMBER);
};


/***/ }),
/* 2670 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(235);
var gOPS = __webpack_require__(419);
var pIE = __webpack_require__(333);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 2671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var isArray = __webpack_require__(417);
var isObject = __webpack_require__(53);
var toLength = __webpack_require__(73);
var ctx = __webpack_require__(160);
var IS_CONCAT_SPREADABLE = __webpack_require__(67)('isConcatSpreadable');

function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
  var element, spreadable;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      spreadable = false;
      if (isObject(element)) {
        spreadable = element[IS_CONCAT_SPREADABLE];
        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
      }

      if (spreadable && depth > 0) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
}

module.exports = flattenIntoArray;


/***/ }),
/* 2672 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(421)('native-function-to-string', Function.toString);


/***/ }),
/* 2673 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var sign = __webpack_require__(629);
var pow = Math.pow;
var EPSILON = pow(2, -52);
var EPSILON32 = pow(2, -23);
var MAX32 = pow(2, 127) * (2 - EPSILON32);
var MIN32 = pow(2, -126);

var roundTiesToEven = function (n) {
  return n + 1 / EPSILON - 1 / EPSILON;
};

module.exports = Math.fround || function fround(x) {
  var $abs = Math.abs(x);
  var $sign = sign(x);
  var a, result;
  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
  a = (1 + EPSILON32 / EPSILON) * $abs;
  result = a - (a - $abs);
  // eslint-disable-next-line no-self-compare
  if (result > MAX32 || result != result) return $sign * Infinity;
  return $sign * result;
};


/***/ }),
/* 2674 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(52);
var macrotask = __webpack_require__(637).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(178)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 2675 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 2676 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
var $export = __webpack_require__(17);

$export($export.P, 'Array', { copyWithin: __webpack_require__(1121) });

__webpack_require__(230)('copyWithin');


/***/ }),
/* 2677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(17);
var $every = __webpack_require__(159)(4);

$export($export.P + $export.F * !__webpack_require__(147)([].every, true), 'Array', {
  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
  every: function every(callbackfn /* , thisArg */) {
    return $every(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2678 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
var $export = __webpack_require__(17);

$export($export.P, 'Array', { fill: __webpack_require__(618) });

__webpack_require__(230)('fill');


/***/ }),
/* 2679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(17);
var $filter = __webpack_require__(159)(2);

$export($export.P + $export.F * !__webpack_require__(147)([].filter, true), 'Array', {
  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
var $export = __webpack_require__(17);
var $find = __webpack_require__(159)(6);
var KEY = 'findIndex';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(230)(KEY);


/***/ }),
/* 2681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__(17);
var $find = __webpack_require__(159)(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__(230)(KEY);


/***/ }),
/* 2682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(17);
var $forEach = __webpack_require__(159)(0);
var STRICT = __webpack_require__(147)([].forEach, true);

$export($export.P + $export.F * !STRICT, 'Array', {
  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
  forEach: function forEach(callbackfn /* , thisArg */) {
    return $forEach(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(160);
var $export = __webpack_require__(17);
var toObject = __webpack_require__(99);
var call = __webpack_require__(1130);
var isArrayIter = __webpack_require__(625);
var toLength = __webpack_require__(73);
var createProperty = __webpack_require__(619);
var getIterFn = __webpack_require__(640);

$export($export.S + $export.F * !__webpack_require__(418)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 2684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(17);
var $indexOf = __webpack_require__(412)(false);
var $native = [].indexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(147)($native)), 'Array', {
  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? $native.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments[1]);
  }
});


/***/ }),
/* 2685 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(17);

$export($export.S, 'Array', { isArray: __webpack_require__(417) });


/***/ }),
/* 2686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.13 Array.prototype.join(separator)
var $export = __webpack_require__(17);
var toIObject = __webpack_require__(132);
var arrayJoin = [].join;

// fallback for not array-like strings
$export($export.P + $export.F * (__webpack_require__(332) != Object || !__webpack_require__(147)(arrayJoin)), 'Array', {
  join: function join(separator) {
    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
  }
});


/***/ }),
/* 2687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(17);
var toIObject = __webpack_require__(132);
var toInteger = __webpack_require__(163);
var toLength = __webpack_require__(73);
var $native = [].lastIndexOf;
var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(147)($native)), 'Array', {
  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
    // convert -0 to +0
    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
    var O = toIObject(this);
    var length = toLength(O.length);
    var index = length - 1;
    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
    if (index < 0) index = length + index;
    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
    return -1;
  }
});


/***/ }),
/* 2688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(17);
var $map = __webpack_require__(159)(1);

$export($export.P + $export.F * !__webpack_require__(147)([].map, true), 'Array', {
  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(17);
var createProperty = __webpack_require__(619);

// WebKit Array.of isn't generic
$export($export.S + $export.F * __webpack_require__(51)(function () {
  function F() { /* empty */ }
  return !(Array.of.call(F) instanceof F);
}), 'Array', {
  // 22.1.2.3 Array.of( ...items)
  of: function of(/* ...args */) {
    var index = 0;
    var aLen = arguments.length;
    var result = new (typeof this == 'function' ? this : Array)(aLen);
    while (aLen > index) createProperty(result, index, arguments[index++]);
    result.length = aLen;
    return result;
  }
});


/***/ }),
/* 2690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(17);
var $reduce = __webpack_require__(1122);

$export($export.P + $export.F * !__webpack_require__(147)([].reduceRight, true), 'Array', {
  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
  }
});


/***/ }),
/* 2691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(17);
var $reduce = __webpack_require__(1122);

$export($export.P + $export.F * !__webpack_require__(147)([].reduce, true), 'Array', {
  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
  }
});


/***/ }),
/* 2692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(17);
var html = __webpack_require__(623);
var cof = __webpack_require__(178);
var toAbsoluteIndex = __webpack_require__(237);
var toLength = __webpack_require__(73);
var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
$export($export.P + $export.F * __webpack_require__(51)(function () {
  if (html) arraySlice.call(html);
}), 'Array', {
  slice: function slice(begin, end) {
    var len = toLength(this.length);
    var klass = cof(this);
    end = end === undefined ? len : end;
    if (klass == 'Array') return arraySlice.call(this, begin, end);
    var start = toAbsoluteIndex(begin, len);
    var upTo = toAbsoluteIndex(end, len);
    var size = toLength(upTo - start);
    var cloned = new Array(size);
    var i = 0;
    for (; i < size; i++) cloned[i] = klass == 'String'
      ? this.charAt(start + i)
      : this[start + i];
    return cloned;
  }
});


/***/ }),
/* 2693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(17);
var $some = __webpack_require__(159)(3);

$export($export.P + $export.F * !__webpack_require__(147)([].some, true), 'Array', {
  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments[1]);
  }
});


/***/ }),
/* 2694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(17);
var aFunction = __webpack_require__(158);
var toObject = __webpack_require__(99);
var fails = __webpack_require__(51);
var $sort = [].sort;
var test = [1, 2, 3];

$export($export.P + $export.F * (fails(function () {
  // IE8-
  test.sort(undefined);
}) || !fails(function () {
  // V8 bug
  test.sort(null);
  // Old WebKit
}) || !__webpack_require__(147)($sort)), 'Array', {
  // 22.1.3.25 Array.prototype.sort(comparefn)
  sort: function sort(comparefn) {
    return comparefn === undefined
      ? $sort.call(toObject(this))
      : $sort.call(toObject(this), aFunction(comparefn));
  }
});


/***/ }),
/* 2695 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(279)('Array');


/***/ }),
/* 2696 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.3.1 / 15.9.4.4 Date.now()
var $export = __webpack_require__(17);

$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ }),
/* 2697 */
/***/ (function(module, exports, __webpack_require__) {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
var $export = __webpack_require__(17);
var toISOString = __webpack_require__(2668);

// PhantomJS / old WebKit has a broken implementations
$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
  toISOString: toISOString
});


/***/ }),
/* 2698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(17);
var toObject = __webpack_require__(99);
var toPrimitive = __webpack_require__(201);

$export($export.P + $export.F * __webpack_require__(51)(function () {
  return new Date(NaN).toJSON() !== null
    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
}), 'Date', {
  // eslint-disable-next-line no-unused-vars
  toJSON: function toJSON(key) {
    var O = toObject(this);
    var pv = toPrimitive(O);
    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
  }
});


/***/ }),
/* 2699 */
/***/ (function(module, exports, __webpack_require__) {

var TO_PRIMITIVE = __webpack_require__(67)('toPrimitive');
var proto = Date.prototype;

if (!(TO_PRIMITIVE in proto)) __webpack_require__(131)(proto, TO_PRIMITIVE, __webpack_require__(2669));


/***/ }),
/* 2700 */
/***/ (function(module, exports, __webpack_require__) {

var DateProto = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var $toString = DateProto[TO_STRING];
var getTime = DateProto.getTime;
if (new Date(NaN) + '' != INVALID_DATE) {
  __webpack_require__(119)(DateProto, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare
    return value === value ? $toString.call(this) : INVALID_DATE;
  });
}


/***/ }),
/* 2701 */
/***/ (function(module, exports, __webpack_require__) {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
var $export = __webpack_require__(17);

$export($export.P, 'Function', { bind: __webpack_require__(1124) });


/***/ }),
/* 2702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(53);
var getPrototypeOf = __webpack_require__(234);
var HAS_INSTANCE = __webpack_require__(67)('hasInstance');
var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(83).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
  if (typeof this != 'function' || !isObject(O)) return false;
  if (!isObject(this.prototype)) return O instanceof this;
  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
  return false;
} });


/***/ }),
/* 2703 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(83).f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__(82) && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),
/* 2704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(1125);
var validate = __webpack_require__(239);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(413)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 2705 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.3 Math.acosh(x)
var $export = __webpack_require__(17);
var log1p = __webpack_require__(1133);
var sqrt = Math.sqrt;
var $acosh = Math.acosh;

$export($export.S + $export.F * !($acosh
  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
  && Math.floor($acosh(Number.MAX_VALUE)) == 710
  // Tor Browser bug: Math.acosh(Infinity) -> NaN
  && $acosh(Infinity) == Infinity
), 'Math', {
  acosh: function acosh(x) {
    return (x = +x) < 1 ? NaN : x > 94906265.62425156
      ? Math.log(x) + Math.LN2
      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
  }
});


/***/ }),
/* 2706 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.5 Math.asinh(x)
var $export = __webpack_require__(17);
var $asinh = Math.asinh;

function asinh(x) {
  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
}

// Tor Browser bug: Math.asinh(0) -> -0
$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ }),
/* 2707 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.7 Math.atanh(x)
var $export = __webpack_require__(17);
var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
  atanh: function atanh(x) {
    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
  }
});


/***/ }),
/* 2708 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.9 Math.cbrt(x)
var $export = __webpack_require__(17);
var sign = __webpack_require__(629);

$export($export.S, 'Math', {
  cbrt: function cbrt(x) {
    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
  }
});


/***/ }),
/* 2709 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.11 Math.clz32(x)
var $export = __webpack_require__(17);

$export($export.S, 'Math', {
  clz32: function clz32(x) {
    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
  }
});


/***/ }),
/* 2710 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.12 Math.cosh(x)
var $export = __webpack_require__(17);
var exp = Math.exp;

$export($export.S, 'Math', {
  cosh: function cosh(x) {
    return (exp(x = +x) + exp(-x)) / 2;
  }
});


/***/ }),
/* 2711 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.14 Math.expm1(x)
var $export = __webpack_require__(17);
var $expm1 = __webpack_require__(628);

$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ }),
/* 2712 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.16 Math.fround(x)
var $export = __webpack_require__(17);

$export($export.S, 'Math', { fround: __webpack_require__(2673) });


/***/ }),
/* 2713 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
var $export = __webpack_require__(17);
var abs = Math.abs;

$export($export.S, 'Math', {
  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
    var sum = 0;
    var i = 0;
    var aLen = arguments.length;
    var larg = 0;
    var arg, div;
    while (i < aLen) {
      arg = abs(arguments[i++]);
      if (larg < arg) {
        div = larg / arg;
        sum = sum * div * div + 1;
        larg = arg;
      } else if (arg > 0) {
        div = arg / larg;
        sum += div * div;
      } else sum += arg;
    }
    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
  }
});


/***/ }),
/* 2714 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.18 Math.imul(x, y)
var $export = __webpack_require__(17);
var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
$export($export.S + $export.F * __webpack_require__(51)(function () {
  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
}), 'Math', {
  imul: function imul(x, y) {
    var UINT16 = 0xffff;
    var xn = +x;
    var yn = +y;
    var xl = UINT16 & xn;
    var yl = UINT16 & yn;
    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
  }
});


/***/ }),
/* 2715 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.21 Math.log10(x)
var $export = __webpack_require__(17);

$export($export.S, 'Math', {
  log10: function log10(x) {
    return Math.log(x) * Math.LOG10E;
  }
});


/***/ }),
/* 2716 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.20 Math.log1p(x)
var $export = __webpack_require__(17);

$export($export.S, 'Math', { log1p: __webpack_require__(1133) });


/***/ }),
/* 2717 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.22 Math.log2(x)
var $export = __webpack_require__(17);

$export($export.S, 'Math', {
  log2: function log2(x) {
    return Math.log(x) / Math.LN2;
  }
});


/***/ }),
/* 2718 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.28 Math.sign(x)
var $export = __webpack_require__(17);

$export($export.S, 'Math', { sign: __webpack_require__(629) });


/***/ }),
/* 2719 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.30 Math.sinh(x)
var $export = __webpack_require__(17);
var expm1 = __webpack_require__(628);
var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
$export($export.S + $export.F * __webpack_require__(51)(function () {
  return !Math.sinh(-2e-17) != -2e-17;
}), 'Math', {
  sinh: function sinh(x) {
    return Math.abs(x = +x) < 1
      ? (expm1(x) - expm1(-x)) / 2
      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
  }
});


/***/ }),
/* 2720 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.33 Math.tanh(x)
var $export = __webpack_require__(17);
var expm1 = __webpack_require__(628);
var exp = Math.exp;

$export($export.S, 'Math', {
  tanh: function tanh(x) {
    var a = expm1(x = +x);
    var b = expm1(-x);
    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
  }
});


/***/ }),
/* 2721 */
/***/ (function(module, exports, __webpack_require__) {

// 20.2.2.34 Math.trunc(x)
var $export = __webpack_require__(17);

$export($export.S, 'Math', {
  trunc: function trunc(it) {
    return (it > 0 ? Math.floor : Math.ceil)(it);
  }
});


/***/ }),
/* 2722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(52);
var has = __webpack_require__(130);
var cof = __webpack_require__(178);
var inheritIfRequired = __webpack_require__(624);
var toPrimitive = __webpack_require__(201);
var fails = __webpack_require__(51);
var gOPN = __webpack_require__(233).f;
var gOPD = __webpack_require__(161).f;
var dP = __webpack_require__(83).f;
var $trim = __webpack_require__(281).trim;
var NUMBER = 'Number';
var $Number = global[NUMBER];
var Base = $Number;
var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
var BROKEN_COF = cof(__webpack_require__(232)(proto)) == NUMBER;
var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  if (typeof it == 'string' && it.length > 2) {
    it = TRIM ? it.trim() : $trim(it, 3);
    var first = it.charCodeAt(0);
    var third, radix, maxCode;
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
        default: return +it;
      }
      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
        code = digits.charCodeAt(i);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
  $Number = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var that = this;
    return that instanceof $Number
      // check on 1..constructor(foo) case
      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
  };
  for (var keys = __webpack_require__(82) ? gOPN(Base) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES6 (in case, if modules with ES6 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (has(Base, key = keys[j]) && !has($Number, key)) {
      dP($Number, key, gOPD(Base, key));
    }
  }
  $Number.prototype = proto;
  proto.constructor = $Number;
  __webpack_require__(119)(global, NUMBER, $Number);
}


/***/ }),
/* 2723 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.1 Number.EPSILON
var $export = __webpack_require__(17);

$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ }),
/* 2724 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.2 Number.isFinite(number)
var $export = __webpack_require__(17);
var _isFinite = __webpack_require__(52).isFinite;

$export($export.S, 'Number', {
  isFinite: function isFinite(it) {
    return typeof it == 'number' && _isFinite(it);
  }
});


/***/ }),
/* 2725 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(17);

$export($export.S, 'Number', { isInteger: __webpack_require__(1129) });


/***/ }),
/* 2726 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.4 Number.isNaN(number)
var $export = __webpack_require__(17);

$export($export.S, 'Number', {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare
    return number != number;
  }
});


/***/ }),
/* 2727 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.5 Number.isSafeInteger(number)
var $export = __webpack_require__(17);
var isInteger = __webpack_require__(1129);
var abs = Math.abs;

$export($export.S, 'Number', {
  isSafeInteger: function isSafeInteger(number) {
    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
  }
});


/***/ }),
/* 2728 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
var $export = __webpack_require__(17);

$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ }),
/* 2729 */
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
var $export = __webpack_require__(17);

$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ }),
/* 2730 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(17);
var $parseFloat = __webpack_require__(1141);
// 20.1.2.12 Number.parseFloat(string)
$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ }),
/* 2731 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(17);
var $parseInt = __webpack_require__(1142);
// 20.1.2.13 Number.parseInt(string, radix)
$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ }),
/* 2732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(17);
var toInteger = __webpack_require__(163);
var aNumberValue = __webpack_require__(1120);
var repeat = __webpack_require__(635);
var $toFixed = 1.0.toFixed;
var floor = Math.floor;
var data = [0, 0, 0, 0, 0, 0];
var ERROR = 'Number.toFixed: incorrect invocation!';
var ZERO = '0';

var multiply = function (n, c) {
  var i = -1;
  var c2 = c;
  while (++i < 6) {
    c2 += n * data[i];
    data[i] = c2 % 1e7;
    c2 = floor(c2 / 1e7);
  }
};
var divide = function (n) {
  var i = 6;
  var c = 0;
  while (--i >= 0) {
    c += data[i];
    data[i] = floor(c / n);
    c = (c % n) * 1e7;
  }
};
var numToString = function () {
  var i = 6;
  var s = '';
  while (--i >= 0) {
    if (s !== '' || i === 0 || data[i] !== 0) {
      var t = String(data[i]);
      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
    }
  } return s;
};
var pow = function (x, n, acc) {
  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
};
var log = function (x) {
  var n = 0;
  var x2 = x;
  while (x2 >= 4096) {
    n += 12;
    x2 /= 4096;
  }
  while (x2 >= 2) {
    n += 1;
    x2 /= 2;
  } return n;
};

$export($export.P + $export.F * (!!$toFixed && (
  0.00008.toFixed(3) !== '0.000' ||
  0.9.toFixed(0) !== '1' ||
  1.255.toFixed(2) !== '1.25' ||
  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
) || !__webpack_require__(51)(function () {
  // V8 ~ Android 4.3-
  $toFixed.call({});
})), 'Number', {
  toFixed: function toFixed(fractionDigits) {
    var x = aNumberValue(this, ERROR);
    var f = toInteger(fractionDigits);
    var s = '';
    var m = ZERO;
    var e, z, j, k;
    if (f < 0 || f > 20) throw RangeError(ERROR);
    // eslint-disable-next-line no-self-compare
    if (x != x) return 'NaN';
    if (x <= -1e21 || x >= 1e21) return String(x);
    if (x < 0) {
      s = '-';
      x = -x;
    }
    if (x > 1e-21) {
      e = log(x * pow(2, 69, 1)) - 69;
      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
      z *= 0x10000000000000;
      e = 52 - e;
      if (e > 0) {
        multiply(0, z);
        j = f;
        while (j >= 7) {
          multiply(1e7, 0);
          j -= 7;
        }
        multiply(pow(10, j, 1), 0);
        j = e - 1;
        while (j >= 23) {
          divide(1 << 23);
          j -= 23;
        }
        divide(1 << j);
        multiply(1, 1);
        divide(2);
        m = numToString();
      } else {
        multiply(0, z);
        multiply(1 << -e, 0);
        m = numToString() + repeat.call(ZERO, f);
      }
    }
    if (f > 0) {
      k = m.length;
      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
    } else {
      m = s + m;
    } return m;
  }
});


/***/ }),
/* 2733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(17);
var $fails = __webpack_require__(51);
var aNumberValue = __webpack_require__(1120);
var $toPrecision = 1.0.toPrecision;

$export($export.P + $export.F * ($fails(function () {
  // IE7-
  return $toPrecision.call(1, undefined) !== '1';
}) || !$fails(function () {
  // V8 ~ Android 4.3-
  $toPrecision.call({});
})), 'Number', {
  toPrecision: function toPrecision(precision) {
    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
  }
});


/***/ }),
/* 2734 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(17);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1135) });


/***/ }),
/* 2735 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(17);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(232) });


/***/ }),
/* 2736 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(17);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
$export($export.S + $export.F * !__webpack_require__(82), 'Object', { defineProperties: __webpack_require__(1136) });


/***/ }),
/* 2737 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(17);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(82), 'Object', { defineProperty: __webpack_require__(83).f });


/***/ }),
/* 2738 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.5 Object.freeze(O)
var isObject = __webpack_require__(53);
var meta = __webpack_require__(200).onFreeze;

__webpack_require__(162)('freeze', function ($freeze) {
  return function freeze(it) {
    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
  };
});


/***/ }),
/* 2739 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(132);
var $getOwnPropertyDescriptor = __webpack_require__(161).f;

__webpack_require__(162)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 2740 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(162)('getOwnPropertyNames', function () {
  return __webpack_require__(1137).f;
});


/***/ }),
/* 2741 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(99);
var $getPrototypeOf = __webpack_require__(234);

__webpack_require__(162)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 2742 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.11 Object.isExtensible(O)
var isObject = __webpack_require__(53);

__webpack_require__(162)('isExtensible', function ($isExtensible) {
  return function isExtensible(it) {
    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
  };
});


/***/ }),
/* 2743 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.12 Object.isFrozen(O)
var isObject = __webpack_require__(53);

__webpack_require__(162)('isFrozen', function ($isFrozen) {
  return function isFrozen(it) {
    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
  };
});


/***/ }),
/* 2744 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.13 Object.isSealed(O)
var isObject = __webpack_require__(53);

__webpack_require__(162)('isSealed', function ($isSealed) {
  return function isSealed(it) {
    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
  };
});


/***/ }),
/* 2745 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.10 Object.is(value1, value2)
var $export = __webpack_require__(17);
$export($export.S, 'Object', { is: __webpack_require__(1144) });


/***/ }),
/* 2746 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(99);
var $keys = __webpack_require__(235);

__webpack_require__(162)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 2747 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.15 Object.preventExtensions(O)
var isObject = __webpack_require__(53);
var meta = __webpack_require__(200).onFreeze;

__webpack_require__(162)('preventExtensions', function ($preventExtensions) {
  return function preventExtensions(it) {
    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
  };
});


/***/ }),
/* 2748 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.17 Object.seal(O)
var isObject = __webpack_require__(53);
var meta = __webpack_require__(200).onFreeze;

__webpack_require__(162)('seal', function ($seal) {
  return function seal(it) {
    return $seal && isObject(it) ? $seal(meta(it)) : it;
  };
});


/***/ }),
/* 2749 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(17);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(631).set });


/***/ }),
/* 2750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(331);
var test = {};
test[__webpack_require__(67)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(119)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 2751 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(17);
var $parseFloat = __webpack_require__(1141);
// 18.2.4 parseFloat(string)
$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ }),
/* 2752 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(17);
var $parseInt = __webpack_require__(1142);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 2753 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
var $export = __webpack_require__(17);
var aFunction = __webpack_require__(158);
var anObject = __webpack_require__(50);
var rApply = (__webpack_require__(52).Reflect || {}).apply;
var fApply = Function.apply;
// MS Edge argumentsList argument is optional
$export($export.S + $export.F * !__webpack_require__(51)(function () {
  rApply(function () { /* empty */ });
}), 'Reflect', {
  apply: function apply(target, thisArgument, argumentsList) {
    var T = aFunction(target);
    var L = anObject(argumentsList);
    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
  }
});


/***/ }),
/* 2754 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
var $export = __webpack_require__(17);
var create = __webpack_require__(232);
var aFunction = __webpack_require__(158);
var anObject = __webpack_require__(50);
var isObject = __webpack_require__(53);
var fails = __webpack_require__(51);
var bind = __webpack_require__(1124);
var rConstruct = (__webpack_require__(52).Reflect || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
var NEW_TARGET_BUG = fails(function () {
  function F() { /* empty */ }
  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
});
var ARGS_BUG = !fails(function () {
  rConstruct(function () { /* empty */ });
});

$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
  construct: function construct(Target, args /* , newTarget */) {
    aFunction(Target);
    anObject(args);
    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
    if (Target == newTarget) {
      // w/o altered newTarget, optimization for 0-4 arguments
      switch (args.length) {
        case 0: return new Target();
        case 1: return new Target(args[0]);
        case 2: return new Target(args[0], args[1]);
        case 3: return new Target(args[0], args[1], args[2]);
        case 4: return new Target(args[0], args[1], args[2], args[3]);
      }
      // w/o altered newTarget, lot of arguments case
      var $args = [null];
      $args.push.apply($args, args);
      return new (bind.apply(Target, $args))();
    }
    // with altered newTarget, not support built-in constructors
    var proto = newTarget.prototype;
    var instance = create(isObject(proto) ? proto : Object.prototype);
    var result = Function.apply.call(Target, instance, args);
    return isObject(result) ? result : instance;
  }
});


/***/ }),
/* 2755 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
var dP = __webpack_require__(83);
var $export = __webpack_require__(17);
var anObject = __webpack_require__(50);
var toPrimitive = __webpack_require__(201);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
$export($export.S + $export.F * __webpack_require__(51)(function () {
  // eslint-disable-next-line no-undef
  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
}), 'Reflect', {
  defineProperty: function defineProperty(target, propertyKey, attributes) {
    anObject(target);
    propertyKey = toPrimitive(propertyKey, true);
    anObject(attributes);
    try {
      dP.f(target, propertyKey, attributes);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 2756 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
var $export = __webpack_require__(17);
var gOPD = __webpack_require__(161).f;
var anObject = __webpack_require__(50);

$export($export.S, 'Reflect', {
  deleteProperty: function deleteProperty(target, propertyKey) {
    var desc = gOPD(anObject(target), propertyKey);
    return desc && !desc.configurable ? false : delete target[propertyKey];
  }
});


/***/ }),
/* 2757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 26.1.5 Reflect.enumerate(target)
var $export = __webpack_require__(17);
var anObject = __webpack_require__(50);
var Enumerate = function (iterated) {
  this._t = anObject(iterated); // target
  this._i = 0;                  // next index
  var keys = this._k = [];      // keys
  var key;
  for (key in iterated) keys.push(key);
};
__webpack_require__(1131)(Enumerate, 'Object', function () {
  var that = this;
  var keys = that._k;
  var key;
  do {
    if (that._i >= keys.length) return { value: undefined, done: true };
  } while (!((key = keys[that._i++]) in that._t));
  return { value: key, done: false };
});

$export($export.S, 'Reflect', {
  enumerate: function enumerate(target) {
    return new Enumerate(target);
  }
});


/***/ }),
/* 2758 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
var gOPD = __webpack_require__(161);
var $export = __webpack_require__(17);
var anObject = __webpack_require__(50);

$export($export.S, 'Reflect', {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
    return gOPD.f(anObject(target), propertyKey);
  }
});


/***/ }),
/* 2759 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.8 Reflect.getPrototypeOf(target)
var $export = __webpack_require__(17);
var getProto = __webpack_require__(234);
var anObject = __webpack_require__(50);

$export($export.S, 'Reflect', {
  getPrototypeOf: function getPrototypeOf(target) {
    return getProto(anObject(target));
  }
});


/***/ }),
/* 2760 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__(161);
var getPrototypeOf = __webpack_require__(234);
var has = __webpack_require__(130);
var $export = __webpack_require__(17);
var isObject = __webpack_require__(53);
var anObject = __webpack_require__(50);

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),
/* 2761 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.9 Reflect.has(target, propertyKey)
var $export = __webpack_require__(17);

$export($export.S, 'Reflect', {
  has: function has(target, propertyKey) {
    return propertyKey in target;
  }
});


/***/ }),
/* 2762 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.10 Reflect.isExtensible(target)
var $export = __webpack_require__(17);
var anObject = __webpack_require__(50);
var $isExtensible = Object.isExtensible;

$export($export.S, 'Reflect', {
  isExtensible: function isExtensible(target) {
    anObject(target);
    return $isExtensible ? $isExtensible(target) : true;
  }
});


/***/ }),
/* 2763 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.11 Reflect.ownKeys(target)
var $export = __webpack_require__(17);

$export($export.S, 'Reflect', { ownKeys: __webpack_require__(1140) });


/***/ }),
/* 2764 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.12 Reflect.preventExtensions(target)
var $export = __webpack_require__(17);
var anObject = __webpack_require__(50);
var $preventExtensions = Object.preventExtensions;

$export($export.S, 'Reflect', {
  preventExtensions: function preventExtensions(target) {
    anObject(target);
    try {
      if ($preventExtensions) $preventExtensions(target);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 2765 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
var $export = __webpack_require__(17);
var setProto = __webpack_require__(631);

if (setProto) $export($export.S, 'Reflect', {
  setPrototypeOf: function setPrototypeOf(target, proto) {
    setProto.check(target, proto);
    try {
      setProto.set(target, proto);
      return true;
    } catch (e) {
      return false;
    }
  }
});


/***/ }),
/* 2766 */
/***/ (function(module, exports, __webpack_require__) {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
var dP = __webpack_require__(83);
var gOPD = __webpack_require__(161);
var getPrototypeOf = __webpack_require__(234);
var has = __webpack_require__(130);
var $export = __webpack_require__(17);
var createDesc = __webpack_require__(236);
var anObject = __webpack_require__(50);
var isObject = __webpack_require__(53);

function set(target, propertyKey, V /* , receiver */) {
  var receiver = arguments.length < 4 ? target : arguments[3];
  var ownDesc = gOPD.f(anObject(target), propertyKey);
  var existingDescriptor, proto;
  if (!ownDesc) {
    if (isObject(proto = getPrototypeOf(target))) {
      return set(proto, propertyKey, V, receiver);
    }
    ownDesc = createDesc(0);
  }
  if (has(ownDesc, 'value')) {
    if (ownDesc.writable === false || !isObject(receiver)) return false;
    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
      existingDescriptor.value = V;
      dP.f(receiver, propertyKey, existingDescriptor);
    } else dP.f(receiver, propertyKey, createDesc(0, V));
    return true;
  }
  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
}

$export($export.S, 'Reflect', { set: set });


/***/ }),
/* 2767 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(52);
var inheritIfRequired = __webpack_require__(624);
var dP = __webpack_require__(83).f;
var gOPN = __webpack_require__(233).f;
var isRegExp = __webpack_require__(626);
var $flags = __webpack_require__(415);
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__(82) && (!CORRECT_NEW || __webpack_require__(51)(function () {
  re2[__webpack_require__(67)('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__(119)(global, 'RegExp', $RegExp);
}

__webpack_require__(279)('RegExp');


/***/ }),
/* 2768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(50);
var toLength = __webpack_require__(73);
var advanceStringIndex = __webpack_require__(617);
var regExpExec = __webpack_require__(420);

// @@match logic
__webpack_require__(414)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),
/* 2769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(50);
var toObject = __webpack_require__(99);
var toLength = __webpack_require__(73);
var toInteger = __webpack_require__(163);
var advanceStringIndex = __webpack_require__(617);
var regExpExec = __webpack_require__(420);
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__(414)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),
/* 2770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__(50);
var sameValue = __webpack_require__(1144);
var regExpExec = __webpack_require__(420);

// @@search logic
__webpack_require__(414)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[SEARCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
    function (regexp) {
      var res = maybeCallNative($search, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),
/* 2771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__(626);
var anObject = __webpack_require__(50);
var speciesConstructor = __webpack_require__(334);
var advanceStringIndex = __webpack_require__(617);
var toLength = __webpack_require__(73);
var callRegExpExec = __webpack_require__(420);
var regexpExec = __webpack_require__(630);
var fails = __webpack_require__(51);
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__(414)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),
/* 2772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(1150);
var anObject = __webpack_require__(50);
var $flags = __webpack_require__(415);
var DESCRIPTORS = __webpack_require__(82);
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__(119)(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__(51)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),
/* 2773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(1125);
var validate = __webpack_require__(239);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(413)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 2774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.2 String.prototype.anchor(name)
__webpack_require__(120)('anchor', function (createHTML) {
  return function anchor(name) {
    return createHTML(this, 'a', 'name', name);
  };
});


/***/ }),
/* 2775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.3 String.prototype.big()
__webpack_require__(120)('big', function (createHTML) {
  return function big() {
    return createHTML(this, 'big', '', '');
  };
});


/***/ }),
/* 2776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.4 String.prototype.blink()
__webpack_require__(120)('blink', function (createHTML) {
  return function blink() {
    return createHTML(this, 'blink', '', '');
  };
});


/***/ }),
/* 2777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.5 String.prototype.bold()
__webpack_require__(120)('bold', function (createHTML) {
  return function bold() {
    return createHTML(this, 'b', '', '');
  };
});


/***/ }),
/* 2778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(17);
var $at = __webpack_require__(633)(false);
$export($export.P, 'String', {
  // 21.1.3.3 String.prototype.codePointAt(pos)
  codePointAt: function codePointAt(pos) {
    return $at(this, pos);
  }
});


/***/ }),
/* 2779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

var $export = __webpack_require__(17);
var toLength = __webpack_require__(73);
var context = __webpack_require__(634);
var ENDS_WITH = 'endsWith';
var $endsWith = ''[ENDS_WITH];

$export($export.P + $export.F * __webpack_require__(622)(ENDS_WITH), 'String', {
  endsWith: function endsWith(searchString /* , endPosition = @length */) {
    var that = context(this, searchString, ENDS_WITH);
    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
    var len = toLength(that.length);
    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
    var search = String(searchString);
    return $endsWith
      ? $endsWith.call(that, search, end)
      : that.slice(end - search.length, end) === search;
  }
});


/***/ }),
/* 2780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.6 String.prototype.fixed()
__webpack_require__(120)('fixed', function (createHTML) {
  return function fixed() {
    return createHTML(this, 'tt', '', '');
  };
});


/***/ }),
/* 2781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.7 String.prototype.fontcolor(color)
__webpack_require__(120)('fontcolor', function (createHTML) {
  return function fontcolor(color) {
    return createHTML(this, 'font', 'color', color);
  };
});


/***/ }),
/* 2782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.8 String.prototype.fontsize(size)
__webpack_require__(120)('fontsize', function (createHTML) {
  return function fontsize(size) {
    return createHTML(this, 'font', 'size', size);
  };
});


/***/ }),
/* 2783 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(17);
var toAbsoluteIndex = __webpack_require__(237);
var fromCharCode = String.fromCharCode;
var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
  // 21.1.2.2 String.fromCodePoint(...codePoints)
  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
    var res = [];
    var aLen = arguments.length;
    var i = 0;
    var code;
    while (aLen > i) {
      code = +arguments[i++];
      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
      res.push(code < 0x10000
        ? fromCharCode(code)
        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
      );
    } return res.join('');
  }
});


/***/ }),
/* 2784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__(17);
var context = __webpack_require__(634);
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__(622)(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),
/* 2785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.9 String.prototype.italics()
__webpack_require__(120)('italics', function (createHTML) {
  return function italics() {
    return createHTML(this, 'i', '', '');
  };
});


/***/ }),
/* 2786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(633)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(627)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 2787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.10 String.prototype.link(url)
__webpack_require__(120)('link', function (createHTML) {
  return function link(url) {
    return createHTML(this, 'a', 'href', url);
  };
});


/***/ }),
/* 2788 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(17);
var toIObject = __webpack_require__(132);
var toLength = __webpack_require__(73);

$export($export.S, 'String', {
  // 21.1.2.4 String.raw(callSite, ...substitutions)
  raw: function raw(callSite) {
    var tpl = toIObject(callSite.raw);
    var len = toLength(tpl.length);
    var aLen = arguments.length;
    var res = [];
    var i = 0;
    while (len > i) {
      res.push(String(tpl[i++]));
      if (i < aLen) res.push(String(arguments[i]));
    } return res.join('');
  }
});


/***/ }),
/* 2789 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(17);

$export($export.P, 'String', {
  // 21.1.3.13 String.prototype.repeat(count)
  repeat: __webpack_require__(635)
});


/***/ }),
/* 2790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.11 String.prototype.small()
__webpack_require__(120)('small', function (createHTML) {
  return function small() {
    return createHTML(this, 'small', '', '');
  };
});


/***/ }),
/* 2791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__(17);
var toLength = __webpack_require__(73);
var context = __webpack_require__(634);
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__(622)(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),
/* 2792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.12 String.prototype.strike()
__webpack_require__(120)('strike', function (createHTML) {
  return function strike() {
    return createHTML(this, 'strike', '', '');
  };
});


/***/ }),
/* 2793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.13 String.prototype.sub()
__webpack_require__(120)('sub', function (createHTML) {
  return function sub() {
    return createHTML(this, 'sub', '', '');
  };
});


/***/ }),
/* 2794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// B.2.3.14 String.prototype.sup()
__webpack_require__(120)('sup', function (createHTML) {
  return function sup() {
    return createHTML(this, 'sup', '', '');
  };
});


/***/ }),
/* 2795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.1.3.25 String.prototype.trim()
__webpack_require__(281)('trim', function ($trim) {
  return function trim() {
    return $trim(this, 3);
  };
});


/***/ }),
/* 2796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(52);
var has = __webpack_require__(130);
var DESCRIPTORS = __webpack_require__(82);
var $export = __webpack_require__(17);
var redefine = __webpack_require__(119);
var META = __webpack_require__(200).KEY;
var $fails = __webpack_require__(51);
var shared = __webpack_require__(421);
var setToStringTag = __webpack_require__(280);
var uid = __webpack_require__(238);
var wks = __webpack_require__(67);
var wksExt = __webpack_require__(639);
var wksDefine = __webpack_require__(1147);
var enumKeys = __webpack_require__(2670);
var isArray = __webpack_require__(417);
var anObject = __webpack_require__(50);
var isObject = __webpack_require__(53);
var toObject = __webpack_require__(99);
var toIObject = __webpack_require__(132);
var toPrimitive = __webpack_require__(201);
var createDesc = __webpack_require__(236);
var _create = __webpack_require__(232);
var gOPNExt = __webpack_require__(1137);
var $GOPD = __webpack_require__(161);
var $GOPS = __webpack_require__(419);
var $DP = __webpack_require__(83);
var $keys = __webpack_require__(235);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(233).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(333).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(231)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(131)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 2797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $export = __webpack_require__(17);
var $typed = __webpack_require__(422);
var buffer = __webpack_require__(638);
var anObject = __webpack_require__(50);
var toAbsoluteIndex = __webpack_require__(237);
var toLength = __webpack_require__(73);
var isObject = __webpack_require__(53);
var ArrayBuffer = __webpack_require__(52).ArrayBuffer;
var speciesConstructor = __webpack_require__(334);
var $ArrayBuffer = buffer.ArrayBuffer;
var $DataView = buffer.DataView;
var $isView = $typed.ABV && ArrayBuffer.isView;
var $slice = $ArrayBuffer.prototype.slice;
var VIEW = $typed.VIEW;
var ARRAY_BUFFER = 'ArrayBuffer';

$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
  // 24.1.3.1 ArrayBuffer.isView(arg)
  isView: function isView(it) {
    return $isView && $isView(it) || isObject(it) && VIEW in it;
  }
});

$export($export.P + $export.U + $export.F * __webpack_require__(51)(function () {
  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
}), ARRAY_BUFFER, {
  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
  slice: function slice(start, end) {
    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
    var len = anObject(this).byteLength;
    var first = toAbsoluteIndex(start, len);
    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
    var viewS = new $DataView(this);
    var viewT = new $DataView(result);
    var index = 0;
    while (first < fin) {
      viewT.setUint8(index++, viewS.getUint8(first++));
    } return result;
  }
});

__webpack_require__(279)(ARRAY_BUFFER);


/***/ }),
/* 2798 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(17);
$export($export.G + $export.W + $export.F * !__webpack_require__(422).ABV, {
  DataView: __webpack_require__(638).DataView
});


/***/ }),
/* 2799 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Float32', 4, function (init) {
  return function Float32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2800 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Float64', 8, function (init) {
  return function Float64Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2801 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Int16', 2, function (init) {
  return function Int16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2802 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Int32', 4, function (init) {
  return function Int32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2803 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Int8', 1, function (init) {
  return function Int8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2804 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Uint16', 2, function (init) {
  return function Uint16Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2805 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Uint32', 4, function (init) {
  return function Uint32Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2806 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Uint8', 1, function (init) {
  return function Uint8Array(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
});


/***/ }),
/* 2807 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(180)('Uint8', 1, function (init) {
  return function Uint8ClampedArray(data, byteOffset, length) {
    return init(this, data, byteOffset, length);
  };
}, true);


/***/ }),
/* 2808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(52);
var each = __webpack_require__(159)(0);
var redefine = __webpack_require__(119);
var meta = __webpack_require__(200);
var assign = __webpack_require__(1135);
var weak = __webpack_require__(1126);
var isObject = __webpack_require__(53);
var validate = __webpack_require__(239);
var NATIVE_WEAK_MAP = __webpack_require__(239);
var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
var WEAK_MAP = 'WeakMap';
var getWeak = meta.getWeak;
var isExtensible = Object.isExtensible;
var uncaughtFrozenStore = weak.ufstore;
var InternalMap;

var wrapper = function (get) {
  return function WeakMap() {
    return get(this, arguments.length > 0 ? arguments[0] : undefined);
  };
};

var methods = {
  // 23.3.3.3 WeakMap.prototype.get(key)
  get: function get(key) {
    if (isObject(key)) {
      var data = getWeak(key);
      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
      return data ? data[this._i] : undefined;
    }
  },
  // 23.3.3.5 WeakMap.prototype.set(key, value)
  set: function set(key, value) {
    return weak.def(validate(this, WEAK_MAP), key, value);
  }
};

// 23.3 WeakMap Objects
var $WeakMap = module.exports = __webpack_require__(413)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
if (NATIVE_WEAK_MAP && IS_IE11) {
  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
  assign(InternalMap.prototype, methods);
  meta.NEED = true;
  each(['delete', 'has', 'get', 'set'], function (key) {
    var proto = $WeakMap.prototype;
    var method = proto[key];
    redefine(proto, key, function (a, b) {
      // store frozen objects on internal weakmap shim
      if (isObject(a) && !isExtensible(a)) {
        if (!this._f) this._f = new InternalMap();
        var result = this._f[key](a, b);
        return key == 'set' ? this : result;
      // store all the rest on native weakmap
      } return method.call(this, a, b);
    });
  });
}


/***/ }),
/* 2809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var weak = __webpack_require__(1126);
var validate = __webpack_require__(239);
var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
__webpack_require__(413)(WEAK_SET, function (get) {
  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.4.3.1 WeakSet.prototype.add(value)
  add: function add(value) {
    return weak.def(validate(this, WEAK_SET), value, true);
  }
}, weak, false, true);


/***/ }),
/* 2810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
var $export = __webpack_require__(17);
var flattenIntoArray = __webpack_require__(2671);
var toObject = __webpack_require__(99);
var toLength = __webpack_require__(73);
var aFunction = __webpack_require__(158);
var arraySpeciesCreate = __webpack_require__(1123);

$export($export.P, 'Array', {
  flatMap: function flatMap(callbackfn /* , thisArg */) {
    var O = toObject(this);
    var sourceLen, A;
    aFunction(callbackfn);
    sourceLen = toLength(O.length);
    A = arraySpeciesCreate(O, 0);
    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
    return A;
  }
});

__webpack_require__(230)('flatMap');


/***/ }),
/* 2811 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__(17);
var $includes = __webpack_require__(412)(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__(230)('includes');


/***/ }),
/* 2812 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(17);
var $entries = __webpack_require__(1139)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 2813 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
var $export = __webpack_require__(17);
var ownKeys = __webpack_require__(1140);
var toIObject = __webpack_require__(132);
var gOPD = __webpack_require__(161);
var createProperty = __webpack_require__(619);

$export($export.S, 'Object', {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIObject(object);
    var getDesc = gOPD.f;
    var keys = ownKeys(O);
    var result = {};
    var i = 0;
    var key, desc;
    while (keys.length > i) {
      desc = getDesc(O, key = keys[i++]);
      if (desc !== undefined) createProperty(result, key, desc);
    }
    return result;
  }
});


/***/ }),
/* 2814 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(17);
var $values = __webpack_require__(1139)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 2815 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(17);
var core = __webpack_require__(78);
var global = __webpack_require__(52);
var speciesConstructor = __webpack_require__(334);
var promiseResolve = __webpack_require__(1143);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 2816 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(17);
var $pad = __webpack_require__(1145);
var userAgent = __webpack_require__(423);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
  }
});


/***/ }),
/* 2817 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-string-pad-start-end
var $export = __webpack_require__(17);
var $pad = __webpack_require__(1145);
var userAgent = __webpack_require__(423);

// https://github.com/zloirock/core-js/issues/280
var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

$export($export.P + $export.F * WEBKIT_BUG, 'String', {
  padStart: function padStart(maxLength /* , fillString = ' ' */) {
    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
  }
});


/***/ }),
/* 2818 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(281)('trimLeft', function ($trim) {
  return function trimLeft() {
    return $trim(this, 1);
  };
}, 'trimStart');


/***/ }),
/* 2819 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
__webpack_require__(281)('trimRight', function ($trim) {
  return function trimRight() {
    return $trim(this, 2);
  };
}, 'trimEnd');


/***/ }),
/* 2820 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1147)('asyncIterator');


/***/ }),
/* 2821 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(641);
var getKeys = __webpack_require__(235);
var redefine = __webpack_require__(119);
var global = __webpack_require__(52);
var hide = __webpack_require__(131);
var Iterators = __webpack_require__(277);
var wks = __webpack_require__(67);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 2822 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(17);
var $task = __webpack_require__(637);
$export($export.G + $export.B, {
  setImmediate: $task.set,
  clearImmediate: $task.clear
});


/***/ }),
/* 2823 */
/***/ (function(module, exports, __webpack_require__) {

// ie9- setTimeout & setInterval additional parameters fix
var global = __webpack_require__(52);
var $export = __webpack_require__(17);
var userAgent = __webpack_require__(423);
var slice = [].slice;
var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
var wrap = function (set) {
  return function (fn, time /* , ...args */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : false;
    return set(boundArgs ? function () {
      // eslint-disable-next-line no-new-func
      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
    } : fn, time);
  };
};
$export($export.G + $export.B + $export.F * MSIE, {
  setTimeout: wrap(global.setTimeout),
  setInterval: wrap(global.setInterval)
});


/***/ }),
/* 2824 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(2823);
__webpack_require__(2822);
__webpack_require__(2821);
module.exports = __webpack_require__(78);


/***/ }),
/* 2825 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(a,n){ true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=n(require,exports,module):a.CountUp=n()}(this,function(a,n,t){var e=function(a,n,t,e,i,r){function o(a){var n,t,e,i,r,o,s=a<0;if(a=Math.abs(a).toFixed(l.decimals),a+="",n=a.split("."),t=n[0],e=n.length>1?l.options.decimal+n[1]:"",l.options.useGrouping){for(i="",r=0,o=t.length;r<o;++r)0!==r&&r%3===0&&(i=l.options.separator+i),i=t[o-r-1]+i;t=i}return l.options.numerals.length&&(t=t.replace(/[0-9]/g,function(a){return l.options.numerals[+a]}),e=e.replace(/[0-9]/g,function(a){return l.options.numerals[+a]})),(s?"-":"")+l.options.prefix+t+e+l.options.suffix}function s(a,n,t,e){return t*(-Math.pow(2,-10*a/e)+1)*1024/1023+n}function u(a){return"number"==typeof a&&!isNaN(a)}var l=this;if(l.version=function(){return"1.9.3"},l.options={useEasing:!0,useGrouping:!0,separator:",",decimal:".",easingFn:s,formattingFn:o,prefix:"",suffix:"",numerals:[]},r&&"object"==typeof r)for(var m in l.options)r.hasOwnProperty(m)&&null!==r[m]&&(l.options[m]=r[m]);""===l.options.separator?l.options.useGrouping=!1:l.options.separator=""+l.options.separator;for(var d=0,c=["webkit","moz","ms","o"],f=0;f<c.length&&!window.requestAnimationFrame;++f)window.requestAnimationFrame=window[c[f]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[c[f]+"CancelAnimationFrame"]||window[c[f]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(a,n){var t=(new Date).getTime(),e=Math.max(0,16-(t-d)),i=window.setTimeout(function(){a(t+e)},e);return d=t+e,i}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(a){clearTimeout(a)}),l.initialize=function(){return!!l.initialized||(l.error="",l.d="string"==typeof a?document.getElementById(a):a,l.d?(l.startVal=Number(n),l.endVal=Number(t),u(l.startVal)&&u(l.endVal)?(l.decimals=Math.max(0,e||0),l.dec=Math.pow(10,l.decimals),l.duration=1e3*Number(i)||2e3,l.countDown=l.startVal>l.endVal,l.frameVal=l.startVal,l.initialized=!0,!0):(l.error="[CountUp] startVal ("+n+") or endVal ("+t+") is not a number",!1)):(l.error="[CountUp] target is null or undefined",!1))},l.printValue=function(a){var n=l.options.formattingFn(a);"INPUT"===l.d.tagName?this.d.value=n:"text"===l.d.tagName||"tspan"===l.d.tagName?this.d.textContent=n:this.d.innerHTML=n},l.count=function(a){l.startTime||(l.startTime=a),l.timestamp=a;var n=a-l.startTime;l.remaining=l.duration-n,l.options.useEasing?l.countDown?l.frameVal=l.startVal-l.options.easingFn(n,0,l.startVal-l.endVal,l.duration):l.frameVal=l.options.easingFn(n,l.startVal,l.endVal-l.startVal,l.duration):l.countDown?l.frameVal=l.startVal-(l.startVal-l.endVal)*(n/l.duration):l.frameVal=l.startVal+(l.endVal-l.startVal)*(n/l.duration),l.countDown?l.frameVal=l.frameVal<l.endVal?l.endVal:l.frameVal:l.frameVal=l.frameVal>l.endVal?l.endVal:l.frameVal,l.frameVal=Math.round(l.frameVal*l.dec)/l.dec,l.printValue(l.frameVal),n<l.duration?l.rAF=requestAnimationFrame(l.count):l.callback&&l.callback()},l.start=function(a){l.initialize()&&(l.callback=a,l.rAF=requestAnimationFrame(l.count))},l.pauseResume=function(){l.paused?(l.paused=!1,delete l.startTime,l.duration=l.remaining,l.startVal=l.frameVal,requestAnimationFrame(l.count)):(l.paused=!0,cancelAnimationFrame(l.rAF))},l.reset=function(){l.paused=!1,delete l.startTime,l.initialized=!1,l.initialize()&&(cancelAnimationFrame(l.rAF),l.printValue(l.startVal))},l.update=function(a){if(l.initialize()){if(a=Number(a),!u(a))return void(l.error="[CountUp] update() - new endVal is not a number: "+a);l.error="",a!==l.frameVal&&(cancelAnimationFrame(l.rAF),l.paused=!1,delete l.startTime,l.startVal=l.frameVal,l.endVal=a,l.countDown=l.startVal>l.endVal,l.rAF=requestAnimationFrame(l.count))}},l.initialize()&&l.printValue(l.startVal)};return e});

/***/ }),
/* 2826 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var elliptic = __webpack_require__(653)
var BN = __webpack_require__(77)

module.exports = function createECDH (curve) {
  return new ECDH(curve)
}

var aliases = {
  secp256k1: {
    name: 'secp256k1',
    byteLength: 32
  },
  secp224r1: {
    name: 'p224',
    byteLength: 28
  },
  prime256v1: {
    name: 'p256',
    byteLength: 32
  },
  prime192v1: {
    name: 'p192',
    byteLength: 24
  },
  ed25519: {
    name: 'ed25519',
    byteLength: 32
  },
  secp384r1: {
    name: 'p384',
    byteLength: 48
  },
  secp521r1: {
    name: 'p521',
    byteLength: 66
  }
}

aliases.p224 = aliases.secp224r1
aliases.p256 = aliases.secp256r1 = aliases.prime256v1
aliases.p192 = aliases.secp192r1 = aliases.prime192v1
aliases.p384 = aliases.secp384r1
aliases.p521 = aliases.secp521r1

function ECDH (curve) {
  this.curveType = aliases[curve]
  if (!this.curveType) {
    this.curveType = {
      name: curve
    }
  }
  this.curve = new elliptic.ec(this.curveType.name) // eslint-disable-line new-cap
  this.keys = void 0
}

ECDH.prototype.generateKeys = function (enc, format) {
  this.keys = this.curve.genKeyPair()
  return this.getPublicKey(enc, format)
}

ECDH.prototype.computeSecret = function (other, inenc, enc) {
  inenc = inenc || 'utf8'
  if (!Buffer.isBuffer(other)) {
    other = new Buffer(other, inenc)
  }
  var otherPub = this.curve.keyFromPublic(other).getPublic()
  var out = otherPub.mul(this.keys.getPrivate()).getX()
  return formatReturnValue(out, enc, this.curveType.byteLength)
}

ECDH.prototype.getPublicKey = function (enc, format) {
  var key = this.keys.getPublic(format === 'compressed', true)
  if (format === 'hybrid') {
    if (key[key.length - 1] % 2) {
      key[0] = 7
    } else {
      key[0] = 6
    }
  }
  return formatReturnValue(key, enc)
}

ECDH.prototype.getPrivateKey = function (enc) {
  return formatReturnValue(this.keys.getPrivate(), enc)
}

ECDH.prototype.setPublicKey = function (pub, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc)
  }
  this.keys._importPublic(pub)
  return this
}

ECDH.prototype.setPrivateKey = function (priv, enc) {
  enc = enc || 'utf8'
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc)
  }

  var _priv = new BN(priv)
  _priv = _priv.toString(16)
  this.keys = this.curve.genKeyPair()
  this.keys._importPrivate(_priv)
  return this
}

function formatReturnValue (bn, enc, len) {
  if (!Array.isArray(bn)) {
    bn = bn.toArray()
  }
  var buf = new Buffer(bn)
  if (len && buf.length < len) {
    var zeros = new Buffer(len - buf.length)
    zeros.fill(0)
    buf = Buffer.concat([zeros, buf])
  }
  if (!enc) {
    return buf
  } else {
    return buf.toString(enc)
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75).Buffer))

/***/ }),
/* 2827 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var inherits = __webpack_require__(41)
var Buffer = __webpack_require__(42).Buffer

var Base = __webpack_require__(198)

var ZEROS = Buffer.alloc(128)
var blocksize = 64

function Hmac (alg, key) {
  Base.call(this, 'digest')
  if (typeof key === 'string') {
    key = Buffer.from(key)
  }

  this._alg = alg
  this._key = key

  if (key.length > blocksize) {
    key = alg(key)
  } else if (key.length < blocksize) {
    key = Buffer.concat([key, ZEROS], blocksize)
  }

  var ipad = this._ipad = Buffer.allocUnsafe(blocksize)
  var opad = this._opad = Buffer.allocUnsafe(blocksize)

  for (var i = 0; i < blocksize; i++) {
    ipad[i] = key[i] ^ 0x36
    opad[i] = key[i] ^ 0x5C
  }

  this._hash = [ipad]
}

inherits(Hmac, Base)

Hmac.prototype._update = function (data) {
  this._hash.push(data)
}

Hmac.prototype._final = function () {
  var h = this._alg(Buffer.concat(this._hash))
  return this._alg(Buffer.concat([this._opad, h]))
}
module.exports = Hmac


/***/ }),
/* 2828 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(121);

var emptyObject = __webpack_require__(2962);
var _invariant = __webpack_require__(2963);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 2829 */
/***/ (function(module, exports) {

var global = typeof self !== 'undefined' ? self : this;
var __self__ = (function () {
function F() {
this.fetch = false;
this.DOMException = global.DOMException
}
F.prototype = global;
return new F();
})();
(function(self) {

var irrelevant = (function (exports) {

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function() {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function(obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift();
        return {done: value === undefined, value: value}
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {};

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value);
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1]);
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name]);
      }, this);
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function(name) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function() {
    var items = [];
    this.forEach(function(value) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function() {
    var items = [];
    this.forEach(function(value, name) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true;
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result);
      };
      reader.onerror = function() {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]);
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false;

    this._initBody = function(body) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this);
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      };

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      };
    }

    this.text = function() {
      var rejected = consumed(this);
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    };

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      };
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    };

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input, options) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url;
      this.credentials = input.credentials;
      if (!options.headers) {
        this.headers = new Headers(input.headers);
      }
      this.method = input.method;
      this.mode = input.mode;
      this.signal = input.signal;
      if (!body && input._bodyInit != null) {
        body = input._bodyInit;
        input.bodyUsed = true;
      }
    } else {
      this.url = String(input);
    }

    this.credentials = options.credentials || this.credentials || 'same-origin';
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers);
    }
    this.method = normalizeMethod(options.method || this.method || 'GET');
    this.mode = options.mode || this.mode || null;
    this.signal = options.signal || this.signal;
    this.referrer = null;

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body);
  }

  Request.prototype.clone = function() {
    return new Request(this, {body: this._bodyInit})
  };

  function decode(body) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function(bytes) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit, options) {
    if (!options) {
      options = {};
    }

    this.type = 'default';
    this.status = options.status === undefined ? 200 : options.status;
    this.ok = this.status >= 200 && this.status < 300;
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    this.headers = new Headers(options.headers);
    this.url = options.url || '';
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''});
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  };

  exports.DOMException = self.DOMException;
  try {
    new exports.DOMException();
  } catch (err) {
    exports.DOMException = function(message, name) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    exports.DOMException.prototype = Object.create(Error.prototype);
    exports.DOMException.prototype.constructor = exports.DOMException;
  }

  function fetch(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new exports.DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : xhr.responseText;
        resolve(new Response(body, options));
      };

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function() {
        reject(new exports.DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function() {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    self.fetch = fetch;
    self.Headers = Headers;
    self.Request = Request;
    self.Response = Response;
  }

  exports.Headers = Headers;
  exports.Request = Request;
  exports.Response = Response;
  exports.fetch = fetch;

  Object.defineProperty(exports, '__esModule', { value: true });

  return exports;

})({});
})(__self__);
__self__.fetch.ponyfill = true;
// Remove "polyfill" property added by whatwg-fetch
delete __self__.fetch.polyfill;
// Choose between native implementation (global) or custom implementation (__self__)
// var ctx = global.fetch ? global : __self__;
var ctx = __self__; // this line disable service worker support temporarily
exports = ctx.fetch // To enable: import fetch from 'cross-fetch'
exports.default = ctx.fetch // For TypeScript consumers without esModuleInterop.
exports.fetch = ctx.fetch // To enable: import {fetch} from 'cross-fetch'
exports.Headers = ctx.Headers
exports.Request = ctx.Request
exports.Response = ctx.Response
module.exports = exports


/***/ }),
/* 2830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.randomBytes = exports.rng = exports.pseudoRandomBytes = exports.prng = __webpack_require__(286)
exports.createHash = exports.Hash = __webpack_require__(336)
exports.createHmac = exports.Hmac = __webpack_require__(1152)

var algos = __webpack_require__(2612)
var algoKeys = Object.keys(algos)
var hashes = ['sha1', 'sha224', 'sha256', 'sha384', 'sha512', 'md5', 'rmd160'].concat(algoKeys)
exports.getHashes = function () {
  return hashes
}

var p = __webpack_require__(1388)
exports.pbkdf2 = p.pbkdf2
exports.pbkdf2Sync = p.pbkdf2Sync

var aes = __webpack_require__(2609)

exports.Cipher = aes.Cipher
exports.createCipher = aes.createCipher
exports.Cipheriv = aes.Cipheriv
exports.createCipheriv = aes.createCipheriv
exports.Decipher = aes.Decipher
exports.createDecipher = aes.createDecipher
exports.Decipheriv = aes.Decipheriv
exports.createDecipheriv = aes.createDecipheriv
exports.getCiphers = aes.getCiphers
exports.listCiphers = aes.listCiphers

var dh = __webpack_require__(2845)

exports.DiffieHellmanGroup = dh.DiffieHellmanGroup
exports.createDiffieHellmanGroup = dh.createDiffieHellmanGroup
exports.getDiffieHellman = dh.getDiffieHellman
exports.createDiffieHellman = dh.createDiffieHellman
exports.DiffieHellman = dh.DiffieHellman

var sign = __webpack_require__(2613)

exports.createSign = sign.createSign
exports.Sign = sign.Sign
exports.createVerify = sign.createVerify
exports.Verify = sign.Verify

exports.createECDH = __webpack_require__(2826)

var publicEncrypt = __webpack_require__(3126)

exports.publicEncrypt = publicEncrypt.publicEncrypt
exports.privateEncrypt = publicEncrypt.privateEncrypt
exports.publicDecrypt = publicEncrypt.publicDecrypt
exports.privateDecrypt = publicEncrypt.privateDecrypt

// the least I can do is make error messages for the rest of the node.js/crypto api.
// ;[
//   'createCredentials'
// ].forEach(function (name) {
//   exports[name] = function () {
//     throw new Error([
//       'sorry, ' + name + ' is not implemented yet',
//       'we accept pull requests',
//       'https://github.com/crypto-browserify/crypto-browserify'
//     ].join('\n'))
//   }
// })

var rf = __webpack_require__(3136)

exports.randomFill = rf.randomFill
exports.randomFillSync = rf.randomFillSync

exports.createCredentials = function () {
  throw new Error([
    'sorry, createCredentials is not implemented yet',
    'we accept pull requests',
    'https://github.com/crypto-browserify/crypto-browserify'
  ].join('\n'))
}

exports.constants = {
  'DH_CHECK_P_NOT_SAFE_PRIME': 2,
  'DH_CHECK_P_NOT_PRIME': 1,
  'DH_UNABLE_TO_CHECK_GENERATOR': 4,
  'DH_NOT_SUITABLE_GENERATOR': 8,
  'NPN_ENABLED': 1,
  'ALPN_ENABLED': 1,
  'RSA_PKCS1_PADDING': 1,
  'RSA_SSLV23_PADDING': 2,
  'RSA_NO_PADDING': 3,
  'RSA_PKCS1_OAEP_PADDING': 4,
  'RSA_X931_PADDING': 5,
  'RSA_PKCS1_PSS_PADDING': 6,
  'POINT_CONVERSION_COMPRESSED': 2,
  'POINT_CONVERSION_UNCOMPRESSED': 4,
  'POINT_CONVERSION_HYBRID': 6
}


/***/ }),
/* 2831 */
/***/ (function(module, exports, __webpack_require__) {

;(function (root, factory) {
	if (true) {
		// CommonJS
		module.exports = exports = factory(__webpack_require__(240));
	}
	else if (typeof define === "function" && define.amd) {
		// AMD
		define(["./core"], factory);
	}
	else {
		// Global (browser)
		factory(root.CryptoJS);
	}
}(this, function (CryptoJS) {

	(function () {
	    // Shortcuts
	    var C = CryptoJS;
	    var C_lib = C.lib;
	    var Base = C_lib.Base;
	    var C_enc = C.enc;
	    var Utf8 = C_enc.Utf8;
	    var C_algo = C.algo;

	    /**
	     * HMAC algorithm.
	     */
	    var HMAC = C_algo.HMAC = Base.extend({
	        /**
	         * Initializes a newly created HMAC.
	         *
	         * @param {Hasher} hasher The hash algorithm to use.
	         * @param {WordArray|string} key The secret key.
	         *
	         * @example
	         *
	         *     var hmacHasher = CryptoJS.algo.HMAC.create(CryptoJS.algo.SHA256, key);
	         */
	        init: function (hasher, key) {
	            // Init hasher
	            hasher = this._hasher = new hasher.init();

	            // Convert string to WordArray, else assume WordArray already
	            if (typeof key == 'string') {
	                key = Utf8.parse(key);
	            }

	            // Shortcuts
	            var hasherBlockSize = hasher.blockSize;
	            var hasherBlockSizeBytes = hasherBlockSize * 4;

	            // Allow arbitrary length keys
	            if (key.sigBytes > hasherBlockSizeBytes) {
	                key = hasher.finalize(key);
	            }

	            // Clamp excess bits
	            key.clamp();

	            // Clone key for inner and outer pads
	            var oKey = this._oKey = key.clone();
	            var iKey = this._iKey = key.clone();

	            // Shortcuts
	            var oKeyWords = oKey.words;
	            var iKeyWords = iKey.words;

	            // XOR keys with pad constants
	            for (var i = 0; i < hasherBlockSize; i++) {
	                oKeyWords[i] ^= 0x5c5c5c5c;
	                iKeyWords[i] ^= 0x36363636;
	            }
	            oKey.sigBytes = iKey.sigBytes = hasherBlockSizeBytes;

	            // Set initial values
	            this.reset();
	        },

	        /**
	         * Resets this HMAC to its initial state.
	         *
	         * @example
	         *
	         *     hmacHasher.reset();
	         */
	        reset: function () {
	            // Shortcut
	            var hasher = this._hasher;

	            // Reset
	            hasher.reset();
	            hasher.update(this._iKey);
	        },

	        /**
	         * Updates this HMAC with a message.
	         *
	         * @param {WordArray|string} messageUpdate The message to append.
	         *
	         * @return {HMAC} This HMAC instance.
	         *
	         * @example
	         *
	         *     hmacHasher.update('message');
	         *     hmacHasher.update(wordArray);
	         */
	        update: function (messageUpdate) {
	            this._hasher.update(messageUpdate);

	            // Chainable
	            return this;
	        },

	        /**
	         * Finalizes the HMAC computation.
	         * Note that the finalize operation is effectively a destructive, read-once operation.
	         *
	         * @param {WordArray|string} messageUpdate (Optional) A final message update.
	         *
	         * @return {WordArray} The HMAC.
	         *
	         * @example
	         *
	         *     var hmac = hmacHasher.finalize();
	         *     var hmac = hmacHasher.finalize('message');
	         *     var hmac = hmacHasher.finalize(wordArray);
	         */
	        finalize: function (messageUpdate) {
	            // Shortcut
	            var hasher = this._hasher;

	            // Compute HMAC
	            var innerHash = hasher.finalize(messageUpdate);
	            hasher.reset();
	            var hmac = hasher.finalize(this._oKey.clone().concat(innerHash));

	            return hmac;
	        }
	    });
	}());


}));

/***/ }),
/* 2832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 2833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(2832);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(2618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["b"] = (cssAnimation);

/***/ }),
/* 2834 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(1156);
exports = module.exports = __webpack_require__(202)(false);
// imports


// module
exports.push([module.i, ".brands {\n  position: relative;\n  vertical-align: middle;\n  text-align: center;\n  display: inline-block;\n  width: 3em;\n  height: 3em;\n  font-size: 0.9em;\n  background-color: #ccc;\n  color: white;\n}\n.brands span {\n  top: 50%;\n  left: 50%;\n  -ms-transform: translate(-50%, -50%);\n      transform: translate(-50%, -50%);\n  position: absolute;\n  font-size: 0.8em;\n}\n.brands.round {\n  border-radius: 50%;\n}\n.brands.cim {\n  background-color: #663333;\n  color: white;\n}\n.brands.hlb {\n  background-color: #213f8d;\n  color: white;\n}\n.brands.mbb {\n  background-color: #ffc80a;\n  color: #000000;\n}\n.brands.ocb {\n  background-color: #e20b16;\n  color: white;\n}\n.brands.rhb {\n  background-color: #0077bd;\n  color: white;\n}\n.brands.uob {\n  background-color: #193272;\n  color: white;\n}\n.brands.amb {\n  background-color: #e20b16;\n  color: #fbff00;\n}\n.brands.alb {\n  border: 1px solid #d6e1e5;\n  background-color: white;\n  color: #00265e;\n}\n.brands.brt {\n  background-color: #0071bb;\n  color: white;\n}\n.brands.bsn {\n  background-color: #02a1b1;\n  color: white;\n}\n.brands.aff {\n  background-color: #3958a6;\n  color: white;\n}\n.brands.kfh {\n  background-color: #0a934e;\n  color: white;\n}\n.brands.bim {\n  border: 1px solid #d6e1e5;\n  background-color: white;\n  color: #cf1d49;\n}\n.brands.pbb {\n  border: 1px solid #d6e1e5;\n  background-color: white;\n  color: #ed1c23;\n}\n.brands.mbs {\n  background-color: #0056a3;\n  color: white;\n}\n.brands.scb {\n  background-color: #0072aa;\n  color: white;\n}\n.brands.arb {\n  background-color: #1b4098;\n  color: white;\n}\n.main-app .pushable {\n  overflow-x: initial !important;\n  -ms-transform: none;\n      transform: none;\n}\n.app-nav .ui.segment {\n  transform: translate3d(0px, 0px, 0px);\n  z-index: 1;\n  padding-top: 0;\n}\n@media only screen and (max-width: 767px) {\n  .app-nav .ui.container {\n    margin-left: auto !important;\n    margin-right: auto !important;\n  }\n}\n.app-nav.fixed {\n  padding-bottom: 3.9em;\n}\n.app-nav.fixed .ui.segment {\n  transition: all 0.3s;\n  top: 0;\n  left: 0;\n  right: auto;\n  bottom: auto;\n  position: fixed;\n  z-index: 101;\n  margin: 0;\n  width: 100%;\n  padding: 0.5em 0;\n  border-bottom: 1px solid white;\n}\n@media only screen and (max-width: 767px) {\n  .app-nav.fixed .ui.container {\n    margin-left: 1em !important;\n    margin-right: 1em !important;\n  }\n}\n.total {\n  background-color: #353B4D !important;\n}\n.total > .bar {\n  background-color: #353B4D !important;\n}\n.new,\n.hims-success,\n.available {\n  background-color: #9AE197 !important;\n}\n.new > .bar,\n.hims-success > .bar,\n.available > .bar {\n  background-color: #9AE197 !important;\n}\n.reserved,\n.developer_reserved,\n.hims-pending {\n  background-color: #FFC800 !important;\n}\n.reserved > .bar,\n.developer_reserved > .bar,\n.hims-pending > .bar {\n  background-color: #FFC800 !important;\n}\n.booked,\n.developer_booked {\n  background-color: #FF8700 !important;\n}\n.booked > .bar,\n.developer_booked > .bar {\n  background-color: #FF8700 !important;\n}\n.sold_spa_signed,\n.developer_sold,\n.unavailable,\n.hims-failed {\n  background-color: #FF0000 !important;\n}\n.sold_spa_signed > .bar,\n.developer_sold > .bar,\n.unavailable > .bar,\n.hims-failed > .bar {\n  background-color: #FF0000 !important;\n}\n.delist {\n  background-color: #767676 !important;\n}\n.delist > .bar {\n  background-color: #767676 !important;\n}\n.cancelled_developer {\n  background-color: #AEBAC1 !important;\n}\n.cancelled_developer > .bar {\n  background-color: #AEBAC1 !important;\n}\n.cancelled_availability {\n  background-color: #C28CD8 !important;\n}\n.cancelled_availability > .bar {\n  background-color: #C28CD8 !important;\n}\n.app-list > .Select > .Select-control {\n  background: rgba(255, 255, 255, 0.2);\n  border: none;\n}\n.app-list > .Select > .Select-control .Select-value {\n  text-align: center;\n}\n.app-list > .Select > .Select-control .Select-value .Select-value-label {\n  color: white !important;\n}\n.app-list > .Select > .Select-control .Select-arrow {\n  border-top-color: white;\n}\n.app-list > .Select > .Select-control .Select-menu-outer {\n  text-align: center;\n}\n.app-list > .Select.is-open .Select-arrow {\n  border-bottom-color: white;\n}\n.app-nav .ui.secondary.menu {\n  margin: 0;\n}\n.app-nav .ui.secondary.menu .right.menu .fitted.item {\n  margin-right: 0;\n}\n.app-footer {\n  width: 100%;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n}\n.app-footer > .app-quick-links-footer {\n  height: 150px;\n  background: #596975;\n  color: white;\n}\n.app-footer > .app-quick-links-footer > .ui.container > .grid > .row > .column > .grid > .app-link-links {\n  padding-top: 0.2em;\n  padding-bottom: 0;\n  font-size: 12px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  height: 7em;\n}\n.app-footer > .app-quick-links-footer > .ui.container > .grid > .row > .column > .grid > .app-link-links > .app-link-list {\n  color: white;\n}\n.app-footer > .app-quick-links-footer > .ui.container > .grid > .row > .column > .grid > .app-link-links > .app-link-list:hover {\n  color: rgba(255, 255, 255, 0.7);\n}\n.app-footer > .app-copyright-footer {\n  height: 2.44em;\n  background: #FFF;\n  color: #00233B;\n  font-size: 12px;\n  /* Mobile */\n}\n@media only screen and (max-width: 767px) {\n  .app-footer > .app-copyright-footer {\n    height: 3em;\n    margin-bottom: 0.25em;\n  }\n}\n.app-footer > .app-copyright-footer .ui.grid {\n  padding-top: 0.5em;\n  /* Mobile */\n}\n@media only screen and (min-width: 1200px) {\n  .app-footer > .app-copyright-footer .ui.grid {\n    width: 1127px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .app-footer > .app-copyright-footer .ui.grid {\n    padding-top: 0;\n    font-size: 10px;\n    text-align: center;\n  }\n}\n.app-footer > .app-copyright-footer .ui.grid > .column {\n  padding: 0;\n}\n.app-footer > .app-copyright-footer .ui.grid > .app-footer-v {\n  /* Mobile */\n  /* Tablet computer */\n}\n@media only screen and (max-width: 767px) {\n  .app-footer > .app-copyright-footer .ui.grid > .app-footer-v {\n    line-height: 1.5em;\n  }\n}\n@media only screen and (min-width: 767px) {\n  .app-footer > .app-copyright-footer .ui.grid > .app-footer-v {\n    text-align: right;\n  }\n}\n.hlb-campaign-link {\n  color: #49B3B1;\n}\n.hlb-campaign-callout-banner {\n  background: linear-gradient(90deg, #E6CF81 -26.34%, #F5EFDB 48.09%, #E6CF81 122.52%);\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  gap: 8px;\n  padding: 10px 16px;\n  border-radius: 8px;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.hlb-campaign-callout-banner .hlb-campaign-callout-banner-text {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 8px;\n}\n.hlb-campaign-callout-banner .hlb-campaign-callout-banner-button {\n  background-color: #FAF5E1;\n  border-radius: 4px;\n  color: #00233B;\n  font-weight: 700;\n  font-size: 14px;\n}\n.hlb-eligible-banner {\n  background-color: #EDF7FD;\n  border: 1px solid #E7EAED;\n  border-radius: 5px;\n  padding: 16px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  gap: 16px;\n}\n.hlb-campaign-rewards-tag {\n  background-color: #50B793;\n  color: #fff;\n  padding: 6px 12px;\n  border-radius: 100px;\n  font-size: 10px;\n  font-weight: bold;\n  border: 1px solid #50B793;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 8px;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.hlb-table-banker-listing {\n  border: none !important;\n}\n.hlb-table-banker-listing,\n.hlb-table-banker-listing tbody,\n.hlb-table-banker-listing tr,\n.hlb-table-banker-listing td {\n  display: block;\n  width: 100%;\n}\n.hlb-table-banker-listing tr {\n  margin-bottom: 1rem;\n  border: 1px solid #E7EAED;\n  border-radius: 8px;\n  padding: 1em;\n}\n.hlb-table-banker-listing tr.hlb-bank-row {\n  border: 1px solid #49B3B1;\n  background: linear-gradient(86.05deg, rgba(228, 215, 173, 0.3) 0%, #F7F1DE 17.92%, #FAF1E0 31.73%, rgba(233, 213, 149, 0.5) 67.79%, #F6ECD5 85.58%, #F0E2B7 100%);\n}\n.hlb-table-banker-listing td {\n  text-align: left;\n  padding: 0.5em 0;\n  border: none !important;\n}\n.hlb-campaign-main-banner {\n  background: url(" + escape(__webpack_require__(3517)) + ") no-repeat center center;\n  background-size: cover;\n  height: -webkit-fit-content;\n  height: -moz-fit-content;\n  height: fit-content;\n  border-radius: 10px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  color: #825500;\n  padding: 2.5em 1em 1em 1em;\n}\n.hlb-campaign-main-banner .hlb-campaign-main-banner-title {\n  font-family: Montserrat;\n  font-weight: 700;\n  font-size: 25px;\n  line-height: 100%;\n  letter-spacing: 5%;\n  text-align: center;\n}\n.hlb-campaign-main-banner .hlb-campaign-main-banner-subtitle {\n  font-family: Montserrat;\n  line-height: 100%;\n  font-weight: 500;\n  font-size: 14px;\n}\n.hlb-campaign-main-banner .hlb-campaign-main-banner-content {\n  background: #FFE8A04D;\n  padding: 12px;\n  border-radius: 8px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n  text-align: start;\n  gap: 0.5em;\n  width: 70%;\n  padding-left: 2em;\n  padding-right: 2em;\n  margin-top: 1em;\n}\n.hlb-campaign-welcome-modal-content {\n  font-size: 14px;\n}\n.hlb-campaign-welcome-modal-content .ui.list > .item {\n  line-height: 1.5;\n}\n.hlb-form-error-message {\n  color: red;\n  font-size: 14px;\n  margin-top: 0.4em;\n}\n@media (max-width: 768px) {\n  .hlb-campaign-main-banner .hlb-campaign-main-banner-content {\n    width: 90%;\n  }\n  .hlb-campaign-callout-banner {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    padding: 16px;\n  }\n}\n.hlb-campaign-terms-modal-content {\n  color: #596975;\n  font-size: 14px;\n  font-family: Lato;\n  max-height: 90vh;\n  overflow-y: auto;\n}\n.hlb-campaign-terms-modal-content .header {\n  font-weight: 700;\n  font-size: 17px;\n  margin-bottom: 10px;\n  font-family: Montserrat;\n}\n.hlb-campaign-terms-modal-content .title {\n  font-weight: 700;\n  font-size: 14px;\n  margin-bottom: -10px;\n}\n.hlb-campaign-terms-modal-content .ui.list > .item {\n  line-height: 1.5;\n  margin-left: 0.5em;\n}\n.bankcasestatus-modal .content {\n  padding: 0.5em 1.5em !important;\n}\n.bankcasestatus-item {\n  display: -ms-inline-flexbox !important;\n  display: inline-flex !important;\n  cursor: pointer;\n  padding: 1em !important;\n  width: 100%;\n}\n.bankcasestatus-item .description {\n  padding-left: 1em;\n}\n.bankcasestatus-item:hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n.disabled-item {\n  background: rgba(0, 0, 0, 0.05);\n}\n@media only screen and (max-width: 767px) {\n  .ui.modal .content .banker-item .image {\n    padding: 0 !important;\n  }\n}\n@media only screen and (max-width: 1200px) {\n  .bookingPricingPackage {\n    overflow-x: scroll;\n  }\n  .bookingPricingPackage .ui.table {\n    width: 900px !important;\n  }\n}\n.bookingPricingPackage .text_name {\n  opacity: 0.8;\n  font-weight: bold;\n}\n.bookingPricingPackage .text_name.italic {\n  font-style: italic;\n}\n.bookingPricingPackage .text_formula_small {\n  font-size: 0.975em;\n}\n.bookingPricingPackage .text_description {\n  font-size: 0.88rem;\n}\n.bookingPricingPackage .text_deduct {\n  color: #db2828;\n}\n.bookingPricingPackage .text_add {\n  color: #21ba45;\n}\n.bookingPricingPackage .row_total {\n  font-weight: bold;\n  font-size: 1.1em;\n}\n.bookingPricingPackage .change_amount_prefix {\n  text-align: left;\n}\n.bookingPricingPackage .change_amount {\n  text-align: right;\n}\n.bookingPricingPackage .col_description {\n  width: 25%;\n}\n.bookingPricingPackage .div_inline_block {\n  display: inline-block;\n}\n.bookingPricingPackage .div_recalculate {\n  float: right;\n}\n.bookingPricingPackage .div_recalculate label {\n  color: red !important;\n}\n.bookingPricingPackage .textButton {\n  background: transparent;\n  font-weight: 600;\n  font-size: 1em !important;\n  color: #0094B3;\n  font-family: 'Open Sans';\n}\n.paymentPlan .loan-amount .prefix {\n  margin-right: 5px;\n}\n.paymentPlan .textButton {\n  background: transparent;\n  font-weight: 400;\n  font-size: 14px !important;\n  color: #49B3B1;\n  font-family: 'Open Sans';\n  padding: 0;\n  margin: 0 !important;\n}\n.paymentPlan .textButton[disabled] {\n  color: #969CA4;\n  cursor: default;\n}\n.paymentPlan .text-header {\n  font-size: 15px;\n  font-weight: 600;\n  font-family: 'Montserrat', 'Lato', sans-serif;\n  line-height: 18.29px;\n  color: #00233B;\n}\n.paymentPlan .text-title {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 19.07px;\n  color: #00233B;\n  font-family: 'Open Sans';\n}\n.paymentPlan .text-body {\n  font-size: 14px;\n  line-height: 19.07px;\n  color: #00233B;\n  font-family: 'Open Sans';\n}\n.paymentPlan .text-item {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16.34px;\n  color: #00233B;\n  font-family: 'Open Sans';\n}\n.paymentPlan .text-subtitle {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16.34px;\n  font-family: 'Open Sans';\n}\n.paymentPlan .ui.grid > .row.emptyNodeRow {\n  padding: 6rem 0;\n}\n.paymentPlan .mb-8 {\n  margin-bottom: 0.5rem;\n}\n.paymentPlan .mt-4 {\n  margin-top: 0.25rem;\n}\n.paymentPlan .verticalAlign-mid {\n  vertical-align: middle;\n}\n.paymentPlan .boxShadowAccordion {\n  border-radius: 10px;\n  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);\n  padding: 1.5rem 1.5rem 2.5rem;\n}\n.paymentPlan .boxShadowAccordion:first-child .title {\n  cursor: default;\n}\n.paymentPlan .boxShadowAccordion:not(:first-child) {\n  margin-top: 2rem;\n}\n.paymentPlan .boxShadowAccordion .grid > .row {\n  padding: 0.6rem 0;\n}\n.paymentPlan .boxShadowAccordion .title {\n  padding-top: 0;\n}\n.paymentPlan .boxShadowAccordion .ui.table:first-child {\n  margin-top: 1rem;\n}\n.paymentPlan .boxShadowAccordion .ui.table {\n  border: none;\n}\n.paymentPlan .boxShadowAccordion .ui.table tr td {\n  border: none;\n}\n.paymentPlan .boxShadowAccordion .ui.table thead th {\n  border-bottom: none;\n  background: #F8F9F9;\n}\n.paymentPlanModal .modal-header {\n  position: -webkit-sticky;\n  position: sticky;\n  top: 0;\n  z-index: 99;\n  background: #fff;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding: 1.5rem;\n  border-bottom: 1px solid #DBDDDE;\n}\n.paymentPlanModal .modal-header .closeButton {\n  border: none;\n  padding: 0;\n  box-shadow: none;\n  filter: opacity(0.6);\n  transition: all 0.5s;\n}\n.paymentPlanModal .modal-header .closeButton:hover {\n  border: none;\n  padding: 0;\n  box-shadow: none;\n  filter: opacity(1);\n}\n.paymentPlanModal .modal-content {\n  max-height: 750px;\n  overflow-y: auto;\n}\n.paymentPlanModal .modal-content-overflow {\n  overflow-y: visible;\n  z-index: 999;\n  position: relative;\n}\n.paymentPlanModal .text-header {\n  font-size: 15px;\n  font-weight: 600;\n  font-family: 'Montserrat', 'Lato', sans-serif;\n  line-height: 18.29px;\n  color: #00233B;\n}\n.paymentPlanModal .text-title {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 19.07px;\n  color: #00233B;\n  font-family: 'Open Sans';\n}\n.paymentPlanModal .submit-button {\n  padding: 8px 14px 8px 14px;\n  background-color: #0094B3;\n  height: 35px;\n  border-radius: 4px;\n  color: #ffffff;\n  font-family: 'Open Sans';\n}\n.paymentPlanModal .submit-button:hover {\n  background-color: #33a9c2;\n  color: #ffffff;\n}\n.paymentPlanModal .submit-button:focus {\n  background-color: #0094B3;\n  color: #ffffff;\n}\n.paymentPlanForm .loan-amount .prefix {\n  margin-right: 5px;\n}\n.paymentPlanForm .text-body {\n  font-size: 14px;\n  line-height: 19.07px;\n  color: #00233B;\n  font-family: 'Open Sans';\n}\n.paymentPlanForm .text-item {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16.34px;\n  color: #00233B;\n  font-family: 'Open Sans';\n}\n.paymentPlanForm .text-subtitle {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16.34px;\n  font-family: 'Open Sans';\n}\n.paymentPlanForm .mt-4 {\n  margin-top: 0.25rem;\n}\n.paymentPlanForm .mt-24 {\n  margin-top: 1.5rem;\n}\n.paymentPlanForm .ml-16 {\n  margin-left: 1rem;\n}\n.paymentPlanForm .verticalAlign-mid {\n  vertical-align: middle;\n}\n.paymentPlanForm .createPsdSection {\n  margin: 0.5rem 1rem 1rem;\n}\n.paymentPlanForm .createPsdSection .button {\n  margin-left: 0.5rem;\n}\n.paymentPlanForm .actions {\n  position: -webkit-sticky;\n  position: sticky;\n  bottom: 0;\n  z-index: 99;\n}\n.paymentPlanForm .ui.grid > .row > .column.ppSelection {\n  padding-right: 4rem;\n}\n.paymentPlanForm .ui.grid > .row > .column.ppSelection p:first-child {\n  margin-bottom: 2.5rem;\n}\n.paymentPlanForm .ui.grid > .row > .column.ppSelection p:nth-child(2) {\n  margin-bottom: 0.5rem;\n}\n.paymentPlanForm .divider {\n  margin: 0.5rem 0 !important;\n}\n.paymentPlanForm .text-red {\n  color: #FF796E;\n}\n.paymentPlanForm .text-green {\n  color: #50B793;\n}\n.paymentPlanForm .dropdown .description {\n  display: none;\n}\n.paymentPlanForm .dropdown .dropdown-item {\n  font-size: 12px;\n  margin-top: 0;\n}\n.paymentPlanForm .dropdown .dropdown-item .sub.header {\n  font-size: 12px;\n}\n.paymentPlanForm .dropdown .dropdown-item .name,\n.paymentPlanForm .dropdown .dropdown-item .value {\n  display: inline;\n  font-size: 14px;\n  font-weight: 400;\n}\n.paymentPlanForm .dropdown .dropdown-item .value {\n  float: right;\n  color: rgba(0, 0, 0, 0.4);\n}\n.paymentPlanForm .dropdown .ui.selection.dropdown .menu > .item {\n  padding: 0.6rem 1.14285714rem !important;\n}\n.paymentPlanForm .dropdown .active.selected.item > .dropdown-item .name,\n.paymentPlanForm .dropdown .active.selected.item > .dropdown-item .value {\n  font-weight: 700;\n}\n.paymentPlanForm .link {\n  color: #0094B3;\n}\n.paymentPlanForm .borderlessAccordion {\n  margin-top: 2.5rem;\n  box-shadow: none;\n}\n.paymentPlanForm .borderlessAccordion .title {\n  padding: 1rem !important;\n  background-color: #F8F9F9;\n  border-radius: 0.25rem 0;\n}\n.paymentPlanForm .borderlessAccordion .accordionContent {\n  padding: 1rem !important;\n}\n.paymentPlanForm .flex-box {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  column-gap: 20px;\n}\n.paymentPlanForm .column-flex-box {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: columns;\n      flex-direction: columns;\n  -ms-flex-align: center;\n      align-items: center;\n  column-gap: 20px;\n}\n.paymentPlanForm .ui.input {\n  width: 100%;\n  height: 40px;\n}\n.paymentPlanForm .ui.labeled.input input {\n  text-align: right;\n  padding-right: 1rem;\n}\n.paymentPlanForm .ui.labeled.input .label {\n  font-family: 'Open Sans';\n  font-size: 14px;\n  color: #969CA4;\n  font-weight: 400;\n  border-right: none;\n}\n.paymentPlanForm .bb-none {\n  border-bottom: none !important;\n}\n.paymentPlanForm .bt-none {\n  border-top: none !important;\n}\n.paymentPlanForm .ui.horizontal.divider.dividerWithButton {\n  margin: 0 !important;\n}\n.paymentPlanForm .ui.horizontal.divider.dividerWithButton:before {\n  background-position: right 0 top 50%;\n}\n.paymentPlanForm .ui.horizontal.divider.dividerWithButton:after {\n  background-position: left 0 top 50%;\n}\n.paymentPlanForm .ui.table:not(.expandIndicateTable) {\n  padding: 0.5rem 1rem;\n}\n.paymentPlanForm .tableExpandButton {\n  background-color: #F4F5F7;\n  min-width: 44px;\n  min-height: 18px;\n  border-radius: 6.25rem;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  margin: 0;\n}\n.paymentPlanForm .noGutterBottom {\n  margin-bottom: 0;\n}\n.paymentPlanForm .textButton {\n  background: transparent;\n  font-weight: 400;\n  font-size: 12px !important;\n  color: #49B3B1;\n  font-family: 'Open Sans';\n  padding: 0;\n  margin: 0 0 0 5px !important;\n}\n.paymentPlanForm .textButton .icon {\n  margin-left: 8px;\n}\n.paymentPlanForm .collapsibleTable td {\n  border-top: none !important;\n}\n.paymentPlanForm .vertical-align-initial {\n  vertical-align: initial;\n}\n.paymentPlanForm .ui.form .field {\n  margin-bottom: 5px;\n}\n.paymentPlanForm .ui.form .field .error {\n  color: #FF4433;\n  font-family: Open Sans;\n  font-size: 10px;\n  font-weight: 400;\n}\n.paymentPlanForm .datePicker .error {\n  color: #FF4433;\n  font-family: Open Sans;\n  font-size: 10px;\n  font-weight: 400;\n}\n.ui.centered.grid.booking-steppers {\n  margin: 1em;\n}\n.ui.centered.grid.booking-steppers .row .column.booking-steppers-left {\n  text-align: right !important;\n  padding-right: 0;\n}\n.ui.centered.grid.booking-steppers .row .column.booking-steppers-middle {\n  width: -webkit-fit-content !important;\n  width: -moz-fit-content !important;\n  width: fit-content !important;\n  padding: 0 !important;\n}\n.ui.centered.grid.booking-steppers .row .column.booking-steppers-right {\n  text-align: left !important;\n  padding-left: 0;\n}\n.ui.centered.grid.booking-steppers .row .column.booking-steppers-divider-col {\n  padding: 0;\n}\n.ui.centered.grid.booking-steppers .row .ui.circular.label {\n  background: rgba(34, 36, 38, 0.03);\n  border: 1px solid rgba(34, 36, 38, 0.2);\n  color: rgba(34, 36, 38, 0.4);\n}\n.ui.centered.grid.booking-steppers .row .ui.circular.label.active {\n  background: transparent;\n  border: 1px solid #4183C4;\n  color: #4183C4;\n}\n.ui.centered.grid.booking-steppers .row .ui.circular.label.checkmark .checkmark.icon {\n  margin: 0;\n}\n.ui.centered.grid.booking-steppers .row .ui.divider.complete {\n  border: 1px solid #4183c4;\n}\n.ui.centered.grid.booking-steppers .row.label-row {\n  padding-top: 0;\n}\n.buyer-banker-card h4.ui.header {\n  margin-bottom: 0.25rem;\n}\n.buyer-banker-card > .ui.dropdown {\n  margin-top: 1rem;\n}\n.buyer-banker-card > .ui.dropdown.active.selection {\n  border-radius: 0.28571429rem !important;\n}\n.buyer-banker-card > .ui.dropdown.status-pending {\n  border-color: #ff9800;\n  background: #ff9800;\n  color: white;\n}\n.buyer-banker-card > .ui.dropdown.status-pending > .text:not(.default) {\n  color: white;\n}\n.buyer-banker-card > .ui.dropdown.status-new {\n  border-color: #03a9f4;\n  background: #03a9f4;\n  color: white;\n}\n.buyer-banker-card > .ui.dropdown.status-new > .text:not(.default) {\n  color: white;\n}\n.buyer-banker-card > .ui.dropdown.status-approved {\n  border-color: #03a9f4;\n  background: #03a9f4;\n  color: white;\n}\n.buyer-banker-card > .ui.dropdown.status-approved > .text:not(.default) {\n  color: white;\n}\n.buyer-banker-card > .ui.dropdown.status-reject {\n  border-color: #4DB6AC;\n  background: #4DB6AC;\n  color: white;\n}\n.buyer-banker-card > .ui.dropdown.status-reject > .text:not(.default) {\n  color: white;\n}\n.buyer-banker-card > .ui.dropdown.status-success {\n  border-color: #4CAF50;\n  background: #4CAF50;\n  color: white;\n}\n.buyer-banker-card > .ui.dropdown.status-success > .text:not(.default) {\n  color: white;\n}\n.buyer-banker-card > .ui.dropdown.status-default {\n  border-color: #F8F9F9;\n  background: #F8F9F9;\n  color: #DBDDDE;\n}\n.buyer-banker-card > .ui.dropdown.status-default > .text:not(.default) {\n  color: #DBDDDE;\n}\n.buyer-banker-card.cancelled {\n  color: #DBDDDE;\n}\n.buyer-banker-card.cancelled a,\n.buyer-banker-card.cancelled h4.ui.header {\n  color: #DBDDDE;\n}\n.buyer-banker-card.cancelled > .ui.dropdown {\n  opacity: 1;\n  color: #DBDDDE;\n  background: #F8F9F9;\n  border-color: #F8F9F9;\n}\n.buyer-banker-card.cancelled > .ui.dropdown > .dropdown.icon {\n  opacity: 0;\n}\n.buyer-banker-card.cancelled > .ui.dropdown > .text:not(.default) {\n  color: #DBDDDE;\n}\n.buyer-banker-card > .actions {\n  margin: 0.25rem 0;\n  padding-bottom: 0.5rem;\n}\n.buyer-banker-card > .actions > .column {\n  width: auto !important;\n}\n.buyer-banker-card > .actions > .column > .ui.button {\n  position: relative;\n}\n.buyer-banker-card > .actions > .column > .ui.button:hover > span {\n  color: #1678c2;\n}\n.buyer-banker-card > .actions > .column > .ui.button > span {\n  font-size: 0.857em;\n  font-weight: 100;\n  position: absolute;\n  top: calc(100% + 0.25rem);\n  left: 50%;\n  -ms-transform: translateX(-50%);\n      transform: translateX(-50%);\n  color: #2185d0;\n}\n.buyer-banker-card > .actions > .column > .ui.button.disabled {\n  opacity: 1 !important;\n  background: #EDEFF0;\n  color: white;\n}\n.buyer-banker-card > .actions > .column > .ui.button.disabled > span {\n  color: #DBDDDE;\n}\n.buyer-banker-card > .actions > .column > .ui.button > .notification-icon {\n  width: 1.85em;\n  height: 1.85em;\n  margin: 0;\n  background: transparent;\n}\n.buyer-banker-card > .actions > .column > .ui.button > .notification-icon > img {\n  width: 100% !important;\n  -ms-transform: scale(1.25);\n      transform: scale(1.25);\n}\n.buyer-check-result .ui.segments.dashboard {\n  background: #F4F5F7;\n  border: none;\n  box-shadow: none;\n}\n.buyer-check-result .ui.segments.dashboard .ui.segment {\n  background: transparent;\n  border-color: white;\n}\n.buyer-check-result .ui.segments.dashboard .ui.segment p {\n  font-size: 0.857em;\n  text-transform: uppercase;\n  color: #596975;\n  margin-bottom: 0.5rem;\n}\n.buyer-check-result .ui.segments.dashboard .ui.segment .ui.header {\n  margin-top: 0;\n  font-weight: 100;\n  font-family: 'Montserrat', 'Lato', sans-serif;\n}\n.buyer-check-result .ui.segments.dashboard .ui.segment.eligible-loan-amount.not-eligible {\n  background: #fdedeb;\n}\n.buyer-check-result .ui.segments.dashboard .ui.segment.eligible-loan-amount.not-eligible .ui.header {\n  color: #f44336;\n}\n.buyer-check-result .ui.button.show-commitment {\n  border: none !important;\n  box-shadow: none !important;\n  background: none !important;\n  border-radius: 0.5rem;\n  padding-left: 0;\n  padding-right: 0;\n  color: rgba(0, 148, 179, 0.8) !important;\n}\n.buyer-check-result .ui.button.show-commitment:hover,\n.buyer-check-result .ui.button.show-commitment.active {\n  color: #0094b3 !important;\n}\n.buyer-check-result .details {\n  margin: 0.5rem 0;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.buyer-check-result .details > .row {\n  padding: 0;\n}\n.buyer-check-result .details > .row > .column:first-child {\n  font-weight: bold;\n  padding-left: 0;\n}\n.buyer-check-result .commitment {\n  padding: 1rem;\n  margin: 0;\n  border: 1px solid #D1D1D1;\n  border-radius: 0.5rem;\n}\n.buyer-check-result .commitment > .row {\n  padding: 0.25rem 0;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.buyer-check-result .commitment > .row.header {\n  border-bottom: 1px solid #D1D1D1;\n  padding-bottom: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n.buyer-check-result .commitment > .row:first-child {\n  padding-top: 0;\n}\n.buyer-check-result .commitment > .row:last-child {\n  padding-bottom: 0;\n}\n.buyer-check-result .commitment > .row > .column {\n  color: #596975;\n  width: auto;\n}\n.buyer-check-result .commitment > .row > .column:first-child {\n  padding-left: 0;\n  padding-right: 5rem;\n}\n.buyer-check-result .commitment > .row > .column:last-child {\n  padding-right: 0;\n}\n.buyer-check-result .commitment > .row.total-amount > .column {\n  font-weight: bold;\n}\n@media only screen and (min-width: 768px) {\n  .buyer-check-result .commitment {\n    display: block;\n    width: -webkit-fit-content;\n    width: -moz-fit-content;\n    width: fit-content;\n  }\n}\n.buyer-loan-card {\n  border-color: #EDEFF0 !important;\n  box-shadow: none !important;\n  border-radius: 0.5rem;\n}\n.buyer-loan-card > .ui.segment {\n  border-color: #EDEFF0;\n}\n.buyer-loan-card > .ui.segment:first-child {\n  border-radius: 0.5rem 0.5rem 0 0;\n}\n.buyer-loan-card > .ui.segment:last-child {\n  border-radius: 0 0 0.5rem 0.5rem;\n}\n.buyer-loan-card > .ui.segment.headers {\n  padding: 0.4em 1em;\n  background: #F4F5F7;\n  font-family: 'Montserrat', 'Lato', sans-serif;\n  font-size: 1.14em;\n}\n.buyer-loan-card > .ui.segment.headers .row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.buyer-loan-card > .ui.segment.headers .row .load-image {\n  width: 45px;\n  margin-right: 0.5rem;\n}\n.buyer-loan-card > .ui.segment.headers .row .load-image .ui.image {\n  background: white;\n}\n.buyer-loan-card > .ui.segment.headers .row span {\n  -ms-flex: 1;\n      flex: 1;\n}\n.buyer-loan-card > .ui.segment.details > .ui.grid {\n  padding: 1rem;\n}\n.buyer-loan-card > .ui.segment.details > .ui.grid > .row {\n  padding: 0.125rem 0;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.buyer-loan-card > .ui.segment.details > .ui.grid > .row:first-child {\n  padding-top: 0;\n}\n.buyer-loan-card > .ui.segment.details > .ui.grid > .row:last-child {\n  padding-bottom: 0;\n}\n.buyer-loan-card > .ui.segment.details > .ui.grid > .row > .column {\n  width: auto;\n}\n.buyer-loan-card > .ui.segment.details > .ui.grid > .row > .column:first-child {\n  padding-left: 0;\n}\n.buyer-loan-card > .ui.segment.details > .ui.grid > .row > .column:last-child {\n  -ms-flex: 1;\n      flex: 1;\n  padding-right: 0;\n}\n.buyer-loan-card > .ui.segment.details > .ui.grid > .row.years {\n  color: #596975;\n  font-size: 0.857em;\n}\n.buyer-loan-card > .ui.segment.details .ui.button.assign {\n  margin-top: 1rem;\n}\n.buyer-loan-card .ui.button.show-history {\n  border: none !important;\n  box-shadow: none !important;\n  background: none !important;\n  border-radius: 0.5rem;\n  padding-left: 0;\n  padding-right: 0;\n  color: rgba(0, 148, 179, 0.8) !important;\n  font-size: 0.8em;\n  margin-top: 0.5rem;\n}\n.buyer-loan-card .ui.button.show-history:hover,\n.buyer-loan-card .ui.button.show-history.active {\n  color: #0094b3 !important;\n}\n@media only screen and (max-width: 1199px) and (min-width: 768px) {\n  .buyer-item .ui.grid > [class*=\"three column\"].doubling.row.row > .column,\n  .buyer-item .ui[class*=\"three column\"].doubling.grid > .column:not(.row),\n  .buyer-item .ui[class*=\"three column\"].doubling.grid > .row > .column {\n    width: 50%!important;\n  }\n}\ncanvas {\n  display: block;\n  max-width: 100%;\n}\ncanvas.center {\n  margin: 0 auto;\n}\n.credit-check .ui.header {\n  color: white;\n}\n.credit-check .ui.header .sub.header {\n  color: white;\n}\n.credit-check .ui.header i.inverted.circular.blue.icon {\n  background-color: #57B4CA !important;\n  padding: 0.5em !important;\n}\n.credit-check .ui.menu.tabular {\n  border-color: #989898;\n}\n.credit-check .ui.menu.tabular .item {\n  color: white;\n  background-color: #5b5b5b;\n  border-radius: 0.28571429rem 0.28571429rem 0 0 !important;\n}\n.credit-check .ui.menu.tabular .item.active {\n  border-color: #989898;\n  background-color: #989898;\n}\n.credit-check .ui.menu:not(.tabular) {\n  background-color: transparent;\n  border-color: #9B9B9B;\n}\n.credit-check .ui.menu:not(.tabular) .item:not(.active) .ui.header {\n  color: #9B9B9B;\n}\n.credit-check .ui.menu:not(.tabular) .item:not(.active) .ui.header .sub.header {\n  color: #9B9B9B;\n}\n.credit-check .ui.menu:not(.tabular) .item.active {\n  border-radius: 0.28571429rem;\n  background-color: #A3A3A3;\n}\n.credit-check .ui.steps {\n  border-color: #A2A2A2;\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n.credit-check .ui.steps .step {\n  text-align: left;\n  border-color: #A2A2A2;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n}\n.credit-check .ui.steps .step .title ~ .description {\n  line-height: 1.4;\n}\n.credit-check .ui.steps .step:after {\n  border-color: #A2A2A2;\n}\n.credit-check .ui.steps .step:first-child {\n  border-radius: 0.28571429rem 0 0 0.28571429rem;\n}\n.credit-check .ui.steps .step:last-child {\n  border-radius: 0 0.28571429rem 0.28571429rem 0;\n}\n.credit-check .ui.steps .step.active {\n  background-color: #3C88CC;\n}\n.credit-check .ui.steps .step.active:before,\n.credit-check .ui.steps .step.active .title,\n.credit-check .ui.steps .step.active .description {\n  color: white;\n}\n.credit-check .ui.steps .step.active:after {\n  background-color: #3C88CC;\n}\n@media only screen and (max-width: 767px) {\n  .credit-check .ui.steps .step {\n    width: 0 !important;\n    -ms-flex-pack: center;\n        justify-content: center;\n  }\n  .credit-check .ui.steps .step:not(.active) {\n    padding: 1.14285714em 0em;\n  }\n  .credit-check .ui.steps .step:not(.active) .content {\n    display: none;\n  }\n}\n@media only screen and (min-width: 992px) {\n  .credit-check .ui.steps .step .content {\n    width: calc(100% - 4em);\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 991px) {\n  .credit-check .ui.steps .step {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    font-size: 0.8em;\n  }\n  .credit-check .ui.steps .step:before,\n  .credit-check .ui.steps .step .icon {\n    margin: 0 0 1rem;\n  }\n  .credit-check .ui.steps .step .content {\n    text-align: center;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .credit-check .ui.steps .step {\n    width: 25% !important;\n  }\n}\n.credit-check .ui.form .field label {\n  color: white;\n  text-align: left;\n}\n.credit-check .ui.checkbox label {\n  color: white;\n}\n.button-credit-check {\n  color: white !important;\n}\n.button-credit-check.run {\n  background-color: #21BA45;\n}\n.button-credit-check.pending {\n  background-color: #F7941E;\n}\n.button-credit-check.success {\n  background-color: #109873;\n}\n.button-credit-check.alert {\n  background-color: #ff0b0b;\n}\n.previous-credit-check .pending {\n  color: #F7941E;\n}\n.previous-credit-check .success {\n  color: #109873;\n}\n.previous-credit-check .alert {\n  color: #ff0b0b;\n}\n.previous-credit-check .zero {\n  color: #ff7171;\n}\n.previous-credit-check .mid {\n  color: #ffaa44;\n}\n.credit-check-scores .scores {\n  display: -ms-flexbox;\n  display: flex;\n  margin-bottom: 2em;\n  max-width: 54em;\n  margin-left: auto;\n  margin-right: auto;\n}\n@media only screen and (max-width: 567px) {\n  .credit-check-scores .scores {\n    -ms-flex-direction: column;\n        flex-direction: column;\n  }\n  .credit-check-scores .scores .score {\n    border-right: none;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.15);\n  }\n  .credit-check-scores .scores .score:last-child {\n    border-bottom: none;\n  }\n}\n.credit-check-scores .score {\n  -ms-flex: 1;\n      flex: 1;\n  padding: 1em;\n  border-right: 1px solid rgba(255, 255, 255, 0.15);\n}\n.credit-check-scores .score:last-child {\n  border-right: none;\n}\n.credit-check-scores .score .round.icon {\n  width: 9em;\n  height: 9em;\n  text-align: center;\n  margin-left: auto;\n  margin-right: auto;\n  border-radius: 60%;\n  padding: 1.5em;\n}\n.credit-check-scores .score .round.icon .value {\n  font-size: 3em;\n  font-weight: bold;\n}\n.credit-check-scores .score .round.icon .value.small {\n  display: initial;\n  font-size: 0.5em;\n  vertical-align: baseline;\n  line-height: 0;\n  height: 0;\n}\n.credit-check-scores .score .round.icon span {\n  display: inline-block;\n  line-height: calc(9em - 7em);\n  vertical-align: middle;\n  height: calc(9em - 3em);\n}\n.credit-check-scores .score .round.icon.pending {\n  background: #F7941E;\n  padding: 2.1em;\n}\n.credit-check-scores .score .round.icon.success {\n  background: #57b4ca;\n}\n.credit-check-scores .score .round.icon.bad {\n  background: white;\n  padding: 2.1em;\n}\n.credit-check-scores .score .breakdown {\n  text-align: left;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  height: 16em;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin: 1em auto 0;\n  padding: 0.5em 0.75em;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 5px;\n}\n.credit-check-scores .score .breakdown .breakdown-item {\n  width: 50%;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 0.5em 0.25em;\n}\n.credit-check-scores .score .breakdown .breakdown-item h5 {\n  margin-bottom: 0;\n}\n.credit-check-scores .score .breakdown .breakdown-item p {\n  font-weight: lighter;\n}\n.credit-check-scores .score .breakdown .breakdown-item .indicator {\n  display: inline-block;\n  width: 0.75em;\n  height: 0.75em;\n  border-radius: 50%;\n  margin-top: 0.4em;\n  margin-right: 0.5em;\n}\n.credit-check-scores .qualified-loans .loans .ui.card {\n  max-width: 160px;\n}\n.credit-check-scores .qualified-loans .loans .ui.card .ui.bottom.attached.button {\n  font-size: 0.8em;\n}\n.credit-check-booking .box-wrap {\n  margin: 1em !important;\n}\n.credit-check-booking .box-wrap .ui.divided.grid:not([class*=\"vertically divided\"]) > .row > .column:not(:first-child) {\n  box-shadow: -1px 0 0 0 #87ADC1;\n}\n.credit-check-booking .box-wrap .box {\n  border-radius: 0.3em;\n  background: #D6E3EA;\n  padding: 1em;\n}\n.credit-check-booking .box-wrap .box .row {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.credit-check-booking .box-wrap .box .column.score {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.credit-check-booking .box-wrap .box .column.score:first-child {\n  padding-left: 0;\n}\n.credit-check-booking .box-wrap .box .column.score:nth-child(2) {\n  padding-right: 0;\n}\n.credit-check-booking .box-wrap .box .column.score p {\n  font-size: 1.1em;\n  margin-bottom: 0.2em;\n  color: #3A3A3A;\n}\n@media only screen and (max-width: 410px) {\n  .credit-check-booking .box-wrap .box .column.score p {\n    font-size: 1em;\n  }\n}\n.credit-check-booking .box-wrap .box .column.last-column {\n  padding-bottom: 0;\n  padding: 1em 0;\n}\n.credit-check-booking .box-wrap .box .column.last-column.normal {\n  padding: 0;\n}\n.credit-check-booking .box-wrap .box .column.last-column.normal .grid {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.credit-check-booking .box-wrap .box .column.last-column .grid {\n  padding-top: 0.9em;\n  padding-bottom: 0;\n}\n.credit-check-booking .box-wrap .box .column.last-column .grid .button-check {\n  margin-top: 1em;\n}\n@media only screen and (min-width: 768px) {\n  .credit-check-booking .box-wrap .box .column.last-column.normal {\n    padding: 1em;\n  }\n  .credit-check-booking .box-wrap .box .column.last-column.normal .time {\n    padding-left: 0;\n    color: #3A3A3A;\n  }\n  .credit-check-booking .box-wrap .box .column.last-column.normal .button-check {\n    padding: 0;\n    margin-top: 0;\n  }\n  .credit-check-booking .box-wrap .box .column.last-column {\n    padding: 1em;\n  }\n  .credit-check-booking .box-wrap .box .column.last-column .grid {\n    padding-bottom: 0.9em;\n  }\n  .credit-check-booking .box-wrap .box .column.last-column .grid .time {\n    padding-left: 0;\n    color: #3A3A3A;\n  }\n  .credit-check-booking .box-wrap .box .column.last-column .grid .button-check {\n    padding: 0;\n    margin-top: 0;\n  }\n}\n.credit-check-detail-modal table.ui.table {\n  border-collapse: collapse;\n}\n.credit-check-detail-modal table.ui.table tbody:last-child tr {\n  border-bottom: none;\n}\n.dtp_tab_content {\n  padding: 0em !important;\n}\n.react-calendar {\n  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);\n  border-radius: 0.28571429rem;\n  border: 1px solid rgba(34, 36, 38, 0.15) !important;\n  margin: auto;\n}\n.react-calendar button.react-calendar__tile.react-calendar__century-view__decades__decade,\n.react-calendar button.react-calendar__tile.react-calendar__decade-view__years__year,\n.react-calendar button.react-calendar__tile.react-calendar__year-view__months__month,\n.react-calendar button.react-calendar__tile.react-calendar__month-view__days__day,\n.react-calendar .react-calendar__month-view__weekdays__weekday {\n  border: 1px solid #dfe0e4;\n}\n.react-calendar .react-calendar__month-view__weekdays__weekday > abbr {\n  color: #1279c6;\n}\n.react-calendar .react-calendar__tile--active {\n  background: #1279c6;\n  border: none !important;\n}\n.react-calendar .react-calendar__navigation {\n  margin-bottom: 0em;\n}\n.editable-button {\n  background-color: #fff !important;\n  font-weight: bold !important;\n  font-size: 14px !important;\n  color: #767676 !important;\n  top: 1px !important;\n  right: 1px !important;\n}\n.editable-button:focus {\n  outline: 0;\n}\n.editable-button:hover {\n  color: #666666 !important;\n}\n.editable-button > .icon {\n  margin: 0 0.25rem 0 0 !important;\n}\n.editable-button-new {\n  background: none !important;\n  font-weight: bold !important;\n  font-size: 14px !important;\n  color: #767676 !important;\n  top: 0.5em;\n  right: 0.5em;\n  position: absolute;\n}\n.editable-button-new:focus {\n  outline: 0;\n}\n.editable-button-new:hover {\n  color: #666666 !important;\n}\n.editable-button-new > .icon {\n  margin: 0 0.25rem 0 0 !important;\n}\n.ui.button.sort-button.icon.dropdown {\n  margin-left: 0.5em;\n}\n.ui.grid > .row > .stretched.column.hidden,\n.ui.segment.hidden {\n  display: none !important;\n}\n.ui.horizontal.divider:after,\n.ui.horizontal.divider:before {\n  top: 0;\n}\n.dimmable:not(.body).center {\n  text-align: center;\n}\n.ui.button.segment.disabled {\n  opacity: 0.7 !important;\n  border-top-width: 1px !important;\n}\n.ui.button.segment.green {\n  border-top: 1px solid rgba(34, 36, 38, 0.15);\n}\n.ui.button.segment .ui.small.header {\n  margin-bottom: 0.5em;\n}\n@media (min-width: 48em) {\n  .project-unit-grid.ui.grid > .row.grid-container::-webkit-scrollbar {\n    width: 0.2em;\n  }\n  .project-unit-grid.ui.grid > .row.grid-container::-webkit-scrollbar-button {\n    width: 0px;\n    height: 0px;\n  }\n  .project-unit-grid.ui.grid > .row.grid-container::-webkit-scrollbar-thumb {\n    background: #75797c;\n    border-radius: 20em;\n  }\n  .project-unit-grid.ui.grid > .row.grid-container::-webkit-scrollbar-thumb:hover {\n    background: #666;\n  }\n  .project-unit-grid.ui.grid > .row.grid-container::-webkit-scrollbar-thumb:active {\n    background: #4c5053;\n  }\n  .project-unit-grid.ui.grid > .row.grid-container::-webkit-scrollbar-track {\n    background: #fff;\n    border-radius: 20em;\n  }\n  .project-unit-grid.ui.grid > .row.grid-container::-webkit-scrollbar-track:hover {\n    background: #f7f7f7;\n  }\n  .project-unit-grid.ui.grid > .row.grid-container::-webkit-scrollbar-track:active {\n    background: #f7f7f7;\n  }\n}\n.project-unit-grid.ui.grid > .row.grid-container > .column {\n  padding-left: 0;\n  padding-right: 0;\n}\n.ui.input.error input {\n  background-color: #FFF6F6 !important;\n  border-color: #E0B4B4 !important;\n  color: #9F3A38 !important;\n  box-shadow: none !important;\n}\n.ui.fixed.table th {\n  overflow: visible;\n}\n.capitalize {\n  text-transform: capitalize;\n}\n.ui.button.flash-button {\n  background: transparent;\n  color: #4183C4;\n  padding: 0;\n}\n.ui.button.flash-button:hover {\n  color: #3F64BF;\n}\n.form-label {\n  margin-bottom: 0 !important;\n}\n.ui.label.arTimerLabel {\n  background: transparent;\n  padding: 0;\n}\n.form-mb1 {\n  margin-bottom: 1em !important;\n  width: 135px;\n}\n.form-sof-segment .ui.header {\n  padding-left: 0.5em;\n}\n.form-sof-segment .fields {\n  margin: 0 !important;\n}\n.form-sof-segment .fields .eleven.wide.field {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n.switch-button .ui.basic.button {\n  width: 100%;\n  text-align: start !important;\n  padding-left: 14px !important;\n  color: #596975 !important;\n  font-weight: 600 !important;\n}\n.ui.segment.hims-address {\n  background: #EDF7FD;\n  border: none;\n  box-shadow: none;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  margin-left: 0.5em;\n  margin-right: 0.5em;\n  width: calc(100% - 4em);\n}\n.ui.segment.hims-address p {\n  margin: 0 0 0.5em;\n  color: #596975;\n}\n.ui.segment.hims-address.error {\n  background: #FFEDED;\n}\n.ui.segment.hims-address.error p {\n  color: #FF796E;\n}\n.validate.field,\n.validate.field > .error.field {\n  margin: 0 0 0.25em;\n}\n.validate.field span.error,\n.validate.field > .error.field span.error {\n  color: #FF4433;\n}\n.merge-tag-tab {\n  margin-top: 20px !important;\n}\n.merge-tag-tab .row.tab-menu .column .ui.menu > a.item {\n  min-width: 80px;\n  background: #F8F8F8;\n  font-weight: bold;\n  text-align: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  padding: 0.5em 1.42857143em;\n}\n.merge-tag-tab .row.tab-menu .column .ui.menu > a.item.active {\n  background-color: #fff !important;\n  border-bottom: none;\n}\n.merge-tag-tab .row.tab-menu .column .ui.menu > a.item:first-child {\n  border-radius: 0.28571429rem 0 0 0 !important;\n}\n.merge-tag-tab .row.tab-menu .column .ui.menu > a.item:not(:first-child) {\n  margin-left: 1px;\n}\n.merge-tag-tab .row.tab-menu .column .ui.menu > a.item:last-of-type {\n  border-radius: 0 0.28571429rem 0 0 !important;\n}\n.ui.container.flash {\n  transition: all 0.6s ease;\n  position: fixed;\n  margin: 0.5em !important;\n  width: calc(100% - 1em) !important;\n  bottom: -4em;\n  opacity: 0;\n  z-index: 2000;\n}\n.ui.container.flash.show {\n  transition: all 0.3s ease;\n  bottom: 0;\n  opacity: 1;\n}\n.ui.image.load-image {\n  text-align: center;\n}\n.ui.image.load-image.constrain {\n  width: auto;\n}\n.ui.image.load-image.constrain img {\n  max-width: 100%;\n}\n.ui.image.load-image .ui.top.attached.label + [class*=\"right floated\"] + *,\n.ui.image.load-image .ui.top.attached.label:first-child + :not(.attached) {\n  margin-top: 0!important;\n}\n.ui.image.load-image.auto-width {\n  width: auto;\n}\n.ui.image.load-image:not(.loaded):before {\n  content: \"\";\n  background: #CBCBCB;\n  display: block;\n  padding-top: 100%;\n}\n.ui.image.load-image:not(.loaded).ratio1_2:before {\n  padding-top: 200%;\n}\n.ui.image.load-image:not(.loaded).ratio4_3:before {\n  padding-top: 75%;\n}\n.ui.image.load-image:not(.loaded).ratio3_2:before {\n  padding-top: 66.66%;\n}\n.ui.image.load-image:not(.loaded).ratio8_5:before {\n  padding-top: 62.5%;\n}\n.ui.image.load-image:not(.loaded).ratio16_9:before {\n  padding-top: 56.25%;\n}\n.ui.image.load-image:not(.loaded).ratio2_1:before {\n  padding-top: 50%;\n}\n.ui.image.load-image .ui.image.load-image-placeholder {\n  position: absolute;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  -ms-transform: translateY(-50%);\n      transform: translateY(-50%);\n  color: #909090;\n  height: auto !important;\n}\n.ui.image.load-image div > .ui.image {\n  max-width: 100%;\n}\n.ui.image.load-image.video div i.video.play.icon {\n  color: white;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -ms-transform: translate(-50%, -50%);\n      transform: translate(-50%, -50%);\n}\n.ui.modal > .content > .image.hidden {\n  display: none;\n}\n@media only screen and (max-width: 767px) {\n  .ui.modal > .content > .image {\n    padding: 0 !important;\n  }\n}\n.ui.hidden.image,\n.ui.hidden.images {\n  display: none !important;\n}\n.picture-item .ui.dimmer {\n  z-index: 10;\n}\n.picture-item-fixed-size .ui.dimmer {\n  z-index: 10;\n}\n.picture-item-fixed-size div {\n  height: 13em;\n  width: 100% !important;\n}\n.picture-label {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  color: white;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  padding: 0.3em 0.5em;\n  overflow: hidden;\n  text-align: left;\n  background: rgba(0, 0, 0, 0.5);\n}\n.slideshow {\n  position: relative;\n}\n.slideshow .ui.button.slide-show-button {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  color: rgba(255, 255, 255, 0.5);\n  border: none !important;\n  box-shadow: none !important;\n  border-radius: 0;\n}\n.slideshow .ui.button.slide-show-button.right {\n  padding: 1.5em 0.5em 1.5em 2.5em;\n  right: 0;\n}\n.slideshow .ui.button.slide-show-button.left {\n  padding: 1.5em 2.5em 1.5em 0.5em;\n  left: 0;\n}\n.slideshow .ui.button.slide-show-button:hover,\n.slideshow .ui.button.slide-show-button:focus {\n  border: none !important;\n  box-shadow: none !important;\n}\n.slideshow .ui.button.slide-show-button.disabled {\n  color: transparent;\n}\n.slideshow .ui.button.slide-show-button:hover {\n  background: transparent;\n}\n.slideshow .ui.button.slide-show-button:hover.no-touch {\n  color: #FFF;\n}\n.slideshow .ui.button.slide-show-button:hover.no-touch.right {\n  background: linear-gradient(to right, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.75) 100%);\n}\n.slideshow .ui.button.slide-show-button:hover.no-touch.left {\n  background: linear-gradient(to left, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.75) 100%);\n}\n.slideshow .ui.button.slide-show-button:focus {\n  background: transparent;\n}\n.ui.modal.view-large {\n  height: calc(100% - 2rem);\n}\n.ui.modal.view-large > .content.slideshow {\n  padding: 0 !important;\n  -ms-transform-origin: 50%;\n      transform-origin: 50%;\n  top: 40%;\n  -ms-transform: translateY(-50%);\n      transform: translateY(-50%);\n}\n.ui.modal.view-large > .content.slideshow > .load-image:not(.loaded) {\n  height: 80vh;\n}\n.ui.modal.view-large > .content.slideshow > .load-image:not(.loaded):before {\n  content: none;\n}\n.ui.modal.view-large > .content.slideshow > .load-image:not(.loaded) .ui.loader {\n  color: rgba(255, 255, 255, 0.9);\n}\n.ui.modal.view-large > .content.slideshow > .load-image > div > .ui.image > img {\n  max-height: 80vh;\n}\n.ui.modal.view-large > .actions {\n  text-align: center;\n  border-top: none;\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 4vh;\n}\n.ui.modal.view-large > .actions p {\n  font-size: 16px;\n  padding: 0 1em;\n}\n@media only screen and (max-width: 767px) {\n  .ui.modal.view-large {\n    width: 100%;\n    margin: 0 0 0 -50%;\n  }\n  .ui.modal.view-large > .content.slideshow {\n    padding: 0 !important;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .ui.button.slide-show-button.right {\n    padding: 3em 1em 3em 5em !important;\n  }\n  .ui.button.slide-show-button.left {\n    padding: 3em 5em 3em 1em !important;\n  }\n}\n.ui.table td .picture-item .image,\n.ui.table th .picture-item .image,\n.ui.table td .picture-item .image img,\n.ui.table th .picture-item .image img {\n  max-width: 100% !important;\n}\n.picture-list-buttons {\n  padding: 0.5em;\n  text-align: right;\n}\n.prefix .ui.label {\n  margin: 0;\n  min-width: 3em;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.prefix input {\n  border-top-left-radius: 0 !important;\n  border-bottom-left-radius: 0 !important;\n}\n.ui.label.capitalize {\n  text-transform: capitalize;\n}\n.ui.label > .detail {\n  margin-left: 0.5em;\n}\n.ui.button.ui.segment .ui.label.left.corner:after {\n  border-top: 2em solid transparent;\n  border-right: 2em solid transparent;\n  border-top-color: inherit;\n}\n.ui.ribbon.label.ribbon-left {\n  left: -1rem;\n}\n.ui.table .ui.grid .ui.label[class*=\"top left attached\"] {\n  margin-top: 0.1em !important;\n  margin-left: 0.2em;\n}\n.ui.table .ui.grid .ui.label[class*=\"top right attached\"] {\n  margin-top: 0.1em !important;\n  margin-right: 0.2em;\n}\n.ui.table .ui.label[class*=\"top left attached\"],\n.ui.image .ui.label[class*=\"top left attached\"] {\n  border-top-left-radius: 0;\n}\n.ui.table .ui.label[class*=\"top right attached\"],\n.ui.image .ui.label[class*=\"top right attached\"] {\n  border-top-right-radius: 0;\n}\n.list-data .image .ui[class*=\"bottom attached\"].label {\n  border-radius: 0;\n}\n.logo.loading svg g .brick-1 {\n  animation: brick1_blink 1.8s ease-in infinite;\n}\n.logo.loading svg g .brick-2 {\n  animation: brick2_blink 1.8s ease-in infinite;\n}\n.logo.loading svg g .brick-3 {\n  animation: brick3_blink 1.8s ease-in infinite;\n}\n.logo.loading svg g .brick-4 {\n  animation: brick6_blink 1.8s ease-in infinite;\n}\n.logo.loading svg g .brick-5 {\n  animation: brick7_blink 1.8s ease-in infinite;\n}\n.logo.loading svg g .brick-6 {\n  animation: brick8_blink 1.8s ease-in infinite;\n}\n.logo.loading svg g .brick-7 {\n  animation: brick5_blink 1.8s ease-in infinite;\n}\n.logo.loading svg g .brick-8 {\n  animation: brick4_blink 1.8s ease-in infinite;\n}\n@keyframes brick1_blink {\n  0% {\n    opacity: 0.5;\n  }\n  6.25% {\n    opacity: 1;\n  }\n}\n@keyframes brick2_blink {\n  6.25% {\n    opacity: 0.5;\n  }\n  12.50% {\n    opacity: 1;\n  }\n}\n@keyframes brick3_blink {\n  12.50% {\n    opacity: 0.5;\n  }\n  18.75% {\n    opacity: 1;\n  }\n}\n@keyframes brick4_blink {\n  18.75% {\n    opacity: 0.5;\n  }\n  25% {\n    opacity: 1;\n  }\n}\n@keyframes brick5_blink {\n  25% {\n    opacity: 0.5;\n  }\n  31.25% {\n    opacity: 1;\n  }\n}\n@keyframes brick6_blink {\n  31.25% {\n    opacity: 0.5;\n  }\n  37.50% {\n    opacity: 1;\n  }\n}\n@keyframes brick7_blink {\n  37.50% {\n    opacity: 0.5;\n  }\n  43.75% {\n    opacity: 1;\n  }\n}\n@keyframes brick8_blink {\n  43.75% {\n    opacity: 0.5;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n.logo_custom_container {\n  text-align: center !important;\n}\n.logo_custom_wl {\n  margin: 0.5em 0 0 0;\n  max-height: 50px;\n  max-width: 135px;\n}\n@media only screen and (max-width: 767px) {\n  .logo_custom_wl {\n    max-width: 8rem !important;\n  }\n}\n.m-marked ul {\n  margin: 8px 0;\n}\n.m-marked ul li {\n  margin-left: 1.5em;\n  position: relative;\n}\n.m-marked ol {\n  margin: 8px 0;\n}\n.m-marked ol li {\n  margin-left: 1.2em;\n  padding-left: 0.3em;\n  position: relative;\n}\n.language-switcher {\n  display: inline-block;\n  position: relative;\n  margin-left: 1em;\n}\n.language-switcher select {\n  padding: 0.5em 3.5em 0.5em 0.75em;\n  border: 1px solid rgba(88, 105, 118, 0.2);\n  border-radius: 4px;\n  background-color: rgba(255, 255, 255, 0.1);\n  color: #586976;\n  font-size: 0.9em;\n  cursor: pointer;\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background-image: url('data:image/svg+xml;utf8,<svg fill=\"%23586976\" height=\"24\" viewBox=\"0 0 24 24\" width=\"24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 10l5 5 5-5z\"/></svg>');\n  background-repeat: no-repeat;\n  background-position: right 0.5em center;\n  background-size: 1.2em;\n  outline: none;\n  transition: all 0.2s ease;\n}\n.language-switcher select:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n  border-color: #586976;\n}\n.language-switcher select:focus,\n.language-switcher select:focus-visible {\n  border-color: #586976;\n  box-shadow: 0 0 0 3px rgba(88, 105, 118, 0.35);\n}\n.language-switcher select:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n.language-switcher select.loading {\n  opacity: 0.7;\n}\n.language-switcher select option {\n  background-color: #fff;\n  color: #333;\n  padding: 0.5em;\n}\n.language-switcher .spinner {\n  position: absolute;\n  right: 2em;\n  top: 50%;\n  pointer-events: none;\n  -ms-transform: translateY(-50%);\n      transform: translateY(-50%);\n  font-size: 1.2em;\n  color: #586976;\n  animation: spin 1s linear infinite;\n}\n@keyframes spin {\n  from {\n    transform: translateY(-50%) rotate(0deg);\n  }\n  to {\n    transform: translateY(-50%) rotate(360deg);\n  }\n}\n.language-switcher {\n  position: relative;\n}\n.language-switcher [role=\"alert\"] {\n  position: absolute;\n  right: 0;\n  top: 100%;\n  width: 280px;\n  max-width: 80vw;\n  padding: 12px;\n  background: #fff;\n  color: #333;\n  white-space: normal;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  z-index: 1500;\n}\n.ui.dimmer .ui.loader {\n  color: black;\n}\n.ui.dimmer .ui.loader:before {\n  border-color: rgba(0, 0, 0, 0.1);\n}\n.ui.dimmer .ui.loader:after {\n  border-color: #767676 transparent transparent;\n}\n.ui.dimmer.not(.modals) .ui.loader {\n  color: rgba(255, 255, 255, 0.9);\n}\n.ui.dimmer.not(.modals) .ui.loader:before {\n  border-color: rgba(255, 255, 255, 0.15);\n}\n.ui.dimmer.not(.modals) .ui.loader:after {\n  border-color: #FFF transparent transparent;\n}\n@media only screen and (min-width: 765px) {\n  .stepsContainer {\n    padding: 3rem !important;\n  }\n}\n@media only screen and (max-width: 764px) {\n  .stepsContainer {\n    padding: 3rem 0.5rem !important;\n    border: none !important;\n    box-shadow: none !important;\n  }\n  .stepsContainer.customer {\n    margin-left: 1em !important;\n    margin-right: 1em !important;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .buttonBorder .ui.container {\n    margin-left: 0.1em !important;\n    margin-right: 0.1em !important;\n  }\n}\n.progressBar .ui.progress {\n  background: #e5f4f5;\n}\n.progressBar .ui.progress .bar {\n  background-color: #00979c;\n}\n.nextButton .ui.fluid.button {\n  background: #5bc699;\n  color: white;\n}\n@media only screen and (min-width: 765px) {\n  .nextButton .ui.fluid.button {\n    width: 40%;\n    float: right;\n  }\n}\n.nextButton .ui.fluid.button:hover {\n  background: rgba(91, 198, 153, 0.7);\n}\n.backButton .ui.button {\n  background: transparent;\n  color: #5bc699;\n}\n@media only screen and (min-width: 765px) {\n  .backButton .ui.button {\n    float: left;\n    width: 22%;\n    text-align: left;\n  }\n}\n@media only screen and (max-width: 764px) {\n  .backButton .ui.button {\n    width: 100%;\n    padding-top: 2rem;\n  }\n}\n.backButton .ui.button:hover {\n  color: rgba(91, 198, 153, 0.7);\n}\n.menuTab .ui.menu .item {\n  background: #e7ecf1;\n  color: #00233b !important;\n  padding: 1.5rem;\n}\n.menuTab .ui.menu .active.item {\n  background: #00233b;\n  color: #e7ecf1 !important;\n}\n.consentLink {\n  background: transparent !important;\n  color: #00979c !important;\n}\n.consentLink:hover {\n  color: rgba(0, 151, 156, 0.7) !important;\n}\n.replaceButton .ui.button {\n  text-align: center;\n  color: #0097a1 !important;\n  background: transparent !important;\n  width: auto;\n}\n.replaceButton .ui.button:hover {\n  color: rgba(0, 151, 161, 0.7) !important;\n}\n.eSignButton .ui.button {\n  background: #00979c;\n  color: white;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 1rem 2rem;\n}\n.eSignButton .ui.button:hover {\n  background: rgba(0, 151, 156, 0.7) !important;\n}\n.loanInfoContainer {\n  border-top: 1px solid #a4b3c1;\n  padding: 1rem;\n  border-radius: 0.25rem;\n  width: 100% !important;\n}\n.spaValueContainer {\n  border: 1px solid #aabac9;\n  border-radius: 0.3rem;\n  background: white;\n  height: 2.5rem;\n  opacity: 0.45;\n  margin-bottom: 1rem;\n  width: 100%;\n  text-align: left;\n  padding-top: 0.5rem;\n  padding-left: 1rem;\n}\n.ctosButton .ui.basic.button {\n  margin: 1rem !important;\n  color: #2185d0 !important;\n  border: 1px solid #2185d0 !important;\n  box-shadow: 0 0 0 0 !important;\n}\n.ctosButton .ui.basic.button:hover {\n  color: rgba(33, 133, 208, 0.7) !important;\n  border: 1px solid rgba(33, 133, 208, 0.7) !important;\n}\n.ctosDSRContainerLeft {\n  width: 50% ;\n  float: left;\n  margin: 0;\n}\n.ctosDSRContainerRight {\n  width: 50%;\n  float: right;\n  margin: 0;\n  border-left: 1px solid #c0c7cd;\n}\n.ctosFooterLabel .ui.mini.image {\n  height: 10px !important;\n  width: auto !important;\n  display: inline-block;\n}\n.searchUnitButton .ui.button {\n  background: #33cc99;\n  color: white;\n  padding: 1rem 2rem;\n}\n.searchUnitButton .ui.button:hover {\n  background: rgba(51, 204, 153, 0.7);\n}\n@media only screen and (min-width: 765px) {\n  .outerDiv .outerContainer {\n    border: 1px solid #d9dadc;\n    padding: 3rem 3%;\n    border-radius: 0.25rem;\n  }\n}\n@media only screen and (max-width: 764px) {\n  .outerDiv .outerContainer {\n    padding: 3rem 0;\n    margin-left: 0.1em !important;\n    margin-right: 0.1em !important;\n  }\n}\n.new-credit-check .ui.header {\n  color: #00233b;\n}\n.new-credit-check .ui.header .sub.header {\n  color: #00233b;\n}\n.new-credit-check .ui.header i.inverted.circular.green.icon {\n  background-color: rgba(0, 151, 156) !important;\n  padding: 0.5em !important;\n}\n.runCreditCheckButton .ui.positive.button,\n.ui.positive.buttons .button {\n  background-color: #33cc99 !important;\n  color: white;\n  padding: 1rem 2rem;\n}\n.runCreditCheckButton .ui.positive.button:hover {\n  background-color: rgba(51, 204, 153, 0.7) !important;\n}\n@media only screen and (min-width: 765px) {\n  .creditCheckGrid {\n    width: 100%;\n  }\n}\n.ctosScoreContainer {\n  padding: 1rem;\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n  height: 10rem;\n}\n.ctosDsrHeader .ui.button {\n  padding: 0;\n  background: transparent;\n  margin-left: 0.1rem;\n}\n.ctosDsrModalButton .ui.button {\n  background: #5bc699;\n  color: white;\n  box-shadow: 2px 2px rgba(0, 0, 0, 0.16);\n}\n.ctosDsrModalButton .ui.button:hover {\n  background: rgba(91, 198, 153, 0.7);\n}\n.projectUnitPackagePricingView > .row {\n  border-bottom: 1px solid #efefef;\n}\n.projectUnitPackagePricingView > .row .spaValue {\n  color: #696867 !important;\n}\n.projectUnitPreview h3 {\n  margin-bottom: 0;\n}\n.projectUnitPreview h5 {\n  margin-bottom: 0;\n}\n.projectUnitPackagePricingView.projectUnitPreview {\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n}\n.packagePricingApplyToBookingFlag {\n  text-align: right;\n  margin-left: 1rem;\n  font-style: italic;\n}\n@media only screen and (max-width: 767px) {\n  .ui.popup.popupUnitInfo .ui.grid .row {\n    padding: 0;\n  }\n}\n.ui.menu.unitInfoPPpopupButton {\n  border: none;\n  box-shadow: none;\n}\n.ui.menu.unitInfoPPpopupButton .item {\n  line-height: 2;\n  padding-bottom: 0;\n}\n@media only screen and (min-width: 767px) {\n  .ui.menu.unitInfoPPpopupButton .item:first-child {\n    padding-top: 0;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .ui.menu.unitInfoPPpopupButton .item:not(:first-child) {\n    padding-bottom: 0.5em;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .ui.menu.unitInfoPPpopupButton .item:last-child {\n    padding-bottom: 1em;\n  }\n}\n.ui.menu.unitInfoPPpopupButton .item:before {\n  display: none;\n}\n.ui.menu.unitInfoPPpopupButton .item.deleteUnitPackagePricing .button {\n  color: red;\n}\n.ui.menu.unitInfoPPpopupButton .item.deleteUnitPackagePricing .button span {\n  color: red;\n  margin-left: 0.3em;\n}\n.ui.menu.unitInfoPPpopupButton .item.deleteUnitPackagePricing .button .icon {\n  font-size: 1.1em;\n}\n.ui.menu.unitInfoPPpopupButton span {\n  font-size: 1.1em;\n  margin-right: 1em;\n}\n@media only screen and (min-width: 1000px) {\n  .ui.menu.unitInfoPPpopupButton span {\n    margin-right: 3rem;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .ui.menu.unitInfoPPpopupButton span {\n    font-size: 1.1em;\n  }\n}\n@media only screen and (max-width: 320px) {\n  .ui.menu.unitInfoPPpopupButton span {\n    font-size: 0.9em;\n  }\n}\n.ui.menu.unitInfoPPpopupButton .checkbox {\n  float: right;\n  padding-top: 4px;\n}\n.ui.menu.unitInfoPPpopupButton .button {\n  margin: 0 auto;\n  text-align: center;\n  vertical-align: middle;\n  padding-left: 0;\n  padding-right: 1em;\n  border: none;\n  color: red;\n  box-shadow: none;\n}\n.ui.menu.unitInfoPPpopupButton .button i.icon {\n  margin: 0 auto !important;\n}\n.ui.menu.unitInfoPPpopupButton .button span {\n  font-size: 1.1em;\n  margin-right: 1em;\n}\n@media only screen and (min-width: 1000px) {\n  .ui.menu.unitInfoPPpopupButton .button span {\n    margin-right: 3rem;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .ui.menu.unitInfoPPpopupButton .button span {\n    font-size: 1.1em;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .projectUnitPreview h3 {\n    font-size: 1em;\n  }\n  .projectUnitPreview h5 {\n    font-size: 0.8rem;\n  }\n  .ui.grid {\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .previewButton {\n    background: none;\n    box-shadow: none !important;\n    top: -2.9em;\n    padding: 0;\n  }\n}\n.content-placeholder {\n  position: relative;\n}\n.content-placeholder .header,\n.content-placeholder .paragraph {\n  animation-duration: 1s;\n  animation-fill-mode: forwards;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n  animation-name: placeHolderShimmer;\n  background: #f6f7f8;\n  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);\n  background-size: 800px 104px;\n  margin-bottom: 0.5em;\n}\n.content-placeholder .header {\n  width: 40%;\n  height: 2em;\n  margin-bottom: 1em;\n}\n.content-placeholder .header.sub {\n  width: 35%;\n  height: 1.5em;\n}\n.content-placeholder .paragraph {\n  width: 100%;\n  height: 1em;\n}\n.content-placeholder .paragraph.first {\n  width: 90%;\n  margin-left: 10%;\n}\n.content-placeholder.right .header {\n  margin-left: 60%;\n}\n.content-placeholder.right .header.sub {\n  margin-left: 65%;\n}\n.show-more {\n  text-align: center;\n  position: absolute;\n  left: 50%;\n  top: 100%;\n  -ms-transform: translateX(-50%);\n      transform: translateX(-50%);\n}\n.expandable {\n  max-height: 34vh;\n  overflow: hidden;\n}\n.expandable:after {\n  position: absolute;\n  bottom: 0;\n  height: 100%;\n  width: 100%;\n  content: \"\";\n  background: linear-gradient(to top, #ffffff 0%, rgba(255, 255, 255, 0) 30%);\n  pointer-events: none;\n}\n@keyframes placeHolderShimmer {\n  0% {\n    background-position: -400px 0;\n  }\n  100% {\n    background-position: 400px 0;\n  }\n}\n.ui.bottom.center.tiny.very.wide.basic.popup.transition.visible.popupList {\n  margin-top: 2px;\n}\n.ui.progress.progress-barchart {\n  margin: 0;\n  border-radius: 0;\n  background-color: #fff !important;\n}\n.ui.progress.progress-barchart > .bar {\n  min-width: 0.25em;\n  border-radius: 0;\n  transition: 1.8s all ease-out;\n}\n@keyframes progress-bar-increase {\n  0% {\n    max-width: 0%;\n  }\n  100% {\n    max-width: 100%;\n  }\n}\n.row.users-bookings.table {\n  padding-bottom: 0 !important;\n  padding-top: 0 !important;\n}\n@media only screen and (min-width: 768px) {\n  .row.users-bookings.controls {\n    padding-bottom: 0 !important;\n  }\n}\n.row.users-bookings.bottom-controls {\n  padding-top: 0 !important;\n}\n@media only screen and (max-width: 600px) {\n  .hide-mobile-six-hundred-px {\n    display: none !important;\n  }\n  .mobile-report-table {\n    overflow: scroll;\n    padding: 0 !important;\n  }\n}\n.app--searchcontrols.advance {\n  transition: background-color 0s, all 0.3s;\n}\n.app--searchcontrols.advance .filtercontrols {\n  max-height: 300px;\n  overflow: inherit;\n  transition: all 0.3s;\n  opacity: 1;\n}\n.app--searchcontrols.advance .filtercontrols .ui.active.dropdown {\n  z-index: 1001 !important;\n}\n.app--searchcontrols.advance .filtercontrols .ui.active.dropdown > .menu {\n  z-index: 1002 !important;\n}\n.app--searchcontrols.advance:not(.hide-side) {\n  background-color: whitesmoke;\n}\n.app--searchcontrols.advance:not(.hide-side)::after,\n.app--searchcontrols.advance:not(.hide-side)::before {\n  content: '';\n}\n.app--searchcontrols.advance::after,\n.app--searchcontrols.advance::before {\n  transition: all 0.3s;\n  width: 100vw;\n  height: 100%;\n  top: 0;\n  position: absolute;\n  background: whitesmoke;\n}\n.app--searchcontrols.advance::after {\n  left: 99.5%;\n}\n.app--searchcontrols.advance::before {\n  right: 99.5%;\n}\n.app--searchcontrols .search-button-only {\n  border-bottom-left-radius: 0!important;\n  border-top-left-radius: 0!important;\n}\n.app--searchcontrols .searchinput .column {\n  padding: 1em 1em 0em !important;\n}\n.app--searchcontrols .searchinput .column.leftjoin {\n  padding-right: 0 !important;\n}\n.app--searchcontrols .searchinput .column.leftjoin .button.search-button {\n  border-radius: 0!important;\n}\n.app--searchcontrols .searchinput .column.leftjoin .button.search-button-only {\n  border-bottom-left-radius: 0!important;\n  border-top-left-radius: 0!important;\n}\n.app--searchcontrols .searchinput .column.rightjoin {\n  padding-left: 0 !important;\n}\n.app--searchcontrols .searchinput .column.rightjoin .button.advance-button {\n  padding: 0.81em 0.75em;\n  font-size: 1.02em !important;\n  border-bottom-left-radius: 0!important;\n  border-top-left-radius: 0!important;\n}\n.app--searchcontrols .searchinput .column > form .ui.icon.input > i.teal.icon {\n  right: 2.5em;\n}\n.app--searchcontrols .filtercontrols {\n  max-height: 0px;\n  overflow: hidden;\n  transition: all 0.3s;\n  opacity: 0;\n}\n.app--searchcontrols .filtercontrols .clearicon {\n  padding-left: 0em !important;\n  text-align: center;\n}\n.app--searchcontrols .filtercontrols > .column {\n  padding: 0em 1em 1em !important;\n}\n.app--searchcontrols .filtercontrols > .column .filtertitle {\n  font-size: 0.75em;\n  margin-top: 0.571em;\n}\n.app--searchcontrols .filtercontrols > .column > .grid {\n  margin-top: 0!important;\n}\n.app--searchcontrols .filtercontrols > .column > .grid > .row {\n  padding-top: 0.1em;\n}\n.app--searchcontrols .filtercontrols > .column > .grid > .row > .column {\n  margin: 0.35em 0;\n}\n.app--listcontrols .right {\n  padding-left: 0 !important;\n}\n.searchlist.scrollresults .results {\n  overflow-y: scroll;\n  max-height: 40vh;\n}\n.searchlist .ui.icon.input {\n  width: 100% !important;\n}\n.searchlist .ui.icon.input input {\n  border-radius: 0.28571429rem !important;\n}\n.searchlist .results .result .image {\n  width: auto !important;\n}\nform.search-in {\n  display: -ms-flexbox;\n  display: flex;\n}\nform.search-in .ui.input {\n  -ms-flex: 1 0 auto;\n      flex: 1 0 auto;\n}\nform.search-in .ui.input input {\n  border-right: none;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\nform.search-in .ui.dropdown {\n  width: 0;\n  -ms-flex: 0.7 0 auto;\n      flex: 0.7 0 auto;\n  border-right: none;\n  border-radius: 0;\n  white-space: nowrap;\n  text-align: right;\n  border-width: thin 2px;\n}\nform.search-in .ui.dropdown.small {\n  -ms-flex: 0.3 0 auto;\n      flex: 0.3 0 auto;\n}\nform.search-in .ui.dropdown.ui.active.selection.dropdown {\n  border-width: thin !important;\n}\n@media only screen and (max-width: 991px) {\n  form.search-in .ui.dropdown {\n    -ms-flex: 0.4 0 auto;\n        flex: 0.4 0 auto;\n  }\n}\nform.search-in .ui.button.search {\n  background: #2CADC3;\n  color: white;\n  border: none;\n}\n.modal.signature > .content {\n  text-align: center;\n}\n.modal.signature > .content > p {\n  text-align: center;\n  font-weight: bold;\n  color: #828282;\n}\n.modal.signature > .content > .wrapper {\n  position: relative;\n  width: 100%;\n  height: 100%;\n}\n.modal.signature > .content > .wrapper:before,\n.modal.signature > .content > .wrapper:after,\n.modal.signature > .content > .wrapper > :first-child:before,\n.modal.signature > .content > .wrapper > :first-child:after {\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  border-color: #9e9e9e;\n  border-style: solid;\n  content: ' ';\n}\n.modal.signature > .content > .wrapper:before {\n  top: 0;\n  left: 0;\n  border-width: 2px 0 0 2px;\n}\n.modal.signature > .content > .wrapper:after {\n  top: 0;\n  right: 0;\n  border-width: 2px 2px 0 0;\n}\n.modal.signature > .content > .wrapper > :first-child:before {\n  bottom: 0;\n  right: 0;\n  border-width: 0 2px 2px 0;\n}\n.modal.signature > .content > .wrapper > :first-child:after {\n  bottom: 0;\n  left: 0;\n  border-width: 0 0 2px 2px;\n}\n.modal.signature > .actions {\n  text-align: center;\n}\n.signature-upload .consent-box {\n  text-align: left;\n}\n@media only screen and (min-width: 768px) {\n  .signature-upload .consent-box {\n    padding-left: 0.6em;\n    padding-right: 0.6em;\n  }\n}\n.signature-upload .consent-box .detail {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: start;\n      justify-content: start;\n}\n.signature-upload .consent-box .detail > div {\n  max-width: 15em;\n  margin-left: 0.4em;\n}\n.signature-upload .consent-box .detail > div > :not(:last-child) {\n  margin-bottom: 0;\n}\n.signature-upload .consent-box h4 {\n  margin: 0;\n}\n.signature-upload .consent-box ol {\n  counter-reset: list;\n  position: relative;\n}\n.signature-upload .consent-box ol > li {\n  list-style: none;\n  margin-left: 2.5em;\n  margin-bottom: 1em;\n}\n@media only screen and (max-width: 767px) {\n  .signature-upload .consent-box ol > li {\n    margin-left: 1.5em;\n  }\n}\n.signature-upload .consent-box ol > li:before {\n  left: 0px;\n  position: absolute;\n  list-style-position: inside;\n  content: counter(list, lower-roman) \") \";\n  counter-increment: list;\n  margin-right: 1.5em;\n}\n.signature-upload .consent-box ol > li > ul {\n  margin-top: 1em;\n}\n.signature-upload .consent-box ol > li > ul > li {\n  list-style-type: none;\n  list-style-position: inside;\n  text-indent: -1.7em;\n  margin-left: 1.7em;\n}\n.signature-upload .esigning-button {\n  padding: 1.5em;\n  background-color: #C5C5C5;\n  /* except mobile */\n}\n.signature-upload .esigning-button > div {\n  position: relative;\n  padding: 1.5em;\n}\n.signature-upload .esigning-button > div:before,\n.signature-upload .esigning-button > div:after,\n.signature-upload .esigning-button > div > :first-child:before,\n.signature-upload .esigning-button > div > :first-child:after {\n  position: absolute;\n  width: 10px;\n  height: 10px;\n  border-color: #9e9e9e;\n  border-style: solid;\n  content: ' ';\n}\n.signature-upload .esigning-button > div:before {\n  top: 0;\n  left: 0;\n  border-width: 2px 0 0 2px;\n}\n.signature-upload .esigning-button > div:after {\n  top: 0;\n  right: 0;\n  border-width: 2px 2px 0 0;\n}\n.signature-upload .esigning-button > div > :first-child:before {\n  bottom: 0;\n  right: 0;\n  border-width: 0 2px 2px 0;\n}\n.signature-upload .esigning-button > div > :first-child:after {\n  bottom: 0;\n  left: 0;\n  border-width: 0 0 2px 2px;\n}\n.signature-upload .row.sign {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  padding-bottom: 0;\n}\n.signature-upload .row.sign > .column {\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -ms-flex: 0 0 auto !important;\n      flex: 0 0 auto !important;\n  width: auto;\n}\n.signature-upload .row.sign > .column:first-child {\n  text-align: right;\n  padding-right: 0;\n}\n.signature-upload .row.sign .icon {\n  position: relative;\n  vertical-align: middle;\n  text-align: center;\n  display: inline-block;\n  width: 3em;\n  height: 3em;\n  font-size: 0.9em;\n  background-color: #3C88CC;\n  color: white;\n}\n.signature-upload .row.sign .icon img {\n  top: 50%;\n  left: 50%;\n  -ms-transform: translate(-50%, -50%);\n      transform: translate(-50%, -50%);\n  position: absolute;\n  width: 1.6em;\n  height: auto;\n}\n.signature-upload .row.sign .icon.round {\n  border-radius: 50%;\n}\n.sortablehoc_item {\n  margin: 0.5em auto;\n}\n.sortablehoc_item.sorting {\n  z-index: 1001 !important;\n  cursor: -webkit-grabbing !important;\n  cursor: grabbing !important;\n  pointer-events: all !important;\n}\n.sortablehoc_item .button.basic {\n  background-color: #fff !important;\n}\n@media only screen and (max-width: 767px) {\n  .sortablehoc_item .row_item {\n    padding: 0.5em !important;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .sortablehoc_item .row_item {\n    padding: 1em !important;\n  }\n}\n.sortablehoc_item .row_item .column {\n  padding: 0 !important;\n}\n.sortablehoc_item .row_item .label.basic {\n  color: rgba(0, 0, 0, 0.6) !important;\n}\n.sortablehoc_item .row_item .sorting_buttons {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.sortablehoc_item .row_item .sorting_buttons .sort_button .button {\n  font-size: 0.55rem !important;\n  padding: 0.3rem 0.6rem !important;\n}\n.sortablehoc_item .row_item .text_name {\n  font-weight: bold;\n}\n.sortablehoc_item .row_item .text_description {\n  font-size: 0.85em;\n}\n.sortablehoc_item .dragicon {\n  cursor: -webkit-grab;\n  cursor: grab;\n}\n.sortablehoc_item .segment.editing.package {\n  background-color: #f8f8f8;\n}\n.sortablehoc_item .segment.editing.item {\n  background-color: #e7eaed;\n}\n.sortablehoc_item .validate.field,\n.sortablehoc_item .validate.field > .error.field {\n  margin: 0 0 0.25em;\n}\n.sortablehoc_item .validate.field span.error,\n.sortablehoc_item .validate.field > .error.field span.error {\n  color: red;\n  font-style: italic;\n}\n.project_package_pricing .row_content,\n.project_package_pricing_item .row_content {\n  padding: 0 !important;\n}\n.project_package_pricing .row_content .segment_formula_not_found,\n.project_package_pricing_item .row_content .segment_formula_not_found,\n.project_package_pricing .row_content .segment_pricing_package_not_found,\n.project_package_pricing_item .row_content .segment_pricing_package_not_found {\n  margin-bottom: 1em;\n}\n.project_package_pricing .row_button_add,\n.project_package_pricing_item .row_button_add {\n  padding-top: 0.5em !important;\n}\n.project_package_pricing .row_name_desc,\n.project_package_pricing_item .row_name_desc {\n  padding-bottom: 1em !important;\n  padding-top: 0 !important;\n}\n@media only screen and (max-width: 767px) {\n  .project_package_pricing .row_name_desc .column:first-child,\n  .project_package_pricing_item .row_name_desc .column:first-child {\n    padding-bottom: 1em;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .project_package_pricing .row_enable_bumi_delete,\n  .project_package_pricing_item .row_enable_bumi_delete,\n  .project_package_pricing .row_enable_formula_delete,\n  .project_package_pricing_item .row_enable_formula_delete {\n    padding-top: 0em !important;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .project_package_pricing .row_enable_bumi_delete,\n  .project_package_pricing_item .row_enable_bumi_delete,\n  .project_package_pricing .row_enable_formula_delete,\n  .project_package_pricing_item .row_enable_formula_delete {\n    padding: 0em !important;\n  }\n}\n.project_package_pricing .row_enable_bumi_delete .ui.checkbox label,\n.project_package_pricing_item .row_enable_bumi_delete .ui.checkbox label,\n.project_package_pricing .row_enable_formula_delete .ui.checkbox label,\n.project_package_pricing_item .row_enable_formula_delete .ui.checkbox label {\n  margin: 0.5em 0;\n  font-size: 13px;\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.87);\n}\n@media only screen and (max-width: 767px) {\n  .project_package_pricing .row_enable_bumi_delete .column_delete,\n  .project_package_pricing_item .row_enable_bumi_delete .column_delete,\n  .project_package_pricing .row_enable_formula_delete .column_delete,\n  .project_package_pricing_item .row_enable_formula_delete .column_delete {\n    text-align: left;\n  }\n  .project_package_pricing .row_enable_bumi_delete .column_delete .button,\n  .project_package_pricing_item .row_enable_bumi_delete .column_delete .button,\n  .project_package_pricing .row_enable_formula_delete .column_delete .button,\n  .project_package_pricing_item .row_enable_formula_delete .column_delete .button {\n    margin-top: 0.5em;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .project_package_pricing .row_enable_bumi_delete .column_delete,\n  .project_package_pricing_item .row_enable_bumi_delete .column_delete,\n  .project_package_pricing .row_enable_formula_delete .column_delete,\n  .project_package_pricing_item .row_enable_formula_delete .column_delete {\n    text-align: right;\n  }\n}\n.project_package_pricing .row_label,\n.project_package_pricing_item .row_label {\n  display: block;\n  margin: 0 0 0.28571429rem 0;\n  color: rgba(0, 0, 0, 0.87);\n  font-size: 0.92857143em;\n  font-weight: 700;\n  text-transform: none;\n  padding: 0;\n  background: transparent;\n  line-height: 1.4285em;\n}\n.project_package_pricing .header_title {\n  color: #696867;\n}\n.project_package_pricing .row_schedule_bu_access {\n  padding-top: 0em !important;\n  padding-bottom: 0.5em !important;\n}\n.project_package_pricing .row_schedule_bu_access .ui.segment.dtp.visible {\n  margin-bottom: 1em !important;\n}\n.project_package_pricing .row_formula {\n  padding-top: 0 !important;\n}\n.project_package_pricing .row_formula .label_formula_type {\n  margin: 0 0 0.28571429rem 0;\n  font-size: 13px;\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.87);\n}\n.project_package_pricing .row_bulk_manage_unit_pp {\n  padding: 0;\n}\n.project_package_pricing .row_bulk_manage_unit_pp .ui.grid > .row {\n  padding: 0;\n}\n@media only screen and (min-width: 768px) {\n  .project_package_pricing .row_bulk_manage_unit_pp .ui.grid > .row .column:first-child {\n    text-align: right;\n  }\n  .project_package_pricing .row_bulk_manage_unit_pp .ui.grid > .row .column:last-child {\n    text-align: left;\n  }\n}\n.project_package_pricing .row_bulk_manage_unit_pp .ui.grid > .row .column {\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n}\n.project_package_pricing_item {\n  padding: 0 !important;\n  background-color: #f8f8f8 !important;\n}\n.project_package_pricing_item .header_title {\n  color: rgba(0, 0, 0, 0.87) !important;\n}\n@media only screen and (min-width: 768px) {\n  .project_package_pricing_item .row_enable_formula_delete .row_formula_dropdown_input .column:first-child {\n    padding-right: 0.5em !important;\n  }\n  .project_package_pricing_item .row_enable_formula_delete .row_formula_dropdown_input .column:last-child {\n    padding-left: 0.5em !important;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .project_package_pricing_item .row_enable_formula_delete .row_formula_dropdown_input .column {\n    padding-bottom: 1em;\n  }\n}\n.project_package_pricing_item .row_enable_formula_delete .row_formula_dropdown_input .icon_custom_formula_help {\n  cursor: pointer !important;\n  pointer-events: auto  !important;\n  opacity: 1 !important;\n}\n@media only screen and (max-width: 767px) {\n  .project_package_pricing_item .row_enable_formula_delete .ui.checkbox {\n    padding-bottom: 1em;\n  }\n}\n.project_package_pricing_item .row_label {\n  display: block;\n  margin: 0 0 0.28571429rem 0;\n  color: rgba(0, 0, 0, 0.87);\n  font-size: 0.92857143em;\n  font-weight: 700;\n  text-transform: none;\n  padding: 0;\n  background: transparent;\n  line-height: 1.4285em;\n}\n@media only screen and (max-width: 767px) {\n  .package_pricing_unit .row_enable_package_custom_price {\n    padding-bottom: 2em !important;\n    padding-left: 1em !important;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .package_pricing_unit .row_enable_package_custom_price .column:first-child {\n    padding: 1em;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .package_pricing_unit .row_enable_package_custom_price .column:first-child {\n    padding: 0 1em;\n  }\n}\n.package_pricing_unit .row_enable_package_custom_price .ui.checkbox label {\n  font-size: 13px;\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.87);\n}\n.package_pricing_unit .row_name_desc {\n  padding-bottom: 1em;\n  padding-top: 0 !important;\n}\n@media only screen and (max-width: 767px) {\n  .package_pricing_unit .row_name_desc {\n    padding-left: 1em !important;\n    padding-bottom: 2em !important;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .package_pricing_unit .row_name_desc .column:first-child {\n    padding-bottom: 1em;\n  }\n}\n.package_pricing_unit .text_name {\n  font-weight: bold;\n}\n.package_pricing_unit .text_description {\n  font-size: 0.85em;\n}\n.segment_unit_pricing_package_not_found {\n  margin-bottom: 1em;\n}\n@media only screen and (max-width: 767px) {\n  .projectUnitPackagePricingView.projectUnitPreview > .singlePPItemRow {\n    width: 100% !important;\n  }\n}\n.ui.grid .column.tab-status {\n  padding: 0.5em 0;\n  font-size: 12px;\n  font-weight: bold;\n  color: #FFF;\n  background-color: #333;\n  margin: 0;\n  max-width: 100px;\n  cursor: pointer;\n}\n.ui.grid .column.tab-status p {\n  font-size: 18px;\n  margin: 0;\n}\n.ui.grid .column.tab-status i {\n  width: 100%;\n  margin: -0.25em 0 0.5em 0;\n}\n@media only screen and (max-width: 768px) {\n  .ui.grid .column.tab-status {\n    font-size: 10px;\n  }\n  .ui.grid .column.tab-status p {\n    font-size: 16px;\n  }\n}\n.ui.grid .column.tab-status.selected {\n  box-shadow: inset 0 0 0 5px white;\n}\n.ui.grid .column.tab-status:not(.selected) {\n  padding-bottom: 1.75em;\n}\n.text_minimal {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.text_minimal:hover {\n  white-space: normal;\n  text-overflow: initial;\n  overflow: visible;\n  word-break: break-word;\n}\n.text_minimal.single:hover {\n  width: 100% !important;\n  text-overflow: initial;\n  overflow: visible;\n}\n.text_expand {\n  word-break: break-word;\n}\n.text_expand_single {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.clock_number {\n  width: 2.1em;\n  margin: auto;\n  background: #555;\n  color: #f7f7f7;\n  padding: 1rem 0.2rem;\n  border-radius: 0.3rem;\n  box-shadow: 0 1px 2px 0 rgba(34, 36, 38, 0.15);\n}\n.clock_numbers {\n  padding: 0 !important;\n}\n.clock_top.controls {\n  padding: 0.3em 0;\n}\n.clock_bottom.controls {\n  padding: 0.3em 0 0.4em 0;\n}\n.controls .icon {\n  cursor: pointer;\n  color: #1a69a4;\n}\n.controls .icon:hover {\n  color: #1678c2;\n}\n.controls .icon:active {\n  color: #1a69a4;\n}\n/* Container Wrapper Layout */\n.refund-detail-wrapper {\n  margin-bottom: 1.5rem;\n}\n/* Core Status Block Styles */\n.refund-status-block.ui.segment {\n  border-radius: 8px;\n  border: 1px solid transparent;\n  padding: 1.5rem;\n  box-shadow: none;\n}\n/* AC 1: Pending Refund Color Theme (Yellow/Orange) */\n.refund-container-pending.ui.segment {\n  background-color: #FFF7EC !important;\n  border-color: #FCD8A5 !important;\n}\n.refund-container-pending .refund-header-title {\n  color: #8A5000;\n  font-size: 1.15rem;\n}\n/* AC 2: Refund Completed Color Theme (Green) */\n.refund-container-completed.ui.segment {\n  background-color: #EBF7ED !important;\n  border-color: #C3E6CB !important;\n}\n.refund-container-completed .refund-header-title {\n  color: #1E4620;\n  font-size: 1.15rem;\n}\n/* AC 3: Refund Denied Color Theme (Red) */\n.refund-container-denied.ui.segment {\n  background-color: #FCE8E6 !important;\n  border-color: #F5C2C1 !important;\n}\n.refund-container-denied .refund-header-title {\n  color: #611A15;\n  font-size: 1.15rem;\n}\n/* Grid Fields Structure Styling */\n.refund-fields-grid .field-row {\n  padding-top: 0.35rem !important;\n  padding-bottom: 0.35rem !important;\n}\n.refund-fields-grid .field-label {\n  color: #7A5B35;\n  font-weight: 500;\n}\n/* When state transitions to complete/denied, labels darken contextually */\n.refund-container-completed .refund-fields-grid .field-label {\n  color: #3B613D;\n}\n.refund-container-denied .refund-fields-grid .field-label {\n  color: #8A433E;\n}\n.refund-fields-grid .field-value {\n  color: #2D2D2D;\n}\n.font-weight-bold {\n  font-weight: bold;\n}\n/* Elegant visual separators matching mocks */\n.refund-status-block .divider-line {\n  border: 0;\n  border-top: 1px solid rgba(0, 0, 0, 0.08);\n  margin: 1rem 0;\n  width: 100%;\n}\n/* Bottom Actions Control Footer */\n.refund-actions-footer {\n  margin-top: 1.5rem;\n  padding-top: 1rem;\n}\n.outcome-confirmation-text {\n  color: #7A5B35;\n  margin-bottom: 1rem !important;\n}\n.refund-actions-footer .buttons-group {\n  display: -ms-flexbox;\n  display: flex;\n  gap: 12px;\n}\n.refund-actions-footer .ui.button.btn-outcome {\n  background-color: transparent !important;\n  color: #333333 !important;\n  border: 1px solid #BCB0A1 !important;\n  border-radius: 6px !important;\n  font-weight: 600;\n  padding: 0.75rem 1.25rem;\n  box-shadow: none !important;\n  /* Removes any default Semantic UI button shadows */\n  transition: all 0.2s ease;\n}\n.refund-actions-footer .ui.button.btn-outcome:hover {\n  background-color: rgba(0, 0, 0, 0.03) !important;\n  border-color: #8A7E70 !important;\n  color: #111111 !important;\n  box-shadow: none !important;\n}\n.reject-refund-wrapper {\n  padding: 0.5rem 0;\n}\n.required-asterisk {\n  color: #DB2828;\n  margin-left: 2px;\n}\n.reject-info-text {\n  font-size: 0.9rem;\n  color: #555555;\n  margin-left: 6px;\n}\n.cancel-detail-wrapper {\n  margin-bottom: 1.5rem;\n}\n.cancel-status-block.ui.segment {\n  border-radius: 8px;\n  border: 1px solid transparent;\n  padding: 1.25rem 1.5rem;\n  box-shadow: none;\n}\n.cancel-container-received.ui.segment {\n  background-color: #FDF0EA !important;\n  border-color: #F8D7C8 !important;\n}\n.cancel-container-received .cancel-header-title {\n  color: #A34F23;\n  font-size: 1.15rem;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 6px;\n}\n.cancel-container-approved.ui.segment {\n  background-color: #EAF6EE !important;\n  border-color: #CBEAD4 !important;\n}\n.cancel-container-approved .cancel-header-title {\n  color: #276A41;\n  font-size: 1.15rem;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 6px;\n}\n.cancel-banner-top-row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 12px;\n}\n.cancel-actions-header-group {\n  display: -ms-flexbox;\n  display: flex;\n  gap: 10px;\n}\n.cancel-actions-header-group .ui.button.btn-cancel-action {\n  background-color: transparent !important;\n  border-radius: 6px !important;\n  font-weight: 600 !important;\n  padding: 0.6rem 1.1rem !important;\n  box-shadow: none !important;\n  font-size: 0.95rem !important;\n  transition: all 0.2s ease;\n}\n.cancel-actions-header-group .btn-approve-cancel {\n  border: 1px solid #00B4A0 !important;\n  color: #008475 !important;\n  background-color: #E6F8F6 !important;\n  /* Soft green-blue layout accent matching mocks */\n}\n.cancel-actions-header-group .btn-approve-cancel:hover {\n  background-color: #CEF2ED !important;\n}\n.cancel-actions-header-group .btn-undo-cancel {\n  border: 1px solid #BCB0A1 !important;\n  color: #4A4A4A !important;\n  background-color: #FFF !important;\n}\n.cancel-actions-header-group .btn-undo-cancel:hover {\n  background-color: #F4F5F7 !important;\n}\n.cancel-fields-grid .field-row {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n.cancel-fields-grid .field-label {\n  color: #6B7280;\n  font-weight: 500;\n}\n.cancel-fields-grid .field-value {\n  color: #111111;\n  text-align: left !important;\n}\n.cancel-fields-grid .field-value.text-green {\n  color: #00B4A0;\n}\n.bankcases-segment {\n  border-radius: 8px;\n}\n.card-header {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: start;\n      align-items: flex-start;\n  margin-bottom: 1.5em;\n  gap: 10px;\n}\n.card-header .header {\n  margin: 0;\n}\n.card-header .header-image {\n  max-height: 35px;\n  margin-right: 10px;\n}\n.card-header .header-content {\n  margin-left: 0.5em;\n}\n.card-header .header-status {\n  text-transform: uppercase;\n  font-size: 0.69em;\n  padding: 0.4em 0.8em;\n  border-radius: 4px;\n}\n.banker-section {\n  margin-bottom: 2em;\n}\n.banker-section .banker-header {\n  margin-bottom: 0.5em;\n}\n.banker-section .banker-list {\n  color: #00b5ad;\n}\n.banker-section .banker-phone {\n  -ms-transform: rotate(90deg);\n      transform: rotate(90deg);\n}\n.banker-section .banker-link {\n  color: #00b5ad;\n}\n.footer-section {\n  margin-top: 1.5em;\n}\n.footer-section .footer-loan-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: baseline;\n      align-items: baseline;\n  margin-bottom: 12px;\n}\n.footer-section .footer-update-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: baseline;\n      align-items: baseline;\n}\n.footer-section .footer-title {\n  color: gray;\n  white-space: nowrap;\n}\n.footer-section .footer-content {\n  text-align: right;\n  color: #1b1c1d;\n}\n.uc-total {\n  background-color: #F2F4F7;\n}\n.uc-total > .bar {\n  background-color: #F8F9F9 !important;\n}\n.uc-total.selected {\n  background-color: #49B3B1;\n  border-bottom: 4px solid #3a8f8e;\n}\n.uc-total:hover:not(.selected) {\n  background-color: #49B3B1;\n}\n.uc-new,\n.uc-hims-success,\n.uc-available {\n  background-color: #F2F4F7;\n}\n.uc-new > .bar,\n.uc-hims-success > .bar,\n.uc-available > .bar {\n  background-color: #9AE197 !important;\n}\n.uc-new.selected,\n.uc-hims-success.selected,\n.uc-available.selected {\n  background-color: #9AE197;\n  border-bottom: 4px solid #7bb479;\n}\n.uc-new:hover:not(.selected),\n.uc-hims-success:hover:not(.selected),\n.uc-available:hover:not(.selected) {\n  background-color: #9AE197;\n}\n.uc-reserved,\n.uc-developer_reserved,\n.uc-hims-pending {\n  background-color: #F2F4F7;\n}\n.uc-reserved > .bar,\n.uc-developer_reserved > .bar,\n.uc-hims-pending > .bar {\n  background-color: #FFF6D1 !important;\n}\n.uc-reserved.selected,\n.uc-developer_reserved.selected,\n.uc-hims-pending.selected {\n  background-color: #F2B42A;\n  border-bottom: 4px solid #c29022;\n}\n.uc-reserved:hover:not(.selected),\n.uc-developer_reserved:hover:not(.selected),\n.uc-hims-pending:hover:not(.selected) {\n  background-color: #F2B42A;\n}\n.uc-booked,\n.uc-developer_booked {\n  background-color: #F2F4F7;\n}\n.uc-booked > .bar,\n.uc-developer_booked > .bar {\n  background-color: #FFE5BF !important;\n}\n.uc-booked.selected,\n.uc-developer_booked.selected {\n  background-color: #F79A3E;\n  border-bottom: 4px solid #c67b32;\n}\n.uc-booked:hover:not(.selected),\n.uc-developer_booked:hover:not(.selected) {\n  background-color: #F79A3E;\n}\n.uc-sold_spa_signed,\n.uc-developer_sold,\n.uc-unavailable,\n.uc-hims-failed {\n  background-color: #F2F4F7;\n}\n.uc-sold_spa_signed > .bar,\n.uc-developer_sold > .bar,\n.uc-unavailable > .bar,\n.uc-hims-failed > .bar {\n  background-color: #FEE4E2 !important;\n}\n.uc-sold_spa_signed.selected,\n.uc-developer_sold.selected,\n.uc-unavailable.selected,\n.uc-hims-failed.selected {\n  background-color: #FF796E;\n  border-bottom: 4px solid #cc6158;\n}\n.uc-sold_spa_signed:hover:not(.selected),\n.uc-developer_sold:hover:not(.selected),\n.uc-unavailable:hover:not(.selected),\n.uc-hims-failed:hover:not(.selected) {\n  background-color: #FF796E;\n}\n.uc-delist,\n.uc-expired {\n  background-color: #F2F4F7;\n}\n.uc-delist > .bar,\n.uc-expired > .bar {\n  background-color: #F2F4F7 !important;\n}\n.uc-delist.selected,\n.uc-expired.selected {\n  background-color: #969CA4;\n  border-bottom: 4px solid #787d83;\n}\n.uc-delist:hover:not(.selected),\n.uc-expired:hover:not(.selected) {\n  background-color: #969CA4;\n}\n.uc-cancelled_developer {\n  background-color: #F2F4F7;\n}\n.uc-cancelled_developer > .bar {\n  background-color: #F2F4F7 !important;\n}\n.uc-cancelled_developer.selected {\n  background-color: #969CA4;\n  border-bottom: 4px solid #787d83;\n}\n.uc-cancelled_developer:hover:not(.selected) {\n  background-color: #969CA4;\n}\n.uc-cancelled_availability {\n  background-color: #F2F4F7;\n}\n.uc-cancelled_availability > .bar {\n  background-color: #E8EBF9 !important;\n}\n.uc-cancelled_availability.selected {\n  background-color: #7282D7;\n  border-bottom: 4px solid #5b68ac;\n}\n.uc-cancelled_availability:hover:not(.selected) {\n  background-color: #7282D7;\n}\n.uc-opportunity-total {\n  background-color: #F2F4F7;\n}\n.uc-opportunity-total > .bar {\n  background-color: #F8F9F9 !important;\n}\n.uc-opportunity-total.selected {\n  background-color: #49B3B1;\n  border-bottom: 4px solid #3a8f8e;\n}\n.uc-opportunity-total:hover:not(.selected) {\n  background-color: #49B3B1;\n}\n.uc-opportunity-pending_approval {\n  background-color: #F2F4F7;\n}\n.uc-opportunity-pending_approval > .bar {\n  background-color: #F8F9F9 !important;\n}\n.uc-opportunity-pending_approval.selected {\n  background-color: #7282D7;\n  border-bottom: 4px solid #5b68ac;\n}\n.uc-opportunity-pending_approval:hover:not(.selected) {\n  background-color: #7282D7;\n}\n.uc-opportunity-approved {\n  background-color: #F2F4F7;\n}\n.uc-opportunity-approved > .bar {\n  background-color: #F8F9F9 !important;\n}\n.uc-opportunity-approved.selected {\n  background-color: #50B793;\n  border-bottom: 4px solid #409276;\n}\n.uc-opportunity-approved:hover:not(.selected) {\n  background-color: #50B793;\n}\n.uc-opportunity-closed {\n  background-color: #F2F4F7;\n}\n.uc-opportunity-closed > .bar {\n  background-color: #F8F9F9 !important;\n}\n.uc-opportunity-closed.selected {\n  background-color: #F79A3E;\n  border-bottom: 4px solid #c67b32;\n}\n.uc-opportunity-closed:hover:not(.selected) {\n  background-color: #F79A3E;\n}\n.uc-opportunity-cancelled {\n  background-color: #F2F4F7;\n}\n.uc-opportunity-cancelled > .bar {\n  background-color: #F8F9F9 !important;\n}\n.uc-opportunity-cancelled.selected {\n  background-color: #FF796E;\n  border-bottom: 4px solid #cc6158;\n}\n.uc-opportunity-cancelled:hover:not(.selected) {\n  background-color: #FF796E;\n}\n.uc-opportunity-rejected {\n  background-color: #F2F4F7;\n}\n.uc-opportunity-rejected > .bar {\n  background-color: #F8F9F9 !important;\n}\n.uc-opportunity-rejected.selected {\n  background-color: #FF796E;\n  border-bottom: 4px solid #cc6158;\n}\n.uc-opportunity-rejected:hover:not(.selected) {\n  background-color: #FF796E;\n}\n.uc-opportunity-pending_cancellation {\n  background-color: #F2F4F7;\n  font-size: 11px !important;\n}\n.uc-opportunity-pending_cancellation > .bar {\n  background-color: #F8F9F9 !important;\n}\n.uc-opportunity-pending_cancellation.selected {\n  background-color: #F2B42A;\n  border-bottom: 4px solid #c29022;\n}\n.uc-opportunity-pending_cancellation:hover:not(.selected) {\n  background-color: #F2B42A;\n}\n.uc-opportunity-pending_closure {\n  background-color: #F2F4F7;\n}\n.uc-opportunity-pending_closure > .bar {\n  background-color: #F8F9F9 !important;\n}\n.uc-opportunity-pending_closure.selected {\n  background-color: #969CA4;\n  border-bottom: 4px solid #787d83;\n}\n.uc-opportunity-pending_closure:hover:not(.selected) {\n  background-color: #969CA4;\n}\n.uc-opportunity-pending_refund {\n  background-color: #F2F4F7;\n}\n.uc-opportunity-pending_refund > .bar {\n  background-color: #F8F9F9 !important;\n}\n.uc-opportunity-pending_refund.selected {\n  background-color: #969CA4;\n  border-bottom: 4px solid #787d83;\n}\n.uc-opportunity-pending_refund:hover:not(.selected) {\n  background-color: #969CA4;\n}\n.uc-opportunity-refunded {\n  background-color: #F2F4F7;\n}\n.uc-opportunity-refunded > .bar {\n  background-color: #F8F9F9 !important;\n}\n.uc-opportunity-refunded.selected {\n  background-color: #969CA4;\n  border-bottom: 4px solid #787d83;\n}\n.uc-opportunity-refunded:hover:not(.selected) {\n  background-color: #969CA4;\n}\n.uc-status-good {\n  background-color: #E5FAF2;\n  color: #386C50;\n}\n.uc-status-info {\n  background-color: #EAF2FE;\n  color: #1556B9;\n}\n.uc-status-info-dim {\n  background-color: #EDF7FD;\n  color: #596975;\n}\n.uc-status-warning {\n  background-color: #FFF6D1;\n  color: #596975;\n}\n.uc-status-danger {\n  background-color: #FCEDEB;\n  color: #A1382C;\n}\n.uc-status-ghost {\n  background-color: #F4F5F7;\n  color: #596975;\n}\n.ui.grid.status .column.uc-tab-status {\n  font-size: 12px;\n  font-weight: 600;\n  margin: 0;\n  margin-right: 0.5em;\n  max-width: 105px;\n  height: 75px;\n  cursor: pointer;\n  border-radius: 0.25em 0.25em 0 0;\n  color: #667085;\n  -ms-flex-line-pack: center;\n      align-content: center;\n}\n.ui.grid.status .column.uc-tab-status p {\n  font-size: 21px;\n  margin: 0;\n}\n.ui.grid.status .column.uc-tab-status.selected,\n.ui.grid.status .column.uc-tab-status:hover {\n  color: #FFFfff;\n  font-weight: 800;\n}\n.ui.grid.status .column.uc-tab-status:last-child {\n  margin-right: 0;\n}\n.ui.button.uc-clear-button {\n  background-color: transparent;\n  box-shadow: none;\n  color: #596975;\n  font-weight: 400;\n}\n.ui.button.uc-clear-button:hover {\n  background-color: #f4f5f7;\n  box-shadow: none;\n}\n.uc-search-wrapper.uc-no-dropdown.ui.input {\n  display: -ms-flexbox !important;\n  display: flex !important;\n  /* override Semantic UI */\n  width: 100% !important;\n  /* fill container */\n  padding: 0 !important;\n  /* remove extra padding if needed */\n  box-sizing: border-box;\n}\n.uc-search-wrapper.uc-no-dropdown.ui.input input {\n  -ms-flex: 1 1 auto !important;\n      flex: 1 1 auto !important;\n  /* allow input to grow and shrink */\n  min-width: 0;\n  /* prevent overflow */\n  margin: 0;\n}\n.uc-search-wrapper.uc-with-dropdown.ui.input {\n  display: -ms-flexbox !important;\n  display: flex !important;\n  /* override Semantic UI */\n  width: 100% !important;\n  /* fill container */\n  padding: 0 !important;\n  /* remove extra padding if needed */\n  box-sizing: border-box;\n}\n.uc-search-wrapper.uc-with-dropdown.ui.input input {\n  -ms-flex: 0 0 67% !important;\n      flex: 0 0 67% !important;\n  min-width: 0;\n  margin: 0;\n}\n.uc-search-wrapper.ui.input > .uc-search-dropdown.ui.selection.dropdown {\n  -ms-flex: 0 0 33% !important;\n      flex: 0 0 33% !important;\n  min-width: 0;\n  margin: 0;\n}\n.uc-search-wrapper.input > .uc-search-dropdown.ui.selection.dropdown > .text {\n  max-width: 100%;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  display: inline-block;\n}\n.uc-aging-tab {\n  color: #00233B !important;\n  font-weight: 400 !important;\n  border-radius: 4px 4px 0 0 !important;\n  border-bottom-style: solid !important;\n  padding-left: 24px !important;\n  padding-right: 24px !important;\n  border-bottom-color: transparent !important;\n}\n.uc-aging-tab:hover:not(.active) {\n  background-color: #F4F5F7 !important;\n  color: #00233B !important;\n}\n.uc-aging-tab.active {\n  border-bottom-color: rgba(73, 179, 177, 0.8) !important;\n  font-weight: 600 !important;\n}\n.ui.accordion.uc-accordion {\n  padding: 1em 1em 0em 1.5em;\n}\n.shadow-border {\n  border: none !important;\n  box-shadow: 0 0 10px 2px #0000000D;\n  border-radius: 8px;\n}\n.ui.button.uc-accordion-toggle-btn {\n  background-color: transparent;\n  box-shadow: none;\n  color: #969ca4;\n  transition: transform 0.3s ease;\n}\n@media screen and (min-width: 992px) {\n  .ui.button.uc-accordion-toggle-btn:hover {\n    background-color: #f4f5f7;\n    box-shadow: none;\n  }\n}\n@media screen and (min-width: 768px) {\n  .ui.button.uc-accordion-toggle-btn {\n    margin-top: 1.8em;\n  }\n}\n.ui.button.uc-accordion-toggle-btn.rotated {\n  -ms-transform: rotate(180deg);\n      transform: rotate(180deg);\n}\n.ui.dropdown.uc-dropdown.dropdown.icon {\n  color: rgba(0, 0, 0, 0.87);\n}\n.ui.dropdown.uc-dropdown.selected {\n  background-color: transparent;\n}\n.uc-dropdown-custom-selection .menu {\n  overflow: visible !important;\n}\n.uc-dropdown-datepicker .menu {\n  max-height: none !important;\n}\n@media screen and (min-width: 768px) {\n  .uc-dropdown-datepicker .menu {\n    width: 30em !important;\n  }\n}\n@media screen and (min-width: 768px) and (max-width: 991px) {\n  .uc-dropdown-select-list-multiple span {\n    display: inline-block;\n    line-height: 1.5;\n  }\n}\n.uc-dropdown-show-all-items .menu {\n  max-height: none !important;\n}\n.uc-dropdown-show-all-items .menu .item {\n  border-top: none !important;\n}\n.uc-booking-status-dropdown {\n  border: none !important;\n  box-shadow: none !important;\n  font-weight: 800;\n}\n.uc-booking-status-dropdown .dropdown.icon {\n  color: rgba(0, 0, 0, 0.87);\n  top: 35% !important;\n}\n.uc-booking-status-dropdown.uc-total {\n  background-color: #F8F9F9 !important;\n}\n.uc-booking-status-dropdown.uc-total .divider.text {\n  color: #00233B !important;\n}\n.uc-booking-status-dropdown.uc-new,\n.uc-booking-status-dropdown.uc-hims-success,\n.uc-booking-status-dropdown.uc-available {\n  background-color: #E8FAE5 !important;\n}\n.uc-booking-status-dropdown.uc-new .divider.text,\n.uc-booking-status-dropdown.uc-hims-success .divider.text,\n.uc-booking-status-dropdown.uc-available .divider.text {\n  color: #027A48 !important;\n}\n.uc-booking-status-dropdown.uc-reserved,\n.uc-booking-status-dropdown.uc-developer_reserved,\n.uc-booking-status-dropdown.uc-hims-pending {\n  background-color: #FFF6D1 !important;\n}\n.uc-booking-status-dropdown.uc-reserved .divider.text,\n.uc-booking-status-dropdown.uc-developer_reserved .divider.text,\n.uc-booking-status-dropdown.uc-hims-pending .divider.text {\n  color: #596975 !important;\n}\n.uc-booking-status-dropdown.uc-booked,\n.uc-booking-status-dropdown.uc-developer_booked {\n  background-color: #FFE5BF !important;\n}\n.uc-booking-status-dropdown.uc-booked .divider.text,\n.uc-booking-status-dropdown.uc-developer_booked .divider.text {\n  color: #B2320F !important;\n}\n.uc-booking-status-dropdown.uc-sold_spa_signed,\n.uc-booking-status-dropdown.uc-developer_sold,\n.uc-booking-status-dropdown.uc-unavailable,\n.uc-booking-status-dropdown.uc-hims-failed {\n  background-color: #FEE4E2 !important;\n}\n.uc-booking-status-dropdown.uc-sold_spa_signed .divider.text,\n.uc-booking-status-dropdown.uc-developer_sold .divider.text,\n.uc-booking-status-dropdown.uc-unavailable .divider.text,\n.uc-booking-status-dropdown.uc-hims-failed .divider.text {\n  color: #B42318 !important;\n}\n.uc-booking-status-dropdown.uc-delist,\n.uc-booking-status-dropdown.uc-expired {\n  background-color: #F2F4F7 !important;\n}\n.uc-booking-status-dropdown.uc-delist .divider.text,\n.uc-booking-status-dropdown.uc-expired .divider.text {\n  color: #667085 !important;\n}\n.uc-booking-status-dropdown.uc-cancelled_developer {\n  background-color: #F2F4F7 !important;\n}\n.uc-booking-status-dropdown.uc-cancelled_developer .divider.text {\n  color: #667085 !important;\n}\n.uc-booking-status-dropdown.uc-cancelled_availability {\n  background-color: #E8EBF9 !important;\n}\n.uc-booking-status-dropdown.uc-cancelled_availability .divider.text {\n  color: #5068E4 !important;\n}\n.uc-booking-status-dropdown:focus {\n  border: #96c8da 1px solid !important;\n}\n.uc-status-flag {\n  padding: 4px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n@media screen and (max-width: 768px) {\n  .uc-status-flag {\n    padding: 2px 12px;\n  }\n}\n.uc-status-flag.uc-total {\n  background-color: #F8F9F9 !important;\n  color: #00233B !important;\n}\n.uc-status-flag.uc-new,\n.uc-status-flag.uc-hims-success,\n.uc-status-flag.uc-available {\n  background-color: #E8FAE5 !important;\n  color: #027A48 !important;\n}\n.uc-status-flag.uc-reserved,\n.uc-status-flag.uc-developer_reserved,\n.uc-status-flag.uc-hims-pending {\n  background-color: #FFF6D1 !important;\n  color: #596975 !important;\n}\n.uc-status-flag.uc-booked,\n.uc-status-flag.uc-developer_booked {\n  background-color: #FFE5BF !important;\n  color: #B2320F !important;\n}\n.uc-status-flag.uc-sold_spa_signed,\n.uc-status-flag.uc-developer_sold,\n.uc-status-flag.uc-unavailable,\n.uc-status-flag.uc-hims-failed {\n  background-color: #FEE4E2 !important;\n  color: #B42318 !important;\n}\n.uc-status-flag.uc-delist,\n.uc-status-flag.uc-expired {\n  background-color: #F2F4F7 !important;\n  color: #667085 !important;\n}\n.uc-status-flag.uc-cancelled_developer {\n  background-color: #F2F4F7 !important;\n  color: #667085 !important;\n}\n.uc-status-flag.uc-cancelled_availability {\n  background-color: #E8EBF9 !important;\n  color: #5068E4 !important;\n}\n.uc-status-flag.uc-opportunity-total {\n  background-color: #F8F9F9 !important;\n  color: #00233B !important;\n}\n.uc-status-flag.uc-opportunity-pending_approval,\n.uc-status-flag.uc-opportunity-pending_payment,\n.uc-status-flag.uc-opportunity-payment_made,\n.uc-status-flag.uc-opportunity-partially_paid_unverified,\n.uc-status-flag.uc-opportunity-paid_unverified,\n.uc-status-flag.uc-opportunity-paid_verified {\n  background-color: #EEF1FF !important;\n  color: #5068E4 !important;\n}\n.uc-status-flag.uc-opportunity-approved {\n  background-color: #E5FAF2 !important;\n  color: #386C50 !important;\n}\n.uc-status-flag.uc-opportunity-closed {\n  background-color: #FFE5BF !important;\n  color: #B2320F !important;\n}\n.uc-status-flag.uc-opportunity-rejected {\n  background-color: #FFECEB !important;\n  color: #AE2E24 !important;\n}\n.uc-status-flag.uc-opportunity-pending_cancellation,\n.uc-status-flag.uc-opportunity-verification_rejected {\n  background-color: #FFF6D1 !important;\n  color: #7F4201 !important;\n}\n.uc-status-flag.uc-opportunity-pending_closure {\n  background-color: #F2F4F7 !important;\n  color: #667085 !important;\n}\n.uc-status-flag.uc-opportunity-pending_refund {\n  background-color: #F8D079 !important;\n  color: #7F4201 !important;\n}\n.uc-status-flag.uc-opportunity-refunded,\n.uc-status-flag.uc-opportunity-cancelled,\n.uc-status-flag.uc-opportunity-refund_declined,\n.uc-status-flag.uc-opportunity-expired {\n  background-color: #F2F4F7 !important;\n  color: #667085 !important;\n}\n.uc-booking-status-text {\n  font-size: 15px;\n  font-weight: 600;\n}\n.uc-booking-status-label {\n  font-size: 12px;\n  font-weight: 600;\n}\n.uc-booking-status-item {\n  font-size: 14px;\n  font-weight: 400;\n}\n.uc-label-ghost {\n  background-color: #F2F4F7 !important;\n  color: #667085 !important;\n}\n.tight-column {\n  padding-right: 0.5rem !important;\n  /* default is around 1rem */\n}\n.uc-grid-title-row {\n  color: #00233B;\n  font-weight: 600;\n  font-size: 15px;\n}\n.uc-grid-detail-row {\n  padding-bottom: 0 !important;\n}\n.uc-grid-detail-row .column:nth-child(odd) {\n  color: #00233B;\n  font-weight: 600;\n  font-size: 14px;\n}\n.uc-grid-detail-row .column:nth-child(even) {\n  color: #596975;\n  font-weight: 400;\n  font-size: 14px;\n}\n.uc-table thead th {\n  border-left: none !important;\n  background-color: transparent !important;\n}\n.uc-table thead th:hover {\n  background-color: rgba(0, 0, 0, 0.05) !important;\n}\n.uc-table tr:hover {\n  background-color: #F8F9F9 !important;\n}\n.uc-table tr td {\n  color: #596975;\n}\n.uc-table a {\n  font-size: 14px;\n  color: #49B3B1;\n}\n.uc-table .uc-table-cell-subtitle1 {\n  font-size: 12px;\n}\n@media screen and (min-width: 768px) {\n  .uc-table a:hover {\n    color: #32c8c5;\n    text-decoration: underline;\n  }\n}\n@media screen and (max-width: 768px) {\n  .uc-booking-list-table {\n    /* Turn each row into a \"card\" */\n    /* Stack each cell vertically */\n    /* Remove bottom border for last cell */\n    /* Optional: Style first cell as \"title\" of card */\n  }\n  .uc-booking-list-table tr {\n    display: block;\n    margin-bottom: 0.625rem;\n    /* space between rows/cards */\n    border: 1px solid #0000000A;\n    border-bottom: none !important;\n    border-radius: 8px;\n    box-shadow: none !important;\n    overflow: hidden;\n  }\n  .uc-booking-list-table td {\n    display: -ms-flexbox;\n    display: flex;\n    width: 100%;\n    padding: 0.75rem;\n    border: none;\n    /* remove table borders */\n    border-bottom: 1px solid #eee;\n    /* optional cell separator */\n    -ms-flex-align: center;\n        align-items: center;\n  }\n  .uc-booking-list-table td:last-child {\n    border-bottom: none;\n  }\n  .uc-booking-list-table td:first-child {\n    font-weight: bold;\n    background: #f9f9f9;\n  }\n}\n.has-overflow .uc-sticky-col {\n  position: -webkit-sticky;\n  position: sticky;\n  background-color: #fff !important;\n  /* Fully opaque */\n  z-index: 2;\n}\n.has-overflow .uc-sticky-col.uc-right {\n  right: 0;\n}\n.has-overflow .uc-sticky-col.uc-left {\n  left: 0;\n}\n.has-overflow .uc-sticky-shadow-left {\n  box-shadow: 3px 0 5px rgba(0, 0, 0, 0.1) !important;\n  z-index: 3;\n}\n.has-overflow .uc-sticky-shadow-right {\n  box-shadow: -3px 0 5px rgba(0, 0, 0, 0.1) !important;\n  z-index: 3;\n}\n.uc-icon-button {\n  background-color: transparent !important;\n  box-shadow: none;\n  cursor: default !important;\n  padding: 10px !important;\n}\n.uc-button {\n  color: #596975 !important;\n  font-size: 14px !important;\n}\n.uc-tab-page-spacer {\n  height: 2rem;\n}\n.uc-section-tabs {\n  overflow-x: auto;\n}\n.uc-section-tabs.sticky .button {\n  color: #cfcfcf !important;\n  background-color: #707070 !important;\n}\n.uc-section-tabs.sticky .button:not(:first-child) {\n  border-left: solid #333 1px !important;\n}\n.uc-section-tabs.sticky .button.active {\n  color: #1b1c1d !important;\n  background-color: #E7ECF1 !important;\n}\n.uc-section-tabs.sticky .button:hover {\n  color: #eee !important;\n  background-color: #999 !important;\n}\n.uc-section-tabs .button {\n  transition: all 0.25s ease-in-out;\n  color: #596975 !important;\n  background-color: #F4F5F7 !important;\n}\n.uc-section-tabs .button:not(:first-child) {\n  border-left: solid white 1px;\n}\n.uc-section-tabs .button .header {\n  color: #596975 !important;\n}\n.uc-section-tabs .button .header .sub.header {\n  color: rgba(0, 0, 0, 0.6) !important;\n}\n.uc-section-tabs .button:hover {\n  transition: all 0.25s ease-in-out;\n  background-color: #CFD4D8 !important;\n}\n.uc-section-tabs .button:hover .header {\n  color: #000000 !important;\n}\n.uc-section-tabs .button:hover .header .sub.header {\n  color: rgba(0, 0, 0, 0.7) !important;\n}\n.uc-section-tabs .button.active {\n  color: white !important;\n  background-color: #49B3B1 !important;\n}\n.uc-section-tabs .button.active .header {\n  color: white !important;\n}\n.uc-section-tabs .button.active .header .sub.header {\n  color: rgba(255, 255, 255, 0.8) !important;\n}\n.uc-timeline {\n  position: relative;\n  margin-left: 40px;\n}\n.uc-timeline .uc-timeline-title-header {\n  font-size: 15px;\n  font-weight: 600;\n  color: #00233B;\n}\n.uc-timeline .uc-timeline-item {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: start;\n      align-items: flex-start;\n  position: relative;\n  margin-bottom: 20px;\n}\n.uc-timeline .uc-timeline-item .uc-timeline-icon {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-right: 16px;\n  margin-top: 4px;\n}\n.uc-timeline .uc-timeline-item .uc-timeline-icon .ui.icon {\n  position: relative;\n  z-index: 1;\n  font-size: 12px;\n}\n.uc-timeline .uc-timeline-item .uc-timeline-line {\n  position: absolute;\n  top: 16px;\n  left: 5px;\n  width: 2px;\n  height: calc(100% + 8px);\n  background: #e8e8e8;\n  z-index: 0;\n}\n.uc-timeline .uc-timeline-item .uc-timeline-content .uc-timeline-date {\n  font-size: 10px;\n  color: #969CA4;\n}\n.uc-timeline .uc-timeline-item .uc-timeline-content .uc-timeline-title {\n  font-size: 13px;\n  color: #00233B;\n}\n.uc-timeline .uc-timeline-item .uc-timeline-content .uc-timeline-description {\n  font-size: 12px;\n  color: #00233B;\n}\n.bulk-edit-mobile-list {\n  display: none;\n}\n.bulk-edit-history-failed-codes {\n  display: inline-block;\n  margin-top: 0.25em;\n  font-size: 0.9em;\n  color: #9f3a38;\n  cursor: pointer;\n  text-decoration: underline;\n  white-space: nowrap;\n}\n.bulk-edit-failed-codes-list {\n  max-height: 50vh;\n  overflow-y: auto;\n  border: 1px solid #eee;\n  border-radius: 4px;\n  padding: 0 0.75em;\n}\n.bulk-edit-mobile-card-row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  gap: 1em;\n  padding: 0.45em 0;\n  border-top: 1px solid #f0f0f0;\n}\n.bulk-edit-mobile-card-row > span:first-child {\n  color: #666;\n  -ms-flex: 0 0 35%;\n      flex: 0 0 35%;\n}\n.bulk-edit-mobile-card-row > span:last-child {\n  overflow-wrap: anywhere;\n  text-align: right;\n}\n.bulk-edit-mobile-card-header {\n  -ms-flex-align: center;\n      align-items: center;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  gap: 0.75em;\n  margin-bottom: 0.5em;\n}\n.bulk-edit-history-mobile {\n  display: none;\n}\n.bulk-edit-history-card-row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  gap: 1em;\n  padding: 0.45em 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n.bulk-edit-history-card-row > span:first-child {\n  color: #666;\n  -ms-flex: 0 0 35%;\n      flex: 0 0 35%;\n}\n.bulk-edit-history-card-row > span:last-child,\n.bulk-edit-history-card-row > strong {\n  overflow-wrap: anywhere;\n  text-align: right;\n}\n@media only screen and (max-width: 767px) {\n  .bulk-edit-modal.ui.modal {\n    width: calc(100% - 1em);\n    height: calc(100vh - 1em);\n    margin: 0.5em auto;\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-direction: column;\n        flex-direction: column;\n  }\n  .bulk-edit-modal.ui.modal > .content {\n    -ms-flex: 1 1 auto;\n        flex: 1 1 auto;\n    min-height: 0;\n    max-height: none;\n    overflow-y: auto;\n    padding: 1em;\n  }\n  .bulk-edit-modal.ui.modal > .actions {\n    -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n    padding: 0.75em;\n  }\n  .bulk-edit-modal.ui.modal > .content > div:first-child {\n    display: -ms-flexbox;\n    display: flex;\n    gap: 0.35em;\n    margin-bottom: 0.75em !important;\n    overflow-x: auto;\n    white-space: nowrap;\n  }\n  .bulk-edit-modal.ui.modal > .content > div:first-child .ui.label {\n    -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n    margin-right: 0 !important;\n    font-size: 0.75em;\n  }\n  .bulk-edit-desktop-table {\n    display: none;\n  }\n  .bulk-edit-mobile-list {\n    display: block;\n  }\n  .bulk-edit-history-desktop {\n    display: none;\n  }\n  .bulk-edit-history-mobile {\n    display: block;\n  }\n  .bulk-edit-mobile-card {\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    margin-bottom: 0.75em;\n    padding: 0.75em;\n  }\n  .bulk-edit-history-card {\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    margin-bottom: 0.75em;\n    padding: 0.75em;\n  }\n  .bulk-edit-history-card .ui.progress {\n    margin: 0.75em 0 0;\n  }\n}\n.notification-item p {\n  margin: 0.1em 0.5em 0.45em;\n  font-size: 0.85em;\n  line-height: 1.3em;\n  color: black;\n  text-align: left;\n  font-weight: 200;\n}\n.notification-item strong {\n  font-weight: 700;\n}\n.notification-item .checkbox {\n  text-align: center;\n}\n.notification-item .created-at {\n  font-weight: 100;\n  font-size: 0.65em;\n  float: right;\n  color: #75797c;\n  font-style: italic;\n}\n.notification-item .notification-icon {\n  display: block;\n}\n.notification-item i {\n  margin-right: 0.25em;\n}\n.notification-icon {\n  width: 1.8em;\n  height: 1.8em;\n  margin: 0.55em auto;\n  background: #5b5b5b;\n}\n.notification-icon img {\n  width: 90% !important;\n  -ms-transform: translate(0, 6%);\n      transform: translate(0, 6%);\n}\n.notification-icon.rounded-rect {\n  border-radius: 20%;\n}\n.notification-icon.round {\n  border-radius: 50%;\n  padding: 0.15em;\n  margin: 0.45em auto;\n}\n.notification-icon.round img {\n  -ms-transform: translate(0, 5%);\n      transform: translate(0, 5%);\n}\n.notification-icon.round.update_reject img,\n.notification-icon.round.closed_reject img {\n  -ms-transform: scaleY(-1) translate(0, -10%);\n      transform: scaleY(-1) translate(0, -10%);\n}\n.notification-icon.round.others img,\n.notification-icon.round.update img {\n  width: 85%;\n}\n.notification-icon.announcement {\n  background: #0D879C;\n}\n.notification-icon.alert {\n  background: #d05454;\n}\n.notification-icon.new {\n  background: #63c465;\n}\n.notification-icon.nudge {\n  background: #326833;\n}\n.notification-icon.update {\n  background: #4c87b9;\n}\n.notification-icon.system,\n.notification-icon.update_pending {\n  background: #ff9800;\n}\n.notification-icon.update_success,\n.notification-icon.closed_success {\n  background: #3faba4;\n}\n.notification-icon.update_reject,\n.notification-icon.closed_reject {\n  background: #5b5b5b;\n}\n.notification-icon.update_reject img,\n.notification-icon.closed_reject img {\n  -ms-transform: scaleY(-1) translate(0, -6%);\n      transform: scaleY(-1) translate(0, -6%);\n}\n.notification-icon.reassign {\n  background: #551A8B;\n}\n.notification-icon.activity-log {\n  background: #c0c0c0;\n}\n.booking-note .bn-header {\n  background-color: #F8F8F9 !important;\n  margin: 0;\n  padding: 0.5em 0;\n}\n.booking-note .bn-refresh {\n  background: none !important;\n  font-weight: bold !important;\n  font-size: 14px !important;\n  color: #767676 !important;\n  top: 1px;\n  right: 0;\n  position: absolute;\n}\n.expand-mode .bn-refresh {\n  background: none !important;\n  font-weight: bold !important;\n  font-size: 14px !important;\n  color: #767676 !important;\n  top: 1px;\n  right: 24px !important;\n  position: absolute;\n}\n.expand-mode .bn-expand {\n  background: none !important;\n  font-weight: bold !important;\n  font-size: 14px !important;\n  color: #767676 !important;\n  top: 1px;\n  right: 0;\n  position: absolute;\n}\n.bn-list {\n  min-height: 6em;\n  max-height: 29em;\n  overflow-y: auto;\n  padding: 0.5em 0.75em 0.75em !important;\n}\n.bn-list.is-expanded {\n  max-height: 66vh !important;\n}\n.bn-list .feed {\n  margin: 0 !important;\n}\n.bn-list.is-write-mode {\n  overflow-y: hidden !important;\n  padding-right: 1.72em !important;\n}\n.bnl-item.is-disabled {\n  opacity: 40%;\n  filter: grayscale(1);\n}\n.bnl-item.is-disabled,\n.bnl-item.is-disabled * {\n  pointer-events: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.bnl-item.is-editing .bnl-item-edit-menu {\n  pointer-events: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  opacity: 40%;\n  filter: grayscale(1);\n}\n.bnl-item .label {\n  padding-top: 0.8em;\n  width: 2em !important;\n}\n.bnl-item .bnl-item-avatar {\n  display: -ms-flexbox;\n  display: flex;\n  background-color: #0E6EB8;\n  color: #fff;\n  width: auto;\n  height: 2rem;\n  border-radius: 50%;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  font-size: 14px;\n  font-weight: 600;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.bnl-item .content {\n  margin-left: 0.55em !important;\n}\n.bnl-item .content .summary {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.bnl-item .content .extra.bnl-item-date-privacy {\n  margin: 0.35em 0 0 !important;\n}\n.bnl-item .content .extra.bnl-item-note-content {\n  margin: 0.18em 0 0 !important;\n}\n.bnl-item .content .extra.bnl-item-note-content .bnl-item-markdown {\n  word-break: break-word;\n}\n.bnl-item .bnl-item-title-info .user:hover {\n  text-decoration: underline;\n}\n.bnl-item .bnl-item-date-privacy {\n  margin-top: 4px;\n  font-size: 12px;\n  cursor: pointer;\n}\n.bnl-item .bnl-item-date-privacy .timedate:hover {\n  text-decoration: underline;\n}\n.bnl-item .bnl-item-edit-menu i.ellipsis.icon {\n  margin: 0 !important;\n}\n.bnl-item .bnl-item-edit-menu .menu > .item {\n  font-size: 80%;\n}\n.bnl-item .bnl-item-delete-dialog {\n  z-index: 10 !important;\n}\n.bnl-empty-item {\n  height: 2em;\n  padding-top: 0.5em !important;\n}\n.bnl-empty-item * {\n  text-align: center;\n}\n.b-note-editor-rdw {\n  /**\n  * react-draft-wysiwyg\n  */\n  /**\n  * Draft v0.9.1\n  *\n  * Copyright (c) 2013-present, Facebook, Inc.\n  * All rights reserved.\n  *\n  * This source code is licensed under the BSD-style license found in the\n  * LICENSE file in the root directory of this source tree. An additional grant\n  * of patent rights can be found in the PATENTS file in the same directory.\n  */\n  /*# sourceMappingURL=react-draft-wysiwyg.css.map*/\n  /* .b-note-editor-rdw */\n  /* compact mode */\n  /* editor button size */\n  /* editor icons size */\n  /* privacy dropdown and submit buttons */\n}\n.b-note-editor-rdw .rdw-option-wrapper {\n  border: 1px solid #F1F1F1;\n  padding: 5px;\n  min-width: 25px;\n  height: 20px;\n  border-radius: 2px;\n  margin: 0 4px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n.b-note-editor-rdw .rdw-option-wrapper:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n.b-note-editor-rdw .rdw-option-wrapper:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n.b-note-editor-rdw .rdw-option-active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n.b-note-editor-rdw .rdw-option-disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n.b-note-editor-rdw .rdw-dropdown-wrapper {\n  height: 30px;\n  cursor: pointer;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  margin: 0 3px;\n  text-transform: capitalize;\n  background: white;\n}\n.b-note-editor-rdw .rdw-dropdown-wrapper:focus {\n  outline: none;\n}\n.b-note-editor-rdw .rdw-dropdown-wrapper:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n  background-color: #FFFFFF;\n}\n.b-note-editor-rdw .rdw-dropdown-wrapper:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n.b-note-editor-rdw .rdw-dropdown-carettoopen {\n  height: 0px;\n  width: 0px;\n  position: absolute;\n  top: 35%;\n  right: 10%;\n  border-top: 6px solid black;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n}\n.b-note-editor-rdw .rdw-dropdown-carettoclose {\n  height: 0px;\n  width: 0px;\n  position: absolute;\n  top: 35%;\n  right: 10%;\n  border-bottom: 6px solid black;\n  border-left: 5px solid transparent;\n  border-right: 5px solid transparent;\n}\n.b-note-editor-rdw .rdw-dropdown-selectedtext {\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  height: 100%;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 0 5px;\n}\n.b-note-editor-rdw .rdw-dropdown-optionwrapper {\n  z-index: 100;\n  position: relative;\n  border: 1px solid #F1F1F1;\n  width: 98%;\n  background: white;\n  border-radius: 2px;\n  margin: 0;\n  padding: 0;\n  max-height: 250px;\n  overflow-y: scroll;\n}\n.b-note-editor-rdw .rdw-dropdown-optionwrapper:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n  background-color: #FFFFFF;\n}\n.b-note-editor-rdw .rdw-dropdownoption-default {\n  min-height: 25px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 0 5px;\n}\n.b-note-editor-rdw .rdw-dropdownoption-highlighted {\n  background: #F1F1F1;\n}\n.b-note-editor-rdw .rdw-dropdownoption-active {\n  background: #f5f5f5;\n}\n.b-note-editor-rdw .rdw-dropdownoption-disabled {\n  opacity: 0.3;\n  cursor: default;\n}\n.b-note-editor-rdw .rdw-inline-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 6px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.b-note-editor-rdw .rdw-inline-dropdown {\n  width: 50px;\n}\n.b-note-editor-rdw .rdw-inline-dropdownoption {\n  height: 40px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.b-note-editor-rdw .rdw-block-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 6px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.b-note-editor-rdw .rdw-block-dropdown {\n  width: 110px;\n}\n.b-note-editor-rdw .rdw-fontsize-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 6px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.b-note-editor-rdw .rdw-fontsize-dropdown {\n  min-width: 40px;\n}\n.b-note-editor-rdw .rdw-fontsize-option {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.b-note-editor-rdw .rdw-fontfamily-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 6px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.b-note-editor-rdw .rdw-fontfamily-dropdown {\n  width: 115px;\n}\n.b-note-editor-rdw .rdw-fontfamily-placeholder {\n  white-space: nowrap;\n  max-width: 90px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.b-note-editor-rdw .rdw-fontfamily-optionwrapper {\n  width: 140px;\n}\n.b-note-editor-rdw .rdw-list-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 6px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.b-note-editor-rdw .rdw-list-dropdown {\n  width: 50px;\n  z-index: 90;\n}\n.b-note-editor-rdw .rdw-list-dropdownOption {\n  height: 40px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.b-note-editor-rdw .rdw-text-align-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 6px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.b-note-editor-rdw .rdw-text-align-dropdown {\n  width: 50px;\n  z-index: 90;\n}\n.b-note-editor-rdw .rdw-text-align-dropdownOption {\n  height: 40px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.b-note-editor-rdw .rdw-right-aligned-block {\n  text-align: right;\n}\n.b-note-editor-rdw .rdw-left-aligned-block {\n  text-align: left !important;\n}\n.b-note-editor-rdw .rdw-center-aligned-block {\n  text-align: center !important;\n}\n.b-note-editor-rdw .rdw-justify-aligned-block {\n  text-align: justify !important;\n}\n.b-note-editor-rdw .rdw-right-aligned-block > div {\n  display: inline-block;\n}\n.b-note-editor-rdw .rdw-left-aligned-block > div {\n  display: inline-block;\n}\n.b-note-editor-rdw .rdw-center-aligned-block > div {\n  display: inline-block;\n}\n.b-note-editor-rdw .rdw-justify-aligned-block > div {\n  display: inline-block;\n}\n.b-note-editor-rdw .rdw-colorpicker-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.b-note-editor-rdw .rdw-colorpicker-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  width: 175px;\n  height: 175px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n.b-note-editor-rdw .rdw-colorpicker-modal-header {\n  display: -ms-flexbox;\n  display: flex;\n  padding-bottom: 5px;\n}\n.b-note-editor-rdw .rdw-colorpicker-modal-style-label {\n  font-size: 15px;\n  width: 50%;\n  text-align: center;\n  cursor: pointer;\n  padding: 0 10px 5px;\n}\n.b-note-editor-rdw .rdw-colorpicker-modal-style-label-active {\n  border-bottom: 2px solid #0a66b7;\n}\n.b-note-editor-rdw .rdw-colorpicker-modal-options {\n  margin: 5px auto;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n  height: 100%;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  overflow: scroll;\n}\n.b-note-editor-rdw .rdw-colorpicker-cube {\n  width: 22px;\n  height: 22px;\n  border: 1px solid #F1F1F1;\n}\n.b-note-editor-rdw .rdw-colorpicker-option {\n  margin: 3px;\n  padding: 0;\n  min-height: 20px;\n  border: none;\n  width: 22px;\n  height: 22px;\n  min-width: 22px;\n  box-shadow: 1px 2px 1px #BFBDBD inset;\n}\n.b-note-editor-rdw .rdw-colorpicker-option:hover {\n  box-shadow: 1px 2px 1px #BFBDBD;\n}\n.b-note-editor-rdw .rdw-colorpicker-option:active {\n  box-shadow: -1px -2px 1px #BFBDBD;\n}\n.b-note-editor-rdw .rdw-colorpicker-option-active {\n  box-shadow: 0px 0px 2px 2px #BFBDBD;\n}\n.b-note-editor-rdw .rdw-link-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.b-note-editor-rdw .rdw-link-dropdown {\n  width: 50px;\n}\n.b-note-editor-rdw .rdw-link-dropdownOption {\n  height: 40px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.b-note-editor-rdw .rdw-link-dropdownPlaceholder {\n  margin-left: 8px;\n}\n.b-note-editor-rdw .rdw-link-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  width: 235px;\n  height: 205px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n.b-note-editor-rdw .rdw-link-modal-label {\n  font-size: 15px;\n}\n.b-note-editor-rdw .rdw-link-modal-input {\n  margin-top: 5px;\n  border-radius: 2px;\n  border: 1px solid #F1F1F1;\n  height: 25px;\n  margin-bottom: 15px;\n  padding: 0 5px;\n}\n.b-note-editor-rdw .rdw-link-modal-input:focus {\n  outline: none;\n}\n.b-note-editor-rdw .rdw-link-modal-buttonsection {\n  margin: 0 auto;\n}\n.b-note-editor-rdw .rdw-link-modal-target-option {\n  margin-bottom: 20px;\n}\n.b-note-editor-rdw .rdw-link-modal-target-option > span {\n  margin-left: 5px;\n}\n.b-note-editor-rdw .rdw-link-modal-btn {\n  margin-left: 10px;\n  width: 75px;\n  height: 30px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n.b-note-editor-rdw .rdw-link-modal-btn:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n.b-note-editor-rdw .rdw-link-modal-btn:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n.b-note-editor-rdw .rdw-link-modal-btn:focus {\n  outline: none !important;\n}\n.b-note-editor-rdw .rdw-link-modal-btn:disabled {\n  background: #ece9e9;\n}\n.b-note-editor-rdw .rdw-link-dropdownoption {\n  height: 40px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.b-note-editor-rdw .rdw-history-dropdown {\n  width: 50px;\n}\n.b-note-editor-rdw .rdw-embedded-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.b-note-editor-rdw .rdw-embedded-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  width: 235px;\n  height: 180px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n.b-note-editor-rdw .rdw-embedded-modal-header {\n  font-size: 15px;\n  display: -ms-flexbox;\n  display: flex;\n}\n.b-note-editor-rdw .rdw-embedded-modal-header-option {\n  width: 50%;\n  cursor: pointer;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.b-note-editor-rdw .rdw-embedded-modal-header-label {\n  width: 95px;\n  border: 1px solid #f1f1f1;\n  margin-top: 5px;\n  background: #6EB8D4;\n  border-bottom: 2px solid #0a66b7;\n}\n.b-note-editor-rdw .rdw-embedded-modal-link-section {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.b-note-editor-rdw .rdw-embedded-modal-link-input {\n  width: 88%;\n  height: 35px;\n  margin: 10px 0;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 15px;\n  padding: 0 5px;\n}\n.b-note-editor-rdw .rdw-embedded-modal-link-input-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.b-note-editor-rdw .rdw-embedded-modal-link-input:focus {\n  outline: none;\n}\n.b-note-editor-rdw .rdw-embedded-modal-btn-section {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.b-note-editor-rdw .rdw-embedded-modal-btn {\n  margin: 0 3px;\n  width: 75px;\n  height: 30px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n.b-note-editor-rdw .rdw-embedded-modal-btn:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n.b-note-editor-rdw .rdw-embedded-modal-btn:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n.b-note-editor-rdw .rdw-embedded-modal-btn:focus {\n  outline: none !important;\n}\n.b-note-editor-rdw .rdw-embedded-modal-btn:disabled {\n  background: #ece9e9;\n}\n.b-note-editor-rdw .rdw-embedded-modal-size {\n  -ms-flex-align: center;\n      align-items: center;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 8px 0;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.b-note-editor-rdw .rdw-embedded-modal-size-input {\n  width: 80%;\n  height: 20px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 12px;\n}\n.b-note-editor-rdw .rdw-embedded-modal-size-input:focus {\n  outline: none;\n}\n.b-note-editor-rdw .rdw-emoji-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.b-note-editor-rdw .rdw-emoji-modal {\n  overflow: auto;\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  width: 235px;\n  height: 180px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n.b-note-editor-rdw .rdw-emoji-icon {\n  margin: 2.5px;\n  height: 24px;\n  width: 24px;\n  cursor: pointer;\n  font-size: 22px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.b-note-editor-rdw .rdw-spinner {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  height: 100%;\n  width: 100%;\n}\n.b-note-editor-rdw .rdw-spinner > div {\n  width: 12px;\n  height: 12px;\n  background-color: #333;\n  border-radius: 100%;\n  display: inline-block;\n  animation: sk-bouncedelay 1.4s infinite ease-in-out both;\n}\n.b-note-editor-rdw .rdw-spinner .rdw-bounce1 {\n  animation-delay: -0.32s;\n}\n.b-note-editor-rdw .rdw-spinner .rdw-bounce2 {\n  animation-delay: -0.16s;\n}\n@keyframes sk-bouncedelay {\n  0%,\n  80%,\n  100% {\n    transform: scale(0);\n  }\n  40% {\n    transform: scale(1);\n  }\n}\n.b-note-editor-rdw .rdw-image-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.b-note-editor-rdw .rdw-image-modal {\n  position: absolute;\n  top: 35px;\n  left: 5px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  width: 235px;\n  border: 1px solid #F1F1F1;\n  padding: 15px;\n  border-radius: 2px;\n  z-index: 100;\n  background: white;\n  box-shadow: 3px 3px 5px #BFBDBD;\n}\n.b-note-editor-rdw .rdw-image-modal-header {\n  font-size: 15px;\n  margin: 10px 0;\n  display: -ms-flexbox;\n  display: flex;\n}\n.b-note-editor-rdw .rdw-image-modal-header-option {\n  width: 50%;\n  cursor: pointer;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.b-note-editor-rdw .rdw-image-modal-header-label {\n  width: 80px;\n  background: #f1f1f1;\n  border: 1px solid #f1f1f1;\n  margin-top: 5px;\n}\n.b-note-editor-rdw .rdw-image-modal-header-label-highlighted {\n  background: #6EB8D4;\n  border-bottom: 2px solid #0a66b7;\n}\n.b-note-editor-rdw .rdw-image-modal-upload-option {\n  width: 100%;\n  color: gray;\n  cursor: pointer;\n  display: -ms-flexbox;\n  display: flex;\n  border: none;\n  font-size: 15px;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  background-color: #f1f1f1;\n  outline: 2px dashed gray;\n  outline-offset: -10px;\n  margin: 10px 0;\n  padding: 9px 0;\n}\n.b-note-editor-rdw .rdw-image-modal-upload-option-highlighted {\n  outline: 2px dashed #0a66b7;\n}\n.b-note-editor-rdw .rdw-image-modal-upload-option-label {\n  cursor: pointer;\n  height: 100%;\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 15px;\n}\n.b-note-editor-rdw .rdw-image-modal-upload-option-label span {\n  padding: 0 20px;\n}\n.b-note-editor-rdw .rdw-image-modal-upload-option-image-preview {\n  max-width: 100%;\n  max-height: 200px;\n}\n.b-note-editor-rdw .rdw-image-modal-upload-option-input {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  overflow: hidden;\n  position: absolute;\n  z-index: -1;\n}\n.b-note-editor-rdw .rdw-image-modal-url-section {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.b-note-editor-rdw .rdw-image-modal-url-input {\n  width: 90%;\n  height: 35px;\n  margin: 15px 0 12px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 15px;\n  padding: 0 5px;\n}\n.b-note-editor-rdw .rdw-image-modal-btn-section {\n  margin: 10px auto 0;\n}\n.b-note-editor-rdw .rdw-image-modal-url-input:focus {\n  outline: none;\n}\n.b-note-editor-rdw .rdw-image-modal-btn {\n  margin: 0 5px;\n  width: 75px;\n  height: 30px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  cursor: pointer;\n  background: white;\n  text-transform: capitalize;\n}\n.b-note-editor-rdw .rdw-image-modal-btn:hover {\n  box-shadow: 1px 1px 0px #BFBDBD;\n}\n.b-note-editor-rdw .rdw-image-modal-btn:active {\n  box-shadow: 1px 1px 0px #BFBDBD inset;\n}\n.b-note-editor-rdw .rdw-image-modal-btn:focus {\n  outline: none !important;\n}\n.b-note-editor-rdw .rdw-image-modal-btn:disabled {\n  background: #ece9e9;\n}\n.b-note-editor-rdw .rdw-image-modal-spinner {\n  position: absolute;\n  top: -3px;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  opacity: 0.5;\n}\n.b-note-editor-rdw .rdw-image-modal-alt-input {\n  width: 70%;\n  height: 20px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 12px;\n  margin-left: 5px;\n}\n.b-note-editor-rdw .rdw-image-modal-alt-input:focus {\n  outline: none;\n}\n.b-note-editor-rdw .rdw-image-modal-alt-lbl {\n  font-size: 12px;\n}\n.b-note-editor-rdw .rdw-image-modal-size {\n  -ms-flex-align: center;\n      align-items: center;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 8px 0;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.b-note-editor-rdw .rdw-image-modal-size-input {\n  width: 40%;\n  height: 20px;\n  border: 1px solid #F1F1F1;\n  border-radius: 2px;\n  font-size: 12px;\n}\n.b-note-editor-rdw .rdw-image-modal-size-input:focus {\n  outline: none;\n}\n.b-note-editor-rdw .rdw-image-mandatory-sign {\n  color: red;\n  margin-left: 3px;\n  margin-right: 3px;\n}\n.b-note-editor-rdw .rdw-remove-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 6px;\n  position: relative;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.b-note-editor-rdw .rdw-history-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 6px;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n.b-note-editor-rdw .rdw-history-dropdownoption {\n  height: 40px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.b-note-editor-rdw .rdw-history-dropdown {\n  width: 50px;\n}\n.b-note-editor-rdw .rdw-link-decorator-wrapper {\n  position: relative;\n}\n.b-note-editor-rdw .rdw-link-decorator-icon {\n  position: absolute;\n  left: 40%;\n  top: 0;\n  cursor: pointer;\n  background-color: white;\n}\n.b-note-editor-rdw .rdw-mention-link {\n  text-decoration: none;\n  color: #1236ff;\n  background-color: #f0fbff;\n  padding: 1px 2px;\n  border-radius: 2px;\n}\n.b-note-editor-rdw .rdw-suggestion-wrapper {\n  position: relative;\n}\n.b-note-editor-rdw .rdw-suggestion-dropdown {\n  position: absolute;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  border: 1px solid #F1F1F1;\n  min-width: 100px;\n  max-height: 150px;\n  overflow: auto;\n  background: white;\n  z-index: 100;\n}\n.b-note-editor-rdw .rdw-suggestion-option {\n  padding: 7px 5px;\n  border-bottom: 1px solid #f1f1f1;\n}\n.b-note-editor-rdw .rdw-suggestion-option-active {\n  background-color: #F1F1F1;\n}\n.b-note-editor-rdw .rdw-hashtag-link {\n  text-decoration: none;\n  color: #1236ff;\n  background-color: #f0fbff;\n  padding: 1px 2px;\n  border-radius: 2px;\n}\n.b-note-editor-rdw .rdw-image-alignment-options-popup {\n  position: absolute;\n  background: white;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 5px 2px;\n  border-radius: 2px;\n  border: 1px solid #F1F1F1;\n  width: 105px;\n  cursor: pointer;\n  z-index: 100;\n}\n.b-note-editor-rdw .rdw-alignment-option-left {\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n}\n.b-note-editor-rdw .rdw-image-alignment-option {\n  height: 15px;\n  width: 15px;\n  min-width: 15px;\n}\n.b-note-editor-rdw .rdw-image-alignment {\n  position: relative;\n}\n.b-note-editor-rdw .rdw-image-imagewrapper {\n  position: relative;\n}\n.b-note-editor-rdw .rdw-image-center {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n.b-note-editor-rdw .rdw-image-left {\n  display: -ms-flexbox;\n  display: flex;\n}\n.b-note-editor-rdw .rdw-image-right {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n}\n.b-note-editor-rdw .rdw-image-alignment-options-popup-right {\n  right: 0;\n}\n.b-note-editor-rdw .rdw-editor-main {\n  height: 100%;\n  overflow: auto;\n  box-sizing: border-box;\n}\n.b-note-editor-rdw .rdw-editor-toolbar {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n  background: white;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  font-size: 15px;\n  margin-bottom: 5px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-block {\n  margin: 1em 0;\n}\n.b-note-editor-rdw .rdw-editor-wrapper:focus {\n  outline: none;\n}\n.b-note-editor-rdw .rdw-editor-wrapper {\n  box-sizing: content-box;\n}\n.b-note-editor-rdw .rdw-editor-main blockquote {\n  border-left: 5px solid #f1f1f1;\n  padding-left: 5px;\n}\n.b-note-editor-rdw .rdw-editor-main pre {\n  background: #f1f1f1;\n  border-radius: 3px;\n  padding: 1px 10px;\n}\n.b-note-editor-rdw .DraftEditor-editorContainer,\n.b-note-editor-rdw .DraftEditor-root,\n.b-note-editor-rdw .public-DraftEditor-content {\n  height: inherit;\n  text-align: initial;\n}\n.b-note-editor-rdw .public-DraftEditor-content[contenteditable=true] {\n  -webkit-user-modify: read-write-plaintext-only;\n}\n.b-note-editor-rdw .DraftEditor-root {\n  position: relative;\n}\n.b-note-editor-rdw .DraftEditor-editorContainer {\n  background-color: rgba(255, 255, 255, 0);\n  border-left: 0.1px solid transparent;\n  position: relative;\n  z-index: 1;\n}\n.b-note-editor-rdw .public-DraftEditor-block {\n  position: relative;\n}\n.b-note-editor-rdw .DraftEditor-alignLeft .public-DraftStyleDefault-block {\n  text-align: left;\n}\n.b-note-editor-rdw .DraftEditor-alignLeft .public-DraftEditorPlaceholder-root {\n  left: 0;\n  text-align: left;\n}\n.b-note-editor-rdw .DraftEditor-alignCenter .public-DraftStyleDefault-block {\n  text-align: center;\n}\n.b-note-editor-rdw .DraftEditor-alignCenter .public-DraftEditorPlaceholder-root {\n  margin: 0 auto;\n  text-align: center;\n  width: 100%;\n}\n.b-note-editor-rdw .DraftEditor-alignRight .public-DraftStyleDefault-block {\n  text-align: right;\n}\n.b-note-editor-rdw .DraftEditor-alignRight .public-DraftEditorPlaceholder-root {\n  right: 0;\n  text-align: right;\n}\n.b-note-editor-rdw .public-DraftEditorPlaceholder-root {\n  color: #9197a3;\n  position: absolute;\n  z-index: 0;\n}\n.b-note-editor-rdw .public-DraftEditorPlaceholder-hasFocus {\n  color: #bdc1c9;\n}\n.b-note-editor-rdw .DraftEditorPlaceholder-hidden {\n  display: none;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-block {\n  position: relative;\n  white-space: pre-wrap;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-ltr {\n  direction: ltr;\n  text-align: left;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-rtl {\n  direction: rtl;\n  text-align: right;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-listLTR {\n  direction: ltr;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-listRTL {\n  direction: rtl;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-ol,\n.b-note-editor-rdw .public-DraftStyleDefault-ul {\n  margin: 16px 0;\n  padding: 0;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR {\n  margin-left: 1.5em;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL {\n  margin-right: 1.5em;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR {\n  margin-left: 3em;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL {\n  margin-right: 3em;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR {\n  margin-left: 4.5em;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL {\n  margin-right: 4.5em;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR {\n  margin-left: 6em;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL {\n  margin-right: 6em;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR {\n  margin-left: 7.5em;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL {\n  margin-right: 7.5em;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-unorderedListItem {\n  list-style-type: square;\n  position: relative;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0 {\n  list-style-type: disc;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1 {\n  list-style-type: circle;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-orderedListItem {\n  list-style-type: none;\n  position: relative;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before {\n  left: -36px;\n  position: absolute;\n  text-align: right;\n  width: 30px;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before {\n  position: absolute;\n  right: -36px;\n  text-align: left;\n  width: 30px;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-orderedListItem:before {\n  content: counter(ol0) \". \";\n  counter-increment: ol0;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before {\n  content: counter(ol1) \". \";\n  counter-increment: ol1;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before {\n  content: counter(ol2) \". \";\n  counter-increment: ol2;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before {\n  content: counter(ol3) \". \";\n  counter-increment: ol3;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before {\n  content: counter(ol4) \". \";\n  counter-increment: ol4;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset {\n  counter-reset: ol0;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset {\n  counter-reset: ol1;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset {\n  counter-reset: ol2;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset {\n  counter-reset: ol3;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset {\n  counter-reset: ol4;\n}\n.b-note-editor-rdw .segment {\n  padding: 0 0.5em 0.21428571em !important;\n}\n.b-note-editor-rdw .b-note-editor-rdw-wrapper {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column-reverse;\n      flex-direction: column-reverse;\n}\n.b-note-editor-rdw .rdw-editor-main {\n  margin-top: 0.75em;\n}\n.b-note-editor-rdw .rdw-editor-toolbar {\n  margin-top: 0.5em;\n}\n.b-note-editor-rdw .rdw-option-wrapper {\n  border: 1px solid rgba(34, 36, 38, 0.15) !important;\n  border-radius: 0.28571429rem !important;\n}\n.b-note-editor-rdw .rdw-option-wrapper.rdw-option-active {\n  background: rgba(0, 0, 0, 0.05) !important;\n  color: rgba(0, 0, 0, 0.95) !important;\n}\n.b-note-editor-rdw .rdw-emoji-modal {\n  width: 215px  !important;\n  right: 0px !important;\n  top: 30px !important;\n  left: auto !important;\n}\n.b-note-editor-rdw .rdw-custom-dropdown-privacy {\n  margin-right: 3em;\n  font-size: 0.74em;\n  min-width: 6.2rem !important;\n}\n.b-note-editor-rdw .rdw-custom-dropdown-privacy .dropdown {\n  min-height: auto !important;\n  padding: 0.68571429em 1.2em 0.68571429em 1em;\n}\n.b-note-editor-rdw .rdw-custom-dropdown-privacy .dropdown .menu {\n  width: 100% !important;\n  min-width: 100% !important;\n}\n.b-note-editor-rdw .rdw-custom-dropdown-privacy .dropdown .menu .item {\n  font-size: 0.95em;\n  padding: 1em 1.3em !important;\n}\n.b-note-editor-rdw .rdw-custom-buttons .rdw-cancel-button {\n  padding: 0.58928571em 0.58928571em 0.58928571em !important;\n}\n.b-note-editor-rdw .rdw-custom-buttons .rdw-add-button {\n  margin-right: 0 !important;\n}\n.b-note-editor-rdw .rdw-inline-wrapper > .rdw-option-wrapper:first-child {\n  margin-left: 0 !important;\n}\n.b-note-editor-rdw .rdw-option-wrapper {\n  margin: 0 3.5px !important;\n  min-width: 17px !important;\n  height: 9px !important;\n}\n.b-note-editor-rdw .rdw-inline-wrapper,\n.b-note-editor-rdw .rdw-list-wrapper,\n.b-note-editor-rdw .rdw-emoji-wrapper {\n  margin-bottom: 5px;\n}\n.b-note-editor-rdw .rdw-option-wrapper img {\n  height: 0.9rem !important;\n}\n.b-note-editor-rdw .rdw-option-wrapper[title=\"Bold\"] img,\n.b-note-editor-rdw .rdw-option-wrapper[title=\"Strikethrough\"] img {\n  height: 0.8rem !important;\n}\n.b-note-editor-rdw .rdw-emoji-wrapper > .rdw-option-wrapper img {\n  height: 1.1rem !important;\n}\n.b-note-editor-rdw .rdw-custom-options {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  width: 100%;\n}\n.b-note-editor-rdw .public-DraftEditorPlaceholder-inner {\n  padding: 0 5px;\n}\n.b-note-editor-rdw .DraftEditor-editorContainer {\n  min-height: 2.5em;\n  /* min text area height */\n  max-height: 8em;\n  /* max text area height */\n  padding: 0 5px;\n}\n.b-note-editor-rdw .DraftEditor-editorContainer .public-DraftEditor-content {\n  overflow-wrap: anywhere !important;\n}\n.b-note-editor-rdw .DraftEditor-editorContainer .public-DraftStyleDefault-block {\n  margin: 0 !important;\n}\n.b-note-editor-rdw .public-DraftStyleDefault-ol,\n.b-note-editor-rdw .public-DraftStyleDefault-ul {\n  margin: 8px 0 !important;\n}\n.b-note-editor-rdw .no-padding {\n  padding: 0 !important;\n}\n.app--listcontrols {\n  padding-top: 3em;\n}\n.app--listcontrols.remove-pad-btm {\n  padding-bottom: 0px !important;\n}\n.app--listcontrols .right {\n  text-align: right;\n}\n.app--listcontrols .left {\n  font-size: 14px !important;\n}\n.DSRMultipleRecords > .status-content > .title:before {\n  background-image: url(" + escape(__webpack_require__(3520)) + ");\n}\n.DSRMultipleRecords h1 {\n  font-size: 1.8em;\n  text-transform: uppercase;\n  text-align: left;\n}\n.DSRMultipleRecords h5 {\n  font-size: 1.4em;\n  text-align: left;\n}\n.DSRMultipleRecords p {\n  text-align: left;\n  margin: 0;\n}\n.DSRMultipleRecords .title {\n  padding: 0.8em 1.2em;\n  min-height: 5em;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  background: #e2e2e2;\n  color: #383f43;\n  margin-bottom: 0.5em;\n}\n.DSRMultipleRecords .title > div {\n  width: 50%;\n  -ms-flex-item-align: center;\n      align-self: center;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  display: -ms-flexbox;\n  display: flex;\n  margin-left: 0.8em;\n}\n.DSRMultipleRecords .title > div:last-child {\n  text-align: right;\n}\n.DSRMultipleRecords .title:before {\n  margin-top: 0.65em;\n  text-align: center;\n  display: -ms-flexbox;\n  display: flex;\n  background-size: contain;\n  padding: 1em;\n  background-repeat: no-repeat;\n  content: \"\";\n}\n.DSRMultipleRecords .content {\n  padding: 1em 1.5em;\n}\n.DSRMultipleRecords .date {\n  text-align: right;\n}\n.DSRMultipleRecords button.button {\n  margin-bottom: 2em;\n}\n.DSRMultipleRecords .status-content h5 {\n  font-size: 1.5em;\n}\n.DSRMultipleRecords .content thead {\n  background-color: #5c666f;\n  border-radius: 0.3em;\n}\n.DSRMultipleRecords .content table {\n  border-collapse: separate;\n  border-radius: 0.3em;\n  font-size: 0.875em;\n  margin: 2em auto 2em auto;\n  width: 100%;\n}\n.DSRMultipleRecords .content tbody {\n  background: #42494f;\n}\n.DSRMultipleRecords .content tbody tr {\n  font-size: 0.9em;\n  cursor: pointer;\n}\n.DSRMultipleRecords .content td.loading {\n  text-align: center;\n}\n.DSRMultipleRecords .content td.loading img {\n  width: 100px;\n}\n.DSRMultipleRecords .content th {\n  padding: 1.5em;\n  text-align: left;\n  text-transform: uppercase;\n}\n.DSRMultipleRecords .content td {\n  padding: 1.5em;\n  text-align: left;\n}\n.DSRMultipleRecords .content th:last-of-type {\n  border: 0;\n}\n.DSRMultipleRecords .content table .select .FormGroup {\n  margin-bottom: 0;\n  width: 20px;\n  margin-left: auto;\n  margin-right: auto;\n}\n.DSRMultipleRecords .mobile-center {\n  text-align: center;\n}\n.DSRMultipleRecords .tag .FormGroup {\n  margin-top: 0.3em;\n  margin-bottom: 0;\n  float: left;\n}\n.DSRMultipleRecords .tag span {\n  font-size: 1.2em;\n}\n@media only screen and (min-width: 551px) {\n  .DSRMultipleRecords .content table th:first-child {\n    border-top-left-radius: 0.5em;\n  }\n  .DSRMultipleRecords .content table th:last-child {\n    border-top-right-radius: 0.5em;\n  }\n  .DSRMultipleRecords .content table tr:last-child td:first-child {\n    border-bottom-left-radius: 0.5em;\n  }\n  .DSRMultipleRecords .content table tr:last-child td:last-child {\n    border-bottom-right-radius: 0.5em;\n  }\n}\n@media only screen and (max-width: 550px) {\n  .DSRMultipleRecords h1 {\n    font-size: 1.4em;\n  }\n  /* Force table to not be like tables anymore */\n  .DSRMultipleRecords .content table,\n  .DSRMultipleRecords .content thead,\n  .DSRMultipleRecords .content tbody,\n  .DSRMultipleRecords .content th,\n  .DSRMultipleRecords .content td,\n  .DSRMultipleRecords .content tr {\n    display: block;\n  }\n  .DSRMultipleRecords .content table {\n    border-collapse: collapse;\n    border: none;\n  }\n  /* Hide table headers (but not display: none;, for accessibility) */\n  .DSRMultipleRecords .content th {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n  /* Hide table headers (but not display: none;, for accessibility) */\n  .DSRMultipleRecords .content tbody td.select {\n    position: absolute;\n    top: -9999px;\n    left: -9999px;\n  }\n  .DSRMultipleRecords .content tbody tr:not(:first-child) {\n    margin: 1em 0;\n  }\n  .DSRMultipleRecords .content tbody tr {\n    border-radius: 0.3em;\n    background-color: #42494f;\n  }\n  .DSRMultipleRecords .content tbody tr.selected {\n    background-color: #E9F1F2;\n    transition: background-color 200ms ease-out;\n    color: #383f44;\n  }\n  .DSRMultipleRecords .content tbody tr.selected td:first-child {\n    background-color: #00BC9E;\n    transition: background-color 200ms ease-out;\n    color: white;\n  }\n  .DSRMultipleRecords .content tbody td {\n    border: none;\n  }\n  .DSRMultipleRecords .content tbody td:first-child {\n    font-weight: bold;\n    font-size: 1.3em;\n    text-align: center;\n    padding: 0.8em 0em;\n    border-top-left-radius: 0.3em;\n    border-top-right-radius: 0.3em;\n    background-color: #5c666f;\n  }\n  .DSRMultipleRecords .content tbody tr:after {\n    content: \"\";\n    padding: 1em;\n  }\n  .DSRMultipleRecords .content tbody td:not(:first-child) {\n    position: relative;\n    padding-left: 40%;\n    padding-top: 0.8em;\n    padding-bottom: 0.5em;\n  }\n  .DSRMultipleRecords .content tbody td:before {\n    /* Now like a table header */\n    position: absolute;\n    /* Top/left values mimic padding */\n    font-weight: bold;\n    top: 0;\n    left: 0.4em;\n    width: 45%;\n    padding-right: 10px;\n    white-space: nowrap;\n    padding: 0.8em;\n    text-align: left;\n    text-transform: uppercase;\n  }\n  .DSRMultipleRecords .content tbody td:nth-of-type(2):before {\n    content: \"Name\";\n  }\n  .DSRMultipleRecords .content tbody td:nth-of-type(3):before {\n    content: \"Ic\";\n  }\n  .DSRMultipleRecords .content tbody td:nth-of-type(4):before {\n    content: \"Nationality\";\n  }\n  .DSRMultipleRecords .content tbody td:nth-of-type(5):before {\n    content: \"Dob\";\n  }\n  .DSRMultipleRecords .tag {\n    text-align: left;\n  }\n  .DSRMultipleRecords .tag .FormGroup {\n    margin-top: 0;\n    margin-left: 1.1em;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .flexitem:nth-child(1) {\n    border-top: 1px #ddd solid;\n  }\n  .threedots > img {\n    right: -0.5em;\n    position: relative;\n  }\n  .list-data.item {\n    -ms-flex-direction: initial !important;\n        flex-direction: initial !important;\n  }\n  .list-data.item .image,\n  .list-data.item .image > img {\n    width: 100px !important;\n    height: 100px !important;\n  }\n  .segment1 {\n    text-align: center;\n  }\n  .segment1 > .countDownBox > button {\n    width: 100%;\n  }\n}\n@media only screen and (min-width: 1200px) {\n  .segment.segment1 > .countDownBox > button {\n    margin-left: 1rem;\n  }\n  .segment.segment1 > p {\n    margin-bottom: 0;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .list-data.item .image,\n  .list-data.item .image > img {\n    width: 110px !important;\n    height: 110px !important;\n  }\n  .list-data.item .extra {\n    margin: 0 !important;\n  }\n  .flexitem {\n    border-right: 1px #ddd solid;\n  }\n  .flexitem:nth-child(1),\n  .flexitem:nth-child(2) {\n    border-top: 1px #ddd solid;\n  }\n  .flexitem:nth-child(odd),\n  .flexitem:nth-child(1) {\n    border-left: 1px #ddd solid;\n  }\n  .threedots > img {\n    right: -1.8em;\n    position: relative;\n  }\n  .segment1 > .countDownBox {\n    margin-bottom: 0;\n  }\n  .segment.segment1 {\n    padding: 2rem;\n  }\n}\n.app--tablelist tbody > tr > td {\n  cursor: pointer;\n}\n.app--listdata .flexitem {\n  padding: 1em;\n  border-bottom: 1px #ddd solid;\n}\n.app--listdata .flexitem .item-info {\n  padding-right: 0 !important;\n}\n.app--listdata .flexitem .list-data.item {\n  margin: 0 !important;\n}\n.app--listdata .flexitem .list-data.item .extra > div {\n  margin: 0.25rem 0.5rem 0 0;\n}\n.app--listdata .flexitem .list-data.item > .content {\n  padding: 0 0.75em !important;\n}\n.app--listdata .flexitem .list-data.item > .content p {\n  margin: 0.25em 0 0.25em !important;\n}\n.table.ui {\n  width: auto !important;\n  min-width: 100%;\n}\n@media only screen and (max-width: 360px) {\n  .ui.compact.table.custom th {\n    padding-right: 0 !important;\n  }\n}\n.text.primary {\n  color: rgba(0, 0, 0, 0.87);\n}\n.text.disabled,\n.text.hint {\n  color: rgba(0, 0, 0, 0.38);\n}\n.project-status-label {\n  top: 0 !important;\n  bottom: auto !important;\n}\n.card-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  gap: 16px;\n  padding: 16px;\n  background: #fff;\n  border-radius: 10px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  color: #00233B;\n  min-height: 182px;\n  height: 100%;\n  border: 1px solid transparent;\n}\n.card-container:hover {\n  border: 1px solid #49B3B1;\n  box-shadow: 0px 0px 8px 0px #00000012;\n}\n.card-container .status-label {\n  position: absolute;\n  top: 9px;\n  left: 8px;\n  color: #fff !important;\n  padding: 0.25rem 0.5rem;\n  border-radius: 9px 15px 15px 0 !important;\n  font-size: 0.75rem;\n}\n.card-container .bookmark-icon {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  cursor: pointer;\n}\n.card-container .info-container {\n  -ms-flex: 2;\n      flex: 2;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.card-container .info-container .info {\n  font-weight: 500;\n  font-size: 11px;\n  color: #596975;\n}\n.card-container .info-container .info.ui.grid > .row {\n  margin-top: 14px;\n}\n.card-container .info-container .name {\n  font-weight: 700;\n  font-size: 14px !important;\n}\n.card-container .info-container .price {\n  font-size: 12px !important;\n}\n.card-container .info-container .item {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: start;\n      align-items: flex-start;\n  gap: 10px;\n  margin-bottom: 10px;\n}\n.card-container .info-container .item .icon {\n  background: #F4F5F7;\n  width: 30px;\n  height: 30px;\n  opacity: 0.8;\n  border-radius: 4px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex: 0 0 30px;\n      flex: 0 0 30px;\n}\n.card-container .info-container .item .icon img {\n  width: 16px;\n  height: 16px;\n}\n.card-container .info-container .item .title {\n  font-size: 10px;\n  line-height: 10px;\n}\n.card-container .info-container .item .value {\n  font-size: 12px;\n  color: #00233B;\n}\n.card-container .info-container .label-group {\n  margin-top: auto;\n}\n.card-container .info-container .label-group .ui.label {\n  color: #596975;\n  font-weight: 600;\n  font-size: 10px;\n  text-align: center;\n  margin-top: 2px;\n}\n.card-container .info-container .label-group .ui.label.bu-label {\n  background-color: #F4F5F7 !important;\n}\n.card-container .image-container {\n  position: relative;\n  -ms-flex: 1;\n      flex: 1;\n  max-width: 200px;\n}\n.card-container .image-container img {\n  -o-object-fit: cover;\n     object-fit: cover;\n  width: 100%;\n  height: 100%;\n}\n.card-container .image-container .ui.centered.image {\n  overflow: hidden;\n  height: 160px !important;\n  border-radius: 10px;\n}\n.card-container .image-container .ui.centered.image:not(.loaded):before {\n  background: #DCEFF1;\n}\n.card-container .image-container .default-img {\n  width: 70%;\n  height: auto;\n  display: block;\n  margin: 0 auto;\n}\n/* Mobile and Tablet (between 768px and 1023px) */\n@media (max-width: 1023px) {\n  .card-container {\n    -ms-flex-direction: column;\n        flex-direction: column;\n  }\n  .card-container .image-container {\n    max-width: 100%;\n    height: 200px;\n  }\n  .card-container .image-container .default-img {\n    width: 50%;\n    height: auto;\n    display: block;\n    margin: 0 auto;\n  }\n}\n.custom-popup {\n  background-color: #596975 !important;\n  border-radius: 4px !important;\n  padding: 4px 10px !important;\n  border: 1px solid #596975 !important;\n  color: #FFFFFF !important;\n  font-family: Lato !important;\n  font-weight: 600 !important;\n  font-size: 10px !important;\n}\n.custom-popup:before {\n  display: none !important;\n}\n@media only screen and (max-width: 767px) {\n  .row_default_pricing .column:first-child {\n    padding-bottom: 1em;\n  }\n}\n.row_default_pricing .header_title {\n  color: #696867;\n}\n.row_default_pricing .label_dropdown_pricing_package {\n  margin: 0 0 0.28571429rem 0;\n  font-size: 13px;\n  font-weight: bold;\n  color: rgba(0, 0, 0, 0.87);\n}\n.hims_notice {\n  margin-bottom: 2.5em;\n}\n.hims_notice .ui.message {\n  font-weight: 600;\n  background: #EDF7FD;\n}\n.hims_notice .ui.attached.segment {\n  background-color: #f7fbfe;\n  border-radius: 0 0 4px 4px;\n  color: #969CA4;\n  padding: 1em;\n}\n.hims_notice .ui.attached.segment .ui.list:last-child,\n.hims_notice .ui.attached.segment ol.ui.list:last-child,\n.hims_notice .ui.attached.segment ul.ui.list:last-child {\n  display: inline-block;\n  text-align: left;\n  padding: 0.5em 0.5em 1em;\n}\n.hims_notice .ui.attached.segment .ui.ordered.list .list > .item:before,\n.hims_notice .ui.attached.segment .ui.ordered.list > .item:before,\n.hims_notice .ui.attached.segment ol.ui.list li:before {\n  color: #969CA4;\n}\n.component_title {\n  font-size: 16px;\n}\n.component_title .ui.divider {\n  font-size: 16px;\n}\n.himsModal .modal_header {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.himsModal .modal_header .closeButton {\n  border: none;\n  padding: 0;\n  margin-left: 1em;\n  box-shadow: none;\n  filter: opacity(0.6);\n  transition: all 0.5s;\n}\n.himsModal .modal_header .closeButton:hover {\n  border: none;\n  padding: 0;\n  box-shadow: none;\n  filter: opacity(1);\n}\n.ui.table.units tr.row-colors.unit_row_new,\n.ui.table.units tr.row-colors.unit_row_available {\n  background-color: rgba(154, 225, 151, 0.05);\n}\n.ui.table.units tr.row-colors.unit_row_new:hover,\n.ui.table.units tr.row-colors.unit_row_available:hover {\n  background-color: rgba(154, 225, 151, 0.1) !important;\n}\n.ui.table.units tr.row-colors.unit_row_reserved,\n.ui.table.units tr.row-colors.unit_row_developer_reserved {\n  background-color: rgba(255, 200, 0, 0.05);\n}\n.ui.table.units tr.row-colors.unit_row_reserved:hover,\n.ui.table.units tr.row-colors.unit_row_developer_reserved:hover {\n  background-color: rgba(255, 200, 0, 0.1) !important;\n}\n.ui.table.units tr.row-colors.unit_row_booked,\n.ui.table.units tr.row-colors.unit_row_developer_booked {\n  background-color: rgba(255, 135, 0, 0.05);\n}\n.ui.table.units tr.row-colors.unit_row_booked:hover,\n.ui.table.units tr.row-colors.unit_row_developer_booked:hover {\n  background-color: rgba(255, 135, 0, 0.1) !important;\n}\n.ui.table.units tr.row-colors.unit_row_sold_spa_signed,\n.ui.table.units tr.row-colors.unit_row_developer_sold,\n.ui.table.units tr.row-colors.unit_row_unavailable {\n  background-color: rgba(255, 0, 0, 0.05);\n}\n.ui.table.units tr.row-colors.unit_row_sold_spa_signed:hover,\n.ui.table.units tr.row-colors.unit_row_developer_sold:hover,\n.ui.table.units tr.row-colors.unit_row_unavailable:hover {\n  background-color: rgba(255, 0, 0, 0.1) !important;\n}\n.ui.table.units tr.row-colors.unit_row_delist {\n  background-color: rgba(118, 118, 118, 0.05);\n}\n.ui.table.units tr.row-colors.unit_row_delist:hover {\n  background-color: rgba(118, 118, 118, 0.1) !important;\n}\n.payment-card {\n  padding-top: 10px !important;\n  padding-bottom: 10px !important;\n  background-color: #E8F3FA;\n  border-radius: 5px;\n}\n.payment-card-cancelled {\n  color: #9d9d9d;\n  background-color: #EFEFEF;\n}\n.payment-card-online-failed {\n  color: #9d9d9d;\n  background-color: #FAE8E8;\n}\n.payment-card-online-expired-rejected {\n  color: #9d9d9d;\n  background-color: #EFEFEF;\n}\n.payment-card-cancelled .ui.header {\n  color: #9d9d9d;\n}\n.payment-card-options a:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n}\n@media only screen and (max-width: 767px) {\n  .payment-save {\n    margin-bottom: 1em !important;\n  }\n}\n.ui.table.online-payments .row-colors.payment_expired {\n  background-color: rgba(174, 186, 193, 0.15) !important;\n}\n.online-rejected-label {\n  color: white !important;\n  background-color: #E74C3C !important;\n}\n@media only screen and (max-width: 767px) {\n  .ui.table.bookings:not(.unstackable) tr > td,\n  .ui.table.bookings:not(.unstackable) tr > th {\n    padding-top: 0em !important;\n    padding-bottom: 0em !important;\n  }\n  .row.reference-info-button {\n    padding-bottom: 0.25em !important;\n  }\n  .ui.table:not(.unstackable) tr > td.mobile-hide {\n    display: none !important;\n  }\n}\n.ui.table.bookings .row-colors.booking_row_cancelled_developer {\n  background-color: rgba(174, 186, 193, 0.15) !important;\n}\n.ui.table.bookings .row-colors.booking_row_cancelled_availability {\n  background-color: rgba(194, 140, 216, 0.1) !important;\n}\n.ui.table.bookings thead th {\n  padding: 0.5em 0.78571429em 0.92857143em 0.78571429em;\n  border-left: none;\n  border-right: none;\n  border-bottom: 1px solid #BCBCBC;\n}\n.ui.table.bookings thead th.sorted {\n  background: transparent;\n}\n.ui.table.bookings thead th:nth-last-child(3) {\n  border-left: 1px solid #BCBCBC;\n}\n.ui.table.bookings tbody td:nth-last-child(3) {\n  border-left: 1px solid #BCBCBC;\n}\n.ui.modal.booking-status-note .cancel_options {\n  margin-top: 1.5em;\n}\n.ui.modal.booking-status-note .cancel_options .field {\n  margin: 0 0 0.5em;\n}\n.ui.modal.booking-status-note .cancel_options .field:first-child {\n  margin: 0 0 1em !important;\n}\n.ui.modal.booking-status-note .booking-sold-status-info {\n  margin-bottom: 0.5em;\n}\n.ui.modal.booking-status-note .booking-sold-status-info div.column div.row {\n  padding-bottom: 0.5em;\n}\n.ui.modal.booking-status-note .ui.checkbox.booking-sold-status-note > label {\n  color: rgba(0, 0, 0, 0.87);\n}\n.ui.modal.booking-status-note .ui.label.booking-sold-status-label {\n  background: transparent;\n  float: left;\n  font-size: 1em;\n  padding-top: 0.8em;\n  font-weight: normal;\n  color: rgba(0, 0, 0, 0.85);\n  margin: 0;\n}\n.ui.modal.booking-status-note .ui.form [class*=\"equal width\"].fields > .field.booking-sold-status-banker-name {\n  opacity: 1;\n}\n@media only screen and (max-width: 425px) {\n  .ui.modal.booking-status-note .ui.checkbox {\n    width: 100%;\n    margin: -0.5em 0.5em 1.5em 0.5em;\n  }\n  .ui.modal.booking-status-note .ui.label.booking-sold-status-label {\n    margin-bottom: 1em;\n  }\n}\n.inactive-case {\n  opacity: 0.6;\n}\n.inactive-case.dark {\n  opacity: 0.7;\n  margin: -0.85em;\n  background: rgba(0, 0, 0, 0.2);\n}\n.ui.secondary.menu .item.booking-manage {\n  color: #2185d0;\n  font-size: 1.1em;\n  font-weight: bold;\n  text-align: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  padding: 0.5em 0;\n}\n.ui.secondary.menu .item.booking-manage:hover {\n  color: #1678c2;\n}\n.ui.secondary.menu .item.booking-manage:hover:not(:focus) {\n  background: none;\n}\n.ui.grid.booking-list .row.tab-menu {\n  padding-bottom: 0;\n}\n.ui.grid.booking-list .row.tab-menu .column {\n  padding: 0;\n}\n.ui.grid.booking-list .row.tab-menu .column .ui.menu {\n  border-bottom: none;\n}\n.ui.grid.booking-list .row.tab-menu .column .ui.menu > a.item {\n  min-width: 80px;\n  background: #B4BABE;\n  border-bottom: none !important;\n  border-left: none !important;\n  border-right: none !important;\n  border-top: none !important;\n  font-weight: bold;\n  text-align: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  padding: 0.5em 1.42857143em;\n}\n.ui.grid.booking-list .row.tab-menu .column .ui.menu > a.item.active {\n  background: #DBE1E5;\n  border-radius: 0 !important;\n}\n.ui.grid.booking-list .row.tab-menu .column .ui.menu > a.item:first-child {\n  border-radius: 0.28571429rem 0 0 0 !important;\n}\n.ui.grid.booking-list .row.tab-menu .column .ui.menu > a.item:not(:first-child) {\n  margin-left: 1px;\n}\n.ui.grid.booking-list .row.tab-menu .column .ui.menu > a.item:last-of-type {\n  border-radius: 0 0.28571429rem 0 0 !important;\n}\n.ui.grid.booking-list .row.tab-menu .column .ui.menu .manage {\n  color: #5C71A8;\n  font-size: 1.1em;\n  font-weight: bold;\n  text-align: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  padding: 0.5em 0;\n}\n.ui.grid.booking-list .row.tab-menu .column .ui.menu .manage:hover {\n  color: #495a88;\n}\n@media only screen and (max-width: 425px) {\n  .ui.grid.booking-list .row.tab-menu .column .ui.menu a.item {\n    -ms-flex: 1;\n        flex: 1;\n    -ms-flex-align: start;\n        align-items: flex-start;\n  }\n  .ui.grid.booking-list .row.tab-menu .column .ui.menu a.item.manage {\n    width: 100%;\n  }\n  .ui.grid.booking-list .row.tab-menu .column .ui.menu .right.menu {\n    margin-left: 0;\n  }\n}\n.ui.grid.booking-list .row.toolbar {\n  background: #DBE1E5;\n  border-radius: 0 0 0.28571429rem 0.28571429rem;\n}\n.ui.grid.booking-list .row.toolbar.new {\n  background: #FFFFFFFF !important;\n  border-radius: 6px;\n  box-shadow: 0px 2px 5px #171a1f17, 0px 0px 2px #171a1f1F;\n  margin-bottom: 30px;\n  margin-top: 10px;\n  padding-bottom: 30px;\n}\n.ui.grid.booking-list .row.toolbar .ui.grid.status {\n  margin: 0 0 1em 0;\n}\n.ui.grid.booking-list .row.toolbar .ui.grid.status .row {\n  padding: 0;\n  border-bottom: 1px solid #C4CBD0;\n}\n.ui.grid.booking-list .row.toolbar .ui.grid.filters > .row {\n  padding: 1rem;\n}\n.ui.grid.booking-list .row.toolbar .ui.grid.filters > .row > .column {\n  padding-left: 0;\n  padding-right: 0;\n}\n.ui.grid.booking-list .row.toolbar .ui.grid.filters > .row > .column.filter:first-child {\n  padding-right: 0.25rem;\n}\n.ui.grid.booking-list .row.toolbar .ui.grid.filters > .row > .column.filter:nth-child(n+2) {\n  padding-right: 0.25rem;\n  padding-left: 0.25rem;\n}\n@media only screen and (max-width: 767px) {\n  .ui.grid.booking-list .row.toolbar .ui.grid.filters > .row > .column.filter:nth-child(odd) {\n    padding-left: 0;\n  }\n  .ui.grid.booking-list .row.toolbar .ui.grid.filters > .row > .column.filter:nth-child(even) {\n    padding-right: 0;\n  }\n}\n.ui.grid.booking-list .row.toolbar .ui.grid.filters > .row > .column.clear {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  -ms-flex-align: center;\n      align-items: center;\n  white-space: nowrap;\n}\n@media only screen and (max-width: 767px) {\n  .ui.grid.booking-list .row.toolbar .ui.grid.filters > .row > .column.clear a {\n    font-size: 1.5em;\n  }\n}\n@media only screen and (max-width: 991px) {\n  .ui.grid.booking-list .row.toolbar .ui.grid.filters > .row > .column.clear {\n    -ms-flex-align: end;\n        align-items: flex-end;\n  }\n  .ui.grid.booking-list .row.toolbar .ui.grid.filters > .row > .column:last-child:not(.clear) {\n    padding-top: 0.5rem;\n  }\n  .ui.grid.booking-list .row.toolbar .ui.grid.filters > .row > .column:last-child:not(.clear).mobile-padding-left {\n    padding-left: 0.5rem;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .ui.grid.booking-list .row.toolbar .ui.grid.filters > .row > .column.clear {\n    padding-right: 0;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .ui.grid.booking-list .row.toolbar .ui.grid.filters.booking > .row > .column.filter:nth-last-child(3) {\n    padding-right: 0;\n  }\n}\n.ui.grid.booking-list .row.toolbar .ui.booking.searchlist > .ui.icon.input > input {\n  min-height: 2.7142em;\n  padding: 0.7em 1em 0.5em 0.7em;\n}\n.ui.grid.booking-list .row.toolbar .ui.booking.searchlist.selected > .ui.icon.input > input {\n  border-color: #56B35A;\n}\n.ui.grid.booking-list .row.toolbar .ui.dropdown.booking {\n  background: #FFF;\n  padding: 0.7em 1em 0.5em 0.7em;\n  line-height: 1em;\n  border: 1px solid rgba(34, 36, 38, 0.15);\n  min-height: 2.7142em;\n  color: rgba(0, 0, 0, 0.87);\n  border-radius: 0.28571429rem;\n  transition: box-shadow 0.1s ease, width 0.1s ease;\n  white-space: nowrap;\n}\n.ui.grid.booking-list .row.toolbar .ui.dropdown.booking:hover {\n  border-color: rgba(34, 36, 38, 0.35);\n}\n.ui.grid.booking-list .row.toolbar .ui.dropdown.booking.selected {\n  border-color: #56B35A;\n}\n.ui.grid.booking-list .row.toolbar .ui.dropdown.booking > .dropdown.icon {\n  cursor: pointer;\n  position: absolute;\n  width: auto;\n  height: auto;\n  line-height: 1.2142em;\n  top: 0.78571429em;\n  right: 0.8em;\n  margin: -0.78571429em;\n  padding: 0.78571429em;\n}\n.ui.grid.booking-list .row.toolbar .ui.dropdown.booking .header {\n  margin-bottom: 0.5em;\n}\n.ui.grid.booking-list .row.toolbar .ui.dropdown.booking .menu {\n  margin-top: 0.3em;\n  right: 0;\n}\n.ui.grid.booking-list .row.toolbar .ui.dropdown.booking .menu i.icon.square {\n  margin-right: 0.78571429rem;\n}\n.ui.grid.booking-list .row.toolbar .ui.dropdown.booking .menu i.icon.square.check {\n  color: #56B35A;\n}\n@media only screen and (max-width: 767px) {\n  .ui.grid.booking-list .row.toolbar .ui.dropdown.booking.scrolling .menu {\n    max-height: 11.5em;\n  }\n}\n.ui.grid.booking-list .row.manage-booking-tab {\n  padding: 3em 1em 0em 1em;\n}\n@media only screen and (max-width: 1199px) {\n  .app--mblr {\n    padding-top: 0 !important;\n  }\n}\n.manage-booking-list-row {\n  padding-top: 0 !important;\n}\n@media only screen and (max-width: 767px) {\n  .manage-booking-list-row .manage-booking-list-col {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n}\n.ui.grid.booking-data .row.header {\n  padding-bottom: 0;\n}\n@media only screen and (max-width: 767px) {\n  .ui.grid.booking-data .row.header .column:first-child {\n    padding: 0 1rem;\n  }\n}\n.ui.grid.booking-data .row .column:not(.download) {\n  padding: 0;\n}\n.ui.grid.booking-data .row .column.download .title {\n  display: inline;\n  margin-right: 0.5em;\n}\n.ui.grid.booking-data .row .column.download .ui.buttons .ui.button:not(.sort-button) {\n  padding: 0.6em 1.25em;\n  color: #5C71A8 !important;\n  white-space: pre;\n  -ms-flex-pack: center;\n      justify-content: center;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n.ui.grid.booking-data .row .column.download .ui.buttons .ui.button:not(.sort-button):hover {\n  background: rgba(0, 0, 0, 0.05) !important;\n}\n@media only screen and (max-width: 767px) {\n  .ui.grid.booking-data .row .column.download .title {\n    display: block;\n    margin-right: 0;\n    margin-bottom: 0.5em;\n  }\n}\n.ui.modal.booking-change-unit .booking-change-unit-info {\n  margin-bottom: 0.5em;\n}\n.ui.modal.booking-change-unit .booking-change-unit-info div.column div.row {\n  padding-bottom: 0.5em;\n}\n.ui.table.hims_bookings thead th {\n  padding: 0.5em 0.78571429em 0.92857143em 0.78571429em;\n  border-left: none;\n  border-right: none;\n  border-bottom: 1px solid #BCBCBC;\n}\n.ui.table.hims_bookings thead th.sorted {\n  background: transparent;\n}\n.ui.table.hims_bookings thead th:nth-last-child(2) {\n  border-left: 1px solid #BCBCBC;\n}\n.ui.table.hims_bookings tbody td:nth-last-child(2) {\n  border-left: 1px solid #BCBCBC;\n}\n.teal-remove {\n  border: none !important;\n  box-shadow: none !important;\n}\n.teal-remove i.icon {\n  color: #82CBC9FF !important;\n}\n.booking-sold-notice {\n  background: #EDF7FD !important;\n  border-radius: 4px !important;\n  box-shadow: none !important;\n  border: 1px solid #d4d4d5 !important;\n}\n.booking-sold-notice .title {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 8px;\n}\n.booking-sold-notice .title i.icon {\n  margin-right: 0.6em;\n}\n.booking-sold-notice .content {\n  color: #969CA4;\n}\n.custom_dropdown .menu.transition.visible {\n  max-height: 170px !important;\n}\n.booking_section_tabs {\n  overflow-x: auto;\n}\n.booking_section_tabs.sticky .button {\n  color: #cfcfcf !important;\n  background-color: #707070 !important;\n}\n.booking_section_tabs.sticky .button:not(:first-child) {\n  border-left: solid #333 1px !important;\n}\n.booking_section_tabs.sticky .button.active {\n  color: #1b1c1d !important;\n  background-color: #E7ECF1 !important;\n}\n.booking_section_tabs.sticky .button:hover {\n  color: #eee !important;\n  background-color: #999 !important;\n}\n.booking_section_tabs .button {\n  transition: all 0.25s ease-in-out;\n  background-color: #E7ECF1 !important;\n}\n.booking_section_tabs .button:not(:first-child) {\n  border-left: solid white 1px;\n}\n.booking_section_tabs .button .header {\n  color: rgba(0, 0, 0, 0.75) !important;\n}\n.booking_section_tabs .button .header .sub.header {\n  color: rgba(0, 0, 0, 0.6) !important;\n}\n.booking_section_tabs .button:hover {\n  transition: all 0.25s ease-in-out;\n  background-color: #CFD4D8 !important;\n}\n.booking_section_tabs .button:hover .header {\n  color: #000000 !important;\n}\n.booking_section_tabs .button:hover .header .sub.header {\n  color: rgba(0, 0, 0, 0.7) !important;\n}\n.booking_section_tabs .button.active {\n  color: white !important;\n  background-color: #00233B !important;\n}\n.booking_section_tabs .button.active .header {\n  color: white !important;\n}\n.booking_section_tabs .button.active .header .sub.header {\n  color: rgba(255, 255, 255, 0.8) !important;\n}\n.header.new_title {\n  background-color: #E7ECF1 !important;\n}\n.header.hims_unit_fields {\n  background-color: #f9fafb !important;\n}\n.ui.button.compact.labeled.dropdown.ui.medium.compact.primary.button.icon.print_dropdown {\n  padding-left: 3.5em;\n  padding-right: 1em !important;\n}\n.ui.button.compact.labeled.dropdown.ui.medium.compact.primary.button.icon.print_dropdown .menu.transition.visible {\n  right: 0 !important;\n  left: auto !important;\n}\n.ui.container.nric-signature-container {\n  background-color: #E7ECF1;\n  margin: 0.5em 0 !important;\n  height: auto;\n  min-height: 5rem;\n  padding-bottom: 0.5em;\n}\n.ui.container.e-signature-container {\n  height: auto;\n  min-height: 5rem;\n  padding-bottom: 0.5em;\n}\n.e-signature-actions {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  text-align: center;\n}\n.icSignStyle {\n  margin: 0 !important;\n}\n.text_deduct {\n  color: #db2828;\n}\n.text_add {\n  color: #21ba45;\n}\n.segment.bookingSummaryContainer > .bookingSummary {\n  word-wrap: break-word;\n}\n.segment.bookingSummaryContainer {\n  white-space: pre-wrap;\n}\n.text_deduct {\n  color: #db2828;\n}\n.text_add {\n  color: #21ba45;\n}\n.segment.bookingSummaryContainer > .bookingSummary {\n  word-wrap: break-word;\n}\n.segment.bookingSummaryContainer {\n  white-space: pre-wrap;\n}\n.search.searchlist > .results > .result .title {\n  font-size: 0.95em;\n}\n.column.clear > a > button {\n  padding: 0.8em 1.2em;\n  margin: 0;\n}\n.column.clear > a > button > .icon {\n  margin-right: 0 !important;\n}\n@media only screen and (min-width: 767px) {\n  .bookingSummaryContainer {\n    padding: 2.5em !important;\n  }\n  .bookingSummary > .personalInfo {\n    padding-top: 2rem;\n    padding-bottom: 2rem;\n  }\n  .bookingSummary > .header {\n    padding-bottom: 1rem;\n  }\n  .button-group {\n    padding-top: 5rem;\n    padding-bottom: 3rem;\n  }\n  .previewBtn {\n    margin-left: 1rem;\n    margin-right: 1rem;\n    vertical-align: text-top;\n    width: 22%;\n    height: 50px;\n  }\n  .saveBtn {\n    vertical-align: text-top;\n    width: 22%;\n    height: 50px;\n  }\n  .printButton > .ui.compact.icon.button,\n  .ui.compact.icon.buttons .button {\n    padding: 0.47em 1.5em 0.6em;\n  }\n  .printButton > .ui.icon.button > .icon,\n  .ui.icon.buttons .button > .icon {\n    vertical-align: middle;\n    margin-right: 15px !important;\n  }\n  .printButton > .ui.dropdown {\n    padding-left: 4em !important;\n  }\n  .printButton > .ui.dropdown > .text {\n    vertical-align: middle;\n    font-size: 12px;\n  }\n  .ui.compact.icon.button,\n  .ui.compact.icon.buttons .button {\n    padding: 0.48em 1.5em 0.65em;\n  }\n  .notReserved {\n    vertical-align: text-top;\n    margin-left: 1rem;\n    margin-right: 1rem;\n    width: 23%;\n    height: 50px;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .printButton > .ui.compact.icon.button,\n  .ui.compact.icon.buttons .button {\n    height: 30px;\n    vertical-align: middle;\n  }\n  .button-group {\n    padding-top: 4rem;\n    padding-bottom: 1rem;\n  }\n  .button-group > .previewBtn {\n    margin-bottom: 1rem;\n    margin-top: 3.5rem;\n  }\n  .button-group .ui.button {\n    width: 80%;\n    height: auto;\n    margin-bottom: 0.35rem;\n  }\n  .bookingSummary {\n    font-size: 0.92857143em;\n    overflow-wrap: break-word;\n  }\n  .column.clear {\n    padding-top: 0.3em;\n  }\n  .ui.grid.booking-list .row.toolbar .ui.grid.filters > .row > .column.filter:nth-child(odd) {\n    padding-right: 0;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 1022px) {\n  .button-group {\n    padding-top: 4rem;\n    padding-bottom: 2rem;\n  }\n  .button-group .ui.button {\n    width: 50%;\n    height: auto;\n    margin-bottom: 0.35rem;\n  }\n}\n@media only screen and (min-width: 1023px) and (max-width: 1197px) {\n  .button-group {\n    padding-top: 5rem;\n    padding-bottom: 3rem;\n  }\n  .notReserved {\n    vertical-align: text-top;\n    margin-left: 1rem;\n    margin-right: 1rem;\n    width: 27%;\n    height: 50px;\n  }\n}\n.packagePricingModal .modal-header {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding: 1.5rem;\n  border-bottom: 1px solid #DBDDDE;\n}\n.packagePricingModal .modal-header .closeButton {\n  border: none;\n  padding: 0;\n  box-shadow: none;\n  filter: opacity(0.6);\n  transition: all 0.5s;\n}\n.packagePricingModal .modal-header .closeButton:hover {\n  border: none;\n  padding: 0;\n  box-shadow: none;\n  filter: opacity(1);\n}\n.packagePricingModal .ui.grid > .row > .column.ppSelection {\n  padding-right: 4rem;\n}\n.packagePricingModal .ui.grid > .row > .column.ppSelection p:first-child {\n  margin-bottom: 2.5rem;\n}\n.packagePricingModal .ui.grid > .row > .column.ppSelection p:nth-child(2) {\n  margin-bottom: 0.5rem;\n}\n.packagePricingModal .divider {\n  margin: 0.5rem 0 !important;\n}\n.packagePricingModal .text-red {\n  color: #FF796E;\n}\n.packagePricingModal .text-green {\n  color: #50B793;\n}\n.packagePricingModal .packagePricingBreakdown {\n  background-color: #F8F9F9;\n  padding: 2rem;\n}\n.packagePricingModal .packagePricingBreakdown .itemContents {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n.packagePricingModal .packagePricingBreakdown .itemContents .itemRow {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.packagePricingModal .packagePricingBreakdown .itemContents .itemRow:last-child {\n  margin-bottom: 1rem;\n}\n.packagePricingModal .packagePricingBreakdown .row:not(:first-child):not(.totalPrice) > .column {\n  margin-bottom: 0.3rem;\n}\n.packagePricingModal .packagePricingBreakdown .row:last-child {\n  margin-bottom: 1rem;\n}\n.packagePricingModal .packagePricingBreakdown .packageFormula {\n  padding: 0.5rem 0 0;\n}\n.packagePricingModal .packagePricingBreakdown .packageFormula .column:first-child {\n  margin-bottom: 1rem !important;\n}\n.packagePricingModal .packagePricingBreakdown .subtotal {\n  margin: 0.5rem 0;\n  padding: 0;\n}\n.packagePricingModal .packagePricingBreakdown .spaValue {\n  padding: 0.7rem 0;\n}\n.packagePricingModal .text-header {\n  font-size: 15px;\n  font-weight: 600;\n  font-family: 'Montserrat', 'Lato', sans-serif;\n  line-height: 18.29px;\n  color: #00233B;\n}\n.packagePricingModal .text-title {\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 19.07px;\n  color: #00233B;\n  font-family: 'Open Sans';\n}\n.packagePricingModal .text-body {\n  font-size: 14px;\n  line-height: 19.07px;\n  color: #00233B;\n  font-family: 'Open Sans';\n}\n.packagePricingModal .text-item {\n  font-size: 12px;\n  font-weight: 400;\n  line-height: 16.34px;\n  color: #00233B;\n  font-family: 'Open Sans';\n}\n.packagePricingModal .text-subtitle {\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 16.34px;\n  font-family: 'Open Sans';\n}\n.packagePricingModal .link {\n  color: #0094B3;\n}\n.packagePricingModal .submit-button {\n  padding: 8px 14px 8px 14px;\n  background-color: #0094B3;\n  height: 35px;\n  border-radius: 4px;\n  color: #ffffff;\n  font-family: 'Open Sans';\n}\n.packagePricingModal .submit-button:hover {\n  background-color: #33a9c2;\n  color: #ffffff;\n}\n.packagePricingModal .submit-button:focus {\n  background-color: #0094B3;\n  color: #ffffff;\n}\n.packagePricingModal .checkboxContainer {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 1rem;\n}\n.packagePricingModal .checkboxContainer.containerHeader {\n  padding-bottom: 0.25em;\n  border-bottom: 1px solid #eee;\n  margin-top: 1em;\n}\n.packagePricingModal .checkboxContainer.containerHeader .text-title {\n  font-size: 13px;\n  font-family: 'Montserrat', 'Lato', sans-serif;\n  font-weight: 100;\n}\n.packagePricingModal .checkboxContainer .checkbox.checked label:before {\n  background-color: #50B793 !important;\n  border: none;\n}\n.packagePricingModal .checkboxContainer .checkbox.checked label:after {\n  color: #ffffff !important;\n}\n.packagePricingModal .checkboxContainer .checkboxLabel {\n  margin-left: 0.8rem;\n}\n.packagePricingModal .checkboxContainer .checkboxLabel p:first-child {\n  margin-bottom: 0.2rem;\n}\n.packagePricingModal .checkboxContainer .checkboxLabel p:last-child {\n  margin-bottom: 0;\n}\n.packagePricingModal .checkboxContainer .checkboxLabel .text-subtitle {\n  font-weight: 100;\n}\n@media only screen and (max-width: 767px) {\n  .packagePricingModal .packagePricingBreakdown {\n    margin-top: 2rem;\n    padding: 0 2rem 2rem 2rem;\n  }\n  .packagePricingModal .ui.grid > .row > .column.ppSelection {\n    padding-right: 1rem;\n  }\n}\n.segment.bookingSummaryContainer.vnBookingSummary {\n  margin-bottom: 1.5em;\n}\n.segment.bookingSummaryContainer.vnBookingSummary .vnSummaryPackageBar {\n  margin: 0.5em 0 1em;\n  padding: 0.6em 1em;\n}\n.segment.bookingSummaryContainer.vnBookingSummary .vnSummaryPackageBar .textButton {\n  background: none;\n  border: none;\n  color: #2185d0;\n  cursor: pointer;\n  font-weight: bold;\n  padding: 0;\n}\n.segment.bookingSummaryContainer.vnBookingSummary .vnSummaryLines .row {\n  padding-top: 0.4em;\n  padding-bottom: 0.4em;\n}\n.ProjectPanelLawyers table.ui.unstackable.bottom.attached.table {\n  width: calc(100% + 2px) !important;\n  margin: 0;\n}\n.ProjectPanelLawyers .ui.label.LawyerAutoAssignSettings {\n  background: transparent;\n  padding: 0;\n  font-size: 1rem;\n  color: black;\n  font-weight: normal;\n}\n.LawyerCases .ui.dropdown {\n  border-color: #1678C2 !important;\n  color: #1678C2;\n  text-align: center;\n}\n.LawyerCases .ui.dropdown.selection.visible > .text:not(.default) {\n  color: #1678C2;\n}\n.LawyerCases .ui.dropdown .menu {\n  border-color: #1678C2 !important;\n}\n.LawyerCases .ui.dropdown .menu > .item:not(.disabled) {\n  color: #1678C2;\n}\n.LawyerCases .section.LA {\n  margin-top: 2rem;\n}\n.LawyerDetails .ui.header,\n.LawyerCaseAppointment .ui.header {\n  color: #979797;\n  text-transform: uppercase;\n}\n.LawyerDetails.ui.segment,\n.LawyerCaseAppointment.ui.segment {\n  padding: 1.5rem 1rem;\n  border-radius: 0.5rem;\n}\n.LawyerDetails.ui.segment.basic,\n.LawyerCaseAppointment.ui.segment.basic {\n  padding-bottom: 1.5rem;\n}\n.LawyerDetails.ui.segment.basic .right.aligned.column,\n.LawyerCaseAppointment.ui.segment.basic .right.aligned.column {\n  color: #979797;\n}\n.LawyerDetails.ui.segment .ui.grid > .column:not(.row),\n.LawyerCaseAppointment.ui.segment .ui.grid > .column:not(.row) {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n.LawyerDetails.ui.segment.tertiary,\n.LawyerCaseAppointment.ui.segment.tertiary {\n  color: #aaa;\n  border: none;\n  background: #f2f2f2;\n  box-shadow: 0 8px 6px -5px #ccc;\n}\n.SecondLawyerDetails .ui.header {\n  color: #979797;\n  text-transform: uppercase;\n}\n.SecondLawyerDetails.ui.segment {\n  padding: 2rem 1rem;\n  border-radius: 0.5rem;\n}\n.SecondLawyerDetails.ui.segment .right.aligned.column {\n  color: #979797;\n}\n.SecondLawyerDetails.ui.segment .ui.grid > .column:not(.row) {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n.SecondLawyerDetails.ui.segment.tertiary {\n  color: #aaa;\n  border: none;\n  background: #f2f2f2;\n  box-shadow: 0 8px 6px -5px #ccc;\n}\n.AppointmentCard.ui.segment {\n  padding: 0.85rem;\n}\n.AppointmentCard p {\n  margin: 0;\n  line-height: 1em;\n}\n.AppointmentCard .year {\n  color: rgba(0, 0, 0, 0.3);\n}\n.AppointmentCard .dayMonth {\n  margin: 1rem 0;\n  color: rgba(0, 0, 0, 0.6);\n}\n.AppointmentCard .dayMonth .day {\n  font-size: 2.28em;\n}\n.AppointmentCard .dayMonth .month {\n  font-size: 1.14em;\n  font-weight: bold;\n  line-height: 1.35em;\n}\n.AppointmentCard .time {\n  color: #707070;\n}\n.CaseStatusMilestone {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  overflow-x: auto;\n  margin: 1rem;\n}\n.CaseStatusMilestone .status {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex: 1;\n      flex: 1;\n  padding: 0 1.75rem;\n  -ms-flex-align: center;\n      align-items: center;\n  font-size: 1em;\n}\n.CaseStatusMilestone .status p {\n  margin: 0;\n  text-align: center;\n}\n.CaseStatusMilestone .status p.date {\n  font-size: 0.7rem;\n}\n.CaseStatusMilestone .status .box {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: center;\n      justify-content: center;\n  position: relative;\n  width: 8rem;\n  height: 5.5rem;\n  padding: 0.5rem;\n  background: white;\n  border-radius: 0.25rem;\n  margin-bottom: 1rem;\n  box-sizing: border-box;\n}\n.CaseStatusMilestone .status .box.between {\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.CaseStatusMilestone .status .box::after {\n  position: absolute;\n  top: calc(100% - 0.5rem);\n  left: calc(50% - 0.5rem);\n  content: \"\";\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  border-radius: 50%;\n  background: inherit;\n  z-index: 1;\n}\n.CaseStatusMilestone .status .dot {\n  width: 1.15rem;\n  height: 1.15rem;\n  border-radius: 50%;\n  background: white;\n  margin: 0.175rem;\n  z-index: 1;\n}\n.CaseStatusMilestone .status::before,\n.CaseStatusMilestone .status::after {\n  width: 50%;\n  height: 4px;\n  position: absolute;\n  bottom: calc(0.75em - 2px);\n  background: white;\n}\n.CaseStatusMilestone .status:not(:first-child)::before {\n  content: \"\";\n  display: block;\n  left: 0;\n}\n.CaseStatusMilestone .status:not(:last-child)::after {\n  content: \"\";\n  display: block;\n  right: 0;\n}\n.CaseStatusMilestone .status:first-child {\n  padding-left: 0;\n}\n.CaseStatusMilestone .status:last-child {\n  padding-right: 0;\n}\n.CaseStatusMilestone .status:first-child::after,\n.CaseStatusMilestone .status:last-child::after,\n.CaseStatusMilestone .status:first-child::before,\n.CaseStatusMilestone .status:last-child::before {\n  width: calc(50% + 0.875rem);\n}\n.CaseStatusMilestone .status.active {\n  font-weight: bold;\n}\n.CaseStatusMilestone .status.active p {\n  color: white;\n}\n.CaseStatusMilestone .status.current {\n  font-size: 1em;\n}\n.CaseStatusMilestone .status.current .dot {\n  width: 1.5rem;\n  height: 1.5rem;\n  margin: 0;\n}\n.CaseStatusMilestone.SPA .status:not(.active) p {\n  color: #00979C;\n}\n.CaseStatusMilestone.SPA .status .box,\n.CaseStatusMilestone.SPA .status .dot {\n  background: #D9F0F0;\n}\n.CaseStatusMilestone.SPA .status::before,\n.CaseStatusMilestone.SPA .status::after {\n  background: #D9F0F0;\n}\n.CaseStatusMilestone.SPA .status.active .box,\n.CaseStatusMilestone.SPA .status.active .dot {\n  background: #00979C;\n}\n.CaseStatusMilestone.SPA .status.active:not(.current)::after,\n.CaseStatusMilestone.SPA .status.active::before {\n  background: #00979C;\n}\n.CaseStatusMilestone.LA .status:not(.active) p {\n  color: #1678C2;\n}\n.CaseStatusMilestone.LA .status .box,\n.CaseStatusMilestone.LA .status .dot {\n  background: #E6F4FF;\n}\n.CaseStatusMilestone.LA .status::before,\n.CaseStatusMilestone.LA .status::after {\n  background: #E6F4FF;\n}\n.CaseStatusMilestone.LA .status.active .box,\n.CaseStatusMilestone.LA .status.active .dot {\n  background: #1678C2;\n}\n.CaseStatusMilestone.LA .status.active:not(.current)::after,\n.CaseStatusMilestone.LA .status.active::before {\n  background: #1678C2;\n}\n.ui.button.DownloadSPA {\n  background-color: #49B3B1;\n  border-radius: 2.5rem;\n  padding: 0.5rem;\n  width: 9.5rem;\n  height: 2rem;\n  border: none;\n  color: white;\n}\n.RemarksCard .ui.header {\n  padding: 1em;\n  font-family: Montserrat;\n  font-weight: 600;\n  font-size: 15px;\n  border-bottom: 1px solid #DBDDDE;\n}\n.RemarksCard.ui.segment {\n  padding: 0;\n  border-radius: 0.5rem;\n  padding-bottom: 2.5rem;\n}\n.RemarksContainer {\n  height: 30rem;\n}\n.Remarks {\n  position: absolute;\n  padding: 1em;\n  padding-top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n.buyer-title {\n  position: relative;\n  color: #EDEDED;\n  font-size: 1.14em;\n  font-weight: 100;\n  font-family: 'Montserrat', 'Lato', sans-serif;\n}\n.buyer-title:first-child::after {\n  top: 50%;\n  right: 0;\n  position: absolute;\n  content: '';\n  border-radius: 50%;\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  border: 2px solid #EDEDED;\n  opacity: 1;\n  width: 0.85rem;\n  height: 0.85rem;\n  -ms-transform: translate(50%, -50%);\n      transform: translate(50%, -50%);\n  visibility: visible;\n}\n.buyer-border {\n  position: relative;\n  padding: 0.25rem 1rem;\n}\n.buyer-border::after {\n  top: 0;\n  right: 0;\n  bottom: 0;\n  position: absolute;\n  content: '';\n  border-right: 1px solid #EDEDED;\n}\n.ui.grid.buyer > .row.buyer-section {\n  padding-top: 0;\n}\n.ui.grid.buyer > .row.buyer-section:not(:last-child) {\n  padding-bottom: 0;\n}\n.ui.grid.buyer > .row.buyer-section.expand .buyer-border {\n  padding: 1rem;\n}\n.ui.grid.buyer > .row.buyer-section.done .buyer-title {\n  color: #00233B;\n}\n.ui.grid.buyer > .row.buyer-section.done .buyer-title::after {\n  background: #49B3B1;\n  border: none;\n}\n.ui.grid.buyer > .row.buyer-section.done .buyer-border::after {\n  border-color: #49B3B1;\n}\n.ui.grid.buyer > .row.buyer-section.active .buyer-title {\n  font-size: 1.35em;\n  font-weight: bold;\n  color: #3597EC;\n}\n.ui.grid.buyer > .row.buyer-section.active .buyer-title::after {\n  border-color: #49B3B1;\n}\n.ui.grid.buyer > .row.buyer-section:not(:last-child) .buyer-item-list {\n  padding-bottom: 2rem;\n}\n.ui.grid.buyer .ui.segment.cancelled {\n  margin: 0.5rem 0;\n  box-shadow: none;\n  border: none;\n  background-color: #FDEDEB;\n  color: #F44336;\n}\n.ui.grid.buyer .ui.segment.sold {\n  margin: 0.5rem 0;\n  box-shadow: none;\n  border: none;\n  background-color: #D5EAD9;\n  color: #0E835C;\n}\n.buyer-item-list > .ui.grid .column.buyer-item {\n  position: relative;\n  padding-left: 3rem;\n  padding-bottom: 1rem;\n}\n.buyer-item-list.expand .ui.grid > .row > .column.buyer-item {\n  padding-top: 1rem;\n}\n.buyer-item::before {\n  position: absolute;\n  content: '';\n  top: 1.6rem;\n  left: 0;\n  height: 1px;\n  margin: 0 0.75rem;\n  width: 1.75rem;\n  background: #49B3B1;\n}\n.buyer-item .timestamp {\n  color: #8C969F;\n  font-size: 0.85em;\n}\n@media only screen and (max-width: 767px) {\n  .ui.grid.buyer > .row.buyer-section .buyer-title:first-child {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n    visibility: hidden;\n    white-space: nowrap;\n  }\n  .ui.grid.buyer > .row.buyer-section .buyer-border {\n    padding-left: 0.5rem;\n    padding-right: 0.5rem;\n  }\n  .buyer-item-list > .ui.grid .column.buyer-item:first-child {\n    padding-top: 2rem;\n  }\n  .buyer-item-list > .ui.grid .column.buyer-item:first-child::before {\n    top: 2.6rem;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .ui.grid.buyer > .row.buyer-section .buyer-title:not(:first-child) {\n    visibility: hidden;\n  }\n}\n.buyer-banker-chat.ui.large.modal.visible.active {\n  width: 50vw;\n  height: 100vh;\n  top: 0;\n  right: 0;\n  left: unset;\n  margin: 0 !important;\n  border-radius: 0;\n  position: absolute !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  box-sizing: border-box;\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .close {\n  top: 0.5rem !important;\n  right: 0.5rem !important;\n  color: rgba(0, 0, 0, 0.87);\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .header {\n  font-weight: 100;\n  font-size: 1em;\n  border-color: #F7F8F9;\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .header .title {\n  -ms-flex: 1;\n      flex: 1;\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .header .title .row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .header .title .row .load-image {\n  width: 40px;\n  margin-right: 1rem;\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .header .title .row .load-image .ui.image {\n  background: white;\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .header .title .row > .banker > h3.ui.header {\n  margin: 0;\n  font-family: 'Montserrat', 'Lato', sans-serif;\n  font-size: 1.14em;\n  font-weight: 100;\n  color: #00233B;\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .header .title .row > .banker > p {\n  margin: 0;\n  font-size: 0.857em;\n  color: #596975;\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .header .header-actions {\n  width: auto;\n  padding-right: 3rem;\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .header .header-actions .ui.button {\n  position: relative;\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .header .header-actions .ui.button:not(:last-child) {\n  margin-right: 1rem;\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .header .header-actions .ui.button:hover > span {\n  color: #1678c2;\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .header .header-actions .ui.button > span {\n  font-size: 0.857em;\n  font-weight: 100;\n  position: absolute;\n  top: calc(100% + 0.25rem);\n  left: 50%;\n  -ms-transform: translateX(-50%);\n      transform: translateX(-50%);\n  color: #2185d0;\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .header .header-actions .ui.button.disabled {\n  opacity: 1 !important;\n  background: #EDEFF0;\n  color: white;\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .header .header-actions .ui.button.disabled > span {\n  color: #DBDDDE;\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .header .header-actions .ui.button > .notification-icon {\n  width: 1.85em;\n  height: 1.85em;\n  margin: 0;\n  background: transparent;\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .header .header-actions .ui.button > .notification-icon > img {\n  width: 100% !important;\n  -ms-transform: scale(1.25);\n      transform: scale(1.25);\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .content {\n  -ms-flex: 1;\n      flex: 1;\n  height: 100%;\n  overflow: auto;\n}\n.buyer-banker-chat.ui.large.modal.visible.active > .actions {\n  background: transparent;\n  border: none;\n}\n@media only screen and (max-width: 991px) and (min-width: 768px) {\n  .buyer-banker-chat.ui.large.modal.visible.active {\n    width: 80vw;\n  }\n  .buyer-banker-chat.ui.large.modal.visible.active > .actions {\n    padding: 1rem !important;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .buyer-banker-chat.ui.large.modal.visible.active {\n    width: 100vw;\n  }\n  .buyer-banker-chat.ui.large.modal.visible.active > .actions {\n    padding: 1rem !important;\n  }\n}\n.loan-tracker label {\n  text-align: left;\n}\n.loan-tracker .message {\n  padding-top: 0.5em;\n  padding-bottom: 0.5em;\n}\n.loan-tracker .ui.button.inverted.grey {\n  color: #767676;\n}\n.loan-tracker .ui.button.inverted.black {\n  color: #1B1C1D;\n}\n.loan-tracker-warning-col {\n  margin-bottom: 2em;\n}\n.loan-tracker-warning-col .ui.label {\n  background-color: #fffbdd;\n  text-align: left;\n  width: 100%;\n  padding: 1em;\n}\n.loan-tracker-disabled {\n  opacity: 0.45;\n}\n.bankcasecard-subheader {\n  color: rgba(0, 0, 0, 0.6);\n}\n.ui.table.bank-report {\n  margin-top: 0;\n  table-layout: fixed;\n  width: 100% !important;\n}\n.ui.table.bank-report.custom-group {\n  min-height: 25em;\n}\n.ui.table.bank-report thead > tr > th {\n  position: relative;\n  white-space: normal;\n  padding-right: 1.5em;\n}\n.ui.table.bank-report thead > tr > th:after,\n.ui.table.bank-report thead > tr > th i.grey.sort.inverted.icon {\n  position: absolute;\n  top: 1em;\n  right: -0.3em;\n}\n.ui.table.bank-report thead > tr > th:after {\n  right: 0.3em;\n}\n.ui.table.bank-report thead > tr > th > div.text {\n  display: inline-table;\n}\n.ui.table.bank-report thead > tr > th .ui.dropdown.booking {\n  background: #FFF;\n  padding: 0.7em 1em 0.5em 0.7em;\n  line-height: 1em;\n  border: 1px solid rgba(34, 36, 38, 0.15);\n  min-height: 2.7142em;\n  color: rgba(0, 0, 0, 0.87);\n  border-radius: 0.28571429rem;\n  transition: box-shadow 0.1s ease, width 0.1s ease;\n  white-space: nowrap;\n}\n.ui.table.bank-report thead > tr > th .ui.dropdown.booking:hover {\n  border-color: rgba(34, 36, 38, 0.35);\n}\n.ui.table.bank-report thead > tr > th .ui.dropdown.booking.selected {\n  border-color: #56B35A;\n}\n.ui.table.bank-report thead > tr > th .ui.dropdown.booking > .dropdown.icon {\n  cursor: pointer;\n  position: absolute;\n  width: auto;\n  height: auto;\n  line-height: 1.2142em;\n  top: 0.78571429em;\n  right: 0.8em;\n  margin: -0.78571429em;\n  padding: 0.78571429em;\n}\n.ui.table.bank-report thead > tr > th .ui.dropdown.booking .header {\n  margin-bottom: 0.5em;\n}\n.ui.table.bank-report thead > tr > th .ui.dropdown.booking .menu {\n  margin-top: 0.3em;\n  right: 0;\n}\n.ui.table.bank-report thead > tr > th .ui.dropdown.booking .menu i.icon.square {\n  margin-right: 0.78571429rem;\n}\n.ui.table.bank-report thead > tr > th .ui.dropdown.booking .menu i.icon.square.check {\n  color: #56B35A;\n}\n@media only screen and (max-width: 767px) {\n  .ui.table.bank-report thead > tr > th {\n    white-space: normal;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .ui.table.bank-report.vertical-header thead > tr > th {\n    vertical-align: bottom;\n    text-align: left;\n    white-space: nowrap;\n    font-weight: 100;\n    padding: 0;\n    height: 16em;\n  }\n  .ui.table.bank-report.vertical-header thead > tr > th.bold {\n    font-weight: 700;\n  }\n  .ui.table.bank-report.vertical-header thead > tr > th.bank {\n    background: #E5E5E5;\n  }\n  .ui.table.bank-report.vertical-header thead > tr > th.current {\n    background: #FAFAFB;\n  }\n  .ui.table.bank-report.vertical-header thead > tr > th.closed {\n    background: #E5E5E5;\n  }\n  .ui.table.bank-report.vertical-header thead > tr > th.sorted > div.text::after {\n    display: inline-block;\n    position: absolute;\n    top: 50%;\n    left: -25%;\n    -ms-transform-origin: 50% 50%;\n        transform-origin: 50% 50%;\n    -ms-transform: rotate(90deg) translateX(-100%);\n        transform: rotate(90deg) translateX(-100%);\n    font-style: normal;\n    font-weight: 400;\n    text-decoration: inherit;\n    height: 1em;\n    width: auto;\n    opacity: 0.8;\n    margin: 0;\n    font-family: Icons;\n    content: '';\n  }\n  .ui.table.bank-report.vertical-header thead > tr > th.sorted.ascending > div.text::after {\n    content: '\\F0D8';\n  }\n  .ui.table.bank-report.vertical-header thead > tr > th.sorted.descending > div.text::after {\n    content: '\\F0D7';\n  }\n  .ui.table.bank-report.vertical-header thead > tr > th:after {\n    display: none;\n  }\n  .ui.table.bank-report.vertical-header thead > tr > th > div.text {\n    width: 100%;\n    display: inline-block;\n    -ms-transform-origin: 50% 50%;\n        transform-origin: 50% 50%;\n    -ms-transform: rotate(-90deg);\n        transform: rotate(-90deg);\n  }\n  .ui.table.bank-report.vertical-header thead > tr > th > div.text:before {\n    content: '';\n    width: 0;\n    padding-top: 180%;\n    /* takes width as reference, + 10% for faking some extra padding */\n    display: inline-block;\n    vertical-align: middle;\n  }\n}\nsvg#mhub-svg g {\n  opacity: 1 !important;\n}\nsvg#mhub-svg g#mhub-site-plan #mhub-units[id^=\"mhub-\"],\nsvg#mhub-svg g#mhub-site-plan #mhub-units * {\n  opacity: 0.9;\n  fill: #cecac1 !important;\n  stroke: none !important;\n  stroke-width: 0 !important;\n}\n.ui.centered.grid > .column:not(.aligned):not(.justified):not(.row),\n.ui.centered.grid > .row > .column:not(.aligned):not(.justified),\n.ui.grid .centered.row > .column:not(.aligned):not(.justified) {\n  text-align: center;\n}\nbutton,\nhtml input[type=button],\ninput[type=reset],\ninput[type=submit] {\n  -webkit-appearance: button;\n  cursor: pointer;\n}\n.accordion .title .ui.dropdown > .dropdown.icon {\n  -ms-transform: rotate(90deg) !important;\n      transform: rotate(90deg) !important;\n  transition: transform 0.3s ease !important;\n}\n.ui.dropdown > .dropdown.icon {\n  font-size: 0.9em !important;\n  width: auto !important;\n  height: auto !important;\n  line-height: normal !important;\n}\n.ui.styled.accordion .title {\n  color: inherit;\n  font-weight: inherit;\n}\n/* Payment tab*/\n.refund-status-label {\n  color: #5F6368 !important;\n  border-radius: 4px !important;\n}\n.payment-header {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.payment-display {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  gap: 15px;\n  margin-top: 10px;\n}\n.payment-display .ui.segment {\n  box-shadow: none !important;\n  border: 1px solid #dee2e6 !important;\n  border-radius: 4px !important;\n  margin-top: 0 !important;\n}\n.div-payment-card-display {\n  padding: 1.2em;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  cursor: pointer;\n}\n.div-payment-card-display i.icon {\n  color: #6c757d;\n  font-size: 0.9em !important;\n  font-weight: 100 !important;\n  opacity: 0.8;\n}\n.status-wrapper {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  vertical-align: middle;\n  gap: 8px;\n}\n.status-wrapper img {\n  display: block;\n  width: 20px;\n  height: auto;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n}\n.status-wrapper span {\n  line-height: normal;\n  display: inline-block;\n}\n.payment-status-dropdown {\n  margin-right: 20px;\n}\n.btn-verify-link {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  padding: 0 !important;\n  color: #009688 !important;\n  display: -ms-inline-flexbox !important;\n  display: inline-flex !important;\n  -ms-flex-align: center !important;\n      align-items: center !important;\n  cursor: pointer;\n}\n.btn-verify-link:hover,\n.btn-verify-link:focus,\n.btn-verify-link:active {\n  text-decoration: none !important;\n}\n.btn-verify-link:focus-visible {\n  outline: 2px solid #009688 !important;\n  outline-offset: 2px;\n  text-decoration: underline !important;\n}\n.currency-payment-format {\n  font-weight: bold;\n  font-size: 1.2em;\n  margin-left: 10px;\n}\n.payment-method {\n  margin-left: 30px;\n  color: gray;\n}\n.payment-open-title {\n  font-weight: bold;\n  font-size: 1.1em;\n  margin-bottom: 10px;\n}\n.payment-card-dropdown {\n  margin-left: 10px;\n  color: #ccc;\n}\n.payment-card-dropdown-hover-text {\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background-color: #F9F8F3;\n  border: 2px solid #E59800;\n  border-radius: 10px;\n}\n.payment-card-dropdown.inline.dropdown > .icon {\n  display: none !important;\n}\n.payment-card-open {\n  background-color: #f9f9f9;\n  padding: 1.5em;\n  border-top: 1px solid #eee;\n  margin-left: 0;\n  width: 100%;\n  box-sizing: border-box;\n}\n.payment-card-open .div-text-holder {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 12px;\n  width: 100%;\n  min-width: 0;\n}\n.payment-card-open .div-text-holder--align-top {\n  -ms-flex-align: start;\n      align-items: flex-start;\n}\n.payment-card-open .div-text {\n  color: #7f8c8d;\n  font-size: 0.9em;\n  width: 140px;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n}\n.payment-card-open .div-value {\n  color: #2c3e50;\n  font-weight: 500;\n  word-break: break-word;\n  -ms-flex: 1;\n      flex: 1;\n  min-width: 0;\n}\n.payment-card-open .attachment-inline-wrapper {\n  width: 100%;\n  min-width: 0;\n  -ms-flex: 1;\n      flex: 1;\n}\n.payment-card-open .attachment-inline-wrapper .attachment-list {\n  width: 100%;\n}\n.div-summary-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.div-currency-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  font-weight: bold;\n}\n.refund-container {\n  margin-top: 15px;\n}\n.refund-container .refund-card {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n  cursor: pointer;\n  margin-bottom: 0 !important;\n  padding: 12px 15px !important;\n  border-radius: 4px !important;\n  border-bottom: 1px solid rgba(34, 36, 38, 0.15) !important;\n  transition: all 0.2s ease;\n}\n.refund-container .refund-card i.icon {\n  color: #6c757d;\n  font-size: 0.9em !important;\n  font-weight: 100 !important;\n  opacity: 0.8;\n}\n.refund-container .refund-card.is-open {\n  border-bottom: none !important;\n  border-radius: 4px 4px 0 0 !important;\n}\n.refund-container .refund-title-text {\n  font-weight: bold;\n  font-size: 1.1em;\n}\n.refund-container .refund-card-open {\n  margin-top: 0;\n  border-radius: 0 0 4px 4px;\n  border-top: none;\n  padding: 15px 20px;\n}\n.refund-container .refund-card-open .refund-row {\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n}\n.refund-container .refund-card-open .refund-row .label {\n  color: #666;\n}\n.refund-container .refund-card-open .refund-row .value {\n  font-weight: 500;\n  color: #333;\n}\n/* Document tab*/\n.document-header {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: start;\n      align-items: flex-start;\n  margin-bottom: 1.5rem;\n}\n.document-header .header {\n  margin-bottom: 0;\n}\n.document-header .span {\n  color: gray;\n}\n.document-upload-button {\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -ms-flex-align: center !important;\n      align-items: center !important;\n  -ms-flex-pack: center !important;\n      justify-content: center !important;\n  border-radius: 4px !important;\n  background-color: #0094B3 !important;\n}\n.document-upload-button .document-upload-icon {\n  width: 22px !important;\n  height: auto;\n  margin-right: 12px !important;\n  display: block;\n}\n.document-search-container {\n  margin-bottom: 10px !important;\n}\n.document-not-found {\n  padding: 3em;\n}\n.document-name-row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex: 1;\n      flex: 1;\n  min-width: 0;\n}\n.document-name-row .doc-name-container {\n  margin-left: 10px;\n  min-width: 0;\n  -ms-flex: 1;\n      flex: 1;\n}\n.document-name-row .doc-name-container .doc-name {\n  font-weight: bold;\n  color: #008b8b;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.document-name-row .doc-name-container .doc-size {\n  font-size: 0.8em;\n  color: gray;\n}\n.attachment-item-row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: start;\n      align-items: flex-start;\n  gap: 8px;\n  padding: 8px 0;\n  border-bottom: 1px solid #f0f0f0;\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n.attachment-item-row:last-child {\n  border-bottom: none;\n}\n.attachment-item-row .attachment-preview-container {\n  -ms-flex: 1;\n      flex: 1;\n  min-width: 0;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: start;\n      align-items: flex-start;\n  gap: 6px;\n}\n.attachment-item-row .attachment-item-link {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: start;\n      align-items: flex-start;\n  min-width: 0;\n  -ms-flex: 1;\n      flex: 1;\n  color: #008b8b;\n  text-decoration: none;\n}\n.attachment-item-row .attachment-item-link:hover {\n  text-decoration: underline;\n}\n.attachment-item-row .attachment-item-link .doc-name {\n  font-weight: bold;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n.attachment-item-row .attachment-download-link {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  cursor: pointer;\n}\n.attachment-item-row .attachment-download-link .attachment-download-icon {\n  width: 14px;\n  height: 14px;\n  opacity: 0.7;\n  transition: opacity 0.2s ease;\n}\n.attachment-item-row .attachment-download-link .attachment-download-icon:hover {\n  opacity: 1;\n}\n.attachment-item-row--small {\n  padding: 4px 0;\n}\n.attachment-item-row--small .attachment-item-link .doc-name {\n  font-size: 0.85em;\n  font-weight: normal;\n}\n.attachment-item-row--small .attachment-download-link .attachment-download-icon {\n  width: 11px;\n  height: 11px;\n}\n.attachment-list {\n  width: 100%;\n}\n.attachment-empty-text {\n  color: #aaa;\n  font-size: 0.9em;\n}\n.payment-card-official-receipt {\n  border-top: 1px solid #e9ecef;\n  margin-top: 12px;\n  padding-top: 12px;\n}\n.payment-metadata-segment {\n  border-top: 1px solid #ccc;\n  margin-top: 1rem;\n  padding-top: 1rem;\n}\n.payment-metadata-segment .metadata-value-truncate {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  gap: 0.4rem;\n  min-width: 0;\n  font-weight: 500;\n  color: #2c3e50;\n}\n.payment-metadata-segment .metadata-value-truncate span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  min-width: 0;\n  -ms-flex: 1;\n      flex: 1;\n}\n.payment-metadata-segment .metadata-copy-btn.ui.button {\n  background: transparent !important;\n  box-shadow: none !important;\n  cursor: pointer;\n  color: #aaa !important;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  font-size: 0.85em !important;\n  line-height: 1 !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  transition: color 0.2s ease;\n}\n.payment-metadata-segment .metadata-copy-btn.ui.button:hover,\n.payment-metadata-segment .metadata-copy-btn.ui.button:focus {\n  background: transparent !important;\n  color: #555 !important;\n}\n.payment-metadata-segment .metadata-copy-btn.ui.button > .icon {\n  margin: 0 !important;\n}\n.document-outline-table {\n  border: 1px solid #dee2e6 !important;\n  border-radius: 4px !important;\n  border-collapse: separate !important;\n}\n.document-outline-table .document-table-header th {\n  background-color: #f9fafb !important;\n  color: #333 !important;\n  font-weight: 600 !important;\n  padding: 12px 15px !important;\n  border-bottom: 1px solid #dee2e6 !important;\n  border-left: none !important;\n  border-right: none !important;\n}\n.document-outline-table .document-table-header th:first-child {\n  border-radius: 4px 0 0 0 !important;\n}\n.document-outline-table .document-table-header th:last-child {\n  border-radius: 0 4px 0 0 !important;\n}\n.document-outline-table tbody td {\n  padding: 15px !important;\n  vertical-align: middle !important;\n  border-top: none !important;\n}\n.btn-icon-only {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  padding: 4px !important;\n  cursor: pointer;\n}\n.btn-icon-only img {\n  width: 18px;\n  height: 18px;\n  display: block;\n  opacity: 0.8;\n}\n.btn-icon-only img:hover {\n  opacity: 1;\n}\n/* loan tab*/\n.minimal-plus-icon {\n  cursor: pointer;\n  color: #7f8c8d !important;\n  font-size: 1em !important;\n}\n/*purchaser tab */\n.cccd-image-container {\n  cursor: pointer;\n  display: inline-block;\n  max-width: 100%;\n}\n.cccd-image-container.is-empty {\n  cursor: default;\n  pointer-events: none;\n  opacity: 0.5;\n}\n.cccd-download-button-container {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.cccd-download-button-container .ui.button.cccd-download-button {\n  color: #596975 !important;\n  font-size: 14px !important;\n  border: none !important;\n  box-shadow: none !important;\n  background: transparent !important;\n}\n.show-dot {\n  width: 7px;\n  height: 7px;\n  background-color: #db2828;\n  border-radius: 50%;\n  display: inline-block;\n  margin-left: 6px;\n  vertical-align: middle;\n  -ms-transform: translateY(-1px);\n      transform: translateY(-1px);\n}\n.refund-actions-footer .ui.button.btn-outcome.btn-initiate-refund,\n.ui.button.btn-initiate-refund {\n  background-color: #EDF5FD !important;\n  /* Soft light-blue background tint */\n  color: #245A8F !important;\n  /* Darker muted corporate blue text */\n  border: 1px solid #B8D4F0 !important;\n  /* Matching soft blue border contour */\n  border-radius: 6px !important;\n  font-weight: 600;\n  box-shadow: none !important;\n  transition: all 0.2s ease;\n}\n/* Hover feedback */\n.refund-actions-footer .ui.button.btn-outcome.btn-initiate-refund:hover,\n.ui.button.btn-initiate-refund:hover {\n  background-color: #DEEDFC !important;\n  /* Slightly deeper blue background on hover */\n  border-color: #92BEE7 !important;\n  color: #17426D !important;\n  box-shadow: none !important;\n}\n.cancellation-reason-modal .modal-title {\n  font-size: 20px !important;\n  font-weight: bold !important;\n  color: #0F1E36 !important;\n}\n.cancellation-reason-modal .modal-body-content {\n  padding: 1.5rem !important;\n}\n.cancellation-reason-modal .modal-body-content form .field label {\n  font-weight: 600 !important;\n  color: #0F1E36 !important;\n  margin-bottom: 0.5rem !important;\n  display: block;\n}\n.cancellation-reason-modal .modal-body-content form .field .required-star {\n  color: #EF4444;\n  margin-left: 2px;\n}\n.cancellation-reason-modal .modal-body-content form .field textarea {\n  border-radius: 6px !important;\n  border: 1px solid #D1D5DB !important;\n  resize: none;\n}\n.cancellation-reason-modal .modal-body-content .field-booking-id {\n  margin-bottom: 1.5rem !important;\n}\n.cancellation-reason-modal .modal-body-content .field-booking-id .read-only-box {\n  background: #F3F4F6;\n  padding: 0.85rem 1rem;\n  border-radius: 6px;\n  color: #374151;\n  font-weight: 500;\n  border: 1px solid #E5E7EB;\n}\n.cancellation-reason-modal .modal-body-content .char-counter {\n  text-align: right;\n  color: #6B7280;\n  font-size: 12px;\n  margin-top: 0.25rem;\n}\n.cancellation-reason-modal .modal-body-content .char-counter.error-limit {\n  color: #EF4444;\n}\n.cancellation-reason-modal .modal-actions-footer {\n  background: #FFF !important;\n  border-top: 1px solid #E5E7EB !important;\n  padding: 1rem !important;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  gap: 12px;\n}\n.cancellation-reason-modal .modal-actions-footer .ui.button {\n  border-radius: 6px !important;\n  font-weight: bold !important;\n  margin: 0 !important;\n  padding: 0.75rem 1.25rem !important;\n}\n.cancellation-reason-modal .modal-actions-footer .btn-dismiss {\n  background: #FFF !important;\n  border: 1px solid #D1D5DB !important;\n  color: #374151 !important;\n}\n.cancellation-reason-modal .modal-actions-footer .btn-dismiss:hover {\n  background: #F9FAFB !important;\n}\n.cancellation-reason-modal .modal-actions-footer .btn-submit {\n  background: #00B4A0 !important;\n  color: #FFF !important;\n}\n.cancellation-reason-modal .modal-actions-footer .btn-submit:hover:not([disabled]) {\n  background: #009685 !important;\n}\n.cancellation-reason-modal .modal-actions-footer .btn-submit[disabled] {\n  opacity: 0.45 !important;\n  cursor: not-allowed !important;\n}\n.showroom-timeline-container {\n  padding-left: 20px !important;\n}\n.showroom-timeline-container .custom-timeline-feed {\n  position: relative;\n}\n.showroom-timeline-container .custom-timeline-feed::before {\n  content: '';\n  position: absolute;\n  top: 10px;\n  left: 6px;\n  bottom: 10px;\n  width: 2px;\n  background-color: #e9ecef;\n  z-index: 1;\n}\n.showroom-timeline-container .timeline-event-row {\n  position: relative;\n  padding: 0 0 24px 0 !important;\n  margin: 0 !important;\n  display: -ms-flexbox !important;\n  display: flex !important;\n  z-index: 2;\n}\n.showroom-timeline-container .timeline-event-row:last-child {\n  padding-bottom: 0 !important;\n}\n.showroom-timeline-container .timeline-event-row:hover .timeline-circle-node {\n  background-color: #0d233a;\n  border-color: #0d233a;\n  -ms-transform: scale(1.15);\n      transform: scale(1.15);\n}\n.showroom-timeline-container .timeline-node-container {\n  width: 20px;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: start;\n      align-items: flex-start;\n  padding-top: 4px;\n  margin-right: 15px;\n}\n.showroom-timeline-container .timeline-circle-node {\n  width: 12px;\n  height: 12px;\n  border-radius: 50%;\n  background-color: #ffffff;\n  border: 2.5px solid #ced4da;\n  display: inline-block;\n  z-index: 3;\n  transition: all 0.2s ease-in-out;\n}\n.showroom-timeline-container .timeline-body-content {\n  margin: 0 !important;\n  padding: 0 !important;\n}\n.showroom-timeline-container .timeline-header-title {\n  font-size: 15px !important;\n  font-weight: 600 !important;\n  color: #0d233a !important;\n  margin-bottom: 4px !important;\n  transition: color 0.2s ease;\n}\n.showroom-timeline-container .timeline-changes-wrapper {\n  font-size: 14px !important;\n  color: #495057 !important;\n  line-height: 1.5 !important;\n  margin: 4px 0 !important;\n}\n.showroom-timeline-container .timeline-changes-wrapper .timeline-diff-line {\n  margin-bottom: 2px;\n  color: #6c757d;\n}\n.showroom-timeline-container .timeline-changes-wrapper .timeline-diff-line strong {\n  color: #212529;\n}\n.showroom-timeline-container .timeline-footer-meta {\n  font-size: 12px !important;\n  color: #adb5bd !important;\n  margin-top: 4px !important;\n}\n.showroom-timeline-container.full-width-timeline {\n  width: 100% !important;\n  max-width: none !important;\n}\n.showroom-timeline-container.full-width-timeline .custom-timeline-feed,\n.showroom-timeline-container.full-width-timeline .timeline-event-row,\n.showroom-timeline-container.full-width-timeline .timeline-body-content {\n  width: 100% !important;\n}\n.showroom-timeline-container.full-width-timeline .timeline-body-content {\n  -ms-flex-positive: 1 !important;\n      flex-grow: 1 !important;\n}\n.showroom-timeline-container.full-width-timeline .timeline-changes-wrapper {\n  width: 100% !important;\n  max-width: none !important;\n  white-space: nowrap !important;\n}\n.showroom-timeline-container.full-width-timeline .timeline-day-header {\n  padding: 12px 0 12px 35px;\n  font-size: 13px;\n  font-weight: 700;\n  color: #6c757d;\n  letter-spacing: 0.5px;\n}\n.showroom-timeline-container .no-activity-placeholder {\n  padding: 20px 0;\n  color: #adb5bd;\n  text-align: center;\n}\n.opportunity-search {\n  font-weight: bold;\n  margin: 0 0 0.28571429rem 0;\n  font-size: 0.92857143em;\n  display: block;\n}\n@media only screen and (max-width: 320px) {\n  body {\n    font-size: 12px !important;\n  }\n}\nhtml {\n  font-size: 14px;\n}\nbody ::-webkit-scrollbar {\n  height: 10px;\n}\na.white {\n  color: white;\n  text-decoration: underline;\n  font-weight: bold;\n}\na.white:hover {\n  color: #ddd;\n}\na:hover {\n  cursor: pointer;\n}\n.hidden {\n  opacity: 0;\n}\n.clear {\n  clear: both;\n}\n.content-centered {\n  height: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n@media only screen and (max-width: 767px) {\n  .booking-new-payment-button {\n    margin: 1em 0 !important;\n  }\n}\n.ui.inverted.grey.segment.dark {\n  background-color: #3b3b3b !important;\n}\n.ui.inverted.segment > .ui.header > .sub {\n  color: white;\n}\n.ui.inverted.popup.srb:before {\n  display: none;\n}\n/* IE Fixes */\n::-ms-clear {\n  display: none!important;\n}\n/* Mobile */\n@media only screen and (max-width: 767px) {\n  .mobile-hide {\n    display: none !important;\n  }\n  .ui.steps {\n    -ms-flex-direction: row;\n        flex-direction: row;\n  }\n  .ui.steps .step {\n    width: 33% !important;\n    font-size: 0.8em;\n    -ms-flex-pack: start;\n        justify-content: flex-start;\n  }\n  .ui.steps .step:first-child {\n    border-radius: 0.28571429rem 0 0 0.28571429rem;\n  }\n  .ui.steps .step:last-child {\n    border-radius: 0 0.28571429rem 0.28571429rem 0;\n  }\n  .mobile-no-padding {\n    padding-left: 0 !important;\n    padding-right: 0 !important;\n  }\n}\n/* except mobile */\n@media only screen and (min-width: 768px) {\n  .computer-hide {\n    display: none !important;\n  }\n}\n/* mobile */\n@media only screen and (max-width: 449px) {\n  .res-width {\n    max-width: 100% !important;\n  }\n}\n/* Tablet */\n@media only screen and (min-width: 450px) and (max-width: 991px) {\n  .tablet-hide {\n    display: none !important;\n  }\n  .res-width {\n    max-width: 60% !important;\n  }\n}\n/* Small Monitor */\n@media only screen and (min-width: 992px) and (max-width: 1199px) {\n  .small-hide {\n    display: none !important;\n  }\n  .res-width {\n    max-width: 40% !important;\n  }\n}\n/* Large Monitor */\n@media only screen and (min-width: 1200px) {\n  .large-hide {\n    display: none !important;\n  }\n  .res-width {\n    max-width: 40% !important;\n  }\n}\n#app {\n  height: 100%;\n}\n#app > div {\n  height: 100%;\n}\n.ui.grid.compact > :first-child {\n  padding-bottom: 0;\n}\n.ui.grid.compact > :last-child {\n  padding-top: 0;\n}\n.ui.grid.fitted {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n.ui.grid.fitted .row {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n.ui.grid.fitted .row .column {\n  padding: 0 !important;\n  margin: 0 !important;\n}\n.no-scoll {\n  overflow: hidden !important;\n  position: fixed !important;\n}\n/* sidebar fix */\n.ui.right.overlay.sidebar {\n  position: fixed;\n}\n.sidebar {\n  width: 22em !important;\n}\n.sidebar.ui.vertical.icon.menu .item > .icon:not(.dropdown) {\n  float: left;\n  margin-top: 0;\n}\n.sidebar.ui.labeled.icon.menu .item > .icon:not(.dropdown) {\n  margin-top: -0.2em !important;\n}\n.sidebar .item {\n  width: 100%;\n  float: left !important;\n}\n.sidebar .item.main {\n  text-align: left !important;\n  padding: 2.4em 1.5em;\n}\n.sidebar .item.sub {\n  padding: 1.5em 1.3em 1.5em 4.3em;\n  text-align: left !important;\n}\n.sidebar .item.sub i {\n  position: absolute;\n  width: 0.6em;\n  text-align: center;\n  font-size: 1.3em;\n  left: 0.95em;\n}\n@media only screen and (max-width: 555px) {\n  .sidebar {\n    width: 15em !important;\n  }\n}\n.main-app {\n  height: 100%;\n  min-height: 100%;\n}\n.app {\n  width: 100%;\n  min-width: 100%;\n}\n.app > .app-content {\n  margin-bottom: 15em;\n}\n.top-app-menu-wrapper {\n  background-color: #fff;\n  height: 3.9em;\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n.top-app-menu-wrapper .ui.container {\n  margin-left: auto !important;\n  margin-right: auto !important;\n  position: relative;\n}\n.top-app-menu-wrapper .top-app-menu {\n  display: -ms-flexbox;\n  display: flex;\n  height: 4em;\n  min-height: 4em;\n  font-family: 'Montserrat', 'Lato', Arial, sans-serif;\n}\n.top-app-menu-wrapper .top-app-menu .row {\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.top-app-menu-wrapper .top-app-menu .logo {\n  margin-left: 0.5em;\n  display: block;\n  width: 7em;\n  padding-top: 1.2em;\n  /* Mobile */\n}\n.top-app-menu-wrapper .top-app-menu .logo svg {\n  height: 1.5em;\n}\n@media only screen and (max-width: 767px) {\n  .top-app-menu-wrapper .top-app-menu .logo {\n    width: 11em;\n    margin-left: 1em;\n    padding-top: 0.7em;\n  }\n  .top-app-menu-wrapper .top-app-menu .logo svg {\n    height: 2.38em;\n  }\n}\n.top-app-menu-wrapper .top-app-menu .ui.secondary.menu .item {\n  color: #596975;\n}\n.top-app-menu-wrapper .top-app-menu .ui.secondary.menu .item:hover {\n  background: transparent;\n  color: rgba(21, 175, 151);\n}\n.top-app-menu-wrapper .top-app-menu .ui.secondary.menu .item:active {\n  background: transparent;\n  color: #596975;\n}\n.top-app-menu-wrapper .top-app-menu .ui.secondary.menu .active.item {\n  background: transparent;\n  color: #15AF97;\n  border-bottom: 1px solid #15AF97;\n  border-radius: 0;\n}\n.top-app-menu-wrapper .top-app-menu .column_book_app_dropdown_menu {\n  padding-top: 1.2em;\n}\n.top-app-menu-wrapper .top-app-menu .column_book_app_dropdown_menu .ui.dropdown.top-menu-dropdown {\n  left: 1em;\n  color: #15AF97;\n}\n.top-app-menu-wrapper .top-app-menu .column_book_app_dropdown_menu .ui.dropdown.top-menu-dropdown .item {\n  color: #596975;\n}\n.top-app-menu-wrapper .top-app-menu .column_book_app_dropdown_menu .ui.dropdown.top-menu-dropdown .active.item {\n  color: #15AF97;\n}\n.ui.popup > .ui.grid.top-popup-menu {\n  border: 1px solid #DBDDDE;\n}\n.ui.popup > .ui.grid.top-popup-menu a {\n  color: #00233b;\n}\n.ui.popup > .ui.grid.top-popup-menu a:hover {\n  color: rgba(0, 35, 59, 0.75);\n}\n.ui.popup > .ui.grid.top-popup-menu a:active {\n  background-color: transparent;\n}\n.ui.popup > .ui.grid.top-popup-menu .popup-row:hover {\n  background: #F4F5F7;\n}\n.ui.popup > .ui.grid.top-popup-menu .popup-col > .row {\n  display: -ms-flexbox;\n  display: flex;\n}\n.ui.popup > .ui.grid.top-popup-menu .popup-col > .row .column {\n  margin-top: auto;\n  margin-bottom: auto;\n}\n.ui.grid.middle-app-menu {\n  margin-top: 0.5em;\n}\n.ui.grid.middle-app-menu .row {\n  padding: 0.5em 0;\n  font-size: 80%;\n}\n.ui.secondary.pointing.menu {\n  border-bottom: 2px solid #F4F5F7;\n}\n.ui.secondary.pointing.menu .item {\n  color: #586976;\n  transition: all 0.2s ease;\n}\n.ui.secondary.pointing.menu .item:hover {\n  color: #2C8483 !important;\n  border-bottom-color: rgba(73, 179, 177, 0.8);\n}\n.ui.secondary.pointing.menu .item.active,\n.ui.secondary.pointing.menu .item:hover.active,\n.ui.secondary.pointing.menu .item:focus {\n  color: #005150 !important;\n  border-bottom-color: rgba(73, 179, 177, 0.8);\n}\n.app-menu-wrapper {\n  margin-bottom: 1em;\n}\n.app-menu-wrapper .app-menu-wrap {\n  position: relative;\n  display: inline-block;\n  overflow: visible;\n  width: 100%;\n}\n.app-menu-wrapper .app-menu-wrap .ui.container {\n  margin-left: auto !important;\n  margin-right: auto !important;\n  z-index: 50;\n  position: relative;\n}\n.app-menu-wrapper .app-menu-wrap .ui.container .ui.secondary.inverted.pointing.menu {\n  border: none;\n}\n.app-menu-wrapper .app-menu-wrap .header-cover {\n  z-index: 0;\n  position: absolute;\n  top: 50%;\n  min-height: 100%;\n  display: block;\n  left: 50%;\n  -ms-transform: translate(-50%, -50%);\n      transform: translate(-50%, -50%);\n  min-width: 100%;\n  bottom: 0;\n  background-color: #F4F5F7;\n}\n@media only screen and (max-width: 1100px) {\n  .app-menu-wrapper .app-menu-wrap .header-cover .color {\n    bottom: 0;\n    position: absolute;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.8);\n  }\n  .app-menu-wrapper .app-menu-wrap .header-cover img {\n    bottom: 0;\n    height: 100%;\n  }\n}\n.app-menu-wrapper .app-menu-wrap .app-menu {\n  display: -ms-flexbox;\n  display: flex;\n  height: 4em;\n  min-height: 4em;\n  /* Mobile */\n}\n.app-menu-wrapper .app-menu-wrap .app-menu.ui.grid {\n  margin-bottom: 0 !important;\n}\n@media only screen and (max-width: 767px) {\n  .app-menu-wrapper .app-menu-wrap .app-menu {\n    min-height: 4em;\n    height: 4em;\n  }\n}\n.app-menu-wrapper .app-menu-wrap .app-menu:not(.secondary) {\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n.app-menu-wrapper .app-menu-wrap .app-menu .app-list {\n  min-width: 10em;\n  margin-top: 0.75em;\n}\n.app-menu-wrapper .app-menu-wrap .app-menu .app-menu-options {\n  text-align: right;\n  margin-right: 0.5em;\n  margin-top: 1em;\n  width: 6em;\n}\n.app-menu-wrapper .app-menu-wrap .app-menu .app-menu-options .dropdown > .text {\n  color: #555555;\n}\n.app-menu-wrapper .app-menu-wrap .app-menu .app-menu-options .icon {\n  color: #555555;\n  font-size: 1.8em;\n  cursor: pointer;\n}\n.app-menu-wrapper .app-menu-wrap .app-menu.ui.menu {\n  margin: 0 !important;\n  border-radius: 0;\n}\n.app-menu-wrapper .app-menu-wrap .app-menu.ui.menu.secondary .item {\n  margin-right: 1em;\n  padding: 1em 1.14285714em;\n  text-transform: uppercase;\n}\n@media only screen and (max-width: 555px) {\n  .app-menu-wrapper .app-menu-wrap .app-menu.ui.menu.secondary {\n    font-size: 0.78571429rem;\n    text-align: center;\n    padding-left: 0!important;\n    padding-right: 0!important;\n    display: -ms-flexbox;\n    display: flex;\n  }\n  .app-menu-wrapper .app-menu-wrap .app-menu.ui.menu.secondary .menu {\n    -ms-flex-pack: distribute;\n        justify-content: space-around;\n    width: 100%;\n  }\n  .app-menu-wrapper .app-menu-wrap .app-menu.ui.menu.secondary .item {\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    -ms-flex-direction: column;\n        flex-direction: column;\n    margin-right: inherit;\n    padding: 0.85714286em 1.14285714em;\n    font-size: 0.78571429rem;\n    padding-left: 0;\n    padding-right: 0;\n  }\n  .app-menu-wrapper .app-menu-wrap .app-menu.ui.menu.secondary .item .icon {\n    height: 1em;\n    display: block;\n    font-size: 1.71428571em !important;\n  }\n}\n@media only screen and (min-width: 556px) {\n  .app-menu-wrapper .app-menu-wrap .app-menu.ui.menu.secondary .item .icon {\n    font-size: 1.5em !important;\n  }\n}\n.app-menu-wrapper .app-menu-wrap .app-menu.ui.menu .header {\n  padding-top: 0.5em;\n  padding-bottom: 0.5em;\n}\n.app-menu-wrapper .app-menu-wrap .app-menu.ui.menu .logo {\n  width: 5em;\n}\n.app-menu-wrapper .app-menu-wrap .app-menu-details {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  color: #555;\n}\n.app-menu-wrapper .app-menu-wrap .app-menu-details h5 {\n  font-weight: normal;\n}\n.app-menu-wrapper .app-menu-wrap .app-menu-details .details {\n  -ms-flex-item-align: end;\n      align-self: flex-end;\n  margin-left: 1em;\n}\n.app-menu-wrapper .app-menu-wrap .app-menu-details .details h2 {\n  margin-bottom: 0.2em;\n}\n.app-menu-wrapper .app-menu-wrap .app-menu-details .details .item {\n  display: -ms-flexbox;\n  display: flex;\n}\n.app-menu-wrapper .app-menu-wrap .app-menu-details .details .item h3 {\n  margin-top: 0.2em;\n}\n.app-menu-wrapper .app-menu-wrap .app-menu-details .details .item .label {\n  margin-left: 0.8em;\n}\n.app-menu-wrapper .app-menu-wrap .app-menu-details .details .item .company_shortname {\n  color: #999;\n}\n.terms {\n  font-size: 0.85em;\n  margin-top: 2em;\n  margin-bottom: 3em;\n}\n.a-button-gray {\n  outline: none;\n  background: none!important;\n  color: #767676;\n  border: none;\n  padding: 0!important;\n  font: inherit;\n  font-weight: bold;\n  cursor: pointer;\n}\n.a-button-gray:hover {\n  color: #666666;\n}\n.a-button-gray.disabled {\n  cursor: default;\n  opacity: 0.45 !important;\n  background-image: none!important;\n  box-shadow: none!important;\n  pointer-events: none!important;\n}\n.a-button-blue {\n  outline: none;\n  background: none!important;\n  color: #4183C4;\n  border: none;\n  padding: 0!important;\n  font: inherit;\n  cursor: pointer;\n}\n.a-button-blue:hover {\n  color: #1e70bf;\n}\n.a-button-blue.disabled {\n  cursor: default;\n  opacity: 0.45 !important;\n  background-image: none!important;\n  box-shadow: none!important;\n  pointer-events: none!important;\n}\n.attachment-button .ui.basic.button {\n  margin-left: 1rem;\n  border-radius: 1rem;\n  color: #4183C4 !important;\n  box-shadow: 0 0 0 1px #4183C4 inset;\n}\n.attachment-button .ui.basic.button:hover {\n  color: #1e70bf !important;\n  box-shadow: 0 0 0 1px #1e70bf inset;\n}\n@media only screen and (min-width: 992px) {\n  .items-list-modal.ui.large.modal {\n    width: 920px;\n    margin: 0 -460px;\n  }\n}\n.items-list-modal .actions {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  -ms-flex-align: center;\n      align-items: center;\n}\n.items-list-modal .actions .pagination {\n  height: 2em;\n}\n.items-list-modal .ui.grid > .column.list {\n  padding-top: 0;\n  overflow-y: auto;\n  height: 14em;\n  /* iPhone 5 */\n  /* Medium Phones */\n}\n@media only screen and (min-height: 481px) and (max-height: 640px) {\n  .items-list-modal .ui.grid > .column.list {\n    height: 16em;\n  }\n}\n@media only screen and (min-height: 641px) and (max-height: 732px) {\n  .items-list-modal .ui.grid > .column.list {\n    height: 25em;\n  }\n}\n@media only screen and (min-height: 733px) {\n  .items-list-modal .ui.grid > .column.list {\n    height: 28em;\n  }\n}\n.clickable:hover {\n  cursor: pointer;\n}\n.clickable.link {\n  color: #00979C;\n}\n.clickable.link:hover {\n  color: #3FC5CA;\n}\n.manage.modal.manage-credit-check .header .icon-credit {\n  width: 2.5em;\n  height: 2.5em;\n}\n.manage.modal.manage-credit-check a.insufficient-credit-text {\n  color: white;\n}\n@media only screen and (max-width: 768px) {\n  .manage.credit-check > .row > .column {\n    padding: 0;\n  }\n}\n.manage.credit-check a.clickable {\n  color: rgba(0, 0, 0, 0.87);\n}\n.manage.credit-check table td.check {\n  padding: 0;\n}\n.manage.credit-check table td.check a {\n  padding: 1.4em 0;\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.manage.credit-check p.notice-font {\n  font-size: 0.8em;\n}\n.manage.credit-check .icon-wrapper {\n  width: 100%;\n  height: 100%;\n  padding: 1.4em 0;\n}\n.manage.credit-check .icon-credit {\n  width: 1.3em;\n  height: 1.3em;\n  vertical-align: middle;\n}\n.manage.credit-check .round.icon {\n  width: 1.3em;\n  height: 1.3em;\n  text-align: center;\n  margin-left: auto;\n  margin-right: auto;\n  border-radius: 60%;\n  padding: 0.11em;\n}\n.manage.credit-check .round.icon.manage {\n  padding: 0;\n}\n.manage.credit-check .round.icon.manage img {\n  width: 0.8em;\n}\n.manage.credit-check .round.icon .value {\n  font-size: 3em;\n  font-weight: bold;\n}\n.manage.credit-check .round.icon span {\n  display: inline-block;\n  line-height: calc(9em - 7em);\n  vertical-align: middle;\n  height: calc(9em - 3em);\n}\n.manage.credit-check .round.icon.pending {\n  background: #F7941E;\n}\n.manage.credit-check .round.icon.success {\n  background: #57b4ca;\n}\n.manage.credit-check .round.icon.green {\n  background: #009774;\n}\n.color-gray {\n  color: #9D9D9D;\n}\n.a-gray {\n  color: #767676;\n}\n.a-gray:hover {\n  color: #666666;\n}\n.a-blue {\n  color: #4183C4;\n}\n.a-blue:hover {\n  color: #1e70bf;\n}\n.cursor-hand {\n  cursor: pointer;\n}\n.white-text {\n  color: #fff !important;\n}\n.grey-text {\n  color: #aaa;\n}\n@media only screen and (min-width: 768px) {\n  #Dash_Grid_SVG {\n    width: 7em !important;\n    height: 7em !important;\n  }\n}\n.text-center {\n  text-align: center;\n}\n.react-cntdwn-timer {\n  display: inline-block;\n}\n.dash_grid .column {\n  margin: 1em 0;\n}\n.dash_grid .column:hover #book_dash_icon_back {\n  fill: #D9E4EB !important;\n  transition: all 0.35s ease;\n}\n.dash_grid .column:hover .header {\n  color: #666;\n  transition: all 0.35s ease;\n}\n.dash_grid .column #book_dash_icon_back,\n.dash_grid .column .header {\n  transition: all 0.35s ease;\n}\n.dash_grid .column h3.header {\n  color: #272A2C;\n}\n@media only screen and (min-width: 768px) {\n  .dash_grid .column h3.header .sub.header {\n    padding: 0 2em;\n  }\n}\n.dash_grid .column p {\n  margin-bottom: 0;\n}\n.details h2 {\n  font-size: 1.5em;\n}\n.unit-list-grey > .content > .price {\n  color: red !important;\n}\n.manage-bookings tr:first-child td {\n  border-top: 3px solid rgba(34, 36, 38, 0.2) !important;\n}\n.manage-bookings tr:last-child td {\n  border-bottom: 3px solid rgba(34, 36, 38, 0.2) !important;\n}\n.manage-bookings .start > td {\n  border-top-width: 3px !important;\n  border-top-color: rgba(34, 36, 38, 0.2) !important;\n}\n.manage-bookings .end > td {\n  border-bottom-width: 3px !important;\n  border-bottom-color: rgba(34, 36, 38, 0.2) !important;\n}\n.team-leader.icons {\n  top: -0.6em;\n  left: 0.6em;\n}\n.team-leader.icons .icon:not(:first-child) {\n  top: 49.5%;\n  left: 44%;\n}\n.text-ellipsis {\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n}\n.icon-wrap {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  padding-bottom: 0;\n}\n.icon-wrap p {\n  margin-left: 0.8em;\n  font-size: 0.9em;\n}\n.icon-wrap .icon {\n  position: relative;\n  vertical-align: middle;\n  text-align: center;\n  display: inline-block;\n  width: 2.6em;\n  height: 2.6em;\n  font-size: 0.9em;\n  background-color: #3C88CC;\n  color: white;\n}\n.icon-wrap .icon img {\n  top: 50%;\n  left: 50%;\n  -ms-transform: translate(-50%, -50%);\n      transform: translate(-50%, -50%);\n  position: absolute;\n  width: 1.6em;\n  height: auto;\n}\n.icon-wrap .icon.round {\n  border-radius: 50%;\n}\n.customField.toggle {\n  text-align: center;\n}\n.customField.toggle.open > div > button {\n  background-color: #e0e0e0;\n}\n.customField.toggle.open > div > button:hover {\n  background-color: #ddd;\n}\n.customField.fields {\n  padding: 0 !important;\n  opacity: 0;\n  max-height: 0px;\n  visibility: hidden;\n  transition: all 0s linear;\n}\n.customField.fields.open {\n  padding: 1em 0 !important;\n  opacity: 1;\n  max-height: 3000px;\n  visibility: visible;\n  transition: all 0.5s ease;\n}\n.ui.feed > .event.activity-logs > .content .extra.text {\n  max-width: inherit !important;\n}\n.semantic-textbox {\n  margin: 0;\n  -webkit-appearance: none;\n  padding: 0.5em 1em;\n  background: #fff;\n  border: 1px solid rgba(34, 36, 38, 0.15);\n  color: rgba(0, 0, 0, 0.87);\n  border-radius: 0.28571429rem;\n  box-shadow: 0 0 0 0 transparent inset;\n  transition: color 0.1s ease, border-color 0.1s ease;\n  font-size: 1em;\n  line-height: 1.2857;\n  resize: vertical;\n  height: 3em;\n  min-height: 3em;\n}\n.multi-edit-nav.fixed {\n  position: fixed !important;\n  top: 0;\n  z-index: 999;\n  width: 98.5% !important;\n  background: #FFF;\n}\n.multi-edit-nav.fixed .ui.menu {\n  border-bottom: none;\n}\n@media only screen and (min-width: 768px) {\n  .multi-edit-nav .ui.menu {\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n  }\n  .multi-edit-nav .ui.menu .item.no-menu-right-border {\n    -ms-flex: 0 1 auto;\n        flex: 0 1 auto;\n    min-width: 0;\n  }\n  .multi-edit-nav .ui.menu .item.no-menu-right-border .filterContainer {\n    -ms-flex: 0 1 auto;\n        flex: 0 1 auto;\n    min-width: 6em;\n  }\n  .multi-edit-nav .ui.menu .item.no-menu-right-border .filterContainer .ui.dropdown.booking > .text {\n    display: block;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n  .multi-edit-nav .ui.menu .item.no-menu-right-border > .ui.selection.dropdown.filterContainer {\n    -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n    width: auto;\n  }\n  .multi-edit-nav .ui.menu .right-menu {\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n  }\n  .multi-edit-nav .ui.menu .right-menu > .item {\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n  }\n  .multi-edit-nav .ui.menu .right-menu > .item .filterContainer {\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n  }\n  .multi-edit-nav .ui.menu .right-menu > .item form {\n    -ms-flex: 0 1 auto;\n        flex: 0 1 auto;\n    min-width: 8em;\n  }\n  .multi-edit-nav .ui.menu .right-menu > .item form .multi-edit-search {\n    width: 100%;\n    min-width: 0;\n  }\n  .multi-edit-nav .ui.menu .right-menu > .item form .multi-edit-search > input {\n    min-width: 0;\n  }\n}\n@media only screen and (min-width: 768px) and (max-width: 1199px) {\n  .multi-edit-nav .ui.menu {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .multi-edit-nav.fixed {\n    position: static !important;\n    width: 100% !important;\n  }\n  .multi-edit-nav .ui.menu .item.no-menu-right-border,\n  .multi-edit-nav .ui.menu .right-menu > .item {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-align: stretch;\n        align-items: stretch;\n  }\n  .multi-edit-nav .ui.menu .item.no-menu-right-border .filterContainer,\n  .multi-edit-nav .ui.menu .right-menu > .item .filterContainer,\n  .multi-edit-nav .ui.menu .item.no-menu-right-border form,\n  .multi-edit-nav .ui.menu .right-menu > .item form {\n    width: 100%;\n    margin: 0 0 0.5em 0;\n  }\n  .multi-edit-nav .ui.menu .item.no-menu-right-border .filterContainer:last-child,\n  .multi-edit-nav .ui.menu .right-menu > .item .filterContainer:last-child,\n  .multi-edit-nav .ui.menu .item.no-menu-right-border form:last-child,\n  .multi-edit-nav .ui.menu .right-menu > .item form:last-child {\n    margin-bottom: 0;\n  }\n  .multi-edit-nav .ui.menu .item.no-menu-right-border .ui.button,\n  .multi-edit-nav .ui.menu .right-menu > .item .ui.button {\n    width: 100%;\n    margin: 0;\n  }\n  .multi-edit-nav .multi-edit-search {\n    width: 100%;\n  }\n  .multi-edit-nav .multi-edit-search > input {\n    max-width: 100% !important;\n  }\n}\n.multi-edit-nav .no-menu-right-border .ui.dropdown.booking,\n.multi-edit-nav .right-menu .ui.dropdown.booking {\n  background: #FFF;\n  padding: 0.7em 2em 0.5em 0.7em;\n  line-height: 1em;\n  border: 1px solid rgba(34, 36, 38, 0.15);\n  min-height: 2.7142em;\n  color: rgba(0, 0, 0, 0.87);\n  border-radius: 0.28571429rem;\n  transition: box-shadow 0.1s ease, width 0.1s ease;\n  white-space: nowrap;\n  max-width: 10em;\n}\n.multi-edit-nav .no-menu-right-border .ui.dropdown.booking:hover,\n.multi-edit-nav .right-menu .ui.dropdown.booking:hover {\n  border-color: rgba(34, 36, 38, 0.35);\n}\n.multi-edit-nav .no-menu-right-border .ui.dropdown.booking.selected,\n.multi-edit-nav .right-menu .ui.dropdown.booking.selected {\n  border-color: #56B35A;\n}\n.multi-edit-nav .no-menu-right-border .ui.dropdown.booking > .dropdown.icon,\n.multi-edit-nav .right-menu .ui.dropdown.booking > .dropdown.icon {\n  cursor: pointer;\n  position: absolute;\n  width: auto;\n  height: auto;\n  line-height: 1.2142em;\n  top: 0.78571429em;\n  right: 0.8em;\n  margin: -0.78571429em;\n  padding: 0.78571429em;\n}\n.multi-edit-nav .no-menu-right-border .ui.dropdown.booking .header,\n.multi-edit-nav .right-menu .ui.dropdown.booking .header {\n  margin-bottom: 0.5em;\n}\n.multi-edit-nav .no-menu-right-border .ui.dropdown.booking .menu i.icon.square,\n.multi-edit-nav .right-menu .ui.dropdown.booking .menu i.icon.square {\n  margin-right: 0.78571429rem;\n}\n.multi-edit-nav .no-menu-right-border .ui.dropdown.booking .menu i.icon.square.check,\n.multi-edit-nav .right-menu .ui.dropdown.booking .menu i.icon.square.check {\n  color: #56B35A;\n}\n@media only screen and (max-width: 767px) {\n  .multi-edit-nav .no-menu-right-border .ui.dropdown.booking.scrolling .menu,\n  .multi-edit-nav .right-menu .ui.dropdown.booking.scrolling .menu {\n    max-height: 11.5em;\n  }\n}\n.multi-edit-nav .no-menu-right-border::before,\n.multi-edit-nav .right-menu::before {\n  width: 0px !important;\n}\n@media only screen and (max-width: 767px) {\n  .multi-edit-nav .no-menu-right-border .ui.dropdown.booking,\n  .multi-edit-nav .right-menu .ui.dropdown.booking {\n    max-width: 100%;\n  }\n}\n.multi-edit-nav .multi-edit-search > input {\n  max-width: 16vw;\n  padding-left: 0.8em !important;\n}\n.multi-edit-nav .multi-edit-search > i.icon {\n  right: 1em !important;\n}\n.multi-edit-nav .multi-edit-search > .dropdown > .text {\n  width: 5em;\n}\n.filterContainer {\n  margin-right: 1em;\n}\n.multi-edit-loading {\n  position: fixed !important;\n  top: 60vh !important;\n}\n.multi-edit-table tbody > tr.green {\n  background: #fff7cc !important;\n}\n.multi-edit-table tbody > tr.red {\n  background: #ffb2af !important;\n}\n.multi-edit-table .ui.input.reference > input,\n.multi-edit-table .ui.input.spaValue > input,\n.multi-edit-table .ui.input.position > input {\n  width: 8em !important;\n}\n.multi-edit-table .ui.input.size > input {\n  width: 7.5em !important;\n}\n.multi-edit-table .ui.input.streetNumberOrLevel > input,\n.multi-edit-table .ui.input.zoneOrBlock > input {\n  width: 9em !important;\n}\n.multi-edit-table .ui.input.streetOrFacing > input {\n  width: 12em !important;\n}\n.multi-edit-top-scoll-bar {\n  overflow-x: scroll;\n  width: 100.5%;\n}\n.multi-edit-top-scoll-bar.fixed {\n  top: 4.5em;\n  position: fixed;\n  z-index: 998;\n  width: 97% !important;\n}\n@media only screen and (max-width: 767px) {\n  .multi-edit-top-scoll-bar.fixed {\n    position: static;\n    width: 100.5% !important;\n  }\n}\n@media only screen and (max-width: 767px) {\n  .multi-edit-actions {\n    text-align: left !important;\n  }\n  .multi-edit-actions .ui.button {\n    float: none !important;\n    margin: 0 0.5em 0.5em 0 !important;\n  }\n}\n.ProjectPanelBankers .segment.sortable {\n  background: #eee;\n}\n.ProjectPanelBankers .banker-item {\n  background: white;\n}\n.ProjectPanelBankers .ui.horizontal.divider,\n.ProjectPanelBankers .ui.header {\n  width: 100%;\n}\n.ProjectPanelBankers .ui.label {\n  background: transparent;\n  color: black;\n  width: 100%;\n}\n.ProjectPanelBankers .ui.selection.dropdown {\n  margin-left: 1em;\n  margin-bottom: 1em;\n}\n.ProjectPanelBankers .ui.segment.form-sof-checkbox {\n  margin-top: 0;\n  margin-left: 1em;\n}\n.ProjectPanelBankers .grouped.fields {\n  width: 100%;\n}\n.ProjectPanelBankers .grouped.fields .fields.form-group {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: 100%;\n  margin: 1em !important;\n  font-weight: bold;\n}\n.ProjectPanelBankers .grouped.fields .fields.form-group .field.form-label {\n  width: 70%;\n}\n.ProjectPanelBankers .grouped.fields .fields.form-group .field.form-value {\n  width: 30%;\n}\n.projectPanelBankers.isSorting {\n  z-index: 1001;\n  background-color: #fff;\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);\n}\n.projectPricingTier.isSorting,\n.projectUnitPricingTier.isSorting {\n  z-index: 1001;\n  background-color: #fff;\n}\n.projectPricingTier.isSorting .colRight .button,\n.projectUnitPricingTier.isSorting .colRight .button {\n  float: right !important;\n  margin-right: 1em !important;\n}\n.projectPricingTier > .row > .column,\n.projectUnitPricingTier > .row > .column {\n  padding: 0 !important;\n}\n@media only screen and (max-width: 767px) {\n  .projectPricingTier > .row > .column,\n  .projectUnitPricingTier > .row > .column {\n    padding: 0 !important;\n  }\n}\n.projectUnitPricingTier .contain {\n  padding: 0 !important;\n  background-color: #efefef;\n}\n.projectUnitPricingTier .contain .head,\n.projectUnitPricingTier .contain .foot {\n  background-color: #fff;\n  margin: 0 !important;\n}\n.projectUnitPricingTier .contain .item {\n  background-color: #fff;\n  margin: 0 !important;\n}\n.projectUnitPricingTier .contain .item > .row {\n  border-bottom: 1px solid #efefef;\n  padding: 1em 0.5em 1em 0em !important;\n}\n@media only screen and (min-width: 768px) {\n  .projectUnitPricingTier .contain .item > .row {\n    padding: 1em 0.8em 1em 0em !important;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .projectUnitPricingTier .contain .ui.dropdown .menu > .item > .description {\n    width: 80% !important;\n    text-align: right;\n  }\n}\n.projectPricingTier .segment {\n  padding: 0 !important;\n  background-color: #efefef;\n}\n.projectPricingTier .segment .head,\n.projectPricingTier .segment .foot {\n  background-color: #fff;\n  margin: 0 !important;\n}\n.projectPricingTier .segment .head .row,\n.projectPricingTier .segment .foot .row {\n  border-bottom: 1px solid #efefef;\n  padding: 1em 0em !important;\n}\n.projectPricingTier .segment .item {\n  background-color: #fff;\n  margin: 0 !important;\n}\n.projectPricingTier .segment .item > .row {\n  border-bottom: 1px solid #efefef;\n  padding: 1em 0.5em 1em 0em !important;\n}\n@media only screen and (min-width: 768px) {\n  .projectPricingTier .segment .item > .row {\n    padding: 1em 0.8em 1em 0em !important;\n  }\n}\n.projectPricingTierView > .row {\n  border-bottom: 1px solid #efefef;\n}\n.projectPricingTierView > .row .spaValue {\n  color: #a5673f !important;\n}\n.PBCFSetup.isSorting,\n.PBCFOSetup.isSorting {\n  z-index: 1001;\n  background-color: #fff;\n}\n.PBCFSetup.row > .column,\n.PBCFOSetup.row > .column {\n  padding: 0 !important;\n}\n@media only screen and (max-width: 767px) {\n  .PBCFSetup.row > .column,\n  .PBCFOSetup.row > .column {\n    padding: 0 !important;\n  }\n}\n.PBCFSetup .contain,\n.PBCFOSetup .contain {\n  padding: 0 !important;\n  background-color: #efefef;\n  border: #efefef solid 1px;\n}\n.PBCFSetup .contain .head,\n.PBCFOSetup .contain .head,\n.PBCFSetup .contain .foot,\n.PBCFOSetup .contain .foot {\n  background-color: #fff;\n  margin: 0 !important;\n}\n.PBCFSetup .contain .item,\n.PBCFOSetup .contain .item {\n  background-color: #fff;\n  margin: 0 !important;\n}\n.PBCFSetup .contain .item > .row:last-child,\n.PBCFOSetup .contain .item > .row:last-child {\n  border-bottom: 3px solid #ddd;\n}\n.PBCFSetup .contain .item > .row.EditArea,\n.PBCFOSetup .contain .item > .row.EditArea {\n  opacity: 1;\n  animation: PCBCF_FadeIn 0.5s ease;\n}\n.PBCFSetup .DragHandleIcon,\n.PBCFOSetup .DragHandleIcon {\n  cursor: move;\n}\n@keyframes PCBCF_FadeIn {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.ddPricingTierDropdown .description {\n  display: none;\n}\n.ddPricingTierDropdown .ddPricingTierItem {\n  font-size: 12px;\n  margin-top: 0;\n}\n.ddPricingTierDropdown .ddPricingTierItem .sub.header {\n  font-size: 12px;\n}\n.ddPricingTierDropdown .ddPricingTierItem .name,\n.ddPricingTierDropdown .ddPricingTierItem .value {\n  display: inline;\n  font-size: 14px;\n  font-weight: 400;\n}\n.ddPricingTierDropdown .ddPricingTierItem .value {\n  float: right;\n  color: rgba(0, 0, 0, 0.4);\n}\n.ddPricingTierDropdown .ui.selection.dropdown .menu > .item {\n  padding: 0.6rem 1.14285714rem !important;\n}\n.ddPricingTierDropdown .active.selected.item > .ddPricingTierItem .name,\n.ddPricingTierDropdown .active.selected.item > .ddPricingTierItem .value {\n  font-weight: 700;\n}\n.priceName {\n  cursor: help;\n  color: #4183C4;\n}\n.import_file_selcted .close.icon {\n  font-size: 1.35em !important;\n}\n.column.compact,\n.row.compact > .column {\n  padding: 0 0.5em !important;\n}\n.text.red {\n  color: #db2828;\n}\n.text.orange {\n  color: #f2711c;\n}\n.text.yellow {\n  color: #fbbd08;\n}\n.text.olive {\n  color: #b5cc18;\n}\n.text.green {\n  color: #21ba45;\n}\n.text.teal {\n  color: #00b5ad;\n}\n.text.blue {\n  color: #2185d0;\n}\n.text.violet {\n  color: #6435c9;\n}\n.text.purple {\n  color: #a333c8;\n}\n.text.pink {\n  color: #e03997;\n}\n.text.brown {\n  color: #a5673f;\n}\n.text.grey {\n  color: #767676;\n}\n.text.black {\n  color: #1b1c1d;\n}\n.word_break_all {\n  word-break: break-all !important;\n}\n.word_break_word {\n  word-break: break-word !important;\n}\n.ui.container.no_margin {\n  margin: 0 !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  margin-bottom: 0 !important;\n  margin-top: 0 !important;\n}\n.manage_user_bu_search_grid .ui.button {\n  background: transparent !important;\n  color: #2185d0 !important;\n}\nbutton.ui.green.small.icon.button.whatsapp-button {\n  background-color: #4FCE5D;\n}\nbutton.ui.green.small.icon.button.whatsapp-button:hover {\n  background-color: #16ab39;\n}\n.securedocuments-root {\n  overflow: auto;\n}\n.collapse-button {\n  background: none !important;\n  color: #767676 !important;\n}\n.collapse-button:hover {\n  color: #666666 !important;\n}\n.collapse-button:focus {\n  outline: 0;\n}\n.ui.grid > .row > .stretched.column.display_inline_block {\n  -ms-flex-item-align: baseline !important;\n      align-self: baseline !important;\n}\n.consent-pin-message {\n  margin-top: 0.5em;\n  margin-bottom: 2em;\n}\n.consent-pin-message a {\n  color: black !important;\n}\n.consent-pin-message .ui.label {\n  background: #DDFFE6;\n  width: 100%;\n  font-weight: 100;\n  line-height: 1.5em;\n  font-size: 0.88em;\n}\n.consent-actions {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  margin-bottom: 1em;\n}\n.consent-actions .ui.button.cancel {\n  margin-right: 1em;\n  border: 1px solid #e0e1e2;\n  background: transparent;\n}\n.consent-actions .ui.button.cancel:hover {\n  border: 1px solid #cccccc;\n}\n.priceNaming .inputBox:not(:first-child) {\n  margin-top: 2rem;\n}\n.resend {\n  margin-top: 10px;\n}\n.ui.transparentMenu {\n  background: transparent;\n  border: transparent;\n  box-shadow: none;\n  border-radius: 0;\n}\n.bot-button-div {\n  display: contents;\n}\n.bot-button-div .bot-resync-button {\n  background: #0094B3;\n  color: #ffffff;\n  margin-top: 0.3em;\n  margin-bottom: 0.3em;\n}\n.bot-button-div .bot-resync-button:hover {\n  background: #33a9c2 !important;\n  color: #ffffff !important;\n}\n.bot-button-div .bot-resync-button:focus {\n  background: #0094B3;\n  color: #ffffff;\n}\n.bot-button-div .bot-syncing-button {\n  margin-top: 0.3em;\n  margin-bottom: 0.3em;\n}\n.bot-button-div .bot-syncing-div {\n  display: -ms-flexbox;\n  display: flex;\n  /* Safari */\n}\n.bot-button-div .bot-syncing-div .bot-loader {\n  border: 2px solid #969CA4;\n  border-radius: 50%;\n  border-top: 2px solid #49B3B1;\n  width: 20px;\n  height: 20px;\n  /* Safari */\n  animation: botspin 1s linear infinite;\n}\n@keyframes botspin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.bot-button-div .bot-syncing-div > span {\n  height: 100%;\n  margin-top: auto;\n  margin-bottom: auto;\n  margin-left: 1em;\n}\n.lawyer-title-pb-row {\n  padding-bottom: 5px !important;\n}\n.lawyer-title-pt-row {\n  padding-top: 5px !important;\n}\n.lawyer-input-pt-row {\n  padding-top: 0px !important;\n}\n.lawyer-wrap-text {\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n}\n.ui.form.lawyer-confirmation-form-input .field > label {\n  font-weight: 100 !important;\n}\n.ui.basic.button.edit-spa-button {\n  color: #00979C !important;\n  box-shadow: none !important;\n  padding-right: 0px;\n}\n.ui.basic.button.edit-spa-button:hover {\n  color: #009297 !important;\n}\n.ui.basic.button.delete-spa-button {\n  color: red !important;\n  box-shadow: none !important;\n  padding-right: 0px;\n}\n.ui.basic.button.delete-spa-button:hover {\n  color: red !important;\n}\n.ui.grid .row.half-padding,\n.ui.grid .row.half-v-padding {\n  padding: 0.5em 0 !important;\n}\n.ui.grid .row.no-top-padding {\n  padding-top: 0 !important;\n}\n.ui.grid .row.no-bottom-padding {\n  padding-bottom: 0 !important;\n}\n.ui.grid .column {\n  /* Not Mobile */\n}\n.ui.grid .column.half-padding,\n.ui.grid .column.half-h-padding {\n  padding: 0 0.5em !important;\n}\n.ui.grid .column.no-right-padding {\n  padding-right: 0 !important;\n}\n.ui.grid .column.no-left-padding {\n  padding-left: 0 !important;\n}\n@media only screen and (min-width: 768px) {\n  .ui.grid .column.mobile-half-left-padding {\n    padding-left: 0.5em !important;\n  }\n}\n.ui.divider.compact {\n  margin: 0.5em 0 !important;\n}\n.ui.divider.midsize {\n  margin: 0.7em 0 !important;\n}\n.ui.button.api-action-button {\n  color: #ffffff !important;\n  background-color: #0094B3 !important;\n}\n.ui.button.api-action-button:hover {\n  background: #33a9c2 !important;\n}\n.system-settings_description-text {\n  color: rgba(0, 0, 0, 0.6);\n  font-style: italic;\n}\n.unit-info_description-text {\n  color: rgba(0, 0, 0, 0.6);\n  font-style: italic;\n  margin: auto 0.5em !important;\n}\n.unit-list_on-hold-icon {\n  color: #767676;\n  margin-left: 0.2em !important;\n}\n.MortgageCalculator .ui.grid + .grid {\n  margin-top: 0;\n}\n.MortgageCalculator .grouped.fields {\n  width: 100%;\n  color: #596975 !important;\n}\n.MortgageCalculator .grouped.fields .fields.form-group {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: 100%;\n  margin: 0.5em 0 !important;\n}\n.MortgageCalculator .grouped.fields .fields.form-group .field.form-label {\n  width: 80%;\n  font-family: 'Open Sans';\n  font-size: 14px;\n  font-weight: 400;\n  text-align: left;\n}\n.MortgageCalculator .grouped.fields .fields.form-group .field.form-value {\n  width: 20%;\n  text-align: right;\n}\n.MortgageCalculator .grouped.fields .fields.form-group .field.form-value .ui.toggle.checkbox input[type=checkbox]:checked ~ label::before,\n.MortgageCalculator .grouped.fields .fields.form-group .field.form-value .ui.toggle.checkbox input[type=checkbox]:checked:focus ~ label::before {\n  background: #50b793 !important;\n}\n.MortgageCalculator .resultBreakdown .ui.grid > .column:not(.row) {\n  padding-top: 0.2rem;\n  padding-bottom: 0.2rem;\n}\n.MortgageCalculator .title {\n  font-family: 'Montserrat';\n  font-size: 15px;\n  font-weight: 600;\n  text-align: left;\n}\n.MortgageCalculator .totalGrid .row {\n  padding-bottom: 0;\n}\n.MortgageCalculator .totalGrid .value {\n  font-family: 'Montserrat';\n  font-size: 19px !important;\n  font-weight: 600 !important;\n  color: #3f85ca !important;\n  padding-bottom: 1.5rem !important;\n}\n.MortgageCalculator .totalFee {\n  margin: 0.5rem 0;\n  font-family: 'Open Sans';\n  font-size: 14px;\n  font-weight: 600;\n  color: #00233b;\n  padding-top: 1rem;\n}\n.MortgageCalculator .fee {\n  padding: 0.7rem 0;\n  font-family: 'Open Sans';\n  font-size: 14px;\n  font-weight: 400;\n  color: #596975;\n  margin-left: 1rem;\n}\n.MortgageCalculator .ppDropdown .ppItem {\n  font-size: 12px;\n  margin-top: 0;\n}\n.MortgageCalculator .ppDropdown .ppItem .name,\n.MortgageCalculator .ppDropdown .ppItem .value {\n  display: inline;\n  font-size: 14px;\n  font-weight: 400;\n}\n.MortgageCalculator .ppDropdown .ppItem .value {\n  float: right;\n  color: rgba(0, 0, 0, 0.4);\n}\n.bn-section-expanded {\n  margin-top: 2em !important;\n  opacity: 0;\n  animation: animate-fade-in 0.75s ease-in-out forwards;\n  /* Apply the animation */\n  animation-delay: 0.25s;\n  z-index: 1;\n}\n.modal.share-e-sign .loading-div {\n  padding: 10em 0;\n}\n.modal.share-e-sign > .content {\n  padding: 1.5rem 1.5rem 3rem 1.5rem !important;\n}\n.modal.share-e-sign > .content > div > p {\n  margin-top: 15px;\n}\n.modal.share-e-sign > .content .disabled {\n  opacity: 0.45;\n}\n.modal.share-e-sign > .content .shared-text {\n  color: #4183c4;\n  font-size: 0.95em;\n  font-style: italic;\n}\n.modal.share-e-sign > .content .share-note {\n  color: #596975;\n  font-size: 0.98em;\n  font-style: italic;\n}\n.modal.share-e-sign > .content .renew {\n  margin-top: 30px;\n  background-color: #f8f9faff;\n}\n.modal.share-e-sign > .content .renew p {\n  color: #596975;\n  text-align: center;\n}\n.modal.share-e-sign > .content .renew button {\n  color: #4183c4;\n  background-color: #f8f9faff;\n  text-decoration: none;\n  border: none;\n}\n.modal.share-e-sign > .content .copy-pin {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  font-size: 16px;\n  margin-bottom: 6px;\n}\n@keyframes animate-fade-in {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.quotation-grid > .row:first-child {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding: 0 !important;\n  margin-top: 1em;\n}\n.quotation-grid > .row:first-child > .column:first-child {\n  width: 50%;\n}\n.quotation-grid > .row:first-child > .column:last-child {\n  width: 50%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: end;\n}\n.quotation-grid > .row:first-child > .column:last-child > .button {\n  border-radius: 0.2em;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}\n.quotation-grid > .row:not(:first-child) {\n  padding: 0;\n}\n.quotation-grid > .row:not(:first-child) > .column > .accordion {\n  margin-left: 1em;\n  margin-right: 1em;\n}\n.quotation-grid > .row:not(:first-child) > .column > .accordion > div > .title {\n  padding: 1em 0 !important;\n}\n.quotation-grid > .row:not(:first-child) > .column > .accordion > div > .title > .ui.grid > .row {\n  margin: 1em 0;\n}\n.quotation-grid > .row:not(:first-child) > .column > .accordion > div > .title > .ui.grid > .row > .column:first-child {\n  width: 80%;\n  display: -ms-grid;\n  display: grid;\n}\n.quotation-grid > .row:not(:first-child) > .column > .accordion > div > .title > .ui.grid > .row > .column:first-child small {\n  margin-left: 2.5em;\n  margin-top: 0.2em;\n  color: rgba(0, 0, 0, 0.6);\n}\n.quotation-grid > .row:not(:first-child) > .column > .accordion > div > .title > .ui.grid > .row > .column:last-child {\n  width: 20%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: end;\n      justify-content: end;\n}\n.quotation-grid > .row:not(:first-child) > .column > .accordion > div > .title > .ui.grid > .row > .column:last-child .ui.basic.button {\n  box-shadow: none;\n}\n.quotation-grid > .row:not(:first-child) > .column > .accordion > div > .title > .ui.grid > .row > .column:last-child .ui.basic.button:focus {\n  background-color: transparent !important;\n}\n.quotation-grid > .row:not(:first-child) > .column > .accordion > div > .active.content {\n  padding: 1.5em 2.5em !important;\n}\n.quotation-grid > .row:not(:first-child) > .column > .accordion > div > .active.content > .row:first-child {\n  margin-bottom: 2em;\n}\n.quotation-grid > .row:not(:first-child) > .column > .accordion > div > .active.content .quotation-subtitle:not(:last-child) {\n  margin: 2em 0;\n}\n.quotation-grid > .row:not(:first-child) > .column > .accordion > div > .active.content .quotation-subtitle:last-child {\n  margin-top: 2em;\n}\n.quotation-grid > .row:not(:first-child) > .column > .accordion > div > .active.content .quotation-calculations {\n  margin-bottom: 1em;\n}\n.quotation-grid > .row:not(:first-child) > .column > .accordion > div > .active.content .quotation-calculations small {\n  display: -ms-grid;\n  display: grid;\n  margin-left: 2.5em;\n  color: rgba(0, 0, 0, 0.6);\n}\n.quotation-grid > .row:not(:first-child) > .column > .accordion > div:not(:last-child) {\n  border-bottom: 1px solid rgba(34, 36, 38, 0.15);\n}\n.quotation-modal > .header > .grid > .row {\n  padding-top: 0.5em;\n  padding-bottom: 0.5em;\n}\n.quotation-modal > .header > .grid > .row > .column:first-child {\n  width: 80%;\n  margin-top: auto;\n  margin-bottom: auto;\n}\n.quotation-modal > .header > .grid > .row > .column:last-child {\n  width: 20%;\n  text-align: right;\n}\n.quotation-modal > .header > .grid > .row > .column:last-child > .button {\n  box-shadow: none;\n  padding: 0;\n  margin: 0;\n}\n.quotation-modal > .header > .grid > .row > .column:last-child > .button:focus {\n  background-color: transparent !important;\n}\n.quotation-modal > .content > .field {\n  display: -ms-grid;\n  display: grid;\n}\n.quotation-modal > .content > .field label,\n.quotation-modal > .content > .field select {\n  font-weight: bold;\n  margin-top: 1.5em;\n  margin-bottom: 3px;\n}\n.quotation-modal > .content > .field label span,\n.quotation-modal > .content > .field select span {\n  color: red;\n}\n.ui.form .field.error .ui.dropdown .menu div,\n.ui.form .field.error .ui.dropdown .menu span {\n  background-color: #fbe7e7 !important;\n}\n.docxTemplates.isSorting {\n  z-index: 1001;\n  background-color: #fff;\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.25);\n  border-radius: 5px;\n}\n", ""]);

// exports


/***/ }),
/* 2835 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(202)(false);
// imports


// module
exports.push([module.i, ".ui.image.load-image:not(.loaded).ratio1_2:before {\n  padding-top: 100%;\n}\n.grid.compare_content > .column > span > h1 {\n  margin-bottom: 0;\n}\n.compare_content > .column > .column {\n  padding-top: 5em;\n  padding-bottom: 3em;\n}\n.row-margin {\n  margin-top: 3em;\n}\n.spec_row > .column > div > i.icon,\n.spec_row > .column > div > p {\n  display: inline-block;\n}\n.spec_row > .column > div > i.icon {\n  margin-right: 0.5em;\n  font-size: 1.2em;\n}\n.spec_row > .column > div > p {\n  font-size: 1.3em;\n}\n.grid > .column.row.compare_header > p {\n  margin-bottom: 2em;\n}\n.spec_row small {\n  font-size: 0.5em;\n  margin-right: 0.2em;\n}\n.noValue {\n  padding-top: 2em;\n}\n.mulitNoValue {\n  padding-top: 7em;\n}\n.noSpecAvailable {\n  line-height: 6;\n  font-size: 0.9em;\n}\n.specColumns:not(:first-child) {\n  margin-top: 3em;\n}\n.compare_content hr {\n  opacity: 0.4;\n  margin: 3em 8em 3em 8em;\n}\n@media only screen and (max-width: 767px) {\n  .compare_content .divider {\n    margin-left: 2em;\n    margin-right: 2em;\n  }\n  .image.load-image > div > .image.load-image-placeholder > div > p,\n  .image.load-image > div > .image.load-image-placeholder > div > a.button {\n    font-size: 0.8em;\n    padding: 0.5em;\n  }\n  .spec_row > .column > div > i.icon,\n  .spec_row > .column > div > p {\n    font-size: 1em;\n  }\n  .grid.compare_content h1 {\n    font-size: 1.6em;\n  }\n  .compare_content > .column > .column {\n    padding-top: 3em;\n  }\n  .noSpecAvailable {\n    font-size: 0.8em;\n  }\n  .compare_content hr {\n    margin: 3em 3em 3em 3em;\n  }\n}\n", ""]);

// exports


/***/ }),
/* 2836 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(202)(false);
// imports


// module
exports.push([module.i, "@media only screen and (max-width: 1200px) {\n  .ui.button.button-reduce-spacing {\n    padding-left: 0.2em;\n    padding-right: 0.2em;\n    font-size: 0.9rem;\n  }\n}\n", ""]);

// exports


/***/ }),
/* 2837 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(202)(false);
// imports


// module
exports.push([module.i, ".compare_content > .column > .column {\n  padding-top: 3em;\n  padding-bottom: 3em;\n}\n.specColumns > p {\n  display: inline-block;\n}\n.specColumns:not(:first-child) {\n  margin-top: 3em;\n}\n.basicInfo h1 > small {\n  font-size: 0.5em;\n  margin-left: 0.5em;\n}\n.multiUnitSpec:not(:first-child) {\n  margin: 6em 2em 3em;\n}\n.noUnitCompare {\n  text-align: center;\n  margin-top: 9em;\n  margin-bottom: 9em;\n}\n.ppItemBox:not(:first-child) {\n  margin-top: 6em;\n}\n.compare_content .ui.horizontal.divider {\n  margin-bottom: 3em;\n}\na.ui.button.viewMoreButton {\n  margin: 0 auto;\n  width: 10em;\n}\nh1 {\n  font-size: 1.6em;\n}\n.basicInfo > .column.unitSpecButtonCol {\n  padding-top: 0;\n}\n.ui.horizontal.divider:not(:first-child) {\n  margin-top: 3em;\n}\n", ""]);

// exports


/***/ }),
/* 2838 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(202)(false);
// imports


// module
exports.push([module.i, ".rc-time-picker {\n  display: inline-block;\n  position: relative;\n  box-sizing: border-box;\n}\n.rc-time-picker * {\n  box-sizing: border-box;\n}\n.rc-time-picker-clear {\n  position: absolute;\n  right: 6px;\n  cursor: pointer;\n  overflow: hidden;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  line-height: 20px;\n  top: 3px;\n  margin: 0;\n}\n.rc-time-picker-clear-icon:after {\n  content: \"x\";\n  font-size: 12px;\n  font-style: normal;\n  color: #aaa;\n  display: inline-block;\n  line-height: 1;\n  height: 20px;\n  width: 20px;\n  transition: color 0.3s ease;\n}\n.rc-time-picker-clear-icon:hover:after {\n  color: #666;\n}\n.rc-time-picker-input {\n  width: 100%;\n  position: relative;\n  display: inline-block;\n  padding: 4px 7px;\n  height: 28px;\n  cursor: text;\n  font-size: 12px;\n  line-height: 1.5;\n  color: #666;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  transition: border 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), background 0.2s cubic-bezier(0.645, 0.045, 0.355, 1), box-shadow 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n.rc-time-picker-input[disabled] {\n  color: #ccc;\n  background: #f7f7f7;\n  cursor: not-allowed;\n}\n.rc-time-picker-panel {\n  z-index: 1070;\n  width: 170px;\n  position: absolute;\n  box-sizing: border-box;\n}\n.rc-time-picker-panel * {\n  box-sizing: border-box;\n}\n.rc-time-picker-panel-inner {\n  display: inline-block;\n  position: relative;\n  outline: none;\n  list-style: none;\n  font-size: 12px;\n  text-align: left;\n  background-color: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 5px #ccc;\n  background-clip: padding-box;\n  border: 1px solid #ccc;\n  line-height: 1.5;\n}\n.rc-time-picker-panel-narrow {\n  max-width: 113px;\n}\n.rc-time-picker-panel-input {\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  cursor: auto;\n  line-height: 1.5;\n  outline: 0;\n  border: 1px solid transparent;\n}\n.rc-time-picker-panel-input-wrap {\n  box-sizing: border-box;\n  position: relative;\n  padding: 6px;\n  border-bottom: 1px solid #e9e9e9;\n}\n.rc-time-picker-panel-input-invalid {\n  border-color: red;\n}\n.rc-time-picker-panel-select {\n  float: left;\n  font-size: 12px;\n  border: 1px solid #e9e9e9;\n  border-width: 0 1px;\n  margin-left: -1px;\n  box-sizing: border-box;\n  width: 56px;\n  max-height: 144px;\n  overflow-y: auto;\n  position: relative;\n}\n.rc-time-picker-panel-select-active {\n  overflow-y: auto;\n}\n.rc-time-picker-panel-select:first-child {\n  border-left: 0;\n  margin-left: 0;\n}\n.rc-time-picker-panel-select:last-child {\n  border-right: 0;\n}\n.rc-time-picker-panel-select ul {\n  list-style: none;\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n}\n.rc-time-picker-panel-select li {\n  list-style: none;\n  margin: 0;\n  padding: 0 0 0 16px;\n  width: 100%;\n  height: 24px;\n  line-height: 24px;\n  text-align: left;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.rc-time-picker-panel-select li:hover {\n  background: #edfaff;\n}\nli.rc-time-picker-panel-select-option-selected {\n  background: #f7f7f7;\n  font-weight: bold;\n}\nli.rc-time-picker-panel-select-option-disabled {\n  color: #ccc;\n}\nli.rc-time-picker-panel-select-option-disabled:hover {\n  background: transparent;\n  cursor: not-allowed;\n}\n", ""]);

// exports


/***/ }),
/* 2839 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(202)(false);
// imports


// module
exports.push([module.i, ".react-calendar {\n  width: 350px;\n  max-width: 100%;\n  background: white;\n  border: 1px solid #a0a096;\n  font-family: Arial, Helvetica, sans-serif;\n  line-height: 1.125em;\n}\n.react-calendar,\n.react-calendar *,\n.react-calendar *:before,\n.react-calendar *:after {\n  box-sizing: border-box;\n}\n.react-calendar button {\n  margin: 0;\n  border: 0;\n  outline: none;\n}\n.react-calendar button:enabled:hover {\n  cursor: pointer;\n}\n.react-calendar__navigation {\n  height: 44px;\n  margin-bottom: 1em;\n}\n.react-calendar__navigation button {\n  min-width: 44px;\n  background: none;\n}\n.react-calendar__navigation button:enabled:hover,\n.react-calendar__navigation button:enabled:focus {\n  background-color: #e6e6e6;\n}\n.react-calendar__navigation button[disabled] {\n  background-color: #f0f0f0;\n}\n.react-calendar__month-view__weekdays {\n  text-align: center;\n  text-transform: uppercase;\n  font-weight: bold;\n  font-size: 0.75em;\n}\n.react-calendar__month-view__weekdays__weekday {\n  padding: 0.5em;\n}\n.react-calendar__month-view__weekNumbers {\n  font-weight: bold;\n}\n.react-calendar__month-view__weekNumbers .react-calendar__tile {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  font-size: 0.75em;\n  padding: calc(0.75em / 0.75) calc(0.5em / 0.75);\n}\n.react-calendar__month-view__days__day--weekend {\n  color: #d10000;\n}\n.react-calendar__month-view__days__day--neighboringMonth {\n  color: #757575;\n}\n.react-calendar__year-view .react-calendar__tile,\n.react-calendar__decade-view .react-calendar__tile,\n.react-calendar__century-view .react-calendar__tile {\n  padding: 2em 0.5em;\n}\n.react-calendar__tile {\n  max-width: 100%;\n  text-align: center;\n  padding: 0.75em 0.5em;\n  background: none;\n}\n.react-calendar__tile:disabled {\n  background-color: #f0f0f0;\n}\n.react-calendar__tile:enabled:hover,\n.react-calendar__tile:enabled:focus {\n  background-color: #e6e6e6;\n}\n.react-calendar__tile--hasActive {\n  background: #76baff;\n}\n.react-calendar__tile--hasActive:enabled:hover,\n.react-calendar__tile--hasActive:enabled:focus {\n  background: #a9d4ff;\n}\n.react-calendar__tile--active {\n  background: #006edc;\n  color: white;\n}\n.react-calendar__tile--active:enabled:hover,\n.react-calendar__tile--active:enabled:focus {\n  background: #1087ff;\n}\n.react-calendar--selectRange .react-calendar__tile--hover {\n  background-color: #e6e6e6;\n}\n", ""]);

// exports


/***/ }),
/* 2840 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(202)(false);
// imports


// module
exports.push([module.i, "/* DayPicker styles */\n\n.DayPicker {\n  display: inline-block;\n  font-size: 1rem;\n}\n\n.DayPicker-wrapper {\n  position: relative;\n\n  -ms-flex-direction: row;\n\n      flex-direction: row;\n  padding-bottom: 1em;\n\n  -webkit-user-select: none;\n\n     -moz-user-select: none;\n\n      -ms-user-select: none;\n\n          user-select: none;\n}\n\n.DayPicker-Months {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n\n.DayPicker-Month {\n  display: table;\n  margin: 0 1em;\n  margin-top: 1em;\n  border-spacing: 0;\n  border-collapse: collapse;\n\n  -webkit-user-select: none;\n\n     -moz-user-select: none;\n\n      -ms-user-select: none;\n\n          user-select: none;\n}\n\n.DayPicker-NavBar {\n}\n\n.DayPicker-NavButton {\n  position: absolute;\n  top: 1em;\n  right: 1.5em;\n  left: auto;\n\n  display: inline-block;\n  margin-top: 2px;\n  width: 1.25em;\n  height: 1.25em;\n  background-position: center;\n  background-size: 50%;\n  background-repeat: no-repeat;\n  color: #8B9898;\n  cursor: pointer;\n}\n\n.DayPicker-NavButton:hover {\n  opacity: 0.8;\n}\n\n.DayPicker-NavButton--prev {\n  margin-right: 1.5em;\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAVVJREFUWAnN2G0KgjAYwPHpGfRkaZeqvgQaK+hY3SUHrk1YzNLay/OiEFp92I+/Mp2F2Mh2lLISWnflFjzH263RQjzMZ19wgs73ez0o1WmtW+dgA01VxrE3p6l2GLsnBy1VYQOtVSEH/atCCgqpQgKKqYIOiq2CBkqtggLKqQIKgqgCBjpJ2Y5CdJ+zrT9A7HHSTA1dxUdHgzCqJIEwq0SDsKsEg6iqBIEoq/wEcVRZBXFV+QJxV5mBtlDFB5VjYTaGZ2sf4R9PM7U9ZU+lLuaetPP/5Die3ToO1+u+MKtHs06qODB2zBnI/jBd4MPQm1VkY79Tb18gB+C62FdBFsZR6yeIo1YQiLJWMIiqVjQIu1YSCLNWFgijVjYIuhYYCKoWKAiiFgoopxYaKLUWOii2FgkophYp6F3r42W5A9s9OcgNvva8xQaysKXlFytoqdYmQH6tF3toSUo0INq9AAAAAElFTkSuQmCC');\n}\n\n.DayPicker-NavButton--next {\n  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAwCAYAAAB5R9gVAAAABGdBTUEAALGPC/xhBQAAAXRJREFUWAnN119ugjAcwPHWzJ1gnmxzB/BBE0n24m4xfNkTaOL7wOtsl3AXMMb+Vjaa1BG00N8fSEibPpAP3xAKKs2yjzTPH9RAjhEo9WzPr/Vm8zgE0+gXATAxxuxtqeJ9t5tIwv5AtQAApsfT6TPdbp+kUBcgVwvO51KqVhMkXKsVJFXrOkigVhCIs1Y4iKlWZxB1rX4gwlpRIIpa8SDkWmggrFq4IIRaJKCYWnSgnrXIQV1r8YD+1Vrn+bReagysIFfLABRt31v8oBu1xEBttfRbltmfjgEcWh9snUS2kNdBK6WN1vrOWxObWsz+fjxevsxmB1GQDfINWiev83nhaoiB/CoOU438oPrhXS0WpQ9xc1ZQWxWHqUYe0I0qrKCQKjygDlXIQV2r0IF6ViEBxVTBBSFUQQNhVYkHIVeJAtkNsbQ7c1LtzP6FsObhb2rCKv7NBIGoq4SDmKoEgTirXAcJVGkFSVVpgoSrXICGUMUH/QBZNSUy5XWUhwAAAABJRU5ErkJggg==');\n}\n\n.DayPicker-NavButton--interactionDisabled {\n  display: none;\n}\n\n.DayPicker-Caption {\n  display: table-caption;\n  margin-bottom: 0.5em;\n  padding: 0 0.5em;\n  text-align: left;\n}\n\n.DayPicker-Caption > div {\n  font-weight: 500;\n  font-size: 1.15em;\n}\n\n.DayPicker-Weekdays {\n  display: table-header-group;\n  margin-top: 1em;\n}\n\n.DayPicker-WeekdaysRow {\n  display: table-row;\n}\n\n.DayPicker-Weekday {\n  display: table-cell;\n  padding: 0.5em;\n  color: #8B9898;\n  text-align: center;\n  font-size: 0.875em;\n}\n\n.DayPicker-Weekday abbr[title] {\n  border-bottom: none;\n  text-decoration: none;\n}\n\n.DayPicker-Body {\n  display: table-row-group;\n}\n\n.DayPicker-Week {\n  display: table-row;\n}\n\n.DayPicker-Day {\n  display: table-cell;\n  padding: 0.5em;\n  border-radius: 50%;\n  vertical-align: middle;\n  text-align: center;\n  cursor: pointer;\n}\n\n.DayPicker-WeekNumber {\n  display: table-cell;\n  padding: 0.5em;\n  min-width: 1em;\n  border-right: 1px solid #EAECEC;\n  color: #8B9898;\n  vertical-align: middle;\n  text-align: right;\n  font-size: 0.75em;\n  cursor: pointer;\n}\n\n.DayPicker--interactionDisabled .DayPicker-Day {\n  cursor: default;\n}\n\n.DayPicker-Footer {\n  padding-top: 0.5em;\n}\n\n.DayPicker-TodayButton {\n  border: none;\n  background-color: transparent;\n  background-image: none;\n  box-shadow: none;\n  color: #4A90E2;\n  font-size: 0.875em;\n  cursor: pointer;\n}\n\n/* Default modifiers */\n\n.DayPicker-Day--today {\n  color: #D0021B;\n  font-weight: 700;\n}\n\n.DayPicker-Day--outside {\n  color: #8B9898;\n  cursor: default;\n}\n\n.DayPicker-Day--disabled {\n  color: #DCE0E0;\n  cursor: default;\n  /* background-color: #eff1f1; */\n}\n\n/* Example modifiers */\n\n.DayPicker-Day--sunday {\n  background-color: #F7F8F8;\n}\n\n.DayPicker-Day--sunday:not(.DayPicker-Day--today) {\n  color: #DCE0E0;\n}\n\n.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {\n  position: relative;\n\n  background-color: #4A90E2;\n  color: #F0F8FF;\n}\n\n.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {\n  background-color: #51A0FA;\n}\n\n.DayPicker:not(.DayPicker--interactionDisabled)\n  .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {\n  background-color: #F0F8FF;\n}\n\n/* DayPickerInput */\n\n.DayPickerInput {\n  display: inline-block;\n}\n\n.DayPickerInput-OverlayWrapper {\n  position: relative;\n}\n\n.DayPickerInput-Overlay {\n  position: absolute;\n  left: 0;\n  z-index: 1;\n\n  background: white;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);\n}\n", ""]);

// exports


/***/ }),
/* 2841 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(1156);
exports = module.exports = __webpack_require__(202)(false);
// imports


// module
exports.push([module.i, ".FormGroup {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  margin-bottom: 1em;\n}\n\n.FormGroup.vertical {\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: start;\n      align-items: flex-start;\n}\n\n.FormGroup label {\n  -ms-flex-order: 1;\n      order: 1;\n}\n\n.FormGroup label {\n  width: 8em;\n  padding-right: 0.5em;\n  white-space: nowrap;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  cursor: pointer;\n  color: #aaacaa;\n  font-weight: bold;\n}\n\n.FormGroup.vertical label {\n  margin-bottom: 0.5em;\n}\n\n.FormGroup input, .FormGroup textarea, .FormGroup select {\n  font-size: .95em;\n  padding: 0.5em 1em;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  color: #394045;\n  outline: none;\n  -ms-flex-positive: 1;\n      flex-grow: 1;\n}\n\n.FormGroup > select {\n  padding: 0.5em 2em 0.5em 0.5em;\n}\n\n.FormGroup select {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  background-image: url(" + escape(__webpack_require__(3519)) + ");\n  background-position: right 10px center;\n  background-repeat: no-repeat;\n  background-size: auto 40%;\n}\n\n.FormGroup input,\n.FormGroup textarea,\n.FormGroup select,\n.FormGroup, .InputGroup,\n.FormGroup .values {\n  -ms-flex-order: 2;\n      order: 2;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n}\n\n.FormGroup .helper {\n  -ms-flex-order: 1;\n      order: 1;\n  font-weight: lighter;\n}\n\n.FormGroup.vertical .helper {\n  margin-bottom: 0.5em;\n}\n\n.FormGroup input[type=\"checkbox\"] {\n  -ms-flex-order: 1;\n      order: 1;\n  -ms-flex: none;\n      flex: none;\n  width: auto;\n  margin-left: 10em;\n}\n\n.FormGroup input[type=\"checkbox\"] ~ label {\n  width: auto;\n  text-align: left;\n  padding-left: 0.4em;\n}\n\n.FormGroup > .values {\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n\n.FormGroup > .values > .FormGroup {\n  margin-bottom: 0;\n}\n\n.FormGroup > .values.radio > .FormGroup {\n  -ms-flex-positive: 0;\n      flex-grow: 0;\n}\n\n.FormGroup > .values.radio > .FormGroup:not(:first-child){\n  padding-left: 1em;\n}\n\n.FormGroup [type=\"radio\"] + label {\n  width: auto;\n}\n\n.FormGroup input[type=\"radio\"]:checked,\n.FormGroup input[type=\"radio\"]:not(:checked) {\n    position: absolute;\n    left: -9999px;\n}\n\n.FormGroup input.text-right {\n  text-align: right;\n}\n\n.FormGroup [type=\"radio\"]:checked + label,\n.FormGroup [type=\"radio\"]:not(:checked) + label\n{\n    position: relative;\n    padding-left: 1.75em;\n    cursor: pointer;\n    line-height: 1.25em;\n    display: inline-block;\n}\n.FormGroup [type=\"radio\"]:checked + label:before,\n.FormGroup [type=\"radio\"]:not(:checked) + label:before {\n    content: '';\n    position: absolute;\n    left: 0;\n    top: 0;\n    width: 1.3em;\n    height: 1.3em;\n    border: 1px solid #ddd;\n    border-radius: 100%;\n    background: #fff;\n}\n.FormGroup [type=\"radio\"]:checked + label:after,\n.FormGroup [type=\"radio\"]:not(:checked) + label:after {\n    content: '';\n    width: .85em;\n    height: .85em;\n    background: #00b296;\n    position: absolute;\n    top: .24em;\n    left: .24em;\n    border-radius: 100%;\n    transition: all 0.2s ease;\n}\n.FormGroup [type=\"radio\"]:not(:checked) + label:after {\n    opacity: 0;\n    -ms-transform: scale(0);\n        transform: scale(0);\n}\n.FormGroup [type=\"radio\"]:checked + label:after {\n    opacity: 1;\n    -ms-transform: scale(1);\n        transform: scale(1);\n}\n\n/* label state styles */\n.FormGroup input:focus ~ label, .FormGroup textarea:focus ~ label, .FormGroup select:focus ~ label {\n  transition: color 0.5s ease;\n  color: #fff;\n}\n\n.FormGroup input:checked ~ label {\n  font-weight: bold;\n}\n\n.FormGroup input[disabled], .FormGroup select[disabled] {\n  background: #95989a;\n  border: none;\n}\n\n.FormGroup > .InputGroup {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.FormGroup > .InputGroup select:first-child {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  width: calc(50% - 2em);\n}\n\n.FormGroup > .InputGroup input:last-child {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  border-left: none;\n  width: calc(50% - 2em);\n}\n\n@media only screen and (max-width: 400px) {\n  .FormGroup {\n    -ms-flex-direction: column;\n        flex-direction: column;\n    -ms-flex-align: stretch;\n        align-items: stretch;\n  }\n  .FormGroup label {\n    margin-bottom: .3em;\n    width: 100%;\n    white-space: pre-wrap;\n  }\n  .FormGroup input {\n    width: calc(100% - 2em);\n  }\n}\n", ""]);

// exports


/***/ }),
/* 2842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.utils = __webpack_require__(1159);
exports.Cipher = __webpack_require__(643);
exports.DES = __webpack_require__(1158);
exports.CBC = __webpack_require__(2843);
exports.EDE = __webpack_require__(2844);


/***/ }),
/* 2843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(137);
var inherits = __webpack_require__(41);

var proto = {};

function CBCState(iv) {
  assert.equal(iv.length, 8, 'Invalid IV length');

  this.iv = new Array(8);
  for (var i = 0; i < this.iv.length; i++)
    this.iv[i] = iv[i];
}

function instantiate(Base) {
  function CBC(options) {
    Base.call(this, options);
    this._cbcInit();
  }
  inherits(CBC, Base);

  var keys = Object.keys(proto);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    CBC.prototype[key] = proto[key];
  }

  CBC.create = function create(options) {
    return new CBC(options);
  };

  return CBC;
}

exports.instantiate = instantiate;

proto._cbcInit = function _cbcInit() {
  var state = new CBCState(this.options.iv);
  this._cbcState = state;
};

proto._update = function _update(inp, inOff, out, outOff) {
  var state = this._cbcState;
  var superProto = this.constructor.super_.prototype;

  var iv = state.iv;
  if (this.type === 'encrypt') {
    for (var i = 0; i < this.blockSize; i++)
      iv[i] ^= inp[inOff + i];

    superProto._update.call(this, iv, 0, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = out[outOff + i];
  } else {
    superProto._update.call(this, inp, inOff, out, outOff);

    for (var i = 0; i < this.blockSize; i++)
      out[outOff + i] ^= iv[i];

    for (var i = 0; i < this.blockSize; i++)
      iv[i] = inp[inOff + i];
  }
};


/***/ }),
/* 2844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assert = __webpack_require__(137);
var inherits = __webpack_require__(41);

var Cipher = __webpack_require__(643);
var DES = __webpack_require__(1158);

function EDEState(type, key) {
  assert.equal(key.length, 24, 'Invalid key length');

  var k1 = key.slice(0, 8);
  var k2 = key.slice(8, 16);
  var k3 = key.slice(16, 24);

  if (type === 'encrypt') {
    this.ciphers = [
      DES.create({ type: 'encrypt', key: k1 }),
      DES.create({ type: 'decrypt', key: k2 }),
      DES.create({ type: 'encrypt', key: k3 })
    ];
  } else {
    this.ciphers = [
      DES.create({ type: 'decrypt', key: k3 }),
      DES.create({ type: 'encrypt', key: k2 }),
      DES.create({ type: 'decrypt', key: k1 })
    ];
  }
}

function EDE(options) {
  Cipher.call(this, options);

  var state = new EDEState(this.type, this.options.key);
  this._edeState = state;
}
inherits(EDE, Cipher);

module.exports = EDE;

EDE.create = function create(options) {
  return new EDE(options);
};

EDE.prototype._update = function _update(inp, inOff, out, outOff) {
  var state = this._edeState;

  state.ciphers[0]._update(inp, inOff, out, outOff);
  state.ciphers[1]._update(out, outOff, out, outOff);
  state.ciphers[2]._update(out, outOff, out, outOff);
};

EDE.prototype._pad = DES.prototype._pad;
EDE.prototype._unpad = DES.prototype._unpad;


/***/ }),
/* 2845 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var generatePrime = __webpack_require__(1160)
var primes = __webpack_require__(2847)

var DH = __webpack_require__(2846)

function getDiffieHellman (mod) {
  var prime = new Buffer(primes[mod].prime, 'hex')
  var gen = new Buffer(primes[mod].gen, 'hex')

  return new DH(prime, gen)
}

var ENCODINGS = {
  'binary': true, 'hex': true, 'base64': true
}

function createDiffieHellman (prime, enc, generator, genc) {
  if (Buffer.isBuffer(enc) || ENCODINGS[enc] === undefined) {
    return createDiffieHellman(prime, 'binary', enc, generator)
  }

  enc = enc || 'binary'
  genc = genc || 'binary'
  generator = generator || new Buffer([2])

  if (!Buffer.isBuffer(generator)) {
    generator = new Buffer(generator, genc)
  }

  if (typeof prime === 'number') {
    return new DH(generatePrime(prime, generator), generator, true)
  }

  if (!Buffer.isBuffer(prime)) {
    prime = new Buffer(prime, enc)
  }

  return new DH(prime, generator, true)
}

exports.DiffieHellmanGroup = exports.createDiffieHellmanGroup = exports.getDiffieHellman = getDiffieHellman
exports.createDiffieHellman = exports.DiffieHellman = createDiffieHellman

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75).Buffer))

/***/ }),
/* 2846 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(Buffer) {var BN = __webpack_require__(77);
var MillerRabin = __webpack_require__(1261);
var millerRabin = new MillerRabin();
var TWENTYFOUR = new BN(24);
var ELEVEN = new BN(11);
var TEN = new BN(10);
var THREE = new BN(3);
var SEVEN = new BN(7);
var primes = __webpack_require__(1160);
var randomBytes = __webpack_require__(286);
module.exports = DH;

function setPublicKey(pub, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(pub)) {
    pub = new Buffer(pub, enc);
  }
  this._pub = new BN(pub);
  return this;
}

function setPrivateKey(priv, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(priv)) {
    priv = new Buffer(priv, enc);
  }
  this._priv = new BN(priv);
  return this;
}

var primeCache = {};
function checkPrime(prime, generator) {
  var gen = generator.toString('hex');
  var hex = [gen, prime.toString(16)].join('_');
  if (hex in primeCache) {
    return primeCache[hex];
  }
  var error = 0;

  if (prime.isEven() ||
    !primes.simpleSieve ||
    !primes.fermatTest(prime) ||
    !millerRabin.test(prime)) {
    //not a prime so +1
    error += 1;

    if (gen === '02' || gen === '05') {
      // we'd be able to check the generator
      // it would fail so +8
      error += 8;
    } else {
      //we wouldn't be able to test the generator
      // so +4
      error += 4;
    }
    primeCache[hex] = error;
    return error;
  }
  if (!millerRabin.test(prime.shrn(1))) {
    //not a safe prime
    error += 2;
  }
  var rem;
  switch (gen) {
    case '02':
      if (prime.mod(TWENTYFOUR).cmp(ELEVEN)) {
        // unsuidable generator
        error += 8;
      }
      break;
    case '05':
      rem = prime.mod(TEN);
      if (rem.cmp(THREE) && rem.cmp(SEVEN)) {
        // prime mod 10 needs to equal 3 or 7
        error += 8;
      }
      break;
    default:
      error += 4;
  }
  primeCache[hex] = error;
  return error;
}

function DH(prime, generator, malleable) {
  this.setGenerator(generator);
  this.__prime = new BN(prime);
  this._prime = BN.mont(this.__prime);
  this._primeLen = prime.length;
  this._pub = undefined;
  this._priv = undefined;
  this._primeCode = undefined;
  if (malleable) {
    this.setPublicKey = setPublicKey;
    this.setPrivateKey = setPrivateKey;
  } else {
    this._primeCode = 8;
  }
}
Object.defineProperty(DH.prototype, 'verifyError', {
  enumerable: true,
  get: function () {
    if (typeof this._primeCode !== 'number') {
      this._primeCode = checkPrime(this.__prime, this.__gen);
    }
    return this._primeCode;
  }
});
DH.prototype.generateKeys = function () {
  if (!this._priv) {
    this._priv = new BN(randomBytes(this._primeLen));
  }
  this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
  return this.getPublicKey();
};

DH.prototype.computeSecret = function (other) {
  other = new BN(other);
  other = other.toRed(this._prime);
  var secret = other.redPow(this._priv).fromRed();
  var out = new Buffer(secret.toArray());
  var prime = this.getPrime();
  if (out.length < prime.length) {
    var front = new Buffer(prime.length - out.length);
    front.fill(0);
    out = Buffer.concat([front, out]);
  }
  return out;
};

DH.prototype.getPublicKey = function getPublicKey(enc) {
  return formatReturnValue(this._pub, enc);
};

DH.prototype.getPrivateKey = function getPrivateKey(enc) {
  return formatReturnValue(this._priv, enc);
};

DH.prototype.getPrime = function (enc) {
  return formatReturnValue(this.__prime, enc);
};

DH.prototype.getGenerator = function (enc) {
  return formatReturnValue(this._gen, enc);
};

DH.prototype.setGenerator = function (gen, enc) {
  enc = enc || 'utf8';
  if (!Buffer.isBuffer(gen)) {
    gen = new Buffer(gen, enc);
  }
  this.__gen = gen;
  this._gen = new BN(gen);
  return this;
};

function formatReturnValue(bn, enc) {
  var buf = new Buffer(bn.toArray());
  if (!enc) {
    return buf;
  } else {
    return buf.toString(enc);
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(75).Buffer))

/***/ }),
/* 2847 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 2848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return alignElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return alignPoint; });
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var vendorPrefix;
var jsCssMap = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  // IE did it wrong again ...
  ms: '-ms-',
  O: '-o-'
};

function getVendorPrefix() {
  if (vendorPrefix !== undefined) {
    return vendorPrefix;
  }

  vendorPrefix = '';
  var style = document.createElement('p').style;
  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      vendorPrefix = key;
    }
  }

  return vendorPrefix;
}

function getTransitionName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
}

function getTransformName() {
  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
}
function setTransitionProperty(node, value) {
  var name = getTransitionName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transitionProperty') {
      node.style.transitionProperty = value;
    }
  }
}

function setTransform(node, value) {
  var name = getTransformName();

  if (name) {
    node.style[name] = value;

    if (name !== 'transform') {
      node.style.transform = value;
    }
  }
}

function getTransitionProperty(node) {
  return node.style.transitionProperty || node.style[getTransitionName()];
}
function getTransformXY(node) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
    return {
      x: parseFloat(matrix[12] || matrix[4], 0),
      y: parseFloat(matrix[13] || matrix[5], 0)
    };
  }

  return {
    x: 0,
    y: 0
  };
}
var matrix2d = /matrix\((.*)\)/;
var matrix3d = /matrix3d\((.*)\)/;
function setTransformXY(node, xy) {
  var style = window.getComputedStyle(node, null);
  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());

  if (transform && transform !== 'none') {
    var arr;
    var match2d = transform.match(matrix2d);

    if (match2d) {
      match2d = match2d[1];
      arr = match2d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[4] = xy.x;
      arr[5] = xy.y;
      setTransform(node, "matrix(".concat(arr.join(','), ")"));
    } else {
      var match3d = transform.match(matrix3d)[1];
      arr = match3d.split(',').map(function (item) {
        return parseFloat(item, 10);
      });
      arr[12] = xy.x;
      arr[13] = xy.y;
      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
    }
  } else {
    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
  }
}

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
var getComputedStyleX; // https://stackoverflow.com/a/3485654/3040605

function forceRelayout(elem) {
  var originalStyle = elem.style.display;
  elem.style.display = 'none';
  elem.offsetHeight; // eslint-disable-line

  elem.style.display = originalStyle;
}

function css(el, name, v) {
  var value = v;

  if (_typeof(name) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }

    return undefined;
  }

  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value = "".concat(value, "px");
    }

    el.style[name] = value;
    return undefined;
  }

  return getComputedStyleX(el, name);
}

function getClientPosition(elem) {
  var box;
  var x;
  var y;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式

  box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top; // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.
  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.
  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;
  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
  var method = "scroll".concat(top ? 'Top' : 'Left');

  if (typeof ret !== 'number') {
    var d = w.document; // ie6,7,8 standard mode

    ret = d.documentElement[method];

    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }

  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
/**
 * A crude way of determining if an object is a window
 * @member util
 */


function isWindow(obj) {
  // must use == for ie8

  /* eslint eqeqeq:0 */
  return obj !== null && obj !== undefined && obj == obj.window;
}

function getDocument(node) {
  if (isWindow(node)) {
    return node.document;
  }

  if (node.nodeType === 9) {
    return node;
  }

  return node.ownerDocument;
}

function _getComputedStyle(elem, name, cs) {
  var computedStyle = cs;
  var val = '';
  var d = getDocument(elem);
  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61

  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');

var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity

  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content

    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out

    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX; // Revert the changed values

    style[LEFT] = left;
    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }

  return ret === '' ? 'auto' : ret;
}

if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function getOffsetDirection(dir, option) {
  if (dir === 'left') {
    return option.useCssRight ? 'right' : dir;
  }

  return option.useCssBottom ? 'bottom' : dir;
}

function oppositeOffsetDirection(dir) {
  if (dir === 'left') {
    return 'right';
  } else if (dir === 'right') {
    return 'left';
  } else if (dir === 'top') {
    return 'bottom';
  } else if (dir === 'bottom') {
    return 'top';
  }
} // 设置 elem 相对 elem.ownerDocument 的坐标


function setLeftTop(elem, offset, option) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var presetH = -999;
  var presetV = -999;
  var horizontalProperty = getOffsetDirection('left', option);
  var verticalProperty = getOffsetDirection('top', option);
  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);

  if (horizontalProperty !== 'left') {
    presetH = 999;
  }

  if (verticalProperty !== 'top') {
    presetV = 999;
  }

  var originalTransition = '';
  var originalOffset = getOffset(elem);

  if ('left' in offset || 'top' in offset) {
    originalTransition = getTransitionProperty(elem) || '';
    setTransitionProperty(elem, 'none');
  }

  if ('left' in offset) {
    elem.style[oppositeHorizontalProperty] = '';
    elem.style[horizontalProperty] = "".concat(presetH, "px");
  }

  if ('top' in offset) {
    elem.style[oppositeVerticalProperty] = '';
    elem.style[verticalProperty] = "".concat(presetV, "px");
  } // force relayout


  forceRelayout(elem);
  var old = getOffset(elem);
  var originalStyle = {};

  for (var key in offset) {
    if (offset.hasOwnProperty(key)) {
      var dir = getOffsetDirection(key, option);
      var preset = key === 'left' ? presetH : presetV;
      var off = originalOffset[key] - old[key];

      if (dir === key) {
        originalStyle[dir] = preset + off;
      } else {
        originalStyle[dir] = preset - off;
      }
    }
  }

  css(elem, originalStyle); // force relayout

  forceRelayout(elem);

  if ('left' in offset || 'top' in offset) {
    setTransitionProperty(elem, originalTransition);
  }

  var ret = {};

  for (var _key in offset) {
    if (offset.hasOwnProperty(_key)) {
      var _dir = getOffsetDirection(_key, option);

      var _off = offset[_key] - originalOffset[_key];

      if (_key === _dir) {
        ret[_dir] = originalStyle[_dir] + _off;
      } else {
        ret[_dir] = originalStyle[_dir] - _off;
      }
    }
  }

  css(elem, ret);
}

function setTransform$1(elem, offset) {
  var originalOffset = getOffset(elem);
  var originalXY = getTransformXY(elem);
  var resultXY = {
    x: originalXY.x,
    y: originalXY.y
  };

  if ('left' in offset) {
    resultXY.x = originalXY.x + offset.left - originalOffset.left;
  }

  if ('top' in offset) {
    resultXY.y = originalXY.y + offset.top - originalOffset.top;
  }

  setTransformXY(elem, resultXY);
}

function setOffset(elem, offset, option) {
  if (option.ignoreShake) {
    var oriOffset = getOffset(elem);
    var oLeft = oriOffset.left.toFixed(0);
    var oTop = oriOffset.top.toFixed(0);
    var tLeft = offset.left.toFixed(0);
    var tTop = offset.top.toFixed(0);

    if (oLeft === tLeft && oTop === tTop) {
      return;
    }
  }

  if (option.useCssRight || option.useCssBottom) {
    setLeftTop(elem, offset, option);
  } else if (option.useCssTransform && getTransformName() in document.body.style) {
    setTransform$1(elem, offset);
  } else {
    setLeftTop(elem, offset, option);
  }
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name; // Remember the old values, and insert the new ones

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem); // Revert the old values

  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop;
  var j;
  var i;

  for (j = 0; j < props.length; j++) {
    prop = props[j];

    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = void 0;

        if (prop === 'border') {
          cssProp = "".concat(prop).concat(which[i], "Width");
        } else {
          cssProp = prop + which[i];
        }

        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }

  return value;
}

var domUtils = {
  getParent: function getParent(element) {
    var parent = element;

    do {
      if (parent.nodeType === 11 && parent.host) {
        parent = parent.host;
      } else {
        parent = parent.parentNode;
      }
    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);

    return parent;
  }
};
each(['Width', 'Height'], function (name) {
  domUtils["doc".concat(name)] = function (refWin) {
    var d = refWin.document;
    return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
  };

  domUtils["viewport".concat(name)] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = "client".concat(name);
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
    // backcompat 取 body

    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});
/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */

function getWH(elem, name, ex) {
  var extra = ex;

  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.getBoundingClientRect().width : elem.getBoundingClientRect().height;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem);
  var cssBoxValue = 0;

  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
    borderBoxValue = undefined; // Fall back to computed then un computed css if necessary

    cssBoxValue = getComputedStyleX(elem, name);

    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    } // Normalize '', auto, and prepare for extra


    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }

  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }

  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;

  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which);
    }

    return cssBoxValue;
  } else if (borderBoxValueOrIsBorderBox) {
    if (extra === BORDER_INDEX) {
      return val;
    }

    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
  }

  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
}; // fix #119 : https://github.com/kissyteam/kissy/issues/119

function getWHIgnoreDisplay() {
  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
    args[_key2] = arguments[_key2];
  }

  var val;
  var elem = args[0]; // in case elem is window
  // elem.offsetWidth === undefined

  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }

  return val;
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);

  domUtils["outer".concat(first)] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };

  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, v) {
    var val = v;

    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);

        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which);
        }

        return css(elem, name, val);
      }

      return undefined;
    }

    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

function mix(to, from) {
  for (var i in from) {
    if (from.hasOwnProperty(i)) {
      to[i] = from[i];
    }
  }

  return to;
}

var utils = {
  getWindow: function getWindow(node) {
    if (node && node.document && node.setTimeout) {
      return node;
    }

    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  getDocument: getDocument,
  offset: function offset(el, value, option) {
    if (typeof value !== 'undefined') {
      setOffset(el, value, option || {});
    } else {
      return getOffset(el);
    }
  },
  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var i;
    var ret = {};

    for (i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }

    var overflow = obj.overflow;

    if (overflow) {
      for (i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }

    return ret;
  },
  mix: mix,
  getWindowScrollLeft: function getWindowScrollLeft(w) {
    return getScrollLeft(w);
  },
  getWindowScrollTop: function getWindowScrollTop(w) {
    return getScrollTop(w);
  },
  merge: function merge() {
    var ret = {};

    for (var i = 0; i < arguments.length; i++) {
      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
    }

    return ret;
  },
  viewportWidth: 0,
  viewportHeight: 0
};
mix(utils, domUtils);

/**
 * 得到会导致元素显示不全的祖先元素
 */

var getParent = utils.getParent;

function getOffsetParent(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return null;
  } // ie 这个也不是完全可行

  /*
   <div style="width: 50px;height: 100px;overflow: hidden">
   <div style="width: 50px;height: 100px;position: relative;" id="d6">
   元素 6 高 100px 宽 50px<br/>
   </div>
   </div>
   */
  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
  //  In other browsers it only includes elements with position absolute, relative or
  // fixed, not elements with overflow set to auto or scroll.
  //        if (UA.ie && ieMode < 8) {
  //            return element.offsetParent;
  //        }
  // 统一的 offsetParent 方法


  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent;
  var positionStyle = utils.css(element, 'position');
  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';

  if (!skipStatic) {
    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
  }

  for (parent = getParent(element); parent && parent !== body; parent = getParent(parent)) {
    positionStyle = utils.css(parent, 'position');

    if (positionStyle !== 'static') {
      return parent;
    }
  }

  return null;
}

var getParent$1 = utils.getParent;
function isAncestorFixed(element) {
  if (utils.isWindow(element) || element.nodeType === 9) {
    return false;
  }

  var doc = utils.getDocument(element);
  var body = doc.body;
  var parent = null;

  for (parent = getParent$1(element); parent && parent !== body; parent = getParent$1(parent)) {
    var positionStyle = utils.css(parent, 'position');

    if (positionStyle === 'fixed') {
      return true;
    }
  }

  return false;
}

/**
 * 获得元素的显示部分的区域
 */

function getVisibleRectForElement(element) {
  var visibleRect = {
    left: 0,
    right: Infinity,
    top: 0,
    bottom: Infinity
  };
  var el = getOffsetParent(element);
  var doc = utils.getDocument(element);
  var win = doc.defaultView || doc.parentWindow;
  var body = doc.body;
  var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
  // all scrollable containers.

  while (el) {
    // clientWidth is zero for inline block elements in ie.
    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
    // viewport. In some browsers, el.offsetParent may be
    // document.documentElement, so check for that too.
    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
      var pos = utils.offset(el); // add border

      pos.left += el.clientLeft;
      pos.top += el.clientTop;
      visibleRect.top = Math.max(visibleRect.top, pos.top);
      visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
      pos.left + el.clientWidth);
      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
      visibleRect.left = Math.max(visibleRect.left, pos.left);
    } else if (el === body || el === documentElement) {
      break;
    }

    el = getOffsetParent(el);
  } // Set element position to fixed
  // make sure absolute element itself don't affect it's visible area
  // https://github.com/ant-design/ant-design/issues/7601


  var originalPosition = null;

  if (!utils.isWindow(element) && element.nodeType !== 9) {
    originalPosition = element.style.position;
    var position = utils.css(element, 'position');

    if (position === 'absolute') {
      element.style.position = 'fixed';
    }
  }

  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);
  var documentWidth = documentElement.scrollWidth;
  var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
  // We should cut this ourself.

  var bodyStyle = window.getComputedStyle(body);

  if (bodyStyle.overflowX === 'hidden') {
    documentWidth = win.innerWidth;
  }

  if (bodyStyle.overflowY === 'hidden') {
    documentHeight = win.innerHeight;
  } // Reset element position after calculate the visible area


  if (element.style) {
    element.style.position = originalPosition;
  }

  if (isAncestorFixed(element)) {
    // Clip by viewport's size.
    visibleRect.left = Math.max(visibleRect.left, scrollX);
    visibleRect.top = Math.max(visibleRect.top, scrollY);
    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
  } else {
    // Clip by document's size.
    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
  }

  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
}

function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
  var pos = utils.clone(elFuturePos);
  var size = {
    width: elRegion.width,
    height: elRegion.height
  };

  if (overflow.adjustX && pos.left < visibleRect.left) {
    pos.left = visibleRect.left;
  } // Left edge inside and right edge outside viewport, try to resize it.


  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
    size.width -= pos.left + size.width - visibleRect.right;
  } // Right edge outside viewport, try to move it.


  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
    // 保证左边界和可视区域左边界对齐
    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
  } // Top edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top < visibleRect.top) {
    pos.top = visibleRect.top;
  } // Top edge inside and bottom edge outside viewport, try to resize it.


  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
    size.height -= pos.top + size.height - visibleRect.bottom;
  } // Bottom edge outside viewport, try to move it.


  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
    // 保证上边界和可视区域上边界对齐
    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
  }

  return utils.mix(pos, size);
}

function getRegion(node) {
  var offset;
  var w;
  var h;

  if (!utils.isWindow(node) && node.nodeType !== 9) {
    offset = utils.offset(node);
    w = utils.outerWidth(node);
    h = utils.outerHeight(node);
  } else {
    var win = utils.getWindow(node);
    offset = {
      left: utils.getWindowScrollLeft(win),
      top: utils.getWindowScrollTop(win)
    };
    w = utils.viewportWidth(win);
    h = utils.viewportHeight(win);
  }

  offset.width = w;
  offset.height = h;
  return offset;
}

/**
 * 获取 node 上的 align 对齐点 相对于页面的坐标
 */
function getAlignOffset(region, align) {
  var V = align.charAt(0);
  var H = align.charAt(1);
  var w = region.width;
  var h = region.height;
  var x = region.left;
  var y = region.top;

  if (V === 'c') {
    y += h / 2;
  } else if (V === 'b') {
    y += h;
  }

  if (H === 'c') {
    x += w / 2;
  } else if (H === 'r') {
    x += w;
  }

  return {
    left: x,
    top: y
  };
}

function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
  var p1 = getAlignOffset(refNodeRegion, points[1]);
  var p2 = getAlignOffset(elRegion, points[0]);
  var diff = [p2.left - p1.left, p2.top - p1.top];
  return {
    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
  };
}

/**
 * align dom node flexibly
 * @author yiminghe@gmail.com
 */

function isFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
}

function isFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
}

function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
}

function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
}

function flip(points, reg, map) {
  var ret = [];
  utils.each(points, function (p) {
    ret.push(p.replace(reg, function (m) {
      return map[m];
    }));
  });
  return ret;
}

function flipOffset(offset, index) {
  offset[index] = -offset[index];
  return offset;
}

function convertOffset(str, offsetLen) {
  var n;

  if (/%$/.test(str)) {
    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
  } else {
    n = parseInt(str, 10);
  }

  return n || 0;
}

function normalizeOffset(offset, el) {
  offset[0] = convertOffset(offset[0], el.width);
  offset[1] = convertOffset(offset[1], el.height);
}
/**
 * @param el
 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
 * @param align
 */


function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
  var points = align.points;
  var offset = align.offset || [0, 0];
  var targetOffset = align.targetOffset || [0, 0];
  var overflow = align.overflow;
  var source = align.source || el;
  offset = [].concat(offset);
  targetOffset = [].concat(targetOffset);
  overflow = overflow || {};
  var newOverflowCfg = {};
  var fail = 0; // 当前节点可以被放置的显示区域

  var visibleRect = getVisibleRectForElement(source); // 当前节点所占的区域, left/top/width/height

  var elRegion = getRegion(source); // 将 offset 转换成数值，支持百分比

  normalizeOffset(offset, elRegion);
  normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置

  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域

  var newElRegion = utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整

  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
    if (overflow.adjustX) {
      // 如果横向不能放下
      if (isFailX(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var newPoints = flip(points, /[lr]/gi, {
          l: 'r',
          r: 'l'
        }); // 偏移量也反下

        var newOffset = flipOffset(offset, 0);
        var newTargetOffset = flipOffset(targetOffset, 0);
        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);

        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = newPoints;
          offset = newOffset;
          targetOffset = newTargetOffset;
        }
      }
    }

    if (overflow.adjustY) {
      // 如果纵向不能放下
      if (isFailY(elFuturePos, elRegion, visibleRect)) {
        // 对齐位置反下
        var _newPoints = flip(points, /[tb]/gi, {
          t: 'b',
          b: 't'
        }); // 偏移量也反下


        var _newOffset = flipOffset(offset, 1);

        var _newTargetOffset = flipOffset(targetOffset, 1);

        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);

        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
          fail = 1;
          points = _newPoints;
          offset = _newOffset;
          targetOffset = _newTargetOffset;
        }
      }
    } // 如果失败，重新计算当前节点将要被放置的位置


    if (fail) {
      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
      utils.mix(newElRegion, elFuturePos);
    }

    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
    // 1. 复原修改过的定位参数

    if (isStillFailX || isStillFailY) {
      points = align.points;
      offset = align.offset || [0, 0];
      targetOffset = align.targetOffset || [0, 0];
    } // 2. 只有指定了可以调整当前方向才调整


    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度

    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
    }
  } // need judge to in case set fixed with in css on height auto element


  if (newElRegion.width !== elRegion.width) {
    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
  }

  if (newElRegion.height !== elRegion.height) {
    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
  } // https://github.com/kissyteam/kissy/issues/190
  // 相对于屏幕位置没变，而 left/top 变了
  // 例如 <div 'relative'><el absolute></div>


  utils.offset(source, {
    left: newElRegion.left,
    top: newElRegion.top
  }, {
    useCssRight: align.useCssRight,
    useCssBottom: align.useCssBottom,
    useCssTransform: align.useCssTransform,
    ignoreShake: align.ignoreShake
  });
  return {
    points: points,
    offset: offset,
    targetOffset: targetOffset,
    overflow: newOverflowCfg
  };
}
/**
 *  2012-04-26 yiminghe@gmail.com
 *   - 优化智能对齐算法
 *   - 慎用 resizeXX
 *
 *  2011-07-13 yiminghe@gmail.com note:
 *   - 增加智能对齐，以及大小调整选项
 **/

function isOutOfVisibleRect(target) {
  var visibleRect = getVisibleRectForElement(target);
  var targetRegion = getRegion(target);
  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
}

function alignElement(el, refNode, align) {
  var target = align.target || refNode;
  var refNodeRegion = getRegion(target);
  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target);
  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
}

alignElement.__getOffsetParent = getOffsetParent;
alignElement.__getVisibleRectForElement = getVisibleRectForElement;

/**
 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
 * If client position provided, will internal convert to page position.
 */

function alignPoint(el, tgtPoint, align) {
  var pageX;
  var pageY;
  var doc = utils.getDocument(el);
  var win = doc.defaultView || doc.parentWindow;
  var scrollX = utils.getWindowScrollLeft(win);
  var scrollY = utils.getWindowScrollTop(win);
  var viewportWidth = utils.viewportWidth(win);
  var viewportHeight = utils.viewportHeight(win);

  if ('pageX' in tgtPoint) {
    pageX = tgtPoint.pageX;
  } else {
    pageX = scrollX + tgtPoint.clientX;
  }

  if ('pageY' in tgtPoint) {
    pageY = tgtPoint.pageY;
  } else {
    pageY = scrollY + tgtPoint.clientY;
  }

  var tgtRegion = {
    left: pageX,
    top: pageY,
    width: 0,
    height: 0
  };
  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point

  var points = [align.points[0], 'cc'];
  return doAlign(el, tgtRegion, _objectSpread2({}, align, {
    points: points
  }), pointInView);
}

/* unused harmony default export */ var _unused_webpack_default_export = (alignElement);

//# sourceMappingURL=index.js.map


/***/ }),
/* 2849 */
/***/ (function(module, exports, __webpack_require__) {

/*! @license DOMPurify 2.3.3 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.3.3/LICENSE */

(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = global || self, global.DOMPurify = factory());
}(this, function () { 'use strict';

  function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

  var hasOwnProperty = Object.hasOwnProperty,
      setPrototypeOf = Object.setPrototypeOf,
      isFrozen = Object.isFrozen,
      getPrototypeOf = Object.getPrototypeOf,
      getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
  var freeze = Object.freeze,
      seal = Object.seal,
      create = Object.create; // eslint-disable-line import/no-mutable-exports

  var _ref = typeof Reflect !== 'undefined' && Reflect,
      apply = _ref.apply,
      construct = _ref.construct;

  if (!apply) {
    apply = function apply(fun, thisValue, args) {
      return fun.apply(thisValue, args);
    };
  }

  if (!freeze) {
    freeze = function freeze(x) {
      return x;
    };
  }

  if (!seal) {
    seal = function seal(x) {
      return x;
    };
  }

  if (!construct) {
    construct = function construct(Func, args) {
      return new (Function.prototype.bind.apply(Func, [null].concat(_toConsumableArray(args))))();
    };
  }

  var arrayForEach = unapply(Array.prototype.forEach);
  var arrayPop = unapply(Array.prototype.pop);
  var arrayPush = unapply(Array.prototype.push);

  var stringToLowerCase = unapply(String.prototype.toLowerCase);
  var stringMatch = unapply(String.prototype.match);
  var stringReplace = unapply(String.prototype.replace);
  var stringIndexOf = unapply(String.prototype.indexOf);
  var stringTrim = unapply(String.prototype.trim);

  var regExpTest = unapply(RegExp.prototype.test);

  var typeErrorCreate = unconstruct(TypeError);

  function unapply(func) {
    return function (thisArg) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return apply(func, thisArg, args);
    };
  }

  function unconstruct(func) {
    return function () {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return construct(func, args);
    };
  }

  /* Add properties to a lookup table */
  function addToSet(set, array) {
    if (setPrototypeOf) {
      // Make 'in' and truthy checks like Boolean(set.constructor)
      // independent of any properties defined on Object.prototype.
      // Prevent prototype setters from intercepting set as a this value.
      setPrototypeOf(set, null);
    }

    var l = array.length;
    while (l--) {
      var element = array[l];
      if (typeof element === 'string') {
        var lcElement = stringToLowerCase(element);
        if (lcElement !== element) {
          // Config presets (e.g. tags.js, attrs.js) are immutable.
          if (!isFrozen(array)) {
            array[l] = lcElement;
          }

          element = lcElement;
        }
      }

      set[element] = true;
    }

    return set;
  }

  /* Shallow clone an object */
  function clone(object) {
    var newObject = create(null);

    var property = void 0;
    for (property in object) {
      if (apply(hasOwnProperty, object, [property])) {
        newObject[property] = object[property];
      }
    }

    return newObject;
  }

  /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */
  function lookupGetter(object, prop) {
    while (object !== null) {
      var desc = getOwnPropertyDescriptor(object, prop);
      if (desc) {
        if (desc.get) {
          return unapply(desc.get);
        }

        if (typeof desc.value === 'function') {
          return unapply(desc.value);
        }
      }

      object = getPrototypeOf(object);
    }

    function fallbackValue(element) {
      console.warn('fallback value for', element);
      return null;
    }

    return fallbackValue;
  }

  var html = freeze(['a', 'abbr', 'acronym', 'address', 'area', 'article', 'aside', 'audio', 'b', 'bdi', 'bdo', 'big', 'blink', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'center', 'cite', 'code', 'col', 'colgroup', 'content', 'data', 'datalist', 'dd', 'decorator', 'del', 'details', 'dfn', 'dialog', 'dir', 'div', 'dl', 'dt', 'element', 'em', 'fieldset', 'figcaption', 'figure', 'font', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'img', 'input', 'ins', 'kbd', 'label', 'legend', 'li', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meter', 'nav', 'nobr', 'ol', 'optgroup', 'option', 'output', 'p', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'section', 'select', 'shadow', 'small', 'source', 'spacer', 'span', 'strike', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'time', 'tr', 'track', 'tt', 'u', 'ul', 'var', 'video', 'wbr']);

  // SVG
  var svg = freeze(['svg', 'a', 'altglyph', 'altglyphdef', 'altglyphitem', 'animatecolor', 'animatemotion', 'animatetransform', 'circle', 'clippath', 'defs', 'desc', 'ellipse', 'filter', 'font', 'g', 'glyph', 'glyphref', 'hkern', 'image', 'line', 'lineargradient', 'marker', 'mask', 'metadata', 'mpath', 'path', 'pattern', 'polygon', 'polyline', 'radialgradient', 'rect', 'stop', 'style', 'switch', 'symbol', 'text', 'textpath', 'title', 'tref', 'tspan', 'view', 'vkern']);

  var svgFilters = freeze(['feBlend', 'feColorMatrix', 'feComponentTransfer', 'feComposite', 'feConvolveMatrix', 'feDiffuseLighting', 'feDisplacementMap', 'feDistantLight', 'feFlood', 'feFuncA', 'feFuncB', 'feFuncG', 'feFuncR', 'feGaussianBlur', 'feMerge', 'feMergeNode', 'feMorphology', 'feOffset', 'fePointLight', 'feSpecularLighting', 'feSpotLight', 'feTile', 'feTurbulence']);

  // List of SVG elements that are disallowed by default.
  // We still need to know them so that we can do namespace
  // checks properly in case one wants to add them to
  // allow-list.
  var svgDisallowed = freeze(['animate', 'color-profile', 'cursor', 'discard', 'fedropshadow', 'feimage', 'font-face', 'font-face-format', 'font-face-name', 'font-face-src', 'font-face-uri', 'foreignobject', 'hatch', 'hatchpath', 'mesh', 'meshgradient', 'meshpatch', 'meshrow', 'missing-glyph', 'script', 'set', 'solidcolor', 'unknown', 'use']);

  var mathMl = freeze(['math', 'menclose', 'merror', 'mfenced', 'mfrac', 'mglyph', 'mi', 'mlabeledtr', 'mmultiscripts', 'mn', 'mo', 'mover', 'mpadded', 'mphantom', 'mroot', 'mrow', 'ms', 'mspace', 'msqrt', 'mstyle', 'msub', 'msup', 'msubsup', 'mtable', 'mtd', 'mtext', 'mtr', 'munder', 'munderover']);

  // Similarly to SVG, we want to know all MathML elements,
  // even those that we disallow by default.
  var mathMlDisallowed = freeze(['maction', 'maligngroup', 'malignmark', 'mlongdiv', 'mscarries', 'mscarry', 'msgroup', 'mstack', 'msline', 'msrow', 'semantics', 'annotation', 'annotation-xml', 'mprescripts', 'none']);

  var text = freeze(['#text']);

  var html$1 = freeze(['accept', 'action', 'align', 'alt', 'autocapitalize', 'autocomplete', 'autopictureinpicture', 'autoplay', 'background', 'bgcolor', 'border', 'capture', 'cellpadding', 'cellspacing', 'checked', 'cite', 'class', 'clear', 'color', 'cols', 'colspan', 'controls', 'controlslist', 'coords', 'crossorigin', 'datetime', 'decoding', 'default', 'dir', 'disabled', 'disablepictureinpicture', 'disableremoteplayback', 'download', 'draggable', 'enctype', 'enterkeyhint', 'face', 'for', 'headers', 'height', 'hidden', 'high', 'href', 'hreflang', 'id', 'inputmode', 'integrity', 'ismap', 'kind', 'label', 'lang', 'list', 'loading', 'loop', 'low', 'max', 'maxlength', 'media', 'method', 'min', 'minlength', 'multiple', 'muted', 'name', 'noshade', 'novalidate', 'nowrap', 'open', 'optimum', 'pattern', 'placeholder', 'playsinline', 'poster', 'preload', 'pubdate', 'radiogroup', 'readonly', 'rel', 'required', 'rev', 'reversed', 'role', 'rows', 'rowspan', 'spellcheck', 'scope', 'selected', 'shape', 'size', 'sizes', 'span', 'srclang', 'start', 'src', 'srcset', 'step', 'style', 'summary', 'tabindex', 'title', 'translate', 'type', 'usemap', 'valign', 'value', 'width', 'xmlns', 'slot']);

  var svg$1 = freeze(['accent-height', 'accumulate', 'additive', 'alignment-baseline', 'ascent', 'attributename', 'attributetype', 'azimuth', 'basefrequency', 'baseline-shift', 'begin', 'bias', 'by', 'class', 'clip', 'clippathunits', 'clip-path', 'clip-rule', 'color', 'color-interpolation', 'color-interpolation-filters', 'color-profile', 'color-rendering', 'cx', 'cy', 'd', 'dx', 'dy', 'diffuseconstant', 'direction', 'display', 'divisor', 'dur', 'edgemode', 'elevation', 'end', 'fill', 'fill-opacity', 'fill-rule', 'filter', 'filterunits', 'flood-color', 'flood-opacity', 'font-family', 'font-size', 'font-size-adjust', 'font-stretch', 'font-style', 'font-variant', 'font-weight', 'fx', 'fy', 'g1', 'g2', 'glyph-name', 'glyphref', 'gradientunits', 'gradienttransform', 'height', 'href', 'id', 'image-rendering', 'in', 'in2', 'k', 'k1', 'k2', 'k3', 'k4', 'kerning', 'keypoints', 'keysplines', 'keytimes', 'lang', 'lengthadjust', 'letter-spacing', 'kernelmatrix', 'kernelunitlength', 'lighting-color', 'local', 'marker-end', 'marker-mid', 'marker-start', 'markerheight', 'markerunits', 'markerwidth', 'maskcontentunits', 'maskunits', 'max', 'mask', 'media', 'method', 'mode', 'min', 'name', 'numoctaves', 'offset', 'operator', 'opacity', 'order', 'orient', 'orientation', 'origin', 'overflow', 'paint-order', 'path', 'pathlength', 'patterncontentunits', 'patterntransform', 'patternunits', 'points', 'preservealpha', 'preserveaspectratio', 'primitiveunits', 'r', 'rx', 'ry', 'radius', 'refx', 'refy', 'repeatcount', 'repeatdur', 'restart', 'result', 'rotate', 'scale', 'seed', 'shape-rendering', 'specularconstant', 'specularexponent', 'spreadmethod', 'startoffset', 'stddeviation', 'stitchtiles', 'stop-color', 'stop-opacity', 'stroke-dasharray', 'stroke-dashoffset', 'stroke-linecap', 'stroke-linejoin', 'stroke-miterlimit', 'stroke-opacity', 'stroke', 'stroke-width', 'style', 'surfacescale', 'systemlanguage', 'tabindex', 'targetx', 'targety', 'transform', 'text-anchor', 'text-decoration', 'text-rendering', 'textlength', 'type', 'u1', 'u2', 'unicode', 'values', 'viewbox', 'visibility', 'version', 'vert-adv-y', 'vert-origin-x', 'vert-origin-y', 'width', 'word-spacing', 'wrap', 'writing-mode', 'xchannelselector', 'ychannelselector', 'x', 'x1', 'x2', 'xmlns', 'y', 'y1', 'y2', 'z', 'zoomandpan']);

  var mathMl$1 = freeze(['accent', 'accentunder', 'align', 'bevelled', 'close', 'columnsalign', 'columnlines', 'columnspan', 'denomalign', 'depth', 'dir', 'display', 'displaystyle', 'encoding', 'fence', 'frame', 'height', 'href', 'id', 'largeop', 'length', 'linethickness', 'lspace', 'lquote', 'mathbackground', 'mathcolor', 'mathsize', 'mathvariant', 'maxsize', 'minsize', 'movablelimits', 'notation', 'numalign', 'open', 'rowalign', 'rowlines', 'rowspacing', 'rowspan', 'rspace', 'rquote', 'scriptlevel', 'scriptminsize', 'scriptsizemultiplier', 'selection', 'separator', 'separators', 'stretchy', 'subscriptshift', 'supscriptshift', 'symmetric', 'voffset', 'width', 'xmlns']);

  var xml = freeze(['xlink:href', 'xml:id', 'xlink:title', 'xml:space', 'xmlns:xlink']);

  // eslint-disable-next-line unicorn/better-regex
  var MUSTACHE_EXPR = seal(/\{\{[\s\S]*|[\s\S]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
  var ERB_EXPR = seal(/<%[\s\S]*|[\s\S]*%>/gm);
  var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
  var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
  var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
  );
  var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
  var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
  );

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

  function _toConsumableArray$1(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

  var getGlobal = function getGlobal() {
    return typeof window === 'undefined' ? null : window;
  };

  /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */
  var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
    if ((typeof trustedTypes === 'undefined' ? 'undefined' : _typeof(trustedTypes)) !== 'object' || typeof trustedTypes.createPolicy !== 'function') {
      return null;
    }

    // Allow the callers to control the unique policy name
    // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
    // Policy creation with duplicate names throws in Trusted Types.
    var suffix = null;
    var ATTR_NAME = 'data-tt-policy-suffix';
    if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) {
      suffix = document.currentScript.getAttribute(ATTR_NAME);
    }

    var policyName = 'dompurify' + (suffix ? '#' + suffix : '');

    try {
      return trustedTypes.createPolicy(policyName, {
        createHTML: function createHTML(html$$1) {
          return html$$1;
        }
      });
    } catch (_) {
      // Policy creation failed (most likely another DOMPurify script has
      // already run). Skip creating the policy, as this will only cause errors
      // if TT are enforced.
      console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
      return null;
    }
  };

  function createDOMPurify() {
    var window = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();

    var DOMPurify = function DOMPurify(root) {
      return createDOMPurify(root);
    };

    /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */
    DOMPurify.version = '2.3.3';

    /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */
    DOMPurify.removed = [];

    if (!window || !window.document || window.document.nodeType !== 9) {
      // Not running in a browser, provide a factory function
      // so that you can pass your own Window
      DOMPurify.isSupported = false;

      return DOMPurify;
    }

    var originalDocument = window.document;

    var document = window.document;
    var DocumentFragment = window.DocumentFragment,
        HTMLTemplateElement = window.HTMLTemplateElement,
        Node = window.Node,
        Element = window.Element,
        NodeFilter = window.NodeFilter,
        _window$NamedNodeMap = window.NamedNodeMap,
        NamedNodeMap = _window$NamedNodeMap === undefined ? window.NamedNodeMap || window.MozNamedAttrMap : _window$NamedNodeMap,
        Text = window.Text,
        Comment = window.Comment,
        DOMParser = window.DOMParser,
        trustedTypes = window.trustedTypes;


    var ElementPrototype = Element.prototype;

    var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
    var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
    var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
    var getParentNode = lookupGetter(ElementPrototype, 'parentNode');

    // As per issue #47, the web-components registry is inherited by a
    // new document created via createHTMLDocument. As per the spec
    // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
    // a new empty registry is used when creating a template contents owner
    // document, so we use that as our parent document to ensure nothing
    // is inherited.
    if (typeof HTMLTemplateElement === 'function') {
      var template = document.createElement('template');
      if (template.content && template.content.ownerDocument) {
        document = template.content.ownerDocument;
      }
    }

    var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
    var emptyHTML = trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML('') : '';

    var _document = document,
        implementation = _document.implementation,
        createNodeIterator = _document.createNodeIterator,
        createDocumentFragment = _document.createDocumentFragment,
        getElementsByTagName = _document.getElementsByTagName;
    var importNode = originalDocument.importNode;


    var documentMode = {};
    try {
      documentMode = clone(document).documentMode ? document.documentMode : {};
    } catch (_) {}

    var hooks = {};

    /**
     * Expose whether this browser supports running the full DOMPurify.
     */
    DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && typeof implementation.createHTMLDocument !== 'undefined' && documentMode !== 9;

    var MUSTACHE_EXPR$$1 = MUSTACHE_EXPR,
        ERB_EXPR$$1 = ERB_EXPR,
        DATA_ATTR$$1 = DATA_ATTR,
        ARIA_ATTR$$1 = ARIA_ATTR,
        IS_SCRIPT_OR_DATA$$1 = IS_SCRIPT_OR_DATA,
        ATTR_WHITESPACE$$1 = ATTR_WHITESPACE;
    var IS_ALLOWED_URI$$1 = IS_ALLOWED_URI;

    /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */

    /* allowed element names */

    var ALLOWED_TAGS = null;
    var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(html), _toConsumableArray$1(svg), _toConsumableArray$1(svgFilters), _toConsumableArray$1(mathMl), _toConsumableArray$1(text)));

    /* Allowed attribute names */
    var ALLOWED_ATTR = null;
    var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray$1(html$1), _toConsumableArray$1(svg$1), _toConsumableArray$1(mathMl$1), _toConsumableArray$1(xml)));

    /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */
    var FORBID_TAGS = null;

    /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */
    var FORBID_ATTR = null;

    /* Decide if ARIA attributes are okay */
    var ALLOW_ARIA_ATTR = true;

    /* Decide if custom data attributes are okay */
    var ALLOW_DATA_ATTR = true;

    /* Decide if unknown protocols are okay */
    var ALLOW_UNKNOWN_PROTOCOLS = false;

    /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */
    var SAFE_FOR_TEMPLATES = false;

    /* Decide if document with <html>... should be returned */
    var WHOLE_DOCUMENT = false;

    /* Track whether config is already set on this instance of DOMPurify. */
    var SET_CONFIG = false;

    /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */
    var FORCE_BODY = false;

    /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */
    var RETURN_DOM = false;

    /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */
    var RETURN_DOM_FRAGMENT = false;

    /* If `RETURN_DOM` or `RETURN_DOM_FRAGMENT` is enabled, decide if the returned DOM
     * `Node` is imported into the current `Document`. If this flag is not enabled the
     * `Node` will belong (its ownerDocument) to a fresh `HTMLDocument`, created by
     * DOMPurify.
     *
     * This defaults to `true` starting DOMPurify 2.2.0. Note that setting it to `false`
     * might cause XSS from attacks hidden in closed shadowroots in case the browser
     * supports Declarative Shadow: DOM https://web.dev/declarative-shadow-dom/
     */
    var RETURN_DOM_IMPORT = true;

    /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */
    var RETURN_TRUSTED_TYPE = false;

    /* Output should be free from DOM clobbering attacks? */
    var SANITIZE_DOM = true;

    /* Keep element content when removing element? */
    var KEEP_CONTENT = true;

    /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */
    var IN_PLACE = false;

    /* Allow usage of profiles like html, svg and mathMl */
    var USE_PROFILES = {};

    /* Tags to ignore content of when KEEP_CONTENT is true */
    var FORBID_CONTENTS = null;
    var DEFAULT_FORBID_CONTENTS = addToSet({}, ['annotation-xml', 'audio', 'colgroup', 'desc', 'foreignobject', 'head', 'iframe', 'math', 'mi', 'mn', 'mo', 'ms', 'mtext', 'noembed', 'noframes', 'noscript', 'plaintext', 'script', 'style', 'svg', 'template', 'thead', 'title', 'video', 'xmp']);

    /* Tags that are safe for data: URIs */
    var DATA_URI_TAGS = null;
    var DEFAULT_DATA_URI_TAGS = addToSet({}, ['audio', 'video', 'img', 'source', 'image', 'track']);

    /* Attributes safe for values like "javascript:" */
    var URI_SAFE_ATTRIBUTES = null;
    var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, ['alt', 'class', 'for', 'id', 'label', 'name', 'pattern', 'placeholder', 'role', 'summary', 'title', 'value', 'style', 'xmlns']);

    var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
    var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
    var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
    /* Document namespace */
    var NAMESPACE = HTML_NAMESPACE;
    var IS_EMPTY_INPUT = false;

    /* Parsing of strict XHTML documents */
    var PARSER_MEDIA_TYPE = void 0;
    var SUPPORTED_PARSER_MEDIA_TYPES = ['application/xhtml+xml', 'text/html'];
    var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
    var transformCaseFunc = void 0;

    /* Keep a reference to config to pass to hooks */
    var CONFIG = null;

    /* Ideally, do not touch anything below this line */
    /* ______________________________________________ */

    var formElement = document.createElement('form');

    /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */
    // eslint-disable-next-line complexity
    var _parseConfig = function _parseConfig(cfg) {
      if (CONFIG && CONFIG === cfg) {
        return;
      }

      /* Shield configuration object from tampering */
      if (!cfg || (typeof cfg === 'undefined' ? 'undefined' : _typeof(cfg)) !== 'object') {
        cfg = {};
      }

      /* Shield configuration object from prototype pollution */
      cfg = clone(cfg);

      /* Set configuration parameters */
      ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS) : DEFAULT_ALLOWED_TAGS;
      ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR) : DEFAULT_ALLOWED_ATTR;
      URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), cfg.ADD_URI_SAFE_ATTR) : DEFAULT_URI_SAFE_ATTRIBUTES;
      DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), cfg.ADD_DATA_URI_TAGS) : DEFAULT_DATA_URI_TAGS;
      FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS) : DEFAULT_FORBID_CONTENTS;
      FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS) : {};
      FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR) : {};
      USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
      ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
      ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
      ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
      SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
      WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
      RETURN_DOM = cfg.RETURN_DOM || false; // Default false
      RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
      RETURN_DOM_IMPORT = cfg.RETURN_DOM_IMPORT !== false; // Default true
      RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
      FORCE_BODY = cfg.FORCE_BODY || false; // Default false
      SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
      KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
      IN_PLACE = cfg.IN_PLACE || false; // Default false
      IS_ALLOWED_URI$$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$$1;
      NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;

      PARSER_MEDIA_TYPE =
      // eslint-disable-next-line unicorn/prefer-includes
      SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;

      // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
      transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? function (x) {
        return x;
      } : stringToLowerCase;

      if (SAFE_FOR_TEMPLATES) {
        ALLOW_DATA_ATTR = false;
      }

      if (RETURN_DOM_FRAGMENT) {
        RETURN_DOM = true;
      }

      /* Parse profile info */
      if (USE_PROFILES) {
        ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray$1(text)));
        ALLOWED_ATTR = [];
        if (USE_PROFILES.html === true) {
          addToSet(ALLOWED_TAGS, html);
          addToSet(ALLOWED_ATTR, html$1);
        }

        if (USE_PROFILES.svg === true) {
          addToSet(ALLOWED_TAGS, svg);
          addToSet(ALLOWED_ATTR, svg$1);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.svgFilters === true) {
          addToSet(ALLOWED_TAGS, svgFilters);
          addToSet(ALLOWED_ATTR, svg$1);
          addToSet(ALLOWED_ATTR, xml);
        }

        if (USE_PROFILES.mathMl === true) {
          addToSet(ALLOWED_TAGS, mathMl);
          addToSet(ALLOWED_ATTR, mathMl$1);
          addToSet(ALLOWED_ATTR, xml);
        }
      }

      /* Merge configuration parameters */
      if (cfg.ADD_TAGS) {
        if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) {
          ALLOWED_TAGS = clone(ALLOWED_TAGS);
        }

        addToSet(ALLOWED_TAGS, cfg.ADD_TAGS);
      }

      if (cfg.ADD_ATTR) {
        if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) {
          ALLOWED_ATTR = clone(ALLOWED_ATTR);
        }

        addToSet(ALLOWED_ATTR, cfg.ADD_ATTR);
      }

      if (cfg.ADD_URI_SAFE_ATTR) {
        addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR);
      }

      if (cfg.FORBID_CONTENTS) {
        if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) {
          FORBID_CONTENTS = clone(FORBID_CONTENTS);
        }

        addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS);
      }

      /* Add #text in case KEEP_CONTENT is set to true */
      if (KEEP_CONTENT) {
        ALLOWED_TAGS['#text'] = true;
      }

      /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */
      if (WHOLE_DOCUMENT) {
        addToSet(ALLOWED_TAGS, ['html', 'head', 'body']);
      }

      /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */
      if (ALLOWED_TAGS.table) {
        addToSet(ALLOWED_TAGS, ['tbody']);
        delete FORBID_TAGS.tbody;
      }

      // Prevent further manipulation of configuration.
      // Not available in IE8, Safari 5, etc.
      if (freeze) {
        freeze(cfg);
      }

      CONFIG = cfg;
    };

    var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, ['mi', 'mo', 'mn', 'ms', 'mtext']);

    var HTML_INTEGRATION_POINTS = addToSet({}, ['foreignobject', 'desc', 'title', 'annotation-xml']);

    /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */
    var ALL_SVG_TAGS = addToSet({}, svg);
    addToSet(ALL_SVG_TAGS, svgFilters);
    addToSet(ALL_SVG_TAGS, svgDisallowed);

    var ALL_MATHML_TAGS = addToSet({}, mathMl);
    addToSet(ALL_MATHML_TAGS, mathMlDisallowed);

    /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */
    var _checkValidNamespace = function _checkValidNamespace(element) {
      var parent = getParentNode(element);

      // In JSDOM, if we're inside shadow DOM, then parentNode
      // can be null. We just simulate parent in this case.
      if (!parent || !parent.tagName) {
        parent = {
          namespaceURI: HTML_NAMESPACE,
          tagName: 'template'
        };
      }

      var tagName = stringToLowerCase(element.tagName);
      var parentTagName = stringToLowerCase(parent.tagName);

      if (element.namespaceURI === SVG_NAMESPACE) {
        // The only way to switch from HTML namespace to SVG
        // is via <svg>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'svg';
        }

        // The only way to switch from MathML to SVG is via
        // svg if parent is either <annotation-xml> or MathML
        // text integration points.
        if (parent.namespaceURI === MATHML_NAMESPACE) {
          return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
        }

        // We only allow elements that are defined in SVG
        // spec. All others are disallowed in SVG namespace.
        return Boolean(ALL_SVG_TAGS[tagName]);
      }

      if (element.namespaceURI === MATHML_NAMESPACE) {
        // The only way to switch from HTML namespace to MathML
        // is via <math>. If it happens via any other tag, then
        // it should be killed.
        if (parent.namespaceURI === HTML_NAMESPACE) {
          return tagName === 'math';
        }

        // The only way to switch from SVG to MathML is via
        // <math> and HTML integration points
        if (parent.namespaceURI === SVG_NAMESPACE) {
          return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
        }

        // We only allow elements that are defined in MathML
        // spec. All others are disallowed in MathML namespace.
        return Boolean(ALL_MATHML_TAGS[tagName]);
      }

      if (element.namespaceURI === HTML_NAMESPACE) {
        // The only way to switch from SVG to HTML is via
        // HTML integration points, and from MathML to HTML
        // is via MathML text integration points
        if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) {
          return false;
        }

        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erronously deleted from
        // HTML namespace.
        var commonSvgAndHTMLElements = addToSet({}, ['title', 'style', 'font', 'a', 'script']);

        // We disallow tags that are specific for MathML
        // or SVG and should never appear in HTML namespace
        return !ALL_MATHML_TAGS[tagName] && (commonSvgAndHTMLElements[tagName] || !ALL_SVG_TAGS[tagName]);
      }

      // The code should never reach this place (this means
      // that the element somehow got namespace that is not
      // HTML, SVG or MathML). Return false just in case.
      return false;
    };

    /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */
    var _forceRemove = function _forceRemove(node) {
      arrayPush(DOMPurify.removed, { element: node });
      try {
        // eslint-disable-next-line unicorn/prefer-dom-node-remove
        node.parentNode.removeChild(node);
      } catch (_) {
        try {
          node.outerHTML = emptyHTML;
        } catch (_) {
          node.remove();
        }
      }
    };

    /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */
    var _removeAttribute = function _removeAttribute(name, node) {
      try {
        arrayPush(DOMPurify.removed, {
          attribute: node.getAttributeNode(name),
          from: node
        });
      } catch (_) {
        arrayPush(DOMPurify.removed, {
          attribute: null,
          from: node
        });
      }

      node.removeAttribute(name);

      // We void attribute values for unremovable "is"" attributes
      if (name === 'is' && !ALLOWED_ATTR[name]) {
        if (RETURN_DOM || RETURN_DOM_FRAGMENT) {
          try {
            _forceRemove(node);
          } catch (_) {}
        } else {
          try {
            node.setAttribute(name, '');
          } catch (_) {}
        }
      }
    };

    /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */
    var _initDocument = function _initDocument(dirty) {
      /* Create a HTML document */
      var doc = void 0;
      var leadingWhitespace = void 0;

      if (FORCE_BODY) {
        dirty = '<remove></remove>' + dirty;
      } else {
        /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */
        var matches = stringMatch(dirty, /^[\r\n\t ]+/);
        leadingWhitespace = matches && matches[0];
      }

      if (PARSER_MEDIA_TYPE === 'application/xhtml+xml') {
        // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
        dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
      }

      var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
      /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */
      if (NAMESPACE === HTML_NAMESPACE) {
        try {
          doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
        } catch (_) {}
      }

      /* Use createHTMLDocument in case DOMParser is not available */
      if (!doc || !doc.documentElement) {
        doc = implementation.createDocument(NAMESPACE, 'template', null);
        try {
          doc.documentElement.innerHTML = IS_EMPTY_INPUT ? '' : dirtyPayload;
        } catch (_) {
          // Syntax error if dirtyPayload is invalid xml
        }
      }

      var body = doc.body || doc.documentElement;

      if (dirty && leadingWhitespace) {
        body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
      }

      /* Work on whole document or just its body */
      if (NAMESPACE === HTML_NAMESPACE) {
        return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
      }

      return WHOLE_DOCUMENT ? doc.documentElement : body;
    };

    /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */
    var _createIterator = function _createIterator(root) {
      return createNodeIterator.call(root.ownerDocument || root, root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT, null, false);
    };

    /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */
    var _isClobbered = function _isClobbered(elm) {
      if (elm instanceof Text || elm instanceof Comment) {
        return false;
      }

      if (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function') {
        return true;
      }

      return false;
    };

    /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */
    var _isNode = function _isNode(object) {
      return (typeof Node === 'undefined' ? 'undefined' : _typeof(Node)) === 'object' ? object instanceof Node : object && (typeof object === 'undefined' ? 'undefined' : _typeof(object)) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
    };

    /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */
    var _executeHook = function _executeHook(entryPoint, currentNode, data) {
      if (!hooks[entryPoint]) {
        return;
      }

      arrayForEach(hooks[entryPoint], function (hook) {
        hook.call(DOMPurify, currentNode, data, CONFIG);
      });
    };

    /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */
    var _sanitizeElements = function _sanitizeElements(currentNode) {
      var content = void 0;

      /* Execute a hook if present */
      _executeHook('beforeSanitizeElements', currentNode, null);

      /* Check if element is clobbered or can clobber */
      if (_isClobbered(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Check if tagname contains Unicode */
      if (stringMatch(currentNode.nodeName, /[\u0080-\uFFFF]/)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Now let's check the element's type and name */
      var tagName = transformCaseFunc(currentNode.nodeName);

      /* Execute a hook if present */
      _executeHook('uponSanitizeElement', currentNode, {
        tagName: tagName,
        allowedTags: ALLOWED_TAGS
      });

      /* Detect mXSS attempts abusing namespace confusion */
      if (!_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Mitigate a problem with templates inside select */
      if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Remove element if anything forbids its presence */
      if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
        /* Keep content except for bad-listed elements */
        if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
          var parentNode = getParentNode(currentNode) || currentNode.parentNode;
          var childNodes = getChildNodes(currentNode) || currentNode.childNodes;

          if (childNodes && parentNode) {
            var childCount = childNodes.length;

            for (var i = childCount - 1; i >= 0; --i) {
              parentNode.insertBefore(cloneNode(childNodes[i], true), getNextSibling(currentNode));
            }
          }
        }

        _forceRemove(currentNode);
        return true;
      }

      /* Check whether element has a valid namespace */
      if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
        _forceRemove(currentNode);
        return true;
      }

      if ((tagName === 'noscript' || tagName === 'noembed') && regExpTest(/<\/no(script|embed)/i, currentNode.innerHTML)) {
        _forceRemove(currentNode);
        return true;
      }

      /* Sanitize element content to be template-safe */
      if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
        /* Get the element's text content */
        content = currentNode.textContent;
        content = stringReplace(content, MUSTACHE_EXPR$$1, ' ');
        content = stringReplace(content, ERB_EXPR$$1, ' ');
        if (currentNode.textContent !== content) {
          arrayPush(DOMPurify.removed, { element: currentNode.cloneNode() });
          currentNode.textContent = content;
        }
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeElements', currentNode, null);

      return false;
    };

    /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */
    // eslint-disable-next-line complexity
    var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
      /* Make sure attribute cannot clobber */
      if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) {
        return false;
      }

      /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */
      if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$$1, lcName)) ; else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$$1, lcName)) ; else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
        return false;

        /* Check value is safe. First, is attr inert? If so, is safe */
      } else if (URI_SAFE_ATTRIBUTES[lcName]) ; else if (regExpTest(IS_ALLOWED_URI$$1, stringReplace(value, ATTR_WHITESPACE$$1, ''))) ; else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ; else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$$1, stringReplace(value, ATTR_WHITESPACE$$1, ''))) ; else if (!value) ; else {
        return false;
      }

      return true;
    };

    /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */
    var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
      var attr = void 0;
      var value = void 0;
      var lcName = void 0;
      var l = void 0;
      /* Execute a hook if present */
      _executeHook('beforeSanitizeAttributes', currentNode, null);

      var attributes = currentNode.attributes;

      /* Check if we have attributes; if not we might have a text node */

      if (!attributes) {
        return;
      }

      var hookEvent = {
        attrName: '',
        attrValue: '',
        keepAttr: true,
        allowedAttributes: ALLOWED_ATTR
      };
      l = attributes.length;

      /* Go backwards over all attributes; safely remove bad ones */
      while (l--) {
        attr = attributes[l];
        var _attr = attr,
            name = _attr.name,
            namespaceURI = _attr.namespaceURI;

        value = stringTrim(attr.value);
        lcName = transformCaseFunc(name);

        /* Execute a hook if present */
        hookEvent.attrName = lcName;
        hookEvent.attrValue = value;
        hookEvent.keepAttr = true;
        hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
        _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
        value = hookEvent.attrValue;
        /* Did the hooks approve of the attribute? */
        if (hookEvent.forceKeepAttr) {
          continue;
        }

        /* Remove attribute */
        _removeAttribute(name, currentNode);

        /* Did the hooks approve of the attribute? */
        if (!hookEvent.keepAttr) {
          continue;
        }

        /* Work around a security issue in jQuery 3.0 */
        if (regExpTest(/\/>/i, value)) {
          _removeAttribute(name, currentNode);
          continue;
        }

        /* Sanitize attribute content to be template-safe */
        if (SAFE_FOR_TEMPLATES) {
          value = stringReplace(value, MUSTACHE_EXPR$$1, ' ');
          value = stringReplace(value, ERB_EXPR$$1, ' ');
        }

        /* Is `value` valid for this attribute? */
        var lcTag = transformCaseFunc(currentNode.nodeName);
        if (!_isValidAttribute(lcTag, lcName, value)) {
          continue;
        }

        /* Handle invalid data-* attribute set by try-catching it */
        try {
          if (namespaceURI) {
            currentNode.setAttributeNS(namespaceURI, name, value);
          } else {
            /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */
            currentNode.setAttribute(name, value);
          }

          arrayPop(DOMPurify.removed);
        } catch (_) {}
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeAttributes', currentNode, null);
    };

    /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */
    var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
      var shadowNode = void 0;
      var shadowIterator = _createIterator(fragment);

      /* Execute a hook if present */
      _executeHook('beforeSanitizeShadowDOM', fragment, null);

      while (shadowNode = shadowIterator.nextNode()) {
        /* Execute a hook if present */
        _executeHook('uponSanitizeShadowNode', shadowNode, null);

        /* Sanitize tags and elements */
        if (_sanitizeElements(shadowNode)) {
          continue;
        }

        /* Deep shadow DOM detected */
        if (shadowNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(shadowNode.content);
        }

        /* Check attributes, sanitize if necessary */
        _sanitizeAttributes(shadowNode);
      }

      /* Execute a hook if present */
      _executeHook('afterSanitizeShadowDOM', fragment, null);
    };

    /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */
    // eslint-disable-next-line complexity
    DOMPurify.sanitize = function (dirty, cfg) {
      var body = void 0;
      var importedNode = void 0;
      var currentNode = void 0;
      var oldNode = void 0;
      var returnNode = void 0;
      /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */
      IS_EMPTY_INPUT = !dirty;
      if (IS_EMPTY_INPUT) {
        dirty = '<!-->';
      }

      /* Stringify, in case dirty is an object */
      if (typeof dirty !== 'string' && !_isNode(dirty)) {
        // eslint-disable-next-line no-negated-condition
        if (typeof dirty.toString !== 'function') {
          throw typeErrorCreate('toString is not a function');
        } else {
          dirty = dirty.toString();
          if (typeof dirty !== 'string') {
            throw typeErrorCreate('dirty is not a string, aborting');
          }
        }
      }

      /* Check we can run. Otherwise fall back or ignore */
      if (!DOMPurify.isSupported) {
        if (_typeof(window.toStaticHTML) === 'object' || typeof window.toStaticHTML === 'function') {
          if (typeof dirty === 'string') {
            return window.toStaticHTML(dirty);
          }

          if (_isNode(dirty)) {
            return window.toStaticHTML(dirty.outerHTML);
          }
        }

        return dirty;
      }

      /* Assign config vars */
      if (!SET_CONFIG) {
        _parseConfig(cfg);
      }

      /* Clean up removed elements */
      DOMPurify.removed = [];

      /* Check if dirty is correctly typed for IN_PLACE */
      if (typeof dirty === 'string') {
        IN_PLACE = false;
      }

      if (IN_PLACE) ; else if (dirty instanceof Node) {
        /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */
        body = _initDocument('<!---->');
        importedNode = body.ownerDocument.importNode(dirty, true);
        if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') {
          /* Node is already a body, use as is */
          body = importedNode;
        } else if (importedNode.nodeName === 'HTML') {
          body = importedNode;
        } else {
          // eslint-disable-next-line unicorn/prefer-dom-node-append
          body.appendChild(importedNode);
        }
      } else {
        /* Exit directly if we have nothing to do */
        if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT &&
        // eslint-disable-next-line unicorn/prefer-includes
        dirty.indexOf('<') === -1) {
          return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
        }

        /* Initialize the document to work on */
        body = _initDocument(dirty);

        /* Check we have a DOM node from the data */
        if (!body) {
          return RETURN_DOM ? null : emptyHTML;
        }
      }

      /* Remove first element node (ours) if FORCE_BODY is set */
      if (body && FORCE_BODY) {
        _forceRemove(body.firstChild);
      }

      /* Get node iterator */
      var nodeIterator = _createIterator(IN_PLACE ? dirty : body);

      /* Now start iterating over the created document */
      while (currentNode = nodeIterator.nextNode()) {
        /* Fix IE's strange behavior with manipulated textNodes #89 */
        if (currentNode.nodeType === 3 && currentNode === oldNode) {
          continue;
        }

        /* Sanitize tags and elements */
        if (_sanitizeElements(currentNode)) {
          continue;
        }

        /* Shadow DOM detected, sanitize it */
        if (currentNode.content instanceof DocumentFragment) {
          _sanitizeShadowDOM(currentNode.content);
        }

        /* Check attributes, sanitize if necessary */
        _sanitizeAttributes(currentNode);

        oldNode = currentNode;
      }

      oldNode = null;

      /* If we sanitized `dirty` in-place, return it. */
      if (IN_PLACE) {
        return dirty;
      }

      /* Return sanitized string or DOM */
      if (RETURN_DOM) {
        if (RETURN_DOM_FRAGMENT) {
          returnNode = createDocumentFragment.call(body.ownerDocument);

          while (body.firstChild) {
            // eslint-disable-next-line unicorn/prefer-dom-node-append
            returnNode.appendChild(body.firstChild);
          }
        } else {
          returnNode = body;
        }

        if (RETURN_DOM_IMPORT) {
          /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */
          returnNode = importNode.call(originalDocument, returnNode, true);
        }

        return returnNode;
      }

      var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;

      /* Sanitize final string template-safe */
      if (SAFE_FOR_TEMPLATES) {
        serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$$1, ' ');
        serializedHTML = stringReplace(serializedHTML, ERB_EXPR$$1, ' ');
      }

      return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
    };

    /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */
    DOMPurify.setConfig = function (cfg) {
      _parseConfig(cfg);
      SET_CONFIG = true;
    };

    /**
     * Public method to remove the configuration
     * clearConfig
     *
     */
    DOMPurify.clearConfig = function () {
      CONFIG = null;
      SET_CONFIG = false;
    };

    /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */
    DOMPurify.isValidAttribute = function (tag, attr, value) {
      /* Initialize shared config vars if necessary. */
      if (!CONFIG) {
        _parseConfig({});
      }

      var lcTag = transformCaseFunc(tag);
      var lcName = transformCaseFunc(attr);
      return _isValidAttribute(lcTag, lcName, value);
    };

    /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */
    DOMPurify.addHook = function (entryPoint, hookFunction) {
      if (typeof hookFunction !== 'function') {
        return;
      }

      hooks[entryPoint] = hooks[entryPoint] || [];
      arrayPush(hooks[entryPoint], hookFunction);
    };

    /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     */
    DOMPurify.removeHook = function (entryPoint) {
      if (hooks[entryPoint]) {
        arrayPop(hooks[entryPoint]);
      }
    };

    /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */
    DOMPurify.removeHooks = function (entryPoint) {
      if (hooks[entryPoint]) {
        hooks[entryPoint] = [];
      }
    };

    /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */
    DOMPurify.removeAllHooks = function () {
      hooks = {};
    };

    return DOMPurify;
  }

  var purify = createDOMPurify();

  return purify;

}));
//# sourceMappingURL=purify.js.map


/***/ }),
/* 2850 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BlockMapBuilder = __webpack_require__(337);

var CharacterMetadata = __webpack_require__(133);

var ContentBlock = __webpack_require__(241);

var ContentBlockNode = __webpack_require__(134);

var DraftModifier = __webpack_require__(105);

var EditorState = __webpack_require__(62);

var generateRandomKey = __webpack_require__(164);

var gkx = __webpack_require__(203);

var Immutable = __webpack_require__(46);

var moveBlockInContentState = __webpack_require__(2917);

var experimentalTreeDataSupport = gkx('draft_tree_data_support');
var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
var List = Immutable.List,
    Repeat = Immutable.Repeat;
var AtomicBlockUtils = {
  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    var afterRemoval = DraftModifier.removeRange(contentState, selectionState, 'backward');
    var targetSelection = afterRemoval.getSelectionAfter();
    var afterSplit = DraftModifier.splitBlock(afterRemoval, targetSelection);
    var insertionTarget = afterSplit.getSelectionAfter();
    var asAtomicBlock = DraftModifier.setBlockType(afterSplit, insertionTarget, 'atomic');
    var charData = CharacterMetadata.create({
      entity: entityKey
    });
    var atomicBlockConfig = {
      key: generateRandomKey(),
      type: 'atomic',
      text: character,
      characterList: List(Repeat(charData, character.length))
    };
    var atomicDividerBlockConfig = {
      key: generateRandomKey(),
      type: 'unstyled'
    };

    if (experimentalTreeDataSupport) {
      atomicBlockConfig = _objectSpread({}, atomicBlockConfig, {
        nextSibling: atomicDividerBlockConfig.key
      });
      atomicDividerBlockConfig = _objectSpread({}, atomicDividerBlockConfig, {
        prevSibling: atomicBlockConfig.key
      });
    }

    var fragmentArray = [new ContentBlockRecord(atomicBlockConfig), new ContentBlockRecord(atomicDividerBlockConfig)];
    var fragment = BlockMapBuilder.createFromArray(fragmentArray);
    var withAtomicBlock = DraftModifier.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);
    var newContent = withAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });
    return EditorState.push(editorState, newContent, 'insert-fragment');
  },
  moveAtomicBlock: function moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode) {
    var contentState = editorState.getCurrentContent();
    var selectionState = editorState.getSelection();
    var withMovedAtomicBlock;

    if (insertionMode === 'before' || insertionMode === 'after') {
      var targetBlock = contentState.getBlockForKey(insertionMode === 'before' ? targetRange.getStartKey() : targetRange.getEndKey());
      withMovedAtomicBlock = moveBlockInContentState(contentState, atomicBlock, targetBlock, insertionMode);
    } else {
      var afterRemoval = DraftModifier.removeRange(contentState, targetRange, 'backward');
      var selectionAfterRemoval = afterRemoval.getSelectionAfter();

      var _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());

      if (selectionAfterRemoval.getStartOffset() === 0) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'before');
      } else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) {
        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'after');
      } else {
        var afterSplit = DraftModifier.splitBlock(afterRemoval, selectionAfterRemoval);
        var selectionAfterSplit = afterSplit.getSelectionAfter();

        var _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());

        withMovedAtomicBlock = moveBlockInContentState(afterSplit, atomicBlock, _targetBlock2, 'before');
      }
    }

    var newContent = withMovedAtomicBlock.merge({
      selectionBefore: selectionState,
      selectionAfter: withMovedAtomicBlock.getSelectionAfter().set('hasFocus', true)
    });
    return EditorState.push(editorState, newContent, 'move-block');
  }
};
module.exports = AtomicBlockUtils;

/***/ }),
/* 2851 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var findRangesImmutable = __webpack_require__(339);

var getOwnObjectValues = __webpack_require__(1179);

var Immutable = __webpack_require__(46);

var List = Immutable.List,
    Repeat = Immutable.Repeat,
    Record = Immutable.Record;

var returnTrue = function returnTrue() {
  return true;
};

var defaultLeafRange = {
  start: null,
  end: null
};
var LeafRange = Record(defaultLeafRange);
var defaultDecoratorRange = {
  start: null,
  end: null,
  decoratorKey: null,
  leaves: null
};
var DecoratorRange = Record(defaultDecoratorRange);
var BlockTree = {
  /**
   * Generate a block tree for a given ContentBlock/decorator pair.
   */
  generate: function generate(contentState, block, decorator) {
    var textLength = block.getLength();

    if (!textLength) {
      return List.of(new DecoratorRange({
        start: 0,
        end: 0,
        decoratorKey: null,
        leaves: List.of(new LeafRange({
          start: 0,
          end: 0
        }))
      }));
    }

    var leafSets = [];
    var decorations = decorator ? decorator.getDecorations(block, contentState) : List(Repeat(null, textLength));
    var chars = block.getCharacterList();
    findRangesImmutable(decorations, areEqual, returnTrue, function (start, end) {
      leafSets.push(new DecoratorRange({
        start: start,
        end: end,
        decoratorKey: decorations.get(start),
        leaves: generateLeaves(chars.slice(start, end).toList(), start)
      }));
    });
    return List(leafSets);
  },
  fromJS: function fromJS(_ref) {
    var leaves = _ref.leaves,
        other = _objectWithoutPropertiesLoose(_ref, ["leaves"]);

    return new DecoratorRange(_objectSpread({}, other, {
      leaves: leaves != null ? List(Array.isArray(leaves) ? leaves : getOwnObjectValues(leaves)).map(function (leaf) {
        return LeafRange(leaf);
      }) : null
    }));
  }
};
/**
 * Generate LeafRange records for a given character list.
 */

function generateLeaves(characters, offset) {
  var leaves = [];
  var inlineStyles = characters.map(function (c) {
    return c.getStyle();
  }).toList();
  findRangesImmutable(inlineStyles, areEqual, returnTrue, function (start, end) {
    leaves.push(new LeafRange({
      start: start + offset,
      end: end + offset
    }));
  });
  return List(leaves);
}

function areEqual(a, b) {
  return a === b;
}

module.exports = BlockTree;

/***/ }),
/* 2852 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Immutable = __webpack_require__(46);

var List = Immutable.List;
var DELIMITER = '.';
/**
 * A CompositeDraftDecorator traverses through a list of DraftDecorator
 * instances to identify sections of a ContentBlock that should be rendered
 * in a "decorated" manner. For example, hashtags, mentions, and links may
 * be intended to stand out visually, be rendered as anchors, etc.
 *
 * The list of decorators supplied to the constructor will be used in the
 * order they are provided. This allows the caller to specify a priority for
 * string matching, in case of match collisions among decorators.
 *
 * For instance, I may have a link with a `#` in its text. Though this section
 * of text may match our hashtag decorator, it should not be treated as a
 * hashtag. I should therefore list my link DraftDecorator
 * before my hashtag DraftDecorator when constructing this composite
 * decorator instance.
 *
 * Thus, when a collision like this is encountered, the earlier match is
 * preserved and the new match is discarded.
 */

var CompositeDraftDecorator = /*#__PURE__*/function () {
  function CompositeDraftDecorator(decorators) {
    _defineProperty(this, "_decorators", void 0);

    // Copy the decorator array, since we use this array order to determine
    // precedence of decoration matching. If the array is mutated externally,
    // we don't want to be affected here.
    this._decorators = decorators.slice();
  }

  var _proto = CompositeDraftDecorator.prototype;

  _proto.getDecorations = function getDecorations(block, contentState) {
    var decorations = Array(block.getText().length).fill(null);

    this._decorators.forEach(function (
    /*object*/
    decorator,
    /*number*/
    ii) {
      var counter = 0;
      var strategy = decorator.strategy;

      var callback = function callback(
      /*number*/
      start,
      /*number*/
      end) {
        // Find out if any of our matching range is already occupied
        // by another decorator. If so, discard the match. Otherwise, store
        // the component key for rendering.
        if (canOccupySlice(decorations, start, end)) {
          occupySlice(decorations, start, end, ii + DELIMITER + counter);
          counter++;
        }
      };

      strategy(block, callback, contentState);
    });

    return List(decorations);
  };

  _proto.getComponentForKey = function getComponentForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].component;
  };

  _proto.getPropsForKey = function getPropsForKey(key) {
    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
    return this._decorators[componentKey].props;
  };

  return CompositeDraftDecorator;
}();
/**
 * Determine whether we can occupy the specified slice of the decorations
 * array.
 */


function canOccupySlice(decorations, start, end) {
  for (var ii = start; ii < end; ii++) {
    if (decorations[ii] != null) {
      return false;
    }
  }

  return true;
}
/**
 * Splice the specified component into our decoration array at the desired
 * range.
 */


function occupySlice(targetArr, start, end, componentKey) {
  for (var ii = start; ii < end; ii++) {
    targetArr[ii] = componentKey;
  }
}

module.exports = CompositeDraftDecorator;

/***/ }),
/* 2853 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var CharacterMetadata = __webpack_require__(133);

var _require = __webpack_require__(46),
    Map = _require.Map;

var ContentStateInlineStyle = {
  add: function add(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
  },
  remove: function remove(contentState, selectionState, inlineStyle) {
    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
  }
};

function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart;
    var sliceEnd;

    if (startKey === endKey) {
      sliceStart = startOffset;
      sliceEnd = endOffset;
    } else {
      sliceStart = blockKey === startKey ? startOffset : 0;
      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    }

    var chars = block.getCharacterList();
    var current;

    while (sliceStart < sliceEnd) {
      current = chars.get(sliceStart);
      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata.applyStyle(current, inlineStyle) : CharacterMetadata.removeStyle(current, inlineStyle));
      sliceStart++;
    }

    return block.set('characterList', chars);
  });
  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = ContentStateInlineStyle;

/***/ }),
/* 2854 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UserAgent = __webpack_require__(106);

var findAncestorOffsetKey = __webpack_require__(426);

var getWindowForNode = __webpack_require__(1185);

var Immutable = __webpack_require__(46);

var invariant = __webpack_require__(48);

var nullthrows = __webpack_require__(107);

var Map = Immutable.Map;
// Heavily based on Prosemirror's DOMObserver https://github.com/ProseMirror/prosemirror-view/blob/master/src/domobserver.js
var DOM_OBSERVER_OPTIONS = {
  subtree: true,
  characterData: true,
  childList: true,
  characterDataOldValue: false,
  attributes: false
}; // IE11 has very broken mutation observers, so we also listen to DOMCharacterDataModified

var USE_CHAR_DATA = UserAgent.isBrowser('IE <= 11');

var DOMObserver = /*#__PURE__*/function () {
  function DOMObserver(container) {
    var _this = this;

    _defineProperty(this, "observer", void 0);

    _defineProperty(this, "container", void 0);

    _defineProperty(this, "mutations", void 0);

    _defineProperty(this, "onCharData", void 0);

    this.container = container;
    this.mutations = Map();
    var containerWindow = getWindowForNode(container);

    if (containerWindow.MutationObserver && !USE_CHAR_DATA) {
      this.observer = new containerWindow.MutationObserver(function (mutations) {
        return _this.registerMutations(mutations);
      });
    } else {
      this.onCharData = function (e) {
        !(e.target instanceof Node) ?  false ? invariant(false, 'Expected target to be an instance of Node') : invariant(false) : void 0;

        _this.registerMutation({
          type: 'characterData',
          target: e.target
        });
      };
    }
  }

  var _proto = DOMObserver.prototype;

  _proto.start = function start() {
    if (this.observer) {
      this.observer.observe(this.container, DOM_OBSERVER_OPTIONS);
    } else {
      /* $FlowFixMe[incompatible-call] (>=0.68.0 site=www,mobile) This event
       * type is not defined by Flow's standard library */
      this.container.addEventListener('DOMCharacterDataModified', this.onCharData);
    }
  };

  _proto.stopAndFlushMutations = function stopAndFlushMutations() {
    var observer = this.observer;

    if (observer) {
      this.registerMutations(observer.takeRecords());
      observer.disconnect();
    } else {
      /* $FlowFixMe[incompatible-call] (>=0.68.0 site=www,mobile) This event
       * type is not defined by Flow's standard library */
      this.container.removeEventListener('DOMCharacterDataModified', this.onCharData);
    }

    var mutations = this.mutations;
    this.mutations = Map();
    return mutations;
  };

  _proto.registerMutations = function registerMutations(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      this.registerMutation(mutations[i]);
    }
  };

  _proto.getMutationTextContent = function getMutationTextContent(mutation) {
    var type = mutation.type,
        target = mutation.target,
        removedNodes = mutation.removedNodes;

    if (type === 'characterData') {
      // When `textContent` is '', there is a race condition that makes
      // getting the offsetKey from the target not possible.
      // These events are also followed by a `childList`, which is the one
      // we are able to retrieve the offsetKey and apply the '' text.
      if (target.textContent !== '') {
        // IE 11 considers the enter keypress that concludes the composition
        // as an input char. This strips that newline character so the draft
        // state does not receive spurious newlines.
        if (USE_CHAR_DATA) {
          return target.textContent.replace('\n', '');
        }

        return target.textContent;
      }
    } else if (type === 'childList') {
      if (removedNodes && removedNodes.length) {
        // `characterData` events won't happen or are ignored when
        // removing the last character of a leaf node, what happens
        // instead is a `childList` event with a `removedNodes` array.
        // For this case the textContent should be '' and
        // `DraftModifier.replaceText` will make sure the content is
        // updated properly.
        return '';
      } else if (target.textContent !== '') {
        // Typing Chinese in an empty block in MS Edge results in a
        // `childList` event with non-empty textContent.
        // See https://github.com/facebook/draft-js/issues/2082
        return target.textContent;
      }
    }

    return null;
  };

  _proto.registerMutation = function registerMutation(mutation) {
    var textContent = this.getMutationTextContent(mutation);

    if (textContent != null) {
      var offsetKey = nullthrows(findAncestorOffsetKey(mutation.target));
      this.mutations = this.mutations.set(offsetKey, textContent);
    }
  };

  return DOMObserver;
}();

module.exports = DOMObserver;

/***/ }),
/* 2855 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @preventMunge
 * @emails oncall+draft_js
 */


var _assign = __webpack_require__(121);

function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DefaultDraftBlockRenderMap = __webpack_require__(645);

var DefaultDraftInlineStyle = __webpack_require__(1161);

var DraftEditorCompositionHandler = __webpack_require__(2857);

var DraftEditorContents = __webpack_require__(2859);

var DraftEditorDragHandler = __webpack_require__(2862);

var DraftEditorEditHandler = __webpack_require__(2863);

var flushControlled = __webpack_require__(2864);

var DraftEditorPlaceholder = __webpack_require__(2866);

var DraftEffects = __webpack_require__(1164);

var EditorState = __webpack_require__(62);

var React = __webpack_require__(0);

var Scroll = __webpack_require__(649);

var Style = __webpack_require__(431);

var UserAgent = __webpack_require__(106);

var cx = __webpack_require__(244);

var generateRandomKey = __webpack_require__(164);

var getDefaultKeyBinding = __webpack_require__(1174);

var getScrollPosition = __webpack_require__(433);

var gkx = __webpack_require__(203);

var invariant = __webpack_require__(48);

var isHTMLElement = __webpack_require__(340);

var nullthrows = __webpack_require__(107);

var isIE = UserAgent.isBrowser('IE'); // IE does not support the `input` event on contentEditable, so we can't
// observe spellcheck behavior.

var allowSpellCheck = !isIE; // Define a set of handler objects to correspond to each possible `mode`
// of editor behavior.

var handlerMap = {
  edit: DraftEditorEditHandler,
  composite: DraftEditorCompositionHandler,
  drag: DraftEditorDragHandler,
  cut: null,
  render: null
};
var didInitODS = false;

var UpdateDraftEditorFlags = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(UpdateDraftEditorFlags, _React$Component);

  function UpdateDraftEditorFlags() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = UpdateDraftEditorFlags.prototype;

  _proto.render = function render() {
    return null;
  };

  _proto.componentDidMount = function componentDidMount() {
    this._update();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this._update();
  };

  _proto._update = function _update() {
    var editor = this.props.editor;
    /**
     * Sometimes a render triggers a 'focus' or other event, and that will
     * schedule a second render pass.
     * In order to make sure the second render pass gets the latest editor
     * state, we update it here.
     * Example:
     * render #1
     * +
     * |
     * | cWU -> Nothing ... latestEditorState = STALE_STATE :(
     * |
     * | render -> this.props.editorState = FRESH_STATE
     * | +         *and* set latestEditorState = FRESH_STATE
     *   |
     * | |
     * | +--> triggers 'focus' event, calling 'handleFocus' with latestEditorState
     * |                                                +
     * |                                                |
     * +>cdU -> latestEditorState = FRESH_STATE         | the 'handleFocus' call schedules render #2
     *                                                  | with latestEditorState, which is FRESH_STATE
     *                                                  |
     * render #2 <--------------------------------------+
     * +
     * |
     * | cwU -> nothing updates
     * |
     * | render -> this.props.editorState = FRESH_STATE which was passed in above
     * |
     * +>cdU fires and resets latestEditorState = FRESH_STATE
     * ---
     * Note that if we don't set latestEditorState in 'render' in the above
     * diagram, then STALE_STATE gets passed to render #2.
     */

    editor._latestEditorState = this.props.editorState;
    /**
     * The reason we set this 'blockSelectEvents' flag is that  IE will fire a
     * 'selectionChange' event when we programmatically change the selection,
     * meaning it would trigger a new select event while we are in the middle
     * of updating.
     * We found that the 'selection.addRange' was what triggered the stray
     * selectionchange event in IE.
     * To be clear - we have not been able to reproduce specific bugs related
     * to this stray selection event, but have recorded logs that some
     * conditions do cause it to get bumped into during editOnSelect.
     */

    editor._blockSelectEvents = true;
  };

  return UpdateDraftEditorFlags;
}(React.Component);
/**
 * `DraftEditor` is the root editor component. It composes a `contentEditable`
 * div, and provides a wide variety of useful function props for managing the
 * state of the editor. See `DraftEditorProps` for details.
 */


var DraftEditor = /*#__PURE__*/function (_React$Component2) {
  _inheritsLoose(DraftEditor, _React$Component2);

  /**
   * Define proxies that can route events to the current handler.
   */
  function DraftEditor(props) {
    var _this;

    _this = _React$Component2.call(this, props) || this;

    _defineProperty(_assertThisInitialized(_this), "_blockSelectEvents", void 0);

    _defineProperty(_assertThisInitialized(_this), "_clipboard", void 0);

    _defineProperty(_assertThisInitialized(_this), "_handler", void 0);

    _defineProperty(_assertThisInitialized(_this), "_dragCount", void 0);

    _defineProperty(_assertThisInitialized(_this), "_internalDrag", void 0);

    _defineProperty(_assertThisInitialized(_this), "_editorKey", void 0);

    _defineProperty(_assertThisInitialized(_this), "_placeholderAccessibilityID", void 0);

    _defineProperty(_assertThisInitialized(_this), "_latestEditorState", void 0);

    _defineProperty(_assertThisInitialized(_this), "_latestCommittedEditorState", void 0);

    _defineProperty(_assertThisInitialized(_this), "_pendingStateFromBeforeInput", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onBeforeInput", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onBlur", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onCharacterData", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onCompositionEnd", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onCompositionStart", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onCopy", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onCut", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onDragEnd", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onDragOver", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onDragStart", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onDrop", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onInput", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onFocus", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onKeyDown", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onKeyPress", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onKeyUp", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onMouseDown", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onMouseUp", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onPaste", void 0);

    _defineProperty(_assertThisInitialized(_this), "_onSelect", void 0);

    _defineProperty(_assertThisInitialized(_this), "editor", void 0);

    _defineProperty(_assertThisInitialized(_this), "editorContainer", void 0);

    _defineProperty(_assertThisInitialized(_this), "focus", void 0);

    _defineProperty(_assertThisInitialized(_this), "blur", void 0);

    _defineProperty(_assertThisInitialized(_this), "setMode", void 0);

    _defineProperty(_assertThisInitialized(_this), "exitCurrentMode", void 0);

    _defineProperty(_assertThisInitialized(_this), "restoreEditorDOM", void 0);

    _defineProperty(_assertThisInitialized(_this), "setClipboard", void 0);

    _defineProperty(_assertThisInitialized(_this), "getClipboard", void 0);

    _defineProperty(_assertThisInitialized(_this), "getEditorKey", void 0);

    _defineProperty(_assertThisInitialized(_this), "update", void 0);

    _defineProperty(_assertThisInitialized(_this), "onDragEnter", void 0);

    _defineProperty(_assertThisInitialized(_this), "onDragLeave", void 0);

    _defineProperty(_assertThisInitialized(_this), "_handleEditorContainerRef", function (node) {
      _this.editorContainer = node; // Instead of having a direct ref on the child, we'll grab it here.
      // This is safe as long as the rendered structure is static (which it is).
      // This lets the child support ref={props.editorRef} without merging refs.

      _this.editor = node !== null ? node.firstChild : null;
    });

    _defineProperty(_assertThisInitialized(_this), "focus", function (scrollPosition) {
      var editorState = _this.props.editorState;
      var alreadyHasFocus = editorState.getSelection().getHasFocus();
      var editorNode = _this.editor;

      if (!editorNode) {
        // once in a while people call 'focus' in a setTimeout, and the node has
        // been deleted, so it can be null in that case.
        return;
      }

      var scrollParent = Style.getScrollParent(editorNode);

      var _ref = scrollPosition || getScrollPosition(scrollParent),
          x = _ref.x,
          y = _ref.y;

      !isHTMLElement(editorNode) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
      editorNode.focus(); // Restore scroll position

      if (scrollParent === window) {
        window.scrollTo(x, y);
      } else {
        Scroll.setTop(scrollParent, y);
      } // On Chrome and Safari, calling focus on contenteditable focuses the
      // cursor at the first character. This is something you don't expect when
      // you're clicking on an input element but not directly on a character.
      // Put the cursor back where it was before the blur.


      if (!alreadyHasFocus) {
        _this.update(EditorState.forceSelection(editorState, editorState.getSelection()));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "blur", function () {
      var editorNode = _this.editor;

      if (!editorNode) {
        return;
      }

      !isHTMLElement(editorNode) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
      editorNode.blur();
    });

    _defineProperty(_assertThisInitialized(_this), "setMode", function (mode) {
      var _this$props = _this.props,
          onPaste = _this$props.onPaste,
          onCut = _this$props.onCut,
          onCopy = _this$props.onCopy;

      var editHandler = _objectSpread({}, handlerMap.edit);

      if (onPaste) {
        /* $FlowFixMe[incompatible-type] (>=0.117.0 site=www,mobile) This comment
         * suppresses an error found when Flow v0.117 was deployed. To see the
         * error delete this comment and run Flow. */
        editHandler.onPaste = onPaste;
      }

      if (onCut) {
        editHandler.onCut = onCut;
      }

      if (onCopy) {
        editHandler.onCopy = onCopy;
      }

      var handler = _objectSpread({}, handlerMap, {
        edit: editHandler
      });

      _this._handler = handler[mode];
    });

    _defineProperty(_assertThisInitialized(_this), "exitCurrentMode", function () {
      _this.setMode('edit');
    });

    _defineProperty(_assertThisInitialized(_this), "restoreEditorDOM", function (scrollPosition) {
      _this.setState({
        contentsKey: _this.state.contentsKey + 1
      }, function () {
        _this.focus(scrollPosition);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "setClipboard", function (clipboard) {
      _this._clipboard = clipboard;
    });

    _defineProperty(_assertThisInitialized(_this), "getClipboard", function () {
      return _this._clipboard;
    });

    _defineProperty(_assertThisInitialized(_this), "update", function (editorState) {
      _this._latestEditorState = editorState;

      _this.props.onChange(editorState);
    });

    _defineProperty(_assertThisInitialized(_this), "onDragEnter", function () {
      _this._dragCount++;
    });

    _defineProperty(_assertThisInitialized(_this), "onDragLeave", function () {
      _this._dragCount--;

      if (_this._dragCount === 0) {
        _this.exitCurrentMode();
      }
    });

    _this._blockSelectEvents = false;
    _this._clipboard = null;
    _this._handler = null;
    _this._dragCount = 0;
    _this._editorKey = props.editorKey || generateRandomKey();
    _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
    _this._latestEditorState = props.editorState;
    _this._latestCommittedEditorState = props.editorState;
    _this._onBeforeInput = _this._buildHandler('onBeforeInput');
    _this._onBlur = _this._buildHandler('onBlur');
    _this._onCharacterData = _this._buildHandler('onCharacterData');
    _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
    _this._onCompositionStart = _this._buildHandler('onCompositionStart');
    _this._onCopy = _this._buildHandler('onCopy');
    _this._onCut = _this._buildHandler('onCut');
    _this._onDragEnd = _this._buildHandler('onDragEnd');
    _this._onDragOver = _this._buildHandler('onDragOver');
    _this._onDragStart = _this._buildHandler('onDragStart');
    _this._onDrop = _this._buildHandler('onDrop');
    _this._onInput = _this._buildHandler('onInput');
    _this._onFocus = _this._buildHandler('onFocus');
    _this._onKeyDown = _this._buildHandler('onKeyDown');
    _this._onKeyPress = _this._buildHandler('onKeyPress');
    _this._onKeyUp = _this._buildHandler('onKeyUp');
    _this._onMouseDown = _this._buildHandler('onMouseDown');
    _this._onMouseUp = _this._buildHandler('onMouseUp');
    _this._onPaste = _this._buildHandler('onPaste');
    _this._onSelect = _this._buildHandler('onSelect');

    _this.getEditorKey = function () {
      return _this._editorKey;
    };

    if (false) {
      ['onDownArrow', 'onEscape', 'onLeftArrow', 'onRightArrow', 'onTab', 'onUpArrow'].forEach(function (propName) {
        if (props.hasOwnProperty(propName)) {
          // eslint-disable-next-line no-console
          console.warn("Supplying an `".concat(propName, "` prop to `DraftEditor` has ") + 'been deprecated. If your handler needs access to the keyboard ' + 'event, supply a custom `keyBindingFn` prop that falls back to ' + 'the default one (eg. https://is.gd/wHKQ3W).');
        }
      });
    } // See `restoreEditorDOM()`.


    _this.state = {
      contentsKey: 0
    };
    return _this;
  }
  /**
   * Build a method that will pass the event to the specified handler method.
   * This allows us to look up the correct handler function for the current
   * editor mode, if any has been specified.
   */


  var _proto2 = DraftEditor.prototype;

  _proto2._buildHandler = function _buildHandler(eventName) {
    var _this2 = this;

    // Wrap event handlers in `flushControlled`. In sync mode, this is
    // effectively a no-op. In async mode, this ensures all updates scheduled
    // inside the handler are flushed before React yields to the browser.
    return function (e) {
      if (!_this2.props.readOnly) {
        var method = _this2._handler && _this2._handler[eventName];

        if (method) {
          if (flushControlled) {
            flushControlled(function () {
              return method(_this2, e);
            });
          } else {
            method(_this2, e);
          }
        }
      }
    };
  };

  _proto2._showPlaceholder = function _showPlaceholder() {
    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
  };

  _proto2._renderPlaceholder = function _renderPlaceholder() {
    if (this._showPlaceholder()) {
      var placeHolderProps = {
        text: nullthrows(this.props.placeholder),
        editorState: this.props.editorState,
        textAlignment: this.props.textAlignment,
        accessibilityID: this._placeholderAccessibilityID
      };
      /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This comment
       * suppresses an error found when Flow v0.112 was deployed. To see the
       * error delete this comment and run Flow. */

      return React.createElement(DraftEditorPlaceholder, placeHolderProps);
    }

    return null;
  }
  /**
   * returns ariaDescribedBy prop with '{{editor_id_placeholder}}' replaced with
   * the DOM id of the placeholder (if it exists)
   * @returns aria-describedby attribute value
   */
  ;

  _proto2._renderARIADescribedBy = function _renderARIADescribedBy() {
    var describedBy = this.props.ariaDescribedBy || '';
    var placeholderID = this._showPlaceholder() ? this._placeholderAccessibilityID : '';
    return describedBy.replace('{{editor_id_placeholder}}', placeholderID) || undefined;
  };

  _proto2.render = function render() {
    var _this$props2 = this.props,
        blockRenderMap = _this$props2.blockRenderMap,
        blockRendererFn = _this$props2.blockRendererFn,
        blockStyleFn = _this$props2.blockStyleFn,
        customStyleFn = _this$props2.customStyleFn,
        customStyleMap = _this$props2.customStyleMap,
        editorState = _this$props2.editorState,
        preventScroll = _this$props2.preventScroll,
        readOnly = _this$props2.readOnly,
        textAlignment = _this$props2.textAlignment,
        textDirectionality = _this$props2.textDirectionality;
    var rootClass = cx({
      'DraftEditor/root': true,
      'DraftEditor/alignLeft': textAlignment === 'left',
      'DraftEditor/alignRight': textAlignment === 'right',
      'DraftEditor/alignCenter': textAlignment === 'center'
    });
    var contentStyle = {
      outline: 'none',
      // fix parent-draggable Safari bug. #1326
      userSelect: 'text',
      WebkitUserSelect: 'text',
      whiteSpace: 'pre-wrap',
      wordWrap: 'break-word'
    }; // The aria-expanded and aria-haspopup properties should only be rendered
    // for a combobox.

    /* $FlowFixMe[prop-missing] (>=0.68.0 site=www,mobile) This comment
     * suppresses an error found when Flow v0.68 was deployed. To see the error
     * delete this comment and run Flow. */

    var ariaRole = this.props.role || 'textbox';
    var ariaExpanded = ariaRole === 'combobox' ? !!this.props.ariaExpanded : null;
    var editorContentsProps = {
      blockRenderMap: blockRenderMap,
      blockRendererFn: blockRendererFn,
      blockStyleFn: blockStyleFn,
      customStyleMap: _objectSpread({}, DefaultDraftInlineStyle, customStyleMap),
      customStyleFn: customStyleFn,
      editorKey: this._editorKey,
      editorState: editorState,
      preventScroll: preventScroll,
      textDirectionality: textDirectionality
    };
    return React.createElement("div", {
      className: rootClass
    }, this._renderPlaceholder(), React.createElement("div", {
      className: cx('DraftEditor/editorContainer'),
      ref: this._handleEditorContainerRef
    }, React.createElement("div", {
      "aria-activedescendant": readOnly ? null : this.props.ariaActiveDescendantID,
      "aria-autocomplete": readOnly ? null : this.props.ariaAutoComplete,
      "aria-controls": readOnly ? null : this.props.ariaControls,
      "aria-describedby": this._renderARIADescribedBy(),
      "aria-expanded": readOnly ? null : ariaExpanded,
      "aria-label": this.props.ariaLabel,
      "aria-labelledby": this.props.ariaLabelledBy,
      "aria-multiline": this.props.ariaMultiline,
      "aria-owns": readOnly ? null : this.props.ariaOwneeID,
      autoCapitalize: this.props.autoCapitalize,
      autoComplete: this.props.autoComplete,
      autoCorrect: this.props.autoCorrect,
      className: cx({
        // Chrome's built-in translation feature mutates the DOM in ways
        // that Draft doesn't expect (ex: adding <font> tags inside
        // DraftEditorLeaf spans) and causes problems. We add notranslate
        // here which makes its autotranslation skip over this subtree.
        notranslate: !readOnly,
        'public/DraftEditor/content': true
      }),
      contentEditable: !readOnly,
      "data-testid": this.props.webDriverTestID,
      onBeforeInput: this._onBeforeInput,
      onBlur: this._onBlur,
      onCompositionEnd: this._onCompositionEnd,
      onCompositionStart: this._onCompositionStart,
      onCopy: this._onCopy,
      onCut: this._onCut,
      onDragEnd: this._onDragEnd,
      onDragEnter: this.onDragEnter,
      onDragLeave: this.onDragLeave,
      onDragOver: this._onDragOver,
      onDragStart: this._onDragStart,
      onDrop: this._onDrop,
      onFocus: this._onFocus,
      onInput: this._onInput,
      onKeyDown: this._onKeyDown,
      onKeyPress: this._onKeyPress,
      onKeyUp: this._onKeyUp,
      onMouseUp: this._onMouseUp,
      onPaste: this._onPaste,
      onSelect: this._onSelect,
      ref: this.props.editorRef,
      role: readOnly ? null : ariaRole,
      spellCheck: allowSpellCheck && this.props.spellCheck,
      style: contentStyle,
      suppressContentEditableWarning: true,
      tabIndex: this.props.tabIndex
    }, React.createElement(UpdateDraftEditorFlags, {
      editor: this,
      editorState: editorState
    }), React.createElement(DraftEditorContents, _extends({}, editorContentsProps, {
      key: 'contents' + this.state.contentsKey
    })))));
  };

  _proto2.componentDidMount = function componentDidMount() {
    this._blockSelectEvents = false;

    if (!didInitODS && gkx('draft_ods_enabled')) {
      didInitODS = true;
      DraftEffects.initODS();
    }

    this.setMode('edit');
    /**
     * IE has a hardcoded "feature" that attempts to convert link text into
     * anchors in contentEditable DOM. This breaks the editor's expectations of
     * the DOM, and control is lost. Disable it to make IE behave.
     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
     * ie9-beta-minor-change-list.aspx
     */

    if (isIE) {
      // editor can be null after mounting
      // https://stackoverflow.com/questions/44074747/componentdidmount-called-before-ref-callback
      if (!this.editor) {
        global.execCommand('AutoUrlDetect', false, false);
      } else {
        this.editor.ownerDocument.execCommand('AutoUrlDetect', false, false);
      }
    }
  };

  _proto2.componentDidUpdate = function componentDidUpdate() {
    this._blockSelectEvents = false;
    this._latestEditorState = this.props.editorState;
    this._latestCommittedEditorState = this.props.editorState;
  }
  /**
   * Used via `this.focus()`.
   *
   * Force focus back onto the editor node.
   *
   * We attempt to preserve scroll position when focusing. You can also pass
   * a specified scroll position (for cases like `cut` behavior where it should
   * be restored to a known position).
   */
  ;

  return DraftEditor;
}(React.Component);

_defineProperty(DraftEditor, "defaultProps", {
  ariaDescribedBy: '{{editor_id_placeholder}}',
  blockRenderMap: DefaultDraftBlockRenderMap,
  blockRendererFn: function blockRendererFn() {
    return null;
  },
  blockStyleFn: function blockStyleFn() {
    return '';
  },
  keyBindingFn: getDefaultKeyBinding,
  readOnly: false,
  spellCheck: false,
  stripPastedStyles: false
});

module.exports = DraftEditor;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 2856 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This file is a fork of DraftEditorBlock.react.js and DraftEditorContents.react.js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */


var _assign = __webpack_require__(121);

function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DraftEditorNode = __webpack_require__(2865);

var DraftOffsetKey = __webpack_require__(182);

var React = __webpack_require__(0);

var Scroll = __webpack_require__(649);

var Style = __webpack_require__(431);

var getElementPosition = __webpack_require__(1197);

var getScrollPosition = __webpack_require__(433);

var getViewportDimensions = __webpack_require__(1198);

var Immutable = __webpack_require__(46);

var invariant = __webpack_require__(48);

var isHTMLElement = __webpack_require__(340);

var SCROLL_BUFFER = 10;
var List = Immutable.List; // we should harden up the bellow flow types to make them more strict

/**
 * Return whether a block overlaps with either edge of the `SelectionState`.
 */
var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
};
/**
 * We will use this helper to identify blocks that need to be wrapped but have siblings that
 * also share the same wrapper element, this way we can do the wrapping once the last sibling
 * is added.
 */


var shouldNotAddWrapperElement = function shouldNotAddWrapperElement(block, contentState) {
  var nextSiblingKey = block.getNextSiblingKey();
  return nextSiblingKey ? contentState.getBlockForKey(nextSiblingKey).getType() === block.getType() : false;
};

var applyWrapperElementToSiblings = function applyWrapperElementToSiblings(wrapperTemplate, Element, nodes) {
  var wrappedSiblings = []; // we check back until we find a sibling that does not have same wrapper

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = nodes.reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var sibling = _step.value;

      if (sibling.type !== Element) {
        break;
      }

      wrappedSiblings.push(sibling);
    } // we now should remove from acc the wrappedSiblings and add them back under same wrap

  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator["return"] != null) {
        _iterator["return"]();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  nodes.splice(nodes.indexOf(wrappedSiblings[0]), wrappedSiblings.length + 1);
  var childrenIs = wrappedSiblings.reverse();
  var key = childrenIs[0].key;
  nodes.push(React.cloneElement(wrapperTemplate, {
    key: "".concat(key, "-wrap"),
    'data-offset-key': DraftOffsetKey.encode(key, 0, 0)
  }, childrenIs));
  return nodes;
};

var getDraftRenderConfig = function getDraftRenderConfig(block, blockRenderMap) {
  var configForType = blockRenderMap.get(block.getType()) || blockRenderMap.get('unstyled');
  var wrapperTemplate = configForType.wrapper;
  var Element = configForType.element || blockRenderMap.get('unstyled').element;
  return {
    Element: Element,
    wrapperTemplate: wrapperTemplate
  };
};

var getCustomRenderConfig = function getCustomRenderConfig(block, blockRendererFn) {
  var customRenderer = blockRendererFn(block);

  if (!customRenderer) {
    return {};
  }

  var CustomComponent = customRenderer.component,
      customProps = customRenderer.props,
      customEditable = customRenderer.editable;
  return {
    CustomComponent: CustomComponent,
    customProps: customProps,
    customEditable: customEditable
  };
};

var getElementPropsConfig = function getElementPropsConfig(block, editorKey, offsetKey, blockStyleFn, customConfig, ref) {
  var elementProps = {
    'data-block': true,
    'data-editor': editorKey,
    'data-offset-key': offsetKey,
    key: block.getKey(),
    ref: ref
  };
  var customClass = blockStyleFn(block);

  if (customClass) {
    elementProps.className = customClass;
  }

  if (customConfig.customEditable !== undefined) {
    elementProps = _objectSpread({}, elementProps, {
      contentEditable: customConfig.customEditable,
      suppressContentEditableWarning: true
    });
  }

  return elementProps;
};

var DraftEditorBlockNode = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorBlockNode, _React$Component);

  function DraftEditorBlockNode() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "wrapperRef", React.createRef());

    return _this;
  }

  var _proto = DraftEditorBlockNode.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var _this$props = this.props,
        block = _this$props.block,
        direction = _this$props.direction,
        tree = _this$props.tree;
    var isContainerNode = !block.getChildKeys().isEmpty();
    var blockHasChanged = block !== nextProps.block || tree !== nextProps.tree || direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection; // if we have children at this stage we always re-render container nodes
    // else if its a root node we avoid re-rendering by checking for block updates

    return isContainerNode || blockHasChanged;
  }
  /**
   * When a block is mounted and overlaps the selection state, we need to make
   * sure that the cursor is visible to match native behavior. This may not
   * be the case if the user has pressed `RETURN` or pasted some content, since
   * programatically creating these new blocks and setting the DOM selection
   * will miss out on the browser natively scrolling to that position.
   *
   * To replicate native behavior, if the block overlaps the selection state
   * on mount, force the scroll position. Check the scroll state of the scroll
   * parent, and adjust it to align the entire block to the bottom of the
   * scroll parent.
   */
  ;

  _proto.componentDidMount = function componentDidMount() {
    var selection = this.props.selection;
    var endKey = selection.getEndKey();

    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
      return;
    }

    var blockNode = this.wrapperRef.current;

    if (!blockNode) {
      // This Block Node was rendered without a wrapper element.
      return;
    }

    var scrollParent = Style.getScrollParent(blockNode);
    var scrollPosition = getScrollPosition(scrollParent);
    var scrollDelta;

    if (scrollParent === window) {
      var nodePosition = getElementPosition(blockNode);
      var nodeBottom = nodePosition.y + nodePosition.height;
      var viewportHeight = getViewportDimensions().height;
      scrollDelta = nodeBottom - viewportHeight;

      if (scrollDelta > 0) {
        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
      }
    } else {
      !isHTMLElement(blockNode) ?  false ? invariant(false, 'blockNode is not an HTMLElement') : invariant(false) : void 0;
      var htmlBlockNode = blockNode;
      var blockBottom = htmlBlockNode.offsetHeight + htmlBlockNode.offsetTop;
      var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
      scrollDelta = blockBottom - scrollBottom;

      if (scrollDelta > 0) {
        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
      }
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        block = _this$props2.block,
        blockRenderMap = _this$props2.blockRenderMap,
        blockRendererFn = _this$props2.blockRendererFn,
        blockStyleFn = _this$props2.blockStyleFn,
        contentState = _this$props2.contentState,
        decorator = _this$props2.decorator,
        editorKey = _this$props2.editorKey,
        editorState = _this$props2.editorState,
        customStyleFn = _this$props2.customStyleFn,
        customStyleMap = _this$props2.customStyleMap,
        direction = _this$props2.direction,
        forceSelection = _this$props2.forceSelection,
        selection = _this$props2.selection,
        tree = _this$props2.tree;
    var children = null;

    if (block.children.size) {
      children = block.children.reduce(function (acc, key) {
        var offsetKey = DraftOffsetKey.encode(key, 0, 0);
        var child = contentState.getBlockForKey(key);
        var customConfig = getCustomRenderConfig(child, blockRendererFn);
        var Component = customConfig.CustomComponent || DraftEditorBlockNode;

        var _getDraftRenderConfig = getDraftRenderConfig(child, blockRenderMap),
            Element = _getDraftRenderConfig.Element,
            wrapperTemplate = _getDraftRenderConfig.wrapperTemplate;

        var elementProps = getElementPropsConfig(child, editorKey, offsetKey, blockStyleFn, customConfig, null);

        var childProps = _objectSpread({}, _this2.props, {
          tree: editorState.getBlockTree(key),
          blockProps: customConfig.customProps,
          offsetKey: offsetKey,
          block: child
        });

        acc.push(React.createElement(Element, elementProps, React.createElement(Component, childProps)));

        if (!wrapperTemplate || shouldNotAddWrapperElement(child, contentState)) {
          return acc;
        } // if we are here it means we are the last block
        // that has a wrapperTemplate so we should wrap itself
        // and all other previous siblings that share the same wrapper


        applyWrapperElementToSiblings(wrapperTemplate, Element, acc);
        return acc;
      }, []);
    }

    var blockKey = block.getKey();
    var offsetKey = DraftOffsetKey.encode(blockKey, 0, 0);
    var customConfig = getCustomRenderConfig(block, blockRendererFn);
    var Component = customConfig.CustomComponent;
    var blockNode = Component != null ? React.createElement(Component, _extends({}, this.props, {
      tree: editorState.getBlockTree(blockKey),
      blockProps: customConfig.customProps,
      offsetKey: offsetKey,
      block: block
    })) : React.createElement(DraftEditorNode, {
      block: block,
      children: children,
      contentState: contentState,
      customStyleFn: customStyleFn,
      customStyleMap: customStyleMap,
      decorator: decorator,
      direction: direction,
      forceSelection: forceSelection,
      hasSelection: isBlockOnSelectionEdge(selection, blockKey),
      selection: selection,
      tree: tree
    });

    if (block.getParentKey()) {
      return blockNode;
    }

    var _getDraftRenderConfig2 = getDraftRenderConfig(block, blockRenderMap),
        Element = _getDraftRenderConfig2.Element;

    var elementProps = getElementPropsConfig(block, editorKey, offsetKey, blockStyleFn, customConfig, this.wrapperRef); // root block nodes needs to be wrapped

    return React.createElement(Element, elementProps, blockNode);
  };

  return DraftEditorBlockNode;
}(React.Component);

module.exports = DraftEditorBlockNode;

/***/ }),
/* 2857 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DOMObserver = __webpack_require__(2854);

var DraftModifier = __webpack_require__(105);

var DraftOffsetKey = __webpack_require__(182);

var EditorState = __webpack_require__(62);

var Keys = __webpack_require__(430);

var UserAgent = __webpack_require__(106);

var editOnSelect = __webpack_require__(1172);

var getContentEditableContainer = __webpack_require__(1173);

var getDraftEditorSelection = __webpack_require__(1175);

var getEntityKeyForSelection = __webpack_require__(647);

var nullthrows = __webpack_require__(107);

var isIE = UserAgent.isBrowser('IE');
/**
 * Millisecond delay to allow `compositionstart` to fire again upon
 * `compositionend`.
 *
 * This is used for Korean input to ensure that typing can continue without
 * the editor trying to render too quickly. More specifically, Safari 7.1+
 * triggers `compositionstart` a little slower than Chrome/FF, which
 * leads to composed characters being resolved and re-render occurring
 * sooner than we want.
 */

var RESOLVE_DELAY = 20;
/**
 * A handful of variables used to track the current composition and its
 * resolution status. These exist at the module level because it is not
 * possible to have compositions occurring in multiple editors simultaneously,
 * and it simplifies state management with respect to the DraftEditor component.
 */

var resolved = false;
var stillComposing = false;
var domObserver = null;

function startDOMObserver(editor) {
  if (!domObserver) {
    domObserver = new DOMObserver(getContentEditableContainer(editor));
    domObserver.start();
  }
}

var DraftEditorCompositionHandler = {
  /**
   * A `compositionstart` event has fired while we're still in composition
   * mode. Continue the current composition session to prevent a re-render.
   */
  onCompositionStart: function onCompositionStart(editor) {
    stillComposing = true;
    startDOMObserver(editor);
  },

  /**
   * Attempt to end the current composition session.
   *
   * Defer handling because browser will still insert the chars into active
   * element after `compositionend`. If a `compositionstart` event fires
   * before `resolveComposition` executes, our composition session will
   * continue.
   *
   * The `resolved` flag is useful because certain IME interfaces fire the
   * `compositionend` event multiple times, thus queueing up multiple attempts
   * at handling the composition. Since handling the same composition event
   * twice could break the DOM, we only use the first event. Example: Arabic
   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
   */
  onCompositionEnd: function onCompositionEnd(editor) {
    resolved = false;
    stillComposing = false;
    setTimeout(function () {
      if (!resolved) {
        DraftEditorCompositionHandler.resolveComposition(editor);
      }
    }, RESOLVE_DELAY);
  },
  onSelect: editOnSelect,

  /**
   * In Safari, keydown events may fire when committing compositions. If
   * the arrow keys are used to commit, prevent default so that the cursor
   * doesn't move, otherwise it will jump back noticeably on re-render.
   */
  onKeyDown: function onKeyDown(editor, e) {
    if (!stillComposing) {
      // If a keydown event is received after compositionend but before the
      // 20ms timer expires (ex: type option-E then backspace, or type A then
      // backspace in 2-Set Korean), we should immediately resolve the
      // composition and reinterpret the key press in edit mode.
      DraftEditorCompositionHandler.resolveComposition(editor);

      editor._onKeyDown(e);

      return;
    }

    if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
      e.preventDefault();
    }
  },

  /**
   * Keypress events may fire when committing compositions. In Firefox,
   * pressing RETURN commits the composition and inserts extra newline
   * characters that we do not want. `preventDefault` allows the composition
   * to be committed while preventing the extra characters.
   */
  onKeyPress: function onKeyPress(_editor, e) {
    if (e.which === Keys.RETURN) {
      e.preventDefault();
    }
  },

  /**
   * Attempt to insert composed characters into the document.
   *
   * If we are still in a composition session, do nothing. Otherwise, insert
   * the characters into the document and terminate the composition session.
   *
   * If no characters were composed -- for instance, the user
   * deleted all composed characters and committed nothing new --
   * force a re-render. We also re-render when the composition occurs
   * at the beginning of a leaf, to ensure that if the browser has
   * created a new text node for the composition, we will discard it.
   *
   * Resetting innerHTML will move focus to the beginning of the editor,
   * so we update to force it back to the correct place.
   */
  resolveComposition: function resolveComposition(editor) {
    if (stillComposing) {
      return;
    }

    var mutations = nullthrows(domObserver).stopAndFlushMutations();
    domObserver = null;
    resolved = true;
    var editorState = EditorState.set(editor._latestEditorState, {
      inCompositionMode: false
    });
    editor.exitCurrentMode();

    if (!mutations.size) {
      editor.update(editorState);
      return;
    } // TODO, check if Facebook still needs this flag or if it could be removed.
    // Since there can be multiple mutations providing a `composedChars` doesn't
    // apply well on this new model.
    // if (
    //   gkx('draft_handlebeforeinput_composed_text') &&
    //   editor.props.handleBeforeInput &&
    //   isEventHandled(
    //     editor.props.handleBeforeInput(
    //       composedChars,
    //       editorState,
    //       event.timeStamp,
    //     ),
    //   )
    // ) {
    //   return;
    // }


    var contentState = editorState.getCurrentContent();
    mutations.forEach(function (composedChars, offsetKey) {
      var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
          blockKey = _DraftOffsetKey$decod.blockKey,
          decoratorKey = _DraftOffsetKey$decod.decoratorKey,
          leafKey = _DraftOffsetKey$decod.leafKey;

      var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
          start = _editorState$getBlock.start,
          end = _editorState$getBlock.end;

      var replacementRange = editorState.getSelection().merge({
        anchorKey: blockKey,
        focusKey: blockKey,
        anchorOffset: start,
        focusOffset: end,
        isBackward: false
      });
      var entityKey = getEntityKeyForSelection(contentState, replacementRange);
      var currentStyle = contentState.getBlockForKey(blockKey).getInlineStyleAt(start);
      contentState = DraftModifier.replaceText(contentState, replacementRange, composedChars, currentStyle, entityKey); // We need to update the editorState so the leaf node ranges are properly
      // updated and multiple mutations are correctly applied.

      editorState = EditorState.set(editorState, {
        currentContent: contentState
      });
    }); // When we apply the text changes to the ContentState, the selection always
    // goes to the end of the field, but it should just stay where it is
    // after compositionEnd.

    var documentSelection = getDraftEditorSelection(editorState, getContentEditableContainer(editor));
    var compositionEndSelectionState = documentSelection.selectionState;
    editor.restoreEditorDOM(); // See:
    // - https://github.com/facebook/draft-js/issues/2093
    // - https://github.com/facebook/draft-js/pull/2094
    // Apply this fix only in IE for now. We can test it in
    // other browsers in the future to ensure no regressions

    var editorStateWithUpdatedSelection = isIE ? EditorState.forceSelection(editorState, compositionEndSelectionState) : EditorState.acceptSelection(editorState, compositionEndSelectionState);
    editor.update(EditorState.push(editorStateWithUpdatedSelection, contentState, 'insert-characters'));
  }
};
module.exports = DraftEditorCompositionHandler;

/***/ }),
/* 2858 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var _assign = __webpack_require__(121);

function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DraftEditorBlock = __webpack_require__(1162);

var DraftOffsetKey = __webpack_require__(182);

var React = __webpack_require__(0);

var cx = __webpack_require__(244);

var joinClasses = __webpack_require__(2938);

var nullthrows = __webpack_require__(107);

/**
 * Provide default styling for list items. This way, lists will be styled with
 * proper counters and indentation even if the caller does not specify
 * their own styling at all. If more than five levels of nesting are needed,
 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
 */
var getListItemClasses = function getListItemClasses(type, depth, shouldResetCount, direction) {
  return cx({
    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
    'public/DraftStyleDefault/reset': shouldResetCount,
    'public/DraftStyleDefault/depth0': depth === 0,
    'public/DraftStyleDefault/depth1': depth === 1,
    'public/DraftStyleDefault/depth2': depth === 2,
    'public/DraftStyleDefault/depth3': depth === 3,
    'public/DraftStyleDefault/depth4': depth >= 4,
    'public/DraftStyleDefault/listLTR': direction === 'LTR',
    'public/DraftStyleDefault/listRTL': direction === 'RTL'
  });
};
/**
 * `DraftEditorContents` is the container component for all block components
 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
 * re-rendering blocks whenever possible.
 *
 * This component is separate from `DraftEditor` because certain props
 * (for instance, ARIA props) must be allowed to update without affecting
 * the contents of the editor.
 */


var DraftEditorContents = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorContents, _React$Component);

  function DraftEditorContents() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorContents.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var prevEditorState = this.props.editorState;
    var nextEditorState = nextProps.editorState;
    var prevDirectionMap = prevEditorState.getDirectionMap();
    var nextDirectionMap = nextEditorState.getDirectionMap(); // Text direction has changed for one or more blocks. We must re-render.

    if (prevDirectionMap !== nextDirectionMap) {
      return true;
    }

    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
    var nowHasFocus = nextEditorState.getSelection().getHasFocus();

    if (didHaveFocus !== nowHasFocus) {
      return true;
    }

    var nextNativeContent = nextEditorState.getNativelyRenderedContent();
    var wasComposing = prevEditorState.isInCompositionMode();
    var nowComposing = nextEditorState.isInCompositionMode(); // If the state is unchanged or we're currently rendering a natively
    // rendered state, there's nothing new to be done.

    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
      return false;
    }

    var prevContent = prevEditorState.getCurrentContent();
    var nextContent = nextEditorState.getCurrentContent();
    var prevDecorator = prevEditorState.getDecorator();
    var nextDecorator = nextEditorState.getDecorator();
    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        blockRenderMap = _this$props.blockRenderMap,
        blockRendererFn = _this$props.blockRendererFn,
        blockStyleFn = _this$props.blockStyleFn,
        customStyleMap = _this$props.customStyleMap,
        customStyleFn = _this$props.customStyleFn,
        editorState = _this$props.editorState,
        editorKey = _this$props.editorKey,
        preventScroll = _this$props.preventScroll,
        textDirectionality = _this$props.textDirectionality;
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var forceSelection = editorState.mustForceSelection();
    var decorator = editorState.getDecorator();
    var directionMap = nullthrows(editorState.getDirectionMap());
    var blocksAsArray = content.getBlocksAsArray();
    var processedBlocks = [];
    var currentDepth = null;
    var lastWrapperTemplate = null;

    for (var ii = 0; ii < blocksAsArray.length; ii++) {
      var _block = blocksAsArray[ii];

      var key = _block.getKey();

      var blockType = _block.getType();

      var customRenderer = blockRendererFn(_block);
      var CustomComponent = void 0,
          customProps = void 0,
          customEditable = void 0;

      if (customRenderer) {
        CustomComponent = customRenderer.component;
        customProps = customRenderer.props;
        customEditable = customRenderer.editable;
      }

      var direction = textDirectionality ? textDirectionality : directionMap.get(key);
      var offsetKey = DraftOffsetKey.encode(key, 0, 0);
      var componentProps = {
        contentState: content,
        block: _block,
        blockProps: customProps,
        blockStyleFn: blockStyleFn,
        customStyleMap: customStyleMap,
        customStyleFn: customStyleFn,
        decorator: decorator,
        direction: direction,
        forceSelection: forceSelection,
        offsetKey: offsetKey,
        preventScroll: preventScroll,
        selection: selection,
        tree: editorState.getBlockTree(key)
      };
      var configForType = blockRenderMap.get(blockType) || blockRenderMap.get('unstyled');
      var wrapperTemplate = configForType.wrapper;
      var Element = configForType.element || blockRenderMap.get('unstyled').element;

      var depth = _block.getDepth();

      var _className = '';

      if (blockStyleFn) {
        _className = blockStyleFn(_block);
      } // List items are special snowflakes, since we handle nesting and
      // counters manually.


      if (Element === 'li') {
        var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
        _className = joinClasses(_className, getListItemClasses(blockType, depth, shouldResetCount, direction));
      }

      var Component = CustomComponent || DraftEditorBlock;
      var childProps = {
        className: _className,
        'data-block': true,
        'data-editor': editorKey,
        'data-offset-key': offsetKey,
        key: key
      };

      if (customEditable !== undefined) {
        childProps = _objectSpread({}, childProps, {
          contentEditable: customEditable,
          suppressContentEditableWarning: true
        });
      }

      var child = React.createElement(Element, childProps,
      /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This
       * comment suppresses an error found when Flow v0.112 was deployed. To
       * see the error delete this comment and run Flow. */
      React.createElement(Component, _extends({}, componentProps, {
        key: key
      })));
      processedBlocks.push({
        block: child,
        wrapperTemplate: wrapperTemplate,
        key: key,
        offsetKey: offsetKey
      });

      if (wrapperTemplate) {
        currentDepth = _block.getDepth();
      } else {
        currentDepth = null;
      }

      lastWrapperTemplate = wrapperTemplate;
    } // Group contiguous runs of blocks that have the same wrapperTemplate


    var outputBlocks = [];

    for (var _ii = 0; _ii < processedBlocks.length;) {
      var info = processedBlocks[_ii];

      if (info.wrapperTemplate) {
        var blocks = [];

        do {
          blocks.push(processedBlocks[_ii].block);
          _ii++;
        } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);

        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
          key: info.key + '-wrap',
          'data-offset-key': info.offsetKey
        }, blocks);
        outputBlocks.push(wrapperElement);
      } else {
        outputBlocks.push(info.block);
        _ii++;
      }
    }

    return React.createElement("div", {
      "data-contents": "true"
    }, outputBlocks);
  };

  return DraftEditorContents;
}(React.Component);

module.exports = DraftEditorContents;

/***/ }),
/* 2859 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */


var gkx = __webpack_require__(203);

var experimentalTreeDataSupport = gkx('draft_tree_data_support');
module.exports = experimentalTreeDataSupport ? __webpack_require__(2860) : __webpack_require__(2858);

/***/ }),
/* 2860 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This file is a fork of DraftEditorContents.react.js for tree nodes
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */


var _assign = __webpack_require__(121);

function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DraftEditorBlockNode = __webpack_require__(2856);

var DraftOffsetKey = __webpack_require__(182);

var React = __webpack_require__(0);

var nullthrows = __webpack_require__(107);

/**
 * `DraftEditorContents` is the container component for all block components
 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
 * re-rendering blocks whenever possible.
 *
 * This component is separate from `DraftEditor` because certain props
 * (for instance, ARIA props) must be allowed to update without affecting
 * the contents of the editor.
 */
var DraftEditorContentsExperimental = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorContentsExperimental, _React$Component);

  function DraftEditorContentsExperimental() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorContentsExperimental.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var prevEditorState = this.props.editorState;
    var nextEditorState = nextProps.editorState;
    var prevDirectionMap = prevEditorState.getDirectionMap();
    var nextDirectionMap = nextEditorState.getDirectionMap(); // Text direction has changed for one or more blocks. We must re-render.

    if (prevDirectionMap !== nextDirectionMap) {
      return true;
    }

    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
    var nowHasFocus = nextEditorState.getSelection().getHasFocus();

    if (didHaveFocus !== nowHasFocus) {
      return true;
    }

    var nextNativeContent = nextEditorState.getNativelyRenderedContent();
    var wasComposing = prevEditorState.isInCompositionMode();
    var nowComposing = nextEditorState.isInCompositionMode(); // If the state is unchanged or we're currently rendering a natively
    // rendered state, there's nothing new to be done.

    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
      return false;
    }

    var prevContent = prevEditorState.getCurrentContent();
    var nextContent = nextEditorState.getCurrentContent();
    var prevDecorator = prevEditorState.getDecorator();
    var nextDecorator = nextEditorState.getDecorator();
    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        blockRenderMap = _this$props.blockRenderMap,
        blockRendererFn = _this$props.blockRendererFn,
        blockStyleFn = _this$props.blockStyleFn,
        customStyleMap = _this$props.customStyleMap,
        customStyleFn = _this$props.customStyleFn,
        editorState = _this$props.editorState,
        editorKey = _this$props.editorKey,
        textDirectionality = _this$props.textDirectionality;
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var forceSelection = editorState.mustForceSelection();
    var decorator = editorState.getDecorator();
    var directionMap = nullthrows(editorState.getDirectionMap());
    var blocksAsArray = content.getBlocksAsArray();
    var rootBlock = blocksAsArray[0];
    var processedBlocks = [];
    var nodeBlock = rootBlock;

    while (nodeBlock) {
      var blockKey = nodeBlock.getKey();
      var blockProps = {
        blockRenderMap: blockRenderMap,
        blockRendererFn: blockRendererFn,
        blockStyleFn: blockStyleFn,
        contentState: content,
        customStyleFn: customStyleFn,
        customStyleMap: customStyleMap,
        decorator: decorator,
        editorKey: editorKey,
        editorState: editorState,
        forceSelection: forceSelection,
        selection: selection,
        block: nodeBlock,
        direction: textDirectionality ? textDirectionality : directionMap.get(blockKey),
        tree: editorState.getBlockTree(blockKey)
      };
      var configForType = blockRenderMap.get(nodeBlock.getType()) || blockRenderMap.get('unstyled');
      var wrapperTemplate = configForType.wrapper;
      processedBlocks.push({
        /* $FlowFixMe[incompatible-type] (>=0.112.0 site=www,mobile) This
         * comment suppresses an error found when Flow v0.112 was deployed. To
         * see the error delete this comment and run Flow. */
        block: React.createElement(DraftEditorBlockNode, _extends({
          key: blockKey
        }, blockProps)),
        wrapperTemplate: wrapperTemplate,
        key: blockKey,
        offsetKey: DraftOffsetKey.encode(blockKey, 0, 0)
      });
      var nextBlockKey = nodeBlock.getNextSiblingKey();
      nodeBlock = nextBlockKey ? content.getBlockForKey(nextBlockKey) : null;
    } // Group contiguous runs of blocks that have the same wrapperTemplate


    var outputBlocks = [];

    for (var ii = 0; ii < processedBlocks.length;) {
      var info = processedBlocks[ii];

      if (info.wrapperTemplate) {
        var blocks = [];

        do {
          blocks.push(processedBlocks[ii].block);
          ii++;
        } while (ii < processedBlocks.length && processedBlocks[ii].wrapperTemplate === info.wrapperTemplate);

        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
          key: info.key + '-wrap',
          'data-offset-key': info.offsetKey
        }, blocks);
        outputBlocks.push(wrapperElement);
      } else {
        outputBlocks.push(info.block);
        ii++;
      }
    }

    return React.createElement("div", {
      "data-contents": "true"
    }, outputBlocks);
  };

  return DraftEditorContentsExperimental;
}(React.Component);

module.exports = DraftEditorContentsExperimental;

/***/ }),
/* 2861 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */


var _assign = __webpack_require__(121);

function _extends() { _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DraftOffsetKey = __webpack_require__(182);

var React = __webpack_require__(0);

var UnicodeBidi = __webpack_require__(650);

var UnicodeBidiDirection = __webpack_require__(432);

var DraftEditorDecoratedLeaves = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorDecoratedLeaves, _React$Component);

  function DraftEditorDecoratedLeaves() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorDecoratedLeaves.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        block = _this$props.block,
        children = _this$props.children,
        contentState = _this$props.contentState,
        decorator = _this$props.decorator,
        decoratorKey = _this$props.decoratorKey,
        direction = _this$props.direction,
        leafSet = _this$props.leafSet,
        text = _this$props.text;
    var blockKey = block.getKey();
    var leavesForLeafSet = leafSet.get('leaves');
    var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
    var decoratorProps = decorator.getPropsForKey(decoratorKey);
    var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, parseInt(decoratorKey, 10), 0);
    var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end')); // Resetting dir to the same value on a child node makes Chrome/Firefox
    // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/

    var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), direction);
    return React.createElement(DecoratorComponent, _extends({}, decoratorProps, {
      contentState: contentState,
      decoratedText: decoratedText,
      dir: dir,
      key: decoratorOffsetKey,
      entityKey: block.getEntityAt(leafSet.get('start')),
      offsetKey: decoratorOffsetKey
    }), children);
  };

  return DraftEditorDecoratedLeaves;
}(React.Component);

module.exports = DraftEditorDecoratedLeaves;

/***/ }),
/* 2862 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DataTransfer = __webpack_require__(1194);

var DraftModifier = __webpack_require__(105);

var EditorState = __webpack_require__(62);

var findAncestorOffsetKey = __webpack_require__(426);

var getCorrectDocumentFromNode = __webpack_require__(428);

var getTextContentFromFiles = __webpack_require__(1183);

var getUpdatedSelectionState = __webpack_require__(1184);

var getWindowForNode = __webpack_require__(1185);

var isEventHandled = __webpack_require__(429);

var nullthrows = __webpack_require__(107);
/**
 * Get a SelectionState for the supplied mouse event.
 */


function getSelectionForEvent(event, editorState) {
  var node = null;
  var offset = null;
  var eventTargetDocument = getCorrectDocumentFromNode(event.currentTarget);
  /* $FlowFixMe[prop-missing] (>=0.68.0 site=www,mobile) This comment
   * suppresses an error found when Flow v0.68 was deployed. To see the error
   * delete this comment and run Flow. */

  if (typeof eventTargetDocument.caretRangeFromPoint === 'function') {
    /* $FlowFixMe[incompatible-use] (>=0.68.0 site=www,mobile) This comment
     * suppresses an error found when Flow v0.68 was deployed. To see the error
     * delete this comment and run Flow. */
    var dropRange = eventTargetDocument.caretRangeFromPoint(event.x, event.y);
    node = dropRange.startContainer;
    offset = dropRange.startOffset;
  } else if (event.rangeParent) {
    node = event.rangeParent;
    offset = event.rangeOffset;
  } else {
    return null;
  }

  node = nullthrows(node);
  offset = nullthrows(offset);
  var offsetKey = nullthrows(findAncestorOffsetKey(node));
  return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
}

var DraftEditorDragHandler = {
  /**
   * Drag originating from input terminated.
   */
  onDragEnd: function onDragEnd(editor) {
    editor.exitCurrentMode();
    endDrag(editor);
  },

  /**
   * Handle data being dropped.
   */
  onDrop: function onDrop(editor, e) {
    var data = new DataTransfer(e.nativeEvent.dataTransfer);
    var editorState = editor._latestEditorState;
    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);
    e.preventDefault();
    editor._dragCount = 0;
    editor.exitCurrentMode();

    if (dropSelection == null) {
      return;
    }

    var files = data.getFiles();

    if (files.length > 0) {
      if (editor.props.handleDroppedFiles && isEventHandled(editor.props.handleDroppedFiles(dropSelection, files))) {
        return;
      }
      /* $FlowFixMe[incompatible-call] This comment suppresses an error found
       * DataTransfer was typed. getFiles() returns an array of <Files extends
       * Blob>, not Blob */


      getTextContentFromFiles(files, function (fileText) {
        fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
      });
      return;
    }

    var dragType = editor._internalDrag ? 'internal' : 'external';

    if (editor.props.handleDrop && isEventHandled(editor.props.handleDrop(dropSelection, data, dragType))) {// handled
    } else if (editor._internalDrag) {
      editor.update(moveText(editorState, dropSelection));
    } else {
      editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
    }

    endDrag(editor);
  }
};

function endDrag(editor) {
  editor._internalDrag = false; // Fix issue #1383
  // Prior to React v16.5.0 onDrop breaks onSelect event:
  // https://github.com/facebook/react/issues/11379.
  // Dispatching a mouseup event on DOM node will make it go back to normal.

  var editorNode = editor.editorContainer;

  if (editorNode) {
    var mouseUpEvent = new MouseEvent('mouseup', {
      view: getWindowForNode(editorNode),
      bubbles: true,
      cancelable: true
    });
    editorNode.dispatchEvent(mouseUpEvent);
  }
}

function moveText(editorState, targetSelection) {
  var newContentState = DraftModifier.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
  return EditorState.push(editorState, newContentState, 'insert-fragment');
}
/**
 * Insert text at a specified selection.
 */


function insertTextAtSelection(editorState, selection, text) {
  var newContentState = DraftModifier.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
  return EditorState.push(editorState, newContentState, 'insert-fragment');
}

module.exports = DraftEditorDragHandler;

/***/ }),
/* 2863 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UserAgent = __webpack_require__(106);

var onBeforeInput = __webpack_require__(2883);

var onBlur = __webpack_require__(2884);

var onCompositionStart = __webpack_require__(2885);

var onCopy = __webpack_require__(2886);

var onCut = __webpack_require__(2887);

var onDragOver = __webpack_require__(2888);

var onDragStart = __webpack_require__(2889);

var onFocus = __webpack_require__(2890);

var onInput = __webpack_require__(2891);

var onKeyDown = __webpack_require__(2892);

var onPaste = __webpack_require__(2893);

var onSelect = __webpack_require__(1172);

var isChrome = UserAgent.isBrowser('Chrome');
var isFirefox = UserAgent.isBrowser('Firefox');
var selectionHandler = isChrome || isFirefox ? onSelect : function (e) {};
var DraftEditorEditHandler = {
  onBeforeInput: onBeforeInput,
  onBlur: onBlur,
  onCompositionStart: onCompositionStart,
  onCopy: onCopy,
  onCut: onCut,
  onDragOver: onDragOver,
  onDragStart: onDragStart,
  onFocus: onFocus,
  onInput: onInput,
  onKeyDown: onKeyDown,
  onPaste: onPaste,
  onSelect: onSelect,
  // In certain cases, contenteditable on chrome does not fire the onSelect
  // event, causing problems with cursor positioning. Therefore, the selection
  // state update handler is added to more events to ensure that the selection
  // state is always synced with the actual cursor positions.
  onMouseUp: selectionHandler,
  onKeyUp: selectionHandler
};
module.exports = DraftEditorEditHandler;

/***/ }),
/* 2864 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var ReactDOMComet = __webpack_require__(109);

var flushControlled = ReactDOMComet.unstable_flushControlled;
module.exports = flushControlled;

/***/ }),
/* 2865 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var DraftEditorDecoratedLeaves = __webpack_require__(2861);

var DraftEditorLeaf = __webpack_require__(1163);

var DraftOffsetKey = __webpack_require__(182);

var Immutable = __webpack_require__(46);

var React = __webpack_require__(0);

var cx = __webpack_require__(244);

var List = Immutable.List;

var DraftEditorNode = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorNode, _React$Component);

  function DraftEditorNode() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorNode.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        block = _this$props.block,
        contentState = _this$props.contentState,
        customStyleFn = _this$props.customStyleFn,
        customStyleMap = _this$props.customStyleMap,
        decorator = _this$props.decorator,
        direction = _this$props.direction,
        forceSelection = _this$props.forceSelection,
        hasSelection = _this$props.hasSelection,
        selection = _this$props.selection,
        tree = _this$props.tree;
    var blockKey = block.getKey();
    var text = block.getText();
    var lastLeafSet = tree.size - 1;
    var children = this.props.children || tree.map(function (leafSet, ii) {
      var decoratorKey = leafSet.get('decoratorKey');
      var leavesForLeafSet = leafSet.get('leaves');
      var lastLeaf = leavesForLeafSet.size - 1;
      var Leaves = leavesForLeafSet.map(function (leaf, jj) {
        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
        var start = leaf.get('start');
        var end = leaf.get('end');
        return React.createElement(DraftEditorLeaf, {
          key: offsetKey,
          offsetKey: offsetKey,
          block: block,
          start: start,
          selection: hasSelection ? selection : null,
          forceSelection: forceSelection,
          text: text.slice(start, end),
          styleSet: block.getInlineStyleAt(start),
          customStyleMap: customStyleMap,
          customStyleFn: customStyleFn,
          isLast: decoratorKey === lastLeafSet && jj === lastLeaf
        });
      }).toArray();

      if (!decoratorKey || !decorator) {
        return Leaves;
      }

      return React.createElement(DraftEditorDecoratedLeaves, {
        block: block,
        children: Leaves,
        contentState: contentState,
        decorator: decorator,
        decoratorKey: decoratorKey,
        direction: direction,
        leafSet: leafSet,
        text: text,
        key: ii
      });
    }).toArray();
    return React.createElement("div", {
      "data-offset-key": DraftOffsetKey.encode(blockKey, 0, 0),
      className: cx({
        'public/DraftStyleDefault/block': true,
        'public/DraftStyleDefault/ltr': direction === 'LTR',
        'public/DraftStyleDefault/rtl': direction === 'RTL'
      })
    }, children);
  };

  return DraftEditorNode;
}(React.Component);

module.exports = DraftEditorNode;

/***/ }),
/* 2866 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var React = __webpack_require__(0);

var cx = __webpack_require__(244);

/**
 * This component is responsible for rendering placeholder text for the
 * `DraftEditor` component.
 *
 * Override placeholder style via CSS.
 */
var DraftEditorPlaceholder = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorPlaceholder, _React$Component);

  function DraftEditorPlaceholder() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DraftEditorPlaceholder.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
  };

  _proto.render = function render() {
    var hasFocus = this.props.editorState.getSelection().getHasFocus();
    var className = cx({
      'public/DraftEditorPlaceholder/root': true,
      'public/DraftEditorPlaceholder/hasFocus': hasFocus
    });
    var contentStyle = {
      whiteSpace: 'pre-wrap'
    };
    return React.createElement("div", {
      className: className
    }, React.createElement("div", {
      className: cx('public/DraftEditorPlaceholder/inner'),
      id: this.props.accessibilityID,
      style: contentStyle
    }, this.props.text));
  };

  return DraftEditorPlaceholder;
}(React.Component);

module.exports = DraftEditorPlaceholder;

/***/ }),
/* 2867 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var React = __webpack_require__(0);

var UserAgent = __webpack_require__(106);

var invariant = __webpack_require__(48);

var isElement = __webpack_require__(242); // In IE, spans with <br> tags render as two newlines. By rendering a span
// with only a newline character, we can be sure to render a single line.


var useNewlineChar = UserAgent.isBrowser('IE <= 11');
/**
 * Check whether the node should be considered a newline.
 */

function isNewline(node) {
  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
}
/**
 * Placeholder elements for empty text content.
 *
 * What is this `data-text` attribute, anyway? It turns out that we need to
 * put an attribute on the lowest-level text node in order to preserve correct
 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
 * If the <span> has an attribute, this appears not to happen.
 * See http://jsfiddle.net/9khdavod/ for the failure case, and
 * http://jsfiddle.net/7pg143f7/ for the fixed case.
 */


var NEWLINE_A = function NEWLINE_A(ref) {
  return useNewlineChar ? React.createElement("span", {
    key: "A",
    "data-text": "true",
    ref: ref
  }, '\n') : React.createElement("br", {
    key: "A",
    "data-text": "true",
    ref: ref
  });
};

var NEWLINE_B = function NEWLINE_B(ref) {
  return useNewlineChar ? React.createElement("span", {
    key: "B",
    "data-text": "true",
    ref: ref
  }, '\n') : React.createElement("br", {
    key: "B",
    "data-text": "true",
    ref: ref
  });
};

/**
 * The lowest-level component in a `DraftEditor`, the text node component
 * replaces the default React text node implementation. This allows us to
 * perform custom handling of newline behavior and avoid re-rendering text
 * nodes with DOM state that already matches the expectations of our immutable
 * editor state.
 */
var DraftEditorTextNode = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DraftEditorTextNode, _React$Component);

  function DraftEditorTextNode(props) {
    var _this;

    _this = _React$Component.call(this, props) || this; // By flipping this flag, we also keep flipping keys which forces
    // React to remount this node every time it rerenders.

    _defineProperty(_assertThisInitialized(_this), "_forceFlag", void 0);

    _defineProperty(_assertThisInitialized(_this), "_node", void 0);

    _this._forceFlag = false;
    return _this;
  }

  var _proto = DraftEditorTextNode.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var node = this._node;
    var shouldBeNewline = nextProps.children === '';
    !isElement(node) ?  false ? invariant(false, 'node is not an Element') : invariant(false) : void 0;
    var elementNode = node;

    if (shouldBeNewline) {
      return !isNewline(elementNode);
    }

    return elementNode.textContent !== nextProps.children;
  };

  _proto.componentDidMount = function componentDidMount() {
    this._forceFlag = !this._forceFlag;
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this._forceFlag = !this._forceFlag;
  };

  _proto.render = function render() {
    var _this2 = this;

    if (this.props.children === '') {
      return this._forceFlag ? NEWLINE_A(function (ref) {
        return _this2._node = ref;
      }) : NEWLINE_B(function (ref) {
        return _this2._node = ref;
      });
    }

    return React.createElement("span", {
      key: this._forceFlag ? 'A' : 'B',
      "data-text": "true",
      ref: function ref(_ref) {
        return _this2._node = _ref;
      }
    }, this.props.children);
  };

  return DraftEditorTextNode;
}(React.Component);

module.exports = DraftEditorTextNode;

/***/ }),
/* 2868 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/**
 * Identify the range to delete from a segmented entity.
 *
 * Rules:
 *
 *  Example: 'John F. Kennedy'
 *
 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
 *     will return the range of that text.
 *
 *       'John F. Kennedy' -> 'John F.'
 *                  ^
 *
 *   - Forward deletion of whitespace will remove the following section:
 *
 *       'John F. Kennedy' -> 'John Kennedy'
 *            ^
 *
 *   - Backward deletion of whitespace will remove the previous section:
 *
 *       'John F. Kennedy' -> 'F. Kennedy'
 *            ^
 */
var DraftEntitySegments = {
  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
    var segments = text.split(' ');
    segments = segments.map(function (
    /*string*/
    segment,
    /*number*/
    ii) {
      if (direction === 'forward') {
        if (ii > 0) {
          return ' ' + segment;
        }
      } else if (ii < segments.length - 1) {
        return segment + ' ';
      }

      return segment;
    });
    var segmentStart = entityStart;
    var segmentEnd;
    var segment;
    var removalStart = null;
    var removalEnd = null;

    for (var jj = 0; jj < segments.length; jj++) {
      segment = segments[jj];
      segmentEnd = segmentStart + segment.length; // Our selection overlaps this segment.

      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
        if (removalStart !== null) {
          removalEnd = segmentEnd;
        } else {
          removalStart = segmentStart;
          removalEnd = segmentEnd;
        }
      } else if (removalStart !== null) {
        break;
      }

      segmentStart = segmentEnd;
    }

    var entityEnd = entityStart + text.length;
    var atStart = removalStart === entityStart;
    var atEnd = removalEnd === entityEnd;

    if (!atStart && atEnd || atStart && !atEnd) {
      if (direction === 'forward') {
        if (removalEnd !== entityEnd) {
          removalEnd++;
        }
      } else if (removalStart !== entityStart) {
        removalStart--;
      }
    }

    return {
      start: removalStart,
      end: removalEnd
    };
  }
};
module.exports = DraftEntitySegments;

/***/ }),
/* 2869 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContentBlock = __webpack_require__(241);

var ContentBlockNode = __webpack_require__(134);

var convertFromHTMLToContentBlocks = __webpack_require__(1170);

var generateRandomKey = __webpack_require__(164);

var getSafeBodyFromHTML = __webpack_require__(1181);

var gkx = __webpack_require__(203);

var Immutable = __webpack_require__(46);

var sanitizeDraftText = __webpack_require__(1193);

var List = Immutable.List,
    Repeat = Immutable.Repeat;
var experimentalTreeDataSupport = gkx('draft_tree_data_support');
var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
var DraftPasteProcessor = {
  processHTML: function processHTML(html, blockRenderMap) {
    return convertFromHTMLToContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
  },
  processText: function processText(textBlocks, character, type) {
    return textBlocks.reduce(function (acc, textLine, index) {
      textLine = sanitizeDraftText(textLine);
      var key = generateRandomKey();
      var blockNodeConfig = {
        key: key,
        type: type,
        text: textLine,
        characterList: List(Repeat(character, textLine.length))
      }; // next block updates previous block

      if (experimentalTreeDataSupport && index !== 0) {
        var prevSiblingIndex = index - 1; // update previous block

        var previousBlock = acc[prevSiblingIndex] = acc[prevSiblingIndex].merge({
          nextSibling: key
        });
        blockNodeConfig = _objectSpread({}, blockNodeConfig, {
          prevSibling: previousBlock.getKey()
        });
      }

      acc.push(new ContentBlockRecord(blockNodeConfig));
      return acc;
    }, []);
  }
};
module.exports = DraftPasteProcessor;

/***/ }),
/* 2870 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */
var generateRandomKey = __webpack_require__(164);

var invariant = __webpack_require__(48);

var traverseInDepthOrder = function traverseInDepthOrder(blocks, fn) {
  var stack = [].concat(blocks).reverse();

  while (stack.length) {
    var _block = stack.pop();

    fn(_block);
    var children = _block.children;
    !Array.isArray(children) ?  false ? invariant(false, 'Invalid tree raw block') : invariant(false) : void 0;
    stack = stack.concat([].concat(children.reverse()));
  }
};

var isListBlock = function isListBlock(block) {
  if (!(block && block.type)) {
    return false;
  }

  var type = block.type;
  return type === 'unordered-list-item' || type === 'ordered-list-item';
};

var addDepthToChildren = function addDepthToChildren(block) {
  if (Array.isArray(block.children)) {
    block.children = block.children.map(function (child) {
      return child.type === block.type ? _objectSpread({}, child, {
        depth: (block.depth || 0) + 1
      }) : child;
    });
  }
};
/**
 * This adapter is intended to be be used as an adapter to draft tree data
 *
 * draft state <=====> draft tree state
 */


var DraftTreeAdapter = {
  /**
   * Converts from a tree raw state back to draft raw state
   */
  fromRawTreeStateToRawState: function fromRawTreeStateToRawState(draftTreeState) {
    var blocks = draftTreeState.blocks;
    var transformedBlocks = [];
    !Array.isArray(blocks) ?  false ? invariant(false, 'Invalid raw state') : invariant(false) : void 0;

    if (!Array.isArray(blocks) || !blocks.length) {
      return draftTreeState;
    }

    traverseInDepthOrder(blocks, function (block) {
      var newBlock = _objectSpread({}, block);

      if (isListBlock(block)) {
        newBlock.depth = newBlock.depth || 0;
        addDepthToChildren(block); // if it's a non-leaf node, we don't do anything else

        if (block.children != null && block.children.length > 0) {
          return;
        }
      }

      delete newBlock.children;
      transformedBlocks.push(newBlock);
    });
    draftTreeState.blocks = transformedBlocks;
    return _objectSpread({}, draftTreeState, {
      blocks: transformedBlocks
    });
  },

  /**
   * Converts from draft raw state to tree draft state
   */
  fromRawStateToRawTreeState: function fromRawStateToRawTreeState(draftState) {
    var transformedBlocks = [];
    var parentStack = [];
    draftState.blocks.forEach(function (block) {
      var isList = isListBlock(block);
      var depth = block.depth || 0;

      var treeBlock = _objectSpread({}, block, {
        children: []
      });

      if (!isList) {
        transformedBlocks.push(treeBlock);
        return;
      }

      var lastParent = parentStack[0]; // block is non-nested & there are no nested blocks, directly push block

      if (lastParent == null && depth === 0) {
        transformedBlocks.push(treeBlock); // block is first nested block or previous nested block is at a lower level
      } else if (lastParent == null || lastParent.depth < depth - 1) {
        // create new parent block
        var newParent = {
          key: generateRandomKey(),
          text: '',
          depth: depth - 1,
          type: block.type,
          children: [],
          entityRanges: [],
          inlineStyleRanges: []
        };
        parentStack.unshift(newParent);

        if (depth === 1) {
          // add as a root-level block
          transformedBlocks.push(newParent);
        } else if (lastParent != null) {
          // depth > 1 => also add as previous parent's child
          lastParent.children.push(newParent);
        }

        newParent.children.push(treeBlock);
      } else if (lastParent.depth === depth - 1) {
        // add as child of last parent
        lastParent.children.push(treeBlock);
      } else {
        // pop out parents at levels above this one from the parent stack
        while (lastParent != null && lastParent.depth >= depth) {
          parentStack.shift();
          lastParent = parentStack[0];
        }

        if (depth > 0) {
          lastParent.children.push(treeBlock);
        } else {
          transformedBlocks.push(treeBlock);
        }
      }
    });
    return _objectSpread({}, draftState, {
      blocks: transformedBlocks
    });
  }
};
module.exports = DraftTreeAdapter;

/***/ }),
/* 2871 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 *
 * This is unstable and not part of the public API and should not be used by
 * production systems. This file may be update/removed without notice.
 */
var warning = __webpack_require__(652);

var DraftTreeInvariants = {
  /**
   * Check if the block is valid
   */
  isValidBlock: function isValidBlock(block, blockMap) {
    var key = block.getKey(); // is its parent's child

    var parentKey = block.getParentKey();

    if (parentKey != null) {
      var parent = blockMap.get(parentKey);

      if (!parent.getChildKeys().includes(key)) {
         false ? warning(true, 'Tree is missing parent -> child pointer on %s', key) : void 0;
        return false;
      }
    } // is its children's parent


    var children = block.getChildKeys().map(function (k) {
      return blockMap.get(k);
    });

    if (!children.every(function (c) {
      return c.getParentKey() === key;
    })) {
       false ? warning(true, 'Tree is missing child -> parent pointer on %s', key) : void 0;
      return false;
    } // is its previous sibling's next sibling


    var prevSiblingKey = block.getPrevSiblingKey();

    if (prevSiblingKey != null) {
      var prevSibling = blockMap.get(prevSiblingKey);

      if (prevSibling.getNextSiblingKey() !== key) {
         false ? warning(true, "Tree is missing nextSibling pointer on %s's prevSibling", key) : void 0;
        return false;
      }
    } // is its next sibling's previous sibling


    var nextSiblingKey = block.getNextSiblingKey();

    if (nextSiblingKey != null) {
      var nextSibling = blockMap.get(nextSiblingKey);

      if (nextSibling.getPrevSiblingKey() !== key) {
         false ? warning(true, "Tree is missing prevSibling pointer on %s's nextSibling", key) : void 0;
        return false;
      }
    } // no 2-node cycles


    if (nextSiblingKey !== null && prevSiblingKey !== null) {
      if (prevSiblingKey === nextSiblingKey) {
         false ? warning(true, 'Tree has a two-node cycle at %s', key) : void 0;
        return false;
      }
    } // if it's a leaf node, it has text but no children


    if (block.text != '') {
      if (block.getChildKeys().size > 0) {
         false ? warning(true, 'Leaf node %s has children', key) : void 0;
        return false;
      }
    }

    return true;
  },

  /**
   * Checks that this is a connected tree on all the blocks
   * starting from the first block, traversing nextSibling and child pointers
   * should be a tree (preorder traversal - parent, then children)
   * num of connected node === number of blocks
   */
  isConnectedTree: function isConnectedTree(blockMap) {
    // exactly one node has no previous sibling + no parent
    var eligibleFirstNodes = blockMap.toArray().filter(function (block) {
      return block.getParentKey() == null && block.getPrevSiblingKey() == null;
    });

    if (eligibleFirstNodes.length !== 1) {
       false ? warning(true, 'Tree is not connected. More or less than one first node') : void 0;
      return false;
    }

    var firstNode = eligibleFirstNodes.shift();
    var nodesSeen = 0;
    var currentKey = firstNode.getKey();
    var visitedStack = [];

    while (currentKey != null) {
      var currentNode = blockMap.get(currentKey);
      var childKeys = currentNode.getChildKeys();
      var nextSiblingKey = currentNode.getNextSiblingKey(); // if the node has children, add parent's next sibling to stack and go to children

      if (childKeys.size > 0) {
        if (nextSiblingKey != null) {
          visitedStack.unshift(nextSiblingKey);
        }

        var children = childKeys.map(function (k) {
          return blockMap.get(k);
        });

        var _firstNode = children.find(function (block) {
          return block.getPrevSiblingKey() == null;
        });

        if (_firstNode == null) {
           false ? warning(true, '%s has no first child', currentKey) : void 0;
          return false;
        }

        currentKey = _firstNode.getKey(); // TODO(T32490138): Deal with multi-node cycles here
      } else {
        if (currentNode.getNextSiblingKey() != null) {
          currentKey = currentNode.getNextSiblingKey();
        } else {
          currentKey = visitedStack.shift();
        }
      }

      nodesSeen++;
    }

    if (nodesSeen !== blockMap.size) {
       false ? warning(true, 'Tree is not connected. %s nodes were seen instead of %s', nodesSeen, blockMap.size) : void 0;
      return false;
    }

    return true;
  },

  /**
   * Checks that the block map is a connected tree with valid blocks
   */
  isValidTree: function isValidTree(blockMap) {
    var _this = this;

    var blocks = blockMap.toArray();

    if (!blocks.every(function (block) {
      return _this.isValidBlock(block, blockMap);
    })) {
      return false;
    }

    return this.isConnectedTree(blockMap);
  }
};
module.exports = DraftTreeInvariants;

/***/ }),
/* 2872 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UnicodeBidiService = __webpack_require__(2926);

var Immutable = __webpack_require__(46);

var nullthrows = __webpack_require__(107);

var OrderedMap = Immutable.OrderedMap;
var bidiService;
var EditorBidiService = {
  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
    if (!bidiService) {
      bidiService = new UnicodeBidiService();
    } else {
      bidiService.reset();
    }

    var blockMap = content.getBlockMap();
    var nextBidi = blockMap.valueSeq().map(function (block) {
      return nullthrows(bidiService).getDirection(block.getText());
    });
    var bidiMap = OrderedMap(blockMap.keySeq().zip(nextBidi));

    if (prevBidiMap != null && Immutable.is(prevBidiMap, bidiMap)) {
      return prevBidiMap;
    }

    return bidiMap;
  }
};
module.exports = EditorBidiService;

/***/ }),
/* 2873 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/***/ }),
/* 2874 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(105);

var EditorState = __webpack_require__(62);

var getContentStateFragment = __webpack_require__(427);

var nullthrows = __webpack_require__(107);

var clipboard = null;
/**
 * Some systems offer a "secondary" clipboard to allow quick internal cut
 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
 */

var SecondaryClipboard = {
  cut: function cut(editorState) {
    var content = editorState.getCurrentContent();
    var selection = editorState.getSelection();
    var targetRange = null;

    if (selection.isCollapsed()) {
      var anchorKey = selection.getAnchorKey();
      var blockEnd = content.getBlockForKey(anchorKey).getLength();

      if (blockEnd === selection.getAnchorOffset()) {
        var keyAfter = content.getKeyAfter(anchorKey);

        if (keyAfter == null) {
          return editorState;
        }

        targetRange = selection.set('focusKey', keyAfter).set('focusOffset', 0);
      } else {
        targetRange = selection.set('focusOffset', blockEnd);
      }
    } else {
      targetRange = selection;
    }

    targetRange = nullthrows(targetRange); // TODO: This should actually append to the current state when doing
    // successive ^K commands without any other cursor movement

    clipboard = getContentStateFragment(content, targetRange);
    var afterRemoval = DraftModifier.removeRange(content, targetRange, 'forward');

    if (afterRemoval === content) {
      return editorState;
    }

    return EditorState.push(editorState, afterRemoval, 'remove-range');
  },
  paste: function paste(editorState) {
    if (!clipboard) {
      return editorState;
    }

    var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);
    return EditorState.push(editorState, newContent, 'insert-fragment');
  }
};
module.exports = SecondaryClipboard;

/***/ }),
/* 2875 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
  var startKey = selectionState.getStartKey();
  var endKey = selectionState.getEndKey();
  var blockMap = contentState.getBlockMap();
  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
    var depth = block.getDepth() + adjustment;
    depth = Math.max(0, Math.min(depth, maxDepth));
    return block.set('depth', depth);
  });
  blockMap = blockMap.merge(blocks);
  return contentState.merge({
    blockMap: blockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = adjustBlockDepthForContentState;

/***/ }),
/* 2876 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var CharacterMetadata = __webpack_require__(133);

function applyEntityToContentBlock(contentBlock, startArg, end, entityKey) {
  var start = startArg;
  var characterList = contentBlock.getCharacterList();

  while (start < end) {
    characterList = characterList.set(start, CharacterMetadata.applyEntity(characterList.get(start), entityKey));
    start++;
  }

  return contentBlock.set('characterList', characterList);
}

module.exports = applyEntityToContentBlock;

/***/ }),
/* 2877 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var applyEntityToContentBlock = __webpack_require__(2876);

var Immutable = __webpack_require__(46);

function applyEntityToContentState(contentState, selectionState, entityKey) {
  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var newBlocks = blockMap.skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).toOrderedMap().merge(Immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
    var sliceStart = blockKey === startKey ? startOffset : 0;
    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
    return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
  });
  return contentState.merge({
    blockMap: blockMap.merge(newBlocks),
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
}

module.exports = applyEntityToContentState;

/***/ }),
/* 2878 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContentBlock = __webpack_require__(241);

var ContentBlockNode = __webpack_require__(134);

var DraftStringKey = __webpack_require__(1168);

var encodeEntityRanges = __webpack_require__(2894);

var encodeInlineStyleRanges = __webpack_require__(2895);

var invariant = __webpack_require__(48);

var createRawBlock = function createRawBlock(block, entityStorageMap) {
  return {
    key: block.getKey(),
    text: block.getText(),
    type: block.getType(),
    depth: block.getDepth(),
    inlineStyleRanges: encodeInlineStyleRanges(block),
    entityRanges: encodeEntityRanges(block, entityStorageMap),
    data: block.getData().toObject()
  };
};

var insertRawBlock = function insertRawBlock(block, entityMap, rawBlocks, blockCacheRef) {
  if (block instanceof ContentBlock) {
    rawBlocks.push(createRawBlock(block, entityMap));
    return;
  }

  !(block instanceof ContentBlockNode) ?  false ? invariant(false, 'block is not a BlockNode') : invariant(false) : void 0;
  var parentKey = block.getParentKey();

  var rawBlock = blockCacheRef[block.getKey()] = _objectSpread({}, createRawBlock(block, entityMap), {
    children: []
  });

  if (parentKey) {
    blockCacheRef[parentKey].children.push(rawBlock);
    return;
  }

  rawBlocks.push(rawBlock);
};

var encodeRawBlocks = function encodeRawBlocks(contentState, rawState) {
  var entityMap = rawState.entityMap;
  var rawBlocks = [];
  var blockCacheRef = {};
  var entityCacheRef = {};
  var entityStorageKey = 0;
  contentState.getBlockMap().forEach(function (block) {
    block.findEntityRanges(function (character) {
      return character.getEntity() !== null;
    }, function (start) {
      var entityKey = block.getEntityAt(start); // Stringify to maintain order of otherwise numeric keys.

      var stringifiedEntityKey = DraftStringKey.stringify(entityKey); // This makes this function resilient to two entities
      // erroneously having the same key

      if (entityCacheRef[stringifiedEntityKey]) {
        return;
      }

      entityCacheRef[stringifiedEntityKey] = entityKey; // we need the `any` casting here since this is a temporary state
      // where we will later on flip the entity map and populate it with
      // real entity, at this stage we just need to map back the entity
      // key used by the BlockNode

      entityMap[stringifiedEntityKey] = "".concat(entityStorageKey);
      entityStorageKey++;
    });
    insertRawBlock(block, entityMap, rawBlocks, blockCacheRef);
  });
  return {
    blocks: rawBlocks,
    entityMap: entityMap
  };
}; // Flip storage map so that our storage keys map to global
// DraftEntity keys.


var encodeRawEntityMap = function encodeRawEntityMap(contentState, rawState) {
  var blocks = rawState.blocks,
      entityMap = rawState.entityMap;
  var rawEntityMap = {};
  Object.keys(entityMap).forEach(function (key, index) {
    var entity = contentState.getEntity(DraftStringKey.unstringify(key));
    rawEntityMap[index] = {
      type: entity.getType(),
      mutability: entity.getMutability(),
      data: entity.getData()
    };
  });
  return {
    blocks: blocks,
    entityMap: rawEntityMap
  };
};

var convertFromDraftStateToRaw = function convertFromDraftStateToRaw(contentState) {
  var rawDraftContentState = {
    entityMap: {},
    blocks: []
  }; // add blocks

  rawDraftContentState = encodeRawBlocks(contentState, rawDraftContentState); // add entities

  rawDraftContentState = encodeRawEntityMap(contentState, rawDraftContentState);
  return rawDraftContentState;
};

module.exports = convertFromDraftStateToRaw;

/***/ }),
/* 2879 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ContentBlock = __webpack_require__(241);

var ContentBlockNode = __webpack_require__(134);

var ContentState = __webpack_require__(644);

var DraftEntity = __webpack_require__(424);

var DraftTreeAdapter = __webpack_require__(2870);

var DraftTreeInvariants = __webpack_require__(2871);

var SelectionState = __webpack_require__(425);

var createCharacterList = __webpack_require__(2880);

var decodeEntityRanges = __webpack_require__(2881);

var decodeInlineStyleRanges = __webpack_require__(2882);

var generateRandomKey = __webpack_require__(164);

var gkx = __webpack_require__(203);

var Immutable = __webpack_require__(46);

var invariant = __webpack_require__(48);

var experimentalTreeDataSupport = gkx('draft_tree_data_support');
var List = Immutable.List,
    Map = Immutable.Map,
    OrderedMap = Immutable.OrderedMap;

var decodeBlockNodeConfig = function decodeBlockNodeConfig(block, entityMap) {
  var key = block.key,
      type = block.type,
      data = block.data,
      text = block.text,
      depth = block.depth;
  var blockNodeConfig = {
    text: text,
    depth: depth || 0,
    type: type || 'unstyled',
    key: key || generateRandomKey(),
    data: Map(data),
    characterList: decodeCharacterList(block, entityMap)
  };
  return blockNodeConfig;
};

var decodeCharacterList = function decodeCharacterList(block, entityMap) {
  var text = block.text,
      rawEntityRanges = block.entityRanges,
      rawInlineStyleRanges = block.inlineStyleRanges;
  var entityRanges = rawEntityRanges || [];
  var inlineStyleRanges = rawInlineStyleRanges || []; // Translate entity range keys to the DraftEntity map.

  return createCharacterList(decodeInlineStyleRanges(text, inlineStyleRanges), decodeEntityRanges(text, entityRanges.filter(function (range) {
    return entityMap.hasOwnProperty(range.key);
  }).map(function (range) {
    return _objectSpread({}, range, {
      key: entityMap[range.key]
    });
  })));
};

var addKeyIfMissing = function addKeyIfMissing(block) {
  return _objectSpread({}, block, {
    key: block.key || generateRandomKey()
  });
};
/**
 * Node stack is responsible to ensure we traverse the tree only once
 * in depth order, while also providing parent refs to inner nodes to
 * construct their links.
 */


var updateNodeStack = function updateNodeStack(stack, nodes, parentRef) {
  var nodesWithParentRef = nodes.map(function (block) {
    return _objectSpread({}, block, {
      parentRef: parentRef
    });
  }); // since we pop nodes from the stack we need to insert them in reverse

  return stack.concat(nodesWithParentRef.reverse());
};
/**
 * This will build a tree draft content state by creating the node
 * reference links into a single tree walk. Each node has a link
 * reference to "parent", "children", "nextSibling" and "prevSibling"
 * blockMap will be created using depth ordering.
 */


var decodeContentBlockNodes = function decodeContentBlockNodes(blocks, entityMap) {
  return blocks // ensure children have valid keys to enable sibling links
  .map(addKeyIfMissing).reduce(function (blockMap, block, index) {
    !Array.isArray(block.children) ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0; // ensure children have valid keys to enable sibling links

    var children = block.children.map(addKeyIfMissing); // root level nodes

    var contentBlockNode = new ContentBlockNode(_objectSpread({}, decodeBlockNodeConfig(block, entityMap), {
      prevSibling: index === 0 ? null : blocks[index - 1].key,
      nextSibling: index === blocks.length - 1 ? null : blocks[index + 1].key,
      children: List(children.map(function (child) {
        return child.key;
      }))
    })); // push root node to blockMap

    blockMap = blockMap.set(contentBlockNode.getKey(), contentBlockNode); // this stack is used to ensure we visit all nodes respecting depth ordering

    var stack = updateNodeStack([], children, contentBlockNode); // start computing children nodes

    while (stack.length > 0) {
      // we pop from the stack and start processing this node
      var node = stack.pop(); // parentRef already points to a converted ContentBlockNode

      var parentRef = node.parentRef;
      var siblings = parentRef.getChildKeys();

      var _index = siblings.indexOf(node.key);

      var isValidBlock = Array.isArray(node.children);

      if (!isValidBlock) {
        !isValidBlock ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;
        break;
      } // ensure children have valid keys to enable sibling links


      var _children = node.children.map(addKeyIfMissing);

      var _contentBlockNode = new ContentBlockNode(_objectSpread({}, decodeBlockNodeConfig(node, entityMap), {
        parent: parentRef.getKey(),
        children: List(_children.map(function (child) {
          return child.key;
        })),
        prevSibling: _index === 0 ? null : siblings.get(_index - 1),
        nextSibling: _index === siblings.size - 1 ? null : siblings.get(_index + 1)
      })); // push node to blockMap


      blockMap = blockMap.set(_contentBlockNode.getKey(), _contentBlockNode); // this stack is used to ensure we visit all nodes respecting depth ordering

      stack = updateNodeStack(stack, _children, _contentBlockNode);
    }

    return blockMap;
  }, OrderedMap());
};

var decodeContentBlocks = function decodeContentBlocks(blocks, entityMap) {
  return OrderedMap(blocks.map(function (block) {
    var contentBlock = new ContentBlock(decodeBlockNodeConfig(block, entityMap));
    return [contentBlock.getKey(), contentBlock];
  }));
};

var decodeRawBlocks = function decodeRawBlocks(rawState, entityMap) {
  var isTreeRawBlock = rawState.blocks.find(function (block) {
    return Array.isArray(block.children) && block.children.length > 0;
  });
  var rawBlocks = experimentalTreeDataSupport && !isTreeRawBlock ? DraftTreeAdapter.fromRawStateToRawTreeState(rawState).blocks : rawState.blocks;

  if (!experimentalTreeDataSupport) {
    return decodeContentBlocks(isTreeRawBlock ? DraftTreeAdapter.fromRawTreeStateToRawState(rawState).blocks : rawBlocks, entityMap);
  }

  var blockMap = decodeContentBlockNodes(rawBlocks, entityMap); // in dev mode, check that the tree invariants are met

  if (false) {
    !DraftTreeInvariants.isValidTree(blockMap) ? process.env.NODE_ENV !== "production" ? invariant(false, 'Should be a valid tree') : invariant(false) : void 0;
  }

  return blockMap;
};

var decodeRawEntityMap = function decodeRawEntityMap(rawState) {
  var rawEntityMap = rawState.entityMap;
  var entityMap = {}; // TODO: Update this once we completely remove DraftEntity

  Object.keys(rawEntityMap).forEach(function (rawEntityKey) {
    var _rawEntityMap$rawEnti = rawEntityMap[rawEntityKey],
        type = _rawEntityMap$rawEnti.type,
        mutability = _rawEntityMap$rawEnti.mutability,
        data = _rawEntityMap$rawEnti.data; // get the key reference to created entity

    entityMap[rawEntityKey] = DraftEntity.__create(type, mutability, data || {});
  });
  return entityMap;
};

var convertFromRawToDraftState = function convertFromRawToDraftState(rawState) {
  !Array.isArray(rawState.blocks) ?  false ? invariant(false, 'invalid RawDraftContentState') : invariant(false) : void 0; // decode entities

  var entityMap = decodeRawEntityMap(rawState); // decode blockMap

  var blockMap = decodeRawBlocks(rawState, entityMap); // create initial selection

  var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
  return new ContentState({
    blockMap: blockMap,
    entityMap: entityMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState
  });
};

module.exports = convertFromRawToDraftState;

/***/ }),
/* 2880 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var CharacterMetadata = __webpack_require__(133);

var Immutable = __webpack_require__(46);

var List = Immutable.List;

function createCharacterList(inlineStyles, entities) {
  var characterArray = inlineStyles.map(function (style, ii) {
    var entity = entities[ii];
    return CharacterMetadata.create({
      style: style,
      entity: entity
    });
  });
  return List(characterArray);
}

module.exports = createCharacterList;

/***/ }),
/* 2881 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UnicodeUtils = __webpack_require__(243);

var substr = UnicodeUtils.substr;
/**
 * Convert to native JavaScript string lengths to determine ranges.
 */

function decodeEntityRanges(text, ranges) {
  var entities = Array(text.length).fill(null);

  if (ranges) {
    ranges.forEach(function (range) {
      // Using Unicode-enabled substrings converted to JavaScript lengths,
      // fill the output array with entity keys.
      var start = substr(text, 0, range.offset).length;
      var end = start + substr(text, range.offset, range.length).length;

      for (var ii = start; ii < end; ii++) {
        entities[ii] = range.key;
      }
    });
  }

  return entities;
}

module.exports = decodeEntityRanges;

/***/ }),
/* 2882 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UnicodeUtils = __webpack_require__(243);

var _require = __webpack_require__(46),
    OrderedSet = _require.OrderedSet;

var substr = UnicodeUtils.substr;
var EMPTY_SET = OrderedSet();
/**
 * Convert to native JavaScript string lengths to determine ranges.
 */

function decodeInlineStyleRanges(text, ranges) {
  var styles = Array(text.length).fill(EMPTY_SET);

  if (ranges) {
    ranges.forEach(function (range) {
      var cursor = substr(text, 0, range.offset).length;
      var end = cursor + substr(text, range.offset, range.length).length;

      while (cursor < end) {
        styles[cursor] = styles[cursor].add(range.style);
        cursor++;
      }
    });
  }

  return styles;
}

module.exports = decodeInlineStyleRanges;

/***/ }),
/* 2883 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(105);

var EditorState = __webpack_require__(62);

var UserAgent = __webpack_require__(106);

var getEntityKeyForSelection = __webpack_require__(647);

var isEventHandled = __webpack_require__(429);

var isSelectionAtLeafStart = __webpack_require__(2906);

var nullthrows = __webpack_require__(107);

var setImmediate = __webpack_require__(2941); // When nothing is focused, Firefox regards two characters, `'` and `/`, as
// commands that should open and focus the "quickfind" search bar. This should
// *never* happen while a contenteditable is focused, but as of v28, it
// sometimes does, even when the keypress event target is the contenteditable.
// This breaks the input. Special case these characters to ensure that when
// they are typed, we prevent default on the event to make sure not to
// trigger quickfind.


var FF_QUICKFIND_CHAR = "'";
var FF_QUICKFIND_LINK_CHAR = '/';
var isFirefox = UserAgent.isBrowser('Firefox');

function mustPreventDefaultForCharacter(character) {
  return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
}
/**
 * Replace the current selection with the specified text string, with the
 * inline style and entity key applied to the newly inserted text.
 */


function replaceText(editorState, text, inlineStyle, entityKey, forceSelection) {
  var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
  return EditorState.push(editorState, contentState, 'insert-characters', forceSelection);
}
/**
 * When `onBeforeInput` executes, the browser is attempting to insert a
 * character into the editor. Apply this character data to the document,
 * allowing native insertion if possible.
 *
 * Native insertion is encouraged in order to limit re-rendering and to
 * preserve spellcheck highlighting, which disappears or flashes if re-render
 * occurs on the relevant text nodes.
 */


function editOnBeforeInput(editor, e) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  }

  var editorState = editor._latestEditorState;
  var chars = e.data; // In some cases (ex: IE ideographic space insertion) no character data
  // is provided. There's nothing to do when this happens.

  if (!chars) {
    return;
  } // Allow the top-level component to handle the insertion manually. This is
  // useful when triggering interesting behaviors for a character insertion,
  // Simple examples: replacing a raw text ':)' with a smile emoji or image
  // decorator, or setting a block to be a list item after typing '- ' at the
  // start of the block.


  if (editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(chars, editorState, e.timeStamp))) {
    e.preventDefault();
    return;
  } // If selection is collapsed, conditionally allow native behavior. This
  // reduces re-renders and preserves spellcheck highlighting. If the selection
  // is not collapsed, we will re-render.


  var selection = editorState.getSelection();
  var selectionStart = selection.getStartOffset();
  var anchorKey = selection.getAnchorKey();

  if (!selection.isCollapsed()) {
    e.preventDefault();
    editor.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()), true));
    return;
  }

  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()), false); // Bunch of different cases follow where we need to prevent native insertion.

  var mustPreventNative = false;

  if (!mustPreventNative) {
    // Browsers tend to insert text in weird places in the DOM when typing at
    // the start of a leaf, so we'll handle it ourselves.
    mustPreventNative = isSelectionAtLeafStart(editor._latestCommittedEditorState);
  }

  if (!mustPreventNative) {
    // Let's say we have a decorator that highlights hashtags. In many cases
    // we need to prevent native behavior and rerender ourselves --
    // particularly, any case *except* where the inserted characters end up
    // anywhere except exactly where you put them.
    //
    // Using [] to denote a decorated leaf, some examples:
    //
    // 1. 'hi #' and append 'f'
    // desired rendering: 'hi [#f]'
    // native rendering would be: 'hi #f' (incorrect)
    //
    // 2. 'x [#foo]' and insert '#' before 'f'
    // desired rendering: 'x #[#foo]'
    // native rendering would be: 'x [##foo]' (incorrect)
    //
    // 3. '[#foobar]' and insert ' ' between 'foo' and 'bar'
    // desired rendering: '[#foo] bar'
    // native rendering would be: '[#foo bar]' (incorrect)
    //
    // 4. '[#foo]' and delete '#' [won't use this beforeinput codepath though]
    // desired rendering: 'foo'
    // native rendering would be: '[foo]' (incorrect)
    //
    // 5. '[#foo]' and append 'b'
    // desired rendering: '[#foob]'
    // native rendering would be: '[#foob]'
    // (native insertion here would be ok for decorators like simple spans,
    // but not more complex decorators. To be safe, we need to prevent it.)
    //
    // It is safe to allow native insertion if and only if the full list of
    // decorator ranges matches what we expect native insertion to give, and
    // the range lengths have not changed. We don't need to compare the content
    // because the only possible mutation to consider here is inserting plain
    // text and decorators can't affect text content.
    var oldBlockTree = editorState.getBlockTree(anchorKey);
    var newBlockTree = newEditorState.getBlockTree(anchorKey);
    mustPreventNative = oldBlockTree.size !== newBlockTree.size || oldBlockTree.zip(newBlockTree).some(function (_ref) {
      var oldLeafSet = _ref[0],
          newLeafSet = _ref[1];
      // selectionStart is guaranteed to be selectionEnd here
      var oldStart = oldLeafSet.get('start');
      var adjustedStart = oldStart + (oldStart >= selectionStart ? chars.length : 0);
      var oldEnd = oldLeafSet.get('end');
      var adjustedEnd = oldEnd + (oldEnd >= selectionStart ? chars.length : 0);
      var newStart = newLeafSet.get('start');
      var newEnd = newLeafSet.get('end');
      var newDecoratorKey = newLeafSet.get('decoratorKey');
      return (// Different decorators
        oldLeafSet.get('decoratorKey') !== newDecoratorKey || // Different number of inline styles
        oldLeafSet.get('leaves').size !== newLeafSet.get('leaves').size || // Different effective decorator position
        adjustedStart !== newStart || adjustedEnd !== newEnd || // Decorator already existed and its length changed
        newDecoratorKey != null && newEnd - newStart !== oldEnd - oldStart
      );
    });
  }

  if (!mustPreventNative) {
    mustPreventNative = mustPreventDefaultForCharacter(chars);
  }

  if (!mustPreventNative) {
    mustPreventNative = nullthrows(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows(editorState.getDirectionMap()).get(anchorKey);
  }

  if (mustPreventNative) {
    e.preventDefault();
    newEditorState = EditorState.set(newEditorState, {
      forceSelection: true
    });
    editor.update(newEditorState);
    return;
  } // We made it all the way! Let the browser do its thing and insert the char.


  newEditorState = EditorState.set(newEditorState, {
    nativelyRenderedContent: newEditorState.getCurrentContent()
  }); // The native event is allowed to occur. To allow user onChange handlers to
  // change the inserted text, we wait until the text is actually inserted
  // before we actually update our state. That way when we rerender, the text
  // we see in the DOM will already have been inserted properly.

  editor._pendingStateFromBeforeInput = newEditorState;
  setImmediate(function () {
    if (editor._pendingStateFromBeforeInput !== undefined) {
      editor.update(editor._pendingStateFromBeforeInput);
      editor._pendingStateFromBeforeInput = undefined;
    }
  });
}

module.exports = editOnBeforeInput;

/***/ }),
/* 2884 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(62);

var containsNode = __webpack_require__(651);

var getActiveElement = __webpack_require__(1196);

function editOnBlur(editor, e) {
  // In a contentEditable element, when you select a range and then click
  // another active element, this does trigger a `blur` event but will not
  // remove the DOM selection from the contenteditable.
  // This is consistent across all browsers, but we prefer that the editor
  // behave like a textarea, where a `blur` event clears the DOM selection.
  // We therefore force the issue to be certain, checking whether the active
  // element is `body` to force it when blurring occurs within the window (as
  // opposed to clicking to another tab or window).
  var ownerDocument = e.currentTarget.ownerDocument;

  if ( // This ESLint rule conflicts with `sketchy-null-bool` flow check
  // eslint-disable-next-line no-extra-boolean-cast
  !Boolean(editor.props.preserveSelectionOnBlur) && getActiveElement(ownerDocument) === ownerDocument.body) {
    var _selection = ownerDocument.defaultView.getSelection();

    var editorNode = editor.editor;

    if (_selection.rangeCount === 1 && containsNode(editorNode, _selection.anchorNode) && containsNode(editorNode, _selection.focusNode)) {
      _selection.removeAllRanges();
    }
  }

  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();

  if (!currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', false);
  editor.props.onBlur && editor.props.onBlur(e);
  editor.update(EditorState.acceptSelection(editorState, selection));
}

module.exports = editOnBlur;

/***/ }),
/* 2885 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(62);
/**
 * The user has begun using an IME input system. Switching to `composite` mode
 * allows handling composition input and disables other edit behavior.
 */


function editOnCompositionStart(editor, e) {
  editor.setMode('composite');
  editor.update(EditorState.set(editor._latestEditorState, {
    inCompositionMode: true
  })); // Allow composition handler to interpret the compositionstart event

  editor._onCompositionStart(e);
}

module.exports = editOnCompositionStart;

/***/ }),
/* 2886 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var getFragmentFromSelection = __webpack_require__(1177);
/**
 * If we have a selection, create a ContentState fragment and store
 * it in our internal clipboard. Subsequent paste events will use this
 * fragment if no external clipboard data is supplied.
 */


function editOnCopy(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection(); // No selection, so there's nothing to copy.

  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  }

  editor.setClipboard(getFragmentFromSelection(editor._latestEditorState));
}

module.exports = editOnCopy;

/***/ }),
/* 2887 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(105);

var EditorState = __webpack_require__(62);

var Style = __webpack_require__(431);

var getFragmentFromSelection = __webpack_require__(1177);

var getScrollPosition = __webpack_require__(433);

var isNode = __webpack_require__(2905);
/**
 * On `cut` events, native behavior is allowed to occur so that the system
 * clipboard is set properly. This means that we need to take steps to recover
 * the editor DOM state after the `cut` has occurred in order to maintain
 * control of the component.
 *
 * In addition, we can keep a copy of the removed fragment, including all
 * styles and entities, for use as an internal paste.
 */


function editOnCut(editor, e) {
  var editorState = editor._latestEditorState;
  var selection = editorState.getSelection();
  var element = e.target;
  var scrollPosition; // No selection, so there's nothing to cut.

  if (selection.isCollapsed()) {
    e.preventDefault();
    return;
  } // Track the current scroll position so that it can be forced back in place
  // after the editor regains control of the DOM.


  if (isNode(element)) {
    var node = element;
    scrollPosition = getScrollPosition(Style.getScrollParent(node));
  }

  var fragment = getFragmentFromSelection(editorState);
  editor.setClipboard(fragment); // Set `cut` mode to disable all event handling temporarily.

  editor.setMode('cut'); // Let native `cut` behavior occur, then recover control.

  setTimeout(function () {
    editor.restoreEditorDOM(scrollPosition);
    editor.exitCurrentMode();
    editor.update(removeFragment(editorState));
  }, 0);
}

function removeFragment(editorState) {
  var newContent = DraftModifier.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
  return EditorState.push(editorState, newContent, 'remove-range');
}

module.exports = editOnCut;

/***/ }),
/* 2888 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/**
 * Drag behavior has begun from outside the editor element.
 */
function editOnDragOver(editor, e) {
  editor.setMode('drag');
  e.preventDefault();
}

module.exports = editOnDragOver;

/***/ }),
/* 2889 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


/**
 * A `dragstart` event has begun within the text editor component.
 */
function editOnDragStart(editor) {
  editor._internalDrag = true;
  editor.setMode('drag');
}

module.exports = editOnDragStart;

/***/ }),
/* 2890 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(62);

var UserAgent = __webpack_require__(106);

function editOnFocus(editor, e) {
  var editorState = editor._latestEditorState;
  var currentSelection = editorState.getSelection();

  if (currentSelection.getHasFocus()) {
    return;
  }

  var selection = currentSelection.set('hasFocus', true);
  editor.props.onFocus && editor.props.onFocus(e); // When the tab containing this text editor is hidden and the user does a
  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
  // selection was right after sending this focus event and (if you let it)
  // moves the cursor back to the beginning of the editor, so we force the
  // selection here instead of simply accepting it in order to preserve the
  // old cursor position. See https://crbug.com/540004.
  // But it looks like this is fixed in Chrome 60.0.3081.0.
  // Other browsers also don't have this bug, so we prefer to acceptSelection
  // when possible, to ensure that unfocusing and refocusing a Draft editor
  // doesn't preserve the selection, matching how textareas work.

  if (UserAgent.isBrowser('Chrome < 60.0.3081.0')) {
    editor.update(EditorState.forceSelection(editorState, selection));
  } else {
    editor.update(EditorState.acceptSelection(editorState, selection));
  }
}

module.exports = editOnFocus;

/***/ }),
/* 2891 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(105);

var DraftOffsetKey = __webpack_require__(182);

var EditorState = __webpack_require__(62);

var UserAgent = __webpack_require__(106);

var _require = __webpack_require__(1171),
    notEmptyKey = _require.notEmptyKey;

var findAncestorOffsetKey = __webpack_require__(426);

var keyCommandPlainBackspace = __webpack_require__(1188);

var nullthrows = __webpack_require__(107);

var isGecko = UserAgent.isEngine('Gecko');
var DOUBLE_NEWLINE = '\n\n';

function onInputType(inputType, editorState) {
  switch (inputType) {
    case 'deleteContentBackward':
      return keyCommandPlainBackspace(editorState);
  }

  return editorState;
}
/**
 * This function serves two purposes
 *
 * 1. To update the editorState and call onChange method with the new
 * editorState. This editorState is calculated in editOnBeforeInput but the
 * onChange method is not called with the new state until this method does it.
 * It is done to handle a specific case where certain character inputs might
 * be replaced with something else. E.g. snippets ('rc' might be replaced
 * with boilerplate code for react component). More information on the
 * exact problem can be found here -
 * https://github.com/facebook/draft-js/commit/07892ba479bd4dfc6afd1e0ed179aaf51cd138b1
 *
 * 2. intended to handle spellcheck and autocorrect changes,
 * which occur in the DOM natively without any opportunity to observe or
 * interpret the changes before they occur.
 *
 * The `input` event fires in contentEditable elements reliably for non-IE
 * browsers, immediately after changes occur to the editor DOM. Since our other
 * handlers override or otherwise handle cover other varieties of text input,
 * the DOM state should match the model in all controlled input cases. Thus,
 * when an `input` change leads to a DOM/model mismatch, the change should be
 * due to a spellcheck change, and we can incorporate it into our model.
 */


function editOnInput(editor, e) {
  if (editor._pendingStateFromBeforeInput !== undefined) {
    editor.update(editor._pendingStateFromBeforeInput);
    editor._pendingStateFromBeforeInput = undefined;
  } // at this point editor is not null for sure (after input)


  var castedEditorElement = editor.editor;
  var domSelection = castedEditorElement.ownerDocument.defaultView.getSelection();
  var anchorNode = domSelection.anchorNode,
      isCollapsed = domSelection.isCollapsed;
  var isNotTextOrElementNode = (anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.nodeType) !== Node.TEXT_NODE && (anchorNode === null || anchorNode === void 0 ? void 0 : anchorNode.nodeType) !== Node.ELEMENT_NODE;

  if (anchorNode == null || isNotTextOrElementNode) {
    // TODO: (t16149272) figure out context for this change
    return;
  }

  if (anchorNode.nodeType === Node.TEXT_NODE && (anchorNode.previousSibling !== null || anchorNode.nextSibling !== null)) {
    // When typing at the beginning of a visual line, Chrome splits the text
    // nodes into two. Why? No one knows. This commit is suspicious:
    // https://chromium.googlesource.com/chromium/src/+/a3b600981286b135632371477f902214c55a1724
    // To work around, we'll merge the sibling text nodes back into this one.
    var span = anchorNode.parentNode;

    if (span == null) {
      // Handle null-parent case.
      return;
    }

    anchorNode.nodeValue = span.textContent;

    for (var child = span.firstChild; child != null; child = child.nextSibling) {
      if (child !== anchorNode) {
        span.removeChild(child);
      }
    }
  }

  var domText = anchorNode.textContent;
  var editorState = editor._latestEditorState;
  var offsetKey = nullthrows(findAncestorOffsetKey(anchorNode));

  var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
      blockKey = _DraftOffsetKey$decod.blockKey,
      decoratorKey = _DraftOffsetKey$decod.decoratorKey,
      leafKey = _DraftOffsetKey$decod.leafKey;

  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
      start = _editorState$getBlock.start,
      end = _editorState$getBlock.end;

  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var modelText = block.getText().slice(start, end); // Special-case soft newlines here. If the DOM text ends in a soft newline,
  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
  // We want to remove this extra newline for the purpose of our comparison
  // of DOM and model text.

  if (domText.endsWith(DOUBLE_NEWLINE)) {
    domText = domText.slice(0, -1);
  } // No change -- the DOM is up to date. Nothing to do here.


  if (domText === modelText) {
    // This can be buggy for some Android keyboards because they don't fire
    // standard onkeydown/pressed events and only fired editOnInput
    // so domText is already changed by the browser and ends up being equal
    // to modelText unexpectedly.
    // Newest versions of Android support the dom-inputevent-inputtype
    // and we can use the `inputType` to properly apply the state changes.

    /* $FlowFixMe[prop-missing] inputType is only defined on a draft of a
     * standard. https://w3c.github.io/input-events/#dom-inputevent-inputtype
     */
    var inputType = e.nativeEvent.inputType;

    if (inputType) {
      var newEditorState = onInputType(inputType, editorState);

      if (newEditorState !== editorState) {
        editor.restoreEditorDOM();
        editor.update(newEditorState);
        return;
      }
    }

    return;
  }

  var selection = editorState.getSelection(); // We'll replace the entire leaf with the text content of the target.

  var targetRange = selection.merge({
    anchorOffset: start,
    focusOffset: end,
    isBackward: false
  });
  var entityKey = block.getEntityAt(start);
  var entity = notEmptyKey(entityKey) ? content.getEntity(entityKey) : null;
  var entityType = entity != null ? entity.getMutability() : null;
  var preserveEntity = entityType === 'MUTABLE'; // Immutable or segmented entities cannot properly be handled by the
  // default browser undo, so we have to use a different change type to
  // force using our internal undo method instead of falling through to the
  // native browser undo.

  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';
  var newContent = DraftModifier.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);
  var anchorOffset, focusOffset, startOffset, endOffset;

  if (isGecko) {
    // Firefox selection does not change while the context menu is open, so
    // we preserve the anchor and focus values of the DOM selection.
    anchorOffset = domSelection.anchorOffset;
    focusOffset = domSelection.focusOffset;
    startOffset = start + Math.min(anchorOffset, focusOffset);
    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
    anchorOffset = startOffset;
    focusOffset = endOffset;
  } else {
    // Browsers other than Firefox may adjust DOM selection while the context
    // menu is open, and Safari autocorrect is prone to providing an inaccurate
    // DOM selection. Don't trust it. Instead, use our existing SelectionState
    // and adjust it based on the number of characters changed during the
    // mutation.
    var charDelta = domText.length - modelText.length;
    startOffset = selection.getStartOffset();
    endOffset = selection.getEndOffset();
    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
    focusOffset = endOffset + charDelta;
  } // Segmented entities are completely or partially removed when their
  // text content changes. For this case we do not want any text to be selected
  // after the change, so we are not merging the selection.


  var contentWithAdjustedDOMSelection = newContent.merge({
    selectionBefore: content.getSelectionAfter(),
    selectionAfter: selection.merge({
      anchorOffset: anchorOffset,
      focusOffset: focusOffset
    })
  });
  editor.update(EditorState.push(editorState, contentWithAdjustedDOMSelection, changeType));
}

module.exports = editOnInput;

/***/ }),
/* 2892 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(105);

var EditorState = __webpack_require__(62);

var KeyBindingUtil = __webpack_require__(646);

var Keys = __webpack_require__(430);

var SecondaryClipboard = __webpack_require__(2874);

var UserAgent = __webpack_require__(106);

var isEventHandled = __webpack_require__(429);

var keyCommandBackspaceToStartOfLine = __webpack_require__(2908);

var keyCommandBackspaceWord = __webpack_require__(2909);

var keyCommandDeleteWord = __webpack_require__(2910);

var keyCommandInsertNewline = __webpack_require__(2911);

var keyCommandMoveSelectionToEndOfBlock = __webpack_require__(2912);

var keyCommandMoveSelectionToStartOfBlock = __webpack_require__(2913);

var keyCommandPlainBackspace = __webpack_require__(1188);

var keyCommandPlainDelete = __webpack_require__(2914);

var keyCommandTransposeCharacters = __webpack_require__(2915);

var keyCommandUndo = __webpack_require__(2916);

var isOptionKeyCommand = KeyBindingUtil.isOptionKeyCommand;
var isChrome = UserAgent.isBrowser('Chrome');
/**
 * Map a `DraftEditorCommand` command value to a corresponding function.
 */

function onKeyCommand(command, editorState, e) {
  switch (command) {
    case 'redo':
      return EditorState.redo(editorState);

    case 'delete':
      return keyCommandPlainDelete(editorState);

    case 'delete-word':
      return keyCommandDeleteWord(editorState);

    case 'backspace':
      return keyCommandPlainBackspace(editorState);

    case 'backspace-word':
      return keyCommandBackspaceWord(editorState);

    case 'backspace-to-start-of-line':
      return keyCommandBackspaceToStartOfLine(editorState, e);

    case 'split-block':
      return keyCommandInsertNewline(editorState);

    case 'transpose-characters':
      return keyCommandTransposeCharacters(editorState);

    case 'move-selection-to-start-of-block':
      return keyCommandMoveSelectionToStartOfBlock(editorState);

    case 'move-selection-to-end-of-block':
      return keyCommandMoveSelectionToEndOfBlock(editorState);

    case 'secondary-cut':
      return SecondaryClipboard.cut(editorState);

    case 'secondary-paste':
      return SecondaryClipboard.paste(editorState);

    default:
      return editorState;
  }
}
/**
 * Intercept keydown behavior to handle keys and commands manually, if desired.
 *
 * Keydown combinations may be mapped to `DraftCommand` values, which may
 * correspond to command functions that modify the editor or its contents.
 *
 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
 * component may provide a custom mapping via the `keyBindingFn` prop.
 */


function editOnKeyDown(editor, e) {
  var keyCode = e.which;
  var editorState = editor._latestEditorState;

  function callDeprecatedHandler(handlerName) {
    var deprecatedHandler = editor.props[handlerName];

    if (deprecatedHandler) {
      deprecatedHandler(e);
      return true;
    } else {
      return false;
    }
  }

  switch (keyCode) {
    case Keys.RETURN:
      e.preventDefault(); // The top-level component may manually handle newline insertion. If
      // no special handling is performed, fall through to command handling.

      if (editor.props.handleReturn && isEventHandled(editor.props.handleReturn(e, editorState))) {
        return;
      }

      break;

    case Keys.ESC:
      e.preventDefault();

      if (callDeprecatedHandler('onEscape')) {
        return;
      }

      break;

    case Keys.TAB:
      if (callDeprecatedHandler('onTab')) {
        return;
      }

      break;

    case Keys.UP:
      if (callDeprecatedHandler('onUpArrow')) {
        return;
      }

      break;

    case Keys.RIGHT:
      if (callDeprecatedHandler('onRightArrow')) {
        return;
      }

      break;

    case Keys.DOWN:
      if (callDeprecatedHandler('onDownArrow')) {
        return;
      }

      break;

    case Keys.LEFT:
      if (callDeprecatedHandler('onLeftArrow')) {
        return;
      }

      break;

    case Keys.SPACE:
      // Prevent Chrome on OSX behavior where option + space scrolls.
      if (isChrome && isOptionKeyCommand(e)) {
        e.preventDefault();
      }

  }

  var command = editor.props.keyBindingFn(e); // If no command is specified, allow keydown event to continue.

  if (command == null || command === '') {
    if (keyCode === Keys.SPACE && isChrome && isOptionKeyCommand(e)) {
      // The default keydown event has already been prevented in order to stop
      // Chrome from scrolling. Insert a nbsp into the editor as OSX would for
      // other browsers.
      var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), "\xA0");
      editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
    }

    return;
  }

  if (command === 'undo') {
    // Since undo requires some special updating behavior to keep the editor
    // in sync, handle it separately.
    keyCommandUndo(e, editorState, editor.update);
    return;
  } // At this point, we know that we're handling a command of some kind, so
  // we don't want to insert a character following the keydown.


  e.preventDefault(); // Allow components higher up the tree to handle the command first.

  if (editor.props.handleKeyCommand && isEventHandled(editor.props.handleKeyCommand(command, editorState, e.timeStamp))) {
    return;
  }

  var newState = onKeyCommand(command, editorState, e);

  if (newState !== editorState) {
    editor.update(newState);
  }
}

module.exports = editOnKeyDown;

/***/ }),
/* 2893 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var BlockMapBuilder = __webpack_require__(337);

var CharacterMetadata = __webpack_require__(133);

var DataTransfer = __webpack_require__(1194);

var DraftModifier = __webpack_require__(105);

var DraftPasteProcessor = __webpack_require__(2869);

var EditorState = __webpack_require__(62);

var RichTextEditorUtil = __webpack_require__(1169);

var getEntityKeyForSelection = __webpack_require__(647);

var getTextContentFromFiles = __webpack_require__(1183);

var isEventHandled = __webpack_require__(429);

var splitTextIntoTextBlocks = __webpack_require__(2921);
/**
 * Paste content.
 */


function editOnPaste(editor, e) {
  e.preventDefault();
  var data = new DataTransfer(e.clipboardData); // Get files, unless this is likely to be a string the user wants inline.

  if (!data.isRichText()) {
    var files = data.getFiles();
    var defaultFileText = data.getText();

    if (files.length > 0) {
      // Allow customized paste handling for images, etc. Otherwise, fall
      // through to insert text contents into the editor.
      if (editor.props.handlePastedFiles && isEventHandled(editor.props.handlePastedFiles(files))) {
        return;
      }
      /* $FlowFixMe[incompatible-call] This comment suppresses an error found
       * DataTransfer was typed. getFiles() returns an array of <Files extends
       * Blob>, not Blob */


      getTextContentFromFiles(files, function (
      /*string*/
      fileText) {
        fileText = fileText || defaultFileText;

        if (!fileText) {
          return;
        }

        var editorState = editor._latestEditorState;
        var blocks = splitTextIntoTextBlocks(fileText);
        var character = CharacterMetadata.create({
          style: editorState.getCurrentInlineStyle(),
          entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
        });
        var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);
        var text = DraftPasteProcessor.processText(blocks, character, currentBlockType);
        var fragment = BlockMapBuilder.createFromArray(text);
        var withInsertedText = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
        editor.update(EditorState.push(editorState, withInsertedText, 'insert-fragment'));
      });
      return;
    }
  }

  var textBlocks = [];
  var text = data.getText();
  var html = data.getHTML();
  var editorState = editor._latestEditorState;

  if (editor.props.formatPastedText) {
    var _editor$props$formatP = editor.props.formatPastedText(text, html),
        formattedText = _editor$props$formatP.text,
        formattedHtml = _editor$props$formatP.html;

    text = formattedText;
    html = formattedHtml;
  }

  if (editor.props.handlePastedText && isEventHandled(editor.props.handlePastedText(text, html, editorState))) {
    return;
  }

  if (text) {
    textBlocks = splitTextIntoTextBlocks(text);
  }

  if (!editor.props.stripPastedStyles) {
    // If the text from the paste event is rich content that matches what we
    // already have on the internal clipboard, assume that we should just use
    // the clipboard fragment for the paste. This will allow us to preserve
    // styling and entities, if any are present. Note that newlines are
    // stripped during comparison -- this is because copy/paste within the
    // editor in Firefox and IE will not include empty lines. The resulting
    // paste will preserve the newlines correctly.
    var internalClipboard = editor.getClipboard();

    if (!editor.props.formatPastedText && data.isRichText() && internalClipboard) {
      var _html;

      if ( // If the editorKey is present in the pasted HTML, it should be safe to
      // assume this is an internal paste.
      ((_html = html) === null || _html === void 0 ? void 0 : _html.indexOf(editor.getEditorKey())) !== -1 || // The copy may have been made within a single block, in which case the
      // editor key won't be part of the paste. In this case, just check
      // whether the pasted text matches the internal clipboard.
      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
        editor.update(insertFragment(editor._latestEditorState, internalClipboard));
        return;
      }
    } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
      // Safari does not properly store text/html in some cases.
      // Use the internalClipboard if present and equal to what is on
      // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
      editor.update(insertFragment(editor._latestEditorState, internalClipboard));
      return;
    } // If there is html paste data, try to parse that.


    if (html) {
      var htmlFragment = DraftPasteProcessor.processHTML(html, editor.props.blockRenderMap);

      if (htmlFragment) {
        var contentBlocks = htmlFragment.contentBlocks,
            entityMap = htmlFragment.entityMap;

        if (contentBlocks) {
          var htmlMap = BlockMapBuilder.createFromArray(contentBlocks);
          editor.update(insertFragment(editor._latestEditorState, htmlMap, entityMap));
          return;
        }
      }
    } // Otherwise, create a new fragment from our pasted text. Also
    // empty the internal clipboard, since it's no longer valid.


    editor.setClipboard(null);
  }

  if (textBlocks.length) {
    var character = CharacterMetadata.create({
      style: editorState.getCurrentInlineStyle(),
      entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
    });
    var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);
    var textFragment = DraftPasteProcessor.processText(textBlocks, character, currentBlockType);
    var textMap = BlockMapBuilder.createFromArray(textFragment);
    editor.update(insertFragment(editor._latestEditorState, textMap));
  }
}

function insertFragment(editorState, fragment, entityMap) {
  var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment); // TODO: merge the entity map once we stop using DraftEntity
  // like this:
  // const mergedEntityMap = newContent.getEntityMap().merge(entityMap);

  return EditorState.push(editorState, newContent.set('entityMap', entityMap), 'insert-fragment');
}

function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
    return block.getText() === textBlocks[ii];
  });
}

module.exports = editOnPaste;

/***/ }),
/* 2894 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftStringKey = __webpack_require__(1168);

var UnicodeUtils = __webpack_require__(243);

var strlen = UnicodeUtils.strlen;
/**
 * Convert to UTF-8 character counts for storage.
 */

function encodeEntityRanges(block, storageMap) {
  var encoded = [];
  block.findEntityRanges(function (character) {
    return !!character.getEntity();
  }, function (
  /*number*/
  start,
  /*number*/
  end) {
    var text = block.getText();
    var key = block.getEntityAt(start);
    encoded.push({
      offset: strlen(text.slice(0, start)),
      length: strlen(text.slice(start, end)),
      // Encode the key as a number for range storage.
      key: Number(storageMap[DraftStringKey.stringify(key)])
    });
  });
  return encoded;
}

module.exports = encodeEntityRanges;

/***/ }),
/* 2895 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var UnicodeUtils = __webpack_require__(243);

var findRangesImmutable = __webpack_require__(339);

var areEqual = function areEqual(a, b) {
  return a === b;
};

var isTruthy = function isTruthy(a) {
  return !!a;
};

var EMPTY_ARRAY = [];
/**
 * Helper function for getting encoded styles for each inline style. Convert
 * to UTF-8 character counts for storage.
 */

function getEncodedInlinesForType(block, styleList, styleToEncode) {
  var ranges = []; // Obtain an array with ranges for only the specified style.

  var filteredInlines = styleList.map(function (style) {
    return style.has(styleToEncode);
  }).toList();
  findRangesImmutable(filteredInlines, areEqual, // We only want to keep ranges with nonzero style values.
  isTruthy, function (start, end) {
    var text = block.getText();
    ranges.push({
      offset: UnicodeUtils.strlen(text.slice(0, start)),
      length: UnicodeUtils.strlen(text.slice(start, end)),
      style: styleToEncode
    });
  });
  return ranges;
}
/*
 * Retrieve the encoded arrays of inline styles, with each individual style
 * treated separately.
 */


function encodeInlineStyleRanges(block) {
  var styleList = block.getCharacterList().map(function (c) {
    return c.getStyle();
  }).toList();
  var ranges = styleList.flatten().toSet().map(function (style) {
    return getEncodedInlinesForType(block, styleList, style);
  });
  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
}

module.exports = encodeInlineStyleRanges;

/***/ }),
/* 2896 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var UnicodeUtils = __webpack_require__(243);

var getCorrectDocumentFromNode = __webpack_require__(428);

var getRangeClientRects = __webpack_require__(1180);

var invariant = __webpack_require__(48);
/**
 * Return the computed line height, in pixels, for the provided element.
 */


function getLineHeightPx(element) {
  var computed = getComputedStyle(element);
  var correctDocument = getCorrectDocumentFromNode(element);
  var div = correctDocument.createElement('div');
  div.style.fontFamily = computed.fontFamily;
  div.style.fontSize = computed.fontSize;
  div.style.fontStyle = computed.fontStyle;
  div.style.fontWeight = computed.fontWeight;
  div.style.lineHeight = computed.lineHeight;
  div.style.position = 'absolute';
  div.textContent = 'M';
  var documentBody = correctDocument.body;
  !documentBody ?  false ? invariant(false, 'Missing document.body') : invariant(false) : void 0; // forced layout here

  documentBody.appendChild(div);
  var rect = div.getBoundingClientRect();
  documentBody.removeChild(div);
  return rect.height;
}
/**
 * Return whether every ClientRect in the provided list lies on the same line.
 *
 * We assume that the rects on the same line all contain the baseline, so the
 * lowest top line needs to be above the highest bottom line (i.e., if you were
 * to project the rects onto the y-axis, their intersection would be nonempty).
 *
 * In addition, we require that no two boxes are lineHeight (or more) apart at
 * either top or bottom, which helps protect against false positives for fonts
 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
 * produces rects of height 58px!).
 */


function areRectsOnOneLine(rects, lineHeight) {
  var minTop = Infinity;
  var minBottom = Infinity;
  var maxTop = -Infinity;
  var maxBottom = -Infinity;

  for (var ii = 0; ii < rects.length; ii++) {
    var rect = rects[ii];

    if (rect.width === 0 || rect.width === 1) {
      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
      // Safari) include an empty rect on the previous or next line. When the
      // text lies in a container whose position is not integral (e.g., from
      // margin: auto), Safari makes these empty rects have width 1 (instead of
      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
      // report widths in subpixel precision anyway) so it's relatively safe to
      // skip over them.
      continue;
    }

    minTop = Math.min(minTop, rect.top);
    minBottom = Math.min(minBottom, rect.bottom);
    maxTop = Math.max(maxTop, rect.top);
    maxBottom = Math.max(maxBottom, rect.bottom);
  }

  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
}
/**
 * Return the length of a node, as used by Range offsets.
 */


function getNodeLength(node) {
  // http://www.w3.org/TR/dom/#concept-node-length
  switch (node.nodeType) {
    case Node.DOCUMENT_TYPE_NODE:
      return 0;

    case Node.TEXT_NODE:
    case Node.PROCESSING_INSTRUCTION_NODE:
    case Node.COMMENT_NODE:
      return node.length;

    default:
      return node.childNodes.length;
  }
}
/**
 * Given a collapsed range, move the start position backwards as far as
 * possible while the range still spans only a single line.
 */


function expandRangeToStartOfLine(range) {
  !range.collapsed ?  false ? invariant(false, 'expandRangeToStartOfLine: Provided range is not collapsed.') : invariant(false) : void 0;
  range = range.cloneRange();
  var containingElement = range.startContainer;

  if (containingElement.nodeType !== 1) {
    containingElement = containingElement.parentNode;
  }

  var lineHeight = getLineHeightPx(containingElement); // Imagine our text looks like:
  //   <div><span>once upon a time, there was a <em>boy
  //   who lived</em> </span><q><strong>under^ the
  //   stairs</strong> in a small closet.</q></div>
  // where the caret represents the cursor. First, we crawl up the tree until
  // the range spans multiple lines (setting the start point to before
  // "<strong>", then before "<div>"), then at each level we do a search to
  // find the latest point which is still on a previous line. We'll find that
  // the break point is inside the span, then inside the <em>, then in its text
  // node child, the actual break point before "who".

  var bestContainer = range.endContainer;
  var bestOffset = range.endOffset;
  range.setStart(range.startContainer, 0);

  while (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
    bestContainer = range.startContainer;
    bestOffset = range.startOffset;
    !bestContainer.parentNode ?  false ? invariant(false, 'Found unexpected detached subtree when traversing.') : invariant(false) : void 0;
    range.setStartBefore(bestContainer);

    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
      // The start of the line is never in a different block-level container.
      break;
    }
  } // In the above example, range now spans from "<div>" to "under",
  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
  // Picking out which child to recurse into here is a special case since we
  // don't want to check past <q> -- once we find that the final range starts
  // in <span>, we can look at all of its children (and all of their children)
  // to find the break point.
  // At all times, (bestContainer, bestOffset) is the latest single-line start
  // point that we know of.


  var currentContainer = bestContainer;
  var maxIndexToConsider = bestOffset - 1;

  do {
    var nodeValue = currentContainer.nodeValue;
    var ii = maxIndexToConsider;

    for (; ii >= 0; ii--) {
      if (nodeValue != null && ii > 0 && UnicodeUtils.isSurrogatePair(nodeValue, ii - 1)) {
        // We're in the middle of a surrogate pair -- skip over so we never
        // return a range with an endpoint in the middle of a code point.
        continue;
      }

      range.setStart(currentContainer, ii);

      if (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
        bestContainer = currentContainer;
        bestOffset = ii;
      } else {
        break;
      }
    }

    if (ii === -1 || currentContainer.childNodes.length === 0) {
      // If ii === -1, then (bestContainer, bestOffset), which is equal to
      // (currentContainer, 0), was a single-line start point but a start
      // point before currentContainer wasn't, so the line break seems to
      // have occurred immediately after currentContainer's start tag
      //
      // If currentContainer.childNodes.length === 0, we're already at a
      // terminal node (e.g., text node) and should return our current best.
      break;
    }

    currentContainer = currentContainer.childNodes[ii];
    maxIndexToConsider = getNodeLength(currentContainer);
  } while (true);

  range.setStart(bestContainer, bestOffset);
  return range;
}

module.exports = expandRangeToStartOfLine;

/***/ }),
/* 2897 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftEntitySegments = __webpack_require__(2868);

var getRangesForDraftEntity = __webpack_require__(2899);

var invariant = __webpack_require__(48);
/**
 * Given a SelectionState and a removal direction, determine the entire range
 * that should be removed from a ContentState. This is based on any entities
 * within the target, with their `mutability` values taken into account.
 *
 * For instance, if we are attempting to remove part of an "immutable" entity
 * range, the entire entity must be removed. The returned `SelectionState`
 * will be adjusted accordingly.
 */


function getCharacterRemovalRange(entityMap, startBlock, endBlock, selectionState, direction) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();
  var startEntityKey = startBlock.getEntityAt(start);
  var endEntityKey = endBlock.getEntityAt(end - 1);

  if (!startEntityKey && !endEntityKey) {
    return selectionState;
  }

  var newSelectionState = selectionState;

  if (startEntityKey && startEntityKey === endEntityKey) {
    newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, true, true);
  } else if (startEntityKey && endEntityKey) {
    var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
    var endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
    newSelectionState = newSelectionState.merge({
      anchorOffset: startSelectionState.getAnchorOffset(),
      focusOffset: endSelectionState.getFocusOffset(),
      isBackward: false
    });
  } else if (startEntityKey) {
    var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);

    newSelectionState = newSelectionState.merge({
      anchorOffset: _startSelectionState.getStartOffset(),
      isBackward: false
    });
  } else if (endEntityKey) {
    var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);

    newSelectionState = newSelectionState.merge({
      focusOffset: _endSelectionState.getEndOffset(),
      isBackward: false
    });
  }

  return newSelectionState;
}

function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
  var start = selectionState.getStartOffset();
  var end = selectionState.getEndOffset();

  var entity = entityMap.__get(entityKey);

  var mutability = entity.getMutability();
  var sideToConsider = isEntityAtStart ? start : end; // `MUTABLE` entities can just have the specified range of text removed
  // directly. No adjustments are needed.

  if (mutability === 'MUTABLE') {
    return selectionState;
  } // Find the entity range that overlaps with our removal range.


  var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function (range) {
    return sideToConsider <= range.end && sideToConsider >= range.start;
  });
  !(entityRanges.length == 1) ?  false ? invariant(false, 'There should only be one entity range within this removal range.') : invariant(false) : void 0;
  var entityRange = entityRanges[0]; // For `IMMUTABLE` entity types, we will remove the entire entity range.

  if (mutability === 'IMMUTABLE') {
    return selectionState.merge({
      anchorOffset: entityRange.start,
      focusOffset: entityRange.end,
      isBackward: false
    });
  } // For `SEGMENTED` entity types, determine the appropriate segment to
  // remove.


  if (!isEntireSelectionWithinEntity) {
    if (isEntityAtStart) {
      end = entityRange.end;
    } else {
      start = entityRange.start;
    }
  }

  var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);
  return selectionState.merge({
    anchorOffset: removalRange.start,
    focusOffset: removalRange.end,
    isBackward: false
  });
}

module.exports = getCharacterRemovalRange;

/***/ }),
/* 2898 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var getRangeClientRects = __webpack_require__(1180);

/**
 * Like range.getBoundingClientRect() but normalizes for browser bugs.
 */
function getRangeBoundingClientRect(range) {
  // "Return a DOMRect object describing the smallest rectangle that includes
  // the first rectangle in list and all of the remaining rectangles of which
  // the height or width is not zero."
  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
  var rects = getRangeClientRects(range);
  var top = 0;
  var right = 0;
  var bottom = 0;
  var left = 0;

  if (rects.length) {
    // If the first rectangle has 0 width, we use the second, this is needed
    // because Chrome renders a 0 width rectangle when the selection contains
    // a line break.
    if (rects.length > 1 && rects[0].width === 0) {
      var _rects$ = rects[1];
      top = _rects$.top;
      right = _rects$.right;
      bottom = _rects$.bottom;
      left = _rects$.left;
    } else {
      var _rects$2 = rects[0];
      top = _rects$2.top;
      right = _rects$2.right;
      bottom = _rects$2.bottom;
      left = _rects$2.left;
    }

    for (var ii = 1; ii < rects.length; ii++) {
      var rect = rects[ii];

      if (rect.height !== 0 && rect.width !== 0) {
        top = Math.min(top, rect.top);
        right = Math.max(right, rect.right);
        bottom = Math.max(bottom, rect.bottom);
        left = Math.min(left, rect.left);
      }
    }
  }

  return {
    top: top,
    right: right,
    bottom: bottom,
    left: left,
    width: right - left,
    height: bottom - top
  };
}

module.exports = getRangeBoundingClientRect;

/***/ }),
/* 2899 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var invariant = __webpack_require__(48);
/**
 * Obtain the start and end positions of the range that has the
 * specified entity applied to it.
 *
 * Entity keys are applied only to contiguous stretches of text, so this
 * method searches for the first instance of the entity key and returns
 * the subsequent range.
 */


function getRangesForDraftEntity(block, key) {
  var ranges = [];
  block.findEntityRanges(function (c) {
    return c.getEntity() === key;
  }, function (start, end) {
    ranges.push({
      start: start,
      end: end
    });
  });
  !!!ranges.length ?  false ? invariant(false, 'Entity key not found in this range.') : invariant(false) : void 0;
  return ranges;
}

module.exports = getRangesForDraftEntity;

/***/ }),
/* 2900 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var getRangeBoundingClientRect = __webpack_require__(2898);
/**
 * Return the bounding ClientRect for the visible DOM selection, if any.
 * In cases where there are no selected ranges or the bounding rect is
 * temporarily invalid, return null.
 *
 * When using from an iframe, you should pass the iframe window object
 */


function getVisibleSelectionRect(global) {
  var selection = global.getSelection();

  if (!selection.rangeCount) {
    return null;
  }

  var range = selection.getRangeAt(0);
  var boundingRect = getRangeBoundingClientRect(range);
  var top = boundingRect.top,
      right = boundingRect.right,
      bottom = boundingRect.bottom,
      left = boundingRect.left; // When a re-render leads to a node being removed, the DOM selection will
  // temporarily be placed on an ancestor node, which leads to an invalid
  // bounding rect. Discard this state.

  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
    return null;
  }

  return boundingRect;
}

module.exports = getVisibleSelectionRect;

/***/ }),
/* 2901 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var BlockMapBuilder = __webpack_require__(337);

var ContentBlockNode = __webpack_require__(134);

var Immutable = __webpack_require__(46);

var insertIntoList = __webpack_require__(1186);

var invariant = __webpack_require__(48);

var randomizeBlockMapKeys = __webpack_require__(1191);

var List = Immutable.List;

var updateExistingBlock = function updateExistingBlock(contentState, selectionState, blockMap, fragmentBlock, targetKey, targetOffset) {
  var mergeBlockData = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 'REPLACE_WITH_NEW_DATA';
  var targetBlock = blockMap.get(targetKey);
  var text = targetBlock.getText();
  var chars = targetBlock.getCharacterList();
  var finalKey = targetKey;
  var finalOffset = targetOffset + fragmentBlock.getText().length;
  var data = null;

  switch (mergeBlockData) {
    case 'MERGE_OLD_DATA_TO_NEW_DATA':
      data = fragmentBlock.getData().merge(targetBlock.getData());
      break;

    case 'REPLACE_WITH_NEW_DATA':
      data = fragmentBlock.getData();
      break;
  }

  var type = targetBlock.getType();

  if (text && type === 'unstyled') {
    type = fragmentBlock.getType();
  }

  var newBlock = targetBlock.merge({
    text: text.slice(0, targetOffset) + fragmentBlock.getText() + text.slice(targetOffset),
    characterList: insertIntoList(chars, fragmentBlock.getCharacterList(), targetOffset),
    type: type,
    data: data
  });
  return contentState.merge({
    blockMap: blockMap.set(targetKey, newBlock),
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};
/**
 * Appends text/characterList from the fragment first block to
 * target block.
 */


var updateHead = function updateHead(block, targetOffset, fragment) {
  var text = block.getText();
  var chars = block.getCharacterList(); // Modify head portion of block.

  var headText = text.slice(0, targetOffset);
  var headCharacters = chars.slice(0, targetOffset);
  var appendToHead = fragment.first();
  return block.merge({
    text: headText + appendToHead.getText(),
    characterList: headCharacters.concat(appendToHead.getCharacterList()),
    type: headText ? block.getType() : appendToHead.getType(),
    data: appendToHead.getData()
  });
};
/**
 * Appends offset text/characterList from the target block to the last
 * fragment block.
 */


var updateTail = function updateTail(block, targetOffset, fragment) {
  // Modify tail portion of block.
  var text = block.getText();
  var chars = block.getCharacterList(); // Modify head portion of block.

  var blockSize = text.length;
  var tailText = text.slice(targetOffset, blockSize);
  var tailCharacters = chars.slice(targetOffset, blockSize);
  var prependToTail = fragment.last();
  return prependToTail.merge({
    text: prependToTail.getText() + tailText,
    characterList: prependToTail.getCharacterList().concat(tailCharacters),
    data: prependToTail.getData()
  });
};

var getRootBlocks = function getRootBlocks(block, blockMap) {
  var headKey = block.getKey();
  var rootBlock = block;
  var rootBlocks = []; // sometimes the fragment head block will not be part of the blockMap itself this can happen when
  // the fragment head is used to update the target block, however when this does not happen we need
  // to make sure that we include it on the rootBlocks since the first block of a fragment is always a
  // fragment root block

  if (blockMap.get(headKey)) {
    rootBlocks.push(headKey);
  }

  while (rootBlock && rootBlock.getNextSiblingKey()) {
    var lastSiblingKey = rootBlock.getNextSiblingKey();

    if (!lastSiblingKey) {
      break;
    }

    rootBlocks.push(lastSiblingKey);
    rootBlock = blockMap.get(lastSiblingKey);
  }

  return rootBlocks;
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockMap, targetBlock, fragmentHeadBlock) {
  return blockMap.withMutations(function (blockMapState) {
    var targetKey = targetBlock.getKey();
    var headKey = fragmentHeadBlock.getKey();
    var targetNextKey = targetBlock.getNextSiblingKey();
    var targetParentKey = targetBlock.getParentKey();
    var fragmentRootBlocks = getRootBlocks(fragmentHeadBlock, blockMap);
    var lastRootFragmentBlockKey = fragmentRootBlocks[fragmentRootBlocks.length - 1];

    if (blockMapState.get(headKey)) {
      // update the fragment head when it is part of the blockMap otherwise
      blockMapState.setIn([targetKey, 'nextSibling'], headKey);
      blockMapState.setIn([headKey, 'prevSibling'], targetKey);
    } else {
      // update the target block that had the fragment head contents merged into it
      blockMapState.setIn([targetKey, 'nextSibling'], fragmentHeadBlock.getNextSiblingKey());
      blockMapState.setIn([fragmentHeadBlock.getNextSiblingKey(), 'prevSibling'], targetKey);
    } // update the last root block fragment


    blockMapState.setIn([lastRootFragmentBlockKey, 'nextSibling'], targetNextKey); // update the original target next block

    if (targetNextKey) {
      blockMapState.setIn([targetNextKey, 'prevSibling'], lastRootFragmentBlockKey);
    } // update fragment parent links


    fragmentRootBlocks.forEach(function (blockKey) {
      return blockMapState.setIn([blockKey, 'parent'], targetParentKey);
    }); // update targetBlock parent child links

    if (targetParentKey) {
      var targetParent = blockMap.get(targetParentKey);
      var originalTargetParentChildKeys = targetParent.getChildKeys();
      var targetBlockIndex = originalTargetParentChildKeys.indexOf(targetKey);
      var insertionIndex = targetBlockIndex + 1;
      var newChildrenKeysArray = originalTargetParentChildKeys.toArray(); // insert fragment children

      newChildrenKeysArray.splice.apply(newChildrenKeysArray, [insertionIndex, 0].concat(fragmentRootBlocks));
      blockMapState.setIn([targetParentKey, 'children'], List(newChildrenKeysArray));
    }
  });
};

var insertFragment = function insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset) {
  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
  var newBlockArr = [];
  var fragmentSize = fragment.size;
  var target = blockMap.get(targetKey);
  var head = fragment.first();
  var tail = fragment.last();
  var finalOffset = tail.getLength();
  var finalKey = tail.getKey();
  var shouldNotUpdateFromFragmentBlock = isTreeBasedBlockMap && (!target.getChildKeys().isEmpty() || !head.getChildKeys().isEmpty());
  blockMap.forEach(function (block, blockKey) {
    if (blockKey !== targetKey) {
      newBlockArr.push(block);
      return;
    }

    if (shouldNotUpdateFromFragmentBlock) {
      newBlockArr.push(block);
    } else {
      newBlockArr.push(updateHead(block, targetOffset, fragment));
    } // Insert fragment blocks after the head and before the tail.


    fragment // when we are updating the target block with the head fragment block we skip the first fragment
    // head since its contents have already been merged with the target block otherwise we include
    // the whole fragment
    .slice(shouldNotUpdateFromFragmentBlock ? 0 : 1, fragmentSize - 1).forEach(function (fragmentBlock) {
      return newBlockArr.push(fragmentBlock);
    }); // update tail

    newBlockArr.push(updateTail(block, targetOffset, fragment));
  });
  var updatedBlockMap = BlockMapBuilder.createFromArray(newBlockArr);

  if (isTreeBasedBlockMap) {
    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, blockMap, target, head);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: finalKey,
      anchorOffset: finalOffset,
      focusKey: finalKey,
      focusOffset: finalOffset,
      isBackward: false
    })
  });
};

var insertFragmentIntoContentState = function insertFragmentIntoContentState(contentState, selectionState, fragmentBlockMap) {
  var mergeBlockData = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'REPLACE_WITH_NEW_DATA';
  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertFragment` should only be called with a collapsed selection state.') : invariant(false) : void 0;
  var blockMap = contentState.getBlockMap();
  var fragment = randomizeBlockMapKeys(fragmentBlockMap);
  var targetKey = selectionState.getStartKey();
  var targetOffset = selectionState.getStartOffset();
  var targetBlock = blockMap.get(targetKey);

  if (targetBlock instanceof ContentBlockNode) {
    !targetBlock.getChildKeys().isEmpty() ?  false ? invariant(false, '`insertFragment` should not be called when a container node is selected.') : invariant(false) : void 0;
  } // When we insert a fragment with a single block we simply update the target block
  // with the contents of the inserted fragment block


  if (fragment.size === 1) {
    return updateExistingBlock(contentState, selectionState, blockMap, fragment.first(), targetKey, targetOffset, mergeBlockData);
  }

  return insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset);
};

module.exports = insertFragmentIntoContentState;

/***/ }),
/* 2902 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var Immutable = __webpack_require__(46);

var insertIntoList = __webpack_require__(1186);

var invariant = __webpack_require__(48);

var Repeat = Immutable.Repeat;

function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertText` should only be called with a collapsed range.') : invariant(false) : void 0;
  var len = null;

  if (text != null) {
    len = text.length;
  }

  if (len == null || len === 0) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var key = selectionState.getStartKey();
  var offset = selectionState.getStartOffset();
  var block = blockMap.get(key);
  var blockText = block.getText();
  var newBlock = block.merge({
    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
    characterList: insertIntoList(block.getCharacterList(), Repeat(characterMetadata, len).toList(), offset)
  });
  var newOffset = offset + len;
  return contentState.merge({
    blockMap: blockMap.set(key, newBlock),
    selectionAfter: selectionState.merge({
      anchorOffset: newOffset,
      focusOffset: newOffset
    })
  });
}

module.exports = insertTextIntoContentState;

/***/ }),
/* 2903 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var isElement = __webpack_require__(242);

function isHTMLAnchorElement(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  return isElement(node) && node.nodeName === 'A';
}

module.exports = isHTMLAnchorElement;

/***/ }),
/* 2904 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
var isElement = __webpack_require__(242);

function isHTMLImageElement(node) {
  if (!node || !node.ownerDocument) {
    return false;
  }

  return isElement(node) && node.nodeName === 'IMG';
}

module.exports = isHTMLImageElement;

/***/ }),
/* 2905 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */
function isInstanceOfNode(target) {
  // we changed the name because of having duplicate module provider (fbjs)
  if (!target || !('ownerDocument' in target)) {
    return false;
  }

  if ('ownerDocument' in target) {
    var node = target;

    if (!node.ownerDocument.defaultView) {
      return node instanceof Node;
    }

    if (node instanceof node.ownerDocument.defaultView.Node) {
      return true;
    }
  }

  return false;
}

module.exports = isInstanceOfNode;

/***/ }),
/* 2906 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


function isSelectionAtLeafStart(editorState) {
  var selection = editorState.getSelection();
  var anchorKey = selection.getAnchorKey();
  var blockTree = editorState.getBlockTree(anchorKey);
  var offset = selection.getStartOffset();
  var isAtStart = false;
  blockTree.some(function (leafSet) {
    if (offset === leafSet.get('start')) {
      isAtStart = true;
      return true;
    }

    if (offset < leafSet.get('end')) {
      return leafSet.get('leaves').some(function (leaf) {
        var leafStart = leaf.get('start');

        if (offset === leafStart) {
          isAtStart = true;
          return true;
        }

        return false;
      });
    }

    return false;
  });
  return isAtStart;
}

module.exports = isSelectionAtLeafStart;

/***/ }),
/* 2907 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var Keys = __webpack_require__(430);

function isSoftNewlineEvent(e) {
  return e.which === Keys.RETURN && (e.getModifierState('Shift') || e.getModifierState('Alt') || e.getModifierState('Control'));
}

module.exports = isSoftNewlineEvent;

/***/ }),
/* 2908 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(62);

var expandRangeToStartOfLine = __webpack_require__(2896);

var getDraftEditorSelectionWithNodes = __webpack_require__(1176);

var moveSelectionBackward = __webpack_require__(648);

var removeTextWithStrategy = __webpack_require__(341);

function keyCommandBackspaceToStartOfLine(editorState, e) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();

    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
      return moveSelectionBackward(strategyState, 1);
    }

    var ownerDocument = e.currentTarget.ownerDocument;
    var domSelection = ownerDocument.defaultView.getSelection(); // getRangeAt can technically throw if there's no selection, but we know
    // there is one here because text editor has focus (the cursor is a
    // selection of length 0). Therefore, we don't need to wrap this in a
    // try-catch block.

    var range = domSelection.getRangeAt(0);
    range = expandRangeToStartOfLine(range);
    return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandBackspaceToStartOfLine;

/***/ }),
/* 2909 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftRemovableWord = __webpack_require__(1167);

var EditorState = __webpack_require__(62);

var moveSelectionBackward = __webpack_require__(648);

var removeTextWithStrategy = __webpack_require__(341);
/**
 * Delete the word that is left of the cursor, as well as any spaces or
 * punctuation after the word.
 */


function keyCommandBackspaceWord(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset(); // If there are no words before the cursor, remove the preceding newline.

    if (offset === 0) {
      return moveSelectionBackward(strategyState, 1);
    }

    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(0, offset);
    var toRemove = DraftRemovableWord.getBackward(text);
    return moveSelectionBackward(strategyState, toRemove.length || 1);
  }, 'backward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandBackspaceWord;

/***/ }),
/* 2910 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftRemovableWord = __webpack_require__(1167);

var EditorState = __webpack_require__(62);

var moveSelectionForward = __webpack_require__(1190);

var removeTextWithStrategy = __webpack_require__(341);
/**
 * Delete the word that is right of the cursor, as well as any spaces or
 * punctuation before the word.
 */


function keyCommandDeleteWord(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var offset = selection.getStartOffset();
    var key = selection.getStartKey();
    var content = strategyState.getCurrentContent();
    var text = content.getBlockForKey(key).getText().slice(offset);
    var toRemove = DraftRemovableWord.getForward(text); // If there are no words in front of the cursor, remove the newline.

    return moveSelectionForward(strategyState, toRemove.length || 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  return EditorState.push(editorState, afterRemoval, 'remove-range');
}

module.exports = keyCommandDeleteWord;

/***/ }),
/* 2911 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(105);

var EditorState = __webpack_require__(62);

function keyCommandInsertNewline(editorState) {
  var contentState = DraftModifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
  return EditorState.push(editorState, contentState, 'split-block');
}

module.exports = keyCommandInsertNewline;

/***/ }),
/* 2912 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(62);
/**
 * See comment for `moveSelectionToStartOfBlock`.
 */


function keyCommandMoveSelectionToEndOfBlock(editorState) {
  var selection = editorState.getSelection();
  var endKey = selection.getEndKey();
  var content = editorState.getCurrentContent();
  var textLength = content.getBlockForKey(endKey).getLength();
  return EditorState.set(editorState, {
    selection: selection.merge({
      anchorKey: endKey,
      anchorOffset: textLength,
      focusKey: endKey,
      focusOffset: textLength,
      isBackward: false
    }),
    forceSelection: true
  });
}

module.exports = keyCommandMoveSelectionToEndOfBlock;

/***/ }),
/* 2913 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(62);
/**
 * Collapse selection at the start of the first selected block. This is used
 * for Firefox versions that attempt to navigate forward/backward instead of
 * moving the cursor. Other browsers are able to move the cursor natively.
 */


function keyCommandMoveSelectionToStartOfBlock(editorState) {
  var selection = editorState.getSelection();
  var startKey = selection.getStartKey();
  return EditorState.set(editorState, {
    selection: selection.merge({
      anchorKey: startKey,
      anchorOffset: 0,
      focusKey: startKey,
      focusOffset: 0,
      isBackward: false
    }),
    forceSelection: true
  });
}

module.exports = keyCommandMoveSelectionToStartOfBlock;

/***/ }),
/* 2914 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(62);

var UnicodeUtils = __webpack_require__(243);

var moveSelectionForward = __webpack_require__(1190);

var removeTextWithStrategy = __webpack_require__(341);
/**
 * Remove the selected range. If the cursor is collapsed, remove the following
 * character. This operation is Unicode-aware, so removing a single character
 * will remove a surrogate pair properly as well.
 */


function keyCommandPlainDelete(editorState) {
  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
    var selection = strategyState.getSelection();
    var content = strategyState.getCurrentContent();
    var key = selection.getAnchorKey();
    var offset = selection.getAnchorOffset();
    var charAhead = content.getBlockForKey(key).getText()[offset];
    return moveSelectionForward(strategyState, charAhead ? UnicodeUtils.getUTF16Length(charAhead, 0) : 1);
  }, 'forward');

  if (afterRemoval === editorState.getCurrentContent()) {
    return editorState;
  }

  var selection = editorState.getSelection();
  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
}

module.exports = keyCommandPlainDelete;

/***/ }),
/* 2915 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftModifier = __webpack_require__(105);

var EditorState = __webpack_require__(62);

var getContentStateFragment = __webpack_require__(427);
/**
 * Transpose the characters on either side of a collapsed cursor, or
 * if the cursor is at the end of the block, transpose the last two
 * characters.
 */


function keyCommandTransposeCharacters(editorState) {
  var selection = editorState.getSelection();

  if (!selection.isCollapsed()) {
    return editorState;
  }

  var offset = selection.getAnchorOffset();

  if (offset === 0) {
    return editorState;
  }

  var blockKey = selection.getAnchorKey();
  var content = editorState.getCurrentContent();
  var block = content.getBlockForKey(blockKey);
  var length = block.getLength(); // Nothing to transpose if there aren't two characters.

  if (length <= 1) {
    return editorState;
  }

  var removalRange;
  var finalSelection;

  if (offset === length) {
    // The cursor is at the end of the block. Swap the last two characters.
    removalRange = selection.set('anchorOffset', offset - 1);
    finalSelection = selection;
  } else {
    removalRange = selection.set('focusOffset', offset + 1);
    finalSelection = removalRange.set('anchorOffset', offset + 1);
  } // Extract the character to move as a fragment. This preserves its
  // styling and entity, if any.


  var movedFragment = getContentStateFragment(content, removalRange);
  var afterRemoval = DraftModifier.removeRange(content, removalRange, 'backward'); // After the removal, the insertion target is one character back.

  var selectionAfter = afterRemoval.getSelectionAfter();
  var targetOffset = selectionAfter.getAnchorOffset() - 1;
  var targetRange = selectionAfter.merge({
    anchorOffset: targetOffset,
    focusOffset: targetOffset
  });
  var afterInsert = DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
  var newEditorState = EditorState.push(editorState, afterInsert, 'insert-fragment');
  return EditorState.acceptSelection(newEditorState, finalSelection);
}

module.exports = keyCommandTransposeCharacters;

/***/ }),
/* 2916 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var EditorState = __webpack_require__(62);

function keyCommandUndo(e, editorState, updateFn) {
  var undoneState = EditorState.undo(editorState); // If the last change to occur was a spellcheck change, allow the undo
  // event to fall through to the browser. This allows the browser to record
  // the unwanted change, which should soon lead it to learn not to suggest
  // the correction again.

  if (editorState.getLastChangeType() === 'spellcheck-change') {
    var nativelyRenderedContent = undoneState.getCurrentContent();
    updateFn(EditorState.set(undoneState, {
      nativelyRenderedContent: nativelyRenderedContent
    }));
    return;
  } // Otheriwse, manage the undo behavior manually.


  e.preventDefault();

  if (!editorState.getNativelyRenderedContent()) {
    updateFn(undoneState);
    return;
  } // Trigger a re-render with the current content state to ensure that the
  // component tree has up-to-date props for comparison.


  updateFn(EditorState.set(editorState, {
    nativelyRenderedContent: null
  })); // Wait to ensure that the re-render has occurred before performing
  // the undo action.

  setTimeout(function () {
    updateFn(undoneState);
  }, 0);
}

module.exports = keyCommandUndo;

/***/ }),
/* 2917 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var ContentBlockNode = __webpack_require__(134);

var getNextDelimiterBlockKey = __webpack_require__(1178);

var Immutable = __webpack_require__(46);

var invariant = __webpack_require__(48);

var OrderedMap = Immutable.OrderedMap,
    List = Immutable.List;

var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockToBeMoved, originalTargetBlock, insertionMode, isExperimentalTreeBlock) {
  if (!isExperimentalTreeBlock) {
    return blockMap;
  } // possible values of 'insertionMode' are: 'after', 'before'


  var isInsertedAfterTarget = insertionMode === 'after';
  var originalBlockKey = originalBlockToBeMoved.getKey();
  var originalTargetKey = originalTargetBlock.getKey();
  var originalParentKey = originalBlockToBeMoved.getParentKey();
  var originalNextSiblingKey = originalBlockToBeMoved.getNextSiblingKey();
  var originalPrevSiblingKey = originalBlockToBeMoved.getPrevSiblingKey();
  var newParentKey = originalTargetBlock.getParentKey();
  var newNextSiblingKey = isInsertedAfterTarget ? originalTargetBlock.getNextSiblingKey() : originalTargetKey;
  var newPrevSiblingKey = isInsertedAfterTarget ? originalTargetKey : originalTargetBlock.getPrevSiblingKey();
  return blockMap.withMutations(function (blocks) {
    // update old parent
    transformBlock(originalParentKey, blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      return block.merge({
        children: parentChildrenList["delete"](parentChildrenList.indexOf(originalBlockKey))
      });
    }); // update old prev

    transformBlock(originalPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalNextSiblingKey
      });
    }); // update old next

    transformBlock(originalNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalPrevSiblingKey
      });
    }); // update new next

    transformBlock(newNextSiblingKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    }); // update new prev

    transformBlock(newPrevSiblingKey, blocks, function (block) {
      return block.merge({
        nextSibling: originalBlockKey
      });
    }); // update new parent

    transformBlock(newParentKey, blocks, function (block) {
      var newParentChildrenList = block.getChildKeys();
      var targetBlockIndex = newParentChildrenList.indexOf(originalTargetKey);
      var insertionIndex = isInsertedAfterTarget ? targetBlockIndex + 1 : targetBlockIndex !== 0 ? targetBlockIndex - 1 : 0;
      var newChildrenArray = newParentChildrenList.toArray();
      newChildrenArray.splice(insertionIndex, 0, originalBlockKey);
      return block.merge({
        children: List(newChildrenArray)
      });
    }); // update block

    transformBlock(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: newNextSiblingKey,
        prevSibling: newPrevSiblingKey,
        parent: newParentKey
      });
    });
  });
};

var moveBlockInContentState = function moveBlockInContentState(contentState, blockToBeMoved, targetBlock, insertionMode) {
  !(insertionMode !== 'replace') ?  false ? invariant(false, 'Replacing blocks is not supported.') : invariant(false) : void 0;
  var targetKey = targetBlock.getKey();
  var blockKey = blockToBeMoved.getKey();
  !(blockKey !== targetKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
  var blockMap = contentState.getBlockMap();
  var isExperimentalTreeBlock = blockToBeMoved instanceof ContentBlockNode;
  var blocksToBeMoved = [blockToBeMoved];
  var blockMapWithoutBlocksToBeMoved = blockMap["delete"](blockKey);

  if (isExperimentalTreeBlock) {
    blocksToBeMoved = [];
    blockMapWithoutBlocksToBeMoved = blockMap.withMutations(function (blocks) {
      var nextSiblingKey = blockToBeMoved.getNextSiblingKey();
      var nextDelimiterBlockKey = getNextDelimiterBlockKey(blockToBeMoved, blocks);
      blocks.toSeq().skipUntil(function (block) {
        return block.getKey() === blockKey;
      }).takeWhile(function (block) {
        var key = block.getKey();
        var isBlockToBeMoved = key === blockKey;
        var hasNextSiblingAndIsNotNextSibling = nextSiblingKey && key !== nextSiblingKey;
        var doesNotHaveNextSiblingAndIsNotDelimiter = !nextSiblingKey && block.getParentKey() && (!nextDelimiterBlockKey || key !== nextDelimiterBlockKey);
        return !!(isBlockToBeMoved || hasNextSiblingAndIsNotNextSibling || doesNotHaveNextSiblingAndIsNotDelimiter);
      }).forEach(function (block) {
        blocksToBeMoved.push(block);
        blocks["delete"](block.getKey());
      });
    });
  }

  var blocksBefore = blockMapWithoutBlocksToBeMoved.toSeq().takeUntil(function (v) {
    return v === targetBlock;
  });
  var blocksAfter = blockMapWithoutBlocksToBeMoved.toSeq().skipUntil(function (v) {
    return v === targetBlock;
  }).skip(1);
  var slicedBlocks = blocksToBeMoved.map(function (block) {
    return [block.getKey(), block];
  });
  var newBlocks = OrderedMap();

  if (insertionMode === 'before') {
    var blockBefore = contentState.getBlockBefore(targetKey);
    !(!blockBefore || blockBefore.getKey() !== blockToBeMoved.getKey()) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
    newBlocks = blocksBefore.concat([].concat(slicedBlocks, [[targetKey, targetBlock]]), blocksAfter).toOrderedMap();
  } else if (insertionMode === 'after') {
    var blockAfter = contentState.getBlockAfter(targetKey);
    !(!blockAfter || blockAfter.getKey() !== blockKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
    newBlocks = blocksBefore.concat([[targetKey, targetBlock]].concat(slicedBlocks), blocksAfter).toOrderedMap();
  }

  return contentState.merge({
    blockMap: updateBlockMapLinks(newBlocks, blockToBeMoved, targetBlock, insertionMode, isExperimentalTreeBlock),
    selectionBefore: contentState.getSelectionAfter(),
    selectionAfter: contentState.getSelectionAfter().merge({
      anchorKey: blockKey,
      focusKey: blockKey
    })
  });
};

module.exports = moveBlockInContentState;

/***/ }),
/* 2918 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var ContentBlockNode = __webpack_require__(134);

var getNextDelimiterBlockKey = __webpack_require__(1178);

var Immutable = __webpack_require__(46);

var List = Immutable.List,
    Map = Immutable.Map;

var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};
/**
 * Ancestors needs to be preserved when there are non selected
 * children to make sure we do not leave any orphans behind
 */


var getAncestorsKeys = function getAncestorsKeys(blockKey, blockMap) {
  var parents = [];

  if (!blockKey) {
    return parents;
  }

  var blockNode = blockMap.get(blockKey);

  while (blockNode && blockNode.getParentKey()) {
    var parentKey = blockNode.getParentKey();

    if (parentKey) {
      parents.push(parentKey);
    }

    blockNode = parentKey ? blockMap.get(parentKey) : null;
  }

  return parents;
};
/**
 * Get all next delimiter keys until we hit a root delimiter and return
 * an array of key references
 */


var getNextDelimitersBlockKeys = function getNextDelimitersBlockKeys(block, blockMap) {
  var nextDelimiters = [];

  if (!block) {
    return nextDelimiters;
  }

  var nextDelimiter = getNextDelimiterBlockKey(block, blockMap);

  while (nextDelimiter && blockMap.get(nextDelimiter)) {
    var _block = blockMap.get(nextDelimiter);

    nextDelimiters.push(nextDelimiter); // we do not need to keep checking all root node siblings, just the first occurance

    nextDelimiter = _block.getParentKey() ? getNextDelimiterBlockKey(_block, blockMap) : null;
  }

  return nextDelimiters;
};

var getNextValidSibling = function getNextValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  } // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations


  var nextValidSiblingKey = originalBlockMap.get(block.getKey()).getNextSiblingKey();

  while (nextValidSiblingKey && !blockMap.get(nextValidSiblingKey)) {
    nextValidSiblingKey = originalBlockMap.get(nextValidSiblingKey).getNextSiblingKey() || null;
  }

  return nextValidSiblingKey;
};

var getPrevValidSibling = function getPrevValidSibling(block, blockMap, originalBlockMap) {
  if (!block) {
    return null;
  } // note that we need to make sure we refer to the original block since this
  // function is called within a withMutations


  var prevValidSiblingKey = originalBlockMap.get(block.getKey()).getPrevSiblingKey();

  while (prevValidSiblingKey && !blockMap.get(prevValidSiblingKey)) {
    prevValidSiblingKey = originalBlockMap.get(prevValidSiblingKey).getPrevSiblingKey() || null;
  }

  return prevValidSiblingKey;
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, startBlock, endBlock, originalBlockMap) {
  return blockMap.withMutations(function (blocks) {
    // update start block if its retained
    transformBlock(startBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
      });
    }); // update endblock if its retained

    transformBlock(endBlock.getKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
        prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
      });
    }); // update start block parent ancestors

    getAncestorsKeys(startBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      return transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    }); // update start block next - can only happen if startBlock == endBlock

    transformBlock(startBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: startBlock.getPrevSiblingKey()
      });
    }); // update start block prev

    transformBlock(startBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: getNextValidSibling(block, blocks, originalBlockMap)
      });
    }); // update end block next

    transformBlock(endBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
      });
    }); // update end block prev

    transformBlock(endBlock.getPrevSiblingKey(), blocks, function (block) {
      return block.merge({
        nextSibling: endBlock.getNextSiblingKey()
      });
    }); // update end block parent ancestors

    getAncestorsKeys(endBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
      transformBlock(parentKey, blocks, function (block) {
        return block.merge({
          children: block.getChildKeys().filter(function (key) {
            return blocks.get(key);
          }),
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    }); // update next delimiters all the way to a root delimiter

    getNextDelimitersBlockKeys(endBlock, originalBlockMap).forEach(function (delimiterKey) {
      return transformBlock(delimiterKey, blocks, function (block) {
        return block.merge({
          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
        });
      });
    }); // if parent (startBlock) was deleted

    if (blockMap.get(startBlock.getKey()) == null && blockMap.get(endBlock.getKey()) != null && endBlock.getParentKey() === startBlock.getKey() && endBlock.getPrevSiblingKey() == null) {
      var prevSiblingKey = startBlock.getPrevSiblingKey(); // endBlock becomes next sibling of parent's prevSibling

      transformBlock(endBlock.getKey(), blocks, function (block) {
        return block.merge({
          prevSibling: prevSiblingKey
        });
      });
      transformBlock(prevSiblingKey, blocks, function (block) {
        return block.merge({
          nextSibling: endBlock.getKey()
        });
      }); // Update parent for previous parent's children, and children for that parent

      var prevSibling = prevSiblingKey ? blockMap.get(prevSiblingKey) : null;
      var newParentKey = prevSibling ? prevSibling.getParentKey() : null;
      startBlock.getChildKeys().forEach(function (childKey) {
        transformBlock(childKey, blocks, function (block) {
          return block.merge({
            parent: newParentKey // set to null if there is no parent

          });
        });
      });

      if (newParentKey != null) {
        var newParent = blockMap.get(newParentKey);
        transformBlock(newParentKey, blocks, function (block) {
          return block.merge({
            children: newParent.getChildKeys().concat(startBlock.getChildKeys())
          });
        });
      } // last child of deleted parent should point to next sibling


      transformBlock(startBlock.getChildKeys().find(function (key) {
        var block = blockMap.get(key);
        return block.getNextSiblingKey() === null;
      }), blocks, function (block) {
        return block.merge({
          nextSibling: startBlock.getNextSiblingKey()
        });
      });
    }
  });
};

var removeRangeFromContentState = function removeRangeFromContentState(contentState, selectionState) {
  if (selectionState.isCollapsed()) {
    return contentState;
  }

  var blockMap = contentState.getBlockMap();
  var startKey = selectionState.getStartKey();
  var startOffset = selectionState.getStartOffset();
  var endKey = selectionState.getEndKey();
  var endOffset = selectionState.getEndOffset();
  var startBlock = blockMap.get(startKey);
  var endBlock = blockMap.get(endKey); // we assume that ContentBlockNode and ContentBlocks are not mixed together

  var isExperimentalTreeBlock = startBlock instanceof ContentBlockNode; // used to retain blocks that should not be deleted to avoid orphan children

  var parentAncestors = [];

  if (isExperimentalTreeBlock) {
    var endBlockchildrenKeys = endBlock.getChildKeys();
    var endBlockAncestors = getAncestorsKeys(endKey, blockMap); // endBlock has unselected siblings so we can not remove its ancestors parents

    if (endBlock.getNextSiblingKey()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors);
    } // endBlock has children so can not remove this block or any of its ancestors


    if (!endBlockchildrenKeys.isEmpty()) {
      parentAncestors = parentAncestors.concat(endBlockAncestors.concat([endKey]));
    } // we need to retain all ancestors of the next delimiter block


    parentAncestors = parentAncestors.concat(getAncestorsKeys(getNextDelimiterBlockKey(endBlock, blockMap), blockMap));
  }

  var characterList;

  if (startBlock === endBlock) {
    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
  } else {
    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
  }

  var modifiedStart = startBlock.merge({
    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
    characterList: characterList
  }); // If cursor (collapsed) is at the start of the first child, delete parent
  // instead of child

  var shouldDeleteParent = isExperimentalTreeBlock && startOffset === 0 && endOffset === 0 && endBlock.getParentKey() === startKey && endBlock.getPrevSiblingKey() == null;
  var newBlocks = shouldDeleteParent ? Map([[startKey, null]]) : blockMap.toSeq().skipUntil(function (_, k) {
    return k === startKey;
  }).takeUntil(function (_, k) {
    return k === endKey;
  }).filter(function (_, k) {
    return parentAncestors.indexOf(k) === -1;
  }).concat(Map([[endKey, null]])).map(function (_, k) {
    return k === startKey ? modifiedStart : null;
  });
  var updatedBlockMap = blockMap.merge(newBlocks).filter(function (block) {
    return !!block;
  }); // Only update tree block pointers if the range is across blocks

  if (isExperimentalTreeBlock && startBlock !== endBlock) {
    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, startBlock, endBlock, blockMap);
  }

  return contentState.merge({
    blockMap: updatedBlockMap,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: startKey,
      anchorOffset: startOffset,
      focusKey: startKey,
      focusOffset: startOffset,
      isBackward: false
    })
  });
};
/**
 * Maintain persistence for target list when removing characters on the
 * head and tail of the character list.
 */


var removeFromList = function removeFromList(targetList, startOffset, endOffset) {
  if (startOffset === 0) {
    while (startOffset < endOffset) {
      targetList = targetList.shift();
      startOffset++;
    }
  } else if (endOffset === targetList.count()) {
    while (endOffset > startOffset) {
      targetList = targetList.pop();
      endOffset--;
    }
  } else {
    var head = targetList.slice(0, startOffset);
    var tail = targetList.slice(endOffset);
    targetList = head.concat(tail).toList();
  }

  return targetList;
};

module.exports = removeRangeFromContentState;

/***/ }),
/* 2919 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var DraftEffects = __webpack_require__(1164);

var DraftJsDebugLogging = __webpack_require__(1166);

var UserAgent = __webpack_require__(106);

var containsNode = __webpack_require__(651);

var getActiveElement = __webpack_require__(1196);

var getCorrectDocumentFromNode = __webpack_require__(428);

var invariant = __webpack_require__(48);

var isElement = __webpack_require__(242);

var isIE = UserAgent.isBrowser('IE');

function getAnonymizedDOM(node, getNodeLabels) {
  if (!node) {
    return '[empty]';
  }

  var anonymized = anonymizeTextWithin(node, getNodeLabels);

  if (anonymized.nodeType === Node.TEXT_NODE) {
    return anonymized.textContent;
  }

  !isElement(anonymized) ?  false ? invariant(false, 'Node must be an Element if it is not a text node.') : invariant(false) : void 0;
  var castedElement = anonymized;
  return castedElement.outerHTML;
}

function anonymizeTextWithin(node, getNodeLabels) {
  var labels = getNodeLabels !== undefined ? getNodeLabels(node) : [];

  if (node.nodeType === Node.TEXT_NODE) {
    var length = node.textContent.length;
    return getCorrectDocumentFromNode(node).createTextNode('[text ' + length + (labels.length ? ' | ' + labels.join(', ') : '') + ']');
  }

  var clone = node.cloneNode();

  if (clone.nodeType === 1 && labels.length) {
    clone.setAttribute('data-labels', labels.join(', '));
  }

  var childNodes = node.childNodes;

  for (var ii = 0; ii < childNodes.length; ii++) {
    clone.appendChild(anonymizeTextWithin(childNodes[ii], getNodeLabels));
  }

  return clone;
}

function getAnonymizedEditorDOM(node, getNodeLabels) {
  // grabbing the DOM content of the Draft editor
  var currentNode = node; // this should only be used after checking with isElement

  var castedNode = currentNode;

  while (currentNode) {
    if (isElement(currentNode) && castedNode.hasAttribute('contenteditable')) {
      // found the Draft editor container
      return getAnonymizedDOM(currentNode, getNodeLabels);
    } else {
      currentNode = currentNode.parentNode;
      castedNode = currentNode;
    }
  }

  return 'Could not find contentEditable parent of node';
}

function getNodeLength(node) {
  return node.nodeValue === null ? node.childNodes.length : node.nodeValue.length;
}
/**
 * In modern non-IE browsers, we can support both forward and backward
 * selections.
 *
 * Note: IE10+ supports the Selection object, but it does not support
 * the `extend` method, which means that even in modern IE, it's not possible
 * to programatically create a backward selection. Thus, for all IE
 * versions, we use the old IE API to create our selections.
 */


function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
  // It's possible that the editor has been removed from the DOM but
  // our selection code doesn't know it yet. Forcing selection in
  // this case may lead to errors, so just bail now.
  var documentObject = getCorrectDocumentFromNode(node);

  if (!containsNode(documentObject.documentElement, node)) {
    return;
  }

  var selection = documentObject.defaultView.getSelection();
  var anchorKey = selectionState.getAnchorKey();
  var anchorOffset = selectionState.getAnchorOffset();
  var focusKey = selectionState.getFocusKey();
  var focusOffset = selectionState.getFocusOffset();
  var isBackward = selectionState.getIsBackward(); // IE doesn't support backward selection. Swap key/offset pairs.

  if (!selection.extend && isBackward) {
    var tempKey = anchorKey;
    var tempOffset = anchorOffset;
    anchorKey = focusKey;
    anchorOffset = focusOffset;
    focusKey = tempKey;
    focusOffset = tempOffset;
    isBackward = false;
  }

  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;
  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset; // If the selection is entirely bound within this node, set the selection
  // and be done.

  if (hasAnchor && hasFocus) {
    selection.removeAllRanges();
    addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    return;
  }

  if (!isBackward) {
    // If the anchor is within this node, set the range start.
    if (hasAnchor) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
    } // If the focus is within this node, we can assume that we have
    // already set the appropriate start range on the selection, and
    // can simply extend the selection.


    if (hasFocus) {
      addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
    }
  } else {
    // If this node has the focus, set the selection range to be a
    // collapsed range beginning here. Later, when we encounter the anchor,
    // we'll use this information to extend the selection.
    if (hasFocus) {
      selection.removeAllRanges();
      addPointToSelection(selection, node, focusOffset - nodeStart, selectionState);
    } // If this node has the anchor, we may assume that the correct
    // focus information is already stored on the selection object.
    // We keep track of it, reset the selection range, and extend it
    // back to the focus point.


    if (hasAnchor) {
      var storedFocusNode = selection.focusNode;
      var storedFocusOffset = selection.focusOffset;
      selection.removeAllRanges();
      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
      addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
    }
  }
}
/**
 * Extend selection towards focus point.
 */


function addFocusToSelection(selection, node, offset, selectionState) {
  var activeElement = getActiveElement();
  var extend = selection.extend; // containsNode returns false if node is null.
  // Let's refine the type of this value out here so flow knows.

  if (extend && node != null && containsNode(activeElement, node)) {
    // If `extend` is called while another element has focus, an error is
    // thrown. We therefore disable `extend` if the active element is somewhere
    // other than the node we are selecting. This should only occur in Firefox,
    // since it is the only browser to support multiple selections.
    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.
    // logging to catch bug that is being reported in t16250795
    if (offset > getNodeLength(node)) {
      // the call to 'selection.extend' is about to throw
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node),
        extraParams: JSON.stringify({
          offset: offset
        }),
        selectionState: JSON.stringify(selectionState.toJS())
      });
    } // logging to catch bug that is being reported in t18110632


    var nodeWasFocus = node === selection.focusNode;

    try {
      // Fixes some reports of "InvalidStateError: Failed to execute 'extend' on
      // 'Selection': This Selection object doesn't have any Ranges."
      // Note: selection.extend does not exist in IE.
      if (selection.rangeCount > 0 && selection.extend) {
        selection.extend(node, offset);
      }
    } catch (e) {
      DraftJsDebugLogging.logSelectionStateFailure({
        anonymizedDom: getAnonymizedEditorDOM(node, function (n) {
          var labels = [];

          if (n === activeElement) {
            labels.push('active element');
          }

          if (n === selection.anchorNode) {
            labels.push('selection anchor node');
          }

          if (n === selection.focusNode) {
            labels.push('selection focus node');
          }

          return labels;
        }),
        extraParams: JSON.stringify({
          activeElementName: activeElement ? activeElement.nodeName : null,
          nodeIsFocus: node === selection.focusNode,
          nodeWasFocus: nodeWasFocus,
          selectionRangeCount: selection.rangeCount,
          selectionAnchorNodeName: selection.anchorNode ? selection.anchorNode.nodeName : null,
          selectionAnchorOffset: selection.anchorOffset,
          selectionFocusNodeName: selection.focusNode ? selection.focusNode.nodeName : null,
          selectionFocusOffset: selection.focusOffset,
          message: e ? '' + e : null,
          offset: offset
        }, null, 2),
        selectionState: JSON.stringify(selectionState.toJS(), null, 2)
      }); // allow the error to be thrown -
      // better than continuing in a broken state

      throw e;
    }
  } else {
    // IE doesn't support extend. This will mean no backward selection.
    // Extract the existing selection range and add focus to it.
    // Additionally, clone the selection range. IE11 throws an
    // InvalidStateError when attempting to access selection properties
    // after the range is detached.
    if (node && selection.rangeCount > 0) {
      var range = selection.getRangeAt(0);
      range.setEnd(node, offset);
      selection.addRange(range.cloneRange());
    }
  }
}

function addPointToSelection(selection, node, offset, selectionState) {
  var range = getCorrectDocumentFromNode(node).createRange(); // logging to catch bug that is being reported in t16250795

  if (offset > getNodeLength(node)) {
    // in this case we know that the call to 'range.setStart' is about to throw
    DraftJsDebugLogging.logSelectionStateFailure({
      anonymizedDom: getAnonymizedEditorDOM(node),
      extraParams: JSON.stringify({
        offset: offset
      }),
      selectionState: JSON.stringify(selectionState.toJS())
    });
    DraftEffects.handleExtensionCausedError();
  }

  range.setStart(node, offset); // IE sometimes throws Unspecified Error when trying to addRange

  if (isIE) {
    try {
      selection.addRange(range);
    } catch (e) {
      if (false) {
        /* eslint-disable-next-line no-console */
        console.warn('Call to selection.addRange() threw exception: ', e);
      }
    }
  } else {
    selection.addRange(range);
  }
}

module.exports = {
  setDraftEditorSelection: setDraftEditorSelection,
  addFocusToSelection: addFocusToSelection
};

/***/ }),
/* 2920 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var ContentBlockNode = __webpack_require__(134);

var generateRandomKey = __webpack_require__(164);

var Immutable = __webpack_require__(46);

var invariant = __webpack_require__(48);

var modifyBlockForContentState = __webpack_require__(1189);

var List = Immutable.List,
    Map = Immutable.Map;

var transformBlock = function transformBlock(key, blockMap, func) {
  if (!key) {
    return;
  }

  var block = blockMap.get(key);

  if (!block) {
    return;
  }

  blockMap.set(key, func(block));
};

var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlock, belowBlock) {
  return blockMap.withMutations(function (blocks) {
    var originalBlockKey = originalBlock.getKey();
    var belowBlockKey = belowBlock.getKey(); // update block parent

    transformBlock(originalBlock.getParentKey(), blocks, function (block) {
      var parentChildrenList = block.getChildKeys();
      var insertionIndex = parentChildrenList.indexOf(originalBlockKey) + 1;
      var newChildrenArray = parentChildrenList.toArray();
      newChildrenArray.splice(insertionIndex, 0, belowBlockKey);
      return block.merge({
        children: List(newChildrenArray)
      });
    }); // update original next block

    transformBlock(originalBlock.getNextSiblingKey(), blocks, function (block) {
      return block.merge({
        prevSibling: belowBlockKey
      });
    }); // update original block

    transformBlock(originalBlockKey, blocks, function (block) {
      return block.merge({
        nextSibling: belowBlockKey
      });
    }); // update below block

    transformBlock(belowBlockKey, blocks, function (block) {
      return block.merge({
        prevSibling: originalBlockKey
      });
    });
  });
};

var splitBlockInContentState = function splitBlockInContentState(contentState, selectionState) {
  !selectionState.isCollapsed() ?  false ? invariant(false, 'Selection range must be collapsed.') : invariant(false) : void 0;
  var key = selectionState.getAnchorKey();
  var blockMap = contentState.getBlockMap();
  var blockToSplit = blockMap.get(key);
  var text = blockToSplit.getText();

  if (!text) {
    var blockType = blockToSplit.getType();

    if (blockType === 'unordered-list-item' || blockType === 'ordered-list-item') {
      return modifyBlockForContentState(contentState, selectionState, function (block) {
        return block.merge({
          type: 'unstyled',
          depth: 0
        });
      });
    }
  }

  var offset = selectionState.getAnchorOffset();
  var chars = blockToSplit.getCharacterList();
  var keyBelow = generateRandomKey();
  var isExperimentalTreeBlock = blockToSplit instanceof ContentBlockNode;
  var blockAbove = blockToSplit.merge({
    text: text.slice(0, offset),
    characterList: chars.slice(0, offset)
  });
  var blockBelow = blockAbove.merge({
    key: keyBelow,
    text: text.slice(offset),
    characterList: chars.slice(offset),
    data: Map()
  });
  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
    return v === blockToSplit;
  });
  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
    return v === blockToSplit;
  }).rest();
  var newBlocks = blocksBefore.concat([[key, blockAbove], [keyBelow, blockBelow]], blocksAfter).toOrderedMap();

  if (isExperimentalTreeBlock) {
    !blockToSplit.getChildKeys().isEmpty() ?  false ? invariant(false, 'ContentBlockNode must not have children') : invariant(false) : void 0;
    newBlocks = updateBlockMapLinks(newBlocks, blockAbove, blockBelow);
  }

  return contentState.merge({
    blockMap: newBlocks,
    selectionBefore: selectionState,
    selectionAfter: selectionState.merge({
      anchorKey: keyBelow,
      anchorOffset: 0,
      focusKey: keyBelow,
      focusOffset: 0,
      isBackward: false
    })
  });
};

module.exports = splitBlockInContentState;

/***/ }),
/* 2921 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 * @emails oncall+draft_js
 */


var NEWLINE_REGEX = /\r\n?|\n/g;

function splitTextIntoTextBlocks(text) {
  return text.split(NEWLINE_REGEX);
}

module.exports = splitTextIntoTextBlocks;

/***/ }),
/* 2922 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @typechecks
 * 
 * @format
 */

/*eslint-disable no-bitwise */

/**
 * Based on the rfc4122-compliant solution posted at
 * http://stackoverflow.com/questions/105034
 */
function uuid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

module.exports = uuid;

/***/ }),
/* 2923 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var PhotosMimeType = {
  isImage: function isImage(mimeString) {
    return getParts(mimeString)[0] === 'image';
  },
  isJpeg: function isJpeg(mimeString) {
    var parts = getParts(mimeString);
    return PhotosMimeType.isImage(mimeString) && ( // see http://fburl.com/10972194
    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
  }
};

function getParts(mimeString) {
  return mimeString.split('/');
}

module.exports = PhotosMimeType;

/***/ }),
/* 2924 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * @stub
 * 
 */
 // \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
//             is latin supplement punctuation except fractions and superscript
//             numbers
// \u2010-\u2027\u2030-\u205e
//             is punctuation from the general punctuation block:
//             weird quotes, commas, bullets, dashes, etc.
// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
//             is CJK punctuation
// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
//             is some full-width/half-width punctuation
// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
//             is some Arabic punctuation marks
// \u1801\u0964\u104a\u104b
//             is misc. other language punctuation marks

var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + "\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F" + "\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D" + "\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E" + "\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]";
module.exports = {
  getPunctuation: function getPunctuation() {
    return PUNCTUATION;
  }
};

/***/ }),
/* 2925 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var URI =
/*#__PURE__*/
function () {
  function URI(uri) {
    _defineProperty(this, "_uri", void 0);

    this._uri = uri;
  }

  var _proto = URI.prototype;

  _proto.toString = function toString() {
    return this._uri;
  };

  return URI;
}();

module.exports = URI;

/***/ }),
/* 2926 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/**
 * Stateful API for text direction detection
 *
 * This class can be used in applications where you need to detect the
 * direction of a sequence of text blocks, where each direction shall be used
 * as the fallback direction for the next one.
 *
 * NOTE: A default direction, if not provided, is set based on the global
 *       direction, as defined by `UnicodeBidiDirection`.
 *
 * == Example ==
 * ```
 * var UnicodeBidiService = require('UnicodeBidiService');
 *
 * var bidiService = new UnicodeBidiService();
 *
 * ...
 *
 * bidiService.reset();
 * for (var para in paragraphs) {
 *   var dir = bidiService.getDirection(para);
 *   ...
 * }
 * ```
 *
 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
 * Unicode Standard Annex #9 (UAX9)
 * http://www.unicode.org/reports/tr9/
 */


function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var UnicodeBidi = __webpack_require__(650);

var UnicodeBidiDirection = __webpack_require__(432);

var invariant = __webpack_require__(48);

var UnicodeBidiService =
/*#__PURE__*/
function () {
  /**
   * Stateful class for paragraph direction detection
   *
   * @param defaultDir  Default direction of the service
   */
  function UnicodeBidiService(defaultDir) {
    _defineProperty(this, "_defaultDir", void 0);

    _defineProperty(this, "_lastDir", void 0);

    if (!defaultDir) {
      defaultDir = UnicodeBidiDirection.getGlobalDir();
    } else {
      !UnicodeBidiDirection.isStrong(defaultDir) ?  false ? invariant(false, 'Default direction must be a strong direction (LTR or RTL)') : invariant(false) : void 0;
    }

    this._defaultDir = defaultDir;
    this.reset();
  }
  /**
   * Reset the internal state
   *
   * Instead of creating a new instance, you can just reset() your instance
   * everytime you start a new loop.
   */


  var _proto = UnicodeBidiService.prototype;

  _proto.reset = function reset() {
    this._lastDir = this._defaultDir;
  };
  /**
   * Returns the direction of a block of text, and remembers it as the
   * fall-back direction for the next paragraph.
   *
   * @param str  A text block, e.g. paragraph, table cell, tag
   * @return     The resolved direction
   */


  _proto.getDirection = function getDirection(str) {
    this._lastDir = UnicodeBidi.getDirection(str, this._lastDir);
    return this._lastDir;
  };

  return UnicodeBidiService;
}();

module.exports = UnicodeBidiService;

/***/ }),
/* 2927 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

/**
 * Usage note:
 * This module makes a best effort to export the same data we would internally.
 * At Facebook we use a server-generated module that does the parsing and
 * exports the data for the client to use. We can't rely on a server-side
 * implementation in open source so instead we make use of an open source
 * library to do the heavy lifting and then make some adjustments as necessary.
 * It's likely there will be some differences. Some we can smooth over.
 * Others are going to be harder.
 */


var UAParser = __webpack_require__(3512);

var UNKNOWN = 'Unknown';
var PLATFORM_MAP = {
  'Mac OS': 'Mac OS X'
};
/**
 * Convert from UAParser platform name to what we expect.
 */

function convertPlatformName(name) {
  return PLATFORM_MAP[name] || name;
}
/**
 * Get the version number in parts. This is very naive. We actually get major
 * version as a part of UAParser already, which is generally good enough, but
 * let's get the minor just in case.
 */


function getBrowserVersion(version) {
  if (!version) {
    return {
      major: '',
      minor: ''
    };
  }

  var parts = version.split('.');
  return {
    major: parts[0],
    minor: parts[1]
  };
}
/**
 * Get the UA data fom UAParser and then convert it to the format we're
 * expecting for our APIS.
 */


var parser = new UAParser();
var results = parser.getResult(); // Do some conversion first.

var browserVersionData = getBrowserVersion(results.browser.version);
var uaData = {
  browserArchitecture: results.cpu.architecture || UNKNOWN,
  browserFullVersion: results.browser.version || UNKNOWN,
  browserMinorVersion: browserVersionData.minor || UNKNOWN,
  browserName: results.browser.name || UNKNOWN,
  browserVersion: results.browser.major || UNKNOWN,
  deviceName: results.device.model || UNKNOWN,
  engineName: results.engine.name || UNKNOWN,
  engineVersion: results.engine.version || UNKNOWN,
  platformArchitecture: results.cpu.architecture || UNKNOWN,
  platformName: convertPlatformName(results.os.name) || UNKNOWN,
  platformVersion: results.os.version || UNKNOWN,
  platformFullVersion: results.os.version || UNKNOWN
};
module.exports = uaData;

/***/ }),
/* 2928 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var invariant = __webpack_require__(48);

var componentRegex = /\./;
var orRegex = /\|\|/;
var rangeRegex = /\s+\-\s+/;
var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
var numericRegex = /^(\d*)(.*)/;
/**
 * Splits input `range` on "||" and returns true if any subrange matches
 * `version`.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */

function checkOrExpression(range, version) {
  var expressions = range.split(orRegex);

  if (expressions.length > 1) {
    return expressions.some(function (range) {
      return VersionRange.contains(range, version);
    });
  } else {
    range = expressions[0].trim();
    return checkRangeExpression(range, version);
  }
}
/**
 * Splits input `range` on " - " (the surrounding whitespace is required) and
 * returns true if version falls between the two operands.
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */


function checkRangeExpression(range, version) {
  var expressions = range.split(rangeRegex);
  !(expressions.length > 0 && expressions.length <= 2) ?  false ? invariant(false, 'the "-" operator expects exactly 2 operands') : invariant(false) : void 0;

  if (expressions.length === 1) {
    return checkSimpleExpression(expressions[0], version);
  } else {
    var startVersion = expressions[0],
        endVersion = expressions[1];
    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ?  false ? invariant(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant(false) : void 0;
    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
  }
}
/**
 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
 * not a compound range using the " - " or "||" operators).
 *
 * @param {string} range
 * @param {string} version
 * @returns {boolean}
 */


function checkSimpleExpression(range, version) {
  range = range.trim();

  if (range === '') {
    return true;
  }

  var versionComponents = version.split(componentRegex);

  var _getModifierAndCompon = getModifierAndComponents(range),
      modifier = _getModifierAndCompon.modifier,
      rangeComponents = _getModifierAndCompon.rangeComponents;

  switch (modifier) {
    case '<':
      return checkLessThan(versionComponents, rangeComponents);

    case '<=':
      return checkLessThanOrEqual(versionComponents, rangeComponents);

    case '>=':
      return checkGreaterThanOrEqual(versionComponents, rangeComponents);

    case '>':
      return checkGreaterThan(versionComponents, rangeComponents);

    case '~':
    case '~>':
      return checkApproximateVersion(versionComponents, rangeComponents);

    default:
      return checkEqual(versionComponents, rangeComponents);
  }
}
/**
 * Checks whether `a` is less than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkLessThan(a, b) {
  return compareComponents(a, b) === -1;
}
/**
 * Checks whether `a` is less than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkLessThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === -1 || result === 0;
}
/**
 * Checks whether `a` is equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkEqual(a, b) {
  return compareComponents(a, b) === 0;
}
/**
 * Checks whether `a` is greater than or equal to `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkGreaterThanOrEqual(a, b) {
  var result = compareComponents(a, b);
  return result === 1 || result === 0;
}
/**
 * Checks whether `a` is greater than `b`.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkGreaterThan(a, b) {
  return compareComponents(a, b) === 1;
}
/**
 * Checks whether `a` is "reasonably close" to `b` (as described in
 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {boolean}
 */


function checkApproximateVersion(a, b) {
  var lowerBound = b.slice();
  var upperBound = b.slice();

  if (upperBound.length > 1) {
    upperBound.pop();
  }

  var lastIndex = upperBound.length - 1;
  var numeric = parseInt(upperBound[lastIndex], 10);

  if (isNumber(numeric)) {
    upperBound[lastIndex] = numeric + 1 + '';
  }

  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
}
/**
 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
 * components from `range`.
 *
 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
 * `">="` and `components` of `[1, 2, 3]`.
 *
 * @param {string} range
 * @returns {object}
 */


function getModifierAndComponents(range) {
  var rangeComponents = range.split(componentRegex);
  var matches = rangeComponents[0].match(modifierRegex);
  !matches ?  false ? invariant(false, 'expected regex to match but it did not') : invariant(false) : void 0;
  return {
    modifier: matches[1],
    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
  };
}
/**
 * Determines if `number` is a number.
 *
 * @param {mixed} number
 * @returns {boolean}
 */


function isNumber(number) {
  return !isNaN(number) && isFinite(number);
}
/**
 * Tests whether `range` is a "simple" version number without any modifiers
 * (">", "~" etc).
 *
 * @param {string} range
 * @returns {boolean}
 */


function isSimpleVersion(range) {
  return !getModifierAndComponents(range).modifier;
}
/**
 * Zero-pads array `array` until it is at least `length` long.
 *
 * @param {array} array
 * @param {number} length
 */


function zeroPad(array, length) {
  for (var i = array.length; i < length; i++) {
    array[i] = '0';
  }
}
/**
 * Normalizes `a` and `b` in preparation for comparison by doing the following:
 *
 * - zero-pads `a` and `b`
 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
 *   in both `a` and `b`
 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
 *   and all of its successors in `a`
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {array<array<string>>}
 */


function normalizeVersions(a, b) {
  a = a.slice();
  b = b.slice();
  zeroPad(a, b.length); // mark "x" and "*" components as equal

  for (var i = 0; i < b.length; i++) {
    var matches = b[i].match(/^[x*]$/i);

    if (matches) {
      b[i] = a[i] = '0'; // final "*" greedily zeros all remaining components

      if (matches[0] === '*' && i === b.length - 1) {
        for (var j = i; j < a.length; j++) {
          a[j] = '0';
        }
      }
    }
  }

  zeroPad(b, a.length);
  return [a, b];
}
/**
 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
 *
 * For example, `10-alpha` is greater than `2-beta`.
 *
 * @param {string} a
 * @param {string} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */


function compareNumeric(a, b) {
  var aPrefix = a.match(numericRegex)[1];
  var bPrefix = b.match(numericRegex)[1];
  var aNumeric = parseInt(aPrefix, 10);
  var bNumeric = parseInt(bPrefix, 10);

  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
    return compare(aNumeric, bNumeric);
  } else {
    return compare(a, b);
  }
}
/**
 * Returns the ordering of `a` and `b`.
 *
 * @param {string|number} a
 * @param {string|number} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */


function compare(a, b) {
  !(typeof a === typeof b) ?  false ? invariant(false, '"a" and "b" must be of the same type') : invariant(false) : void 0;

  if (a > b) {
    return 1;
  } else if (a < b) {
    return -1;
  } else {
    return 0;
  }
}
/**
 * Compares arrays of version components.
 *
 * @param {array<string>} a
 * @param {array<string>} b
 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
 * or greater than `b`, respectively
 */


function compareComponents(a, b) {
  var _normalizeVersions = normalizeVersions(a, b),
      aNormalized = _normalizeVersions[0],
      bNormalized = _normalizeVersions[1];

  for (var i = 0; i < bNormalized.length; i++) {
    var result = compareNumeric(aNormalized[i], bNormalized[i]);

    if (result) {
      return result;
    }
  }

  return 0;
}

var VersionRange = {
  /**
   * Checks whether `version` satisfies the `range` specification.
   *
   * We support a subset of the expressions defined in
   * https://www.npmjs.org/doc/misc/semver.html:
   *
   *    version   Must match version exactly
   *    =version  Same as just version
   *    >version  Must be greater than version
   *    >=version Must be greater than or equal to version
   *    <version  Must be less than version
   *    <=version Must be less than or equal to version
   *    ~version  Must be at least version, but less than the next significant
   *              revision above version:
   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
   *    ~>version Equivalent to ~version
   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
   *              anything
   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
   *              "greedy" wildcard, so will match any number of additional
   *              components:
   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
   *    *         Any version
   *    ""        (Empty string) Same as *
   *    v1 - v2   Equivalent to ">= v1 and <= v2"
   *    r1 || r2  Passes if either r1 or r2 are satisfied
   *
   * @param {string} range
   * @param {string} version
   * @returns {boolean}
   */
  contains: function contains(range, version) {
    return checkOrExpression(range.trim(), version.trim());
  }
};
module.exports = VersionRange;

/***/ }),
/* 2929 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var _hyphenPattern = /-(.)/g;
/**
 * Camelcases a hyphenated string, for example:
 *
 *   > camelize('background-color')
 *   < "backgroundColor"
 *
 * @param {string} string
 * @return {string}
 */

function camelize(string) {
  return string.replace(_hyphenPattern, function (_, character) {
    return character.toUpperCase();
  });
}

module.exports = camelize;

/***/ }),
/* 2930 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var invariant = __webpack_require__(48);
/**
 * Convert array-like objects to arrays.
 *
 * This API assumes the caller knows the contents of the data type. For less
 * well defined inputs use createArrayFromMixed.
 *
 * @param {object|function|filelist} obj
 * @return {array}
 */


function toArray(obj) {
  var length = obj.length; // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
  // in old versions of Safari).

  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0; // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
  // without method will throw during the slice call and skip straight to the
  // fallback.

  if (obj.hasOwnProperty) {
    try {
      return Array.prototype.slice.call(obj);
    } catch (e) {// IE < 9 does not support Array#slice on collections objects
    }
  } // Fall back to copying key by key. This assumes all keys have a value,
  // so will not preserve sparsely populated inputs.


  var ret = Array(length);

  for (var ii = 0; ii < length; ii++) {
    ret[ii] = obj[ii];
  }

  return ret;
}
/**
 * Perform a heuristic test to determine if an object is "array-like".
 *
 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
 *   Joshu replied: "Mu."
 *
 * This function determines if its argument has "array nature": it returns
 * true if the argument is an actual array, an `arguments' object, or an
 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
 *
 * It will return false for other array-like objects like Filelist.
 *
 * @param {*} obj
 * @return {boolean}
 */


function hasArrayNature(obj) {
  return (// not null/false
    !!obj && ( // arrays are objects, NodeLists are functions in Safari
    typeof obj == 'object' || typeof obj == 'function') && // quacks like an array
    'length' in obj && // not window
    !('setInterval' in obj) && // no DOM node should be considered an array-like
    // a 'select' element has 'length' and 'item' properties on IE8
    typeof obj.nodeType != 'number' && ( // a real array
    Array.isArray(obj) || // arguments
    'callee' in obj || // HTMLCollection/NodeList
    'item' in obj)
  );
}
/**
 * Ensure that the argument is an array by wrapping it in an array if it is not.
 * Creates a copy of the argument if it is already an array.
 *
 * This is mostly useful idiomatically:
 *
 *   var createArrayFromMixed = require('createArrayFromMixed');
 *
 *   function takesOneOrMoreThings(things) {
 *     things = createArrayFromMixed(things);
 *     ...
 *   }
 *
 * This allows you to treat `things' as an array, but accept scalars in the API.
 *
 * If you need to convert an array-like object, like `arguments`, into an array
 * use toArray instead.
 *
 * @param {*} obj
 * @return {array}
 */


function createArrayFromMixed(obj) {
  if (!hasArrayNature(obj)) {
    return [obj];
  } else if (Array.isArray(obj)) {
    return obj.slice();
  } else {
    return toArray(obj);
  }
}

module.exports = createArrayFromMixed;

/***/ }),
/* 2931 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */


var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;
/**
 * Gets the element with the document scroll properties such as `scrollLeft` and
 * `scrollHeight`. This may differ across different browsers.
 *
 * NOTE: The return value can be null if the DOM is not yet ready.
 *
 * @param {?DOMDocument} doc Defaults to current document.
 * @return {?DOMElement}
 */

function getDocumentScrollElement(doc) {
  doc = doc || document;

  if (doc.scrollingElement) {
    return doc.scrollingElement;
  }

  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
}

module.exports = getDocumentScrollElement;

/***/ }),
/* 2932 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var containsNode = __webpack_require__(651);
/**
 * Gets an element's bounding rect in pixels relative to the viewport.
 *
 * @param {DOMElement} elem
 * @return {object}
 */


function getElementRect(elem) {
  var docElem = elem.ownerDocument.documentElement; // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
  // IE9- will throw if the element is not in the document.

  if (!('getBoundingClientRect' in elem) || !containsNode(docElem, elem)) {
    return {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0
    };
  } // Subtracts clientTop/Left because IE8- added a 2px border to the
  // <html> element (see http://fburl.com/1493213). IE 7 in
  // Quicksmode does not report clientLeft/clientTop so there
  // will be an unaccounted offset of 2px when in quirksmode


  var rect = elem.getBoundingClientRect();
  return {
    left: Math.round(rect.left) - docElem.clientLeft,
    right: Math.round(rect.right) - docElem.clientLeft,
    top: Math.round(rect.top) - docElem.clientTop,
    bottom: Math.round(rect.bottom) - docElem.clientTop
  };
}

module.exports = getElementRect;

/***/ }),
/* 2933 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var camelize = __webpack_require__(2929);

var hyphenate = __webpack_require__(2935);

function asString(value)
/*?string*/
{
  return value == null ? value : String(value);
}

function getStyleProperty(
/*DOMNode*/
node,
/*string*/
name)
/*?string*/
{
  var computedStyle; // W3C Standard

  if (window.getComputedStyle) {
    // In certain cases such as within an iframe in FF3, this returns null.
    computedStyle = window.getComputedStyle(node, null);

    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name)));
    }
  } // Safari


  if (document.defaultView && document.defaultView.getComputedStyle) {
    computedStyle = document.defaultView.getComputedStyle(node, null); // A Safari bug causes this to return null for `display: none` elements.

    if (computedStyle) {
      return asString(computedStyle.getPropertyValue(hyphenate(name)));
    }

    if (name === 'display') {
      return 'none';
    }
  } // Internet Explorer


  if (node.currentStyle) {
    if (name === 'float') {
      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
    }

    return asString(node.currentStyle[camelize(name)]);
  }

  return asString(node.style && node.style[camelize(name)]);
}

module.exports = getStyleProperty;

/***/ }),
/* 2934 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * Gets the scroll position of the supplied element or window.
 *
 * The return values are unbounded, unlike `getScrollPosition`. This means they
 * may be negative or exceed the element boundaries (which is possible using
 * inertial scrolling).
 *
 * @param {DOMWindow|DOMElement} scrollable
 * @return {object} Map with `x` and `y` keys.
 */

function getUnboundedScrollPosition(scrollable) {
  if (scrollable.Window && scrollable instanceof scrollable.Window) {
    return {
      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
    };
  }

  return {
    x: scrollable.scrollLeft,
    y: scrollable.scrollTop
  };
}

module.exports = getUnboundedScrollPosition;

/***/ }),
/* 2935 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var _uppercasePattern = /([A-Z])/g;
/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */

function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 2936 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM node.
 */
function isNode(object) {
  var doc = object ? object.ownerDocument || object : document;
  var defaultView = doc.defaultView || window;
  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
}

module.exports = isNode;

/***/ }),
/* 2937 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var isNode = __webpack_require__(2936);
/**
 * @param {*} object The object to check.
 * @return {boolean} Whether or not the object is a DOM text node.
 */


function isTextNode(object) {
  return isNode(object) && object.nodeType == 3;
}

module.exports = isTextNode;

/***/ }),
/* 2938 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */

/**
 * Combines multiple className strings into one.
 */

function joinClasses(className) {
  var newClassName = className || '';
  var argLength = arguments.length;

  if (argLength > 1) {
    for (var index = 1; index < argLength; index++) {
      var nextClass = arguments[index];

      if (nextClass) {
        newClassName = (newClassName ? newClassName + ' ' : '') + nextClass;
      }
    }
  }

  return newClassName;
}

module.exports = joinClasses;

/***/ }),
/* 2939 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var hasOwnProperty = Object.prototype.hasOwnProperty;
/**
 * Executes the provided `callback` once for each enumerable own property in the
 * object and constructs a new object from the results. The `callback` is
 * invoked with three arguments:
 *
 *  - the property value
 *  - the property name
 *  - the object being traversed
 *
 * Properties that are added after the call to `mapObject` will not be visited
 * by `callback`. If the values of existing properties are changed, the value
 * passed to `callback` will be the value at the time `mapObject` visits them.
 * Properties that are deleted before being visited are not visited.
 *
 * @grep function objectMap()
 * @grep function objMap()
 *
 * @param {?object} object
 * @param {function} callback
 * @param {*} context
 * @return {?object}
 */

function mapObject(object, callback, context) {
  if (!object) {
    return null;
  }

  var result = {};

  for (var name in object) {
    if (hasOwnProperty.call(object, name)) {
      result[name] = callback.call(context, object[name], name, object);
    }
  }

  return result;
}

module.exports = mapObject;

/***/ }),
/* 2940 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @typechecks static-only
 */

/**
 * Memoizes the return value of a function that accepts one string argument.
 */

function memoizeStringOnly(callback) {
  var cache = {};
  return function (string) {
    if (!cache.hasOwnProperty(string)) {
      cache[string] = callback.call(this, string);
    }

    return cache[string];
  };
}

module.exports = memoizeStringOnly;

/***/ }),
/* 2941 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
 // setimmediate adds setImmediate to the global. We want to make sure we export
// the actual function.

__webpack_require__(1589);

module.exports = global.setImmediate;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 2942 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(1106);
var gOPD = __webpack_require__(1203);

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;


/***/ }),
/* 2943 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(135);
var BN = __webpack_require__(77);
var inherits = __webpack_require__(41);
var Base = __webpack_require__(434);

var assert = utils.assert;

function EdwardsCurve(conf) {
  // NOTE: Important as we are creating point in Base.call()
  this.twisted = (conf.a | 0) !== 1;
  this.mOneA = this.twisted && (conf.a | 0) === -1;
  this.extended = this.mOneA;

  Base.call(this, 'edwards', conf);

  this.a = new BN(conf.a, 16).umod(this.red.m);
  this.a = this.a.toRed(this.red);
  this.c = new BN(conf.c, 16).toRed(this.red);
  this.c2 = this.c.redSqr();
  this.d = new BN(conf.d, 16).toRed(this.red);
  this.dd = this.d.redAdd(this.d);

  assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
  this.oneC = (conf.c | 0) === 1;
}
inherits(EdwardsCurve, Base);
module.exports = EdwardsCurve;

EdwardsCurve.prototype._mulA = function _mulA(num) {
  if (this.mOneA)
    return num.redNeg();
  else
    return this.a.redMul(num);
};

EdwardsCurve.prototype._mulC = function _mulC(num) {
  if (this.oneC)
    return num;
  else
    return this.c.redMul(num);
};

// Just for compatibility with Short curve
EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
  return this.point(x, y, z, t);
};

EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var x2 = x.redSqr();
  var rhs = this.c2.redSub(this.a.redMul(x2));
  var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));

  var y2 = rhs.redMul(lhs.redInvm());
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
  y = new BN(y, 16);
  if (!y.red)
    y = y.toRed(this.red);

  // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
  var y2 = y.redSqr();
  var lhs = y2.redSub(this.c2);
  var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
  var x2 = lhs.redMul(rhs.redInvm());

  if (x2.cmp(this.zero) === 0) {
    if (odd)
      throw new Error('invalid point');
    else
      return this.point(this.zero, y);
  }

  var x = x2.redSqrt();
  if (x.redSqr().redSub(x2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  if (x.fromRed().isOdd() !== odd)
    x = x.redNeg();

  return this.point(x, y);
};

EdwardsCurve.prototype.validate = function validate(point) {
  if (point.isInfinity())
    return true;

  // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
  point.normalize();

  var x2 = point.x.redSqr();
  var y2 = point.y.redSqr();
  var lhs = x2.redMul(this.a).redAdd(y2);
  var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));

  return lhs.cmp(rhs) === 0;
};

function Point(curve, x, y, z, t) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && y === null && z === null) {
    this.x = this.curve.zero;
    this.y = this.curve.one;
    this.z = this.curve.one;
    this.t = this.curve.zero;
    this.zOne = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = z ? new BN(z, 16) : this.curve.one;
    this.t = t && new BN(t, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
    if (this.t && !this.t.red)
      this.t = this.t.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;

    // Use extended coordinates
    if (this.curve.extended && !this.t) {
      this.t = this.x.redMul(this.y);
      if (!this.zOne)
        this.t = this.t.redMul(this.z.redInvm());
    }
  }
}
inherits(Point, Base.BasePoint);

EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

EdwardsCurve.prototype.point = function point(x, y, z, t) {
  return new Point(this, x, y, z, t);
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1], obj[2]);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.x.cmpn(0) === 0 &&
    (this.y.cmp(this.z) === 0 ||
    (this.zOne && this.y.cmp(this.curve.c) === 0));
};

Point.prototype._extDbl = function _extDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #doubling-dbl-2008-hwcd
  // 4M + 4S

  // A = X1^2
  var a = this.x.redSqr();
  // B = Y1^2
  var b = this.y.redSqr();
  // C = 2 * Z1^2
  var c = this.z.redSqr();
  c = c.redIAdd(c);
  // D = a * A
  var d = this.curve._mulA(a);
  // E = (X1 + Y1)^2 - A - B
  var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
  // G = D + B
  var g = d.redAdd(b);
  // F = G - C
  var f = g.redSub(c);
  // H = D - B
  var h = d.redSub(b);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projDbl = function _projDbl() {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #doubling-dbl-2008-bbjlp
  //     #doubling-dbl-2007-bl
  // and others
  // Generally 3M + 4S or 2M + 4S

  // B = (X1 + Y1)^2
  var b = this.x.redAdd(this.y).redSqr();
  // C = X1^2
  var c = this.x.redSqr();
  // D = Y1^2
  var d = this.y.redSqr();

  var nx;
  var ny;
  var nz;
  var e;
  var h;
  var j;
  if (this.curve.twisted) {
    // E = a * C
    e = this.curve._mulA(c);
    // F = E + D
    var f = e.redAdd(d);
    if (this.zOne) {
      // X3 = (B - C - D) * (F - 2)
      nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F^2 - 2 * F
      nz = f.redSqr().redSub(f).redSub(f);
    } else {
      // H = Z1^2
      h = this.z.redSqr();
      // J = F - 2 * H
      j = f.redSub(h).redISub(h);
      // X3 = (B-C-D)*J
      nx = b.redSub(c).redISub(d).redMul(j);
      // Y3 = F * (E - D)
      ny = f.redMul(e.redSub(d));
      // Z3 = F * J
      nz = f.redMul(j);
    }
  } else {
    // E = C + D
    e = c.redAdd(d);
    // H = (c * Z1)^2
    h = this.curve._mulC(this.z).redSqr();
    // J = E - 2 * H
    j = e.redSub(h).redSub(h);
    // X3 = c * (B - E) * J
    nx = this.curve._mulC(b.redISub(e)).redMul(j);
    // Y3 = c * E * (C - D)
    ny = this.curve._mulC(e).redMul(c.redISub(d));
    // Z3 = E * J
    nz = e.redMul(j);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  // Double in extended coordinates
  if (this.curve.extended)
    return this._extDbl();
  else
    return this._projDbl();
};

Point.prototype._extAdd = function _extAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
  //     #addition-add-2008-hwcd-3
  // 8M

  // A = (Y1 - X1) * (Y2 - X2)
  var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
  // B = (Y1 + X1) * (Y2 + X2)
  var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
  // C = T1 * k * T2
  var c = this.t.redMul(this.curve.dd).redMul(p.t);
  // D = Z1 * 2 * Z2
  var d = this.z.redMul(p.z.redAdd(p.z));
  // E = B - A
  var e = b.redSub(a);
  // F = D - C
  var f = d.redSub(c);
  // G = D + C
  var g = d.redAdd(c);
  // H = B + A
  var h = b.redAdd(a);
  // X3 = E * F
  var nx = e.redMul(f);
  // Y3 = G * H
  var ny = g.redMul(h);
  // T3 = E * H
  var nt = e.redMul(h);
  // Z3 = F * G
  var nz = f.redMul(g);
  return this.curve.point(nx, ny, nz, nt);
};

Point.prototype._projAdd = function _projAdd(p) {
  // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
  //     #addition-add-2008-bbjlp
  //     #addition-add-2007-bl
  // 10M + 1S

  // A = Z1 * Z2
  var a = this.z.redMul(p.z);
  // B = A^2
  var b = a.redSqr();
  // C = X1 * X2
  var c = this.x.redMul(p.x);
  // D = Y1 * Y2
  var d = this.y.redMul(p.y);
  // E = d * C * D
  var e = this.curve.d.redMul(c).redMul(d);
  // F = B - E
  var f = b.redSub(e);
  // G = B + E
  var g = b.redAdd(e);
  // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
  var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
  var nx = a.redMul(f).redMul(tmp);
  var ny;
  var nz;
  if (this.curve.twisted) {
    // Y3 = A * G * (D - a * C)
    ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
    // Z3 = F * G
    nz = f.redMul(g);
  } else {
    // Y3 = A * G * (D - C)
    ny = a.redMul(g).redMul(d.redSub(c));
    // Z3 = c * F * G
    nz = this.curve._mulC(f).redMul(g);
  }
  return this.curve.point(nx, ny, nz);
};

Point.prototype.add = function add(p) {
  if (this.isInfinity())
    return p;
  if (p.isInfinity())
    return this;

  if (this.curve.extended)
    return this._extAdd(p);
  else
    return this._projAdd(p);
};

Point.prototype.mul = function mul(k) {
  if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, false);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
  return this.curve._wnafMulAdd(1, [ this, p ], [ k1, k2 ], 2, true);
};

Point.prototype.normalize = function normalize() {
  if (this.zOne)
    return this;

  // Normalize coordinates
  var zi = this.z.redInvm();
  this.x = this.x.redMul(zi);
  this.y = this.y.redMul(zi);
  if (this.t)
    this.t = this.t.redMul(zi);
  this.z = this.curve.one;
  this.zOne = true;
  return this;
};

Point.prototype.neg = function neg() {
  return this.curve.point(this.x.redNeg(),
    this.y,
    this.z,
    this.t && this.t.redNeg());
};

Point.prototype.getX = function getX() {
  this.normalize();
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  this.normalize();
  return this.y.fromRed();
};

Point.prototype.eq = function eq(other) {
  return this === other ||
         this.getX().cmp(other.getX()) === 0 &&
         this.getY().cmp(other.getY()) === 0;
};

Point.prototype.eqXToP = function eqXToP(x) {
  var rx = x.toRed(this.curve.red).redMul(this.z);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(this.z);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

// Compatibility with BaseCurve
Point.prototype.toP = Point.prototype.normalize;
Point.prototype.mixedAdd = Point.prototype.add;


/***/ }),
/* 2944 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(77);
var inherits = __webpack_require__(41);
var Base = __webpack_require__(434);

var utils = __webpack_require__(135);

function MontCurve(conf) {
  Base.call(this, 'mont', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.i4 = new BN(4).toRed(this.red).redInvm();
  this.two = new BN(2).toRed(this.red);
  this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
inherits(MontCurve, Base);
module.exports = MontCurve;

MontCurve.prototype.validate = function validate(point) {
  var x = point.normalize().x;
  var x2 = x.redSqr();
  var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
  var y = rhs.redSqrt();

  return y.redSqr().cmp(rhs) === 0;
};

function Point(curve, x, z) {
  Base.BasePoint.call(this, curve, 'projective');
  if (x === null && z === null) {
    this.x = this.curve.one;
    this.z = this.curve.zero;
  } else {
    this.x = new BN(x, 16);
    this.z = new BN(z, 16);
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.z.red)
      this.z = this.z.toRed(this.curve.red);
  }
}
inherits(Point, Base.BasePoint);

MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
  return this.point(utils.toArray(bytes, enc), 1);
};

MontCurve.prototype.point = function point(x, z) {
  return new Point(this, x, z);
};

MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
  return Point.fromJSON(this, obj);
};

Point.prototype.precompute = function precompute() {
  // No-op
};

Point.prototype._encode = function _encode() {
  return this.getX().toArray('be', this.curve.p.byteLength());
};

Point.fromJSON = function fromJSON(curve, obj) {
  return new Point(curve, obj[0], obj[1] || curve.one);
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};

Point.prototype.dbl = function dbl() {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
  // 2M + 2S + 4A

  // A = X1 + Z1
  var a = this.x.redAdd(this.z);
  // AA = A^2
  var aa = a.redSqr();
  // B = X1 - Z1
  var b = this.x.redSub(this.z);
  // BB = B^2
  var bb = b.redSqr();
  // C = AA - BB
  var c = aa.redSub(bb);
  // X3 = AA * BB
  var nx = aa.redMul(bb);
  // Z3 = C * (BB + A24 * C)
  var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
  return this.curve.point(nx, nz);
};

Point.prototype.add = function add() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.diffAdd = function diffAdd(p, diff) {
  // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
  // 4M + 2S + 6A

  // A = X2 + Z2
  var a = this.x.redAdd(this.z);
  // B = X2 - Z2
  var b = this.x.redSub(this.z);
  // C = X3 + Z3
  var c = p.x.redAdd(p.z);
  // D = X3 - Z3
  var d = p.x.redSub(p.z);
  // DA = D * A
  var da = d.redMul(a);
  // CB = C * B
  var cb = c.redMul(b);
  // X5 = Z1 * (DA + CB)^2
  var nx = diff.z.redMul(da.redAdd(cb).redSqr());
  // Z5 = X1 * (DA - CB)^2
  var nz = diff.x.redMul(da.redISub(cb).redSqr());
  return this.curve.point(nx, nz);
};

Point.prototype.mul = function mul(k) {
  var t = k.clone();
  var a = this; // (N / 2) * Q + Q
  var b = this.curve.point(null, null); // (N / 2) * Q
  var c = this; // Q

  for (var bits = []; t.cmpn(0) !== 0; t.iushrn(1))
    bits.push(t.andln(1));

  for (var i = bits.length - 1; i >= 0; i--) {
    if (bits[i] === 0) {
      // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
      a = a.diffAdd(b, c);
      // N * Q = 2 * ((N / 2) * Q + Q))
      b = b.dbl();
    } else {
      // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
      b = a.diffAdd(b, c);
      // N * Q + Q = 2 * ((N / 2) * Q + Q)
      a = a.dbl();
    }
  }
  return b;
};

Point.prototype.mulAdd = function mulAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.jumlAdd = function jumlAdd() {
  throw new Error('Not supported on Montgomery curve');
};

Point.prototype.eq = function eq(other) {
  return this.getX().cmp(other.getX()) === 0;
};

Point.prototype.normalize = function normalize() {
  this.x = this.x.redMul(this.z.redInvm());
  this.z = this.curve.one;
  return this;
};

Point.prototype.getX = function getX() {
  // Normalize coordinates
  this.normalize();

  return this.x.fromRed();
};


/***/ }),
/* 2945 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(135);
var BN = __webpack_require__(77);
var inherits = __webpack_require__(41);
var Base = __webpack_require__(434);

var assert = utils.assert;

function ShortCurve(conf) {
  Base.call(this, 'short', conf);

  this.a = new BN(conf.a, 16).toRed(this.red);
  this.b = new BN(conf.b, 16).toRed(this.red);
  this.tinv = this.two.redInvm();

  this.zeroA = this.a.fromRed().cmpn(0) === 0;
  this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;

  // If the curve is endomorphic, precalculate beta and lambda
  this.endo = this._getEndomorphism(conf);
  this._endoWnafT1 = new Array(4);
  this._endoWnafT2 = new Array(4);
}
inherits(ShortCurve, Base);
module.exports = ShortCurve;

ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
  // No efficient endomorphism
  if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)
    return;

  // Compute beta and lambda, that lambda * P = (beta * Px; Py)
  var beta;
  var lambda;
  if (conf.beta) {
    beta = new BN(conf.beta, 16).toRed(this.red);
  } else {
    var betas = this._getEndoRoots(this.p);
    // Choose the smallest beta
    beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
    beta = beta.toRed(this.red);
  }
  if (conf.lambda) {
    lambda = new BN(conf.lambda, 16);
  } else {
    // Choose the lambda that is matching selected beta
    var lambdas = this._getEndoRoots(this.n);
    if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) {
      lambda = lambdas[0];
    } else {
      lambda = lambdas[1];
      assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
    }
  }

  // Get basis vectors, used for balanced length-two representation
  var basis;
  if (conf.basis) {
    basis = conf.basis.map(function(vec) {
      return {
        a: new BN(vec.a, 16),
        b: new BN(vec.b, 16),
      };
    });
  } else {
    basis = this._getEndoBasis(lambda);
  }

  return {
    beta: beta,
    lambda: lambda,
    basis: basis,
  };
};

ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
  // Find roots of for x^2 + x + 1 in F
  // Root = (-1 +- Sqrt(-3)) / 2
  //
  var red = num === this.p ? this.red : BN.mont(num);
  var tinv = new BN(2).toRed(red).redInvm();
  var ntinv = tinv.redNeg();

  var s = new BN(3).toRed(red).redNeg().redSqrt().redMul(tinv);

  var l1 = ntinv.redAdd(s).fromRed();
  var l2 = ntinv.redSub(s).fromRed();
  return [ l1, l2 ];
};

ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
  // aprxSqrt >= sqrt(this.n)
  var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));

  // 3.74
  // Run EGCD, until r(L + 1) < aprxSqrt
  var u = lambda;
  var v = this.n.clone();
  var x1 = new BN(1);
  var y1 = new BN(0);
  var x2 = new BN(0);
  var y2 = new BN(1);

  // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
  var a0;
  var b0;
  // First vector
  var a1;
  var b1;
  // Second vector
  var a2;
  var b2;

  var prevR;
  var i = 0;
  var r;
  var x;
  while (u.cmpn(0) !== 0) {
    var q = v.div(u);
    r = v.sub(q.mul(u));
    x = x2.sub(q.mul(x1));
    var y = y2.sub(q.mul(y1));

    if (!a1 && r.cmp(aprxSqrt) < 0) {
      a0 = prevR.neg();
      b0 = x1;
      a1 = r.neg();
      b1 = x;
    } else if (a1 && ++i === 2) {
      break;
    }
    prevR = r;

    v = u;
    u = r;
    x2 = x1;
    x1 = x;
    y2 = y1;
    y1 = y;
  }
  a2 = r.neg();
  b2 = x;

  var len1 = a1.sqr().add(b1.sqr());
  var len2 = a2.sqr().add(b2.sqr());
  if (len2.cmp(len1) >= 0) {
    a2 = a0;
    b2 = b0;
  }

  // Normalize signs
  if (a1.negative) {
    a1 = a1.neg();
    b1 = b1.neg();
  }
  if (a2.negative) {
    a2 = a2.neg();
    b2 = b2.neg();
  }

  return [
    { a: a1, b: b1 },
    { a: a2, b: b2 },
  ];
};

ShortCurve.prototype._endoSplit = function _endoSplit(k) {
  var basis = this.endo.basis;
  var v1 = basis[0];
  var v2 = basis[1];

  var c1 = v2.b.mul(k).divRound(this.n);
  var c2 = v1.b.neg().mul(k).divRound(this.n);

  var p1 = c1.mul(v1.a);
  var p2 = c2.mul(v2.a);
  var q1 = c1.mul(v1.b);
  var q2 = c2.mul(v2.b);

  // Calculate answer
  var k1 = k.sub(p1).sub(p2);
  var k2 = q1.add(q2).neg();
  return { k1: k1, k2: k2 };
};

ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
  x = new BN(x, 16);
  if (!x.red)
    x = x.toRed(this.red);

  var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
  var y = y2.redSqrt();
  if (y.redSqr().redSub(y2).cmp(this.zero) !== 0)
    throw new Error('invalid point');

  // XXX Is there any way to tell if the number is odd without converting it
  // to non-red form?
  var isOdd = y.fromRed().isOdd();
  if (odd && !isOdd || !odd && isOdd)
    y = y.redNeg();

  return this.point(x, y);
};

ShortCurve.prototype.validate = function validate(point) {
  if (point.inf)
    return true;

  var x = point.x;
  var y = point.y;

  var ax = this.a.redMul(x);
  var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
  return y.redSqr().redISub(rhs).cmpn(0) === 0;
};

ShortCurve.prototype._endoWnafMulAdd =
    function _endoWnafMulAdd(points, coeffs, jacobianResult) {
      var npoints = this._endoWnafT1;
      var ncoeffs = this._endoWnafT2;
      for (var i = 0; i < points.length; i++) {
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();

        if (split.k1.negative) {
          split.k1.ineg();
          p = p.neg(true);
        }
        if (split.k2.negative) {
          split.k2.ineg();
          beta = beta.neg(true);
        }

        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
      }
      var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);

      // Clean-up references to points and coefficients
      for (var j = 0; j < i * 2; j++) {
        npoints[j] = null;
        ncoeffs[j] = null;
      }
      return res;
    };

function Point(curve, x, y, isRed) {
  Base.BasePoint.call(this, curve, 'affine');
  if (x === null && y === null) {
    this.x = null;
    this.y = null;
    this.inf = true;
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    // Force redgomery representation when loading from JSON
    if (isRed) {
      this.x.forceRed(this.curve.red);
      this.y.forceRed(this.curve.red);
    }
    if (!this.x.red)
      this.x = this.x.toRed(this.curve.red);
    if (!this.y.red)
      this.y = this.y.toRed(this.curve.red);
    this.inf = false;
  }
}
inherits(Point, Base.BasePoint);

ShortCurve.prototype.point = function point(x, y, isRed) {
  return new Point(this, x, y, isRed);
};

ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
  return Point.fromJSON(this, obj, red);
};

Point.prototype._getBeta = function _getBeta() {
  if (!this.curve.endo)
    return;

  var pre = this.precomputed;
  if (pre && pre.beta)
    return pre.beta;

  var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
  if (pre) {
    var curve = this.curve;
    var endoMul = function(p) {
      return curve.point(p.x.redMul(curve.endo.beta), p.y);
    };
    pre.beta = beta;
    beta.precomputed = {
      beta: null,
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(endoMul),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(endoMul),
      },
    };
  }
  return beta;
};

Point.prototype.toJSON = function toJSON() {
  if (!this.precomputed)
    return [ this.x, this.y ];

  return [ this.x, this.y, this.precomputed && {
    doubles: this.precomputed.doubles && {
      step: this.precomputed.doubles.step,
      points: this.precomputed.doubles.points.slice(1),
    },
    naf: this.precomputed.naf && {
      wnd: this.precomputed.naf.wnd,
      points: this.precomputed.naf.points.slice(1),
    },
  } ];
};

Point.fromJSON = function fromJSON(curve, obj, red) {
  if (typeof obj === 'string')
    obj = JSON.parse(obj);
  var res = curve.point(obj[0], obj[1], red);
  if (!obj[2])
    return res;

  function obj2point(obj) {
    return curve.point(obj[0], obj[1], red);
  }

  var pre = obj[2];
  res.precomputed = {
    beta: null,
    doubles: pre.doubles && {
      step: pre.doubles.step,
      points: [ res ].concat(pre.doubles.points.map(obj2point)),
    },
    naf: pre.naf && {
      wnd: pre.naf.wnd,
      points: [ res ].concat(pre.naf.points.map(obj2point)),
    },
  };
  return res;
};

Point.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC Point Infinity>';
  return '<EC Point x: ' + this.x.fromRed().toString(16, 2) +
      ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};

Point.prototype.isInfinity = function isInfinity() {
  return this.inf;
};

Point.prototype.add = function add(p) {
  // O + P = P
  if (this.inf)
    return p;

  // P + O = P
  if (p.inf)
    return this;

  // P + P = 2P
  if (this.eq(p))
    return this.dbl();

  // P + (-P) = O
  if (this.neg().eq(p))
    return this.curve.point(null, null);

  // P + Q = O
  if (this.x.cmp(p.x) === 0)
    return this.curve.point(null, null);

  var c = this.y.redSub(p.y);
  if (c.cmpn(0) !== 0)
    c = c.redMul(this.x.redSub(p.x).redInvm());
  var nx = c.redSqr().redISub(this.x).redISub(p.x);
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.dbl = function dbl() {
  if (this.inf)
    return this;

  // 2P = O
  var ys1 = this.y.redAdd(this.y);
  if (ys1.cmpn(0) === 0)
    return this.curve.point(null, null);

  var a = this.curve.a;

  var x2 = this.x.redSqr();
  var dyinv = ys1.redInvm();
  var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);

  var nx = c.redSqr().redISub(this.x.redAdd(this.x));
  var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
  return this.curve.point(nx, ny);
};

Point.prototype.getX = function getX() {
  return this.x.fromRed();
};

Point.prototype.getY = function getY() {
  return this.y.fromRed();
};

Point.prototype.mul = function mul(k) {
  k = new BN(k, 16);
  if (this.isInfinity())
    return this;
  else if (this._hasDoubles(k))
    return this.curve._fixedNafMul(this, k);
  else if (this.curve.endo)
    return this.curve._endoWnafMulAdd([ this ], [ k ]);
  else
    return this.curve._wnafMul(this, k);
};

Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2);
};

Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
  var points = [ this, p2 ];
  var coeffs = [ k1, k2 ];
  if (this.curve.endo)
    return this.curve._endoWnafMulAdd(points, coeffs, true);
  else
    return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};

Point.prototype.eq = function eq(p) {
  return this === p ||
         this.inf === p.inf &&
             (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};

Point.prototype.neg = function neg(_precompute) {
  if (this.inf)
    return this;

  var res = this.curve.point(this.x, this.y.redNeg());
  if (_precompute && this.precomputed) {
    var pre = this.precomputed;
    var negate = function(p) {
      return p.neg();
    };
    res.precomputed = {
      naf: pre.naf && {
        wnd: pre.naf.wnd,
        points: pre.naf.points.map(negate),
      },
      doubles: pre.doubles && {
        step: pre.doubles.step,
        points: pre.doubles.points.map(negate),
      },
    };
  }
  return res;
};

Point.prototype.toJ = function toJ() {
  if (this.inf)
    return this.curve.jpoint(null, null, null);

  var res = this.curve.jpoint(this.x, this.y, this.curve.one);
  return res;
};

function JPoint(curve, x, y, z) {
  Base.BasePoint.call(this, curve, 'jacobian');
  if (x === null && y === null && z === null) {
    this.x = this.curve.one;
    this.y = this.curve.one;
    this.z = new BN(0);
  } else {
    this.x = new BN(x, 16);
    this.y = new BN(y, 16);
    this.z = new BN(z, 16);
  }
  if (!this.x.red)
    this.x = this.x.toRed(this.curve.red);
  if (!this.y.red)
    this.y = this.y.toRed(this.curve.red);
  if (!this.z.red)
    this.z = this.z.toRed(this.curve.red);

  this.zOne = this.z === this.curve.one;
}
inherits(JPoint, Base.BasePoint);

ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
  return new JPoint(this, x, y, z);
};

JPoint.prototype.toP = function toP() {
  if (this.isInfinity())
    return this.curve.point(null, null);

  var zinv = this.z.redInvm();
  var zinv2 = zinv.redSqr();
  var ax = this.x.redMul(zinv2);
  var ay = this.y.redMul(zinv2).redMul(zinv);

  return this.curve.point(ax, ay);
};

JPoint.prototype.neg = function neg() {
  return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};

JPoint.prototype.add = function add(p) {
  // O + P = P
  if (this.isInfinity())
    return p;

  // P + O = P
  if (p.isInfinity())
    return this;

  // 12M + 4S + 7A
  var pz2 = p.z.redSqr();
  var z2 = this.z.redSqr();
  var u1 = this.x.redMul(pz2);
  var u2 = p.x.redMul(z2);
  var s1 = this.y.redMul(pz2.redMul(p.z));
  var s2 = p.y.redMul(z2.redMul(this.z));

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(p.z).redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mixedAdd = function mixedAdd(p) {
  // O + P = P
  if (this.isInfinity())
    return p.toJ();

  // P + O = P
  if (p.isInfinity())
    return this;

  // 8M + 3S + 7A
  var z2 = this.z.redSqr();
  var u1 = this.x;
  var u2 = p.x.redMul(z2);
  var s1 = this.y;
  var s2 = p.y.redMul(z2).redMul(this.z);

  var h = u1.redSub(u2);
  var r = s1.redSub(s2);
  if (h.cmpn(0) === 0) {
    if (r.cmpn(0) !== 0)
      return this.curve.jpoint(null, null, null);
    else
      return this.dbl();
  }

  var h2 = h.redSqr();
  var h3 = h2.redMul(h);
  var v = u1.redMul(h2);

  var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
  var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
  var nz = this.z.redMul(h);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.dblp = function dblp(pow) {
  if (pow === 0)
    return this;
  if (this.isInfinity())
    return this;
  if (!pow)
    return this.dbl();

  var i;
  if (this.curve.zeroA || this.curve.threeA) {
    var r = this;
    for (i = 0; i < pow; i++)
      r = r.dbl();
    return r;
  }

  // 1M + 2S + 1A + N * (4S + 5M + 8A)
  // N = 1 => 6M + 6S + 9A
  var a = this.curve.a;
  var tinv = this.curve.tinv;

  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  // Reuse results
  var jyd = jy.redAdd(jy);
  for (i = 0; i < pow; i++) {
    var jx2 = jx.redSqr();
    var jyd2 = jyd.redSqr();
    var jyd4 = jyd2.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

    var t1 = jx.redMul(jyd2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var dny = c.redMul(t2);
    dny = dny.redIAdd(dny).redISub(jyd4);
    var nz = jyd.redMul(jz);
    if (i + 1 < pow)
      jz4 = jz4.redMul(jyd4);

    jx = nx;
    jz = nz;
    jyd = dny;
  }

  return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};

JPoint.prototype.dbl = function dbl() {
  if (this.isInfinity())
    return this;

  if (this.curve.zeroA)
    return this._zeroDbl();
  else if (this.curve.threeA)
    return this._threeDbl();
  else
    return this._dbl();
};

JPoint.prototype._zeroDbl = function _zeroDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 14A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // T = M ^ 2 - 2*S
    var t = m.redSqr().redISub(s).redISub(s);

    // 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);

    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2*Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
    //     #doubling-dbl-2009-l
    // 2M + 5S + 13A

    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = B^2
    var c = b.redSqr();
    // D = 2 * ((X1 + B)^2 - A - C)
    var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
    d = d.redIAdd(d);
    // E = 3 * A
    var e = a.redAdd(a).redIAdd(a);
    // F = E^2
    var f = e.redSqr();

    // 8 * C
    var c8 = c.redIAdd(c);
    c8 = c8.redIAdd(c8);
    c8 = c8.redIAdd(c8);

    // X3 = F - 2 * D
    nx = f.redISub(d).redISub(d);
    // Y3 = E * (D - X3) - 8 * C
    ny = e.redMul(d.redISub(nx)).redISub(c8);
    // Z3 = 2 * Y1 * Z1
    nz = this.y.redMul(this.z);
    nz = nz.redIAdd(nz);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._threeDbl = function _threeDbl() {
  var nx;
  var ny;
  var nz;
  // Z = 1
  if (this.zOne) {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
    //     #doubling-mdbl-2007-bl
    // 1M + 5S + 15A

    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // S = 2 * ((X1 + YY)^2 - XX - YYYY)
    var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    s = s.redIAdd(s);
    // M = 3 * XX + a
    var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
    // T = M^2 - 2 * S
    var t = m.redSqr().redISub(s).redISub(s);
    // X3 = T
    nx = t;
    // Y3 = M * (S - T) - 8 * YYYY
    var yyyy8 = yyyy.redIAdd(yyyy);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    yyyy8 = yyyy8.redIAdd(yyyy8);
    ny = m.redMul(s.redISub(t)).redISub(yyyy8);
    // Z3 = 2 * Y1
    nz = this.y.redAdd(this.y);
  } else {
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
    // 3M + 5S

    // delta = Z1^2
    var delta = this.z.redSqr();
    // gamma = Y1^2
    var gamma = this.y.redSqr();
    // beta = X1 * gamma
    var beta = this.x.redMul(gamma);
    // alpha = 3 * (X1 - delta) * (X1 + delta)
    var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
    alpha = alpha.redAdd(alpha).redIAdd(alpha);
    // X3 = alpha^2 - 8 * beta
    var beta4 = beta.redIAdd(beta);
    beta4 = beta4.redIAdd(beta4);
    var beta8 = beta4.redAdd(beta4);
    nx = alpha.redSqr().redISub(beta8);
    // Z3 = (Y1 + Z1)^2 - gamma - delta
    nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
    // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
    var ggamma8 = gamma.redSqr();
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ggamma8 = ggamma8.redIAdd(ggamma8);
    ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
  }

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype._dbl = function _dbl() {
  var a = this.curve.a;

  // 4M + 6S + 10A
  var jx = this.x;
  var jy = this.y;
  var jz = this.z;
  var jz4 = jz.redSqr().redSqr();

  var jx2 = jx.redSqr();
  var jy2 = jy.redSqr();

  var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));

  var jxd4 = jx.redAdd(jx);
  jxd4 = jxd4.redIAdd(jxd4);
  var t1 = jxd4.redMul(jy2);
  var nx = c.redSqr().redISub(t1.redAdd(t1));
  var t2 = t1.redISub(nx);

  var jyd8 = jy2.redSqr();
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  jyd8 = jyd8.redIAdd(jyd8);
  var ny = c.redMul(t2).redISub(jyd8);
  var nz = jy.redAdd(jy).redMul(jz);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.trpl = function trpl() {
  if (!this.curve.zeroA)
    return this.dbl().add(this);

  // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
  // 5M + 10S + ...

  // XX = X1^2
  var xx = this.x.redSqr();
  // YY = Y1^2
  var yy = this.y.redSqr();
  // ZZ = Z1^2
  var zz = this.z.redSqr();
  // YYYY = YY^2
  var yyyy = yy.redSqr();
  // M = 3 * XX + a * ZZ2; a = 0
  var m = xx.redAdd(xx).redIAdd(xx);
  // MM = M^2
  var mm = m.redSqr();
  // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
  var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
  e = e.redIAdd(e);
  e = e.redAdd(e).redIAdd(e);
  e = e.redISub(mm);
  // EE = E^2
  var ee = e.redSqr();
  // T = 16*YYYY
  var t = yyyy.redIAdd(yyyy);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  t = t.redIAdd(t);
  // U = (M + E)^2 - MM - EE - T
  var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
  // X3 = 4 * (X1 * EE - 4 * YY * U)
  var yyu4 = yy.redMul(u);
  yyu4 = yyu4.redIAdd(yyu4);
  yyu4 = yyu4.redIAdd(yyu4);
  var nx = this.x.redMul(ee).redISub(yyu4);
  nx = nx.redIAdd(nx);
  nx = nx.redIAdd(nx);
  // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
  var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  ny = ny.redIAdd(ny);
  // Z3 = (Z1 + E)^2 - ZZ - EE
  var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);

  return this.curve.jpoint(nx, ny, nz);
};

JPoint.prototype.mul = function mul(k, kbase) {
  k = new BN(k, kbase);

  return this.curve._wnafMul(this, k);
};

JPoint.prototype.eq = function eq(p) {
  if (p.type === 'affine')
    return this.eq(p.toJ());

  if (this === p)
    return true;

  // x1 * z2^2 == x2 * z1^2
  var z2 = this.z.redSqr();
  var pz2 = p.z.redSqr();
  if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0)
    return false;

  // y1 * z2^3 == y2 * z1^3
  var z3 = z2.redMul(this.z);
  var pz3 = pz2.redMul(p.z);
  return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};

JPoint.prototype.eqXToP = function eqXToP(x) {
  var zs = this.z.redSqr();
  var rx = x.toRed(this.curve.red).redMul(zs);
  if (this.x.cmp(rx) === 0)
    return true;

  var xc = x.clone();
  var t = this.curve.redN.redMul(zs);
  for (;;) {
    xc.iadd(this.curve.n);
    if (xc.cmp(this.curve.p) >= 0)
      return false;

    rx.redIAdd(t);
    if (this.x.cmp(rx) === 0)
      return true;
  }
};

JPoint.prototype.inspect = function inspect() {
  if (this.isInfinity())
    return '<EC JPoint Infinity>';
  return '<EC JPoint x: ' + this.x.toString(16, 2) +
      ' y: ' + this.y.toString(16, 2) +
      ' z: ' + this.z.toString(16, 2) + '>';
};

JPoint.prototype.isInfinity = function isInfinity() {
  // XXX This code assumes that zero is always zero in red
  return this.z.cmpn(0) === 0;
};


/***/ }),
/* 2946 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(77);
var HmacDRBG = __webpack_require__(3014);
var utils = __webpack_require__(135);
var curves = __webpack_require__(654);
var rand = __webpack_require__(599);
var assert = utils.assert;

var KeyPair = __webpack_require__(2947);
var Signature = __webpack_require__(2948);

function EC(options) {
  if (!(this instanceof EC))
    return new EC(options);

  // Shortcut `elliptic.ec(curve-name)`
  if (typeof options === 'string') {
    assert(Object.prototype.hasOwnProperty.call(curves, options),
      'Unknown curve ' + options);

    options = curves[options];
  }

  // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
  if (options instanceof curves.PresetCurve)
    options = { curve: options };

  this.curve = options.curve.curve;
  this.n = this.curve.n;
  this.nh = this.n.ushrn(1);
  this.g = this.curve.g;

  // Point on curve
  this.g = options.curve.g;
  this.g.precompute(options.curve.n.bitLength() + 1);

  // Hash for function for DRBG
  this.hash = options.hash || options.curve.hash;
}
module.exports = EC;

EC.prototype.keyPair = function keyPair(options) {
  return new KeyPair(this, options);
};

EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
  return KeyPair.fromPrivate(this, priv, enc);
};

EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
  return KeyPair.fromPublic(this, pub, enc);
};

EC.prototype.genKeyPair = function genKeyPair(options) {
  if (!options)
    options = {};

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
    entropy: options.entropy || rand(this.hash.hmacStrength),
    entropyEnc: options.entropy && options.entropyEnc || 'utf8',
    nonce: this.n.toArray(),
  });

  var bytes = this.n.byteLength();
  var ns2 = this.n.sub(new BN(2));
  for (;;) {
    var priv = new BN(drbg.generate(bytes));
    if (priv.cmp(ns2) > 0)
      continue;

    priv.iaddn(1);
    return this.keyFromPrivate(priv);
  }
};

EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
  var byteLength;
  if (BN.isBN(msg) || typeof msg === 'number') {
    msg = new BN(msg, 16);
    byteLength = msg.byteLength();
  } else if (typeof msg === 'object') {
    // BN assumes an array-like input and asserts length
    byteLength = msg.length;
    msg = new BN(msg, 16);
  } else {
    // BN converts the value to string
    var str = msg.toString();
    // HEX encoding
    byteLength = (str.length + 1) >>> 1;
    msg = new BN(str, 16);
  }
  // Allow overriding
  if (typeof bitLength !== 'number') {
    bitLength = byteLength * 8;
  }
  var delta = bitLength - this.n.bitLength();
  if (delta > 0)
    msg = msg.ushrn(delta);
  if (!truncOnly && msg.cmp(this.n) >= 0)
    return msg.sub(this.n);
  else
    return msg;
};

EC.prototype.sign = function sign(msg, key, enc, options) {
  if (typeof enc === 'object') {
    options = enc;
    enc = null;
  }
  if (!options)
    options = {};

  if (typeof msg !== 'string' && typeof msg !== 'number' && !BN.isBN(msg)) {
    assert(typeof msg === 'object' && msg && typeof msg.length === 'number',
      'Expected message to be an array-like, a hex string, or a BN instance');
    assert((msg.length >>> 0) === msg.length); // non-negative 32-bit integer
    for (var i = 0; i < msg.length; i++) assert((msg[i] & 255) === msg[i]);
  }

  key = this.keyFromPrivate(key, enc);
  msg = this._truncateToN(msg, false, options.msgBitLength);

  // Would fail further checks, but let's make the error message clear
  assert(!msg.isNeg(), 'Can not sign a negative message');

  // Zero-extend key to provide enough entropy
  var bytes = this.n.byteLength();
  var bkey = key.getPrivate().toArray('be', bytes);

  // Zero-extend nonce to have the same byte size as N
  var nonce = msg.toArray('be', bytes);

  // Recheck nonce to be bijective to msg
  assert((new BN(nonce)).eq(msg), 'Can not sign message');

  // Instantiate Hmac_DRBG
  var drbg = new HmacDRBG({
    hash: this.hash,
    entropy: bkey,
    nonce: nonce,
    pers: options.pers,
    persEnc: options.persEnc || 'utf8',
  });

  // Number of bytes to generate
  var ns1 = this.n.sub(new BN(1));

  for (var iter = 0; ; iter++) {
    var k = options.k ?
      options.k(iter) :
      new BN(drbg.generate(this.n.byteLength()));
    k = this._truncateToN(k, true);
    if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0)
      continue;

    var kp = this.g.mul(k);
    if (kp.isInfinity())
      continue;

    var kpX = kp.getX();
    var r = kpX.umod(this.n);
    if (r.cmpn(0) === 0)
      continue;

    var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
    s = s.umod(this.n);
    if (s.cmpn(0) === 0)
      continue;

    var recoveryParam = (kp.getY().isOdd() ? 1 : 0) |
                        (kpX.cmp(r) !== 0 ? 2 : 0);

    // Use complement of `s`, if it is > `n / 2`
    if (options.canonical && s.cmp(this.nh) > 0) {
      s = this.n.sub(s);
      recoveryParam ^= 1;
    }

    return new Signature({ r: r, s: s, recoveryParam: recoveryParam });
  }
};

EC.prototype.verify = function verify(msg, signature, key, enc, options) {
  if (!options)
    options = {};

  msg = this._truncateToN(msg, false, options.msgBitLength);
  key = this.keyFromPublic(key, enc);
  signature = new Signature(signature, 'hex');

  // Perform primitive values validation
  var r = signature.r;
  var s = signature.s;
  if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0)
    return false;
  if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0)
    return false;

  // Validate signature
  var sinv = s.invm(this.n);
  var u1 = sinv.mul(msg).umod(this.n);
  var u2 = sinv.mul(r).umod(this.n);
  var p;

  if (!this.curve._maxwellTrick) {
    p = this.g.mulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity())
      return false;

    return p.getX().umod(this.n).cmp(r) === 0;
  }

  // NOTE: Greg Maxwell's trick, inspired by:
  // https://git.io/vad3K

  p = this.g.jmulAdd(u1, key.getPublic(), u2);
  if (p.isInfinity())
    return false;

  // Compare `p.x` of Jacobian point with `r`,
  // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
  // inverse of `p.z^2`
  return p.eqXToP(r);
};

EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
  assert((3 & j) === j, 'The recovery param is more than two bits');
  signature = new Signature(signature, enc);

  var n = this.n;
  var e = new BN(msg);
  var r = signature.r;
  var s = signature.s;

  // A set LSB signifies that the y-coordinate is odd
  var isYOdd = j & 1;
  var isSecondKey = j >> 1;
  if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey)
    throw new Error('Unable to find sencond key candinate');

  // 1.1. Let x = r + jn.
  if (isSecondKey)
    r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
  else
    r = this.curve.pointFromX(r, isYOdd);

  var rInv = signature.r.invm(n);
  var s1 = n.sub(e).mul(rInv).umod(n);
  var s2 = s.mul(rInv).umod(n);

  // 1.6.1 Compute Q = r^-1 (sR -  eG)
  //               Q = r^-1 (sR + -eG)
  return this.g.mulAdd(s1, r, s2);
};

EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
  signature = new Signature(signature, enc);
  if (signature.recoveryParam !== null)
    return signature.recoveryParam;

  for (var i = 0; i < 4; i++) {
    var Qprime;
    try {
      Qprime = this.recoverPubKey(e, signature, i);
    } catch (e) {
      continue;
    }

    if (Qprime.eq(Q))
      return i;
  }
  throw new Error('Unable to find valid recovery factor');
};


/***/ }),
/* 2947 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(77);
var utils = __webpack_require__(135);
var assert = utils.assert;

function KeyPair(ec, options) {
  this.ec = ec;
  this.priv = null;
  this.pub = null;

  // KeyPair(ec, { priv: ..., pub: ... })
  if (options.priv)
    this._importPrivate(options.priv, options.privEnc);
  if (options.pub)
    this._importPublic(options.pub, options.pubEnc);
}
module.exports = KeyPair;

KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
  if (pub instanceof KeyPair)
    return pub;

  return new KeyPair(ec, {
    pub: pub,
    pubEnc: enc,
  });
};

KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
  if (priv instanceof KeyPair)
    return priv;

  return new KeyPair(ec, {
    priv: priv,
    privEnc: enc,
  });
};

KeyPair.prototype.validate = function validate() {
  var pub = this.getPublic();

  if (pub.isInfinity())
    return { result: false, reason: 'Invalid public key' };
  if (!pub.validate())
    return { result: false, reason: 'Public key is not a point' };
  if (!pub.mul(this.ec.curve.n).isInfinity())
    return { result: false, reason: 'Public key * N != O' };

  return { result: true, reason: null };
};

KeyPair.prototype.getPublic = function getPublic(compact, enc) {
  // compact is optional argument
  if (typeof compact === 'string') {
    enc = compact;
    compact = null;
  }

  if (!this.pub)
    this.pub = this.ec.g.mul(this.priv);

  if (!enc)
    return this.pub;

  return this.pub.encode(enc, compact);
};

KeyPair.prototype.getPrivate = function getPrivate(enc) {
  if (enc === 'hex')
    return this.priv.toString(16, 2);
  else
    return this.priv;
};

KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
  this.priv = new BN(key, enc || 16);

  // Ensure that the priv won't be bigger than n, otherwise we may fail
  // in fixed multiplication method
  this.priv = this.priv.umod(this.ec.curve.n);
};

KeyPair.prototype._importPublic = function _importPublic(key, enc) {
  if (key.x || key.y) {
    // Montgomery points only have an `x` coordinate.
    // Weierstrass/Edwards points on the other hand have both `x` and
    // `y` coordinates.
    if (this.ec.curve.type === 'mont') {
      assert(key.x, 'Need x coordinate');
    } else if (this.ec.curve.type === 'short' ||
               this.ec.curve.type === 'edwards') {
      assert(key.x && key.y, 'Need both x and y coordinate');
    }
    this.pub = this.ec.curve.point(key.x, key.y);
    return;
  }
  this.pub = this.ec.curve.decodePoint(key, enc);
};

// ECDH
KeyPair.prototype.derive = function derive(pub) {
  if(!pub.validate()) {
    assert(pub.validate(), 'public point not validated');
  }
  return pub.mul(this.priv).getX();
};

// ECDSA
KeyPair.prototype.sign = function sign(msg, enc, options) {
  return this.ec.sign(msg, this, enc, options);
};

KeyPair.prototype.verify = function verify(msg, signature, options) {
  return this.ec.verify(msg, signature, this, undefined, options);
};

KeyPair.prototype.inspect = function inspect() {
  return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) +
         ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};


/***/ }),
/* 2948 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(77);

var utils = __webpack_require__(135);
var assert = utils.assert;

function Signature(options, enc) {
  if (options instanceof Signature)
    return options;

  if (this._importDER(options, enc))
    return;

  assert(options.r && options.s, 'Signature without r or s');
  this.r = new BN(options.r, 16);
  this.s = new BN(options.s, 16);
  if (options.recoveryParam === undefined)
    this.recoveryParam = null;
  else
    this.recoveryParam = options.recoveryParam;
}
module.exports = Signature;

function Position() {
  this.place = 0;
}

function getLength(buf, p) {
  var initial = buf[p.place++];
  if (!(initial & 0x80)) {
    return initial;
  }
  var octetLen = initial & 0xf;

  // Indefinite length or overflow
  if (octetLen === 0 || octetLen > 4) {
    return false;
  }

  if(buf[p.place] === 0x00) {
    return false;
  }

  var val = 0;
  for (var i = 0, off = p.place; i < octetLen; i++, off++) {
    val <<= 8;
    val |= buf[off];
    val >>>= 0;
  }

  // Leading zeroes
  if (val <= 0x7f) {
    return false;
  }

  p.place = off;
  return val;
}

function rmPadding(buf) {
  var i = 0;
  var len = buf.length - 1;
  while (!buf[i] && !(buf[i + 1] & 0x80) && i < len) {
    i++;
  }
  if (i === 0) {
    return buf;
  }
  return buf.slice(i);
}

Signature.prototype._importDER = function _importDER(data, enc) {
  data = utils.toArray(data, enc);
  var p = new Position();
  if (data[p.place++] !== 0x30) {
    return false;
  }
  var len = getLength(data, p);
  if (len === false) {
    return false;
  }
  if ((len + p.place) !== data.length) {
    return false;
  }
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var rlen = getLength(data, p);
  if (rlen === false) {
    return false;
  }
  if ((data[p.place] & 128) !== 0) {
    return false;
  }
  var r = data.slice(p.place, rlen + p.place);
  p.place += rlen;
  if (data[p.place++] !== 0x02) {
    return false;
  }
  var slen = getLength(data, p);
  if (slen === false) {
    return false;
  }
  if (data.length !== slen + p.place) {
    return false;
  }
  if ((data[p.place] & 128) !== 0) {
    return false;
  }
  var s = data.slice(p.place, slen + p.place);
  if (r[0] === 0) {
    if (r[1] & 0x80) {
      r = r.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }
  if (s[0] === 0) {
    if (s[1] & 0x80) {
      s = s.slice(1);
    } else {
      // Leading zeroes
      return false;
    }
  }

  this.r = new BN(r);
  this.s = new BN(s);
  this.recoveryParam = null;

  return true;
};

function constructLength(arr, len) {
  if (len < 0x80) {
    arr.push(len);
    return;
  }
  var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
  arr.push(octets | 0x80);
  while (--octets) {
    arr.push((len >>> (octets << 3)) & 0xff);
  }
  arr.push(len);
}

Signature.prototype.toDER = function toDER(enc) {
  var r = this.r.toArray();
  var s = this.s.toArray();

  // Pad values
  if (r[0] & 0x80)
    r = [ 0 ].concat(r);
  // Pad values
  if (s[0] & 0x80)
    s = [ 0 ].concat(s);

  r = rmPadding(r);
  s = rmPadding(s);

  while (!s[0] && !(s[1] & 0x80)) {
    s = s.slice(1);
  }
  var arr = [ 0x02 ];
  constructLength(arr, r.length);
  arr = arr.concat(r);
  arr.push(0x02);
  constructLength(arr, s.length);
  var backHalf = arr.concat(s);
  var res = [ 0x30 ];
  constructLength(res, backHalf.length);
  res = res.concat(backHalf);
  return utils.encode(res, enc);
};


/***/ }),
/* 2949 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(670);
var curves = __webpack_require__(654);
var utils = __webpack_require__(135);
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var KeyPair = __webpack_require__(2950);
var Signature = __webpack_require__(2951);

function EDDSA(curve) {
  assert(curve === 'ed25519', 'only tested with ed25519 so far');

  if (!(this instanceof EDDSA))
    return new EDDSA(curve);

  curve = curves[curve].curve;
  this.curve = curve;
  this.g = curve.g;
  this.g.precompute(curve.n.bitLength() + 1);

  this.pointClass = curve.point().constructor;
  this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
  this.hash = hash.sha512;
}

module.exports = EDDSA;

/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/
EDDSA.prototype.sign = function sign(message, secret) {
  message = parseBytes(message);
  var key = this.keyFromSecret(secret);
  var r = this.hashInt(key.messagePrefix(), message);
  var R = this.g.mul(r);
  var Rencoded = this.encodePoint(R);
  var s_ = this.hashInt(Rencoded, key.pubBytes(), message)
    .mul(key.priv());
  var S = r.add(s_).umod(this.curve.n);
  return this.makeSignature({ R: R, S: S, Rencoded: Rencoded });
};

/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/
EDDSA.prototype.verify = function verify(message, sig, pub) {
  message = parseBytes(message);
  sig = this.makeSignature(sig);
  if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) {
    return false;
  }
  var key = this.keyFromPublic(pub);
  var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
  var SG = this.g.mul(sig.S());
  var RplusAh = sig.R().add(key.pub().mul(h));
  return RplusAh.eq(SG);
};

EDDSA.prototype.hashInt = function hashInt() {
  var hash = this.hash();
  for (var i = 0; i < arguments.length; i++)
    hash.update(arguments[i]);
  return utils.intFromLE(hash.digest()).umod(this.curve.n);
};

EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
  return KeyPair.fromPublic(this, pub);
};

EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
  return KeyPair.fromSecret(this, secret);
};

EDDSA.prototype.makeSignature = function makeSignature(sig) {
  if (sig instanceof Signature)
    return sig;
  return new Signature(this, sig);
};

/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/
EDDSA.prototype.encodePoint = function encodePoint(point) {
  var enc = point.getY().toArray('le', this.encodingLength);
  enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
  return enc;
};

EDDSA.prototype.decodePoint = function decodePoint(bytes) {
  bytes = utils.parseBytes(bytes);

  var lastIx = bytes.length - 1;
  var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & ~0x80);
  var xIsOdd = (bytes[lastIx] & 0x80) !== 0;

  var y = utils.intFromLE(normed);
  return this.curve.pointFromY(y, xIsOdd);
};

EDDSA.prototype.encodeInt = function encodeInt(num) {
  return num.toArray('le', this.encodingLength);
};

EDDSA.prototype.decodeInt = function decodeInt(bytes) {
  return utils.intFromLE(bytes);
};

EDDSA.prototype.isPoint = function isPoint(val) {
  return val instanceof this.pointClass;
};


/***/ }),
/* 2950 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(135);
var assert = utils.assert;
var parseBytes = utils.parseBytes;
var cachedProperty = utils.cachedProperty;

/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/
function KeyPair(eddsa, params) {
  this.eddsa = eddsa;
  this._secret = parseBytes(params.secret);
  if (eddsa.isPoint(params.pub))
    this._pub = params.pub;
  else
    this._pubBytes = parseBytes(params.pub);
}

KeyPair.fromPublic = function fromPublic(eddsa, pub) {
  if (pub instanceof KeyPair)
    return pub;
  return new KeyPair(eddsa, { pub: pub });
};

KeyPair.fromSecret = function fromSecret(eddsa, secret) {
  if (secret instanceof KeyPair)
    return secret;
  return new KeyPair(eddsa, { secret: secret });
};

KeyPair.prototype.secret = function secret() {
  return this._secret;
};

cachedProperty(KeyPair, 'pubBytes', function pubBytes() {
  return this.eddsa.encodePoint(this.pub());
});

cachedProperty(KeyPair, 'pub', function pub() {
  if (this._pubBytes)
    return this.eddsa.decodePoint(this._pubBytes);
  return this.eddsa.g.mul(this.priv());
});

cachedProperty(KeyPair, 'privBytes', function privBytes() {
  var eddsa = this.eddsa;
  var hash = this.hash();
  var lastIx = eddsa.encodingLength - 1;

  var a = hash.slice(0, eddsa.encodingLength);
  a[0] &= 248;
  a[lastIx] &= 127;
  a[lastIx] |= 64;

  return a;
});

cachedProperty(KeyPair, 'priv', function priv() {
  return this.eddsa.decodeInt(this.privBytes());
});

cachedProperty(KeyPair, 'hash', function hash() {
  return this.eddsa.hash().update(this.secret()).digest();
});

cachedProperty(KeyPair, 'messagePrefix', function messagePrefix() {
  return this.hash().slice(this.eddsa.encodingLength);
});

KeyPair.prototype.sign = function sign(message) {
  assert(this._secret, 'KeyPair can only verify');
  return this.eddsa.sign(message, this);
};

KeyPair.prototype.verify = function verify(message, sig) {
  return this.eddsa.verify(message, sig, this);
};

KeyPair.prototype.getSecret = function getSecret(enc) {
  assert(this._secret, 'KeyPair is public only');
  return utils.encode(this.secret(), enc);
};

KeyPair.prototype.getPublic = function getPublic(enc) {
  return utils.encode(this.pubBytes(), enc);
};

module.exports = KeyPair;


/***/ }),
/* 2951 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var BN = __webpack_require__(77);
var utils = __webpack_require__(135);
var assert = utils.assert;
var cachedProperty = utils.cachedProperty;
var parseBytes = utils.parseBytes;

/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/
function Signature(eddsa, sig) {
  this.eddsa = eddsa;

  if (typeof sig !== 'object')
    sig = parseBytes(sig);

  if (Array.isArray(sig)) {
    assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
    sig = {
      R: sig.slice(0, eddsa.encodingLength),
      S: sig.slice(eddsa.encodingLength),
    };
  }

  assert(sig.R && sig.S, 'Signature without R or S');

  if (eddsa.isPoint(sig.R))
    this._R = sig.R;
  if (sig.S instanceof BN)
    this._S = sig.S;

  this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
  this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}

cachedProperty(Signature, 'S', function S() {
  return this.eddsa.decodeInt(this.Sencoded());
});

cachedProperty(Signature, 'R', function R() {
  return this.eddsa.decodePoint(this.Rencoded());
});

cachedProperty(Signature, 'Rencoded', function Rencoded() {
  return this.eddsa.encodePoint(this.R());
});

cachedProperty(Signature, 'Sencoded', function Sencoded() {
  return this.eddsa.encodeInt(this.S());
});

Signature.prototype.toBytes = function toBytes() {
  return this.Rencoded().concat(this.Sencoded());
};

Signature.prototype.toHex = function toHex() {
  return utils.encode(this.toBytes(), 'hex').toUpperCase();
};

module.exports = Signature;


/***/ }),
/* 2952 */
/***/ (function(module, exports) {

module.exports = {
  doubles: {
    step: 4,
    points: [
      [
        'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
        'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821',
      ],
      [
        '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
        '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf',
      ],
      [
        '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
        'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695',
      ],
      [
        '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
        '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9',
      ],
      [
        '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
        '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36',
      ],
      [
        '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
        '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f',
      ],
      [
        'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
        '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999',
      ],
      [
        '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
        'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09',
      ],
      [
        'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
        '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d',
      ],
      [
        'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
        'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088',
      ],
      [
        'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
        '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d',
      ],
      [
        '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
        '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8',
      ],
      [
        '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
        '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a',
      ],
      [
        '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
        '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453',
      ],
      [
        '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
        '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160',
      ],
      [
        '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
        '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0',
      ],
      [
        '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
        '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6',
      ],
      [
        '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
        '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589',
      ],
      [
        '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
        'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17',
      ],
      [
        'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
        '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda',
      ],
      [
        'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
        '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd',
      ],
      [
        '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
        '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2',
      ],
      [
        '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
        '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6',
      ],
      [
        'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
        '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f',
      ],
      [
        '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
        'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01',
      ],
      [
        'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
        '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3',
      ],
      [
        'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
        'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f',
      ],
      [
        'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
        '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7',
      ],
      [
        'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
        'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78',
      ],
      [
        'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
        '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1',
      ],
      [
        '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
        'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150',
      ],
      [
        '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
        '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82',
      ],
      [
        'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
        '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc',
      ],
      [
        '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
        'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b',
      ],
      [
        'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
        '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51',
      ],
      [
        'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
        '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45',
      ],
      [
        'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
        'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120',
      ],
      [
        '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
        '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84',
      ],
      [
        '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
        '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d',
      ],
      [
        '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
        'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d',
      ],
      [
        '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
        '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8',
      ],
      [
        'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
        '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8',
      ],
      [
        '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
        '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac',
      ],
      [
        '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
        'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f',
      ],
      [
        '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
        '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962',
      ],
      [
        'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
        '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907',
      ],
      [
        '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
        'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec',
      ],
      [
        'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
        'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d',
      ],
      [
        'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
        '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414',
      ],
      [
        '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
        'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd',
      ],
      [
        '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
        'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0',
      ],
      [
        'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
        '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811',
      ],
      [
        'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
        '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1',
      ],
      [
        'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
        '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c',
      ],
      [
        '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
        'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73',
      ],
      [
        '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
        '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd',
      ],
      [
        'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
        'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405',
      ],
      [
        '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
        'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589',
      ],
      [
        '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
        '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e',
      ],
      [
        '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
        '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27',
      ],
      [
        'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
        'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1',
      ],
      [
        '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
        '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482',
      ],
      [
        '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
        '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945',
      ],
      [
        'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
        '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573',
      ],
      [
        'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
        'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82',
      ],
    ],
  },
  naf: {
    wnd: 7,
    points: [
      [
        'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
        '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672',
      ],
      [
        '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
        'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6',
      ],
      [
        '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
        '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da',
      ],
      [
        'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
        'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37',
      ],
      [
        '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
        'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b',
      ],
      [
        'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
        'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81',
      ],
      [
        'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
        '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58',
      ],
      [
        'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
        '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77',
      ],
      [
        '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
        '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a',
      ],
      [
        '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
        '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c',
      ],
      [
        '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
        '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67',
      ],
      [
        '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
        '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402',
      ],
      [
        'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
        'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55',
      ],
      [
        'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
        '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482',
      ],
      [
        '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
        'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82',
      ],
      [
        '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
        'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396',
      ],
      [
        '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
        '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49',
      ],
      [
        '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
        '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf',
      ],
      [
        '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
        '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a',
      ],
      [
        '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
        'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7',
      ],
      [
        'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
        'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933',
      ],
      [
        '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
        '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a',
      ],
      [
        '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
        '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6',
      ],
      [
        'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
        'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37',
      ],
      [
        '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
        '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e',
      ],
      [
        'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
        'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6',
      ],
      [
        'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
        'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476',
      ],
      [
        '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
        '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40',
      ],
      [
        '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
        '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61',
      ],
      [
        '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
        '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683',
      ],
      [
        'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
        '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5',
      ],
      [
        '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
        '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b',
      ],
      [
        'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
        '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417',
      ],
      [
        '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
        'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868',
      ],
      [
        '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
        'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a',
      ],
      [
        'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
        'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6',
      ],
      [
        '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
        '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996',
      ],
      [
        '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
        'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e',
      ],
      [
        'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
        'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d',
      ],
      [
        '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
        '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2',
      ],
      [
        '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
        'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e',
      ],
      [
        '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
        '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437',
      ],
      [
        '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
        'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311',
      ],
      [
        'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
        '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4',
      ],
      [
        '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
        '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575',
      ],
      [
        '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
        'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d',
      ],
      [
        '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
        'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d',
      ],
      [
        'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
        'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629',
      ],
      [
        'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
        'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06',
      ],
      [
        '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
        '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374',
      ],
      [
        '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
        '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee',
      ],
      [
        'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
        '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1',
      ],
      [
        'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
        'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b',
      ],
      [
        '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
        '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661',
      ],
      [
        '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
        '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6',
      ],
      [
        'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
        '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e',
      ],
      [
        '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
        '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d',
      ],
      [
        'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
        'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc',
      ],
      [
        '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
        'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4',
      ],
      [
        '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
        '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c',
      ],
      [
        'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
        '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b',
      ],
      [
        'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
        '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913',
      ],
      [
        '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
        '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154',
      ],
      [
        '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
        '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865',
      ],
      [
        '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
        'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc',
      ],
      [
        '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
        'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224',
      ],
      [
        '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
        '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e',
      ],
      [
        '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
        '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6',
      ],
      [
        '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
        '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511',
      ],
      [
        '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
        'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b',
      ],
      [
        'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
        'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2',
      ],
      [
        '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
        'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c',
      ],
      [
        'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
        '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3',
      ],
      [
        'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
        '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d',
      ],
      [
        'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
        '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700',
      ],
      [
        'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
        '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4',
      ],
      [
        '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
        'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196',
      ],
      [
        '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
        '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4',
      ],
      [
        '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
        'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257',
      ],
      [
        'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
        'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13',
      ],
      [
        'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
        '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096',
      ],
      [
        'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
        'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38',
      ],
      [
        'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
        '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f',
      ],
      [
        '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
        '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448',
      ],
      [
        'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
        '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a',
      ],
      [
        'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
        '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4',
      ],
      [
        '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
        '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437',
      ],
      [
        '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
        'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7',
      ],
      [
        'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
        '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d',
      ],
      [
        'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
        '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a',
      ],
      [
        'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
        '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54',
      ],
      [
        '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
        '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77',
      ],
      [
        'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
        'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517',
      ],
      [
        '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
        'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10',
      ],
      [
        'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
        'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125',
      ],
      [
        'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
        '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e',
      ],
      [
        '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
        'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1',
      ],
      [
        'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
        '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2',
      ],
      [
        'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
        '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423',
      ],
      [
        'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
        '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8',
      ],
      [
        '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
        'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758',
      ],
      [
        '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
        'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375',
      ],
      [
        'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
        '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d',
      ],
      [
        '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
        'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec',
      ],
      [
        '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
        '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0',
      ],
      [
        '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
        'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c',
      ],
      [
        'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
        'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4',
      ],
      [
        '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
        'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f',
      ],
      [
        '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
        '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649',
      ],
      [
        '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
        'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826',
      ],
      [
        '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
        '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5',
      ],
      [
        'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
        'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87',
      ],
      [
        '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
        '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b',
      ],
      [
        'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
        '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc',
      ],
      [
        '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
        '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c',
      ],
      [
        'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
        'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f',
      ],
      [
        'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
        '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a',
      ],
      [
        'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
        'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46',
      ],
      [
        '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
        'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f',
      ],
      [
        '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
        '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03',
      ],
      [
        '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
        'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08',
      ],
      [
        '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
        '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8',
      ],
      [
        '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
        '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373',
      ],
      [
        '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
        'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3',
      ],
      [
        '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
        '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8',
      ],
      [
        '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
        '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1',
      ],
      [
        '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
        '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9',
      ],
    ],
  },
};


/***/ }),
/* 2953 */
/***/ (function(module, exports) {

module.exports = {"name":"elliptic","version":"6.6.1","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}

/***/ }),
/* 2954 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),
/* 2955 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),
/* 2956 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),
/* 2957 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),
/* 2958 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),
/* 2959 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),
/* 2960 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),
/* 2961 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 2962 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 2963 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 2964 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 2965 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reflectGetProto = __webpack_require__(1202);
var originalGetProto = __webpack_require__(1201);

var getDunderProto = __webpack_require__(2942);

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;


/***/ }),
/* 2966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserLocales", function() { return getUserLocales; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUserLocale", function() { return getUserLocale; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_once__ = __webpack_require__(3031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_once___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_once__);


function filterDuplicates(arr) {
  return arr.filter(function (el, index, self) {
    return self.indexOf(el) === index;
  });
}

function fixLowercaseProperties(arr) {
  return arr.map(function (el) {
    if (!el || el.indexOf('-') === -1 || el.toLowerCase() !== el) {
      return el;
    }

    var splitEl = el.split('-');
    return "".concat(splitEl[0], "-").concat(splitEl[1].toUpperCase());
  });
}

function getUserLocalesInternal() {
  var languageList = [];

  if (typeof window !== 'undefined') {
    if (window.navigator.languages) {
      languageList = languageList.concat(window.navigator.languages);
    }

    if (window.navigator.language) {
      languageList.push(window.navigator.language);
    }

    if (window.navigator.userLanguage) {
      languageList.push(window.navigator.userLanguage);
    }

    if (window.navigator.browserLanguage) {
      languageList.push(window.navigator.browserLanguage);
    }

    if (window.navigator.systemLanguage) {
      languageList.push(window.navigator.systemLanguage);
    }
  }

  languageList.push('en-US'); // Fallback

  return fixLowercaseProperties(filterDuplicates(languageList));
}

var getUserLocales = __WEBPACK_IMPORTED_MODULE_0_lodash_once___default()(getUserLocalesInternal);

function getUserLocaleInternal() {
  return getUserLocales()[0];
}

var getUserLocale = __WEBPACK_IMPORTED_MODULE_0_lodash_once___default()(getUserLocaleInternal);
/* harmony default export */ __webpack_exports__["default"] = (getUserLocale);

/***/ }),
/* 2967 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),
/* 2968 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatError = formatError;

var _invariant = _interopRequireDefault(__webpack_require__(108));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 */
function formatError(error) {
  !error ? (0, _invariant.default)(0, 'Received null or undefined error.') : void 0;
  var message = error.message || 'An unknown error occurred.';
  var locations = error.locations;
  var path = error.path;
  var extensions = error.extensions;
  return extensions ? {
    message: message,
    locations: locations,
    path: path,
    extensions: extensions
  } : {
    message: message,
    locations: locations,
    path: path
  };
}

/***/ }),
/* 2969 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.syntaxError = syntaxError;

var _GraphQLError = __webpack_require__(37);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */
function syntaxError(source, position, description) {
  return new _GraphQLError.GraphQLError("Syntax Error: ".concat(description), undefined, source, [position]);
}

/***/ }),
/* 2970 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "execute", {
  enumerable: true,
  get: function get() {
    return _execute.execute;
  }
});
Object.defineProperty(exports, "defaultFieldResolver", {
  enumerable: true,
  get: function get() {
    return _execute.defaultFieldResolver;
  }
});
Object.defineProperty(exports, "responsePathAsArray", {
  enumerable: true,
  get: function get() {
    return _execute.responsePathAsArray;
  }
});
Object.defineProperty(exports, "getDirectiveValues", {
  enumerable: true,
  get: function get() {
    return _values.getDirectiveValues;
  }
});

var _execute = __webpack_require__(437);

var _values = __webpack_require__(658);

/***/ }),
/* 2971 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.graphql = graphql;
exports.graphqlSync = graphqlSync;

var _validate = __webpack_require__(440);

var _parser = __webpack_require__(283);

var _validate2 = __webpack_require__(443);

var _execute = __webpack_require__(437);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function graphql(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver) {
  var _arguments = arguments;

  /* eslint-enable no-redeclare */
  // Always return a Promise for a consistent API.
  return new Promise(function (resolve) {
    return resolve( // Extract arguments from object args if provided.
    _arguments.length === 1 ? graphqlImpl(argsOrSchema.schema, argsOrSchema.source, argsOrSchema.rootValue, argsOrSchema.contextValue, argsOrSchema.variableValues, argsOrSchema.operationName, argsOrSchema.fieldResolver) : graphqlImpl(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver));
  });
}
/**
 * The graphqlSync function also fulfills GraphQL operations by parsing,
 * validating, and executing a GraphQL document along side a GraphQL schema.
 * However, it guarantees to complete synchronously (or throw an error) assuming
 * that all field resolvers are also synchronous.
 */


function graphqlSync(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver) {
  /* eslint-enable no-redeclare */
  // Extract arguments from object args if provided.
  var result = arguments.length === 1 ? graphqlImpl(argsOrSchema.schema, argsOrSchema.source, argsOrSchema.rootValue, argsOrSchema.contextValue, argsOrSchema.variableValues, argsOrSchema.operationName, argsOrSchema.fieldResolver) : graphqlImpl(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver); // Assert that the execution was synchronous.

  if (result.then) {
    throw new Error('GraphQL execution failed to complete synchronously.');
  }

  return result;
}

function graphqlImpl(schema, source, rootValue, contextValue, variableValues, operationName, fieldResolver) {
  // Validate Schema
  var schemaValidationErrors = (0, _validate.validateSchema)(schema);

  if (schemaValidationErrors.length > 0) {
    return {
      errors: schemaValidationErrors
    };
  } // Parse


  var document;

  try {
    document = (0, _parser.parse)(source);
  } catch (syntaxError) {
    return {
      errors: [syntaxError]
    };
  } // Validate


  var validationErrors = (0, _validate2.validate)(schema, document);

  if (validationErrors.length > 0) {
    return {
      errors: validationErrors
    };
  } // Execute


  return (0, _execute.execute)(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver);
}

/***/ }),
/* 2972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql__ = __webpack_require__(2971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__graphql___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__graphql__);
/* unused harmony reexport graphql */
/* unused harmony reexport graphqlSync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type__ = __webpack_require__(2982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__type__);
/* unused harmony reexport GraphQLSchema */
/* unused harmony reexport GraphQLScalarType */
/* unused harmony reexport GraphQLObjectType */
/* unused harmony reexport GraphQLInterfaceType */
/* unused harmony reexport GraphQLUnionType */
/* unused harmony reexport GraphQLEnumType */
/* unused harmony reexport GraphQLInputObjectType */
/* unused harmony reexport GraphQLList */
/* unused harmony reexport GraphQLNonNull */
/* unused harmony reexport GraphQLDirective */
/* unused harmony reexport TypeKind */
/* unused harmony reexport specifiedScalarTypes */
/* unused harmony reexport GraphQLInt */
/* unused harmony reexport GraphQLFloat */
/* unused harmony reexport GraphQLString */
/* unused harmony reexport GraphQLBoolean */
/* unused harmony reexport GraphQLID */
/* unused harmony reexport specifiedDirectives */
/* unused harmony reexport GraphQLIncludeDirective */
/* unused harmony reexport GraphQLSkipDirective */
/* unused harmony reexport GraphQLDeprecatedDirective */
/* unused harmony reexport DEFAULT_DEPRECATION_REASON */
/* unused harmony reexport SchemaMetaFieldDef */
/* unused harmony reexport TypeMetaFieldDef */
/* unused harmony reexport TypeNameMetaFieldDef */
/* unused harmony reexport introspectionTypes */
/* unused harmony reexport __Schema */
/* unused harmony reexport __Directive */
/* unused harmony reexport __DirectiveLocation */
/* unused harmony reexport __Type */
/* unused harmony reexport __Field */
/* unused harmony reexport __InputValue */
/* unused harmony reexport __EnumValue */
/* unused harmony reexport __TypeKind */
/* unused harmony reexport isSchema */
/* unused harmony reexport isDirective */
/* unused harmony reexport isType */
/* unused harmony reexport isScalarType */
/* unused harmony reexport isObjectType */
/* unused harmony reexport isInterfaceType */
/* unused harmony reexport isUnionType */
/* unused harmony reexport isEnumType */
/* unused harmony reexport isInputObjectType */
/* unused harmony reexport isListType */
/* unused harmony reexport isNonNullType */
/* unused harmony reexport isInputType */
/* unused harmony reexport isOutputType */
/* unused harmony reexport isLeafType */
/* unused harmony reexport isCompositeType */
/* unused harmony reexport isAbstractType */
/* unused harmony reexport isWrappingType */
/* unused harmony reexport isNullableType */
/* unused harmony reexport isNamedType */
/* unused harmony reexport isRequiredArgument */
/* unused harmony reexport isRequiredInputField */
/* unused harmony reexport isSpecifiedScalarType */
/* unused harmony reexport isIntrospectionType */
/* unused harmony reexport isSpecifiedDirective */
/* unused harmony reexport assertType */
/* unused harmony reexport assertScalarType */
/* unused harmony reexport assertObjectType */
/* unused harmony reexport assertInterfaceType */
/* unused harmony reexport assertUnionType */
/* unused harmony reexport assertEnumType */
/* unused harmony reexport assertInputObjectType */
/* unused harmony reexport assertListType */
/* unused harmony reexport assertNonNullType */
/* unused harmony reexport assertInputType */
/* unused harmony reexport assertOutputType */
/* unused harmony reexport assertLeafType */
/* unused harmony reexport assertCompositeType */
/* unused harmony reexport assertAbstractType */
/* unused harmony reexport assertWrappingType */
/* unused harmony reexport assertNullableType */
/* unused harmony reexport assertNamedType */
/* unused harmony reexport getNullableType */
/* unused harmony reexport getNamedType */
/* unused harmony reexport validateSchema */
/* unused harmony reexport assertValidSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language__ = __webpack_require__(2978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__language__);
/* unused harmony reexport Source */
/* unused harmony reexport getLocation */
/* unused harmony reexport parse */
/* unused harmony reexport parseValue */
/* unused harmony reexport parseType */
/* unused harmony reexport print */
/* unused harmony reexport visit */
/* unused harmony reexport visitInParallel */
/* unused harmony reexport visitWithTypeInfo */
/* unused harmony reexport getVisitFn */
/* unused harmony reexport Kind */
/* unused harmony reexport TokenKind */
/* unused harmony reexport DirectiveLocation */
/* unused harmony reexport BREAK */
/* unused harmony reexport isDefinitionNode */
/* unused harmony reexport isExecutableDefinitionNode */
/* unused harmony reexport isSelectionNode */
/* unused harmony reexport isValueNode */
/* unused harmony reexport isTypeNode */
/* unused harmony reexport isTypeSystemDefinitionNode */
/* unused harmony reexport isTypeDefinitionNode */
/* unused harmony reexport isTypeSystemExtensionNode */
/* unused harmony reexport isTypeExtensionNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__execution__ = __webpack_require__(2970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__execution___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__execution__);
/* unused harmony reexport execute */
/* unused harmony reexport defaultFieldResolver */
/* unused harmony reexport responsePathAsArray */
/* unused harmony reexport getDirectiveValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subscription__ = __webpack_require__(2979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subscription___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__subscription__);
/* unused harmony reexport subscribe */
/* unused harmony reexport createSourceEventStream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation__ = __webpack_require__(2996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__validation__);
/* unused harmony reexport validate */
/* unused harmony reexport ValidationContext */
/* unused harmony reexport specifiedRules */
/* unused harmony reexport FieldsOnCorrectTypeRule */
/* unused harmony reexport FragmentsOnCompositeTypesRule */
/* unused harmony reexport KnownArgumentNamesRule */
/* unused harmony reexport KnownDirectivesRule */
/* unused harmony reexport KnownFragmentNamesRule */
/* unused harmony reexport KnownTypeNamesRule */
/* unused harmony reexport LoneAnonymousOperationRule */
/* unused harmony reexport NoFragmentCyclesRule */
/* unused harmony reexport NoUndefinedVariablesRule */
/* unused harmony reexport NoUnusedFragmentsRule */
/* unused harmony reexport NoUnusedVariablesRule */
/* unused harmony reexport OverlappingFieldsCanBeMergedRule */
/* unused harmony reexport PossibleFragmentSpreadsRule */
/* unused harmony reexport ProvidedRequiredArgumentsRule */
/* unused harmony reexport ScalarLeafsRule */
/* unused harmony reexport SingleFieldSubscriptionsRule */
/* unused harmony reexport UniqueArgumentNamesRule */
/* unused harmony reexport UniqueDirectivesPerLocationRule */
/* unused harmony reexport UniqueFragmentNamesRule */
/* unused harmony reexport UniqueInputFieldNamesRule */
/* unused harmony reexport UniqueOperationNamesRule */
/* unused harmony reexport UniqueVariableNamesRule */
/* unused harmony reexport ValuesOfCorrectTypeRule */
/* unused harmony reexport VariablesAreInputTypesRule */
/* unused harmony reexport VariablesInAllowedPositionRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error__ = __webpack_require__(656);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__error__);
/* harmony reexport (binding) */ if(__webpack_require__.o(__WEBPACK_IMPORTED_MODULE_6__error__, "GraphQLError")) __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__error__["GraphQLError"]; });
/* unused harmony reexport formatError */
/* unused harmony reexport printError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities__ = __webpack_require__(2989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__utilities__);
/* unused harmony reexport getIntrospectionQuery */
/* unused harmony reexport introspectionQuery */
/* unused harmony reexport getOperationAST */
/* unused harmony reexport getOperationRootType */
/* unused harmony reexport introspectionFromSchema */
/* unused harmony reexport buildClientSchema */
/* unused harmony reexport buildASTSchema */
/* unused harmony reexport buildSchema */
/* unused harmony reexport getDescription */
/* unused harmony reexport extendSchema */
/* unused harmony reexport lexicographicSortSchema */
/* unused harmony reexport printSchema */
/* unused harmony reexport printIntrospectionSchema */
/* unused harmony reexport printType */
/* unused harmony reexport typeFromAST */
/* unused harmony reexport valueFromAST */
/* unused harmony reexport valueFromASTUntyped */
/* unused harmony reexport astFromValue */
/* unused harmony reexport TypeInfo */
/* unused harmony reexport coerceValue */
/* unused harmony reexport isValidJSValue */
/* unused harmony reexport isValidLiteralValue */
/* unused harmony reexport concatAST */
/* unused harmony reexport separateOperations */
/* unused harmony reexport isEqualType */
/* unused harmony reexport isTypeSubTypeOf */
/* unused harmony reexport doTypesOverlap */
/* unused harmony reexport assertValidName */
/* unused harmony reexport isValidNameError */
/* unused harmony reexport findBreakingChanges */
/* unused harmony reexport findDangerousChanges */
/* unused harmony reexport BreakingChangeType */
/* unused harmony reexport DangerousChangeType */
/* unused harmony reexport findDeprecatedUsages */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * GraphQL.js provides a reference implementation for the GraphQL specification
 * but is also a useful utility for operating on GraphQL files and building
 * sophisticated tools.
 *
 * This primary module exports a general purpose function for fulfilling all
 * steps of the GraphQL specification in a single operation, but also includes
 * utilities for every part of the GraphQL specification:
 *
 *   - Parsing the GraphQL language.
 *   - Building a GraphQL type schema.
 *   - Validating a GraphQL request against a type schema.
 *   - Executing a GraphQL request against a type schema.
 *
 * This also includes utility functions for operating on GraphQL types and
 * GraphQL documents to facilitate building tools.
 *
 * You may also import from each sub-directory directly. For example, the
 * following two import statements are equivalent:
 *
 *     import { parse } from 'graphql';
 *     import { parse } from 'graphql/language';
 */
// The primary entry point into fulfilling a GraphQL request.
 // Create and operate on GraphQL type definitions and schema.


// Parse and operate on GraphQL language source files.

// Execute GraphQL queries.

 // Validate GraphQL queries.

 // Create, format, and print GraphQL errors.


// Utilities for operating on GraphQL type schema and parsed sources.


/***/ }),
/* 2973 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Copyright (c) 2018-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/* eslint-disable no-redeclare */
// $FlowFixMe workaround for: https://github.com/facebook/flow/issues/4441
var isFinite = Number.isFinite || function (value) {
  return typeof value === 'number' && isFinite(value);
};

var _default = isFinite;
exports.default = _default;

/***/ }),
/* 2974 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Copyright (c) 2018-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/* eslint-disable no-redeclare */
// $FlowFixMe workaround for: https://github.com/facebook/flow/issues/4441
var isInteger = Number.isInteger || function (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};

var _default = isInteger;
exports.default = _default;

/***/ }),
/* 2975 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = memoize3;

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Memoizes the provided three-argument function.
 */
function memoize3(fn) {
  var cache0;

  function memoized(a1, a2, a3) {
    if (!cache0) {
      cache0 = new WeakMap();
    }

    var cache1 = cache0.get(a1);
    var cache2;

    if (cache1) {
      cache2 = cache1.get(a2);

      if (cache2) {
        var cachedValue = cache2.get(a3);

        if (cachedValue !== undefined) {
          return cachedValue;
        }
      }
    } else {
      cache1 = new WeakMap();
      cache0.set(a1, cache1);
    }

    if (!cache2) {
      cache2 = new WeakMap();
      cache1.set(a2, cache2);
    }

    var newValue = fn.apply(this, arguments);
    cache2.set(a3, newValue);
    return newValue;
  }

  return memoized;
}

/***/ }),
/* 2976 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = promiseForObject;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * This function transforms a JS object `ObjMap<Promise<T>>` into
 * a `Promise<ObjMap<T>>`
 *
 * This is akin to bluebird's `Promise.props`, but implemented only using
 * `Promise.all` so it will work with any implementation of ES6 promises.
 */
function promiseForObject(object) {
  var keys = Object.keys(object);
  var valuesAndPromises = keys.map(function (name) {
    return object[name];
  });
  return Promise.all(valuesAndPromises).then(function (values) {
    return values.reduce(function (resolvedObject, value, i) {
      resolvedObject[keys[i]] = value;
      return resolvedObject;
    }, Object.create(null));
  });
}

/***/ }),
/* 2977 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = promiseReduce;

var _isPromise = _interopRequireDefault(__webpack_require__(1206));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Similar to Array.prototype.reduce(), however the reducing callback may return
 * a Promise, in which case reduction will continue after each promise resolves.
 *
 * If the callback does not return a Promise, then this function will also not
 * return a Promise.
 */
function promiseReduce(values, callback, initialValue) {
  return values.reduce(function (previous, value) {
    return (0, _isPromise.default)(previous) ? previous.then(function (resolved) {
      return callback(resolved, value);
    }) : callback(previous, value);
  }, initialValue);
}

/***/ }),
/* 2978 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getLocation", {
  enumerable: true,
  get: function get() {
    return _location.getLocation;
  }
});
Object.defineProperty(exports, "Kind", {
  enumerable: true,
  get: function get() {
    return _kinds.Kind;
  }
});
Object.defineProperty(exports, "createLexer", {
  enumerable: true,
  get: function get() {
    return _lexer.createLexer;
  }
});
Object.defineProperty(exports, "TokenKind", {
  enumerable: true,
  get: function get() {
    return _lexer.TokenKind;
  }
});
Object.defineProperty(exports, "parse", {
  enumerable: true,
  get: function get() {
    return _parser.parse;
  }
});
Object.defineProperty(exports, "parseValue", {
  enumerable: true,
  get: function get() {
    return _parser.parseValue;
  }
});
Object.defineProperty(exports, "parseType", {
  enumerable: true,
  get: function get() {
    return _parser.parseType;
  }
});
Object.defineProperty(exports, "print", {
  enumerable: true,
  get: function get() {
    return _printer.print;
  }
});
Object.defineProperty(exports, "Source", {
  enumerable: true,
  get: function get() {
    return _source.Source;
  }
});
Object.defineProperty(exports, "visit", {
  enumerable: true,
  get: function get() {
    return _visitor.visit;
  }
});
Object.defineProperty(exports, "visitInParallel", {
  enumerable: true,
  get: function get() {
    return _visitor.visitInParallel;
  }
});
Object.defineProperty(exports, "visitWithTypeInfo", {
  enumerable: true,
  get: function get() {
    return _visitor.visitWithTypeInfo;
  }
});
Object.defineProperty(exports, "getVisitFn", {
  enumerable: true,
  get: function get() {
    return _visitor.getVisitFn;
  }
});
Object.defineProperty(exports, "BREAK", {
  enumerable: true,
  get: function get() {
    return _visitor.BREAK;
  }
});
Object.defineProperty(exports, "isDefinitionNode", {
  enumerable: true,
  get: function get() {
    return _predicates.isDefinitionNode;
  }
});
Object.defineProperty(exports, "isExecutableDefinitionNode", {
  enumerable: true,
  get: function get() {
    return _predicates.isExecutableDefinitionNode;
  }
});
Object.defineProperty(exports, "isSelectionNode", {
  enumerable: true,
  get: function get() {
    return _predicates.isSelectionNode;
  }
});
Object.defineProperty(exports, "isValueNode", {
  enumerable: true,
  get: function get() {
    return _predicates.isValueNode;
  }
});
Object.defineProperty(exports, "isTypeNode", {
  enumerable: true,
  get: function get() {
    return _predicates.isTypeNode;
  }
});
Object.defineProperty(exports, "isTypeSystemDefinitionNode", {
  enumerable: true,
  get: function get() {
    return _predicates.isTypeSystemDefinitionNode;
  }
});
Object.defineProperty(exports, "isTypeDefinitionNode", {
  enumerable: true,
  get: function get() {
    return _predicates.isTypeDefinitionNode;
  }
});
Object.defineProperty(exports, "isTypeSystemExtensionNode", {
  enumerable: true,
  get: function get() {
    return _predicates.isTypeSystemExtensionNode;
  }
});
Object.defineProperty(exports, "isTypeExtensionNode", {
  enumerable: true,
  get: function get() {
    return _predicates.isTypeExtensionNode;
  }
});
Object.defineProperty(exports, "DirectiveLocation", {
  enumerable: true,
  get: function get() {
    return _directiveLocation.DirectiveLocation;
  }
});

var _location = __webpack_require__(664);

var _kinds = __webpack_require__(68);

var _lexer = __webpack_require__(663);

var _parser = __webpack_require__(283);

var _printer = __webpack_require__(165);

var _source = __webpack_require__(1208);

var _visitor = __webpack_require__(245);

var _predicates = __webpack_require__(439);

var _directiveLocation = __webpack_require__(345);

/***/ }),
/* 2979 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "subscribe", {
  enumerable: true,
  get: function get() {
    return _subscribe.subscribe;
  }
});
Object.defineProperty(exports, "createSourceEventStream", {
  enumerable: true,
  get: function get() {
    return _subscribe.createSourceEventStream;
  }
});

var _subscribe = __webpack_require__(2981);

/***/ }),
/* 2980 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = mapAsyncIterator;

var _iterall = __webpack_require__(348);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Given an AsyncIterable and a callback function, return an AsyncIterator
 * which produces values mapped via calling the callback function.
 */
function mapAsyncIterator(iterable, callback, rejectCallback) {
  var iterator = (0, _iterall.getAsyncIterator)(iterable);
  var $return;
  var abruptClose; // $FlowFixMe(>=0.68.0)

  if (typeof iterator.return === 'function') {
    $return = iterator.return;

    abruptClose = function abruptClose(error) {
      var rethrow = function rethrow() {
        return Promise.reject(error);
      };

      return $return.call(iterator).then(rethrow, rethrow);
    };
  }

  function mapResult(result) {
    return result.done ? result : asyncMapValue(result.value, callback).then(iteratorResult, abruptClose);
  }

  var mapReject;

  if (rejectCallback) {
    // Capture rejectCallback to ensure it cannot be null.
    var reject = rejectCallback;

    mapReject = function mapReject(error) {
      return asyncMapValue(error, reject).then(iteratorResult, abruptClose);
    };
  }
  /* TODO: Flow doesn't support symbols as keys:
     https://github.com/facebook/flow/issues/3258 */


  return _defineProperty({
    next: function next() {
      return iterator.next().then(mapResult, mapReject);
    },
    return: function _return() {
      return $return ? $return.call(iterator).then(mapResult, mapReject) : Promise.resolve({
        value: undefined,
        done: true
      });
    },
    throw: function _throw(error) {
      // $FlowFixMe(>=0.68.0)
      if (typeof iterator.throw === 'function') {
        return iterator.throw(error).then(mapResult, mapReject);
      }

      return Promise.reject(error).catch(abruptClose);
    }
  }, _iterall.$$asyncIterator, function () {
    return this;
  });
}

function asyncMapValue(value, callback) {
  return new Promise(function (resolve) {
    return resolve(callback(value));
  });
}

function iteratorResult(value) {
  return {
    value: value,
    done: false
  };
}

/***/ }),
/* 2981 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.subscribe = subscribe;
exports.createSourceEventStream = createSourceEventStream;

var _iterall = __webpack_require__(348);

var _inspect = _interopRequireDefault(__webpack_require__(93));

var _GraphQLError = __webpack_require__(37);

var _locatedError = __webpack_require__(657);

var _execute = __webpack_require__(437);

var _mapAsyncIterator = _interopRequireDefault(__webpack_require__(2980));

var _getOperationRootType = __webpack_require__(667);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2017-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function subscribe(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver) {
  /* eslint-enable no-redeclare */
  // Extract arguments from object args if provided.
  return arguments.length === 1 ? subscribeImpl(argsOrSchema.schema, argsOrSchema.document, argsOrSchema.rootValue, argsOrSchema.contextValue, argsOrSchema.variableValues, argsOrSchema.operationName, argsOrSchema.fieldResolver, argsOrSchema.subscribeFieldResolver) : subscribeImpl(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver);
}
/**
 * This function checks if the error is a GraphQLError. If it is, report it as
 * an ExecutionResult, containing only errors and no data. Otherwise treat the
 * error as a system-class error and re-throw it.
 */


function reportGraphQLError(error) {
  if (error instanceof _GraphQLError.GraphQLError) {
    return {
      errors: [error]
    };
  }

  throw error;
}

function subscribeImpl(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver) {
  var sourcePromise = createSourceEventStream(schema, document, rootValue, contextValue, variableValues, operationName, subscribeFieldResolver); // For each payload yielded from a subscription, map it over the normal
  // GraphQL `execute` function, with `payload` as the rootValue.
  // This implements the "MapSourceToResponseEvent" algorithm described in
  // the GraphQL specification. The `execute` function provides the
  // "ExecuteSubscriptionEvent" algorithm, as it is nearly identical to the
  // "ExecuteQuery" algorithm, for which `execute` is also used.

  var mapSourceToResponse = function mapSourceToResponse(payload) {
    return (0, _execute.execute)(schema, document, payload, contextValue, variableValues, operationName, fieldResolver);
  }; // Resolve the Source Stream, then map every source value to a
  // ExecutionResult value as described above.


  return sourcePromise.then(function (resultOrStream) {
    return (// Note: Flow can't refine isAsyncIterable, so explicit casts are used.
      (0, _iterall.isAsyncIterable)(resultOrStream) ? (0, _mapAsyncIterator.default)(resultOrStream, mapSourceToResponse, reportGraphQLError) : resultOrStream
    );
  }, reportGraphQLError);
}
/**
 * Implements the "CreateSourceEventStream" algorithm described in the
 * GraphQL specification, resolving the subscription source event stream.
 *
 * Returns a Promise<AsyncIterable>.
 *
 * If the client-provided invalid arguments, the source stream could not be
 * created, or the resolver did not return an AsyncIterable, this function will
 * will throw an error, which should be caught and handled by the caller.
 *
 * A Source Event Stream represents a sequence of events, each of which triggers
 * a GraphQL execution for that event.
 *
 * This may be useful when hosting the stateful subscription service in a
 * different process or machine than the stateless GraphQL execution engine,
 * or otherwise separating these two steps. For more on this, see the
 * "Supporting Subscriptions at Scale" information in the GraphQL specification.
 */


function createSourceEventStream(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
  // If arguments are missing or incorrectly typed, this is an internal
  // developer mistake which should throw an early error.
  (0, _execute.assertValidExecutionArguments)(schema, document, variableValues);

  try {
    // If a valid context cannot be created due to incorrect arguments,
    // this will throw an error.
    var exeContext = (0, _execute.buildExecutionContext)(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver); // Return early errors if execution context failed.

    if (Array.isArray(exeContext)) {
      return Promise.resolve({
        errors: exeContext
      });
    }

    var type = (0, _getOperationRootType.getOperationRootType)(schema, exeContext.operation);
    var fields = (0, _execute.collectFields)(exeContext, type, exeContext.operation.selectionSet, Object.create(null), Object.create(null));
    var responseNames = Object.keys(fields);
    var responseName = responseNames[0];
    var fieldNodes = fields[responseName];
    var fieldNode = fieldNodes[0];
    var fieldName = fieldNode.name.value;
    var fieldDef = (0, _execute.getFieldDef)(schema, type, fieldName);

    if (!fieldDef) {
      throw new _GraphQLError.GraphQLError("The subscription field \"".concat(fieldName, "\" is not defined."), fieldNodes);
    } // Call the `subscribe()` resolver or the default resolver to produce an
    // AsyncIterable yielding raw payloads.


    var resolveFn = fieldDef.subscribe || exeContext.fieldResolver;
    var path = (0, _execute.addPath)(undefined, responseName);
    var info = (0, _execute.buildResolveInfo)(exeContext, fieldDef, fieldNodes, type, path); // resolveFieldValueOrError implements the "ResolveFieldEventStream"
    // algorithm from GraphQL specification. It differs from
    // "ResolveFieldValue" due to providing a different `resolveFn`.

    var result = (0, _execute.resolveFieldValueOrError)(exeContext, fieldDef, fieldNodes, resolveFn, rootValue, info); // Coerce to Promise for easier error handling and consistent return type.

    return Promise.resolve(result).then(function (eventStream) {
      // If eventStream is an Error, rethrow a located error.
      if (eventStream instanceof Error) {
        throw (0, _locatedError.locatedError)(eventStream, fieldNodes, (0, _execute.responsePathAsArray)(path));
      } // Assert field returned an event stream, otherwise yield an error.


      if ((0, _iterall.isAsyncIterable)(eventStream)) {
        // Note: isAsyncIterable above ensures this will be correct.
        return eventStream;
      }

      throw new Error('Subscription field must return Async Iterable. Received: ' + (0, _inspect.default)(eventStream));
    });
  } catch (error) {
    return Promise.reject(error);
  }
}

/***/ }),
/* 2982 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "isSchema", {
  enumerable: true,
  get: function get() {
    return _schema.isSchema;
  }
});
Object.defineProperty(exports, "GraphQLSchema", {
  enumerable: true,
  get: function get() {
    return _schema.GraphQLSchema;
  }
});
Object.defineProperty(exports, "isType", {
  enumerable: true,
  get: function get() {
    return _definition.isType;
  }
});
Object.defineProperty(exports, "isScalarType", {
  enumerable: true,
  get: function get() {
    return _definition.isScalarType;
  }
});
Object.defineProperty(exports, "isObjectType", {
  enumerable: true,
  get: function get() {
    return _definition.isObjectType;
  }
});
Object.defineProperty(exports, "isInterfaceType", {
  enumerable: true,
  get: function get() {
    return _definition.isInterfaceType;
  }
});
Object.defineProperty(exports, "isUnionType", {
  enumerable: true,
  get: function get() {
    return _definition.isUnionType;
  }
});
Object.defineProperty(exports, "isEnumType", {
  enumerable: true,
  get: function get() {
    return _definition.isEnumType;
  }
});
Object.defineProperty(exports, "isInputObjectType", {
  enumerable: true,
  get: function get() {
    return _definition.isInputObjectType;
  }
});
Object.defineProperty(exports, "isListType", {
  enumerable: true,
  get: function get() {
    return _definition.isListType;
  }
});
Object.defineProperty(exports, "isNonNullType", {
  enumerable: true,
  get: function get() {
    return _definition.isNonNullType;
  }
});
Object.defineProperty(exports, "isInputType", {
  enumerable: true,
  get: function get() {
    return _definition.isInputType;
  }
});
Object.defineProperty(exports, "isOutputType", {
  enumerable: true,
  get: function get() {
    return _definition.isOutputType;
  }
});
Object.defineProperty(exports, "isLeafType", {
  enumerable: true,
  get: function get() {
    return _definition.isLeafType;
  }
});
Object.defineProperty(exports, "isCompositeType", {
  enumerable: true,
  get: function get() {
    return _definition.isCompositeType;
  }
});
Object.defineProperty(exports, "isAbstractType", {
  enumerable: true,
  get: function get() {
    return _definition.isAbstractType;
  }
});
Object.defineProperty(exports, "isWrappingType", {
  enumerable: true,
  get: function get() {
    return _definition.isWrappingType;
  }
});
Object.defineProperty(exports, "isNullableType", {
  enumerable: true,
  get: function get() {
    return _definition.isNullableType;
  }
});
Object.defineProperty(exports, "isNamedType", {
  enumerable: true,
  get: function get() {
    return _definition.isNamedType;
  }
});
Object.defineProperty(exports, "isRequiredArgument", {
  enumerable: true,
  get: function get() {
    return _definition.isRequiredArgument;
  }
});
Object.defineProperty(exports, "isRequiredInputField", {
  enumerable: true,
  get: function get() {
    return _definition.isRequiredInputField;
  }
});
Object.defineProperty(exports, "assertType", {
  enumerable: true,
  get: function get() {
    return _definition.assertType;
  }
});
Object.defineProperty(exports, "assertScalarType", {
  enumerable: true,
  get: function get() {
    return _definition.assertScalarType;
  }
});
Object.defineProperty(exports, "assertObjectType", {
  enumerable: true,
  get: function get() {
    return _definition.assertObjectType;
  }
});
Object.defineProperty(exports, "assertInterfaceType", {
  enumerable: true,
  get: function get() {
    return _definition.assertInterfaceType;
  }
});
Object.defineProperty(exports, "assertUnionType", {
  enumerable: true,
  get: function get() {
    return _definition.assertUnionType;
  }
});
Object.defineProperty(exports, "assertEnumType", {
  enumerable: true,
  get: function get() {
    return _definition.assertEnumType;
  }
});
Object.defineProperty(exports, "assertInputObjectType", {
  enumerable: true,
  get: function get() {
    return _definition.assertInputObjectType;
  }
});
Object.defineProperty(exports, "assertListType", {
  enumerable: true,
  get: function get() {
    return _definition.assertListType;
  }
});
Object.defineProperty(exports, "assertNonNullType", {
  enumerable: true,
  get: function get() {
    return _definition.assertNonNullType;
  }
});
Object.defineProperty(exports, "assertInputType", {
  enumerable: true,
  get: function get() {
    return _definition.assertInputType;
  }
});
Object.defineProperty(exports, "assertOutputType", {
  enumerable: true,
  get: function get() {
    return _definition.assertOutputType;
  }
});
Object.defineProperty(exports, "assertLeafType", {
  enumerable: true,
  get: function get() {
    return _definition.assertLeafType;
  }
});
Object.defineProperty(exports, "assertCompositeType", {
  enumerable: true,
  get: function get() {
    return _definition.assertCompositeType;
  }
});
Object.defineProperty(exports, "assertAbstractType", {
  enumerable: true,
  get: function get() {
    return _definition.assertAbstractType;
  }
});
Object.defineProperty(exports, "assertWrappingType", {
  enumerable: true,
  get: function get() {
    return _definition.assertWrappingType;
  }
});
Object.defineProperty(exports, "assertNullableType", {
  enumerable: true,
  get: function get() {
    return _definition.assertNullableType;
  }
});
Object.defineProperty(exports, "assertNamedType", {
  enumerable: true,
  get: function get() {
    return _definition.assertNamedType;
  }
});
Object.defineProperty(exports, "getNullableType", {
  enumerable: true,
  get: function get() {
    return _definition.getNullableType;
  }
});
Object.defineProperty(exports, "getNamedType", {
  enumerable: true,
  get: function get() {
    return _definition.getNamedType;
  }
});
Object.defineProperty(exports, "GraphQLScalarType", {
  enumerable: true,
  get: function get() {
    return _definition.GraphQLScalarType;
  }
});
Object.defineProperty(exports, "GraphQLObjectType", {
  enumerable: true,
  get: function get() {
    return _definition.GraphQLObjectType;
  }
});
Object.defineProperty(exports, "GraphQLInterfaceType", {
  enumerable: true,
  get: function get() {
    return _definition.GraphQLInterfaceType;
  }
});
Object.defineProperty(exports, "GraphQLUnionType", {
  enumerable: true,
  get: function get() {
    return _definition.GraphQLUnionType;
  }
});
Object.defineProperty(exports, "GraphQLEnumType", {
  enumerable: true,
  get: function get() {
    return _definition.GraphQLEnumType;
  }
});
Object.defineProperty(exports, "GraphQLInputObjectType", {
  enumerable: true,
  get: function get() {
    return _definition.GraphQLInputObjectType;
  }
});
Object.defineProperty(exports, "GraphQLList", {
  enumerable: true,
  get: function get() {
    return _definition.GraphQLList;
  }
});
Object.defineProperty(exports, "GraphQLNonNull", {
  enumerable: true,
  get: function get() {
    return _definition.GraphQLNonNull;
  }
});
Object.defineProperty(exports, "isDirective", {
  enumerable: true,
  get: function get() {
    return _directives.isDirective;
  }
});
Object.defineProperty(exports, "GraphQLDirective", {
  enumerable: true,
  get: function get() {
    return _directives.GraphQLDirective;
  }
});
Object.defineProperty(exports, "isSpecifiedDirective", {
  enumerable: true,
  get: function get() {
    return _directives.isSpecifiedDirective;
  }
});
Object.defineProperty(exports, "specifiedDirectives", {
  enumerable: true,
  get: function get() {
    return _directives.specifiedDirectives;
  }
});
Object.defineProperty(exports, "GraphQLIncludeDirective", {
  enumerable: true,
  get: function get() {
    return _directives.GraphQLIncludeDirective;
  }
});
Object.defineProperty(exports, "GraphQLSkipDirective", {
  enumerable: true,
  get: function get() {
    return _directives.GraphQLSkipDirective;
  }
});
Object.defineProperty(exports, "GraphQLDeprecatedDirective", {
  enumerable: true,
  get: function get() {
    return _directives.GraphQLDeprecatedDirective;
  }
});
Object.defineProperty(exports, "DEFAULT_DEPRECATION_REASON", {
  enumerable: true,
  get: function get() {
    return _directives.DEFAULT_DEPRECATION_REASON;
  }
});
Object.defineProperty(exports, "isSpecifiedScalarType", {
  enumerable: true,
  get: function get() {
    return _scalars.isSpecifiedScalarType;
  }
});
Object.defineProperty(exports, "specifiedScalarTypes", {
  enumerable: true,
  get: function get() {
    return _scalars.specifiedScalarTypes;
  }
});
Object.defineProperty(exports, "GraphQLInt", {
  enumerable: true,
  get: function get() {
    return _scalars.GraphQLInt;
  }
});
Object.defineProperty(exports, "GraphQLFloat", {
  enumerable: true,
  get: function get() {
    return _scalars.GraphQLFloat;
  }
});
Object.defineProperty(exports, "GraphQLString", {
  enumerable: true,
  get: function get() {
    return _scalars.GraphQLString;
  }
});
Object.defineProperty(exports, "GraphQLBoolean", {
  enumerable: true,
  get: function get() {
    return _scalars.GraphQLBoolean;
  }
});
Object.defineProperty(exports, "GraphQLID", {
  enumerable: true,
  get: function get() {
    return _scalars.GraphQLID;
  }
});
Object.defineProperty(exports, "TypeKind", {
  enumerable: true,
  get: function get() {
    return _introspection.TypeKind;
  }
});
Object.defineProperty(exports, "isIntrospectionType", {
  enumerable: true,
  get: function get() {
    return _introspection.isIntrospectionType;
  }
});
Object.defineProperty(exports, "introspectionTypes", {
  enumerable: true,
  get: function get() {
    return _introspection.introspectionTypes;
  }
});
Object.defineProperty(exports, "__Schema", {
  enumerable: true,
  get: function get() {
    return _introspection.__Schema;
  }
});
Object.defineProperty(exports, "__Directive", {
  enumerable: true,
  get: function get() {
    return _introspection.__Directive;
  }
});
Object.defineProperty(exports, "__DirectiveLocation", {
  enumerable: true,
  get: function get() {
    return _introspection.__DirectiveLocation;
  }
});
Object.defineProperty(exports, "__Type", {
  enumerable: true,
  get: function get() {
    return _introspection.__Type;
  }
});
Object.defineProperty(exports, "__Field", {
  enumerable: true,
  get: function get() {
    return _introspection.__Field;
  }
});
Object.defineProperty(exports, "__InputValue", {
  enumerable: true,
  get: function get() {
    return _introspection.__InputValue;
  }
});
Object.defineProperty(exports, "__EnumValue", {
  enumerable: true,
  get: function get() {
    return _introspection.__EnumValue;
  }
});
Object.defineProperty(exports, "__TypeKind", {
  enumerable: true,
  get: function get() {
    return _introspection.__TypeKind;
  }
});
Object.defineProperty(exports, "SchemaMetaFieldDef", {
  enumerable: true,
  get: function get() {
    return _introspection.SchemaMetaFieldDef;
  }
});
Object.defineProperty(exports, "TypeMetaFieldDef", {
  enumerable: true,
  get: function get() {
    return _introspection.TypeMetaFieldDef;
  }
});
Object.defineProperty(exports, "TypeNameMetaFieldDef", {
  enumerable: true,
  get: function get() {
    return _introspection.TypeNameMetaFieldDef;
  }
});
Object.defineProperty(exports, "validateSchema", {
  enumerable: true,
  get: function get() {
    return _validate.validateSchema;
  }
});
Object.defineProperty(exports, "assertValidSchema", {
  enumerable: true,
  get: function get() {
    return _validate.assertValidSchema;
  }
});

var _schema = __webpack_require__(246);

var _definition = __webpack_require__(54);

var _directives = __webpack_require__(136);

var _scalars = __webpack_require__(184);

var _introspection = __webpack_require__(166);

var _validate = __webpack_require__(440);

/***/ }),
/* 2983 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildClientSchema = buildClientSchema;

var _invariant = _interopRequireDefault(__webpack_require__(108));

var _keyMap = _interopRequireDefault(__webpack_require__(183));

var _keyValMap = _interopRequireDefault(__webpack_require__(343));

var _valueFromAST = __webpack_require__(442);

var _parser = __webpack_require__(283);

var _schema = __webpack_require__(246);

var _definition = __webpack_require__(54);

var _directives = __webpack_require__(136);

var _introspection = __webpack_require__(166);

var _scalars = __webpack_require__(184);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Build a GraphQLSchema for use by client tools.
 *
 * Given the result of a client running the introspection query, creates and
 * returns a GraphQLSchema instance which can be then used with all graphql-js
 * tools, but cannot be used to execute a query, as introspection does not
 * represent the "resolver", "parse" or "serialize" functions or any other
 * server-internal mechanisms.
 *
 * This function expects a complete introspection result. Don't forget to check
 * the "errors" field of a server response before calling this function.
 */
function buildClientSchema(introspection, options) {
  // Get the schema from the introspection result.
  var schemaIntrospection = introspection.__schema; // Converts the list of types into a keyMap based on the type names.

  var typeIntrospectionMap = (0, _keyMap.default)(schemaIntrospection.types, function (type) {
    return type.name;
  }); // A cache to use to store the actual GraphQLType definition objects by name.
  // Initialize to the GraphQL built in scalars. All functions below are inline
  // so that this type def cache is within the scope of the closure.

  var typeDefCache = (0, _keyMap.default)(_scalars.specifiedScalarTypes.concat(_introspection.introspectionTypes), function (type) {
    return type.name;
  }); // Given a type reference in introspection, return the GraphQLType instance.
  // preferring cached instances before building new instances.

  function getType(typeRef) {
    if (typeRef.kind === _introspection.TypeKind.LIST) {
      var itemRef = typeRef.ofType;

      if (!itemRef) {
        throw new Error('Decorated type deeper than introspection query.');
      }

      return (0, _definition.GraphQLList)(getType(itemRef));
    }

    if (typeRef.kind === _introspection.TypeKind.NON_NULL) {
      var nullableRef = typeRef.ofType;

      if (!nullableRef) {
        throw new Error('Decorated type deeper than introspection query.');
      }

      var nullableType = getType(nullableRef);
      return (0, _definition.GraphQLNonNull)((0, _definition.assertNullableType)(nullableType));
    }

    if (!typeRef.name) {
      throw new Error('Unknown type reference: ' + JSON.stringify(typeRef));
    }

    return getNamedType(typeRef.name);
  }

  function getNamedType(typeName) {
    if (typeDefCache[typeName]) {
      return typeDefCache[typeName];
    }

    var typeIntrospection = typeIntrospectionMap[typeName];

    if (!typeIntrospection) {
      throw new Error("Invalid or incomplete schema, unknown type: ".concat(typeName, ". Ensure ") + 'that a full introspection query is used in order to build a ' + 'client schema.');
    }

    var typeDef = buildType(typeIntrospection);
    typeDefCache[typeName] = typeDef;
    return typeDef;
  }

  function getInputType(typeRef) {
    var type = getType(typeRef);
    !(0, _definition.isInputType)(type) ? (0, _invariant.default)(0, 'Introspection must provide input type for arguments.') : void 0;
    return type;
  }

  function getOutputType(typeRef) {
    var type = getType(typeRef);
    !(0, _definition.isOutputType)(type) ? (0, _invariant.default)(0, 'Introspection must provide output type for fields.') : void 0;
    return type;
  }

  function getObjectType(typeRef) {
    var type = getType(typeRef);
    return (0, _definition.assertObjectType)(type);
  }

  function getInterfaceType(typeRef) {
    var type = getType(typeRef);
    return (0, _definition.assertInterfaceType)(type);
  } // Given a type's introspection result, construct the correct
  // GraphQLType instance.


  function buildType(type) {
    if (type && type.name && type.kind) {
      switch (type.kind) {
        case _introspection.TypeKind.SCALAR:
          return buildScalarDef(type);

        case _introspection.TypeKind.OBJECT:
          return buildObjectDef(type);

        case _introspection.TypeKind.INTERFACE:
          return buildInterfaceDef(type);

        case _introspection.TypeKind.UNION:
          return buildUnionDef(type);

        case _introspection.TypeKind.ENUM:
          return buildEnumDef(type);

        case _introspection.TypeKind.INPUT_OBJECT:
          return buildInputObjectDef(type);
      }
    }

    throw new Error('Invalid or incomplete introspection result. Ensure that a full ' + 'introspection query is used in order to build a client schema:' + JSON.stringify(type));
  }

  function buildScalarDef(scalarIntrospection) {
    return new _definition.GraphQLScalarType({
      name: scalarIntrospection.name,
      description: scalarIntrospection.description,
      serialize: function serialize(value) {
        return value;
      }
    });
  }

  function buildObjectDef(objectIntrospection) {
    if (!objectIntrospection.interfaces) {
      throw new Error('Introspection result missing interfaces: ' + JSON.stringify(objectIntrospection));
    }

    return new _definition.GraphQLObjectType({
      name: objectIntrospection.name,
      description: objectIntrospection.description,
      interfaces: objectIntrospection.interfaces.map(getInterfaceType),
      fields: function fields() {
        return buildFieldDefMap(objectIntrospection);
      }
    });
  }

  function buildInterfaceDef(interfaceIntrospection) {
    return new _definition.GraphQLInterfaceType({
      name: interfaceIntrospection.name,
      description: interfaceIntrospection.description,
      fields: function fields() {
        return buildFieldDefMap(interfaceIntrospection);
      }
    });
  }

  function buildUnionDef(unionIntrospection) {
    if (!unionIntrospection.possibleTypes) {
      throw new Error('Introspection result missing possibleTypes: ' + JSON.stringify(unionIntrospection));
    }

    return new _definition.GraphQLUnionType({
      name: unionIntrospection.name,
      description: unionIntrospection.description,
      types: unionIntrospection.possibleTypes.map(getObjectType)
    });
  }

  function buildEnumDef(enumIntrospection) {
    if (!enumIntrospection.enumValues) {
      throw new Error('Introspection result missing enumValues: ' + JSON.stringify(enumIntrospection));
    }

    return new _definition.GraphQLEnumType({
      name: enumIntrospection.name,
      description: enumIntrospection.description,
      values: (0, _keyValMap.default)(enumIntrospection.enumValues, function (valueIntrospection) {
        return valueIntrospection.name;
      }, function (valueIntrospection) {
        return {
          description: valueIntrospection.description,
          deprecationReason: valueIntrospection.deprecationReason
        };
      })
    });
  }

  function buildInputObjectDef(inputObjectIntrospection) {
    if (!inputObjectIntrospection.inputFields) {
      throw new Error('Introspection result missing inputFields: ' + JSON.stringify(inputObjectIntrospection));
    }

    return new _definition.GraphQLInputObjectType({
      name: inputObjectIntrospection.name,
      description: inputObjectIntrospection.description,
      fields: function fields() {
        return buildInputValueDefMap(inputObjectIntrospection.inputFields);
      }
    });
  }

  function buildFieldDefMap(typeIntrospection) {
    if (!typeIntrospection.fields) {
      throw new Error('Introspection result missing fields: ' + JSON.stringify(typeIntrospection));
    }

    return (0, _keyValMap.default)(typeIntrospection.fields, function (fieldIntrospection) {
      return fieldIntrospection.name;
    }, function (fieldIntrospection) {
      if (!fieldIntrospection.args) {
        throw new Error('Introspection result missing field args: ' + JSON.stringify(fieldIntrospection));
      }

      return {
        description: fieldIntrospection.description,
        deprecationReason: fieldIntrospection.deprecationReason,
        type: getOutputType(fieldIntrospection.type),
        args: buildInputValueDefMap(fieldIntrospection.args)
      };
    });
  }

  function buildInputValueDefMap(inputValueIntrospections) {
    return (0, _keyValMap.default)(inputValueIntrospections, function (inputValue) {
      return inputValue.name;
    }, buildInputValue);
  }

  function buildInputValue(inputValueIntrospection) {
    var type = getInputType(inputValueIntrospection.type);
    var defaultValue = inputValueIntrospection.defaultValue ? (0, _valueFromAST.valueFromAST)((0, _parser.parseValue)(inputValueIntrospection.defaultValue), type) : undefined;
    return {
      description: inputValueIntrospection.description,
      type: type,
      defaultValue: defaultValue
    };
  }

  function buildDirective(directiveIntrospection) {
    if (!directiveIntrospection.args) {
      throw new Error('Introspection result missing directive args: ' + JSON.stringify(directiveIntrospection));
    }

    return new _directives.GraphQLDirective({
      name: directiveIntrospection.name,
      description: directiveIntrospection.description,
      locations: directiveIntrospection.locations.slice(),
      args: buildInputValueDefMap(directiveIntrospection.args)
    });
  } // Iterate through all types, getting the type definition for each, ensuring
  // that any type not directly referenced by a field will get created.


  var types = schemaIntrospection.types.map(function (typeIntrospection) {
    return getNamedType(typeIntrospection.name);
  }); // Get the root Query, Mutation, and Subscription types.

  var queryType = schemaIntrospection.queryType ? getObjectType(schemaIntrospection.queryType) : null;
  var mutationType = schemaIntrospection.mutationType ? getObjectType(schemaIntrospection.mutationType) : null;
  var subscriptionType = schemaIntrospection.subscriptionType ? getObjectType(schemaIntrospection.subscriptionType) : null; // Get the directives supported by Introspection, assuming empty-set if
  // directives were not queried for.

  var directives = schemaIntrospection.directives ? schemaIntrospection.directives.map(buildDirective) : []; // Then produce and return a Schema with these types.

  return new _schema.GraphQLSchema({
    query: queryType,
    mutation: mutationType,
    subscription: subscriptionType,
    types: types,
    directives: directives,
    assumeValid: options && options.assumeValid,
    allowedLegacyNames: options && options.allowedLegacyNames
  });
}

/***/ }),
/* 2984 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.concatAST = concatAST;

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Provided a collection of ASTs, presumably each from different files,
 * concatenate the ASTs together into batched AST, useful for validating many
 * GraphQL source files which together represent one conceptual application.
 */
function concatAST(asts) {
  var batchDefinitions = [];

  for (var i = 0; i < asts.length; i++) {
    var definitions = asts[i].definitions;

    for (var j = 0; j < definitions.length; j++) {
      batchDefinitions.push(definitions[j]);
    }
  }

  return {
    kind: 'Document',
    definitions: batchDefinitions
  };
}

/***/ }),
/* 2985 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.extendSchema = extendSchema;

var _invariant = _interopRequireDefault(__webpack_require__(108));

var _keyMap = _interopRequireDefault(__webpack_require__(183));

var _keyValMap = _interopRequireDefault(__webpack_require__(343));

var _objectValues = _interopRequireDefault(__webpack_require__(205));

var _buildASTSchema = __webpack_require__(1210);

var _validate = __webpack_require__(443);

var _GraphQLError = __webpack_require__(37);

var _schema = __webpack_require__(246);

var _introspection = __webpack_require__(166);

var _scalars = __webpack_require__(184);

var _definition = __webpack_require__(54);

var _directives = __webpack_require__(136);

var _kinds = __webpack_require__(68);

var _predicates = __webpack_require__(439);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Produces a new schema given an existing schema and a document which may
 * contain GraphQL type extensions and definitions. The original schema will
 * remain unaltered.
 *
 * Because a schema represents a graph of references, a schema cannot be
 * extended without effectively making an entire copy. We do not know until it's
 * too late if subgraphs remain unchanged.
 *
 * This algorithm copies the provided schema, applying extensions while
 * producing the copy. The original schema remains unaltered.
 *
 * Accepts options as a third argument:
 *
 *    - commentDescriptions:
 *        Provide true to use preceding comments as the description.
 *
 */
function extendSchema(schema, documentAST, options) {
  !(0, _schema.isSchema)(schema) ? (0, _invariant.default)(0, 'Must provide valid GraphQLSchema') : void 0;
  !(documentAST && documentAST.kind === _kinds.Kind.DOCUMENT) ? (0, _invariant.default)(0, 'Must provide valid Document AST') : void 0;

  if (!options || !(options.assumeValid || options.assumeValidSDL)) {
    (0, _validate.assertValidSDLExtension)(documentAST, schema);
  } // Collect the type definitions and extensions found in the document.


  var typeDefinitionMap = Object.create(null);
  var typeExtensionsMap = Object.create(null); // New directives and types are separate because a directives and types can
  // have the same name. For example, a type named "skip".

  var directiveDefinitions = [];
  var schemaDef; // Schema extensions are collected which may add additional operation types.

  var schemaExtensions = [];

  for (var i = 0; i < documentAST.definitions.length; i++) {
    var def = documentAST.definitions[i];

    if (def.kind === _kinds.Kind.SCHEMA_DEFINITION) {
      schemaDef = def;
    } else if (def.kind === _kinds.Kind.SCHEMA_EXTENSION) {
      schemaExtensions.push(def);
    } else if ((0, _predicates.isTypeDefinitionNode)(def)) {
      // Sanity check that none of the defined types conflict with the
      // schema's existing types.
      var typeName = def.name.value;

      if (schema.getType(typeName)) {
        throw new _GraphQLError.GraphQLError("Type \"".concat(typeName, "\" already exists in the schema. It cannot also ") + 'be defined in this type definition.', [def]);
      }

      typeDefinitionMap[typeName] = def;
    } else if ((0, _predicates.isTypeExtensionNode)(def)) {
      // Sanity check that this type extension exists within the
      // schema's existing types.
      var extendedTypeName = def.name.value;
      var existingType = schema.getType(extendedTypeName);

      if (!existingType) {
        throw new _GraphQLError.GraphQLError("Cannot extend type \"".concat(extendedTypeName, "\" because it does not ") + 'exist in the existing schema.', [def]);
      }

      checkExtensionNode(existingType, def);
      var existingTypeExtensions = typeExtensionsMap[extendedTypeName];
      typeExtensionsMap[extendedTypeName] = existingTypeExtensions ? existingTypeExtensions.concat([def]) : [def];
    } else if (def.kind === _kinds.Kind.DIRECTIVE_DEFINITION) {
      var directiveName = def.name.value;
      var existingDirective = schema.getDirective(directiveName);

      if (existingDirective) {
        throw new _GraphQLError.GraphQLError("Directive \"".concat(directiveName, "\" already exists in the schema. It ") + 'cannot be redefined.', [def]);
      }

      directiveDefinitions.push(def);
    }
  } // If this document contains no new types, extensions, or directives then
  // return the same unmodified GraphQLSchema instance.


  if (Object.keys(typeExtensionsMap).length === 0 && Object.keys(typeDefinitionMap).length === 0 && directiveDefinitions.length === 0 && schemaExtensions.length === 0 && !schemaDef) {
    return schema;
  }

  var astBuilder = new _buildASTSchema.ASTDefinitionBuilder(typeDefinitionMap, options, function (typeRef) {
    var typeName = typeRef.name.value;
    var existingType = schema.getType(typeName);

    if (existingType) {
      return extendNamedType(existingType);
    }

    throw new _GraphQLError.GraphQLError("Unknown type: \"".concat(typeName, "\". Ensure that this type exists ") + 'either in the original schema, or is added in a type definition.', [typeRef]);
  });
  var extendTypeCache = Object.create(null); // Get the extended root operation types.

  var operationTypes = {
    query: extendMaybeNamedType(schema.getQueryType()),
    mutation: extendMaybeNamedType(schema.getMutationType()),
    subscription: extendMaybeNamedType(schema.getSubscriptionType())
  };

  if (schemaDef) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = schemaDef.operationTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref2 = _step.value;
        var operation = _ref2.operation,
            type = _ref2.type;

        if (operationTypes[operation]) {
          throw new Error("Must provide only one ".concat(operation, " type in schema."));
        } // Note: While this could make early assertions to get the correctly
        // typed values, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.


        operationTypes[operation] = astBuilder.buildType(type);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  } // Then, incorporate schema definition and all schema extensions.


  for (var _i = 0; _i < schemaExtensions.length; _i++) {
    var schemaExtension = schemaExtensions[_i];

    if (schemaExtension.operationTypes) {
      var _iteratorNormalCompletion12 = true;
      var _didIteratorError12 = false;
      var _iteratorError12 = undefined;

      try {
        for (var _iterator12 = schemaExtension.operationTypes[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
          var _ref4 = _step12.value;
          var operation = _ref4.operation,
              type = _ref4.type;

          if (operationTypes[operation]) {
            throw new Error("Must provide only one ".concat(operation, " type in schema."));
          } // Note: While this could make early assertions to get the correctly
          // typed values, that would throw immediately while type system
          // validation with validateSchema() will produce more actionable results.


          operationTypes[operation] = astBuilder.buildType(type);
        }
      } catch (err) {
        _didIteratorError12 = true;
        _iteratorError12 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
            _iterator12.return();
          }
        } finally {
          if (_didIteratorError12) {
            throw _iteratorError12;
          }
        }
      }
    }
  }

  var schemaExtensionASTNodes = schemaExtensions ? schema.extensionASTNodes ? schema.extensionASTNodes.concat(schemaExtensions) : schemaExtensions : schema.extensionASTNodes;
  var types = (0, _objectValues.default)(schema.getTypeMap()).map(function (type) {
    return extendNamedType(type);
  }).concat((0, _objectValues.default)(typeDefinitionMap).map(function (type) {
    return astBuilder.buildType(type);
  })); // Support both original legacy names and extended legacy names.

  var allowedLegacyNames = schema.__allowedLegacyNames.concat(options && options.allowedLegacyNames || []); // Then produce and return a Schema with these types.


  return new _schema.GraphQLSchema(_objectSpread({}, operationTypes, {
    types: types,
    directives: getMergedDirectives(),
    astNode: schema.astNode,
    extensionASTNodes: schemaExtensionASTNodes,
    allowedLegacyNames: allowedLegacyNames
  })); // Below are functions used for producing this schema that have closed over
  // this scope and have access to the schema, cache, and newly defined types.

  function getMergedDirectives() {
    var existingDirectives = schema.getDirectives().map(extendDirective);
    !existingDirectives ? (0, _invariant.default)(0, 'schema must have default directives') : void 0;
    return existingDirectives.concat(directiveDefinitions.map(function (node) {
      return astBuilder.buildDirective(node);
    }));
  }

  function extendMaybeNamedType(type) {
    return type ? extendNamedType(type) : null;
  }

  function extendNamedType(type) {
    if ((0, _introspection.isIntrospectionType)(type) || (0, _scalars.isSpecifiedScalarType)(type)) {
      // Builtin types are not extended.
      return type;
    }

    var name = type.name;

    if (!extendTypeCache[name]) {
      if ((0, _definition.isScalarType)(type)) {
        extendTypeCache[name] = extendScalarType(type);
      } else if ((0, _definition.isObjectType)(type)) {
        extendTypeCache[name] = extendObjectType(type);
      } else if ((0, _definition.isInterfaceType)(type)) {
        extendTypeCache[name] = extendInterfaceType(type);
      } else if ((0, _definition.isUnionType)(type)) {
        extendTypeCache[name] = extendUnionType(type);
      } else if ((0, _definition.isEnumType)(type)) {
        extendTypeCache[name] = extendEnumType(type);
      } else if ((0, _definition.isInputObjectType)(type)) {
        extendTypeCache[name] = extendInputObjectType(type);
      }
    }

    return extendTypeCache[name];
  }

  function extendDirective(directive) {
    return new _directives.GraphQLDirective({
      name: directive.name,
      description: directive.description,
      locations: directive.locations,
      args: extendArgs(directive.args),
      astNode: directive.astNode
    });
  }

  function extendInputObjectType(type) {
    var name = type.name;
    var extensionASTNodes = typeExtensionsMap[name] ? type.extensionASTNodes ? type.extensionASTNodes.concat(typeExtensionsMap[name]) : typeExtensionsMap[name] : type.extensionASTNodes;
    return new _definition.GraphQLInputObjectType({
      name: name,
      description: type.description,
      fields: function fields() {
        return extendInputFieldMap(type);
      },
      astNode: type.astNode,
      extensionASTNodes: extensionASTNodes
    });
  }

  function extendInputFieldMap(type) {
    var newFieldMap = Object.create(null);
    var oldFieldMap = type.getFields();

    var _arr = Object.keys(oldFieldMap);

    for (var _i2 = 0; _i2 < _arr.length; _i2++) {
      var _fieldName = _arr[_i2];
      var _field = oldFieldMap[_fieldName];
      newFieldMap[_fieldName] = {
        description: _field.description,
        type: extendType(_field.type),
        defaultValue: _field.defaultValue,
        astNode: _field.astNode
      };
    } // If there are any extensions to the fields, apply those here.


    var extensions = typeExtensionsMap[type.name];

    if (extensions) {
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = extensions[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var extension = _step2.value;
          var _iteratorNormalCompletion3 = true;
          var _didIteratorError3 = false;
          var _iteratorError3 = undefined;

          try {
            for (var _iterator3 = extension.fields[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
              var field = _step3.value;
              var fieldName = field.name.value;

              if (oldFieldMap[fieldName]) {
                throw new _GraphQLError.GraphQLError("Field \"".concat(type.name, ".").concat(fieldName, "\" already exists in the ") + 'schema. It cannot also be defined in this type extension.', [field]);
              }

              newFieldMap[fieldName] = astBuilder.buildInputField(field);
            }
          } catch (err) {
            _didIteratorError3 = true;
            _iteratorError3 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                _iterator3.return();
              }
            } finally {
              if (_didIteratorError3) {
                throw _iteratorError3;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }

    return newFieldMap;
  }

  function extendEnumType(type) {
    var name = type.name;
    var extensionASTNodes = typeExtensionsMap[name] ? type.extensionASTNodes ? type.extensionASTNodes.concat(typeExtensionsMap[name]) : typeExtensionsMap[name] : type.extensionASTNodes;
    return new _definition.GraphQLEnumType({
      name: name,
      description: type.description,
      values: extendValueMap(type),
      astNode: type.astNode,
      extensionASTNodes: extensionASTNodes
    });
  }

  function extendValueMap(type) {
    var newValueMap = Object.create(null);
    var oldValueMap = (0, _keyMap.default)(type.getValues(), function (value) {
      return value.name;
    });

    var _arr2 = Object.keys(oldValueMap);

    for (var _i3 = 0; _i3 < _arr2.length; _i3++) {
      var _valueName = _arr2[_i3];
      var _value = oldValueMap[_valueName];
      newValueMap[_valueName] = {
        name: _value.name,
        description: _value.description,
        value: _value.value,
        deprecationReason: _value.deprecationReason,
        astNode: _value.astNode
      };
    } // If there are any extensions to the values, apply those here.


    var extensions = typeExtensionsMap[type.name];

    if (extensions) {
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = extensions[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var extension = _step4.value;
          var _iteratorNormalCompletion5 = true;
          var _didIteratorError5 = false;
          var _iteratorError5 = undefined;

          try {
            for (var _iterator5 = extension.values[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
              var value = _step5.value;
              var valueName = value.name.value;

              if (oldValueMap[valueName]) {
                throw new _GraphQLError.GraphQLError("Enum value \"".concat(type.name, ".").concat(valueName, "\" already exists in the ") + 'schema. It cannot also be defined in this type extension.', [value]);
              }

              newValueMap[valueName] = astBuilder.buildEnumValue(value);
            }
          } catch (err) {
            _didIteratorError5 = true;
            _iteratorError5 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                _iterator5.return();
              }
            } finally {
              if (_didIteratorError5) {
                throw _iteratorError5;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }
    }

    return newValueMap;
  }

  function extendScalarType(type) {
    var name = type.name;
    var extensionASTNodes = typeExtensionsMap[name] ? type.extensionASTNodes ? type.extensionASTNodes.concat(typeExtensionsMap[name]) : typeExtensionsMap[name] : type.extensionASTNodes;
    return new _definition.GraphQLScalarType({
      name: name,
      description: type.description,
      astNode: type.astNode,
      extensionASTNodes: extensionASTNodes,
      serialize: type.serialize,
      parseValue: type.parseValue,
      parseLiteral: type.parseLiteral
    });
  }

  function extendObjectType(type) {
    var name = type.name;
    var extensionASTNodes = typeExtensionsMap[name] ? type.extensionASTNodes ? type.extensionASTNodes.concat(typeExtensionsMap[name]) : typeExtensionsMap[name] : type.extensionASTNodes;
    return new _definition.GraphQLObjectType({
      name: name,
      description: type.description,
      interfaces: function interfaces() {
        return extendImplementedInterfaces(type);
      },
      fields: function fields() {
        return extendFieldMap(type);
      },
      astNode: type.astNode,
      extensionASTNodes: extensionASTNodes,
      isTypeOf: type.isTypeOf
    });
  }

  function extendArgs(args) {
    return (0, _keyValMap.default)(args, function (arg) {
      return arg.name;
    }, function (arg) {
      return {
        type: extendType(arg.type),
        defaultValue: arg.defaultValue,
        description: arg.description,
        astNode: arg.astNode
      };
    });
  }

  function extendInterfaceType(type) {
    var name = type.name;
    var extensionASTNodes = typeExtensionsMap[name] ? type.extensionASTNodes ? type.extensionASTNodes.concat(typeExtensionsMap[name]) : typeExtensionsMap[name] : type.extensionASTNodes;
    return new _definition.GraphQLInterfaceType({
      name: type.name,
      description: type.description,
      fields: function fields() {
        return extendFieldMap(type);
      },
      astNode: type.astNode,
      extensionASTNodes: extensionASTNodes,
      resolveType: type.resolveType
    });
  }

  function extendUnionType(type) {
    var name = type.name;
    var extensionASTNodes = typeExtensionsMap[name] ? type.extensionASTNodes ? type.extensionASTNodes.concat(typeExtensionsMap[name]) : typeExtensionsMap[name] : type.extensionASTNodes;
    return new _definition.GraphQLUnionType({
      name: name,
      description: type.description,
      types: function types() {
        return extendPossibleTypes(type);
      },
      astNode: type.astNode,
      resolveType: type.resolveType,
      extensionASTNodes: extensionASTNodes
    });
  }

  function extendPossibleTypes(type) {
    var possibleTypes = type.getTypes().map(extendNamedType); // If there are any extensions to the union, apply those here.

    var extensions = typeExtensionsMap[type.name];

    if (extensions) {
      var _iteratorNormalCompletion6 = true;
      var _didIteratorError6 = false;
      var _iteratorError6 = undefined;

      try {
        for (var _iterator6 = extensions[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
          var extension = _step6.value;
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = extension.types[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var namedType = _step7.value;
              // Note: While this could make early assertions to get the correctly
              // typed values, that would throw immediately while type system
              // validation with validateSchema() will produce more actionable results.
              possibleTypes.push(astBuilder.buildType(namedType));
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError6 = true;
        _iteratorError6 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
            _iterator6.return();
          }
        } finally {
          if (_didIteratorError6) {
            throw _iteratorError6;
          }
        }
      }
    }

    return possibleTypes;
  }

  function extendImplementedInterfaces(type) {
    var interfaces = type.getInterfaces().map(extendNamedType); // If there are any extensions to the interfaces, apply those here.

    var extensions = typeExtensionsMap[type.name];

    if (extensions) {
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = extensions[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var extension = _step8.value;
          var _iteratorNormalCompletion9 = true;
          var _didIteratorError9 = false;
          var _iteratorError9 = undefined;

          try {
            for (var _iterator9 = extension.interfaces[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
              var namedType = _step9.value;
              // Note: While this could make early assertions to get the correctly
              // typed values, that would throw immediately while type system
              // validation with validateSchema() will produce more actionable results.
              interfaces.push(astBuilder.buildType(namedType));
            }
          } catch (err) {
            _didIteratorError9 = true;
            _iteratorError9 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
                _iterator9.return();
              }
            } finally {
              if (_didIteratorError9) {
                throw _iteratorError9;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }
    }

    return interfaces;
  }

  function extendFieldMap(type) {
    var newFieldMap = Object.create(null);
    var oldFieldMap = type.getFields();

    var _arr3 = Object.keys(oldFieldMap);

    for (var _i4 = 0; _i4 < _arr3.length; _i4++) {
      var _fieldName2 = _arr3[_i4];
      var _field2 = oldFieldMap[_fieldName2];
      newFieldMap[_fieldName2] = {
        description: _field2.description,
        deprecationReason: _field2.deprecationReason,
        type: extendType(_field2.type),
        args: extendArgs(_field2.args),
        astNode: _field2.astNode,
        resolve: _field2.resolve
      };
    } // If there are any extensions to the fields, apply those here.


    var extensions = typeExtensionsMap[type.name];

    if (extensions) {
      var _iteratorNormalCompletion10 = true;
      var _didIteratorError10 = false;
      var _iteratorError10 = undefined;

      try {
        for (var _iterator10 = extensions[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
          var extension = _step10.value;
          var _iteratorNormalCompletion11 = true;
          var _didIteratorError11 = false;
          var _iteratorError11 = undefined;

          try {
            for (var _iterator11 = extension.fields[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
              var field = _step11.value;
              var fieldName = field.name.value;

              if (oldFieldMap[fieldName]) {
                throw new _GraphQLError.GraphQLError("Field \"".concat(type.name, ".").concat(fieldName, "\" already exists in the ") + 'schema. It cannot also be defined in this type extension.', [field]);
              }

              newFieldMap[fieldName] = astBuilder.buildField(field);
            }
          } catch (err) {
            _didIteratorError11 = true;
            _iteratorError11 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
                _iterator11.return();
              }
            } finally {
              if (_didIteratorError11) {
                throw _iteratorError11;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError10 = true;
        _iteratorError10 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
            _iterator10.return();
          }
        } finally {
          if (_didIteratorError10) {
            throw _iteratorError10;
          }
        }
      }
    }

    return newFieldMap;
  }

  function extendType(typeDef) {
    if ((0, _definition.isListType)(typeDef)) {
      return (0, _definition.GraphQLList)(extendType(typeDef.ofType));
    }

    if ((0, _definition.isNonNullType)(typeDef)) {
      return (0, _definition.GraphQLNonNull)(extendType(typeDef.ofType));
    }

    return extendNamedType(typeDef);
  }
}

function checkExtensionNode(type, node) {
  switch (node.kind) {
    case _kinds.Kind.OBJECT_TYPE_EXTENSION:
      if (!(0, _definition.isObjectType)(type)) {
        throw new _GraphQLError.GraphQLError("Cannot extend non-object type \"".concat(type.name, "\"."), [node]);
      }

      break;

    case _kinds.Kind.INTERFACE_TYPE_EXTENSION:
      if (!(0, _definition.isInterfaceType)(type)) {
        throw new _GraphQLError.GraphQLError("Cannot extend non-interface type \"".concat(type.name, "\"."), [node]);
      }

      break;

    case _kinds.Kind.ENUM_TYPE_EXTENSION:
      if (!(0, _definition.isEnumType)(type)) {
        throw new _GraphQLError.GraphQLError("Cannot extend non-enum type \"".concat(type.name, "\"."), [node]);
      }

      break;

    case _kinds.Kind.UNION_TYPE_EXTENSION:
      if (!(0, _definition.isUnionType)(type)) {
        throw new _GraphQLError.GraphQLError("Cannot extend non-union type \"".concat(type.name, "\"."), [node]);
      }

      break;

    case _kinds.Kind.INPUT_OBJECT_TYPE_EXTENSION:
      if (!(0, _definition.isInputObjectType)(type)) {
        throw new _GraphQLError.GraphQLError("Cannot extend non-input object type \"".concat(type.name, "\"."), [node]);
      }

      break;
  }
}

/***/ }),
/* 2986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findBreakingChanges = findBreakingChanges;
exports.findDangerousChanges = findDangerousChanges;
exports.findRemovedTypes = findRemovedTypes;
exports.findTypesThatChangedKind = findTypesThatChangedKind;
exports.findArgChanges = findArgChanges;
exports.findFieldsThatChangedTypeOnObjectOrInterfaceTypes = findFieldsThatChangedTypeOnObjectOrInterfaceTypes;
exports.findFieldsThatChangedTypeOnInputObjectTypes = findFieldsThatChangedTypeOnInputObjectTypes;
exports.findTypesRemovedFromUnions = findTypesRemovedFromUnions;
exports.findTypesAddedToUnions = findTypesAddedToUnions;
exports.findValuesRemovedFromEnums = findValuesRemovedFromEnums;
exports.findValuesAddedToEnums = findValuesAddedToEnums;
exports.findInterfacesRemovedFromObjectTypes = findInterfacesRemovedFromObjectTypes;
exports.findInterfacesAddedToObjectTypes = findInterfacesAddedToObjectTypes;
exports.findRemovedDirectives = findRemovedDirectives;
exports.findRemovedDirectiveArgs = findRemovedDirectiveArgs;
exports.findAddedNonNullDirectiveArgs = findAddedNonNullDirectiveArgs;
exports.findRemovedLocationsForDirective = findRemovedLocationsForDirective;
exports.findRemovedDirectiveLocations = findRemovedDirectiveLocations;
exports.DangerousChangeType = exports.BreakingChangeType = void 0;

var _definition = __webpack_require__(54);

var _keyMap = _interopRequireDefault(__webpack_require__(183));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2016-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
var BreakingChangeType = {
  FIELD_CHANGED_KIND: 'FIELD_CHANGED_KIND',
  FIELD_REMOVED: 'FIELD_REMOVED',
  TYPE_CHANGED_KIND: 'TYPE_CHANGED_KIND',
  TYPE_REMOVED: 'TYPE_REMOVED',
  TYPE_REMOVED_FROM_UNION: 'TYPE_REMOVED_FROM_UNION',
  VALUE_REMOVED_FROM_ENUM: 'VALUE_REMOVED_FROM_ENUM',
  ARG_REMOVED: 'ARG_REMOVED',
  ARG_CHANGED_KIND: 'ARG_CHANGED_KIND',
  REQUIRED_ARG_ADDED: 'REQUIRED_ARG_ADDED',
  REQUIRED_INPUT_FIELD_ADDED: 'REQUIRED_INPUT_FIELD_ADDED',
  INTERFACE_REMOVED_FROM_OBJECT: 'INTERFACE_REMOVED_FROM_OBJECT',
  DIRECTIVE_REMOVED: 'DIRECTIVE_REMOVED',
  DIRECTIVE_ARG_REMOVED: 'DIRECTIVE_ARG_REMOVED',
  DIRECTIVE_LOCATION_REMOVED: 'DIRECTIVE_LOCATION_REMOVED',
  REQUIRED_DIRECTIVE_ARG_ADDED: 'REQUIRED_DIRECTIVE_ARG_ADDED'
};
exports.BreakingChangeType = BreakingChangeType;
var DangerousChangeType = {
  ARG_DEFAULT_VALUE_CHANGE: 'ARG_DEFAULT_VALUE_CHANGE',
  VALUE_ADDED_TO_ENUM: 'VALUE_ADDED_TO_ENUM',
  INTERFACE_ADDED_TO_OBJECT: 'INTERFACE_ADDED_TO_OBJECT',
  TYPE_ADDED_TO_UNION: 'TYPE_ADDED_TO_UNION',
  OPTIONAL_INPUT_FIELD_ADDED: 'OPTIONAL_INPUT_FIELD_ADDED',
  OPTIONAL_ARG_ADDED: 'OPTIONAL_ARG_ADDED'
};
exports.DangerousChangeType = DangerousChangeType;

/**
 * Given two schemas, returns an Array containing descriptions of all the types
 * of breaking changes covered by the other functions down below.
 */
function findBreakingChanges(oldSchema, newSchema) {
  return findRemovedTypes(oldSchema, newSchema).concat(findTypesThatChangedKind(oldSchema, newSchema), findFieldsThatChangedTypeOnObjectOrInterfaceTypes(oldSchema, newSchema), findFieldsThatChangedTypeOnInputObjectTypes(oldSchema, newSchema).breakingChanges, findTypesRemovedFromUnions(oldSchema, newSchema), findValuesRemovedFromEnums(oldSchema, newSchema), findArgChanges(oldSchema, newSchema).breakingChanges, findInterfacesRemovedFromObjectTypes(oldSchema, newSchema), findRemovedDirectives(oldSchema, newSchema), findRemovedDirectiveArgs(oldSchema, newSchema), findAddedNonNullDirectiveArgs(oldSchema, newSchema), findRemovedDirectiveLocations(oldSchema, newSchema));
}
/**
 * Given two schemas, returns an Array containing descriptions of all the types
 * of potentially dangerous changes covered by the other functions down below.
 */


function findDangerousChanges(oldSchema, newSchema) {
  return findArgChanges(oldSchema, newSchema).dangerousChanges.concat(findValuesAddedToEnums(oldSchema, newSchema), findInterfacesAddedToObjectTypes(oldSchema, newSchema), findTypesAddedToUnions(oldSchema, newSchema), findFieldsThatChangedTypeOnInputObjectTypes(oldSchema, newSchema).dangerousChanges);
}
/**
 * Given two schemas, returns an Array containing descriptions of any breaking
 * changes in the newSchema related to removing an entire type.
 */


function findRemovedTypes(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();
  var breakingChanges = [];

  var _arr = Object.keys(oldTypeMap);

  for (var _i = 0; _i < _arr.length; _i++) {
    var typeName = _arr[_i];

    if (!newTypeMap[typeName]) {
      breakingChanges.push({
        type: BreakingChangeType.TYPE_REMOVED,
        description: "".concat(typeName, " was removed.")
      });
    }
  }

  return breakingChanges;
}
/**
 * Given two schemas, returns an Array containing descriptions of any breaking
 * changes in the newSchema related to changing the type of a type.
 */


function findTypesThatChangedKind(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();
  var breakingChanges = [];

  var _arr2 = Object.keys(oldTypeMap);

  for (var _i2 = 0; _i2 < _arr2.length; _i2++) {
    var typeName = _arr2[_i2];

    if (!newTypeMap[typeName]) {
      continue;
    }

    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];

    if (oldType.constructor !== newType.constructor) {
      breakingChanges.push({
        type: BreakingChangeType.TYPE_CHANGED_KIND,
        description: "".concat(typeName, " changed from ") + "".concat(typeKindName(oldType), " to ").concat(typeKindName(newType), ".")
      });
    }
  }

  return breakingChanges;
}
/**
 * Given two schemas, returns an Array containing descriptions of any
 * breaking or dangerous changes in the newSchema related to arguments
 * (such as removal or change of type of an argument, or a change in an
 * argument's default value).
 */


function findArgChanges(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();
  var breakingChanges = [];
  var dangerousChanges = [];

  var _arr3 = Object.keys(oldTypeMap);

  for (var _i3 = 0; _i3 < _arr3.length; _i3++) {
    var typeName = _arr3[_i3];
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];

    if (!((0, _definition.isObjectType)(oldType) || (0, _definition.isInterfaceType)(oldType)) || !((0, _definition.isObjectType)(newType) || (0, _definition.isInterfaceType)(newType)) || newType.constructor !== oldType.constructor) {
      continue;
    }

    var oldTypeFields = oldType.getFields();
    var newTypeFields = newType.getFields();

    var _arr4 = Object.keys(oldTypeFields);

    for (var _i4 = 0; _i4 < _arr4.length; _i4++) {
      var fieldName = _arr4[_i4];

      if (!newTypeFields[fieldName]) {
        continue;
      }

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        var _loop = function _loop() {
          var oldArgDef = _step.value;
          var newArgs = newTypeFields[fieldName].args;
          var newArgDef = newArgs.find(function (arg) {
            return arg.name === oldArgDef.name;
          }); // Arg not present

          if (!newArgDef) {
            breakingChanges.push({
              type: BreakingChangeType.ARG_REMOVED,
              description: "".concat(oldType.name, ".").concat(fieldName, " arg ") + "".concat(oldArgDef.name, " was removed")
            });
          } else {
            var isSafe = isChangeSafeForInputObjectFieldOrFieldArg(oldArgDef.type, newArgDef.type);

            if (!isSafe) {
              breakingChanges.push({
                type: BreakingChangeType.ARG_CHANGED_KIND,
                description: "".concat(oldType.name, ".").concat(fieldName, " arg ") + "".concat(oldArgDef.name, " has changed type from ") + "".concat(oldArgDef.type.toString(), " to ").concat(newArgDef.type.toString())
              });
            } else if (oldArgDef.defaultValue !== undefined && oldArgDef.defaultValue !== newArgDef.defaultValue) {
              dangerousChanges.push({
                type: DangerousChangeType.ARG_DEFAULT_VALUE_CHANGE,
                description: "".concat(oldType.name, ".").concat(fieldName, " arg ") + "".concat(oldArgDef.name, " has changed defaultValue")
              });
            }
          }
        };

        for (var _iterator = oldTypeFields[fieldName].args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          _loop();
        } // Check if arg was added to the field

      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        var _loop2 = function _loop2() {
          var newArgDef = _step2.value;
          var oldArgs = oldTypeFields[fieldName].args;
          var oldArgDef = oldArgs.find(function (arg) {
            return arg.name === newArgDef.name;
          });

          if (!oldArgDef) {
            var argName = newArgDef.name;

            if ((0, _definition.isRequiredArgument)(newArgDef)) {
              breakingChanges.push({
                type: BreakingChangeType.REQUIRED_ARG_ADDED,
                description: "A required arg ".concat(argName, " on ") + "".concat(typeName, ".").concat(fieldName, " was added")
              });
            } else {
              dangerousChanges.push({
                type: DangerousChangeType.OPTIONAL_ARG_ADDED,
                description: "An optional arg ".concat(argName, " on ") + "".concat(typeName, ".").concat(fieldName, " was added")
              });
            }
          }
        };

        for (var _iterator2 = newTypeFields[fieldName].args[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          _loop2();
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }
  }

  return {
    breakingChanges: breakingChanges,
    dangerousChanges: dangerousChanges
  };
}

function typeKindName(type) {
  if ((0, _definition.isScalarType)(type)) {
    return 'a Scalar type';
  }

  if ((0, _definition.isObjectType)(type)) {
    return 'an Object type';
  }

  if ((0, _definition.isInterfaceType)(type)) {
    return 'an Interface type';
  }

  if ((0, _definition.isUnionType)(type)) {
    return 'a Union type';
  }

  if ((0, _definition.isEnumType)(type)) {
    return 'an Enum type';
  }

  if ((0, _definition.isInputObjectType)(type)) {
    return 'an Input type';
  }

  throw new TypeError('Unknown type ' + type.constructor.name);
}

function findFieldsThatChangedTypeOnObjectOrInterfaceTypes(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();
  var breakingChanges = [];

  var _arr5 = Object.keys(oldTypeMap);

  for (var _i5 = 0; _i5 < _arr5.length; _i5++) {
    var typeName = _arr5[_i5];
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];

    if (!((0, _definition.isObjectType)(oldType) || (0, _definition.isInterfaceType)(oldType)) || !((0, _definition.isObjectType)(newType) || (0, _definition.isInterfaceType)(newType)) || newType.constructor !== oldType.constructor) {
      continue;
    }

    var oldTypeFieldsDef = oldType.getFields();
    var newTypeFieldsDef = newType.getFields();

    var _arr6 = Object.keys(oldTypeFieldsDef);

    for (var _i6 = 0; _i6 < _arr6.length; _i6++) {
      var fieldName = _arr6[_i6];

      // Check if the field is missing on the type in the new schema.
      if (!(fieldName in newTypeFieldsDef)) {
        breakingChanges.push({
          type: BreakingChangeType.FIELD_REMOVED,
          description: "".concat(typeName, ".").concat(fieldName, " was removed.")
        });
      } else {
        var oldFieldType = oldTypeFieldsDef[fieldName].type;
        var newFieldType = newTypeFieldsDef[fieldName].type;
        var isSafe = isChangeSafeForObjectOrInterfaceField(oldFieldType, newFieldType);

        if (!isSafe) {
          var oldFieldTypeString = (0, _definition.isNamedType)(oldFieldType) ? oldFieldType.name : oldFieldType.toString();
          var newFieldTypeString = (0, _definition.isNamedType)(newFieldType) ? newFieldType.name : newFieldType.toString();
          breakingChanges.push({
            type: BreakingChangeType.FIELD_CHANGED_KIND,
            description: "".concat(typeName, ".").concat(fieldName, " changed type from ") + "".concat(oldFieldTypeString, " to ").concat(newFieldTypeString, ".")
          });
        }
      }
    }
  }

  return breakingChanges;
}

function findFieldsThatChangedTypeOnInputObjectTypes(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();
  var breakingChanges = [];
  var dangerousChanges = [];

  var _arr7 = Object.keys(oldTypeMap);

  for (var _i7 = 0; _i7 < _arr7.length; _i7++) {
    var typeName = _arr7[_i7];
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];

    if (!(0, _definition.isInputObjectType)(oldType) || !(0, _definition.isInputObjectType)(newType)) {
      continue;
    }

    var oldTypeFieldsDef = oldType.getFields();
    var newTypeFieldsDef = newType.getFields();

    var _arr8 = Object.keys(oldTypeFieldsDef);

    for (var _i8 = 0; _i8 < _arr8.length; _i8++) {
      var fieldName = _arr8[_i8];

      // Check if the field is missing on the type in the new schema.
      if (!(fieldName in newTypeFieldsDef)) {
        breakingChanges.push({
          type: BreakingChangeType.FIELD_REMOVED,
          description: "".concat(typeName, ".").concat(fieldName, " was removed.")
        });
      } else {
        var oldFieldType = oldTypeFieldsDef[fieldName].type;
        var newFieldType = newTypeFieldsDef[fieldName].type;
        var isSafe = isChangeSafeForInputObjectFieldOrFieldArg(oldFieldType, newFieldType);

        if (!isSafe) {
          var oldFieldTypeString = (0, _definition.isNamedType)(oldFieldType) ? oldFieldType.name : oldFieldType.toString();
          var newFieldTypeString = (0, _definition.isNamedType)(newFieldType) ? newFieldType.name : newFieldType.toString();
          breakingChanges.push({
            type: BreakingChangeType.FIELD_CHANGED_KIND,
            description: "".concat(typeName, ".").concat(fieldName, " changed type from ") + "".concat(oldFieldTypeString, " to ").concat(newFieldTypeString, ".")
          });
        }
      }
    } // Check if a field was added to the input object type


    var _arr9 = Object.keys(newTypeFieldsDef);

    for (var _i9 = 0; _i9 < _arr9.length; _i9++) {
      var _fieldName = _arr9[_i9];

      if (!(_fieldName in oldTypeFieldsDef)) {
        if ((0, _definition.isRequiredInputField)(newTypeFieldsDef[_fieldName])) {
          breakingChanges.push({
            type: BreakingChangeType.REQUIRED_INPUT_FIELD_ADDED,
            description: "A required field ".concat(_fieldName, " on ") + "input type ".concat(typeName, " was added.")
          });
        } else {
          dangerousChanges.push({
            type: DangerousChangeType.OPTIONAL_INPUT_FIELD_ADDED,
            description: "An optional field ".concat(_fieldName, " on ") + "input type ".concat(typeName, " was added.")
          });
        }
      }
    }
  }

  return {
    breakingChanges: breakingChanges,
    dangerousChanges: dangerousChanges
  };
}

function isChangeSafeForObjectOrInterfaceField(oldType, newType) {
  if ((0, _definition.isNamedType)(oldType)) {
    return (// if they're both named types, see if their names are equivalent
      (0, _definition.isNamedType)(newType) && oldType.name === newType.name || // moving from nullable to non-null of the same underlying type is safe
      (0, _definition.isNonNullType)(newType) && isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType)
    );
  } else if ((0, _definition.isListType)(oldType)) {
    return (// if they're both lists, make sure the underlying types are compatible
      (0, _definition.isListType)(newType) && isChangeSafeForObjectOrInterfaceField(oldType.ofType, newType.ofType) || // moving from nullable to non-null of the same underlying type is safe
      (0, _definition.isNonNullType)(newType) && isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType)
    );
  } else if ((0, _definition.isNonNullType)(oldType)) {
    // if they're both non-null, make sure the underlying types are compatible
    return (0, _definition.isNonNullType)(newType) && isChangeSafeForObjectOrInterfaceField(oldType.ofType, newType.ofType);
  }

  return false;
}

function isChangeSafeForInputObjectFieldOrFieldArg(oldType, newType) {
  if ((0, _definition.isNamedType)(oldType)) {
    // if they're both named types, see if their names are equivalent
    return (0, _definition.isNamedType)(newType) && oldType.name === newType.name;
  } else if ((0, _definition.isListType)(oldType)) {
    // if they're both lists, make sure the underlying types are compatible
    return (0, _definition.isListType)(newType) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType.ofType);
  } else if ((0, _definition.isNonNullType)(oldType)) {
    return (// if they're both non-null, make sure the underlying types are
      // compatible
      (0, _definition.isNonNullType)(newType) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType.ofType) || // moving from non-null to nullable of the same underlying type is safe
      !(0, _definition.isNonNullType)(newType) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType)
    );
  }

  return false;
}
/**
 * Given two schemas, returns an Array containing descriptions of any breaking
 * changes in the newSchema related to removing types from a union type.
 */


function findTypesRemovedFromUnions(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();
  var typesRemovedFromUnion = [];

  var _arr10 = Object.keys(oldTypeMap);

  for (var _i10 = 0; _i10 < _arr10.length; _i10++) {
    var typeName = _arr10[_i10];
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];

    if (!(0, _definition.isUnionType)(oldType) || !(0, _definition.isUnionType)(newType)) {
      continue;
    }

    var typeNamesInNewUnion = Object.create(null);
    var _iteratorNormalCompletion3 = true;
    var _didIteratorError3 = false;
    var _iteratorError3 = undefined;

    try {
      for (var _iterator3 = newType.getTypes()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
        var type = _step3.value;
        typeNamesInNewUnion[type.name] = true;
      }
    } catch (err) {
      _didIteratorError3 = true;
      _iteratorError3 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
          _iterator3.return();
        }
      } finally {
        if (_didIteratorError3) {
          throw _iteratorError3;
        }
      }
    }

    var _iteratorNormalCompletion4 = true;
    var _didIteratorError4 = false;
    var _iteratorError4 = undefined;

    try {
      for (var _iterator4 = oldType.getTypes()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
        var _type = _step4.value;

        if (!typeNamesInNewUnion[_type.name]) {
          typesRemovedFromUnion.push({
            type: BreakingChangeType.TYPE_REMOVED_FROM_UNION,
            description: "".concat(_type.name, " was removed from union type ").concat(typeName, ".")
          });
        }
      }
    } catch (err) {
      _didIteratorError4 = true;
      _iteratorError4 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
          _iterator4.return();
        }
      } finally {
        if (_didIteratorError4) {
          throw _iteratorError4;
        }
      }
    }
  }

  return typesRemovedFromUnion;
}
/**
 * Given two schemas, returns an Array containing descriptions of any dangerous
 * changes in the newSchema related to adding types to a union type.
 */


function findTypesAddedToUnions(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();
  var typesAddedToUnion = [];

  var _arr11 = Object.keys(newTypeMap);

  for (var _i11 = 0; _i11 < _arr11.length; _i11++) {
    var typeName = _arr11[_i11];
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];

    if (!(0, _definition.isUnionType)(oldType) || !(0, _definition.isUnionType)(newType)) {
      continue;
    }

    var typeNamesInOldUnion = Object.create(null);
    var _iteratorNormalCompletion5 = true;
    var _didIteratorError5 = false;
    var _iteratorError5 = undefined;

    try {
      for (var _iterator5 = oldType.getTypes()[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
        var type = _step5.value;
        typeNamesInOldUnion[type.name] = true;
      }
    } catch (err) {
      _didIteratorError5 = true;
      _iteratorError5 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
          _iterator5.return();
        }
      } finally {
        if (_didIteratorError5) {
          throw _iteratorError5;
        }
      }
    }

    var _iteratorNormalCompletion6 = true;
    var _didIteratorError6 = false;
    var _iteratorError6 = undefined;

    try {
      for (var _iterator6 = newType.getTypes()[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
        var _type2 = _step6.value;

        if (!typeNamesInOldUnion[_type2.name]) {
          typesAddedToUnion.push({
            type: DangerousChangeType.TYPE_ADDED_TO_UNION,
            description: "".concat(_type2.name, " was added to union type ").concat(typeName, ".")
          });
        }
      }
    } catch (err) {
      _didIteratorError6 = true;
      _iteratorError6 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
          _iterator6.return();
        }
      } finally {
        if (_didIteratorError6) {
          throw _iteratorError6;
        }
      }
    }
  }

  return typesAddedToUnion;
}
/**
 * Given two schemas, returns an Array containing descriptions of any breaking
 * changes in the newSchema related to removing values from an enum type.
 */


function findValuesRemovedFromEnums(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();
  var valuesRemovedFromEnums = [];

  var _arr12 = Object.keys(oldTypeMap);

  for (var _i12 = 0; _i12 < _arr12.length; _i12++) {
    var typeName = _arr12[_i12];
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];

    if (!(0, _definition.isEnumType)(oldType) || !(0, _definition.isEnumType)(newType)) {
      continue;
    }

    var valuesInNewEnum = Object.create(null);
    var _iteratorNormalCompletion7 = true;
    var _didIteratorError7 = false;
    var _iteratorError7 = undefined;

    try {
      for (var _iterator7 = newType.getValues()[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
        var value = _step7.value;
        valuesInNewEnum[value.name] = true;
      }
    } catch (err) {
      _didIteratorError7 = true;
      _iteratorError7 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion7 && _iterator7.return != null) {
          _iterator7.return();
        }
      } finally {
        if (_didIteratorError7) {
          throw _iteratorError7;
        }
      }
    }

    var _iteratorNormalCompletion8 = true;
    var _didIteratorError8 = false;
    var _iteratorError8 = undefined;

    try {
      for (var _iterator8 = oldType.getValues()[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
        var _value = _step8.value;

        if (!valuesInNewEnum[_value.name]) {
          valuesRemovedFromEnums.push({
            type: BreakingChangeType.VALUE_REMOVED_FROM_ENUM,
            description: "".concat(_value.name, " was removed from enum type ").concat(typeName, ".")
          });
        }
      }
    } catch (err) {
      _didIteratorError8 = true;
      _iteratorError8 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion8 && _iterator8.return != null) {
          _iterator8.return();
        }
      } finally {
        if (_didIteratorError8) {
          throw _iteratorError8;
        }
      }
    }
  }

  return valuesRemovedFromEnums;
}
/**
 * Given two schemas, returns an Array containing descriptions of any dangerous
 * changes in the newSchema related to adding values to an enum type.
 */


function findValuesAddedToEnums(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();
  var valuesAddedToEnums = [];

  var _arr13 = Object.keys(oldTypeMap);

  for (var _i13 = 0; _i13 < _arr13.length; _i13++) {
    var typeName = _arr13[_i13];
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];

    if (!(0, _definition.isEnumType)(oldType) || !(0, _definition.isEnumType)(newType)) {
      continue;
    }

    var valuesInOldEnum = Object.create(null);
    var _iteratorNormalCompletion9 = true;
    var _didIteratorError9 = false;
    var _iteratorError9 = undefined;

    try {
      for (var _iterator9 = oldType.getValues()[Symbol.iterator](), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
        var value = _step9.value;
        valuesInOldEnum[value.name] = true;
      }
    } catch (err) {
      _didIteratorError9 = true;
      _iteratorError9 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion9 && _iterator9.return != null) {
          _iterator9.return();
        }
      } finally {
        if (_didIteratorError9) {
          throw _iteratorError9;
        }
      }
    }

    var _iteratorNormalCompletion10 = true;
    var _didIteratorError10 = false;
    var _iteratorError10 = undefined;

    try {
      for (var _iterator10 = newType.getValues()[Symbol.iterator](), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
        var _value2 = _step10.value;

        if (!valuesInOldEnum[_value2.name]) {
          valuesAddedToEnums.push({
            type: DangerousChangeType.VALUE_ADDED_TO_ENUM,
            description: "".concat(_value2.name, " was added to enum type ").concat(typeName, ".")
          });
        }
      }
    } catch (err) {
      _didIteratorError10 = true;
      _iteratorError10 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion10 && _iterator10.return != null) {
          _iterator10.return();
        }
      } finally {
        if (_didIteratorError10) {
          throw _iteratorError10;
        }
      }
    }
  }

  return valuesAddedToEnums;
}

function findInterfacesRemovedFromObjectTypes(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();
  var breakingChanges = [];

  var _arr14 = Object.keys(oldTypeMap);

  for (var _i14 = 0; _i14 < _arr14.length; _i14++) {
    var typeName = _arr14[_i14];
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];

    if (!(0, _definition.isObjectType)(oldType) || !(0, _definition.isObjectType)(newType)) {
      continue;
    }

    var oldInterfaces = oldType.getInterfaces();
    var newInterfaces = newType.getInterfaces();
    var _iteratorNormalCompletion11 = true;
    var _didIteratorError11 = false;
    var _iteratorError11 = undefined;

    try {
      var _loop3 = function _loop3() {
        var oldInterface = _step11.value;

        if (!newInterfaces.some(function (int) {
          return int.name === oldInterface.name;
        })) {
          breakingChanges.push({
            type: BreakingChangeType.INTERFACE_REMOVED_FROM_OBJECT,
            description: "".concat(typeName, " no longer implements interface ") + "".concat(oldInterface.name, ".")
          });
        }
      };

      for (var _iterator11 = oldInterfaces[Symbol.iterator](), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
        _loop3();
      }
    } catch (err) {
      _didIteratorError11 = true;
      _iteratorError11 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion11 && _iterator11.return != null) {
          _iterator11.return();
        }
      } finally {
        if (_didIteratorError11) {
          throw _iteratorError11;
        }
      }
    }
  }

  return breakingChanges;
}

function findInterfacesAddedToObjectTypes(oldSchema, newSchema) {
  var oldTypeMap = oldSchema.getTypeMap();
  var newTypeMap = newSchema.getTypeMap();
  var interfacesAddedToObjectTypes = [];

  var _arr15 = Object.keys(newTypeMap);

  for (var _i15 = 0; _i15 < _arr15.length; _i15++) {
    var typeName = _arr15[_i15];
    var oldType = oldTypeMap[typeName];
    var newType = newTypeMap[typeName];

    if (!(0, _definition.isObjectType)(oldType) || !(0, _definition.isObjectType)(newType)) {
      continue;
    }

    var oldInterfaces = oldType.getInterfaces();
    var newInterfaces = newType.getInterfaces();
    var _iteratorNormalCompletion12 = true;
    var _didIteratorError12 = false;
    var _iteratorError12 = undefined;

    try {
      var _loop4 = function _loop4() {
        var newInterface = _step12.value;

        if (!oldInterfaces.some(function (int) {
          return int.name === newInterface.name;
        })) {
          interfacesAddedToObjectTypes.push({
            type: DangerousChangeType.INTERFACE_ADDED_TO_OBJECT,
            description: "".concat(newInterface.name, " added to interfaces implemented ") + "by ".concat(typeName, ".")
          });
        }
      };

      for (var _iterator12 = newInterfaces[Symbol.iterator](), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
        _loop4();
      }
    } catch (err) {
      _didIteratorError12 = true;
      _iteratorError12 = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion12 && _iterator12.return != null) {
          _iterator12.return();
        }
      } finally {
        if (_didIteratorError12) {
          throw _iteratorError12;
        }
      }
    }
  }

  return interfacesAddedToObjectTypes;
}

function findRemovedDirectives(oldSchema, newSchema) {
  var removedDirectives = [];
  var newSchemaDirectiveMap = getDirectiveMapForSchema(newSchema);
  var _iteratorNormalCompletion13 = true;
  var _didIteratorError13 = false;
  var _iteratorError13 = undefined;

  try {
    for (var _iterator13 = oldSchema.getDirectives()[Symbol.iterator](), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
      var directive = _step13.value;

      if (!newSchemaDirectiveMap[directive.name]) {
        removedDirectives.push({
          type: BreakingChangeType.DIRECTIVE_REMOVED,
          description: "".concat(directive.name, " was removed")
        });
      }
    }
  } catch (err) {
    _didIteratorError13 = true;
    _iteratorError13 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion13 && _iterator13.return != null) {
        _iterator13.return();
      }
    } finally {
      if (_didIteratorError13) {
        throw _iteratorError13;
      }
    }
  }

  return removedDirectives;
}

function findRemovedArgsForDirective(oldDirective, newDirective) {
  var removedArgs = [];
  var newArgMap = getArgumentMapForDirective(newDirective);
  var _iteratorNormalCompletion14 = true;
  var _didIteratorError14 = false;
  var _iteratorError14 = undefined;

  try {
    for (var _iterator14 = oldDirective.args[Symbol.iterator](), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
      var arg = _step14.value;

      if (!newArgMap[arg.name]) {
        removedArgs.push(arg);
      }
    }
  } catch (err) {
    _didIteratorError14 = true;
    _iteratorError14 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion14 && _iterator14.return != null) {
        _iterator14.return();
      }
    } finally {
      if (_didIteratorError14) {
        throw _iteratorError14;
      }
    }
  }

  return removedArgs;
}

function findRemovedDirectiveArgs(oldSchema, newSchema) {
  var removedDirectiveArgs = [];
  var oldSchemaDirectiveMap = getDirectiveMapForSchema(oldSchema);
  var _iteratorNormalCompletion15 = true;
  var _didIteratorError15 = false;
  var _iteratorError15 = undefined;

  try {
    for (var _iterator15 = newSchema.getDirectives()[Symbol.iterator](), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
      var newDirective = _step15.value;
      var oldDirective = oldSchemaDirectiveMap[newDirective.name];

      if (!oldDirective) {
        continue;
      }

      var _iteratorNormalCompletion16 = true;
      var _didIteratorError16 = false;
      var _iteratorError16 = undefined;

      try {
        for (var _iterator16 = findRemovedArgsForDirective(oldDirective, newDirective)[Symbol.iterator](), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
          var arg = _step16.value;
          removedDirectiveArgs.push({
            type: BreakingChangeType.DIRECTIVE_ARG_REMOVED,
            description: "".concat(arg.name, " was removed from ").concat(newDirective.name)
          });
        }
      } catch (err) {
        _didIteratorError16 = true;
        _iteratorError16 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion16 && _iterator16.return != null) {
            _iterator16.return();
          }
        } finally {
          if (_didIteratorError16) {
            throw _iteratorError16;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError15 = true;
    _iteratorError15 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion15 && _iterator15.return != null) {
        _iterator15.return();
      }
    } finally {
      if (_didIteratorError15) {
        throw _iteratorError15;
      }
    }
  }

  return removedDirectiveArgs;
}

function findAddedArgsForDirective(oldDirective, newDirective) {
  var addedArgs = [];
  var oldArgMap = getArgumentMapForDirective(oldDirective);
  var _iteratorNormalCompletion17 = true;
  var _didIteratorError17 = false;
  var _iteratorError17 = undefined;

  try {
    for (var _iterator17 = newDirective.args[Symbol.iterator](), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
      var arg = _step17.value;

      if (!oldArgMap[arg.name]) {
        addedArgs.push(arg);
      }
    }
  } catch (err) {
    _didIteratorError17 = true;
    _iteratorError17 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion17 && _iterator17.return != null) {
        _iterator17.return();
      }
    } finally {
      if (_didIteratorError17) {
        throw _iteratorError17;
      }
    }
  }

  return addedArgs;
}

function findAddedNonNullDirectiveArgs(oldSchema, newSchema) {
  var addedNonNullableArgs = [];
  var oldSchemaDirectiveMap = getDirectiveMapForSchema(oldSchema);
  var _iteratorNormalCompletion18 = true;
  var _didIteratorError18 = false;
  var _iteratorError18 = undefined;

  try {
    for (var _iterator18 = newSchema.getDirectives()[Symbol.iterator](), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
      var newDirective = _step18.value;
      var oldDirective = oldSchemaDirectiveMap[newDirective.name];

      if (!oldDirective) {
        continue;
      }

      var _iteratorNormalCompletion19 = true;
      var _didIteratorError19 = false;
      var _iteratorError19 = undefined;

      try {
        for (var _iterator19 = findAddedArgsForDirective(oldDirective, newDirective)[Symbol.iterator](), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
          var arg = _step19.value;

          if ((0, _definition.isRequiredArgument)(arg)) {
            addedNonNullableArgs.push({
              type: BreakingChangeType.REQUIRED_DIRECTIVE_ARG_ADDED,
              description: "A required arg ".concat(arg.name, " on directive ") + "".concat(newDirective.name, " was added")
            });
          }
        }
      } catch (err) {
        _didIteratorError19 = true;
        _iteratorError19 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion19 && _iterator19.return != null) {
            _iterator19.return();
          }
        } finally {
          if (_didIteratorError19) {
            throw _iteratorError19;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError18 = true;
    _iteratorError18 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion18 && _iterator18.return != null) {
        _iterator18.return();
      }
    } finally {
      if (_didIteratorError18) {
        throw _iteratorError18;
      }
    }
  }

  return addedNonNullableArgs;
}

function findRemovedLocationsForDirective(oldDirective, newDirective) {
  var removedLocations = [];
  var newLocationSet = new Set(newDirective.locations);
  var _iteratorNormalCompletion20 = true;
  var _didIteratorError20 = false;
  var _iteratorError20 = undefined;

  try {
    for (var _iterator20 = oldDirective.locations[Symbol.iterator](), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
      var oldLocation = _step20.value;

      if (!newLocationSet.has(oldLocation)) {
        removedLocations.push(oldLocation);
      }
    }
  } catch (err) {
    _didIteratorError20 = true;
    _iteratorError20 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion20 && _iterator20.return != null) {
        _iterator20.return();
      }
    } finally {
      if (_didIteratorError20) {
        throw _iteratorError20;
      }
    }
  }

  return removedLocations;
}

function findRemovedDirectiveLocations(oldSchema, newSchema) {
  var removedLocations = [];
  var oldSchemaDirectiveMap = getDirectiveMapForSchema(oldSchema);
  var _iteratorNormalCompletion21 = true;
  var _didIteratorError21 = false;
  var _iteratorError21 = undefined;

  try {
    for (var _iterator21 = newSchema.getDirectives()[Symbol.iterator](), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
      var newDirective = _step21.value;
      var oldDirective = oldSchemaDirectiveMap[newDirective.name];

      if (!oldDirective) {
        continue;
      }

      var _iteratorNormalCompletion22 = true;
      var _didIteratorError22 = false;
      var _iteratorError22 = undefined;

      try {
        for (var _iterator22 = findRemovedLocationsForDirective(oldDirective, newDirective)[Symbol.iterator](), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
          var location = _step22.value;
          removedLocations.push({
            type: BreakingChangeType.DIRECTIVE_LOCATION_REMOVED,
            description: "".concat(location, " was removed from ").concat(newDirective.name)
          });
        }
      } catch (err) {
        _didIteratorError22 = true;
        _iteratorError22 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion22 && _iterator22.return != null) {
            _iterator22.return();
          }
        } finally {
          if (_didIteratorError22) {
            throw _iteratorError22;
          }
        }
      }
    }
  } catch (err) {
    _didIteratorError21 = true;
    _iteratorError21 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion21 && _iterator21.return != null) {
        _iterator21.return();
      }
    } finally {
      if (_didIteratorError21) {
        throw _iteratorError21;
      }
    }
  }

  return removedLocations;
}

function getDirectiveMapForSchema(schema) {
  return (0, _keyMap.default)(schema.getDirectives(), function (dir) {
    return dir.name;
  });
}

function getArgumentMapForDirective(directive) {
  return (0, _keyMap.default)(directive.args, function (arg) {
    return arg.name;
  });
}

/***/ }),
/* 2987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findDeprecatedUsages = findDeprecatedUsages;

var _GraphQLError = __webpack_require__(37);

var _visitor = __webpack_require__(245);

var _definition = __webpack_require__(54);

var _TypeInfo = __webpack_require__(346);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * A validation rule which reports deprecated usages.
 *
 * Returns a list of GraphQLError instances describing each deprecated use.
 */
function findDeprecatedUsages(schema, ast) {
  var errors = [];
  var typeInfo = new _TypeInfo.TypeInfo(schema);
  (0, _visitor.visit)(ast, (0, _visitor.visitWithTypeInfo)(typeInfo, {
    Field: function Field(node) {
      var fieldDef = typeInfo.getFieldDef();

      if (fieldDef && fieldDef.isDeprecated) {
        var parentType = typeInfo.getParentType();

        if (parentType) {
          var reason = fieldDef.deprecationReason;
          errors.push(new _GraphQLError.GraphQLError("The field ".concat(parentType.name, ".").concat(fieldDef.name, " is deprecated.") + (reason ? ' ' + reason : ''), [node]));
        }
      }
    },
    EnumValue: function EnumValue(node) {
      var enumVal = typeInfo.getEnumValue();

      if (enumVal && enumVal.isDeprecated) {
        var type = (0, _definition.getNamedType)(typeInfo.getInputType());

        if (type) {
          var reason = enumVal.deprecationReason;
          errors.push(new _GraphQLError.GraphQLError("The enum value ".concat(type.name, ".").concat(enumVal.name, " is deprecated.") + (reason ? ' ' + reason : ''), [node]));
        }
      }
    }
  }));
  return errors;
}

/***/ }),
/* 2988 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOperationAST = getOperationAST;

var _kinds = __webpack_require__(68);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Returns an operation AST given a document AST and optionally an operation
 * name. If a name is not provided, an operation is only returned if only one is
 * provided in the document.
 */
function getOperationAST(documentAST, operationName) {
  var operation = null;

  for (var i = 0; i < documentAST.definitions.length; i++) {
    var definition = documentAST.definitions[i];

    if (definition.kind === _kinds.Kind.OPERATION_DEFINITION) {
      if (!operationName) {
        // If no operation name was provided, only return an Operation if there
        // is one defined in the document. Upon encountering the second, return
        // null.
        if (operation) {
          return null;
        }

        operation = definition;
      } else if (definition.name && definition.name.value === operationName) {
        return definition;
      }
    }
  }

  return operation;
}

/***/ }),
/* 2989 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "getIntrospectionQuery", {
  enumerable: true,
  get: function get() {
    return _introspectionQuery.getIntrospectionQuery;
  }
});
Object.defineProperty(exports, "introspectionQuery", {
  enumerable: true,
  get: function get() {
    return _introspectionQuery.introspectionQuery;
  }
});
Object.defineProperty(exports, "getOperationAST", {
  enumerable: true,
  get: function get() {
    return _getOperationAST.getOperationAST;
  }
});
Object.defineProperty(exports, "getOperationRootType", {
  enumerable: true,
  get: function get() {
    return _getOperationRootType.getOperationRootType;
  }
});
Object.defineProperty(exports, "introspectionFromSchema", {
  enumerable: true,
  get: function get() {
    return _introspectionFromSchema.introspectionFromSchema;
  }
});
Object.defineProperty(exports, "buildClientSchema", {
  enumerable: true,
  get: function get() {
    return _buildClientSchema.buildClientSchema;
  }
});
Object.defineProperty(exports, "buildASTSchema", {
  enumerable: true,
  get: function get() {
    return _buildASTSchema.buildASTSchema;
  }
});
Object.defineProperty(exports, "buildSchema", {
  enumerable: true,
  get: function get() {
    return _buildASTSchema.buildSchema;
  }
});
Object.defineProperty(exports, "getDescription", {
  enumerable: true,
  get: function get() {
    return _buildASTSchema.getDescription;
  }
});
Object.defineProperty(exports, "extendSchema", {
  enumerable: true,
  get: function get() {
    return _extendSchema.extendSchema;
  }
});
Object.defineProperty(exports, "lexicographicSortSchema", {
  enumerable: true,
  get: function get() {
    return _lexicographicSortSchema.lexicographicSortSchema;
  }
});
Object.defineProperty(exports, "printSchema", {
  enumerable: true,
  get: function get() {
    return _schemaPrinter.printSchema;
  }
});
Object.defineProperty(exports, "printType", {
  enumerable: true,
  get: function get() {
    return _schemaPrinter.printType;
  }
});
Object.defineProperty(exports, "printIntrospectionSchema", {
  enumerable: true,
  get: function get() {
    return _schemaPrinter.printIntrospectionSchema;
  }
});
Object.defineProperty(exports, "typeFromAST", {
  enumerable: true,
  get: function get() {
    return _typeFromAST.typeFromAST;
  }
});
Object.defineProperty(exports, "valueFromAST", {
  enumerable: true,
  get: function get() {
    return _valueFromAST.valueFromAST;
  }
});
Object.defineProperty(exports, "valueFromASTUntyped", {
  enumerable: true,
  get: function get() {
    return _valueFromASTUntyped.valueFromASTUntyped;
  }
});
Object.defineProperty(exports, "astFromValue", {
  enumerable: true,
  get: function get() {
    return _astFromValue.astFromValue;
  }
});
Object.defineProperty(exports, "TypeInfo", {
  enumerable: true,
  get: function get() {
    return _TypeInfo.TypeInfo;
  }
});
Object.defineProperty(exports, "coerceValue", {
  enumerable: true,
  get: function get() {
    return _coerceValue.coerceValue;
  }
});
Object.defineProperty(exports, "isValidJSValue", {
  enumerable: true,
  get: function get() {
    return _isValidJSValue.isValidJSValue;
  }
});
Object.defineProperty(exports, "isValidLiteralValue", {
  enumerable: true,
  get: function get() {
    return _isValidLiteralValue.isValidLiteralValue;
  }
});
Object.defineProperty(exports, "concatAST", {
  enumerable: true,
  get: function get() {
    return _concatAST.concatAST;
  }
});
Object.defineProperty(exports, "separateOperations", {
  enumerable: true,
  get: function get() {
    return _separateOperations.separateOperations;
  }
});
Object.defineProperty(exports, "isEqualType", {
  enumerable: true,
  get: function get() {
    return _typeComparators.isEqualType;
  }
});
Object.defineProperty(exports, "isTypeSubTypeOf", {
  enumerable: true,
  get: function get() {
    return _typeComparators.isTypeSubTypeOf;
  }
});
Object.defineProperty(exports, "doTypesOverlap", {
  enumerable: true,
  get: function get() {
    return _typeComparators.doTypesOverlap;
  }
});
Object.defineProperty(exports, "assertValidName", {
  enumerable: true,
  get: function get() {
    return _assertValidName.assertValidName;
  }
});
Object.defineProperty(exports, "isValidNameError", {
  enumerable: true,
  get: function get() {
    return _assertValidName.isValidNameError;
  }
});
Object.defineProperty(exports, "BreakingChangeType", {
  enumerable: true,
  get: function get() {
    return _findBreakingChanges.BreakingChangeType;
  }
});
Object.defineProperty(exports, "DangerousChangeType", {
  enumerable: true,
  get: function get() {
    return _findBreakingChanges.DangerousChangeType;
  }
});
Object.defineProperty(exports, "findBreakingChanges", {
  enumerable: true,
  get: function get() {
    return _findBreakingChanges.findBreakingChanges;
  }
});
Object.defineProperty(exports, "findDangerousChanges", {
  enumerable: true,
  get: function get() {
    return _findBreakingChanges.findDangerousChanges;
  }
});
Object.defineProperty(exports, "findDeprecatedUsages", {
  enumerable: true,
  get: function get() {
    return _findDeprecatedUsages.findDeprecatedUsages;
  }
});

var _introspectionQuery = __webpack_require__(1211);

var _getOperationAST = __webpack_require__(2988);

var _getOperationRootType = __webpack_require__(667);

var _introspectionFromSchema = __webpack_require__(2990);

var _buildClientSchema = __webpack_require__(2983);

var _buildASTSchema = __webpack_require__(1210);

var _extendSchema = __webpack_require__(2985);

var _lexicographicSortSchema = __webpack_require__(2993);

var _schemaPrinter = __webpack_require__(2994);

var _typeFromAST = __webpack_require__(185);

var _valueFromAST = __webpack_require__(442);

var _valueFromASTUntyped = __webpack_require__(1212);

var _astFromValue = __webpack_require__(665);

var _TypeInfo = __webpack_require__(346);

var _coerceValue = __webpack_require__(666);

var _isValidJSValue = __webpack_require__(2991);

var _isValidLiteralValue = __webpack_require__(2992);

var _concatAST = __webpack_require__(2984);

var _separateOperations = __webpack_require__(2995);

var _typeComparators = __webpack_require__(441);

var _assertValidName = __webpack_require__(1209);

var _findBreakingChanges = __webpack_require__(2986);

var _findDeprecatedUsages = __webpack_require__(2987);

/***/ }),
/* 2990 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.introspectionFromSchema = introspectionFromSchema;

var _invariant = _interopRequireDefault(__webpack_require__(108));

var _introspectionQuery = __webpack_require__(1211);

var _execute = __webpack_require__(437);

var _parser = __webpack_require__(283);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Build an IntrospectionQuery from a GraphQLSchema
 *
 * IntrospectionQuery is useful for utilities that care about type and field
 * relationships, but do not need to traverse through those relationships.
 *
 * This is the inverse of buildClientSchema. The primary use case is outside
 * of the server context, for instance when doing schema comparisons.
 */
function introspectionFromSchema(schema, options) {
  var queryAST = (0, _parser.parse)((0, _introspectionQuery.getIntrospectionQuery)(options));
  var result = (0, _execute.execute)(schema, queryAST);
  !(!result.then && !result.errors && result.data) ? (0, _invariant.default)(0) : void 0;
  return result.data;
}

/***/ }),
/* 2991 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidJSValue = isValidJSValue;

var _coerceValue = __webpack_require__(666);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Deprecated. Use coerceValue() directly for richer information.
 *
 * This function will be removed in v15
 */
function isValidJSValue(value, type) {
  var errors = (0, _coerceValue.coerceValue)(value, type).errors;
  return errors ? errors.map(function (error) {
    return error.message;
  }) : [];
}

/***/ }),
/* 2992 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isValidLiteralValue = isValidLiteralValue;

var _TypeInfo = __webpack_require__(346);

var _kinds = __webpack_require__(68);

var _visitor = __webpack_require__(245);

var _schema = __webpack_require__(246);

var _ValuesOfCorrectType = __webpack_require__(669);

var _ValidationContext = __webpack_require__(668);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Utility which determines if a value literal node is valid for an input type.
 *
 * Deprecated. Rely on validation for documents containing literal values.
 *
 * This function will be removed in v15
 */
function isValidLiteralValue(type, valueNode) {
  var emptySchema = new _schema.GraphQLSchema({});
  var emptyDoc = {
    kind: _kinds.Kind.DOCUMENT,
    definitions: []
  };
  var typeInfo = new _TypeInfo.TypeInfo(emptySchema, undefined, type);
  var context = new _ValidationContext.ValidationContext(emptySchema, emptyDoc, typeInfo);
  var visitor = (0, _ValuesOfCorrectType.ValuesOfCorrectType)(context);
  (0, _visitor.visit)(valueNode, (0, _visitor.visitWithTypeInfo)(typeInfo, visitor));
  return context.getErrors();
}

/***/ }),
/* 2993 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.lexicographicSortSchema = lexicographicSortSchema;

var _keyValMap = _interopRequireDefault(__webpack_require__(343));

var _objectValues = _interopRequireDefault(__webpack_require__(205));

var _schema = __webpack_require__(246);

var _directives = __webpack_require__(136);

var _definition = __webpack_require__(54);

var _scalars = __webpack_require__(184);

var _introspection = __webpack_require__(166);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Sort GraphQLSchema.
 */
function lexicographicSortSchema(schema) {
  var cache = Object.create(null);

  var sortMaybeType = function sortMaybeType(maybeType) {
    return maybeType && sortNamedType(maybeType);
  };

  return new _schema.GraphQLSchema({
    types: sortTypes((0, _objectValues.default)(schema.getTypeMap())),
    directives: sortByName(schema.getDirectives()).map(sortDirective),
    query: sortMaybeType(schema.getQueryType()),
    mutation: sortMaybeType(schema.getMutationType()),
    subscription: sortMaybeType(schema.getSubscriptionType()),
    astNode: schema.astNode
  });

  function sortDirective(directive) {
    return new _directives.GraphQLDirective({
      name: directive.name,
      description: directive.description,
      locations: sortBy(directive.locations, function (x) {
        return x;
      }),
      args: sortArgs(directive.args),
      astNode: directive.astNode
    });
  }

  function sortArgs(args) {
    return (0, _keyValMap.default)(sortByName(args), function (arg) {
      return arg.name;
    }, function (arg) {
      return _objectSpread({}, arg, {
        type: sortType(arg.type)
      });
    });
  }

  function sortFields(fieldsMap) {
    return sortObjMap(fieldsMap, function (field) {
      return {
        type: sortType(field.type),
        args: sortArgs(field.args),
        resolve: field.resolve,
        subscribe: field.subscribe,
        deprecationReason: field.deprecationReason,
        description: field.description,
        astNode: field.astNode
      };
    });
  }

  function sortInputFields(fieldsMap) {
    return sortObjMap(fieldsMap, function (field) {
      return {
        type: sortType(field.type),
        defaultValue: field.defaultValue,
        description: field.description,
        astNode: field.astNode
      };
    });
  }

  function sortType(type) {
    if ((0, _definition.isListType)(type)) {
      return new _definition.GraphQLList(sortType(type.ofType));
    } else if ((0, _definition.isNonNullType)(type)) {
      return new _definition.GraphQLNonNull(sortType(type.ofType));
    }

    return sortNamedType(type);
  }

  function sortTypes(arr) {
    return sortByName(arr).map(sortNamedType);
  }

  function sortNamedType(type) {
    if ((0, _scalars.isSpecifiedScalarType)(type) || (0, _introspection.isIntrospectionType)(type)) {
      return type;
    }

    var sortedType = cache[type.name];

    if (!sortedType) {
      sortedType = sortNamedTypeImpl(type);
      cache[type.name] = sortedType;
    }

    return sortedType;
  }

  function sortNamedTypeImpl(type) {
    if ((0, _definition.isScalarType)(type)) {
      return type;
    } else if ((0, _definition.isObjectType)(type)) {
      return new _definition.GraphQLObjectType({
        name: type.name,
        interfaces: function interfaces() {
          return sortTypes(type.getInterfaces());
        },
        fields: function fields() {
          return sortFields(type.getFields());
        },
        isTypeOf: type.isTypeOf,
        description: type.description,
        astNode: type.astNode,
        extensionASTNodes: type.extensionASTNodes
      });
    } else if ((0, _definition.isInterfaceType)(type)) {
      return new _definition.GraphQLInterfaceType({
        name: type.name,
        fields: function fields() {
          return sortFields(type.getFields());
        },
        resolveType: type.resolveType,
        description: type.description,
        astNode: type.astNode,
        extensionASTNodes: type.extensionASTNodes
      });
    } else if ((0, _definition.isUnionType)(type)) {
      return new _definition.GraphQLUnionType({
        name: type.name,
        types: function types() {
          return sortTypes(type.getTypes());
        },
        resolveType: type.resolveType,
        description: type.description,
        astNode: type.astNode
      });
    } else if ((0, _definition.isEnumType)(type)) {
      return new _definition.GraphQLEnumType({
        name: type.name,
        values: (0, _keyValMap.default)(sortByName(type.getValues()), function (val) {
          return val.name;
        }, function (val) {
          return {
            value: val.value,
            deprecationReason: val.deprecationReason,
            description: val.description,
            astNode: val.astNode
          };
        }),
        description: type.description,
        astNode: type.astNode
      });
    } else if ((0, _definition.isInputObjectType)(type)) {
      return new _definition.GraphQLInputObjectType({
        name: type.name,
        fields: function fields() {
          return sortInputFields(type.getFields());
        },
        description: type.description,
        astNode: type.astNode
      });
    }

    throw new Error("Unknown type: \"".concat(type, "\""));
  }
}

function sortObjMap(map, sortValueFn) {
  var sortedMap = Object.create(null);
  var sortedKeys = sortBy(Object.keys(map), function (x) {
    return x;
  });

  for (var _i = 0; _i < sortedKeys.length; _i++) {
    var key = sortedKeys[_i];
    var value = map[key];
    sortedMap[key] = sortValueFn ? sortValueFn(value) : value;
  }

  return sortedMap;
}

function sortByName(array) {
  return sortBy(array, function (obj) {
    return obj.name;
  });
}

function sortBy(array, mapToKey) {
  return array.slice().sort(function (obj1, obj2) {
    var key1 = mapToKey(obj1);
    var key2 = mapToKey(obj2);
    return key1.localeCompare(key2);
  });
}

/***/ }),
/* 2994 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.printSchema = printSchema;
exports.printIntrospectionSchema = printIntrospectionSchema;
exports.printType = printType;

var _isNullish = _interopRequireDefault(__webpack_require__(660));

var _isInvalid = _interopRequireDefault(__webpack_require__(204));

var _objectValues = _interopRequireDefault(__webpack_require__(205));

var _astFromValue = __webpack_require__(665);

var _printer = __webpack_require__(165);

var _definition = __webpack_require__(54);

var _scalars = __webpack_require__(184);

var _directives = __webpack_require__(136);

var _introspection = __webpack_require__(166);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * Accepts options as a second argument:
 *
 *    - commentDescriptions:
 *        Provide true to use preceding comments as the description.
 *
 */
function printSchema(schema, options) {
  return printFilteredSchema(schema, function (n) {
    return !(0, _directives.isSpecifiedDirective)(n);
  }, isDefinedType, options);
}

function printIntrospectionSchema(schema, options) {
  return printFilteredSchema(schema, _directives.isSpecifiedDirective, _introspection.isIntrospectionType, options);
}

function isDefinedType(type) {
  return !(0, _scalars.isSpecifiedScalarType)(type) && !(0, _introspection.isIntrospectionType)(type);
}

function printFilteredSchema(schema, directiveFilter, typeFilter, options) {
  var directives = schema.getDirectives().filter(directiveFilter);
  var typeMap = schema.getTypeMap();
  var types = (0, _objectValues.default)(typeMap).sort(function (type1, type2) {
    return type1.name.localeCompare(type2.name);
  }).filter(typeFilter);
  return [printSchemaDefinition(schema)].concat(directives.map(function (directive) {
    return printDirective(directive, options);
  }), types.map(function (type) {
    return printType(type, options);
  })).filter(Boolean).join('\n\n') + '\n';
}

function printSchemaDefinition(schema) {
  if (isSchemaOfCommonNames(schema)) {
    return;
  }

  var operationTypes = [];
  var queryType = schema.getQueryType();

  if (queryType) {
    operationTypes.push("  query: ".concat(queryType.name));
  }

  var mutationType = schema.getMutationType();

  if (mutationType) {
    operationTypes.push("  mutation: ".concat(mutationType.name));
  }

  var subscriptionType = schema.getSubscriptionType();

  if (subscriptionType) {
    operationTypes.push("  subscription: ".concat(subscriptionType.name));
  }

  return "schema {\n".concat(operationTypes.join('\n'), "\n}");
}
/**
 * GraphQL schema define root types for each type of operation. These types are
 * the same as any other type and can be named in any manner, however there is
 * a common naming convention:
 *
 *   schema {
 *     query: Query
 *     mutation: Mutation
 *   }
 *
 * When using this naming convention, the schema description can be omitted.
 */


function isSchemaOfCommonNames(schema) {
  var queryType = schema.getQueryType();

  if (queryType && queryType.name !== 'Query') {
    return false;
  }

  var mutationType = schema.getMutationType();

  if (mutationType && mutationType.name !== 'Mutation') {
    return false;
  }

  var subscriptionType = schema.getSubscriptionType();

  if (subscriptionType && subscriptionType.name !== 'Subscription') {
    return false;
  }

  return true;
}

function printType(type, options) {
  if ((0, _definition.isScalarType)(type)) {
    return printScalar(type, options);
  } else if ((0, _definition.isObjectType)(type)) {
    return printObject(type, options);
  } else if ((0, _definition.isInterfaceType)(type)) {
    return printInterface(type, options);
  } else if ((0, _definition.isUnionType)(type)) {
    return printUnion(type, options);
  } else if ((0, _definition.isEnumType)(type)) {
    return printEnum(type, options);
  } else if ((0, _definition.isInputObjectType)(type)) {
    return printInputObject(type, options);
  }
  /* istanbul ignore next */


  throw new Error("Unknown type: ".concat(type, "."));
}

function printScalar(type, options) {
  return printDescription(options, type) + "scalar ".concat(type.name);
}

function printObject(type, options) {
  var interfaces = type.getInterfaces();
  var implementedInterfaces = interfaces.length ? ' implements ' + interfaces.map(function (i) {
    return i.name;
  }).join(' & ') : '';
  return printDescription(options, type) + "type ".concat(type.name).concat(implementedInterfaces, " {\n") + printFields(options, type) + '\n' + '}';
}

function printInterface(type, options) {
  return printDescription(options, type) + "interface ".concat(type.name, " {\n") + printFields(options, type) + '\n' + '}';
}

function printUnion(type, options) {
  return printDescription(options, type) + "union ".concat(type.name, " = ").concat(type.getTypes().join(' | '));
}

function printEnum(type, options) {
  return printDescription(options, type) + "enum ".concat(type.name, " {\n") + printEnumValues(type.getValues(), options) + '\n' + '}';
}

function printEnumValues(values, options) {
  return values.map(function (value, i) {
    return printDescription(options, value, '  ', !i) + '  ' + value.name + printDeprecated(value);
  }).join('\n');
}

function printInputObject(type, options) {
  var fields = (0, _objectValues.default)(type.getFields());
  return printDescription(options, type) + "input ".concat(type.name, " {\n") + fields.map(function (f, i) {
    return printDescription(options, f, '  ', !i) + '  ' + printInputValue(f);
  }).join('\n') + '\n' + '}';
}

function printFields(options, type) {
  var fields = (0, _objectValues.default)(type.getFields());
  return fields.map(function (f, i) {
    return printDescription(options, f, '  ', !i) + '  ' + f.name + printArgs(options, f.args, '  ') + ': ' + String(f.type) + printDeprecated(f);
  }).join('\n');
}

function printArgs(options, args) {
  var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if (args.length === 0) {
    return '';
  } // If every arg does not have a description, print them on one line.


  if (args.every(function (arg) {
    return !arg.description;
  })) {
    return '(' + args.map(printInputValue).join(', ') + ')';
  }

  return '(\n' + args.map(function (arg, i) {
    return printDescription(options, arg, '  ' + indentation, !i) + '  ' + indentation + printInputValue(arg);
  }).join('\n') + '\n' + indentation + ')';
}

function printInputValue(arg) {
  var argDecl = arg.name + ': ' + String(arg.type);

  if (!(0, _isInvalid.default)(arg.defaultValue)) {
    argDecl += " = ".concat((0, _printer.print)((0, _astFromValue.astFromValue)(arg.defaultValue, arg.type)));
  }

  return argDecl;
}

function printDirective(directive, options) {
  return printDescription(options, directive) + 'directive @' + directive.name + printArgs(options, directive.args) + ' on ' + directive.locations.join(' | ');
}

function printDeprecated(fieldOrEnumVal) {
  if (!fieldOrEnumVal.isDeprecated) {
    return '';
  }

  var reason = fieldOrEnumVal.deprecationReason;

  if ((0, _isNullish.default)(reason) || reason === '' || reason === _directives.DEFAULT_DEPRECATION_REASON) {
    return ' @deprecated';
  }

  return ' @deprecated(reason: ' + (0, _printer.print)((0, _astFromValue.astFromValue)(reason, _scalars.GraphQLString)) + ')';
}

function printDescription(options, def) {
  var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var firstInBlock = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

  if (!def.description) {
    return '';
  }

  var lines = descriptionLines(def.description, 120 - indentation.length);

  if (options && options.commentDescriptions) {
    return printDescriptionWithComments(lines, indentation, firstInBlock);
  }

  var description = indentation && !firstInBlock ? '\n' + indentation + '"""' : indentation + '"""'; // In some circumstances, a single line can be used for the description.

  if (lines.length === 1 && lines[0].length < 70 && lines[0][lines[0].length - 1] !== '"') {
    return description + escapeQuote(lines[0]) + '"""\n';
  } // Format a multi-line block quote to account for leading space.


  var hasLeadingSpace = lines[0][0] === ' ' || lines[0][0] === '\t';

  if (!hasLeadingSpace) {
    description += '\n';
  }

  for (var i = 0; i < lines.length; i++) {
    if (i !== 0 || !hasLeadingSpace) {
      description += indentation;
    }

    description += escapeQuote(lines[i]) + '\n';
  }

  description += indentation + '"""\n';
  return description;
}

function escapeQuote(line) {
  return line.replace(/"""/g, '\\"""');
}

function printDescriptionWithComments(lines, indentation, firstInBlock) {
  var description = indentation && !firstInBlock ? '\n' : '';

  for (var i = 0; i < lines.length; i++) {
    if (lines[i] === '') {
      description += indentation + '#\n';
    } else {
      description += indentation + '# ' + lines[i] + '\n';
    }
  }

  return description;
}

function descriptionLines(description, maxLen) {
  var lines = [];
  var rawLines = description.split('\n');

  for (var i = 0; i < rawLines.length; i++) {
    if (rawLines[i] === '') {
      lines.push(rawLines[i]);
    } else {
      // For > 120 character long lines, cut at space boundaries into sublines
      // of ~80 chars.
      var sublines = breakLine(rawLines[i], maxLen);

      for (var j = 0; j < sublines.length; j++) {
        lines.push(sublines[j]);
      }
    }
  }

  return lines;
}

function breakLine(line, maxLen) {
  if (line.length < maxLen + 5) {
    return [line];
  }

  var parts = line.split(new RegExp("((?: |^).{15,".concat(maxLen - 40, "}(?= |$))")));

  if (parts.length < 4) {
    return [line];
  }

  var sublines = [parts[0] + parts[1] + parts[2]];

  for (var i = 3; i < parts.length; i += 2) {
    sublines.push(parts[i].slice(1) + parts[i + 1]);
  }

  return sublines;
}

/***/ }),
/* 2995 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.separateOperations = separateOperations;

var _visitor = __webpack_require__(245);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */

/**
 * separateOperations accepts a single AST document which may contain many
 * operations and fragments and returns a collection of AST documents each of
 * which contains a single operation as well the fragment definitions it
 * refers to.
 */
function separateOperations(documentAST) {
  var operations = [];
  var fragments = Object.create(null);
  var positions = new Map();
  var depGraph = Object.create(null);
  var fromName;
  var idx = 0; // Populate metadata and build a dependency graph.

  (0, _visitor.visit)(documentAST, {
    OperationDefinition: function OperationDefinition(node) {
      fromName = opName(node);
      operations.push(node);
      positions.set(node, idx++);
    },
    FragmentDefinition: function FragmentDefinition(node) {
      fromName = node.name.value;
      fragments[fromName] = node;
      positions.set(node, idx++);
    },
    FragmentSpread: function FragmentSpread(node) {
      var toName = node.name.value;
      (depGraph[fromName] || (depGraph[fromName] = Object.create(null)))[toName] = true;
    }
  }); // For each operation, produce a new synthesized AST which includes only what
  // is necessary for completing that operation.

  var separatedDocumentASTs = Object.create(null);

  for (var _i = 0; _i < operations.length; _i++) {
    var operation = operations[_i];
    var operationName = opName(operation);
    var dependencies = Object.create(null);
    collectTransitiveDependencies(dependencies, depGraph, operationName); // The list of definition nodes to be included for this operation, sorted
    // to retain the same order as the original document.

    var definitions = [operation];

    var _arr = Object.keys(dependencies);

    for (var _i2 = 0; _i2 < _arr.length; _i2++) {
      var name = _arr[_i2];
      definitions.push(fragments[name]);
    }

    definitions.sort(function (n1, n2) {
      return (positions.get(n1) || 0) - (positions.get(n2) || 0);
    });
    separatedDocumentASTs[operationName] = {
      kind: 'Document',
      definitions: definitions
    };
  }

  return separatedDocumentASTs;
}

// Provides the empty string for anonymous operations.
function opName(operation) {
  return operation.name ? operation.name.value : '';
} // From a dependency graph, collects a list of transitive dependencies by
// recursing through a dependency graph.


function collectTransitiveDependencies(collected, depGraph, fromName) {
  var immediateDeps = depGraph[fromName];

  if (immediateDeps) {
    var _arr2 = Object.keys(immediateDeps);

    for (var _i3 = 0; _i3 < _arr2.length; _i3++) {
      var toName = _arr2[_i3];

      if (!collected[toName]) {
        collected[toName] = true;
        collectTransitiveDependencies(collected, depGraph, toName);
      }
    }
  }
}

/***/ }),
/* 2996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "validate", {
  enumerable: true,
  get: function get() {
    return _validate.validate;
  }
});
Object.defineProperty(exports, "ValidationContext", {
  enumerable: true,
  get: function get() {
    return _ValidationContext.ValidationContext;
  }
});
Object.defineProperty(exports, "specifiedRules", {
  enumerable: true,
  get: function get() {
    return _specifiedRules.specifiedRules;
  }
});
Object.defineProperty(exports, "FieldsOnCorrectTypeRule", {
  enumerable: true,
  get: function get() {
    return _FieldsOnCorrectType.FieldsOnCorrectType;
  }
});
Object.defineProperty(exports, "FragmentsOnCompositeTypesRule", {
  enumerable: true,
  get: function get() {
    return _FragmentsOnCompositeTypes.FragmentsOnCompositeTypes;
  }
});
Object.defineProperty(exports, "KnownArgumentNamesRule", {
  enumerable: true,
  get: function get() {
    return _KnownArgumentNames.KnownArgumentNames;
  }
});
Object.defineProperty(exports, "KnownDirectivesRule", {
  enumerable: true,
  get: function get() {
    return _KnownDirectives.KnownDirectives;
  }
});
Object.defineProperty(exports, "KnownFragmentNamesRule", {
  enumerable: true,
  get: function get() {
    return _KnownFragmentNames.KnownFragmentNames;
  }
});
Object.defineProperty(exports, "KnownTypeNamesRule", {
  enumerable: true,
  get: function get() {
    return _KnownTypeNames.KnownTypeNames;
  }
});
Object.defineProperty(exports, "LoneAnonymousOperationRule", {
  enumerable: true,
  get: function get() {
    return _LoneAnonymousOperation.LoneAnonymousOperation;
  }
});
Object.defineProperty(exports, "NoFragmentCyclesRule", {
  enumerable: true,
  get: function get() {
    return _NoFragmentCycles.NoFragmentCycles;
  }
});
Object.defineProperty(exports, "NoUndefinedVariablesRule", {
  enumerable: true,
  get: function get() {
    return _NoUndefinedVariables.NoUndefinedVariables;
  }
});
Object.defineProperty(exports, "NoUnusedFragmentsRule", {
  enumerable: true,
  get: function get() {
    return _NoUnusedFragments.NoUnusedFragments;
  }
});
Object.defineProperty(exports, "NoUnusedVariablesRule", {
  enumerable: true,
  get: function get() {
    return _NoUnusedVariables.NoUnusedVariables;
  }
});
Object.defineProperty(exports, "OverlappingFieldsCanBeMergedRule", {
  enumerable: true,
  get: function get() {
    return _OverlappingFieldsCanBeMerged.OverlappingFieldsCanBeMerged;
  }
});
Object.defineProperty(exports, "PossibleFragmentSpreadsRule", {
  enumerable: true,
  get: function get() {
    return _PossibleFragmentSpreads.PossibleFragmentSpreads;
  }
});
Object.defineProperty(exports, "ProvidedRequiredArgumentsRule", {
  enumerable: true,
  get: function get() {
    return _ProvidedRequiredArguments.ProvidedRequiredArguments;
  }
});
Object.defineProperty(exports, "ScalarLeafsRule", {
  enumerable: true,
  get: function get() {
    return _ScalarLeafs.ScalarLeafs;
  }
});
Object.defineProperty(exports, "SingleFieldSubscriptionsRule", {
  enumerable: true,
  get: function get() {
    return _SingleFieldSubscriptions.SingleFieldSubscriptions;
  }
});
Object.defineProperty(exports, "UniqueArgumentNamesRule", {
  enumerable: true,
  get: function get() {
    return _UniqueArgumentNames.UniqueArgumentNames;
  }
});
Object.defineProperty(exports, "UniqueDirectivesPerLocationRule", {
  enumerable: true,
  get: function get() {
    return _UniqueDirectivesPerLocation.UniqueDirectivesPerLocation;
  }
});
Object.defineProperty(exports, "UniqueFragmentNamesRule", {
  enumerable: true,
  get: function get() {
    return _UniqueFragmentNames.UniqueFragmentNames;
  }
});
Object.defineProperty(exports, "UniqueInputFieldNamesRule", {
  enumerable: true,
  get: function get() {
    return _UniqueInputFieldNames.UniqueInputFieldNames;
  }
});
Object.defineProperty(exports, "UniqueOperationNamesRule", {
  enumerable: true,
  get: function get() {
    return _UniqueOperationNames.UniqueOperationNames;
  }
});
Object.defineProperty(exports, "UniqueVariableNamesRule", {
  enumerable: true,
  get: function get() {
    return _UniqueVariableNames.UniqueVariableNames;
  }
});
Object.defineProperty(exports, "ValuesOfCorrectTypeRule", {
  enumerable: true,
  get: function get() {
    return _ValuesOfCorrectType.ValuesOfCorrectType;
  }
});
Object.defineProperty(exports, "VariablesAreInputTypesRule", {
  enumerable: true,
  get: function get() {
    return _VariablesAreInputTypes.VariablesAreInputTypes;
  }
});
Object.defineProperty(exports, "VariablesInAllowedPositionRule", {
  enumerable: true,
  get: function get() {
    return _VariablesInAllowedPosition.VariablesInAllowedPosition;
  }
});

var _validate = __webpack_require__(443);

var _ValidationContext = __webpack_require__(668);

var _specifiedRules = __webpack_require__(1237);

var _FieldsOnCorrectType = __webpack_require__(1213);

var _FragmentsOnCompositeTypes = __webpack_require__(1214);

var _KnownArgumentNames = __webpack_require__(1215);

var _KnownDirectives = __webpack_require__(1216);

var _KnownFragmentNames = __webpack_require__(1217);

var _KnownTypeNames = __webpack_require__(1218);

var _LoneAnonymousOperation = __webpack_require__(1219);

var _NoFragmentCycles = __webpack_require__(1220);

var _NoUndefinedVariables = __webpack_require__(1221);

var _NoUnusedFragments = __webpack_require__(1222);

var _NoUnusedVariables = __webpack_require__(1223);

var _OverlappingFieldsCanBeMerged = __webpack_require__(1224);

var _PossibleFragmentSpreads = __webpack_require__(1225);

var _ProvidedRequiredArguments = __webpack_require__(1226);

var _ScalarLeafs = __webpack_require__(1227);

var _SingleFieldSubscriptions = __webpack_require__(1228);

var _UniqueArgumentNames = __webpack_require__(1229);

var _UniqueDirectivesPerLocation = __webpack_require__(1230);

var _UniqueFragmentNames = __webpack_require__(1231);

var _UniqueInputFieldNames = __webpack_require__(1232);

var _UniqueOperationNames = __webpack_require__(1233);

var _UniqueVariableNames = __webpack_require__(1234);

var _ValuesOfCorrectType = __webpack_require__(669);

var _VariablesAreInputTypes = __webpack_require__(1235);

var _VariablesInAllowedPosition = __webpack_require__(1236);

/***/ }),
/* 2997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nonExecutableDefinitionMessage = nonExecutableDefinitionMessage;
exports.ExecutableDefinitions = ExecutableDefinitions;

var _GraphQLError = __webpack_require__(37);

var _kinds = __webpack_require__(68);

var _predicates = __webpack_require__(439);

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function nonExecutableDefinitionMessage(defName) {
  return "The ".concat(defName, " definition is not executable.");
}
/**
 * Executable definitions
 *
 * A GraphQL document is only valid for execution if all definitions are either
 * operation or fragment definitions.
 */


function ExecutableDefinitions(context) {
  return {
    Document: function Document(node) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = node.definitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var definition = _step.value;

          if (!(0, _predicates.isExecutableDefinitionNode)(definition)) {
            context.reportError(new _GraphQLError.GraphQLError(nonExecutableDefinitionMessage(definition.kind === _kinds.Kind.SCHEMA_DEFINITION || definition.kind === _kinds.Kind.SCHEMA_EXTENSION ? 'schema' : definition.name.value), [definition]));
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return false;
    }
  };
}

/***/ }),
/* 2998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.schemaDefinitionNotAloneMessage = schemaDefinitionNotAloneMessage;
exports.canNotDefineSchemaWithinExtensionMessage = canNotDefineSchemaWithinExtensionMessage;
exports.LoneSchemaDefinition = LoneSchemaDefinition;

var _GraphQLError = __webpack_require__(37);

/**
 * Copyright (c) 2018-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *  strict
 */
function schemaDefinitionNotAloneMessage() {
  return 'Must provide only one schema definition.';
}

function canNotDefineSchemaWithinExtensionMessage() {
  return 'Cannot define a new schema within a schema extension.';
}
/**
 * Lone Schema definition
 *
 * A GraphQL document is only valid if it contains only one schema definition.
 */


function LoneSchemaDefinition(context) {
  var oldSchema = context.getSchema();
  var alreadyDefined = oldSchema && (oldSchema.astNode || oldSchema.getQueryType() || oldSchema.getMutationType() || oldSchema.getSubscriptionType());
  var schemaDefinitionsCount = 0;
  return {
    SchemaDefinition: function SchemaDefinition(node) {
      if (alreadyDefined) {
        context.reportError(new _GraphQLError.GraphQLError(canNotDefineSchemaWithinExtensionMessage(), node));
        return;
      }

      if (schemaDefinitionsCount > 0) {
        context.reportError(new _GraphQLError.GraphQLError(schemaDefinitionNotAloneMessage(), node));
      }

      ++schemaDefinitionsCount;
    }
  };
}

/***/ }),
/* 2999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(3000);

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 3000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 3001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(167);
var assert = __webpack_require__(137);

function Hmac(hash, key, enc) {
  if (!(this instanceof Hmac))
    return new Hmac(hash, key, enc);
  this.Hash = hash;
  this.blockSize = hash.blockSize / 8;
  this.outSize = hash.outSize / 8;
  this.inner = null;
  this.outer = null;

  this._init(utils.toArray(key, enc));
}
module.exports = Hmac;

Hmac.prototype._init = function init(key) {
  // Shorten key, if needed
  if (key.length > this.blockSize)
    key = new this.Hash().update(key).digest();
  assert(key.length <= this.blockSize);

  // Add padding to key
  for (var i = key.length; i < this.blockSize; i++)
    key.push(0);

  for (i = 0; i < key.length; i++)
    key[i] ^= 0x36;
  this.inner = new this.Hash().update(key);

  // 0x36 ^ 0x5c = 0x6a
  for (i = 0; i < key.length; i++)
    key[i] ^= 0x6a;
  this.outer = new this.Hash().update(key);
};

Hmac.prototype.update = function update(msg, enc) {
  this.inner.update(msg, enc);
  return this;
};

Hmac.prototype.digest = function digest(enc) {
  this.outer.update(this.inner.digest());
  return this.outer.digest(enc);
};


/***/ }),
/* 3002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(167);
var common = __webpack_require__(347);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_3 = utils.sum32_3;
var sum32_4 = utils.sum32_4;
var BlockHash = common.BlockHash;

function RIPEMD160() {
  if (!(this instanceof RIPEMD160))
    return new RIPEMD160();

  BlockHash.call(this);

  this.h = [ 0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0 ];
  this.endian = 'little';
}
utils.inherits(RIPEMD160, BlockHash);
exports.ripemd160 = RIPEMD160;

RIPEMD160.blockSize = 512;
RIPEMD160.outSize = 160;
RIPEMD160.hmacStrength = 192;
RIPEMD160.padLength = 64;

RIPEMD160.prototype._update = function update(msg, start) {
  var A = this.h[0];
  var B = this.h[1];
  var C = this.h[2];
  var D = this.h[3];
  var E = this.h[4];
  var Ah = A;
  var Bh = B;
  var Ch = C;
  var Dh = D;
  var Eh = E;
  for (var j = 0; j < 80; j++) {
    var T = sum32(
      rotl32(
        sum32_4(A, f(j, B, C, D), msg[r[j] + start], K(j)),
        s[j]),
      E);
    A = E;
    E = D;
    D = rotl32(C, 10);
    C = B;
    B = T;
    T = sum32(
      rotl32(
        sum32_4(Ah, f(79 - j, Bh, Ch, Dh), msg[rh[j] + start], Kh(j)),
        sh[j]),
      Eh);
    Ah = Eh;
    Eh = Dh;
    Dh = rotl32(Ch, 10);
    Ch = Bh;
    Bh = T;
  }
  T = sum32_3(this.h[1], C, Dh);
  this.h[1] = sum32_3(this.h[2], D, Eh);
  this.h[2] = sum32_3(this.h[3], E, Ah);
  this.h[3] = sum32_3(this.h[4], A, Bh);
  this.h[4] = sum32_3(this.h[0], B, Ch);
  this.h[0] = T;
};

RIPEMD160.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'little');
  else
    return utils.split32(this.h, 'little');
};

function f(j, x, y, z) {
  if (j <= 15)
    return x ^ y ^ z;
  else if (j <= 31)
    return (x & y) | ((~x) & z);
  else if (j <= 47)
    return (x | (~y)) ^ z;
  else if (j <= 63)
    return (x & z) | (y & (~z));
  else
    return x ^ (y | (~z));
}

function K(j) {
  if (j <= 15)
    return 0x00000000;
  else if (j <= 31)
    return 0x5a827999;
  else if (j <= 47)
    return 0x6ed9eba1;
  else if (j <= 63)
    return 0x8f1bbcdc;
  else
    return 0xa953fd4e;
}

function Kh(j) {
  if (j <= 15)
    return 0x50a28be6;
  else if (j <= 31)
    return 0x5c4dd124;
  else if (j <= 47)
    return 0x6d703ef3;
  else if (j <= 63)
    return 0x7a6d76e9;
  else
    return 0x00000000;
}

var r = [
  0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15,
  7, 4, 13, 1, 10, 6, 15, 3, 12, 0, 9, 5, 2, 14, 11, 8,
  3, 10, 14, 4, 9, 15, 8, 1, 2, 7, 0, 6, 13, 11, 5, 12,
  1, 9, 11, 10, 0, 8, 12, 4, 13, 3, 7, 15, 14, 5, 6, 2,
  4, 0, 5, 9, 7, 12, 2, 10, 14, 1, 3, 8, 11, 6, 15, 13
];

var rh = [
  5, 14, 7, 0, 9, 2, 11, 4, 13, 6, 15, 8, 1, 10, 3, 12,
  6, 11, 3, 7, 0, 13, 5, 10, 14, 15, 8, 12, 4, 9, 1, 2,
  15, 5, 1, 3, 7, 14, 6, 9, 11, 8, 12, 2, 10, 0, 4, 13,
  8, 6, 4, 1, 3, 11, 15, 0, 5, 12, 2, 13, 9, 7, 10, 14,
  12, 15, 10, 4, 1, 5, 8, 7, 6, 2, 13, 14, 0, 3, 9, 11
];

var s = [
  11, 14, 15, 12, 5, 8, 7, 9, 11, 13, 14, 15, 6, 7, 9, 8,
  7, 6, 8, 13, 11, 9, 7, 15, 7, 12, 15, 9, 11, 7, 13, 12,
  11, 13, 6, 7, 14, 9, 13, 15, 14, 8, 13, 6, 5, 12, 7, 5,
  11, 12, 14, 15, 14, 15, 9, 8, 9, 14, 5, 6, 8, 6, 5, 12,
  9, 15, 5, 11, 6, 8, 13, 12, 5, 12, 13, 14, 11, 8, 5, 6
];

var sh = [
  8, 9, 9, 11, 13, 15, 15, 5, 7, 7, 8, 11, 14, 14, 12, 6,
  9, 13, 15, 7, 12, 8, 9, 11, 7, 7, 12, 7, 6, 15, 13, 11,
  9, 7, 15, 11, 8, 6, 6, 14, 12, 13, 5, 14, 13, 13, 7, 5,
  15, 5, 8, 11, 14, 14, 6, 14, 6, 9, 12, 9, 12, 5, 15, 8,
  8, 5, 12, 9, 12, 5, 14, 6, 8, 13, 6, 5, 15, 13, 11, 11
];


/***/ }),
/* 3003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.sha1 = __webpack_require__(3004);
exports.sha224 = __webpack_require__(3005);
exports.sha256 = __webpack_require__(1239);
exports.sha384 = __webpack_require__(3006);
exports.sha512 = __webpack_require__(1240);


/***/ }),
/* 3004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(167);
var common = __webpack_require__(347);
var shaCommon = __webpack_require__(1241);

var rotl32 = utils.rotl32;
var sum32 = utils.sum32;
var sum32_5 = utils.sum32_5;
var ft_1 = shaCommon.ft_1;
var BlockHash = common.BlockHash;

var sha1_K = [
  0x5A827999, 0x6ED9EBA1,
  0x8F1BBCDC, 0xCA62C1D6
];

function SHA1() {
  if (!(this instanceof SHA1))
    return new SHA1();

  BlockHash.call(this);
  this.h = [
    0x67452301, 0xefcdab89, 0x98badcfe,
    0x10325476, 0xc3d2e1f0 ];
  this.W = new Array(80);
}

utils.inherits(SHA1, BlockHash);
module.exports = SHA1;

SHA1.blockSize = 512;
SHA1.outSize = 160;
SHA1.hmacStrength = 80;
SHA1.padLength = 64;

SHA1.prototype._update = function _update(msg, start) {
  var W = this.W;

  for (var i = 0; i < 16; i++)
    W[i] = msg[start + i];

  for(; i < W.length; i++)
    W[i] = rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);

  var a = this.h[0];
  var b = this.h[1];
  var c = this.h[2];
  var d = this.h[3];
  var e = this.h[4];

  for (i = 0; i < W.length; i++) {
    var s = ~~(i / 20);
    var t = sum32_5(rotl32(a, 5), ft_1(s, b, c, d), e, W[i], sha1_K[s]);
    e = d;
    d = c;
    c = rotl32(b, 30);
    b = a;
    a = t;
  }

  this.h[0] = sum32(this.h[0], a);
  this.h[1] = sum32(this.h[1], b);
  this.h[2] = sum32(this.h[2], c);
  this.h[3] = sum32(this.h[3], d);
  this.h[4] = sum32(this.h[4], e);
};

SHA1.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h, 'big');
  else
    return utils.split32(this.h, 'big');
};


/***/ }),
/* 3005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(167);
var SHA256 = __webpack_require__(1239);

function SHA224() {
  if (!(this instanceof SHA224))
    return new SHA224();

  SHA256.call(this);
  this.h = [
    0xc1059ed8, 0x367cd507, 0x3070dd17, 0xf70e5939,
    0xffc00b31, 0x68581511, 0x64f98fa7, 0xbefa4fa4 ];
}
utils.inherits(SHA224, SHA256);
module.exports = SHA224;

SHA224.blockSize = 512;
SHA224.outSize = 224;
SHA224.hmacStrength = 192;
SHA224.padLength = 64;

SHA224.prototype._digest = function digest(enc) {
  // Just truncate output
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 7), 'big');
  else
    return utils.split32(this.h.slice(0, 7), 'big');
};



/***/ }),
/* 3006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(167);

var SHA512 = __webpack_require__(1240);

function SHA384() {
  if (!(this instanceof SHA384))
    return new SHA384();

  SHA512.call(this);
  this.h = [
    0xcbbb9d5d, 0xc1059ed8,
    0x629a292a, 0x367cd507,
    0x9159015a, 0x3070dd17,
    0x152fecd8, 0xf70e5939,
    0x67332667, 0xffc00b31,
    0x8eb44a87, 0x68581511,
    0xdb0c2e0d, 0x64f98fa7,
    0x47b5481d, 0xbefa4fa4 ];
}
utils.inherits(SHA384, SHA512);
module.exports = SHA384;

SHA384.blockSize = 1024;
SHA384.outSize = 384;
SHA384.hmacStrength = 192;
SHA384.padLength = 128;

SHA384.prototype._digest = function digest(enc) {
  if (enc === 'hex')
    return utils.toHex32(this.h.slice(0, 12), 'big');
  else
    return utils.split32(this.h.slice(0, 12), 'big');
};


/***/ }),
/* 3007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(436);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),
/* 3008 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
  var currentTurn = 0,
      isDone = false;
  var isSync = false,
      hasNext = false,
      doneArgs = void 0;

  var done = function done() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    isDone = true;

    if (isSync) {
      // Iterate instead of recursing if possible.
      doneArgs = args;
      return;
    }

    callback.apply(undefined, args);
  };

  var next = function next() {
    if (isDone) return;

    hasNext = true;

    if (isSync) return; // Iterate instead of recursing if possible.

    isSync = true;

    while (!isDone && currentTurn < turns && hasNext) {
      hasNext = false;
      work(currentTurn++, next, done);
    }

    isSync = false;

    if (isDone) {
      // This means the loop finished synchronously.
      callback.apply(undefined, doneArgs);
      return;
    }

    if (currentTurn >= turns && hasNext) {
      isDone = true;
      callback();
    }
  };

  next();
};

/***/ }),
/* 3009 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(671);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _warning = __webpack_require__(212);

var _warning2 = _interopRequireDefault(_warning);

var _LocationUtils = __webpack_require__(284);

var _DOMUtils = __webpack_require__(445);

var _DOMStateStorage = __webpack_require__(1242);

var _PathUtils = __webpack_require__(206);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HashChangeEvent = 'hashchange';

var getHashPath = function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
};

var pushHashPath = function pushHashPath(path) {
  return window.location.hash = path;
};

var replaceHashPath = function replaceHashPath(path) {
  var hashIndex = window.location.href.indexOf('#');

  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
};

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
  var path = pathCoder.decodePath(getHashPath());
  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);

  var state = void 0;
  if (key) {
    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
    state = (0, _DOMStateStorage.readState)(key);
  }

  var init = (0, _PathUtils.parsePath)(path);
  init.state = state;

  return (0, _LocationUtils.createLocation)(init, undefined, key);
};

var prevLocation = void 0;

var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
  var handleHashChange = function handleHashChange() {
    var path = getHashPath();
    var encodedPath = pathCoder.encodePath(path);

    if (path !== encodedPath) {
      // Always be sure we have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var currentLocation = getCurrentLocation(pathCoder, queryKey);

      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events

      prevLocation = currentLocation;

      listener(currentLocation);
    }
  };

  // Ensure the hash is encoded properly.
  var path = getHashPath();
  var encodedPath = pathCoder.encodePath(path);

  if (path !== encodedPath) replaceHashPath(encodedPath);

  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
  };
};

var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
  var state = location.state,
      key = location.key;


  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));

  if (state !== undefined) {
    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
    (0, _DOMStateStorage.saveState)(key, state);
  }

  prevLocation = location;

  updateHash(path);
};

var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) {
      pushHashPath(path);
    } else {
       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
    }
  });
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
  return updateLocation(location, pathCoder, queryKey, function (path) {
    if (getHashPath() !== path) replaceHashPath(path);
  });
};

/***/ }),
/* 3010 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;

var _BrowserProtocol = __webpack_require__(671);

Object.defineProperty(exports, 'getUserConfirmation', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.getUserConfirmation;
  }
});
Object.defineProperty(exports, 'go', {
  enumerable: true,
  get: function get() {
    return _BrowserProtocol.go;
  }
});

var _LocationUtils = __webpack_require__(284);

var _PathUtils = __webpack_require__(206);

var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
  return (0, _LocationUtils.createLocation)(window.location);
};

var pushLocation = exports.pushLocation = function pushLocation(location) {
  window.location.href = (0, _PathUtils.createPath)(location);
  return false; // Don't update location
};

var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
  window.location.replace((0, _PathUtils.createPath)(location));
  return false; // Don't update location
};

/***/ }),
/* 3011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(89);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(672);

var _BrowserProtocol = __webpack_require__(671);

var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);

var _RefreshProtocol = __webpack_require__(3010);

var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);

var _DOMUtils = __webpack_require__(445);

var _createHistory = __webpack_require__(673);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates and returns a history object that uses HTML5's history API
 * (pushState, replaceState, and the popstate event) to manage history.
 * This is the recommended method of managing history in browsers because
 * it provides the cleanest URLs.
 *
 * Note: In browsers that do not support the HTML5 history API full
 * page reloads will be used to preserve clean URLs. You can force this
 * behavior using { forceRefresh: true } in options.
 */
var createBrowserHistory = function createBrowserHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;

  var getUserConfirmation = Protocol.getUserConfirmation,
      getCurrentLocation = Protocol.getCurrentLocation,
      pushLocation = Protocol.pushLocation,
      replaceLocation = Protocol.replaceLocation,
      go = Protocol.go;


  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen
  });
};

exports.default = createBrowserHistory;

/***/ }),
/* 3012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(212);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(89);

var _invariant2 = _interopRequireDefault(_invariant);

var _ExecutionEnvironment = __webpack_require__(672);

var _DOMUtils = __webpack_require__(445);

var _HashProtocol = __webpack_require__(3009);

var HashProtocol = _interopRequireWildcard(_HashProtocol);

var _createHistory = __webpack_require__(673);

var _createHistory2 = _interopRequireDefault(_createHistory);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DefaultQueryKey = '_k';

var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
};

var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!' + path;
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substring(1) : path;
    }
  },
  noslash: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '/' ? path.substring(1) : path;
    },
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

var createHashHistory = function createHashHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;

  var queryKey = options.queryKey,
      hashType = options.hashType;


   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;

  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;

  if (hashType == null) hashType = 'slash';

  if (!(hashType in HashPathCoders)) {
     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;

    hashType = 'slash';
  }

  var pathCoder = HashPathCoders[hashType];

  var getUserConfirmation = HashProtocol.getUserConfirmation;


  var getCurrentLocation = function getCurrentLocation() {
    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
  };

  var pushLocation = function pushLocation(location) {
    return HashProtocol.pushLocation(location, pathCoder, queryKey);
  };

  var replaceLocation = function replaceLocation(location) {
    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
  };

  var history = (0, _createHistory2.default)(_extends({
    getUserConfirmation: getUserConfirmation }, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: HashProtocol.go
  }));

  var listenerCount = 0,
      stopListener = void 0;

  var startListener = function startListener(listener, before) {
    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);

    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);

    return function () {
      unlisten();

      if (--listenerCount === 0) stopListener();
    };
  };

  var listenBefore = function listenBefore(listener) {
    return startListener(listener, true);
  };

  var listen = function listen(listener) {
    return startListener(listener, false);
  };

  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();

  var go = function go(n) {
     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;

    history.go(n);
  };

  var createHref = function createHref(path) {
    return '#' + pathCoder.encodePath(history.createHref(path));
  };

  return _extends({}, history, {
    listenBefore: listenBefore,
    listen: listen,
    go: go,
    createHref: createHref
  });
};

exports.default = createHashHistory;

/***/ }),
/* 3013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(212);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(89);

var _invariant2 = _interopRequireDefault(_invariant);

var _LocationUtils = __webpack_require__(284);

var _PathUtils = __webpack_require__(206);

var _createHistory = __webpack_require__(673);

var _createHistory2 = _interopRequireDefault(_createHistory);

var _Actions = __webpack_require__(444);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createStateStorage = function createStateStorage(entries) {
  return entries.filter(function (entry) {
    return entry.state;
  }).reduce(function (memo, entry) {
    memo[entry.key] = entry.state;
    return memo;
  }, {});
};

var createMemoryHistory = function createMemoryHistory() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (Array.isArray(options)) {
    options = { entries: options };
  } else if (typeof options === 'string') {
    options = { entries: [options] };
  }

  var getCurrentLocation = function getCurrentLocation() {
    var entry = entries[current];
    var path = (0, _PathUtils.createPath)(entry);

    var key = void 0,
        state = void 0;
    if (entry.key) {
      key = entry.key;
      state = readState(key);
    }

    var init = (0, _PathUtils.parsePath)(path);

    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
  };

  var canGo = function canGo(n) {
    var index = current + n;
    return index >= 0 && index < entries.length;
  };

  var go = function go(n) {
    if (!n) return;

    if (!canGo(n)) {
       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;

      return;
    }

    current += n;
    var currentLocation = getCurrentLocation();

    // Change action to POP
    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
  };

  var pushLocation = function pushLocation(location) {
    current += 1;

    if (current < entries.length) entries.splice(current);

    entries.push(location);

    saveState(location.key, location.state);
  };

  var replaceLocation = function replaceLocation(location) {
    entries[current] = location;
    saveState(location.key, location.state);
  };

  var history = (0, _createHistory2.default)(_extends({}, options, {
    getCurrentLocation: getCurrentLocation,
    pushLocation: pushLocation,
    replaceLocation: replaceLocation,
    go: go
  }));

  var _options = options,
      entries = _options.entries,
      current = _options.current;


  if (typeof entries === 'string') {
    entries = [entries];
  } else if (!Array.isArray(entries)) {
    entries = ['/'];
  }

  entries = entries.map(function (entry) {
    return (0, _LocationUtils.createLocation)(entry);
  });

  if (current == null) {
    current = entries.length - 1;
  } else {
    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
  }

  var storage = createStateStorage(entries);

  var saveState = function saveState(key, state) {
    return storage[key] = state;
  };

  var readState = function readState(key) {
    return storage[key];
  };

  return _extends({}, history, {
    canGo: canGo
  });
};

exports.default = createMemoryHistory;

/***/ }),
/* 3014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var hash = __webpack_require__(670);
var utils = __webpack_require__(1262);
var assert = __webpack_require__(137);

function HmacDRBG(options) {
  if (!(this instanceof HmacDRBG))
    return new HmacDRBG(options);
  this.hash = options.hash;
  this.predResist = !!options.predResist;

  this.outLen = this.hash.outSize;
  this.minEntropy = options.minEntropy || this.hash.hmacStrength;

  this._reseed = null;
  this.reseedInterval = null;
  this.K = null;
  this.V = null;

  var entropy = utils.toArray(options.entropy, options.entropyEnc || 'hex');
  var nonce = utils.toArray(options.nonce, options.nonceEnc || 'hex');
  var pers = utils.toArray(options.pers, options.persEnc || 'hex');
  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
  this._init(entropy, nonce, pers);
}
module.exports = HmacDRBG;

HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
  var seed = entropy.concat(nonce).concat(pers);

  this.K = new Array(this.outLen / 8);
  this.V = new Array(this.outLen / 8);
  for (var i = 0; i < this.V.length; i++) {
    this.K[i] = 0x00;
    this.V[i] = 0x01;
  }

  this._update(seed);
  this._reseed = 1;
  this.reseedInterval = 0x1000000000000;  // 2^48
};

HmacDRBG.prototype._hmac = function hmac() {
  return new hash.hmac(this.hash, this.K);
};

HmacDRBG.prototype._update = function update(seed) {
  var kmac = this._hmac()
                 .update(this.V)
                 .update([ 0x00 ]);
  if (seed)
    kmac = kmac.update(seed);
  this.K = kmac.digest();
  this.V = this._hmac().update(this.V).digest();
  if (!seed)
    return;

  this.K = this._hmac()
               .update(this.V)
               .update([ 0x01 ])
               .update(seed)
               .digest();
  this.V = this._hmac().update(this.V).digest();
};

HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
  // Optional entropy enc
  if (typeof entropyEnc !== 'string') {
    addEnc = add;
    add = entropyEnc;
    entropyEnc = null;
  }

  entropy = utils.toArray(entropy, entropyEnc);
  add = utils.toArray(add, addEnc);

  assert(entropy.length >= (this.minEntropy / 8),
         'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');

  this._update(entropy.concat(add || []));
  this._reseed = 1;
};

HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
  if (this._reseed > this.reseedInterval)
    throw new Error('Reseed is required');

  // Optional encoding
  if (typeof enc !== 'string') {
    addEnc = add;
    add = enc;
    enc = null;
  }

  // Optional additional data
  if (add) {
    add = utils.toArray(add, addEnc || 'hex');
    this._update(add);
  }

  var temp = [];
  while (temp.length < len) {
    this.V = this._hmac().update(this.V).digest();
    temp = temp.concat(this.V);
  }

  var res = temp.slice(0, len);
  this._update(add);
  this._reseed++;
  return utils.encode(res, enc);
};


/***/ }),
/* 3015 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(466);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }

  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 3016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_void_elements__ = __webpack_require__(3553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_void_elements___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_void_elements__);
var t=/\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;function n(n){var r={type:"tag",name:"",voidElement:!1,attrs:{},children:[]},i=n.match(/<\/?([^\s]+?)[/\s>]/);if(i&&(r.name=i[1],(__WEBPACK_IMPORTED_MODULE_0_void_elements___default.a[i[1]]||"/"===n.charAt(n.length-2))&&(r.voidElement=!0),r.name.startsWith("!--"))){var s=n.indexOf("--\x3e");return{type:"comment",comment:-1!==s?n.slice(4,s):""}}for(var a=new RegExp(t),c=null;null!==(c=a.exec(n));)if(c[0].trim())if(c[1]){var o=c[1].trim(),l=[o,""];o.indexOf("=")>-1&&(l=o.split("=")),r.attrs[l[0]]=l[1],a.lastIndex--}else c[2]&&(r.attrs[c[2]]=c[3].trim().substring(1,c[3].length-1));return r}var r=/<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g,i=/^\s*$/,s=Object.create(null);function a(e,t){switch(t.type){case"text":return e+t.content;case"tag":return e+="<"+t.name+(t.attrs?function(e){var t=[];for(var n in e)t.push(n+'="'+e[n]+'"');return t.length?" "+t.join(" "):""}(t.attrs):"")+(t.voidElement?"/>":">"),t.voidElement?e:e+t.children.reduce(a,"")+"</"+t.name+">";case"comment":return e+"\x3c!--"+t.comment+"--\x3e"}}var c={parse:function(e,t){t||(t={}),t.components||(t.components=s);var a,c=[],o=[],l=-1,m=!1;if(0!==e.indexOf("<")){var u=e.indexOf("<");c.push({type:"text",content:-1===u?e:e.substring(0,u)})}return e.replace(r,function(r,s){if(m){if(r!=="</"+a.name+">")return;m=!1}var u,f="/"!==r.charAt(1),h=r.startsWith("\x3c!--"),p=s+r.length,d=e.charAt(p);if(h){var v=n(r);return l<0?(c.push(v),c):((u=o[l]).children.push(v),c)}if(f&&(l++,"tag"===(a=n(r)).type&&t.components[a.name]&&(a.type="component",m=!0),a.voidElement||m||!d||"<"===d||a.children.push({type:"text",content:e.slice(p,e.indexOf("<",p))}),0===l&&c.push(a),(u=o[l-1])&&u.children.push(a),o[l]=a),(!f||a.voidElement)&&(l>-1&&(a.voidElement||a.name===r.slice(2,-1))&&(l--,a=-1===l?c:o[l]),!m&&"<"!==d&&d)){u=-1===l?c:o[l].children;var x=e.indexOf("<",p),g=e.slice(p,-1===x?void 0:x);i.test(g)&&(g=" "),(x>-1&&l+u.length>=0||" "!==g)&&u.push({type:"text",content:g})}}),c},stringify:function(e){return e.reduce(function(e,t){return e+a("",t)},"")}};/* harmony default export */ __webpack_exports__["a"] = (c);
//# sourceMappingURL=html-parse-stringify.module.js.map


/***/ }),
/* 3017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return Browser; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(529);



var arr = [];
var each = arr.forEach;
var slice = arr.slice;
function defaults(obj) {
  each.call(slice.call(arguments, 1), function (source) {
    if (source) {
      for (var prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}

// eslint-disable-next-line no-control-regex
var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var serializeCookie = function serializeCookie(name, val, options) {
  var opt = options || {};
  opt.path = opt.path || '/';
  var value = encodeURIComponent(val);
  var str = "".concat(name, "=").concat(value);
  if (opt.maxAge > 0) {
    var maxAge = opt.maxAge - 0;
    if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += "; Max-Age=".concat(Math.floor(maxAge));
  }
  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }
    str += "; Domain=".concat(opt.domain);
  }
  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }
    str += "; Path=".concat(opt.path);
  }
  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }
    str += "; Expires=".concat(opt.expires.toUTCString());
  }
  if (opt.httpOnly) str += '; HttpOnly';
  if (opt.secure) str += '; Secure';
  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }
  return str;
};
var cookie = {
  create: function create(name, value, minutes, domain) {
    var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
      path: '/',
      sameSite: 'strict'
    };
    if (minutes) {
      cookieOptions.expires = new Date();
      cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60 * 1000);
    }
    if (domain) cookieOptions.domain = domain;
    document.cookie = serializeCookie(name, encodeURIComponent(value), cookieOptions);
  },
  read: function read(name) {
    var nameEQ = "".concat(name, "=");
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length);
      }
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
  remove: function remove(name) {
    this.create(name, '', -1);
  }
};
var cookie$1 = {
  name: 'cookie',
  lookup: function lookup(options) {
    var found;
    if (options.lookupCookie && typeof document !== 'undefined') {
      var c = cookie.read(options.lookupCookie);
      if (c) found = c;
    }
    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupCookie && typeof document !== 'undefined') {
      cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
  }
};

var querystring = {
  name: 'querystring',
  lookup: function lookup(options) {
    var found;
    if (typeof window !== 'undefined') {
      var search = window.location.search;
      if (!window.location.search && window.location.hash && window.location.hash.indexOf('?') > -1) {
        search = window.location.hash.substring(window.location.hash.indexOf('?'));
      }
      var query = search.substring(1);
      var params = query.split('&');
      for (var i = 0; i < params.length; i++) {
        var pos = params[i].indexOf('=');
        if (pos > 0) {
          var key = params[i].substring(0, pos);
          if (key === options.lookupQuerystring) {
            found = params[i].substring(pos + 1);
          }
        }
      }
    }
    return found;
  }
};

var hasLocalStorageSupport = null;
var localStorageAvailable = function localStorageAvailable() {
  if (hasLocalStorageSupport !== null) return hasLocalStorageSupport;
  try {
    hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
    var testKey = 'i18next.translate.boo';
    window.localStorage.setItem(testKey, 'foo');
    window.localStorage.removeItem(testKey);
  } catch (e) {
    hasLocalStorageSupport = false;
  }
  return hasLocalStorageSupport;
};
var localStorage = {
  name: 'localStorage',
  lookup: function lookup(options) {
    var found;
    if (options.lookupLocalStorage && localStorageAvailable()) {
      var lng = window.localStorage.getItem(options.lookupLocalStorage);
      if (lng) found = lng;
    }
    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupLocalStorage && localStorageAvailable()) {
      window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
  }
};

var hasSessionStorageSupport = null;
var sessionStorageAvailable = function sessionStorageAvailable() {
  if (hasSessionStorageSupport !== null) return hasSessionStorageSupport;
  try {
    hasSessionStorageSupport = window !== 'undefined' && window.sessionStorage !== null;
    var testKey = 'i18next.translate.boo';
    window.sessionStorage.setItem(testKey, 'foo');
    window.sessionStorage.removeItem(testKey);
  } catch (e) {
    hasSessionStorageSupport = false;
  }
  return hasSessionStorageSupport;
};
var sessionStorage = {
  name: 'sessionStorage',
  lookup: function lookup(options) {
    var found;
    if (options.lookupSessionStorage && sessionStorageAvailable()) {
      var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
      if (lng) found = lng;
    }
    return found;
  },
  cacheUserLanguage: function cacheUserLanguage(lng, options) {
    if (options.lookupSessionStorage && sessionStorageAvailable()) {
      window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
  }
};

var navigator$1 = {
  name: 'navigator',
  lookup: function lookup(options) {
    var found = [];
    if (typeof navigator !== 'undefined') {
      if (navigator.languages) {
        // chrome only; not an array, so can't use .push.apply instead of iterating
        for (var i = 0; i < navigator.languages.length; i++) {
          found.push(navigator.languages[i]);
        }
      }
      if (navigator.userLanguage) {
        found.push(navigator.userLanguage);
      }
      if (navigator.language) {
        found.push(navigator.language);
      }
    }
    return found.length > 0 ? found : undefined;
  }
};

var htmlTag = {
  name: 'htmlTag',
  lookup: function lookup(options) {
    var found;
    var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
    if (htmlTag && typeof htmlTag.getAttribute === 'function') {
      found = htmlTag.getAttribute('lang');
    }
    return found;
  }
};

var path = {
  name: 'path',
  lookup: function lookup(options) {
    var found;
    if (typeof window !== 'undefined') {
      var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
      if (language instanceof Array) {
        if (typeof options.lookupFromPathIndex === 'number') {
          if (typeof language[options.lookupFromPathIndex] !== 'string') {
            return undefined;
          }
          found = language[options.lookupFromPathIndex].replace('/', '');
        } else {
          found = language[0].replace('/', '');
        }
      }
    }
    return found;
  }
};

var subdomain = {
  name: 'subdomain',
  lookup: function lookup(options) {
    // If given get the subdomain index else 1
    var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === 'number' ? options.lookupFromSubdomainIndex + 1 : 1;
    // get all matches if window.location. is existing
    // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
    // is the hostname no public domain get the or option of localhost
    var language = typeof window !== 'undefined' && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);

    // if there is no match (null) return undefined
    if (!language) return undefined;
    // return the given group match
    return language[lookupFromSubdomainIndex];
  }
};

function getDefaults() {
  return {
    order: ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
    lookupQuerystring: 'lng',
    lookupCookie: 'i18next',
    lookupLocalStorage: 'i18nextLng',
    lookupSessionStorage: 'i18nextLng',
    // cache user language
    caches: ['localStorage'],
    excludeCacheFor: ['cimode']
    // cookieMinutes: 10,
    // cookieDomain: 'myDomain'
  };
}
var Browser = /*#__PURE__*/function () {
  function Browser(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, Browser);
    this.type = 'languageDetector';
    this.detectors = {};
    this.init(services, options);
  }
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(Browser, [{
    key: "init",
    value: function init(services) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.services = services || {
        languageUtils: {}
      }; // this way the language detector can be used without i18next
      this.options = defaults(options, this.options || {}, getDefaults());

      // backwards compatibility
      if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
      this.i18nOptions = i18nOptions;
      this.addDetector(cookie$1);
      this.addDetector(querystring);
      this.addDetector(localStorage);
      this.addDetector(sessionStorage);
      this.addDetector(navigator$1);
      this.addDetector(htmlTag);
      this.addDetector(path);
      this.addDetector(subdomain);
    }
  }, {
    key: "addDetector",
    value: function addDetector(detector) {
      this.detectors[detector.name] = detector;
    }
  }, {
    key: "detect",
    value: function detect(detectionOrder) {
      var _this = this;
      if (!detectionOrder) detectionOrder = this.options.order;
      var detected = [];
      detectionOrder.forEach(function (detectorName) {
        if (_this.detectors[detectorName]) {
          var lookup = _this.detectors[detectorName].lookup(_this.options);
          if (lookup && typeof lookup === 'string') lookup = [lookup];
          if (lookup) detected = detected.concat(lookup);
        }
      });
      if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
      return detected.length > 0 ? detected[0] : null; // a little backward compatibility
    }
  }, {
    key: "cacheUserLanguage",
    value: function cacheUserLanguage(lng, caches) {
      var _this2 = this;
      if (!caches) caches = this.options.caches;
      if (!caches) return;
      if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
      caches.forEach(function (cacheName) {
        if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
      });
    }
  }]);
  return Browser;
}();
Browser.type = 'languageDetector';




/***/ }),
/* 3018 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var fetchApi
if (typeof fetch === 'function') {
  if (typeof global !== 'undefined' && global.fetch) {
    fetchApi = global.fetch
  } else if (typeof window !== 'undefined' && window.fetch) {
    fetchApi = window.fetch
  } else {
    fetchApi = fetch
  }
}

if ("function" !== 'undefined' && (typeof window === 'undefined' || typeof window.document === 'undefined')) {
  var f = fetchApi || __webpack_require__(2829)
  if (f.default) f = f.default
  exports.default = f
  module.exports = exports.default
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 3019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__request_js__ = __webpack_require__(3020);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }


var getDefaults = function getDefaults() {
  return {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
    addPath: '/locales/add/{{lng}}/{{ns}}',
    allowMultiLoading: false,
    parse: function parse(data) {
      return JSON.parse(data);
    },
    stringify: JSON.stringify,
    parsePayload: function parsePayload(namespace, key, fallbackValue) {
      return _defineProperty({}, key, fallbackValue || '');
    },
    parseLoadPayload: function parseLoadPayload(languages, namespaces) {
      return undefined;
    },
    request: __WEBPACK_IMPORTED_MODULE_1__request_js__["a" /* default */],
    reloadInterval: typeof window !== 'undefined' ? false : 60 * 60 * 1000,
    customHeaders: {},
    queryStringParams: {},
    crossDomain: false,
    withCredentials: false,
    overrideMimeType: false,
    requestOptions: {
      mode: 'cors',
      credentials: 'same-origin',
      cache: 'default'
    }
  };
};
var Backend = function () {
  function Backend(services) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, Backend);
    this.services = services;
    this.options = options;
    this.allOptions = allOptions;
    this.type = 'backend';
    this.init(services, options, allOptions);
  }
  _createClass(Backend, [{
    key: "init",
    value: function init(services) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var allOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      this.services = services;
      this.options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* defaults */])(options, this.options || {}, getDefaults());
      this.allOptions = allOptions;
      if (this.services && this.options.reloadInterval) {
        setInterval(function () {
          return _this.reload();
        }, this.options.reloadInterval);
      }
    }
  }, {
    key: "readMulti",
    value: function readMulti(languages, namespaces, callback) {
      this._readAny(languages, languages, namespaces, namespaces, callback);
    }
  }, {
    key: "read",
    value: function read(language, namespace, callback) {
      this._readAny([language], language, [namespace], namespace, callback);
    }
  }, {
    key: "_readAny",
    value: function _readAny(languages, loadUrlLanguages, namespaces, loadUrlNamespaces, callback) {
      var _this2 = this;
      var loadPath = this.options.loadPath;
      if (typeof this.options.loadPath === 'function') {
        loadPath = this.options.loadPath(languages, namespaces);
      }
      loadPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_js__["b" /* makePromise */])(loadPath);
      loadPath.then(function (resolvedLoadPath) {
        if (!resolvedLoadPath) return callback(null, {});
        var url = _this2.services.interpolator.interpolate(resolvedLoadPath, {
          lng: languages.join('+'),
          ns: namespaces.join('+')
        });
        _this2.loadUrl(url, callback, loadUrlLanguages, loadUrlNamespaces);
      });
    }
  }, {
    key: "loadUrl",
    value: function loadUrl(url, callback, languages, namespaces) {
      var _this3 = this;
      var lng = typeof languages === 'string' ? [languages] : languages;
      var ns = typeof namespaces === 'string' ? [namespaces] : namespaces;
      var payload = this.options.parseLoadPayload(lng, ns);
      this.options.request(this.options, url, payload, function (err, res) {
        if (res && (res.status >= 500 && res.status < 600 || !res.status)) return callback('failed loading ' + url + '; status code: ' + res.status, true);
        if (res && res.status >= 400 && res.status < 500) return callback('failed loading ' + url + '; status code: ' + res.status, false);
        if (!res && err && err.message && err.message.indexOf('Failed to fetch') > -1) return callback('failed loading ' + url + ': ' + err.message, true);
        if (err) return callback(err, false);
        var ret, parseErr;
        try {
          if (typeof res.data === 'string') {
            ret = _this3.options.parse(res.data, languages, namespaces);
          } else {
            ret = res.data;
          }
        } catch (e) {
          parseErr = 'failed parsing ' + url + ' to json';
        }
        if (parseErr) return callback(parseErr, false);
        callback(null, ret);
      });
    }
  }, {
    key: "create",
    value: function create(languages, namespace, key, fallbackValue, callback) {
      var _this4 = this;
      if (!this.options.addPath) return;
      if (typeof languages === 'string') languages = [languages];
      var payload = this.options.parsePayload(namespace, key, fallbackValue);
      var finished = 0;
      var dataArray = [];
      var resArray = [];
      languages.forEach(function (lng) {
        var addPath = _this4.options.addPath;
        if (typeof _this4.options.addPath === 'function') {
          addPath = _this4.options.addPath(lng, namespace);
        }
        var url = _this4.services.interpolator.interpolate(addPath, {
          lng: lng,
          ns: namespace
        });
        _this4.options.request(_this4.options, url, payload, function (data, res) {
          finished += 1;
          dataArray.push(data);
          resArray.push(res);
          if (finished === languages.length) {
            if (typeof callback === 'function') callback(dataArray, resArray);
          }
        });
      });
    }
  }, {
    key: "reload",
    value: function reload() {
      var _this5 = this;
      var _this$services = this.services,
        backendConnector = _this$services.backendConnector,
        languageUtils = _this$services.languageUtils,
        logger = _this$services.logger;
      var currentLanguage = backendConnector.language;
      if (currentLanguage && currentLanguage.toLowerCase() === 'cimode') return;
      var toLoad = [];
      var append = function append(lng) {
        var lngs = languageUtils.toResolveHierarchy(lng);
        lngs.forEach(function (l) {
          if (toLoad.indexOf(l) < 0) toLoad.push(l);
        });
      };
      append(currentLanguage);
      if (this.allOptions.preload) this.allOptions.preload.forEach(function (l) {
        return append(l);
      });
      toLoad.forEach(function (lng) {
        _this5.allOptions.ns.forEach(function (ns) {
          backendConnector.read(lng, ns, 'read', null, null, function (err, data) {
            if (err) logger.warn("loading namespace ".concat(ns, " for language ").concat(lng, " failed"), err);
            if (!err && data) logger.log("loaded namespace ".concat(ns, " for language ").concat(lng), data);
            backendConnector.loaded("".concat(lng, "|").concat(ns), err, data);
          });
        });
      });
    }
  }]);
  return Backend;
}();
Backend.type = 'backend';
/* harmony default export */ __webpack_exports__["default"] = (Backend);

/***/ }),
/* 3020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_js__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getFetch_cjs__ = __webpack_require__(3018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getFetch_cjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__getFetch_cjs__);
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }


var fetchApi;
if (typeof fetch === 'function') {
  if (typeof global !== 'undefined' && global.fetch) {
    fetchApi = global.fetch;
  } else if (typeof window !== 'undefined' && window.fetch) {
    fetchApi = window.fetch;
  } else {
    fetchApi = fetch;
  }
}
var XmlHttpRequestApi;
if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_js__["c" /* hasXMLHttpRequest */])()) {
  if (typeof global !== 'undefined' && global.XMLHttpRequest) {
    XmlHttpRequestApi = global.XMLHttpRequest;
  } else if (typeof window !== 'undefined' && window.XMLHttpRequest) {
    XmlHttpRequestApi = window.XMLHttpRequest;
  }
}
var ActiveXObjectApi;
if (typeof ActiveXObject === 'function') {
  if (typeof global !== 'undefined' && global.ActiveXObject) {
    ActiveXObjectApi = global.ActiveXObject;
  } else if (typeof window !== 'undefined' && window.ActiveXObject) {
    ActiveXObjectApi = window.ActiveXObject;
  }
}
if (!fetchApi && __WEBPACK_IMPORTED_MODULE_1__getFetch_cjs__ && !XmlHttpRequestApi && !ActiveXObjectApi) fetchApi = __WEBPACK_IMPORTED_MODULE_1__getFetch_cjs__["default"] || __WEBPACK_IMPORTED_MODULE_1__getFetch_cjs__;
if (typeof fetchApi !== 'function') fetchApi = undefined;
var addQueryString = function addQueryString(url, params) {
  if (params && _typeof(params) === 'object') {
    var queryString = '';
    for (var paramName in params) {
      queryString += '&' + encodeURIComponent(paramName) + '=' + encodeURIComponent(params[paramName]);
    }
    if (!queryString) return url;
    url = url + (url.indexOf('?') !== -1 ? '&' : '?') + queryString.slice(1);
  }
  return url;
};
var fetchIt = function fetchIt(url, fetchOptions, callback) {
  fetchApi(url, fetchOptions).then(function (response) {
    if (!response.ok) return callback(response.statusText || 'Error', {
      status: response.status
    });
    response.text().then(function (data) {
      callback(null, {
        status: response.status,
        data: data
      });
    }).catch(callback);
  }).catch(callback);
};
var omitFetchOptions = false;
var requestWithFetch = function requestWithFetch(options, url, payload, callback) {
  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }
  var headers = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* defaults */])({}, typeof options.customHeaders === 'function' ? options.customHeaders() : options.customHeaders);
  if (payload) headers['Content-Type'] = 'application/json';
  var reqOptions = typeof options.requestOptions === 'function' ? options.requestOptions(payload) : options.requestOptions;
  var fetchOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_js__["a" /* defaults */])({
    method: payload ? 'POST' : 'GET',
    body: payload ? options.stringify(payload) : undefined,
    headers: headers
  }, omitFetchOptions ? {} : reqOptions);
  try {
    fetchIt(url, fetchOptions, callback);
  } catch (e) {
    if (!reqOptions || Object.keys(reqOptions).length === 0 || !e.message || e.message.indexOf('not implemented') < 0) {
      return callback(e);
    }
    try {
      Object.keys(reqOptions).forEach(function (opt) {
        delete fetchOptions[opt];
      });
      fetchIt(url, fetchOptions, callback);
      omitFetchOptions = true;
    } catch (err) {
      callback(err);
    }
  }
};
var requestWithXmlHttpRequest = function requestWithXmlHttpRequest(options, url, payload, callback) {
  if (payload && _typeof(payload) === 'object') {
    payload = addQueryString('', payload).slice(1);
  }
  if (options.queryStringParams) {
    url = addQueryString(url, options.queryStringParams);
  }
  try {
    var x;
    if (XmlHttpRequestApi) {
      x = new XmlHttpRequestApi();
    } else {
      x = new ActiveXObjectApi('MSXML2.XMLHTTP.3.0');
    }
    x.open(payload ? 'POST' : 'GET', url, 1);
    if (!options.crossDomain) {
      x.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    }
    x.withCredentials = !!options.withCredentials;
    if (payload) {
      x.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    }
    if (x.overrideMimeType) {
      x.overrideMimeType('application/json');
    }
    var h = options.customHeaders;
    h = typeof h === 'function' ? h() : h;
    if (h) {
      for (var i in h) {
        x.setRequestHeader(i, h[i]);
      }
    }
    x.onreadystatechange = function () {
      x.readyState > 3 && callback(x.status >= 400 ? x.statusText : null, {
        status: x.status,
        data: x.responseText
      });
    };
    x.send(payload);
  } catch (e) {
    console && console.log(e);
  }
};
var request = function request(options, url, payload, callback) {
  if (typeof payload === 'function') {
    callback = payload;
    payload = undefined;
  }
  callback = callback || function () {};
  if (fetchApi && url.indexOf('file:') !== 0) {
    return requestWithFetch(options, url, payload, callback);
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_js__["c" /* hasXMLHttpRequest */])() || typeof ActiveXObject === 'function') {
    return requestWithXmlHttpRequest(options, url, payload, callback);
  }
  callback(new Error('No fetch and no xhr implementation found!'));
};
/* harmony default export */ __webpack_exports__["a"] = (request);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(56)))

/***/ }),
/* 3021 */
/***/ (function(module, exports) {

exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = nBytes * 8 - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = (value * c - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),
/* 3022 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = self.fetch || (self.fetch = __webpack_require__(1593).default || __webpack_require__(1593));


/***/ }),
/* 3023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(3026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(3027);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 3024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(56)))

/***/ }),
/* 3025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(3028);


/** Built-in value references. */
var getPrototype = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 3026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(1247);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 3027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 3028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 3029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(3024);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 3030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 3031 */
/***/ (function(module, exports) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return before(2, func);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = once;


/***/ }),
/* 3032 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(285),
    root = __webpack_require__(186);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 3033 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(3063),
    hashDelete = __webpack_require__(3064),
    hashGet = __webpack_require__(3065),
    hashHas = __webpack_require__(3066),
    hashSet = __webpack_require__(3067);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 3034 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(285),
    root = __webpack_require__(186);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 3035 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(285),
    root = __webpack_require__(186);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 3036 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(1249),
    setCacheAdd = __webpack_require__(3086),
    setCacheHas = __webpack_require__(3087);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 3037 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(446),
    stackClear = __webpack_require__(3089),
    stackDelete = __webpack_require__(3090),
    stackGet = __webpack_require__(3091),
    stackHas = __webpack_require__(3092),
    stackSet = __webpack_require__(3093);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 3038 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(186);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 3039 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(285),
    root = __webpack_require__(186);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 3040 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 3041 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(3051),
    isArguments = __webpack_require__(3094),
    isArray = __webpack_require__(677),
    isBuffer = __webpack_require__(1255),
    isIndex = __webpack_require__(3068),
    isTypedArray = __webpack_require__(1259);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 3042 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 3043 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 3044 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(3042),
    isArray = __webpack_require__(677);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 3045 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(350),
    isObjectLike = __webpack_require__(351);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 3046 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(3047),
    isObjectLike = __webpack_require__(351);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 3047 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(3037),
    equalArrays = __webpack_require__(1250),
    equalByTag = __webpack_require__(3055),
    equalObjects = __webpack_require__(3056),
    getTag = __webpack_require__(3061),
    isArray = __webpack_require__(677),
    isBuffer = __webpack_require__(1255),
    isTypedArray = __webpack_require__(1259);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 3048 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(1256),
    isMasked = __webpack_require__(3070),
    isObject = __webpack_require__(1258),
    toSource = __webpack_require__(1253);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 3049 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(350),
    isLength = __webpack_require__(1257),
    isObjectLike = __webpack_require__(351);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 3050 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(3071),
    nativeKeys = __webpack_require__(3083);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 3051 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 3052 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 3053 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 3054 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(186);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 3055 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(676),
    Uint8Array = __webpack_require__(3038),
    eq = __webpack_require__(1254),
    equalArrays = __webpack_require__(1250),
    mapToArray = __webpack_require__(3082),
    setToArray = __webpack_require__(3088);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 3056 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(3057);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 3057 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(3044),
    getSymbols = __webpack_require__(3060),
    keys = __webpack_require__(3098);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 3058 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1252);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 3059 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(676);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 3060 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(3040),
    stubArray = __webpack_require__(3099);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 3061 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(3032),
    Map = __webpack_require__(675),
    Promise = __webpack_require__(3034),
    Set = __webpack_require__(3035),
    WeakMap = __webpack_require__(3039),
    baseGetTag = __webpack_require__(350),
    toSource = __webpack_require__(1253);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 3062 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 3063 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(449);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 3064 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 3065 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(449);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 3066 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(449);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 3067 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(449);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 3068 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 3069 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 3070 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(3054);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 3071 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 3072 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 3073 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(447);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 3074 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(447);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 3075 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(447);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 3076 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(447);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 3077 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(3033),
    ListCache = __webpack_require__(446),
    Map = __webpack_require__(675);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 3078 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(448);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 3079 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(448);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 3080 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(448);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 3081 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(448);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 3082 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 3083 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(1252);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 3084 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(1251);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(299)(module)))

/***/ }),
/* 3085 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 3086 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 3087 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 3088 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 3089 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(446);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 3090 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 3091 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 3092 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 3093 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(446),
    Map = __webpack_require__(675),
    MapCache = __webpack_require__(1249);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 3094 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(3045),
    isObjectLike = __webpack_require__(351);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 3095 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(1256),
    isLength = __webpack_require__(1257);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 3096 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(3046);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 3097 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(350),
    getPrototype = __webpack_require__(3058),
    isObjectLike = __webpack_require__(351);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 3098 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(3041),
    baseKeys = __webpack_require__(3050),
    isArrayLike = __webpack_require__(3095);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 3099 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 3100 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 3101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var TRAILING_WHITESPACE = /[ \u0020\t\n]*$/; // This escapes some markdown but there's a few cases that are TODO -
// - List items
// - Back tics  (see https://github.com/Rosey/markdown-draft-js/issues/52#issuecomment-388458017)
// - Complex markdown, like links or images. Not sure it's even worth it, because if you're typing
// that into draft chances are you know its markdown and maybe expect it convert? :/

var MARKDOWN_STYLE_CHARACTERS = ['*', '_', '~', '`'];
var MARKDOWN_STYLE_CHARACTER_REGXP = /(\*|_|~|\\|`)/g; // I hate this a bit, being outside of the function’s scope
// but can’t think of a better way to keep track of how many ordered list
// items were are on, as draft doesn’t explicitly tell us in the raw object 😢.
// This is a hash that will be assigned values based on depth, so like
// orderedListNumber[0] = 1 would mean that ordered list at depth 0 is on number 1.
// orderedListNumber[0] = 2 would mean that ordered list at depth 0 is on number 2.
// This is so we have the right number of numbers when doing a list, eg
// 1. Item One
// 2. Item two
// 3. Item three
// And so on.

var orderedListNumber = {},
    previousOrderedListDepth = 0; // A map of draftjs block types -> markdown open and close characters
// Both the open and close methods must exist, even if they simply return an empty string.
// They should always return a string.

var StyleItems = {
  // BLOCK LEVEL
  'unordered-list-item': {
    open: function open() {
      return '- ';
    },
    close: function close() {
      return '';
    }
  },
  'ordered-list-item': {
    open: function open(block) {
      var number = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      return "".concat(number, ". ");
    },
    close: function close() {
      return '';
    }
  },
  'blockquote': {
    open: function open() {
      return '> ';
    },
    close: function close() {
      return '';
    }
  },
  'header-one': {
    open: function open() {
      return '# ';
    },
    close: function close() {
      return '';
    }
  },
  'header-two': {
    open: function open() {
      return '## ';
    },
    close: function close() {
      return '';
    }
  },
  'header-three': {
    open: function open() {
      return '### ';
    },
    close: function close() {
      return '';
    }
  },
  'header-four': {
    open: function open() {
      return '#### ';
    },
    close: function close() {
      return '';
    }
  },
  'header-five': {
    open: function open() {
      return '##### ';
    },
    close: function close() {
      return '';
    }
  },
  'header-six': {
    open: function open() {
      return '###### ';
    },
    close: function close() {
      return '';
    }
  },
  'code-block': {
    open: function open(block) {
      return '```' + (block.data.language || '') + '\n';
    },
    close: function close() {
      return '\n```';
    }
  },
  // INLINE LEVEL
  'BOLD': {
    open: function open() {
      return '**';
    },
    close: function close() {
      return '**';
    }
  },
  'ITALIC': {
    open: function open() {
      return '_';
    },
    close: function close() {
      return '_';
    }
  },
  'STRIKETHROUGH': {
    open: function open() {
      return '~~';
    },
    close: function close() {
      return '~~';
    }
  },
  'CODE': {
    open: function open() {
      return '`';
    },
    close: function close() {
      return '`';
    }
  }
}; // A map of draftjs entity types -> markdown open and close characters
// entities are different from block types because they have additional data attached to them.
// an entity object is passed in to both open and close, in case it's needed for string generation.
//
// Both the open and close methods must exist, even if they simply return an empty string.
// They should always return a string.

var EntityItems = {
  'LINK': {
    open: function open(entity) {
      return '[';
    },
    close: function close(entity) {
      return "](".concat(entity.data.url || entity.data.href, ")");
    }
  }
}; // Bit of a hack - we normally want a double newline after a block,
// but for list items we just want one (unless it's the _last_ list item in a group.)

var SingleNewlineAfterBlock = ['unordered-list-item', 'ordered-list-item'];

function isEmptyBlock(block) {
  return block.text.length === 0 && block.entityRanges.length === 0 && Object.keys(block.data || {}).length === 0;
}
/**
 * Generate markdown for a single block javascript object
 * DraftJS raw object contains an array of blocks, which is the main "structure"
 * of the text. Each block = a new line.
 *
 * @param {Object} block - block to generate markdown for
 * @param {Number} index - index of the block in the blocks array
 * @param {Object} rawDraftObject - entire raw draft object (needed for accessing the entityMap)
 * @param {Object} options - additional options passed in by the user calling this method.
 *
 * @return {String} markdown string
**/


function renderBlock(block, index, rawDraftObject, options) {
  var openInlineStyles = [],
      markdownToAdd = [];
  var markdownString = '',
      customStyleItems = options.styleItems || {},
      customEntityItems = options.entityItems || {},
      escapeMarkdownCharacters = options.hasOwnProperty('escapeMarkdownCharacters') ? options.escapeMarkdownCharacters : true;
  var type = block.type;
  var markdownStyleCharactersToEscape = []; // draft-js emits empty blocks that have type set… don’t style them unless the user wants to preserve new lines
  // (if newlines are preserved each empty line should be "styled" eg in case of blockquote we want to see a blockquote.)
  // but if newlines aren’t preserved then we'd end up having double or triple or etc markdown characters, which is a bug.

  if (isEmptyBlock(block) && !options.preserveNewlines) {
    type = 'unstyled';
  } // Render main block wrapping element


  if (customStyleItems[type] || StyleItems[type]) {
    if (type === 'unordered-list-item' || type === 'ordered-list-item') {
      markdownString += ' '.repeat(block.depth * 4);
    }

    if (type === 'ordered-list-item') {
      orderedListNumber[block.depth] = orderedListNumber[block.depth] || 1;
      markdownString += (customStyleItems[type] || StyleItems[type]).open(block, orderedListNumber[block.depth]);
      orderedListNumber[block.depth]++; // Have to reset the number for orderedListNumber if we are breaking out of a list so that if
      // there's another nested list at the same level further down, it starts at 1 again.
      // COMPLICATED 😭

      if (previousOrderedListDepth > block.depth) {
        orderedListNumber[previousOrderedListDepth] = 1;
      }

      previousOrderedListDepth = block.depth;
    } else {
      orderedListNumber = {};
      markdownString += (customStyleItems[type] || StyleItems[type]).open(block);
    }
  } else {
    orderedListNumber = {};
  } // A stack to keep track of open tags


  var openTags = [];

  function openTag(tag) {
    openTags.push(tag);

    if (tag.style) {
      // Open inline tag
      if (customStyleItems[tag.style] || StyleItems[tag.style]) {
        var styleToAdd = (customStyleItems[tag.style] || StyleItems[tag.style]).open();
        markdownToAdd.push({
          type: 'style',
          style: tag,
          value: styleToAdd
        });
      }
    } else {
      // Open entity tag
      var entity = rawDraftObject.entityMap[tag.key];

      if (customEntityItems[entity.type] || EntityItems[entity.type]) {
        var entityToAdd = (customEntityItems[entity.type] || EntityItems[entity.type]).open(entity, block);
        markdownToAdd.push({
          type: 'entity',
          value: entityToAdd
        });
      }
    }
  }

  function closeTag(tag) {
    var popped = openTags.pop();

    if (tag !== popped) {
      throw new Error('Invariant violation: Cannot close a tag before all inner tags have been closed');
    }

    if (tag.style) {
      // Close inline tag
      if (customStyleItems[tag.style] || StyleItems[tag.style]) {
        // Have to trim whitespace first and then re-add after because markdown can't handle leading/trailing whitespace
        var trailingWhitespace = TRAILING_WHITESPACE.exec(markdownString);
        markdownString = markdownString.slice(0, markdownString.length - trailingWhitespace[0].length);
        markdownString += (customStyleItems[tag.style] || StyleItems[tag.style]).close();
        markdownString += trailingWhitespace[0];
      }
    } else {
      // Close entity tag
      var entity = rawDraftObject.entityMap[tag.key];

      if (customEntityItems[entity.type] || EntityItems[entity.type]) {
        markdownString += (customEntityItems[entity.type] || EntityItems[entity.type]).close(entity, block);
      }
    }
  }

  var compareTagsLastCloseFirst = function compareTagsLastCloseFirst(a, b) {
    return b.offset + b.length - (a.offset + a.length);
  }; // reverse array without mutating the original


  var reverse = function reverse(array) {
    return array.concat().reverse();
  }; // Render text within content, along with any inline styles/entities


  Array.from(block.text).some(function (character, characterIndex) {
    // Close any tags that need closing, starting from top of the stack
    reverse(openTags).forEach(function (tag) {
      if (tag.offset + tag.length === characterIndex) {
        // Take all tags stacked on top of the current one, meaning they opened after it.
        // Since they have not been popped, they'll close only later. So we need to split them.
        var tagsToSplit = openTags.slice(openTags.indexOf(tag) + 1); // Close in reverse order as they were opened

        reverse(tagsToSplit).forEach(closeTag); // Now we can close the current tag

        closeTag(tag); // Reopen split tags, ordered so that tags that close last open first

        tagsToSplit.sort(compareTagsLastCloseFirst).forEach(openTag);
      }
    }); // Open any tags that need opening, using the correct nesting order.

    var inlineTagsToOpen = block.inlineStyleRanges.filter(function (tag) {
      return tag.offset === characterIndex;
    });
    var entityTagsToOpen = block.entityRanges.filter(function (tag) {
      return tag.offset === characterIndex;
    });
    inlineTagsToOpen.concat(entityTagsToOpen).sort(compareTagsLastCloseFirst).forEach(openTag); // These are all the opening entity and style types being added to the markdown string for this loop
    // we store in an array and add here because if the character is WS character, we want to hang onto it and not apply it until the next non-whitespace
    // character before adding the markdown, since markdown doesn’t play nice with leading whitespace (eg '** bold**' is no  good, whereas ' **bold**' is good.)

    if (character !== ' ' && markdownToAdd.length) {
      markdownString += markdownToAdd.map(function (item) {
        return item.value;
      }).join('');
      markdownToAdd = [];
    }

    if (block.type !== 'code-block' && escapeMarkdownCharacters) {
      var insideInlineCodeStyle = openTags.find(function (style) {
        return style.style === 'CODE';
      });

      if (insideInlineCodeStyle) {// Todo - The syntax to escape backtics when inside backtic code already is to use MORE backtics wrapping.
        // So we need to see how many backtics in a row we have and then when converting to markdown, use that # + 1
        // EG  ``Test ` Hllo ``
        // OR   ```Test `` Hello```
        // OR ````Test ``` Hello ````
        // Similar work has to be done for codeblocks.
      } else {
        // Special escape logic for blockquotes and heading characters
        if (characterIndex === 0 && character === '#' && block.text[1] && block.text[1] === ' ') {
          character = character.replace('#', '\\#');
        } else if (characterIndex === 0 && character === '>') {
          character = character.replace('>', '\\>');
        } // Escaping inline markdown characters
        // 🧹 If someone can think of a more elegant solution, I would love that.
        // orginally this was just a little char replace using a simple regular expression, but there’s lots of cases where
        // a markdown character does not actually get converted to markdown, like this case: http://google.com/i_am_a_link
        // so this code now tries to be smart and keeps track of potential “opening” characters as well as potential “closing”
        // characters, and only escapes if both opening and closing exist, and they have the correct whitepace-before-open, whitespace-or-end-of-string-after-close pattern


        if (MARKDOWN_STYLE_CHARACTERS.includes(character)) {
          var openingStyle = markdownStyleCharactersToEscape.find(function (item) {
            return item.character === character;
          });

          if (!openingStyle && block.text[characterIndex - 1] === ' ' && block.text[characterIndex + 1] !== ' ') {
            markdownStyleCharactersToEscape.push({
              character: character,
              index: characterIndex,
              markdownStringIndexStart: markdownString.length + character.length - 1,
              markdownStringIndexEnd: markdownString.length + character.length
            });
          } else if (openingStyle && block.text[characterIndex - 1] === character && characterIndex === openingStyle.index + 1) {
            openingStyle.markdownStringIndexEnd += 1;
          } else if (openingStyle) {
            var openingStyleLength = openingStyle.markdownStringIndexEnd - openingStyle.markdownStringIndexStart;
            var escapeCharacter = false;
            var popOpeningStyle = false;

            if (openingStyleLength === 1 && (block.text[characterIndex + 1] === ' ' || !block.text[characterIndex + 1])) {
              popOpeningStyle = true;
              escapeCharacter = true;
            }

            if (openingStyleLength === 2 && block.text[characterIndex + 1] === character) {
              escapeCharacter = true;
            }

            if (openingStyleLength === 2 && block.text[characterIndex - 1] === character && (block.text[characterIndex + 1] === ' ' || !block.text[characterIndex + 1])) {
              popOpeningStyle = true;
              escapeCharacter = true;
            }

            if (popOpeningStyle) {
              markdownStyleCharactersToEscape.splice(markdownStyleCharactersToEscape.indexOf(openingStyle), 1);
              var replacementString = markdownString.slice(openingStyle.markdownStringIndexStart, openingStyle.markdownStringIndexEnd);
              replacementString = replacementString.replace(MARKDOWN_STYLE_CHARACTER_REGXP, '\\$1');
              markdownString = markdownString.slice(0, openingStyle.markdownStringIndexStart) + replacementString + markdownString.slice(openingStyle.markdownStringIndexEnd);
            }

            if (escapeCharacter) {
              character = "\\".concat(character);
            }
          }
        }
      }
    }

    if (character === '\n' && type === 'blockquote') {
      markdownString += '\n> ';
    } else {
      markdownString += character;
    }
  }); // Finally, close all remaining open tags

  reverse(openTags).forEach(closeTag); // Close block level item

  if (customStyleItems[type] || StyleItems[type]) {
    markdownString += (customStyleItems[type] || StyleItems[type]).close(block);
  } // Determine how many newlines to add - generally we want 2, but for list items we just want one when they are succeeded by another list item.


  if (SingleNewlineAfterBlock.indexOf(type) !== -1 && rawDraftObject.blocks[index + 1] && SingleNewlineAfterBlock.indexOf(rawDraftObject.blocks[index + 1].type) !== -1) {
    markdownString += '\n';
  } else if (rawDraftObject.blocks[index + 1]) {
    if (rawDraftObject.blocks[index].text) {
      if (SingleNewlineAfterBlock.indexOf(type) !== -1 && SingleNewlineAfterBlock.indexOf(rawDraftObject.blocks[index + 1].type) === -1) {
        markdownString += '\n\n';
      } else if (!options.preserveNewlines) {
        // 2 newlines if not preserving
        markdownString += '\n\n';
      } else {
        markdownString += '\n';
      }
    } else if (options.preserveNewlines) {
      markdownString += '\n';
    }
  }

  return markdownString;
}
/**
 * Generate markdown for a raw draftjs object
 * DraftJS raw object contains an array of blocks, which is the main "structure"
 * of the text. Each block = a new line.
 *
 * @param {Object} rawDraftObject - draftjs object to generate markdown for
 * @param {Object} options - optional additional data, see readme for what options can be passed in.
 *
 * @return {String} markdown string
**/


function draftToMarkdown(rawDraftObject, options) {
  options = options || {};
  var markdownString = '';
  rawDraftObject.blocks.forEach(function (block, index) {
    markdownString += renderBlock(block, index, rawDraftObject, options);
  });
  orderedListNumber = {}; // See variable definitions at the top of the page to see why we have to do this sad hack.

  return markdownString;
}

/* harmony default export */ __webpack_exports__["a"] = (draftToMarkdown);

/***/ }),
/* 3102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_remarkable__ = __webpack_require__(3229);
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


var TRAILING_NEW_LINE = /\n$/; // In DraftJS, string lengths are calculated differently than in JS itself (due
// to surrogate pairs). Instead of importing the entire UnicodeUtils file from
// FBJS, we use a simpler alternative, in the form of `Array.from`.
//
// Alternative:  const { strlen } = require('fbjs/lib/UnicodeUtils');

function strlen(str) {
  return Array.from(str).length;
} // Block level items, key is Remarkable's key for them, value returned is
// A function that generates the raw draftjs key and block data.
//
// Why a function? Because in some cases (headers) we need additional information
// before we can determine the exact key to return. And blocks may also return data


var DefaultBlockTypes = {
  paragraph_open: function paragraph_open(item) {
    return {
      type: 'unstyled',
      text: '',
      entityRanges: [],
      inlineStyleRanges: []
    };
  },
  blockquote_open: function blockquote_open(item) {
    return {
      type: 'blockquote',
      text: ''
    };
  },
  ordered_list_item_open: function ordered_list_item_open() {
    return {
      type: 'ordered-list-item',
      text: ''
    };
  },
  unordered_list_item_open: function unordered_list_item_open() {
    return {
      type: 'unordered-list-item',
      text: ''
    };
  },
  fence: function fence(item) {
    return {
      type: 'code-block',
      data: {
        language: item.params || ''
      },
      text: (item.content || '').replace(TRAILING_NEW_LINE, ''),
      // remarkable seems to always append an erronious trailing newline to its codeblock content, so we need to trim it out.
      entityRanges: [],
      inlineStyleRanges: []
    };
  },
  heading_open: function heading_open(item) {
    var type = 'header-' + {
      1: 'one',
      2: 'two',
      3: 'three',
      4: 'four',
      5: 'five',
      6: 'six'
    }[item.hLevel];
    return {
      type: type,
      text: ''
    };
  }
}; // Entity types. These are things like links or images that require
// additional data and will be added to the `entityMap`
// again. In this case, key is remarkable key, value is
// meethod that returns the draftjs key + any data needed.

var DefaultBlockEntities = {
  link_open: function link_open(item) {
    return {
      type: 'LINK',
      mutability: 'MUTABLE',
      data: {
        url: item.href,
        href: item.href
      }
    };
  }
}; // Entity styles. Simple Inline styles that aren't added to entityMap
// key is remarkable key, value is draftjs raw key

var DefaultBlockStyles = {
  strong_open: 'BOLD',
  em_open: 'ITALIC',
  code: 'CODE',
  del_open: 'STRIKETHROUGH'
}; // Key generator for entityMap items

var idCounter = -1;

function generateUniqueKey() {
  idCounter++;
  return idCounter;
}
/*
 * Handle inline content in a block level item
 * parses for BlockEntities (links, images) and BlockStyles (em, strong)
 * doesn't handle block level items (blockquote, ordered list, etc)
 *
 * @param <Object> inlineItem - single object from remarkable data representation of markdown
 * @param <Object> BlockEntities - key-value object of mappable block entity items. Passed in as param so users can include their own custom stuff
 * @param <Object> BlockStyles - key-value object of mappable block styles items. Passed in as param so users can include their own custom stuff
 *
 * @return <Object>
 *  content: Entire text content for the inline item,
 *  blockEntities: New block eneities to be added to global block entity map
 *  blockEntityRanges: block-level representation of block entities including key to access the block entity from the global map
 *  blockStyleRanges: block-level representation of styles (eg strong, em)
*/


function parseInline(inlineItem, BlockEntities, BlockStyles) {
  var content = '',
      blockEntities = {},
      blockEntityRanges = [],
      blockInlineStyleRanges = [];
  inlineItem.children.forEach(function (child) {
    if (child.type === 'text') {
      content += child.content;
    } else if (child.type === 'softbreak') {
      content += '\n';
    } else if (child.type === 'hardbreak') {
      content += '\n';
    } else if (BlockStyles[child.type]) {
      var key = generateUniqueKey();
      var styleBlock = {
        offset: strlen(content) || 0,
        length: 0,
        style: BlockStyles[child.type]
      }; // Edge case hack because code items don't have inline content or open/close, unlike everything else
      // sub and sup are also special :)

      if (child.type === 'code' || child.type === 'sub' || child.type === 'sup') {
        styleBlock.length = strlen(child.content);
        content += child.content;
      }

      blockInlineStyleRanges.push(styleBlock);
    } else if (BlockEntities[child.type]) {
      var key = generateUniqueKey();
      blockEntities[key] = BlockEntities[child.type](child);
      blockEntityRanges.push({
        offset: strlen(content) || 0,
        length: 0,
        key: key
      });
    } else if (child.type.indexOf('_close') !== -1 && BlockEntities[child.type.replace('_close', '_open')]) {
      blockEntityRanges[blockEntityRanges.length - 1].length = strlen(content) - blockEntityRanges[blockEntityRanges.length - 1].offset;
    } else if (child.type.indexOf('_close') !== -1 && BlockStyles[child.type.replace('_close', '_open')]) {
      var type = BlockStyles[child.type.replace('_close', '_open')];
      blockInlineStyleRanges = blockInlineStyleRanges.map(function (style) {
        if (style.length === 0 && style.style === type) {
          style.length = strlen(content) - style.offset;
        }

        return style;
      });
    }
  });
  return {
    content: content,
    blockEntities: blockEntities,
    blockEntityRanges: blockEntityRanges,
    blockInlineStyleRanges: blockInlineStyleRanges
  };
}
/**
 * Convert markdown into raw draftjs object
 *
 * @param {String} markdown - markdown to convert into raw draftjs object
 * @param {Object} options - optional additional data, see readme for what options can be passed in.
 *
 * @return {Object} rawDraftObject
**/


function markdownToDraft(string) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var remarkablePreset = options.remarkablePreset || options.remarkableOptions;
  var remarkableOptions = _typeof(options.remarkableOptions) === 'object' ? options.remarkableOptions : null;
  var md = new __WEBPACK_IMPORTED_MODULE_0_remarkable__["a" /* Remarkable */](remarkablePreset, remarkableOptions); // if tables are not explicitly enabled, disable them by default

  if (!remarkableOptions || !remarkableOptions.enable || !remarkableOptions.enable.block || remarkableOptions.enable.block !== 'table' || remarkableOptions.enable.block.includes('table') === false) {
    md.block.ruler.disable('table');
  } // disable the specified rules


  if (remarkableOptions && remarkableOptions.disable) {
    for (var _i = 0, _Object$entries = Object.entries(remarkableOptions.disable); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
          key = _Object$entries$_i[0],
          value = _Object$entries$_i[1];

      md[key].ruler.disable(value);
    }
  } // enable the specified rules


  if (remarkableOptions && remarkableOptions.enable) {
    for (var _i2 = 0, _Object$entries2 = Object.entries(remarkableOptions.enable); _i2 < _Object$entries2.length; _i2++) {
      var _Object$entries2$_i = _slicedToArray(_Object$entries2[_i2], 2),
          _key = _Object$entries2$_i[0],
          _value = _Object$entries2$_i[1];

      md[_key].ruler.enable(_value);
    }
  } // If users want to define custom remarkable plugins for custom markdown, they can be added here


  if (options.remarkablePlugins) {
    options.remarkablePlugins.forEach(function (plugin) {
      md.use(plugin, {});
    });
  }

  var blocks = []; // blocks will be returned as part of the final draftjs raw object

  var entityMap = {}; // entitymap will be returned as part of the final draftjs raw object

  var parsedData = md.parse(string, {}); // remarkable js takes markdown and makes it an array of style objects for us to easily parse

  var currentListType = null; // Because of how remarkable's data is formatted, we need to cache what kind of list we're currently dealing with

  var previousBlockEndingLine = 0; // Allow user to define custom BlockTypes and Entities if they so wish

  var BlockTypes = Object.assign({}, DefaultBlockTypes, options.blockTypes || {});
  var BlockEntities = Object.assign({}, DefaultBlockEntities, options.blockEntities || {});
  var BlockStyles = Object.assign({}, DefaultBlockStyles, options.blockStyles || {});
  parsedData.forEach(function (item) {
    // Because of how remarkable's data is formatted, we need to cache what kind of list we're currently dealing with
    if (item.type === 'bullet_list_open') {
      currentListType = 'unordered_list_item_open';
    } else if (item.type === 'ordered_list_open') {
      currentListType = 'ordered_list_item_open';
    }

    var itemType = item.type;

    if (itemType === 'list_item_open') {
      itemType = currentListType;
    }

    if (itemType === 'inline') {
      // Parse inline content and apply it to the most recently created block level item,
      // which is where the inline content will belong.
      var _parseInline = parseInline(item, BlockEntities, BlockStyles),
          content = _parseInline.content,
          blockEntities = _parseInline.blockEntities,
          blockEntityRanges = _parseInline.blockEntityRanges,
          blockInlineStyleRanges = _parseInline.blockInlineStyleRanges;

      var blockToModify = blocks[blocks.length - 1];
      blockToModify.text = content;
      blockToModify.inlineStyleRanges = blockInlineStyleRanges;
      blockToModify.entityRanges = blockEntityRanges; // The entity map is a master object separate from the block so just add any entities created for this block to the master object

      Object.assign(entityMap, blockEntities);
    } else if ((itemType.indexOf('_open') !== -1 || itemType === 'fence' || itemType === 'hr' || itemType === 'htmlblock') && BlockTypes[itemType]) {
      var depth = 0;
      var block;

      if (item.level > 0) {
        depth = Math.floor(item.level / 2);
      } // Draftjs only supports 1 level of blocks, hence the item.level === 0 check
      // List items will always be at least `level==1` though so we need a separate check for that
      // If there’s nested block level items deeper than that, we need to make sure we capture this by cloning the topmost block
      // otherwise we’ll accidentally overwrite its text. (eg if there's a blockquote with 3 nested paragraphs with inline text, without this check, only the last paragraph would be reflected)


      if (item.level === 0 || item.type === 'list_item_open') {
        block = Object.assign({
          depth: depth
        }, BlockTypes[itemType](item));
      } else if (item.level > 0 && blocks[blocks.length - 1].text) {
        block = Object.assign({}, blocks[blocks.length - 1]);
      }

      if (block && options.preserveNewlines) {
        // Re: previousBlockEndingLine.... omg.
        // So remarkable strips out empty newlines and doesn't make any entities to parse to restore them
        // the only solution I could find is that there's a 2-value array on each block item called "lines" which is the start and end line of the block element.
        // by keeping track of the PREVIOUS block element ending line and the NEXT block element starting line, we can find the difference between the new lines and insert
        // an appropriate number of extra paragraphs to re-create those newlines in draftjs.
        // This is probably my least favourite thing in this file, but not sure what could be better.
        var totalEmptyParagraphsToCreate = item.lines[0] - previousBlockEndingLine;

        for (var i = 0; i < totalEmptyParagraphsToCreate; i++) {
          blocks.push(DefaultBlockTypes.paragraph_open());
        }
      }

      if (block) {
        previousBlockEndingLine = item.lines[1]; // reserve one line after list block

        if (block.type === 'unordered-list-item' || block.type === 'ordered-list-item') {
          previousBlockEndingLine += 1;
        }

        blocks.push(block);
      }
    }
  }); // EditorState.createWithContent will error if there's no blocks defined
  // Remarkable returns an empty array though. So we have to generate a 'fake'
  // empty block in this case. 😑

  if (!blocks.length) {
    blocks.push(DefaultBlockTypes.paragraph_open());
  }

  return {
    entityMap: entityMap,
    blocks: blocks
  };
}

/* harmony default export */ __webpack_exports__["a"] = (markdownToDraft);

/***/ }),
/* 3103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.abs;


/***/ }),
/* 3104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./floor')} */
module.exports = Math.floor;


/***/ }),
/* 3105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 3106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./max')} */
module.exports = Math.max;


/***/ }),
/* 3107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./min')} */
module.exports = Math.min;


/***/ }),
/* 3108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./pow')} */
module.exports = Math.pow;


/***/ }),
/* 3109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./round')} */
module.exports = Math.round;


/***/ }),
/* 3110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(3105);

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};


/***/ }),
/* 3111 */
/***/ (function(module, exports) {

module.exports = {"application/1d-interleaved-parityfec":{"source":"iana"},"application/3gpdash-qoe-report+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/3gpp-ims+xml":{"source":"iana","compressible":true},"application/3gpphal+json":{"source":"iana","compressible":true},"application/3gpphalforms+json":{"source":"iana","compressible":true},"application/a2l":{"source":"iana"},"application/ace+cbor":{"source":"iana"},"application/activemessage":{"source":"iana"},"application/activity+json":{"source":"iana","compressible":true},"application/alto-costmap+json":{"source":"iana","compressible":true},"application/alto-costmapfilter+json":{"source":"iana","compressible":true},"application/alto-directory+json":{"source":"iana","compressible":true},"application/alto-endpointcost+json":{"source":"iana","compressible":true},"application/alto-endpointcostparams+json":{"source":"iana","compressible":true},"application/alto-endpointprop+json":{"source":"iana","compressible":true},"application/alto-endpointpropparams+json":{"source":"iana","compressible":true},"application/alto-error+json":{"source":"iana","compressible":true},"application/alto-networkmap+json":{"source":"iana","compressible":true},"application/alto-networkmapfilter+json":{"source":"iana","compressible":true},"application/alto-updatestreamcontrol+json":{"source":"iana","compressible":true},"application/alto-updatestreamparams+json":{"source":"iana","compressible":true},"application/aml":{"source":"iana"},"application/andrew-inset":{"source":"iana","extensions":["ez"]},"application/applefile":{"source":"iana"},"application/applixware":{"source":"apache","extensions":["aw"]},"application/at+jwt":{"source":"iana"},"application/atf":{"source":"iana"},"application/atfx":{"source":"iana"},"application/atom+xml":{"source":"iana","compressible":true,"extensions":["atom"]},"application/atomcat+xml":{"source":"iana","compressible":true,"extensions":["atomcat"]},"application/atomdeleted+xml":{"source":"iana","compressible":true,"extensions":["atomdeleted"]},"application/atomicmail":{"source":"iana"},"application/atomsvc+xml":{"source":"iana","compressible":true,"extensions":["atomsvc"]},"application/atsc-dwd+xml":{"source":"iana","compressible":true,"extensions":["dwd"]},"application/atsc-dynamic-event-message":{"source":"iana"},"application/atsc-held+xml":{"source":"iana","compressible":true,"extensions":["held"]},"application/atsc-rdt+json":{"source":"iana","compressible":true},"application/atsc-rsat+xml":{"source":"iana","compressible":true,"extensions":["rsat"]},"application/atxml":{"source":"iana"},"application/auth-policy+xml":{"source":"iana","compressible":true},"application/bacnet-xdd+zip":{"source":"iana","compressible":false},"application/batch-smtp":{"source":"iana"},"application/bdoc":{"compressible":false,"extensions":["bdoc"]},"application/beep+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/calendar+json":{"source":"iana","compressible":true},"application/calendar+xml":{"source":"iana","compressible":true,"extensions":["xcs"]},"application/call-completion":{"source":"iana"},"application/cals-1840":{"source":"iana"},"application/captive+json":{"source":"iana","compressible":true},"application/cbor":{"source":"iana"},"application/cbor-seq":{"source":"iana"},"application/cccex":{"source":"iana"},"application/ccmp+xml":{"source":"iana","compressible":true},"application/ccxml+xml":{"source":"iana","compressible":true,"extensions":["ccxml"]},"application/cdfx+xml":{"source":"iana","compressible":true,"extensions":["cdfx"]},"application/cdmi-capability":{"source":"iana","extensions":["cdmia"]},"application/cdmi-container":{"source":"iana","extensions":["cdmic"]},"application/cdmi-domain":{"source":"iana","extensions":["cdmid"]},"application/cdmi-object":{"source":"iana","extensions":["cdmio"]},"application/cdmi-queue":{"source":"iana","extensions":["cdmiq"]},"application/cdni":{"source":"iana"},"application/cea":{"source":"iana"},"application/cea-2018+xml":{"source":"iana","compressible":true},"application/cellml+xml":{"source":"iana","compressible":true},"application/cfw":{"source":"iana"},"application/city+json":{"source":"iana","compressible":true},"application/clr":{"source":"iana"},"application/clue+xml":{"source":"iana","compressible":true},"application/clue_info+xml":{"source":"iana","compressible":true},"application/cms":{"source":"iana"},"application/cnrp+xml":{"source":"iana","compressible":true},"application/coap-group+json":{"source":"iana","compressible":true},"application/coap-payload":{"source":"iana"},"application/commonground":{"source":"iana"},"application/conference-info+xml":{"source":"iana","compressible":true},"application/cose":{"source":"iana"},"application/cose-key":{"source":"iana"},"application/cose-key-set":{"source":"iana"},"application/cpl+xml":{"source":"iana","compressible":true,"extensions":["cpl"]},"application/csrattrs":{"source":"iana"},"application/csta+xml":{"source":"iana","compressible":true},"application/cstadata+xml":{"source":"iana","compressible":true},"application/csvm+json":{"source":"iana","compressible":true},"application/cu-seeme":{"source":"apache","extensions":["cu"]},"application/cwt":{"source":"iana"},"application/cybercash":{"source":"iana"},"application/dart":{"compressible":true},"application/dash+xml":{"source":"iana","compressible":true,"extensions":["mpd"]},"application/dash-patch+xml":{"source":"iana","compressible":true,"extensions":["mpp"]},"application/dashdelta":{"source":"iana"},"application/davmount+xml":{"source":"iana","compressible":true,"extensions":["davmount"]},"application/dca-rft":{"source":"iana"},"application/dcd":{"source":"iana"},"application/dec-dx":{"source":"iana"},"application/dialog-info+xml":{"source":"iana","compressible":true},"application/dicom":{"source":"iana"},"application/dicom+json":{"source":"iana","compressible":true},"application/dicom+xml":{"source":"iana","compressible":true},"application/dii":{"source":"iana"},"application/dit":{"source":"iana"},"application/dns":{"source":"iana"},"application/dns+json":{"source":"iana","compressible":true},"application/dns-message":{"source":"iana"},"application/docbook+xml":{"source":"apache","compressible":true,"extensions":["dbk"]},"application/dots+cbor":{"source":"iana"},"application/dskpp+xml":{"source":"iana","compressible":true},"application/dssc+der":{"source":"iana","extensions":["dssc"]},"application/dssc+xml":{"source":"iana","compressible":true,"extensions":["xdssc"]},"application/dvcs":{"source":"iana"},"application/ecmascript":{"source":"iana","compressible":true,"extensions":["es","ecma"]},"application/edi-consent":{"source":"iana"},"application/edi-x12":{"source":"iana","compressible":false},"application/edifact":{"source":"iana","compressible":false},"application/efi":{"source":"iana"},"application/elm+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/elm+xml":{"source":"iana","compressible":true},"application/emergencycalldata.cap+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/emergencycalldata.comment+xml":{"source":"iana","compressible":true},"application/emergencycalldata.control+xml":{"source":"iana","compressible":true},"application/emergencycalldata.deviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.ecall.msd":{"source":"iana"},"application/emergencycalldata.providerinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.serviceinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.subscriberinfo+xml":{"source":"iana","compressible":true},"application/emergencycalldata.veds+xml":{"source":"iana","compressible":true},"application/emma+xml":{"source":"iana","compressible":true,"extensions":["emma"]},"application/emotionml+xml":{"source":"iana","compressible":true,"extensions":["emotionml"]},"application/encaprtp":{"source":"iana"},"application/epp+xml":{"source":"iana","compressible":true},"application/epub+zip":{"source":"iana","compressible":false,"extensions":["epub"]},"application/eshop":{"source":"iana"},"application/exi":{"source":"iana","extensions":["exi"]},"application/expect-ct-report+json":{"source":"iana","compressible":true},"application/express":{"source":"iana","extensions":["exp"]},"application/fastinfoset":{"source":"iana"},"application/fastsoap":{"source":"iana"},"application/fdt+xml":{"source":"iana","compressible":true,"extensions":["fdt"]},"application/fhir+json":{"source":"iana","charset":"UTF-8","compressible":true},"application/fhir+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/fido.trusted-apps+json":{"compressible":true},"application/fits":{"source":"iana"},"application/flexfec":{"source":"iana"},"application/font-sfnt":{"source":"iana"},"application/font-tdpfr":{"source":"iana","extensions":["pfr"]},"application/font-woff":{"source":"iana","compressible":false},"application/framework-attributes+xml":{"source":"iana","compressible":true},"application/geo+json":{"source":"iana","compressible":true,"extensions":["geojson"]},"application/geo+json-seq":{"source":"iana"},"application/geopackage+sqlite3":{"source":"iana"},"application/geoxacml+xml":{"source":"iana","compressible":true},"application/gltf-buffer":{"source":"iana"},"application/gml+xml":{"source":"iana","compressible":true,"extensions":["gml"]},"application/gpx+xml":{"source":"apache","compressible":true,"extensions":["gpx"]},"application/gxf":{"source":"apache","extensions":["gxf"]},"application/gzip":{"source":"iana","compressible":false,"extensions":["gz"]},"application/h224":{"source":"iana"},"application/held+xml":{"source":"iana","compressible":true},"application/hjson":{"extensions":["hjson"]},"application/http":{"source":"iana"},"application/hyperstudio":{"source":"iana","extensions":["stk"]},"application/ibe-key-request+xml":{"source":"iana","compressible":true},"application/ibe-pkg-reply+xml":{"source":"iana","compressible":true},"application/ibe-pp-data":{"source":"iana"},"application/iges":{"source":"iana"},"application/im-iscomposing+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/index":{"source":"iana"},"application/index.cmd":{"source":"iana"},"application/index.obj":{"source":"iana"},"application/index.response":{"source":"iana"},"application/index.vnd":{"source":"iana"},"application/inkml+xml":{"source":"iana","compressible":true,"extensions":["ink","inkml"]},"application/iotp":{"source":"iana"},"application/ipfix":{"source":"iana","extensions":["ipfix"]},"application/ipp":{"source":"iana"},"application/isup":{"source":"iana"},"application/its+xml":{"source":"iana","compressible":true,"extensions":["its"]},"application/java-archive":{"source":"apache","compressible":false,"extensions":["jar","war","ear"]},"application/java-serialized-object":{"source":"apache","compressible":false,"extensions":["ser"]},"application/java-vm":{"source":"apache","compressible":false,"extensions":["class"]},"application/javascript":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["js","mjs"]},"application/jf2feed+json":{"source":"iana","compressible":true},"application/jose":{"source":"iana"},"application/jose+json":{"source":"iana","compressible":true},"application/jrd+json":{"source":"iana","compressible":true},"application/jscalendar+json":{"source":"iana","compressible":true},"application/json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["json","map"]},"application/json-patch+json":{"source":"iana","compressible":true},"application/json-seq":{"source":"iana"},"application/json5":{"extensions":["json5"]},"application/jsonml+json":{"source":"apache","compressible":true,"extensions":["jsonml"]},"application/jwk+json":{"source":"iana","compressible":true},"application/jwk-set+json":{"source":"iana","compressible":true},"application/jwt":{"source":"iana"},"application/kpml-request+xml":{"source":"iana","compressible":true},"application/kpml-response+xml":{"source":"iana","compressible":true},"application/ld+json":{"source":"iana","compressible":true,"extensions":["jsonld"]},"application/lgr+xml":{"source":"iana","compressible":true,"extensions":["lgr"]},"application/link-format":{"source":"iana"},"application/load-control+xml":{"source":"iana","compressible":true},"application/lost+xml":{"source":"iana","compressible":true,"extensions":["lostxml"]},"application/lostsync+xml":{"source":"iana","compressible":true},"application/lpf+zip":{"source":"iana","compressible":false},"application/lxf":{"source":"iana"},"application/mac-binhex40":{"source":"iana","extensions":["hqx"]},"application/mac-compactpro":{"source":"apache","extensions":["cpt"]},"application/macwriteii":{"source":"iana"},"application/mads+xml":{"source":"iana","compressible":true,"extensions":["mads"]},"application/manifest+json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["webmanifest"]},"application/marc":{"source":"iana","extensions":["mrc"]},"application/marcxml+xml":{"source":"iana","compressible":true,"extensions":["mrcx"]},"application/mathematica":{"source":"iana","extensions":["ma","nb","mb"]},"application/mathml+xml":{"source":"iana","compressible":true,"extensions":["mathml"]},"application/mathml-content+xml":{"source":"iana","compressible":true},"application/mathml-presentation+xml":{"source":"iana","compressible":true},"application/mbms-associated-procedure-description+xml":{"source":"iana","compressible":true},"application/mbms-deregister+xml":{"source":"iana","compressible":true},"application/mbms-envelope+xml":{"source":"iana","compressible":true},"application/mbms-msk+xml":{"source":"iana","compressible":true},"application/mbms-msk-response+xml":{"source":"iana","compressible":true},"application/mbms-protection-description+xml":{"source":"iana","compressible":true},"application/mbms-reception-report+xml":{"source":"iana","compressible":true},"application/mbms-register+xml":{"source":"iana","compressible":true},"application/mbms-register-response+xml":{"source":"iana","compressible":true},"application/mbms-schedule+xml":{"source":"iana","compressible":true},"application/mbms-user-service-description+xml":{"source":"iana","compressible":true},"application/mbox":{"source":"iana","extensions":["mbox"]},"application/media-policy-dataset+xml":{"source":"iana","compressible":true,"extensions":["mpf"]},"application/media_control+xml":{"source":"iana","compressible":true},"application/mediaservercontrol+xml":{"source":"iana","compressible":true,"extensions":["mscml"]},"application/merge-patch+json":{"source":"iana","compressible":true},"application/metalink+xml":{"source":"apache","compressible":true,"extensions":["metalink"]},"application/metalink4+xml":{"source":"iana","compressible":true,"extensions":["meta4"]},"application/mets+xml":{"source":"iana","compressible":true,"extensions":["mets"]},"application/mf4":{"source":"iana"},"application/mikey":{"source":"iana"},"application/mipc":{"source":"iana"},"application/missing-blocks+cbor-seq":{"source":"iana"},"application/mmt-aei+xml":{"source":"iana","compressible":true,"extensions":["maei"]},"application/mmt-usd+xml":{"source":"iana","compressible":true,"extensions":["musd"]},"application/mods+xml":{"source":"iana","compressible":true,"extensions":["mods"]},"application/moss-keys":{"source":"iana"},"application/moss-signature":{"source":"iana"},"application/mosskey-data":{"source":"iana"},"application/mosskey-request":{"source":"iana"},"application/mp21":{"source":"iana","extensions":["m21","mp21"]},"application/mp4":{"source":"iana","extensions":["mp4s","m4p"]},"application/mpeg4-generic":{"source":"iana"},"application/mpeg4-iod":{"source":"iana"},"application/mpeg4-iod-xmt":{"source":"iana"},"application/mrb-consumer+xml":{"source":"iana","compressible":true},"application/mrb-publish+xml":{"source":"iana","compressible":true},"application/msc-ivr+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msc-mixer+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/msword":{"source":"iana","compressible":false,"extensions":["doc","dot"]},"application/mud+json":{"source":"iana","compressible":true},"application/multipart-core":{"source":"iana"},"application/mxf":{"source":"iana","extensions":["mxf"]},"application/n-quads":{"source":"iana","extensions":["nq"]},"application/n-triples":{"source":"iana","extensions":["nt"]},"application/nasdata":{"source":"iana"},"application/news-checkgroups":{"source":"iana","charset":"US-ASCII"},"application/news-groupinfo":{"source":"iana","charset":"US-ASCII"},"application/news-transmission":{"source":"iana"},"application/nlsml+xml":{"source":"iana","compressible":true},"application/node":{"source":"iana","extensions":["cjs"]},"application/nss":{"source":"iana"},"application/oauth-authz-req+jwt":{"source":"iana"},"application/oblivious-dns-message":{"source":"iana"},"application/ocsp-request":{"source":"iana"},"application/ocsp-response":{"source":"iana"},"application/octet-stream":{"source":"iana","compressible":false,"extensions":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]},"application/oda":{"source":"iana","extensions":["oda"]},"application/odm+xml":{"source":"iana","compressible":true},"application/odx":{"source":"iana"},"application/oebps-package+xml":{"source":"iana","compressible":true,"extensions":["opf"]},"application/ogg":{"source":"iana","compressible":false,"extensions":["ogx"]},"application/omdoc+xml":{"source":"apache","compressible":true,"extensions":["omdoc"]},"application/onenote":{"source":"apache","extensions":["onetoc","onetoc2","onetmp","onepkg"]},"application/opc-nodeset+xml":{"source":"iana","compressible":true},"application/oscore":{"source":"iana"},"application/oxps":{"source":"iana","extensions":["oxps"]},"application/p21":{"source":"iana"},"application/p21+zip":{"source":"iana","compressible":false},"application/p2p-overlay+xml":{"source":"iana","compressible":true,"extensions":["relo"]},"application/parityfec":{"source":"iana"},"application/passport":{"source":"iana"},"application/patch-ops-error+xml":{"source":"iana","compressible":true,"extensions":["xer"]},"application/pdf":{"source":"iana","compressible":false,"extensions":["pdf"]},"application/pdx":{"source":"iana"},"application/pem-certificate-chain":{"source":"iana"},"application/pgp-encrypted":{"source":"iana","compressible":false,"extensions":["pgp"]},"application/pgp-keys":{"source":"iana","extensions":["asc"]},"application/pgp-signature":{"source":"iana","extensions":["asc","sig"]},"application/pics-rules":{"source":"apache","extensions":["prf"]},"application/pidf+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pidf-diff+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/pkcs10":{"source":"iana","extensions":["p10"]},"application/pkcs12":{"source":"iana"},"application/pkcs7-mime":{"source":"iana","extensions":["p7m","p7c"]},"application/pkcs7-signature":{"source":"iana","extensions":["p7s"]},"application/pkcs8":{"source":"iana","extensions":["p8"]},"application/pkcs8-encrypted":{"source":"iana"},"application/pkix-attr-cert":{"source":"iana","extensions":["ac"]},"application/pkix-cert":{"source":"iana","extensions":["cer"]},"application/pkix-crl":{"source":"iana","extensions":["crl"]},"application/pkix-pkipath":{"source":"iana","extensions":["pkipath"]},"application/pkixcmp":{"source":"iana","extensions":["pki"]},"application/pls+xml":{"source":"iana","compressible":true,"extensions":["pls"]},"application/poc-settings+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/postscript":{"source":"iana","compressible":true,"extensions":["ai","eps","ps"]},"application/ppsp-tracker+json":{"source":"iana","compressible":true},"application/problem+json":{"source":"iana","compressible":true},"application/problem+xml":{"source":"iana","compressible":true},"application/provenance+xml":{"source":"iana","compressible":true,"extensions":["provx"]},"application/prs.alvestrand.titrax-sheet":{"source":"iana"},"application/prs.cww":{"source":"iana","extensions":["cww"]},"application/prs.cyn":{"source":"iana","charset":"7-BIT"},"application/prs.hpub+zip":{"source":"iana","compressible":false},"application/prs.nprend":{"source":"iana"},"application/prs.plucker":{"source":"iana"},"application/prs.rdf-xml-crypt":{"source":"iana"},"application/prs.xsf+xml":{"source":"iana","compressible":true},"application/pskc+xml":{"source":"iana","compressible":true,"extensions":["pskcxml"]},"application/pvd+json":{"source":"iana","compressible":true},"application/qsig":{"source":"iana"},"application/raml+yaml":{"compressible":true,"extensions":["raml"]},"application/raptorfec":{"source":"iana"},"application/rdap+json":{"source":"iana","compressible":true},"application/rdf+xml":{"source":"iana","compressible":true,"extensions":["rdf","owl"]},"application/reginfo+xml":{"source":"iana","compressible":true,"extensions":["rif"]},"application/relax-ng-compact-syntax":{"source":"iana","extensions":["rnc"]},"application/remote-printing":{"source":"iana"},"application/reputon+json":{"source":"iana","compressible":true},"application/resource-lists+xml":{"source":"iana","compressible":true,"extensions":["rl"]},"application/resource-lists-diff+xml":{"source":"iana","compressible":true,"extensions":["rld"]},"application/rfc+xml":{"source":"iana","compressible":true},"application/riscos":{"source":"iana"},"application/rlmi+xml":{"source":"iana","compressible":true},"application/rls-services+xml":{"source":"iana","compressible":true,"extensions":["rs"]},"application/route-apd+xml":{"source":"iana","compressible":true,"extensions":["rapd"]},"application/route-s-tsid+xml":{"source":"iana","compressible":true,"extensions":["sls"]},"application/route-usd+xml":{"source":"iana","compressible":true,"extensions":["rusd"]},"application/rpki-ghostbusters":{"source":"iana","extensions":["gbr"]},"application/rpki-manifest":{"source":"iana","extensions":["mft"]},"application/rpki-publication":{"source":"iana"},"application/rpki-roa":{"source":"iana","extensions":["roa"]},"application/rpki-updown":{"source":"iana"},"application/rsd+xml":{"source":"apache","compressible":true,"extensions":["rsd"]},"application/rss+xml":{"source":"apache","compressible":true,"extensions":["rss"]},"application/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"application/rtploopback":{"source":"iana"},"application/rtx":{"source":"iana"},"application/samlassertion+xml":{"source":"iana","compressible":true},"application/samlmetadata+xml":{"source":"iana","compressible":true},"application/sarif+json":{"source":"iana","compressible":true},"application/sarif-external-properties+json":{"source":"iana","compressible":true},"application/sbe":{"source":"iana"},"application/sbml+xml":{"source":"iana","compressible":true,"extensions":["sbml"]},"application/scaip+xml":{"source":"iana","compressible":true},"application/scim+json":{"source":"iana","compressible":true},"application/scvp-cv-request":{"source":"iana","extensions":["scq"]},"application/scvp-cv-response":{"source":"iana","extensions":["scs"]},"application/scvp-vp-request":{"source":"iana","extensions":["spq"]},"application/scvp-vp-response":{"source":"iana","extensions":["spp"]},"application/sdp":{"source":"iana","extensions":["sdp"]},"application/secevent+jwt":{"source":"iana"},"application/senml+cbor":{"source":"iana"},"application/senml+json":{"source":"iana","compressible":true},"application/senml+xml":{"source":"iana","compressible":true,"extensions":["senmlx"]},"application/senml-etch+cbor":{"source":"iana"},"application/senml-etch+json":{"source":"iana","compressible":true},"application/senml-exi":{"source":"iana"},"application/sensml+cbor":{"source":"iana"},"application/sensml+json":{"source":"iana","compressible":true},"application/sensml+xml":{"source":"iana","compressible":true,"extensions":["sensmlx"]},"application/sensml-exi":{"source":"iana"},"application/sep+xml":{"source":"iana","compressible":true},"application/sep-exi":{"source":"iana"},"application/session-info":{"source":"iana"},"application/set-payment":{"source":"iana"},"application/set-payment-initiation":{"source":"iana","extensions":["setpay"]},"application/set-registration":{"source":"iana"},"application/set-registration-initiation":{"source":"iana","extensions":["setreg"]},"application/sgml":{"source":"iana"},"application/sgml-open-catalog":{"source":"iana"},"application/shf+xml":{"source":"iana","compressible":true,"extensions":["shf"]},"application/sieve":{"source":"iana","extensions":["siv","sieve"]},"application/simple-filter+xml":{"source":"iana","compressible":true},"application/simple-message-summary":{"source":"iana"},"application/simplesymbolcontainer":{"source":"iana"},"application/sipc":{"source":"iana"},"application/slate":{"source":"iana"},"application/smil":{"source":"iana"},"application/smil+xml":{"source":"iana","compressible":true,"extensions":["smi","smil"]},"application/smpte336m":{"source":"iana"},"application/soap+fastinfoset":{"source":"iana"},"application/soap+xml":{"source":"iana","compressible":true},"application/sparql-query":{"source":"iana","extensions":["rq"]},"application/sparql-results+xml":{"source":"iana","compressible":true,"extensions":["srx"]},"application/spdx+json":{"source":"iana","compressible":true},"application/spirits-event+xml":{"source":"iana","compressible":true},"application/sql":{"source":"iana"},"application/srgs":{"source":"iana","extensions":["gram"]},"application/srgs+xml":{"source":"iana","compressible":true,"extensions":["grxml"]},"application/sru+xml":{"source":"iana","compressible":true,"extensions":["sru"]},"application/ssdl+xml":{"source":"apache","compressible":true,"extensions":["ssdl"]},"application/ssml+xml":{"source":"iana","compressible":true,"extensions":["ssml"]},"application/stix+json":{"source":"iana","compressible":true},"application/swid+xml":{"source":"iana","compressible":true,"extensions":["swidtag"]},"application/tamp-apex-update":{"source":"iana"},"application/tamp-apex-update-confirm":{"source":"iana"},"application/tamp-community-update":{"source":"iana"},"application/tamp-community-update-confirm":{"source":"iana"},"application/tamp-error":{"source":"iana"},"application/tamp-sequence-adjust":{"source":"iana"},"application/tamp-sequence-adjust-confirm":{"source":"iana"},"application/tamp-status-query":{"source":"iana"},"application/tamp-status-response":{"source":"iana"},"application/tamp-update":{"source":"iana"},"application/tamp-update-confirm":{"source":"iana"},"application/tar":{"compressible":true},"application/taxii+json":{"source":"iana","compressible":true},"application/td+json":{"source":"iana","compressible":true},"application/tei+xml":{"source":"iana","compressible":true,"extensions":["tei","teicorpus"]},"application/tetra_isi":{"source":"iana"},"application/thraud+xml":{"source":"iana","compressible":true,"extensions":["tfi"]},"application/timestamp-query":{"source":"iana"},"application/timestamp-reply":{"source":"iana"},"application/timestamped-data":{"source":"iana","extensions":["tsd"]},"application/tlsrpt+gzip":{"source":"iana"},"application/tlsrpt+json":{"source":"iana","compressible":true},"application/tnauthlist":{"source":"iana"},"application/token-introspection+jwt":{"source":"iana"},"application/toml":{"compressible":true,"extensions":["toml"]},"application/trickle-ice-sdpfrag":{"source":"iana"},"application/trig":{"source":"iana","extensions":["trig"]},"application/ttml+xml":{"source":"iana","compressible":true,"extensions":["ttml"]},"application/tve-trigger":{"source":"iana"},"application/tzif":{"source":"iana"},"application/tzif-leap":{"source":"iana"},"application/ubjson":{"compressible":false,"extensions":["ubj"]},"application/ulpfec":{"source":"iana"},"application/urc-grpsheet+xml":{"source":"iana","compressible":true},"application/urc-ressheet+xml":{"source":"iana","compressible":true,"extensions":["rsheet"]},"application/urc-targetdesc+xml":{"source":"iana","compressible":true,"extensions":["td"]},"application/urc-uisocketdesc+xml":{"source":"iana","compressible":true},"application/vcard+json":{"source":"iana","compressible":true},"application/vcard+xml":{"source":"iana","compressible":true},"application/vemmi":{"source":"iana"},"application/vividence.scriptfile":{"source":"apache"},"application/vnd.1000minds.decision-model+xml":{"source":"iana","compressible":true,"extensions":["1km"]},"application/vnd.3gpp-prose+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-prose-pc3ch+xml":{"source":"iana","compressible":true},"application/vnd.3gpp-v2x-local-service-information":{"source":"iana"},"application/vnd.3gpp.5gnas":{"source":"iana"},"application/vnd.3gpp.access-transfer-events+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.bsf+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gmop+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.gtpc":{"source":"iana"},"application/vnd.3gpp.interworking-data":{"source":"iana"},"application/vnd.3gpp.lpp":{"source":"iana"},"application/vnd.3gpp.mc-signalling-ear":{"source":"iana"},"application/vnd.3gpp.mcdata-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-payload":{"source":"iana"},"application/vnd.3gpp.mcdata-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-signalling":{"source":"iana"},"application/vnd.3gpp.mcdata-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcdata-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-floor-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-signed+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-ue-init-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcptt-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-command+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-affiliation-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-location-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-mbms-usage-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-service-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-transmission-request+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-ue-config+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mcvideo-user-profile+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.mid-call+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ngap":{"source":"iana"},"application/vnd.3gpp.pfcp":{"source":"iana"},"application/vnd.3gpp.pic-bw-large":{"source":"iana","extensions":["plb"]},"application/vnd.3gpp.pic-bw-small":{"source":"iana","extensions":["psb"]},"application/vnd.3gpp.pic-bw-var":{"source":"iana","extensions":["pvb"]},"application/vnd.3gpp.s1ap":{"source":"iana"},"application/vnd.3gpp.sms":{"source":"iana"},"application/vnd.3gpp.sms+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-ext+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.srvcc-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.state-and-event-info+xml":{"source":"iana","compressible":true},"application/vnd.3gpp.ussd+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.bcmcsinfo+xml":{"source":"iana","compressible":true},"application/vnd.3gpp2.sms":{"source":"iana"},"application/vnd.3gpp2.tcap":{"source":"iana","extensions":["tcap"]},"application/vnd.3lightssoftware.imagescal":{"source":"iana"},"application/vnd.3m.post-it-notes":{"source":"iana","extensions":["pwn"]},"application/vnd.accpac.simply.aso":{"source":"iana","extensions":["aso"]},"application/vnd.accpac.simply.imp":{"source":"iana","extensions":["imp"]},"application/vnd.acucobol":{"source":"iana","extensions":["acu"]},"application/vnd.acucorp":{"source":"iana","extensions":["atc","acutc"]},"application/vnd.adobe.air-application-installer-package+zip":{"source":"apache","compressible":false,"extensions":["air"]},"application/vnd.adobe.flash.movie":{"source":"iana"},"application/vnd.adobe.formscentral.fcdt":{"source":"iana","extensions":["fcdt"]},"application/vnd.adobe.fxp":{"source":"iana","extensions":["fxp","fxpl"]},"application/vnd.adobe.partial-upload":{"source":"iana"},"application/vnd.adobe.xdp+xml":{"source":"iana","compressible":true,"extensions":["xdp"]},"application/vnd.adobe.xfdf":{"source":"iana","extensions":["xfdf"]},"application/vnd.aether.imp":{"source":"iana"},"application/vnd.afpc.afplinedata":{"source":"iana"},"application/vnd.afpc.afplinedata-pagedef":{"source":"iana"},"application/vnd.afpc.cmoca-cmresource":{"source":"iana"},"application/vnd.afpc.foca-charset":{"source":"iana"},"application/vnd.afpc.foca-codedfont":{"source":"iana"},"application/vnd.afpc.foca-codepage":{"source":"iana"},"application/vnd.afpc.modca":{"source":"iana"},"application/vnd.afpc.modca-cmtable":{"source":"iana"},"application/vnd.afpc.modca-formdef":{"source":"iana"},"application/vnd.afpc.modca-mediummap":{"source":"iana"},"application/vnd.afpc.modca-objectcontainer":{"source":"iana"},"application/vnd.afpc.modca-overlay":{"source":"iana"},"application/vnd.afpc.modca-pagesegment":{"source":"iana"},"application/vnd.age":{"source":"iana","extensions":["age"]},"application/vnd.ah-barcode":{"source":"iana"},"application/vnd.ahead.space":{"source":"iana","extensions":["ahead"]},"application/vnd.airzip.filesecure.azf":{"source":"iana","extensions":["azf"]},"application/vnd.airzip.filesecure.azs":{"source":"iana","extensions":["azs"]},"application/vnd.amadeus+json":{"source":"iana","compressible":true},"application/vnd.amazon.ebook":{"source":"apache","extensions":["azw"]},"application/vnd.amazon.mobi8-ebook":{"source":"iana"},"application/vnd.americandynamics.acc":{"source":"iana","extensions":["acc"]},"application/vnd.amiga.ami":{"source":"iana","extensions":["ami"]},"application/vnd.amundsen.maze+xml":{"source":"iana","compressible":true},"application/vnd.android.ota":{"source":"iana"},"application/vnd.android.package-archive":{"source":"apache","compressible":false,"extensions":["apk"]},"application/vnd.anki":{"source":"iana"},"application/vnd.anser-web-certificate-issue-initiation":{"source":"iana","extensions":["cii"]},"application/vnd.anser-web-funds-transfer-initiation":{"source":"apache","extensions":["fti"]},"application/vnd.antix.game-component":{"source":"iana","extensions":["atx"]},"application/vnd.apache.arrow.file":{"source":"iana"},"application/vnd.apache.arrow.stream":{"source":"iana"},"application/vnd.apache.thrift.binary":{"source":"iana"},"application/vnd.apache.thrift.compact":{"source":"iana"},"application/vnd.apache.thrift.json":{"source":"iana"},"application/vnd.api+json":{"source":"iana","compressible":true},"application/vnd.aplextor.warrp+json":{"source":"iana","compressible":true},"application/vnd.apothekende.reservation+json":{"source":"iana","compressible":true},"application/vnd.apple.installer+xml":{"source":"iana","compressible":true,"extensions":["mpkg"]},"application/vnd.apple.keynote":{"source":"iana","extensions":["key"]},"application/vnd.apple.mpegurl":{"source":"iana","extensions":["m3u8"]},"application/vnd.apple.numbers":{"source":"iana","extensions":["numbers"]},"application/vnd.apple.pages":{"source":"iana","extensions":["pages"]},"application/vnd.apple.pkpass":{"compressible":false,"extensions":["pkpass"]},"application/vnd.arastra.swi":{"source":"iana"},"application/vnd.aristanetworks.swi":{"source":"iana","extensions":["swi"]},"application/vnd.artisan+json":{"source":"iana","compressible":true},"application/vnd.artsquare":{"source":"iana"},"application/vnd.astraea-software.iota":{"source":"iana","extensions":["iota"]},"application/vnd.audiograph":{"source":"iana","extensions":["aep"]},"application/vnd.autopackage":{"source":"iana"},"application/vnd.avalon+json":{"source":"iana","compressible":true},"application/vnd.avistar+xml":{"source":"iana","compressible":true},"application/vnd.balsamiq.bmml+xml":{"source":"iana","compressible":true,"extensions":["bmml"]},"application/vnd.balsamiq.bmpr":{"source":"iana"},"application/vnd.banana-accounting":{"source":"iana"},"application/vnd.bbf.usp.error":{"source":"iana"},"application/vnd.bbf.usp.msg":{"source":"iana"},"application/vnd.bbf.usp.msg+json":{"source":"iana","compressible":true},"application/vnd.bekitzur-stech+json":{"source":"iana","compressible":true},"application/vnd.bint.med-content":{"source":"iana"},"application/vnd.biopax.rdf+xml":{"source":"iana","compressible":true},"application/vnd.blink-idb-value-wrapper":{"source":"iana"},"application/vnd.blueice.multipass":{"source":"iana","extensions":["mpm"]},"application/vnd.bluetooth.ep.oob":{"source":"iana"},"application/vnd.bluetooth.le.oob":{"source":"iana"},"application/vnd.bmi":{"source":"iana","extensions":["bmi"]},"application/vnd.bpf":{"source":"iana"},"application/vnd.bpf3":{"source":"iana"},"application/vnd.businessobjects":{"source":"iana","extensions":["rep"]},"application/vnd.byu.uapi+json":{"source":"iana","compressible":true},"application/vnd.cab-jscript":{"source":"iana"},"application/vnd.canon-cpdl":{"source":"iana"},"application/vnd.canon-lips":{"source":"iana"},"application/vnd.capasystems-pg+json":{"source":"iana","compressible":true},"application/vnd.cendio.thinlinc.clientconf":{"source":"iana"},"application/vnd.century-systems.tcp_stream":{"source":"iana"},"application/vnd.chemdraw+xml":{"source":"iana","compressible":true,"extensions":["cdxml"]},"application/vnd.chess-pgn":{"source":"iana"},"application/vnd.chipnuts.karaoke-mmd":{"source":"iana","extensions":["mmd"]},"application/vnd.ciedi":{"source":"iana"},"application/vnd.cinderella":{"source":"iana","extensions":["cdy"]},"application/vnd.cirpack.isdn-ext":{"source":"iana"},"application/vnd.citationstyles.style+xml":{"source":"iana","compressible":true,"extensions":["csl"]},"application/vnd.claymore":{"source":"iana","extensions":["cla"]},"application/vnd.cloanto.rp9":{"source":"iana","extensions":["rp9"]},"application/vnd.clonk.c4group":{"source":"iana","extensions":["c4g","c4d","c4f","c4p","c4u"]},"application/vnd.cluetrust.cartomobile-config":{"source":"iana","extensions":["c11amc"]},"application/vnd.cluetrust.cartomobile-config-pkg":{"source":"iana","extensions":["c11amz"]},"application/vnd.coffeescript":{"source":"iana"},"application/vnd.collabio.xodocuments.document":{"source":"iana"},"application/vnd.collabio.xodocuments.document-template":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation-template":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet-template":{"source":"iana"},"application/vnd.collection+json":{"source":"iana","compressible":true},"application/vnd.collection.doc+json":{"source":"iana","compressible":true},"application/vnd.collection.next+json":{"source":"iana","compressible":true},"application/vnd.comicbook+zip":{"source":"iana","compressible":false},"application/vnd.comicbook-rar":{"source":"iana"},"application/vnd.commerce-battelle":{"source":"iana"},"application/vnd.commonspace":{"source":"iana","extensions":["csp"]},"application/vnd.contact.cmsg":{"source":"iana","extensions":["cdbcmsg"]},"application/vnd.coreos.ignition+json":{"source":"iana","compressible":true},"application/vnd.cosmocaller":{"source":"iana","extensions":["cmc"]},"application/vnd.crick.clicker":{"source":"iana","extensions":["clkx"]},"application/vnd.crick.clicker.keyboard":{"source":"iana","extensions":["clkk"]},"application/vnd.crick.clicker.palette":{"source":"iana","extensions":["clkp"]},"application/vnd.crick.clicker.template":{"source":"iana","extensions":["clkt"]},"application/vnd.crick.clicker.wordbank":{"source":"iana","extensions":["clkw"]},"application/vnd.criticaltools.wbs+xml":{"source":"iana","compressible":true,"extensions":["wbs"]},"application/vnd.cryptii.pipe+json":{"source":"iana","compressible":true},"application/vnd.crypto-shade-file":{"source":"iana"},"application/vnd.cryptomator.encrypted":{"source":"iana"},"application/vnd.cryptomator.vault":{"source":"iana"},"application/vnd.ctc-posml":{"source":"iana","extensions":["pml"]},"application/vnd.ctct.ws+xml":{"source":"iana","compressible":true},"application/vnd.cups-pdf":{"source":"iana"},"application/vnd.cups-postscript":{"source":"iana"},"application/vnd.cups-ppd":{"source":"iana","extensions":["ppd"]},"application/vnd.cups-raster":{"source":"iana"},"application/vnd.cups-raw":{"source":"iana"},"application/vnd.curl":{"source":"iana"},"application/vnd.curl.car":{"source":"apache","extensions":["car"]},"application/vnd.curl.pcurl":{"source":"apache","extensions":["pcurl"]},"application/vnd.cyan.dean.root+xml":{"source":"iana","compressible":true},"application/vnd.cybank":{"source":"iana"},"application/vnd.cyclonedx+json":{"source":"iana","compressible":true},"application/vnd.cyclonedx+xml":{"source":"iana","compressible":true},"application/vnd.d2l.coursepackage1p0+zip":{"source":"iana","compressible":false},"application/vnd.d3m-dataset":{"source":"iana"},"application/vnd.d3m-problem":{"source":"iana"},"application/vnd.dart":{"source":"iana","compressible":true,"extensions":["dart"]},"application/vnd.data-vision.rdz":{"source":"iana","extensions":["rdz"]},"application/vnd.datapackage+json":{"source":"iana","compressible":true},"application/vnd.dataresource+json":{"source":"iana","compressible":true},"application/vnd.dbf":{"source":"iana","extensions":["dbf"]},"application/vnd.debian.binary-package":{"source":"iana"},"application/vnd.dece.data":{"source":"iana","extensions":["uvf","uvvf","uvd","uvvd"]},"application/vnd.dece.ttml+xml":{"source":"iana","compressible":true,"extensions":["uvt","uvvt"]},"application/vnd.dece.unspecified":{"source":"iana","extensions":["uvx","uvvx"]},"application/vnd.dece.zip":{"source":"iana","extensions":["uvz","uvvz"]},"application/vnd.denovo.fcselayout-link":{"source":"iana","extensions":["fe_launch"]},"application/vnd.desmume.movie":{"source":"iana"},"application/vnd.dir-bi.plate-dl-nosuffix":{"source":"iana"},"application/vnd.dm.delegation+xml":{"source":"iana","compressible":true},"application/vnd.dna":{"source":"iana","extensions":["dna"]},"application/vnd.document+json":{"source":"iana","compressible":true},"application/vnd.dolby.mlp":{"source":"apache","extensions":["mlp"]},"application/vnd.dolby.mobile.1":{"source":"iana"},"application/vnd.dolby.mobile.2":{"source":"iana"},"application/vnd.doremir.scorecloud-binary-document":{"source":"iana"},"application/vnd.dpgraph":{"source":"iana","extensions":["dpg"]},"application/vnd.dreamfactory":{"source":"iana","extensions":["dfac"]},"application/vnd.drive+json":{"source":"iana","compressible":true},"application/vnd.ds-keypoint":{"source":"apache","extensions":["kpxx"]},"application/vnd.dtg.local":{"source":"iana"},"application/vnd.dtg.local.flash":{"source":"iana"},"application/vnd.dtg.local.html":{"source":"iana"},"application/vnd.dvb.ait":{"source":"iana","extensions":["ait"]},"application/vnd.dvb.dvbisl+xml":{"source":"iana","compressible":true},"application/vnd.dvb.dvbj":{"source":"iana"},"application/vnd.dvb.esgcontainer":{"source":"iana"},"application/vnd.dvb.ipdcdftnotifaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess2":{"source":"iana"},"application/vnd.dvb.ipdcesgpdd":{"source":"iana"},"application/vnd.dvb.ipdcroaming":{"source":"iana"},"application/vnd.dvb.iptv.alfec-base":{"source":"iana"},"application/vnd.dvb.iptv.alfec-enhancement":{"source":"iana"},"application/vnd.dvb.notif-aggregate-root+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-container+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-generic+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-msglist+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-request+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-ia-registration-response+xml":{"source":"iana","compressible":true},"application/vnd.dvb.notif-init+xml":{"source":"iana","compressible":true},"application/vnd.dvb.pfr":{"source":"iana"},"application/vnd.dvb.service":{"source":"iana","extensions":["svc"]},"application/vnd.dxr":{"source":"iana"},"application/vnd.dynageo":{"source":"iana","extensions":["geo"]},"application/vnd.dzr":{"source":"iana"},"application/vnd.easykaraoke.cdgdownload":{"source":"iana"},"application/vnd.ecdis-update":{"source":"iana"},"application/vnd.ecip.rlp":{"source":"iana"},"application/vnd.eclipse.ditto+json":{"source":"iana","compressible":true},"application/vnd.ecowin.chart":{"source":"iana","extensions":["mag"]},"application/vnd.ecowin.filerequest":{"source":"iana"},"application/vnd.ecowin.fileupdate":{"source":"iana"},"application/vnd.ecowin.series":{"source":"iana"},"application/vnd.ecowin.seriesrequest":{"source":"iana"},"application/vnd.ecowin.seriesupdate":{"source":"iana"},"application/vnd.efi.img":{"source":"iana"},"application/vnd.efi.iso":{"source":"iana"},"application/vnd.emclient.accessrequest+xml":{"source":"iana","compressible":true},"application/vnd.enliven":{"source":"iana","extensions":["nml"]},"application/vnd.enphase.envoy":{"source":"iana"},"application/vnd.eprints.data+xml":{"source":"iana","compressible":true},"application/vnd.epson.esf":{"source":"iana","extensions":["esf"]},"application/vnd.epson.msf":{"source":"iana","extensions":["msf"]},"application/vnd.epson.quickanime":{"source":"iana","extensions":["qam"]},"application/vnd.epson.salt":{"source":"iana","extensions":["slt"]},"application/vnd.epson.ssf":{"source":"iana","extensions":["ssf"]},"application/vnd.ericsson.quickcall":{"source":"iana"},"application/vnd.espass-espass+zip":{"source":"iana","compressible":false},"application/vnd.eszigno3+xml":{"source":"iana","compressible":true,"extensions":["es3","et3"]},"application/vnd.etsi.aoc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.asic-e+zip":{"source":"iana","compressible":false},"application/vnd.etsi.asic-s+zip":{"source":"iana","compressible":false},"application/vnd.etsi.cug+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvcommand+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-bc+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-cod+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsad-npvr+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvservice+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvsync+xml":{"source":"iana","compressible":true},"application/vnd.etsi.iptvueprofile+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mcid+xml":{"source":"iana","compressible":true},"application/vnd.etsi.mheg5":{"source":"iana"},"application/vnd.etsi.overload-control-policy-dataset+xml":{"source":"iana","compressible":true},"application/vnd.etsi.pstn+xml":{"source":"iana","compressible":true},"application/vnd.etsi.sci+xml":{"source":"iana","compressible":true},"application/vnd.etsi.simservs+xml":{"source":"iana","compressible":true},"application/vnd.etsi.timestamp-token":{"source":"iana"},"application/vnd.etsi.tsl+xml":{"source":"iana","compressible":true},"application/vnd.etsi.tsl.der":{"source":"iana"},"application/vnd.eu.kasparian.car+json":{"source":"iana","compressible":true},"application/vnd.eudora.data":{"source":"iana"},"application/vnd.evolv.ecig.profile":{"source":"iana"},"application/vnd.evolv.ecig.settings":{"source":"iana"},"application/vnd.evolv.ecig.theme":{"source":"iana"},"application/vnd.exstream-empower+zip":{"source":"iana","compressible":false},"application/vnd.exstream-package":{"source":"iana"},"application/vnd.ezpix-album":{"source":"iana","extensions":["ez2"]},"application/vnd.ezpix-package":{"source":"iana","extensions":["ez3"]},"application/vnd.f-secure.mobile":{"source":"iana"},"application/vnd.familysearch.gedcom+zip":{"source":"iana","compressible":false},"application/vnd.fastcopy-disk-image":{"source":"iana"},"application/vnd.fdf":{"source":"iana","extensions":["fdf"]},"application/vnd.fdsn.mseed":{"source":"iana","extensions":["mseed"]},"application/vnd.fdsn.seed":{"source":"iana","extensions":["seed","dataless"]},"application/vnd.ffsns":{"source":"iana"},"application/vnd.ficlab.flb+zip":{"source":"iana","compressible":false},"application/vnd.filmit.zfc":{"source":"iana"},"application/vnd.fints":{"source":"iana"},"application/vnd.firemonkeys.cloudcell":{"source":"iana"},"application/vnd.flographit":{"source":"iana","extensions":["gph"]},"application/vnd.fluxtime.clip":{"source":"iana","extensions":["ftc"]},"application/vnd.font-fontforge-sfd":{"source":"iana"},"application/vnd.framemaker":{"source":"iana","extensions":["fm","frame","maker","book"]},"application/vnd.frogans.fnc":{"source":"iana","extensions":["fnc"]},"application/vnd.frogans.ltf":{"source":"iana","extensions":["ltf"]},"application/vnd.fsc.weblaunch":{"source":"iana","extensions":["fsc"]},"application/vnd.fujifilm.fb.docuworks":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.binder":{"source":"iana"},"application/vnd.fujifilm.fb.docuworks.container":{"source":"iana"},"application/vnd.fujifilm.fb.jfi+xml":{"source":"iana","compressible":true},"application/vnd.fujitsu.oasys":{"source":"iana","extensions":["oas"]},"application/vnd.fujitsu.oasys2":{"source":"iana","extensions":["oa2"]},"application/vnd.fujitsu.oasys3":{"source":"iana","extensions":["oa3"]},"application/vnd.fujitsu.oasysgp":{"source":"iana","extensions":["fg5"]},"application/vnd.fujitsu.oasysprs":{"source":"iana","extensions":["bh2"]},"application/vnd.fujixerox.art-ex":{"source":"iana"},"application/vnd.fujixerox.art4":{"source":"iana"},"application/vnd.fujixerox.ddd":{"source":"iana","extensions":["ddd"]},"application/vnd.fujixerox.docuworks":{"source":"iana","extensions":["xdw"]},"application/vnd.fujixerox.docuworks.binder":{"source":"iana","extensions":["xbd"]},"application/vnd.fujixerox.docuworks.container":{"source":"iana"},"application/vnd.fujixerox.hbpl":{"source":"iana"},"application/vnd.fut-misnet":{"source":"iana"},"application/vnd.futoin+cbor":{"source":"iana"},"application/vnd.futoin+json":{"source":"iana","compressible":true},"application/vnd.fuzzysheet":{"source":"iana","extensions":["fzs"]},"application/vnd.genomatix.tuxedo":{"source":"iana","extensions":["txd"]},"application/vnd.gentics.grd+json":{"source":"iana","compressible":true},"application/vnd.geo+json":{"source":"iana","compressible":true},"application/vnd.geocube+xml":{"source":"iana","compressible":true},"application/vnd.geogebra.file":{"source":"iana","extensions":["ggb"]},"application/vnd.geogebra.slides":{"source":"iana"},"application/vnd.geogebra.tool":{"source":"iana","extensions":["ggt"]},"application/vnd.geometry-explorer":{"source":"iana","extensions":["gex","gre"]},"application/vnd.geonext":{"source":"iana","extensions":["gxt"]},"application/vnd.geoplan":{"source":"iana","extensions":["g2w"]},"application/vnd.geospace":{"source":"iana","extensions":["g3w"]},"application/vnd.gerber":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt-response":{"source":"iana"},"application/vnd.gmx":{"source":"iana","extensions":["gmx"]},"application/vnd.google-apps.document":{"compressible":false,"extensions":["gdoc"]},"application/vnd.google-apps.presentation":{"compressible":false,"extensions":["gslides"]},"application/vnd.google-apps.spreadsheet":{"compressible":false,"extensions":["gsheet"]},"application/vnd.google-earth.kml+xml":{"source":"iana","compressible":true,"extensions":["kml"]},"application/vnd.google-earth.kmz":{"source":"iana","compressible":false,"extensions":["kmz"]},"application/vnd.gov.sk.e-form+xml":{"source":"iana","compressible":true},"application/vnd.gov.sk.e-form+zip":{"source":"iana","compressible":false},"application/vnd.gov.sk.xmldatacontainer+xml":{"source":"iana","compressible":true},"application/vnd.grafeq":{"source":"iana","extensions":["gqf","gqs"]},"application/vnd.gridmp":{"source":"iana"},"application/vnd.groove-account":{"source":"iana","extensions":["gac"]},"application/vnd.groove-help":{"source":"iana","extensions":["ghf"]},"application/vnd.groove-identity-message":{"source":"iana","extensions":["gim"]},"application/vnd.groove-injector":{"source":"iana","extensions":["grv"]},"application/vnd.groove-tool-message":{"source":"iana","extensions":["gtm"]},"application/vnd.groove-tool-template":{"source":"iana","extensions":["tpl"]},"application/vnd.groove-vcard":{"source":"iana","extensions":["vcg"]},"application/vnd.hal+json":{"source":"iana","compressible":true},"application/vnd.hal+xml":{"source":"iana","compressible":true,"extensions":["hal"]},"application/vnd.handheld-entertainment+xml":{"source":"iana","compressible":true,"extensions":["zmm"]},"application/vnd.hbci":{"source":"iana","extensions":["hbci"]},"application/vnd.hc+json":{"source":"iana","compressible":true},"application/vnd.hcl-bireports":{"source":"iana"},"application/vnd.hdt":{"source":"iana"},"application/vnd.heroku+json":{"source":"iana","compressible":true},"application/vnd.hhe.lesson-player":{"source":"iana","extensions":["les"]},"application/vnd.hl7cda+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.hl7v2+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.hp-hpgl":{"source":"iana","extensions":["hpgl"]},"application/vnd.hp-hpid":{"source":"iana","extensions":["hpid"]},"application/vnd.hp-hps":{"source":"iana","extensions":["hps"]},"application/vnd.hp-jlyt":{"source":"iana","extensions":["jlt"]},"application/vnd.hp-pcl":{"source":"iana","extensions":["pcl"]},"application/vnd.hp-pclxl":{"source":"iana","extensions":["pclxl"]},"application/vnd.httphone":{"source":"iana"},"application/vnd.hydrostatix.sof-data":{"source":"iana","extensions":["sfd-hdstx"]},"application/vnd.hyper+json":{"source":"iana","compressible":true},"application/vnd.hyper-item+json":{"source":"iana","compressible":true},"application/vnd.hyperdrive+json":{"source":"iana","compressible":true},"application/vnd.hzn-3d-crossword":{"source":"iana"},"application/vnd.ibm.afplinedata":{"source":"iana"},"application/vnd.ibm.electronic-media":{"source":"iana"},"application/vnd.ibm.minipay":{"source":"iana","extensions":["mpy"]},"application/vnd.ibm.modcap":{"source":"iana","extensions":["afp","listafp","list3820"]},"application/vnd.ibm.rights-management":{"source":"iana","extensions":["irm"]},"application/vnd.ibm.secure-container":{"source":"iana","extensions":["sc"]},"application/vnd.iccprofile":{"source":"iana","extensions":["icc","icm"]},"application/vnd.ieee.1905":{"source":"iana"},"application/vnd.igloader":{"source":"iana","extensions":["igl"]},"application/vnd.imagemeter.folder+zip":{"source":"iana","compressible":false},"application/vnd.imagemeter.image+zip":{"source":"iana","compressible":false},"application/vnd.immervision-ivp":{"source":"iana","extensions":["ivp"]},"application/vnd.immervision-ivu":{"source":"iana","extensions":["ivu"]},"application/vnd.ims.imsccv1p1":{"source":"iana"},"application/vnd.ims.imsccv1p2":{"source":"iana"},"application/vnd.ims.imsccv1p3":{"source":"iana"},"application/vnd.ims.lis.v2.result+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolconsumerprofile+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy.id+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings.simple+json":{"source":"iana","compressible":true},"application/vnd.informedcontrol.rms+xml":{"source":"iana","compressible":true},"application/vnd.informix-visionary":{"source":"iana"},"application/vnd.infotech.project":{"source":"iana"},"application/vnd.infotech.project+xml":{"source":"iana","compressible":true},"application/vnd.innopath.wamp.notification":{"source":"iana"},"application/vnd.insors.igm":{"source":"iana","extensions":["igm"]},"application/vnd.intercon.formnet":{"source":"iana","extensions":["xpw","xpx"]},"application/vnd.intergeo":{"source":"iana","extensions":["i2g"]},"application/vnd.intertrust.digibox":{"source":"iana"},"application/vnd.intertrust.nncp":{"source":"iana"},"application/vnd.intu.qbo":{"source":"iana","extensions":["qbo"]},"application/vnd.intu.qfx":{"source":"iana","extensions":["qfx"]},"application/vnd.iptc.g2.catalogitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.conceptitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.knowledgeitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.newsmessage+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.packageitem+xml":{"source":"iana","compressible":true},"application/vnd.iptc.g2.planningitem+xml":{"source":"iana","compressible":true},"application/vnd.ipunplugged.rcprofile":{"source":"iana","extensions":["rcprofile"]},"application/vnd.irepository.package+xml":{"source":"iana","compressible":true,"extensions":["irp"]},"application/vnd.is-xpr":{"source":"iana","extensions":["xpr"]},"application/vnd.isac.fcs":{"source":"iana","extensions":["fcs"]},"application/vnd.iso11783-10+zip":{"source":"iana","compressible":false},"application/vnd.jam":{"source":"iana","extensions":["jam"]},"application/vnd.japannet-directory-service":{"source":"iana"},"application/vnd.japannet-jpnstore-wakeup":{"source":"iana"},"application/vnd.japannet-payment-wakeup":{"source":"iana"},"application/vnd.japannet-registration":{"source":"iana"},"application/vnd.japannet-registration-wakeup":{"source":"iana"},"application/vnd.japannet-setstore-wakeup":{"source":"iana"},"application/vnd.japannet-verification":{"source":"iana"},"application/vnd.japannet-verification-wakeup":{"source":"iana"},"application/vnd.jcp.javame.midlet-rms":{"source":"iana","extensions":["rms"]},"application/vnd.jisp":{"source":"iana","extensions":["jisp"]},"application/vnd.joost.joda-archive":{"source":"iana","extensions":["joda"]},"application/vnd.jsk.isdn-ngn":{"source":"iana"},"application/vnd.kahootz":{"source":"iana","extensions":["ktz","ktr"]},"application/vnd.kde.karbon":{"source":"iana","extensions":["karbon"]},"application/vnd.kde.kchart":{"source":"iana","extensions":["chrt"]},"application/vnd.kde.kformula":{"source":"iana","extensions":["kfo"]},"application/vnd.kde.kivio":{"source":"iana","extensions":["flw"]},"application/vnd.kde.kontour":{"source":"iana","extensions":["kon"]},"application/vnd.kde.kpresenter":{"source":"iana","extensions":["kpr","kpt"]},"application/vnd.kde.kspread":{"source":"iana","extensions":["ksp"]},"application/vnd.kde.kword":{"source":"iana","extensions":["kwd","kwt"]},"application/vnd.kenameaapp":{"source":"iana","extensions":["htke"]},"application/vnd.kidspiration":{"source":"iana","extensions":["kia"]},"application/vnd.kinar":{"source":"iana","extensions":["kne","knp"]},"application/vnd.koan":{"source":"iana","extensions":["skp","skd","skt","skm"]},"application/vnd.kodak-descriptor":{"source":"iana","extensions":["sse"]},"application/vnd.las":{"source":"iana"},"application/vnd.las.las+json":{"source":"iana","compressible":true},"application/vnd.las.las+xml":{"source":"iana","compressible":true,"extensions":["lasxml"]},"application/vnd.laszip":{"source":"iana"},"application/vnd.leap+json":{"source":"iana","compressible":true},"application/vnd.liberty-request+xml":{"source":"iana","compressible":true},"application/vnd.llamagraphics.life-balance.desktop":{"source":"iana","extensions":["lbd"]},"application/vnd.llamagraphics.life-balance.exchange+xml":{"source":"iana","compressible":true,"extensions":["lbe"]},"application/vnd.logipipe.circuit+zip":{"source":"iana","compressible":false},"application/vnd.loom":{"source":"iana"},"application/vnd.lotus-1-2-3":{"source":"iana","extensions":["123"]},"application/vnd.lotus-approach":{"source":"iana","extensions":["apr"]},"application/vnd.lotus-freelance":{"source":"iana","extensions":["pre"]},"application/vnd.lotus-notes":{"source":"iana","extensions":["nsf"]},"application/vnd.lotus-organizer":{"source":"iana","extensions":["org"]},"application/vnd.lotus-screencam":{"source":"iana","extensions":["scm"]},"application/vnd.lotus-wordpro":{"source":"iana","extensions":["lwp"]},"application/vnd.macports.portpkg":{"source":"iana","extensions":["portpkg"]},"application/vnd.mapbox-vector-tile":{"source":"iana","extensions":["mvt"]},"application/vnd.marlin.drm.actiontoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.conftoken+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.license+xml":{"source":"iana","compressible":true},"application/vnd.marlin.drm.mdcf":{"source":"iana"},"application/vnd.mason+json":{"source":"iana","compressible":true},"application/vnd.maxar.archive.3tz+zip":{"source":"iana","compressible":false},"application/vnd.maxmind.maxmind-db":{"source":"iana"},"application/vnd.mcd":{"source":"iana","extensions":["mcd"]},"application/vnd.medcalcdata":{"source":"iana","extensions":["mc1"]},"application/vnd.mediastation.cdkey":{"source":"iana","extensions":["cdkey"]},"application/vnd.meridian-slingshot":{"source":"iana"},"application/vnd.mfer":{"source":"iana","extensions":["mwf"]},"application/vnd.mfmp":{"source":"iana","extensions":["mfm"]},"application/vnd.micro+json":{"source":"iana","compressible":true},"application/vnd.micrografx.flo":{"source":"iana","extensions":["flo"]},"application/vnd.micrografx.igx":{"source":"iana","extensions":["igx"]},"application/vnd.microsoft.portable-executable":{"source":"iana"},"application/vnd.microsoft.windows.thumbnail-cache":{"source":"iana"},"application/vnd.miele+json":{"source":"iana","compressible":true},"application/vnd.mif":{"source":"iana","extensions":["mif"]},"application/vnd.minisoft-hp3000-save":{"source":"iana"},"application/vnd.mitsubishi.misty-guard.trustweb":{"source":"iana"},"application/vnd.mobius.daf":{"source":"iana","extensions":["daf"]},"application/vnd.mobius.dis":{"source":"iana","extensions":["dis"]},"application/vnd.mobius.mbk":{"source":"iana","extensions":["mbk"]},"application/vnd.mobius.mqy":{"source":"iana","extensions":["mqy"]},"application/vnd.mobius.msl":{"source":"iana","extensions":["msl"]},"application/vnd.mobius.plc":{"source":"iana","extensions":["plc"]},"application/vnd.mobius.txf":{"source":"iana","extensions":["txf"]},"application/vnd.mophun.application":{"source":"iana","extensions":["mpn"]},"application/vnd.mophun.certificate":{"source":"iana","extensions":["mpc"]},"application/vnd.motorola.flexsuite":{"source":"iana"},"application/vnd.motorola.flexsuite.adsi":{"source":"iana"},"application/vnd.motorola.flexsuite.fis":{"source":"iana"},"application/vnd.motorola.flexsuite.gotap":{"source":"iana"},"application/vnd.motorola.flexsuite.kmr":{"source":"iana"},"application/vnd.motorola.flexsuite.ttc":{"source":"iana"},"application/vnd.motorola.flexsuite.wem":{"source":"iana"},"application/vnd.motorola.iprm":{"source":"iana"},"application/vnd.mozilla.xul+xml":{"source":"iana","compressible":true,"extensions":["xul"]},"application/vnd.ms-3mfdocument":{"source":"iana"},"application/vnd.ms-artgalry":{"source":"iana","extensions":["cil"]},"application/vnd.ms-asf":{"source":"iana"},"application/vnd.ms-cab-compressed":{"source":"iana","extensions":["cab"]},"application/vnd.ms-color.iccprofile":{"source":"apache"},"application/vnd.ms-excel":{"source":"iana","compressible":false,"extensions":["xls","xlm","xla","xlc","xlt","xlw"]},"application/vnd.ms-excel.addin.macroenabled.12":{"source":"iana","extensions":["xlam"]},"application/vnd.ms-excel.sheet.binary.macroenabled.12":{"source":"iana","extensions":["xlsb"]},"application/vnd.ms-excel.sheet.macroenabled.12":{"source":"iana","extensions":["xlsm"]},"application/vnd.ms-excel.template.macroenabled.12":{"source":"iana","extensions":["xltm"]},"application/vnd.ms-fontobject":{"source":"iana","compressible":true,"extensions":["eot"]},"application/vnd.ms-htmlhelp":{"source":"iana","extensions":["chm"]},"application/vnd.ms-ims":{"source":"iana","extensions":["ims"]},"application/vnd.ms-lrm":{"source":"iana","extensions":["lrm"]},"application/vnd.ms-office.activex+xml":{"source":"iana","compressible":true},"application/vnd.ms-officetheme":{"source":"iana","extensions":["thmx"]},"application/vnd.ms-opentype":{"source":"apache","compressible":true},"application/vnd.ms-outlook":{"compressible":false,"extensions":["msg"]},"application/vnd.ms-package.obfuscated-opentype":{"source":"apache"},"application/vnd.ms-pki.seccat":{"source":"apache","extensions":["cat"]},"application/vnd.ms-pki.stl":{"source":"apache","extensions":["stl"]},"application/vnd.ms-playready.initiator+xml":{"source":"iana","compressible":true},"application/vnd.ms-powerpoint":{"source":"iana","compressible":false,"extensions":["ppt","pps","pot"]},"application/vnd.ms-powerpoint.addin.macroenabled.12":{"source":"iana","extensions":["ppam"]},"application/vnd.ms-powerpoint.presentation.macroenabled.12":{"source":"iana","extensions":["pptm"]},"application/vnd.ms-powerpoint.slide.macroenabled.12":{"source":"iana","extensions":["sldm"]},"application/vnd.ms-powerpoint.slideshow.macroenabled.12":{"source":"iana","extensions":["ppsm"]},"application/vnd.ms-powerpoint.template.macroenabled.12":{"source":"iana","extensions":["potm"]},"application/vnd.ms-printdevicecapabilities+xml":{"source":"iana","compressible":true},"application/vnd.ms-printing.printticket+xml":{"source":"apache","compressible":true},"application/vnd.ms-printschematicket+xml":{"source":"iana","compressible":true},"application/vnd.ms-project":{"source":"iana","extensions":["mpp","mpt"]},"application/vnd.ms-tnef":{"source":"iana"},"application/vnd.ms-windows.devicepairing":{"source":"iana"},"application/vnd.ms-windows.nwprinting.oob":{"source":"iana"},"application/vnd.ms-windows.printerpairing":{"source":"iana"},"application/vnd.ms-windows.wsd.oob":{"source":"iana"},"application/vnd.ms-wmdrm.lic-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.lic-resp":{"source":"iana"},"application/vnd.ms-wmdrm.meter-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.meter-resp":{"source":"iana"},"application/vnd.ms-word.document.macroenabled.12":{"source":"iana","extensions":["docm"]},"application/vnd.ms-word.template.macroenabled.12":{"source":"iana","extensions":["dotm"]},"application/vnd.ms-works":{"source":"iana","extensions":["wps","wks","wcm","wdb"]},"application/vnd.ms-wpl":{"source":"iana","extensions":["wpl"]},"application/vnd.ms-xpsdocument":{"source":"iana","compressible":false,"extensions":["xps"]},"application/vnd.msa-disk-image":{"source":"iana"},"application/vnd.mseq":{"source":"iana","extensions":["mseq"]},"application/vnd.msign":{"source":"iana"},"application/vnd.multiad.creator":{"source":"iana"},"application/vnd.multiad.creator.cif":{"source":"iana"},"application/vnd.music-niff":{"source":"iana"},"application/vnd.musician":{"source":"iana","extensions":["mus"]},"application/vnd.muvee.style":{"source":"iana","extensions":["msty"]},"application/vnd.mynfc":{"source":"iana","extensions":["taglet"]},"application/vnd.nacamar.ybrid+json":{"source":"iana","compressible":true},"application/vnd.ncd.control":{"source":"iana"},"application/vnd.ncd.reference":{"source":"iana"},"application/vnd.nearst.inv+json":{"source":"iana","compressible":true},"application/vnd.nebumind.line":{"source":"iana"},"application/vnd.nervana":{"source":"iana"},"application/vnd.netfpx":{"source":"iana"},"application/vnd.neurolanguage.nlu":{"source":"iana","extensions":["nlu"]},"application/vnd.nimn":{"source":"iana"},"application/vnd.nintendo.nitro.rom":{"source":"iana"},"application/vnd.nintendo.snes.rom":{"source":"iana"},"application/vnd.nitf":{"source":"iana","extensions":["ntf","nitf"]},"application/vnd.noblenet-directory":{"source":"iana","extensions":["nnd"]},"application/vnd.noblenet-sealer":{"source":"iana","extensions":["nns"]},"application/vnd.noblenet-web":{"source":"iana","extensions":["nnw"]},"application/vnd.nokia.catalogs":{"source":"iana"},"application/vnd.nokia.conml+wbxml":{"source":"iana"},"application/vnd.nokia.conml+xml":{"source":"iana","compressible":true},"application/vnd.nokia.iptv.config+xml":{"source":"iana","compressible":true},"application/vnd.nokia.isds-radio-presets":{"source":"iana"},"application/vnd.nokia.landmark+wbxml":{"source":"iana"},"application/vnd.nokia.landmark+xml":{"source":"iana","compressible":true},"application/vnd.nokia.landmarkcollection+xml":{"source":"iana","compressible":true},"application/vnd.nokia.n-gage.ac+xml":{"source":"iana","compressible":true,"extensions":["ac"]},"application/vnd.nokia.n-gage.data":{"source":"iana","extensions":["ngdat"]},"application/vnd.nokia.n-gage.symbian.install":{"source":"iana","extensions":["n-gage"]},"application/vnd.nokia.ncd":{"source":"iana"},"application/vnd.nokia.pcd+wbxml":{"source":"iana"},"application/vnd.nokia.pcd+xml":{"source":"iana","compressible":true},"application/vnd.nokia.radio-preset":{"source":"iana","extensions":["rpst"]},"application/vnd.nokia.radio-presets":{"source":"iana","extensions":["rpss"]},"application/vnd.novadigm.edm":{"source":"iana","extensions":["edm"]},"application/vnd.novadigm.edx":{"source":"iana","extensions":["edx"]},"application/vnd.novadigm.ext":{"source":"iana","extensions":["ext"]},"application/vnd.ntt-local.content-share":{"source":"iana"},"application/vnd.ntt-local.file-transfer":{"source":"iana"},"application/vnd.ntt-local.ogw_remote-access":{"source":"iana"},"application/vnd.ntt-local.sip-ta_remote":{"source":"iana"},"application/vnd.ntt-local.sip-ta_tcp_stream":{"source":"iana"},"application/vnd.oasis.opendocument.chart":{"source":"iana","extensions":["odc"]},"application/vnd.oasis.opendocument.chart-template":{"source":"iana","extensions":["otc"]},"application/vnd.oasis.opendocument.database":{"source":"iana","extensions":["odb"]},"application/vnd.oasis.opendocument.formula":{"source":"iana","extensions":["odf"]},"application/vnd.oasis.opendocument.formula-template":{"source":"iana","extensions":["odft"]},"application/vnd.oasis.opendocument.graphics":{"source":"iana","compressible":false,"extensions":["odg"]},"application/vnd.oasis.opendocument.graphics-template":{"source":"iana","extensions":["otg"]},"application/vnd.oasis.opendocument.image":{"source":"iana","extensions":["odi"]},"application/vnd.oasis.opendocument.image-template":{"source":"iana","extensions":["oti"]},"application/vnd.oasis.opendocument.presentation":{"source":"iana","compressible":false,"extensions":["odp"]},"application/vnd.oasis.opendocument.presentation-template":{"source":"iana","extensions":["otp"]},"application/vnd.oasis.opendocument.spreadsheet":{"source":"iana","compressible":false,"extensions":["ods"]},"application/vnd.oasis.opendocument.spreadsheet-template":{"source":"iana","extensions":["ots"]},"application/vnd.oasis.opendocument.text":{"source":"iana","compressible":false,"extensions":["odt"]},"application/vnd.oasis.opendocument.text-master":{"source":"iana","extensions":["odm"]},"application/vnd.oasis.opendocument.text-template":{"source":"iana","extensions":["ott"]},"application/vnd.oasis.opendocument.text-web":{"source":"iana","extensions":["oth"]},"application/vnd.obn":{"source":"iana"},"application/vnd.ocf+cbor":{"source":"iana"},"application/vnd.oci.image.manifest.v1+json":{"source":"iana","compressible":true},"application/vnd.oftn.l10n+json":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessdownload+xml":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessstreaming+xml":{"source":"iana","compressible":true},"application/vnd.oipf.cspg-hexbinary":{"source":"iana"},"application/vnd.oipf.dae.svg+xml":{"source":"iana","compressible":true},"application/vnd.oipf.dae.xhtml+xml":{"source":"iana","compressible":true},"application/vnd.oipf.mippvcontrolmessage+xml":{"source":"iana","compressible":true},"application/vnd.oipf.pae.gem":{"source":"iana"},"application/vnd.oipf.spdiscovery+xml":{"source":"iana","compressible":true},"application/vnd.oipf.spdlist+xml":{"source":"iana","compressible":true},"application/vnd.oipf.ueprofile+xml":{"source":"iana","compressible":true},"application/vnd.oipf.userprofile+xml":{"source":"iana","compressible":true},"application/vnd.olpc-sugar":{"source":"iana","extensions":["xo"]},"application/vnd.oma-scws-config":{"source":"iana"},"application/vnd.oma-scws-http-request":{"source":"iana"},"application/vnd.oma-scws-http-response":{"source":"iana"},"application/vnd.oma.bcast.associated-procedure-parameter+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.drm-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.imd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.ltkm":{"source":"iana"},"application/vnd.oma.bcast.notification+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.provisioningtrigger":{"source":"iana"},"application/vnd.oma.bcast.sgboot":{"source":"iana"},"application/vnd.oma.bcast.sgdd+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sgdu":{"source":"iana"},"application/vnd.oma.bcast.simple-symbol-container":{"source":"iana"},"application/vnd.oma.bcast.smartcard-trigger+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.sprov+xml":{"source":"iana","compressible":true},"application/vnd.oma.bcast.stkm":{"source":"iana"},"application/vnd.oma.cab-address-book+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-feature-handler+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-pcc+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-subs-invite+xml":{"source":"iana","compressible":true},"application/vnd.oma.cab-user-prefs+xml":{"source":"iana","compressible":true},"application/vnd.oma.dcd":{"source":"iana"},"application/vnd.oma.dcdc":{"source":"iana"},"application/vnd.oma.dd2+xml":{"source":"iana","compressible":true,"extensions":["dd2"]},"application/vnd.oma.drm.risd+xml":{"source":"iana","compressible":true},"application/vnd.oma.group-usage-list+xml":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+cbor":{"source":"iana"},"application/vnd.oma.lwm2m+json":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+tlv":{"source":"iana"},"application/vnd.oma.pal+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.detailed-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.final-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.groups+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.invocation-descriptor+xml":{"source":"iana","compressible":true},"application/vnd.oma.poc.optimized-progress-report+xml":{"source":"iana","compressible":true},"application/vnd.oma.push":{"source":"iana"},"application/vnd.oma.scidm.messages+xml":{"source":"iana","compressible":true},"application/vnd.oma.xcap-directory+xml":{"source":"iana","compressible":true},"application/vnd.omads-email+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-file+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omads-folder+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.omaloc-supl-init":{"source":"iana"},"application/vnd.onepager":{"source":"iana"},"application/vnd.onepagertamp":{"source":"iana"},"application/vnd.onepagertamx":{"source":"iana"},"application/vnd.onepagertat":{"source":"iana"},"application/vnd.onepagertatp":{"source":"iana"},"application/vnd.onepagertatx":{"source":"iana"},"application/vnd.openblox.game+xml":{"source":"iana","compressible":true,"extensions":["obgx"]},"application/vnd.openblox.game-binary":{"source":"iana"},"application/vnd.openeye.oeb":{"source":"iana"},"application/vnd.openofficeorg.extension":{"source":"apache","extensions":["oxt"]},"application/vnd.openstreetmap.data+xml":{"source":"iana","compressible":true,"extensions":["osm"]},"application/vnd.opentimestamps.ots":{"source":"iana"},"application/vnd.openxmlformats-officedocument.custom-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.customxmlproperties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawing+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.extended-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presentation":{"source":"iana","compressible":false,"extensions":["pptx"]},"application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.presprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slide":{"source":"iana","extensions":["sldx"]},"application/vnd.openxmlformats-officedocument.presentationml.slide+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideshow":{"source":"iana","extensions":["ppsx"]},"application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.tags+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.template":{"source":"iana","extensions":["potx"]},"application/vnd.openxmlformats-officedocument.presentationml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":{"source":"iana","compressible":false,"extensions":["xlsx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.template":{"source":"iana","extensions":["xltx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.theme+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.themeoverride+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.vmldrawing":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document":{"source":"iana","compressible":false,"extensions":["docx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.template":{"source":"iana","extensions":["dotx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.core-properties+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml":{"source":"iana","compressible":true},"application/vnd.openxmlformats-package.relationships+xml":{"source":"iana","compressible":true},"application/vnd.oracle.resource+json":{"source":"iana","compressible":true},"application/vnd.orange.indata":{"source":"iana"},"application/vnd.osa.netdeploy":{"source":"iana"},"application/vnd.osgeo.mapguide.package":{"source":"iana","extensions":["mgp"]},"application/vnd.osgi.bundle":{"source":"iana"},"application/vnd.osgi.dp":{"source":"iana","extensions":["dp"]},"application/vnd.osgi.subsystem":{"source":"iana","extensions":["esa"]},"application/vnd.otps.ct-kip+xml":{"source":"iana","compressible":true},"application/vnd.oxli.countgraph":{"source":"iana"},"application/vnd.pagerduty+json":{"source":"iana","compressible":true},"application/vnd.palm":{"source":"iana","extensions":["pdb","pqa","oprc"]},"application/vnd.panoply":{"source":"iana"},"application/vnd.paos.xml":{"source":"iana"},"application/vnd.patentdive":{"source":"iana"},"application/vnd.patientecommsdoc":{"source":"iana"},"application/vnd.pawaafile":{"source":"iana","extensions":["paw"]},"application/vnd.pcos":{"source":"iana"},"application/vnd.pg.format":{"source":"iana","extensions":["str"]},"application/vnd.pg.osasli":{"source":"iana","extensions":["ei6"]},"application/vnd.piaccess.application-licence":{"source":"iana"},"application/vnd.picsel":{"source":"iana","extensions":["efif"]},"application/vnd.pmi.widget":{"source":"iana","extensions":["wg"]},"application/vnd.poc.group-advertisement+xml":{"source":"iana","compressible":true},"application/vnd.pocketlearn":{"source":"iana","extensions":["plf"]},"application/vnd.powerbuilder6":{"source":"iana","extensions":["pbd"]},"application/vnd.powerbuilder6-s":{"source":"iana"},"application/vnd.powerbuilder7":{"source":"iana"},"application/vnd.powerbuilder7-s":{"source":"iana"},"application/vnd.powerbuilder75":{"source":"iana"},"application/vnd.powerbuilder75-s":{"source":"iana"},"application/vnd.preminet":{"source":"iana"},"application/vnd.previewsystems.box":{"source":"iana","extensions":["box"]},"application/vnd.proteus.magazine":{"source":"iana","extensions":["mgz"]},"application/vnd.psfs":{"source":"iana"},"application/vnd.publishare-delta-tree":{"source":"iana","extensions":["qps"]},"application/vnd.pvi.ptid1":{"source":"iana","extensions":["ptid"]},"application/vnd.pwg-multiplexed":{"source":"iana"},"application/vnd.pwg-xhtml-print+xml":{"source":"iana","compressible":true},"application/vnd.qualcomm.brew-app-res":{"source":"iana"},"application/vnd.quarantainenet":{"source":"iana"},"application/vnd.quark.quarkxpress":{"source":"iana","extensions":["qxd","qxt","qwd","qwt","qxl","qxb"]},"application/vnd.quobject-quoxdocument":{"source":"iana"},"application/vnd.radisys.moml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-conn+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-audit-stream+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-conf+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-base+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-detect+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-fax-sendrecv+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-group+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-speech+xml":{"source":"iana","compressible":true},"application/vnd.radisys.msml-dialog-transform+xml":{"source":"iana","compressible":true},"application/vnd.rainstor.data":{"source":"iana"},"application/vnd.rapid":{"source":"iana"},"application/vnd.rar":{"source":"iana","extensions":["rar"]},"application/vnd.realvnc.bed":{"source":"iana","extensions":["bed"]},"application/vnd.recordare.musicxml":{"source":"iana","extensions":["mxl"]},"application/vnd.recordare.musicxml+xml":{"source":"iana","compressible":true,"extensions":["musicxml"]},"application/vnd.renlearn.rlprint":{"source":"iana"},"application/vnd.resilient.logic":{"source":"iana"},"application/vnd.restful+json":{"source":"iana","compressible":true},"application/vnd.rig.cryptonote":{"source":"iana","extensions":["cryptonote"]},"application/vnd.rim.cod":{"source":"apache","extensions":["cod"]},"application/vnd.rn-realmedia":{"source":"apache","extensions":["rm"]},"application/vnd.rn-realmedia-vbr":{"source":"apache","extensions":["rmvb"]},"application/vnd.route66.link66+xml":{"source":"iana","compressible":true,"extensions":["link66"]},"application/vnd.rs-274x":{"source":"iana"},"application/vnd.ruckus.download":{"source":"iana"},"application/vnd.s3sms":{"source":"iana"},"application/vnd.sailingtracker.track":{"source":"iana","extensions":["st"]},"application/vnd.sar":{"source":"iana"},"application/vnd.sbm.cid":{"source":"iana"},"application/vnd.sbm.mid2":{"source":"iana"},"application/vnd.scribus":{"source":"iana"},"application/vnd.sealed.3df":{"source":"iana"},"application/vnd.sealed.csf":{"source":"iana"},"application/vnd.sealed.doc":{"source":"iana"},"application/vnd.sealed.eml":{"source":"iana"},"application/vnd.sealed.mht":{"source":"iana"},"application/vnd.sealed.net":{"source":"iana"},"application/vnd.sealed.ppt":{"source":"iana"},"application/vnd.sealed.tiff":{"source":"iana"},"application/vnd.sealed.xls":{"source":"iana"},"application/vnd.sealedmedia.softseal.html":{"source":"iana"},"application/vnd.sealedmedia.softseal.pdf":{"source":"iana"},"application/vnd.seemail":{"source":"iana","extensions":["see"]},"application/vnd.seis+json":{"source":"iana","compressible":true},"application/vnd.sema":{"source":"iana","extensions":["sema"]},"application/vnd.semd":{"source":"iana","extensions":["semd"]},"application/vnd.semf":{"source":"iana","extensions":["semf"]},"application/vnd.shade-save-file":{"source":"iana"},"application/vnd.shana.informed.formdata":{"source":"iana","extensions":["ifm"]},"application/vnd.shana.informed.formtemplate":{"source":"iana","extensions":["itp"]},"application/vnd.shana.informed.interchange":{"source":"iana","extensions":["iif"]},"application/vnd.shana.informed.package":{"source":"iana","extensions":["ipk"]},"application/vnd.shootproof+json":{"source":"iana","compressible":true},"application/vnd.shopkick+json":{"source":"iana","compressible":true},"application/vnd.shp":{"source":"iana"},"application/vnd.shx":{"source":"iana"},"application/vnd.sigrok.session":{"source":"iana"},"application/vnd.simtech-mindmapper":{"source":"iana","extensions":["twd","twds"]},"application/vnd.siren+json":{"source":"iana","compressible":true},"application/vnd.smaf":{"source":"iana","extensions":["mmf"]},"application/vnd.smart.notebook":{"source":"iana"},"application/vnd.smart.teacher":{"source":"iana","extensions":["teacher"]},"application/vnd.snesdev-page-table":{"source":"iana"},"application/vnd.software602.filler.form+xml":{"source":"iana","compressible":true,"extensions":["fo"]},"application/vnd.software602.filler.form-xml-zip":{"source":"iana"},"application/vnd.solent.sdkm+xml":{"source":"iana","compressible":true,"extensions":["sdkm","sdkd"]},"application/vnd.spotfire.dxp":{"source":"iana","extensions":["dxp"]},"application/vnd.spotfire.sfs":{"source":"iana","extensions":["sfs"]},"application/vnd.sqlite3":{"source":"iana"},"application/vnd.sss-cod":{"source":"iana"},"application/vnd.sss-dtf":{"source":"iana"},"application/vnd.sss-ntf":{"source":"iana"},"application/vnd.stardivision.calc":{"source":"apache","extensions":["sdc"]},"application/vnd.stardivision.draw":{"source":"apache","extensions":["sda"]},"application/vnd.stardivision.impress":{"source":"apache","extensions":["sdd"]},"application/vnd.stardivision.math":{"source":"apache","extensions":["smf"]},"application/vnd.stardivision.writer":{"source":"apache","extensions":["sdw","vor"]},"application/vnd.stardivision.writer-global":{"source":"apache","extensions":["sgl"]},"application/vnd.stepmania.package":{"source":"iana","extensions":["smzip"]},"application/vnd.stepmania.stepchart":{"source":"iana","extensions":["sm"]},"application/vnd.street-stream":{"source":"iana"},"application/vnd.sun.wadl+xml":{"source":"iana","compressible":true,"extensions":["wadl"]},"application/vnd.sun.xml.calc":{"source":"apache","extensions":["sxc"]},"application/vnd.sun.xml.calc.template":{"source":"apache","extensions":["stc"]},"application/vnd.sun.xml.draw":{"source":"apache","extensions":["sxd"]},"application/vnd.sun.xml.draw.template":{"source":"apache","extensions":["std"]},"application/vnd.sun.xml.impress":{"source":"apache","extensions":["sxi"]},"application/vnd.sun.xml.impress.template":{"source":"apache","extensions":["sti"]},"application/vnd.sun.xml.math":{"source":"apache","extensions":["sxm"]},"application/vnd.sun.xml.writer":{"source":"apache","extensions":["sxw"]},"application/vnd.sun.xml.writer.global":{"source":"apache","extensions":["sxg"]},"application/vnd.sun.xml.writer.template":{"source":"apache","extensions":["stw"]},"application/vnd.sus-calendar":{"source":"iana","extensions":["sus","susp"]},"application/vnd.svd":{"source":"iana","extensions":["svd"]},"application/vnd.swiftview-ics":{"source":"iana"},"application/vnd.sycle+xml":{"source":"iana","compressible":true},"application/vnd.syft+json":{"source":"iana","compressible":true},"application/vnd.symbian.install":{"source":"apache","extensions":["sis","sisx"]},"application/vnd.syncml+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xsm"]},"application/vnd.syncml.dm+wbxml":{"source":"iana","charset":"UTF-8","extensions":["bdm"]},"application/vnd.syncml.dm+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["xdm"]},"application/vnd.syncml.dm.notification":{"source":"iana"},"application/vnd.syncml.dmddf+wbxml":{"source":"iana"},"application/vnd.syncml.dmddf+xml":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["ddf"]},"application/vnd.syncml.dmtnds+wbxml":{"source":"iana"},"application/vnd.syncml.dmtnds+xml":{"source":"iana","charset":"UTF-8","compressible":true},"application/vnd.syncml.ds.notification":{"source":"iana"},"application/vnd.tableschema+json":{"source":"iana","compressible":true},"application/vnd.tao.intent-module-archive":{"source":"iana","extensions":["tao"]},"application/vnd.tcpdump.pcap":{"source":"iana","extensions":["pcap","cap","dmp"]},"application/vnd.think-cell.ppttc+json":{"source":"iana","compressible":true},"application/vnd.tmd.mediaflex.api+xml":{"source":"iana","compressible":true},"application/vnd.tml":{"source":"iana"},"application/vnd.tmobile-livetv":{"source":"iana","extensions":["tmo"]},"application/vnd.tri.onesource":{"source":"iana"},"application/vnd.trid.tpt":{"source":"iana","extensions":["tpt"]},"application/vnd.triscape.mxs":{"source":"iana","extensions":["mxs"]},"application/vnd.trueapp":{"source":"iana","extensions":["tra"]},"application/vnd.truedoc":{"source":"iana"},"application/vnd.ubisoft.webplayer":{"source":"iana"},"application/vnd.ufdl":{"source":"iana","extensions":["ufd","ufdl"]},"application/vnd.uiq.theme":{"source":"iana","extensions":["utz"]},"application/vnd.umajin":{"source":"iana","extensions":["umj"]},"application/vnd.unity":{"source":"iana","extensions":["unityweb"]},"application/vnd.uoml+xml":{"source":"iana","compressible":true,"extensions":["uoml"]},"application/vnd.uplanet.alert":{"source":"iana"},"application/vnd.uplanet.alert-wbxml":{"source":"iana"},"application/vnd.uplanet.bearer-choice":{"source":"iana"},"application/vnd.uplanet.bearer-choice-wbxml":{"source":"iana"},"application/vnd.uplanet.cacheop":{"source":"iana"},"application/vnd.uplanet.cacheop-wbxml":{"source":"iana"},"application/vnd.uplanet.channel":{"source":"iana"},"application/vnd.uplanet.channel-wbxml":{"source":"iana"},"application/vnd.uplanet.list":{"source":"iana"},"application/vnd.uplanet.list-wbxml":{"source":"iana"},"application/vnd.uplanet.listcmd":{"source":"iana"},"application/vnd.uplanet.listcmd-wbxml":{"source":"iana"},"application/vnd.uplanet.signal":{"source":"iana"},"application/vnd.uri-map":{"source":"iana"},"application/vnd.valve.source.material":{"source":"iana"},"application/vnd.vcx":{"source":"iana","extensions":["vcx"]},"application/vnd.vd-study":{"source":"iana"},"application/vnd.vectorworks":{"source":"iana"},"application/vnd.vel+json":{"source":"iana","compressible":true},"application/vnd.verimatrix.vcas":{"source":"iana"},"application/vnd.veritone.aion+json":{"source":"iana","compressible":true},"application/vnd.veryant.thin":{"source":"iana"},"application/vnd.ves.encrypted":{"source":"iana"},"application/vnd.vidsoft.vidconference":{"source":"iana"},"application/vnd.visio":{"source":"iana","extensions":["vsd","vst","vss","vsw"]},"application/vnd.visionary":{"source":"iana","extensions":["vis"]},"application/vnd.vividence.scriptfile":{"source":"iana"},"application/vnd.vsf":{"source":"iana","extensions":["vsf"]},"application/vnd.wap.sic":{"source":"iana"},"application/vnd.wap.slc":{"source":"iana"},"application/vnd.wap.wbxml":{"source":"iana","charset":"UTF-8","extensions":["wbxml"]},"application/vnd.wap.wmlc":{"source":"iana","extensions":["wmlc"]},"application/vnd.wap.wmlscriptc":{"source":"iana","extensions":["wmlsc"]},"application/vnd.webturbo":{"source":"iana","extensions":["wtb"]},"application/vnd.wfa.dpp":{"source":"iana"},"application/vnd.wfa.p2p":{"source":"iana"},"application/vnd.wfa.wsc":{"source":"iana"},"application/vnd.windows.devicepairing":{"source":"iana"},"application/vnd.wmc":{"source":"iana"},"application/vnd.wmf.bootstrap":{"source":"iana"},"application/vnd.wolfram.mathematica":{"source":"iana"},"application/vnd.wolfram.mathematica.package":{"source":"iana"},"application/vnd.wolfram.player":{"source":"iana","extensions":["nbp"]},"application/vnd.wordperfect":{"source":"iana","extensions":["wpd"]},"application/vnd.wqd":{"source":"iana","extensions":["wqd"]},"application/vnd.wrq-hp3000-labelled":{"source":"iana"},"application/vnd.wt.stf":{"source":"iana","extensions":["stf"]},"application/vnd.wv.csp+wbxml":{"source":"iana"},"application/vnd.wv.csp+xml":{"source":"iana","compressible":true},"application/vnd.wv.ssp+xml":{"source":"iana","compressible":true},"application/vnd.xacml+json":{"source":"iana","compressible":true},"application/vnd.xara":{"source":"iana","extensions":["xar"]},"application/vnd.xfdl":{"source":"iana","extensions":["xfdl"]},"application/vnd.xfdl.webform":{"source":"iana"},"application/vnd.xmi+xml":{"source":"iana","compressible":true},"application/vnd.xmpie.cpkg":{"source":"iana"},"application/vnd.xmpie.dpkg":{"source":"iana"},"application/vnd.xmpie.plan":{"source":"iana"},"application/vnd.xmpie.ppkg":{"source":"iana"},"application/vnd.xmpie.xlim":{"source":"iana"},"application/vnd.yamaha.hv-dic":{"source":"iana","extensions":["hvd"]},"application/vnd.yamaha.hv-script":{"source":"iana","extensions":["hvs"]},"application/vnd.yamaha.hv-voice":{"source":"iana","extensions":["hvp"]},"application/vnd.yamaha.openscoreformat":{"source":"iana","extensions":["osf"]},"application/vnd.yamaha.openscoreformat.osfpvg+xml":{"source":"iana","compressible":true,"extensions":["osfpvg"]},"application/vnd.yamaha.remote-setup":{"source":"iana"},"application/vnd.yamaha.smaf-audio":{"source":"iana","extensions":["saf"]},"application/vnd.yamaha.smaf-phrase":{"source":"iana","extensions":["spf"]},"application/vnd.yamaha.through-ngn":{"source":"iana"},"application/vnd.yamaha.tunnel-udpencap":{"source":"iana"},"application/vnd.yaoweme":{"source":"iana"},"application/vnd.yellowriver-custom-menu":{"source":"iana","extensions":["cmp"]},"application/vnd.youtube.yt":{"source":"iana"},"application/vnd.zul":{"source":"iana","extensions":["zir","zirz"]},"application/vnd.zzazz.deck+xml":{"source":"iana","compressible":true,"extensions":["zaz"]},"application/voicexml+xml":{"source":"iana","compressible":true,"extensions":["vxml"]},"application/voucher-cms+json":{"source":"iana","compressible":true},"application/vq-rtcpxr":{"source":"iana"},"application/wasm":{"source":"iana","compressible":true,"extensions":["wasm"]},"application/watcherinfo+xml":{"source":"iana","compressible":true,"extensions":["wif"]},"application/webpush-options+json":{"source":"iana","compressible":true},"application/whoispp-query":{"source":"iana"},"application/whoispp-response":{"source":"iana"},"application/widget":{"source":"iana","extensions":["wgt"]},"application/winhlp":{"source":"apache","extensions":["hlp"]},"application/wita":{"source":"iana"},"application/wordperfect5.1":{"source":"iana"},"application/wsdl+xml":{"source":"iana","compressible":true,"extensions":["wsdl"]},"application/wspolicy+xml":{"source":"iana","compressible":true,"extensions":["wspolicy"]},"application/x-7z-compressed":{"source":"apache","compressible":false,"extensions":["7z"]},"application/x-abiword":{"source":"apache","extensions":["abw"]},"application/x-ace-compressed":{"source":"apache","extensions":["ace"]},"application/x-amf":{"source":"apache"},"application/x-apple-diskimage":{"source":"apache","extensions":["dmg"]},"application/x-arj":{"compressible":false,"extensions":["arj"]},"application/x-authorware-bin":{"source":"apache","extensions":["aab","x32","u32","vox"]},"application/x-authorware-map":{"source":"apache","extensions":["aam"]},"application/x-authorware-seg":{"source":"apache","extensions":["aas"]},"application/x-bcpio":{"source":"apache","extensions":["bcpio"]},"application/x-bdoc":{"compressible":false,"extensions":["bdoc"]},"application/x-bittorrent":{"source":"apache","extensions":["torrent"]},"application/x-blorb":{"source":"apache","extensions":["blb","blorb"]},"application/x-bzip":{"source":"apache","compressible":false,"extensions":["bz"]},"application/x-bzip2":{"source":"apache","compressible":false,"extensions":["bz2","boz"]},"application/x-cbr":{"source":"apache","extensions":["cbr","cba","cbt","cbz","cb7"]},"application/x-cdlink":{"source":"apache","extensions":["vcd"]},"application/x-cfs-compressed":{"source":"apache","extensions":["cfs"]},"application/x-chat":{"source":"apache","extensions":["chat"]},"application/x-chess-pgn":{"source":"apache","extensions":["pgn"]},"application/x-chrome-extension":{"extensions":["crx"]},"application/x-cocoa":{"source":"nginx","extensions":["cco"]},"application/x-compress":{"source":"apache"},"application/x-conference":{"source":"apache","extensions":["nsc"]},"application/x-cpio":{"source":"apache","extensions":["cpio"]},"application/x-csh":{"source":"apache","extensions":["csh"]},"application/x-deb":{"compressible":false},"application/x-debian-package":{"source":"apache","extensions":["deb","udeb"]},"application/x-dgc-compressed":{"source":"apache","extensions":["dgc"]},"application/x-director":{"source":"apache","extensions":["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]},"application/x-doom":{"source":"apache","extensions":["wad"]},"application/x-dtbncx+xml":{"source":"apache","compressible":true,"extensions":["ncx"]},"application/x-dtbook+xml":{"source":"apache","compressible":true,"extensions":["dtb"]},"application/x-dtbresource+xml":{"source":"apache","compressible":true,"extensions":["res"]},"application/x-dvi":{"source":"apache","compressible":false,"extensions":["dvi"]},"application/x-envoy":{"source":"apache","extensions":["evy"]},"application/x-eva":{"source":"apache","extensions":["eva"]},"application/x-font-bdf":{"source":"apache","extensions":["bdf"]},"application/x-font-dos":{"source":"apache"},"application/x-font-framemaker":{"source":"apache"},"application/x-font-ghostscript":{"source":"apache","extensions":["gsf"]},"application/x-font-libgrx":{"source":"apache"},"application/x-font-linux-psf":{"source":"apache","extensions":["psf"]},"application/x-font-pcf":{"source":"apache","extensions":["pcf"]},"application/x-font-snf":{"source":"apache","extensions":["snf"]},"application/x-font-speedo":{"source":"apache"},"application/x-font-sunos-news":{"source":"apache"},"application/x-font-type1":{"source":"apache","extensions":["pfa","pfb","pfm","afm"]},"application/x-font-vfont":{"source":"apache"},"application/x-freearc":{"source":"apache","extensions":["arc"]},"application/x-futuresplash":{"source":"apache","extensions":["spl"]},"application/x-gca-compressed":{"source":"apache","extensions":["gca"]},"application/x-glulx":{"source":"apache","extensions":["ulx"]},"application/x-gnumeric":{"source":"apache","extensions":["gnumeric"]},"application/x-gramps-xml":{"source":"apache","extensions":["gramps"]},"application/x-gtar":{"source":"apache","extensions":["gtar"]},"application/x-gzip":{"source":"apache"},"application/x-hdf":{"source":"apache","extensions":["hdf"]},"application/x-httpd-php":{"compressible":true,"extensions":["php"]},"application/x-install-instructions":{"source":"apache","extensions":["install"]},"application/x-iso9660-image":{"source":"apache","extensions":["iso"]},"application/x-iwork-keynote-sffkey":{"extensions":["key"]},"application/x-iwork-numbers-sffnumbers":{"extensions":["numbers"]},"application/x-iwork-pages-sffpages":{"extensions":["pages"]},"application/x-java-archive-diff":{"source":"nginx","extensions":["jardiff"]},"application/x-java-jnlp-file":{"source":"apache","compressible":false,"extensions":["jnlp"]},"application/x-javascript":{"compressible":true},"application/x-keepass2":{"extensions":["kdbx"]},"application/x-latex":{"source":"apache","compressible":false,"extensions":["latex"]},"application/x-lua-bytecode":{"extensions":["luac"]},"application/x-lzh-compressed":{"source":"apache","extensions":["lzh","lha"]},"application/x-makeself":{"source":"nginx","extensions":["run"]},"application/x-mie":{"source":"apache","extensions":["mie"]},"application/x-mobipocket-ebook":{"source":"apache","extensions":["prc","mobi"]},"application/x-mpegurl":{"compressible":false},"application/x-ms-application":{"source":"apache","extensions":["application"]},"application/x-ms-shortcut":{"source":"apache","extensions":["lnk"]},"application/x-ms-wmd":{"source":"apache","extensions":["wmd"]},"application/x-ms-wmz":{"source":"apache","extensions":["wmz"]},"application/x-ms-xbap":{"source":"apache","extensions":["xbap"]},"application/x-msaccess":{"source":"apache","extensions":["mdb"]},"application/x-msbinder":{"source":"apache","extensions":["obd"]},"application/x-mscardfile":{"source":"apache","extensions":["crd"]},"application/x-msclip":{"source":"apache","extensions":["clp"]},"application/x-msdos-program":{"extensions":["exe"]},"application/x-msdownload":{"source":"apache","extensions":["exe","dll","com","bat","msi"]},"application/x-msmediaview":{"source":"apache","extensions":["mvb","m13","m14"]},"application/x-msmetafile":{"source":"apache","extensions":["wmf","wmz","emf","emz"]},"application/x-msmoney":{"source":"apache","extensions":["mny"]},"application/x-mspublisher":{"source":"apache","extensions":["pub"]},"application/x-msschedule":{"source":"apache","extensions":["scd"]},"application/x-msterminal":{"source":"apache","extensions":["trm"]},"application/x-mswrite":{"source":"apache","extensions":["wri"]},"application/x-netcdf":{"source":"apache","extensions":["nc","cdf"]},"application/x-ns-proxy-autoconfig":{"compressible":true,"extensions":["pac"]},"application/x-nzb":{"source":"apache","extensions":["nzb"]},"application/x-perl":{"source":"nginx","extensions":["pl","pm"]},"application/x-pilot":{"source":"nginx","extensions":["prc","pdb"]},"application/x-pkcs12":{"source":"apache","compressible":false,"extensions":["p12","pfx"]},"application/x-pkcs7-certificates":{"source":"apache","extensions":["p7b","spc"]},"application/x-pkcs7-certreqresp":{"source":"apache","extensions":["p7r"]},"application/x-pki-message":{"source":"iana"},"application/x-rar-compressed":{"source":"apache","compressible":false,"extensions":["rar"]},"application/x-redhat-package-manager":{"source":"nginx","extensions":["rpm"]},"application/x-research-info-systems":{"source":"apache","extensions":["ris"]},"application/x-sea":{"source":"nginx","extensions":["sea"]},"application/x-sh":{"source":"apache","compressible":true,"extensions":["sh"]},"application/x-shar":{"source":"apache","extensions":["shar"]},"application/x-shockwave-flash":{"source":"apache","compressible":false,"extensions":["swf"]},"application/x-silverlight-app":{"source":"apache","extensions":["xap"]},"application/x-sql":{"source":"apache","extensions":["sql"]},"application/x-stuffit":{"source":"apache","compressible":false,"extensions":["sit"]},"application/x-stuffitx":{"source":"apache","extensions":["sitx"]},"application/x-subrip":{"source":"apache","extensions":["srt"]},"application/x-sv4cpio":{"source":"apache","extensions":["sv4cpio"]},"application/x-sv4crc":{"source":"apache","extensions":["sv4crc"]},"application/x-t3vm-image":{"source":"apache","extensions":["t3"]},"application/x-tads":{"source":"apache","extensions":["gam"]},"application/x-tar":{"source":"apache","compressible":true,"extensions":["tar"]},"application/x-tcl":{"source":"apache","extensions":["tcl","tk"]},"application/x-tex":{"source":"apache","extensions":["tex"]},"application/x-tex-tfm":{"source":"apache","extensions":["tfm"]},"application/x-texinfo":{"source":"apache","extensions":["texinfo","texi"]},"application/x-tgif":{"source":"apache","extensions":["obj"]},"application/x-ustar":{"source":"apache","extensions":["ustar"]},"application/x-virtualbox-hdd":{"compressible":true,"extensions":["hdd"]},"application/x-virtualbox-ova":{"compressible":true,"extensions":["ova"]},"application/x-virtualbox-ovf":{"compressible":true,"extensions":["ovf"]},"application/x-virtualbox-vbox":{"compressible":true,"extensions":["vbox"]},"application/x-virtualbox-vbox-extpack":{"compressible":false,"extensions":["vbox-extpack"]},"application/x-virtualbox-vdi":{"compressible":true,"extensions":["vdi"]},"application/x-virtualbox-vhd":{"compressible":true,"extensions":["vhd"]},"application/x-virtualbox-vmdk":{"compressible":true,"extensions":["vmdk"]},"application/x-wais-source":{"source":"apache","extensions":["src"]},"application/x-web-app-manifest+json":{"compressible":true,"extensions":["webapp"]},"application/x-www-form-urlencoded":{"source":"iana","compressible":true},"application/x-x509-ca-cert":{"source":"iana","extensions":["der","crt","pem"]},"application/x-x509-ca-ra-cert":{"source":"iana"},"application/x-x509-next-ca-cert":{"source":"iana"},"application/x-xfig":{"source":"apache","extensions":["fig"]},"application/x-xliff+xml":{"source":"apache","compressible":true,"extensions":["xlf"]},"application/x-xpinstall":{"source":"apache","compressible":false,"extensions":["xpi"]},"application/x-xz":{"source":"apache","extensions":["xz"]},"application/x-zmachine":{"source":"apache","extensions":["z1","z2","z3","z4","z5","z6","z7","z8"]},"application/x400-bp":{"source":"iana"},"application/xacml+xml":{"source":"iana","compressible":true},"application/xaml+xml":{"source":"apache","compressible":true,"extensions":["xaml"]},"application/xcap-att+xml":{"source":"iana","compressible":true,"extensions":["xav"]},"application/xcap-caps+xml":{"source":"iana","compressible":true,"extensions":["xca"]},"application/xcap-diff+xml":{"source":"iana","compressible":true,"extensions":["xdf"]},"application/xcap-el+xml":{"source":"iana","compressible":true,"extensions":["xel"]},"application/xcap-error+xml":{"source":"iana","compressible":true},"application/xcap-ns+xml":{"source":"iana","compressible":true,"extensions":["xns"]},"application/xcon-conference-info+xml":{"source":"iana","compressible":true},"application/xcon-conference-info-diff+xml":{"source":"iana","compressible":true},"application/xenc+xml":{"source":"iana","compressible":true,"extensions":["xenc"]},"application/xhtml+xml":{"source":"iana","compressible":true,"extensions":["xhtml","xht"]},"application/xhtml-voice+xml":{"source":"apache","compressible":true},"application/xliff+xml":{"source":"iana","compressible":true,"extensions":["xlf"]},"application/xml":{"source":"iana","compressible":true,"extensions":["xml","xsl","xsd","rng"]},"application/xml-dtd":{"source":"iana","compressible":true,"extensions":["dtd"]},"application/xml-external-parsed-entity":{"source":"iana"},"application/xml-patch+xml":{"source":"iana","compressible":true},"application/xmpp+xml":{"source":"iana","compressible":true},"application/xop+xml":{"source":"iana","compressible":true,"extensions":["xop"]},"application/xproc+xml":{"source":"apache","compressible":true,"extensions":["xpl"]},"application/xslt+xml":{"source":"iana","compressible":true,"extensions":["xsl","xslt"]},"application/xspf+xml":{"source":"apache","compressible":true,"extensions":["xspf"]},"application/xv+xml":{"source":"iana","compressible":true,"extensions":["mxml","xhvml","xvml","xvm"]},"application/yang":{"source":"iana","extensions":["yang"]},"application/yang-data+json":{"source":"iana","compressible":true},"application/yang-data+xml":{"source":"iana","compressible":true},"application/yang-patch+json":{"source":"iana","compressible":true},"application/yang-patch+xml":{"source":"iana","compressible":true},"application/yin+xml":{"source":"iana","compressible":true,"extensions":["yin"]},"application/zip":{"source":"iana","compressible":false,"extensions":["zip"]},"application/zlib":{"source":"iana"},"application/zstd":{"source":"iana"},"audio/1d-interleaved-parityfec":{"source":"iana"},"audio/32kadpcm":{"source":"iana"},"audio/3gpp":{"source":"iana","compressible":false,"extensions":["3gpp"]},"audio/3gpp2":{"source":"iana"},"audio/aac":{"source":"iana"},"audio/ac3":{"source":"iana"},"audio/adpcm":{"source":"apache","extensions":["adp"]},"audio/amr":{"source":"iana","extensions":["amr"]},"audio/amr-wb":{"source":"iana"},"audio/amr-wb+":{"source":"iana"},"audio/aptx":{"source":"iana"},"audio/asc":{"source":"iana"},"audio/atrac-advanced-lossless":{"source":"iana"},"audio/atrac-x":{"source":"iana"},"audio/atrac3":{"source":"iana"},"audio/basic":{"source":"iana","compressible":false,"extensions":["au","snd"]},"audio/bv16":{"source":"iana"},"audio/bv32":{"source":"iana"},"audio/clearmode":{"source":"iana"},"audio/cn":{"source":"iana"},"audio/dat12":{"source":"iana"},"audio/dls":{"source":"iana"},"audio/dsr-es201108":{"source":"iana"},"audio/dsr-es202050":{"source":"iana"},"audio/dsr-es202211":{"source":"iana"},"audio/dsr-es202212":{"source":"iana"},"audio/dv":{"source":"iana"},"audio/dvi4":{"source":"iana"},"audio/eac3":{"source":"iana"},"audio/encaprtp":{"source":"iana"},"audio/evrc":{"source":"iana"},"audio/evrc-qcp":{"source":"iana"},"audio/evrc0":{"source":"iana"},"audio/evrc1":{"source":"iana"},"audio/evrcb":{"source":"iana"},"audio/evrcb0":{"source":"iana"},"audio/evrcb1":{"source":"iana"},"audio/evrcnw":{"source":"iana"},"audio/evrcnw0":{"source":"iana"},"audio/evrcnw1":{"source":"iana"},"audio/evrcwb":{"source":"iana"},"audio/evrcwb0":{"source":"iana"},"audio/evrcwb1":{"source":"iana"},"audio/evs":{"source":"iana"},"audio/flexfec":{"source":"iana"},"audio/fwdred":{"source":"iana"},"audio/g711-0":{"source":"iana"},"audio/g719":{"source":"iana"},"audio/g722":{"source":"iana"},"audio/g7221":{"source":"iana"},"audio/g723":{"source":"iana"},"audio/g726-16":{"source":"iana"},"audio/g726-24":{"source":"iana"},"audio/g726-32":{"source":"iana"},"audio/g726-40":{"source":"iana"},"audio/g728":{"source":"iana"},"audio/g729":{"source":"iana"},"audio/g7291":{"source":"iana"},"audio/g729d":{"source":"iana"},"audio/g729e":{"source":"iana"},"audio/gsm":{"source":"iana"},"audio/gsm-efr":{"source":"iana"},"audio/gsm-hr-08":{"source":"iana"},"audio/ilbc":{"source":"iana"},"audio/ip-mr_v2.5":{"source":"iana"},"audio/isac":{"source":"apache"},"audio/l16":{"source":"iana"},"audio/l20":{"source":"iana"},"audio/l24":{"source":"iana","compressible":false},"audio/l8":{"source":"iana"},"audio/lpc":{"source":"iana"},"audio/melp":{"source":"iana"},"audio/melp1200":{"source":"iana"},"audio/melp2400":{"source":"iana"},"audio/melp600":{"source":"iana"},"audio/mhas":{"source":"iana"},"audio/midi":{"source":"apache","extensions":["mid","midi","kar","rmi"]},"audio/mobile-xmf":{"source":"iana","extensions":["mxmf"]},"audio/mp3":{"compressible":false,"extensions":["mp3"]},"audio/mp4":{"source":"iana","compressible":false,"extensions":["m4a","mp4a"]},"audio/mp4a-latm":{"source":"iana"},"audio/mpa":{"source":"iana"},"audio/mpa-robust":{"source":"iana"},"audio/mpeg":{"source":"iana","compressible":false,"extensions":["mpga","mp2","mp2a","mp3","m2a","m3a"]},"audio/mpeg4-generic":{"source":"iana"},"audio/musepack":{"source":"apache"},"audio/ogg":{"source":"iana","compressible":false,"extensions":["oga","ogg","spx","opus"]},"audio/opus":{"source":"iana"},"audio/parityfec":{"source":"iana"},"audio/pcma":{"source":"iana"},"audio/pcma-wb":{"source":"iana"},"audio/pcmu":{"source":"iana"},"audio/pcmu-wb":{"source":"iana"},"audio/prs.sid":{"source":"iana"},"audio/qcelp":{"source":"iana"},"audio/raptorfec":{"source":"iana"},"audio/red":{"source":"iana"},"audio/rtp-enc-aescm128":{"source":"iana"},"audio/rtp-midi":{"source":"iana"},"audio/rtploopback":{"source":"iana"},"audio/rtx":{"source":"iana"},"audio/s3m":{"source":"apache","extensions":["s3m"]},"audio/scip":{"source":"iana"},"audio/silk":{"source":"apache","extensions":["sil"]},"audio/smv":{"source":"iana"},"audio/smv-qcp":{"source":"iana"},"audio/smv0":{"source":"iana"},"audio/sofa":{"source":"iana"},"audio/sp-midi":{"source":"iana"},"audio/speex":{"source":"iana"},"audio/t140c":{"source":"iana"},"audio/t38":{"source":"iana"},"audio/telephone-event":{"source":"iana"},"audio/tetra_acelp":{"source":"iana"},"audio/tetra_acelp_bb":{"source":"iana"},"audio/tone":{"source":"iana"},"audio/tsvcis":{"source":"iana"},"audio/uemclip":{"source":"iana"},"audio/ulpfec":{"source":"iana"},"audio/usac":{"source":"iana"},"audio/vdvi":{"source":"iana"},"audio/vmr-wb":{"source":"iana"},"audio/vnd.3gpp.iufp":{"source":"iana"},"audio/vnd.4sb":{"source":"iana"},"audio/vnd.audiokoz":{"source":"iana"},"audio/vnd.celp":{"source":"iana"},"audio/vnd.cisco.nse":{"source":"iana"},"audio/vnd.cmles.radio-events":{"source":"iana"},"audio/vnd.cns.anp1":{"source":"iana"},"audio/vnd.cns.inf1":{"source":"iana"},"audio/vnd.dece.audio":{"source":"iana","extensions":["uva","uvva"]},"audio/vnd.digital-winds":{"source":"iana","extensions":["eol"]},"audio/vnd.dlna.adts":{"source":"iana"},"audio/vnd.dolby.heaac.1":{"source":"iana"},"audio/vnd.dolby.heaac.2":{"source":"iana"},"audio/vnd.dolby.mlp":{"source":"iana"},"audio/vnd.dolby.mps":{"source":"iana"},"audio/vnd.dolby.pl2":{"source":"iana"},"audio/vnd.dolby.pl2x":{"source":"iana"},"audio/vnd.dolby.pl2z":{"source":"iana"},"audio/vnd.dolby.pulse.1":{"source":"iana"},"audio/vnd.dra":{"source":"iana","extensions":["dra"]},"audio/vnd.dts":{"source":"iana","extensions":["dts"]},"audio/vnd.dts.hd":{"source":"iana","extensions":["dtshd"]},"audio/vnd.dts.uhd":{"source":"iana"},"audio/vnd.dvb.file":{"source":"iana"},"audio/vnd.everad.plj":{"source":"iana"},"audio/vnd.hns.audio":{"source":"iana"},"audio/vnd.lucent.voice":{"source":"iana","extensions":["lvp"]},"audio/vnd.ms-playready.media.pya":{"source":"iana","extensions":["pya"]},"audio/vnd.nokia.mobile-xmf":{"source":"iana"},"audio/vnd.nortel.vbk":{"source":"iana"},"audio/vnd.nuera.ecelp4800":{"source":"iana","extensions":["ecelp4800"]},"audio/vnd.nuera.ecelp7470":{"source":"iana","extensions":["ecelp7470"]},"audio/vnd.nuera.ecelp9600":{"source":"iana","extensions":["ecelp9600"]},"audio/vnd.octel.sbc":{"source":"iana"},"audio/vnd.presonus.multitrack":{"source":"iana"},"audio/vnd.qcelp":{"source":"iana"},"audio/vnd.rhetorex.32kadpcm":{"source":"iana"},"audio/vnd.rip":{"source":"iana","extensions":["rip"]},"audio/vnd.rn-realaudio":{"compressible":false},"audio/vnd.sealedmedia.softseal.mpeg":{"source":"iana"},"audio/vnd.vmx.cvsd":{"source":"iana"},"audio/vnd.wave":{"compressible":false},"audio/vorbis":{"source":"iana","compressible":false},"audio/vorbis-config":{"source":"iana"},"audio/wav":{"compressible":false,"extensions":["wav"]},"audio/wave":{"compressible":false,"extensions":["wav"]},"audio/webm":{"source":"apache","compressible":false,"extensions":["weba"]},"audio/x-aac":{"source":"apache","compressible":false,"extensions":["aac"]},"audio/x-aiff":{"source":"apache","extensions":["aif","aiff","aifc"]},"audio/x-caf":{"source":"apache","compressible":false,"extensions":["caf"]},"audio/x-flac":{"source":"apache","extensions":["flac"]},"audio/x-m4a":{"source":"nginx","extensions":["m4a"]},"audio/x-matroska":{"source":"apache","extensions":["mka"]},"audio/x-mpegurl":{"source":"apache","extensions":["m3u"]},"audio/x-ms-wax":{"source":"apache","extensions":["wax"]},"audio/x-ms-wma":{"source":"apache","extensions":["wma"]},"audio/x-pn-realaudio":{"source":"apache","extensions":["ram","ra"]},"audio/x-pn-realaudio-plugin":{"source":"apache","extensions":["rmp"]},"audio/x-realaudio":{"source":"nginx","extensions":["ra"]},"audio/x-tta":{"source":"apache"},"audio/x-wav":{"source":"apache","extensions":["wav"]},"audio/xm":{"source":"apache","extensions":["xm"]},"chemical/x-cdx":{"source":"apache","extensions":["cdx"]},"chemical/x-cif":{"source":"apache","extensions":["cif"]},"chemical/x-cmdf":{"source":"apache","extensions":["cmdf"]},"chemical/x-cml":{"source":"apache","extensions":["cml"]},"chemical/x-csml":{"source":"apache","extensions":["csml"]},"chemical/x-pdb":{"source":"apache"},"chemical/x-xyz":{"source":"apache","extensions":["xyz"]},"font/collection":{"source":"iana","extensions":["ttc"]},"font/otf":{"source":"iana","compressible":true,"extensions":["otf"]},"font/sfnt":{"source":"iana"},"font/ttf":{"source":"iana","compressible":true,"extensions":["ttf"]},"font/woff":{"source":"iana","extensions":["woff"]},"font/woff2":{"source":"iana","extensions":["woff2"]},"image/aces":{"source":"iana","extensions":["exr"]},"image/apng":{"compressible":false,"extensions":["apng"]},"image/avci":{"source":"iana","extensions":["avci"]},"image/avcs":{"source":"iana","extensions":["avcs"]},"image/avif":{"source":"iana","compressible":false,"extensions":["avif"]},"image/bmp":{"source":"iana","compressible":true,"extensions":["bmp"]},"image/cgm":{"source":"iana","extensions":["cgm"]},"image/dicom-rle":{"source":"iana","extensions":["drle"]},"image/emf":{"source":"iana","extensions":["emf"]},"image/fits":{"source":"iana","extensions":["fits"]},"image/g3fax":{"source":"iana","extensions":["g3"]},"image/gif":{"source":"iana","compressible":false,"extensions":["gif"]},"image/heic":{"source":"iana","extensions":["heic"]},"image/heic-sequence":{"source":"iana","extensions":["heics"]},"image/heif":{"source":"iana","extensions":["heif"]},"image/heif-sequence":{"source":"iana","extensions":["heifs"]},"image/hej2k":{"source":"iana","extensions":["hej2"]},"image/hsj2":{"source":"iana","extensions":["hsj2"]},"image/ief":{"source":"iana","extensions":["ief"]},"image/jls":{"source":"iana","extensions":["jls"]},"image/jp2":{"source":"iana","compressible":false,"extensions":["jp2","jpg2"]},"image/jpeg":{"source":"iana","compressible":false,"extensions":["jpeg","jpg","jpe"]},"image/jph":{"source":"iana","extensions":["jph"]},"image/jphc":{"source":"iana","extensions":["jhc"]},"image/jpm":{"source":"iana","compressible":false,"extensions":["jpm"]},"image/jpx":{"source":"iana","compressible":false,"extensions":["jpx","jpf"]},"image/jxr":{"source":"iana","extensions":["jxr"]},"image/jxra":{"source":"iana","extensions":["jxra"]},"image/jxrs":{"source":"iana","extensions":["jxrs"]},"image/jxs":{"source":"iana","extensions":["jxs"]},"image/jxsc":{"source":"iana","extensions":["jxsc"]},"image/jxsi":{"source":"iana","extensions":["jxsi"]},"image/jxss":{"source":"iana","extensions":["jxss"]},"image/ktx":{"source":"iana","extensions":["ktx"]},"image/ktx2":{"source":"iana","extensions":["ktx2"]},"image/naplps":{"source":"iana"},"image/pjpeg":{"compressible":false},"image/png":{"source":"iana","compressible":false,"extensions":["png"]},"image/prs.btif":{"source":"iana","extensions":["btif"]},"image/prs.pti":{"source":"iana","extensions":["pti"]},"image/pwg-raster":{"source":"iana"},"image/sgi":{"source":"apache","extensions":["sgi"]},"image/svg+xml":{"source":"iana","compressible":true,"extensions":["svg","svgz"]},"image/t38":{"source":"iana","extensions":["t38"]},"image/tiff":{"source":"iana","compressible":false,"extensions":["tif","tiff"]},"image/tiff-fx":{"source":"iana","extensions":["tfx"]},"image/vnd.adobe.photoshop":{"source":"iana","compressible":true,"extensions":["psd"]},"image/vnd.airzip.accelerator.azv":{"source":"iana","extensions":["azv"]},"image/vnd.cns.inf2":{"source":"iana"},"image/vnd.dece.graphic":{"source":"iana","extensions":["uvi","uvvi","uvg","uvvg"]},"image/vnd.djvu":{"source":"iana","extensions":["djvu","djv"]},"image/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"image/vnd.dwg":{"source":"iana","extensions":["dwg"]},"image/vnd.dxf":{"source":"iana","extensions":["dxf"]},"image/vnd.fastbidsheet":{"source":"iana","extensions":["fbs"]},"image/vnd.fpx":{"source":"iana","extensions":["fpx"]},"image/vnd.fst":{"source":"iana","extensions":["fst"]},"image/vnd.fujixerox.edmics-mmr":{"source":"iana","extensions":["mmr"]},"image/vnd.fujixerox.edmics-rlc":{"source":"iana","extensions":["rlc"]},"image/vnd.globalgraphics.pgb":{"source":"iana"},"image/vnd.microsoft.icon":{"source":"iana","compressible":true,"extensions":["ico"]},"image/vnd.mix":{"source":"iana"},"image/vnd.mozilla.apng":{"source":"iana"},"image/vnd.ms-dds":{"compressible":true,"extensions":["dds"]},"image/vnd.ms-modi":{"source":"iana","extensions":["mdi"]},"image/vnd.ms-photo":{"source":"apache","extensions":["wdp"]},"image/vnd.net-fpx":{"source":"iana","extensions":["npx"]},"image/vnd.pco.b16":{"source":"iana","extensions":["b16"]},"image/vnd.radiance":{"source":"iana"},"image/vnd.sealed.png":{"source":"iana"},"image/vnd.sealedmedia.softseal.gif":{"source":"iana"},"image/vnd.sealedmedia.softseal.jpg":{"source":"iana"},"image/vnd.svf":{"source":"iana"},"image/vnd.tencent.tap":{"source":"iana","extensions":["tap"]},"image/vnd.valve.source.texture":{"source":"iana","extensions":["vtf"]},"image/vnd.wap.wbmp":{"source":"iana","extensions":["wbmp"]},"image/vnd.xiff":{"source":"iana","extensions":["xif"]},"image/vnd.zbrush.pcx":{"source":"iana","extensions":["pcx"]},"image/webp":{"source":"apache","extensions":["webp"]},"image/wmf":{"source":"iana","extensions":["wmf"]},"image/x-3ds":{"source":"apache","extensions":["3ds"]},"image/x-cmu-raster":{"source":"apache","extensions":["ras"]},"image/x-cmx":{"source":"apache","extensions":["cmx"]},"image/x-freehand":{"source":"apache","extensions":["fh","fhc","fh4","fh5","fh7"]},"image/x-icon":{"source":"apache","compressible":true,"extensions":["ico"]},"image/x-jng":{"source":"nginx","extensions":["jng"]},"image/x-mrsid-image":{"source":"apache","extensions":["sid"]},"image/x-ms-bmp":{"source":"nginx","compressible":true,"extensions":["bmp"]},"image/x-pcx":{"source":"apache","extensions":["pcx"]},"image/x-pict":{"source":"apache","extensions":["pic","pct"]},"image/x-portable-anymap":{"source":"apache","extensions":["pnm"]},"image/x-portable-bitmap":{"source":"apache","extensions":["pbm"]},"image/x-portable-graymap":{"source":"apache","extensions":["pgm"]},"image/x-portable-pixmap":{"source":"apache","extensions":["ppm"]},"image/x-rgb":{"source":"apache","extensions":["rgb"]},"image/x-tga":{"source":"apache","extensions":["tga"]},"image/x-xbitmap":{"source":"apache","extensions":["xbm"]},"image/x-xcf":{"compressible":false},"image/x-xpixmap":{"source":"apache","extensions":["xpm"]},"image/x-xwindowdump":{"source":"apache","extensions":["xwd"]},"message/cpim":{"source":"iana"},"message/delivery-status":{"source":"iana"},"message/disposition-notification":{"source":"iana","extensions":["disposition-notification"]},"message/external-body":{"source":"iana"},"message/feedback-report":{"source":"iana"},"message/global":{"source":"iana","extensions":["u8msg"]},"message/global-delivery-status":{"source":"iana","extensions":["u8dsn"]},"message/global-disposition-notification":{"source":"iana","extensions":["u8mdn"]},"message/global-headers":{"source":"iana","extensions":["u8hdr"]},"message/http":{"source":"iana","compressible":false},"message/imdn+xml":{"source":"iana","compressible":true},"message/news":{"source":"iana"},"message/partial":{"source":"iana","compressible":false},"message/rfc822":{"source":"iana","compressible":true,"extensions":["eml","mime"]},"message/s-http":{"source":"iana"},"message/sip":{"source":"iana"},"message/sipfrag":{"source":"iana"},"message/tracking-status":{"source":"iana"},"message/vnd.si.simp":{"source":"iana"},"message/vnd.wfa.wsc":{"source":"iana","extensions":["wsc"]},"model/3mf":{"source":"iana","extensions":["3mf"]},"model/e57":{"source":"iana"},"model/gltf+json":{"source":"iana","compressible":true,"extensions":["gltf"]},"model/gltf-binary":{"source":"iana","compressible":true,"extensions":["glb"]},"model/iges":{"source":"iana","compressible":false,"extensions":["igs","iges"]},"model/mesh":{"source":"iana","compressible":false,"extensions":["msh","mesh","silo"]},"model/mtl":{"source":"iana","extensions":["mtl"]},"model/obj":{"source":"iana","extensions":["obj"]},"model/step":{"source":"iana"},"model/step+xml":{"source":"iana","compressible":true,"extensions":["stpx"]},"model/step+zip":{"source":"iana","compressible":false,"extensions":["stpz"]},"model/step-xml+zip":{"source":"iana","compressible":false,"extensions":["stpxz"]},"model/stl":{"source":"iana","extensions":["stl"]},"model/vnd.collada+xml":{"source":"iana","compressible":true,"extensions":["dae"]},"model/vnd.dwf":{"source":"iana","extensions":["dwf"]},"model/vnd.flatland.3dml":{"source":"iana"},"model/vnd.gdl":{"source":"iana","extensions":["gdl"]},"model/vnd.gs-gdl":{"source":"apache"},"model/vnd.gs.gdl":{"source":"iana"},"model/vnd.gtw":{"source":"iana","extensions":["gtw"]},"model/vnd.moml+xml":{"source":"iana","compressible":true},"model/vnd.mts":{"source":"iana","extensions":["mts"]},"model/vnd.opengex":{"source":"iana","extensions":["ogex"]},"model/vnd.parasolid.transmit.binary":{"source":"iana","extensions":["x_b"]},"model/vnd.parasolid.transmit.text":{"source":"iana","extensions":["x_t"]},"model/vnd.pytha.pyox":{"source":"iana"},"model/vnd.rosette.annotated-data-model":{"source":"iana"},"model/vnd.sap.vds":{"source":"iana","extensions":["vds"]},"model/vnd.usdz+zip":{"source":"iana","compressible":false,"extensions":["usdz"]},"model/vnd.valve.source.compiled-map":{"source":"iana","extensions":["bsp"]},"model/vnd.vtu":{"source":"iana","extensions":["vtu"]},"model/vrml":{"source":"iana","compressible":false,"extensions":["wrl","vrml"]},"model/x3d+binary":{"source":"apache","compressible":false,"extensions":["x3db","x3dbz"]},"model/x3d+fastinfoset":{"source":"iana","extensions":["x3db"]},"model/x3d+vrml":{"source":"apache","compressible":false,"extensions":["x3dv","x3dvz"]},"model/x3d+xml":{"source":"iana","compressible":true,"extensions":["x3d","x3dz"]},"model/x3d-vrml":{"source":"iana","extensions":["x3dv"]},"multipart/alternative":{"source":"iana","compressible":false},"multipart/appledouble":{"source":"iana"},"multipart/byteranges":{"source":"iana"},"multipart/digest":{"source":"iana"},"multipart/encrypted":{"source":"iana","compressible":false},"multipart/form-data":{"source":"iana","compressible":false},"multipart/header-set":{"source":"iana"},"multipart/mixed":{"source":"iana"},"multipart/multilingual":{"source":"iana"},"multipart/parallel":{"source":"iana"},"multipart/related":{"source":"iana","compressible":false},"multipart/report":{"source":"iana"},"multipart/signed":{"source":"iana","compressible":false},"multipart/vnd.bint.med-plus":{"source":"iana"},"multipart/voice-message":{"source":"iana"},"multipart/x-mixed-replace":{"source":"iana"},"text/1d-interleaved-parityfec":{"source":"iana"},"text/cache-manifest":{"source":"iana","compressible":true,"extensions":["appcache","manifest"]},"text/calendar":{"source":"iana","extensions":["ics","ifb"]},"text/calender":{"compressible":true},"text/cmd":{"compressible":true},"text/coffeescript":{"extensions":["coffee","litcoffee"]},"text/cql":{"source":"iana"},"text/cql-expression":{"source":"iana"},"text/cql-identifier":{"source":"iana"},"text/css":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["css"]},"text/csv":{"source":"iana","compressible":true,"extensions":["csv"]},"text/csv-schema":{"source":"iana"},"text/directory":{"source":"iana"},"text/dns":{"source":"iana"},"text/ecmascript":{"source":"iana"},"text/encaprtp":{"source":"iana"},"text/enriched":{"source":"iana"},"text/fhirpath":{"source":"iana"},"text/flexfec":{"source":"iana"},"text/fwdred":{"source":"iana"},"text/gff3":{"source":"iana"},"text/grammar-ref-list":{"source":"iana"},"text/html":{"source":"iana","compressible":true,"extensions":["html","htm","shtml"]},"text/jade":{"extensions":["jade"]},"text/javascript":{"source":"iana","compressible":true},"text/jcr-cnd":{"source":"iana"},"text/jsx":{"compressible":true,"extensions":["jsx"]},"text/less":{"compressible":true,"extensions":["less"]},"text/markdown":{"source":"iana","compressible":true,"extensions":["markdown","md"]},"text/mathml":{"source":"nginx","extensions":["mml"]},"text/mdx":{"compressible":true,"extensions":["mdx"]},"text/mizar":{"source":"iana"},"text/n3":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["n3"]},"text/parameters":{"source":"iana","charset":"UTF-8"},"text/parityfec":{"source":"iana"},"text/plain":{"source":"iana","compressible":true,"extensions":["txt","text","conf","def","list","log","in","ini"]},"text/provenance-notation":{"source":"iana","charset":"UTF-8"},"text/prs.fallenstein.rst":{"source":"iana"},"text/prs.lines.tag":{"source":"iana","extensions":["dsc"]},"text/prs.prop.logic":{"source":"iana"},"text/raptorfec":{"source":"iana"},"text/red":{"source":"iana"},"text/rfc822-headers":{"source":"iana"},"text/richtext":{"source":"iana","compressible":true,"extensions":["rtx"]},"text/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"text/rtp-enc-aescm128":{"source":"iana"},"text/rtploopback":{"source":"iana"},"text/rtx":{"source":"iana"},"text/sgml":{"source":"iana","extensions":["sgml","sgm"]},"text/shaclc":{"source":"iana"},"text/shex":{"source":"iana","extensions":["shex"]},"text/slim":{"extensions":["slim","slm"]},"text/spdx":{"source":"iana","extensions":["spdx"]},"text/strings":{"source":"iana"},"text/stylus":{"extensions":["stylus","styl"]},"text/t140":{"source":"iana"},"text/tab-separated-values":{"source":"iana","compressible":true,"extensions":["tsv"]},"text/troff":{"source":"iana","extensions":["t","tr","roff","man","me","ms"]},"text/turtle":{"source":"iana","charset":"UTF-8","extensions":["ttl"]},"text/ulpfec":{"source":"iana"},"text/uri-list":{"source":"iana","compressible":true,"extensions":["uri","uris","urls"]},"text/vcard":{"source":"iana","compressible":true,"extensions":["vcard"]},"text/vnd.a":{"source":"iana"},"text/vnd.abc":{"source":"iana"},"text/vnd.ascii-art":{"source":"iana"},"text/vnd.curl":{"source":"iana","extensions":["curl"]},"text/vnd.curl.dcurl":{"source":"apache","extensions":["dcurl"]},"text/vnd.curl.mcurl":{"source":"apache","extensions":["mcurl"]},"text/vnd.curl.scurl":{"source":"apache","extensions":["scurl"]},"text/vnd.debian.copyright":{"source":"iana","charset":"UTF-8"},"text/vnd.dmclientscript":{"source":"iana"},"text/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"text/vnd.esmertec.theme-descriptor":{"source":"iana","charset":"UTF-8"},"text/vnd.familysearch.gedcom":{"source":"iana","extensions":["ged"]},"text/vnd.ficlab.flt":{"source":"iana"},"text/vnd.fly":{"source":"iana","extensions":["fly"]},"text/vnd.fmi.flexstor":{"source":"iana","extensions":["flx"]},"text/vnd.gml":{"source":"iana"},"text/vnd.graphviz":{"source":"iana","extensions":["gv"]},"text/vnd.hans":{"source":"iana"},"text/vnd.hgl":{"source":"iana"},"text/vnd.in3d.3dml":{"source":"iana","extensions":["3dml"]},"text/vnd.in3d.spot":{"source":"iana","extensions":["spot"]},"text/vnd.iptc.newsml":{"source":"iana"},"text/vnd.iptc.nitf":{"source":"iana"},"text/vnd.latex-z":{"source":"iana"},"text/vnd.motorola.reflex":{"source":"iana"},"text/vnd.ms-mediapackage":{"source":"iana"},"text/vnd.net2phone.commcenter.command":{"source":"iana"},"text/vnd.radisys.msml-basic-layout":{"source":"iana"},"text/vnd.senx.warpscript":{"source":"iana"},"text/vnd.si.uricatalogue":{"source":"iana"},"text/vnd.sosi":{"source":"iana"},"text/vnd.sun.j2me.app-descriptor":{"source":"iana","charset":"UTF-8","extensions":["jad"]},"text/vnd.trolltech.linguist":{"source":"iana","charset":"UTF-8"},"text/vnd.wap.si":{"source":"iana"},"text/vnd.wap.sl":{"source":"iana"},"text/vnd.wap.wml":{"source":"iana","extensions":["wml"]},"text/vnd.wap.wmlscript":{"source":"iana","extensions":["wmls"]},"text/vtt":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["vtt"]},"text/x-asm":{"source":"apache","extensions":["s","asm"]},"text/x-c":{"source":"apache","extensions":["c","cc","cxx","cpp","h","hh","dic"]},"text/x-component":{"source":"nginx","extensions":["htc"]},"text/x-fortran":{"source":"apache","extensions":["f","for","f77","f90"]},"text/x-gwt-rpc":{"compressible":true},"text/x-handlebars-template":{"extensions":["hbs"]},"text/x-java-source":{"source":"apache","extensions":["java"]},"text/x-jquery-tmpl":{"compressible":true},"text/x-lua":{"extensions":["lua"]},"text/x-markdown":{"compressible":true,"extensions":["mkd"]},"text/x-nfo":{"source":"apache","extensions":["nfo"]},"text/x-opml":{"source":"apache","extensions":["opml"]},"text/x-org":{"compressible":true,"extensions":["org"]},"text/x-pascal":{"source":"apache","extensions":["p","pas"]},"text/x-processing":{"compressible":true,"extensions":["pde"]},"text/x-sass":{"extensions":["sass"]},"text/x-scss":{"extensions":["scss"]},"text/x-setext":{"source":"apache","extensions":["etx"]},"text/x-sfv":{"source":"apache","extensions":["sfv"]},"text/x-suse-ymp":{"compressible":true,"extensions":["ymp"]},"text/x-uuencode":{"source":"apache","extensions":["uu"]},"text/x-vcalendar":{"source":"apache","extensions":["vcs"]},"text/x-vcard":{"source":"apache","extensions":["vcf"]},"text/xml":{"source":"iana","compressible":true,"extensions":["xml"]},"text/xml-external-parsed-entity":{"source":"iana"},"text/yaml":{"compressible":true,"extensions":["yaml","yml"]},"video/1d-interleaved-parityfec":{"source":"iana"},"video/3gpp":{"source":"iana","extensions":["3gp","3gpp"]},"video/3gpp-tt":{"source":"iana"},"video/3gpp2":{"source":"iana","extensions":["3g2"]},"video/av1":{"source":"iana"},"video/bmpeg":{"source":"iana"},"video/bt656":{"source":"iana"},"video/celb":{"source":"iana"},"video/dv":{"source":"iana"},"video/encaprtp":{"source":"iana"},"video/ffv1":{"source":"iana"},"video/flexfec":{"source":"iana"},"video/h261":{"source":"iana","extensions":["h261"]},"video/h263":{"source":"iana","extensions":["h263"]},"video/h263-1998":{"source":"iana"},"video/h263-2000":{"source":"iana"},"video/h264":{"source":"iana","extensions":["h264"]},"video/h264-rcdo":{"source":"iana"},"video/h264-svc":{"source":"iana"},"video/h265":{"source":"iana"},"video/iso.segment":{"source":"iana","extensions":["m4s"]},"video/jpeg":{"source":"iana","extensions":["jpgv"]},"video/jpeg2000":{"source":"iana"},"video/jpm":{"source":"apache","extensions":["jpm","jpgm"]},"video/jxsv":{"source":"iana"},"video/mj2":{"source":"iana","extensions":["mj2","mjp2"]},"video/mp1s":{"source":"iana"},"video/mp2p":{"source":"iana"},"video/mp2t":{"source":"iana","extensions":["ts"]},"video/mp4":{"source":"iana","compressible":false,"extensions":["mp4","mp4v","mpg4"]},"video/mp4v-es":{"source":"iana"},"video/mpeg":{"source":"iana","compressible":false,"extensions":["mpeg","mpg","mpe","m1v","m2v"]},"video/mpeg4-generic":{"source":"iana"},"video/mpv":{"source":"iana"},"video/nv":{"source":"iana"},"video/ogg":{"source":"iana","compressible":false,"extensions":["ogv"]},"video/parityfec":{"source":"iana"},"video/pointer":{"source":"iana"},"video/quicktime":{"source":"iana","compressible":false,"extensions":["qt","mov"]},"video/raptorfec":{"source":"iana"},"video/raw":{"source":"iana"},"video/rtp-enc-aescm128":{"source":"iana"},"video/rtploopback":{"source":"iana"},"video/rtx":{"source":"iana"},"video/scip":{"source":"iana"},"video/smpte291":{"source":"iana"},"video/smpte292m":{"source":"iana"},"video/ulpfec":{"source":"iana"},"video/vc1":{"source":"iana"},"video/vc2":{"source":"iana"},"video/vnd.cctv":{"source":"iana"},"video/vnd.dece.hd":{"source":"iana","extensions":["uvh","uvvh"]},"video/vnd.dece.mobile":{"source":"iana","extensions":["uvm","uvvm"]},"video/vnd.dece.mp4":{"source":"iana"},"video/vnd.dece.pd":{"source":"iana","extensions":["uvp","uvvp"]},"video/vnd.dece.sd":{"source":"iana","extensions":["uvs","uvvs"]},"video/vnd.dece.video":{"source":"iana","extensions":["uvv","uvvv"]},"video/vnd.directv.mpeg":{"source":"iana"},"video/vnd.directv.mpeg-tts":{"source":"iana"},"video/vnd.dlna.mpeg-tts":{"source":"iana"},"video/vnd.dvb.file":{"source":"iana","extensions":["dvb"]},"video/vnd.fvt":{"source":"iana","extensions":["fvt"]},"video/vnd.hns.video":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.ttsavc":{"source":"iana"},"video/vnd.iptvforum.ttsmpeg2":{"source":"iana"},"video/vnd.motorola.video":{"source":"iana"},"video/vnd.motorola.videop":{"source":"iana"},"video/vnd.mpegurl":{"source":"iana","extensions":["mxu","m4u"]},"video/vnd.ms-playready.media.pyv":{"source":"iana","extensions":["pyv"]},"video/vnd.nokia.interleaved-multimedia":{"source":"iana"},"video/vnd.nokia.mp4vr":{"source":"iana"},"video/vnd.nokia.videovoip":{"source":"iana"},"video/vnd.objectvideo":{"source":"iana"},"video/vnd.radgamettools.bink":{"source":"iana"},"video/vnd.radgamettools.smacker":{"source":"iana"},"video/vnd.sealed.mpeg1":{"source":"iana"},"video/vnd.sealed.mpeg4":{"source":"iana"},"video/vnd.sealed.swf":{"source":"iana"},"video/vnd.sealedmedia.softseal.mov":{"source":"iana"},"video/vnd.uvvu.mp4":{"source":"iana","extensions":["uvu","uvvu"]},"video/vnd.vivo":{"source":"iana","extensions":["viv"]},"video/vnd.youtube.yt":{"source":"iana"},"video/vp8":{"source":"iana"},"video/vp9":{"source":"iana"},"video/webm":{"source":"apache","compressible":false,"extensions":["webm"]},"video/x-f4v":{"source":"apache","extensions":["f4v"]},"video/x-fli":{"source":"apache","extensions":["fli"]},"video/x-flv":{"source":"apache","compressible":false,"extensions":["flv"]},"video/x-m4v":{"source":"apache","extensions":["m4v"]},"video/x-matroska":{"source":"apache","compressible":false,"extensions":["mkv","mk3d","mks"]},"video/x-mng":{"source":"apache","extensions":["mng"]},"video/x-ms-asf":{"source":"apache","extensions":["asf","asx"]},"video/x-ms-vob":{"source":"apache","extensions":["vob"]},"video/x-ms-wm":{"source":"apache","extensions":["wm"]},"video/x-ms-wmv":{"source":"apache","compressible":false,"extensions":["wmv"]},"video/x-ms-wmx":{"source":"apache","extensions":["wmx"]},"video/x-ms-wvx":{"source":"apache","extensions":["wvx"]},"video/x-msvideo":{"source":"apache","extensions":["avi"]},"video/x-sgi-movie":{"source":"apache","extensions":["movie"]},"video/x-smv":{"source":"apache","extensions":["smv"]},"x-conference/x-cooltalk":{"source":"apache","extensions":["ice"]},"x-shader/x-fragment":{"compressible":true},"x-shader/x-vertex":{"compressible":true}}

/***/ }),
/* 3112 */
/***/ (function(module, exports, __webpack_require__) {

/*!
 * mime-db
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015-2022 Douglas Christopher Wilson
 * MIT Licensed
 */

/**
 * Module exports.
 */

module.exports = __webpack_require__(3111)


/***/ }),
/* 3113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * mime-types
 * Copyright(c) 2014 Jonathan Ong
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module dependencies.
 * @private
 */

var db = __webpack_require__(3112)
var extname = __webpack_require__(682).extname

/**
 * Module variables.
 * @private
 */

var EXTRACT_TYPE_REGEXP = /^\s*([^;\s]*)(?:;|\s|$)/
var TEXT_TYPE_REGEXP = /^text\//i

/**
 * Module exports.
 * @public
 */

exports.charset = charset
exports.charsets = { lookup: charset }
exports.contentType = contentType
exports.extension = extension
exports.extensions = Object.create(null)
exports.lookup = lookup
exports.types = Object.create(null)

// Populate the extensions/types maps
populateMaps(exports.extensions, exports.types)

/**
 * Get the default charset for a MIME type.
 *
 * @param {string} type
 * @return {boolean|string}
 */

function charset (type) {
  if (!type || typeof type !== 'string') {
    return false
  }

  // TODO: use media-typer
  var match = EXTRACT_TYPE_REGEXP.exec(type)
  var mime = match && db[match[1].toLowerCase()]

  if (mime && mime.charset) {
    return mime.charset
  }

  // default text/* to utf-8
  if (match && TEXT_TYPE_REGEXP.test(match[1])) {
    return 'UTF-8'
  }

  return false
}

/**
 * Create a full Content-Type header given a MIME type or extension.
 *
 * @param {string} str
 * @return {boolean|string}
 */

function contentType (str) {
  // TODO: should this even be in this module?
  if (!str || typeof str !== 'string') {
    return false
  }

  var mime = str.indexOf('/') === -1
    ? exports.lookup(str)
    : str

  if (!mime) {
    return false
  }

  // TODO: use content-type or other module
  if (mime.indexOf('charset') === -1) {
    var charset = exports.charset(mime)
    if (charset) mime += '; charset=' + charset.toLowerCase()
  }

  return mime
}

/**
 * Get the default extension for a MIME type.
 *
 * @param {string} type
 * @return {boolean|string}
 */

function extension (type) {
  if (!type || typeof type !== 'string') {
    return false
  }

  // TODO: use media-typer
  var match = EXTRACT_TYPE_REGEXP.exec(type)

  // get extensions
  var exts = match && exports.extensions[match[1].toLowerCase()]

  if (!exts || !exts.length) {
    return false
  }

  return exts[0]
}

/**
 * Lookup the MIME type for a file path/extension.
 *
 * @param {string} path
 * @return {boolean|string}
 */

function lookup (path) {
  if (!path || typeof path !== 'string') {
    return false
  }

  // get the extension ("ext" or ".ext" or full path)
  var extension = extname('x.' + path)
    .toLowerCase()
    .substr(1)

  if (!extension) {
    return false
  }

  return exports.types[extension] || false
}

/**
 * Populate the extensions and types maps.
 * @private
 */

function populateMaps (extensions, types) {
  // source preference (least -> most)
  var preference = ['nginx', 'apache', undefined, 'iana']

  Object.keys(db).forEach(function forEachMimeType (type) {
    var mime = db[type]
    var exts = mime.extensions

    if (!exts || !exts.length) {
      return
    }

    // mime -> extensions
    extensions[type] = exts

    // extension -> mime
    for (var i = 0; i < exts.length; i++) {
      var extension = exts[i]

      if (types[extension]) {
        var from = preference.indexOf(db[types[extension]].source)
        var to = preference.indexOf(mime.source)

        if (types[extension] !== 'application/octet-stream' &&
          (from > to || (from === to && types[extension].substr(0, 12) === 'application/'))) {
          // skip the remapping
          continue
        }
      }

      // set the extension -> mime
      types[extension] = type
    }
  })
}


/***/ }),
/* 3114 */
/***/ (function(module, exports) {

module.exports = {"version":"2021a","zones":["Africa/Abidjan|LMT GMT|g.8 0|01|-2ldXH.Q|48e5","Africa/Accra|LMT GMT +0020 +0030|.Q 0 -k -u|01212121212121212121212121212121212121212121212131313131313131|-2bRzX.8 9RbX.8 fdE 1BAk MLE 1Bck MLE 1Bck MLE 1Bck MLE 1BAk MLE 1Bck MLE 1Bck MLE 1Bck MLE 1BAk MLE 1Bck MLE 1Bck MLE 1Bck MLE 1BAk MLE 1Bck MLE 1Bck MLE 1Bck MLE 1BAk MLE 1Bck MLE 1Bck MLE 1Bck MLE Mok 1BXE M0k 1BXE fak 9vbu bjCu MLu 1Bcu MLu 1BAu MLu 1Bcu MLu 1Bcu MLu 1Bcu MLu|41e5","Africa/Nairobi|LMT +0230 EAT +0245|-2r.g -2u -30 -2J|012132|-2ua2r.g N6nV.g 3Fbu h1cu dzbJ|47e5","Africa/Algiers|PMT WET WEST CET CEST|-9.l 0 -10 -10 -20|0121212121212121343431312123431213|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 DA0 Imo0 rd0 De0 9Xz0 1fb0 1ap0 16K0 2yo0 mEp0 hwL0 jxA0 11A0 dDd0 17b0 11B0 1cN0 2Dy0 1cN0 1fB0 1cL0|26e5","Africa/Lagos|LMT GMT +0030 WAT|-d.z 0 -u -10|01023|-2B40d.z 7iod.z dnXK.p dLzH.z|17e6","Africa/Bissau|LMT -01 GMT|12.k 10 0|012|-2ldX0 2xoo0|39e4","Africa/Maputo|LMT CAT|-2a.k -20|01|-2GJea.k|26e5","Africa/Cairo|EET EEST|-20 -30|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1bIO0 vb0 1ip0 11z0 1iN0 1nz0 12p0 1pz0 10N0 1pz0 16p0 1jz0 s3d0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1WL0 rd0 1Rz0 wp0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1qL0 Xd0 1oL0 11d0 1oL0 11d0 1pb0 11d0 1oL0 11d0 1oL0 11d0 1ny0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 WL0 1qN0 Rb0 1wp0 On0 1zd0 Lz0 1EN0 Fb0 c10 8n0 8Nd0 gL0 e10 mn0|15e6","Africa/Casablanca|LMT +00 +01|u.k 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-2gMnt.E 130Lt.E rb0 Dd0 dVb0 b6p0 TX0 EoB0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4mn0 SyN0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|32e5","Africa/Ceuta|WET WEST CET CEST|0 -10 -10 -20|010101010101010101010232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-25KN0 11z0 drd0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1y7o0 LL0 gnd0 rz0 43d0 AL0 1Nd0 XX0 1Cp0 pz0 dEp0 4VB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|85e3","Africa/El_Aaiun|LMT -01 +00 +01|Q.M 10 0 -10|012323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1rDz7.c 1GVA7.c 6L0 AL0 1Nd0 XX0 1Cp0 pz0 1cBB0 AL0 1Nd0 wn0 1FB0 Db0 1zd0 Lz0 1Nf0 wM0 co0 go0 1o00 s00 dA0 vc0 11A0 A00 e00 y00 11A0 uM0 e00 Dc0 11A0 s00 e00 IM0 WM0 mo0 gM0 LA0 WM0 jA0 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0 2600 e00 2600 gM0 2600 gM0 2600 e00 2600 gM0|20e4","Africa/Johannesburg|SAST SAST SAST|-1u -20 -30|012121|-2GJdu 1Ajdu 1cL0 1cN0 1cL0|84e5","Africa/Juba|LMT CAT CAST EAT|-26.s -20 -30 -30|012121212121212121212121212121212131|-1yW26.s 1zK06.s 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 PeX0|","Africa/Khartoum|LMT CAT CAST EAT|-2a.8 -20 -30 -30|012121212121212121212121212121212131|-1yW2a.8 1zK0a.8 16L0 1iN0 17b0 1jd0 17b0 1ip0 17z0 1i10 17X0 1hB0 18n0 1hd0 19b0 1gp0 19z0 1iN0 17b0 1ip0 17z0 1i10 18n0 1hd0 18L0 1gN0 19b0 1gp0 19z0 1iN0 17z0 1i10 17X0 yGd0 HjL0|51e5","Africa/Monrovia|MMT MMT GMT|H.8 I.u 0|012|-23Lzg.Q 28G01.m|11e5","Africa/Ndjamena|LMT WAT WAST|-10.c -10 -20|0121|-2le10.c 2J3c0.c Wn0|13e5","Africa/Sao_Tome|LMT GMT WAT|A.J 0 -10|0121|-2le00 4i6N0 2q00|","Africa/Tripoli|LMT CET CEST EET|-Q.I -10 -20 -20|012121213121212121212121213123123|-21JcQ.I 1hnBQ.I vx0 4iP0 xx0 4eN0 Bb0 7ip0 U0n0 A10 1db0 1cN0 1db0 1dd0 1db0 1eN0 1bb0 1e10 1cL0 1c10 1db0 1dd0 1db0 1cN0 1db0 1q10 fAn0 1ep0 1db0 AKq0 TA0 1o00|11e5","Africa/Tunis|PMT CET CEST|-9.l -10 -20|0121212121212121212121212121212121|-2nco9.l 18pa9.l 1qM0 DA0 3Tc0 11B0 1ze0 WM0 7z0 3d0 14L0 1cN0 1f90 1ar0 16J0 1gXB0 WM0 1rA0 11c0 nwo0 Ko0 1cM0 1cM0 1rA0 10M0 zuM0 10N0 1aN0 1qM0 WM0 1qM0 11A0 1o00|20e5","Africa/Windhoek|+0130 SAST SAST CAT WAT|-1u -20 -30 -20 -10|01213434343434343434343434343434343434343434343434343|-2GJdu 1Ajdu 1cL0 1SqL0 9Io0 16P0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0|32e4","America/Adak|NST NWT NPT BST BDT AHST HST HDT|b0 a0 a0 b0 a0 a0 a0 90|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326","America/Anchorage|AST AWT APT AHST AHDT YST AKST AKDT|a0 90 90 a0 90 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T00 8wX0 iA0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cm0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4","America/Port_of_Spain|LMT AST|46.4 40|01|-2kNvR.U|43e3","America/Araguaina|LMT -03 -02|3c.M 30 20|0121212121212121212121212121212121212121212121212121|-2glwL.c HdKL.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 ny10 Lz0|14e4","America/Argentina/Buenos_Aires|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Catamarca|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Cordoba|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323132323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0 1qN0 WL0|","America/Argentina/Jujuy|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1ze0 TX0 1ld0 WK0 1wp0 TX0 A4p0 uL0|","America/Argentina/La_Rioja|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Mendoza|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232312121321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1u20 SL0 1vd0 Tb0 1wp0 TW0 ri10 Op0 7TX0 uL0|","America/Argentina/Rio_Gallegos|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rlB0 7B0 8zb0 uL0|","America/Argentina/Salta|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231323232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 A4p0 uL0|","America/Argentina/San_Juan|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323231232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Qn0 qO0 16n0 Rb0 1wp0 TX0 rld0 m10 8lb0 uL0|","America/Argentina/San_Luis|CMT -04 -03 -02|4g.M 40 30 20|012121212121212121212121212121212121212121232323121212321212|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 XX0 1q20 SL0 AN0 vDb0 m10 8lb0 8L0 jd0 1qN0 WL0 1qN0|","America/Argentina/Tucuman|CMT -04 -03 -02|4g.M 40 30 20|0121212121212121212121212121212121212121212323232313232123232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wq0 Ra0 1wp0 TX0 rlB0 4N0 8BX0 uL0 1qN0 WL0|","America/Argentina/Ushuaia|CMT -04 -03 -02|4g.M 40 30 20|01212121212121212121212121212121212121212123232323232321232|-20UHH.c pKnH.c Mn0 1iN0 Tb0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 1C10 LX0 1C10 LX0 1C10 LX0 1C10 Mn0 MN0 2jz0 MN0 4lX0 u10 5Lb0 1pB0 Fnz0 u10 uL0 1vd0 SL0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 zvd0 Bz0 1tB0 TX0 1wp0 Rb0 1wp0 Rb0 1wp0 TX0 rkN0 8p0 8zb0 uL0|","America/Curacao|LMT -0430 AST|4z.L 4u 40|012|-2kV7o.d 28KLS.d|15e4","America/Asuncion|AMT -04 -03|3O.E 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-1x589.k 1DKM9.k 3CL0 3Dd0 10L0 1pB0 10n0 1pB0 10n0 1pB0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1dd0 1cL0 1dd0 1cL0 1dd0 1db0 1dd0 1cL0 1lB0 14n0 1dd0 1cL0 1fd0 WL0 1rd0 1aL0 1dB0 Xz0 1qp0 Xb0 1qN0 10L0 1rB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 WN0 1qL0 11B0 1nX0 1ip0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 TX0 1tB0 19X0 1a10 1fz0 1a10 1fz0 1cN0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0 17b0 1ip0 17b0 1ip0|28e5","America/Atikokan|CST CDT CWT CPT EST|60 50 50 50 50|0101234|-25TQ0 1in0 Rnb0 3je0 8x30 iw0|28e2","America/Bahia_Banderas|LMT MST CST PST MDT CDT|71 70 60 80 60 50|0121212131414141414141414141414141414152525252525252525252525252525252525252525252525252525252|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nW0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|84e3","America/Bahia|LMT -03 -02|2y.4 30 20|01212121212121212121212121212121212121212121212121212121212121|-2glxp.U HdLp.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 l5B0 Rb0|27e5","America/Barbados|LMT BMT AST ADT|3W.t 3W.t 40 30|01232323232|-1Q0I1.v jsM0 1ODC1.v IL0 1ip0 17b0 1ip0 17b0 1ld0 13b0|28e4","America/Belem|LMT -03 -02|3d.U 30 20|012121212121212121212121212121|-2glwK.4 HdKK.4 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|20e5","America/Belize|LMT CST -0530 CWT CPT CDT|5Q.M 60 5u 50 50 50|012121212121212121212121212121212121212121212121213412121212121212121212121212121212121212121215151|-2kBu7.c fPA7.c Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu Rcu 7Bt0 Ni0 4nd0 Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1wou Rbu 1wou Rbu 1zcu Onu e9Au qn0 lxB0 mn0|57e3","America/Blanc-Sablon|AST ADT AWT APT|40 30 30 30|010230|-25TS0 1in0 UGp0 8x50 iu0|11e2","America/Boa_Vista|LMT -04 -03|42.E 40 30|0121212121212121212121212121212121|-2glvV.k HdKV.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 smp0 WL0 1tB0 2L0|62e2","America/Bogota|BMT -05 -04|4U.g 50 40|0121|-2eb73.I 38yo3.I 2en0|90e5","America/Boise|PST PDT MST MWT MPT MDT|80 70 70 60 60 60|0101023425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-261q0 1nX0 11B0 1nX0 8C10 JCL0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 Dd0 1Kn0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e4","America/Cambridge_Bay|-00 MST MWT MPT MDDT MDT CST CDT EST|0 70 60 60 50 60 60 50 50|0123141515151515151515151515151515151515151515678651515151515151515151515151515151515151515151515151515151515151515151515151|-21Jc0 RO90 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11A0 1nX0 2K0 WQ0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e2","America/Campo_Grande|LMT -04 -03|3C.s 40 30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwl.w HdLl.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|77e4","America/Cancun|LMT CST EST EDT CDT|5L.4 60 50 40 50|0123232341414141414141414141414141414141412|-1UQG0 2q2o0 yLB0 1lb0 14p0 1lb0 14p0 Lz0 xB0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 Dd0|63e4","America/Caracas|CMT -0430 -04|4r.E 4u 40|01212|-2kV7w.k 28KM2.k 1IwOu kqo0|29e5","America/Cayenne|LMT -04 -03|3t.k 40 30|012|-2mrwu.E 2gWou.E|58e3","America/Panama|CMT EST|5j.A 50|01|-2uduE.o|15e5","America/Chicago|CST CDT EST CWT CPT|60 50 50 50 50|01010101010101010101010101010101010102010101010103401010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 1wp0 TX0 WN0 1qL0 1cN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 11B0 1Hz0 14p0 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5","America/Chihuahua|LMT MST CST CDT MDT|74.k 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|81e4","America/Costa_Rica|SJMT CST CDT|5A.d 60 50|0121212121|-1Xd6n.L 2lu0n.L Db0 1Kp0 Db0 pRB0 15b0 1kp0 mL0|12e5","America/Creston|MST PST|70 80|010|-29DR0 43B0|53e2","America/Cuiaba|LMT -04 -03|3I.k 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwf.E HdLf.E 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 4a10 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|54e4","America/Danmarkshavn|LMT -03 -02 GMT|1e.E 30 20 0|01212121212121212121212121212121213|-2a5WJ.k 2z5fJ.k 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 DC0|8","America/Dawson_Creek|PST PDT PWT PPT MST|80 70 70 70 70|0102301010101010101010101010101010101010101010101010101014|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 ML0|12e3","America/Dawson|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 jrA0 fNd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|13e2","America/Denver|MST MDT MWT MPT|70 60 60 60|01010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 11B0 1qL0 WN0 mn0 Ord0 8x20 ix0 LCN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5","America/Detroit|LMT CST EST EWT EPT EDT|5w.b 60 50 40 40 40|0123425252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2Cgir.N peqr.N 156L0 8x40 iv0 6fd0 11z0 JxX1 SMX 1cN0 1cL0 aW10 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e5","America/Edmonton|LMT MST MDT MWT MPT|7x.Q 70 60 60 60|0121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2yd4q.8 shdq.8 1in0 17d0 hz0 2dB0 1fz0 1a10 11z0 1qN0 WL0 1qN0 11z0 IGN0 8x20 ix0 3NB0 11z0 XQp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|10e5","America/Eirunepe|LMT -05 -04|4D.s 50 40|0121212121212121212121212121212121|-2glvk.w HdLk.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0 yTd0 d5X0|31e3","America/El_Salvador|LMT CST CDT|5U.M 60 50|012121|-1XiG3.c 2Fvc3.c WL0 1qN0 WL0|11e5","America/Tijuana|LMT MST PST PDT PWT PPT|7M.4 70 80 70 70 70|012123245232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQE0 4PX0 8mM0 8lc0 SN0 1cL0 pHB0 83r0 zI0 5O10 1Rz0 cOO0 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 BUp0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|20e5","America/Fort_Nelson|PST PDT PWT PPT MST|80 70 70 70 70|01023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010104|-25TO0 1in0 UGp0 8x10 iy0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0|39e2","America/Fort_Wayne|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010101023010101010101010101040454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 QI10 Db0 RB0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 5Tz0 1o10 qLb0 1cL0 1cN0 1cL0 1qhd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Fortaleza|LMT -03 -02|2y 30 20|0121212121212121212121212121212121212121|-2glxq HdLq 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 5z0 2mN0 On0|34e5","America/Glace_Bay|LMT AST ADT AWT APT|3X.M 40 30 30 30|012134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsI0.c CwO0.c 1in0 UGp0 8x50 iu0 iq10 11z0 Jg10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","America/Godthab|LMT -03 -02|3q.U 30 20|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5Ux.4 2z5dx.4 19U0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e3","America/Goose_Bay|NST NDT NST NDT NWT NPT AST ADT ADDT|3u.Q 2u.Q 3u 2u 2u 2u 40 30 20|010232323232323245232323232323232323232323232323232323232326767676767676767676767676767676767676767676768676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-25TSt.8 1in0 DXb0 2HbX.8 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 S10 g0u 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|76e2","America/Grand_Turk|KMT EST EDT AST|57.a 50 40 40|0121212121212121212121212121212121212121212121212121212121212121212121212132121212121212121212121212121212121212121|-2l1uQ.O 2HHBQ.O 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 7jA0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|37e2","America/Guatemala|LMT CST CDT|62.4 60 50|0121212121|-24KhV.U 2efXV.U An0 mtd0 Nz0 ifB0 17b0 zDB0 11z0|13e5","America/Guayaquil|QMT -05 -04|5e 50 40|0121|-1yVSK 2uILK rz0|27e5","America/Guyana|LMT -0345 -03 -04|3Q.E 3J 30 40|0123|-2dvU7.k 2r6LQ.k Bxbf|80e4","America/Halifax|LMT AST ADT AWT APT|4e.o 40 30 30 30|0121212121212121212121212121212121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsHJ.A xzzJ.A 1db0 3I30 1in0 3HX0 IL0 1E10 ML0 1yN0 Pb0 1Bd0 Mn0 1Bd0 Rz0 1w10 Xb0 1w10 LX0 1w10 Xb0 1w10 Lz0 1C10 Jz0 1E10 OL0 1yN0 Un0 1qp0 Xb0 1qp0 11X0 1w10 Lz0 1HB0 LX0 1C10 FX0 1w10 Xb0 1qp0 Xb0 1BB0 LX0 1td0 Xb0 1qp0 Xb0 Rf0 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 3Qp0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 6i10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4","America/Havana|HMT CST CDT|5t.A 50 40|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Meuu.o 72zu.o ML0 sld0 An0 1Nd0 Db0 1Nd0 An0 6Ep0 An0 1Nd0 An0 JDd0 Mn0 1Ap0 On0 1fd0 11X0 1qN0 WL0 1wp0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 14n0 1ld0 14L0 1kN0 15b0 1kp0 1cL0 1cN0 1fz0 1a10 1fz0 1fB0 11z0 14p0 1nX0 11B0 1nX0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 1a10 1in0 1a10 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 17c0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 11A0 6i00 Rc0 1wo0 U00 1tA0 Rc0 1wo0 U00 1wo0 U00 1zc0 U00 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5","America/Hermosillo|LMT MST CST PST MDT|7n.Q 70 60 80 60|0121212131414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0|64e4","America/Indiana/Knox|CST CDT CWT CPT EST|60 50 50 50 50|0101023010101010101010101010101010101040101010101010101010101010101010101010101010101010141010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 3NB0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 3Cn0 8wp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 z8o0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Marengo|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010104545454545414545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 dyN0 11z0 6fd0 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1e6p0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Petersburg|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010104010101010101010101010141014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 3Fb0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 19co0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Tell_City|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010401054541010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 njX0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 8wn0 1cN0 1cL0 1cN0 1cK0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vevay|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|010102304545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 kPB0 Awn0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1lnd0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Vincennes|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010454541014545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 g0p0 11z0 1o10 11z0 1qL0 WN0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 caL0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Indiana/Winamac|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|01010230101010101010101010101010101010454541054545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 jrz0 1cL0 1cN0 1cL0 1qhd0 1o00 Rd0 1za0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Inuvik|-00 PST PDDT MST MDT|0 80 60 70 60|0121343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-FnA0 tWU0 1fA0 wPe0 2pz0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|35e2","America/Iqaluit|-00 EWT EPT EST EDDT EDT CST CDT|0 40 40 50 30 40 60 50|01234353535353535353535353535353535353535353567353535353535353535353535353535353535353535353535353535353535353535353535353|-16K00 7nX0 iv0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|67e2","America/Jamaica|KMT EST EDT|57.a 50 40|0121212121212121212121|-2l1uQ.O 2uM1Q.O 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0|94e4","America/Juneau|PST PWT PPT PDT YDT YST AKST AKDT|80 70 70 70 80 90 90 80|01203030303030303030303030403030356767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cM0 1cM0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|33e3","America/Kentucky/Louisville|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101010102301010101010101010101010101454545454545414545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 3Fd0 Nb0 LPd0 11z0 RB0 8x30 iw0 1nX1 e0X 9vd0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 xz0 gso0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1VA0 LA0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Kentucky/Monticello|CST CDT CWT CPT EST EDT|60 50 50 50 50 40|0101023010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454545454|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 SWp0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/La_Paz|CMT BST -04|4w.A 3w.A 40|012|-1x37r.o 13b0|19e5","America/Lima|LMT -05 -04|58.A 50 40|0121212121212121|-2tyGP.o 1bDzP.o zX0 1aN0 1cL0 1cN0 1cL0 1PrB0 zX0 1O10 zX0 6Gp0 zX0 98p0 zX0|11e6","America/Los_Angeles|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 5Wp1 1VaX 3dA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6","America/Maceio|LMT -03 -02|2m.Q 30 20|012121212121212121212121212121212121212121|-2glxB.8 HdLB.8 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 dMN0 Lz0 8Q10 WL0 1tB0 5z0 2mN0 On0|93e4","America/Managua|MMT CST EST CDT|5J.c 60 50 50|0121313121213131|-1quie.M 1yAMe.M 4mn0 9Up0 Dz0 1K10 Dz0 s3F0 1KH0 DB0 9In0 k8p0 19X0 1o30 11y0|22e5","America/Manaus|LMT -04 -03|40.4 40 30|01212121212121212121212121212121|-2glvX.U HdKX.U 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 dPB0 On0|19e5","America/Martinique|FFMT AST ADT|44.k 40 30|0121|-2mPTT.E 2LPbT.E 19X0|39e4","America/Matamoros|LMT CST CDT|6E 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|45e4","America/Mazatlan|LMT MST CST PST MDT|75.E 70 60 80 60|0121212131414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 otX0 gmN0 P2N0 13Vd0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|44e4","America/Menominee|CST CDT CWT CPT EST|60 50 50 50 50|01010230101041010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 1o10 11z0 LCN0 1fz0 6410 9Jb0 1cM0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|85e2","America/Merida|LMT CST EST CDT|5W.s 60 50 50|0121313131313131313131313131313131313131313131313131313131313131313131313131313131313131|-1UQG0 2q2o0 2hz0 wu30 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|11e5","America/Metlakatla|PST PWT PPT PDT AKST AKDT|80 70 70 70 90 80|01203030303030303030303030303030304545450454545454545454545454545454545454545454|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1hU10 Rd0 1zb0 Op0 1zb0 Op0 1zb0 uM0 jB0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Mexico_City|LMT MST CST CDT CWT|6A.A 70 60 50 50|012121232324232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 gEn0 TX0 3xd0 Jb0 6zB0 SL0 e5d0 17b0 1Pff0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|20e6","America/Miquelon|LMT AST -03 -02|3I.E 40 30 20|012323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2mKkf.k 2LTAf.k gQ10 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2","America/Moncton|EST AST ADT AWT APT|50 40 30 30 30|012121212121212121212134121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2IsH0 CwN0 1in0 zAo0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1Nd0 An0 1K10 Lz0 1zB0 NX0 1u10 Wn0 S20 8x50 iu0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14n1 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 ReX 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|64e3","America/Monterrey|LMT CST CDT|6F.g 60 50|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1UQG0 2FjC0 1nX0 i6p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0|41e5","America/Montevideo|LMT MMT -04 -03 -0330 -0230 -02 -0130|3I.P 3I.P 40 30 3u 2u 20 1u|012343434343434343434343435353636353636375363636363636363636363636363636363636363636363|-2tRUf.9 sVc0 8jcf.9 1db0 1dcu 1cLu 1dcu 1cLu ircu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu WLu 1fAu 1cLu 1o0u 11zu NAu 3jXu zXu Dq0u 19Xu pcu jz0 cm10 19X0 6tB0 1fbu 3o0u jX0 4vB0 xz0 3Cp0 mmu 1a10 IMu Db0 4c10 uL0 1Nd0 An0 1SN0 uL0 mp0 28L0 iPB0 un0 1SN0 xz0 1zd0 Lz0 1zd0 Rb0 1zd0 On0 1wp0 Rb0 s8p0 1fB0 1ip0 11z0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 14n0 1ld0 14n0 1ld0 14n0 1o10 11z0 1o10 11z0 1o10 11z0|17e5","America/Toronto|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101012301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 11Wu 1nzu 1fD0 WJ0 1wr0 Nb0 1Ap0 On0 1zd0 On0 1wp0 TX0 1tB0 TX0 1tB0 TX0 1tB0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 4kM0 8x40 iv0 1o10 11z0 1nX0 11z0 1o10 11z0 1o10 1qL0 11D0 1nX0 11B0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e5","America/Nassau|LMT EST EWT EPT EDT|59.u 50 40 40 40|01212314141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2kNuO.u 1drbO.u 6tX0 cp0 1hS0 pF0 J630 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|24e4","America/New_York|EST EDT EWT EPT|50 40 40 40|01010101010101010101010101010101010101010101010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 11B0 1qL0 1a10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 RB0 8x40 iv0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6","America/Nipigon|EST EDT EWT EPT|50 40 40 40|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TR0 1in0 Rnb0 3je0 8x40 iv0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|16e2","America/Nome|NST NWT NPT BST BDT YST AKST AKDT|b0 a0 a0 b0 a0 90 90 80|012034343434343434343434343434343456767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676767676|-17SX0 8wW0 iB0 Qlb0 52O0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cl0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|38e2","America/Noronha|LMT -02 -01|29.E 20 10|0121212121212121212121212121212121212121|-2glxO.k HdKO.k 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|30e2","America/North_Dakota/Beulah|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Oo0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/Center|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101014545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/North_Dakota/New_Salem|MST MDT MWT MPT CST CDT|70 60 60 60 60 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101454545454545454545454545454545454545454545454545454545454545454545454|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14o0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","America/Ojinaga|LMT MST CST CDT MDT|6V.E 70 60 50 60|0121212323241414141414141414141414141414141414141414141414141414141414141414141414141414141|-1UQF0 deL0 8lc0 17c0 10M0 1dd0 2zQN0 1lb0 14p0 1lb0 14q0 1lb0 14p0 1nX0 11B0 1nX0 1fB0 WL0 1fB0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 U10 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3","America/Pangnirtung|-00 AST AWT APT ADDT ADT EDT EST CST CDT|0 40 30 30 20 30 40 50 60 50|012314151515151515151515151515151515167676767689767676767676767676767676767676767676767676767676767676767676767676767676767|-1XiM0 PnG0 8x50 iu0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1o00 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11C0 1nX0 11A0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|14e2","America/Paramaribo|LMT PMT PMT -0330 -03|3E.E 3E.Q 3E.A 3u 30|01234|-2nDUj.k Wqo0.c qanX.I 1yVXN.o|24e4","America/Phoenix|MST MDT MWT|70 60 60|01010202010|-261r0 1nX0 11B0 1nX0 SgN0 4Al1 Ap0 1db0 SWqX 1cL0|42e5","America/Port-au-Prince|PPMT EST EDT|4N 50 40|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-28RHb 2FnMb 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14q0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 i6n0 1nX0 11B0 1nX0 d430 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 3iN0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Rio_Branco|LMT -05 -04|4v.c 50 40|01212121212121212121212121212121|-2glvs.M HdLs.M 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0 d5X0|31e4","America/Porto_Velho|LMT -04 -03|4f.A 40 30|012121212121212121212121212121|-2glvI.o HdKI.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0|37e4","America/Puerto_Rico|AST AWT APT|40 30 30|0120|-17lU0 7XT0 iu0|24e5","America/Punta_Arenas|SMT -05 -04 -03|4G.K 50 40 30|0102021212121212121232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 blz0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|","America/Rainy_River|CST CDT CWT CPT|60 50 50 50|010123010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TQ0 1in0 Rnb0 3je0 8x30 iw0 19yN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|842","America/Rankin_Inlet|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313131313131313131313131313131313131313131313131313131313131313131|-vDc0 keu0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e2","America/Recife|LMT -03 -02|2j.A 30 20|0121212121212121212121212121212121212121|-2glxE.o HdLE.o 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 nsp0 WL0 1tB0 2L0 2pB0 On0|33e5","America/Regina|LMT MST MDT MWT MPT CST|6W.A 70 60 60 60 60|012121212121212121212121341212121212121212121212121215|-2AD51.o uHe1.o 1in0 s2L0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 66N0 1cL0 1cN0 19X0 1fB0 1cL0 1fB0 1cL0 1cN0 1cL0 M30 8x20 ix0 1ip0 1cL0 1ip0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 3NB0 1cL0 1cN0|19e4","America/Resolute|-00 CST CDDT CDT EST|0 60 40 50 50|012131313131313131313131313131313131313131313431313131313431313131313131313131313131313131313131313131313131313131313131|-SnA0 GWS0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|229","America/Santarem|LMT -04 -03|3C.M 40 30|0121212121212121212121212121212|-2glwl.c HdLl.c 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 qe10 xb0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 NBd0|21e4","America/Santiago|SMT -05 -04 -03|4G.K 50 40 30|010202121212121212321232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-2q2jh.e fJAh.e 5knG.K 1Vzh.e jRAG.K 1pbh.e 11d0 1oL0 11d0 1oL0 11d0 1oL0 11d0 1pb0 11d0 nHX0 op0 9Bz0 jb0 1oN0 ko0 Qeo0 WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|62e5","America/Santo_Domingo|SDMT EST EDT -0430 AST|4E 50 40 4u 40|01213131313131414|-1ttjk 1lJMk Mn0 6sp0 Lbu 1Cou yLu 1RAu wLu 1QMu xzu 1Q0u xXu 1PAu 13jB0 e00|29e5","America/Sao_Paulo|LMT -03 -02|36.s 30 20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glwR.w HdKR.w 1cc0 1e10 1bX0 Ezd0 So0 1vA0 Mn0 1BB0 ML0 1BB0 zX0 pTd0 PX0 2ep0 nz0 1C10 zX0 1C10 LX0 1C10 Mn0 H210 Rb0 1tB0 IL0 1Fd0 FX0 1EN0 FX0 1HB0 Lz0 1EN0 Lz0 1C10 IL0 1HB0 Db0 1HB0 On0 1zd0 On0 1zd0 Lz0 1zd0 Rb0 1wN0 Wn0 1tB0 Rb0 1tB0 WL0 1tB0 Rb0 1zd0 On0 1HB0 FX0 1C10 Lz0 1Ip0 HX0 1zd0 On0 1HB0 IL0 1wp0 On0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 Rb0 1zd0 Lz0 1C10 Lz0 1C10 On0 1zd0 On0 1zd0 On0 1zd0 On0 1HB0 FX0|20e6","America/Scoresbysund|LMT -02 -01 +00|1r.Q 20 10 0|0121323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2a5Ww.8 2z5ew.8 1a00 1cK0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|452","America/Sitka|PST PWT PPT PDT YST AKST AKDT|80 70 70 70 90 90 80|01203030303030303030303030303030345656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565656565|-17T20 8x10 iy0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 co0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|90e2","America/St_Johns|NST NDT NST NDT NWT NPT NDDT|3u.Q 2u.Q 3u 2u 2u 2u 1u|01010101010101010101010101010101010102323232323232324523232323232323232323232323232323232323232323232323232323232323232323232323232323232326232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28oit.8 14L0 1nB0 1in0 1gm0 Dz0 1JB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1fB0 1cL0 1fB0 19X0 1fB0 19X0 10O0 eKX.8 19X0 1iq0 WL0 1qN0 WL0 1qN0 WL0 1tB0 TX0 1tB0 WL0 1qN0 WL0 1qN0 7UHu itu 1tB0 WL0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1tB0 WL0 1ld0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14n1 1lb0 14p0 1nW0 11C0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zcX Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Swift_Current|LMT MST MDT MWT MPT CST|7b.k 70 60 60 60 60|012134121212121212121215|-2AD4M.E uHdM.E 1in0 UGp0 8x20 ix0 1o10 17b0 1ip0 11z0 1o10 11z0 1o10 11z0 isN0 1cL0 3Cp0 1cL0 1cN0 11z0 1qN0 WL0 pMp0|16e3","America/Tegucigalpa|LMT CST CDT|5M.Q 60 50|01212121|-1WGGb.8 2ETcb.8 WL0 1qN0 WL0 GRd0 AL0|11e5","America/Thule|LMT AST ADT|4z.8 40 30|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a5To.Q 31NBo.Q 1cL0 1cN0 1cL0 1fB0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|656","America/Thunder_Bay|CST EST EWT EPT EDT|60 50 40 40 40|0123141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141414141|-2q5S0 1iaN0 8x40 iv0 XNB0 1cL0 1cN0 1fz0 1cN0 1cL0 3Cp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4","America/Vancouver|PST PDT PWT PPT|80 70 70 70|0102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-25TO0 1in0 UGp0 8x10 iy0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e5","America/Whitehorse|YST YDT YWT YPT YDDT PST PDT MST|90 80 80 80 70 80 70 70|010102304056565656565656565656565656565656565656565656565656565656565656565656565656565656567|-25TN0 1in0 1o10 13V0 Ser0 8x00 iz0 LCL0 1fA0 3NA0 vrd0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1z90|23e3","America/Winnipeg|CST CDT CWT CPT|60 50 50 50|010101023010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aIi0 WL0 3ND0 1in0 Jap0 Rb0 aCN0 8x30 iw0 1tB0 11z0 1ip0 11z0 1o10 11z0 1o10 11z0 1rd0 10L0 1op0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 1cL0 1cN0 11z0 6i10 WL0 6i10 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1a00 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1o00 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1o00 11A0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|66e4","America/Yakutat|YST YWT YPT YDT AKST AKDT|90 80 80 80 90 80|01203030303030303030303030303030304545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-17T10 8x00 iz0 Vo10 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 cn0 10q0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|642","America/Yellowknife|-00 MST MWT MPT MDDT MDT|0 70 60 60 50 60|012314151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151515151|-1pdA0 hix0 8x20 ix0 LCL0 1fA0 zgO0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|19e3","Antarctica/Casey|-00 +08 +11|0 -80 -b0|0121212121212|-2q00 1DjS0 T90 40P0 KL0 blz0 3m10 1o30 14k0 1kr0 12l0 1o01|10","Antarctica/Davis|-00 +07 +05|0 -70 -50|01012121|-vyo0 iXt0 alj0 1D7v0 VB0 3Wn0 KN0|70","Antarctica/DumontDUrville|-00 +10|0 -a0|0101|-U0o0 cfq0 bFm0|80","Antarctica/Macquarie|AEST AEDT -00|-a0 -b0 0|010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 4SK0 1ayy0 Lvs0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 3Co0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|1","Antarctica/Mawson|-00 +06 +05|0 -60 -50|012|-CEo0 2fyk0|60","Pacific/Auckland|NZMT NZST NZST NZDT|-bu -cu -c0 -d0|01020202020202020202020202023232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1GCVu Lz0 1tB0 11zu 1o0u 11zu 1o0u 11zu 1o0u 14nu 1lcu 14nu 1lcu 1lbu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1nXu 11Au 1qLu WMu 1qLu 11Au 1n1bu IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|14e5","Antarctica/Palmer|-00 -03 -04 -02|0 30 40 20|0121212121213121212121212121212121212121212121212121212121212121212121212121212121|-cao0 nD0 1vd0 SL0 1vd0 17z0 1cN0 1fz0 1cN0 1cL0 1cN0 asn0 Db0 jsN0 14N0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0|40","Antarctica/Rothera|-00 -03|0 30|01|gOo0|130","Antarctica/Syowa|-00 +03|0 -30|01|-vs00|20","Antarctica/Troll|-00 +00 +02|0 0 -20|01212121212121212121212121212121212121212121212121212121212121212121|1puo0 hd0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|40","Antarctica/Vostok|-00 +06|0 -60|01|-tjA0|25","Europe/Oslo|CET CEST|-10 -20|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2awM0 Qm0 W6o0 5pf0 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 wJc0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1qM0 WM0 zpc0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e4","Asia/Riyadh|LMT +03|-36.Q -30|01|-TvD6.Q|57e5","Asia/Almaty|LMT +05 +06 +07|-57.M -50 -60 -70|012323232323232323232321232323232323232323232323232|-1Pc57.M eUo7.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|15e5","Asia/Amman|LMT EET EEST|-2n.I -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1yW2n.I 1HiMn.I KL0 1oN0 11b0 1oN0 11b0 1pd0 1dz0 1cp0 11b0 1op0 11b0 fO10 1db0 1e10 1cL0 1cN0 1cL0 1cN0 1fz0 1pd0 10n0 1ld0 14n0 1hB0 15b0 1ip0 19X0 1cN0 1cL0 1cN0 17b0 1ld0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1So0 y00 1fc0 1dc0 1co0 1dc0 1cM0 1cM0 1cM0 1o00 11A0 1lc0 17c0 1cM0 1cM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 4bX0 Dd0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|25e5","Asia/Anadyr|LMT +12 +13 +14 +11|-bN.U -c0 -d0 -e0 -b0|01232121212121212121214121212121212121212121212121212121212141|-1PcbN.U eUnN.U 23CL0 1db0 2q10 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|13e3","Asia/Aqtau|LMT +04 +05 +06|-3l.4 -40 -50 -60|012323232323232323232123232312121212121212121212|-1Pc3l.4 eUnl.4 24PX0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|15e4","Asia/Aqtobe|LMT +04 +05 +06|-3M.E -40 -50 -60|0123232323232323232321232323232323232323232323232|-1Pc3M.E eUnM.E 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0|27e4","Asia/Ashgabat|LMT +04 +05 +06|-3R.w -40 -50 -60|0123232323232323232323212|-1Pc3R.w eUnR.w 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0|41e4","Asia/Atyrau|LMT +03 +05 +06 +04|-3r.I -30 -50 -60 -40|01232323232323232323242323232323232324242424242|-1Pc3r.I eUor.I 24PW0 2pX0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 2sp0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Baghdad|BMT +03 +04|-2V.A -30 -40|012121212121212121212121212121212121212121212121212121|-26BeV.A 2ACnV.A 11b0 1cp0 1dz0 1dd0 1db0 1cN0 1cp0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1de0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0 1dc0 1dc0 1cM0 1dc0 1cM0 1dc0 1cM0 1dc0|66e5","Asia/Qatar|LMT +04 +03|-3q.8 -40 -30|012|-21Jfq.8 27BXq.8|96e4","Asia/Baku|LMT +03 +04 +05|-3j.o -30 -40 -50|01232323232323232323232123232323232323232323232323232323232323232|-1Pc3j.o 1jUoj.o WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 9Je0 1o00 11z0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00|27e5","Asia/Bangkok|BMT +07|-6G.4 -70|01|-218SG.4|15e6","Asia/Barnaul|LMT +06 +07 +08|-5z -60 -70 -80|0123232323232323232323212323232321212121212121212121212121212121212|-21S5z pCnz 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 p90 LE0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|","Asia/Beirut|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-21aq0 1on0 1410 1db0 19B0 1in0 1ip0 WL0 1lQp0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 q6N0 En0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1op0 11b0 dA10 17b0 1iN0 17b0 1iN0 17b0 1iN0 17b0 1vB0 SL0 1mp0 13z0 1iN0 17b0 1iN0 17b0 1jd0 12n0 1a10 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0|22e5","Asia/Bishkek|LMT +05 +06 +07|-4W.o -50 -60 -70|012323232323232323232321212121212121212121212121212|-1Pc4W.o eUnW.o 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2e00 1tX0 17b0 1ip0 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1cPu 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0|87e4","Asia/Brunei|LMT +0730 +08|-7D.E -7u -80|012|-1KITD.E gDc9.E|42e4","Asia/Kolkata|MMT IST +0630|-5l.a -5u -6u|012121|-2zOtl.a 1r2LP.a 1un0 HB0 7zX0|15e6","Asia/Chita|LMT +08 +09 +10|-7x.Q -80 -90 -a0|012323232323232323232321232323232323232323232323232323232323232312|-21Q7x.Q pAnx.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3re0|33e4","Asia/Choibalsan|LMT +07 +08 +10 +09|-7C -70 -80 -a0 -90|0123434343434343434343434343434343434343434343424242|-2APHC 2UkoC cKn0 1da0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 3Db0 h1f0 1cJ0 1cP0 1cJ0|38e3","Asia/Shanghai|CST CDT|-80 -90|01010101010101010101010101010|-23uw0 18n0 OjB0 Rz0 11d0 1wL0 A10 8HX0 1G10 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 aL0 1tU30 Rb0 1o10 11z0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0|23e6","Asia/Colombo|MMT +0530 +06 +0630|-5j.w -5u -60 -6u|01231321|-2zOtj.w 1rFbN.w 1zzu 7Apu 23dz0 11zu n3cu|22e5","Asia/Dhaka|HMT +0630 +0530 +06 +07|-5R.k -6u -5u -60 -70|0121343|-18LFR.k 1unn.k HB0 m6n0 2kxbu 1i00|16e6","Asia/Damascus|LMT EET EEST|-2p.c -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-21Jep.c Hep.c 17b0 1ip0 17b0 1ip0 17b0 1ip0 19X0 1xRB0 11X0 1oN0 10L0 1pB0 11b0 1oN0 10L0 1mp0 13X0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 1pd0 11b0 1oN0 Nb0 1AN0 Nb0 bcp0 19X0 1gp0 19X0 3ld0 1xX0 Vd0 1Bz0 Sp0 1vX0 10p0 1dz0 1cN0 1cL0 1db0 1db0 1g10 1an0 1ap0 1db0 1fd0 1db0 1cN0 1db0 1dd0 1db0 1cp0 1dz0 1c10 1dX0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1db0 1cN0 1db0 1cN0 19z0 1fB0 1qL0 11B0 1on0 Wp0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0|26e5","Asia/Dili|LMT +08 +09|-8m.k -80 -90|01212|-2le8m.k 1dnXm.k 1nfA0 Xld0|19e4","Asia/Dubai|LMT +04|-3F.c -40|01|-21JfF.c|39e5","Asia/Dushanbe|LMT +05 +06 +07|-4z.c -50 -60 -70|012323232323232323232321|-1Pc4z.c eUnz.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2hB0|76e4","Asia/Famagusta|LMT EET EEST +03|-2f.M -20 -30 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212312121212121212121212121212121212121212121|-1Vc2f.M 2a3cf.M 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 15U0 2Ks0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Asia/Gaza|EET EEST IST IDT|-20 -30 -20 -30|010101010101010101010101010101010123232323232323232323232323232320101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 11z0 1o10 14o0 1lA1 SKX 1xd1 MKX 1AN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Asia/Hebron|EET EEST IST IDT|-20 -30 -20 -30|01010101010101010101010101010101012323232323232323232323232323232010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-1c2o0 MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 pBa0 Vz0 1oN0 11b0 1oO0 10N0 1pz0 10N0 1pb0 10N0 1pb0 10N0 1pb0 10N0 1pz0 10N0 1pb0 10N0 1pb0 11d0 1oL0 dW0 hfB0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 M10 C00 17c0 1io0 17c0 1io0 17c0 1o00 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 17c0 1io0 18N0 1bz0 19z0 1gp0 1610 1iL0 12L0 1mN0 14o0 1lc0 Tb0 1xd1 MKX bB0 cn0 1cN0 1a00 1fA0 1cL0 1cN0 1nX0 1210 1nA0 1210 1qL0 WN0 1qL0 WN0 1qL0 11c0 1on0 11B0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Asia/Ho_Chi_Minh|LMT PLMT +07 +08 +09|-76.E -76.u -70 -80 -90|0123423232|-2yC76.E bK00.a 1h7b6.u 5lz0 18o0 3Oq0 k5b0 aW00 BAM0|90e5","Asia/Hong_Kong|LMT HKT HKST HKWT JST|-7A.G -80 -90 -8u -90|0123412121212121212121212121212121212121212121212121212121212121212121|-2CFH0 1taO0 Hc0 xUu 9tBu 11z0 1tDu Rc0 1wo0 11A0 1cM0 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1nX0 U10 1tz0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|73e5","Asia/Hovd|LMT +06 +07 +08|-66.A -60 -70 -80|012323232323232323232323232323232323232323232323232|-2APG6.A 2Uko6.A cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|81e3","Asia/Irkutsk|IMT +07 +08 +09|-6V.5 -70 -80 -90|01232323232323232323232123232323232323232323232323232323232323232|-21zGV.5 pjXV.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Europe/Istanbul|IMT EET EEST +03 +04|-1U.U -20 -30 -30 -40|0121212121212121212121212121212121212121212121234312121212121212121212121212121212121212121212121212121212121212123|-2ogNU.U dzzU.U 11b0 8tB0 1on0 1410 1db0 19B0 1in0 3Rd0 Un0 1oN0 11b0 zSN0 CL0 mp0 1Vz0 1gN0 8yn0 1yp0 ML0 1kp0 17b0 1ip0 17b0 1fB0 19X0 1ip0 19X0 1ip0 17b0 qdB0 38L0 1jd0 Tz0 l6O0 11A0 WN0 1qL0 TB0 1tX0 U10 1tz0 11B0 1in0 17d0 z90 cne0 pb0 2Cp0 1800 14o0 1dc0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1a00 1fA0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WO0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 Xc0 1qo0 WM0 1qM0 11A0 1o00 1200 1nA0 11A0 1tA0 U00 15w0|13e6","Asia/Jakarta|BMT +0720 +0730 +09 +08 WIB|-77.c -7k -7u -90 -80 -70|01232425|-1Q0Tk luM0 mPzO 8vWu 6kpu 4PXu xhcu|31e6","Asia/Jayapura|LMT +09 +0930 WIT|-9m.M -90 -9u -90|0123|-1uu9m.M sMMm.M L4nu|26e4","Asia/Jerusalem|JMT IST IDT IDDT|-2k.E -20 -30 -40|01212121212121321212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-26Bek.E SyOk.E MM0 iM0 4JA0 10o0 1pA0 10M0 1pA0 16o0 1jA0 16o0 1jA0 3LA0 Eo0 oo0 1co0 1dA0 16o0 10M0 1jc0 1tA0 14o0 1cM0 1a00 11A0 1Nc0 Ao0 1Nc0 Ao0 1Ko0 LA0 1o00 WM0 EQK0 Db0 1fB0 Rb0 bXB0 gM0 8Q00 IM0 1wo0 TX0 1HB0 IL0 1s10 10n0 1o10 WL0 1zd0 On0 1ld0 11z0 1o10 14n0 1o10 14n0 1nd0 12n0 1nd0 Xz0 1q10 12n0 1hB0 1dX0 1ep0 1aL0 1eN0 17X0 1nf0 11z0 1tB0 19W0 1e10 17b0 1ep0 1gL0 18N0 1fz0 1eN0 17b0 1gq0 1gn0 19d0 1dz0 1c10 17X0 1hB0 1gn0 19d0 1dz0 1c10 17X0 1kp0 1dz0 1c10 1aL0 1eN0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0|81e4","Asia/Kabul|+04 +0430|-40 -4u|01|-10Qs0|46e5","Asia/Kamchatka|LMT +11 +12 +13|-ay.A -b0 -c0 -d0|012323232323232323232321232323232323232323232323232323232323212|-1SLKy.A ivXy.A 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|18e4","Asia/Karachi|LMT +0530 +0630 +05 PKT PKST|-4s.c -5u -6u -50 -50 -60|012134545454|-2xoss.c 1qOKW.c 7zX0 eup0 LqMu 1fy00 1cL0 dK10 11b0 1610 1jX0|24e6","Asia/Urumqi|LMT +06|-5O.k -60|01|-1GgtO.k|32e5","Asia/Kathmandu|LMT +0530 +0545|-5F.g -5u -5J|012|-21JhF.g 2EGMb.g|12e5","Asia/Khandyga|LMT +08 +09 +10 +11|-92.d -80 -90 -a0 -b0|0123232323232323232323212323232323232323232323232343434343434343432|-21Q92.d pAp2.d 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 qK0 yN0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|66e2","Asia/Krasnoyarsk|LMT +06 +07 +08|-6b.q -60 -70 -80|01232323232323232323232123232323232323232323232323232323232323232|-21Hib.q prAb.q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|10e5","Asia/Kuala_Lumpur|SMT +07 +0720 +0730 +09 +08|-6T.p -70 -7k -7u -90 -80|0123435|-2Bg6T.p 17anT.p l5XE 17bO 8Fyu 1so1u|71e5","Asia/Kuching|LMT +0730 +08 +0820 +09|-7l.k -7u -80 -8k -90|0123232323232323242|-1KITl.k gDbP.k 6ynu AnE 1O0k AnE 1NAk AnE 1NAk AnE 1NAk AnE 1O0k AnE 1NAk AnE pAk 8Fz0|13e4","Asia/Macau|LMT CST +09 +10 CDT|-7y.a -80 -90 -a0 -90|012323214141414141414141414141414141414141414141414141414141414141414141|-2CFHy.a 1uqKy.a PX0 1kn0 15B0 11b0 4Qq0 1oM0 11c0 1ko0 1u00 11A0 1cM0 11c0 1o00 11A0 1o00 11A0 1oo0 1400 1o00 11A0 1o00 U00 1tA0 U00 1wo0 Rc0 1wru U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 Rd0 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 17d0 1cK0 1cO0 1cK0 1cO0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 s10 1Vz0 1cN0 1cL0 1cN0 1cL0 6fd0 14n0|57e4","Asia/Magadan|LMT +10 +11 +12|-a3.c -a0 -b0 -c0|012323232323232323232321232323232323232323232323232323232323232312|-1Pca3.c eUo3.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Cq0|95e3","Asia/Makassar|LMT MMT +08 +09 WITA|-7V.A -7V.A -80 -90 -80|01234|-21JjV.A vfc0 myLV.A 8ML0|15e5","Asia/Manila|PST PDT JST|-80 -90 -90|010201010|-1kJI0 AL0 cK10 65X0 mXB0 vX0 VK10 1db0|24e6","Asia/Nicosia|LMT EET EEST|-2d.s -20 -30|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1Vc2d.s 2a3cd.s 1cL0 1qp0 Xz0 19B0 19X0 1fB0 1db0 1cp0 1cL0 1fB0 19X0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1o30 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|32e4","Asia/Novokuznetsk|LMT +06 +07 +08|-5M.M -60 -70 -80|012323232323232323232321232323232323232323232323232323232323212|-1PctM.M eULM.M 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|55e4","Asia/Novosibirsk|LMT +06 +07 +08|-5v.E -60 -70 -80|0123232323232323232323212323212121212121212121212121212121212121212|-21Qnv.E pAFv.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 ml0 Os0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 4eN0|15e5","Asia/Omsk|LMT +05 +06 +07|-4R.u -50 -60 -70|01232323232323232323232123232323232323232323232323232323232323232|-224sR.u pMLR.u 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|12e5","Asia/Oral|LMT +03 +05 +06 +04|-3p.o -30 -50 -60 -40|01232323232323232424242424242424242424242424242|-1Pc3p.o eUop.o 23CK0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 1cM0 IM0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|27e4","Asia/Pontianak|LMT PMT +0730 +09 +08 WITA WIB|-7h.k -7h.k -7u -90 -80 -80 -70|012324256|-2ua7h.k XE00 munL.k 8Rau 6kpu 4PXu xhcu Wqnu|23e4","Asia/Pyongyang|LMT KST JST KST|-8n -8u -90 -90|012313|-2um8n 97XR 1lTzu 2Onc0 6BA0|29e5","Asia/Qostanay|LMT +04 +05 +06|-4e.s -40 -50 -60|012323232323232323232123232323232323232323232323|-1Pc4e.s eUoe.s 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0|","Asia/Qyzylorda|LMT +04 +05 +06|-4l.Q -40 -50 -60|01232323232323232323232323232323232323232323232|-1Pc4l.Q eUol.Q 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 3ao0 1EM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 zQl0|73e4","Asia/Rangoon|RMT +0630 +09|-6o.L -6u -90|0121|-21Jio.L SmnS.L 7j9u|48e5","Asia/Sakhalin|LMT +09 +11 +12 +10|-9u.M -90 -b0 -c0 -a0|01232323232323232323232423232323232424242424242424242424242424242|-2AGVu.M 1BoMu.M 1qFa0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 2pB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|58e4","Asia/Samarkand|LMT +04 +05 +06|-4r.R -40 -50 -60|01232323232323232323232|-1Pc4r.R eUor.R 23CL0 3Db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|36e4","Asia/Seoul|LMT KST JST KST KDT KDT|-8r.Q -8u -90 -90 -a0 -9u|012343434343151515151515134343|-2um8r.Q 97XV.Q 1m1zu 6CM0 Fz0 1kN0 14n0 1kN0 14L0 1zd0 On0 69B0 2I0u OL0 1FB0 Rb0 1qN0 TX0 1tB0 TX0 1tB0 TX0 1tB0 TX0 2ap0 12FBu 11A0 1o00 11A0|23e6","Asia/Srednekolymsk|LMT +10 +11 +12|-ae.Q -a0 -b0 -c0|01232323232323232323232123232323232323232323232323232323232323232|-1Pcae.Q eUoe.Q 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|35e2","Asia/Taipei|CST JST CDT|-80 -90 -90|01020202020202020202020202020202020202020|-1iw80 joM0 1yo0 Tz0 1ip0 1jX0 1cN0 11b0 1oN0 11b0 1oN0 11b0 1oN0 11b0 10N0 1BX0 10p0 1pz0 10p0 1pz0 10p0 1db0 1dd0 1db0 1cN0 1db0 1cN0 1db0 1cN0 1db0 1BB0 ML0 1Bd0 ML0 uq10 1db0 1cN0 1db0 97B0 AL0|74e5","Asia/Tashkent|LMT +05 +06 +07|-4B.b -50 -60 -70|012323232323232323232321|-1Pc4B.b eUnB.b 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0|23e5","Asia/Tbilisi|TBMT +03 +04 +05|-2X.b -30 -40 -50|0123232323232323232323212121232323232323232323212|-1Pc2X.b 1jUnX.b WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cK0 1cL0 1cN0 1cL0 1cN0 2pz0 1cL0 1fB0 3Nz0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 An0 Os0 WM0|11e5","Asia/Tehran|LMT TMT +0330 +04 +05 +0430|-3p.I -3p.I -3u -40 -50 -4u|01234325252525252525252525252525252525252525252525252525252525252525252525252525252525252525252525252|-2btDp.I 1d3c0 1huLT.I TXu 1pz0 sN0 vAu 1cL0 1dB0 1en0 pNB0 UL0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 64p0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0 1cN0 1dz0 1cp0 1dz0 1cp0 1dz0 1cp0 1dz0|14e6","Asia/Thimphu|LMT +0530 +06|-5W.A -5u -60|012|-Su5W.A 1BGMs.A|79e3","Asia/Tokyo|JST JDT|-90 -a0|010101010|-QJJ0 Rc0 1lc0 14o0 1zc0 Oo0 1zc0 Oo0|38e6","Asia/Tomsk|LMT +06 +07 +08|-5D.P -60 -70 -80|0123232323232323232323212323232323232323232323212121212121212121212|-21NhD.P pxzD.P 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 co0 1bB0 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3Qp0|10e5","Asia/Ulaanbaatar|LMT +07 +08 +09|-77.w -70 -80 -90|012323232323232323232323232323232323232323232323232|-2APH7.w 2Uko7.w cKn0 1db0 1dd0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 6hD0 11z0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 kEp0 1cJ0 1cP0 1cJ0|12e5","Asia/Ust-Nera|LMT +08 +09 +12 +11 +10|-9w.S -80 -90 -c0 -b0 -a0|012343434343434343434345434343434343434343434343434343434343434345|-21Q9w.S pApw.S 23CL0 1d90 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 17V0 7zD0|65e2","Asia/Vladivostok|LMT +09 +10 +11|-8L.v -90 -a0 -b0|01232323232323232323232123232323232323232323232323232323232323232|-1SJIL.v itXL.v 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|60e4","Asia/Yakutsk|LMT +08 +09 +10|-8C.W -80 -90 -a0|01232323232323232323232123232323232323232323232323232323232323232|-21Q8C.W pAoC.W 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|28e4","Asia/Yekaterinburg|LMT PMT +04 +05 +06|-42.x -3J.5 -40 -50 -60|012343434343434343434343234343434343434343434343434343434343434343|-2ag42.x 7mQh.s qBvJ.5 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|14e5","Asia/Yerevan|LMT +03 +04 +05|-2W -30 -40 -50|0123232323232323232323212121212323232323232323232323232323232|-1Pc2W 1jUnW WCL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 2pB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 4RX0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0|13e5","Atlantic/Azores|HMT -02 -01 +00 WET|1S.w 20 10 0 0|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121232323232323232323232323232323234323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-2ldW0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cL0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|25e4","Atlantic/Bermuda|BMT BST AST ADT|4j.i 3j.i 40 30|010102323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-28p7E.G 1bb0 1i10 11X0 ru30 thbE.G 1PX0 11B0 1tz0 Rd0 1zb0 Op0 1zb0 3I10 Lz0 1EN0 FX0 1HB0 FX0 1Kp0 Db0 1Kp0 Db0 1Kp0 FX0 93d0 11z0 GAp0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|65e3","Atlantic/Canary|LMT -01 WET WEST|11.A 10 0 -10|01232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-1UtaW.o XPAW.o 1lAK0 1a10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Atlantic/Cape_Verde|LMT -02 -01|1y.4 20 10|01212|-2ldW0 1eEo0 7zX0 1djf0|50e4","Atlantic/Faroe|LMT WET WEST|r.4 0 -10|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2uSnw.U 2Wgow.U 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|49e3","Atlantic/Madeira|FMT -01 +00 +01 WET WEST|17.A 10 0 -10 0 -10|01212121212121212121212121212121212121212121232123212321232121212121212121212121212121212121212121454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2ldX0 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 qIl0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e4","Atlantic/Reykjavik|LMT -01 +00 GMT|1s 10 0 0|012121212121212121212121212121212121212121212121212121212121212121213|-2uWmw mfaw 1Bd0 ML0 1LB0 Cn0 1LB0 3fX0 C10 HrX0 1cO0 LB0 1EL0 LA0 1C00 Oo0 1wo0 Rc0 1wo0 Rc0 1wo0 Rc0 1zc0 Oo0 1zc0 14o0 1lc0 14o0 1lc0 14o0 1o00 11A0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1lc0 14o0 1o00 14o0|12e4","Atlantic/South_Georgia|-02|20|0||30","Atlantic/Stanley|SMT -04 -03 -02|3P.o 40 30 20|012121212121212323212121212121212121212121212121212121212121212121212|-2kJw8.A 12bA8.A 19X0 1fB0 19X0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 Cn0 1Cc10 WL0 1qL0 U10 1tz0 2mN0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 U10 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1tz0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qL0 WN0 1qN0 U10 1wn0 Rd0 1wn0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1tz0 U10 1wn0 U10 1tz0 U10 1tz0 U10|21e2","Australia/Sydney|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|40e5","Australia/Adelaide|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 WM0 1qM0 Rc0 1zc0 U00 1tA0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|11e5","Australia/Brisbane|AEST AEDT|-a0 -b0|01010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0|20e5","Australia/Broken_Hill|ACST ACDT|-9u -au|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 14o0 1o00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1tA0 WM0 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|18e3","Australia/Hobart|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-29E80 1a00 1qM0 Oo0 1zc0 Oo0 TAo0 yM0 1cM0 1cM0 1fA0 1a00 VfA0 1cM0 1o00 Rc0 1wo0 Rc0 1wo0 U00 1wo0 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 11A0 1qM0 WM0 1qM0 Oo0 1zc0 Oo0 1zc0 Oo0 1wo0 WM0 1tA0 WM0 1tA0 U00 1tA0 U00 1tA0 11A0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 11A0 1o00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|21e4","Australia/Darwin|ACST ACDT|-9u -au|010101010|-293ju xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00|12e4","Australia/Eucla|+0845 +0945|-8J -9J|0101010101010101010|-293iJ xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|368","Australia/Lord_Howe|AEST +1030 +1130 +11|-a0 -au -bu -b0|0121212121313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313131313|raC0 1zdu Rb0 1zd0 On0 1zd0 On0 1zd0 On0 1zd0 TXu 1qMu WLu 1tAu WLu 1tAu TXu 1tAu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu 11zu 1o0u 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 11Au 1nXu 1qMu 11zu 1o0u 11zu 1o0u 11zu 1qMu WLu 1qMu 11zu 1o0u WLu 1qMu 14nu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu 1cLu 1cMu|347","Australia/Lindeman|AEST AEDT|-a0 -b0|010101010101010101010|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 H1A0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0|10","Australia/Melbourne|AEST AEDT|-a0 -b0|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101|-293k0 xc0 10jc0 yM0 1cM0 1cM0 1fA0 1a00 17c00 LA0 1C00 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 U00 1qM0 WM0 1qM0 11A0 1tA0 U00 1tA0 U00 1tA0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 11A0 1o00 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 14o0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|39e5","Australia/Perth|AWST AWDT|-80 -90|0101010101010101010|-293i0 xc0 10jc0 yM0 1cM0 1cM0 1gSo0 Oo0 l5A0 Oo0 iJA0 G00 zU00 IM0 1qM0 11A0 1o00 11A0|18e5","CET|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Pacific/Easter|EMT -07 -06 -05|7h.s 70 60 50|012121212121212121212121212123232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323|-1uSgG.w 1s4IG.w WL0 1zd0 On0 1ip0 11z0 1o10 11z0 1qN0 WL0 1ld0 14n0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 2pA0 11z0 1o10 11z0 1qN0 WL0 1qN0 WL0 1qN0 1cL0 1cN0 11z0 1o10 11z0 1qN0 WL0 1fB0 19X0 1qN0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1ip0 1fz0 1fB0 11z0 1qN0 WL0 1qN0 WL0 1qN0 WL0 1qN0 11z0 1o10 11z0 1o10 11z0 1qN0 WL0 1qN0 17b0 1ip0 11z0 1o10 19X0 1fB0 1nX0 G10 1EL0 Op0 1zb0 Rd0 1wn0 Rd0 46n0 Ap0 1Nb0 Ap0 1Nb0 Ap0 1zb0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0 1nX0 11B0|30e2","CST6CDT|CST CDT CWT CPT|60 50 50 50|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261s0 1nX0 11B0 1nX0 SgN0 8x30 iw0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","EET|EET EEST|-20 -30|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","Europe/Dublin|DMT IST GMT BST IST|p.l -y.D 0 -10 -10|01232323232324242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242424242|-2ax9y.D Rc0 1fzy.D 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 g600 14o0 1wo0 17c0 1io0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","EST|EST|50|0||","EST5EDT|EST EDT EWT EPT|50 40 40 40|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261t0 1nX0 11B0 1nX0 SgN0 8x40 iv0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Etc/GMT-0|GMT|0|0||","Etc/GMT-1|+01|-10|0||","Pacific/Port_Moresby|+10|-a0|0||25e4","Etc/GMT-11|+11|-b0|0||","Pacific/Tarawa|+12|-c0|0||29e3","Etc/GMT-13|+13|-d0|0||","Etc/GMT-14|+14|-e0|0||","Etc/GMT-2|+02|-20|0||","Etc/GMT-3|+03|-30|0||","Etc/GMT-4|+04|-40|0||","Etc/GMT-5|+05|-50|0||","Etc/GMT-6|+06|-60|0||","Indian/Christmas|+07|-70|0||21e2","Etc/GMT-8|+08|-80|0||","Pacific/Palau|+09|-90|0||21e3","Etc/GMT+1|-01|10|0||","Etc/GMT+10|-10|a0|0||","Etc/GMT+11|-11|b0|0||","Etc/GMT+12|-12|c0|0||","Etc/GMT+3|-03|30|0||","Etc/GMT+4|-04|40|0||","Etc/GMT+5|-05|50|0||","Etc/GMT+6|-06|60|0||","Etc/GMT+7|-07|70|0||","Etc/GMT+8|-08|80|0||","Etc/GMT+9|-09|90|0||","Etc/UTC|UTC|0|0||","Europe/Amsterdam|AMT NST +0120 +0020 CEST CET|-j.w -1j.w -1k -k -20 -10|010101010101010101010101010101010101010101012323234545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545|-2aFcj.w 11b0 1iP0 11A0 1io0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1co0 1io0 1yo0 Pc0 1a00 1fA0 1Bc0 Mo0 1tc0 Uo0 1tA0 U00 1uo0 W00 1s00 VA0 1so0 Vc0 1sM0 UM0 1wo0 Rc0 1u00 Wo0 1rA0 W00 1s00 VA0 1sM0 UM0 1w00 fV0 BCX.w 1tA0 U00 1u00 Wo0 1sm0 601k WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|16e5","Europe/Andorra|WET CET CEST|0 -10 -20|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-UBA0 1xIN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|79e3","Europe/Astrakhan|LMT +03 +04 +05|-3c.c -30 -40 -50|012323232323232323212121212121212121212121212121212121212121212|-1Pcrc.c eUMc.c 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|10e5","Europe/Athens|AMT EET EEST CEST CET|-1y.Q -20 -30 -20 -10|012123434121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2a61x.Q CNbx.Q mn0 kU10 9b0 3Es0 Xa0 1fb0 1dd0 k3X0 Nz0 SCp0 1vc0 SO0 1cM0 1a00 1ao0 1fc0 1a10 1fG0 1cg0 1dX0 1bX0 1cQ0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|35e5","Europe/London|GMT BST BDST|0 -10 -20|0101010101010101010101010101010101010101010101010121212121210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1a00 1qM0 WM0 1qM0 11A0 1o00 WM0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1tA0 IM0 90o0 U00 1tA0 U00 1tA0 U00 1tA0 U00 1tA0 WM0 1qM0 WM0 1qM0 WM0 1tA0 U00 1tA0 U00 1tA0 11z0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1o00 14o0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|10e6","Europe/Belgrade|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19RC0 3IP0 WM0 1fA0 1cM0 1cM0 1rc0 Qo0 1vmo0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Berlin|CET CEST CEMT|-10 -20 -30|01010101010101210101210101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 kL0 Nc0 m10 WM0 1ao0 1cp0 dX0 jz0 Dd0 1io0 17c0 1fA0 1a00 1ehA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e5","Europe/Prague|CET CEST GMT|-10 -20 0|01010101010101010201010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 1cM0 1qM0 11c0 mp0 xA0 mn0 17c0 1io0 17c0 1fc0 1ao0 1bNc0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|13e5","Europe/Brussels|WET CET CEST WEST|0 -10 -20 -10|0121212103030303030303030303030303030303030303030303212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ehc0 3zX0 11c0 1iO0 11A0 1o00 11A0 my0 Ic0 1qM0 Rc0 1EM0 UM0 1u00 10o0 1io0 1io0 17c0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a30 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 y00 5Wn0 WM0 1fA0 1cM0 16M0 1iM0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|21e5","Europe/Bucharest|BMT EET EEST|-1I.o -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1xApI.o 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Axc0 On0 1fA0 1a10 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|19e5","Europe/Budapest|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 1oo0 11c0 1lc0 17c0 O1V0 3Nf0 WM0 1fA0 1cM0 1cM0 1oJ0 1dd0 1020 1fX0 1cp0 1cM0 1cM0 1cM0 1fA0 1a00 bhy0 Rb0 1wr0 Rc0 1C00 LA0 1C00 LA0 SNW0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cO0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zurich|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-19Lc0 11A0 1o00 11A0 1xG10 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e4","Europe/Chisinau|CMT BMT EET EEST CEST CET MSK MSD|-1T -1I.o -20 -30 -20 -10 -30 -40|012323232323232323234545467676767676767676767323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232323232|-26jdT wGMa.A 20LI.o RA0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 27A0 2en0 39g0 WM0 1fA0 1cM0 V90 1t7z0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 gL0 WO0 1cM0 1cM0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11D0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|67e4","Europe/Copenhagen|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 Tz0 VuO0 60q0 WM0 1fA0 1cM0 1cM0 1cM0 S00 1HA0 Nc0 1C00 Dc0 1Nc0 Ao0 1h5A0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Gibraltar|GMT BST BDST CET CEST|0 -10 -20 -10 -20|010101010101010101010101010101010101010101010101012121212121010121010101010101010101034343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-2axa0 Rc0 1fA0 14M0 1fc0 1g00 1co0 1dc0 1co0 1oo0 1400 1dc0 19A0 1io0 1io0 WM0 1o00 14o0 1o00 17c0 1io0 17c0 1fA0 1a00 1lc0 17c0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1cM0 1io0 17c0 1fA0 1a00 1io0 17c0 1io0 17c0 1fA0 1a00 1io0 1qM0 Dc0 2Rz0 Dc0 1zc0 Oo0 1zc0 Rc0 1wo0 17c0 1iM0 FA0 xB0 1fA0 1a00 14o0 bb0 LA0 xB0 Rc0 1wo0 11A0 1o00 17c0 1fA0 1a00 1fA0 1cM0 1fA0 1a00 17c0 1fA0 1a00 1io0 17c0 1lc0 17c0 1fA0 10Jz0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|30e3","Europe/Helsinki|HMT EET EEST|-1D.N -20 -30|0121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-1WuND.N OULD.N 1dA0 1xGq0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Kaliningrad|CET CEST EET EEST MSK MSD +03|-10 -20 -20 -30 -30 -40 -30|01010101010101232454545454545454543232323232323232323232323232323232323232323262|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 390 7A0 1en0 12N0 1pbb0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|44e4","Europe/Kiev|KMT EET MSK CEST CET MSD EEST|-22.4 -20 -30 -20 -10 -40 -30|0123434252525252525252525256161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc22.4 eUo2.4 rnz0 2Hg0 WM0 1fA0 da0 1v4m0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 Db0 3220 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|34e5","Europe/Kirov|LMT +03 +04 +05|-3i.M -30 -40 -50|01232323232323232321212121212121212121212121212121212121212121|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|48e4","Europe/Lisbon|LMT WET WEST WEMT CET CEST|A.J 0 -10 -20 -10 -20|012121212121212121212121212121212121212121212321232123212321212121212121212121212121212121212121214121212121212121212121212121212124545454212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2le00 aPX0 Sp0 LX0 1vc0 Tc0 1uM0 SM0 1vc0 Tc0 1vc0 SM0 1vc0 6600 1co0 3E00 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 3I00 17c0 1cM0 1cM0 3Fc0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 1tA0 1cM0 1dc0 1400 gL0 IM0 s10 U00 dX0 Rc0 pd0 Rc0 gL0 Oo0 pd0 Rc0 gL0 Oo0 pd0 14o0 1cM0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 3Co0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 pvy0 1cM0 1cM0 1fA0 1cM0 1cM0 1cN0 1cL0 1cN0 1cM0 1cM0 1cM0 1cM0 1cN0 1cL0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|27e5","Europe/Luxembourg|LMT CET CEST WET WEST WEST WET|-o.A -10 -20 0 -10 -20 -10|0121212134343434343434343434343434343434343434343434565651212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2DG0o.A t6mo.A TB0 1nX0 Up0 1o20 11A0 rW0 CM0 1qP0 R90 1EO0 UK0 1u20 10m0 1ip0 1in0 17e0 19W0 1fB0 1db0 1cp0 1in0 17d0 1fz0 1a10 1in0 1a10 1in0 17f0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Dc0 vA0 60L0 WM0 1fA0 1cM0 17c0 1io0 16M0 1C00 Uo0 1eeo0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Madrid|WET WEST WEMT CET CEST|0 -10 -20 -10 -20|010101010101010101210343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343|-25Td0 19B0 1cL0 1dd0 b1z0 18p0 3HX0 17d0 1fz0 1a10 1io0 1a00 1in0 17d0 iIn0 Hd0 1cL0 bb0 1200 2s20 14n0 5aL0 Mp0 1vz0 17d0 1in0 17d0 1in0 17d0 1in0 17d0 6hX0 11B0 XHX0 1a10 1fz0 1a10 19X0 1cN0 1fz0 1a10 1fC0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|62e5","Europe/Malta|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1co0 17c0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1co0 1cM0 1lA0 Xc0 1qq0 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1o10 11z0 1iN0 19z0 1fB0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Minsk|MMT EET MSK CEST CET MSD EEST +03|-1O -20 -30 -20 -10 -40 -30 -30|01234343252525252525252525261616161616161616161616161616161616161617|-1Pc1O eUnO qNX0 3gQ0 WM0 1fA0 1cM0 Al0 1tsn0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 3Fc0 1cN0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0|19e5","Europe/Monaco|PMT WET WEST WEMT CET CEST|-9.l 0 -10 -20 -10 -20|01212121212121212121212121212121212121212121212121232323232345454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-2n5c9.l cFX9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 2RV0 11z0 11B0 1ze0 WM0 1fA0 1cM0 1fa0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|38e3","Europe/Moscow|MMT MMT MST MDST MSD MSK +05 EET EEST MSK|-2u.h -2v.j -3v.j -4v.j -40 -30 -50 -20 -30 -40|012132345464575454545454545454545458754545454545454545454545454545454545454595|-2ag2u.h 2pyW.W 1bA0 11X0 GN0 1Hb0 c4v.j ik0 3DA0 dz0 15A0 c10 2q10 iM10 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0|16e6","Europe/Paris|PMT WET WEST CEST CET WEMT|-9.l 0 -10 -20 -10 -20|0121212121212121212121212121212121212121212121212123434352543434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434343434|-2nco9.l cNb9.l HA0 19A0 1iM0 11c0 1oo0 Wo0 1rc0 QM0 1EM0 UM0 1u00 10o0 1io0 1wo0 Rc0 1a00 1fA0 1cM0 1cM0 1io0 17c0 1fA0 1a00 1io0 1a00 1io0 17c0 1fA0 1a00 1io0 17c0 1cM0 1cM0 1a00 1io0 1cM0 1cM0 1a00 1fA0 1io0 17c0 1cM0 1cM0 1a00 1fA0 1io0 1qM0 Df0 Ik0 5M30 WM0 1fA0 1cM0 Vx0 hB0 1aq0 16M0 1ekn0 1cL0 1fC0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e6","Europe/Riga|RMT LST EET MSK CEST CET MSD EEST|-1A.y -2A.y -20 -30 -20 -10 -40 -30|010102345454536363636363636363727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272727272|-25TzA.y 11A0 1iM0 ko0 gWm0 yDXA.y 2bX0 3fE0 WM0 1fA0 1cM0 1cM0 4m0 1sLy0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cN0 1o00 11A0 1o00 11A0 1qM0 3oo0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|64e4","Europe/Rome|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2arB0 Lz0 1cN0 1db0 1410 1on0 Wp0 1qL0 17d0 1cL0 M3B0 5M20 WM0 1fA0 1cM0 16M0 1iM0 16m0 1de0 1lc0 14m0 1lc0 WO0 1qM0 GTW0 On0 1C10 LA0 1C00 LA0 1EM0 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1C00 LA0 1zc0 Oo0 1C00 LA0 1C00 LA0 1zc0 Oo0 1C00 Oo0 1zc0 Oo0 1fC0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|39e5","Europe/Samara|LMT +03 +04 +05|-3k.k -30 -40 -50|0123232323232323232121232323232323232323232323232323232323212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2y10 14m0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 2sp0 WM0|12e5","Europe/Saratov|LMT +03 +04 +05|-34.i -30 -40 -50|012323232323232321212121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 5810|","Europe/Simferopol|SMT EET MSK CEST CET MSD EEST MSK|-2g -20 -30 -20 -10 -40 -30 -40|012343432525252525252525252161616525252616161616161616161616161616161616172|-1Pc2g eUog rEn0 2qs0 WM0 1fA0 1cM0 3V0 1u0L0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 4eL0 1cL0 1cN0 1cL0 1cN0 dX0 WL0 1cN0 1cL0 1fB0 1o30 11B0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11z0 1nW0|33e4","Europe/Sofia|EET CET CEST EEST|-20 -10 -20 -30|01212103030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030303030|-168L0 WM0 1fA0 1cM0 1cM0 1cN0 1mKH0 1dd0 1fb0 1ap0 1fb0 1a20 1fy0 1a30 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cK0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 1nX0 11E0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|12e5","Europe/Stockholm|CET CEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2azC0 TB0 2yDe0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|15e5","Europe/Tallinn|TMT CET CEST EET MSK MSD EEST|-1D -10 -20 -20 -30 -40 -30|012103421212454545454545454546363636363636363636363636363636363636363636363636363636363636363636363636363636363636363636363|-26oND teD 11A0 1Ta0 4rXl KSLD 2FX0 2Jg0 WM0 1fA0 1cM0 18J0 1sTX0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o10 11A0 1qM0 5QM0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|41e4","Europe/Tirane|LMT CET CEST|-1j.k -10 -20|01212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2glBj.k 14pcj.k 5LC0 WM0 4M0 1fCK0 10n0 1op0 11z0 1pd0 11z0 1qN0 WL0 1qp0 Xb0 1qp0 Xb0 1qp0 11z0 1lB0 11z0 1qN0 11z0 1iN0 16n0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|42e4","Europe/Ulyanovsk|LMT +03 +04 +05 +02|-3d.A -30 -40 -50 -20|01232323232323232321214121212121212121212121212121212121212121212|-22WM0 qH90 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1fA0 2pB0 IM0 rX0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 3rd0|13e5","Europe/Uzhgorod|CET CEST MSK MSD EET EEST|-10 -20 -30 -40 -20 -30|010101023232323232323232320454545454545454545454545454545454545454545454545454545454545454545454545454545454545454545454|-1cqL0 6i00 WM0 1fA0 1cM0 1ml0 1Cp0 1r3W0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1Q00 1Nf0 2pw0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|11e4","Europe/Vienna|CET CEST|-10 -20|0101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 3KM0 14o0 LA00 6i00 WM0 1fA0 1cM0 1cM0 1cM0 400 2qM0 1ao0 1co0 1cM0 1io0 17c0 1gHa0 19X0 1cP0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|18e5","Europe/Vilnius|WMT KMT CET EET MSK CEST MSD EEST|-1o -1z.A -10 -20 -30 -20 -40 -30|012324525254646464646464646473737373737373737352537373737373737373737373737373737373737373737373737373737373737373737373|-293do 6ILM.o 1Ooz.A zz0 Mfd0 29W0 3is0 WM0 1fA0 1cM0 LV0 1tgL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11B0 1o00 11A0 1qM0 8io0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|54e4","Europe/Volgograd|LMT +03 +04 +05|-2V.E -30 -40 -50|0123232323232323212121212121212121212121212121212121212121212121|-21IqV.E psLV.E 23CL0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 2pB0 1cM0 1cM0 1cM0 1fA0 1cM0 3Co0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 8Hz0 9Jd0 5gn0|10e5","Europe/Warsaw|WMT CET CEST EET EEST|-1o -10 -20 -20 -30|012121234312121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121|-2ctdo 1LXo 11d0 1iO0 11A0 1o00 11A0 1on0 11A0 6zy0 HWP0 5IM0 WM0 1fA0 1cM0 1dz0 1mL0 1en0 15B0 1aq0 1nA0 11A0 1io0 17c0 1fA0 1a00 iDX0 LA0 1cM0 1cM0 1C00 Oo0 1cM0 1cM0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1C00 LA0 uso0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cN0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|17e5","Europe/Zaporozhye|+0220 EET MSK CEST CET MSD EEST|-2k -20 -30 -20 -10 -40 -30|01234342525252525252525252526161616161616161616161616161616161616161616161616161616161616161616161616161616161616161616161|-1Pc2k eUok rdb0 2RE0 WM0 1fA0 8m0 1v9a0 1db0 1cN0 1db0 1cN0 1db0 1dd0 1cO0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cK0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cQ0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|77e4","HST|HST|a0|0||","Indian/Chagos|LMT +05 +06|-4N.E -50 -60|012|-2xosN.E 3AGLN.E|30e2","Indian/Cocos|+0630|-6u|0||596","Indian/Kerguelen|-00 +05|0 -50|01|-MG00|130","Indian/Mahe|LMT +04|-3F.M -40|01|-2xorF.M|79e3","Indian/Maldives|MMT +05|-4S -50|01|-olgS|35e4","Indian/Mauritius|LMT +04 +05|-3O -40 -50|012121|-2xorO 34unO 14L0 12kr0 11z0|15e4","Indian/Reunion|LMT +04|-3F.Q -40|01|-2mDDF.Q|84e4","Pacific/Kwajalein|+11 +10 +09 -12 +12|-b0 -a0 -90 c0 -c0|012034|-1kln0 akp0 6Up0 12ry0 Wan0|14e3","MET|MET MEST|-10 -20|01010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-2aFe0 11d0 1iO0 11A0 1o00 11A0 Qrc0 6i00 WM0 1fA0 1cM0 1cM0 1cM0 16M0 1gMM0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|","MST|MST|70|0||","MST7MDT|MST MDT MWT MPT|70 60 60 60|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261r0 1nX0 11B0 1nX0 SgN0 8x20 ix0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","Pacific/Chatham|+1215 +1245 +1345|-cf -cJ -dJ|012121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212121212|-WqAf 1adef IM0 1C00 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1qM0 14o0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1lc0 14o0 1lc0 14o0 1lc0 17c0 1io0 17c0 1io0 17c0 1io0 17c0 1io0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|600","Pacific/Apia|LMT -1130 -11 -10 +14 +13|bq.U bu b0 a0 -e0 -d0|01232345454545454545454545454545454545454545454545454545454|-2nDMx.4 1yW03.4 2rRbu 1ff0 1a00 CI0 AQ0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00 1fA0 1a00|37e3","Pacific/Bougainville|+10 +09 +11|-a0 -90 -b0|0102|-16Wy0 7CN0 2MQp0|18e4","Pacific/Chuuk|+10 +09|-a0 -90|01010|-2ewy0 axB0 RVX0 axd0|49e3","Pacific/Efate|LMT +11 +12|-bd.g -b0 -c0|012121212121212121212121|-2l9nd.g 2uNXd.g Dc0 n610 1cL0 1cN0 1cL0 1fB0 19X0 1fB0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1fB0 Lz0 1Nd0 An0|66e3","Pacific/Enderbury|-12 -11 +13|c0 b0 -d0|012|nIc0 B7X0|1","Pacific/Fakaofo|-11 +13|b0 -d0|01|1Gfn0|483","Pacific/Fiji|LMT +12 +13|-bT.I -c0 -d0|0121212121212121212121212121212121212121212121212121212121212121|-2bUzT.I 3m8NT.I LA0 1EM0 IM0 nJc0 LA0 1o00 Rc0 1wo0 Ao0 1Nc0 Ao0 1Q00 xz0 1SN0 uM0 1SM0 uM0 1VA0 s00 1VA0 s00 1VA0 s00 20o0 pc0 2hc0 bc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 20o0 pc0 20o0 pc0 20o0 pc0 20o0 pc0 20o0 s00 1VA0 s00|88e4","Pacific/Galapagos|LMT -05 -06|5W.o 50 60|01212|-1yVS1.A 2dTz1.A gNd0 rz0|25e3","Pacific/Gambier|LMT -09|8X.M 90|01|-2jof0.c|125","Pacific/Guadalcanal|LMT +11|-aD.M -b0|01|-2joyD.M|11e4","Pacific/Guam|GST +09 GDT ChST|-a0 -90 -b0 -a0|01020202020202020203|-18jK0 6pB0 AhB0 3QL0 g2p0 3p91 WOX rX0 1zd0 Rb0 1wp0 Rb0 5xd0 rX0 5sN0 zb1 1C0X On0 ULb0|17e4","Pacific/Honolulu|HST HDT HWT HPT HST|au 9u 9u 9u a0|0102304|-1thLu 8x0 lef0 8wWu iAu 46p0|37e4","Pacific/Kiritimati|-1040 -10 +14|aE a0 -e0|012|nIaE B7Xk|51e2","Pacific/Kosrae|+11 +09 +10 +12|-b0 -90 -a0 -c0|01021030|-2ewz0 axC0 HBy0 akp0 axd0 WOK0 1bdz0|66e2","Pacific/Majuro|+11 +09 +10 +12|-b0 -90 -a0 -c0|0102103|-2ewz0 axC0 HBy0 akp0 6RB0 12um0|28e3","Pacific/Marquesas|LMT -0930|9i 9u|01|-2joeG|86e2","Pacific/Pago_Pago|LMT SST|bm.M b0|01|-2nDMB.c|37e2","Pacific/Nauru|LMT +1130 +09 +12|-b7.E -bu -90 -c0|01213|-1Xdn7.E QCnB.E 7mqu 1lnbu|10e3","Pacific/Niue|-1120 -1130 -11|bk bu b0|012|-KfME 17y0a|12e2","Pacific/Norfolk|+1112 +1130 +1230 +11 +12|-bc -bu -cu -b0 -c0|012134343434343434343434343434343434343434|-Kgbc W01G Oo0 1COo0 9Jcu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0|25e4","Pacific/Noumea|LMT +11 +12|-b5.M -b0 -c0|01212121|-2l9n5.M 2EqM5.M xX0 1PB0 yn0 HeP0 Ao0|98e3","Pacific/Pitcairn|-0830 -08|8u 80|01|18Vku|56","Pacific/Pohnpei|+11 +09 +10|-b0 -90 -a0|010210|-2ewz0 axC0 HBy0 akp0 axd0|34e3","Pacific/Rarotonga|-1030 -0930 -10|au 9u a0|012121212121212121212121212|lyWu IL0 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Onu 1zcu Rbu 1zcu Onu 1zcu Onu 1zcu Onu|13e3","Pacific/Tahiti|LMT -10|9W.g a0|01|-2joe1.I|18e4","Pacific/Tongatapu|+1220 +13 +14|-ck -d0 -e0|0121212121|-1aB0k 2n5dk 15A0 1wo0 xz0 1Q10 xz0 zWN0 s00|75e3","PST8PDT|PST PDT PWT PPT|80 70 70 70|010102301010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|-261q0 1nX0 11B0 1nX0 SgN0 8x10 iy0 QwN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1cN0 1cL0 1cN0 1cL0 s10 1Vz0 LB0 1BX0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 14p0 1lb0 14p0 1lb0 14p0 1nX0 11B0 1nX0 11B0 1nX0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|","WET|WET WEST|0 -10|010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010101010|hDB0 1a00 1fA0 1cM0 1cM0 1cM0 1fA0 1a00 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00|"],"links":["Africa/Abidjan|Africa/Bamako","Africa/Abidjan|Africa/Banjul","Africa/Abidjan|Africa/Conakry","Africa/Abidjan|Africa/Dakar","Africa/Abidjan|Africa/Freetown","Africa/Abidjan|Africa/Lome","Africa/Abidjan|Africa/Nouakchott","Africa/Abidjan|Africa/Ouagadougou","Africa/Abidjan|Africa/Timbuktu","Africa/Abidjan|Atlantic/St_Helena","Africa/Cairo|Egypt","Africa/Johannesburg|Africa/Maseru","Africa/Johannesburg|Africa/Mbabane","Africa/Lagos|Africa/Bangui","Africa/Lagos|Africa/Brazzaville","Africa/Lagos|Africa/Douala","Africa/Lagos|Africa/Kinshasa","Africa/Lagos|Africa/Libreville","Africa/Lagos|Africa/Luanda","Africa/Lagos|Africa/Malabo","Africa/Lagos|Africa/Niamey","Africa/Lagos|Africa/Porto-Novo","Africa/Maputo|Africa/Blantyre","Africa/Maputo|Africa/Bujumbura","Africa/Maputo|Africa/Gaborone","Africa/Maputo|Africa/Harare","Africa/Maputo|Africa/Kigali","Africa/Maputo|Africa/Lubumbashi","Africa/Maputo|Africa/Lusaka","Africa/Nairobi|Africa/Addis_Ababa","Africa/Nairobi|Africa/Asmara","Africa/Nairobi|Africa/Asmera","Africa/Nairobi|Africa/Dar_es_Salaam","Africa/Nairobi|Africa/Djibouti","Africa/Nairobi|Africa/Kampala","Africa/Nairobi|Africa/Mogadishu","Africa/Nairobi|Indian/Antananarivo","Africa/Nairobi|Indian/Comoro","Africa/Nairobi|Indian/Mayotte","Africa/Tripoli|Libya","America/Adak|America/Atka","America/Adak|US/Aleutian","America/Anchorage|US/Alaska","America/Argentina/Buenos_Aires|America/Buenos_Aires","America/Argentina/Catamarca|America/Argentina/ComodRivadavia","America/Argentina/Catamarca|America/Catamarca","America/Argentina/Cordoba|America/Cordoba","America/Argentina/Cordoba|America/Rosario","America/Argentina/Jujuy|America/Jujuy","America/Argentina/Mendoza|America/Mendoza","America/Atikokan|America/Coral_Harbour","America/Chicago|US/Central","America/Curacao|America/Aruba","America/Curacao|America/Kralendijk","America/Curacao|America/Lower_Princes","America/Denver|America/Shiprock","America/Denver|Navajo","America/Denver|US/Mountain","America/Detroit|US/Michigan","America/Edmonton|Canada/Mountain","America/Fort_Wayne|America/Indiana/Indianapolis","America/Fort_Wayne|America/Indianapolis","America/Fort_Wayne|US/East-Indiana","America/Godthab|America/Nuuk","America/Halifax|Canada/Atlantic","America/Havana|Cuba","America/Indiana/Knox|America/Knox_IN","America/Indiana/Knox|US/Indiana-Starke","America/Jamaica|Jamaica","America/Kentucky/Louisville|America/Louisville","America/Los_Angeles|US/Pacific","America/Manaus|Brazil/West","America/Mazatlan|Mexico/BajaSur","America/Mexico_City|Mexico/General","America/New_York|US/Eastern","America/Noronha|Brazil/DeNoronha","America/Panama|America/Cayman","America/Phoenix|US/Arizona","America/Port_of_Spain|America/Anguilla","America/Port_of_Spain|America/Antigua","America/Port_of_Spain|America/Dominica","America/Port_of_Spain|America/Grenada","America/Port_of_Spain|America/Guadeloupe","America/Port_of_Spain|America/Marigot","America/Port_of_Spain|America/Montserrat","America/Port_of_Spain|America/St_Barthelemy","America/Port_of_Spain|America/St_Kitts","America/Port_of_Spain|America/St_Lucia","America/Port_of_Spain|America/St_Thomas","America/Port_of_Spain|America/St_Vincent","America/Port_of_Spain|America/Tortola","America/Port_of_Spain|America/Virgin","America/Regina|Canada/Saskatchewan","America/Rio_Branco|America/Porto_Acre","America/Rio_Branco|Brazil/Acre","America/Santiago|Chile/Continental","America/Sao_Paulo|Brazil/East","America/St_Johns|Canada/Newfoundland","America/Tijuana|America/Ensenada","America/Tijuana|America/Santa_Isabel","America/Tijuana|Mexico/BajaNorte","America/Toronto|America/Montreal","America/Toronto|Canada/Eastern","America/Vancouver|Canada/Pacific","America/Whitehorse|Canada/Yukon","America/Winnipeg|Canada/Central","Asia/Ashgabat|Asia/Ashkhabad","Asia/Bangkok|Asia/Phnom_Penh","Asia/Bangkok|Asia/Vientiane","Asia/Dhaka|Asia/Dacca","Asia/Dubai|Asia/Muscat","Asia/Ho_Chi_Minh|Asia/Saigon","Asia/Hong_Kong|Hongkong","Asia/Jerusalem|Asia/Tel_Aviv","Asia/Jerusalem|Israel","Asia/Kathmandu|Asia/Katmandu","Asia/Kolkata|Asia/Calcutta","Asia/Kuala_Lumpur|Asia/Singapore","Asia/Kuala_Lumpur|Singapore","Asia/Macau|Asia/Macao","Asia/Makassar|Asia/Ujung_Pandang","Asia/Nicosia|Europe/Nicosia","Asia/Qatar|Asia/Bahrain","Asia/Rangoon|Asia/Yangon","Asia/Riyadh|Asia/Aden","Asia/Riyadh|Asia/Kuwait","Asia/Seoul|ROK","Asia/Shanghai|Asia/Chongqing","Asia/Shanghai|Asia/Chungking","Asia/Shanghai|Asia/Harbin","Asia/Shanghai|PRC","Asia/Taipei|ROC","Asia/Tehran|Iran","Asia/Thimphu|Asia/Thimbu","Asia/Tokyo|Japan","Asia/Ulaanbaatar|Asia/Ulan_Bator","Asia/Urumqi|Asia/Kashgar","Atlantic/Faroe|Atlantic/Faeroe","Atlantic/Reykjavik|Iceland","Atlantic/South_Georgia|Etc/GMT+2","Australia/Adelaide|Australia/South","Australia/Brisbane|Australia/Queensland","Australia/Broken_Hill|Australia/Yancowinna","Australia/Darwin|Australia/North","Australia/Hobart|Australia/Currie","Australia/Hobart|Australia/Tasmania","Australia/Lord_Howe|Australia/LHI","Australia/Melbourne|Australia/Victoria","Australia/Perth|Australia/West","Australia/Sydney|Australia/ACT","Australia/Sydney|Australia/Canberra","Australia/Sydney|Australia/NSW","Etc/GMT-0|Etc/GMT","Etc/GMT-0|Etc/GMT+0","Etc/GMT-0|Etc/GMT0","Etc/GMT-0|Etc/Greenwich","Etc/GMT-0|GMT","Etc/GMT-0|GMT+0","Etc/GMT-0|GMT-0","Etc/GMT-0|GMT0","Etc/GMT-0|Greenwich","Etc/UTC|Etc/UCT","Etc/UTC|Etc/Universal","Etc/UTC|Etc/Zulu","Etc/UTC|UCT","Etc/UTC|UTC","Etc/UTC|Universal","Etc/UTC|Zulu","Europe/Belgrade|Europe/Ljubljana","Europe/Belgrade|Europe/Podgorica","Europe/Belgrade|Europe/Sarajevo","Europe/Belgrade|Europe/Skopje","Europe/Belgrade|Europe/Zagreb","Europe/Chisinau|Europe/Tiraspol","Europe/Dublin|Eire","Europe/Helsinki|Europe/Mariehamn","Europe/Istanbul|Asia/Istanbul","Europe/Istanbul|Turkey","Europe/Lisbon|Portugal","Europe/London|Europe/Belfast","Europe/London|Europe/Guernsey","Europe/London|Europe/Isle_of_Man","Europe/London|Europe/Jersey","Europe/London|GB","Europe/London|GB-Eire","Europe/Moscow|W-SU","Europe/Oslo|Arctic/Longyearbyen","Europe/Oslo|Atlantic/Jan_Mayen","Europe/Prague|Europe/Bratislava","Europe/Rome|Europe/San_Marino","Europe/Rome|Europe/Vatican","Europe/Warsaw|Poland","Europe/Zurich|Europe/Busingen","Europe/Zurich|Europe/Vaduz","Indian/Christmas|Etc/GMT-7","Pacific/Auckland|Antarctica/McMurdo","Pacific/Auckland|Antarctica/South_Pole","Pacific/Auckland|NZ","Pacific/Chatham|NZ-CHAT","Pacific/Chuuk|Pacific/Truk","Pacific/Chuuk|Pacific/Yap","Pacific/Easter|Chile/EasterIsland","Pacific/Guam|Pacific/Saipan","Pacific/Honolulu|Pacific/Johnston","Pacific/Honolulu|US/Hawaii","Pacific/Kwajalein|Kwajalein","Pacific/Pago_Pago|Pacific/Midway","Pacific/Pago_Pago|Pacific/Samoa","Pacific/Pago_Pago|US/Samoa","Pacific/Palau|Etc/GMT-9","Pacific/Pohnpei|Pacific/Ponape","Pacific/Port_Moresby|Etc/GMT-10","Pacific/Tarawa|Etc/GMT-12","Pacific/Tarawa|Pacific/Funafuti","Pacific/Tarawa|Pacific/Wake","Pacific/Tarawa|Pacific/Wallis"],"countries":["AD|Europe/Andorra","AE|Asia/Dubai","AF|Asia/Kabul","AG|America/Port_of_Spain America/Antigua","AI|America/Port_of_Spain America/Anguilla","AL|Europe/Tirane","AM|Asia/Yerevan","AO|Africa/Lagos Africa/Luanda","AQ|Antarctica/Casey Antarctica/Davis Antarctica/DumontDUrville Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Syowa Antarctica/Troll Antarctica/Vostok Pacific/Auckland Antarctica/McMurdo","AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia","AS|Pacific/Pago_Pago","AT|Europe/Vienna","AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Currie Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla","AW|America/Curacao America/Aruba","AX|Europe/Helsinki Europe/Mariehamn","AZ|Asia/Baku","BA|Europe/Belgrade Europe/Sarajevo","BB|America/Barbados","BD|Asia/Dhaka","BE|Europe/Brussels","BF|Africa/Abidjan Africa/Ouagadougou","BG|Europe/Sofia","BH|Asia/Qatar Asia/Bahrain","BI|Africa/Maputo Africa/Bujumbura","BJ|Africa/Lagos Africa/Porto-Novo","BL|America/Port_of_Spain America/St_Barthelemy","BM|Atlantic/Bermuda","BN|Asia/Brunei","BO|America/La_Paz","BQ|America/Curacao America/Kralendijk","BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco","BS|America/Nassau","BT|Asia/Thimphu","BW|Africa/Maputo Africa/Gaborone","BY|Europe/Minsk","BZ|America/Belize","CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Blanc-Sablon America/Toronto America/Nipigon America/Thunder_Bay America/Iqaluit America/Pangnirtung America/Atikokan America/Winnipeg America/Rainy_River America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Yellowknife America/Inuvik America/Creston America/Dawson_Creek America/Fort_Nelson America/Vancouver America/Whitehorse America/Dawson","CC|Indian/Cocos","CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi","CF|Africa/Lagos Africa/Bangui","CG|Africa/Lagos Africa/Brazzaville","CH|Europe/Zurich","CI|Africa/Abidjan","CK|Pacific/Rarotonga","CL|America/Santiago America/Punta_Arenas Pacific/Easter","CM|Africa/Lagos Africa/Douala","CN|Asia/Shanghai Asia/Urumqi","CO|America/Bogota","CR|America/Costa_Rica","CU|America/Havana","CV|Atlantic/Cape_Verde","CW|America/Curacao","CX|Indian/Christmas","CY|Asia/Nicosia Asia/Famagusta","CZ|Europe/Prague","DE|Europe/Zurich Europe/Berlin Europe/Busingen","DJ|Africa/Nairobi Africa/Djibouti","DK|Europe/Copenhagen","DM|America/Port_of_Spain America/Dominica","DO|America/Santo_Domingo","DZ|Africa/Algiers","EC|America/Guayaquil Pacific/Galapagos","EE|Europe/Tallinn","EG|Africa/Cairo","EH|Africa/El_Aaiun","ER|Africa/Nairobi Africa/Asmara","ES|Europe/Madrid Africa/Ceuta Atlantic/Canary","ET|Africa/Nairobi Africa/Addis_Ababa","FI|Europe/Helsinki","FJ|Pacific/Fiji","FK|Atlantic/Stanley","FM|Pacific/Chuuk Pacific/Pohnpei Pacific/Kosrae","FO|Atlantic/Faroe","FR|Europe/Paris","GA|Africa/Lagos Africa/Libreville","GB|Europe/London","GD|America/Port_of_Spain America/Grenada","GE|Asia/Tbilisi","GF|America/Cayenne","GG|Europe/London Europe/Guernsey","GH|Africa/Accra","GI|Europe/Gibraltar","GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule","GM|Africa/Abidjan Africa/Banjul","GN|Africa/Abidjan Africa/Conakry","GP|America/Port_of_Spain America/Guadeloupe","GQ|Africa/Lagos Africa/Malabo","GR|Europe/Athens","GS|Atlantic/South_Georgia","GT|America/Guatemala","GU|Pacific/Guam","GW|Africa/Bissau","GY|America/Guyana","HK|Asia/Hong_Kong","HN|America/Tegucigalpa","HR|Europe/Belgrade Europe/Zagreb","HT|America/Port-au-Prince","HU|Europe/Budapest","ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura","IE|Europe/Dublin","IL|Asia/Jerusalem","IM|Europe/London Europe/Isle_of_Man","IN|Asia/Kolkata","IO|Indian/Chagos","IQ|Asia/Baghdad","IR|Asia/Tehran","IS|Atlantic/Reykjavik","IT|Europe/Rome","JE|Europe/London Europe/Jersey","JM|America/Jamaica","JO|Asia/Amman","JP|Asia/Tokyo","KE|Africa/Nairobi","KG|Asia/Bishkek","KH|Asia/Bangkok Asia/Phnom_Penh","KI|Pacific/Tarawa Pacific/Enderbury Pacific/Kiritimati","KM|Africa/Nairobi Indian/Comoro","KN|America/Port_of_Spain America/St_Kitts","KP|Asia/Pyongyang","KR|Asia/Seoul","KW|Asia/Riyadh Asia/Kuwait","KY|America/Panama America/Cayman","KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral","LA|Asia/Bangkok Asia/Vientiane","LB|Asia/Beirut","LC|America/Port_of_Spain America/St_Lucia","LI|Europe/Zurich Europe/Vaduz","LK|Asia/Colombo","LR|Africa/Monrovia","LS|Africa/Johannesburg Africa/Maseru","LT|Europe/Vilnius","LU|Europe/Luxembourg","LV|Europe/Riga","LY|Africa/Tripoli","MA|Africa/Casablanca","MC|Europe/Monaco","MD|Europe/Chisinau","ME|Europe/Belgrade Europe/Podgorica","MF|America/Port_of_Spain America/Marigot","MG|Africa/Nairobi Indian/Antananarivo","MH|Pacific/Majuro Pacific/Kwajalein","MK|Europe/Belgrade Europe/Skopje","ML|Africa/Abidjan Africa/Bamako","MM|Asia/Yangon","MN|Asia/Ulaanbaatar Asia/Hovd Asia/Choibalsan","MO|Asia/Macau","MP|Pacific/Guam Pacific/Saipan","MQ|America/Martinique","MR|Africa/Abidjan Africa/Nouakchott","MS|America/Port_of_Spain America/Montserrat","MT|Europe/Malta","MU|Indian/Mauritius","MV|Indian/Maldives","MW|Africa/Maputo Africa/Blantyre","MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Mazatlan America/Chihuahua America/Ojinaga America/Hermosillo America/Tijuana America/Bahia_Banderas","MY|Asia/Kuala_Lumpur Asia/Kuching","MZ|Africa/Maputo","NA|Africa/Windhoek","NC|Pacific/Noumea","NE|Africa/Lagos Africa/Niamey","NF|Pacific/Norfolk","NG|Africa/Lagos","NI|America/Managua","NL|Europe/Amsterdam","NO|Europe/Oslo","NP|Asia/Kathmandu","NR|Pacific/Nauru","NU|Pacific/Niue","NZ|Pacific/Auckland Pacific/Chatham","OM|Asia/Dubai Asia/Muscat","PA|America/Panama","PE|America/Lima","PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier","PG|Pacific/Port_Moresby Pacific/Bougainville","PH|Asia/Manila","PK|Asia/Karachi","PL|Europe/Warsaw","PM|America/Miquelon","PN|Pacific/Pitcairn","PR|America/Puerto_Rico","PS|Asia/Gaza Asia/Hebron","PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores","PW|Pacific/Palau","PY|America/Asuncion","QA|Asia/Qatar","RE|Indian/Reunion","RO|Europe/Bucharest","RS|Europe/Belgrade","RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Astrakhan Europe/Volgograd Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr","RW|Africa/Maputo Africa/Kigali","SA|Asia/Riyadh","SB|Pacific/Guadalcanal","SC|Indian/Mahe","SD|Africa/Khartoum","SE|Europe/Stockholm","SG|Asia/Singapore","SH|Africa/Abidjan Atlantic/St_Helena","SI|Europe/Belgrade Europe/Ljubljana","SJ|Europe/Oslo Arctic/Longyearbyen","SK|Europe/Prague Europe/Bratislava","SL|Africa/Abidjan Africa/Freetown","SM|Europe/Rome Europe/San_Marino","SN|Africa/Abidjan Africa/Dakar","SO|Africa/Nairobi Africa/Mogadishu","SR|America/Paramaribo","SS|Africa/Juba","ST|Africa/Sao_Tome","SV|America/El_Salvador","SX|America/Curacao America/Lower_Princes","SY|Asia/Damascus","SZ|Africa/Johannesburg Africa/Mbabane","TC|America/Grand_Turk","TD|Africa/Ndjamena","TF|Indian/Reunion Indian/Kerguelen","TG|Africa/Abidjan Africa/Lome","TH|Asia/Bangkok","TJ|Asia/Dushanbe","TK|Pacific/Fakaofo","TL|Asia/Dili","TM|Asia/Ashgabat","TN|Africa/Tunis","TO|Pacific/Tongatapu","TR|Europe/Istanbul","TT|America/Port_of_Spain","TV|Pacific/Funafuti","TW|Asia/Taipei","TZ|Africa/Nairobi Africa/Dar_es_Salaam","UA|Europe/Simferopol Europe/Kiev Europe/Uzhgorod Europe/Zaporozhye","UG|Africa/Nairobi Africa/Kampala","UM|Pacific/Pago_Pago Pacific/Wake Pacific/Honolulu Pacific/Midway","US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu","UY|America/Montevideo","UZ|Asia/Samarkand Asia/Tashkent","VA|Europe/Rome Europe/Vatican","VC|America/Port_of_Spain America/St_Vincent","VE|America/Caracas","VG|America/Port_of_Spain America/Tortola","VI|America/Port_of_Spain America/St_Thomas","VN|Asia/Bangkok Asia/Ho_Chi_Minh","VU|Pacific/Efate","WF|Pacific/Wallis","WS|Pacific/Apia","YE|Asia/Riyadh Asia/Aden","YT|Africa/Nairobi Indian/Mayotte","ZA|Africa/Johannesburg","ZM|Africa/Maputo Africa/Lusaka","ZW|Africa/Maputo Africa/Harare"]}

/***/ }),
/* 3115 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//! moment-timezone.js
//! version : 0.5.33
//! Copyright (c) JS Foundation and other contributors
//! license : MIT
//! github.com/moment/moment-timezone

(function (root, factory) {
	"use strict";

	/*global define*/
	if (typeof module === 'object' && module.exports) {
		module.exports = factory(__webpack_require__(12)); // Node
	} else if (true) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(12)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));                 // AMD
	} else {
		factory(root.moment);                        // Browser
	}
}(this, function (moment) {
	"use strict";

	// Resolves es6 module loading issue
	if (moment.version === undefined && moment.default) {
		moment = moment.default;
	}

	// Do not load moment-timezone a second time.
	// if (moment.tz !== undefined) {
	// 	logError('Moment Timezone ' + moment.tz.version + ' was already loaded ' + (moment.tz.dataVersion ? 'with data from ' : 'without any data') + moment.tz.dataVersion);
	// 	return moment;
	// }

	var VERSION = "0.5.33",
		zones = {},
		links = {},
		countries = {},
		names = {},
		guesses = {},
		cachedGuess;

	if (!moment || typeof moment.version !== 'string') {
		logError('Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/');
	}

	var momentVersion = moment.version.split('.'),
		major = +momentVersion[0],
		minor = +momentVersion[1];

	// Moment.js version check
	if (major < 2 || (major === 2 && minor < 6)) {
		logError('Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js ' + moment.version + '. See momentjs.com');
	}

	/************************************
		Unpacking
	************************************/

	function charCodeToInt(charCode) {
		if (charCode > 96) {
			return charCode - 87;
		} else if (charCode > 64) {
			return charCode - 29;
		}
		return charCode - 48;
	}

	function unpackBase60(string) {
		var i = 0,
			parts = string.split('.'),
			whole = parts[0],
			fractional = parts[1] || '',
			multiplier = 1,
			num,
			out = 0,
			sign = 1;

		// handle negative numbers
		if (string.charCodeAt(0) === 45) {
			i = 1;
			sign = -1;
		}

		// handle digits before the decimal
		for (i; i < whole.length; i++) {
			num = charCodeToInt(whole.charCodeAt(i));
			out = 60 * out + num;
		}

		// handle digits after the decimal
		for (i = 0; i < fractional.length; i++) {
			multiplier = multiplier / 60;
			num = charCodeToInt(fractional.charCodeAt(i));
			out += num * multiplier;
		}

		return out * sign;
	}

	function arrayToInt (array) {
		for (var i = 0; i < array.length; i++) {
			array[i] = unpackBase60(array[i]);
		}
	}

	function intToUntil (array, length) {
		for (var i = 0; i < length; i++) {
			array[i] = Math.round((array[i - 1] || 0) + (array[i] * 60000)); // minutes to milliseconds
		}

		array[length - 1] = Infinity;
	}

	function mapIndices (source, indices) {
		var out = [], i;

		for (i = 0; i < indices.length; i++) {
			out[i] = source[indices[i]];
		}

		return out;
	}

	function unpack (string) {
		var data = string.split('|'),
			offsets = data[2].split(' '),
			indices = data[3].split(''),
			untils  = data[4].split(' ');

		arrayToInt(offsets);
		arrayToInt(indices);
		arrayToInt(untils);

		intToUntil(untils, indices.length);

		return {
			name       : data[0],
			abbrs      : mapIndices(data[1].split(' '), indices),
			offsets    : mapIndices(offsets, indices),
			untils     : untils,
			population : data[5] | 0
		};
	}

	/************************************
		Zone object
	************************************/

	function Zone (packedString) {
		if (packedString) {
			this._set(unpack(packedString));
		}
	}

	Zone.prototype = {
		_set : function (unpacked) {
			this.name       = unpacked.name;
			this.abbrs      = unpacked.abbrs;
			this.untils     = unpacked.untils;
			this.offsets    = unpacked.offsets;
			this.population = unpacked.population;
		},

		_index : function (timestamp) {
			var target = +timestamp,
				untils = this.untils,
				i;

			for (i = 0; i < untils.length; i++) {
				if (target < untils[i]) {
					return i;
				}
			}
		},

		countries : function () {
			var zone_name = this.name;
			return Object.keys(countries).filter(function (country_code) {
				return countries[country_code].zones.indexOf(zone_name) !== -1;
			});
		},

		parse : function (timestamp) {
			var target  = +timestamp,
				offsets = this.offsets,
				untils  = this.untils,
				max     = untils.length - 1,
				offset, offsetNext, offsetPrev, i;

			for (i = 0; i < max; i++) {
				offset     = offsets[i];
				offsetNext = offsets[i + 1];
				offsetPrev = offsets[i ? i - 1 : i];

				if (offset < offsetNext && tz.moveAmbiguousForward) {
					offset = offsetNext;
				} else if (offset > offsetPrev && tz.moveInvalidForward) {
					offset = offsetPrev;
				}

				if (target < untils[i] - (offset * 60000)) {
					return offsets[i];
				}
			}

			return offsets[max];
		},

		abbr : function (mom) {
			return this.abbrs[this._index(mom)];
		},

		offset : function (mom) {
			logError("zone.offset has been deprecated in favor of zone.utcOffset");
			return this.offsets[this._index(mom)];
		},

		utcOffset : function (mom) {
			return this.offsets[this._index(mom)];
		}
	};

	/************************************
		Country object
	************************************/

	function Country (country_name, zone_names) {
		this.name = country_name;
		this.zones = zone_names;
	}

	/************************************
		Current Timezone
	************************************/

	function OffsetAt(at) {
		var timeString = at.toTimeString();
		var abbr = timeString.match(/\([a-z ]+\)/i);
		if (abbr && abbr[0]) {
			// 17:56:31 GMT-0600 (CST)
			// 17:56:31 GMT-0600 (Central Standard Time)
			abbr = abbr[0].match(/[A-Z]/g);
			abbr = abbr ? abbr.join('') : undefined;
		} else {
			// 17:56:31 CST
			// 17:56:31 GMT+0800 (台北標準時間)
			abbr = timeString.match(/[A-Z]{3,5}/g);
			abbr = abbr ? abbr[0] : undefined;
		}

		if (abbr === 'GMT') {
			abbr = undefined;
		}

		this.at = +at;
		this.abbr = abbr;
		this.offset = at.getTimezoneOffset();
	}

	function ZoneScore(zone) {
		this.zone = zone;
		this.offsetScore = 0;
		this.abbrScore = 0;
	}

	ZoneScore.prototype.scoreOffsetAt = function (offsetAt) {
		this.offsetScore += Math.abs(this.zone.utcOffset(offsetAt.at) - offsetAt.offset);
		if (this.zone.abbr(offsetAt.at).replace(/[^A-Z]/g, '') !== offsetAt.abbr) {
			this.abbrScore++;
		}
	};

	function findChange(low, high) {
		var mid, diff;

		while ((diff = ((high.at - low.at) / 12e4 | 0) * 6e4)) {
			mid = new OffsetAt(new Date(low.at + diff));
			if (mid.offset === low.offset) {
				low = mid;
			} else {
				high = mid;
			}
		}

		return low;
	}

	function userOffsets() {
		var startYear = new Date().getFullYear() - 2,
			last = new OffsetAt(new Date(startYear, 0, 1)),
			offsets = [last],
			change, next, i;

		for (i = 1; i < 48; i++) {
			next = new OffsetAt(new Date(startYear, i, 1));
			if (next.offset !== last.offset) {
				change = findChange(last, next);
				offsets.push(change);
				offsets.push(new OffsetAt(new Date(change.at + 6e4)));
			}
			last = next;
		}

		for (i = 0; i < 4; i++) {
			offsets.push(new OffsetAt(new Date(startYear + i, 0, 1)));
			offsets.push(new OffsetAt(new Date(startYear + i, 6, 1)));
		}

		return offsets;
	}

	function sortZoneScores (a, b) {
		if (a.offsetScore !== b.offsetScore) {
			return a.offsetScore - b.offsetScore;
		}
		if (a.abbrScore !== b.abbrScore) {
			return a.abbrScore - b.abbrScore;
		}
		if (a.zone.population !== b.zone.population) {
			return b.zone.population - a.zone.population;
		}
		return b.zone.name.localeCompare(a.zone.name);
	}

	function addToGuesses (name, offsets) {
		var i, offset;
		arrayToInt(offsets);
		for (i = 0; i < offsets.length; i++) {
			offset = offsets[i];
			guesses[offset] = guesses[offset] || {};
			guesses[offset][name] = true;
		}
	}

	function guessesForUserOffsets (offsets) {
		var offsetsLength = offsets.length,
			filteredGuesses = {},
			out = [],
			i, j, guessesOffset;

		for (i = 0; i < offsetsLength; i++) {
			guessesOffset = guesses[offsets[i].offset] || {};
			for (j in guessesOffset) {
				if (guessesOffset.hasOwnProperty(j)) {
					filteredGuesses[j] = true;
				}
			}
		}

		for (i in filteredGuesses) {
			if (filteredGuesses.hasOwnProperty(i)) {
				out.push(names[i]);
			}
		}

		return out;
	}

	function rebuildGuess () {

		// use Intl API when available and returning valid time zone
		try {
			var intlName = Intl.DateTimeFormat().resolvedOptions().timeZone;
			if (intlName && intlName.length > 3) {
				var name = names[normalizeName(intlName)];
				if (name) {
					return name;
				}
				logError("Moment Timezone found " + intlName + " from the Intl api, but did not have that data loaded.");
			}
		} catch (e) {
			// Intl unavailable, fall back to manual guessing.
		}

		var offsets = userOffsets(),
			offsetsLength = offsets.length,
			guesses = guessesForUserOffsets(offsets),
			zoneScores = [],
			zoneScore, i, j;

		for (i = 0; i < guesses.length; i++) {
			zoneScore = new ZoneScore(getZone(guesses[i]), offsetsLength);
			for (j = 0; j < offsetsLength; j++) {
				zoneScore.scoreOffsetAt(offsets[j]);
			}
			zoneScores.push(zoneScore);
		}

		zoneScores.sort(sortZoneScores);

		return zoneScores.length > 0 ? zoneScores[0].zone.name : undefined;
	}

	function guess (ignoreCache) {
		if (!cachedGuess || ignoreCache) {
			cachedGuess = rebuildGuess();
		}
		return cachedGuess;
	}

	/************************************
		Global Methods
	************************************/

	function normalizeName (name) {
		return (name || '').toLowerCase().replace(/\//g, '_');
	}

	function addZone (packed) {
		var i, name, split, normalized;

		if (typeof packed === "string") {
			packed = [packed];
		}

		for (i = 0; i < packed.length; i++) {
			split = packed[i].split('|');
			name = split[0];
			normalized = normalizeName(name);
			zones[normalized] = packed[i];
			names[normalized] = name;
			addToGuesses(normalized, split[2].split(' '));
		}
	}

	function getZone (name, caller) {

		name = normalizeName(name);

		var zone = zones[name];
		var link;

		if (zone instanceof Zone) {
			return zone;
		}

		if (typeof zone === 'string') {
			zone = new Zone(zone);
			zones[name] = zone;
			return zone;
		}

		// Pass getZone to prevent recursion more than 1 level deep
		if (links[name] && caller !== getZone && (link = getZone(links[name], getZone))) {
			zone = zones[name] = new Zone();
			zone._set(link);
			zone.name = names[name];
			return zone;
		}

		return null;
	}

	function getNames () {
		var i, out = [];

		for (i in names) {
			if (names.hasOwnProperty(i) && (zones[i] || zones[links[i]]) && names[i]) {
				out.push(names[i]);
			}
		}

		return out.sort();
	}

	function getCountryNames () {
		return Object.keys(countries);
	}

	function addLink (aliases) {
		var i, alias, normal0, normal1;

		if (typeof aliases === "string") {
			aliases = [aliases];
		}

		for (i = 0; i < aliases.length; i++) {
			alias = aliases[i].split('|');

			normal0 = normalizeName(alias[0]);
			normal1 = normalizeName(alias[1]);

			links[normal0] = normal1;
			names[normal0] = alias[0];

			links[normal1] = normal0;
			names[normal1] = alias[1];
		}
	}

	function addCountries (data) {
		var i, country_code, country_zones, split;
		if (!data || !data.length) return;
		for (i = 0; i < data.length; i++) {
			split = data[i].split('|');
			country_code = split[0].toUpperCase();
			country_zones = split[1].split(' ');
			countries[country_code] = new Country(
				country_code,
				country_zones
			);
		}
	}

	function getCountry (name) {
		name = name.toUpperCase();
		return countries[name] || null;
	}

	function zonesForCountry(country, with_offset) {
		country = getCountry(country);

		if (!country) return null;

		var zones = country.zones.sort();

		if (with_offset) {
			return zones.map(function (zone_name) {
				var zone = getZone(zone_name);
				return {
					name: zone_name,
					offset: zone.utcOffset(new Date())
				};
			});
		}

		return zones;
	}

	function loadData (data) {
		addZone(data.zones);
		addLink(data.links);
		addCountries(data.countries);
		tz.dataVersion = data.version;
	}

	function zoneExists (name) {
		if (!zoneExists.didShowError) {
			zoneExists.didShowError = true;
				logError("moment.tz.zoneExists('" + name + "') has been deprecated in favor of !moment.tz.zone('" + name + "')");
		}
		return !!getZone(name);
	}

	function needsOffset (m) {
		var isUnixTimestamp = (m._f === 'X' || m._f === 'x');
		return !!(m._a && (m._tzm === undefined) && !isUnixTimestamp);
	}

	function logError (message) {
		if (typeof console !== 'undefined' && typeof console.error === 'function') {
			console.error(message);
		}
	}

	/************************************
		moment.tz namespace
	************************************/

	function tz (input) {
		var args = Array.prototype.slice.call(arguments, 0, -1),
			name = arguments[arguments.length - 1],
			zone = getZone(name),
			out  = moment.utc.apply(null, args);

		if (zone && !moment.isMoment(input) && needsOffset(out)) {
			out.add(zone.parse(out), 'minutes');
		}

		out.tz(name);

		return out;
	}

	tz.version      = VERSION;
	tz.dataVersion  = '';
	tz._zones       = zones;
	tz._links       = links;
	tz._names       = names;
	tz._countries	= countries;
	tz.add          = addZone;
	tz.link         = addLink;
	tz.load         = loadData;
	tz.zone         = getZone;
	tz.zoneExists   = zoneExists; // deprecated in 0.1.0
	tz.guess        = guess;
	tz.names        = getNames;
	tz.Zone         = Zone;
	tz.unpack       = unpack;
	tz.unpackBase60 = unpackBase60;
	tz.needsOffset  = needsOffset;
	tz.moveInvalidForward   = true;
	tz.moveAmbiguousForward = false;
	tz.countries    = getCountryNames;
	tz.zonesForCountry = zonesForCountry;

	/************************************
		Interface with Moment.js
	************************************/

	var fn = moment.fn;

	moment.tz = tz;

	moment.defaultZone = null;

	moment.updateOffset = function (mom, keepTime) {
		var zone = moment.defaultZone,
			offset;

		if (mom._z === undefined) {
			if (zone && needsOffset(mom) && !mom._isUTC) {
				mom._d = moment.utc(mom._a)._d;
				mom.utc().add(zone.parse(mom), 'minutes');
			}
			mom._z = zone;
		}
		if (mom._z) {
			offset = mom._z.utcOffset(mom);
			if (Math.abs(offset) < 16) {
				offset = offset / 60;
			}
			if (mom.utcOffset !== undefined) {
				var z = mom._z;
				mom.utcOffset(-offset, keepTime);
				mom._z = z;
			} else {
				mom.zone(offset, keepTime);
			}
		}
	};

	fn.tz = function (name, keepTime) {
		if (name) {
			if (typeof name !== 'string') {
				throw new Error('Time zone name must be a string, got ' + name + ' [' + typeof name + ']');
			}
			this._z = getZone(name);
			if (this._z) {
				moment.updateOffset(this, keepTime);
			} else {
				logError("Moment Timezone has no data for " + name + ". See http://momentjs.com/timezone/docs/#/data-loading/.");
			}
			return this;
		}
		if (this._z) { return this._z.name; }
	};

	function abbrWrap (old) {
		return function () {
			if (this._z) { return this._z.abbr(this); }
			return old.call(this);
		};
	}

	function resetZoneWrap (old) {
		return function () {
			this._z = null;
			return old.apply(this, arguments);
		};
	}

	function resetZoneWrap2 (old) {
		return function () {
			if (arguments.length > 0) this._z = null;
			return old.apply(this, arguments);
		};
	}

	fn.zoneName  = abbrWrap(fn.zoneName);
	fn.zoneAbbr  = abbrWrap(fn.zoneAbbr);
	fn.utc       = resetZoneWrap(fn.utc);
	fn.local     = resetZoneWrap(fn.local);
	fn.utcOffset = resetZoneWrap2(fn.utcOffset);

	moment.tz.setDefault = function(name) {
		if (major < 2 || (major === 2 && minor < 9)) {
			logError('Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js ' + moment.version + '.');
		}
		moment.defaultZone = name ? getZone(name) : null;
		return moment;
	};

	// Cloning a moment should include the _z property.
	var momentProperties = moment.momentProperties;
	if (Object.prototype.toString.call(momentProperties) === '[object Array]') {
		// moment 2.8.1+
		momentProperties.push('_z');
		momentProperties.push('_a');
	} else if (momentProperties) {
		// moment 2.7.0
		momentProperties._z = null;
	}

	// INJECT DATA

	return moment;
}));


/***/ }),
/* 3116 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 1263,
	"./af.js": 1263,
	"./ar": 1270,
	"./ar-dz": 1264,
	"./ar-dz.js": 1264,
	"./ar-kw": 1265,
	"./ar-kw.js": 1265,
	"./ar-ly": 1266,
	"./ar-ly.js": 1266,
	"./ar-ma": 1267,
	"./ar-ma.js": 1267,
	"./ar-sa": 1268,
	"./ar-sa.js": 1268,
	"./ar-tn": 1269,
	"./ar-tn.js": 1269,
	"./ar.js": 1270,
	"./az": 1271,
	"./az.js": 1271,
	"./be": 1272,
	"./be.js": 1272,
	"./bg": 1273,
	"./bg.js": 1273,
	"./bm": 1274,
	"./bm.js": 1274,
	"./bn": 1275,
	"./bn.js": 1275,
	"./bo": 1276,
	"./bo.js": 1276,
	"./br": 1277,
	"./br.js": 1277,
	"./bs": 1278,
	"./bs.js": 1278,
	"./ca": 1279,
	"./ca.js": 1279,
	"./cs": 1280,
	"./cs.js": 1280,
	"./cv": 1281,
	"./cv.js": 1281,
	"./cy": 1282,
	"./cy.js": 1282,
	"./da": 1283,
	"./da.js": 1283,
	"./de": 1286,
	"./de-at": 1284,
	"./de-at.js": 1284,
	"./de-ch": 1285,
	"./de-ch.js": 1285,
	"./de.js": 1286,
	"./dv": 1287,
	"./dv.js": 1287,
	"./el": 1288,
	"./el.js": 1288,
	"./en-SG": 1289,
	"./en-SG.js": 1289,
	"./en-au": 1290,
	"./en-au.js": 1290,
	"./en-ca": 1291,
	"./en-ca.js": 1291,
	"./en-gb": 1292,
	"./en-gb.js": 1292,
	"./en-ie": 1293,
	"./en-ie.js": 1293,
	"./en-il": 1294,
	"./en-il.js": 1294,
	"./en-nz": 1295,
	"./en-nz.js": 1295,
	"./eo": 1296,
	"./eo.js": 1296,
	"./es": 1299,
	"./es-do": 1297,
	"./es-do.js": 1297,
	"./es-us": 1298,
	"./es-us.js": 1298,
	"./es.js": 1299,
	"./et": 1300,
	"./et.js": 1300,
	"./eu": 1301,
	"./eu.js": 1301,
	"./fa": 1302,
	"./fa.js": 1302,
	"./fi": 1303,
	"./fi.js": 1303,
	"./fo": 1304,
	"./fo.js": 1304,
	"./fr": 1307,
	"./fr-ca": 1305,
	"./fr-ca.js": 1305,
	"./fr-ch": 1306,
	"./fr-ch.js": 1306,
	"./fr.js": 1307,
	"./fy": 1308,
	"./fy.js": 1308,
	"./ga": 1309,
	"./ga.js": 1309,
	"./gd": 1310,
	"./gd.js": 1310,
	"./gl": 1311,
	"./gl.js": 1311,
	"./gom-latn": 1312,
	"./gom-latn.js": 1312,
	"./gu": 1313,
	"./gu.js": 1313,
	"./he": 1314,
	"./he.js": 1314,
	"./hi": 1315,
	"./hi.js": 1315,
	"./hr": 1316,
	"./hr.js": 1316,
	"./hu": 1317,
	"./hu.js": 1317,
	"./hy-am": 1318,
	"./hy-am.js": 1318,
	"./id": 451,
	"./id.js": 451,
	"./is": 1319,
	"./is.js": 1319,
	"./it": 1321,
	"./it-ch": 1320,
	"./it-ch.js": 1320,
	"./it.js": 1321,
	"./ja": 1322,
	"./ja.js": 1322,
	"./jv": 1323,
	"./jv.js": 1323,
	"./ka": 1324,
	"./ka.js": 1324,
	"./kk": 1325,
	"./kk.js": 1325,
	"./km": 1326,
	"./km.js": 1326,
	"./kn": 1327,
	"./kn.js": 1327,
	"./ko": 1328,
	"./ko.js": 1328,
	"./ku": 1329,
	"./ku.js": 1329,
	"./ky": 1330,
	"./ky.js": 1330,
	"./lb": 1331,
	"./lb.js": 1331,
	"./lo": 1332,
	"./lo.js": 1332,
	"./lt": 1333,
	"./lt.js": 1333,
	"./lv": 1334,
	"./lv.js": 1334,
	"./me": 1335,
	"./me.js": 1335,
	"./mi": 1336,
	"./mi.js": 1336,
	"./mk": 1337,
	"./mk.js": 1337,
	"./ml": 1338,
	"./ml.js": 1338,
	"./mn": 1339,
	"./mn.js": 1339,
	"./mr": 1340,
	"./mr.js": 1340,
	"./ms": 1342,
	"./ms-my": 1341,
	"./ms-my.js": 1341,
	"./ms.js": 1342,
	"./mt": 1343,
	"./mt.js": 1343,
	"./my": 1344,
	"./my.js": 1344,
	"./nb": 1345,
	"./nb.js": 1345,
	"./ne": 1346,
	"./ne.js": 1346,
	"./nl": 1348,
	"./nl-be": 1347,
	"./nl-be.js": 1347,
	"./nl.js": 1348,
	"./nn": 1349,
	"./nn.js": 1349,
	"./pa-in": 1350,
	"./pa-in.js": 1350,
	"./pl": 1351,
	"./pl.js": 1351,
	"./pt": 1353,
	"./pt-br": 1352,
	"./pt-br.js": 1352,
	"./pt.js": 1353,
	"./ro": 1354,
	"./ro.js": 1354,
	"./ru": 1355,
	"./ru.js": 1355,
	"./sd": 1356,
	"./sd.js": 1356,
	"./se": 1357,
	"./se.js": 1357,
	"./si": 1358,
	"./si.js": 1358,
	"./sk": 1359,
	"./sk.js": 1359,
	"./sl": 1360,
	"./sl.js": 1360,
	"./sq": 1361,
	"./sq.js": 1361,
	"./sr": 1363,
	"./sr-cyrl": 1362,
	"./sr-cyrl.js": 1362,
	"./sr.js": 1363,
	"./ss": 1364,
	"./ss.js": 1364,
	"./sv": 1365,
	"./sv.js": 1365,
	"./sw": 1366,
	"./sw.js": 1366,
	"./ta": 1367,
	"./ta.js": 1367,
	"./te": 1368,
	"./te.js": 1368,
	"./tet": 1369,
	"./tet.js": 1369,
	"./tg": 1370,
	"./tg.js": 1370,
	"./th": 1371,
	"./th.js": 1371,
	"./tl-ph": 1372,
	"./tl-ph.js": 1372,
	"./tlh": 1373,
	"./tlh.js": 1373,
	"./tr": 1374,
	"./tr.js": 1374,
	"./tzl": 1375,
	"./tzl.js": 1375,
	"./tzm": 1377,
	"./tzm-latn": 1376,
	"./tzm-latn.js": 1376,
	"./tzm.js": 1377,
	"./ug-cn": 1378,
	"./ug-cn.js": 1378,
	"./uk": 1379,
	"./uk.js": 1379,
	"./ur": 1380,
	"./ur.js": 1380,
	"./uz": 1382,
	"./uz-latn": 1381,
	"./uz-latn.js": 1381,
	"./uz.js": 1382,
	"./vi": 452,
	"./vi.js": 452,
	"./x-pseudo": 1383,
	"./x-pseudo.js": 1383,
	"./yo": 1384,
	"./yo.js": 1384,
	"./zh-cn": 1385,
	"./zh-cn.js": 1385,
	"./zh-hk": 1386,
	"./zh-hk.js": 1386,
	"./zh-tw": 1387,
	"./zh-tw.js": 1387
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3116;

/***/ }),
/* 3117 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/*******************************************************************************
 * Copyright (c) 2013 IBM Corp.
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License v1.0
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *    http://www.eclipse.org/legal/epl-v10.html
 * and the Eclipse Distribution License is available at
 *   http://www.eclipse.org/org/documents/edl-v10.php.
 *
 * Contributors:
 *    Andrew Banks - initial API and implementation and initial documentation
 *******************************************************************************/


// Only expose a single object name in the global namespace.
// Everything must go through this module. Global Paho module
// only has a single public function, client, which returns
// a Paho client object given connection details.

/**
 * Send and receive messages using web browsers.
 * <p>
 * This programming interface lets a JavaScript client application use the MQTT V3.1 or
 * V3.1.1 protocol to connect to an MQTT-supporting messaging server.
 *
 * The function supported includes:
 * <ol>
 * <li>Connecting to and disconnecting from a server. The server is identified by its host name and port number.
 * <li>Specifying options that relate to the communications link with the server,
 * for example the frequency of keep-alive heartbeats, and whether SSL/TLS is required.
 * <li>Subscribing to and receiving messages from MQTT Topics.
 * <li>Publishing messages to MQTT Topics.
 * </ol>
 * <p>
 * The API consists of two main objects:
 * <dl>
 * <dt><b>{@link Paho.Client}</b></dt>
 * <dd>This contains methods that provide the functionality of the API,
 * including provision of callbacks that notify the application when a message
 * arrives from or is delivered to the messaging server,
 * or when the status of its connection to the messaging server changes.</dd>
 * <dt><b>{@link Paho.Message}</b></dt>
 * <dd>This encapsulates the payload of the message along with various attributes
 * associated with its delivery, in particular the destination to which it has
 * been (or is about to be) sent.</dd>
 * </dl>
 * <p>
 * The programming interface validates parameters passed to it, and will throw
 * an Error containing an error message intended for developer use, if it detects
 * an error with any parameter.
 * <p>
 * Example:
 *
 * <code><pre>
var client = new Paho.MQTT.Client(location.hostname, Number(location.port), "clientId");
client.onConnectionLost = onConnectionLost;
client.onMessageArrived = onMessageArrived;
client.connect({onSuccess:onConnect});

function onConnect() {
  // Once a connection has been made, make a subscription and send a message.
  console.log("onConnect");
  client.subscribe("/World");
  var message = new Paho.MQTT.Message("Hello");
  message.destinationName = "/World";
  client.send(message);
};
function onConnectionLost(responseObject) {
  if (responseObject.errorCode !== 0)
	console.log("onConnectionLost:"+responseObject.errorMessage);
};
function onMessageArrived(message) {
  console.log("onMessageArrived:"+message.payloadString);
  client.disconnect();
};
 * </pre></code>
 * @namespace Paho
 */

/* jshint shadow:true */
(function ExportLibrary(root, factory) {
	if(true){
		module.exports = factory();
	} else if (typeof define === "function" && define.amd){
		define(factory);
	} else if (typeof exports === "object"){
		exports = factory();
	} else {
		//if (typeof root.Paho === "undefined"){
		//	root.Paho = {};
		//}
		root.Paho = factory();
	}
})(this, function LibraryFactory(){


	var PahoMQTT = (function (global) {

	// Private variables below, these are only visible inside the function closure
	// which is used to define the module.
	var version = "@VERSION@-@BUILDLEVEL@";

	/**
	 * @private
	 */
	var localStorage = global.localStorage || (function () {
		var data = {};

		return {
			setItem: function (key, item) { data[key] = item; },
			getItem: function (key) { return data[key]; },
			removeItem: function (key) { delete data[key]; },
		};
	})();

		/**
	 * Unique message type identifiers, with associated
	 * associated integer values.
	 * @private
	 */
		var MESSAGE_TYPE = {
			CONNECT: 1,
			CONNACK: 2,
			PUBLISH: 3,
			PUBACK: 4,
			PUBREC: 5,
			PUBREL: 6,
			PUBCOMP: 7,
			SUBSCRIBE: 8,
			SUBACK: 9,
			UNSUBSCRIBE: 10,
			UNSUBACK: 11,
			PINGREQ: 12,
			PINGRESP: 13,
			DISCONNECT: 14
		};

		// Collection of utility methods used to simplify module code
		// and promote the DRY pattern.

		/**
	 * Validate an object's parameter names to ensure they
	 * match a list of expected variables name for this option
	 * type. Used to ensure option object passed into the API don't
	 * contain erroneous parameters.
	 * @param {Object} obj - User options object
	 * @param {Object} keys - valid keys and types that may exist in obj.
	 * @throws {Error} Invalid option parameter found.
	 * @private
	 */
		var validate = function(obj, keys) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					if (keys.hasOwnProperty(key)) {
						if (typeof obj[key] !== keys[key])
							throw new Error(format(ERROR.INVALID_TYPE, [typeof obj[key], key]));
					} else {
						var errorStr = "Unknown property, " + key + ". Valid properties are:";
						for (var validKey in keys)
							if (keys.hasOwnProperty(validKey))
								errorStr = errorStr+" "+validKey;
						throw new Error(errorStr);
					}
				}
			}
		};

		/**
	 * Return a new function which runs the user function bound
	 * to a fixed scope.
	 * @param {function} User function
	 * @param {object} Function scope
	 * @return {function} User function bound to another scope
	 * @private
	 */
		var scope = function (f, scope) {
			return function () {
				return f.apply(scope, arguments);
			};
		};

		/**
	 * Unique message type identifiers, with associated
	 * associated integer values.
	 * @private
	 */
		var ERROR = {
			OK: {code:0, text:"AMQJSC0000I OK."},
			CONNECT_TIMEOUT: {code:1, text:"AMQJSC0001E Connect timed out."},
			SUBSCRIBE_TIMEOUT: {code:2, text:"AMQJS0002E Subscribe timed out."},
			UNSUBSCRIBE_TIMEOUT: {code:3, text:"AMQJS0003E Unsubscribe timed out."},
			PING_TIMEOUT: {code:4, text:"AMQJS0004E Ping timed out."},
			INTERNAL_ERROR: {code:5, text:"AMQJS0005E Internal error. Error Message: {0}, Stack trace: {1}"},
			CONNACK_RETURNCODE: {code:6, text:"AMQJS0006E Bad Connack return code:{0} {1}."},
			SOCKET_ERROR: {code:7, text:"AMQJS0007E Socket error:{0}."},
			SOCKET_CLOSE: {code:8, text:"AMQJS0008I Socket closed."},
			MALFORMED_UTF: {code:9, text:"AMQJS0009E Malformed UTF data:{0} {1} {2}."},
			UNSUPPORTED: {code:10, text:"AMQJS0010E {0} is not supported by this browser."},
			INVALID_STATE: {code:11, text:"AMQJS0011E Invalid state {0}."},
			INVALID_TYPE: {code:12, text:"AMQJS0012E Invalid type {0} for {1}."},
			INVALID_ARGUMENT: {code:13, text:"AMQJS0013E Invalid argument {0} for {1}."},
			UNSUPPORTED_OPERATION: {code:14, text:"AMQJS0014E Unsupported operation."},
			INVALID_STORED_DATA: {code:15, text:"AMQJS0015E Invalid data in local storage key={0} value={1}."},
			INVALID_MQTT_MESSAGE_TYPE: {code:16, text:"AMQJS0016E Invalid MQTT message type {0}."},
			MALFORMED_UNICODE: {code:17, text:"AMQJS0017E Malformed Unicode string:{0} {1}."},
			BUFFER_FULL: {code:18, text:"AMQJS0018E Message buffer is full, maximum buffer size: {0}."},
		};

		/** CONNACK RC Meaning. */
		var CONNACK_RC = {
			0:"Connection Accepted",
			1:"Connection Refused: unacceptable protocol version",
			2:"Connection Refused: identifier rejected",
			3:"Connection Refused: server unavailable",
			4:"Connection Refused: bad user name or password",
			5:"Connection Refused: not authorized"
		};

	/**
	 * Format an error message text.
	 * @private
	 * @param {error} ERROR value above.
	 * @param {substitutions} [array] substituted into the text.
	 * @return the text with the substitutions made.
	 */
		var format = function(error, substitutions) {
			var text = error.text;
			if (substitutions) {
				var field,start;
				for (var i=0; i<substitutions.length; i++) {
					field = "{"+i+"}";
					start = text.indexOf(field);
					if(start > 0) {
						var part1 = text.substring(0,start);
						var part2 = text.substring(start+field.length);
						text = part1+substitutions[i]+part2;
					}
				}
			}
			return text;
		};

		//MQTT protocol and version          6    M    Q    I    s    d    p    3
		var MqttProtoIdentifierv3 = [0x00,0x06,0x4d,0x51,0x49,0x73,0x64,0x70,0x03];
		//MQTT proto/version for 311         4    M    Q    T    T    4
		var MqttProtoIdentifierv4 = [0x00,0x04,0x4d,0x51,0x54,0x54,0x04];

		/**
	 * Construct an MQTT wire protocol message.
	 * @param type MQTT packet type.
	 * @param options optional wire message attributes.
	 *
	 * Optional properties
	 *
	 * messageIdentifier: message ID in the range [0..65535]
	 * payloadMessage:	Application Message - PUBLISH only
	 * connectStrings:	array of 0 or more Strings to be put into the CONNECT payload
	 * topics:			array of strings (SUBSCRIBE, UNSUBSCRIBE)
	 * requestQoS:		array of QoS values [0..2]
	 *
	 * "Flag" properties
	 * cleanSession:	true if present / false if absent (CONNECT)
	 * willMessage:  	true if present / false if absent (CONNECT)
	 * isRetained:		true if present / false if absent (CONNECT)
	 * userName:		true if present / false if absent (CONNECT)
	 * password:		true if present / false if absent (CONNECT)
	 * keepAliveInterval:	integer [0..65535]  (CONNECT)
	 *
	 * @private
	 * @ignore
	 */
		var WireMessage = function (type, options) {
			this.type = type;
			for (var name in options) {
				if (options.hasOwnProperty(name)) {
					this[name] = options[name];
				}
			}
		};

		WireMessage.prototype.encode = function() {
		// Compute the first byte of the fixed header
			var first = ((this.type & 0x0f) << 4);

			/*
		 * Now calculate the length of the variable header + payload by adding up the lengths
		 * of all the component parts
		 */

			var remLength = 0;
			var topicStrLength = [];
			var destinationNameLength = 0;
			var willMessagePayloadBytes;

			// if the message contains a messageIdentifier then we need two bytes for that
			if (this.messageIdentifier !== undefined)
				remLength += 2;

			switch(this.type) {
			// If this a Connect then we need to include 12 bytes for its header
			case MESSAGE_TYPE.CONNECT:
				switch(this.mqttVersion) {
				case 3:
					remLength += MqttProtoIdentifierv3.length + 3;
					break;
				case 4:
					remLength += MqttProtoIdentifierv4.length + 3;
					break;
				}

				remLength += UTF8Length(this.clientId) + 2;
				if (this.willMessage !== undefined) {
					remLength += UTF8Length(this.willMessage.destinationName) + 2;
					// Will message is always a string, sent as UTF-8 characters with a preceding length.
					willMessagePayloadBytes = this.willMessage.payloadBytes;
					if (!(willMessagePayloadBytes instanceof Uint8Array))
						willMessagePayloadBytes = new Uint8Array(payloadBytes);
					remLength += willMessagePayloadBytes.byteLength +2;
				}
				if (this.userName !== undefined)
					remLength += UTF8Length(this.userName) + 2;
				if (this.password !== undefined)
					remLength += UTF8Length(this.password) + 2;
				break;

			// Subscribe, Unsubscribe can both contain topic strings
			case MESSAGE_TYPE.SUBSCRIBE:
				first |= 0x02; // Qos = 1;
				for ( var i = 0; i < this.topics.length; i++) {
					topicStrLength[i] = UTF8Length(this.topics[i]);
					remLength += topicStrLength[i] + 2;
				}
				remLength += this.requestedQos.length; // 1 byte for each topic's Qos
				// QoS on Subscribe only
				break;

			case MESSAGE_TYPE.UNSUBSCRIBE:
				first |= 0x02; // Qos = 1;
				for ( var i = 0; i < this.topics.length; i++) {
					topicStrLength[i] = UTF8Length(this.topics[i]);
					remLength += topicStrLength[i] + 2;
				}
				break;

			case MESSAGE_TYPE.PUBREL:
				first |= 0x02; // Qos = 1;
				break;

			case MESSAGE_TYPE.PUBLISH:
				if (this.payloadMessage.duplicate) first |= 0x08;
				first  = first |= (this.payloadMessage.qos << 1);
				if (this.payloadMessage.retained) first |= 0x01;
				destinationNameLength = UTF8Length(this.payloadMessage.destinationName);
				remLength += destinationNameLength + 2;
				var payloadBytes = this.payloadMessage.payloadBytes;
				remLength += payloadBytes.byteLength;
				if (payloadBytes instanceof ArrayBuffer)
					payloadBytes = new Uint8Array(payloadBytes);
				else if (!(payloadBytes instanceof Uint8Array))
					payloadBytes = new Uint8Array(payloadBytes.buffer);
				break;

			case MESSAGE_TYPE.DISCONNECT:
				break;

			default:
				break;
			}

			// Now we can allocate a buffer for the message

			var mbi = encodeMBI(remLength);  // Convert the length to MQTT MBI format
			var pos = mbi.length + 1;        // Offset of start of variable header
			var buffer = new ArrayBuffer(remLength + pos);
			var byteStream = new Uint8Array(buffer);    // view it as a sequence of bytes

			//Write the fixed header into the buffer
			byteStream[0] = first;
			byteStream.set(mbi,1);

			// If this is a PUBLISH then the variable header starts with a topic
			if (this.type == MESSAGE_TYPE.PUBLISH)
				pos = writeString(this.payloadMessage.destinationName, destinationNameLength, byteStream, pos);
			// If this is a CONNECT then the variable header contains the protocol name/version, flags and keepalive time

			else if (this.type == MESSAGE_TYPE.CONNECT) {
				switch (this.mqttVersion) {
				case 3:
					byteStream.set(MqttProtoIdentifierv3, pos);
					pos += MqttProtoIdentifierv3.length;
					break;
				case 4:
					byteStream.set(MqttProtoIdentifierv4, pos);
					pos += MqttProtoIdentifierv4.length;
					break;
				}
				var connectFlags = 0;
				if (this.cleanSession)
					connectFlags = 0x02;
				if (this.willMessage !== undefined ) {
					connectFlags |= 0x04;
					connectFlags |= (this.willMessage.qos<<3);
					if (this.willMessage.retained) {
						connectFlags |= 0x20;
					}
				}
				if (this.userName !== undefined)
					connectFlags |= 0x80;
				if (this.password !== undefined)
					connectFlags |= 0x40;
				byteStream[pos++] = connectFlags;
				pos = writeUint16 (this.keepAliveInterval, byteStream, pos);
			}

			// Output the messageIdentifier - if there is one
			if (this.messageIdentifier !== undefined)
				pos = writeUint16 (this.messageIdentifier, byteStream, pos);

			switch(this.type) {
			case MESSAGE_TYPE.CONNECT:
				pos = writeString(this.clientId, UTF8Length(this.clientId), byteStream, pos);
				if (this.willMessage !== undefined) {
					pos = writeString(this.willMessage.destinationName, UTF8Length(this.willMessage.destinationName), byteStream, pos);
					pos = writeUint16(willMessagePayloadBytes.byteLength, byteStream, pos);
					byteStream.set(willMessagePayloadBytes, pos);
					pos += willMessagePayloadBytes.byteLength;

				}
				if (this.userName !== undefined)
					pos = writeString(this.userName, UTF8Length(this.userName), byteStream, pos);
				if (this.password !== undefined)
					pos = writeString(this.password, UTF8Length(this.password), byteStream, pos);
				break;

			case MESSAGE_TYPE.PUBLISH:
				// PUBLISH has a text or binary payload, if text do not add a 2 byte length field, just the UTF characters.
				byteStream.set(payloadBytes, pos);

				break;

				//    	    case MESSAGE_TYPE.PUBREC:
				//    	    case MESSAGE_TYPE.PUBREL:
				//    	    case MESSAGE_TYPE.PUBCOMP:
				//    	    	break;

			case MESSAGE_TYPE.SUBSCRIBE:
				// SUBSCRIBE has a list of topic strings and request QoS
				for (var i=0; i<this.topics.length; i++) {
					pos = writeString(this.topics[i], topicStrLength[i], byteStream, pos);
					byteStream[pos++] = this.requestedQos[i];
				}
				break;

			case MESSAGE_TYPE.UNSUBSCRIBE:
				// UNSUBSCRIBE has a list of topic strings
				for (var i=0; i<this.topics.length; i++)
					pos = writeString(this.topics[i], topicStrLength[i], byteStream, pos);
				break;

			default:
				// Do nothing.
			}

			return buffer;
		};

		function decodeMessage(input,pos) {
			var startingPos = pos;
			var first = input[pos];
			var type = first >> 4;
			var messageInfo = first &= 0x0f;
			pos += 1;


			// Decode the remaining length (MBI format)

			var digit;
			var remLength = 0;
			var multiplier = 1;
			do {
				if (pos == input.length) {
					return [null,startingPos];
				}
				digit = input[pos++];
				remLength += ((digit & 0x7F) * multiplier);
				multiplier *= 128;
			} while ((digit & 0x80) !== 0);

			var endPos = pos+remLength;
			if (endPos > input.length) {
				return [null,startingPos];
			}

			var wireMessage = new WireMessage(type);
			switch(type) {
			case MESSAGE_TYPE.CONNACK:
				var connectAcknowledgeFlags = input[pos++];
				if (connectAcknowledgeFlags & 0x01)
					wireMessage.sessionPresent = true;
				wireMessage.returnCode = input[pos++];
				break;

			case MESSAGE_TYPE.PUBLISH:
				var qos = (messageInfo >> 1) & 0x03;

				var len = readUint16(input, pos);
				pos += 2;
				var topicName = parseUTF8(input, pos, len);
				pos += len;
				// If QoS 1 or 2 there will be a messageIdentifier
				if (qos > 0) {
					wireMessage.messageIdentifier = readUint16(input, pos);
					pos += 2;
				}

				var message = new Message(input.subarray(pos, endPos));
				if ((messageInfo & 0x01) == 0x01)
					message.retained = true;
				if ((messageInfo & 0x08) == 0x08)
					message.duplicate =  true;
				message.qos = qos;
				message.destinationName = topicName;
				wireMessage.payloadMessage = message;
				break;

			case  MESSAGE_TYPE.PUBACK:
			case  MESSAGE_TYPE.PUBREC:
			case  MESSAGE_TYPE.PUBREL:
			case  MESSAGE_TYPE.PUBCOMP:
			case  MESSAGE_TYPE.UNSUBACK:
				wireMessage.messageIdentifier = readUint16(input, pos);
				break;

			case  MESSAGE_TYPE.SUBACK:
				wireMessage.messageIdentifier = readUint16(input, pos);
				pos += 2;
				wireMessage.returnCode = input.subarray(pos, endPos);
				break;

			default:
				break;
			}

			return [wireMessage,endPos];
		}

		function writeUint16(input, buffer, offset) {
			buffer[offset++] = input >> 8;      //MSB
			buffer[offset++] = input % 256;     //LSB
			return offset;
		}

		function writeString(input, utf8Length, buffer, offset) {
			offset = writeUint16(utf8Length, buffer, offset);
			stringToUTF8(input, buffer, offset);
			return offset + utf8Length;
		}

		function readUint16(buffer, offset) {
			return 256*buffer[offset] + buffer[offset+1];
		}

		/**
	 * Encodes an MQTT Multi-Byte Integer
	 * @private
	 */
		function encodeMBI(number) {
			var output = new Array(1);
			var numBytes = 0;

			do {
				var digit = number % 128;
				number = number >> 7;
				if (number > 0) {
					digit |= 0x80;
				}
				output[numBytes++] = digit;
			} while ( (number > 0) && (numBytes<4) );

			return output;
		}

		/**
	 * Takes a String and calculates its length in bytes when encoded in UTF8.
	 * @private
	 */
		function UTF8Length(input) {
			var output = 0;
			for (var i = 0; i<input.length; i++)
			{
				var charCode = input.charCodeAt(i);
				if (charCode > 0x7FF)
				{
					// Surrogate pair means its a 4 byte character
					if (0xD800 <= charCode && charCode <= 0xDBFF)
					{
						i++;
						output++;
					}
					output +=3;
				}
				else if (charCode > 0x7F)
					output +=2;
				else
					output++;
			}
			return output;
		}

		/**
	 * Takes a String and writes it into an array as UTF8 encoded bytes.
	 * @private
	 */
		function stringToUTF8(input, output, start) {
			var pos = start;
			for (var i = 0; i<input.length; i++) {
				var charCode = input.charCodeAt(i);

				// Check for a surrogate pair.
				if (0xD800 <= charCode && charCode <= 0xDBFF) {
					var lowCharCode = input.charCodeAt(++i);
					if (isNaN(lowCharCode)) {
						throw new Error(format(ERROR.MALFORMED_UNICODE, [charCode, lowCharCode]));
					}
					charCode = ((charCode - 0xD800)<<10) + (lowCharCode - 0xDC00) + 0x10000;

				}

				if (charCode <= 0x7F) {
					output[pos++] = charCode;
				} else if (charCode <= 0x7FF) {
					output[pos++] = charCode>>6  & 0x1F | 0xC0;
					output[pos++] = charCode     & 0x3F | 0x80;
				} else if (charCode <= 0xFFFF) {
					output[pos++] = charCode>>12 & 0x0F | 0xE0;
					output[pos++] = charCode>>6  & 0x3F | 0x80;
					output[pos++] = charCode     & 0x3F | 0x80;
				} else {
					output[pos++] = charCode>>18 & 0x07 | 0xF0;
					output[pos++] = charCode>>12 & 0x3F | 0x80;
					output[pos++] = charCode>>6  & 0x3F | 0x80;
					output[pos++] = charCode     & 0x3F | 0x80;
				}
			}
			return output;
		}

		function parseUTF8(input, offset, length) {
			var output = "";
			var utf16;
			var pos = offset;

			while (pos < offset+length)
			{
				var byte1 = input[pos++];
				if (byte1 < 128)
					utf16 = byte1;
				else
				{
					var byte2 = input[pos++]-128;
					if (byte2 < 0)
						throw new Error(format(ERROR.MALFORMED_UTF, [byte1.toString(16), byte2.toString(16),""]));
					if (byte1 < 0xE0)             // 2 byte character
						utf16 = 64*(byte1-0xC0) + byte2;
					else
					{
						var byte3 = input[pos++]-128;
						if (byte3 < 0)
							throw new Error(format(ERROR.MALFORMED_UTF, [byte1.toString(16), byte2.toString(16), byte3.toString(16)]));
						if (byte1 < 0xF0)        // 3 byte character
							utf16 = 4096*(byte1-0xE0) + 64*byte2 + byte3;
						else
						{
							var byte4 = input[pos++]-128;
							if (byte4 < 0)
								throw new Error(format(ERROR.MALFORMED_UTF, [byte1.toString(16), byte2.toString(16), byte3.toString(16), byte4.toString(16)]));
							if (byte1 < 0xF8)        // 4 byte character
								utf16 = 262144*(byte1-0xF0) + 4096*byte2 + 64*byte3 + byte4;
							else                     // longer encodings are not supported
								throw new Error(format(ERROR.MALFORMED_UTF, [byte1.toString(16), byte2.toString(16), byte3.toString(16), byte4.toString(16)]));
						}
					}
				}

				if (utf16 > 0xFFFF)   // 4 byte character - express as a surrogate pair
				{
					utf16 -= 0x10000;
					output += String.fromCharCode(0xD800 + (utf16 >> 10)); // lead character
					utf16 = 0xDC00 + (utf16 & 0x3FF);  // trail character
				}
				output += String.fromCharCode(utf16);
			}
			return output;
		}

		/**
	 * Repeat keepalive requests, monitor responses.
	 * @ignore
	 */
		var Pinger = function(client, keepAliveInterval) {
			this._client = client;
			this._keepAliveInterval = keepAliveInterval*1000;
			this.isReset = false;

			var pingReq = new WireMessage(MESSAGE_TYPE.PINGREQ).encode();

			var doTimeout = function (pinger) {
				return function () {
					return doPing.apply(pinger);
				};
			};

			/** @ignore */
			var doPing = function() {
				if (!this.isReset) {
					this._client._trace("Pinger.doPing", "Timed out");
					this._client._disconnected( ERROR.PING_TIMEOUT.code , format(ERROR.PING_TIMEOUT));
				} else {
					this.isReset = false;
					this._client._trace("Pinger.doPing", "send PINGREQ");
					this._client.socket.send(pingReq);
					this.timeout = setTimeout(doTimeout(this), this._keepAliveInterval);
				}
			};

			this.reset = function() {
				this.isReset = true;
				clearTimeout(this.timeout);
				if (this._keepAliveInterval > 0)
					this.timeout = setTimeout(doTimeout(this), this._keepAliveInterval);
			};

			this.cancel = function() {
				clearTimeout(this.timeout);
			};
		};

		/**
	 * Monitor request completion.
	 * @ignore
	 */
		var Timeout = function(client, timeoutSeconds, action, args) {
			if (!timeoutSeconds)
				timeoutSeconds = 30;

			var doTimeout = function (action, client, args) {
				return function () {
					return action.apply(client, args);
				};
			};
			this.timeout = setTimeout(doTimeout(action, client, args), timeoutSeconds * 1000);

			this.cancel = function() {
				clearTimeout(this.timeout);
			};
		};

	/**
	 * Internal implementation of the Websockets MQTT V3.1 client.
	 *
	 * @name Paho.ClientImpl @constructor
	 * @param {String} host the DNS nameof the webSocket host.
	 * @param {Number} port the port number for that host.
	 * @param {String} clientId the MQ client identifier.
	 */
		var ClientImpl = function (uri, host, port, path, clientId) {
		// Check dependencies are satisfied in this browser.
			if (!("WebSocket" in global && global.WebSocket !== null)) {
				throw new Error(format(ERROR.UNSUPPORTED, ["WebSocket"]));
			}
			if (!("ArrayBuffer" in global && global.ArrayBuffer !== null)) {
				throw new Error(format(ERROR.UNSUPPORTED, ["ArrayBuffer"]));
			}
			this._trace("Paho.Client", uri, host, port, path, clientId);

			this.host = host;
			this.port = port;
			this.path = path;
			this.uri = uri;
			this.clientId = clientId;
			this._wsuri = null;

			// Local storagekeys are qualified with the following string.
			// The conditional inclusion of path in the key is for backward
			// compatibility to when the path was not configurable and assumed to
			// be /mqtt
			this._localKey=host+":"+port+(path!="/mqtt"?":"+path:"")+":"+clientId+":";

			// Create private instance-only message queue
			// Internal queue of messages to be sent, in sending order.
			this._msg_queue = [];
			this._buffered_msg_queue = [];

			// Messages we have sent and are expecting a response for, indexed by their respective message ids.
			this._sentMessages = {};

			// Messages we have received and acknowleged and are expecting a confirm message for
			// indexed by their respective message ids.
			this._receivedMessages = {};

			// Internal list of callbacks to be executed when messages
			// have been successfully sent over web socket, e.g. disconnect
			// when it doesn't have to wait for ACK, just message is dispatched.
			this._notify_msg_sent = {};

			// Unique identifier for SEND messages, incrementing
			// counter as messages are sent.
			this._message_identifier = 1;

			// Used to determine the transmission sequence of stored sent messages.
			this._sequence = 0;


			// Load the local state, if any, from the saved version, only restore state relevant to this client.
			for (var key in localStorage)
				if (   key.indexOf("Sent:"+this._localKey) === 0 || key.indexOf("Received:"+this._localKey) === 0)
					this.restore(key);
		};

		// Messaging Client public instance members.
		ClientImpl.prototype.host = null;
		ClientImpl.prototype.port = null;
		ClientImpl.prototype.path = null;
		ClientImpl.prototype.uri = null;
		ClientImpl.prototype.clientId = null;

		// Messaging Client private instance members.
		ClientImpl.prototype.socket = null;
		/* true once we have received an acknowledgement to a CONNECT packet. */
		ClientImpl.prototype.connected = false;
		/* The largest message identifier allowed, may not be larger than 2**16 but
		 * if set smaller reduces the maximum number of outbound messages allowed.
		 */
		ClientImpl.prototype.maxMessageIdentifier = 65536;
		ClientImpl.prototype.connectOptions = null;
		ClientImpl.prototype.hostIndex = null;
		ClientImpl.prototype.onConnected = null;
		ClientImpl.prototype.onConnectionLost = null;
		ClientImpl.prototype.onMessageDelivered = null;
		ClientImpl.prototype.onMessageArrived = null;
		ClientImpl.prototype.traceFunction = null;
		ClientImpl.prototype._msg_queue = null;
		ClientImpl.prototype._buffered_msg_queue = null;
		ClientImpl.prototype._connectTimeout = null;
		/* The sendPinger monitors how long we allow before we send data to prove to the server that we are alive. */
		ClientImpl.prototype.sendPinger = null;
		/* The receivePinger monitors how long we allow before we require evidence that the server is alive. */
		ClientImpl.prototype.receivePinger = null;
		ClientImpl.prototype._reconnectInterval = 1; // Reconnect Delay, starts at 1 second
		ClientImpl.prototype._reconnecting = false;
		ClientImpl.prototype._reconnectTimeout = null;
		ClientImpl.prototype.disconnectedPublishing = false;
		ClientImpl.prototype.disconnectedBufferSize = 5000;

		ClientImpl.prototype.receiveBuffer = null;

		ClientImpl.prototype._traceBuffer = null;
		ClientImpl.prototype._MAX_TRACE_ENTRIES = 100;

		ClientImpl.prototype.connect = function (connectOptions) {
			var connectOptionsMasked = this._traceMask(connectOptions, "password");
			this._trace("Client.connect", connectOptionsMasked, this.socket, this.connected);

			if (this.connected)
				throw new Error(format(ERROR.INVALID_STATE, ["already connected"]));
			if (this.socket)
				throw new Error(format(ERROR.INVALID_STATE, ["already connected"]));

			if (this._reconnecting) {
			// connect() function is called while reconnect is in progress.
			// Terminate the auto reconnect process to use new connect options.
				this._reconnectTimeout.cancel();
				this._reconnectTimeout = null;
				this._reconnecting = false;
			}

			this.connectOptions = connectOptions;
			this._reconnectInterval = 1;
			this._reconnecting = false;
			if (connectOptions.uris) {
				this.hostIndex = 0;
				this._doConnect(connectOptions.uris[0]);
			} else {
				this._doConnect(this.uri);
			}

		};

		ClientImpl.prototype.subscribe = function (filter, subscribeOptions) {
			this._trace("Client.subscribe", filter, subscribeOptions);

			if (!this.connected)
				throw new Error(format(ERROR.INVALID_STATE, ["not connected"]));

            var wireMessage = new WireMessage(MESSAGE_TYPE.SUBSCRIBE);
            wireMessage.topics = filter.constructor === Array ? filter : [filter];
            if (subscribeOptions.qos === undefined)
                subscribeOptions.qos = 0;
            wireMessage.requestedQos = [];
            for (var i = 0; i < wireMessage.topics.length; i++)
                wireMessage.requestedQos[i] = subscribeOptions.qos;

			if (subscribeOptions.onSuccess) {
				wireMessage.onSuccess = function(grantedQos) {subscribeOptions.onSuccess({invocationContext:subscribeOptions.invocationContext,grantedQos:grantedQos});};
			}

			if (subscribeOptions.onFailure) {
				wireMessage.onFailure = function(errorCode) {subscribeOptions.onFailure({invocationContext:subscribeOptions.invocationContext,errorCode:errorCode, errorMessage:format(errorCode)});};
			}

			if (subscribeOptions.timeout) {
				wireMessage.timeOut = new Timeout(this, subscribeOptions.timeout, subscribeOptions.onFailure,
					[{invocationContext:subscribeOptions.invocationContext,
						errorCode:ERROR.SUBSCRIBE_TIMEOUT.code,
						errorMessage:format(ERROR.SUBSCRIBE_TIMEOUT)}]);
			}

			// All subscriptions return a SUBACK.
			this._requires_ack(wireMessage);
			this._schedule_message(wireMessage);
		};

		/** @ignore */
		ClientImpl.prototype.unsubscribe = function(filter, unsubscribeOptions) {
			this._trace("Client.unsubscribe", filter, unsubscribeOptions);

			if (!this.connected)
				throw new Error(format(ERROR.INVALID_STATE, ["not connected"]));

            var wireMessage = new WireMessage(MESSAGE_TYPE.UNSUBSCRIBE);
            wireMessage.topics = filter.constructor === Array ? filter : [filter];

			if (unsubscribeOptions.onSuccess) {
				wireMessage.callback = function() {unsubscribeOptions.onSuccess({invocationContext:unsubscribeOptions.invocationContext});};
			}
			if (unsubscribeOptions.timeout) {
				wireMessage.timeOut = new Timeout(this, unsubscribeOptions.timeout, unsubscribeOptions.onFailure,
					[{invocationContext:unsubscribeOptions.invocationContext,
						errorCode:ERROR.UNSUBSCRIBE_TIMEOUT.code,
						errorMessage:format(ERROR.UNSUBSCRIBE_TIMEOUT)}]);
			}

			// All unsubscribes return a SUBACK.
			this._requires_ack(wireMessage);
			this._schedule_message(wireMessage);
		};

		ClientImpl.prototype.send = function (message) {
			this._trace("Client.send", message);

			var wireMessage = new WireMessage(MESSAGE_TYPE.PUBLISH);
			wireMessage.payloadMessage = message;

			if (this.connected) {
			// Mark qos 1 & 2 message as "ACK required"
			// For qos 0 message, invoke onMessageDelivered callback if there is one.
			// Then schedule the message.
				if (message.qos > 0) {
					this._requires_ack(wireMessage);
				} else if (this.onMessageDelivered) {
					this._notify_msg_sent[wireMessage] = this.onMessageDelivered(wireMessage.payloadMessage);
				}
				this._schedule_message(wireMessage);
			} else {
			// Currently disconnected, will not schedule this message
			// Check if reconnecting is in progress and disconnected publish is enabled.
				if (this._reconnecting && this.disconnectedPublishing) {
				// Check the limit which include the "required ACK" messages
					var messageCount = Object.keys(this._sentMessages).length + this._buffered_msg_queue.length;
					if (messageCount > this.disconnectedBufferSize) {
						throw new Error(format(ERROR.BUFFER_FULL, [this.disconnectedBufferSize]));
					} else {
						if (message.qos > 0) {
						// Mark this message as "ACK required"
							this._requires_ack(wireMessage);
						} else {
							wireMessage.sequence = ++this._sequence;
							// Add messages in fifo order to array, by adding to start
							this._buffered_msg_queue.unshift(wireMessage);
						}
					}
				} else {
					throw new Error(format(ERROR.INVALID_STATE, ["not connected"]));
				}
			}
		};

		ClientImpl.prototype.disconnect = function () {
			this._trace("Client.disconnect");

			if (this._reconnecting) {
			// disconnect() function is called while reconnect is in progress.
			// Terminate the auto reconnect process.
				this._reconnectTimeout.cancel();
				this._reconnectTimeout = null;
				this._reconnecting = false;
			}

			if (!this.socket)
				throw new Error(format(ERROR.INVALID_STATE, ["not connecting or connected"]));

			var wireMessage = new WireMessage(MESSAGE_TYPE.DISCONNECT);

			// Run the disconnected call back as soon as the message has been sent,
			// in case of a failure later on in the disconnect processing.
			// as a consequence, the _disconected call back may be run several times.
			this._notify_msg_sent[wireMessage] = scope(this._disconnected, this);

			this._schedule_message(wireMessage);
		};

		ClientImpl.prototype.getTraceLog = function () {
			if ( this._traceBuffer !== null ) {
				this._trace("Client.getTraceLog", new Date());
				this._trace("Client.getTraceLog in flight messages", this._sentMessages.length);
				for (var key in this._sentMessages)
					this._trace("_sentMessages ",key, this._sentMessages[key]);
				for (var key in this._receivedMessages)
					this._trace("_receivedMessages ",key, this._receivedMessages[key]);

				return this._traceBuffer;
			}
		};

		ClientImpl.prototype.startTrace = function () {
			if ( this._traceBuffer === null ) {
				this._traceBuffer = [];
			}
			this._trace("Client.startTrace", new Date(), version);
		};

		ClientImpl.prototype.stopTrace = function () {
			delete this._traceBuffer;
		};

		ClientImpl.prototype._doConnect = function (wsurl) {
		// When the socket is open, this client will send the CONNECT WireMessage using the saved parameters.
			if (this.connectOptions.useSSL) {
				var uriParts = wsurl.split(":");
				uriParts[0] = "wss";
				wsurl = uriParts.join(":");
			}
			this._wsuri = wsurl;
			this.connected = false;



			if (this.connectOptions.mqttVersion < 4) {
				this.socket = new WebSocket(wsurl, ["mqttv3.1"]);
			} else {
				this.socket = new WebSocket(wsurl, ["mqtt"]);
			}
			this.socket.binaryType = "arraybuffer";
			this.socket.onopen = scope(this._on_socket_open, this);
			this.socket.onmessage = scope(this._on_socket_message, this);
			this.socket.onerror = scope(this._on_socket_error, this);
			this.socket.onclose = scope(this._on_socket_close, this);

			this.sendPinger = new Pinger(this, this.connectOptions.keepAliveInterval);
			this.receivePinger = new Pinger(this, this.connectOptions.keepAliveInterval);
			if (this._connectTimeout) {
				this._connectTimeout.cancel();
				this._connectTimeout = null;
			}
			this._connectTimeout = new Timeout(this, this.connectOptions.timeout, this._disconnected,  [ERROR.CONNECT_TIMEOUT.code, format(ERROR.CONNECT_TIMEOUT)]);
		};


		// Schedule a new message to be sent over the WebSockets
		// connection. CONNECT messages cause WebSocket connection
		// to be started. All other messages are queued internally
		// until this has happened. When WS connection starts, process
		// all outstanding messages.
		ClientImpl.prototype._schedule_message = function (message) {
			// Add messages in fifo order to array, by adding to start
			this._msg_queue.unshift(message);
			// Process outstanding messages in the queue if we have an  open socket, and have received CONNACK.
			if (this.connected) {
				this._process_queue();
			}
		};

		ClientImpl.prototype.store = function(prefix, wireMessage) {
			var storedMessage = {type:wireMessage.type, messageIdentifier:wireMessage.messageIdentifier, version:1};

			switch(wireMessage.type) {
			case MESSAGE_TYPE.PUBLISH:
				if(wireMessage.pubRecReceived)
					storedMessage.pubRecReceived = true;

				// Convert the payload to a hex string.
				storedMessage.payloadMessage = {};
				var hex = "";
				var messageBytes = wireMessage.payloadMessage.payloadBytes;
				for (var i=0; i<messageBytes.length; i++) {
					if (messageBytes[i] <= 0xF)
						hex = hex+"0"+messageBytes[i].toString(16);
					else
						hex = hex+messageBytes[i].toString(16);
				}
				storedMessage.payloadMessage.payloadHex = hex;

				storedMessage.payloadMessage.qos = wireMessage.payloadMessage.qos;
				storedMessage.payloadMessage.destinationName = wireMessage.payloadMessage.destinationName;
				if (wireMessage.payloadMessage.duplicate)
					storedMessage.payloadMessage.duplicate = true;
				if (wireMessage.payloadMessage.retained)
					storedMessage.payloadMessage.retained = true;

				// Add a sequence number to sent messages.
				if ( prefix.indexOf("Sent:") === 0 ) {
					if ( wireMessage.sequence === undefined )
						wireMessage.sequence = ++this._sequence;
					storedMessage.sequence = wireMessage.sequence;
				}
				break;

			default:
				throw Error(format(ERROR.INVALID_STORED_DATA, [prefix+this._localKey+wireMessage.messageIdentifier, storedMessage]));
			}
			localStorage.setItem(prefix+this._localKey+wireMessage.messageIdentifier, JSON.stringify(storedMessage));
		};

		ClientImpl.prototype.restore = function(key) {
			var value = localStorage.getItem(key);
			var storedMessage = JSON.parse(value);

			var wireMessage = new WireMessage(storedMessage.type, storedMessage);

			switch(storedMessage.type) {
			case MESSAGE_TYPE.PUBLISH:
				// Replace the payload message with a Message object.
				var hex = storedMessage.payloadMessage.payloadHex;
				var buffer = new ArrayBuffer((hex.length)/2);
				var byteStream = new Uint8Array(buffer);
				var i = 0;
				while (hex.length >= 2) {
					var x = parseInt(hex.substring(0, 2), 16);
					hex = hex.substring(2, hex.length);
					byteStream[i++] = x;
				}
				var payloadMessage = new Message(byteStream);

				payloadMessage.qos = storedMessage.payloadMessage.qos;
				payloadMessage.destinationName = storedMessage.payloadMessage.destinationName;
				if (storedMessage.payloadMessage.duplicate)
					payloadMessage.duplicate = true;
				if (storedMessage.payloadMessage.retained)
					payloadMessage.retained = true;
				wireMessage.payloadMessage = payloadMessage;

				break;

			default:
				throw Error(format(ERROR.INVALID_STORED_DATA, [key, value]));
			}

			if (key.indexOf("Sent:"+this._localKey) === 0) {
				wireMessage.payloadMessage.duplicate = true;
				this._sentMessages[wireMessage.messageIdentifier] = wireMessage;
			} else if (key.indexOf("Received:"+this._localKey) === 0) {
				this._receivedMessages[wireMessage.messageIdentifier] = wireMessage;
			}
		};

		ClientImpl.prototype._process_queue = function () {
			var message = null;

			// Send all queued messages down socket connection
			while ((message = this._msg_queue.pop())) {
				this._socket_send(message);
				// Notify listeners that message was successfully sent
				if (this._notify_msg_sent[message]) {
					this._notify_msg_sent[message]();
					delete this._notify_msg_sent[message];
				}
			}
		};

		/**
	 * Expect an ACK response for this message. Add message to the set of in progress
	 * messages and set an unused identifier in this message.
	 * @ignore
	 */
		ClientImpl.prototype._requires_ack = function (wireMessage) {
			var messageCount = Object.keys(this._sentMessages).length;
			if (messageCount > this.maxMessageIdentifier)
				throw Error ("Too many messages:"+messageCount);

			while(this._sentMessages[this._message_identifier] !== undefined) {
				this._message_identifier++;
			}
			wireMessage.messageIdentifier = this._message_identifier;
			this._sentMessages[wireMessage.messageIdentifier] = wireMessage;
			if (wireMessage.type === MESSAGE_TYPE.PUBLISH) {
				this.store("Sent:", wireMessage);
			}
			if (this._message_identifier === this.maxMessageIdentifier) {
				this._message_identifier = 1;
			}
		};

		/**
	 * Called when the underlying websocket has been opened.
	 * @ignore
	 */
		ClientImpl.prototype._on_socket_open = function () {
		// Create the CONNECT message object.
			var wireMessage = new WireMessage(MESSAGE_TYPE.CONNECT, this.connectOptions);
			wireMessage.clientId = this.clientId;
			this._socket_send(wireMessage);
		};

		/**
	 * Called when the underlying websocket has received a complete packet.
	 * @ignore
	 */
		ClientImpl.prototype._on_socket_message = function (event) {
			this._trace("Client._on_socket_message", event.data);
			var messages = this._deframeMessages(event.data);
			for (var i = 0; i < messages.length; i+=1) {
				this._handleMessage(messages[i]);
			}
		};

		ClientImpl.prototype._deframeMessages = function(data) {
			var byteArray = new Uint8Array(data);
			var messages = [];
			if (this.receiveBuffer) {
				var newData = new Uint8Array(this.receiveBuffer.length+byteArray.length);
				newData.set(this.receiveBuffer);
				newData.set(byteArray,this.receiveBuffer.length);
				byteArray = newData;
				delete this.receiveBuffer;
			}
			try {
				var offset = 0;
				while(offset < byteArray.length) {
					var result = decodeMessage(byteArray,offset);
					var wireMessage = result[0];
					offset = result[1];
					if (wireMessage !== null) {
						messages.push(wireMessage);
					} else {
						break;
					}
				}
				if (offset < byteArray.length) {
					this.receiveBuffer = byteArray.subarray(offset);
				}
			} catch (error) {
				var errorStack = ((error.hasOwnProperty("stack") == "undefined") ? error.stack.toString() : "No Error Stack Available");
				this._disconnected(ERROR.INTERNAL_ERROR.code , format(ERROR.INTERNAL_ERROR, [error.message,errorStack]));
				return;
			}
			return messages;
		};

		ClientImpl.prototype._handleMessage = function(wireMessage) {

			this._trace("Client._handleMessage", wireMessage);

			try {
				switch(wireMessage.type) {
				case MESSAGE_TYPE.CONNACK:
					this._connectTimeout.cancel();
					if (this._reconnectTimeout)
						this._reconnectTimeout.cancel();

					// If we have started using clean session then clear up the local state.
					if (this.connectOptions.cleanSession) {
						for (var key in this._sentMessages) {
							var sentMessage = this._sentMessages[key];
							localStorage.removeItem("Sent:"+this._localKey+sentMessage.messageIdentifier);
						}
						this._sentMessages = {};

						for (var key in this._receivedMessages) {
							var receivedMessage = this._receivedMessages[key];
							localStorage.removeItem("Received:"+this._localKey+receivedMessage.messageIdentifier);
						}
						this._receivedMessages = {};
					}
					// Client connected and ready for business.
					if (wireMessage.returnCode === 0) {

						this.connected = true;
						// Jump to the end of the list of uris and stop looking for a good host.

						if (this.connectOptions.uris)
							this.hostIndex = this.connectOptions.uris.length;

					} else {
						this._disconnected(ERROR.CONNACK_RETURNCODE.code , format(ERROR.CONNACK_RETURNCODE, [wireMessage.returnCode, CONNACK_RC[wireMessage.returnCode]]));
						break;
					}

					// Resend messages.
					var sequencedMessages = [];
					for (var msgId in this._sentMessages) {
						if (this._sentMessages.hasOwnProperty(msgId))
							sequencedMessages.push(this._sentMessages[msgId]);
					}

					// Also schedule qos 0 buffered messages if any
					if (this._buffered_msg_queue.length > 0) {
						var msg = null;
						while ((msg = this._buffered_msg_queue.pop())) {
							sequencedMessages.push(msg);
							if (this.onMessageDelivered)
								this._notify_msg_sent[msg] = this.onMessageDelivered(msg.payloadMessage);
						}
					}

					// Sort sentMessages into the original sent order.
					var sequencedMessages = sequencedMessages.sort(function(a,b) {return a.sequence - b.sequence;} );
					for (var i=0, len=sequencedMessages.length; i<len; i++) {
						var sentMessage = sequencedMessages[i];
						if (sentMessage.type == MESSAGE_TYPE.PUBLISH && sentMessage.pubRecReceived) {
							var pubRelMessage = new WireMessage(MESSAGE_TYPE.PUBREL, {messageIdentifier:sentMessage.messageIdentifier});
							this._schedule_message(pubRelMessage);
						} else {
							this._schedule_message(sentMessage);
						}
					}

					// Execute the connectOptions.onSuccess callback if there is one.
					// Will also now return if this connection was the result of an automatic
					// reconnect and which URI was successfully connected to.
					if (this.connectOptions.onSuccess) {
						this.connectOptions.onSuccess({invocationContext:this.connectOptions.invocationContext});
					}

					var reconnected = false;
					if (this._reconnecting) {
						reconnected = true;
						this._reconnectInterval = 1;
						this._reconnecting = false;
					}

					// Execute the onConnected callback if there is one.
					this._connected(reconnected, this._wsuri);

					// Process all queued messages now that the connection is established.
					this._process_queue();
					break;

				case MESSAGE_TYPE.PUBLISH:
					this._receivePublish(wireMessage);
					break;

				case MESSAGE_TYPE.PUBACK:
					var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
					// If this is a re flow of a PUBACK after we have restarted receivedMessage will not exist.
					if (sentMessage) {
						delete this._sentMessages[wireMessage.messageIdentifier];
						localStorage.removeItem("Sent:"+this._localKey+wireMessage.messageIdentifier);
						if (this.onMessageDelivered)
							this.onMessageDelivered(sentMessage.payloadMessage);
					}
					break;

				case MESSAGE_TYPE.PUBREC:
					var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
					// If this is a re flow of a PUBREC after we have restarted receivedMessage will not exist.
					if (sentMessage) {
						sentMessage.pubRecReceived = true;
						var pubRelMessage = new WireMessage(MESSAGE_TYPE.PUBREL, {messageIdentifier:wireMessage.messageIdentifier});
						this.store("Sent:", sentMessage);
						this._schedule_message(pubRelMessage);
					}
					break;

				case MESSAGE_TYPE.PUBREL:
					var receivedMessage = this._receivedMessages[wireMessage.messageIdentifier];
					localStorage.removeItem("Received:"+this._localKey+wireMessage.messageIdentifier);
					// If this is a re flow of a PUBREL after we have restarted receivedMessage will not exist.
					if (receivedMessage) {
						this._receiveMessage(receivedMessage);
						delete this._receivedMessages[wireMessage.messageIdentifier];
					}
					// Always flow PubComp, we may have previously flowed PubComp but the server lost it and restarted.
					var pubCompMessage = new WireMessage(MESSAGE_TYPE.PUBCOMP, {messageIdentifier:wireMessage.messageIdentifier});
					this._schedule_message(pubCompMessage);


					break;

				case MESSAGE_TYPE.PUBCOMP:
					var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
					delete this._sentMessages[wireMessage.messageIdentifier];
					localStorage.removeItem("Sent:"+this._localKey+wireMessage.messageIdentifier);
					if (this.onMessageDelivered)
						this.onMessageDelivered(sentMessage.payloadMessage);
					break;

				case MESSAGE_TYPE.SUBACK:
					var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
					if (sentMessage) {
						if(sentMessage.timeOut)
							sentMessage.timeOut.cancel();
						// This will need to be fixed when we add multiple topic support
						if (wireMessage.returnCode[0] === 0x80) {
							if (sentMessage.onFailure) {
								sentMessage.onFailure(wireMessage.returnCode);
							}
						} else if (sentMessage.onSuccess) {
							sentMessage.onSuccess(wireMessage.returnCode);
						}
						delete this._sentMessages[wireMessage.messageIdentifier];
					}
					break;

				case MESSAGE_TYPE.UNSUBACK:
					var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
					if (sentMessage) {
						if (sentMessage.timeOut)
							sentMessage.timeOut.cancel();
						if (sentMessage.callback) {
							sentMessage.callback();
						}
						delete this._sentMessages[wireMessage.messageIdentifier];
					}

					break;

				case MESSAGE_TYPE.PINGRESP:
				/* The sendPinger or receivePinger may have sent a ping, the receivePinger has already been reset. */
					this.sendPinger.reset();
					break;

				case MESSAGE_TYPE.DISCONNECT:
				// Clients do not expect to receive disconnect packets.
					this._disconnected(ERROR.INVALID_MQTT_MESSAGE_TYPE.code , format(ERROR.INVALID_MQTT_MESSAGE_TYPE, [wireMessage.type]));
					break;

				default:
					this._disconnected(ERROR.INVALID_MQTT_MESSAGE_TYPE.code , format(ERROR.INVALID_MQTT_MESSAGE_TYPE, [wireMessage.type]));
				}
			} catch (error) {
				var errorStack = ((error.hasOwnProperty("stack") == "undefined") ? error.stack.toString() : "No Error Stack Available");
				this._disconnected(ERROR.INTERNAL_ERROR.code , format(ERROR.INTERNAL_ERROR, [error.message,errorStack]));
				return;
			}
		};

		/** @ignore */
		ClientImpl.prototype._on_socket_error = function (error) {
			if (!this._reconnecting) {
				this._disconnected(ERROR.SOCKET_ERROR.code , format(ERROR.SOCKET_ERROR, [error.data]));
			}
		};

		/** @ignore */
		ClientImpl.prototype._on_socket_close = function () {
			if (!this._reconnecting) {
				this._disconnected(ERROR.SOCKET_CLOSE.code , format(ERROR.SOCKET_CLOSE));
			}
		};

		/** @ignore */
		ClientImpl.prototype._socket_send = function (wireMessage) {

			if (wireMessage.type == 1) {
				var wireMessageMasked = this._traceMask(wireMessage, "password");
				this._trace("Client._socket_send", wireMessageMasked);
			}
			else this._trace("Client._socket_send", wireMessage);

			this.socket.send(wireMessage.encode());
			/* We have proved to the server we are alive. */
			this.sendPinger.reset();
		};

		/** @ignore */
		ClientImpl.prototype._receivePublish = function (wireMessage) {
			switch(wireMessage.payloadMessage.qos) {
			case "undefined":
			case 0:
				this._receiveMessage(wireMessage);
				break;

			case 1:
				var pubAckMessage = new WireMessage(MESSAGE_TYPE.PUBACK, {messageIdentifier:wireMessage.messageIdentifier});
				this._schedule_message(pubAckMessage);
				this._receiveMessage(wireMessage);
				break;

			case 2:
				this._receivedMessages[wireMessage.messageIdentifier] = wireMessage;
				this.store("Received:", wireMessage);
				var pubRecMessage = new WireMessage(MESSAGE_TYPE.PUBREC, {messageIdentifier:wireMessage.messageIdentifier});
				this._schedule_message(pubRecMessage);

				break;

			default:
				throw Error("Invaild qos=" + wireMessage.payloadMessage.qos);
			}
		};

		/** @ignore */
		ClientImpl.prototype._receiveMessage = function (wireMessage) {
			if (this.onMessageArrived) {
				this.onMessageArrived(wireMessage.payloadMessage);
			}
		};

		/**
	 * Client has connected.
	 * @param {reconnect} [boolean] indicate if this was a result of reconnect operation.
	 * @param {uri} [string] fully qualified WebSocket URI of the server.
	 */
		ClientImpl.prototype._connected = function (reconnect, uri) {
		// Execute the onConnected callback if there is one.
			if (this.onConnected)
				this.onConnected(reconnect, uri);
		};

		/**
	 * Attempts to reconnect the client to the server.
   * For each reconnect attempt, will double the reconnect interval
   * up to 128 seconds.
	 */
		ClientImpl.prototype._reconnect = function () {
			this._trace("Client._reconnect");
			if (!this.connected) {
				this._reconnecting = true;
				this.sendPinger.cancel();
				this.receivePinger.cancel();
				if (this._reconnectInterval < 128)
					this._reconnectInterval = this._reconnectInterval * 2;
				if (this.connectOptions.uris) {
					this.hostIndex = 0;
					this._doConnect(this.connectOptions.uris[0]);
				} else {
					this._doConnect(this.uri);
				}
			}
		};

		/**
	 * Client has disconnected either at its own request or because the server
	 * or network disconnected it. Remove all non-durable state.
	 * @param {errorCode} [number] the error number.
	 * @param {errorText} [string] the error text.
	 * @ignore
	 */
		ClientImpl.prototype._disconnected = function (errorCode, errorText) {
			this._trace("Client._disconnected", errorCode, errorText);

			if (errorCode !== undefined && this._reconnecting) {
				//Continue automatic reconnect process
				this._reconnectTimeout = new Timeout(this, this._reconnectInterval, this._reconnect);
				return;
			}

			this.sendPinger.cancel();
			this.receivePinger.cancel();
			if (this._connectTimeout) {
				this._connectTimeout.cancel();
				this._connectTimeout = null;
			}

			// Clear message buffers.
			this._msg_queue = [];
			this._buffered_msg_queue = [];
			this._notify_msg_sent = {};

			if (this.socket) {
			// Cancel all socket callbacks so that they cannot be driven again by this socket.
				this.socket.onopen = null;
				this.socket.onmessage = null;
				this.socket.onerror = null;
				this.socket.onclose = null;
				if (this.socket.readyState === 1)
					this.socket.close();
				delete this.socket;
			}

			if (this.connectOptions.uris && this.hostIndex < this.connectOptions.uris.length-1) {
			// Try the next host.
				this.hostIndex++;
				this._doConnect(this.connectOptions.uris[this.hostIndex]);
			} else {

				if (errorCode === undefined) {
					errorCode = ERROR.OK.code;
					errorText = format(ERROR.OK);
				}

				// Run any application callbacks last as they may attempt to reconnect and hence create a new socket.
				if (this.connected) {
					this.connected = false;
					// Execute the connectionLostCallback if there is one, and we were connected.
					if (this.onConnectionLost) {
						this.onConnectionLost({errorCode:errorCode, errorMessage:errorText, reconnect:this.connectOptions.reconnect, uri:this._wsuri});
					}
					if (errorCode !== ERROR.OK.code && this.connectOptions.reconnect) {
					// Start automatic reconnect process for the very first time since last successful connect.
						this._reconnectInterval = 1;
						this._reconnect();
						return;
					}
				} else {
				// Otherwise we never had a connection, so indicate that the connect has failed.
					if (this.connectOptions.mqttVersion === 4 && this.connectOptions.mqttVersionExplicit === false) {
						this._trace("Failed to connect V4, dropping back to V3");
						this.connectOptions.mqttVersion = 3;
						if (this.connectOptions.uris) {
							this.hostIndex = 0;
							this._doConnect(this.connectOptions.uris[0]);
						} else {
							this._doConnect(this.uri);
						}
					} else if(this.connectOptions.onFailure) {
						this.connectOptions.onFailure({invocationContext:this.connectOptions.invocationContext, errorCode:errorCode, errorMessage:errorText});
					}
				}
			}
		};

		/** @ignore */
		ClientImpl.prototype._trace = function () {
		// Pass trace message back to client's callback function
			if (this.traceFunction) {
				var args = Array.prototype.slice.call(arguments);
				for (var i in args)
				{
					if (typeof args[i] !== "undefined")
						args.splice(i, 1, JSON.stringify(args[i]));
				}
				var record = args.join("");
				this.traceFunction ({severity: "Debug", message: record	});
			}

			//buffer style trace
			if ( this._traceBuffer !== null ) {
				for (var i = 0, max = arguments.length; i < max; i++) {
					if ( this._traceBuffer.length == this._MAX_TRACE_ENTRIES ) {
						this._traceBuffer.shift();
					}
					if (i === 0) this._traceBuffer.push(arguments[i]);
					else if (typeof arguments[i] === "undefined" ) this._traceBuffer.push(arguments[i]);
					else this._traceBuffer.push("  "+JSON.stringify(arguments[i]));
				}
			}
		};

		/** @ignore */
		ClientImpl.prototype._traceMask = function (traceObject, masked) {
			var traceObjectMasked = {};
			for (var attr in traceObject) {
				if (traceObject.hasOwnProperty(attr)) {
					if (attr == masked)
						traceObjectMasked[attr] = "******";
					else
						traceObjectMasked[attr] = traceObject[attr];
				}
			}
			return traceObjectMasked;
		};

		// ------------------------------------------------------------------------
		// Public Programming interface.
		// ------------------------------------------------------------------------

		/**
	 * The JavaScript application communicates to the server using a {@link Paho.Client} object.
	 * <p>
	 * Most applications will create just one Client object and then call its connect() method,
	 * however applications can create more than one Client object if they wish.
	 * In this case the combination of host, port and clientId attributes must be different for each Client object.
	 * <p>
	 * The send, subscribe and unsubscribe methods are implemented as asynchronous JavaScript methods
	 * (even though the underlying protocol exchange might be synchronous in nature).
	 * This means they signal their completion by calling back to the application,
	 * via Success or Failure callback functions provided by the application on the method in question.
	 * Such callbacks are called at most once per method invocation and do not persist beyond the lifetime
	 * of the script that made the invocation.
	 * <p>
	 * In contrast there are some callback functions, most notably <i>onMessageArrived</i>,
	 * that are defined on the {@link Paho.Client} object.
	 * These may get called multiple times, and aren't directly related to specific method invocations made by the client.
	 *
	 * @name Paho.Client
	 *
	 * @constructor
	 *
	 * @param {string} host - the address of the messaging server, as a fully qualified WebSocket URI, as a DNS name or dotted decimal IP address.
	 * @param {number} port - the port number to connect to - only required if host is not a URI
	 * @param {string} path - the path on the host to connect to - only used if host is not a URI. Default: '/mqtt'.
	 * @param {string} clientId - the Messaging client identifier, between 1 and 23 characters in length.
	 *
	 * @property {string} host - <i>read only</i> the server's DNS hostname or dotted decimal IP address.
	 * @property {number} port - <i>read only</i> the server's port.
	 * @property {string} path - <i>read only</i> the server's path.
	 * @property {string} clientId - <i>read only</i> used when connecting to the server.
	 * @property {function} onConnectionLost - called when a connection has been lost.
	 *                            after a connect() method has succeeded.
	 *                            Establish the call back used when a connection has been lost. The connection may be
	 *                            lost because the client initiates a disconnect or because the server or network
	 *                            cause the client to be disconnected. The disconnect call back may be called without
	 *                            the connectionComplete call back being invoked if, for example the client fails to
	 *                            connect.
	 *                            A single response object parameter is passed to the onConnectionLost callback containing the following fields:
	 *                            <ol>
	 *                            <li>errorCode
	 *                            <li>errorMessage
	 *                            </ol>
	 * @property {function} onMessageDelivered - called when a message has been delivered.
	 *                            All processing that this Client will ever do has been completed. So, for example,
	 *                            in the case of a Qos=2 message sent by this client, the PubComp flow has been received from the server
	 *                            and the message has been removed from persistent storage before this callback is invoked.
	 *                            Parameters passed to the onMessageDelivered callback are:
	 *                            <ol>
	 *                            <li>{@link Paho.Message} that was delivered.
	 *                            </ol>
	 * @property {function} onMessageArrived - called when a message has arrived in this Paho.client.
	 *                            Parameters passed to the onMessageArrived callback are:
	 *                            <ol>
	 *                            <li>{@link Paho.Message} that has arrived.
	 *                            </ol>
	 * @property {function} onConnected - called when a connection is successfully made to the server.
	 *                                  after a connect() method.
	 *                                  Parameters passed to the onConnected callback are:
	 *                                  <ol>
	 *                                  <li>reconnect (boolean) - If true, the connection was the result of a reconnect.</li>
	 *                                  <li>URI (string) - The URI used to connect to the server.</li>
	 *                                  </ol>
	 * @property {boolean} disconnectedPublishing - if set, will enable disconnected publishing in
	 *                                            in the event that the connection to the server is lost.
	 * @property {number} disconnectedBufferSize - Used to set the maximum number of messages that the disconnected
	 *                                             buffer will hold before rejecting new messages. Default size: 5000 messages
	 * @property {function} trace - called whenever trace is called. TODO
	 */
		var Client = function (host, port, path, clientId) {

			var uri;

			if (typeof host !== "string")
				throw new Error(format(ERROR.INVALID_TYPE, [typeof host, "host"]));

			if (arguments.length == 2) {
			// host: must be full ws:// uri
			// port: clientId
				clientId = port;
				uri = host;
				var match = uri.match(/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/);
				if (match) {
					host = match[4]||match[2];
					port = parseInt(match[7]);
					path = match[8];
				} else {
					throw new Error(format(ERROR.INVALID_ARGUMENT,[host,"host"]));
				}
			} else {
				if (arguments.length == 3) {
					clientId = path;
					path = "/mqtt";
				}
				if (typeof port !== "number" || port < 0)
					throw new Error(format(ERROR.INVALID_TYPE, [typeof port, "port"]));
				if (typeof path !== "string")
					throw new Error(format(ERROR.INVALID_TYPE, [typeof path, "path"]));

				var ipv6AddSBracket = (host.indexOf(":") !== -1 && host.slice(0,1) !== "[" && host.slice(-1) !== "]");
				uri = "ws://"+(ipv6AddSBracket?"["+host+"]":host)+":"+port+path;
			}

			var clientIdLength = 0;
			for (var i = 0; i<clientId.length; i++) {
				var charCode = clientId.charCodeAt(i);
				if (0xD800 <= charCode && charCode <= 0xDBFF)  {
					i++; // Surrogate pair.
				}
				clientIdLength++;
			}
			if (typeof clientId !== "string" || clientIdLength > 65535)
				throw new Error(format(ERROR.INVALID_ARGUMENT, [clientId, "clientId"]));

			var client = new ClientImpl(uri, host, port, path, clientId);

			//Public Properties
			Object.defineProperties(this,{
				"host":{
					get: function() { return host; },
					set: function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); }
				},
				"port":{
					get: function() { return port; },
					set: function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); }
				},
				"path":{
					get: function() { return path; },
					set: function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); }
				},
				"uri":{
					get: function() { return uri; },
					set: function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); }
				},
				"clientId":{
					get: function() { return client.clientId; },
					set: function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); }
				},
				"onConnected":{
					get: function() { return client.onConnected; },
					set: function(newOnConnected) {
						if (typeof newOnConnected === "function")
							client.onConnected = newOnConnected;
						else
							throw new Error(format(ERROR.INVALID_TYPE, [typeof newOnConnected, "onConnected"]));
					}
				},
				"disconnectedPublishing":{
					get: function() { return client.disconnectedPublishing; },
					set: function(newDisconnectedPublishing) {
						client.disconnectedPublishing = newDisconnectedPublishing;
					}
				},
				"disconnectedBufferSize":{
					get: function() { return client.disconnectedBufferSize; },
					set: function(newDisconnectedBufferSize) {
						client.disconnectedBufferSize = newDisconnectedBufferSize;
					}
				},
				"onConnectionLost":{
					get: function() { return client.onConnectionLost; },
					set: function(newOnConnectionLost) {
						if (typeof newOnConnectionLost === "function")
							client.onConnectionLost = newOnConnectionLost;
						else
							throw new Error(format(ERROR.INVALID_TYPE, [typeof newOnConnectionLost, "onConnectionLost"]));
					}
				},
				"onMessageDelivered":{
					get: function() { return client.onMessageDelivered; },
					set: function(newOnMessageDelivered) {
						if (typeof newOnMessageDelivered === "function")
							client.onMessageDelivered = newOnMessageDelivered;
						else
							throw new Error(format(ERROR.INVALID_TYPE, [typeof newOnMessageDelivered, "onMessageDelivered"]));
					}
				},
				"onMessageArrived":{
					get: function() { return client.onMessageArrived; },
					set: function(newOnMessageArrived) {
						if (typeof newOnMessageArrived === "function")
							client.onMessageArrived = newOnMessageArrived;
						else
							throw new Error(format(ERROR.INVALID_TYPE, [typeof newOnMessageArrived, "onMessageArrived"]));
					}
				},
				"trace":{
					get: function() { return client.traceFunction; },
					set: function(trace) {
						if(typeof trace === "function"){
							client.traceFunction = trace;
						}else{
							throw new Error(format(ERROR.INVALID_TYPE, [typeof trace, "onTrace"]));
						}
					}
				},
			});

			/**
		 * Connect this Messaging client to its server.
		 *
		 * @name Paho.Client#connect
		 * @function
		 * @param {object} connectOptions - Attributes used with the connection.
		 * @param {number} connectOptions.timeout - If the connect has not succeeded within this
		 *                    number of seconds, it is deemed to have failed.
		 *                    The default is 30 seconds.
		 * @param {string} connectOptions.userName - Authentication username for this connection.
		 * @param {string} connectOptions.password - Authentication password for this connection.
		 * @param {Paho.Message} connectOptions.willMessage - sent by the server when the client
		 *                    disconnects abnormally.
		 * @param {number} connectOptions.keepAliveInterval - the server disconnects this client if
		 *                    there is no activity for this number of seconds.
		 *                    The default value of 60 seconds is assumed if not set.
		 * @param {boolean} connectOptions.cleanSession - if true(default) the client and server
		 *                    persistent state is deleted on successful connect.
		 * @param {boolean} connectOptions.useSSL - if present and true, use an SSL Websocket connection.
		 * @param {object} connectOptions.invocationContext - passed to the onSuccess callback or onFailure callback.
		 * @param {function} connectOptions.onSuccess - called when the connect acknowledgement
		 *                    has been received from the server.
		 * A single response object parameter is passed to the onSuccess callback containing the following fields:
		 * <ol>
		 * <li>invocationContext as passed in to the onSuccess method in the connectOptions.
		 * </ol>
	 * @param {function} connectOptions.onFailure - called when the connect request has failed or timed out.
		 * A single response object parameter is passed to the onFailure callback containing the following fields:
		 * <ol>
		 * <li>invocationContext as passed in to the onFailure method in the connectOptions.
		 * <li>errorCode a number indicating the nature of the error.
		 * <li>errorMessage text describing the error.
		 * </ol>
	 * @param {array} connectOptions.hosts - If present this contains either a set of hostnames or fully qualified
		 * WebSocket URIs (ws://iot.eclipse.org:80/ws), that are tried in order in place
		 * of the host and port paramater on the construtor. The hosts are tried one at at time in order until
		 * one of then succeeds.
	 * @param {array} connectOptions.ports - If present the set of ports matching the hosts. If hosts contains URIs, this property
		 * is not used.
	 * @param {boolean} connectOptions.reconnect - Sets whether the client will automatically attempt to reconnect
	 * to the server if the connection is lost.
	 *<ul>
	 *<li>If set to false, the client will not attempt to automatically reconnect to the server in the event that the
	 * connection is lost.</li>
	 *<li>If set to true, in the event that the connection is lost, the client will attempt to reconnect to the server.
	 * It will initially wait 1 second before it attempts to reconnect, for every failed reconnect attempt, the delay
	 * will double until it is at 2 minutes at which point the delay will stay at 2 minutes.</li>
	 *</ul>
	 * @param {number} connectOptions.mqttVersion - The version of MQTT to use to connect to the MQTT Broker.
	 *<ul>
	 *<li>3 - MQTT V3.1</li>
	 *<li>4 - MQTT V3.1.1</li>
	 *</ul>
	 * @param {boolean} connectOptions.mqttVersionExplicit - If set to true, will force the connection to use the
	 * selected MQTT Version or will fail to connect.
	 * @param {array} connectOptions.uris - If present, should contain a list of fully qualified WebSocket uris
	 * (e.g. ws://iot.eclipse.org:80/ws), that are tried in order in place of the host and port parameter of the construtor.
	 * The uris are tried one at a time in order until one of them succeeds. Do not use this in conjunction with hosts as
	 * the hosts array will be converted to uris and will overwrite this property.
		 * @throws {InvalidState} If the client is not in disconnected state. The client must have received connectionLost
		 * or disconnected before calling connect for a second or subsequent time.
		 */
			this.connect = function (connectOptions) {
				connectOptions = connectOptions || {} ;
				validate(connectOptions,  {timeout:"number",
					userName:"string",
					password:"string",
					willMessage:"object",
					keepAliveInterval:"number",
					cleanSession:"boolean",
					useSSL:"boolean",
					invocationContext:"object",
					onSuccess:"function",
					onFailure:"function",
					hosts:"object",
					ports:"object",
					reconnect:"boolean",
					mqttVersion:"number",
					mqttVersionExplicit:"boolean",
					uris: "object"});

				// If no keep alive interval is set, assume 60 seconds.
				if (connectOptions.keepAliveInterval === undefined)
					connectOptions.keepAliveInterval = 60;

				if (connectOptions.mqttVersion > 4 || connectOptions.mqttVersion < 3) {
					throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.mqttVersion, "connectOptions.mqttVersion"]));
				}

				if (connectOptions.mqttVersion === undefined) {
					connectOptions.mqttVersionExplicit = false;
					connectOptions.mqttVersion = 4;
				} else {
					connectOptions.mqttVersionExplicit = true;
				}

				//Check that if password is set, so is username
				if (connectOptions.password !== undefined && connectOptions.userName === undefined)
					throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.password, "connectOptions.password"]));

				if (connectOptions.willMessage) {
					if (!(connectOptions.willMessage instanceof Message))
						throw new Error(format(ERROR.INVALID_TYPE, [connectOptions.willMessage, "connectOptions.willMessage"]));
					// The will message must have a payload that can be represented as a string.
					// Cause the willMessage to throw an exception if this is not the case.
					connectOptions.willMessage.stringPayload = null;

					if (typeof connectOptions.willMessage.destinationName === "undefined")
						throw new Error(format(ERROR.INVALID_TYPE, [typeof connectOptions.willMessage.destinationName, "connectOptions.willMessage.destinationName"]));
				}
				if (typeof connectOptions.cleanSession === "undefined")
					connectOptions.cleanSession = true;
				if (connectOptions.hosts) {

					if (!(connectOptions.hosts instanceof Array) )
						throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.hosts, "connectOptions.hosts"]));
					if (connectOptions.hosts.length <1 )
						throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.hosts, "connectOptions.hosts"]));

					var usingURIs = false;
					for (var i = 0; i<connectOptions.hosts.length; i++) {
						if (typeof connectOptions.hosts[i] !== "string")
							throw new Error(format(ERROR.INVALID_TYPE, [typeof connectOptions.hosts[i], "connectOptions.hosts["+i+"]"]));
						if (/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/.test(connectOptions.hosts[i])) {
							if (i === 0) {
								usingURIs = true;
							} else if (!usingURIs) {
								throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.hosts[i], "connectOptions.hosts["+i+"]"]));
							}
						} else if (usingURIs) {
							throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.hosts[i], "connectOptions.hosts["+i+"]"]));
						}
					}

					if (!usingURIs) {
						if (!connectOptions.ports)
							throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.ports, "connectOptions.ports"]));
						if (!(connectOptions.ports instanceof Array) )
							throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.ports, "connectOptions.ports"]));
						if (connectOptions.hosts.length !== connectOptions.ports.length)
							throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.ports, "connectOptions.ports"]));

						connectOptions.uris = [];

						for (var i = 0; i<connectOptions.hosts.length; i++) {
							if (typeof connectOptions.ports[i] !== "number" || connectOptions.ports[i] < 0)
								throw new Error(format(ERROR.INVALID_TYPE, [typeof connectOptions.ports[i], "connectOptions.ports["+i+"]"]));
							var host = connectOptions.hosts[i];
							var port = connectOptions.ports[i];

							var ipv6 = (host.indexOf(":") !== -1);
							uri = "ws://"+(ipv6?"["+host+"]":host)+":"+port+path;
							connectOptions.uris.push(uri);
						}
					} else {
						connectOptions.uris = connectOptions.hosts;
					}
				}

				client.connect(connectOptions);
			};

			/**
		 * Subscribe for messages, request receipt of a copy of messages sent to the destinations described by the filter.
		 *
		 * @name Paho.Client#subscribe
		 * @function
		 * @param {string} filter describing the destinations to receive messages from.
		 * <br>
		 * @param {object} subscribeOptions - used to control the subscription
		 *
		 * @param {number} subscribeOptions.qos - the maximum qos of any publications sent
		 *                                  as a result of making this subscription.
		 * @param {object} subscribeOptions.invocationContext - passed to the onSuccess callback
		 *                                  or onFailure callback.
		 * @param {function} subscribeOptions.onSuccess - called when the subscribe acknowledgement
		 *                                  has been received from the server.
		 *                                  A single response object parameter is passed to the onSuccess callback containing the following fields:
		 *                                  <ol>
		 *                                  <li>invocationContext if set in the subscribeOptions.
		 *                                  </ol>
		 * @param {function} subscribeOptions.onFailure - called when the subscribe request has failed or timed out.
		 *                                  A single response object parameter is passed to the onFailure callback containing the following fields:
		 *                                  <ol>
		 *                                  <li>invocationContext - if set in the subscribeOptions.
		 *                                  <li>errorCode - a number indicating the nature of the error.
		 *                                  <li>errorMessage - text describing the error.
		 *                                  </ol>
		 * @param {number} subscribeOptions.timeout - which, if present, determines the number of
		 *                                  seconds after which the onFailure calback is called.
		 *                                  The presence of a timeout does not prevent the onSuccess
		 *                                  callback from being called when the subscribe completes.
		 * @throws {InvalidState} if the client is not in connected state.
		 */
			this.subscribe = function (filter, subscribeOptions) {
				if (typeof filter !== "string" && filter.constructor !== Array)
					throw new Error("Invalid argument:"+filter);
				subscribeOptions = subscribeOptions || {} ;
				validate(subscribeOptions,  {qos:"number",
					invocationContext:"object",
					onSuccess:"function",
					onFailure:"function",
					timeout:"number"
				});
				if (subscribeOptions.timeout && !subscribeOptions.onFailure)
					throw new Error("subscribeOptions.timeout specified with no onFailure callback.");
				if (typeof subscribeOptions.qos !== "undefined" && !(subscribeOptions.qos === 0 || subscribeOptions.qos === 1 || subscribeOptions.qos === 2 ))
					throw new Error(format(ERROR.INVALID_ARGUMENT, [subscribeOptions.qos, "subscribeOptions.qos"]));
				client.subscribe(filter, subscribeOptions);
			};

		/**
		 * Unsubscribe for messages, stop receiving messages sent to destinations described by the filter.
		 *
		 * @name Paho.Client#unsubscribe
		 * @function
		 * @param {string} filter - describing the destinations to receive messages from.
		 * @param {object} unsubscribeOptions - used to control the subscription
		 * @param {object} unsubscribeOptions.invocationContext - passed to the onSuccess callback
											  or onFailure callback.
		 * @param {function} unsubscribeOptions.onSuccess - called when the unsubscribe acknowledgement has been received from the server.
		 *                                    A single response object parameter is passed to the
		 *                                    onSuccess callback containing the following fields:
		 *                                    <ol>
		 *                                    <li>invocationContext - if set in the unsubscribeOptions.
		 *                                    </ol>
		 * @param {function} unsubscribeOptions.onFailure called when the unsubscribe request has failed or timed out.
		 *                                    A single response object parameter is passed to the onFailure callback containing the following fields:
		 *                                    <ol>
		 *                                    <li>invocationContext - if set in the unsubscribeOptions.
		 *                                    <li>errorCode - a number indicating the nature of the error.
		 *                                    <li>errorMessage - text describing the error.
		 *                                    </ol>
		 * @param {number} unsubscribeOptions.timeout - which, if present, determines the number of seconds
		 *                                    after which the onFailure callback is called. The presence of
		 *                                    a timeout does not prevent the onSuccess callback from being
		 *                                    called when the unsubscribe completes
		 * @throws {InvalidState} if the client is not in connected state.
		 */
			this.unsubscribe = function (filter, unsubscribeOptions) {
				if (typeof filter !== "string" && filter.constructor !== Array)
					throw new Error("Invalid argument:"+filter);
				unsubscribeOptions = unsubscribeOptions || {} ;
				validate(unsubscribeOptions,  {invocationContext:"object",
					onSuccess:"function",
					onFailure:"function",
					timeout:"number"
				});
				if (unsubscribeOptions.timeout && !unsubscribeOptions.onFailure)
					throw new Error("unsubscribeOptions.timeout specified with no onFailure callback.");
				client.unsubscribe(filter, unsubscribeOptions);
			};

			/**
		 * Send a message to the consumers of the destination in the Message.
		 *
		 * @name Paho.Client#send
		 * @function
		 * @param {string|Paho.Message} topic - <b>mandatory</b> The name of the destination to which the message is to be sent.
		 * 					   - If it is the only parameter, used as Paho.Message object.
		 * @param {String|ArrayBuffer} payload - The message data to be sent.
		 * @param {number} qos The Quality of Service used to deliver the message.
		 * 		<dl>
		 * 			<dt>0 Best effort (default).
		 *     			<dt>1 At least once.
		 *     			<dt>2 Exactly once.
		 * 		</dl>
		 * @param {Boolean} retained If true, the message is to be retained by the server and delivered
		 *                     to both current and future subscriptions.
		 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
		 *                     A received message has the retained boolean set to true if the message was published
		 *                     with the retained boolean set to true
		 *                     and the subscrption was made after the message has been published.
		 * @throws {InvalidState} if the client is not connected.
		 */
			this.send = function (topic,payload,qos,retained) {
				var message ;

				if(arguments.length === 0){
					throw new Error("Invalid argument."+"length");

				}else if(arguments.length == 1) {

					if (!(topic instanceof Message) && (typeof topic !== "string"))
						throw new Error("Invalid argument:"+ typeof topic);

					message = topic;
					if (typeof message.destinationName === "undefined")
						throw new Error(format(ERROR.INVALID_ARGUMENT,[message.destinationName,"Message.destinationName"]));
					client.send(message);

				}else {
				//parameter checking in Message object
					message = new Message(payload);
					message.destinationName = topic;
					if(arguments.length >= 3)
						message.qos = qos;
					if(arguments.length >= 4)
						message.retained = retained;
					client.send(message);
				}
			};

			/**
		 * Publish a message to the consumers of the destination in the Message.
		 * Synonym for Paho.Mqtt.Client#send
		 *
		 * @name Paho.Client#publish
		 * @function
		 * @param {string|Paho.Message} topic - <b>mandatory</b> The name of the topic to which the message is to be published.
		 * 					   - If it is the only parameter, used as Paho.Message object.
		 * @param {String|ArrayBuffer} payload - The message data to be published.
		 * @param {number} qos The Quality of Service used to deliver the message.
		 * 		<dl>
		 * 			<dt>0 Best effort (default).
		 *     			<dt>1 At least once.
		 *     			<dt>2 Exactly once.
		 * 		</dl>
		 * @param {Boolean} retained If true, the message is to be retained by the server and delivered
		 *                     to both current and future subscriptions.
		 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
		 *                     A received message has the retained boolean set to true if the message was published
		 *                     with the retained boolean set to true
		 *                     and the subscrption was made after the message has been published.
		 * @throws {InvalidState} if the client is not connected.
		 */
			this.publish = function(topic,payload,qos,retained) {
				var message ;

				if(arguments.length === 0){
					throw new Error("Invalid argument."+"length");

				}else if(arguments.length == 1) {

					if (!(topic instanceof Message) && (typeof topic !== "string"))
						throw new Error("Invalid argument:"+ typeof topic);

					message = topic;
					if (typeof message.destinationName === "undefined")
						throw new Error(format(ERROR.INVALID_ARGUMENT,[message.destinationName,"Message.destinationName"]));
					client.send(message);

				}else {
					//parameter checking in Message object
					message = new Message(payload);
					message.destinationName = topic;
					if(arguments.length >= 3)
						message.qos = qos;
					if(arguments.length >= 4)
						message.retained = retained;
					client.send(message);
				}
			};

			/**
		 * Normal disconnect of this Messaging client from its server.
		 *
		 * @name Paho.Client#disconnect
		 * @function
		 * @throws {InvalidState} if the client is already disconnected.
		 */
			this.disconnect = function () {
				client.disconnect();
			};

			/**
		 * Get the contents of the trace log.
		 *
		 * @name Paho.Client#getTraceLog
		 * @function
		 * @return {Object[]} tracebuffer containing the time ordered trace records.
		 */
			this.getTraceLog = function () {
				return client.getTraceLog();
			};

			/**
		 * Start tracing.
		 *
		 * @name Paho.Client#startTrace
		 * @function
		 */
			this.startTrace = function () {
				client.startTrace();
			};

			/**
		 * Stop tracing.
		 *
		 * @name Paho.Client#stopTrace
		 * @function
		 */
			this.stopTrace = function () {
				client.stopTrace();
			};

			this.isConnected = function() {
				return client.connected;
			};
		};

		/**
	 * An application message, sent or received.
	 * <p>
	 * All attributes may be null, which implies the default values.
	 *
	 * @name Paho.Message
	 * @constructor
	 * @param {String|ArrayBuffer} payload The message data to be sent.
	 * <p>
	 * @property {string} payloadString <i>read only</i> The payload as a string if the payload consists of valid UTF-8 characters.
	 * @property {ArrayBuffer} payloadBytes <i>read only</i> The payload as an ArrayBuffer.
	 * <p>
	 * @property {string} destinationName <b>mandatory</b> The name of the destination to which the message is to be sent
	 *                    (for messages about to be sent) or the name of the destination from which the message has been received.
	 *                    (for messages received by the onMessage function).
	 * <p>
	 * @property {number} qos The Quality of Service used to deliver the message.
	 * <dl>
	 *     <dt>0 Best effort (default).
	 *     <dt>1 At least once.
	 *     <dt>2 Exactly once.
	 * </dl>
	 * <p>
	 * @property {Boolean} retained If true, the message is to be retained by the server and delivered
	 *                     to both current and future subscriptions.
	 *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
	 *                     A received message has the retained boolean set to true if the message was published
	 *                     with the retained boolean set to true
	 *                     and the subscrption was made after the message has been published.
	 * <p>
	 * @property {Boolean} duplicate <i>read only</i> If true, this message might be a duplicate of one which has already been received.
	 *                     This is only set on messages received from the server.
	 *
	 */
		var Message = function (newPayload) {
			var payload;
			if (   typeof newPayload === "string" ||
		newPayload instanceof ArrayBuffer ||
		(ArrayBuffer.isView(newPayload) && !(newPayload instanceof DataView))
			) {
				payload = newPayload;
			} else {
				throw (format(ERROR.INVALID_ARGUMENT, [newPayload, "newPayload"]));
			}

			var destinationName;
			var qos = 0;
			var retained = false;
			var duplicate = false;

			Object.defineProperties(this,{
				"payloadString":{
					enumerable : true,
					get : function () {
						if (typeof payload === "string")
							return payload;
						else
							return parseUTF8(payload, 0, payload.length);
					}
				},
				"payloadBytes":{
					enumerable: true,
					get: function() {
						if (typeof payload === "string") {
							var buffer = new ArrayBuffer(UTF8Length(payload));
							var byteStream = new Uint8Array(buffer);
							stringToUTF8(payload, byteStream, 0);

							return byteStream;
						} else {
							return payload;
						}
					}
				},
				"destinationName":{
					enumerable: true,
					get: function() { return destinationName; },
					set: function(newDestinationName) {
						if (typeof newDestinationName === "string")
							destinationName = newDestinationName;
						else
							throw new Error(format(ERROR.INVALID_ARGUMENT, [newDestinationName, "newDestinationName"]));
					}
				},
				"qos":{
					enumerable: true,
					get: function() { return qos; },
					set: function(newQos) {
						if (newQos === 0 || newQos === 1 || newQos === 2 )
							qos = newQos;
						else
							throw new Error("Invalid argument:"+newQos);
					}
				},
				"retained":{
					enumerable: true,
					get: function() { return retained; },
					set: function(newRetained) {
						if (typeof newRetained === "boolean")
							retained = newRetained;
						else
							throw new Error(format(ERROR.INVALID_ARGUMENT, [newRetained, "newRetained"]));
					}
				},
				"topic":{
					enumerable: true,
					get: function() { return destinationName; },
					set: function(newTopic) {destinationName=newTopic;}
				},
				"duplicate":{
					enumerable: true,
					get: function() { return duplicate; },
					set: function(newDuplicate) {duplicate=newDuplicate;}
				}
			});
		};

		// Module contents.
		return {
			Client: Client,
			Message: Message
		};
	// eslint-disable-next-line no-nested-ternary
	})(typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	return PahoMQTT;
});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 3118 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 3119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.


var asn1 = __webpack_require__(310)

exports.certificate = __webpack_require__(3120)

var RSAPrivateKey = asn1.define('RSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('modulus').int(),
    this.key('publicExponent').int(),
    this.key('privateExponent').int(),
    this.key('prime1').int(),
    this.key('prime2').int(),
    this.key('exponent1').int(),
    this.key('exponent2').int(),
    this.key('coefficient').int()
  )
})
exports.RSAPrivateKey = RSAPrivateKey

var RSAPublicKey = asn1.define('RSAPublicKey', function () {
  this.seq().obj(
    this.key('modulus').int(),
    this.key('publicExponent').int()
  )
})
exports.RSAPublicKey = RSAPublicKey

var PublicKey = asn1.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})
exports.PublicKey = PublicKey

var AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('none').null_().optional(),
    this.key('curve').objid().optional(),
    this.key('params').seq().obj(
      this.key('p').int(),
      this.key('q').int(),
      this.key('g').int()
    ).optional()
  )
})

var PrivateKeyInfo = asn1.define('PrivateKeyInfo', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPrivateKey').octstr()
  )
})
exports.PrivateKey = PrivateKeyInfo
var EncryptedPrivateKeyInfo = asn1.define('EncryptedPrivateKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').seq().obj(
      this.key('id').objid(),
      this.key('decrypt').seq().obj(
        this.key('kde').seq().obj(
          this.key('id').objid(),
          this.key('kdeparams').seq().obj(
            this.key('salt').octstr(),
            this.key('iters').int()
          )
        ),
        this.key('cipher').seq().obj(
          this.key('algo').objid(),
          this.key('iv').octstr()
        )
      )
    ),
    this.key('subjectPrivateKey').octstr()
  )
})

exports.EncryptedPrivateKey = EncryptedPrivateKeyInfo

var DSAPrivateKey = asn1.define('DSAPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('g').int(),
    this.key('pub_key').int(),
    this.key('priv_key').int()
  )
})
exports.DSAPrivateKey = DSAPrivateKey

exports.DSAparam = asn1.define('DSAparam', function () {
  this.int()
})

var ECPrivateKey = asn1.define('ECPrivateKey', function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').optional().explicit(0).use(ECParameters),
    this.key('publicKey').optional().explicit(1).bitstr()
  )
})
exports.ECPrivateKey = ECPrivateKey

var ECParameters = asn1.define('ECParameters', function () {
  this.choice({
    namedCurve: this.objid()
  })
})

exports.signature = asn1.define('signature', function () {
  this.seq().obj(
    this.key('r').int(),
    this.key('s').int()
  )
})


/***/ }),
/* 3120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen



var asn = __webpack_require__(310)

var Time = asn.define('Time', function () {
  this.choice({
    utcTime: this.utctime(),
    generalTime: this.gentime()
  })
})

var AttributeTypeValue = asn.define('AttributeTypeValue', function () {
  this.seq().obj(
    this.key('type').objid(),
    this.key('value').any()
  )
})

var AlgorithmIdentifier = asn.define('AlgorithmIdentifier', function () {
  this.seq().obj(
    this.key('algorithm').objid(),
    this.key('parameters').optional(),
    this.key('curve').objid().optional()
  )
})

var SubjectPublicKeyInfo = asn.define('SubjectPublicKeyInfo', function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('subjectPublicKey').bitstr()
  )
})

var RelativeDistinguishedName = asn.define('RelativeDistinguishedName', function () {
  this.setof(AttributeTypeValue)
})

var RDNSequence = asn.define('RDNSequence', function () {
  this.seqof(RelativeDistinguishedName)
})

var Name = asn.define('Name', function () {
  this.choice({
    rdnSequence: this.use(RDNSequence)
  })
})

var Validity = asn.define('Validity', function () {
  this.seq().obj(
    this.key('notBefore').use(Time),
    this.key('notAfter').use(Time)
  )
})

var Extension = asn.define('Extension', function () {
  this.seq().obj(
    this.key('extnID').objid(),
    this.key('critical').bool().def(false),
    this.key('extnValue').octstr()
  )
})

var TBSCertificate = asn.define('TBSCertificate', function () {
  this.seq().obj(
    this.key('version').explicit(0).int().optional(),
    this.key('serialNumber').int(),
    this.key('signature').use(AlgorithmIdentifier),
    this.key('issuer').use(Name),
    this.key('validity').use(Validity),
    this.key('subject').use(Name),
    this.key('subjectPublicKeyInfo').use(SubjectPublicKeyInfo),
    this.key('issuerUniqueID').implicit(1).bitstr().optional(),
    this.key('subjectUniqueID').implicit(2).bitstr().optional(),
    this.key('extensions').explicit(3).seqof(Extension).optional()
  )
})

var X509Certificate = asn.define('X509Certificate', function () {
  this.seq().obj(
    this.key('tbsCertificate').use(TBSCertificate),
    this.key('signatureAlgorithm').use(AlgorithmIdentifier),
    this.key('signatureValue').bitstr()
  )
})

module.exports = X509Certificate


/***/ }),
/* 3121 */
/***/ (function(module, exports, __webpack_require__) {

// adapted from https://github.com/apatil/pemstrip
var findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m
var startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m
var fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m
var evp = __webpack_require__(435)
var ciphers = __webpack_require__(600)
var Buffer = __webpack_require__(42).Buffer
module.exports = function (okey, password) {
  var key = okey.toString()
  var match = key.match(findProc)
  var decrypted
  if (!match) {
    var match2 = key.match(fullRegex)
    decrypted = new Buffer(match2[2].replace(/[\r\n]/g, ''), 'base64')
  } else {
    var suite = 'aes' + match[1]
    var iv = Buffer.from(match[2], 'hex')
    var cipherText = Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64')
    var cipherKey = evp(password, iv.slice(0, 8), parseInt(match[1], 10)).key
    var out = []
    var cipher = ciphers.createDecipheriv(suite, cipherKey, iv)
    out.push(cipher.update(cipherText))
    out.push(cipher.final())
    decrypted = Buffer.concat(out)
  }
  var tag = key.match(startRegex)[1]
  return {
    tag: tag,
    data: decrypted
  }
}


/***/ }),
/* 3122 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {var checkParameters = __webpack_require__(1390)
var defaultEncoding = __webpack_require__(1389)
var sync = __webpack_require__(1391)
var Buffer = __webpack_require__(42).Buffer

var ZERO_BUF
var subtle = global.crypto && global.crypto.subtle
var toBrowser = {
  'sha': 'SHA-1',
  'sha-1': 'SHA-1',
  'sha1': 'SHA-1',
  'sha256': 'SHA-256',
  'sha-256': 'SHA-256',
  'sha384': 'SHA-384',
  'sha-384': 'SHA-384',
  'sha-512': 'SHA-512',
  'sha512': 'SHA-512'
}
var checks = []
function checkNative (algo) {
  if (global.process && !global.process.browser) {
    return Promise.resolve(false)
  }
  if (!subtle || !subtle.importKey || !subtle.deriveBits) {
    return Promise.resolve(false)
  }
  if (checks[algo] !== undefined) {
    return checks[algo]
  }
  ZERO_BUF = ZERO_BUF || Buffer.alloc(8)
  var prom = browserPbkdf2(ZERO_BUF, ZERO_BUF, 10, 128, algo)
    .then(function () {
      return true
    }).catch(function () {
      return false
    })
  checks[algo] = prom
  return prom
}

function browserPbkdf2 (password, salt, iterations, length, algo) {
  return subtle.importKey(
    'raw', password, {name: 'PBKDF2'}, false, ['deriveBits']
  ).then(function (key) {
    return subtle.deriveBits({
      name: 'PBKDF2',
      salt: salt,
      iterations: iterations,
      hash: {
        name: algo
      }
    }, key, length << 3)
  }).then(function (res) {
    return Buffer.from(res)
  })
}

function resolvePromise (promise, callback) {
  promise.then(function (out) {
    process.nextTick(function () {
      callback(null, out)
    })
  }, function (e) {
    process.nextTick(function () {
      callback(e)
    })
  })
}
module.exports = function (password, salt, iterations, keylen, digest, callback) {
  if (typeof digest === 'function') {
    callback = digest
    digest = undefined
  }

  digest = digest || 'sha1'
  var algo = toBrowser[digest.toLowerCase()]

  if (!algo || typeof global.Promise !== 'function') {
    return process.nextTick(function () {
      var out
      try {
        out = sync(password, salt, iterations, keylen, digest)
      } catch (e) {
        return callback(e)
      }
      callback(null, out)
    })
  }

  checkParameters(password, salt, iterations, keylen)
  if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2')
  if (!Buffer.isBuffer(password)) password = Buffer.from(password, defaultEncoding)
  if (!Buffer.isBuffer(salt)) salt = Buffer.from(salt, defaultEncoding)

  resolvePromise(checkNative(algo).then(function (resp) {
    if (resp) return browserPbkdf2(password, salt, iterations, keylen, algo)

    return sync(password, salt, iterations, keylen, digest)
  }), callback)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56), __webpack_require__(90)))

/***/ }),
/* 3123 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(90)))

/***/ }),
/* 3124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(3125);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 3125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 3126 */
/***/ (function(module, exports, __webpack_require__) {

exports.publicEncrypt = __webpack_require__(3128)
exports.privateDecrypt = __webpack_require__(3127)

exports.privateEncrypt = function privateEncrypt (key, buf) {
  return exports.publicEncrypt(key, buf, true)
}

exports.publicDecrypt = function publicDecrypt (key, buf) {
  return exports.privateDecrypt(key, buf, true)
}


/***/ }),
/* 3127 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(454)
var mgf = __webpack_require__(1392)
var xor = __webpack_require__(1394)
var BN = __webpack_require__(77)
var crt = __webpack_require__(602)
var createHash = __webpack_require__(336)
var withPublic = __webpack_require__(1393)
var Buffer = __webpack_require__(42).Buffer

module.exports = function privateDecrypt (privateKey, enc, reverse) {
  var padding
  if (privateKey.padding) {
    padding = privateKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }

  var key = parseKeys(privateKey)
  var k = key.modulus.byteLength()
  if (enc.length > k || new BN(enc).cmp(key.modulus) >= 0) {
    throw new Error('decryption error')
  }
  var msg
  if (reverse) {
    msg = withPublic(new BN(enc), key)
  } else {
    msg = crt(enc, key)
  }
  var zBuffer = Buffer.alloc(k - msg.length)
  msg = Buffer.concat([zBuffer, msg], k)
  if (padding === 4) {
    return oaep(key, msg)
  } else if (padding === 1) {
    return pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    return msg
  } else {
    throw new Error('unknown padding')
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  if (msg[0] !== 0) {
    throw new Error('decryption error')
  }
  var maskedSeed = msg.slice(1, hLen + 1)
  var maskedDb = msg.slice(hLen + 1)
  var seed = xor(maskedSeed, mgf(maskedDb, hLen))
  var db = xor(maskedDb, mgf(seed, k - hLen - 1))
  if (compare(iHash, db.slice(0, hLen))) {
    throw new Error('decryption error')
  }
  var i = hLen
  while (db[i] === 0) {
    i++
  }
  if (db[i++] !== 1) {
    throw new Error('decryption error')
  }
  return db.slice(i)
}

function pkcs1 (key, msg, reverse) {
  var p1 = msg.slice(0, 2)
  var i = 2
  var status = 0
  while (msg[i++] !== 0) {
    if (i >= msg.length) {
      status++
      break
    }
  }
  var ps = msg.slice(2, i - 1)

  if ((p1.toString('hex') !== '0002' && !reverse) || (p1.toString('hex') !== '0001' && reverse)) {
    status++
  }
  if (ps.length < 8) {
    status++
  }
  if (status) {
    throw new Error('decryption error')
  }
  return msg.slice(i)
}
function compare (a, b) {
  a = Buffer.from(a)
  b = Buffer.from(b)
  var dif = 0
  var len = a.length
  if (a.length !== b.length) {
    dif++
    len = Math.min(a.length, b.length)
  }
  var i = -1
  while (++i < len) {
    dif += (a[i] ^ b[i])
  }
  return dif
}


/***/ }),
/* 3128 */
/***/ (function(module, exports, __webpack_require__) {

var parseKeys = __webpack_require__(454)
var randomBytes = __webpack_require__(286)
var createHash = __webpack_require__(336)
var mgf = __webpack_require__(1392)
var xor = __webpack_require__(1394)
var BN = __webpack_require__(77)
var withPublic = __webpack_require__(1393)
var crt = __webpack_require__(602)
var Buffer = __webpack_require__(42).Buffer

module.exports = function publicEncrypt (publicKey, msg, reverse) {
  var padding
  if (publicKey.padding) {
    padding = publicKey.padding
  } else if (reverse) {
    padding = 1
  } else {
    padding = 4
  }
  var key = parseKeys(publicKey)
  var paddedMsg
  if (padding === 4) {
    paddedMsg = oaep(key, msg)
  } else if (padding === 1) {
    paddedMsg = pkcs1(key, msg, reverse)
  } else if (padding === 3) {
    paddedMsg = new BN(msg)
    if (paddedMsg.cmp(key.modulus) >= 0) {
      throw new Error('data too long for modulus')
    }
  } else {
    throw new Error('unknown padding')
  }
  if (reverse) {
    return crt(paddedMsg, key)
  } else {
    return withPublic(paddedMsg, key)
  }
}

function oaep (key, msg) {
  var k = key.modulus.byteLength()
  var mLen = msg.length
  var iHash = createHash('sha1').update(Buffer.alloc(0)).digest()
  var hLen = iHash.length
  var hLen2 = 2 * hLen
  if (mLen > k - hLen2 - 2) {
    throw new Error('message too long')
  }
  var ps = Buffer.alloc(k - mLen - hLen2 - 2)
  var dblen = k - hLen - 1
  var seed = randomBytes(hLen)
  var maskedDb = xor(Buffer.concat([iHash, ps, Buffer.alloc(1, 1), msg], dblen), mgf(seed, dblen))
  var maskedSeed = xor(seed, mgf(maskedDb, hLen))
  return new BN(Buffer.concat([Buffer.alloc(1), maskedSeed, maskedDb], k))
}
function pkcs1 (key, msg, reverse) {
  var mLen = msg.length
  var k = key.modulus.byteLength()
  if (mLen > k - 11) {
    throw new Error('message too long')
  }
  var ps
  if (reverse) {
    ps = Buffer.alloc(k - mLen - 3, 0xff)
  } else {
    ps = nonZero(k - mLen - 3)
  }
  return new BN(Buffer.concat([Buffer.from([0, reverse ? 1 : 2]), ps, Buffer.alloc(1), msg], k))
}
function nonZero (len) {
  var out = Buffer.allocUnsafe(len)
  var i = 0
  var cache = randomBytes(len * 2)
  var cur = 0
  var num
  while (i < len) {
    if (cur === cache.length) {
      cache = randomBytes(len * 2)
      cur = 0
    }
    num = cache[cur++]
    if (num) {
      out[i++] = num
    }
  }
  return out
}


/***/ }),
/* 3129 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.3.2 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return punycode;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(299)(module), __webpack_require__(56)))

/***/ }),
/* 3130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1395);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) {
        throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');

    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(
        options.delimiter,
        options.throwOnLimitExceeded ? limit + 1 : limit
    );

    if (options.throwOnLimitExceeded && parts.length > limit) {
        throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    }

    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');

            val = utils.maybeMap(
                parseArrayValue(
                    part.slice(pos + 1),
                    options,
                    isArray(obj[key]) ? obj[key].length : 0
                ),
                function (encodedVal) {
                    return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                }
            );
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(String(val));
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        var existing = has.call(obj, key);
        if (existing && options.duplicates === 'combine') {
            obj[key] = utils.combine(obj[key], val);
        } else if (!existing || options.duplicates === 'last') {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }

    var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                ? []
                : utils.combine([], leaf);
        } else {
            obj = options.plainObjects ? { __proto__: null } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while (options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, check strictDepth option for throw, else just add whatever is left

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') {
        throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    }

    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? { __proto__: null } : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? { __proto__: null } : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),
/* 3131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(3498);
var utils = __webpack_require__(1395);
var formats = __webpack_require__(683);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    filter: void undefined,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
            ? key.value
            : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = obj[key];

        if (options.skipNulls && value === null) {
            continue;
        }
        pushToArray(keys, stringify(
            value,
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),
/* 3132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};


/***/ }),
/* 3133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};


/***/ }),
/* 3134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.decode = exports.parse = __webpack_require__(3132);
exports.encode = exports.stringify = __webpack_require__(3133);


/***/ }),
/* 3135 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(3123)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 3136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, process) {

function oldBrowser () {
  throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11')
}
var safeBuffer = __webpack_require__(42)
var randombytes = __webpack_require__(286)
var Buffer = safeBuffer.Buffer
var kBufferMaxLength = safeBuffer.kMaxLength
var crypto = global.crypto || global.msCrypto
var kMaxUint32 = Math.pow(2, 32) - 1
function assertOffset (offset, length) {
  if (typeof offset !== 'number' || offset !== offset) { // eslint-disable-line no-self-compare
    throw new TypeError('offset must be a number')
  }

  if (offset > kMaxUint32 || offset < 0) {
    throw new TypeError('offset must be a uint32')
  }

  if (offset > kBufferMaxLength || offset > length) {
    throw new RangeError('offset out of range')
  }
}

function assertSize (size, offset, length) {
  if (typeof size !== 'number' || size !== size) { // eslint-disable-line no-self-compare
    throw new TypeError('size must be a number')
  }

  if (size > kMaxUint32 || size < 0) {
    throw new TypeError('size must be a uint32')
  }

  if (size + offset > length || size > kBufferMaxLength) {
    throw new RangeError('buffer too small')
  }
}
if ((crypto && crypto.getRandomValues) || !process.browser) {
  exports.randomFill = randomFill
  exports.randomFillSync = randomFillSync
} else {
  exports.randomFill = oldBrowser
  exports.randomFillSync = oldBrowser
}
function randomFill (buf, offset, size, cb) {
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  if (typeof offset === 'function') {
    cb = offset
    offset = 0
    size = buf.length
  } else if (typeof size === 'function') {
    cb = size
    size = buf.length - offset
  } else if (typeof cb !== 'function') {
    throw new TypeError('"cb" argument must be a function')
  }
  assertOffset(offset, buf.length)
  assertSize(size, offset, buf.length)
  return actualFill(buf, offset, size, cb)
}

function actualFill (buf, offset, size, cb) {
  if (process.browser) {
    var ourBuf = buf.buffer
    var uint = new Uint8Array(ourBuf, offset, size)
    crypto.getRandomValues(uint)
    if (cb) {
      process.nextTick(function () {
        cb(null, buf)
      })
      return
    }
    return buf
  }
  if (cb) {
    randombytes(size, function (err, bytes) {
      if (err) {
        return cb(err)
      }
      bytes.copy(buf, offset)
      cb(null, buf)
    })
    return
  }
  var bytes = randombytes(size)
  bytes.copy(buf, offset)
  return buf
}
function randomFillSync (buf, offset, size) {
  if (typeof offset === 'undefined') {
    offset = 0
  }
  if (!Buffer.isBuffer(buf) && !(buf instanceof global.Uint8Array)) {
    throw new TypeError('"buf" argument must be a Buffer or Uint8Array')
  }

  assertOffset(offset, buf.length)

  if (size === undefined) size = buf.length - offset

  assertSize(size, offset, buf.length)

  return actualFill(buf, offset, size)
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56), __webpack_require__(90)))

/***/ }),
/* 3137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_align__ = __webpack_require__(2848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__util__ = __webpack_require__(3139);












function getElement(func) {
  if (typeof func !== 'function' || !func) return null;
  return func();
}

function getPoint(point) {
  if (typeof point !== 'object' || !point) return null;
  return point;
}

var Align = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Align, _Component);

  function Align() {
    var _ref;

    var _temp, _this, _ret;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Align);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          target = _this$props.target,
          align = _this$props.align,
          onAlign = _this$props.onAlign;

      if (!disabled && target) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(_this);

        var result = void 0;
        var element = getElement(target);
        var point = getPoint(target);

        // IE lose focus after element realign
        // We should record activeElement and restore later
        var activeElement = document.activeElement;

        if (element) {
          result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_dom_align__["a" /* alignElement */])(source, element, align);
        } else if (point) {
          result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_dom_align__["b" /* alignPoint */])(source, point, align);
        }

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["a" /* restoreFocus */])(activeElement, source);

        if (onAlign) {
          onAlign(source, result);
        }
      }
    }, _temp), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(_this, _ret);
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Align, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var props = this.props;
      // if parent ref not attached .... use document.getElementById
      this.forceAlign();
      if (!props.disabled && props.monitorWindowResize) {
        this.startMonitorWindowResize();
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var reAlign = false;
      var props = this.props;

      if (!props.disabled) {
        var source = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
        var sourceRect = source ? source.getBoundingClientRect() : null;

        if (prevProps.disabled) {
          reAlign = true;
        } else {
          var lastElement = getElement(prevProps.target);
          var currentElement = getElement(props.target);
          var lastPoint = getPoint(prevProps.target);
          var currentPoint = getPoint(props.target);

          if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isWindow */])(lastElement) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["b" /* isWindow */])(currentElement)) {
            // Skip if is window
            reAlign = false;
          } else if (lastElement !== currentElement || // Element change
          lastElement && !currentElement && currentPoint || // Change from element to point
          lastPoint && currentPoint && currentElement || // Change from point to element
          currentPoint && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["c" /* isSamePoint */])(lastPoint, currentPoint)) {
            reAlign = true;
          }

          // If source element size changed
          var preRect = this.sourceRect || {};
          if (!reAlign && source && (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isSimilarValue */])(preRect.width, sourceRect.width) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["d" /* isSimilarValue */])(preRect.height, sourceRect.height))) {
            reAlign = true;
          }
        }

        this.sourceRect = sourceRect;
      }

      if (reAlign) {
        this.forceAlign();
      }

      if (props.monitorWindowResize && !props.disabled) {
        this.startMonitorWindowResize();
      } else {
        this.stopMonitorWindowResize();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stopMonitorWindowResize();
    }
  }, {
    key: 'startMonitorWindowResize',
    value: function startMonitorWindowResize() {
      if (!this.resizeHandler) {
        this.bufferMonitor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__util__["e" /* buffer */])(this.forceAlign, this.props.monitorBufferTime);
        this.resizeHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'resize', this.bufferMonitor);
      }
    }
  }, {
    key: 'stopMonitorWindowResize',
    value: function stopMonitorWindowResize() {
      if (this.resizeHandler) {
        this.bufferMonitor.clear();
        this.resizeHandler.remove();
        this.resizeHandler = null;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          childrenProps = _props.childrenProps,
          children = _props.children;

      var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
      if (childrenProps) {
        var newProps = {};
        var propList = Object.keys(childrenProps);
        propList.forEach(function (prop) {
          newProps[prop] = _this2.props[childrenProps[prop]];
        });

        return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newProps);
      }
      return child;
    }
  }]);

  return Align;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Align.propTypes = {
  childrenProps: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired,
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    clientX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    clientY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })]),
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  monitorBufferTime: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  monitorWindowResize: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any
};
Align.defaultProps = {
  target: function target() {
    return window;
  },
  monitorBufferTime: 50,
  monitorWindowResize: false,
  disabled: false
};


/* harmony default export */ __webpack_exports__["a"] = (Align);

/***/ }),
/* 3138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Align__ = __webpack_require__(3137);
// export this package's api


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Align__["a" /* default */]);

/***/ }),
/* 3139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = buffer;
/* harmony export (immutable) */ __webpack_exports__["c"] = isSamePoint;
/* harmony export (immutable) */ __webpack_exports__["b"] = isWindow;
/* harmony export (immutable) */ __webpack_exports__["d"] = isSimilarValue;
/* harmony export (immutable) */ __webpack_exports__["a"] = restoreFocus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__ = __webpack_require__(1400);


function buffer(fn, ms) {
  var timer = void 0;

  function clear() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }

  function bufferFn() {
    clear();
    timer = setTimeout(fn, ms);
  }

  bufferFn.clear = clear;

  return bufferFn;
}

function isSamePoint(prev, next) {
  if (prev === next) return true;
  if (!prev || !next) return false;

  if ('pageX' in next && 'pageY' in next) {
    return prev.pageX === next.pageX && prev.pageY === next.pageY;
  }

  if ('clientX' in next && 'clientY' in next) {
    return prev.clientX === next.clientX && prev.clientY === next.clientY;
  }

  return false;
}

function isWindow(obj) {
  return obj && typeof obj === 'object' && obj.window === obj;
}

function isSimilarValue(val1, val2) {
  var int1 = Math.floor(val1);
  var int2 = Math.floor(val2);
  return Math.abs(int1 - int2) <= 1;
}

function restoreFocus(activeElement, container) {
  // Focus back if is in the container
  if (activeElement !== document.activeElement && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_rc_util_es_Dom_contains__["a" /* default */])(container, activeElement)) {
    activeElement.focus();
  }
}

/***/ }),
/* 3140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(2596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__ = __webpack_require__(3155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__ = __webpack_require__(3142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__(3141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__(1396);













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["c" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__["a" /* default */])(Animate));

/***/ }),
/* 3141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(2833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(1396);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 3142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["b"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["d"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["e"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["c"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 3143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Select__ = __webpack_require__(3146);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





var formatOption = function formatOption(option, disabledOptions) {
  var value = "".concat(option);

  if (option < 10) {
    value = "0".concat(option);
  }

  var disabled = false;

  if (disabledOptions && disabledOptions.indexOf(option) >= 0) {
    disabled = true;
  }

  return {
    value: value,
    disabled: disabled
  };
};

var Combobox =
/*#__PURE__*/
function (_Component) {
  _inherits(Combobox, _Component);

  function Combobox() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Combobox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Combobox)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "onItemChange", function (type, itemValue) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          defaultOpenValue = _this$props.defaultOpenValue,
          use12Hours = _this$props.use12Hours,
          propValue = _this$props.value,
          isAM = _this$props.isAM,
          onAmPmChange = _this$props.onAmPmChange;
      var value = (propValue || defaultOpenValue).clone();

      if (type === 'hour') {
        if (use12Hours) {
          if (isAM) {
            value.hour(+itemValue % 12);
          } else {
            value.hour(+itemValue % 12 + 12);
          }
        } else {
          value.hour(+itemValue);
        }
      } else if (type === 'minute') {
        value.minute(+itemValue);
      } else if (type === 'ampm') {
        var ampm = itemValue.toUpperCase();

        if (use12Hours) {
          if (ampm === 'PM' && value.hour() < 12) {
            value.hour(value.hour() % 12 + 12);
          }

          if (ampm === 'AM') {
            if (value.hour() >= 12) {
              value.hour(value.hour() - 12);
            }
          }
        }

        onAmPmChange(ampm);
      } else {
        value.second(+itemValue);
      }

      onChange(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onEnterSelectPanel", function (range) {
      var onCurrentSelectPanelChange = _this.props.onCurrentSelectPanelChange;
      onCurrentSelectPanelChange(range);
    });

    return _this;
  }

  _createClass(Combobox, [{
    key: "getHourSelect",
    value: function getHourSelect(hour) {
      var _this2 = this;

      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          hourOptions = _this$props2.hourOptions,
          disabledHours = _this$props2.disabledHours,
          showHour = _this$props2.showHour,
          use12Hours = _this$props2.use12Hours,
          onEsc = _this$props2.onEsc;

      if (!showHour) {
        return null;
      }

      var disabledOptions = disabledHours();
      var hourOptionsAdj;
      var hourAdj;

      if (use12Hours) {
        hourOptionsAdj = [12].concat(hourOptions.filter(function (h) {
          return h < 12 && h > 0;
        }));
        hourAdj = hour % 12 || 12;
      } else {
        hourOptionsAdj = hourOptions;
        hourAdj = hour;
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Select__["a" /* default */], {
        prefixCls: prefixCls,
        options: hourOptionsAdj.map(function (option) {
          return formatOption(option, disabledOptions);
        }),
        selectedIndex: hourOptionsAdj.indexOf(hourAdj),
        type: "hour",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this2.onEnterSelectPanel('hour');
        },
        onEsc: onEsc
      });
    }
  }, {
    key: "getMinuteSelect",
    value: function getMinuteSelect(minute) {
      var _this3 = this;

      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          minuteOptions = _this$props3.minuteOptions,
          disabledMinutes = _this$props3.disabledMinutes,
          defaultOpenValue = _this$props3.defaultOpenValue,
          showMinute = _this$props3.showMinute,
          propValue = _this$props3.value,
          onEsc = _this$props3.onEsc;

      if (!showMinute) {
        return null;
      }

      var value = propValue || defaultOpenValue;
      var disabledOptions = disabledMinutes(value.hour());
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Select__["a" /* default */], {
        prefixCls: prefixCls,
        options: minuteOptions.map(function (option) {
          return formatOption(option, disabledOptions);
        }),
        selectedIndex: minuteOptions.indexOf(minute),
        type: "minute",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this3.onEnterSelectPanel('minute');
        },
        onEsc: onEsc
      });
    }
  }, {
    key: "getSecondSelect",
    value: function getSecondSelect(second) {
      var _this4 = this;

      var _this$props4 = this.props,
          prefixCls = _this$props4.prefixCls,
          secondOptions = _this$props4.secondOptions,
          disabledSeconds = _this$props4.disabledSeconds,
          showSecond = _this$props4.showSecond,
          defaultOpenValue = _this$props4.defaultOpenValue,
          propValue = _this$props4.value,
          onEsc = _this$props4.onEsc;

      if (!showSecond) {
        return null;
      }

      var value = propValue || defaultOpenValue;
      var disabledOptions = disabledSeconds(value.hour(), value.minute());
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Select__["a" /* default */], {
        prefixCls: prefixCls,
        options: secondOptions.map(function (option) {
          return formatOption(option, disabledOptions);
        }),
        selectedIndex: secondOptions.indexOf(second),
        type: "second",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this4.onEnterSelectPanel('second');
        },
        onEsc: onEsc
      });
    }
  }, {
    key: "getAMPMSelect",
    value: function getAMPMSelect() {
      var _this5 = this;

      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          use12Hours = _this$props5.use12Hours,
          format = _this$props5.format,
          isAM = _this$props5.isAM,
          onEsc = _this$props5.onEsc;

      if (!use12Hours) {
        return null;
      }

      var AMPMOptions = ['am', 'pm'] // If format has A char, then we should uppercase AM/PM
      .map(function (c) {
        return format.match(/\sA/) ? c.toUpperCase() : c;
      }).map(function (c) {
        return {
          value: c
        };
      });
      var selected = isAM ? 0 : 1;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Select__["a" /* default */], {
        prefixCls: prefixCls,
        options: AMPMOptions,
        selectedIndex: selected,
        type: "ampm",
        onSelect: this.onItemChange,
        onMouseEnter: function onMouseEnter() {
          return _this5.onEnterSelectPanel('ampm');
        },
        onEsc: onEsc
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          prefixCls = _this$props6.prefixCls,
          defaultOpenValue = _this$props6.defaultOpenValue,
          propValue = _this$props6.value;
      var value = propValue || defaultOpenValue;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "".concat(prefixCls, "-combobox")
      }, this.getHourSelect(value.hour()), this.getMinuteSelect(value.minute()), this.getSecondSelect(value.second()), this.getAMPMSelect(value.hour()));
    }
  }]);

  return Combobox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Combobox, "propTypes", {
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  defaultOpenValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onAmPmChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showHour: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMinute: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showSecond: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hourOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  minuteOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  secondOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  disabledHours: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledMinutes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledSeconds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onCurrentSelectPanelChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  use12Hours: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onEsc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  isAM: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool
});

/* harmony default export */ __webpack_exports__["a"] = (Combobox);

/***/ }),
/* 3144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






var Header =
/*#__PURE__*/
function (_Component) {
  _inherits(Header, _Component);

  function Header(props) {
    var _this;

    _classCallCheck(this, Header);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Header).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (event) {
      var str = event.target.value;

      _this.setState({
        str: str
      });

      var _this$props = _this.props,
          format = _this$props.format,
          hourOptions = _this$props.hourOptions,
          minuteOptions = _this$props.minuteOptions,
          secondOptions = _this$props.secondOptions,
          disabledHours = _this$props.disabledHours,
          disabledMinutes = _this$props.disabledMinutes,
          disabledSeconds = _this$props.disabledSeconds,
          onChange = _this$props.onChange;

      if (str) {
        var originalValue = _this.props.value;

        var value = _this.getProtoValue().clone();

        var parsed = __WEBPACK_IMPORTED_MODULE_2_moment___default()(str, format, true);

        if (!parsed.isValid()) {
          _this.setState({
            invalid: true
          });

          return;
        }

        value.hour(parsed.hour()).minute(parsed.minute()).second(parsed.second()); // if time value not allowed, response warning.

        if (hourOptions.indexOf(value.hour()) < 0 || minuteOptions.indexOf(value.minute()) < 0 || secondOptions.indexOf(value.second()) < 0) {
          _this.setState({
            invalid: true
          });

          return;
        } // if time value is disabled, response warning.


        var disabledHourOptions = disabledHours();
        var disabledMinuteOptions = disabledMinutes(value.hour());
        var disabledSecondOptions = disabledSeconds(value.hour(), value.minute());

        if (disabledHourOptions && disabledHourOptions.indexOf(value.hour()) >= 0 || disabledMinuteOptions && disabledMinuteOptions.indexOf(value.minute()) >= 0 || disabledSecondOptions && disabledSecondOptions.indexOf(value.second()) >= 0) {
          _this.setState({
            invalid: true
          });

          return;
        }

        if (originalValue) {
          if (originalValue.hour() !== value.hour() || originalValue.minute() !== value.minute() || originalValue.second() !== value.second()) {
            // keep other fields for rc-calendar
            var changedValue = originalValue.clone();
            changedValue.hour(value.hour());
            changedValue.minute(value.minute());
            changedValue.second(value.second());
            onChange(changedValue);
          }
        } else if (originalValue !== value) {
          onChange(value);
        }
      } else {
        onChange(null);
      }

      _this.setState({
        invalid: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      var _this$props2 = _this.props,
          onEsc = _this$props2.onEsc,
          onKeyDown = _this$props2.onKeyDown;

      if (e.keyCode === 27) {
        onEsc();
      }

      onKeyDown(e);
    });

    var _value = props.value,
        _format = props.format;
    _this.state = {
      str: _value && _value.format(_format) || '',
      invalid: false
    };
    return _this;
  }

  _createClass(Header, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var focusOnOpen = this.props.focusOnOpen;

      if (focusOnOpen) {
        // Wait one frame for the panel to be positioned before focusing
        var requestAnimationFrame = window.requestAnimationFrame || window.setTimeout;
        requestAnimationFrame(function () {
          _this2.refInput.focus();

          _this2.refInput.select();
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
          value = _this$props3.value,
          format = _this$props3.format;

      if (value !== prevProps.value) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          str: value && value.format(format) || '',
          invalid: false
        });
      }
    }
  }, {
    key: "getProtoValue",
    value: function getProtoValue() {
      var _this$props4 = this.props,
          value = _this$props4.value,
          defaultOpenValue = _this$props4.defaultOpenValue;
      return value || defaultOpenValue;
    }
  }, {
    key: "getInput",
    value: function getInput() {
      var _this3 = this;

      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          placeholder = _this$props5.placeholder,
          inputReadOnly = _this$props5.inputReadOnly;
      var _this$state = this.state,
          invalid = _this$state.invalid,
          str = _this$state.str;
      var invalidClass = invalid ? "".concat(prefixCls, "-input-invalid") : '';
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()("".concat(prefixCls, "-input"), invalidClass),
        ref: function ref(_ref) {
          _this3.refInput = _ref;
        },
        onKeyDown: this.onKeyDown,
        value: str,
        placeholder: placeholder,
        onChange: this.onInputChange,
        readOnly: !!inputReadOnly
      });
    }
  }, {
    key: "render",
    value: function render() {
      var prefixCls = this.props.prefixCls;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: "".concat(prefixCls, "-input-wrap")
      }, this.getInput());
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Header, "propTypes", {
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  disabledDate: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  clearText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  inputReadOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hourOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  minuteOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  secondOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  disabledHours: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledMinutes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledSeconds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onEsc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  defaultOpenValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  currentSelectPanel: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  focusOnOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  clearIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
});

_defineProperty(Header, "defaultProps", {
  inputReadOnly: false
});

/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 3145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_lifecycles_compat__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Header__ = __webpack_require__(3144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Combobox__ = __webpack_require__(3143);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









function noop() {}

function generateOptions(length, disabledOptions, hideDisabledOptions) {
  var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
  var arr = [];

  for (var value = 0; value < length; value += step) {
    if (!disabledOptions || disabledOptions.indexOf(value) < 0 || !hideDisabledOptions) {
      arr.push(value);
    }
  }

  return arr;
}

function toNearestValidTime(time, hourOptions, minuteOptions, secondOptions) {
  var hour = hourOptions.slice().sort(function (a, b) {
    return Math.abs(time.hour() - a) - Math.abs(time.hour() - b);
  })[0];
  var minute = minuteOptions.slice().sort(function (a, b) {
    return Math.abs(time.minute() - a) - Math.abs(time.minute() - b);
  })[0];
  var second = secondOptions.slice().sort(function (a, b) {
    return Math.abs(time.second() - a) - Math.abs(time.second() - b);
  })[0];
  return __WEBPACK_IMPORTED_MODULE_2_moment___default()("".concat(hour, ":").concat(minute, ":").concat(second), 'HH:mm:ss');
}

var Panel =
/*#__PURE__*/
function (_Component) {
  _inherits(Panel, _Component);

  function Panel() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Panel);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Panel)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "onChange", function (newValue) {
      var onChange = _this.props.onChange;

      _this.setState({
        value: newValue
      });

      onChange(newValue);
    });

    _defineProperty(_assertThisInitialized(_this), "onAmPmChange", function (ampm) {
      var onAmPmChange = _this.props.onAmPmChange;
      onAmPmChange(ampm);
    });

    _defineProperty(_assertThisInitialized(_this), "onCurrentSelectPanelChange", function (currentSelectPanel) {
      _this.setState({
        currentSelectPanel: currentSelectPanel
      });
    });

    _defineProperty(_assertThisInitialized(_this), "disabledHours", function () {
      var _this$props = _this.props,
          use12Hours = _this$props.use12Hours,
          disabledHours = _this$props.disabledHours;
      var disabledOptions = disabledHours();

      if (use12Hours && Array.isArray(disabledOptions)) {
        if (_this.isAM()) {
          disabledOptions = disabledOptions.filter(function (h) {
            return h < 12;
          }).map(function (h) {
            return h === 0 ? 12 : h;
          });
        } else {
          disabledOptions = disabledOptions.map(function (h) {
            return h === 12 ? 12 : h - 12;
          });
        }
      }

      return disabledOptions;
    });

    return _this;
  }

  _createClass(Panel, [{
    key: "close",
    // https://github.com/ant-design/ant-design/issues/5829
    value: function close() {
      var onEsc = this.props.onEsc;
      onEsc();
    }
  }, {
    key: "isAM",
    value: function isAM() {
      var defaultOpenValue = this.props.defaultOpenValue;
      var value = this.state.value;
      var realValue = value || defaultOpenValue;
      return realValue.hour() >= 0 && realValue.hour() < 12;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          className = _this$props2.className,
          placeholder = _this$props2.placeholder,
          disabledMinutes = _this$props2.disabledMinutes,
          disabledSeconds = _this$props2.disabledSeconds,
          hideDisabledOptions = _this$props2.hideDisabledOptions,
          showHour = _this$props2.showHour,
          showMinute = _this$props2.showMinute,
          showSecond = _this$props2.showSecond,
          format = _this$props2.format,
          defaultOpenValue = _this$props2.defaultOpenValue,
          clearText = _this$props2.clearText,
          onEsc = _this$props2.onEsc,
          addon = _this$props2.addon,
          use12Hours = _this$props2.use12Hours,
          focusOnOpen = _this$props2.focusOnOpen,
          onKeyDown = _this$props2.onKeyDown,
          hourStep = _this$props2.hourStep,
          minuteStep = _this$props2.minuteStep,
          secondStep = _this$props2.secondStep,
          inputReadOnly = _this$props2.inputReadOnly,
          clearIcon = _this$props2.clearIcon;
      var _this$state = this.state,
          value = _this$state.value,
          currentSelectPanel = _this$state.currentSelectPanel;
      var disabledHourOptions = this.disabledHours();
      var disabledMinuteOptions = disabledMinutes(value ? value.hour() : null);
      var disabledSecondOptions = disabledSeconds(value ? value.hour() : null, value ? value.minute() : null);
      var hourOptions = generateOptions(24, disabledHourOptions, hideDisabledOptions, hourStep);
      var minuteOptions = generateOptions(60, disabledMinuteOptions, hideDisabledOptions, minuteStep);
      var secondOptions = generateOptions(60, disabledSecondOptions, hideDisabledOptions, secondStep);
      var validDefaultOpenValue = toNearestValidTime(defaultOpenValue, hourOptions, minuteOptions, secondOptions);
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, "".concat(prefixCls, "-inner"))
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Header__["a" /* default */], {
        clearText: clearText,
        prefixCls: prefixCls,
        defaultOpenValue: validDefaultOpenValue,
        value: value,
        currentSelectPanel: currentSelectPanel,
        onEsc: onEsc,
        format: format,
        placeholder: placeholder,
        hourOptions: hourOptions,
        minuteOptions: minuteOptions,
        secondOptions: secondOptions,
        disabledHours: this.disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        onChange: this.onChange,
        focusOnOpen: focusOnOpen,
        onKeyDown: onKeyDown,
        inputReadOnly: inputReadOnly,
        clearIcon: clearIcon
      }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Combobox__["a" /* default */], {
        prefixCls: prefixCls,
        value: value,
        defaultOpenValue: validDefaultOpenValue,
        format: format,
        onChange: this.onChange,
        onAmPmChange: this.onAmPmChange,
        showHour: showHour,
        showMinute: showMinute,
        showSecond: showSecond,
        hourOptions: hourOptions,
        minuteOptions: minuteOptions,
        secondOptions: secondOptions,
        disabledHours: this.disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        onCurrentSelectPanelChange: this.onCurrentSelectPanelChange,
        use12Hours: use12Hours,
        onEsc: onEsc,
        isAM: this.isAM()
      }), addon(this));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if ('value' in props) {
        return _objectSpread({}, state, {
          value: props.value
        });
      }

      return null;
    }
  }]);

  return Panel;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Panel, "propTypes", {
  clearText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  defaultOpenValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inputReadOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabledHours: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledMinutes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledSeconds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hideDisabledOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onAmPmChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onEsc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  showHour: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMinute: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showSecond: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  use12Hours: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hourStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  minuteStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  secondStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  addon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  focusOnOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  clearIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
});

_defineProperty(Panel, "defaultProps", {
  prefixCls: 'rc-time-picker-panel',
  onChange: noop,
  disabledHours: noop,
  disabledMinutes: noop,
  disabledSeconds: noop,
  defaultOpenValue: __WEBPACK_IMPORTED_MODULE_2_moment___default()(),
  use12Hours: false,
  addon: noop,
  onKeyDown: noop,
  onAmPmChange: noop,
  inputReadOnly: false
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_lifecycles_compat__["polyfill"])(Panel);
/* harmony default export */ __webpack_exports__["a"] = (Panel);

/***/ }),
/* 3146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raf__ = __webpack_require__(3135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_raf___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_raf__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint jsx-a11y/no-noninteractive-element-to-interactive-role: 0 */






var scrollTo = function scrollTo(element, to, duration) {
  // jump to target if duration zero
  if (duration <= 0) {
    __WEBPACK_IMPORTED_MODULE_4_raf___default()(function () {
      element.scrollTop = to;
    });
    return;
  }

  var difference = to - element.scrollTop;
  var perTick = difference / duration * 10;
  __WEBPACK_IMPORTED_MODULE_4_raf___default()(function () {
    element.scrollTop += perTick;
    if (element.scrollTop === to) return;
    scrollTo(element, to, duration - 10);
  });
};

var Select =
/*#__PURE__*/
function (_Component) {
  _inherits(Select, _Component);

  function Select() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Select);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Select)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      active: false
    });

    _defineProperty(_assertThisInitialized(_this), "onSelect", function (value) {
      var _this$props = _this.props,
          onSelect = _this$props.onSelect,
          type = _this$props.type;
      onSelect(type, value);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function (e) {
      var onMouseEnter = _this.props.onMouseEnter;

      _this.setState({
        active: true
      });

      onMouseEnter(e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
      _this.setState({
        active: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "saveList", function (node) {
      _this.list = node;
    });

    return _this;
  }

  _createClass(Select, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // jump to selected option
      this.scrollToSelected(0);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var selectedIndex = this.props.selectedIndex; // smooth scroll to selected option

      if (prevProps.selectedIndex !== selectedIndex) {
        this.scrollToSelected(120);
      }
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      var _this2 = this;

      var _this$props2 = this.props,
          options = _this$props2.options,
          selectedIndex = _this$props2.selectedIndex,
          prefixCls = _this$props2.prefixCls,
          onEsc = _this$props2.onEsc;
      return options.map(function (item, index) {
        var _classNames;

        var cls = __WEBPACK_IMPORTED_MODULE_3_classnames___default()((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-select-option-selected"), selectedIndex === index), _defineProperty(_classNames, "".concat(prefixCls, "-select-option-disabled"), item.disabled), _classNames));
        var onClick = item.disabled ? undefined : function () {
          _this2.onSelect(item.value);
        };

        var onKeyDown = function onKeyDown(e) {
          if (e.keyCode === 13) onClick();else if (e.keyCode === 27) onEsc();
        };

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li", {
          role: "button",
          onClick: onClick,
          className: cls,
          key: index,
          disabled: item.disabled,
          tabIndex: "0",
          onKeyDown: onKeyDown
        }, item.value);
      });
    }
  }, {
    key: "scrollToSelected",
    value: function scrollToSelected(duration) {
      // move to selected item
      var selectedIndex = this.props.selectedIndex;
      var select = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this);
      var list = __WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this.list);

      if (!list) {
        return;
      }

      var index = selectedIndex;

      if (index < 0) {
        index = 0;
      }

      var topOption = list.children[index];
      var to = topOption.offsetTop;
      scrollTo(select, to, duration);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          prefixCls = _this$props3.prefixCls,
          options = _this$props3.options;
      var active = this.state.active;

      if (options.length === 0) {
        return null;
      }

      var cls = __WEBPACK_IMPORTED_MODULE_3_classnames___default()("".concat(prefixCls, "-select"), _defineProperty({}, "".concat(prefixCls, "-select-active"), active));
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        className: cls,
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul", {
        ref: this.saveList
      }, this.getOptions()));
    }
  }]);

  return Select;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Select, "propTypes", {
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  options: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.array,
  selectedIndex: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  type: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onSelect: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onEsc: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
});

/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 3147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_rc_trigger__ = __webpack_require__(3152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_lifecycles_compat__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Panel__ = __webpack_require__(3145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__placements__ = __webpack_require__(3149);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint jsx-a11y/no-autofocus: 0 */









function noop() {}

function refFn(field, component) {
  this[field] = component;
}

var Picker =
/*#__PURE__*/
function (_Component) {
  _inherits(Picker, _Component);

  function Picker(props) {
    var _this;

    _classCallCheck(this, Picker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Picker).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onPanelChange", function (value) {
      _this.setValue(value);
    });

    _defineProperty(_assertThisInitialized(_this), "onAmPmChange", function (ampm) {
      var onAmPmChange = _this.props.onAmPmChange;
      onAmPmChange(ampm);
    });

    _defineProperty(_assertThisInitialized(_this), "onClear", function (event) {
      event.stopPropagation();

      _this.setValue(null);

      _this.setOpen(false);
    });

    _defineProperty(_assertThisInitialized(_this), "onVisibleChange", function (open) {
      _this.setOpen(open);
    });

    _defineProperty(_assertThisInitialized(_this), "onEsc", function () {
      _this.setOpen(false);

      _this.focus();
    });

    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      if (e.keyCode === 40) {
        _this.setOpen(true);
      }
    });

    _this.saveInputRef = refFn.bind(_assertThisInitialized(_this), 'picker');
    _this.savePanelRef = refFn.bind(_assertThisInitialized(_this), 'panelInstance');

    var defaultOpen = props.defaultOpen,
        defaultValue = props.defaultValue,
        _props$open = props.open,
        _open = _props$open === void 0 ? defaultOpen : _props$open,
        _props$value = props.value,
        _value = _props$value === void 0 ? defaultValue : _props$value;

    _this.state = {
      open: _open,
      value: _value
    };
    return _this;
  }

  _createClass(Picker, [{
    key: "setValue",
    value: function setValue(value) {
      var onChange = this.props.onChange;

      if (!('value' in this.props)) {
        this.setState({
          value: value
        });
      }

      onChange(value);
    }
  }, {
    key: "getFormat",
    value: function getFormat() {
      var _this$props = this.props,
          format = _this$props.format,
          showHour = _this$props.showHour,
          showMinute = _this$props.showMinute,
          showSecond = _this$props.showSecond,
          use12Hours = _this$props.use12Hours;

      if (format) {
        return format;
      }

      if (use12Hours) {
        var fmtString = [showHour ? 'h' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
          return !!item;
        }).join(':');
        return fmtString.concat(' a');
      }

      return [showHour ? 'HH' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
        return !!item;
      }).join(':');
    }
  }, {
    key: "getPanelElement",
    value: function getPanelElement() {
      var _this$props2 = this.props,
          prefixCls = _this$props2.prefixCls,
          placeholder = _this$props2.placeholder,
          disabledHours = _this$props2.disabledHours,
          disabledMinutes = _this$props2.disabledMinutes,
          disabledSeconds = _this$props2.disabledSeconds,
          hideDisabledOptions = _this$props2.hideDisabledOptions,
          inputReadOnly = _this$props2.inputReadOnly,
          showHour = _this$props2.showHour,
          showMinute = _this$props2.showMinute,
          showSecond = _this$props2.showSecond,
          defaultOpenValue = _this$props2.defaultOpenValue,
          clearText = _this$props2.clearText,
          addon = _this$props2.addon,
          use12Hours = _this$props2.use12Hours,
          focusOnOpen = _this$props2.focusOnOpen,
          onKeyDown = _this$props2.onKeyDown,
          hourStep = _this$props2.hourStep,
          minuteStep = _this$props2.minuteStep,
          secondStep = _this$props2.secondStep,
          clearIcon = _this$props2.clearIcon;
      var value = this.state.value;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Panel__["a" /* default */], {
        clearText: clearText,
        prefixCls: "".concat(prefixCls, "-panel"),
        ref: this.savePanelRef,
        value: value,
        inputReadOnly: inputReadOnly,
        onChange: this.onPanelChange,
        onAmPmChange: this.onAmPmChange,
        defaultOpenValue: defaultOpenValue,
        showHour: showHour,
        showMinute: showMinute,
        showSecond: showSecond,
        onEsc: this.onEsc,
        format: this.getFormat(),
        placeholder: placeholder,
        disabledHours: disabledHours,
        disabledMinutes: disabledMinutes,
        disabledSeconds: disabledSeconds,
        hideDisabledOptions: hideDisabledOptions,
        use12Hours: use12Hours,
        hourStep: hourStep,
        minuteStep: minuteStep,
        secondStep: secondStep,
        addon: addon,
        focusOnOpen: focusOnOpen,
        onKeyDown: onKeyDown,
        clearIcon: clearIcon
      });
    }
  }, {
    key: "getPopupClassName",
    value: function getPopupClassName() {
      var _this$props3 = this.props,
          showHour = _this$props3.showHour,
          showMinute = _this$props3.showMinute,
          showSecond = _this$props3.showSecond,
          use12Hours = _this$props3.use12Hours,
          prefixCls = _this$props3.prefixCls,
          popupClassName = _this$props3.popupClassName;
      var selectColumnCount = 0;

      if (showHour) {
        selectColumnCount += 1;
      }

      if (showMinute) {
        selectColumnCount += 1;
      }

      if (showSecond) {
        selectColumnCount += 1;
      }

      if (use12Hours) {
        selectColumnCount += 1;
      } // Keep it for old compatibility


      return __WEBPACK_IMPORTED_MODULE_5_classnames___default()(popupClassName, _defineProperty({}, "".concat(prefixCls, "-panel-narrow"), (!showHour || !showMinute || !showSecond) && !use12Hours), "".concat(prefixCls, "-panel-column-").concat(selectColumnCount));
    }
  }, {
    key: "setOpen",
    value: function setOpen(open) {
      var _this$props4 = this.props,
          onOpen = _this$props4.onOpen,
          onClose = _this$props4.onClose;
      var currentOpen = this.state.open;

      if (currentOpen !== open) {
        if (!('open' in this.props)) {
          this.setState({
            open: open
          });
        }

        if (open) {
          onOpen({
            open: open
          });
        } else {
          onClose({
            open: open
          });
        }
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.picker.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.picker.blur();
    }
  }, {
    key: "renderClearButton",
    value: function renderClearButton() {
      var _this2 = this;

      var value = this.state.value;
      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          allowEmpty = _this$props5.allowEmpty,
          clearIcon = _this$props5.clearIcon,
          clearText = _this$props5.clearText,
          disabled = _this$props5.disabled;

      if (!allowEmpty || !value || disabled) {
        return null;
      }

      if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(clearIcon)) {
        var _ref = clearIcon.props || {},
            _onClick = _ref.onClick;

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(clearIcon, {
          onClick: function onClick() {
            if (_onClick) _onClick.apply(void 0, arguments);

            _this2.onClear.apply(_this2, arguments);
          }
        });
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", {
        role: "button",
        className: "".concat(prefixCls, "-clear"),
        title: clearText,
        onClick: this.onClear,
        tabIndex: 0
      }, clearIcon || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("i", {
        className: "".concat(prefixCls, "-clear-icon")
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
          prefixCls = _this$props6.prefixCls,
          placeholder = _this$props6.placeholder,
          placement = _this$props6.placement,
          align = _this$props6.align,
          id = _this$props6.id,
          disabled = _this$props6.disabled,
          transitionName = _this$props6.transitionName,
          style = _this$props6.style,
          className = _this$props6.className,
          getPopupContainer = _this$props6.getPopupContainer,
          name = _this$props6.name,
          autoComplete = _this$props6.autoComplete,
          onFocus = _this$props6.onFocus,
          onBlur = _this$props6.onBlur,
          autoFocus = _this$props6.autoFocus,
          inputReadOnly = _this$props6.inputReadOnly,
          inputIcon = _this$props6.inputIcon,
          popupStyle = _this$props6.popupStyle;
      var _this$state = this.state,
          open = _this$state.open,
          value = _this$state.value;
      var popupClassName = this.getPopupClassName();
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_rc_trigger__["a" /* default */], {
        prefixCls: "".concat(prefixCls, "-panel"),
        popupClassName: popupClassName,
        popupStyle: popupStyle,
        popup: this.getPanelElement(),
        popupAlign: align,
        builtinPlacements: __WEBPACK_IMPORTED_MODULE_7__placements__["a" /* default */],
        popupPlacement: placement,
        action: disabled ? [] : ['click'],
        destroyPopupOnHide: true,
        getPopupContainer: getPopupContainer,
        popupTransitionName: transitionName,
        popupVisible: open,
        onPopupVisibleChange: this.onVisibleChange
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(prefixCls, className),
        style: style
      }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input", {
        className: "".concat(prefixCls, "-input"),
        ref: this.saveInputRef,
        type: "text",
        placeholder: placeholder,
        name: name,
        onKeyDown: this.onKeyDown,
        disabled: disabled,
        value: value && value.format(this.getFormat()) || '',
        autoComplete: autoComplete,
        onFocus: onFocus,
        onBlur: onBlur,
        autoFocus: autoFocus,
        onChange: noop,
        readOnly: !!inputReadOnly,
        id: id
      }), inputIcon || __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
        className: "".concat(prefixCls, "-icon")
      }), this.renderClearButton()));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      var newState = {};

      if ('value' in props) {
        newState.value = props.value;
      }

      if (props.open !== undefined) {
        newState.open = props.open;
      }

      return Object.keys(newState).length > 0 ? _objectSpread({}, state, {}, newState) : null;
    }
  }]);

  return Picker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

_defineProperty(Picker, "propTypes", {
  prefixCls: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  clearText: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  defaultOpenValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  inputReadOnly: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  allowEmpty: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  defaultValue: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  open: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  defaultOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  align: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  placement: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  placeholder: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  format: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  showHour: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showMinute: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  showSecond: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  popupStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  disabledHours: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledMinutes: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  disabledSeconds: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hideDisabledOptions: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onAmPmChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onClose: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onBlur: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  addon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  autoComplete: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  use12Hours: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  hourStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  minuteStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  secondStep: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  focusOnOpen: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  autoFocus: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  id: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  inputIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  clearIcon: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
});

_defineProperty(Picker, "defaultProps", {
  clearText: 'clear',
  prefixCls: 'rc-time-picker',
  defaultOpen: false,
  inputReadOnly: false,
  style: {},
  className: '',
  popupClassName: '',
  popupStyle: {},
  id: '',
  align: {},
  defaultOpenValue: __WEBPACK_IMPORTED_MODULE_3_moment___default()(),
  allowEmpty: true,
  showHour: true,
  showMinute: true,
  showSecond: true,
  disabledHours: noop,
  disabledMinutes: noop,
  disabledSeconds: noop,
  hideDisabledOptions: false,
  placement: 'bottomLeft',
  onChange: noop,
  onAmPmChange: noop,
  onOpen: noop,
  onClose: noop,
  onFocus: noop,
  onBlur: noop,
  addon: noop,
  use12Hours: false,
  focusOnOpen: false,
  onKeyDown: noop
});

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_react_lifecycles_compat__["polyfill"])(Picker);
/* harmony default export */ __webpack_exports__["a"] = (Picker);

/***/ }),
/* 3148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TimePicker__ = __webpack_require__(3147);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__TimePicker__["a"]; });


/***/ }),
/* 3149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var autoAdjustOverflow = {
  adjustX: 1,
  adjustY: 1
};
var targetOffset = [0, 0];
var placements = {
  bottomLeft: {
    points: ['tl', 'tl'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  bottomRight: {
    points: ['tr', 'tr'],
    overflow: autoAdjustOverflow,
    offset: [0, -3],
    targetOffset: targetOffset
  },
  topRight: {
    points: ['br', 'br'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  },
  topLeft: {
    points: ['bl', 'bl'],
    overflow: autoAdjustOverflow,
    offset: [0, 3],
    targetOffset: targetOffset
  }
};
/* harmony default export */ __webpack_exports__["a"] = (placements);

/***/ }),
/* 3150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_rc_align__ = __webpack_require__(3138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_animate__ = __webpack_require__(3140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PopupInner__ = __webpack_require__(3151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(1398);













var Popup = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Popup, _Component);

  function Popup(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Popup);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    _this.state = {
      // Used for stretch
      stretchChecked: false,
      targetWidth: undefined,
      targetHeight: undefined
    };

    _this.savePopupRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'popupInstance');
    _this.saveAlignRef = __WEBPACK_IMPORTED_MODULE_11__utils__["c" /* saveRef */].bind(_this, 'alignInstance');
    return _this;
  }

  Popup.prototype.componentDidMount = function componentDidMount() {
    this.rootNode = this.getPopupDomNode();
    this.setStretchSize();
  };

  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
    this.setStretchSize();
  };

  // Record size if stretch needed


  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
    return __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this.popupInstance);
  };

  // `target` on `rc-align` can accept as a function to get the bind element or a point.
  // ref: https://www.npmjs.com/package/rc-align


  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
    var props = this.props;
    var transitionName = props.maskTransitionName;
    var animation = props.maskAnimation;
    if (!transitionName && animation) {
      transitionName = props.prefixCls + '-' + animation;
    }
    return transitionName;
  };

  Popup.prototype.getTransitionName = function getTransitionName() {
    var props = this.props;
    var transitionName = props.transitionName;
    if (!transitionName && props.animation) {
      transitionName = props.prefixCls + '-' + props.animation;
    }
    return transitionName;
  };

  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
  };

  Popup.prototype.getPopupElement = function getPopupElement() {
    var _this2 = this;

    var savePopupRef = this.savePopupRef;
    var _state = this.state,
        stretchChecked = _state.stretchChecked,
        targetHeight = _state.targetHeight,
        targetWidth = _state.targetWidth;
    var _props = this.props,
        align = _props.align,
        visible = _props.visible,
        prefixCls = _props.prefixCls,
        style = _props.style,
        getClassNameFromAlign = _props.getClassNameFromAlign,
        destroyPopupOnHide = _props.destroyPopupOnHide,
        stretch = _props.stretch,
        children = _props.children,
        onMouseEnter = _props.onMouseEnter,
        onMouseLeave = _props.onMouseLeave,
        onMouseDown = _props.onMouseDown,
        onTouchStart = _props.onTouchStart;

    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
    var hiddenClassName = prefixCls + '-hidden';

    if (!visible) {
      this.currentAlignClassName = null;
    }

    var sizeStyle = {};
    if (stretch) {
      // Stretch with target
      if (stretch.indexOf('height') !== -1) {
        sizeStyle.height = targetHeight;
      } else if (stretch.indexOf('minHeight') !== -1) {
        sizeStyle.minHeight = targetHeight;
      }
      if (stretch.indexOf('width') !== -1) {
        sizeStyle.width = targetWidth;
      } else if (stretch.indexOf('minWidth') !== -1) {
        sizeStyle.minWidth = targetWidth;
      }

      // Delay force align to makes ui smooth
      if (!stretchChecked) {
        sizeStyle.visibility = 'hidden';
        setTimeout(function () {
          if (_this2.alignInstance) {
            _this2.alignInstance.forceAlign();
          }
        }, 0);
      }
    }

    var newStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, sizeStyle, style, this.getZIndexStyle());

    var popupInnerProps = {
      className: className,
      prefixCls: prefixCls,
      ref: savePopupRef,
      onMouseEnter: onMouseEnter,
      onMouseLeave: onMouseLeave,
      onMouseDown: onMouseDown,
      onTouchStart: onTouchStart,
      style: newStyle
    };
    if (destroyPopupOnHide) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
        {
          component: '',
          exclusive: true,
          transitionAppear: true,
          transitionName: this.getTransitionName()
        },
        visible ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
          {
            target: this.getAlignTarget(),
            key: 'popup',
            ref: this.saveAlignRef,
            monitorWindowResize: true,
            align: align,
            onAlign: this.onAlign
          },
          __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              visible: true
            }, popupInnerProps),
            children
          )
        ) : null
      );
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
      {
        component: '',
        exclusive: true,
        transitionAppear: true,
        transitionName: this.getTransitionName(),
        showProp: 'xVisible'
      },
      __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_7_rc_align__["a" /* default */],
        {
          target: this.getAlignTarget(),
          key: 'popup',
          ref: this.saveAlignRef,
          monitorWindowResize: true,
          xVisible: visible,
          childrenProps: { visible: 'xVisible' },
          disabled: !visible,
          align: align,
          onAlign: this.onAlign
        },
        __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_9__PopupInner__["a" /* default */],
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            hiddenClassName: hiddenClassName
          }, popupInnerProps),
          children
        )
      )
    );
  };

  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
    var style = {};
    var props = this.props;
    if (props.zIndex !== undefined) {
      style.zIndex = props.zIndex;
    }
    return style;
  };

  Popup.prototype.getMaskElement = function getMaskElement() {
    var props = this.props;
    var maskElement = void 0;
    if (props.mask) {
      var maskTransition = this.getMaskTransitionName();
      maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__LazyRenderBox__["a" /* default */], {
        style: this.getZIndexStyle(),
        key: 'mask',
        className: props.prefixCls + '-mask',
        hiddenClassName: props.prefixCls + '-mask-hidden',
        visible: props.visible
      });
      if (maskTransition) {
        maskElement = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
          __WEBPACK_IMPORTED_MODULE_8_rc_animate__["a" /* default */],
          {
            key: 'mask',
            showProp: 'visible',
            transitionAppear: true,
            component: '',
            transitionName: maskTransition
          },
          maskElement
        );
      }
    }
    return maskElement;
  };

  Popup.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      'div',
      null,
      this.getMaskElement(),
      this.getPopupElement()
    );
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Popup.propTypes = {
  visible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  style: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  getClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getRootDomNode: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,
  point: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    pageX: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
    pageY: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
  })
};

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.onAlign = function (popupDomNode, align) {
    var props = _this3.props;
    var currentAlignClassName = props.getClassNameFromAlign(align);
    // FIX: https://github.com/react-component/trigger/issues/56
    // FIX: https://github.com/react-component/tooltip/issues/79
    if (_this3.currentAlignClassName !== currentAlignClassName) {
      _this3.currentAlignClassName = currentAlignClassName;
      popupDomNode.className = _this3.getClassName(currentAlignClassName);
    }
    props.onAlign(popupDomNode, align);
  };

  this.setStretchSize = function () {
    var _props2 = _this3.props,
        stretch = _props2.stretch,
        getRootDomNode = _props2.getRootDomNode,
        visible = _props2.visible;
    var _state2 = _this3.state,
        stretchChecked = _state2.stretchChecked,
        targetHeight = _state2.targetHeight,
        targetWidth = _state2.targetWidth;


    if (!stretch || !visible) {
      if (stretchChecked) {
        _this3.setState({ stretchChecked: false });
      }
      return;
    }

    var $ele = getRootDomNode();
    if (!$ele) return;

    var height = $ele.offsetHeight;
    var width = $ele.offsetWidth;

    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
      _this3.setState({
        stretchChecked: true,
        targetHeight: height,
        targetWidth: width
      });
    }
  };

  this.getTargetElement = function () {
    return _this3.props.getRootDomNode();
  };

  this.getAlignTarget = function () {
    var point = _this3.props.point;

    if (point) {
      return point;
    }
    return _this3.getTargetElement;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (Popup);

/***/ }),
/* 3151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__ = __webpack_require__(1397);







var PopupInner = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(PopupInner, _Component);

  function PopupInner() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, PopupInner);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, _Component.apply(this, arguments));
  }

  PopupInner.prototype.render = function render() {
    var props = this.props;
    var className = props.className;
    if (!props.visible) {
      className += ' ' + props.hiddenClassName;
    }
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
      'div',
      {
        className: className,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onMouseDown: props.onMouseDown,
        onTouchStart: props.onTouchStart,
        style: props.style
      },
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5__LazyRenderBox__["a" /* default */],
        { className: props.prefixCls + '-content', visible: props.visible },
        props.children
      )
    );
  };

  return PopupInner;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

PopupInner.propTypes = {
  hiddenClassName: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  prefixCls: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onMouseDown: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  onTouchStart: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any
};


/* harmony default export */ __webpack_exports__["a"] = (PopupInner);

/***/ }),
/* 3152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(225);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__ = __webpack_require__(467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__ = __webpack_require__(1399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__ = __webpack_require__(3153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__ = __webpack_require__(3154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames__ = __webpack_require__(328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils__ = __webpack_require__(1398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Popup__ = __webpack_require__(3150);

















function noop() {}

function returnEmptyString() {
  return '';
}

function returnDocument() {
  return window.document;
}

var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];

var IS_REACT_16 = !!__WEBPACK_IMPORTED_MODULE_6_react_dom__["createPortal"];

var contextTypes = {
  rcTrigger: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    onPopupMouseDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};

var Trigger = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Trigger, _React$Component);

  function Trigger(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Trigger);

    var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, _React$Component.call(this, props));

    _initialiseProps.call(_this);

    var popupVisible = void 0;
    if ('popupVisible' in props) {
      popupVisible = !!props.popupVisible;
    } else {
      popupVisible = !!props.defaultPopupVisible;
    }

    _this.state = {
      prevPopupVisible: popupVisible,
      popupVisible: popupVisible
    };

    ALL_HANDLERS.forEach(function (h) {
      _this['fire' + h] = function (e) {
        _this.fireEvents(h, e);
      };
    });
    return _this;
  }

  Trigger.prototype.getChildContext = function getChildContext() {
    return {
      rcTrigger: {
        onPopupMouseDown: this.onPopupMouseDown
      }
    };
  };

  Trigger.prototype.componentDidMount = function componentDidMount() {
    this.componentDidUpdate({}, {
      popupVisible: this.state.popupVisible
    });
  };

  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
    var props = this.props;
    var state = this.state;
    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
      if (prevState.popupVisible !== state.popupVisible) {
        props.afterPopupVisibleChange(state.popupVisible);
      }
    };
    if (!IS_REACT_16) {
      this.renderComponent(null, triggerAfterPopupVisibleChange);
    }

    // We must listen to `mousedown` or `touchstart`, edge case:
    // https://github.com/ant-design/ant-design/issues/5804
    // https://github.com/react-component/calendar/issues/250
    // https://github.com/react-component/trigger/issues/50
    if (state.popupVisible) {
      var currentDocument = void 0;
      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
        currentDocument = props.getDocument();
        this.clickOutsideHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'mousedown', this.onDocumentClick);
      }
      // always hide on mobile
      if (!this.touchOutsideHandler) {
        currentDocument = currentDocument || props.getDocument();
        this.touchOutsideHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'touchstart', this.onDocumentClick);
      }
      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
        currentDocument = currentDocument || props.getDocument();
        this.contextMenuOutsideHandler1 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(currentDocument, 'scroll', this.onContextMenuClose);
      }
      // close popup when trigger type contains 'onContextMenu' and window is blur.
      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
        this.contextMenuOutsideHandler2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_rc_util_es_Dom_addEventListener__["a" /* default */])(window, 'blur', this.onContextMenuClose);
      }
      return;
    }

    this.clearOutsideHandler();
  };

  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
    this.clearDelayTimer();
    this.clearOutsideHandler();
    clearTimeout(this.mouseDownTimeout);
  };

  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var popupVisible = _ref.popupVisible;

    var newState = {};

    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
      newState.popupVisible = popupVisible;
      newState.prevPopupVisible = prevState.popupVisible;
    }

    return newState;
  };

  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
    // for test
    if (this._component && this._component.getPopupDomNode) {
      return this._component.getPopupDomNode();
    }
    return null;
  };

  Trigger.prototype.getPopupAlign = function getPopupAlign() {
    var props = this.props;
    var popupPlacement = props.popupPlacement,
        popupAlign = props.popupAlign,
        builtinPlacements = props.builtinPlacements;

    if (popupPlacement && builtinPlacements) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils__["a" /* getAlignFromPlacement */])(builtinPlacements, popupPlacement, popupAlign);
    }
    return popupAlign;
  };

  /**
   * @param popupVisible    Show or not the popup element
   * @param event           SyntheticEvent, used for `pointAlign`
   */
  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
    var alignPoint = this.props.alignPoint;
    var prevPopupVisible = this.state.popupVisible;


    this.clearDelayTimer();

    if (prevPopupVisible !== popupVisible) {
      if (!('popupVisible' in this.props)) {
        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
      }
      this.props.onPopupVisibleChange(popupVisible);
    }

    // Always record the point position since mouseEnterDelay will delay the show
    if (alignPoint && event) {
      this.setPoint(event);
    }
  };

  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
    var _this2 = this;

    var delay = delayS * 1000;
    this.clearDelayTimer();
    if (delay) {
      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
      this.delayTimer = setTimeout(function () {
        _this2.setPopupVisible(visible, point);
        _this2.clearDelayTimer();
      }, delay);
    } else {
      this.setPopupVisible(visible, event);
    }
  };

  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
    if (this.delayTimer) {
      clearTimeout(this.delayTimer);
      this.delayTimer = null;
    }
  };

  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
    if (this.clickOutsideHandler) {
      this.clickOutsideHandler.remove();
      this.clickOutsideHandler = null;
    }

    if (this.contextMenuOutsideHandler1) {
      this.contextMenuOutsideHandler1.remove();
      this.contextMenuOutsideHandler1 = null;
    }

    if (this.contextMenuOutsideHandler2) {
      this.contextMenuOutsideHandler2.remove();
      this.contextMenuOutsideHandler2 = null;
    }

    if (this.touchOutsideHandler) {
      this.touchOutsideHandler.remove();
      this.touchOutsideHandler = null;
    }
  };

  Trigger.prototype.createTwoChains = function createTwoChains(event) {
    var childPros = this.props.children.props;
    var props = this.props;
    if (childPros[event] && props[event]) {
      return this['fire' + event];
    }
    return childPros[event] || props[event];
  };

  Trigger.prototype.isClickToShow = function isClickToShow() {
    var _props = this.props,
        action = _props.action,
        showAction = _props.showAction;

    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
    var _props2 = this.props,
        action = _props2.action,
        showAction = _props2.showAction;

    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
  };

  Trigger.prototype.isClickToHide = function isClickToHide() {
    var _props3 = this.props,
        action = _props3.action,
        hideAction = _props3.hideAction;

    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
  };

  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
    var _props4 = this.props,
        action = _props4.action,
        showAction = _props4.showAction;

    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
  };

  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
    var _props5 = this.props,
        action = _props5.action,
        hideAction = _props5.hideAction;

    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
  };

  Trigger.prototype.isFocusToShow = function isFocusToShow() {
    var _props6 = this.props,
        action = _props6.action,
        showAction = _props6.showAction;

    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
  };

  Trigger.prototype.isBlurToHide = function isBlurToHide() {
    var _props7 = this.props,
        action = _props7.action,
        hideAction = _props7.hideAction;

    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
  };

  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
    if (this.state.popupVisible && this._component && this._component.alignInstance) {
      this._component.alignInstance.forceAlign();
    }
  };

  Trigger.prototype.fireEvents = function fireEvents(type, e) {
    var childCallback = this.props.children.props[type];
    if (childCallback) {
      childCallback(e);
    }
    var callback = this.props[type];
    if (callback) {
      callback(e);
    }
  };

  Trigger.prototype.close = function close() {
    this.setPopupVisible(false);
  };

  Trigger.prototype.render = function render() {
    var _this3 = this;

    var popupVisible = this.state.popupVisible;
    var _props8 = this.props,
        children = _props8.children,
        forceRender = _props8.forceRender,
        alignPoint = _props8.alignPoint,
        className = _props8.className;

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    var newChildProps = { key: 'trigger' };

    if (this.isContextMenuToShow()) {
      newChildProps.onContextMenu = this.onContextMenu;
    } else {
      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
    }

    if (this.isClickToHide() || this.isClickToShow()) {
      newChildProps.onClick = this.onClick;
      newChildProps.onMouseDown = this.onMouseDown;
      newChildProps.onTouchStart = this.onTouchStart;
    } else {
      newChildProps.onClick = this.createTwoChains('onClick');
      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
    }
    if (this.isMouseEnterToShow()) {
      newChildProps.onMouseEnter = this.onMouseEnter;
      if (alignPoint) {
        newChildProps.onMouseMove = this.onMouseMove;
      }
    } else {
      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
    }
    if (this.isMouseLeaveToHide()) {
      newChildProps.onMouseLeave = this.onMouseLeave;
    } else {
      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
    }
    if (this.isFocusToShow() || this.isBlurToHide()) {
      newChildProps.onFocus = this.onFocus;
      newChildProps.onBlur = this.onBlur;
    } else {
      newChildProps.onFocus = this.createTwoChains('onFocus');
      newChildProps.onBlur = this.createTwoChains('onBlur');
    }

    var childrenClassName = __WEBPACK_IMPORTED_MODULE_12_classnames___default()(child && child.props && child.props.className, className);
    if (childrenClassName) {
      newChildProps.className = childrenClassName;
    }
    var trigger = __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, newChildProps);

    if (!IS_REACT_16) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_10_rc_util_es_ContainerRender__["a" /* default */],
        {
          parent: this,
          visible: popupVisible,
          autoMount: false,
          forceRender: forceRender,
          getComponent: this.getComponent,
          getContainer: this.getContainer
        },
        function (_ref2) {
          var renderComponent = _ref2.renderComponent;

          _this3.renderComponent = renderComponent;
          return trigger;
        }
      );
    }

    var portal = void 0;
    // prevent unmounting after it's rendered
    if (popupVisible || this._component || forceRender) {
      portal = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_11_rc_util_es_Portal__["a" /* default */],
        { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
        this.getComponent()
      );
    }

    return [trigger, portal];
  };

  return Trigger;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Trigger.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  action: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string)]),
  showAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  hideAction: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  getPopupClassNameFromAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  onPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  afterPopupVisibleChange: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func]).isRequired,
  popupStyle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  prefixCls: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  popupPlacement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  builtinPlacements: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  popupAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  mouseEnterDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  mouseLeaveDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  zIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  focusDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  blurDelay: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,
  getPopupContainer: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  getDocument: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  forceRender: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  destroyPopupOnHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  mask: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskClosable: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  onPopupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  popupAlign: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object,
  popupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  defaultPopupVisible: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  maskTransitionName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object]),
  maskAnimation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  stretch: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  alignPoint: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool // Maybe we can support user pass position in the future
};
Trigger.contextTypes = contextTypes;
Trigger.childContextTypes = contextTypes;
Trigger.defaultProps = {
  prefixCls: 'rc-trigger-popup',
  getPopupClassNameFromAlign: returnEmptyString,
  getDocument: returnDocument,
  onPopupVisibleChange: noop,
  afterPopupVisibleChange: noop,
  onPopupAlign: noop,
  popupClassName: '',
  mouseEnterDelay: 0,
  mouseLeaveDelay: 0.1,
  focusDelay: 0,
  blurDelay: 0.15,
  popupStyle: {},
  destroyPopupOnHide: false,
  popupAlign: {},
  defaultPopupVisible: false,
  mask: false,
  maskClosable: true,
  action: [],
  showAction: [],
  hideAction: []
};

var _initialiseProps = function _initialiseProps() {
  var _this4 = this;

  this.onMouseEnter = function (e) {
    var mouseEnterDelay = _this4.props.mouseEnterDelay;

    _this4.fireEvents('onMouseEnter', e);
    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
  };

  this.onMouseMove = function (e) {
    _this4.fireEvents('onMouseMove', e);
    _this4.setPoint(e);
  };

  this.onMouseLeave = function (e) {
    _this4.fireEvents('onMouseLeave', e);
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onPopupMouseEnter = function () {
    _this4.clearDelayTimer();
  };

  this.onPopupMouseLeave = function (e) {
    // https://github.com/react-component/trigger/pull/13
    // react bug?
    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
      return;
    }
    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
  };

  this.onFocus = function (e) {
    _this4.fireEvents('onFocus', e);
    // incase focusin and focusout
    _this4.clearDelayTimer();
    if (_this4.isFocusToShow()) {
      _this4.focusTime = Date.now();
      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
    }
  };

  this.onMouseDown = function (e) {
    _this4.fireEvents('onMouseDown', e);
    _this4.preClickTime = Date.now();
  };

  this.onTouchStart = function (e) {
    _this4.fireEvents('onTouchStart', e);
    _this4.preTouchTime = Date.now();
  };

  this.onBlur = function (e) {
    _this4.fireEvents('onBlur', e);
    _this4.clearDelayTimer();
    if (_this4.isBlurToHide()) {
      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
    }
  };

  this.onContextMenu = function (e) {
    e.preventDefault();
    _this4.fireEvents('onContextMenu', e);
    _this4.setPopupVisible(true, e);
  };

  this.onContextMenuClose = function () {
    if (_this4.isContextMenuToShow()) {
      _this4.close();
    }
  };

  this.onClick = function (event) {
    _this4.fireEvents('onClick', event);
    // focus will trigger click
    if (_this4.focusTime) {
      var preTime = void 0;
      if (_this4.preClickTime && _this4.preTouchTime) {
        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
      } else if (_this4.preClickTime) {
        preTime = _this4.preClickTime;
      } else if (_this4.preTouchTime) {
        preTime = _this4.preTouchTime;
      }
      if (Math.abs(preTime - _this4.focusTime) < 20) {
        return;
      }
      _this4.focusTime = 0;
    }
    _this4.preClickTime = 0;
    _this4.preTouchTime = 0;

    // Only prevent default when all the action is click.
    // https://github.com/ant-design/ant-design/issues/17043
    // https://github.com/ant-design/ant-design/issues/17291
    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
      event.preventDefault();
    }
    var nextVisible = !_this4.state.popupVisible;
    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
      _this4.setPopupVisible(!_this4.state.popupVisible, event);
    }
  };

  this.onPopupMouseDown = function () {
    var _context$rcTrigger = _this4.context.rcTrigger,
        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;

    _this4.hasPopupMouseDown = true;

    clearTimeout(_this4.mouseDownTimeout);
    _this4.mouseDownTimeout = setTimeout(function () {
      _this4.hasPopupMouseDown = false;
    }, 0);

    if (rcTrigger.onPopupMouseDown) {
      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
    }
  };

  this.onDocumentClick = function (event) {
    if (_this4.props.mask && !_this4.props.maskClosable) {
      return;
    }

    var target = event.target;
    var root = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_Dom_contains__["a" /* default */])(root, target) && !_this4.hasPopupMouseDown) {
      _this4.close();
    }
  };

  this.getRootDomNode = function () {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4);
  };

  this.getPopupClassNameFromAlign = function (align) {
    var className = [];
    var _props9 = _this4.props,
        popupPlacement = _props9.popupPlacement,
        builtinPlacements = _props9.builtinPlacements,
        prefixCls = _props9.prefixCls,
        alignPoint = _props9.alignPoint,
        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;

    if (popupPlacement && builtinPlacements) {
      className.push(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__utils__["b" /* getAlignPopupClassName */])(builtinPlacements, prefixCls, align, alignPoint));
    }
    if (getPopupClassNameFromAlign) {
      className.push(getPopupClassNameFromAlign(align));
    }
    return className.join(' ');
  };

  this.getComponent = function () {
    var _props10 = _this4.props,
        prefixCls = _props10.prefixCls,
        destroyPopupOnHide = _props10.destroyPopupOnHide,
        popupClassName = _props10.popupClassName,
        action = _props10.action,
        onPopupAlign = _props10.onPopupAlign,
        popupAnimation = _props10.popupAnimation,
        popupTransitionName = _props10.popupTransitionName,
        popupStyle = _props10.popupStyle,
        mask = _props10.mask,
        maskAnimation = _props10.maskAnimation,
        maskTransitionName = _props10.maskTransitionName,
        zIndex = _props10.zIndex,
        popup = _props10.popup,
        stretch = _props10.stretch,
        alignPoint = _props10.alignPoint;
    var _state = _this4.state,
        popupVisible = _state.popupVisible,
        point = _state.point;


    var align = _this4.getPopupAlign();

    var mouseProps = {};
    if (_this4.isMouseEnterToShow()) {
      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
    }
    if (_this4.isMouseLeaveToHide()) {
      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
    }

    mouseProps.onMouseDown = _this4.onPopupMouseDown;
    mouseProps.onTouchStart = _this4.onPopupMouseDown;

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(
      __WEBPACK_IMPORTED_MODULE_14__Popup__["a" /* default */],
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        prefixCls: prefixCls,
        destroyPopupOnHide: destroyPopupOnHide,
        visible: popupVisible,
        point: alignPoint && point,
        className: popupClassName,
        action: action,
        align: align,
        onAlign: onPopupAlign,
        animation: popupAnimation,
        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
      }, mouseProps, {
        stretch: stretch,
        getRootDomNode: _this4.getRootDomNode,
        style: popupStyle,
        mask: mask,
        zIndex: zIndex,
        transitionName: popupTransitionName,
        maskAnimation: maskAnimation,
        maskTransitionName: maskTransitionName,
        ref: _this4.savePopup
      }),
      typeof popup === 'function' ? popup() : popup
    );
  };

  this.getContainer = function () {
    var props = _this4.props;

    var popupContainer = document.createElement('div');
    // Make sure default popup container will never cause scrollbar appearing
    // https://github.com/react-component/trigger/issues/41
    popupContainer.style.position = 'absolute';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    var mountNode = props.getPopupContainer ? props.getPopupContainer(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react_dom__["findDOMNode"])(_this4)) : props.getDocument().body;
    mountNode.appendChild(popupContainer);
    return popupContainer;
  };

  this.setPoint = function (point) {
    var alignPoint = _this4.props.alignPoint;

    if (!alignPoint || !point) return;

    _this4.setState({
      point: {
        pageX: point.pageX,
        pageY: point.pageY
      }
    });
  };

  this.handlePortalUpdate = function () {
    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
    }
  };

  this.savePopup = function (node) {
    _this4._component = node;
  };
};

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react_lifecycles_compat__["polyfill"])(Trigger);

/* harmony default export */ __webpack_exports__["a"] = (Trigger);

/***/ }),
/* 3153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ContainerRender; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }





var ContainerRender =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ContainerRender, _React$Component);

  function ContainerRender() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ContainerRender);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ContainerRender)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.removeContainer = function () {
      if (_this.container) {
        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unmountComponentAtNode(_this.container);

        _this.container.parentNode.removeChild(_this.container);

        _this.container = null;
      }
    };

    _this.renderComponent = function (props, ready) {
      var _this$props = _this.props,
          visible = _this$props.visible,
          getComponent = _this$props.getComponent,
          forceRender = _this$props.forceRender,
          getContainer = _this$props.getContainer,
          parent = _this$props.parent;

      if (visible || parent._component || forceRender) {
        if (!_this.container) {
          _this.container = getContainer();
        }

        __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
          if (ready) {
            ready.call(this);
          }
        });
      }
    };

    return _this;
  }

  _createClass(ContainerRender, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this.props.autoMount) {
        this.renderComponent();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.autoDestroy) {
        this.removeContainer();
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children({
        renderComponent: this.renderComponent,
        removeContainer: this.removeContainer
      });
    }
  }]);

  return ContainerRender;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

ContainerRender.propTypes = {
  autoMount: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  autoDestroy: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  visible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  forceRender: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  parent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  getComponent: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
ContainerRender.defaultProps = {
  autoMount: true,
  autoDestroy: true,
  forceRender: false
};


/***/ }),
/* 3154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Portal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }





var Portal =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    _classCallCheck(this, Portal);

    return _possibleConstructorReturn(this, _getPrototypeOf(Portal).apply(this, arguments));
  }

  _createClass(Portal, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.createContainer();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didUpdate = this.props.didUpdate;

      if (didUpdate) {
        didUpdate(prevProps);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.removeContainer();
    }
  }, {
    key: "createContainer",
    value: function createContainer() {
      this._container = this.props.getContainer();
      this.forceUpdate();
    }
  }, {
    key: "removeContainer",
    value: function removeContainer() {
      if (this._container) {
        this._container.parentNode.removeChild(this._container);
      }
    }
  }, {
    key: "render",
    value: function render() {
      if (this._container) {
        return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(this.props.children, this._container);
      }

      return null;
    }
  }]);

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Portal.propTypes = {
  getContainer: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node.isRequired,
  didUpdate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};


/***/ }),
/* 3155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (unsafeLifecyclesPolyfill);

/***/ }),
/* 3156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _reactLifecyclesCompat = __webpack_require__(467);

var _mergeClassNames = _interopRequireDefault(__webpack_require__(1260));

var _Navigation = _interopRequireDefault(__webpack_require__(3157));

var _CenturyView = _interopRequireDefault(__webpack_require__(1401));

var _DecadeView = _interopRequireDefault(__webpack_require__(1402));

var _YearView = _interopRequireDefault(__webpack_require__(1404));

var _MonthView = _interopRequireDefault(__webpack_require__(1403));

var _dates = __webpack_require__(122);

var _propTypes2 = __webpack_require__(100);

var _utils = __webpack_require__(1406);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var baseClassName = 'react-calendar';
var allViews = ['century', 'decade', 'year', 'month'];
var allValueTypes = [].concat(_toConsumableArray(allViews.slice(1)), ['day']);

var datesAreDifferent = function datesAreDifferent(date1, date2) {
  return date1 && !date2 || !date1 && date2 || date1 && date2 && date1.getTime() !== date2.getTime();
};
/**
 * Returns views array with disallowed values cut off.
 */


var getLimitedViews = function getLimitedViews(minDetail, maxDetail) {
  return allViews.slice(allViews.indexOf(minDetail), allViews.indexOf(maxDetail) + 1);
};
/**
 * Determines whether a given view is allowed with currently applied settings.
 */


var isViewAllowed = function isViewAllowed(view, minDetail, maxDetail) {
  var views = getLimitedViews(minDetail, maxDetail);
  return views.indexOf(view) !== -1;
};
/**
 * Gets either provided view if allowed by minDetail and maxDetail, or gets
 * the default view if not allowed.
 */


var getView = function getView(view, minDetail, maxDetail) {
  if (isViewAllowed(view, minDetail, maxDetail)) {
    return view;
  }

  return getLimitedViews(minDetail, maxDetail).pop();
};
/**
 * Returns value type that can be returned with currently applied settings.
 */


var getValueType = function getValueType(maxDetail) {
  return allValueTypes[allViews.indexOf(maxDetail)];
};

var getValueFrom = function getValueFrom(value) {
  if (!value) {
    return null;
  }

  var rawValueFrom = value instanceof Array && value.length === 2 ? value[0] : value;

  if (!rawValueFrom) {
    return null;
  }

  var valueFromDate = new Date(rawValueFrom);

  if (isNaN(valueFromDate.getTime())) {
    throw new Error("Invalid date: ".concat(value));
  }

  return valueFromDate;
};

var getDetailValueFrom = function getDetailValueFrom(value, minDate, maxDate, maxDetail) {
  var valueFrom = getValueFrom(value);

  if (!valueFrom) {
    return null;
  }

  var detailValueFrom = (0, _dates.getBegin)(getValueType(maxDetail), valueFrom);
  return (0, _utils.between)(detailValueFrom, minDate, maxDate);
};

var getValueTo = function getValueTo(value) {
  if (!value) {
    return null;
  }

  var rawValueTo = value instanceof Array && value.length === 2 ? value[1] : value;

  if (!rawValueTo) {
    return null;
  }

  var valueToDate = new Date(rawValueTo);

  if (isNaN(valueToDate.getTime())) {
    throw new Error("Invalid date: ".concat(value));
  }

  return valueToDate;
};

var getDetailValueTo = function getDetailValueTo(value, minDate, maxDate, maxDetail) {
  var valueTo = getValueTo(value);

  if (!valueTo) {
    return null;
  }

  var detailValueTo = (0, _dates.getEnd)(getValueType(maxDetail), valueTo);
  return (0, _utils.between)(detailValueTo, minDate, maxDate);
};

var getDetailValueArray = function getDetailValueArray(value, minDate, maxDate, maxDetail) {
  if (value instanceof Array) {
    return value;
  }

  return [getDetailValueFrom(value, minDate, maxDate, maxDetail), getDetailValueTo(value, minDate, maxDate, maxDetail)];
};

var getActiveStartDate = function getActiveStartDate(props) {
  var activeStartDate = props.activeStartDate,
      maxDate = props.maxDate,
      maxDetail = props.maxDetail,
      minDate = props.minDate,
      minDetail = props.minDetail,
      value = props.value,
      view = props.view;
  var rangeType = getView(view, minDetail, maxDetail);
  var valueFrom = getDetailValueFrom(value, minDate, maxDate, maxDetail) || activeStartDate || new Date();
  return (0, _dates.getBegin)(rangeType, valueFrom);
};

var Calendar =
/*#__PURE__*/
function (_Component) {
  _inherits(Calendar, _Component);

  function Calendar() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Calendar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Calendar)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {});

    _defineProperty(_assertThisInitialized(_this), "setActiveStartDate", function (activeStartDate) {
      var onActiveDateChange = _this.props.onActiveDateChange;

      _this.setState({
        activeStartDate: activeStartDate
      }, function () {
        var view = _this.state.view;
        (0, _utils.callIfDefined)(onActiveDateChange, {
          activeStartDate: activeStartDate,
          view: view
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "drillDown", function (activeStartDate) {
      if (!_this.drillDownAvailable) {
        return;
      }

      var _this$props = _this.props,
          maxDetail = _this$props.maxDetail,
          minDetail = _this$props.minDetail,
          onDrillDown = _this$props.onDrillDown;
      var views = getLimitedViews(minDetail, maxDetail);

      _this.setState(function (prevState) {
        var nextView = views[views.indexOf(prevState.view) + 1];
        return {
          activeStartDate: activeStartDate,
          view: nextView
        };
      }, function () {
        var view = _this.state.view;
        (0, _utils.callIfDefined)(onDrillDown, {
          activeStartDate: activeStartDate,
          view: view
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "drillUp", function () {
      if (!_this.drillUpAvailable) {
        return;
      }

      var _this$props2 = _this.props,
          maxDetail = _this$props2.maxDetail,
          minDetail = _this$props2.minDetail,
          onDrillUp = _this$props2.onDrillUp;
      var views = getLimitedViews(minDetail, maxDetail);

      _this.setState(function (prevState) {
        var nextView = views[views.indexOf(prevState.view) - 1];
        var activeStartDate = (0, _dates.getBegin)(nextView, prevState.activeStartDate);
        return {
          activeStartDate: activeStartDate,
          view: nextView
        };
      }, function () {
        var _this$state = _this.state,
            activeStartDate = _this$state.activeStartDate,
            view = _this$state.view;
        (0, _utils.callIfDefined)(onDrillUp, {
          activeStartDate: activeStartDate,
          view: view
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          selectRange = _this$props3.selectRange;
      var nextValue;
      var callback;

      if (selectRange) {
        var previousValue = _this.state.value; // Range selection turned on

        if (!previousValue || [].concat(previousValue).length !== 1 // 0 or 2 - either way we're starting a new array
        ) {
            // First value
            nextValue = (0, _dates.getBegin)(_this.valueType, value);
          } else {
          // Second value
          nextValue = (0, _dates.getValueRange)(_this.valueType, previousValue, value);

          callback = function callback() {
            return (0, _utils.callIfDefined)(onChange, nextValue);
          };
        }
      } else {
        // Range selection turned off
        nextValue = _this.getProcessedValue(value);

        callback = function callback() {
          return (0, _utils.callIfDefined)(onChange, nextValue);
        };
      }

      _this.setState({
        value: nextValue
      }, callback);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseOver", function (value) {
      _this.setState(function (prevState) {
        if (prevState.hover && prevState.hover.getTime() === value.getTime()) {
          return null;
        }

        return {
          hover: value
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      _this.setState({
        hover: null
      });
    });

    return _this;
  }

  _createClass(Calendar, [{
    key: "getProcessedValue",

    /**
     * Gets current value in a desired format.
     */
    value: function getProcessedValue(value) {
      var _this$props4 = this.props,
          minDate = _this$props4.minDate,
          maxDate = _this$props4.maxDate,
          maxDetail = _this$props4.maxDetail,
          returnValue = _this$props4.returnValue;

      var processFunction = function () {
        switch (returnValue) {
          case 'start':
            return getDetailValueFrom;

          case 'end':
            return getDetailValueTo;

          case 'range':
            return getDetailValueArray;

          default:
            throw new Error('Invalid returnValue.');
        }
      }();

      return processFunction(value, minDate, maxDate, maxDetail);
    }
    /**
     * Called when the user uses navigation buttons.
     */

  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props5 = this.props,
          calendarType = _this$props5.calendarType,
          locale = _this$props5.locale,
          maxDate = _this$props5.maxDate,
          minDate = _this$props5.minDate,
          renderChildren = _this$props5.renderChildren,
          selectRange = _this$props5.selectRange,
          tileClassName = _this$props5.tileClassName,
          tileContent = _this$props5.tileContent,
          tileDisabled = _this$props5.tileDisabled;
      var _this$state2 = this.state,
          activeStartDate = _this$state2.activeStartDate,
          hover = _this$state2.hover,
          value = _this$state2.value,
          view = _this$state2.view;
      var onMouseOver = this.onMouseOver,
          valueType = this.valueType;
      var commonProps = {
        activeStartDate: activeStartDate,
        hover: hover,
        locale: locale,
        maxDate: maxDate,
        minDate: minDate,
        onMouseOver: selectRange ? onMouseOver : null,
        tileClassName: tileClassName,
        tileContent: tileContent || renderChildren,
        // For backwards compatibility
        tileDisabled: tileDisabled,
        value: value,
        valueType: valueType
      };
      var clickAction = this.drillDownAvailable ? this.drillDown : this.onChange;

      switch (view) {
        case 'century':
          {
            var onClickDecade = this.props.onClickDecade;
            return _react["default"].createElement(_CenturyView["default"], _extends({
              onClick: (0, _utils.mergeFunctions)(clickAction, onClickDecade)
            }, commonProps));
          }

        case 'decade':
          {
            var onClickYear = this.props.onClickYear;
            return _react["default"].createElement(_DecadeView["default"], _extends({
              onClick: (0, _utils.mergeFunctions)(clickAction, onClickYear)
            }, commonProps));
          }

        case 'year':
          {
            var _this$props6 = this.props,
                formatMonth = _this$props6.formatMonth,
                onClickMonth = _this$props6.onClickMonth;
            return _react["default"].createElement(_YearView["default"], _extends({
              formatMonth: formatMonth,
              onClick: (0, _utils.mergeFunctions)(clickAction, onClickMonth)
            }, commonProps));
          }

        case 'month':
          {
            var _this$props7 = this.props,
                formatShortWeekday = _this$props7.formatShortWeekday,
                onClickDay = _this$props7.onClickDay,
                onClickWeekNumber = _this$props7.onClickWeekNumber,
                showFixedNumberOfWeeks = _this$props7.showFixedNumberOfWeeks,
                showNeighboringMonth = _this$props7.showNeighboringMonth,
                showWeekNumbers = _this$props7.showWeekNumbers;
            var onMouseLeave = this.onMouseLeave;
            return _react["default"].createElement(_MonthView["default"], _extends({
              calendarType: calendarType,
              formatShortWeekday: formatShortWeekday,
              onClick: (0, _utils.mergeFunctions)(clickAction, onClickDay),
              onClickWeekNumber: onClickWeekNumber,
              onMouseLeave: onMouseLeave,
              showFixedNumberOfWeeks: showFixedNumberOfWeeks,
              showNeighboringMonth: showNeighboringMonth,
              showWeekNumbers: showWeekNumbers
            }, commonProps));
          }

        default:
          throw new Error("Invalid view: ".concat(view, "."));
      }
    }
  }, {
    key: "renderNavigation",
    value: function renderNavigation() {
      var showNavigation = this.props.showNavigation;

      if (!showNavigation) {
        return null;
      }

      var _this$props8 = this.props,
          formatMonthYear = _this$props8.formatMonthYear,
          locale = _this$props8.locale,
          maxDate = _this$props8.maxDate,
          maxDetail = _this$props8.maxDetail,
          minDate = _this$props8.minDate,
          minDetail = _this$props8.minDetail,
          navigationAriaLabel = _this$props8.navigationAriaLabel,
          navigationLabel = _this$props8.navigationLabel,
          next2AriaLabel = _this$props8.next2AriaLabel,
          next2Label = _this$props8.next2Label,
          nextAriaLabel = _this$props8.nextAriaLabel,
          nextLabel = _this$props8.nextLabel,
          prev2AriaLabel = _this$props8.prev2AriaLabel,
          prev2Label = _this$props8.prev2Label,
          prevAriaLabel = _this$props8.prevAriaLabel,
          prevLabel = _this$props8.prevLabel;
      var _this$state3 = this.state,
          activeStartDate = _this$state3.activeStartDate,
          view = _this$state3.view;
      return _react["default"].createElement(_Navigation["default"], {
        activeStartDate: activeStartDate,
        drillUp: this.drillUp,
        formatMonthYear: formatMonthYear,
        locale: locale,
        maxDate: maxDate,
        minDate: minDate,
        navigationAriaLabel: navigationAriaLabel,
        navigationLabel: navigationLabel,
        next2AriaLabel: next2AriaLabel,
        next2Label: next2Label,
        nextAriaLabel: nextAriaLabel,
        nextLabel: nextLabel,
        prev2AriaLabel: prev2AriaLabel,
        prev2Label: prev2Label,
        prevAriaLabel: prevAriaLabel,
        prevLabel: prevLabel,
        setActiveStartDate: this.setActiveStartDate,
        view: view,
        views: getLimitedViews(minDetail, maxDetail)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
          className = _this$props9.className,
          selectRange = _this$props9.selectRange;
      var value = this.state.value;
      var onMouseLeave = this.onMouseLeave;
      var valueArray = [].concat(value);
      return _react["default"].createElement("div", {
        className: (0, _mergeClassNames["default"])(baseClassName, selectRange && valueArray.length === 1 && "".concat(baseClassName, "--selectRange"), className)
      }, this.renderNavigation(), _react["default"].createElement("div", {
        className: "".concat(baseClassName, "__viewContainer"),
        onBlur: selectRange ? onMouseLeave : null,
        onMouseLeave: selectRange ? onMouseLeave : null
      }, this.renderContent()));
    }
  }, {
    key: "drillDownAvailable",
    get: function get() {
      var _this$props10 = this.props,
          maxDetail = _this$props10.maxDetail,
          minDetail = _this$props10.minDetail;
      var view = this.state.view;
      var views = getLimitedViews(minDetail, maxDetail);
      return views.indexOf(view) < views.length - 1;
    }
  }, {
    key: "drillUpAvailable",
    get: function get() {
      var _this$props11 = this.props,
          maxDetail = _this$props11.maxDetail,
          minDetail = _this$props11.minDetail;
      var view = this.state.view;
      var views = getLimitedViews(minDetail, maxDetail);
      return views.indexOf(view) > 0;
    }
  }, {
    key: "valueType",
    get: function get() {
      var maxDetail = this.props.maxDetail;
      return getValueType(maxDetail);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      var minDate = nextProps.minDate,
          maxDate = nextProps.maxDate,
          minDetail = nextProps.minDetail,
          maxDetail = nextProps.maxDetail;
      var nextState = {};
      /**
       * If the next activeStartDate is different from the current one, update
       * activeStartDate (for display) and activeStartDateProps (for future comparisons)
       */

      var nextActiveStartDate = getActiveStartDate(nextProps);

      if (datesAreDifferent(nextActiveStartDate, prevState.activeStartDateProps)) {
        nextState.activeStartDate = nextActiveStartDate;
        nextState.activeStartDateProps = nextActiveStartDate;
      }
      /**
       * If the next view is different from the current one, and the previously set view is not
       * valid based on minDetail and maxDetail, get a new one.
       */


      var nextView = getView(nextProps.view, minDetail, maxDetail);

      if (nextView !== prevState.viewProps && !isViewAllowed(prevState.view, minDetail, maxDetail)) {
        nextState.view = nextView;
        nextState.viewProps = nextView;
      }
      /**
       * If the next value is different from the current one (with an exception of situation in
       * which values provided are limited by minDate and maxDate so that the dates are the same),
       * get a new one.
       */


      var values = [nextProps.value, prevState.valueProps];

      if (nextState.view // Allowed view changed
      || datesAreDifferent.apply(void 0, _toConsumableArray(values.map(function (value) {
        return getValueFrom(value, minDate, maxDate, maxDetail);
      }))) || datesAreDifferent.apply(void 0, _toConsumableArray(values.map(function (value) {
        return getValueTo(value, minDate, maxDate, maxDetail);
      })))) {
        nextState.value = nextProps.value;
        nextState.valueProps = nextProps.value;
      }

      if (!nextProps.selectRange && prevState.hover) {
        nextState.hover = null;
      }

      return nextState;
    }
  }]);

  return Calendar;
}(_react.Component);

exports["default"] = Calendar;
Calendar.defaultProps = {
  maxDetail: 'month',
  minDetail: 'century',
  returnValue: 'start',
  showNavigation: true,
  showNeighboringMonth: true,
  view: 'month'
};
Calendar.propTypes = {
  activeStartDate: _propTypes["default"].instanceOf(Date),
  calendarType: _propTypes2.isCalendarType,
  className: _propTypes2.isClassName,
  formatMonth: _propTypes["default"].func,
  formatMonthYear: _propTypes["default"].func,
  formatShortWeekday: _propTypes["default"].func,
  locale: _propTypes["default"].string,
  maxDate: _propTypes2.isMaxDate,
  maxDetail: _propTypes["default"].oneOf(allViews),
  minDate: _propTypes2.isMinDate,
  minDetail: _propTypes["default"].oneOf(allViews),
  navigationAriaLabel: _propTypes["default"].string,
  navigationLabel: _propTypes["default"].func,
  next2AriaLabel: _propTypes["default"].string,
  next2Label: _propTypes["default"].node,
  nextAriaLabel: _propTypes["default"].string,
  nextLabel: _propTypes["default"].node,
  onActiveDateChange: _propTypes["default"].func,
  onChange: _propTypes["default"].func,
  onClickDay: _propTypes["default"].func,
  onClickDecade: _propTypes["default"].func,
  onClickMonth: _propTypes["default"].func,
  onClickWeekNumber: _propTypes["default"].func,
  onClickYear: _propTypes["default"].func,
  onDrillDown: _propTypes["default"].func,
  onDrillUp: _propTypes["default"].func,
  prev2AriaLabel: _propTypes["default"].string,
  prev2Label: _propTypes["default"].node,
  prevAriaLabel: _propTypes["default"].string,
  prevLabel: _propTypes["default"].node,
  renderChildren: _propTypes["default"].func,
  // For backwards compatibility
  returnValue: _propTypes["default"].oneOf(['start', 'end', 'range']),
  selectRange: _propTypes["default"].bool,
  showFixedNumberOfWeeks: _propTypes["default"].bool,
  showNavigation: _propTypes["default"].bool,
  showNeighboringMonth: _propTypes["default"].bool,
  showWeekNumbers: _propTypes["default"].bool,
  tileClassName: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes2.isClassName]),
  tileContent: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].node]),
  tileDisabled: _propTypes["default"].func,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes2.isValue]),
  view: _propTypes["default"].oneOf(allViews)
};
(0, _reactLifecyclesCompat.polyfill)(Calendar);

/***/ }),
/* 3157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Navigation;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _dates = __webpack_require__(122);

var _dateFormatter = __webpack_require__(458);

var _propTypes2 = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var className = 'react-calendar__navigation';

function Navigation(_ref) {
  var date = _ref.activeStartDate,
      drillUp = _ref.drillUp,
      formatMonthYear = _ref.formatMonthYear,
      locale = _ref.locale,
      maxDate = _ref.maxDate,
      minDate = _ref.minDate,
      navigationAriaLabel = _ref.navigationAriaLabel,
      navigationLabel = _ref.navigationLabel,
      next2AriaLabel = _ref.next2AriaLabel,
      next2Label = _ref.next2Label,
      nextAriaLabel = _ref.nextAriaLabel,
      nextLabel = _ref.nextLabel,
      prev2AriaLabel = _ref.prev2AriaLabel,
      prev2Label = _ref.prev2Label,
      prevAriaLabel = _ref.prevAriaLabel,
      prevLabel = _ref.prevLabel,
      setActiveStartDate = _ref.setActiveStartDate,
      view = _ref.view,
      views = _ref.views;
  var drillUpAvailable = views.indexOf(view) > 0;
  var shouldShowPrevNext2Buttons = view !== 'century';
  var previousActiveStartDate = (0, _dates.getBeginPrevious)(view, date);
  var previousActiveStartDate2 = shouldShowPrevNext2Buttons && (0, _dates.getBeginPrevious2)(view, date);
  var nextActiveStartDate = (0, _dates.getBeginNext)(view, date);
  var nextActiveStartDate2 = shouldShowPrevNext2Buttons && (0, _dates.getBeginNext2)(view, date);

  var prevButtonDisabled = function () {
    if (previousActiveStartDate.getFullYear() < 1000) {
      return true;
    }

    var previousActiveEndDate = (0, _dates.getEndPrevious)(view, date);
    return minDate && minDate >= previousActiveEndDate;
  }();

  var prev2ButtonDisabled = shouldShowPrevNext2Buttons && function () {
    if (previousActiveStartDate2.getFullYear() < 1000) {
      return true;
    }

    var previousActiveEndDate = (0, _dates.getEndPrevious2)(view, date);
    return minDate && minDate >= previousActiveEndDate;
  }();

  var nextButtonDisabled = maxDate && maxDate <= nextActiveStartDate;
  var next2ButtonDisabled = shouldShowPrevNext2Buttons && maxDate && maxDate <= nextActiveStartDate2;

  function onClickPrevious() {
    setActiveStartDate(previousActiveStartDate);
  }

  function onClickPrevious2() {
    setActiveStartDate(previousActiveStartDate2);
  }

  function onClickNext() {
    setActiveStartDate(nextActiveStartDate);
  }

  function onClickNext2() {
    setActiveStartDate(nextActiveStartDate2);
  }

  var label = function () {
    switch (view) {
      case 'century':
        return (0, _dates.getCenturyLabel)(date);

      case 'decade':
        return (0, _dates.getDecadeLabel)(date);

      case 'year':
        return (0, _dates.getYear)(date);

      case 'month':
        return formatMonthYear(locale, date);

      default:
        throw new Error("Invalid view: ".concat(view, "."));
    }
  }();

  return _react["default"].createElement("div", {
    className: className,
    style: {
      display: 'flex'
    }
  }, prev2Label !== null && shouldShowPrevNext2Buttons && _react["default"].createElement("button", {
    "aria-label": prev2AriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__prev2-button"),
    disabled: prev2ButtonDisabled,
    onClick: onClickPrevious2,
    type: "button"
  }, prev2Label), _react["default"].createElement("button", {
    "aria-label": prevAriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__prev-button"),
    disabled: prevButtonDisabled,
    onClick: onClickPrevious,
    type: "button"
  }, prevLabel), _react["default"].createElement("button", {
    "aria-label": navigationAriaLabel,
    className: "react-calendar__navigation__label",
    disabled: !drillUpAvailable,
    onClick: drillUp,
    style: {
      flexGrow: 1
    },
    type: "button"
  }, navigationLabel ? navigationLabel({
    date: date,
    view: view,
    label: label
  }) : label), _react["default"].createElement("button", {
    "aria-label": nextAriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__next-button"),
    disabled: nextButtonDisabled,
    onClick: onClickNext,
    type: "button"
  }, nextLabel), next2Label !== null && shouldShowPrevNext2Buttons && _react["default"].createElement("button", {
    "aria-label": next2AriaLabel,
    className: "".concat(className, "__arrow ").concat(className, "__next2-button"),
    disabled: next2ButtonDisabled,
    onClick: onClickNext2,
    type: "button"
  }, next2Label));
}

Navigation.defaultProps = {
  formatMonthYear: _dateFormatter.formatMonthYear,
  navigationAriaLabel: '',
  next2AriaLabel: '',
  next2Label: '»',
  nextAriaLabel: '',
  nextLabel: '›',
  prev2AriaLabel: '',
  prev2Label: '«',
  prevAriaLabel: '',
  prevLabel: '‹'
};
Navigation.propTypes = {
  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
  drillUp: _propTypes["default"].func.isRequired,
  formatMonthYear: _propTypes["default"].func,
  locale: _propTypes["default"].string,
  maxDate: _propTypes["default"].instanceOf(Date),
  minDate: _propTypes["default"].instanceOf(Date),
  navigationAriaLabel: _propTypes["default"].string,
  navigationLabel: _propTypes["default"].func,
  next2AriaLabel: _propTypes["default"].string,
  next2Label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  nextAriaLabel: _propTypes["default"].string,
  nextLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  prev2AriaLabel: _propTypes["default"].string,
  prev2Label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  prevAriaLabel: _propTypes["default"].string,
  prevLabel: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]),
  setActiveStartDate: _propTypes["default"].func.isRequired,
  view: _propTypes2.isView.isRequired,
  views: _propTypes2.isViews.isRequired
};

/***/ }),
/* 3158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Decade;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _Tile = _interopRequireDefault(__webpack_require__(456));

var _dates = __webpack_require__(122);

var _propTypes2 = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var className = 'react-calendar__century-view__decades__decade';

function Decade(_ref) {
  var classes = _ref.classes,
      point = _ref.point,
      otherProps = _objectWithoutProperties(_ref, ["classes", "point"]);

  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
    classes: [].concat(classes, className),
    maxDateTransform: _dates.getEndOfDecade,
    minDateTransform: _dates.getBeginOfDecade,
    view: "century"
  }), (0, _dates.getDecadeLabel)(point));
}

Decade.propTypes = _objectSpread({}, _propTypes2.tileProps, {
  point: _propTypes["default"].number.isRequired
});

/***/ }),
/* 3159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Decades;

var _react = _interopRequireDefault(__webpack_require__(0));

var _TileGroup = _interopRequireDefault(__webpack_require__(457));

var _Decade = _interopRequireDefault(__webpack_require__(3158));

var _dates = __webpack_require__(122);

var _propTypes = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Decades(props) {
  var activeStartDate = props.activeStartDate;
  var start = (0, _dates.getBeginOfCenturyYear)(activeStartDate);
  var end = start + 99;
  return _react["default"].createElement(_TileGroup["default"], _extends({}, props, {
    className: "react-calendar__century-view__decades",
    dateTransform: _dates.getBeginOfDecade,
    dateType: "decade",
    end: end,
    start: start,
    step: 10,
    tile: _Decade["default"]
  }));
}

Decades.propTypes = _objectSpread({}, _propTypes.tileGroupProps);

/***/ }),
/* 3160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Year;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _Tile = _interopRequireDefault(__webpack_require__(456));

var _dates = __webpack_require__(122);

var _propTypes2 = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var className = 'react-calendar__decade-view__years__year';

function Year(_ref) {
  var classes = _ref.classes,
      point = _ref.point,
      otherProps = _objectWithoutProperties(_ref, ["classes", "point"]);

  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
    classes: [].concat(classes, className),
    maxDateTransform: _dates.getEndOfYear,
    minDateTransform: _dates.getBeginOfYear,
    view: "decade"
  }), point);
}

Year.propTypes = _objectSpread({}, _propTypes2.tileProps, {
  point: _propTypes["default"].number.isRequired
});

/***/ }),
/* 3161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Years;

var _react = _interopRequireDefault(__webpack_require__(0));

var _TileGroup = _interopRequireDefault(__webpack_require__(457));

var _Year = _interopRequireDefault(__webpack_require__(3160));

var _dates = __webpack_require__(122);

var _propTypes = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Years(props) {
  var activeStartDate = props.activeStartDate;
  var start = (0, _dates.getBeginOfDecadeYear)(activeStartDate);
  var end = start + 9;
  return _react["default"].createElement(_TileGroup["default"], _extends({}, props, {
    className: "react-calendar__decade-view__years",
    dateTransform: function dateTransform(year) {
      return new Date(year, 0, 1);
    },
    dateType: "year",
    end: end,
    start: start,
    tile: _Year["default"]
  }));
}

Years.propTypes = _objectSpread({}, _propTypes.tileGroupProps);

/***/ }),
/* 3162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Day;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _Tile = _interopRequireDefault(__webpack_require__(456));

var _dates = __webpack_require__(122);

var _dateFormatter = __webpack_require__(458);

var _propTypes2 = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var className = 'react-calendar__month-view__days__day';

function Day(_ref) {
  var calendarType = _ref.calendarType,
      classes = _ref.classes,
      currentMonthIndex = _ref.currentMonthIndex,
      date = _ref.date,
      otherProps = _objectWithoutProperties(_ref, ["calendarType", "classes", "currentMonthIndex", "date"]);

  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
    classes: [].concat(classes, className, (0, _dates.isWeekend)(date, calendarType) ? "".concat(className, "--weekend") : null, date.getMonth() !== currentMonthIndex ? "".concat(className, "--neighboringMonth") : null),
    date: date,
    formatAbbr: _dateFormatter.formatLongDate,
    maxDateTransform: _dates.getEndOfDay,
    minDateTransform: _dates.getBeginOfDay,
    view: "month"
  }), (0, _dates.getDay)(date));
}

Day.propTypes = _objectSpread({}, _propTypes2.tileProps, {
  currentMonthIndex: _propTypes["default"].number.isRequired
});

/***/ }),
/* 3163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Days;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _TileGroup = _interopRequireDefault(__webpack_require__(457));

var _Day = _interopRequireDefault(__webpack_require__(3162));

var _dates = __webpack_require__(122);

var _propTypes2 = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Days(props) {
  var activeStartDate = props.activeStartDate,
      calendarType = props.calendarType;

  var showFixedNumberOfWeeks = props.showFixedNumberOfWeeks,
      showNeighboringMonth = props.showNeighboringMonth,
      otherProps = _objectWithoutProperties(props, ["showFixedNumberOfWeeks", "showNeighboringMonth"]);

  var year = (0, _dates.getYear)(activeStartDate);
  var monthIndex = (0, _dates.getMonthIndex)(activeStartDate);
  var hasFixedNumberOfWeeks = showFixedNumberOfWeeks || showNeighboringMonth;
  var dayOfWeek = (0, _dates.getDayOfWeek)(activeStartDate, calendarType);
  var offset = hasFixedNumberOfWeeks ? 0 : dayOfWeek;
  /**
   * Defines on which day of the month the grid shall start. If we simply show current
   * month, we obviously start on day one, but if showNeighboringMonth is set to
   * true, we need to find the beginning of the week the first day of the month is in.
   */

  var start = (hasFixedNumberOfWeeks ? -dayOfWeek : 0) + 1;
  /**
   * Defines on which day of the month the grid shall end. If we simply show current
   * month, we need to stop on the last day of the month, but if showNeighboringMonth
   * is set to true, we need to find the end of the week the last day of the month is in.
   */

  var end = function () {
    if (showFixedNumberOfWeeks) {
      // Always show 6 weeks
      return start + 6 * 7 - 1;
    }

    var daysInMonth = (0, _dates.getDaysInMonth)(activeStartDate);

    if (showNeighboringMonth) {
      var activeEndDate = new Date(year, monthIndex, daysInMonth);
      return daysInMonth + (7 - (0, _dates.getDayOfWeek)(activeEndDate, calendarType) - 1);
    }

    return daysInMonth;
  }();

  return _react["default"].createElement(_TileGroup["default"], _extends({}, otherProps, {
    className: "react-calendar__month-view__days",
    count: 7,
    currentMonthIndex: monthIndex,
    dateTransform: function dateTransform(day) {
      return new Date(year, monthIndex, day);
    },
    dateType: "day",
    end: end,
    offset: offset,
    start: start,
    tile: _Day["default"]
  }));
}

Days.propTypes = _objectSpread({
  calendarType: _propTypes2.isCalendarType.isRequired,
  showFixedNumberOfWeeks: _propTypes["default"].bool,
  showNeighboringMonth: _propTypes["default"].bool
}, _propTypes2.tileGroupProps);

/***/ }),
/* 3164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = WeekNumber;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function WeekNumber(_ref) {
  var date = _ref.date,
      onClickWeekNumber = _ref.onClickWeekNumber,
      weekNumber = _ref.weekNumber;
  return onClickWeekNumber ? _react["default"].createElement("button", {
    className: "react-calendar__tile",
    onClick: function onClick() {
      return onClickWeekNumber(weekNumber, date);
    },
    style: {
      flexGrow: 1
    },
    type: "button"
  }, _react["default"].createElement("span", null, weekNumber)) : _react["default"].createElement("div", {
    className: "react-calendar__tile",
    style: {
      flexGrow: 1
    }
  }, _react["default"].createElement("span", null, weekNumber));
}

WeekNumber.propTypes = {
  date: _propTypes["default"].instanceOf(Date).isRequired,
  onClickWeekNumber: _propTypes["default"].func,
  weekNumber: _propTypes["default"].number.isRequired
};

/***/ }),
/* 3165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = WeekNumbers;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _WeekNumber = _interopRequireDefault(__webpack_require__(3164));

var _Flex = _interopRequireDefault(__webpack_require__(685));

var _dates = __webpack_require__(122);

var _propTypes2 = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function WeekNumbers(props) {
  var activeStartDate = props.activeStartDate,
      calendarType = props.calendarType,
      onClickWeekNumber = props.onClickWeekNumber,
      onMouseLeave = props.onMouseLeave,
      showFixedNumberOfWeeks = props.showFixedNumberOfWeeks;

  var numberOfWeeks = function () {
    if (showFixedNumberOfWeeks) {
      return 6;
    }

    var numberOfDays = (0, _dates.getDaysInMonth)(activeStartDate);
    var startWeekday = (0, _dates.getDayOfWeek)(activeStartDate, calendarType);
    var days = numberOfDays - (7 - startWeekday);
    return 1 + Math.ceil(days / 7);
  }();

  var dates = function () {
    var year = (0, _dates.getYear)(activeStartDate);
    var monthIndex = (0, _dates.getMonthIndex)(activeStartDate);
    var day = (0, _dates.getDay)(activeStartDate);
    var result = [];

    for (var index = 0; index < numberOfWeeks; index += 1) {
      result.push((0, _dates.getBeginOfWeek)(new Date(year, monthIndex, day + index * 7), calendarType));
    }

    return result;
  }();

  var weekNumbers = dates.map(function (date) {
    return (0, _dates.getWeekNumber)(date, calendarType);
  });
  return _react["default"].createElement(_Flex["default"], {
    className: "react-calendar__month-view__weekNumbers",
    count: numberOfWeeks,
    direction: "column",
    onFocus: onMouseLeave,
    onMouseOver: onMouseLeave,
    style: {
      flexBasis: 'calc(100% * (1 / 8)',
      flexShrink: 0
    }
  }, weekNumbers.map(function (weekNumber, weekIndex) {
    return _react["default"].createElement(_WeekNumber["default"], {
      key: weekNumber,
      date: dates[weekIndex],
      onClickWeekNumber: onClickWeekNumber,
      weekNumber: weekNumber
    });
  }));
}

WeekNumbers.propTypes = {
  activeStartDate: _propTypes["default"].instanceOf(Date).isRequired,
  calendarType: _propTypes2.isCalendarType.isRequired,
  onClickWeekNumber: _propTypes["default"].func,
  onMouseLeave: _propTypes["default"].func,
  showFixedNumberOfWeeks: _propTypes["default"].bool
};

/***/ }),
/* 3166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Weekdays;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _Flex = _interopRequireDefault(__webpack_require__(685));

var _dates = __webpack_require__(122);

var _dateFormatter = __webpack_require__(458);

var _propTypes2 = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Weekdays(props) {
  var calendarType = props.calendarType,
      formatShortWeekday = props.formatShortWeekday,
      locale = props.locale,
      onMouseLeave = props.onMouseLeave;
  var anyDate = new Date();
  var beginOfMonth = (0, _dates.getBeginOfMonth)(anyDate);
  var year = (0, _dates.getYear)(beginOfMonth);
  var monthIndex = (0, _dates.getMonthIndex)(beginOfMonth);
  var weekdays = [];

  for (var weekday = 1; weekday <= 7; weekday += 1) {
    var weekdayDate = new Date(year, monthIndex, weekday - (0, _dates.getDayOfWeek)(beginOfMonth, calendarType));
    var abbr = (0, _dateFormatter.formatWeekday)(locale, weekdayDate);
    weekdays.push(_react["default"].createElement("div", {
      key: weekday,
      className: "react-calendar__month-view__weekdays__weekday"
    }, _react["default"].createElement("abbr", {
      "aria-label": abbr,
      title: abbr
    }, formatShortWeekday(locale, weekdayDate).replace('.', ''))));
  }

  return _react["default"].createElement(_Flex["default"], {
    className: "react-calendar__month-view__weekdays",
    count: 7,
    onFocus: onMouseLeave,
    onMouseOver: onMouseLeave
  }, weekdays);
}

Weekdays.defaultProps = {
  formatShortWeekday: _dateFormatter.formatShortWeekday
};
Weekdays.propTypes = {
  calendarType: _propTypes2.isCalendarType.isRequired,
  formatShortWeekday: _propTypes["default"].func,
  locale: _propTypes["default"].string,
  onMouseLeave: _propTypes["default"].func
};

/***/ }),
/* 3167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Month;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _Tile = _interopRequireDefault(__webpack_require__(456));

var _dates = __webpack_require__(122);

var _dateFormatter = __webpack_require__(458);

var _propTypes2 = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var className = 'react-calendar__year-view__months__month';

function Month(_ref) {
  var classes = _ref.classes,
      date = _ref.date,
      formatMonth = _ref.formatMonth,
      locale = _ref.locale,
      otherProps = _objectWithoutProperties(_ref, ["classes", "date", "formatMonth", "locale"]);

  return _react["default"].createElement(_Tile["default"], _extends({}, otherProps, {
    classes: [].concat(classes, className),
    date: date,
    formatAbbr: _dateFormatter.formatMonthYear,
    locale: locale,
    maxDateTransform: _dates.getEndOfMonth,
    minDateTransform: _dates.getBeginOfMonth,
    view: "year"
  }), formatMonth(locale, date));
}

Month.defaultProps = {
  formatMonth: _dateFormatter.formatMonth
};
Month.propTypes = _objectSpread({}, _propTypes2.tileProps, {
  formatMonth: _propTypes["default"].func
});

/***/ }),
/* 3168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Months;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _TileGroup = _interopRequireDefault(__webpack_require__(457));

var _Month = _interopRequireDefault(__webpack_require__(3167));

var _dates = __webpack_require__(122);

var _propTypes2 = __webpack_require__(100);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Months(props) {
  var activeStartDate = props.activeStartDate;
  var start = 0;
  var end = 11;
  var year = (0, _dates.getYear)(activeStartDate);
  return _react["default"].createElement(_TileGroup["default"], _extends({}, props, {
    className: "react-calendar__year-view__months",
    dateTransform: function dateTransform(monthIndex) {
      return new Date(year, monthIndex, 1);
    },
    dateType: "month",
    end: end,
    start: start,
    tile: _Month["default"]
  }));
}

Months.propTypes = _objectSpread({}, _propTypes2.tileGroupProps, {
  locale: _propTypes["default"].string
});

/***/ }),
/* 3169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LocaleUtils = __webpack_require__(460);

var _LocaleUtils2 = _interopRequireDefault(_LocaleUtils);

var _keys = __webpack_require__(462);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Caption = function (_Component) {
  _inherits(Caption, _Component);

  function Caption(props) {
    _classCallCheck(this, Caption);

    var _this = _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));

    _this.handleKeyUp = _this.handleKeyUp.bind(_this);
    return _this;
  }

  _createClass(Caption, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.locale !== this.props.locale || nextProps.classNames !== this.props.classNames || nextProps.date.getMonth() !== this.props.date.getMonth() || nextProps.date.getFullYear() !== this.props.date.getFullYear();
    }
  }, {
    key: 'handleKeyUp',
    value: function handleKeyUp(e) {
      if (e.keyCode === _keys.ENTER) {
        this.props.onClick(e);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          date = _props.date,
          months = _props.months,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          onClick = _props.onClick;

      return _react2.default.createElement(
        'div',
        { className: classNames.caption, role: 'heading' },
        _react2.default.createElement(
          'div',
          { onClick: onClick, onKeyUp: this.handleKeyUp },
          months ? months[date.getMonth()] + ' ' + date.getFullYear() : localeUtils.formatMonthTitle(date, locale)
        )
      );
    }
  }]);

  return Caption;
}(_react.Component);

Caption.propTypes = {
  date: _propTypes2.default.instanceOf(Date),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  classNames: _propTypes2.default.shape({
    caption: _propTypes2.default.string.isRequired
  }).isRequired
};
Caption.defaultProps = {
  localeUtils: _LocaleUtils2.default
};
exports.default = Caption;
//# sourceMappingURL=Caption.js.map

/***/ }),
/* 3170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DateUtils = __webpack_require__(287);

var _Helpers = __webpack_require__(459);

var _classNames = __webpack_require__(461);

var _classNames2 = _interopRequireDefault(_classNames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/no-static-element-interactions, react/forbid-prop-types */

function handleEvent(handler, day, modifiers) {
  if (!handler) {
    return undefined;
  }
  return function (e) {
    e.persist();
    handler(day, modifiers, e);
  };
}

var Day = function (_Component) {
  _inherits(Day, _Component);

  function Day() {
    _classCallCheck(this, Day);

    return _possibleConstructorReturn(this, (Day.__proto__ || Object.getPrototypeOf(Day)).apply(this, arguments));
  }

  _createClass(Day, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      var _this2 = this;

      var propNames = Object.keys(this.props);
      var nextPropNames = Object.keys(nextProps);
      if (propNames.length !== nextPropNames.length) {
        return true;
      }
      return propNames.some(function (name) {
        if (name === 'modifiers' || name === 'modifiersStyles' || name === 'classNames') {
          var prop = _this2.props[name];
          var nextProp = nextProps[name];
          var modifiers = Object.keys(prop);
          var nextModifiers = Object.keys(nextProp);
          if (modifiers.length !== nextModifiers.length) {
            return true;
          }
          return modifiers.some(function (mod) {
            return !(0, _Helpers.hasOwnProp)(nextProp, mod) || prop[mod] !== nextProp[mod];
          });
        }
        if (name === 'day') {
          return !(0, _DateUtils.isSameDay)(_this2.props[name], nextProps[name]);
        }
        return !(0, _Helpers.hasOwnProp)(nextProps, name) || _this2.props[name] !== nextProps[name];
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          modifiersStyles = _props.modifiersStyles,
          day = _props.day,
          tabIndex = _props.tabIndex,
          empty = _props.empty,
          modifiers = _props.modifiers,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          onMouseUp = _props.onMouseUp,
          onMouseDown = _props.onMouseDown,
          onClick = _props.onClick,
          onKeyDown = _props.onKeyDown,
          onTouchStart = _props.onTouchStart,
          onTouchEnd = _props.onTouchEnd,
          onFocus = _props.onFocus,
          ariaLabel = _props.ariaLabel,
          ariaDisabled = _props.ariaDisabled,
          ariaSelected = _props.ariaSelected,
          children = _props.children;


      var className = classNames.day;
      if (classNames !== _classNames2.default) {
        // When using CSS modules prefix the modifier as required by the BEM syntax
        className += ' ' + Object.keys(modifiers).join(' ');
      } else {
        className += Object.keys(modifiers).map(function (modifier) {
          return ' ' + className + '--' + modifier;
        }).join('');
      }

      var style = void 0;
      if (modifiersStyles) {
        Object.keys(modifiers).filter(function (modifier) {
          return !!modifiersStyles[modifier];
        }).forEach(function (modifier) {
          style = _extends({}, style, modifiersStyles[modifier]);
        });
      }

      if (empty) {
        return _react2.default.createElement('div', { 'aria-disabled': true, className: className, style: style });
      }
      return _react2.default.createElement(
        'div',
        {
          className: className,
          tabIndex: tabIndex,
          style: style,
          role: 'gridcell',
          'aria-label': ariaLabel,
          'aria-disabled': ariaDisabled,
          'aria-selected': ariaSelected,
          onClick: handleEvent(onClick, day, modifiers),
          onKeyDown: handleEvent(onKeyDown, day, modifiers),
          onMouseEnter: handleEvent(onMouseEnter, day, modifiers),
          onMouseLeave: handleEvent(onMouseLeave, day, modifiers),
          onMouseUp: handleEvent(onMouseUp, day, modifiers),
          onMouseDown: handleEvent(onMouseDown, day, modifiers),
          onTouchEnd: handleEvent(onTouchEnd, day, modifiers),
          onTouchStart: handleEvent(onTouchStart, day, modifiers),
          onFocus: handleEvent(onFocus, day, modifiers)
        },
        children
      );
    }
  }]);

  return Day;
}(_react.Component);

Day.propTypes = {
  classNames: _propTypes2.default.shape({
    day: _propTypes2.default.string.isRequired
  }).isRequired,

  day: _propTypes2.default.instanceOf(Date).isRequired,
  children: _propTypes2.default.node.isRequired,

  ariaDisabled: _propTypes2.default.bool,
  ariaLabel: _propTypes2.default.string,
  ariaSelected: _propTypes2.default.bool,
  empty: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,
  onClick: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onMouseEnter: _propTypes2.default.func,
  onMouseLeave: _propTypes2.default.func,
  onMouseDown: _propTypes2.default.func,
  onMouseUp: _propTypes2.default.func,
  onTouchEnd: _propTypes2.default.func,
  onTouchStart: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  tabIndex: _propTypes2.default.number
};
Day.defaultProps = {
  tabIndex: -1
};
Day.defaultProps = {
  modifiers: {},
  modifiersStyles: {},
  empty: false
};
exports.default = Day;
//# sourceMappingURL=Day.js.map

/***/ }),
/* 3171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModifiersUtils = exports.LocaleUtils = exports.DateUtils = exports.DayPicker = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Caption = __webpack_require__(3169);

var _Caption2 = _interopRequireDefault(_Caption);

var _Navbar = __webpack_require__(1407);

var _Navbar2 = _interopRequireDefault(_Navbar);

var _Month = __webpack_require__(3172);

var _Month2 = _interopRequireDefault(_Month);

var _Weekday = __webpack_require__(1408);

var _Weekday2 = _interopRequireDefault(_Weekday);

var _Helpers = __webpack_require__(459);

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__(287);

var DateUtils = _interopRequireWildcard(_DateUtils);

var _LocaleUtils = __webpack_require__(460);

var LocaleUtils = _interopRequireWildcard(_LocaleUtils);

var _ModifiersUtils = __webpack_require__(688);

var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);

var _classNames = __webpack_require__(461);

var _classNames2 = _interopRequireDefault(_classNames);

var _keys = __webpack_require__(462);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DayPicker = exports.DayPicker = function (_Component) {
  _inherits(DayPicker, _Component);

  function DayPicker(props) {
    _classCallCheck(this, DayPicker);

    var _this = _possibleConstructorReturn(this, (DayPicker.__proto__ || Object.getPrototypeOf(DayPicker)).call(this, props));

    _this.dayPicker = null;

    _this.showNextMonth = function (callback) {
      if (!_this.allowNextMonth()) {
        return;
      }
      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
      var nextMonth = DateUtils.addMonths(_this.state.currentMonth, deltaMonths);
      _this.showMonth(nextMonth, callback);
    };

    _this.showPreviousMonth = function (callback) {
      if (!_this.allowPreviousMonth()) {
        return;
      }
      var deltaMonths = _this.props.pagedNavigation ? _this.props.numberOfMonths : 1;
      var previousMonth = DateUtils.addMonths(_this.state.currentMonth, -deltaMonths);
      _this.showMonth(previousMonth, callback);
    };

    _this.handleKeyDown = function (e) {
      e.persist();

      switch (e.keyCode) {
        case _keys.LEFT:
          if (_this.props.dir === 'rtl') {
            _this.showNextMonth();
          } else {
            _this.showPreviousMonth();
          }
          Helpers.cancelEvent(e);
          break;
        case _keys.RIGHT:
          if (_this.props.dir === 'rtl') {
            _this.showPreviousMonth();
          } else {
            _this.showNextMonth();
          }
          Helpers.cancelEvent(e);
          break;
        case _keys.UP:
          _this.showPreviousYear();
          Helpers.cancelEvent(e);
          break;
        case _keys.DOWN:
          _this.showNextYear();
          Helpers.cancelEvent(e);
          break;
        default:
          break;
      }

      if (_this.props.onKeyDown) {
        _this.props.onKeyDown(e);
      }
    };

    _this.handleDayKeyDown = function (day, modifiers, e) {
      e.persist();

      switch (e.keyCode) {
        case _keys.LEFT:
          Helpers.cancelEvent(e);
          if (_this.props.dir === 'rtl') {
            _this.focusNextDay(e.target);
          } else {
            _this.focusPreviousDay(e.target);
          }
          break;
        case _keys.RIGHT:
          Helpers.cancelEvent(e);
          if (_this.props.dir === 'rtl') {
            _this.focusPreviousDay(e.target);
          } else {
            _this.focusNextDay(e.target);
          }
          break;
        case _keys.UP:
          Helpers.cancelEvent(e);
          _this.focusPreviousWeek(e.target);
          break;
        case _keys.DOWN:
          Helpers.cancelEvent(e);
          _this.focusNextWeek(e.target);
          break;
        case _keys.ENTER:
        case _keys.SPACE:
          Helpers.cancelEvent(e);
          if (_this.props.onDayClick) {
            _this.handleDayClick(day, modifiers, e);
          }
          break;
        default:
          break;
      }
      if (_this.props.onDayKeyDown) {
        _this.props.onDayKeyDown(day, modifiers, e);
      }
    };

    _this.handleDayClick = function (day, modifiers, e) {
      e.persist();

      if (modifiers[_this.props.classNames.outside] && _this.props.enableOutsideDaysClick) {
        _this.handleOutsideDayClick(day);
      }
      if (_this.props.onDayClick) {
        _this.props.onDayClick(day, modifiers, e);
      }
    };

    _this.handleTodayButtonClick = function (e) {
      var today = new Date();
      var month = new Date(today.getFullYear(), today.getMonth());
      _this.showMonth(month);
      e.target.blur();
      if (_this.props.onTodayButtonClick) {
        e.persist();
        _this.props.onTodayButtonClick(new Date(today.getFullYear(), today.getMonth(), today.getDate()), ModifiersUtils.getModifiersForDay(today, _this.props.modifiers), e);
      }
    };

    var currentMonth = _this.getCurrentMonthFromProps(props);
    _this.state = { currentMonth: currentMonth };
    return _this;
  }

  _createClass(DayPicker, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      // Changing the `month` props means changing the current displayed month
      if (prevProps.month !== this.props.month && !DateUtils.isSameMonth(prevProps.month, this.props.month)) {
        var currentMonth = this.getCurrentMonthFromProps(this.props);
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ currentMonth: currentMonth });
      }
    }

    /**
     * Return the month to be shown in the calendar based on the component props.
     *
     * @param {Object} props
     * @returns Date
     * @memberof DayPicker
     * @private
     */

  }, {
    key: 'getCurrentMonthFromProps',
    value: function getCurrentMonthFromProps(props) {
      var initialMonth = Helpers.startOfMonth(props.month || props.initialMonth);
      var currentMonth = initialMonth;

      if (props.pagedNavigation && props.numberOfMonths > 1 && props.fromMonth) {
        var fromMonth = Helpers.startOfMonth(props.fromMonth);
        var diffInMonths = Helpers.getMonthsDiff(fromMonth, currentMonth);
        currentMonth = DateUtils.addMonths(fromMonth, Math.floor(diffInMonths / props.numberOfMonths) * props.numberOfMonths);
      } else if (props.toMonth && props.numberOfMonths > 1 && Helpers.getMonthsDiff(currentMonth, props.toMonth) <= 0) {
        currentMonth = DateUtils.addMonths(Helpers.startOfMonth(props.toMonth), 1 - this.props.numberOfMonths);
      }
      return currentMonth;
    }
  }, {
    key: 'getNextNavigableMonth',
    value: function getNextNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
    }
  }, {
    key: 'getPreviousNavigableMonth',
    value: function getPreviousNavigableMonth() {
      return DateUtils.addMonths(this.state.currentMonth, -1);
    }
  }, {
    key: 'allowPreviousMonth',
    value: function allowPreviousMonth() {
      var previousMonth = DateUtils.addMonths(this.state.currentMonth, -1);
      return this.allowMonth(previousMonth);
    }
  }, {
    key: 'allowNextMonth',
    value: function allowNextMonth() {
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, this.props.numberOfMonths);
      return this.allowMonth(nextMonth);
    }
  }, {
    key: 'allowMonth',
    value: function allowMonth(d) {
      var _props = this.props,
          fromMonth = _props.fromMonth,
          toMonth = _props.toMonth,
          canChangeMonth = _props.canChangeMonth;

      if (!canChangeMonth || fromMonth && Helpers.getMonthsDiff(fromMonth, d) < 0 || toMonth && Helpers.getMonthsDiff(toMonth, d) > 0) {
        return false;
      }
      return true;
    }
  }, {
    key: 'allowYearChange',
    value: function allowYearChange() {
      return this.props.canChangeMonth;
    }
  }, {
    key: 'showMonth',
    value: function showMonth(d, callback) {
      var _this2 = this;

      if (!this.allowMonth(d)) {
        return;
      }
      this.setState({ currentMonth: Helpers.startOfMonth(d) }, function () {
        if (callback) {
          callback();
        }
        if (_this2.props.onMonthChange) {
          _this2.props.onMonthChange(_this2.state.currentMonth);
        }
      });
    }
  }, {
    key: 'showNextYear',
    value: function showNextYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, 12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'showPreviousYear',
    value: function showPreviousYear() {
      if (!this.allowYearChange()) {
        return;
      }
      var nextMonth = DateUtils.addMonths(this.state.currentMonth, -12);
      this.showMonth(nextMonth);
    }
  }, {
    key: 'focus',
    value: function focus() {
      this.wrapper.focus();
    }
  }, {
    key: 'focusFirstDayOfMonth',
    value: function focusFirstDayOfMonth() {
      Helpers.getDayNodes(this.dayPicker, this.props.classNames)[0].focus();
    }
  }, {
    key: 'focusLastDayOfMonth',
    value: function focusLastDayOfMonth() {
      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      dayNodes[dayNodes.length - 1].focus();
    }
  }, {
    key: 'focusPreviousDay',
    value: function focusPreviousDay(dayNode) {
      var _this3 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === -1) return;
      if (dayNodeIndex === 0) {
        this.showPreviousMonth(function () {
          return _this3.focusLastDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex - 1].focus();
      }
    }
  }, {
    key: 'focusNextDay',
    value: function focusNextDay(dayNode) {
      var _this4 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      if (dayNodeIndex === -1) return;
      if (dayNodeIndex === dayNodes.length - 1) {
        this.showNextMonth(function () {
          return _this4.focusFirstDayOfMonth();
        });
      } else {
        dayNodes[dayNodeIndex + 1].focus();
      }
    }
  }, {
    key: 'focusNextWeek',
    value: function focusNextWeek(dayNode) {
      var _this5 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInLastWeekOfMonth = dayNodeIndex > dayNodes.length - 8;

      if (isInLastWeekOfMonth) {
        this.showNextMonth(function () {
          var daysAfterIndex = dayNodes.length - dayNodeIndex;
          var nextMonthDayNodeIndex = 7 - daysAfterIndex;
          Helpers.getDayNodes(_this5.dayPicker, _this5.props.classNames)[nextMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex + 7].focus();
      }
    }
  }, {
    key: 'focusPreviousWeek',
    value: function focusPreviousWeek(dayNode) {
      var _this6 = this;

      var dayNodes = Helpers.getDayNodes(this.dayPicker, this.props.classNames);
      var dayNodeIndex = Helpers.nodeListToArray(dayNodes).indexOf(dayNode);
      var isInFirstWeekOfMonth = dayNodeIndex <= 6;

      if (isInFirstWeekOfMonth) {
        this.showPreviousMonth(function () {
          var previousMonthDayNodes = Helpers.getDayNodes(_this6.dayPicker, _this6.props.classNames);
          var startOfLastWeekOfMonth = previousMonthDayNodes.length - 7;
          var previousMonthDayNodeIndex = startOfLastWeekOfMonth + dayNodeIndex;
          previousMonthDayNodes[previousMonthDayNodeIndex].focus();
        });
      } else {
        dayNodes[dayNodeIndex - 7].focus();
      }
    }

    // Event handlers

  }, {
    key: 'handleOutsideDayClick',
    value: function handleOutsideDayClick(day) {
      var currentMonth = this.state.currentMonth;
      var numberOfMonths = this.props.numberOfMonths;

      var diffInMonths = Helpers.getMonthsDiff(currentMonth, day);
      if (diffInMonths > 0 && diffInMonths >= numberOfMonths) {
        this.showNextMonth();
      } else if (diffInMonths < 0) {
        this.showPreviousMonth();
      }
    }
  }, {
    key: 'renderNavbar',
    value: function renderNavbar() {
      var _props2 = this.props,
          labels = _props2.labels,
          locale = _props2.locale,
          localeUtils = _props2.localeUtils,
          canChangeMonth = _props2.canChangeMonth,
          navbarElement = _props2.navbarElement,
          attributes = _objectWithoutProperties(_props2, ['labels', 'locale', 'localeUtils', 'canChangeMonth', 'navbarElement']);

      if (!canChangeMonth) return null;

      var props = {
        month: this.state.currentMonth,
        classNames: this.props.classNames,
        className: this.props.classNames.navBar,
        nextMonth: this.getNextNavigableMonth(),
        previousMonth: this.getPreviousNavigableMonth(),
        showPreviousButton: this.allowPreviousMonth(),
        showNextButton: this.allowNextMonth(),
        onNextClick: this.showNextMonth,
        onPreviousClick: this.showPreviousMonth,
        dir: attributes.dir,
        labels: labels,
        locale: locale,
        localeUtils: localeUtils
      };
      return _react2.default.isValidElement(navbarElement) ? _react2.default.cloneElement(navbarElement, props) : _react2.default.createElement(navbarElement, props);
    }
  }, {
    key: 'renderMonths',
    value: function renderMonths() {
      var months = [];
      var firstDayOfWeek = Helpers.getFirstDayOfWeekFromProps(this.props);
      for (var i = 0; i < this.props.numberOfMonths; i += 1) {
        var month = DateUtils.addMonths(this.state.currentMonth, i);
        months.push(_react2.default.createElement(_Month2.default, _extends({
          key: i
        }, this.props, {
          month: month,
          firstDayOfWeek: firstDayOfWeek,
          onDayKeyDown: this.handleDayKeyDown,
          onDayClick: this.handleDayClick
        })));
      }

      if (this.props.reverseMonths) {
        months.reverse();
      }
      return months;
    }
  }, {
    key: 'renderFooter',
    value: function renderFooter() {
      if (this.props.todayButton) {
        return _react2.default.createElement(
          'div',
          { className: this.props.classNames.footer },
          this.renderTodayButton()
        );
      }
      return null;
    }
  }, {
    key: 'renderTodayButton',
    value: function renderTodayButton() {
      return _react2.default.createElement(
        'button',
        {
          type: 'button',
          tabIndex: 0,
          className: this.props.classNames.todayButton,
          'aria-label': this.props.todayButton,
          onClick: this.handleTodayButtonClick
        },
        this.props.todayButton
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this7 = this;

      var className = this.props.classNames.container;

      if (!this.props.onDayClick) {
        className = className + ' ' + this.props.classNames.interactionDisabled;
      }
      if (this.props.className) {
        className = className + ' ' + this.props.className;
      }
      return _react2.default.createElement(
        'div',
        _extends({}, this.props.containerProps, {
          className: className,
          ref: function ref(el) {
            return _this7.dayPicker = el;
          },
          lang: this.props.locale
        }),
        _react2.default.createElement(
          'div',
          {
            className: this.props.classNames.wrapper,
            ref: function ref(el) {
              return _this7.wrapper = el;
            },
            tabIndex: this.props.canChangeMonth && typeof this.props.tabIndex !== 'undefined' ? this.props.tabIndex : -1,
            onKeyDown: this.handleKeyDown,
            onFocus: this.props.onFocus,
            onBlur: this.props.onBlur
          },
          this.renderNavbar(),
          _react2.default.createElement(
            'div',
            { className: this.props.classNames.months },
            this.renderMonths()
          ),
          this.renderFooter()
        )
      );
    }
  }]);

  return DayPicker;
}(_react.Component);

DayPicker.VERSION = '7.4.0';
DayPicker.propTypes = {
  // Rendering months
  initialMonth: _propTypes2.default.instanceOf(Date),
  month: _propTypes2.default.instanceOf(Date),
  numberOfMonths: _propTypes2.default.number,
  fromMonth: _propTypes2.default.instanceOf(Date),
  toMonth: _propTypes2.default.instanceOf(Date),
  canChangeMonth: _propTypes2.default.bool,
  reverseMonths: _propTypes2.default.bool,
  pagedNavigation: _propTypes2.default.bool,
  todayButton: _propTypes2.default.string,
  showWeekNumbers: _propTypes2.default.bool,
  showWeekDays: _propTypes2.default.bool,

  // Modifiers
  selectedDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),
  disabledDays: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.func, _propTypes2.default.array]),

  modifiers: _propTypes2.default.object,
  modifiersStyles: _propTypes2.default.object,

  // Localization
  dir: _propTypes2.default.string,
  firstDayOfWeek: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5, 6]),
  labels: _propTypes2.default.shape({
    nextMonth: _propTypes2.default.string.isRequired,
    previousMonth: _propTypes2.default.string.isRequired
  }),
  locale: _propTypes2.default.string,
  localeUtils: _propTypes2.default.shape({
    formatMonthTitle: _propTypes2.default.func,
    formatWeekdayShort: _propTypes2.default.func,
    formatWeekdayLong: _propTypes2.default.func,
    getFirstDayOfWeek: _propTypes2.default.func
  }),
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),

  // Customization
  showOutsideDays: _propTypes2.default.bool,
  enableOutsideDaysClick: _propTypes2.default.bool,
  fixedWeeks: _propTypes2.default.bool,

  // CSS and HTML
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string,
    container: _propTypes2.default.string,
    day: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.string.isRequired,
    footer: _propTypes2.default.string,
    interactionDisabled: _propTypes2.default.string,
    months: _propTypes2.default.string,
    month: _propTypes2.default.string,
    navBar: _propTypes2.default.string,
    outside: _propTypes2.default.string.isRequired,
    selected: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    todayButton: _propTypes2.default.string,
    week: _propTypes2.default.string,
    wrapper: _propTypes2.default.string
  }),
  className: _propTypes2.default.string,
  containerProps: _propTypes2.default.object,
  tabIndex: _propTypes2.default.number,

  // Custom elements
  renderDay: _propTypes2.default.func,
  renderWeek: _propTypes2.default.func,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
  navbarElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),
  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react.Component)]),

  // Events
  onBlur: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onKeyDown: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onMonthChange: _propTypes2.default.func,
  onCaptionClick: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func,
  onTodayButtonClick: _propTypes2.default.func
};
DayPicker.defaultProps = {
  classNames: _classNames2.default,
  tabIndex: 0,
  initialMonth: new Date(),
  numberOfMonths: 1,
  labels: {
    previousMonth: 'Previous Month',
    nextMonth: 'Next Month'
  },
  locale: 'en',
  localeUtils: LocaleUtils,
  showOutsideDays: false,
  enableOutsideDaysClick: true,
  fixedWeeks: false,
  canChangeMonth: true,
  reverseMonths: false,
  pagedNavigation: false,
  showWeekNumbers: false,
  showWeekDays: true,
  renderDay: function renderDay(day) {
    return day.getDate();
  },
  renderWeek: function renderWeek(weekNumber) {
    return weekNumber;
  },
  weekdayElement: _react2.default.createElement(_Weekday2.default, null),
  navbarElement: _react2.default.createElement(_Navbar2.default, { classNames: _classNames2.default }),
  captionElement: _react2.default.createElement(_Caption2.default, { classNames: _classNames2.default })
};


DayPicker.DateUtils = DateUtils;
DayPicker.LocaleUtils = LocaleUtils;
DayPicker.ModifiersUtils = ModifiersUtils;

exports.DateUtils = DateUtils;
exports.LocaleUtils = LocaleUtils;
exports.ModifiersUtils = ModifiersUtils;
exports.default = DayPicker;
//# sourceMappingURL=DayPicker.js.map

/***/ }),
/* 3172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Weekdays = __webpack_require__(3174);

var _Weekdays2 = _interopRequireDefault(_Weekdays);

var _Day = __webpack_require__(3170);

var _Day2 = _interopRequireDefault(_Day);

var _keys = __webpack_require__(462);

var _ModifiersUtils = __webpack_require__(688);

var ModifiersUtils = _interopRequireWildcard(_ModifiersUtils);

var _Helpers = __webpack_require__(459);

var Helpers = _interopRequireWildcard(_Helpers);

var _DateUtils = __webpack_require__(287);

var DateUtils = _interopRequireWildcard(_DateUtils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Month = function (_Component) {
  _inherits(Month, _Component);

  function Month() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Month);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Month.__proto__ || Object.getPrototypeOf(Month)).call.apply(_ref, [this].concat(args))), _this), _this.renderDay = function (day) {
      var monthNumber = _this.props.month.getMonth();
      var propModifiers = Helpers.getModifiersFromProps(_this.props);
      var dayModifiers = ModifiersUtils.getModifiersForDay(day, propModifiers);
      if (DateUtils.isSameDay(day, new Date()) && !Object.prototype.hasOwnProperty.call(propModifiers, _this.props.classNames.today)) {
        dayModifiers.push(_this.props.classNames.today);
      }
      if (day.getMonth() !== monthNumber) {
        dayModifiers.push(_this.props.classNames.outside);
      }

      var isOutside = day.getMonth() !== monthNumber;
      var tabIndex = -1;
      // Focus on the first day of the month
      if (_this.props.onDayClick && !isOutside && day.getDate() === 1) {
        tabIndex = _this.props.tabIndex; // eslint-disable-line prefer-destructuring
      }
      var key = '' + day.getFullYear() + day.getMonth() + day.getDate();
      var modifiers = {};
      dayModifiers.forEach(function (modifier) {
        modifiers[modifier] = true;
      });

      return _react2.default.createElement(
        _Day2.default,
        {
          key: '' + (isOutside ? 'outside-' : '') + key,
          classNames: _this.props.classNames,
          day: day,
          modifiers: modifiers,
          modifiersStyles: _this.props.modifiersStyles,
          empty: isOutside && !_this.props.showOutsideDays && !_this.props.fixedWeeks,
          tabIndex: tabIndex,
          ariaLabel: _this.props.localeUtils.formatDay(day, _this.props.locale),
          ariaDisabled: isOutside || dayModifiers.indexOf('disabled') > -1,
          ariaSelected: dayModifiers.indexOf('selected') > -1,
          onClick: _this.props.onDayClick,
          onFocus: _this.props.onDayFocus,
          onKeyDown: _this.props.onDayKeyDown,
          onMouseEnter: _this.props.onDayMouseEnter,
          onMouseLeave: _this.props.onDayMouseLeave,
          onMouseDown: _this.props.onDayMouseDown,
          onMouseUp: _this.props.onDayMouseUp,
          onTouchEnd: _this.props.onDayTouchEnd,
          onTouchStart: _this.props.onDayTouchStart
        },
        _this.props.renderDay(day, modifiers)
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Month, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          classNames = _props.classNames,
          month = _props.month,
          months = _props.months,
          fixedWeeks = _props.fixedWeeks,
          captionElement = _props.captionElement,
          weekdayElement = _props.weekdayElement,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          firstDayOfWeek = _props.firstDayOfWeek,
          onCaptionClick = _props.onCaptionClick,
          showWeekNumbers = _props.showWeekNumbers,
          showWeekDays = _props.showWeekDays,
          onWeekClick = _props.onWeekClick;


      var captionProps = {
        date: month,
        classNames: classNames,
        months: months,
        localeUtils: localeUtils,
        locale: locale,
        onClick: onCaptionClick ? function (e) {
          return onCaptionClick(month, e);
        } : undefined
      };
      var caption = _react2.default.isValidElement(captionElement) ? _react2.default.cloneElement(captionElement, captionProps) : _react2.default.createElement(captionElement, captionProps);

      var weeks = Helpers.getWeekArray(month, firstDayOfWeek, fixedWeeks);
      return _react2.default.createElement(
        'div',
        { className: classNames.month, role: 'grid' },
        caption,
        showWeekDays && _react2.default.createElement(_Weekdays2.default, {
          classNames: classNames,
          weekdaysShort: weekdaysShort,
          weekdaysLong: weekdaysLong,
          firstDayOfWeek: firstDayOfWeek,
          showWeekNumbers: showWeekNumbers,
          locale: locale,
          localeUtils: localeUtils,
          weekdayElement: weekdayElement
        }),
        _react2.default.createElement(
          'div',
          { className: classNames.body, role: 'rowgroup' },
          weeks.map(function (week) {
            var weekNumber = void 0;
            if (showWeekNumbers) {
              weekNumber = DateUtils.getWeekNumber(week[6]);
            }
            return _react2.default.createElement(
              'div',
              {
                key: week[0].getTime(),
                className: classNames.week,
                role: 'row'
              },
              showWeekNumbers && _react2.default.createElement(
                'div',
                {
                  className: classNames.weekNumber,
                  tabIndex: onWeekClick ? 0 : -1,
                  role: 'gridcell',
                  onClick: onWeekClick ? function (e) {
                    return onWeekClick(weekNumber, week, e);
                  } : undefined,
                  onKeyUp: onWeekClick ? function (e) {
                    return e.keyCode === _keys.ENTER && onWeekClick(weekNumber, week, e);
                  } : undefined
                },
                _this2.props.renderWeek(weekNumber, week, month)
              ),
              week.map(_this2.renderDay)
            );
          })
        )
      );
    }
  }]);

  return Month;
}(_react.Component);

Month.propTypes = {
  classNames: _propTypes2.default.shape({
    body: _propTypes2.default.string.isRequired,
    month: _propTypes2.default.string.isRequired,
    outside: _propTypes2.default.string.isRequired,
    today: _propTypes2.default.string.isRequired,
    week: _propTypes2.default.string.isRequired,
    weekNumber: _propTypes2.default.string.isRequired
  }).isRequired,
  tabIndex: _propTypes2.default.number,

  month: _propTypes2.default.instanceOf(Date).isRequired,
  months: _propTypes2.default.arrayOf(_propTypes2.default.string),

  modifiersStyles: _propTypes2.default.object,

  showWeekDays: _propTypes2.default.bool,
  showOutsideDays: _propTypes2.default.bool,

  renderDay: _propTypes2.default.func.isRequired,
  renderWeek: _propTypes2.default.func.isRequired,

  captionElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]).isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)]),

  fixedWeeks: _propTypes2.default.bool,
  showWeekNumbers: _propTypes2.default.bool,

  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  firstDayOfWeek: _propTypes2.default.number.isRequired,

  onCaptionClick: _propTypes2.default.func,
  onDayClick: _propTypes2.default.func,
  onDayFocus: _propTypes2.default.func,
  onDayKeyDown: _propTypes2.default.func,
  onDayMouseEnter: _propTypes2.default.func,
  onDayMouseLeave: _propTypes2.default.func,
  onDayMouseDown: _propTypes2.default.func,
  onDayMouseUp: _propTypes2.default.func,
  onDayTouchEnd: _propTypes2.default.func,
  onDayTouchStart: _propTypes2.default.func,
  onWeekClick: _propTypes2.default.func
};
exports.default = Month;
//# sourceMappingURL=Month.js.map

/***/ }),
/* 3173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ModifierPropType = undefined;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PrimitiveTypes = {
  localeUtils: _propTypes2.default.shape({
    formatMonthTitle: _propTypes2.default.func,
    formatWeekdayShort: _propTypes2.default.func,
    formatWeekdayLong: _propTypes2.default.func,
    getFirstDayOfWeek: _propTypes2.default.func
  }),
  range: _propTypes2.default.shape({
    from: _propTypes2.default.instanceOf(Date),
    to: _propTypes2.default.instanceOf(Date)
  }),
  after: _propTypes2.default.shape({
    after: _propTypes2.default.instanceOf(Date)
  }),
  before: _propTypes2.default.shape({
    before: _propTypes2.default.instanceOf(Date)
  })
};

var ModifierPropType = exports.ModifierPropType = _propTypes2.default.oneOfType([PrimitiveTypes.after, PrimitiveTypes.before, PrimitiveTypes.range, _propTypes2.default.func, _propTypes2.default.array]);

exports.default = PrimitiveTypes;
//# sourceMappingURL=PropTypes.js.map

/***/ }),
/* 3174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Weekdays = function (_Component) {
  _inherits(Weekdays, _Component);

  function Weekdays() {
    _classCallCheck(this, Weekdays);

    return _possibleConstructorReturn(this, (Weekdays.__proto__ || Object.getPrototypeOf(Weekdays)).apply(this, arguments));
  }

  _createClass(Weekdays, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps) {
      return this.props !== nextProps;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          classNames = _props.classNames,
          firstDayOfWeek = _props.firstDayOfWeek,
          showWeekNumbers = _props.showWeekNumbers,
          weekdaysLong = _props.weekdaysLong,
          weekdaysShort = _props.weekdaysShort,
          locale = _props.locale,
          localeUtils = _props.localeUtils,
          weekdayElement = _props.weekdayElement;

      var days = [];
      for (var i = 0; i < 7; i += 1) {
        var weekday = (i + firstDayOfWeek) % 7;
        var elementProps = {
          key: i,
          className: classNames.weekday,
          weekday: weekday,
          weekdaysLong: weekdaysLong,
          weekdaysShort: weekdaysShort,
          localeUtils: localeUtils,
          locale: locale
        };
        var element = _react2.default.isValidElement(weekdayElement) ? _react2.default.cloneElement(weekdayElement, elementProps) : _react2.default.createElement(weekdayElement, elementProps);
        days.push(element);
      }

      return _react2.default.createElement(
        'div',
        { className: classNames.weekdays, role: 'rowgroup' },
        _react2.default.createElement(
          'div',
          { className: classNames.weekdaysRow, role: 'row' },
          showWeekNumbers && _react2.default.createElement('div', { className: classNames.weekday }),
          days
        )
      );
    }
  }]);

  return Weekdays;
}(_react.Component);

Weekdays.propTypes = {
  classNames: _propTypes2.default.shape({
    weekday: _propTypes2.default.string.isRequired,
    weekdays: _propTypes2.default.string.isRequired,
    weekdaysRow: _propTypes2.default.string.isRequired
  }).isRequired,

  firstDayOfWeek: _propTypes2.default.number.isRequired,
  weekdaysLong: _propTypes2.default.arrayOf(_propTypes2.default.string),
  weekdaysShort: _propTypes2.default.arrayOf(_propTypes2.default.string),
  showWeekNumbers: _propTypes2.default.bool,
  locale: _propTypes2.default.string.isRequired,
  localeUtils: _propTypes2.default.object.isRequired,
  weekdayElement: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.func, _propTypes2.default.instanceOf(_react2.default.Component)])
};
exports.default = Weekdays;
//# sourceMappingURL=Weekdays.js.map

/***/ }),
/* 3175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),m=__webpack_require__(121),q=__webpack_require__(3231);function t(a){for(var b=a.message,c="https://reactjs.org/docs/error-decoder.html?invariant="+b,d=1;d<arguments.length;d++)c+="&args[]="+encodeURIComponent(arguments[d]);a.message="Minified React error #"+b+"; visit "+c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}if(!aa)throw t(Error(227));var ba=null,ca={};
function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw t(Error(96),a);if(!ea[c]){if(!b.extractEvents)throw t(Error(97),a);ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],h=b,g=d;if(fa.hasOwnProperty(g))throw t(Error(99),g);fa[g]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],h,g);e=!0}else f.registrationName?(ha(f.registrationName,h,g),e=!0):e=!1;if(!e)throw t(Error(98),d,a);}}}}
function ha(a,b,c){if(ia[a])throw t(Error(100),a);ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,h,g,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(n){this.onError(n)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,h,g,k){la=!1;ma=null;ka.apply(pa,arguments)}
function ra(a,b,c,d,e,f,h,g,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw t(Error(198));na||(na=!0,oa=l)}}var sa=null,ta=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw t(Error(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw t(Error(95));if(na)throw a=oa,na=!1,oa=null,a;}}
var Ca={injectEventPluginOrder:function(a){if(ba)throw t(Error(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw t(Error(102),c);ca[c]=d;b=!0}}b&&da()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw t(Error(231),b,typeof c);
return c}var Ea=Math.random().toString(36).slice(2),Fa="__reactInternalInstance$"+Ea,Ga="__reactEventHandlers$"+Ea;function Ha(a){if(a[Fa])return a[Fa];for(;!a[Fa];)if(a.parentNode)a=a.parentNode;else return null;a=a[Fa];return 5===a.tag||6===a.tag?a:null}function Ia(a){a=a[Fa];return!a||5!==a.tag&&6!==a.tag?null:a}function Ja(a){if(5===a.tag||6===a.tag)return a.stateNode;throw t(Error(33));}function Ka(a){return a[Ga]||null}function La(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Ma(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}function Na(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=La(b);for(b=c.length;0<b--;)Ma(c[b],"captured",a);for(b=0;b<c.length;b++)Ma(c[b],"bubbled",a)}}
function Oa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Pa(a){a&&a.dispatchConfig.registrationName&&Oa(a._targetInst,null,a)}function Qa(a){ya(a,Na)}var Ra=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement);
function Sa(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ta={animationend:Sa("Animation","AnimationEnd"),animationiteration:Sa("Animation","AnimationIteration"),animationstart:Sa("Animation","AnimationStart"),transitionend:Sa("Transition","TransitionEnd")},Ua={},Va={};
Ra&&(Va=document.createElement("div").style,"AnimationEvent"in window||(delete Ta.animationend.animation,delete Ta.animationiteration.animation,delete Ta.animationstart.animation),"TransitionEvent"in window||delete Ta.transitionend.transition);function Wa(a){if(Ua[a])return Ua[a];if(!Ta[a])return a;var b=Ta[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Va)return Ua[a]=b[c];return a}
var Xa=Wa("animationend"),Ya=Wa("animationiteration"),Za=Wa("animationstart"),ab=Wa("transitionend"),bb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),cb=null,db=null,eb=null;
function fb(){if(eb)return eb;var a,b=db,c=b.length,d,e="value"in cb?cb.value:cb.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var h=c-a;for(d=1;d<=h&&b[c-d]===e[f-d];d++);return eb=e.slice(a,1<d?1-d:void 0)}function gb(){return!0}function hb(){return!1}
function y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?gb:hb;this.isPropagationStopped=hb;return this}
m(y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=gb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=gb)},persist:function(){this.isPersistent=gb},isPersistent:hb,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=hb;this._dispatchInstances=this._dispatchListeners=null}});y.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
y.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;m(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=m({},d.Interface,a);c.extend=d.extend;ib(c);return c};ib(y);function jb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function kb(a){if(!(a instanceof this))throw t(Error(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function ib(a){a.eventPool=[];a.getPooled=jb;a.release=kb}var lb=y.extend({data:null}),mb=y.extend({data:null}),nb=[9,13,27,32],ob=Ra&&"CompositionEvent"in window,pb=null;Ra&&"documentMode"in document&&(pb=document.documentMode);
var qb=Ra&&"TextEvent"in window&&!pb,sb=Ra&&(!ob||pb&&8<pb&&11>=pb),tb=String.fromCharCode(32),ub={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},vb=!1;
function wb(a,b){switch(a){case "keyup":return-1!==nb.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function xb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var yb=!1;function Ab(a,b){switch(a){case "compositionend":return xb(b);case "keypress":if(32!==b.which)return null;vb=!0;return tb;case "textInput":return a=b.data,a===tb&&vb?null:a;default:return null}}
function Bb(a,b){if(yb)return"compositionend"===a||!ob&&wb(a,b)?(a=fb(),eb=db=cb=null,yb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return sb&&"ko"!==b.locale?null:b.data;default:return null}}
var Cb={eventTypes:ub,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(ob)b:{switch(a){case "compositionstart":e=ub.compositionStart;break b;case "compositionend":e=ub.compositionEnd;break b;case "compositionupdate":e=ub.compositionUpdate;break b}e=void 0}else yb?wb(a,c)&&(e=ub.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=ub.compositionStart);e?(sb&&"ko"!==c.locale&&(yb||e!==ub.compositionStart?e===ub.compositionEnd&&yb&&(f=fb()):(cb=d,db="value"in cb?cb.value:cb.textContent,yb=
!0)),e=lb.getPooled(e,b,c,d),f?e.data=f:(f=xb(c),null!==f&&(e.data=f)),Qa(e),f=e):f=null;(a=qb?Ab(a,c):Bb(a,c))?(b=mb.getPooled(ub.beforeInput,b,c,d),b.data=a,Qa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Db=null,Eb=null,Fb=null;function Gb(a){if(a=ta(a)){if("function"!==typeof Db)throw t(Error(280));var b=sa(a.stateNode);Db(a.stateNode,a.type,b)}}function Hb(a){Eb?Fb?Fb.push(a):Fb=[a]:Eb=a}function Ib(){if(Eb){var a=Eb,b=Fb;Fb=Eb=null;Gb(a);if(b)for(a=0;a<b.length;a++)Gb(b[a])}}
function Jb(a,b){return a(b)}function Kb(a,b,c,d){return a(b,c,d)}function Lb(){}var Mb=Jb,Nb=!1;function Ob(){if(null!==Eb||null!==Fb)Lb(),Ib()}var Pb={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Qb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Pb[a.type]:"textarea"===b?!0:!1}
function Rb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Sb(a){if(!Ra)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Tb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ub(a){var b=Tb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function Vb(a){a._valueTracker||(a._valueTracker=Ub(a))}function Wb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Tb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}var Xb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Xb.hasOwnProperty("ReactCurrentDispatcher")||(Xb.ReactCurrentDispatcher={current:null});Xb.hasOwnProperty("ReactCurrentBatchConfig")||(Xb.ReactCurrentBatchConfig={suspense:null});
var Yb=/^(.*)[\\\/]/,B="function"===typeof Symbol&&Symbol.for,Zb=B?Symbol.for("react.element"):60103,$b=B?Symbol.for("react.portal"):60106,ac=B?Symbol.for("react.fragment"):60107,bc=B?Symbol.for("react.strict_mode"):60108,cc=B?Symbol.for("react.profiler"):60114,dc=B?Symbol.for("react.provider"):60109,ec=B?Symbol.for("react.context"):60110,fc=B?Symbol.for("react.concurrent_mode"):60111,gc=B?Symbol.for("react.forward_ref"):60112,hc=B?Symbol.for("react.suspense"):60113,ic=B?Symbol.for("react.suspense_list"):
60120,jc=B?Symbol.for("react.memo"):60115,kc=B?Symbol.for("react.lazy"):60116;B&&Symbol.for("react.fundamental");B&&Symbol.for("react.responder");var lc="function"===typeof Symbol&&Symbol.iterator;function mc(a){if(null===a||"object"!==typeof a)return null;a=lc&&a[lc]||a["@@iterator"];return"function"===typeof a?a:null}
function oc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ac:return"Fragment";case $b:return"Portal";case cc:return"Profiler";case bc:return"StrictMode";case hc:return"Suspense";case ic:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case ec:return"Context.Consumer";case dc:return"Context.Provider";case gc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jc:return oc(a.type);case kc:if(a=1===a._status?a._result:null)return oc(a)}return null}function pc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=oc(a.type);c=null;d&&(c=oc(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Yb,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var qc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,rc=Object.prototype.hasOwnProperty,sc={},tc={};
function uc(a){if(rc.call(tc,a))return!0;if(rc.call(sc,a))return!1;if(qc.test(a))return tc[a]=!0;sc[a]=!0;return!1}function vc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function wc(a,b,c,d){if(null===b||"undefined"===typeof b||vc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function D(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var F={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){F[a]=new D(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];F[b]=new D(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){F[a]=new D(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){F[a]=new D(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){F[a]=new D(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){F[a]=new D(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){F[a]=new D(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){F[a]=new D(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){F[a]=new D(a,5,!1,a.toLowerCase(),null,!1)});var xc=/[\-:]([a-z])/g;function yc(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(xc,
yc);F[b]=new D(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(xc,yc);F[b]=new D(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(xc,yc);F[b]=new D(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){F[a]=new D(a,1,!1,a.toLowerCase(),null,!1)});
F.xlinkHref=new D("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){F[a]=new D(a,1,!1,a.toLowerCase(),null,!0)});
function zc(a,b,c,d){var e=F.hasOwnProperty(b)?F[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(wc(b,c,e,d)&&(c=null),d||null===e?uc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function Ac(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function Bc(a,b){var c=b.checked;return m({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Cc(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Ac(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Dc(a,b){b=b.checked;null!=b&&zc(a,"checked",b,!1)}
function Ec(a,b){Dc(a,b);var c=Ac(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fc(a,b.type,Ac(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Gc(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Fc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Hc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Ic(a,b,c){a=y.getPooled(Hc.change,a,b,c);a.type="change";Hb(c);Qa(a);return a}var Jc=null,Kc=null;function Lc(a){Ba(a)}
function Mc(a){var b=Ja(a);if(Wb(b))return a}function Nc(a,b){if("change"===a)return b}var Oc=!1;Ra&&(Oc=Sb("input")&&(!document.documentMode||9<document.documentMode));function Pc(){Jc&&(Jc.detachEvent("onpropertychange",Qc),Kc=Jc=null)}function Qc(a){if("value"===a.propertyName&&Mc(Kc))if(a=Ic(Kc,a,Rb(a)),Nb)Ba(a);else{Nb=!0;try{Jb(Lc,a)}finally{Nb=!1,Ob()}}}function Rc(a,b,c){"focus"===a?(Pc(),Jc=b,Kc=c,Jc.attachEvent("onpropertychange",Qc)):"blur"===a&&Pc()}
function Sc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Mc(Kc)}function Tc(a,b){if("click"===a)return Mc(b)}function Uc(a,b){if("input"===a||"change"===a)return Mc(b)}
var Vc={eventTypes:Hc,_isInputEventSupported:Oc,extractEvents:function(a,b,c,d){var e=b?Ja(b):window,f=void 0,h=void 0,g=e.nodeName&&e.nodeName.toLowerCase();"select"===g||"input"===g&&"file"===e.type?f=Nc:Qb(e)?Oc?f=Uc:(f=Sc,h=Rc):(g=e.nodeName)&&"input"===g.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Tc);if(f&&(f=f(a,b)))return Ic(f,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fc(e,"number",e.value)}},Wc=y.extend({view:null,detail:null}),Xc={Alt:"altKey",
Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Yc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Xc[a])?!!b[a]:!1}function Zc(){return Yc}
var $c=0,ad=0,bd=!1,cd=!1,dd=Wc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Zc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=$c;$c=a.screenX;return bd?"mousemove"===a.type?a.screenX-b:0:(bd=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=ad;ad=a.screenY;return cd?"mousemove"===a.type?a.screenY-b:0:(cd=!0,0)}}),ed=dd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),fd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},gd={eventTypes:fd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ha(b):null):f=null;if(f===b)return null;var h=void 0,g=void 0,k=void 0,l=void 0;if("mouseout"===a||"mouseover"===a)h=dd,g=fd.mouseLeave,k=fd.mouseEnter,l="mouse";
else if("pointerout"===a||"pointerover"===a)h=ed,g=fd.pointerLeave,k=fd.pointerEnter,l="pointer";var n=null==f?e:Ja(f);e=null==b?e:Ja(b);a=h.getPooled(g,f,c,d);a.type=l+"leave";a.target=n;a.relatedTarget=e;c=h.getPooled(k,b,c,d);c.type=l+"enter";c.target=e;c.relatedTarget=n;d=b;if(f&&d)a:{b=f;e=d;l=0;for(h=b;h;h=La(h))l++;h=0;for(k=e;k;k=La(k))h++;for(;0<l-h;)b=La(b),l--;for(;0<h-l;)e=La(e),h--;for(;l--;){if(b===e||b===e.alternate)break a;b=La(b);e=La(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){l=
f.alternate;if(null!==l&&l===e)break;b.push(f);f=La(f)}for(f=[];d&&d!==e;){l=d.alternate;if(null!==l&&l===e)break;f.push(d);d=La(d)}for(d=0;d<b.length;d++)Oa(b[d],"bubbled",a);for(d=f.length;0<d--;)Oa(f[d],"captured",c);return[a,c]}};function hd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var id=Object.prototype.hasOwnProperty;
function jd(a,b){if(hd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!id.call(b,c[d])||!hd(a[c[d]],b[c[d]]))return!1;return!0}function kd(a,b){return{responder:a,props:b}}new Map;new Map;new Set;new Map;
function ld(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function od(a){if(2!==ld(a))throw t(Error(188));}
function pd(a){var b=a.alternate;if(!b){b=ld(a);if(3===b)throw t(Error(188));return 1===b?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return od(e),a;if(f===d)return od(e),b;f=f.sibling}throw t(Error(188));}if(c.return!==d.return)c=e,d=f;else{for(var h=!1,g=e.child;g;){if(g===c){h=!0;c=e;d=f;break}if(g===d){h=!0;d=e;c=f;break}g=g.sibling}if(!h){for(g=f.child;g;){if(g===
c){h=!0;c=f;d=e;break}if(g===d){h=!0;d=f;c=e;break}g=g.sibling}if(!h)throw t(Error(189));}}if(c.alternate!==d)throw t(Error(190));}if(3!==c.tag)throw t(Error(188));return c.stateNode.current===c?a:b}function qd(a){a=pd(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var rd=y.extend({animationName:null,elapsedTime:null,pseudoElement:null}),sd=y.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),td=Wc.extend({relatedTarget:null});function ud(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var vd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},wd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},xd=Wc.extend({key:function(a){if(a.key){var b=vd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=ud(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?wd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Zc,charCode:function(a){return"keypress"===
a.type?ud(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?ud(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),yd=dd.extend({dataTransfer:null}),zd=Wc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Zc}),Ad=y.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),Bd=dd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),Cd=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],
["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",
1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",2],[Xa,"animationEnd",2],[Ya,"animationIteration",2],[Za,"animationStart",2],["canplay","canPlay",2],["canplaythrough",
"canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress","progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",
2],[ab,"transitionEnd",2],["waiting","waiting",2]],Dd={},Ed={},Fd=0;for(;Fd<Cd.length;Fd++){var Gd=Cd[Fd],Hd=Gd[0],Id=Gd[1],Jd=Gd[2],Kd="on"+(Id[0].toUpperCase()+Id.slice(1)),Ld={phasedRegistrationNames:{bubbled:Kd,captured:Kd+"Capture"},dependencies:[Hd],eventPriority:Jd};Dd[Id]=Ld;Ed[Hd]=Ld}
var Md={eventTypes:Dd,getEventPriority:function(a){a=Ed[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=Ed[a];if(!e)return null;switch(a){case "keypress":if(0===ud(c))return null;case "keydown":case "keyup":a=xd;break;case "blur":case "focus":a=td;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=dd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
yd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=zd;break;case Xa:case Ya:case Za:a=rd;break;case ab:a=Ad;break;case "scroll":a=Wc;break;case "wheel":a=Bd;break;case "copy":case "cut":case "paste":a=sd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=ed;break;default:a=y}b=a.getPooled(e,b,c,d);Qa(b);return b}},Nd=Md.getEventPriority,Od=[];
function Pd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ha(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Rb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,h=null,g=0;g<ea.length;g++){var k=ea[g];k&&(k=k.extractEvents(d,b,f,e))&&(h=xa(h,k))}Ba(h)}}var Qd=!0;function G(a,b){Rd(b,a,!1)}
function Rd(a,b,c){switch(Nd(b)){case 0:var d=Sd.bind(null,b,1);break;case 1:d=Td.bind(null,b,1);break;default:d=Ud.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Sd(a,b,c){Nb||Lb();var d=Ud,e=Nb;Nb=!0;try{Kb(d,a,b,c)}finally{(Nb=e)||Ob()}}function Td(a,b,c){Ud(a,b,c)}
function Ud(a,b,c){if(Qd){b=Rb(c);b=Ha(b);null===b||"number"!==typeof b.tag||2===ld(b)||(b=null);if(Od.length){var d=Od.pop();d.topLevelType=a;d.nativeEvent=c;d.targetInst=b;a=d}else a={topLevelType:a,nativeEvent:c,targetInst:b,ancestors:[]};try{if(c=a,Nb)Pd(c,void 0);else{Nb=!0;try{Mb(Pd,c,void 0)}finally{Nb=!1,Ob()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Od.length&&Od.push(a)}}}var Vd=new ("function"===typeof WeakMap?WeakMap:Map);
function Wd(a){var b=Vd.get(a);void 0===b&&(b=new Set,Vd.set(a,b));return b}function Xd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Yd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Zd(a,b){var c=Yd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Yd(c)}}function $d(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?$d(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function ae(){for(var a=window,b=Xd();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=Xd(a.document)}return b}function be(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var ce=Ra&&"documentMode"in document&&11>=document.documentMode,de={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ee=null,fe=null,ge=null,he=!1;
function ie(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(he||null==ee||ee!==Xd(c))return null;c=ee;"selectionStart"in c&&be(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return ge&&jd(ge,c)?null:(ge=c,a=y.getPooled(de.select,fe,a,b),a.type="select",a.target=ee,Qa(a),a)}
var je={eventTypes:de,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Wd(e);f=ja.onSelect;for(var h=0;h<f.length;h++)if(!e.has(f[h])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Ja(b):window;switch(a){case "focus":if(Qb(e)||"true"===e.contentEditable)ee=e,fe=b,ge=null;break;case "blur":ge=fe=ee=null;break;case "mousedown":he=!0;break;case "contextmenu":case "mouseup":case "dragend":return he=!1,ie(c,d);case "selectionchange":if(ce)break;
case "keydown":case "keyup":return ie(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));sa=Ka;ta=Ia;va=Ja;Ca.injectEventPluginsByName({SimpleEventPlugin:Md,EnterLeaveEventPlugin:gd,ChangeEventPlugin:Vc,SelectEventPlugin:je,BeforeInputEventPlugin:Cb});function ke(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
function le(a,b){a=m({children:void 0},b);if(b=ke(b.children))a.children=b;return a}function me(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+Ac(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function ne(a,b){if(null!=b.dangerouslySetInnerHTML)throw t(Error(91));return m({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function oe(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw t(Error(92));if(Array.isArray(b)){if(!(1>=b.length))throw t(Error(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:Ac(c)}}
function pe(a,b){var c=Ac(b.value),d=Ac(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function qe(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var re={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function se(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function te(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?se(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var ue=void 0,ve=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==re.svg||"innerHTML"in a)a.innerHTML=b;else{ue=ue||document.createElement("div");ue.innerHTML="<svg>"+b+"</svg>";for(b=ue.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function we(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
var xe={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},ye=["Webkit","ms","Moz","O"];Object.keys(xe).forEach(function(a){ye.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);xe[b]=xe[a]})});function ze(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||xe.hasOwnProperty(a)&&xe[a]?(""+b).trim():b+"px"}
function Ae(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ze(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Ce=m({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function De(a,b){if(b){if(Ce[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw t(Error(137),a,"");if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw t(Error(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw t(Error(61));}if(null!=b.style&&"object"!==typeof b.style)throw t(Error(62),"");}}
function Ee(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
function Fe(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Wd(a);b=ja[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.has(e)){switch(e){case "scroll":Rd(a,"scroll",!0);break;case "focus":case "blur":Rd(a,"focus",!0);Rd(a,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Sb(e)&&Rd(a,e,!0);break;case "invalid":case "submit":case "reset":break;default:-1===bb.indexOf(e)&&G(e,a)}c.add(e)}}}function Ge(){}var He=null,Ie=null;
function Je(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function Ke(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Le="function"===typeof setTimeout?setTimeout:void 0,Me="function"===typeof clearTimeout?clearTimeout:void 0;
function Ne(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}new Set;var Oe=[],Pe=-1;function H(a){0>Pe||(a.current=Oe[Pe],Oe[Pe]=null,Pe--)}function J(a,b){Pe++;Oe[Pe]=a.current;a.current=b}var Qe={},L={current:Qe},M={current:!1},Re=Qe;
function Se(a,b){var c=a.type.contextTypes;if(!c)return Qe;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function N(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Te(a){H(M,a);H(L,a)}function Ue(a){H(M,a);H(L,a)}
function Ve(a,b,c){if(L.current!==Qe)throw t(Error(168));J(L,b,a);J(M,c,a)}function We(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw t(Error(108),oc(b)||"Unknown",e);return m({},c,d)}function Xe(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Qe;Re=L.current;J(L,b,a);J(M,M.current,a);return!0}
function Ye(a,b,c){var d=a.stateNode;if(!d)throw t(Error(169));c?(b=We(a,b,Re),d.__reactInternalMemoizedMergedChildContext=b,H(M,a),H(L,a),J(L,b,a)):H(M,a);J(M,c,a)}
var Ze=q.unstable_runWithPriority,$e=q.unstable_scheduleCallback,af=q.unstable_cancelCallback,bf=q.unstable_shouldYield,cf=q.unstable_requestPaint,df=q.unstable_now,ef=q.unstable_getCurrentPriorityLevel,ff=q.unstable_ImmediatePriority,hf=q.unstable_UserBlockingPriority,jf=q.unstable_NormalPriority,kf=q.unstable_LowPriority,lf=q.unstable_IdlePriority,mf={},nf=void 0!==cf?cf:function(){},of=null,pf=null,qf=!1,rf=df(),sf=1E4>rf?df:function(){return df()-rf};
function tf(){switch(ef()){case ff:return 99;case hf:return 98;case jf:return 97;case kf:return 96;case lf:return 95;default:throw t(Error(332));}}function uf(a){switch(a){case 99:return ff;case 98:return hf;case 97:return jf;case 96:return kf;case 95:return lf;default:throw t(Error(332));}}function vf(a,b){a=uf(a);return Ze(a,b)}function wf(a,b,c){a=uf(a);return $e(a,b,c)}function xf(a){null===of?(of=[a],pf=$e(ff,yf)):of.push(a);return mf}function O(){null!==pf&&af(pf);yf()}
function yf(){if(!qf&&null!==of){qf=!0;var a=0;try{var b=of;vf(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});of=null}catch(c){throw null!==of&&(of=of.slice(a+1)),$e(ff,O),c;}finally{qf=!1}}}function zf(a,b){if(1073741823===b)return 99;if(1===b)return 95;a=10*(1073741821-b)-10*(1073741821-a);return 0>=a?99:250>=a?98:5250>=a?97:95}function Af(a,b){if(a&&a.defaultProps){b=m({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
function Bf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var Cf={current:null},Df=null,Ef=null,Ff=null;function Gf(){Ff=Ef=Df=null}
function Hf(a,b){var c=a.type._context;J(Cf,c._currentValue,a);c._currentValue=b}function If(a){var b=Cf.current;H(Cf,a);a.type._context._currentValue=b}function Jf(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function Kf(a,b){Df=a;Ff=Ef=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(Lf=!0),a.firstContext=null)}function Mf(a,b){if(Ff!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)Ff=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===Ef){if(null===Df)throw t(Error(308));Ef=b;Df.dependencies={expirationTime:0,firstContext:b,responders:null}}else Ef=Ef.next=b}return a._currentValue}var Nf=!1;
function Of(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Pf(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Qf(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Rf(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Sf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=Of(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=Of(a.memoizedState),e=c.updateQueue=Of(c.memoizedState)):d=a.updateQueue=Pf(e):null===e&&(e=c.updateQueue=Pf(d));null===e||d===e?Rf(d,b):null===d.lastUpdate||null===e.lastUpdate?(Rf(d,b),Rf(e,b)):(Rf(d,b),e.lastUpdate=b)}
function Tf(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=Of(a.memoizedState):Uf(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Uf(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Pf(b));return b}
function Vf(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-2049|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return m({},d,e);case 2:Nf=!0}return d}
function Wf(a,b,c,d,e){Nf=!1;b=Uf(a,b);for(var f=b.baseState,h=null,g=0,k=b.firstUpdate,l=f;null!==k;){var n=k.expirationTime;n<e?(null===h&&(h=k,f=l),g<n&&(g=n)):(Xf(n,k.suspenseConfig),l=Vf(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}n=null;for(k=b.firstCapturedUpdate;null!==k;){var z=k.expirationTime;z<e?(null===n&&(n=k,null===h&&(f=l)),g<z&&(g=z)):(l=Vf(a,b,k,l,c,d),null!==
k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===h&&(b.lastUpdate=null);null===n?b.lastCapturedUpdate=null:a.effectTag|=32;null===h&&null===n&&(f=l);b.baseState=f;b.firstUpdate=h;b.firstCapturedUpdate=n;a.expirationTime=g;a.memoizedState=l}
function Yf(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Zf(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Zf(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Zf(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw t(Error(191),c);c.call(d)}a=a.nextEffect}}
var $f=Xb.ReactCurrentBatchConfig,ag=(new aa.Component).refs;function bg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:m({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var fg={isMounted:function(a){return(a=a._reactInternalFiber)?2===ld(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=cg(),e=$f.suspense;d=dg(d,a,e);e=Qf(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf(a,e);eg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=cg(),e=$f.suspense;d=dg(d,a,e);e=Qf(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Sf(a,e);eg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=cg(),d=$f.suspense;
c=dg(c,a,d);d=Qf(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Sf(a,d);eg(a,c)}};function gg(a,b,c,d,e,f,h){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,h):b.prototype&&b.prototype.isPureReactComponent?!jd(c,d)||!jd(e,f):!0}
function hg(a,b,c){var d=!1,e=Qe;var f=b.contextType;"object"===typeof f&&null!==f?f=Mf(f):(e=N(b)?Re:L.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Se(a,e):Qe);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=fg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function ig(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&fg.enqueueReplaceState(b,b.state,null)}
function jg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=ag;var f=b.contextType;"object"===typeof f&&null!==f?e.context=Mf(f):(f=N(b)?Re:L.current,e.context=Se(a,f));f=a.updateQueue;null!==f&&(Wf(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(bg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&fg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Wf(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var kg=Array.isArray;
function lg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;if(c){if(1!==c.tag)throw t(Error(309));d=c.stateNode}if(!d)throw t(Error(147),a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===ag&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw t(Error(284));if(!c._owner)throw t(Error(290),a);}return a}
function mg(a,b){if("textarea"!==a.type)throw t(Error(31),"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"");}
function ng(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=og(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function h(b){a&&null===b.alternate&&(b.effectTag=2);return b}function g(a,b,c,d){if(null===b||6!==b.tag)return b=pg(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=lg(a,b,c),d.return=a,d;d=qg(c.type,c.key,c.props,null,a.mode,d);d.ref=lg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=rg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function n(a,b,c,d,f){if(null===b||7!==b.tag)return b=sg(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function z(a,b,c){if("string"===typeof b||"number"===typeof b)return b=pg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Zb:return c=qg(b.type,b.key,b.props,null,a.mode,c),c.ref=lg(a,null,b),c.return=a,c;case $b:return b=rg(b,a.mode,c),b.return=a,b}if(kg(b)||
mc(b))return b=sg(b,a.mode,c,null),b.return=a,b;mg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:g(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Zb:return c.key===e?c.type===ac?n(a,b,c.props.children,d,e):k(a,b,c,d):null;case $b:return c.key===e?l(a,b,c,d):null}if(kg(c)||mc(c))return null!==e?null:n(a,b,c,d,null);mg(a,c)}return null}function v(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,g(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Zb:return a=a.get(null===d.key?c:d.key)||null,d.type===ac?n(b,a,d.props.children,e,d.key):k(b,a,d,e);case $b:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(kg(d)||mc(d))return a=a.get(c)||null,n(b,a,d,e,null);mg(b,d)}return null}function rb(e,h,g,k){for(var l=null,u=null,n=h,w=h=0,C=null;null!==n&&w<g.length;w++){n.index>w?(C=n,n=null):C=n.sibling;var p=x(e,n,g[w],k);if(null===p){null===n&&(n=C);break}a&&
n&&null===p.alternate&&b(e,n);h=f(p,h,w);null===u?l=p:u.sibling=p;u=p;n=C}if(w===g.length)return c(e,n),l;if(null===n){for(;w<g.length;w++)n=z(e,g[w],k),null!==n&&(h=f(n,h,w),null===u?l=n:u.sibling=n,u=n);return l}for(n=d(e,n);w<g.length;w++)C=v(n,e,w,g[w],k),null!==C&&(a&&null!==C.alternate&&n.delete(null===C.key?w:C.key),h=f(C,h,w),null===u?l=C:u.sibling=C,u=C);a&&n.forEach(function(a){return b(e,a)});return l}function Be(e,h,g,k){var l=mc(g);if("function"!==typeof l)throw t(Error(150));g=l.call(g);
if(null==g)throw t(Error(151));for(var n=l=null,u=h,w=h=0,C=null,p=g.next();null!==u&&!p.done;w++,p=g.next()){u.index>w?(C=u,u=null):C=u.sibling;var r=x(e,u,p.value,k);if(null===r){null===u&&(u=C);break}a&&u&&null===r.alternate&&b(e,u);h=f(r,h,w);null===n?l=r:n.sibling=r;n=r;u=C}if(p.done)return c(e,u),l;if(null===u){for(;!p.done;w++,p=g.next())p=z(e,p.value,k),null!==p&&(h=f(p,h,w),null===n?l=p:n.sibling=p,n=p);return l}for(u=d(e,u);!p.done;w++,p=g.next())p=v(u,e,w,p.value,k),null!==p&&(a&&null!==
p.alternate&&u.delete(null===p.key?w:p.key),h=f(p,h,w),null===n?l=p:n.sibling=p,n=p);a&&u.forEach(function(a){return b(e,a)});return l}return function(a,d,f,g){var k="object"===typeof f&&null!==f&&f.type===ac&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Zb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){if(7===k.tag?f.type===ac:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===ac?f.props.children:f.props,g);d.ref=lg(a,k,f);d.return=a;a=d;break a}c(a,
k);break}else b(a,k);k=k.sibling}f.type===ac?(d=sg(f.props.children,a.mode,g,f.key),d.return=a,a=d):(g=qg(f.type,f.key,f.props,null,a.mode,g),g.ref=lg(a,d,f),g.return=a,a=g)}return h(a);case $b:a:{for(k=f.key;null!==d;){if(d.key===k){if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],g);d.return=a;a=d;break a}c(a,d);break}else b(a,d);d=d.sibling}d=rg(f,a.mode,g);d.return=a;a=d}return h(a)}if("string"===typeof f||
"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,g),d.return=a,a=d):(c(a,d),d=pg(f,a.mode,g),d.return=a,a=d),h(a);if(kg(f))return rb(a,d,f,g);if(mc(f))return Be(a,d,f,g);l&&mg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,t(Error(152),a.displayName||a.name||"Component");}return c(a,d)}}var tg=ng(!0),ug=ng(!1),vg={},wg={current:vg},xg={current:vg},yg={current:vg};function zg(a){if(a===vg)throw t(Error(174));return a}
function Ag(a,b){J(yg,b,a);J(xg,a,a);J(wg,vg,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:te(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=te(b,c)}H(wg,a);J(wg,b,a)}function Bg(a){H(wg,a);H(xg,a);H(yg,a)}function Cg(a){zg(yg.current);var b=zg(wg.current);var c=te(b,a.type);b!==c&&(J(xg,a,a),J(wg,c,a))}function Dg(a){xg.current===a&&(H(wg,a),H(xg,a))}var Eg=1,Fg=1,Gg=2,P={current:0};
function Hg(a){for(var b=a;null!==b;){if(13===b.tag){if(null!==b.memoizedState)return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}
var Ig=0,Jg=2,Kg=4,Lg=8,Mg=16,Ng=32,Og=64,Pg=128,Qg=Xb.ReactCurrentDispatcher,Rg=0,Sg=null,Q=null,Tg=null,Ug=null,R=null,Vg=null,Wg=0,Xg=null,Yg=0,Zg=!1,$g=null,ah=0;function bh(){throw t(Error(321));}function ch(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!hd(a[c],b[c]))return!1;return!0}
function dh(a,b,c,d,e,f){Rg=f;Sg=b;Tg=null!==a?a.memoizedState:null;Qg.current=null===Tg?eh:fh;b=c(d,e);if(Zg){do Zg=!1,ah+=1,Tg=null!==a?a.memoizedState:null,Vg=Ug,Xg=R=Q=null,Qg.current=fh,b=c(d,e);while(Zg);$g=null;ah=0}Qg.current=hh;a=Sg;a.memoizedState=Ug;a.expirationTime=Wg;a.updateQueue=Xg;a.effectTag|=Yg;a=null!==Q&&null!==Q.next;Rg=0;Vg=R=Ug=Tg=Q=Sg=null;Wg=0;Xg=null;Yg=0;if(a)throw t(Error(300));return b}
function ih(){Qg.current=hh;Rg=0;Vg=R=Ug=Tg=Q=Sg=null;Wg=0;Xg=null;Yg=0;Zg=!1;$g=null;ah=0}function jh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===R?Ug=R=a:R=R.next=a;return R}function kh(){if(null!==Vg)R=Vg,Vg=R.next,Q=Tg,Tg=null!==Q?Q.next:null;else{if(null===Tg)throw t(Error(310));Q=Tg;var a={memoizedState:Q.memoizedState,baseState:Q.baseState,queue:Q.queue,baseUpdate:Q.baseUpdate,next:null};R=null===R?Ug=a:R.next=a;Tg=Q.next}return R}
function lh(a,b){return"function"===typeof b?b(a):b}
function mh(a){var b=kh(),c=b.queue;if(null===c)throw t(Error(311));c.lastRenderedReducer=a;if(0<ah){var d=c.dispatch;if(null!==$g){var e=$g.get(c);if(void 0!==e){$g.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);hd(f,b.memoizedState)||(Lf=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var h=b.baseUpdate;f=b.baseState;null!==h?(null!==d&&(d.next=null),d=h.next):d=null!==d?d.next:null;if(null!==
d){var g=e=null,k=d,l=!1;do{var n=k.expirationTime;n<Rg?(l||(l=!0,g=h,e=f),n>Wg&&(Wg=n)):(Xf(n,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));h=k;k=k.next}while(null!==k&&k!==d);l||(g=h,e=f);hd(f,b.memoizedState)||(Lf=!0);b.memoizedState=f;b.baseUpdate=g;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function nh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===Xg?(Xg={lastEffect:null},Xg.lastEffect=a.next=a):(b=Xg.lastEffect,null===b?Xg.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,Xg.lastEffect=a));return a}function oh(a,b,c,d){var e=jh();Yg|=a;e.memoizedState=nh(b,c,void 0,void 0===d?null:d)}
function ph(a,b,c,d){var e=kh();d=void 0===d?null:d;var f=void 0;if(null!==Q){var h=Q.memoizedState;f=h.destroy;if(null!==d&&ch(d,h.deps)){nh(Ig,c,f,d);return}}Yg|=a;e.memoizedState=nh(b,c,f,d)}function qh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function rh(){}
function sh(a,b,c){if(!(25>ah))throw t(Error(301));var d=a.alternate;if(a===Sg||null!==d&&d===Sg)if(Zg=!0,a={expirationTime:Rg,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===$g&&($g=new Map),c=$g.get(b),void 0===c)$g.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=cg(),f=$f.suspense;e=dg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var h=b.last;if(null===h)f.next=f;else{var g=h.next;null!==g&&
(f.next=g);h.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(hd(l,k))return}catch(n){}finally{}eg(a,e)}}
var hh={readContext:Mf,useCallback:bh,useContext:bh,useEffect:bh,useImperativeHandle:bh,useLayoutEffect:bh,useMemo:bh,useReducer:bh,useRef:bh,useState:bh,useDebugValue:bh,useResponder:bh},eh={readContext:Mf,useCallback:function(a,b){jh().memoizedState=[a,void 0===b?null:b];return a},useContext:Mf,useEffect:function(a,b){return oh(516,Pg|Og,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return oh(4,Kg|Ng,qh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return oh(4,
Kg|Ng,a,b)},useMemo:function(a,b){var c=jh();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=jh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=sh.bind(null,Sg,a);return[d.memoizedState,a]},useRef:function(a){var b=jh();a={current:a};return b.memoizedState=a},useState:function(a){var b=jh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue=
{last:null,dispatch:null,lastRenderedReducer:lh,lastRenderedState:a};a=a.dispatch=sh.bind(null,Sg,a);return[b.memoizedState,a]},useDebugValue:rh,useResponder:kd},fh={readContext:Mf,useCallback:function(a,b){var c=kh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&ch(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:Mf,useEffect:function(a,b){return ph(516,Pg|Og,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return ph(4,Kg|Ng,qh.bind(null,
b,a),c)},useLayoutEffect:function(a,b){return ph(4,Kg|Ng,a,b)},useMemo:function(a,b){var c=kh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&ch(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:mh,useRef:function(){return kh().memoizedState},useState:function(a){return mh(lh,a)},useDebugValue:rh,useResponder:kd},th=null,uh=null,vh=!1;
function wh(a,b){var c=xh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function yh(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function zh(a){if(vh){var b=uh;if(b){var c=b;if(!yh(a,b)){b=Ne(c.nextSibling);if(!b||!yh(a,b)){a.effectTag|=2;vh=!1;th=a;return}wh(th,c)}th=a;uh=Ne(b.firstChild)}else a.effectTag|=2,vh=!1,th=a}}function Ah(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&18!==a.tag;)a=a.return;th=a}
function Bh(a){if(a!==th)return!1;if(!vh)return Ah(a),vh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Ke(b,a.memoizedProps))for(b=uh;b;)wh(a,b),b=Ne(b.nextSibling);Ah(a);uh=th?Ne(a.stateNode.nextSibling):null;return!0}function Ch(){uh=th=null;vh=!1}var Dh=Xb.ReactCurrentOwner,Lf=!1;function S(a,b,c,d){b.child=null===a?ug(b,null,c,d):tg(b,a.child,c,d)}
function Eh(a,b,c,d,e){c=c.render;var f=b.ref;Kf(b,e);d=dh(a,b,c,d,f,e);if(null!==a&&!Lf)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Fh(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
function Gh(a,b,c,d,e,f){if(null===a){var h=c.type;if("function"===typeof h&&!Hh(h)&&void 0===h.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=h,Ih(a,b,h,d,e,f);a=qg(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}h=a.child;if(e<f&&(e=h.memoizedProps,c=c.compare,c=null!==c?c:jd,c(e,d)&&a.ref===b.ref))return Fh(a,b,f);b.effectTag|=1;a=og(h,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function Ih(a,b,c,d,e,f){return null!==a&&jd(a.memoizedProps,d)&&a.ref===b.ref&&(Lf=!1,e<f)?Fh(a,b,f):Jh(a,b,c,d,f)}function Kh(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Jh(a,b,c,d,e){var f=N(c)?Re:L.current;f=Se(b,f);Kf(b,e);c=dh(a,b,c,d,f,e);if(null!==a&&!Lf)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Fh(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
function Lh(a,b,c,d,e){if(N(c)){var f=!0;Xe(b)}else f=!1;Kf(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),hg(b,c,d,e),jg(b,c,d,e),d=!0;else if(null===a){var h=b.stateNode,g=b.memoizedProps;h.props=g;var k=h.context,l=c.contextType;"object"===typeof l&&null!==l?l=Mf(l):(l=N(c)?Re:L.current,l=Se(b,l));var n=c.getDerivedStateFromProps,z="function"===typeof n||"function"===typeof h.getSnapshotBeforeUpdate;z||"function"!==typeof h.UNSAFE_componentWillReceiveProps&&
"function"!==typeof h.componentWillReceiveProps||(g!==d||k!==l)&&ig(b,h,d,l);Nf=!1;var x=b.memoizedState;k=h.state=x;var v=b.updateQueue;null!==v&&(Wf(b,v,d,h,e),k=b.memoizedState);g!==d||x!==k||M.current||Nf?("function"===typeof n&&(bg(b,c,n,d),k=b.memoizedState),(g=Nf||gg(b,c,g,d,x,k,l))?(z||"function"!==typeof h.UNSAFE_componentWillMount&&"function"!==typeof h.componentWillMount||("function"===typeof h.componentWillMount&&h.componentWillMount(),"function"===typeof h.UNSAFE_componentWillMount&&
h.UNSAFE_componentWillMount()),"function"===typeof h.componentDidMount&&(b.effectTag|=4)):("function"===typeof h.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),h.props=d,h.state=k,h.context=l,d=g):("function"===typeof h.componentDidMount&&(b.effectTag|=4),d=!1)}else h=b.stateNode,g=b.memoizedProps,h.props=b.type===b.elementType?g:Af(b.type,g),k=h.context,l=c.contextType,"object"===typeof l&&null!==l?l=Mf(l):(l=N(c)?Re:L.current,l=Se(b,l)),n=c.getDerivedStateFromProps,(z=
"function"===typeof n||"function"===typeof h.getSnapshotBeforeUpdate)||"function"!==typeof h.UNSAFE_componentWillReceiveProps&&"function"!==typeof h.componentWillReceiveProps||(g!==d||k!==l)&&ig(b,h,d,l),Nf=!1,k=b.memoizedState,x=h.state=k,v=b.updateQueue,null!==v&&(Wf(b,v,d,h,e),x=b.memoizedState),g!==d||k!==x||M.current||Nf?("function"===typeof n&&(bg(b,c,n,d),x=b.memoizedState),(n=Nf||gg(b,c,g,d,k,x,l))?(z||"function"!==typeof h.UNSAFE_componentWillUpdate&&"function"!==typeof h.componentWillUpdate||
("function"===typeof h.componentWillUpdate&&h.componentWillUpdate(d,x,l),"function"===typeof h.UNSAFE_componentWillUpdate&&h.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof h.componentDidUpdate&&(b.effectTag|=4),"function"===typeof h.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof h.componentDidUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof h.getSnapshotBeforeUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=x),h.props=d,h.state=x,h.context=l,d=n):("function"!==typeof h.componentDidUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof h.getSnapshotBeforeUpdate||g===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return Mh(a,b,c,d,f,e)}
function Mh(a,b,c,d,e,f){Kh(a,b);var h=0!==(b.effectTag&64);if(!d&&!h)return e&&Ye(b,c,!1),Fh(a,b,f);d=b.stateNode;Dh.current=b;var g=h&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&h?(b.child=tg(b,a.child,null,f),b.child=tg(b,null,g,f)):S(a,b,g,f);b.memoizedState=d.state;e&&Ye(b,c,!0);return b.child}function Nh(a){var b=a.stateNode;b.pendingContext?Ve(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ve(a,b.context,!1);Ag(a,b.containerInfo)}
var Oh={};
function Ph(a,b,c){var d=b.mode,e=b.pendingProps,f=P.current,h=null,g=!1,k;(k=0!==(b.effectTag&64))||(k=0!==(f&Gg)&&(null===a||null!==a.memoizedState));k?(h=Oh,g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=Fg);f&=Eg;J(P,f,b);if(null===a)if(g){e=e.fallback;a=sg(null,d,0,null);a.return=b;if(0===(b.mode&2))for(g=null!==b.memoizedState?b.child.child:b.child,a.child=g;null!==g;)g.return=a,g=g.sibling;c=sg(e,d,c,null);c.return=b;a.sibling=
c;d=a}else d=c=ug(b,null,e.children,c);else{if(null!==a.memoizedState)if(f=a.child,d=f.sibling,g){e=e.fallback;c=og(f,f.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==f.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;e=og(d,e,d.expirationTime);e.return=b;c.sibling=e;d=c;c.childExpirationTime=0;c=e}else d=c=tg(b,f.child,e.children,c);else if(f=a.child,g){g=e.fallback;e=sg(null,d,0,null);e.return=b;e.child=f;null!==f&&(f.return=e);if(0===(b.mode&
2))for(f=null!==b.memoizedState?b.child.child:b.child,e.child=f;null!==f;)f.return=e,f=f.sibling;c=sg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;d=e;e.childExpirationTime=0}else c=d=tg(b,f,e.children,c);b.stateNode=a.stateNode}b.memoizedState=h;b.child=d;return c}function Qh(a,b,c,d,e){var f=a.memoizedState;null===f?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e}:(f.isBackwards=b,f.rendering=null,f.last=d,f.tail=c,f.tailExpiration=0,f.tailMode=e)}
function Rh(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;S(a,b,d.children,c);d=P.current;if(0!==(d&Gg))d=d&Eg|Gg,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag){if(null!==a.memoizedState){a.expirationTime<c&&(a.expirationTime=c);var h=a.alternate;null!==h&&h.expirationTime<c&&(h.expirationTime=c);Jf(a.return,c)}}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===
b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=Eg}J(P,d,b);if(0===(b.mode&2))b.memoizedState=null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)d=c.alternate,null!==d&&null===Hg(d)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Qh(b,!1,e,c,f);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){d=e.alternate;if(null!==d&&null===Hg(d)){b.child=e;break}d=e.sibling;e.sibling=c;c=e;e=d}Qh(b,!0,c,null,f);break;case "together":Qh(b,
!1,null,null,void 0);break;default:b.memoizedState=null}return b.child}function Fh(a,b,c){null!==a&&(b.dependencies=a.dependencies);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw t(Error(153));if(null!==b.child){a=b.child;c=og(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=og(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Sh(a){a.effectTag|=4}
var Th=void 0,Uh=void 0,Vh=void 0,Wh=void 0;Th=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(20===c.tag)a.appendChild(c.stateNode.instance);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Uh=function(){};
Vh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var h=b.stateNode;zg(wg.current);a=null;switch(c){case "input":f=Bc(h,f);d=Bc(h,d);a=[];break;case "option":f=le(h,f);d=le(h,d);a=[];break;case "select":f=m({},f,{value:void 0});d=m({},d,{value:void 0});a=[];break;case "textarea":f=ne(h,f);d=ne(h,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(h.onclick=Ge)}De(c,d);h=c=void 0;var g=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
c){var k=f[c];for(h in k)k.hasOwnProperty(h)&&(g||(g={}),g[h]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ia.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var l=d[c];k=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&l!==k&&(null!=l||null!=k))if("style"===c)if(k){for(h in k)!k.hasOwnProperty(h)||l&&l.hasOwnProperty(h)||(g||(g={}),g[h]="");for(h in l)l.hasOwnProperty(h)&&k[h]!==l[h]&&(g||
(g={}),g[h]=l[h])}else g||(a||(a=[]),a.push(c,g)),g=l;else"dangerouslySetInnerHTML"===c?(l=l?l.__html:void 0,k=k?k.__html:void 0,null!=l&&k!==l&&(a=a||[]).push(c,""+l)):"children"===c?k===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(c,""+l):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ia.hasOwnProperty(c)?(null!=l&&Fe(e,c),a||k===l||(a=[])):(a=a||[]).push(c,l))}g&&(a=a||[]).push("style",g);e=a;(b.updateQueue=e)&&Sh(b)}};Wh=function(a,b,c,d){c!==d&&Sh(b)};
function $h(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function ai(a){switch(a.tag){case 1:N(a.type)&&Te(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:Bg(a);Ue(a);b=a.effectTag;if(0!==(b&64))throw t(Error(285));a.effectTag=b&-2049|64;return a;case 5:return Dg(a),null;case 13:return H(P,a),b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 18:return null;case 19:return H(P,a),null;case 4:return Bg(a),null;case 10:return If(a),null;default:return null}}function bi(a,b){return{value:a,source:b,stack:pc(b)}}
var ci="function"===typeof WeakSet?WeakSet:Set;function di(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=pc(c));null!==c&&oc(c.type);b=b.value;null!==a&&1===a.tag&&oc(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function ei(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){fi(a,c)}}function gi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){fi(a,c)}else b.current=null}
function hi(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Ig){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Ig&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function ii(a,b){"function"===typeof ji&&ji(a);switch(a.tag){case 0:case 11:case 14:case 15:var c=a.updateQueue;if(null!==c&&(c=c.lastEffect,null!==c)){var d=c.next;vf(97<b?97:b,function(){var b=d;do{var c=b.destroy;if(void 0!==c){var h=a;try{c()}catch(g){fi(h,g)}}b=b.next}while(b!==d)})}break;case 1:gi(a);b=a.stateNode;"function"===typeof b.componentWillUnmount&&ei(a,b);break;case 5:gi(a);break;case 4:ki(a,b)}}
function li(a,b){for(var c=a;;)if(ii(c,b),null!==c.child&&4!==c.tag)c.child.return=c,c=c.child;else{if(c===a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}function mi(a){return 5===a.tag||3===a.tag||4===a.tag}
function ni(a){a:{for(var b=a.return;null!==b;){if(mi(b)){var c=b;break a}b=b.return}throw t(Error(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw t(Error(161));}c.effectTag&16&&(we(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||mi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f||20===e.tag){var h=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var g=h;h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(h,c);else d?(g=b,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=Ge)):
b.appendChild(h)}else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function ki(a,b){for(var c=a,d=!1,e=void 0,f=void 0;;){if(!d){d=c.return;a:for(;;){if(null===d)throw t(Error(160));e=d.stateNode;switch(d.tag){case 5:f=!1;break a;case 3:e=e.containerInfo;f=!0;break a;case 4:e=e.containerInfo;f=!0;break a}d=d.return}d=!0}if(5===c.tag||6===c.tag)if(li(c,b),f){var h=e,g=c.stateNode;8===h.nodeType?h.parentNode.removeChild(g):h.removeChild(g)}else e.removeChild(c.stateNode);else if(20===c.tag)g=c.stateNode.instance,li(c,b),f?(h=e,8===h.nodeType?h.parentNode.removeChild(g):
h.removeChild(g)):e.removeChild(g);else if(4===c.tag){if(null!==c.child){e=c.stateNode.containerInfo;f=!0;c.child.return=c;c=c.child;continue}}else if(ii(c,b),null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return;4===c.tag&&(d=!1)}c.sibling.return=c.return;c=c.sibling}}
function oi(a,b){switch(b.tag){case 0:case 11:case 14:case 15:hi(Kg,Lg,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Ga]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Dc(c,d);Ee(a,e);b=Ee(a,d);for(e=0;e<f.length;e+=2){var h=f[e],g=f[e+1];"style"===h?Ae(c,g):"dangerouslySetInnerHTML"===h?ve(c,g):"children"===h?we(c,g):zc(c,h,g,b)}switch(a){case "input":Ec(c,d);break;case "textarea":pe(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?me(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?me(c,!!d.multiple,d.defaultValue,!0):me(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw t(Error(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,pi=sf());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=
f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ze("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===
a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}qi(b);break;case 19:qi(b);break;case 17:break;case 20:break;default:throw t(Error(163));}}function qi(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new ci);b.forEach(function(b){var d=ri.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var si="function"===typeof WeakMap?WeakMap:Map;
function ti(a,b,c){c=Qf(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){ui||(ui=!0,vi=d);di(a,b)};return c}
function wi(a,b,c){c=Qf(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){di(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===xi?xi=new Set([this]):xi.add(this),di(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var yi=Math.ceil,zi=Xb.ReactCurrentDispatcher,Ai=Xb.ReactCurrentOwner,T=0,Bi=8,Ci=16,Di=32,Ei=0,Fi=1,Gi=2,Hi=3,Ii=4,U=T,Ji=null,V=null,W=0,X=Ei,Ki=1073741823,Li=1073741823,Mi=null,Ni=!1,pi=0,Oi=500,Y=null,ui=!1,vi=null,xi=null,Pi=!1,Qi=null,Ri=90,Si=0,Ti=null,Ui=0,Vi=null,Wi=0;function cg(){return(U&(Ci|Di))!==T?1073741821-(sf()/10|0):0!==Wi?Wi:Wi=1073741821-(sf()/10|0)}
function dg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=tf();if(0===(b&4))return 99===d?1073741823:1073741822;if((U&Ci)!==T)return W;if(null!==c)a=1073741821-25*(((1073741821-a+(c.timeoutMs|0||5E3)/10)/25|0)+1);else switch(d){case 99:a=1073741823;break;case 98:a=1073741821-10*(((1073741821-a+15)/10|0)+1);break;case 97:case 96:a=1073741821-25*(((1073741821-a+500)/25|0)+1);break;case 95:a=1;break;default:throw t(Error(326));}null!==Ji&&a===W&&--a;return a}var Xi=0;
function eg(a,b){if(50<Ui)throw Ui=0,Vi=null,t(Error(185));a=Yi(a,b);if(null!==a){a.pingTime=0;var c=tf();if(1073741823===b)if((U&Bi)!==T&&(U&(Ci|Di))===T)for(var d=Z(a,1073741823,!0);null!==d;)d=d(!0);else Zi(a,99,1073741823),U===T&&O();else Zi(a,c,b);(U&4)===T||98!==c&&99!==c||(null===Ti?Ti=new Map([[a,b]]):(c=Ti.get(a),(void 0===c||c>b)&&Ti.set(a,b)))}}
function Yi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(b>e.firstPendingTime&&(e.firstPendingTime=b),a=e.lastPendingTime,0===a||b<a)&&(e.lastPendingTime=
b);return e}function Zi(a,b,c){if(a.callbackExpirationTime<c){var d=a.callbackNode;null!==d&&d!==mf&&af(d);a.callbackExpirationTime=c;1073741823===c?a.callbackNode=xf($i.bind(null,a,Z.bind(null,a,c))):(d=null,1!==c&&(d={timeout:10*(1073741821-c)-sf()}),a.callbackNode=wf(b,$i.bind(null,a,Z.bind(null,a,c)),d))}}function $i(a,b,c){var d=a.callbackNode,e=null;try{return e=b(c),null!==e?$i.bind(null,a,e):null}finally{null===e&&d===a.callbackNode&&(a.callbackNode=null,a.callbackExpirationTime=0)}}
function aj(){(U&(1|Ci|Di))===T&&(bj(),cj())}function dj(a,b){var c=a.firstBatch;return null!==c&&c._defer&&c._expirationTime>=b?(wf(97,function(){c._onComplete();return null}),!0):!1}function bj(){if(null!==Ti){var a=Ti;Ti=null;a.forEach(function(a,c){xf(Z.bind(null,c,a))});O()}}function ej(a,b){var c=U;U|=1;try{return a(b)}finally{U=c,U===T&&O()}}function fj(a,b,c,d){var e=U;U|=4;try{return vf(98,a.bind(null,b,c,d))}finally{U=e,U===T&&O()}}
function gj(a,b){var c=U;U&=-2;U|=Bi;try{return a(b)}finally{U=c,U===T&&O()}}
function hj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Me(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Te(d);break;case 3:Bg(d);Ue(d);break;case 5:Dg(d);break;case 4:Bg(d);break;case 13:H(P,d);break;case 19:H(P,d);break;case 10:If(d)}c=c.return}Ji=a;V=og(a.current,null,b);W=b;X=Ei;Li=Ki=1073741823;Mi=null;Ni=!1}
function Z(a,b,c){if((U&(Ci|Di))!==T)throw t(Error(327));if(a.firstPendingTime<b)return null;if(c&&a.finishedExpirationTime===b)return ij.bind(null,a);cj();if(a!==Ji||b!==W)hj(a,b);else if(X===Hi)if(Ni)hj(a,b);else{var d=a.lastPendingTime;if(d<b)return Z.bind(null,a,d)}if(null!==V){d=U;U|=Ci;var e=zi.current;null===e&&(e=hh);zi.current=hh;if(c){if(1073741823!==b){var f=cg();if(f<b)return U=d,Gf(),zi.current=e,Z.bind(null,a,f)}}else Wi=0;do try{if(c)for(;null!==V;)V=jj(V);else for(;null!==V&&!bf();)V=
jj(V);break}catch(rb){Gf();ih();f=V;if(null===f||null===f.return)throw hj(a,b),U=d,rb;a:{var h=a,g=f.return,k=f,l=rb,n=W;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==l&&"object"===typeof l&&"function"===typeof l.then){var z=l,x=0!==(P.current&Fg);l=g;do{var v;if(v=13===l.tag)null!==l.memoizedState?v=!1:(v=l.memoizedProps,v=void 0===v.fallback?!1:!0!==v.unstable_avoidThisFallback?!0:x?!1:!0);if(v){g=l.updateQueue;null===g?(g=new Set,g.add(z),l.updateQueue=g):g.add(z);if(0===(l.mode&
2)){l.effectTag|=64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(n=Qf(1073741823,null),n.tag=2,Sf(k,n)));k.expirationTime=1073741823;break a}k=h;h=n;x=k.pingCache;null===x?(x=k.pingCache=new si,g=new Set,x.set(z,g)):(g=x.get(z),void 0===g&&(g=new Set,x.set(z,g)));g.has(h)||(g.add(h),k=kj.bind(null,k,z,h),z.then(k,k));l.effectTag|=2048;l.expirationTime=n;break a}l=l.return}while(null!==l);l=Error((oc(k.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+
pc(k))}X!==Ii&&(X=Fi);l=bi(l,k);k=g;do{switch(k.tag){case 3:k.effectTag|=2048;k.expirationTime=n;n=ti(k,l,n);Tf(k,n);break a;case 1:if(z=l,h=k.type,g=k.stateNode,0===(k.effectTag&64)&&("function"===typeof h.getDerivedStateFromError||null!==g&&"function"===typeof g.componentDidCatch&&(null===xi||!xi.has(g)))){k.effectTag|=2048;k.expirationTime=n;n=wi(k,z,n);Tf(k,n);break a}}k=k.return}while(null!==k)}V=lj(f)}while(1);U=d;Gf();zi.current=e;if(null!==V)return Z.bind(null,a,b)}a.finishedWork=a.current.alternate;
a.finishedExpirationTime=b;if(dj(a,b))return null;Ji=null;switch(X){case Ei:throw t(Error(328));case Fi:return d=a.lastPendingTime,d<b?Z.bind(null,a,d):c?ij.bind(null,a):(hj(a,b),xf(Z.bind(null,a,b)),null);case Gi:if(1073741823===Ki&&!c&&(c=pi+Oi-sf(),10<c)){if(Ni)return hj(a,b),Z.bind(null,a,b);d=a.lastPendingTime;if(d<b)return Z.bind(null,a,d);a.timeoutHandle=Le(ij.bind(null,a),c);return null}return ij.bind(null,a);case Hi:if(!c){if(Ni)return hj(a,b),Z.bind(null,a,b);c=a.lastPendingTime;if(c<b)return Z.bind(null,
a,c);1073741823!==Li?c=10*(1073741821-Li)-sf():1073741823===Ki?c=0:(c=10*(1073741821-Ki)-5E3,d=sf(),b=10*(1073741821-b)-d,c=d-c,0>c&&(c=0),c=(120>c?120:480>c?480:1080>c?1080:1920>c?1920:3E3>c?3E3:4320>c?4320:1960*yi(c/1960))-c,b<c&&(c=b));if(10<c)return a.timeoutHandle=Le(ij.bind(null,a),c),null}return ij.bind(null,a);case Ii:return!c&&1073741823!==Ki&&null!==Mi&&(d=Ki,e=Mi,b=e.busyMinDurationMs|0,0>=b?b=0:(c=e.busyDelayMs|0,d=sf()-(10*(1073741821-d)-(e.timeoutMs|0||5E3)),b=d<=c?0:c+b-d),10<b)?(a.timeoutHandle=
Le(ij.bind(null,a),b),null):ij.bind(null,a);default:throw t(Error(329));}}function Xf(a,b){a<Ki&&1<a&&(Ki=a);null!==b&&a<Li&&1<a&&(Li=a,Mi=b)}function jj(a){var b=mj(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=lj(a));Ai.current=null;return b}
function lj(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&1024)){a:{var c=b;b=V;var d=W,e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:N(b.type)&&Te(b);break;case 3:Bg(b);Ue(b);d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===c||null===c.child)Bh(b),b.effectTag&=-3;Uh(b);break;case 5:Dg(b);d=zg(yg.current);var f=b.type;if(null!==c&&null!=b.stateNode)Vh(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var h=
zg(wg.current);if(Bh(b)){c=b;e=void 0;f=c.stateNode;var g=c.type,k=c.memoizedProps;f[Fa]=c;f[Ga]=k;switch(g){case "iframe":case "object":case "embed":G("load",f);break;case "video":case "audio":for(var l=0;l<bb.length;l++)G(bb[l],f);break;case "source":G("error",f);break;case "img":case "image":case "link":G("error",f);G("load",f);break;case "form":G("reset",f);G("submit",f);break;case "details":G("toggle",f);break;case "input":Cc(f,k);G("invalid",f);Fe(d,"onChange");break;case "select":f._wrapperState=
{wasMultiple:!!k.multiple};G("invalid",f);Fe(d,"onChange");break;case "textarea":oe(f,k),G("invalid",f),Fe(d,"onChange")}De(g,k);l=null;for(e in k)k.hasOwnProperty(e)&&(h=k[e],"children"===e?"string"===typeof h?f.textContent!==h&&(l=["children",h]):"number"===typeof h&&f.textContent!==""+h&&(l=["children",""+h]):ia.hasOwnProperty(e)&&null!=h&&Fe(d,e));switch(g){case "input":Vb(f);Gc(f,k,!0);break;case "textarea":Vb(f);qe(f,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
(f.onclick=Ge)}d=l;c.updateQueue=d;null!==d&&Sh(b)}else{k=f;c=e;g=b;l=9===d.nodeType?d:d.ownerDocument;h===re.html&&(h=se(k));h===re.html?"script"===k?(k=l.createElement("div"),k.innerHTML="<script>\x3c/script>",l=k.removeChild(k.firstChild)):"string"===typeof c.is?l=l.createElement(k,{is:c.is}):(l=l.createElement(k),"select"===k&&(k=l,c.multiple?k.multiple=!0:c.size&&(k.size=c.size))):l=l.createElementNS(h,k);k=l;k[Fa]=g;k[Ga]=c;c=k;Th(c,b,!1,!1);g=c;var n=d,z=Ee(f,e);switch(f){case "iframe":case "object":case "embed":G("load",
g);d=e;break;case "video":case "audio":for(d=0;d<bb.length;d++)G(bb[d],g);d=e;break;case "source":G("error",g);d=e;break;case "img":case "image":case "link":G("error",g);G("load",g);d=e;break;case "form":G("reset",g);G("submit",g);d=e;break;case "details":G("toggle",g);d=e;break;case "input":Cc(g,e);d=Bc(g,e);G("invalid",g);Fe(n,"onChange");break;case "option":d=le(g,e);break;case "select":g._wrapperState={wasMultiple:!!e.multiple};d=m({},e,{value:void 0});G("invalid",g);Fe(n,"onChange");break;case "textarea":oe(g,
e);d=ne(g,e);G("invalid",g);Fe(n,"onChange");break;default:d=e}De(f,d);k=void 0;l=f;h=g;var x=d;for(k in x)if(x.hasOwnProperty(k)){var v=x[k];"style"===k?Ae(h,v):"dangerouslySetInnerHTML"===k?(v=v?v.__html:void 0,null!=v&&ve(h,v)):"children"===k?"string"===typeof v?("textarea"!==l||""!==v)&&we(h,v):"number"===typeof v&&we(h,""+v):"suppressContentEditableWarning"!==k&&"suppressHydrationWarning"!==k&&"autoFocus"!==k&&(ia.hasOwnProperty(k)?null!=v&&Fe(n,k):null!=v&&zc(h,k,v,z))}switch(f){case "input":Vb(g);
Gc(g,e,!1);break;case "textarea":Vb(g);qe(g,e);break;case "option":null!=e.value&&g.setAttribute("value",""+Ac(e.value));break;case "select":d=g;g=e;d.multiple=!!g.multiple;k=g.value;null!=k?me(d,!!g.multiple,k,!1):null!=g.defaultValue&&me(d,!!g.multiple,g.defaultValue,!0);break;default:"function"===typeof d.onClick&&(g.onclick=Ge)}Je(f,e)&&Sh(b);b.stateNode=c}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw t(Error(166));break;case 6:if(c&&null!=b.stateNode)Wh(c,b,c.memoizedProps,
e);else{if("string"!==typeof e&&null===b.stateNode)throw t(Error(166));c=zg(yg.current);zg(wg.current);Bh(b)?(d=b.stateNode,c=b.memoizedProps,d[Fa]=b,d.nodeValue!==c&&Sh(b)):(d=b,c=(9===c.nodeType?c:c.ownerDocument).createTextNode(e),c[Fa]=b,d.stateNode=c)}break;case 11:break;case 13:H(P,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}d=null!==e;e=!1;null===c?Bh(b):(f=c.memoizedState,e=null!==f,d||null===f||(f=c.child.sibling,null!==f&&(g=b.firstEffect,null!==g?(b.firstEffect=
f,f.nextEffect=g):(b.firstEffect=b.lastEffect=f,f.nextEffect=null),f.effectTag=8)));if(d&&!e&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(P.current&Fg))X===Ei&&(X=Gi);else if(X===Ei||X===Gi)X=Hi;if(d||e)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Bg(b);Uh(b);break;case 10:If(b);break;case 9:break;case 14:break;case 17:N(b.type)&&Te(b);break;case 18:break;case 19:H(P,b);e=b.memoizedState;if(null===e)break;f=0!==(b.effectTag&64);g=e.rendering;
if(null===g)if(f)$h(e,!1);else{if(X!==Ei||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){g=Hg(c);if(null!==g){b.effectTag|=64;$h(e,!1);c=g.updateQueue;null!==c&&(b.updateQueue=c,b.effectTag|=4);b.firstEffect=b.lastEffect=null;for(c=b.child;null!==c;)e=c,f=d,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,g=e.alternate,null===g?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=
g.childExpirationTime,e.expirationTime=g.expirationTime,e.child=g.child,e.memoizedProps=g.memoizedProps,e.memoizedState=g.memoizedState,e.updateQueue=g.updateQueue,f=g.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),c=c.sibling;J(P,P.current&Eg|Gg,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=Hg(g),null!==c){if(b.effectTag|=64,f=!0,$h(e,!0),null===e.tail&&"hidden"===e.tailMode){d=c.updateQueue;null!==d&&(b.updateQueue=
d,b.effectTag|=4);b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else sf()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,$h(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(g.sibling=b.child,b.child=g):(d=e.last,null!==d?d.sibling=g:b.child=g,e.last=g)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=sf()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;e.lastEffect=b.lastEffect;d.sibling=null;c=P.current;c=f?c&Eg|Gg:c&Eg;J(P,c,b);b=d;break a}break;case 20:break;
default:throw t(Error(156));}b=null}d=V;if(1===W||1!==d.childExpirationTime){c=0;for(e=d.child;null!==e;)f=e.expirationTime,g=e.childExpirationTime,f>c&&(c=f),g>c&&(c=g),e=e.sibling;d.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&1024)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,
a.lastEffect=V))}else{b=ai(V,W);if(null!==b)return b.effectTag&=1023,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=1024)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===Ei&&(X=Ii);return null}function ij(a){var b=tf();vf(99,nj.bind(null,a,b));null!==Qi&&wf(97,function(){cj();return null});return null}
function nj(a,b){cj();if((U&(Ci|Di))!==T)throw t(Error(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw t(Error(177));a.callbackNode=null;a.callbackExpirationTime=0;var e=c.expirationTime,f=c.childExpirationTime;e=f>e?f:e;a.firstPendingTime=e;e<a.lastPendingTime&&(a.lastPendingTime=e);a===Ji&&(V=Ji=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;
if(null!==e){f=U;U|=Di;Ai.current=null;He=Qd;var h=ae();if(be(h)){if("selectionStart"in h)var g={start:h.selectionStart,end:h.selectionEnd};else a:{g=(g=h.ownerDocument)&&g.defaultView||window;var k=g.getSelection&&g.getSelection();if(k&&0!==k.rangeCount){g=k.anchorNode;var l=k.anchorOffset,n=k.focusNode;k=k.focusOffset;try{g.nodeType,n.nodeType}catch(zb){g=null;break a}var z=0,x=-1,v=-1,rb=0,Be=0,u=h,w=null;b:for(;;){for(var C;;){u!==g||0!==l&&3!==u.nodeType||(x=z+l);u!==n||0!==k&&3!==u.nodeType||
(v=z+k);3===u.nodeType&&(z+=u.nodeValue.length);if(null===(C=u.firstChild))break;w=u;u=C}for(;;){if(u===h)break b;w===g&&++rb===l&&(x=z);w===n&&++Be===k&&(v=z);if(null!==(C=u.nextSibling))break;u=w;w=u.parentNode}u=C}g=-1===x||-1===v?null:{start:x,end:v}}else g=null}g=g||{start:0,end:0}}else g=null;Ie={focusedElem:h,selectionRange:g};Qd=!1;Y=e;do try{for(;null!==Y;){if(0!==(Y.effectTag&256)){var I=Y.alternate;h=Y;switch(h.tag){case 0:case 11:case 15:hi(Jg,Ig,h);break;case 1:if(h.effectTag&256&&null!==
I){var E=I.memoizedProps,ua=I.memoizedState,gh=h.stateNode,oj=gh.getSnapshotBeforeUpdate(h.elementType===h.type?E:Af(h.type,E),ua);gh.__reactInternalSnapshotBeforeUpdate=oj}break;case 3:case 5:case 6:case 4:case 17:break;default:throw t(Error(163));}}Y=Y.nextEffect}}catch(zb){if(null===Y)throw t(Error(330));fi(Y,zb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(I=b;null!==Y;){var A=Y.effectTag;A&16&&we(Y.stateNode,"");if(A&128){var p=Y.alternate;if(null!==p){var r=p.ref;null!==r&&("function"===typeof r?
r(null):r.current=null)}}switch(A&14){case 2:ni(Y);Y.effectTag&=-3;break;case 6:ni(Y);Y.effectTag&=-3;oi(Y.alternate,Y);break;case 4:oi(Y.alternate,Y);break;case 8:E=Y;ki(E,I);E.return=null;E.child=null;E.memoizedState=null;E.updateQueue=null;E.dependencies=null;var K=E.alternate;null!==K&&(K.return=null,K.child=null,K.memoizedState=null,K.updateQueue=null,K.dependencies=null)}Y=Y.nextEffect}}catch(zb){if(null===Y)throw t(Error(330));fi(Y,zb);Y=Y.nextEffect}while(null!==Y);r=Ie;p=ae();A=r.focusedElem;
I=r.selectionRange;if(p!==A&&A&&A.ownerDocument&&$d(A.ownerDocument.documentElement,A)){null!==I&&be(A)&&(p=I.start,r=I.end,void 0===r&&(r=p),"selectionStart"in A?(A.selectionStart=p,A.selectionEnd=Math.min(r,A.value.length)):(r=(p=A.ownerDocument||document)&&p.defaultView||window,r.getSelection&&(r=r.getSelection(),E=A.textContent.length,K=Math.min(I.start,E),I=void 0===I.end?K:Math.min(I.end,E),!r.extend&&K>I&&(E=I,I=K,K=E),E=Zd(A,K),ua=Zd(A,I),E&&ua&&(1!==r.rangeCount||r.anchorNode!==E.node||r.anchorOffset!==
E.offset||r.focusNode!==ua.node||r.focusOffset!==ua.offset)&&(p=p.createRange(),p.setStart(E.node,E.offset),r.removeAllRanges(),K>I?(r.addRange(p),r.extend(ua.node,ua.offset)):(p.setEnd(ua.node,ua.offset),r.addRange(p))))));p=[];for(r=A;r=r.parentNode;)1===r.nodeType&&p.push({element:r,left:r.scrollLeft,top:r.scrollTop});"function"===typeof A.focus&&A.focus();for(A=0;A<p.length;A++)r=p[A],r.element.scrollLeft=r.left,r.element.scrollTop=r.top}Ie=null;Qd=!!He;He=null;a.current=c;Y=e;do try{for(A=d;null!==
Y;){var $a=Y.effectTag;if($a&36){var nc=Y.alternate;p=Y;r=A;switch(p.tag){case 0:case 11:case 15:hi(Mg,Ng,p);break;case 1:var md=p.stateNode;if(p.effectTag&4)if(null===nc)md.componentDidMount();else{var Fj=p.elementType===p.type?nc.memoizedProps:Af(p.type,nc.memoizedProps);md.componentDidUpdate(Fj,nc.memoizedState,md.__reactInternalSnapshotBeforeUpdate)}var Xh=p.updateQueue;null!==Xh&&Yf(p,Xh,md,r);break;case 3:var Yh=p.updateQueue;if(null!==Yh){K=null;if(null!==p.child)switch(p.child.tag){case 5:K=
p.child.stateNode;break;case 1:K=p.child.stateNode}Yf(p,Yh,K,r)}break;case 5:var Gj=p.stateNode;null===nc&&p.effectTag&4&&(r=Gj,Je(p.type,p.memoizedProps)&&r.focus());break;case 6:break;case 4:break;case 12:break;case 13:case 19:case 17:case 20:break;default:throw t(Error(163));}}if($a&128){var nd=Y.ref;if(null!==nd){var Zh=Y.stateNode;switch(Y.tag){case 5:var gf=Zh;break;default:gf=Zh}"function"===typeof nd?nd(gf):nd.current=gf}}$a&512&&(Pi=!0);Y=Y.nextEffect}}catch(zb){if(null===Y)throw t(Error(330));
fi(Y,zb);Y=Y.nextEffect}while(null!==Y);Y=null;nf();U=f}else a.current=c;if(Pi)Pi=!1,Qi=a,Si=d,Ri=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0!==b?($a=cg(),$a=zf($a,b),Zi(a,$a,b)):xi=null;"function"===typeof pj&&pj(c.stateNode,d);1073741823===b?a===Vi?Ui++:(Ui=0,Vi=a):Ui=0;if(ui)throw ui=!1,a=vi,vi=null,a;if((U&Bi)!==T)return null;O();return null}
function cj(){if(null===Qi)return!1;var a=Qi,b=Si,c=Ri;Qi=null;Si=0;Ri=90;return vf(97<c?97:c,qj.bind(null,a,b))}function qj(a){if((U&(Ci|Di))!==T)throw t(Error(331));var b=U;U|=Di;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:hi(Pg,Ig,c),hi(Ig,Og,c)}}catch(d){if(null===a)throw t(Error(330));fi(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}U=b;O();return!0}
function rj(a,b,c){b=bi(c,b);b=ti(a,b,1073741823);Sf(a,b);a=Yi(a,1073741823);null!==a&&Zi(a,99,1073741823)}function fi(a,b){if(3===a.tag)rj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){rj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===xi||!xi.has(d))){a=bi(b,a);a=wi(c,a,1073741823);Sf(c,a);c=Yi(c,1073741823);null!==c&&Zi(c,99,1073741823);break}}c=c.return}}
function kj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);Ji===a&&W===c?X===Hi||X===Gi&&1073741823===Ki&&sf()-pi<Oi?hj(a,W):Ni=!0:a.lastPendingTime<c||(b=a.pingTime,0!==b&&b<c||(a.pingTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),b=cg(),b=zf(b,c),Zi(a,b,c)))}function ri(a,b){var c=a.stateNode;null!==c&&c.delete(b);c=cg();b=dg(c,a,null);c=zf(c,b);a=Yi(a,b);null!==a&&Zi(a,c,b)}var mj=void 0;
mj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||M.current)Lf=!0;else if(d<c){Lf=!1;switch(b.tag){case 3:Nh(b);Ch();break;case 5:Cg(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:N(b.type)&&Xe(b);break;case 4:Ag(b,b.stateNode.containerInfo);break;case 10:Hf(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return Ph(a,b,c);J(P,P.current&
Eg,b);b=Fh(a,b,c);return null!==b?b.sibling:null}J(P,P.current&Eg,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Rh(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);J(P,P.current,b);if(!d)return null}return Fh(a,b,c)}}else Lf=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Se(b,L.current);Kf(b,c);e=dh(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&
null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;ih();if(N(d)){var f=!0;Xe(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var h=d.getDerivedStateFromProps;"function"===typeof h&&bg(b,d,h,a);e.updater=fg;b.stateNode=e;e._reactInternalFiber=b;jg(b,d,a,c);b=Mh(null,b,d,!0,f,c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Bf(e);b.type=e;f=b.tag=sj(e);
a=Af(e,a);switch(f){case 0:b=Jh(null,b,e,a,c);break;case 1:b=Lh(null,b,e,a,c);break;case 11:b=Eh(null,b,e,a,c);break;case 14:b=Gh(null,b,e,Af(e.type,a),d,c);break;default:throw t(Error(306),e,"");}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),Jh(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),Lh(a,b,d,e,c);case 3:Nh(b);d=b.updateQueue;if(null===d)throw t(Error(282));e=b.memoizedState;e=null!==e?e.element:null;Wf(b,d,b.pendingProps,
null,c);d=b.memoizedState.element;if(d===e)Ch(),b=Fh(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)uh=Ne(b.stateNode.containerInfo.firstChild),th=b,e=vh=!0;e?(b.effectTag|=2,b.child=ug(b,null,d,c)):(S(a,b,d,c),Ch());b=b.child}return b;case 5:return Cg(b),null===a&&zh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,h=e.children,Ke(d,e)?h=null:null!==f&&Ke(d,f)&&(b.effectTag|=16),Kh(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):
(S(a,b,h,c),b=b.child),b;case 6:return null===a&&zh(b),null;case 13:return Ph(a,b,c);case 4:return Ag(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=tg(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),Eh(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;h=b.memoizedProps;
f=e.value;Hf(b,f);if(null!==h){var g=h.value;f=hd(g,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(g,f):1073741823)|0;if(0===f){if(h.children===e.children&&!M.current){b=Fh(a,b,c);break a}}else for(g=b.child,null!==g&&(g.return=b);null!==g;){var k=g.dependencies;if(null!==k){h=g.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===g.tag&&(l=Qf(c,null),l.tag=2,Sf(g,l));g.expirationTime<c&&(g.expirationTime=c);l=g.alternate;null!==l&&l.expirationTime<
c&&(l.expirationTime=c);Jf(g.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else h=10===g.tag?g.type===b.type?null:g.child:g.child;if(null!==h)h.return=g;else for(h=g;null!==h;){if(h===b){h=null;break}g=h.sibling;if(null!==g){g.return=h.return;h=g;break}h=h.return}g=h}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Kf(b,c),e=Mf(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=Af(e,b.pendingProps),
f=Af(e.type,f),Gh(a,b,e,f,d,c);case 15:return Ih(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:Af(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,N(d)?(a=!0,Xe(b)):a=!1,Kf(b,c),hg(b,d,e,c),jg(b,d,e,c),Mh(null,b,d,!0,a,c);case 19:return Rh(a,b,c)}throw t(Error(156));};var pj=null,ji=null;
function tj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);pj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};ji=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function uj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function xh(a,b,c,d){return new uj(a,b,c,d)}
function Hh(a){a=a.prototype;return!(!a||!a.isReactComponent)}function sj(a){if("function"===typeof a)return Hh(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gc)return 11;if(a===jc)return 14}return 2}
function og(a,b){var c=a.alternate;null===c?(c=xh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function qg(a,b,c,d,e,f){var h=2;d=a;if("function"===typeof a)Hh(a)&&(h=1);else if("string"===typeof a)h=5;else a:switch(a){case ac:return sg(c.children,e,f,b);case fc:h=8;e|=7;break;case bc:h=8;e|=1;break;case cc:return a=xh(12,c,b,e|8),a.elementType=cc,a.type=cc,a.expirationTime=f,a;case hc:return a=xh(13,c,b,e),a.type=hc,a.elementType=hc,a.expirationTime=f,a;case ic:return a=xh(19,c,b,e),a.elementType=ic,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case dc:h=
10;break a;case ec:h=9;break a;case gc:h=11;break a;case jc:h=14;break a;case kc:h=16;d=null;break a}throw t(Error(130),null==a?a:typeof a,"");}b=xh(h,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function sg(a,b,c,d){a=xh(7,a,d,b);a.expirationTime=c;return a}function pg(a,b,c){a=xh(6,a,null,b);a.expirationTime=c;return a}
function rg(a,b,c){b=xh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function vj(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=this.firstBatch=null;this.pingTime=this.lastPendingTime=this.firstPendingTime=this.callbackExpirationTime=0}function wj(a,b,c){a=new vj(a,b,c);b=xh(3,null,null,2===b?7:1===b?3:0);a.current=b;return b.stateNode=a}
function xj(a,b,c,d,e,f){var h=b.current;a:if(c){c=c._reactInternalFiber;b:{if(2!==ld(c)||1!==c.tag)throw t(Error(170));var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(N(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);throw t(Error(171));}if(1===c.tag){var k=c.type;if(N(k)){c=We(c,k,g);break a}}c=g}else c=Qe;null===b.context?b.context=c:b.pendingContext=c;b=f;e=Qf(d,e);e.payload={element:a};b=void 0===b?null:b;null!==b&&
(e.callback=b);Sf(h,e);eg(h,d);return d}function yj(a,b,c,d){var e=b.current,f=cg(),h=$f.suspense;e=dg(f,e,h);return xj(a,b,c,e,h,d)}function zj(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Aj(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$b,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
Db=function(a,b,c){switch(b){case "input":Ec(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ka(d);if(!e)throw t(Error(90));Wb(d);Ec(d,e)}}}break;case "textarea":pe(a,c);break;case "select":b=c.value,null!=b&&me(a,!!c.multiple,b,!1)}};
function Bj(a){var b=1073741821-25*(((1073741821-cg()+500)/25|0)+1);b<=Xi&&--b;this._expirationTime=Xi=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Bj.prototype.render=function(a){if(!this._defer)throw t(Error(250));this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Cj;xj(a,b,null,c,null,d._onCommit);return d};
Bj.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Bj.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;if(!this._defer||null===b)throw t(Error(251));if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;if(null===d)throw t(Error(251));d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;b=c;if((U&(Ci|Di))!==T)throw t(Error(253));xf(Z.bind(null,a,b));O();b=this._next;this._next=
null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=null,this._defer=!1};Bj.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Cj(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Cj.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
Cj.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];if("function"!==typeof c)throw t(Error(191),c);c()}}};function Dj(a,b,c){this._internalRoot=wj(a,b,c)}function Ej(a,b){this._internalRoot=wj(a,2,b)}Ej.prototype.render=Dj.prototype.render=function(a,b){var c=this._internalRoot,d=new Cj;b=void 0===b?null:b;null!==b&&d.then(b);yj(a,c,null,d._onCommit);return d};
Ej.prototype.unmount=Dj.prototype.unmount=function(a){var b=this._internalRoot,c=new Cj;a=void 0===a?null:a;null!==a&&c.then(a);yj(null,b,null,c._onCommit);return c};Ej.prototype.createBatch=function(){var a=new Bj(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};
function Hj(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Jb=ej;Kb=fj;Lb=aj;Mb=function(a,b){var c=U;U|=2;try{return a(b)}finally{U=c,U===T&&O()}};function Ij(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Dj(a,0,b)}
function Jj(a,b,c,d,e){var f=c._reactRootContainer,h=void 0;if(f){h=f._internalRoot;if("function"===typeof e){var g=e;e=function(){var a=zj(h);g.call(a)}}yj(b,h,a,e)}else{f=c._reactRootContainer=Ij(c,d);h=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=zj(h);k.call(a)}}gj(function(){yj(b,h,a,e)})}return zj(h)}function Kj(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!Hj(b))throw t(Error(200));return Aj(a,b,null,c)}
var Nj={createPortal:Kj,findDOMNode:function(a){if(null==a)a=null;else if(1!==a.nodeType){var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw t(Error(188));throw t(Error(268),Object.keys(a));}a=qd(b);a=null===a?null:a.stateNode}return a},hydrate:function(a,b,c){if(!Hj(b))throw t(Error(200));return Jj(null,a,b,!0,c)},render:function(a,b,c){if(!Hj(b))throw t(Error(200));return Jj(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!Hj(c))throw t(Error(200));
if(null==a||void 0===a._reactInternalFiber)throw t(Error(38));return Jj(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!Hj(a))throw t(Error(40));return a._reactRootContainer?(gj(function(){Jj(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return Kj.apply(void 0,arguments)},unstable_batchedUpdates:ej,unstable_interactiveUpdates:function(a,b,c,d){aj();return fj(a,b,c,d)},unstable_discreteUpdates:fj,unstable_flushDiscreteUpdates:aj,flushSync:function(a,
b){if((U&(Ci|Di))!==T)throw t(Error(187));var c=U;U|=1;try{return vf(99,a.bind(null,b))}finally{U=c,O()}},unstable_createRoot:Lj,unstable_createSyncRoot:Mj,unstable_flushControlled:function(a){var b=U;U|=1;try{vf(99,a)}finally{U=b,U===T&&O()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ia,Ja,Ka,Ca.injectEventPluginsByName,fa,Qa,function(a){ya(a,Pa)},Hb,Ib,Ud,Ba,cj,{current:!1}]}};
function Lj(a,b){if(!Hj(a))throw t(Error(299),"unstable_createRoot");return new Ej(a,null!=b&&!0===b.hydrate)}function Mj(a,b){if(!Hj(a))throw t(Error(299),"unstable_createRoot");return new Dj(a,1,null!=b&&!0===b.hydrate)}
(function(a){var b=a.findFiberByHostInstance;return tj(m({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Xb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=qd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Ha,bundleType:0,version:"16.9.0",
rendererPackageName:"react-dom"});var Oj={default:Nj},Pj=Oj&&Nj||Oj;module.exports=Pj.default||Pj;


/***/ }),
/* 3176 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e(__webpack_require__(0),__webpack_require__(338),__webpack_require__(46)):"function"==typeof define&&define.amd?define(["react","draft-js","immutable"],e):"object"==typeof exports?exports.reactDraftWysiwyg=e(require("react"),require("draft-js"),require("immutable")):t.reactDraftWysiwyg=e(t.react,t["draft-js"],t.immutable)}(window,function(n,o,r){return a={},i.m=c=[function(t,e,n){t.exports=n(10)()},function(t,e){t.exports=n},function(t,e,n){var o;
/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
!function(){"use strict";var c={}.hasOwnProperty;function a(){for(var t=[],e=0;e<arguments.length;e++){var n=arguments[e];if(n){var o=typeof n;if("string"==o||"number"==o)t.push(n);else if(Array.isArray(n)&&n.length){var r=a.apply(null,n);r&&t.push(r)}else if("object"==o)for(var i in n)c.call(n,i)&&n[i]&&t.push(i)}}return t.join(" ")}t.exports?(a.default=a,t.exports=a):void 0===(o=function(){return a}.apply(e,[]))||(t.exports=o)}()},function(t,e){t.exports=o},function(t,e,n){function r(t){if(a[t])return a[t].exports;var e=a[t]={i:t,l:!1,exports:{}};return c[t].call(e.exports,e,e.exports,r),e.l=!0,e.exports}var o,i,c,a;window,t.exports=(o=n(3),i=n(5),a={},r.m=c=[function(t,e){t.exports=o},function(t,e){t.exports=i},function(t,e,n){t.exports=n(3)},function(t,e,n){"use strict";n.r(e);var M=n(0),i=n(1);function j(t){var e=t.getSelection(),n=t.getCurrentContent(),o=e.getStartKey(),r=e.getEndKey(),i=n.getBlockMap();return i.toSeq().skipUntil(function(t,e){return e===o}).takeUntil(function(t,e){return e===r}).concat([[r,i.get(r)]])}function u(t){return j(t).toList()}function l(t){if(t)return u(t).get(0)}function o(t){if(t){var n=l(t),e=t.getCurrentContent().getBlockMap().toSeq().toList(),o=0;if(e.forEach(function(t,e){t.get("key")===n.get("key")&&(o=e-1)}),-1<o)return e.get(o)}}function r(t){return t?t.getCurrentContent().getBlockMap().toList():new i.List}function c(t){var e=u(t);if(!e.some(function(t){return t.type!==e.get(0).type}))return e.get(0).type}function a(t){var e=M.RichUtils.tryToRemoveBlockStyle(t);return e?M.EditorState.push(t,e,"change-block-type"):t}function s(t){var e="",n=t.getSelection(),o=n.getAnchorOffset(),r=n.getFocusOffset(),i=u(t);if(0<i.size){if(n.getIsBackward()){var c=o;o=r,r=c}for(var a=0;a<i.size;a+=1){var l=0===a?o:0,s=a===i.size-1?r:i.get(a).getText().length;e+=i.get(a).getText().slice(l,s)}}return e}function p(t){var e=t.getCurrentContent(),n=t.getSelection(),o=M.Modifier.removeRange(e,n,"forward"),r=o.getSelectionAfter(),i=o.getBlockForKey(r.getStartKey());return o=M.Modifier.insertText(o,r,"\n",i.getInlineStyleAt(r.getStartOffset()),null),M.EditorState.push(t,o,"insert-fragment")}function d(t){var e=M.Modifier.splitBlock(t.getCurrentContent(),t.getSelection());return a(M.EditorState.push(t,e,"split-block"))}function f(t){var e=t.getCurrentContent().getBlockMap().toList(),n=t.getSelection().merge({anchorKey:e.first().get("key"),anchorOffset:0,focusKey:e.last().get("key"),focusOffset:e.last().getLength()}),o=M.Modifier.removeRange(t.getCurrentContent(),n,"forward");return M.EditorState.push(t,o,"remove-range")}function y(t,e){var n=M.Modifier.setBlockData(t.getCurrentContent(),t.getSelection(),e);return M.EditorState.push(t,n,"change-block-data")}function m(t){var o=new i.Map({}),e=u(t);if(e&&0<e.size)for(var n=function(t){var n=e.get(t).getData();if(!n||0===n.size)return o=o.clear(),"break";if(0===t)o=n;else if(o.forEach(function(t,e){n.get(e)&&n.get(e)===t||(o=o.delete(e))}),0===o.size)return o=o.clear(),"break"},r=0;r<e.size&&"break"!==n(r);r+=1);return o}var g=Object(i.Map)({code:{element:"pre"}}),b=M.DefaultDraftBlockRenderMap.merge(g);function h(t){if(t){var e=t.getType();return"unordered-list-item"===e||"ordered-list-item"===e}return!1}function v(t,e,n){var o,r=t.getSelection();o=r.getIsBackward()?r.getFocusKey():r.getAnchorKey();var i=t.getCurrentContent(),c=i.getBlockForKey(o),a=c.getType();if("unordered-list-item"!==a&&"ordered-list-item"!==a)return t;var l=i.getBlockBefore(o);if(!l)return t;if(l.getType()!==a)return t;var s=c.getDepth();if(1===e&&s===n)return t;var u,p,d,f,y,m,g,b=Math.min(l.getDepth()+1,n),h=(p=e,d=b,f=(u=t).getSelection(),y=u.getCurrentContent(),m=y.getBlockMap(),g=j(u).map(function(t){var e=t.getDepth()+p;return e=Math.max(0,Math.min(e,d)),t.set("depth",e)}),m=m.merge(g),y.merge({blockMap:m,selectionBefore:f,selectionAfter:f}));return M.EditorState.push(t,h,"adjust-depth")}function N(t,e){var n;return 13===(n=e).which&&(n.getModifierState("Shift")||n.getModifierState("Alt")||n.getModifierState("Control"))?t.getSelection().isCollapsed()?M.RichUtils.insertSoftNewline(t):p(t):function(t){var e=t.getSelection();if(e.isCollapsed()){var n=t.getCurrentContent(),o=e.getStartKey(),r=n.getBlockForKey(o);if(!h(r)&&"unstyled"!==r.getType()&&r.getLength()===e.getStartOffset())return d(t);if(h(r)&&0===r.getLength()){var i=r.getDepth();if(0===i)return a(t);if(0<i)return v(t,-1,i)}}}(t)}function E(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,o)}return n}function S(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function w(t){return(w="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function C(t){var e=t.getSelection();if(e.isCollapsed()){var n={},o=t.getCurrentInlineStyle().toList().toJS();if(o)return["BOLD","ITALIC","UNDERLINE","STRIKETHROUGH","CODE","SUPERSCRIPT","SUBSCRIPT"].forEach(function(t){n[t]=0<=o.indexOf(t)}),n}var c=e.getStartOffset(),a=e.getEndOffset(),l=u(t);if(0<l.size){var r=function(){for(var n={BOLD:!0,ITALIC:!0,UNDERLINE:!0,STRIKETHROUGH:!0,CODE:!0,SUPERSCRIPT:!0,SUBSCRIPT:!0},o=0;o<l.size;o+=1){var t=0===o?c:0,e=o===l.size-1?a:l.get(o).getText().length;t===e&&0===t?(t=1,e=2):t===e&&--t;for(var r=function(t){var e=l.get(o).getInlineStyleAt(t);["BOLD","ITALIC","UNDERLINE","STRIKETHROUGH","CODE","SUPERSCRIPT","SUBSCRIPT"].forEach(function(t){n[t]=n[t]&&e.get(t)===t})},i=t;i<e;i+=1)r(i)}return{v:n}}();if("object"===w(r))return r.v}return{}}function L(t){var e,n=t.getSelection(),o=n.getStartOffset(),r=n.getEndOffset();o===r&&0===o?r=1:o===r&&--o;for(var i=l(t),c=o;c<r;c+=1){var a=i.getEntityAt(c);if(!a){e=void 0;break}if(c===o)e=a;else if(e!==a){e=void 0;break}}return e}function D(t,e){var n,o=l(t);return o.findEntityRanges(function(t){return t.get("entity")===e},function(t,e){n={start:t,end:e,text:o.get("text").slice(t,e)}}),n}function k(t,e,n){x[t]["".concat(t.toLowerCase(),"-").concat(n)]=S({},"".concat(e),n)}function O(){return function(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?E(Object(n),!0).forEach(function(t){S(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):E(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}({},x.color,{},x.bgcolor,{},x.fontSize,{},x.fontFamily,{CODE:x.CODE,SUPERSCRIPT:x.SUPERSCRIPT,SUBSCRIPT:x.SUBSCRIPT})}var x={color:{},bgcolor:{},fontSize:{},fontFamily:{},CODE:{fontFamily:"monospace",wordWrap:"break-word",background:"#f1f1f1",borderRadius:3,padding:"1px 3px"},SUPERSCRIPT:{fontSize:11,position:"relative",top:-8,display:"inline-flex"},SUBSCRIPT:{fontSize:11,position:"relative",bottom:-8,display:"inline-flex"}};function I(t,e,n){var o=t.getSelection(),r=Object.keys(x[e]).reduce(function(t,e){return M.Modifier.removeInlineStyle(t,o,e)},t.getCurrentContent()),i=M.EditorState.push(t,r,"changeinline-style"),c=t.getCurrentInlineStyle();if(o.isCollapsed()&&(i=c.reduce(function(t,e){return M.RichUtils.toggleInlineStyle(t,e)},i)),"SUPERSCRIPT"===e||"SUBSCRIPT"==e)c.has(n)||(i=M.RichUtils.toggleInlineStyle(i,n));else{var a="bgcolor"===e?"backgroundColor":e;c.has("".concat(a,"-").concat(n))||(i=M.RichUtils.toggleInlineStyle(i,"".concat(e.toLowerCase(),"-").concat(n)),k(e,a,n))}return i}function T(t){t&&t.getCurrentContent().getBlockMap().map(function(t){return t.get("characterList")}).toList().flatten().forEach(function(t){t&&0===t.indexOf("color-")?k("color","color",t.substr(6)):t&&0===t.indexOf("bgcolor-")?k("bgcolor","backgroundColor",t.substr(8)):t&&0===t.indexOf("fontsize-")?k("fontSize","fontSize",+t.substr(9)):t&&0===t.indexOf("fontfamily-")&&k("fontFamily","fontFamily",t.substr(11))})}function A(t,e,n){var o=t.getInlineStyleAt(n).toList().filter(function(t){return t.startsWith(e.toLowerCase())});if(o&&0<o.size)return o.get(0)}function z(o,s){if(o&&s&&0<s.length){var t=function(){var t=o.getSelection(),i={};if(t.isCollapsed())return s.forEach(function(t){i[t]=function(t,e){var n=t.getCurrentInlineStyle().toList().filter(function(t){return t.startsWith(e.toLowerCase())});if(n&&0<n.size)return n.get(0)}(o,t)}),{v:i};var c=t.getStartOffset(),a=t.getEndOffset(),l=u(o);if(0<l.size){for(var e=function(n){var t=0===n?c:0,e=n===l.size-1?a:l.get(n).getText().length;t===e&&0===t?(t=1,e=2):t===e&&--t;for(var o=function(e){e===t?s.forEach(function(t){i[t]=A(l.get(n),t,e)}):s.forEach(function(t){i[t]&&i[t]!==A(l.get(n),t,e)&&(i[t]=void 0)})},r=t;r<e;r+=1)o(r)},n=0;n<l.size;n+=1)e(n);return{v:i}}}();if("object"===w(t))return t.v}return{}}function _(e){var t=e.getCurrentInlineStyle(),n=e.getCurrentContent();return t.forEach(function(t){n=M.Modifier.removeInlineStyle(n,e.getSelection(),t)}),M.EditorState.push(e,n,"change-inline-style")}n.d(e,"isListBlock",function(){return h}),n.d(e,"changeDepth",function(){return v}),n.d(e,"handleNewLine",function(){return N}),n.d(e,"getEntityRange",function(){return D}),n.d(e,"getCustomStyleMap",function(){return O}),n.d(e,"toggleCustomInlineStyle",function(){return I}),n.d(e,"getSelectionEntity",function(){return L}),n.d(e,"extractInlineStyle",function(){return T}),n.d(e,"removeAllInlineStyles",function(){return _}),n.d(e,"getSelectionInlineStyle",function(){return C}),n.d(e,"getSelectionCustomInlineStyle",function(){return z}),n.d(e,"getSelectedBlocksMap",function(){return j}),n.d(e,"getSelectedBlocksList",function(){return u}),n.d(e,"getSelectedBlock",function(){return l}),n.d(e,"getBlockBeforeSelectedBlock",function(){return o}),n.d(e,"getAllBlocks",function(){return r}),n.d(e,"getSelectedBlocksType",function(){return c}),n.d(e,"removeSelectedBlocksStyle",function(){return a}),n.d(e,"getSelectionText",function(){return s}),n.d(e,"addLineBreakRemovingSelection",function(){return p}),n.d(e,"insertNewUnstyledBlock",function(){return d}),n.d(e,"clearEditorContent",function(){return f}),n.d(e,"setBlockData",function(){return y}),n.d(e,"getSelectedBlocksMetadata",function(){return m}),n.d(e,"blockRenderMap",function(){return b})}],r.c=a,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)r.d(n,o,function(t){return e[t]}.bind(null,o));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=2))},function(t,e){t.exports=r},function(t,e,n){function r(t){if(a[t])return a[t].exports;var e=a[t]={i:t,l:!1,exports:{}};return c[t].call(e.exports,e,e.exports,r),e.l=!0,e.exports}var o,i,c,a;window,t.exports=(o=n(5),i=n(3),a={},r.m=c=[function(t,e){t.exports=o},function(t,e){t.exports=i},function(t,e,n){t.exports=n(3)},function(t,e,n){"use strict";n.r(e);var j=n(1),s=n(0),v=function(t,e,n){var o,r=t.textContent;return""===r.trim()?{chunk:(o=n,{text:" ",inlines:[new s.OrderedSet],entities:[o],blocks:[]})}:{chunk:{text:r,inlines:Array(r.length).fill(e),entities:Array(r.length).fill(n),blocks:[]}}},N=function(){return{text:"\n",inlines:[new s.OrderedSet],entities:new Array(1),blocks:[]}},E=function(){return{text:"",inlines:[],entities:[],blocks:[]}},S=function(t,e){return{text:"",inlines:[],entities:[],blocks:[{type:t,depth:0,data:e||new s.Map({})}]}},w=function(t,e,n){return{text:"\r",inlines:[],entities:[],blocks:[{type:t,depth:Math.max(0,Math.min(4,e)),data:n||new s.Map({})}]}},C=function(t){return{text:"\r ",inlines:[new s.OrderedSet],entities:[t],blocks:[{type:"atomic",depth:0,data:new s.Map({})}]}},L=function(t,e){return{text:t.text+e.text,inlines:t.inlines.concat(e.inlines),entities:t.entities.concat(e.entities),blocks:t.blocks.concat(e.blocks)}},D=new s.Map({"header-one":{element:"h1"},"header-two":{element:"h2"},"header-three":{element:"h3"},"header-four":{element:"h4"},"header-five":{element:"h5"},"header-six":{element:"h6"},"unordered-list-item":{element:"li",wrapper:"ul"},"ordered-list-item":{element:"li",wrapper:"ol"},blockquote:{element:"blockquote"},code:{element:"pre"},atomic:{element:"figure"},unstyled:{element:"p",aliasedElements:["div"]}}),k={code:"CODE",del:"STRIKETHROUGH",em:"ITALIC",strong:"BOLD",ins:"UNDERLINE",sub:"SUBSCRIPT",sup:"SUPERSCRIPT"};function O(t){return t.style.textAlign?new s.Map({"text-align":t.style.textAlign}):t.style.marginLeft?new s.Map({"margin-left":t.style.marginLeft}):void 0}var x=function(t){var e=void 0;if(t instanceof HTMLAnchorElement){var n={};e=t.dataset&&void 0!==t.dataset.mention?(n.url=t.href,n.text=t.innerHTML,n.value=t.dataset.value,j.Entity.__create("MENTION","IMMUTABLE",n)):(n.url=t.getAttribute&&t.getAttribute("href")||t.href,n.title=t.innerHTML,n.targetOption=t.target,j.Entity.__create("LINK","MUTABLE",n))}return e};n.d(e,"default",function(){return o});var u=" ",p=new RegExp("&nbsp;","g"),I=!0;function o(t,e){var n,o,r,i=(n=e,o=t.trim().replace(p,u),(r=function(t){var e,n=null;return document.implementation&&document.implementation.createHTMLDocument&&((e=document.implementation.createHTMLDocument("foo")).documentElement.innerHTML=t,n=e.getElementsByTagName("body")[0]),n}(o))?(I=!0,{chunk:function t(e,n,o,r,i,c){var a=e.nodeName.toLowerCase();if(c){var l=c(a,e);if(l){var s=j.Entity.__create(l.type,l.mutability,l.data||{});return{chunk:C(s)}}}if("#text"===a&&"\n"!==e.textContent)return v(e,n,i);if("br"===a)return{chunk:N()};if("img"===a&&e instanceof HTMLImageElement){var u={};u.src=e.getAttribute&&e.getAttribute("src")||e.src,u.alt=e.alt,u.height=e.style.height,u.width=e.style.width,e.style.float&&(u.alignment=e.style.float);var p=j.Entity.__create("IMAGE","MUTABLE",u);return{chunk:C(p)}}if("video"===a&&e instanceof HTMLVideoElement){var d={};d.src=e.getAttribute&&e.getAttribute("src")||e.src,d.alt=e.alt,d.height=e.style.height,d.width=e.style.width,e.style.float&&(d.alignment=e.style.float);var f=j.Entity.__create("VIDEO","MUTABLE",d);return{chunk:C(f)}}if("iframe"===a&&e instanceof HTMLIFrameElement){var y={};y.src=e.getAttribute&&e.getAttribute("src")||e.src,y.height=e.height,y.width=e.width;var m=j.Entity.__create("EMBEDDED_LINK","MUTABLE",y);return{chunk:C(m)}}var g,b=function(e,n){var t=D.filter(function(t){return t.element===e&&(!t.wrapper||t.wrapper===n)||t.wrapper===e||t.aliasedElements&&-1<t.aliasedElements.indexOf(e)}).keySeq().toSet().toArray();if(1===t.length)return t[0]}(a,r);b&&("ul"===a||"ol"===a?(r=a,o+=1):("unordered-list-item"!==b&&"ordered-list-item"!==b&&(r="",o=-1),I?(g=S(b,O(e)),I=!1):g=w(b,o,O(e)))),g=g||E(),n=function(t,e,n){var o,r=k[t];if(r)o=n.add(r).toOrderedSet();else if(e instanceof HTMLElement){var l=e;o=(o=n).withMutations(function(t){var e=l.style.color,n=l.style.backgroundColor,o=l.style.fontSize,r=l.style.fontFamily.replace(/^"|"$/g,""),i=l.style.fontWeight,c=l.style.textDecoration,a=l.style.fontStyle;e&&t.add("color-".concat(e.replace(/ /g,""))),n&&t.add("bgcolor-".concat(n.replace(/ /g,""))),o&&t.add("fontsize-".concat(o.replace(/px$/g,""))),r&&t.add("fontfamily-".concat(r)),"bold"===i&&t.add(k.strong),"underline"===c&&t.add(k.ins),"italic"===a&&t.add(k.em)}).toOrderedSet()}return o}(a,e,n);for(var h=e.firstChild;h;){var M=t(h,n,o,r,x(h)||i,c).chunk;g=L(g,M),h=h.nextSibling}return{chunk:g}}(r,new s.OrderedSet,-1,"",void 0,n).chunk}):null);if(i){var c=i.chunk,a=new s.OrderedMap({});c.entities&&c.entities.forEach(function(t){t&&(a=a.set(t,j.Entity.__get(t)))});var l=0;return{contentBlocks:c.text.split("\r").map(function(t,e){var n=l+t.length,o=c&&c.inlines.slice(l,n),r=c&&c.entities.slice(l,n),i=new s.List(o.map(function(t,e){var n={style:t,entity:null};return r[e]&&(n.entity=r[e]),j.CharacterMetadata.create(n)}));return l=n,new j.ContentBlock({key:Object(j.genKey)(),type:c&&c.blocks[e]&&c.blocks[e].type||"unstyled",depth:c&&c.blocks[e]&&c.blocks[e].depth,data:c&&c.blocks[e]&&c.blocks[e].data||new s.Map({}),text:t,characterList:i})}),entityMap:a}}return null}}],r.c=a,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},r.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)r.d(n,o,function(t){return e[t]}.bind(null,o));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s=2))},function(t,e,l){"use strict";function o(n){return Array.prototype.slice.call(arguments,1).forEach(function(e){e&&Object.keys(e).forEach(function(t){n[t]=e[t]})}),n}function s(t){return Object.prototype.toString.call(t)}function u(t){return"[object Function]"===s(t)}function p(t){return t.replace(/[.?*+^$[\]\\(){}|-]/g,"\\$&")}var r={fuzzyLink:!0,fuzzyEmail:!0,fuzzyIP:!1};var i={"http:":{validate:function(t,e,n){var o=t.slice(e);return n.re.http||(n.re.http=new RegExp("^\\/\\/"+n.re.src_auth+n.re.src_host_port_strict+n.re.src_path,"i")),n.re.http.test(o)?o.match(n.re.http)[0].length:0}},"https:":"http:","ftp:":"http:","//":{validate:function(t,e,n){var o=t.slice(e);return n.re.no_http||(n.re.no_http=new RegExp("^"+n.re.src_auth+"(?:localhost|(?:(?:"+n.re.src_domain+")\\.)+"+n.re.src_domain_root+")"+n.re.src_port+n.re.src_host_terminator+n.re.src_path,"i")),n.re.no_http.test(o)?3<=e&&":"===t[e-3]?0:3<=e&&"/"===t[e-3]?0:o.match(n.re.no_http)[0].length:0}},"mailto:":{validate:function(t,e,n){var o=t.slice(e);return n.re.mailto||(n.re.mailto=new RegExp("^"+n.re.src_email_name+"@"+n.re.src_host_strict,"i")),n.re.mailto.test(o)?o.match(n.re.mailto)[0].length:0}}},d="a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]",c="biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф".split("|");function f(){return function(t,e){e.normalize(t)}}function a(r){var e=r.re=l(21)(r.__opts__),t=r.__tlds__.slice();function n(t){return t.replace("%TLDS%",e.src_tlds)}r.onCompile(),r.__tlds_replaced__||t.push(d),t.push(e.src_xn),e.src_tlds=t.join("|"),e.email_fuzzy=RegExp(n(e.tpl_email_fuzzy),"i"),e.link_fuzzy=RegExp(n(e.tpl_link_fuzzy),"i"),e.link_no_ip_fuzzy=RegExp(n(e.tpl_link_no_ip_fuzzy),"i"),e.host_fuzzy_test=RegExp(n(e.tpl_host_fuzzy_test),"i");var i=[];function c(t,e){throw new Error('(LinkifyIt) Invalid schema "'+t+'": '+e)}r.__compiled__={},Object.keys(r.__schemas__).forEach(function(t){var e=r.__schemas__[t];if(null!==e){var o,n={validate:null,link:null};if(r.__compiled__[t]=n,"[object Object]"===s(e))return"[object RegExp]"===s(e.validate)?n.validate=(o=e.validate,function(t,e){var n=t.slice(e);return o.test(n)?n.match(o)[0].length:0}):u(e.validate)?n.validate=e.validate:c(t,e),void(u(e.normalize)?n.normalize=e.normalize:e.normalize?c(t,e):n.normalize=f());if("[object String]"!==s(e))c(t,e);else i.push(t)}}),i.forEach(function(t){r.__compiled__[r.__schemas__[t]]&&(r.__compiled__[t].validate=r.__compiled__[r.__schemas__[t]].validate,r.__compiled__[t].normalize=r.__compiled__[r.__schemas__[t]].normalize)}),r.__compiled__[""]={validate:null,normalize:f()};var o,a=Object.keys(r.__compiled__).filter(function(t){return 0<t.length&&r.__compiled__[t]}).map(p).join("|");r.re.schema_test=RegExp("(^|(?!_)(?:[><｜]|"+e.src_ZPCc+"))("+a+")","i"),r.re.schema_search=RegExp("(^|(?!_)(?:[><｜]|"+e.src_ZPCc+"))("+a+")","ig"),r.re.pretest=RegExp("("+r.re.schema_test.source+")|("+r.re.host_fuzzy_test.source+")|@","i"),(o=r).__index__=-1,o.__text_cache__=""}function y(t,e){var n=t.__index__,o=t.__last_index__,r=t.__text_cache__.slice(n,o);this.schema=t.__schema__.toLowerCase(),this.index=n+e,this.lastIndex=o+e,this.raw=r,this.text=r,this.url=r}function m(t,e){var n=new y(t,e);return t.__compiled__[n.schema].normalize(n,t),n}function g(t,e){if(!(this instanceof g))return new g(t,e);var n;e||(n=t,Object.keys(n||{}).reduce(function(t,e){return t||r.hasOwnProperty(e)},!1)&&(e=t,t={})),this.__opts__=o({},r,e),this.__index__=-1,this.__last_index__=-1,this.__schema__="",this.__text_cache__="",this.__schemas__=o({},i,t),this.__compiled__={},this.__tlds__=c,this.__tlds_replaced__=!1,this.re={},a(this)}g.prototype.add=function(t,e){return this.__schemas__[t]=e,a(this),this},g.prototype.set=function(t){return this.__opts__=o(this.__opts__,t),this},g.prototype.test=function(t){if(this.__text_cache__=t,this.__index__=-1,!t.length)return!1;var e,n,o,r,i,c,a,l;if(this.re.schema_test.test(t))for((a=this.re.schema_search).lastIndex=0;null!==(e=a.exec(t));)if(r=this.testSchemaAt(t,e[2],a.lastIndex)){this.__schema__=e[2],this.__index__=e.index+e[1].length,this.__last_index__=e.index+e[0].length+r;break}return this.__opts__.fuzzyLink&&this.__compiled__["http:"]&&0<=(l=t.search(this.re.host_fuzzy_test))&&(this.__index__<0||l<this.__index__)&&null!==(n=t.match(this.__opts__.fuzzyIP?this.re.link_fuzzy:this.re.link_no_ip_fuzzy))&&(i=n.index+n[1].length,(this.__index__<0||i<this.__index__)&&(this.__schema__="",this.__index__=i,this.__last_index__=n.index+n[0].length)),this.__opts__.fuzzyEmail&&this.__compiled__["mailto:"]&&0<=t.indexOf("@")&&null!==(o=t.match(this.re.email_fuzzy))&&(i=o.index+o[1].length,c=o.index+o[0].length,(this.__index__<0||i<this.__index__||i===this.__index__&&c>this.__last_index__)&&(this.__schema__="mailto:",this.__index__=i,this.__last_index__=c)),0<=this.__index__},g.prototype.pretest=function(t){return this.re.pretest.test(t)},g.prototype.testSchemaAt=function(t,e,n){return this.__compiled__[e.toLowerCase()]?this.__compiled__[e.toLowerCase()].validate(t,n,this):0},g.prototype.match=function(t){var e=0,n=[];0<=this.__index__&&this.__text_cache__===t&&(n.push(m(this,e)),e=this.__last_index__);for(var o=e?t.slice(e):t;this.test(o);)n.push(m(this,e)),o=o.slice(this.__last_index__),e+=this.__last_index__;return n.length?n:null},g.prototype.tlds=function(t,e){return t=Array.isArray(t)?t:[t],e?this.__tlds__=this.__tlds__.concat(t).sort().filter(function(t,e,n){return t!==n[e-1]}).reverse():(this.__tlds__=t.slice(),this.__tlds_replaced__=!0),a(this),this},g.prototype.normalize=function(t){t.schema||(t.url="http://"+t.url),"mailto:"!==t.schema||/^mailto:/i.test(t.url)||(t.url="mailto:"+t.url)},g.prototype.onCompile=function(){},t.exports=g},function(t,e,n){t.exports=n(40)},function(t,e,n){},function(t,e,n){"use strict";var a=n(11);function o(){}function r(){}r.resetWarningCache=o,t.exports=function(){function t(t,e,n,o,r,i){if(i!==a){var c=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw c.name="Invariant Violation",c}}function e(){return t}var n={array:t.isRequired=t,bigint:t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:e,element:t,elementType:t,instanceOf:e,node:t,objectOf:e,oneOf:e,oneOfType:e,shape:e,exact:e,checkPropTypes:r,resetWarningCache:o};return n.PropTypes=n}},function(t,e,n){"use strict";t.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,o){"use strict";t.exports=function(t){var e={};e.src_Any=o(22).source,e.src_Cc=o(23).source,e.src_Z=o(24).source,e.src_P=o(25).source,e.src_ZPCc=[e.src_Z,e.src_P,e.src_Cc].join("|"),e.src_ZCc=[e.src_Z,e.src_Cc].join("|");var n="[><｜]";return e.src_pseudo_letter="(?:(?![><｜]|"+e.src_ZPCc+")"+e.src_Any+")",e.src_ip4="(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)",e.src_auth="(?:(?:(?!"+e.src_ZCc+"|[@/\\[\\]()]).)+@)?",e.src_port="(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?",e.src_host_terminator="(?=$|[><｜]|"+e.src_ZPCc+")(?!-|_|:\\d|\\.-|\\.(?!$|"+e.src_ZPCc+"))",e.src_path="(?:[/?#](?:(?!"+e.src_ZCc+"|"+n+"|[()[\\]{}.,\"'?!\\-]).|\\[(?:(?!"+e.src_ZCc+"|\\]).)*\\]|\\((?:(?!"+e.src_ZCc+"|[)]).)*\\)|\\{(?:(?!"+e.src_ZCc+'|[}]).)*\\}|\\"(?:(?!'+e.src_ZCc+'|["]).)+\\"|\\\'(?:(?!'+e.src_ZCc+"|[']).)+\\'|\\'(?="+e.src_pseudo_letter+"|[-]).|\\.{2,4}[a-zA-Z0-9%/]|\\.(?!"+e.src_ZCc+"|[.]).|"+(t&&t["---"]?"\\-(?!--(?:[^-]|$))(?:-*)|":"\\-+|")+"\\,(?!"+e.src_ZCc+").|\\!(?!"+e.src_ZCc+"|[!]).|\\?(?!"+e.src_ZCc+"|[?]).)+|\\/)?",e.src_email_name='[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*',e.src_xn="xn--[a-z0-9\\-]{1,59}",e.src_domain_root="(?:"+e.src_xn+"|"+e.src_pseudo_letter+"{1,63})",e.src_domain="(?:"+e.src_xn+"|(?:"+e.src_pseudo_letter+")|(?:"+e.src_pseudo_letter+"(?:-|"+e.src_pseudo_letter+"){0,61}"+e.src_pseudo_letter+"))",e.src_host="(?:(?:(?:(?:"+e.src_domain+")\\.)*"+e.src_domain+"))",e.tpl_host_fuzzy="(?:"+e.src_ip4+"|(?:(?:(?:"+e.src_domain+")\\.)+(?:%TLDS%)))",e.tpl_host_no_ip_fuzzy="(?:(?:(?:"+e.src_domain+")\\.)+(?:%TLDS%))",e.src_host_strict=e.src_host+e.src_host_terminator,e.tpl_host_fuzzy_strict=e.tpl_host_fuzzy+e.src_host_terminator,e.src_host_port_strict=e.src_host+e.src_port+e.src_host_terminator,e.tpl_host_port_fuzzy_strict=e.tpl_host_fuzzy+e.src_port+e.src_host_terminator,e.tpl_host_port_no_ip_fuzzy_strict=e.tpl_host_no_ip_fuzzy+e.src_port+e.src_host_terminator,e.tpl_host_fuzzy_test="localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:"+e.src_ZPCc+"|>|$))",e.tpl_email_fuzzy='(^|[><｜]|"|\\(|'+e.src_ZCc+")("+e.src_email_name+"@"+e.tpl_host_fuzzy_strict+")",e.tpl_link_fuzzy="(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|"+e.src_ZPCc+"))((?![$+<=>^`|｜])"+e.tpl_host_port_fuzzy_strict+e.src_path+")",e.tpl_link_no_ip_fuzzy="(^|(?![.:/\\-_@])(?:[$+<=>^`|｜]|"+e.src_ZPCc+"))((?![$+<=>^`|｜])"+e.tpl_host_port_no_ip_fuzzy_strict+e.src_path+")",e}},function(t,e){t.exports=/[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/},function(t,e){t.exports=/[\0-\x1F\x7F-\x9F]/},function(t,e){t.exports=/[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/},function(t,e){t.exports=/[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4E\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDF55-\uDF59]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDC3B\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){},function(t,e,n){"use strict";n.r(e),n.d(e,"Editor",function(){return ar});var f=n(1),N=n.n(f),o=n(0),y=n.n(o),E=n(3),S=n(4),r=n(2),w=n.n(r);function i(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function c(t,e,n){return e&&i(t.prototype,e),n&&i(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}var a=c(function t(){var n=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.callBacks=[],this.suggestionCallback=void 0,this.editorFlag=!1,this.suggestionFlag=!1,this.closeAllModals=function(e){n.callBacks.forEach(function(t){t(e)})},this.init=function(t){var e=document.getElementById(t);e&&e.addEventListener("click",function(){n.editorFlag=!0}),document&&(document.addEventListener("click",function(){n.editorFlag?n.editorFlag=!1:(n.closeAllModals(),n.suggestionCallback&&n.suggestionCallback())}),document.addEventListener("keydown",function(t){"Escape"===t.key&&n.closeAllModals()}))},this.onEditorClick=function(){n.closeModals(),!n.suggestionFlag&&n.suggestionCallback?n.suggestionCallback():n.suggestionFlag=!1},this.closeModals=function(t){n.closeAllModals(t)},this.registerCallBack=function(t){n.callBacks.push(t)},this.deregisterCallBack=function(e){n.callBacks=n.callBacks.filter(function(t){return t!==e})},this.setSuggestionCallback=function(t){n.suggestionCallback=t},this.removeSuggestionCallback=function(){n.suggestionCallback=void 0},this.onSuggestionClick=function(){n.suggestionFlag=!0}});function l(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function s(t,e,n){return e&&l(t.prototype,e),n&&l(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}var u,p=s(function t(){var e=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.inputFocused=!1,this.editorMouseDown=!1,this.onEditorMouseDown=function(){e.editorFocused=!0},this.onInputMouseDown=function(){e.inputFocused=!0},this.isEditorBlur=function(t){return"INPUT"!==t.target.tagName&&"LABEL"!==t.target.tagName&&"TEXTAREA"!==t.target.tagName||e.editorFocused?!("INPUT"===t.target.tagName&&"LABEL"===t.target.tagName&&"TEXTAREA"===t.target.tagName||e.inputFocused)&&!(e.editorFocused=!1):!(e.inputFocused=!1)},this.isEditorFocused=function(){return!e.inputFocused||(e.inputFocused=!1)},this.isToolbarFocused=function(){return!e.editorFocused||(e.editorFocused=!1)},this.isInputFocused=function(){return e.inputFocused}}),d=[],C={onKeyDown:function(e){d.forEach(function(t){t(e)})},registerCallBack:function(t){d.push(t)},deregisterCallBack:function(e){d=d.filter(function(t){return t!==e})}},m=function(){u=!0},g=function(){u=!1},b=function(){return u};function L(t){var e=t.getData()&&t.getData().get("text-align");return e?"rdw-".concat(e,"-aligned-block"):""}function h(t,e){if(t)for(var n in t)!{}.hasOwnProperty.call(t,n)||e(n,t[n])}function M(t,e){var n=!1;if(t)for(var o in t)if({}.hasOwnProperty.call(t,o)&&e===o){n=!0;break}return n}function j(t){t.stopPropagation()}function v(t){return t[t.options[0]].icon}function D(t,o){if(t&&void 0===o)return t;var r={};return h(t,function(t,e){var n;n=e,"[object Object]"===Object.prototype.toString.call(n)?r[t]=D(e,o[t]):r[t]=void 0!==o[t]?o[t]:e}),r}var k=n(6),O=n.n(k),x=n(5);n(9);function I(t){return(I="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function T(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function A(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function z(t,e){return(z=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function _(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=P(o);if(r){var n=P(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===I(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function P(t){return(P=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var R=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&z(t,e)}(i,f["Component"]);var t,e,n,o=_(i);function i(){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(r=o.call.apply(o,[this].concat(e))).onClick=function(){var t=r.props,e=t.disabled,n=t.onClick,o=t.value;e||n(o)},r}return t=i,(e=[{key:"render",value:function(){var t,e=this.props,n=e.children,o=e.className,r=e.activeClassName,i=e.active,c=e.disabled,a=e.title;return N.a.createElement("div",{className:w()("rdw-option-wrapper",o,(T(t={},"rdw-option-active ".concat(r),i),T(t,"rdw-option-disabled",c),t)),onClick:this.onClick,"aria-selected":i,title:a},n)}}])&&A(t.prototype,e),n&&A(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();R.propTypes={onClick:y.a.func.isRequired,children:y.a.any,value:y.a.string,className:y.a.string,activeClassName:y.a.string,active:y.a.bool,disabled:y.a.bool,title:y.a.string},R.defaultProps={activeClassName:""};n(12);function U(t){return(U="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function B(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function F(t,e){return(F=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Y(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Q(o);if(r){var n=Q(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===U(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Q(t){return(Q=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var H=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&F(t,e)}(i,f["Component"]);var t,e,n,r=Y(i);function i(){var o;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(o=r.call.apply(r,[this].concat(e))).state={highlighted:-1},o.onChange=function(t){var e=o.props.onChange;e&&e(t),o.toggleExpansion()},o.setHighlighted=function(t){o.setState({highlighted:t})},o.toggleExpansion=function(){var t=o.props,e=t.doExpand,n=t.doCollapse;t.expanded?n():e()},o}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.expanded;t.expanded&&!e&&this.setState({highlighted:-1})}},{key:"render",value:function(){var n=this,t=this.props,e=t.expanded,o=t.children,r=t.className,i=t.optionWrapperClassName,c=t.ariaLabel,a=t.onExpandEvent,l=t.title,s=this.state.highlighted,u=o.slice(1,o.length);return N.a.createElement("div",{className:w()("rdw-dropdown-wrapper",r),"aria-expanded":e,"aria-label":c||"rdw-dropdown"},N.a.createElement("a",{className:"rdw-dropdown-selectedtext",onClick:a,title:l},o[0],N.a.createElement("div",{className:w()({"rdw-dropdown-carettoclose":e,"rdw-dropdown-carettoopen":!e})})),e?N.a.createElement("ul",{className:w()("rdw-dropdown-optionwrapper",i),onClick:j},N.a.Children.map(u,function(t,e){return t&&N.a.cloneElement(t,{onSelect:n.onChange,highlighted:s===e,setHighlighted:n.setHighlighted,index:e})})):void 0)}}])&&B(t.prototype,e),n&&B(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();H.propTypes={children:y.a.any,onChange:y.a.func,className:y.a.string,expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,optionWrapperClassName:y.a.string,ariaLabel:y.a.string,title:y.a.string};n(13);function Z(t){return(Z="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function W(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function G(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function J(t,e){return(J=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function V(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=q(o);if(r){var n=q(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Z(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function q(t){return(q=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var K=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&J(t,e)}(r,f["Component"]);var t,e,n,o=V(r);function r(){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(i=o.call.apply(o,[this].concat(e))).onClick=function(t){var e=i.props,n=e.onSelect,o=e.onClick,r=e.value;e.disabled||(n&&n(r),o&&(t.stopPropagation(),o(r)))},i.setHighlighted=function(){var t=i.props;(0,t.setHighlighted)(t.index)},i.resetHighlighted=function(){(0,i.props.setHighlighted)(-1)},i}return t=r,(e=[{key:"render",value:function(){var t,e=this.props,n=e.children,o=e.active,r=e.disabled,i=e.highlighted,c=e.className,a=e.activeClassName,l=e.disabledClassName,s=e.highlightedClassName,u=e.title;return N.a.createElement("li",{className:w()("rdw-dropdownoption-default",c,(W(t={},"rdw-dropdownoption-active ".concat(a),o),W(t,"rdw-dropdownoption-highlighted ".concat(s),i),W(t,"rdw-dropdownoption-disabled ".concat(l),r),t)),onMouseEnter:this.setHighlighted,onMouseLeave:this.resetHighlighted,onClick:this.onClick,title:u},n)}}])&&G(t.prototype,e),n&&G(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();K.propTypes={children:y.a.any,value:y.a.any,onClick:y.a.func,onSelect:y.a.func,setHighlighted:y.a.func,index:y.a.number,disabled:y.a.bool,active:y.a.bool,highlighted:y.a.bool,className:y.a.string,activeClassName:y.a.string,disabledClassName:y.a.string,highlightedClassName:y.a.string,title:y.a.string},K.defaultProps={activeClassName:"",disabledClassName:"",highlightedClassName:""};n(14);function X(t){return(X="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function $(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function tt(t,e){return(tt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function et(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=nt(o);if(r){var n=nt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===X(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function nt(t){return(nt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var ot=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&tt(t,e)}(r,f["Component"]);var t,e,n,o=et(r);function r(){return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),o.apply(this,arguments)}return t=r,(e=[{key:"renderInFlatList",value:function(){var t=this.props,n=t.config,o=t.currentState,r=t.onChange,i=t.translations;return N.a.createElement("div",{className:w()("rdw-inline-wrapper",n.className),"aria-label":"rdw-inline-control"},n.options.map(function(t,e){return N.a.createElement(R,{key:e,value:t,onClick:r,className:w()(n[t].className),active:!0===o[t]||"MONOSPACE"===t&&o.CODE,title:n[t].title||i["components.controls.inline.".concat(t)]},N.a.createElement("img",{alt:"",src:n[t].icon}))}))}},{key:"renderInDropDown",value:function(){var t=this.props,n=t.config,e=t.expanded,o=t.doExpand,r=t.onExpandEvent,i=t.doCollapse,c=t.currentState,a=t.onChange,l=t.translations,s=n.className,u=n.dropdownClassName,p=n.title;return N.a.createElement(H,{className:w()("rdw-inline-dropdown",s),optionWrapperClassName:w()(u),onChange:a,expanded:e,doExpand:o,doCollapse:i,onExpandEvent:r,"aria-label":"rdw-inline-control",title:p},N.a.createElement("img",{src:v(n),alt:""}),n.options.map(function(t,e){return N.a.createElement(K,{key:e,value:t,className:w()("rdw-inline-dropdownoption",n[t].className),active:!0===c[t]||"MONOSPACE"===t&&c.CODE,title:n[t].title||l["components.controls.inline.".concat(t)]},N.a.createElement("img",{src:n[t].icon,alt:""}))}))}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&$(t.prototype,e),n&&$(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();function rt(t){return(rt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function it(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function ct(t,e){return(ct=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function at(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=lt(o);if(r){var n=lt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===rt(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function lt(t){return(lt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}ot.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object};var st=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&ct(t,e)}(i,f["Component"]);var t,e,n,r=at(i);function i(t){var l;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(l=r.call(this,t)).onExpandEvent=function(){l.signalExpanded=!l.state.expanded},l.expandCollapse=function(){l.setState({expanded:l.signalExpanded}),l.signalExpanded=!1},l.toggleInlineStyle=function(t){var e="monospace"===t?"CODE":t.toUpperCase(),n=l.props,o=n.editorState,r=n.onChange,i=E.RichUtils.toggleInlineStyle(o,e);if("subscript"===t||"superscript"===t){var c="subscript"===t?"SUPERSCRIPT":"SUBSCRIPT",a=E.Modifier.removeInlineStyle(i.getCurrentContent(),i.getSelection(),c);i=E.EditorState.push(i,a,"change-inline-style")}i&&r(i)},l.changeKeys=function(t){if(t){var n={};return h(t,function(t,e){n["CODE"===t?"monospace":t.toLowerCase()]=e}),n}},l.doExpand=function(){l.setState({expanded:!0})},l.doCollapse=function(){l.setState({expanded:!1})};var e=l.props,n=e.editorState,o=e.modalHandler;return l.state={currentStyles:n?l.changeKeys(Object(S.getSelectionInlineStyle)(n)):{}},o.registerCallBack(l.expandCollapse),l}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentStyles:this.changeKeys(Object(S.getSelectionInlineStyle)(e))})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentStyles,c=e.component||ot;return N.a.createElement(c,{config:e,translations:n,currentState:i,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onChange:this.toggleInlineStyle})}}])&&it(t.prototype,e),n&&it(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();st.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(15);function ut(t){return(ut="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function pt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function dt(t,e){return(dt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function ft(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=yt(o);if(r){var n=yt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ut(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function yt(t){return(yt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var mt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&dt(t,e)}(r,f["Component"]);var t,e,n,o=ft(r);function r(t){var e;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(e=o.call(this,t)).getBlockTypes=function(t){return[{label:"Normal",displayName:t["components.controls.blocktype.normal"]},{label:"H1",displayName:t["components.controls.blocktype.h1"]},{label:"H2",displayName:t["components.controls.blocktype.h2"]},{label:"H3",displayName:t["components.controls.blocktype.h3"]},{label:"H4",displayName:t["components.controls.blocktype.h4"]},{label:"H5",displayName:t["components.controls.blocktype.h5"]},{label:"H6",displayName:t["components.controls.blocktype.h6"]},{label:"Blockquote",displayName:t["components.controls.blocktype.blockquote"]},{label:"Code",displayName:t["components.controls.blocktype.code"]}]},e.state={blockTypes:e.getBlockTypes(t.translations)},e}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.translations;e!==t.translations&&this.setState({blockTypes:this.getBlockTypes(e)})}},{key:"renderFlat",value:function(t){var e=this.props,n=e.config.className,o=e.onChange,r=e.currentState.blockType;return N.a.createElement("div",{className:w()("rdw-inline-wrapper",n)},t.map(function(t,e){return N.a.createElement(R,{key:e,value:t.label,active:r===t.label,onClick:o},t.displayName)}))}},{key:"renderInDropdown",value:function(t){var e=this.props,n=e.config,o=n.className,r=n.dropdownClassName,i=n.title,c=e.currentState.blockType,a=e.expanded,l=e.doExpand,s=e.onExpandEvent,u=e.doCollapse,p=e.onChange,d=e.translations,f=this.state.blockTypes.filter(function(t){return t.label===c}),y=f&&f[0]&&f[0].displayName;return N.a.createElement("div",{className:"rdw-block-wrapper","aria-label":"rdw-block-control"},N.a.createElement(H,{className:w()("rdw-block-dropdown",o),optionWrapperClassName:w()(r),onChange:p,expanded:a,doExpand:l,doCollapse:u,onExpandEvent:s,title:i||d["components.controls.blocktype.blocktype"]},N.a.createElement("span",null,y||d["components.controls.blocktype.blocktype"]),t.map(function(t,e){return N.a.createElement(K,{active:c===t.label,value:t.label,key:e},t.displayName)})))}},{key:"render",value:function(){var n=this.props.config,t=n.inDropdown,e=this.state.blockTypes.filter(function(t){var e=t.label;return-1<n.options.indexOf(e)});return t?this.renderInDropdown(e):this.renderFlat(e)}}])&&pt(t.prototype,e),n&&pt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();mt.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,doExpand:y.a.func,doCollapse:y.a.func,onChange:y.a.func,config:y.a.object,currentState:y.a.object,translations:y.a.object};var gt=mt;function bt(t){return(bt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ht(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Mt(t,e){return(Mt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function jt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=vt(o);if(r){var n=vt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===bt(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function vt(t){return(vt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Nt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Mt(t,e)}(r,f["Component"]);var t,e,n,o=jt(r);function r(t){var c;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(c=o.call(this,t)).onExpandEvent=function(){c.signalExpanded=!c.state.expanded},c.expandCollapse=function(){c.setState({expanded:c.signalExpanded}),c.signalExpanded=!1},c.blocksTypes=[{label:"Normal",style:"unstyled"},{label:"H1",style:"header-one"},{label:"H2",style:"header-two"},{label:"H3",style:"header-three"},{label:"H4",style:"header-four"},{label:"H5",style:"header-five"},{label:"H6",style:"header-six"},{label:"Blockquote",style:"blockquote"},{label:"Code",style:"code"}],c.doExpand=function(){c.setState({expanded:!0})},c.doCollapse=function(){c.setState({expanded:!1})},c.toggleBlockType=function(e){var t=c.blocksTypes.find(function(t){return t.label===e}).style,n=c.props,o=n.editorState,r=n.onChange,i=E.RichUtils.toggleBlockType(o,t);i&&r(i)};var e=t.editorState,n=t.modalHandler;return c.state={expanded:!1,currentBlockType:e?Object(S.getSelectedBlocksType)(e):"unstyled"},n.registerCallBack(c.expandCollapse),c}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentBlockType:Object(S.getSelectedBlocksType)(e)})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentBlockType,c=e.component||gt,a=this.blocksTypes.find(function(t){return t.style===i});return N.a.createElement(c,{config:e,translations:n,currentState:{blockType:a&&a.label},onChange:this.toggleBlockType,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&ht(t.prototype,e),n&&ht(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Nt.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var Et=Nt;n(16);function St(t){return(St="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function wt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Ct(t,e){return(Ct=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Lt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Dt(o);if(r){var n=Dt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===St(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Dt(t){return(Dt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var kt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Ct(t,e)}(i,f["Component"]);var t,e,n,r=Lt(i);function i(){var t;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))).state={defaultFontSize:void 0},t}return t=i,(e=[{key:"componentDidMount",value:function(){var t=document.getElementsByClassName("DraftEditor-root");if(t&&0<t.length){var e=window.getComputedStyle(t[0]).getPropertyValue("font-size");e=e.substring(0,e.length-2),this.setState({defaultFontSize:e})}}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.dropdownClassName,i=e.options,c=e.title,a=t.onChange,l=t.expanded,s=t.doCollapse,u=t.onExpandEvent,p=t.doExpand,d=t.translations,f=this.props.currentState.fontSize,y=this.state.defaultFontSize;return y=Number(y),f=f||i&&0<=i.indexOf(y)&&y,N.a.createElement("div",{className:"rdw-fontsize-wrapper","aria-label":"rdw-font-size-control"},N.a.createElement(H,{className:w()("rdw-fontsize-dropdown",o),optionWrapperClassName:w()(r),onChange:a,expanded:l,doExpand:p,doCollapse:s,onExpandEvent:u,title:c||d["components.controls.fontsize.fontsize"]},f?N.a.createElement("span",null,f):N.a.createElement("img",{src:n,alt:""}),i.map(function(t,e){return N.a.createElement(K,{className:"rdw-fontsize-option",active:f===t,value:t,key:e},t)})))}}])&&wt(t.prototype,e),n&&wt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();function Ot(t){return(Ot="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function xt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function It(t,e){return(It=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Tt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=At(o);if(r){var n=At(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Ot(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function At(t){return(At=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}kt.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,doExpand:y.a.func,doCollapse:y.a.func,onChange:y.a.func,config:y.a.object,currentState:y.a.object,translations:y.a.object};var zt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&It(t,e)}(r,f["Component"]);var t,e,n,o=Tt(r);function r(t){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(i=o.call(this,t)).onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})},i.toggleFontSize=function(t){var e=i.props,n=e.editorState,o=e.onChange,r=Object(S.toggleCustomInlineStyle)(n,"fontSize",t);r&&o(r)};var e=t.editorState,n=t.modalHandler;return i.state={expanded:void 0,currentFontSize:e?Object(S.getSelectionCustomInlineStyle)(e,["FONTSIZE"]).FONTSIZE:void 0},n.registerCallBack(i.expandCollapse),i}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentFontSize:Object(S.getSelectionCustomInlineStyle)(e,["FONTSIZE"]).FONTSIZE})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentFontSize,c=e.component||kt,a=i&&Number(i.substring(9));return N.a.createElement(c,{config:e,translations:n,currentState:{fontSize:a},onChange:this.toggleFontSize,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&xt(t.prototype,e),n&&xt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();zt.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(17);function _t(t){return(_t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Pt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Rt(t,e){return(Rt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Ut(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Bt(o);if(r){var n=Bt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===_t(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Bt(t){return(Bt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Ft=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Rt(t,e)}(i,f["Component"]);var t,e,n,r=Ut(i);function i(){var t;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))).state={defaultFontFamily:void 0},t}return t=i,(e=[{key:"componentDidMount",value:function(){var t=document.getElementsByClassName("DraftEditor-root");if(t&&0<t.length){var e=window.getComputedStyle(t[0]).getPropertyValue("font-family");this.setState({defaultFontFamily:e})}}},{key:"render",value:function(){var e=this.state.defaultFontFamily,t=this.props,n=t.config,o=n.className,r=n.dropdownClassName,i=n.options,c=n.title,a=t.translations,l=t.onChange,s=t.expanded,u=t.doCollapse,p=t.onExpandEvent,d=t.doExpand,f=this.props.currentState.fontFamily;return f=f||i&&e&&i.some(function(t){return t.toLowerCase()===e.toLowerCase()})&&e,N.a.createElement("div",{className:"rdw-fontfamily-wrapper","aria-label":"rdw-font-family-control"},N.a.createElement(H,{className:w()("rdw-fontfamily-dropdown",o),optionWrapperClassName:w()("rdw-fontfamily-optionwrapper",r),onChange:l,expanded:s,doExpand:d,doCollapse:u,onExpandEvent:p,title:c||a["components.controls.fontfamily.fontfamily"]},N.a.createElement("span",{className:"rdw-fontfamily-placeholder"},f||a["components.controls.fontfamily.fontfamily"]),i.map(function(t,e){return N.a.createElement(K,{active:f===t,value:t,key:e},t)})))}}])&&Pt(t.prototype,e),n&&Pt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();Ft.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,doExpand:y.a.func,doCollapse:y.a.func,onChange:y.a.func,config:y.a.object,currentState:y.a.object,translations:y.a.object};var Yt=Ft;function Qt(t){return(Qt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Ht(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Zt(t,e){return(Zt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Wt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Gt(o);if(r){var n=Gt(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Qt(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Gt(t){return(Gt=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Jt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Zt(t,e)}(r,f["Component"]);var t,e,n,o=Wt(r);function r(t){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(i=o.call(this,t)).onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})},i.toggleFontFamily=function(t){var e=i.props,n=e.editorState,o=e.onChange,r=Object(S.toggleCustomInlineStyle)(n,"fontFamily",t);r&&o(r)};var e=t.editorState,n=t.modalHandler;return i.state={expanded:void 0,currentFontFamily:e?Object(S.getSelectionCustomInlineStyle)(e,["FONTFAMILY"]).FONTFAMILY:void 0},n.registerCallBack(i.expandCollapse),i}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentFontFamily:Object(S.getSelectionCustomInlineStyle)(e,["FONTFAMILY"]).FONTFAMILY})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentFontFamily,c=e.component||Yt,a=i&&i.substring(11);return N.a.createElement(c,{translations:n,config:e,currentState:{fontFamily:a},onChange:this.toggleFontFamily,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&Ht(t.prototype,e),n&&Ht(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Jt.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(18);function Vt(t){return(Vt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function qt(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Kt(t,e){return(Kt=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Xt(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=$t(o);if(r){var n=$t(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Vt(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function $t(t){return($t=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var te=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Kt(t,e)}(i,f["Component"]);var t,e,n,r=Xt(i);function i(){var e;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))).options=["unordered","ordered","indent","outdent"],e.toggleBlockType=function(t){(0,e.props.onChange)(t)},e.indent=function(){(0,e.props.onChange)("indent")},e.outdent=function(){(0,e.props.onChange)("outdent")},e}return t=i,(e=[{key:"renderInFlatList",value:function(){var t=this.props,e=t.config,n=t.currentState.listType,o=t.translations,r=t.indentDisabled,i=t.outdentDisabled,c=e.options,a=e.unordered,l=e.ordered,s=e.indent,u=e.outdent,p=e.className;return N.a.createElement("div",{className:w()("rdw-list-wrapper",p),"aria-label":"rdw-list-control"},0<=c.indexOf("unordered")&&N.a.createElement(R,{value:"unordered",onClick:this.toggleBlockType,className:w()(a.className),active:"unordered"===n,title:a.title||o["components.controls.list.unordered"]},N.a.createElement("img",{src:a.icon,alt:""})),0<=c.indexOf("ordered")&&N.a.createElement(R,{value:"ordered",onClick:this.toggleBlockType,className:w()(l.className),active:"ordered"===n,title:l.title||o["components.controls.list.ordered"]},N.a.createElement("img",{src:l.icon,alt:""})),0<=c.indexOf("indent")&&N.a.createElement(R,{onClick:this.indent,disabled:r,className:w()(s.className),title:s.title||o["components.controls.list.indent"]},N.a.createElement("img",{src:s.icon,alt:""})),0<=c.indexOf("outdent")&&N.a.createElement(R,{onClick:this.outdent,disabled:i,className:w()(u.className),title:u.title||o["components.controls.list.outdent"]},N.a.createElement("img",{src:u.icon,alt:""})))}},{key:"renderInDropDown",value:function(){var n=this,t=this.props,o=t.config,e=t.expanded,r=t.doCollapse,i=t.doExpand,c=t.onExpandEvent,a=t.onChange,l=t.currentState.listType,s=t.translations,u=o.options,p=o.className,d=o.dropdownClassName,f=o.title;return N.a.createElement(H,{className:w()("rdw-list-dropdown",p),optionWrapperClassName:w()(d),onChange:a,expanded:e,doExpand:i,doCollapse:r,onExpandEvent:c,"aria-label":"rdw-list-control",title:f||s["components.controls.list.list"]},N.a.createElement("img",{src:v(o),alt:""}),this.options.filter(function(t){return 0<=u.indexOf(t)}).map(function(t,e){return N.a.createElement(K,{key:e,value:t,disabled:n.props["".concat(t,"Disabled")],className:w()("rdw-list-dropdownOption",o[t].className),active:l===t,title:o[t].title||s["components.controls.list.".concat(t)]},N.a.createElement("img",{src:o[t].icon,alt:""}))}))}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&qt(t.prototype,e),n&&qt(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();function ee(t){return(ee="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ne(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function oe(t,e){return(oe=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function re(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=ie(o);if(r){var n=ie(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ee(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function ie(t){return(ie=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}te.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object,indentDisabled:y.a.bool,outdentDisabled:y.a.bool};var ce=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&oe(t,e)}(c,f["Component"]);var t,e,n,r=re(c);function c(t){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,c),(i=r.call(this,t)).onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.onChange=function(t){"unordered"===t?i.toggleBlockType("unordered-list-item"):"ordered"===t?i.toggleBlockType("ordered-list-item"):"indent"===t?i.adjustDepth(1):i.adjustDepth(-1)},i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})},i.toggleBlockType=function(t){var e=i.props,n=e.onChange,o=e.editorState,r=E.RichUtils.toggleBlockType(o,t);r&&n(r)},i.adjustDepth=function(t){var e=i.props,n=e.onChange,o=e.editorState,r=Object(S.changeDepth)(o,t,4);r&&n(r)},i.isIndentDisabled=function(){var t=i.props.editorState,e=i.state.currentBlock,n=Object(S.getBlockBeforeSelectedBlock)(t);return!n||!Object(S.isListBlock)(e)||n.get("type")!==e.get("type")||n.get("depth")<e.get("depth")},i.isOutdentDisabled=function(){var t=i.state.currentBlock;return!t||!Object(S.isListBlock)(t)||t.get("depth")<=0};var e=i.props,n=e.editorState,o=e.modalHandler;return i.state={expanded:!1,currentBlock:n?Object(S.getSelectedBlock)(n):void 0},o.registerCallBack(i.expandCollapse),i}return t=c,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentBlock:Object(S.getSelectedBlock)(e)})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t,e=this.props,n=e.config,o=e.translations,r=this.state,i=r.expanded,c=r.currentBlock,a=n.component||te;"unordered-list-item"===c.get("type")?t="unordered":"ordered-list-item"===c.get("type")&&(t="ordered");var l=this.isIndentDisabled(),s=this.isOutdentDisabled();return N.a.createElement(a,{config:n,translations:o,currentState:{listType:t},expanded:i,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onChange:this.onChange,indentDisabled:l,outdentDisabled:s})}}])&&ne(t.prototype,e),n&&ne(t,n),Object.defineProperty(t,"prototype",{writable:!1}),c}();ce.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(19);function ae(t){return(ae="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function le(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function se(t,e){return(se=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function ue(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=pe(o);if(r){var n=pe(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ae(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function pe(t){return(pe=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var de=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&se(t,e)}(r,f["Component"]);var t,e,n,o=ue(r);function r(){return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),o.apply(this,arguments)}return t=r,(e=[{key:"renderInFlatList",value:function(){var t=this.props,e=t.config,n=e.options,o=e.left,r=e.center,i=e.right,c=e.justify,a=e.className,l=t.onChange,s=t.currentState.textAlignment,u=t.translations;return N.a.createElement("div",{className:w()("rdw-text-align-wrapper",a),"aria-label":"rdw-textalign-control"},0<=n.indexOf("left")&&N.a.createElement(R,{value:"left",className:w()(o.className),active:"left"===s,onClick:l,title:o.title||u["components.controls.textalign.left"]},N.a.createElement("img",{src:o.icon,alt:""})),0<=n.indexOf("center")&&N.a.createElement(R,{value:"center",className:w()(r.className),active:"center"===s,onClick:l,title:r.title||u["components.controls.textalign.center"]},N.a.createElement("img",{src:r.icon,alt:""})),0<=n.indexOf("right")&&N.a.createElement(R,{value:"right",className:w()(i.className),active:"right"===s,onClick:l,title:i.title||u["components.controls.textalign.right"]},N.a.createElement("img",{src:i.icon,alt:""})),0<=n.indexOf("justify")&&N.a.createElement(R,{value:"justify",className:w()(c.className),active:"justify"===s,onClick:l,title:c.title||u["components.controls.textalign.justify"]},N.a.createElement("img",{src:c.icon,alt:""})))}},{key:"renderInDropDown",value:function(){var t=this.props,e=t.config,n=t.expanded,o=t.doExpand,r=t.onExpandEvent,i=t.doCollapse,c=t.currentState.textAlignment,a=t.onChange,l=t.translations,s=e.options,u=e.left,p=e.center,d=e.right,f=e.justify,y=e.className,m=e.dropdownClassName,g=e.title;return N.a.createElement(H,{className:w()("rdw-text-align-dropdown",y),optionWrapperClassName:w()(m),onChange:a,expanded:n,doExpand:o,doCollapse:i,onExpandEvent:r,"aria-label":"rdw-textalign-control",title:g||l["components.controls.textalign.textalign"]},N.a.createElement("img",{src:c&&e[c]&&e[c].icon||v(e),alt:""}),0<=s.indexOf("left")&&N.a.createElement(K,{value:"left",active:"left"===c,className:w()("rdw-text-align-dropdownOption",u.className),title:u.title||l["components.controls.textalign.left"]},N.a.createElement("img",{src:u.icon,alt:""})),0<=s.indexOf("center")&&N.a.createElement(K,{value:"center",active:"center"===c,className:w()("rdw-text-align-dropdownOption",p.className),title:p.title||l["components.controls.textalign.center"]},N.a.createElement("img",{src:p.icon,alt:""})),0<=s.indexOf("right")&&N.a.createElement(K,{value:"right",active:"right"===c,className:w()("rdw-text-align-dropdownOption",d.className),title:d.title||l["components.controls.textalign.right"]},N.a.createElement("img",{src:d.icon,alt:""})),0<=s.indexOf("justify")&&N.a.createElement(K,{value:"justify",active:"justify"===c,className:w()("rdw-text-align-dropdownOption",f.className),title:f.title||l["components.controls.textalign.justify"]},N.a.createElement("img",{src:f.icon,alt:""})))}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&le(t.prototype,e),n&&le(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();function fe(t){return(fe="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ye(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function me(t,e){return(me=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function ge(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=be(o);if(r){var n=be(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===fe(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function be(t){return(be=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}de.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object};var he=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&me(t,e)}(i,f["Component"]);var t,e,n,o=ge(i);function i(t){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(r=o.call(this,t)).onExpandEvent=function(){r.signalExpanded=!r.state.expanded},r.expandCollapse=function(){r.setState({expanded:r.signalExpanded}),r.signalExpanded=!1},r.doExpand=function(){r.setState({expanded:!0})},r.doCollapse=function(){r.setState({expanded:!1})},r.addBlockAlignmentData=function(t){var e=r.props,n=e.editorState,o=e.onChange;o(r.state.currentTextAlignment!==t?Object(S.setBlockData)(n,{"text-align":t}):Object(S.setBlockData)(n,{"text-align":void 0}))};var e=r.props.modalHandler;return r.state={currentTextAlignment:void 0},e.registerCallBack(r.expandCollapse),r}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e!==t.editorState&&this.setState({currentTextAlignment:Object(S.getSelectedBlocksMetadata)(e).get("text-align")})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.expanded,i=o.currentTextAlignment,c=e.component||de;return N.a.createElement(c,{config:e,translations:n,expanded:r,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,currentState:{textAlignment:i},onChange:this.addBlockAlignmentData})}}])&&ye(t.prototype,e),n&&ye(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();he.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};n(20);function Me(t){return(Me="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function je(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function ve(t,e){return(ve=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Ne(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Ee(o);if(r){var n=Ee(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Me(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Ee(t){return(Ee=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Se=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&ve(t,e)}(r,f["Component"]);var t,e,n,o=Ne(r);function r(){var u;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(u=o.call.apply(o,[this].concat(e))).state={currentStyle:"color"},u.onChange=function(t){(0,u.props.onChange)(u.state.currentStyle,t)},u.setCurrentStyleColor=function(){u.setState({currentStyle:"color"})},u.setCurrentStyleBgcolor=function(){u.setState({currentStyle:"bgcolor"})},u.renderModal=function(){var t=u.props,e=t.config,n=e.popupClassName,o=e.colors,r=t.currentState,i=r.color,c=r.bgColor,a=t.translations,l=u.state.currentStyle,s="color"===l?i:c;return N.a.createElement("div",{className:w()("rdw-colorpicker-modal",n),onClick:j},N.a.createElement("span",{className:"rdw-colorpicker-modal-header"},N.a.createElement("span",{className:w()("rdw-colorpicker-modal-style-label",{"rdw-colorpicker-modal-style-label-active":"color"===l}),onClick:u.setCurrentStyleColor},a["components.controls.colorpicker.text"]),N.a.createElement("span",{className:w()("rdw-colorpicker-modal-style-label",{"rdw-colorpicker-modal-style-label-active":"bgcolor"===l}),onClick:u.setCurrentStyleBgcolor},a["components.controls.colorpicker.background"])),N.a.createElement("span",{className:"rdw-colorpicker-modal-options"},o.map(function(t,e){return N.a.createElement(R,{value:t,key:e,className:"rdw-colorpicker-option",activeClassName:"rdw-colorpicker-option-active",active:s===t,onClick:u.onChange},N.a.createElement("span",{style:{backgroundColor:t},className:"rdw-colorpicker-cube"}))})))},u}return t=r,(e=[{key:"componentDidUpdate",value:function(t){this.props.expanded&&!t.expanded&&this.setState({currentStyle:"color"})}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.title,i=t.expanded,c=t.onExpandEvent,a=t.translations;return N.a.createElement("div",{className:"rdw-colorpicker-wrapper","aria-haspopup":"true","aria-expanded":i,"aria-label":"rdw-color-picker",title:r||a["components.controls.colorpicker.colorpicker"]},N.a.createElement(R,{onClick:c,className:w()(o)},N.a.createElement("img",{src:n,alt:""})),i?this.renderModal():void 0)}}])&&je(t.prototype,e),n&&je(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Se.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,onChange:y.a.func,config:y.a.object,currentState:y.a.object,translations:y.a.object};var we=Se;function Ce(t){return(Ce="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Le(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function De(t,e){return(De=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function ke(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Oe(o);if(r){var n=Oe(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Ce(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Oe(t){return(Oe=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var xe=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&De(t,e)}(i,f["Component"]);var t,e,n,r=ke(i);function i(t){var c;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(c=r.call(this,t)).state={expanded:!1,currentColor:void 0,currentBgColor:void 0},c.onExpandEvent=function(){c.signalExpanded=!c.state.expanded},c.expandCollapse=function(){c.setState({expanded:c.signalExpanded}),c.signalExpanded=!1},c.doExpand=function(){c.setState({expanded:!0})},c.doCollapse=function(){c.setState({expanded:!1})},c.toggleColor=function(t,e){var n=c.props,o=n.editorState,r=n.onChange,i=Object(S.toggleCustomInlineStyle)(o,t,e);i&&r(i),c.doCollapse()};var e=t.editorState,n=t.modalHandler,o={expanded:!1,currentColor:void 0,currentBgColor:void 0};return e&&(o.currentColor=Object(S.getSelectionCustomInlineStyle)(e,["COLOR"]).COLOR,o.currentBgColor=Object(S.getSelectionCustomInlineStyle)(e,["BGCOLOR"]).BGCOLOR),c.state=o,n.registerCallBack(c.expandCollapse),c}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentColor:Object(S.getSelectionCustomInlineStyle)(e,["COLOR"]).COLOR,currentBgColor:Object(S.getSelectionCustomInlineStyle)(e,["BGCOLOR"]).BGCOLOR})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.currentColor,i=o.currentBgColor,c=o.expanded,a=e.component||we,l=r&&r.substring(6),s=i&&i.substring(8);return N.a.createElement(a,{config:e,translations:n,onChange:this.toggleColor,expanded:c,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,currentState:{color:l,bgColor:s}})}}])&&Le(t.prototype,e),n&&Le(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();xe.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var Ie=xe,Te=n(7),Ae=n.n(Te);n(26);function ze(t){return(ze="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function _e(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Pe(t,e){return(Pe=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Re(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Ue(o);if(r){var n=Ue(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ze(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Ue(t){return(Ue=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Be=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Pe(t,e)}(r,f["Component"]);var t,e,n,o=Re(r);function r(){var c;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(c=o.call.apply(o,[this].concat(e))).state={showModal:!1,linkTarget:"",linkTitle:"",linkTargetOption:c.props.config.defaultTargetOption},c.removeLink=function(){(0,c.props.onChange)("unlink")},c.addLink=function(){var t=c.props.onChange,e=c.state;t("link",e.linkTitle,e.linkTarget,e.linkTargetOption)},c.updateValue=function(t){var e,n,o;c.setState((e={},n="".concat(t.target.name),o=t.target.value,n in e?Object.defineProperty(e,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[n]=o,e))},c.updateTargetOption=function(t){c.setState({linkTargetOption:t.target.checked?"_blank":"_self"})},c.hideModal=function(){c.setState({showModal:!1})},c.signalExpandShowModal=function(){var t=c.props,e=t.onExpandEvent,n=t.currentState,o=n.link,r=n.selectionText,i=c.state.linkTargetOption;e(),c.setState({showModal:!0,linkTarget:o&&o.target||"",linkTargetOption:o&&o.targetOption||i,linkTitle:o&&o.title||r})},c.forceExpandAndShowModal=function(){var t=c.props,e=t.doExpand,n=t.currentState,o=n.link,r=n.selectionText,i=c.state.linkTargetOption;e(),c.setState({showModal:!0,linkTarget:o&&o.target,linkTargetOption:o&&o.targetOption||i,linkTitle:o&&o.title||r})},c}return t=r,(e=[{key:"componentDidUpdate",value:function(t){t.expanded&&!this.props.expanded&&this.setState({showModal:!1,linkTarget:"",linkTitle:"",linkTargetOption:this.props.config.defaultTargetOption})}},{key:"renderAddLinkModal",value:function(){var t=this.props,e=t.config.popupClassName,n=t.doCollapse,o=t.translations,r=this.state,i=r.linkTitle,c=r.linkTarget,a=r.linkTargetOption;return N.a.createElement("div",{className:w()("rdw-link-modal",e),onClick:j},N.a.createElement("label",{className:"rdw-link-modal-label",htmlFor:"linkTitle"},o["components.controls.link.linkTitle"]),N.a.createElement("input",{id:"linkTitle",className:"rdw-link-modal-input",onChange:this.updateValue,onBlur:this.updateValue,name:"linkTitle",value:i}),N.a.createElement("label",{className:"rdw-link-modal-label",htmlFor:"linkTarget"},o["components.controls.link.linkTarget"]),N.a.createElement("input",{id:"linkTarget",className:"rdw-link-modal-input",onChange:this.updateValue,onBlur:this.updateValue,name:"linkTarget",value:c}),N.a.createElement("label",{className:"rdw-link-modal-target-option",htmlFor:"openLinkInNewWindow"},N.a.createElement("input",{id:"openLinkInNewWindow",type:"checkbox",defaultChecked:"_blank"===a,value:"_blank",onChange:this.updateTargetOption}),N.a.createElement("span",null,o["components.controls.link.linkTargetOption"])),N.a.createElement("span",{className:"rdw-link-modal-buttonsection"},N.a.createElement("button",{className:"rdw-link-modal-btn",onClick:this.addLink,disabled:!c||!i},o["generic.add"]),N.a.createElement("button",{className:"rdw-link-modal-btn",onClick:n},o["generic.cancel"])))}},{key:"renderInFlatList",value:function(){var t=this.props,e=t.config,n=e.options,o=e.link,r=e.unlink,i=e.className,c=t.currentState,a=t.expanded,l=t.translations,s=this.state.showModal;return N.a.createElement("div",{className:w()("rdw-link-wrapper",i),"aria-label":"rdw-link-control"},0<=n.indexOf("link")&&N.a.createElement(R,{value:"unordered-list-item",className:w()(o.className),onClick:this.signalExpandShowModal,"aria-haspopup":"true","aria-expanded":s,title:o.title||l["components.controls.link.link"]},N.a.createElement("img",{src:o.icon,alt:""})),0<=n.indexOf("unlink")&&N.a.createElement(R,{disabled:!c.link,value:"ordered-list-item",className:w()(r.className),onClick:this.removeLink,title:r.title||l["components.controls.link.unlink"]},N.a.createElement("img",{src:r.icon,alt:""})),a&&s?this.renderAddLinkModal():void 0)}},{key:"renderInDropDown",value:function(){var t=this.props,e=t.expanded,n=t.onExpandEvent,o=t.doCollapse,r=t.doExpand,i=t.onChange,c=t.config,a=t.currentState,l=t.translations,s=c.options,u=c.link,p=c.unlink,d=c.className,f=c.dropdownClassName,y=c.title,m=this.state.showModal;return N.a.createElement("div",{className:"rdw-link-wrapper","aria-haspopup":"true","aria-label":"rdw-link-control","aria-expanded":e,title:y},N.a.createElement(H,{className:w()("rdw-link-dropdown",d),optionWrapperClassName:w()(f),onChange:i,expanded:e&&!m,doExpand:r,doCollapse:o,onExpandEvent:n},N.a.createElement("img",{src:v(c),alt:""}),0<=s.indexOf("link")&&N.a.createElement(K,{onClick:this.forceExpandAndShowModal,className:w()("rdw-link-dropdownoption",u.className),title:u.title||l["components.controls.link.link"]},N.a.createElement("img",{src:u.icon,alt:""})),0<=s.indexOf("unlink")&&N.a.createElement(K,{onClick:this.removeLink,disabled:!a.link,className:w()("rdw-link-dropdownoption",p.className),title:p.title||l["components.controls.link.unlink"]},N.a.createElement("img",{src:p.icon,alt:""}))),e&&m?this.renderAddLinkModal():void 0)}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&_e(t.prototype,e),n&&_e(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Be.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object};var Fe=Be;function Ye(t){return(Ye="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Qe(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function He(t,e){return(He=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Ze(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=We(o);if(r){var n=We(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Ye(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function We(t){return(We=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Ge(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,o)}return n}function Je(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Ge(Object(n),!0).forEach(function(t){Ve(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Ge(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function Ve(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function qe(t){var e=Ke.match(t.target);return Je(Je({},t),{},{target:e&&e[0]&&e[0].url||t.target})}var Ke=Ae()(),Xe=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&He(t,e)}(i,f["Component"]);var t,e,n,r=Ze(i);function i(t){var d;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(d=r.call(this,t)).onExpandEvent=function(){d.signalExpanded=!d.state.expanded},d.onChange=function(t,e,n,o){var r=d.props.config.linkCallback;if("link"===t){var i=(r||qe)({title:e,target:n,targetOption:o});d.addLink(i.title,i.target,i.targetOption)}else d.removeLink()},d.getCurrentValues=function(){var t=d.props.editorState,e=d.state.currentEntity,n=t.getCurrentContent(),o={};if(e&&"LINK"===n.getEntity(e).get("type")){o.link={};var r=e&&Object(S.getEntityRange)(t,e);o.link.target=e&&n.getEntity(e).get("data").url,o.link.targetOption=e&&n.getEntity(e).get("data").targetOption,o.link.title=r&&r.text}return o.selectionText=Object(S.getSelectionText)(t),o},d.doExpand=function(){d.setState({expanded:!0})},d.expandCollapse=function(){d.setState({expanded:d.signalExpanded}),d.signalExpanded=!1},d.doCollapse=function(){d.setState({expanded:!1})},d.removeLink=function(){var t=d.props,e=t.editorState,n=t.onChange,o=d.state.currentEntity,r=e.getSelection();if(o){var i=Object(S.getEntityRange)(e,o);r=r.getIsBackward()?r.merge({anchorOffset:i.end,focusOffset:i.start}):r.merge({anchorOffset:i.start,focusOffset:i.end}),n(E.RichUtils.toggleLink(e,r,null))}},d.addLink=function(t,e,n){var o=d.props,r=o.editorState,i=o.onChange,c=d.state.currentEntity,a=r.getSelection();if(c){var l=Object(S.getEntityRange)(r,c);a=a.getIsBackward()?a.merge({anchorOffset:l.end,focusOffset:l.start}):a.merge({anchorOffset:l.start,focusOffset:l.end})}var s=r.getCurrentContent().createEntity("LINK","MUTABLE",{url:e,targetOption:n}).getLastCreatedEntityKey(),u=E.Modifier.replaceText(r.getCurrentContent(),a,"".concat(t),r.getCurrentInlineStyle(),s),p=E.EditorState.push(r,u,"insert-characters");a=p.getSelection().merge({anchorOffset:a.get("anchorOffset")+t.length,focusOffset:a.get("anchorOffset")+t.length}),p=E.EditorState.acceptSelection(p,a),u=E.Modifier.insertText(p.getCurrentContent(),a," ",p.getCurrentInlineStyle(),void 0),i(E.EditorState.push(p,u,"insert-characters")),d.doCollapse()};var e=d.props,n=e.editorState,o=e.modalHandler;return d.state={expanded:!1,link:void 0,selectionText:void 0,currentEntity:n?Object(S.getSelectionEntity)(n):void 0},o.registerCallBack(d.expandCollapse),d}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&e!==t.editorState&&this.setState({currentEntity:Object(S.getSelectionEntity)(e)})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=this.getCurrentValues(),i=r.link,c=r.selectionText,a=e.component||Fe;return N.a.createElement(a,{config:e,translations:n,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,currentState:{link:i,selectionText:c},onChange:this.onChange})}}])&&Qe(t.prototype,e),n&&Qe(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();Xe.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var $e=Xe;n(27);function tn(t){return(tn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function en(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function nn(t,e){return(nn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function on(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=rn(o);if(r){var n=rn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===tn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function rn(t){return(rn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var cn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&nn(t,e)}(i,f["Component"]);var t,e,n,o=on(i);function i(){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(r=o.call.apply(o,[this].concat(e))).state={embeddedLink:"",height:r.props.config.defaultSize.height,width:r.props.config.defaultSize.width},r.onChange=function(){var t=r.props.onChange,e=r.state;t(e.embeddedLink,e.height,e.width)},r.updateValue=function(t){var e,n,o;r.setState((e={},n="".concat(t.target.name),o=t.target.value,n in e?Object.defineProperty(e,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[n]=o,e))},r}return t=i,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props,n=e.expanded,o=e.config;if(!n&&t.expanded){var r=o.defaultSize,i=r.height,c=r.width;this.setState({embeddedLink:"",height:i,width:c})}}},{key:"rendeEmbeddedLinkModal",value:function(){var t=this.state,e=t.embeddedLink,n=t.height,o=t.width,r=this.props,i=r.config.popupClassName,c=r.doCollapse,a=r.translations;return N.a.createElement("div",{className:w()("rdw-embedded-modal",i),onClick:j},N.a.createElement("div",{className:"rdw-embedded-modal-header"},N.a.createElement("span",{className:"rdw-embedded-modal-header-option"},a["components.controls.embedded.embeddedlink"],N.a.createElement("span",{className:"rdw-embedded-modal-header-label"}))),N.a.createElement("div",{className:"rdw-embedded-modal-link-section"},N.a.createElement("span",{className:"rdw-embedded-modal-link-input-wrapper"},N.a.createElement("input",{className:"rdw-embedded-modal-link-input",placeholder:a["components.controls.embedded.enterlink"],onChange:this.updateValue,onBlur:this.updateValue,value:e,name:"embeddedLink"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")),N.a.createElement("div",{className:"rdw-embedded-modal-size"},N.a.createElement("span",null,N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:n,name:"height",className:"rdw-embedded-modal-size-input",placeholder:"Height"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")),N.a.createElement("span",null,N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:o,name:"width",className:"rdw-embedded-modal-size-input",placeholder:"Width"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")))),N.a.createElement("span",{className:"rdw-embedded-modal-btn-section"},N.a.createElement("button",{type:"button",className:"rdw-embedded-modal-btn",onClick:this.onChange,disabled:!e||!n||!o},a["generic.add"]),N.a.createElement("button",{type:"button",className:"rdw-embedded-modal-btn",onClick:c},a["generic.cancel"])))}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.title,i=t.expanded,c=t.onExpandEvent,a=t.translations;return N.a.createElement("div",{className:"rdw-embedded-wrapper","aria-haspopup":"true","aria-expanded":i,"aria-label":"rdw-embedded-control"},N.a.createElement(R,{className:w()(o),value:"unordered-list-item",onClick:c,title:r||a["components.controls.embedded.embedded"]},N.a.createElement("img",{src:n,alt:""})),i?this.rendeEmbeddedLinkModal():void 0)}}])&&en(t.prototype,e),n&&en(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();cn.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,onChange:y.a.func,config:y.a.object,translations:y.a.object,doCollapse:y.a.func};var an=cn;function ln(t){return(ln="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function sn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function un(t,e){return(un=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function pn(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=dn(o);if(r){var n=dn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===ln(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function dn(t){return(dn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var fn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&un(t,e)}(r,f["Component"]);var t,e,n,o=pn(r);function r(){var s;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(s=o.call.apply(o,[this].concat(e))).state={expanded:!1},s.onExpandEvent=function(){s.signalExpanded=!s.state.expanded},s.expandCollapse=function(){s.setState({expanded:s.signalExpanded}),s.signalExpanded=!1},s.doExpand=function(){s.setState({expanded:!0})},s.doCollapse=function(){s.setState({expanded:!1})},s.addEmbeddedLink=function(t,e,n){var o=s.props,r=o.editorState,i=o.onChange,c=o.config.embedCallback,a=c?c(t):t,l=r.getCurrentContent().createEntity("EMBEDDED_LINK","MUTABLE",{src:a,height:e,width:n}).getLastCreatedEntityKey();i(E.AtomicBlockUtils.insertAtomicBlock(r,l," ")),s.doCollapse()},s}return t=r,(e=[{key:"componentDidMount",value:function(){this.props.modalHandler.registerCallBack(this.expandCollapse)}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=e.component||an;return N.a.createElement(r,{config:e,translations:n,onChange:this.addEmbeddedLink,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&sn(t.prototype,e),n&&sn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();fn.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var yn=fn;n(28);function mn(t){return(mn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function gn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function bn(t,e){return(bn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function hn(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Mn(o);if(r){var n=Mn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===mn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Mn(t){return(Mn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var jn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&bn(t,e)}(i,f["Component"]);var t,e,n,r=hn(i);function i(){var e;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))).onChange=function(t){(0,e.props.onChange)(t.target.innerHTML)},e}return t=i,(e=[{key:"renderEmojiModal",value:function(){var n=this,t=this.props.config,e=t.popupClassName,o=t.emojis;return N.a.createElement("div",{className:w()("rdw-emoji-modal",e),onClick:j},o.map(function(t,e){return N.a.createElement("span",{key:e,className:"rdw-emoji-icon",alt:"",onClick:n.onChange},t)}))}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.title,i=t.expanded,c=t.onExpandEvent,a=t.translations;return N.a.createElement("div",{className:"rdw-emoji-wrapper","aria-haspopup":"true","aria-label":"rdw-emoji-control","aria-expanded":i,title:r||a["components.controls.emoji.emoji"]},N.a.createElement(R,{className:w()(o),value:"unordered-list-item",onClick:c},N.a.createElement("img",{src:n,alt:""})),i?this.renderEmojiModal():void 0)}}])&&gn(t.prototype,e),n&&gn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();jn.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,onChange:y.a.func,config:y.a.object,translations:y.a.object};var vn=jn;function Nn(t){return(Nn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function En(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Sn(t,e){return(Sn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function wn(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Cn(o);if(r){var n=Cn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Nn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Cn(t){return(Cn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Ln=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Sn(t,e)}(r,f["Component"]);var t,e,n,o=wn(r);function r(){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(i=o.call.apply(o,[this].concat(e))).state={expanded:!1},i.onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})},i.addEmoji=function(t){var e=i.props,n=e.editorState,o=e.onChange,r=E.Modifier.replaceText(n.getCurrentContent(),n.getSelection(),t,n.getCurrentInlineStyle());o(E.EditorState.push(n,r,"insert-characters")),i.doCollapse()},i}return t=r,(e=[{key:"componentDidMount",value:function(){this.props.modalHandler.registerCallBack(this.expandCollapse)}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=e.component||vn;return N.a.createElement(r,{config:e,translations:n,onChange:this.addEmoji,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onCollpase:this.closeModal})}}])&&En(t.prototype,e),n&&En(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Ln.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};function Dn(){return N.a.createElement("div",{className:"rdw-spinner"},N.a.createElement("div",{className:"rdw-bounce1"}),N.a.createElement("div",{className:"rdw-bounce2"}),N.a.createElement("div",{className:"rdw-bounce3"}))}n(29),n(30);function kn(t){return(kn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function On(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function xn(t,e){return(xn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function In(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Tn(o);if(r){var n=Tn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===kn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Tn(t){return(Tn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var An=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&xn(t,e)}(r,f["Component"]);var t,e,n,o=In(r);function r(){var a;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(a=o.call.apply(o,[this].concat(e))).state={imgSrc:"",dragEnter:!1,uploadHighlighted:a.props.config.uploadEnabled&&!!a.props.config.uploadCallback,showImageLoading:!1,height:a.props.config.defaultSize.height,width:a.props.config.defaultSize.width,alt:""},a.onDragEnter=function(t){a.stopPropagation(t),a.setState({dragEnter:!0})},a.onImageDrop=function(t){var e,n;t.preventDefault(),t.stopPropagation(),a.setState({dragEnter:!1}),n=t.dataTransfer.items?(e=t.dataTransfer.items,!0):(e=t.dataTransfer.files,!1);for(var o=0;o<e.length;o+=1)if((!n||"file"===e[o].kind)&&e[o].type.match("^image/")){var r=n?e[o].getAsFile():e[o];a.uploadImage(r)}},a.showImageUploadOption=function(){a.setState({uploadHighlighted:!0})},a.addImageFromState=function(){var t=a.state,e=t.imgSrc,n=t.alt,o=a.state,r=o.height,i=o.width,c=a.props.onChange;isNaN(r)||(r+="px"),isNaN(i)||(i+="px"),c(e,r,i,n)},a.showImageURLOption=function(){a.setState({uploadHighlighted:!1})},a.toggleShowImageLoading=function(){var t=!a.state.showImageLoading;a.setState({showImageLoading:t})},a.updateValue=function(t){var e,n,o;a.setState((e={},n="".concat(t.target.name),o=t.target.value,n in e?Object.defineProperty(e,n,{value:o,enumerable:!0,configurable:!0,writable:!0}):e[n]=o,e))},a.selectImage=function(t){t.target.files&&0<t.target.files.length&&a.uploadImage(t.target.files[0])},a.uploadImage=function(t){a.toggleShowImageLoading(),(0,a.props.config.uploadCallback)(t).then(function(t){var e=t.data;a.setState({showImageLoading:!1,dragEnter:!1,imgSrc:e.link||e.url}),a.fileUpload=!1}).catch(function(){a.setState({showImageLoading:!1,dragEnter:!1})})},a.fileUploadClick=function(t){a.fileUpload=!0,t.stopPropagation()},a.stopPropagation=function(t){a.fileUpload?a.fileUpload=!1:(t.preventDefault(),t.stopPropagation())},a}return t=r,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.config;t.expanded&&!this.props.expanded?this.setState({imgSrc:"",dragEnter:!1,uploadHighlighted:e.uploadEnabled&&!!e.uploadCallback,showImageLoading:!1,height:e.defaultSize.height,width:e.defaultSize.width,alt:""}):e.uploadCallback===t.config.uploadCallback&&e.uploadEnabled===t.config.uploadEnabled||this.setState({uploadHighlighted:e.uploadEnabled&&!!e.uploadCallback})}},{key:"renderAddImageModal",value:function(){var t=this.state,e=t.imgSrc,n=t.uploadHighlighted,o=t.showImageLoading,r=t.dragEnter,i=t.height,c=t.width,a=t.alt,l=this.props,s=l.config,u=s.popupClassName,p=s.uploadCallback,d=s.uploadEnabled,f=s.urlEnabled,y=s.previewImage,m=s.inputAccept,g=s.alt,b=l.doCollapse,h=l.translations;return N.a.createElement("div",{className:w()("rdw-image-modal",u),onClick:this.stopPropagation},N.a.createElement("div",{className:"rdw-image-modal-header"},d&&p&&N.a.createElement("span",{onClick:this.showImageUploadOption,className:"rdw-image-modal-header-option"},h["components.controls.image.fileUpload"],N.a.createElement("span",{className:w()("rdw-image-modal-header-label",{"rdw-image-modal-header-label-highlighted":n})})),f&&N.a.createElement("span",{onClick:this.showImageURLOption,className:"rdw-image-modal-header-option"},h["components.controls.image.byURL"],N.a.createElement("span",{className:w()("rdw-image-modal-header-label",{"rdw-image-modal-header-label-highlighted":!n})}))),n?N.a.createElement("div",{onClick:this.fileUploadClick},N.a.createElement("div",{onDragEnter:this.onDragEnter,onDragOver:this.stopPropagation,onDrop:this.onImageDrop,className:w()("rdw-image-modal-upload-option",{"rdw-image-modal-upload-option-highlighted":r})},N.a.createElement("label",{htmlFor:"file",className:"rdw-image-modal-upload-option-label"},y&&e?N.a.createElement("img",{src:e,alt:e,className:"rdw-image-modal-upload-option-image-preview"}):e||h["components.controls.image.dropFileText"])),N.a.createElement("input",{type:"file",id:"file",accept:m,onChange:this.selectImage,className:"rdw-image-modal-upload-option-input"})):N.a.createElement("div",{className:"rdw-image-modal-url-section"},N.a.createElement("input",{className:"rdw-image-modal-url-input",placeholder:h["components.controls.image.enterlink"],name:"imgSrc",onChange:this.updateValue,onBlur:this.updateValue,value:e}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")),g.present&&N.a.createElement("div",{className:"rdw-image-modal-size"},N.a.createElement("span",{className:"rdw-image-modal-alt-lbl"},"Alt Text"),N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:a,name:"alt",className:"rdw-image-modal-alt-input",placeholder:"alt"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},g.mandatory&&"*")),N.a.createElement("div",{className:"rdw-image-modal-size"},"↕ ",N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:i,name:"height",className:"rdw-image-modal-size-input",placeholder:"Height"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")," ↔ ",N.a.createElement("input",{onChange:this.updateValue,onBlur:this.updateValue,value:c,name:"width",className:"rdw-image-modal-size-input",placeholder:"Width"}),N.a.createElement("span",{className:"rdw-image-mandatory-sign"},"*")),N.a.createElement("span",{className:"rdw-image-modal-btn-section"},N.a.createElement("button",{className:"rdw-image-modal-btn",onClick:this.addImageFromState,disabled:!e||!i||!c||g.mandatory&&!a},h["generic.add"]),N.a.createElement("button",{className:"rdw-image-modal-btn",onClick:b},h["generic.cancel"])),o?N.a.createElement("div",{className:"rdw-image-modal-spinner"},N.a.createElement(Dn,null)):void 0)}},{key:"render",value:function(){var t=this.props,e=t.config,n=e.icon,o=e.className,r=e.title,i=t.expanded,c=t.onExpandEvent,a=t.translations;return N.a.createElement("div",{className:"rdw-image-wrapper","aria-haspopup":"true","aria-expanded":i,"aria-label":"rdw-image-control"},N.a.createElement(R,{className:w()(o),value:"unordered-list-item",onClick:c,title:r||a["components.controls.image.image"]},N.a.createElement("img",{src:n,alt:""})),i?this.renderAddImageModal():void 0)}}])&&On(t.prototype,e),n&&On(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();An.propTypes={expanded:y.a.bool,onExpandEvent:y.a.func,doCollapse:y.a.func,onChange:y.a.func,config:y.a.object,translations:y.a.object};var zn=An;function _n(t){return(_n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Pn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Rn(t,e){return(Rn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Un(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Bn(o);if(r){var n=Bn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===_n(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Bn(t){return(Bn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Fn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Rn(t,e)}(r,f["Component"]);var t,e,n,o=Un(r);function r(t){var s;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r),(s=o.call(this,t)).onExpandEvent=function(){s.signalExpanded=!s.state.expanded},s.doExpand=function(){s.setState({expanded:!0})},s.doCollapse=function(){s.setState({expanded:!1})},s.expandCollapse=function(){s.setState({expanded:s.signalExpanded}),s.signalExpanded=!1},s.addImage=function(t,e,n,o){var r=s.props,i=r.editorState,c=r.onChange,a={src:t,height:e,width:n};r.config.alt.present&&(a.alt=o);var l=i.getCurrentContent().createEntity("IMAGE","MUTABLE",a).getLastCreatedEntityKey();c(E.AtomicBlockUtils.insertAtomicBlock(i,l," ")),s.doCollapse()};var e=s.props.modalHandler;return s.state={expanded:!1},e.registerCallBack(s.expandCollapse),s}return t=r,(e=[{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=e.component||zn;return N.a.createElement(r,{config:e,translations:n,onChange:this.addImage,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse})}}])&&Pn(t.prototype,e),n&&Pn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}();Fn.propTypes={editorState:y.a.object.isRequired,onChange:y.a.func.isRequired,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};function Yn(t){var e=t.config,n=t.onChange,o=t.translations,r=e.icon,i=e.className,c=e.title;return N.a.createElement("div",{className:"rdw-remove-wrapper","aria-label":"rdw-remove-control"},N.a.createElement(R,{className:w()(i),onClick:n,title:c||o["components.controls.remove.remove"]},N.a.createElement("img",{src:r,alt:""})))}var Qn=Fn;n(31);Yn.propTypes={onChange:y.a.func,config:y.a.object,translations:y.a.object};var Hn=Yn;function Zn(t){return(Zn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Wn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Gn(t,e){return(Gn=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Jn(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Vn(o);if(r){var n=Vn(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Zn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Vn(t){return(Vn=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var qn=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Gn(t,e)}(i,f["Component"]);var t,e,n,r=Jn(i);function i(){var n;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),o=0;o<t;o++)e[o]=arguments[o];return(n=r.call.apply(r,[this].concat(e))).state={expanded:!1},n.onExpandEvent=function(){n.signalExpanded=!n.state.expanded},n.expandCollapse=function(){n.setState({expanded:n.signalExpanded}),n.signalExpanded=!1},n.removeInlineStyles=function(){var t=n.props,e=t.editorState;(0,t.onChange)(n.removeAllInlineStyles(e))},n.removeAllInlineStyles=function(n){var o=n.getCurrentContent();return["BOLD","ITALIC","UNDERLINE","STRIKETHROUGH","MONOSPACE","SUPERSCRIPT","SUBSCRIPT"].forEach(function(t){o=E.Modifier.removeInlineStyle(o,n.getSelection(),t)}),h(Object(S.getSelectionCustomInlineStyle)(n,["FONTSIZE","FONTFAMILY","COLOR","BGCOLOR"]),function(t,e){e&&(o=E.Modifier.removeInlineStyle(o,n.getSelection(),e))}),E.EditorState.push(n,o,"change-inline-style")},n.doExpand=function(){n.setState({expanded:!0})},n.doCollapse=function(){n.setState({expanded:!1})},n}return t=i,(e=[{key:"componentDidMount",value:function(){this.props.modalHandler.registerCallBack(this.expandCollapse)}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state.expanded,r=e.component||Hn;return N.a.createElement(r,{config:e,translations:n,expanded:o,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onChange:this.removeInlineStyles})}}])&&Wn(t.prototype,e),n&&Wn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();qn.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object.isRequired,config:y.a.object,translations:y.a.object,modalHandler:y.a.object};n(32);function Kn(t){return(Kn="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Xn(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function $n(t,e){return($n=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function to(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=eo(o);if(r){var n=eo(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Kn(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function eo(t){return(eo=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var no=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&$n(t,e)}(i,f["Component"]);var t,e,n,r=to(i);function i(){var e;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))).onChange=function(t){(0,e.props.onChange)(t)},e}return t=i,(e=[{key:"renderInDropDown",value:function(){var t=this.props,e=t.config,n=t.expanded,o=t.doExpand,r=t.onExpandEvent,i=t.doCollapse,c=t.currentState,a=c.undoDisabled,l=c.redoDisabled,s=t.translations,u=e.options,p=e.undo,d=e.redo,f=e.className,y=e.dropdownClassName,m=e.title;return N.a.createElement(H,{className:w()("rdw-history-dropdown",f),optionWrapperClassName:w()(y),expanded:n,doExpand:o,doCollapse:i,onExpandEvent:r,"aria-label":"rdw-history-control",title:m||s["components.controls.history.history"]},N.a.createElement("img",{src:v(e),alt:""}),0<=u.indexOf("undo")&&N.a.createElement(K,{value:"undo",onClick:this.onChange,disabled:a,className:w()("rdw-history-dropdownoption",p.className),title:p.title||s["components.controls.history.undo"]},N.a.createElement("img",{src:p.icon,alt:""})),0<=u.indexOf("redo")&&N.a.createElement(K,{value:"redo",onClick:this.onChange,disabled:l,className:w()("rdw-history-dropdownoption",d.className),title:d.title||s["components.controls.history.redo"]},N.a.createElement("img",{src:d.icon,alt:""})))}},{key:"renderInFlatList",value:function(){var t=this.props,e=t.config,n=e.options,o=e.undo,r=e.redo,i=e.className,c=t.currentState,a=c.undoDisabled,l=c.redoDisabled,s=t.translations;return N.a.createElement("div",{className:w()("rdw-history-wrapper",i),"aria-label":"rdw-history-control"},0<=n.indexOf("undo")&&N.a.createElement(R,{value:"undo",onClick:this.onChange,className:w()(o.className),disabled:a,title:o.title||s["components.controls.history.undo"]},N.a.createElement("img",{src:o.icon,alt:""})),0<=n.indexOf("redo")&&N.a.createElement(R,{value:"redo",onClick:this.onChange,className:w()(r.className),disabled:l,title:r.title||s["components.controls.history.redo"]},N.a.createElement("img",{src:r.icon,alt:""})))}},{key:"render",value:function(){return this.props.config.inDropdown?this.renderInDropDown():this.renderInFlatList()}}])&&Xn(t.prototype,e),n&&Xn(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();function oo(t){return(oo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ro(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function io(t,e){return(io=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function co(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=ao(o);if(r){var n=ao(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===oo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function ao(t){return(ao=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}no.propTypes={expanded:y.a.bool,doExpand:y.a.func,doCollapse:y.a.func,onExpandEvent:y.a.func,config:y.a.object,onChange:y.a.func,currentState:y.a.object,translations:y.a.object};var lo=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&io(t,e)}(c,f["Component"]);var t,e,n,r=co(c);function c(t){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,c),(i=r.call(this,t)).onExpandEvent=function(){i.signalExpanded=!i.state.expanded},i.onChange=function(t){var e=i.props,n=e.editorState,o=e.onChange,r=E.EditorState[t](n);r&&o(r)},i.doExpand=function(){i.setState({expanded:!0})},i.doCollapse=function(){i.setState({expanded:!1})};var e={expanded:!(i.expandCollapse=function(){i.setState({expanded:i.signalExpanded}),i.signalExpanded=!1}),undoDisabled:!1,redoDisabled:!1},n=t.editorState,o=t.modalHandler;return n&&(e.undoDisabled=0===n.getUndoStack().size,e.redoDisabled=0===n.getRedoStack().size),i.state=e,o.registerCallBack(i.expandCollapse),i}return t=c,(e=[{key:"componentDidUpdate",value:function(t){var e=this.props.editorState;e&&t.editorState!==e&&this.setState({undoDisabled:0===e.getUndoStack().size,redoDisabled:0===e.getRedoStack().size})}},{key:"componentWillUnmount",value:function(){this.props.modalHandler.deregisterCallBack(this.expandCollapse)}},{key:"render",value:function(){var t=this.props,e=t.config,n=t.translations,o=this.state,r=o.undoDisabled,i=o.redoDisabled,c=o.expanded,a=e.component||no;return N.a.createElement(a,{config:e,translations:n,currentState:{undoDisabled:r,redoDisabled:i},expanded:c,onExpandEvent:this.onExpandEvent,doExpand:this.doExpand,doCollapse:this.doCollapse,onChange:this.onChange})}}])&&ro(t.prototype,e),n&&ro(t,n),Object.defineProperty(t,"prototype",{writable:!1}),c}();lo.propTypes={onChange:y.a.func.isRequired,editorState:y.a.object,modalHandler:y.a.object,config:y.a.object,translations:y.a.object};var so={inline:st,blockType:Et,fontSize:zt,fontFamily:Jt,list:ce,textAlign:he,colorPicker:Ie,link:$e,embedded:yn,emoji:Ln,image:Qn,remove:qn,history:lo},uo=/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g,po=/^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i;function fo(t){return String(t).replace(uo,"").match(po)?t:"#"}n(33);function yo(t){return(yo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function mo(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function go(t,e){return(go=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function bo(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=ho(o);if(r){var n=ho(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===yo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function ho(t){return(ho=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Mo(t,e,n){t.findEntityRanges(function(t){var e=t.getEntity();return null!==e&&"LINK"===n.getEntity(e).getType()},e)}function jo(t){var e,a=t.showOpenOptionOnHover;return(e=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&go(t,e)}(i,f["Component"]);var t,e,n,o=bo(i);function i(){var r;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(r=o.call.apply(o,[this].concat(e))).state={showPopOver:!1},r.openLink=function(){var t=r.props,e=t.entityKey,n=t.contentState.getEntity(e).getData().url,o=window.open(fo(n),"blank");o&&o.focus()},r.toggleShowPopOver=function(){var t=!r.state.showPopOver;r.setState({showPopOver:t})},r}return t=i,(e=[{key:"render",value:function(){var t=this.props,e=t.children,n=t.entityKey,o=t.contentState.getEntity(n).getData(),r=o.url,i=o.targetOption,c=this.state.showPopOver;return N.a.createElement("span",{className:"rdw-link-decorator-wrapper",onMouseEnter:this.toggleShowPopOver,onMouseLeave:this.toggleShowPopOver},N.a.createElement("a",{href:fo(r),target:i},e),c&&a?N.a.createElement("img",{src:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuMDcyIDBIOC45MTVhLjkyNS45MjUgMCAwIDAgMCAxLjg0OWgyLjkyNUw2Ljk2MSA2LjcyN2EuOTE4LjkxOCAwIDAgMC0uMjcuNjU0YzAgLjI0Ny4wOTUuNDguMjcuNjU0YS45MTguOTE4IDAgMCAwIC42NTQuMjcuOTE4LjkxOCAwIDAgMCAuNjUzLS4yN2w0Ljg4LTQuODh2Mi45MjZhLjkyNS45MjUgMCAwIDAgMS44NDggMFYuOTI0QS45MjUuOTI1IDAgMCAwIDE0LjA3MiAweiIvPjxwYXRoIGQ9Ik0xMC42MjMgMTMuNDExSDEuNTg1VjQuMzcyaDYuNzk4bDEuNTg0LTEuNTg0SC43OTJBLjc5Mi43OTIgMCAwIDAgMCAzLjU4djEwLjYyNGMwIC40MzcuMzU1Ljc5Mi43OTIuNzkyaDEwLjYyNGEuNzkyLjc5MiAwIDAgMCAuNzkyLS43OTJWNS4wMjlsLTEuNTg1IDEuNTg0djYuNzk4eiIvPjwvZz48L3N2Zz4=",alt:"",onClick:this.openLink,className:"rdw-link-decorator-icon"}):void 0)}}])&&mo(t.prototype,e),n&&mo(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}()).propTypes={entityKey:y.a.string.isRequired,children:y.a.array,contentState:y.a.object},e}n(34);function vo(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function No(t,e,n){return e&&vo(t.prototype,e),n&&vo(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}var Eo=No(function t(e){var n=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.getMentionComponent=function(){function t(t){var e=t.entityKey,n=t.children,o=t.contentState.getEntity(e).getData(),r=o.url,i=o.value;return N.a.createElement("a",{href:r||i,className:w()("rdw-mention-link",c)},n)}var c=n.className;return t.propTypes={entityKey:y.a.number,children:y.a.array,contentState:y.a.object},t},this.getMentionDecorator=function(){return{strategy:n.findMentionEntities,component:n.getMentionComponent()}},this.className=e});Eo.prototype.findMentionEntities=function(t,e,n){t.findEntityRanges(function(t){var e=t.getEntity();return null!==e&&"MENTION"===n.getEntity(e).getType()},e)};var So=Eo;n(35);function wo(t){return(wo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Co(t,e){return(Co=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Lo(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Do(o);if(r){var n=Do(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===wo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Do(t){return(Do=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function ko(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Oo(t,e,n){return e&&ko(t.prototype,e),n&&ko(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}function xo(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}var Io=Oo(function t(e){var p=this;xo(this,t),this.findSuggestionEntities=function(t,e){if(p.config.getEditorState()){var n=p.config,o=n.separator,r=n.trigger,i=n.getSuggestions,c=(0,n.getEditorState)().getSelection();if(c.get("anchorKey")===t.get("key")&&c.get("anchorKey")===c.get("focusKey")){var a=t.getText(),l=(a=a.substr(0,c.get("focusOffset")===a.length-1?a.length:c.get("focusOffset")+1)).lastIndexOf(o+r),s=o+r;if((void 0===l||l<0)&&a[0]===r&&(l=0,s=r),0<=l){var u=a.substr(l+s.length,a.length);i().some(function(t){return!!t.value&&(p.config.caseSensitive?0<=t.value.indexOf(u):0<=t.value.toLowerCase().indexOf(u&&u.toLowerCase()))})&&e(0===l?0:l+1,a.length)}}}},this.getSuggestionComponent=function(){var t,a=this.config;return(t=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Co(t,e)}(r,f["Component"]);var o=Lo(r);function r(){var c;xo(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(c=o.call.apply(o,[this].concat(e))).state={style:{left:15},activeOption:-1,showSuggestions:!0},c.onEditorKeyDown=function(t){var e=c.state.activeOption,n={};"ArrowDown"===t.key?(t.preventDefault(),e===c.filteredSuggestions.length-1?n.activeOption=0:n.activeOption=e+1):"ArrowUp"===t.key?n.activeOption=e<=0?c.filteredSuggestions.length-1:e-1:"Escape"===t.key?(n.showSuggestions=!1,g()):"Enter"===t.key&&c.addMention(),c.setState(n)},c.onOptionMouseEnter=function(t){var e=t.target.getAttribute("data-index");c.setState({activeOption:e})},c.onOptionMouseLeave=function(){c.setState({activeOption:-1})},c.setSuggestionReference=function(t){c.suggestion=t},c.setDropdownReference=function(t){c.dropdown=t},c.closeSuggestionDropdown=function(){c.setState({showSuggestions:!1})},c.filteredSuggestions=[],c.filterSuggestions=function(t){var e=t.children[0].props.text.substr(1),n=a.getSuggestions();c.filteredSuggestions=n&&n.filter(function(t){return!e||0===e.length||(a.caseSensitive?0<=t.value.indexOf(e):0<=t.value.toLowerCase().indexOf(e&&e.toLowerCase()))})},c.addMention=function(){var t=c.state.activeOption,e=a.getEditorState(),n=a.onChange,o=a.separator,r=a.trigger,i=c.filteredSuggestions[t];i&&function(t,e,n,o,r){var i=r.value,c=r.url,a=t.getCurrentContent().createEntity("MENTION","IMMUTABLE",{text:"".concat(o).concat(i),value:i,url:c}).getLastCreatedEntityKey(),l=Object(S.getSelectedBlock)(t).getText(),s=t.getSelection().focusOffset,u=(l.lastIndexOf(n+o,s)||0)+1,p=!1;l.length===u+1&&(s=l.length)," "===l[s]&&(p=!0);var d=t.getSelection().merge({anchorOffset:u,focusOffset:s}),f=E.EditorState.acceptSelection(t,d),y=E.Modifier.replaceText(f.getCurrentContent(),d,"".concat(o).concat(i),f.getCurrentInlineStyle(),a);f=E.EditorState.push(f,y,"insert-characters"),p||(d=f.getSelection().merge({anchorOffset:u+i.length+o.length,focusOffset:u+i.length+o.length}),f=E.EditorState.acceptSelection(f,d),y=E.Modifier.insertText(f.getCurrentContent(),d," ",f.getCurrentInlineStyle(),void 0)),e(E.EditorState.push(f,y,"insert-characters"))}(e,n,o,r,i)},c}return Oo(r,[{key:"componentDidMount",value:function(){var t,e,n,o=a.getWrapperRef().getBoundingClientRect(),r=this.suggestion.getBoundingClientRect(),i=this.dropdown.getBoundingClientRect();o.width<r.left-o.left+i.width?e=15:t=15,o.bottom<i.bottom&&(n=0),this.setState({style:{left:t,right:e,bottom:n}}),C.registerCallBack(this.onEditorKeyDown),m(),a.modalHandler.setSuggestionCallback(this.closeSuggestionDropdown),this.filterSuggestions(this.props)}},{key:"componentDidUpdate",value:function(t){this.props.children!==t.children&&(this.filterSuggestions(t),this.setState({showSuggestions:!0}))}},{key:"componentWillUnmount",value:function(){C.deregisterCallBack(this.onEditorKeyDown),g(),a.modalHandler.removeSuggestionCallback()}},{key:"render",value:function(){var n=this,t=this.props.children,e=this.state,o=e.activeOption,r=e.showSuggestions,i=a.dropdownClassName,c=a.optionClassName;return N.a.createElement("span",{className:"rdw-suggestion-wrapper",ref:this.setSuggestionReference,onClick:a.modalHandler.onSuggestionClick,"aria-haspopup":"true","aria-label":"rdw-suggestion-popup"},N.a.createElement("span",null,t),r&&N.a.createElement("span",{className:w()("rdw-suggestion-dropdown",i),contentEditable:"false",suppressContentEditableWarning:!0,style:this.state.style,ref:this.setDropdownReference},this.filteredSuggestions.map(function(t,e){return N.a.createElement("span",{key:e,spellCheck:!1,onClick:n.addMention,"data-index":e,onMouseEnter:n.onOptionMouseEnter,onMouseLeave:n.onOptionMouseLeave,className:w()("rdw-suggestion-option",c,{"rdw-suggestion-option-active":e===o})},t.text)})))}}]),r}()).propTypes={children:y.a.array},t}.bind(this),this.getSuggestionDecorator=function(){return{strategy:p.findSuggestionEntities,component:p.getSuggestionComponent()}};var n=e.separator,o=e.trigger,r=e.getSuggestions,i=e.onChange,c=e.getEditorState,a=e.getWrapperRef,l=e.caseSensitive,s=e.dropdownClassName,u=e.optionClassName,d=e.modalHandler;this.config={separator:n,trigger:o,getSuggestions:r,onChange:i,getEditorState:c,getWrapperRef:a,caseSensitive:l,dropdownClassName:s,optionClassName:u,modalHandler:d}}),To=function(t){return[new So(t.mentionClassName).getMentionDecorator(),new Io(t).getSuggestionDecorator()]};n(36);function Ao(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function zo(t,e,n){return e&&Ao(t.prototype,e),n&&Ao(t,n),Object.defineProperty(t,"prototype",{writable:!1}),t}function _o(t){var e=t.block,n=t.contentState.getEntity(e.getEntityAt(0)).getData(),o=n.src,r=n.height,i=n.width;return N.a.createElement("iframe",{height:r,width:i,src:o,frameBorder:"0",allowFullScreen:!0,title:"Wysiwyg Embedded Content"})}var Po=zo(function t(e){var a=this;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,t),this.getHashtagComponent=function(){function t(t){var e=t.children,n=e[0].props.text;return N.a.createElement("a",{href:n,className:w()("rdw-hashtag-link",o)},e)}var o=a.className;return t.propTypes={children:y.a.object},t},this.findHashtagEntities=function(t,e){for(var n=t.getText(),o=0,r=0;0<n.length&&0<=o;)if(n[0]===a.hashCharacter?(r=o=0,n=n.substr(a.hashCharacter.length)):0<=(o=n.indexOf(a.separator+a.hashCharacter))&&(n=n.substr(o+(a.separator+a.hashCharacter).length),r+=o+a.separator.length),0<=o){var i=0<=n.indexOf(a.separator)?n.indexOf(a.separator):n.length,c=n.substr(0,i);c&&0<c.length&&(e(r,r+c.length+a.hashCharacter.length),r+=a.hashCharacter.length)}},this.getHashtagDecorator=function(){return{strategy:a.findHashtagEntities,component:a.getHashtagComponent()}},this.className=e.className,this.hashCharacter=e.hashCharacter||"#",this.separator=e.separator||" "}),Ro=function(t){return new Po(t).getHashtagDecorator()};_o.propTypes={block:y.a.object,contentState:y.a.object};var Uo=_o;n(37);function Bo(t){return(Bo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Fo(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function Yo(t,e){return(Yo=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function Qo(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=Ho(o);if(r){var n=Ho(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Bo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function Ho(t){return(Ho=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Zo=function(d){var t;return(t=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&Yo(t,e)}(r,f["Component"]);var t,e,n,o=Qo(r);function r(){var i;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,r);for(var t=arguments.length,e=new Array(t),n=0;n<t;n++)e[n]=arguments[n];return(i=o.call.apply(o,[this].concat(e))).state={hovered:!1},i.setEntityAlignmentLeft=function(){i.setEntityAlignment("left")},i.setEntityAlignmentRight=function(){i.setEntityAlignment("right")},i.setEntityAlignmentCenter=function(){i.setEntityAlignment("none")},i.setEntityAlignment=function(t){var e=i.props,n=e.block,o=e.contentState,r=n.getEntityAt(0);o.mergeEntityData(r,{alignment:t}),d.onChange(E.EditorState.push(d.getEditorState(),o,"change-block-data")),i.setState({dummy:!0})},i.toggleHovered=function(){var t=!i.state.hovered;i.setState({hovered:t})},i}return t=r,(e=[{key:"renderAlignmentOptions",value:function(t){return N.a.createElement("div",{className:w()("rdw-image-alignment-options-popup",{"rdw-image-alignment-options-popup-right":"right"===t})},N.a.createElement(R,{onClick:this.setEntityAlignmentLeft,className:"rdw-image-alignment-option"},"L"),N.a.createElement(R,{onClick:this.setEntityAlignmentCenter,className:"rdw-image-alignment-option"},"C"),N.a.createElement(R,{onClick:this.setEntityAlignmentRight,className:"rdw-image-alignment-option"},"R"))}},{key:"render",value:function(){var t=this.props,e=t.block,n=t.contentState,o=this.state.hovered,r=d.isReadOnly,i=d.isImageAlignmentEnabled,c=n.getEntity(e.getEntityAt(0)).getData(),a=c.src,l=c.alignment,s=c.height,u=c.width,p=c.alt;return N.a.createElement("span",{onMouseEnter:this.toggleHovered,onMouseLeave:this.toggleHovered,className:w()("rdw-image-alignment",{"rdw-image-left":"left"===l,"rdw-image-right":"right"===l,"rdw-image-center":!l||"none"===l})},N.a.createElement("span",{className:"rdw-image-imagewrapper"},N.a.createElement("img",{src:a,alt:p,style:{height:s,width:u}}),!r()&&o&&i()?this.renderAlignmentOptions(l):void 0))}}])&&Fo(t.prototype,e),n&&Fo(t,n),Object.defineProperty(t,"prototype",{writable:!1}),r}()).propTypes={block:y.a.object,contentState:y.a.object},t},Wo=function(o,r){return function(t){if("function"==typeof r){var e=r(t,o,o.getEditorState);if(e)return e}if("atomic"===t.getType()){var n=o.getEditorState().getCurrentContent().getEntity(t.getEntityAt(0));if(n&&"IMAGE"===n.type)return{component:Zo(o),editable:!1};if(n&&"EMBEDDED_LINK"===n.type)return{component:Uo,editable:!1}}}},Go={options:["inline","blockType","fontSize","fontFamily","list","textAlign","colorPicker","link","embedded","emoji","image","remove","history"],inline:{inDropdown:!1,className:void 0,component:void 0,dropdownClassName:void 0,options:["bold","italic","underline","strikethrough","monospace","superscript","subscript"],bold:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuMjM2IDBjMS42NTIgMCAyLjk0LjI5OCAzLjg2Ni44OTMuOTI1LjU5NSAxLjM4OCAxLjQ4NSAxLjM4OCAyLjY2OSAwIC42MDEtLjE3MyAxLjEzOS0uNTE2IDEuNjEtLjM0My40NzQtLjg0NC44My0xLjQ5OSAxLjA2OC44NDMuMTY3IDEuNDc0LjUyMyAxLjg5NSAxLjA3MS40MTkuNTUuNjMgMS4xODMuNjMgMS45MDMgMCAxLjI0NS0uNDQ0IDIuMTg3LTEuMzMgMi44MjUtLjg4Ni42NDEtMi4xNDQuOTYxLTMuNzY5Ljk2MUgwdi0yLjE2N2gxLjQ5NFYyLjE2N0gwVjBoNi4yMzZ6TTQuMzA4IDUuNDQ2aDIuMDI0Yy43NTIgMCAxLjMzLS4xNDMgMS43MzQtLjQzLjQwNS0uMjg1LjYwOC0uNzAxLjYwOC0xLjI1IDAtLjYtLjIwNC0xLjA0NC0uNjEyLTEuMzMtLjQwOC0uMjg2LTEuMDE2LS40MjctMS44MjYtLjQyN0g0LjMwOHYzLjQzN3ptMCAxLjgwNFYxMWgyLjU5M2MuNzQ3IDAgMS4zMTQtLjE1MiAxLjcwNy0uNDUyLjM5LS4zLjU4OC0uNzQ1LjU4OC0xLjMzNCAwLS42MzYtLjE2OC0xLjEyNC0uNS0xLjQ2LS4zMzYtLjMzNS0uODY0LS41MDQtMS41ODItLjUwNEg0LjMwOHoiIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==",className:void 0,title:void 0},italic:{icon:"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZD0iTTcgM1YyaDR2MUg5Ljc1M2wtMyAxMEg4djFINHYtMWgxLjI0N2wzLTEwSDd6Ii8+PC9zdmc+",className:void 0,title:void 0},underline:{icon:"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PHBhdGggZD0iTTYuMDQ1IDJ2Ljk5Mkw0Ljc4NSAzdjUuMTcyYzAgLjg1OS4yNDMgMS41MTIuNzI3IDEuOTU3czEuMTI0LjY2OCAxLjkxOC42NjhjLjgzNiAwIDEuNTA5LS4yMjEgMi4wMTktLjY2NC41MTEtLjQ0Mi43NjYtMS4wOTYuNzY2LTEuOTYxVjNsLTEuMjYtLjAwOFYySDEzdi45OTJMMTEuNzM5IDN2NS4xNzJjMCAxLjIzNC0uMzk4IDIuMTgxLTEuMTk1IDIuODQtLjc5Ny42NTktMS44MzUuOTg4LTMuMTE0Ljk4OC0xLjI0MiAwLTIuMjQ4LS4zMjktMy4wMTctLjk4OC0uNzY5LS42NTktMS4xNTItMS42MDUtMS4xNTItMi44NFYzTDIgMi45OTJWMmg0LjA0NXpNMiAxM2gxMXYxSDJ6Ii8+PC9zdmc+",className:void 0,title:void 0},strikethrough:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNC4wNCA1Ljk1NGg2LjIxNWE3LjQxMiA3LjQxMiAwIDAgMC0uNzk1LS40MzggMTEuOTA3IDExLjkwNyAwIDAgMC0xLjQ0Ny0uNTU3Yy0xLjE4OC0uMzQ4LTEuOTY2LS43MTEtMi4zMzQtMS4wODgtLjM2OC0uMzc3LS41NTItLjc3LS41NTItMS4xODEgMC0uNDk1LjE4Ny0uOTA2LjU2LTEuMjMyLjM4LS4zMzEuODg3LS40OTcgMS41MjMtLjQ5Ny42OCAwIDEuMjY2LjI1NSAxLjc1Ny43NjcuMjk1LjMxNS41ODIuODkxLjg2MSAxLjczbC4xMTcuMDE2LjcwMy4wNS4xLS4wMjRjLjAyOC0uMTUyLjA0Mi0uMjc5LjA0Mi0uMzggMC0uMzM3LS4wMzktLjg1Mi0uMTE3LTEuNTQ0YTkuMzc0IDkuMzc0IDAgMCAwLS4xNzYtLjk5NUM5Ljg4LjM3OSA5LjM4NS4yNDQgOS4wMTcuMTc2IDguMzY1LjA3IDcuODk5LjAxNiA3LjYyLjAxNmMtMS40NSAwLTIuNTQ1LjM1Ny0zLjI4NyAxLjA3MS0uNzQ3LjcyLTEuMTIgMS41ODktMS4xMiAyLjYwNyAwIC41MTEuMTMzIDEuMDQuNCAxLjU4Ni4xMjkuMjUzLjI3LjQ3OC40MjcuNjc0ek04LjI4IDguMTE0Yy41NzUuMjM2Ljk1Ny40MzYgMS4xNDcuNTk5LjQ1MS40MS42NzcuODUyLjY3NyAxLjMyNCAwIC4zODMtLjEzLjc0NS0uMzkzIDEuMDg4LS4yNS4zMzgtLjU5LjU4LTEuMDIuNzI2YTMuNDE2IDMuNDE2IDAgMCAxLTEuMTYzLjIyOGMtLjQwNyAwLS43NzUtLjA2Mi0xLjEwNC0uMTg2YTIuNjk2IDIuNjk2IDAgMCAxLS44NzgtLjQ4IDMuMTMzIDMuMTMzIDAgMCAxLS42Ny0uNzk0IDEuNTI3IDEuNTI3IDAgMCAxLS4xMDQtLjIyNyA1Ny41MjMgNTcuNTIzIDAgMCAwLS4xODgtLjQ3MyAyMS4zNzEgMjEuMzcxIDAgMCAwLS4yNTEtLjU5OWwtLjg1My4wMTd2LjM3MWwtLjAxNy4zMTNhOS45MiA5LjkyIDAgMCAwIDAgLjU3M2MuMDExLjI3LjAxNy43MDkuMDE3IDEuMzE2di4xMWMwIC4wNzkuMDIyLjE0LjA2Ny4xODUuMDgzLjA2OC4yODQuMTQ3LjYwMi4yMzdsMS4xNy4zMzdjLjQ1Mi4xMy45OTYuMTk0IDEuNjMyLjE5NC42ODYgMCAxLjI1Mi0uMDU5IDEuNjk4LS4xNzdhNC42OTQgNC42OTQgMCAwIDAgMS4yOC0uNTU3Yy40MDEtLjI1OS43MDUtLjQ4Ni45MTEtLjY4My4yNjgtLjI3Ni40NjYtLjU2OC41OTQtLjg3OGE0Ljc0IDQuNzQgMCAwIDAgLjM0My0xLjc4OGMwLS4yOTgtLjAyLS41NTctLjA1OC0uNzc2SDguMjgxek0xNC45MTQgNi41N2EuMjYuMjYgMCAwIDAtLjE5My0uMDc2SC4yNjhhLjI2LjI2IDAgMCAwLS4xOTMuMDc2LjI2NC4yNjQgMCAwIDAtLjA3NS4xOTR2LjU0YzAgLjA3OS4wMjUuMTQzLjA3NS4xOTRhLjI2LjI2IDAgMCAwIC4xOTMuMDc2SDE0LjcyYS4yNi4yNiAwIDAgMCAuMTkzLS4wNzYuMjY0LjI2NCAwIDAgMCAuMDc1LS4xOTR2LS41NGEuMjY0LjI2NCAwIDAgMC0uMDc1LS4xOTR6Ii8+PC9nPjwvc3ZnPg==",className:void 0,title:void 0},monospace:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzQ0NCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMS4wMjEgMi45MDZjLjE4NiAxLjIxOS4zNzIgMS41LjM3MiAyLjcxOUMxLjM5MyA2LjM3NSAwIDcuMDMxIDAgNy4wMzF2LjkzOHMxLjM5My42NTYgMS4zOTMgMS40MDZjMCAxLjIxOS0uMTg2IDEuNS0uMzcyIDIuNzE5Qy43NDMgMTQuMDYzIDEuNzY0IDE1IDIuNjkzIDE1aDEuOTV2LTEuODc1cy0xLjY3Mi4xODgtMS42NzItLjkzOGMwLS44NDMuMTg2LS44NDMuMzcyLTIuNzE4LjA5My0uODQ0LS40NjQtMS41LTEuMDIyLTEuOTY5LjU1OC0uNDY5IDEuMTE1LTEuMDMxIDEuMDIyLTEuODc1QzMuMDY0IDMuNzUgMi45NyAzLjc1IDIuOTcgMi45MDZjMC0xLjEyNSAxLjY3Mi0xLjAzMSAxLjY3Mi0xLjAzMVYwaC0xLjk1QzEuNjcgMCAuNzQzLjkzOCAxLjAyIDIuOTA2ek0xMS45NzkgMi45MDZjLS4xODYgMS4yMTktLjM3MiAxLjUtLjM3MiAyLjcxOSAwIC43NSAxLjM5MyAxLjQwNiAxLjM5MyAxLjQwNnYuOTM4cy0xLjM5My42NTYtMS4zOTMgMS40MDZjMCAxLjIxOS4xODYgMS41LjM3MiAyLjcxOS4yNzggMS45NjktLjc0MyAyLjkwNi0xLjY3MiAyLjkwNmgtMS45NXYtMS44NzVzMS42NzIuMTg4IDEuNjcyLS45MzhjMC0uODQzLS4xODYtLjg0My0uMzcyLTIuNzE4LS4wOTMtLjg0NC40NjQtMS41IDEuMDIyLTEuOTY5LS41NTgtLjQ2OS0xLjExNS0xLjAzMS0xLjAyMi0xLjg3NS4xODYtMS44NzUuMzcyLTEuODc1LjM3Mi0yLjcxOSAwLTEuMTI1LTEuNjcyLTEuMDMxLTEuNjcyLTEuMDMxVjBoMS45NWMxLjAyMiAwIDEuOTUuOTM4IDEuNjcyIDIuOTA2eiIvPjwvZz48L3N2Zz4=",className:void 0,title:void 0},superscript:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcuMzA1IDEwLjE2NUwxMS44NjUgMTVIOS4wNTdsLTMuMTkyLTMuNTM2TDIuNzQ2IDE1SDBsNC41MjMtNC44MzVMLjIxOCA1LjYwM2gyLjc3TDUuOTg2IDguOTEgOS4wMSA1LjYwM2gyLjY0OWwtNC4zNTQgNC41NjJ6bTYuMjM0LTMuMjY5bDEuODc5LTEuMzA2Yy42NC0uNDE2IDEuMDYyLS44MDEgMS4yNjQtMS4xNTcuMjAxLS4zNTYuMzAyLS43MzguMzAyLTEuMTQ4IDAtLjY2OS0uMjM3LTEuMjEtLjcxLTEuNjItLjQ3NC0uNDExLTEuMDk3LS42MTctMS44NjgtLjYxNy0uNzQ0IDAtMS4zNC4yMDgtMS43ODUuNjI0LS40NDcuNDE2LS42NyAxLjA0My0uNjcgMS44ODFoMS40MzZjMC0uNS4wOTQtLjg0Ni4yODEtMS4wMzguMTg4LS4xOTEuNDQ1LS4yODcuNzcyLS4yODdzLjU4NS4wOTcuNzc3LjI5MmMuMTkuMTk1LjI4Ni40MzcuMjg2LjcyNiAwIC4yOS0uMDg5LjU1LS4yNjYuNzg1cy0uNjcuNjI4LTEuNDc5IDEuMTg0Yy0uNjkxLjQ3Ny0xLjYyNy45MjctMS45MDggMS4zNWwuMDE0IDEuNTY5SDE3VjYuODk2aC0zLjQ2MXoiLz48L3N2Zz4=",className:void 0,title:void 0},subscript:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTExLjg2NiAxMS42NDZIOS4wNkw1Ljg2NyA3Ljk0MmwtMy4xMjEgMy43MDRIMGw0LjUyNC01LjA2NEwuMjE4IDEuODA0aDIuNzdsMyAzLjQ2NCAzLjAyMy0zLjQ2NGgyLjY1TDcuMzA2IDYuNTgybDQuNTYgNS4wNjR6bTEuNzI1IDIuMDU4bDEuODI3LTEuMzY4Yy42NC0uNDM1IDEuMDYyLS44NCAxLjI2NC0xLjIxMi4yMDItLjM3Mi4zMDItLjc3My4zMDItMS4yMDIgMC0uNy0uMjM3LTEuMjY2LS43MS0xLjY5Ni0uNDc0LS40MzEtMS4wOTctLjY0Ni0xLjg2OS0uNjQ2LS43NDQgMC0xLjM0LjIxOC0xLjc4NS42NTMtLjQ0Ni40MzYtLjY3IDEuMDkyLS42NyAxLjk3aDEuNDM2YzAtLjUyNC4wOTQtLjg4Ni4yODEtMS4wODcuMTg4LS4yLjQ0NS0uMzAxLjc3Mi0uMzAxcy41ODYuMTAyLjc3Ny4zMDZjLjE5LjIwNC4yODYuNDU4LjI4Ni43NiAwIC4zMDMtLjA4OC41NzctLjI2Ni44MjItLjE3Ny4yNDUtLjY3LjY1OC0xLjQ3OCAxLjI0LS42OTIuNS0xLjYyOC45NzEtMS45MSAxLjQxM0wxMS44NjQgMTVIMTd2LTEuMjk2aC0zLjQxeiIvPjwvc3ZnPg==",className:void 0,title:void 0}},blockType:{inDropdown:!0,options:["Normal","H1","H2","H3","H4","H5","H6","Blockquote","Code"],className:void 0,component:void 0,dropdownClassName:void 0,title:void 0},fontSize:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTEuOTIxIDMuMTE5YS40MjcuNDI3IDAgMCAwIC4zMzUuMTY0aC45N2EuNDI2LjQyNiAwIDAgMCAuMzA0LS4xMy40NDEuNDQxIDAgMCAwIC4xMjUtLjMxbC4wMDItMi40MWEuNDM0LjQzNCAwIDAgMC0uNDMtLjQzMkguNDNBLjQzNC40MzQgMCAwIDAgMCAuNDR2Mi40MDZjMCAuMjQyLjE5Mi40MzguNDMuNDM4aC45N2MuMTMgMCAuMjU0LS4wNi4zMzUtLjE2NWwuNzMtLjkzSDUuNTR2MTEuMzZjMCAuMjQxLjE5Mi40MzcuNDMuNDM3aDEuNzE3Yy4yMzcgMCAuNDMtLjE5Ni40My0uNDM3VjIuMTg4aDMuMDdsLjczNC45MzF6TTEzLjg5OCAxMS4yNjNhLjQyNS40MjUgMCAwIDAtLjQ4Mi0uMTQ2bC0uNTQ3LjE5NFY5LjYxN2EuNDQyLjQ0MiAwIDAgMC0uMTI2LS4zMS40MjYuNDI2IDAgMCAwLS4zMDQtLjEyN2gtLjQyOWEuNDM0LjQzNCAwIDAgMC0uNDMuNDM3djEuNjk0bC0uNTQ3LS4xOTRhLjQyNS40MjUgMCAwIDAtLjQ4MS4xNDYuNDQ0LjQ0NCAwIDAgMC0uMDE2LjUxMmwxLjMzMiAyLjAxN2EuNDI3LjQyNyAwIDAgMCAuNzEzIDBsMS4zMzMtMi4wMTdhLjQ0NC40NDQgMCAwIDAtLjAxNi0uNTEyeiIvPjwvZz48L3N2Zz4=",options:[8,9,10,11,12,14,16,18,24,30,36,48,60,72,96],className:void 0,component:void 0,dropdownClassName:void 0,title:void 0},fontFamily:{options:["Arial","Georgia","Impact","Tahoma","Times New Roman","Verdana"],className:void 0,component:void 0,dropdownClassName:void 0,title:void 0},list:{inDropdown:!1,className:void 0,component:void 0,dropdownClassName:void 0,options:["unordered","ordered","indent","outdent"],unordered:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMS43MiAzLjQyN2MuOTUxIDAgMS43MjItLjc2OCAxLjcyMi0xLjcwOFMyLjY3LjAxIDEuNzIuMDFDLjc3LjAwOCAwIC43NzUgMCAxLjcxNWMwIC45NC43NzQgMS43MTEgMS43MiAxLjcxMXptMC0yLjYyNWMuNTEgMCAuOTIyLjQxMi45MjIuOTE0YS45Mi45MiAwIDAgMS0xLjg0MiAwIC45Mi45MiAwIDAgMSAuOTItLjkxNHpNMS43MiA4LjcwM2MuOTUxIDAgMS43MjItLjc2OCAxLjcyMi0xLjcwOFMyLjY3IDUuMjg3IDEuNzIgNS4yODdDLjc3IDUuMjg3IDAgNi4wNTIgMCA2Ljk5NXMuNzc0IDEuNzA4IDEuNzIgMS43MDh6bTAtMi42MjJjLjUxIDAgLjkyMi40MTIuOTIyLjkxNGEuOTIuOTIgMCAwIDEtMS44NDIgMGMwLS41MDUuNDE1LS45MTQuOTItLjkxNHpNMS43MiAxMy45ODJjLjk1MSAwIDEuNzIyLS43NjggMS43MjItMS43MDggMC0uOTQzLS43NzQtMS43MDgtMS43MjEtMS43MDgtLjk0NyAwLTEuNzIxLjc2OC0xLjcyMSAxLjcwOHMuNzc0IDEuNzA4IDEuNzIgMS43MDh6bTAtMi42MjVjLjUxIDAgLjkyMi40MTIuOTIyLjkxNGEuOTIuOTIgMCAxIDEtMS44NDIgMCAuOTIuOTIgMCAwIDEgLjkyLS45MTR6TTUuNzQ0IDIuMTE1aDkuODQ1YS40LjQgMCAwIDAgLjQwMS0uMzk5LjQuNCAwIDAgMC0uNDAxLS4zOTlINS43NDRhLjQuNCAwIDAgMC0uNDAyLjM5OS40LjQgMCAwIDAgLjQwMi4zOTl6TTUuNzQ0IDcuMzk0aDkuODQ1YS40LjQgMCAwIDAgLjQwMS0uMzk5LjQuNCAwIDAgMC0uNDAxLS4zOThINS43NDRhLjQuNCAwIDAgMC0uNDAyLjM5OC40LjQgMCAwIDAgLjQwMi4zOTl6TTUuNzQ0IDEyLjY3aDkuODQ1YS40LjQgMCAwIDAgLjQwMS0uMzk5LjQuNCAwIDAgMC0uNDAxLS4zOTlINS43NDRhLjQuNCAwIDAgMC0uNDAyLjQuNC40IDAgMCAwIC40MDIuMzk4eiIvPjwvZz48L3N2Zz4=",className:void 0,title:void 0},ordered:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTMiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNC4yMDIgMS40NjZoOC4xNWMuMzM4IDAgLjYxMi0uMzIyLjYxMi0uNzIgMC0uMzk3LS4yNzQtLjcyLS42MTItLjcyaC04LjE1Yy0uMzM4IDAtLjYxMS4zMjMtLjYxMS43MiAwIC4zOTguMjczLjcyLjYxLjcyek0xMi4zNTIgNS43ODNoLTguMTVjLS4zMzggMC0uNjExLjMyMi0uNjExLjcyIDAgLjM5Ny4yNzMuNzIuNjEuNzJoOC4xNTFjLjMzOCAwIC42MTItLjMyMy42MTItLjcyIDAtLjM5OC0uMjc0LS43Mi0uNjEyLS43MnpNMTIuMzUyIDExLjU0aC04LjE1Yy0uMzM4IDAtLjYxMS4zMjItLjYxMS43MiAwIC4zOTYuMjczLjcxOS42MS43MTloOC4xNTFjLjMzOCAwIC42MTItLjMyMy42MTItLjcyIDAtLjM5Ny0uMjc0LS43Mi0uNjEyLS43MnpNLjc2NyAxLjI0OXYxLjgwMmMwIC4xOTUuMTM2LjM0My4zMTUuMzQzLjE3NiAwIC4zMTUtLjE1LjMxNS0uMzQzVi4zNTZjMC0uMTktLjEzMy0uMzM5LS4zMDItLjMzOS0uMTQ4IDAtLjIyMy4xMTgtLjI0Ny4xNTZhLjIyOC4yMjggMCAwIDAtLjAwMy4wMDVMLjU3OS42MjFhLjQ3NC40NzQgMCAwIDAtLjA5OC4yNzNjMCAuMTk0LjEyOC4zNTEuMjg2LjM1NXpNLjM1MiA4LjE5SDEuNTVjLjE1NyAwIC4yODUtLjE2Mi4yODUtLjM2MiAwLS4xOTgtLjEyOC0uMzU5LS4yODUtLjM1OUguNjh2LS4wMDZjMC0uMTA3LjIxLS4yODEuMzc4LS40MjIuMzM2LS4yNzguNzUzLS42MjUuNzUzLTEuMjI2IDAtLjU3LS4zNzYtMS0uODc0LTEtLjQ3NyAwLS44MzYuMzg1LS44MzYuODk3IDAgLjI5Ny4xNjQuNDAyLjMwNS40MDIuMiAwIC4zMjEtLjE3Ni4zMjEtLjM0NiAwLS4xMDYuMDIzLS4yMjguMjA0LS4yMjguMjQzIDAgLjI1LjI1NC4yNS4yODMgMCAuMjI4LS4yNTIuNDQyLS40OTUuNjQ5LS4zMDEuMjU1LS42NDIuNTQ0LS42NDIuOTkydi4zODRjMCAuMjA1LjE1OS4zNDMuMzA4LjM0M3pNMS43NyAxMC41NDNjMC0uNTkyLS4yOTYtLjkzMS0uODE0LS45MzEtLjY4IDAtLjg1OS41Ny0uODU5Ljg3MiAwIC4zNTEuMjIyLjM5LjMxOC4zOS4xODUgMCAuMzEtLjE0OC4zMS0uMzY2IDAtLjA4NC4wMjYtLjE4MS4yMjQtLjE4MS4xNDIgMCAuMi4wMjQuMi4yNjcgMCAuMjM3LS4wNDMuMjYzLS4yMTMuMjYzLS4xNjQgMC0uMjg4LjE1Mi0uMjg4LjM1NCAwIC4yLjEyNS4zNS4yOTEuMzUuMjI1IDAgLjI3LjEwOC4yNy4yODN2LjA3NWMwIC4yOTQtLjA5Ny4zNS0uMjc3LjM1LS4yNDggMC0uMjY3LS4xNS0uMjY3LS4xOTcgMC0uMTc0LS4wOTgtLjM1LS4zMTctLjM1LS4xOTIgMC0uMzA3LjE0MS0uMzA3LjM3OCAwIC40My4zMTMuODg4Ljg5NS44ODguNTY0IDAgLjkwMS0uNC45MDEtMS4wN3YtLjA3NGMwLS4yNzQtLjA3NC0uNTAyLS4yMTQtLjY2Ni4wOTYtLjE2My4xNDgtLjM4LjE0OC0uNjM1eiIvPjwvZz48L3N2Zz4=",className:void 0,title:void 0},indent:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNS43MTYgMy4yMTFIMTd2MS4xOTdINS43MTZ6TTAgLjAyaDE3djEuMTk3SDB6TTAgMTIuNzgzaDE3djEuMTk3SDB6TTUuNzE2IDkuNTkzSDE3djEuMTk3SDUuNzE2ek01LjcxNiA2LjQwMkgxN3YxLjE5N0g1LjcxNnpNLjE4NyA5LjQ5MUwyLjUyIDcgLjE4NyA0LjUwOXoiLz48L2c+PC9zdmc+",className:void 0,title:void 0},outdent:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNS4zOTYgMy4xOTNoMTAuNTczVjQuMzlINS4zOTZ6TS4wMzkuMDAzaDE1LjkzVjEuMkguMDM5ek0uMDM5IDEyLjc2NmgxNS45M3YxLjE5N0guMDM5ek01LjM5NiA5LjU3NWgxMC41NzN2MS4xOTdINS4zOTZ6TTUuMzk2IDYuMzg0aDEwLjU3M3YxLjE5N0g1LjM5NnpNMi4xODcgNC40OTFMMCA2Ljk4M2wyLjE4NyAyLjQ5MXoiLz48L2c+PC9zdmc+",className:void 0,title:void 0},title:void 0},textAlign:{inDropdown:!1,className:void 0,component:void 0,dropdownClassName:void 0,options:["left","center","right","justify"],left:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNOC40OTMgMTQuODg3SC4zMjZhLjMyNi4zMjYgMCAwIDEgMC0uNjUyaDguMTY3YS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjE4IDEwLjE2MkguMzI2YS4zMjYuMzI2IDAgMCAxIDAtLjY1M2gxNC4yOTJhLjMyNi4zMjYgMCAwIDEgMCAuNjUzek04LjQ5MyA1LjQzNUguMzI2YS4zMjYuMzI2IDAgMCAxIDAtLjY1Mmg4LjE2N2EuMzI2LjMyNiAwIDAgMSAwIC42NTJ6TTE0LjYxOC43MDlILjMyNmEuMzI2LjMyNiAwIDAgMSAwLS42NTJoMTQuMjkyYS4zMjYuMzI2IDAgMCAxIDAgLjY1MnoiLz48L2c+PC9zdmc+",className:void 0,title:void 0},center:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTEuNTU2IDE0Ljg4N0gzLjM4OGEuMzI2LjMyNiAwIDAgMSAwLS42NTJoOC4xNjdhLjMyNi4zMjYgMCAwIDEgMCAuNjUyek0xNC42MTggMTAuMTYySC4zMjZhLjMyNi4zMjYgMCAwIDEgMC0uNjUzaDE0LjI5MmEuMzI2LjMyNiAwIDAgMSAwIC42NTN6TTExLjU1NiA1LjQzNUgzLjM4OGEuMzI2LjMyNiAwIDAgMSAwLS42NTJoOC4xNjdhLjMyNi4zMjYgMCAwIDEgMCAuNjUyek0xNC42MTguNzA5SC4zMjZhLjMyNi4zMjYgMCAwIDEgMC0uNjUyaDE0LjI5MmEuMzI2LjMyNiAwIDAgMSAwIC42NTJ6Ii8+PC9nPjwvc3ZnPg==",className:void 0,title:void 0},right:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNjE4IDE0Ljg4N0g2LjQ1YS4zMjYuMzI2IDAgMCAxIDAtLjY1Mmg4LjE2N2EuMzI2LjMyNiAwIDAgMSAwIC42NTJ6TTE0LjYxOCAxMC4xNjJILjMyNmEuMzI2LjMyNiAwIDAgMSAwLS42NTNoMTQuMjkyYS4zMjYuMzI2IDAgMCAxIDAgLjY1M3pNMTQuNjE4IDUuNDM1SDYuNDVhLjMyNi4zMjYgMCAwIDEgMC0uNjUyaDguMTY3YS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjE4LjcwOUguMzI2YS4zMjYuMzI2IDAgMCAxIDAtLjY1MmgxNC4yOTJhLjMyNi4zMjYgMCAwIDEgMCAuNjUyeiIvPjwvZz48L3N2Zz4=",className:void 0,title:void 0},justify:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNjIgMTQuODg4SC4zMjVhLjMyNi4zMjYgMCAwIDEgMC0uNjUySDE0LjYyYS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjIgMTAuMTYySC4zMjVhLjMyNi4zMjYgMCAwIDEgMC0uNjUySDE0LjYyYS4zMjYuMzI2IDAgMCAxIDAgLjY1MnpNMTQuNjIgNS40MzZILjMyNWEuMzI2LjMyNiAwIDAgMSAwLS42NTJIMTQuNjJhLjMyNi4zMjYgMCAwIDEgMCAuNjUyek0xNC42Mi43MUguMzI1YS4zMjYuMzI2IDAgMCAxIDAtLjY1M0gxNC42MmEuMzI2LjMyNiAwIDAgMSAwIC42NTN6Ii8+PC9nPjwvc3ZnPg==",className:void 0,title:void 0},title:void 0},colorPicker:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNDA2LjU4NWExLjk5OCAxLjk5OCAwIDAgMC0yLjgyNSAwbC0uNTQuNTRhLjc0MS43NDEgMCAxIDAtMS4wNDggMS4wNDhsLjE3NS4xNzUtNS44MjYgNS44MjUtMi4wMjIgMi4wMjNhLjkxLjkxIDAgMCAwLS4yNjYuNjAybC0uMDA1LjEwOHYuMDAybC0uMDgxIDEuODI5YS4zMDIuMzAyIDAgMCAwIC4zMDIuMzE2aC4wMTNsLjk3LS4wNDQuNTkyLS4wMjYuMjY4LS4wMTJjLjI5Ny0uMDEzLjU3OS0uMTM3Ljc5LS4zNDdsNy43Ny03Ljc3LjE0Ni4xNDRhLjc0Ljc0IDAgMCAwIDEuMDQ4IDBjLjI5LS4yOS4yOS0uNzU5IDAtMS4wNDhsLjU0LS41NGMuNzgtLjc4Ljc4LTIuMDQ0IDAtMi44MjV6TTguNzk1IDcuMzMzbC0yLjczLjUxNSA0LjQ1Mi00LjQ1MiAxLjEwOCAxLjEwNy0yLjgzIDIuODN6TTIuMDggMTMuNjczYy0xLjE0OCAwLTIuMDguMjk1LTIuMDguNjYgMCAuMzYzLjkzMi42NTggMi4wOC42NTggMS4xNSAwIDIuMDgtLjI5NCAyLjA4LS42NTkgMC0uMzY0LS45My0uNjU5LTIuMDgtLjY1OXoiLz48L2c+PC9zdmc+",className:void 0,component:void 0,popupClassName:void 0,colors:["rgb(97,189,109)","rgb(26,188,156)","rgb(84,172,210)","rgb(44,130,201)","rgb(147,101,184)","rgb(71,85,119)","rgb(204,204,204)","rgb(65,168,95)","rgb(0,168,133)","rgb(61,142,185)","rgb(41,105,176)","rgb(85,57,130)","rgb(40,50,78)","rgb(0,0,0)","rgb(247,218,100)","rgb(251,160,38)","rgb(235,107,86)","rgb(226,80,65)","rgb(163,143,132)","rgb(239,239,239)","rgb(255,255,255)","rgb(250,197,28)","rgb(243,121,52)","rgb(209,72,65)","rgb(184,49,47)","rgb(124,112,107)","rgb(209,213,216)"],title:void 0},link:{inDropdown:!1,className:void 0,component:void 0,popupClassName:void 0,dropdownClassName:void 0,showOpenOptionOnHover:!0,defaultTargetOption:"_self",options:["link","unlink"],link:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTEzLjk2Ny45NUEzLjIyNiAzLjIyNiAwIDAgMCAxMS42Ny4wMDJjLS44NyAwLTEuNjg2LjMzNy0yLjI5Ny45NDhMNy4xMDUgMy4yMThBMy4yNDcgMy4yNDcgMCAwIDAgNi4yNCA2LjI0YTMuMjI1IDMuMjI1IDAgMCAwLTMuMDIyLjg2NUwuOTUgOS4zNzNhMy4yNTMgMy4yNTMgMCAwIDAgMCA0LjU5NCAzLjIyNiAzLjIyNiAwIDAgMCAyLjI5Ny45NDhjLjg3IDAgMS42ODYtLjMzNiAyLjI5OC0uOTQ4TDcuODEyIDExLjdhMy4yNDcgMy4yNDcgMCAwIDAgLjg2NS0zLjAyMyAzLjIyNSAzLjIyNSAwIDAgMCAzLjAyMi0uODY1bDIuMjY4LTIuMjY3YTMuMjUyIDMuMjUyIDAgMCAwIDAtNC41OTV6TTcuMTA1IDEwLjk5M0w0LjgzNyAxMy4yNmEyLjIzMyAyLjIzMyAwIDAgMS0xLjU5LjY1NSAyLjIzMyAyLjIzMyAwIDAgMS0xLjU5LS42NTUgMi4yNTIgMi4yNTIgMCAwIDEgMC0zLjE4bDIuMjY4LTIuMjY4YTIuMjMyIDIuMjMyIDAgMCAxIDEuNTktLjY1NWMuNDMgMCAuODQxLjEyIDEuMTk1LjM0M0w0Ljc3MiA5LjQzOGEuNS41IDAgMSAwIC43MDcuNzA3bDEuOTM5LTEuOTM4Yy41NDUuODY4LjQ0MiAyLjAzLS4zMTMgMi43ODV6bTYuMTU1LTYuMTU1bC0yLjI2OCAyLjI2N2EyLjIzMyAyLjIzMyAwIDAgMS0xLjU5LjY1NWMtLjQzMSAwLS44NDEtLjEyLTEuMTk1LS4zNDNsMS45MzgtMS45MzhhLjUuNSAwIDEgMC0uNzA3LS43MDdMNy40OTkgNi43MWEyLjI1MiAyLjI1MiAwIDAgMSAuMzEzLTIuNzg1bDIuMjY3LTIuMjY4YTIuMjMzIDIuMjMzIDAgMCAxIDEuNTktLjY1NSAyLjIzMyAyLjIzMyAwIDAgMSAyLjI0NiAyLjI0NWMwIC42MDMtLjIzMiAxLjE2OC0uNjU1IDEuNTl6IiBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=",className:void 0,title:void 0},unlink:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTMuOTU2IDEuMDM3YTMuNTUgMy41NSAwIDAgMC01LjAxNCAwTDYuNDM2IDMuNTQ0YS41NDUuNTQ1IDAgMSAwIC43Ny43N2wyLjUwOC0yLjUwNmEyLjQzOCAyLjQzOCAwIDAgMSAxLjczNS0uNzE1Yy42NTggMCAxLjI3NS4yNTQgMS43MzYuNzE1LjQ2LjQ2MS43MTUgMS4wNzguNzE1IDEuNzM2IDAgLjY1OC0uMjU0IDEuMjc0LS43MTUgMS43MzVMOS45MDcgOC41NThhMi40NTggMi40NTggMCAwIDEtMy40NzIgMCAuNTQ1LjU0NSAwIDEgMC0uNzcxLjc3MSAzLjUzNCAzLjUzNCAwIDAgMCAyLjUwNyAxLjAzN2MuOTA4IDAgMS44MTYtLjM0NiAyLjUwNy0xLjAzN2wzLjI3OC0zLjI3OGEzLjUyIDMuNTIgMCAwIDAgMS4wMzUtMi41MDdjMC0uOTUtLjM2Ny0xLjg0LTEuMDM1LTIuNTA3eiIvPjxwYXRoIGQ9Ik03LjQgMTEuMDY1bC0yLjEyMiAyLjEyYTIuNDM3IDIuNDM3IDAgMCAxLTEuNzM1LjcxNiAyLjQzNyAyLjQzNyAwIDAgMS0xLjczNi0uNzE1IDIuNDU3IDIuNDU3IDAgMCAxIDAtMy40NzFsMy4wODYtMy4wODZhMi40MzggMi40MzggMCAwIDEgMS43MzUtLjcxNWMuNjU4IDAgMS4yNzUuMjU0IDEuNzM2LjcxNWEuNTQ1LjU0NSAwIDEgMCAuNzcxLS43NzEgMy41NSAzLjU1IDAgMCAwLTUuMDE0IDBMMS4wMzYgOC45NDRBMy41MiAzLjUyIDAgMCAwIDAgMTEuNDVjMCAuOTUuMzY3IDEuODQgMS4wMzUgMi41MDdhMy41MiAzLjUyIDAgMCAwIDIuNTA2IDEuMDM1Yy45NSAwIDEuODQtLjM2OCAyLjUwNy0xLjAzNWwyLjEyMi0yLjEyMWEuNTQ1LjU0NSAwIDAgMC0uNzcxLS43NzF6TTkuMjc0IDEyLjAwMmEuNTQ2LjU0NiAwIDAgMC0uNTQ2LjU0NXYxLjYzN2EuNTQ2LjU0NiAwIDAgMCAxLjA5MSAwdi0xLjYzN2EuNTQ1LjU0NSAwIDAgMC0uNTQ1LS41NDV6TTExLjIzIDExLjYxNmEuNTQ1LjU0NSAwIDEgMC0uNzcyLjc3MmwxLjE1NyAxLjE1NmEuNTQzLjU0MyAwIDAgMCAuNzcxIDAgLjU0NS41NDUgMCAwIDAgMC0uNzdsLTEuMTU2LTEuMTU4ek0xMi41MzcgOS44MkgxMC45YS41NDYuNTQ2IDAgMCAwIDAgMS4wOTFoMS42MzdhLjU0Ni41NDYgMCAwIDAgMC0xLjA5ek00LjkxIDMuNTQ3YS41NDYuNTQ2IDAgMCAwIC41NDUtLjU0NVYxLjM2NmEuNTQ2LjU0NiAwIDAgMC0xLjA5IDB2MS42MzZjMCAuMzAxLjI0NC41NDUuNTQ1LjU0NXpNMi44ODggMy45MzNhLjU0My41NDMgMCAwIDAgLjc3MSAwIC41NDUuNTQ1IDAgMCAwIDAtLjc3MUwyLjUwMiAyLjAwNWEuNTQ1LjU0NSAwIDEgMC0uNzcxLjc3bDEuMTU3IDEuMTU4ek0xLjYyOCA1LjczaDEuNjM2YS41NDYuNTQ2IDAgMCAwIDAtMS4wOTJIMS42MjhhLjU0Ni41NDYgMCAwIDAgMCAxLjA5MXoiLz48L2c+PC9zdmc+",className:void 0,title:void 0},linkCallback:void 0},emoji:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHZpZXdCb3g9IjE1LjcyOSAyMi4wODIgMTcgMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI5LjcwOCAyNS4xMDRjLTMuMDIxLTMuMDIyLTcuOTM3LTMuMDIyLTEwLjk1OCAwLTMuMDIxIDMuMDItMy4wMiA3LjkzNiAwIDEwLjk1OCAzLjAyMSAzLjAyIDcuOTM3IDMuMDIgMTAuOTU4LS4wMDEgMy4wMi0zLjAyMSAzLjAyLTcuOTM2IDAtMTAuOTU3em0tLjg0NSAxMC4xMTJhNi41NiA2LjU2IDAgMCAxLTkuMjY4IDAgNi41NiA2LjU2IDAgMCAxIDAtOS4yNjcgNi41NiA2LjU2IDAgMCAxIDkuMjY4IDAgNi41NiA2LjU2IDAgMCAxIDAgOS4yNjd6bS03LjUyNC02LjczYS45MDYuOTA2IDAgMSAxIDEuODExIDAgLjkwNi45MDYgMCAwIDEtMS44MTEgMHptNC4xMDYgMGEuOTA2LjkwNiAwIDEgMSAxLjgxMiAwIC45MDYuOTA2IDAgMCAxLTEuODEyIDB6bTIuMTQxIDMuNzA4Yy0uNTYxIDEuMjk4LTEuODc1IDIuMTM3LTMuMzQ4IDIuMTM3LTEuNTA1IDAtMi44MjctLjg0My0zLjM2OS0yLjE0N2EuNDM4LjQzOCAwIDAgMSAuODEtLjMzNmMuNDA1Ljk3NiAxLjQxIDEuNjA3IDIuNTU5IDEuNjA3IDEuMTIzIDAgMi4xMjEtLjYzMSAyLjU0NC0xLjYwOGEuNDM4LjQzOCAwIDAgMSAuODA0LjM0N3oiLz48L3N2Zz4=",className:void 0,component:void 0,popupClassName:void 0,emojis:["😀","😁","😂","😃","😉","😋","😎","😍","😗","🤗","🤔","😣","😫","😴","😌","🤓","😛","😜","😠","😇","😷","😈","👻","😺","😸","😹","😻","😼","😽","🙀","🙈","🙉","🙊","👼","👮","🕵","💂","👳","🎅","👸","👰","👲","🙍","🙇","🚶","🏃","💃","⛷","🏂","🏌","🏄","🚣","🏊","⛹","🏋","🚴","👫","💪","👈","👉","👆","🖕","👇","🖖","🤘","🖐","👌","👍","👎","✊","👊","👏","🙌","🙏","🐵","🐶","🐇","🐥","🐸","🐌","🐛","🐜","🐝","🍉","🍄","🍔","🍤","🍨","🍪","🎂","🍰","🍾","🍷","🍸","🍺","🌍","🚑","⏰","🌙","🌝","🌞","⭐","🌟","🌠","🌨","🌩","⛄","🔥","🎄","🎈","🎉","🎊","🎁","🎗","🏀","🏈","🎲","🔇","🔈","📣","🔔","🎵","🎷","💰","🖊","📅","✅","❎","💯"],title:void 0},embedded:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuNzA4IDYuNjE1YS40MzYuNDM2IDAgMCAwLS41NDMuMjkxbC0xLjgzIDYuMDQ1YS40MzYuNDM2IDAgMCAwIC44MzMuMjUyTDcgNy4xNmEuNDM2LjQzNiAwIDAgMC0uMjktLjU0NHpNOC45MzEgNi42MTVhLjQzNi40MzYgMCAwIDAtLjU0My4yOTFsLTEuODMgNi4wNDVhLjQzNi40MzYgMCAwIDAgLjgzNC4yNTJsMS44My02LjA0NGEuNDM2LjQzNiAwIDAgMC0uMjktLjU0NHoiLz48cGF0aCBkPSJNMTYuNTY0IDBILjQzNkEuNDM2LjQzNiAwIDAgMCAwIC40MzZ2MTYuMTI4YzAgLjI0LjE5NS40MzYuNDM2LjQzNmgxNi4xMjhjLjI0IDAgLjQzNi0uMTk1LjQzNi0uNDM2Vi40MzZBLjQzNi40MzYgMCAwIDAgMTYuNTY0IDB6TTMuNDg3Ljg3MmgxMC4wMjZ2MS43NDNIMy40ODdWLjg3MnptLTIuNjE1IDBoMS43NDN2MS43NDNILjg3MlYuODcyem0xNS4yNTYgMTUuMjU2SC44NzJWMy40ODhoMTUuMjU2djEyLjY0em0wLTEzLjUxM2gtMS43NDNWLjg3MmgxLjc0M3YxLjc0M3oiLz48Y2lyY2xlIGN4PSI5My44NjciIGN5PSIyNDUuMDY0IiByPSIxMy4xMjgiIHRyYW5zZm9ybT0ibWF0cml4KC4wMzMyIDAgMCAuMDMzMiAwIDApIi8+PGNpcmNsZSBjeD0iOTMuODY3IiBjeT0iMzYwLjU5MiIgcj0iMTMuMTI4IiB0cmFuc2Zvcm09Im1hdHJpeCguMDMzMiAwIDAgLjAzMzIgMCAwKSIvPjxwYXRoIGQ9Ik0xNC4yNTQgMTIuNjQxSDEwLjJhLjQzNi40MzYgMCAwIDAgMCAuODcyaDQuMDU0YS40MzYuNDM2IDAgMCAwIDAtLjg3MnoiLz48L3N2Zz4=",className:void 0,component:void 0,popupClassName:void 0,embedCallback:void 0,defaultSize:{height:"auto",width:"auto"},title:void 0},image:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNMTQuNzQxIDBILjI2Qy4xMTYgMCAwIC4xMzYgMCAuMzA0djEzLjM5MmMwIC4xNjguMTE2LjMwNC4yNTkuMzA0SDE0Ljc0Yy4xNDMgMCAuMjU5LS4xMzYuMjU5LS4zMDRWLjMwNEMxNSAuMTM2IDE0Ljg4NCAwIDE0Ljc0MSAwem0tLjI1OCAxMy4zOTFILjUxN1YuNjFoMTMuOTY2VjEzLjM5eiIvPjxwYXRoIGQ9Ik00LjEzOCA2LjczOGMuNzk0IDAgMS40NC0uNzYgMS40NC0xLjY5NXMtLjY0Ni0xLjY5NS0xLjQ0LTEuNjk1Yy0uNzk0IDAtMS40NC43Ni0xLjQ0IDEuNjk1IDAgLjkzNC42NDYgMS42OTUgMS40NCAxLjY5NXptMC0yLjc4MWMuNTA5IDAgLjkyMy40ODcuOTIzIDEuMDg2IDAgLjU5OC0uNDE0IDEuMDg2LS45MjMgMS4wODYtLjUwOSAwLS45MjMtLjQ4Ny0uOTIzLTEuMDg2IDAtLjU5OS40MTQtMS4wODYuOTIzLTEuMDg2ek0xLjgxIDEyLjE3NGMuMDYgMCAuMTIyLS4wMjUuMTcxLS4wNzZMNi4yIDcuNzI4bDIuNjY0IDMuMTM0YS4yMzIuMjMyIDAgMCAwIC4zNjYgMCAuMzQzLjM0MyAwIDAgMCAwLS40M0w3Ljk4NyA4Ljk2OWwyLjM3NC0zLjA2IDIuOTEyIDMuMTQyYy4xMDYuMTEzLjI3LjEwNS4zNjYtLjAyYS4zNDMuMzQzIDAgMCAwLS4wMTYtLjQzbC0zLjEwNC0zLjM0N2EuMjQ0LjI0NCAwIDAgMC0uMTg2LS4wOC4yNDUuMjQ1IDAgMCAwLS4xOC4xTDcuNjIyIDguNTM3IDYuMzk0IDcuMDk0YS4yMzIuMjMyIDAgMCAwLS4zNTQtLjAxM2wtNC40IDQuNTZhLjM0My4zNDMgMCAwIDAtLjAyNC40My4yNDMuMjQzIDAgMCAwIC4xOTQuMTAzeiIvPjwvZz48L3N2Zz4=",className:void 0,component:void 0,popupClassName:void 0,urlEnabled:!0,uploadEnabled:!0,previewImage:!1,alignmentEnabled:!0,uploadCallback:void 0,inputAccept:"image/gif,image/jpeg,image/jpg,image/png,image/svg",alt:{present:!1,mandatory:!1},defaultSize:{height:"auto",width:"auto"},title:void 0},remove:{icon:"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDE2IDE2Ij48cGF0aCBkPSJNOC4xIDE0bDYuNC03LjJjLjYtLjcuNi0xLjgtLjEtMi41bC0yLjctMi43Yy0uMy0uNC0uOC0uNi0xLjMtLjZIOC42Yy0uNSAwLTEgLjItMS40LjZMLjUgOS4yYy0uNi43LS42IDEuOS4xIDIuNWwyLjcgMi43Yy4zLjQuOC42IDEuMy42SDE2di0xSDguMXptLTEuMy0uMXMwLS4xIDAgMGwtMi43LTIuN2MtLjQtLjQtLjQtLjkgMC0xLjNMNy41IDZoLTFsLTMgMy4zYy0uNi43LS42IDEuNy4xIDIuNEw1LjkgMTRINC42Yy0uMiAwLS40LS4xLS42LS4yTDEuMiAxMWMtLjMtLjMtLjMtLjggMC0xLjFMNC43IDZoMS44TDEwIDJoMUw3LjUgNmwzLjEgMy43LTMuNSA0Yy0uMS4xLS4yLjEtLjMuMnoiLz48L3N2Zz4=",className:void 0,component:void 0,title:void 0},history:{inDropdown:!1,className:void 0,component:void 0,dropdownClassName:void 0,options:["undo","redo"],undo:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTciIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcgMTQuODc1YzIuNjcyIDAgNC44NDYtMi4xNDUgNC44NDYtNC43ODEgMC0yLjYzNy0yLjE3NC00Ljc4MS00Ljg0Ni00Ljc4MVY4LjVMMS42MTUgNC4yNSA3IDB2My4xODhjMy44NiAwIDcgMy4wOTggNyA2LjkwNlMxMC44NiAxNyA3IDE3cy03LTMuMDk4LTctNi45MDZoMi4xNTRjMCAyLjYzNiAyLjE3NCA0Ljc4MSA0Ljg0NiA0Ljc4MXoiIGZpbGw9IiMwMDAiIGZpbGwtcnVsZT0iZXZlbm9kZCIvPjwvc3ZnPg==",className:void 0,title:void 0},redo:{icon:"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTMiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTYuNTA0IDEzLjk3N2E0LjQ5NyA0LjQ5NyAwIDAgMS00LjQ5Mi00LjQ5MiA0LjQ5NyA0LjQ5NyAwIDAgMSA0LjQ5Mi00LjQ5M3YyLjk5NWw0Ljk5LTMuOTkzTDYuNTA0IDB2Mi45OTVhNi40OTYgNi40OTYgMCAwIDAtNi40ODggNi40OWMwIDMuNTc4IDIuOTEgNi40OSA2LjQ4OCA2LjQ5YTYuNDk2IDYuNDk2IDAgMCAwIDYuNDg3LTYuNDloLTEuOTk2YTQuNDk3IDQuNDk3IDAgMCAxLTQuNDkxIDQuNDkyeiIgZmlsbD0iIzAwMCIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+",className:void 0,title:void 0},title:void 0}},Jo={en:{"generic.add":"Add","generic.cancel":"Cancel","components.controls.blocktype.h1":"H1","components.controls.blocktype.h2":"H2","components.controls.blocktype.h3":"H3","components.controls.blocktype.h4":"H4","components.controls.blocktype.h5":"H5","components.controls.blocktype.h6":"H6","components.controls.blocktype.blockquote":"Blockquote","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"Block Type","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Color Picker","components.controls.colorpicker.text":"Text","components.controls.colorpicker.background":"Highlight","components.controls.embedded.embedded":"Embedded","components.controls.embedded.embeddedlink":"Embedded Link","components.controls.embedded.enterlink":"Enter link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Font","components.controls.fontsize.fontsize":"Font Size","components.controls.history.history":"History","components.controls.history.undo":"Undo","components.controls.history.redo":"Redo","components.controls.image.image":"Image","components.controls.image.fileUpload":"File Upload","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Drop the file or click to upload","components.controls.inline.bold":"Bold","components.controls.inline.italic":"Italic","components.controls.inline.underline":"Underline","components.controls.inline.strikethrough":"Strikethrough","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Superscript","components.controls.inline.subscript":"Subscript","components.controls.link.linkTitle":"Link Title","components.controls.link.linkTarget":"Link Target","components.controls.link.linkTargetOption":"Open link in new window","components.controls.link.link":"Link","components.controls.link.unlink":"Unlink","components.controls.list.list":"List","components.controls.list.unordered":"Unordered","components.controls.list.ordered":"Ordered","components.controls.list.indent":"Indent","components.controls.list.outdent":"Outdent","components.controls.remove.remove":"Remove","components.controls.textalign.textalign":"Text Align","components.controls.textalign.left":"Left","components.controls.textalign.center":"Center","components.controls.textalign.right":"Right","components.controls.textalign.justify":"Justify"},fr:{"generic.add":"Ok","generic.cancel":"Annuler","components.controls.blocktype.h1":"Titre 1","components.controls.blocktype.h2":"Titre 2","components.controls.blocktype.h3":"Titre 3","components.controls.blocktype.h4":"Titre 4","components.controls.blocktype.h5":"Titre 5","components.controls.blocktype.h6":"Titre 6","components.controls.blocktype.blockquote":"Citation","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"Type bloc","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Palette de couleur","components.controls.colorpicker.text":"Texte","components.controls.colorpicker.background":"Fond","components.controls.embedded.embedded":"Embedded","components.controls.embedded.embeddedlink":"Lien iFrame","components.controls.embedded.enterlink":"Entrer le lien","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Police","components.controls.fontsize.fontsize":"Taille de police","components.controls.history.history":"Historique","components.controls.history.undo":"Précédent","components.controls.history.redo":"Suivant","components.controls.image.image":"Image","components.controls.image.fileUpload":"Téléchargement","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Glisser une image ou cliquer pour télécharger","components.controls.inline.bold":"Gras","components.controls.inline.italic":"Italique","components.controls.inline.underline":"Souligner","components.controls.inline.strikethrough":"Barrer","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Exposant","components.controls.inline.subscript":"Indice","components.controls.link.linkTitle":"Titre du lien","components.controls.link.linkTarget":"Cible du lien","components.controls.link.linkTargetOption":"Ouvrir le lien dans une nouvelle fenêtre","components.controls.link.link":"Lier","components.controls.link.unlink":"Délier","components.controls.list.list":"Liste","components.controls.list.unordered":"Désordonnée","components.controls.list.ordered":"Ordonnée","components.controls.list.indent":"Augmenter le retrait","components.controls.list.outdent":"Diminuer le retrait","components.controls.remove.remove":"Supprimer","components.controls.textalign.textalign":"Alignement du texte","components.controls.textalign.left":"Gauche","components.controls.textalign.center":"Centre","components.controls.textalign.right":"Droite","components.controls.textalign.justify":"Justifier"},zh:{"generic.add":"添加","generic.cancel":"取消","components.controls.blocktype.h1":"标题1","components.controls.blocktype.h2":"标题2","components.controls.blocktype.h3":"标题3","components.controls.blocktype.h4":"标题4","components.controls.blocktype.h5":"标题5","components.controls.blocktype.h6":"标题6","components.controls.blocktype.blockquote":"引用","components.controls.blocktype.code":"源码","components.controls.blocktype.blocktype":"样式","components.controls.blocktype.normal":"正文","components.controls.colorpicker.colorpicker":"选色器","components.controls.colorpicker.text":"文字","components.controls.colorpicker.background":"背景","components.controls.embedded.embedded":"内嵌","components.controls.embedded.embeddedlink":"内嵌网页","components.controls.embedded.enterlink":"输入网页地址","components.controls.emoji.emoji":"表情符号","components.controls.fontfamily.fontfamily":"字体","components.controls.fontsize.fontsize":"字号","components.controls.history.history":"历史","components.controls.history.undo":"撤销","components.controls.history.redo":"恢复","components.controls.image.image":"图片","components.controls.image.fileUpload":"来自文件","components.controls.image.byURL":"在线图片","components.controls.image.dropFileText":"点击或者拖拽文件上传","components.controls.inline.bold":"粗体","components.controls.inline.italic":"斜体","components.controls.inline.underline":"下划线","components.controls.inline.strikethrough":"删除线","components.controls.inline.monospace":"等宽字体","components.controls.inline.superscript":"上标","components.controls.inline.subscript":"下标","components.controls.link.linkTitle":"超链接","components.controls.link.linkTarget":"输入链接地址","components.controls.link.linkTargetOption":"在新窗口中打开链接","components.controls.link.link":"链接","components.controls.link.unlink":"删除链接","components.controls.list.list":"列表","components.controls.list.unordered":"项目符号","components.controls.list.ordered":"编号","components.controls.list.indent":"增加缩进量","components.controls.list.outdent":"减少缩进量","components.controls.remove.remove":"清除格式","components.controls.textalign.textalign":"文本对齐","components.controls.textalign.left":"文本左对齐","components.controls.textalign.center":"居中","components.controls.textalign.right":"文本右对齐","components.controls.textalign.justify":"两端对齐"},ru:{"generic.add":"Добавить","generic.cancel":"Отменить","components.controls.blocktype.h1":"Заголовок 1","components.controls.blocktype.h2":"Заголовок 2","components.controls.blocktype.h3":"Заголовок 3","components.controls.blocktype.h4":"Заголовок 4","components.controls.blocktype.h5":"Заголовок 5","components.controls.blocktype.h6":"Заголовок 6","components.controls.blocktype.blockquote":"Цитата","components.controls.blocktype.code":"Код","components.controls.blocktype.blocktype":"Форматирование","components.controls.blocktype.normal":"Обычный","components.controls.colorpicker.colorpicker":"Выбор цвета","components.controls.colorpicker.text":"Текст","components.controls.colorpicker.background":"Фон","components.controls.embedded.embedded":"Встраивание","components.controls.embedded.embeddedlink":"Ссылка в iFrame","components.controls.embedded.enterlink":"Вставьте ссылку","components.controls.emoji.emoji":"Эмодзи","components.controls.fontfamily.fontfamily":"Шрифт","components.controls.fontsize.fontsize":"Размер шрифта","components.controls.history.history":"История","components.controls.history.undo":"Отменить","components.controls.history.redo":"Вернуть","components.controls.image.image":"Изображение","components.controls.image.fileUpload":"Файлы","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Переместите в эту область файлы или кликните для загрузки","components.controls.inline.bold":"Жирный","components.controls.inline.italic":"Курсив","components.controls.inline.underline":"Подчеркивание","components.controls.inline.strikethrough":"Зачеркивание","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Верхний индекс","components.controls.inline.subscript":"Нижний индекс","components.controls.link.linkTitle":"Текст","components.controls.link.linkTarget":"Адрес ссылки","components.controls.link.linkTargetOption":"Открывать в новом окне","components.controls.link.link":"Ссылка","components.controls.link.unlink":"Убрать ссылку","components.controls.list.list":"Список","components.controls.list.unordered":"Неупорядоченный","components.controls.list.ordered":"Упорядоченный","components.controls.list.indent":"Отступ","components.controls.list.outdent":"Выступ","components.controls.remove.remove":"Удалить","components.controls.textalign.textalign":"Выравнивание текста","components.controls.textalign.left":"Слева","components.controls.textalign.center":"По центру","components.controls.textalign.right":"Справа","components.controls.textalign.justify":"Выравнить"},pt:{"generic.add":"Ok","generic.cancel":"Cancelar","components.controls.blocktype.h1":"Título 1","components.controls.blocktype.h2":"Título 2","components.controls.blocktype.h3":"Título 3","components.controls.blocktype.h4":"Título 4","components.controls.blocktype.h5":"Título 5","components.controls.blocktype.h6":"Título 6","components.controls.blocktype.blockquote":"Citação","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"Estilo","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Paleta de cores","components.controls.colorpicker.text":"Texto","components.controls.colorpicker.background":"Fundo","components.controls.embedded.embedded":"Embarcado","components.controls.embedded.embeddedlink":"Link embarcado","components.controls.embedded.enterlink":"Coloque o link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Fonte","components.controls.fontsize.fontsize":"Tamanho da Fonte","components.controls.history.history":"Histórico","components.controls.history.undo":"Desfazer","components.controls.history.redo":"Refazer","components.controls.image.image":"Imagem","components.controls.image.fileUpload":"Carregar arquivo","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Arraste uma imagem aqui ou clique para carregar","components.controls.inline.bold":"Negrito","components.controls.inline.italic":"Itálico","components.controls.inline.underline":"Sublinhado","components.controls.inline.strikethrough":"Strikethrough","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Sobrescrito","components.controls.inline.subscript":"Subscrito","components.controls.link.linkTitle":"Título do link","components.controls.link.linkTarget":"Alvo do link","components.controls.link.linkTargetOption":"Abrir link em outra janela","components.controls.link.link":"Adicionar Link","components.controls.link.unlink":"Remover link","components.controls.list.list":"Lista","components.controls.list.unordered":"Sem ordenção","components.controls.list.ordered":"Ordenada","components.controls.list.indent":"Aumentar recuo","components.controls.list.outdent":"Diminuir recuo","components.controls.remove.remove":"Remover","components.controls.textalign.textalign":"Alinhamento do texto","components.controls.textalign.left":"À Esquerda","components.controls.textalign.center":"Centralizado","components.controls.textalign.right":"À Direita","components.controls.textalign.justify":"Justificado"},ko:{"generic.add":"입력","generic.cancel":"취소","components.controls.blocktype.h1":"제목1","components.controls.blocktype.h2":"제목2","components.controls.blocktype.h3":"제목3","components.controls.blocktype.h4":"제목4","components.controls.blocktype.h5":"제목5","components.controls.blocktype.h6":"제목6","components.controls.blocktype.blockquote":"인용","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"블록","components.controls.blocktype.normal":"표준","components.controls.colorpicker.colorpicker":"색상 선택","components.controls.colorpicker.text":"글꼴색","components.controls.colorpicker.background":"배경색","components.controls.embedded.embedded":"임베드","components.controls.embedded.embeddedlink":"임베드 링크","components.controls.embedded.enterlink":"주소를 입력하세요","components.controls.emoji.emoji":"이모지","components.controls.fontfamily.fontfamily":"글꼴","components.controls.fontsize.fontsize":"글꼴 크기","components.controls.history.history":"히스토리","components.controls.history.undo":"실행 취소","components.controls.history.redo":"다시 실행","components.controls.image.image":"이미지","components.controls.image.fileUpload":"파일 업로드","components.controls.image.byURL":"주소","components.controls.image.dropFileText":"클릭하거나 파일을 드롭하여 업로드하세요","components.controls.inline.bold":"굵게","components.controls.inline.italic":"기울임꼴","components.controls.inline.underline":"밑줄","components.controls.inline.strikethrough":"취소선","components.controls.inline.monospace":"고정 너비","components.controls.inline.superscript":"위 첨자","components.controls.inline.subscript":"아래 첨자","components.controls.link.linkTitle":"링크 제목","components.controls.link.linkTarget":"링크 타겟","components.controls.link.linkTargetOption":"새창으로 열기","components.controls.link.link":"링크","components.controls.link.unlink":"링크 제거","components.controls.list.list":"리스트","components.controls.list.unordered":"일반 리스트","components.controls.list.ordered":"순서 리스트","components.controls.list.indent":"들여쓰기","components.controls.list.outdent":"내어쓰기","components.controls.remove.remove":"삭제","components.controls.textalign.textalign":"텍스트 정렬","components.controls.textalign.left":"왼쪽","components.controls.textalign.center":"중앙","components.controls.textalign.right":"오른쪽","components.controls.textalign.justify":"양쪽"},it:{"generic.add":"Aggiungi","generic.cancel":"Annulla","components.controls.blocktype.h1":"H1","components.controls.blocktype.h2":"H2","components.controls.blocktype.h3":"H3","components.controls.blocktype.h4":"H4","components.controls.blocktype.h5":"H5","components.controls.blocktype.h6":"H6","components.controls.blocktype.blockquote":"Citazione","components.controls.blocktype.code":"Codice","components.controls.blocktype.blocktype":"Stili","components.controls.blocktype.normal":"Normale","components.controls.colorpicker.colorpicker":"Colore testo","components.controls.colorpicker.text":"Testo","components.controls.colorpicker.background":"Evidenziazione","components.controls.embedded.embedded":"Incorpora","components.controls.embedded.embeddedlink":"Incorpora link","components.controls.embedded.enterlink":"Inserisci link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Carattere","components.controls.fontsize.fontsize":"Dimensione carattere","components.controls.history.history":"Modifiche","components.controls.history.undo":"Annulla","components.controls.history.redo":"Ripristina","components.controls.image.image":"Immagine","components.controls.image.fileUpload":"Carica immagine","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Trascina il file o clicca per caricare","components.controls.inline.bold":"Grassetto","components.controls.inline.italic":"Corsivo","components.controls.inline.underline":"Sottolineato","components.controls.inline.strikethrough":"Barrato","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Apice","components.controls.inline.subscript":"Pedice","components.controls.link.linkTitle":"Testo","components.controls.link.linkTarget":"Link","components.controls.link.linkTargetOption":"Apri link in una nuova finestra","components.controls.link.link":"Inserisci link","components.controls.link.unlink":"Rimuovi link","components.controls.list.list":"Lista","components.controls.list.unordered":"Elenco puntato","components.controls.list.ordered":"Elenco numerato","components.controls.list.indent":"Indent","components.controls.list.outdent":"Outdent","components.controls.remove.remove":"Rimuovi formattazione","components.controls.textalign.textalign":"Allineamento del testo","components.controls.textalign.left":"Allinea a sinistra","components.controls.textalign.center":"Allinea al centro","components.controls.textalign.right":"Allinea a destra","components.controls.textalign.justify":"Giustifica"},nl:{"generic.add":"Toevoegen","generic.cancel":"Annuleren","components.controls.blocktype.h1":"H1","components.controls.blocktype.h2":"H2","components.controls.blocktype.h3":"H3","components.controls.blocktype.h4":"H4","components.controls.blocktype.h5":"H5","components.controls.blocktype.h6":"H6","components.controls.blocktype.blockquote":"Blockquote","components.controls.blocktype.code":"Code","components.controls.blocktype.blocktype":"Blocktype","components.controls.blocktype.normal":"Normaal","components.controls.colorpicker.colorpicker":"Kleurkiezer","components.controls.colorpicker.text":"Tekst","components.controls.colorpicker.background":"Achtergrond","components.controls.embedded.embedded":"Ingevoegd","components.controls.embedded.embeddedlink":"Ingevoegde link","components.controls.embedded.enterlink":"Voeg link toe","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Lettertype","components.controls.fontsize.fontsize":"Lettergrootte","components.controls.history.history":"Geschiedenis","components.controls.history.undo":"Ongedaan maken","components.controls.history.redo":"Opnieuw","components.controls.image.image":"Afbeelding","components.controls.image.fileUpload":"Bestand uploaden","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Drop het bestand hier of klik om te uploaden","components.controls.inline.bold":"Dikgedrukt","components.controls.inline.italic":"Schuingedrukt","components.controls.inline.underline":"Onderstrepen","components.controls.inline.strikethrough":"Doorstrepen","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Superscript","components.controls.inline.subscript":"Subscript","components.controls.link.linkTitle":"Linktitel","components.controls.link.linkTarget":"Link bestemming","components.controls.link.linkTargetOption":"Open link in een nieuw venster","components.controls.link.link":"Link","components.controls.link.unlink":"Unlink","components.controls.list.list":"Lijst","components.controls.list.unordered":"Ongeordend","components.controls.list.ordered":"Geordend","components.controls.list.indent":"Inspringen","components.controls.list.outdent":"Inspringen verkleinen","components.controls.remove.remove":"Verwijderen","components.controls.textalign.textalign":"Tekst uitlijnen","components.controls.textalign.left":"Links","components.controls.textalign.center":"Gecentreerd","components.controls.textalign.right":"Rechts","components.controls.textalign.justify":"Uitgelijnd"},de:{"generic.add":"Hinzufügen","generic.cancel":"Abbrechen","components.controls.blocktype.h1":"Überschrift 1","components.controls.blocktype.h2":"Überschrift 2","components.controls.blocktype.h3":"Überschrift 3","components.controls.blocktype.h4":"Überschrift 4","components.controls.blocktype.h5":"Überschrift 5","components.controls.blocktype.h6":"Überschrift 6","components.controls.blocktype.blockquote":"Zitat","components.controls.blocktype.code":"Quellcode","components.controls.blocktype.blocktype":"Blocktyp","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Farbauswahl","components.controls.colorpicker.text":"Text","components.controls.colorpicker.background":"Hintergrund","components.controls.embedded.embedded":"Eingebettet","components.controls.embedded.embeddedlink":"Eingebetteter Link","components.controls.embedded.enterlink":"Link eingeben","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Schriftart","components.controls.fontsize.fontsize":"Schriftgröße","components.controls.history.history":"Historie","components.controls.history.undo":"Zurücknehmen","components.controls.history.redo":"Wiederholen","components.controls.image.image":"Bild","components.controls.image.fileUpload":"Datei-Upload","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Dateien ziehen und ablegen, oder klicken zum Hochladen","components.controls.inline.bold":"Fett","components.controls.inline.italic":"Kursiv","components.controls.inline.underline":"Unterstreichen","components.controls.inline.strikethrough":"Durchstreichen","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Hochgestellt","components.controls.inline.subscript":"Tiefgestellt","components.controls.link.linkTitle":"Link-Titel","components.controls.link.linkTarget":"Link-Ziel","components.controls.link.linkTargetOption":"Link in neuem Fenster öffnen","components.controls.link.link":"Link","components.controls.link.unlink":"Aufheben","components.controls.list.list":"Liste","components.controls.list.unordered":"Aufzählung","components.controls.list.ordered":"Nummerierte Liste","components.controls.list.indent":"Einzug vergrößern","components.controls.list.outdent":"Einzug reduzieren","components.controls.remove.remove":"Entfernen","components.controls.textalign.textalign":"Textausrichtung","components.controls.textalign.left":"Linksbündig","components.controls.textalign.center":"Zentrieren","components.controls.textalign.right":"Rechtsbündig","components.controls.textalign.justify":"Blocksatz"},da:{"generic.add":"Tilføj","generic.cancel":"Annuller","components.controls.blocktype.h1":"Overskrift 1","components.controls.blocktype.h2":"Overskrift 2","components.controls.blocktype.h3":"Overskrift 3","components.controls.blocktype.h4":"Overskrift 4","components.controls.blocktype.h5":"Overskrift 5","components.controls.blocktype.h6":"Overskrift 6","components.controls.blocktype.blockquote":"Blokcitat","components.controls.blocktype.code":"Kode","components.controls.blocktype.blocktype":"Blok Type","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Farver","components.controls.colorpicker.text":"Tekst","components.controls.colorpicker.background":"Baggrund","components.controls.embedded.embedded":"Indlejre","components.controls.embedded.embeddedlink":"Indlejre Link","components.controls.embedded.enterlink":"Indtast link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Fonttype","components.controls.fontsize.fontsize":"Fontstørrelser","components.controls.history.history":"Historie","components.controls.history.undo":"Fortryd","components.controls.history.redo":"Gendan","components.controls.image.image":"Billede","components.controls.image.fileUpload":"Filoverførsel","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Drop filen eller klik for at uploade","components.controls.inline.bold":"Fed","components.controls.inline.italic":"Kursiv","components.controls.inline.underline":"Understrege","components.controls.inline.strikethrough":"Gennemstreget","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Hævet","components.controls.inline.subscript":"Sænket","components.controls.link.linkTitle":"Link Titel","components.controls.link.linkTarget":"Link Mål","components.controls.link.linkTargetOption":"Åbn link i nyt vindue","components.controls.link.link":"Link","components.controls.link.unlink":"Fjern link","components.controls.list.list":"Liste","components.controls.list.unordered":"Uordnet","components.controls.list.ordered":"Ordnet","components.controls.list.indent":"Indrykning","components.controls.list.outdent":"Udrykning","components.controls.remove.remove":"Fjern","components.controls.textalign.textalign":"Tekstjustering","components.controls.textalign.left":"Venstre","components.controls.textalign.center":"Center","components.controls.textalign.right":"Højre","components.controls.textalign.justify":"Margener"},zh_tw:{"generic.add":"新增","generic.cancel":"取消","components.controls.blocktype.h1":"標題1","components.controls.blocktype.h2":"標題2","components.controls.blocktype.h3":"標題3","components.controls.blocktype.h4":"標題4","components.controls.blocktype.h5":"標題5","components.controls.blocktype.h6":"標題6","components.controls.blocktype.blockquote":"引用","components.controls.blocktype.code":"程式碼","components.controls.blocktype.blocktype":"樣式","components.controls.blocktype.normal":"正文","components.controls.colorpicker.colorpicker":"選色器","components.controls.colorpicker.text":"文字","components.controls.colorpicker.background":"背景","components.controls.embedded.embedded":"內嵌","components.controls.embedded.embeddedlink":"內嵌網頁","components.controls.embedded.enterlink":"輸入網頁地址","components.controls.emoji.emoji":"表情符號","components.controls.fontfamily.fontfamily":"字體","components.controls.fontsize.fontsize":"字體大小","components.controls.history.history":"歷史紀錄","components.controls.history.undo":"復原","components.controls.history.redo":"重做","components.controls.image.image":"圖片","components.controls.image.fileUpload":"檔案上傳","components.controls.image.byURL":"網址","components.controls.image.dropFileText":"點擊或拖曳檔案上傳","components.controls.inline.bold":"粗體","components.controls.inline.italic":"斜體","components.controls.inline.underline":"底線","components.controls.inline.strikethrough":"刪除線","components.controls.inline.monospace":"等寬字體","components.controls.inline.superscript":"上標","components.controls.inline.subscript":"下標","components.controls.link.linkTitle":"超連結","components.controls.link.linkTarget":"輸入連結位址","components.controls.link.linkTargetOption":"在新視窗打開連結","components.controls.link.link":"連結","components.controls.link.unlink":"刪除連結","components.controls.list.list":"列表","components.controls.list.unordered":"項目符號","components.controls.list.ordered":"編號","components.controls.list.indent":"增加縮排","components.controls.list.outdent":"減少縮排","components.controls.remove.remove":"清除格式","components.controls.textalign.textalign":"文字對齊","components.controls.textalign.left":"文字向左對齊","components.controls.textalign.center":"文字置中","components.controls.textalign.right":"文字向右對齊","components.controls.textalign.justify":"兩端對齊"},pl:{"generic.add":"Dodaj","generic.cancel":"Anuluj","components.controls.blocktype.h1":"Nagłówek 1","components.controls.blocktype.h2":"Nagłówek 2","components.controls.blocktype.h3":"Nagłówek 3","components.controls.blocktype.h4":"Nagłówek 4","components.controls.blocktype.h5":"Nagłówek 5","components.controls.blocktype.h6":"Nagłówek 6","components.controls.blocktype.blockquote":"Cytat","components.controls.blocktype.code":"Kod","components.controls.blocktype.blocktype":"Format","components.controls.blocktype.normal":"Normalny","components.controls.colorpicker.colorpicker":"Kolor","components.controls.colorpicker.text":"Tekst","components.controls.colorpicker.background":"Tło","components.controls.embedded.embedded":"Osadź","components.controls.embedded.embeddedlink":"Osadź odnośnik","components.controls.embedded.enterlink":"Wprowadź odnośnik","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Krój czcionki","components.controls.fontsize.fontsize":"Rozmiar czcionki","components.controls.history.history":"Historia","components.controls.history.undo":"Cofnij","components.controls.history.redo":"Ponów","components.controls.image.image":"Obrazek","components.controls.image.fileUpload":"Prześlij plik","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Upuść plik lub kliknij, aby przesłać","components.controls.inline.bold":"Pogrubienie","components.controls.inline.italic":"Kursywa","components.controls.inline.underline":"Podkreślenie","components.controls.inline.strikethrough":"Przekreślenie","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Indeks górny","components.controls.inline.subscript":"Indeks dolny","components.controls.link.linkTitle":"Tytuł odnośnika","components.controls.link.linkTarget":"Adres odnośnika","components.controls.link.linkTargetOption":"Otwórz odnośnik w nowej karcie","components.controls.link.link":"Wstaw odnośnik","components.controls.link.unlink":"Usuń odnośnik","components.controls.list.list":"Lista","components.controls.list.unordered":"Lista nieuporządkowana","components.controls.list.ordered":"Lista uporządkowana","components.controls.list.indent":"Zwiększ wcięcie","components.controls.list.outdent":"Zmniejsz wcięcie","components.controls.remove.remove":"Usuń","components.controls.textalign.textalign":"Wyrównaj tekst","components.controls.textalign.left":"Do lewej","components.controls.textalign.center":"Do środka","components.controls.textalign.right":"Do prawej","components.controls.textalign.justify":"Wyjustuj"},es:{"generic.add":"Añadir","generic.cancel":"Cancelar","components.controls.blocktype.h1":"H1","components.controls.blocktype.h2":"H2","components.controls.blocktype.h3":"H3","components.controls.blocktype.h4":"H4","components.controls.blocktype.h5":"H5","components.controls.blocktype.h6":"H6","components.controls.blocktype.blockquote":"Blockquote","components.controls.blocktype.code":"Código","components.controls.blocktype.blocktype":"Tipo de bloque","components.controls.blocktype.normal":"Normal","components.controls.colorpicker.colorpicker":"Seleccionar color","components.controls.colorpicker.text":"Texto","components.controls.colorpicker.background":"Subrayado","components.controls.embedded.embedded":"Adjuntar","components.controls.embedded.embeddedlink":"Adjuntar Link","components.controls.embedded.enterlink":"Introducir link","components.controls.emoji.emoji":"Emoji","components.controls.fontfamily.fontfamily":"Fuente","components.controls.fontsize.fontsize":"Tamaño de fuente","components.controls.history.history":"Histórico","components.controls.history.undo":"Deshacer","components.controls.history.redo":"Rehacer","components.controls.image.image":"Imagen","components.controls.image.fileUpload":"Subir archivo","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"Arrastra el archivo o haz click para subirlo","components.controls.inline.bold":"Negrita","components.controls.inline.italic":"Cursiva","components.controls.inline.underline":"Subrayado","components.controls.inline.strikethrough":"Tachado","components.controls.inline.monospace":"Monospace","components.controls.inline.superscript":"Sobreíndice","components.controls.inline.subscript":"Subíndice","components.controls.link.linkTitle":"Título del enlace","components.controls.link.linkTarget":"Objetivo del enlace","components.controls.link.linkTargetOption":"Abrir en nueva ventana","components.controls.link.link":"Enlazar","components.controls.link.unlink":"Desenlazar","components.controls.list.list":"Lista","components.controls.list.unordered":"Desordenada","components.controls.list.ordered":"Ordenada","components.controls.list.indent":"Indentada","components.controls.list.outdent":"Dentada","components.controls.remove.remove":"Eliminar","components.controls.textalign.textalign":"Alineación del texto","components.controls.textalign.left":"Izquierda","components.controls.textalign.center":"Centrado","components.controls.textalign.right":"Derecha","components.controls.textalign.justify":"Justificado"},ja:{"generic.add":"追加","generic.cancel":"キャンセル","components.controls.blocktype.h1":"見出し1","components.controls.blocktype.h2":"見出し2","components.controls.blocktype.h3":"見出し3","components.controls.blocktype.h4":"見出し4","components.controls.blocktype.h5":"見出し5","components.controls.blocktype.h6":"見出し6","components.controls.blocktype.blockquote":"引用","components.controls.blocktype.code":"コード","components.controls.blocktype.blocktype":"スタイル","components.controls.blocktype.normal":"標準テキスト","components.controls.colorpicker.colorpicker":"テキストの色","components.controls.colorpicker.text":"テキスト","components.controls.colorpicker.background":"ハイライト","components.controls.embedded.embedded":"埋め込み","components.controls.embedded.embeddedlink":"埋め込みリンク","components.controls.embedded.enterlink":"リンクを入力してください","components.controls.emoji.emoji":"絵文字","components.controls.fontfamily.fontfamily":"フォント","components.controls.fontsize.fontsize":"フォントサイズ","components.controls.history.history":"履歴","components.controls.history.undo":"元に戻す","components.controls.history.redo":"やり直し","components.controls.image.image":"画像","components.controls.image.fileUpload":"ファイルをアップロード","components.controls.image.byURL":"URL","components.controls.image.dropFileText":"ここに画像をドラッグするか、クリックしてください","components.controls.inline.bold":"太字","components.controls.inline.italic":"斜体","components.controls.inline.underline":"下線","components.controls.inline.strikethrough":"取り消し線","components.controls.inline.monospace":"等幅フォント","components.controls.inline.superscript":"上付き文字","components.controls.inline.subscript":"下付き文字","components.controls.link.linkTitle":"リンクタイトル","components.controls.link.linkTarget":"リンク対象","components.controls.link.linkTargetOption":"新しいウィンドウで開く","components.controls.link.link":"リンク","components.controls.link.unlink":"リンクを解除","components.controls.list.list":"リスト","components.controls.list.unordered":"箇条書き","components.controls.list.ordered":"番号付き","components.controls.list.indent":"インデント増","components.controls.list.outdent":"インデント減","components.controls.remove.remove":"書式をクリア","components.controls.textalign.textalign":"整列","components.controls.textalign.left":"左揃え","components.controls.textalign.center":"中央揃え","components.controls.textalign.right":"右揃え","components.controls.textalign.justify":"両端揃え"}};n(38),n(39);function Vo(t){return(Vo="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function qo(){return(qo=Object.assign?Object.assign.bind():function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function Ko(e,t){var n=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),n.push.apply(n,o)}return n}function Xo(e){for(var t=1;t<arguments.length;t++){var n=null!=arguments[t]?arguments[t]:{};t%2?Ko(Object(n),!0).forEach(function(t){$o(e,t,n[t])}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(n)):Ko(Object(n)).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(n,t))})}return e}function $o(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}function tr(t){return function(t){if(Array.isArray(t))return er(t)}(t)||function(t){if("undefined"!=typeof Symbol&&null!=t[Symbol.iterator]||null!=t["@@iterator"])return Array.from(t)}(t)||function(t,e){if(!t)return;if("string"==typeof t)return er(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);"Object"===n&&t.constructor&&(n=t.constructor.name);if("Map"===n||"Set"===n)return Array.from(t);if("Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))return er(t,e)}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function er(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,o=new Array(e);n<e;n++)o[n]=t[n];return o}function nr(t,e){for(var n=0;n<e.length;n++){var o=e[n];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(t,o.key,o)}}function or(t,e){return(or=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(t,e){return t.__proto__=e,t})(t,e)}function rr(o){var r=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){})),!0}catch(t){return!1}}();return function(){var t,e=ir(o);if(r){var n=ir(this).constructor;t=Reflect.construct(e,arguments,n)}else t=e.apply(this,arguments);return function(t,e){{if(e&&("object"===Vo(e)||"function"==typeof e))return e;if(void 0!==e)throw new TypeError("Derived constructors may only return object or undefined")}return function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(t)}(this,t)}}function ir(t){return(ir=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var cr=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),Object.defineProperty(t,"prototype",{writable:!1}),e&&or(t,e)}(i,f["Component"]);var t,e,n,r=rr(i);function i(t){var c;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),(c=r.call(this,t)).onEditorBlur=function(){c.setState({editorFocused:!1})},c.onEditorFocus=function(t){var e=c.props.onFocus;c.setState({editorFocused:!0});var n=c.focusHandler.isEditorFocused();e&&n&&e(t)},c.onEditorMouseDown=function(){c.focusHandler.onEditorMouseDown()},c.keyBindingFn=function(t){if("Tab"!==t.key)return"ArrowUp"!==t.key&&"ArrowDown"!==t.key||b()&&t.preventDefault(),Object(E.getDefaultKeyBinding)(t);var e=c.props.onTab;if(!e||!e(t)){var n=Object(S.changeDepth)(c.state.editorState,t.shiftKey?-1:1,4);n&&n!==c.state.editorState&&(c.onChange(n),t.preventDefault())}return null},c.onToolbarFocus=function(t){var e=c.props.onFocus;e&&c.focusHandler.isToolbarFocused()&&e(t)},c.onWrapperBlur=function(t){var e=c.props.onBlur;e&&c.focusHandler.isEditorBlur(t)&&e(t,c.getEditorState())},c.onChange=function(t){var e=c.props,n=e.readOnly,o=e.onEditorStateChange;n||"atomic"===Object(S.getSelectedBlocksType)(t)&&t.getSelection().isCollapsed||(o&&o(t,c.props.wrapperId),M(c.props,"editorState")?c.afterChange(t):c.setState({editorState:t},c.afterChange(t)))},c.setWrapperReference=function(t){c.wrapper=t},c.setEditorReference=function(t){c.props.editorRef&&c.props.editorRef(t),c.editor=t},c.getCompositeDecorator=function(t){var e=[].concat(tr(c.props.customDecorators),[{strategy:Mo,component:jo({showOpenOptionOnHover:t.link.showOpenOptionOnHover})}]);return c.props.mention&&e.push.apply(e,tr(To(Xo(Xo({},c.props.mention),{},{onChange:c.onChange,getEditorState:c.getEditorState,getSuggestions:c.getSuggestions,getWrapperRef:c.getWrapperRef,modalHandler:c.modalHandler})))),c.props.hashtag&&e.push(Ro(c.props.hashtag)),new E.CompositeDecorator(e)},c.getWrapperRef=function(){return c.wrapper},c.getEditorState=function(){return c.state?c.state.editorState:null},c.getSuggestions=function(){return c.props.mention&&c.props.mention.suggestions},c.afterChange=function(o){setTimeout(function(){var t=c.props,e=t.onChange,n=t.onContentStateChange;e&&e(Object(E.convertToRaw)(o.getCurrentContent())),n&&n(Object(E.convertToRaw)(o.getCurrentContent()))})},c.isReadOnly=function(){return c.props.readOnly},c.isImageAlignmentEnabled=function(){return c.state.toolbar.image.alignmentEnabled},c.createEditorState=function(t){var e;if(M(c.props,"editorState"))c.props.editorState&&(e=E.EditorState.set(c.props.editorState,{decorator:t}));else if(M(c.props,"defaultEditorState"))c.props.defaultEditorState&&(e=E.EditorState.set(c.props.defaultEditorState,{decorator:t}));else if(M(c.props,"contentState")){if(c.props.contentState){var n=Object(E.convertFromRaw)(c.props.contentState);e=E.EditorState.createWithContent(n,t),e=E.EditorState.moveSelectionToEnd(e)}}else if(M(c.props,"defaultContentState")||M(c.props,"initialContentState")){var o=c.props.defaultContentState||c.props.initialContentState;o&&(o=Object(E.convertFromRaw)(o),e=E.EditorState.createWithContent(o,t),e=E.EditorState.moveSelectionToEnd(e))}return e=e||E.EditorState.createEmpty(t)},c.filterEditorProps=function(t){return e=t,n=["onChange","onEditorStateChange","onContentStateChange","initialContentState","defaultContentState","contentState","editorState","defaultEditorState","locale","localization","toolbarOnFocus","toolbar","toolbarCustomButtons","toolbarClassName","editorClassName","toolbarHidden","wrapperClassName","toolbarStyle","editorStyle","wrapperStyle","uploadCallback","onFocus","onBlur","onTab","mention","hashtag","ariaLabel","customBlockRenderFunc","customDecorators","handlePastedText","customStyleMap"],o=Object.keys(e).filter(function(t){return n.indexOf(t)<0}),r={},o&&0<o.length&&o.forEach(function(t){r[t]=e[t]}),r;var e,n,o,r},c.getStyleMap=function(t){return Xo(Xo({},Object(S.getCustomStyleMap)()),t.customStyleMap)},c.changeEditorState=function(t){var e=Object(E.convertFromRaw)(t),n=c.state.editorState;return n=E.EditorState.push(n,e,"insert-characters"),n=E.EditorState.moveSelectionToEnd(n)},c.focusEditor=function(){setTimeout(function(){c.editor.focus()})},c.handleKeyCommand=function(t){var e=c.state,n=e.editorState,o=e.toolbar.inline;if(o&&0<=o.options.indexOf(t)){var r=E.RichUtils.handleKeyCommand(n,t);if(r)return c.onChange(r),!0}return!1},c.handleReturn=function(t){if(b())return!0;var e=c.state.editorState,n=Object(S.handleNewLine)(e,t);return!!n&&(c.onChange(n),!0)},c.handlePastedTextFn=function(t,e){var n=c.state.editorState,o=c.props,r=o.handlePastedText,i=o.stripPastedStyles;return r?r(t,e,n,c.onChange):!i&&function(t,e,n,o){var r=Object(S.getSelectedBlock)(n);if(r&&"code"===r.type){var i=E.Modifier.replaceText(n.getCurrentContent(),n.getSelection(),t,n.getCurrentInlineStyle());return o(E.EditorState.push(n,i,"insert-characters")),!0}if(e){var c=O()(e),a=n.getCurrentContent();return c.entityMap.forEach(function(t,e){a=a.mergeEntityData(e,t)}),a=E.Modifier.replaceWithFragment(a,n.getSelection(),new x.List(c.contentBlocks)),o(E.EditorState.push(n,a,"insert-characters")),!0}return!1}(t,e,n,c.onChange)},c.preventDefault=function(t){"INPUT"===t.target.tagName||"LABEL"===t.target.tagName||"TEXTAREA"===t.target.tagName?c.focusHandler.onInputMouseDown():t.preventDefault()};var e=D(Go,t.toolbar),n=t.wrapperId?t.wrapperId:Math.floor(1e4*Math.random());c.wrapperId="rdw-wrapper-".concat(n),c.modalHandler=new a,c.focusHandler=new p,c.blockRendererFn=Wo({isReadOnly:c.isReadOnly,isImageAlignmentEnabled:c.isImageAlignmentEnabled,getEditorState:c.getEditorState,onChange:c.onChange},t.customBlockRenderFunc),c.editorProps=c.filterEditorProps(t),c.customStyleMap=c.getStyleMap(t),c.compositeDecorator=c.getCompositeDecorator(e);var o=c.createEditorState(c.compositeDecorator);return Object(S.extractInlineStyle)(o),c.state={editorState:o,editorFocused:!1,toolbar:e},c}return t=i,(e=[{key:"componentDidMount",value:function(){this.modalHandler.init(this.wrapperId)}},{key:"componentDidUpdate",value:function(t){if(t!==this.props){var e={},n=this.props,o=n.editorState,r=n.contentState;if(!this.state.toolbar){var i=D(Go,i);e.toolbar=i}if(M(this.props,"editorState")&&o!==t.editorState)e.editorState=o?E.EditorState.set(o,{decorator:this.compositeDecorator}):E.EditorState.createEmpty(this.compositeDecorator);else if(M(this.props,"contentState")&&r!==t.contentState)if(r){var c=this.changeEditorState(r);c&&(e.editorState=c)}else e.editorState=E.EditorState.createEmpty(this.compositeDecorator);t.editorState===o&&t.contentState===r||Object(S.extractInlineStyle)(e.editorState),Object.keys(e).length&&this.setState(e),this.editorProps=this.filterEditorProps(this.props),this.customStyleMap=this.getStyleMap(this.props)}}},{key:"render",value:function(){var t=this.state,e=t.editorState,n=t.editorFocused,r=t.toolbar,o=this.props,i=o.locale,c=o.localization,a=c.locale,l=c.translations,s=o.toolbarCustomButtons,u=o.toolbarOnFocus,p=o.toolbarClassName,d=o.toolbarHidden,f=o.editorClassName,y=o.wrapperClassName,m=o.toolbarStyle,g=o.editorStyle,b=o.wrapperStyle,h=o.uploadCallback,M=o.ariaLabel,j={modalHandler:this.modalHandler,editorState:e,onChange:this.onChange,translations:Xo(Xo({},Jo[i||a]),l)},v=n||this.focusHandler.isInputFocused()||!u;return N.a.createElement("div",{id:this.wrapperId,className:w()(y,"rdw-editor-wrapper"),style:b,onClick:this.modalHandler.onEditorClick,onBlur:this.onWrapperBlur,"aria-label":"rdw-wrapper"},!d&&N.a.createElement("div",{className:w()("rdw-editor-toolbar",p),style:Xo({visibility:v?"visible":"hidden"},m),onMouseDown:this.preventDefault,"aria-label":"rdw-toolbar","aria-hidden":(!n&&u).toString(),onFocus:this.onToolbarFocus},r.options.map(function(t,e){var n=so[t],o=r[t];return"image"===t&&h&&(o.uploadCallback=h),N.a.createElement(n,qo({key:e},j,{config:o}))}),s&&s.map(function(t,e){return N.a.cloneElement(t,Xo({key:e},j))})),N.a.createElement("div",{ref:this.setWrapperReference,className:w()(f,"rdw-editor-main"),style:g,onClick:this.focusEditor,onFocus:this.onEditorFocus,onBlur:this.onEditorBlur,onKeyDown:C.onKeyDown,onMouseDown:this.onEditorMouseDown},N.a.createElement(E.Editor,qo({ref:this.setEditorReference,keyBindingFn:this.keyBindingFn,editorState:e,onChange:this.onChange,blockStyleFn:L,customStyleMap:this.getStyleMap(this.props),handleReturn:this.handleReturn,handlePastedText:this.handlePastedTextFn,blockRendererFn:this.blockRendererFn,handleKeyCommand:this.handleKeyCommand,ariaLabel:M||"rdw-editor",blockRenderMap:S.blockRenderMap},this.editorProps))))}}])&&nr(t.prototype,e),n&&nr(t,n),Object.defineProperty(t,"prototype",{writable:!1}),i}();cr.propTypes={onChange:y.a.func,onEditorStateChange:y.a.func,onContentStateChange:y.a.func,initialContentState:y.a.object,defaultContentState:y.a.object,contentState:y.a.object,editorState:y.a.object,defaultEditorState:y.a.object,toolbarOnFocus:y.a.bool,spellCheck:y.a.bool,stripPastedStyles:y.a.bool,toolbar:y.a.object,toolbarCustomButtons:y.a.array,toolbarClassName:y.a.string,toolbarHidden:y.a.bool,locale:y.a.string,localization:y.a.object,editorClassName:y.a.string,wrapperClassName:y.a.string,toolbarStyle:y.a.object,editorStyle:y.a.object,wrapperStyle:y.a.object,uploadCallback:y.a.func,onFocus:y.a.func,onBlur:y.a.func,onTab:y.a.func,mention:y.a.object,hashtag:y.a.object,textAlignment:y.a.string,readOnly:y.a.bool,tabIndex:y.a.number,placeholder:y.a.string,ariaLabel:y.a.string,ariaOwneeID:y.a.string,ariaActiveDescendantID:y.a.string,ariaAutoComplete:y.a.string,ariaDescribedBy:y.a.string,ariaExpanded:y.a.string,ariaHasPopup:y.a.string,customBlockRenderFunc:y.a.func,wrapperId:y.a.number,customDecorators:y.a.array,editorRef:y.a.func,handlePastedText:y.a.func},cr.defaultProps={toolbarOnFocus:!1,toolbarHidden:!1,stripPastedStyles:!1,localization:{locale:"en",translations:{}},customDecorators:[]};var ar=cr}],i.c=a,i.d=function(t,e,n){i.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n})},i.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},i.t=function(e,t){if(1&t&&(e=i(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(i.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)i.d(n,o,function(t){return e[t]}.bind(null,o));return n},i.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return i.d(e,"a",e),e},i.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},i.p="",i(i.s=8);function i(t){if(a[t])return a[t].exports;var e=a[t]={i:t,l:!1,exports:{}};return c[t].call(e.exports,e,e.exports,i),e.l=!0,e.exports}var c,a});

/***/ }),
/* 3177 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(0), __webpack_require__(1));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types"], factory);
	else if(typeof exports === 'object')
		exports["Dropzone"] = factory(require("react"), require("prop-types"));
	else
		root["Dropzone"] = factory(root["react"], root["prop-types"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_3__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _attrAccept = __webpack_require__(4);
	
	var _attrAccept2 = _interopRequireDefault(_attrAccept);
	
	var _getDataTransferItems = __webpack_require__(5);
	
	var _getDataTransferItems2 = _interopRequireDefault(_getDataTransferItems);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint prefer-template: 0 */
	
	var supportMultiple = typeof document !== 'undefined' && document && document.createElement ? 'multiple' in document.createElement('input') : true;
	
	function fileAccepted(file, accept) {
	  // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
	  // that MIME type will always be accepted
	  return file.type === 'application/x-moz-file' || (0, _attrAccept2.default)(file, accept);
	}
	
	var Dropzone = function (_React$Component) {
	  _inherits(Dropzone, _React$Component);
	
	  _createClass(Dropzone, null, [{
	    key: 'onDocumentDragOver',
	    value: function onDocumentDragOver(evt) {
	      // allow the entire document to be a drag target
	      evt.preventDefault();
	    }
	  }]);
	
	  function Dropzone(props, context) {
	    _classCallCheck(this, Dropzone);
	
	    var _this = _possibleConstructorReturn(this, (Dropzone.__proto__ || Object.getPrototypeOf(Dropzone)).call(this, props, context));
	
	    _this.renderChildren = function (children, isDragActive, isDragReject) {
	      if (typeof children === 'function') {
	        return children(_extends({}, _this.state, { isDragActive: isDragActive, isDragReject: isDragReject }));
	      }
	      return children;
	    };
	
	    _this.onClick = _this.onClick.bind(_this);
	    _this.onDocumentDrop = _this.onDocumentDrop.bind(_this);
	    _this.onDragStart = _this.onDragStart.bind(_this);
	    _this.onDragEnter = _this.onDragEnter.bind(_this);
	    _this.onDragLeave = _this.onDragLeave.bind(_this);
	    _this.onDragOver = _this.onDragOver.bind(_this);
	    _this.onDrop = _this.onDrop.bind(_this);
	    _this.onFileDialogCancel = _this.onFileDialogCancel.bind(_this);
	    _this.setRef = _this.setRef.bind(_this);
	    _this.setRefs = _this.setRefs.bind(_this);
	    _this.onInputElementClick = _this.onInputElementClick.bind(_this);
	    _this.isFileDialogActive = false;
	    _this.state = {
	      draggedFiles: [],
	      acceptedFiles: [],
	      rejectedFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(Dropzone, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var preventDropOnDocument = this.props.preventDropOnDocument;
	
	      this.dragTargets = [];
	
	      if (preventDropOnDocument) {
	        document.addEventListener('dragover', Dropzone.onDocumentDragOver, false);
	        document.addEventListener('drop', this.onDocumentDrop, false);
	      }
	      this.fileInputEl.addEventListener('click', this.onInputElementClick, false);
	      // Tried implementing addEventListener, but didn't work out
	      document.body.onfocus = this.onFileDialogCancel;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var preventDropOnDocument = this.props.preventDropOnDocument;
	
	      if (preventDropOnDocument) {
	        document.removeEventListener('dragover', Dropzone.onDocumentDragOver);
	        document.removeEventListener('drop', this.onDocumentDrop);
	      }
	      this.fileInputEl.removeEventListener('click', this.onInputElementClick, false);
	      // Can be replaced with removeEventListener, if addEventListener works
	      document.body.onfocus = null;
	    }
	  }, {
	    key: 'onDocumentDrop',
	    value: function onDocumentDrop(evt) {
	      if (this.node.contains(evt.target)) {
	        // if we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
	        return;
	      }
	      evt.preventDefault();
	      this.dragTargets = [];
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(evt) {
	      if (this.props.onDragStart) {
	        this.props.onDragStart.call(this, evt);
	      }
	    }
	  }, {
	    key: 'onDragEnter',
	    value: function onDragEnter(evt) {
	      evt.preventDefault();
	
	      // Count the dropzone and any children that are entered.
	      if (this.dragTargets.indexOf(evt.target) === -1) {
	        this.dragTargets.push(evt.target);
	      }
	
	      this.setState({ draggedFiles: (0, _getDataTransferItems2.default)(evt) });
	
	      if (this.props.onDragEnter) {
	        this.props.onDragEnter.call(this, evt);
	      }
	    }
	  }, {
	    key: 'onDragOver',
	    value: function onDragOver(evt) {
	      // eslint-disable-line class-methods-use-this
	      evt.preventDefault();
	      evt.stopPropagation();
	      try {
	        evt.dataTransfer.dropEffect = 'copy'; // eslint-disable-line no-param-reassign
	      } catch (err) {
	        // continue regardless of error
	      }
	
	      if (this.props.onDragOver) {
	        this.props.onDragOver.call(this, evt);
	      }
	      return false;
	    }
	  }, {
	    key: 'onDragLeave',
	    value: function onDragLeave(evt) {
	      var _this2 = this;
	
	      evt.preventDefault();
	
	      // Only deactivate once the dropzone and all children have been left.
	      this.dragTargets = this.dragTargets.filter(function (el) {
	        return el !== evt.target && _this2.node.contains(el);
	      });
	      if (this.dragTargets.length > 0) {
	        return;
	      }
	
	      // Clear dragging files state
	      this.setState({ draggedFiles: [] });
	
	      if (this.props.onDragLeave) {
	        this.props.onDragLeave.call(this, evt);
	      }
	    }
	  }, {
	    key: 'onDrop',
	    value: function onDrop(evt) {
	      var _this3 = this;
	
	      var _props = this.props,
	          onDrop = _props.onDrop,
	          onDropAccepted = _props.onDropAccepted,
	          onDropRejected = _props.onDropRejected,
	          multiple = _props.multiple,
	          disablePreview = _props.disablePreview,
	          accept = _props.accept;
	
	      var fileList = (0, _getDataTransferItems2.default)(evt);
	      var acceptedFiles = [];
	      var rejectedFiles = [];
	
	      // Stop default browser behavior
	      evt.preventDefault();
	
	      // Reset the counter along with the drag on a drop.
	      this.dragTargets = [];
	      this.isFileDialogActive = false;
	
	      fileList.forEach(function (file) {
	        if (!disablePreview) {
	          try {
	            file.preview = window.URL.createObjectURL(file); // eslint-disable-line no-param-reassign
	          } catch (err) {
	            if (process.env.NODE_ENV !== 'production') {
	              console.error('Failed to generate preview for file', file, err); // eslint-disable-line no-console
	            }
	          }
	        }
	
	        if (fileAccepted(file, accept) && _this3.fileMatchSize(file)) {
	          acceptedFiles.push(file);
	        } else {
	          rejectedFiles.push(file);
	        }
	      });
	
	      if (!multiple) {
	        // if not in multi mode add any extra accepted files to rejected.
	        // This will allow end users to easily ignore a multi file drop in "single" mode.
	        rejectedFiles.push.apply(rejectedFiles, _toConsumableArray(acceptedFiles.splice(1)));
	      }
	
	      if (onDrop) {
	        onDrop.call(this, acceptedFiles, rejectedFiles, evt);
	      }
	
	      if (rejectedFiles.length > 0 && onDropRejected) {
	        onDropRejected.call(this, rejectedFiles, evt);
	      }
	
	      if (acceptedFiles.length > 0 && onDropAccepted) {
	        onDropAccepted.call(this, acceptedFiles, evt);
	      }
	
	      // Clear files value
	      this.draggedFiles = null;
	
	      // Reset drag state
	      this.setState({
	        draggedFiles: [],
	        acceptedFiles: acceptedFiles,
	        rejectedFiles: rejectedFiles
	      });
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(evt) {
	      var _props2 = this.props,
	          onClick = _props2.onClick,
	          disableClick = _props2.disableClick;
	
	      if (!disableClick) {
	        evt.stopPropagation();
	
	        if (onClick) {
	          onClick.call(this, evt);
	        }
	
	        // in IE11/Edge the file-browser dialog is blocking, ensure this is behind setTimeout
	        // this is so react can handle state changes in the onClick prop above above
	        // see: https://github.com/okonet/react-dropzone/issues/450
	        setTimeout(this.open.bind(this), 0);
	      }
	    }
	  }, {
	    key: 'onInputElementClick',
	    value: function onInputElementClick(evt) {
	      evt.stopPropagation();
	      if (this.props.inputProps && this.props.inputProps.onClick) {
	        this.props.inputProps.onClick();
	      }
	    }
	  }, {
	    key: 'onFileDialogCancel',
	    value: function onFileDialogCancel() {
	      // timeout will not recognize context of this method
	      var onFileDialogCancel = this.props.onFileDialogCancel;
	      var fileInputEl = this.fileInputEl;
	      var isFileDialogActive = this.isFileDialogActive;
	      // execute the timeout only if the onFileDialogCancel is defined and FileDialog
	      // is opened in the browser
	
	      if (onFileDialogCancel && isFileDialogActive) {
	        setTimeout(function () {
	          // Returns an object as FileList
	          var FileList = fileInputEl.files;
	          if (!FileList.length) {
	            isFileDialogActive = false;
	            onFileDialogCancel();
	          }
	        }, 300);
	      }
	    }
	  }, {
	    key: 'setRef',
	    value: function setRef(ref) {
	      this.node = ref;
	    }
	  }, {
	    key: 'setRefs',
	    value: function setRefs(ref) {
	      this.fileInputEl = ref;
	    }
	  }, {
	    key: 'fileMatchSize',
	    value: function fileMatchSize(file) {
	      return file.size <= this.props.maxSize && file.size >= this.props.minSize;
	    }
	  }, {
	    key: 'allFilesAccepted',
	    value: function allFilesAccepted(files) {
	      var _this4 = this;
	
	      return files.every(function (file) {
	        return fileAccepted(file, _this4.props.accept);
	      });
	    }
	
	    /**
	     * Open system file upload dialog.
	     *
	     * @public
	     */
	
	  }, {
	    key: 'open',
	    value: function open() {
	      this.isFileDialogActive = true;
	      this.fileInputEl.value = null;
	      this.fileInputEl.click();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          accept = _props3.accept,
	          activeClassName = _props3.activeClassName,
	          inputProps = _props3.inputProps,
	          multiple = _props3.multiple,
	          name = _props3.name,
	          rejectClassName = _props3.rejectClassName,
	          children = _props3.children,
	          rest = _objectWithoutProperties(_props3, ['accept', 'activeClassName', 'inputProps', 'multiple', 'name', 'rejectClassName', 'children']);
	
	      var activeStyle = rest.activeStyle,
	          className = rest.className,
	          rejectStyle = rest.rejectStyle,
	          style = rest.style,
	          props = _objectWithoutProperties(rest, ['activeStyle', 'className', 'rejectStyle', 'style']);
	
	      var draggedFiles = this.state.draggedFiles;
	
	      var filesCount = draggedFiles.length;
	      var isMultipleAllowed = multiple || filesCount <= 1;
	      var isDragActive = filesCount > 0 && this.allFilesAccepted(draggedFiles);
	      var isDragReject = filesCount > 0 && (!isDragActive || !isMultipleAllowed);
	
	      className = className || '';
	
	      if (isDragActive && activeClassName) {
	        className += ' ' + activeClassName;
	      }
	      if (isDragReject && rejectClassName) {
	        className += ' ' + rejectClassName;
	      }
	
	      if (!className && !style && !activeStyle && !rejectStyle) {
	        style = {
	          width: 200,
	          height: 200,
	          borderWidth: 2,
	          borderColor: '#666',
	          borderStyle: 'dashed',
	          borderRadius: 5
	        };
	        activeStyle = {
	          borderStyle: 'solid',
	          borderColor: '#6c6',
	          backgroundColor: '#eee'
	        };
	        rejectStyle = {
	          borderStyle: 'solid',
	          borderColor: '#c66',
	          backgroundColor: '#eee'
	        };
	      }
	
	      var appliedStyle = void 0;
	      if (activeStyle && isDragActive) {
	        appliedStyle = _extends({}, style, activeStyle);
	      } else if (rejectStyle && isDragReject) {
	        appliedStyle = _extends({}, style, rejectStyle);
	      } else {
	        appliedStyle = _extends({}, style);
	      }
	
	      var inputAttributes = {
	        accept: accept,
	        type: 'file',
	        style: { display: 'none' },
	        multiple: supportMultiple && multiple,
	        ref: this.setRefs,
	        onChange: this.onDrop
	      };
	
	      if (name && name.length) {
	        inputAttributes.name = name;
	      }
	
	      // Remove custom properties before passing them to the wrapper div element
	      var customProps = ['acceptedFiles', 'preventDropOnDocument', 'disablePreview', 'disableClick', 'onDropAccepted', 'onDropRejected', 'onFileDialogCancel', 'maxSize', 'minSize'];
	      var divProps = _extends({}, props);
	      customProps.forEach(function (prop) {
	        return delete divProps[prop];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        _extends({
	          className: className,
	          style: appliedStyle
	        }, divProps /* expand user provided props first so event handlers are never overridden */, {
	          onClick: this.onClick,
	          onDragStart: this.onDragStart,
	          onDragEnter: this.onDragEnter,
	          onDragOver: this.onDragOver,
	          onDragLeave: this.onDragLeave,
	          onDrop: this.onDrop,
	          ref: this.setRef
	        }),
	        this.renderChildren(children, isDragActive, isDragReject),
	        _react2.default.createElement('input', _extends({}, inputProps /* expand user provided inputProps first so inputAttributes override them */, inputAttributes))
	      );
	    }
	  }]);
	
	  return Dropzone;
	}(_react2.default.Component);
	
	Dropzone.propTypes = {
	  /**
	   * Allow specific types of files. See https://github.com/okonet/attr-accept for more information.
	   * Keep in mind that mime type determination is not reliable accross platforms. CSV files,
	   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
	   * Windows. In some cases there might not be a mime type set at all.
	   * See: https://github.com/okonet/react-dropzone/issues/276
	   */
	  accept: _propTypes2.default.string,
	
	  /**
	   * Contents of the dropzone
	   */
	  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
	
	  /**
	   * Disallow clicking on the dropzone container to open file dialog
	   */
	  disableClick: _propTypes2.default.bool,
	
	  /**
	   * Enable/disable preview generation
	   */
	  disablePreview: _propTypes2.default.bool,
	
	  /**
	   * If false, allow dropped items to take over the current browser window
	   */
	  preventDropOnDocument: _propTypes2.default.bool,
	
	  /**
	   * Pass additional attributes to the `<input type="file"/>` tag
	   */
	  inputProps: _propTypes2.default.object,
	
	  /**
	   * Allow dropping multiple files
	   */
	  multiple: _propTypes2.default.bool,
	
	  /**
	   * `name` attribute for the input tag
	   */
	  name: _propTypes2.default.string,
	
	  /**
	   * Maximum file size
	   */
	  maxSize: _propTypes2.default.number,
	
	  /**
	   * Minimum file size
	   */
	  minSize: _propTypes2.default.number,
	
	  /**
	   * className
	   */
	  className: _propTypes2.default.string,
	
	  /**
	   * className for accepted state
	   */
	  activeClassName: _propTypes2.default.string,
	
	  /**
	   * className for rejected state
	   */
	  rejectClassName: _propTypes2.default.string,
	
	  /**
	   * CSS styles to apply
	   */
	  style: _propTypes2.default.object,
	
	  /**
	   * CSS styles to apply when drop will be accepted
	   */
	  activeStyle: _propTypes2.default.object,
	
	  /**
	   * CSS styles to apply when drop will be rejected
	   */
	  rejectStyle: _propTypes2.default.object,
	
	  /**
	   * onClick callback
	   * @param {Event} event
	   */
	  onClick: _propTypes2.default.func,
	
	  /**
	   * onDrop callback
	   */
	  onDrop: _propTypes2.default.func,
	
	  /**
	   * onDropAccepted callback
	   */
	  onDropAccepted: _propTypes2.default.func,
	
	  /**
	   * onDropRejected callback
	   */
	  onDropRejected: _propTypes2.default.func,
	
	  /**
	   * onDragStart callback
	   */
	  onDragStart: _propTypes2.default.func,
	
	  /**
	   * onDragEnter callback
	   */
	  onDragEnter: _propTypes2.default.func,
	
	  /**
	   * onDragOver callback
	   */
	  onDragOver: _propTypes2.default.func,
	
	  /**
	   * onDragLeave callback
	   */
	  onDragLeave: _propTypes2.default.func,
	
	  /**
	   * Provide a callback on clicking the cancel button of the file dialog
	   */
	  onFileDialogCancel: _propTypes2.default.func
	};
	
	Dropzone.defaultProps = {
	  preventDropOnDocument: true,
	  disablePreview: false,
	  disableClick: false,
	  multiple: true,
	  maxSize: Infinity,
	  minSize: 0
	};
	
	exports.default = Dropzone;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 2 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_3__;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

	module.exports=function(t){function n(e){if(r[e])return r[e].exports;var o=r[e]={exports:{},id:e,loaded:!1};return t[e].call(o.exports,o,o.exports,n),o.loaded=!0,o.exports}var r={};return n.m=t,n.c=r,n.p="",n(0)}([function(t,n,r){"use strict";n.__esModule=!0,r(8),r(9),n["default"]=function(t,n){if(t&&n){var r=function(){var r=Array.isArray(n)?n:n.split(","),e=t.name||"",o=t.type||"",i=o.replace(/\/.*$/,"");return{v:r.some(function(t){var n=t.trim();return"."===n.charAt(0)?e.toLowerCase().endsWith(n.toLowerCase()):/\/\*$/.test(n)?i===n.replace(/\/.*$/,""):o===n})}}();if("object"==typeof r)return r.v}return!0},t.exports=n["default"]},function(t,n){var r=t.exports={version:"1.2.2"};"number"==typeof __e&&(__e=r)},function(t,n){var r=t.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r)},function(t,n,r){var e=r(2),o=r(1),i=r(4),u=r(19),c="prototype",f=function(t,n){return function(){return t.apply(n,arguments)}},s=function(t,n,r){var a,p,l,y,d=t&s.G,h=t&s.P,v=d?e:t&s.S?e[n]||(e[n]={}):(e[n]||{})[c],x=d?o:o[n]||(o[n]={});d&&(r=n);for(a in r)p=!(t&s.F)&&v&&a in v,l=(p?v:r)[a],y=t&s.B&&p?f(l,e):h&&"function"==typeof l?f(Function.call,l):l,v&&!p&&u(v,a,l),x[a]!=l&&i(x,a,y),h&&((x[c]||(x[c]={}))[a]=l)};e.core=o,s.F=1,s.G=2,s.S=4,s.P=8,s.B=16,s.W=32,t.exports=s},function(t,n,r){var e=r(5),o=r(18);t.exports=r(22)?function(t,n,r){return e.setDesc(t,n,o(1,r))}:function(t,n,r){return t[n]=r,t}},function(t,n){var r=Object;t.exports={create:r.create,getProto:r.getPrototypeOf,isEnum:{}.propertyIsEnumerable,getDesc:r.getOwnPropertyDescriptor,setDesc:r.defineProperty,setDescs:r.defineProperties,getKeys:r.keys,getNames:r.getOwnPropertyNames,getSymbols:r.getOwnPropertySymbols,each:[].forEach}},function(t,n){var r=0,e=Math.random();t.exports=function(t){return"Symbol(".concat(void 0===t?"":t,")_",(++r+e).toString(36))}},function(t,n,r){var e=r(20)("wks"),o=r(2).Symbol;t.exports=function(t){return e[t]||(e[t]=o&&o[t]||(o||r(6))("Symbol."+t))}},function(t,n,r){r(26),t.exports=r(1).Array.some},function(t,n,r){r(25),t.exports=r(1).String.endsWith},function(t,n){t.exports=function(t){if("function"!=typeof t)throw TypeError(t+" is not a function!");return t}},function(t,n){var r={}.toString;t.exports=function(t){return r.call(t).slice(8,-1)}},function(t,n,r){var e=r(10);t.exports=function(t,n,r){if(e(t),void 0===n)return t;switch(r){case 1:return function(r){return t.call(n,r)};case 2:return function(r,e){return t.call(n,r,e)};case 3:return function(r,e,o){return t.call(n,r,e,o)}}return function(){return t.apply(n,arguments)}}},function(t,n){t.exports=function(t){if(void 0==t)throw TypeError("Can't call method on  "+t);return t}},function(t,n,r){t.exports=function(t){var n=/./;try{"/./"[t](n)}catch(e){try{return n[r(7)("match")]=!1,!"/./"[t](n)}catch(o){}}return!0}},function(t,n){t.exports=function(t){try{return!!t()}catch(n){return!0}}},function(t,n){t.exports=function(t){return"object"==typeof t?null!==t:"function"==typeof t}},function(t,n,r){var e=r(16),o=r(11),i=r(7)("match");t.exports=function(t){var n;return e(t)&&(void 0!==(n=t[i])?!!n:"RegExp"==o(t))}},function(t,n){t.exports=function(t,n){return{enumerable:!(1&t),configurable:!(2&t),writable:!(4&t),value:n}}},function(t,n,r){var e=r(2),o=r(4),i=r(6)("src"),u="toString",c=Function[u],f=(""+c).split(u);r(1).inspectSource=function(t){return c.call(t)},(t.exports=function(t,n,r,u){"function"==typeof r&&(o(r,i,t[n]?""+t[n]:f.join(String(n))),"name"in r||(r.name=n)),t===e?t[n]=r:(u||delete t[n],o(t,n,r))})(Function.prototype,u,function(){return"function"==typeof this&&this[i]||c.call(this)})},function(t,n,r){var e=r(2),o="__core-js_shared__",i=e[o]||(e[o]={});t.exports=function(t){return i[t]||(i[t]={})}},function(t,n,r){var e=r(17),o=r(13);t.exports=function(t,n,r){if(e(n))throw TypeError("String#"+r+" doesn't accept regex!");return String(o(t))}},function(t,n,r){t.exports=!r(15)(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a})},function(t,n){var r=Math.ceil,e=Math.floor;t.exports=function(t){return isNaN(t=+t)?0:(t>0?e:r)(t)}},function(t,n,r){var e=r(23),o=Math.min;t.exports=function(t){return t>0?o(e(t),9007199254740991):0}},function(t,n,r){"use strict";var e=r(3),o=r(24),i=r(21),u="endsWith",c=""[u];e(e.P+e.F*r(14)(u),"String",{endsWith:function(t){var n=i(this,t,u),r=arguments,e=r.length>1?r[1]:void 0,f=o(n.length),s=void 0===e?f:Math.min(o(e),f),a=String(t);return c?c.call(n,a,s):n.slice(s-a.length,s)===a}})},function(t,n,r){var e=r(5),o=r(3),i=r(1).Array||Array,u={},c=function(t,n){e.each.call(t.split(","),function(t){void 0==n&&t in i?u[t]=i[t]:t in[]&&(u[t]=r(12)(Function.call,[][t],n))})};c("pop,reverse,shift,keys,values,entries",1),c("indexOf,every,some,forEach,map,filter,find,findIndex,includes",3),c("join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill"),o(o.S,"Array",u)}]);

/***/ }),
/* 5 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getDataTransferFiles;
	function getDataTransferFiles(event) {
	  var dataTransferItemsList = [];
	  if (event.dataTransfer) {
	    var dt = event.dataTransfer;
	    if (dt.files && dt.files.length) {
	      dataTransferItemsList = dt.files;
	    } else if (dt.items && dt.items.length) {
	      // During the drag even the dataTransfer.files is null
	      // but Chrome implements some drag store, which is accesible via dataTransfer.items
	      dataTransferItemsList = dt.items;
	    }
	  } else if (event.target && event.target.files) {
	    dataTransferItemsList = event.target.files;
	  }
	  // Convert from DataTransferItemsList to the native Array
	  return Array.prototype.slice.call(dataTransferItemsList);
	}
	module.exports = exports["default"];

/***/ })
/******/ ])
});
;
//# sourceMappingURL=index.js.map

/***/ }),
/* 3178 */
/***/ (function(module, exports) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 3179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = format;
var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }
    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }
    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === "string" && s.indexOf("@") !== -1;
}
var redacted = "REDACTED (Potential Email Address)";
function redactEmail(string) {
  if (mightBeEmail(string)) {
    console.warn("This arg looks like an email address, redacting.");
    return redacted;
  }
  return string;
}
function format() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var _str = s || "";
  if (titleCase) {
    _str = toTitleCase(s);
  }
  if (redactingEmail) {
    _str = redactEmail(_str);
  }
  return _str;
}

/***/ }),
/* 3180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GA4 = void 0;
var _gtag = _interopRequireDefault(__webpack_require__(3181));
var _format = _interopRequireDefault(__webpack_require__(3179));
var _excluded = ["eventCategory", "eventAction", "eventLabel", "eventValue", "hitType"],
  _excluded2 = ["title", "location"],
  _excluded3 = ["page", "hitType"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
Links
https://developers.google.com/gtagjs/reference/api
https://developers.google.com/tag-platform/gtagjs/reference
*/
/**
 * @typedef GaOptions
 * @type {Object}
 * @property {boolean} [cookieUpdate=true]
 * @property {number} [cookieExpires=63072000] Default two years
 * @property {string} [cookieDomain="auto"]
 * @property {string} [cookieFlags]
 * @property {string} [userId]
 * @property {string} [clientId]
 * @property {boolean} [anonymizeIp]
 * @property {string} [contentGroup1]
 * @property {string} [contentGroup2]
 * @property {string} [contentGroup3]
 * @property {string} [contentGroup4]
 * @property {string} [contentGroup5]
 * @property {boolean} [allowAdFeatures=true]
 * @property {boolean} [allowAdPersonalizationSignals]
 * @property {boolean} [nonInteraction]
 * @property {string} [page]
 */
/**
 * @typedef UaEventOptions
 * @type {Object}
 * @property {string} action
 * @property {string} category
 * @property {string} [label]
 * @property {number} [value]
 * @property {boolean} [nonInteraction]
 * @property {('beacon'|'xhr'|'image')} [transport]
 */
/**
 * @typedef InitOptions
 * @type {Object}
 * @property {string} trackingId
 * @property {GaOptions|any} [gaOptions]
 * @property {Object} [gtagOptions] New parameter
 */
var GA4 = /*#__PURE__*/function () {
  function GA4() {
    var _this = this;
    _classCallCheck(this, GA4);
    _defineProperty(this, "reset", function () {
      _this.isInitialized = false;
      _this._testMode = false;
      _this._currentMeasurementId;
      _this._hasLoadedGA = false;
      _this._isQueuing = false;
      _this._queueGtag = [];
    });
    _defineProperty(this, "_gtag", function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (!_this._testMode) {
        if (_this._isQueuing) {
          _this._queueGtag.push(args);
        } else {
          _gtag["default"].apply(void 0, args);
        }
      } else {
        _this._queueGtag.push(args);
      }
    });
    _defineProperty(this, "_loadGA", function (GA_MEASUREMENT_ID, nonce) {
      var gtagUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
      if (typeof window === "undefined" || typeof document === "undefined") {
        return;
      }
      if (!_this._hasLoadedGA) {
        // Global Site Tag (gtag.js) - Google Analytics
        var script = document.createElement("script");
        script.async = true;
        script.src = "".concat(gtagUrl, "?id=").concat(GA_MEASUREMENT_ID);
        if (nonce) {
          script.setAttribute("nonce", nonce);
        }
        document.body.appendChild(script);
        window.dataLayer = window.dataLayer || [];
        window.gtag = function gtag() {
          window.dataLayer.push(arguments);
        };
        _this._hasLoadedGA = true;
      }
    });
    _defineProperty(this, "_toGtagOptions", function (gaOptions) {
      if (!gaOptions) {
        return;
      }
      var mapFields = {
        // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
        // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
        cookieUpdate: "cookie_update",
        cookieExpires: "cookie_expires",
        cookieDomain: "cookie_domain",
        cookieFlags: "cookie_flags",
        // must be in set method?
        userId: "user_id",
        clientId: "client_id",
        anonymizeIp: "anonymize_ip",
        // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
        contentGroup1: "content_group1",
        contentGroup2: "content_group2",
        contentGroup3: "content_group3",
        contentGroup4: "content_group4",
        contentGroup5: "content_group5",
        // https://support.google.com/analytics/answer/9050852?hl=en
        allowAdFeatures: "allow_google_signals",
        allowAdPersonalizationSignals: "allow_ad_personalization_signals",
        nonInteraction: "non_interaction",
        page: "page_path",
        hitCallback: "event_callback"
      };
      var gtagOptions = Object.entries(gaOptions).reduce(function (prev, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        if (mapFields[key]) {
          prev[mapFields[key]] = value;
        } else {
          prev[key] = value;
        }
        return prev;
      }, {});
      return gtagOptions;
    });
    _defineProperty(this, "initialize", function (GA_MEASUREMENT_ID) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!GA_MEASUREMENT_ID) {
        throw new Error("Require GA_MEASUREMENT_ID");
      }
      var initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [{
        trackingId: GA_MEASUREMENT_ID
      }] : GA_MEASUREMENT_ID;
      _this._currentMeasurementId = initConfigs[0].trackingId;
      var gaOptions = options.gaOptions,
        gtagOptions = options.gtagOptions,
        nonce = options.nonce,
        _options$testMode = options.testMode,
        testMode = _options$testMode === void 0 ? false : _options$testMode,
        gtagUrl = options.gtagUrl;
      _this._testMode = testMode;
      if (!testMode) {
        _this._loadGA(_this._currentMeasurementId, nonce, gtagUrl);
      }
      if (!_this.isInitialized) {
        _this._gtag("js", new Date());
        initConfigs.forEach(function (config) {
          var mergedGtagOptions = _objectSpread(_objectSpread(_objectSpread({}, _this._toGtagOptions(_objectSpread(_objectSpread({}, gaOptions), config.gaOptions))), gtagOptions), config.gtagOptions);
          if (Object.keys(mergedGtagOptions).length) {
            _this._gtag("config", config.trackingId, mergedGtagOptions);
          } else {
            _this._gtag("config", config.trackingId);
          }
        });
      }
      _this.isInitialized = true;
      if (!testMode) {
        var queues = _toConsumableArray(_this._queueGtag);
        _this._queueGtag = [];
        _this._isQueuing = false;
        while (queues.length) {
          var queue = queues.shift();
          _this._gtag.apply(_this, _toConsumableArray(queue));
          if (queue[0] === "get") {
            _this._isQueuing = true;
          }
        }
      }
    });
    _defineProperty(this, "set", function (fieldsObject) {
      if (!fieldsObject) {
        console.warn("`fieldsObject` is required in .set()");
        return;
      }
      if (_typeof(fieldsObject) !== "object") {
        console.warn("Expected `fieldsObject` arg to be an Object");
        return;
      }
      if (Object.keys(fieldsObject).length === 0) {
        console.warn("empty `fieldsObject` given to .set()");
      }
      _this._gaCommand("set", fieldsObject);
    });
    _defineProperty(this, "_gaCommandSendEvent", function (eventCategory, eventAction, eventLabel, eventValue, fieldsObject) {
      _this._gtag("event", eventAction, _objectSpread(_objectSpread({
        event_category: eventCategory,
        event_label: eventLabel,
        value: eventValue
      }, fieldsObject && {
        non_interaction: fieldsObject.nonInteraction
      }), _this._toGtagOptions(fieldsObject)));
    });
    _defineProperty(this, "_gaCommandSendEventParameters", function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      if (typeof args[0] === "string") {
        _this._gaCommandSendEvent.apply(_this, _toConsumableArray(args.slice(1)));
      } else {
        var _args$ = args[0],
          eventCategory = _args$.eventCategory,
          eventAction = _args$.eventAction,
          eventLabel = _args$.eventLabel,
          eventValue = _args$.eventValue,
          hitType = _args$.hitType,
          rest = _objectWithoutProperties(_args$, _excluded);
        _this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
      }
    });
    _defineProperty(this, "_gaCommandSendTiming", function (timingCategory, timingVar, timingValue, timingLabel) {
      _this._gtag("event", "timing_complete", {
        name: timingVar,
        value: timingValue,
        event_category: timingCategory,
        event_label: timingLabel
      });
    });
    _defineProperty(this, "_gaCommandSendPageview", function (page, fieldsObject) {
      if (fieldsObject && Object.keys(fieldsObject).length) {
        var _this$_toGtagOptions = _this._toGtagOptions(fieldsObject),
          title = _this$_toGtagOptions.title,
          location = _this$_toGtagOptions.location,
          rest = _objectWithoutProperties(_this$_toGtagOptions, _excluded2);
        _this._gtag("event", "page_view", _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, page && {
          page_path: page
        }), title && {
          page_title: title
        }), location && {
          page_location: location
        }), rest));
      } else if (page) {
        _this._gtag("event", "page_view", {
          page_path: page
        });
      } else {
        _this._gtag("event", "page_view");
      }
    });
    _defineProperty(this, "_gaCommandSendPageviewParameters", function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      if (typeof args[0] === "string") {
        _this._gaCommandSendPageview.apply(_this, _toConsumableArray(args.slice(1)));
      } else {
        var _args$2 = args[0],
          page = _args$2.page,
          hitType = _args$2.hitType,
          rest = _objectWithoutProperties(_args$2, _excluded3);
        _this._gaCommandSendPageview(page, rest);
      }
    });
    _defineProperty(this, "_gaCommandSend", function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      var hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;
      switch (hitType) {
        case "event":
          _this._gaCommandSendEventParameters.apply(_this, args);
          break;
        case "pageview":
          _this._gaCommandSendPageviewParameters.apply(_this, args);
          break;
        case "timing":
          _this._gaCommandSendTiming.apply(_this, _toConsumableArray(args.slice(1)));
          break;
        case "screenview":
        case "transaction":
        case "item":
        case "social":
        case "exception":
          console.warn("Unsupported send command: ".concat(hitType));
          break;
        default:
          console.warn("Send command doesn't exist: ".concat(hitType));
      }
    });
    _defineProperty(this, "_gaCommandSet", function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      if (typeof args[0] === "string") {
        args[0] = _defineProperty({}, args[0], args[1]);
      }
      _this._gtag("set", _this._toGtagOptions(args[0]));
    });
    _defineProperty(this, "_gaCommand", function (command) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }
      switch (command) {
        case "send":
          _this._gaCommandSend.apply(_this, args);
          break;
        case "set":
          _this._gaCommandSet.apply(_this, args);
          break;
        default:
          console.warn("Command doesn't exist: ".concat(command));
      }
    });
    _defineProperty(this, "ga", function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }
      if (typeof args[0] === "string") {
        _this._gaCommand.apply(_this, args);
      } else {
        var readyCallback = args[0];
        _this._gtag("get", _this._currentMeasurementId, "client_id", function (clientId) {
          _this._isQueuing = false;
          var queues = _this._queueGtag;
          readyCallback({
            get: function get(property) {
              return property === "clientId" ? clientId : property === "trackingId" ? _this._currentMeasurementId : property === "apiVersion" ? "1" : undefined;
            }
          });
          while (queues.length) {
            var queue = queues.shift();
            _this._gtag.apply(_this, _toConsumableArray(queue));
          }
        });
        _this._isQueuing = true;
      }
      return _this.ga;
    });
    _defineProperty(this, "event", function (optionsOrName, params) {
      if (typeof optionsOrName === "string") {
        _this._gtag("event", optionsOrName, _this._toGtagOptions(params));
      } else {
        var action = optionsOrName.action,
          category = optionsOrName.category,
          label = optionsOrName.label,
          value = optionsOrName.value,
          nonInteraction = optionsOrName.nonInteraction,
          transport = optionsOrName.transport;
        if (!category || !action) {
          console.warn("args.category AND args.action are required in event()");
          return;
        }

        // Required Fields
        var fieldObject = {
          hitType: "event",
          eventCategory: (0, _format["default"])(category),
          eventAction: (0, _format["default"])(action)
        };

        // Optional Fields
        if (label) {
          fieldObject.eventLabel = (0, _format["default"])(label);
        }
        if (typeof value !== "undefined") {
          if (typeof value !== "number") {
            console.warn("Expected `args.value` arg to be a Number.");
          } else {
            fieldObject.eventValue = value;
          }
        }
        if (typeof nonInteraction !== "undefined") {
          if (typeof nonInteraction !== "boolean") {
            console.warn("`args.nonInteraction` must be a boolean.");
          } else {
            fieldObject.nonInteraction = nonInteraction;
          }
        }
        if (typeof transport !== "undefined") {
          if (typeof transport !== "string") {
            console.warn("`args.transport` must be a string.");
          } else {
            if (["beacon", "xhr", "image"].indexOf(transport) === -1) {
              console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
            }
            fieldObject.transport = transport;
          }
        }
        _this._gaCommand("send", fieldObject);
      }
    });
    _defineProperty(this, "send", function (fieldObject) {
      _this._gaCommand("send", fieldObject);
    });
    this.reset();
  }
  _createClass(GA4, [{
    key: "gtag",
    value: function gtag() {
      this._gtag.apply(this, arguments);
    }
  }]);
  return GA4;
}();
exports.GA4 = GA4;
var _default = new GA4();
exports["default"] = _default;

/***/ }),
/* 3181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var gtag = function gtag() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (typeof window !== "undefined") {
    var _window;
    if (typeof window.gtag === "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
    }
    (_window = window).gtag.apply(_window, args);
  }
};
var _default = gtag;
exports["default"] = _default;

/***/ }),
/* 3182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = I18nextProvider;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__context_js__ = __webpack_require__(289);


function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["useMemo"])(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_1__context_js__["a" /* I18nContext */].Provider, {
    value: value
  }, children);
}

/***/ }),
/* 3183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Trans;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TransWithoutContext_js__ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_js__ = __webpack_require__(289);
/* unused harmony reexport nodesToString */


var _excluded = ["children", "count", "parent", "i18nKey", "context", "tOptions", "values", "defaults", "components", "ns", "i18n", "t", "shouldUnescape"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





function Trans(_ref) {
  var children = _ref.children,
      count = _ref.count,
      parent = _ref.parent,
      i18nKey = _ref.i18nKey,
      context = _ref.context,
      _ref$tOptions = _ref.tOptions,
      tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions,
      values = _ref.values,
      defaults = _ref.defaults,
      components = _ref.components,
      ns = _ref.ns,
      i18nFromProps = _ref.i18n,
      tFromProps = _ref.t,
      shouldUnescape = _ref.shouldUnescape,
      additionalProps = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

  var _ref2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["useContext"])(__WEBPACK_IMPORTED_MODULE_4__context_js__["a" /* I18nContext */]) || {},
      i18nFromContext = _ref2.i18n,
      defaultNSFromContext = _ref2.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__context_js__["d" /* getI18n */])();
  var t = tFromProps || i18n && i18n.t.bind(i18n);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__TransWithoutContext_js__["a" /* Trans */])(_objectSpread({
    children: children,
    count: count,
    parent: parent,
    i18nKey: i18nKey,
    context: context,
    tOptions: tOptions,
    values: values,
    defaults: defaults,
    components: components,
    ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
    i18n: i18n,
    t: tFromProps,
    shouldUnescape: shouldUnescape
  }, additionalProps));
}

/***/ }),
/* 3184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Translation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useTranslation_js__ = __webpack_require__(689);


var _excluded = ["ns", "children"];

function Translation(props) {
  var ns = props.ns,
      children = props.children,
      options = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(props, _excluded);

  var _useTranslation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__useTranslation_js__["a" /* useTranslation */])(ns, options),
      _useTranslation2 = __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_slicedToArray___default()(_useTranslation, 3),
      t = _useTranslation2[0],
      i18n = _useTranslation2[1],
      ready = _useTranslation2[2];

  return children(t, {
    i18n: i18n,
    lng: i18n.language
  }, ready);
}

/***/ }),
/* 3185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return unescape; });
var matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var htmlEntities = {
  '&amp;': '&',
  '&#38;': '&',
  '&lt;': '<',
  '&#60;': '<',
  '&gt;': '>',
  '&#62;': '>',
  '&apos;': "'",
  '&#39;': "'",
  '&quot;': '"',
  '&#34;': '"',
  '&nbsp;': ' ',
  '&#160;': ' ',
  '&copy;': '©',
  '&#169;': '©',
  '&reg;': '®',
  '&#174;': '®',
  '&hellip;': '…',
  '&#8230;': '…',
  '&#x2F;': '/',
  '&#47;': '/'
};

var unescapeHtmlEntity = function unescapeHtmlEntity(m) {
  return htmlEntities[m];
};

var unescape = function unescape(text) {
  return text.replace(matchHtmlEntity, unescapeHtmlEntity);
};

/***/ }),
/* 3186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withSSR;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__useSSR_js__ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__context_js__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_js__ = __webpack_require__(465);


var _excluded = ["initialI18nStore", "initialLanguage"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





function withSSR() {
  return function Extend(WrappedComponent) {
    function I18nextWithSSR(_ref) {
      var initialI18nStore = _ref.initialI18nStore,
          initialLanguage = _ref.initialLanguage,
          rest = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__useSSR_js__["a" /* useSSR */])(initialI18nStore, initialLanguage);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, _objectSpread({}, rest));
    }

    I18nextWithSSR.getInitialProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__context_js__["b" /* composeInitialProps */])(WrappedComponent);
    I18nextWithSSR.displayName = "withI18nextSSR(".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_js__["a" /* getDisplayName */])(WrappedComponent), ")");
    I18nextWithSSR.WrappedComponent = WrappedComponent;
    return I18nextWithSSR;
  };
}

/***/ }),
/* 3187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withTranslation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useTranslation_js__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_js__ = __webpack_require__(465);



var _excluded = ["forwardedRef"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_defineProperty___default()(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }




function withTranslation(ns) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function Extend(WrappedComponent) {
    function I18nextWithTranslation(_ref) {
      var forwardedRef = _ref.forwardedRef,
          rest = __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_objectWithoutProperties___default()(_ref, _excluded);

      var _useTranslation = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__useTranslation_js__["a" /* useTranslation */])(ns, _objectSpread(_objectSpread({}, rest), {}, {
        keyPrefix: options.keyPrefix
      })),
          _useTranslation2 = __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_slicedToArray___default()(_useTranslation, 3),
          t = _useTranslation2[0],
          i18n = _useTranslation2[1],
          ready = _useTranslation2[2];

      var passDownProps = _objectSpread(_objectSpread({}, rest), {}, {
        t: t,
        i18n: i18n,
        tReady: ready
      });

      if (options.withRef && forwardedRef) {
        passDownProps.ref = forwardedRef;
      } else if (!options.withRef && forwardedRef) {
        passDownProps.forwardedRef = forwardedRef;
      }

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(WrappedComponent, passDownProps);
    }

    I18nextWithTranslation.displayName = "withI18nextTranslation(".concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__utils_js__["a" /* getDisplayName */])(WrappedComponent), ")");
    I18nextWithTranslation.WrappedComponent = WrappedComponent;

    var forwardRef = function forwardRef(props, ref) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(I18nextWithTranslation, Object.assign({}, props, {
        forwardedRef: ref
      }));
    };

    return options.withRef ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_react__["forwardRef"])(forwardRef) : I18nextWithTranslation;
  };
}

/***/ }),
/* 3188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function z(a){return y(a)===m}
exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ }),
/* 3189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = Popper;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manager__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__usePopper__ = __webpack_require__(1413);





var NOOP = function NOOP() {
  return void 0;
};

var NOOP_PROMISE = function NOOP_PROMISE() {
  return Promise.resolve(null);
};

var EMPTY_MODIFIERS = [];
function Popper(_ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers,
      referenceElement = _ref.referenceElement,
      onFirstUpdate = _ref.onFirstUpdate,
      innerRef = _ref.innerRef,
      children = _ref.children;
  var referenceNode = __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_1__Manager__["a" /* ManagerReferenceNodeContext */]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](null),
      popperElement = _React$useState[0],
      setPopperElement = _React$useState[1];

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_0_react__["useState"](null),
      arrowElement = _React$useState2[0],
      setArrowElement = _React$useState2[1];

  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* setRef */])(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options = __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    return {
      placement: placement,
      strategy: strategy,
      onFirstUpdate: onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: 'arrow',
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);

  var _usePopper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__usePopper__["a" /* usePopper */])(referenceElement || referenceNode, popperElement, options),
      state = _usePopper.state,
      styles = _usePopper.styles,
      forceUpdate = _usePopper.forceUpdate,
      update = _usePopper.update;

  var childrenProps = __WEBPACK_IMPORTED_MODULE_0_react__["useMemo"](function () {
    return {
      ref: setPopperElement,
      style: styles.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* unwrapArray */])(children)(childrenProps);
}

/***/ }),
/* 3190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Reference */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_warning__ = __webpack_require__(3192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Manager__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(691);




function Reference(_ref) {
  var children = _ref.children,
      innerRef = _ref.innerRef;
  var setReferenceNode = __WEBPACK_IMPORTED_MODULE_0_react__["useContext"](__WEBPACK_IMPORTED_MODULE_2__Manager__["b" /* ManagerReferenceNodeSetterContext */]);
  var refHandler = __WEBPACK_IMPORTED_MODULE_0_react__["useCallback"](function (node) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* setRef */])(innerRef, node);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["e" /* safeInvoke */])(setReferenceNode, node);
  }, [innerRef, setReferenceNode]); // ran on unmount
  // eslint-disable-next-line react-hooks/exhaustive-deps

  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    return function () {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* setRef */])(innerRef, null);
    };
  }, []);
  __WEBPACK_IMPORTED_MODULE_0_react__["useEffect"](function () {
    __WEBPACK_IMPORTED_MODULE_1_warning___default()(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
  }, [setReferenceNode]);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__utils__["b" /* unwrapArray */])(children)({
    ref: refHandler
  });
}

/***/ }),
/* 3191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popper__ = __webpack_require__(3189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Manager__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reference__ = __webpack_require__(3190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__usePopper__ = __webpack_require__(1413);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["a"]; });
/* unused harmony reexport Manager */
/* unused harmony reexport Reference */
/* unused harmony reexport usePopper */
// Public components




 // Public types

/***/ }),
/* 3192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 3193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = undefined;

var _react = __webpack_require__(0);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _storeShape = __webpack_require__(1414);

var _storeShape2 = _interopRequireDefault(_storeShape);

var _warning = __webpack_require__(1415);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var didWarnAboutReceivingStore = false;
function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }
  didWarnAboutReceivingStore = true;

  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

var Provider = function (_Component) {
  _inherits(Provider, _Component);

  Provider.prototype.getChildContext = function getChildContext() {
    return { store: this.store };
  };

  function Provider(props, context) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.store = props.store;
    return _this;
  }

  Provider.prototype.render = function render() {
    return _react.Children.only(this.props.children);
  };

  return Provider;
}(_react.Component);

exports["default"] = Provider;


if (false) {
  Provider.prototype.componentWillReceiveProps = function (nextProps) {
    var store = this.store;
    var nextStore = nextProps.store;


    if (store !== nextStore) {
      warnAboutReceivingStore();
    }
  };
}

Provider.propTypes = {
  store: _storeShape2["default"].isRequired,
  children: _propTypes2["default"].element.isRequired
};
Provider.childContextTypes = {
  store: _storeShape2["default"].isRequired
};

/***/ }),
/* 3194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports["default"] = connect;

var _react = __webpack_require__(0);

var _storeShape = __webpack_require__(1414);

var _storeShape2 = _interopRequireDefault(_storeShape);

var _shallowEqual = __webpack_require__(3195);

var _shallowEqual2 = _interopRequireDefault(_shallowEqual);

var _wrapActionCreators = __webpack_require__(3196);

var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);

var _warning = __webpack_require__(1415);

var _warning2 = _interopRequireDefault(_warning);

var _isPlainObject = __webpack_require__(3097);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _hoistNonReactStatics = __webpack_require__(3015);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _invariant = __webpack_require__(89);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultMapStateToProps = function defaultMapStateToProps(state) {
  return {};
}; // eslint-disable-line no-unused-vars
var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
  return { dispatch: dispatch };
};
var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
  return _extends({}, parentProps, stateProps, dispatchProps);
};

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

var errorObject = { value: null };
function tryCatch(fn, ctx) {
  try {
    return fn.apply(ctx);
  } catch (e) {
    errorObject.value = e;
    return errorObject;
  }
}

// Helps track hot reloading.
var nextVersion = 0;

function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  var shouldSubscribe = Boolean(mapStateToProps);
  var mapState = mapStateToProps || defaultMapStateToProps;

  var mapDispatch = void 0;
  if (typeof mapDispatchToProps === 'function') {
    mapDispatch = mapDispatchToProps;
  } else if (!mapDispatchToProps) {
    mapDispatch = defaultMapDispatchToProps;
  } else {
    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
  }

  var finalMergeProps = mergeProps || defaultMergeProps;
  var _options$pure = options.pure,
      pure = _options$pure === undefined ? true : _options$pure,
      _options$withRef = options.withRef,
      withRef = _options$withRef === undefined ? false : _options$withRef;

  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;

  // Helps track hot reloading.
  var version = nextVersion++;

  return function wrapWithConnect(WrappedComponent) {
    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';

    function checkStateShape(props, methodName) {
      if (!(0, _isPlainObject2["default"])(props)) {
        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
      }
    }

    function computeMergedProps(stateProps, dispatchProps, parentProps) {
      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
      if (false) {
        checkStateShape(mergedProps, 'mergeProps');
      }
      return mergedProps;
    }

    var Connect = function (_Component) {
      _inherits(Connect, _Component);

      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
      };

      function Connect(props, context) {
        _classCallCheck(this, Connect);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

        _this.version = version;
        _this.store = props.store || context.store;

        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));

        var storeState = _this.store.getState();
        _this.state = { storeState: storeState };
        _this.clearCache();
        return _this;
      }

      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
        if (!this.finalMapStateToProps) {
          return this.configureFinalMapState(store, props);
        }

        var state = store.getState();
        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);

        if (false) {
          checkStateShape(stateProps, 'mapStateToProps');
        }
        return stateProps;
      };

      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
        var mappedState = mapState(store.getState(), props);
        var isFactory = typeof mappedState === 'function';

        this.finalMapStateToProps = isFactory ? mappedState : mapState;
        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;

        if (isFactory) {
          return this.computeStateProps(store, props);
        }

        if (false) {
          checkStateShape(mappedState, 'mapStateToProps');
        }
        return mappedState;
      };

      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
        if (!this.finalMapDispatchToProps) {
          return this.configureFinalMapDispatch(store, props);
        }

        var dispatch = store.dispatch;

        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);

        if (false) {
          checkStateShape(dispatchProps, 'mapDispatchToProps');
        }
        return dispatchProps;
      };

      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
        var mappedDispatch = mapDispatch(store.dispatch, props);
        var isFactory = typeof mappedDispatch === 'function';

        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;

        if (isFactory) {
          return this.computeDispatchProps(store, props);
        }

        if (false) {
          checkStateShape(mappedDispatch, 'mapDispatchToProps');
        }
        return mappedDispatch;
      };

      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
        var nextStateProps = this.computeStateProps(this.store, this.props);
        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
          return false;
        }

        this.stateProps = nextStateProps;
        return true;
      };

      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
          return false;
        }

        this.dispatchProps = nextDispatchProps;
        return true;
      };

      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
          return false;
        }

        this.mergedProps = nextMergedProps;
        return true;
      };

      Connect.prototype.isSubscribed = function isSubscribed() {
        return typeof this.unsubscribe === 'function';
      };

      Connect.prototype.trySubscribe = function trySubscribe() {
        if (shouldSubscribe && !this.unsubscribe) {
          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
          this.handleChange();
        }
      };

      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
        if (this.unsubscribe) {
          this.unsubscribe();
          this.unsubscribe = null;
        }
      };

      Connect.prototype.componentDidMount = function componentDidMount() {
        this.trySubscribe();
      };

      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
          this.haveOwnPropsChanged = true;
        }
      };

      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
        this.tryUnsubscribe();
        this.clearCache();
      };

      Connect.prototype.clearCache = function clearCache() {
        this.dispatchProps = null;
        this.stateProps = null;
        this.mergedProps = null;
        this.haveOwnPropsChanged = true;
        this.hasStoreStateChanged = true;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;
        this.renderedElement = null;
        this.finalMapDispatchToProps = null;
        this.finalMapStateToProps = null;
      };

      Connect.prototype.handleChange = function handleChange() {
        if (!this.unsubscribe) {
          return;
        }

        var storeState = this.store.getState();
        var prevStoreState = this.state.storeState;
        if (pure && prevStoreState === storeState) {
          return;
        }

        if (pure && !this.doStatePropsDependOnOwnProps) {
          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
          if (!haveStatePropsChanged) {
            return;
          }
          if (haveStatePropsChanged === errorObject) {
            this.statePropsPrecalculationError = errorObject.value;
          }
          this.haveStatePropsBeenPrecalculated = true;
        }

        this.hasStoreStateChanged = true;
        this.setState({ storeState: storeState });
      };

      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');

        return this.refs.wrappedInstance;
      };

      Connect.prototype.render = function render() {
        var haveOwnPropsChanged = this.haveOwnPropsChanged,
            hasStoreStateChanged = this.hasStoreStateChanged,
            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
            statePropsPrecalculationError = this.statePropsPrecalculationError,
            renderedElement = this.renderedElement;


        this.haveOwnPropsChanged = false;
        this.hasStoreStateChanged = false;
        this.haveStatePropsBeenPrecalculated = false;
        this.statePropsPrecalculationError = null;

        if (statePropsPrecalculationError) {
          throw statePropsPrecalculationError;
        }

        var shouldUpdateStateProps = true;
        var shouldUpdateDispatchProps = true;
        if (pure && renderedElement) {
          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
        }

        var haveStatePropsChanged = false;
        var haveDispatchPropsChanged = false;
        if (haveStatePropsBeenPrecalculated) {
          haveStatePropsChanged = true;
        } else if (shouldUpdateStateProps) {
          haveStatePropsChanged = this.updateStatePropsIfNeeded();
        }
        if (shouldUpdateDispatchProps) {
          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
        }

        var haveMergedPropsChanged = true;
        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
        } else {
          haveMergedPropsChanged = false;
        }

        if (!haveMergedPropsChanged && renderedElement) {
          return renderedElement;
        }

        if (withRef) {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
            ref: 'wrappedInstance'
          }));
        } else {
          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
        }

        return this.renderedElement;
      };

      return Connect;
    }(_react.Component);

    Connect.displayName = connectDisplayName;
    Connect.WrappedComponent = WrappedComponent;
    Connect.contextTypes = {
      store: _storeShape2["default"]
    };
    Connect.propTypes = {
      store: _storeShape2["default"]
    };

    if (false) {
      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
        if (this.version === version) {
          return;
        }

        // We are hot reloading!
        this.version = version;
        this.trySubscribe();
        this.clearCache();
      };
    }

    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
  };
}

/***/ }),
/* 3195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = shallowEqual;
function shallowEqual(objA, objB) {
  if (objA === objB) {
    return true;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  var hasOwn = Object.prototype.hasOwnProperty;
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 3196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports["default"] = wrapActionCreators;

var _redux = __webpack_require__(698);

function wrapActionCreators(actionCreators) {
  return function (dispatch) {
    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
  };
}

/***/ }),
/* 3197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = routerMiddleware;

var _actions = __webpack_require__(1416);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */
function routerMiddleware(history) {
  return function () {
    return function (next) {
      return function (action) {
        if (action.type !== _actions.CALL_HISTORY_METHOD) {
          return next(action);
        }

        var _action$payload = action.payload,
            method = _action$payload.method,
            args = _action$payload.args;

        history[method].apply(history, _toConsumableArray(args));
      };
    };
  };
}

/***/ }),
/* 3198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports['default'] = syncHistoryWithStore;

var _reducer = __webpack_require__(1417);

var defaultSelectLocationState = function defaultSelectLocationState(state) {
  return state.routing;
};

/**
 * This function synchronizes your history state with the Redux store.
 * Location changes flow from history to the store. An enhanced history is
 * returned with a listen method that responds to store updates for location.
 *
 * When this history is provided to the router, this means the location data
 * will flow like this:
 * history.push -> store.dispatch -> enhancedHistory.listen -> router
 * This ensures that when the store state changes due to a replay or other
 * event, the router will be updated appropriately and can transition to the
 * correct router state.
 */
function syncHistoryWithStore(history, store) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref$selectLocationSt = _ref.selectLocationState,
      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;

  // Ensure that the reducer is mounted on the store and functioning properly.
  if (typeof selectLocationState(store.getState()) === 'undefined') {
    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
  }

  var initialLocation = void 0;
  var isTimeTraveling = void 0;
  var unsubscribeFromStore = void 0;
  var unsubscribeFromHistory = void 0;
  var currentLocation = void 0;

  // What does the store say about current location?
  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
    var locationState = selectLocationState(store.getState());
    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
  };

  // Init initialLocation with potential location in store
  initialLocation = getLocationInStore();

  // If the store is replayed, update the URL in the browser to match.
  if (adjustUrlOnReplay) {
    var handleStoreChange = function handleStoreChange() {
      var locationInStore = getLocationInStore(true);
      if (currentLocation === locationInStore || initialLocation === locationInStore) {
        return;
      }

      // Update address bar to reflect store state
      isTimeTraveling = true;
      currentLocation = locationInStore;
      history.transitionTo(_extends({}, locationInStore, {
        action: 'PUSH'
      }));
      isTimeTraveling = false;
    };

    unsubscribeFromStore = store.subscribe(handleStoreChange);
    handleStoreChange();
  }

  // Whenever location changes, dispatch an action to get it in the store
  var handleLocationChange = function handleLocationChange(location) {
    // ... unless we just caused that location change
    if (isTimeTraveling) {
      return;
    }

    // Remember where we are
    currentLocation = location;

    // Are we being called for the first time?
    if (!initialLocation) {
      // Remember as a fallback in case state is reset
      initialLocation = location;

      // Respect persisted location, if any
      if (getLocationInStore()) {
        return;
      }
    }

    // Tell the store to update by dispatching an action
    store.dispatch({
      type: _reducer.LOCATION_CHANGE,
      payload: location
    });
  };
  unsubscribeFromHistory = history.listen(handleLocationChange);

  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
  if (history.getCurrentLocation) {
    handleLocationChange(history.getCurrentLocation());
  }

  // The enhanced history uses store as source of truth
  return _extends({}, history, {
    // The listeners are subscribed to the store instead of history
    listen: function listen(listener) {
      // Copy of last location.
      var lastPublishedLocation = getLocationInStore(true);

      // Keep track of whether we unsubscribed, as Redux store
      // only applies changes in subscriptions on next dispatch
      var unsubscribed = false;
      var unsubscribeFromStore = store.subscribe(function () {
        var currentLocation = getLocationInStore(true);
        if (currentLocation === lastPublishedLocation) {
          return;
        }
        lastPublishedLocation = currentLocation;
        if (!unsubscribed) {
          listener(lastPublishedLocation);
        }
      });

      // History 2.x listeners expect a synchronous call. Make the first call to the
      // listener after subscribing to the store, in case the listener causes a
      // location change (e.g. when it redirects)
      if (!history.getCurrentLocation) {
        listener(lastPublishedLocation);
      }

      // Let user unsubscribe later
      return function () {
        unsubscribed = true;
        unsubscribeFromStore();
      };
    },


    // It also provides a way to destroy internal listeners
    unsubscribe: function unsubscribe() {
      if (adjustUrlOnReplay) {
        unsubscribeFromStore();
      }
      unsubscribeFromHistory();
    }
  });
}

/***/ }),
/* 3199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(1418);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/**
 * An <IndexLink> is used to link to an <IndexRoute>.
 */
var IndexLink = __WEBPACK_IMPORTED_MODULE_1_create_react_class___default()({
  displayName: 'IndexLink',

  render: function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Link__["a" /* default */], _extends({}, this.props, { onlyActiveOnIndex: true }));
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexLink);

/***/ }),
/* 3200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Redirect__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(352);







/**
 * An <IndexRedirect> is used to redirect from an indexRoute.
 */
/* eslint-disable react/require-render-return */
var IndexRedirect = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRedirect',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __WEBPACK_IMPORTED_MODULE_4__Redirect__["a" /* default */].createRouteFromReactElement(element);
      } else {
         false ? warning(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    to: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"].isRequired,
    query: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    state: __WEBPACK_IMPORTED_MODULE_1_prop_types__["object"],
    onEnter: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRedirect);

/***/ }),
/* 3201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(352);







/**
 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
 * a JSX route config.
 */
/* eslint-disable react/require-render-return */
var IndexRoute = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'IndexRoute',

  statics: {
    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
      /* istanbul ignore else: sanity check */
      if (parentRoute) {
        parentRoute.indexRoute = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["c" /* createRouteFromReactElement */])(element);
      } else {
         false ? warning(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
      }
    }
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["c" /* falsy */],
    component: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_3_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (IndexRoute);

/***/ }),
/* 3202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__RouteUtils__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__ = __webpack_require__(352);






/**
 * A <Route> is used to declare which components are rendered to the
 * page when the URL matches a given pattern.
 *
 * Routes are arranged in a nested tree structure. When a new URL is
 * requested, the tree is searched depth-first to find a route whose
 * path matches the URL.  When one is found, all routes in the tree
 * that lead to it are considered "active" and their components are
 * rendered into the DOM, nested in the same order as in the tree.
 */
/* eslint-disable react/require-render-return */
var Route = __WEBPACK_IMPORTED_MODULE_0_create_react_class___default()({
  displayName: 'Route',

  statics: {
    createRouteFromReactElement: __WEBPACK_IMPORTED_MODULE_3__RouteUtils__["c" /* createRouteFromReactElement */]
  },

  propTypes: {
    path: __WEBPACK_IMPORTED_MODULE_1_prop_types__["string"],
    component: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["a" /* component */],
    components: __WEBPACK_IMPORTED_MODULE_4__InternalPropTypes__["b" /* components */],
    getComponent: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"],
    getComponents: __WEBPACK_IMPORTED_MODULE_1_prop_types__["func"]
  },

  /* istanbul ignore next: sanity check */
  render: function render() {
     true ?  false ? invariant(false, '<Route> elements are for router configuration only and should not be rendered') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  }
});

/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 3203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createTransitionManager__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RouterContext__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RouteUtils__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__RouterUtils__ = __webpack_require__(1421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routerWarning__ = __webpack_require__(291);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }













var propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"],
  children: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */],
  routes: __WEBPACK_IMPORTED_MODULE_5__InternalPropTypes__["d" /* routes */], // alias for children
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  createElement: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onError: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],
  onUpdate: __WEBPACK_IMPORTED_MODULE_3_prop_types__["func"],

  // PRIVATE: For client-side rehydration of server match.
  matchContext: __WEBPACK_IMPORTED_MODULE_3_prop_types__["object"]
};

var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== 'undefined';

/**
 * A <Router> is a high-level API for automatically setting up
 * a router that renders a <RouterContext> with all the props
 * it needs each time the URL changes.
 */
var Router = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
  displayName: 'Router',

  propTypes: propTypes,

  getDefaultProps: function getDefaultProps() {
    return {
      render: function render(props) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RouterContext__["a" /* default */], props);
      }
    };
  },
  getInitialState: function getInitialState() {
    return {
      location: null,
      routes: null,
      params: null,
      components: null
    };
  },
  handleError: function handleError(error) {
    if (this.props.onError) {
      this.props.onError.call(this, error);
    } else {
      // Throw errors by default so we don't silently swallow them!
      throw error; // This error probably occurred in getChildRoutes or getComponents.
    }
  },
  createRouterObject: function createRouterObject(state) {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.router;
    }

    var history = this.props.history;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["a" /* createRouterObject */])(history, this.transitionManager, state);
  },
  createTransitionManager: function createTransitionManager() {
    var matchContext = this.props.matchContext;

    if (matchContext) {
      return matchContext.transitionManager;
    }

    var history = this.props.history;
    var _props = this.props,
        routes = _props.routes,
        children = _props.children;


    !history.getCurrentLocation ?  false ? invariant(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__createTransitionManager__["a" /* default */])(history, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__RouteUtils__["a" /* createRoutes */])(routes || children));
  },


  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
  componentWillMount: function componentWillMount() {
    var _this = this;

    this.transitionManager = this.createTransitionManager();
    this.router = this.createRouterObject(this.state);

    this._unlisten = this.transitionManager.listen(function (error, state) {
      if (error) {
        _this.handleError(error);
      } else {
        // Keep the identity of this.router because of a caveat in ContextUtils:
        // they only work if the object identity is preserved.
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__RouterUtils__["b" /* assignRouterState */])(_this.router, state);
        _this.setState(state, _this.props.onUpdate);
      }
    });
  },


  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
  /* istanbul ignore next: sanity check */
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
     false ? warning(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;

     false ? warning((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
  },
  componentWillUnmount: function componentWillUnmount() {
    if (this._unlisten) this._unlisten();
  },
  render: function render() {
    var _state = this.state,
        location = _state.location,
        routes = _state.routes,
        params = _state.params,
        components = _state.components;

    var _props2 = this.props,
        createElement = _props2.createElement,
        render = _props2.render,
        props = _objectWithoutProperties(_props2, ['createElement', 'render']);

    if (location == null) return null; // Async match

    // Only forward non-Router-specific props to routing context, as those are
    // the only ones that might be custom routing context props.
    Object.keys(propTypes).forEach(function (propType) {
      return delete props[propType];
    });

    return render(_extends({}, props, {
      router: this.router,
      location: location,
      routes: routes,
      params: params,
      components: components,
      createElement: createElement
    }));
  }
});

if (prefixUnsafeLifecycleMethods) {
  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
  delete Router.prototype.componentWillReceiveProps;
  delete Router.prototype.componentWillMount;
}

/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 3204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionUtils;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(692);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var PendingHooks = function PendingHooks() {
  var _this = this;

  _classCallCheck(this, PendingHooks);

  this.hooks = [];

  this.add = function (hook) {
    return _this.hooks.push(hook);
  };

  this.remove = function (hook) {
    return _this.hooks = _this.hooks.filter(function (h) {
      return h !== hook;
    });
  };

  this.has = function (hook) {
    return _this.hooks.indexOf(hook) !== -1;
  };

  this.clear = function () {
    return _this.hooks = [];
  };
};

function getTransitionUtils() {
  var enterHooks = new PendingHooks();
  var changeHooks = new PendingHooks();

  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
    var isSync = hook.length < asyncArity;

    var transitionHook = function transitionHook() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      hook.apply(route, args);

      if (isSync) {
        var callback = args[args.length - 1];
        // Assume hook executes synchronously and
        // automatically call the callback.
        callback();
      }
    };

    pendingHooks.add(transitionHook);

    return transitionHook;
  }

  function getEnterHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
      return hooks;
    }, []);
  }

  function getChangeHooks(routes) {
    return routes.reduce(function (hooks, route) {
      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
      return hooks;
    }, []);
  }

  function runTransitionHooks(length, iter, callback) {
    if (!length) {
      callback();
      return;
    }

    var redirectInfo = void 0;
    function replace(location) {
      redirectInfo = location;
    }

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(length, function (index, next, done) {
      iter(index, replace, function (error) {
        if (error || redirectInfo) {
          done(error, redirectInfo); // No need to continue.
        } else {
          next();
        }
      });
    }, callback);
  }

  /**
   * Runs all onEnter hooks in the given array of routes in order
   * with onEnter(nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runEnterHooks(routes, nextState, callback) {
    enterHooks.clear();
    var hooks = getEnterHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (enterHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          enterHooks.remove(hooks[index]);
        }
      };
      hooks[index](nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onChange hooks in the given array of routes in order
   * with onChange(prevState, nextState, replace, callback) and calls
   * callback(error, redirectInfo) when finished. The first hook
   * to use replace short-circuits the loop.
   *
   * If a hook needs to run asynchronously, it may use the callback
   * function. However, doing so will cause the transition to pause,
   * which could lead to a non-responsive UI if the hook is slow.
   */
  function runChangeHooks(routes, state, nextState, callback) {
    changeHooks.clear();
    var hooks = getChangeHooks(routes);
    return runTransitionHooks(hooks.length, function (index, replace, next) {
      var wrappedNext = function wrappedNext() {
        if (changeHooks.has(hooks[index])) {
          next.apply(undefined, arguments);
          changeHooks.remove(hooks[index]);
        }
      };
      hooks[index](state, nextState, replace, wrappedNext);
    }, callback);
  }

  /**
   * Runs all onLeave hooks in the given array of routes in order.
   */
  function runLeaveHooks(routes, prevState) {
    for (var i = 0, len = routes.length; i < len; ++i) {
      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
    }
  }

  return {
    runEnterHooks: runEnterHooks,
    runChangeHooks: runChangeHooks,
    runLeaveHooks: runLeaveHooks
  };
}

/***/ }),
/* 3205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RouterContext__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routerWarning__ = __webpack_require__(291);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





/* harmony default export */ __webpack_exports__["a"] = (function () {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  if (false) {
    middlewares.forEach(function (middleware, index) {
      process.env.NODE_ENV !== 'production' ? warning(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
    });
  }

  var withContext = middlewares.map(function (middleware) {
    return middleware.renderRouterContext;
  }).filter(Boolean);
  var withComponent = middlewares.map(function (middleware) {
    return middleware.renderRouteComponent;
  }).filter(Boolean);

  var makeCreateElement = function makeCreateElement() {
    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : __WEBPACK_IMPORTED_MODULE_0_react__["createElement"];
    return function (Component, props) {
      return withComponent.reduceRight(function (previous, renderRouteComponent) {
        return renderRouteComponent(previous, props);
      }, baseCreateElement(Component, props));
    };
  };

  return function (renderProps) {
    return withContext.reduceRight(function (previous, renderRouterContext) {
      return renderRouterContext(previous, renderProps);
    }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__RouterContext__["a" /* default */], _extends({}, renderProps, {
      createElement: makeCreateElement(renderProps.createElement)
    })));
  };
});

/***/ }),
/* 3206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__ = __webpack_require__(3011);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(1423);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createBrowserHistory___default.a));

/***/ }),
/* 3207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(290);


function routeParamsChanged(route, prevState, nextState) {
  if (!route.path) return false;

  var paramNames = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path);

  return paramNames.some(function (paramName) {
    return prevState.params[paramName] !== nextState.params[paramName];
  });
}

/**
 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
 * the change from prevState to nextState. We leave routes if either
 * 1) they are not in the next state or 2) they are in the next state
 * but their params have changed (i.e. /users/123 => /users/456).
 *
 * leaveRoutes are ordered starting at the leaf route of the tree
 * we're leaving up to the common parent route. enterRoutes are ordered
 * from the top of the tree we're entering down to the leaf route.
 *
 * changeRoutes are any routes that didn't leave or enter during
 * the transition.
 */
function computeChangedRoutes(prevState, nextState) {
  var prevRoutes = prevState && prevState.routes;
  var nextRoutes = nextState.routes;

  var leaveRoutes = void 0,
      changeRoutes = void 0,
      enterRoutes = void 0;
  if (prevRoutes) {
    var parentIsLeaving = false;
    leaveRoutes = prevRoutes.filter(function (route) {
      if (parentIsLeaving) {
        return true;
      } else {
        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
        if (isLeaving) parentIsLeaving = true;
        return isLeaving;
      }
    });

    // onLeave hooks start at the leaf route.
    leaveRoutes.reverse();

    enterRoutes = [];
    changeRoutes = [];

    nextRoutes.forEach(function (route) {
      var isNew = prevRoutes.indexOf(route) === -1;
      var paramsChanged = leaveRoutes.indexOf(route) !== -1;

      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
    });
  } else {
    leaveRoutes = [];
    changeRoutes = [];
    enterRoutes = nextRoutes;
  }

  return {
    leaveRoutes: leaveRoutes,
    changeRoutes: changeRoutes,
    enterRoutes: enterRoutes
  };
}

/* harmony default export */ __webpack_exports__["a"] = (computeChangedRoutes);

/***/ }),
/* 3208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(1419);



function getComponentsForRoute(nextState, route, callback) {
  if (route.component || route.components) {
    callback(null, route.component || route.components);
    return;
  }

  var getComponent = route.getComponent || route.getComponents;
  if (getComponent) {
    var componentReturn = getComponent.call(route, nextState, callback);
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(componentReturn)) componentReturn.then(function (component) {
      return callback(null, component);
    }, callback);
  } else {
    callback();
  }
}

/**
 * Asynchronously fetches all components needed for the given router
 * state and calls callback(error, components) when finished.
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getComponents method.
 */
function getComponents(nextState, callback) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["a" /* mapAsync */])(nextState.routes, function (route, index, callback) {
    getComponentsForRoute(nextState, route, callback);
  }, callback);
}

/* harmony default export */ __webpack_exports__["a"] = (getComponents);

/***/ }),
/* 3209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(290);


/**
 * Extracts an object of params the given route cares about from
 * the given params object.
 */
function getRouteParams(route, params) {
  var routeParams = {};

  if (!route.path) return routeParams;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["b" /* getParamNames */])(route.path).forEach(function (p) {
    if (Object.prototype.hasOwnProperty.call(params, p)) {
      routeParams[p] = params[p];
    }
  });

  return routeParams;
}

/* harmony default export */ __webpack_exports__["a"] = (getRouteParams);

/***/ }),
/* 3210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__ = __webpack_require__(3012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createRouterHistory__ = __webpack_require__(1423);


/* harmony default export */ __webpack_exports__["a"] = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createRouterHistory__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_history_lib_createHashHistory___default.a));

/***/ }),
/* 3211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isActive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PatternUtils__ = __webpack_require__(290);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



function deepEqual(a, b) {
  if (a == b) return true;

  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
      return deepEqual(item, b[index]);
    });
  }

  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
    for (var p in a) {
      if (!Object.prototype.hasOwnProperty.call(a, p)) {
        continue;
      }

      if (a[p] === undefined) {
        if (b[p] !== undefined) {
          return false;
        }
      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
        return false;
      } else if (!deepEqual(a[p], b[p])) {
        return false;
      }
    }

    return true;
  }

  return String(a) === String(b);
}

/**
 * Returns true if the current pathname matches the supplied one, net of
 * leading and trailing slash normalization. This is sufficient for an
 * indexOnly route match.
 */
function pathIsActive(pathname, currentPathname) {
  // Normalize leading slash for consistency. Leading slash on pathname has
  // already been normalized in isActive. See caveat there.
  if (currentPathname.charAt(0) !== '/') {
    currentPathname = '/' + currentPathname;
  }

  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
  // `/foo` as active, but in this case, we would already have failed the
  // match.
  if (pathname.charAt(pathname.length - 1) !== '/') {
    pathname += '/';
  }
  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
    currentPathname += '/';
  }

  return currentPathname === pathname;
}

/**
 * Returns true if the given pathname matches the active routes and params.
 */
function routeIsActive(pathname, routes, params) {
  var remainingPathname = pathname,
      paramNames = [],
      paramValues = [];

  // for...of would work here but it's probably slower post-transpilation.
  for (var i = 0, len = routes.length; i < len; ++i) {
    var route = routes[i];
    var pattern = route.path || '';

    if (pattern.charAt(0) === '/') {
      remainingPathname = pathname;
      paramNames = [];
      paramValues = [];
    }

    if (remainingPathname !== null && pattern) {
      var matched = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }

      if (remainingPathname === '') {
        // We have an exact match on the route. Just check that all the params
        // match.
        // FIXME: This doesn't work on repeated params.
        return paramNames.every(function (paramName, index) {
          return String(paramValues[index]) === String(params[paramName]);
        });
      }
    }
  }

  return false;
}

/**
 * Returns true if all key/value pairs in the given query are
 * currently active.
 */
function queryIsActive(query, activeQuery) {
  if (activeQuery == null) return query == null;

  if (query == null) return true;

  return deepEqual(query, activeQuery);
}

/**
 * Returns true if a <Link> to the given pathname/query combination is
 * currently active.
 */
function isActive(_ref, indexOnly, currentLocation, routes, params) {
  var pathname = _ref.pathname,
      query = _ref.query;

  if (currentLocation == null) return false;

  // TODO: This is a bit ugly. It keeps around support for treating pathnames
  // without preceding slashes as absolute paths, but possibly also works
  // around the same quirks with basenames as in matchRoutes.
  if (pathname.charAt(0) !== '/') {
    pathname = '/' + pathname;
  }

  if (!pathIsActive(pathname, currentLocation.pathname)) {
    // The path check is necessary and sufficient for indexOnly, but otherwise
    // we still need to check the routes.
    if (indexOnly || !routeIsActive(pathname, routes, params)) {
      return false;
    }
  }

  return queryIsActive(query, currentLocation.query);
}

/***/ }),
/* 3212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createTransitionManager__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RouterUtils__ = __webpack_require__(1421);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }









/**
 * A high-level API to be used for server-side rendering.
 *
 * This function matches a location to a set of routes and calls
 * callback(error, redirectLocation, renderProps) when finished.
 *
 * Note: You probably don't want to use this in a browser unless you're using
 * server-side rendering with async routes.
 */
function match(_ref, callback) {
  var history = _ref.history,
      routes = _ref.routes,
      location = _ref.location,
      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);

  !(history || location) ?  false ? invariant(false, 'match needs a history or a location') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  history = history ? history : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__createMemoryHistory__["a" /* default */])(options);
  var transitionManager = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__createTransitionManager__["a" /* default */])(history, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(routes));

  if (location) {
    // Allow match({ location: '/the/path', ... })
    location = history.createLocation(location);
  } else {
    location = history.getCurrentLocation();
  }

  transitionManager.match(location, function (error, redirectLocation, nextState) {
    var renderProps = void 0;

    if (nextState) {
      var router = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__RouterUtils__["a" /* createRouterObject */])(history, transitionManager, nextState);
      renderProps = _extends({}, nextState, {
        router: router,
        matchContext: { transitionManager: transitionManager, router: router }
      });
    }

    callback(error, redirectLocation && history.createLocation(redirectLocation, __WEBPACK_IMPORTED_MODULE_0_history_lib_Actions__["REPLACE"]), renderProps);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (match);

/***/ }),
/* 3213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = matchRoutes;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AsyncUtils__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PromiseUtils__ = __webpack_require__(1419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PatternUtils__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routerWarning__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__RouteUtils__ = __webpack_require__(207);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };







function getChildRoutes(route, location, paramNames, paramValues, callback) {
  if (route.childRoutes) {
    return [null, route.childRoutes];
  }
  if (!route.getChildRoutes) {
    return [];
  }

  var sync = true,
      result = void 0;

  var partialNextState = {
    location: location,
    params: createParams(paramNames, paramValues)
  };

  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
    childRoutes = !error && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(childRoutes);
    if (sync) {
      result = [error, childRoutes];
      return;
    }

    callback(error, childRoutes);
  });

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
    return callback(null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(childRoutes));
  }, callback);

  sync = false;
  return result; // Might be undefined.
}

function getIndexRoute(route, location, paramNames, paramValues, callback) {
  if (route.indexRoute) {
    callback(null, route.indexRoute);
  } else if (route.getIndexRoute) {
    var partialNextState = {
      location: location,
      params: createParams(paramNames, paramValues)
    };

    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
      callback(error, !error && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(indexRoute)[0]);
    });

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__PromiseUtils__["a" /* isPromise */])(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
      return callback(null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__RouteUtils__["a" /* createRoutes */])(indexRoute)[0]);
    }, callback);
  } else if (route.childRoutes || route.getChildRoutes) {
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
        return;
      }

      var pathless = childRoutes.filter(function (childRoute) {
        return !childRoute.path;
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(pathless.length, function (index, next, done) {
        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
          if (error || indexRoute) {
            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
            done(error, routes);
          } else {
            next();
          }
        });
      }, function (err, routes) {
        callback(null, routes);
      });
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

function assignParams(params, paramNames, paramValues) {
  return paramNames.reduce(function (params, paramName, index) {
    var paramValue = paramValues && paramValues[index];

    if (Array.isArray(params[paramName])) {
      params[paramName].push(paramValue);
    } else if (paramName in params) {
      params[paramName] = [params[paramName], paramValue];
    } else {
      params[paramName] = paramValue;
    }

    return params;
  }, params);
}

function createParams(paramNames, paramValues) {
  return assignParams({}, paramNames, paramValues);
}

function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
  var pattern = route.path || '';

  if (pattern.charAt(0) === '/') {
    remainingPathname = location.pathname;
    paramNames = [];
    paramValues = [];
  }

  // Only try to match the path if the route actually has a pattern, and if
  // we're not just searching for potential nested absolute paths.
  if (remainingPathname !== null && pattern) {
    try {
      var matched = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__PatternUtils__["c" /* matchPattern */])(pattern, remainingPathname);
      if (matched) {
        remainingPathname = matched.remainingPathname;
        paramNames = [].concat(paramNames, matched.paramNames);
        paramValues = [].concat(paramValues, matched.paramValues);
      } else {
        remainingPathname = null;
      }
    } catch (error) {
      callback(error);
    }

    // By assumption, pattern is non-empty here, which is the prerequisite for
    // actually terminating a match.
    if (remainingPathname === '') {
      var match = {
        routes: [route],
        params: createParams(paramNames, paramValues)
      };

      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
        if (error) {
          callback(error);
        } else {
          if (Array.isArray(indexRoute)) {
            var _match$routes;

             false ? warning(indexRoute.every(function (route) {
              return !route.path;
            }), 'Index routes should not have paths') : void 0;
            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
          } else if (indexRoute) {
             false ? warning(!indexRoute.path, 'Index routes should not have paths') : void 0;
            match.routes.push(indexRoute);
          }

          callback(null, match);
        }
      });

      return;
    }
  }

  if (remainingPathname != null || route.childRoutes) {
    // Either a) this route matched at least some of the path or b)
    // we don't have to load this route's children asynchronously. In
    // either case continue checking for matches in the subtree.
    var onChildRoutes = function onChildRoutes(error, childRoutes) {
      if (error) {
        callback(error);
      } else if (childRoutes) {
        // Check the child routes to see if any of them match.
        matchRoutes(childRoutes, location, function (error, match) {
          if (error) {
            callback(error);
          } else if (match) {
            // A child route matched! Augment the match and pass it up the stack.
            match.routes.unshift(route);
            callback(null, match);
          } else {
            callback();
          }
        }, remainingPathname, paramNames, paramValues);
      } else {
        callback();
      }
    };

    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
    if (result) {
      onChildRoutes.apply(undefined, result);
    }
  } else {
    callback();
  }
}

/**
 * Asynchronously matches the given location to a set of routes and calls
 * callback(error, state) when finished. The state object will have the
 * following properties:
 *
 * - routes       An array of routes that matched, in hierarchical order
 * - params       An object of URL parameters
 *
 * Note: This operation may finish synchronously if no routes have an
 * asynchronous getChildRoutes method.
 */
function matchRoutes(routes, location, callback, remainingPathname) {
  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (remainingPathname === undefined) {
    // TODO: This is a little bit ugly, but it works around a quirk in history
    // that strips the leading slash from pathnames when using basenames with
    // trailing slashes.
    if (location.pathname.charAt(0) !== '/') {
      location = _extends({}, location, {
        pathname: '/' + location.pathname
      });
    }
    remainingPathname = location.pathname;
  }

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__AsyncUtils__["b" /* loopAsync */])(routes.length, function (index, next, done) {
    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
      if (error || match) {
        done(error, match);
      } else {
        next();
      }
    });
  }, callback);
}

/***/ }),
/* 3214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withRouter;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_create_react_class___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_create_react_class__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__ = __webpack_require__(3216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ContextUtils__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PropTypes__ = __webpack_require__(694);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };








function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
}

function withRouter(WrappedComponent, options) {
  var withRef = options && options.withRef;

  var WithRouter = __WEBPACK_IMPORTED_MODULE_2_create_react_class___default()({
    displayName: 'WithRouter',

    mixins: [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__ContextUtils__["b" /* ContextSubscriber */])('router')],

    contextTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },
    propTypes: { router: __WEBPACK_IMPORTED_MODULE_5__PropTypes__["b" /* routerShape */] },

    getWrappedInstance: function getWrappedInstance() {
      !withRef ?  false ? invariant(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : __WEBPACK_IMPORTED_MODULE_0_invariant___default()(false) : void 0;

      return this.wrappedInstance;
    },
    render: function render() {
      var _this = this;

      var router = this.props.router || this.context.router;
      if (!router) {
        return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, this.props);
      }

      var params = router.params,
          location = router.location,
          routes = router.routes;

      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });

      if (withRef) {
        props.ref = function (c) {
          _this.wrappedInstance = c;
        };
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(WrappedComponent, props);
    }
  });

  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
  WithRouter.WrappedComponent = WrappedComponent;

  return __WEBPACK_IMPORTED_MODULE_3_hoist_non_react_statics___default()(WithRouter, WrappedComponent);
}

/***/ }),
/* 3215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.compilePattern = compilePattern;
exports.matchPattern = matchPattern;
exports.getParamNames = getParamNames;
exports.getParams = getParams;
exports.formatPattern = formatPattern;

var _invariant = __webpack_require__(89);

var _invariant2 = _interopRequireDefault(_invariant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function _compilePattern(pattern) {
  var regexpSource = '';
  var paramNames = [];
  var tokens = [];

  var match = void 0,
      lastIndex = 0,
      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
  while (match = matcher.exec(pattern)) {
    if (match.index !== lastIndex) {
      tokens.push(pattern.slice(lastIndex, match.index));
      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
    }

    if (match[1]) {
      regexpSource += '([^/]+)';
      paramNames.push(match[1]);
    } else if (match[0] === '**') {
      regexpSource += '(.*)';
      paramNames.push('splat');
    } else if (match[0] === '*') {
      regexpSource += '(.*?)';
      paramNames.push('splat');
    } else if (match[0] === '(') {
      regexpSource += '(?:';
    } else if (match[0] === ')') {
      regexpSource += ')?';
    } else if (match[0] === '\\(') {
      regexpSource += '\\(';
    } else if (match[0] === '\\)') {
      regexpSource += '\\)';
    }

    tokens.push(match[0]);

    lastIndex = matcher.lastIndex;
  }

  if (lastIndex !== pattern.length) {
    tokens.push(pattern.slice(lastIndex, pattern.length));
    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
  }

  return {
    pattern: pattern,
    regexpSource: regexpSource,
    paramNames: paramNames,
    tokens: tokens
  };
}

var CompiledPatternsCache = Object.create(null);

function compilePattern(pattern) {
  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);

  return CompiledPatternsCache[pattern];
}

/**
 * Attempts to match a pattern on the given pathname. Patterns may use
 * the following special characters:
 *
 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
 *                  captured string is considered a "param"
 * - ()             Wraps a segment of the URL that is optional
 * - *              Consumes (non-greedy) all characters up to the next
 *                  character in the pattern, or to the end of the URL if
 *                  there is none
 * - **             Consumes (greedy) all characters up to the next character
 *                  in the pattern, or to the end of the URL if there is none
 *
 *  The function calls callback(error, matched) when finished.
 * The return value is an object with the following properties:
 *
 * - remainingPathname
 * - paramNames
 * - paramValues
 */
function matchPattern(pattern, pathname) {
  // Ensure pattern starts with leading slash for consistency with pathname.
  if (pattern.charAt(0) !== '/') {
    pattern = '/' + pattern;
  }

  var _compilePattern2 = compilePattern(pattern),
      regexpSource = _compilePattern2.regexpSource,
      paramNames = _compilePattern2.paramNames,
      tokens = _compilePattern2.tokens;

  if (pattern.charAt(pattern.length - 1) !== '/') {
    regexpSource += '/?'; // Allow optional path separator at end.
  }

  // Special-case patterns like '*' for catch-all routes.
  if (tokens[tokens.length - 1] === '*') {
    regexpSource += '$';
  }

  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
  if (match == null) {
    return null;
  }

  var matchedPath = match[0];
  var remainingPathname = pathname.substr(matchedPath.length);

  if (remainingPathname) {
    // Require that the match ends at a path separator, if we didn't match
    // the full path, so any remaining pathname is a new path segment.
    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
      return null;
    }

    // If there is a remaining pathname, treat the path separator as part of
    // the remaining pathname for properly continuing the match.
    remainingPathname = '/' + remainingPathname;
  }

  return {
    remainingPathname: remainingPathname,
    paramNames: paramNames,
    paramValues: match.slice(1).map(function (v) {
      return v && decodeURIComponent(v);
    })
  };
}

function getParamNames(pattern) {
  return compilePattern(pattern).paramNames;
}

function getParams(pattern, pathname) {
  var match = matchPattern(pattern, pathname);
  if (!match) {
    return null;
  }

  var paramNames = match.paramNames,
      paramValues = match.paramValues;

  var params = {};

  paramNames.forEach(function (paramName, index) {
    params[paramName] = paramValues[index];
  });

  return params;
}

/**
 * Returns a version of the given pattern with params interpolated. Throws
 * if there is a dynamic segment of the pattern for which there is no param.
 */
function formatPattern(pattern, params) {
  params = params || {};

  var _compilePattern3 = compilePattern(pattern),
      tokens = _compilePattern3.tokens;

  var parenCount = 0,
      pathname = '',
      splatIndex = 0,
      parenHistory = [];

  var token = void 0,
      paramName = void 0,
      paramValue = void 0;
  for (var i = 0, len = tokens.length; i < len; ++i) {
    token = tokens[i];

    if (token === '*' || token === '**') {
      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;

      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue != null) pathname += encodeURI(paramValue);
    } else if (token === '(') {
      parenHistory[parenCount] = '';
      parenCount += 1;
    } else if (token === ')') {
      var parenText = parenHistory.pop();
      parenCount -= 1;

      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
    } else if (token === '\\(') {
      pathname += '(';
    } else if (token === '\\)') {
      pathname += ')';
    } else if (token.charAt(0) === ':') {
      paramName = token.substring(1);
      paramValue = params[paramName];

      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;

      if (paramValue == null) {
        if (parenCount) {
          parenHistory[parenCount - 1] = '';

          var curTokenIdx = tokens.indexOf(token);
          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
          var nextParenIdx = -1;

          for (var _i = 0; _i < tokensSubset.length; _i++) {
            if (tokensSubset[_i] == ')') {
              nextParenIdx = _i;
              break;
            }
          }

          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;

          // jump to ending paren
          i = curTokenIdx + nextParenIdx - 1;
        }
      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
    } else {
      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
    }
  }

  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;

  return pathname.replace(/\/+/g, '/');
}

/***/ }),
/* 3216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 3217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.9.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(121),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.suspense_list"):60120,ba=n?Symbol.for("react.memo"):
60115,ca=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");var z="function"===typeof Symbol&&Symbol.iterator;
function A(a){for(var b=a.message,d="https://reactjs.org/docs/error-decoder.html?invariant="+b,c=1;c<arguments.length;c++)d+="&args[]="+encodeURIComponent(arguments[c]);a.message="Minified React error #"+b+"; visit "+d+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ";return a}var B={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},C={};
function D(a,b,d){this.props=a;this.context=b;this.refs=C;this.updater=d||B}D.prototype.isReactComponent={};D.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw A(Error(85));this.updater.enqueueSetState(this,a,b,"setState")};D.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function E(){}E.prototype=D.prototype;function F(a,b,d){this.props=a;this.context=b;this.refs=C;this.updater=d||B}var G=F.prototype=new E;
G.constructor=F;h(G,D.prototype);G.isPureReactComponent=!0;var H={current:null},I={suspense:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,d){var c=void 0,e={},g=null,k=null;if(null!=b)for(c in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:k,props:e,_owner:J.current}}
function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){e=a[k];var f=b+T(e,k);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=z&&a[z]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(e=a.next()).done;)e=e.value,f=b+T(e,k++),g+=S(e,f,d,c);else if("object"===e)throw d=""+a,A(Error(31),"[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,"");return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=H.current;if(null===a)throw A(Error(321));return a}
var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw A(Error(143));return a}},createRef:function(){return{current:null}},Component:D,PureComponent:F,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:ca,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:ba,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,unstable_SuspenseList:aa,createElement:M,cloneElement:function(a,b,d){if(null===a||void 0===a)throw A(Error(267),a);var c=void 0,e=
h({},a.props),g=a.key,k=a.ref,f=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:k,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);
b.type=a;return b},isValidElement:N,version:"16.9.0",unstable_withSuspenseConfig:function(a,b){var d=I.suspense;I.suspense=void 0===b?null:b;try{a()}finally{I.suspense=d}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:H,ReactCurrentBatchConfig:I,ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 3218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(248);


/***/ }),
/* 3219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.



module.exports = PassThrough;

var Transform = __webpack_require__(1427);

/*<replacement>*/
var util = __webpack_require__(335);
util.inherits = __webpack_require__(41);
/*</replacement>*/

util.inherits(PassThrough, Transform);

function PassThrough(options) {
  if (!(this instanceof PassThrough)) return new PassThrough(options);

  Transform.call(this, options);
}

PassThrough.prototype._transform = function (chunk, encoding, cb) {
  cb(null, chunk);
};

/***/ }),
/* 3220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Buffer = __webpack_require__(42).Buffer;
var util = __webpack_require__(3564);

function copyBuffer(src, target, offset) {
  src.copy(target, offset);
}

module.exports = function () {
  function BufferList() {
    _classCallCheck(this, BufferList);

    this.head = null;
    this.tail = null;
    this.length = 0;
  }

  BufferList.prototype.push = function push(v) {
    var entry = { data: v, next: null };
    if (this.length > 0) this.tail.next = entry;else this.head = entry;
    this.tail = entry;
    ++this.length;
  };

  BufferList.prototype.unshift = function unshift(v) {
    var entry = { data: v, next: this.head };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
  };

  BufferList.prototype.shift = function shift() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
    --this.length;
    return ret;
  };

  BufferList.prototype.clear = function clear() {
    this.head = this.tail = null;
    this.length = 0;
  };

  BufferList.prototype.join = function join(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while (p = p.next) {
      ret += s + p.data;
    }return ret;
  };

  BufferList.prototype.concat = function concat(n) {
    if (this.length === 0) return Buffer.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = Buffer.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while (p) {
      copyBuffer(p.data, ret, i);
      i += p.data.length;
      p = p.next;
    }
    return ret;
  };

  return BufferList;
}();

if (util && util.inspect && util.inspect.custom) {
  module.exports.prototype[util.inspect.custom] = function () {
    var obj = util.inspect({ length: this.length });
    return this.constructor.name + ' ' + obj;
  };
}

/***/ }),
/* 3221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(697).PassThrough


/***/ }),
/* 3222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(697).Transform


/***/ }),
/* 3223 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(696);


/***/ }),
/* 3224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["default"] = (thunk);

/***/ }),
/* 3225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(1430);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 3226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 3227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(1248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(1432);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["b" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 3228 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright (c) 2014, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
 * additional grant of patent rights can be found in the PATENTS file in
 * the same directory.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    if (typeof global.process === "object" && global.process.domain) {
      invoke = global.process.domain.bind(invoke);
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // Among the various tricks for obtaining a reference to the global
  // object, this seems to be the most reliable technique that does not
  // use indirect eval (which violates Content Security Policy).
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this
);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 3229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Remarkable; });
/* unused harmony export utils */
var textarea;

function decodeEntity(name) {
  textarea = textarea || document.createElement('textarea');
  textarea.innerHTML = '&' + name + ';';
  return textarea.value;
}

/**
 * Utility functions
 */

function typeOf(obj) {
  return Object.prototype.toString.call(obj);
}

function isString(obj) {
  return typeOf(obj) === '[object String]';
}

var hasOwn = Object.prototype.hasOwnProperty;

function has(object, key) {
  return object
    ? hasOwn.call(object, key)
    : false;
}

// Extend objects
//
function assign(obj /*from1, from2, from3, ...*/) {
  var sources = [].slice.call(arguments, 1);

  sources.forEach(function (source) {
    if (!source) { return; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be object');
    }

    Object.keys(source).forEach(function (key) {
      obj[key] = source[key];
    });
  });

  return obj;
}

////////////////////////////////////////////////////////////////////////////////

var UNESCAPE_MD_RE = /\\([\\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;

function unescapeMd(str) {
  if (str.indexOf('\\') < 0) { return str; }
  return str.replace(UNESCAPE_MD_RE, '$1');
}

////////////////////////////////////////////////////////////////////////////////

function isValidEntityCode(c) {
  /*eslint no-bitwise:0*/
  // broken sequence
  if (c >= 0xD800 && c <= 0xDFFF) { return false; }
  // never used
  if (c >= 0xFDD0 && c <= 0xFDEF) { return false; }
  if ((c & 0xFFFF) === 0xFFFF || (c & 0xFFFF) === 0xFFFE) { return false; }
  // control codes
  if (c >= 0x00 && c <= 0x08) { return false; }
  if (c === 0x0B) { return false; }
  if (c >= 0x0E && c <= 0x1F) { return false; }
  if (c >= 0x7F && c <= 0x9F) { return false; }
  // out of range
  if (c > 0x10FFFF) { return false; }
  return true;
}

function fromCodePoint(c) {
  /*eslint no-bitwise:0*/
  if (c > 0xffff) {
    c -= 0x10000;
    var surrogate1 = 0xd800 + (c >> 10),
        surrogate2 = 0xdc00 + (c & 0x3ff);

    return String.fromCharCode(surrogate1, surrogate2);
  }
  return String.fromCharCode(c);
}

var NAMED_ENTITY_RE   = /&([a-z#][a-z0-9]{1,31});/gi;
var DIGITAL_ENTITY_TEST_RE = /^#((?:x[a-f0-9]{1,8}|[0-9]{1,8}))/i;

function replaceEntityPattern(match, name) {
  var code = 0;
  var decoded = decodeEntity(name);

  if (name !== decoded) {
    return decoded;
  } else if (name.charCodeAt(0) === 0x23/* # */ && DIGITAL_ENTITY_TEST_RE.test(name)) {
    code = name[1].toLowerCase() === 'x' ?
      parseInt(name.slice(2), 16)
    :
      parseInt(name.slice(1), 10);
    if (isValidEntityCode(code)) {
      return fromCodePoint(code);
    }
  }
  return match;
}

function replaceEntities(str) {
  if (str.indexOf('&') < 0) { return str; }

  return str.replace(NAMED_ENTITY_RE, replaceEntityPattern);
}

////////////////////////////////////////////////////////////////////////////////

var HTML_ESCAPE_TEST_RE = /[&<>"]/;
var HTML_ESCAPE_REPLACE_RE = /[&<>"]/g;
var HTML_REPLACEMENTS = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;'
};

function replaceUnsafeChar(ch) {
  return HTML_REPLACEMENTS[ch];
}

function escapeHtml(str) {
  if (HTML_ESCAPE_TEST_RE.test(str)) {
    return str.replace(HTML_ESCAPE_REPLACE_RE, replaceUnsafeChar);
  }
  return str;
}

var utils = /*#__PURE__*/Object.freeze({
  isString: isString,
  has: has,
  assign: assign,
  unescapeMd: unescapeMd,
  isValidEntityCode: isValidEntityCode,
  fromCodePoint: fromCodePoint,
  replaceEntities: replaceEntities,
  escapeHtml: escapeHtml
});

/**
 * Renderer rules cache
 */

var rules = {};

/**
 * Blockquotes
 */

rules.blockquote_open = function(/* tokens, idx, options, env */) {
  return '<blockquote>\n';
};

rules.blockquote_close = function(tokens, idx /*, options, env */) {
  return '</blockquote>' + getBreak(tokens, idx);
};

/**
 * Code
 */

rules.code = function(tokens, idx /*, options, env */) {
  if (tokens[idx].block) {
    return '<pre><code>' + escapeHtml(tokens[idx].content) + '</code></pre>' + getBreak(tokens, idx);
  }
  return '<code>' + escapeHtml(tokens[idx].content) + '</code>';
};

/**
 * Fenced code blocks
 */

rules.fence = function(tokens, idx, options, env, instance) {
  var token = tokens[idx];
  var langClass = '';
  var langPrefix = options.langPrefix;
  var langName = '', fences, fenceName;
  var highlighted;

  if (token.params) {

    //
    // ```foo bar
    //
    // Try custom renderer "foo" first. That will simplify overwrite
    // for diagrams, latex, and any other fenced block with custom look
    //

    fences = token.params.split(/\s+/g);
    fenceName = fences.join(' ');

    if (has(instance.rules.fence_custom, fences[0])) {
      return instance.rules.fence_custom[fences[0]](tokens, idx, options, env, instance);
    }

    langName = escapeHtml(replaceEntities(unescapeMd(fenceName)));
    langClass = ' class="' + langPrefix + langName + '"';
  }

  if (options.highlight) {
    highlighted = options.highlight.apply(options.highlight, [ token.content ].concat(fences))
      || escapeHtml(token.content);
  } else {
    highlighted = escapeHtml(token.content);
  }

  return '<pre><code' + langClass + '>'
        + highlighted
        + '</code></pre>'
        + getBreak(tokens, idx);
};

rules.fence_custom = {};

/**
 * Headings
 */

rules.heading_open = function(tokens, idx /*, options, env */) {
  return '<h' + tokens[idx].hLevel + '>';
};
rules.heading_close = function(tokens, idx /*, options, env */) {
  return '</h' + tokens[idx].hLevel + '>\n';
};

/**
 * Horizontal rules
 */

rules.hr = function(tokens, idx, options /*, env */) {
  return (options.xhtmlOut ? '<hr />' : '<hr>') + getBreak(tokens, idx);
};

/**
 * Bullets
 */

rules.bullet_list_open = function(/* tokens, idx, options, env */) {
  return '<ul>\n';
};
rules.bullet_list_close = function(tokens, idx /*, options, env */) {
  return '</ul>' + getBreak(tokens, idx);
};

/**
 * List items
 */

rules.list_item_open = function(/* tokens, idx, options, env */) {
  return '<li>';
};
rules.list_item_close = function(/* tokens, idx, options, env */) {
  return '</li>\n';
};

/**
 * Ordered list items
 */

rules.ordered_list_open = function(tokens, idx /*, options, env */) {
  var token = tokens[idx];
  var order = token.order > 1 ? ' start="' + token.order + '"' : '';
  return '<ol' + order + '>\n';
};
rules.ordered_list_close = function(tokens, idx /*, options, env */) {
  return '</ol>' + getBreak(tokens, idx);
};

/**
 * Paragraphs
 */

rules.paragraph_open = function(tokens, idx /*, options, env */) {
  return tokens[idx].tight ? '' : '<p>';
};
rules.paragraph_close = function(tokens, idx /*, options, env */) {
  var addBreak = !(tokens[idx].tight && idx && tokens[idx - 1].type === 'inline' && !tokens[idx - 1].content);
  return (tokens[idx].tight ? '' : '</p>') + (addBreak ? getBreak(tokens, idx) : '');
};

/**
 * Links
 */

rules.link_open = function(tokens, idx, options /* env */) {
  var title = tokens[idx].title ? (' title="' + escapeHtml(replaceEntities(tokens[idx].title)) + '"') : '';
  var target = options.linkTarget ? (' target="' + options.linkTarget + '"') : '';
  return '<a href="' + escapeHtml(tokens[idx].href) + '"' + title + target + '>';
};
rules.link_close = function(/* tokens, idx, options, env */) {
  return '</a>';
};

/**
 * Images
 */

rules.image = function(tokens, idx, options /*, env */) {
  var src = ' src="' + escapeHtml(tokens[idx].src) + '"';
  var title = tokens[idx].title ? (' title="' + escapeHtml(replaceEntities(tokens[idx].title)) + '"') : '';
  var alt = ' alt="' + (tokens[idx].alt ? escapeHtml(replaceEntities(unescapeMd(tokens[idx].alt))) : '') + '"';
  var suffix = options.xhtmlOut ? ' /' : '';
  return '<img' + src + alt + title + suffix + '>';
};

/**
 * Tables
 */

rules.table_open = function(/* tokens, idx, options, env */) {
  return '<table>\n';
};
rules.table_close = function(/* tokens, idx, options, env */) {
  return '</table>\n';
};
rules.thead_open = function(/* tokens, idx, options, env */) {
  return '<thead>\n';
};
rules.thead_close = function(/* tokens, idx, options, env */) {
  return '</thead>\n';
};
rules.tbody_open = function(/* tokens, idx, options, env */) {
  return '<tbody>\n';
};
rules.tbody_close = function(/* tokens, idx, options, env */) {
  return '</tbody>\n';
};
rules.tr_open = function(/* tokens, idx, options, env */) {
  return '<tr>';
};
rules.tr_close = function(/* tokens, idx, options, env */) {
  return '</tr>\n';
};
rules.th_open = function(tokens, idx /*, options, env */) {
  var token = tokens[idx];
  return '<th'
    + (token.align ? ' style="text-align:' + token.align + '"' : '')
    + '>';
};
rules.th_close = function(/* tokens, idx, options, env */) {
  return '</th>';
};
rules.td_open = function(tokens, idx /*, options, env */) {
  var token = tokens[idx];
  return '<td'
    + (token.align ? ' style="text-align:' + token.align + '"' : '')
    + '>';
};
rules.td_close = function(/* tokens, idx, options, env */) {
  return '</td>';
};

/**
 * Bold
 */

rules.strong_open = function(/* tokens, idx, options, env */) {
  return '<strong>';
};
rules.strong_close = function(/* tokens, idx, options, env */) {
  return '</strong>';
};

/**
 * Italicize
 */

rules.em_open = function(/* tokens, idx, options, env */) {
  return '<em>';
};
rules.em_close = function(/* tokens, idx, options, env */) {
  return '</em>';
};

/**
 * Strikethrough
 */

rules.del_open = function(/* tokens, idx, options, env */) {
  return '<del>';
};
rules.del_close = function(/* tokens, idx, options, env */) {
  return '</del>';
};

/**
 * Insert
 */

rules.ins_open = function(/* tokens, idx, options, env */) {
  return '<ins>';
};
rules.ins_close = function(/* tokens, idx, options, env */) {
  return '</ins>';
};

/**
 * Highlight
 */

rules.mark_open = function(/* tokens, idx, options, env */) {
  return '<mark>';
};
rules.mark_close = function(/* tokens, idx, options, env */) {
  return '</mark>';
};

/**
 * Super- and sub-script
 */

rules.sub = function(tokens, idx /*, options, env */) {
  return '<sub>' + escapeHtml(tokens[idx].content) + '</sub>';
};
rules.sup = function(tokens, idx /*, options, env */) {
  return '<sup>' + escapeHtml(tokens[idx].content) + '</sup>';
};

/**
 * Breaks
 */

rules.hardbreak = function(tokens, idx, options /*, env */) {
  return options.xhtmlOut ? '<br />\n' : '<br>\n';
};
rules.softbreak = function(tokens, idx, options /*, env */) {
  return options.breaks ? (options.xhtmlOut ? '<br />\n' : '<br>\n') : '\n';
};

/**
 * Text
 */

rules.text = function(tokens, idx /*, options, env */) {
  return escapeHtml(tokens[idx].content);
};

/**
 * Content
 */

rules.htmlblock = function(tokens, idx /*, options, env */) {
  return tokens[idx].content;
};
rules.htmltag = function(tokens, idx /*, options, env */) {
  return tokens[idx].content;
};

/**
 * Abbreviations, initialism
 */

rules.abbr_open = function(tokens, idx /*, options, env */) {
  return '<abbr title="' + escapeHtml(replaceEntities(tokens[idx].title)) + '">';
};
rules.abbr_close = function(/* tokens, idx, options, env */) {
  return '</abbr>';
};

/**
 * Footnotes
 */

rules.footnote_ref = function(tokens, idx) {
  var n = Number(tokens[idx].id + 1).toString();
  var id = 'fnref' + n;
  if (tokens[idx].subId > 0) {
    id += ':' + tokens[idx].subId;
  }
  return '<sup class="footnote-ref"><a href="#fn' + n + '" id="' + id + '">[' + n + ']</a></sup>';
};
rules.footnote_block_open = function(tokens, idx, options) {
  var hr = options.xhtmlOut
    ? '<hr class="footnotes-sep" />\n'
    : '<hr class="footnotes-sep">\n';
  return hr + '<section class="footnotes">\n<ol class="footnotes-list">\n';
};
rules.footnote_block_close = function() {
  return '</ol>\n</section>\n';
};
rules.footnote_open = function(tokens, idx) {
  var id = Number(tokens[idx].id + 1).toString();
  return '<li id="fn' + id + '"  class="footnote-item">';
};
rules.footnote_close = function() {
  return '</li>\n';
};
rules.footnote_anchor = function(tokens, idx) {
  var n = Number(tokens[idx].id + 1).toString();
  var id = 'fnref' + n;
  if (tokens[idx].subId > 0) {
    id += ':' + tokens[idx].subId;
  }
  return ' <a href="#' + id + '" class="footnote-backref">↩</a>';
};

/**
 * Definition lists
 */

rules.dl_open = function() {
  return '<dl>\n';
};
rules.dt_open = function() {
  return '<dt>';
};
rules.dd_open = function() {
  return '<dd>';
};
rules.dl_close = function() {
  return '</dl>\n';
};
rules.dt_close = function() {
  return '</dt>\n';
};
rules.dd_close = function() {
  return '</dd>\n';
};

/**
 * Helper functions
 */

function nextToken(tokens, idx) {
  if (++idx >= tokens.length - 2) {
    return idx;
  }
  if ((tokens[idx].type === 'paragraph_open' && tokens[idx].tight) &&
      (tokens[idx + 1].type === 'inline' && tokens[idx + 1].content.length === 0) &&
      (tokens[idx + 2].type === 'paragraph_close' && tokens[idx + 2].tight)) {
    return nextToken(tokens, idx + 2);
  }
  return idx;
}

/**
 * Check to see if `\n` is needed before the next token.
 *
 * @param  {Array} `tokens`
 * @param  {Number} `idx`
 * @return {String} Empty string or newline
 * @api private
 */

var getBreak = rules.getBreak = function getBreak(tokens, idx) {
  idx = nextToken(tokens, idx);
  if (idx < tokens.length && tokens[idx].type === 'list_item_close') {
    return '';
  }
  return '\n';
};

/**
 * Renderer class. Renders HTML and exposes `rules` to allow
 * local modifications.
 */

function Renderer() {
  this.rules = assign({}, rules);

  // exported helper, for custom rules only
  this.getBreak = rules.getBreak;
}

/**
 * Render a string of inline HTML with the given `tokens` and
 * `options`.
 *
 * @param  {Array} `tokens`
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @return {String}
 * @api public
 */

Renderer.prototype.renderInline = function (tokens, options, env) {
  var _rules = this.rules;
  var len = tokens.length, i = 0;
  var result = '';

  while (len--) {
    result += _rules[tokens[i].type](tokens, i++, options, env, this);
  }

  return result;
};

/**
 * Render a string of HTML with the given `tokens` and
 * `options`.
 *
 * @param  {Array} `tokens`
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @return {String}
 * @api public
 */

Renderer.prototype.render = function (tokens, options, env) {
  var _rules = this.rules;
  var len = tokens.length, i = -1;
  var result = '';

  while (++i < len) {
    if (tokens[i].type === 'inline') {
      result += this.renderInline(tokens[i].children, options, env);
    } else {
      result += _rules[tokens[i].type](tokens, i, options, env, this);
    }
  }
  return result;
};

/**
 * Ruler is a helper class for building responsibility chains from
 * parse rules. It allows:
 *
 *   - easy stack rules chains
 *   - getting main chain and named chains content (as arrays of functions)
 *
 * Helper methods, should not be used directly.
 * @api private
 */

function Ruler() {
  // List of added rules. Each element is:
  //
  // { name: XXX,
  //   enabled: Boolean,
  //   fn: Function(),
  //   alt: [ name2, name3 ] }
  //
  this.__rules__ = [];

  // Cached rule chains.
  //
  // First level - chain name, '' for default.
  // Second level - digital anchor for fast filtering by charcodes.
  //
  this.__cache__ = null;
}

/**
 * Find the index of a rule by `name`.
 *
 * @param  {String} `name`
 * @return {Number} Index of the given `name`
 * @api private
 */

Ruler.prototype.__find__ = function (name) {
  var len = this.__rules__.length;
  var i = -1;

  while (len--) {
    if (this.__rules__[++i].name === name) {
      return i;
    }
  }
  return -1;
};

/**
 * Build the rules lookup cache
 *
 * @api private
 */

Ruler.prototype.__compile__ = function () {
  var self = this;
  var chains = [ '' ];

  // collect unique names
  self.__rules__.forEach(function (rule) {
    if (!rule.enabled) {
      return;
    }

    rule.alt.forEach(function (altName) {
      if (chains.indexOf(altName) < 0) {
        chains.push(altName);
      }
    });
  });

  self.__cache__ = {};

  chains.forEach(function (chain) {
    self.__cache__[chain] = [];
    self.__rules__.forEach(function (rule) {
      if (!rule.enabled) {
        return;
      }

      if (chain && rule.alt.indexOf(chain) < 0) {
        return;
      }
      self.__cache__[chain].push(rule.fn);
    });
  });
};

/**
 * Ruler public methods
 * ------------------------------------------------
 */

/**
 * Replace rule function
 *
 * @param  {String} `name` Rule name
 * @param  {Function `fn`
 * @param  {Object} `options`
 * @api private
 */

Ruler.prototype.at = function (name, fn, options) {
  var idx = this.__find__(name);
  var opt = options || {};

  if (idx === -1) {
    throw new Error('Parser rule not found: ' + name);
  }

  this.__rules__[idx].fn = fn;
  this.__rules__[idx].alt = opt.alt || [];
  this.__cache__ = null;
};

/**
 * Add a rule to the chain before given the `ruleName`.
 *
 * @param  {String}   `beforeName`
 * @param  {String}   `ruleName`
 * @param  {Function} `fn`
 * @param  {Object}   `options`
 * @api private
 */

Ruler.prototype.before = function (beforeName, ruleName, fn, options) {
  var idx = this.__find__(beforeName);
  var opt = options || {};

  if (idx === -1) {
    throw new Error('Parser rule not found: ' + beforeName);
  }

  this.__rules__.splice(idx, 0, {
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};

/**
 * Add a rule to the chain after the given `ruleName`.
 *
 * @param  {String}   `afterName`
 * @param  {String}   `ruleName`
 * @param  {Function} `fn`
 * @param  {Object}   `options`
 * @api private
 */

Ruler.prototype.after = function (afterName, ruleName, fn, options) {
  var idx = this.__find__(afterName);
  var opt = options || {};

  if (idx === -1) {
    throw new Error('Parser rule not found: ' + afterName);
  }

  this.__rules__.splice(idx + 1, 0, {
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};

/**
 * Add a rule to the end of chain.
 *
 * @param  {String}   `ruleName`
 * @param  {Function} `fn`
 * @param  {Object}   `options`
 * @return {String}
 */

Ruler.prototype.push = function (ruleName, fn, options) {
  var opt = options || {};

  this.__rules__.push({
    name: ruleName,
    enabled: true,
    fn: fn,
    alt: opt.alt || []
  });

  this.__cache__ = null;
};

/**
 * Enable a rule or list of rules.
 *
 * @param  {String|Array} `list` Name or array of rule names to enable
 * @param  {Boolean} `strict` If `true`, all non listed rules will be disabled.
 * @api private
 */

Ruler.prototype.enable = function (list, strict) {
  list = !Array.isArray(list)
    ? [ list ]
    : list;

  // In strict mode disable all existing rules first
  if (strict) {
    this.__rules__.forEach(function (rule) {
      rule.enabled = false;
    });
  }

  // Search by name and enable
  list.forEach(function (name) {
    var idx = this.__find__(name);
    if (idx < 0) {
      throw new Error('Rules manager: invalid rule name ' + name);
    }
    this.__rules__[idx].enabled = true;
  }, this);

  this.__cache__ = null;
};


/**
 * Disable a rule or list of rules.
 *
 * @param  {String|Array} `list` Name or array of rule names to disable
 * @api private
 */

Ruler.prototype.disable = function (list) {
  list = !Array.isArray(list)
    ? [ list ]
    : list;

  // Search by name and disable
  list.forEach(function (name) {
    var idx = this.__find__(name);
    if (idx < 0) {
      throw new Error('Rules manager: invalid rule name ' + name);
    }
    this.__rules__[idx].enabled = false;
  }, this);

  this.__cache__ = null;
};

/**
 * Get a rules list as an array of functions.
 *
 * @param  {String} `chainName`
 * @return {Object}
 * @api private
 */

Ruler.prototype.getRules = function (chainName) {
  if (this.__cache__ === null) {
    this.__compile__();
  }
  return this.__cache__[chainName] || [];
};

function block(state) {

  if (state.inlineMode) {
    state.tokens.push({
      type: 'inline',
      content: state.src.replace(/\n/g, ' ').trim(),
      level: 0,
      lines: [ 0, 1 ],
      children: []
    });

  } else {
    state.block.parse(state.src, state.options, state.env, state.tokens);
  }
}

// Inline parser state

function StateInline(src, parserInline, options, env, outTokens) {
  this.src = src;
  this.env = env;
  this.options = options;
  this.parser = parserInline;
  this.tokens = outTokens;
  this.pos = 0;
  this.posMax = this.src.length;
  this.level = 0;
  this.pending = '';
  this.pendingLevel = 0;

  this.cache = [];        // Stores { start: end } pairs. Useful for backtrack
                          // optimization of pairs parse (emphasis, strikes).

  // Link parser state vars

  this.isInLabel = false; // Set true when seek link label - we should disable
                          // "paired" rules (emphasis, strikes) to not skip
                          // tailing `]`

  this.linkLevel = 0;     // Increment for each nesting link. Used to prevent
                          // nesting in definitions

  this.linkContent = '';  // Temporary storage for link url

  this.labelUnmatchedScopes = 0; // Track unpaired `[` for link labels
                                 // (backtrack optimization)
}

// Flush pending text
//
StateInline.prototype.pushPending = function () {
  this.tokens.push({
    type: 'text',
    content: this.pending,
    level: this.pendingLevel
  });
  this.pending = '';
};

// Push new token to "stream".
// If pending text exists - flush it as text token
//
StateInline.prototype.push = function (token) {
  if (this.pending) {
    this.pushPending();
  }

  this.tokens.push(token);
  this.pendingLevel = this.level;
};

// Store value to cache.
// !!! Implementation has parser-specific optimizations
// !!! keys MUST be integer, >= 0; values MUST be integer, > 0
//
StateInline.prototype.cacheSet = function (key, val) {
  for (var i = this.cache.length; i <= key; i++) {
    this.cache.push(0);
  }

  this.cache[key] = val;
};

// Get cache value
//
StateInline.prototype.cacheGet = function (key) {
  return key < this.cache.length ? this.cache[key] : 0;
};

/**
 * Parse link labels
 *
 * This function assumes that first character (`[`) already matches;
 * returns the end of the label.
 *
 * @param  {Object} state
 * @param  {Number} start
 * @api private
 */

function parseLinkLabel(state, start) {
  var level, found, marker,
      labelEnd = -1,
      max = state.posMax,
      oldPos = state.pos,
      oldFlag = state.isInLabel;

  if (state.isInLabel) { return -1; }

  if (state.labelUnmatchedScopes) {
    state.labelUnmatchedScopes--;
    return -1;
  }

  state.pos = start + 1;
  state.isInLabel = true;
  level = 1;

  while (state.pos < max) {
    marker = state.src.charCodeAt(state.pos);
    if (marker === 0x5B /* [ */) {
      level++;
    } else if (marker === 0x5D /* ] */) {
      level--;
      if (level === 0) {
        found = true;
        break;
      }
    }

    state.parser.skipToken(state);
  }

  if (found) {
    labelEnd = state.pos;
    state.labelUnmatchedScopes = 0;
  } else {
    state.labelUnmatchedScopes = level - 1;
  }

  // restore old state
  state.pos = oldPos;
  state.isInLabel = oldFlag;

  return labelEnd;
}

// Parse abbreviation definitions, i.e. `*[abbr]: description`


function parseAbbr(str, parserInline, options, env) {
  var state, labelEnd, pos, max, label, title;

  if (str.charCodeAt(0) !== 0x2A/* * */) { return -1; }
  if (str.charCodeAt(1) !== 0x5B/* [ */) { return -1; }

  if (str.indexOf(']:') === -1) { return -1; }

  state = new StateInline(str, parserInline, options, env, []);
  labelEnd = parseLinkLabel(state, 1);

  if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A/* : */) { return -1; }

  max = state.posMax;

  // abbr title is always one line, so looking for ending "\n" here
  for (pos = labelEnd + 2; pos < max; pos++) {
    if (state.src.charCodeAt(pos) === 0x0A) { break; }
  }

  label = str.slice(2, labelEnd);
  title = str.slice(labelEnd + 2, pos).trim();
  if (title.length === 0) { return -1; }
  if (!env.abbreviations) { env.abbreviations = {}; }
  // prepend ':' to avoid conflict with Object.prototype members
  if (typeof env.abbreviations[':' + label] === 'undefined') {
    env.abbreviations[':' + label] = title;
  }

  return pos;
}

function abbr(state) {
  var tokens = state.tokens, i, l, content, pos;

  if (state.inlineMode) {
    return;
  }

  // Parse inlines
  for (i = 1, l = tokens.length - 1; i < l; i++) {
    if (tokens[i - 1].type === 'paragraph_open' &&
        tokens[i].type === 'inline' &&
        tokens[i + 1].type === 'paragraph_close') {

      content = tokens[i].content;
      while (content.length) {
        pos = parseAbbr(content, state.inline, state.options, state.env);
        if (pos < 0) { break; }
        content = content.slice(pos).trim();
      }

      tokens[i].content = content;
      if (!content.length) {
        tokens[i - 1].tight = true;
        tokens[i + 1].tight = true;
      }
    }
  }
}

function normalizeLink(url) {
  var normalized = replaceEntities(url);
  // We shouldn't care about the result of malformed URIs,
  // and should not throw an exception.
  try {
    normalized = decodeURI(normalized);
  } catch (err) {}
  return encodeURI(normalized);
}

/**
 * Parse link destination
 *
 *   - on success it returns a string and updates state.pos;
 *   - on failure it returns null
 *
 * @param  {Object} state
 * @param  {Number} pos
 * @api private
 */

function parseLinkDestination(state, pos) {
  var code, level, link,
      start = pos,
      max = state.posMax;

  if (state.src.charCodeAt(pos) === 0x3C /* < */) {
    pos++;
    while (pos < max) {
      code = state.src.charCodeAt(pos);
      if (code === 0x0A /* \n */) { return false; }
      if (code === 0x3E /* > */) {
        link = normalizeLink(unescapeMd(state.src.slice(start + 1, pos)));
        if (!state.parser.validateLink(link)) { return false; }
        state.pos = pos + 1;
        state.linkContent = link;
        return true;
      }
      if (code === 0x5C /* \ */ && pos + 1 < max) {
        pos += 2;
        continue;
      }

      pos++;
    }

    // no closing '>'
    return false;
  }

  // this should be ... } else { ... branch

  level = 0;
  while (pos < max) {
    code = state.src.charCodeAt(pos);

    if (code === 0x20) { break; }

    // ascii control chars
    if (code < 0x20 || code === 0x7F) { break; }

    if (code === 0x5C /* \ */ && pos + 1 < max) {
      pos += 2;
      continue;
    }

    if (code === 0x28 /* ( */) {
      level++;
      if (level > 1) { break; }
    }

    if (code === 0x29 /* ) */) {
      level--;
      if (level < 0) { break; }
    }

    pos++;
  }

  if (start === pos) { return false; }

  link = unescapeMd(state.src.slice(start, pos));
  if (!state.parser.validateLink(link)) { return false; }

  state.linkContent = link;
  state.pos = pos;
  return true;
}

/**
 * Parse link title
 *
 *   - on success it returns a string and updates state.pos;
 *   - on failure it returns null
 *
 * @param  {Object} state
 * @param  {Number} pos
 * @api private
 */

function parseLinkTitle(state, pos) {
  var code,
      start = pos,
      max = state.posMax,
      marker = state.src.charCodeAt(pos);

  if (marker !== 0x22 /* " */ && marker !== 0x27 /* ' */ && marker !== 0x28 /* ( */) { return false; }

  pos++;

  // if opening marker is "(", switch it to closing marker ")"
  if (marker === 0x28) { marker = 0x29; }

  while (pos < max) {
    code = state.src.charCodeAt(pos);
    if (code === marker) {
      state.pos = pos + 1;
      state.linkContent = unescapeMd(state.src.slice(start + 1, pos));
      return true;
    }
    if (code === 0x5C /* \ */ && pos + 1 < max) {
      pos += 2;
      continue;
    }

    pos++;
  }

  return false;
}

function normalizeReference(str) {
  // use .toUpperCase() instead of .toLowerCase()
  // here to avoid a conflict with Object.prototype
  // members (most notably, `__proto__`)
  return str.trim().replace(/\s+/g, ' ').toUpperCase();
}

function parseReference(str, parser, options, env) {
  var state, labelEnd, pos, max, code, start, href, title, label;

  if (str.charCodeAt(0) !== 0x5B/* [ */) { return -1; }

  if (str.indexOf(']:') === -1) { return -1; }

  state = new StateInline(str, parser, options, env, []);
  labelEnd = parseLinkLabel(state, 0);

  if (labelEnd < 0 || str.charCodeAt(labelEnd + 1) !== 0x3A/* : */) { return -1; }

  max = state.posMax;

  // [label]:   destination   'title'
  //         ^^^ skip optional whitespace here
  for (pos = labelEnd + 2; pos < max; pos++) {
    code = state.src.charCodeAt(pos);
    if (code !== 0x20 && code !== 0x0A) { break; }
  }

  // [label]:   destination   'title'
  //            ^^^^^^^^^^^ parse this
  if (!parseLinkDestination(state, pos)) { return -1; }
  href = state.linkContent;
  pos = state.pos;

  // [label]:   destination   'title'
  //                       ^^^ skipping those spaces
  start = pos;
  for (pos = pos + 1; pos < max; pos++) {
    code = state.src.charCodeAt(pos);
    if (code !== 0x20 && code !== 0x0A) { break; }
  }

  // [label]:   destination   'title'
  //                          ^^^^^^^ parse this
  if (pos < max && start !== pos && parseLinkTitle(state, pos)) {
    title = state.linkContent;
    pos = state.pos;
  } else {
    title = '';
    pos = start;
  }

  // ensure that the end of the line is empty
  while (pos < max && state.src.charCodeAt(pos) === 0x20/* space */) { pos++; }
  if (pos < max && state.src.charCodeAt(pos) !== 0x0A) { return -1; }

  label = normalizeReference(str.slice(1, labelEnd));
  if (typeof env.references[label] === 'undefined') {
    env.references[label] = { title: title, href: href };
  }

  return pos;
}


function references(state) {
  var tokens = state.tokens, i, l, content, pos;

  state.env.references = state.env.references || {};

  if (state.inlineMode) {
    return;
  }

  // Scan definitions in paragraph inlines
  for (i = 1, l = tokens.length - 1; i < l; i++) {
    if (tokens[i].type === 'inline' &&
        tokens[i - 1].type === 'paragraph_open' &&
        tokens[i + 1].type === 'paragraph_close') {

      content = tokens[i].content;
      while (content.length) {
        pos = parseReference(content, state.inline, state.options, state.env);
        if (pos < 0) { break; }
        content = content.slice(pos).trim();
      }

      tokens[i].content = content;
      if (!content.length) {
        tokens[i - 1].tight = true;
        tokens[i + 1].tight = true;
      }
    }
  }
}

function inline(state) {
  var tokens = state.tokens, tok, i, l;

  // Parse inlines
  for (i = 0, l = tokens.length; i < l; i++) {
    tok = tokens[i];
    if (tok.type === 'inline') {
      state.inline.parse(tok.content, state.options, state.env, tok.children);
    }
  }
}

function footnote_block(state) {
  var i, l, j, t, lastParagraph, list, tokens, current, currentLabel,
      level = 0,
      insideRef = false,
      refTokens = {};

  if (!state.env.footnotes) { return; }

  state.tokens = state.tokens.filter(function(tok) {
    if (tok.type === 'footnote_reference_open') {
      insideRef = true;
      current = [];
      currentLabel = tok.label;
      return false;
    }
    if (tok.type === 'footnote_reference_close') {
      insideRef = false;
      // prepend ':' to avoid conflict with Object.prototype members
      refTokens[':' + currentLabel] = current;
      return false;
    }
    if (insideRef) { current.push(tok); }
    return !insideRef;
  });

  if (!state.env.footnotes.list) { return; }
  list = state.env.footnotes.list;

  state.tokens.push({
    type: 'footnote_block_open',
    level: level++
  });
  for (i = 0, l = list.length; i < l; i++) {
    state.tokens.push({
      type: 'footnote_open',
      id: i,
      level: level++
    });

    if (list[i].tokens) {
      tokens = [];
      tokens.push({
        type: 'paragraph_open',
        tight: false,
        level: level++
      });
      tokens.push({
        type: 'inline',
        content: '',
        level: level,
        children: list[i].tokens
      });
      tokens.push({
        type: 'paragraph_close',
        tight: false,
        level: --level
      });
    } else if (list[i].label) {
      tokens = refTokens[':' + list[i].label];
    }

    state.tokens = state.tokens.concat(tokens);
    if (state.tokens[state.tokens.length - 1].type === 'paragraph_close') {
      lastParagraph = state.tokens.pop();
    } else {
      lastParagraph = null;
    }

    t = list[i].count > 0 ? list[i].count : 1;
    for (j = 0; j < t; j++) {
      state.tokens.push({
        type: 'footnote_anchor',
        id: i,
        subId: j,
        level: level
      });
    }

    if (lastParagraph) {
      state.tokens.push(lastParagraph);
    }

    state.tokens.push({
      type: 'footnote_close',
      level: --level
    });
  }
  state.tokens.push({
    type: 'footnote_block_close',
    level: --level
  });
}

// Enclose abbreviations in <abbr> tags
//

var PUNCT_CHARS = ' \n()[]\'".,!?-';


// from Google closure library
// http://closure-library.googlecode.com/git-history/docs/local_closure_goog_string_string.js.source.html#line1021
function regEscape(s) {
  return s.replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\$1');
}


function abbr2(state) {
  var i, j, l, tokens, token, text, nodes, pos, level, reg, m, regText,
      blockTokens = state.tokens;

  if (!state.env.abbreviations) { return; }
  if (!state.env.abbrRegExp) {
    regText = '(^|[' + PUNCT_CHARS.split('').map(regEscape).join('') + '])'
            + '(' + Object.keys(state.env.abbreviations).map(function (x) {
                      return x.substr(1);
                    }).sort(function (a, b) {
                      return b.length - a.length;
                    }).map(regEscape).join('|') + ')'
            + '($|[' + PUNCT_CHARS.split('').map(regEscape).join('') + '])';
    state.env.abbrRegExp = new RegExp(regText, 'g');
  }
  reg = state.env.abbrRegExp;

  for (j = 0, l = blockTokens.length; j < l; j++) {
    if (blockTokens[j].type !== 'inline') { continue; }
    tokens = blockTokens[j].children;

    // We scan from the end, to keep position when new tags added.
    for (i = tokens.length - 1; i >= 0; i--) {
      token = tokens[i];
      if (token.type !== 'text') { continue; }

      pos = 0;
      text = token.content;
      reg.lastIndex = 0;
      level = token.level;
      nodes = [];

      while ((m = reg.exec(text))) {
        if (reg.lastIndex > pos) {
          nodes.push({
            type: 'text',
            content: text.slice(pos, m.index + m[1].length),
            level: level
          });
        }

        nodes.push({
          type: 'abbr_open',
          title: state.env.abbreviations[':' + m[2]],
          level: level++
        });
        nodes.push({
          type: 'text',
          content: m[2],
          level: level
        });
        nodes.push({
          type: 'abbr_close',
          level: --level
        });
        pos = reg.lastIndex - m[3].length;
      }

      if (!nodes.length) { continue; }

      if (pos < text.length) {
        nodes.push({
          type: 'text',
          content: text.slice(pos),
          level: level
        });
      }

      // replace current node
      blockTokens[j].children = tokens = [].concat(tokens.slice(0, i), nodes, tokens.slice(i + 1));
    }
  }
}

// Simple typographical replacements
//
// TODO:
// - fractionals 1/2, 1/4, 3/4 -> ½, ¼, ¾
// - miltiplication 2 x 4 -> 2 × 4

var RARE_RE = /\+-|\.\.|\?\?\?\?|!!!!|,,|--/;

var SCOPED_ABBR_RE = /\((c|tm|r|p)\)/ig;
var SCOPED_ABBR = {
  'c': '©',
  'r': '®',
  'p': '§',
  'tm': '™'
};

function replaceScopedAbbr(str) {
  if (str.indexOf('(') < 0) { return str; }

  return str.replace(SCOPED_ABBR_RE, function(match, name) {
    return SCOPED_ABBR[name.toLowerCase()];
  });
}


function replace(state) {
  var i, token, text, inlineTokens, blkIdx;

  if (!state.options.typographer) { return; }

  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {

    if (state.tokens[blkIdx].type !== 'inline') { continue; }

    inlineTokens = state.tokens[blkIdx].children;

    for (i = inlineTokens.length - 1; i >= 0; i--) {
      token = inlineTokens[i];
      if (token.type === 'text') {
        text = token.content;

        text = replaceScopedAbbr(text);

        if (RARE_RE.test(text)) {
          text = text
            .replace(/\+-/g, '±')
            // .., ..., ....... -> …
            // but ?..... & !..... -> ?.. & !..
            .replace(/\.{2,}/g, '…').replace(/([?!])…/g, '$1..')
            .replace(/([?!]){4,}/g, '$1$1$1').replace(/,{2,}/g, ',')
            // em-dash
            .replace(/(^|[^-])---([^-]|$)/mg, '$1\u2014$2')
            // en-dash
            .replace(/(^|\s)--(\s|$)/mg, '$1\u2013$2')
            .replace(/(^|[^-\s])--([^-\s]|$)/mg, '$1\u2013$2');
        }

        token.content = text;
      }
    }
  }
}

// Convert straight quotation marks to typographic ones
//

var QUOTE_TEST_RE = /['"]/;
var QUOTE_RE = /['"]/g;
var PUNCT_RE = /[-\s()\[\]]/;
var APOSTROPHE = '’';

// This function returns true if the character at `pos`
// could be inside a word.
function isLetter(str, pos) {
  if (pos < 0 || pos >= str.length) { return false; }
  return !PUNCT_RE.test(str[pos]);
}


function replaceAt(str, index, ch) {
  return str.substr(0, index) + ch + str.substr(index + 1);
}


function smartquotes(state) {
  /*eslint max-depth:0*/
  var i, token, text, t, pos, max, thisLevel, lastSpace, nextSpace, item,
      canOpen, canClose, j, isSingle, blkIdx, tokens,
      stack;

  if (!state.options.typographer) { return; }

  stack = [];

  for (blkIdx = state.tokens.length - 1; blkIdx >= 0; blkIdx--) {

    if (state.tokens[blkIdx].type !== 'inline') { continue; }

    tokens = state.tokens[blkIdx].children;
    stack.length = 0;

    for (i = 0; i < tokens.length; i++) {
      token = tokens[i];

      if (token.type !== 'text' || QUOTE_TEST_RE.test(token.text)) { continue; }

      thisLevel = tokens[i].level;

      for (j = stack.length - 1; j >= 0; j--) {
        if (stack[j].level <= thisLevel) { break; }
      }
      stack.length = j + 1;

      text = token.content;
      pos = 0;
      max = text.length;

      /*eslint no-labels:0,block-scoped-var:0*/
      OUTER:
      while (pos < max) {
        QUOTE_RE.lastIndex = pos;
        t = QUOTE_RE.exec(text);
        if (!t) { break; }

        lastSpace = !isLetter(text, t.index - 1);
        pos = t.index + 1;
        isSingle = (t[0] === "'");
        nextSpace = !isLetter(text, pos);

        if (!nextSpace && !lastSpace) {
          // middle of word
          if (isSingle) {
            token.content = replaceAt(token.content, t.index, APOSTROPHE);
          }
          continue;
        }

        canOpen = !nextSpace;
        canClose = !lastSpace;

        if (canClose) {
          // this could be a closing quote, rewind the stack to get a match
          for (j = stack.length - 1; j >= 0; j--) {
            item = stack[j];
            if (stack[j].level < thisLevel) { break; }
            if (item.single === isSingle && stack[j].level === thisLevel) {
              item = stack[j];
              if (isSingle) {
                tokens[item.token].content = replaceAt(tokens[item.token].content, item.pos, state.options.quotes[2]);
                token.content = replaceAt(token.content, t.index, state.options.quotes[3]);
              } else {
                tokens[item.token].content = replaceAt(tokens[item.token].content, item.pos, state.options.quotes[0]);
                token.content = replaceAt(token.content, t.index, state.options.quotes[1]);
              }
              stack.length = j;
              continue OUTER;
            }
          }
        }

        if (canOpen) {
          stack.push({
            token: i,
            pos: t.index,
            single: isSingle,
            level: thisLevel
          });
        } else if (canClose && isSingle) {
          token.content = replaceAt(token.content, t.index, APOSTROPHE);
        }
      }
    }
  }
}

/**
 * Core parser `rules`
 */

var _rules = [
  [ 'block',          block          ],
  [ 'abbr',           abbr           ],
  [ 'references',     references     ],
  [ 'inline',         inline         ],
  [ 'footnote_tail',  footnote_block  ],
  [ 'abbr2',          abbr2          ],
  [ 'replacements',   replace   ],
  [ 'smartquotes',    smartquotes    ],
];

/**
 * Class for top level (`core`) parser rules
 *
 * @api private
 */

function Core() {
  this.options = {};
  this.ruler = new Ruler();
  for (var i = 0; i < _rules.length; i++) {
    this.ruler.push(_rules[i][0], _rules[i][1]);
  }
}

/**
 * Process rules with the given `state`
 *
 * @param  {Object} `state`
 * @api private
 */

Core.prototype.process = function (state) {
  var i, l, rules;
  rules = this.ruler.getRules('');
  for (i = 0, l = rules.length; i < l; i++) {
    rules[i](state);
  }
};

// Parser state class

function StateBlock(src, parser, options, env, tokens) {
  var ch, s, start, pos, len, indent, indent_found;

  this.src = src;

  // Shortcuts to simplify nested calls
  this.parser = parser;

  this.options = options;

  this.env = env;

  //
  // Internal state vartiables
  //

  this.tokens = tokens;

  this.bMarks = [];  // line begin offsets for fast jumps
  this.eMarks = [];  // line end offsets for fast jumps
  this.tShift = [];  // indent for each line

  // block parser variables
  this.blkIndent  = 0; // required block content indent
                       // (for example, if we are in list)
  this.line       = 0; // line index in src
  this.lineMax    = 0; // lines count
  this.tight      = false;  // loose/tight mode for lists
  this.parentType = 'root'; // if `list`, block parser stops on two newlines
  this.ddIndent   = -1; // indent of the current dd block (-1 if there isn't any)

  this.level = 0;

  // renderer
  this.result = '';

  // Create caches
  // Generate markers.
  s = this.src;
  indent = 0;
  indent_found = false;

  for (start = pos = indent = 0, len = s.length; pos < len; pos++) {
    ch = s.charCodeAt(pos);

    if (!indent_found) {
      if (ch === 0x20/* space */) {
        indent++;
        continue;
      } else {
        indent_found = true;
      }
    }

    if (ch === 0x0A || pos === len - 1) {
      if (ch !== 0x0A) { pos++; }
      this.bMarks.push(start);
      this.eMarks.push(pos);
      this.tShift.push(indent);

      indent_found = false;
      indent = 0;
      start = pos + 1;
    }
  }

  // Push fake entry to simplify cache bounds checks
  this.bMarks.push(s.length);
  this.eMarks.push(s.length);
  this.tShift.push(0);

  this.lineMax = this.bMarks.length - 1; // don't count last fake line
}

StateBlock.prototype.isEmpty = function isEmpty(line) {
  return this.bMarks[line] + this.tShift[line] >= this.eMarks[line];
};

StateBlock.prototype.skipEmptyLines = function skipEmptyLines(from) {
  for (var max = this.lineMax; from < max; from++) {
    if (this.bMarks[from] + this.tShift[from] < this.eMarks[from]) {
      break;
    }
  }
  return from;
};

// Skip spaces from given position.
StateBlock.prototype.skipSpaces = function skipSpaces(pos) {
  for (var max = this.src.length; pos < max; pos++) {
    if (this.src.charCodeAt(pos) !== 0x20/* space */) { break; }
  }
  return pos;
};

// Skip char codes from given position
StateBlock.prototype.skipChars = function skipChars(pos, code) {
  for (var max = this.src.length; pos < max; pos++) {
    if (this.src.charCodeAt(pos) !== code) { break; }
  }
  return pos;
};

// Skip char codes reverse from given position - 1
StateBlock.prototype.skipCharsBack = function skipCharsBack(pos, code, min) {
  if (pos <= min) { return pos; }

  while (pos > min) {
    if (code !== this.src.charCodeAt(--pos)) { return pos + 1; }
  }
  return pos;
};

// cut lines range from source.
StateBlock.prototype.getLines = function getLines(begin, end, indent, keepLastLF) {
  var i, first, last, queue, shift,
      line = begin;

  if (begin >= end) {
    return '';
  }

  // Opt: don't use push queue for single line;
  if (line + 1 === end) {
    first = this.bMarks[line] + Math.min(this.tShift[line], indent);
    last = keepLastLF ? this.eMarks[line] + 1 : this.eMarks[line];
    return this.src.slice(first, last);
  }

  queue = new Array(end - begin);

  for (i = 0; line < end; line++, i++) {
    shift = this.tShift[line];
    if (shift > indent) { shift = indent; }
    if (shift < 0) { shift = 0; }

    first = this.bMarks[line] + shift;

    if (line + 1 < end || keepLastLF) {
      // No need for bounds check because we have fake entry on tail.
      last = this.eMarks[line] + 1;
    } else {
      last = this.eMarks[line];
    }

    queue[i] = this.src.slice(first, last);
  }

  return queue.join('');
};

// Code block (4 spaces padded)

function code(state, startLine, endLine/*, silent*/) {
  var nextLine, last;

  if (state.tShift[startLine] - state.blkIndent < 4) { return false; }

  last = nextLine = startLine + 1;

  while (nextLine < endLine) {
    if (state.isEmpty(nextLine)) {
      nextLine++;
      continue;
    }
    if (state.tShift[nextLine] - state.blkIndent >= 4) {
      nextLine++;
      last = nextLine;
      continue;
    }
    break;
  }

  state.line = nextLine;
  state.tokens.push({
    type: 'code',
    content: state.getLines(startLine, last, 4 + state.blkIndent, true),
    block: true,
    lines: [ startLine, state.line ],
    level: state.level
  });

  return true;
}

// fences (``` lang, ~~~ lang)

function fences(state, startLine, endLine, silent) {
  var marker, len, params, nextLine, mem,
      haveEndMarker = false,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  if (pos + 3 > max) { return false; }

  marker = state.src.charCodeAt(pos);

  if (marker !== 0x7E/* ~ */ && marker !== 0x60 /* ` */) {
    return false;
  }

  // scan marker length
  mem = pos;
  pos = state.skipChars(pos, marker);

  len = pos - mem;

  if (len < 3) { return false; }

  params = state.src.slice(pos, max).trim();

  if (params.indexOf('`') >= 0) { return false; }

  // Since start is found, we can report success here in validation mode
  if (silent) { return true; }

  // search end of block
  nextLine = startLine;

  for (;;) {
    nextLine++;
    if (nextLine >= endLine) {
      // unclosed block should be autoclosed by end of document.
      // also block seems to be autoclosed by end of parent
      break;
    }

    pos = mem = state.bMarks[nextLine] + state.tShift[nextLine];
    max = state.eMarks[nextLine];

    if (pos < max && state.tShift[nextLine] < state.blkIndent) {
      // non-empty line with negative indent should stop the list:
      // - ```
      //  test
      break;
    }

    if (state.src.charCodeAt(pos) !== marker) { continue; }

    if (state.tShift[nextLine] - state.blkIndent >= 4) {
      // closing fence should be indented less than 4 spaces
      continue;
    }

    pos = state.skipChars(pos, marker);

    // closing code fence must be at least as long as the opening one
    if (pos - mem < len) { continue; }

    // make sure tail has spaces only
    pos = state.skipSpaces(pos);

    if (pos < max) { continue; }

    haveEndMarker = true;
    // found!
    break;
  }

  // If a fence has heading spaces, they should be removed from its inner block
  len = state.tShift[startLine];

  state.line = nextLine + (haveEndMarker ? 1 : 0);
  state.tokens.push({
    type: 'fence',
    params: params,
    content: state.getLines(startLine + 1, nextLine, len, true),
    lines: [ startLine, state.line ],
    level: state.level
  });

  return true;
}

// Block quotes

function blockquote(state, startLine, endLine, silent) {
  var nextLine, lastLineEmpty, oldTShift, oldBMarks, oldIndent, oldParentType, lines,
      terminatorRules,
      i, l, terminate,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  if (pos > max) { return false; }

  // check the block quote marker
  if (state.src.charCodeAt(pos++) !== 0x3E/* > */) { return false; }

  if (state.level >= state.options.maxNesting) { return false; }

  // we know that it's going to be a valid blockquote,
  // so no point trying to find the end of it in silent mode
  if (silent) { return true; }

  // skip one optional space after '>'
  if (state.src.charCodeAt(pos) === 0x20) { pos++; }

  oldIndent = state.blkIndent;
  state.blkIndent = 0;

  oldBMarks = [ state.bMarks[startLine] ];
  state.bMarks[startLine] = pos;

  // check if we have an empty blockquote
  pos = pos < max ? state.skipSpaces(pos) : pos;
  lastLineEmpty = pos >= max;

  oldTShift = [ state.tShift[startLine] ];
  state.tShift[startLine] = pos - state.bMarks[startLine];

  terminatorRules = state.parser.ruler.getRules('blockquote');

  // Search the end of the block
  //
  // Block ends with either:
  //  1. an empty line outside:
  //     ```
  //     > test
  //
  //     ```
  //  2. an empty line inside:
  //     ```
  //     >
  //     test
  //     ```
  //  3. another tag
  //     ```
  //     > test
  //      - - -
  //     ```
  for (nextLine = startLine + 1; nextLine < endLine; nextLine++) {
    pos = state.bMarks[nextLine] + state.tShift[nextLine];
    max = state.eMarks[nextLine];

    if (pos >= max) {
      // Case 1: line is not inside the blockquote, and this line is empty.
      break;
    }

    if (state.src.charCodeAt(pos++) === 0x3E/* > */) {
      // This line is inside the blockquote.

      // skip one optional space after '>'
      if (state.src.charCodeAt(pos) === 0x20) { pos++; }

      oldBMarks.push(state.bMarks[nextLine]);
      state.bMarks[nextLine] = pos;

      pos = pos < max ? state.skipSpaces(pos) : pos;
      lastLineEmpty = pos >= max;

      oldTShift.push(state.tShift[nextLine]);
      state.tShift[nextLine] = pos - state.bMarks[nextLine];
      continue;
    }

    // Case 2: line is not inside the blockquote, and the last line was empty.
    if (lastLineEmpty) { break; }

    // Case 3: another tag found.
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }

    oldBMarks.push(state.bMarks[nextLine]);
    oldTShift.push(state.tShift[nextLine]);

    // A negative number means that this is a paragraph continuation;
    //
    // Any negative number will do the job here, but it's better for it
    // to be large enough to make any bugs obvious.
    state.tShift[nextLine] = -1337;
  }

  oldParentType = state.parentType;
  state.parentType = 'blockquote';
  state.tokens.push({
    type: 'blockquote_open',
    lines: lines = [ startLine, 0 ],
    level: state.level++
  });
  state.parser.tokenize(state, startLine, nextLine);
  state.tokens.push({
    type: 'blockquote_close',
    level: --state.level
  });
  state.parentType = oldParentType;
  lines[1] = state.line;

  // Restore original tShift; this might not be necessary since the parser
  // has already been here, but just to make sure we can do that.
  for (i = 0; i < oldTShift.length; i++) {
    state.bMarks[i + startLine] = oldBMarks[i];
    state.tShift[i + startLine] = oldTShift[i];
  }
  state.blkIndent = oldIndent;

  return true;
}

// Horizontal rule

function hr(state, startLine, endLine, silent) {
  var marker, cnt, ch,
      pos = state.bMarks[startLine],
      max = state.eMarks[startLine];

  pos += state.tShift[startLine];

  if (pos > max) { return false; }

  marker = state.src.charCodeAt(pos++);

  // Check hr marker
  if (marker !== 0x2A/* * */ &&
      marker !== 0x2D/* - */ &&
      marker !== 0x5F/* _ */) {
    return false;
  }

  // markers can be mixed with spaces, but there should be at least 3 one

  cnt = 1;
  while (pos < max) {
    ch = state.src.charCodeAt(pos++);
    if (ch !== marker && ch !== 0x20/* space */) { return false; }
    if (ch === marker) { cnt++; }
  }

  if (cnt < 3) { return false; }

  if (silent) { return true; }

  state.line = startLine + 1;
  state.tokens.push({
    type: 'hr',
    lines: [ startLine, state.line ],
    level: state.level
  });

  return true;
}

// Lists

// Search `[-+*][\n ]`, returns next pos arter marker on success
// or -1 on fail.
function skipBulletListMarker(state, startLine) {
  var marker, pos, max;

  pos = state.bMarks[startLine] + state.tShift[startLine];
  max = state.eMarks[startLine];

  if (pos >= max) { return -1; }

  marker = state.src.charCodeAt(pos++);
  // Check bullet
  if (marker !== 0x2A/* * */ &&
      marker !== 0x2D/* - */ &&
      marker !== 0x2B/* + */) {
    return -1;
  }

  if (pos < max && state.src.charCodeAt(pos) !== 0x20) {
    // " 1.test " - is not a list item
    return -1;
  }

  return pos;
}

// Search `\d+[.)][\n ]`, returns next pos arter marker on success
// or -1 on fail.
function skipOrderedListMarker(state, startLine) {
  var ch,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  if (pos + 1 >= max) { return -1; }

  ch = state.src.charCodeAt(pos++);

  if (ch < 0x30/* 0 */ || ch > 0x39/* 9 */) { return -1; }

  for (;;) {
    // EOL -> fail
    if (pos >= max) { return -1; }

    ch = state.src.charCodeAt(pos++);

    if (ch >= 0x30/* 0 */ && ch <= 0x39/* 9 */) {
      continue;
    }

    // found valid marker
    if (ch === 0x29/* ) */ || ch === 0x2e/* . */) {
      break;
    }

    return -1;
  }


  if (pos < max && state.src.charCodeAt(pos) !== 0x20/* space */) {
    // " 1.test " - is not a list item
    return -1;
  }
  return pos;
}

function markTightParagraphs(state, idx) {
  var i, l,
      level = state.level + 2;

  for (i = idx + 2, l = state.tokens.length - 2; i < l; i++) {
    if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
      state.tokens[i + 2].tight = true;
      state.tokens[i].tight = true;
      i += 2;
    }
  }
}


function list(state, startLine, endLine, silent) {
  var nextLine,
      indent,
      oldTShift,
      oldIndent,
      oldTight,
      oldParentType,
      start,
      posAfterMarker,
      max,
      indentAfterMarker,
      markerValue,
      markerCharCode,
      isOrdered,
      contentStart,
      listTokIdx,
      prevEmptyEnd,
      listLines,
      itemLines,
      tight = true,
      terminatorRules,
      i, l, terminate;

  // Detect list type and position after marker
  if ((posAfterMarker = skipOrderedListMarker(state, startLine)) >= 0) {
    isOrdered = true;
  } else if ((posAfterMarker = skipBulletListMarker(state, startLine)) >= 0) {
    isOrdered = false;
  } else {
    return false;
  }

  if (state.level >= state.options.maxNesting) { return false; }

  // We should terminate list on style change. Remember first one to compare.
  markerCharCode = state.src.charCodeAt(posAfterMarker - 1);

  // For validation mode we can terminate immediately
  if (silent) { return true; }

  // Start list
  listTokIdx = state.tokens.length;

  if (isOrdered) {
    start = state.bMarks[startLine] + state.tShift[startLine];
    markerValue = Number(state.src.substr(start, posAfterMarker - start - 1));

    state.tokens.push({
      type: 'ordered_list_open',
      order: markerValue,
      lines: listLines = [ startLine, 0 ],
      level: state.level++
    });

  } else {
    state.tokens.push({
      type: 'bullet_list_open',
      lines: listLines = [ startLine, 0 ],
      level: state.level++
    });
  }

  //
  // Iterate list items
  //

  nextLine = startLine;
  prevEmptyEnd = false;
  terminatorRules = state.parser.ruler.getRules('list');

  while (nextLine < endLine) {
    contentStart = state.skipSpaces(posAfterMarker);
    max = state.eMarks[nextLine];

    if (contentStart >= max) {
      // trimming space in "-    \n  3" case, indent is 1 here
      indentAfterMarker = 1;
    } else {
      indentAfterMarker = contentStart - posAfterMarker;
    }

    // If we have more than 4 spaces, the indent is 1
    // (the rest is just indented code block)
    if (indentAfterMarker > 4) { indentAfterMarker = 1; }

    // If indent is less than 1, assume that it's one, example:
    //  "-\n  test"
    if (indentAfterMarker < 1) { indentAfterMarker = 1; }

    // "  -  test"
    //  ^^^^^ - calculating total length of this thing
    indent = (posAfterMarker - state.bMarks[nextLine]) + indentAfterMarker;

    // Run subparser & write tokens
    state.tokens.push({
      type: 'list_item_open',
      lines: itemLines = [ startLine, 0 ],
      level: state.level++
    });

    oldIndent = state.blkIndent;
    oldTight = state.tight;
    oldTShift = state.tShift[startLine];
    oldParentType = state.parentType;
    state.tShift[startLine] = contentStart - state.bMarks[startLine];
    state.blkIndent = indent;
    state.tight = true;
    state.parentType = 'list';

    state.parser.tokenize(state, startLine, endLine, true);

    // If any of list item is tight, mark list as tight
    if (!state.tight || prevEmptyEnd) {
      tight = false;
    }
    // Item become loose if finish with empty line,
    // but we should filter last element, because it means list finish
    prevEmptyEnd = (state.line - startLine) > 1 && state.isEmpty(state.line - 1);

    state.blkIndent = oldIndent;
    state.tShift[startLine] = oldTShift;
    state.tight = oldTight;
    state.parentType = oldParentType;

    state.tokens.push({
      type: 'list_item_close',
      level: --state.level
    });

    nextLine = startLine = state.line;
    itemLines[1] = nextLine;
    contentStart = state.bMarks[startLine];

    if (nextLine >= endLine) { break; }

    if (state.isEmpty(nextLine)) {
      break;
    }

    //
    // Try to check if list is terminated or continued.
    //
    if (state.tShift[nextLine] < state.blkIndent) { break; }

    // fail if terminating block found
    terminate = false;
    for (i = 0, l = terminatorRules.length; i < l; i++) {
      if (terminatorRules[i](state, nextLine, endLine, true)) {
        terminate = true;
        break;
      }
    }
    if (terminate) { break; }

    // fail if list has another type
    if (isOrdered) {
      posAfterMarker = skipOrderedListMarker(state, nextLine);
      if (posAfterMarker < 0) { break; }
    } else {
      posAfterMarker = skipBulletListMarker(state, nextLine);
      if (posAfterMarker < 0) { break; }
    }

    if (markerCharCode !== state.src.charCodeAt(posAfterMarker - 1)) { break; }
  }

  // Finilize list
  state.tokens.push({
    type: isOrdered ? 'ordered_list_close' : 'bullet_list_close',
    level: --state.level
  });
  listLines[1] = nextLine;

  state.line = nextLine;

  // mark paragraphs tight if needed
  if (tight) {
    markTightParagraphs(state, listTokIdx);
  }

  return true;
}

// Process footnote reference list

function footnote(state, startLine, endLine, silent) {
  var oldBMark, oldTShift, oldParentType, pos, label,
      start = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  // line should be at least 5 chars - "[^x]:"
  if (start + 4 > max) { return false; }

  if (state.src.charCodeAt(start) !== 0x5B/* [ */) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x5E/* ^ */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  for (pos = start + 2; pos < max; pos++) {
    if (state.src.charCodeAt(pos) === 0x20) { return false; }
    if (state.src.charCodeAt(pos) === 0x5D /* ] */) {
      break;
    }
  }

  if (pos === start + 2) { return false; } // no empty footnote labels
  if (pos + 1 >= max || state.src.charCodeAt(++pos) !== 0x3A /* : */) { return false; }
  if (silent) { return true; }
  pos++;

  if (!state.env.footnotes) { state.env.footnotes = {}; }
  if (!state.env.footnotes.refs) { state.env.footnotes.refs = {}; }
  label = state.src.slice(start + 2, pos - 2);
  state.env.footnotes.refs[':' + label] = -1;

  state.tokens.push({
    type: 'footnote_reference_open',
    label: label,
    level: state.level++
  });

  oldBMark = state.bMarks[startLine];
  oldTShift = state.tShift[startLine];
  oldParentType = state.parentType;
  state.tShift[startLine] = state.skipSpaces(pos) - pos;
  state.bMarks[startLine] = pos;
  state.blkIndent += 4;
  state.parentType = 'footnote';

  if (state.tShift[startLine] < state.blkIndent) {
    state.tShift[startLine] += state.blkIndent;
    state.bMarks[startLine] -= state.blkIndent;
  }

  state.parser.tokenize(state, startLine, endLine, true);

  state.parentType = oldParentType;
  state.blkIndent -= 4;
  state.tShift[startLine] = oldTShift;
  state.bMarks[startLine] = oldBMark;

  state.tokens.push({
    type: 'footnote_reference_close',
    level: --state.level
  });

  return true;
}

// heading (#, ##, ...)

function heading(state, startLine, endLine, silent) {
  var ch, level, tmp,
      pos = state.bMarks[startLine] + state.tShift[startLine],
      max = state.eMarks[startLine];

  if (pos >= max) { return false; }

  ch  = state.src.charCodeAt(pos);

  if (ch !== 0x23/* # */ || pos >= max) { return false; }

  // count heading level
  level = 1;
  ch = state.src.charCodeAt(++pos);
  while (ch === 0x23/* # */ && pos < max && level <= 6) {
    level++;
    ch = state.src.charCodeAt(++pos);
  }

  if (level > 6 || (pos < max && ch !== 0x20/* space */)) { return false; }

  if (silent) { return true; }

  // Let's cut tails like '    ###  ' from the end of string

  max = state.skipCharsBack(max, 0x20, pos); // space
  tmp = state.skipCharsBack(max, 0x23, pos); // #
  if (tmp > pos && state.src.charCodeAt(tmp - 1) === 0x20/* space */) {
    max = tmp;
  }

  state.line = startLine + 1;

  state.tokens.push({ type: 'heading_open',
    hLevel: level,
    lines: [ startLine, state.line ],
    level: state.level
  });

  // only if header is not empty
  if (pos < max) {
    state.tokens.push({
      type: 'inline',
      content: state.src.slice(pos, max).trim(),
      level: state.level + 1,
      lines: [ startLine, state.line ],
      children: []
    });
  }
  state.tokens.push({ type: 'heading_close', hLevel: level, level: state.level });

  return true;
}

// lheading (---, ===)

function lheading(state, startLine, endLine/*, silent*/) {
  var marker, pos, max,
      next = startLine + 1;

  if (next >= endLine) { return false; }
  if (state.tShift[next] < state.blkIndent) { return false; }

  // Scan next line

  if (state.tShift[next] - state.blkIndent > 3) { return false; }

  pos = state.bMarks[next] + state.tShift[next];
  max = state.eMarks[next];

  if (pos >= max) { return false; }

  marker = state.src.charCodeAt(pos);

  if (marker !== 0x2D/* - */ && marker !== 0x3D/* = */) { return false; }

  pos = state.skipChars(pos, marker);

  pos = state.skipSpaces(pos);

  if (pos < max) { return false; }

  pos = state.bMarks[startLine] + state.tShift[startLine];

  state.line = next + 1;
  state.tokens.push({
    type: 'heading_open',
    hLevel: marker === 0x3D/* = */ ? 1 : 2,
    lines: [ startLine, state.line ],
    level: state.level
  });
  state.tokens.push({
    type: 'inline',
    content: state.src.slice(pos, state.eMarks[startLine]).trim(),
    level: state.level + 1,
    lines: [ startLine, state.line - 1 ],
    children: []
  });
  state.tokens.push({
    type: 'heading_close',
    hLevel: marker === 0x3D/* = */ ? 1 : 2,
    level: state.level
  });

  return true;
}

// List of valid html blocks names, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#html-blocks

var html_blocks = {};

[
  'article',
  'aside',
  'button',
  'blockquote',
  'body',
  'canvas',
  'caption',
  'col',
  'colgroup',
  'dd',
  'div',
  'dl',
  'dt',
  'embed',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'header',
  'hgroup',
  'hr',
  'iframe',
  'li',
  'map',
  'object',
  'ol',
  'output',
  'p',
  'pre',
  'progress',
  'script',
  'section',
  'style',
  'table',
  'tbody',
  'td',
  'textarea',
  'tfoot',
  'th',
  'tr',
  'thead',
  'ul',
  'video'
].forEach(function (name) { html_blocks[name] = true; });

// HTML block


var HTML_TAG_OPEN_RE = /^<([a-zA-Z]{1,15})[\s\/>]/;
var HTML_TAG_CLOSE_RE = /^<\/([a-zA-Z]{1,15})[\s>]/;

function isLetter$1(ch) {
  /*eslint no-bitwise:0*/
  var lc = ch | 0x20; // to lower case
  return (lc >= 0x61/* a */) && (lc <= 0x7a/* z */);
}

function htmlblock(state, startLine, endLine, silent) {
  var ch, match, nextLine,
      pos = state.bMarks[startLine],
      max = state.eMarks[startLine],
      shift = state.tShift[startLine];

  pos += shift;

  if (!state.options.html) { return false; }

  if (shift > 3 || pos + 2 >= max) { return false; }

  if (state.src.charCodeAt(pos) !== 0x3C/* < */) { return false; }

  ch = state.src.charCodeAt(pos + 1);

  if (ch === 0x21/* ! */ || ch === 0x3F/* ? */) {
    // Directive start / comment start / processing instruction start
    if (silent) { return true; }

  } else if (ch === 0x2F/* / */ || isLetter$1(ch)) {

    // Probably start or end of tag
    if (ch === 0x2F/* \ */) {
      // closing tag
      match = state.src.slice(pos, max).match(HTML_TAG_CLOSE_RE);
      if (!match) { return false; }
    } else {
      // opening tag
      match = state.src.slice(pos, max).match(HTML_TAG_OPEN_RE);
      if (!match) { return false; }
    }
    // Make sure tag name is valid
    if (html_blocks[match[1].toLowerCase()] !== true) { return false; }
    if (silent) { return true; }

  } else {
    return false;
  }

  // If we are here - we detected HTML block.
  // Let's roll down till empty line (block end).
  nextLine = startLine + 1;
  while (nextLine < state.lineMax && !state.isEmpty(nextLine)) {
    nextLine++;
  }

  state.line = nextLine;
  state.tokens.push({
    type: 'htmlblock',
    level: state.level,
    lines: [ startLine, state.line ],
    content: state.getLines(startLine, nextLine, 0, true)
  });

  return true;
}

// GFM table, non-standard

function getLine(state, line) {
  var pos = state.bMarks[line] + state.blkIndent,
      max = state.eMarks[line];

  return state.src.substr(pos, max - pos);
}

function table(state, startLine, endLine, silent) {
  var ch, lineText, pos, i, nextLine, rows, cell,
      aligns, t, tableLines, tbodyLines;

  // should have at least three lines
  if (startLine + 2 > endLine) { return false; }

  nextLine = startLine + 1;

  if (state.tShift[nextLine] < state.blkIndent) { return false; }

  // first character of the second line should be '|' or '-'

  pos = state.bMarks[nextLine] + state.tShift[nextLine];
  if (pos >= state.eMarks[nextLine]) { return false; }

  ch = state.src.charCodeAt(pos);
  if (ch !== 0x7C/* | */ && ch !== 0x2D/* - */ && ch !== 0x3A/* : */) { return false; }

  lineText = getLine(state, startLine + 1);
  if (!/^[-:| ]+$/.test(lineText)) { return false; }

  rows = lineText.split('|');
  if (rows <= 2) { return false; }
  aligns = [];
  for (i = 0; i < rows.length; i++) {
    t = rows[i].trim();
    if (!t) {
      // allow empty columns before and after table, but not in between columns;
      // e.g. allow ` |---| `, disallow ` ---||--- `
      if (i === 0 || i === rows.length - 1) {
        continue;
      } else {
        return false;
      }
    }

    if (!/^:?-+:?$/.test(t)) { return false; }
    if (t.charCodeAt(t.length - 1) === 0x3A/* : */) {
      aligns.push(t.charCodeAt(0) === 0x3A/* : */ ? 'center' : 'right');
    } else if (t.charCodeAt(0) === 0x3A/* : */) {
      aligns.push('left');
    } else {
      aligns.push('');
    }
  }

  lineText = getLine(state, startLine).trim();
  if (lineText.indexOf('|') === -1) { return false; }
  rows = lineText.replace(/^\||\|$/g, '').split('|');
  if (aligns.length !== rows.length) { return false; }
  if (silent) { return true; }

  state.tokens.push({
    type: 'table_open',
    lines: tableLines = [ startLine, 0 ],
    level: state.level++
  });
  state.tokens.push({
    type: 'thead_open',
    lines: [ startLine, startLine + 1 ],
    level: state.level++
  });

  state.tokens.push({
    type: 'tr_open',
    lines: [ startLine, startLine + 1 ],
    level: state.level++
  });
  for (i = 0; i < rows.length; i++) {
    state.tokens.push({
      type: 'th_open',
      align: aligns[i],
      lines: [ startLine, startLine + 1 ],
      level: state.level++
    });
    state.tokens.push({
      type: 'inline',
      content: rows[i].trim(),
      lines: [ startLine, startLine + 1 ],
      level: state.level,
      children: []
    });
    state.tokens.push({ type: 'th_close', level: --state.level });
  }
  state.tokens.push({ type: 'tr_close', level: --state.level });
  state.tokens.push({ type: 'thead_close', level: --state.level });

  state.tokens.push({
    type: 'tbody_open',
    lines: tbodyLines = [ startLine + 2, 0 ],
    level: state.level++
  });

  for (nextLine = startLine + 2; nextLine < endLine; nextLine++) {
    if (state.tShift[nextLine] < state.blkIndent) { break; }

    lineText = getLine(state, nextLine).trim();
    if (lineText.indexOf('|') === -1) { break; }
    rows = lineText.replace(/^\||\|$/g, '').split('|');

    state.tokens.push({ type: 'tr_open', level: state.level++ });
    for (i = 0; i < rows.length; i++) {
      state.tokens.push({ type: 'td_open', align: aligns[i], level: state.level++ });
      // 0x7c === '|'
      cell = rows[i].substring(
          rows[i].charCodeAt(0) === 0x7c ? 1 : 0,
          rows[i].charCodeAt(rows[i].length - 1) === 0x7c ? rows[i].length - 1 : rows[i].length
      ).trim();
      state.tokens.push({
        type: 'inline',
        content: cell,
        level: state.level,
        children: []
      });
      state.tokens.push({ type: 'td_close', level: --state.level });
    }
    state.tokens.push({ type: 'tr_close', level: --state.level });
  }
  state.tokens.push({ type: 'tbody_close', level: --state.level });
  state.tokens.push({ type: 'table_close', level: --state.level });

  tableLines[1] = tbodyLines[1] = nextLine;
  state.line = nextLine;
  return true;
}

// Definition lists

// Search `[:~][\n ]`, returns next pos after marker on success
// or -1 on fail.
function skipMarker(state, line) {
  var pos, marker,
      start = state.bMarks[line] + state.tShift[line],
      max = state.eMarks[line];

  if (start >= max) { return -1; }

  // Check bullet
  marker = state.src.charCodeAt(start++);
  if (marker !== 0x7E/* ~ */ && marker !== 0x3A/* : */) { return -1; }

  pos = state.skipSpaces(start);

  // require space after ":"
  if (start === pos) { return -1; }

  // no empty definitions, e.g. "  : "
  if (pos >= max) { return -1; }

  return pos;
}

function markTightParagraphs$1(state, idx) {
  var i, l,
      level = state.level + 2;

  for (i = idx + 2, l = state.tokens.length - 2; i < l; i++) {
    if (state.tokens[i].level === level && state.tokens[i].type === 'paragraph_open') {
      state.tokens[i + 2].tight = true;
      state.tokens[i].tight = true;
      i += 2;
    }
  }
}

function deflist(state, startLine, endLine, silent) {
  var contentStart,
      ddLine,
      dtLine,
      itemLines,
      listLines,
      listTokIdx,
      nextLine,
      oldIndent,
      oldDDIndent,
      oldParentType,
      oldTShift,
      oldTight,
      prevEmptyEnd,
      tight;

  if (silent) {
    // quirk: validation mode validates a dd block only, not a whole deflist
    if (state.ddIndent < 0) { return false; }
    return skipMarker(state, startLine) >= 0;
  }

  nextLine = startLine + 1;
  if (state.isEmpty(nextLine)) {
    if (++nextLine > endLine) { return false; }
  }

  if (state.tShift[nextLine] < state.blkIndent) { return false; }
  contentStart = skipMarker(state, nextLine);
  if (contentStart < 0) { return false; }

  if (state.level >= state.options.maxNesting) { return false; }

  // Start list
  listTokIdx = state.tokens.length;

  state.tokens.push({
    type: 'dl_open',
    lines: listLines = [ startLine, 0 ],
    level: state.level++
  });

  //
  // Iterate list items
  //

  dtLine = startLine;
  ddLine = nextLine;

  // One definition list can contain multiple DTs,
  // and one DT can be followed by multiple DDs.
  //
  // Thus, there is two loops here, and label is
  // needed to break out of the second one
  //
  /*eslint no-labels:0,block-scoped-var:0*/
  OUTER:
  for (;;) {
    tight = true;
    prevEmptyEnd = false;

    state.tokens.push({
      type: 'dt_open',
      lines: [ dtLine, dtLine ],
      level: state.level++
    });
    state.tokens.push({
      type: 'inline',
      content: state.getLines(dtLine, dtLine + 1, state.blkIndent, false).trim(),
      level: state.level + 1,
      lines: [ dtLine, dtLine ],
      children: []
    });
    state.tokens.push({
      type: 'dt_close',
      level: --state.level
    });

    for (;;) {
      state.tokens.push({
        type: 'dd_open',
        lines: itemLines = [ nextLine, 0 ],
        level: state.level++
      });

      oldTight = state.tight;
      oldDDIndent = state.ddIndent;
      oldIndent = state.blkIndent;
      oldTShift = state.tShift[ddLine];
      oldParentType = state.parentType;
      state.blkIndent = state.ddIndent = state.tShift[ddLine] + 2;
      state.tShift[ddLine] = contentStart - state.bMarks[ddLine];
      state.tight = true;
      state.parentType = 'deflist';

      state.parser.tokenize(state, ddLine, endLine, true);

      // If any of list item is tight, mark list as tight
      if (!state.tight || prevEmptyEnd) {
        tight = false;
      }
      // Item become loose if finish with empty line,
      // but we should filter last element, because it means list finish
      prevEmptyEnd = (state.line - ddLine) > 1 && state.isEmpty(state.line - 1);

      state.tShift[ddLine] = oldTShift;
      state.tight = oldTight;
      state.parentType = oldParentType;
      state.blkIndent = oldIndent;
      state.ddIndent = oldDDIndent;

      state.tokens.push({
        type: 'dd_close',
        level: --state.level
      });

      itemLines[1] = nextLine = state.line;

      if (nextLine >= endLine) { break OUTER; }

      if (state.tShift[nextLine] < state.blkIndent) { break OUTER; }
      contentStart = skipMarker(state, nextLine);
      if (contentStart < 0) { break; }

      ddLine = nextLine;

      // go to the next loop iteration:
      // insert DD tag and repeat checking
    }

    if (nextLine >= endLine) { break; }
    dtLine = nextLine;

    if (state.isEmpty(dtLine)) { break; }
    if (state.tShift[dtLine] < state.blkIndent) { break; }

    ddLine = dtLine + 1;
    if (ddLine >= endLine) { break; }
    if (state.isEmpty(ddLine)) { ddLine++; }
    if (ddLine >= endLine) { break; }

    if (state.tShift[ddLine] < state.blkIndent) { break; }
    contentStart = skipMarker(state, ddLine);
    if (contentStart < 0) { break; }

    // go to the next loop iteration:
    // insert DT and DD tags and repeat checking
  }

  // Finilize list
  state.tokens.push({
    type: 'dl_close',
    level: --state.level
  });
  listLines[1] = nextLine;

  state.line = nextLine;

  // mark paragraphs tight if needed
  if (tight) {
    markTightParagraphs$1(state, listTokIdx);
  }

  return true;
}

// Paragraph

function paragraph(state, startLine/*, endLine*/) {
  var endLine, content, terminate, i, l,
      nextLine = startLine + 1,
      terminatorRules;

  endLine = state.lineMax;

  // jump line-by-line until empty one or EOF
  if (nextLine < endLine && !state.isEmpty(nextLine)) {
    terminatorRules = state.parser.ruler.getRules('paragraph');

    for (; nextLine < endLine && !state.isEmpty(nextLine); nextLine++) {
      // this would be a code block normally, but after paragraph
      // it's considered a lazy continuation regardless of what's there
      if (state.tShift[nextLine] - state.blkIndent > 3) { continue; }

      // Some tags can terminate paragraph without empty line.
      terminate = false;
      for (i = 0, l = terminatorRules.length; i < l; i++) {
        if (terminatorRules[i](state, nextLine, endLine, true)) {
          terminate = true;
          break;
        }
      }
      if (terminate) { break; }
    }
  }

  content = state.getLines(startLine, nextLine, state.blkIndent, false).trim();

  state.line = nextLine;
  if (content.length) {
    state.tokens.push({
      type: 'paragraph_open',
      tight: false,
      lines: [ startLine, state.line ],
      level: state.level
    });
    state.tokens.push({
      type: 'inline',
      content: content,
      level: state.level + 1,
      lines: [ startLine, state.line ],
      children: []
    });
    state.tokens.push({
      type: 'paragraph_close',
      tight: false,
      level: state.level
    });
  }

  return true;
}

/**
 * Parser rules
 */

var _rules$1 = [
  [ 'code',       code ],
  [ 'fences',     fences,     [ 'paragraph', 'blockquote', 'list' ] ],
  [ 'blockquote', blockquote, [ 'paragraph', 'blockquote', 'list' ] ],
  [ 'hr',         hr,         [ 'paragraph', 'blockquote', 'list' ] ],
  [ 'list',       list,       [ 'paragraph', 'blockquote' ] ],
  [ 'footnote',   footnote,   [ 'paragraph' ] ],
  [ 'heading',    heading,    [ 'paragraph', 'blockquote' ] ],
  [ 'lheading',   lheading ],
  [ 'htmlblock',  htmlblock,  [ 'paragraph', 'blockquote' ] ],
  [ 'table',      table,      [ 'paragraph' ] ],
  [ 'deflist',    deflist,    [ 'paragraph' ] ],
  [ 'paragraph',  paragraph ]
];

/**
 * Block Parser class
 *
 * @api private
 */

function ParserBlock() {
  this.ruler = new Ruler();
  for (var i = 0; i < _rules$1.length; i++) {
    this.ruler.push(_rules$1[i][0], _rules$1[i][1], {
      alt: (_rules$1[i][2] || []).slice()
    });
  }
}

/**
 * Generate tokens for the given input range.
 *
 * @param  {Object} `state` Has properties like `src`, `parser`, `options` etc
 * @param  {Number} `startLine`
 * @param  {Number} `endLine`
 * @api private
 */

ParserBlock.prototype.tokenize = function (state, startLine, endLine) {
  var rules = this.ruler.getRules('');
  var len = rules.length;
  var line = startLine;
  var hasEmptyLines = false;
  var ok, i;

  while (line < endLine) {
    state.line = line = state.skipEmptyLines(line);
    if (line >= endLine) {
      break;
    }

    // Termination condition for nested calls.
    // Nested calls currently used for blockquotes & lists
    if (state.tShift[line] < state.blkIndent) {
      break;
    }

    // Try all possible rules.
    // On success, rule should:
    //
    // - update `state.line`
    // - update `state.tokens`
    // - return true

    for (i = 0; i < len; i++) {
      ok = rules[i](state, line, endLine, false);
      if (ok) {
        break;
      }
    }

    // set state.tight iff we had an empty line before current tag
    // i.e. latest empty line should not count
    state.tight = !hasEmptyLines;

    // paragraph might "eat" one newline after it in nested lists
    if (state.isEmpty(state.line - 1)) {
      hasEmptyLines = true;
    }

    line = state.line;

    if (line < endLine && state.isEmpty(line)) {
      hasEmptyLines = true;
      line++;

      // two empty lines should stop the parser in list mode
      if (line < endLine && state.parentType === 'list' && state.isEmpty(line)) { break; }
      state.line = line;
    }
  }
};

var TABS_SCAN_RE = /[\n\t]/g;
var NEWLINES_RE  = /\r[\n\u0085]|[\u2424\u2028\u0085]/g;
var SPACES_RE    = /\u00a0/g;

/**
 * Tokenize the given `str`.
 *
 * @param  {String} `str` Source string
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @param  {Array} `outTokens`
 * @api private
 */

ParserBlock.prototype.parse = function (str, options, env, outTokens) {
  var state, lineStart = 0, lastTabPos = 0;
  if (!str) { return []; }

  // Normalize spaces
  str = str.replace(SPACES_RE, ' ');

  // Normalize newlines
  str = str.replace(NEWLINES_RE, '\n');

  // Replace tabs with proper number of spaces (1..4)
  if (str.indexOf('\t') >= 0) {
    str = str.replace(TABS_SCAN_RE, function (match, offset) {
      var result;
      if (str.charCodeAt(offset) === 0x0A) {
        lineStart = offset + 1;
        lastTabPos = 0;
        return match;
      }
      result = '    '.slice((offset - lineStart - lastTabPos) % 4);
      lastTabPos = offset - lineStart + 1;
      return result;
    });
  }

  state = new StateBlock(str, this, options, env, outTokens);
  this.tokenize(state, state.line, state.lineMax);
};

// Skip text characters for text token, place those to pending buffer
// and increment current pos

// Rule to skip pure text
// '{}$%@~+=:' reserved for extentions

function isTerminatorChar(ch) {
  switch (ch) {
    case 0x0A/* \n */:
    case 0x5C/* \ */:
    case 0x60/* ` */:
    case 0x2A/* * */:
    case 0x5F/* _ */:
    case 0x5E/* ^ */:
    case 0x5B/* [ */:
    case 0x5D/* ] */:
    case 0x21/* ! */:
    case 0x26/* & */:
    case 0x3C/* < */:
    case 0x3E/* > */:
    case 0x7B/* { */:
    case 0x7D/* } */:
    case 0x24/* $ */:
    case 0x25/* % */:
    case 0x40/* @ */:
    case 0x7E/* ~ */:
    case 0x2B/* + */:
    case 0x3D/* = */:
    case 0x3A/* : */:
      return true;
    default:
      return false;
  }
}

function text(state, silent) {
  var pos = state.pos;

  while (pos < state.posMax && !isTerminatorChar(state.src.charCodeAt(pos))) {
    pos++;
  }

  if (pos === state.pos) { return false; }

  if (!silent) { state.pending += state.src.slice(state.pos, pos); }

  state.pos = pos;

  return true;
}

// Proceess '\n'

function newline(state, silent) {
  var pmax, max, pos = state.pos;

  if (state.src.charCodeAt(pos) !== 0x0A/* \n */) { return false; }

  pmax = state.pending.length - 1;
  max = state.posMax;

  // '  \n' -> hardbreak
  // Lookup in pending chars is bad practice! Don't copy to other rules!
  // Pending string is stored in concat mode, indexed lookups will cause
  // convertion to flat mode.
  if (!silent) {
    if (pmax >= 0 && state.pending.charCodeAt(pmax) === 0x20) {
      if (pmax >= 1 && state.pending.charCodeAt(pmax - 1) === 0x20) {
        // Strip out all trailing spaces on this line.
        for (var i = pmax - 2; i >= 0; i--) {
          if (state.pending.charCodeAt(i) !== 0x20) {
            state.pending = state.pending.substring(0, i + 1);
            break;
          }
        }
        state.push({
          type: 'hardbreak',
          level: state.level
        });
      } else {
        state.pending = state.pending.slice(0, -1);
        state.push({
          type: 'softbreak',
          level: state.level
        });
      }

    } else {
      state.push({
        type: 'softbreak',
        level: state.level
      });
    }
  }

  pos++;

  // skip heading spaces for next line
  while (pos < max && state.src.charCodeAt(pos) === 0x20) { pos++; }

  state.pos = pos;
  return true;
}

// Proceess escaped chars and hardbreaks

var ESCAPED = [];

for (var i = 0; i < 256; i++) { ESCAPED.push(0); }

'\\!"#$%&\'()*+,./:;<=>?@[]^_`{|}~-'
  .split('').forEach(function(ch) { ESCAPED[ch.charCodeAt(0)] = 1; });


function escape(state, silent) {
  var ch, pos = state.pos, max = state.posMax;

  if (state.src.charCodeAt(pos) !== 0x5C/* \ */) { return false; }

  pos++;

  if (pos < max) {
    ch = state.src.charCodeAt(pos);

    if (ch < 256 && ESCAPED[ch] !== 0) {
      if (!silent) { state.pending += state.src[pos]; }
      state.pos += 2;
      return true;
    }

    if (ch === 0x0A) {
      if (!silent) {
        state.push({
          type: 'hardbreak',
          level: state.level
        });
      }

      pos++;
      // skip leading whitespaces from next line
      while (pos < max && state.src.charCodeAt(pos) === 0x20) { pos++; }

      state.pos = pos;
      return true;
    }
  }

  if (!silent) { state.pending += '\\'; }
  state.pos++;
  return true;
}

// Parse backticks

function backticks(state, silent) {
  var start, max, marker, matchStart, matchEnd,
      pos = state.pos,
      ch = state.src.charCodeAt(pos);

  if (ch !== 0x60/* ` */) { return false; }

  start = pos;
  pos++;
  max = state.posMax;

  while (pos < max && state.src.charCodeAt(pos) === 0x60/* ` */) { pos++; }

  marker = state.src.slice(start, pos);

  matchStart = matchEnd = pos;

  while ((matchStart = state.src.indexOf('`', matchEnd)) !== -1) {
    matchEnd = matchStart + 1;

    while (matchEnd < max && state.src.charCodeAt(matchEnd) === 0x60/* ` */) { matchEnd++; }

    if (matchEnd - matchStart === marker.length) {
      if (!silent) {
        state.push({
          type: 'code',
          content: state.src.slice(pos, matchStart)
                              .replace(/[ \n]+/g, ' ')
                              .trim(),
          block: false,
          level: state.level
        });
      }
      state.pos = matchEnd;
      return true;
    }
  }

  if (!silent) { state.pending += marker; }
  state.pos += marker.length;
  return true;
}

// Process ~~deleted text~~

function del(state, silent) {
  var found,
      pos,
      stack,
      max = state.posMax,
      start = state.pos,
      lastChar,
      nextChar;

  if (state.src.charCodeAt(start) !== 0x7E/* ~ */) { return false; }
  if (silent) { return false; } // don't run any pairs in validation mode
  if (start + 4 >= max) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x7E/* ~ */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
  nextChar = state.src.charCodeAt(start + 2);

  if (lastChar === 0x7E/* ~ */) { return false; }
  if (nextChar === 0x7E/* ~ */) { return false; }
  if (nextChar === 0x20 || nextChar === 0x0A) { return false; }

  pos = start + 2;
  while (pos < max && state.src.charCodeAt(pos) === 0x7E/* ~ */) { pos++; }
  if (pos > start + 3) {
    // sequence of 4+ markers taking as literal, same as in a emphasis
    state.pos += pos - start;
    if (!silent) { state.pending += state.src.slice(start, pos); }
    return true;
  }

  state.pos = start + 2;
  stack = 1;

  while (state.pos + 1 < max) {
    if (state.src.charCodeAt(state.pos) === 0x7E/* ~ */) {
      if (state.src.charCodeAt(state.pos + 1) === 0x7E/* ~ */) {
        lastChar = state.src.charCodeAt(state.pos - 1);
        nextChar = state.pos + 2 < max ? state.src.charCodeAt(state.pos + 2) : -1;
        if (nextChar !== 0x7E/* ~ */ && lastChar !== 0x7E/* ~ */) {
          if (lastChar !== 0x20 && lastChar !== 0x0A) {
            // closing '~~'
            stack--;
          } else if (nextChar !== 0x20 && nextChar !== 0x0A) {
            // opening '~~'
            stack++;
          } // else {
            //  // standalone ' ~~ ' indented with spaces
            // }
          if (stack <= 0) {
            found = true;
            break;
          }
        }
      }
    }

    state.parser.skipToken(state);
  }

  if (!found) {
    // parser failed to find ending tag, so it's not valid emphasis
    state.pos = start;
    return false;
  }

  // found!
  state.posMax = state.pos;
  state.pos = start + 2;

  if (!silent) {
    state.push({ type: 'del_open', level: state.level++ });
    state.parser.tokenize(state);
    state.push({ type: 'del_close', level: --state.level });
  }

  state.pos = state.posMax + 2;
  state.posMax = max;
  return true;
}

// Process ++inserted text++

function ins(state, silent) {
  var found,
      pos,
      stack,
      max = state.posMax,
      start = state.pos,
      lastChar,
      nextChar;

  if (state.src.charCodeAt(start) !== 0x2B/* + */) { return false; }
  if (silent) { return false; } // don't run any pairs in validation mode
  if (start + 4 >= max) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x2B/* + */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
  nextChar = state.src.charCodeAt(start + 2);

  if (lastChar === 0x2B/* + */) { return false; }
  if (nextChar === 0x2B/* + */) { return false; }
  if (nextChar === 0x20 || nextChar === 0x0A) { return false; }

  pos = start + 2;
  while (pos < max && state.src.charCodeAt(pos) === 0x2B/* + */) { pos++; }
  if (pos !== start + 2) {
    // sequence of 3+ markers taking as literal, same as in a emphasis
    state.pos += pos - start;
    if (!silent) { state.pending += state.src.slice(start, pos); }
    return true;
  }

  state.pos = start + 2;
  stack = 1;

  while (state.pos + 1 < max) {
    if (state.src.charCodeAt(state.pos) === 0x2B/* + */) {
      if (state.src.charCodeAt(state.pos + 1) === 0x2B/* + */) {
        lastChar = state.src.charCodeAt(state.pos - 1);
        nextChar = state.pos + 2 < max ? state.src.charCodeAt(state.pos + 2) : -1;
        if (nextChar !== 0x2B/* + */ && lastChar !== 0x2B/* + */) {
          if (lastChar !== 0x20 && lastChar !== 0x0A) {
            // closing '++'
            stack--;
          } else if (nextChar !== 0x20 && nextChar !== 0x0A) {
            // opening '++'
            stack++;
          } // else {
            //  // standalone ' ++ ' indented with spaces
            // }
          if (stack <= 0) {
            found = true;
            break;
          }
        }
      }
    }

    state.parser.skipToken(state);
  }

  if (!found) {
    // parser failed to find ending tag, so it's not valid emphasis
    state.pos = start;
    return false;
  }

  // found!
  state.posMax = state.pos;
  state.pos = start + 2;

  if (!silent) {
    state.push({ type: 'ins_open', level: state.level++ });
    state.parser.tokenize(state);
    state.push({ type: 'ins_close', level: --state.level });
  }

  state.pos = state.posMax + 2;
  state.posMax = max;
  return true;
}

// Process ==highlighted text==

function mark(state, silent) {
  var found,
      pos,
      stack,
      max = state.posMax,
      start = state.pos,
      lastChar,
      nextChar;

  if (state.src.charCodeAt(start) !== 0x3D/* = */) { return false; }
  if (silent) { return false; } // don't run any pairs in validation mode
  if (start + 4 >= max) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x3D/* = */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;
  nextChar = state.src.charCodeAt(start + 2);

  if (lastChar === 0x3D/* = */) { return false; }
  if (nextChar === 0x3D/* = */) { return false; }
  if (nextChar === 0x20 || nextChar === 0x0A) { return false; }

  pos = start + 2;
  while (pos < max && state.src.charCodeAt(pos) === 0x3D/* = */) { pos++; }
  if (pos !== start + 2) {
    // sequence of 3+ markers taking as literal, same as in a emphasis
    state.pos += pos - start;
    if (!silent) { state.pending += state.src.slice(start, pos); }
    return true;
  }

  state.pos = start + 2;
  stack = 1;

  while (state.pos + 1 < max) {
    if (state.src.charCodeAt(state.pos) === 0x3D/* = */) {
      if (state.src.charCodeAt(state.pos + 1) === 0x3D/* = */) {
        lastChar = state.src.charCodeAt(state.pos - 1);
        nextChar = state.pos + 2 < max ? state.src.charCodeAt(state.pos + 2) : -1;
        if (nextChar !== 0x3D/* = */ && lastChar !== 0x3D/* = */) {
          if (lastChar !== 0x20 && lastChar !== 0x0A) {
            // closing '=='
            stack--;
          } else if (nextChar !== 0x20 && nextChar !== 0x0A) {
            // opening '=='
            stack++;
          } // else {
            //  // standalone ' == ' indented with spaces
            // }
          if (stack <= 0) {
            found = true;
            break;
          }
        }
      }
    }

    state.parser.skipToken(state);
  }

  if (!found) {
    // parser failed to find ending tag, so it's not valid emphasis
    state.pos = start;
    return false;
  }

  // found!
  state.posMax = state.pos;
  state.pos = start + 2;

  if (!silent) {
    state.push({ type: 'mark_open', level: state.level++ });
    state.parser.tokenize(state);
    state.push({ type: 'mark_close', level: --state.level });
  }

  state.pos = state.posMax + 2;
  state.posMax = max;
  return true;
}

// Process *this* and _that_

function isAlphaNum(code) {
  return (code >= 0x30 /* 0 */ && code <= 0x39 /* 9 */) ||
         (code >= 0x41 /* A */ && code <= 0x5A /* Z */) ||
         (code >= 0x61 /* a */ && code <= 0x7A /* z */);
}

// parse sequence of emphasis markers,
// "start" should point at a valid marker
function scanDelims(state, start) {
  var pos = start, lastChar, nextChar, count,
      can_open = true,
      can_close = true,
      max = state.posMax,
      marker = state.src.charCodeAt(start);

  lastChar = start > 0 ? state.src.charCodeAt(start - 1) : -1;

  while (pos < max && state.src.charCodeAt(pos) === marker) { pos++; }
  if (pos >= max) { can_open = false; }
  count = pos - start;

  if (count >= 4) {
    // sequence of four or more unescaped markers can't start/end an emphasis
    can_open = can_close = false;
  } else {
    nextChar = pos < max ? state.src.charCodeAt(pos) : -1;

    // check whitespace conditions
    if (nextChar === 0x20 || nextChar === 0x0A) { can_open = false; }
    if (lastChar === 0x20 || lastChar === 0x0A) { can_close = false; }

    if (marker === 0x5F /* _ */) {
      // check if we aren't inside the word
      if (isAlphaNum(lastChar)) { can_open = false; }
      if (isAlphaNum(nextChar)) { can_close = false; }
    }
  }

  return {
    can_open: can_open,
    can_close: can_close,
    delims: count
  };
}

function emphasis(state, silent) {
  var startCount,
      count,
      found,
      oldCount,
      newCount,
      stack,
      res,
      max = state.posMax,
      start = state.pos,
      marker = state.src.charCodeAt(start);

  if (marker !== 0x5F/* _ */ && marker !== 0x2A /* * */) { return false; }
  if (silent) { return false; } // don't run any pairs in validation mode

  res = scanDelims(state, start);
  startCount = res.delims;
  if (!res.can_open) {
    state.pos += startCount;
    if (!silent) { state.pending += state.src.slice(start, state.pos); }
    return true;
  }

  if (state.level >= state.options.maxNesting) { return false; }

  state.pos = start + startCount;
  stack = [ startCount ];

  while (state.pos < max) {
    if (state.src.charCodeAt(state.pos) === marker) {
      res = scanDelims(state, state.pos);
      count = res.delims;
      if (res.can_close) {
        oldCount = stack.pop();
        newCount = count;

        while (oldCount !== newCount) {
          if (newCount < oldCount) {
            stack.push(oldCount - newCount);
            break;
          }

          // assert(newCount > oldCount)
          newCount -= oldCount;

          if (stack.length === 0) { break; }
          state.pos += oldCount;
          oldCount = stack.pop();
        }

        if (stack.length === 0) {
          startCount = oldCount;
          found = true;
          break;
        }
        state.pos += count;
        continue;
      }

      if (res.can_open) { stack.push(count); }
      state.pos += count;
      continue;
    }

    state.parser.skipToken(state);
  }

  if (!found) {
    // parser failed to find ending tag, so it's not valid emphasis
    state.pos = start;
    return false;
  }

  // found!
  state.posMax = state.pos;
  state.pos = start + startCount;

  if (!silent) {
    if (startCount === 2 || startCount === 3) {
      state.push({ type: 'strong_open', level: state.level++ });
    }
    if (startCount === 1 || startCount === 3) {
      state.push({ type: 'em_open', level: state.level++ });
    }

    state.parser.tokenize(state);

    if (startCount === 1 || startCount === 3) {
      state.push({ type: 'em_close', level: --state.level });
    }
    if (startCount === 2 || startCount === 3) {
      state.push({ type: 'strong_close', level: --state.level });
    }
  }

  state.pos = state.posMax + startCount;
  state.posMax = max;
  return true;
}

// Process ~subscript~

// same as UNESCAPE_MD_RE plus a space
var UNESCAPE_RE = /\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;

function sub(state, silent) {
  var found,
      content,
      max = state.posMax,
      start = state.pos;

  if (state.src.charCodeAt(start) !== 0x7E/* ~ */) { return false; }
  if (silent) { return false; } // don't run any pairs in validation mode
  if (start + 2 >= max) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  state.pos = start + 1;

  while (state.pos < max) {
    if (state.src.charCodeAt(state.pos) === 0x7E/* ~ */) {
      found = true;
      break;
    }

    state.parser.skipToken(state);
  }

  if (!found || start + 1 === state.pos) {
    state.pos = start;
    return false;
  }

  content = state.src.slice(start + 1, state.pos);

  // don't allow unescaped spaces/newlines inside
  if (content.match(/(^|[^\\])(\\\\)*\s/)) {
    state.pos = start;
    return false;
  }

  // found!
  state.posMax = state.pos;
  state.pos = start + 1;

  if (!silent) {
    state.push({
      type: 'sub',
      level: state.level,
      content: content.replace(UNESCAPE_RE, '$1')
    });
  }

  state.pos = state.posMax + 1;
  state.posMax = max;
  return true;
}

// Process ^superscript^

// same as UNESCAPE_MD_RE plus a space
var UNESCAPE_RE$1 = /\\([ \\!"#$%&'()*+,.\/:;<=>?@[\]^_`{|}~-])/g;

function sup(state, silent) {
  var found,
      content,
      max = state.posMax,
      start = state.pos;

  if (state.src.charCodeAt(start) !== 0x5E/* ^ */) { return false; }
  if (silent) { return false; } // don't run any pairs in validation mode
  if (start + 2 >= max) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  state.pos = start + 1;

  while (state.pos < max) {
    if (state.src.charCodeAt(state.pos) === 0x5E/* ^ */) {
      found = true;
      break;
    }

    state.parser.skipToken(state);
  }

  if (!found || start + 1 === state.pos) {
    state.pos = start;
    return false;
  }

  content = state.src.slice(start + 1, state.pos);

  // don't allow unescaped spaces/newlines inside
  if (content.match(/(^|[^\\])(\\\\)*\s/)) {
    state.pos = start;
    return false;
  }

  // found!
  state.posMax = state.pos;
  state.pos = start + 1;

  if (!silent) {
    state.push({
      type: 'sup',
      level: state.level,
      content: content.replace(UNESCAPE_RE$1, '$1')
    });
  }

  state.pos = state.posMax + 1;
  state.posMax = max;
  return true;
}

// Process [links](<to> "stuff")


function links(state, silent) {
  var labelStart,
      labelEnd,
      label,
      href,
      title,
      pos,
      ref,
      code,
      isImage = false,
      oldPos = state.pos,
      max = state.posMax,
      start = state.pos,
      marker = state.src.charCodeAt(start);

  if (marker === 0x21/* ! */) {
    isImage = true;
    marker = state.src.charCodeAt(++start);
  }

  if (marker !== 0x5B/* [ */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  labelStart = start + 1;
  labelEnd = parseLinkLabel(state, start);

  // parser failed to find ']', so it's not a valid link
  if (labelEnd < 0) { return false; }

  pos = labelEnd + 1;
  if (pos < max && state.src.charCodeAt(pos) === 0x28/* ( */) {
    //
    // Inline link
    //

    // [link](  <href>  "title"  )
    //        ^^ skipping these spaces
    pos++;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (code !== 0x20 && code !== 0x0A) { break; }
    }
    if (pos >= max) { return false; }

    // [link](  <href>  "title"  )
    //          ^^^^^^ parsing link destination
    start = pos;
    if (parseLinkDestination(state, pos)) {
      href = state.linkContent;
      pos = state.pos;
    } else {
      href = '';
    }

    // [link](  <href>  "title"  )
    //                ^^ skipping these spaces
    start = pos;
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (code !== 0x20 && code !== 0x0A) { break; }
    }

    // [link](  <href>  "title"  )
    //                  ^^^^^^^ parsing link title
    if (pos < max && start !== pos && parseLinkTitle(state, pos)) {
      title = state.linkContent;
      pos = state.pos;

      // [link](  <href>  "title"  )
      //                         ^^ skipping these spaces
      for (; pos < max; pos++) {
        code = state.src.charCodeAt(pos);
        if (code !== 0x20 && code !== 0x0A) { break; }
      }
    } else {
      title = '';
    }

    if (pos >= max || state.src.charCodeAt(pos) !== 0x29/* ) */) {
      state.pos = oldPos;
      return false;
    }
    pos++;
  } else {
    //
    // Link reference
    //

    // do not allow nested reference links
    if (state.linkLevel > 0) { return false; }

    // [foo]  [bar]
    //      ^^ optional whitespace (can include newlines)
    for (; pos < max; pos++) {
      code = state.src.charCodeAt(pos);
      if (code !== 0x20 && code !== 0x0A) { break; }
    }

    if (pos < max && state.src.charCodeAt(pos) === 0x5B/* [ */) {
      start = pos + 1;
      pos = parseLinkLabel(state, pos);
      if (pos >= 0) {
        label = state.src.slice(start, pos++);
      } else {
        pos = start - 1;
      }
    }

    // covers label === '' and label === undefined
    // (collapsed reference link and shortcut reference link respectively)
    if (!label) {
      if (typeof label === 'undefined') {
        pos = labelEnd + 1;
      }
      label = state.src.slice(labelStart, labelEnd);
    }

    ref = state.env.references[normalizeReference(label)];
    if (!ref) {
      state.pos = oldPos;
      return false;
    }
    href = ref.href;
    title = ref.title;
  }

  //
  // We found the end of the link, and know for a fact it's a valid link;
  // so all that's left to do is to call tokenizer.
  //
  if (!silent) {
    state.pos = labelStart;
    state.posMax = labelEnd;

    if (isImage) {
      state.push({
        type: 'image',
        src: href,
        title: title,
        alt: state.src.substr(labelStart, labelEnd - labelStart),
        level: state.level
      });
    } else {
      state.push({
        type: 'link_open',
        href: href,
        title: title,
        level: state.level++
      });
      state.linkLevel++;
      state.parser.tokenize(state);
      state.linkLevel--;
      state.push({ type: 'link_close', level: --state.level });
    }
  }

  state.pos = pos;
  state.posMax = max;
  return true;
}

// Process inline footnotes (^[...])


function footnote_inline(state, silent) {
  var labelStart,
      labelEnd,
      footnoteId,
      oldLength,
      max = state.posMax,
      start = state.pos;

  if (start + 2 >= max) { return false; }
  if (state.src.charCodeAt(start) !== 0x5E/* ^ */) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x5B/* [ */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  labelStart = start + 2;
  labelEnd = parseLinkLabel(state, start + 1);

  // parser failed to find ']', so it's not a valid note
  if (labelEnd < 0) { return false; }

  // We found the end of the link, and know for a fact it's a valid link;
  // so all that's left to do is to call tokenizer.
  //
  if (!silent) {
    if (!state.env.footnotes) { state.env.footnotes = {}; }
    if (!state.env.footnotes.list) { state.env.footnotes.list = []; }
    footnoteId = state.env.footnotes.list.length;

    state.pos = labelStart;
    state.posMax = labelEnd;

    state.push({
      type: 'footnote_ref',
      id: footnoteId,
      level: state.level
    });
    state.linkLevel++;
    oldLength = state.tokens.length;
    state.parser.tokenize(state);
    state.env.footnotes.list[footnoteId] = { tokens: state.tokens.splice(oldLength) };
    state.linkLevel--;
  }

  state.pos = labelEnd + 1;
  state.posMax = max;
  return true;
}

// Process footnote references ([^...])

function footnote_ref(state, silent) {
  var label,
      pos,
      footnoteId,
      footnoteSubId,
      max = state.posMax,
      start = state.pos;

  // should be at least 4 chars - "[^x]"
  if (start + 3 > max) { return false; }

  if (!state.env.footnotes || !state.env.footnotes.refs) { return false; }
  if (state.src.charCodeAt(start) !== 0x5B/* [ */) { return false; }
  if (state.src.charCodeAt(start + 1) !== 0x5E/* ^ */) { return false; }
  if (state.level >= state.options.maxNesting) { return false; }

  for (pos = start + 2; pos < max; pos++) {
    if (state.src.charCodeAt(pos) === 0x20) { return false; }
    if (state.src.charCodeAt(pos) === 0x0A) { return false; }
    if (state.src.charCodeAt(pos) === 0x5D /* ] */) {
      break;
    }
  }

  if (pos === start + 2) { return false; } // no empty footnote labels
  if (pos >= max) { return false; }
  pos++;

  label = state.src.slice(start + 2, pos - 1);
  if (typeof state.env.footnotes.refs[':' + label] === 'undefined') { return false; }

  if (!silent) {
    if (!state.env.footnotes.list) { state.env.footnotes.list = []; }

    if (state.env.footnotes.refs[':' + label] < 0) {
      footnoteId = state.env.footnotes.list.length;
      state.env.footnotes.list[footnoteId] = { label: label, count: 0 };
      state.env.footnotes.refs[':' + label] = footnoteId;
    } else {
      footnoteId = state.env.footnotes.refs[':' + label];
    }

    footnoteSubId = state.env.footnotes.list[footnoteId].count;
    state.env.footnotes.list[footnoteId].count++;

    state.push({
      type: 'footnote_ref',
      id: footnoteId,
      subId: footnoteSubId,
      level: state.level
    });
  }

  state.pos = pos;
  state.posMax = max;
  return true;
}

// List of valid url schemas, accorting to commonmark spec
// http://jgm.github.io/CommonMark/spec.html#autolinks

var url_schemas = [
  'coap',
  'doi',
  'javascript',
  'aaa',
  'aaas',
  'about',
  'acap',
  'cap',
  'cid',
  'crid',
  'data',
  'dav',
  'dict',
  'dns',
  'file',
  'ftp',
  'geo',
  'go',
  'gopher',
  'h323',
  'http',
  'https',
  'iax',
  'icap',
  'im',
  'imap',
  'info',
  'ipp',
  'iris',
  'iris.beep',
  'iris.xpc',
  'iris.xpcs',
  'iris.lwz',
  'ldap',
  'mailto',
  'mid',
  'msrp',
  'msrps',
  'mtqp',
  'mupdate',
  'news',
  'nfs',
  'ni',
  'nih',
  'nntp',
  'opaquelocktoken',
  'pop',
  'pres',
  'rtsp',
  'service',
  'session',
  'shttp',
  'sieve',
  'sip',
  'sips',
  'sms',
  'snmp',
  'soap.beep',
  'soap.beeps',
  'tag',
  'tel',
  'telnet',
  'tftp',
  'thismessage',
  'tn3270',
  'tip',
  'tv',
  'urn',
  'vemmi',
  'ws',
  'wss',
  'xcon',
  'xcon-userid',
  'xmlrpc.beep',
  'xmlrpc.beeps',
  'xmpp',
  'z39.50r',
  'z39.50s',
  'adiumxtra',
  'afp',
  'afs',
  'aim',
  'apt',
  'attachment',
  'aw',
  'beshare',
  'bitcoin',
  'bolo',
  'callto',
  'chrome',
  'chrome-extension',
  'com-eventbrite-attendee',
  'content',
  'cvs',
  'dlna-playsingle',
  'dlna-playcontainer',
  'dtn',
  'dvb',
  'ed2k',
  'facetime',
  'feed',
  'finger',
  'fish',
  'gg',
  'git',
  'gizmoproject',
  'gtalk',
  'hcp',
  'icon',
  'ipn',
  'irc',
  'irc6',
  'ircs',
  'itms',
  'jar',
  'jms',
  'keyparc',
  'lastfm',
  'ldaps',
  'magnet',
  'maps',
  'market',
  'message',
  'mms',
  'ms-help',
  'msnim',
  'mumble',
  'mvn',
  'notes',
  'oid',
  'palm',
  'paparazzi',
  'platform',
  'proxy',
  'psyc',
  'query',
  'res',
  'resource',
  'rmi',
  'rsync',
  'rtmp',
  'secondlife',
  'sftp',
  'sgn',
  'skype',
  'smb',
  'soldat',
  'spotify',
  'ssh',
  'steam',
  'svn',
  'teamspeak',
  'things',
  'udp',
  'unreal',
  'ut2004',
  'ventrilo',
  'view-source',
  'webcal',
  'wtai',
  'wyciwyg',
  'xfire',
  'xri',
  'ymsgr'
];

// Process autolinks '<protocol:...>'


/*eslint max-len:0*/
var EMAIL_RE    = /^<([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*)>/;
var AUTOLINK_RE = /^<([a-zA-Z.\-]{1,25}):([^<>\x00-\x20]*)>/;


function autolink(state, silent) {
  var tail, linkMatch, emailMatch, url, fullUrl, pos = state.pos;

  if (state.src.charCodeAt(pos) !== 0x3C/* < */) { return false; }

  tail = state.src.slice(pos);

  if (tail.indexOf('>') < 0) { return false; }

  linkMatch = tail.match(AUTOLINK_RE);

  if (linkMatch) {
    if (url_schemas.indexOf(linkMatch[1].toLowerCase()) < 0) { return false; }

    url = linkMatch[0].slice(1, -1);
    fullUrl = normalizeLink(url);
    if (!state.parser.validateLink(url)) { return false; }

    if (!silent) {
      state.push({
        type: 'link_open',
        href: fullUrl,
        level: state.level
      });
      state.push({
        type: 'text',
        content: url,
        level: state.level + 1
      });
      state.push({ type: 'link_close', level: state.level });
    }

    state.pos += linkMatch[0].length;
    return true;
  }

  emailMatch = tail.match(EMAIL_RE);

  if (emailMatch) {

    url = emailMatch[0].slice(1, -1);

    fullUrl = normalizeLink('mailto:' + url);
    if (!state.parser.validateLink(fullUrl)) { return false; }

    if (!silent) {
      state.push({
        type: 'link_open',
        href: fullUrl,
        level: state.level
      });
      state.push({
        type: 'text',
        content: url,
        level: state.level + 1
      });
      state.push({ type: 'link_close', level: state.level });
    }

    state.pos += emailMatch[0].length;
    return true;
  }

  return false;
}

// Regexps to match html elements

function replace$1(regex, options) {
  regex = regex.source;
  options = options || '';

  return function self(name, val) {
    if (!name) {
      return new RegExp(regex, options);
    }
    val = val.source || val;
    regex = regex.replace(name, val);
    return self;
  };
}


var attr_name     = /[a-zA-Z_:][a-zA-Z0-9:._-]*/;

var unquoted      = /[^"'=<>`\x00-\x20]+/;
var single_quoted = /'[^']*'/;
var double_quoted = /"[^"]*"/;

/*eslint no-spaced-func:0*/
var attr_value  = replace$1(/(?:unquoted|single_quoted|double_quoted)/)
                    ('unquoted', unquoted)
                    ('single_quoted', single_quoted)
                    ('double_quoted', double_quoted)
                    ();

var attribute   = replace$1(/(?:\s+attr_name(?:\s*=\s*attr_value)?)/)
                    ('attr_name', attr_name)
                    ('attr_value', attr_value)
                    ();

var open_tag    = replace$1(/<[A-Za-z][A-Za-z0-9]*attribute*\s*\/?>/)
                    ('attribute', attribute)
                    ();

var close_tag   = /<\/[A-Za-z][A-Za-z0-9]*\s*>/;
var comment     = /<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->/;
var processing  = /<[?].*?[?]>/;
var declaration = /<![A-Z]+\s+[^>]*>/;
var cdata       = /<!\[CDATA\[[\s\S]*?\]\]>/;

var HTML_TAG_RE = replace$1(/^(?:open_tag|close_tag|comment|processing|declaration|cdata)/)
  ('open_tag', open_tag)
  ('close_tag', close_tag)
  ('comment', comment)
  ('processing', processing)
  ('declaration', declaration)
  ('cdata', cdata)
  ();

// Process html tags


function isLetter$2(ch) {
  /*eslint no-bitwise:0*/
  var lc = ch | 0x20; // to lower case
  return (lc >= 0x61/* a */) && (lc <= 0x7a/* z */);
}


function htmltag(state, silent) {
  var ch, match, max, pos = state.pos;

  if (!state.options.html) { return false; }

  // Check start
  max = state.posMax;
  if (state.src.charCodeAt(pos) !== 0x3C/* < */ ||
      pos + 2 >= max) {
    return false;
  }

  // Quick fail on second char
  ch = state.src.charCodeAt(pos + 1);
  if (ch !== 0x21/* ! */ &&
      ch !== 0x3F/* ? */ &&
      ch !== 0x2F/* / */ &&
      !isLetter$2(ch)) {
    return false;
  }

  match = state.src.slice(pos).match(HTML_TAG_RE);
  if (!match) { return false; }

  if (!silent) {
    state.push({
      type: 'htmltag',
      content: state.src.slice(pos, pos + match[0].length),
      level: state.level
    });
  }
  state.pos += match[0].length;
  return true;
}

// Process html entity - &#123;, &#xAF;, &quot;, ...


var DIGITAL_RE = /^&#((?:x[a-f0-9]{1,8}|[0-9]{1,8}));/i;
var NAMED_RE   = /^&([a-z][a-z0-9]{1,31});/i;


function entity(state, silent) {
  var ch, code, match, pos = state.pos, max = state.posMax;

  if (state.src.charCodeAt(pos) !== 0x26/* & */) { return false; }

  if (pos + 1 < max) {
    ch = state.src.charCodeAt(pos + 1);

    if (ch === 0x23 /* # */) {
      match = state.src.slice(pos).match(DIGITAL_RE);
      if (match) {
        if (!silent) {
          code = match[1][0].toLowerCase() === 'x' ? parseInt(match[1].slice(1), 16) : parseInt(match[1], 10);
          state.pending += isValidEntityCode(code) ? fromCodePoint(code) : fromCodePoint(0xFFFD);
        }
        state.pos += match[0].length;
        return true;
      }
    } else {
      match = state.src.slice(pos).match(NAMED_RE);
      if (match) {
        var decoded = decodeEntity(match[1]);
        if (match[1] !== decoded) {
          if (!silent) { state.pending += decoded; }
          state.pos += match[0].length;
          return true;
        }
      }
    }
  }

  if (!silent) { state.pending += '&'; }
  state.pos++;
  return true;
}

/**
 * Inline Parser `rules`
 */

var _rules$2 = [
  [ 'text',            text ],
  [ 'newline',         newline ],
  [ 'escape',          escape ],
  [ 'backticks',       backticks ],
  [ 'del',             del ],
  [ 'ins',             ins ],
  [ 'mark',            mark ],
  [ 'emphasis',        emphasis ],
  [ 'sub',             sub ],
  [ 'sup',             sup ],
  [ 'links',           links ],
  [ 'footnote_inline', footnote_inline ],
  [ 'footnote_ref',    footnote_ref ],
  [ 'autolink',        autolink ],
  [ 'htmltag',         htmltag ],
  [ 'entity',          entity ]
];

/**
 * Inline Parser class. Note that link validation is stricter
 * in Remarkable than what is specified by CommonMark. If you
 * want to change this you can use a custom validator.
 *
 * @api private
 */

function ParserInline() {
  this.ruler = new Ruler();
  for (var i = 0; i < _rules$2.length; i++) {
    this.ruler.push(_rules$2[i][0], _rules$2[i][1]);
  }

  // Can be overridden with a custom validator
  this.validateLink = validateLink;
}

/**
 * Skip a single token by running all rules in validation mode.
 * Returns `true` if any rule reports success.
 *
 * @param  {Object} `state`
 * @api privage
 */

ParserInline.prototype.skipToken = function (state) {
  var rules = this.ruler.getRules('');
  var len = rules.length;
  var pos = state.pos;
  var i, cached_pos;

  if ((cached_pos = state.cacheGet(pos)) > 0) {
    state.pos = cached_pos;
    return;
  }

  for (i = 0; i < len; i++) {
    if (rules[i](state, true)) {
      state.cacheSet(pos, state.pos);
      return;
    }
  }

  state.pos++;
  state.cacheSet(pos, state.pos);
};

/**
 * Generate tokens for the given input range.
 *
 * @param  {Object} `state`
 * @api private
 */

ParserInline.prototype.tokenize = function (state) {
  var rules = this.ruler.getRules('');
  var len = rules.length;
  var end = state.posMax;
  var ok, i;

  while (state.pos < end) {

    // Try all possible rules.
    // On success, the rule should:
    //
    // - update `state.pos`
    // - update `state.tokens`
    // - return true
    for (i = 0; i < len; i++) {
      ok = rules[i](state, false);

      if (ok) {
        break;
      }
    }

    if (ok) {
      if (state.pos >= end) { break; }
      continue;
    }

    state.pending += state.src[state.pos++];
  }

  if (state.pending) {
    state.pushPending();
  }
};

/**
 * Parse the given input string.
 *
 * @param  {String} `str`
 * @param  {Object} `options`
 * @param  {Object} `env`
 * @param  {Array} `outTokens`
 * @api private
 */

ParserInline.prototype.parse = function (str, options, env, outTokens) {
  var state = new StateInline(str, this, options, env, outTokens);
  this.tokenize(state);
};

/**
 * Validate the given `url` by checking for bad protocols.
 *
 * @param  {String} `url`
 * @return {Boolean}
 */

function validateLink(url) {
  var BAD_PROTOCOLS = [ 'vbscript', 'javascript', 'file', 'data' ];
  var str = url.trim().toLowerCase();
  // Care about digital entities "javascript&#x3A;alert(1)"
  str = replaceEntities(str);
  if (str.indexOf(':') !== -1 && BAD_PROTOCOLS.indexOf(str.split(':')[0]) !== -1) {
    return false;
  }
  return true;
}

// Remarkable default options

var defaultConfig = {
  options: {
    html:         false,        // Enable HTML tags in source
    xhtmlOut:     false,        // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkTarget:   '',           // set target to open link in

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
    quotes: '“”‘’',

    // Highlighter function. Should return escaped HTML,
    // or '' if input not changed
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting:   20            // Internal protection, recursion limit
  },

  components: {

    core: {
      rules: [
        'block',
        'inline',
        'references',
        'replacements',
        'smartquotes',
        'references',
        'abbr2',
        'footnote_tail'
      ]
    },

    block: {
      rules: [
        'blockquote',
        'code',
        'fences',
        'footnote',
        'heading',
        'hr',
        'htmlblock',
        'lheading',
        'list',
        'paragraph',
        'table'
      ]
    },

    inline: {
      rules: [
        'autolink',
        'backticks',
        'del',
        'emphasis',
        'entity',
        'escape',
        'footnote_ref',
        'htmltag',
        'links',
        'newline',
        'text'
      ]
    }
  }
};

// Remarkable default options

var fullConfig = {
  options: {
    html:         false,        // Enable HTML tags in source
    xhtmlOut:     false,        // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkTarget:   '',           // set target to open link in

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
    quotes:       '“”‘’',

    // Highlighter function. Should return escaped HTML,
    // or '' if input not changed
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight:     null,

    maxNesting:    20            // Internal protection, recursion limit
  },

  components: {
    // Don't restrict core/block/inline rules
    core: {},
    block: {},
    inline: {}
  }
};

// Commonmark default options

var commonmarkConfig = {
  options: {
    html:         true,         // Enable HTML tags in source
    xhtmlOut:     true,         // Use '/' to close single tags (<br />)
    breaks:       false,        // Convert '\n' in paragraphs into <br>
    langPrefix:   'language-',  // CSS language prefix for fenced blocks
    linkTarget:   '',           // set target to open link in

    // Enable some language-neutral replacements + quotes beautification
    typographer:  false,

    // Double + single quotes replacement pairs, when typographer enabled,
    // and smartquotes on. Set doubles to '«»' for Russian, '„“' for German.
    quotes: '“”‘’',

    // Highlighter function. Should return escaped HTML,
    // or '' if input not changed
    //
    // function (/*str, lang*/) { return ''; }
    //
    highlight: null,

    maxNesting:   20            // Internal protection, recursion limit
  },

  components: {

    core: {
      rules: [
        'block',
        'inline',
        'references',
        'abbr2'
      ]
    },

    block: {
      rules: [
        'blockquote',
        'code',
        'fences',
        'heading',
        'hr',
        'htmlblock',
        'lheading',
        'list',
        'paragraph'
      ]
    },

    inline: {
      rules: [
        'autolink',
        'backticks',
        'emphasis',
        'entity',
        'escape',
        'htmltag',
        'links',
        'newline',
        'text'
      ]
    }
  }
};

/**
 * Preset configs
 */

var config = {
  'default': defaultConfig,
  'full': fullConfig,
  'commonmark': commonmarkConfig
};

/**
 * The `StateCore` class manages state.
 *
 * @param {Object} `instance` Remarkable instance
 * @param {String} `str` Markdown string
 * @param {Object} `env`
 */

function StateCore(instance, str, env) {
  this.src = str;
  this.env = env;
  this.options = instance.options;
  this.tokens = [];
  this.inlineMode = false;

  this.inline = instance.inline;
  this.block = instance.block;
  this.renderer = instance.renderer;
  this.typographer = instance.typographer;
}

/**
 * The main `Remarkable` class. Create an instance of
 * `Remarkable` with a `preset` and/or `options`.
 *
 * @param {String} `preset` If no preset is given, `default` is used.
 * @param {Object} `options`
 */

function Remarkable(preset, options) {
  if (typeof preset !== 'string') {
    options = preset;
    preset = 'default';
  }

  if (options && options.linkify != null) {
    console.warn(
      'linkify option is removed. Use linkify plugin instead:\n\n' +
      'import Remarkable from \'remarkable\';\n' +
      'import linkify from \'remarkable/linkify\';\n' +
      'new Remarkable().use(linkify)\n'
    );
  }

  this.inline   = new ParserInline();
  this.block    = new ParserBlock();
  this.core     = new Core();
  this.renderer = new Renderer();
  this.ruler    = new Ruler();

  this.options  = {};
  this.configure(config[preset]);
  this.set(options || {});
}

/**
 * Set options as an alternative to passing them
 * to the constructor.
 *
 * ```js
 * md.set({typographer: true});
 * ```
 * @param {Object} `options`
 * @api public
 */

Remarkable.prototype.set = function (options) {
  assign(this.options, options);
};

/**
 * Batch loader for components rules states, and options
 *
 * @param  {Object} `presets`
 */

Remarkable.prototype.configure = function (presets) {
  var self = this;

  if (!presets) { throw new Error('Wrong `remarkable` preset, check name/content'); }
  if (presets.options) { self.set(presets.options); }
  if (presets.components) {
    Object.keys(presets.components).forEach(function (name) {
      if (presets.components[name].rules) {
        self[name].ruler.enable(presets.components[name].rules, true);
      }
    });
  }
};

/**
 * Use a plugin.
 *
 * ```js
 * var md = new Remarkable();
 *
 * md.use(plugin1)
 *   .use(plugin2, opts)
 *   .use(plugin3);
 * ```
 *
 * @param  {Function} `plugin`
 * @param  {Object} `options`
 * @return {Object} `Remarkable` for chaining
 */

Remarkable.prototype.use = function (plugin, options) {
  plugin(this, options);
  return this;
};


/**
 * Parse the input `string` and return a tokens array.
 * Modifies `env` with definitions data.
 *
 * @param  {String} `string`
 * @param  {Object} `env`
 * @return {Array} Array of tokens
 */

Remarkable.prototype.parse = function (str, env) {
  var state = new StateCore(this, str, env);
  this.core.process(state);
  return state.tokens;
};

/**
 * The main `.render()` method that does all the magic :)
 *
 * @param  {String} `string`
 * @param  {Object} `env`
 * @return {String} Rendered HTML.
 */

Remarkable.prototype.render = function (str, env) {
  env = env || {};
  return this.renderer.render(this.parse(str, env), this.options, env);
};

/**
 * Parse the given content `string` as a single string.
 *
 * @param  {String} `string`
 * @param  {Object} `env`
 * @return {Array} Array of tokens
 */

Remarkable.prototype.parseInline = function (str, env) {
  var state = new StateCore(this, str, env);
  state.inlineMode = true;
  this.core.process(state);
  return state.tokens;
};

/**
 * Render a single content `string`, without wrapping it
 * to paragraphs
 *
 * @param  {String} `str`
 * @param  {Object} `env`
 * @return {String}
 */

Remarkable.prototype.renderInline = function (str, env) {
  env = env || {};
  return this.renderer.render(this.parseInline(str, env), this.options, env);
};




/***/ }),
/* 3230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.15.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var d=void 0,e=void 0,g=void 0,m=void 0,n=void 0;exports.unstable_now=void 0;exports.unstable_forceFrameRate=void 0;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,r=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(r,0),b;}};exports.unstable_now=function(){return Date.now()};d=function(a){null!==p?setTimeout(d,0,a):(p=a,setTimeout(r,0))};e=function(a,b){q=setTimeout(a,b)};g=function(){clearTimeout(q)};m=function(){return!1};n=exports.unstable_forceFrameRate=function(){}}else{var t=window.performance,u=window.Date,v=window.setTimeout,
w=window.clearTimeout,x=window.requestAnimationFrame,y=window.cancelAnimationFrame;"undefined"!==typeof console&&("function"!==typeof x&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),"function"!==typeof y&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));exports.unstable_now="object"===typeof t&&
"function"===typeof t.now?function(){return t.now()}:function(){return u.now()};var z=!1,A=null,B=-1,C=-1,D=33.33,E=-1,F=-1,G=0,H=!1;m=function(){return exports.unstable_now()>=G};n=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):0<a?(D=Math.floor(1E3/a),H=!0):(D=33.33,H=!1)};var J=function(){if(null!==A){var a=exports.unstable_now(),b=0<G-a;try{A(b,
a)||(A=null)}catch(c){throw I.postMessage(null),c;}}},K=new MessageChannel,I=K.port2;K.port1.onmessage=J;var L=function(a){if(null===A)F=E=-1,z=!1;else{z=!0;x(function(a){w(B);L(a)});var b=function(){G=exports.unstable_now()+D/2;J();B=v(b,3*D)};B=v(b,3*D);if(-1!==E&&.1<a-E){var c=a-E;!H&&-1!==F&&c<D&&F<D&&(D=c<F?F:c,8.33>D&&(D=8.33));F=c}E=a;G=a+D;I.postMessage(null)}};d=function(a){A=a;z||(z=!0,x(function(a){L(a)}))};e=function(a,b){C=v(function(){a(exports.unstable_now())},b)};g=function(){w(C);
C=-1}}var M=null,N=null,O=null,P=3,Q=!1,R=!1,S=!1;
function T(a,b){var c=a.next;if(c===a)M=null;else{a===M&&(M=c);var f=a.previous;f.next=c;c.previous=f}a.next=a.previous=null;c=a.callback;f=P;var l=O;P=a.priorityLevel;O=a;try{var h=a.expirationTime<=b;switch(P){case 1:var k=c(h);break;case 2:k=c(h);break;case 3:k=c(h);break;case 4:k=c(h);break;case 5:k=c(h)}}catch(Z){throw Z;}finally{P=f,O=l}if("function"===typeof k)if(b=a.expirationTime,a.callback=k,null===M)M=a.next=a.previous=a;else{k=null;h=M;do{if(b<=h.expirationTime){k=h;break}h=h.next}while(h!==
M);null===k?k=M:k===M&&(M=a);b=k.previous;b.next=k.previous=a;a.next=k;a.previous=b}}function U(a){if(null!==N&&N.startTime<=a){do{var b=N,c=b.next;if(b===c)N=null;else{N=c;var f=b.previous;f.next=c;c.previous=f}b.next=b.previous=null;V(b,b.expirationTime)}while(null!==N&&N.startTime<=a)}}function W(a){S=!1;U(a);R||(null!==M?(R=!0,d(X)):null!==N&&e(W,N.startTime-a))}
function X(a,b){R=!1;S&&(S=!1,g());U(b);Q=!0;try{if(!a)for(;null!==M&&M.expirationTime<=b;)T(M,b),b=exports.unstable_now(),U(b);else if(null!==M){do T(M,b),b=exports.unstable_now(),U(b);while(null!==M&&!m())}if(null!==M)return!0;null!==N&&e(W,N.startTime-b);return!1}finally{Q=!1}}function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}
function V(a,b){if(null===M)M=a.next=a.previous=a;else{var c=null,f=M;do{if(b<f.expirationTime){c=f;break}f=f.next}while(f!==M);null===c?c=M:c===M&&(M=a);b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}}var aa=n;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=P;P=a;try{return b()}finally{P=c}};exports.unstable_next=function(a){switch(P){case 1:case 2:case 3:var b=3;break;default:b=P}var c=P;P=b;try{return a()}finally{P=c}};
exports.unstable_scheduleCallback=function(a,b,c){var f=exports.unstable_now();if("object"===typeof c&&null!==c){var l=c.delay;l="number"===typeof l&&0<l?f+l:f;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),l=f;c=l+c;a={callback:b,priorityLevel:a,startTime:l,expirationTime:c,next:null,previous:null};if(l>f){c=l;if(null===N)N=a.next=a.previous=a;else{b=null;var h=N;do{if(c<h.startTime){b=h;break}h=h.next}while(h!==N);null===b?b=N:b===N&&(N=a);c=b.previous;c.next=b.previous=a;a.next=b;a.previous=
c}null===M&&N===a&&(S?g():S=!0,e(W,l-f))}else V(a,c),R||Q||(R=!0,d(X));return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(a===b)a===M?M=null:a===N&&(N=null);else{a===M?M=b:a===N&&(N=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=P;return function(){var c=P;P=b;try{return a.apply(this,arguments)}finally{P=c}}};exports.unstable_getCurrentPriorityLevel=function(){return P};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();U(a);return null!==O&&null!==M&&M.startTime<=a&&M.expirationTime<O.expirationTime||m()};exports.unstable_requestPaint=aa;exports.unstable_continueExecution=function(){R||Q||(R=!0,d(X))};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return M};


/***/ }),
/* 3231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(3230);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 3232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_has__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__elements_Button__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_Modal__ = __webpack_require__(1502);









/**
 * A Confirm modal gives the user a choice to confirm or cancel an action.
 * @see Modal
 */

var Confirm = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Confirm, _Component);

  function Confirm() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleCancel = function (e) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(_this.props, 'onCancel', e, _this.props);
    };

    _this.handleCancelOverrides = function (predefinedProps) {
      return {
        onClick: function onClick(e, buttonProps) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(predefinedProps, 'onClick', e, buttonProps);

          _this.handleCancel(e);
        }
      };
    };

    _this.handleConfirmOverrides = function (predefinedProps) {
      return {
        onClick: function onClick(e, buttonProps) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(predefinedProps, 'onClick', e, buttonProps);

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(_this.props, 'onConfirm', e, _this.props);
        }
      };
    };

    return _this;
  }

  var _proto = Confirm.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        cancelButton = _this$props.cancelButton,
        confirmButton = _this$props.confirmButton,
        content = _this$props.content,
        header = _this$props.header,
        open = _this$props.open,
        size = _this$props.size;
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(Confirm, this.props); // `open` is auto controlled by the Modal
    // It cannot be present (even undefined) with `defaultOpen`
    // only apply it if the user provided an open prop

    var openProp = {};
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_has__["a" /* default */])(this.props, 'open')) openProp.open = open;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__modules_Modal__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, openProp, {
      size: size,
      onClose: this.handleCancel
    }), __WEBPACK_IMPORTED_MODULE_8__modules_Modal__["a" /* default */].Header.create(header, {
      autoGenerateKey: false
    }), __WEBPACK_IMPORTED_MODULE_8__modules_Modal__["a" /* default */].Content.create(content, {
      autoGenerateKey: false
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__modules_Modal__["a" /* default */].Actions, null, __WEBPACK_IMPORTED_MODULE_7__elements_Button__["a" /* default */].create(cancelButton, {
      autoGenerateKey: false,
      overrideProps: this.handleCancelOverrides
    }), __WEBPACK_IMPORTED_MODULE_7__elements_Button__["a" /* default */].create(confirmButton, {
      autoGenerateKey: false,
      defaultProps: {
        primary: true
      },
      overrideProps: this.handleConfirmOverrides
    })));
  };

  return Confirm;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

Confirm.handledProps = ["cancelButton", "confirmButton", "content", "header", "onCancel", "onConfirm", "open", "size"];
Confirm.propTypes =  false ? {
  /** The cancel button text. */
  cancelButton: customPropTypes.itemShorthand,

  /** The OK button text. */
  confirmButton: customPropTypes.itemShorthand,

  /** The ModalContent text. */
  content: customPropTypes.itemShorthand,

  /** The ModalHeader text. */
  header: customPropTypes.itemShorthand,

  /**
   * Called when the Modal is closed without clicking confirm.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onCancel: PropTypes.func,

  /**
   * Called when the OK button is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onConfirm: PropTypes.func,

  /** Whether or not the modal is visible. */
  open: PropTypes.bool,

  /** A Confirm can vary in size */
  size: PropTypes.oneOf(['mini', 'tiny', 'small', 'large', 'fullscreen'])
} : {};
Confirm.defaultProps = {
  cancelButton: 'Cancel',
  confirmButton: 'OK',
  content: 'Are you sure?',
  size: 'small'
};
/* harmony default export */ __webpack_exports__["a"] = (Confirm);

/***/ }),
/* 3233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Confirm__ = __webpack_require__(3232);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Confirm__["a"]; });



/***/ }),
/* 3234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Pagination; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__collections_Menu__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PaginationItem__ = __webpack_require__(1433);










/**
 * A component to render a pagination.
 */

var Pagination = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Pagination, _Component);

  function Pagination() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleItemClick = function (e, _ref) {
      var nextActivePage = _ref.value;
      var prevActivePage = _this.state.activePage; // Heads up! We need the cast to the "number" type there, as `activePage` can be a string

      if (+prevActivePage === +nextActivePage) return;

      _this.setState({
        activePage: nextActivePage
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_invoke__["a" /* default */])(_this.props, 'onPageChange', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        activePage: nextActivePage
      }));
    };

    _this.handleItemOverrides = function (active, type, value) {
      return function (predefinedProps) {
        return {
          active: active,
          type: type,
          key: type + "-" + value,
          onClick: function onClick(e, itemProps) {
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_invoke__["a" /* default */])(predefinedProps, 'onClick', e, itemProps);

            if (itemProps.type !== 'ellipsisItem') _this.handleItemClick(e, itemProps);
          }
        };
      };
    };

    return _this;
  }

  var _proto = Pagination.prototype;

  _proto.getInitialAutoControlledState = function getInitialAutoControlledState() {
    return {
      activePage: 1
    };
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        ariaLabel = _this$props['aria-label'],
        boundaryRange = _this$props.boundaryRange,
        disabled = _this$props.disabled,
        ellipsisItem = _this$props.ellipsisItem,
        siblingRange = _this$props.siblingRange,
        totalPages = _this$props.totalPages;
    var activePage = this.state.activePage;
    var items = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["D" /* createPaginationItems */])({
      activePage: activePage,
      boundaryRange: boundaryRange,
      hideEllipsis: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])(ellipsisItem),
      siblingRange: siblingRange,
      totalPages: totalPages
    });
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["b" /* getUnhandledProps */])(Pagination, this.props);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__collections_Menu__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      "aria-label": ariaLabel,
      pagination: true,
      role: "navigation"
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_map__["a" /* default */])(items, function (_ref2) {
      var active = _ref2.active,
          type = _ref2.type,
          value = _ref2.value;
      return __WEBPACK_IMPORTED_MODULE_9__PaginationItem__["a" /* default */].create(_this2.props[type], {
        defaultProps: {
          content: value,
          disabled: disabled,
          value: value
        },
        overrideProps: _this2.handleItemOverrides(active, type, value)
      });
    }));
  };

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_7__lib__["q" /* ModernAutoControlledComponent */]);

Pagination.handledProps = ["activePage", "aria-label", "boundaryRange", "defaultActivePage", "disabled", "ellipsisItem", "firstItem", "lastItem", "nextItem", "onPageChange", "pageItem", "prevItem", "siblingRange", "totalPages"];

Pagination.propTypes =  false ? {
  /** A pagination item can have an aria label. */
  'aria-label': PropTypes.string,

  /** Initial activePage value. */
  defaultActivePage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Index of the currently active page. */
  activePage: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Number of always visible pages at the beginning and end. */
  boundaryRange: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A pagination can be disabled. */
  disabled: PropTypes.bool,

  /** A shorthand for PaginationItem. */
  ellipsisItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  firstItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  lastItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  nextItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  pageItem: customPropTypes.itemShorthand,

  /** A shorthand for PaginationItem. */
  prevItem: customPropTypes.itemShorthand,

  /**
   * Called on change of an active page.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onPageChange: PropTypes.func,

  /** Number of always visible pages before and after the current one. */
  siblingRange: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Total number of pages. */
  totalPages: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired
} : {};
Pagination.autoControlledProps = ['activePage'];
Pagination.defaultProps = {
  'aria-label': 'Pagination Navigation',
  boundaryRange: 1,
  ellipsisItem: '...',
  firstItem: {
    'aria-label': 'First item',
    content: '«'
  },
  lastItem: {
    'aria-label': 'Last item',
    content: '»'
  },
  nextItem: {
    'aria-label': 'Next item',
    content: '⟩'
  },
  pageItem: {},
  prevItem: {
    'aria-label': 'Previous item',
    content: '⟨'
  },
  siblingRange: 1
};
Pagination.Item = __WEBPACK_IMPORTED_MODULE_9__PaginationItem__["a" /* default */];

/***/ }),
/* 3235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Pagination__ = __webpack_require__(3234);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Pagination__["a"]; });



/***/ }),
/* 3236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__semantic_ui_react_event_stack__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__semantic_ui_react_event_stack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__semantic_ui_react_event_stack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fluentui_react_component_ref__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_keyboard_key__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_keyboard_key___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_keyboard_key__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_validateTrigger__ = __webpack_require__(3237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PortalInner__ = __webpack_require__(1434);












/**
 * A component that allows you to render children outside their parent.
 * @see Modal
 * @see Popup
 * @see Dimmer
 * @see Confirm
 */
var Portal = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Portal, _Component);

  function Portal() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.contentRef = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createRef();
    _this.triggerRef = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createRef();
    _this.latestDocumentMouseDownEvent = null;

    _this.handleDocumentMouseDown = function (e) {
      _this.latestDocumentMouseDownEvent = e;
    };

    _this.handleDocumentClick = function (e) {
      var closeOnDocumentClick = _this.props.closeOnDocumentClick;
      var currentMouseDownEvent = _this.latestDocumentMouseDownEvent;
      _this.latestDocumentMouseDownEvent = null;

      if (!_this.contentRef.current || // no portal
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["u" /* doesNodeContainClick */])(_this.triggerRef.current, e) || // event happened in trigger (delegate to trigger handlers)
      currentMouseDownEvent && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["u" /* doesNodeContainClick */])(_this.contentRef.current, currentMouseDownEvent) || // event originated in the portal but was ended outside
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["u" /* doesNodeContainClick */])(_this.contentRef.current, e) // event happened in the portal
      ) {
          return;
        } // ignore the click


      if (closeOnDocumentClick) {
        _this.close(e);
      }
    };

    _this.handleEscape = function (e) {
      if (!_this.props.closeOnEscape) return;
      if (__WEBPACK_IMPORTED_MODULE_5_keyboard_key___default.a.getCode(e) !== __WEBPACK_IMPORTED_MODULE_5_keyboard_key___default.a.Escape) return;

      _this.close(e);
    };

    _this.handlePortalMouseLeave = function (e) {
      var _this$props = _this.props,
          closeOnPortalMouseLeave = _this$props.closeOnPortalMouseLeave,
          mouseLeaveDelay = _this$props.mouseLeaveDelay;
      if (!closeOnPortalMouseLeave) return; // Do not close the portal when 'mouseleave' is triggered by children

      if (e.target !== _this.contentRef.current) return;
      _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
    };

    _this.handlePortalMouseEnter = function () {
      // In order to enable mousing from the trigger to the portal, we need to
      // clear the mouseleave timer that was set when leaving the trigger.
      var closeOnPortalMouseLeave = _this.props.closeOnPortalMouseLeave;
      if (!closeOnPortalMouseLeave) return;
      clearTimeout(_this.mouseLeaveTimer);
    };

    _this.handleTriggerBlur = function (e) {
      var _this$props2 = _this.props,
          trigger = _this$props2.trigger,
          closeOnTriggerBlur = _this$props2.closeOnTriggerBlur; // Call original event handler

      for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        rest[_key2 - 1] = arguments[_key2];
      }

      __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */].apply(void 0, [trigger, 'props.onBlur', e].concat(rest)); // IE 11 doesn't work with relatedTarget in blur events


      var target = e.relatedTarget || document.activeElement; // do not close if focus is given to the portal

      var didFocusPortal = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.contentRef.current, 'contains', target);

      if (!closeOnTriggerBlur || didFocusPortal) return;

      _this.close(e);
    };

    _this.handleTriggerClick = function (e) {
      var _this$props3 = _this.props,
          trigger = _this$props3.trigger,
          closeOnTriggerClick = _this$props3.closeOnTriggerClick,
          openOnTriggerClick = _this$props3.openOnTriggerClick;
      var open = _this.state.open; // Call original event handler

      for (var _len3 = arguments.length, rest = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        rest[_key3 - 1] = arguments[_key3];
      }

      __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */].apply(void 0, [trigger, 'props.onClick', e].concat(rest));

      if (open && closeOnTriggerClick) {
        _this.close(e);
      } else if (!open && openOnTriggerClick) {
        _this.open(e);
      }
    };

    _this.handleTriggerFocus = function (e) {
      var _this$props4 = _this.props,
          trigger = _this$props4.trigger,
          openOnTriggerFocus = _this$props4.openOnTriggerFocus; // Call original event handler

      for (var _len4 = arguments.length, rest = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        rest[_key4 - 1] = arguments[_key4];
      }

      __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */].apply(void 0, [trigger, 'props.onFocus', e].concat(rest));

      if (!openOnTriggerFocus) return;

      _this.open(e);
    };

    _this.handleTriggerMouseLeave = function (e) {
      clearTimeout(_this.mouseEnterTimer);
      var _this$props5 = _this.props,
          trigger = _this$props5.trigger,
          closeOnTriggerMouseLeave = _this$props5.closeOnTriggerMouseLeave,
          mouseLeaveDelay = _this$props5.mouseLeaveDelay; // Call original event handler

      for (var _len5 = arguments.length, rest = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        rest[_key5 - 1] = arguments[_key5];
      }

      __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */].apply(void 0, [trigger, 'props.onMouseLeave', e].concat(rest));

      if (!closeOnTriggerMouseLeave) return;
      _this.mouseLeaveTimer = _this.closeWithTimeout(e, mouseLeaveDelay);
    };

    _this.handleTriggerMouseEnter = function (e) {
      clearTimeout(_this.mouseLeaveTimer);
      var _this$props6 = _this.props,
          trigger = _this$props6.trigger,
          mouseEnterDelay = _this$props6.mouseEnterDelay,
          openOnTriggerMouseEnter = _this$props6.openOnTriggerMouseEnter; // Call original event handler

      for (var _len6 = arguments.length, rest = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        rest[_key6 - 1] = arguments[_key6];
      }

      __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */].apply(void 0, [trigger, 'props.onMouseEnter', e].concat(rest));

      if (!openOnTriggerMouseEnter) return;
      _this.mouseEnterTimer = _this.openWithTimeout(e, mouseEnterDelay);
    };

    _this.open = function (e) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onOpen', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        open: true
      }));

      _this.setState({
        open: true
      });
    };

    _this.openWithTimeout = function (e, delay) {
      // React wipes the entire event object and suggests using e.persist() if
      // you need the event for async access. However, even with e.persist
      // certain required props (e.g. currentTarget) are null so we're forced to clone.
      var eventClone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, e);

      return setTimeout(function () {
        return _this.open(eventClone);
      }, delay || 0);
    };

    _this.close = function (e) {
      _this.setState({
        open: false
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onClose', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        open: false
      }));
    };

    _this.closeWithTimeout = function (e, delay) {
      // React wipes the entire event object and suggests using e.persist() if
      // you need the event for async access. However, even with e.persist
      // certain required props (e.g. currentTarget) are null so we're forced to clone.
      var eventClone = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, e);

      return setTimeout(function () {
        return _this.close(eventClone);
      }, delay || 0);
    };

    _this.handleMount = function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onMount', null, _this.props);
    };

    _this.handleUnmount = function () {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onUnmount', null, _this.props);
    };

    _this.handleTriggerRef = function (c) {
      _this.triggerRef.current = c;
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__fluentui_react_component_ref__["c" /* handleRef */])(_this.props.triggerRef, c);
    };

    return _this;
  }

  var _proto = Portal.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    // Clean up timers
    clearTimeout(this.mouseEnterTimer);
    clearTimeout(this.mouseLeaveTimer);
  } // ----------------------------------------
  // Document Event Handlers
  // ----------------------------------------
  ;

  _proto.render = function render() {
    var _this$props7 = this.props,
        children = _this$props7.children,
        eventPool = _this$props7.eventPool,
        mountNode = _this$props7.mountNode,
        trigger = _this$props7.trigger;
    var open = this.state.open;
    /* istanbul ignore else */

    if (false) {
      validateTrigger(trigger);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Fragment, null, open && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__PortalInner__["a" /* default */], {
      innerRef: this.contentRef,
      mountNode: mountNode,
      onMount: this.handleMount,
      onUnmount: this.handleUnmount
    }, children), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__semantic_ui_react_event_stack___default.a, {
      name: "mouseleave",
      on: this.handlePortalMouseLeave,
      pool: eventPool,
      target: this.contentRef
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__semantic_ui_react_event_stack___default.a, {
      name: "mouseenter",
      on: this.handlePortalMouseEnter,
      pool: eventPool,
      target: this.contentRef
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__semantic_ui_react_event_stack___default.a, {
      name: "mousedown",
      on: this.handleDocumentMouseDown,
      pool: eventPool
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__semantic_ui_react_event_stack___default.a, {
      name: "click",
      on: this.handleDocumentClick,
      pool: eventPool
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__semantic_ui_react_event_stack___default.a, {
      name: "keydown",
      on: this.handleEscape,
      pool: eventPool
    })), trigger && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__fluentui_react_component_ref__["a" /* Ref */], {
      innerRef: this.handleTriggerRef
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(trigger, {
      onBlur: this.handleTriggerBlur,
      onClick: this.handleTriggerClick,
      onFocus: this.handleTriggerFocus,
      onMouseLeave: this.handleTriggerMouseLeave,
      onMouseEnter: this.handleTriggerMouseEnter
    })));
  };

  return Portal;
}(__WEBPACK_IMPORTED_MODULE_8__lib__["q" /* ModernAutoControlledComponent */]);

Portal.handledProps = ["children", "closeOnDocumentClick", "closeOnEscape", "closeOnPortalMouseLeave", "closeOnTriggerBlur", "closeOnTriggerClick", "closeOnTriggerMouseLeave", "defaultOpen", "eventPool", "mountNode", "mouseEnterDelay", "mouseLeaveDelay", "onClose", "onMount", "onOpen", "onUnmount", "open", "openOnTriggerClick", "openOnTriggerFocus", "openOnTriggerMouseEnter", "trigger", "triggerRef"];
Portal.propTypes =  false ? {
  /** Primary content. */
  children: PropTypes.node.isRequired,

  /** Controls whether or not the portal should close when the document is clicked. */
  closeOnDocumentClick: PropTypes.bool,

  /** Controls whether or not the portal should close when escape is pressed is displayed. */
  closeOnEscape: PropTypes.bool,

  /**
   * Controls whether or not the portal should close when mousing out of the portal.
   * NOTE: This will prevent `closeOnTriggerMouseLeave` when mousing over the
   * gap from the trigger to the portal.
   */
  closeOnPortalMouseLeave: PropTypes.bool,

  /** Controls whether or not the portal should close on blur of the trigger. */
  closeOnTriggerBlur: PropTypes.bool,

  /** Controls whether or not the portal should close on click of the trigger. */
  closeOnTriggerClick: PropTypes.bool,

  /** Controls whether or not the portal should close when mousing out of the trigger. */
  closeOnTriggerMouseLeave: PropTypes.bool,

  /** Initial value of open. */
  defaultOpen: PropTypes.bool,

  /** Event pool namespace that is used to handle component events */
  eventPool: PropTypes.string,

  /** The node where the portal should mount. */
  mountNode: PropTypes.any,

  /** Milliseconds to wait before opening on mouse over */
  mouseEnterDelay: PropTypes.number,

  /** Milliseconds to wait before closing on mouse leave */
  mouseLeaveDelay: PropTypes.number,

  /**
   * Called when a close event happens
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: PropTypes.func,

  /**
   * Called when the portal is mounted on the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: PropTypes.func,

  /**
   * Called when an open event happens
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: PropTypes.func,

  /**
   * Called when the portal is unmounted from the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: PropTypes.func,

  /** Controls whether or not the portal is displayed. */
  open: PropTypes.bool,

  /** Controls whether or not the portal should open when the trigger is clicked. */
  openOnTriggerClick: PropTypes.bool,

  /** Controls whether or not the portal should open on focus of the trigger. */
  openOnTriggerFocus: PropTypes.bool,

  /** Controls whether or not the portal should open when mousing over the trigger. */
  openOnTriggerMouseEnter: PropTypes.bool,

  /** Element to be rendered in-place where the portal is defined. */
  trigger: PropTypes.node,

  /** Called with a ref to the trigger node. */
  triggerRef: customPropTypes.ref
} : {};
Portal.defaultProps = {
  closeOnDocumentClick: true,
  closeOnEscape: true,
  eventPool: 'default',
  openOnTriggerClick: true
};
Portal.autoControlledProps = ['open'];
Portal.Inner = __WEBPACK_IMPORTED_MODULE_10__PortalInner__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 3237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_is__);


/**
 * Asserts that a passed element can be used cloned a props will be applied properly.
 */

function validateTrigger(element) {
  if (element) {
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(element);

    if (__WEBPACK_IMPORTED_MODULE_1_react_is__["isFragment"](element)) {
      throw new Error('An "React.Fragment" cannot be used as a `trigger`.');
    }
  }
}

/***/ }),
/* 3238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Checkbox__ = __webpack_require__(473);




/**
 * A Radio is sugar for <Checkbox radio />.
 * Useful for exclusive groups of sliders or toggles.
 * @see Checkbox
 * @see Form
 */

function Radio(props) {
  var slider = props.slider,
      toggle = props.toggle,
      type = props.type;
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__lib__["b" /* getUnhandledProps */])(Radio, props); // const ElementType = getElementType(Radio, props)
  // radio, slider, toggle are exclusive
  // use an undefined radio if slider or toggle are present

  var radio = !(slider || toggle) || undefined;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__modules_Checkbox__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    type: type,
    radio: radio,
    slider: slider,
    toggle: toggle
  }));
}

Radio.handledProps = ["slider", "toggle", "type"];
Radio.propTypes =  false ? {
  /** Format to emphasize the current selection state. */
  slider: Checkbox.propTypes.slider,

  /** Format to show an on or off choice. */
  toggle: Checkbox.propTypes.toggle,

  /** HTML input type, either checkbox or radio. */
  type: Checkbox.propTypes.type
} : {};
Radio.defaultProps = {
  type: 'radio'
};
/* harmony default export */ __webpack_exports__["a"] = (Radio);

/***/ }),
/* 3239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__ = __webpack_require__(474);




/**
 * A Select is sugar for <Dropdown selection />.
 * @see Dropdown
 * @see Form
 */

function Select(props) {
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
    selection: true
  }));
}

Select.handledProps = ["options"];
Select.propTypes =  false ? {
  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
  options: PropTypes.arrayOf(PropTypes.shape(Dropdown.Item.propTypes)).isRequired
} : {};
Select.Divider = __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */].Divider;
Select.Header = __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */].Header;
Select.Item = __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */].Item;
Select.Menu = __WEBPACK_IMPORTED_MODULE_3__modules_Dropdown__["a" /* default */].Menu;
/* harmony default export */ __webpack_exports__["a"] = (Select);

/***/ }),
/* 3240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_get__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fluentui_react_component_ref__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(8);








/**
 * A TextArea can be used to allow for extended user input.
 * @see Form
 */

var TextArea = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(TextArea, _Component);

  function TextArea() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.ref = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["createRef"])();

    _this.focus = function () {
      return _this.ref.current.focus();
    };

    _this.handleChange = function (e) {
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_get__["a" /* default */])(e, 'target.value');

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onChange', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        value: value
      }));
    };

    _this.handleInput = function (e) {
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_get__["a" /* default */])(e, 'target.value');

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onInput', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        value: value
      }));
    };

    return _this;
  }

  var _proto = TextArea.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        rows = _this$props.rows,
        value = _this$props.value;
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["b" /* getUnhandledProps */])(TextArea, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["c" /* getElementType */])(TextArea, this.props);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__fluentui_react_component_ref__["a" /* Ref */], {
      innerRef: this.ref
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      onChange: this.handleChange,
      onInput: this.handleInput,
      rows: rows,
      value: value
    })));
  };

  return TextArea;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

TextArea.handledProps = ["as", "onChange", "onInput", "rows", "value"];
TextArea.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /**
   * Called on change.
   * @param {SyntheticEvent} event - The React SyntheticEvent object
   * @param {object} data - All props and the event value.
   */
  onChange: PropTypes.func,

  /**
   * Called on input.
   * @param {SyntheticEvent} event - The React SyntheticEvent object
   * @param {object} data - All props and the event value.
   */
  onInput: PropTypes.func,

  /** Indicates row count for a TextArea. */
  rows: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** The value of the textarea. */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : {};
TextArea.defaultProps = {
  as: 'textarea',
  rows: 3
};
/* harmony default export */ __webpack_exports__["a"] = (TextArea);

/***/ }),
/* 3241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TransitionablePortal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isUndefined__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Portal__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_Transition__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_Transition_utils_computeStatuses__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib__ = __webpack_require__(8);











/**
 * A sugar for `Portal` and `Transition`.
 * @see Portal
 * @see Transition
 */
var TransitionablePortal = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(TransitionablePortal, _Component);

  function TransitionablePortal() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {};

    _this.handlePortalClose = function () {
      _this.setState({
        portalOpen: -1
      });
    };

    _this.handlePortalOpen = function () {
      _this.setState({
        portalOpen: true
      });
    };

    _this.handleTransitionHide = function (nothing, data) {
      var portalOpen = _this.state.portalOpen;

      _this.setState({
        transitionVisible: false
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onClose', null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, data, {
        portalOpen: false,
        transitionVisible: false
      }));

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onHide', null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, data, {
        portalOpen: portalOpen,
        transitionVisible: false
      }));
    };

    _this.handleTransitionStart = function (nothing, data) {
      var portalOpen = _this.state.portalOpen;
      var status = data.status;
      var transitionVisible = status === __WEBPACK_IMPORTED_MODULE_8__modules_Transition_utils_computeStatuses__["c" /* TRANSITION_STATUS_ENTERING */];

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onStart', null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, data, {
        portalOpen: portalOpen,
        transitionVisible: transitionVisible
      })); // Heads up! TransitionablePortal fires onOpen callback on the start of transition animation


      if (!transitionVisible) return;

      _this.setState({
        transitionVisible: transitionVisible
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onOpen', null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, data, {
        transitionVisible: transitionVisible,
        portalOpen: true
      }));
    };

    return _this;
  }

  // ----------------------------------------
  // Lifecycle
  // ----------------------------------------
  TransitionablePortal.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    // This is definitely a hack :(
    //
    // It's coupled with handlePortalClose() for force set the state of `portalOpen` omitting
    // props.open. It's related to implementation of the component itself as `onClose()` will be
    // called after a transition will end.
    // https://github.com/Semantic-Org/Semantic-UI-React/issues/2382
    if (state.portalOpen === -1) {
      return {
        portalOpen: false
      };
    }

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isUndefined__["a" /* default */])(props.open)) {
      return null;
    }

    return {
      portalOpen: props.open
    };
  } // ----------------------------------------
  // Callback handling
  // ----------------------------------------
  ;

  var _proto = TransitionablePortal.prototype;

  // ----------------------------------------
  // Render
  // ----------------------------------------
  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        transition = _this$props.transition;
    var _this$state = this.state,
        portalOpen = _this$state.portalOpen,
        transitionVisible = _this$state.transitionVisible;
    var open = portalOpen || transitionVisible;
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["b" /* getUnhandledProps */])(TransitionablePortal, this.props);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Portal__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      open: open,
      onOpen: this.handlePortalOpen,
      onClose: this.handlePortalClose
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__modules_Transition__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, transition, {
      transitionOnMount: true,
      onStart: this.handleTransitionStart,
      onHide: this.handleTransitionHide,
      visible: portalOpen
    }), children));
  };

  return TransitionablePortal;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

TransitionablePortal.handledProps = ["children", "onClose", "onHide", "onOpen", "onStart", "open", "transition"];

TransitionablePortal.propTypes =  false ? {
  /** Primary content. */
  children: PropTypes.node.isRequired,

  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and internal state.
   */
  onClose: PropTypes.func,

  /**
   * Callback on each transition that changes visibility to hidden.
   *
   * @param {null}
   * @param {object} data - All props with transition status and internal state.
   */
  onHide: PropTypes.func,

  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and internal state.
   */
  onOpen: PropTypes.func,

  /**
   * Callback on animation start.
   *
   * @param {null}
   * @param {object} data - All props with transition status and internal state.
   */
  onStart: PropTypes.func,

  /** Controls whether or not the portal is displayed. */
  open: PropTypes.bool,

  /** Transition props. */
  transition: PropTypes.object
} : {};
TransitionablePortal.defaultProps = {
  transition: {
    animation: 'scale',
    duration: 400
  }
};

/***/ }),
/* 3242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TransitionablePortal__ = __webpack_require__(3241);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TransitionablePortal__["a"]; });



/***/ }),
/* 3243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Visibility; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_forEach__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_includes__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fluentui_react_component_ref__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib__ = __webpack_require__(8);










/**
 * Visibility provides a set of callbacks for when a content appears in the viewport.
 *
 * @deprecated This component is deprecated and will be removed in next major release.
 */

var Visibility = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Visibility, _Component);

  function Visibility() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.calculations = {
      bottomPassed: false,
      bottomVisible: false,
      fits: false,
      passing: false,
      offScreen: false,
      onScreen: false,
      topPassed: false,
      topVisible: false
    };
    _this.firedCallbacks = [];
    _this.ref = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_react__["createRef"])();

    _this.fire = function (_ref, value, reverse) {
      var callback = _ref.callback,
          name = _ref.name;

      if (reverse === void 0) {
        reverse = false;
      }

      var _this$props = _this.props,
          continuous = _this$props.continuous,
          once = _this$props.once; // Heads up! For the execution is required:
      // - current value correspond to the fired direction
      // - `continuous` is true or calculation values are different

      var matchesDirection = _this.calculations[value] !== reverse;
      var executionPossible = continuous || _this.calculations[value] !== _this.oldCalculations[value];
      if (matchesDirection && executionPossible) _this.execute(callback, name); // Heads up! We should remove callback from the happened when it's not `once`

      if (!once) _this.firedCallbacks = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_without__["a" /* default */])(_this.firedCallbacks, name);
    };

    _this.handleUpdate = function () {
      if (_this.ticking) return;
      _this.ticking = true;
      _this.frameId = requestAnimationFrame(_this.update);
    };

    _this.update = function () {
      if (!_this.mounted) return;
      _this.ticking = false;
      _this.oldCalculations = _this.calculations;
      _this.calculations = _this.computeCalculations();
      _this.pageYOffset = _this.getPageYOffset();
      var _this$props2 = _this.props,
          onBottomPassed = _this$props2.onBottomPassed,
          onBottomPassedReverse = _this$props2.onBottomPassedReverse,
          onBottomVisible = _this$props2.onBottomVisible,
          onBottomVisibleReverse = _this$props2.onBottomVisibleReverse,
          onPassing = _this$props2.onPassing,
          onPassingReverse = _this$props2.onPassingReverse,
          onTopPassed = _this$props2.onTopPassed,
          onTopPassedReverse = _this$props2.onTopPassedReverse,
          onTopVisible = _this$props2.onTopVisible,
          onTopVisibleReverse = _this$props2.onTopVisibleReverse,
          onOffScreen = _this$props2.onOffScreen,
          onOnScreen = _this$props2.onOnScreen,
          updateOn = _this$props2.updateOn;
      var forward = {
        bottomPassed: {
          callback: onBottomPassed,
          name: 'onBottomPassed'
        },
        bottomVisible: {
          callback: onBottomVisible,
          name: 'onBottomVisible'
        },
        passing: {
          callback: onPassing,
          name: 'onPassing'
        },
        offScreen: {
          callback: onOffScreen,
          name: 'onOffScreen'
        },
        onScreen: {
          callback: onOnScreen,
          name: 'onOnScreen'
        },
        topPassed: {
          callback: onTopPassed,
          name: 'onTopPassed'
        },
        topVisible: {
          callback: onTopVisible,
          name: 'onTopVisible'
        }
      };
      var reverse = {
        bottomPassed: {
          callback: onBottomPassedReverse,
          name: 'onBottomPassedReverse'
        },
        bottomVisible: {
          callback: onBottomVisibleReverse,
          name: 'onBottomVisibleReverse'
        },
        passing: {
          callback: onPassingReverse,
          name: 'onPassingReverse'
        },
        topPassed: {
          callback: onTopPassedReverse,
          name: 'onTopPassedReverse'
        },
        topVisible: {
          callback: onTopVisibleReverse,
          name: 'onTopVisibleReverse'
        }
      };

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onUpdate', null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        calculations: _this.calculations
      }));

      _this.fireOnPassed(); // Heads up! Reverse callbacks should be fired first


      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_forEach__["a" /* default */])(reverse, function (data, value) {
        return _this.fire(data, value, true);
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_forEach__["a" /* default */])(forward, function (data, value) {
        return _this.fire(data, value);
      });

      if (updateOn === 'repaint') _this.handleUpdate();
    };

    return _this;
  }

  var _proto = Visibility.prototype;

  // ----------------------------------------
  // Lifecycle
  // ----------------------------------------
  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["t" /* isBrowser */])()) return;
    var _this$props3 = this.props,
        context = _this$props3.context,
        fireOnMount = _this$props3.fireOnMount,
        updateOn = _this$props3.updateOn;
    this.pageYOffset = this.getPageYOffset();
    this.attachHandlers(context, updateOn);
    if (fireOnMount) this.update();
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var cleanHappened = prevProps.continuous !== this.props.continuous || prevProps.once !== this.props.once || prevProps.updateOn !== this.props.updateOn; // Heads up! We should clean up array of happened callbacks, if values of these props are changed

    if (cleanHappened) this.firedCallbacks = [];

    if (prevProps.context !== this.props.context || prevProps.updateOn !== this.props.updateOn) {
      this.unattachHandlers(prevProps.context);
      this.attachHandlers(this.props.context, this.props.updateOn);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var context = this.props.context;
    this.unattachHandlers(context);
    this.mounted = false;
  };

  _proto.attachHandlers = function attachHandlers(context, updateOn) {
    if (updateOn === 'events') {
      if (context) {
        __WEBPACK_IMPORTED_MODULE_9__lib__["s" /* eventStack */].sub('resize', this.handleUpdate, {
          target: context
        });
        __WEBPACK_IMPORTED_MODULE_9__lib__["s" /* eventStack */].sub('scroll', this.handleUpdate, {
          target: context
        });
      }

      return;
    } // Heads up!
    // We will deal with `repaint` there


    this.handleUpdate();
  };

  _proto.unattachHandlers = function unattachHandlers(context) {
    if (context) {
      __WEBPACK_IMPORTED_MODULE_9__lib__["s" /* eventStack */].unsub('resize', this.handleUpdate, {
        target: context
      });
      __WEBPACK_IMPORTED_MODULE_9__lib__["s" /* eventStack */].unsub('scroll', this.handleUpdate, {
        target: context
      });
    }

    if (this.frameId) cancelAnimationFrame(this.frameId);
  } // ----------------------------------------
  // Callback handling
  // ----------------------------------------
  ;

  _proto.execute = function execute(callback, name) {
    var continuous = this.props.continuous;
    if (!callback) return; // Heads up! When `continuous` is true, callback will be fired always

    if (!continuous && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_includes__["a" /* default */])(this.firedCallbacks, name)) return;
    callback(null, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.props, {
      calculations: this.calculations
    }));
    this.firedCallbacks.push(name);
  };

  _proto.fireOnPassed = function fireOnPassed() {
    var _this2 = this;

    var _this$calculations = this.calculations,
        percentagePassed = _this$calculations.percentagePassed,
        pixelsPassed = _this$calculations.pixelsPassed;
    var onPassed = this.props.onPassed;

    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_forEach__["a" /* default */])(onPassed, function (callback, passed) {
      var pixelsValue = Number(passed);

      if (pixelsValue && pixelsPassed >= pixelsValue) {
        _this2.execute(callback, passed);

        return;
      }

      var matchPercentage = ("" + passed).match(/^(\d+)%$/);
      if (!matchPercentage) return;
      var percentageValue = Number(matchPercentage[1]) / 100;
      if (percentagePassed >= percentageValue) _this2.execute(callback, passed);
    });
  };

  // ----------------------------------------
  // Helpers
  // ----------------------------------------
  _proto.computeCalculations = function computeCalculations() {
    var offset = this.props.offset;

    var _this$ref$current$get = this.ref.current.getBoundingClientRect(),
        bottom = _this$ref$current$get.bottom,
        height = _this$ref$current$get.height,
        top = _this$ref$current$get.top,
        width = _this$ref$current$get.width;

    var _normalizeOffset = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["C" /* normalizeOffset */])(offset),
        topOffset = _normalizeOffset[0],
        bottomOffset = _normalizeOffset[1];

    var newOffset = this.getPageYOffset();
    var direction = newOffset > this.pageYOffset ? 'down' : 'up';
    var topPassed = top < topOffset;
    var bottomPassed = bottom < bottomOffset;
    var pixelsPassed = bottomPassed ? 0 : Math.max(top * -1, 0);
    var percentagePassed = pixelsPassed / height;
    var bottomVisible = bottom >= bottomOffset && bottom <= window.innerHeight;
    var topVisible = top >= topOffset && top <= window.innerHeight;
    var fits = topVisible && bottomVisible;
    var passing = topPassed && !bottomPassed;
    var onScreen = (topVisible || topPassed) && !bottomPassed;
    var offScreen = !onScreen;
    return {
      bottomPassed: bottomPassed,
      bottomVisible: bottomVisible,
      direction: direction,
      fits: fits,
      height: height,
      passing: passing,
      percentagePassed: percentagePassed,
      pixelsPassed: pixelsPassed,
      offScreen: offScreen,
      onScreen: onScreen,
      topPassed: topPassed,
      topVisible: topVisible,
      width: width
    };
  };

  _proto.getPageYOffset = function getPageYOffset() {
    var context = this.props.context;

    if (context) {
      // Heads up! `window` doesn't have `pageYOffset` property
      return context === window ? window.pageYOffset : context.scrollTop;
    }

    return 0;
  } // ----------------------------------------
  // Render
  // ----------------------------------------
  ;

  _proto.render = function render() {
    var children = this.props.children;
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["c" /* getElementType */])(Visibility, this.props);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["b" /* getUnhandledProps */])(Visibility, this.props);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__fluentui_react_component_ref__["a" /* Ref */], {
      innerRef: this.ref
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ElementType, rest, children));
  };

  return Visibility;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

Visibility.handledProps = ["as", "children", "context", "continuous", "fireOnMount", "offset", "onBottomPassed", "onBottomPassedReverse", "onBottomVisible", "onBottomVisibleReverse", "onOffScreen", "onOnScreen", "onPassed", "onPassing", "onPassingReverse", "onTopPassed", "onTopPassedReverse", "onTopVisible", "onTopVisibleReverse", "onUpdate", "once", "updateOn"];

Visibility.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Context which visibility should attach onscroll events. */
  context: PropTypes.object,

  /**
   * When set to true a callback will occur anytime an element passes a condition not just immediately after the
   * threshold is met.
   */
  continuous: PropTypes.bool,

  /** Fires callbacks immediately after mount. */
  fireOnMount: PropTypes.bool,

  /**
   * Element's bottom edge has passed top of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onBottomPassed: PropTypes.func,

  /**
   * Element's bottom edge has not passed top of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onBottomPassedReverse: PropTypes.func,

  /**
   * Element's bottom edge has passed bottom of screen
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onBottomVisible: PropTypes.func,

  /**
   * Element's bottom edge has not passed bottom of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onBottomVisibleReverse: PropTypes.func,

  /**
   * Value that context should be adjusted in pixels. Useful for making content appear below content fixed to the
   * page.
   */
  offset: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string]))]),

  /** When set to false a callback will occur each time an element passes the threshold for a condition. */
  once: PropTypes.bool,

  /** Element is not visible on the screen. */
  onPassed: PropTypes.object,

  /**
   * Any part of an element is visible on screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onPassing: PropTypes.func,

  /**
   * Element's top has not passed top of screen but bottom has.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onPassingReverse: PropTypes.func,

  /**
   * Element is not visible on the screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onOffScreen: PropTypes.func,

  /**
   * Element is visible on the screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onOnScreen: PropTypes.func,

  /**
   * Element's top edge has passed top of the screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onTopPassed: PropTypes.func,

  /**
   * Element's top edge has not passed top of the screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onTopPassedReverse: PropTypes.func,

  /**
   * Element's top edge has passed bottom of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onTopVisible: PropTypes.func,

  /**
   * Element's top edge has not passed bottom of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onTopVisibleReverse: PropTypes.func,

  /**
   * Element's top edge has passed bottom of screen.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUpdate: PropTypes.func,

  /**
   * Allows to choose the mode of the position calculations:
   * - `events` - (default) update and fire callbacks only on scroll/resize events
   * - `repaint` - update and fire callbacks on browser repaint (animation frames)
   */
  updateOn: PropTypes.oneOf(['events', 'repaint'])
} : {};
Visibility.defaultProps = {
  context: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["t" /* isBrowser */])() ? window : null,
  continuous: false,
  offset: [0, 0],
  once: true,
  updateOn: 'events'
};

/***/ }),
/* 3244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Visibility__ = __webpack_require__(3243);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Visibility__["a"]; });



/***/ }),
/* 3245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_each__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BreadcrumbDivider__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BreadcrumbSection__ = __webpack_require__(1438);









/**
 * A breadcrumb is used to show hierarchy between content.
 */

function Breadcrumb(props) {
  var children = props.children,
      className = props.className,
      divider = props.divider,
      icon = props.icon,
      sections = props.sections,
      size = props.size;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])('ui', size, 'breadcrumb', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(Breadcrumb, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(Breadcrumb, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  var childElements = [];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_each__["a" /* default */])(sections, function (section, index) {
    // section
    var breadcrumbElement = __WEBPACK_IMPORTED_MODULE_8__BreadcrumbSection__["a" /* default */].create(section);
    childElements.push(breadcrumbElement); // divider

    if (index !== sections.length - 1) {
      var key = breadcrumbElement.key + "_divider" || JSON.stringify(section);
      childElements.push(__WEBPACK_IMPORTED_MODULE_7__BreadcrumbDivider__["a" /* default */].create({
        content: divider,
        icon: icon,
        key: key
      }));
    }
  });

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), childElements);
}

Breadcrumb.handledProps = ["as", "children", "className", "divider", "icon", "sections", "size"];
Breadcrumb.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content of the Breadcrumb.Divider. */
  divider: customPropTypes.every([customPropTypes.disallow(['icon']), customPropTypes.contentShorthand]),

  /** For use with the sections prop. Render as an `Icon` component with `divider` class instead of a `div` in
   *  Breadcrumb.Divider. */
  icon: customPropTypes.every([customPropTypes.disallow(['divider']), customPropTypes.itemShorthand]),

  /** Shorthand array of props for Breadcrumb.Section. */
  sections: customPropTypes.collectionShorthand,

  /** Size of Breadcrumb. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium'))
} : {};
Breadcrumb.Divider = __WEBPACK_IMPORTED_MODULE_7__BreadcrumbDivider__["a" /* default */];
Breadcrumb.Section = __WEBPACK_IMPORTED_MODULE_8__BreadcrumbSection__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Breadcrumb);

/***/ }),
/* 3246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Breadcrumb__ = __webpack_require__(3245);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Breadcrumb__["a"]; });



/***/ }),
/* 3247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormButton__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FormCheckbox__ = __webpack_require__(1440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FormDropdown__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FormField__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FormGroup__ = __webpack_require__(1442);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FormInput__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FormRadio__ = __webpack_require__(1444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__FormSelect__ = __webpack_require__(1445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__FormTextArea__ = __webpack_require__(1446);

















/**
 * A Form displays a set of related user input fields in a structured way.
 * @see Button
 * @see Checkbox
 * @see Dropdown
 * @see Input
 * @see Message
 * @see Radio
 * @see Select
 * @see Visibility
 */

var Form = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Form, _Component);

  function Form() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(_args)) || this;

    _this.handleSubmit = function (e) {
      var action = _this.props.action; // Heads up! Third party libs can pass own data as first argument, we need to check that it has preventDefault()
      // method.

      if (typeof action !== 'string') __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(e, 'preventDefault');

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      __WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */].apply(void 0, [_this.props, 'onSubmit', e, _this.props].concat(args));
    };

    return _this;
  }

  var _proto = Form.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        action = _this$props.action,
        children = _this$props.children,
        className = _this$props.className,
        error = _this$props.error,
        inverted = _this$props.inverted,
        loading = _this$props.loading,
        reply = _this$props.reply,
        size = _this$props.size,
        success = _this$props.success,
        unstackable = _this$props.unstackable,
        warning = _this$props.warning,
        widths = _this$props.widths;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])('ui', size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(error, 'error'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(loading, 'loading'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(reply, 'reply'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(success, 'success'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(unstackable, 'unstackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(warning, 'warning'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["f" /* useWidthProp */])(widths, null, true), 'form', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["b" /* getUnhandledProps */])(Form, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["c" /* getElementType */])(Form, this.props);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      action: action,
      className: classes,
      onSubmit: this.handleSubmit
    }), children);
  };

  return Form;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

Form.handledProps = ["action", "as", "children", "className", "error", "inverted", "loading", "onSubmit", "reply", "size", "success", "unstackable", "warning", "widths"];
Form.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** The HTML form action */
  action: PropTypes.string,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Automatically show any error Message children. */
  error: PropTypes.bool,

  /** A form can have its color inverted for contrast. */
  inverted: PropTypes.bool,

  /** Automatically show a loading indicator. */
  loading: PropTypes.bool,

  /** The HTML form submit handler. */
  onSubmit: PropTypes.func,

  /** A comment can contain a form to reply to a comment. This may have arbitrary content. */
  reply: PropTypes.bool,

  /** A form can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** Automatically show any success Message children. */
  success: PropTypes.bool,

  /** A form can prevent itself from stacking on mobile. */
  unstackable: PropTypes.bool,

  /** Automatically show any warning Message children. */
  warning: PropTypes.bool,

  /** Forms can automatically divide fields to be equal width. */
  widths: PropTypes.oneOf(['equal'])
} : {};
Form.defaultProps = {
  as: 'form'
};
Form.Field = __WEBPACK_IMPORTED_MODULE_11__FormField__["a" /* default */];
Form.Button = __WEBPACK_IMPORTED_MODULE_8__FormButton__["a" /* default */];
Form.Checkbox = __WEBPACK_IMPORTED_MODULE_9__FormCheckbox__["a" /* default */];
Form.Dropdown = __WEBPACK_IMPORTED_MODULE_10__FormDropdown__["a" /* default */];
Form.Group = __WEBPACK_IMPORTED_MODULE_12__FormGroup__["a" /* default */];
Form.Input = __WEBPACK_IMPORTED_MODULE_13__FormInput__["a" /* default */];
Form.Radio = __WEBPACK_IMPORTED_MODULE_14__FormRadio__["a" /* default */];
Form.Select = __WEBPACK_IMPORTED_MODULE_15__FormSelect__["a" /* default */];
Form.TextArea = __WEBPACK_IMPORTED_MODULE_16__FormTextArea__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Form);

/***/ }),
/* 3248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Form__ = __webpack_require__(3247);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Form__["a"]; });



/***/ }),
/* 3249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(1447);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });



/***/ }),
/* 3250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Message; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__elements_Icon__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MessageContent__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MessageHeader__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MessageList__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__MessageItem__ = __webpack_require__(703);













/**
 * A message displays information that explains nearby content.
 * @see Form
 */

var Message = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Message, _Component);

  function Message() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleDismiss = function (e) {
      var onDismiss = _this.props.onDismiss;
      if (onDismiss) onDismiss(e, _this.props);
    };

    return _this;
  }

  var _proto = Message.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        attached = _this$props.attached,
        children = _this$props.children,
        className = _this$props.className,
        color = _this$props.color,
        compact = _this$props.compact,
        content = _this$props.content,
        error = _this$props.error,
        floating = _this$props.floating,
        header = _this$props.header,
        hidden = _this$props.hidden,
        icon = _this$props.icon,
        info = _this$props.info,
        list = _this$props.list,
        negative = _this$props.negative,
        onDismiss = _this$props.onDismiss,
        positive = _this$props.positive,
        size = _this$props.size,
        success = _this$props.success,
        visible = _this$props.visible,
        warning = _this$props.warning;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(compact, 'compact'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(error, 'error'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(floating, 'floating'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(hidden, 'hidden'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(icon, 'icon'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(info, 'info'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(negative, 'negative'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(positive, 'positive'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(success, 'success'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(visible, 'visible'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(warning, 'warning'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["h" /* useKeyOrValueAndKey */])(attached, 'attached'), 'message', className);
    var dismissIcon = onDismiss && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__elements_Icon__["a" /* default */], {
      name: "close",
      onClick: this.handleDismiss
    });
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["b" /* getUnhandledProps */])(Message, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["c" /* getElementType */])(Message, this.props);

    if (!__WEBPACK_IMPORTED_MODULE_7__lib__["d" /* childrenUtils */].isNil(children)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        className: classes
      }), dismissIcon, children);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), dismissIcon, __WEBPACK_IMPORTED_MODULE_8__elements_Icon__["a" /* default */].create(icon, {
      autoGenerateKey: false
    }), (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])(header) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])(content) || !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])(list)) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__MessageContent__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_10__MessageHeader__["a" /* default */].create(header, {
      autoGenerateKey: false
    }), __WEBPACK_IMPORTED_MODULE_11__MessageList__["a" /* default */].create(list, {
      autoGenerateKey: false
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["B" /* createHTMLParagraph */])(content, {
      autoGenerateKey: false
    })));
  };

  return Message;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

Message.handledProps = ["as", "attached", "children", "className", "color", "compact", "content", "error", "floating", "header", "hidden", "icon", "info", "list", "negative", "onDismiss", "positive", "size", "success", "visible", "warning"];

Message.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A message can be formatted to attach itself to other content. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['bottom', 'top'])]),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A message can be formatted to be different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A message can only take up the width of its content. */
  compact: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A message may be formatted to display a negative message. Same as `negative`. */
  error: PropTypes.bool,

  /** A message can float above content that it is related to. */
  floating: PropTypes.bool,

  /** Shorthand for MessageHeader. */
  header: customPropTypes.itemShorthand,

  /** A message can be hidden. */
  hidden: PropTypes.bool,

  /** A message can contain an icon. */
  icon: PropTypes.oneOfType([customPropTypes.itemShorthand, PropTypes.bool]),

  /** A message may be formatted to display information. */
  info: PropTypes.bool,

  /** Array shorthand items for the MessageList. Mutually exclusive with children. */
  list: customPropTypes.collectionShorthand,

  /** A message may be formatted to display a negative message. Same as `error`. */
  negative: PropTypes.bool,

  /**
   * A message that the user can choose to hide.
   * Called when the user clicks the "x" icon. This also adds the "x" icon.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onDismiss: PropTypes.func,

  /** A message may be formatted to display a positive message.  Same as `success`. */
  positive: PropTypes.bool,

  /** A message can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** A message may be formatted to display a positive message.  Same as `positive`. */
  success: PropTypes.bool,

  /** A message can be set to visible to force itself to be shown. */
  visible: PropTypes.bool,

  /** A message may be formatted to display warning messages. */
  warning: PropTypes.bool
} : {};
Message.Content = __WEBPACK_IMPORTED_MODULE_9__MessageContent__["a" /* default */];
Message.Header = __WEBPACK_IMPORTED_MODULE_10__MessageHeader__["a" /* default */];
Message.List = __WEBPACK_IMPORTED_MODULE_11__MessageList__["a" /* default */];
Message.Item = __WEBPACK_IMPORTED_MODULE_12__MessageItem__["a" /* default */];

/***/ }),
/* 3251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Message__ = __webpack_require__(3250);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Message__["a"]; });



/***/ }),
/* 3252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TableBody__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TableCell__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TableFooter__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TableHeader__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TableHeaderCell__ = __webpack_require__(1458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TableRow__ = __webpack_require__(1459);













/**
 * A table displays a collections of data grouped into rows.
 */

function Table(props) {
  var attached = props.attached,
      basic = props.basic,
      celled = props.celled,
      children = props.children,
      className = props.className,
      collapsing = props.collapsing,
      color = props.color,
      columns = props.columns,
      compact = props.compact,
      definition = props.definition,
      fixed = props.fixed,
      footerRow = props.footerRow,
      headerRow = props.headerRow,
      headerRows = props.headerRows,
      inverted = props.inverted,
      padded = props.padded,
      renderBodyRow = props.renderBodyRow,
      selectable = props.selectable,
      singleLine = props.singleLine,
      size = props.size,
      sortable = props.sortable,
      stackable = props.stackable,
      striped = props.striped,
      structured = props.structured,
      tableData = props.tableData,
      textAlign = props.textAlign,
      unstackable = props.unstackable,
      verticalAlign = props.verticalAlign;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(celled, 'celled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(collapsing, 'collapsing'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(definition, 'definition'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(fixed, 'fixed'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(selectable, 'selectable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(singleLine, 'single line'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(sortable, 'sortable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(stackable, 'stackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(striped, 'striped'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(structured, 'structured'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["a" /* useKeyOnly */])(unstackable, 'unstackable'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["h" /* useKeyOrValueAndKey */])(attached, 'attached'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["h" /* useKeyOrValueAndKey */])(basic, 'basic'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["h" /* useKeyOrValueAndKey */])(compact, 'compact'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["h" /* useKeyOrValueAndKey */])(padded, 'padded'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["n" /* useTextAlignProp */])(textAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["i" /* useVerticalAlignProp */])(verticalAlign), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["f" /* useWidthProp */])(columns, 'column'), 'table', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["b" /* getUnhandledProps */])(Table, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__lib__["c" /* getElementType */])(Table, props);

  if (!__WEBPACK_IMPORTED_MODULE_6__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  var hasHeaderRows = headerRow || headerRows;
  var headerShorthandOptions = {
    defaultProps: {
      cellAs: 'th'
    }
  };
  var headerElement = hasHeaderRows && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__TableHeader__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */].create(headerRow, headerShorthandOptions), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_map__["a" /* default */])(headerRows, function (data) {
    return __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */].create(data, headerShorthandOptions);
  }));
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), headerElement, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TableBody__["a" /* default */], null, renderBodyRow && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_map__["a" /* default */])(tableData, function (data, index) {
    return __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */].create(renderBodyRow(data, index));
  })), footerRow && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__TableFooter__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */].create(footerRow)));
}

Table.handledProps = ["as", "attached", "basic", "celled", "children", "className", "collapsing", "color", "columns", "compact", "definition", "fixed", "footerRow", "headerRow", "headerRows", "inverted", "padded", "renderBodyRow", "selectable", "singleLine", "size", "sortable", "stackable", "striped", "structured", "tableData", "textAlign", "unstackable", "verticalAlign"];
Table.defaultProps = {
  as: 'table'
};
Table.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Attach table to other content */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** A table can reduce its complexity to increase readability. */
  basic: PropTypes.oneOfType([PropTypes.oneOf(['very']), PropTypes.bool]),

  /** A table may be divided into individual cells. */
  celled: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A table can be collapsing, taking up only as much space as its rows. */
  collapsing: PropTypes.bool,

  /** A table can be given a color to distinguish it from other tables. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** A table can specify its column count to divide its content evenly. */
  columns: PropTypes.oneOf(SUI.WIDTHS),

  /** A table may sometimes need to be more compact to make more rows visible at a time. */
  compact: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** A table may be formatted to emphasize a first column that defines a rows content. */
  definition: PropTypes.bool,

  /**
   * A table can use fixed a special faster form of table rendering that does not resize table cells based on content
   */
  fixed: PropTypes.bool,

  /** Shorthand for a TableRow to be placed within Table.Footer. */
  footerRow: customPropTypes.itemShorthand,

  /** Shorthand for a TableRow to be placed within Table.Header. */
  headerRow: customPropTypes.every([customPropTypes.disallow(['headerRows']), customPropTypes.itemShorthand]),

  /** Shorthand for multiple TableRows to be placed within Table.Header. */
  headerRows: customPropTypes.every([customPropTypes.disallow(['headerRow']), customPropTypes.collectionShorthand]),

  /** A table's colors can be inverted. */
  inverted: PropTypes.bool,

  /** A table may sometimes need to be more padded for legibility. */
  padded: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /**
   * Mapped over `tableData` and should return shorthand for each Table.Row to be placed within Table.Body.
   *
   * @param {*} data - An element in the `tableData` array.
   * @param {number} index - The index of the current element in `tableData`.
   * @returns {*} Shorthand for a Table.Row.
   */
  renderBodyRow: customPropTypes.every([customPropTypes.disallow(['children']), customPropTypes.demand(['tableData']), PropTypes.func]),

  /** A table can have its rows appear selectable. */
  selectable: PropTypes.bool,

  /** A table can specify that its cell contents should remain on a single line and not wrap. */
  singleLine: PropTypes.bool,

  /** A table can also be small or large. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'mini', 'tiny', 'medium', 'big', 'huge', 'massive')),

  /** A table may allow a user to sort contents by clicking on a table header. */
  sortable: PropTypes.bool,

  /** A table can specify how it stacks table content responsively. */
  stackable: PropTypes.bool,

  /** A table can stripe alternate rows of content with a darker color to increase contrast. */
  striped: PropTypes.bool,

  /** A table can be formatted to display complex structured data. */
  structured: PropTypes.bool,

  /** Data to be passed to the renderBodyRow function. */
  tableData: customPropTypes.every([customPropTypes.disallow(['children']), customPropTypes.demand(['renderBodyRow']), PropTypes.array]),

  /** A table can adjust its text alignment. */
  textAlign: PropTypes.oneOf(_without(SUI.TEXT_ALIGNMENTS, 'justified')),

  /** A table can specify how it stacks table content responsively. */
  unstackable: PropTypes.bool,

  /** A table can adjust its text alignment. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
Table.Body = __WEBPACK_IMPORTED_MODULE_7__TableBody__["a" /* default */];
Table.Cell = __WEBPACK_IMPORTED_MODULE_8__TableCell__["a" /* default */];
Table.Footer = __WEBPACK_IMPORTED_MODULE_9__TableFooter__["a" /* default */];
Table.Header = __WEBPACK_IMPORTED_MODULE_10__TableHeader__["a" /* default */];
Table.HeaderCell = __WEBPACK_IMPORTED_MODULE_11__TableHeaderCell__["a" /* default */];
Table.Row = __WEBPACK_IMPORTED_MODULE_12__TableRow__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Table);

/***/ }),
/* 3253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table__ = __webpack_require__(3252);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Table__["a"]; });



/***/ }),
/* 3254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A container limits content to a maximum width.
 */

function Container(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      fluid = props.fluid,
      text = props.text,
      textAlign = props.textAlign;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(text, 'text'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["n" /* useTextAlignProp */])(textAlign), 'container', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Container, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(Container, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

Container.handledProps = ["as", "children", "className", "content", "fluid", "text", "textAlign"];
Container.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Container has no maximum width. */
  fluid: PropTypes.bool,

  /** Reduce maximum width to more naturally accommodate text. */
  text: PropTypes.bool,

  /** Align container text. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ }),
/* 3255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Container__ = __webpack_require__(3254);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Container__["a"]; });



/***/ }),
/* 3256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A divider visually segments content into groups.
 */

function Divider(props) {
  var children = props.children,
      className = props.className,
      clearing = props.clearing,
      content = props.content,
      fitted = props.fitted,
      hidden = props.hidden,
      horizontal = props.horizontal,
      inverted = props.inverted,
      section = props.section,
      vertical = props.vertical;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(clearing, 'clearing'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(fitted, 'fitted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(hidden, 'hidden'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(horizontal, 'horizontal'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(section, 'section'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(vertical, 'vertical'), 'divider', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Divider, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(Divider, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

Divider.handledProps = ["as", "children", "className", "clearing", "content", "fitted", "hidden", "horizontal", "inverted", "section", "vertical"];
Divider.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Divider can clear the content above it. */
  clearing: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Divider can be fitted without any space above or below it. */
  fitted: PropTypes.bool,

  /** Divider can divide content without creating a dividing line. */
  hidden: PropTypes.bool,

  /** Divider can segment content horizontally. */
  horizontal: PropTypes.bool,

  /** Divider can have its colours inverted. */
  inverted: PropTypes.bool,

  /** Divider can provide greater margins to divide sections of content. */
  section: PropTypes.bool,

  /** Divider can segment content vertically. */
  vertical: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Divider);

/***/ }),
/* 3257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Divider__ = __webpack_require__(3256);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Divider__["a"]; });



/***/ }),
/* 3258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export names */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);






var names = ['ad', 'andorra', 'ae', 'united arab emirates', 'uae', 'af', 'afghanistan', 'ag', 'antigua', 'ai', 'anguilla', 'al', 'albania', 'am', 'armenia', 'an', 'netherlands antilles', 'ao', 'angola', 'ar', 'argentina', 'as', 'american samoa', 'at', 'austria', 'au', 'australia', 'aw', 'aruba', 'ax', 'aland islands', 'az', 'azerbaijan', 'ba', 'bosnia', 'bb', 'barbados', 'bd', 'bangladesh', 'be', 'belgium', 'bf', 'burkina faso', 'bg', 'bulgaria', 'bh', 'bahrain', 'bi', 'burundi', 'bj', 'benin', 'bm', 'bermuda', 'bn', 'brunei', 'bo', 'bolivia', 'br', 'brazil', 'bs', 'bahamas', 'bt', 'bhutan', 'bv', 'bouvet island', 'bw', 'botswana', 'by', 'belarus', 'bz', 'belize', 'ca', 'canada', 'cc', 'cocos islands', 'cd', 'congo', 'cf', 'central african republic', 'cg', 'congo brazzaville', 'ch', 'switzerland', 'ci', 'cote divoire', 'ck', 'cook islands', 'cl', 'chile', 'cm', 'cameroon', 'cn', 'china', 'co', 'colombia', 'cr', 'costa rica', 'cs', 'cu', 'cuba', 'cv', 'cape verde', 'cx', 'christmas island', 'cy', 'cyprus', 'cz', 'czech republic', 'de', 'germany', 'dj', 'djibouti', 'dk', 'denmark', 'dm', 'dominica', 'do', 'dominican republic', 'dz', 'algeria', 'ec', 'ecuador', 'england', 'gb eng', 'ee', 'estonia', 'eg', 'egypt', 'eh', 'western sahara', 'er', 'eritrea', 'es', 'spain', 'et', 'ethiopia', 'eu', 'european union', 'fi', 'finland', 'fj', 'fiji', 'fk', 'falkland islands', 'fm', 'micronesia', 'fo', 'faroe islands', 'fr', 'france', 'ga', 'gabon', 'gb', 'uk', 'united kingdom', 'gd', 'grenada', 'ge', 'georgia', 'gf', 'french guiana', 'gh', 'ghana', 'gi', 'gibraltar', 'gl', 'greenland', 'gm', 'gambia', 'gn', 'guinea', 'gp', 'guadeloupe', 'gq', 'equatorial guinea', 'gr', 'greece', 'gs', 'sandwich islands', 'gt', 'guatemala', 'gu', 'guam', 'gw', 'guinea-bissau', 'gy', 'guyana', 'hk', 'hong kong', 'hm', 'heard island', 'hn', 'honduras', 'hr', 'croatia', 'ht', 'haiti', 'hu', 'hungary', 'id', 'indonesia', 'ie', 'ireland', 'il', 'israel', 'in', 'india', 'io', 'indian ocean territory', 'iq', 'iraq', 'ir', 'iran', 'is', 'iceland', 'it', 'italy', 'jm', 'jamaica', 'jo', 'jordan', 'jp', 'japan', 'ke', 'kenya', 'kg', 'kyrgyzstan', 'kh', 'cambodia', 'ki', 'kiribati', 'km', 'comoros', 'kn', 'saint kitts and nevis', 'kp', 'north korea', 'kr', 'south korea', 'kw', 'kuwait', 'ky', 'cayman islands', 'kz', 'kazakhstan', 'la', 'laos', 'lb', 'lebanon', 'lc', 'saint lucia', 'li', 'liechtenstein', 'lk', 'sri lanka', 'lr', 'liberia', 'ls', 'lesotho', 'lt', 'lithuania', 'lu', 'luxembourg', 'lv', 'latvia', 'ly', 'libya', 'ma', 'morocco', 'mc', 'monaco', 'md', 'moldova', 'me', 'montenegro', 'mg', 'madagascar', 'mh', 'marshall islands', 'mk', 'macedonia', 'ml', 'mali', 'mm', 'myanmar', 'burma', 'mn', 'mongolia', 'mo', 'macau', 'mp', 'northern mariana islands', 'mq', 'martinique', 'mr', 'mauritania', 'ms', 'montserrat', 'mt', 'malta', 'mu', 'mauritius', 'mv', 'maldives', 'mw', 'malawi', 'mx', 'mexico', 'my', 'malaysia', 'mz', 'mozambique', 'na', 'namibia', 'nc', 'new caledonia', 'ne', 'niger', 'nf', 'norfolk island', 'ng', 'nigeria', 'ni', 'nicaragua', 'nl', 'netherlands', 'no', 'norway', 'np', 'nepal', 'nr', 'nauru', 'nu', 'niue', 'nz', 'new zealand', 'om', 'oman', 'pa', 'panama', 'pe', 'peru', 'pf', 'french polynesia', 'pg', 'new guinea', 'ph', 'philippines', 'pk', 'pakistan', 'pl', 'poland', 'pm', 'saint pierre', 'pn', 'pitcairn islands', 'pr', 'puerto rico', 'ps', 'palestine', 'pt', 'portugal', 'pw', 'palau', 'py', 'paraguay', 'qa', 'qatar', 're', 'reunion', 'ro', 'romania', 'rs', 'serbia', 'ru', 'russia', 'rw', 'rwanda', 'sa', 'saudi arabia', 'sb', 'solomon islands', 'sc', 'seychelles', 'gb sct', 'scotland', 'sd', 'sudan', 'se', 'sweden', 'sg', 'singapore', 'sh', 'saint helena', 'si', 'slovenia', 'sj', 'svalbard', 'jan mayen', 'sk', 'slovakia', 'sl', 'sierra leone', 'sm', 'san marino', 'sn', 'senegal', 'so', 'somalia', 'sr', 'suriname', 'st', 'sao tome', 'sv', 'el salvador', 'sy', 'syria', 'sz', 'swaziland', 'tc', 'caicos islands', 'td', 'chad', 'tf', 'french territories', 'tg', 'togo', 'th', 'thailand', 'tj', 'tajikistan', 'tk', 'tokelau', 'tl', 'timorleste', 'tm', 'turkmenistan', 'tn', 'tunisia', 'to', 'tonga', 'tr', 'turkey', 'tt', 'trinidad', 'tv', 'tuvalu', 'tw', 'taiwan', 'tz', 'tanzania', 'ua', 'ukraine', 'ug', 'uganda', 'um', 'us minor islands', 'us', 'america', 'united states', 'uy', 'uruguay', 'uz', 'uzbekistan', 'va', 'vatican city', 'vc', 'saint vincent', 've', 'venezuela', 'vg', 'british virgin islands', 'vi', 'us virgin islands', 'vn', 'vietnam', 'vu', 'vanuatu', 'gb wls', 'wales', 'wf', 'wallis and futuna', 'ws', 'samoa', 'ye', 'yemen', 'yt', 'mayotte', 'za', 'south africa', 'zm', 'zambia', 'zw', 'zimbabwe'];
/**
 * A flag is is used to represent a political state.
 */

var Flag = /*#__PURE__*/function (_PureComponent) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Flag, _PureComponent);

  function Flag() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = Flag.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        name = _this$props.name;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(name, 'flag', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(Flag, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(Flag, this.props);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }));
  };

  return Flag;
}(__WEBPACK_IMPORTED_MODULE_4_react__["PureComponent"]);

Flag.handledProps = ["as", "className", "name"];
Flag.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Additional classes. */
  className: PropTypes.string,

  /** Flag name, can use the two digit country code, the full name, or a common alias. */
  name: customPropTypes.suggest(names)
} : {};
Flag.defaultProps = {
  as: 'i'
};
Flag.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["e" /* createShorthandFactory */])(Flag, function (value) {
  return {
    name: value
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Flag);

/***/ }),
/* 3259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Icon__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Image__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__HeaderSubheader__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HeaderContent__ = __webpack_require__(1463);










/**
 * A header provides a short summary of content
 */

function Header(props) {
  var attached = props.attached,
      block = props.block,
      children = props.children,
      className = props.className,
      color = props.color,
      content = props.content,
      disabled = props.disabled,
      dividing = props.dividing,
      floated = props.floated,
      icon = props.icon,
      image = props.image,
      inverted = props.inverted,
      size = props.size,
      sub = props.sub,
      subheader = props.subheader,
      textAlign = props.textAlign;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(block, 'block'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(dividing, 'dividing'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["g" /* useValueAndKey */])(floated, 'floated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(icon === true, 'icon'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(image === true, 'image'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(sub, 'sub'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["h" /* useKeyOrValueAndKey */])(attached, 'attached'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["n" /* useTextAlignProp */])(textAlign), 'header', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(Header, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(Header, props);

  if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  var iconElement = __WEBPACK_IMPORTED_MODULE_6__Icon__["a" /* default */].create(icon, {
    autoGenerateKey: false
  });
  var imageElement = __WEBPACK_IMPORTED_MODULE_7__Image__["a" /* default */].create(image, {
    autoGenerateKey: false
  });
  var subheaderElement = __WEBPACK_IMPORTED_MODULE_8__HeaderSubheader__["a" /* default */].create(subheader, {
    autoGenerateKey: false
  });

  if (iconElement || imageElement) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), iconElement || imageElement, (content || subheaderElement) && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__HeaderContent__["a" /* default */], null, content, subheaderElement));
  }

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), content, subheaderElement);
}

Header.handledProps = ["as", "attached", "block", "children", "className", "color", "content", "disabled", "dividing", "floated", "icon", "image", "inverted", "size", "sub", "subheader", "textAlign"];
Header.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Attach header  to other content, like a segment. */
  attached: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['top', 'bottom'])]),

  /** Format header to appear inside a content block. */
  block: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Color of the header. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Show that the header is inactive. */
  disabled: PropTypes.bool,

  /** Divide header from the content below it. */
  dividing: PropTypes.bool,

  /** Header can sit to the left or right of other content. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** Add an icon by icon name or pass an Icon. */
  icon: customPropTypes.every([customPropTypes.disallow(['image']), PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand])]),

  /** Add an image by img src or pass an Image. */
  image: customPropTypes.every([customPropTypes.disallow(['icon']), PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand])]),

  /** Inverts the color of the header for dark backgrounds. */
  inverted: PropTypes.bool,

  /** Content headings are sized with em and are based on the font-size of their container. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'big', 'massive', 'mini')),

  /** Headers may be formatted to label smaller or de-emphasized content. */
  sub: PropTypes.bool,

  /** Shorthand for Header.Subheader. */
  subheader: customPropTypes.itemShorthand,

  /** Align header content. */
  textAlign: PropTypes.oneOf(SUI.TEXT_ALIGNMENTS)
} : {};
Header.Content = __WEBPACK_IMPORTED_MODULE_9__HeaderContent__["a" /* default */];
Header.Subheader = __WEBPACK_IMPORTED_MODULE_8__HeaderSubheader__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Header);

/***/ }),
/* 3260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header__ = __webpack_require__(3259);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Header__["a"]; });



/***/ }),
/* 3261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_includes__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_get__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_es_isNil__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__fluentui_react_component_ref__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Button__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Icon__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Label__ = __webpack_require__(354);















/**
 * An Input is a field used to elicit a response from a user.
 * @see Button
 * @see Form
 * @see Icon
 * @see Label
 */

var Input = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Input, _Component);

  function Input() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.inputRef = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react__["createRef"])();

    _this.computeIcon = function () {
      var _this$props = _this.props,
          loading = _this$props.loading,
          icon = _this$props.icon;
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isNil__["a" /* default */])(icon)) return icon;
      if (loading) return 'spinner';
    };

    _this.computeTabIndex = function () {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          tabIndex = _this$props2.tabIndex;
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isNil__["a" /* default */])(tabIndex)) return tabIndex;
      if (disabled) return -1;
    };

    _this.focus = function (options) {
      return _this.inputRef.current.focus(options);
    };

    _this.select = function () {
      return _this.inputRef.current.select();
    };

    _this.handleChange = function (e) {
      var value = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_get__["a" /* default */])(e, 'target.value');

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_invoke__["a" /* default */])(_this.props, 'onChange', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        value: value
      }));
    };

    _this.handleChildOverrides = function (child, defaultProps) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, defaultProps, child.props, {
        ref: function ref(c) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__fluentui_react_component_ref__["c" /* handleRef */])(child.ref, c);
          _this.inputRef.current = c;
        }
      });
    };

    _this.partitionProps = function () {
      var _this$props3 = _this.props,
          disabled = _this$props3.disabled,
          type = _this$props3.type;

      var tabIndex = _this.computeTabIndex();

      var unhandled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["b" /* getUnhandledProps */])(Input, _this.props);

      var _partitionHTMLProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["l" /* partitionHTMLProps */])(unhandled),
          htmlInputProps = _partitionHTMLProps[0],
          rest = _partitionHTMLProps[1];

      return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, htmlInputProps, {
        disabled: disabled,
        type: type,
        tabIndex: tabIndex,
        onChange: _this.handleChange,
        ref: _this.inputRef
      }), rest];
    };

    return _this;
  }

  var _proto = Input.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props4 = this.props,
        action = _this$props4.action,
        actionPosition = _this$props4.actionPosition,
        children = _this$props4.children,
        className = _this$props4.className,
        disabled = _this$props4.disabled,
        error = _this$props4.error,
        fluid = _this$props4.fluid,
        focus = _this$props4.focus,
        icon = _this$props4.icon,
        iconPosition = _this$props4.iconPosition,
        input = _this$props4.input,
        inverted = _this$props4.inverted,
        label = _this$props4.label,
        labelPosition = _this$props4.labelPosition,
        loading = _this$props4.loading,
        size = _this$props4.size,
        transparent = _this$props4.transparent,
        type = _this$props4.type;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_clsx__["a" /* default */])('ui', size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* useKeyOnly */])(error, 'error'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* useKeyOnly */])(focus, 'focus'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* useKeyOnly */])(loading, 'loading'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* useKeyOnly */])(transparent, 'transparent'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["g" /* useValueAndKey */])(actionPosition, 'action') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* useKeyOnly */])(action, 'action'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["g" /* useValueAndKey */])(iconPosition, 'icon') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* useKeyOnly */])(icon || loading, 'icon'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["g" /* useValueAndKey */])(labelPosition, 'labeled') || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["a" /* useKeyOnly */])(label, 'labeled'), 'input', className);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["c" /* getElementType */])(Input, this.props);

    var _this$partitionProps = this.partitionProps(),
        htmlInputProps = _this$partitionProps[0],
        rest = _this$partitionProps[1]; // Render with children
    // ----------------------------------------


    if (!__WEBPACK_IMPORTED_MODULE_11__lib__["d" /* childrenUtils */].isNil(children)) {
      // add htmlInputProps to the `<input />` child
      var childElements = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_map__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_10_react__["Children"].toArray(children), function (child) {
        if (child.type !== 'input') return child;
        return /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_react__["cloneElement"])(child, _this2.handleChildOverrides(child, htmlInputProps));
      });

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        className: classes
      }), childElements);
    } // Render Shorthand
    // ----------------------------------------


    var actionElement = __WEBPACK_IMPORTED_MODULE_12__Button__["a" /* default */].create(action, {
      autoGenerateKey: false
    });
    var labelElement = __WEBPACK_IMPORTED_MODULE_14__Label__["a" /* default */].create(label, {
      defaultProps: {
        className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_clsx__["a" /* default */])('label', // add 'left|right corner'
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_includes__["a" /* default */])(labelPosition, 'corner') && labelPosition)
      },
      autoGenerateKey: false
    });
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), actionPosition === 'left' && actionElement, labelPosition !== 'right' && labelElement, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["A" /* createHTMLInput */])(input || type, {
      defaultProps: htmlInputProps,
      autoGenerateKey: false
    }), __WEBPACK_IMPORTED_MODULE_13__Icon__["a" /* default */].create(this.computeIcon(), {
      autoGenerateKey: false
    }), actionPosition !== 'left' && actionElement, labelPosition === 'right' && labelElement);
  };

  return Input;
}(__WEBPACK_IMPORTED_MODULE_10_react__["Component"]);

Input.handledProps = ["action", "actionPosition", "as", "children", "className", "disabled", "error", "fluid", "focus", "icon", "iconPosition", "input", "inverted", "label", "labelPosition", "loading", "onChange", "size", "tabIndex", "transparent", "type"];
Input.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** An Input can be formatted to alert the user to an action they may perform. */
  action: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),

  /** An action can appear along side an Input on the left or right. */
  actionPosition: PropTypes.oneOf(['left']),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** An Input field can show that it is disabled. */
  disabled: PropTypes.bool,

  /** An Input field can show the data contains errors. */
  error: PropTypes.bool,

  /** Take on the size of its container. */
  fluid: PropTypes.bool,

  /** An Input field can show a user is currently interacting with it. */
  focus: PropTypes.bool,

  /** Optional Icon to display inside the Input. */
  icon: PropTypes.oneOfType([PropTypes.bool, customPropTypes.itemShorthand]),

  /** An Icon can appear inside an Input on the left or right. */
  iconPosition: PropTypes.oneOf(['left']),

  /** Shorthand for creating the HTML Input. */
  input: customPropTypes.itemShorthand,

  /** Format to appear on dark backgrounds. */
  inverted: PropTypes.bool,

  /** Optional Label to display along side the Input. */
  label: customPropTypes.itemShorthand,

  /** A Label can appear outside an Input on the left or right. */
  labelPosition: PropTypes.oneOf(['left', 'right', 'left corner', 'right corner']),

  /** An Icon Input field can show that it is currently loading data. */
  loading: PropTypes.bool,

  /**
   * Called on change.
   *
   * @param {ChangeEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and a proposed value.
   */
  onChange: PropTypes.func,

  /** An Input can vary in size. */
  size: PropTypes.oneOf(['mini', 'small', 'large', 'big', 'huge', 'massive']),

  /** An Input can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Transparent Input has no background. */
  transparent: PropTypes.bool,

  /** The HTML input type. */
  type: PropTypes.string
} : {};
Input.defaultProps = {
  type: 'text'
};
Input.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__lib__["e" /* createShorthandFactory */])(Input, function (type) {
  return {
    type: type
  };
});
/* harmony default export */ __webpack_exports__["a"] = (Input);

/***/ }),
/* 3262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ListContent__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ListDescription__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ListHeader__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ListIcon__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ListItem__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ListList__ = __webpack_require__(1471);














/**
 * A list groups related content.
 */

var List = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(List, _Component);

  function List() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleItemOverrides = function (predefinedProps) {
      return {
        onClick: function onClick(e, itemProps) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(predefinedProps, 'onClick', e, itemProps);

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(_this.props, 'onItemClick', e, itemProps);
        }
      };
    };

    return _this;
  }

  var _proto = List.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        animated = _this$props.animated,
        bulleted = _this$props.bulleted,
        celled = _this$props.celled,
        children = _this$props.children,
        className = _this$props.className,
        content = _this$props.content,
        divided = _this$props.divided,
        floated = _this$props.floated,
        horizontal = _this$props.horizontal,
        inverted = _this$props.inverted,
        items = _this$props.items,
        link = _this$props.link,
        ordered = _this$props.ordered,
        relaxed = _this$props.relaxed,
        selection = _this$props.selection,
        size = _this$props.size,
        verticalAlign = _this$props.verticalAlign;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])('ui', size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(animated, 'animated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(bulleted, 'bulleted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(celled, 'celled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(divided, 'divided'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(horizontal, 'horizontal'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(link, 'link'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(ordered, 'ordered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["a" /* useKeyOnly */])(selection, 'selection'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["h" /* useKeyOrValueAndKey */])(relaxed, 'relaxed'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["g" /* useValueAndKey */])(floated, 'floated'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["i" /* useVerticalAlignProp */])(verticalAlign), 'list', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["b" /* getUnhandledProps */])(List, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["c" /* getElementType */])(List, this.props);

    if (!__WEBPACK_IMPORTED_MODULE_7__lib__["d" /* childrenUtils */].isNil(children)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        role: "list",
        className: classes
      }, rest), children);
    }

    if (!__WEBPACK_IMPORTED_MODULE_7__lib__["d" /* childrenUtils */].isNil(content)) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        role: "list",
        className: classes
      }, rest), content);
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      role: "list",
      className: classes
    }, rest), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_map__["a" /* default */])(items, function (item) {
      return __WEBPACK_IMPORTED_MODULE_12__ListItem__["a" /* default */].create(item, {
        overrideProps: _this2.handleItemOverrides
      });
    }));
  };

  return List;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

List.handledProps = ["animated", "as", "bulleted", "celled", "children", "className", "content", "divided", "floated", "horizontal", "inverted", "items", "link", "onItemClick", "ordered", "relaxed", "selection", "size", "verticalAlign"];
List.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A list can animate to set the current item apart from the list. */
  animated: PropTypes.bool,

  /** A list can mark items with a bullet. */
  bulleted: PropTypes.bool,

  /** A list can divide its items into cells. */
  celled: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A list can show divisions between content. */
  divided: PropTypes.bool,

  /** An list can be floated left or right. */
  floated: PropTypes.oneOf(SUI.FLOATS),

  /** A list can be formatted to have items appear horizontally. */
  horizontal: PropTypes.bool,

  /** A list can be inverted to appear on a dark background. */
  inverted: PropTypes.bool,

  /** Shorthand array of props for ListItem. */
  items: customPropTypes.collectionShorthand,

  /** A list can be specially formatted for navigation links. */
  link: PropTypes.bool,

  /**
   * onClick handler for ListItem. Mutually exclusive with children.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All item props.
   */
  onItemClick: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.func]),

  /** A list can be ordered numerically. */
  ordered: PropTypes.bool,

  /** A list can relax its padding to provide more negative space. */
  relaxed: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** A selection list formats list items as possible choices. */
  selection: PropTypes.bool,

  /** A list can vary in size. */
  size: PropTypes.oneOf(SUI.SIZES),

  /** An element inside a list can be vertically aligned. */
  verticalAlign: PropTypes.oneOf(SUI.VERTICAL_ALIGNMENTS)
} : {};
List.Content = __WEBPACK_IMPORTED_MODULE_8__ListContent__["a" /* default */];
List.Description = __WEBPACK_IMPORTED_MODULE_9__ListDescription__["a" /* default */];
List.Header = __WEBPACK_IMPORTED_MODULE_10__ListHeader__["a" /* default */];
List.Icon = __WEBPACK_IMPORTED_MODULE_11__ListIcon__["a" /* default */];
List.Item = __WEBPACK_IMPORTED_MODULE_12__ListItem__["a" /* default */];
List.List = __WEBPACK_IMPORTED_MODULE_13__ListList__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (List);

/***/ }),
/* 3263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(3262);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });



/***/ }),
/* 3264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * A loader alerts a user to wait for an activity to complete.
 * @see Dimmer
 */

function Loader(props) {
  var active = props.active,
      children = props.children,
      className = props.className,
      content = props.content,
      disabled = props.disabled,
      indeterminate = props.indeterminate,
      inline = props.inline,
      inverted = props.inverted,
      size = props.size;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('ui', size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(indeterminate, 'indeterminate'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(children || content, 'text'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["h" /* useKeyOrValueAndKey */])(inline, 'inline'), 'loader', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Loader, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(Loader, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

Loader.handledProps = ["active", "as", "children", "className", "content", "disabled", "indeterminate", "inline", "inverted", "size"];
Loader.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A loader can be active or visible. */
  active: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A loader can be disabled or hidden. */
  disabled: PropTypes.bool,

  /** A loader can show it's unsure of how long a task will take. */
  indeterminate: PropTypes.bool,

  /** Loaders can appear inline with content. */
  inline: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['centered'])]),

  /** Loaders can have their colors inverted. */
  inverted: PropTypes.bool,

  /** Loaders can have different sizes. */
  size: PropTypes.oneOf(SUI.SIZES)
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 3265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Loader__ = __webpack_require__(3264);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Loader__["a"]; });



/***/ }),
/* 3266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PlaceholderHeader__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PlaceholderImage__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PlaceholderLine__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PlaceholderParagraph__ = __webpack_require__(1475);









/**
 * A placeholder is used to reserve space for content that soon will appear in a layout.
 */

function Placeholder(props) {
  var children = props.children,
      className = props.className,
      content = props.content,
      fluid = props.fluid,
      inverted = props.inverted;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), 'placeholder', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Placeholder, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(Placeholder, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

Placeholder.handledProps = ["as", "children", "className", "content", "fluid", "inverted"];
Placeholder.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A fluid placeholder takes up the width of its container. */
  fluid: PropTypes.bool,

  /** A placeholder can have their colors inverted. */
  inverted: PropTypes.bool
} : {};
Placeholder.Header = __WEBPACK_IMPORTED_MODULE_5__PlaceholderHeader__["a" /* default */];
Placeholder.Image = __WEBPACK_IMPORTED_MODULE_6__PlaceholderImage__["a" /* default */];
Placeholder.Line = __WEBPACK_IMPORTED_MODULE_7__PlaceholderLine__["a" /* default */];
Placeholder.Paragraph = __WEBPACK_IMPORTED_MODULE_8__PlaceholderParagraph__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Placeholder);

/***/ }),
/* 3267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Placeholder__ = __webpack_require__(3266);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Placeholder__["a"]; });



/***/ }),
/* 3268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);






/**
 * A rail is used to show accompanying content outside the boundaries of the main view of a site.
 */

function Rail(props) {
  var attached = props.attached,
      children = props.children,
      className = props.className,
      close = props.close,
      content = props.content,
      dividing = props.dividing,
      internal = props.internal,
      position = props.position,
      size = props.size;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])('ui', position, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(attached, 'attached'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(dividing, 'dividing'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(internal, 'internal'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["h" /* useKeyOrValueAndKey */])(close, 'close'), 'rail', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(Rail, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(Rail, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

Rail.handledProps = ["as", "attached", "children", "className", "close", "content", "dividing", "internal", "position", "size"];
Rail.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A rail can appear attached to the main viewport. */
  attached: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A rail can appear closer to the main viewport. */
  close: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])]),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A rail can create a division between itself and a container. */
  dividing: PropTypes.bool,

  /** A rail can attach itself to the inside of a container. */
  internal: PropTypes.bool,

  /** A rail can be presented on the left or right side of a container. */
  position: PropTypes.oneOf(SUI.FLOATS).isRequired,

  /** A rail can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium'))
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Rail);

/***/ }),
/* 3269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rail__ = __webpack_require__(3268);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Rail__["a"]; });



/***/ }),
/* 3270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__RevealContent__ = __webpack_require__(1476);






/**
 * A reveal displays additional content in place of previous content when activated.
 */

function Reveal(props) {
  var active = props.active,
      animated = props.animated,
      children = props.children,
      className = props.className,
      content = props.content,
      disabled = props.disabled,
      instant = props.instant;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('ui', animated, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(active, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(instant, 'instant'), 'reveal', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Reveal, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(Reveal, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

Reveal.handledProps = ["active", "animated", "as", "children", "className", "content", "disabled", "instant"];
Reveal.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** An active reveal displays its hidden content. */
  active: PropTypes.bool,

  /** An animation name that will be applied to Reveal. */
  animated: PropTypes.oneOf(['fade', 'small fade', 'move', 'move right', 'move up', 'move down', 'rotate', 'rotate left']),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A disabled reveal will not animate when hovered. */
  disabled: PropTypes.bool,

  /** An element can show its content without delay. */
  instant: PropTypes.bool
} : {};
Reveal.Content = __WEBPACK_IMPORTED_MODULE_5__RevealContent__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Reveal);

/***/ }),
/* 3271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Reveal__ = __webpack_require__(3270);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Reveal__["a"]; });



/***/ }),
/* 3272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Segment__ = __webpack_require__(1477);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Segment__["a"]; });



/***/ }),
/* 3273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Step__ = __webpack_require__(1480);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Step__["a"]; });



/***/ }),
/* 3274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ModernAutoControlledComponent; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isUndefined__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_startsWith__ = __webpack_require__(3480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_filter__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_es_isEmpty__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_es_keys__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_es_intersection__ = __webpack_require__(3461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_es_has__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_es_each__ = __webpack_require__(1582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react__);














var getDefaultPropName = function getDefaultPropName(prop) {
  return "default" + (prop[0].toUpperCase() + prop.slice(1));
};
/**
 * Return the auto controlled state value for a give prop. The initial value is chosen in this order:
 *  - regular props
 *  - then, default props
 *  - then, initial state
 *  - then, `checked` defaults to false
 *  - then, `value` defaults to '' or [] if props.multiple
 *  - else, undefined
 *
 *  @param {string} propName A prop name
 *  @param {object} [props] A props object
 *  @param {object} [state] A state object
 *  @param {boolean} [includeDefaults=false] Whether or not to heed the default props or initial state
 */


var getAutoControlledStateValue = function getAutoControlledStateValue(propName, props, state, includeDefaults) {
  if (includeDefaults === void 0) {
    includeDefaults = false;
  }

  // regular props
  var propValue = props[propName];
  if (propValue !== undefined) return propValue;

  if (includeDefaults) {
    // defaultProps
    var defaultProp = props[getDefaultPropName(propName)];
    if (defaultProp !== undefined) return defaultProp; // initial state - state may be null or undefined

    if (state) {
      var initialState = state[propName];
      if (initialState !== undefined) return initialState;
    }
  } // React doesn't allow changing from uncontrolled to controlled components,
  // default checked/value if they were not present.


  if (propName === 'checked') return false;
  if (propName === 'value') return props.multiple ? [] : ''; // otherwise, undefined
};

var ModernAutoControlledComponent = /*#__PURE__*/function (_React$Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ModernAutoControlledComponent, _React$Component);

  function ModernAutoControlledComponent() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    var _this$constructor = _this.constructor,
        autoControlledProps = _this$constructor.autoControlledProps,
        getAutoControlledStateFromProps = _this$constructor.getAutoControlledStateFromProps;
    var state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash_es_invoke__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this), 'getInitialAutoControlledState', _this.props) || {};

    if (false) {
      var _this$constructor2 = _this.constructor,
          defaultProps = _this$constructor2.defaultProps,
          name = _this$constructor2.name,
          propTypes = _this$constructor2.propTypes,
          getDerivedStateFromProps = _this$constructor2.getDerivedStateFromProps; // require usage of getAutoControlledStateFromProps()

      if (getDerivedStateFromProps !== ModernAutoControlledComponent.getDerivedStateFromProps) {
        /* eslint-disable-next-line no-console */
        console.error("Auto controlled " + name + " must specify a static getAutoControlledStateFromProps() instead of getDerivedStateFromProps().");
      } // require propTypes


      _each(autoControlledProps, function (prop) {
        var defaultProp = getDefaultPropName(prop); // regular prop

        if (!_has(propTypes, defaultProp)) {
          console.error(name + " is missing \"" + defaultProp + "\" propTypes validation for auto controlled prop \"" + prop + "\".");
        } // its default prop


        if (!_has(propTypes, prop)) {
          console.error(name + " is missing propTypes validation for auto controlled prop \"" + prop + "\".");
        }
      }); // prevent autoControlledProps in defaultProps
      //
      // When setting state, auto controlled props values always win (so the parent can manage them).
      // It is not reasonable to decipher the difference between props from the parent and defaultProps.
      // Allowing defaultProps results in trySetState always deferring to the defaultProp value.
      // Auto controlled props also listed in defaultProps can never be updated.
      //
      // To set defaults for an AutoControlled prop, you can set the initial state in the
      // constructor or by using an ES7 property initializer:
      // https://babeljs.io/blog/2015/06/07/react-on-es6-plus#property-initializers


      var illegalDefaults = _intersection(autoControlledProps, _keys(defaultProps));

      if (!_isEmpty(illegalDefaults)) {
        console.error(['Do not set defaultProps for autoControlledProps. You can set defaults by', 'setting state in the constructor or using an ES7 property initializer', '(https://babeljs.io/blog/2015/06/07/react-on-es6-plus#property-initializers)', "See " + name + " props: \"" + illegalDefaults + "\"."].join(' '));
      } // prevent listing defaultProps in autoControlledProps
      //
      // Default props are automatically handled.
      // Listing defaults in autoControlledProps would result in allowing defaultDefaultValue props.


      var illegalAutoControlled = _filter(autoControlledProps, function (prop) {
        return _startsWith(prop, 'default');
      });

      if (!_isEmpty(illegalAutoControlled)) {
        console.error(['Do not add default props to autoControlledProps.', 'Default props are automatically handled.', "See " + name + " autoControlledProps: \"" + illegalAutoControlled + "\"."].join(' '));
      }
    } // Auto controlled props are copied to state.
    // Set initial state by copying auto controlled props to state.
    // Also look for the default prop for any auto controlled props (foo => defaultFoo)
    // so we can set initial values from defaults.


    var initialAutoControlledState = autoControlledProps.reduce(function (acc, prop) {
      acc[prop] = getAutoControlledStateValue(prop, _this.props, state, true);

      if (false) {
        var defaultPropName = getDefaultPropName(prop);
        var _name = _this.constructor.name; // prevent defaultFoo={} along side foo={}

        if (!_isUndefined(_this.props[defaultPropName]) && !_isUndefined(_this.props[prop])) {
          console.error(_name + " prop \"" + prop + "\" is auto controlled. Specify either " + defaultPropName + " or " + prop + ", but not both.");
        }
      }

      return acc;
    }, {});
    _this.state = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, initialAutoControlledState, {
      autoControlledProps: autoControlledProps,
      getAutoControlledStateFromProps: getAutoControlledStateFromProps
    });
    return _this;
  }

  ModernAutoControlledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    var autoControlledProps = state.autoControlledProps,
        getAutoControlledStateFromProps = state.getAutoControlledStateFromProps; // Solve the next state for autoControlledProps

    var newStateFromProps = autoControlledProps.reduce(function (acc, prop) {
      var isNextDefined = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isUndefined__["a" /* default */])(props[prop]); // if next is defined then use its value

      if (isNextDefined) acc[prop] = props[prop];
      return acc;
    }, {}); // Due to the inheritance of the AutoControlledComponent we should call its
    // getAutoControlledStateFromProps() and merge it with the existing state

    if (getAutoControlledStateFromProps) {
      var computedState = getAutoControlledStateFromProps(props, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state, newStateFromProps), state); // We should follow the idea of getDerivedStateFromProps() and return only modified state

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, newStateFromProps, computedState);
    }

    return newStateFromProps;
  }
  /**
   * Override this method to use getDerivedStateFromProps() in child components.
   */
  ;

  ModernAutoControlledComponent.getAutoControlledStateFromProps = function getAutoControlledStateFromProps() {
    return null;
  };

  return ModernAutoControlledComponent;
}(__WEBPACK_IMPORTED_MODULE_12_react___default.a.Component);



/***/ }),
/* 3275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COLORS", function() { return COLORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FLOATS", function() { return FLOATS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SIZES", function() { return SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TEXT_ALIGNMENTS", function() { return TEXT_ALIGNMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VERTICAL_ALIGNMENTS", function() { return VERTICAL_ALIGNMENTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VISIBILITY", function() { return VISIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WIDTHS", function() { return WIDTHS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DIRECTIONAL_TRANSITIONS", function() { return DIRECTIONAL_TRANSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATIC_TRANSITIONS", function() { return STATIC_TRANSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TRANSITIONS", function() { return TRANSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ACCESSIBILITY", function() { return ACCESSIBILITY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARROWS", function() { return ARROWS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUDIO_VIDEO", function() { return AUDIO_VIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BUSINESS", function() { return BUSINESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHESS", function() { return CHESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CODE", function() { return CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMMUNICATION", function() { return COMMUNICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPUTERS", function() { return COMPUTERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CURRENCY", function() { return CURRENCY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DATE_TIME", function() { return DATE_TIME; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESIGN", function() { return DESIGN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EDITORS", function() { return EDITORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FILES", function() { return FILES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "GENDERS", function() { return GENDERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HANDS_GESTURES", function() { return HANDS_GESTURES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HEALTH", function() { return HEALTH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IMAGES", function() { return IMAGES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INTERFACES", function() { return INTERFACES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LOGISTICS", function() { return LOGISTICS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MAPS", function() { return MAPS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MEDICAL", function() { return MEDICAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OBJECTS", function() { return OBJECTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PAYMENTS_SHOPPING", function() { return PAYMENTS_SHOPPING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SHAPES", function() { return SHAPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPINNERS", function() { return SPINNERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SPORTS", function() { return SPORTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STATUS", function() { return STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "USERS_PEOPLE", function() { return USERS_PEOPLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VEHICLES", function() { return VEHICLES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WRITING", function() { return WRITING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BRANDS", function() { return BRANDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICONS", function() { return ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICON_ALIASES", function() { return ICON_ALIASES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ICONS_AND_ALIASES", function() { return ICONS_AND_ALIASES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "COMPONENT_CONTEXT_SPECIFIC_ICONS", function() { return COMPONENT_CONTEXT_SPECIFIC_ICONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ALL_ICONS_IN_ALL_CONTEXTS", function() { return ALL_ICONS_IN_ALL_CONTEXTS; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_uniq__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_values__ = __webpack_require__(502);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_keys__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__numberToWord__ = __webpack_require__(713);




var COLORS = ['red', 'orange', 'yellow', 'olive', 'green', 'teal', 'blue', 'violet', 'purple', 'pink', 'brown', 'grey', 'black'];
var FLOATS = ['left', 'right'];
var SIZES = ['mini', 'tiny', 'small', 'medium', 'large', 'big', 'huge', 'massive'];
var TEXT_ALIGNMENTS = ['left', 'center', 'right', 'justified'];
var VERTICAL_ALIGNMENTS = ['bottom', 'middle', 'top'];
var VISIBILITY = ['mobile', 'tablet', 'computer', 'large screen', 'widescreen'];
var WIDTHS = [].concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_keys__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__numberToWord__["a" /* numberToWordMap */]), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_keys__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__numberToWord__["a" /* numberToWordMap */]).map(Number), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_values__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__numberToWord__["a" /* numberToWordMap */]));
var DIRECTIONAL_TRANSITIONS = ['browse', 'browse right', 'drop', 'fade', 'fade up', 'fade down', 'fade left', 'fade right', 'fly up', 'fly down', 'fly left', 'fly right', 'horizontal flip', 'vertical flip', 'scale', 'slide up', 'slide down', 'slide left', 'slide right', 'swing up', 'swing down', 'swing left', 'swing right', 'zoom'];
var STATIC_TRANSITIONS = ['jiggle', 'flash', 'shake', 'pulse', 'tada', 'bounce', 'glow'];
var TRANSITIONS = [].concat(DIRECTIONAL_TRANSITIONS, STATIC_TRANSITIONS); // Generated from:
// https://github.com/Semantic-Org/Semantic-UI/blob/master/dist/components/icon.css

var ACCESSIBILITY = ['american sign language interpreting', 'assistive listening systems', 'audio description', 'blind', 'braille', 'closed captioning', 'closed captioning outline', 'deaf', 'low vision', 'phone volume', 'question circle', 'question circle outline', 'sign language', 'tty', 'universal access', 'wheelchair'];
var ARROWS = ['angle double down', 'angle double left', 'angle double right', 'angle double up', 'angle down', 'angle left', 'angle right', 'angle up', 'arrow alternate circle down', 'arrow alternate circle down outline', 'arrow alternate circle left', 'arrow alternate circle left outline', 'arrow alternate circle right', 'arrow alternate circle right outline', 'arrow alternate circle up', 'arrow alternate circle up outline', 'arrow circle down', 'arrow circle left', 'arrow circle right', 'arrow circle up', 'arrow down', 'arrow left', 'arrow right', 'arrow up', 'arrows alternate', 'arrows alternate horizontal', 'arrows alternate vertical', 'caret down', 'caret left', 'caret right', 'caret square down', 'caret square down outline', 'caret square left', 'caret square left outline', 'caret square right', 'caret square right outline', 'caret square up', 'caret square up outline', 'caret up', 'cart arrow down', 'chart line', 'chevron circle down', 'chevron circle left', 'chevron circle right', 'chevron circle up', 'chevron down', 'chevron left', 'chevron right', 'chevron up', 'cloud download', 'cloud upload', 'download', 'exchange', 'expand arrows alternate', 'external alternate', 'external square alternate', 'hand point down', 'hand point down outline', 'hand point left', 'hand point left outline', 'hand point right', 'hand point right outline', 'hand point up', 'hand point up outline', 'hand pointer', 'hand pointer outline', 'history', 'level down alternate', 'level up alternate', 'location arrow', 'long arrow alternate down', 'long arrow alternate left', 'long arrow alternate right', 'long arrow alternate up', 'mouse pointer', 'play', 'random', 'recycle', 'redo', 'redo alternate', 'reply', 'reply all', 'retweet', 'share', 'share square', 'share square outline', 'sign-in', 'sign-out', 'sign-in alternate', 'sign-out alternate', 'sort', 'sort alphabet down', 'sort alphabet up', 'sort amount down', 'sort amount up', 'sort down', 'sort numeric down', 'sort numeric up', 'sort up', 'sync', 'sync alternate', 'text height', 'text width', 'undo', 'undo alternate', 'upload', 'zoom-in', 'zoom-out'];
var AUDIO_VIDEO = ['audio description', 'backward', 'circle', 'circle outline', 'closed captioning', 'closed captioning outline', 'compress', 'eject', 'expand', 'expand arrows alternate', 'fast backward', 'fast forward', 'file audio', 'file audio outline', 'file video', 'file video outline', 'film', 'forward', 'headphones', 'microphone', 'microphone slash', 'music', 'pause', 'pause circle', 'pause circle outline', 'phone volume', 'play', 'play circle', 'play circle outline', 'podcast', 'random', 'redo', 'redo alternate', 'rss', 'rss square', 'step backward', 'step forward', 'stop', 'stop circle', 'stop circle outline', 'sync', 'sync alternate', 'undo', 'undo alternate', 'video', 'volume down', 'volume off', 'volume up'];
var BUSINESS = ['address book', 'address book outline', 'address card', 'address card outline', 'archive', 'balance scale', 'birthday cake', 'book', 'briefcase', 'building', 'building outline', 'bullhorn', 'bullseye', 'calculator', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'certificate', 'chart area', 'chart bar', 'chart bar outline', 'chart line', 'chart pie', 'clipboard', 'clipboard outline', 'coffee', 'columns', 'compass', 'compass outline', 'copy', 'copy outline', 'copyright', 'copyright outline', 'cut', 'edit', 'edit outline', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'envelope square', 'eraser', 'fax', 'file', 'file outline', 'file alternate', 'file alternate outline', 'folder', 'folder outline', 'folder open', 'folder open outline', 'globe', 'industry', 'paperclip', 'paste', 'pen square', 'pencil alternate', 'percent', 'phone', 'phone square', 'phone volume', 'registered', 'registered outline', 'save', 'save outline', 'sitemap', 'sticky note', 'sticky note outline', 'suitcase', 'table', 'tag', 'tags', 'tasks', 'thumbtack', 'trademark'];
var CHESS = ['chess', 'chess bishop', 'chess board', 'chess king', 'chess knight', 'chess pawn', 'chess queen', 'chess rook', 'square full'];
var CODE = ['archive', 'barcode', 'bath', 'bug', 'code', 'code branch', 'coffee', 'file', 'file outline', 'file alternate', 'file alternate outline', 'file code', 'file code outline', 'filter', 'fire extinguisher', 'folder', 'folder outline', 'folder open', 'folder open outline', 'keyboard', 'keyboard outline', 'microchip', 'qrcode', 'shield alternate', 'sitemap', 'terminal', 'user secret', 'window close', 'window close outline', 'window maximize', 'window maximize outline', 'window minimize', 'window minimize outline', 'window restore', 'window restore outline'];
var COMMUNICATION = ['address book', 'address book outline', 'address card', 'address card outline', 'american sign language interpreting', 'assistive listening systems', 'at', 'bell', 'bell outline', 'bell slash', 'bell slash outline', 'bullhorn', 'comment', 'comment outline', 'comment alternate', 'comment alternate outline', 'comments', 'comments outline', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'envelope square', 'fax', 'inbox', 'language', 'microphone', 'microphone slash', 'mobile', 'mobile alternate', 'paper plane', 'paper plane outline', 'phone', 'phone square', 'phone volume', 'rss', 'rss square', 'tty', 'wifi'];
var COMPUTERS = ['desktop', 'download', 'hdd', 'hdd outline', 'headphones', 'keyboard', 'keyboard outline', 'laptop', 'microchip', 'mobile', 'mobile alternate', 'plug', 'power off', 'print', 'save', 'save outline', 'server', 'tablet', 'tablet alternate', 'tv', 'upload'];
var CURRENCY = ['dollar sign', 'euro sign', 'lira sign', 'money bill alternate', 'money bill alternate outline', 'pound sign', 'ruble sign', 'rupee sign', 'shekel sign', 'won sign', 'yen sign'];
var DATE_TIME = ['bell', 'bell outline', 'bell slash', 'bell slash outline', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'calendar check', 'calendar check outline', 'calendar minus', 'calendar minus outline', 'calendar plus', 'calendar plus outline', 'calendar times', 'calendar times outline', 'clock', 'clock outline', 'hourglass', 'hourglass outline', 'hourglass end', 'hourglass half', 'hourglass start', 'stopwatch'];
var DESIGN = ['adjust', 'clone', 'clone outline', 'copy', 'copy outline', 'crop', 'crosshairs', 'cut', 'edit', 'edit outline', 'eraser', 'eye', 'eye dropper', 'eye slash', 'eye slash outline', 'object group', 'object group outline', 'object ungroup', 'object ungroup outline', 'paint brush', 'paste', 'pencil alternate', 'save', 'save outline', 'tint'];
var EDITORS = ['align center', 'align justify', 'align left', 'align right', 'bold', 'clipboard', 'clipboard outline', 'clone', 'clone outline', 'columns', 'copy', 'copy outline', 'cut', 'edit', 'edit outline', 'eraser', 'file', 'file outline', 'file alternate', 'file alternate outline', 'font', 'heading', 'i cursor', 'indent', 'italic', 'linkify', 'list', 'list alternate', 'list alternate outline', 'list ol', 'list ul', 'outdent', 'paper plane', 'paper plane outline', 'paperclip', 'paragraph', 'paste', 'pencil alternate', 'print', 'quote left', 'quote right', 'redo', 'redo alternate', 'reply', 'reply all', 'share', 'strikethrough', 'subscript', 'superscript', 'sync', 'sync alternate', 'table', 'tasks', 'text height', 'text width', 'th', 'th large', 'th list', 'trash', 'trash alternate', 'trash alternate outline', 'underline', 'undo', 'undo alternate', 'unlink'];
var FILES = ['archive', 'clone', 'clone outline', 'copy', 'copy outline', 'cut', 'file', 'file outline', 'file alternate', 'file alternate outline', 'file archive', 'file archive outline', 'file audio', 'file audio outline', 'file code', 'file code outline', 'file excel', 'file excel outline', 'file image', 'file image outline', 'file pdf', 'file pdf outline', 'file powerpoint', 'file powerpoint outline', 'file video', 'file video outline', 'file word', 'file word outline', 'folder', 'folder outline', 'folder open', 'folder open outline', 'paste', 'save', 'save outline', 'sticky note', 'sticky note outline'];
var GENDERS = ['genderless', 'mars', 'mars double', 'mars stroke', 'mars stroke horizontal', 'mars stroke vertical', 'mercury', 'neuter', 'transgender', 'transgender alternate', 'venus', 'venus double', 'venus mars'];
var HANDS_GESTURES = ['hand lizard', 'hand lizard outline', 'hand paper', 'hand paper outline', 'hand peace', 'hand peace outline', 'hand point down', 'hand point down outline', 'hand point left', 'hand point left outline', 'hand point right', 'hand point right outline', 'hand point up', 'hand point up outline', 'hand pointer', 'hand pointer outline', 'hand rock', 'hand rock outline', 'hand scissors', 'hand scissors outline', 'hand spock', 'hand spock outline', 'handshake', 'handshake outline', 'thumbs down', 'thumbs down outline', 'thumbs up', 'thumbs up outline'];
var HEALTH = ['ambulance', 'h square', 'heart', 'heart outline', 'heartbeat', 'hospital', 'hospital outline', 'medkit', 'plus square', 'plus square outline', 'stethoscope', 'user md', 'wheelchair'];
var IMAGES = ['adjust', 'bolt', 'camera', 'camera retro', 'clone', 'clone outline', 'compress', 'expand', 'eye', 'eye dropper', 'eye slash', 'eye slash outline', 'file image', 'file image outline', 'film', 'id badge', 'id badge outline', 'id card', 'id card outline', 'image', 'image outline', 'images', 'images outline', 'sliders horizontal', 'tint'];
var INTERFACES = ['ban', 'barcode', 'bars', 'beer', 'bell', 'bell outline', 'bell slash', 'bell slash outline', 'bug', 'bullhorn', 'bullseye', 'calculator', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'calendar check', 'calendar check outline', 'calendar minus', 'calendar minus outline', 'calendar plus', 'calendar plus outline', 'calendar times', 'calendar times outline', 'certificate', 'check', 'check circle', 'check circle outline', 'check square', 'check square outline', 'circle', 'circle outline', 'clipboard', 'clipboard outline', 'clone', 'clone outline', 'cloud', 'cloud download', 'cloud upload', 'coffee', 'cog', 'cogs', 'copy', 'copy outline', 'cut', 'database', 'dot circle', 'dot circle outline', 'download', 'edit', 'edit outline', 'ellipsis horizontal', 'ellipsis vertical', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'eraser', 'exclamation', 'exclamation circle', 'exclamation triangle', 'external alternate', 'external square alternate', 'eye', 'eye slash', 'eye slash outline', 'file', 'file outline', 'file alternate', 'file alternate outline', 'filter', 'flag', 'flag outline', 'flag checkered', 'folder', 'folder outline', 'folder open', 'folder open outline', 'frown', 'frown outline', 'hashtag', 'heart', 'heart outline', 'history', 'home', 'i cursor', 'info', 'info circle', 'language', 'magic', 'meh', 'meh outline', 'microphone', 'microphone slash', 'minus', 'minus circle', 'minus square', 'minus square outline', 'paste', 'pencil alternate', 'plus', 'plus circle', 'plus square', 'plus square outline', 'qrcode', 'question', 'question circle', 'question circle outline', 'quote left', 'quote right', 'redo', 'redo alternate', 'reply', 'reply all', 'rss', 'rss square', 'save', 'save outline', 'search', 'search minus', 'search plus', 'share', 'share alternate', 'share alternate square', 'share square', 'share square outline', 'shield alternate', 'sign-in', 'sign-out', 'signal', 'sitemap', 'sliders horizontal', 'smile', 'smile outline', 'sort', 'sort alphabet down', 'sort alphabet up', 'sort amount down', 'sort amount up', 'sort down', 'sort numeric down', 'sort numeric up', 'sort up', 'star', 'star outline', 'star half', 'star half outline', 'sync', 'sync alternate', 'thumbs down', 'thumbs down outline', 'thumbs up', 'thumbs up outline', 'times', 'times circle', 'times circle outline', 'toggle off', 'toggle on', 'trash', 'trash alternate', 'trash alternate outline', 'trophy', 'undo', 'undo alternate', 'upload', 'user', 'user outline', 'user circle', 'user circle outline', 'wifi'];
var LOGISTICS = ['box', 'boxes', 'clipboard check', 'clipboard list', 'dolly', 'dolly flatbed', 'pallet', 'shipping fast', 'truck', 'warehouse'];
var MAPS = ['ambulance', 'anchor', 'balance scale', 'bath', 'bed', 'beer', 'bell', 'bell outline', 'bell slash', 'bell slash outline', 'bicycle', 'binoculars', 'birthday cake', 'blind', 'bomb', 'book', 'bookmark', 'bookmark outline', 'briefcase', 'building', 'building outline', 'car', 'coffee', 'crosshairs', 'dollar sign', 'eye', 'eye slash', 'eye slash outline', 'fighter jet', 'fire', 'fire extinguisher', 'flag', 'flag outline', 'flag checkered', 'flask', 'gamepad', 'gavel', 'gift', 'glass martini', 'globe', 'graduation cap', 'h square', 'heart', 'heart outline', 'heartbeat', 'home', 'hospital', 'hospital outline', 'image', 'image outline', 'images', 'images outline', 'industry', 'info', 'info circle', 'key', 'leaf', 'lemon', 'lemon outline', 'life ring', 'life ring outline', 'lightbulb', 'lightbulb outline', 'location arrow', 'low vision', 'magnet', 'male', 'map', 'map outline', 'map marker', 'map marker alternate', 'map pin', 'map signs', 'medkit', 'money bill alternate', 'money bill alternate outline', 'motorcycle', 'music', 'newspaper', 'newspaper outline', 'paw', 'phone', 'phone square', 'phone volume', 'plane', 'plug', 'plus', 'plus square', 'plus square outline', 'print', 'recycle', 'road', 'rocket', 'search', 'search minus', 'search plus', 'ship', 'shopping bag', 'shopping basket', 'shopping cart', 'shower', 'street view', 'subway', 'suitcase', 'tag', 'tags', 'taxi', 'thumbtack', 'ticket alternate', 'tint', 'train', 'tree', 'trophy', 'truck', 'tty', 'umbrella', 'university', 'utensil spoon', 'utensils', 'wheelchair', 'wifi', 'wrench'];
var MEDICAL = ['ambulance', 'band aid', 'dna', 'first aid', 'heart', 'heart outline', 'heartbeat', 'hospital', 'hospital outline', 'hospital symbol', 'pills', 'plus', 'stethoscope', 'syringe', 'thermometer', 'user md', 'weight'];
var OBJECTS = ['ambulance', 'anchor', 'archive', 'balance scale', 'bath', 'bed', 'beer', 'bell', 'bell outline', 'bicycle', 'binoculars', 'birthday cake', 'bomb', 'book', 'bookmark', 'bookmark outline', 'briefcase', 'bug', 'building', 'building outline', 'bullhorn', 'bullseye', 'bus', 'calculator', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'camera', 'camera retro', 'car', 'clipboard', 'clipboard outline', 'cloud', 'coffee', 'cog', 'cogs', 'compass', 'compass outline', 'copy', 'copy outline', 'cube', 'cubes', 'cut', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'eraser', 'eye', 'eye dropper', 'fax', 'fighter jet', 'file', 'file outline', 'file alternate', 'file alternate outline', 'film', 'fire', 'fire extinguisher', 'flag', 'flag outline', 'flag checkered', 'flask', 'futbol', 'futbol outline', 'gamepad', 'gavel', 'gem', 'gem outline', 'gift', 'glass martini', 'globe', 'graduation cap', 'hdd', 'hdd outline', 'headphones', 'heart', 'heart outline', 'home', 'hospital', 'hospital outline', 'hourglass', 'hourglass outline', 'image', 'image outline', 'images', 'images outline', 'industry', 'key', 'keyboard', 'keyboard outline', 'laptop', 'leaf', 'lemon', 'lemon outline', 'life ring', 'life ring outline', 'lightbulb', 'lightbulb outline', 'lock', 'lock open', 'magic', 'magnet', 'map', 'map outline', 'map marker', 'map marker alternate', 'map pin', 'map signs', 'medkit', 'microchip', 'microphone', 'mobile', 'mobile alternate', 'money bill alternate', 'money bill alternate outline', 'moon', 'moon outline', 'motorcycle', 'newspaper', 'newspaper outline', 'paint brush', 'paper plane', 'paper plane outline', 'paperclip', 'paste', 'paw', 'pencil alternate', 'phone', 'plane', 'plug', 'print', 'puzzle piece', 'road', 'rocket', 'save', 'save outline', 'search', 'shield alternate', 'shopping bag', 'shopping basket', 'shopping cart', 'shower', 'snowflake', 'snowflake outline', 'space shuttle', 'star', 'star outline', 'sticky note', 'sticky note outline', 'stopwatch', 'subway', 'suitcase', 'sun', 'sun outline', 'tablet', 'tablet alternate', 'tachometer alternate', 'tag', 'tags', 'taxi', 'thumbtack', 'ticket alternate', 'train', 'trash', 'trash alternate', 'trash alternate outline', 'tree', 'trophy', 'truck', 'tv', 'umbrella', 'university', 'unlock', 'unlock alternate', 'utensil spoon', 'utensils', 'wheelchair', 'wrench'];
var PAYMENTS_SHOPPING = ['bell', 'bell outline', 'bookmark', 'bookmark outline', 'bullhorn', 'camera', 'camera retro', 'cart arrow down', 'cart plus', 'certificate', 'credit card', 'credit card outline', 'gem', 'gem outline', 'gift', 'handshake', 'handshake outline', 'heart', 'heart outline', 'key', 'shopping bag', 'shopping basket', 'shopping cart', 'star', 'star outline', 'tag', 'tags', 'thumbs down', 'thumbs down outline', 'thumbs up', 'thumbs up outline', 'trophy'];
var SHAPES = ['bookmark', 'bookmark outline', 'calendar', 'calendar outline', 'certificate', 'circle', 'circle outline', 'cloud', 'comment', 'comment outline', 'file', 'file outline', 'folder', 'folder outline', 'heart', 'heart outline', 'map marker', 'play', 'square', 'square outline', 'star', 'star outline'];
var SPINNERS = ['asterisk', 'certificate', 'circle notch', 'cog', 'compass', 'compass outline', 'crosshairs', 'life ring', 'life ring outline', 'snowflake', 'snowflake outline', 'spinner', 'sun', 'sun outline', 'sync'];
var SPORTS = ['baseball ball', 'basketball ball', 'bowling ball', 'football ball', 'futbol', 'futbol outline', 'golf ball', 'hockey puck', 'quidditch', 'table tennis', 'volleyball ball'];
var STATUS = ['ban', 'battery empty', 'battery full', 'battery half', 'battery quarter', 'battery three quarters', 'bell', 'bell outline', 'bell slash', 'bell slash outline', 'calendar', 'calendar outline', 'calendar alternate', 'calendar alternate outline', 'calendar check', 'calendar check outline', 'calendar minus', 'calendar minus outline', 'calendar plus', 'calendar plus outline', 'calendar times', 'calendar times outline', 'cart arrow down', 'cart plus', 'exclamation', 'exclamation circle', 'exclamation triangle', 'eye', 'eye slash', 'eye slash outline', 'file', 'file outline', 'file alternate', 'file alternate outline', 'folder', 'folder outline', 'folder open', 'folder open outline', 'info', 'info circle', 'lock', 'lock open', 'minus', 'minus circle', 'minus square', 'minus square outline', 'plus', 'plus circle', 'plus square', 'plus square outline', 'question', 'question circle', 'question circle outline', 'shield alternate', 'shopping cart', 'sign in alternate', 'sign out alternate', 'thermometer empty', 'thermometer full', 'thermometer half', 'thermometer quarter', 'thermometer three quarters', 'thumbs down', 'thumbs down outline', 'thumbs up', 'thumbs up outline', 'toggle off', 'toggle on', 'unlock', 'unlock alternate'];
var USERS_PEOPLE = ['address book', 'address book outline', 'address card', 'address card outline', 'bed', 'blind', 'child', 'female', 'frown', 'frown outline', 'id badge', 'id badge outline', 'id card', 'id card outline', 'male', 'meh', 'meh outline', 'power off', 'smile', 'smile outline', 'street view', 'user', 'user outline', 'user circle', 'user circle outline', 'user md', 'user plus', 'user secret', 'user times', 'users', 'wheelchair'];
var VEHICLES = ['ambulance', 'bicycle', 'bus', 'car', 'fighter jet', 'motorcycle', 'paper plane', 'paper plane outline', 'plane', 'rocket', 'ship', 'shopping cart', 'space shuttle', 'subway', 'taxi', 'train', 'truck', 'wheelchair'];
var WRITING = ['archive', 'book', 'bookmark', 'bookmark outline', 'edit', 'edit outline', 'envelope', 'envelope outline', 'envelope open', 'envelope open outline', 'eraser', 'file', 'file outline', 'file alternate', 'file alternate outline', 'folder', 'folder outline', 'folder open', 'folder open outline', 'keyboard', 'keyboard outline', 'newspaper', 'newspaper outline', 'paper plane', 'paper plane outline', 'paperclip', 'paragraph', 'pen square', 'pencil alternate', 'quote left', 'quote right', 'sticky note', 'sticky note outline', 'thumbtack'];
var BRANDS = ['500px', 'accessible', 'accusoft', 'adn', 'adversal', 'affiliatetheme', 'algolia', 'amazon', 'amazon pay', 'amilia', 'android', 'angellist', 'angrycreative', 'angular', 'app store', 'app store ios', 'apper', 'apple', 'apple pay', 'asymmetrik', 'audible', 'autoprefixer', 'avianex', 'aviato', 'aws', 'bandcamp', 'behance', 'behance square', 'bimobject', 'bitbucket', 'bitcoin', 'bity', 'black tie', 'blackberry', 'blogger', 'blogger b', 'bluetooth', 'bluetooth b', 'btc', 'buromobelexperte', 'buysellads', 'cc amazon pay', 'cc amex', 'cc apple pay', 'cc diners club', 'cc discover', 'cc jcb', 'cc mastercard', 'cc paypal', 'cc stripe', 'cc visa', 'centercode', 'chrome', 'cloudscale', 'cloudsmith', 'cloudversify', 'codepen', 'codiepie', 'connectdevelop', 'contao', 'cpanel', 'creative commons', 'css3', 'css3 alternate', 'cuttlefish', 'd and d', 'dashcube', 'delicious', 'deploydog', 'deskpro', 'deviantart', 'digg', 'digital ocean', 'discord', 'discourse', 'dochub', 'docker', 'draft2digital', 'dribbble', 'dribbble square', 'dropbox', 'drupal', 'dyalog', 'earlybirds', 'edge', 'elementor', 'ember', 'empire', 'envira', 'erlang', 'ethereum', 'etsy', 'expeditedssl', 'facebook', 'facebook f', 'facebook messenger', 'facebook square', 'firefox', 'first order', 'firstdraft', 'flickr', 'flipboard', 'fly', 'font awesome', 'font awesome alternate', 'font awesome flag', 'fonticons', 'fonticons fi', 'fort awesome', 'fort awesome alternate', 'forumbee', 'foursquare', 'free code camp', 'freebsd', 'get pocket', 'gg', 'gg circle', 'git', 'git square', 'github', 'github alternate', 'github square', 'gitkraken', 'gitlab', 'gitter', 'glide', 'glide g', 'gofore', 'goodreads', 'goodreads g', 'google', 'google drive', 'google play', 'google plus', 'google plus g', 'google plus square', 'google wallet', 'gratipay', 'grav', 'gripfire', 'grunt', 'gulp', 'hacker news', 'hacker news square', 'hips', 'hire a helper', 'hooli', 'hotjar', 'houzz', 'html5', 'hubspot', 'imdb', 'instagram', 'internet explorer', 'ioxhost', 'itunes', 'itunes note', 'jenkins', 'joget', 'joomla', 'js', 'js square', 'jsfiddle', 'keycdn', 'kickstarter', 'kickstarter k', 'korvue', 'laravel', 'lastfm', 'lastfm square', 'leanpub', 'less', 'linechat', 'linkedin', 'linkedin alternate', 'linode', 'linux', 'lyft', 'magento', 'maxcdn', 'medapps', 'medium', 'medium m', 'medrt', 'meetup', 'microsoft', 'mix', 'mixcloud', 'mizuni', 'modx', 'monero', 'napster', 'nintendo switch', 'node', 'node js', 'npm', 'ns8', 'nutritionix', 'odnoklassniki', 'odnoklassniki square', 'opencart', 'openid', 'opera', 'optin monster', 'osi', 'page4', 'pagelines', 'palfed', 'patreon', 'paypal', 'periscope', 'phabricator', 'phoenix framework', 'php', 'pied piper', 'pied piper alternate', 'pied piper pp', 'pinterest', 'pinterest p', 'pinterest square', 'playstation', 'product hunt', 'pushed', 'python', 'qq', 'quinscape', 'quora', 'ravelry', 'react', 'rebel', 'redriver', 'reddit', 'reddit alien', 'reddit square', 'rendact', 'renren', 'replyd', 'resolving', 'rocketchat', 'rockrms', 'safari', 'sass', 'schlix', 'scribd', 'searchengin', 'sellcast', 'sellsy', 'servicestack', 'shirtsinbulk', 'simplybuilt', 'sistrix', 'skyatlas', 'skype', 'slack', 'slack hash', 'slideshare', 'snapchat', 'snapchat ghost', 'snapchat square', 'soundcloud', 'speakap', 'spotify', 'stack exchange', 'stack overflow', 'staylinked', 'steam', 'steam square', 'steam symbol', 'sticker mule', 'strava', 'stripe', 'stripe s', 'studiovinari', 'stumbleupon', 'stumbleupon circle', 'superpowers', 'supple', 'telegram', 'telegram plane', 'tencent weibo', 'themeisle', 'trello', 'tripadvisor', 'tumblr', 'tumblr square', 'twitch', 'twitter', 'twitter square', 'typo3', 'uber', 'uikit', 'uniregistry', 'untappd', 'usb', 'ussunnah', 'vaadin', 'viacoin', 'viadeo', 'viadeo square', 'viber', 'vimeo', 'vimeo square', 'vimeo v', 'vine', 'vk', 'vnv', 'vuejs', 'wechat', 'weibo', 'weixin', 'whatsapp', 'whatsapp square', 'whmcs', 'wikipedia w', 'windows', 'wordpress', 'wordpress simple', 'wpbeginner', 'wpexplorer', 'wpforms', 'xbox', 'xing', 'xing square', 'y combinator', 'yahoo', 'yandex', 'yandex international', 'yelp', 'yoast', 'youtube', 'youtube square'];
var ICONS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_uniq__["a" /* default */])([].concat(ACCESSIBILITY, ARROWS, AUDIO_VIDEO, BUSINESS, CHESS, CODE, COMMUNICATION, COMPUTERS, CURRENCY, DATE_TIME, DESIGN, EDITORS, FILES, GENDERS, HANDS_GESTURES, HEALTH, IMAGES, INTERFACES, LOGISTICS, MAPS, MEDICAL, OBJECTS, PAYMENTS_SHOPPING, SHAPES, SPINNERS, SPORTS, STATUS, USERS_PEOPLE, VEHICLES, WRITING, BRANDS));
var ICON_ALIASES = ['chess rock', 'ordered list', 'unordered list', 'user doctor', 'shield', 'puzzle', 'add circle', 'add square', 'add to calendar', 'add to cart', 'add user', 'add', 'alarm mute', 'alarm', 'ald', 'als', 'announcement', 'area chart', 'area graph', 'arrow down cart', 'asexual', 'asl interpreting', 'asl', 'assistive listening devices', 'attach', 'attention', 'balance', 'bar', 'bathtub', 'battery four', 'battery high', 'battery low', 'battery one', 'battery three', 'battery two', 'battery zero', 'birthday', 'block layout', 'bluetooth alternative', 'broken chain', 'browser', 'call square', 'call', 'cancel', 'cart', 'cc', 'chain', 'chat', 'checked calendar', 'checkmark', 'circle notched', 'close', 'cny', 'cocktail', 'commenting', 'computer', 'configure', 'content', 'deafness', 'delete calendar', 'delete', 'detective', 'discussions', 'doctor', 'dollar', 'dont', 'drivers license', 'dropdown', 'emergency', 'envira gallery', 'erase', 'eur', 'euro', 'eyedropper', 'factory', 'favorite', 'feed', 'female homosexual', 'file text', 'file text outline', 'find', 'first aid', 'fork', 'game', 'gay', 'gbp', 'google plus circle', 'google plus official', 'grab', 'graduation', 'grid layout', 'group', 'h', 'hand victory', 'handicap', 'hard of hearing', 'header', 'help circle', 'help', 'heterosexual', 'hide', 'hotel', 'hourglass four', 'hourglass full', 'hourglass one', 'hourglass three', 'hourglass two', 'idea', 'ils', 'in cart', 'inr', 'intergender', 'intersex', 'jpy', 'krw', 'lab', 'law', 'legal', 'lesbian', 'lightning', 'like', 'line graph', 'linkedin square', 'linkify', 'lira', 'list layout', 'magnify', 'mail forward', 'mail outline', 'mail square', 'mail', 'male homosexual', 'man', 'marker', 'mars alternate', 'mars horizontal', 'mars vertical', 'microsoft edge', 'military', 'ms edge', 'mute', 'new pied piper', 'non binary transgender', 'numbered list', 'options', 'other gender horizontal', 'other gender vertical', 'other gender', 'payment', 'paypal card', 'pencil square', 'photo', 'picture', 'pie chart', 'pie graph', 'pied piper hat', 'pin', 'plus cart', 'point', 'pointing down', 'pointing left', 'pointing right', 'pointing up', 'pound', 'power cord', 'power', 'privacy', 'r circle', 'rain', 'record', 'refresh', 'remove circle', 'remove from calendar', 'remove user', 'remove', 'repeat', 'rmb', 'rouble', 'rub', 'ruble', 'rupee', 's15', 'selected radio', 'send', 'setting', 'settings', 'shekel', 'sheqel', 'shipping', 'shop', 'shuffle', 'shutdown', 'sidebar', 'signing', 'signup', 'sliders', 'soccer', 'sort alphabet ascending', 'sort alphabet descending', 'sort ascending', 'sort content ascending', 'sort content descending', 'sort descending', 'sort numeric ascending', 'sort numeric descending', 'sound', 'spy', 'stripe card', 'student', 'talk', 'target', 'teletype', 'television', 'text cursor', 'text telephone', 'theme', 'thermometer', 'thumb tack', 'time', 'tm', 'toggle down', 'toggle left', 'toggle right', 'toggle up', 'translate', 'travel', 'treatment', 'triangle down', 'triangle left', 'triangle right', 'triangle up', 'try', 'unhide', 'unlinkify', 'unmute', 'usd', 'user cancel', 'user close', 'user delete', 'user x', 'vcard', 'video camera', 'video play', 'volume control phone', 'wait', 'warning circle', 'warning sign', 'warning', 'wi-fi', 'winner', 'wizard', 'woman', 'won', 'wordpress beginner', 'wordpress forms', 'world', 'write square', 'x', 'yen', 'zip', 'zoom in', 'zoom out', 'zoom', 'bitbucket square', 'checkmark box', 'circle thin', 'cloud download', 'cloud upload', 'compose', 'conversation', 'credit card alternative', 'currency', 'dashboard', 'diamond', 'disk', 'exchange', 'external share', 'external square', 'external', 'facebook official', 'food', 'hourglass zero', 'level down', 'level up', 'log out', 'meanpath', 'money', 'move', 'pencil', 'protect', 'radio', 'remove bookmark', 'resize horizontal', 'resize vertical', 'sign in', 'sign out', 'spoon', 'star half empty', 'star half full', 'ticket', 'times rectangle', 'write', 'youtube play'];
var ICONS_AND_ALIASES = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_uniq__["a" /* default */])([].concat(ICONS, ICON_ALIASES)); // Some icon names are not part of icons.css.
// These are only valid as children of other components.
// Their CSS rules are defined by a specific component's CSS.
// We don't want to show name warnings for those usages so we add them as valid names here.

var COMPONENT_CONTEXT_SPECIFIC_ICONS = ['left dropdown' // nested dropdown menu direction icon
];
var ALL_ICONS_IN_ALL_CONTEXTS = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_uniq__["a" /* default */])([].concat(ICONS_AND_ALIASES, COMPONENT_CONTEXT_SPECIFIC_ICONS));

/***/ }),
/* 3276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "someByType", function() { return someByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findByType", function() { return findByType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isNil", function() { return isNil; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_find__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_some__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);



/**
 * Determine if child by type exists in children.
 * @param {Object} children The children prop of a component.
 * @param {string|Function} type An html tag name string or React component.
 * @returns {Boolean}
 */

var someByType = function someByType(children, type) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_some__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_react__["Children"].toArray(children), {
    type: type
  });
};
/**
 * Find child by type.
 * @param {Object} children The children prop of a component.
 * @param {string|Function} type An html tag name string or React component.
 * @returns {undefined|Object}
 */

var findByType = function findByType(children, type) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_find__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2_react__["Children"].toArray(children), {
    type: type
  });
};
/**
 * Tests if children are nil in React and Preact.
 * @param {Object} children The children prop of a component.
 * @returns {Boolean}
 */

var isNil = function isNil(children) {
  return children === null || children === undefined || Array.isArray(children) && children.length === 0;
};

/***/ }),
/* 3277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return useKeyOnly; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return useValueAndKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return useKeyOrValueAndKey; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return useMultipleProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return useTextAlignProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return useVerticalAlignProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return useWidthProp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__numberToWord__ = __webpack_require__(713);

/*
 * There are 3 prop patterns used to build up the className for a component.
 * Each utility here is meant for use in a classnames() argument.
 *
 * There is no util for valueOnly() because it would simply return val.
 * Use the prop value inline instead.
 *   <Label size='big' />
 *   <div class="ui big label"></div>
 */

/**
 * Props where only the prop key is used in the className.
 * @param {*} val A props value
 * @param {string} key A props key
 *
 * @example
 * <Label tag />
 * <div class="ui tag label"></div>
 */

var useKeyOnly = function useKeyOnly(val, key) {
  return val && key;
};
/**
 * Props that require both a key and value to create a className.
 * @param {*} val A props value
 * @param {string} key A props key
 *
 * @example
 * <Label corner='left' />
 * <div class="ui left corner label"></div>
 */

var useValueAndKey = function useValueAndKey(val, key) {
  return val && val !== true && val + " " + key;
};
/**
 * Props whose key will be used in className, or value and key.
 * @param {*} val A props value
 * @param {string} key A props key
 *
 * @example Key Only
 * <Label pointing />
 * <div class="ui pointing label"></div>
 *
 * @example Key and Value
 * <Label pointing='left' />
 * <div class="ui left pointing label"></div>
 */

var useKeyOrValueAndKey = function useKeyOrValueAndKey(val, key) {
  return val && (val === true ? key : val + " " + key);
}; //
// Prop to className exceptions
//

/**
 * The "multiple" prop implements control of visibility and reserved classes for Grid subcomponents.
 *
 * @param {*} val The value of the "multiple" prop
 * @param {*} key A props key
 *
 * @example
 * <Grid.Row only='mobile' />
 * <Grid.Row only='mobile tablet' />
 * <div class="mobile only row"></div>
 * <div class="mobile only tablet only row"></div>
 */

var useMultipleProp = function useMultipleProp(val, key) {
  if (!val || val === true) return null;
  return val.replace('large screen', 'large-screen').replace(/ vertically/g, '-vertically').split(' ').map(function (prop) {
    return prop.replace('-', ' ') + " " + key;
  }).join(' ');
};
/**
 * The "textAlign" prop follows the useValueAndKey except when the value is "justified'.
 * In this case, only the class "justified" is used, ignoring the "aligned" class.
 * @param {*} val The value of the "textAlign" prop
 *
 * @example
 * <Container textAlign='justified' />
 * <div class="ui justified container"></div>
 *
 * @example
 * <Container textAlign='left' />
 * <div class="ui left aligned container"></div>
 */

var useTextAlignProp = function useTextAlignProp(val) {
  return val === 'justified' ? 'justified' : useValueAndKey(val, 'aligned');
};
/**
 * The "verticalAlign" prop follows the useValueAndKey.
 *
 * @param {*} val The value of the "verticalAlign" prop
 *
 * @example
 * <Grid verticalAlign='middle' />
 * <div class="ui middle aligned grid"></div>
 */

var useVerticalAlignProp = function useVerticalAlignProp(val) {
  return useValueAndKey(val, 'aligned');
};
/**
 * Create "X", "X wide" and "equal width" classNames.
 * "X" is a numberToWord value and "wide" is configurable.
 * @param {*} val The prop value
 * @param {string} [widthClass=''] The class
 * @param {boolean} [canEqual=false] Flag that indicates possibility of "equal" value
 *
 * @example
 * <Grid columns='equal' />
 * <div class="ui equal width grid"></div>
 *
 * <Form widths='equal' />
 * <div class="ui equal width form"></div>
 *
 * <FieldGroup widths='equal' />
 * <div class="equal width fields"></div>
 *
 * @example
 * <Grid columns={4} />
 * <div class="ui four column grid"></div>
 */

var useWidthProp = function useWidthProp(val, widthClass, canEqual) {
  if (widthClass === void 0) {
    widthClass = '';
  }

  if (canEqual === void 0) {
    canEqual = false;
  }

  if (canEqual && val === 'equal') {
    return 'equal width';
  }

  var valType = typeof val;

  if ((valType === 'string' || valType === 'number') && widthClass) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__numberToWord__["b" /* numberToWord */])(val) + " " + widthClass;
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__numberToWord__["b" /* numberToWord */])(val);
};

/***/ }),
/* 3278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__itemFactories__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rangeFactories__ = __webpack_require__(3281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paginationUtils__ = __webpack_require__(3280);



/**
 * @param {object} rawOptions
 * @param {number|string} rawOptions.activePage
 * @param {number|string} rawOptions.boundaryRange Number of always visible pages at the beginning and end.
 * @param {boolean} rawOptions.hideEllipsis Marks if ellipsis should be hidden.
 * @param {number|string} rawOptions.siblingRange Number of always visible pages before and after the current one.
 * @param {number|string} rawOptions.totalPages Total number of pages.
 */

var createPaginationItems = function createPaginationItems(rawOptions) {
  var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__paginationUtils__["a" /* typifyOptions */])(rawOptions);
  var activePage = options.activePage,
      totalPages = options.totalPages;
  var pageFactory = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__itemFactories__["a" /* createPageFactory */])(activePage);
  var innerRange = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__paginationUtils__["b" /* isSimplePagination */])(options) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__rangeFactories__["a" /* createSimpleRange */])(1, totalPages, pageFactory) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__rangeFactories__["b" /* createComplexRange */])(options, pageFactory);
  return [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__itemFactories__["b" /* createFirstPage */])(), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__itemFactories__["c" /* createPrevItem */])(activePage)].concat(innerRange, [__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__itemFactories__["d" /* createNextItem */])(activePage, totalPages), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__itemFactories__["e" /* createLastItem */])(totalPages)]);
};

/* harmony default export */ __webpack_exports__["a"] = (createPaginationItems);

/***/ }),
/* 3279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createPaginationItems__ = __webpack_require__(3278);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createPaginationItems__["a"]; });



/***/ }),
/* 3280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isSimplePagination; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return typifyOptions; });
/**
 * Checks the possibility of using simple range generation, if number of generated pages is equal
 * or greater than total pages to show.
 *
 * @param {object} options
 * @param {number} options.boundaryRange Number of always visible pages at the beginning and end.
 * @param {number} options.siblingRange Number of always visible pages before and after the current one.
 * @param {number} options.totalPages Total number of pages.
 * @return {boolean}
 */
var isSimplePagination = function isSimplePagination(_ref) {
  var boundaryRange = _ref.boundaryRange,
      hideEllipsis = _ref.hideEllipsis,
      siblingRange = _ref.siblingRange,
      totalPages = _ref.totalPages;
  var boundaryRangeSize = 2 * boundaryRange;
  var ellipsisSize = hideEllipsis ? 0 : 2;
  var siblingRangeSize = 2 * siblingRange;
  return 1 + ellipsisSize + siblingRangeSize + boundaryRangeSize >= totalPages;
};
var typifyOptions = function typifyOptions(_ref2) {
  var activePage = _ref2.activePage,
      boundaryRange = _ref2.boundaryRange,
      hideEllipsis = _ref2.hideEllipsis,
      siblingRange = _ref2.siblingRange,
      totalPages = _ref2.totalPages;
  return {
    activePage: +activePage,
    boundaryRange: +boundaryRange,
    hideEllipsis: !!hideEllipsis,
    siblingRange: +siblingRange,
    totalPages: +totalPages
  };
};

/***/ }),
/* 3281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createSimpleRange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createComplexRange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_range__ = __webpack_require__(3474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__suffixFactories__ = __webpack_require__(3282);



var createSimpleRange = function createSimpleRange(start, end, pageFactory) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_map__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_range__["a" /* default */])(start, end + 1), pageFactory);
};
var createComplexRange = function createComplexRange(options, pageFactory) {
  var activePage = options.activePage,
      boundaryRange = options.boundaryRange,
      hideEllipsis = options.hideEllipsis,
      siblingRange = options.siblingRange,
      totalPages = options.totalPages;
  var ellipsisSize = hideEllipsis ? 0 : 1;
  var firstGroupEnd = boundaryRange;
  var firstGroup = createSimpleRange(1, firstGroupEnd, pageFactory);
  var lastGroupStart = totalPages + 1 - boundaryRange;
  var lastGroup = createSimpleRange(lastGroupStart, totalPages, pageFactory);
  var innerGroupStart = Math.min(Math.max(activePage - siblingRange, firstGroupEnd + ellipsisSize + 1), lastGroupStart - ellipsisSize - 2 * siblingRange - 1);
  var innerGroupEnd = innerGroupStart + 2 * siblingRange;
  var innerGroup = createSimpleRange(innerGroupStart, innerGroupEnd, pageFactory);
  return [].concat(firstGroup, [!hideEllipsis && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__suffixFactories__["a" /* createInnerPrefix */])(firstGroupEnd, innerGroupStart, pageFactory)], innerGroup, [!hideEllipsis && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__suffixFactories__["b" /* createInnerSuffix */])(innerGroupEnd, lastGroupStart, pageFactory)], lastGroup).filter(Boolean);
};

/***/ }),
/* 3282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createInnerPrefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createInnerSuffix; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__itemFactories__ = __webpack_require__(1483);

var createInnerPrefix = function createInnerPrefix(firstGroupEnd, innerGroupStart, pageFactory) {
  var prefixPage = innerGroupStart - 1;
  var showEllipsis = prefixPage !== firstGroupEnd + 1;
  var prefixFactory = showEllipsis ? __WEBPACK_IMPORTED_MODULE_0__itemFactories__["f" /* createEllipsisItem */] : pageFactory;
  return prefixFactory(prefixPage);
};
var createInnerSuffix = function createInnerSuffix(innerGroupEnd, lastGroupStart, pageFactory) {
  var suffixPage = innerGroupEnd + 1;
  var showEllipsis = suffixPage !== lastGroupStart - 1;
  var suffixFactory = showEllipsis ? __WEBPACK_IMPORTED_MODULE_0__itemFactories__["f" /* createEllipsisItem */] : pageFactory;
  return suffixFactory(suffixPage);
};

/***/ }),
/* 3283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export domNode */
/* unused harmony export suggest */
/* unused harmony export disallow */
/* unused harmony export every */
/* unused harmony export givenProps */
/* unused harmony export demand */
/* unused harmony export multipleProp */
/* unused harmony export contentShorthand */
/* unused harmony export itemShorthand */
/* unused harmony export collectionShorthand */
/* unused harmony export deprecate */
/* unused harmony export refObject */
/* unused harmony export ref */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_difference__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_trim__ = __webpack_require__(3486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isObject__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_pick__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_keys__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_isPlainObject__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_es_isNil__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_es_min__ = __webpack_require__(3470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_es_sum__ = __webpack_require__(3482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_es_sortBy__ = __webpack_require__(3478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_es_take__ = __webpack_require__(3483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_es_memoize__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__leven__ = __webpack_require__(1485);
















var typeOf = function typeOf() {
  var _Object$prototype$toS;

  return (_Object$prototype$toS = Object.prototype.toString).call.apply(_Object$prototype$toS, arguments);
};
/**
 * Ensure a prop is a valid DOM node.
 */


var domNode = function domNode(props, propName) {
  // skip if prop is undefined
  if (props[propName] === undefined) return; // short circle for SSR env

  if (typeof Element === 'undefined') return; // skip if prop is valid

  if (props[propName] instanceof Element) return;
  return new Error("Invalid prop \"" + propName + "\" supplied, expected a DOM node.");
};
/**
 * Similar to PropTypes.oneOf but shows closest matches.
 * Word order is ignored allowing `left chevron` to match `chevron left`.
 * Useful for very large lists of options (e.g. Icon name, Flag name, etc.)
 * @param {string[]} suggestions An array of allowed values.
 */

var suggest = function suggest(suggestions) {
  if (!Array.isArray(suggestions)) {
    throw new Error('Invalid argument supplied to suggest, expected an instance of array.');
  }
  /* eslint-disable max-nested-callbacks */


  var findBestSuggestions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lodash_es_memoize__["a" /* default */])(function (str) {
    var propValueWords = str.split(' ');
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash_es_take__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash_es_sortBy__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash_es_map__["a" /* default */])(suggestions, function (suggestion) {
      var suggestionWords = suggestion.split(' ');

      var propValueScore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash_es_sum__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash_es_map__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash_es_map__["a" /* default */])(propValueWords, function (x) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash_es_map__["a" /* default */])(suggestionWords, function (y) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__leven__["a" /* default */])(x, y);
        });
      }), __WEBPACK_IMPORTED_MODULE_7_lodash_es_min__["a" /* default */]));

      var suggestionScore = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash_es_sum__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash_es_map__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash_es_map__["a" /* default */])(suggestionWords, function (x) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash_es_map__["a" /* default */])(propValueWords, function (y) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__leven__["a" /* default */])(x, y);
        });
      }), __WEBPACK_IMPORTED_MODULE_7_lodash_es_min__["a" /* default */]));

      return {
        suggestion: suggestion,
        score: propValueScore + suggestionScore
      };
    }), ['score', 'suggestion']), 3);
  });
  /* eslint-enable max-nested-callbacks */
  // Convert the suggestions list into a hash map for O(n) lookup times. Ensure
  // the words in each key are sorted alphabetically so that we have a consistent
  // way of looking up a value in the map, i.e. we can sort the words in the
  // incoming propValue and look that up without having to check all permutations.


  var suggestionsLookup = suggestions.reduce(function (acc, key) {
    acc[key.split(' ').sort().join(' ')] = true;
    return acc;
  }, {});
  return function (props, propName, componentName) {
    var propValue = props[propName]; // skip if prop is undefined or is included in the suggestions

    if (!propValue || suggestionsLookup[propValue]) return; // check if the words were correct but ordered differently.
    // Since we're matching for classNames we need to allow any word order
    // to pass validation, e.g. `left chevron` vs `chevron left`.

    var propValueSorted = propValue.split(' ').sort().join(' ');
    if (suggestionsLookup[propValueSorted]) return; // find best suggestions

    var bestMatches = findBestSuggestions(propValue); // skip if a match scored 0

    if (bestMatches.some(function (x) {
      return x.score === 0;
    })) return;
    return new Error(["Invalid prop `" + propName + "` of value `" + propValue + "` supplied to `" + componentName + "`.", "\n\nInstead of `" + propValue + "`, did you mean:", bestMatches.map(function (x) {
      return "\n  - " + x.suggestion;
    }).join(''), '\n'].join(''));
  };
};
/**
 * Disallow other props from being defined with this prop.
 * @param {string[]} disallowedProps An array of props that cannot be used with this prop.
 */

var disallow = function disallow(disallowedProps) {
  return function (props, propName, componentName) {
    if (!Array.isArray(disallowedProps)) {
      throw new Error(['Invalid argument supplied to disallow, expected an instance of array.', " See `" + propName + "` prop in `" + componentName + "`."].join(''));
    } // skip if prop is undefined


    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isNil__["a" /* default */])(props[propName]) || props[propName] === false) {
      return;
    } // find disallowed props with values


    var disallowed = disallowedProps.reduce(function (acc, disallowedProp) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isNil__["a" /* default */])(props[disallowedProp]) && props[disallowedProp] !== false) {
        return [].concat(acc, [disallowedProp]);
      }

      return acc;
    }, []);

    if (disallowed.length > 0) {
      return new Error(["Prop `" + propName + "` in `" + componentName + "` conflicts with props: `" + disallowed.join('`, `') + "`.", 'They cannot be defined together, choose one or the other.'].join(' '));
    }
  };
};
/**
 * Ensure a prop adherers to multiple prop type validators.
 * @param {function[]} validators An array of propType functions.
 */

var every = function every(validators) {
  return function (props, propName, componentName) {
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }

    if (!Array.isArray(validators)) {
      throw new Error(['Invalid argument supplied to every, expected an instance of array.', "See `" + propName + "` prop in `" + componentName + "`."].join(' '));
    }

    var errors = [];
    validators.forEach(function (validator) {
      if (typeof validator !== 'function') {
        throw new Error("every() argument \"validators\" should contain functions, found: " + typeOf(validator) + ".");
      }

      var error = validator.apply(void 0, [props, propName, componentName].concat(rest));

      if (error) {
        errors.push(error);
      }
    }); // we can only return one error at a time

    return errors[0];
  };
};
/**
 * Ensure a validator passes only when a component has a given propsShape.
 * @param {object} propsShape An object describing the prop shape.
 * @param {function} validator A propType function.
 */

var givenProps = function givenProps(propsShape, validator) {
  return function (props, propName, componentName) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
      rest[_key2 - 3] = arguments[_key2];
    }

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isPlainObject__["a" /* default */])(propsShape)) {
      throw new Error(['Invalid argument supplied to givenProps, expected an object.', "See `" + propName + "` prop in `" + componentName + "`."].join(' '));
    }

    if (typeof validator !== 'function') {
      throw new Error(['Invalid argument supplied to givenProps, expected a function.', "See `" + propName + "` prop in `" + componentName + "`."].join(' '));
    }

    var shouldValidate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_keys__["a" /* default */])(propsShape).every(function (key) {
      var val = propsShape[key]; // require propShape validators to pass or prop values to match

      return typeof val === 'function' ? !val.apply(void 0, [props, key, componentName].concat(rest)) : val === props[propName];
    });

    if (!shouldValidate) return;
    var error = validator.apply(void 0, [props, propName, componentName].concat(rest));

    if (error) {
      // poor mans shallow pretty print, prevents JSON circular reference errors
      var prettyProps = "{ " + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_keys__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_pick__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_keys__["a" /* default */])(propsShape), props)).map(function (key) {
        var val = props[key];
        var renderedValue = val;
        if (typeof val === 'string') renderedValue = "\"" + val + "\"";else if (Array.isArray(val)) renderedValue = "[" + val.join(', ') + "]";else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isObject__["a" /* default */])(val)) renderedValue = '{...}';
        return key + ": " + renderedValue;
      }).join(', ') + " }";
      error.message = "Given props " + prettyProps + ": " + error.message;
      return error;
    }
  };
};
/**
 * Define prop dependencies by requiring other props.
 * @param {string[]} requiredProps An array of required prop names.
 */

var demand = function demand(requiredProps) {
  return function (props, propName, componentName) {
    if (!Array.isArray(requiredProps)) {
      throw new Error(['Invalid `requiredProps` argument supplied to require, expected an instance of array.', " See `" + propName + "` prop in `" + componentName + "`."].join(''));
    } // skip if prop is undefined


    if (props[propName] === undefined) return;
    var missingRequired = requiredProps.filter(function (requiredProp) {
      return props[requiredProp] === undefined;
    });

    if (missingRequired.length > 0) {
      return new Error("`" + propName + "` prop in `" + componentName + "` requires props: `" + missingRequired.join('`, `') + "`.");
    }
  };
};
/**
 * Ensure an multiple prop contains a string with only possible values.
 * @param {string[]} possible An array of possible values to prop.
 */

var multipleProp = function multipleProp(possible) {
  return function (props, propName, componentName) {
    if (!Array.isArray(possible)) {
      throw new Error(['Invalid argument supplied to some, expected an instance of array.', "See `" + propName + "` prop in `" + componentName + "`."].join(' '));
    }

    var propValue = props[propName]; // skip if prop is undefined

    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isNil__["a" /* default */])(propValue) || propValue === false) return;
    var values = propValue.replace('large screen', 'large-screen').replace(/ vertically/g, '-vertically').split(' ').map(function (val) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_trim__["a" /* default */])(val).replace('-', ' ');
    });

    var invalid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_difference__["a" /* default */])(values, possible); // fail only if there are invalid values


    if (invalid.length > 0) {
      return new Error("`" + propName + "` prop in `" + componentName + "` has invalid values: `" + invalid.join('`, `') + "`.");
    }
  };
};
/**
 * Ensure a component can render as a node passed as a prop value in place of children.
 */

var contentShorthand = function contentShorthand() {
  return every([disallow(['children']), __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.node]).apply(void 0, arguments);
};
/**
 * Item shorthand is a description of a component that can be a literal,
 * a props object, or an element.
 */

var itemShorthand = function itemShorthand() {
  return every([disallow(['children']), __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.object, __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.node, __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.object]))])]).apply(void 0, arguments);
};
/**
 * Collection shorthand ensures a prop is an array of item shorthand.
 */

var collectionShorthand = function collectionShorthand() {
  return every([disallow(['children']), __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.arrayOf(itemShorthand)]).apply(void 0, arguments);
};
/**
 * Show a deprecated warning for component props with a help message and optional validator.
 * @param {string} help A help message to display with the deprecation warning.
 * @param {function} [validator] A propType function.
 */

var deprecate = function deprecate(help, validator) {
  return function (props, propName, componentName) {
    if (typeof help !== 'string') {
      throw new Error(['Invalid `help` argument supplied to deprecate, expected a string.', "See `" + propName + "` prop in `" + componentName + "`."].join(' '));
    } // skip if prop is undefined


    if (props[propName] === undefined) return; // deprecation error and help

    var error = new Error("The `" + propName + "` prop in `" + componentName + "` is deprecated.");
    if (help) error.message += " " + help; // add optional validation error message

    if (validator) {
      if (typeof validator === 'function') {
        for (var _len3 = arguments.length, args = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
          args[_key3 - 3] = arguments[_key3];
        }

        var validationError = validator.apply(void 0, [props, propName, componentName].concat(args));

        if (validationError) {
          error.message = error.message + " " + validationError.message;
        }
      } else {
        throw new Error(['Invalid argument supplied to deprecate, expected a function.', "See `" + propName + "` prop in `" + componentName + "`."].join(' '));
      }
    }

    return error;
  };
};
/** A checker that matches the React.RefObject type. */

var refObject = __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.shape({
  current: __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.object
});
/** A checker that matches the React.Ref type. */

var ref = __WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_13_prop_types___default.a.func, refObject]);

/***/ }),
/* 3284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_inRange__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_first__ = __webpack_require__(3458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_some__ = __webpack_require__(756);






/**
 * Determines if a click's coordinates are within the bounds of a node.
 *
 * @see https://github.com/Semantic-Org/Semantic-UI-React/pull/2384
 *
 * @param {object} node - A DOM node.
 * @param {object} e - A SyntheticEvent or DOM Event.
 * @returns {boolean}
 */
var doesNodeContainClick = function doesNodeContainClick(node, e) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_some__["a" /* default */])([e, node], __WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])) return false; // if there is an e.target and it is in the document, use a simple node.contains() check

  if (e.target) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(e.target, 'setAttribute', 'data-suir-click-target', true);

    if (document.querySelector('[data-suir-click-target=true]')) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(e.target, 'removeAttribute', 'data-suir-click-target');

      return node.contains(e.target);
    }
  } // Below logic handles cases where the e.target is no longer in the document.
  // The result of the click likely has removed the e.target node.
  // Instead of node.contains(), we'll identify the click by X/Y position.
  // return early if the event properties aren't available
  // prevent measuring the node and repainting if we don't need to


  var clientX = e.clientX,
      clientY = e.clientY;
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_some__["a" /* default */])([clientX, clientY], __WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])) return false; // false if the node is not visible

  var clientRects = node.getClientRects(); // Heads Up!
  // getClientRects returns a DOMRectList, not an array nor a plain object
  // We explicitly avoid _.isEmpty and check .length to cover all possible shapes

  if (!node.offsetWidth || !node.offsetHeight || !clientRects || !clientRects.length) return false; // false if the node doesn't have a valid bounding rect

  var _first2 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_first__["a" /* default */])(clientRects),
      top = _first2.top,
      bottom = _first2.bottom,
      left = _first2.left,
      right = _first2.right;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_some__["a" /* default */])([top, bottom, left, right], __WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])) return false; // we add a small decimal to the upper bound just to make it inclusive
  // don't add an whole pixel (1) as the event/node values may be decimal sensitive

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_inRange__["a" /* default */])(clientY, top, bottom + 0.001) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_inRange__["a" /* default */])(clientX, left, right + 0.001);
};

/* harmony default export */ __webpack_exports__["a"] = (doesNodeContainClick);

/***/ }),
/* 3285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__semantic_ui_react_event_stack__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__semantic_ui_react_event_stack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__semantic_ui_react_event_stack__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__semantic_ui_react_event_stack__["instance"]);

/***/ }),
/* 3286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = createShorthand;
/* harmony export (immutable) */ __webpack_exports__["a"] = createShorthandFactory;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createHTMLDivision; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createHTMLIframe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createHTMLImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return createHTMLInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return createHTMLLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return createHTMLParagraph; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_uniq__ = __webpack_require__(1588);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isArray__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_isFunction__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_isNumber__ = __webpack_require__(3465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_es_isString__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_es_isBoolean__ = __webpack_require__(3463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_es_isNil__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react__);











var DEPRECATED_CALLS = {}; // ============================================================
// Factories
// ============================================================

/**
 * A more robust React.createElement. It can create elements from primitive values.
 *
 * @param {function|string} Component A ReactClass or string
 * @param {function} mapValueToProps A function that maps a primitive value to the Component props
 * @param {string|object|function} val The value to create a ReactElement from
 * @param {Object} [options={}]
 * @param {object} [options.defaultProps={}] Default props object
 * @param {object|function} [options.overrideProps={}] Override props object or function (called with regular props)
 * @param {boolean} [options.autoGenerateKey=true] Whether or not automatic key generation is allowed
 * @returns {object|null}
 */

function createShorthand(Component, mapValueToProps, val, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof Component !== 'function' && typeof Component !== 'string') {
    throw new Error('createShorthand() Component must be a string or function.');
  } // short circuit noop values


  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash_es_isNil__["a" /* default */])(val) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash_es_isBoolean__["a" /* default */])(val)) {
    return null;
  }

  var valIsString = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isString__["a" /* default */])(val);

  var valIsNumber = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isNumber__["a" /* default */])(val);

  var valIsFunction = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_isFunction__["a" /* default */])(val);

  var valIsReactElement = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react__["isValidElement"](val);

  var valIsPropsObject = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isPlainObject__["a" /* default */])(val);

  var valIsPrimitiveValue = valIsString || valIsNumber || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isArray__["a" /* default */])(val); // unhandled type return null

  /* eslint-disable no-console */


  if (!valIsFunction && !valIsReactElement && !valIsPropsObject && !valIsPrimitiveValue) {
    if (false) {
      console.error(['Shorthand value must be a string|number|array|object|ReactElement|function.', ' Use null|undefined|boolean for none', " Received " + typeof val + "."].join(''));
    }

    return null;
  }
  /* eslint-enable no-console */
  // ----------------------------------------
  // Build up props
  // ----------------------------------------


  var _options = options,
      _options$defaultProps = _options.defaultProps,
      defaultProps = _options$defaultProps === void 0 ? {} : _options$defaultProps; // User's props

  var usersProps = valIsReactElement && val.props || valIsPropsObject && val || valIsPrimitiveValue && mapValueToProps(val); // Override props

  var _options2 = options,
      _options2$overridePro = _options2.overrideProps,
      overrideProps = _options2$overridePro === void 0 ? {} : _options2$overridePro;
  overrideProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_isFunction__["a" /* default */])(overrideProps) ? overrideProps(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, defaultProps, usersProps)) : overrideProps; // Merge props

  /* eslint-disable react/prop-types */

  var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, defaultProps, usersProps, overrideProps); // Merge className


  if (defaultProps.className || overrideProps.className || usersProps.className) {
    var mergedClassesNames = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_clsx__["a" /* default */])(defaultProps.className, overrideProps.className, usersProps.className);
    props.className = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_uniq__["a" /* default */])(mergedClassesNames.split(' ')).join(' ');
  } // Merge style


  if (defaultProps.style || overrideProps.style || usersProps.style) {
    props.style = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, defaultProps.style, usersProps.style, overrideProps.style);
  } // ----------------------------------------
  // Get key
  // ----------------------------------------
  // Use key, childKey, or generate key


  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash_es_isNil__["a" /* default */])(props.key)) {
    var childKey = props.childKey;
    var _options3 = options,
        _options3$autoGenerat = _options3.autoGenerateKey,
        autoGenerateKey = _options3$autoGenerat === void 0 ? true : _options3$autoGenerat;

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash_es_isNil__["a" /* default */])(childKey)) {
      // apply and consume the childKey
      props.key = typeof childKey === 'function' ? childKey(props) : childKey;
      delete props.childKey;
    } else if (autoGenerateKey && (valIsString || valIsNumber)) {
      // use string/number shorthand values as the key
      props.key = val;
    }
  } // ----------------------------------------
  // Create Element
  // ----------------------------------------
  // Clone ReactElements


  if (valIsReactElement) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react__["cloneElement"](val, props);
  }

  if (typeof props.children === 'function') {
    return props.children(Component, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      children: undefined
    }));
  } // Create ReactElements from built up props


  if (valIsPrimitiveValue || valIsPropsObject) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_10_react__["createElement"](Component, props);
  } // Call functions with args similar to createElement()
  // TODO: V3 remove the implementation


  if (valIsFunction) {
    if (false) {
      if (!DEPRECATED_CALLS[Component]) {
        DEPRECATED_CALLS[Component] = true; // eslint-disable-next-line no-console

        console.warn("Warning: There is a deprecated shorthand function usage for \"" + Component + "\". It is deprecated and will be removed in v3 release. Please follow our upgrade guide: https://github.com/Semantic-Org/Semantic-UI-React/pull/4029");
      }
    }

    return val(Component, props, props.children);
  }
  /* eslint-enable react/prop-types */

} // ============================================================
// Factory Creators
// ============================================================

/**
 * Creates a `createShorthand` function that is waiting for a value and options.
 *
 * @param {function|string} Component A ReactClass or string
 * @param {function} mapValueToProps A function that maps a primitive value to the Component props
 * @returns {function} A shorthand factory function waiting for `val` and `defaultProps`.
 */

function createShorthandFactory(Component, mapValueToProps) {
  if (typeof Component !== 'function' && typeof Component !== 'string') {
    throw new Error('createShorthandFactory() Component must be a string or function.');
  }

  return function (val, options) {
    return createShorthand(Component, mapValueToProps, val, options);
  };
} // ============================================================
// HTML Factories
// ============================================================

var createHTMLDivision = /* #__PURE__ */createShorthandFactory('div', function (val) {
  return {
    children: val
  };
});
var createHTMLIframe = /* #__PURE__ */createShorthandFactory('iframe', function (src) {
  return {
    src: src
  };
});
var createHTMLImage = /* #__PURE__ */createShorthandFactory('img', function (val) {
  return {
    src: val
  };
});
var createHTMLInput = /* #__PURE__ */createShorthandFactory('input', function (val) {
  return {
    type: val
  };
});
var createHTMLLabel = /* #__PURE__ */createShorthandFactory('label', function (val) {
  return {
    children: val
  };
});
var createHTMLParagraph = /* #__PURE__ */createShorthandFactory('p', function (val) {
  return {
    children: val
  };
});

/***/ }),
/* 3287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Returns a createElement() type based on the props of the Component.
 * Useful for calculating what type a component should render as.
 *
 * @param {function} Component A function or ReactClass.
 * @param {object} props A ReactElement props object
 * @param {function} [getDefault] A function that returns a default element type.
 * @returns {string|function} A ReactElement type
 */
function getElementType(Component, props, getDefault) {
  var _Component$defaultPro = Component.defaultProps,
      defaultProps = _Component$defaultPro === void 0 ? {} : _Component$defaultPro; // ----------------------------------------
  // user defined "as" element type

  if (props.as && props.as !== defaultProps.as) return props.as; // ----------------------------------------
  // computed default element type

  if (getDefault) {
    var computedDefault = getDefault();
    if (computedDefault) return computedDefault;
  } // ----------------------------------------
  // infer anchor links


  if (props.href) return 'a'; // ----------------------------------------
  // use defaultProp or 'div'

  return defaultProps.as || 'div';
}

/* harmony default export */ __webpack_exports__["a"] = (getElementType);

/***/ }),
/* 3288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Returns an object consisting of props beyond the scope of the Component.
 * Useful for getting and spreading unknown props from the user.
 * @param {function} Component A function or ReactClass.
 * @param {object} props A ReactElement props object
 * @returns {{}} A shallow copy of the prop object
 */
var getUnhandledProps = function getUnhandledProps(Component, props) {
  // Note that `handledProps` are generated automatically during build with `babel-plugin-transform-react-handled-props`
  var _Component$handledPro = Component.handledProps,
      handledProps = _Component$handledPro === void 0 ? [] : _Component$handledPro;
  return Object.keys(props).reduce(function (acc, prop) {
    if (prop === 'childKey') return acc;
    if (handledProps.indexOf(prop) === -1) acc[prop] = props[prop];
    return acc;
  }, {});
};

/* harmony default export */ __webpack_exports__["a"] = (getUnhandledProps);

/***/ }),
/* 3289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export computeClassNames */
/* unused harmony export computeClassNamesDifference */
/* unused harmony export handleClassNamesChange */
/* unused harmony export NodeRegistry */
/* harmony export (immutable) */ __webpack_exports__["a"] = useClassNamesOnNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fluentui_react_component_ref__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__useIsomorphicLayoutEffect__ = __webpack_require__(3290);



var CLASS_NAME_DELITIMITER = /\s+/;
/**
 * Accepts a set of ref objects that contain classnames as a string and returns an array of unique
 * classNames.
 *
 * @param {Set<React.RefObject>|undefined} classNameRefs
 * @returns String[]
 */

function computeClassNames(classNameRefs) {
  var classNames = [];

  if (classNameRefs) {
    classNameRefs.forEach(function (classNameRef) {
      if (typeof classNameRef.current === 'string') {
        var classNamesForRef = classNameRef.current.split(CLASS_NAME_DELITIMITER);
        classNamesForRef.forEach(function (className) {
          classNames.push(className);
        });
      }
    });
    return classNames.filter(function (className, i, array) {
      return className.length > 0 && array.indexOf(className) === i;
    });
  }

  return [];
}
/**
 * Computes classnames that should be removed and added to a node based on input differences.
 *
 * @param {String[]} prevClassNames
 * @param {String[]} currentClassNames
 */

function computeClassNamesDifference(prevClassNames, currentClassNames) {
  return [currentClassNames.filter(function (className) {
    return prevClassNames.indexOf(className) === -1;
  }), prevClassNames.filter(function (className) {
    return currentClassNames.indexOf(className) === -1;
  })];
}
var prevClassNames = new Map();
/**
 * @param {HTMLElement} node
 * @param {Set<React.RefObject>|undefined} classNameRefs
 */

var handleClassNamesChange = function handleClassNamesChange(node, classNameRefs) {
  var currentClassNames = computeClassNames(classNameRefs);

  var _computeClassNamesDif = computeClassNamesDifference(prevClassNames.get(node) || [], currentClassNames),
      forAdd = _computeClassNamesDif[0],
      forRemoval = _computeClassNamesDif[1];

  if (node) {
    forAdd.forEach(function (className) {
      return node.classList.add(className);
    });
    forRemoval.forEach(function (className) {
      return node.classList.remove(className);
    });
  }

  prevClassNames.set(node, currentClassNames);
};
var NodeRegistry = function NodeRegistry() {
  var _this = this;

  this.add = function (node, classNameRef) {
    if (_this.nodes.has(node)) {
      var _set = _this.nodes.get(node);

      _set.add(classNameRef);

      return;
    } // IE11 does not support constructor params


    var set = new Set();
    set.add(classNameRef);

    _this.nodes.set(node, set);
  };

  this.del = function (node, classNameRef) {
    if (!_this.nodes.has(node)) {
      return;
    }

    var set = _this.nodes.get(node);

    if (set.size === 1) {
      _this.nodes.delete(node);

      return;
    }

    set.delete(classNameRef);
  };

  this.emit = function (node, callback) {
    callback(node, _this.nodes.get(node));
  };

  this.nodes = new Map();
};
var nodeRegistry = new NodeRegistry();
/**
 * A React hooks that allows to manage classNames on a DOM node in declarative manner. Accepts
 * a HTML element or React ref objects with it.
 *
 * @param {HTMLElement|React.RefObject} node
 * @param {String} className
 */

function useClassNamesOnNode(node, className) {
  var classNameRef = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useRef();
  var isMounted = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useRef(false);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__useIsomorphicLayoutEffect__["a" /* default */])(function () {
    classNameRef.current = className;

    if (isMounted.current) {
      var element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__fluentui_react_component_ref__["b" /* isRefObject */])(node) ? node.current : node;
      nodeRegistry.emit(element, handleClassNamesChange);
    }

    isMounted.current = true;
  }, [className]);
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__useIsomorphicLayoutEffect__["a" /* default */])(function () {
    var element = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__fluentui_react_component_ref__["b" /* isRefObject */])(node) ? node.current : node;
    nodeRegistry.add(element, classNameRef);
    nodeRegistry.emit(element, handleClassNamesChange);
    return function () {
      nodeRegistry.del(element, classNameRef);
      nodeRegistry.emit(element, handleClassNamesChange);
    };
  }, [node]);
}

/***/ }),
/* 3290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isBrowser__ = __webpack_require__(1484);

 // useLayoutEffect() produces a warning with SSR rendering
// https://medium.com/@alexandereardon/uselayouteffect-and-ssr-192986cdcf7a

var useIsomorphicLayoutEffect = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isBrowser__["a" /* default */])() && "production" !== 'test' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.useLayoutEffect : __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect;
/* harmony default export */ __webpack_exports__["a"] = (useIsomorphicLayoutEffect);

/***/ }),
/* 3291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return htmlInputAttrs; });
/* unused harmony export htmlInputEvents */
/* unused harmony export htmlInputProps */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return htmlImageProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return partitionHTMLProps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_includes__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_forEach__ = __webpack_require__(359);


var htmlInputAttrs = [// REACT
'selected', 'defaultValue', 'defaultChecked', // LIMITED HTML PROPS
'accept', 'autoCapitalize', 'autoComplete', 'autoCorrect', 'autoFocus', 'checked', 'disabled', 'enterKeyHint', 'form', 'id', 'inputMode', 'lang', 'list', 'max', 'maxLength', 'min', 'minLength', 'multiple', 'name', 'pattern', 'placeholder', 'readOnly', 'required', 'step', 'title', 'type', 'value'];
var htmlInputEvents = [// EVENTS
// keyboard
'onKeyDown', 'onKeyPress', 'onKeyUp', // focus
'onFocus', 'onBlur', // form
'onChange', 'onInput', // mouse
'onClick', 'onContextMenu', 'onDrag', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop', 'onMouseDown', 'onMouseEnter', 'onMouseLeave', 'onMouseMove', 'onMouseOut', 'onMouseOver', 'onMouseUp', // selection
'onSelect', // touch
'onTouchCancel', 'onTouchEnd', 'onTouchMove', 'onTouchStart'];
var htmlInputProps = [].concat(htmlInputAttrs, htmlInputEvents);
var htmlImageProps = ['alt', 'height', 'src', 'srcSet', 'width', 'loading'];
/**
 * Returns an array of objects consisting of: props of html input element and rest.
 * @param {object} props A ReactElement props object
 * @param {Object} [options={}]
 * @param {Array} [options.htmlProps] An array of html input props
 * @param {boolean} [options.includeAria] Includes all input props that starts with "aria-"
 * @returns {[{}, {}]} An array of objects
 */

var partitionHTMLProps = function partitionHTMLProps(props, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$htmlProps = _options.htmlProps,
      htmlProps = _options$htmlProps === void 0 ? htmlInputProps : _options$htmlProps,
      _options$includeAria = _options.includeAria,
      includeAria = _options$includeAria === void 0 ? true : _options$includeAria;
  var inputProps = {};
  var rest = {};

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_forEach__["a" /* default */])(props, function (val, prop) {
    var possibleAria = includeAria && (/^aria-.*$/.test(prop) || prop === 'role');
    var target = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_includes__["a" /* default */])(htmlProps, prop) || possibleAria ? inputProps : rest;
    target[prop] = val;
  });

  return [inputProps, rest];
};

/***/ }),
/* 3292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Normalizes the offset value.
 * @param {number|array} value The value to normalize.
 * @returns {number}
 */
/* harmony default export */ __webpack_exports__["a"] = (function (value) {
  return typeof value === 'number' || typeof value === 'string' ? [value, value] : value;
});

/***/ }),
/* 3293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Normalizes the duration of a transition.
 * @param {number|object} duration The value to normalize.
 * @param {'hide'|'show'} type The type of transition.
 * @returns {number}
 */
/* harmony default export */ __webpack_exports__["a"] = (function (duration, type) {
  return typeof duration === 'number' || typeof duration === 'string' ? duration : duration[type];
});

/***/ }),
/* 3294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqual__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_has__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_transform__ = __webpack_require__(3485);




/**
 * Naive and inefficient object difference, intended for development / debugging use only.
 * Deleted keys are shown as [DELETED].
 * @param {{}} source The source object
 * @param {{}} target The target object.
 * @returns {{}} A new object containing new/modified/deleted keys.
 * @example
 * import { objectDiff } from 'src/lib'
 *
 * const a = { key: 'val', foo: 'bar' }
 * const b = { key: 'val', foo: 'baz' }
 *
 * objectDiff(a, b)
 * //=> { foo: 'baz' }
 */
/* unused harmony default export */ var _unused_webpack_default_export = (function (source, target) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_transform__["a" /* default */])(source, function (res, val, key) {
    // deleted keys
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_has__["a" /* default */])(target, key)) res[key] = '[DELETED]'; // new keys / changed values
    // Note, we tolerate isEqual here as this is a dev only utility and not included in production code
    else if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqual__["a" /* default */])(val, target[key])) res[key] = target[key];
  }, {});
});

/***/ }),
/* 3295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AccordionAccordion__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__AccordionContent__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AccordionPanel__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AccordionTitle__ = __webpack_require__(716);









/**
 * An accordion allows users to toggle the display of sections of content.
 */

function Accordion(props) {
  var className = props.className,
      fluid = props.fluid,
      inverted = props.inverted,
      styled = props.styled;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(styled, 'styled'), className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Accordion, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__AccordionAccordion__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }));
}

Accordion.handledProps = ["className", "fluid", "inverted", "styled"];
Accordion.propTypes =  false ? {
  /** Additional classes. */
  className: PropTypes.string,

  /** Format to take up the width of its container. */
  fluid: PropTypes.bool,

  /** Format for dark backgrounds. */
  inverted: PropTypes.bool,

  /** Adds some basic styling to accordion panels. */
  styled: PropTypes.bool
} : {};
Accordion.Accordion = __WEBPACK_IMPORTED_MODULE_5__AccordionAccordion__["a" /* default */];
Accordion.Content = __WEBPACK_IMPORTED_MODULE_6__AccordionContent__["a" /* default */];
Accordion.Panel = __WEBPACK_IMPORTED_MODULE_7__AccordionPanel__["a" /* default */];
Accordion.Title = __WEBPACK_IMPORTED_MODULE_8__AccordionTitle__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Accordion);

/***/ }),
/* 3296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Checkbox; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_set__ = __webpack_require__(3476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_get__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_isNil__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__fluentui_react_component_ref__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__lib__ = __webpack_require__(8);












/**
 * A checkbox allows a user to select a value from a small set of options, often binary.
 * @see Form
 * @see Radio
 */
var Checkbox = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Checkbox, _Component);

  function Checkbox() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.inputRef = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react__["createRef"])();
    _this.labelRef = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react__["createRef"])();

    _this.canToggle = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          radio = _this$props.radio,
          readOnly = _this$props.readOnly;
      var checked = _this.state.checked;
      return !disabled && !readOnly && !(radio && checked);
    };

    _this.computeTabIndex = function () {
      var _this$props2 = _this.props,
          disabled = _this$props2.disabled,
          tabIndex = _this$props2.tabIndex;
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isNil__["a" /* default */])(tabIndex)) return tabIndex;
      return disabled ? -1 : 0;
    };

    _this.handleClick = function (e) {
      var id = _this.props.id;
      var _this$state = _this.state,
          checked = _this$state.checked,
          indeterminate = _this$state.indeterminate;

      var isInputClick = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(_this.inputRef.current, 'contains', e.target);

      var isLabelClick = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(_this.labelRef.current, 'contains', e.target);

      var isRootClick = !isLabelClick && !isInputClick;
      var hasId = !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isNil__["a" /* default */])(id);
      var isLabelClickAndForwardedToInput = isLabelClick && hasId; // https://github.com/Semantic-Org/Semantic-UI-React/pull/3351

      if (!isLabelClickAndForwardedToInput) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(_this.props, 'onClick', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
          checked: !checked,
          indeterminate: !!indeterminate
        }));
      }

      if (_this.isClickFromMouse) {
        _this.isClickFromMouse = false;

        if (isLabelClick && !hasId) {
          _this.handleChange(e);
        } // Changes should be triggered for the slider variation


        if (isRootClick) {
          _this.handleChange(e);
        }

        if (isLabelClick && hasId) {
          // To prevent two clicks from being fired from the component we have to stop the propagation
          // from the "input" click: https://github.com/Semantic-Org/Semantic-UI-React/issues/3433
          e.stopPropagation();
        }
      }
    };

    _this.handleChange = function (e) {
      var checked = _this.state.checked;
      if (!_this.canToggle()) return;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(_this.props, 'onChange', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        checked: !checked,
        indeterminate: false
      }));

      _this.setState({
        checked: !checked,
        indeterminate: false
      });
    };

    _this.handleMouseDown = function (e) {
      var _this$state2 = _this.state,
          checked = _this$state2.checked,
          indeterminate = _this$state2.indeterminate;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(_this.props, 'onMouseDown', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        checked: !!checked,
        indeterminate: !!indeterminate
      }));

      if (!e.defaultPrevented) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(_this.inputRef.current, 'focus');
      } // Heads up!
      // We need to call "preventDefault" to keep element focused.


      e.preventDefault();
    };

    _this.handleMouseUp = function (e) {
      var _this$state3 = _this.state,
          checked = _this$state3.checked,
          indeterminate = _this$state3.indeterminate;
      _this.isClickFromMouse = true;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_invoke__["a" /* default */])(_this.props, 'onMouseUp', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        checked: !!checked,
        indeterminate: !!indeterminate
      }));
    };

    _this.setIndeterminate = function () {
      var indeterminate = _this.state.indeterminate;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_set__["a" /* default */])(_this.inputRef, 'current.indeterminate', !!indeterminate);
    };

    return _this;
  }

  var _proto = Checkbox.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setIndeterminate();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.setIndeterminate();
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        className = _this$props3.className,
        disabled = _this$props3.disabled,
        label = _this$props3.label,
        id = _this$props3.id,
        name = _this$props3.name,
        radio = _this$props3.radio,
        readOnly = _this$props3.readOnly,
        slider = _this$props3.slider,
        toggle = _this$props3.toggle,
        type = _this$props3.type,
        value = _this$props3.value;
    var _this$state4 = this.state,
        checked = _this$state4.checked,
        indeterminate = _this$state4.indeterminate;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_clsx__["a" /* default */])('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["a" /* useKeyOnly */])(checked, 'checked'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["a" /* useKeyOnly */])(indeterminate, 'indeterminate'), // auto apply fitted class to compact white space when there is no label
    // https://semantic-ui.com/modules/checkbox.html#fitted
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["a" /* useKeyOnly */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isNil__["a" /* default */])(label), 'fitted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["a" /* useKeyOnly */])(radio, 'radio'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["a" /* useKeyOnly */])(readOnly, 'read-only'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["a" /* useKeyOnly */])(slider, 'slider'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["a" /* useKeyOnly */])(toggle, 'toggle'), 'checkbox', className);
    var unhandled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["b" /* getUnhandledProps */])(Checkbox, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["c" /* getElementType */])(Checkbox, this.props);

    var _partitionHTMLProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["l" /* partitionHTMLProps */])(unhandled, {
      htmlProps: __WEBPACK_IMPORTED_MODULE_10__lib__["v" /* htmlInputAttrs */]
    }),
        htmlInputProps = _partitionHTMLProps[0],
        rest = _partitionHTMLProps[1]; // Heads Up!
    // Do not remove empty labels, they are required by SUI CSS


    var labelElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__lib__["z" /* createHTMLLabel */])(label, {
      defaultProps: {
        htmlFor: id
      },
      autoGenerateKey: false
    }) || /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("label", {
      htmlFor: id
    });
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes,
      onClick: this.handleClick,
      onChange: this.handleChange,
      onMouseDown: this.handleMouseDown,
      onMouseUp: this.handleMouseUp
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__fluentui_react_component_ref__["a" /* Ref */], {
      innerRef: this.inputRef
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement("input", __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, htmlInputProps, {
      checked: checked,
      className: "hidden",
      disabled: disabled,
      id: id,
      name: name,
      readOnly: true,
      tabIndex: this.computeTabIndex(),
      type: type,
      value: value
    }))), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__fluentui_react_component_ref__["a" /* Ref */], {
      innerRef: this.labelRef
    }, labelElement));
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_10__lib__["q" /* ModernAutoControlledComponent */]);

Checkbox.handledProps = ["as", "checked", "className", "defaultChecked", "defaultIndeterminate", "disabled", "fitted", "id", "indeterminate", "label", "name", "onChange", "onClick", "onMouseDown", "onMouseUp", "radio", "readOnly", "slider", "tabIndex", "toggle", "type", "value"];

Checkbox.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Whether or not checkbox is checked. */
  checked: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** The initial value of checked. */
  defaultChecked: PropTypes.bool,

  /** Whether or not checkbox is indeterminate. */
  defaultIndeterminate: PropTypes.bool,

  /** A checkbox can appear disabled and be unable to change states */
  disabled: PropTypes.bool,

  /** Removes padding for a label. Auto applied when there is no label. */
  fitted: PropTypes.bool,

  /** A unique identifier. */
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Whether or not checkbox is indeterminate. */
  indeterminate: PropTypes.bool,

  /** The text of the associated label element. */
  label: customPropTypes.itemShorthand,

  /** The HTML input name. */
  name: PropTypes.string,

  /**
   * Called when the user attempts to change the checked state.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed checked/indeterminate state.
   */
  onChange: PropTypes.func,

  /**
   * Called when the checkbox or label is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and current checked/indeterminate state.
   */
  onClick: PropTypes.func,

  /**
   * Called when the user presses down on the mouse.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and current checked/indeterminate state.
   */
  onMouseDown: PropTypes.func,

  /**
   * Called when the user releases the mouse.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and current checked/indeterminate state.
   */
  onMouseUp: PropTypes.func,

  /** Format as a radio element. This means it is an exclusive option. */
  radio: customPropTypes.every([PropTypes.bool, customPropTypes.disallow(['slider', 'toggle'])]),

  /** A checkbox can be read-only and unable to change states. */
  readOnly: PropTypes.bool,

  /** Format to emphasize the current selection state. */
  slider: customPropTypes.every([PropTypes.bool, customPropTypes.disallow(['radio', 'toggle'])]),

  /** A checkbox can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Format to show an on or off choice. */
  toggle: customPropTypes.every([PropTypes.bool, customPropTypes.disallow(['radio', 'slider'])]),

  /** HTML input type, either checkbox or radio. */
  type: PropTypes.oneOf(['checkbox', 'radio']),

  /** The HTML input value. */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
} : {};
Checkbox.defaultProps = {
  type: 'checkbox'
};
Checkbox.autoControlledProps = ['checked', 'indeterminate'];

/***/ }),
/* 3297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dimmer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__addons_Portal__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DimmerDimmable__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DimmerInner__ = __webpack_require__(1488);








/**
 * A dimmer hides distractions to focus attention on particular content.
 */

var Dimmer = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Dimmer, _Component);

  function Dimmer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handlePortalMount = function () {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["t" /* isBrowser */])()) return; // Heads up, IE doesn't support second argument in add()

      document.body.classList.add('dimmed');
      document.body.classList.add('dimmable');
    };

    _this.handlePortalUnmount = function () {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["t" /* isBrowser */])()) return; // Heads up, IE doesn't support second argument in add()

      document.body.classList.remove('dimmed');
      document.body.classList.remove('dimmable');
    };

    return _this;
  }

  var _proto = Dimmer.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        page = _this$props.page;
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Dimmer, this.props);

    if (page) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__addons_Portal__["a" /* default */], {
        closeOnEscape: false,
        closeOnDocumentClick: false,
        onMount: this.handlePortalMount,
        onUnmount: this.handlePortalUnmount,
        open: active,
        openOnTriggerClick: false
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DimmerInner__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        active: active,
        page: page
      })));
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__DimmerInner__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      active: active,
      page: page
    }));
  };

  return Dimmer;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Dimmer.handledProps = ["active", "page"];

Dimmer.propTypes =  false ? {
  /** An active dimmer will dim its parent container. */
  active: PropTypes.bool,

  /** A dimmer can be formatted to be fixed to the page. */
  page: PropTypes.bool
} : {};
Dimmer.Dimmable = __WEBPACK_IMPORTED_MODULE_6__DimmerDimmable__["a" /* default */];
Dimmer.Inner = __WEBPACK_IMPORTED_MODULE_7__DimmerInner__["a" /* default */];
Dimmer.create = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["e" /* createShorthandFactory */])(Dimmer, function (value) {
  return {
    content: value
  };
});

/***/ }),
/* 3298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Dropdown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_includes__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_compact__ = __webpack_require__(3454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_every__ = __webpack_require__(3457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_es_find__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_es_dropRight__ = __webpack_require__(3455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_es_isEmpty__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_es_size__ = __webpack_require__(3477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_es_difference__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_es_union__ = __webpack_require__(3487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_es_get__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_es_noop__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_es_isUndefined__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_lodash_es_has__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_lodash_es_isEqual__ = __webpack_require__(1586);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_lodash_es_isFunction__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash_es_pick__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_lodash_es_isNil__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__semantic_ui_react_event_stack__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__semantic_ui_react_event_stack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__semantic_ui_react_event_stack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__fluentui_react_component_ref__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_keyboard_key__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_keyboard_key___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_keyboard_key__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_shallowequal__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__elements_Icon__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__elements_Label__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__elements_Flag__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__elements_Image__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__DropdownDivider__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__DropdownItem__ = __webpack_require__(1492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__DropdownHeader__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__DropdownMenu__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__DropdownSearchInput__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__DropdownText__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__utils_getMenuOptions__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__utils_getSelectedIndex__ = __webpack_require__(3299);











































var getKeyOrValue = function getKeyOrValue(key, value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_lodash_es_isNil__["a" /* default */])(key) ? value : key;
};

var getKeyAndValues = function getKeyAndValues(options) {
  return options ? options.map(function (option) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20_lodash_es_pick__["a" /* default */])(option, ['key', 'value']);
  }) : options;
};

function renderItemContent(item) {
  var flag = item.flag,
      image = item.image,
      text = item.text; // TODO: remove this in v3
  // This maintains compatibility with Shorthand API in v1 as this might be called in "Label.create()"

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_19_lodash_es_isFunction__["a" /* default */])(text)) {
    return text;
  }

  return {
    content: /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_27_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_32__elements_Flag__["a" /* default */].create(flag), __WEBPACK_IMPORTED_MODULE_33__elements_Image__["a" /* default */].create(image), text)
  };
}
/**
 * A dropdown allows a user to select a value from a series of options.
 * @see Form
 * @see Select
 * @see Menu
 */


var Dropdown = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Dropdown, _Component);

  function Dropdown() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.searchRef = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_react__["createRef"])();
    _this.sizerRef = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_react__["createRef"])();
    _this.ref = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_react__["createRef"])();

    _this.handleChange = function (e, value) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.props, 'onChange', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        value: value
      }));
    };

    _this.closeOnChange = function (e) {
      var _this$props = _this.props,
          closeOnChange = _this$props.closeOnChange,
          multiple = _this$props.multiple;
      var shouldClose = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_15_lodash_es_isUndefined__["a" /* default */])(closeOnChange) ? !multiple : closeOnChange;

      if (shouldClose) {
        _this.close(e, __WEBPACK_IMPORTED_MODULE_14_lodash_es_noop__["a" /* default */]);
      }
    };

    _this.closeOnEscape = function (e) {
      if (!_this.props.closeOnEscape) return;
      if (__WEBPACK_IMPORTED_MODULE_25_keyboard_key___default.a.getCode(e) !== __WEBPACK_IMPORTED_MODULE_25_keyboard_key___default.a.Escape) return;
      e.preventDefault();

      _this.close(e);
    };

    _this.moveSelectionOnKeyDown = function (e) {
      var _moves;

      var _this$props2 = _this.props,
          multiple = _this$props2.multiple,
          selectOnNavigation = _this$props2.selectOnNavigation;
      var open = _this.state.open;

      if (!open) {
        return;
      }

      var moves = (_moves = {}, _moves[__WEBPACK_IMPORTED_MODULE_25_keyboard_key___default.a.ArrowDown] = 1, _moves[__WEBPACK_IMPORTED_MODULE_25_keyboard_key___default.a.ArrowUp] = -1, _moves);
      var move = moves[__WEBPACK_IMPORTED_MODULE_25_keyboard_key___default.a.getCode(e)];

      if (move === undefined) {
        return;
      }

      e.preventDefault();

      var nextIndex = _this.getSelectedIndexAfterMove(move);

      if (!multiple && selectOnNavigation) {
        _this.makeSelectedItemActive(e, nextIndex);
      }

      _this.setState({
        selectedIndex: nextIndex
      });
    };

    _this.openOnSpace = function (e) {
      var _e$target, _e$target2, _e$target3;

      var shouldHandleEvent = _this.state.focus && !_this.state.open && __WEBPACK_IMPORTED_MODULE_25_keyboard_key___default.a.getCode(e) === __WEBPACK_IMPORTED_MODULE_25_keyboard_key___default.a.Spacebar;
      var shouldPreventDefault = ((_e$target = e.target) == null ? void 0 : _e$target.tagName) !== 'INPUT' && ((_e$target2 = e.target) == null ? void 0 : _e$target2.tagName) !== 'TEXTAREA' && ((_e$target3 = e.target) == null ? void 0 : _e$target3.isContentEditable) !== true;

      if (shouldHandleEvent) {
        if (shouldPreventDefault) {
          e.preventDefault();
        }

        _this.open(e);
      }
    };

    _this.openOnArrow = function (e) {
      var _this$state = _this.state,
          focus = _this$state.focus,
          open = _this$state.open;

      if (focus && !open) {
        var code = __WEBPACK_IMPORTED_MODULE_25_keyboard_key___default.a.getCode(e);

        if (code === __WEBPACK_IMPORTED_MODULE_25_keyboard_key___default.a.ArrowDown || code === __WEBPACK_IMPORTED_MODULE_25_keyboard_key___default.a.ArrowUp) {
          e.preventDefault();

          _this.open(e);
        }
      }
    };

    _this.makeSelectedItemActive = function (e, selectedIndex) {
      var _this$state2 = _this.state,
          open = _this$state2.open,
          value = _this$state2.value;
      var multiple = _this.props.multiple;

      var item = _this.getSelectedItem(selectedIndex);

      var selectedValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lodash_es_get__["a" /* default */])(item, 'value');

      var disabled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lodash_es_get__["a" /* default */])(item, 'disabled'); // prevent selecting null if there was no selected item value
      // prevent selecting duplicate items when the dropdown is closed
      // prevent selecting disabled items


      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_lodash_es_isNil__["a" /* default */])(selectedValue) || !open || disabled) {
        return value;
      } // state value may be undefined


      var newValue = multiple ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lodash_es_union__["a" /* default */])(value, [selectedValue]) : selectedValue;
      var valueHasChanged = multiple ? !!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash_es_difference__["a" /* default */])(newValue, value).length : newValue !== value;

      if (valueHasChanged) {
        // notify the onChange prop that the user is trying to change value
        _this.setState({
          value: newValue
        });

        _this.handleChange(e, newValue); // Heads up! This event handler should be called after `onChange`
        // Notify the onAddItem prop if this is a new value


        if (item['data-additional']) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.props, 'onAddItem', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
            value: selectedValue
          }));
        }
      }

      return value;
    };

    _this.selectItemOnEnter = function (e) {
      var search = _this.props.search;
      var _this$state3 = _this.state,
          open = _this$state3.open,
          selectedIndex = _this$state3.selectedIndex;

      if (!open) {
        return;
      }

      var shouldSelect = __WEBPACK_IMPORTED_MODULE_25_keyboard_key___default.a.getCode(e) === __WEBPACK_IMPORTED_MODULE_25_keyboard_key___default.a.Enter || // https://github.com/Semantic-Org/Semantic-UI-React/pull/3766
      !search && __WEBPACK_IMPORTED_MODULE_25_keyboard_key___default.a.getCode(e) === __WEBPACK_IMPORTED_MODULE_25_keyboard_key___default.a.Spacebar;

      if (!shouldSelect) {
        return;
      }

      e.preventDefault();

      var optionSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash_es_size__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_40__utils_getMenuOptions__["a" /* default */])({
        value: _this.state.value,
        options: _this.props.options,
        searchQuery: _this.state.searchQuery,
        additionLabel: _this.props.additionLabel,
        additionPosition: _this.props.additionPosition,
        allowAdditions: _this.props.allowAdditions,
        deburr: _this.props.deburr,
        multiple: _this.props.multiple,
        search: _this.props.search
      }));

      if (search && optionSize === 0) {
        return;
      }

      var nextValue = _this.makeSelectedItemActive(e, selectedIndex); // This is required as selected value may be the same


      _this.setState({
        selectedIndex: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__utils_getSelectedIndex__["a" /* default */])({
          additionLabel: _this.props.additionLabel,
          additionPosition: _this.props.additionPosition,
          allowAdditions: _this.props.allowAdditions,
          deburr: _this.props.deburr,
          multiple: _this.props.multiple,
          search: _this.props.search,
          selectedIndex: selectedIndex,
          value: nextValue,
          options: _this.props.options,
          searchQuery: ''
        })
      });

      _this.closeOnChange(e);

      _this.clearSearchQuery();

      if (search) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.searchRef.current, 'focus');
      }
    };

    _this.removeItemOnBackspace = function (e) {
      var _this$props3 = _this.props,
          multiple = _this$props3.multiple,
          search = _this$props3.search;
      var _this$state4 = _this.state,
          searchQuery = _this$state4.searchQuery,
          value = _this$state4.value;
      if (__WEBPACK_IMPORTED_MODULE_25_keyboard_key___default.a.getCode(e) !== __WEBPACK_IMPORTED_MODULE_25_keyboard_key___default.a.Backspace) return;
      if (searchQuery || !search || !multiple || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash_es_isEmpty__["a" /* default */])(value)) return;
      e.preventDefault(); // remove most recent value

      var newValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash_es_dropRight__["a" /* default */])(value);

      _this.setState({
        value: newValue
      });

      _this.handleChange(e, newValue);
    };

    _this.closeOnDocumentClick = function (e) {
      if (!_this.props.closeOnBlur) return; // If event happened in the dropdown, ignore it

      if (_this.ref.current && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["u" /* doesNodeContainClick */])(_this.ref.current, e)) return;

      _this.close();
    };

    _this.handleMouseDown = function (e) {
      _this.isMouseDown = true;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.props, 'onMouseDown', e, _this.props);

      document.addEventListener('mouseup', _this.handleDocumentMouseUp);
    };

    _this.handleDocumentMouseUp = function () {
      _this.isMouseDown = false;
      document.removeEventListener('mouseup', _this.handleDocumentMouseUp);
    };

    _this.handleClick = function (e) {
      var _this$props4 = _this.props,
          minCharacters = _this$props4.minCharacters,
          search = _this$props4.search;
      var _this$state5 = _this.state,
          open = _this$state5.open,
          searchQuery = _this$state5.searchQuery;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.props, 'onClick', e, _this.props); // prevent closeOnDocumentClick()


      e.stopPropagation();
      if (!search) return _this.toggle(e);

      if (open) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.searchRef.current, 'focus');

        return;
      }

      if (searchQuery.length >= minCharacters || minCharacters === 1) {
        _this.open(e);

        return;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.searchRef.current, 'focus');
    };

    _this.handleIconClick = function (e) {
      var clearable = _this.props.clearable;

      var hasValue = _this.hasValue();

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.props, 'onClick', e, _this.props); // prevent handleClick()


      e.stopPropagation();

      if (clearable && hasValue) {
        _this.clearValue(e);
      } else {
        _this.toggle(e);
      }
    };

    _this.handleItemClick = function (e, item) {
      var _this$props5 = _this.props,
          multiple = _this$props5.multiple,
          search = _this$props5.search;
      var currentValue = _this.state.value;
      var value = item.value; // prevent toggle() in handleClick()

      e.stopPropagation(); // prevent closeOnDocumentClick() if multiple or item is disabled

      if (multiple || item.disabled) {
        e.nativeEvent.stopImmediatePropagation();
      }

      if (item.disabled) {
        return;
      }

      var isAdditionItem = item['data-additional'];
      var newValue = multiple ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lodash_es_union__["a" /* default */])(_this.state.value, [value]) : value;
      var valueHasChanged = multiple ? !!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash_es_difference__["a" /* default */])(newValue, currentValue).length : newValue !== currentValue; // notify the onChange prop that the user is trying to change value

      if (valueHasChanged) {
        _this.setState({
          value: newValue
        });

        _this.handleChange(e, newValue);
      }

      _this.clearSearchQuery();

      if (search) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.searchRef.current, 'focus');
      } else {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.ref.current, 'focus');
      }

      _this.closeOnChange(e); // Heads up! This event handler should be called after `onChange`
      // Notify the onAddItem prop if this is a new value


      if (isAdditionItem) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.props, 'onAddItem', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
          value: value
        }));
      }
    };

    _this.handleFocus = function (e) {
      var focus = _this.state.focus;
      if (focus) return;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.props, 'onFocus', e, _this.props);

      _this.setState({
        focus: true
      });
    };

    _this.handleBlur = function (e) {
      // Heads up! Don't remove this.
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/1315
      var currentTarget = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lodash_es_get__["a" /* default */])(e, 'currentTarget');

      if (currentTarget && currentTarget.contains(document.activeElement)) return;
      var _this$props6 = _this.props,
          closeOnBlur = _this$props6.closeOnBlur,
          multiple = _this$props6.multiple,
          selectOnBlur = _this$props6.selectOnBlur; // do not "blur" when the mouse is down inside of the Dropdown

      if (_this.isMouseDown) return;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.props, 'onBlur', e, _this.props);

      if (selectOnBlur && !multiple) {
        _this.makeSelectedItemActive(e, _this.state.selectedIndex);

        if (closeOnBlur) _this.close();
      }

      _this.setState({
        focus: false
      });

      _this.clearSearchQuery();
    };

    _this.handleSearchChange = function (e, _ref) {
      var value = _ref.value;
      // prevent propagating to this.props.onChange()
      e.stopPropagation();
      var minCharacters = _this.props.minCharacters;
      var open = _this.state.open;
      var newQuery = value;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.props, 'onSearchChange', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        searchQuery: newQuery
      }));

      _this.setState({
        searchQuery: newQuery,
        selectedIndex: 0
      }); // open search dropdown on search query


      if (!open && newQuery.length >= minCharacters) {
        _this.open();

        return;
      } // close search dropdown if search query is too small


      if (open && minCharacters !== 1 && newQuery.length < minCharacters) _this.close();
    };

    _this.handleKeyDown = function (e) {
      _this.moveSelectionOnKeyDown(e);

      _this.openOnArrow(e);

      _this.openOnSpace(e);

      _this.selectItemOnEnter(e);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.props, 'onKeyDown', e);
    };

    _this.getSelectedItem = function (selectedIndex) {
      var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_40__utils_getMenuOptions__["a" /* default */])({
        value: _this.state.value,
        options: _this.props.options,
        searchQuery: _this.state.searchQuery,
        additionLabel: _this.props.additionLabel,
        additionPosition: _this.props.additionPosition,
        allowAdditions: _this.props.allowAdditions,
        deburr: _this.props.deburr,
        multiple: _this.props.multiple,
        search: _this.props.search
      });
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_lodash_es_get__["a" /* default */])(options, "[" + selectedIndex + "]");
    };

    _this.getItemByValue = function (value) {
      var options = _this.props.options;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash_es_find__["a" /* default */])(options, {
        value: value
      });
    };

    _this.getDropdownAriaOptions = function () {
      var _this$props7 = _this.props,
          loading = _this$props7.loading,
          disabled = _this$props7.disabled,
          search = _this$props7.search,
          multiple = _this$props7.multiple;
      var open = _this.state.open;
      var ariaOptions = {
        role: search ? 'combobox' : 'listbox',
        'aria-busy': loading,
        'aria-disabled': disabled,
        'aria-expanded': !!open
      };

      if (ariaOptions.role === 'listbox') {
        ariaOptions['aria-multiselectable'] = multiple;
      }

      return ariaOptions;
    };

    _this.clearSearchQuery = function () {
      var searchQuery = _this.state.searchQuery;
      if (searchQuery === undefined || searchQuery === '') return;

      _this.setState({
        searchQuery: ''
      });
    };

    _this.handleLabelClick = function (e, labelProps) {
      // prevent focusing search input on click
      e.stopPropagation();

      _this.setState({
        selectedLabel: labelProps.value
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.props, 'onLabelClick', e, labelProps);
    };

    _this.handleLabelRemove = function (e, labelProps) {
      // prevent focusing search input on click
      e.stopPropagation();
      var value = _this.state.value;

      var newValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash_es_without__["a" /* default */])(value, labelProps.value);

      _this.setState({
        value: newValue
      });

      _this.handleChange(e, newValue);
    };

    _this.getSelectedIndexAfterMove = function (offset, startIndex) {
      if (startIndex === void 0) {
        startIndex = _this.state.selectedIndex;
      }

      var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_40__utils_getMenuOptions__["a" /* default */])({
        value: _this.state.value,
        options: _this.props.options,
        searchQuery: _this.state.searchQuery,
        additionLabel: _this.props.additionLabel,
        additionPosition: _this.props.additionPosition,
        allowAdditions: _this.props.allowAdditions,
        deburr: _this.props.deburr,
        multiple: _this.props.multiple,
        search: _this.props.search
      }); // Prevent infinite loop
      // TODO: remove left part of condition after children API will be removed

      if (options === undefined || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_every__["a" /* default */])(options, 'disabled')) return;
      var lastIndex = options.length - 1;
      var wrapSelection = _this.props.wrapSelection; // next is after last, wrap to beginning
      // next is before first, wrap to end

      var nextIndex = startIndex + offset; // if 'wrapSelection' is set to false and selection is after last or before first, it just does not change

      if (!wrapSelection && (nextIndex > lastIndex || nextIndex < 0)) {
        nextIndex = startIndex;
      } else if (nextIndex > lastIndex) {
        nextIndex = 0;
      } else if (nextIndex < 0) {
        nextIndex = lastIndex;
      }

      if (options[nextIndex].disabled) {
        return _this.getSelectedIndexAfterMove(offset, nextIndex);
      }

      return nextIndex;
    };

    _this.handleIconOverrides = function (predefinedProps) {
      var clearable = _this.props.clearable;
      var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_clsx__["a" /* default */])(clearable && _this.hasValue() && 'clear', predefinedProps.className);
      return {
        className: classes,
        onClick: function onClick(e) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(predefinedProps, 'onClick', e, predefinedProps);

          _this.handleIconClick(e);
        }
      };
    };

    _this.clearValue = function (e) {
      var multiple = _this.props.multiple;
      var newValue = multiple ? [] : '';

      _this.setState({
        value: newValue
      });

      _this.handleChange(e, newValue);
    };

    _this.computeSearchInputTabIndex = function () {
      var _this$props8 = _this.props,
          disabled = _this$props8.disabled,
          tabIndex = _this$props8.tabIndex;
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_lodash_es_isNil__["a" /* default */])(tabIndex)) return tabIndex;
      return disabled ? -1 : 0;
    };

    _this.computeSearchInputWidth = function () {
      var searchQuery = _this.state.searchQuery;

      if (_this.sizerRef.current && searchQuery) {
        // resize the search input, temporarily show the sizer so we can measure it
        _this.sizerRef.current.style.display = 'inline';
        _this.sizerRef.current.textContent = searchQuery;
        var searchWidth = Math.ceil(_this.sizerRef.current.getBoundingClientRect().width);

        _this.sizerRef.current.style.removeProperty('display');

        return searchWidth;
      }
    };

    _this.computeTabIndex = function () {
      var _this$props9 = _this.props,
          disabled = _this$props9.disabled,
          search = _this$props9.search,
          tabIndex = _this$props9.tabIndex; // don't set a root node tabIndex as the search input has its own tabIndex

      if (search) return undefined;
      if (disabled) return -1;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_lodash_es_isNil__["a" /* default */])(tabIndex) ? 0 : tabIndex;
    };

    _this.handleSearchInputOverrides = function (predefinedProps) {
      return {
        onChange: function onChange(e, inputProps) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(predefinedProps, 'onChange', e, inputProps);

          _this.handleSearchChange(e, inputProps);
        }
      };
    };

    _this.hasValue = function () {
      var multiple = _this.props.multiple;
      var value = _this.state.value;
      return multiple ? !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash_es_isEmpty__["a" /* default */])(value) : !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21_lodash_es_isNil__["a" /* default */])(value) && value !== '';
    };

    _this.scrollSelectedItemIntoView = function () {
      if (!_this.ref.current) return;

      var menu = _this.ref.current.querySelector('.menu.visible');

      if (!menu) return;
      var item = menu.querySelector('.item.selected');
      if (!item) return;
      var isOutOfUpperView = item.offsetTop < menu.scrollTop;
      var isOutOfLowerView = item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight;

      if (isOutOfUpperView) {
        menu.scrollTop = item.offsetTop;
      } else if (isOutOfLowerView) {
        // eslint-disable-next-line no-mixed-operators
        menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight;
      }
    };

    _this.setOpenDirection = function () {
      if (!_this.ref.current) return;

      var menu = _this.ref.current.querySelector('.menu.visible');

      if (!menu) return;

      var dropdownRect = _this.ref.current.getBoundingClientRect();

      var menuHeight = menu.clientHeight;
      var spaceAtTheBottom = document.documentElement.clientHeight - dropdownRect.top - dropdownRect.height - menuHeight;
      var spaceAtTheTop = dropdownRect.top - menuHeight;
      var upward = spaceAtTheBottom < 0 && spaceAtTheTop > spaceAtTheBottom; // set state only if there's a relevant difference

      if (!upward !== !_this.state.upward) {
        _this.setState({
          upward: upward
        });
      }
    };

    _this.open = function (e, triggerSetState) {
      if (e === void 0) {
        e = null;
      }

      if (triggerSetState === void 0) {
        triggerSetState = true;
      }

      var _this$props10 = _this.props,
          disabled = _this$props10.disabled,
          search = _this$props10.search;
      if (disabled) return;
      if (search) __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.searchRef.current, 'focus');

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.props, 'onOpen', e, _this.props);

      if (triggerSetState) {
        _this.setState({
          open: true
        });
      }

      _this.scrollSelectedItemIntoView();
    };

    _this.close = function (e, callback) {
      if (callback === void 0) {
        callback = _this.handleClose;
      }

      if (_this.state.open) {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_16_lodash_es_invoke__["a" /* default */])(_this.props, 'onClose', e, _this.props);

        _this.setState({
          open: false
        }, callback);
      }
    };

    _this.handleClose = function () {
      var hasSearchFocus = document.activeElement === _this.searchRef.current; // https://github.com/Semantic-Org/Semantic-UI-React/issues/627
      // Blur the Dropdown on close so it is blurred after selecting an item.
      // This is to prevent it from re-opening when switching tabs after selecting an item.

      if (!hasSearchFocus && _this.ref.current) {
        _this.ref.current.blur();
      }

      var hasDropdownFocus = document.activeElement === _this.ref.current;
      var hasFocus = hasSearchFocus || hasDropdownFocus; // We need to keep the virtual model in sync with the browser focus change
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/692

      _this.setState({
        focus: hasFocus
      });
    };

    _this.toggle = function (e) {
      return _this.state.open ? _this.close(e) : _this.open(e);
    };

    _this.renderText = function () {
      var _this$props11 = _this.props,
          multiple = _this$props11.multiple,
          placeholder = _this$props11.placeholder,
          search = _this$props11.search,
          text = _this$props11.text;
      var _this$state6 = _this.state,
          searchQuery = _this$state6.searchQuery,
          selectedIndex = _this$state6.selectedIndex,
          value = _this$state6.value,
          open = _this$state6.open;

      var hasValue = _this.hasValue();

      var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_clsx__["a" /* default */])(placeholder && !hasValue && 'default', 'text', search && searchQuery && 'filtered');
      var _text = placeholder;
      var selectedItem;

      if (text) {
        _text = text;
      } else if (open && !multiple) {
        selectedItem = _this.getSelectedItem(selectedIndex);
      } else if (hasValue) {
        selectedItem = _this.getItemByValue(value);
      }

      return __WEBPACK_IMPORTED_MODULE_39__DropdownText__["a" /* default */].create(selectedItem ? renderItemContent(selectedItem) : _text, {
        defaultProps: {
          className: classes
        }
      });
    };

    _this.renderSearchInput = function () {
      var _this$props12 = _this.props,
          search = _this$props12.search,
          searchInput = _this$props12.searchInput;
      var searchQuery = _this.state.searchQuery;
      return search && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__fluentui_react_component_ref__["a" /* Ref */], {
        innerRef: _this.searchRef
      }, __WEBPACK_IMPORTED_MODULE_38__DropdownSearchInput__["a" /* default */].create(searchInput, {
        defaultProps: {
          style: {
            width: _this.computeSearchInputWidth()
          },
          tabIndex: _this.computeSearchInputTabIndex(),
          value: searchQuery
        },
        overrideProps: _this.handleSearchInputOverrides
      }));
    };

    _this.renderSearchSizer = function () {
      var _this$props13 = _this.props,
          search = _this$props13.search,
          multiple = _this$props13.multiple;
      return search && multiple && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("span", {
        className: "sizer",
        ref: _this.sizerRef
      });
    };

    _this.renderLabels = function () {
      var _this$props14 = _this.props,
          multiple = _this$props14.multiple,
          renderLabel = _this$props14.renderLabel;
      var _this$state7 = _this.state,
          selectedLabel = _this$state7.selectedLabel,
          value = _this$state7.value;

      if (!multiple || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash_es_isEmpty__["a" /* default */])(value)) {
        return;
      }

      var selectedItems = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_map__["a" /* default */])(value, _this.getItemByValue);

      // if no item could be found for a given state value the selected item will be undefined
      // compact the selectedItems so we only have actual objects left
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_map__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_compact__["a" /* default */])(selectedItems), function (item, index) {
        var defaultProps = {
          active: item.value === selectedLabel,
          as: 'a',
          key: getKeyOrValue(item.key, item.value),
          onClick: _this.handleLabelClick,
          onRemove: _this.handleLabelRemove,
          value: item.value
        };
        return __WEBPACK_IMPORTED_MODULE_31__elements_Label__["a" /* default */].create(renderLabel(item, index, defaultProps), {
          defaultProps: defaultProps
        });
      });
    };

    _this.renderOptions = function () {
      var _this$props15 = _this.props,
          lazyLoad = _this$props15.lazyLoad,
          multiple = _this$props15.multiple,
          search = _this$props15.search,
          noResultsMessage = _this$props15.noResultsMessage;
      var _this$state8 = _this.state,
          open = _this$state8.open,
          selectedIndex = _this$state8.selectedIndex,
          value = _this$state8.value; // lazy load, only render options when open

      if (lazyLoad && !open) return null;
      var options = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_40__utils_getMenuOptions__["a" /* default */])({
        value: _this.state.value,
        options: _this.props.options,
        searchQuery: _this.state.searchQuery,
        additionLabel: _this.props.additionLabel,
        additionPosition: _this.props.additionPosition,
        allowAdditions: _this.props.allowAdditions,
        deburr: _this.props.deburr,
        multiple: _this.props.multiple,
        search: _this.props.search
      });

      if (noResultsMessage !== null && search && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash_es_isEmpty__["a" /* default */])(options)) {
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement("div", {
          className: "message"
        }, noResultsMessage);
      }

      var isActive = multiple ? function (optValue) {
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_includes__["a" /* default */])(value, optValue);
      } : function (optValue) {
        return optValue === value;
      };
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_map__["a" /* default */])(options, function (opt, i) {
        return __WEBPACK_IMPORTED_MODULE_35__DropdownItem__["a" /* default */].create(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          active: isActive(opt.value),
          selected: selectedIndex === i
        }, opt, {
          key: getKeyOrValue(opt.key, opt.value),
          // Needed for handling click events on disabled items
          style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, opt.style, {
            pointerEvents: 'all'
          })
        }), {
          generateKey: false,
          overrideProps: function overrideProps(predefinedProps) {
            return {
              onClick: function onClick(e, item) {
                predefinedProps.onClick == null ? void 0 : predefinedProps.onClick(e, item);

                _this.handleItemClick(e, item);
              }
            };
          }
        });
      });
    };

    _this.renderMenu = function () {
      var _this$props16 = _this.props,
          children = _this$props16.children,
          direction = _this$props16.direction,
          header = _this$props16.header;
      var open = _this.state.open;

      var ariaOptions = _this.getDropdownMenuAriaOptions(); // single menu child


      if (!__WEBPACK_IMPORTED_MODULE_29__lib__["d" /* childrenUtils */].isNil(children)) {
        var menuChild = __WEBPACK_IMPORTED_MODULE_27_react__["Children"].only(children);
        var className = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_clsx__["a" /* default */])(direction, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(open, 'visible'), menuChild.props.className);
        return /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_27_react__["cloneElement"])(menuChild, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          className: className
        }, ariaOptions));
      }

      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_37__DropdownMenu__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ariaOptions, {
        direction: direction,
        open: open
      }), __WEBPACK_IMPORTED_MODULE_36__DropdownHeader__["a" /* default */].create(header, {
        autoGenerateKey: false
      }), _this.renderOptions());
    };

    return _this;
  }

  var _proto = Dropdown.prototype;

  _proto.getInitialAutoControlledState = function getInitialAutoControlledState() {
    return {
      focus: false,
      searchQuery: ''
    };
  };

  Dropdown.getAutoControlledStateFromProps = function getAutoControlledStateFromProps(nextProps, computedState, prevState) {
    // These values are stored only for a comparison on next getAutoControlledStateFromProps()
    var derivedState = {
      __options: nextProps.options,
      __value: computedState.value
    }; // The selected index is only dependent:

    var shouldComputeSelectedIndex = // On value change
    !__WEBPACK_IMPORTED_MODULE_28_shallowequal___default()(prevState.__value, computedState.value) || // On option keys/values, we only check those properties to avoid recursive performance impacts.
    // https://github.com/Semantic-Org/Semantic-UI-React/issues/3000
    !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18_lodash_es_isEqual__["a" /* default */])(getKeyAndValues(nextProps.options), getKeyAndValues(prevState.__options));

    if (shouldComputeSelectedIndex) {
      derivedState.selectedIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_41__utils_getSelectedIndex__["a" /* default */])({
        additionLabel: nextProps.additionLabel,
        additionPosition: nextProps.additionPosition,
        allowAdditions: nextProps.allowAdditions,
        deburr: nextProps.deburr,
        multiple: nextProps.multiple,
        search: nextProps.search,
        selectedIndex: computedState.selectedIndex,
        value: computedState.value,
        options: nextProps.options,
        searchQuery: computedState.searchQuery
      });
    }

    return derivedState;
  };

  _proto.componentDidMount = function componentDidMount() {
    var open = this.state.open;

    if (open) {
      this.open(null, false);
    }
  };

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    return !__WEBPACK_IMPORTED_MODULE_28_shallowequal___default()(nextProps, this.props) || !__WEBPACK_IMPORTED_MODULE_28_shallowequal___default()(nextState, this.state);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // eslint-disable-line complexity
    var _this$props17 = this.props,
        closeOnBlur = _this$props17.closeOnBlur,
        minCharacters = _this$props17.minCharacters,
        openOnFocus = _this$props17.openOnFocus,
        search = _this$props17.search;
    /* eslint-disable no-console */

    if (false) {
      // in development, validate value type matches dropdown type
      var isNextValueArray = Array.isArray(this.props.value);

      var hasValue = _has(this.props, 'value');

      if (hasValue && this.props.multiple && !isNextValueArray) {
        console.error('Dropdown `value` must be an array when `multiple` is set.' + (" Received type: `" + Object.prototype.toString.call(this.props.value) + "`."));
      } else if (hasValue && !this.props.multiple && isNextValueArray) {
        console.error('Dropdown `value` must not be an array when `multiple` is not set.' + ' Either set `multiple={true}` or use a string or number value.');
      }
    }
    /* eslint-enable no-console */
    // focused / blurred


    if (!prevState.focus && this.state.focus) {
      if (!this.isMouseDown) {
        var openable = !search || search && minCharacters === 1 && !this.state.open;
        if (openOnFocus && openable) this.open();
      }
    } else if (prevState.focus && !this.state.focus) {
      if (!this.isMouseDown && closeOnBlur) {
        this.close();
      }
    } // opened / closed


    if (!prevState.open && this.state.open) {
      this.setOpenDirection();
      this.scrollSelectedItemIntoView();
    } else if (prevState.open && !this.state.open) {}

    if (prevState.selectedIndex !== this.state.selectedIndex) {
      this.scrollSelectedItemIntoView();
    }
  } // ----------------------------------------
  // Document Event Handlers
  // ----------------------------------------
  // onChange needs to receive a value
  // can't rely on props.value if we are controlled
  ;

  _proto.getDropdownMenuAriaOptions = function getDropdownMenuAriaOptions() {
    var _this$props18 = this.props,
        search = _this$props18.search,
        multiple = _this$props18.multiple;
    var ariaOptions = {};

    if (search) {
      ariaOptions['aria-multiselectable'] = multiple;
      ariaOptions.role = 'listbox';
    }

    return ariaOptions;
  } // ----------------------------------------
  // Setters
  // ----------------------------------------
  ;

  _proto.render = function render() {
    var _this$props19 = this.props,
        basic = _this$props19.basic,
        button = _this$props19.button,
        className = _this$props19.className,
        compact = _this$props19.compact,
        disabled = _this$props19.disabled,
        error = _this$props19.error,
        fluid = _this$props19.fluid,
        floating = _this$props19.floating,
        icon = _this$props19.icon,
        inline = _this$props19.inline,
        item = _this$props19.item,
        labeled = _this$props19.labeled,
        loading = _this$props19.loading,
        multiple = _this$props19.multiple,
        pointing = _this$props19.pointing,
        search = _this$props19.search,
        selection = _this$props19.selection,
        scrolling = _this$props19.scrolling,
        simple = _this$props19.simple,
        trigger = _this$props19.trigger;
    var _this$state9 = this.state,
        focus = _this$state9.focus,
        open = _this$state9.open,
        upward = _this$state9.upward; // Classes

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_24_clsx__["a" /* default */])('ui', __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(open, 'active visible'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(error, 'error'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(loading, 'loading'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(basic, 'basic'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(button, 'button'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(compact, 'compact'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(floating, 'floating'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(inline, 'inline'), // TODO: consider augmentation to render Dropdowns as Button/Menu, solves icon/link item issues
    // https://github.com/Semantic-Org/Semantic-UI-React/issues/401#issuecomment-240487229
    // TODO: the icon class is only required when a dropdown is a button
    // useKeyOnly(icon, 'icon'),
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(labeled, 'labeled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(item, 'item'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(multiple, 'multiple'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(search, 'search'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(selection, 'selection'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(simple, 'simple'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(scrolling, 'scrolling'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["a" /* useKeyOnly */])(upward, 'upward'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["h" /* useKeyOrValueAndKey */])(pointing, 'pointing'), 'dropdown', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["b" /* getUnhandledProps */])(Dropdown, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_29__lib__["c" /* getElementType */])(Dropdown, this.props);
    var ariaOptions = this.getDropdownAriaOptions(ElementType, this.props);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_23__fluentui_react_component_ref__["a" /* Ref */], {
      innerRef: this.ref
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, ariaOptions, {
      className: classes,
      onBlur: this.handleBlur,
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      onMouseDown: this.handleMouseDown,
      onFocus: this.handleFocus,
      onChange: this.handleChange,
      tabIndex: this.computeTabIndex()
    }), this.renderLabels(), this.renderSearchInput(), this.renderSearchSizer(), trigger || this.renderText(), __WEBPACK_IMPORTED_MODULE_30__elements_Icon__["a" /* default */].create(icon, {
      overrideProps: this.handleIconOverrides,
      autoGenerateKey: false
    }), this.renderMenu(), open && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__semantic_ui_react_event_stack___default.a, {
      name: "keydown",
      on: this.closeOnEscape
    }), open && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__semantic_ui_react_event_stack___default.a, {
      name: "click",
      on: this.closeOnDocumentClick
    }), focus && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_27_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__semantic_ui_react_event_stack___default.a, {
      name: "keydown",
      on: this.removeItemOnBackspace
    })));
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_29__lib__["q" /* ModernAutoControlledComponent */]);

Dropdown.handledProps = ["additionLabel", "additionPosition", "allowAdditions", "as", "basic", "button", "children", "className", "clearable", "closeOnBlur", "closeOnChange", "closeOnEscape", "compact", "deburr", "defaultOpen", "defaultSearchQuery", "defaultSelectedLabel", "defaultUpward", "defaultValue", "direction", "disabled", "error", "floating", "fluid", "header", "icon", "inline", "item", "labeled", "lazyLoad", "loading", "minCharacters", "multiple", "noResultsMessage", "onAddItem", "onBlur", "onChange", "onClick", "onClose", "onFocus", "onLabelClick", "onMouseDown", "onOpen", "onSearchChange", "open", "openOnFocus", "options", "placeholder", "pointing", "renderLabel", "scrolling", "search", "searchInput", "searchQuery", "selectOnBlur", "selectOnNavigation", "selectedLabel", "selection", "simple", "tabIndex", "text", "trigger", "upward", "value", "wrapSelection"];

Dropdown.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Label prefixed to an option added by a user. */
  additionLabel: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),

  /** Position of the `Add: ...` option in the dropdown list ('top' or 'bottom'). */
  additionPosition: PropTypes.oneOf(['top', 'bottom']),

  /**
   * Allow user additions to the list of options (boolean).
   * Requires the use of `selection`, `options` and `search`.
   */
  allowAdditions: customPropTypes.every([customPropTypes.demand(['options', 'selection', 'search']), PropTypes.bool]),

  /** A Dropdown can reduce its complexity. */
  basic: PropTypes.bool,

  /** Format the Dropdown to appear as a button. */
  button: PropTypes.bool,

  /** Primary content. */
  children: customPropTypes.every([customPropTypes.disallow(['options', 'selection']), customPropTypes.givenProps({
    children: PropTypes.any.isRequired
  }, PropTypes.element.isRequired)]),

  /** Additional classes. */
  className: PropTypes.string,

  /** Using the clearable setting will let users remove their selection from a dropdown. */
  clearable: PropTypes.bool,

  /** Whether or not the menu should close when the dropdown is blurred. */
  closeOnBlur: PropTypes.bool,

  /** Whether or not the dropdown should close when the escape key is pressed. */
  closeOnEscape: PropTypes.bool,

  /**
   * Whether or not the menu should close when a value is selected from the dropdown.
   * By default, multiple selection dropdowns will remain open on change, while single
   * selection dropdowns will close on change.
   */
  closeOnChange: PropTypes.bool,

  /** A compact dropdown has no minimum width. */
  compact: PropTypes.bool,

  /** Whether or not the dropdown should strip diacritics in options and input search */
  deburr: PropTypes.bool,

  /** Initial value of open. */
  defaultOpen: PropTypes.bool,

  /** Initial value of searchQuery. */
  defaultSearchQuery: PropTypes.string,

  /** Currently selected label in multi-select. */
  defaultSelectedLabel: customPropTypes.every([customPropTypes.demand(['multiple']), PropTypes.oneOfType([PropTypes.number, PropTypes.string])]),

  /** Initial value of upward. */
  defaultUpward: PropTypes.bool,

  /** Initial value or value array if multiple. */
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]))]),

  /** A dropdown menu can open to the left or to the right. */
  direction: PropTypes.oneOf(['left', 'right']),

  /** A disabled dropdown menu or item does not allow user interaction. */
  disabled: PropTypes.bool,

  /** An errored dropdown can alert a user to a problem. */
  error: PropTypes.bool,

  /** A dropdown menu can contain floated content. */
  floating: PropTypes.bool,

  /** A dropdown can take the full width of its parent */
  fluid: PropTypes.bool,

  /** A dropdown menu can contain a header. */
  header: PropTypes.node,

  /** Shorthand for Icon. */
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),

  /** A dropdown can be formatted to appear inline in other content. */
  inline: PropTypes.bool,

  /** A dropdown can be formatted as a Menu item. */
  item: PropTypes.bool,

  /** A dropdown can be labeled. */
  labeled: PropTypes.bool,

  /** A dropdown can defer rendering its options until it is open. */
  lazyLoad: PropTypes.bool,

  /** A dropdown can show that it is currently loading data. */
  loading: PropTypes.bool,

  /** The minimum characters for a search to begin showing results. */
  minCharacters: PropTypes.number,

  /** A selection dropdown can allow multiple selections. */
  multiple: PropTypes.bool,

  /** Message to display when there are no results. */
  noResultsMessage: PropTypes.node,

  /**
   * Called when a user adds a new item. Use this to update the options list.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and the new item's value.
   */
  onAddItem: PropTypes.func,

  /**
   * Called on blur.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onBlur: PropTypes.func,

  /**
   * Called when the user attempts to change the value.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed value.
   */
  onChange: PropTypes.func,

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClick: PropTypes.func,

  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: PropTypes.func,

  /**
   * Called on focus.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onFocus: PropTypes.func,

  /**
   * Called when a multi-select label is clicked.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All label props.
   */
  onLabelClick: PropTypes.func,

  /**
   * Called on mousedown.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onMouseDown: PropTypes.func,

  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: PropTypes.func,

  /**
   * Called on search input change.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props, includes current value of searchQuery.
   */
  onSearchChange: PropTypes.func,

  /** Controls whether or not the dropdown menu is displayed. */
  open: PropTypes.bool,

  /** Whether or not the menu should open when the dropdown is focused. */
  openOnFocus: PropTypes.bool,

  /** Array of Dropdown.Item props e.g. `{ text: '', value: '' }` */
  options: customPropTypes.every([customPropTypes.disallow(['children']), PropTypes.arrayOf(PropTypes.shape(DropdownItem.propTypes))]),

  /** Placeholder text. */
  placeholder: PropTypes.string,

  /** A dropdown can be formatted so that its menu is pointing. */
  pointing: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right', 'top', 'top left', 'top right', 'bottom', 'bottom left', 'bottom right'])]),

  /**
   * Mapped over the active items and returns shorthand for the active item Labels.
   * Only applies to `multiple` Dropdowns.
   *
   * @param {object} item - A currently active dropdown item.
   * @param {number} index - The current index.
   * @param {object} defaultLabelProps - The default props for an active item Label.
   * @returns {*} Shorthand for a Label.
   */
  renderLabel: PropTypes.func,

  /** A dropdown can have its menu scroll. */
  scrolling: PropTypes.bool,

  /**
   * A selection dropdown can allow a user to search through a large list of choices.
   * Pass a function here to replace the default search.
   */
  search: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),

  /** A shorthand for a search input. */
  searchInput: PropTypes.oneOfType([PropTypes.array, PropTypes.node, PropTypes.object]),

  /** Current value of searchQuery. Creates a controlled component. */
  searchQuery: PropTypes.string,
  // TODO 'searchInMenu' or 'search='in menu' or ???  How to handle this markup and functionality?

  /** Define whether the highlighted item should be selected on blur. */
  selectOnBlur: PropTypes.bool,

  /**
   * Whether or not to change the value when navigating the menu using arrow keys.
   * Setting to false will require enter or left click to confirm a choice.
   */
  selectOnNavigation: PropTypes.bool,

  /** Currently selected label in multi-select. */
  selectedLabel: customPropTypes.every([customPropTypes.demand(['multiple']), PropTypes.oneOfType([PropTypes.string, PropTypes.number])]),

  /** A dropdown can be used to select between choices in a form. */
  selection: customPropTypes.every([customPropTypes.disallow(['children']), customPropTypes.demand(['options']), PropTypes.bool]),

  /** A simple dropdown can open without Javascript. */
  simple: PropTypes.bool,

  /** A dropdown can receive focus. */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** The text displayed in the dropdown, usually for the active item. */
  text: PropTypes.string,

  /** Custom element to trigger the menu to become visible. Takes place of 'text'. */
  trigger: customPropTypes.every([customPropTypes.disallow(['selection', 'text']), PropTypes.node]),

  /** Current value or value array if multiple. Creates a controlled component. */
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number, PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.bool, PropTypes.string, PropTypes.number]))]),

  /** Controls whether the dropdown will open upward. */
  upward: PropTypes.bool,

  /**
   * A dropdown will go to the last element when ArrowUp is pressed on the first,
   * or go to the first when ArrowDown is pressed on the last( aka infinite selection )
   */
  wrapSelection: PropTypes.bool
} : {};
Dropdown.defaultProps = {
  additionLabel: 'Add ',
  additionPosition: 'top',
  closeOnBlur: true,
  closeOnEscape: true,
  deburr: false,
  icon: 'dropdown',
  minCharacters: 1,
  noResultsMessage: 'No results found.',
  openOnFocus: true,
  renderLabel: renderItemContent,
  searchInput: 'text',
  selectOnBlur: true,
  selectOnNavigation: true,
  wrapSelection: true
};
Dropdown.autoControlledProps = ['open', 'searchQuery', 'selectedLabel', 'value', 'upward'];
Dropdown.Divider = __WEBPACK_IMPORTED_MODULE_34__DropdownDivider__["a" /* default */];
Dropdown.Header = __WEBPACK_IMPORTED_MODULE_36__DropdownHeader__["a" /* default */];
Dropdown.Item = __WEBPACK_IMPORTED_MODULE_35__DropdownItem__["a" /* default */];
Dropdown.Menu = __WEBPACK_IMPORTED_MODULE_37__DropdownMenu__["a" /* default */];
Dropdown.SearchInput = __WEBPACK_IMPORTED_MODULE_38__DropdownSearchInput__["a" /* default */];
Dropdown.Text = __WEBPACK_IMPORTED_MODULE_39__DropdownText__["a" /* default */];

/***/ }),
/* 3299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getSelectedIndex;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_includes__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_find__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_findIndex__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_reduce__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getMenuOptions__ = __webpack_require__(1496);





function getSelectedIndex(config) {
  var additionLabel = config.additionLabel,
      additionPosition = config.additionPosition,
      allowAdditions = config.allowAdditions,
      deburr = config.deburr,
      multiple = config.multiple,
      options = config.options,
      search = config.search,
      searchQuery = config.searchQuery,
      selectedIndex = config.selectedIndex,
      value = config.value;
  var menuOptions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getMenuOptions__["a" /* default */])({
    value: value,
    options: options,
    searchQuery: searchQuery,
    additionLabel: additionLabel,
    additionPosition: additionPosition,
    allowAdditions: allowAdditions,
    deburr: deburr,
    multiple: multiple,
    search: search
  });

  var enabledIndexes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_reduce__["a" /* default */])(menuOptions, function (memo, item, index) {
    if (!item.disabled) memo.push(index);
    return memo;
  }, []);

  var newSelectedIndex; // update the selected index

  if (!selectedIndex || selectedIndex < 0) {
    var firstIndex = enabledIndexes[0]; // Select the currently active item, if none, use the first item.
    // Multiple selects remove active items from the list,
    // their initial selected index should be 0.

    newSelectedIndex = multiple ? firstIndex : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_findIndex__["a" /* default */])(menuOptions, ['value', value]) || enabledIndexes[0];
  } else if (multiple) {
    newSelectedIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_find__["a" /* default */])(enabledIndexes, function (index) {
      return index >= selectedIndex;
    }); // multiple selects remove options from the menu as they are made active
    // keep the selected index within range of the remaining items

    if (selectedIndex >= menuOptions.length - 1) {
      newSelectedIndex = enabledIndexes[enabledIndexes.length - 1];
    }
  } else {
    var activeIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_findIndex__["a" /* default */])(menuOptions, ['value', value]); // regular selects can only have one active item
    // set the selected index to the currently active item


    newSelectedIndex = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_includes__["a" /* default */])(enabledIndexes, activeIndex) ? activeIndex : undefined;
  }

  if (!newSelectedIndex || newSelectedIndex < 0) {
    newSelectedIndex = enabledIndexes[0];
  }

  return newSelectedIndex;
}

/***/ }),
/* 3300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Embed; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__elements_Icon__ = __webpack_require__(95);







/**
 * An embed displays content from other websites like YouTube videos or Google Maps.
 */

var Embed = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Embed, _Component);

  function Embed() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleClick = function (e) {
      var onClick = _this.props.onClick;
      var active = _this.state.active;
      if (onClick) onClick(e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        active: true
      }));
      if (!active) _this.setState({
        active: true
      });
    };

    return _this;
  }

  var _proto = Embed.prototype;

  _proto.getSrc = function getSrc() {
    var _this$props = this.props,
        _this$props$autoplay = _this$props.autoplay,
        autoplay = _this$props$autoplay === void 0 ? true : _this$props$autoplay,
        _this$props$brandedUI = _this$props.brandedUI,
        brandedUI = _this$props$brandedUI === void 0 ? false : _this$props$brandedUI,
        _this$props$color = _this$props.color,
        color = _this$props$color === void 0 ? '#444444' : _this$props$color,
        _this$props$hd = _this$props.hd,
        hd = _this$props$hd === void 0 ? true : _this$props$hd,
        id = _this$props.id,
        source = _this$props.source,
        url = _this$props.url;

    if (source === 'youtube') {
      return ["//www.youtube.com/embed/" + id, '?autohide=true', "&amp;autoplay=" + autoplay, "&amp;color=" + encodeURIComponent(color), "&amp;hq=" + hd, '&amp;jsapi=false', "&amp;modestbranding=" + brandedUI, "&amp;rel=" + (brandedUI ? 0 : 1)].join('');
    }

    if (source === 'vimeo') {
      return ["//player.vimeo.com/video/" + id, '?api=false', "&amp;autoplay=" + autoplay, '&amp;byline=false', "&amp;color=" + encodeURIComponent(color), '&amp;portrait=false', '&amp;title=false'].join('');
    }

    return url;
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        aspectRatio = _this$props2.aspectRatio,
        className = _this$props2.className,
        icon = _this$props2.icon,
        placeholder = _this$props2.placeholder;
    var active = this.state.active;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])('ui', aspectRatio, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["a" /* useKeyOnly */])(active, 'active'), 'embed', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["b" /* getUnhandledProps */])(Embed, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["c" /* getElementType */])(Embed, this.props);
    var iconShorthand = icon !== undefined ? icon : 'video play';
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes,
      onClick: this.handleClick
    }), __WEBPACK_IMPORTED_MODULE_6__elements_Icon__["a" /* default */].create(iconShorthand, {
      autoGenerateKey: false
    }), placeholder && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", {
      className: "placeholder",
      src: placeholder
    }), this.renderEmbed());
  };

  _proto.renderEmbed = function renderEmbed() {
    var _this$props3 = this.props,
        children = _this$props3.children,
        content = _this$props3.content,
        iframe = _this$props3.iframe,
        source = _this$props3.source;
    var active = this.state.active;
    if (!active) return null;
    if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(children)) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: "embed"
    }, children);
    if (!__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(content)) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: "embed"
    }, content);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: "embed"
    }, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__lib__["y" /* createHTMLIframe */])(__WEBPACK_IMPORTED_MODULE_5__lib__["d" /* childrenUtils */].isNil(iframe) ? this.getSrc() : iframe, {
      defaultProps: {
        allowFullScreen: false,
        frameBorder: 0,
        height: '100%',
        scrolling: 'no',
        src: this.getSrc(),
        title: "Embedded content from " + source + ".",
        width: '100%'
      },
      autoGenerateKey: false
    }));
  };

  return Embed;
}(__WEBPACK_IMPORTED_MODULE_5__lib__["q" /* ModernAutoControlledComponent */]);

Embed.handledProps = ["active", "as", "aspectRatio", "autoplay", "brandedUI", "children", "className", "color", "content", "defaultActive", "hd", "icon", "id", "iframe", "onClick", "placeholder", "source", "url"];

Embed.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** An embed can be active. */
  active: PropTypes.bool,

  /** An embed can specify an alternative aspect ratio. */
  aspectRatio: PropTypes.oneOf(['4:3', '16:9', '21:9']),

  /** Setting to true or false will force autoplay. */
  autoplay: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.bool]),

  /** Whether to show networks branded UI like title cards, or after video calls to action. */
  brandedUI: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.bool]),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Specifies a default chrome color with Vimeo or YouTube. */
  color: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.string]),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Initial value of active. */
  defaultActive: PropTypes.bool,

  /** Whether to prefer HD content. */
  hd: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.bool]),

  /** Specifies an icon to use with placeholder content. */
  icon: customPropTypes.itemShorthand,

  /** Specifies an id for source. */
  id: customPropTypes.every([customPropTypes.demand(['source']), PropTypes.string]),

  /** Shorthand for HTML iframe. */
  iframe: customPropTypes.every([customPropTypes.demand(['source']), customPropTypes.itemShorthand]),

  /**
   * Called on click.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed value.
   */
  onClick: PropTypes.func,

  /** A placeholder image for embed. */
  placeholder: PropTypes.string,

  /** Specifies a source to use. */
  source: customPropTypes.every([customPropTypes.disallow(['sourceUrl']), PropTypes.oneOf(['youtube', 'vimeo'])]),

  /** Specifies a url to use for embed. */
  url: customPropTypes.every([customPropTypes.disallow(['source']), PropTypes.string])
} : {};
Embed.autoControlledProps = ['active'];

/***/ }),
/* 3301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Embed__ = __webpack_require__(3300);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Embed__["a"]; });



/***/ }),
/* 3302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isPlainObject__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_pick__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_includes__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_reduce__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_es_isEmpty__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__fluentui_react_component_ref__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shallowequal__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__elements_Icon__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__addons_Portal__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ModalActions__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ModalContent__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ModalDescription__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ModalDimmer__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ModalHeader__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils__ = __webpack_require__(3303);























/**
 * A modal displays content that temporarily blocks interactions with the main view of a site.
 * @see Confirm
 * @see Portal
 */
var Modal = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Modal, _Component);

  function Modal() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.legacy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["t" /* isBrowser */])() && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils__["a" /* isLegacy */])();
    _this.ref = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react__["createRef"])();
    _this.dimmerRef = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react__["createRef"])();
    _this.latestDocumentMouseDownEvent = null;

    _this.getMountNode = function () {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["t" /* isBrowser */])() ? _this.props.mountNode || document.body : null;
    };

    _this.handleActionsOverrides = function (predefinedProps) {
      return {
        onActionClick: function onActionClick(e, actionProps) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash_es_invoke__["a" /* default */])(predefinedProps, 'onActionClick', e, actionProps);

          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash_es_invoke__["a" /* default */])(_this.props, 'onActionClick', e, _this.props);

          _this.handleClose(e);
        }
      };
    };

    _this.handleClose = function (e) {
      _this.setState({
        open: false
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash_es_invoke__["a" /* default */])(_this.props, 'onClose', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        open: false
      }));
    };

    _this.handleDocumentMouseDown = function (e) {
      _this.latestDocumentMouseDownEvent = e;
    };

    _this.handleDocumentClick = function (e) {
      var closeOnDimmerClick = _this.props.closeOnDimmerClick;
      var currentDocumentMouseDownEvent = _this.latestDocumentMouseDownEvent;
      _this.latestDocumentMouseDownEvent = null;
      if (!closeOnDimmerClick || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["u" /* doesNodeContainClick */])(_this.ref.current, currentDocumentMouseDownEvent) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["u" /* doesNodeContainClick */])(_this.ref.current, e)) return;

      _this.setState({
        open: false
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash_es_invoke__["a" /* default */])(_this.props, 'onClose', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        open: false
      }));
    };

    _this.handleIconOverrides = function (predefinedProps) {
      return {
        onClick: function onClick(e) {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash_es_invoke__["a" /* default */])(predefinedProps, 'onClick', e);

          _this.handleClose(e);
        }
      };
    };

    _this.handleOpen = function (e) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash_es_invoke__["a" /* default */])(_this.props, 'onOpen', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        open: true
      }));

      _this.setState({
        open: true
      });
    };

    _this.handlePortalMount = function (e) {
      var eventPool = _this.props.eventPool;

      _this.setState({
        scrolling: false
      });

      _this.setPositionAndClassNames();

      __WEBPACK_IMPORTED_MODULE_13__lib__["s" /* eventStack */].sub('mousedown', _this.handleDocumentMouseDown, {
        pool: eventPool,
        target: _this.dimmerRef.current
      });
      __WEBPACK_IMPORTED_MODULE_13__lib__["s" /* eventStack */].sub('click', _this.handleDocumentClick, {
        pool: eventPool,
        target: _this.dimmerRef.current
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash_es_invoke__["a" /* default */])(_this.props, 'onMount', e, _this.props);
    };

    _this.handlePortalUnmount = function (e) {
      var eventPool = _this.props.eventPool;
      cancelAnimationFrame(_this.animationRequestId);
      __WEBPACK_IMPORTED_MODULE_13__lib__["s" /* eventStack */].unsub('mousedown', _this.handleDocumentMouseDown, {
        pool: eventPool,
        target: _this.dimmerRef.current
      });
      __WEBPACK_IMPORTED_MODULE_13__lib__["s" /* eventStack */].unsub('click', _this.handleDocumentClick, {
        pool: eventPool,
        target: _this.dimmerRef.current
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash_es_invoke__["a" /* default */])(_this.props, 'onUnmount', e, _this.props);
    };

    _this.setPositionAndClassNames = function () {
      var centered = _this.props.centered;
      var scrolling;
      var newState = {};

      if (_this.ref.current) {
        var rect = _this.ref.current.getBoundingClientRect();

        var isFitted = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils__["b" /* canFit */])(rect);
        scrolling = !isFitted; // Styles should be computed for IE11

        var legacyStyles = _this.legacy ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_21__utils__["c" /* getLegacyStyles */])(isFitted, centered, rect) : {};

        if (!__WEBPACK_IMPORTED_MODULE_12_shallowequal___default()(_this.state.legacyStyles, legacyStyles)) {
          newState.legacyStyles = legacyStyles;
        }

        if (_this.state.scrolling !== scrolling) {
          newState.scrolling = scrolling;
        }
      }

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isEmpty__["a" /* default */])(newState)) _this.setState(newState);
      _this.animationRequestId = requestAnimationFrame(_this.setPositionAndClassNames);
    };

    _this.renderContent = function (rest) {
      var _this$props = _this.props,
          actions = _this$props.actions,
          basic = _this$props.basic,
          children = _this$props.children,
          className = _this$props.className,
          closeIcon = _this$props.closeIcon,
          content = _this$props.content,
          header = _this$props.header,
          size = _this$props.size,
          style = _this$props.style;
      var _this$state = _this.state,
          legacyStyles = _this$state.legacyStyles,
          scrolling = _this$state.scrolling;
      var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_clsx__["a" /* default */])('ui', size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(basic, 'basic'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(_this.legacy, 'legacy'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["a" /* useKeyOnly */])(scrolling, 'scrolling'), 'modal transition visible active', className);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["c" /* getElementType */])(Modal, _this.props);
      var closeIconName = closeIcon === true ? 'close' : closeIcon;
      var closeIconJSX = __WEBPACK_IMPORTED_MODULE_14__elements_Icon__["a" /* default */].create(closeIconName, {
        overrideProps: _this.handleIconOverrides
      });
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__fluentui_react_component_ref__["a" /* Ref */], {
        innerRef: _this.ref
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
        className: classes,
        style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, legacyStyles, style)
      }), closeIconJSX, __WEBPACK_IMPORTED_MODULE_13__lib__["d" /* childrenUtils */].isNil(children) ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_20__ModalHeader__["a" /* default */].create(header, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_17__ModalContent__["a" /* default */].create(content, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_16__ModalActions__["a" /* default */].create(actions, {
        overrideProps: _this.handleActionsOverrides
      })) : children));
    };

    return _this;
  }

  var _proto = Modal.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.handlePortalUnmount();
  } // Do not access document when server side rendering
  ;

  _proto.render = function render() {
    var _this$props2 = this.props,
        centered = _this$props2.centered,
        closeOnDocumentClick = _this$props2.closeOnDocumentClick,
        dimmer = _this$props2.dimmer,
        eventPool = _this$props2.eventPool,
        trigger = _this$props2.trigger;
    var _this$state2 = this.state,
        open = _this$state2.open,
        scrolling = _this$state2.scrolling;
    var mountNode = this.getMountNode(); // Short circuit when server side rendering

    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["t" /* isBrowser */])()) {
      return /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_react__["isValidElement"])(trigger) ? trigger : null;
    }

    var unhandled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13__lib__["b" /* getUnhandledProps */])(Modal, this.props);
    var portalPropNames = __WEBPACK_IMPORTED_MODULE_15__addons_Portal__["a" /* default */].handledProps;

    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_reduce__["a" /* default */])(unhandled, function (acc, val, key) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_includes__["a" /* default */])(portalPropNames, key)) acc[key] = val;
      return acc;
    }, {});

    var portalProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_pick__["a" /* default */])(unhandled, portalPropNames); // Heads up!
    //
    // The SUI CSS selector to prevent the modal itself from blurring requires an immediate .dimmer child:
    // .blurring.dimmed.dimmable>:not(.dimmer) { ... }
    //
    // The .blurring.dimmed.dimmable is the body, so that all body content inside is blurred.
    // We need the immediate child to be the dimmer to :not() blur the modal itself!
    // Otherwise, the portal div is also blurred, blurring the modal.
    //
    // We cannot them wrap the modalJSX in an actual <Dimmer /> instead, we apply the dimmer classes to the <Portal />.


    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__addons_Portal__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      closeOnDocumentClick: closeOnDocumentClick
    }, portalProps, {
      trigger: trigger,
      eventPool: eventPool,
      mountNode: mountNode,
      open: open,
      onClose: this.handleClose,
      onMount: this.handlePortalMount,
      onOpen: this.handleOpen,
      onUnmount: this.handlePortalUnmount
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_11_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__fluentui_react_component_ref__["a" /* Ref */], {
      innerRef: this.dimmerRef
    }, __WEBPACK_IMPORTED_MODULE_19__ModalDimmer__["a" /* default */].create(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isPlainObject__["a" /* default */])(dimmer) ? dimmer : {}, {
      autoGenerateKey: false,
      defaultProps: {
        blurring: dimmer === 'blurring',
        inverted: dimmer === 'inverted'
      },
      overrideProps: {
        children: this.renderContent(rest),
        centered: centered,
        mountNode: mountNode,
        scrolling: scrolling
      }
    })));
  };

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_13__lib__["q" /* ModernAutoControlledComponent */]);

Modal.handledProps = ["actions", "as", "basic", "centered", "children", "className", "closeIcon", "closeOnDimmerClick", "closeOnDocumentClick", "content", "defaultOpen", "dimmer", "eventPool", "header", "mountNode", "onActionClick", "onClose", "onMount", "onOpen", "onUnmount", "open", "size", "style", "trigger"];
Modal.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Shorthand for Modal.Actions. Typically an array of button shorthand. */
  actions: customPropTypes.itemShorthand,

  /** A modal can reduce its complexity */
  basic: PropTypes.bool,

  /** A modal can be vertically centered in the viewport */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for the close icon. Closes the modal on click. */
  closeIcon: PropTypes.oneOfType([PropTypes.node, PropTypes.object, PropTypes.bool]),

  /** Whether or not the Modal should close when the dimmer is clicked. */
  closeOnDimmerClick: PropTypes.bool,

  /** Whether or not the Modal should close when the document is clicked. */
  closeOnDocumentClick: PropTypes.bool,

  /** Simple text content for the Modal. */
  content: customPropTypes.itemShorthand,

  /** Initial value of open. */
  defaultOpen: PropTypes.bool,

  /** A Modal can appear in a dimmer. */
  dimmer: PropTypes.oneOfType([PropTypes.bool, PropTypes.func, PropTypes.object, PropTypes.oneOf(['inverted', 'blurring'])]),

  /** Event pool namespace that is used to handle component events */
  eventPool: PropTypes.string,

  /** Modal displayed above the content in bold. */
  header: customPropTypes.itemShorthand,

  /** The node where the modal should mount. Defaults to document.body. */
  mountNode: PropTypes.any,

  /**
   * Action onClick handler when using shorthand `actions`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onActionClick: PropTypes.func,

  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: PropTypes.func,

  /**
   * Called when the modal is mounted on the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: PropTypes.func,

  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: PropTypes.func,

  /**
   * Called when the modal is unmounted from the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: PropTypes.func,

  /** Controls whether or not the Modal is displayed. */
  open: PropTypes.bool,

  /** A modal can vary in size */
  size: PropTypes.oneOf(['mini', 'tiny', 'small', 'large', 'fullscreen']),

  /** Custom styles. */
  style: PropTypes.object,

  /** Element to be rendered in-place where the modal is defined. */
  trigger: PropTypes.node
  /**
   * NOTE: Any unhandled props that are defined in Modal are passed-through
   * to the inner Portal.
   */

} : {};
Modal.defaultProps = {
  centered: true,
  dimmer: true,
  closeOnDimmerClick: true,
  closeOnDocumentClick: false,
  eventPool: 'Modal'
};
Modal.autoControlledProps = ['open'];
Modal.Actions = __WEBPACK_IMPORTED_MODULE_16__ModalActions__["a" /* default */];
Modal.Content = __WEBPACK_IMPORTED_MODULE_17__ModalContent__["a" /* default */];
Modal.Description = __WEBPACK_IMPORTED_MODULE_18__ModalDescription__["a" /* default */];
Modal.Dimmer = __WEBPACK_IMPORTED_MODULE_19__ModalDimmer__["a" /* default */];
Modal.Header = __WEBPACK_IMPORTED_MODULE_20__ModalHeader__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 3303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return canFit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getLegacyStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isLegacy; });
// https://github.com/Semantic-Org/Semantic-UI/blob/2.4.1/src/definitions/modules/modal.js#L956
var OFFSET = 0; // https://github.com/Semantic-Org/Semantic-UI/blob/2.4.1/src/definitions/modules/modal.js#L990

var PADDING = 50;
/**
 * Ensures that modal can fit viewport without scroll.
 *
 * @param modalRect {DOMRect}
 *
 * @see https://github.com/Semantic-Org/Semantic-UI/blob/2.4.1/src/definitions/modules/modal.js#L608
 */

var canFit = function canFit(modalRect) {
  // original: scrollHeight = $module.prop('scrollHeight'),
  // is replaced by .height because scrollHeight provides integer which produces glitches
  // https://github.com/Semantic-Org/Semantic-UI-React/issues/2221
  var scrollHeight = modalRect.height + OFFSET; // $module.outerHeight() + settings.offset

  var height = modalRect.height + OFFSET; // original: $(window).height()

  var contextHeight = window.innerHeight;
  var verticalCenter = contextHeight / 2;
  var topOffset = -(height / 2); // padding with edge of page

  var paddingHeight = PADDING;
  var startPosition = verticalCenter + topOffset; // 0
  // original: scrollHeight > height
  //     ? startPosition + scrollHeight + paddingHeight < contextHeight
  //     : height + paddingHeight * 2 < contextHeight

  return startPosition + scrollHeight + paddingHeight < contextHeight;
};
/**
 * Creates legacy styles for IE11.
 *
 * @param isFitted {Boolean}
 * @param centered {Boolean}
 * @param modalRect {DOMRect}
 *
 * @see https://github.com/Semantic-Org/Semantic-UI/blob/2.4.1/src/definitions/modules/modal.js#L718
 */

var getLegacyStyles = function getLegacyStyles(isFitted, centered, modalRect) {
  var marginTop = centered && isFitted ? -(modalRect.height / 2) : 0;
  var marginLeft = -(modalRect.width / 2);
  return {
    marginLeft: marginLeft,
    marginTop: marginTop
  };
}; // https://github.com/Semantic-Org/Semantic-UI/blob/2.4.1/src/definitions/modules/modal.js#L631

/* istanbul ignore next */

var isLegacy = function isLegacy() {
  return !window.ActiveXObject && 'ActiveXObject' in window;
};

/***/ }),
/* 3304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Popup; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_isUndefined__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_es_isElement__ = __webpack_require__(3464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_es_isArray__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_es_pick__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_es_includes__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_es_reduce__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__semantic_ui_react_event_stack__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__semantic_ui_react_event_stack___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__semantic_ui_react_event_stack__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_popper__ = __webpack_require__(3191);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shallowequal__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__addons_Portal__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__lib_positions__ = __webpack_require__(3307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__lib_createReferenceProxy__ = __webpack_require__(3306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__PopupContent__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__PopupHeader__ = __webpack_require__(1504);
























/**
 * A Popup displays additional information on top of a page.
 */
var Popup = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Popup, _Component);

  function Popup() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {};
    _this.open = false;
    _this.zIndexWasSynced = false;
    _this.triggerRef = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createRef();
    _this.elementRef = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createRef();

    _this.getPortalProps = function () {
      var portalProps = {};
      var _this$props = _this.props,
          on = _this$props.on,
          hoverable = _this$props.hoverable;
      var normalizedOn = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash_es_isArray__["a" /* default */])(on) ? on : [on];

      if (hoverable) {
        portalProps.closeOnPortalMouseLeave = true;
        portalProps.mouseLeaveDelay = 300;
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash_es_includes__["a" /* default */])(normalizedOn, 'hover')) {
        portalProps.openOnTriggerClick = false;
        portalProps.closeOnTriggerClick = false;
        portalProps.openOnTriggerMouseEnter = true;
        portalProps.closeOnTriggerMouseLeave = true; // Taken from SUI: https://git.io/vPmCm

        portalProps.mouseLeaveDelay = 70;
        portalProps.mouseEnterDelay = 50;
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash_es_includes__["a" /* default */])(normalizedOn, 'click')) {
        portalProps.openOnTriggerClick = true;
        portalProps.closeOnTriggerClick = true;
        portalProps.closeOnDocumentClick = true;
      }

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash_es_includes__["a" /* default */])(normalizedOn, 'focus')) {
        portalProps.openOnTriggerFocus = true;
        portalProps.closeOnTriggerBlur = true;
      }

      return portalProps;
    };

    _this.hideOnScroll = function (e) {
      // Do not hide the popup when scroll comes from inside the popup
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/4305
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash_es_isElement__["a" /* default */])(e.target) && _this.elementRef.current.contains(e.target)) {
        return;
      }

      _this.setState({
        closed: true
      });

      __WEBPACK_IMPORTED_MODULE_17__lib__["s" /* eventStack */].unsub('scroll', _this.hideOnScroll, {
        target: window
      });
      _this.timeoutId = setTimeout(function () {
        _this.setState({
          closed: false
        });
      }, 50);

      _this.handleClose(e);
    };

    _this.handleClose = function (e) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_invoke__["a" /* default */])(_this.props, 'onClose', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        open: false
      }));
    };

    _this.handleOpen = function (e) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_invoke__["a" /* default */])(_this.props, 'onOpen', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        open: true
      }));
    };

    _this.handlePortalMount = function (e) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_invoke__["a" /* default */])(_this.props, 'onMount', e, _this.props);
    };

    _this.handlePortalUnmount = function (e) {
      _this.positionUpdate = null;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_invoke__["a" /* default */])(_this.props, 'onUnmount', e, _this.props);
    };

    _this.renderContent = function (_ref) {
      var popperPlacement = _ref.placement,
          popperRef = _ref.ref,
          update = _ref.update,
          popperStyle = _ref.style;
      var _this$props2 = _this.props,
          basic = _this$props2.basic,
          children = _this$props2.children,
          className = _this$props2.className,
          content = _this$props2.content,
          hideOnScroll = _this$props2.hideOnScroll,
          flowing = _this$props2.flowing,
          header = _this$props2.header,
          inverted = _this$props2.inverted,
          popper = _this$props2.popper,
          size = _this$props2.size,
          style = _this$props2.style,
          wide = _this$props2.wide;
      var contentRestProps = _this.state.contentRestProps;
      _this.positionUpdate = update;
      var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_clsx__["a" /* default */])('ui', __WEBPACK_IMPORTED_MODULE_19__lib_positions__["a" /* placementMapping */][popperPlacement], size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib__["h" /* useKeyOrValueAndKey */])(wide, 'wide'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib__["a" /* useKeyOnly */])(basic, 'basic'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib__["a" /* useKeyOnly */])(flowing, 'flowing'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), 'popup transition visible', className);
      var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib__["c" /* getElementType */])(Popup, _this.props);

      var styles = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        // Heads up! We need default styles to get working correctly `flowing`
        left: 'auto',
        right: 'auto',
        // This is required to be properly positioned inside wrapping `div`
        position: 'initial'
      }, style);

      var innerElement = /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, contentRestProps, {
        className: classes,
        style: styles,
        ref: _this.elementRef
      }), __WEBPACK_IMPORTED_MODULE_17__lib__["d" /* childrenUtils */].isNil(children) ? /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_22__PopupHeader__["a" /* default */].create(header, {
        autoGenerateKey: false
      }), __WEBPACK_IMPORTED_MODULE_21__PopupContent__["a" /* default */].create(content, {
        autoGenerateKey: false
      })) : children, hideOnScroll && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__semantic_ui_react_event_stack___default.a, {
        on: _this.hideOnScroll,
        name: "scroll",
        target: "window"
      })); // https://github.com/popperjs/popper-core/blob/f1f9d1ab75b6b0e962f90a5b2a50f6cfd307d794/src/createPopper.js#L136-L137
      // Heads up!
      // A wrapping `div` there is a pure magic, it's required as Popper warns on margins that are
      // defined by SUI CSS. It also means that this `div` will be positioned instead of `content`.

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib__["w" /* createHTMLDivision */])(popper || {}, {
        overrideProps: {
          children: innerElement,
          ref: popperRef,
          style: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
            // Fixes layout for floated elements
            // https://github.com/Semantic-Org/Semantic-UI-React/issues/4092
            display: 'flex'
          }, popperStyle)
        }
      });
    };

    return _this;
  }

  Popup.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (state.closed || state.disabled) return {};
    var unhandledProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_17__lib__["b" /* getUnhandledProps */])(Popup, props);

    var contentRestProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash_es_reduce__["a" /* default */])(unhandledProps, function (acc, val, key) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash_es_includes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_18__addons_Portal__["a" /* default */].handledProps, key)) acc[key] = val;
      return acc;
    }, {});

    var portalRestProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash_es_pick__["a" /* default */])(unhandledProps, __WEBPACK_IMPORTED_MODULE_18__addons_Portal__["a" /* default */].handledProps);

    return {
      contentRestProps: contentRestProps,
      portalRestProps: portalRestProps
    };
  };

  var _proto = Popup.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var depsEqual = __WEBPACK_IMPORTED_MODULE_16_shallowequal___default()(this.props.popperDependencies, prevProps.popperDependencies);

    if (!depsEqual) {
      this.handleUpdate();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeoutId);
  };

  _proto.handleUpdate = function handleUpdate() {
    if (this.positionUpdate) this.positionUpdate();
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        context = _this$props3.context,
        disabled = _this$props3.disabled,
        eventsEnabled = _this$props3.eventsEnabled,
        offset = _this$props3.offset,
        pinned = _this$props3.pinned,
        popper = _this$props3.popper,
        popperModifiers = _this$props3.popperModifiers,
        position = _this$props3.position,
        positionFixed = _this$props3.positionFixed,
        trigger = _this$props3.trigger;
    var _this$state = this.state,
        closed = _this$state.closed,
        portalRestProps = _this$state.portalRestProps;

    if (closed || disabled) {
      return trigger;
    }

    var modifiers = [{
      name: 'arrow',
      enabled: false
    }, {
      name: 'eventListeners',
      options: {
        scroll: !!eventsEnabled,
        resize: !!eventsEnabled
      }
    }, {
      name: 'flip',
      enabled: !pinned
    }, {
      name: 'preventOverflow',
      enabled: !!offset
    }, {
      name: 'offset',
      enabled: !!offset,
      options: {
        offset: offset
      }
    }].concat(popperModifiers, [// We are syncing zIndex from `.ui.popup.content` to avoid layering issues as in SUIR we are using an additional
    // `div` for Popper.js
    // https://github.com/Semantic-Org/Semantic-UI-React/issues/4083
    {
      name: 'syncZIndex',
      enabled: true,
      phase: 'beforeRead',
      fn: function fn(_ref2) {
        var _popper$style;

        var state = _ref2.state;

        if (_this2.zIndexWasSynced) {
          return;
        } // if zIndex defined in <Popup popper={{ style: {} }} /> there is no sense to override it


        var definedZIndex = popper == null ? void 0 : (_popper$style = popper.style) == null ? void 0 : _popper$style.zIndex;

        if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_isUndefined__["a" /* default */])(definedZIndex)) {
          // eslint-disable-next-line no-param-reassign
          state.elements.popper.style.zIndex = window.getComputedStyle(state.elements.popper.firstChild).zIndex;
        }

        _this2.zIndexWasSynced = true;
      },
      effect: function effect() {
        return function () {
          _this2.zIndexWasSynced = false;
        };
      }
    }]);
    var referenceElement = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_20__lib_createReferenceProxy__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_isNil__["a" /* default */])(context) ? this.triggerRef : context);

    var mergedPortalProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.getPortalProps(), portalRestProps);

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__addons_Portal__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, mergedPortalProps, {
      onClose: this.handleClose,
      onMount: this.handlePortalMount,
      onOpen: this.handleOpen,
      onUnmount: this.handlePortalUnmount,
      trigger: trigger,
      triggerRef: this.triggerRef
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_14_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_popper__["a" /* Popper */], {
      modifiers: modifiers,
      placement: __WEBPACK_IMPORTED_MODULE_19__lib_positions__["b" /* positionsMapping */][position],
      strategy: positionFixed ? 'fixed' : null,
      referenceElement: referenceElement
    }, this.renderContent));
  };

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_14_react__["Component"]);

Popup.handledProps = ["as", "basic", "children", "className", "content", "context", "disabled", "eventsEnabled", "flowing", "header", "hideOnScroll", "hoverable", "inverted", "offset", "on", "onClose", "onMount", "onOpen", "onUnmount", "pinned", "popper", "popperDependencies", "popperModifiers", "position", "positionFixed", "size", "style", "trigger", "wide"];

Popup.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Display the popup without the pointing arrow. */
  basic: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Simple text content for the popover. */
  content: customPropTypes.itemShorthand,

  /** Existing element the pop-up should be bound to. */
  context: PropTypes.oneOfType([PropTypes.object, customPropTypes.refObject]),

  /** A disabled popup only renders its trigger. */
  disabled: PropTypes.bool,

  /** Enables the Popper.js event listeners. */
  eventsEnabled: PropTypes.bool,

  /** A flowing Popup has no maximum width and continues to flow to fit its content. */
  flowing: PropTypes.bool,

  /** Takes up the entire width of its offset container. */
  // TODO: implement the Popup fluid layout
  // fluid: PropTypes.bool,

  /** Header displayed above the content in bold. */
  header: customPropTypes.itemShorthand,

  /** Hide the Popup when scrolling the window. */
  hideOnScroll: PropTypes.bool,

  /** Whether the popup should not close on hover. */
  hoverable: PropTypes.bool,

  /** Invert the colors of the Popup. */
  inverted: PropTypes.bool,

  /**
   * Offset values in px unit to apply to rendered popup. The basic offset accepts an
   * array with two numbers in the form [skidding, distance]:
   * - `skidding` displaces the Popup along the reference element
   * - `distance` displaces the Popup away from, or toward, the reference element in the direction of its placement. A positive number displaces it further away, while a negative number lets it overlap the reference.
   *
   * @see https://popper.js.org/docs/v2/modifiers/offset/
   */
  offset: PropTypes.oneOfType([PropTypes.func, PropTypes.arrayOf(PropTypes.number)]),

  /** Events triggering the popup. */
  on: PropTypes.oneOfType([PropTypes.oneOf(['hover', 'click', 'focus']), PropTypes.arrayOf(PropTypes.oneOf(['hover', 'click', 'focus']))]),

  /**
   * Called when a close event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onClose: PropTypes.func,

  /**
   * Called when the portal is mounted on the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onMount: PropTypes.func,

  /**
   * Called when an open event happens.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onOpen: PropTypes.func,

  /**
   * Called when the portal is unmounted from the DOM.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onUnmount: PropTypes.func,

  /** Disables automatic repositioning of the component, it will always be placed according to the position value. */
  pinned: PropTypes.bool,

  /** Position for the popover. */
  position: PropTypes.oneOf(positions),

  /** Tells `Popper.js` to use the `position: fixed` strategy to position the popover. */
  positionFixed: PropTypes.bool,

  /** A wrapping element for an actual content that will be used for positioning. */
  popper: customPropTypes.itemShorthand,

  /** An array containing custom settings for the Popper.js modifiers. */
  popperModifiers: PropTypes.array,

  /** A popup can have dependencies which update will schedule a position update. */
  popperDependencies: PropTypes.array,

  /** Popup size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium', 'big', 'massive')),

  /** Custom Popup style. */
  style: PropTypes.object,

  /** Element to be rendered in-place where the popup is defined. */
  trigger: PropTypes.node,

  /** Popup width. */
  wide: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['very'])])
} : {};
Popup.defaultProps = {
  disabled: false,
  eventsEnabled: true,
  on: ['click', 'hover'],
  pinned: false,
  popperModifiers: [],
  position: 'top left'
};
Popup.Content = __WEBPACK_IMPORTED_MODULE_21__PopupContent__["a" /* default */];
Popup.Header = __WEBPACK_IMPORTED_MODULE_22__PopupHeader__["a" /* default */];

/***/ }),
/* 3305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popup__ = __webpack_require__(3304);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Popup__["a"]; });



/***/ }),
/* 3306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_createClass__ = __webpack_require__(529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_memoize__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fluentui_react_component_ref__ = __webpack_require__(91);





var ReferenceProxy = /*#__PURE__*/function () {
  function ReferenceProxy(refObject) {
    this.ref = refObject;
  }

  var _proto = ReferenceProxy.prototype;

  _proto.getBoundingClientRect = function getBoundingClientRect() {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(this.ref.current, 'getBoundingClientRect') || {};
  };

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_createClass__["a" /* default */])(ReferenceProxy, [{
    key: "clientWidth",
    get: function get() {
      return this.getBoundingClientRect().width;
    }
  }, {
    key: "clientHeight",
    get: function get() {
      return this.getBoundingClientRect().height;
    }
  }, {
    key: "parentNode",
    get: function get() {
      return this.ref.current ? this.ref.current.parentNode : undefined;
    }
  }]);

  return ReferenceProxy;
}();
/**
 * Popper.js does not support ref objects from `createRef()` as referenceElement. If we will pass
 * directly `ref`, `ref.current` will be `null` at the render process. We use memoize to keep the
 * same reference between renders.
 *
 * @see https://popper.js.org/popper-documentation.html#referenceObject
 */


var createReferenceProxy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_memoize__["a" /* default */])(function (reference) {
  return new ReferenceProxy(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fluentui_react_component_ref__["b" /* isRefObject */])(reference) ? reference : {
    current: reference
  });
});

/* harmony default export */ __webpack_exports__["a"] = (createReferenceProxy);

/***/ }),
/* 3307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return positionsMapping; });
/* unused harmony export positions */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return placementMapping; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_invert__ = __webpack_require__(3462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_keys__ = __webpack_require__(150);


var positionsMapping = {
  'top center': 'top',
  'top left': 'top-start',
  'top right': 'top-end',
  'bottom center': 'bottom',
  'bottom left': 'bottom-start',
  'bottom right': 'bottom-end',
  'right center': 'right',
  'left center': 'left'
};
var positions = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_keys__["a" /* default */])(positionsMapping);
var placementMapping = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_invert__["a" /* default */])(positionsMapping);

/***/ }),
/* 3308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_round__ = __webpack_require__(3475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_clamp__ = __webpack_require__(3453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_isUndefined__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__lib__ = __webpack_require__(8);










/**
 * A progress bar shows the progression of a task.
 */

var Progress = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Progress, _Component);

  function Progress() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.calculatePercent = function () {
      var _this$props = _this.props,
          percent = _this$props.percent,
          total = _this$props.total,
          value = _this$props.value;
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isUndefined__["a" /* default */])(percent)) return percent;
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isUndefined__["a" /* default */])(total) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isUndefined__["a" /* default */])(value)) return value / total * 100;
    };

    _this.computeValueText = function (percent) {
      var _this$props2 = _this.props,
          progress = _this$props2.progress,
          total = _this$props2.total,
          value = _this$props2.value;
      if (progress === 'value') return value;
      if (progress === 'ratio') return value + "/" + total;
      return percent + "%";
    };

    _this.getPercent = function () {
      var _this$props3 = _this.props,
          precision = _this$props3.precision,
          progress = _this$props3.progress,
          total = _this$props3.total,
          value = _this$props3.value;

      var percent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_clamp__["a" /* default */])(_this.calculatePercent(), 0, 100);

      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isUndefined__["a" /* default */])(total) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isUndefined__["a" /* default */])(value) && progress === 'value') {
        return value / total * 100;
      }

      if (progress === 'value') return value;
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isUndefined__["a" /* default */])(precision)) return percent;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_round__["a" /* default */])(percent, precision);
    };

    _this.isAutoSuccess = function () {
      var _this$props4 = _this.props,
          autoSuccess = _this$props4.autoSuccess,
          percent = _this$props4.percent,
          total = _this$props4.total,
          value = _this$props4.value;
      return autoSuccess && (percent >= 100 || value >= total);
    };

    _this.renderLabel = function () {
      var _this$props5 = _this.props,
          children = _this$props5.children,
          content = _this$props5.content,
          label = _this$props5.label;
      if (!__WEBPACK_IMPORTED_MODULE_9__lib__["d" /* childrenUtils */].isNil(children)) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
        className: "label"
      }, children);
      if (!__WEBPACK_IMPORTED_MODULE_9__lib__["d" /* childrenUtils */].isNil(content)) return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
        className: "label"
      }, content);
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["w" /* createHTMLDivision */])(label, {
        autoGenerateKey: false,
        defaultProps: {
          className: 'label'
        }
      });
    };

    _this.renderProgress = function (percent) {
      var _this$props6 = _this.props,
          precision = _this$props6.precision,
          progress = _this$props6.progress;
      if (!progress && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_isUndefined__["a" /* default */])(precision)) return;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
        className: "progress"
      }, _this.computeValueText(percent));
    };

    return _this;
  }

  var _proto = Progress.prototype;

  _proto.render = function render() {
    var _this$props7 = this.props,
        active = _this$props7.active,
        attached = _this$props7.attached,
        className = _this$props7.className,
        color = _this$props7.color,
        disabled = _this$props7.disabled,
        error = _this$props7.error,
        indicating = _this$props7.indicating,
        inverted = _this$props7.inverted,
        size = _this$props7.size,
        success = _this$props7.success,
        warning = _this$props7.warning;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])('ui', color, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* useKeyOnly */])(active || indicating, 'active'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* useKeyOnly */])(error, 'error'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* useKeyOnly */])(indicating, 'indicating'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* useKeyOnly */])(inverted, 'inverted'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* useKeyOnly */])(success || this.isAutoSuccess(), 'success'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["a" /* useKeyOnly */])(warning, 'warning'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["g" /* useValueAndKey */])(attached, 'attached'), 'progress', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["b" /* getUnhandledProps */])(Progress, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__lib__["c" /* getElementType */])(Progress, this.props);
    var percent = this.getPercent() || 0;
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes,
      "data-percent": Math.floor(percent)
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div", {
      className: "bar",
      style: {
        width: percent + "%"
      }
    }, this.renderProgress(percent)), this.renderLabel());
  };

  return Progress;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

Progress.handledProps = ["active", "as", "attached", "autoSuccess", "children", "className", "color", "content", "disabled", "error", "indicating", "inverted", "label", "percent", "precision", "progress", "size", "success", "total", "value", "warning"];
Progress.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A progress bar can show activity. */
  active: PropTypes.bool,

  /** A progress bar can attach to and show the progress of an element (i.e. Card or Segment). */
  attached: PropTypes.oneOf(['top', 'bottom']),

  /** Whether success state should automatically trigger when progress completes. */
  autoSuccess: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** A progress bar can have different colors. */
  color: PropTypes.oneOf(SUI.COLORS),

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** A progress bar be disabled. */
  disabled: PropTypes.bool,

  /** A progress bar can show a error state. */
  error: PropTypes.bool,

  /** An indicating progress bar visually indicates the current level of progress of a task. */
  indicating: PropTypes.bool,

  /** A progress bar can have its colors inverted. */
  inverted: PropTypes.bool,

  /** Can be set to either to display progress as percent or ratio. */
  label: customPropTypes.itemShorthand,

  /** Current percent complete. */
  percent: customPropTypes.every([customPropTypes.disallow(['total', 'value']), PropTypes.oneOfType([PropTypes.number, PropTypes.string])]),

  /** Decimal point precision for calculated progress. */
  precision: PropTypes.number,

  /** A progress bar can contain a text value indicating current progress. */
  progress: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['percent', 'ratio', 'value'])]),

  /** A progress bar can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'mini', 'huge', 'massive')),

  /** A progress bar can show a success state. */
  success: PropTypes.bool,

  /** For use with value. Together, these will calculate the percent. Mutually excludes percent. */
  total: customPropTypes.every([customPropTypes.demand(['value']), customPropTypes.disallow(['percent']), PropTypes.oneOfType([PropTypes.number, PropTypes.string])]),

  /** For use with total. Together, these will calculate the percent. Mutually excludes percent. */
  value: customPropTypes.every([customPropTypes.disallow(['percent']), PropTypes.oneOfType([PropTypes.number, PropTypes.string])]),

  /** A progress bar can show a warning state. */
  warning: PropTypes.bool
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Progress);

/***/ }),
/* 3309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Progress__ = __webpack_require__(3308);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Progress__["a"]; });



/***/ }),
/* 3310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Rating; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_times__ = __webpack_require__(3484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__RatingIcon__ = __webpack_require__(1505);










/**
 * A rating indicates user interest in content.
 */

var Rating = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Rating, _Component);

  function Rating() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(_args)) || this;

    _this.handleIconClick = function (e, _ref) {
      var index = _ref.index;
      var _this$props = _this.props,
          clearable = _this$props.clearable,
          disabled = _this$props.disabled,
          maxRating = _this$props.maxRating,
          onRate = _this$props.onRate;
      var rating = _this.state.rating;
      if (disabled) return; // default newRating is the clicked icon
      // allow toggling a binary rating
      // allow clearing ratings

      var newRating = index + 1;

      if (clearable === 'auto' && maxRating === 1) {
        newRating = +!rating;
      } else if (clearable === true && newRating === rating) {
        newRating = 0;
      } // set rating


      _this.setState({
        rating: newRating,
        isSelecting: false
      });

      if (onRate) onRate(e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        rating: newRating
      }));
    };

    _this.handleIconMouseEnter = function (e, _ref2) {
      var index = _ref2.index;
      if (_this.props.disabled) return;

      _this.setState({
        selectedIndex: index,
        isSelecting: true
      });
    };

    _this.handleMouseLeave = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      __WEBPACK_IMPORTED_MODULE_4_lodash_es_invoke__["a" /* default */].apply(void 0, [_this.props, 'onMouseLeave'].concat(args));

      if (_this.props.disabled) return;

      _this.setState({
        selectedIndex: -1,
        isSelecting: false
      });
    };

    return _this;
  }

  var _proto = Rating.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        className = _this$props2.className,
        disabled = _this$props2.disabled,
        icon = _this$props2.icon,
        maxRating = _this$props2.maxRating,
        size = _this$props2.size;
    var _this$state = this.state,
        rating = _this$state.rating,
        selectedIndex = _this$state.selectedIndex,
        isSelecting = _this$state.isSelecting;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])('ui', icon, size, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(disabled, 'disabled'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(isSelecting && !disabled && selectedIndex >= 0, 'selected'), 'rating', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["b" /* getUnhandledProps */])(Rating, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["c" /* getElementType */])(Rating, this.props);
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes,
      role: "radiogroup",
      onMouseLeave: this.handleMouseLeave,
      tabIndex: disabled ? 0 : -1
    }), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_times__["a" /* default */])(maxRating, function (i) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__RatingIcon__["a" /* default */], {
        tabIndex: disabled ? -1 : 0,
        active: rating >= i + 1,
        "aria-checked": rating === i + 1,
        "aria-posinset": i + 1,
        "aria-setsize": maxRating,
        index: i,
        key: i,
        onClick: _this2.handleIconClick,
        onMouseEnter: _this2.handleIconMouseEnter,
        selected: selectedIndex >= i && isSelecting
      });
    }));
  };

  return Rating;
}(__WEBPACK_IMPORTED_MODULE_8__lib__["q" /* ModernAutoControlledComponent */]);

Rating.handledProps = ["as", "className", "clearable", "defaultRating", "disabled", "icon", "maxRating", "onRate", "rating", "size"];

Rating.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Additional classes. */
  className: PropTypes.string,

  /**
   * You can clear the rating by clicking on the current start rating.
   * By default a rating will be only clearable if there is 1 icon.
   * Setting to `true`/`false` will allow or disallow a user to clear their rating.
   */
  clearable: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['auto'])]),

  /** The initial rating value. */
  defaultRating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** You can disable or enable interactive rating.  Makes a read-only rating. */
  disabled: PropTypes.bool,

  /** A rating can use a set of star or heart icons. */
  icon: PropTypes.oneOf(['star', 'heart']),

  /** The total number of icons. */
  maxRating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Called after user selects a new rating.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed rating.
   */
  onRate: PropTypes.func,

  /** The current number of active icons. */
  rating: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** A progress bar can vary in size. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium', 'big'))
} : {};
Rating.autoControlledProps = ['rating'];
Rating.defaultProps = {
  clearable: 'auto',
  maxRating: 1
};
Rating.Icon = __WEBPACK_IMPORTED_MODULE_9__RatingIcon__["a" /* default */];

/***/ }),
/* 3311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rating__ = __webpack_require__(3310);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Rating__["a"]; });



/***/ }),
/* 3312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Search; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_isEmpty__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_partialRight__ = __webpack_require__(3471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_es_inRange__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_es_get__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_es_reduce__ = __webpack_require__(500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_es_isPlainObject__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_es_isUndefined__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_keyboard_key__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_keyboard_key___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_keyboard_key__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shallowequal__ = __webpack_require__(503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_shallowequal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_shallowequal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__elements_Input__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__SearchCategory__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__SearchResult__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__SearchResults__ = __webpack_require__(1508);
























var overrideSearchInputProps = function overrideSearchInputProps(predefinedProps) {
  var input = predefinedProps.input;

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_12_lodash_es_isUndefined__["a" /* default */])(input)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, predefinedProps, {
      input: {
        className: 'prompt'
      }
    });
  }

  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11_lodash_es_isPlainObject__["a" /* default */])(input)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, predefinedProps, {
      input: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, input, {
        className: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_clsx__["a" /* default */])(input.className, 'prompt')
      })
    });
  }

  return predefinedProps;
};
/**
 * A search module allows a user to query for results from a selection of data
 */


var Search = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Search, _Component);

  function Search() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleResultSelect = function (e, result) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash_es_invoke__["a" /* default */])(_this.props, 'onResultSelect', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        result: result
      }));
    };

    _this.handleSelectionChange = function (e) {
      var result = _this.getSelectedResult();

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash_es_invoke__["a" /* default */])(_this.props, 'onSelectionChange', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        result: result
      }));
    };

    _this.closeOnEscape = function (e) {
      if (__WEBPACK_IMPORTED_MODULE_14_keyboard_key___default.a.getCode(e) !== __WEBPACK_IMPORTED_MODULE_14_keyboard_key___default.a.Escape) return;
      e.preventDefault();

      _this.close();
    };

    _this.moveSelectionOnKeyDown = function (e) {
      switch (__WEBPACK_IMPORTED_MODULE_14_keyboard_key___default.a.getCode(e)) {
        case __WEBPACK_IMPORTED_MODULE_14_keyboard_key___default.a.ArrowDown:
          e.preventDefault();

          _this.moveSelectionBy(e, 1);

          break;

        case __WEBPACK_IMPORTED_MODULE_14_keyboard_key___default.a.ArrowUp:
          e.preventDefault();

          _this.moveSelectionBy(e, -1);

          break;

        default:
          break;
      }
    };

    _this.selectItemOnEnter = function (e) {
      if (__WEBPACK_IMPORTED_MODULE_14_keyboard_key___default.a.getCode(e) !== __WEBPACK_IMPORTED_MODULE_14_keyboard_key___default.a.Enter) return;

      var result = _this.getSelectedResult(); // prevent selecting null if there was no selected item value


      if (!result) return;
      e.preventDefault(); // notify the onResultSelect prop that the user is trying to change value

      _this.setValue(result.title);

      _this.handleResultSelect(e, result);

      _this.close();
    };

    _this.closeOnDocumentClick = function (e) {
      _this.close();
    };

    _this.handleMouseDown = function (e) {
      _this.isMouseDown = true;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash_es_invoke__["a" /* default */])(_this.props, 'onMouseDown', e, _this.props);

      __WEBPACK_IMPORTED_MODULE_18__lib__["s" /* eventStack */].sub('mouseup', _this.handleDocumentMouseUp);
    };

    _this.handleDocumentMouseUp = function () {
      _this.isMouseDown = false;
      __WEBPACK_IMPORTED_MODULE_18__lib__["s" /* eventStack */].unsub('mouseup', _this.handleDocumentMouseUp);
    };

    _this.handleInputClick = function (e) {
      // prevent closeOnDocumentClick()
      e.nativeEvent.stopImmediatePropagation();

      _this.tryOpen();
    };

    _this.handleItemClick = function (e, _ref) {
      var id = _ref.id;

      var result = _this.getSelectedResult(id); // prevent closeOnDocumentClick()


      e.nativeEvent.stopImmediatePropagation(); // notify the onResultSelect prop that the user is trying to change value

      _this.setValue(result.title);

      _this.handleResultSelect(e, result);

      _this.close();
    };

    _this.handleItemMouseDown = function (e) {
      // Heads up! We should prevent default to prevent blur events.
      // https://github.com/Semantic-Org/Semantic-UI-React/issues/3298
      e.preventDefault();
    };

    _this.handleFocus = function (e) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash_es_invoke__["a" /* default */])(_this.props, 'onFocus', e, _this.props);

      _this.setState({
        focus: true
      });
    };

    _this.handleBlur = function (e) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash_es_invoke__["a" /* default */])(_this.props, 'onBlur', e, _this.props);

      _this.setState({
        focus: false
      });
    };

    _this.handleSearchChange = function (e) {
      // prevent propagating to this.props.onChange()
      e.stopPropagation();
      var minCharacters = _this.props.minCharacters;
      var open = _this.state.open;
      var newQuery = e.target.value;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10_lodash_es_invoke__["a" /* default */])(_this.props, 'onSearchChange', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        value: newQuery
      })); // open search dropdown on search query


      if (newQuery.length < minCharacters) {
        _this.close();
      } else if (!open) {
        _this.tryOpen(newQuery);
      }

      _this.setValue(newQuery);
    };

    _this.getFlattenedResults = function () {
      var _this$props = _this.props,
          category = _this$props.category,
          results = _this$props.results;
      return !category ? results : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_lodash_es_reduce__["a" /* default */])(results, function (memo, categoryData) {
        return memo.concat(categoryData.results);
      }, []);
    };

    _this.getSelectedResult = function (index) {
      if (index === void 0) {
        index = _this.state.selectedIndex;
      }

      var results = _this.getFlattenedResults();

      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8_lodash_es_get__["a" /* default */])(results, index);
    };

    _this.setValue = function (value) {
      var selectFirstResult = _this.props.selectFirstResult;

      _this.setState({
        value: value,
        selectedIndex: selectFirstResult ? 0 : -1
      });
    };

    _this.moveSelectionBy = function (e, offset) {
      var selectedIndex = _this.state.selectedIndex;

      var results = _this.getFlattenedResults();

      var lastIndex = results.length - 1; // next is after last, wrap to beginning
      // next is before first, wrap to end

      var nextIndex = selectedIndex + offset;
      if (nextIndex > lastIndex) nextIndex = 0;else if (nextIndex < 0) nextIndex = lastIndex;

      _this.setState({
        selectedIndex: nextIndex
      });

      _this.scrollSelectedItemIntoView();

      _this.handleSelectionChange(e);
    };

    _this.scrollSelectedItemIntoView = function () {
      // Do not access document when server side rendering
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["t" /* isBrowser */])()) return;
      var menu = document.querySelector('.ui.search.active.visible .results.visible');
      if (!menu) return;
      var item = menu.querySelector('.result.active');
      if (!item) return;
      var isOutOfUpperView = item.offsetTop < menu.scrollTop;
      var isOutOfLowerView = item.offsetTop + item.clientHeight > menu.scrollTop + menu.clientHeight;

      if (isOutOfUpperView) {
        menu.scrollTop = item.offsetTop;
      } else if (isOutOfLowerView) {
        menu.scrollTop = item.offsetTop + item.clientHeight - menu.clientHeight;
      }
    };

    _this.tryOpen = function (currentValue) {
      if (currentValue === void 0) {
        currentValue = _this.state.value;
      }

      var minCharacters = _this.props.minCharacters;
      if (currentValue.length < minCharacters) return;

      _this.open();
    };

    _this.open = function () {
      _this.setState({
        open: true
      });
    };

    _this.close = function () {
      _this.setState({
        open: false
      });
    };

    _this.renderSearchInput = function (rest) {
      var _this$props2 = _this.props,
          icon = _this$props2.icon,
          input = _this$props2.input,
          placeholder = _this$props2.placeholder;
      var value = _this.state.value;
      return __WEBPACK_IMPORTED_MODULE_19__elements_Input__["a" /* default */].create(input, {
        autoGenerateKey: false,
        defaultProps: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
          autoComplete: 'off',
          icon: icon,
          onChange: _this.handleSearchChange,
          onClick: _this.handleInputClick,
          tabIndex: '0',
          value: value,
          placeholder: placeholder
        }),
        // Nested shorthand props need special treatment to survive the shallow merge
        overrideProps: overrideSearchInputProps
      });
    };

    _this.renderNoResults = function () {
      var _this$props3 = _this.props,
          noResultsDescription = _this$props3.noResultsDescription,
          noResultsMessage = _this$props3.noResultsMessage;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div", {
        className: "message empty"
      }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div", {
        className: "header"
      }, noResultsMessage), noResultsDescription && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div", {
        className: "description"
      }, noResultsDescription));
    };

    _this.renderResult = function (_ref2, index, _array, offset) {
      var childKey = _ref2.childKey,
          result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["childKey"]);

      if (offset === void 0) {
        offset = 0;
      }

      var resultRenderer = _this.props.resultRenderer;
      var selectedIndex = _this.state.selectedIndex;
      var offsetIndex = index + offset;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__SearchResult__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
        key: childKey != null ? childKey : result.id || result.title,
        active: selectedIndex === offsetIndex,
        onClick: _this.handleItemClick,
        onMouseDown: _this.handleItemMouseDown,
        renderer: resultRenderer
      }, result, {
        id: offsetIndex // Used to lookup the result on item click

      }));
    };

    _this.renderResults = function () {
      var results = _this.props.results;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash_es_map__["a" /* default */])(results, _this.renderResult);
    };

    _this.renderCategories = function () {
      var _this$props4 = _this.props,
          categoryLayoutRenderer = _this$props4.categoryLayoutRenderer,
          categoryRenderer = _this$props4.categoryRenderer,
          categories = _this$props4.results;
      var selectedIndex = _this.state.selectedIndex;
      var count = 0;
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_lodash_es_map__["a" /* default */])(categories, function (_ref3) {
        var childKey = _ref3.childKey,
            category = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["childKey"]);

        var categoryProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
          key: childKey != null ? childKey : category.name,
          active: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_lodash_es_inRange__["a" /* default */])(selectedIndex, count, count + category.results.length),
          layoutRenderer: categoryLayoutRenderer,
          renderer: categoryRenderer
        }, category);

        var renderFn = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_partialRight__["a" /* default */])(_this.renderResult, count);

        count += category.results.length;
        return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__SearchCategory__["a" /* default */], categoryProps, category.results.map(renderFn));
      });
    };

    _this.renderMenuContent = function () {
      var _this$props5 = _this.props,
          category = _this$props5.category,
          showNoResults = _this$props5.showNoResults,
          results = _this$props5.results;

      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_isEmpty__["a" /* default */])(results)) {
        return showNoResults ? _this.renderNoResults() : null;
      }

      return category ? _this.renderCategories() : _this.renderResults();
    };

    _this.renderResultsMenu = function () {
      var open = _this.state.open;
      var resultsClasses = open ? 'visible' : '';

      var menuContent = _this.renderMenuContent();

      if (!menuContent) return;
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__SearchResults__["a" /* default */], {
        className: resultsClasses
      }, menuContent);
    };

    return _this;
  }

  Search.getAutoControlledStateFromProps = function getAutoControlledStateFromProps(props, state) {
    // We need to store a `prevValue` to compare as in `getDerivedStateFromProps` we don't have
    // prevState
    if (typeof state.prevValue !== 'undefined' && __WEBPACK_IMPORTED_MODULE_17_shallowequal___default()(state.prevValue, state.value)) {
      return {
        prevValue: state.value
      };
    }

    var selectedIndex = props.selectFirstResult ? 0 : -1;
    return {
      prevValue: state.value,
      selectedIndex: selectedIndex
    };
  };

  var _proto = Search.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
    return !__WEBPACK_IMPORTED_MODULE_17_shallowequal___default()(nextProps, this.props) || !__WEBPACK_IMPORTED_MODULE_17_shallowequal___default()(nextState, this.state);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    // eslint-disable-line complexity
    // focused / blurred
    if (!prevState.focus && this.state.focus) {
      if (!this.isMouseDown) {
        this.tryOpen();
      }

      if (this.state.open) {
        __WEBPACK_IMPORTED_MODULE_18__lib__["s" /* eventStack */].sub('keydown', [this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
      }
    } else if (prevState.focus && !this.state.focus) {
      if (!this.isMouseDown) {
        this.close();
      }

      __WEBPACK_IMPORTED_MODULE_18__lib__["s" /* eventStack */].unsub('keydown', [this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
    } // opened / closed


    if (!prevState.open && this.state.open) {
      this.open();
      __WEBPACK_IMPORTED_MODULE_18__lib__["s" /* eventStack */].sub('click', this.closeOnDocumentClick);
      __WEBPACK_IMPORTED_MODULE_18__lib__["s" /* eventStack */].sub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
    } else if (prevState.open && !this.state.open) {
      this.close();
      __WEBPACK_IMPORTED_MODULE_18__lib__["s" /* eventStack */].unsub('click', this.closeOnDocumentClick);
      __WEBPACK_IMPORTED_MODULE_18__lib__["s" /* eventStack */].unsub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_18__lib__["s" /* eventStack */].unsub('click', this.closeOnDocumentClick);
    __WEBPACK_IMPORTED_MODULE_18__lib__["s" /* eventStack */].unsub('keydown', [this.closeOnEscape, this.moveSelectionOnKeyDown, this.selectItemOnEnter]);
  } // ----------------------------------------
  // Document Event Handlers
  // ----------------------------------------
  ;

  _proto.render = function render() {
    var _this$state = this.state,
        searchClasses = _this$state.searchClasses,
        focus = _this$state.focus,
        open = _this$state.open;
    var _this$props6 = this.props,
        aligned = _this$props6.aligned,
        category = _this$props6.category,
        className = _this$props6.className,
        fluid = _this$props6.fluid,
        loading = _this$props6.loading,
        size = _this$props6.size; // Classes

    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_13_clsx__["a" /* default */])('ui', open && 'active visible', size, searchClasses, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(category, 'category'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(focus, 'focus'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(fluid, 'fluid'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["a" /* useKeyOnly */])(loading, 'loading'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["g" /* useValueAndKey */])(aligned, 'aligned'), 'search', className);
    var unhandled = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["b" /* getUnhandledProps */])(Search, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["c" /* getElementType */])(Search, this.props);

    var _partitionHTMLProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_18__lib__["l" /* partitionHTMLProps */])(unhandled, {
      htmlProps: __WEBPACK_IMPORTED_MODULE_18__lib__["v" /* htmlInputAttrs */]
    }),
        htmlInputProps = _partitionHTMLProps[0],
        rest = _partitionHTMLProps[1];

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      onMouseDown: this.handleMouseDown
    }), this.renderSearchInput(htmlInputProps), this.renderResultsMenu());
  };

  return Search;
}(__WEBPACK_IMPORTED_MODULE_18__lib__["q" /* ModernAutoControlledComponent */]);

Search.handledProps = ["aligned", "as", "category", "categoryLayoutRenderer", "categoryRenderer", "className", "defaultOpen", "defaultValue", "fluid", "icon", "input", "loading", "minCharacters", "noResultsDescription", "noResultsMessage", "onBlur", "onFocus", "onMouseDown", "onResultSelect", "onSearchChange", "onSelectionChange", "open", "placeholder", "resultRenderer", "results", "selectFirstResult", "showNoResults", "size", "value"];

Search.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,
  // ------------------------------------
  // Behavior
  // ------------------------------------

  /** Initial value of open. */
  defaultOpen: PropTypes.bool,

  /** Initial value. */
  defaultValue: PropTypes.string,

  /** Shorthand for Icon. */
  icon: PropTypes.oneOfType([PropTypes.node, PropTypes.object]),

  /** Minimum characters to query for results */
  minCharacters: PropTypes.number,

  /** Additional text for "No Results" message with less emphasis. */
  noResultsDescription: PropTypes.node,

  /** Message to display when there are no results. */
  noResultsMessage: PropTypes.node,

  /** Controls whether or not the results menu is displayed. */
  open: PropTypes.bool,

  /**
   * One of:
   * - array of Search.Result props e.g. `{ title: '', description: '' }` or
   * - object of categories e.g. `{ name: '', results: [{ title: '', description: '' }]`
   */
  results: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape(SearchResult.propTypes)), PropTypes.shape(SearchCategory.propTypes)]),

  /** Whether the search should automatically select the first result after searching. */
  selectFirstResult: PropTypes.bool,

  /** Whether a "no results" message should be shown if no results are found. */
  showNoResults: PropTypes.bool,

  /** Current value of the search input. Creates a controlled component. */
  value: PropTypes.string,
  // ------------------------------------
  // Rendering
  // ------------------------------------

  /**
   * Renders the SearchCategory layout.
   *
   * @param {object} categoryContent - The Renderable SearchCategory contents.
   * @param {object} resultsContent - The Renderable SearchResult contents.
   * @returns {*} - Renderable SearchCategory layout.
   */
  categoryLayoutRenderer: PropTypes.func,

  /**
   * Renders the SearchCategory contents.
   *
   * @param {object} props - The SearchCategory props object.
   * @returns {*} - Renderable SearchCategory contents.
   */
  categoryRenderer: PropTypes.func,

  /**
   * Renders the SearchResult contents.
   *
   * @param {object} props - The SearchResult props object.
   * @returns {*} - Renderable SearchResult contents.
   */
  resultRenderer: PropTypes.func,
  // ------------------------------------
  // Callbacks
  // ------------------------------------

  /**
   * Called on blur.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onBlur: PropTypes.func,

  /**
   * Called on focus.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onFocus: PropTypes.func,

  /**
   * Called on mousedown.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onMouseDown: PropTypes.func,

  /**
   * Called when a result is selected.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onResultSelect: PropTypes.func,

  /**
   * Called on search input change.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props, includes current value of search input.
   */
  onSearchChange: PropTypes.func,

  /**
   * Called when the active selection index is changed.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onSelectionChange: PropTypes.func,
  // ------------------------------------
  // Style
  // ------------------------------------

  /** A search can have its results aligned to its left or right container edge. */
  aligned: PropTypes.string,

  /** A search can display results from remote content ordered by categories. */
  category: PropTypes.bool,

  /** Additional classes. */
  className: PropTypes.string,

  /** A search can have its results take up the width of its container. */
  fluid: PropTypes.bool,

  /** Shorthand for input element. */
  input: customPropTypes.itemShorthand,

  /** A search can show a loading indicator. */
  loading: PropTypes.bool,

  /** A search can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'medium')),

  /** A search can show placeholder text when empty. */
  placeholder: PropTypes.string
} : {};
Search.defaultProps = {
  icon: 'search',
  input: 'text',
  minCharacters: 1,
  noResultsMessage: 'No results found.',
  showNoResults: true
};
Search.autoControlledProps = ['open', 'value'];
Search.Category = __WEBPACK_IMPORTED_MODULE_20__SearchCategory__["a" /* default */];
Search.Result = __WEBPACK_IMPORTED_MODULE_21__SearchResult__["a" /* default */];
Search.Results = __WEBPACK_IMPORTED_MODULE_22__SearchResults__["a" /* default */];

/***/ }),
/* 3313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



function SearchCategoryLayout(props) {
  var categoryContent = props.categoryContent,
      resultsContent = props.resultsContent;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "name"
  }, categoryContent), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div", {
    className: "results"
  }, resultsContent));
}

SearchCategoryLayout.handledProps = ["categoryContent", "resultsContent"];
SearchCategoryLayout.propTypes =  false ? {
  /** The rendered category content */
  categoryContent: PropTypes.element.isRequired,

  /** The rendered results content */
  resultsContent: PropTypes.element.isRequired
} : {};
/* harmony default export */ __webpack_exports__["a"] = (SearchCategoryLayout);

/***/ }),
/* 3314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Search__ = __webpack_require__(3312);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Search__["a"]; });



/***/ }),
/* 3315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fluentui_react_component_event_listener__ = __webpack_require__(1786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fluentui_react_component_ref__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SidebarPushable__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SidebarPusher__ = __webpack_require__(1510);











/**
 * A sidebar hides additional content beside a page.
 */

var Sidebar = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Sidebar, _Component);

  function Sidebar(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.ref = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7_react__["createRef"])();

    _this.handleAnimationStart = function () {
      var visible = _this.props.visible;
      var callback = visible ? 'onVisible' : 'onHide';
      clearTimeout(_this.animationTimer);
      _this.animationTimer = setTimeout(_this.handleAnimationEnd, Sidebar.animationDuration);

      if (_this.skipNextCallback) {
        _this.skipNextCallback = false;
        return;
      }

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, callback, null, _this.props);
    };

    _this.handleAnimationEnd = function () {
      var visible = _this.props.visible;
      var callback = visible ? 'onShow' : 'onHidden';

      _this.setState({
        animationTick: 0
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, callback, null, _this.props);
    };

    _this.handleDocumentClick = function (e) {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["u" /* doesNodeContainClick */])(_this.ref.current, e)) {
        _this.skipNextCallback = true;

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onHide', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
          visible: false
        }));
      }
    };

    _this.state = {
      animationTick: 0,
      visible: props.visible
    };
    return _this;
  }

  Sidebar.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    // We use `animationTick` to understand when an animation should be scheduled
    var tickIncrement = !!props.visible === !!state.visible ? 0 : 1;
    return {
      animationTick: state.animationTick + tickIncrement,
      visible: props.visible
    };
  };

  var _proto = Sidebar.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.state.animationTick > prevState.animationTick) {
      this.handleAnimationStart();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.animationTimer);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        animation = _this$props.animation,
        className = _this$props.className,
        children = _this$props.children,
        content = _this$props.content,
        direction = _this$props.direction,
        target = _this$props.target,
        visible = _this$props.visible,
        width = _this$props.width;
    var animationTick = this.state.animationTick;
    var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])('ui', animation, direction, width, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(animationTick > 0, 'animating'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["a" /* useKeyOnly */])(visible, 'visible'), 'sidebar', className);
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["b" /* getUnhandledProps */])(Sidebar, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["c" /* getElementType */])(Sidebar, this.props);
    var targetProp = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__fluentui_react_component_ref__["b" /* isRefObject */])(target) ? {
      targetRef: target
    } : {
      target: target
    };
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Fragment, null, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__fluentui_react_component_ref__["a" /* Ref */], {
      innerRef: this.ref
    }, /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), __WEBPACK_IMPORTED_MODULE_8__lib__["d" /* childrenUtils */].isNil(children) ? content : children)), visible && /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__fluentui_react_component_event_listener__["EventListener"], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      listener: this.handleDocumentClick,
      type: "click"
    }, targetProp)));
  };

  return Sidebar;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Sidebar.handledProps = ["animation", "as", "children", "className", "content", "direction", "onHidden", "onHide", "onShow", "onVisible", "target", "visible", "width"];
Sidebar.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Animation style. */
  animation: PropTypes.oneOf(['overlay', 'push', 'scale down', 'uncover', 'slide out', 'slide along']),

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Direction the sidebar should appear on. */
  direction: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * Called before a sidebar begins to animate out.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onHide: PropTypes.func,

  /**
   * Called after a sidebar has finished animating out.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onHidden: PropTypes.func,

  /**
   * Called when a sidebar has finished animating in.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onShow: PropTypes.func,

  /**
   * Called when a sidebar begins animating in.
   *
   * @param {null}
   * @param {object} data - All props.
   */
  onVisible: PropTypes.func,

  /** A sidebar can handle clicks on the passed element. */
  target: PropTypes.oneOfType([customPropTypes.domNode, customPropTypes.refObject]),

  /** Controls whether or not the sidebar is visible on the page. */
  visible: PropTypes.bool,

  /** Sidebar width. */
  width: PropTypes.oneOf(['very thin', 'thin', 'wide', 'very wide'])
} : {};
Sidebar.defaultProps = {
  direction: 'left',
  target: __WEBPACK_IMPORTED_MODULE_3__fluentui_react_component_event_listener__["documentRef"],
  visible: false
};
Sidebar.animationDuration = 500;
Sidebar.autoControlledProps = ['visible'];
Sidebar.Pushable = __WEBPACK_IMPORTED_MODULE_9__SidebarPushable__["a" /* default */];
Sidebar.Pusher = __WEBPACK_IMPORTED_MODULE_10__SidebarPusher__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Sidebar);

/***/ }),
/* 3316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sidebar__ = __webpack_require__(3315);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Sidebar__["a"]; });



/***/ }),
/* 3317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Sticky; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fluentui_react_component_ref__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(8);








/**
 * Sticky content stays fixed to the browser viewport while another column of content is visible on the page.
 */

var Sticky = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Sticky, _Component);

  function Sticky() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      active: true,
      sticky: false
    };
    _this.stickyRef = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["createRef"])();
    _this.triggerRef = /*#__PURE__*/__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6_react__["createRef"])();

    _this.addListeners = function (scrollContext) {
      var scrollContextNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fluentui_react_component_ref__["b" /* isRefObject */])(scrollContext) ? scrollContext.current : scrollContext;

      if (scrollContextNode) {
        __WEBPACK_IMPORTED_MODULE_7__lib__["s" /* eventStack */].sub('resize', _this.handleUpdate, {
          target: scrollContextNode
        });
        __WEBPACK_IMPORTED_MODULE_7__lib__["s" /* eventStack */].sub('scroll', _this.handleUpdate, {
          target: scrollContextNode
        });
      }
    };

    _this.removeListeners = function (scrollContext) {
      var scrollContextNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fluentui_react_component_ref__["b" /* isRefObject */])(scrollContext) ? scrollContext.current : scrollContext;

      if (scrollContextNode) {
        __WEBPACK_IMPORTED_MODULE_7__lib__["s" /* eventStack */].unsub('resize', _this.handleUpdate, {
          target: scrollContextNode
        });
        __WEBPACK_IMPORTED_MODULE_7__lib__["s" /* eventStack */].unsub('scroll', _this.handleUpdate, {
          target: scrollContextNode
        });
      }
    };

    _this.update = function (e) {
      var pushing = _this.state.pushing;
      _this.ticking = false;

      _this.assignRects();

      if (pushing) {
        if (_this.didReachStartingPoint()) return _this.stickToContextTop(e);
        if (_this.didTouchScreenBottom()) return _this.stickToScreenBottom(e);
        return _this.stickToContextBottom(e);
      }

      if (_this.isOversized()) {
        if (_this.contextRect.top > 0) return _this.stickToContextTop(e);
        if (_this.contextRect.bottom < window.innerHeight) return _this.stickToContextBottom(e);
      }

      if (_this.didTouchScreenTop()) {
        if (_this.didReachContextBottom()) return _this.stickToContextBottom(e);
        return _this.stickToScreenTop(e);
      }

      return _this.stickToContextTop(e);
    };

    _this.handleUpdate = function (e) {
      if (!_this.ticking) {
        _this.ticking = true;
        _this.frameId = requestAnimationFrame(function () {
          return _this.update(e);
        });
      }
    };

    _this.assignRects = function () {
      var context = _this.props.context;
      var contextNode = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__fluentui_react_component_ref__["b" /* isRefObject */])(context) ? context.current : context || document.body;
      _this.triggerRect = _this.triggerRef.current.getBoundingClientRect();
      _this.contextRect = contextNode.getBoundingClientRect();
      _this.stickyRect = _this.stickyRef.current.getBoundingClientRect();
    };

    _this.didReachContextBottom = function () {
      var offset = _this.props.offset;
      return _this.stickyRect.height + offset >= _this.contextRect.bottom;
    };

    _this.didReachStartingPoint = function () {
      return _this.stickyRect.top <= _this.triggerRect.top;
    };

    _this.didTouchScreenTop = function () {
      return _this.triggerRect.top < _this.props.offset;
    };

    _this.didTouchScreenBottom = function () {
      var bottomOffset = _this.props.bottomOffset;
      return _this.contextRect.bottom + bottomOffset > window.innerHeight;
    };

    _this.isOversized = function () {
      return _this.stickyRect.height > window.innerHeight;
    };

    _this.pushing = function (pushing) {
      var possible = _this.props.pushing;
      if (possible) _this.setState({
        pushing: pushing
      });
    };

    _this.stick = function (e, bound) {
      _this.setState({
        bound: bound,
        sticky: true
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onStick', e, _this.props);
    };

    _this.unstick = function (e, bound) {
      _this.setState({
        bound: bound,
        sticky: false
      });

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onUnstick', e, _this.props);
    };

    _this.stickToContextBottom = function (e) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onBottom', e, _this.props);

      _this.stick(e, true);

      _this.pushing(true);
    };

    _this.stickToContextTop = function (e) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_invoke__["a" /* default */])(_this.props, 'onTop', e, _this.props);

      _this.unstick(e, false);

      _this.pushing(false);
    };

    _this.stickToScreenBottom = function (e) {
      var bottom = _this.props.bottomOffset;

      _this.stick(e, false);

      _this.setState({
        bottom: bottom,
        top: null
      });
    };

    _this.stickToScreenTop = function (e) {
      var top = _this.props.offset;

      _this.stick(e, false);

      _this.setState({
        top: top,
        bottom: null
      });
    };

    return _this;
  }

  var _proto = Sticky.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["t" /* isBrowser */])()) return;
    var active = this.state.active;

    if (active) {
      this.handleUpdate();
      this.addListeners(this.props.scrollContext);
    }
  };

  Sticky.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (state.active !== props.active && !props.active) {
      return {
        active: props.active,
        sticky: false
      };
    }

    return {
      active: props.active
    };
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevState.active === this.state.active) {
      if (prevProps.scrollContext !== this.props.scrollContext) {
        this.removeListeners(prevProps.scrollContext);
        this.addListeners(this.props.scrollContext);
      }

      return;
    }

    if (this.state.active) {
      this.handleUpdate();
      this.addListeners(this.props.scrollContext);
      return;
    }

    this.removeListeners(prevProps.scrollContext);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["t" /* isBrowser */])()) return;
    var active = this.state.active;

    if (active) {
      this.removeListeners(this.props.scrollContext);
      cancelAnimationFrame(this.frameId);
    }
  } // ----------------------------------------
  // Events
  // ----------------------------------------
  ;

  _proto.computeStyle = function computeStyle() {
    var styleElement = this.props.styleElement;
    var _this$state = this.state,
        bottom = _this$state.bottom,
        bound = _this$state.bound,
        sticky = _this$state.sticky,
        top = _this$state.top;
    if (!sticky) return styleElement;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      bottom: bound ? 0 : bottom,
      top: bound ? undefined : top,
      width: this.triggerRect.width
    }, styleElement);
  } // Return true when the component reached the bottom of the context
  ;

  // ----------------------------------------
  // Render
  // ----------------------------------------
  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className;
    var _this$state2 = this.state,
        bottom = _this$state2.bottom,
        bound = _this$state2.bound,
        sticky = _this$state2.sticky;
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["b" /* getUnhandledProps */])(Sticky, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["c" /* getElementType */])(Sticky, this.props);
    var containerClasses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(sticky && 'ui', sticky && 'stuck-container', sticky && (bound ? 'bound-container' : 'fixed-container'), className);
    var elementClasses = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])('ui', sticky && (bound ? 'bound bottom' : 'fixed'), sticky && !bound && (bottom === null ? 'top' : 'bottom'), 'sticky');
    var triggerStyles = sticky && this.stickyRect ? {
      height: this.stickyRect.height
    } : {};
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: containerClasses
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div", {
      ref: this.triggerRef,
      style: triggerStyles
    }), /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div", {
      className: elementClasses,
      ref: this.stickyRef,
      style: this.computeStyle()
    }, children));
  };

  return Sticky;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

Sticky.handledProps = ["active", "as", "bottomOffset", "children", "className", "context", "offset", "onBottom", "onStick", "onTop", "onUnstick", "pushing", "scrollContext", "styleElement"];

Sticky.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** A Sticky can be active. */
  active: PropTypes.bool,

  /** Offset in pixels from the bottom of the screen when fixing element to viewport. */
  bottomOffset: PropTypes.number,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Context which sticky element should stick to. */
  context: PropTypes.oneOfType([customPropTypes.domNode, customPropTypes.refObject]),

  /** Offset in pixels from the top of the screen when fixing element to viewport. */
  offset: PropTypes.number,

  /**
   * Callback when element is bound to bottom of parent container.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onBottom: PropTypes.func,

  /**
   * Callback when element is fixed to page.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onStick: PropTypes.func,

  /**
   * Callback when element is bound to top of parent container.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onTop: PropTypes.func,

  /**
   * Callback when element is unfixed from page.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props.
   */
  onUnstick: PropTypes.func,

  /** Whether element should be "pushed" by the viewport, attaching to the bottom of the screen when scrolling up. */
  pushing: PropTypes.bool,

  /** Context which sticky should attach onscroll events. */
  scrollContext: PropTypes.oneOfType([customPropTypes.domNode, customPropTypes.refObject]),

  /** Custom style for sticky element. */
  styleElement: PropTypes.object
} : {};
Sticky.defaultProps = {
  active: true,
  bottomOffset: 0,
  offset: 0,
  scrollContext: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["t" /* isBrowser */])() ? window : null
};

/***/ }),
/* 3318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Sticky__ = __webpack_require__(3317);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Sticky__["a"]; });



/***/ }),
/* 3319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_get__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_es_invoke__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__collections_Grid_Grid__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__collections_Grid_GridColumn__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__collections_Menu_Menu__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TabPane__ = __webpack_require__(1511);













/**
 * A Tab is a hidden section of content activated by a Menu.
 * @see Menu
 * @see Segment
 */

var Tab = /*#__PURE__*/function (_Component) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Tab, _Component);

  function Tab() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this.handleItemClick = function (e, _ref) {
      var index = _ref.index;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_invoke__["a" /* default */])(_this.props, 'onTabChange', e, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, _this.props, {
        activeIndex: index
      }));

      _this.setState({
        activeIndex: index
      });
    };

    return _this;
  }

  var _proto = Tab.prototype;

  _proto.getInitialAutoControlledState = function getInitialAutoControlledState() {
    return {
      activeIndex: 0
    };
  };

  _proto.renderItems = function renderItems() {
    var _this$props = this.props,
        panes = _this$props.panes,
        renderActiveOnly = _this$props.renderActiveOnly;
    var activeIndex = this.state.activeIndex;
    if (renderActiveOnly) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5_lodash_es_invoke__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_get__["a" /* default */])(panes, "[" + activeIndex + "]"), 'render', this.props);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_map__["a" /* default */])(panes, function (_ref2, index) {
      var pane = _ref2.pane;
      return __WEBPACK_IMPORTED_MODULE_12__TabPane__["a" /* default */].create(pane, {
        overrideProps: {
          active: index === activeIndex
        }
      });
    });
  };

  _proto.renderMenu = function renderMenu() {
    var _this$props2 = this.props,
        menu = _this$props2.menu,
        panes = _this$props2.panes,
        menuPosition = _this$props2.menuPosition;
    var activeIndex = this.state.activeIndex;

    if (menu.tabular === true && menuPosition === 'right') {
      menu.tabular = 'right';
    }

    return __WEBPACK_IMPORTED_MODULE_11__collections_Menu_Menu__["a" /* default */].create(menu, {
      autoGenerateKey: false,
      overrideProps: {
        items: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_map__["a" /* default */])(panes, 'menuItem'),
        onItemClick: this.handleItemClick,
        activeIndex: activeIndex
      }
    });
  };

  _proto.renderVertical = function renderVertical(menu) {
    var _this$props3 = this.props,
        grid = _this$props3.grid,
        menuPosition = _this$props3.menuPosition;

    var paneWidth = grid.paneWidth,
        tabWidth = grid.tabWidth,
        gridProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(grid, ["paneWidth", "tabWidth"]);

    var position = menuPosition || menu.props.tabular === 'right' && 'right' || 'left';
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__collections_Grid_Grid__["a" /* default */], gridProps, position === 'left' && __WEBPACK_IMPORTED_MODULE_10__collections_Grid_GridColumn__["a" /* default */].create({
      width: tabWidth,
      children: menu
    }, {
      autoGenerateKey: false
    }), __WEBPACK_IMPORTED_MODULE_10__collections_Grid_GridColumn__["a" /* default */].create({
      width: paneWidth,
      children: this.renderItems(),
      stretched: true
    }, {
      autoGenerateKey: false
    }), position === 'right' && __WEBPACK_IMPORTED_MODULE_10__collections_Grid_GridColumn__["a" /* default */].create({
      width: tabWidth,
      children: menu
    }, {
      autoGenerateKey: false
    }));
  };

  _proto.render = function render() {
    var menu = this.renderMenu();
    var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["b" /* getUnhandledProps */])(Tab, this.props);
    var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__lib__["c" /* getElementType */])(Tab, this.props);

    if (menu.props.vertical) {
      return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ElementType, rest, this.renderVertical(menu));
    }

    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(ElementType, rest, menu.props.attached !== 'bottom' && menu, this.renderItems(), menu.props.attached === 'bottom' && menu);
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_8__lib__["q" /* ModernAutoControlledComponent */]);

Tab.handledProps = ["activeIndex", "as", "defaultActiveIndex", "grid", "menu", "menuPosition", "onTabChange", "panes", "renderActiveOnly"];
Tab.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** The initial activeIndex. */
  defaultActiveIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /** Index of the currently active tab. */
  activeIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Shorthand props for the Menu.
   * tabular, if true, will derive final value from `menuPosition`, otherwise set 'left' or 'right' explicitly.
   */
  menu: PropTypes.object,

  /** Align vertical menu */
  menuPosition: PropTypes.oneOf(['left', 'right']),

  /** Shorthand props for the Grid. Only applicable to vertical menus. */
  grid: PropTypes.object,

  /**
   * Called on tab change.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent.
   * @param {object} data - All props and proposed new activeIndex.
   * @param {object} data.activeIndex - The new proposed activeIndex.
   */
  onTabChange: PropTypes.func,

  /**
   * Array of objects describing each Menu.Item and Tab.Pane:
   * { menuItem: 'Home', render: () => <Tab.Pane /> }
   * or
   * { menuItem: 'Home', pane: 'Welcome' }
   */
  panes: PropTypes.arrayOf(PropTypes.shape({
    menuItem: customPropTypes.itemShorthand,
    pane: customPropTypes.itemShorthand,
    render: PropTypes.func
  })),

  /** A Tab can render only active pane. */
  renderActiveOnly: PropTypes.bool
} : {};
Tab.autoControlledProps = ['activeIndex'];
Tab.defaultProps = {
  grid: {
    paneWidth: 12,
    tabWidth: 4
  },
  menu: {
    attached: true,
    tabular: true
  },
  renderActiveOnly: true
};
Tab.Pane = __WEBPACK_IMPORTED_MODULE_12__TabPane__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Tab);

/***/ }),
/* 3320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tab__ = __webpack_require__(3319);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Tab__["a"]; });



/***/ }),
/* 3321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getChildMapping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return mergeChildMappings; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_has__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_keys__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_forEach__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_filter__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_es_keyBy__ = __webpack_require__(3466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);






/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {object} children Element's children
 * @return {object} Mapping of key to child
 */

var getChildMapping = function getChildMapping(children) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_lodash_es_keyBy__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_filter__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_5_react__["Children"].toArray(children), __WEBPACK_IMPORTED_MODULE_5_react__["isValidElement"]), 'key');
};

var getPendingKeys = function getPendingKeys(prev, next) {
  var nextKeysPending = {};
  var pendingKeys = [];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_forEach__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_keys__["a" /* default */])(prev), function (prevKey) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_has__["a" /* default */])(next, prevKey)) {
      pendingKeys.push(prevKey);
      return;
    }

    if (pendingKeys.length) {
      nextKeysPending[prevKey] = pendingKeys;
      pendingKeys = [];
    }
  });

  return [nextKeysPending, pendingKeys];
};

var getValue = function getValue(key, prev, next) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_has__["a" /* default */])(next, key) ? next[key] : prev[key];
};
/**
 * When you're adding or removing children some may be added or removed in the same render pass. We want to show *both*
 * since we want to simultaneously animate elements in and out. This function takes a previous set of keys and a new set
 * of keys and merges them with its best guess of the correct ordering.
 *
 * @param {object} prev Prev children as returned from `getChildMapping()`
 * @param {object} next Next children as returned from `getChildMapping()`
 * @return {object} A key set that contains all keys in `prev` and all keys in `next` in a reasonable order
 */


var mergeChildMappings = function mergeChildMappings(prev, next) {
  if (prev === void 0) {
    prev = {};
  }

  if (next === void 0) {
    next = {};
  }

  var childMapping = {};

  var _getPendingKeys = getPendingKeys(prev, next),
      nextKeysPending = _getPendingKeys[0],
      pendingKeys = _getPendingKeys[1];

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_forEach__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_lodash_es_keys__["a" /* default */])(next), function (nextKey) {
    if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_lodash_es_has__["a" /* default */])(nextKeysPending, nextKey)) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_forEach__["a" /* default */])(nextKeysPending[nextKey], function (pendingKey) {
        childMapping[pendingKey] = getValue(pendingKey, prev, next);
      });
    }

    childMapping[nextKey] = getValue(nextKey, prev, next);
  });

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_lodash_es_forEach__["a" /* default */])(pendingKeys, function (pendingKey) {
    childMapping[pendingKey] = getValue(pendingKey, prev, next);
  });

  return childMapping;
};

/***/ }),
/* 3322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapChild;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Transition__ = __webpack_require__(1512);


/**
 * Wraps a React element with a Transition component.
 *
 * @param {React.ReactElement} child
 * @param {Function} onHide
 * @param {Object} [options={}]
 * @param {String} [options.animation]
 * @param {Number} [options.duration]
 * @param {Boolean} [options.directional]
 * @param {Boolean} [options.transitionOnMount=false]
 * @param {Boolean} [options.visible=true]
 */

function wrapChild(child, onHide, options) {
  if (options === void 0) {
    options = {};
  }

  var key = child.key;
  var _options = options,
      animation = _options.animation,
      directional = _options.directional,
      duration = _options.duration,
      _options$transitionOn = _options.transitionOnMount,
      transitionOnMount = _options$transitionOn === void 0 ? false : _options$transitionOn,
      _options$visible = _options.visible,
      visible = _options$visible === void 0 ? true : _options$visible;
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Transition__["a" /* default */], {
    animation: animation,
    directional: directional,
    duration: duration,
    key: key,
    onHide: onHide,
    reactKey: key,
    transitionOnMount: transitionOnMount,
    visible: visible
  }, child);
}
wrapChild.handledProps = [];

/***/ }),
/* 3323 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);





/**
 * An ad displays third-party promotional content.
 */

function Advertisement(props) {
  var centered = props.centered,
      children = props.children,
      className = props.className,
      content = props.content,
      test = props.test,
      unit = props.unit;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])('ui', unit, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(centered, 'centered'), __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(test, 'test'), 'ad', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Advertisement, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(Advertisement, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes,
    "data-text": test
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

Advertisement.handledProps = ["as", "centered", "children", "className", "content", "test", "unit"];
Advertisement.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Center the advertisement. */
  centered: PropTypes.bool,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,

  /** Text to be displayed on the advertisement. */
  test: PropTypes.oneOfType([PropTypes.bool, PropTypes.number, PropTypes.string]),

  /** Varies the size of the advertisement. */
  unit: PropTypes.oneOf(['medium rectangle', 'large rectangle', 'vertical rectangle', 'small rectangle', 'mobile banner', 'banner', 'vertical banner', 'top banner', 'half banner', 'button', 'square button', 'small button', 'skyscraper', 'wide skyscraper', 'leaderboard', 'large leaderboard', 'mobile leaderboard', 'billboard', 'panorama', 'netboard', 'half page', 'square', 'small square']).isRequired
} : {};
/* harmony default export */ __webpack_exports__["a"] = (Advertisement);

/***/ }),
/* 3324 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Advertisement__ = __webpack_require__(3323);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Advertisement__["a"]; });



/***/ }),
/* 3325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CommentAction__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CommentActions__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CommentAuthor__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CommentAvatar__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CommentContent__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CommentGroup__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CommentMetadata__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CommentText__ = __webpack_require__(1526);













/**
 * A comment displays user feedback to site content.
 */

function Comment(props) {
  var className = props.className,
      children = props.children,
      collapsed = props.collapsed,
      content = props.content;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_clsx__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["a" /* useKeyOnly */])(collapsed, 'collapsed'), 'comment', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["b" /* getUnhandledProps */])(Comment, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__lib__["c" /* getElementType */])(Comment, props);
  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), __WEBPACK_IMPORTED_MODULE_4__lib__["d" /* childrenUtils */].isNil(children) ? content : children);
}

Comment.handledProps = ["as", "children", "className", "collapsed", "content"];
Comment.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Comment can be collapsed, or hidden from view. */
  collapsed: PropTypes.bool,

  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand
} : {};
Comment.Author = __WEBPACK_IMPORTED_MODULE_7__CommentAuthor__["a" /* default */];
Comment.Action = __WEBPACK_IMPORTED_MODULE_5__CommentAction__["a" /* default */];
Comment.Actions = __WEBPACK_IMPORTED_MODULE_6__CommentActions__["a" /* default */];
Comment.Avatar = __WEBPACK_IMPORTED_MODULE_8__CommentAvatar__["a" /* default */];
Comment.Content = __WEBPACK_IMPORTED_MODULE_9__CommentContent__["a" /* default */];
Comment.Group = __WEBPACK_IMPORTED_MODULE_10__CommentGroup__["a" /* default */];
Comment.Metadata = __WEBPACK_IMPORTED_MODULE_11__CommentMetadata__["a" /* default */];
Comment.Text = __WEBPACK_IMPORTED_MODULE_12__CommentText__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Comment);

/***/ }),
/* 3326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Comment__ = __webpack_require__(3325);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Comment__["a"]; });



/***/ }),
/* 3327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_without__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_es_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lib__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FeedContent__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FeedDate__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FeedEvent__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FeedExtra__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FeedLabel__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FeedLike__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__FeedMeta__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__FeedSummary__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__FeedUser__ = __webpack_require__(726);

















/**
 * A feed presents user activity chronologically.
 */

function Feed(props) {
  var children = props.children,
      className = props.className,
      events = props.events,
      size = props.size;
  var classes = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])('ui', size, 'feed', className);
  var rest = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["b" /* getUnhandledProps */])(Feed, props);
  var ElementType = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__lib__["c" /* getElementType */])(Feed, props);

  if (!__WEBPACK_IMPORTED_MODULE_7__lib__["d" /* childrenUtils */].isNil(children)) {
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      className: classes
    }), children);
  }

  var eventElements = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3_lodash_es_map__["a" /* default */])(events, function (eventProps) {
    var childKey = eventProps.childKey,
        date = eventProps.date,
        meta = eventProps.meta,
        summary = eventProps.summary,
        eventData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(eventProps, ["childKey", "date", "meta", "summary"]);

    var finalKey = childKey != null ? childKey : [date, meta, summary].join('-');
    return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__FeedEvent__["a" /* default */], __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      date: date,
      key: finalKey,
      meta: meta,
      summary: summary
    }, eventData));
  });

  return /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(ElementType, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
    className: classes
  }), eventElements);
}

Feed.handledProps = ["as", "children", "className", "events", "size"];
Feed.propTypes =  false ? {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,

  /** Primary content. */
  children: PropTypes.node,

  /** Additional classes. */
  className: PropTypes.string,

  /** Shorthand array of props for FeedEvent. */
  events: customPropTypes.collectionShorthand,

  /** A feed can have different sizes. */
  size: PropTypes.oneOf(_without(SUI.SIZES, 'mini', 'tiny', 'medium', 'big', 'huge', 'massive'))
} : {};
Feed.Content = __WEBPACK_IMPORTED_MODULE_8__FeedContent__["a" /* default */];
Feed.Date = __WEBPACK_IMPORTED_MODULE_9__FeedDate__["a" /* default */];
Feed.Event = __WEBPACK_IMPORTED_MODULE_10__FeedEvent__["a" /* default */];
Feed.Extra = __WEBPACK_IMPORTED_MODULE_11__FeedExtra__["a" /* default */];
Feed.Label = __WEBPACK_IMPORTED_MODULE_12__FeedLabel__["a" /* default */];
Feed.Like = __WEBPACK_IMPORTED_MODULE_13__FeedLike__["a" /* default */];
Feed.Meta = __WEBPACK_IMPORTED_MODULE_14__FeedMeta__["a" /* default */];
Feed.Summary = __WEBPACK_IMPORTED_MODULE_15__FeedSummary__["a" /* default */];
Feed.User = __WEBPACK_IMPORTED_MODULE_16__FeedUser__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Feed);

/***/ }),
/* 3328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Feed__ = __webpack_require__(3327);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Feed__["a"]; });



/***/ }),
/* 3329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Item__ = __webpack_require__(1528);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Item__["a"]; });



/***/ }),
/* 3330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Statistic__ = __webpack_require__(1532);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Statistic__["a"]; });



/***/ }),
/* 3331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(110);



/* Built-in method references that are verified to be native. */
var DataView = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),
/* 3332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hashClear_js__ = __webpack_require__(3407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__ = __webpack_require__(3408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hashGet_js__ = __webpack_require__(3409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashHas_js__ = __webpack_require__(3410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hashSet_js__ = __webpack_require__(3411);






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__hashClear_js__["a" /* default */];
Hash.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__["a" /* default */];
Hash.prototype.get = __WEBPACK_IMPORTED_MODULE_2__hashGet_js__["a" /* default */];
Hash.prototype.has = __WEBPACK_IMPORTED_MODULE_3__hashHas_js__["a" /* default */];
Hash.prototype.set = __WEBPACK_IMPORTED_MODULE_4__hashSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Hash);


/***/ }),
/* 3333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(110);



/* Built-in method references that are verified to be native. */
var Promise = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),
/* 3334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(110);


/** Built-in value references. */
var Uint8Array = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Uint8Array;

/* harmony default export */ __webpack_exports__["a"] = (Uint8Array);


/***/ }),
/* 3335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function arrayAggregator(array, setter, iteratee, accumulator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    var value = array[index];
    setter(accumulator, value, iteratee(value), array);
  }
  return accumulator;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayAggregator);


/***/ }),
/* 3336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */
function arrayEvery(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (!predicate(array[index], index, array)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayEvery);


/***/ }),
/* 3337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseProperty_js__ = __webpack_require__(1550);


/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseProperty_js__["a" /* default */])('length');

/* harmony default export */ __webpack_exports__["a"] = (asciiSize);


/***/ }),
/* 3338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

/* harmony default export */ __webpack_exports__["a"] = (asciiToArray);


/***/ }),
/* 3339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/* harmony default export */ __webpack_exports__["a"] = (asciiWords);


/***/ }),
/* 3340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(493);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(objValue, value)) ||
      (value === undefined && !(key in object))) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignValue);


/***/ }),
/* 3341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseEach_js__ = __webpack_require__(250);


/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */
function baseAggregator(collection, setter, iteratee, accumulator) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseEach_js__["a" /* default */])(collection, function(value, key, collection) {
    setter(accumulator, value, iteratee(value), collection);
  });
  return accumulator;
}

/* harmony default export */ __webpack_exports__["a"] = (baseAggregator);


/***/ }),
/* 3342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseEach_js__ = __webpack_require__(250);


/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */
function baseEvery(collection, predicate) {
  var result = true;
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseEach_js__["a" /* default */])(collection, function(value, index, collection) {
    result = !!predicate(value, index, collection);
    return result;
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseEvery);


/***/ }),
/* 3343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(296);


/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */
function baseExtremum(array, iteratee, comparator) {
  var index = -1,
      length = array.length;

  while (++index < length) {
    var value = array[index],
        current = iteratee(value);

    if (current != null && (computed === undefined
          ? (current === current && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(current))
          : comparator(current, computed)
        )) {
      var computed = current,
          result = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseExtremum);


/***/ }),
/* 3344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseEach_js__ = __webpack_require__(250);


/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseEach_js__["a" /* default */])(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseFilter);


/***/ }),
/* 3345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__ = __webpack_require__(3382);


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (baseFor);


/***/ }),
/* 3346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHas);


/***/ }),
/* 3347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHasIn);


/***/ }),
/* 3348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * The base implementation of `_.inRange` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to check.
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
 */
function baseInRange(number, start, end) {
  return number >= nativeMin(start, end) && number < nativeMax(start, end);
}

/* harmony default export */ __webpack_exports__["a"] = (baseInRange);


/***/ }),
/* 3349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayIncludes_js__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__arrayIncludesWith_js__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__arrayMap_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseUnary_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cacheHas_js__ = __webpack_require__(487);







/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */
function baseIntersection(arrays, iteratee, comparator) {
  var includes = comparator ? __WEBPACK_IMPORTED_MODULE_2__arrayIncludesWith_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__arrayIncludes_js__["a" /* default */],
      length = arrays[0].length,
      othLength = arrays.length,
      othIndex = othLength,
      caches = Array(othLength),
      maxLength = Infinity,
      result = [];

  while (othIndex--) {
    var array = arrays[othIndex];
    if (othIndex && iteratee) {
      array = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__arrayMap_js__["a" /* default */])(array, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__baseUnary_js__["a" /* default */])(iteratee));
    }
    maxLength = nativeMin(array.length, maxLength);
    caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
      ? new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */](othIndex && array)
      : undefined;
  }
  array = arrays[0];

  var index = -1,
      seen = caches[0];

  outer:
  while (++index < length && result.length < maxLength) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (!(seen
          ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__cacheHas_js__["a" /* default */])(seen, computed)
          : includes(result, computed, comparator)
        )) {
      othIndex = othLength;
      while (--othIndex) {
        var cache = caches[othIndex];
        if (!(cache
              ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__cacheHas_js__["a" /* default */])(cache, computed)
              : includes(arrays[othIndex], computed, comparator))
            ) {
          continue outer;
        }
      }
      if (seen) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIntersection);


/***/ }),
/* 3350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseForOwn_js__ = __webpack_require__(483);


/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */
function baseInverter(object, setter, iteratee, accumulator) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseForOwn_js__["a" /* default */])(object, function(value, key, object) {
    setter(accumulator, iteratee(value), key, object);
  });
  return accumulator;
}

/* harmony default export */ __webpack_exports__["a"] = (baseInverter);


/***/ }),
/* 3351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castPath_js__ = __webpack_require__(357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__last_js__ = __webpack_require__(3468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parent_js__ = __webpack_require__(3434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__toKey_js__ = __webpack_require__(292);






/**
 * The base implementation of `_.invoke` without support for individual
 * method arguments.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the method to invoke.
 * @param {Array} args The arguments to invoke the method with.
 * @returns {*} Returns the result of the invoked method.
 */
function baseInvoke(object, path, args) {
  path = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__castPath_js__["a" /* default */])(path, object);
  object = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__parent_js__["a" /* default */])(object, path);
  var func = object == null ? object : object[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__toKey_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__last_js__["a" /* default */])(path))];
  return func == null ? undefined : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, object, args);
}

/* harmony default export */ __webpack_exports__["a"] = (baseInvoke);


/***/ }),
/* 3352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(139);



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),
/* 3353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equalArrays_js__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equalByTag_js__ = __webpack_require__(3395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalObjects_js__ = __webpack_require__(3396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getTag_js__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArray_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isBuffer_js__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(498);









/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(object),
      othIsArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(other),
      objTag = objIsArr ? arrayTag : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(object),
      othTag = othIsArr ? arrayTag : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(object)) {
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    return (objIsArr || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(object))
      ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__equalArrays_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack)
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__equalByTag_js__["a" /* default */])(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__equalObjects_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqualDeep);


/***/ }),
/* 3354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__ = __webpack_require__(738);



/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */];
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMatch);


/***/ }),
/* 3355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNaN);


/***/ }),
/* 3356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__(3416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__(1578);





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),
/* 3357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(139);




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),
/* 3358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPrototype_js__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__ = __webpack_require__(3431);




/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(object)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__["a" /* default */])(object);
  }
  var isProto = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isPrototype_js__["a" /* default */])(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeysIn);


/***/ }),
/* 3359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */
function baseLt(value, other) {
  return value < other;
}

/* harmony default export */ __webpack_exports__["a"] = (baseLt);


/***/ }),
/* 3360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__ = __webpack_require__(3354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getMatchData_js__ = __webpack_require__(3401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__ = __webpack_require__(1570);




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getMatchData_js__["a" /* default */])(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__["a" /* default */])(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__["a" /* default */])(object, source, matchData);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatches);


/***/ }),
/* 3361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_js__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasIn_js__ = __webpack_require__(1584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isKey_js__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__ = __webpack_require__(1570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toKey_js__ = __webpack_require__(292);








/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isKey_js__["a" /* default */])(path) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__["a" /* default */])(srcValue)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toKey_js__["a" /* default */])(path), srcValue);
  }
  return function(object) {
    var objValue = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__get_js__["a" /* default */])(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__hasIn_js__["a" /* default */])(object, path)
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatchesProperty);


/***/ }),
/* 3362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseGet_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseMap_js__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__baseSortBy_js__ = __webpack_require__(3370);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseUnary_js__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__compareMultiple_js__ = __webpack_require__(3377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__identity_js__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isArray_js__ = __webpack_require__(69);










/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(iteratees, function(iteratee) {
      if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__isArray_js__["a" /* default */])(iteratee)) {
        return function(value) {
          return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseGet_js__["a" /* default */])(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [__WEBPACK_IMPORTED_MODULE_7__identity_js__["a" /* default */]];
  }

  var index = -1;
  iteratees = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(iteratees, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__baseUnary_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */]));

  var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseMap_js__["a" /* default */])(collection, function(value, key, collection) {
    var criteria = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__baseSortBy_js__["a" /* default */])(result, function(object, other) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__compareMultiple_js__["a" /* default */])(object, other, orders);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (baseOrderBy);


/***/ }),
/* 3363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePickBy_js__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasIn_js__ = __webpack_require__(1584);



/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basePickBy_js__["a" /* default */])(object, paths, function(value, path) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hasIn_js__["a" /* default */])(object, path);
  });
}

/* harmony default export */ __webpack_exports__["a"] = (basePick);


/***/ }),
/* 3364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(356);


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (basePropertyDeep);


/***/ }),
/* 3365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (basePropertyOf);


/***/ }),
/* 3366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseRange);


/***/ }),
/* 3367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

/* harmony default export */ __webpack_exports__["a"] = (baseReduce);


/***/ }),
/* 3368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defineProperty_js__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(189);




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */] : function(func, string) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */])(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(string),
    'writable': true
  });
};

/* harmony default export */ __webpack_exports__["a"] = (baseSetToString);


/***/ }),
/* 3369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseEach_js__ = __webpack_require__(250);


/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function baseSome(collection, predicate) {
  var result;

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseEach_js__["a" /* default */])(collection, function(value, index, collection) {
    result = predicate(value, index, collection);
    return !result;
  });
  return !!result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseSome);


/***/ }),
/* 3370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (baseSortBy);


/***/ }),
/* 3371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseSum);


/***/ }),
/* 3372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(208);


/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(props, function(key) {
    return object[key];
  });
}

/* harmony default export */ __webpack_exports__["a"] = (baseValues);


/***/ }),
/* 3373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLikeObject_js__ = __webpack_require__(495);


/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */
function castArrayLikeObject(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isArrayLikeObject_js__["a" /* default */])(value) ? value : [];
}

/* harmony default export */ __webpack_exports__["a"] = (castArrayLikeObject);


/***/ }),
/* 3374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__ = __webpack_require__(484);


/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__["a" /* default */])(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/* harmony default export */ __webpack_exports__["a"] = (charsEndIndex);


/***/ }),
/* 3375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__ = __webpack_require__(484);


/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseIndexOf_js__["a" /* default */])(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

/* harmony default export */ __webpack_exports__["a"] = (charsStartIndex);


/***/ }),
/* 3376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(296);


/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

/* harmony default export */ __webpack_exports__["a"] = (compareAscending);


/***/ }),
/* 3377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compareAscending_js__ = __webpack_require__(3376);


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__compareAscending_js__["a" /* default */])(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

/* harmony default export */ __webpack_exports__["a"] = (compareMultiple);


/***/ }),
/* 3378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(110);


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),
/* 3379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (countHolders);


/***/ }),
/* 3380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayAggregator_js__ = __webpack_require__(3335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAggregator_js__ = __webpack_require__(3341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(69);





/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */
function createAggregator(setter, initializer) {
  return function(collection, iteratee) {
    var func = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arrayAggregator_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__baseAggregator_js__["a" /* default */],
        accumulator = initializer ? initializer() : {};

    return func(collection, setter, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 2), accumulator);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createAggregator);


/***/ }),
/* 3381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(169);


/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createBaseEach);


/***/ }),
/* 3382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createBaseFor);


/***/ }),
/* 3383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCtor_js__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(110);



/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createCtor_js__["a" /* default */])(func);

  function wrapper() {
    var fn = (this && this !== __WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */] && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

/* harmony default export */ __webpack_exports__["a"] = (createBind);


/***/ }),
/* 3384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castSlice_js__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToArray_js__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(210);





/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(string);

    var strSymbols = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__["a" /* default */])(string)
      ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__stringToArray_js__["a" /* default */])(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__castSlice_js__["a" /* default */])(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createCaseFirst);


/***/ }),
/* 3385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayReduce_js__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deburr_js__ = __webpack_require__(1580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__words_js__ = __webpack_require__(3489);




/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayReduce_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__words_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__deburr_js__["a" /* default */])(string).replace(reApos, '')), callback, '');
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createCompounder);


/***/ }),
/* 3386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createCtor_js__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createHybrid_js__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createRecurry_js__ = __webpack_require__(1562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getHolder_js__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__replaceHolders_js__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__root_js__ = __webpack_require__(110);








/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createCtor_js__["a" /* default */])(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getHolder_js__["a" /* default */])(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__replaceHolders_js__["a" /* default */])(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__createRecurry_js__["a" /* default */])(
        func, bitmask, __WEBPACK_IMPORTED_MODULE_2__createHybrid_js__["a" /* default */], wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== __WEBPACK_IMPORTED_MODULE_6__root_js__["a" /* default */] && this instanceof wrapper) ? Ctor : func;
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(fn, this, args);
  }
  return wrapper;
}

/* harmony default export */ __webpack_exports__["a"] = (createCurry);


/***/ }),
/* 3387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(150);




/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(collection)) {
      var iteratee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseIteratee_js__["a" /* default */])(predicate, 3);
      collection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */])(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createFind);


/***/ }),
/* 3388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseInverter_js__ = __webpack_require__(3350);


/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */
function createInverter(setter, toIteratee) {
  return function(object, iteratee) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseInverter_js__["a" /* default */])(object, setter, toIteratee(iteratee), {});
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createInverter);


/***/ }),
/* 3389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createCtor_js__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__root_js__ = __webpack_require__(110);




/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createCtor_js__["a" /* default */])(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== __WEBPACK_IMPORTED_MODULE_2__root_js__["a" /* default */] && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

/* harmony default export */ __webpack_exports__["a"] = (createPartial);


/***/ }),
/* 3390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRange_js__ = __webpack_require__(3366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toFinite_js__ = __webpack_require__(757);




/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toFinite_js__["a" /* default */])(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toFinite_js__["a" /* default */])(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toFinite_js__["a" /* default */])(step);
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseRange_js__["a" /* default */])(start, end, step, fromRight);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createRange);


/***/ }),
/* 3391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toInteger_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toNumber_js__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(210);





/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsFinite = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].isFinite,
    nativeMin = Math.min;

/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */
function createRound(methodName) {
  var func = Math[methodName];
  return function(number, precision) {
    number = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toNumber_js__["a" /* default */])(number);
    precision = precision == null ? 0 : nativeMin(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toInteger_js__["a" /* default */])(precision), 292);
    if (precision && nativeIsFinite(number)) {
      // Shift with exponential notation to avoid floating-point issues.
      // See [MDN](https://mdn.io/round#Examples) for more details.
      var pair = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(number) + 'e').split('e'),
          value = func(pair[0] + 'e' + (+pair[1] + precision));

      pair = (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(value) + 'e').split('e');
      return +(pair[0] + 'e' + (+pair[1] - precision));
    }
    return func(number);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createRound);


/***/ }),
/* 3392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Set_js__ = __webpack_require__(1537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__noop_js__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToArray_js__ = __webpack_require__(748);




/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(__WEBPACK_IMPORTED_MODULE_0__Set_js__["a" /* default */] && (1 / __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__setToArray_js__["a" /* default */])(new __WEBPACK_IMPORTED_MODULE_0__Set_js__["a" /* default */]([,-0]))[1]) == INFINITY) ? __WEBPACK_IMPORTED_MODULE_1__noop_js__["a" /* default */] : function(values) {
  return new __WEBPACK_IMPORTED_MODULE_0__Set_js__["a" /* default */](values);
};

/* harmony default export */ __webpack_exports__["a"] = (createSet);


/***/ }),
/* 3393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSetData_js__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createBind_js__ = __webpack_require__(3383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createCurry_js__ = __webpack_require__(3386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createHybrid_js__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createPartial_js__ = __webpack_require__(3389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getData_js__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeData_js__ = __webpack_require__(3429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__setData_js__ = __webpack_require__(1574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__setWrapToString_js__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__toInteger_js__ = __webpack_require__(209);











/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__toInteger_js__["a" /* default */])(ary), 0);
  arity = arity === undefined ? arity : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__toInteger_js__["a" /* default */])(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__getData_js__["a" /* default */])(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__mergeData_js__["a" /* default */])(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createBind_js__["a" /* default */])(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__createCurry_js__["a" /* default */])(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__createPartial_js__["a" /* default */])(func, bitmask, thisArg, partials);
  } else {
    result = __WEBPACK_IMPORTED_MODULE_3__createHybrid_js__["a" /* default */].apply(undefined, newData);
  }
  var setter = data ? __WEBPACK_IMPORTED_MODULE_0__baseSetData_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_7__setData_js__["a" /* default */];
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__setWrapToString_js__["a" /* default */])(setter(result, newData), func, bitmask);
}

/* harmony default export */ __webpack_exports__["a"] = (createWrap);


/***/ }),
/* 3394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__basePropertyOf_js__ = __webpack_require__(3365);


/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__basePropertyOf_js__["a" /* default */])(deburredLetters);

/* harmony default export */ __webpack_exports__["a"] = (deburrLetter);


/***/ }),
/* 3395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__ = __webpack_require__(3334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eq_js__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalArrays_js__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__ = __webpack_require__(3427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setToArray_js__ = __webpack_require__(748);







/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](object), new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__eq_js__["a" /* default */])(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__["a" /* default */];

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = __WEBPACK_IMPORTED_MODULE_5__setToArray_js__["a" /* default */]);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__equalArrays_js__["a" /* default */])(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (equalByTag);


/***/ }),
/* 3396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__ = __webpack_require__(3398);


/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(object),
      objLength = objProps.length,
      othProps = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalObjects);


/***/ }),
/* 3397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__flatten_js__ = __webpack_require__(3459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overRest_js__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(749);




/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__overRest_js__["a" /* default */])(func, undefined, __WEBPACK_IMPORTED_MODULE_0__flatten_js__["a" /* default */]), func + '');
}

/* harmony default export */ __webpack_exports__["a"] = (flatRest);


/***/ }),
/* 3398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(150);




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeys);


/***/ }),
/* 3399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__ = __webpack_require__(3403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keysIn_js__ = __webpack_require__(3467);




/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keysIn_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbolsIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeysIn);


/***/ }),
/* 3400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__realNames_js__ = __webpack_require__(3435);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = __WEBPACK_IMPORTED_MODULE_0__realNames_js__["a" /* default */][result],
      length = hasOwnProperty.call(__WEBPACK_IMPORTED_MODULE_0__realNames_js__["a" /* default */], result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getFuncName);


/***/ }),
/* 3401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(150);



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__["a" /* default */])(value)];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getMatchData);


/***/ }),
/* 3402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(355);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 3403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getSymbols_js__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stubArray_js__ = __webpack_require__(1587);





/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_3__stubArray_js__["a" /* default */] : function(object) {
  var result = [];
  while (object) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getSymbols_js__["a" /* default */])(object));
    object = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object);
  }
  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbolsIn);


/***/ }),
/* 3404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),
/* 3405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

/* harmony default export */ __webpack_exports__["a"] = (getWrapDetails);


/***/ }),
/* 3406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/* harmony default export */ __webpack_exports__["a"] = (hasUnicodeWord);


/***/ }),
/* 3407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(491);


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */])(null) : {};
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (hashClear);


/***/ }),
/* 3408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (hashDelete);


/***/ }),
/* 3409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(491);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */]) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (hashGet);


/***/ }),
/* 3410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(491);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/* harmony default export */ __webpack_exports__["a"] = (hashHas);


/***/ }),
/* 3411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(491);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (hashSet);


/***/ }),
/* 3412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

/* harmony default export */ __webpack_exports__["a"] = (insertWrapDetails);


/***/ }),
/* 3413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(69);




/** Built-in value references. */
var spreadableSymbol = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/* harmony default export */ __webpack_exports__["a"] = (isFlattenable);


/***/ }),
/* 3414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ __webpack_exports__["a"] = (isKeyable);


/***/ }),
/* 3415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getData_js__ = __webpack_require__(1566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getFuncName_js__ = __webpack_require__(3400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__wrapperLodash_js__ = __webpack_require__(3490);





/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getFuncName_js__["a" /* default */])(func),
      other = __WEBPACK_IMPORTED_MODULE_3__wrapperLodash_js__["a" /* default */][funcName];

  if (typeof other != 'function' || !(funcName in __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__["a" /* default */].prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getData_js__["a" /* default */])(other);
  return !!data && func === data[0];
}

/* harmony default export */ __webpack_exports__["a"] = (isLaziable);


/***/ }),
/* 3416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(3378);


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),
/* 3417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheClear);


/***/ }),
/* 3418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(480);


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheDelete);


/***/ }),
/* 3419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(480);


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheGet);


/***/ }),
/* 3420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(480);


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(this.__data__, key) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheHas);


/***/ }),
/* 3421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(480);


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheSet);


/***/ }),
/* 3422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hash_js__ = __webpack_require__(3332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListCache_js__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_js__ = __webpack_require__(732);




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */],
    'map': new (__WEBPACK_IMPORTED_MODULE_2__Map_js__["a" /* default */] || __WEBPACK_IMPORTED_MODULE_1__ListCache_js__["a" /* default */]),
    'string': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheClear);


/***/ }),
/* 3423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(489);


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheDelete);


/***/ }),
/* 3424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(489);


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheGet);


/***/ }),
/* 3425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(489);


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheHas);


/***/ }),
/* 3426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(489);


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheSet);


/***/ }),
/* 3427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapToArray);


/***/ }),
/* 3428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoize_js__ = __webpack_require__(754);


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__memoize_js__["a" /* default */])(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeCapped);


/***/ }),
/* 3429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__composeArgs_js__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__composeArgsRight_js__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__replaceHolders_js__ = __webpack_require__(492);




/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__composeArgs_js__["a" /* default */])(partials, value, source[4]) : value;
    data[4] = partials ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__replaceHolders_js__["a" /* default */])(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__composeArgsRight_js__["a" /* default */])(partials, value, source[6]) : value;
    data[6] = partials ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__replaceHolders_js__["a" /* default */])(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

/* harmony default export */ __webpack_exports__["a"] = (mergeData);


/***/ }),
/* 3430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(1572);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),
/* 3431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (nativeKeysIn);


/***/ }),
/* 3432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(1565);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(766)(module)))

/***/ }),
/* 3433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 3434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseSlice_js__ = __webpack_require__(485);



/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseSlice_js__["a" /* default */])(path, 0, -1));
}

/* harmony default export */ __webpack_exports__["a"] = (parent);


/***/ }),
/* 3435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to lookup unminified function names. */
var realNames = {};

/* harmony default export */ __webpack_exports__["a"] = (realNames);


/***/ }),
/* 3436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyArray_js__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIndex_js__ = __webpack_require__(358);



/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__copyArray_js__["a" /* default */])(array);

  while (length--) {
    var index = indexes[length];
    array[length] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isIndex_js__["a" /* default */])(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (reorder);


/***/ }),
/* 3437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheAdd);


/***/ }),
/* 3438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheHas);


/***/ }),
/* 3439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(476);


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (stackClear);


/***/ }),
/* 3440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (stackDelete);


/***/ }),
/* 3441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackGet);


/***/ }),
/* 3442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackHas);


/***/ }),
/* 3443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapCache_js__ = __webpack_require__(733);




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */]) {
    var pairs = data.__data__;
    if (!__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_2__MapCache_js__["a" /* default */](pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (stackSet);


/***/ }),
/* 3444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (strictIndexOf);


/***/ }),
/* 3445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__asciiSize_js__ = __webpack_require__(3337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__unicodeSize_js__ = __webpack_require__(3448);




/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hasUnicode_js__["a" /* default */])(string)
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__unicodeSize_js__["a" /* default */])(string)
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__asciiSize_js__["a" /* default */])(string);
}

/* harmony default export */ __webpack_exports__["a"] = (stringSize);


/***/ }),
/* 3446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__ = __webpack_require__(3428);


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__["a" /* default */])(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (stringToPath);


/***/ }),
/* 3447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

/* harmony default export */ __webpack_exports__["a"] = (trimmedEndIndex);


/***/ }),
/* 3448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (unicodeSize);


/***/ }),
/* 3449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

/* harmony default export */ __webpack_exports__["a"] = (unicodeToArray);


/***/ }),
/* 3450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/* harmony default export */ __webpack_exports__["a"] = (unicodeWords);


/***/ }),
/* 3451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayEach_js__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayIncludes_js__ = __webpack_require__(479);



/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayEach_js__["a" /* default */])(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__arrayIncludes_js__["a" /* default */])(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

/* harmony default export */ __webpack_exports__["a"] = (updateWrapDetails);


/***/ }),
/* 3452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LodashWrapper_js__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__copyArray_js__ = __webpack_require__(1560);




/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__["a" /* default */]) {
    return wrapper.clone();
  }
  var result = new __WEBPACK_IMPORTED_MODULE_1__LodashWrapper_js__["a" /* default */](wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__copyArray_js__["a" /* default */])(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (wrapperClone);


/***/ }),
/* 3453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClamp_js__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toNumber_js__ = __webpack_require__(501);



/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toNumber_js__["a" /* default */])(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toNumber_js__["a" /* default */])(lower);
    lower = lower === lower ? lower : 0;
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseClamp_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toNumber_js__["a" /* default */])(number), lower, upper);
}

/* harmony default export */ __webpack_exports__["a"] = (clamp);


/***/ }),
/* 3454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates an array with all falsey values removed. The values `false`, `null`,
 * `0`, `""`, `undefined`, and `NaN` are falsey.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to compact.
 * @returns {Array} Returns the new array of filtered values.
 * @example
 *
 * _.compact([0, 1, false, 2, '', 3]);
 * // => [1, 2, 3]
 */
function compact(array) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (compact);


/***/ }),
/* 3455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSlice_js__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toInteger_js__ = __webpack_require__(209);



/**
 * Creates a slice of `array` with `n` elements dropped from the end.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to drop.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.dropRight([1, 2, 3]);
 * // => [1, 2]
 *
 * _.dropRight([1, 2, 3], 2);
 * // => [1]
 *
 * _.dropRight([1, 2, 3], 5);
 * // => []
 *
 * _.dropRight([1, 2, 3], 0);
 * // => [1, 2, 3]
 */
function dropRight(array, n, guard) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toInteger_js__["a" /* default */])(n);
  n = length - n;
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseSlice_js__["a" /* default */])(array, 0, n < 0 ? 0 : n);
}

/* harmony default export */ __webpack_exports__["a"] = (dropRight);


/***/ }),
/* 3456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toString_js__ = __webpack_require__(210);


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

/**
 * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
 * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escapeRegExp('[lodash](https://lodash.com/)');
 * // => '\[lodash\]\(https://lodash\.com/\)'
 */
function escapeRegExp(string) {
  string = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__toString_js__["a" /* default */])(string);
  return (string && reHasRegExpChar.test(string))
    ? string.replace(reRegExpChar, '\\$&')
    : string;
}

/* harmony default export */ __webpack_exports__["a"] = (escapeRegExp);


/***/ }),
/* 3457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayEvery_js__ = __webpack_require__(3336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseEvery_js__ = __webpack_require__(3342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIterateeCall_js__ = __webpack_require__(490);






/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */
function every(collection, predicate, guard) {
  var func = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(collection) ? __WEBPACK_IMPORTED_MODULE_0__arrayEvery_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_1__baseEvery_js__["a" /* default */];
  if (guard && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__isIterateeCall_js__["a" /* default */])(collection, predicate, guard)) {
    predicate = undefined;
  }
  return func(collection, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(predicate, 3));
}

/* harmony default export */ __webpack_exports__["a"] = (every);


/***/ }),
/* 3458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__head_js__ = __webpack_require__(3460);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__head_js__["a"]; });



/***/ }),
/* 3459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__ = __webpack_require__(482);


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__["a" /* default */])(array, 1) : [];
}

/* harmony default export */ __webpack_exports__["a"] = (flatten);


/***/ }),
/* 3460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (head);


/***/ }),
/* 3461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIntersection_js__ = __webpack_require__(3349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseRest_js__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__castArrayLikeObject_js__ = __webpack_require__(3373);





/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */
var intersection = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseRest_js__["a" /* default */])(function(arrays) {
  var mapped = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(arrays, __WEBPACK_IMPORTED_MODULE_3__castArrayLikeObject_js__["a" /* default */]);
  return (mapped.length && mapped[0] === arrays[0])
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseIntersection_js__["a" /* default */])(mapped)
    : [];
});

/* unused harmony default export */ var _unused_webpack_default_export = (intersection);


/***/ }),
/* 3462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createInverter_js__ = __webpack_require__(3388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(189);




/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */
var invert = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createInverter_js__["a" /* default */])(function(result, value, key) {
  if (value != null &&
      typeof value.toString != 'function') {
    value = nativeObjectToString.call(value);
  }

  result[value] = key;
}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */]));

/* harmony default export */ __webpack_exports__["a"] = (invert);


/***/ }),
/* 3463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(139);



/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == boolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isBoolean);


/***/ }),
/* 3464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObjectLike_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPlainObject_js__ = __webpack_require__(295);



/**
 * Checks if `value` is likely a DOM element.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
 * @example
 *
 * _.isElement(document.body);
 * // => true
 *
 * _.isElement('<body>');
 * // => false
 */
function isElement(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__isObjectLike_js__["a" /* default */])(value) && value.nodeType === 1 && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isPlainObject_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isElement);


/***/ }),
/* 3465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(139);



/** `Object#toString` result references. */
var numberTag = '[object Number]';

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == numberTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isNumber);


/***/ }),
/* 3466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAggregator_js__ = __webpack_require__(3380);



/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */
var keyBy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createAggregator_js__["a" /* default */])(function(result, value, key) {
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, key, value);
});

/* harmony default export */ __webpack_exports__["a"] = (keyBy);


/***/ }),
/* 3467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__ = __webpack_require__(3358);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(169);




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object, true) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keysIn);


/***/ }),
/* 3468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (last);


/***/ }),
/* 3469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(138);




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 3);

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__["a" /* default */])(object, function(value, key, object) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, key, iteratee(value, key, object));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapValues);


/***/ }),
/* 3470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseExtremum_js__ = __webpack_require__(3343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseLt_js__ = __webpack_require__(3359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(189);




/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */
function min(array) {
  return (array && array.length)
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseExtremum_js__["a" /* default */])(array, __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__baseLt_js__["a" /* default */])
    : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (min);


/***/ }),
/* 3471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createWrap_js__ = __webpack_require__(3393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getHolder_js__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__replaceHolders_js__ = __webpack_require__(492);





/** Used to compose bitmasks for function metadata. */
var WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * This method is like `_.partial` except that partially applied arguments
 * are appended to the arguments it receives.
 *
 * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
 * builds, may be used as a placeholder for partially applied arguments.
 *
 * **Note:** This method doesn't set the "length" property of partially
 * applied functions.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Function
 * @param {Function} func The function to partially apply arguments to.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new partially applied function.
 * @example
 *
 * function greet(greeting, name) {
 *   return greeting + ' ' + name;
 * }
 *
 * var greetFred = _.partialRight(greet, 'fred');
 * greetFred('hi');
 * // => 'hi fred'
 *
 * // Partially applied with placeholders.
 * var sayHelloTo = _.partialRight(greet, 'hello', _);
 * sayHelloTo('fred');
 * // => 'hello fred'
 */
var partialRight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(func, partials) {
  var holders = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__replaceHolders_js__["a" /* default */])(partials, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__getHolder_js__["a" /* default */])(partialRight));
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__createWrap_js__["a" /* default */])(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
});

// Assign default placeholders.
partialRight.placeholder = {};

/* harmony default export */ __webpack_exports__["a"] = (partialRight);


/***/ }),
/* 3472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__basePickBy_js__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getAllKeysIn_js__ = __webpack_require__(3399);





/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__getAllKeysIn_js__["a" /* default */])(object), function(prop) {
    return [prop];
  });
  predicate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseIteratee_js__["a" /* default */])(predicate);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__basePickBy_js__["a" /* default */])(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

/* unused harmony default export */ var _unused_webpack_default_export = (pickBy);


/***/ }),
/* 3473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseProperty_js__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__ = __webpack_require__(3364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isKey_js__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toKey_js__ = __webpack_require__(292);





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isKey_js__["a" /* default */])(path) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseProperty_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__toKey_js__["a" /* default */])(path)) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__["a" /* default */])(path);
}

/* harmony default export */ __webpack_exports__["a"] = (property);


/***/ }),
/* 3474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createRange_js__ = __webpack_require__(3390);


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createRange_js__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (range);


/***/ }),
/* 3475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createRound_js__ = __webpack_require__(3391);


/**
 * Computes `number` rounded to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round.
 * @param {number} [precision=0] The precision to round to.
 * @returns {number} Returns the rounded number.
 * @example
 *
 * _.round(4.006);
 * // => 4
 *
 * _.round(4.006, 2);
 * // => 4.01
 *
 * _.round(4060, -2);
 * // => 4100
 */
var round = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createRound_js__["a" /* default */])('round');

/* harmony default export */ __webpack_exports__["a"] = (round);


/***/ }),
/* 3476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSet_js__ = __webpack_require__(1551);


/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseSet_js__["a" /* default */])(object, path, value);
}

/* harmony default export */ __webpack_exports__["a"] = (set);


/***/ }),
/* 3477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseKeys_js__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTag_js__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isString_js__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stringSize_js__ = __webpack_require__(3445);






/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(collection)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isString_js__["a" /* default */])(collection) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__stringSize_js__["a" /* default */])(collection) : collection.length;
  }
  var tag = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__getTag_js__["a" /* default */])(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseKeys_js__["a" /* default */])(collection).length;
}

/* harmony default export */ __webpack_exports__["a"] = (size);


/***/ }),
/* 3478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseOrderBy_js__ = __webpack_require__(3362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseRest_js__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIterateeCall_js__ = __webpack_require__(490);





/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseRest_js__["a" /* default */])(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isIterateeCall_js__["a" /* default */])(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isIterateeCall_js__["a" /* default */])(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseOrderBy_js__["a" /* default */])(collection, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__["a" /* default */])(iteratees, 1), []);
});

/* harmony default export */ __webpack_exports__["a"] = (sortBy);


/***/ }),
/* 3479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCompounder_js__ = __webpack_require__(3385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__upperFirst_js__ = __webpack_require__(3488);



/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createCompounder_js__["a" /* default */])(function(result, word, index) {
  return result + (index ? ' ' : '') + __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__upperFirst_js__["a" /* default */])(word);
});

/* harmony default export */ __webpack_exports__["a"] = (startCase);


/***/ }),
/* 3480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseClamp_js__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseToString_js__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_js__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(210);





/**
 * Checks if `string` starts with the given target string.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {string} [target] The string to search for.
 * @param {number} [position=0] The position to search from.
 * @returns {boolean} Returns `true` if `string` starts with `target`,
 *  else `false`.
 * @example
 *
 * _.startsWith('abc', 'a');
 * // => true
 *
 * _.startsWith('abc', 'b');
 * // => false
 *
 * _.startsWith('abc', 'b', 1);
 * // => true
 */
function startsWith(string, target, position) {
  string = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(string);
  position = position == null
    ? 0
    : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseClamp_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(position), 0, string.length);

  target = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseToString_js__["a" /* default */])(target);
  return string.slice(position, position + target.length) == target;
}

/* unused harmony default export */ var _unused_webpack_default_export = (startsWith);


/***/ }),
/* 3481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 3482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSum_js__ = __webpack_require__(3371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__identity_js__ = __webpack_require__(189);



/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */
function sum(array) {
  return (array && array.length)
    ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseSum_js__["a" /* default */])(array, __WEBPACK_IMPORTED_MODULE_1__identity_js__["a" /* default */])
    : 0;
}

/* harmony default export */ __webpack_exports__["a"] = (sum);


/***/ }),
/* 3483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSlice_js__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toInteger_js__ = __webpack_require__(209);



/**
 * Creates a slice of `array` with `n` elements taken from the beginning.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @param {number} [n=1] The number of elements to take.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the slice of `array`.
 * @example
 *
 * _.take([1, 2, 3]);
 * // => [1]
 *
 * _.take([1, 2, 3], 2);
 * // => [1, 2]
 *
 * _.take([1, 2, 3], 5);
 * // => [1, 2, 3]
 *
 * _.take([1, 2, 3], 0);
 * // => []
 */
function take(array, n, guard) {
  if (!(array && array.length)) {
    return [];
  }
  n = (guard || n === undefined) ? 1 : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__toInteger_js__["a" /* default */])(n);
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseSlice_js__["a" /* default */])(array, 0, n < 0 ? 0 : n);
}

/* harmony default export */ __webpack_exports__["a"] = (take);


/***/ }),
/* 3484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__castFunction_js__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toInteger_js__ = __webpack_require__(209);




/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */
function times(n, iteratee) {
  n = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toInteger_js__["a" /* default */])(n);
  if (n < 1 || n > MAX_SAFE_INTEGER) {
    return [];
  }
  var index = MAX_ARRAY_LENGTH,
      length = nativeMin(n, MAX_ARRAY_LENGTH);

  iteratee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__castFunction_js__["a" /* default */])(iteratee);
  n -= MAX_ARRAY_LENGTH;

  var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(length, iteratee);
  while (++index < n) {
    iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (times);


/***/ }),
/* 3485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayEach_js__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseCreate_js__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseForOwn_js__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseIteratee_js__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getPrototype_js__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArray_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isBuffer_js__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isFunction_js__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isObject_js__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isTypedArray_js__ = __webpack_require__(498);











/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */
function transform(object, iteratee, accumulator) {
  var isArr = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(object),
      isArrLike = isArr || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(object) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__isTypedArray_js__["a" /* default */])(object);

  iteratee = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__baseIteratee_js__["a" /* default */])(iteratee, 4);
  if (accumulator == null) {
    var Ctor = object && object.constructor;
    if (isArrLike) {
      accumulator = isArr ? new Ctor : [];
    }
    else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__isObject_js__["a" /* default */])(object)) {
      accumulator = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__isFunction_js__["a" /* default */])(Ctor) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseCreate_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__getPrototype_js__["a" /* default */])(object)) : {};
    }
    else {
      accumulator = {};
    }
  }
  (isArrLike ? __WEBPACK_IMPORTED_MODULE_0__arrayEach_js__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_2__baseForOwn_js__["a" /* default */])(object, function(value, index, object) {
    return iteratee(accumulator, value, index, object);
  });
  return accumulator;
}

/* harmony default export */ __webpack_exports__["a"] = (transform);


/***/ }),
/* 3486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseTrim_js__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__castSlice_js__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__charsEndIndex_js__ = __webpack_require__(3374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__charsStartIndex_js__ = __webpack_require__(3375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stringToArray_js__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toString_js__ = __webpack_require__(210);








/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__toString_js__["a" /* default */])(string);
  if (string && (guard || chars === undefined)) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseTrim_js__["a" /* default */])(string);
  }
  if (!string || !(chars = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(chars))) {
    return string;
  }
  var strSymbols = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__stringToArray_js__["a" /* default */])(string),
      chrSymbols = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__stringToArray_js__["a" /* default */])(chars),
      start = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__charsStartIndex_js__["a" /* default */])(strSymbols, chrSymbols),
      end = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__charsEndIndex_js__["a" /* default */])(strSymbols, chrSymbols) + 1;

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__castSlice_js__["a" /* default */])(strSymbols, start, end).join('');
}

/* harmony default export */ __webpack_exports__["a"] = (trim);


/***/ }),
/* 3487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseRest_js__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseUniq_js__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__ = __webpack_require__(495);





/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */
var union = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__baseRest_js__["a" /* default */])(function(arrays) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__baseUniq_js__["a" /* default */])(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__baseFlatten_js__["a" /* default */])(arrays, 1, __WEBPACK_IMPORTED_MODULE_3__isArrayLikeObject_js__["a" /* default */], true));
});

/* harmony default export */ __webpack_exports__["a"] = (union);


/***/ }),
/* 3488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createCaseFirst_js__ = __webpack_require__(3384);


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__createCaseFirst_js__["a" /* default */])('toUpperCase');

/* harmony default export */ __webpack_exports__["a"] = (upperFirst);


/***/ }),
/* 3489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__asciiWords_js__ = __webpack_require__(3339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasUnicodeWord_js__ = __webpack_require__(3406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__toString_js__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__unicodeWords_js__ = __webpack_require__(3450);





/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__toString_js__["a" /* default */])(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__hasUnicodeWord_js__["a" /* default */])(string) ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__unicodeWords_js__["a" /* default */])(string) : __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__asciiWords_js__["a" /* default */])(string);
  }
  return string.match(pattern) || [];
}

/* harmony default export */ __webpack_exports__["a"] = (words);


/***/ }),
/* 3490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LodashWrapper_js__ = __webpack_require__(1536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseLodash_js__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isObjectLike_js__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__wrapperClone_js__ = __webpack_require__(3452);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__isObjectLike_js__["a" /* default */])(value) && !__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value) && !(value instanceof __WEBPACK_IMPORTED_MODULE_0__LazyWrapper_js__["a" /* default */])) {
    if (value instanceof __WEBPACK_IMPORTED_MODULE_1__LodashWrapper_js__["a" /* default */]) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__wrapperClone_js__["a" /* default */])(value);
    }
  }
  return new __WEBPACK_IMPORTED_MODULE_1__LodashWrapper_js__["a" /* default */](value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = __WEBPACK_IMPORTED_MODULE_2__baseLodash_js__["a" /* default */].prototype;
lodash.prototype.constructor = lodash;

/* harmony default export */ __webpack_exports__["a"] = (lodash);


/***/ }),
/* 3491 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */

var inherits = __webpack_require__(41)
var Hash = __webpack_require__(297)
var Buffer = __webpack_require__(42).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha, Hash)

Sha.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha


/***/ }),
/* 3492 */
/***/ (function(module, exports, __webpack_require__) {

/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */

var inherits = __webpack_require__(41)
var Hash = __webpack_require__(297)
var Buffer = __webpack_require__(42).Buffer

var K = [
  0x5a827999, 0x6ed9eba1, 0x8f1bbcdc | 0, 0xca62c1d6 | 0
]

var W = new Array(80)

function Sha1 () {
  this.init()
  this._w = W

  Hash.call(this, 64, 56)
}

inherits(Sha1, Hash)

Sha1.prototype.init = function () {
  this._a = 0x67452301
  this._b = 0xefcdab89
  this._c = 0x98badcfe
  this._d = 0x10325476
  this._e = 0xc3d2e1f0

  return this
}

function rotl1 (num) {
  return (num << 1) | (num >>> 31)
}

function rotl5 (num) {
  return (num << 5) | (num >>> 27)
}

function rotl30 (num) {
  return (num << 30) | (num >>> 2)
}

function ft (s, b, c, d) {
  if (s === 0) return (b & c) | ((~b) & d)
  if (s === 2) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

Sha1.prototype._update = function (M) {
  var W = this._w

  var a = this._a | 0
  var b = this._b | 0
  var c = this._c | 0
  var d = this._d | 0
  var e = this._e | 0

  for (var i = 0; i < 16; ++i) W[i] = M.readInt32BE(i * 4)
  for (; i < 80; ++i) W[i] = rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16])

  for (var j = 0; j < 80; ++j) {
    var s = ~~(j / 20)
    var t = (rotl5(a) + ft(s, b, c, d) + e + W[j] + K[s]) | 0

    e = d
    d = c
    c = rotl30(b)
    b = a
    a = t
  }

  this._a = (a + this._a) | 0
  this._b = (b + this._b) | 0
  this._c = (c + this._c) | 0
  this._d = (d + this._d) | 0
  this._e = (e + this._e) | 0
}

Sha1.prototype._hash = function () {
  var H = Buffer.allocUnsafe(20)

  H.writeInt32BE(this._a | 0, 0)
  H.writeInt32BE(this._b | 0, 4)
  H.writeInt32BE(this._c | 0, 8)
  H.writeInt32BE(this._d | 0, 12)
  H.writeInt32BE(this._e | 0, 16)

  return H
}

module.exports = Sha1


/***/ }),
/* 3493 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */

var inherits = __webpack_require__(41)
var Sha256 = __webpack_require__(1590)
var Hash = __webpack_require__(297)
var Buffer = __webpack_require__(42).Buffer

var W = new Array(64)

function Sha224 () {
  this.init()

  this._w = W // new Array(64)

  Hash.call(this, 64, 56)
}

inherits(Sha224, Sha256)

Sha224.prototype.init = function () {
  this._a = 0xc1059ed8
  this._b = 0x367cd507
  this._c = 0x3070dd17
  this._d = 0xf70e5939
  this._e = 0xffc00b31
  this._f = 0x68581511
  this._g = 0x64f98fa7
  this._h = 0xbefa4fa4

  return this
}

Sha224.prototype._hash = function () {
  var H = Buffer.allocUnsafe(28)

  H.writeInt32BE(this._a, 0)
  H.writeInt32BE(this._b, 4)
  H.writeInt32BE(this._c, 8)
  H.writeInt32BE(this._d, 12)
  H.writeInt32BE(this._e, 16)
  H.writeInt32BE(this._f, 20)
  H.writeInt32BE(this._g, 24)

  return H
}

module.exports = Sha224


/***/ }),
/* 3494 */
/***/ (function(module, exports, __webpack_require__) {

var inherits = __webpack_require__(41)
var SHA512 = __webpack_require__(1591)
var Hash = __webpack_require__(297)
var Buffer = __webpack_require__(42).Buffer

var W = new Array(160)

function Sha384 () {
  this.init()
  this._w = W

  Hash.call(this, 128, 112)
}

inherits(Sha384, SHA512)

Sha384.prototype.init = function () {
  this._ah = 0xcbbb9d5d
  this._bh = 0x629a292a
  this._ch = 0x9159015a
  this._dh = 0x152fecd8
  this._eh = 0x67332667
  this._fh = 0x8eb44a87
  this._gh = 0xdb0c2e0d
  this._hh = 0x47b5481d

  this._al = 0xc1059ed8
  this._bl = 0x367cd507
  this._cl = 0x3070dd17
  this._dl = 0xf70e5939
  this._el = 0xffc00b31
  this._fl = 0x68581511
  this._gl = 0x64f98fa7
  this._hl = 0xbefa4fa4

  return this
}

Sha384.prototype._hash = function () {
  var H = Buffer.allocUnsafe(48)

  function writeInt64BE (h, l, offset) {
    H.writeInt32BE(h, offset)
    H.writeInt32BE(l, offset + 4)
  }

  writeInt64BE(this._ah, this._al, 0)
  writeInt64BE(this._bh, this._bl, 8)
  writeInt64BE(this._ch, this._cl, 16)
  writeInt64BE(this._dh, this._dl, 24)
  writeInt64BE(this._eh, this._el, 32)
  writeInt64BE(this._fh, this._fl, 40)

  return H
}

module.exports = Sha384


/***/ }),
/* 3495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function isFunction (funktion) {
  return typeof funktion === 'function'
}

// Default to complaining loudly when things don't go according to plan.
var logger = console.error.bind(console)

// Sets a property on an object, preserving its enumerability.
// This function assumes that the property is already writable.
function defineProperty (obj, name, value) {
  var enumerable = !!obj[name] && obj.propertyIsEnumerable(name)
  Object.defineProperty(obj, name, {
    configurable: true,
    enumerable: enumerable,
    writable: true,
    value: value
  })
}

// Keep initialization idempotent.
function shimmer (options) {
  if (options && options.logger) {
    if (!isFunction(options.logger)) logger("new logger isn't a function, not replacing")
    else logger = options.logger
  }
}

function wrap (nodule, name, wrapper) {
  if (!nodule || !nodule[name]) {
    logger('no original function ' + name + ' to wrap')
    return
  }

  if (!wrapper) {
    logger('no wrapper function')
    logger((new Error()).stack)
    return
  }

  if (!isFunction(nodule[name]) || !isFunction(wrapper)) {
    logger('original object and wrapper must be functions')
    return
  }

  var original = nodule[name]
  var wrapped = wrapper(original, name)

  defineProperty(wrapped, '__original', original)
  defineProperty(wrapped, '__unwrap', function () {
    if (nodule[name] === wrapped) defineProperty(nodule, name, original)
  })
  defineProperty(wrapped, '__wrapped', true)

  defineProperty(nodule, name, wrapped)
  return wrapped
}

function massWrap (nodules, names, wrapper) {
  if (!nodules) {
    logger('must provide one or more modules to patch')
    logger((new Error()).stack)
    return
  } else if (!Array.isArray(nodules)) {
    nodules = [nodules]
  }

  if (!(names && Array.isArray(names))) {
    logger('must provide one or more functions to wrap on modules')
    return
  }

  nodules.forEach(function (nodule) {
    names.forEach(function (name) {
      wrap(nodule, name, wrapper)
    })
  })
}

function unwrap (nodule, name) {
  if (!nodule || !nodule[name]) {
    logger('no function to unwrap.')
    logger((new Error()).stack)
    return
  }

  if (!nodule[name].__unwrap) {
    logger('no original to unwrap to -- has ' + name + ' already been unwrapped?')
  } else {
    return nodule[name].__unwrap()
  }
}

function massUnwrap (nodules, names) {
  if (!nodules) {
    logger('must provide one or more modules to patch')
    logger((new Error()).stack)
    return
  } else if (!Array.isArray(nodules)) {
    nodules = [nodules]
  }

  if (!(names && Array.isArray(names))) {
    logger('must provide one or more functions to unwrap on modules')
    return
  }

  nodules.forEach(function (nodule) {
    names.forEach(function (name) {
      unwrap(nodule, name)
    })
  })
}

shimmer.wrap = wrap
shimmer.massWrap = massWrap
shimmer.unwrap = unwrap
shimmer.massUnwrap = massUnwrap

module.exports = shimmer


/***/ }),
/* 3496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var inspect = __webpack_require__(453);

var $TypeError = __webpack_require__(282);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('./list.d.ts').listGetNode} */
// eslint-disable-next-line consistent-return
var listGetNode = function (list, key, isDelete) {
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	// eslint-disable-next-line eqeqeq
	for (; (curr = prev.next) != null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			if (!isDelete) {
				// eslint-disable-next-line no-extra-parens
				curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
				list.next = curr; // eslint-disable-line no-param-reassign
			}
			return curr;
		}
	}
};

/** @type {import('./list.d.ts').listGet} */
var listGet = function (objects, key) {
	if (!objects) {
		return void undefined;
	}
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('./list.d.ts').listHas} */
var listHas = function (objects, key) {
	if (!objects) {
		return false;
	}
	return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */
// eslint-disable-next-line consistent-return
var listDelete = function (objects, key) {
	if (objects) {
		return listGetNode(objects, key, true);
	}
};

/** @type {import('.')} */
module.exports = function getSideChannelList() {
	/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			var root = $o && $o.next;
			var deletedNode = listDelete($o, key);
			if (deletedNode && root && root === deletedNode) {
				$o = void undefined;
			}
			return !!deletedNode;
		},
		get: function (key) {
			return listGet($o, key);
		},
		has: function (key) {
			return listHas($o, key);
		},
		set: function (key, value) {
			if (!$o) {
				// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
				$o = {
					next: void undefined
				};
			}
			// eslint-disable-next-line no-extra-parens
			listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),
/* 3497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(655);
var callBound = __webpack_require__(1107);
var inspect = __webpack_require__(453);
var getSideChannelMap = __webpack_require__(1592);

var $TypeError = __webpack_require__(282);
var $WeakMap = GetIntrinsic('%WeakMap%', true);

/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapDelete = callBound('WeakMap.prototype.delete', true);

/** @type {import('.')} */
module.exports = $WeakMap
	? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
		/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */

		/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
		/** @type {Channel | undefined} */ var $m;

		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapDelete($wm, key);
					}
				} else if (getSideChannelMap) {
					if ($m) {
						return $m['delete'](key);
					}
				}
				return false;
			},
			get: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				}
				return $m && $m.get(key);
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				}
				return !!$m && $m.has(key);
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if (getSideChannelMap) {
					if (!$m) {
						$m = getSideChannelMap();
					}
					// eslint-disable-next-line no-extra-parens
					/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
				}
			}
		};

		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	}
	: getSideChannelMap;


/***/ }),
/* 3498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(282);
var inspect = __webpack_require__(453);
var getSideChannelList = __webpack_require__(3496);
var getSideChannelMap = __webpack_require__(1592);
var getSideChannelWeakMap = __webpack_require__(3497);

var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @typedef {ReturnType<typeof getSideChannel>} Channel */

	/** @type {Channel | undefined} */ var $channelData;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			return !!$channelData && $channelData['delete'](key);
		},
		get: function (key) {
			return $channelData && $channelData.get(key);
		},
		has: function (key) {
			return !!$channelData && $channelData.has(key);
		},
		set: function (key, value) {
			if (!$channelData) {
				$channelData = makeChannel();
			}

			$channelData.set(key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),
/* 3499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (str) {
	return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
		return '%' + c.charCodeAt(0).toString(16).toUpperCase();
	});
};


/***/ }),
/* 3500 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2834);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(211)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?-autoprefixer!../../node_modules/postcss-loader/index.js!../../node_modules/less-loader/index.js!./book.less", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?-autoprefixer!../../node_modules/postcss-loader/index.js!../../node_modules/less-loader/index.js!./book.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3501 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2835);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(211)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../node_modules/postcss-loader/index.js!../../../../../node_modules/less-loader/index.js!./compare.less", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../node_modules/postcss-loader/index.js!../../../../../node_modules/less-loader/index.js!./compare.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3502 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2836);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(211)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../node_modules/postcss-loader/index.js!../../../../../node_modules/less-loader/index.js!./project.less", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../node_modules/postcss-loader/index.js!../../../../../node_modules/less-loader/index.js!./project.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3503 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2837);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(211)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../node_modules/postcss-loader/index.js!../../../../../node_modules/less-loader/index.js!./unitsCompare.less", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js?-autoprefixer!../../../../../node_modules/postcss-loader/index.js!../../../../../node_modules/less-loader/index.js!./unitsCompare.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3504 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2838);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(211)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js?-autoprefixer!../../postcss-loader/index.js!./index.css", function() {
			var newContent = require("!!../../css-loader/index.js?-autoprefixer!../../postcss-loader/index.js!./index.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3505 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2839);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(211)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../css-loader/index.js?-autoprefixer!../../postcss-loader/index.js!./Calendar.css", function() {
			var newContent = require("!!../../css-loader/index.js?-autoprefixer!../../postcss-loader/index.js!./Calendar.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3506 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2841);
if(typeof content === 'string') content = [[module.i, content, '']];
// add the styles to the DOM
var update = __webpack_require__(211)(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../node_modules/css-loader/index.js?-autoprefixer!../../node_modules/postcss-loader/index.js!./FormGroup.css", function() {
			var newContent = require("!!../../node_modules/css-loader/index.js?-autoprefixer!../../node_modules/postcss-loader/index.js!./FormGroup.css");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 3507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(3508);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(56), __webpack_require__(766)(module)))

/***/ }),
/* 3508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 3509 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1589);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 3510 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.trimCanvas=t():e.trimCanvas=t()}(this,function(){return function(e){function t(n){if(r[n])return r[n].exports;var o=r[n]={exports:{},id:n,loaded:!1};return e[n].call(o.exports,o,o.exports,t),o.loaded=!0,o.exports}var r={};return t.m=e,t.c=r,t.p="",t(0)}([function(e,t){"use strict";function r(e){var t=e.getContext("2d"),r=e.width,n=e.height,o=t.getImageData(0,0,r,n).data,f=a(!0,r,n,o),i=a(!1,r,n,o),c=u(!0,r,n,o),d=u(!1,r,n,o),p=d-c+1,l=i-f+1,s=t.getImageData(c,f,p,l);return e.width=p,e.height=l,t.clearRect(0,0,p,l),t.putImageData(s,0,0),e}function n(e,t,r,n){return{red:n[4*(r*t+e)],green:n[4*(r*t+e)+1],blue:n[4*(r*t+e)+2],alpha:n[4*(r*t+e)+3]}}function o(e,t,r,o){return n(e,t,r,o).alpha}function a(e,t,r,n){for(var a=e?1:-1,u=e?0:r-1,f=u;e?f<r:f>-1;f+=a)for(var i=0;i<t;i++)if(o(i,f,t,n))return f;return null}function u(e,t,r,n){for(var a=e?1:-1,u=e?0:t-1,f=u;e?f<t:f>-1;f+=a)for(var i=0;i<r;i++)if(o(f,i,t,n))return f;return null}Object.defineProperty(t,"__esModule",{value:!0}),t.default=r}])});

/***/ }),
/* 3511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InvariantError", function() { return InvariantError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "invariant", function() { return invariant; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "process", function() { return processStub; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setVerbosity", function() { return setVerbosity; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_tslib__ = __webpack_require__(31);


var genericMessage = "Invariant Violation";
var _a = Object.setPrototypeOf, setPrototypeOf = _a === void 0 ? function (obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : _a;
var InvariantError = /** @class */ (function (_super) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_tslib__["__extends"])(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) { message = genericMessage; }
        var _this = _super.call(this, typeof message === "number"
            ? genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)"
            : message) || this;
        _this.framesToPop = 1;
        _this.name = genericMessage;
        setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error));
function invariant(condition, message) {
    if (!condition) {
        throw new InvariantError(message);
    }
}
var verbosityLevels = ["log", "warn", "error", "silent"];
var verbosityLevel = verbosityLevels.indexOf("log");
function wrapConsoleMethod(method) {
    return function () {
        if (verbosityLevels.indexOf(method) >= verbosityLevel) {
            return console[method].apply(console, arguments);
        }
    };
}
(function (invariant) {
    invariant.log = wrapConsoleMethod("log");
    invariant.warn = wrapConsoleMethod("warn");
    invariant.error = wrapConsoleMethod("error");
})(invariant || (invariant = {}));
function setVerbosity(level) {
    var old = verbosityLevels[verbosityLevel];
    verbosityLevel = Math.max(0, verbosityLevels.indexOf(level));
    return old;
}
// Code that uses ts-invariant with rollup-plugin-invariant may want to
// import this process stub to avoid errors evaluating process.env.NODE_ENV.
// However, because most ESM-to-CJS compilers will rewrite the process import
// as tsInvariant.process, which prevents proper replacement by minifiers, we
// also attempt to define the stub globally when it is not already defined.
var processStub = { env: {} };
if (typeof process === "object") {
    processStub = process;
}
else
    try {
        // Using Function to evaluate this assignment in global scope also escapes
        // the strict mode of the current module, thereby allowing the assignment.
        // Inspired by https://github.com/facebook/regenerator/pull/369.
        Function("stub", "process = stub")(processStub);
    }
    catch (atLeastWeTried) {
        // The assignment can fail if a Content Security Policy heavy-handedly
        // forbids Function usage. In those environments, developers should take
        // extra care to replace process.env.NODE_ENV in their production builds,
        // or define an appropriate global.process polyfill.
    }
var invariant$1 = invariant;

/* harmony default export */ __webpack_exports__["default"] = (invariant$1);

//# sourceMappingURL=invariant.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(90)))

/***/ }),
/* 3512 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * UAParser.js v0.7.20
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2019 Faisal Salman <f@faisalman.com>
 * Licensed under MIT License
 */

(function (window, undefined) {

    'use strict';

    //////////////
    // Constants
    /////////////


    var LIBVERSION  = '0.7.20',
        EMPTY       = '',
        UNKNOWN     = '?',
        FUNC_TYPE   = 'function',
        UNDEF_TYPE  = 'undefined',
        OBJ_TYPE    = 'object',
        STR_TYPE    = 'string',
        MAJOR       = 'major', // deprecated
        MODEL       = 'model',
        NAME        = 'name',
        TYPE        = 'type',
        VENDOR      = 'vendor',
        VERSION     = 'version',
        ARCHITECTURE= 'architecture',
        CONSOLE     = 'console',
        MOBILE      = 'mobile',
        TABLET      = 'tablet',
        SMARTTV     = 'smarttv',
        WEARABLE    = 'wearable',
        EMBEDDED    = 'embedded';


    ///////////
    // Helper
    //////////


    var util = {
        extend : function (regexes, extensions) {
            var mergedRegexes = {};
            for (var i in regexes) {
                if (extensions[i] && extensions[i].length % 2 === 0) {
                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
                } else {
                    mergedRegexes[i] = regexes[i];
                }
            }
            return mergedRegexes;
        },
        has : function (str1, str2) {
          if (typeof str1 === "string") {
            return str2.toLowerCase().indexOf(str1.toLowerCase()) !== -1;
          } else {
            return false;
          }
        },
        lowerize : function (str) {
            return str.toLowerCase();
        },
        major : function (version) {
            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g,'').split(".")[0] : undefined;
        },
        trim : function (str) {
          return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
        }
    };


    ///////////////
    // Map helper
    //////////////


    var mapper = {

        rgx : function (ua, arrays) {

            var i = 0, j, k, p, q, matches, match;

            // loop through all regexes maps
            while (i < arrays.length && !matches) {

                var regex = arrays[i],       // even sequence (0,2,4,..)
                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
                j = k = 0;

                // try matching uastring with regexes
                while (j < regex.length && !matches) {

                    matches = regex[j++].exec(ua);

                    if (!!matches) {
                        for (p = 0; p < props.length; p++) {
                            match = matches[++k];
                            q = props[p];
                            // check if given property is actually array
                            if (typeof q === OBJ_TYPE && q.length > 0) {
                                if (q.length == 2) {
                                    if (typeof q[1] == FUNC_TYPE) {
                                        // assign modified match
                                        this[q[0]] = q[1].call(this, match);
                                    } else {
                                        // assign given value, ignore regex match
                                        this[q[0]] = q[1];
                                    }
                                } else if (q.length == 3) {
                                    // check whether function or regex
                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
                                        // call function (usually string mapper)
                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
                                    } else {
                                        // sanitize match using given regex
                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
                                    }
                                } else if (q.length == 4) {
                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
                                }
                            } else {
                                this[q] = match ? match : undefined;
                            }
                        }
                    }
                }
                i += 2;
            }
        },

        str : function (str, map) {

            for (var i in map) {
                // check if array
                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
                    for (var j = 0; j < map[i].length; j++) {
                        if (util.has(map[i][j], str)) {
                            return (i === UNKNOWN) ? undefined : i;
                        }
                    }
                } else if (util.has(map[i], str)) {
                    return (i === UNKNOWN) ? undefined : i;
                }
            }
            return str;
        }
    };


    ///////////////
    // String map
    //////////////


    var maps = {

        browser : {
            oldsafari : {
                version : {
                    '1.0'   : '/8',
                    '1.2'   : '/1',
                    '1.3'   : '/3',
                    '2.0'   : '/412',
                    '2.0.2' : '/416',
                    '2.0.3' : '/417',
                    '2.0.4' : '/419',
                    '?'     : '/'
                }
            }
        },

        device : {
            amazon : {
                model : {
                    'Fire Phone' : ['SD', 'KF']
                }
            },
            sprint : {
                model : {
                    'Evo Shift 4G' : '7373KT'
                },
                vendor : {
                    'HTC'       : 'APA',
                    'Sprint'    : 'Sprint'
                }
            }
        },

        os : {
            windows : {
                version : {
                    'ME'        : '4.90',
                    'NT 3.11'   : 'NT3.51',
                    'NT 4.0'    : 'NT4.0',
                    '2000'      : 'NT 5.0',
                    'XP'        : ['NT 5.1', 'NT 5.2'],
                    'Vista'     : 'NT 6.0',
                    '7'         : 'NT 6.1',
                    '8'         : 'NT 6.2',
                    '8.1'       : 'NT 6.3',
                    '10'        : ['NT 6.4', 'NT 10.0'],
                    'RT'        : 'ARM'
                }
            }
        }
    };


    //////////////
    // Regex map
    /////////////


    var regexes = {

        browser : [[

            // Presto based
            /(opera\smini)\/([\w\.-]+)/i,                                       // Opera Mini
            /(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,                      // Opera Mobi/Tablet
            /(opera).+version\/([\w\.]+)/i,                                     // Opera > 9.80
            /(opera)[\/\s]+([\w\.]+)/i                                          // Opera < 9.80
            ], [NAME, VERSION], [

            /(opios)[\/\s]+([\w\.]+)/i                                          // Opera mini on iphone >= 8.0
            ], [[NAME, 'Opera Mini'], VERSION], [

            /\s(opr)\/([\w\.]+)/i                                               // Opera Webkit
            ], [[NAME, 'Opera'], VERSION], [

            // Mixed
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,
                                                                                // Lunascape/Maxthon/Netfront/Jasmine/Blazer

            // Trident based
            /(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,
                                                                                // Avant/IEMobile/SlimBrowser/Baidu
            /(?:ms|\()(ie)\s([\w\.]+)/i,                                        // Internet Explorer

            // Webkit/KHTML based
            /(rekonq)\/([\w\.]*)/i,                                             // Rekonq
            /(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon)\/([\w\.-]+)/i
                                                                                // Chromium/Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
            ], [NAME, VERSION], [

            /(konqueror)\/([\w\.]+)/i                                           // Konqueror
            ], [[NAME, 'Konqueror'], VERSION], [

            /(trident).+rv[:\s]([\w\.]+).+like\sgecko/i                         // IE11
            ], [[NAME, 'IE'], VERSION], [

            /(edge|edgios|edga|edg)\/((\d+)?[\w\.]+)/i                          // Microsoft Edge
            ], [[NAME, 'Edge'], VERSION], [

            /(yabrowser)\/([\w\.]+)/i                                           // Yandex
            ], [[NAME, 'Yandex'], VERSION], [

            /(puffin)\/([\w\.]+)/i                                              // Puffin
            ], [[NAME, 'Puffin'], VERSION], [

            /(focus)\/([\w\.]+)/i                                               // Firefox Focus
            ], [[NAME, 'Firefox Focus'], VERSION], [

            /(opt)\/([\w\.]+)/i                                                 // Opera Touch
            ], [[NAME, 'Opera Touch'], VERSION], [

            /((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i         // UCBrowser
            ], [[NAME, 'UCBrowser'], VERSION], [

            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
            ], [[NAME, /_/g, ' '], VERSION], [

            /(windowswechat qbcore)\/([\w\.]+)/i                                // WeChat Desktop for Windows Built-in Browser
            ], [[NAME, 'WeChat(Win) Desktop'], VERSION], [

            /(micromessenger)\/([\w\.]+)/i                                      // WeChat
            ], [[NAME, 'WeChat'], VERSION], [

            /(brave)\/([\w\.]+)/i                                              // Brave browser
            ], [[NAME, 'Brave'], VERSION], [

            /(qqbrowserlite)\/([\w\.]+)/i                                       // QQBrowserLite
            ], [NAME, VERSION], [

            /(QQ)\/([\d\.]+)/i                                                  // QQ, aka ShouQ
            ], [NAME, VERSION], [

            /m?(qqbrowser)[\/\s]?([\w\.]+)/i                                    // QQBrowser
            ], [NAME, VERSION], [

            /(BIDUBrowser)[\/\s]?([\w\.]+)/i                                    // Baidu Browser
            ], [NAME, VERSION], [

            /(2345Explorer)[\/\s]?([\w\.]+)/i                                   // 2345 Browser
            ], [NAME, VERSION], [

            /(MetaSr)[\/\s]?([\w\.]+)/i                                         // SouGouBrowser
            ], [NAME], [

            /(LBBROWSER)/i                                      // LieBao Browser
            ], [NAME], [

            /xiaomi\/miuibrowser\/([\w\.]+)/i                                   // MIUI Browser
            ], [VERSION, [NAME, 'MIUI Browser']], [

            /;fbav\/([\w\.]+);/i                                                // Facebook App for iOS & Android
            ], [VERSION, [NAME, 'Facebook']], [

            /safari\s(line)\/([\w\.]+)/i,                                       // Line App for iOS
            /android.+(line)\/([\w\.]+)\/iab/i                                  // Line App for Android
            ], [NAME, VERSION], [

            /headlesschrome(?:\/([\w\.]+)|\s)/i                                 // Chrome Headless
            ], [VERSION, [NAME, 'Chrome Headless']], [

            /\swv\).+(chrome)\/([\w\.]+)/i                                      // Chrome WebView
            ], [[NAME, /(.+)/, '$1 WebView'], VERSION], [

            /((?:oculus|samsung)browser)\/([\w\.]+)/i
            ], [[NAME, /(.+(?:g|us))(.+)/, '$1 $2'], VERSION], [                // Oculus / Samsung Browser

            /android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i        // Android Browser
            ], [VERSION, [NAME, 'Android Browser']], [

            /(sailfishbrowser)\/([\w\.]+)/i                                     // Sailfish Browser
            ], [[NAME, 'Sailfish Browser'], VERSION], [

            /(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i
                                                                                // Chrome/OmniWeb/Arora/Tizen/Nokia
            ], [NAME, VERSION], [

            /(dolfin)\/([\w\.]+)/i                                              // Dolphin
            ], [[NAME, 'Dolphin'], VERSION], [

            /((?:android.+)crmo|crios)\/([\w\.]+)/i                             // Chrome for Android/iOS
            ], [[NAME, 'Chrome'], VERSION], [

            /(coast)\/([\w\.]+)/i                                               // Opera Coast
            ], [[NAME, 'Opera Coast'], VERSION], [

            /fxios\/([\w\.-]+)/i                                                // Firefox for iOS
            ], [VERSION, [NAME, 'Firefox']], [

            /version\/([\w\.]+).+?mobile\/\w+\s(safari)/i                       // Mobile Safari
            ], [VERSION, [NAME, 'Mobile Safari']], [

            /version\/([\w\.]+).+?(mobile\s?safari|safari)/i                    // Safari & Safari Mobile
            ], [VERSION, NAME], [

            /webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i  // Google Search Appliance on iOS
            ], [[NAME, 'GSA'], VERSION], [

            /webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i                     // Safari < 3.0
            ], [NAME, [VERSION, mapper.str, maps.browser.oldsafari.version]], [

            /(webkit|khtml)\/([\w\.]+)/i
            ], [NAME, VERSION], [

            // Gecko based
            /(navigator|netscape)\/([\w\.-]+)/i                                 // Netscape
            ], [[NAME, 'Netscape'], VERSION], [
            /(swiftfox)/i,                                                      // Swiftfox
            /(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,
                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror
            /(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,

                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
            /(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,                          // Mozilla

            // Other
            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,
                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir
            /(links)\s\(([\w\.]+)/i,                                            // Links
            /(gobrowser)\/?([\w\.]*)/i,                                         // GoBrowser
            /(ice\s?browser)\/v?([\w\._]+)/i,                                   // ICE Browser
            /(mosaic)[\/\s]([\w\.]+)/i                                          // Mosaic
            ], [NAME, VERSION]
        ],

        cpu : [[

            /(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i                     // AMD64
            ], [[ARCHITECTURE, 'amd64']], [

            /(ia32(?=;))/i                                                      // IA32 (quicktime)
            ], [[ARCHITECTURE, util.lowerize]], [

            /((?:i[346]|x)86)[;\)]/i                                            // IA32
            ], [[ARCHITECTURE, 'ia32']], [

            // PocketPC mistakenly identified as PowerPC
            /windows\s(ce|mobile);\sppc;/i
            ], [[ARCHITECTURE, 'arm']], [

            /((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i                           // PowerPC
            ], [[ARCHITECTURE, /ower/, '', util.lowerize]], [

            /(sun4\w)[;\)]/i                                                    // SPARC
            ], [[ARCHITECTURE, 'sparc']], [

            /((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+[;l]))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i
                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
            ], [[ARCHITECTURE, util.lowerize]]
        ],

        device : [[

            /\((ipad|playbook);[\w\s\),;-]+(rim|apple)/i                        // iPad/PlayBook
            ], [MODEL, VENDOR, [TYPE, TABLET]], [

            /applecoremedia\/[\w\.]+ \((ipad)/                                  // iPad
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, TABLET]], [

            /(apple\s{0,1}tv)/i                                                 // Apple TV
            ], [[MODEL, 'Apple TV'], [VENDOR, 'Apple']], [

            /(archos)\s(gamepad2?)/i,                                           // Archos
            /(hp).+(touchpad)/i,                                                // HP TouchPad
            /(hp).+(tablet)/i,                                                  // HP Tablet
            /(kindle)\/([\w\.]+)/i,                                             // Kindle
            /\s(nook)[\w\s]+build\/(\w+)/i,                                     // Nook
            /(dell)\s(strea[kpr\s\d]*[\dko])/i                                  // Dell Streak
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /(kf[A-z]+)\sbuild\/.+silk\//i                                      // Kindle Fire HD
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [
            /(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i                         // Fire Phone
            ], [[MODEL, mapper.str, maps.device.amazon.model], [VENDOR, 'Amazon'], [TYPE, MOBILE]], [
            /android.+aft([bms])\sbuild/i                                       // Fire TV
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, SMARTTV]], [

            /\((ip[honed|\s\w*]+);.+(apple)/i                                   // iPod/iPhone
            ], [MODEL, VENDOR, [TYPE, MOBILE]], [
            /\((ip[honed|\s\w*]+);/i                                            // iPod/iPhone
            ], [MODEL, [VENDOR, 'Apple'], [TYPE, MOBILE]], [

            /(blackberry)[\s-]?(\w+)/i,                                         // BlackBerry
            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,
                                                                                // BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
            /(hp)\s([\w\s]+\w)/i,                                               // HP iPAQ
            /(asus)-?(\w+)/i                                                    // Asus
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
            /\(bb10;\s(\w+)/i                                                   // BlackBerry 10
            ], [MODEL, [VENDOR, 'BlackBerry'], [TYPE, MOBILE]], [
                                                                                // Asus Tablets
            /android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone|p00c)/i
            ], [MODEL, [VENDOR, 'Asus'], [TYPE, TABLET]], [

            /(sony)\s(tablet\s[ps])\sbuild\//i,                                  // Sony
            /(sony)?(?:sgp.+)\sbuild\//i
            ], [[VENDOR, 'Sony'], [MODEL, 'Xperia Tablet'], [TYPE, TABLET]], [
            /android.+\s([c-g]\d{4}|so[-l]\w+)(?=\sbuild\/|\).+chrome\/(?![1-6]{0,1}\d\.))/i
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, MOBILE]], [

            /\s(ouya)\s/i,                                                      // Ouya
            /(nintendo)\s([wids3u]+)/i                                          // Nintendo
            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [

            /android.+;\s(shield)\sbuild/i                                      // Nvidia
            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [

            /(playstation\s[34portablevi]+)/i                                   // Playstation
            ], [MODEL, [VENDOR, 'Sony'], [TYPE, CONSOLE]], [

            /(sprint\s(\w+))/i                                                  // Sprint Phones
            ], [[VENDOR, mapper.str, maps.device.sprint.vendor], [MODEL, mapper.str, maps.device.sprint.model], [TYPE, MOBILE]], [

            /(htc)[;_\s-]+([\w\s]+(?=\)|\sbuild)|\w+)/i,                        // HTC
            /(zte)-(\w*)/i,                                                     // ZTE
            /(alcatel|geeksphone|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i
                                                                                // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [

            /(nexus\s9)/i                                                       // HTC Nexus 9
            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [

            /d\/huawei([\w\s-]+)[;\)]/i,
            /(nexus\s6p)/i                                                      // Huawei
            ], [MODEL, [VENDOR, 'Huawei'], [TYPE, MOBILE]], [

            /(microsoft);\s(lumia[\s\w]+)/i                                     // Microsoft Lumia
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /[\s\(;](xbox(?:\sone)?)[\s\);]/i                                   // Microsoft Xbox
            ], [MODEL, [VENDOR, 'Microsoft'], [TYPE, CONSOLE]], [
            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
            ], [[MODEL, /\./g, ' '], [VENDOR, 'Microsoft'], [TYPE, MOBILE]], [

                                                                                // Motorola
            /\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,
            /mot[\s-]?(\w*)/i,
            /(XT\d{3,4}) build\//i,
            /(nexus\s6)/i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, MOBILE]], [
            /android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i
            ], [MODEL, [VENDOR, 'Motorola'], [TYPE, TABLET]], [

            /hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i            // HbbTV devices
            ], [[VENDOR, util.trim], [MODEL, util.trim], [TYPE, SMARTTV]], [

            /hbbtv.+maple;(\d+)/i
            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, 'Samsung'], [TYPE, SMARTTV]], [

            /\(dtv[\);].+(aquos)/i                                              // Sharp
            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [

            /android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,
            /((SM-T\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, TABLET]], [                  // Samsung
            /smart-tv.+(samsung)/i
            ], [VENDOR, [TYPE, SMARTTV], MODEL], [
            /((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,
            /(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,
            /sec-((sgh\w+))/i
            ], [[VENDOR, 'Samsung'], MODEL, [TYPE, MOBILE]], [

            /sie-(\w*)/i                                                        // Siemens
            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [

            /(maemo|nokia).*(n900|lumia\s\d+)/i,                                // Nokia
            /(nokia)[\s_-]?([\w-]*)/i
            ], [[VENDOR, 'Nokia'], MODEL, [TYPE, MOBILE]], [

            /android[x\d\.\s;]+\s([ab][1-7]\-?[0178a]\d\d?)/i                   // Acer
            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [

            /android.+([vl]k\-?\d{3})\s+build/i                                 // LG Tablet
            ], [MODEL, [VENDOR, 'LG'], [TYPE, TABLET]], [
            /android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i                     // LG Tablet
            ], [[VENDOR, 'LG'], MODEL, [TYPE, TABLET]], [
            /(lg) netcast\.tv/i                                                 // LG SmartTV
            ], [VENDOR, MODEL, [TYPE, SMARTTV]], [
            /(nexus\s[45])/i,                                                   // LG
            /lg[e;\s\/-]+(\w*)/i,
            /android.+lg(\-?[\d\w]+)\s+build/i
            ], [MODEL, [VENDOR, 'LG'], [TYPE, MOBILE]], [

            /(lenovo)\s?(s(?:5000|6000)(?:[\w-]+)|tab(?:[\s\w]+))/i             // Lenovo tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [
            /android.+(ideatab[a-z0-9\-\s]+)/i                                  // Lenovo
            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
            /(lenovo)[_\s-]?([\w-]+)/i
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /linux;.+((jolla));/i                                               // Jolla
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /((pebble))app\/[\d\.]+\s/i                                         // Pebble
            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [

            /android.+;\s(oppo)\s?([\w\s]+)\sbuild/i                            // OPPO
            ], [VENDOR, MODEL, [TYPE, MOBILE]], [

            /crkey/i                                                            // Google Chromecast
            ], [[MODEL, 'Chromecast'], [VENDOR, 'Google']], [

            /android.+;\s(glass)\s\d/i                                          // Google Glass
            ], [MODEL, [VENDOR, 'Google'], [TYPE, WEARABLE]], [

            /android.+;\s(pixel c)[\s)]/i                                       // Google Pixel C
            ], [MODEL, [VENDOR, 'Google'], [TYPE, TABLET]], [

            /android.+;\s(pixel( [23])?( xl)?)[\s)]/i                              // Google Pixel
            ], [MODEL, [VENDOR, 'Google'], [TYPE, MOBILE]], [

            /android.+;\s(\w+)\s+build\/hm\1/i,                                 // Xiaomi Hongmi 'numeric' models
            /android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,               // Xiaomi Hongmi
            /android.+(mi[\s\-_]*(?:a\d|one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,    
                                                                                // Xiaomi Mi
            /android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i       // Redmi Phones
            ], [[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, MOBILE]], [
            /android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i            // Mi Pad tablets
            ],[[MODEL, /_/g, ' '], [VENDOR, 'Xiaomi'], [TYPE, TABLET]], [
            /android.+;\s(m[1-5]\snote)\sbuild/i                                // Meizu
            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
            /(mz)-([\w-]{2,})/i
            ], [[VENDOR, 'Meizu'], MODEL, [TYPE, MOBILE]], [

            /android.+a000(1)\s+build/i,                                        // OnePlus
            /android.+oneplus\s(a\d{4})\s+build/i
            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(RCT[\d\w]+)\s+build/i                            // RCA Tablets
            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [

            /android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i                      // Dell Venue Tablets
            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i                         // Verizon Tablet
            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [

            /android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i     // Barnes & Noble Tablet
            ], [[VENDOR, 'Barnes & Noble'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i                           // Barnes & Noble Tablet
            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [

            /android.+;\s(k88)\sbuild/i                                         // ZTE K Series Tablet
            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(gen\d{3})\s+build.*49h/i                         // Swiss GEN Mobile
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [

            /android.+[;\/]\s*(zur\d{3})\s+build/i                              // Swiss ZUR Tablet
            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i                         // Zeki Tablets
            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [

            /(android).+[;\/]\s+([YR]\d{2})\s+build/i,
            /android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i        // Dragon Touch Tablet
            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i                            // Insignia Tablets
            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [

            /android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i                    // NextBook Tablets
            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i
            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [                    // Voice Xtreme Phones

            /android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i                     // LvTel Phones
            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [

            /android.+;\s(PH-1)\s/i
            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [                // Essential PH-1

            /android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i          // Envizen Tablets
            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i          // Le Pan Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i                         // MachSpeed Tablets
            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [

            /android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i                // Trinity Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /android.+[;\/]\s*TU_(1491)\s+build/i                               // Rotor Tablets
            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [

            /android.+(KS(.+))\s+build/i                                        // Amazon Kindle Tablets
            ], [MODEL, [VENDOR, 'Amazon'], [TYPE, TABLET]], [

            /android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i                      // Gigaset Tablets
            ], [VENDOR, MODEL, [TYPE, TABLET]], [

            /\s(tablet|tab)[;\/]/i,                                             // Unidentifiable Tablet
            /\s(mobile)(?:[;\/]|\ssafari)/i                                     // Unidentifiable Mobile
            ], [[TYPE, util.lowerize], VENDOR, MODEL], [

            /[\s\/\(](smart-?tv)[;\)]/i                                         // SmartTV
            ], [[TYPE, SMARTTV]], [

            /(android[\w\.\s\-]{0,9});.+build/i                                 // Generic Android Device
            ], [MODEL, [VENDOR, 'Generic']]
        ],

        engine : [[

            /windows.+\sedge\/([\w\.]+)/i                                       // EdgeHTML
            ], [VERSION, [NAME, 'EdgeHTML']], [

            /webkit\/537\.36.+chrome\/(?!27)/i                                  // Blink
            ], [[NAME, 'Blink']], [

            /(presto)\/([\w\.]+)/i,                                             // Presto
            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,     
                                                                                // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
            /(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,                          // KHTML/Tasman/Links
            /(icab)[\/\s]([23]\.[\d\.]+)/i                                      // iCab
            ], [NAME, VERSION], [

            /rv\:([\w\.]{1,9}).+(gecko)/i                                       // Gecko
            ], [VERSION, NAME]
        ],

        os : [[

            // Windows based
            /microsoft\s(windows)\s(vista|xp)/i                                 // Windows (iTunes)
            ], [NAME, VERSION], [
            /(windows)\snt\s6\.2;\s(arm)/i,                                     // Windows RT
            /(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,                   // Windows Phone
            /(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i
            ], [NAME, [VERSION, mapper.str, maps.os.windows.version]], [
            /(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i
            ], [[NAME, 'Windows'], [VERSION, mapper.str, maps.os.windows.version]], [

            // Mobile/Embedded OS
            /\((bb)(10);/i                                                      // BlackBerry 10
            ], [[NAME, 'BlackBerry'], VERSION], [
            /(blackberry)\w*\/?([\w\.]*)/i,                                     // Blackberry
            /(tizen)[\/\s]([\w\.]+)/i,                                          // Tizen
            /(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|sailfish|contiki)[\/\s-]?([\w\.]*)/i
                                                                                // Android/WebOS/Palm/QNX/Bada/RIM/MeeGo/Contiki/Sailfish OS
            ], [NAME, VERSION], [
            /(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i                  // Symbian
            ], [[NAME, 'Symbian'], VERSION], [
            /\((series40);/i                                                    // Series 40
            ], [NAME], [
            /mozilla.+\(mobile;.+gecko.+firefox/i                               // Firefox OS
            ], [[NAME, 'Firefox OS'], VERSION], [

            // Console
            /(nintendo|playstation)\s([wids34portablevu]+)/i,                   // Nintendo/Playstation

            // GNU/Linux based
            /(mint)[\/\s\(]?(\w*)/i,                                            // Mint
            /(mageia|vectorlinux)[;\s]/i,                                       // Mageia/VectorLinux
            /(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,
                                                                                // Joli/Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware
                                                                                // Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus
            /(hurd|linux)\s?([\w\.]*)/i,                                        // Hurd/Linux
            /(gnu)\s?([\w\.]*)/i                                                // GNU
            ], [NAME, VERSION], [

            /(cros)\s[\w]+\s([\w\.]+\w)/i                                       // Chromium OS
            ], [[NAME, 'Chromium OS'], VERSION],[

            // Solaris
            /(sunos)\s?([\w\.\d]*)/i                                            // Solaris
            ], [[NAME, 'Solaris'], VERSION], [

            // BSD based
            /\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i                    // FreeBSD/NetBSD/OpenBSD/PC-BSD/DragonFly
            ], [NAME, VERSION],[

            /(haiku)\s(\w+)/i                                                   // Haiku
            ], [NAME, VERSION],[

            /cfnetwork\/.+darwin/i,
            /ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i             // iOS
            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [

            /(mac\sos\sx)\s?([\w\s\.]*)/i,
            /(macintosh|mac(?=_powerpc)\s)/i                                    // Mac OS
            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [

            // Other
            /((?:open)?solaris)[\/\s-]?([\w\.]*)/i,                             // Solaris
            /(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,                                // AIX
            /(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms|fuchsia)/i,
                                                                                // Plan9/Minix/BeOS/OS2/AmigaOS/MorphOS/RISCOS/OpenVMS/Fuchsia
            /(unix)\s?([\w\.]*)/i                                               // UNIX
            ], [NAME, VERSION]
        ]
    };


    /////////////////
    // Constructor
    ////////////////
    var UAParser = function (uastring, extensions) {

        if (typeof uastring === 'object') {
            extensions = uastring;
            uastring = undefined;
        }

        if (!(this instanceof UAParser)) {
            return new UAParser(uastring, extensions).getResult();
        }

        var ua = uastring || ((window && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
        var rgxmap = extensions ? util.extend(regexes, extensions) : regexes;

        this.getBrowser = function () {
            var browser = { name: undefined, version: undefined };
            mapper.rgx.call(browser, ua, rgxmap.browser);
            browser.major = util.major(browser.version); // deprecated
            return browser;
        };
        this.getCPU = function () {
            var cpu = { architecture: undefined };
            mapper.rgx.call(cpu, ua, rgxmap.cpu);
            return cpu;
        };
        this.getDevice = function () {
            var device = { vendor: undefined, model: undefined, type: undefined };
            mapper.rgx.call(device, ua, rgxmap.device);
            return device;
        };
        this.getEngine = function () {
            var engine = { name: undefined, version: undefined };
            mapper.rgx.call(engine, ua, rgxmap.engine);
            return engine;
        };
        this.getOS = function () {
            var os = { name: undefined, version: undefined };
            mapper.rgx.call(os, ua, rgxmap.os);
            return os;
        };
        this.getResult = function () {
            return {
                ua      : this.getUA(),
                browser : this.getBrowser(),
                engine  : this.getEngine(),
                os      : this.getOS(),
                device  : this.getDevice(),
                cpu     : this.getCPU()
            };
        };
        this.getUA = function () {
            return ua;
        };
        this.setUA = function (uastring) {
            ua = uastring;
            return this;
        };
        return this;
    };

    UAParser.VERSION = LIBVERSION;
    UAParser.BROWSER = {
        NAME    : NAME,
        MAJOR   : MAJOR, // deprecated
        VERSION : VERSION
    };
    UAParser.CPU = {
        ARCHITECTURE : ARCHITECTURE
    };
    UAParser.DEVICE = {
        MODEL   : MODEL,
        VENDOR  : VENDOR,
        TYPE    : TYPE,
        CONSOLE : CONSOLE,
        MOBILE  : MOBILE,
        SMARTTV : SMARTTV,
        TABLET  : TABLET,
        WEARABLE: WEARABLE,
        EMBEDDED: EMBEDDED
    };
    UAParser.ENGINE = {
        NAME    : NAME,
        VERSION : VERSION
    };
    UAParser.OS = {
        NAME    : NAME,
        VERSION : VERSION
    };

    ///////////
    // Export
    //////////


    // check js environment
    if (typeof(exports) !== UNDEF_TYPE) {
        // nodejs env
        if (typeof module !== UNDEF_TYPE && module.exports) {
            exports = module.exports = UAParser;
        }
        exports.UAParser = UAParser;
    } else {
        // requirejs env (optional)
        if (true) {
            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
                return UAParser;
            }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
        } else if (window) {
            // browser env
            window.UAParser = UAParser;
        }
    }

    // jQuery/Zepto specific (optional)
    // Note:
    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
    //   and we should catch that.
    var $ = window && (window.jQuery || window.Zepto);
    if (typeof $ !== UNDEF_TYPE && !$.ua) {
        var parser = new UAParser();
        $.ua = parser.getResult();
        $.ua.get = function () {
            return parser.getUA();
        };
        $.ua.set = function (uastring) {
            parser.setUA(uastring);
            var result = parser.getResult();
            for (var prop in result) {
                $.ua[prop] = result[prop];
            }
        };
    }

})(typeof window === 'object' ? window : this);


/***/ }),
/* 3513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(3515);
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};


var Cookies = /** @class */ (function () {
    function Cookies(cookies, options) {
        var _this = this;
        this.changeListeners = [];
        this.HAS_DOCUMENT_COOKIE = false;
        this.cookies = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* parseCookies */])(cookies, options);
        new Promise(function () {
            _this.HAS_DOCUMENT_COOKIE = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["b" /* hasDocumentCookie */])();
        }).catch(function () { });
    }
    Cookies.prototype._updateBrowserValues = function (parseOptions) {
        if (!this.HAS_DOCUMENT_COOKIE) {
            return;
        }
        this.cookies = __WEBPACK_IMPORTED_MODULE_0_cookie__["parse"](document.cookie, parseOptions);
    };
    Cookies.prototype._emitChange = function (params) {
        for (var i = 0; i < this.changeListeners.length; ++i) {
            this.changeListeners[i](params);
        }
    };
    Cookies.prototype.get = function (name, options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* readCookie */])(this.cookies[name], options);
    };
    Cookies.prototype.getAll = function (options, parseOptions) {
        if (options === void 0) { options = {}; }
        this._updateBrowserValues(parseOptions);
        var result = {};
        for (var name_1 in this.cookies) {
            result[name_1] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__utils__["c" /* readCookie */])(this.cookies[name_1], options);
        }
        return result;
    };
    Cookies.prototype.set = function (name, value, options) {
        var _a;
        if (typeof value === 'object') {
            value = JSON.stringify(value);
        }
        this.cookies = __assign(__assign({}, this.cookies), (_a = {}, _a[name] = value, _a));
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = __WEBPACK_IMPORTED_MODULE_0_cookie__["serialize"](name, value, options);
        }
        this._emitChange({ name: name, value: value, options: options });
    };
    Cookies.prototype.remove = function (name, options) {
        var finalOptions = (options = __assign(__assign({}, options), { expires: new Date(1970, 1, 1, 0, 0, 1), maxAge: 0 }));
        this.cookies = __assign({}, this.cookies);
        delete this.cookies[name];
        if (this.HAS_DOCUMENT_COOKIE) {
            document.cookie = __WEBPACK_IMPORTED_MODULE_0_cookie__["serialize"](name, '', finalOptions);
        }
        this._emitChange({ name: name, value: undefined, options: options });
    };
    Cookies.prototype.addChangeListener = function (callback) {
        this.changeListeners.push(callback);
    };
    Cookies.prototype.removeChangeListener = function (callback) {
        var idx = this.changeListeners.indexOf(callback);
        if (idx >= 0) {
            this.changeListeners.splice(idx, 1);
        }
    };
    return Cookies;
}());
/* harmony default export */ __webpack_exports__["a"] = (Cookies);


/***/ }),
/* 3514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Cookies__ = __webpack_require__(3513);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0__Cookies__["a" /* default */]);


/***/ }),
/* 3515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = hasDocumentCookie;
/* unused harmony export cleanCookies */
/* harmony export (immutable) */ __webpack_exports__["a"] = parseCookies;
/* unused harmony export isParsingCookie */
/* harmony export (immutable) */ __webpack_exports__["c"] = readCookie;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_cookie__);

function hasDocumentCookie() {
    // Can we get/set cookies on document.cookie?
    return typeof document === 'object' && typeof document.cookie === 'string';
}
function cleanCookies() {
    document.cookie.split(';').forEach(function (c) {
        document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
}
function parseCookies(cookies, options) {
    if (typeof cookies === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_cookie__["parse"](cookies, options);
    }
    else if (typeof cookies === 'object' && cookies !== null) {
        return cookies;
    }
    else {
        return {};
    }
}
function isParsingCookie(value, doNotParse) {
    if (typeof doNotParse === 'undefined') {
        // We guess if the cookie start with { or [, it has been serialized
        doNotParse =
            !value || (value[0] !== '{' && value[0] !== '[' && value[0] !== '"');
    }
    return !doNotParse;
}
function readCookie(value, options) {
    if (options === void 0) { options = {}; }
    var cleanValue = cleanupCookieValue(value);
    if (isParsingCookie(cleanValue, options.doNotParse)) {
        try {
            return JSON.parse(cleanValue);
        }
        catch (e) {
            // At least we tried
        }
    }
    // Ignore clean value if we failed the deserialization
    // It is not relevant anymore to trim those values
    return value;
}
function cleanupCookieValue(value) {
    // express prepend j: before serializing a cookie
    if (value && value[0] === 'j' && value[1] === ':') {
        return value.substr(2);
    }
    return value;
}


/***/ }),
/* 3516 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 3517 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "1013ec43d08c24c72e04e562dd86ecc3.png";

/***/ }),
/* 3518 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 3519 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIgogIHZlcnNpb249IjEuMSIKICBpZD0ibWh1Yi1kcm9wZG93biIKICB4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjUxMnB4IiBoZWlnaHQ9IjUxMnB4IgogIHZpZXdCb3g9IjAgMCAyNTUgMjU1IgogIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDI1NSAyNTU7IgogIHhtbDpzcGFjZT0icHJlc2VydmUiPgogIDxnPgogICAgPHBvbHlnb24gcG9pbnRzPSIwLDYzLjc1IDEyNy41LDE5MS4yNSAyNTUsNjMuNzUgICAiIGRhdGEtb3JpZ2luYWw9IiMwMDAwMDAiIGNsYXNzPSJhY3RpdmUtcGF0aCIgZGF0YS1vbGRfY29sb3I9IiMwMDAwMDAiIGZpbGw9IiMzOTQwNDUiLz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 3520 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxLjgzY20iIGhlaWdodD0iMS44M2NtIiB2aWV3Qm94PSIwIDAgNTEuNzQgNTEuNzQiPgogIDx0aXRsZT5BbGVydC13aGl0ZTwvdGl0bGU+CiAgPGc+CiAgICA8Zz4KICAgICAgPHBhdGggZD0iTTI1Ljg3LDUxLjc0QTI1Ljg3LDI1Ljg3LDAsMSwxLDUxLjc0LDI1Ljg3LDI1LjksMjUuOSwwLDAsMSwyNS44Nyw1MS43NFpNMjUuODcsM0EyMi44NywyMi44NywwLDEsMCw0OC43NCwyNS44NywyMi45LDIyLjksMCwwLDAsMjUuODcsM1oiIHN0eWxlPSJmaWxsOiAjMzgzRjQzIi8+CiAgICA8L2c+CiAgICA8Zz4KICAgICAgPHBhdGggZD0iTTIyLjYyLDQzLjE1VjM3aDYuMzN2Ni4xN1ptMC0xMi4zM1YxMi4zMWg2LjMzVjMwLjgyWiIgc3R5bGU9ImZpbGw6ICMzODNGNDMiLz4KICAgIDwvZz4KICA8L2c+Cjwvc3ZnPgo="

/***/ }),
/* 3521 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 3522 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNCAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkuNjY2NjcgMS4zMzMwMVYzLjk5OTY3TTQuMzMzMzMgMS4zMzMwMVYzLjk5OTY3TTEgNi42NjYzNEgxM00yLjMzMzMzIDIuNjY2MzRIMTEuNjY2N0MxMi40MDMgMi42NjYzNCAxMyAzLjI2MzI5IDEzIDMuOTk5NjdWMTMuMzMzQzEzIDE0LjA2OTQgMTIuNDAzIDE0LjY2NjMgMTEuNjY2NyAxNC42NjYzSDIuMzMzMzNDMS41OTY5NSAxNC42NjYzIDEgMTQuMDY5NCAxIDEzLjMzM1YzLjk5OTY3QzEgMy4yNjMyOSAxLjU5Njk1IDIuNjY2MzQgMi4zMzMzMyAyLjY2NjM0WiIgc3Ryb2tlPSIjNTk2OTc1IiBzdHJva2Utd2lkdGg9IjEuMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),
/* 3523 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEwOTVfMTk0KSI+CjxwYXRoIGQ9Ik05IDQuNVY5TDEyIDEwLjVNMTYuNSA5QzE2LjUgMTMuMTQyMSAxMy4xNDIxIDE2LjUgOSAxNi41QzQuODU3ODYgMTYuNSAxLjUgMTMuMTQyMSAxLjUgOUMxLjUgNC44NTc4NiA0Ljg1Nzg2IDEuNSA5IDEuNUMxMy4xNDIxIDEuNSAxNi41IDQuODU3ODYgMTYuNSA5WiIgc3Ryb2tlPSIjREJERERFIiBzdHJva2Utd2lkdGg9IjEuNjY2NjciIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzEwOTVfMTk0Ij4KPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),
/* 3524 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgNC41VjlMMTIgMTAuNU0xNi41IDlDMTYuNSAxMy4xNDIxIDEzLjE0MjEgMTYuNSA5IDE2LjVDNC44NTc4NiAxNi41IDEuNSAxMy4xNDIxIDEuNSA5QzEuNSA0Ljg1Nzg2IDQuODU3ODYgMS41IDkgMS41QzEzLjE0MjEgMS41IDE2LjUgNC44NTc4NiAxNi41IDlaIiBzdHJva2U9IiNFRTAwMDAiIHN0cm9rZS13aWR0aD0iMS42NjY2NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),
/* 3525 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTkgNC41VjlMMTIgMTAuNU0xNi41IDlDMTYuNSAxMy4xNDIxIDEzLjE0MjEgMTYuNSA5IDE2LjVDNC44NTc4NiAxNi41IDEuNSAxMy4xNDIxIDEuNSA5QzEuNSA0Ljg1Nzg2IDQuODU3ODYgMS41IDkgMS41QzEzLjE0MjEgMS41IDE2LjUgNC44NTc4NiAxNi41IDlaIiBzdHJva2U9IiNGMkI0MkEiIHN0cm9rZS13aWR0aD0iMS42NjY2NyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo="

/***/ }),
/* 3526 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iRGVsZXRlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4LjQ2N21tIiBoZWlnaHQ9IjguNDY3bW0iIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgPHBhdGggZD0iTTIxLDQuODg4SDE2LjUzM1YzLjM2MmExLjUsMS41LDAsMCwwLTEuNS0xLjVIOS4wNDZhMS41LDEuNSwwLDAsMC0xLjUsMS41VjQuODg4SDN2MS41SDQuNTMyVjE5LjdhMi4zMywyLjMzLDAsMCwwLDIuMiwyLjQzOGgxMC42YTIuMzI5LDIuMzI5LDAsMCwwLDIuMi0yLjQzOFY2LjM4OEgyMVpNOS4wNDYsMy4zNjJoNS45ODdWNC44ODhIOS4wNDZaTTE4LjAzMiwxOS43YzAsLjUwOC0uMzE5LjkzOC0uNy45MzhINi43MjljLS4zNzgsMC0uNy0uNDMtLjctLjkzOFY2LjM4OGgxMlptLTcuNDg2LTkuNTU5djcuNWEuNzUuNzUsMCwwLDEtMS41LDB2LTcuNWEuNzUuNzUsMCwxLDEsMS41LDBabTQuNSwwdjcuNWEuNzUuNzUsMCwwLDEtMS41LDB2LTcuNWEuNzUuNzUsMCwxLDEsMS41LDBaIi8+Cjwvc3ZnPgo="

/***/ }),
/* 3527 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjM0OTYgMi4yNUg0Ljk0OTYxQzQuNTkxNTcgMi4yNSA0LjI0ODE5IDIuMzkyMjMgMy45OTUwMiAyLjY0NTQxQzMuNzQxODQgMi44OTg1OCAzLjU5OTYxIDMuMjQxOTYgMy41OTk2MSAzLjZWMTQuNEMzLjU5OTYxIDE0Ljc1OCAzLjc0MTg0IDE1LjEwMTQgMy45OTUwMiAxNS4zNTQ2QzQuMjQ4MTkgMTUuNjA3OCA0LjU5MTU3IDE1Ljc1IDQuOTQ5NjEgMTUuNzVIMTMuMDQ5NkMxMy40MDc3IDE1Ljc1IDEzLjc1MSAxNS42MDc4IDE0LjAwNDIgMTUuMzU0NkMxNC4yNTc0IDE1LjEwMTQgMTQuMzk5NiAxNC43NTggMTQuMzk5NiAxNC40VjYuM00xMC4zNDk2IDIuMjVMMTQuMzk5NiA2LjNNMTAuMzQ5NiAyLjI1VjYuM0gxNC4zOTk2IiBzdHJva2U9IiMyNEE0NzYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggb3BhY2l0eT0iMC44IiBkPSJNMTEuNjk5OCA5LjY3NDk5SDYuMjk5OE0xMS42OTk4IDEyLjM3NUg2LjI5OThNNy42NDk4IDYuOTc0OTlINi4yOTk4IiBzdHJva2U9IiMyNEE0NzYiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),
/* 3528 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjM0OTYgMi4yNUg0Ljk0OTYxQzQuNTkxNTcgMi4yNSA0LjI0ODE5IDIuMzkyMjMgMy45OTUwMiAyLjY0NTQxQzMuNzQxODQgMi44OTg1OCAzLjU5OTYxIDMuMjQxOTYgMy41OTk2MSAzLjZWMTQuNEMzLjU5OTYxIDE0Ljc1OCAzLjc0MTg0IDE1LjEwMTQgMy45OTUwMiAxNS4zNTQ2QzQuMjQ4MTkgMTUuNjA3OCA0LjU5MTU3IDE1Ljc1IDQuOTQ5NjEgMTUuNzVIMTMuMDQ5NkMxMy40MDc3IDE1Ljc1IDEzLjc1MSAxNS42MDc4IDE0LjAwNDIgMTUuMzU0NkMxNC4yNTc0IDE1LjEwMTQgMTQuMzk5NiAxNC43NTggMTQuMzk5NiAxNC40VjYuM00xMC4zNDk2IDIuMjVMMTQuMzk5NiA2LjNNMTAuMzQ5NiAyLjI1VjYuM0gxNC4zOTk2IiBzdHJva2U9IiNGRjc5NkUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggb3BhY2l0eT0iMC44IiBkPSJNMTEuNjk5OCA5LjY3NDk5SDYuMjk5OE0xMS42OTk4IDEyLjM3NUg2LjI5OThNNy42NDk4IDYuOTc0OTlINi4yOTk4IiBzdHJva2U9IiNGRjc5NkUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),
/* 3529 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEwLjM0OTYgMi4yNUg0Ljk0OTYxQzQuNTkxNTcgMi4yNSA0LjI0ODE5IDIuMzkyMjMgMy45OTUwMiAyLjY0NTQxQzMuNzQxODQgMi44OTg1OCAzLjU5OTYxIDMuMjQxOTYgMy41OTk2MSAzLjZWMTQuNEMzLjU5OTYxIDE0Ljc1OCAzLjc0MTg0IDE1LjEwMTQgMy45OTUwMiAxNS4zNTQ2QzQuMjQ4MTkgMTUuNjA3OCA0LjU5MTU3IDE1Ljc1IDQuOTQ5NjEgMTUuNzVIMTMuMDQ5NkMxMy40MDc3IDE1Ljc1IDEzLjc1MSAxNS42MDc4IDE0LjAwNDIgMTUuMzU0NkMxNC4yNTc0IDE1LjEwMTQgMTQuMzk5NiAxNC43NTggMTQuMzk5NiAxNC40VjYuM00xMC4zNDk2IDIuMjVMMTQuMzk5NiA2LjNNMTAuMzQ5NiAyLjI1VjYuM0gxNC4zOTk2IiBzdHJva2U9IiNGMkI0MkEiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggb3BhY2l0eT0iMC44IiBkPSJNMTEuNjk5OCA5LjY3NDk5SDYuMjk5OE0xMS42OTk4IDEyLjM3NUg2LjI5OThNNy42NDk4IDYuOTc0OTlINi4yOTk4IiBzdHJva2U9IiNGMkI0MkEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),
/* 3530 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iNCIgdmlld0JveD0iMCAwIDE2IDQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xLjk2OCAzLjk4NDA2QzEuNDI0IDMuOTg0MDYgMC45NiAzLjgwMDA2IDAuNTc2IDMuNDMyMDZDMC4xOTIgMy4wNDgwNiAwIDIuNTY4MDYgMCAxLjk5MjA2QzAgMS40MDAwNiAwLjE4NCAwLjkyMDA2MSAwLjU1MiAwLjU1MjA2MUMwLjkzNiAwLjE4NDA2MSAxLjQwOCA2LjEwMzUyZS0wNSAxLjk2OCA2LjEwMzUyZS0wNUMyLjUyOCA2LjEwMzUyZS0wNSAyLjk5MiAwLjE4NDA2MSAzLjM2IDAuNTUyMDYxQzMuNzQ0IDAuOTIwMDYxIDMuOTM2IDEuNDAwMDYgMy45MzYgMS45OTIwNkMzLjkzNiAyLjU2ODA2IDMuNzQ0IDMuMDQ4MDYgMy4zNiAzLjQzMjA2QzIuOTc2IDMuODAwMDYgMi41MTIgMy45ODQwNiAxLjk2OCAzLjk4NDA2WiIgZmlsbD0iIzk2OUNBNCIvPgo8cGF0aCBkPSJNNy44MjczOCAzLjk4NDA2QzcuMjgzMzggMy45ODQwNiA2LjgxOTM4IDMuODAwMDYgNi40MzUzOCAzLjQzMjA2QzYuMDUxMzggMy4wNDgwNiA1Ljg1OTM4IDIuNTY4MDYgNS44NTkzOCAxLjk5MjA2QzUuODU5MzggMS40MDAwNiA2LjA0MzM4IDAuOTIwMDYxIDYuNDExMzggMC41NTIwNjFDNi43OTUzNyAwLjE4NDA2MSA3LjI2NzM4IDYuMTAzNTJlLTA1IDcuODI3MzggNi4xMDM1MmUtMDVDOC4zODczNyA2LjEwMzUyZS0wNSA4Ljg1MTM3IDAuMTg0MDYxIDkuMjE5MzcgMC41NTIwNjFDOS42MDMzNyAwLjkyMDA2MSA5Ljc5NTM3IDEuNDAwMDYgOS43OTUzNyAxLjk5MjA2QzkuNzk1MzcgMi41NjgwNiA5LjYwMzM3IDMuMDQ4MDYgOS4yMTkzNyAzLjQzMjA2QzguODM1MzcgMy44MDAwNiA4LjM3MTM4IDMuOTg0MDYgNy44MjczOCAzLjk4NDA2WiIgZmlsbD0iIzk2OUNBNCIvPgo8cGF0aCBkPSJNMTMuNjg2OCAzLjk4NDA2QzEzLjE0MjggMy45ODQwNiAxMi42Nzg4IDMuODAwMDYgMTIuMjk0OCAzLjQzMjA2QzExLjkxMDggMy4wNDgwNiAxMS43MTg4IDIuNTY4MDYgMTEuNzE4OCAxLjk5MjA2QzExLjcxODggMS40MDAwNiAxMS45MDI4IDAuOTIwMDYxIDEyLjI3MDggMC41NTIwNjFDMTIuNjU0NyAwLjE4NDA2MSAxMy4xMjY3IDYuMTAzNTJlLTA1IDEzLjY4NjggNi4xMDM1MmUtMDVDMTQuMjQ2NyA2LjEwMzUyZS0wNSAxNC43MTA3IDAuMTg0MDYxIDE1LjA3ODcgMC41NTIwNjFDMTUuNDYyNyAwLjkyMDA2MSAxNS42NTQ3IDEuNDAwMDYgMTUuNjU0NyAxLjk5MjA2QzE1LjY1NDcgMi41NjgwNiAxNS40NjI3IDMuMDQ4MDYgMTUuMDc4NyAzLjQzMjA2QzE0LjY5NDcgMy44MDAwNiAxNC4yMzA4IDMuOTg0MDYgMTMuNjg2OCAzLjk4NDA2WiIgZmlsbD0iIzk2OUNBNCIvPgo8L3N2Zz4K"

/***/ }),
/* 3531 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iOCIgaGVpZ2h0PSI4IiB2aWV3Qm94PSIwIDAgOCA4IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMC42NjY2MjYgNy4zMzMyOUw3LjMzMzI5IDAuNjY2NjI2TTcuMzMzMjkgMC42NjY2MjZIMC42NjY2MjZNNy4zMzMyOSAwLjY2NjYyNlY3LjMzMzI5IiBzdHJva2U9IiM0OUIzQjEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K"

/***/ }),
/* 3532 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 3533 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 3534 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 3535 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 3536 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEwMDBfMTIyMTcpIj4KPHBhdGggZD0iTTQuNSA2Ljc1TDcuNSA5Ljc1IiBzdHJva2U9IiNEQkREREUiIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkuNzUgNy41TDYuNzUgNC41IiBzdHJva2U9IiNEQkREREUiIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkuNzUgNy41TDE1LjI4NzIgMTMuMDYzNUMxNS45MDQ1IDEzLjY3ODUgMTUuOTA0NSAxNC42NzQ1IDE1LjI4NzIgMTUuMjg4OEMxNC45OTA3IDE1LjU4MzcgMTQuNTg5NSAxNS43NDkzIDE0LjE3MTIgMTUuNzQ5M0MxMy43NTMgMTUuNzQ5MyAxMy4zNTE4IDE1LjU4MzcgMTMuMDU1MiAxNS4yODg4TDcuNSA5Ljc1IiBzdHJva2U9IiNEQkREREUiIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTIuMjUgMTUuNzVINy41IiBzdHJva2U9IiNEQkREREUiIHN0cm9rZS13aWR0aD0iMS4zIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTUuMDk0NzYgMTEuODQ0NkwyLjQwNTI2IDkuMTU1MTRDMi4yNjQ2NiA5LjAxNDQ5IDIuMTg1NjcgOC44MjM3NiAyLjE4NTY3IDguNjI0ODlDMi4xODU2NyA4LjQyNjAxIDIuMjY0NjYgOC4yMzUyOCAyLjQwNTI2IDguMDk0NjRMNC4xMjUwMSA2LjM3NDg5TDQuNTAwMDEgNi43NDk4OUw2Ljc1MDAxIDQuNDk5ODlMNi4zNzUwMSA0LjEyNDg5TDguMDk0NzYgMi40MDUxNEM4LjIzNTQgMi4yNjQ1MyA4LjQyNjE0IDIuMTg1NTUgOC42MjUwMSAyLjE4NTU1QzguODIzODggMi4xODU1NSA5LjAxNDYxIDIuMjY0NTMgOS4xNTUyNiAyLjQwNTE0TDExLjg0NDggNS4wOTQ2NEMxMS45ODU0IDUuMjM1MjggMTIuMDY0MyA1LjQyNjAxIDEyLjA2NDMgNS42MjQ4OUMxMi4wNjQzIDUuODIzNzYgMTEuOTg1NCA2LjAxNDQ5IDExLjg0NDggNi4xNTUxNEwxMC4xMjUgNy44NzQ4OUw5Ljc1MDAxIDcuNDk5ODlMNy41MDAwMSA5Ljc0OTg5TDcuODc1MDEgMTAuMTI0OUw2LjE1NTI2IDExLjg0NDZDNi4wMTQ2MSAxMS45ODUyIDUuODIzODggMTIuMDY0MiA1LjYyNTAxIDEyLjA2NDJDNS40MjYxNCAxMi4wNjQyIDUuMjM1NCAxMS45ODUyIDUuMDk0NzYgMTEuODQ0NloiIHN0cm9rZT0iI0RCRERERSIgc3Ryb2tlLXdpZHRoPSIxLjMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzEwMDBfMTIyMTciPgo8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg=="

/***/ }),
/* 3537 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEwMDBfMTIyNDApIj4KPHBhdGggZD0iTTIuMjUgMTUuNzVIMTUuNzUiIHN0cm9rZT0iIzU5Njk3NSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMi4yNSA3LjVIMTUuNzUiIHN0cm9rZT0iIzU5Njk3NSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMy43NSA0LjVMOSAyLjI1TDE0LjI1IDQuNSIgc3Ryb2tlPSIjNTk2OTc1IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0zIDcuNVYxNS43NSIgc3Ryb2tlPSIjNTk2OTc1IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xNSA3LjVWMTUuNzUiIHN0cm9rZT0iIzU5Njk3NSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNNiAxMC41VjEyLjc1IiBzdHJva2U9IiM1OTY5NzUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTkgMTAuNVYxMi43NSIgc3Ryb2tlPSIjNTk2OTc1IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMiAxMC41VjEyLjc1IiBzdHJva2U9IiM1OTY5NzUiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9nPgo8ZGVmcz4KPGNsaXBQYXRoIGlkPSJjbGlwMF8xMDAwXzEyMjQwIj4KPHJlY3Qgd2lkdGg9IjE4IiBoZWlnaHQ9IjE4IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo="

/***/ }),
/* 3538 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEwMDBfMTIyNTQpIj4KPHBhdGggZD0iTTkuNzUgMTVMMTUgOS43NSIgc3Ryb2tlPSIjNTk2OTc1IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik05Ljc1IDE1VjEwLjVDOS43NSAxMC4zMDExIDkuODI5MDIgMTAuMTEwMyA5Ljk2OTY3IDkuOTY5NjdDMTAuMTEwMyA5LjgyOTAyIDEwLjMwMTEgOS43NSAxMC41IDkuNzVIMTVWNC41QzE1IDQuMTAyMTggMTQuODQyIDMuNzIwNjQgMTQuNTYwNyAzLjQzOTM0QzE0LjI3OTQgMy4xNTgwNCAxMy44OTc4IDMgMTMuNSAzSDQuNUM0LjEwMjE4IDMgMy43MjA2NCAzLjE1ODA0IDMuNDM5MzQgMy40MzkzNEMzLjE1ODA0IDMuNzIwNjQgMyA0LjEwMjE4IDMgNC41VjEzLjVDMyAxMy44OTc4IDMuMTU4MDQgMTQuMjc5NCAzLjQzOTM0IDE0LjU2MDdDMy43MjA2NCAxNC44NDIgNC4xMDIxOCAxNSA0LjUgMTVIOS43NVoiIHN0cm9rZT0iIzU5Njk3NSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzEwMDBfMTIyNTQiPgo8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg=="

/***/ }),
/* 3539 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAxOCAxOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzEwMDBfMTIyNTEpIj4KPHBhdGggZD0iTTkuNzUgMTVMMTUgOS43NSIgc3Ryb2tlPSIjREJERERFIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik05Ljc1IDE1VjEwLjVDOS43NSAxMC4zMDExIDkuODI5MDIgMTAuMTEwMyA5Ljk2OTY3IDkuOTY5NjdDMTAuMTEwMyA5LjgyOTAyIDEwLjMwMTEgOS43NSAxMC41IDkuNzVIMTVWNC41QzE1IDQuMTAyMTggMTQuODQyIDMuNzIwNjQgMTQuNTYwNyAzLjQzOTM0QzE0LjI3OTQgMy4xNTgwNCAxMy44OTc4IDMgMTMuNSAzSDQuNUM0LjEwMjE4IDMgMy43MjA2NCAzLjE1ODA0IDMuNDM5MzQgMy40MzkzNEMzLjE1ODA0IDMuNzIwNjQgMyA0LjEwMjE4IDMgNC41VjEzLjVDMyAxMy44OTc4IDMuMTU4MDQgMTQuMjc5NCAzLjQzOTM0IDE0LjU2MDdDMy43MjA2NCAxNC44NDIgNC4xMDIxOCAxNSA0LjUgMTVIOS43NVoiIHN0cm9rZT0iI0RCRERERSIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzEwMDBfMTIyNTEiPgo8cmVjdCB3aWR0aD0iMTgiIGhlaWdodD0iMTgiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg=="

/***/ }),
/* 3540 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNS43NiAxMiI+PHRpdGxlPlVwbG9hZCBpY29uPC90aXRsZT48ZyBpZD0iR3JvdXBfMTMwNyIgZGF0YS1uYW1lPSJHcm91cCAxMzA3Ij48cGF0aCBpZD0iUGF0aF81MDQiIGRhdGEtbmFtZT0iUGF0aCA1MDQiIGQ9Ik02LjgxLDYuODN2M2gydi0zaDJMNy43LDQsNC44NCw2LjgzWiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSIgc3R5bGU9ImZpbGw6I2ZmZiIvPjxwYXRoIGlkPSJQYXRoXzUwNSIgZGF0YS1uYW1lPSJQYXRoIDUwNSIgZD0iTTUuNzMuOUEzLjIxLDMuMjEsMCwwLDAsMi41MSw0LjFzMCwwLDAsMFY1LjE5bC0uMzYuMThBMy4xNiwzLjE2LDAsMCwwLC43Miw4LjA2YTMuMjEsMy4yMSwwLDAsMCwzLjIsMy4yMmg4LjQ0QTIuNDUsMi40NSwwLDAsMCwxNC44Nyw4LjlzMC0uMDgsMC0uMTJhMi42OSwyLjY5LDAsMCwwLTEuNzktMi41MWwtLjcyLS4xOHYtLjlBMi40NSwyLjQ1LDAsMCwwLDEwLDIuNjlIOC42bC0uMzYtLjU0QTMuMTMsMy4xMywwLDAsMCw1LjczLjltMC0uOWE0LjA4LDQuMDgsMCwwLDEsMy40LDEuNzloLjcyYTMuNCwzLjQsMCwwLDEsMy40LDMuNHYuMThBMy4yOCwzLjI4LDAsMCwxLDE1Ljc2LDguNmEzLjQsMy40LDAsMCwxLTMuNCwzLjRIMy45NEE0LDQsMCwwLDEsMCw4LjA2YTMuODQsMy44NCwwLDAsMSwyLTMuNFY0LjEyQTMuNzcsMy43NywwLDAsMSw1LjM3LDBaIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwIDApIiBzdHlsZT0iZmlsbDojZmZmIi8+PC9nPjwvc3ZnPg=="

/***/ }),
/* 3541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};


/***/ }),
/* 3542 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {
/**
 * Module exports.
 */

module.exports = deprecate;

/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */

function deprecate (fn, msg) {
  if (config('noDeprecation')) {
    return fn;
  }

  var warned = false;
  function deprecated() {
    if (!warned) {
      if (config('throwDeprecation')) {
        throw new Error(msg);
      } else if (config('traceDeprecation')) {
        console.trace(msg);
      } else {
        console.warn(msg);
      }
      warned = true;
    }
    return fn.apply(this, arguments);
  }

  return deprecated;
}

/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */

function config (name) {
  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
  try {
    if (!global.localStorage) return false;
  } catch (_) {
    return false;
  }
  var val = global.localStorage[name];
  if (null == val) return false;
  return String(val).toLowerCase() === 'true';
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ }),
/* 3543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * Browser-compatible JavaScript MD5
 *
 * Modification of JavaScript MD5
 * https://github.com/blueimp/JavaScript-MD5
 *
 * Copyright 2011, Sebastian Tschan
 * https://blueimp.net
 *
 * Licensed under the MIT license:
 * https://opensource.org/licenses/MIT
 *
 * Based on
 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
 * Digest Algorithm, as defined in RFC 1321.
 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for more info.
 */
function md5(bytes) {
  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = new Uint8Array(msg.length);

    for (var i = 0; i < msg.length; ++i) {
      bytes[i] = msg.charCodeAt(i);
    }
  }

  return md5ToHexEncodedArray(wordsToMd5(bytesToWords(bytes), bytes.length * 8));
}
/*
 * Convert an array of little-endian words to an array of bytes
 */


function md5ToHexEncodedArray(input) {
  var output = [];
  var length32 = input.length * 32;
  var hexTab = '0123456789abcdef';

  for (var i = 0; i < length32; i += 8) {
    var x = input[i >> 5] >>> i % 32 & 0xff;
    var hex = parseInt(hexTab.charAt(x >>> 4 & 0x0f) + hexTab.charAt(x & 0x0f), 16);
    output.push(hex);
  }

  return output;
}
/**
 * Calculate output length with padding and bit length
 */


function getOutputLength(inputLength8) {
  return (inputLength8 + 64 >>> 9 << 4) + 14 + 1;
}
/*
 * Calculate the MD5 of an array of little-endian words, and a bit length.
 */


function wordsToMd5(x, len) {
  /* append padding */
  x[len >> 5] |= 0x80 << len % 32;
  x[getOutputLength(len) - 1] = len;
  var a = 1732584193;
  var b = -271733879;
  var c = -1732584194;
  var d = 271733878;

  for (var i = 0; i < x.length; i += 16) {
    var olda = a;
    var oldb = b;
    var oldc = c;
    var oldd = d;
    a = md5ff(a, b, c, d, x[i], 7, -680876936);
    d = md5ff(d, a, b, c, x[i + 1], 12, -389564586);
    c = md5ff(c, d, a, b, x[i + 2], 17, 606105819);
    b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330);
    a = md5ff(a, b, c, d, x[i + 4], 7, -176418897);
    d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426);
    c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341);
    b = md5ff(b, c, d, a, x[i + 7], 22, -45705983);
    a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416);
    d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417);
    c = md5ff(c, d, a, b, x[i + 10], 17, -42063);
    b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162);
    a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682);
    d = md5ff(d, a, b, c, x[i + 13], 12, -40341101);
    c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290);
    b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329);
    a = md5gg(a, b, c, d, x[i + 1], 5, -165796510);
    d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632);
    c = md5gg(c, d, a, b, x[i + 11], 14, 643717713);
    b = md5gg(b, c, d, a, x[i], 20, -373897302);
    a = md5gg(a, b, c, d, x[i + 5], 5, -701558691);
    d = md5gg(d, a, b, c, x[i + 10], 9, 38016083);
    c = md5gg(c, d, a, b, x[i + 15], 14, -660478335);
    b = md5gg(b, c, d, a, x[i + 4], 20, -405537848);
    a = md5gg(a, b, c, d, x[i + 9], 5, 568446438);
    d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690);
    c = md5gg(c, d, a, b, x[i + 3], 14, -187363961);
    b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501);
    a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467);
    d = md5gg(d, a, b, c, x[i + 2], 9, -51403784);
    c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473);
    b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734);
    a = md5hh(a, b, c, d, x[i + 5], 4, -378558);
    d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463);
    c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562);
    b = md5hh(b, c, d, a, x[i + 14], 23, -35309556);
    a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060);
    d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353);
    c = md5hh(c, d, a, b, x[i + 7], 16, -155497632);
    b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640);
    a = md5hh(a, b, c, d, x[i + 13], 4, 681279174);
    d = md5hh(d, a, b, c, x[i], 11, -358537222);
    c = md5hh(c, d, a, b, x[i + 3], 16, -722521979);
    b = md5hh(b, c, d, a, x[i + 6], 23, 76029189);
    a = md5hh(a, b, c, d, x[i + 9], 4, -640364487);
    d = md5hh(d, a, b, c, x[i + 12], 11, -421815835);
    c = md5hh(c, d, a, b, x[i + 15], 16, 530742520);
    b = md5hh(b, c, d, a, x[i + 2], 23, -995338651);
    a = md5ii(a, b, c, d, x[i], 6, -198630844);
    d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415);
    c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905);
    b = md5ii(b, c, d, a, x[i + 5], 21, -57434055);
    a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571);
    d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606);
    c = md5ii(c, d, a, b, x[i + 10], 15, -1051523);
    b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799);
    a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359);
    d = md5ii(d, a, b, c, x[i + 15], 10, -30611744);
    c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380);
    b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649);
    a = md5ii(a, b, c, d, x[i + 4], 6, -145523070);
    d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379);
    c = md5ii(c, d, a, b, x[i + 2], 15, 718787259);
    b = md5ii(b, c, d, a, x[i + 9], 21, -343485551);
    a = safeAdd(a, olda);
    b = safeAdd(b, oldb);
    c = safeAdd(c, oldc);
    d = safeAdd(d, oldd);
  }

  return [a, b, c, d];
}
/*
 * Convert an array bytes to an array of little-endian words
 * Characters >255 have their high-byte silently ignored.
 */


function bytesToWords(input) {
  if (input.length === 0) {
    return [];
  }

  var length8 = input.length * 8;
  var output = new Uint32Array(getOutputLength(length8));

  for (var i = 0; i < length8; i += 8) {
    output[i >> 5] |= (input[i / 8] & 0xff) << i % 32;
  }

  return output;
}
/*
 * Add integers, wrapping at 2^32. This uses 16-bit operations internally
 * to work around bugs in some JS interpreters.
 */


function safeAdd(x, y) {
  var lsw = (x & 0xffff) + (y & 0xffff);
  var msw = (x >> 16) + (y >> 16) + (lsw >> 16);
  return msw << 16 | lsw & 0xffff;
}
/*
 * Bitwise rotate a 32-bit number to the left.
 */


function bitRotateLeft(num, cnt) {
  return num << cnt | num >>> 32 - cnt;
}
/*
 * These functions implement the four basic operations the algorithm uses.
 */


function md5cmn(q, a, b, x, s, t) {
  return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b);
}

function md5ff(a, b, c, d, x, s, t) {
  return md5cmn(b & c | ~b & d, a, b, x, s, t);
}

function md5gg(a, b, c, d, x, s, t) {
  return md5cmn(b & d | c & ~d, a, b, x, s, t);
}

function md5hh(a, b, c, d, x, s, t) {
  return md5cmn(b ^ c ^ d, a, b, x, s, t);
}

function md5ii(a, b, c, d, x, s, t) {
  return md5cmn(c ^ (b | ~d), a, b, x, s, t);
}

/* harmony default export */ __webpack_exports__["a"] = (md5);

/***/ }),
/* 3544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ('00000000-0000-0000-0000-000000000000');

/***/ }),
/* 3545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);

/***/ }),
/* 3546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Adapted from Chris Veness' SHA1 code at
// http://www.movable-type.co.uk/scripts/sha1.html
function f(s, x, y, z) {
  switch (s) {
    case 0:
      return x & y ^ ~x & z;

    case 1:
      return x ^ y ^ z;

    case 2:
      return x & y ^ x & z ^ y & z;

    case 3:
      return x ^ y ^ z;
  }
}

function ROTL(x, n) {
  return x << n | x >>> 32 - n;
}

function sha1(bytes) {
  var K = [0x5a827999, 0x6ed9eba1, 0x8f1bbcdc, 0xca62c1d6];
  var H = [0x67452301, 0xefcdab89, 0x98badcfe, 0x10325476, 0xc3d2e1f0];

  if (typeof bytes === 'string') {
    var msg = unescape(encodeURIComponent(bytes)); // UTF8 escape

    bytes = [];

    for (var i = 0; i < msg.length; ++i) {
      bytes.push(msg.charCodeAt(i));
    }
  } else if (!Array.isArray(bytes)) {
    // Convert Array-like to Array
    bytes = Array.prototype.slice.call(bytes);
  }

  bytes.push(0x80);
  var l = bytes.length / 4 + 2;
  var N = Math.ceil(l / 16);
  var M = new Array(N);

  for (var _i = 0; _i < N; ++_i) {
    var arr = new Uint32Array(16);

    for (var j = 0; j < 16; ++j) {
      arr[j] = bytes[_i * 64 + j * 4] << 24 | bytes[_i * 64 + j * 4 + 1] << 16 | bytes[_i * 64 + j * 4 + 2] << 8 | bytes[_i * 64 + j * 4 + 3];
    }

    M[_i] = arr;
  }

  M[N - 1][14] = (bytes.length - 1) * 8 / Math.pow(2, 32);
  M[N - 1][14] = Math.floor(M[N - 1][14]);
  M[N - 1][15] = (bytes.length - 1) * 8 & 0xffffffff;

  for (var _i2 = 0; _i2 < N; ++_i2) {
    var W = new Uint32Array(80);

    for (var t = 0; t < 16; ++t) {
      W[t] = M[_i2][t];
    }

    for (var _t = 16; _t < 80; ++_t) {
      W[_t] = ROTL(W[_t - 3] ^ W[_t - 8] ^ W[_t - 14] ^ W[_t - 16], 1);
    }

    var a = H[0];
    var b = H[1];
    var c = H[2];
    var d = H[3];
    var e = H[4];

    for (var _t2 = 0; _t2 < 80; ++_t2) {
      var s = Math.floor(_t2 / 20);
      var T = ROTL(a, 5) + f(s, b, c, d) + e + K[s] + W[_t2] >>> 0;
      e = d;
      d = c;
      c = ROTL(b, 30) >>> 0;
      b = a;
      a = T;
    }

    H[0] = H[0] + a >>> 0;
    H[1] = H[1] + b >>> 0;
    H[2] = H[2] + c >>> 0;
    H[3] = H[3] + d >>> 0;
    H[4] = H[4] + e >>> 0;
  }

  return [H[0] >> 24 & 0xff, H[0] >> 16 & 0xff, H[0] >> 8 & 0xff, H[0] & 0xff, H[1] >> 24 & 0xff, H[1] >> 16 & 0xff, H[1] >> 8 & 0xff, H[1] & 0xff, H[2] >> 24 & 0xff, H[2] >> 16 & 0xff, H[2] >> 8 & 0xff, H[2] & 0xff, H[3] >> 24 & 0xff, H[3] >> 16 & 0xff, H[3] >> 8 & 0xff, H[3] & 0xff, H[4] >> 24 & 0xff, H[4] >> 16 & 0xff, H[4] >> 8 & 0xff, H[4] & 0xff];
}

/* harmony default export */ __webpack_exports__["a"] = (sha1);

/***/ }),
/* 3547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rng_js__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringify_js__ = __webpack_require__(505);

 // **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html

var _nodeId;

var _clockseq; // Previous uuid creation time


var _lastMSecs = 0;
var _lastNSecs = 0; // See https://github.com/uuidjs/uuid for API details

function v1(options, buf, offset) {
  var i = buf && offset || 0;
  var b = buf || new Array(16);
  options = options || {};
  var node = options.node || _nodeId;
  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq; // node and clockseq need to be initialized to random values if they're not
  // specified.  We do this lazily to minimize issues related to insufficient
  // system entropy.  See #189

  if (node == null || clockseq == null) {
    var seedBytes = options.random || (options.rng || __WEBPACK_IMPORTED_MODULE_0__rng_js__["a" /* default */])();

    if (node == null) {
      // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
      node = _nodeId = [seedBytes[0] | 0x01, seedBytes[1], seedBytes[2], seedBytes[3], seedBytes[4], seedBytes[5]];
    }

    if (clockseq == null) {
      // Per 4.2.2, randomize (14 bit) clockseq
      clockseq = _clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
  } // UUID timestamps are 100 nano-second units since the Gregorian epoch,
  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.


  var msecs = options.msecs !== undefined ? options.msecs : Date.now(); // Per 4.2.1.2, use count of uuid's generated during the current clock
  // cycle to simulate higher resolution clock

  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1; // Time since last uuid creation (in msecs)

  var dt = msecs - _lastMSecs + (nsecs - _lastNSecs) / 10000; // Per 4.2.1.2, Bump clockseq on clock regression

  if (dt < 0 && options.clockseq === undefined) {
    clockseq = clockseq + 1 & 0x3fff;
  } // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
  // time interval


  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
    nsecs = 0;
  } // Per 4.2.1.2 Throw error if too many uuids are requested


  if (nsecs >= 10000) {
    throw new Error("uuid.v1(): Can't create more than 10M uuids/sec");
  }

  _lastMSecs = msecs;
  _lastNSecs = nsecs;
  _clockseq = clockseq; // Per 4.1.4 - Convert from unix epoch to Gregorian epoch

  msecs += 12219292800000; // `time_low`

  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
  b[i++] = tl >>> 24 & 0xff;
  b[i++] = tl >>> 16 & 0xff;
  b[i++] = tl >>> 8 & 0xff;
  b[i++] = tl & 0xff; // `time_mid`

  var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
  b[i++] = tmh >>> 8 & 0xff;
  b[i++] = tmh & 0xff; // `time_high_and_version`

  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version

  b[i++] = tmh >>> 16 & 0xff; // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)

  b[i++] = clockseq >>> 8 | 0x80; // `clock_seq_low`

  b[i++] = clockseq & 0xff; // `node`

  for (var n = 0; n < 6; ++n) {
    b[i + n] = node[n];
  }

  return buf || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stringify_js__["a" /* default */])(b);
}

/* harmony default export */ __webpack_exports__["a"] = (v1);

/***/ }),
/* 3548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v35_js__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__md5_js__ = __webpack_require__(3543);


var v3 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__v35_js__["a" /* default */])('v3', 0x30, __WEBPACK_IMPORTED_MODULE_1__md5_js__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (v3);

/***/ }),
/* 3549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rng_js__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stringify_js__ = __webpack_require__(505);



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || __WEBPACK_IMPORTED_MODULE_0__rng_js__["a" /* default */])(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__stringify_js__["a" /* default */])(rnds);
}

/* harmony default export */ __webpack_exports__["a"] = (v4);

/***/ }),
/* 3550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__v35_js__ = __webpack_require__(1603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sha1_js__ = __webpack_require__(3546);


var v5 = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__v35_js__["a" /* default */])('v5', 0x50, __WEBPACK_IMPORTED_MODULE_1__sha1_js__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (v5);

/***/ }),
/* 3551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate_js__ = __webpack_require__(506);


function version(uuid) {
  if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__validate_js__["a" /* default */])(uuid)) {
    throw TypeError('Invalid UUID');
  }

  return parseInt(uuid.substr(14, 1), 16);
}

/* harmony default export */ __webpack_exports__["a"] = (version);

/***/ }),
/* 3552 */
/***/ (function(module, exports) {

var indexOf = function (xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for (var i = 0; i < xs.length; i++) {
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function (obj) {
    if (Object.keys) return Object.keys(obj)
    else {
        var res = [];
        for (var key in obj) res.push(key)
        return res;
    }
};

var forEach = function (xs, fn) {
    if (xs.forEach) return xs.forEach(fn)
    else for (var i = 0; i < xs.length; i++) {
        fn(xs[i], i, xs);
    }
};

var defineProp = (function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            })
        };
    } catch(e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}());

var globals = ['Array', 'Boolean', 'Date', 'Error', 'EvalError', 'Function',
'Infinity', 'JSON', 'Math', 'NaN', 'Number', 'Object', 'RangeError',
'ReferenceError', 'RegExp', 'String', 'SyntaxError', 'TypeError', 'URIError',
'decodeURI', 'decodeURIComponent', 'encodeURI', 'encodeURIComponent', 'escape',
'eval', 'isFinite', 'isNaN', 'parseFloat', 'parseInt', 'undefined', 'unescape'];

function Context() {}
Context.prototype = {};

var Script = exports.Script = function NodeScript (code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};

Script.prototype.runInContext = function (context) {
    if (!(context instanceof Context)) {
        throw new TypeError("needs a 'context' argument.");
    }
    
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    
    document.body.appendChild(iframe);
    
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;

    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    
    forEach(Object_keys(context), function (key) {
        win[key] = context[key];
    });
    forEach(globals, function (key) {
        if (context[key]) {
            win[key] = context[key];
        }
    });
    
    var winKeys = Object_keys(win);

    var res = wEval.call(win, this.code);
    
    forEach(Object_keys(win), function (key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) {
            context[key] = win[key];
        }
    });

    forEach(globals, function (key) {
        if (!(key in context)) {
            defineProp(context, key, win[key]);
        }
    });
    
    document.body.removeChild(iframe);
    
    return res;
};

Script.prototype.runInThisContext = function () {
    return eval(this.code); // maybe...
};

Script.prototype.runInNewContext = function (context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);

    if (context) {
        forEach(Object_keys(ctx), function (key) {
            context[key] = ctx[key];
        });
    }

    return res;
};

forEach(Object_keys(Script.prototype), function (name) {
    exports[name] = Script[name] = function (code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});

exports.isContext = function (context) {
    return context instanceof Context;
};

exports.createScript = function (code) {
    return exports.Script(code);
};

exports.createContext = Script.createContext = function (context) {
    var copy = new Context();
    if(typeof context === 'object') {
        forEach(Object_keys(context), function (key) {
            copy[key] = context[key];
        });
    }
    return copy;
};


/***/ }),
/* 3553 */
/***/ (function(module, exports) {

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

module.exports = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "link": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};


/***/ }),
/* 3554 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 3555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["Headers"] = Headers;
/* harmony export (immutable) */ __webpack_exports__["Request"] = Request;
/* harmony export (immutable) */ __webpack_exports__["Response"] = Response;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMException", function() { return DOMException; });
/* harmony export (immutable) */ __webpack_exports__["fetch"] = fetch;
var support = {
  searchParams: 'URLSearchParams' in self,
  iterable: 'Symbol' in self && 'iterator' in Symbol,
  blob:
    'FileReader' in self &&
    'Blob' in self &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in self,
  arrayBuffer: 'ArrayBuffer' in self
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsText(blob)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    this._bodyInit = body
    if (!body) {
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
    var parts = line.split(':')
    var key = parts.shift().trim()
    if (key) {
      var value = parts.join(':').trim()
      headers.append(key, value)
    }
  })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = 'statusText' in options ? options.statusText : 'OK'
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''})
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = self.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      resolve(new Response(body, options))
    }

    xhr.onerror = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.ontimeout = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.onabort = function() {
      reject(new DOMException('Aborted', 'AbortError'))
    }

    xhr.open(request.method, request.url, true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr && support.blob) {
      xhr.responseType = 'blob'
    }

    request.headers.forEach(function(value, name) {
      xhr.setRequestHeader(name, value)
    })

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!self.fetch) {
  self.fetch = fetch
  self.Headers = Headers
  self.Request = Request
  self.Response = Response
}


/***/ }),
/* 3556 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(3557).Observable;


/***/ }),
/* 3557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Observable = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// === Symbol Support ===
var hasSymbols = function () {
  return typeof Symbol === 'function';
};

var hasSymbol = function (name) {
  return hasSymbols() && Boolean(Symbol[name]);
};

var getSymbol = function (name) {
  return hasSymbol(name) ? Symbol[name] : '@@' + name;
};

if (hasSymbols() && !hasSymbol('observable')) {
  Symbol.observable = Symbol('observable');
}

var SymbolIterator = getSymbol('iterator');
var SymbolObservable = getSymbol('observable');
var SymbolSpecies = getSymbol('species'); // === Abstract Operations ===

function getMethod(obj, key) {
  var value = obj[key];
  if (value == null) return undefined;
  if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
  return value;
}

function getSpecies(obj) {
  var ctor = obj.constructor;

  if (ctor !== undefined) {
    ctor = ctor[SymbolSpecies];

    if (ctor === null) {
      ctor = undefined;
    }
  }

  return ctor !== undefined ? ctor : Observable;
}

function isObservable(x) {
  return x instanceof Observable; // SPEC: Brand check
}

function hostReportError(e) {
  if (hostReportError.log) {
    hostReportError.log(e);
  } else {
    setTimeout(function () {
      throw e;
    });
  }
}

function enqueue(fn) {
  Promise.resolve().then(function () {
    try {
      fn();
    } catch (e) {
      hostReportError(e);
    }
  });
}

function cleanupSubscription(subscription) {
  var cleanup = subscription._cleanup;
  if (cleanup === undefined) return;
  subscription._cleanup = undefined;

  if (!cleanup) {
    return;
  }

  try {
    if (typeof cleanup === 'function') {
      cleanup();
    } else {
      var unsubscribe = getMethod(cleanup, 'unsubscribe');

      if (unsubscribe) {
        unsubscribe.call(cleanup);
      }
    }
  } catch (e) {
    hostReportError(e);
  }
}

function closeSubscription(subscription) {
  subscription._observer = undefined;
  subscription._queue = undefined;
  subscription._state = 'closed';
}

function flushSubscription(subscription) {
  var queue = subscription._queue;

  if (!queue) {
    return;
  }

  subscription._queue = undefined;
  subscription._state = 'ready';

  for (var i = 0; i < queue.length; ++i) {
    notifySubscription(subscription, queue[i].type, queue[i].value);
    if (subscription._state === 'closed') break;
  }
}

function notifySubscription(subscription, type, value) {
  subscription._state = 'running';
  var observer = subscription._observer;

  try {
    var m = getMethod(observer, type);

    switch (type) {
      case 'next':
        if (m) m.call(observer, value);
        break;

      case 'error':
        closeSubscription(subscription);
        if (m) m.call(observer, value);else throw value;
        break;

      case 'complete':
        closeSubscription(subscription);
        if (m) m.call(observer);
        break;
    }
  } catch (e) {
    hostReportError(e);
  }

  if (subscription._state === 'closed') cleanupSubscription(subscription);else if (subscription._state === 'running') subscription._state = 'ready';
}

function onNotify(subscription, type, value) {
  if (subscription._state === 'closed') return;

  if (subscription._state === 'buffering') {
    subscription._queue.push({
      type: type,
      value: value
    });

    return;
  }

  if (subscription._state !== 'ready') {
    subscription._state = 'buffering';
    subscription._queue = [{
      type: type,
      value: value
    }];
    enqueue(function () {
      return flushSubscription(subscription);
    });
    return;
  }

  notifySubscription(subscription, type, value);
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(observer, subscriber) {
    _classCallCheck(this, Subscription);

    // ASSERT: observer is an object
    // ASSERT: subscriber is callable
    this._cleanup = undefined;
    this._observer = observer;
    this._queue = undefined;
    this._state = 'initializing';
    var subscriptionObserver = new SubscriptionObserver(this);

    try {
      this._cleanup = subscriber.call(undefined, subscriptionObserver);
    } catch (e) {
      subscriptionObserver.error(e);
    }

    if (this._state === 'initializing') this._state = 'ready';
  }

  _createClass(Subscription, [{
    key: "unsubscribe",
    value: function unsubscribe() {
      if (this._state !== 'closed') {
        closeSubscription(this);
        cleanupSubscription(this);
      }
    }
  }, {
    key: "closed",
    get: function () {
      return this._state === 'closed';
    }
  }]);

  return Subscription;
}();

var SubscriptionObserver =
/*#__PURE__*/
function () {
  function SubscriptionObserver(subscription) {
    _classCallCheck(this, SubscriptionObserver);

    this._subscription = subscription;
  }

  _createClass(SubscriptionObserver, [{
    key: "next",
    value: function next(value) {
      onNotify(this._subscription, 'next', value);
    }
  }, {
    key: "error",
    value: function error(value) {
      onNotify(this._subscription, 'error', value);
    }
  }, {
    key: "complete",
    value: function complete() {
      onNotify(this._subscription, 'complete');
    }
  }, {
    key: "closed",
    get: function () {
      return this._subscription._state === 'closed';
    }
  }]);

  return SubscriptionObserver;
}();

var Observable =
/*#__PURE__*/
function () {
  function Observable(subscriber) {
    _classCallCheck(this, Observable);

    if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
    if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
    this._subscriber = subscriber;
  }

  _createClass(Observable, [{
    key: "subscribe",
    value: function subscribe(observer) {
      if (typeof observer !== 'object' || observer === null) {
        observer = {
          next: observer,
          error: arguments[1],
          complete: arguments[2]
        };
      }

      return new Subscription(observer, this._subscriber);
    }
  }, {
    key: "forEach",
    value: function forEach(fn) {
      var _this = this;

      return new Promise(function (resolve, reject) {
        if (typeof fn !== 'function') {
          reject(new TypeError(fn + ' is not a function'));
          return;
        }

        function done() {
          subscription.unsubscribe();
          resolve();
        }

        var subscription = _this.subscribe({
          next: function (value) {
            try {
              fn(value, done);
            } catch (e) {
              reject(e);
              subscription.unsubscribe();
            }
          },
          error: reject,
          complete: resolve
        });
      });
    }
  }, {
    key: "map",
    value: function map(fn) {
      var _this2 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        return _this2.subscribe({
          next: function (value) {
            try {
              value = fn(value);
            } catch (e) {
              return observer.error(e);
            }

            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "filter",
    value: function filter(fn) {
      var _this3 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        return _this3.subscribe({
          next: function (value) {
            try {
              if (!fn(value)) return;
            } catch (e) {
              return observer.error(e);
            }

            observer.next(value);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "reduce",
    value: function reduce(fn) {
      var _this4 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      var hasSeed = arguments.length > 1;
      var hasValue = false;
      var seed = arguments[1];
      var acc = seed;
      return new C(function (observer) {
        return _this4.subscribe({
          next: function (value) {
            var first = !hasValue;
            hasValue = true;

            if (!first || hasSeed) {
              try {
                acc = fn(acc, value);
              } catch (e) {
                return observer.error(e);
              }
            } else {
              acc = value;
            }
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
            observer.next(acc);
            observer.complete();
          }
        });
      });
    }
  }, {
    key: "concat",
    value: function concat() {
      var _this5 = this;

      for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
        sources[_key] = arguments[_key];
      }

      var C = getSpecies(this);
      return new C(function (observer) {
        var subscription;
        var index = 0;

        function startNext(next) {
          subscription = next.subscribe({
            next: function (v) {
              observer.next(v);
            },
            error: function (e) {
              observer.error(e);
            },
            complete: function () {
              if (index === sources.length) {
                subscription = undefined;
                observer.complete();
              } else {
                startNext(C.from(sources[index++]));
              }
            }
          });
        }

        startNext(_this5);
        return function () {
          if (subscription) {
            subscription.unsubscribe();
            subscription = undefined;
          }
        };
      });
    }
  }, {
    key: "flatMap",
    value: function flatMap(fn) {
      var _this6 = this;

      if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
      var C = getSpecies(this);
      return new C(function (observer) {
        var subscriptions = [];

        var outer = _this6.subscribe({
          next: function (value) {
            if (fn) {
              try {
                value = fn(value);
              } catch (e) {
                return observer.error(e);
              }
            }

            var inner = C.from(value).subscribe({
              next: function (value) {
                observer.next(value);
              },
              error: function (e) {
                observer.error(e);
              },
              complete: function () {
                var i = subscriptions.indexOf(inner);
                if (i >= 0) subscriptions.splice(i, 1);
                completeIfDone();
              }
            });
            subscriptions.push(inner);
          },
          error: function (e) {
            observer.error(e);
          },
          complete: function () {
            completeIfDone();
          }
        });

        function completeIfDone() {
          if (outer.closed && subscriptions.length === 0) observer.complete();
        }

        return function () {
          subscriptions.forEach(function (s) {
            return s.unsubscribe();
          });
          outer.unsubscribe();
        };
      });
    }
  }, {
    key: SymbolObservable,
    value: function () {
      return this;
    }
  }], [{
    key: "from",
    value: function from(x) {
      var C = typeof this === 'function' ? this : Observable;
      if (x == null) throw new TypeError(x + ' is not an object');
      var method = getMethod(x, SymbolObservable);

      if (method) {
        var observable = method.call(x);
        if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
        if (isObservable(observable) && observable.constructor === C) return observable;
        return new C(function (observer) {
          return observable.subscribe(observer);
        });
      }

      if (hasSymbol('iterator')) {
        method = getMethod(x, SymbolIterator);

        if (method) {
          return new C(function (observer) {
            enqueue(function () {
              if (observer.closed) return;
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = method.call(x)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var _item = _step.value;
                  observer.next(_item);
                  if (observer.closed) return;
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }

              observer.complete();
            });
          });
        }
      }

      if (Array.isArray(x)) {
        return new C(function (observer) {
          enqueue(function () {
            if (observer.closed) return;

            for (var i = 0; i < x.length; ++i) {
              observer.next(x[i]);
              if (observer.closed) return;
            }

            observer.complete();
          });
        });
      }

      throw new TypeError(x + ' is not observable');
    }
  }, {
    key: "of",
    value: function of() {
      for (var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        items[_key2] = arguments[_key2];
      }

      var C = typeof this === 'function' ? this : Observable;
      return new C(function (observer) {
        enqueue(function () {
          if (observer.closed) return;

          for (var i = 0; i < items.length; ++i) {
            observer.next(items[i]);
            if (observer.closed) return;
          }

          observer.complete();
        });
      });
    }
  }, {
    key: SymbolSpecies,
    get: function () {
      return this;
    }
  }]);

  return Observable;
}();

exports.Observable = Observable;

if (hasSymbols()) {
  Object.defineProperty(Observable, Symbol('extensions'), {
    value: {
      symbol: SymbolObservable,
      hostReportError: hostReportError
    },
    configurable: true
  });
}

/***/ }),
/* 3558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/**
 * @license Angular v<unknown>
 * (c) 2010-2025 Google LLC. https://angular.io/
 * License: MIT
 */
(function (factory) {
     true ? !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)) :
        factory();
})((function () {
    'use strict';
    var global = globalThis;
    // __Zone_symbol_prefix global can be used to override the default zone
    // symbol prefix with a custom one if needed.
    function __symbol__(name) {
        var symbolPrefix = global['__Zone_symbol_prefix'] || '__zone_symbol__';
        return symbolPrefix + name;
    }
    function initZone() {
        var performance = global['performance'];
        function mark(name) {
            performance && performance['mark'] && performance['mark'](name);
        }
        function performanceMeasure(name, label) {
            performance && performance['measure'] && performance['measure'](name, label);
        }
        mark('Zone');
        var ZoneImpl = /** @class */ (function () {
            function ZoneImpl(parent, zoneSpec) {
                this._parent = parent;
                this._name = zoneSpec ? zoneSpec.name || 'unnamed' : '<root>';
                this._properties = (zoneSpec && zoneSpec.properties) || {};
                this._zoneDelegate = new _ZoneDelegate(this, this._parent && this._parent._zoneDelegate, zoneSpec);
            }
            ZoneImpl.assertZonePatched = function () {
                if (global['Promise'] !== patches['ZoneAwarePromise']) {
                    throw new Error('Zone.js has detected that ZoneAwarePromise `(window|global).Promise` ' +
                        'has been overwritten.\n' +
                        'Most likely cause is that a Promise polyfill has been loaded ' +
                        'after Zone.js (Polyfilling Promise api is not necessary when zone.js is loaded. ' +
                        'If you must load one, do so before loading zone.js.)');
                }
            };
            Object.defineProperty(ZoneImpl, "root", {
                get: function () {
                    var zone = ZoneImpl.current;
                    while (zone.parent) {
                        zone = zone.parent;
                    }
                    return zone;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ZoneImpl, "current", {
                get: function () {
                    return _currentZoneFrame.zone;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ZoneImpl, "currentTask", {
                get: function () {
                    return _currentTask;
                },
                enumerable: false,
                configurable: true
            });
            ZoneImpl.__load_patch = function (name, fn, ignoreDuplicate) {
                if (ignoreDuplicate === void 0) { ignoreDuplicate = false; }
                if (patches.hasOwnProperty(name)) {
                    // `checkDuplicate` option is defined from global variable
                    // so it works for all modules.
                    // `ignoreDuplicate` can work for the specified module
                    var checkDuplicate = global[__symbol__('forceDuplicateZoneCheck')] === true;
                    if (!ignoreDuplicate && checkDuplicate) {
                        throw Error('Already loaded patch: ' + name);
                    }
                }
                else if (!global['__Zone_disable_' + name]) {
                    var perfName = 'Zone:' + name;
                    mark(perfName);
                    patches[name] = fn(global, ZoneImpl, _api);
                    performanceMeasure(perfName, perfName);
                }
            };
            Object.defineProperty(ZoneImpl.prototype, "parent", {
                get: function () {
                    return this._parent;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ZoneImpl.prototype, "name", {
                get: function () {
                    return this._name;
                },
                enumerable: false,
                configurable: true
            });
            ZoneImpl.prototype.get = function (key) {
                var zone = this.getZoneWith(key);
                if (zone)
                    return zone._properties[key];
            };
            ZoneImpl.prototype.getZoneWith = function (key) {
                var current = this;
                while (current) {
                    if (current._properties.hasOwnProperty(key)) {
                        return current;
                    }
                    current = current._parent;
                }
                return null;
            };
            ZoneImpl.prototype.fork = function (zoneSpec) {
                if (!zoneSpec)
                    throw new Error('ZoneSpec required!');
                return this._zoneDelegate.fork(this, zoneSpec);
            };
            ZoneImpl.prototype.wrap = function (callback, source) {
                if (typeof callback !== 'function') {
                    throw new Error('Expecting function got: ' + callback);
                }
                var _callback = this._zoneDelegate.intercept(this, callback, source);
                var zone = this;
                return function () {
                    return zone.runGuarded(_callback, this, arguments, source);
                };
            };
            ZoneImpl.prototype.run = function (callback, applyThis, applyArgs, source) {
                _currentZoneFrame = { parent: _currentZoneFrame, zone: this };
                try {
                    return this._zoneDelegate.invoke(this, callback, applyThis, applyArgs, source);
                }
                finally {
                    _currentZoneFrame = _currentZoneFrame.parent;
                }
            };
            ZoneImpl.prototype.runGuarded = function (callback, applyThis, applyArgs, source) {
                if (applyThis === void 0) { applyThis = null; }
                _currentZoneFrame = { parent: _currentZoneFrame, zone: this };
                try {
                    try {
                        return this._zoneDelegate.invoke(this, callback, applyThis, applyArgs, source);
                    }
                    catch (error) {
                        if (this._zoneDelegate.handleError(this, error)) {
                            throw error;
                        }
                    }
                }
                finally {
                    _currentZoneFrame = _currentZoneFrame.parent;
                }
            };
            ZoneImpl.prototype.runTask = function (task, applyThis, applyArgs) {
                if (task.zone != this) {
                    throw new Error('A task can only be run in the zone of creation! (Creation: ' +
                        (task.zone || NO_ZONE).name +
                        '; Execution: ' +
                        this.name +
                        ')');
                }
                var zoneTask = task;
                // https://github.com/angular/zone.js/issues/778, sometimes eventTask
                // will run in notScheduled(canceled) state, we should not try to
                // run such kind of task but just return
                var type = task.type, _a = task.data, _b = _a === void 0 ? {} : _a, _c = _b.isPeriodic, isPeriodic = _c === void 0 ? false : _c, _d = _b.isRefreshable, isRefreshable = _d === void 0 ? false : _d;
                if (task.state === notScheduled && (type === eventTask || type === macroTask)) {
                    return;
                }
                var reEntryGuard = task.state != running;
                reEntryGuard && zoneTask._transitionTo(running, scheduled);
                var previousTask = _currentTask;
                _currentTask = zoneTask;
                _currentZoneFrame = { parent: _currentZoneFrame, zone: this };
                try {
                    if (type == macroTask && task.data && !isPeriodic && !isRefreshable) {
                        task.cancelFn = undefined;
                    }
                    try {
                        return this._zoneDelegate.invokeTask(this, zoneTask, applyThis, applyArgs);
                    }
                    catch (error) {
                        if (this._zoneDelegate.handleError(this, error)) {
                            throw error;
                        }
                    }
                }
                finally {
                    // if the task's state is notScheduled or unknown, then it has already been cancelled
                    // we should not reset the state to scheduled
                    var state = task.state;
                    if (state !== notScheduled && state !== unknown) {
                        if (type == eventTask || isPeriodic || (isRefreshable && state === scheduling)) {
                            reEntryGuard && zoneTask._transitionTo(scheduled, running, scheduling);
                        }
                        else {
                            var zoneDelegates = zoneTask._zoneDelegates;
                            this._updateTaskCount(zoneTask, -1);
                            reEntryGuard && zoneTask._transitionTo(notScheduled, running, notScheduled);
                            if (isRefreshable) {
                                zoneTask._zoneDelegates = zoneDelegates;
                            }
                        }
                    }
                    _currentZoneFrame = _currentZoneFrame.parent;
                    _currentTask = previousTask;
                }
            };
            ZoneImpl.prototype.scheduleTask = function (task) {
                if (task.zone && task.zone !== this) {
                    // check if the task was rescheduled, the newZone
                    // should not be the children of the original zone
                    var newZone = this;
                    while (newZone) {
                        if (newZone === task.zone) {
                            throw Error("can not reschedule task to ".concat(this.name, " which is descendants of the original zone ").concat(task.zone.name));
                        }
                        newZone = newZone.parent;
                    }
                }
                task._transitionTo(scheduling, notScheduled);
                var zoneDelegates = [];
                task._zoneDelegates = zoneDelegates;
                task._zone = this;
                try {
                    task = this._zoneDelegate.scheduleTask(this, task);
                }
                catch (err) {
                    // should set task's state to unknown when scheduleTask throw error
                    // because the err may from reschedule, so the fromState maybe notScheduled
                    task._transitionTo(unknown, scheduling, notScheduled);
                    // TODO: @JiaLiPassion, should we check the result from handleError?
                    this._zoneDelegate.handleError(this, err);
                    throw err;
                }
                if (task._zoneDelegates === zoneDelegates) {
                    // we have to check because internally the delegate can reschedule the task.
                    this._updateTaskCount(task, 1);
                }
                if (task.state == scheduling) {
                    task._transitionTo(scheduled, scheduling);
                }
                return task;
            };
            ZoneImpl.prototype.scheduleMicroTask = function (source, callback, data, customSchedule) {
                return this.scheduleTask(new ZoneTask(microTask, source, callback, data, customSchedule, undefined));
            };
            ZoneImpl.prototype.scheduleMacroTask = function (source, callback, data, customSchedule, customCancel) {
                return this.scheduleTask(new ZoneTask(macroTask, source, callback, data, customSchedule, customCancel));
            };
            ZoneImpl.prototype.scheduleEventTask = function (source, callback, data, customSchedule, customCancel) {
                return this.scheduleTask(new ZoneTask(eventTask, source, callback, data, customSchedule, customCancel));
            };
            ZoneImpl.prototype.cancelTask = function (task) {
                if (task.zone != this)
                    throw new Error('A task can only be cancelled in the zone of creation! (Creation: ' +
                        (task.zone || NO_ZONE).name +
                        '; Execution: ' +
                        this.name +
                        ')');
                if (task.state !== scheduled && task.state !== running) {
                    return;
                }
                task._transitionTo(canceling, scheduled, running);
                try {
                    this._zoneDelegate.cancelTask(this, task);
                }
                catch (err) {
                    // if error occurs when cancelTask, transit the state to unknown
                    task._transitionTo(unknown, canceling);
                    this._zoneDelegate.handleError(this, err);
                    throw err;
                }
                this._updateTaskCount(task, -1);
                task._transitionTo(notScheduled, canceling);
                task.runCount = -1;
                return task;
            };
            ZoneImpl.prototype._updateTaskCount = function (task, count) {
                var zoneDelegates = task._zoneDelegates;
                if (count == -1) {
                    task._zoneDelegates = null;
                }
                for (var i = 0; i < zoneDelegates.length; i++) {
                    zoneDelegates[i]._updateTaskCount(task.type, count);
                }
            };
            ZoneImpl.__symbol__ = __symbol__;
            return ZoneImpl;
        }());
        var DELEGATE_ZS = {
            name: '',
            onHasTask: function (delegate, _, target, hasTaskState) { return delegate.hasTask(target, hasTaskState); },
            onScheduleTask: function (delegate, _, target, task) { return delegate.scheduleTask(target, task); },
            onInvokeTask: function (delegate, _, target, task, applyThis, applyArgs) { return delegate.invokeTask(target, task, applyThis, applyArgs); },
            onCancelTask: function (delegate, _, target, task) { return delegate.cancelTask(target, task); },
        };
        var _ZoneDelegate = /** @class */ (function () {
            function _ZoneDelegate(zone, parentDelegate, zoneSpec) {
                this._taskCounts = {
                    'microTask': 0,
                    'macroTask': 0,
                    'eventTask': 0,
                };
                this._zone = zone;
                this._parentDelegate = parentDelegate;
                this._forkZS = zoneSpec && (zoneSpec && zoneSpec.onFork ? zoneSpec : parentDelegate._forkZS);
                this._forkDlgt = zoneSpec && (zoneSpec.onFork ? parentDelegate : parentDelegate._forkDlgt);
                this._forkCurrZone =
                    zoneSpec && (zoneSpec.onFork ? this._zone : parentDelegate._forkCurrZone);
                this._interceptZS =
                    zoneSpec && (zoneSpec.onIntercept ? zoneSpec : parentDelegate._interceptZS);
                this._interceptDlgt =
                    zoneSpec && (zoneSpec.onIntercept ? parentDelegate : parentDelegate._interceptDlgt);
                this._interceptCurrZone =
                    zoneSpec && (zoneSpec.onIntercept ? this._zone : parentDelegate._interceptCurrZone);
                this._invokeZS = zoneSpec && (zoneSpec.onInvoke ? zoneSpec : parentDelegate._invokeZS);
                this._invokeDlgt =
                    zoneSpec && (zoneSpec.onInvoke ? parentDelegate : parentDelegate._invokeDlgt);
                this._invokeCurrZone =
                    zoneSpec && (zoneSpec.onInvoke ? this._zone : parentDelegate._invokeCurrZone);
                this._handleErrorZS =
                    zoneSpec && (zoneSpec.onHandleError ? zoneSpec : parentDelegate._handleErrorZS);
                this._handleErrorDlgt =
                    zoneSpec && (zoneSpec.onHandleError ? parentDelegate : parentDelegate._handleErrorDlgt);
                this._handleErrorCurrZone =
                    zoneSpec && (zoneSpec.onHandleError ? this._zone : parentDelegate._handleErrorCurrZone);
                this._scheduleTaskZS =
                    zoneSpec && (zoneSpec.onScheduleTask ? zoneSpec : parentDelegate._scheduleTaskZS);
                this._scheduleTaskDlgt =
                    zoneSpec && (zoneSpec.onScheduleTask ? parentDelegate : parentDelegate._scheduleTaskDlgt);
                this._scheduleTaskCurrZone =
                    zoneSpec && (zoneSpec.onScheduleTask ? this._zone : parentDelegate._scheduleTaskCurrZone);
                this._invokeTaskZS =
                    zoneSpec && (zoneSpec.onInvokeTask ? zoneSpec : parentDelegate._invokeTaskZS);
                this._invokeTaskDlgt =
                    zoneSpec && (zoneSpec.onInvokeTask ? parentDelegate : parentDelegate._invokeTaskDlgt);
                this._invokeTaskCurrZone =
                    zoneSpec && (zoneSpec.onInvokeTask ? this._zone : parentDelegate._invokeTaskCurrZone);
                this._cancelTaskZS =
                    zoneSpec && (zoneSpec.onCancelTask ? zoneSpec : parentDelegate._cancelTaskZS);
                this._cancelTaskDlgt =
                    zoneSpec && (zoneSpec.onCancelTask ? parentDelegate : parentDelegate._cancelTaskDlgt);
                this._cancelTaskCurrZone =
                    zoneSpec && (zoneSpec.onCancelTask ? this._zone : parentDelegate._cancelTaskCurrZone);
                this._hasTaskZS = null;
                this._hasTaskDlgt = null;
                this._hasTaskDlgtOwner = null;
                this._hasTaskCurrZone = null;
                var zoneSpecHasTask = zoneSpec && zoneSpec.onHasTask;
                var parentHasTask = parentDelegate && parentDelegate._hasTaskZS;
                if (zoneSpecHasTask || parentHasTask) {
                    // If we need to report hasTask, than this ZS needs to do ref counting on tasks. In such
                    // a case all task related interceptors must go through this ZD. We can't short circuit it.
                    this._hasTaskZS = zoneSpecHasTask ? zoneSpec : DELEGATE_ZS;
                    this._hasTaskDlgt = parentDelegate;
                    this._hasTaskDlgtOwner = this;
                    this._hasTaskCurrZone = this._zone;
                    if (!zoneSpec.onScheduleTask) {
                        this._scheduleTaskZS = DELEGATE_ZS;
                        this._scheduleTaskDlgt = parentDelegate;
                        this._scheduleTaskCurrZone = this._zone;
                    }
                    if (!zoneSpec.onInvokeTask) {
                        this._invokeTaskZS = DELEGATE_ZS;
                        this._invokeTaskDlgt = parentDelegate;
                        this._invokeTaskCurrZone = this._zone;
                    }
                    if (!zoneSpec.onCancelTask) {
                        this._cancelTaskZS = DELEGATE_ZS;
                        this._cancelTaskDlgt = parentDelegate;
                        this._cancelTaskCurrZone = this._zone;
                    }
                }
            }
            Object.defineProperty(_ZoneDelegate.prototype, "zone", {
                get: function () {
                    return this._zone;
                },
                enumerable: false,
                configurable: true
            });
            _ZoneDelegate.prototype.fork = function (targetZone, zoneSpec) {
                return this._forkZS
                    ? this._forkZS.onFork(this._forkDlgt, this.zone, targetZone, zoneSpec)
                    : new ZoneImpl(targetZone, zoneSpec);
            };
            _ZoneDelegate.prototype.intercept = function (targetZone, callback, source) {
                return this._interceptZS
                    ? this._interceptZS.onIntercept(this._interceptDlgt, this._interceptCurrZone, targetZone, callback, source)
                    : callback;
            };
            _ZoneDelegate.prototype.invoke = function (targetZone, callback, applyThis, applyArgs, source) {
                return this._invokeZS
                    ? this._invokeZS.onInvoke(this._invokeDlgt, this._invokeCurrZone, targetZone, callback, applyThis, applyArgs, source)
                    : callback.apply(applyThis, applyArgs);
            };
            _ZoneDelegate.prototype.handleError = function (targetZone, error) {
                return this._handleErrorZS
                    ? this._handleErrorZS.onHandleError(this._handleErrorDlgt, this._handleErrorCurrZone, targetZone, error)
                    : true;
            };
            _ZoneDelegate.prototype.scheduleTask = function (targetZone, task) {
                var returnTask = task;
                if (this._scheduleTaskZS) {
                    if (this._hasTaskZS) {
                        returnTask._zoneDelegates.push(this._hasTaskDlgtOwner);
                    }
                    returnTask = this._scheduleTaskZS.onScheduleTask(this._scheduleTaskDlgt, this._scheduleTaskCurrZone, targetZone, task);
                    if (!returnTask)
                        returnTask = task;
                }
                else {
                    if (task.scheduleFn) {
                        task.scheduleFn(task);
                    }
                    else if (task.type == microTask) {
                        scheduleMicroTask(task);
                    }
                    else {
                        throw new Error('Task is missing scheduleFn.');
                    }
                }
                return returnTask;
            };
            _ZoneDelegate.prototype.invokeTask = function (targetZone, task, applyThis, applyArgs) {
                return this._invokeTaskZS
                    ? this._invokeTaskZS.onInvokeTask(this._invokeTaskDlgt, this._invokeTaskCurrZone, targetZone, task, applyThis, applyArgs)
                    : task.callback.apply(applyThis, applyArgs);
            };
            _ZoneDelegate.prototype.cancelTask = function (targetZone, task) {
                var value;
                if (this._cancelTaskZS) {
                    value = this._cancelTaskZS.onCancelTask(this._cancelTaskDlgt, this._cancelTaskCurrZone, targetZone, task);
                }
                else {
                    if (!task.cancelFn) {
                        throw Error('Task is not cancelable');
                    }
                    value = task.cancelFn(task);
                }
                return value;
            };
            _ZoneDelegate.prototype.hasTask = function (targetZone, isEmpty) {
                // hasTask should not throw error so other ZoneDelegate
                // can still trigger hasTask callback
                try {
                    this._hasTaskZS &&
                        this._hasTaskZS.onHasTask(this._hasTaskDlgt, this._hasTaskCurrZone, targetZone, isEmpty);
                }
                catch (err) {
                    this.handleError(targetZone, err);
                }
            };
            _ZoneDelegate.prototype._updateTaskCount = function (type, count) {
                var counts = this._taskCounts;
                var prev = counts[type];
                var next = (counts[type] = prev + count);
                if (next < 0) {
                    throw new Error('More tasks executed then were scheduled.');
                }
                if (prev == 0 || next == 0) {
                    var isEmpty = {
                        microTask: counts['microTask'] > 0,
                        macroTask: counts['macroTask'] > 0,
                        eventTask: counts['eventTask'] > 0,
                        change: type,
                    };
                    this.hasTask(this._zone, isEmpty);
                }
            };
            return _ZoneDelegate;
        }());
        var ZoneTask = /** @class */ (function () {
            function ZoneTask(type, source, callback, options, scheduleFn, cancelFn) {
                this._zone = null;
                this.runCount = 0;
                this._zoneDelegates = null;
                this._state = 'notScheduled';
                this.type = type;
                this.source = source;
                this.data = options;
                this.scheduleFn = scheduleFn;
                this.cancelFn = cancelFn;
                if (!callback) {
                    throw new Error('callback is not defined');
                }
                this.callback = callback;
                var self = this;
                // TODO: @JiaLiPassion options should have interface
                if (type === eventTask && options && options.useG) {
                    this.invoke = ZoneTask.invokeTask;
                }
                else {
                    this.invoke = function () {
                        return ZoneTask.invokeTask.call(global, self, this, arguments);
                    };
                }
            }
            ZoneTask.invokeTask = function (task, target, args) {
                if (!task) {
                    task = this;
                }
                _numberOfNestedTaskFrames++;
                try {
                    task.runCount++;
                    return task.zone.runTask(task, target, args);
                }
                finally {
                    if (_numberOfNestedTaskFrames == 1) {
                        drainMicroTaskQueue();
                    }
                    _numberOfNestedTaskFrames--;
                }
            };
            Object.defineProperty(ZoneTask.prototype, "zone", {
                get: function () {
                    return this._zone;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(ZoneTask.prototype, "state", {
                get: function () {
                    return this._state;
                },
                enumerable: false,
                configurable: true
            });
            ZoneTask.prototype.cancelScheduleRequest = function () {
                this._transitionTo(notScheduled, scheduling);
            };
            ZoneTask.prototype._transitionTo = function (toState, fromState1, fromState2) {
                if (this._state === fromState1 || this._state === fromState2) {
                    this._state = toState;
                    if (toState == notScheduled) {
                        this._zoneDelegates = null;
                    }
                }
                else {
                    throw new Error("".concat(this.type, " '").concat(this.source, "': can not transition to '").concat(toState, "', expecting state '").concat(fromState1, "'").concat(fromState2 ? " or '" + fromState2 + "'" : '', ", was '").concat(this._state, "'."));
                }
            };
            ZoneTask.prototype.toString = function () {
                if (this.data && typeof this.data.handleId !== 'undefined') {
                    return this.data.handleId.toString();
                }
                else {
                    return Object.prototype.toString.call(this);
                }
            };
            // add toJSON method to prevent cyclic error when
            // call JSON.stringify(zoneTask)
            ZoneTask.prototype.toJSON = function () {
                return {
                    type: this.type,
                    state: this.state,
                    source: this.source,
                    zone: this.zone.name,
                    runCount: this.runCount,
                };
            };
            return ZoneTask;
        }());
        //////////////////////////////////////////////////////
        //////////////////////////////////////////////////////
        ///  MICROTASK QUEUE
        //////////////////////////////////////////////////////
        //////////////////////////////////////////////////////
        var symbolSetTimeout = __symbol__('setTimeout');
        var symbolPromise = __symbol__('Promise');
        var symbolThen = __symbol__('then');
        var _microTaskQueue = [];
        var _isDrainingMicrotaskQueue = false;
        var nativeMicroTaskQueuePromise;
        function nativeScheduleMicroTask(func) {
            if (!nativeMicroTaskQueuePromise) {
                if (global[symbolPromise]) {
                    nativeMicroTaskQueuePromise = global[symbolPromise].resolve(0);
                }
            }
            if (nativeMicroTaskQueuePromise) {
                var nativeThen = nativeMicroTaskQueuePromise[symbolThen];
                if (!nativeThen) {
                    // native Promise is not patchable, we need to use `then` directly
                    // issue 1078
                    nativeThen = nativeMicroTaskQueuePromise['then'];
                }
                nativeThen.call(nativeMicroTaskQueuePromise, func);
            }
            else {
                global[symbolSetTimeout](func, 0);
            }
        }
        function scheduleMicroTask(task) {
            // if we are not running in any task, and there has not been anything scheduled
            // we must bootstrap the initial task creation by manually scheduling the drain
            if (_numberOfNestedTaskFrames === 0 && _microTaskQueue.length === 0) {
                // We are not running in Task, so we need to kickstart the microtask queue.
                nativeScheduleMicroTask(drainMicroTaskQueue);
            }
            task && _microTaskQueue.push(task);
        }
        function drainMicroTaskQueue() {
            if (!_isDrainingMicrotaskQueue) {
                _isDrainingMicrotaskQueue = true;
                while (_microTaskQueue.length) {
                    var queue = _microTaskQueue;
                    _microTaskQueue = [];
                    for (var i = 0; i < queue.length; i++) {
                        var task = queue[i];
                        try {
                            task.zone.runTask(task, null, null);
                        }
                        catch (error) {
                            _api.onUnhandledError(error);
                        }
                    }
                }
                _api.microtaskDrainDone();
                _isDrainingMicrotaskQueue = false;
            }
        }
        //////////////////////////////////////////////////////
        //////////////////////////////////////////////////////
        ///  BOOTSTRAP
        //////////////////////////////////////////////////////
        //////////////////////////////////////////////////////
        var NO_ZONE = { name: 'NO ZONE' };
        var notScheduled = 'notScheduled', scheduling = 'scheduling', scheduled = 'scheduled', running = 'running', canceling = 'canceling', unknown = 'unknown';
        var microTask = 'microTask', macroTask = 'macroTask', eventTask = 'eventTask';
        var patches = {};
        var _api = {
            symbol: __symbol__,
            currentZoneFrame: function () { return _currentZoneFrame; },
            onUnhandledError: noop,
            microtaskDrainDone: noop,
            scheduleMicroTask: scheduleMicroTask,
            showUncaughtError: function () { return !ZoneImpl[__symbol__('ignoreConsoleErrorUncaughtError')]; },
            patchEventTarget: function () { return []; },
            patchOnProperties: noop,
            patchMethod: function () { return noop; },
            bindArguments: function () { return []; },
            patchThen: function () { return noop; },
            patchMacroTask: function () { return noop; },
            patchEventPrototype: function () { return noop; },
            isIEOrEdge: function () { return false; },
            getGlobalObjects: function () { return undefined; },
            ObjectDefineProperty: function () { return noop; },
            ObjectGetOwnPropertyDescriptor: function () { return undefined; },
            ObjectCreate: function () { return undefined; },
            ArraySlice: function () { return []; },
            patchClass: function () { return noop; },
            wrapWithCurrentZone: function () { return noop; },
            filterProperties: function () { return []; },
            attachOriginToPatched: function () { return noop; },
            _redefineProperty: function () { return noop; },
            patchCallbacks: function () { return noop; },
            nativeScheduleMicroTask: nativeScheduleMicroTask,
        };
        var _currentZoneFrame = { parent: null, zone: new ZoneImpl(null, null) };
        var _currentTask = null;
        var _numberOfNestedTaskFrames = 0;
        function noop() { }
        performanceMeasure('Zone', 'Zone');
        return ZoneImpl;
    }
    function loadZone() {
        var _a;
        // if global['Zone'] already exists (maybe zone.js was already loaded or
        // some other lib also registered a global object named Zone), we may need
        // to throw an error, but sometimes user may not want this error.
        // For example,
        // we have two web pages, page1 includes zone.js, page2 doesn't.
        // and the 1st time user load page1 and page2, everything work fine,
        // but when user load page2 again, error occurs because global['Zone'] already exists.
        // so we add a flag to let user choose whether to throw this error or not.
        // By default, if existing Zone is from zone.js, we will not throw the error.
        var global = globalThis;
        var checkDuplicate = global[__symbol__('forceDuplicateZoneCheck')] === true;
        if (global['Zone'] && (checkDuplicate || typeof global['Zone'].__symbol__ !== 'function')) {
            throw new Error('Zone already loaded.');
        }
        // Initialize global `Zone` constant.
        (_a = global['Zone']) !== null && _a !== void 0 ? _a : (global['Zone'] = initZone());
        return global['Zone'];
    }
    /**
     * Suppress closure compiler errors about unknown 'Zone' variable
     * @fileoverview
     * @suppress {undefinedVars,globalThis,missingRequire}
     */
    /// <reference types="node"/>
    // issue #989, to reduce bundle size, use short name
    /** Object.getOwnPropertyDescriptor */
    var ObjectGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    /** Object.defineProperty */
    var ObjectDefineProperty = Object.defineProperty;
    /** Object.getPrototypeOf */
    var ObjectGetPrototypeOf = Object.getPrototypeOf;
    /** Object.create */
    var ObjectCreate = Object.create;
    /** Array.prototype.slice */
    var ArraySlice = Array.prototype.slice;
    /** addEventListener string const */
    var ADD_EVENT_LISTENER_STR = 'addEventListener';
    /** removeEventListener string const */
    var REMOVE_EVENT_LISTENER_STR = 'removeEventListener';
    /** zoneSymbol addEventListener */
    var ZONE_SYMBOL_ADD_EVENT_LISTENER = __symbol__(ADD_EVENT_LISTENER_STR);
    /** zoneSymbol removeEventListener */
    var ZONE_SYMBOL_REMOVE_EVENT_LISTENER = __symbol__(REMOVE_EVENT_LISTENER_STR);
    /** true string const */
    var TRUE_STR = 'true';
    /** false string const */
    var FALSE_STR = 'false';
    /** Zone symbol prefix string const. */
    var ZONE_SYMBOL_PREFIX = __symbol__('');
    function wrapWithCurrentZone(callback, source) {
        return Zone.current.wrap(callback, source);
    }
    function scheduleMacroTaskWithCurrentZone(source, callback, data, customSchedule, customCancel) {
        return Zone.current.scheduleMacroTask(source, callback, data, customSchedule, customCancel);
    }
    var zoneSymbol = __symbol__;
    var isWindowExists = typeof window !== 'undefined';
    var internalWindow = isWindowExists ? window : undefined;
    var _global = (isWindowExists && internalWindow) || globalThis;
    var REMOVE_ATTRIBUTE = 'removeAttribute';
    function bindArguments(args, source) {
        for (var i = args.length - 1; i >= 0; i--) {
            if (typeof args[i] === 'function') {
                args[i] = wrapWithCurrentZone(args[i], source + '_' + i);
            }
        }
        return args;
    }
    function patchPrototype(prototype, fnNames) {
        var source = prototype.constructor['name'];
        var _loop_1 = function (i) {
            var name_1 = fnNames[i];
            var delegate = prototype[name_1];
            if (delegate) {
                var prototypeDesc = ObjectGetOwnPropertyDescriptor(prototype, name_1);
                if (!isPropertyWritable(prototypeDesc)) {
                    return "continue";
                }
                prototype[name_1] = (function (delegate) {
                    var patched = function () {
                        return delegate.apply(this, bindArguments(arguments, source + '.' + name_1));
                    };
                    attachOriginToPatched(patched, delegate);
                    return patched;
                })(delegate);
            }
        };
        for (var i = 0; i < fnNames.length; i++) {
            _loop_1(i);
        }
    }
    function isPropertyWritable(propertyDesc) {
        if (!propertyDesc) {
            return true;
        }
        if (propertyDesc.writable === false) {
            return false;
        }
        return !(typeof propertyDesc.get === 'function' && typeof propertyDesc.set === 'undefined');
    }
    var isWebWorker = typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope;
    // Make sure to access `process` through `_global` so that WebPack does not accidentally browserify
    // this code.
    var isNode = !('nw' in _global) &&
        typeof _global.process !== 'undefined' &&
        _global.process.toString() === '[object process]';
    var isBrowser = !isNode && !isWebWorker && !!(isWindowExists && internalWindow['HTMLElement']);
    // we are in electron of nw, so we are both browser and nodejs
    // Make sure to access `process` through `_global` so that WebPack does not accidentally browserify
    // this code.
    var isMix = typeof _global.process !== 'undefined' &&
        _global.process.toString() === '[object process]' &&
        !isWebWorker &&
        !!(isWindowExists && internalWindow['HTMLElement']);
    var zoneSymbolEventNames$1 = {};
    var enableBeforeunloadSymbol = zoneSymbol('enable_beforeunload');
    var wrapFn = function (event) {
        // https://github.com/angular/zone.js/issues/911, in IE, sometimes
        // event will be undefined, so we need to use window.event
        event = event || _global.event;
        if (!event) {
            return;
        }
        var eventNameSymbol = zoneSymbolEventNames$1[event.type];
        if (!eventNameSymbol) {
            eventNameSymbol = zoneSymbolEventNames$1[event.type] = zoneSymbol('ON_PROPERTY' + event.type);
        }
        var target = this || event.target || _global;
        var listener = target[eventNameSymbol];
        var result;
        if (isBrowser && target === internalWindow && event.type === 'error') {
            // window.onerror have different signature
            // https://developer.mozilla.org/en-US/docs/Web/API/GlobalEventHandlers/onerror#window.onerror
            // and onerror callback will prevent default when callback return true
            var errorEvent = event;
            result =
                listener &&
                    listener.call(this, errorEvent.message, errorEvent.filename, errorEvent.lineno, errorEvent.colno, errorEvent.error);
            if (result === true) {
                event.preventDefault();
            }
        }
        else {
            result = listener && listener.apply(this, arguments);
            if (
            // https://github.com/angular/angular/issues/47579
            // https://www.w3.org/TR/2011/WD-html5-20110525/history.html#beforeunloadevent
            // This is the only specific case we should check for. The spec defines that the
            // `returnValue` attribute represents the message to show the user. When the event
            // is created, this attribute must be set to the empty string.
            event.type === 'beforeunload' &&
                // To prevent any breaking changes resulting from this change, given that
                // it was already causing a significant number of failures in G3, we have hidden
                // that behavior behind a global configuration flag. Consumers can enable this
                // flag explicitly if they want the `beforeunload` event to be handled as defined
                // in the specification.
                _global[enableBeforeunloadSymbol] &&
                // The IDL event definition is `attribute DOMString returnValue`, so we check whether
                // `typeof result` is a string.
                typeof result === 'string') {
                event.returnValue = result;
            }
            else if (result != undefined && !result) {
                event.preventDefault();
            }
        }
        return result;
    };
    function patchProperty(obj, prop, prototype) {
        var desc = ObjectGetOwnPropertyDescriptor(obj, prop);
        if (!desc && prototype) {
            // when patch window object, use prototype to check prop exist or not
            var prototypeDesc = ObjectGetOwnPropertyDescriptor(prototype, prop);
            if (prototypeDesc) {
                desc = { enumerable: true, configurable: true };
            }
        }
        // if the descriptor not exists or is not configurable
        // just return
        if (!desc || !desc.configurable) {
            return;
        }
        var onPropPatchedSymbol = zoneSymbol('on' + prop + 'patched');
        if (obj.hasOwnProperty(onPropPatchedSymbol) && obj[onPropPatchedSymbol]) {
            return;
        }
        // A property descriptor cannot have getter/setter and be writable
        // deleting the writable and value properties avoids this error:
        //
        // TypeError: property descriptors must not specify a value or be writable when a
        // getter or setter has been specified
        delete desc.writable;
        delete desc.value;
        var originalDescGet = desc.get;
        var originalDescSet = desc.set;
        // slice(2) cuz 'onclick' -> 'click', etc
        var eventName = prop.slice(2);
        var eventNameSymbol = zoneSymbolEventNames$1[eventName];
        if (!eventNameSymbol) {
            eventNameSymbol = zoneSymbolEventNames$1[eventName] = zoneSymbol('ON_PROPERTY' + eventName);
        }
        desc.set = function (newValue) {
            // In some versions of Windows, the `this` context may be undefined
            // in on-property callbacks.
            // To handle this edge case, we check if `this` is falsy and
            // fallback to `_global` if needed.
            var target = this;
            if (!target && obj === _global) {
                target = _global;
            }
            if (!target) {
                return;
            }
            var previousValue = target[eventNameSymbol];
            if (typeof previousValue === 'function') {
                target.removeEventListener(eventName, wrapFn);
            }
            // https://github.com/angular/zone.js/issues/978
            // If an inline handler (like `onload`) was defined before zone.js was loaded,
            // call the original descriptor's setter to clean it up.
            originalDescSet === null || originalDescSet === void 0 ? void 0 : originalDescSet.call(target, null);
            target[eventNameSymbol] = newValue;
            if (typeof newValue === 'function') {
                target.addEventListener(eventName, wrapFn, false);
            }
        };
        // The getter would return undefined for unassigned properties but the default value of an
        // unassigned property is null
        desc.get = function () {
            // in some of windows's onproperty callback, this is undefined
            // so we need to check it
            var target = this;
            if (!target && obj === _global) {
                target = _global;
            }
            if (!target) {
                return null;
            }
            var listener = target[eventNameSymbol];
            if (listener) {
                return listener;
            }
            else if (originalDescGet) {
                // result will be null when use inline event attribute,
                // such as <button onclick="func();">OK</button>
                // because the onclick function is internal raw uncompiled handler
                // the onclick will be evaluated when first time event was triggered or
                // the property is accessed, https://github.com/angular/zone.js/issues/525
                // so we should use original native get to retrieve the handler
                var value = originalDescGet.call(this);
                if (value) {
                    desc.set.call(this, value);
                    if (typeof target[REMOVE_ATTRIBUTE] === 'function') {
                        target.removeAttribute(prop);
                    }
                    return value;
                }
            }
            return null;
        };
        ObjectDefineProperty(obj, prop, desc);
        obj[onPropPatchedSymbol] = true;
    }
    function patchOnProperties(obj, properties, prototype) {
        if (properties) {
            for (var i = 0; i < properties.length; i++) {
                patchProperty(obj, 'on' + properties[i], prototype);
            }
        }
        else {
            var onProperties = [];
            for (var prop in obj) {
                if (prop.slice(0, 2) == 'on') {
                    onProperties.push(prop);
                }
            }
            for (var j = 0; j < onProperties.length; j++) {
                patchProperty(obj, onProperties[j], prototype);
            }
        }
    }
    var originalInstanceKey = zoneSymbol('originalInstance');
    // wrap some native API on `window`
    function patchClass(className) {
        var OriginalClass = _global[className];
        if (!OriginalClass)
            return;
        // keep original class in global
        _global[zoneSymbol(className)] = OriginalClass;
        _global[className] = function () {
            var a = bindArguments(arguments, className);
            switch (a.length) {
                case 0:
                    this[originalInstanceKey] = new OriginalClass();
                    break;
                case 1:
                    this[originalInstanceKey] = new OriginalClass(a[0]);
                    break;
                case 2:
                    this[originalInstanceKey] = new OriginalClass(a[0], a[1]);
                    break;
                case 3:
                    this[originalInstanceKey] = new OriginalClass(a[0], a[1], a[2]);
                    break;
                case 4:
                    this[originalInstanceKey] = new OriginalClass(a[0], a[1], a[2], a[3]);
                    break;
                default:
                    throw new Error('Arg list too long.');
            }
        };
        // attach original delegate to patched function
        attachOriginToPatched(_global[className], OriginalClass);
        var instance = new OriginalClass(function () { });
        var prop;
        for (prop in instance) {
            // https://bugs.webkit.org/show_bug.cgi?id=44721
            if (className === 'XMLHttpRequest' && prop === 'responseBlob')
                continue;
            (function (prop) {
                if (typeof instance[prop] === 'function') {
                    _global[className].prototype[prop] = function () {
                        return this[originalInstanceKey][prop].apply(this[originalInstanceKey], arguments);
                    };
                }
                else {
                    ObjectDefineProperty(_global[className].prototype, prop, {
                        set: function (fn) {
                            if (typeof fn === 'function') {
                                this[originalInstanceKey][prop] = wrapWithCurrentZone(fn, className + '.' + prop);
                                // keep callback in wrapped function so we can
                                // use it in Function.prototype.toString to return
                                // the native one.
                                attachOriginToPatched(this[originalInstanceKey][prop], fn);
                            }
                            else {
                                this[originalInstanceKey][prop] = fn;
                            }
                        },
                        get: function () {
                            return this[originalInstanceKey][prop];
                        },
                    });
                }
            })(prop);
        }
        for (prop in OriginalClass) {
            if (prop !== 'prototype' && OriginalClass.hasOwnProperty(prop)) {
                _global[className][prop] = OriginalClass[prop];
            }
        }
    }
    function patchMethod(target, name, patchFn) {
        var proto = target;
        while (proto && !proto.hasOwnProperty(name)) {
            proto = ObjectGetPrototypeOf(proto);
        }
        if (!proto && target[name]) {
            // somehow we did not find it, but we can see it. This happens on IE for Window properties.
            proto = target;
        }
        var delegateName = zoneSymbol(name);
        var delegate = null;
        if (proto && (!(delegate = proto[delegateName]) || !proto.hasOwnProperty(delegateName))) {
            delegate = proto[delegateName] = proto[name];
            // check whether proto[name] is writable
            // some property is readonly in safari, such as HtmlCanvasElement.prototype.toBlob
            var desc = proto && ObjectGetOwnPropertyDescriptor(proto, name);
            if (isPropertyWritable(desc)) {
                var patchDelegate_1 = patchFn(delegate, delegateName, name);
                proto[name] = function () {
                    return patchDelegate_1(this, arguments);
                };
                attachOriginToPatched(proto[name], delegate);
            }
        }
        return delegate;
    }
    // TODO: @JiaLiPassion, support cancel task later if necessary
    function patchMacroTask(obj, funcName, metaCreator) {
        var setNative = null;
        function scheduleTask(task) {
            var data = task.data;
            data.args[data.cbIdx] = function () {
                task.invoke.apply(this, arguments);
            };
            setNative.apply(data.target, data.args);
            return task;
        }
        setNative = patchMethod(obj, funcName, function (delegate) { return function (self, args) {
            var meta = metaCreator(self, args);
            if (meta.cbIdx >= 0 && typeof args[meta.cbIdx] === 'function') {
                return scheduleMacroTaskWithCurrentZone(meta.name, args[meta.cbIdx], meta, scheduleTask);
            }
            else {
                // cause an error by calling it directly.
                return delegate.apply(self, args);
            }
        }; });
    }
    function attachOriginToPatched(patched, original) {
        patched[zoneSymbol('OriginalDelegate')] = original;
    }
    var isDetectedIEOrEdge = false;
    var ieOrEdge = false;
    function isIEOrEdge() {
        if (isDetectedIEOrEdge) {
            return ieOrEdge;
        }
        isDetectedIEOrEdge = true;
        try {
            var ua = internalWindow.navigator.userAgent;
            if (ua.indexOf('MSIE ') !== -1 || ua.indexOf('Trident/') !== -1 || ua.indexOf('Edge/') !== -1) {
                ieOrEdge = true;
            }
        }
        catch (error) { }
        return ieOrEdge;
    }
    function isFunction(value) {
        return typeof value === 'function';
    }
    function isNumber(value) {
        return typeof value === 'number';
    }
    /**
     * @fileoverview
     * @suppress {missingRequire}
     */
    // an identifier to tell ZoneTask do not create a new invoke closure
    var OPTIMIZED_ZONE_EVENT_TASK_DATA = {
        useG: true,
    };
    var zoneSymbolEventNames = {};
    var globalSources = {};
    var EVENT_NAME_SYMBOL_REGX = new RegExp('^' + ZONE_SYMBOL_PREFIX + '(\\w+)(true|false)$');
    var IMMEDIATE_PROPAGATION_SYMBOL = zoneSymbol('propagationStopped');
    function prepareEventNames(eventName, eventNameToString) {
        var falseEventName = (eventNameToString ? eventNameToString(eventName) : eventName) + FALSE_STR;
        var trueEventName = (eventNameToString ? eventNameToString(eventName) : eventName) + TRUE_STR;
        var symbol = ZONE_SYMBOL_PREFIX + falseEventName;
        var symbolCapture = ZONE_SYMBOL_PREFIX + trueEventName;
        zoneSymbolEventNames[eventName] = {};
        zoneSymbolEventNames[eventName][FALSE_STR] = symbol;
        zoneSymbolEventNames[eventName][TRUE_STR] = symbolCapture;
    }
    function patchEventTarget(_global, api, apis, patchOptions) {
        var ADD_EVENT_LISTENER = (patchOptions && patchOptions.add) || ADD_EVENT_LISTENER_STR;
        var REMOVE_EVENT_LISTENER = (patchOptions && patchOptions.rm) || REMOVE_EVENT_LISTENER_STR;
        var LISTENERS_EVENT_LISTENER = (patchOptions && patchOptions.listeners) || 'eventListeners';
        var REMOVE_ALL_LISTENERS_EVENT_LISTENER = (patchOptions && patchOptions.rmAll) || 'removeAllListeners';
        var zoneSymbolAddEventListener = zoneSymbol(ADD_EVENT_LISTENER);
        var ADD_EVENT_LISTENER_SOURCE = '.' + ADD_EVENT_LISTENER + ':';
        var PREPEND_EVENT_LISTENER = 'prependListener';
        var PREPEND_EVENT_LISTENER_SOURCE = '.' + PREPEND_EVENT_LISTENER + ':';
        var invokeTask = function (task, target, event) {
            // for better performance, check isRemoved which is set
            // by removeEventListener
            if (task.isRemoved) {
                return;
            }
            var delegate = task.callback;
            if (typeof delegate === 'object' && delegate.handleEvent) {
                // create the bind version of handleEvent when invoke
                task.callback = function (event) { return delegate.handleEvent(event); };
                task.originalDelegate = delegate;
            }
            // invoke static task.invoke
            // need to try/catch error here, otherwise, the error in one event listener
            // will break the executions of the other event listeners. Also error will
            // not remove the event listener when `once` options is true.
            var error;
            try {
                task.invoke(task, target, [event]);
            }
            catch (err) {
                error = err;
            }
            var options = task.options;
            if (options && typeof options === 'object' && options.once) {
                // if options.once is true, after invoke once remove listener here
                // only browser need to do this, nodejs eventEmitter will cal removeListener
                // inside EventEmitter.once
                var delegate_1 = task.originalDelegate ? task.originalDelegate : task.callback;
                target[REMOVE_EVENT_LISTENER].call(target, event.type, delegate_1, options);
            }
            return error;
        };
        function globalCallback(context, event, isCapture) {
            // https://github.com/angular/zone.js/issues/911, in IE, sometimes
            // event will be undefined, so we need to use window.event
            event = event || _global.event;
            if (!event) {
                return;
            }
            // event.target is needed for Samsung TV and SourceBuffer
            // || global is needed https://github.com/angular/zone.js/issues/190
            var target = context || event.target || _global;
            var tasks = target[zoneSymbolEventNames[event.type][isCapture ? TRUE_STR : FALSE_STR]];
            if (tasks) {
                var errors = [];
                // invoke all tasks which attached to current target with given event.type and capture = false
                // for performance concern, if task.length === 1, just invoke
                if (tasks.length === 1) {
                    var err = invokeTask(tasks[0], target, event);
                    err && errors.push(err);
                }
                else {
                    // https://github.com/angular/zone.js/issues/836
                    // copy the tasks array before invoke, to avoid
                    // the callback will remove itself or other listener
                    var copyTasks = tasks.slice();
                    for (var i = 0; i < copyTasks.length; i++) {
                        if (event && event[IMMEDIATE_PROPAGATION_SYMBOL] === true) {
                            break;
                        }
                        var err = invokeTask(copyTasks[i], target, event);
                        err && errors.push(err);
                    }
                }
                // Since there is only one error, we don't need to schedule microTask
                // to throw the error.
                if (errors.length === 1) {
                    throw errors[0];
                }
                else {
                    var _loop_2 = function (i) {
                        var err = errors[i];
                        api.nativeScheduleMicroTask(function () {
                            throw err;
                        });
                    };
                    for (var i = 0; i < errors.length; i++) {
                        _loop_2(i);
                    }
                }
            }
        }
        // global shared zoneAwareCallback to handle all event callback with capture = false
        var globalZoneAwareCallback = function (event) {
            return globalCallback(this, event, false);
        };
        // global shared zoneAwareCallback to handle all event callback with capture = true
        var globalZoneAwareCaptureCallback = function (event) {
            return globalCallback(this, event, true);
        };
        function patchEventTargetMethods(obj, patchOptions) {
            if (!obj) {
                return false;
            }
            var useGlobalCallback = true;
            if (patchOptions && patchOptions.useG !== undefined) {
                useGlobalCallback = patchOptions.useG;
            }
            var validateHandler = patchOptions && patchOptions.vh;
            var checkDuplicate = true;
            if (patchOptions && patchOptions.chkDup !== undefined) {
                checkDuplicate = patchOptions.chkDup;
            }
            var returnTarget = false;
            if (patchOptions && patchOptions.rt !== undefined) {
                returnTarget = patchOptions.rt;
            }
            var proto = obj;
            while (proto && !proto.hasOwnProperty(ADD_EVENT_LISTENER)) {
                proto = ObjectGetPrototypeOf(proto);
            }
            if (!proto && obj[ADD_EVENT_LISTENER]) {
                // somehow we did not find it, but we can see it. This happens on IE for Window properties.
                proto = obj;
            }
            if (!proto) {
                return false;
            }
            if (proto[zoneSymbolAddEventListener]) {
                return false;
            }
            var eventNameToString = patchOptions && patchOptions.eventNameToString;
            // We use a shared global `taskData` to pass data for `scheduleEventTask`,
            // eliminating the need to create a new object solely for passing data.
            // WARNING: This object has a static lifetime, meaning it is not created
            // each time `addEventListener` is called. It is instantiated only once
            // and captured by reference inside the `addEventListener` and
            // `removeEventListener` functions. Do not add any new properties to this
            // object, as doing so would necessitate maintaining the information
            // between `addEventListener` calls.
            var taskData = {};
            var nativeAddEventListener = (proto[zoneSymbolAddEventListener] = proto[ADD_EVENT_LISTENER]);
            var nativeRemoveEventListener = (proto[zoneSymbol(REMOVE_EVENT_LISTENER)] =
                proto[REMOVE_EVENT_LISTENER]);
            var nativeListeners = (proto[zoneSymbol(LISTENERS_EVENT_LISTENER)] =
                proto[LISTENERS_EVENT_LISTENER]);
            var nativeRemoveAllListeners = (proto[zoneSymbol(REMOVE_ALL_LISTENERS_EVENT_LISTENER)] =
                proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER]);
            var nativePrependEventListener;
            if (patchOptions && patchOptions.prepend) {
                nativePrependEventListener = proto[zoneSymbol(patchOptions.prepend)] =
                    proto[patchOptions.prepend];
            }
            /**
             * This util function will build an option object with passive option
             * to handle all possible input from the user.
             */
            function buildEventListenerOptions(options, passive) {
                if (!passive) {
                    return options;
                }
                if (typeof options === 'boolean') {
                    return { capture: options, passive: true };
                }
                if (!options) {
                    return { passive: true };
                }
                if (typeof options === 'object' && options.passive !== false) {
                    return __assign(__assign({}, options), { passive: true });
                }
                return options;
            }
            var customScheduleGlobal = function (task) {
                // if there is already a task for the eventName + capture,
                // just return, because we use the shared globalZoneAwareCallback here.
                if (taskData.isExisting) {
                    return;
                }
                return nativeAddEventListener.call(taskData.target, taskData.eventName, taskData.capture ? globalZoneAwareCaptureCallback : globalZoneAwareCallback, taskData.options);
            };
            /**
             * In the context of events and listeners, this function will be
             * called at the end by `cancelTask`, which, in turn, calls `task.cancelFn`.
             * Cancelling a task is primarily used to remove event listeners from
             * the task target.
             */
            var customCancelGlobal = function (task) {
                // if task is not marked as isRemoved, this call is directly
                // from Zone.prototype.cancelTask, we should remove the task
                // from tasksList of target first
                if (!task.isRemoved) {
                    var symbolEventNames = zoneSymbolEventNames[task.eventName];
                    var symbolEventName = void 0;
                    if (symbolEventNames) {
                        symbolEventName = symbolEventNames[task.capture ? TRUE_STR : FALSE_STR];
                    }
                    var existingTasks = symbolEventName && task.target[symbolEventName];
                    if (existingTasks) {
                        for (var i = 0; i < existingTasks.length; i++) {
                            var existingTask = existingTasks[i];
                            if (existingTask === task) {
                                existingTasks.splice(i, 1);
                                // set isRemoved to data for faster invokeTask check
                                task.isRemoved = true;
                                if (task.removeAbortListener) {
                                    task.removeAbortListener();
                                    task.removeAbortListener = null;
                                }
                                if (existingTasks.length === 0) {
                                    // all tasks for the eventName + capture have gone,
                                    // remove globalZoneAwareCallback and remove the task cache from target
                                    task.allRemoved = true;
                                    task.target[symbolEventName] = null;
                                }
                                break;
                            }
                        }
                    }
                }
                // if all tasks for the eventName + capture have gone,
                // we will really remove the global event callback,
                // if not, return
                if (!task.allRemoved) {
                    return;
                }
                return nativeRemoveEventListener.call(task.target, task.eventName, task.capture ? globalZoneAwareCaptureCallback : globalZoneAwareCallback, task.options);
            };
            var customScheduleNonGlobal = function (task) {
                return nativeAddEventListener.call(taskData.target, taskData.eventName, task.invoke, taskData.options);
            };
            var customSchedulePrepend = function (task) {
                return nativePrependEventListener.call(taskData.target, taskData.eventName, task.invoke, taskData.options);
            };
            var customCancelNonGlobal = function (task) {
                return nativeRemoveEventListener.call(task.target, task.eventName, task.invoke, task.options);
            };
            var customSchedule = useGlobalCallback ? customScheduleGlobal : customScheduleNonGlobal;
            var customCancel = useGlobalCallback ? customCancelGlobal : customCancelNonGlobal;
            var compareTaskCallbackVsDelegate = function (task, delegate) {
                var typeOfDelegate = typeof delegate;
                return ((typeOfDelegate === 'function' && task.callback === delegate) ||
                    (typeOfDelegate === 'object' && task.originalDelegate === delegate));
            };
            var compare = (patchOptions === null || patchOptions === void 0 ? void 0 : patchOptions.diff) || compareTaskCallbackVsDelegate;
            var unpatchedEvents = Zone[zoneSymbol('UNPATCHED_EVENTS')];
            var passiveEvents = _global[zoneSymbol('PASSIVE_EVENTS')];
            function copyEventListenerOptions(options) {
                if (typeof options === 'object' && options !== null) {
                    // We need to destructure the target `options` object since it may
                    // be frozen or sealed (possibly provided implicitly by a third-party
                    // library), or its properties may be readonly.
                    var newOptions = __assign({}, options);
                    // The `signal` option was recently introduced, which caused regressions in
                    // third-party scenarios where `AbortController` was directly provided to
                    // `addEventListener` as options. For instance, in cases like
                    // `document.addEventListener('keydown', callback, abortControllerInstance)`,
                    // which is valid because `AbortController` includes a `signal` getter, spreading
                    // `{...options}` wouldn't copy the `signal`. Additionally, using `Object.create`
                    // isn't feasible since `AbortController` is a built-in object type, and attempting
                    // to create a new object directly with it as the prototype might result in
                    // unexpected behavior.
                    if (options.signal) {
                        newOptions.signal = options.signal;
                    }
                    return newOptions;
                }
                return options;
            }
            var makeAddListener = function (nativeListener, addSource, customScheduleFn, customCancelFn, returnTarget, prepend) {
                if (returnTarget === void 0) { returnTarget = false; }
                if (prepend === void 0) { prepend = false; }
                return function () {
                    var target = this || _global;
                    var eventName = arguments[0];
                    if (patchOptions && patchOptions.transferEventName) {
                        eventName = patchOptions.transferEventName(eventName);
                    }
                    var delegate = arguments[1];
                    if (!delegate) {
                        return nativeListener.apply(this, arguments);
                    }
                    if (isNode && eventName === 'uncaughtException') {
                        // don't patch uncaughtException of nodejs to prevent endless loop
                        return nativeListener.apply(this, arguments);
                    }
                    // To improve `addEventListener` performance, we will create the callback
                    // for the task later when the task is invoked.
                    var isEventListenerObject = false;
                    if (typeof delegate !== 'function') {
                        // This checks whether the provided listener argument is an object with
                        // a `handleEvent` method (since we can call `addEventListener` with a
                        // function `event => ...` or with an object `{ handleEvent: event => ... }`).
                        if (!delegate.handleEvent) {
                            return nativeListener.apply(this, arguments);
                        }
                        isEventListenerObject = true;
                    }
                    if (validateHandler && !validateHandler(nativeListener, delegate, target, arguments)) {
                        return;
                    }
                    var passive = !!passiveEvents && passiveEvents.indexOf(eventName) !== -1;
                    var options = copyEventListenerOptions(buildEventListenerOptions(arguments[2], passive));
                    var signal = options === null || options === void 0 ? void 0 : options.signal;
                    if (signal === null || signal === void 0 ? void 0 : signal.aborted) {
                        // the signal is an aborted one, just return without attaching the event listener.
                        return;
                    }
                    if (unpatchedEvents) {
                        // check unpatched list
                        for (var i = 0; i < unpatchedEvents.length; i++) {
                            if (eventName === unpatchedEvents[i]) {
                                if (passive) {
                                    return nativeListener.call(target, eventName, delegate, options);
                                }
                                else {
                                    return nativeListener.apply(this, arguments);
                                }
                            }
                        }
                    }
                    var capture = !options ? false : typeof options === 'boolean' ? true : options.capture;
                    var once = options && typeof options === 'object' ? options.once : false;
                    var zone = Zone.current;
                    var symbolEventNames = zoneSymbolEventNames[eventName];
                    if (!symbolEventNames) {
                        prepareEventNames(eventName, eventNameToString);
                        symbolEventNames = zoneSymbolEventNames[eventName];
                    }
                    var symbolEventName = symbolEventNames[capture ? TRUE_STR : FALSE_STR];
                    var existingTasks = target[symbolEventName];
                    var isExisting = false;
                    if (existingTasks) {
                        // already have task registered
                        isExisting = true;
                        if (checkDuplicate) {
                            for (var i = 0; i < existingTasks.length; i++) {
                                if (compare(existingTasks[i], delegate)) {
                                    // same callback, same capture, same event name, just return
                                    return;
                                }
                            }
                        }
                    }
                    else {
                        existingTasks = target[symbolEventName] = [];
                    }
                    var source;
                    var constructorName = target.constructor['name'];
                    var targetSource = globalSources[constructorName];
                    if (targetSource) {
                        source = targetSource[eventName];
                    }
                    if (!source) {
                        source =
                            constructorName +
                                addSource +
                                (eventNameToString ? eventNameToString(eventName) : eventName);
                    }
                    // In the code below, `options` should no longer be reassigned; instead, it
                    // should only be mutated. This is because we pass that object to the native
                    // `addEventListener`.
                    // It's generally recommended to use the same object reference for options.
                    // This ensures consistency and avoids potential issues.
                    taskData.options = options;
                    if (once) {
                        // When using `addEventListener` with the `once` option, we don't pass
                        // the `once` option directly to the native `addEventListener` method.
                        // Instead, we keep the `once` setting and handle it ourselves.
                        taskData.options.once = false;
                    }
                    taskData.target = target;
                    taskData.capture = capture;
                    taskData.eventName = eventName;
                    taskData.isExisting = isExisting;
                    var data = useGlobalCallback ? OPTIMIZED_ZONE_EVENT_TASK_DATA : undefined;
                    // keep taskData into data to allow onScheduleEventTask to access the task information
                    if (data) {
                        data.taskData = taskData;
                    }
                    if (signal) {
                        // When using `addEventListener` with the `signal` option, we don't pass
                        // the `signal` option directly to the native `addEventListener` method.
                        // Instead, we keep the `signal` setting and handle it ourselves.
                        taskData.options.signal = undefined;
                    }
                    // The `scheduleEventTask` function will ultimately call `customScheduleGlobal`,
                    // which in turn calls the native `addEventListener`. This is why `taskData.options`
                    // is updated before scheduling the task, as `customScheduleGlobal` uses
                    // `taskData.options` to pass it to the native `addEventListener`.
                    var task = zone.scheduleEventTask(source, delegate, data, customScheduleFn, customCancelFn);
                    if (signal) {
                        // after task is scheduled, we need to store the signal back to task.options
                        taskData.options.signal = signal;
                        // Wrapping `task` in a weak reference would not prevent memory leaks. Weak references are
                        // primarily used for preventing strong references cycles. `onAbort` is always reachable
                        // as it's an event listener, so its closure retains a strong reference to the `task`.
                        var onAbort_1 = function () { return task.zone.cancelTask(task); };
                        nativeListener.call(signal, 'abort', onAbort_1, { once: true });
                        // We need to remove the `abort` listener when the event listener is going to be removed,
                        // as it creates a closure that captures `task`. This closure retains a reference to the
                        // `task` object even after it goes out of scope, preventing `task` from being garbage
                        // collected.
                        task.removeAbortListener = function () { return signal.removeEventListener('abort', onAbort_1); };
                    }
                    // should clear taskData.target to avoid memory leak
                    // issue, https://github.com/angular/angular/issues/20442
                    taskData.target = null;
                    // need to clear up taskData because it is a global object
                    if (data) {
                        data.taskData = null;
                    }
                    // have to save those information to task in case
                    // application may call task.zone.cancelTask() directly
                    if (once) {
                        taskData.options.once = true;
                    }
                    if (typeof task.options !== 'boolean') {
                        // We should save the options on the task (if it's an object) because
                        // we'll be using `task.options` later when removing the event listener
                        // and passing it back to `removeEventListener`.
                        task.options = options;
                    }
                    task.target = target;
                    task.capture = capture;
                    task.eventName = eventName;
                    if (isEventListenerObject) {
                        // save original delegate for compare to check duplicate
                        task.originalDelegate = delegate;
                    }
                    if (!prepend) {
                        existingTasks.push(task);
                    }
                    else {
                        existingTasks.unshift(task);
                    }
                    if (returnTarget) {
                        return target;
                    }
                };
            };
            proto[ADD_EVENT_LISTENER] = makeAddListener(nativeAddEventListener, ADD_EVENT_LISTENER_SOURCE, customSchedule, customCancel, returnTarget);
            if (nativePrependEventListener) {
                proto[PREPEND_EVENT_LISTENER] = makeAddListener(nativePrependEventListener, PREPEND_EVENT_LISTENER_SOURCE, customSchedulePrepend, customCancel, returnTarget, true);
            }
            proto[REMOVE_EVENT_LISTENER] = function () {
                var target = this || _global;
                var eventName = arguments[0];
                if (patchOptions && patchOptions.transferEventName) {
                    eventName = patchOptions.transferEventName(eventName);
                }
                var options = arguments[2];
                var capture = !options ? false : typeof options === 'boolean' ? true : options.capture;
                var delegate = arguments[1];
                if (!delegate) {
                    return nativeRemoveEventListener.apply(this, arguments);
                }
                if (validateHandler &&
                    !validateHandler(nativeRemoveEventListener, delegate, target, arguments)) {
                    return;
                }
                var symbolEventNames = zoneSymbolEventNames[eventName];
                var symbolEventName;
                if (symbolEventNames) {
                    symbolEventName = symbolEventNames[capture ? TRUE_STR : FALSE_STR];
                }
                var existingTasks = symbolEventName && target[symbolEventName];
                // `existingTasks` may not exist if the `addEventListener` was called before
                // it was patched by zone.js. Please refer to the attached issue for
                // clarification, particularly after the `if` condition, before calling
                // the native `removeEventListener`.
                if (existingTasks) {
                    for (var i = 0; i < existingTasks.length; i++) {
                        var existingTask = existingTasks[i];
                        if (compare(existingTask, delegate)) {
                            existingTasks.splice(i, 1);
                            // set isRemoved to data for faster invokeTask check
                            existingTask.isRemoved = true;
                            if (existingTasks.length === 0) {
                                // all tasks for the eventName + capture have gone,
                                // remove globalZoneAwareCallback and remove the task cache from target
                                existingTask.allRemoved = true;
                                target[symbolEventName] = null;
                                // in the target, we have an event listener which is added by on_property
                                // such as target.onclick = function() {}, so we need to clear this internal
                                // property too if all delegates with capture=false were removed
                                // https:// github.com/angular/angular/issues/31643
                                // https://github.com/angular/angular/issues/54581
                                if (!capture && typeof eventName === 'string') {
                                    var onPropertySymbol = ZONE_SYMBOL_PREFIX + 'ON_PROPERTY' + eventName;
                                    target[onPropertySymbol] = null;
                                }
                            }
                            // In all other conditions, when `addEventListener` is called after being
                            // patched by zone.js, we would always find an event task on the `EventTarget`.
                            // This will trigger `cancelFn` on the `existingTask`, leading to `customCancelGlobal`,
                            // which ultimately removes an event listener and cleans up the abort listener
                            // (if an `AbortSignal` was provided when scheduling a task).
                            existingTask.zone.cancelTask(existingTask);
                            if (returnTarget) {
                                return target;
                            }
                            return;
                        }
                    }
                }
                // https://github.com/angular/zone.js/issues/930
                // We may encounter a situation where the `addEventListener` was
                // called on the event target before zone.js is loaded, resulting
                // in no task being stored on the event target due to its invocation
                // of the native implementation. In this scenario, we simply need to
                // invoke the native `removeEventListener`.
                return nativeRemoveEventListener.apply(this, arguments);
            };
            proto[LISTENERS_EVENT_LISTENER] = function () {
                var target = this || _global;
                var eventName = arguments[0];
                if (patchOptions && patchOptions.transferEventName) {
                    eventName = patchOptions.transferEventName(eventName);
                }
                var listeners = [];
                var tasks = findEventTasks(target, eventNameToString ? eventNameToString(eventName) : eventName);
                for (var i = 0; i < tasks.length; i++) {
                    var task = tasks[i];
                    var delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                    listeners.push(delegate);
                }
                return listeners;
            };
            proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER] = function () {
                var target = this || _global;
                var eventName = arguments[0];
                if (!eventName) {
                    var keys = Object.keys(target);
                    for (var i = 0; i < keys.length; i++) {
                        var prop = keys[i];
                        var match = EVENT_NAME_SYMBOL_REGX.exec(prop);
                        var evtName = match && match[1];
                        // in nodejs EventEmitter, removeListener event is
                        // used for monitoring the removeListener call,
                        // so just keep removeListener eventListener until
                        // all other eventListeners are removed
                        if (evtName && evtName !== 'removeListener') {
                            this[REMOVE_ALL_LISTENERS_EVENT_LISTENER].call(this, evtName);
                        }
                    }
                    // remove removeListener listener finally
                    this[REMOVE_ALL_LISTENERS_EVENT_LISTENER].call(this, 'removeListener');
                }
                else {
                    if (patchOptions && patchOptions.transferEventName) {
                        eventName = patchOptions.transferEventName(eventName);
                    }
                    var symbolEventNames = zoneSymbolEventNames[eventName];
                    if (symbolEventNames) {
                        var symbolEventName = symbolEventNames[FALSE_STR];
                        var symbolCaptureEventName = symbolEventNames[TRUE_STR];
                        var tasks = target[symbolEventName];
                        var captureTasks = target[symbolCaptureEventName];
                        if (tasks) {
                            var removeTasks = tasks.slice();
                            for (var i = 0; i < removeTasks.length; i++) {
                                var task = removeTasks[i];
                                var delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                                this[REMOVE_EVENT_LISTENER].call(this, eventName, delegate, task.options);
                            }
                        }
                        if (captureTasks) {
                            var removeTasks = captureTasks.slice();
                            for (var i = 0; i < removeTasks.length; i++) {
                                var task = removeTasks[i];
                                var delegate = task.originalDelegate ? task.originalDelegate : task.callback;
                                this[REMOVE_EVENT_LISTENER].call(this, eventName, delegate, task.options);
                            }
                        }
                    }
                }
                if (returnTarget) {
                    return this;
                }
            };
            // for native toString patch
            attachOriginToPatched(proto[ADD_EVENT_LISTENER], nativeAddEventListener);
            attachOriginToPatched(proto[REMOVE_EVENT_LISTENER], nativeRemoveEventListener);
            if (nativeRemoveAllListeners) {
                attachOriginToPatched(proto[REMOVE_ALL_LISTENERS_EVENT_LISTENER], nativeRemoveAllListeners);
            }
            if (nativeListeners) {
                attachOriginToPatched(proto[LISTENERS_EVENT_LISTENER], nativeListeners);
            }
            return true;
        }
        var results = [];
        for (var i = 0; i < apis.length; i++) {
            results[i] = patchEventTargetMethods(apis[i], patchOptions);
        }
        return results;
    }
    function findEventTasks(target, eventName) {
        if (!eventName) {
            var foundTasks = [];
            for (var prop in target) {
                var match = EVENT_NAME_SYMBOL_REGX.exec(prop);
                var evtName = match && match[1];
                if (evtName && (!eventName || evtName === eventName)) {
                    var tasks = target[prop];
                    if (tasks) {
                        for (var i = 0; i < tasks.length; i++) {
                            foundTasks.push(tasks[i]);
                        }
                    }
                }
            }
            return foundTasks;
        }
        var symbolEventName = zoneSymbolEventNames[eventName];
        if (!symbolEventName) {
            prepareEventNames(eventName);
            symbolEventName = zoneSymbolEventNames[eventName];
        }
        var captureFalseTasks = target[symbolEventName[FALSE_STR]];
        var captureTrueTasks = target[symbolEventName[TRUE_STR]];
        if (!captureFalseTasks) {
            return captureTrueTasks ? captureTrueTasks.slice() : [];
        }
        else {
            return captureTrueTasks
                ? captureFalseTasks.concat(captureTrueTasks)
                : captureFalseTasks.slice();
        }
    }
    function patchEventPrototype(global, api) {
        var Event = global['Event'];
        if (Event && Event.prototype) {
            api.patchMethod(Event.prototype, 'stopImmediatePropagation', function (delegate) { return function (self, args) {
                self[IMMEDIATE_PROPAGATION_SYMBOL] = true;
                // we need to call the native stopImmediatePropagation
                // in case in some hybrid application, some part of
                // application will be controlled by zone, some are not
                delegate && delegate.apply(self, args);
            }; });
        }
    }
    /**
     * @fileoverview
     * @suppress {missingRequire}
     */
    function patchQueueMicrotask(global, api) {
        api.patchMethod(global, 'queueMicrotask', function (delegate) {
            return function (self, args) {
                Zone.current.scheduleMicroTask('queueMicrotask', args[0]);
            };
        });
    }
    /**
     * @fileoverview
     * @suppress {missingRequire}
     */
    var taskSymbol = zoneSymbol('zoneTask');
    function patchTimer(window, setName, cancelName, nameSuffix) {
        var setNative = null;
        var clearNative = null;
        setName += nameSuffix;
        cancelName += nameSuffix;
        var tasksByHandleId = {};
        function scheduleTask(task) {
            var data = task.data;
            data.args[0] = function () {
                return task.invoke.apply(this, arguments);
            };
            var handleOrId = setNative.apply(window, data.args);
            // Whlist on Node.js when get can the ID by using `[Symbol.toPrimitive]()` we do
            // to this so that we do not cause potentally leaks when using `setTimeout`
            // since this can be periodic when using `.refresh`.
            if (isNumber(handleOrId)) {
                data.handleId = handleOrId;
            }
            else {
                data.handle = handleOrId;
                // On Node.js a timeout and interval can be restarted over and over again by using the `.refresh` method.
                data.isRefreshable = isFunction(handleOrId.refresh);
            }
            return task;
        }
        function clearTask(task) {
            var _a = task.data, handle = _a.handle, handleId = _a.handleId;
            return clearNative.call(window, handle !== null && handle !== void 0 ? handle : handleId);
        }
        setNative = patchMethod(window, setName, function (delegate) { return function (self, args) {
            var _a;
            if (isFunction(args[0])) {
                var options_1 = {
                    isRefreshable: false,
                    isPeriodic: nameSuffix === 'Interval',
                    delay: nameSuffix === 'Timeout' || nameSuffix === 'Interval' ? args[1] || 0 : undefined,
                    args: args,
                };
                var callback_1 = args[0];
                args[0] = function timer() {
                    try {
                        return callback_1.apply(this, arguments);
                    }
                    finally {
                        // issue-934, task will be cancelled
                        // even it is a periodic task such as
                        // setInterval
                        // https://github.com/angular/angular/issues/40387
                        // Cleanup tasksByHandleId should be handled before scheduleTask
                        // Since some zoneSpec may intercept and doesn't trigger
                        // scheduleFn(scheduleTask) provided here.
                        var handle_1 = options_1.handle, handleId_1 = options_1.handleId, isPeriodic_1 = options_1.isPeriodic, isRefreshable_1 = options_1.isRefreshable;
                        if (!isPeriodic_1 && !isRefreshable_1) {
                            if (handleId_1) {
                                // in non-nodejs env, we remove timerId
                                // from local cache
                                delete tasksByHandleId[handleId_1];
                            }
                            else if (handle_1) {
                                // Node returns complex objects as handleIds
                                // we remove task reference from timer object
                                handle_1[taskSymbol] = null;
                            }
                        }
                    }
                };
                var task_1 = scheduleMacroTaskWithCurrentZone(setName, args[0], options_1, scheduleTask, clearTask);
                if (!task_1) {
                    return task_1;
                }
                // Node.js must additionally support the ref and unref functions.
                var _b = task_1.data, handleId = _b.handleId, handle = _b.handle, isRefreshable = _b.isRefreshable, isPeriodic = _b.isPeriodic;
                if (handleId) {
                    // for non nodejs env, we save handleId: task
                    // mapping in local cache for clearTimeout
                    tasksByHandleId[handleId] = task_1;
                }
                else if (handle) {
                    // for nodejs env, we save task
                    // reference in timerId Object for clearTimeout
                    handle[taskSymbol] = task_1;
                    if (isRefreshable && !isPeriodic) {
                        var originalRefresh_1 = handle.refresh;
                        handle.refresh = function () {
                            var zone = task_1.zone, state = task_1.state;
                            if (state === 'notScheduled') {
                                task_1._state = 'scheduled';
                                zone._updateTaskCount(task_1, 1);
                            }
                            else if (state === 'running') {
                                task_1._state = 'scheduling';
                            }
                            return originalRefresh_1.call(this);
                        };
                    }
                }
                return (_a = handle !== null && handle !== void 0 ? handle : handleId) !== null && _a !== void 0 ? _a : task_1;
            }
            else {
                // cause an error by calling it directly.
                return delegate.apply(window, args);
            }
        }; });
        clearNative = patchMethod(window, cancelName, function (delegate) { return function (self, args) {
            var id = args[0];
            var task;
            if (isNumber(id)) {
                // non nodejs env.
                task = tasksByHandleId[id];
                delete tasksByHandleId[id];
            }
            else {
                // nodejs env ?? other environments.
                task = id === null || id === void 0 ? void 0 : id[taskSymbol];
                if (task) {
                    id[taskSymbol] = null;
                }
                else {
                    task = id;
                }
            }
            if (task === null || task === void 0 ? void 0 : task.type) {
                if (task.cancelFn) {
                    // Do not cancel already canceled functions
                    task.zone.cancelTask(task);
                }
            }
            else {
                // cause an error by calling it directly.
                delegate.apply(window, args);
            }
        }; });
    }
    function patchCustomElements(_global, api) {
        var _a = api.getGlobalObjects(), isBrowser = _a.isBrowser, isMix = _a.isMix;
        if ((!isBrowser && !isMix) || !_global['customElements'] || !('customElements' in _global)) {
            return;
        }
        // https://html.spec.whatwg.org/multipage/custom-elements.html#concept-custom-element-definition-lifecycle-callbacks
        var callbacks = [
            'connectedCallback',
            'disconnectedCallback',
            'adoptedCallback',
            'attributeChangedCallback',
            'formAssociatedCallback',
            'formDisabledCallback',
            'formResetCallback',
            'formStateRestoreCallback',
        ];
        api.patchCallbacks(api, _global.customElements, 'customElements', 'define', callbacks);
    }
    function eventTargetPatch(_global, api) {
        if (Zone[api.symbol('patchEventTarget')]) {
            // EventTarget is already patched.
            return;
        }
        var _a = api.getGlobalObjects(), eventNames = _a.eventNames, zoneSymbolEventNames = _a.zoneSymbolEventNames, TRUE_STR = _a.TRUE_STR, FALSE_STR = _a.FALSE_STR, ZONE_SYMBOL_PREFIX = _a.ZONE_SYMBOL_PREFIX;
        //  predefine all __zone_symbol__ + eventName + true/false string
        for (var i = 0; i < eventNames.length; i++) {
            var eventName = eventNames[i];
            var falseEventName = eventName + FALSE_STR;
            var trueEventName = eventName + TRUE_STR;
            var symbol = ZONE_SYMBOL_PREFIX + falseEventName;
            var symbolCapture = ZONE_SYMBOL_PREFIX + trueEventName;
            zoneSymbolEventNames[eventName] = {};
            zoneSymbolEventNames[eventName][FALSE_STR] = symbol;
            zoneSymbolEventNames[eventName][TRUE_STR] = symbolCapture;
        }
        var EVENT_TARGET = _global['EventTarget'];
        if (!EVENT_TARGET || !EVENT_TARGET.prototype) {
            return;
        }
        api.patchEventTarget(_global, api, [EVENT_TARGET && EVENT_TARGET.prototype]);
        return true;
    }
    function patchEvent(global, api) {
        api.patchEventPrototype(global, api);
    }
    /**
     * @fileoverview
     * @suppress {globalThis}
     */
    function filterProperties(target, onProperties, ignoreProperties) {
        if (!ignoreProperties || ignoreProperties.length === 0) {
            return onProperties;
        }
        var tip = ignoreProperties.filter(function (ip) { return ip.target === target; });
        if (tip.length === 0) {
            return onProperties;
        }
        var targetIgnoreProperties = tip[0].ignoreProperties;
        return onProperties.filter(function (op) { return targetIgnoreProperties.indexOf(op) === -1; });
    }
    function patchFilteredProperties(target, onProperties, ignoreProperties, prototype) {
        // check whether target is available, sometimes target will be undefined
        // because different browser or some 3rd party plugin.
        if (!target) {
            return;
        }
        var filteredProperties = filterProperties(target, onProperties, ignoreProperties);
        patchOnProperties(target, filteredProperties, prototype);
    }
    /**
     * Get all event name properties which the event name startsWith `on`
     * from the target object itself, inherited properties are not considered.
     */
    function getOnEventNames(target) {
        return Object.getOwnPropertyNames(target)
            .filter(function (name) { return name.startsWith('on') && name.length > 2; })
            .map(function (name) { return name.substring(2); });
    }
    function propertyDescriptorPatch(api, _global) {
        if (isNode && !isMix) {
            return;
        }
        if (Zone[api.symbol('patchEvents')]) {
            // events are already been patched by legacy patch.
            return;
        }
        var ignoreProperties = _global['__Zone_ignore_on_properties'];
        // for browsers that we can patch the descriptor:  Chrome & Firefox
        var patchTargets = [];
        if (isBrowser) {
            var internalWindow_1 = window;
            patchTargets = patchTargets.concat([
                'Document',
                'SVGElement',
                'Element',
                'HTMLElement',
                'HTMLBodyElement',
                'HTMLMediaElement',
                'HTMLFrameSetElement',
                'HTMLFrameElement',
                'HTMLIFrameElement',
                'HTMLMarqueeElement',
                'Worker',
            ]);
            var ignoreErrorProperties = [];
            // In older browsers like IE or Edge, event handler properties (e.g., `onclick`)
            // may not be defined directly on the `window` object but on its prototype (`WindowPrototype`).
            // To ensure complete coverage, we use the prototype when checking
            // for and patching these properties.
            patchFilteredProperties(internalWindow_1, getOnEventNames(internalWindow_1), ignoreProperties ? ignoreProperties.concat(ignoreErrorProperties) : ignoreProperties, ObjectGetPrototypeOf(internalWindow_1));
        }
        patchTargets = patchTargets.concat([
            'XMLHttpRequest',
            'XMLHttpRequestEventTarget',
            'IDBIndex',
            'IDBRequest',
            'IDBOpenDBRequest',
            'IDBDatabase',
            'IDBTransaction',
            'IDBCursor',
            'WebSocket',
        ]);
        for (var i = 0; i < patchTargets.length; i++) {
            var target = _global[patchTargets[i]];
            (target === null || target === void 0 ? void 0 : target.prototype) &&
                patchFilteredProperties(target.prototype, getOnEventNames(target.prototype), ignoreProperties);
        }
    }
    /**
     * @fileoverview
     * @suppress {missingRequire}
     */
    function patchBrowser(Zone) {
        Zone.__load_patch('legacy', function (global) {
            var legacyPatch = global[Zone.__symbol__('legacyPatch')];
            if (legacyPatch) {
                legacyPatch();
            }
        });
        Zone.__load_patch('timers', function (global) {
            var set = 'set';
            var clear = 'clear';
            patchTimer(global, set, clear, 'Timeout');
            patchTimer(global, set, clear, 'Interval');
            patchTimer(global, set, clear, 'Immediate');
        });
        Zone.__load_patch('requestAnimationFrame', function (global) {
            patchTimer(global, 'request', 'cancel', 'AnimationFrame');
            patchTimer(global, 'mozRequest', 'mozCancel', 'AnimationFrame');
            patchTimer(global, 'webkitRequest', 'webkitCancel', 'AnimationFrame');
        });
        Zone.__load_patch('blocking', function (global, Zone) {
            var blockingMethods = ['alert', 'prompt', 'confirm'];
            for (var i = 0; i < blockingMethods.length; i++) {
                var name_2 = blockingMethods[i];
                patchMethod(global, name_2, function (delegate, symbol, name) {
                    return function (s, args) {
                        return Zone.current.run(delegate, global, args, name);
                    };
                });
            }
        });
        Zone.__load_patch('EventTarget', function (global, Zone, api) {
            patchEvent(global, api);
            eventTargetPatch(global, api);
            // patch XMLHttpRequestEventTarget's addEventListener/removeEventListener
            var XMLHttpRequestEventTarget = global['XMLHttpRequestEventTarget'];
            if (XMLHttpRequestEventTarget && XMLHttpRequestEventTarget.prototype) {
                api.patchEventTarget(global, api, [XMLHttpRequestEventTarget.prototype]);
            }
        });
        Zone.__load_patch('MutationObserver', function (global, Zone, api) {
            patchClass('MutationObserver');
            patchClass('WebKitMutationObserver');
        });
        Zone.__load_patch('IntersectionObserver', function (global, Zone, api) {
            patchClass('IntersectionObserver');
        });
        Zone.__load_patch('FileReader', function (global, Zone, api) {
            patchClass('FileReader');
        });
        Zone.__load_patch('on_property', function (global, Zone, api) {
            propertyDescriptorPatch(api, global);
        });
        Zone.__load_patch('customElements', function (global, Zone, api) {
            patchCustomElements(global, api);
        });
        Zone.__load_patch('XHR', function (global, Zone) {
            // Treat XMLHttpRequest as a macrotask.
            patchXHR(global);
            var XHR_TASK = zoneSymbol('xhrTask');
            var XHR_SYNC = zoneSymbol('xhrSync');
            var XHR_LISTENER = zoneSymbol('xhrListener');
            var XHR_SCHEDULED = zoneSymbol('xhrScheduled');
            var XHR_URL = zoneSymbol('xhrURL');
            var XHR_ERROR_BEFORE_SCHEDULED = zoneSymbol('xhrErrorBeforeScheduled');
            function patchXHR(window) {
                var XMLHttpRequest = window['XMLHttpRequest'];
                if (!XMLHttpRequest) {
                    // XMLHttpRequest is not available in service worker
                    return;
                }
                var XMLHttpRequestPrototype = XMLHttpRequest.prototype;
                function findPendingTask(target) {
                    return target[XHR_TASK];
                }
                var oriAddListener = XMLHttpRequestPrototype[ZONE_SYMBOL_ADD_EVENT_LISTENER];
                var oriRemoveListener = XMLHttpRequestPrototype[ZONE_SYMBOL_REMOVE_EVENT_LISTENER];
                if (!oriAddListener) {
                    var XMLHttpRequestEventTarget_1 = window['XMLHttpRequestEventTarget'];
                    if (XMLHttpRequestEventTarget_1) {
                        var XMLHttpRequestEventTargetPrototype = XMLHttpRequestEventTarget_1.prototype;
                        oriAddListener = XMLHttpRequestEventTargetPrototype[ZONE_SYMBOL_ADD_EVENT_LISTENER];
                        oriRemoveListener = XMLHttpRequestEventTargetPrototype[ZONE_SYMBOL_REMOVE_EVENT_LISTENER];
                    }
                }
                var READY_STATE_CHANGE = 'readystatechange';
                var SCHEDULED = 'scheduled';
                function scheduleTask(task) {
                    var data = task.data;
                    var target = data.target;
                    target[XHR_SCHEDULED] = false;
                    target[XHR_ERROR_BEFORE_SCHEDULED] = false;
                    // remove existing event listener
                    var listener = target[XHR_LISTENER];
                    if (!oriAddListener) {
                        oriAddListener = target[ZONE_SYMBOL_ADD_EVENT_LISTENER];
                        oriRemoveListener = target[ZONE_SYMBOL_REMOVE_EVENT_LISTENER];
                    }
                    if (listener) {
                        oriRemoveListener.call(target, READY_STATE_CHANGE, listener);
                    }
                    var newListener = (target[XHR_LISTENER] = function () {
                        if (target.readyState === target.DONE) {
                            // sometimes on some browsers XMLHttpRequest will fire onreadystatechange with
                            // readyState=4 multiple times, so we need to check task state here
                            if (!data.aborted && target[XHR_SCHEDULED] && task.state === SCHEDULED) {
                                // check whether the xhr has registered onload listener
                                // if that is the case, the task should invoke after all
                                // onload listeners finish.
                                // Also if the request failed without response (status = 0), the load event handler
                                // will not be triggered, in that case, we should also invoke the placeholder callback
                                // to close the XMLHttpRequest::send macroTask.
                                // https://github.com/angular/angular/issues/38795
                                var loadTasks = target[Zone.__symbol__('loadfalse')];
                                if (target.status !== 0 && loadTasks && loadTasks.length > 0) {
                                    var oriInvoke_1 = task.invoke;
                                    task.invoke = function () {
                                        // need to load the tasks again, because in other
                                        // load listener, they may remove themselves
                                        var loadTasks = target[Zone.__symbol__('loadfalse')];
                                        for (var i = 0; i < loadTasks.length; i++) {
                                            if (loadTasks[i] === task) {
                                                loadTasks.splice(i, 1);
                                            }
                                        }
                                        if (!data.aborted && task.state === SCHEDULED) {
                                            oriInvoke_1.call(task);
                                        }
                                    };
                                    loadTasks.push(task);
                                }
                                else {
                                    task.invoke();
                                }
                            }
                            else if (!data.aborted && target[XHR_SCHEDULED] === false) {
                                // error occurs when xhr.send()
                                target[XHR_ERROR_BEFORE_SCHEDULED] = true;
                            }
                        }
                    });
                    oriAddListener.call(target, READY_STATE_CHANGE, newListener);
                    var storedTask = target[XHR_TASK];
                    if (!storedTask) {
                        target[XHR_TASK] = task;
                    }
                    sendNative.apply(target, data.args);
                    target[XHR_SCHEDULED] = true;
                    return task;
                }
                function placeholderCallback() { }
                function clearTask(task) {
                    var data = task.data;
                    // Note - ideally, we would call data.target.removeEventListener here, but it's too late
                    // to prevent it from firing. So instead, we store info for the event listener.
                    data.aborted = true;
                    return abortNative.apply(data.target, data.args);
                }
                var openNative = patchMethod(XMLHttpRequestPrototype, 'open', function () { return function (self, args) {
                    self[XHR_SYNC] = args[2] == false;
                    self[XHR_URL] = args[1];
                    return openNative.apply(self, args);
                }; });
                var XMLHTTPREQUEST_SOURCE = 'XMLHttpRequest.send';
                var fetchTaskAborting = zoneSymbol('fetchTaskAborting');
                var fetchTaskScheduling = zoneSymbol('fetchTaskScheduling');
                var sendNative = patchMethod(XMLHttpRequestPrototype, 'send', function () { return function (self, args) {
                    if (Zone.current[fetchTaskScheduling] === true) {
                        // a fetch is scheduling, so we are using xhr to polyfill fetch
                        // and because we already schedule macroTask for fetch, we should
                        // not schedule a macroTask for xhr again
                        return sendNative.apply(self, args);
                    }
                    if (self[XHR_SYNC]) {
                        // if the XHR is sync there is no task to schedule, just execute the code.
                        return sendNative.apply(self, args);
                    }
                    else {
                        var options = {
                            target: self,
                            url: self[XHR_URL],
                            isPeriodic: false,
                            args: args,
                            aborted: false,
                        };
                        var task = scheduleMacroTaskWithCurrentZone(XMLHTTPREQUEST_SOURCE, placeholderCallback, options, scheduleTask, clearTask);
                        if (self &&
                            self[XHR_ERROR_BEFORE_SCHEDULED] === true &&
                            !options.aborted &&
                            task.state === SCHEDULED) {
                            // xhr request throw error when send
                            // we should invoke task instead of leaving a scheduled
                            // pending macroTask
                            task.invoke();
                        }
                    }
                }; });
                var abortNative = patchMethod(XMLHttpRequestPrototype, 'abort', function () { return function (self, args) {
                    var task = findPendingTask(self);
                    if (task && typeof task.type == 'string') {
                        // If the XHR has already completed, do nothing.
                        // If the XHR has already been aborted, do nothing.
                        // Fix #569, call abort multiple times before done will cause
                        // macroTask task count be negative number
                        if (task.cancelFn == null || (task.data && task.data.aborted)) {
                            return;
                        }
                        task.zone.cancelTask(task);
                    }
                    else if (Zone.current[fetchTaskAborting] === true) {
                        // the abort is called from fetch polyfill, we need to call native abort of XHR.
                        return abortNative.apply(self, args);
                    }
                    // Otherwise, we are trying to abort an XHR which has not yet been sent, so there is no
                    // task
                    // to cancel. Do nothing.
                }; });
            }
        });
        Zone.__load_patch('geolocation', function (global) {
            /// GEO_LOCATION
            if (global['navigator'] && global['navigator'].geolocation) {
                patchPrototype(global['navigator'].geolocation, ['getCurrentPosition', 'watchPosition']);
            }
        });
        Zone.__load_patch('PromiseRejectionEvent', function (global, Zone) {
            // handle unhandled promise rejection
            function findPromiseRejectionHandler(evtName) {
                return function (e) {
                    var eventTasks = findEventTasks(global, evtName);
                    eventTasks.forEach(function (eventTask) {
                        // windows has added unhandledrejection event listener
                        // trigger the event listener
                        var PromiseRejectionEvent = global['PromiseRejectionEvent'];
                        if (PromiseRejectionEvent) {
                            var evt = new PromiseRejectionEvent(evtName, {
                                promise: e.promise,
                                reason: e.rejection,
                            });
                            eventTask.invoke(evt);
                        }
                    });
                };
            }
            if (global['PromiseRejectionEvent']) {
                Zone[zoneSymbol('unhandledPromiseRejectionHandler')] =
                    findPromiseRejectionHandler('unhandledrejection');
                Zone[zoneSymbol('rejectionHandledHandler')] =
                    findPromiseRejectionHandler('rejectionhandled');
            }
        });
        Zone.__load_patch('queueMicrotask', function (global, Zone, api) {
            patchQueueMicrotask(global, api);
        });
    }
    function patchPromise(Zone) {
        Zone.__load_patch('ZoneAwarePromise', function (global, Zone, api) {
            var ObjectGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
            var ObjectDefineProperty = Object.defineProperty;
            function readableObjectToString(obj) {
                if (obj && obj.toString === Object.prototype.toString) {
                    var className = obj.constructor && obj.constructor.name;
                    return (className ? className : '') + ': ' + JSON.stringify(obj);
                }
                return obj ? obj.toString() : Object.prototype.toString.call(obj);
            }
            var __symbol__ = api.symbol;
            var _uncaughtPromiseErrors = [];
            var isDisableWrappingUncaughtPromiseRejection = global[__symbol__('DISABLE_WRAPPING_UNCAUGHT_PROMISE_REJECTION')] !== false;
            var symbolPromise = __symbol__('Promise');
            var symbolThen = __symbol__('then');
            var creationTrace = '__creationTrace__';
            api.onUnhandledError = function (e) {
                if (api.showUncaughtError()) {
                    var rejection = e && e.rejection;
                    if (rejection) {
                        console.error('Unhandled Promise rejection:', rejection instanceof Error ? rejection.message : rejection, '; Zone:', e.zone.name, '; Task:', e.task && e.task.source, '; Value:', rejection, rejection instanceof Error ? rejection.stack : undefined);
                    }
                    else {
                        console.error(e);
                    }
                }
            };
            api.microtaskDrainDone = function () {
                var _loop_3 = function () {
                    var uncaughtPromiseError = _uncaughtPromiseErrors.shift();
                    try {
                        uncaughtPromiseError.zone.runGuarded(function () {
                            if (uncaughtPromiseError.throwOriginal) {
                                throw uncaughtPromiseError.rejection;
                            }
                            throw uncaughtPromiseError;
                        });
                    }
                    catch (error) {
                        handleUnhandledRejection(error);
                    }
                };
                while (_uncaughtPromiseErrors.length) {
                    _loop_3();
                }
            };
            var UNHANDLED_PROMISE_REJECTION_HANDLER_SYMBOL = __symbol__('unhandledPromiseRejectionHandler');
            function handleUnhandledRejection(e) {
                api.onUnhandledError(e);
                try {
                    var handler = Zone[UNHANDLED_PROMISE_REJECTION_HANDLER_SYMBOL];
                    if (typeof handler === 'function') {
                        handler.call(this, e);
                    }
                }
                catch (err) { }
            }
            function isThenable(value) {
                return value && typeof value.then === 'function';
            }
            function forwardResolution(value) {
                return value;
            }
            function forwardRejection(rejection) {
                return ZoneAwarePromise.reject(rejection);
            }
            var symbolState = __symbol__('state');
            var symbolValue = __symbol__('value');
            var symbolFinally = __symbol__('finally');
            var symbolParentPromiseValue = __symbol__('parentPromiseValue');
            var symbolParentPromiseState = __symbol__('parentPromiseState');
            var source = 'Promise.then';
            var UNRESOLVED = null;
            var RESOLVED = true;
            var REJECTED = false;
            var REJECTED_NO_CATCH = 0;
            function makeResolver(promise, state) {
                return function (v) {
                    try {
                        resolvePromise(promise, state, v);
                    }
                    catch (err) {
                        resolvePromise(promise, false, err);
                    }
                    // Do not return value or you will break the Promise spec.
                };
            }
            var once = function () {
                var wasCalled = false;
                return function wrapper(wrappedFunction) {
                    return function () {
                        if (wasCalled) {
                            return;
                        }
                        wasCalled = true;
                        wrappedFunction.apply(null, arguments);
                    };
                };
            };
            var TYPE_ERROR = 'Promise resolved with itself';
            var CURRENT_TASK_TRACE_SYMBOL = __symbol__('currentTaskTrace');
            // Promise Resolution
            function resolvePromise(promise, state, value) {
                var onceWrapper = once();
                if (promise === value) {
                    throw new TypeError(TYPE_ERROR);
                }
                if (promise[symbolState] === UNRESOLVED) {
                    // should only get value.then once based on promise spec.
                    var then = null;
                    try {
                        if (typeof value === 'object' || typeof value === 'function') {
                            then = value && value.then;
                        }
                    }
                    catch (err) {
                        onceWrapper(function () {
                            resolvePromise(promise, false, err);
                        })();
                        return promise;
                    }
                    // if (value instanceof ZoneAwarePromise) {
                    if (state !== REJECTED &&
                        value instanceof ZoneAwarePromise &&
                        value.hasOwnProperty(symbolState) &&
                        value.hasOwnProperty(symbolValue) &&
                        value[symbolState] !== UNRESOLVED) {
                        clearRejectedNoCatch(value);
                        resolvePromise(promise, value[symbolState], value[symbolValue]);
                    }
                    else if (state !== REJECTED && typeof then === 'function') {
                        try {
                            then.call(value, onceWrapper(makeResolver(promise, state)), onceWrapper(makeResolver(promise, false)));
                        }
                        catch (err) {
                            onceWrapper(function () {
                                resolvePromise(promise, false, err);
                            })();
                        }
                    }
                    else {
                        promise[symbolState] = state;
                        var queue = promise[symbolValue];
                        promise[symbolValue] = value;
                        if (promise[symbolFinally] === symbolFinally) {
                            // the promise is generated by Promise.prototype.finally
                            if (state === RESOLVED) {
                                // the state is resolved, should ignore the value
                                // and use parent promise value
                                promise[symbolState] = promise[symbolParentPromiseState];
                                promise[symbolValue] = promise[symbolParentPromiseValue];
                            }
                        }
                        // record task information in value when error occurs, so we can
                        // do some additional work such as render longStackTrace
                        if (state === REJECTED && value instanceof Error) {
                            // check if longStackTraceZone is here
                            var trace = Zone.currentTask &&
                                Zone.currentTask.data &&
                                Zone.currentTask.data[creationTrace];
                            if (trace) {
                                // only keep the long stack trace into error when in longStackTraceZone
                                ObjectDefineProperty(value, CURRENT_TASK_TRACE_SYMBOL, {
                                    configurable: true,
                                    enumerable: false,
                                    writable: true,
                                    value: trace,
                                });
                            }
                        }
                        for (var i = 0; i < queue.length;) {
                            scheduleResolveOrReject(promise, queue[i++], queue[i++], queue[i++], queue[i++]);
                        }
                        if (queue.length == 0 && state == REJECTED) {
                            promise[symbolState] = REJECTED_NO_CATCH;
                            var uncaughtPromiseError = value;
                            try {
                                // Here we throws a new Error to print more readable error log
                                // and if the value is not an error, zone.js builds an `Error`
                                // Object here to attach the stack information.
                                throw new Error('Uncaught (in promise): ' +
                                    readableObjectToString(value) +
                                    (value && value.stack ? '\n' + value.stack : ''));
                            }
                            catch (err) {
                                uncaughtPromiseError = err;
                            }
                            if (isDisableWrappingUncaughtPromiseRejection) {
                                // If disable wrapping uncaught promise reject
                                // use the value instead of wrapping it.
                                uncaughtPromiseError.throwOriginal = true;
                            }
                            uncaughtPromiseError.rejection = value;
                            uncaughtPromiseError.promise = promise;
                            uncaughtPromiseError.zone = Zone.current;
                            uncaughtPromiseError.task = Zone.currentTask;
                            _uncaughtPromiseErrors.push(uncaughtPromiseError);
                            api.scheduleMicroTask(); // to make sure that it is running
                        }
                    }
                }
                // Resolving an already resolved promise is a noop.
                return promise;
            }
            var REJECTION_HANDLED_HANDLER = __symbol__('rejectionHandledHandler');
            function clearRejectedNoCatch(promise) {
                if (promise[symbolState] === REJECTED_NO_CATCH) {
                    // if the promise is rejected no catch status
                    // and queue.length > 0, means there is a error handler
                    // here to handle the rejected promise, we should trigger
                    // windows.rejectionhandled eventHandler or nodejs rejectionHandled
                    // eventHandler
                    try {
                        var handler = Zone[REJECTION_HANDLED_HANDLER];
                        if (handler && typeof handler === 'function') {
                            handler.call(this, { rejection: promise[symbolValue], promise: promise });
                        }
                    }
                    catch (err) { }
                    promise[symbolState] = REJECTED;
                    for (var i = 0; i < _uncaughtPromiseErrors.length; i++) {
                        if (promise === _uncaughtPromiseErrors[i].promise) {
                            _uncaughtPromiseErrors.splice(i, 1);
                        }
                    }
                }
            }
            function scheduleResolveOrReject(promise, zone, chainPromise, onFulfilled, onRejected) {
                clearRejectedNoCatch(promise);
                var promiseState = promise[symbolState];
                var delegate = promiseState
                    ? typeof onFulfilled === 'function'
                        ? onFulfilled
                        : forwardResolution
                    : typeof onRejected === 'function'
                        ? onRejected
                        : forwardRejection;
                zone.scheduleMicroTask(source, function () {
                    try {
                        var parentPromiseValue = promise[symbolValue];
                        var isFinallyPromise = !!chainPromise && symbolFinally === chainPromise[symbolFinally];
                        if (isFinallyPromise) {
                            // if the promise is generated from finally call, keep parent promise's state and value
                            chainPromise[symbolParentPromiseValue] = parentPromiseValue;
                            chainPromise[symbolParentPromiseState] = promiseState;
                        }
                        // should not pass value to finally callback
                        var value = zone.run(delegate, undefined, isFinallyPromise && delegate !== forwardRejection && delegate !== forwardResolution
                            ? []
                            : [parentPromiseValue]);
                        resolvePromise(chainPromise, true, value);
                    }
                    catch (error) {
                        // if error occurs, should always return this error
                        resolvePromise(chainPromise, false, error);
                    }
                }, chainPromise);
            }
            var ZONE_AWARE_PROMISE_TO_STRING = 'function ZoneAwarePromise() { [native code] }';
            var noop = function () { };
            var AggregateError = global.AggregateError;
            var ZoneAwarePromise = /** @class */ (function () {
                function ZoneAwarePromise(executor) {
                    var promise = this;
                    if (!(promise instanceof ZoneAwarePromise)) {
                        throw new Error('Must be an instanceof Promise.');
                    }
                    promise[symbolState] = UNRESOLVED;
                    promise[symbolValue] = []; // queue;
                    try {
                        var onceWrapper = once();
                        executor &&
                            executor(onceWrapper(makeResolver(promise, RESOLVED)), onceWrapper(makeResolver(promise, REJECTED)));
                    }
                    catch (error) {
                        resolvePromise(promise, false, error);
                    }
                }
                ZoneAwarePromise.toString = function () {
                    return ZONE_AWARE_PROMISE_TO_STRING;
                };
                ZoneAwarePromise.resolve = function (value) {
                    if (value instanceof ZoneAwarePromise) {
                        return value;
                    }
                    return resolvePromise(new this(null), RESOLVED, value);
                };
                ZoneAwarePromise.reject = function (error) {
                    return resolvePromise(new this(null), REJECTED, error);
                };
                ZoneAwarePromise.withResolvers = function () {
                    var result = {};
                    result.promise = new ZoneAwarePromise(function (res, rej) {
                        result.resolve = res;
                        result.reject = rej;
                    });
                    return result;
                };
                ZoneAwarePromise.any = function (values) {
                    if (!values || typeof values[Symbol.iterator] !== 'function') {
                        return Promise.reject(new AggregateError([], 'All promises were rejected'));
                    }
                    var promises = [];
                    var count = 0;
                    try {
                        for (var _i = 0, values_1 = values; _i < values_1.length; _i++) {
                            var v = values_1[_i];
                            count++;
                            promises.push(ZoneAwarePromise.resolve(v));
                        }
                    }
                    catch (err) {
                        return Promise.reject(new AggregateError([], 'All promises were rejected'));
                    }
                    if (count === 0) {
                        return Promise.reject(new AggregateError([], 'All promises were rejected'));
                    }
                    var finished = false;
                    var errors = [];
                    return new ZoneAwarePromise(function (resolve, reject) {
                        for (var i = 0; i < promises.length; i++) {
                            promises[i].then(function (v) {
                                if (finished) {
                                    return;
                                }
                                finished = true;
                                resolve(v);
                            }, function (err) {
                                errors.push(err);
                                count--;
                                if (count === 0) {
                                    finished = true;
                                    reject(new AggregateError(errors, 'All promises were rejected'));
                                }
                            });
                        }
                    });
                };
                ZoneAwarePromise.race = function (values) {
                    var resolve;
                    var reject;
                    var promise = new this(function (res, rej) {
                        resolve = res;
                        reject = rej;
                    });
                    function onResolve(value) {
                        resolve(value);
                    }
                    function onReject(error) {
                        reject(error);
                    }
                    for (var _i = 0, values_2 = values; _i < values_2.length; _i++) {
                        var value = values_2[_i];
                        if (!isThenable(value)) {
                            value = this.resolve(value);
                        }
                        value.then(onResolve, onReject);
                    }
                    return promise;
                };
                ZoneAwarePromise.all = function (values) {
                    return ZoneAwarePromise.allWithCallback(values);
                };
                ZoneAwarePromise.allSettled = function (values) {
                    var P = this && this.prototype instanceof ZoneAwarePromise ? this : ZoneAwarePromise;
                    return P.allWithCallback(values, {
                        thenCallback: function (value) { return ({ status: 'fulfilled', value: value }); },
                        errorCallback: function (err) { return ({ status: 'rejected', reason: err }); },
                    });
                };
                ZoneAwarePromise.allWithCallback = function (values, callback) {
                    var resolve;
                    var reject;
                    var promise = new this(function (res, rej) {
                        resolve = res;
                        reject = rej;
                    });
                    // Start at 2 to prevent prematurely resolving if .then is called immediately.
                    var unresolvedCount = 2;
                    var valueIndex = 0;
                    var resolvedValues = [];
                    var _loop_4 = function (value) {
                        if (!isThenable(value)) {
                            value = this_1.resolve(value);
                        }
                        var curValueIndex = valueIndex;
                        try {
                            value.then(function (value) {
                                resolvedValues[curValueIndex] = callback ? callback.thenCallback(value) : value;
                                unresolvedCount--;
                                if (unresolvedCount === 0) {
                                    resolve(resolvedValues);
                                }
                            }, function (err) {
                                if (!callback) {
                                    reject(err);
                                }
                                else {
                                    resolvedValues[curValueIndex] = callback.errorCallback(err);
                                    unresolvedCount--;
                                    if (unresolvedCount === 0) {
                                        resolve(resolvedValues);
                                    }
                                }
                            });
                        }
                        catch (thenErr) {
                            reject(thenErr);
                        }
                        unresolvedCount++;
                        valueIndex++;
                    };
                    var this_1 = this;
                    for (var _i = 0, values_3 = values; _i < values_3.length; _i++) {
                        var value = values_3[_i];
                        _loop_4(value);
                    }
                    // Make the unresolvedCount zero-based again.
                    unresolvedCount -= 2;
                    if (unresolvedCount === 0) {
                        resolve(resolvedValues);
                    }
                    return promise;
                };
                Object.defineProperty(ZoneAwarePromise.prototype, Symbol.toStringTag, {
                    get: function () {
                        return 'Promise';
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ZoneAwarePromise.prototype, Symbol.species, {
                    get: function () {
                        return ZoneAwarePromise;
                    },
                    enumerable: false,
                    configurable: true
                });
                ZoneAwarePromise.prototype.then = function (onFulfilled, onRejected) {
                    var _a;
                    // We must read `Symbol.species` safely because `this` may be anything. For instance, `this`
                    // may be an object without a prototype (created through `Object.create(null)`); thus
                    // `this.constructor` will be undefined. One of the use cases is SystemJS creating
                    // prototype-less objects (modules) via `Object.create(null)`. The SystemJS creates an empty
                    // object and copies promise properties into that object (within the `getOrCreateLoad`
                    // function). The zone.js then checks if the resolved value has the `then` method and
                    // invokes it with the `value` context. Otherwise, this will throw an error: `TypeError:
                    // Cannot read properties of undefined (reading 'Symbol(Symbol.species)')`.
                    var C = (_a = this.constructor) === null || _a === void 0 ? void 0 : _a[Symbol.species];
                    if (!C || typeof C !== 'function') {
                        C = this.constructor || ZoneAwarePromise;
                    }
                    var chainPromise = new C(noop);
                    var zone = Zone.current;
                    if (this[symbolState] == UNRESOLVED) {
                        this[symbolValue].push(zone, chainPromise, onFulfilled, onRejected);
                    }
                    else {
                        scheduleResolveOrReject(this, zone, chainPromise, onFulfilled, onRejected);
                    }
                    return chainPromise;
                };
                ZoneAwarePromise.prototype.catch = function (onRejected) {
                    return this.then(null, onRejected);
                };
                ZoneAwarePromise.prototype.finally = function (onFinally) {
                    var _a;
                    // See comment on the call to `then` about why thee `Symbol.species` is safely accessed.
                    var C = (_a = this.constructor) === null || _a === void 0 ? void 0 : _a[Symbol.species];
                    if (!C || typeof C !== 'function') {
                        C = ZoneAwarePromise;
                    }
                    var chainPromise = new C(noop);
                    chainPromise[symbolFinally] = symbolFinally;
                    var zone = Zone.current;
                    if (this[symbolState] == UNRESOLVED) {
                        this[symbolValue].push(zone, chainPromise, onFinally, onFinally);
                    }
                    else {
                        scheduleResolveOrReject(this, zone, chainPromise, onFinally, onFinally);
                    }
                    return chainPromise;
                };
                return ZoneAwarePromise;
            }());
            // Protect against aggressive optimizers dropping seemingly unused properties.
            // E.g. Closure Compiler in advanced mode.
            ZoneAwarePromise['resolve'] = ZoneAwarePromise.resolve;
            ZoneAwarePromise['reject'] = ZoneAwarePromise.reject;
            ZoneAwarePromise['race'] = ZoneAwarePromise.race;
            ZoneAwarePromise['all'] = ZoneAwarePromise.all;
            var NativePromise = (global[symbolPromise] = global['Promise']);
            global['Promise'] = ZoneAwarePromise;
            var symbolThenPatched = __symbol__('thenPatched');
            function patchThen(Ctor) {
                var proto = Ctor.prototype;
                var prop = ObjectGetOwnPropertyDescriptor(proto, 'then');
                if (prop && (prop.writable === false || !prop.configurable)) {
                    // check Ctor.prototype.then propertyDescriptor is writable or not
                    // in meteor env, writable is false, we should ignore such case
                    return;
                }
                var originalThen = proto.then;
                // Keep a reference to the original method.
                proto[symbolThen] = originalThen;
                Ctor.prototype.then = function (onResolve, onReject) {
                    var _this = this;
                    var wrapped = new ZoneAwarePromise(function (resolve, reject) {
                        originalThen.call(_this, resolve, reject);
                    });
                    return wrapped.then(onResolve, onReject);
                };
                Ctor[symbolThenPatched] = true;
            }
            api.patchThen = patchThen;
            function zoneify(fn) {
                return function (self, args) {
                    var resultPromise = fn.apply(self, args);
                    if (resultPromise instanceof ZoneAwarePromise) {
                        return resultPromise;
                    }
                    var ctor = resultPromise.constructor;
                    if (!ctor[symbolThenPatched]) {
                        patchThen(ctor);
                    }
                    return resultPromise;
                };
            }
            if (NativePromise) {
                patchThen(NativePromise);
                patchMethod(global, 'fetch', function (delegate) { return zoneify(delegate); });
            }
            // This is not part of public API, but it is useful for tests, so we expose it.
            Promise[Zone.__symbol__('uncaughtPromiseErrors')] = _uncaughtPromiseErrors;
            return ZoneAwarePromise;
        });
    }
    function patchToString(Zone) {
        // override Function.prototype.toString to make zone.js patched function
        // look like native function
        Zone.__load_patch('toString', function (global) {
            // patch Func.prototype.toString to let them look like native
            var originalFunctionToString = Function.prototype.toString;
            var ORIGINAL_DELEGATE_SYMBOL = zoneSymbol('OriginalDelegate');
            var PROMISE_SYMBOL = zoneSymbol('Promise');
            var ERROR_SYMBOL = zoneSymbol('Error');
            var newFunctionToString = function toString() {
                if (typeof this === 'function') {
                    var originalDelegate = this[ORIGINAL_DELEGATE_SYMBOL];
                    if (originalDelegate) {
                        if (typeof originalDelegate === 'function') {
                            return originalFunctionToString.call(originalDelegate);
                        }
                        else {
                            return Object.prototype.toString.call(originalDelegate);
                        }
                    }
                    if (this === Promise) {
                        var nativePromise = global[PROMISE_SYMBOL];
                        if (nativePromise) {
                            return originalFunctionToString.call(nativePromise);
                        }
                    }
                    if (this === Error) {
                        var nativeError = global[ERROR_SYMBOL];
                        if (nativeError) {
                            return originalFunctionToString.call(nativeError);
                        }
                    }
                }
                return originalFunctionToString.call(this);
            };
            newFunctionToString[ORIGINAL_DELEGATE_SYMBOL] = originalFunctionToString;
            Function.prototype.toString = newFunctionToString;
            // patch Object.prototype.toString to let them look like native
            var originalObjectToString = Object.prototype.toString;
            var PROMISE_OBJECT_TO_STRING = '[object Promise]';
            Object.prototype.toString = function () {
                if (typeof Promise === 'function' && this instanceof Promise) {
                    return PROMISE_OBJECT_TO_STRING;
                }
                return originalObjectToString.call(this);
            };
        });
    }
    function patchCallbacks(api, target, targetName, method, callbacks) {
        var symbol = Zone.__symbol__(method);
        if (target[symbol]) {
            return;
        }
        var nativeDelegate = (target[symbol] = target[method]);
        target[method] = function (name, opts, options) {
            if (opts && opts.prototype) {
                callbacks.forEach(function (callback) {
                    var source = "".concat(targetName, ".").concat(method, "::") + callback;
                    var prototype = opts.prototype;
                    // Note: the `patchCallbacks` is used for patching the `document.registerElement` and
                    // `customElements.define`. We explicitly wrap the patching code into try-catch since
                    // callbacks may be already patched by other web components frameworks (e.g. LWC), and they
                    // make those properties non-writable. This means that patching callback will throw an error
                    // `cannot assign to read-only property`. See this code as an example:
                    // https://github.com/salesforce/lwc/blob/master/packages/@lwc/engine-core/src/framework/base-bridge-element.ts#L180-L186
                    // We don't want to stop the application rendering if we couldn't patch some
                    // callback, e.g. `attributeChangedCallback`.
                    try {
                        if (prototype.hasOwnProperty(callback)) {
                            var descriptor = api.ObjectGetOwnPropertyDescriptor(prototype, callback);
                            if (descriptor && descriptor.value) {
                                descriptor.value = api.wrapWithCurrentZone(descriptor.value, source);
                                api._redefineProperty(opts.prototype, callback, descriptor);
                            }
                            else if (prototype[callback]) {
                                prototype[callback] = api.wrapWithCurrentZone(prototype[callback], source);
                            }
                        }
                        else if (prototype[callback]) {
                            prototype[callback] = api.wrapWithCurrentZone(prototype[callback], source);
                        }
                    }
                    catch (_a) {
                        // Note: we leave the catch block empty since there's no way to handle the error related
                        // to non-writable property.
                    }
                });
            }
            return nativeDelegate.call(target, name, opts, options);
        };
        api.attachOriginToPatched(target[method], nativeDelegate);
    }
    function patchUtil(Zone) {
        Zone.__load_patch('util', function (global, Zone, api) {
            // Collect native event names by looking at properties
            // on the global namespace, e.g. 'onclick'.
            var eventNames = getOnEventNames(global);
            api.patchOnProperties = patchOnProperties;
            api.patchMethod = patchMethod;
            api.bindArguments = bindArguments;
            api.patchMacroTask = patchMacroTask;
            // In earlier version of zone.js (<0.9.0), we use env name `__zone_symbol__BLACK_LISTED_EVENTS`
            // to define which events will not be patched by `Zone.js`. In newer version (>=0.9.0), we
            // change the env name to `__zone_symbol__UNPATCHED_EVENTS` to keep the name consistent with
            // angular repo. The  `__zone_symbol__BLACK_LISTED_EVENTS` is deprecated, but it is still be
            // supported for backwards compatibility.
            var SYMBOL_BLACK_LISTED_EVENTS = Zone.__symbol__('BLACK_LISTED_EVENTS');
            var SYMBOL_UNPATCHED_EVENTS = Zone.__symbol__('UNPATCHED_EVENTS');
            if (global[SYMBOL_UNPATCHED_EVENTS]) {
                global[SYMBOL_BLACK_LISTED_EVENTS] = global[SYMBOL_UNPATCHED_EVENTS];
            }
            if (global[SYMBOL_BLACK_LISTED_EVENTS]) {
                Zone[SYMBOL_BLACK_LISTED_EVENTS] = Zone[SYMBOL_UNPATCHED_EVENTS] =
                    global[SYMBOL_BLACK_LISTED_EVENTS];
            }
            api.patchEventPrototype = patchEventPrototype;
            api.patchEventTarget = patchEventTarget;
            api.isIEOrEdge = isIEOrEdge;
            api.ObjectDefineProperty = ObjectDefineProperty;
            api.ObjectGetOwnPropertyDescriptor = ObjectGetOwnPropertyDescriptor;
            api.ObjectCreate = ObjectCreate;
            api.ArraySlice = ArraySlice;
            api.patchClass = patchClass;
            api.wrapWithCurrentZone = wrapWithCurrentZone;
            api.filterProperties = filterProperties;
            api.attachOriginToPatched = attachOriginToPatched;
            api._redefineProperty = Object.defineProperty;
            api.patchCallbacks = patchCallbacks;
            api.getGlobalObjects = function () { return ({
                globalSources: globalSources,
                zoneSymbolEventNames: zoneSymbolEventNames,
                eventNames: eventNames,
                isBrowser: isBrowser,
                isMix: isMix,
                isNode: isNode,
                TRUE_STR: TRUE_STR,
                FALSE_STR: FALSE_STR,
                ZONE_SYMBOL_PREFIX: ZONE_SYMBOL_PREFIX,
                ADD_EVENT_LISTENER_STR: ADD_EVENT_LISTENER_STR,
                REMOVE_EVENT_LISTENER_STR: REMOVE_EVENT_LISTENER_STR,
            }); };
        });
    }
    function patchCommon(Zone) {
        patchPromise(Zone);
        patchToString(Zone);
        patchUtil(Zone);
    }
    var Zone$1 = loadZone();
    patchCommon(Zone$1);
    patchBrowser(Zone$1);
}));


/***/ }),
/* 3559 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 3560 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 3561 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 3562 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 3563 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 3564 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 3565 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1604);


/***/ })
],[3565]);


// WEBPACK FOOTER //
// book/book.6cdef3763299357922d3.js